function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}
function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || dest.hasOwnProperty(key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire0802"];
if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire0802"] = parcelRequire;
}
parcelRequire.register("9LHVU", function(module, exports) {

$parcel$export(module.exports, "register", () => $71ca95046697bae3$export$6503ec6e8aabbaf, (v) => $71ca95046697bae3$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $71ca95046697bae3$export$f7ad0328861e2f03, (v) => $71ca95046697bae3$export$f7ad0328861e2f03 = v);
var $71ca95046697bae3$export$6503ec6e8aabbaf;
var $71ca95046697bae3$export$f7ad0328861e2f03;
"use strict";
var $71ca95046697bae3$var$mapping = {};
function $71ca95046697bae3$var$register(pairs) {
    var keys = Object.keys(pairs);
    for(var i = 0; i < keys.length; i++)$71ca95046697bae3$var$mapping[keys[i]] = pairs[keys[i]];
}
function $71ca95046697bae3$var$resolve(id) {
    var resolved = $71ca95046697bae3$var$mapping[id];
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return resolved;
}
$71ca95046697bae3$export$6503ec6e8aabbaf = $71ca95046697bae3$var$register;
$71ca95046697bae3$export$f7ad0328861e2f03 = $71ca95046697bae3$var$resolve;

});

parcelRequire.register("fI7KS", function(module, exports) {

$parcel$export(module.exports, "Fragment", () => $b700fb12892d9d49$export$ffb0004e005737fa, (v) => $b700fb12892d9d49$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "jsx", () => $b700fb12892d9d49$export$34b9dba7ce09269b, (v) => $b700fb12892d9d49$export$34b9dba7ce09269b = v);
$parcel$export(module.exports, "jsxs", () => $b700fb12892d9d49$export$25062201e9e25d76, (v) => $b700fb12892d9d49$export$25062201e9e25d76 = v);
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $b700fb12892d9d49$export$ffb0004e005737fa;
var $b700fb12892d9d49$export$34b9dba7ce09269b;
var $b700fb12892d9d49$export$25062201e9e25d76;
"use strict";

var $eO7Kz = parcelRequire("eO7Kz");
var $b700fb12892d9d49$var$k = Symbol.for("react.element"), $b700fb12892d9d49$var$l = Symbol.for("react.fragment"), $b700fb12892d9d49$var$m = Object.prototype.hasOwnProperty, $b700fb12892d9d49$var$n = $eO7Kz.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $b700fb12892d9d49$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $b700fb12892d9d49$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$b700fb12892d9d49$var$m.call(a, b) && !$b700fb12892d9d49$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $b700fb12892d9d49$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $b700fb12892d9d49$var$n.current
    };
}
$b700fb12892d9d49$export$ffb0004e005737fa = $b700fb12892d9d49$var$l;
$b700fb12892d9d49$export$34b9dba7ce09269b = $b700fb12892d9d49$var$q;
$b700fb12892d9d49$export$25062201e9e25d76 = $b700fb12892d9d49$var$q;

});
parcelRequire.register("eO7Kz", function(module, exports) {
"use strict";

module.exports = (parcelRequire("7yLsO"));

});
parcelRequire.register("7yLsO", function(module, exports) {

$parcel$export(module.exports, "Children", () => $581086b41291c535$export$dca3b0875bd9a954, (v) => $581086b41291c535$export$dca3b0875bd9a954 = v);
$parcel$export(module.exports, "Component", () => $581086b41291c535$export$16fa2f45be04daa8, (v) => $581086b41291c535$export$16fa2f45be04daa8 = v);
$parcel$export(module.exports, "Fragment", () => $581086b41291c535$export$ffb0004e005737fa, (v) => $581086b41291c535$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Profiler", () => $581086b41291c535$export$e2c29f18771995cb, (v) => $581086b41291c535$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "PureComponent", () => $581086b41291c535$export$221d75b3f55bb0bd, (v) => $581086b41291c535$export$221d75b3f55bb0bd = v);
$parcel$export(module.exports, "StrictMode", () => $581086b41291c535$export$5f8d39834fd61797, (v) => $581086b41291c535$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $581086b41291c535$export$74bf444e3cd11ea5, (v) => $581086b41291c535$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $581086b41291c535$export$ae55be85d98224ed, (v) => $581086b41291c535$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "cloneElement", () => $581086b41291c535$export$e530037191fcd5d7, (v) => $581086b41291c535$export$e530037191fcd5d7 = v);
$parcel$export(module.exports, "createContext", () => $581086b41291c535$export$fd42f52fd3ae1109, (v) => $581086b41291c535$export$fd42f52fd3ae1109 = v);
$parcel$export(module.exports, "createElement", () => $581086b41291c535$export$c8a8987d4410bf2d, (v) => $581086b41291c535$export$c8a8987d4410bf2d = v);
$parcel$export(module.exports, "createFactory", () => $581086b41291c535$export$d38cd72104c1f0e9, (v) => $581086b41291c535$export$d38cd72104c1f0e9 = v);
$parcel$export(module.exports, "createRef", () => $581086b41291c535$export$7d1e3a5e95ceca43, (v) => $581086b41291c535$export$7d1e3a5e95ceca43 = v);
$parcel$export(module.exports, "forwardRef", () => $581086b41291c535$export$257a8862b851cb5b, (v) => $581086b41291c535$export$257a8862b851cb5b = v);
$parcel$export(module.exports, "isValidElement", () => $581086b41291c535$export$a8257692ac88316c, (v) => $581086b41291c535$export$a8257692ac88316c = v);
$parcel$export(module.exports, "lazy", () => $581086b41291c535$export$488013bae63b21da, (v) => $581086b41291c535$export$488013bae63b21da = v);
$parcel$export(module.exports, "memo", () => $581086b41291c535$export$7c73462e0d25e514, (v) => $581086b41291c535$export$7c73462e0d25e514 = v);
$parcel$export(module.exports, "startTransition", () => $581086b41291c535$export$7568632d0d33d16d, (v) => $581086b41291c535$export$7568632d0d33d16d = v);
$parcel$export(module.exports, "unstable_act", () => $581086b41291c535$export$88948ce120ea2619, (v) => $581086b41291c535$export$88948ce120ea2619 = v);
$parcel$export(module.exports, "useCallback", () => $581086b41291c535$export$35808ee640e87ca7, (v) => $581086b41291c535$export$35808ee640e87ca7 = v);
$parcel$export(module.exports, "useContext", () => $581086b41291c535$export$fae74005e78b1a27, (v) => $581086b41291c535$export$fae74005e78b1a27 = v);
$parcel$export(module.exports, "useDebugValue", () => $581086b41291c535$export$dc8fbce3eb94dc1e, (v) => $581086b41291c535$export$dc8fbce3eb94dc1e = v);
$parcel$export(module.exports, "useDeferredValue", () => $581086b41291c535$export$6a7bc4e911dc01cf, (v) => $581086b41291c535$export$6a7bc4e911dc01cf = v);
$parcel$export(module.exports, "useEffect", () => $581086b41291c535$export$6d9c69b0de29b591, (v) => $581086b41291c535$export$6d9c69b0de29b591 = v);
$parcel$export(module.exports, "useId", () => $581086b41291c535$export$f680877a34711e37, (v) => $581086b41291c535$export$f680877a34711e37 = v);
$parcel$export(module.exports, "useImperativeHandle", () => $581086b41291c535$export$d5a552a76deda3c2, (v) => $581086b41291c535$export$d5a552a76deda3c2 = v);
$parcel$export(module.exports, "useInsertionEffect", () => $581086b41291c535$export$aaabe4eda9ed9969, (v) => $581086b41291c535$export$aaabe4eda9ed9969 = v);
$parcel$export(module.exports, "useLayoutEffect", () => $581086b41291c535$export$e5c5a5f917a5871c, (v) => $581086b41291c535$export$e5c5a5f917a5871c = v);
$parcel$export(module.exports, "useMemo", () => $581086b41291c535$export$1538c33de8887b59, (v) => $581086b41291c535$export$1538c33de8887b59 = v);
$parcel$export(module.exports, "useReducer", () => $581086b41291c535$export$13e3392192263954, (v) => $581086b41291c535$export$13e3392192263954 = v);
$parcel$export(module.exports, "useRef", () => $581086b41291c535$export$b8f5890fc79d6aca, (v) => $581086b41291c535$export$b8f5890fc79d6aca = v);
$parcel$export(module.exports, "useState", () => $581086b41291c535$export$60241385465d0a34, (v) => $581086b41291c535$export$60241385465d0a34 = v);
$parcel$export(module.exports, "useSyncExternalStore", () => $581086b41291c535$export$306c0aa65ff9ec16, (v) => $581086b41291c535$export$306c0aa65ff9ec16 = v);
$parcel$export(module.exports, "useTransition", () => $581086b41291c535$export$7b286972b8d8ccbf, (v) => $581086b41291c535$export$7b286972b8d8ccbf = v);
$parcel$export(module.exports, "version", () => $581086b41291c535$export$83d89fbfd8236492, (v) => $581086b41291c535$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $581086b41291c535$export$dca3b0875bd9a954;
var $581086b41291c535$export$16fa2f45be04daa8;
var $581086b41291c535$export$ffb0004e005737fa;
var $581086b41291c535$export$e2c29f18771995cb;
var $581086b41291c535$export$221d75b3f55bb0bd;
var $581086b41291c535$export$5f8d39834fd61797;
var $581086b41291c535$export$74bf444e3cd11ea5;
var $581086b41291c535$export$ae55be85d98224ed;
var $581086b41291c535$export$e530037191fcd5d7;
var $581086b41291c535$export$fd42f52fd3ae1109;
var $581086b41291c535$export$c8a8987d4410bf2d;
var $581086b41291c535$export$d38cd72104c1f0e9;
var $581086b41291c535$export$7d1e3a5e95ceca43;
var $581086b41291c535$export$257a8862b851cb5b;
var $581086b41291c535$export$a8257692ac88316c;
var $581086b41291c535$export$488013bae63b21da;
var $581086b41291c535$export$7c73462e0d25e514;
var $581086b41291c535$export$7568632d0d33d16d;
var $581086b41291c535$export$88948ce120ea2619;
var $581086b41291c535$export$35808ee640e87ca7;
var $581086b41291c535$export$fae74005e78b1a27;
var $581086b41291c535$export$dc8fbce3eb94dc1e;
var $581086b41291c535$export$6a7bc4e911dc01cf;
var $581086b41291c535$export$6d9c69b0de29b591;
var $581086b41291c535$export$f680877a34711e37;
var $581086b41291c535$export$d5a552a76deda3c2;
var $581086b41291c535$export$aaabe4eda9ed9969;
var $581086b41291c535$export$e5c5a5f917a5871c;
var $581086b41291c535$export$1538c33de8887b59;
var $581086b41291c535$export$13e3392192263954;
var $581086b41291c535$export$b8f5890fc79d6aca;
var $581086b41291c535$export$60241385465d0a34;
var $581086b41291c535$export$306c0aa65ff9ec16;
var $581086b41291c535$export$7b286972b8d8ccbf;
var $581086b41291c535$export$83d89fbfd8236492;
"use strict";
var $581086b41291c535$var$l = Symbol.for("react.element"), $581086b41291c535$var$n = Symbol.for("react.portal"), $581086b41291c535$var$p = Symbol.for("react.fragment"), $581086b41291c535$var$q = Symbol.for("react.strict_mode"), $581086b41291c535$var$r = Symbol.for("react.profiler"), $581086b41291c535$var$t = Symbol.for("react.provider"), $581086b41291c535$var$u = Symbol.for("react.context"), $581086b41291c535$var$v = Symbol.for("react.forward_ref"), $581086b41291c535$var$w = Symbol.for("react.suspense"), $581086b41291c535$var$x = Symbol.for("react.memo"), $581086b41291c535$var$y = Symbol.for("react.lazy"), $581086b41291c535$var$z = Symbol.iterator;
function $581086b41291c535$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $581086b41291c535$var$z && a[$581086b41291c535$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $581086b41291c535$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $581086b41291c535$var$C = Object.assign, $581086b41291c535$var$D = {};
function $581086b41291c535$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $581086b41291c535$var$D;
    this.updater = e || $581086b41291c535$var$B;
}
$581086b41291c535$var$E.prototype.isReactComponent = {};
$581086b41291c535$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$581086b41291c535$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $581086b41291c535$var$F() {}
$581086b41291c535$var$F.prototype = $581086b41291c535$var$E.prototype;
function $581086b41291c535$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $581086b41291c535$var$D;
    this.updater = e || $581086b41291c535$var$B;
}
var $581086b41291c535$var$H = $581086b41291c535$var$G.prototype = new $581086b41291c535$var$F;
$581086b41291c535$var$H.constructor = $581086b41291c535$var$G;
$581086b41291c535$var$C($581086b41291c535$var$H, $581086b41291c535$var$E.prototype);
$581086b41291c535$var$H.isPureReactComponent = !0;
var $581086b41291c535$var$I = Array.isArray, $581086b41291c535$var$J = Object.prototype.hasOwnProperty, $581086b41291c535$var$K = {
    current: null
}, $581086b41291c535$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $581086b41291c535$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$581086b41291c535$var$J.call(b, d) && !$581086b41291c535$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $581086b41291c535$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $581086b41291c535$var$K.current
    };
}
function $581086b41291c535$var$N(a, b) {
    return {
        $$typeof: $581086b41291c535$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $581086b41291c535$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $581086b41291c535$var$l;
}
function $581086b41291c535$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $581086b41291c535$var$P = /\/+/g;
function $581086b41291c535$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $581086b41291c535$var$escape("" + a.key) : b.toString(36);
}
function $581086b41291c535$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $581086b41291c535$var$l:
                case $581086b41291c535$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $581086b41291c535$var$Q(h, 0) : d, $581086b41291c535$var$I(c) ? (e = "", null != a && (e = a.replace($581086b41291c535$var$P, "$&/") + "/"), $581086b41291c535$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($581086b41291c535$var$O(c) && (c = $581086b41291c535$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($581086b41291c535$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($581086b41291c535$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $581086b41291c535$var$Q(k, g);
        h += $581086b41291c535$var$R(k, b, e, f, c);
    }
    else if (f = $581086b41291c535$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $581086b41291c535$var$Q(k, g++), h += $581086b41291c535$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $581086b41291c535$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $581086b41291c535$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $581086b41291c535$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $581086b41291c535$var$U = {
    current: null
}, $581086b41291c535$var$V = {
    transition: null
}, $581086b41291c535$var$W = {
    ReactCurrentDispatcher: $581086b41291c535$var$U,
    ReactCurrentBatchConfig: $581086b41291c535$var$V,
    ReactCurrentOwner: $581086b41291c535$var$K
};
$581086b41291c535$export$dca3b0875bd9a954 = {
    map: $581086b41291c535$var$S,
    forEach: function(a, b, e) {
        $581086b41291c535$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $581086b41291c535$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $581086b41291c535$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$581086b41291c535$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$581086b41291c535$export$16fa2f45be04daa8 = $581086b41291c535$var$E;
$581086b41291c535$export$ffb0004e005737fa = $581086b41291c535$var$p;
$581086b41291c535$export$e2c29f18771995cb = $581086b41291c535$var$r;
$581086b41291c535$export$221d75b3f55bb0bd = $581086b41291c535$var$G;
$581086b41291c535$export$5f8d39834fd61797 = $581086b41291c535$var$q;
$581086b41291c535$export$74bf444e3cd11ea5 = $581086b41291c535$var$w;
$581086b41291c535$export$ae55be85d98224ed = $581086b41291c535$var$W;
$581086b41291c535$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $581086b41291c535$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $581086b41291c535$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$581086b41291c535$var$J.call(b, f) && !$581086b41291c535$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $581086b41291c535$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$581086b41291c535$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $581086b41291c535$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $581086b41291c535$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$581086b41291c535$export$c8a8987d4410bf2d = $581086b41291c535$var$M;
$581086b41291c535$export$d38cd72104c1f0e9 = function(a) {
    var b = $581086b41291c535$var$M.bind(null, a);
    b.type = a;
    return b;
};
$581086b41291c535$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$581086b41291c535$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $581086b41291c535$var$v,
        render: a
    };
};
$581086b41291c535$export$a8257692ac88316c = $581086b41291c535$var$O;
$581086b41291c535$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $581086b41291c535$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $581086b41291c535$var$T
    };
};
$581086b41291c535$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $581086b41291c535$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$581086b41291c535$export$7568632d0d33d16d = function(a) {
    var b = $581086b41291c535$var$V.transition;
    $581086b41291c535$var$V.transition = {};
    try {
        a();
    } finally{
        $581086b41291c535$var$V.transition = b;
    }
};
$581086b41291c535$export$88948ce120ea2619 = function() {
    throw Error("act(...) is not supported in production builds of React.");
};
$581086b41291c535$export$35808ee640e87ca7 = function(a, b) {
    return $581086b41291c535$var$U.current.useCallback(a, b);
};
$581086b41291c535$export$fae74005e78b1a27 = function(a) {
    return $581086b41291c535$var$U.current.useContext(a);
};
$581086b41291c535$export$dc8fbce3eb94dc1e = function() {};
$581086b41291c535$export$6a7bc4e911dc01cf = function(a) {
    return $581086b41291c535$var$U.current.useDeferredValue(a);
};
$581086b41291c535$export$6d9c69b0de29b591 = function(a, b) {
    return $581086b41291c535$var$U.current.useEffect(a, b);
};
$581086b41291c535$export$f680877a34711e37 = function() {
    return $581086b41291c535$var$U.current.useId();
};
$581086b41291c535$export$d5a552a76deda3c2 = function(a, b, e) {
    return $581086b41291c535$var$U.current.useImperativeHandle(a, b, e);
};
$581086b41291c535$export$aaabe4eda9ed9969 = function(a, b) {
    return $581086b41291c535$var$U.current.useInsertionEffect(a, b);
};
$581086b41291c535$export$e5c5a5f917a5871c = function(a, b) {
    return $581086b41291c535$var$U.current.useLayoutEffect(a, b);
};
$581086b41291c535$export$1538c33de8887b59 = function(a, b) {
    return $581086b41291c535$var$U.current.useMemo(a, b);
};
$581086b41291c535$export$13e3392192263954 = function(a, b, e) {
    return $581086b41291c535$var$U.current.useReducer(a, b, e);
};
$581086b41291c535$export$b8f5890fc79d6aca = function(a) {
    return $581086b41291c535$var$U.current.useRef(a);
};
$581086b41291c535$export$60241385465d0a34 = function(a) {
    return $581086b41291c535$var$U.current.useState(a);
};
$581086b41291c535$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $581086b41291c535$var$U.current.useSyncExternalStore(a, b, e);
};
$581086b41291c535$export$7b286972b8d8ccbf = function() {
    return $581086b41291c535$var$U.current.useTransition();
};
$581086b41291c535$export$83d89fbfd8236492 = "18.2.0";

});



parcelRequire.register("kz03S", function(module, exports) {
"use strict";
function $ef871fc20ed070da$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== "function") return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($ef871fc20ed070da$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$ef871fc20ed070da$var$checkDCE();

module.exports = (parcelRequire("4EYMj"));

});
parcelRequire.register("4EYMj", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $364a0b1eab5991a3$export$ae55be85d98224ed, (v) => $364a0b1eab5991a3$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "createPortal", () => $364a0b1eab5991a3$export$d39a5bbd09211389, (v) => $364a0b1eab5991a3$export$d39a5bbd09211389 = v);
$parcel$export(module.exports, "createRoot", () => $364a0b1eab5991a3$export$882461b6382ed46c, (v) => $364a0b1eab5991a3$export$882461b6382ed46c = v);
$parcel$export(module.exports, "findDOMNode", () => $364a0b1eab5991a3$export$466bfc07425424d5, (v) => $364a0b1eab5991a3$export$466bfc07425424d5 = v);
$parcel$export(module.exports, "flushSync", () => $364a0b1eab5991a3$export$cd75ccfd720a3cd4, (v) => $364a0b1eab5991a3$export$cd75ccfd720a3cd4 = v);
$parcel$export(module.exports, "hydrate", () => $364a0b1eab5991a3$export$fa8d919ba61d84db, (v) => $364a0b1eab5991a3$export$fa8d919ba61d84db = v);
$parcel$export(module.exports, "hydrateRoot", () => $364a0b1eab5991a3$export$757ceba2d55c277e, (v) => $364a0b1eab5991a3$export$757ceba2d55c277e = v);
$parcel$export(module.exports, "render", () => $364a0b1eab5991a3$export$b3890eb0ae9dca99, (v) => $364a0b1eab5991a3$export$b3890eb0ae9dca99 = v);
$parcel$export(module.exports, "unmountComponentAtNode", () => $364a0b1eab5991a3$export$502457920280e6be, (v) => $364a0b1eab5991a3$export$502457920280e6be = v);
$parcel$export(module.exports, "unstable_batchedUpdates", () => $364a0b1eab5991a3$export$c78a37762a8d58e1, (v) => $364a0b1eab5991a3$export$c78a37762a8d58e1 = v);
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", () => $364a0b1eab5991a3$export$dc54d992c10e8a18, (v) => $364a0b1eab5991a3$export$dc54d992c10e8a18 = v);
$parcel$export(module.exports, "version", () => $364a0b1eab5991a3$export$83d89fbfd8236492, (v) => $364a0b1eab5991a3$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $364a0b1eab5991a3$export$ae55be85d98224ed;
var $364a0b1eab5991a3$export$d39a5bbd09211389;
var $364a0b1eab5991a3$export$882461b6382ed46c;
var $364a0b1eab5991a3$export$466bfc07425424d5;
var $364a0b1eab5991a3$export$cd75ccfd720a3cd4;
var $364a0b1eab5991a3$export$fa8d919ba61d84db;
var $364a0b1eab5991a3$export$757ceba2d55c277e;
var $364a0b1eab5991a3$export$b3890eb0ae9dca99;
var $364a0b1eab5991a3$export$502457920280e6be;
var $364a0b1eab5991a3$export$c78a37762a8d58e1;
var $364a0b1eab5991a3$export$dc54d992c10e8a18;
var $364a0b1eab5991a3$export$83d89fbfd8236492;
"use strict";

var $eO7Kz = parcelRequire("eO7Kz");

var $93WKs = parcelRequire("93WKs");
function $364a0b1eab5991a3$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $364a0b1eab5991a3$var$da = new Set, $364a0b1eab5991a3$var$ea = {};
function $364a0b1eab5991a3$var$fa(a, b) {
    $364a0b1eab5991a3$var$ha(a, b);
    $364a0b1eab5991a3$var$ha(a + "Capture", b);
}
function $364a0b1eab5991a3$var$ha(a, b) {
    $364a0b1eab5991a3$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$364a0b1eab5991a3$var$da.add(b[a]);
}
var $364a0b1eab5991a3$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $364a0b1eab5991a3$var$ja = Object.prototype.hasOwnProperty, $364a0b1eab5991a3$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $364a0b1eab5991a3$var$la = {}, $364a0b1eab5991a3$var$ma = {};
function $364a0b1eab5991a3$var$oa(a) {
    if ($364a0b1eab5991a3$var$ja.call($364a0b1eab5991a3$var$ma, a)) return !0;
    if ($364a0b1eab5991a3$var$ja.call($364a0b1eab5991a3$var$la, a)) return !1;
    if ($364a0b1eab5991a3$var$ka.test(a)) return $364a0b1eab5991a3$var$ma[a] = !0;
    $364a0b1eab5991a3$var$la[a] = !0;
    return !1;
}
function $364a0b1eab5991a3$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $364a0b1eab5991a3$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $364a0b1eab5991a3$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $364a0b1eab5991a3$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $364a0b1eab5991a3$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $364a0b1eab5991a3$var$z[a] = new $364a0b1eab5991a3$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $364a0b1eab5991a3$var$z[b] = new $364a0b1eab5991a3$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $364a0b1eab5991a3$var$z[a] = new $364a0b1eab5991a3$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $364a0b1eab5991a3$var$z[a] = new $364a0b1eab5991a3$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $364a0b1eab5991a3$var$z[a] = new $364a0b1eab5991a3$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $364a0b1eab5991a3$var$z[a] = new $364a0b1eab5991a3$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $364a0b1eab5991a3$var$z[a] = new $364a0b1eab5991a3$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $364a0b1eab5991a3$var$z[a] = new $364a0b1eab5991a3$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $364a0b1eab5991a3$var$z[a] = new $364a0b1eab5991a3$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $364a0b1eab5991a3$var$ra = /[\-:]([a-z])/g;
function $364a0b1eab5991a3$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($364a0b1eab5991a3$var$ra, $364a0b1eab5991a3$var$sa);
    $364a0b1eab5991a3$var$z[b] = new $364a0b1eab5991a3$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($364a0b1eab5991a3$var$ra, $364a0b1eab5991a3$var$sa);
    $364a0b1eab5991a3$var$z[b] = new $364a0b1eab5991a3$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($364a0b1eab5991a3$var$ra, $364a0b1eab5991a3$var$sa);
    $364a0b1eab5991a3$var$z[b] = new $364a0b1eab5991a3$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $364a0b1eab5991a3$var$z[a] = new $364a0b1eab5991a3$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$364a0b1eab5991a3$var$z.xlinkHref = new $364a0b1eab5991a3$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $364a0b1eab5991a3$var$z[a] = new $364a0b1eab5991a3$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $364a0b1eab5991a3$var$ta(a, b, c, d) {
    var e = $364a0b1eab5991a3$var$z.hasOwnProperty(b) ? $364a0b1eab5991a3$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $364a0b1eab5991a3$var$qa(b, c, e, d) && (c = null), d || null === e ? $364a0b1eab5991a3$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $364a0b1eab5991a3$var$ua = $eO7Kz.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $364a0b1eab5991a3$var$va = Symbol.for("react.element"), $364a0b1eab5991a3$var$wa = Symbol.for("react.portal"), $364a0b1eab5991a3$var$ya = Symbol.for("react.fragment"), $364a0b1eab5991a3$var$za = Symbol.for("react.strict_mode"), $364a0b1eab5991a3$var$Aa = Symbol.for("react.profiler"), $364a0b1eab5991a3$var$Ba = Symbol.for("react.provider"), $364a0b1eab5991a3$var$Ca = Symbol.for("react.context"), $364a0b1eab5991a3$var$Da = Symbol.for("react.forward_ref"), $364a0b1eab5991a3$var$Ea = Symbol.for("react.suspense"), $364a0b1eab5991a3$var$Fa = Symbol.for("react.suspense_list"), $364a0b1eab5991a3$var$Ga = Symbol.for("react.memo"), $364a0b1eab5991a3$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $364a0b1eab5991a3$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $364a0b1eab5991a3$var$Ja = Symbol.iterator;
function $364a0b1eab5991a3$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $364a0b1eab5991a3$var$Ja && a[$364a0b1eab5991a3$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $364a0b1eab5991a3$var$A = Object.assign, $364a0b1eab5991a3$var$La;
function $364a0b1eab5991a3$var$Ma(a) {
    if (void 0 === $364a0b1eab5991a3$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $364a0b1eab5991a3$var$La = b && b[1] || "";
    }
    return "\n" + $364a0b1eab5991a3$var$La + a;
}
var $364a0b1eab5991a3$var$Na = !1;
function $364a0b1eab5991a3$var$Oa(a, b) {
    if (!a || $364a0b1eab5991a3$var$Na) return "";
    $364a0b1eab5991a3$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $364a0b1eab5991a3$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $364a0b1eab5991a3$var$Ma(a) : "";
}
function $364a0b1eab5991a3$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $364a0b1eab5991a3$var$Ma(a.type);
        case 16:
            return $364a0b1eab5991a3$var$Ma("Lazy");
        case 13:
            return $364a0b1eab5991a3$var$Ma("Suspense");
        case 19:
            return $364a0b1eab5991a3$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $364a0b1eab5991a3$var$Oa(a.type, !1), a;
        case 11:
            return a = $364a0b1eab5991a3$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $364a0b1eab5991a3$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $364a0b1eab5991a3$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $364a0b1eab5991a3$var$ya:
            return "Fragment";
        case $364a0b1eab5991a3$var$wa:
            return "Portal";
        case $364a0b1eab5991a3$var$Aa:
            return "Profiler";
        case $364a0b1eab5991a3$var$za:
            return "StrictMode";
        case $364a0b1eab5991a3$var$Ea:
            return "Suspense";
        case $364a0b1eab5991a3$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $364a0b1eab5991a3$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $364a0b1eab5991a3$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $364a0b1eab5991a3$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $364a0b1eab5991a3$var$Ga:
            return b = a.displayName || null, null !== b ? b : $364a0b1eab5991a3$var$Qa(a.type) || "Memo";
        case $364a0b1eab5991a3$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $364a0b1eab5991a3$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $364a0b1eab5991a3$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $364a0b1eab5991a3$var$Qa(b);
        case 8:
            return b === $364a0b1eab5991a3$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $364a0b1eab5991a3$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $364a0b1eab5991a3$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $364a0b1eab5991a3$var$Ua(a) {
    var b = $364a0b1eab5991a3$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $364a0b1eab5991a3$var$Va(a) {
    a._valueTracker || (a._valueTracker = $364a0b1eab5991a3$var$Ua(a));
}
function $364a0b1eab5991a3$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $364a0b1eab5991a3$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $364a0b1eab5991a3$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $364a0b1eab5991a3$var$Ya(a, b) {
    var c = b.checked;
    return $364a0b1eab5991a3$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $364a0b1eab5991a3$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $364a0b1eab5991a3$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $364a0b1eab5991a3$var$ab(a, b) {
    b = b.checked;
    null != b && $364a0b1eab5991a3$var$ta(a, "checked", b, !1);
}
function $364a0b1eab5991a3$var$bb(a, b) {
    $364a0b1eab5991a3$var$ab(a, b);
    var c = $364a0b1eab5991a3$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $364a0b1eab5991a3$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $364a0b1eab5991a3$var$cb(a, b.type, $364a0b1eab5991a3$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $364a0b1eab5991a3$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $364a0b1eab5991a3$var$cb(a, b, c) {
    if ("number" !== b || $364a0b1eab5991a3$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $364a0b1eab5991a3$var$eb = Array.isArray;
function $364a0b1eab5991a3$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $364a0b1eab5991a3$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $364a0b1eab5991a3$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($364a0b1eab5991a3$var$p(91));
    return $364a0b1eab5991a3$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $364a0b1eab5991a3$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($364a0b1eab5991a3$var$p(92));
            if ($364a0b1eab5991a3$var$eb(c)) {
                if (1 < c.length) throw Error($364a0b1eab5991a3$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $364a0b1eab5991a3$var$Sa(c)
    };
}
function $364a0b1eab5991a3$var$ib(a, b) {
    var c = $364a0b1eab5991a3$var$Sa(b.value), d = $364a0b1eab5991a3$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $364a0b1eab5991a3$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $364a0b1eab5991a3$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $364a0b1eab5991a3$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $364a0b1eab5991a3$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $364a0b1eab5991a3$var$mb, $364a0b1eab5991a3$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $364a0b1eab5991a3$var$mb = $364a0b1eab5991a3$var$mb || document.createElement("div");
        $364a0b1eab5991a3$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $364a0b1eab5991a3$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $364a0b1eab5991a3$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $364a0b1eab5991a3$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $364a0b1eab5991a3$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($364a0b1eab5991a3$var$pb).forEach(function(a) {
    $364a0b1eab5991a3$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $364a0b1eab5991a3$var$pb[b] = $364a0b1eab5991a3$var$pb[a];
    });
});
function $364a0b1eab5991a3$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $364a0b1eab5991a3$var$pb.hasOwnProperty(a) && $364a0b1eab5991a3$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $364a0b1eab5991a3$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $364a0b1eab5991a3$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $364a0b1eab5991a3$var$tb = $364a0b1eab5991a3$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $364a0b1eab5991a3$var$ub(a, b) {
    if (b) {
        if ($364a0b1eab5991a3$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($364a0b1eab5991a3$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($364a0b1eab5991a3$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($364a0b1eab5991a3$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($364a0b1eab5991a3$var$p(62));
    }
}
function $364a0b1eab5991a3$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $364a0b1eab5991a3$var$wb = null;
function $364a0b1eab5991a3$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $364a0b1eab5991a3$var$yb = null, $364a0b1eab5991a3$var$zb = null, $364a0b1eab5991a3$var$Ab = null;
function $364a0b1eab5991a3$var$Bb(a) {
    if (a = $364a0b1eab5991a3$var$Cb(a)) {
        if ("function" !== typeof $364a0b1eab5991a3$var$yb) throw Error($364a0b1eab5991a3$var$p(280));
        var b = a.stateNode;
        b && (b = $364a0b1eab5991a3$var$Db(b), $364a0b1eab5991a3$var$yb(a.stateNode, a.type, b));
    }
}
function $364a0b1eab5991a3$var$Eb(a) {
    $364a0b1eab5991a3$var$zb ? $364a0b1eab5991a3$var$Ab ? $364a0b1eab5991a3$var$Ab.push(a) : $364a0b1eab5991a3$var$Ab = [
        a
    ] : $364a0b1eab5991a3$var$zb = a;
}
function $364a0b1eab5991a3$var$Fb() {
    if ($364a0b1eab5991a3$var$zb) {
        var a = $364a0b1eab5991a3$var$zb, b = $364a0b1eab5991a3$var$Ab;
        $364a0b1eab5991a3$var$Ab = $364a0b1eab5991a3$var$zb = null;
        $364a0b1eab5991a3$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$364a0b1eab5991a3$var$Bb(b[a]);
    }
}
function $364a0b1eab5991a3$var$Gb(a, b) {
    return a(b);
}
function $364a0b1eab5991a3$var$Hb() {}
var $364a0b1eab5991a3$var$Ib = !1;
function $364a0b1eab5991a3$var$Jb(a, b, c) {
    if ($364a0b1eab5991a3$var$Ib) return a(b, c);
    $364a0b1eab5991a3$var$Ib = !0;
    try {
        return $364a0b1eab5991a3$var$Gb(a, b, c);
    } finally{
        if ($364a0b1eab5991a3$var$Ib = !1, null !== $364a0b1eab5991a3$var$zb || null !== $364a0b1eab5991a3$var$Ab) $364a0b1eab5991a3$var$Hb(), $364a0b1eab5991a3$var$Fb();
    }
}
function $364a0b1eab5991a3$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $364a0b1eab5991a3$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($364a0b1eab5991a3$var$p(231, b, typeof c));
    return c;
}
var $364a0b1eab5991a3$var$Lb = !1;
if ($364a0b1eab5991a3$var$ia) try {
    var $364a0b1eab5991a3$var$Mb = {};
    Object.defineProperty($364a0b1eab5991a3$var$Mb, "passive", {
        get: function() {
            $364a0b1eab5991a3$var$Lb = !0;
        }
    });
    window.addEventListener("test", $364a0b1eab5991a3$var$Mb, $364a0b1eab5991a3$var$Mb);
    window.removeEventListener("test", $364a0b1eab5991a3$var$Mb, $364a0b1eab5991a3$var$Mb);
} catch (a) {
    $364a0b1eab5991a3$var$Lb = !1;
}
function $364a0b1eab5991a3$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $364a0b1eab5991a3$var$Ob = !1, $364a0b1eab5991a3$var$Pb = null, $364a0b1eab5991a3$var$Qb = !1, $364a0b1eab5991a3$var$Rb = null, $364a0b1eab5991a3$var$Sb = {
    onError: function(a) {
        $364a0b1eab5991a3$var$Ob = !0;
        $364a0b1eab5991a3$var$Pb = a;
    }
};
function $364a0b1eab5991a3$var$Tb(a, b, c, d, e, f, g, h, k) {
    $364a0b1eab5991a3$var$Ob = !1;
    $364a0b1eab5991a3$var$Pb = null;
    $364a0b1eab5991a3$var$Nb.apply($364a0b1eab5991a3$var$Sb, arguments);
}
function $364a0b1eab5991a3$var$Ub(a, b, c, d, e, f, g, h, k) {
    $364a0b1eab5991a3$var$Tb.apply(this, arguments);
    if ($364a0b1eab5991a3$var$Ob) {
        if ($364a0b1eab5991a3$var$Ob) {
            var l = $364a0b1eab5991a3$var$Pb;
            $364a0b1eab5991a3$var$Ob = !1;
            $364a0b1eab5991a3$var$Pb = null;
        } else throw Error($364a0b1eab5991a3$var$p(198));
        $364a0b1eab5991a3$var$Qb || ($364a0b1eab5991a3$var$Qb = !0, $364a0b1eab5991a3$var$Rb = l);
    }
}
function $364a0b1eab5991a3$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $364a0b1eab5991a3$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $364a0b1eab5991a3$var$Xb(a) {
    if ($364a0b1eab5991a3$var$Vb(a) !== a) throw Error($364a0b1eab5991a3$var$p(188));
}
function $364a0b1eab5991a3$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $364a0b1eab5991a3$var$Vb(a);
        if (null === b) throw Error($364a0b1eab5991a3$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $364a0b1eab5991a3$var$Xb(e), a;
                if (f === d) return $364a0b1eab5991a3$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($364a0b1eab5991a3$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($364a0b1eab5991a3$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($364a0b1eab5991a3$var$p(190));
    }
    if (3 !== c.tag) throw Error($364a0b1eab5991a3$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $364a0b1eab5991a3$var$Zb(a) {
    a = $364a0b1eab5991a3$var$Yb(a);
    return null !== a ? $364a0b1eab5991a3$var$$b(a) : null;
}
function $364a0b1eab5991a3$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $364a0b1eab5991a3$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $364a0b1eab5991a3$var$ac = $93WKs.unstable_scheduleCallback, $364a0b1eab5991a3$var$bc = $93WKs.unstable_cancelCallback, $364a0b1eab5991a3$var$cc = $93WKs.unstable_shouldYield, $364a0b1eab5991a3$var$dc = $93WKs.unstable_requestPaint, $364a0b1eab5991a3$var$B = $93WKs.unstable_now, $364a0b1eab5991a3$var$ec = $93WKs.unstable_getCurrentPriorityLevel, $364a0b1eab5991a3$var$fc = $93WKs.unstable_ImmediatePriority, $364a0b1eab5991a3$var$gc = $93WKs.unstable_UserBlockingPriority, $364a0b1eab5991a3$var$hc = $93WKs.unstable_NormalPriority, $364a0b1eab5991a3$var$ic = $93WKs.unstable_LowPriority, $364a0b1eab5991a3$var$jc = $93WKs.unstable_IdlePriority, $364a0b1eab5991a3$var$kc = null, $364a0b1eab5991a3$var$lc = null;
function $364a0b1eab5991a3$var$mc(a) {
    if ($364a0b1eab5991a3$var$lc && "function" === typeof $364a0b1eab5991a3$var$lc.onCommitFiberRoot) try {
        $364a0b1eab5991a3$var$lc.onCommitFiberRoot($364a0b1eab5991a3$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $364a0b1eab5991a3$var$oc = Math.clz32 ? Math.clz32 : $364a0b1eab5991a3$var$nc, $364a0b1eab5991a3$var$pc = Math.log, $364a0b1eab5991a3$var$qc = Math.LN2;
function $364a0b1eab5991a3$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($364a0b1eab5991a3$var$pc(a) / $364a0b1eab5991a3$var$qc | 0) | 0;
}
var $364a0b1eab5991a3$var$rc = 64, $364a0b1eab5991a3$var$sc = 4194304;
function $364a0b1eab5991a3$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $364a0b1eab5991a3$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $364a0b1eab5991a3$var$tc(h) : (f &= g, 0 !== f && (d = $364a0b1eab5991a3$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $364a0b1eab5991a3$var$tc(g) : 0 !== f && (d = $364a0b1eab5991a3$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $364a0b1eab5991a3$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $364a0b1eab5991a3$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $364a0b1eab5991a3$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $364a0b1eab5991a3$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $364a0b1eab5991a3$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $364a0b1eab5991a3$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $364a0b1eab5991a3$var$yc() {
    var a = $364a0b1eab5991a3$var$rc;
    $364a0b1eab5991a3$var$rc <<= 1;
    0 === ($364a0b1eab5991a3$var$rc & 4194240) && ($364a0b1eab5991a3$var$rc = 64);
    return a;
}
function $364a0b1eab5991a3$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $364a0b1eab5991a3$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $364a0b1eab5991a3$var$oc(b);
    a[b] = c;
}
function $364a0b1eab5991a3$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $364a0b1eab5991a3$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $364a0b1eab5991a3$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $364a0b1eab5991a3$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $364a0b1eab5991a3$var$C = 0;
function $364a0b1eab5991a3$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $364a0b1eab5991a3$var$Ec, $364a0b1eab5991a3$var$Fc, $364a0b1eab5991a3$var$Gc, $364a0b1eab5991a3$var$Hc, $364a0b1eab5991a3$var$Ic, $364a0b1eab5991a3$var$Jc = !1, $364a0b1eab5991a3$var$Kc = [], $364a0b1eab5991a3$var$Lc = null, $364a0b1eab5991a3$var$Mc = null, $364a0b1eab5991a3$var$Nc = null, $364a0b1eab5991a3$var$Oc = new Map, $364a0b1eab5991a3$var$Pc = new Map, $364a0b1eab5991a3$var$Qc = [], $364a0b1eab5991a3$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $364a0b1eab5991a3$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $364a0b1eab5991a3$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $364a0b1eab5991a3$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $364a0b1eab5991a3$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $364a0b1eab5991a3$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $364a0b1eab5991a3$var$Pc.delete(b.pointerId);
    }
}
function $364a0b1eab5991a3$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $364a0b1eab5991a3$var$Cb(b), null !== b && $364a0b1eab5991a3$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $364a0b1eab5991a3$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $364a0b1eab5991a3$var$Lc = $364a0b1eab5991a3$var$Tc($364a0b1eab5991a3$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $364a0b1eab5991a3$var$Mc = $364a0b1eab5991a3$var$Tc($364a0b1eab5991a3$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $364a0b1eab5991a3$var$Nc = $364a0b1eab5991a3$var$Tc($364a0b1eab5991a3$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $364a0b1eab5991a3$var$Oc.set(f, $364a0b1eab5991a3$var$Tc($364a0b1eab5991a3$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $364a0b1eab5991a3$var$Pc.set(f, $364a0b1eab5991a3$var$Tc($364a0b1eab5991a3$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $364a0b1eab5991a3$var$Vc(a) {
    var b = $364a0b1eab5991a3$var$Wc(a.target);
    if (null !== b) {
        var c = $364a0b1eab5991a3$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $364a0b1eab5991a3$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $364a0b1eab5991a3$var$Ic(a.priority, function() {
                        $364a0b1eab5991a3$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $364a0b1eab5991a3$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $364a0b1eab5991a3$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $364a0b1eab5991a3$var$wb = d;
            c.target.dispatchEvent(d);
            $364a0b1eab5991a3$var$wb = null;
        } else return b = $364a0b1eab5991a3$var$Cb(c), null !== b && $364a0b1eab5991a3$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $364a0b1eab5991a3$var$Zc(a, b, c) {
    $364a0b1eab5991a3$var$Xc(a) && c.delete(b);
}
function $364a0b1eab5991a3$var$$c() {
    $364a0b1eab5991a3$var$Jc = !1;
    null !== $364a0b1eab5991a3$var$Lc && $364a0b1eab5991a3$var$Xc($364a0b1eab5991a3$var$Lc) && ($364a0b1eab5991a3$var$Lc = null);
    null !== $364a0b1eab5991a3$var$Mc && $364a0b1eab5991a3$var$Xc($364a0b1eab5991a3$var$Mc) && ($364a0b1eab5991a3$var$Mc = null);
    null !== $364a0b1eab5991a3$var$Nc && $364a0b1eab5991a3$var$Xc($364a0b1eab5991a3$var$Nc) && ($364a0b1eab5991a3$var$Nc = null);
    $364a0b1eab5991a3$var$Oc.forEach($364a0b1eab5991a3$var$Zc);
    $364a0b1eab5991a3$var$Pc.forEach($364a0b1eab5991a3$var$Zc);
}
function $364a0b1eab5991a3$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $364a0b1eab5991a3$var$Jc || ($364a0b1eab5991a3$var$Jc = !0, $93WKs.unstable_scheduleCallback($93WKs.unstable_NormalPriority, $364a0b1eab5991a3$var$$c)));
}
function $364a0b1eab5991a3$var$bd(a) {
    function b(b) {
        return $364a0b1eab5991a3$var$ad(b, a);
    }
    if (0 < $364a0b1eab5991a3$var$Kc.length) {
        $364a0b1eab5991a3$var$ad($364a0b1eab5991a3$var$Kc[0], a);
        for(var c = 1; c < $364a0b1eab5991a3$var$Kc.length; c++){
            var d = $364a0b1eab5991a3$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $364a0b1eab5991a3$var$Lc && $364a0b1eab5991a3$var$ad($364a0b1eab5991a3$var$Lc, a);
    null !== $364a0b1eab5991a3$var$Mc && $364a0b1eab5991a3$var$ad($364a0b1eab5991a3$var$Mc, a);
    null !== $364a0b1eab5991a3$var$Nc && $364a0b1eab5991a3$var$ad($364a0b1eab5991a3$var$Nc, a);
    $364a0b1eab5991a3$var$Oc.forEach(b);
    $364a0b1eab5991a3$var$Pc.forEach(b);
    for(c = 0; c < $364a0b1eab5991a3$var$Qc.length; c++)d = $364a0b1eab5991a3$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $364a0b1eab5991a3$var$Qc.length && (c = $364a0b1eab5991a3$var$Qc[0], null === c.blockedOn);)$364a0b1eab5991a3$var$Vc(c), null === c.blockedOn && $364a0b1eab5991a3$var$Qc.shift();
}
var $364a0b1eab5991a3$var$cd = $364a0b1eab5991a3$var$ua.ReactCurrentBatchConfig, $364a0b1eab5991a3$var$dd = !0;
function $364a0b1eab5991a3$var$ed(a, b, c, d) {
    var e = $364a0b1eab5991a3$var$C, f = $364a0b1eab5991a3$var$cd.transition;
    $364a0b1eab5991a3$var$cd.transition = null;
    try {
        $364a0b1eab5991a3$var$C = 1, $364a0b1eab5991a3$var$fd(a, b, c, d);
    } finally{
        $364a0b1eab5991a3$var$C = e, $364a0b1eab5991a3$var$cd.transition = f;
    }
}
function $364a0b1eab5991a3$var$gd(a, b, c, d) {
    var e = $364a0b1eab5991a3$var$C, f = $364a0b1eab5991a3$var$cd.transition;
    $364a0b1eab5991a3$var$cd.transition = null;
    try {
        $364a0b1eab5991a3$var$C = 4, $364a0b1eab5991a3$var$fd(a, b, c, d);
    } finally{
        $364a0b1eab5991a3$var$C = e, $364a0b1eab5991a3$var$cd.transition = f;
    }
}
function $364a0b1eab5991a3$var$fd(a, b, c, d) {
    if ($364a0b1eab5991a3$var$dd) {
        var e = $364a0b1eab5991a3$var$Yc(a, b, c, d);
        if (null === e) $364a0b1eab5991a3$var$hd(a, b, d, $364a0b1eab5991a3$var$id, c), $364a0b1eab5991a3$var$Sc(a, d);
        else if ($364a0b1eab5991a3$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($364a0b1eab5991a3$var$Sc(a, d), b & 4 && -1 < $364a0b1eab5991a3$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $364a0b1eab5991a3$var$Cb(e);
                null !== f && $364a0b1eab5991a3$var$Ec(f);
                f = $364a0b1eab5991a3$var$Yc(a, b, c, d);
                null === f && $364a0b1eab5991a3$var$hd(a, b, d, $364a0b1eab5991a3$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $364a0b1eab5991a3$var$hd(a, b, d, null, c);
    }
}
var $364a0b1eab5991a3$var$id = null;
function $364a0b1eab5991a3$var$Yc(a, b, c, d) {
    $364a0b1eab5991a3$var$id = null;
    a = $364a0b1eab5991a3$var$xb(d);
    a = $364a0b1eab5991a3$var$Wc(a);
    if (null !== a) {
        if (b = $364a0b1eab5991a3$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $364a0b1eab5991a3$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $364a0b1eab5991a3$var$id = a;
    return null;
}
function $364a0b1eab5991a3$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($364a0b1eab5991a3$var$ec()){
                case $364a0b1eab5991a3$var$fc:
                    return 1;
                case $364a0b1eab5991a3$var$gc:
                    return 4;
                case $364a0b1eab5991a3$var$hc:
                case $364a0b1eab5991a3$var$ic:
                    return 16;
                case $364a0b1eab5991a3$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $364a0b1eab5991a3$var$kd = null, $364a0b1eab5991a3$var$ld = null, $364a0b1eab5991a3$var$md = null;
function $364a0b1eab5991a3$var$nd() {
    if ($364a0b1eab5991a3$var$md) return $364a0b1eab5991a3$var$md;
    var a, b = $364a0b1eab5991a3$var$ld, c = b.length, d, e = "value" in $364a0b1eab5991a3$var$kd ? $364a0b1eab5991a3$var$kd.value : $364a0b1eab5991a3$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $364a0b1eab5991a3$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $364a0b1eab5991a3$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $364a0b1eab5991a3$var$pd() {
    return !0;
}
function $364a0b1eab5991a3$var$qd() {
    return !1;
}
function $364a0b1eab5991a3$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $364a0b1eab5991a3$var$pd : $364a0b1eab5991a3$var$qd;
        this.isPropagationStopped = $364a0b1eab5991a3$var$qd;
        return this;
    }
    $364a0b1eab5991a3$var$A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $364a0b1eab5991a3$var$pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $364a0b1eab5991a3$var$pd);
        },
        persist: function() {},
        isPersistent: $364a0b1eab5991a3$var$pd
    });
    return b;
}
var $364a0b1eab5991a3$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $364a0b1eab5991a3$var$td = $364a0b1eab5991a3$var$rd($364a0b1eab5991a3$var$sd), $364a0b1eab5991a3$var$ud = $364a0b1eab5991a3$var$A({}, $364a0b1eab5991a3$var$sd, {
    view: 0,
    detail: 0
}), $364a0b1eab5991a3$var$vd = $364a0b1eab5991a3$var$rd($364a0b1eab5991a3$var$ud), $364a0b1eab5991a3$var$wd, $364a0b1eab5991a3$var$xd, $364a0b1eab5991a3$var$yd, $364a0b1eab5991a3$var$Ad = $364a0b1eab5991a3$var$A({}, $364a0b1eab5991a3$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $364a0b1eab5991a3$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $364a0b1eab5991a3$var$yd && ($364a0b1eab5991a3$var$yd && "mousemove" === a.type ? ($364a0b1eab5991a3$var$wd = a.screenX - $364a0b1eab5991a3$var$yd.screenX, $364a0b1eab5991a3$var$xd = a.screenY - $364a0b1eab5991a3$var$yd.screenY) : $364a0b1eab5991a3$var$xd = $364a0b1eab5991a3$var$wd = 0, $364a0b1eab5991a3$var$yd = a);
        return $364a0b1eab5991a3$var$wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $364a0b1eab5991a3$var$xd;
    }
}), $364a0b1eab5991a3$var$Bd = $364a0b1eab5991a3$var$rd($364a0b1eab5991a3$var$Ad), $364a0b1eab5991a3$var$Cd = $364a0b1eab5991a3$var$A({}, $364a0b1eab5991a3$var$Ad, {
    dataTransfer: 0
}), $364a0b1eab5991a3$var$Dd = $364a0b1eab5991a3$var$rd($364a0b1eab5991a3$var$Cd), $364a0b1eab5991a3$var$Ed = $364a0b1eab5991a3$var$A({}, $364a0b1eab5991a3$var$ud, {
    relatedTarget: 0
}), $364a0b1eab5991a3$var$Fd = $364a0b1eab5991a3$var$rd($364a0b1eab5991a3$var$Ed), $364a0b1eab5991a3$var$Gd = $364a0b1eab5991a3$var$A({}, $364a0b1eab5991a3$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $364a0b1eab5991a3$var$Hd = $364a0b1eab5991a3$var$rd($364a0b1eab5991a3$var$Gd), $364a0b1eab5991a3$var$Id = $364a0b1eab5991a3$var$A({}, $364a0b1eab5991a3$var$sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $364a0b1eab5991a3$var$Jd = $364a0b1eab5991a3$var$rd($364a0b1eab5991a3$var$Id), $364a0b1eab5991a3$var$Kd = $364a0b1eab5991a3$var$A({}, $364a0b1eab5991a3$var$sd, {
    data: 0
}), $364a0b1eab5991a3$var$Ld = $364a0b1eab5991a3$var$rd($364a0b1eab5991a3$var$Kd), $364a0b1eab5991a3$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $364a0b1eab5991a3$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $364a0b1eab5991a3$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $364a0b1eab5991a3$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $364a0b1eab5991a3$var$Od[a]) ? !!b[a] : !1;
}
function $364a0b1eab5991a3$var$zd() {
    return $364a0b1eab5991a3$var$Pd;
}
var $364a0b1eab5991a3$var$Qd = $364a0b1eab5991a3$var$A({}, $364a0b1eab5991a3$var$ud, {
    key: function(a) {
        if (a.key) {
            var b = $364a0b1eab5991a3$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $364a0b1eab5991a3$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $364a0b1eab5991a3$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $364a0b1eab5991a3$var$zd,
    charCode: function(a) {
        return "keypress" === a.type ? $364a0b1eab5991a3$var$od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $364a0b1eab5991a3$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $364a0b1eab5991a3$var$Rd = $364a0b1eab5991a3$var$rd($364a0b1eab5991a3$var$Qd), $364a0b1eab5991a3$var$Sd = $364a0b1eab5991a3$var$A({}, $364a0b1eab5991a3$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $364a0b1eab5991a3$var$Td = $364a0b1eab5991a3$var$rd($364a0b1eab5991a3$var$Sd), $364a0b1eab5991a3$var$Ud = $364a0b1eab5991a3$var$A({}, $364a0b1eab5991a3$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $364a0b1eab5991a3$var$zd
}), $364a0b1eab5991a3$var$Vd = $364a0b1eab5991a3$var$rd($364a0b1eab5991a3$var$Ud), $364a0b1eab5991a3$var$Wd = $364a0b1eab5991a3$var$A({}, $364a0b1eab5991a3$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $364a0b1eab5991a3$var$Xd = $364a0b1eab5991a3$var$rd($364a0b1eab5991a3$var$Wd), $364a0b1eab5991a3$var$Yd = $364a0b1eab5991a3$var$A({}, $364a0b1eab5991a3$var$Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $364a0b1eab5991a3$var$Zd = $364a0b1eab5991a3$var$rd($364a0b1eab5991a3$var$Yd), $364a0b1eab5991a3$var$$d = [
    9,
    13,
    27,
    32
], $364a0b1eab5991a3$var$ae = $364a0b1eab5991a3$var$ia && "CompositionEvent" in window, $364a0b1eab5991a3$var$be = null;
$364a0b1eab5991a3$var$ia && "documentMode" in document && ($364a0b1eab5991a3$var$be = document.documentMode);
var $364a0b1eab5991a3$var$ce = $364a0b1eab5991a3$var$ia && "TextEvent" in window && !$364a0b1eab5991a3$var$be, $364a0b1eab5991a3$var$de = $364a0b1eab5991a3$var$ia && (!$364a0b1eab5991a3$var$ae || $364a0b1eab5991a3$var$be && 8 < $364a0b1eab5991a3$var$be && 11 >= $364a0b1eab5991a3$var$be), $364a0b1eab5991a3$var$ee = String.fromCharCode(32), $364a0b1eab5991a3$var$fe = !1;
function $364a0b1eab5991a3$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $364a0b1eab5991a3$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $364a0b1eab5991a3$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $364a0b1eab5991a3$var$ie = !1;
function $364a0b1eab5991a3$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $364a0b1eab5991a3$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $364a0b1eab5991a3$var$fe = !0;
            return $364a0b1eab5991a3$var$ee;
        case "textInput":
            return a = b.data, a === $364a0b1eab5991a3$var$ee && $364a0b1eab5991a3$var$fe ? null : a;
        default:
            return null;
    }
}
function $364a0b1eab5991a3$var$ke(a, b) {
    if ($364a0b1eab5991a3$var$ie) return "compositionend" === a || !$364a0b1eab5991a3$var$ae && $364a0b1eab5991a3$var$ge(a, b) ? (a = $364a0b1eab5991a3$var$nd(), $364a0b1eab5991a3$var$md = $364a0b1eab5991a3$var$ld = $364a0b1eab5991a3$var$kd = null, $364a0b1eab5991a3$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $364a0b1eab5991a3$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $364a0b1eab5991a3$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $364a0b1eab5991a3$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$364a0b1eab5991a3$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $364a0b1eab5991a3$var$ne(a, b, c, d) {
    $364a0b1eab5991a3$var$Eb(d);
    b = $364a0b1eab5991a3$var$oe(b, "onChange");
    0 < b.length && (c = new $364a0b1eab5991a3$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $364a0b1eab5991a3$var$pe = null, $364a0b1eab5991a3$var$qe = null;
function $364a0b1eab5991a3$var$re(a) {
    $364a0b1eab5991a3$var$se(a, 0);
}
function $364a0b1eab5991a3$var$te(a) {
    var b = $364a0b1eab5991a3$var$ue(a);
    if ($364a0b1eab5991a3$var$Wa(b)) return a;
}
function $364a0b1eab5991a3$var$ve(a, b) {
    if ("change" === a) return b;
}
var $364a0b1eab5991a3$var$we = !1;
if ($364a0b1eab5991a3$var$ia) {
    var $364a0b1eab5991a3$var$xe;
    if ($364a0b1eab5991a3$var$ia) {
        var $364a0b1eab5991a3$var$ye = "oninput" in document;
        if (!$364a0b1eab5991a3$var$ye) {
            var $364a0b1eab5991a3$var$ze = document.createElement("div");
            $364a0b1eab5991a3$var$ze.setAttribute("oninput", "return;");
            $364a0b1eab5991a3$var$ye = "function" === typeof $364a0b1eab5991a3$var$ze.oninput;
        }
        $364a0b1eab5991a3$var$xe = $364a0b1eab5991a3$var$ye;
    } else $364a0b1eab5991a3$var$xe = !1;
    $364a0b1eab5991a3$var$we = $364a0b1eab5991a3$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $364a0b1eab5991a3$var$Ae() {
    $364a0b1eab5991a3$var$pe && ($364a0b1eab5991a3$var$pe.detachEvent("onpropertychange", $364a0b1eab5991a3$var$Be), $364a0b1eab5991a3$var$qe = $364a0b1eab5991a3$var$pe = null);
}
function $364a0b1eab5991a3$var$Be(a) {
    if ("value" === a.propertyName && $364a0b1eab5991a3$var$te($364a0b1eab5991a3$var$qe)) {
        var b = [];
        $364a0b1eab5991a3$var$ne(b, $364a0b1eab5991a3$var$qe, a, $364a0b1eab5991a3$var$xb(a));
        $364a0b1eab5991a3$var$Jb($364a0b1eab5991a3$var$re, b);
    }
}
function $364a0b1eab5991a3$var$Ce(a, b, c) {
    "focusin" === a ? ($364a0b1eab5991a3$var$Ae(), $364a0b1eab5991a3$var$pe = b, $364a0b1eab5991a3$var$qe = c, $364a0b1eab5991a3$var$pe.attachEvent("onpropertychange", $364a0b1eab5991a3$var$Be)) : "focusout" === a && $364a0b1eab5991a3$var$Ae();
}
function $364a0b1eab5991a3$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $364a0b1eab5991a3$var$te($364a0b1eab5991a3$var$qe);
}
function $364a0b1eab5991a3$var$Ee(a, b) {
    if ("click" === a) return $364a0b1eab5991a3$var$te(b);
}
function $364a0b1eab5991a3$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $364a0b1eab5991a3$var$te(b);
}
function $364a0b1eab5991a3$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $364a0b1eab5991a3$var$He = "function" === typeof Object.is ? Object.is : $364a0b1eab5991a3$var$Ge;
function $364a0b1eab5991a3$var$Ie(a, b) {
    if ($364a0b1eab5991a3$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$364a0b1eab5991a3$var$ja.call(b, e) || !$364a0b1eab5991a3$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $364a0b1eab5991a3$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $364a0b1eab5991a3$var$Ke(a, b) {
    var c = $364a0b1eab5991a3$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $364a0b1eab5991a3$var$Je(c);
    }
}
function $364a0b1eab5991a3$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $364a0b1eab5991a3$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $364a0b1eab5991a3$var$Me() {
    for(var a = window, b = $364a0b1eab5991a3$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $364a0b1eab5991a3$var$Xa(a.document);
    }
    return b;
}
function $364a0b1eab5991a3$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $364a0b1eab5991a3$var$Oe(a) {
    var b = $364a0b1eab5991a3$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $364a0b1eab5991a3$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $364a0b1eab5991a3$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $364a0b1eab5991a3$var$Ke(c, f);
                var g = $364a0b1eab5991a3$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $364a0b1eab5991a3$var$Pe = $364a0b1eab5991a3$var$ia && "documentMode" in document && 11 >= document.documentMode, $364a0b1eab5991a3$var$Qe = null, $364a0b1eab5991a3$var$Re = null, $364a0b1eab5991a3$var$Se = null, $364a0b1eab5991a3$var$Te = !1;
function $364a0b1eab5991a3$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $364a0b1eab5991a3$var$Te || null == $364a0b1eab5991a3$var$Qe || $364a0b1eab5991a3$var$Qe !== $364a0b1eab5991a3$var$Xa(d) || (d = $364a0b1eab5991a3$var$Qe, "selectionStart" in d && $364a0b1eab5991a3$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $364a0b1eab5991a3$var$Se && $364a0b1eab5991a3$var$Ie($364a0b1eab5991a3$var$Se, d) || ($364a0b1eab5991a3$var$Se = d, d = $364a0b1eab5991a3$var$oe($364a0b1eab5991a3$var$Re, "onSelect"), 0 < d.length && (b = new $364a0b1eab5991a3$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $364a0b1eab5991a3$var$Qe)));
}
function $364a0b1eab5991a3$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $364a0b1eab5991a3$var$We = {
    animationend: $364a0b1eab5991a3$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $364a0b1eab5991a3$var$Ve("Animation", "AnimationIteration"),
    animationstart: $364a0b1eab5991a3$var$Ve("Animation", "AnimationStart"),
    transitionend: $364a0b1eab5991a3$var$Ve("Transition", "TransitionEnd")
}, $364a0b1eab5991a3$var$Xe = {}, $364a0b1eab5991a3$var$Ye = {};
$364a0b1eab5991a3$var$ia && ($364a0b1eab5991a3$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $364a0b1eab5991a3$var$We.animationend.animation, delete $364a0b1eab5991a3$var$We.animationiteration.animation, delete $364a0b1eab5991a3$var$We.animationstart.animation), "TransitionEvent" in window || delete $364a0b1eab5991a3$var$We.transitionend.transition);
function $364a0b1eab5991a3$var$Ze(a) {
    if ($364a0b1eab5991a3$var$Xe[a]) return $364a0b1eab5991a3$var$Xe[a];
    if (!$364a0b1eab5991a3$var$We[a]) return a;
    var b = $364a0b1eab5991a3$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $364a0b1eab5991a3$var$Ye) return $364a0b1eab5991a3$var$Xe[a] = b[c];
    return a;
}
var $364a0b1eab5991a3$var$$e = $364a0b1eab5991a3$var$Ze("animationend"), $364a0b1eab5991a3$var$af = $364a0b1eab5991a3$var$Ze("animationiteration"), $364a0b1eab5991a3$var$bf = $364a0b1eab5991a3$var$Ze("animationstart"), $364a0b1eab5991a3$var$cf = $364a0b1eab5991a3$var$Ze("transitionend"), $364a0b1eab5991a3$var$df = new Map, $364a0b1eab5991a3$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $364a0b1eab5991a3$var$ff(a, b) {
    $364a0b1eab5991a3$var$df.set(a, b);
    $364a0b1eab5991a3$var$fa(b, [
        a
    ]);
}
for(var $364a0b1eab5991a3$var$gf = 0; $364a0b1eab5991a3$var$gf < $364a0b1eab5991a3$var$ef.length; $364a0b1eab5991a3$var$gf++){
    var $364a0b1eab5991a3$var$hf = $364a0b1eab5991a3$var$ef[$364a0b1eab5991a3$var$gf], $364a0b1eab5991a3$var$jf = $364a0b1eab5991a3$var$hf.toLowerCase(), $364a0b1eab5991a3$var$kf = $364a0b1eab5991a3$var$hf[0].toUpperCase() + $364a0b1eab5991a3$var$hf.slice(1);
    $364a0b1eab5991a3$var$ff($364a0b1eab5991a3$var$jf, "on" + $364a0b1eab5991a3$var$kf);
}
$364a0b1eab5991a3$var$ff($364a0b1eab5991a3$var$$e, "onAnimationEnd");
$364a0b1eab5991a3$var$ff($364a0b1eab5991a3$var$af, "onAnimationIteration");
$364a0b1eab5991a3$var$ff($364a0b1eab5991a3$var$bf, "onAnimationStart");
$364a0b1eab5991a3$var$ff("dblclick", "onDoubleClick");
$364a0b1eab5991a3$var$ff("focusin", "onFocus");
$364a0b1eab5991a3$var$ff("focusout", "onBlur");
$364a0b1eab5991a3$var$ff($364a0b1eab5991a3$var$cf, "onTransitionEnd");
$364a0b1eab5991a3$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$364a0b1eab5991a3$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$364a0b1eab5991a3$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$364a0b1eab5991a3$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$364a0b1eab5991a3$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$364a0b1eab5991a3$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$364a0b1eab5991a3$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$364a0b1eab5991a3$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$364a0b1eab5991a3$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$364a0b1eab5991a3$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $364a0b1eab5991a3$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $364a0b1eab5991a3$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($364a0b1eab5991a3$var$lf));
function $364a0b1eab5991a3$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $364a0b1eab5991a3$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $364a0b1eab5991a3$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $364a0b1eab5991a3$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $364a0b1eab5991a3$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($364a0b1eab5991a3$var$Qb) throw a = $364a0b1eab5991a3$var$Rb, $364a0b1eab5991a3$var$Qb = !1, $364a0b1eab5991a3$var$Rb = null, a;
}
function $364a0b1eab5991a3$var$D(a, b) {
    var c = b[$364a0b1eab5991a3$var$of];
    void 0 === c && (c = b[$364a0b1eab5991a3$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($364a0b1eab5991a3$var$pf(b, a, 2, !1), c.add(d));
}
function $364a0b1eab5991a3$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $364a0b1eab5991a3$var$pf(c, a, d, b);
}
var $364a0b1eab5991a3$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $364a0b1eab5991a3$var$sf(a) {
    if (!a[$364a0b1eab5991a3$var$rf]) {
        a[$364a0b1eab5991a3$var$rf] = !0;
        $364a0b1eab5991a3$var$da.forEach(function(b) {
            "selectionchange" !== b && ($364a0b1eab5991a3$var$mf.has(b) || $364a0b1eab5991a3$var$qf(b, !1, a), $364a0b1eab5991a3$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$364a0b1eab5991a3$var$rf] || (b[$364a0b1eab5991a3$var$rf] = !0, $364a0b1eab5991a3$var$qf("selectionchange", !1, b));
    }
}
function $364a0b1eab5991a3$var$pf(a, b, c, d) {
    switch($364a0b1eab5991a3$var$jd(b)){
        case 1:
            var e = $364a0b1eab5991a3$var$ed;
            break;
        case 4:
            e = $364a0b1eab5991a3$var$gd;
            break;
        default:
            e = $364a0b1eab5991a3$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$364a0b1eab5991a3$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $364a0b1eab5991a3$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $364a0b1eab5991a3$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $364a0b1eab5991a3$var$Jb(function() {
        var d = f, e = $364a0b1eab5991a3$var$xb(c), g = [];
        a: {
            var h = $364a0b1eab5991a3$var$df.get(a);
            if (void 0 !== h) {
                var k = $364a0b1eab5991a3$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $364a0b1eab5991a3$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $364a0b1eab5991a3$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $364a0b1eab5991a3$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $364a0b1eab5991a3$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $364a0b1eab5991a3$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $364a0b1eab5991a3$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $364a0b1eab5991a3$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $364a0b1eab5991a3$var$Vd;
                        break;
                    case $364a0b1eab5991a3$var$$e:
                    case $364a0b1eab5991a3$var$af:
                    case $364a0b1eab5991a3$var$bf:
                        k = $364a0b1eab5991a3$var$Hd;
                        break;
                    case $364a0b1eab5991a3$var$cf:
                        k = $364a0b1eab5991a3$var$Xd;
                        break;
                    case "scroll":
                        k = $364a0b1eab5991a3$var$vd;
                        break;
                    case "wheel":
                        k = $364a0b1eab5991a3$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $364a0b1eab5991a3$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $364a0b1eab5991a3$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $364a0b1eab5991a3$var$Kb(w, x), null != F && t.push($364a0b1eab5991a3$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $364a0b1eab5991a3$var$wb && (n = c.relatedTarget || c.fromElement) && ($364a0b1eab5991a3$var$Wc(n) || n[$364a0b1eab5991a3$var$uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? $364a0b1eab5991a3$var$Wc(n) : null, null !== n && (J = $364a0b1eab5991a3$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = $364a0b1eab5991a3$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $364a0b1eab5991a3$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $364a0b1eab5991a3$var$ue(k);
                        u = null == n ? h : $364a0b1eab5991a3$var$ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $364a0b1eab5991a3$var$Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $364a0b1eab5991a3$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $364a0b1eab5991a3$var$vf(F))u++;
                            for(; 0 < w - u;)t = $364a0b1eab5991a3$var$vf(t), w--;
                            for(; 0 < u - w;)x = $364a0b1eab5991a3$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $364a0b1eab5991a3$var$vf(t);
                                x = $364a0b1eab5991a3$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $364a0b1eab5991a3$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $364a0b1eab5991a3$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? $364a0b1eab5991a3$var$ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $364a0b1eab5991a3$var$ve;
                else if ($364a0b1eab5991a3$var$me(h)) {
                    if ($364a0b1eab5991a3$var$we) na = $364a0b1eab5991a3$var$Fe;
                    else {
                        na = $364a0b1eab5991a3$var$De;
                        var xa = $364a0b1eab5991a3$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $364a0b1eab5991a3$var$Ee);
                if (na && (na = na(a, d))) {
                    $364a0b1eab5991a3$var$ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $364a0b1eab5991a3$var$cb(h, "number", h.value);
            }
            xa = d ? $364a0b1eab5991a3$var$ue(d) : window;
            switch(a){
                case "focusin":
                    if ($364a0b1eab5991a3$var$me(xa) || "true" === xa.contentEditable) $364a0b1eab5991a3$var$Qe = xa, $364a0b1eab5991a3$var$Re = d, $364a0b1eab5991a3$var$Se = null;
                    break;
                case "focusout":
                    $364a0b1eab5991a3$var$Se = $364a0b1eab5991a3$var$Re = $364a0b1eab5991a3$var$Qe = null;
                    break;
                case "mousedown":
                    $364a0b1eab5991a3$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $364a0b1eab5991a3$var$Te = !1;
                    $364a0b1eab5991a3$var$Ue(g, c, e);
                    break;
                case "selectionchange":
                    if ($364a0b1eab5991a3$var$Pe) break;
                case "keydown":
                case "keyup":
                    $364a0b1eab5991a3$var$Ue(g, c, e);
            }
            var $a;
            if ($364a0b1eab5991a3$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $364a0b1eab5991a3$var$ie ? $364a0b1eab5991a3$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($364a0b1eab5991a3$var$de && "ko" !== c.locale && ($364a0b1eab5991a3$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $364a0b1eab5991a3$var$ie && ($a = $364a0b1eab5991a3$var$nd()) : ($364a0b1eab5991a3$var$kd = e, $364a0b1eab5991a3$var$ld = "value" in $364a0b1eab5991a3$var$kd ? $364a0b1eab5991a3$var$kd.value : $364a0b1eab5991a3$var$kd.textContent, $364a0b1eab5991a3$var$ie = !0)), xa = $364a0b1eab5991a3$var$oe(d, ba), 0 < xa.length && (ba = new $364a0b1eab5991a3$var$Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $364a0b1eab5991a3$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $364a0b1eab5991a3$var$ce ? $364a0b1eab5991a3$var$je(a, c) : $364a0b1eab5991a3$var$ke(a, c)) d = $364a0b1eab5991a3$var$oe(d, "onBeforeInput"), 0 < d.length && (e = new $364a0b1eab5991a3$var$Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        $364a0b1eab5991a3$var$se(g, b);
    });
}
function $364a0b1eab5991a3$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $364a0b1eab5991a3$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $364a0b1eab5991a3$var$Kb(a, c), null != f && d.unshift($364a0b1eab5991a3$var$tf(a, f, e)), f = $364a0b1eab5991a3$var$Kb(a, b), null != f && d.push($364a0b1eab5991a3$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $364a0b1eab5991a3$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $364a0b1eab5991a3$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $364a0b1eab5991a3$var$Kb(c, f), null != k && g.unshift($364a0b1eab5991a3$var$tf(c, k, h))) : e || (k = $364a0b1eab5991a3$var$Kb(c, f), null != k && g.push($364a0b1eab5991a3$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $364a0b1eab5991a3$var$xf = /\r\n?/g, $364a0b1eab5991a3$var$yf = /\u0000|\uFFFD/g;
function $364a0b1eab5991a3$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($364a0b1eab5991a3$var$xf, "\n").replace($364a0b1eab5991a3$var$yf, "");
}
function $364a0b1eab5991a3$var$Af(a, b, c) {
    b = $364a0b1eab5991a3$var$zf(b);
    if ($364a0b1eab5991a3$var$zf(a) !== b && c) throw Error($364a0b1eab5991a3$var$p(425));
}
function $364a0b1eab5991a3$var$Bf() {}
var $364a0b1eab5991a3$var$Cf = null, $364a0b1eab5991a3$var$Df = null;
function $364a0b1eab5991a3$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $364a0b1eab5991a3$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $364a0b1eab5991a3$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $364a0b1eab5991a3$var$Hf = "function" === typeof Promise ? Promise : void 0, $364a0b1eab5991a3$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $364a0b1eab5991a3$var$Hf ? function(a) {
    return $364a0b1eab5991a3$var$Hf.resolve(null).then(a).catch($364a0b1eab5991a3$var$If);
} : $364a0b1eab5991a3$var$Ff;
function $364a0b1eab5991a3$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $364a0b1eab5991a3$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $364a0b1eab5991a3$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $364a0b1eab5991a3$var$bd(b);
}
function $364a0b1eab5991a3$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $364a0b1eab5991a3$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $364a0b1eab5991a3$var$Nf = Math.random().toString(36).slice(2), $364a0b1eab5991a3$var$Of = "__reactFiber$" + $364a0b1eab5991a3$var$Nf, $364a0b1eab5991a3$var$Pf = "__reactProps$" + $364a0b1eab5991a3$var$Nf, $364a0b1eab5991a3$var$uf = "__reactContainer$" + $364a0b1eab5991a3$var$Nf, $364a0b1eab5991a3$var$of = "__reactEvents$" + $364a0b1eab5991a3$var$Nf, $364a0b1eab5991a3$var$Qf = "__reactListeners$" + $364a0b1eab5991a3$var$Nf, $364a0b1eab5991a3$var$Rf = "__reactHandles$" + $364a0b1eab5991a3$var$Nf;
function $364a0b1eab5991a3$var$Wc(a) {
    var b = a[$364a0b1eab5991a3$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$364a0b1eab5991a3$var$uf] || c[$364a0b1eab5991a3$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $364a0b1eab5991a3$var$Mf(a); null !== a;){
                if (c = a[$364a0b1eab5991a3$var$Of]) return c;
                a = $364a0b1eab5991a3$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $364a0b1eab5991a3$var$Cb(a) {
    a = a[$364a0b1eab5991a3$var$Of] || a[$364a0b1eab5991a3$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $364a0b1eab5991a3$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($364a0b1eab5991a3$var$p(33));
}
function $364a0b1eab5991a3$var$Db(a) {
    return a[$364a0b1eab5991a3$var$Pf] || null;
}
var $364a0b1eab5991a3$var$Sf = [], $364a0b1eab5991a3$var$Tf = -1;
function $364a0b1eab5991a3$var$Uf(a) {
    return {
        current: a
    };
}
function $364a0b1eab5991a3$var$E(a) {
    0 > $364a0b1eab5991a3$var$Tf || (a.current = $364a0b1eab5991a3$var$Sf[$364a0b1eab5991a3$var$Tf], $364a0b1eab5991a3$var$Sf[$364a0b1eab5991a3$var$Tf] = null, $364a0b1eab5991a3$var$Tf--);
}
function $364a0b1eab5991a3$var$G(a, b) {
    $364a0b1eab5991a3$var$Tf++;
    $364a0b1eab5991a3$var$Sf[$364a0b1eab5991a3$var$Tf] = a.current;
    a.current = b;
}
var $364a0b1eab5991a3$var$Vf = {}, $364a0b1eab5991a3$var$H = $364a0b1eab5991a3$var$Uf($364a0b1eab5991a3$var$Vf), $364a0b1eab5991a3$var$Wf = $364a0b1eab5991a3$var$Uf(!1), $364a0b1eab5991a3$var$Xf = $364a0b1eab5991a3$var$Vf;
function $364a0b1eab5991a3$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $364a0b1eab5991a3$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $364a0b1eab5991a3$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $364a0b1eab5991a3$var$$f() {
    $364a0b1eab5991a3$var$E($364a0b1eab5991a3$var$Wf);
    $364a0b1eab5991a3$var$E($364a0b1eab5991a3$var$H);
}
function $364a0b1eab5991a3$var$ag(a, b, c) {
    if ($364a0b1eab5991a3$var$H.current !== $364a0b1eab5991a3$var$Vf) throw Error($364a0b1eab5991a3$var$p(168));
    $364a0b1eab5991a3$var$G($364a0b1eab5991a3$var$H, b);
    $364a0b1eab5991a3$var$G($364a0b1eab5991a3$var$Wf, c);
}
function $364a0b1eab5991a3$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($364a0b1eab5991a3$var$p(108, $364a0b1eab5991a3$var$Ra(a) || "Unknown", e));
    return $364a0b1eab5991a3$var$A({}, c, d);
}
function $364a0b1eab5991a3$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $364a0b1eab5991a3$var$Vf;
    $364a0b1eab5991a3$var$Xf = $364a0b1eab5991a3$var$H.current;
    $364a0b1eab5991a3$var$G($364a0b1eab5991a3$var$H, a);
    $364a0b1eab5991a3$var$G($364a0b1eab5991a3$var$Wf, $364a0b1eab5991a3$var$Wf.current);
    return !0;
}
function $364a0b1eab5991a3$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($364a0b1eab5991a3$var$p(169));
    c ? (a = $364a0b1eab5991a3$var$bg(a, b, $364a0b1eab5991a3$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $364a0b1eab5991a3$var$E($364a0b1eab5991a3$var$Wf), $364a0b1eab5991a3$var$E($364a0b1eab5991a3$var$H), $364a0b1eab5991a3$var$G($364a0b1eab5991a3$var$H, a)) : $364a0b1eab5991a3$var$E($364a0b1eab5991a3$var$Wf);
    $364a0b1eab5991a3$var$G($364a0b1eab5991a3$var$Wf, c);
}
var $364a0b1eab5991a3$var$eg = null, $364a0b1eab5991a3$var$fg = !1, $364a0b1eab5991a3$var$gg = !1;
function $364a0b1eab5991a3$var$hg(a) {
    null === $364a0b1eab5991a3$var$eg ? $364a0b1eab5991a3$var$eg = [
        a
    ] : $364a0b1eab5991a3$var$eg.push(a);
}
function $364a0b1eab5991a3$var$ig(a) {
    $364a0b1eab5991a3$var$fg = !0;
    $364a0b1eab5991a3$var$hg(a);
}
function $364a0b1eab5991a3$var$jg() {
    if (!$364a0b1eab5991a3$var$gg && null !== $364a0b1eab5991a3$var$eg) {
        $364a0b1eab5991a3$var$gg = !0;
        var a = 0, b = $364a0b1eab5991a3$var$C;
        try {
            var c = $364a0b1eab5991a3$var$eg;
            for($364a0b1eab5991a3$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $364a0b1eab5991a3$var$eg = null;
            $364a0b1eab5991a3$var$fg = !1;
        } catch (e) {
            throw null !== $364a0b1eab5991a3$var$eg && ($364a0b1eab5991a3$var$eg = $364a0b1eab5991a3$var$eg.slice(a + 1)), $364a0b1eab5991a3$var$ac($364a0b1eab5991a3$var$fc, $364a0b1eab5991a3$var$jg), e;
        } finally{
            $364a0b1eab5991a3$var$C = b, $364a0b1eab5991a3$var$gg = !1;
        }
    }
    return null;
}
var $364a0b1eab5991a3$var$kg = [], $364a0b1eab5991a3$var$lg = 0, $364a0b1eab5991a3$var$mg = null, $364a0b1eab5991a3$var$ng = 0, $364a0b1eab5991a3$var$og = [], $364a0b1eab5991a3$var$pg = 0, $364a0b1eab5991a3$var$qg = null, $364a0b1eab5991a3$var$rg = 1, $364a0b1eab5991a3$var$sg = "";
function $364a0b1eab5991a3$var$tg(a, b) {
    $364a0b1eab5991a3$var$kg[$364a0b1eab5991a3$var$lg++] = $364a0b1eab5991a3$var$ng;
    $364a0b1eab5991a3$var$kg[$364a0b1eab5991a3$var$lg++] = $364a0b1eab5991a3$var$mg;
    $364a0b1eab5991a3$var$mg = a;
    $364a0b1eab5991a3$var$ng = b;
}
function $364a0b1eab5991a3$var$ug(a, b, c) {
    $364a0b1eab5991a3$var$og[$364a0b1eab5991a3$var$pg++] = $364a0b1eab5991a3$var$rg;
    $364a0b1eab5991a3$var$og[$364a0b1eab5991a3$var$pg++] = $364a0b1eab5991a3$var$sg;
    $364a0b1eab5991a3$var$og[$364a0b1eab5991a3$var$pg++] = $364a0b1eab5991a3$var$qg;
    $364a0b1eab5991a3$var$qg = a;
    var d = $364a0b1eab5991a3$var$rg;
    a = $364a0b1eab5991a3$var$sg;
    var e = 32 - $364a0b1eab5991a3$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $364a0b1eab5991a3$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $364a0b1eab5991a3$var$rg = 1 << 32 - $364a0b1eab5991a3$var$oc(b) + e | c << e | d;
        $364a0b1eab5991a3$var$sg = f + a;
    } else $364a0b1eab5991a3$var$rg = 1 << f | c << e | d, $364a0b1eab5991a3$var$sg = a;
}
function $364a0b1eab5991a3$var$vg(a) {
    null !== a.return && ($364a0b1eab5991a3$var$tg(a, 1), $364a0b1eab5991a3$var$ug(a, 1, 0));
}
function $364a0b1eab5991a3$var$wg(a) {
    for(; a === $364a0b1eab5991a3$var$mg;)$364a0b1eab5991a3$var$mg = $364a0b1eab5991a3$var$kg[--$364a0b1eab5991a3$var$lg], $364a0b1eab5991a3$var$kg[$364a0b1eab5991a3$var$lg] = null, $364a0b1eab5991a3$var$ng = $364a0b1eab5991a3$var$kg[--$364a0b1eab5991a3$var$lg], $364a0b1eab5991a3$var$kg[$364a0b1eab5991a3$var$lg] = null;
    for(; a === $364a0b1eab5991a3$var$qg;)$364a0b1eab5991a3$var$qg = $364a0b1eab5991a3$var$og[--$364a0b1eab5991a3$var$pg], $364a0b1eab5991a3$var$og[$364a0b1eab5991a3$var$pg] = null, $364a0b1eab5991a3$var$sg = $364a0b1eab5991a3$var$og[--$364a0b1eab5991a3$var$pg], $364a0b1eab5991a3$var$og[$364a0b1eab5991a3$var$pg] = null, $364a0b1eab5991a3$var$rg = $364a0b1eab5991a3$var$og[--$364a0b1eab5991a3$var$pg], $364a0b1eab5991a3$var$og[$364a0b1eab5991a3$var$pg] = null;
}
var $364a0b1eab5991a3$var$xg = null, $364a0b1eab5991a3$var$yg = null, $364a0b1eab5991a3$var$I = !1, $364a0b1eab5991a3$var$zg = null;
function $364a0b1eab5991a3$var$Ag(a, b) {
    var c = $364a0b1eab5991a3$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $364a0b1eab5991a3$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $364a0b1eab5991a3$var$xg = a, $364a0b1eab5991a3$var$yg = $364a0b1eab5991a3$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $364a0b1eab5991a3$var$xg = a, $364a0b1eab5991a3$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $364a0b1eab5991a3$var$qg ? {
                id: $364a0b1eab5991a3$var$rg,
                overflow: $364a0b1eab5991a3$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $364a0b1eab5991a3$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $364a0b1eab5991a3$var$xg = a, $364a0b1eab5991a3$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $364a0b1eab5991a3$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $364a0b1eab5991a3$var$Eg(a) {
    if ($364a0b1eab5991a3$var$I) {
        var b = $364a0b1eab5991a3$var$yg;
        if (b) {
            var c = b;
            if (!$364a0b1eab5991a3$var$Cg(a, b)) {
                if ($364a0b1eab5991a3$var$Dg(a)) throw Error($364a0b1eab5991a3$var$p(418));
                b = $364a0b1eab5991a3$var$Lf(c.nextSibling);
                var d = $364a0b1eab5991a3$var$xg;
                b && $364a0b1eab5991a3$var$Cg(a, b) ? $364a0b1eab5991a3$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $364a0b1eab5991a3$var$I = !1, $364a0b1eab5991a3$var$xg = a);
            }
        } else {
            if ($364a0b1eab5991a3$var$Dg(a)) throw Error($364a0b1eab5991a3$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $364a0b1eab5991a3$var$I = !1;
            $364a0b1eab5991a3$var$xg = a;
        }
    }
}
function $364a0b1eab5991a3$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $364a0b1eab5991a3$var$xg = a;
}
function $364a0b1eab5991a3$var$Gg(a) {
    if (a !== $364a0b1eab5991a3$var$xg) return !1;
    if (!$364a0b1eab5991a3$var$I) return $364a0b1eab5991a3$var$Fg(a), $364a0b1eab5991a3$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$364a0b1eab5991a3$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $364a0b1eab5991a3$var$yg)) {
        if ($364a0b1eab5991a3$var$Dg(a)) throw $364a0b1eab5991a3$var$Hg(), Error($364a0b1eab5991a3$var$p(418));
        for(; b;)$364a0b1eab5991a3$var$Ag(a, b), b = $364a0b1eab5991a3$var$Lf(b.nextSibling);
    }
    $364a0b1eab5991a3$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($364a0b1eab5991a3$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $364a0b1eab5991a3$var$yg = $364a0b1eab5991a3$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $364a0b1eab5991a3$var$yg = null;
        }
    } else $364a0b1eab5991a3$var$yg = $364a0b1eab5991a3$var$xg ? $364a0b1eab5991a3$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $364a0b1eab5991a3$var$Hg() {
    for(var a = $364a0b1eab5991a3$var$yg; a;)a = $364a0b1eab5991a3$var$Lf(a.nextSibling);
}
function $364a0b1eab5991a3$var$Ig() {
    $364a0b1eab5991a3$var$yg = $364a0b1eab5991a3$var$xg = null;
    $364a0b1eab5991a3$var$I = !1;
}
function $364a0b1eab5991a3$var$Jg(a) {
    null === $364a0b1eab5991a3$var$zg ? $364a0b1eab5991a3$var$zg = [
        a
    ] : $364a0b1eab5991a3$var$zg.push(a);
}
var $364a0b1eab5991a3$var$Kg = $364a0b1eab5991a3$var$ua.ReactCurrentBatchConfig;
function $364a0b1eab5991a3$var$Lg(a, b) {
    if (a && a.defaultProps) {
        b = $364a0b1eab5991a3$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
var $364a0b1eab5991a3$var$Mg = $364a0b1eab5991a3$var$Uf(null), $364a0b1eab5991a3$var$Ng = null, $364a0b1eab5991a3$var$Og = null, $364a0b1eab5991a3$var$Pg = null;
function $364a0b1eab5991a3$var$Qg() {
    $364a0b1eab5991a3$var$Pg = $364a0b1eab5991a3$var$Og = $364a0b1eab5991a3$var$Ng = null;
}
function $364a0b1eab5991a3$var$Rg(a) {
    var b = $364a0b1eab5991a3$var$Mg.current;
    $364a0b1eab5991a3$var$E($364a0b1eab5991a3$var$Mg);
    a._currentValue = b;
}
function $364a0b1eab5991a3$var$Sg(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $364a0b1eab5991a3$var$Tg(a, b) {
    $364a0b1eab5991a3$var$Ng = a;
    $364a0b1eab5991a3$var$Pg = $364a0b1eab5991a3$var$Og = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($364a0b1eab5991a3$var$Ug = !0), a.firstContext = null);
}
function $364a0b1eab5991a3$var$Vg(a) {
    var b = a._currentValue;
    if ($364a0b1eab5991a3$var$Pg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $364a0b1eab5991a3$var$Og) {
            if (null === $364a0b1eab5991a3$var$Ng) throw Error($364a0b1eab5991a3$var$p(308));
            $364a0b1eab5991a3$var$Og = a;
            $364a0b1eab5991a3$var$Ng.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $364a0b1eab5991a3$var$Og = $364a0b1eab5991a3$var$Og.next = a;
    }
    return b;
}
var $364a0b1eab5991a3$var$Wg = null;
function $364a0b1eab5991a3$var$Xg(a) {
    null === $364a0b1eab5991a3$var$Wg ? $364a0b1eab5991a3$var$Wg = [
        a
    ] : $364a0b1eab5991a3$var$Wg.push(a);
}
function $364a0b1eab5991a3$var$Yg(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $364a0b1eab5991a3$var$Xg(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $364a0b1eab5991a3$var$Zg(a, d);
}
function $364a0b1eab5991a3$var$Zg(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $364a0b1eab5991a3$var$$g = !1;
function $364a0b1eab5991a3$var$ah(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $364a0b1eab5991a3$var$bh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $364a0b1eab5991a3$var$ch(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $364a0b1eab5991a3$var$dh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($364a0b1eab5991a3$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $364a0b1eab5991a3$var$Zg(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $364a0b1eab5991a3$var$Xg(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $364a0b1eab5991a3$var$Zg(a, c);
}
function $364a0b1eab5991a3$var$eh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $364a0b1eab5991a3$var$Cc(a, c);
    }
}
function $364a0b1eab5991a3$var$fh(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $364a0b1eab5991a3$var$gh(a, b, c, d) {
    var e = a.updateQueue;
    $364a0b1eab5991a3$var$$g = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $364a0b1eab5991a3$var$A({}, q, r);
                            break a;
                        case 2:
                            $364a0b1eab5991a3$var$$g = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $364a0b1eab5991a3$var$hh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $364a0b1eab5991a3$var$ih(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($364a0b1eab5991a3$var$p(191, e));
            e.call(d);
        }
    }
}
var $364a0b1eab5991a3$var$jh = (new $eO7Kz.Component).refs;
function $364a0b1eab5991a3$var$kh(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $364a0b1eab5991a3$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $364a0b1eab5991a3$var$nh = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $364a0b1eab5991a3$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $364a0b1eab5991a3$var$L(), e = $364a0b1eab5991a3$var$lh(a), f = $364a0b1eab5991a3$var$ch(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $364a0b1eab5991a3$var$dh(a, f, e);
        null !== b && ($364a0b1eab5991a3$var$mh(b, a, e, d), $364a0b1eab5991a3$var$eh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $364a0b1eab5991a3$var$L(), e = $364a0b1eab5991a3$var$lh(a), f = $364a0b1eab5991a3$var$ch(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $364a0b1eab5991a3$var$dh(a, f, e);
        null !== b && ($364a0b1eab5991a3$var$mh(b, a, e, d), $364a0b1eab5991a3$var$eh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $364a0b1eab5991a3$var$L(), d = $364a0b1eab5991a3$var$lh(a), e = $364a0b1eab5991a3$var$ch(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $364a0b1eab5991a3$var$dh(a, e, d);
        null !== b && ($364a0b1eab5991a3$var$mh(b, a, d, c), $364a0b1eab5991a3$var$eh(b, a, d));
    }
};
function $364a0b1eab5991a3$var$oh(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$364a0b1eab5991a3$var$Ie(c, d) || !$364a0b1eab5991a3$var$Ie(e, f) : !0;
}
function $364a0b1eab5991a3$var$ph(a, b, c) {
    var d = !1, e = $364a0b1eab5991a3$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $364a0b1eab5991a3$var$Vg(f) : (e = $364a0b1eab5991a3$var$Zf(b) ? $364a0b1eab5991a3$var$Xf : $364a0b1eab5991a3$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $364a0b1eab5991a3$var$Yf(a, e) : $364a0b1eab5991a3$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $364a0b1eab5991a3$var$nh;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $364a0b1eab5991a3$var$qh(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $364a0b1eab5991a3$var$nh.enqueueReplaceState(b, b.state, null);
}
function $364a0b1eab5991a3$var$rh(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = $364a0b1eab5991a3$var$jh;
    $364a0b1eab5991a3$var$ah(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $364a0b1eab5991a3$var$Vg(f) : (f = $364a0b1eab5991a3$var$Zf(b) ? $364a0b1eab5991a3$var$Xf : $364a0b1eab5991a3$var$H.current, e.context = $364a0b1eab5991a3$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($364a0b1eab5991a3$var$kh(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $364a0b1eab5991a3$var$nh.enqueueReplaceState(e, e.state, null), $364a0b1eab5991a3$var$gh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $364a0b1eab5991a3$var$sh(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($364a0b1eab5991a3$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($364a0b1eab5991a3$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                b === $364a0b1eab5991a3$var$jh && (b = e.refs = {});
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($364a0b1eab5991a3$var$p(284));
        if (!c._owner) throw Error($364a0b1eab5991a3$var$p(290, a));
    }
    return a;
}
function $364a0b1eab5991a3$var$th(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($364a0b1eab5991a3$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $364a0b1eab5991a3$var$uh(a) {
    var b = a._init;
    return b(a._payload);
}
function $364a0b1eab5991a3$var$vh(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $364a0b1eab5991a3$var$wh(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $364a0b1eab5991a3$var$xh(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $364a0b1eab5991a3$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $364a0b1eab5991a3$var$Ha && $364a0b1eab5991a3$var$uh(f) === b.type)) return d = e(b, c.props), d.ref = $364a0b1eab5991a3$var$sh(a, b, c), d.return = a, d;
        d = $364a0b1eab5991a3$var$yh(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $364a0b1eab5991a3$var$sh(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $364a0b1eab5991a3$var$zh(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $364a0b1eab5991a3$var$Ah(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $364a0b1eab5991a3$var$xh("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $364a0b1eab5991a3$var$va:
                    return c = $364a0b1eab5991a3$var$yh(b.type, b.key, b.props, null, a.mode, c), c.ref = $364a0b1eab5991a3$var$sh(a, null, b), c.return = a, c;
                case $364a0b1eab5991a3$var$wa:
                    return b = $364a0b1eab5991a3$var$zh(b, a.mode, c), b.return = a, b;
                case $364a0b1eab5991a3$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($364a0b1eab5991a3$var$eb(b) || $364a0b1eab5991a3$var$Ka(b)) return b = $364a0b1eab5991a3$var$Ah(b, a.mode, c, null), b.return = a, b;
            $364a0b1eab5991a3$var$th(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $364a0b1eab5991a3$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $364a0b1eab5991a3$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $364a0b1eab5991a3$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($364a0b1eab5991a3$var$eb(c) || $364a0b1eab5991a3$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $364a0b1eab5991a3$var$th(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $364a0b1eab5991a3$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $364a0b1eab5991a3$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $364a0b1eab5991a3$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($364a0b1eab5991a3$var$eb(d) || $364a0b1eab5991a3$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $364a0b1eab5991a3$var$th(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $364a0b1eab5991a3$var$I && $364a0b1eab5991a3$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $364a0b1eab5991a3$var$I && $364a0b1eab5991a3$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $364a0b1eab5991a3$var$I && $364a0b1eab5991a3$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $364a0b1eab5991a3$var$Ka(h);
        if ("function" !== typeof l) throw Error($364a0b1eab5991a3$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($364a0b1eab5991a3$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $364a0b1eab5991a3$var$I && $364a0b1eab5991a3$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $364a0b1eab5991a3$var$I && $364a0b1eab5991a3$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $364a0b1eab5991a3$var$I && $364a0b1eab5991a3$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $364a0b1eab5991a3$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $364a0b1eab5991a3$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $364a0b1eab5991a3$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $364a0b1eab5991a3$var$Ha && $364a0b1eab5991a3$var$uh(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $364a0b1eab5991a3$var$sh(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $364a0b1eab5991a3$var$ya ? (d = $364a0b1eab5991a3$var$Ah(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $364a0b1eab5991a3$var$yh(f.type, f.key, f.props, null, a.mode, h), h.ref = $364a0b1eab5991a3$var$sh(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $364a0b1eab5991a3$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $364a0b1eab5991a3$var$zh(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $364a0b1eab5991a3$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($364a0b1eab5991a3$var$eb(f)) return n(a, d, f, h);
            if ($364a0b1eab5991a3$var$Ka(f)) return t(a, d, f, h);
            $364a0b1eab5991a3$var$th(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $364a0b1eab5991a3$var$xh(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $364a0b1eab5991a3$var$Bh = $364a0b1eab5991a3$var$vh(!0), $364a0b1eab5991a3$var$Ch = $364a0b1eab5991a3$var$vh(!1), $364a0b1eab5991a3$var$Dh = {}, $364a0b1eab5991a3$var$Eh = $364a0b1eab5991a3$var$Uf($364a0b1eab5991a3$var$Dh), $364a0b1eab5991a3$var$Fh = $364a0b1eab5991a3$var$Uf($364a0b1eab5991a3$var$Dh), $364a0b1eab5991a3$var$Gh = $364a0b1eab5991a3$var$Uf($364a0b1eab5991a3$var$Dh);
function $364a0b1eab5991a3$var$Hh(a) {
    if (a === $364a0b1eab5991a3$var$Dh) throw Error($364a0b1eab5991a3$var$p(174));
    return a;
}
function $364a0b1eab5991a3$var$Ih(a, b) {
    $364a0b1eab5991a3$var$G($364a0b1eab5991a3$var$Gh, b);
    $364a0b1eab5991a3$var$G($364a0b1eab5991a3$var$Fh, a);
    $364a0b1eab5991a3$var$G($364a0b1eab5991a3$var$Eh, $364a0b1eab5991a3$var$Dh);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $364a0b1eab5991a3$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $364a0b1eab5991a3$var$lb(b, a);
    }
    $364a0b1eab5991a3$var$E($364a0b1eab5991a3$var$Eh);
    $364a0b1eab5991a3$var$G($364a0b1eab5991a3$var$Eh, b);
}
function $364a0b1eab5991a3$var$Jh() {
    $364a0b1eab5991a3$var$E($364a0b1eab5991a3$var$Eh);
    $364a0b1eab5991a3$var$E($364a0b1eab5991a3$var$Fh);
    $364a0b1eab5991a3$var$E($364a0b1eab5991a3$var$Gh);
}
function $364a0b1eab5991a3$var$Kh(a) {
    $364a0b1eab5991a3$var$Hh($364a0b1eab5991a3$var$Gh.current);
    var b = $364a0b1eab5991a3$var$Hh($364a0b1eab5991a3$var$Eh.current);
    var c = $364a0b1eab5991a3$var$lb(b, a.type);
    b !== c && ($364a0b1eab5991a3$var$G($364a0b1eab5991a3$var$Fh, a), $364a0b1eab5991a3$var$G($364a0b1eab5991a3$var$Eh, c));
}
function $364a0b1eab5991a3$var$Lh(a) {
    $364a0b1eab5991a3$var$Fh.current === a && ($364a0b1eab5991a3$var$E($364a0b1eab5991a3$var$Eh), $364a0b1eab5991a3$var$E($364a0b1eab5991a3$var$Fh));
}
var $364a0b1eab5991a3$var$M = $364a0b1eab5991a3$var$Uf(0);
function $364a0b1eab5991a3$var$Mh(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $364a0b1eab5991a3$var$Nh = [];
function $364a0b1eab5991a3$var$Oh() {
    for(var a = 0; a < $364a0b1eab5991a3$var$Nh.length; a++)$364a0b1eab5991a3$var$Nh[a]._workInProgressVersionPrimary = null;
    $364a0b1eab5991a3$var$Nh.length = 0;
}
var $364a0b1eab5991a3$var$Ph = $364a0b1eab5991a3$var$ua.ReactCurrentDispatcher, $364a0b1eab5991a3$var$Qh = $364a0b1eab5991a3$var$ua.ReactCurrentBatchConfig, $364a0b1eab5991a3$var$Rh = 0, $364a0b1eab5991a3$var$N = null, $364a0b1eab5991a3$var$O = null, $364a0b1eab5991a3$var$P = null, $364a0b1eab5991a3$var$Sh = !1, $364a0b1eab5991a3$var$Th = !1, $364a0b1eab5991a3$var$Uh = 0, $364a0b1eab5991a3$var$Vh = 0;
function $364a0b1eab5991a3$var$Q() {
    throw Error($364a0b1eab5991a3$var$p(321));
}
function $364a0b1eab5991a3$var$Wh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$364a0b1eab5991a3$var$He(a[c], b[c])) return !1;
    return !0;
}
function $364a0b1eab5991a3$var$Xh(a, b, c, d, e, f) {
    $364a0b1eab5991a3$var$Rh = f;
    $364a0b1eab5991a3$var$N = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $364a0b1eab5991a3$var$Ph.current = null === a || null === a.memoizedState ? $364a0b1eab5991a3$var$Yh : $364a0b1eab5991a3$var$Zh;
    a = c(d, e);
    if ($364a0b1eab5991a3$var$Th) {
        f = 0;
        do {
            $364a0b1eab5991a3$var$Th = !1;
            $364a0b1eab5991a3$var$Uh = 0;
            if (25 <= f) throw Error($364a0b1eab5991a3$var$p(301));
            f += 1;
            $364a0b1eab5991a3$var$P = $364a0b1eab5991a3$var$O = null;
            b.updateQueue = null;
            $364a0b1eab5991a3$var$Ph.current = $364a0b1eab5991a3$var$$h;
            a = c(d, e);
        }while ($364a0b1eab5991a3$var$Th);
    }
    $364a0b1eab5991a3$var$Ph.current = $364a0b1eab5991a3$var$ai;
    b = null !== $364a0b1eab5991a3$var$O && null !== $364a0b1eab5991a3$var$O.next;
    $364a0b1eab5991a3$var$Rh = 0;
    $364a0b1eab5991a3$var$P = $364a0b1eab5991a3$var$O = $364a0b1eab5991a3$var$N = null;
    $364a0b1eab5991a3$var$Sh = !1;
    if (b) throw Error($364a0b1eab5991a3$var$p(300));
    return a;
}
function $364a0b1eab5991a3$var$bi() {
    var a = 0 !== $364a0b1eab5991a3$var$Uh;
    $364a0b1eab5991a3$var$Uh = 0;
    return a;
}
function $364a0b1eab5991a3$var$ci() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $364a0b1eab5991a3$var$P ? $364a0b1eab5991a3$var$N.memoizedState = $364a0b1eab5991a3$var$P = a : $364a0b1eab5991a3$var$P = $364a0b1eab5991a3$var$P.next = a;
    return $364a0b1eab5991a3$var$P;
}
function $364a0b1eab5991a3$var$di() {
    if (null === $364a0b1eab5991a3$var$O) {
        var a = $364a0b1eab5991a3$var$N.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $364a0b1eab5991a3$var$O.next;
    var b = null === $364a0b1eab5991a3$var$P ? $364a0b1eab5991a3$var$N.memoizedState : $364a0b1eab5991a3$var$P.next;
    if (null !== b) $364a0b1eab5991a3$var$P = b, $364a0b1eab5991a3$var$O = a;
    else {
        if (null === a) throw Error($364a0b1eab5991a3$var$p(310));
        $364a0b1eab5991a3$var$O = a;
        a = {
            memoizedState: $364a0b1eab5991a3$var$O.memoizedState,
            baseState: $364a0b1eab5991a3$var$O.baseState,
            baseQueue: $364a0b1eab5991a3$var$O.baseQueue,
            queue: $364a0b1eab5991a3$var$O.queue,
            next: null
        };
        null === $364a0b1eab5991a3$var$P ? $364a0b1eab5991a3$var$N.memoizedState = $364a0b1eab5991a3$var$P = a : $364a0b1eab5991a3$var$P = $364a0b1eab5991a3$var$P.next = a;
    }
    return $364a0b1eab5991a3$var$P;
}
function $364a0b1eab5991a3$var$ei(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $364a0b1eab5991a3$var$fi(a) {
    var b = $364a0b1eab5991a3$var$di(), c = b.queue;
    if (null === c) throw Error($364a0b1eab5991a3$var$p(311));
    c.lastRenderedReducer = a;
    var d = $364a0b1eab5991a3$var$O, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($364a0b1eab5991a3$var$Rh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $364a0b1eab5991a3$var$N.lanes |= m;
                $364a0b1eab5991a3$var$hh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $364a0b1eab5991a3$var$He(d, b.memoizedState) || ($364a0b1eab5991a3$var$Ug = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $364a0b1eab5991a3$var$N.lanes |= f, $364a0b1eab5991a3$var$hh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $364a0b1eab5991a3$var$gi(a) {
    var b = $364a0b1eab5991a3$var$di(), c = b.queue;
    if (null === c) throw Error($364a0b1eab5991a3$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $364a0b1eab5991a3$var$He(f, b.memoizedState) || ($364a0b1eab5991a3$var$Ug = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $364a0b1eab5991a3$var$hi() {}
function $364a0b1eab5991a3$var$ii(a, b) {
    var c = $364a0b1eab5991a3$var$N, d = $364a0b1eab5991a3$var$di(), e = b(), f = !$364a0b1eab5991a3$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $364a0b1eab5991a3$var$Ug = !0);
    d = d.queue;
    $364a0b1eab5991a3$var$ji($364a0b1eab5991a3$var$ki.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $364a0b1eab5991a3$var$P && $364a0b1eab5991a3$var$P.memoizedState.tag & 1) {
        c.flags |= 2048;
        $364a0b1eab5991a3$var$li(9, $364a0b1eab5991a3$var$mi.bind(null, c, d, e, b), void 0, null);
        if (null === $364a0b1eab5991a3$var$R) throw Error($364a0b1eab5991a3$var$p(349));
        0 !== ($364a0b1eab5991a3$var$Rh & 30) || $364a0b1eab5991a3$var$ni(c, b, e);
    }
    return e;
}
function $364a0b1eab5991a3$var$ni(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $364a0b1eab5991a3$var$N.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $364a0b1eab5991a3$var$N.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $364a0b1eab5991a3$var$mi(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $364a0b1eab5991a3$var$oi(b) && $364a0b1eab5991a3$var$pi(a);
}
function $364a0b1eab5991a3$var$ki(a, b, c) {
    return c(function() {
        $364a0b1eab5991a3$var$oi(b) && $364a0b1eab5991a3$var$pi(a);
    });
}
function $364a0b1eab5991a3$var$oi(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$364a0b1eab5991a3$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $364a0b1eab5991a3$var$pi(a) {
    var b = $364a0b1eab5991a3$var$Zg(a, 1);
    null !== b && $364a0b1eab5991a3$var$mh(b, a, 1, -1);
}
function $364a0b1eab5991a3$var$qi(a) {
    var b = $364a0b1eab5991a3$var$ci();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $364a0b1eab5991a3$var$ei,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $364a0b1eab5991a3$var$ri.bind(null, $364a0b1eab5991a3$var$N, a);
    return [
        b.memoizedState,
        a
    ];
}
function $364a0b1eab5991a3$var$li(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $364a0b1eab5991a3$var$N.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $364a0b1eab5991a3$var$N.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $364a0b1eab5991a3$var$si() {
    return $364a0b1eab5991a3$var$di().memoizedState;
}
function $364a0b1eab5991a3$var$ti(a, b, c, d) {
    var e = $364a0b1eab5991a3$var$ci();
    $364a0b1eab5991a3$var$N.flags |= a;
    e.memoizedState = $364a0b1eab5991a3$var$li(1 | b, c, void 0, void 0 === d ? null : d);
}
function $364a0b1eab5991a3$var$ui(a, b, c, d) {
    var e = $364a0b1eab5991a3$var$di();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $364a0b1eab5991a3$var$O) {
        var g = $364a0b1eab5991a3$var$O.memoizedState;
        f = g.destroy;
        if (null !== d && $364a0b1eab5991a3$var$Wh(d, g.deps)) {
            e.memoizedState = $364a0b1eab5991a3$var$li(b, c, f, d);
            return;
        }
    }
    $364a0b1eab5991a3$var$N.flags |= a;
    e.memoizedState = $364a0b1eab5991a3$var$li(1 | b, c, f, d);
}
function $364a0b1eab5991a3$var$vi(a, b) {
    return $364a0b1eab5991a3$var$ti(8390656, 8, a, b);
}
function $364a0b1eab5991a3$var$ji(a, b) {
    return $364a0b1eab5991a3$var$ui(2048, 8, a, b);
}
function $364a0b1eab5991a3$var$wi(a, b) {
    return $364a0b1eab5991a3$var$ui(4, 2, a, b);
}
function $364a0b1eab5991a3$var$xi(a, b) {
    return $364a0b1eab5991a3$var$ui(4, 4, a, b);
}
function $364a0b1eab5991a3$var$yi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $364a0b1eab5991a3$var$zi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $364a0b1eab5991a3$var$ui(4, 4, $364a0b1eab5991a3$var$yi.bind(null, b, a), c);
}
function $364a0b1eab5991a3$var$Ai() {}
function $364a0b1eab5991a3$var$Bi(a, b) {
    var c = $364a0b1eab5991a3$var$di();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $364a0b1eab5991a3$var$Wh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $364a0b1eab5991a3$var$Ci(a, b) {
    var c = $364a0b1eab5991a3$var$di();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $364a0b1eab5991a3$var$Wh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $364a0b1eab5991a3$var$Di(a, b, c) {
    if (0 === ($364a0b1eab5991a3$var$Rh & 21)) return a.baseState && (a.baseState = !1, $364a0b1eab5991a3$var$Ug = !0), a.memoizedState = c;
    $364a0b1eab5991a3$var$He(c, b) || (c = $364a0b1eab5991a3$var$yc(), $364a0b1eab5991a3$var$N.lanes |= c, $364a0b1eab5991a3$var$hh |= c, a.baseState = !0);
    return b;
}
function $364a0b1eab5991a3$var$Ei(a, b) {
    var c = $364a0b1eab5991a3$var$C;
    $364a0b1eab5991a3$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $364a0b1eab5991a3$var$Qh.transition;
    $364a0b1eab5991a3$var$Qh.transition = {};
    try {
        a(!1), b();
    } finally{
        $364a0b1eab5991a3$var$C = c, $364a0b1eab5991a3$var$Qh.transition = d;
    }
}
function $364a0b1eab5991a3$var$Fi() {
    return $364a0b1eab5991a3$var$di().memoizedState;
}
function $364a0b1eab5991a3$var$Gi(a, b, c) {
    var d = $364a0b1eab5991a3$var$lh(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($364a0b1eab5991a3$var$Hi(a)) $364a0b1eab5991a3$var$Ii(b, c);
    else if (c = $364a0b1eab5991a3$var$Yg(a, b, c, d), null !== c) {
        var e = $364a0b1eab5991a3$var$L();
        $364a0b1eab5991a3$var$mh(c, a, d, e);
        $364a0b1eab5991a3$var$Ji(c, b, d);
    }
}
function $364a0b1eab5991a3$var$ri(a, b, c) {
    var d = $364a0b1eab5991a3$var$lh(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($364a0b1eab5991a3$var$Hi(a)) $364a0b1eab5991a3$var$Ii(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($364a0b1eab5991a3$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $364a0b1eab5991a3$var$Xg(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $364a0b1eab5991a3$var$Yg(a, b, e, d);
        null !== c && (e = $364a0b1eab5991a3$var$L(), $364a0b1eab5991a3$var$mh(c, a, d, e), $364a0b1eab5991a3$var$Ji(c, b, d));
    }
}
function $364a0b1eab5991a3$var$Hi(a) {
    var b = a.alternate;
    return a === $364a0b1eab5991a3$var$N || null !== b && b === $364a0b1eab5991a3$var$N;
}
function $364a0b1eab5991a3$var$Ii(a, b) {
    $364a0b1eab5991a3$var$Th = $364a0b1eab5991a3$var$Sh = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $364a0b1eab5991a3$var$Ji(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $364a0b1eab5991a3$var$Cc(a, c);
    }
}
var $364a0b1eab5991a3$var$ai = {
    readContext: $364a0b1eab5991a3$var$Vg,
    useCallback: $364a0b1eab5991a3$var$Q,
    useContext: $364a0b1eab5991a3$var$Q,
    useEffect: $364a0b1eab5991a3$var$Q,
    useImperativeHandle: $364a0b1eab5991a3$var$Q,
    useInsertionEffect: $364a0b1eab5991a3$var$Q,
    useLayoutEffect: $364a0b1eab5991a3$var$Q,
    useMemo: $364a0b1eab5991a3$var$Q,
    useReducer: $364a0b1eab5991a3$var$Q,
    useRef: $364a0b1eab5991a3$var$Q,
    useState: $364a0b1eab5991a3$var$Q,
    useDebugValue: $364a0b1eab5991a3$var$Q,
    useDeferredValue: $364a0b1eab5991a3$var$Q,
    useTransition: $364a0b1eab5991a3$var$Q,
    useMutableSource: $364a0b1eab5991a3$var$Q,
    useSyncExternalStore: $364a0b1eab5991a3$var$Q,
    useId: $364a0b1eab5991a3$var$Q,
    unstable_isNewReconciler: !1
}, $364a0b1eab5991a3$var$Yh = {
    readContext: $364a0b1eab5991a3$var$Vg,
    useCallback: function(a, b) {
        $364a0b1eab5991a3$var$ci().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $364a0b1eab5991a3$var$Vg,
    useEffect: $364a0b1eab5991a3$var$vi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $364a0b1eab5991a3$var$ti(4194308, 4, $364a0b1eab5991a3$var$yi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $364a0b1eab5991a3$var$ti(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $364a0b1eab5991a3$var$ti(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $364a0b1eab5991a3$var$ci();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $364a0b1eab5991a3$var$ci();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $364a0b1eab5991a3$var$Gi.bind(null, $364a0b1eab5991a3$var$N, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $364a0b1eab5991a3$var$ci();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $364a0b1eab5991a3$var$qi,
    useDebugValue: $364a0b1eab5991a3$var$Ai,
    useDeferredValue: function(a) {
        return $364a0b1eab5991a3$var$ci().memoizedState = a;
    },
    useTransition: function() {
        var a = $364a0b1eab5991a3$var$qi(!1), b = a[0];
        a = $364a0b1eab5991a3$var$Ei.bind(null, a[1]);
        $364a0b1eab5991a3$var$ci().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $364a0b1eab5991a3$var$N, e = $364a0b1eab5991a3$var$ci();
        if ($364a0b1eab5991a3$var$I) {
            if (void 0 === c) throw Error($364a0b1eab5991a3$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $364a0b1eab5991a3$var$R) throw Error($364a0b1eab5991a3$var$p(349));
            0 !== ($364a0b1eab5991a3$var$Rh & 30) || $364a0b1eab5991a3$var$ni(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $364a0b1eab5991a3$var$vi($364a0b1eab5991a3$var$ki.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $364a0b1eab5991a3$var$li(9, $364a0b1eab5991a3$var$mi.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $364a0b1eab5991a3$var$ci(), b = $364a0b1eab5991a3$var$R.identifierPrefix;
        if ($364a0b1eab5991a3$var$I) {
            var c = $364a0b1eab5991a3$var$sg;
            var d = $364a0b1eab5991a3$var$rg;
            c = (d & ~(1 << 32 - $364a0b1eab5991a3$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $364a0b1eab5991a3$var$Uh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $364a0b1eab5991a3$var$Vh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $364a0b1eab5991a3$var$Zh = {
    readContext: $364a0b1eab5991a3$var$Vg,
    useCallback: $364a0b1eab5991a3$var$Bi,
    useContext: $364a0b1eab5991a3$var$Vg,
    useEffect: $364a0b1eab5991a3$var$ji,
    useImperativeHandle: $364a0b1eab5991a3$var$zi,
    useInsertionEffect: $364a0b1eab5991a3$var$wi,
    useLayoutEffect: $364a0b1eab5991a3$var$xi,
    useMemo: $364a0b1eab5991a3$var$Ci,
    useReducer: $364a0b1eab5991a3$var$fi,
    useRef: $364a0b1eab5991a3$var$si,
    useState: function() {
        return $364a0b1eab5991a3$var$fi($364a0b1eab5991a3$var$ei);
    },
    useDebugValue: $364a0b1eab5991a3$var$Ai,
    useDeferredValue: function(a) {
        var b = $364a0b1eab5991a3$var$di();
        return $364a0b1eab5991a3$var$Di(b, $364a0b1eab5991a3$var$O.memoizedState, a);
    },
    useTransition: function() {
        var a = $364a0b1eab5991a3$var$fi($364a0b1eab5991a3$var$ei)[0], b = $364a0b1eab5991a3$var$di().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $364a0b1eab5991a3$var$hi,
    useSyncExternalStore: $364a0b1eab5991a3$var$ii,
    useId: $364a0b1eab5991a3$var$Fi,
    unstable_isNewReconciler: !1
}, $364a0b1eab5991a3$var$$h = {
    readContext: $364a0b1eab5991a3$var$Vg,
    useCallback: $364a0b1eab5991a3$var$Bi,
    useContext: $364a0b1eab5991a3$var$Vg,
    useEffect: $364a0b1eab5991a3$var$ji,
    useImperativeHandle: $364a0b1eab5991a3$var$zi,
    useInsertionEffect: $364a0b1eab5991a3$var$wi,
    useLayoutEffect: $364a0b1eab5991a3$var$xi,
    useMemo: $364a0b1eab5991a3$var$Ci,
    useReducer: $364a0b1eab5991a3$var$gi,
    useRef: $364a0b1eab5991a3$var$si,
    useState: function() {
        return $364a0b1eab5991a3$var$gi($364a0b1eab5991a3$var$ei);
    },
    useDebugValue: $364a0b1eab5991a3$var$Ai,
    useDeferredValue: function(a) {
        var b = $364a0b1eab5991a3$var$di();
        return null === $364a0b1eab5991a3$var$O ? b.memoizedState = a : $364a0b1eab5991a3$var$Di(b, $364a0b1eab5991a3$var$O.memoizedState, a);
    },
    useTransition: function() {
        var a = $364a0b1eab5991a3$var$gi($364a0b1eab5991a3$var$ei)[0], b = $364a0b1eab5991a3$var$di().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $364a0b1eab5991a3$var$hi,
    useSyncExternalStore: $364a0b1eab5991a3$var$ii,
    useId: $364a0b1eab5991a3$var$Fi,
    unstable_isNewReconciler: !1
};
function $364a0b1eab5991a3$var$Ki(a, b) {
    try {
        var c = "", d = b;
        do c += $364a0b1eab5991a3$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $364a0b1eab5991a3$var$Li(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $364a0b1eab5991a3$var$Mi(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $364a0b1eab5991a3$var$Ni = "function" === typeof WeakMap ? WeakMap : Map;
function $364a0b1eab5991a3$var$Oi(a, b, c) {
    c = $364a0b1eab5991a3$var$ch(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $364a0b1eab5991a3$var$Pi || ($364a0b1eab5991a3$var$Pi = !0, $364a0b1eab5991a3$var$Qi = d);
        $364a0b1eab5991a3$var$Mi(a, b);
    };
    return c;
}
function $364a0b1eab5991a3$var$Ri(a, b, c) {
    c = $364a0b1eab5991a3$var$ch(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $364a0b1eab5991a3$var$Mi(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $364a0b1eab5991a3$var$Mi(a, b);
        "function" !== typeof d && (null === $364a0b1eab5991a3$var$Si ? $364a0b1eab5991a3$var$Si = new Set([
            this
        ]) : $364a0b1eab5991a3$var$Si.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $364a0b1eab5991a3$var$Ti(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $364a0b1eab5991a3$var$Ni;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $364a0b1eab5991a3$var$Ui.bind(null, a, b, c), b.then(a, a));
}
function $364a0b1eab5991a3$var$Vi(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $364a0b1eab5991a3$var$Wi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $364a0b1eab5991a3$var$ch(-1, 1), b.tag = 2, $364a0b1eab5991a3$var$dh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $364a0b1eab5991a3$var$Xi = $364a0b1eab5991a3$var$ua.ReactCurrentOwner, $364a0b1eab5991a3$var$Ug = !1;
function $364a0b1eab5991a3$var$Yi(a, b, c, d) {
    b.child = null === a ? $364a0b1eab5991a3$var$Ch(b, null, c, d) : $364a0b1eab5991a3$var$Bh(b, a.child, c, d);
}
function $364a0b1eab5991a3$var$Zi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $364a0b1eab5991a3$var$Tg(b, e);
    d = $364a0b1eab5991a3$var$Xh(a, b, c, d, f, e);
    c = $364a0b1eab5991a3$var$bi();
    if (null !== a && !$364a0b1eab5991a3$var$Ug) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $364a0b1eab5991a3$var$$i(a, b, e);
    $364a0b1eab5991a3$var$I && c && $364a0b1eab5991a3$var$vg(b);
    b.flags |= 1;
    $364a0b1eab5991a3$var$Yi(a, b, d, e);
    return b.child;
}
function $364a0b1eab5991a3$var$aj(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$364a0b1eab5991a3$var$bj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $364a0b1eab5991a3$var$cj(a, b, f, d, e);
        a = $364a0b1eab5991a3$var$yh(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $364a0b1eab5991a3$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $364a0b1eab5991a3$var$$i(a, b, e);
    }
    b.flags |= 1;
    a = $364a0b1eab5991a3$var$wh(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $364a0b1eab5991a3$var$cj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($364a0b1eab5991a3$var$Ie(f, d) && a.ref === b.ref) {
            if ($364a0b1eab5991a3$var$Ug = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($364a0b1eab5991a3$var$Ug = !0);
            else return b.lanes = a.lanes, $364a0b1eab5991a3$var$$i(a, b, e);
        }
    }
    return $364a0b1eab5991a3$var$dj(a, b, c, d, e);
}
function $364a0b1eab5991a3$var$ej(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $364a0b1eab5991a3$var$G($364a0b1eab5991a3$var$fj, $364a0b1eab5991a3$var$gj), $364a0b1eab5991a3$var$gj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $364a0b1eab5991a3$var$G($364a0b1eab5991a3$var$fj, $364a0b1eab5991a3$var$gj), $364a0b1eab5991a3$var$gj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $364a0b1eab5991a3$var$G($364a0b1eab5991a3$var$fj, $364a0b1eab5991a3$var$gj);
            $364a0b1eab5991a3$var$gj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $364a0b1eab5991a3$var$G($364a0b1eab5991a3$var$fj, $364a0b1eab5991a3$var$gj), $364a0b1eab5991a3$var$gj |= d;
    $364a0b1eab5991a3$var$Yi(a, b, e, c);
    return b.child;
}
function $364a0b1eab5991a3$var$hj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $364a0b1eab5991a3$var$dj(a, b, c, d, e) {
    var f = $364a0b1eab5991a3$var$Zf(c) ? $364a0b1eab5991a3$var$Xf : $364a0b1eab5991a3$var$H.current;
    f = $364a0b1eab5991a3$var$Yf(b, f);
    $364a0b1eab5991a3$var$Tg(b, e);
    c = $364a0b1eab5991a3$var$Xh(a, b, c, d, f, e);
    d = $364a0b1eab5991a3$var$bi();
    if (null !== a && !$364a0b1eab5991a3$var$Ug) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $364a0b1eab5991a3$var$$i(a, b, e);
    $364a0b1eab5991a3$var$I && d && $364a0b1eab5991a3$var$vg(b);
    b.flags |= 1;
    $364a0b1eab5991a3$var$Yi(a, b, c, e);
    return b.child;
}
function $364a0b1eab5991a3$var$ij(a, b, c, d, e) {
    if ($364a0b1eab5991a3$var$Zf(c)) {
        var f = !0;
        $364a0b1eab5991a3$var$cg(b);
    } else f = !1;
    $364a0b1eab5991a3$var$Tg(b, e);
    if (null === b.stateNode) $364a0b1eab5991a3$var$jj(a, b), $364a0b1eab5991a3$var$ph(b, c, d), $364a0b1eab5991a3$var$rh(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $364a0b1eab5991a3$var$Vg(l) : (l = $364a0b1eab5991a3$var$Zf(c) ? $364a0b1eab5991a3$var$Xf : $364a0b1eab5991a3$var$H.current, l = $364a0b1eab5991a3$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $364a0b1eab5991a3$var$qh(b, g, d, l);
        $364a0b1eab5991a3$var$$g = !1;
        var r = b.memoizedState;
        g.state = r;
        $364a0b1eab5991a3$var$gh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $364a0b1eab5991a3$var$Wf.current || $364a0b1eab5991a3$var$$g ? ("function" === typeof m && ($364a0b1eab5991a3$var$kh(b, c, m, d), k = b.memoizedState), (h = $364a0b1eab5991a3$var$$g || $364a0b1eab5991a3$var$oh(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $364a0b1eab5991a3$var$bh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $364a0b1eab5991a3$var$Lg(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $364a0b1eab5991a3$var$Vg(k) : (k = $364a0b1eab5991a3$var$Zf(c) ? $364a0b1eab5991a3$var$Xf : $364a0b1eab5991a3$var$H.current, k = $364a0b1eab5991a3$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $364a0b1eab5991a3$var$qh(b, g, d, k);
        $364a0b1eab5991a3$var$$g = !1;
        r = b.memoizedState;
        g.state = r;
        $364a0b1eab5991a3$var$gh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $364a0b1eab5991a3$var$Wf.current || $364a0b1eab5991a3$var$$g ? ("function" === typeof y && ($364a0b1eab5991a3$var$kh(b, c, y, d), n = b.memoizedState), (l = $364a0b1eab5991a3$var$$g || $364a0b1eab5991a3$var$oh(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $364a0b1eab5991a3$var$kj(a, b, c, d, f, e);
}
function $364a0b1eab5991a3$var$kj(a, b, c, d, e, f) {
    $364a0b1eab5991a3$var$hj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $364a0b1eab5991a3$var$dg(b, c, !1), $364a0b1eab5991a3$var$$i(a, b, f);
    d = b.stateNode;
    $364a0b1eab5991a3$var$Xi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $364a0b1eab5991a3$var$Bh(b, a.child, null, f), b.child = $364a0b1eab5991a3$var$Bh(b, null, h, f)) : $364a0b1eab5991a3$var$Yi(a, b, h, f);
    b.memoizedState = d.state;
    e && $364a0b1eab5991a3$var$dg(b, c, !0);
    return b.child;
}
function $364a0b1eab5991a3$var$lj(a) {
    var b = a.stateNode;
    b.pendingContext ? $364a0b1eab5991a3$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $364a0b1eab5991a3$var$ag(a, b.context, !1);
    $364a0b1eab5991a3$var$Ih(a, b.containerInfo);
}
function $364a0b1eab5991a3$var$mj(a, b, c, d, e) {
    $364a0b1eab5991a3$var$Ig();
    $364a0b1eab5991a3$var$Jg(e);
    b.flags |= 256;
    $364a0b1eab5991a3$var$Yi(a, b, c, d);
    return b.child;
}
var $364a0b1eab5991a3$var$nj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $364a0b1eab5991a3$var$oj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $364a0b1eab5991a3$var$pj(a, b, c) {
    var d = b.pendingProps, e = $364a0b1eab5991a3$var$M.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $364a0b1eab5991a3$var$G($364a0b1eab5991a3$var$M, e & 1);
    if (null === a) {
        $364a0b1eab5991a3$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $364a0b1eab5991a3$var$qj(g, d, 0, null), a = $364a0b1eab5991a3$var$Ah(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $364a0b1eab5991a3$var$oj(c), b.memoizedState = $364a0b1eab5991a3$var$nj, a) : $364a0b1eab5991a3$var$rj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $364a0b1eab5991a3$var$sj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $364a0b1eab5991a3$var$wh(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $364a0b1eab5991a3$var$wh(h, f) : (f = $364a0b1eab5991a3$var$Ah(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $364a0b1eab5991a3$var$oj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $364a0b1eab5991a3$var$nj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $364a0b1eab5991a3$var$wh(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $364a0b1eab5991a3$var$rj(a, b) {
    b = $364a0b1eab5991a3$var$qj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $364a0b1eab5991a3$var$tj(a, b, c, d) {
    null !== d && $364a0b1eab5991a3$var$Jg(d);
    $364a0b1eab5991a3$var$Bh(b, a.child, null, c);
    a = $364a0b1eab5991a3$var$rj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $364a0b1eab5991a3$var$sj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $364a0b1eab5991a3$var$Li(Error($364a0b1eab5991a3$var$p(422))), $364a0b1eab5991a3$var$tj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $364a0b1eab5991a3$var$qj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $364a0b1eab5991a3$var$Ah(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $364a0b1eab5991a3$var$Bh(b, a.child, null, g);
        b.child.memoizedState = $364a0b1eab5991a3$var$oj(g);
        b.memoizedState = $364a0b1eab5991a3$var$nj;
        return f;
    }
    if (0 === (b.mode & 1)) return $364a0b1eab5991a3$var$tj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($364a0b1eab5991a3$var$p(419));
        d = $364a0b1eab5991a3$var$Li(f, d, void 0);
        return $364a0b1eab5991a3$var$tj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($364a0b1eab5991a3$var$Ug || h) {
        d = $364a0b1eab5991a3$var$R;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $364a0b1eab5991a3$var$Zg(a, e), $364a0b1eab5991a3$var$mh(d, a, e, -1));
        }
        $364a0b1eab5991a3$var$uj();
        d = $364a0b1eab5991a3$var$Li(Error($364a0b1eab5991a3$var$p(421)));
        return $364a0b1eab5991a3$var$tj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $364a0b1eab5991a3$var$vj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $364a0b1eab5991a3$var$yg = $364a0b1eab5991a3$var$Lf(e.nextSibling);
    $364a0b1eab5991a3$var$xg = b;
    $364a0b1eab5991a3$var$I = !0;
    $364a0b1eab5991a3$var$zg = null;
    null !== a && ($364a0b1eab5991a3$var$og[$364a0b1eab5991a3$var$pg++] = $364a0b1eab5991a3$var$rg, $364a0b1eab5991a3$var$og[$364a0b1eab5991a3$var$pg++] = $364a0b1eab5991a3$var$sg, $364a0b1eab5991a3$var$og[$364a0b1eab5991a3$var$pg++] = $364a0b1eab5991a3$var$qg, $364a0b1eab5991a3$var$rg = a.id, $364a0b1eab5991a3$var$sg = a.overflow, $364a0b1eab5991a3$var$qg = b);
    b = $364a0b1eab5991a3$var$rj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $364a0b1eab5991a3$var$wj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $364a0b1eab5991a3$var$Sg(a.return, b, c);
}
function $364a0b1eab5991a3$var$xj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $364a0b1eab5991a3$var$yj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $364a0b1eab5991a3$var$Yi(a, b, d.children, c);
    d = $364a0b1eab5991a3$var$M.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $364a0b1eab5991a3$var$wj(a, c, b);
            else if (19 === a.tag) $364a0b1eab5991a3$var$wj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $364a0b1eab5991a3$var$G($364a0b1eab5991a3$var$M, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $364a0b1eab5991a3$var$Mh(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $364a0b1eab5991a3$var$xj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $364a0b1eab5991a3$var$Mh(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $364a0b1eab5991a3$var$xj(b, !0, c, null, f);
            break;
        case "together":
            $364a0b1eab5991a3$var$xj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $364a0b1eab5991a3$var$jj(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $364a0b1eab5991a3$var$$i(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $364a0b1eab5991a3$var$hh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($364a0b1eab5991a3$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $364a0b1eab5991a3$var$wh(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $364a0b1eab5991a3$var$wh(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $364a0b1eab5991a3$var$zj(a, b, c) {
    switch(b.tag){
        case 3:
            $364a0b1eab5991a3$var$lj(b);
            $364a0b1eab5991a3$var$Ig();
            break;
        case 5:
            $364a0b1eab5991a3$var$Kh(b);
            break;
        case 1:
            $364a0b1eab5991a3$var$Zf(b.type) && $364a0b1eab5991a3$var$cg(b);
            break;
        case 4:
            $364a0b1eab5991a3$var$Ih(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $364a0b1eab5991a3$var$G($364a0b1eab5991a3$var$Mg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $364a0b1eab5991a3$var$G($364a0b1eab5991a3$var$M, $364a0b1eab5991a3$var$M.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $364a0b1eab5991a3$var$pj(a, b, c);
                $364a0b1eab5991a3$var$G($364a0b1eab5991a3$var$M, $364a0b1eab5991a3$var$M.current & 1);
                a = $364a0b1eab5991a3$var$$i(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $364a0b1eab5991a3$var$G($364a0b1eab5991a3$var$M, $364a0b1eab5991a3$var$M.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $364a0b1eab5991a3$var$yj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $364a0b1eab5991a3$var$G($364a0b1eab5991a3$var$M, $364a0b1eab5991a3$var$M.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $364a0b1eab5991a3$var$ej(a, b, c);
    }
    return $364a0b1eab5991a3$var$$i(a, b, c);
}
var $364a0b1eab5991a3$var$Aj, $364a0b1eab5991a3$var$Bj, $364a0b1eab5991a3$var$Cj, $364a0b1eab5991a3$var$Dj;
$364a0b1eab5991a3$var$Aj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$364a0b1eab5991a3$var$Bj = function() {};
$364a0b1eab5991a3$var$Cj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $364a0b1eab5991a3$var$Hh($364a0b1eab5991a3$var$Eh.current);
        var f = null;
        switch(c){
            case "input":
                e = $364a0b1eab5991a3$var$Ya(a, e);
                d = $364a0b1eab5991a3$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $364a0b1eab5991a3$var$A({}, e, {
                    value: void 0
                });
                d = $364a0b1eab5991a3$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $364a0b1eab5991a3$var$gb(a, e);
                d = $364a0b1eab5991a3$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $364a0b1eab5991a3$var$Bf);
        }
        $364a0b1eab5991a3$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($364a0b1eab5991a3$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($364a0b1eab5991a3$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $364a0b1eab5991a3$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$364a0b1eab5991a3$var$Dj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $364a0b1eab5991a3$var$Ej(a, b) {
    if (!$364a0b1eab5991a3$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $364a0b1eab5991a3$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $364a0b1eab5991a3$var$Fj(a, b, c) {
    var d = b.pendingProps;
    $364a0b1eab5991a3$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $364a0b1eab5991a3$var$S(b), null;
        case 1:
            return $364a0b1eab5991a3$var$Zf(b.type) && $364a0b1eab5991a3$var$$f(), $364a0b1eab5991a3$var$S(b), null;
        case 3:
            d = b.stateNode;
            $364a0b1eab5991a3$var$Jh();
            $364a0b1eab5991a3$var$E($364a0b1eab5991a3$var$Wf);
            $364a0b1eab5991a3$var$E($364a0b1eab5991a3$var$H);
            $364a0b1eab5991a3$var$Oh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $364a0b1eab5991a3$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $364a0b1eab5991a3$var$zg && ($364a0b1eab5991a3$var$Gj($364a0b1eab5991a3$var$zg), $364a0b1eab5991a3$var$zg = null));
            $364a0b1eab5991a3$var$Bj(a, b);
            $364a0b1eab5991a3$var$S(b);
            return null;
        case 5:
            $364a0b1eab5991a3$var$Lh(b);
            var e = $364a0b1eab5991a3$var$Hh($364a0b1eab5991a3$var$Gh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $364a0b1eab5991a3$var$Cj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($364a0b1eab5991a3$var$p(166));
                    $364a0b1eab5991a3$var$S(b);
                    return null;
                }
                a = $364a0b1eab5991a3$var$Hh($364a0b1eab5991a3$var$Eh.current);
                if ($364a0b1eab5991a3$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$364a0b1eab5991a3$var$Of] = b;
                    d[$364a0b1eab5991a3$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $364a0b1eab5991a3$var$D("cancel", d);
                            $364a0b1eab5991a3$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $364a0b1eab5991a3$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $364a0b1eab5991a3$var$lf.length; e++)$364a0b1eab5991a3$var$D($364a0b1eab5991a3$var$lf[e], d);
                            break;
                        case "source":
                            $364a0b1eab5991a3$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $364a0b1eab5991a3$var$D("error", d);
                            $364a0b1eab5991a3$var$D("load", d);
                            break;
                        case "details":
                            $364a0b1eab5991a3$var$D("toggle", d);
                            break;
                        case "input":
                            $364a0b1eab5991a3$var$Za(d, f);
                            $364a0b1eab5991a3$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $364a0b1eab5991a3$var$D("invalid", d);
                            break;
                        case "textarea":
                            $364a0b1eab5991a3$var$hb(d, f), $364a0b1eab5991a3$var$D("invalid", d);
                    }
                    $364a0b1eab5991a3$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $364a0b1eab5991a3$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $364a0b1eab5991a3$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $364a0b1eab5991a3$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $364a0b1eab5991a3$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $364a0b1eab5991a3$var$Va(d);
                            $364a0b1eab5991a3$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $364a0b1eab5991a3$var$Va(d);
                            $364a0b1eab5991a3$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $364a0b1eab5991a3$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $364a0b1eab5991a3$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script></script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$364a0b1eab5991a3$var$Of] = b;
                    a[$364a0b1eab5991a3$var$Pf] = d;
                    $364a0b1eab5991a3$var$Aj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $364a0b1eab5991a3$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $364a0b1eab5991a3$var$D("cancel", a);
                                $364a0b1eab5991a3$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $364a0b1eab5991a3$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $364a0b1eab5991a3$var$lf.length; e++)$364a0b1eab5991a3$var$D($364a0b1eab5991a3$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $364a0b1eab5991a3$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $364a0b1eab5991a3$var$D("error", a);
                                $364a0b1eab5991a3$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $364a0b1eab5991a3$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $364a0b1eab5991a3$var$Za(a, d);
                                e = $364a0b1eab5991a3$var$Ya(a, d);
                                $364a0b1eab5991a3$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $364a0b1eab5991a3$var$A({}, d, {
                                    value: void 0
                                });
                                $364a0b1eab5991a3$var$D("invalid", a);
                                break;
                            case "textarea":
                                $364a0b1eab5991a3$var$hb(a, d);
                                e = $364a0b1eab5991a3$var$gb(a, d);
                                $364a0b1eab5991a3$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $364a0b1eab5991a3$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $364a0b1eab5991a3$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $364a0b1eab5991a3$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $364a0b1eab5991a3$var$ob(a, k) : "number" === typeof k && $364a0b1eab5991a3$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($364a0b1eab5991a3$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $364a0b1eab5991a3$var$D("scroll", a) : null != k && $364a0b1eab5991a3$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $364a0b1eab5991a3$var$Va(a);
                                $364a0b1eab5991a3$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $364a0b1eab5991a3$var$Va(a);
                                $364a0b1eab5991a3$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $364a0b1eab5991a3$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $364a0b1eab5991a3$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $364a0b1eab5991a3$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $364a0b1eab5991a3$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $364a0b1eab5991a3$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $364a0b1eab5991a3$var$Dj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($364a0b1eab5991a3$var$p(166));
                c = $364a0b1eab5991a3$var$Hh($364a0b1eab5991a3$var$Gh.current);
                $364a0b1eab5991a3$var$Hh($364a0b1eab5991a3$var$Eh.current);
                if ($364a0b1eab5991a3$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$364a0b1eab5991a3$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $364a0b1eab5991a3$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $364a0b1eab5991a3$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $364a0b1eab5991a3$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$364a0b1eab5991a3$var$Of] = b, b.stateNode = d;
            }
            $364a0b1eab5991a3$var$S(b);
            return null;
        case 13:
            $364a0b1eab5991a3$var$E($364a0b1eab5991a3$var$M);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($364a0b1eab5991a3$var$I && null !== $364a0b1eab5991a3$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $364a0b1eab5991a3$var$Hg(), $364a0b1eab5991a3$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $364a0b1eab5991a3$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($364a0b1eab5991a3$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($364a0b1eab5991a3$var$p(317));
                        f[$364a0b1eab5991a3$var$Of] = b;
                    } else $364a0b1eab5991a3$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $364a0b1eab5991a3$var$S(b);
                    f = !1;
                } else null !== $364a0b1eab5991a3$var$zg && ($364a0b1eab5991a3$var$Gj($364a0b1eab5991a3$var$zg), $364a0b1eab5991a3$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($364a0b1eab5991a3$var$M.current & 1) ? 0 === $364a0b1eab5991a3$var$T && ($364a0b1eab5991a3$var$T = 3) : $364a0b1eab5991a3$var$uj()));
            null !== b.updateQueue && (b.flags |= 4);
            $364a0b1eab5991a3$var$S(b);
            return null;
        case 4:
            return $364a0b1eab5991a3$var$Jh(), $364a0b1eab5991a3$var$Bj(a, b), null === a && $364a0b1eab5991a3$var$sf(b.stateNode.containerInfo), $364a0b1eab5991a3$var$S(b), null;
        case 10:
            return $364a0b1eab5991a3$var$Rg(b.type._context), $364a0b1eab5991a3$var$S(b), null;
        case 17:
            return $364a0b1eab5991a3$var$Zf(b.type) && $364a0b1eab5991a3$var$$f(), $364a0b1eab5991a3$var$S(b), null;
        case 19:
            $364a0b1eab5991a3$var$E($364a0b1eab5991a3$var$M);
            f = b.memoizedState;
            if (null === f) return $364a0b1eab5991a3$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $364a0b1eab5991a3$var$Ej(f, !1);
                else {
                    if (0 !== $364a0b1eab5991a3$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $364a0b1eab5991a3$var$Mh(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $364a0b1eab5991a3$var$Ej(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $364a0b1eab5991a3$var$G($364a0b1eab5991a3$var$M, $364a0b1eab5991a3$var$M.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $364a0b1eab5991a3$var$B() > $364a0b1eab5991a3$var$Hj && (b.flags |= 128, d = !0, $364a0b1eab5991a3$var$Ej(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $364a0b1eab5991a3$var$Mh(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $364a0b1eab5991a3$var$Ej(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$364a0b1eab5991a3$var$I) return $364a0b1eab5991a3$var$S(b), null;
                    } else 2 * $364a0b1eab5991a3$var$B() - f.renderingStartTime > $364a0b1eab5991a3$var$Hj && 1073741824 !== c && (b.flags |= 128, d = !0, $364a0b1eab5991a3$var$Ej(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $364a0b1eab5991a3$var$B(), b.sibling = null, c = $364a0b1eab5991a3$var$M.current, $364a0b1eab5991a3$var$G($364a0b1eab5991a3$var$M, d ? c & 1 | 2 : c & 1), b;
            $364a0b1eab5991a3$var$S(b);
            return null;
        case 22:
        case 23:
            return $364a0b1eab5991a3$var$Ij(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($364a0b1eab5991a3$var$gj & 1073741824) && ($364a0b1eab5991a3$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $364a0b1eab5991a3$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($364a0b1eab5991a3$var$p(156, b.tag));
}
function $364a0b1eab5991a3$var$Jj(a, b) {
    $364a0b1eab5991a3$var$wg(b);
    switch(b.tag){
        case 1:
            return $364a0b1eab5991a3$var$Zf(b.type) && $364a0b1eab5991a3$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $364a0b1eab5991a3$var$Jh(), $364a0b1eab5991a3$var$E($364a0b1eab5991a3$var$Wf), $364a0b1eab5991a3$var$E($364a0b1eab5991a3$var$H), $364a0b1eab5991a3$var$Oh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $364a0b1eab5991a3$var$Lh(b), null;
        case 13:
            $364a0b1eab5991a3$var$E($364a0b1eab5991a3$var$M);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($364a0b1eab5991a3$var$p(340));
                $364a0b1eab5991a3$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $364a0b1eab5991a3$var$E($364a0b1eab5991a3$var$M), null;
        case 4:
            return $364a0b1eab5991a3$var$Jh(), null;
        case 10:
            return $364a0b1eab5991a3$var$Rg(b.type._context), null;
        case 22:
        case 23:
            return $364a0b1eab5991a3$var$Ij(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $364a0b1eab5991a3$var$Kj = !1, $364a0b1eab5991a3$var$U = !1, $364a0b1eab5991a3$var$Lj = "function" === typeof WeakSet ? WeakSet : Set, $364a0b1eab5991a3$var$V = null;
function $364a0b1eab5991a3$var$Mj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $364a0b1eab5991a3$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $364a0b1eab5991a3$var$Nj(a, b, c) {
    try {
        c();
    } catch (d) {
        $364a0b1eab5991a3$var$W(a, b, d);
    }
}
var $364a0b1eab5991a3$var$Oj = !1;
function $364a0b1eab5991a3$var$Pj(a, b) {
    $364a0b1eab5991a3$var$Cf = $364a0b1eab5991a3$var$dd;
    a = $364a0b1eab5991a3$var$Me();
    if ($364a0b1eab5991a3$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $364a0b1eab5991a3$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $364a0b1eab5991a3$var$dd = !1;
    for($364a0b1eab5991a3$var$V = b; null !== $364a0b1eab5991a3$var$V;)if (b = $364a0b1eab5991a3$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $364a0b1eab5991a3$var$V = a;
    else for(; null !== $364a0b1eab5991a3$var$V;){
        b = $364a0b1eab5991a3$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $364a0b1eab5991a3$var$Lg(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($364a0b1eab5991a3$var$p(163));
            }
        } catch (F) {
            $364a0b1eab5991a3$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $364a0b1eab5991a3$var$V = a;
            break;
        }
        $364a0b1eab5991a3$var$V = b.return;
    }
    n = $364a0b1eab5991a3$var$Oj;
    $364a0b1eab5991a3$var$Oj = !1;
    return n;
}
function $364a0b1eab5991a3$var$Qj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $364a0b1eab5991a3$var$Nj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $364a0b1eab5991a3$var$Rj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $364a0b1eab5991a3$var$Sj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $364a0b1eab5991a3$var$Tj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $364a0b1eab5991a3$var$Tj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$364a0b1eab5991a3$var$Of], delete b[$364a0b1eab5991a3$var$Pf], delete b[$364a0b1eab5991a3$var$of], delete b[$364a0b1eab5991a3$var$Qf], delete b[$364a0b1eab5991a3$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $364a0b1eab5991a3$var$Uj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $364a0b1eab5991a3$var$Vj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $364a0b1eab5991a3$var$Uj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $364a0b1eab5991a3$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $364a0b1eab5991a3$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($364a0b1eab5991a3$var$Wj(a, b, c), a = a.sibling; null !== a;)$364a0b1eab5991a3$var$Wj(a, b, c), a = a.sibling;
}
function $364a0b1eab5991a3$var$Xj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($364a0b1eab5991a3$var$Xj(a, b, c), a = a.sibling; null !== a;)$364a0b1eab5991a3$var$Xj(a, b, c), a = a.sibling;
}
var $364a0b1eab5991a3$var$X = null, $364a0b1eab5991a3$var$Yj = !1;
function $364a0b1eab5991a3$var$Zj(a, b, c) {
    for(c = c.child; null !== c;)$364a0b1eab5991a3$var$ak(a, b, c), c = c.sibling;
}
function $364a0b1eab5991a3$var$ak(a, b, c) {
    if ($364a0b1eab5991a3$var$lc && "function" === typeof $364a0b1eab5991a3$var$lc.onCommitFiberUnmount) try {
        $364a0b1eab5991a3$var$lc.onCommitFiberUnmount($364a0b1eab5991a3$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $364a0b1eab5991a3$var$U || $364a0b1eab5991a3$var$Mj(c, b);
        case 6:
            var d = $364a0b1eab5991a3$var$X, e = $364a0b1eab5991a3$var$Yj;
            $364a0b1eab5991a3$var$X = null;
            $364a0b1eab5991a3$var$Zj(a, b, c);
            $364a0b1eab5991a3$var$X = d;
            $364a0b1eab5991a3$var$Yj = e;
            null !== $364a0b1eab5991a3$var$X && ($364a0b1eab5991a3$var$Yj ? (a = $364a0b1eab5991a3$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $364a0b1eab5991a3$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $364a0b1eab5991a3$var$X && ($364a0b1eab5991a3$var$Yj ? (a = $364a0b1eab5991a3$var$X, c = c.stateNode, 8 === a.nodeType ? $364a0b1eab5991a3$var$Kf(a.parentNode, c) : 1 === a.nodeType && $364a0b1eab5991a3$var$Kf(a, c), $364a0b1eab5991a3$var$bd(a)) : $364a0b1eab5991a3$var$Kf($364a0b1eab5991a3$var$X, c.stateNode));
            break;
        case 4:
            d = $364a0b1eab5991a3$var$X;
            e = $364a0b1eab5991a3$var$Yj;
            $364a0b1eab5991a3$var$X = c.stateNode.containerInfo;
            $364a0b1eab5991a3$var$Yj = !0;
            $364a0b1eab5991a3$var$Zj(a, b, c);
            $364a0b1eab5991a3$var$X = d;
            $364a0b1eab5991a3$var$Yj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$364a0b1eab5991a3$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $364a0b1eab5991a3$var$Nj(c, b, g) : 0 !== (f & 4) && $364a0b1eab5991a3$var$Nj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $364a0b1eab5991a3$var$Zj(a, b, c);
            break;
        case 1:
            if (!$364a0b1eab5991a3$var$U && ($364a0b1eab5991a3$var$Mj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $364a0b1eab5991a3$var$W(c, b, h);
            }
            $364a0b1eab5991a3$var$Zj(a, b, c);
            break;
        case 21:
            $364a0b1eab5991a3$var$Zj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($364a0b1eab5991a3$var$U = (d = $364a0b1eab5991a3$var$U) || null !== c.memoizedState, $364a0b1eab5991a3$var$Zj(a, b, c), $364a0b1eab5991a3$var$U = d) : $364a0b1eab5991a3$var$Zj(a, b, c);
            break;
        default:
            $364a0b1eab5991a3$var$Zj(a, b, c);
    }
}
function $364a0b1eab5991a3$var$bk(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $364a0b1eab5991a3$var$Lj);
        b.forEach(function(b) {
            var d = $364a0b1eab5991a3$var$ck.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $364a0b1eab5991a3$var$dk(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $364a0b1eab5991a3$var$X = h.stateNode;
                        $364a0b1eab5991a3$var$Yj = !1;
                        break a;
                    case 3:
                        $364a0b1eab5991a3$var$X = h.stateNode.containerInfo;
                        $364a0b1eab5991a3$var$Yj = !0;
                        break a;
                    case 4:
                        $364a0b1eab5991a3$var$X = h.stateNode.containerInfo;
                        $364a0b1eab5991a3$var$Yj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $364a0b1eab5991a3$var$X) throw Error($364a0b1eab5991a3$var$p(160));
            $364a0b1eab5991a3$var$ak(f, g, e);
            $364a0b1eab5991a3$var$X = null;
            $364a0b1eab5991a3$var$Yj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $364a0b1eab5991a3$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$364a0b1eab5991a3$var$ek(b, a), b = b.sibling;
}
function $364a0b1eab5991a3$var$ek(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $364a0b1eab5991a3$var$dk(b, a);
            $364a0b1eab5991a3$var$fk(a);
            if (d & 4) {
                try {
                    $364a0b1eab5991a3$var$Qj(3, a, a.return), $364a0b1eab5991a3$var$Rj(3, a);
                } catch (t) {
                    $364a0b1eab5991a3$var$W(a, a.return, t);
                }
                try {
                    $364a0b1eab5991a3$var$Qj(5, a, a.return);
                } catch (t) {
                    $364a0b1eab5991a3$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $364a0b1eab5991a3$var$dk(b, a);
            $364a0b1eab5991a3$var$fk(a);
            d & 512 && null !== c && $364a0b1eab5991a3$var$Mj(c, c.return);
            break;
        case 5:
            $364a0b1eab5991a3$var$dk(b, a);
            $364a0b1eab5991a3$var$fk(a);
            d & 512 && null !== c && $364a0b1eab5991a3$var$Mj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $364a0b1eab5991a3$var$ob(e, "");
                } catch (t) {
                    $364a0b1eab5991a3$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $364a0b1eab5991a3$var$ab(e, f);
                    $364a0b1eab5991a3$var$vb(h, g);
                    var l = $364a0b1eab5991a3$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $364a0b1eab5991a3$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $364a0b1eab5991a3$var$nb(e, q) : "children" === m ? $364a0b1eab5991a3$var$ob(e, q) : $364a0b1eab5991a3$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $364a0b1eab5991a3$var$bb(e, f);
                            break;
                        case "textarea":
                            $364a0b1eab5991a3$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $364a0b1eab5991a3$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $364a0b1eab5991a3$var$fb(e, !!f.multiple, f.defaultValue, !0) : $364a0b1eab5991a3$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$364a0b1eab5991a3$var$Pf] = f;
                } catch (t) {
                    $364a0b1eab5991a3$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $364a0b1eab5991a3$var$dk(b, a);
            $364a0b1eab5991a3$var$fk(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($364a0b1eab5991a3$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $364a0b1eab5991a3$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $364a0b1eab5991a3$var$dk(b, a);
            $364a0b1eab5991a3$var$fk(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $364a0b1eab5991a3$var$bd(b.containerInfo);
            } catch (t) {
                $364a0b1eab5991a3$var$W(a, a.return, t);
            }
            break;
        case 4:
            $364a0b1eab5991a3$var$dk(b, a);
            $364a0b1eab5991a3$var$fk(a);
            break;
        case 13:
            $364a0b1eab5991a3$var$dk(b, a);
            $364a0b1eab5991a3$var$fk(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($364a0b1eab5991a3$var$gk = $364a0b1eab5991a3$var$B()));
            d & 4 && $364a0b1eab5991a3$var$bk(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($364a0b1eab5991a3$var$U = (l = $364a0b1eab5991a3$var$U) || m, $364a0b1eab5991a3$var$dk(b, a), $364a0b1eab5991a3$var$U = l) : $364a0b1eab5991a3$var$dk(b, a);
            $364a0b1eab5991a3$var$fk(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($364a0b1eab5991a3$var$V = a, m = a.child; null !== m;){
                    for(q = $364a0b1eab5991a3$var$V = m; null !== $364a0b1eab5991a3$var$V;){
                        r = $364a0b1eab5991a3$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $364a0b1eab5991a3$var$Qj(4, r, r.return);
                                break;
                            case 1:
                                $364a0b1eab5991a3$var$Mj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $364a0b1eab5991a3$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $364a0b1eab5991a3$var$Mj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $364a0b1eab5991a3$var$hk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $364a0b1eab5991a3$var$V = y) : $364a0b1eab5991a3$var$hk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $364a0b1eab5991a3$var$rb("display", g));
                            } catch (t) {
                                $364a0b1eab5991a3$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $364a0b1eab5991a3$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $364a0b1eab5991a3$var$dk(b, a);
            $364a0b1eab5991a3$var$fk(a);
            d & 4 && $364a0b1eab5991a3$var$bk(a);
            break;
        case 21:
            break;
        default:
            $364a0b1eab5991a3$var$dk(b, a), $364a0b1eab5991a3$var$fk(a);
    }
}
function $364a0b1eab5991a3$var$fk(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($364a0b1eab5991a3$var$Uj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($364a0b1eab5991a3$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($364a0b1eab5991a3$var$ob(e, ""), d.flags &= -33);
                    var f = $364a0b1eab5991a3$var$Vj(a);
                    $364a0b1eab5991a3$var$Xj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $364a0b1eab5991a3$var$Vj(a);
                    $364a0b1eab5991a3$var$Wj(a, h, g);
                    break;
                default:
                    throw Error($364a0b1eab5991a3$var$p(161));
            }
        } catch (k) {
            $364a0b1eab5991a3$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $364a0b1eab5991a3$var$ik(a, b, c) {
    $364a0b1eab5991a3$var$V = a;
    $364a0b1eab5991a3$var$jk(a, b, c);
}
function $364a0b1eab5991a3$var$jk(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $364a0b1eab5991a3$var$V;){
        var e = $364a0b1eab5991a3$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $364a0b1eab5991a3$var$Kj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $364a0b1eab5991a3$var$U;
                h = $364a0b1eab5991a3$var$Kj;
                var l = $364a0b1eab5991a3$var$U;
                $364a0b1eab5991a3$var$Kj = g;
                if (($364a0b1eab5991a3$var$U = k) && !l) for($364a0b1eab5991a3$var$V = e; null !== $364a0b1eab5991a3$var$V;)g = $364a0b1eab5991a3$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $364a0b1eab5991a3$var$kk(e) : null !== k ? (k.return = g, $364a0b1eab5991a3$var$V = k) : $364a0b1eab5991a3$var$kk(e);
                for(; null !== f;)$364a0b1eab5991a3$var$V = f, $364a0b1eab5991a3$var$jk(f, b, c), f = f.sibling;
                $364a0b1eab5991a3$var$V = e;
                $364a0b1eab5991a3$var$Kj = h;
                $364a0b1eab5991a3$var$U = l;
            }
            $364a0b1eab5991a3$var$lk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $364a0b1eab5991a3$var$V = f) : $364a0b1eab5991a3$var$lk(a, b, c);
    }
}
function $364a0b1eab5991a3$var$lk(a) {
    for(; null !== $364a0b1eab5991a3$var$V;){
        var b = $364a0b1eab5991a3$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $364a0b1eab5991a3$var$U || $364a0b1eab5991a3$var$Rj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$364a0b1eab5991a3$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $364a0b1eab5991a3$var$Lg(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $364a0b1eab5991a3$var$ih(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $364a0b1eab5991a3$var$ih(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $364a0b1eab5991a3$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($364a0b1eab5991a3$var$p(163));
                }
                $364a0b1eab5991a3$var$U || b.flags & 512 && $364a0b1eab5991a3$var$Sj(b);
            } catch (r) {
                $364a0b1eab5991a3$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $364a0b1eab5991a3$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $364a0b1eab5991a3$var$V = c;
            break;
        }
        $364a0b1eab5991a3$var$V = b.return;
    }
}
function $364a0b1eab5991a3$var$hk(a) {
    for(; null !== $364a0b1eab5991a3$var$V;){
        var b = $364a0b1eab5991a3$var$V;
        if (b === a) {
            $364a0b1eab5991a3$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $364a0b1eab5991a3$var$V = c;
            break;
        }
        $364a0b1eab5991a3$var$V = b.return;
    }
}
function $364a0b1eab5991a3$var$kk(a) {
    for(; null !== $364a0b1eab5991a3$var$V;){
        var b = $364a0b1eab5991a3$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $364a0b1eab5991a3$var$Rj(4, b);
                    } catch (k) {
                        $364a0b1eab5991a3$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $364a0b1eab5991a3$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $364a0b1eab5991a3$var$Sj(b);
                    } catch (k) {
                        $364a0b1eab5991a3$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $364a0b1eab5991a3$var$Sj(b);
                    } catch (k) {
                        $364a0b1eab5991a3$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $364a0b1eab5991a3$var$W(b, b.return, k);
        }
        if (b === a) {
            $364a0b1eab5991a3$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $364a0b1eab5991a3$var$V = h;
            break;
        }
        $364a0b1eab5991a3$var$V = b.return;
    }
}
var $364a0b1eab5991a3$var$mk = Math.ceil, $364a0b1eab5991a3$var$nk = $364a0b1eab5991a3$var$ua.ReactCurrentDispatcher, $364a0b1eab5991a3$var$ok = $364a0b1eab5991a3$var$ua.ReactCurrentOwner, $364a0b1eab5991a3$var$pk = $364a0b1eab5991a3$var$ua.ReactCurrentBatchConfig, $364a0b1eab5991a3$var$K = 0, $364a0b1eab5991a3$var$R = null, $364a0b1eab5991a3$var$Y = null, $364a0b1eab5991a3$var$Z = 0, $364a0b1eab5991a3$var$gj = 0, $364a0b1eab5991a3$var$fj = $364a0b1eab5991a3$var$Uf(0), $364a0b1eab5991a3$var$T = 0, $364a0b1eab5991a3$var$qk = null, $364a0b1eab5991a3$var$hh = 0, $364a0b1eab5991a3$var$rk = 0, $364a0b1eab5991a3$var$sk = 0, $364a0b1eab5991a3$var$tk = null, $364a0b1eab5991a3$var$uk = null, $364a0b1eab5991a3$var$gk = 0, $364a0b1eab5991a3$var$Hj = Infinity, $364a0b1eab5991a3$var$vk = null, $364a0b1eab5991a3$var$Pi = !1, $364a0b1eab5991a3$var$Qi = null, $364a0b1eab5991a3$var$Si = null, $364a0b1eab5991a3$var$wk = !1, $364a0b1eab5991a3$var$xk = null, $364a0b1eab5991a3$var$yk = 0, $364a0b1eab5991a3$var$zk = 0, $364a0b1eab5991a3$var$Ak = null, $364a0b1eab5991a3$var$Bk = -1, $364a0b1eab5991a3$var$Ck = 0;
function $364a0b1eab5991a3$var$L() {
    return 0 !== ($364a0b1eab5991a3$var$K & 6) ? $364a0b1eab5991a3$var$B() : -1 !== $364a0b1eab5991a3$var$Bk ? $364a0b1eab5991a3$var$Bk : $364a0b1eab5991a3$var$Bk = $364a0b1eab5991a3$var$B();
}
function $364a0b1eab5991a3$var$lh(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($364a0b1eab5991a3$var$K & 2) && 0 !== $364a0b1eab5991a3$var$Z) return $364a0b1eab5991a3$var$Z & -$364a0b1eab5991a3$var$Z;
    if (null !== $364a0b1eab5991a3$var$Kg.transition) return 0 === $364a0b1eab5991a3$var$Ck && ($364a0b1eab5991a3$var$Ck = $364a0b1eab5991a3$var$yc()), $364a0b1eab5991a3$var$Ck;
    a = $364a0b1eab5991a3$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $364a0b1eab5991a3$var$jd(a.type);
    return a;
}
function $364a0b1eab5991a3$var$mh(a, b, c, d) {
    if (50 < $364a0b1eab5991a3$var$zk) throw $364a0b1eab5991a3$var$zk = 0, $364a0b1eab5991a3$var$Ak = null, Error($364a0b1eab5991a3$var$p(185));
    $364a0b1eab5991a3$var$Ac(a, c, d);
    if (0 === ($364a0b1eab5991a3$var$K & 2) || a !== $364a0b1eab5991a3$var$R) a === $364a0b1eab5991a3$var$R && (0 === ($364a0b1eab5991a3$var$K & 2) && ($364a0b1eab5991a3$var$rk |= c), 4 === $364a0b1eab5991a3$var$T && $364a0b1eab5991a3$var$Dk(a, $364a0b1eab5991a3$var$Z)), $364a0b1eab5991a3$var$Ek(a, d), 1 === c && 0 === $364a0b1eab5991a3$var$K && 0 === (b.mode & 1) && ($364a0b1eab5991a3$var$Hj = $364a0b1eab5991a3$var$B() + 500, $364a0b1eab5991a3$var$fg && $364a0b1eab5991a3$var$jg());
}
function $364a0b1eab5991a3$var$Ek(a, b) {
    var c = a.callbackNode;
    $364a0b1eab5991a3$var$wc(a, b);
    var d = $364a0b1eab5991a3$var$uc(a, a === $364a0b1eab5991a3$var$R ? $364a0b1eab5991a3$var$Z : 0);
    if (0 === d) null !== c && $364a0b1eab5991a3$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $364a0b1eab5991a3$var$bc(c);
        if (1 === b) 0 === a.tag ? $364a0b1eab5991a3$var$ig($364a0b1eab5991a3$var$Fk.bind(null, a)) : $364a0b1eab5991a3$var$hg($364a0b1eab5991a3$var$Fk.bind(null, a)), $364a0b1eab5991a3$var$Jf(function() {
            0 === ($364a0b1eab5991a3$var$K & 6) && $364a0b1eab5991a3$var$jg();
        }), c = null;
        else {
            switch($364a0b1eab5991a3$var$Dc(d)){
                case 1:
                    c = $364a0b1eab5991a3$var$fc;
                    break;
                case 4:
                    c = $364a0b1eab5991a3$var$gc;
                    break;
                case 16:
                    c = $364a0b1eab5991a3$var$hc;
                    break;
                case 536870912:
                    c = $364a0b1eab5991a3$var$jc;
                    break;
                default:
                    c = $364a0b1eab5991a3$var$hc;
            }
            c = $364a0b1eab5991a3$var$Gk(c, $364a0b1eab5991a3$var$Hk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $364a0b1eab5991a3$var$Hk(a, b) {
    $364a0b1eab5991a3$var$Bk = -1;
    $364a0b1eab5991a3$var$Ck = 0;
    if (0 !== ($364a0b1eab5991a3$var$K & 6)) throw Error($364a0b1eab5991a3$var$p(327));
    var c = a.callbackNode;
    if ($364a0b1eab5991a3$var$Ik() && a.callbackNode !== c) return null;
    var d = $364a0b1eab5991a3$var$uc(a, a === $364a0b1eab5991a3$var$R ? $364a0b1eab5991a3$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $364a0b1eab5991a3$var$Jk(a, d);
    else {
        b = d;
        var e = $364a0b1eab5991a3$var$K;
        $364a0b1eab5991a3$var$K |= 2;
        var f = $364a0b1eab5991a3$var$Kk();
        if ($364a0b1eab5991a3$var$R !== a || $364a0b1eab5991a3$var$Z !== b) $364a0b1eab5991a3$var$vk = null, $364a0b1eab5991a3$var$Hj = $364a0b1eab5991a3$var$B() + 500, $364a0b1eab5991a3$var$Lk(a, b);
        for(;;)try {
            $364a0b1eab5991a3$var$Mk();
            break;
        } catch (h) {
            $364a0b1eab5991a3$var$Nk(a, h);
        }
        $364a0b1eab5991a3$var$Qg();
        $364a0b1eab5991a3$var$nk.current = f;
        $364a0b1eab5991a3$var$K = e;
        null !== $364a0b1eab5991a3$var$Y ? b = 0 : ($364a0b1eab5991a3$var$R = null, $364a0b1eab5991a3$var$Z = 0, b = $364a0b1eab5991a3$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $364a0b1eab5991a3$var$xc(a), 0 !== e && (d = e, b = $364a0b1eab5991a3$var$Ok(a, e)));
        if (1 === b) throw c = $364a0b1eab5991a3$var$qk, $364a0b1eab5991a3$var$Lk(a, 0), $364a0b1eab5991a3$var$Dk(a, d), $364a0b1eab5991a3$var$Ek(a, $364a0b1eab5991a3$var$B()), c;
        if (6 === b) $364a0b1eab5991a3$var$Dk(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$364a0b1eab5991a3$var$Pk(e) && (b = $364a0b1eab5991a3$var$Jk(a, d), 2 === b && (f = $364a0b1eab5991a3$var$xc(a), 0 !== f && (d = f, b = $364a0b1eab5991a3$var$Ok(a, f))), 1 === b)) throw c = $364a0b1eab5991a3$var$qk, $364a0b1eab5991a3$var$Lk(a, 0), $364a0b1eab5991a3$var$Dk(a, d), $364a0b1eab5991a3$var$Ek(a, $364a0b1eab5991a3$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($364a0b1eab5991a3$var$p(345));
                case 2:
                    $364a0b1eab5991a3$var$Qk(a, $364a0b1eab5991a3$var$uk, $364a0b1eab5991a3$var$vk);
                    break;
                case 3:
                    $364a0b1eab5991a3$var$Dk(a, d);
                    if ((d & 130023424) === d && (b = $364a0b1eab5991a3$var$gk + 500 - $364a0b1eab5991a3$var$B(), 10 < b)) {
                        if (0 !== $364a0b1eab5991a3$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $364a0b1eab5991a3$var$L();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $364a0b1eab5991a3$var$Ff($364a0b1eab5991a3$var$Qk.bind(null, a, $364a0b1eab5991a3$var$uk, $364a0b1eab5991a3$var$vk), b);
                        break;
                    }
                    $364a0b1eab5991a3$var$Qk(a, $364a0b1eab5991a3$var$uk, $364a0b1eab5991a3$var$vk);
                    break;
                case 4:
                    $364a0b1eab5991a3$var$Dk(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $364a0b1eab5991a3$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $364a0b1eab5991a3$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $364a0b1eab5991a3$var$mk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $364a0b1eab5991a3$var$Ff($364a0b1eab5991a3$var$Qk.bind(null, a, $364a0b1eab5991a3$var$uk, $364a0b1eab5991a3$var$vk), d);
                        break;
                    }
                    $364a0b1eab5991a3$var$Qk(a, $364a0b1eab5991a3$var$uk, $364a0b1eab5991a3$var$vk);
                    break;
                case 5:
                    $364a0b1eab5991a3$var$Qk(a, $364a0b1eab5991a3$var$uk, $364a0b1eab5991a3$var$vk);
                    break;
                default:
                    throw Error($364a0b1eab5991a3$var$p(329));
            }
        }
    }
    $364a0b1eab5991a3$var$Ek(a, $364a0b1eab5991a3$var$B());
    return a.callbackNode === c ? $364a0b1eab5991a3$var$Hk.bind(null, a) : null;
}
function $364a0b1eab5991a3$var$Ok(a, b) {
    var c = $364a0b1eab5991a3$var$tk;
    a.current.memoizedState.isDehydrated && ($364a0b1eab5991a3$var$Lk(a, b).flags |= 256);
    a = $364a0b1eab5991a3$var$Jk(a, b);
    2 !== a && (b = $364a0b1eab5991a3$var$uk, $364a0b1eab5991a3$var$uk = c, null !== b && $364a0b1eab5991a3$var$Gj(b));
    return a;
}
function $364a0b1eab5991a3$var$Gj(a) {
    null === $364a0b1eab5991a3$var$uk ? $364a0b1eab5991a3$var$uk = a : $364a0b1eab5991a3$var$uk.push.apply($364a0b1eab5991a3$var$uk, a);
}
function $364a0b1eab5991a3$var$Pk(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$364a0b1eab5991a3$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $364a0b1eab5991a3$var$Dk(a, b) {
    b &= ~$364a0b1eab5991a3$var$sk;
    b &= ~$364a0b1eab5991a3$var$rk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $364a0b1eab5991a3$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $364a0b1eab5991a3$var$Fk(a) {
    if (0 !== ($364a0b1eab5991a3$var$K & 6)) throw Error($364a0b1eab5991a3$var$p(327));
    $364a0b1eab5991a3$var$Ik();
    var b = $364a0b1eab5991a3$var$uc(a, 0);
    if (0 === (b & 1)) return $364a0b1eab5991a3$var$Ek(a, $364a0b1eab5991a3$var$B()), null;
    var c = $364a0b1eab5991a3$var$Jk(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $364a0b1eab5991a3$var$xc(a);
        0 !== d && (b = d, c = $364a0b1eab5991a3$var$Ok(a, d));
    }
    if (1 === c) throw c = $364a0b1eab5991a3$var$qk, $364a0b1eab5991a3$var$Lk(a, 0), $364a0b1eab5991a3$var$Dk(a, b), $364a0b1eab5991a3$var$Ek(a, $364a0b1eab5991a3$var$B()), c;
    if (6 === c) throw Error($364a0b1eab5991a3$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $364a0b1eab5991a3$var$Qk(a, $364a0b1eab5991a3$var$uk, $364a0b1eab5991a3$var$vk);
    $364a0b1eab5991a3$var$Ek(a, $364a0b1eab5991a3$var$B());
    return null;
}
function $364a0b1eab5991a3$var$Rk(a, b) {
    var c = $364a0b1eab5991a3$var$K;
    $364a0b1eab5991a3$var$K |= 1;
    try {
        return a(b);
    } finally{
        $364a0b1eab5991a3$var$K = c, 0 === $364a0b1eab5991a3$var$K && ($364a0b1eab5991a3$var$Hj = $364a0b1eab5991a3$var$B() + 500, $364a0b1eab5991a3$var$fg && $364a0b1eab5991a3$var$jg());
    }
}
function $364a0b1eab5991a3$var$Sk(a) {
    null !== $364a0b1eab5991a3$var$xk && 0 === $364a0b1eab5991a3$var$xk.tag && 0 === ($364a0b1eab5991a3$var$K & 6) && $364a0b1eab5991a3$var$Ik();
    var b = $364a0b1eab5991a3$var$K;
    $364a0b1eab5991a3$var$K |= 1;
    var c = $364a0b1eab5991a3$var$pk.transition, d = $364a0b1eab5991a3$var$C;
    try {
        if ($364a0b1eab5991a3$var$pk.transition = null, $364a0b1eab5991a3$var$C = 1, a) return a();
    } finally{
        $364a0b1eab5991a3$var$C = d, $364a0b1eab5991a3$var$pk.transition = c, $364a0b1eab5991a3$var$K = b, 0 === ($364a0b1eab5991a3$var$K & 6) && $364a0b1eab5991a3$var$jg();
    }
}
function $364a0b1eab5991a3$var$Ij() {
    $364a0b1eab5991a3$var$gj = $364a0b1eab5991a3$var$fj.current;
    $364a0b1eab5991a3$var$E($364a0b1eab5991a3$var$fj);
}
function $364a0b1eab5991a3$var$Lk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $364a0b1eab5991a3$var$Gf(c));
    if (null !== $364a0b1eab5991a3$var$Y) for(c = $364a0b1eab5991a3$var$Y.return; null !== c;){
        var d = c;
        $364a0b1eab5991a3$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $364a0b1eab5991a3$var$$f();
                break;
            case 3:
                $364a0b1eab5991a3$var$Jh();
                $364a0b1eab5991a3$var$E($364a0b1eab5991a3$var$Wf);
                $364a0b1eab5991a3$var$E($364a0b1eab5991a3$var$H);
                $364a0b1eab5991a3$var$Oh();
                break;
            case 5:
                $364a0b1eab5991a3$var$Lh(d);
                break;
            case 4:
                $364a0b1eab5991a3$var$Jh();
                break;
            case 13:
                $364a0b1eab5991a3$var$E($364a0b1eab5991a3$var$M);
                break;
            case 19:
                $364a0b1eab5991a3$var$E($364a0b1eab5991a3$var$M);
                break;
            case 10:
                $364a0b1eab5991a3$var$Rg(d.type._context);
                break;
            case 22:
            case 23:
                $364a0b1eab5991a3$var$Ij();
        }
        c = c.return;
    }
    $364a0b1eab5991a3$var$R = a;
    $364a0b1eab5991a3$var$Y = a = $364a0b1eab5991a3$var$wh(a.current, null);
    $364a0b1eab5991a3$var$Z = $364a0b1eab5991a3$var$gj = b;
    $364a0b1eab5991a3$var$T = 0;
    $364a0b1eab5991a3$var$qk = null;
    $364a0b1eab5991a3$var$sk = $364a0b1eab5991a3$var$rk = $364a0b1eab5991a3$var$hh = 0;
    $364a0b1eab5991a3$var$uk = $364a0b1eab5991a3$var$tk = null;
    if (null !== $364a0b1eab5991a3$var$Wg) {
        for(b = 0; b < $364a0b1eab5991a3$var$Wg.length; b++)if (c = $364a0b1eab5991a3$var$Wg[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $364a0b1eab5991a3$var$Wg = null;
    }
    return a;
}
function $364a0b1eab5991a3$var$Nk(a, b) {
    do {
        var c = $364a0b1eab5991a3$var$Y;
        try {
            $364a0b1eab5991a3$var$Qg();
            $364a0b1eab5991a3$var$Ph.current = $364a0b1eab5991a3$var$ai;
            if ($364a0b1eab5991a3$var$Sh) {
                for(var d = $364a0b1eab5991a3$var$N.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $364a0b1eab5991a3$var$Sh = !1;
            }
            $364a0b1eab5991a3$var$Rh = 0;
            $364a0b1eab5991a3$var$P = $364a0b1eab5991a3$var$O = $364a0b1eab5991a3$var$N = null;
            $364a0b1eab5991a3$var$Th = !1;
            $364a0b1eab5991a3$var$Uh = 0;
            $364a0b1eab5991a3$var$ok.current = null;
            if (null === c || null === c.return) {
                $364a0b1eab5991a3$var$T = 1;
                $364a0b1eab5991a3$var$qk = b;
                $364a0b1eab5991a3$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $364a0b1eab5991a3$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $364a0b1eab5991a3$var$Vi(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $364a0b1eab5991a3$var$Wi(y, g, h, f, b);
                        y.mode & 1 && $364a0b1eab5991a3$var$Ti(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $364a0b1eab5991a3$var$Ti(f, l, b);
                            $364a0b1eab5991a3$var$uj();
                            break a;
                        }
                        k = Error($364a0b1eab5991a3$var$p(426));
                    }
                } else if ($364a0b1eab5991a3$var$I && h.mode & 1) {
                    var J = $364a0b1eab5991a3$var$Vi(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $364a0b1eab5991a3$var$Wi(J, g, h, f, b);
                        $364a0b1eab5991a3$var$Jg($364a0b1eab5991a3$var$Ki(k, h));
                        break a;
                    }
                }
                f = k = $364a0b1eab5991a3$var$Ki(k, h);
                4 !== $364a0b1eab5991a3$var$T && ($364a0b1eab5991a3$var$T = 2);
                null === $364a0b1eab5991a3$var$tk ? $364a0b1eab5991a3$var$tk = [
                    f
                ] : $364a0b1eab5991a3$var$tk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $364a0b1eab5991a3$var$Oi(f, k, b);
                            $364a0b1eab5991a3$var$fh(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $364a0b1eab5991a3$var$Si || !$364a0b1eab5991a3$var$Si.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $364a0b1eab5991a3$var$Ri(f, h, b);
                                $364a0b1eab5991a3$var$fh(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $364a0b1eab5991a3$var$Tk(c);
        } catch (na) {
            b = na;
            $364a0b1eab5991a3$var$Y === c && null !== c && ($364a0b1eab5991a3$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $364a0b1eab5991a3$var$Kk() {
    var a = $364a0b1eab5991a3$var$nk.current;
    $364a0b1eab5991a3$var$nk.current = $364a0b1eab5991a3$var$ai;
    return null === a ? $364a0b1eab5991a3$var$ai : a;
}
function $364a0b1eab5991a3$var$uj() {
    if (0 === $364a0b1eab5991a3$var$T || 3 === $364a0b1eab5991a3$var$T || 2 === $364a0b1eab5991a3$var$T) $364a0b1eab5991a3$var$T = 4;
    null === $364a0b1eab5991a3$var$R || 0 === ($364a0b1eab5991a3$var$hh & 268435455) && 0 === ($364a0b1eab5991a3$var$rk & 268435455) || $364a0b1eab5991a3$var$Dk($364a0b1eab5991a3$var$R, $364a0b1eab5991a3$var$Z);
}
function $364a0b1eab5991a3$var$Jk(a, b) {
    var c = $364a0b1eab5991a3$var$K;
    $364a0b1eab5991a3$var$K |= 2;
    var d = $364a0b1eab5991a3$var$Kk();
    if ($364a0b1eab5991a3$var$R !== a || $364a0b1eab5991a3$var$Z !== b) $364a0b1eab5991a3$var$vk = null, $364a0b1eab5991a3$var$Lk(a, b);
    for(;;)try {
        $364a0b1eab5991a3$var$Uk();
        break;
    } catch (e) {
        $364a0b1eab5991a3$var$Nk(a, e);
    }
    $364a0b1eab5991a3$var$Qg();
    $364a0b1eab5991a3$var$K = c;
    $364a0b1eab5991a3$var$nk.current = d;
    if (null !== $364a0b1eab5991a3$var$Y) throw Error($364a0b1eab5991a3$var$p(261));
    $364a0b1eab5991a3$var$R = null;
    $364a0b1eab5991a3$var$Z = 0;
    return $364a0b1eab5991a3$var$T;
}
function $364a0b1eab5991a3$var$Uk() {
    for(; null !== $364a0b1eab5991a3$var$Y;)$364a0b1eab5991a3$var$Vk($364a0b1eab5991a3$var$Y);
}
function $364a0b1eab5991a3$var$Mk() {
    for(; null !== $364a0b1eab5991a3$var$Y && !$364a0b1eab5991a3$var$cc();)$364a0b1eab5991a3$var$Vk($364a0b1eab5991a3$var$Y);
}
function $364a0b1eab5991a3$var$Vk(a) {
    var b = $364a0b1eab5991a3$var$Wk(a.alternate, a, $364a0b1eab5991a3$var$gj);
    a.memoizedProps = a.pendingProps;
    null === b ? $364a0b1eab5991a3$var$Tk(a) : $364a0b1eab5991a3$var$Y = b;
    $364a0b1eab5991a3$var$ok.current = null;
}
function $364a0b1eab5991a3$var$Tk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $364a0b1eab5991a3$var$Fj(c, b, $364a0b1eab5991a3$var$gj), null !== c) {
                $364a0b1eab5991a3$var$Y = c;
                return;
            }
        } else {
            c = $364a0b1eab5991a3$var$Jj(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $364a0b1eab5991a3$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $364a0b1eab5991a3$var$T = 6;
                $364a0b1eab5991a3$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $364a0b1eab5991a3$var$Y = b;
            return;
        }
        $364a0b1eab5991a3$var$Y = b = a;
    }while (null !== b);
    0 === $364a0b1eab5991a3$var$T && ($364a0b1eab5991a3$var$T = 5);
}
function $364a0b1eab5991a3$var$Qk(a, b, c) {
    var d = $364a0b1eab5991a3$var$C, e = $364a0b1eab5991a3$var$pk.transition;
    try {
        $364a0b1eab5991a3$var$pk.transition = null, $364a0b1eab5991a3$var$C = 1, $364a0b1eab5991a3$var$Xk(a, b, c, d);
    } finally{
        $364a0b1eab5991a3$var$pk.transition = e, $364a0b1eab5991a3$var$C = d;
    }
    return null;
}
function $364a0b1eab5991a3$var$Xk(a, b, c, d) {
    do $364a0b1eab5991a3$var$Ik();
    while (null !== $364a0b1eab5991a3$var$xk);
    if (0 !== ($364a0b1eab5991a3$var$K & 6)) throw Error($364a0b1eab5991a3$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($364a0b1eab5991a3$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $364a0b1eab5991a3$var$Bc(a, f);
    a === $364a0b1eab5991a3$var$R && ($364a0b1eab5991a3$var$Y = $364a0b1eab5991a3$var$R = null, $364a0b1eab5991a3$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $364a0b1eab5991a3$var$wk || ($364a0b1eab5991a3$var$wk = !0, $364a0b1eab5991a3$var$Gk($364a0b1eab5991a3$var$hc, function() {
        $364a0b1eab5991a3$var$Ik();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $364a0b1eab5991a3$var$pk.transition;
        $364a0b1eab5991a3$var$pk.transition = null;
        var g = $364a0b1eab5991a3$var$C;
        $364a0b1eab5991a3$var$C = 1;
        var h = $364a0b1eab5991a3$var$K;
        $364a0b1eab5991a3$var$K |= 4;
        $364a0b1eab5991a3$var$ok.current = null;
        $364a0b1eab5991a3$var$Pj(a, c);
        $364a0b1eab5991a3$var$ek(c, a);
        $364a0b1eab5991a3$var$Oe($364a0b1eab5991a3$var$Df);
        $364a0b1eab5991a3$var$dd = !!$364a0b1eab5991a3$var$Cf;
        $364a0b1eab5991a3$var$Df = $364a0b1eab5991a3$var$Cf = null;
        a.current = c;
        $364a0b1eab5991a3$var$ik(c, a, e);
        $364a0b1eab5991a3$var$dc();
        $364a0b1eab5991a3$var$K = h;
        $364a0b1eab5991a3$var$C = g;
        $364a0b1eab5991a3$var$pk.transition = f;
    } else a.current = c;
    $364a0b1eab5991a3$var$wk && ($364a0b1eab5991a3$var$wk = !1, $364a0b1eab5991a3$var$xk = a, $364a0b1eab5991a3$var$yk = e);
    f = a.pendingLanes;
    0 === f && ($364a0b1eab5991a3$var$Si = null);
    $364a0b1eab5991a3$var$mc(c.stateNode, d);
    $364a0b1eab5991a3$var$Ek(a, $364a0b1eab5991a3$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($364a0b1eab5991a3$var$Pi) throw $364a0b1eab5991a3$var$Pi = !1, a = $364a0b1eab5991a3$var$Qi, $364a0b1eab5991a3$var$Qi = null, a;
    0 !== ($364a0b1eab5991a3$var$yk & 1) && 0 !== a.tag && $364a0b1eab5991a3$var$Ik();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $364a0b1eab5991a3$var$Ak ? $364a0b1eab5991a3$var$zk++ : ($364a0b1eab5991a3$var$zk = 0, $364a0b1eab5991a3$var$Ak = a) : $364a0b1eab5991a3$var$zk = 0;
    $364a0b1eab5991a3$var$jg();
    return null;
}
function $364a0b1eab5991a3$var$Ik() {
    if (null !== $364a0b1eab5991a3$var$xk) {
        var a = $364a0b1eab5991a3$var$Dc($364a0b1eab5991a3$var$yk), b = $364a0b1eab5991a3$var$pk.transition, c = $364a0b1eab5991a3$var$C;
        try {
            $364a0b1eab5991a3$var$pk.transition = null;
            $364a0b1eab5991a3$var$C = 16 > a ? 16 : a;
            if (null === $364a0b1eab5991a3$var$xk) var d = !1;
            else {
                a = $364a0b1eab5991a3$var$xk;
                $364a0b1eab5991a3$var$xk = null;
                $364a0b1eab5991a3$var$yk = 0;
                if (0 !== ($364a0b1eab5991a3$var$K & 6)) throw Error($364a0b1eab5991a3$var$p(331));
                var e = $364a0b1eab5991a3$var$K;
                $364a0b1eab5991a3$var$K |= 4;
                for($364a0b1eab5991a3$var$V = a.current; null !== $364a0b1eab5991a3$var$V;){
                    var f = $364a0b1eab5991a3$var$V, g = f.child;
                    if (0 !== ($364a0b1eab5991a3$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($364a0b1eab5991a3$var$V = l; null !== $364a0b1eab5991a3$var$V;){
                                    var m = $364a0b1eab5991a3$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $364a0b1eab5991a3$var$Qj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $364a0b1eab5991a3$var$V = q;
                                    else for(; null !== $364a0b1eab5991a3$var$V;){
                                        m = $364a0b1eab5991a3$var$V;
                                        var r = m.sibling, y = m.return;
                                        $364a0b1eab5991a3$var$Tj(m);
                                        if (m === l) {
                                            $364a0b1eab5991a3$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $364a0b1eab5991a3$var$V = r;
                                            break;
                                        }
                                        $364a0b1eab5991a3$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $364a0b1eab5991a3$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $364a0b1eab5991a3$var$V = g;
                    else b: for(; null !== $364a0b1eab5991a3$var$V;){
                        f = $364a0b1eab5991a3$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $364a0b1eab5991a3$var$Qj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $364a0b1eab5991a3$var$V = x;
                            break b;
                        }
                        $364a0b1eab5991a3$var$V = f.return;
                    }
                }
                var w = a.current;
                for($364a0b1eab5991a3$var$V = w; null !== $364a0b1eab5991a3$var$V;){
                    g = $364a0b1eab5991a3$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $364a0b1eab5991a3$var$V = u;
                    else b: for(g = w; null !== $364a0b1eab5991a3$var$V;){
                        h = $364a0b1eab5991a3$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $364a0b1eab5991a3$var$Rj(9, h);
                            }
                        } catch (na) {
                            $364a0b1eab5991a3$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $364a0b1eab5991a3$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $364a0b1eab5991a3$var$V = F;
                            break b;
                        }
                        $364a0b1eab5991a3$var$V = h.return;
                    }
                }
                $364a0b1eab5991a3$var$K = e;
                $364a0b1eab5991a3$var$jg();
                if ($364a0b1eab5991a3$var$lc && "function" === typeof $364a0b1eab5991a3$var$lc.onPostCommitFiberRoot) try {
                    $364a0b1eab5991a3$var$lc.onPostCommitFiberRoot($364a0b1eab5991a3$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $364a0b1eab5991a3$var$C = c, $364a0b1eab5991a3$var$pk.transition = b;
        }
    }
    return !1;
}
function $364a0b1eab5991a3$var$Yk(a, b, c) {
    b = $364a0b1eab5991a3$var$Ki(c, b);
    b = $364a0b1eab5991a3$var$Oi(a, b, 1);
    a = $364a0b1eab5991a3$var$dh(a, b, 1);
    b = $364a0b1eab5991a3$var$L();
    null !== a && ($364a0b1eab5991a3$var$Ac(a, 1, b), $364a0b1eab5991a3$var$Ek(a, b));
}
function $364a0b1eab5991a3$var$W(a, b, c) {
    if (3 === a.tag) $364a0b1eab5991a3$var$Yk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $364a0b1eab5991a3$var$Yk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $364a0b1eab5991a3$var$Si || !$364a0b1eab5991a3$var$Si.has(d))) {
                a = $364a0b1eab5991a3$var$Ki(c, a);
                a = $364a0b1eab5991a3$var$Ri(b, a, 1);
                b = $364a0b1eab5991a3$var$dh(b, a, 1);
                a = $364a0b1eab5991a3$var$L();
                null !== b && ($364a0b1eab5991a3$var$Ac(b, 1, a), $364a0b1eab5991a3$var$Ek(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $364a0b1eab5991a3$var$Ui(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $364a0b1eab5991a3$var$L();
    a.pingedLanes |= a.suspendedLanes & c;
    $364a0b1eab5991a3$var$R === a && ($364a0b1eab5991a3$var$Z & c) === c && (4 === $364a0b1eab5991a3$var$T || 3 === $364a0b1eab5991a3$var$T && ($364a0b1eab5991a3$var$Z & 130023424) === $364a0b1eab5991a3$var$Z && 500 > $364a0b1eab5991a3$var$B() - $364a0b1eab5991a3$var$gk ? $364a0b1eab5991a3$var$Lk(a, 0) : $364a0b1eab5991a3$var$sk |= c);
    $364a0b1eab5991a3$var$Ek(a, b);
}
function $364a0b1eab5991a3$var$Zk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $364a0b1eab5991a3$var$sc, $364a0b1eab5991a3$var$sc <<= 1, 0 === ($364a0b1eab5991a3$var$sc & 130023424) && ($364a0b1eab5991a3$var$sc = 4194304)));
    var c = $364a0b1eab5991a3$var$L();
    a = $364a0b1eab5991a3$var$Zg(a, b);
    null !== a && ($364a0b1eab5991a3$var$Ac(a, b, c), $364a0b1eab5991a3$var$Ek(a, c));
}
function $364a0b1eab5991a3$var$vj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $364a0b1eab5991a3$var$Zk(a, c);
}
function $364a0b1eab5991a3$var$ck(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($364a0b1eab5991a3$var$p(314));
    }
    null !== d && d.delete(b);
    $364a0b1eab5991a3$var$Zk(a, c);
}
var $364a0b1eab5991a3$var$Wk;
$364a0b1eab5991a3$var$Wk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $364a0b1eab5991a3$var$Wf.current) $364a0b1eab5991a3$var$Ug = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $364a0b1eab5991a3$var$Ug = !1, $364a0b1eab5991a3$var$zj(a, b, c);
            $364a0b1eab5991a3$var$Ug = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $364a0b1eab5991a3$var$Ug = !1, $364a0b1eab5991a3$var$I && 0 !== (b.flags & 1048576) && $364a0b1eab5991a3$var$ug(b, $364a0b1eab5991a3$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $364a0b1eab5991a3$var$jj(a, b);
            a = b.pendingProps;
            var e = $364a0b1eab5991a3$var$Yf(b, $364a0b1eab5991a3$var$H.current);
            $364a0b1eab5991a3$var$Tg(b, c);
            e = $364a0b1eab5991a3$var$Xh(null, b, d, a, e, c);
            var f = $364a0b1eab5991a3$var$bi();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $364a0b1eab5991a3$var$Zf(d) ? (f = !0, $364a0b1eab5991a3$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $364a0b1eab5991a3$var$ah(b), e.updater = $364a0b1eab5991a3$var$nh, b.stateNode = e, e._reactInternals = b, $364a0b1eab5991a3$var$rh(b, d, a, c), b = $364a0b1eab5991a3$var$kj(null, b, d, !0, f, c)) : (b.tag = 0, $364a0b1eab5991a3$var$I && f && $364a0b1eab5991a3$var$vg(b), $364a0b1eab5991a3$var$Yi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $364a0b1eab5991a3$var$jj(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $364a0b1eab5991a3$var$$k(d);
                a = $364a0b1eab5991a3$var$Lg(d, a);
                switch(e){
                    case 0:
                        b = $364a0b1eab5991a3$var$dj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $364a0b1eab5991a3$var$ij(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $364a0b1eab5991a3$var$Zi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $364a0b1eab5991a3$var$aj(null, b, d, $364a0b1eab5991a3$var$Lg(d.type, a), c);
                        break a;
                }
                throw Error($364a0b1eab5991a3$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $364a0b1eab5991a3$var$Lg(d, e), $364a0b1eab5991a3$var$dj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $364a0b1eab5991a3$var$Lg(d, e), $364a0b1eab5991a3$var$ij(a, b, d, e, c);
        case 3:
            a: {
                $364a0b1eab5991a3$var$lj(b);
                if (null === a) throw Error($364a0b1eab5991a3$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $364a0b1eab5991a3$var$bh(a, b);
                $364a0b1eab5991a3$var$gh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $364a0b1eab5991a3$var$Ki(Error($364a0b1eab5991a3$var$p(423)), b);
                        b = $364a0b1eab5991a3$var$mj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $364a0b1eab5991a3$var$Ki(Error($364a0b1eab5991a3$var$p(424)), b);
                        b = $364a0b1eab5991a3$var$mj(a, b, d, c, e);
                        break a;
                    } else for($364a0b1eab5991a3$var$yg = $364a0b1eab5991a3$var$Lf(b.stateNode.containerInfo.firstChild), $364a0b1eab5991a3$var$xg = b, $364a0b1eab5991a3$var$I = !0, $364a0b1eab5991a3$var$zg = null, c = $364a0b1eab5991a3$var$Ch(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $364a0b1eab5991a3$var$Ig();
                    if (d === e) {
                        b = $364a0b1eab5991a3$var$$i(a, b, c);
                        break a;
                    }
                    $364a0b1eab5991a3$var$Yi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $364a0b1eab5991a3$var$Kh(b), null === a && $364a0b1eab5991a3$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $364a0b1eab5991a3$var$Ef(d, e) ? g = null : null !== f && $364a0b1eab5991a3$var$Ef(d, f) && (b.flags |= 32), $364a0b1eab5991a3$var$hj(a, b), $364a0b1eab5991a3$var$Yi(a, b, g, c), b.child;
        case 6:
            return null === a && $364a0b1eab5991a3$var$Eg(b), null;
        case 13:
            return $364a0b1eab5991a3$var$pj(a, b, c);
        case 4:
            return $364a0b1eab5991a3$var$Ih(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $364a0b1eab5991a3$var$Bh(b, null, d, c) : $364a0b1eab5991a3$var$Yi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $364a0b1eab5991a3$var$Lg(d, e), $364a0b1eab5991a3$var$Zi(a, b, d, e, c);
        case 7:
            return $364a0b1eab5991a3$var$Yi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $364a0b1eab5991a3$var$Yi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $364a0b1eab5991a3$var$Yi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $364a0b1eab5991a3$var$G($364a0b1eab5991a3$var$Mg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($364a0b1eab5991a3$var$He(f.value, g)) {
                        if (f.children === e.children && !$364a0b1eab5991a3$var$Wf.current) {
                            b = $364a0b1eab5991a3$var$$i(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $364a0b1eab5991a3$var$ch(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $364a0b1eab5991a3$var$Sg(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($364a0b1eab5991a3$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $364a0b1eab5991a3$var$Sg(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $364a0b1eab5991a3$var$Yi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $364a0b1eab5991a3$var$Tg(b, c), e = $364a0b1eab5991a3$var$Vg(e), d = d(e), b.flags |= 1, $364a0b1eab5991a3$var$Yi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $364a0b1eab5991a3$var$Lg(d, b.pendingProps), e = $364a0b1eab5991a3$var$Lg(d.type, e), $364a0b1eab5991a3$var$aj(a, b, d, e, c);
        case 15:
            return $364a0b1eab5991a3$var$cj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $364a0b1eab5991a3$var$Lg(d, e), $364a0b1eab5991a3$var$jj(a, b), b.tag = 1, $364a0b1eab5991a3$var$Zf(d) ? (a = !0, $364a0b1eab5991a3$var$cg(b)) : a = !1, $364a0b1eab5991a3$var$Tg(b, c), $364a0b1eab5991a3$var$ph(b, d, e), $364a0b1eab5991a3$var$rh(b, d, e, c), $364a0b1eab5991a3$var$kj(null, b, d, !0, a, c);
        case 19:
            return $364a0b1eab5991a3$var$yj(a, b, c);
        case 22:
            return $364a0b1eab5991a3$var$ej(a, b, c);
    }
    throw Error($364a0b1eab5991a3$var$p(156, b.tag));
};
function $364a0b1eab5991a3$var$Gk(a, b) {
    return $364a0b1eab5991a3$var$ac(a, b);
}
function $364a0b1eab5991a3$var$al(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $364a0b1eab5991a3$var$Bg(a, b, c, d) {
    return new $364a0b1eab5991a3$var$al(a, b, c, d);
}
function $364a0b1eab5991a3$var$bj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $364a0b1eab5991a3$var$$k(a) {
    if ("function" === typeof a) return $364a0b1eab5991a3$var$bj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $364a0b1eab5991a3$var$Da) return 11;
        if (a === $364a0b1eab5991a3$var$Ga) return 14;
    }
    return 2;
}
function $364a0b1eab5991a3$var$wh(a, b) {
    var c = a.alternate;
    null === c ? (c = $364a0b1eab5991a3$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $364a0b1eab5991a3$var$yh(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $364a0b1eab5991a3$var$bj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $364a0b1eab5991a3$var$ya:
            return $364a0b1eab5991a3$var$Ah(c.children, e, f, b);
        case $364a0b1eab5991a3$var$za:
            g = 8;
            e |= 8;
            break;
        case $364a0b1eab5991a3$var$Aa:
            return a = $364a0b1eab5991a3$var$Bg(12, c, b, e | 2), a.elementType = $364a0b1eab5991a3$var$Aa, a.lanes = f, a;
        case $364a0b1eab5991a3$var$Ea:
            return a = $364a0b1eab5991a3$var$Bg(13, c, b, e), a.elementType = $364a0b1eab5991a3$var$Ea, a.lanes = f, a;
        case $364a0b1eab5991a3$var$Fa:
            return a = $364a0b1eab5991a3$var$Bg(19, c, b, e), a.elementType = $364a0b1eab5991a3$var$Fa, a.lanes = f, a;
        case $364a0b1eab5991a3$var$Ia:
            return $364a0b1eab5991a3$var$qj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $364a0b1eab5991a3$var$Ba:
                    g = 10;
                    break a;
                case $364a0b1eab5991a3$var$Ca:
                    g = 9;
                    break a;
                case $364a0b1eab5991a3$var$Da:
                    g = 11;
                    break a;
                case $364a0b1eab5991a3$var$Ga:
                    g = 14;
                    break a;
                case $364a0b1eab5991a3$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($364a0b1eab5991a3$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $364a0b1eab5991a3$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $364a0b1eab5991a3$var$Ah(a, b, c, d) {
    a = $364a0b1eab5991a3$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $364a0b1eab5991a3$var$qj(a, b, c, d) {
    a = $364a0b1eab5991a3$var$Bg(22, a, d, b);
    a.elementType = $364a0b1eab5991a3$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $364a0b1eab5991a3$var$xh(a, b, c) {
    a = $364a0b1eab5991a3$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $364a0b1eab5991a3$var$zh(a, b, c) {
    b = $364a0b1eab5991a3$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $364a0b1eab5991a3$var$bl(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $364a0b1eab5991a3$var$zc(0);
    this.expirationTimes = $364a0b1eab5991a3$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $364a0b1eab5991a3$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $364a0b1eab5991a3$var$cl(a, b, c, d, e, f, g, h, k) {
    a = new $364a0b1eab5991a3$var$bl(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $364a0b1eab5991a3$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $364a0b1eab5991a3$var$ah(f);
    return a;
}
function $364a0b1eab5991a3$var$dl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $364a0b1eab5991a3$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $364a0b1eab5991a3$var$el(a) {
    if (!a) return $364a0b1eab5991a3$var$Vf;
    a = a._reactInternals;
    a: {
        if ($364a0b1eab5991a3$var$Vb(a) !== a || 1 !== a.tag) throw Error($364a0b1eab5991a3$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($364a0b1eab5991a3$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($364a0b1eab5991a3$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($364a0b1eab5991a3$var$Zf(c)) return $364a0b1eab5991a3$var$bg(a, c, b);
    }
    return b;
}
function $364a0b1eab5991a3$var$fl(a, b, c, d, e, f, g, h, k) {
    a = $364a0b1eab5991a3$var$cl(c, d, !0, a, e, f, g, h, k);
    a.context = $364a0b1eab5991a3$var$el(null);
    c = a.current;
    d = $364a0b1eab5991a3$var$L();
    e = $364a0b1eab5991a3$var$lh(c);
    f = $364a0b1eab5991a3$var$ch(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $364a0b1eab5991a3$var$dh(c, f, e);
    a.current.lanes = e;
    $364a0b1eab5991a3$var$Ac(a, e, d);
    $364a0b1eab5991a3$var$Ek(a, d);
    return a;
}
function $364a0b1eab5991a3$var$gl(a, b, c, d) {
    var e = b.current, f = $364a0b1eab5991a3$var$L(), g = $364a0b1eab5991a3$var$lh(e);
    c = $364a0b1eab5991a3$var$el(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $364a0b1eab5991a3$var$ch(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $364a0b1eab5991a3$var$dh(e, b, g);
    null !== a && ($364a0b1eab5991a3$var$mh(a, e, g, f), $364a0b1eab5991a3$var$eh(a, e, g));
    return g;
}
function $364a0b1eab5991a3$var$hl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $364a0b1eab5991a3$var$il(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $364a0b1eab5991a3$var$jl(a, b) {
    $364a0b1eab5991a3$var$il(a, b);
    (a = a.alternate) && $364a0b1eab5991a3$var$il(a, b);
}
function $364a0b1eab5991a3$var$kl() {
    return null;
}
var $364a0b1eab5991a3$var$ll = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $364a0b1eab5991a3$var$ml(a) {
    this._internalRoot = a;
}
$364a0b1eab5991a3$var$nl.prototype.render = $364a0b1eab5991a3$var$ml.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($364a0b1eab5991a3$var$p(409));
    $364a0b1eab5991a3$var$gl(a, b, null, null);
};
$364a0b1eab5991a3$var$nl.prototype.unmount = $364a0b1eab5991a3$var$ml.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $364a0b1eab5991a3$var$Sk(function() {
            $364a0b1eab5991a3$var$gl(null, a, null, null);
        });
        b[$364a0b1eab5991a3$var$uf] = null;
    }
};
function $364a0b1eab5991a3$var$nl(a) {
    this._internalRoot = a;
}
$364a0b1eab5991a3$var$nl.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $364a0b1eab5991a3$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $364a0b1eab5991a3$var$Qc.length && 0 !== b && b < $364a0b1eab5991a3$var$Qc[c].priority; c++);
        $364a0b1eab5991a3$var$Qc.splice(c, 0, a);
        0 === c && $364a0b1eab5991a3$var$Vc(a);
    }
};
function $364a0b1eab5991a3$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $364a0b1eab5991a3$var$pl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $364a0b1eab5991a3$var$ql() {}
function $364a0b1eab5991a3$var$rl(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $364a0b1eab5991a3$var$hl(g);
                f.call(a);
            };
        }
        var g = $364a0b1eab5991a3$var$fl(b, d, a, 0, null, !1, !1, "", $364a0b1eab5991a3$var$ql);
        a._reactRootContainer = g;
        a[$364a0b1eab5991a3$var$uf] = g.current;
        $364a0b1eab5991a3$var$sf(8 === a.nodeType ? a.parentNode : a);
        $364a0b1eab5991a3$var$Sk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $364a0b1eab5991a3$var$hl(k);
            h.call(a);
        };
    }
    var k = $364a0b1eab5991a3$var$cl(a, 0, !1, null, null, !1, !1, "", $364a0b1eab5991a3$var$ql);
    a._reactRootContainer = k;
    a[$364a0b1eab5991a3$var$uf] = k.current;
    $364a0b1eab5991a3$var$sf(8 === a.nodeType ? a.parentNode : a);
    $364a0b1eab5991a3$var$Sk(function() {
        $364a0b1eab5991a3$var$gl(b, k, c, d);
    });
    return k;
}
function $364a0b1eab5991a3$var$sl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $364a0b1eab5991a3$var$hl(g);
                h.call(a);
            };
        }
        $364a0b1eab5991a3$var$gl(b, g, a, e);
    } else g = $364a0b1eab5991a3$var$rl(c, b, a, e, d);
    return $364a0b1eab5991a3$var$hl(g);
}
$364a0b1eab5991a3$var$Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $364a0b1eab5991a3$var$tc(b.pendingLanes);
                0 !== c && ($364a0b1eab5991a3$var$Cc(b, c | 1), $364a0b1eab5991a3$var$Ek(b, $364a0b1eab5991a3$var$B()), 0 === ($364a0b1eab5991a3$var$K & 6) && ($364a0b1eab5991a3$var$Hj = $364a0b1eab5991a3$var$B() + 500, $364a0b1eab5991a3$var$jg()));
            }
            break;
        case 13:
            $364a0b1eab5991a3$var$Sk(function() {
                var b = $364a0b1eab5991a3$var$Zg(a, 1);
                if (null !== b) {
                    var c = $364a0b1eab5991a3$var$L();
                    $364a0b1eab5991a3$var$mh(b, a, 1, c);
                }
            }), $364a0b1eab5991a3$var$jl(a, 1);
    }
};
$364a0b1eab5991a3$var$Fc = function(a) {
    if (13 === a.tag) {
        var b = $364a0b1eab5991a3$var$Zg(a, 134217728);
        if (null !== b) {
            var c = $364a0b1eab5991a3$var$L();
            $364a0b1eab5991a3$var$mh(b, a, 134217728, c);
        }
        $364a0b1eab5991a3$var$jl(a, 134217728);
    }
};
$364a0b1eab5991a3$var$Gc = function(a) {
    if (13 === a.tag) {
        var b = $364a0b1eab5991a3$var$lh(a), c = $364a0b1eab5991a3$var$Zg(a, b);
        if (null !== c) {
            var d = $364a0b1eab5991a3$var$L();
            $364a0b1eab5991a3$var$mh(c, a, b, d);
        }
        $364a0b1eab5991a3$var$jl(a, b);
    }
};
$364a0b1eab5991a3$var$Hc = function() {
    return $364a0b1eab5991a3$var$C;
};
$364a0b1eab5991a3$var$Ic = function(a, b) {
    var c = $364a0b1eab5991a3$var$C;
    try {
        return $364a0b1eab5991a3$var$C = a, b();
    } finally{
        $364a0b1eab5991a3$var$C = c;
    }
};
$364a0b1eab5991a3$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $364a0b1eab5991a3$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $364a0b1eab5991a3$var$Db(d);
                        if (!e) throw Error($364a0b1eab5991a3$var$p(90));
                        $364a0b1eab5991a3$var$Wa(d);
                        $364a0b1eab5991a3$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $364a0b1eab5991a3$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $364a0b1eab5991a3$var$fb(a, !!c.multiple, b, !1);
    }
};
$364a0b1eab5991a3$var$Gb = $364a0b1eab5991a3$var$Rk;
$364a0b1eab5991a3$var$Hb = $364a0b1eab5991a3$var$Sk;
var $364a0b1eab5991a3$var$tl = {
    usingClientEntryPoint: !1,
    Events: [
        $364a0b1eab5991a3$var$Cb,
        $364a0b1eab5991a3$var$ue,
        $364a0b1eab5991a3$var$Db,
        $364a0b1eab5991a3$var$Eb,
        $364a0b1eab5991a3$var$Fb,
        $364a0b1eab5991a3$var$Rk
    ]
}, $364a0b1eab5991a3$var$ul = {
    findFiberByHostInstance: $364a0b1eab5991a3$var$Wc,
    bundleType: 0,
    version: "18.2.0",
    rendererPackageName: "react-dom"
};
var $364a0b1eab5991a3$var$vl = {
    bundleType: $364a0b1eab5991a3$var$ul.bundleType,
    version: $364a0b1eab5991a3$var$ul.version,
    rendererPackageName: $364a0b1eab5991a3$var$ul.rendererPackageName,
    rendererConfig: $364a0b1eab5991a3$var$ul.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $364a0b1eab5991a3$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $364a0b1eab5991a3$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $364a0b1eab5991a3$var$ul.findFiberByHostInstance || $364a0b1eab5991a3$var$kl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.2.0-next-9e3b772b8-20220608"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $364a0b1eab5991a3$var$wl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$364a0b1eab5991a3$var$wl.isDisabled && $364a0b1eab5991a3$var$wl.supportsFiber) try {
        $364a0b1eab5991a3$var$kc = $364a0b1eab5991a3$var$wl.inject($364a0b1eab5991a3$var$vl), $364a0b1eab5991a3$var$lc = $364a0b1eab5991a3$var$wl;
    } catch (a) {}
}
$364a0b1eab5991a3$export$ae55be85d98224ed = $364a0b1eab5991a3$var$tl;
$364a0b1eab5991a3$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$364a0b1eab5991a3$var$ol(b)) throw Error($364a0b1eab5991a3$var$p(200));
    return $364a0b1eab5991a3$var$dl(a, b, null, c);
};
$364a0b1eab5991a3$export$882461b6382ed46c = function(a, b) {
    if (!$364a0b1eab5991a3$var$ol(a)) throw Error($364a0b1eab5991a3$var$p(299));
    var c = !1, d = "", e = $364a0b1eab5991a3$var$ll;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $364a0b1eab5991a3$var$cl(a, 1, !1, null, null, c, !1, d, e);
    a[$364a0b1eab5991a3$var$uf] = b.current;
    $364a0b1eab5991a3$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $364a0b1eab5991a3$var$ml(b);
};
$364a0b1eab5991a3$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($364a0b1eab5991a3$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($364a0b1eab5991a3$var$p(268, a));
    }
    a = $364a0b1eab5991a3$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$364a0b1eab5991a3$export$cd75ccfd720a3cd4 = function(a) {
    return $364a0b1eab5991a3$var$Sk(a);
};
$364a0b1eab5991a3$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$364a0b1eab5991a3$var$pl(b)) throw Error($364a0b1eab5991a3$var$p(200));
    return $364a0b1eab5991a3$var$sl(null, a, b, !0, c);
};
$364a0b1eab5991a3$export$757ceba2d55c277e = function(a, b, c) {
    if (!$364a0b1eab5991a3$var$ol(a)) throw Error($364a0b1eab5991a3$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $364a0b1eab5991a3$var$ll;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $364a0b1eab5991a3$var$fl(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$364a0b1eab5991a3$var$uf] = b.current;
    $364a0b1eab5991a3$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $364a0b1eab5991a3$var$nl(b);
};
$364a0b1eab5991a3$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$364a0b1eab5991a3$var$pl(b)) throw Error($364a0b1eab5991a3$var$p(200));
    return $364a0b1eab5991a3$var$sl(null, a, b, !1, c);
};
$364a0b1eab5991a3$export$502457920280e6be = function(a) {
    if (!$364a0b1eab5991a3$var$pl(a)) throw Error($364a0b1eab5991a3$var$p(40));
    return a._reactRootContainer ? ($364a0b1eab5991a3$var$Sk(function() {
        $364a0b1eab5991a3$var$sl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$364a0b1eab5991a3$var$uf] = null;
        });
    }), !0) : !1;
};
$364a0b1eab5991a3$export$c78a37762a8d58e1 = $364a0b1eab5991a3$var$Rk;
$364a0b1eab5991a3$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$364a0b1eab5991a3$var$pl(c)) throw Error($364a0b1eab5991a3$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($364a0b1eab5991a3$var$p(38));
    return $364a0b1eab5991a3$var$sl(a, b, c, !1, d);
};
$364a0b1eab5991a3$export$83d89fbfd8236492 = "18.2.0-next-9e3b772b8-20220608";

});
parcelRequire.register("93WKs", function(module, exports) {
"use strict";

module.exports = (parcelRequire("9n5yN"));

});
parcelRequire.register("9n5yN", function(module, exports) {

$parcel$export(module.exports, "unstable_now", () => $6d2a933262527b6c$export$c4744153514ff05d, (v) => $6d2a933262527b6c$export$c4744153514ff05d = v);
$parcel$export(module.exports, "unstable_IdlePriority", () => $6d2a933262527b6c$export$3e506c1ccc9cc1a7, (v) => $6d2a933262527b6c$export$3e506c1ccc9cc1a7 = v);
$parcel$export(module.exports, "unstable_ImmediatePriority", () => $6d2a933262527b6c$export$e26fe2ed2fa76875, (v) => $6d2a933262527b6c$export$e26fe2ed2fa76875 = v);
$parcel$export(module.exports, "unstable_LowPriority", () => $6d2a933262527b6c$export$502329bbf4b505b1, (v) => $6d2a933262527b6c$export$502329bbf4b505b1 = v);
$parcel$export(module.exports, "unstable_NormalPriority", () => $6d2a933262527b6c$export$6e3807111c4874c4, (v) => $6d2a933262527b6c$export$6e3807111c4874c4 = v);
$parcel$export(module.exports, "unstable_Profiling", () => $6d2a933262527b6c$export$c27134553091fb3a, (v) => $6d2a933262527b6c$export$c27134553091fb3a = v);
$parcel$export(module.exports, "unstable_UserBlockingPriority", () => $6d2a933262527b6c$export$33ee1acdc04fd2a2, (v) => $6d2a933262527b6c$export$33ee1acdc04fd2a2 = v);
$parcel$export(module.exports, "unstable_cancelCallback", () => $6d2a933262527b6c$export$b00a404bbd5edef2, (v) => $6d2a933262527b6c$export$b00a404bbd5edef2 = v);
$parcel$export(module.exports, "unstable_continueExecution", () => $6d2a933262527b6c$export$8352ce38b91d0c62, (v) => $6d2a933262527b6c$export$8352ce38b91d0c62 = v);
$parcel$export(module.exports, "unstable_forceFrameRate", () => $6d2a933262527b6c$export$d66a1c1c77bd778b, (v) => $6d2a933262527b6c$export$d66a1c1c77bd778b = v);
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", () => $6d2a933262527b6c$export$d3dfb8e4810cb555, (v) => $6d2a933262527b6c$export$d3dfb8e4810cb555 = v);
$parcel$export(module.exports, "unstable_getFirstCallbackNode", () => $6d2a933262527b6c$export$839f9183b0465a69, (v) => $6d2a933262527b6c$export$839f9183b0465a69 = v);
$parcel$export(module.exports, "unstable_next", () => $6d2a933262527b6c$export$72fdf0e06517287b, (v) => $6d2a933262527b6c$export$72fdf0e06517287b = v);
$parcel$export(module.exports, "unstable_pauseExecution", () => $6d2a933262527b6c$export$4b844e58a3e414b4, (v) => $6d2a933262527b6c$export$4b844e58a3e414b4 = v);
$parcel$export(module.exports, "unstable_requestPaint", () => $6d2a933262527b6c$export$816d2913ae6b83b1, (v) => $6d2a933262527b6c$export$816d2913ae6b83b1 = v);
$parcel$export(module.exports, "unstable_runWithPriority", () => $6d2a933262527b6c$export$61bcfe829111a1d0, (v) => $6d2a933262527b6c$export$61bcfe829111a1d0 = v);
$parcel$export(module.exports, "unstable_scheduleCallback", () => $6d2a933262527b6c$export$7ee8c9beb337bc3f, (v) => $6d2a933262527b6c$export$7ee8c9beb337bc3f = v);
$parcel$export(module.exports, "unstable_shouldYield", () => $6d2a933262527b6c$export$b5836b71941fa3ed, (v) => $6d2a933262527b6c$export$b5836b71941fa3ed = v);
$parcel$export(module.exports, "unstable_wrapCallback", () => $6d2a933262527b6c$export$cf845f2c119da08a, (v) => $6d2a933262527b6c$export$cf845f2c119da08a = v);
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $6d2a933262527b6c$export$c4744153514ff05d;
var $6d2a933262527b6c$export$3e506c1ccc9cc1a7;
var $6d2a933262527b6c$export$e26fe2ed2fa76875;
var $6d2a933262527b6c$export$502329bbf4b505b1;
var $6d2a933262527b6c$export$6e3807111c4874c4;
var $6d2a933262527b6c$export$c27134553091fb3a;
var $6d2a933262527b6c$export$33ee1acdc04fd2a2;
var $6d2a933262527b6c$export$b00a404bbd5edef2;
var $6d2a933262527b6c$export$8352ce38b91d0c62;
var $6d2a933262527b6c$export$d66a1c1c77bd778b;
var $6d2a933262527b6c$export$d3dfb8e4810cb555;
var $6d2a933262527b6c$export$839f9183b0465a69;
var $6d2a933262527b6c$export$72fdf0e06517287b;
var $6d2a933262527b6c$export$4b844e58a3e414b4;
var $6d2a933262527b6c$export$816d2913ae6b83b1;
var $6d2a933262527b6c$export$61bcfe829111a1d0;
var $6d2a933262527b6c$export$7ee8c9beb337bc3f;
var $6d2a933262527b6c$export$b5836b71941fa3ed;
var $6d2a933262527b6c$export$cf845f2c119da08a;
"use strict";
function $6d2a933262527b6c$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $6d2a933262527b6c$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $6d2a933262527b6c$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $6d2a933262527b6c$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $6d2a933262527b6c$var$g(C, c)) n < e && 0 > $6d2a933262527b6c$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $6d2a933262527b6c$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $6d2a933262527b6c$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $6d2a933262527b6c$var$l = performance;
    $6d2a933262527b6c$export$c4744153514ff05d = function() {
        return $6d2a933262527b6c$var$l.now();
    };
} else {
    var $6d2a933262527b6c$var$p = Date, $6d2a933262527b6c$var$q = $6d2a933262527b6c$var$p.now();
    $6d2a933262527b6c$export$c4744153514ff05d = function() {
        return $6d2a933262527b6c$var$p.now() - $6d2a933262527b6c$var$q;
    };
}
var $6d2a933262527b6c$var$r = [], $6d2a933262527b6c$var$t = [], $6d2a933262527b6c$var$u = 1, $6d2a933262527b6c$var$v = null, $6d2a933262527b6c$var$y = 3, $6d2a933262527b6c$var$z = !1, $6d2a933262527b6c$var$A = !1, $6d2a933262527b6c$var$B = !1, $6d2a933262527b6c$var$D = "function" === typeof setTimeout ? setTimeout : null, $6d2a933262527b6c$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $6d2a933262527b6c$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $6d2a933262527b6c$var$G(a) {
    for(var b = $6d2a933262527b6c$var$h($6d2a933262527b6c$var$t); null !== b;){
        if (null === b.callback) $6d2a933262527b6c$var$k($6d2a933262527b6c$var$t);
        else if (b.startTime <= a) $6d2a933262527b6c$var$k($6d2a933262527b6c$var$t), b.sortIndex = b.expirationTime, $6d2a933262527b6c$var$f($6d2a933262527b6c$var$r, b);
        else break;
        b = $6d2a933262527b6c$var$h($6d2a933262527b6c$var$t);
    }
}
function $6d2a933262527b6c$var$H(a) {
    $6d2a933262527b6c$var$B = !1;
    $6d2a933262527b6c$var$G(a);
    if (!$6d2a933262527b6c$var$A) {
        if (null !== $6d2a933262527b6c$var$h($6d2a933262527b6c$var$r)) $6d2a933262527b6c$var$A = !0, $6d2a933262527b6c$var$I($6d2a933262527b6c$var$J);
        else {
            var b = $6d2a933262527b6c$var$h($6d2a933262527b6c$var$t);
            null !== b && $6d2a933262527b6c$var$K($6d2a933262527b6c$var$H, b.startTime - a);
        }
    }
}
function $6d2a933262527b6c$var$J(a, b) {
    $6d2a933262527b6c$var$A = !1;
    $6d2a933262527b6c$var$B && ($6d2a933262527b6c$var$B = !1, $6d2a933262527b6c$var$E($6d2a933262527b6c$var$L), $6d2a933262527b6c$var$L = -1);
    $6d2a933262527b6c$var$z = !0;
    var c = $6d2a933262527b6c$var$y;
    try {
        $6d2a933262527b6c$var$G(b);
        for($6d2a933262527b6c$var$v = $6d2a933262527b6c$var$h($6d2a933262527b6c$var$r); null !== $6d2a933262527b6c$var$v && (!($6d2a933262527b6c$var$v.expirationTime > b) || a && !$6d2a933262527b6c$var$M());){
            var d = $6d2a933262527b6c$var$v.callback;
            if ("function" === typeof d) {
                $6d2a933262527b6c$var$v.callback = null;
                $6d2a933262527b6c$var$y = $6d2a933262527b6c$var$v.priorityLevel;
                var e = d($6d2a933262527b6c$var$v.expirationTime <= b);
                b = $6d2a933262527b6c$export$c4744153514ff05d();
                "function" === typeof e ? $6d2a933262527b6c$var$v.callback = e : $6d2a933262527b6c$var$v === $6d2a933262527b6c$var$h($6d2a933262527b6c$var$r) && $6d2a933262527b6c$var$k($6d2a933262527b6c$var$r);
                $6d2a933262527b6c$var$G(b);
            } else $6d2a933262527b6c$var$k($6d2a933262527b6c$var$r);
            $6d2a933262527b6c$var$v = $6d2a933262527b6c$var$h($6d2a933262527b6c$var$r);
        }
        if (null !== $6d2a933262527b6c$var$v) var w = !0;
        else {
            var m = $6d2a933262527b6c$var$h($6d2a933262527b6c$var$t);
            null !== m && $6d2a933262527b6c$var$K($6d2a933262527b6c$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $6d2a933262527b6c$var$v = null, $6d2a933262527b6c$var$y = c, $6d2a933262527b6c$var$z = !1;
    }
}
var $6d2a933262527b6c$var$N = !1, $6d2a933262527b6c$var$O = null, $6d2a933262527b6c$var$L = -1, $6d2a933262527b6c$var$P = 5, $6d2a933262527b6c$var$Q = -1;
function $6d2a933262527b6c$var$M() {
    return $6d2a933262527b6c$export$c4744153514ff05d() - $6d2a933262527b6c$var$Q < $6d2a933262527b6c$var$P ? !1 : !0;
}
function $6d2a933262527b6c$var$R() {
    if (null !== $6d2a933262527b6c$var$O) {
        var a = $6d2a933262527b6c$export$c4744153514ff05d();
        $6d2a933262527b6c$var$Q = a;
        var b = !0;
        try {
            b = $6d2a933262527b6c$var$O(!0, a);
        } finally{
            b ? $6d2a933262527b6c$var$S() : ($6d2a933262527b6c$var$N = !1, $6d2a933262527b6c$var$O = null);
        }
    } else $6d2a933262527b6c$var$N = !1;
}
var $6d2a933262527b6c$var$S;
if ("function" === typeof $6d2a933262527b6c$var$F) $6d2a933262527b6c$var$S = function() {
    $6d2a933262527b6c$var$F($6d2a933262527b6c$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $6d2a933262527b6c$var$T = new MessageChannel, $6d2a933262527b6c$var$U = $6d2a933262527b6c$var$T.port2;
    $6d2a933262527b6c$var$T.port1.onmessage = $6d2a933262527b6c$var$R;
    $6d2a933262527b6c$var$S = function() {
        $6d2a933262527b6c$var$U.postMessage(null);
    };
} else $6d2a933262527b6c$var$S = function() {
    $6d2a933262527b6c$var$D($6d2a933262527b6c$var$R, 0);
};
function $6d2a933262527b6c$var$I(a) {
    $6d2a933262527b6c$var$O = a;
    $6d2a933262527b6c$var$N || ($6d2a933262527b6c$var$N = !0, $6d2a933262527b6c$var$S());
}
function $6d2a933262527b6c$var$K(a, b) {
    $6d2a933262527b6c$var$L = $6d2a933262527b6c$var$D(function() {
        a($6d2a933262527b6c$export$c4744153514ff05d());
    }, b);
}
$6d2a933262527b6c$export$3e506c1ccc9cc1a7 = 5;
$6d2a933262527b6c$export$e26fe2ed2fa76875 = 1;
$6d2a933262527b6c$export$502329bbf4b505b1 = 4;
$6d2a933262527b6c$export$6e3807111c4874c4 = 3;
$6d2a933262527b6c$export$c27134553091fb3a = null;
$6d2a933262527b6c$export$33ee1acdc04fd2a2 = 2;
$6d2a933262527b6c$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$6d2a933262527b6c$export$8352ce38b91d0c62 = function() {
    $6d2a933262527b6c$var$A || $6d2a933262527b6c$var$z || ($6d2a933262527b6c$var$A = !0, $6d2a933262527b6c$var$I($6d2a933262527b6c$var$J));
};
$6d2a933262527b6c$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $6d2a933262527b6c$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$6d2a933262527b6c$export$d3dfb8e4810cb555 = function() {
    return $6d2a933262527b6c$var$y;
};
$6d2a933262527b6c$export$839f9183b0465a69 = function() {
    return $6d2a933262527b6c$var$h($6d2a933262527b6c$var$r);
};
$6d2a933262527b6c$export$72fdf0e06517287b = function(a) {
    switch($6d2a933262527b6c$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $6d2a933262527b6c$var$y;
    }
    var c = $6d2a933262527b6c$var$y;
    $6d2a933262527b6c$var$y = b;
    try {
        return a();
    } finally{
        $6d2a933262527b6c$var$y = c;
    }
};
$6d2a933262527b6c$export$4b844e58a3e414b4 = function() {};
$6d2a933262527b6c$export$816d2913ae6b83b1 = function() {};
$6d2a933262527b6c$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $6d2a933262527b6c$var$y;
    $6d2a933262527b6c$var$y = a;
    try {
        return b();
    } finally{
        $6d2a933262527b6c$var$y = c;
    }
};
$6d2a933262527b6c$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $6d2a933262527b6c$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $6d2a933262527b6c$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $6d2a933262527b6c$var$f($6d2a933262527b6c$var$t, a), null === $6d2a933262527b6c$var$h($6d2a933262527b6c$var$r) && a === $6d2a933262527b6c$var$h($6d2a933262527b6c$var$t) && ($6d2a933262527b6c$var$B ? ($6d2a933262527b6c$var$E($6d2a933262527b6c$var$L), $6d2a933262527b6c$var$L = -1) : $6d2a933262527b6c$var$B = !0, $6d2a933262527b6c$var$K($6d2a933262527b6c$var$H, c - d))) : (a.sortIndex = e, $6d2a933262527b6c$var$f($6d2a933262527b6c$var$r, a), $6d2a933262527b6c$var$A || $6d2a933262527b6c$var$z || ($6d2a933262527b6c$var$A = !0, $6d2a933262527b6c$var$I($6d2a933262527b6c$var$J)));
    return a;
};
$6d2a933262527b6c$export$b5836b71941fa3ed = $6d2a933262527b6c$var$M;
$6d2a933262527b6c$export$cf845f2c119da08a = function(a) {
    var b = $6d2a933262527b6c$var$y;
    return function() {
        var c = $6d2a933262527b6c$var$y;
        $6d2a933262527b6c$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $6d2a933262527b6c$var$y = c;
        }
    };
};

});




parcelRequire.register("f7UXb", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $b033b03ca96b23c1$var$ReactIs, $b033b03ca96b23c1$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
module.exports = (parcelRequire("k8QgV"))();

});
parcelRequire.register("k8QgV", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";

var $gwZkL = parcelRequire("gwZkL");
function $ea9d1a253281148c$var$emptyFunction() {}
function $ea9d1a253281148c$var$emptyFunctionWithReset() {}
$ea9d1a253281148c$var$emptyFunctionWithReset.resetWarningCache = $ea9d1a253281148c$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $gwZkL) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = "Invariant Violation";
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $ea9d1a253281148c$var$emptyFunctionWithReset,
        resetWarningCache: $ea9d1a253281148c$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRequire.register("gwZkL", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var $c08f361c83a1ed3b$var$ReactPropTypesSecret = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
module.exports = $c08f361c83a1ed3b$var$ReactPropTypesSecret;

});



parcelRequire.register("iygN0", function(module, exports) {

$parcel$export(module.exports, "getBundleURL", () => $d8186cfb7814e8b5$export$bdfd709ae4826697, (v) => $d8186cfb7814e8b5$export$bdfd709ae4826697 = v);
var $d8186cfb7814e8b5$export$bdfd709ae4826697;
var $d8186cfb7814e8b5$export$c9e73fbda7da57b6;
var $d8186cfb7814e8b5$export$5a759dc7a1cfb72a;
"use strict";
var $d8186cfb7814e8b5$var$bundleURL = {};
function $d8186cfb7814e8b5$var$getBundleURLCached(id) {
    var value = $d8186cfb7814e8b5$var$bundleURL[id];
    if (!value) {
        value = $d8186cfb7814e8b5$var$getBundleURL();
        $d8186cfb7814e8b5$var$bundleURL[id] = value;
    }
    return value;
}
function $d8186cfb7814e8b5$var$getBundleURL() {
    try {
        throw new Error();
    } catch (err) {
        var matches = ("" + err.stack).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g);
        if (matches) // The first two stack frames will be this function and getBundleURLCached.
        // Use the 3rd one, which will be a runtime in the original bundle.
        return $d8186cfb7814e8b5$var$getBaseURL(matches[2]);
    }
    return "/";
}
function $d8186cfb7814e8b5$var$getBaseURL(url) {
    return ("" + url).replace(/^((?:https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/.+)\/[^/]+$/, "$1") + "/";
}
// TODO: Replace uses with `new URL(url).origin` when ie11 is no longer supported.
function $d8186cfb7814e8b5$var$getOrigin(url) {
    var matches = ("" + url).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^/]+/);
    if (!matches) throw new Error("Origin not found");
    return matches[0];
}
$d8186cfb7814e8b5$export$bdfd709ae4826697 = $d8186cfb7814e8b5$var$getBundleURLCached;
$d8186cfb7814e8b5$export$c9e73fbda7da57b6 = $d8186cfb7814e8b5$var$getBaseURL;
$d8186cfb7814e8b5$export$5a759dc7a1cfb72a = $d8186cfb7814e8b5$var$getOrigin;

});

parcelRequire.register("3w8Sv", function(module, exports) {
function $28fb3f41cb1ade64$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
module.exports = $28fb3f41cb1ade64$var$_defineProperty, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRequire.register("2PxO1", function(module, exports) {
function $20fa9151e5c2cd15$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return module.exports = $20fa9151e5c2cd15$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $20fa9151e5c2cd15$var$_typeof(obj);
}
module.exports = $20fa9151e5c2cd15$var$_typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRequire.register("hOWci", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SENT = module.exports.SEND_FAILED = module.exports.SENDING = void 0;
/** @deprecated This constant is being deprecated, please use string literal instead. Will be remove on or after 2024-07-31. */ var $cf943ff37a5c743e$var$SEND_FAILED = "send failed";
/** @deprecated This constant is being deprecated, please use string literal instead. Will be remove on or after 2024-07-31. */ module.exports.SEND_FAILED = $cf943ff37a5c743e$var$SEND_FAILED;
var $cf943ff37a5c743e$var$SENDING = "sending";
/** @deprecated This constant is being deprecated, please use string literal instead. Will be remove on or after 2024-07-31. */ module.exports.SENDING = $cf943ff37a5c743e$var$SENDING;
var $cf943ff37a5c743e$var$SENT = "sent";
module.exports.SENT = $cf943ff37a5c743e$var$SENT;

});

parcelRequire.register("5iNAf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.WILL_START = module.exports.STOPPING = module.exports.STARTING = module.exports.IDLE = module.exports.DICTATING = void 0;
var $3dc51871dd63e98f$var$IDLE = 0;
module.exports.IDLE = $3dc51871dd63e98f$var$IDLE;
var $3dc51871dd63e98f$var$WILL_START = 1;
module.exports.WILL_START = $3dc51871dd63e98f$var$WILL_START;
var $3dc51871dd63e98f$var$STARTING = 2;
module.exports.STARTING = $3dc51871dd63e98f$var$STARTING;
var $3dc51871dd63e98f$var$DICTATING = 3;
module.exports.DICTATING = $3dc51871dd63e98f$var$DICTATING;
var $3dc51871dd63e98f$var$STOPPING = 4;
module.exports.STOPPING = $3dc51871dd63e98f$var$STOPPING;

});

parcelRequire.register("c2kkc", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CLEAR_SUGGESTED_ACTIONS = void 0;
module.exports["default"] = $8c357007b52803bf$var$clearSuggestedActions;
var $8c357007b52803bf$var$CLEAR_SUGGESTED_ACTIONS = "WEB_CHAT/CLEAR_SUGGESTED_ACTIONS";
module.exports.CLEAR_SUGGESTED_ACTIONS = $8c357007b52803bf$var$CLEAR_SUGGESTED_ACTIONS;
function $8c357007b52803bf$var$clearSuggestedActions() {
    return {
        type: $8c357007b52803bf$var$CLEAR_SUGGESTED_ACTIONS
    };
}

});

parcelRequire.register("dd04G", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CONNECT_STILL_PENDING = module.exports.CONNECT_REJECTED = module.exports.CONNECT_PENDING = module.exports.CONNECT_FULFILLING = module.exports.CONNECT_FULFILLED = module.exports.CONNECT = void 0;
module.exports["default"] = $99dc8c10b0d7b81e$var$connect;
var $99dc8c10b0d7b81e$var$CONNECT = "DIRECT_LINE/CONNECT";
module.exports.CONNECT = $99dc8c10b0d7b81e$var$CONNECT;
var $99dc8c10b0d7b81e$var$CONNECT_FULFILLED = "".concat($99dc8c10b0d7b81e$var$CONNECT, "_FULFILLED");
module.exports.CONNECT_FULFILLED = $99dc8c10b0d7b81e$var$CONNECT_FULFILLED;
var $99dc8c10b0d7b81e$var$CONNECT_FULFILLING = "".concat($99dc8c10b0d7b81e$var$CONNECT, "_FULFILLING");
module.exports.CONNECT_FULFILLING = $99dc8c10b0d7b81e$var$CONNECT_FULFILLING;
var $99dc8c10b0d7b81e$var$CONNECT_PENDING = "".concat($99dc8c10b0d7b81e$var$CONNECT, "_PENDING");
module.exports.CONNECT_PENDING = $99dc8c10b0d7b81e$var$CONNECT_PENDING;
var $99dc8c10b0d7b81e$var$CONNECT_REJECTED = "".concat($99dc8c10b0d7b81e$var$CONNECT, "_REJECTED");
module.exports.CONNECT_REJECTED = $99dc8c10b0d7b81e$var$CONNECT_REJECTED;
var $99dc8c10b0d7b81e$var$CONNECT_STILL_PENDING = "".concat($99dc8c10b0d7b81e$var$CONNECT, "_STILL_PENDING");
module.exports.CONNECT_STILL_PENDING = $99dc8c10b0d7b81e$var$CONNECT_STILL_PENDING;
function $99dc8c10b0d7b81e$var$connect(_ref) {
    var directLine = _ref.directLine, userID = _ref.userID, username = _ref.username;
    return {
        type: $99dc8c10b0d7b81e$var$CONNECT,
        payload: {
            directLine: directLine,
            userID: userID,
            username: username
        }
    };
}

});

parcelRequire.register("gohnK", function(module, exports) {
"use strict";

var $8usDI = parcelRequire("8usDI");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = $beec5ef524852afb$var$createStore;
module.exports.withDevTools = $beec5ef524852afb$var$withDevTools;
module.exports.withOptions = $beec5ef524852afb$var$withOptions;

var $8ixsH = parcelRequire("8ixsH");

var $iNfpX = parcelRequire("iNfpX");

var $beec5ef524852afb$var$_reduxSaga = $8usDI((parcelRequire("iWyjb")));

var $beec5ef524852afb$var$_createReducer = $8usDI((parcelRequire("iMuTW")));

var $beec5ef524852afb$var$_createSagas = $8usDI((parcelRequire("4nGOs")));

var $beec5ef524852afb$var$_sagaError = $8usDI((parcelRequire("1Kju1")));
function $beec5ef524852afb$var$createEnhancerAndSagaMiddleware(getStore) {
    var sagaMiddleware = (0, $beec5ef524852afb$var$_reduxSaga["default"])({
        onError: function onError() {
            for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
            var err = args[0];
            console.error(err);
            var store = getStore();
            store && store.dispatch((0, $beec5ef524852afb$var$_sagaError["default"])());
        }
    });
    for(var _len = arguments.length, middlewares = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)middlewares[_key - 1] = arguments[_key];
    return {
        enhancer: $8ixsH.applyMiddleware.apply(void 0, middlewares.concat([
            sagaMiddleware
        ])),
        sagaMiddleware: sagaMiddleware
    };
}
/**
 * Creates a Redux store internally used by Web Chat.
 *
 * This store is critical for Web Chat business logics to operate, please use with cautions.
 */ // The complexity is introduced by the check of ponyfill.
// eslint-disable-next-line complexity
function $beec5ef524852afb$var$withOptions(options, initialState) {
    // IE Mode does not have `globalThis`.
    var globalThisOrWindow = typeof globalThis === "undefined" ? window : globalThis;
    var ponyfillFromOptions = options.ponyfill || {}; // TODO: [P2] Dedupe: when we have an utility package, move this code there and mark it as internal use.
    var ponyfill = {
        cancelAnimationFrame: ponyfillFromOptions.cancelAnimationFrame || // eslint-disable-next-line no-restricted-globals
        (typeof cancelAnimationFrame === "function" ? cancelAnimationFrame.bind(globalThisOrWindow) : undefined),
        cancelIdleCallback: ponyfillFromOptions.cancelIdleCallback || (typeof cancelIdleCallback === "function" ? cancelIdleCallback.bind(globalThisOrWindow) : undefined),
        clearImmediate: ponyfillFromOptions.clearImmediate || (typeof clearImmediate === "function" ? clearImmediate.bind(globalThisOrWindow) : undefined),
        clearInterval: ponyfillFromOptions.clearInterval || (typeof clearInterval === "function" ? clearInterval.bind(globalThisOrWindow) : undefined),
        clearTimeout: ponyfillFromOptions.clearTimeout || (typeof clearTimeout === "function" ? clearTimeout.bind(globalThisOrWindow) : undefined),
        // eslint-disable-next-line no-restricted-globals
        Date: ponyfillFromOptions.Date || Date,
        requestAnimationFrame: ponyfillFromOptions.requestAnimationFrame || (typeof requestAnimationFrame === "function" ? requestAnimationFrame.bind(globalThisOrWindow) : undefined),
        requestIdleCallback: ponyfillFromOptions.requestIdleCallback || (typeof requestIdleCallback === "function" ? requestIdleCallback.bind(globalThisOrWindow) : undefined),
        setImmediate: ponyfillFromOptions.setImmediate || (typeof setImmediate === "function" ? setImmediate.bind(globalThisOrWindow) : undefined),
        setInterval: ponyfillFromOptions.setInterval || (typeof setInterval === "function" ? setInterval.bind(globalThisOrWindow) : undefined),
        setTimeout: ponyfillFromOptions.setTimeout || (typeof setTimeout === "function" ? setTimeout.bind(globalThisOrWindow) : undefined)
    }; // We are sure the "getStore" (first argument) is not called on "createEnhancerAndSagaMiddleware()".
    // eslint-disable-next-line @typescript-eslint/no-use-before-define
    for(var _len3 = arguments.length, middlewares = new Array(_len3 > 2 ? _len3 - 2 : 0), _key3 = 2; _key3 < _len3; _key3++)middlewares[_key3 - 2] = arguments[_key3];
    var _createEnhancerAndSag = $beec5ef524852afb$var$createEnhancerAndSagaMiddleware.apply(void 0, [
        function() {
            return store;
        }
    ].concat(middlewares)), enhancer = _createEnhancerAndSag.enhancer, sagaMiddleware = _createEnhancerAndSag.sagaMiddleware;
    var store = (0, $8ixsH.createStore)((0, $beec5ef524852afb$var$_createReducer["default"])(ponyfill), initialState || {}, options.devTools ? (0, $iNfpX.composeWithDevTools)(enhancer) : enhancer);
    sagaMiddleware.run((0, $beec5ef524852afb$var$_createSagas["default"])({
        ponyfill: ponyfill
    }));
    return store;
}
/**
 * Creates a Redux store internally used by Web Chat.
 *
 * This store is critical for Web Chat business logics to operate, please use with cautions.
 */ function $beec5ef524852afb$var$createStore(initialState) {
    for(var _len4 = arguments.length, middlewares = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++)middlewares[_key4 - 1] = arguments[_key4];
    return $beec5ef524852afb$var$withOptions.apply(void 0, [
        {},
        initialState
    ].concat(middlewares));
}
/**
 * Creates a Redux store internally used by Web Chat, with Redux development tools.
 *
 * This store is critical for Web Chat business logics to operate, please use with cautions.
 *
 * @deprecated Use `withOptions` instead and pass `{ devTools: true }`
 */ function $beec5ef524852afb$var$withDevTools(initialState) {
    for(var _len5 = arguments.length, middlewares = new Array(_len5 > 1 ? _len5 - 1 : 0), _key5 = 1; _key5 < _len5; _key5++)middlewares[_key5 - 1] = arguments[_key5];
    return $beec5ef524852afb$var$withOptions.apply(void 0, [
        {
            devTools: true
        },
        initialState
    ].concat(middlewares));
}

});
parcelRequire.register("8usDI", function(module, exports) {
function $62e7574c7403bc80$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
module.exports = $62e7574c7403bc80$var$_interopRequireDefault, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRequire.register("8ixsH", function(module, exports) {

$parcel$export(module.exports, "createStore", () => $60a9f5fbe665b602$export$f51a9068ac82ea43);
$parcel$export(module.exports, "combineReducers", () => $60a9f5fbe665b602$export$66e4520cdb265d18);
$parcel$export(module.exports, "compose", () => $60a9f5fbe665b602$export$f672e0b6f7222cd7);
$parcel$export(module.exports, "applyMiddleware", () => $60a9f5fbe665b602$export$9ff26e0402cc7b7);

var $gCJj3 = parcelRequire("gCJj3");
/**
 * Adapted from React: https://github.com/facebook/react/blob/master/packages/shared/formatProdErrorMessage.js
 *
 * Do not require this module directly! Use normal throw error calls. These messages will be replaced with error codes
 * during build.
 * @param {number} code
 */ function $60a9f5fbe665b602$var$formatProdErrorMessage(code) {
    return "Minified Redux error #" + code + "; visit https://redux.js.org/Errors?code=" + code + " for the full message or " + "use the non-minified dev environment for full errors. ";
}
// Inlined version of the `symbol-observable` polyfill
var $60a9f5fbe665b602$var$$$observable = function() {
    return typeof Symbol === "function" && Symbol.observable || "@@observable";
}();
/**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */ var $60a9f5fbe665b602$var$randomString = function randomString() {
    return Math.random().toString(36).substring(7).split("").join(".");
};
var $60a9f5fbe665b602$export$4219e499db7ca678 = {
    INIT: "@@redux/INIT" + $60a9f5fbe665b602$var$randomString(),
    REPLACE: "@@redux/REPLACE" + $60a9f5fbe665b602$var$randomString(),
    PROBE_UNKNOWN_ACTION: function PROBE_UNKNOWN_ACTION() {
        return "@@redux/PROBE_UNKNOWN_ACTION" + $60a9f5fbe665b602$var$randomString();
    }
};
/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */ function $60a9f5fbe665b602$var$isPlainObject(obj) {
    if (typeof obj !== "object" || obj === null) return false;
    var proto = obj;
    while(Object.getPrototypeOf(proto) !== null)proto = Object.getPrototypeOf(proto);
    return Object.getPrototypeOf(obj) === proto;
}
// Inlined / shortened version of `kindOf` from https://github.com/jonschlinkert/kind-of
function $60a9f5fbe665b602$var$miniKindOf(val) {
    if (val === void 0) return "undefined";
    if (val === null) return "null";
    var type = typeof val;
    switch(type){
        case "boolean":
        case "string":
        case "number":
        case "symbol":
        case "function":
            return type;
    }
    if (Array.isArray(val)) return "array";
    if ($60a9f5fbe665b602$var$isDate(val)) return "date";
    if ($60a9f5fbe665b602$var$isError(val)) return "error";
    var constructorName = $60a9f5fbe665b602$var$ctorName(val);
    switch(constructorName){
        case "Symbol":
        case "Promise":
        case "WeakMap":
        case "WeakSet":
        case "Map":
        case "Set":
            return constructorName;
    } // other
    return type.slice(8, -1).toLowerCase().replace(/\s/g, "");
}
function $60a9f5fbe665b602$var$ctorName(val) {
    return typeof val.constructor === "function" ? val.constructor.name : null;
}
function $60a9f5fbe665b602$var$isError(val) {
    return val instanceof Error || typeof val.message === "string" && val.constructor && typeof val.constructor.stackTraceLimit === "number";
}
function $60a9f5fbe665b602$var$isDate(val) {
    if (val instanceof Date) return true;
    return typeof val.toDateString === "function" && typeof val.getDate === "function" && typeof val.setDate === "function";
}
function $60a9f5fbe665b602$var$kindOf(val) {
    var typeOfVal = typeof val;
    return typeOfVal;
}
/**
 * @deprecated
 *
 * **We recommend using the `configureStore` method
 * of the `@reduxjs/toolkit` package**, which replaces `createStore`.
 *
 * Redux Toolkit is our recommended approach for writing Redux logic today,
 * including store setup, reducers, data fetching, and more.
 *
 * **For more details, please read this Redux docs page:**
 * **https://redux.js.org/introduction/why-rtk-is-redux-today**
 *
 * `configureStore` from Redux Toolkit is an improved version of `createStore` that
 * simplifies setup and helps avoid common bugs.
 *
 * You should not be using the `redux` core package by itself today, except for learning purposes.
 * The `createStore` method from the core `redux` package will not be removed, but we encourage
 * all users to migrate to using Redux Toolkit for all Redux code.
 *
 * If you want to use `createStore` without this visual deprecation warning, use
 * the `legacy_createStore` import instead:
 *
 * `import { legacy_createStore as createStore} from 'redux'`
 *
 */ function $60a9f5fbe665b602$export$f51a9068ac82ea43(reducer, preloadedState, enhancer) {
    var _ref2;
    if (typeof preloadedState === "function" && typeof enhancer === "function" || typeof enhancer === "function" && typeof arguments[3] === "function") throw new Error($60a9f5fbe665b602$var$formatProdErrorMessage(0));
    if (typeof preloadedState === "function" && typeof enhancer === "undefined") {
        enhancer = preloadedState;
        preloadedState = undefined;
    }
    if (typeof enhancer !== "undefined") {
        if (typeof enhancer !== "function") throw new Error($60a9f5fbe665b602$var$formatProdErrorMessage(1));
        return enhancer($60a9f5fbe665b602$export$f51a9068ac82ea43)(reducer, preloadedState);
    }
    if (typeof reducer !== "function") throw new Error($60a9f5fbe665b602$var$formatProdErrorMessage(2));
    var currentReducer = reducer;
    var currentState = preloadedState;
    var currentListeners = [];
    var nextListeners = currentListeners;
    var isDispatching = false;
    /**
   * This makes a shallow copy of currentListeners so we can use
   * nextListeners as a temporary list while dispatching.
   *
   * This prevents any bugs around consumers calling
   * subscribe/unsubscribe in the middle of a dispatch.
   */ function ensureCanMutateNextListeners() {
        if (nextListeners === currentListeners) nextListeners = currentListeners.slice();
    }
    /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */ function getState() {
        if (isDispatching) throw new Error($60a9f5fbe665b602$var$formatProdErrorMessage(3));
        return currentState;
    }
    /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */ function subscribe(listener) {
        if (typeof listener !== "function") throw new Error($60a9f5fbe665b602$var$formatProdErrorMessage(4));
        if (isDispatching) throw new Error($60a9f5fbe665b602$var$formatProdErrorMessage(5));
        var isSubscribed = true;
        ensureCanMutateNextListeners();
        nextListeners.push(listener);
        return function unsubscribe() {
            if (!isSubscribed) return;
            if (isDispatching) throw new Error($60a9f5fbe665b602$var$formatProdErrorMessage(6));
            isSubscribed = false;
            ensureCanMutateNextListeners();
            var index = nextListeners.indexOf(listener);
            nextListeners.splice(index, 1);
            currentListeners = null;
        };
    }
    /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */ function dispatch(action) {
        if (!$60a9f5fbe665b602$var$isPlainObject(action)) throw new Error($60a9f5fbe665b602$var$formatProdErrorMessage(7));
        if (typeof action.type === "undefined") throw new Error($60a9f5fbe665b602$var$formatProdErrorMessage(8));
        if (isDispatching) throw new Error($60a9f5fbe665b602$var$formatProdErrorMessage(9));
        try {
            isDispatching = true;
            currentState = currentReducer(currentState, action);
        } finally{
            isDispatching = false;
        }
        var listeners = currentListeners = nextListeners;
        for(var i = 0; i < listeners.length; i++){
            var listener = listeners[i];
            listener();
        }
        return action;
    }
    /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */ function replaceReducer(nextReducer) {
        if (typeof nextReducer !== "function") throw new Error($60a9f5fbe665b602$var$formatProdErrorMessage(10));
        currentReducer = nextReducer; // This action has a similiar effect to ActionTypes.INIT.
        // Any reducers that existed in both the new and old rootReducer
        // will receive the previous state. This effectively populates
        // the new state tree with any relevant data from the old one.
        dispatch({
            type: $60a9f5fbe665b602$export$4219e499db7ca678.REPLACE
        });
    }
    /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */ function observable() {
        var _ref;
        var outerSubscribe = subscribe;
        return _ref = {
            /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */ subscribe: function subscribe(observer) {
                if (typeof observer !== "object" || observer === null) throw new Error($60a9f5fbe665b602$var$formatProdErrorMessage(11));
                function observeState() {
                    if (observer.next) observer.next(getState());
                }
                observeState();
                var unsubscribe = outerSubscribe(observeState);
                return {
                    unsubscribe: unsubscribe
                };
            }
        }, _ref[$60a9f5fbe665b602$var$$$observable] = function() {
            return this;
        }, _ref;
    } // When a store is created, an "INIT" action is dispatched so that every
    // reducer returns their initial state. This effectively populates
    // the initial state tree.
    dispatch({
        type: $60a9f5fbe665b602$export$4219e499db7ca678.INIT
    });
    return _ref2 = {
        dispatch: dispatch,
        subscribe: subscribe,
        getState: getState,
        replaceReducer: replaceReducer
    }, _ref2[$60a9f5fbe665b602$var$$$observable] = observable, _ref2;
}
/**
 * Creates a Redux store that holds the state tree.
 *
 * **We recommend using `configureStore` from the
 * `@reduxjs/toolkit` package**, which replaces `createStore`:
 * **https://redux.js.org/introduction/why-rtk-is-redux-today**
 *
 * The only way to change the data in the store is to call `dispatch()` on it.
 *
 * There should only be a single store in your app. To specify how different
 * parts of the state tree respond to actions, you may combine several reducers
 * into a single reducer function by using `combineReducers`.
 *
 * @param {Function} reducer A function that returns the next state tree, given
 * the current state tree and the action to handle.
 *
 * @param {any} [preloadedState] The initial state. You may optionally specify it
 * to hydrate the state from the server in universal apps, or to restore a
 * previously serialized user session.
 * If you use `combineReducers` to produce the root reducer function, this must be
 * an object with the same shape as `combineReducers` keys.
 *
 * @param {Function} [enhancer] The store enhancer. You may optionally specify it
 * to enhance the store with third-party capabilities such as middleware,
 * time travel, persistence, etc. The only store enhancer that ships with Redux
 * is `applyMiddleware()`.
 *
 * @returns {Store} A Redux store that lets you read the state, dispatch actions
 * and subscribe to changes.
 */ var $60a9f5fbe665b602$export$8928921ea2d3b126 = $60a9f5fbe665b602$export$f51a9068ac82ea43;
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */ function $60a9f5fbe665b602$var$warning(message) {
    /* eslint-disable no-console */ if (typeof console !== "undefined" && typeof console.error === "function") console.error(message);
    /* eslint-enable no-console */ try {
        // This error was thrown as a convenience so that if you enable
        // "break on all exceptions" in your console,
        // it would pause the execution at this line.
        throw new Error(message);
    } catch (e) {} // eslint-disable-line no-empty
}
function $60a9f5fbe665b602$var$getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
    var reducerKeys = Object.keys(reducers);
    var argumentName = action && action.type === $60a9f5fbe665b602$export$4219e499db7ca678.INIT ? "preloadedState argument passed to createStore" : "previous state received by the reducer";
    if (reducerKeys.length === 0) return "Store does not have a valid reducer. Make sure the argument passed to combineReducers is an object whose values are reducers.";
    if (!$60a9f5fbe665b602$var$isPlainObject(inputState)) return "The " + argumentName + ' has unexpected type of "' + $60a9f5fbe665b602$var$kindOf(inputState) + '". Expected argument to be an object with the following ' + ('keys: "' + reducerKeys.join('", "') + '"');
    var unexpectedKeys = Object.keys(inputState).filter(function(key) {
        return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
    });
    unexpectedKeys.forEach(function(key) {
        unexpectedKeyCache[key] = true;
    });
    if (action && action.type === $60a9f5fbe665b602$export$4219e499db7ca678.REPLACE) return;
    if (unexpectedKeys.length > 0) return "Unexpected " + (unexpectedKeys.length > 1 ? "keys" : "key") + " " + ('"' + unexpectedKeys.join('", "') + '" found in ' + argumentName + ". ") + "Expected to find one of the known reducer keys instead: " + ('"' + reducerKeys.join('", "') + '". Unexpected keys will be ignored.');
}
function $60a9f5fbe665b602$var$assertReducerShape(reducers) {
    Object.keys(reducers).forEach(function(key) {
        var reducer = reducers[key];
        var initialState = reducer(undefined, {
            type: $60a9f5fbe665b602$export$4219e499db7ca678.INIT
        });
        if (typeof initialState === "undefined") throw new Error($60a9f5fbe665b602$var$formatProdErrorMessage(12));
        if (typeof reducer(undefined, {
            type: $60a9f5fbe665b602$export$4219e499db7ca678.PROBE_UNKNOWN_ACTION()
        }) === "undefined") throw new Error($60a9f5fbe665b602$var$formatProdErrorMessage(13));
    });
}
/**
 * Turns an object whose values are different reducer functions, into a single
 * reducer function. It will call every child reducer, and gather their results
 * into a single state object, whose keys correspond to the keys of the passed
 * reducer functions.
 *
 * @param {Object} reducers An object whose values correspond to different
 * reducer functions that need to be combined into one. One handy way to obtain
 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
 * undefined for any action. Instead, they should return their initial state
 * if the state passed to them was undefined, and the current state for any
 * unrecognized action.
 *
 * @returns {Function} A reducer function that invokes every reducer inside the
 * passed object, and builds a state object with the same shape.
 */ function $60a9f5fbe665b602$export$66e4520cdb265d18(reducers) {
    var reducerKeys = Object.keys(reducers);
    var finalReducers = {};
    for(var i = 0; i < reducerKeys.length; i++){
        var key = reducerKeys[i];
        if (typeof reducers[key] === "function") finalReducers[key] = reducers[key];
    }
    var finalReducerKeys = Object.keys(finalReducers); // This is used to make sure we don't warn about the same
    // keys multiple times.
    var unexpectedKeyCache;
    var shapeAssertionError;
    try {
        $60a9f5fbe665b602$var$assertReducerShape(finalReducers);
    } catch (e) {
        shapeAssertionError = e;
    }
    return function combination(state, action) {
        if (state === void 0) state = {};
        if (shapeAssertionError) throw shapeAssertionError;
        var warningMessage;
        var hasChanged = false;
        var nextState = {};
        for(var _i = 0; _i < finalReducerKeys.length; _i++){
            var _key = finalReducerKeys[_i];
            var reducer = finalReducers[_key];
            var previousStateForKey = state[_key];
            var nextStateForKey = reducer(previousStateForKey, action);
            if (typeof nextStateForKey === "undefined") {
                var actionType = action && action.type;
                throw new Error($60a9f5fbe665b602$var$formatProdErrorMessage(14));
            }
            nextState[_key] = nextStateForKey;
            hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
        }
        hasChanged = hasChanged || finalReducerKeys.length !== Object.keys(state).length;
        return hasChanged ? nextState : state;
    };
}
function $60a9f5fbe665b602$var$bindActionCreator(actionCreator, dispatch) {
    return function() {
        return dispatch(actionCreator.apply(this, arguments));
    };
}
/**
 * Turns an object whose values are action creators, into an object with the
 * same keys, but with every function wrapped into a `dispatch` call so they
 * may be invoked directly. This is just a convenience method, as you can call
 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
 *
 * For convenience, you can also pass an action creator as the first argument,
 * and get a dispatch wrapped function in return.
 *
 * @param {Function|Object} actionCreators An object whose values are action
 * creator functions. One handy way to obtain it is to use ES6 `import * as`
 * syntax. You may also pass a single function.
 *
 * @param {Function} dispatch The `dispatch` function available on your Redux
 * store.
 *
 * @returns {Function|Object} The object mimicking the original object, but with
 * every action creator wrapped into the `dispatch` call. If you passed a
 * function as `actionCreators`, the return value will also be a single
 * function.
 */ function $60a9f5fbe665b602$export$aea084d96e84da92(actionCreators, dispatch) {
    if (typeof actionCreators === "function") return $60a9f5fbe665b602$var$bindActionCreator(actionCreators, dispatch);
    if (typeof actionCreators !== "object" || actionCreators === null) throw new Error($60a9f5fbe665b602$var$formatProdErrorMessage(16));
    var boundActionCreators = {};
    for(var key in actionCreators){
        var actionCreator = actionCreators[key];
        if (typeof actionCreator === "function") boundActionCreators[key] = $60a9f5fbe665b602$var$bindActionCreator(actionCreator, dispatch);
    }
    return boundActionCreators;
}
/**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */ function $60a9f5fbe665b602$export$f672e0b6f7222cd7() {
    for(var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++)funcs[_key] = arguments[_key];
    if (funcs.length === 0) return function(arg) {
        return arg;
    };
    if (funcs.length === 1) return funcs[0];
    return funcs.reduce(function(a, b) {
        return function() {
            return a(b.apply(void 0, arguments));
        };
    });
}
/**
 * Creates a store enhancer that applies middleware to the dispatch method
 * of the Redux store. This is handy for a variety of tasks, such as expressing
 * asynchronous actions in a concise manner, or logging every action payload.
 *
 * See `redux-thunk` package as an example of the Redux middleware.
 *
 * Because middleware is potentially asynchronous, this should be the first
 * store enhancer in the composition chain.
 *
 * Note that each middleware will be given the `dispatch` and `getState` functions
 * as named arguments.
 *
 * @param {...Function} middlewares The middleware chain to be applied.
 * @returns {Function} A store enhancer applying the middleware.
 */ function $60a9f5fbe665b602$export$9ff26e0402cc7b7() {
    for(var _len = arguments.length, middlewares = new Array(_len), _key = 0; _key < _len; _key++)middlewares[_key] = arguments[_key];
    return function(createStore) {
        return function() {
            var store = createStore.apply(void 0, arguments);
            var _dispatch = function dispatch() {
                throw new Error($60a9f5fbe665b602$var$formatProdErrorMessage(15));
            };
            var middlewareAPI = {
                getState: store.getState,
                dispatch: function dispatch() {
                    return _dispatch.apply(void 0, arguments);
                }
            };
            var chain = middlewares.map(function(middleware) {
                return middleware(middlewareAPI);
            });
            _dispatch = $60a9f5fbe665b602$export$f672e0b6f7222cd7.apply(void 0, chain)(store.dispatch);
            return (0, $gCJj3.default)((0, $gCJj3.default)({}, store), {}, {
                dispatch: _dispatch
            });
        };
    };
}

});
parcelRequire.register("gCJj3", function(module, exports) {

$parcel$export(module.exports, "default", () => $c1a356d33bb07722$export$2e2bcd8739ae039);

var $cJBeB = parcelRequire("cJBeB");
function $c1a356d33bb07722$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $c1a356d33bb07722$export$2e2bcd8739ae039(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $c1a356d33bb07722$var$ownKeys(Object(source), !0).forEach(function(key) {
            (0, $cJBeB.default)(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $c1a356d33bb07722$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}

});
parcelRequire.register("cJBeB", function(module, exports) {

$parcel$export(module.exports, "default", () => $945692043773888e$export$2e2bcd8739ae039);

var $a6EiF = parcelRequire("a6EiF");
function $945692043773888e$export$2e2bcd8739ae039(obj, key, value) {
    key = (0, $a6EiF.default)(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}

});
parcelRequire.register("a6EiF", function(module, exports) {

$parcel$export(module.exports, "default", () => $75b9b9a916822875$export$2e2bcd8739ae039);

var $6kV2e = parcelRequire("6kV2e");

var $g7A27 = parcelRequire("g7A27");
function $75b9b9a916822875$export$2e2bcd8739ae039(arg) {
    var key = (0, $g7A27.default)(arg, "string");
    return (0, $6kV2e.default)(key) === "symbol" ? key : String(key);
}

});
parcelRequire.register("6kV2e", function(module, exports) {

$parcel$export(module.exports, "default", () => $49d0da50ab0e1352$export$2e2bcd8739ae039);
function $49d0da50ab0e1352$export$2e2bcd8739ae039(obj) {
    "@babel/helpers - typeof";
    return $49d0da50ab0e1352$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $49d0da50ab0e1352$export$2e2bcd8739ae039(obj);
}

});

parcelRequire.register("g7A27", function(module, exports) {

$parcel$export(module.exports, "default", () => $bbc94035f5c3f2fb$export$2e2bcd8739ae039);

var $6kV2e = parcelRequire("6kV2e");
function $bbc94035f5c3f2fb$export$2e2bcd8739ae039(input, hint) {
    if ((0, $6kV2e.default)(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ((0, $6kV2e.default)(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}

});





parcelRequire.register("iNfpX", function(module, exports) {

$parcel$export(module.exports, "composeWithDevTools", () => $dae8c33df39c0bdd$export$d32324a03b6bde1b, (v) => $dae8c33df39c0bdd$export$d32324a03b6bde1b = v);
var $dae8c33df39c0bdd$export$1e511d4a378977f5;
var $dae8c33df39c0bdd$export$d32324a03b6bde1b;
var $dae8c33df39c0bdd$export$321b1ffcca858b2b;
"use strict";

var $8ixsH = parcelRequire("8ixsH");
var $dae8c33df39c0bdd$require$compose = $8ixsH.compose;
$dae8c33df39c0bdd$export$1e511d4a378977f5 = true;
$dae8c33df39c0bdd$export$d32324a03b6bde1b = typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ : function() {
    if (arguments.length === 0) return undefined;
    if (typeof arguments[0] === "object") return $dae8c33df39c0bdd$require$compose;
    return $dae8c33df39c0bdd$require$compose.apply(null, arguments);
};
$dae8c33df39c0bdd$export$321b1ffcca858b2b = typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__ : function() {
    return function(noop) {
        return noop;
    };
};

});

parcelRequire.register("iWyjb", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $dca841b0a6027e60$export$2e2bcd8739ae039);

var $ifrjy = parcelRequire("ifrjy");
var $dca841b0a6027e60$export$2e2bcd8739ae039 = (0, $ifrjy.default);
$parcel$exportWildcard(module.exports, $ifrjy);

});
parcelRequire.register("ifrjy", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "END", () => $d48ed0c62abc38a9$export$32239d68d9c6cb49);
$parcel$export(module.exports, "isEnd", () => $d48ed0c62abc38a9$export$42af6f45c6e0d09f);
$parcel$export(module.exports, "channel", () => $d48ed0c62abc38a9$export$1f95fbd68d964d36);
$parcel$export(module.exports, "eventChannel", () => $d48ed0c62abc38a9$export$dfc3101b3180c292);
$parcel$export(module.exports, "multicastChannel", () => $d48ed0c62abc38a9$export$438eddf2fd884f37);
$parcel$export(module.exports, "stdChannel", () => $d48ed0c62abc38a9$export$e987d166a3a4f3ec);
$parcel$export(module.exports, "runSaga", () => $d48ed0c62abc38a9$export$3d8d44bf0c43bb61);
$parcel$export(module.exports, "default", () => $d48ed0c62abc38a9$export$2e2bcd8739ae039);
$parcel$export(module.exports, "CANCEL", () => (parcelRequire("6LdGn")).CANCEL);
$parcel$export(module.exports, "SAGA_LOCATION", () => (parcelRequire("6LdGn")).SAGA_LOCATION);
$parcel$export(module.exports, "buffers", () => (parcelRequire("7McF6")).H);
$parcel$export(module.exports, "detach", () => (parcelRequire("7McF6")).I);

var $6LdGn = parcelRequire("6LdGn");

var $aO5a1 = parcelRequire("aO5a1");

var $akilq = parcelRequire("akilq");

var $a6awc = parcelRequire("a6awc");

var $7McF6 = parcelRequire("7McF6");

var $8ixsH = parcelRequire("8ixsH");

var $4QkW5 = parcelRequire("4QkW5");
parcelRequire("35th6");
var $d48ed0c62abc38a9$var$queue = [];
/**
  Variable to hold a counting semaphore
  - Incrementing adds a lock and puts the scheduler in a `suspended` state (if it's not
    already suspended)
  - Decrementing releases a lock. Zero locks puts the scheduler in a `released` state. This
    triggers flushing the queued tasks.
**/ var $d48ed0c62abc38a9$var$semaphore = 0;
/**
  Executes a task 'atomically'. Tasks scheduled during this execution will be queued
  and flushed after this task has finished (assuming the scheduler endup in a released
  state).
**/ function $d48ed0c62abc38a9$var$exec(task) {
    try {
        $d48ed0c62abc38a9$var$suspend();
        task();
    } finally{
        $d48ed0c62abc38a9$var$release();
    }
}
/**
  Executes or queues a task depending on the state of the scheduler (`suspended` or `released`)
**/ function $d48ed0c62abc38a9$var$asap(task) {
    $d48ed0c62abc38a9$var$queue.push(task);
    if (!$d48ed0c62abc38a9$var$semaphore) {
        $d48ed0c62abc38a9$var$suspend();
        $d48ed0c62abc38a9$var$flush();
    }
}
/**
 * Puts the scheduler in a `suspended` state and executes a task immediately.
 */ function $d48ed0c62abc38a9$var$immediately(task) {
    try {
        $d48ed0c62abc38a9$var$suspend();
        return task();
    } finally{
        $d48ed0c62abc38a9$var$flush();
    }
}
/**
  Puts the scheduler in a `suspended` state. Scheduled tasks will be queued until the
  scheduler is released.
**/ function $d48ed0c62abc38a9$var$suspend() {
    $d48ed0c62abc38a9$var$semaphore++;
}
/**
  Puts the scheduler in a `released` state.
**/ function $d48ed0c62abc38a9$var$release() {
    $d48ed0c62abc38a9$var$semaphore--;
}
/**
  Releases the current lock. Executes all queued tasks if the scheduler is in the released state.
**/ function $d48ed0c62abc38a9$var$flush() {
    $d48ed0c62abc38a9$var$release();
    var task;
    while(!$d48ed0c62abc38a9$var$semaphore && (task = $d48ed0c62abc38a9$var$queue.shift()) !== undefined)$d48ed0c62abc38a9$var$exec(task);
}
var $d48ed0c62abc38a9$var$array = function array(patterns) {
    return function(input) {
        return patterns.some(function(p) {
            return $d48ed0c62abc38a9$var$matcher(p)(input);
        });
    };
};
var $d48ed0c62abc38a9$var$predicate = function predicate(_predicate) {
    return function(input) {
        return _predicate(input);
    };
};
var $d48ed0c62abc38a9$var$string = function string(pattern) {
    return function(input) {
        return input.type === String(pattern);
    };
};
var $d48ed0c62abc38a9$var$symbol = function symbol(pattern) {
    return function(input) {
        return input.type === pattern;
    };
};
var $d48ed0c62abc38a9$var$wildcard = function wildcard() {
    return 0, $7McF6.k;
};
function $d48ed0c62abc38a9$var$matcher(pattern) {
    // prettier-ignore
    var matcherCreator = pattern === "*" ? $d48ed0c62abc38a9$var$wildcard : (0, $a6awc.string)(pattern) ? $d48ed0c62abc38a9$var$string : (0, $a6awc.array)(pattern) ? $d48ed0c62abc38a9$var$array : (0, $a6awc.stringableFunc)(pattern) ? $d48ed0c62abc38a9$var$string : (0, $a6awc.func)(pattern) ? $d48ed0c62abc38a9$var$predicate : (0, $a6awc.symbol)(pattern) ? $d48ed0c62abc38a9$var$symbol : null;
    if (matcherCreator === null) throw new Error("invalid pattern: " + pattern);
    return matcherCreator(pattern);
}
var $d48ed0c62abc38a9$export$32239d68d9c6cb49 = {
    type: (0, $6LdGn.CHANNEL_END_TYPE)
};
var $d48ed0c62abc38a9$export$42af6f45c6e0d09f = function isEnd(a) {
    return a && a.type === (0, $6LdGn.CHANNEL_END_TYPE);
};
var $d48ed0c62abc38a9$var$CLOSED_CHANNEL_WITH_TAKERS = "Cannot have a closed channel with pending takers";
var $d48ed0c62abc38a9$var$INVALID_BUFFER = "invalid buffer passed to channel factory function";
var $d48ed0c62abc38a9$var$UNDEFINED_INPUT_ERROR = "Saga or channel was provided with an undefined action\nHints:\n  - check that your Action Creator returns a non-undefined value\n  - if the Saga was started using runSaga, check that your subscribe source provides the action to its listeners";
function $d48ed0c62abc38a9$export$1f95fbd68d964d36(buffer$1) {
    if (buffer$1 === void 0) buffer$1 = (0, $7McF6.e)();
    var closed = false;
    var takers = [];
    function checkForbiddenStates() {
        if (closed && takers.length) throw (0, $7McF6.i)($d48ed0c62abc38a9$var$CLOSED_CHANNEL_WITH_TAKERS);
        if (takers.length && !buffer$1.isEmpty()) throw (0, $7McF6.i)("Cannot have pending takers with non empty buffer");
    }
    function put(input) {
        if (closed) return;
        if (takers.length === 0) return buffer$1.put(input);
        var cb = takers.shift();
        cb(input);
    }
    function take(cb) {
        if (closed && buffer$1.isEmpty()) cb($d48ed0c62abc38a9$export$32239d68d9c6cb49);
        else if (!buffer$1.isEmpty()) cb(buffer$1.take());
        else {
            takers.push(cb);
            cb.cancel = function() {
                (0, $7McF6.r)(takers, cb);
            };
        }
    }
    function flush(cb) {
        if (closed && buffer$1.isEmpty()) {
            cb($d48ed0c62abc38a9$export$32239d68d9c6cb49);
            return;
        }
        cb(buffer$1.flush());
    }
    function close() {
        if (closed) return;
        closed = true;
        var arr = takers;
        takers = [];
        for(var i = 0, len = arr.length; i < len; i++){
            var taker = arr[i];
            taker($d48ed0c62abc38a9$export$32239d68d9c6cb49);
        }
    }
    return {
        take: take,
        put: put,
        flush: flush,
        close: close
    };
}
function $d48ed0c62abc38a9$export$dfc3101b3180c292(subscribe, buffer) {
    if (buffer === void 0) buffer = (0, $7McF6.n)();
    var closed = false;
    var unsubscribe;
    var chan = $d48ed0c62abc38a9$export$1f95fbd68d964d36(buffer);
    var close = function close() {
        if (closed) return;
        closed = true;
        if ((0, $a6awc.func)(unsubscribe)) unsubscribe();
        chan.close();
    };
    unsubscribe = subscribe(function(input) {
        if ($d48ed0c62abc38a9$export$42af6f45c6e0d09f(input)) {
            close();
            return;
        }
        chan.put(input);
    });
    unsubscribe = (0, $7McF6.o)(unsubscribe);
    if (closed) unsubscribe();
    return {
        take: chan.take,
        flush: chan.flush,
        close: close
    };
}
function $d48ed0c62abc38a9$export$438eddf2fd884f37() {
    var _ref;
    var closed = false;
    var currentTakers = [];
    var nextTakers = currentTakers;
    function checkForbiddenStates() {
        if (closed && nextTakers.length) throw (0, $7McF6.i)($d48ed0c62abc38a9$var$CLOSED_CHANNEL_WITH_TAKERS);
    }
    var ensureCanMutateNextTakers = function ensureCanMutateNextTakers() {
        if (nextTakers !== currentTakers) return;
        nextTakers = currentTakers.slice();
    };
    var close = function close() {
        closed = true;
        var takers = currentTakers = nextTakers;
        nextTakers = [];
        takers.forEach(function(taker) {
            taker($d48ed0c62abc38a9$export$32239d68d9c6cb49);
        });
    };
    return _ref = {}, _ref[0, $6LdGn.MULTICAST] = true, _ref.put = function put(input) {
        if (closed) return;
        if ($d48ed0c62abc38a9$export$42af6f45c6e0d09f(input)) {
            close();
            return;
        }
        var takers = currentTakers = nextTakers;
        for(var i = 0, len = takers.length; i < len; i++){
            var taker = takers[i];
            if (taker[0, $6LdGn.MATCH](input)) {
                taker.cancel();
                taker(input);
            }
        }
    }, _ref.take = function take(cb, matcher) {
        if (matcher === void 0) matcher = $d48ed0c62abc38a9$var$wildcard;
        if (closed) {
            cb($d48ed0c62abc38a9$export$32239d68d9c6cb49);
            return;
        }
        cb[0, $6LdGn.MATCH] = matcher;
        ensureCanMutateNextTakers();
        nextTakers.push(cb);
        cb.cancel = (0, $7McF6.o)(function() {
            ensureCanMutateNextTakers();
            (0, $7McF6.r)(nextTakers, cb);
        });
    }, _ref.close = close, _ref;
}
function $d48ed0c62abc38a9$export$e987d166a3a4f3ec() {
    var chan = $d48ed0c62abc38a9$export$438eddf2fd884f37();
    var put = chan.put;
    chan.put = function(input) {
        if (input[0, $6LdGn.SAGA_ACTION]) {
            put(input);
            return;
        }
        $d48ed0c62abc38a9$var$asap(function() {
            put(input);
        });
    };
    return chan;
}
var $d48ed0c62abc38a9$var$RUNNING = 0;
var $d48ed0c62abc38a9$var$CANCELLED = 1;
var $d48ed0c62abc38a9$var$ABORTED = 2;
var $d48ed0c62abc38a9$var$DONE = 3;
function $d48ed0c62abc38a9$var$resolvePromise(promise, cb) {
    var cancelPromise = promise[0, $6LdGn.CANCEL];
    if ((0, $a6awc.func)(cancelPromise)) cb.cancel = cancelPromise;
    promise.then(cb, function(error) {
        cb(error, true);
    });
}
var $d48ed0c62abc38a9$var$current = 0;
var $d48ed0c62abc38a9$var$nextSagaId = function() {
    return ++$d48ed0c62abc38a9$var$current;
};
var $d48ed0c62abc38a9$var$_effectRunnerMap;
function $d48ed0c62abc38a9$var$getIteratorMetaInfo(iterator, fn) {
    if (iterator.isSagaIterator) return {
        name: iterator.meta.name
    };
    return (0, $7McF6.j)(fn);
}
function $d48ed0c62abc38a9$var$createTaskIterator(_ref) {
    var context = _ref.context, fn = _ref.fn, args = _ref.args;
    // catch synchronous failures; see #152 and #441
    try {
        var result = fn.apply(context, args); // i.e. a generator function returns an iterator
        if ((0, $a6awc.iterator)(result)) return result;
        var resolved = false;
        var next = function next(arg) {
            if (!resolved) {
                resolved = true; // Only promises returned from fork will be interpreted. See #1573
                return {
                    value: result,
                    done: !(0, $a6awc.promise)(result)
                };
            } else return {
                value: arg,
                done: true
            };
        };
        return (0, $7McF6.q)(next);
    } catch (err) {
        // do not bubble up synchronous failures for detached forks
        // instead create a failed task. See #152 and #441
        return (0, $7McF6.q)(function() {
            throw err;
        });
    }
}
function $d48ed0c62abc38a9$var$runPutEffect(env, _ref2, cb) {
    var channel = _ref2.channel, action = _ref2.action, resolve = _ref2.resolve;
    /**
   Schedule the put in case another saga is holding a lock.
   The put will be executed atomically. ie nested puts will execute after
   this put has terminated.
   **/ $d48ed0c62abc38a9$var$asap(function() {
        var result;
        try {
            result = (channel ? channel.put : env.dispatch)(action);
        } catch (error) {
            cb(error, true);
            return;
        }
        if (resolve && (0, $a6awc.promise)(result)) $d48ed0c62abc38a9$var$resolvePromise(result, cb);
        else cb(result);
    }); // Put effects are non cancellables
}
function $d48ed0c62abc38a9$var$runTakeEffect(env, _ref3, cb) {
    var _ref3$channel = _ref3.channel, channel = _ref3$channel === void 0 ? env.channel : _ref3$channel, pattern = _ref3.pattern, maybe = _ref3.maybe;
    var takeCb = function takeCb(input) {
        if (input instanceof Error) {
            cb(input, true);
            return;
        }
        if ($d48ed0c62abc38a9$export$42af6f45c6e0d09f(input) && !maybe) {
            cb((0, $6LdGn.TERMINATE));
            return;
        }
        cb(input);
    };
    try {
        channel.take(takeCb, (0, $a6awc.notUndef)(pattern) ? $d48ed0c62abc38a9$var$matcher(pattern) : null);
    } catch (err) {
        cb(err, true);
        return;
    }
    cb.cancel = takeCb.cancel;
}
function $d48ed0c62abc38a9$var$runCallEffect(env, _ref4, cb, _ref5) {
    var context = _ref4.context, fn = _ref4.fn, args = _ref4.args;
    var task = _ref5.task;
    // catch synchronous failures; see #152
    try {
        var result = fn.apply(context, args);
        if ((0, $a6awc.promise)(result)) {
            $d48ed0c62abc38a9$var$resolvePromise(result, cb);
            return;
        }
        if ((0, $a6awc.iterator)(result)) {
            // resolve iterator
            $d48ed0c62abc38a9$var$proc(env, result, task.context, $d48ed0c62abc38a9$var$current, (0, $7McF6.j)(fn), /* isRoot */ false, cb);
            return;
        }
        cb(result);
    } catch (error) {
        cb(error, true);
    }
}
function $d48ed0c62abc38a9$var$runCPSEffect(env, _ref6, cb) {
    var context = _ref6.context, fn = _ref6.fn, args = _ref6.args;
    // CPS (ie node style functions) can define their own cancellation logic
    // by setting cancel field on the cb
    // catch synchronous failures; see #152
    try {
        var cpsCb = function cpsCb(err, res) {
            if ((0, $a6awc.undef)(err)) cb(res);
            else cb(err, true);
        };
        fn.apply(context, args.concat(cpsCb));
        if (cpsCb.cancel) cb.cancel = cpsCb.cancel;
    } catch (error) {
        cb(error, true);
    }
}
function $d48ed0c62abc38a9$var$runForkEffect(env, _ref7, cb, _ref8) {
    var context = _ref7.context, fn = _ref7.fn, args = _ref7.args, detached = _ref7.detached;
    var parent = _ref8.task;
    var taskIterator = $d48ed0c62abc38a9$var$createTaskIterator({
        context: context,
        fn: fn,
        args: args
    });
    var meta = $d48ed0c62abc38a9$var$getIteratorMetaInfo(taskIterator, fn);
    $d48ed0c62abc38a9$var$immediately(function() {
        var child = $d48ed0c62abc38a9$var$proc(env, taskIterator, parent.context, $d48ed0c62abc38a9$var$current, meta, detached, undefined);
        if (detached) cb(child);
        else {
            if (child.isRunning()) {
                parent.queue.addTask(child);
                cb(child);
            } else if (child.isAborted()) parent.queue.abort(child.error());
            else cb(child);
        }
    }); // Fork effects are non cancellables
}
function $d48ed0c62abc38a9$var$runJoinEffect(env, taskOrTasks, cb, _ref9) {
    var task = _ref9.task;
    var joinSingleTask = function joinSingleTask(taskToJoin, cb) {
        if (taskToJoin.isRunning()) {
            var joiner = {
                task: task,
                cb: cb
            };
            cb.cancel = function() {
                if (taskToJoin.isRunning()) (0, $7McF6.r)(taskToJoin.joiners, joiner);
            };
            taskToJoin.joiners.push(joiner);
        } else if (taskToJoin.isAborted()) cb(taskToJoin.error(), true);
        else cb(taskToJoin.result());
    };
    if ((0, $a6awc.array)(taskOrTasks)) {
        if (taskOrTasks.length === 0) {
            cb([]);
            return;
        }
        var childCallbacks = (0, $7McF6.l)(taskOrTasks, cb);
        taskOrTasks.forEach(function(t, i) {
            joinSingleTask(t, childCallbacks[i]);
        });
    } else joinSingleTask(taskOrTasks, cb);
}
function $d48ed0c62abc38a9$var$cancelSingleTask(taskToCancel) {
    if (taskToCancel.isRunning()) taskToCancel.cancel();
}
function $d48ed0c62abc38a9$var$runCancelEffect(env, taskOrTasks, cb, _ref10) {
    var task = _ref10.task;
    if (taskOrTasks === (0, $6LdGn.SELF_CANCELLATION)) $d48ed0c62abc38a9$var$cancelSingleTask(task);
    else if ((0, $a6awc.array)(taskOrTasks)) taskOrTasks.forEach($d48ed0c62abc38a9$var$cancelSingleTask);
    else $d48ed0c62abc38a9$var$cancelSingleTask(taskOrTasks);
    cb(); // cancel effects are non cancellables
}
function $d48ed0c62abc38a9$var$runAllEffect(env, effects, cb, _ref11) {
    var digestEffect = _ref11.digestEffect;
    var effectId = $d48ed0c62abc38a9$var$current;
    var keys = Object.keys(effects);
    if (keys.length === 0) {
        cb((0, $a6awc.array)(effects) ? [] : {});
        return;
    }
    var childCallbacks = (0, $7McF6.l)(effects, cb);
    keys.forEach(function(key) {
        digestEffect(effects[key], effectId, childCallbacks[key], key);
    });
}
function $d48ed0c62abc38a9$var$runRaceEffect(env, effects, cb, _ref12) {
    var digestEffect = _ref12.digestEffect;
    var effectId = $d48ed0c62abc38a9$var$current;
    var keys = Object.keys(effects);
    var response = (0, $a6awc.array)(effects) ? (0, $7McF6.m)(keys.length) : {};
    var childCbs = {};
    var completed = false;
    keys.forEach(function(key) {
        var chCbAtKey = function chCbAtKey(res, isErr) {
            if (completed) return;
            if (isErr || (0, $7McF6.s)(res)) {
                // Race Auto cancellation
                cb.cancel();
                cb(res, isErr);
            } else {
                cb.cancel();
                completed = true;
                response[key] = res;
                cb(response);
            }
        };
        chCbAtKey.cancel = (0, $7McF6.t);
        childCbs[key] = chCbAtKey;
    });
    cb.cancel = function() {
        // prevents unnecessary cancellation
        if (!completed) {
            completed = true;
            keys.forEach(function(key) {
                return childCbs[key].cancel();
            });
        }
    };
    keys.forEach(function(key) {
        if (completed) return;
        digestEffect(effects[key], effectId, childCbs[key], key);
    });
}
function $d48ed0c62abc38a9$var$runSelectEffect(env, _ref13, cb) {
    var selector = _ref13.selector, args = _ref13.args;
    try {
        var state = selector.apply(void 0, [
            env.getState()
        ].concat(args));
        cb(state);
    } catch (error) {
        cb(error, true);
    }
}
function $d48ed0c62abc38a9$var$runChannelEffect(env, _ref14, cb) {
    var pattern = _ref14.pattern, buffer = _ref14.buffer;
    var chan = $d48ed0c62abc38a9$export$1f95fbd68d964d36(buffer);
    var match = $d48ed0c62abc38a9$var$matcher(pattern);
    var taker = function taker(action) {
        if (!$d48ed0c62abc38a9$export$42af6f45c6e0d09f(action)) env.channel.take(taker, match);
        chan.put(action);
    };
    var close = chan.close;
    chan.close = function() {
        taker.cancel();
        close();
    };
    env.channel.take(taker, match);
    cb(chan);
}
function $d48ed0c62abc38a9$var$runCancelledEffect(env, data, cb, _ref15) {
    var task = _ref15.task;
    cb(task.isCancelled());
}
function $d48ed0c62abc38a9$var$runFlushEffect(env, channel, cb) {
    channel.flush(cb);
}
function $d48ed0c62abc38a9$var$runGetContextEffect(env, prop, cb, _ref16) {
    var task = _ref16.task;
    cb(task.context[prop]);
}
function $d48ed0c62abc38a9$var$runSetContextEffect(env, props, cb, _ref17) {
    var task = _ref17.task;
    (0, $7McF6.p)(task.context, props);
    cb();
}
var $d48ed0c62abc38a9$var$effectRunnerMap = ($d48ed0c62abc38a9$var$_effectRunnerMap = {}, $d48ed0c62abc38a9$var$_effectRunnerMap[0, $7McF6.T] = $d48ed0c62abc38a9$var$runTakeEffect, $d48ed0c62abc38a9$var$_effectRunnerMap[0, $7McF6.P] = $d48ed0c62abc38a9$var$runPutEffect, $d48ed0c62abc38a9$var$_effectRunnerMap[0, $7McF6.A] = $d48ed0c62abc38a9$var$runAllEffect, $d48ed0c62abc38a9$var$_effectRunnerMap[0, $7McF6.R] = $d48ed0c62abc38a9$var$runRaceEffect, $d48ed0c62abc38a9$var$_effectRunnerMap[0, $7McF6.C] = $d48ed0c62abc38a9$var$runCallEffect, $d48ed0c62abc38a9$var$_effectRunnerMap[0, $7McF6.a] = $d48ed0c62abc38a9$var$runCPSEffect, $d48ed0c62abc38a9$var$_effectRunnerMap[0, $7McF6.F] = $d48ed0c62abc38a9$var$runForkEffect, $d48ed0c62abc38a9$var$_effectRunnerMap[0, $7McF6.J] = $d48ed0c62abc38a9$var$runJoinEffect, $d48ed0c62abc38a9$var$_effectRunnerMap[0, $7McF6.b] = $d48ed0c62abc38a9$var$runCancelEffect, $d48ed0c62abc38a9$var$_effectRunnerMap[0, $7McF6.S] = $d48ed0c62abc38a9$var$runSelectEffect, $d48ed0c62abc38a9$var$_effectRunnerMap[0, $7McF6.d] = $d48ed0c62abc38a9$var$runChannelEffect, $d48ed0c62abc38a9$var$_effectRunnerMap[0, $7McF6.f] = $d48ed0c62abc38a9$var$runCancelledEffect, $d48ed0c62abc38a9$var$_effectRunnerMap[0, $7McF6.g] = $d48ed0c62abc38a9$var$runFlushEffect, $d48ed0c62abc38a9$var$_effectRunnerMap[0, $7McF6.G] = $d48ed0c62abc38a9$var$runGetContextEffect, $d48ed0c62abc38a9$var$_effectRunnerMap[0, $7McF6.h] = $d48ed0c62abc38a9$var$runSetContextEffect, $d48ed0c62abc38a9$var$_effectRunnerMap);
/**
 Used to track a parent task and its forks
 In the fork model, forked tasks are attached by default to their parent
 We model this using the concept of Parent task && main Task
 main task is the main flow of the current Generator, the parent tasks is the
 aggregation of the main tasks + all its forked tasks.
 Thus the whole model represents an execution tree with multiple branches (vs the
 linear execution tree in sequential (non parallel) programming)

 A parent tasks has the following semantics
 - It completes if all its forks either complete or all cancelled
 - If it's cancelled, all forks are cancelled as well
 - It aborts if any uncaught error bubbles up from forks
 - If it completes, the return value is the one returned by the main task
 **/ function $d48ed0c62abc38a9$var$forkQueue(mainTask, onAbort, cont) {
    var tasks = [];
    var result;
    var completed = false;
    addTask(mainTask);
    var getTasks = function getTasks() {
        return tasks;
    };
    function abort(err) {
        onAbort();
        cancelAll();
        cont(err, true);
    }
    function addTask(task) {
        tasks.push(task);
        task.cont = function(res, isErr) {
            if (completed) return;
            (0, $7McF6.r)(tasks, task);
            task.cont = (0, $7McF6.t);
            if (isErr) abort(res);
            else {
                if (task === mainTask) result = res;
                if (!tasks.length) {
                    completed = true;
                    cont(result);
                }
            }
        };
    }
    function cancelAll() {
        if (completed) return;
        completed = true;
        tasks.forEach(function(t) {
            t.cont = (0, $7McF6.t);
            t.cancel();
        });
        tasks = [];
    }
    return {
        addTask: addTask,
        cancelAll: cancelAll,
        abort: abort,
        getTasks: getTasks
    };
}
// there can be only a single saga error created at any given moment
function $d48ed0c62abc38a9$var$formatLocation(fileName, lineNumber) {
    return fileName + "?" + lineNumber;
}
function $d48ed0c62abc38a9$var$effectLocationAsString(effect) {
    var location = (0, $7McF6.v)(effect);
    if (location) {
        var code = location.code, fileName = location.fileName, lineNumber = location.lineNumber;
        var source = code + "  " + $d48ed0c62abc38a9$var$formatLocation(fileName, lineNumber);
        return source;
    }
    return "";
}
function $d48ed0c62abc38a9$var$sagaLocationAsString(sagaMeta) {
    var name = sagaMeta.name, location = sagaMeta.location;
    if (location) return name + "  " + $d48ed0c62abc38a9$var$formatLocation(location.fileName, location.lineNumber);
    return name;
}
function $d48ed0c62abc38a9$var$cancelledTasksAsString(sagaStack) {
    var cancelledTasks = (0, $7McF6.u)(function(i) {
        return i.cancelledTasks;
    }, sagaStack);
    if (!cancelledTasks.length) return "";
    return [
        "Tasks cancelled due to error:"
    ].concat(cancelledTasks).join("\n");
}
var $d48ed0c62abc38a9$var$crashedEffect = null;
var $d48ed0c62abc38a9$var$sagaStack = [];
var $d48ed0c62abc38a9$var$addSagaFrame = function addSagaFrame(frame) {
    frame.crashedEffect = $d48ed0c62abc38a9$var$crashedEffect;
    $d48ed0c62abc38a9$var$sagaStack.push(frame);
};
var $d48ed0c62abc38a9$var$clear = function clear() {
    $d48ed0c62abc38a9$var$crashedEffect = null;
    $d48ed0c62abc38a9$var$sagaStack.length = 0;
}; // this sets crashed effect for the soon-to-be-reported saga frame
// this slightly streatches the singleton nature of this module into wrong direction
// as it's even less obvious what's the data flow here, but it is what it is for now
var $d48ed0c62abc38a9$var$setCrashedEffect = function setCrashedEffect(effect) {
    $d48ed0c62abc38a9$var$crashedEffect = effect;
};
/**
  @returns {string}

  @example
  The above error occurred in task errorInPutSaga {pathToFile}
  when executing effect put({type: 'REDUCER_ACTION_ERROR_IN_PUT'}) {pathToFile}
      created by fetchSaga {pathToFile}
      created by rootSaga {pathToFile}
*/ var $d48ed0c62abc38a9$var$toString = function toString() {
    var firstSaga = $d48ed0c62abc38a9$var$sagaStack[0], otherSagas = $d48ed0c62abc38a9$var$sagaStack.slice(1);
    var crashedEffectLocation = firstSaga.crashedEffect ? $d48ed0c62abc38a9$var$effectLocationAsString(firstSaga.crashedEffect) : null;
    var errorMessage = "The above error occurred in task " + $d48ed0c62abc38a9$var$sagaLocationAsString(firstSaga.meta) + (crashedEffectLocation ? " \n when executing effect " + crashedEffectLocation : "");
    return [
        errorMessage
    ].concat(otherSagas.map(function(s) {
        return "    created by " + $d48ed0c62abc38a9$var$sagaLocationAsString(s.meta);
    }), [
        $d48ed0c62abc38a9$var$cancelledTasksAsString($d48ed0c62abc38a9$var$sagaStack)
    ]).join("\n");
};
function $d48ed0c62abc38a9$var$newTask(env, mainTask, parentContext, parentEffectId, meta, isRoot, cont) {
    var _task;
    if (cont === void 0) cont = (0, $7McF6.t);
    var status = $d48ed0c62abc38a9$var$RUNNING;
    var taskResult;
    var taskError;
    var deferredEnd = null;
    var cancelledDueToErrorTasks = [];
    var context = Object.create(parentContext);
    var queue = $d48ed0c62abc38a9$var$forkQueue(mainTask, function onAbort() {
        cancelledDueToErrorTasks.push.apply(cancelledDueToErrorTasks, queue.getTasks().map(function(t) {
            return t.meta.name;
        }));
    }, end);
    /**
   This may be called by a parent generator to trigger/propagate cancellation
   cancel all pending tasks (including the main task), then end the current task.
    Cancellation propagates down to the whole execution tree held by this Parent task
   It's also propagated to all joiners of this task and their execution tree/joiners
    Cancellation is noop for terminated/Cancelled tasks tasks
   **/ function cancel() {
        if (status === $d48ed0c62abc38a9$var$RUNNING) {
            // Setting status to CANCELLED does not necessarily mean that the task/iterators are stopped
            // effects in the iterator's finally block will still be executed
            status = $d48ed0c62abc38a9$var$CANCELLED;
            queue.cancelAll(); // Ending with a TASK_CANCEL will propagate the Cancellation to all joiners
            end((0, $6LdGn.TASK_CANCEL), false);
        }
    }
    function end(result, isErr) {
        if (!isErr) {
            // The status here may be RUNNING or CANCELLED
            // If the status is CANCELLED, then we do not need to change it here
            if (result === (0, $6LdGn.TASK_CANCEL)) status = $d48ed0c62abc38a9$var$CANCELLED;
            else if (status !== $d48ed0c62abc38a9$var$CANCELLED) status = $d48ed0c62abc38a9$var$DONE;
            taskResult = result;
            deferredEnd && deferredEnd.resolve(result);
        } else {
            status = $d48ed0c62abc38a9$var$ABORTED;
            $d48ed0c62abc38a9$var$addSagaFrame({
                meta: meta,
                cancelledTasks: cancelledDueToErrorTasks
            });
            if (task.isRoot) {
                var sagaStack = $d48ed0c62abc38a9$var$toString(); // we've dumped the saga stack to string and are passing it to user's code
                // we know that it won't be needed anymore and we need to clear it
                $d48ed0c62abc38a9$var$clear();
                env.onError(result, {
                    sagaStack: sagaStack
                });
            }
            taskError = result;
            deferredEnd && deferredEnd.reject(result);
        }
        task.cont(result, isErr);
        task.joiners.forEach(function(joiner) {
            joiner.cb(result, isErr);
        });
        task.joiners = null;
    }
    function setContext(props) {
        (0, $7McF6.p)(context, props);
    }
    function toPromise() {
        if (deferredEnd) return deferredEnd.promise;
        deferredEnd = (0, $4QkW5.default)();
        if (status === $d48ed0c62abc38a9$var$ABORTED) deferredEnd.reject(taskError);
        else if (status !== $d48ed0c62abc38a9$var$RUNNING) deferredEnd.resolve(taskResult);
        return deferredEnd.promise;
    }
    var task = (_task = {}, _task[0, $6LdGn.TASK] = true, _task.id = parentEffectId, _task.meta = meta, _task.isRoot = isRoot, _task.context = context, _task.joiners = [], _task.queue = queue, _task.cancel = cancel, _task.cont = cont, _task.end = end, _task.setContext = setContext, _task.toPromise = toPromise, _task.isRunning = function isRunning() {
        return status === $d48ed0c62abc38a9$var$RUNNING;
    }, _task.isCancelled = function isCancelled() {
        return status === $d48ed0c62abc38a9$var$CANCELLED || status === $d48ed0c62abc38a9$var$RUNNING && mainTask.status === $d48ed0c62abc38a9$var$CANCELLED;
    }, _task.isAborted = function isAborted() {
        return status === $d48ed0c62abc38a9$var$ABORTED;
    }, _task.result = function result() {
        return taskResult;
    }, _task.error = function error() {
        return taskError;
    }, _task);
    return task;
}
function $d48ed0c62abc38a9$var$proc(env, iterator$1, parentContext, parentEffectId, meta, isRoot, cont) {
    var finalRunEffect = env.finalizeRunEffect(runEffect);
    /**
    Tracks the current effect cancellation
    Each time the generator progresses. calling runEffect will set a new value
    on it. It allows propagating cancellation to child effects
  **/ next.cancel = (0, $7McF6.t);
    /** Creates a main task to track the main flow */ var mainTask = {
        meta: meta,
        cancel: cancelMain,
        status: $d48ed0c62abc38a9$var$RUNNING
    };
    /**
   Creates a new task descriptor for this generator.
   A task is the aggregation of it's mainTask and all it's forked tasks.
   **/ var task = $d48ed0c62abc38a9$var$newTask(env, mainTask, parentContext, parentEffectId, meta, isRoot, cont);
    var executingContext = {
        task: task,
        digestEffect: digestEffect
    };
    /**
    cancellation of the main task. We'll simply resume the Generator with a TASK_CANCEL
  **/ function cancelMain() {
        if (mainTask.status === $d48ed0c62abc38a9$var$RUNNING) {
            mainTask.status = $d48ed0c62abc38a9$var$CANCELLED;
            next((0, $6LdGn.TASK_CANCEL));
        }
    }
    /**
    attaches cancellation logic to this task's continuation
    this will permit cancellation to propagate down the call chain
  **/ if (cont) cont.cancel = task.cancel;
     // kicks up the generator
    next(); // then return the task descriptor to the caller
    return task;
    /**
   * This is the generator driver
   * It's a recursive async/continuation function which calls itself
   * until the generator terminates or throws
   * @param {internal commands(TASK_CANCEL | TERMINATE) | any} arg - value, generator will be resumed with.
   * @param {boolean} isErr - the flag shows if effect finished with an error
   *
   * receives either (command | effect result, false) or (any thrown thing, true)
   */ function next(arg, isErr) {
        try {
            var result;
            if (isErr) {
                result = iterator$1.throw(arg); // user handled the error, we can clear bookkept values
                $d48ed0c62abc38a9$var$clear();
            } else if ((0, $7McF6.y)(arg)) {
                /**
          getting TASK_CANCEL automatically cancels the main task
          We can get this value here
           - By cancelling the parent task manually
          - By joining a Cancelled task
        **/ mainTask.status = $d48ed0c62abc38a9$var$CANCELLED;
                /**
          Cancels the current effect; this will propagate the cancellation down to any called tasks
        **/ next.cancel();
                /**
          If this Generator has a `return` method then invokes it
          This will jump to the finally block
        **/ result = (0, $a6awc.func)(iterator$1.return) ? iterator$1.return((0, $6LdGn.TASK_CANCEL)) : {
                    done: true,
                    value: (0, $6LdGn.TASK_CANCEL)
                };
            } else if ((0, $7McF6.z)(arg)) // We get TERMINATE flag, i.e. by taking from a channel that ended using `take` (and not `takem` used to trap End of channels)
            result = (0, $a6awc.func)(iterator$1.return) ? iterator$1.return() : {
                done: true
            };
            else result = iterator$1.next(arg);
            if (!result.done) digestEffect(result.value, parentEffectId, next);
            else {
                /**
          This Generator has ended, terminate the main task and notify the fork queue
        **/ if (mainTask.status !== $d48ed0c62abc38a9$var$CANCELLED) mainTask.status = $d48ed0c62abc38a9$var$DONE;
                mainTask.cont(result.value);
            }
        } catch (error) {
            if (mainTask.status === $d48ed0c62abc38a9$var$CANCELLED) throw error;
            mainTask.status = $d48ed0c62abc38a9$var$ABORTED;
            mainTask.cont(error, true);
        }
    }
    function runEffect(effect, effectId, currCb) {
        /**
      each effect runner must attach its own logic of cancellation to the provided callback
      it allows this generator to propagate cancellation downward.
       ATTENTION! effect runners must setup the cancel logic by setting cb.cancel = [cancelMethod]
      And the setup must occur before calling the callback
       This is a sort of inversion of control: called async functions are responsible
      of completing the flow by calling the provided continuation; while caller functions
      are responsible for aborting the current flow by calling the attached cancel function
       Library users can attach their own cancellation logic to promises by defining a
      promise[CANCEL] method in their returned promises
      ATTENTION! calling cancel must have no effect on an already completed or cancelled effect
    **/ if ((0, $a6awc.promise)(effect)) $d48ed0c62abc38a9$var$resolvePromise(effect, currCb);
        else if ((0, $a6awc.iterator)(effect)) // resolve iterator
        $d48ed0c62abc38a9$var$proc(env, effect, task.context, effectId, meta, /* isRoot */ false, currCb);
        else if (effect && effect[0, $6LdGn.IO]) {
            var effectRunner = $d48ed0c62abc38a9$var$effectRunnerMap[effect.type];
            effectRunner(env, effect.payload, currCb, executingContext);
        } else // anything else returned as is
        currCb(effect);
    }
    function digestEffect(effect, parentEffectId, cb, label) {
        if (label === void 0) label = "";
        var effectId = $d48ed0c62abc38a9$var$nextSagaId();
        env.sagaMonitor && env.sagaMonitor.effectTriggered({
            effectId: effectId,
            parentEffectId: parentEffectId,
            label: label,
            effect: effect
        });
        /**
      completion callback and cancel callback are mutually exclusive
      We can't cancel an already completed effect
      And We can't complete an already cancelled effectId
    **/ var effectSettled; // Completion callback passed to the appropriate effect runner
        function currCb(res, isErr) {
            if (effectSettled) return;
            effectSettled = true;
            cb.cancel = (0, $7McF6.t); // defensive measure
            if (env.sagaMonitor) {
                if (isErr) env.sagaMonitor.effectRejected(effectId, res);
                else env.sagaMonitor.effectResolved(effectId, res);
            }
            if (isErr) $d48ed0c62abc38a9$var$setCrashedEffect(effect);
            cb(res, isErr);
        } // tracks down the current cancel
        currCb.cancel = (0, $7McF6.t); // setup cancellation logic on the parent cb
        cb.cancel = function() {
            // prevents cancelling an already completed effect
            if (effectSettled) return;
            effectSettled = true;
            currCb.cancel(); // propagates cancel downward
            currCb.cancel = (0, $7McF6.t); // defensive measure
            env.sagaMonitor && env.sagaMonitor.effectCancelled(effectId);
        };
        finalRunEffect(effect, effectId, currCb);
    }
}
var $d48ed0c62abc38a9$var$RUN_SAGA_SIGNATURE = "runSaga(options, saga, ...args)";
var $d48ed0c62abc38a9$var$NON_GENERATOR_ERR = $d48ed0c62abc38a9$var$RUN_SAGA_SIGNATURE + ": saga argument must be a Generator function!";
function $d48ed0c62abc38a9$export$3d8d44bf0c43bb61(_ref, saga) {
    var _ref$channel = _ref.channel, channel = _ref$channel === void 0 ? $d48ed0c62abc38a9$export$e987d166a3a4f3ec() : _ref$channel, dispatch = _ref.dispatch, getState = _ref.getState, _ref$context = _ref.context, context = _ref$context === void 0 ? {} : _ref$context, sagaMonitor = _ref.sagaMonitor, effectMiddlewares = _ref.effectMiddlewares, _ref$onError = _ref.onError, onError = _ref$onError === void 0 ? (0, $7McF6.B) : _ref$onError;
    for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)args[_key - 2] = arguments[_key];
    var iterator$1 = saga.apply(void 0, args);
    var effectId = $d48ed0c62abc38a9$var$nextSagaId();
    if (sagaMonitor) {
        // monitors are expected to have a certain interface, let's fill-in any missing ones
        sagaMonitor.rootSagaStarted = sagaMonitor.rootSagaStarted || (0, $7McF6.t);
        sagaMonitor.effectTriggered = sagaMonitor.effectTriggered || (0, $7McF6.t);
        sagaMonitor.effectResolved = sagaMonitor.effectResolved || (0, $7McF6.t);
        sagaMonitor.effectRejected = sagaMonitor.effectRejected || (0, $7McF6.t);
        sagaMonitor.effectCancelled = sagaMonitor.effectCancelled || (0, $7McF6.t);
        sagaMonitor.actionDispatched = sagaMonitor.actionDispatched || (0, $7McF6.t);
        sagaMonitor.rootSagaStarted({
            effectId: effectId,
            saga: saga,
            args: args
        });
    }
    var MIDDLEWARE_TYPE_ERROR;
    var finalizeRunEffect;
    if (effectMiddlewares) {
        var middleware = (0, $8ixsH.compose).apply(void 0, effectMiddlewares);
        finalizeRunEffect = function finalizeRunEffect(runEffect) {
            return function(effect, effectId, currCb) {
                var plainRunEffect = function plainRunEffect(eff) {
                    return runEffect(eff, effectId, currCb);
                };
                return middleware(plainRunEffect)(effect);
            };
        };
    } else finalizeRunEffect = (0, $7McF6.E);
    var env = {
        channel: channel,
        dispatch: (0, $7McF6.D)(dispatch),
        getState: getState,
        sagaMonitor: sagaMonitor,
        onError: onError,
        finalizeRunEffect: finalizeRunEffect
    };
    return $d48ed0c62abc38a9$var$immediately(function() {
        var task = $d48ed0c62abc38a9$var$proc(env, iterator$1, context, effectId, (0, $7McF6.j)(saga), /* isRoot */ true, undefined);
        if (sagaMonitor) sagaMonitor.effectResolved(effectId, task);
        return task;
    });
}
function $d48ed0c62abc38a9$var$sagaMiddlewareFactory(_temp) {
    var _ref = _temp === void 0 ? {} : _temp, _ref$context = _ref.context, context = _ref$context === void 0 ? {} : _ref$context, _ref$channel = _ref.channel, channel = _ref$channel === void 0 ? $d48ed0c62abc38a9$export$e987d166a3a4f3ec() : _ref$channel, sagaMonitor = _ref.sagaMonitor, options = (0, $akilq.default)(_ref, [
        "context",
        "channel",
        "sagaMonitor"
    ]);
    var boundRunSaga;
    function sagaMiddleware(_ref2) {
        var getState = _ref2.getState, dispatch = _ref2.dispatch;
        boundRunSaga = $d48ed0c62abc38a9$export$3d8d44bf0c43bb61.bind(null, (0, $aO5a1.default)({}, options, {
            context: context,
            channel: channel,
            dispatch: dispatch,
            getState: getState,
            sagaMonitor: sagaMonitor
        }));
        return function(next) {
            return function(action) {
                if (sagaMonitor && sagaMonitor.actionDispatched) sagaMonitor.actionDispatched(action);
                var result = next(action); // hit reducers
                channel.put(action);
                return result;
            };
        };
    }
    sagaMiddleware.run = function() {
        return boundRunSaga.apply(void 0, arguments);
    };
    sagaMiddleware.setContext = function(props) {
        (0, $7McF6.p)(context, props);
    };
    return sagaMiddleware;
}
var $d48ed0c62abc38a9$export$2e2bcd8739ae039 = $d48ed0c62abc38a9$var$sagaMiddlewareFactory;

});
parcelRequire.register("6LdGn", function(module, exports) {

$parcel$export(module.exports, "CANCEL", () => $4ec1bee662a210bd$export$2b10f4b30fb65583);
$parcel$export(module.exports, "CHANNEL_END_TYPE", () => $4ec1bee662a210bd$export$3281fbb3edc9dee3);
$parcel$export(module.exports, "IO", () => $4ec1bee662a210bd$export$8f8422ac5947a789);
$parcel$export(module.exports, "MATCH", () => $4ec1bee662a210bd$export$5a1a83be8f503735);
$parcel$export(module.exports, "MULTICAST", () => $4ec1bee662a210bd$export$9074c4e62c4e51bb);
$parcel$export(module.exports, "SAGA_ACTION", () => $4ec1bee662a210bd$export$7d963e45ecdffba1);
$parcel$export(module.exports, "SELF_CANCELLATION", () => $4ec1bee662a210bd$export$3f4d38f8b89bfda7);
$parcel$export(module.exports, "TASK", () => $4ec1bee662a210bd$export$9355e489ad16f98e);
$parcel$export(module.exports, "TASK_CANCEL", () => $4ec1bee662a210bd$export$a47f788ef0b36709);
$parcel$export(module.exports, "TERMINATE", () => $4ec1bee662a210bd$export$d966e43d90bf4c05);
$parcel$export(module.exports, "SAGA_LOCATION", () => $4ec1bee662a210bd$export$bdae2c4f4f03305d);
var $4ec1bee662a210bd$var$createSymbol = function createSymbol(name) {
    return "@@redux-saga/" + name;
};
var $4ec1bee662a210bd$export$2b10f4b30fb65583 = /*#__PURE__*/ $4ec1bee662a210bd$var$createSymbol("CANCEL_PROMISE");
var $4ec1bee662a210bd$export$3281fbb3edc9dee3 = /*#__PURE__*/ $4ec1bee662a210bd$var$createSymbol("CHANNEL_END");
var $4ec1bee662a210bd$export$8f8422ac5947a789 = /*#__PURE__*/ $4ec1bee662a210bd$var$createSymbol("IO");
var $4ec1bee662a210bd$export$5a1a83be8f503735 = /*#__PURE__*/ $4ec1bee662a210bd$var$createSymbol("MATCH");
var $4ec1bee662a210bd$export$9074c4e62c4e51bb = /*#__PURE__*/ $4ec1bee662a210bd$var$createSymbol("MULTICAST");
var $4ec1bee662a210bd$export$7d963e45ecdffba1 = /*#__PURE__*/ $4ec1bee662a210bd$var$createSymbol("SAGA_ACTION");
var $4ec1bee662a210bd$export$3f4d38f8b89bfda7 = /*#__PURE__*/ $4ec1bee662a210bd$var$createSymbol("SELF_CANCELLATION");
var $4ec1bee662a210bd$export$9355e489ad16f98e = /*#__PURE__*/ $4ec1bee662a210bd$var$createSymbol("TASK");
var $4ec1bee662a210bd$export$a47f788ef0b36709 = /*#__PURE__*/ $4ec1bee662a210bd$var$createSymbol("TASK_CANCEL");
var $4ec1bee662a210bd$export$d966e43d90bf4c05 = /*#__PURE__*/ $4ec1bee662a210bd$var$createSymbol("TERMINATE");
var $4ec1bee662a210bd$export$bdae2c4f4f03305d = /*#__PURE__*/ $4ec1bee662a210bd$var$createSymbol("LOCATION");

});

parcelRequire.register("aO5a1", function(module, exports) {

$parcel$export(module.exports, "default", () => $7de293ae5d60dc53$export$2e2bcd8739ae039);
function $7de293ae5d60dc53$export$2e2bcd8739ae039() {
    $7de293ae5d60dc53$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $7de293ae5d60dc53$export$2e2bcd8739ae039.apply(this, arguments);
}

});

parcelRequire.register("akilq", function(module, exports) {

$parcel$export(module.exports, "default", () => $784a0078327a7952$export$2e2bcd8739ae039);
function $784a0078327a7952$export$2e2bcd8739ae039(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}

});

parcelRequire.register("a6awc", function(module, exports) {

$parcel$export(module.exports, "undef", () => $75a29fa60f3fa642$export$c7b6444af1f098df);
$parcel$export(module.exports, "notUndef", () => $75a29fa60f3fa642$export$1352885233577768);
$parcel$export(module.exports, "func", () => $75a29fa60f3fa642$export$86951950244e2001);
$parcel$export(module.exports, "string", () => $75a29fa60f3fa642$export$22b082955e083ec3);
$parcel$export(module.exports, "array", () => $75a29fa60f3fa642$export$2f23118c22fb2630);
$parcel$export(module.exports, "object", () => $75a29fa60f3fa642$export$be5493f9613cbbe);
$parcel$export(module.exports, "promise", () => $75a29fa60f3fa642$export$c957ef27a0ebfd4);
$parcel$export(module.exports, "iterator", () => $75a29fa60f3fa642$export$6f58e2338da23f4d);
$parcel$export(module.exports, "pattern", () => $75a29fa60f3fa642$export$24f82734ea047e6f);
$parcel$export(module.exports, "symbol", () => $75a29fa60f3fa642$export$8f701197936bc2a6);
$parcel$export(module.exports, "channel", () => $75a29fa60f3fa642$export$1f95fbd68d964d36);
$parcel$export(module.exports, "stringableFunc", () => $75a29fa60f3fa642$export$32b5e46230afa379);
$parcel$export(module.exports, "multicast", () => $75a29fa60f3fa642$export$1364843af8d5a963);
$parcel$export(module.exports, "effect", () => $75a29fa60f3fa642$export$dc573d8a6576cdb3);

var $6LdGn = parcelRequire("6LdGn");
var $75a29fa60f3fa642$export$c7b6444af1f098df = function undef(v) {
    return v === null || v === undefined;
};
var $75a29fa60f3fa642$export$1352885233577768 = function notUndef(v) {
    return v !== null && v !== undefined;
};
var $75a29fa60f3fa642$export$86951950244e2001 = function func(f) {
    return typeof f === "function";
};
var $75a29fa60f3fa642$export$98e628dec113755e = function number(n) {
    return typeof n === "number";
};
var $75a29fa60f3fa642$export$22b082955e083ec3 = function string(s) {
    return typeof s === "string";
};
var $75a29fa60f3fa642$export$2f23118c22fb2630 = Array.isArray;
var $75a29fa60f3fa642$export$be5493f9613cbbe = function object(obj) {
    return obj && !$75a29fa60f3fa642$export$2f23118c22fb2630(obj) && typeof obj === "object";
};
var $75a29fa60f3fa642$export$c957ef27a0ebfd4 = function promise(p) {
    return p && $75a29fa60f3fa642$export$86951950244e2001(p.then);
};
var $75a29fa60f3fa642$export$6f58e2338da23f4d = function iterator(it) {
    return it && $75a29fa60f3fa642$export$86951950244e2001(it.next) && $75a29fa60f3fa642$export$86951950244e2001(it.throw);
};
var $75a29fa60f3fa642$export$8e2ddbe84aff549 = function iterable(it) {
    return it && $75a29fa60f3fa642$export$86951950244e2001(Symbol) ? $75a29fa60f3fa642$export$86951950244e2001(it[Symbol.iterator]) : $75a29fa60f3fa642$export$2f23118c22fb2630(it);
};
var $75a29fa60f3fa642$export$94e939b87ca64fb4 = function task(t) {
    return t && t[0, $6LdGn.TASK];
};
var $75a29fa60f3fa642$export$2ce8c19c8dfba715 = function sagaAction(a) {
    return Boolean(a && a[0, $6LdGn.SAGA_ACTION]);
};
var $75a29fa60f3fa642$export$5ab46cbf6120b33a = function observable(ob) {
    return ob && $75a29fa60f3fa642$export$86951950244e2001(ob.subscribe);
};
var $75a29fa60f3fa642$export$ab1029bcae9ddb4a = function buffer(buf) {
    return buf && $75a29fa60f3fa642$export$86951950244e2001(buf.isEmpty) && $75a29fa60f3fa642$export$86951950244e2001(buf.take) && $75a29fa60f3fa642$export$86951950244e2001(buf.put);
};
var $75a29fa60f3fa642$export$24f82734ea047e6f = function pattern(pat) {
    return pat && ($75a29fa60f3fa642$export$22b082955e083ec3(pat) || $75a29fa60f3fa642$export$8f701197936bc2a6(pat) || $75a29fa60f3fa642$export$86951950244e2001(pat) || $75a29fa60f3fa642$export$2f23118c22fb2630(pat) && pat.every(pattern));
};
var $75a29fa60f3fa642$export$1f95fbd68d964d36 = function channel(ch) {
    return ch && $75a29fa60f3fa642$export$86951950244e2001(ch.take) && $75a29fa60f3fa642$export$86951950244e2001(ch.close);
};
var $75a29fa60f3fa642$export$32b5e46230afa379 = function stringableFunc(f) {
    return $75a29fa60f3fa642$export$86951950244e2001(f) && f.hasOwnProperty("toString");
};
var $75a29fa60f3fa642$export$8f701197936bc2a6 = function symbol(sym) {
    return Boolean(sym) && typeof Symbol === "function" && sym.constructor === Symbol && sym !== Symbol.prototype;
};
var $75a29fa60f3fa642$export$1364843af8d5a963 = function multicast(ch) {
    return $75a29fa60f3fa642$export$1f95fbd68d964d36(ch) && ch[0, $6LdGn.MULTICAST];
};
var $75a29fa60f3fa642$export$dc573d8a6576cdb3 = function effect(eff) {
    return eff && eff[0, $6LdGn.IO];
};

});

parcelRequire.register("7McF6", function(module, exports) {

$parcel$export(module.exports, "k", () => $5a96d67f9caf5c5e$export$342063e11d6c3cad);
$parcel$export(module.exports, "t", () => $5a96d67f9caf5c5e$export$625550452a3fa3ec);
$parcel$export(module.exports, "E", () => $5a96d67f9caf5c5e$export$a9c23c6ac3fc3eca);
$parcel$export(module.exports, "c", () => $5a96d67f9caf5c5e$export$db3b6bfb95261072);
$parcel$export(module.exports, "p", () => $5a96d67f9caf5c5e$export$ffb5f4729a158638);
$parcel$export(module.exports, "u", () => $5a96d67f9caf5c5e$export$3b14a55fb2447963);
$parcel$export(module.exports, "r", () => $5a96d67f9caf5c5e$export$43caf9889c228507);
$parcel$export(module.exports, "o", () => $5a96d67f9caf5c5e$export$ae1af26003f05816);
$parcel$export(module.exports, "q", () => $5a96d67f9caf5c5e$export$9e5f44173e64f162);
$parcel$export(module.exports, "B", () => $5a96d67f9caf5c5e$export$ef35774e6d314e91);
$parcel$export(module.exports, "i", () => $5a96d67f9caf5c5e$export$23f2a1d2818174ef);
$parcel$export(module.exports, "m", () => $5a96d67f9caf5c5e$export$953cecd6e717a553);
$parcel$export(module.exports, "D", () => $5a96d67f9caf5c5e$export$96f57966bedc81b4);
$parcel$export(module.exports, "z", () => $5a96d67f9caf5c5e$export$df995fae86a55f06);
$parcel$export(module.exports, "y", () => $5a96d67f9caf5c5e$export$4a5767248b18ef41);
$parcel$export(module.exports, "s", () => $5a96d67f9caf5c5e$export$2408f22a0fab9ae5);
$parcel$export(module.exports, "l", () => $5a96d67f9caf5c5e$export$882b5998b3b9117c);
$parcel$export(module.exports, "j", () => $5a96d67f9caf5c5e$export$35e795649ee09318);
$parcel$export(module.exports, "v", () => $5a96d67f9caf5c5e$export$90a7f3efeed30595);
$parcel$export(module.exports, "n", () => $5a96d67f9caf5c5e$export$7ccc53e8f1e7dfc5);
$parcel$export(module.exports, "U", () => $5a96d67f9caf5c5e$export$3a6d5c9ae78a2c08);
$parcel$export(module.exports, "e", () => $5a96d67f9caf5c5e$export$f1e1789686576879);
$parcel$export(module.exports, "H", () => $5a96d67f9caf5c5e$export$7f8ddf7c7c20b3cd);
$parcel$export(module.exports, "T", () => $5a96d67f9caf5c5e$export$971d5caa766a69d7);
$parcel$export(module.exports, "P", () => $5a96d67f9caf5c5e$export$56c0d5a1e737357d);
$parcel$export(module.exports, "A", () => $5a96d67f9caf5c5e$export$ebd11618f299a286);
$parcel$export(module.exports, "R", () => $5a96d67f9caf5c5e$export$db202ddc8be9136);
$parcel$export(module.exports, "C", () => $5a96d67f9caf5c5e$export$e7094788287c5e9b);
$parcel$export(module.exports, "a", () => $5a96d67f9caf5c5e$export$407448d2b89b1813);
$parcel$export(module.exports, "F", () => $5a96d67f9caf5c5e$export$d66501df72047452);
$parcel$export(module.exports, "J", () => $5a96d67f9caf5c5e$export$b4171a6734a65d42);
$parcel$export(module.exports, "b", () => $5a96d67f9caf5c5e$export$8b22cf2602fb60ce);
$parcel$export(module.exports, "S", () => $5a96d67f9caf5c5e$export$25ce5a424b770e84);
$parcel$export(module.exports, "d", () => $5a96d67f9caf5c5e$export$4368d992c4eafac0);
$parcel$export(module.exports, "f", () => $5a96d67f9caf5c5e$export$2d1720544b23b823);
$parcel$export(module.exports, "g", () => $5a96d67f9caf5c5e$export$39b482c5e57630a8);
$parcel$export(module.exports, "G", () => $5a96d67f9caf5c5e$export$2329c99376c9d0a4);
$parcel$export(module.exports, "h", () => $5a96d67f9caf5c5e$export$dda1d9f60106f0e9);
$parcel$export(module.exports, "I", () => $5a96d67f9caf5c5e$export$9bb611d729802a56);
$parcel$export(module.exports, "K", () => $5a96d67f9caf5c5e$export$3466f893ebf79586);
$parcel$export(module.exports, "Y", () => $5a96d67f9caf5c5e$export$8743009a87fcb00f);
$parcel$export(module.exports, "_", () => $5a96d67f9caf5c5e$export$71511d61b312f219);
$parcel$export(module.exports, "V", () => $5a96d67f9caf5c5e$export$e7c866399fa523f5);
$parcel$export(module.exports, "O", () => $5a96d67f9caf5c5e$export$c4ce752e73470fba);
$parcel$export(module.exports, "N", () => $5a96d67f9caf5c5e$export$a07804094c3ecf2d);
$parcel$export(module.exports, "L", () => $5a96d67f9caf5c5e$export$61196ced6d74a310);
$parcel$export(module.exports, "M", () => $5a96d67f9caf5c5e$export$3a1a48c8f6ef640e);
$parcel$export(module.exports, "a3", () => $5a96d67f9caf5c5e$export$6559d589eb85fbb6);
$parcel$export(module.exports, "Q", () => $5a96d67f9caf5c5e$export$3722cfe417b6ed86);
$parcel$export(module.exports, "a4", () => $5a96d67f9caf5c5e$export$efca4cbe5dd06740);

var $6LdGn = parcelRequire("6LdGn");

var $aO5a1 = parcelRequire("aO5a1");

var $a6awc = parcelRequire("a6awc");

var $35th6 = parcelRequire("35th6");
var $5a96d67f9caf5c5e$var$konst = function konst(v) {
    return function() {
        return v;
    };
};
var $5a96d67f9caf5c5e$export$342063e11d6c3cad = /*#__PURE__*/ $5a96d67f9caf5c5e$var$konst(true);
var $5a96d67f9caf5c5e$export$625550452a3fa3ec = function noop() {};
var $5a96d67f9caf5c5e$export$a9c23c6ac3fc3eca = function identity(v) {
    return v;
};
var $5a96d67f9caf5c5e$var$hasSymbol = typeof Symbol === "function";
var $5a96d67f9caf5c5e$export$d141bba7fdc215a3 = $5a96d67f9caf5c5e$var$hasSymbol && Symbol.asyncIterator ? Symbol.asyncIterator : "@@asyncIterator";
function $5a96d67f9caf5c5e$export$db3b6bfb95261072(value, predicate, error) {
    if (!predicate(value)) throw new Error(error);
}
var $5a96d67f9caf5c5e$export$ffb5f4729a158638 = function assignWithSymbols(target, source) {
    (0, $aO5a1.default)(target, source);
    if (Object.getOwnPropertySymbols) Object.getOwnPropertySymbols(source).forEach(function(s) {
        target[s] = source[s];
    });
};
var $5a96d67f9caf5c5e$export$3b14a55fb2447963 = function flatMap(mapper, arr) {
    var _ref;
    return (_ref = []).concat.apply(_ref, arr.map(mapper));
};
function $5a96d67f9caf5c5e$export$43caf9889c228507(array, item) {
    var index = array.indexOf(item);
    if (index >= 0) array.splice(index, 1);
}
function $5a96d67f9caf5c5e$export$ae1af26003f05816(fn) {
    var called = false;
    return function() {
        if (called) return;
        called = true;
        fn();
    };
}
var $5a96d67f9caf5c5e$var$kThrow = function kThrow(err) {
    throw err;
};
var $5a96d67f9caf5c5e$var$kReturn = function kReturn(value) {
    return {
        value: value,
        done: true
    };
};
function $5a96d67f9caf5c5e$export$9e5f44173e64f162(next, thro, name) {
    if (thro === void 0) thro = $5a96d67f9caf5c5e$var$kThrow;
    if (name === void 0) name = "iterator";
    var iterator = {
        meta: {
            name: name
        },
        next: next,
        throw: thro,
        return: $5a96d67f9caf5c5e$var$kReturn,
        isSagaIterator: true
    };
    if (typeof Symbol !== "undefined") iterator[Symbol.iterator] = function() {
        return iterator;
    };
    return iterator;
}
function $5a96d67f9caf5c5e$export$ef35774e6d314e91(error, _ref2) {
    var sagaStack = _ref2.sagaStack;
    /*eslint-disable no-console*/ console.error(error);
    console.error(sagaStack);
}
var $5a96d67f9caf5c5e$export$23f2a1d2818174ef = function internalErr(err) {
    return new Error("\n  redux-saga: Error checking hooks detected an inconsistent state. This is likely a bug\n  in redux-saga code and not yours. Thanks for reporting this in the project's github repo.\n  Error: " + err + "\n");
};
var $5a96d67f9caf5c5e$export$efccba1c4a2ef57b = function createSetContextWarning(ctx, props) {
    return (ctx ? ctx + "." : "") + "setContext(props): argument " + props + " is not a plain object";
};
var $5a96d67f9caf5c5e$var$FROZEN_ACTION_ERROR = "You can't put (a.k.a. dispatch from saga) frozen actions.\nWe have to define a special non-enumerable property on those actions for scheduling purposes.\nOtherwise you wouldn't be able to communicate properly between sagas & other subscribers (action ordering would become far less predictable).\nIf you are using redux and you care about this behaviour (frozen actions),\nthen you might want to switch to freezing actions in a middleware rather than in action creator.\nExample implementation:\n\nconst freezeActions = store => next => action => next(Object.freeze(action))\n"; // creates empty, but not-holey array
var $5a96d67f9caf5c5e$export$953cecd6e717a553 = function createEmptyArray(n) {
    return Array.apply(null, new Array(n));
};
var $5a96d67f9caf5c5e$export$96f57966bedc81b4 = function wrapSagaDispatch(dispatch) {
    return function(action) {
        return dispatch(Object.defineProperty(action, (0, $6LdGn.SAGA_ACTION), {
            value: true
        }));
    };
};
var $5a96d67f9caf5c5e$export$df995fae86a55f06 = function shouldTerminate(res) {
    return res === (0, $6LdGn.TERMINATE);
};
var $5a96d67f9caf5c5e$export$4a5767248b18ef41 = function shouldCancel(res) {
    return res === (0, $6LdGn.TASK_CANCEL);
};
var $5a96d67f9caf5c5e$export$2408f22a0fab9ae5 = function shouldComplete(res) {
    return $5a96d67f9caf5c5e$export$df995fae86a55f06(res) || $5a96d67f9caf5c5e$export$4a5767248b18ef41(res);
};
function $5a96d67f9caf5c5e$export$882b5998b3b9117c(shape, parentCallback) {
    var keys = Object.keys(shape);
    var totalCount = keys.length;
    var completedCount = 0;
    var completed;
    var results = (0, $a6awc.array)(shape) ? $5a96d67f9caf5c5e$export$953cecd6e717a553(totalCount) : {};
    var childCallbacks = {};
    function checkEnd() {
        if (completedCount === totalCount) {
            completed = true;
            parentCallback(results);
        }
    }
    keys.forEach(function(key) {
        var chCbAtKey = function chCbAtKey(res, isErr) {
            if (completed) return;
            if (isErr || $5a96d67f9caf5c5e$export$2408f22a0fab9ae5(res)) {
                parentCallback.cancel();
                parentCallback(res, isErr);
            } else {
                results[key] = res;
                completedCount++;
                checkEnd();
            }
        };
        chCbAtKey.cancel = $5a96d67f9caf5c5e$export$625550452a3fa3ec;
        childCallbacks[key] = chCbAtKey;
    });
    parentCallback.cancel = function() {
        if (!completed) {
            completed = true;
            keys.forEach(function(key) {
                return childCallbacks[key].cancel();
            });
        }
    };
    return childCallbacks;
}
function $5a96d67f9caf5c5e$export$35e795649ee09318(fn) {
    return {
        name: fn.name || "anonymous",
        location: $5a96d67f9caf5c5e$export$90a7f3efeed30595(fn)
    };
}
function $5a96d67f9caf5c5e$export$90a7f3efeed30595(instrumented) {
    return instrumented[0, $6LdGn.SAGA_LOCATION];
}
var $5a96d67f9caf5c5e$var$BUFFER_OVERFLOW = "Channel's Buffer overflow!";
var $5a96d67f9caf5c5e$var$ON_OVERFLOW_THROW = 1;
var $5a96d67f9caf5c5e$var$ON_OVERFLOW_DROP = 2;
var $5a96d67f9caf5c5e$var$ON_OVERFLOW_SLIDE = 3;
var $5a96d67f9caf5c5e$var$ON_OVERFLOW_EXPAND = 4;
var $5a96d67f9caf5c5e$var$zeroBuffer = {
    isEmpty: $5a96d67f9caf5c5e$export$342063e11d6c3cad,
    put: $5a96d67f9caf5c5e$export$625550452a3fa3ec,
    take: $5a96d67f9caf5c5e$export$625550452a3fa3ec
};
function $5a96d67f9caf5c5e$var$ringBuffer(limit, overflowAction) {
    if (limit === void 0) limit = 10;
    var arr = new Array(limit);
    var length = 0;
    var pushIndex = 0;
    var popIndex = 0;
    var push = function push(it) {
        arr[pushIndex] = it;
        pushIndex = (pushIndex + 1) % limit;
        length++;
    };
    var take = function take() {
        if (length != 0) {
            var it = arr[popIndex];
            arr[popIndex] = null;
            length--;
            popIndex = (popIndex + 1) % limit;
            return it;
        }
    };
    var flush = function flush() {
        var items = [];
        while(length)items.push(take());
        return items;
    };
    return {
        isEmpty: function isEmpty() {
            return length == 0;
        },
        put: function put(it) {
            if (length < limit) push(it);
            else {
                var doubledLimit;
                switch(overflowAction){
                    case $5a96d67f9caf5c5e$var$ON_OVERFLOW_THROW:
                        throw new Error($5a96d67f9caf5c5e$var$BUFFER_OVERFLOW);
                    case $5a96d67f9caf5c5e$var$ON_OVERFLOW_SLIDE:
                        arr[pushIndex] = it;
                        pushIndex = (pushIndex + 1) % limit;
                        popIndex = pushIndex;
                        break;
                    case $5a96d67f9caf5c5e$var$ON_OVERFLOW_EXPAND:
                        doubledLimit = 2 * limit;
                        arr = flush();
                        length = arr.length;
                        pushIndex = arr.length;
                        popIndex = 0;
                        arr.length = doubledLimit;
                        limit = doubledLimit;
                        push(it);
                        break;
                    default:
                }
            }
        },
        take: take,
        flush: flush
    };
}
var $5a96d67f9caf5c5e$export$7ccc53e8f1e7dfc5 = function none() {
    return $5a96d67f9caf5c5e$var$zeroBuffer;
};
var $5a96d67f9caf5c5e$var$fixed = function fixed(limit) {
    return $5a96d67f9caf5c5e$var$ringBuffer(limit, $5a96d67f9caf5c5e$var$ON_OVERFLOW_THROW);
};
var $5a96d67f9caf5c5e$var$dropping = function dropping(limit) {
    return $5a96d67f9caf5c5e$var$ringBuffer(limit, $5a96d67f9caf5c5e$var$ON_OVERFLOW_DROP);
};
var $5a96d67f9caf5c5e$export$3a6d5c9ae78a2c08 = function sliding(limit) {
    return $5a96d67f9caf5c5e$var$ringBuffer(limit, $5a96d67f9caf5c5e$var$ON_OVERFLOW_SLIDE);
};
var $5a96d67f9caf5c5e$export$f1e1789686576879 = function expanding(initialSize) {
    return $5a96d67f9caf5c5e$var$ringBuffer(initialSize, $5a96d67f9caf5c5e$var$ON_OVERFLOW_EXPAND);
};
var $5a96d67f9caf5c5e$export$7f8ddf7c7c20b3cd = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    none: $5a96d67f9caf5c5e$export$7ccc53e8f1e7dfc5,
    fixed: $5a96d67f9caf5c5e$var$fixed,
    dropping: $5a96d67f9caf5c5e$var$dropping,
    sliding: $5a96d67f9caf5c5e$export$3a6d5c9ae78a2c08,
    expanding: $5a96d67f9caf5c5e$export$f1e1789686576879
});
var $5a96d67f9caf5c5e$export$971d5caa766a69d7 = "TAKE";
var $5a96d67f9caf5c5e$export$56c0d5a1e737357d = "PUT";
var $5a96d67f9caf5c5e$export$ebd11618f299a286 = "ALL";
var $5a96d67f9caf5c5e$export$db202ddc8be9136 = "RACE";
var $5a96d67f9caf5c5e$export$e7094788287c5e9b = "CALL";
var $5a96d67f9caf5c5e$export$407448d2b89b1813 = "CPS";
var $5a96d67f9caf5c5e$export$d66501df72047452 = "FORK";
var $5a96d67f9caf5c5e$export$b4171a6734a65d42 = "JOIN";
var $5a96d67f9caf5c5e$export$8b22cf2602fb60ce = "CANCEL";
var $5a96d67f9caf5c5e$export$25ce5a424b770e84 = "SELECT";
var $5a96d67f9caf5c5e$export$4368d992c4eafac0 = "ACTION_CHANNEL";
var $5a96d67f9caf5c5e$export$2d1720544b23b823 = "CANCELLED";
var $5a96d67f9caf5c5e$export$39b482c5e57630a8 = "FLUSH";
var $5a96d67f9caf5c5e$export$2329c99376c9d0a4 = "GET_CONTEXT";
var $5a96d67f9caf5c5e$export$dda1d9f60106f0e9 = "SET_CONTEXT";
var $5a96d67f9caf5c5e$export$71cec2538cb2c617 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    TAKE: $5a96d67f9caf5c5e$export$971d5caa766a69d7,
    PUT: $5a96d67f9caf5c5e$export$56c0d5a1e737357d,
    ALL: $5a96d67f9caf5c5e$export$ebd11618f299a286,
    RACE: $5a96d67f9caf5c5e$export$db202ddc8be9136,
    CALL: $5a96d67f9caf5c5e$export$e7094788287c5e9b,
    CPS: $5a96d67f9caf5c5e$export$407448d2b89b1813,
    FORK: $5a96d67f9caf5c5e$export$d66501df72047452,
    JOIN: $5a96d67f9caf5c5e$export$b4171a6734a65d42,
    CANCEL: $5a96d67f9caf5c5e$export$8b22cf2602fb60ce,
    SELECT: $5a96d67f9caf5c5e$export$25ce5a424b770e84,
    ACTION_CHANNEL: $5a96d67f9caf5c5e$export$4368d992c4eafac0,
    CANCELLED: $5a96d67f9caf5c5e$export$2d1720544b23b823,
    FLUSH: $5a96d67f9caf5c5e$export$39b482c5e57630a8,
    GET_CONTEXT: $5a96d67f9caf5c5e$export$2329c99376c9d0a4,
    SET_CONTEXT: $5a96d67f9caf5c5e$export$dda1d9f60106f0e9
});
var $5a96d67f9caf5c5e$var$TEST_HINT = "\n(HINT: if you are getting these errors in tests, consider using createMockTask from @redux-saga/testing-utils)";
var $5a96d67f9caf5c5e$var$makeEffect = function makeEffect(type, payload) {
    var _ref;
    return _ref = {}, _ref[0, $6LdGn.IO] = true, _ref.combinator = false, _ref.type = type, _ref.payload = payload, _ref;
};
var $5a96d67f9caf5c5e$var$isForkEffect = function isForkEffect(eff) {
    return (0, $a6awc.effect)(eff) && eff.type === $5a96d67f9caf5c5e$export$d66501df72047452;
};
var $5a96d67f9caf5c5e$export$9bb611d729802a56 = function detach(eff) {
    return $5a96d67f9caf5c5e$var$makeEffect($5a96d67f9caf5c5e$export$d66501df72047452, (0, $aO5a1.default)({}, eff.payload, {
        detached: true
    }));
};
function $5a96d67f9caf5c5e$export$3466f893ebf79586(patternOrChannel, multicastPattern) {
    if (patternOrChannel === void 0) patternOrChannel = "*";
    if ((0, $a6awc.pattern)(patternOrChannel)) {
        if ((0, $a6awc.notUndef)(multicastPattern)) /* eslint-disable no-console */ console.warn("take(pattern) takes one argument but two were provided. Consider passing an array for listening to several action types");
        return $5a96d67f9caf5c5e$var$makeEffect($5a96d67f9caf5c5e$export$971d5caa766a69d7, {
            pattern: patternOrChannel
        });
    }
    if ((0, $a6awc.multicast)(patternOrChannel) && (0, $a6awc.notUndef)(multicastPattern) && (0, $a6awc.pattern)(multicastPattern)) return $5a96d67f9caf5c5e$var$makeEffect($5a96d67f9caf5c5e$export$971d5caa766a69d7, {
        channel: patternOrChannel,
        pattern: multicastPattern
    });
    if ((0, $a6awc.channel)(patternOrChannel)) {
        if ((0, $a6awc.notUndef)(multicastPattern)) /* eslint-disable no-console */ console.warn("take(channel) takes one argument but two were provided. Second argument is ignored.");
        return $5a96d67f9caf5c5e$var$makeEffect($5a96d67f9caf5c5e$export$971d5caa766a69d7, {
            channel: patternOrChannel
        });
    }
}
var $5a96d67f9caf5c5e$export$78acf4525d8a74c4 = function takeMaybe() {
    var eff = $5a96d67f9caf5c5e$export$3466f893ebf79586.apply(void 0, arguments);
    eff.payload.maybe = true;
    return eff;
};
function $5a96d67f9caf5c5e$export$8743009a87fcb00f(channel$1, action) {
    if ((0, $a6awc.undef)(action)) {
        action = channel$1; // `undefined` instead of `null` to make default parameter work
        channel$1 = undefined;
    }
    return $5a96d67f9caf5c5e$var$makeEffect($5a96d67f9caf5c5e$export$56c0d5a1e737357d, {
        channel: channel$1,
        action: action
    });
}
var $5a96d67f9caf5c5e$export$dc98b0b04f4c7758 = function putResolve() {
    var eff = $5a96d67f9caf5c5e$export$8743009a87fcb00f.apply(void 0, arguments);
    eff.payload.resolve = true;
    return eff;
};
function $5a96d67f9caf5c5e$export$71511d61b312f219(effects) {
    var eff = $5a96d67f9caf5c5e$var$makeEffect($5a96d67f9caf5c5e$export$ebd11618f299a286, effects);
    eff.combinator = true;
    return eff;
}
function $5a96d67f9caf5c5e$export$e7c866399fa523f5(effects) {
    var eff = $5a96d67f9caf5c5e$var$makeEffect($5a96d67f9caf5c5e$export$db202ddc8be9136, effects);
    eff.combinator = true;
    return eff;
} // this match getFnCallDescriptor logic
var $5a96d67f9caf5c5e$var$validateFnDescriptor = function validateFnDescriptor(effectName, fnDescriptor) {
    $5a96d67f9caf5c5e$export$db3b6bfb95261072(fnDescriptor, (0, $a6awc.notUndef), effectName + ": argument fn is undefined or null");
    if ((0, $a6awc.func)(fnDescriptor)) return;
    var context = null;
    var fn;
    if ((0, $a6awc.array)(fnDescriptor)) {
        context = fnDescriptor[0];
        fn = fnDescriptor[1];
        $5a96d67f9caf5c5e$export$db3b6bfb95261072(fn, (0, $a6awc.notUndef), effectName + ": argument of type [context, fn] has undefined or null `fn`");
    } else if ((0, $a6awc.object)(fnDescriptor)) {
        context = fnDescriptor.context;
        fn = fnDescriptor.fn;
        $5a96d67f9caf5c5e$export$db3b6bfb95261072(fn, (0, $a6awc.notUndef), effectName + ": argument of type {context, fn} has undefined or null `fn`");
    } else {
        $5a96d67f9caf5c5e$export$db3b6bfb95261072(fnDescriptor, (0, $a6awc.func), effectName + ": argument fn is not function");
        return;
    }
    if (context && (0, $a6awc.string)(fn)) {
        $5a96d67f9caf5c5e$export$db3b6bfb95261072(context[fn], (0, $a6awc.func), effectName + ': context arguments has no such method - "' + fn + '"');
        return;
    }
    $5a96d67f9caf5c5e$export$db3b6bfb95261072(fn, (0, $a6awc.func), effectName + ": unpacked fn argument (from [context, fn] or {context, fn}) is not a function");
};
function $5a96d67f9caf5c5e$var$getFnCallDescriptor(fnDescriptor, args) {
    var context = null;
    var fn;
    if ((0, $a6awc.func)(fnDescriptor)) fn = fnDescriptor;
    else {
        if ((0, $a6awc.array)(fnDescriptor)) {
            context = fnDescriptor[0];
            fn = fnDescriptor[1];
        } else {
            context = fnDescriptor.context;
            fn = fnDescriptor.fn;
        }
        if (context && (0, $a6awc.string)(fn) && (0, $a6awc.func)(context[fn])) fn = context[fn];
    }
    return {
        context: context,
        fn: fn,
        args: args
    };
}
var $5a96d67f9caf5c5e$var$isNotDelayEffect = function isNotDelayEffect(fn) {
    return fn !== $5a96d67f9caf5c5e$export$c4ce752e73470fba;
};
function $5a96d67f9caf5c5e$export$a07804094c3ecf2d(fnDescriptor) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
    var arg0;
    return $5a96d67f9caf5c5e$var$makeEffect($5a96d67f9caf5c5e$export$e7094788287c5e9b, $5a96d67f9caf5c5e$var$getFnCallDescriptor(fnDescriptor, args));
}
function $5a96d67f9caf5c5e$export$3d8c2f653ac9d0b9(context, fn, args) {
    if (args === void 0) args = [];
    var fnDescriptor = [
        context,
        fn
    ];
    return $5a96d67f9caf5c5e$var$makeEffect($5a96d67f9caf5c5e$export$e7094788287c5e9b, $5a96d67f9caf5c5e$var$getFnCallDescriptor([
        context,
        fn
    ], args));
}
function $5a96d67f9caf5c5e$export$34aec0b863436764(fnDescriptor) {
    for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
    return $5a96d67f9caf5c5e$var$makeEffect($5a96d67f9caf5c5e$export$407448d2b89b1813, $5a96d67f9caf5c5e$var$getFnCallDescriptor(fnDescriptor, args));
}
function $5a96d67f9caf5c5e$export$61196ced6d74a310(fnDescriptor) {
    for(var _len3 = arguments.length, args = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++)args[_key3 - 1] = arguments[_key3];
    return $5a96d67f9caf5c5e$var$makeEffect($5a96d67f9caf5c5e$export$d66501df72047452, $5a96d67f9caf5c5e$var$getFnCallDescriptor(fnDescriptor, args));
}
function $5a96d67f9caf5c5e$export$3c2fa207a37baaea(fnDescriptor) {
    for(var _len4 = arguments.length, args = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++)args[_key4 - 1] = arguments[_key4];
    return $5a96d67f9caf5c5e$export$9bb611d729802a56($5a96d67f9caf5c5e$export$61196ced6d74a310.apply(void 0, [
        fnDescriptor
    ].concat(args)));
}
function $5a96d67f9caf5c5e$export$ce26c07117d59d6a(taskOrTasks) {
    return $5a96d67f9caf5c5e$var$makeEffect($5a96d67f9caf5c5e$export$b4171a6734a65d42, taskOrTasks);
}
function $5a96d67f9caf5c5e$export$3a1a48c8f6ef640e(taskOrTasks) {
    if (taskOrTasks === void 0) taskOrTasks = (0, $6LdGn.SELF_CANCELLATION);
    return $5a96d67f9caf5c5e$var$makeEffect($5a96d67f9caf5c5e$export$8b22cf2602fb60ce, taskOrTasks);
}
function $5a96d67f9caf5c5e$export$6559d589eb85fbb6(selector) {
    if (selector === void 0) selector = $5a96d67f9caf5c5e$export$a9c23c6ac3fc3eca;
    for(var _len5 = arguments.length, args = new Array(_len5 > 1 ? _len5 - 1 : 0), _key5 = 1; _key5 < _len5; _key5++)args[_key5 - 1] = arguments[_key5];
    return $5a96d67f9caf5c5e$var$makeEffect($5a96d67f9caf5c5e$export$25ce5a424b770e84, {
        selector: selector,
        args: args
    });
}
/**
  channel(pattern, [buffer])    => creates a proxy channel for store actions
**/ function $5a96d67f9caf5c5e$export$3722cfe417b6ed86(pattern$1, buffer$1) {
    return $5a96d67f9caf5c5e$var$makeEffect($5a96d67f9caf5c5e$export$4368d992c4eafac0, {
        pattern: pattern$1,
        buffer: buffer$1
    });
}
function $5a96d67f9caf5c5e$export$efca4cbe5dd06740() {
    return $5a96d67f9caf5c5e$var$makeEffect($5a96d67f9caf5c5e$export$2d1720544b23b823, {});
}
function $5a96d67f9caf5c5e$export$a8550f7dbe79f93a(channel$1) {
    return $5a96d67f9caf5c5e$var$makeEffect($5a96d67f9caf5c5e$export$39b482c5e57630a8, channel$1);
}
function $5a96d67f9caf5c5e$export$2e2af4578d910ddf(prop) {
    return $5a96d67f9caf5c5e$var$makeEffect($5a96d67f9caf5c5e$export$2329c99376c9d0a4, prop);
}
function $5a96d67f9caf5c5e$export$a93c5207d687da10(props) {
    return $5a96d67f9caf5c5e$var$makeEffect($5a96d67f9caf5c5e$export$dda1d9f60106f0e9, props);
}
var $5a96d67f9caf5c5e$export$c4ce752e73470fba = /*#__PURE__*/ $5a96d67f9caf5c5e$export$a07804094c3ecf2d.bind(null, (0, $35th6.default));

});
parcelRequire.register("35th6", function(module, exports) {

$parcel$export(module.exports, "default", () => $23f88c1f2c62a8f4$export$2e2bcd8739ae039);

var $6LdGn = parcelRequire("6LdGn");
var $23f88c1f2c62a8f4$var$MAX_SIGNED_INT = 2147483647;
function $23f88c1f2c62a8f4$var$delayP(ms, val) {
    if (val === void 0) val = true;
    var timeoutId;
    var promise = new Promise(function(resolve) {
        timeoutId = setTimeout(resolve, Math.min($23f88c1f2c62a8f4$var$MAX_SIGNED_INT, ms), val);
    });
    promise[0, $6LdGn.CANCEL] = function() {
        clearTimeout(timeoutId);
    };
    return promise;
}
var $23f88c1f2c62a8f4$export$2e2bcd8739ae039 = $23f88c1f2c62a8f4$var$delayP;

});


parcelRequire.register("4QkW5", function(module, exports) {

$parcel$export(module.exports, "default", () => $386c42325540d318$export$2e2bcd8739ae039);
function $386c42325540d318$var$deferred() {
    var def = {};
    def.promise = new Promise(function(resolve, reject) {
        def.resolve = resolve;
        def.reject = reject;
    });
    return def;
}
function $386c42325540d318$export$368f32fb8739d33c(length) {
    var arr = [];
    for(var i = 0; i < length; i++)arr.push($386c42325540d318$var$deferred());
    return arr;
}
var $386c42325540d318$export$2e2bcd8739ae039 = $386c42325540d318$var$deferred;

});



parcelRequire.register("iMuTW", function(module, exports) {
"use strict";

var $8usDI = parcelRequire("8usDI");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = $dac4ae106d928675$var$createReducer;

var $8ixsH = parcelRequire("8ixsH");

var $dac4ae106d928675$var$_createActivitiesReducer = $8usDI((parcelRequire("iEfIS")));

var $dac4ae106d928675$var$_createInternalReducer = $8usDI((parcelRequire("aaSXY")));

var $dac4ae106d928675$var$_createNotificationsReducer = $8usDI((parcelRequire("8aEFh")));

var $dac4ae106d928675$var$_createTypingReducer = $8usDI((parcelRequire("iN8Vt")));

var $dac4ae106d928675$var$_connectivityStatus = $8usDI((parcelRequire("gcEGo")));

var $dac4ae106d928675$var$_dictateInterims = $8usDI((parcelRequire("fqITb")));

var $dac4ae106d928675$var$_dictateState = $8usDI((parcelRequire("9pAzK")));

var $dac4ae106d928675$var$_language = $8usDI((parcelRequire("cLEuH")));

var $dac4ae106d928675$var$_readyState = $8usDI((parcelRequire("4SrXH")));

var $dac4ae106d928675$var$_referenceGrammarID = $8usDI((parcelRequire("8NAat")));

var $dac4ae106d928675$var$_sendBoxValue = $8usDI((parcelRequire("4v3Uv")));

var $dac4ae106d928675$var$_sendTimeout = $8usDI((parcelRequire("gPu4g")));

var $dac4ae106d928675$var$_sendTypingIndicator = $8usDI((parcelRequire("gwSkZ")));

var $dac4ae106d928675$var$_shouldSpeakIncomingActivity = $8usDI((parcelRequire("3Hq1k")));

var $dac4ae106d928675$var$_suggestedActions = $8usDI((parcelRequire("NKTom")));
function $dac4ae106d928675$var$createReducer(ponyfill) {
    return (0, $8ixsH.combineReducers)({
        activities: (0, $dac4ae106d928675$var$_createActivitiesReducer["default"])(ponyfill),
        connectivityStatus: $dac4ae106d928675$var$_connectivityStatus["default"],
        dictateInterims: $dac4ae106d928675$var$_dictateInterims["default"],
        dictateState: $dac4ae106d928675$var$_dictateState["default"],
        internal: (0, $dac4ae106d928675$var$_createInternalReducer["default"])(ponyfill),
        language: $dac4ae106d928675$var$_language["default"],
        notifications: (0, $dac4ae106d928675$var$_createNotificationsReducer["default"])(ponyfill),
        readyState: $dac4ae106d928675$var$_readyState["default"],
        referenceGrammarID: $dac4ae106d928675$var$_referenceGrammarID["default"],
        sendBoxValue: $dac4ae106d928675$var$_sendBoxValue["default"],
        sendTimeout: $dac4ae106d928675$var$_sendTimeout["default"],
        sendTypingIndicator: $dac4ae106d928675$var$_sendTypingIndicator["default"],
        shouldSpeakIncomingActivity: $dac4ae106d928675$var$_shouldSpeakIncomingActivity["default"],
        suggestedActions: $dac4ae106d928675$var$_suggestedActions["default"],
        typing: (0, $dac4ae106d928675$var$_createTypingReducer["default"])(ponyfill)
    });
}

});
parcelRequire.register("iEfIS", function(module, exports) {
"use strict";

var $8usDI = parcelRequire("8usDI");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = $d93828abd5d8ef12$var$createActivitiesReducer;

var $d93828abd5d8ef12$var$_simpleUpdateIn = $8usDI((parcelRequire("7qq3H")));

var $d3IPn = parcelRequire("d3IPn");

var $89rfh = parcelRequire("89rfh");

var $ciuoj = parcelRequire("ciuoj");

var $lnNkF = parcelRequire("lnNkF");

var $jsYZG = parcelRequire("jsYZG");
/* eslint no-magic-numbers: ["error", { "ignore": [0, 1, -1] }] */ var $d93828abd5d8ef12$var$DEFAULT_STATE = [];
var $d93828abd5d8ef12$var$DIRECT_LINE_PLACEHOLDER_URL = "https://docs.botframework.com/static/devportal/client/images/bot-framework-default-placeholder.png";
function $d93828abd5d8ef12$var$getClientActivityID(activity) {
    var _activity$channelData;
    return (_activity$channelData = activity.channelData) === null || _activity$channelData === void 0 ? void 0 : _activity$channelData.clientActivityID;
}
function $d93828abd5d8ef12$var$findByClientActivityID(clientActivityID) {
    return function(activity) {
        return $d93828abd5d8ef12$var$getClientActivityID(activity) === clientActivityID;
    };
}
function $d93828abd5d8ef12$var$patchActivity(activity, lastActivity, _ref) {
    var Date = _ref.Date;
    // Direct Line channel will return a placeholder image for the user-uploaded image.
    // As observed, the URL for the placeholder image is https://docs.botframework.com/static/devportal/client/images/bot-framework-default-placeholder.png.
    // To make our code simpler, we are removing the value if "contentUrl" is pointing to a placeholder image.
    // TODO: [P2] #2869 This "contentURL" removal code should be moved to DirectLineJS adapter.
    // Also, if the "contentURL" starts with "blob:", this means the user is uploading a file (the URL is constructed by URL.createObjectURL)
    // Although the copy/reference of the file is temporary in-memory, to make the UX consistent across page refresh, we do not allow the user to re-download the file either.
    activity = (0, $d93828abd5d8ef12$var$_simpleUpdateIn["default"])(activity, [
        "attachments",
        function() {
            return true;
        },
        "contentUrl"
    ], function(contentUrl) {
        if (contentUrl !== $d93828abd5d8ef12$var$DIRECT_LINE_PLACEHOLDER_URL && !/^blob:/i.test(contentUrl)) return contentUrl;
    }); // If the message does not have sequence ID, use these fallback values:
    // 1. "timestamp" field
    //    - outgoing activity will not have "timestamp" field
    // 2. last activity sequence ID (or 0) + 0.001
    //    - best effort to put this message the last one in the chat history
    activity = (0, $d93828abd5d8ef12$var$_simpleUpdateIn["default"])(activity, [
        "channelData",
        "webchat:sequence-id"
    ], function(sequenceId) {
        var _lastActivity$channel;
        return typeof sequenceId === "number" ? sequenceId : typeof activity.timestamp !== "undefined" ? +new Date(activity.timestamp) : // If there are more than 1,000 messages, some messages will get reordered and appear jumpy after receiving server response.
        // eslint-disable-next-line no-magic-numbers
        ((lastActivity === null || lastActivity === void 0 ? void 0 : (_lastActivity$channel = lastActivity.channelData) === null || _lastActivity$channel === void 0 ? void 0 : _lastActivity$channel["webchat:sequence-id"]) || 0) + 0.001;
    }); // TODO: [P1] #3953 We should move this patching logic to a DLJS wrapper for simplicity.
    activity = (0, $d93828abd5d8ef12$var$_simpleUpdateIn["default"])(activity, [
        "channelData",
        "webchat:sequence-id"
    ], function(sequenceId) {
        return typeof sequenceId === "number" ? sequenceId : +new Date(activity.timestamp || 0) || 0;
    });
    return activity;
}
function $d93828abd5d8ef12$var$upsertActivityWithSort(activities, nextActivity, ponyfill) {
    nextActivity = $d93828abd5d8ef12$var$patchActivity(nextActivity, activities[activities.length - 1], ponyfill);
    var _nextActivity = nextActivity, _nextActivity$channel = _nextActivity.channelData;
    _nextActivity$channel = _nextActivity$channel === void 0 ? {} : _nextActivity$channel;
    var nextClientActivityID = _nextActivity$channel.clientActivityID, nextSequenceId = _nextActivity$channel["webchat:sequence-id"];
    var nextActivities = activities.filter(function(_ref2) {
        var _ref2$channelData = _ref2.channelData;
        _ref2$channelData = _ref2$channelData === void 0 ? {} : _ref2$channelData;
        var clientActivityID = _ref2$channelData.clientActivityID, id = _ref2.id;
        return(// "clientActivityID" is unique and used to track if the message has been sent and echoed back from the server
        !(nextClientActivityID && clientActivityID === nextClientActivityID) && !(id && id === nextActivity.id));
    }); // Then, find the right (sorted) place to insert the new activity at, based on sequence ID.
    var indexToInsert = nextActivities.findIndex(function(_ref3) {
        var _ref3$channelData = _ref3.channelData;
        _ref3$channelData = _ref3$channelData === void 0 ? {} : _ref3$channelData;
        var sequenceId = _ref3$channelData["webchat:sequence-id"];
        return (sequenceId || 0) > (nextSequenceId || 0);
    }); // If no right place are found, append it
    nextActivities.splice(~indexToInsert ? indexToInsert : nextActivities.length, 0, nextActivity);
    return nextActivities;
}
function $d93828abd5d8ef12$var$createActivitiesReducer(ponyfill) {
    return function activities() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : $d93828abd5d8ef12$var$DEFAULT_STATE;
        var action = arguments.length > 1 ? arguments[1] : undefined;
        switch(action.type){
            case $d3IPn.DELETE_ACTIVITY:
                state = (0, $d93828abd5d8ef12$var$_simpleUpdateIn["default"])(state, [
                    function(_ref4) {
                        var id = _ref4.id;
                        return id === action.payload.activityID;
                    }
                ]);
                break;
            case $ciuoj.MARK_ACTIVITY:
                var payload = action.payload;
                state = (0, $d93828abd5d8ef12$var$_simpleUpdateIn["default"])(state, [
                    function(_ref5) {
                        var id = _ref5.id;
                        return id === payload.activityID;
                    },
                    "channelData",
                    payload.name
                ], function() {
                    return payload.value;
                });
                break;
            case $lnNkF.POST_ACTIVITY_PENDING:
                var _activity = action.payload.activity; // `channelData.state` is being deprecated in favor of `channelData['webchat:send-status']`.
                // Please refer to #4362 for details. Remove on or after 2024-07-31.
                _activity = (0, $d93828abd5d8ef12$var$_simpleUpdateIn["default"])(_activity, [
                    "channelData",
                    "state"
                ], function() {
                    return $jsYZG.SENDING;
                });
                _activity = (0, $d93828abd5d8ef12$var$_simpleUpdateIn["default"])(_activity, [
                    "channelData",
                    "webchat:send-status"
                ], function() {
                    return $jsYZG.SENDING;
                });
                state = $d93828abd5d8ef12$var$upsertActivityWithSort(state, _activity, ponyfill);
                break;
            case $lnNkF.POST_ACTIVITY_IMPEDED:
                state = (0, $d93828abd5d8ef12$var$_simpleUpdateIn["default"])(state, // Please refer to #4362 for details. Remove on or after 2024-07-31.
                [
                    $d93828abd5d8ef12$var$findByClientActivityID(action.meta.clientActivityID),
                    "channelData",
                    "state"
                ], function() {
                    return $jsYZG.SEND_FAILED;
                });
                break;
            case $lnNkF.POST_ACTIVITY_REJECTED:
                state = (0, $d93828abd5d8ef12$var$_simpleUpdateIn["default"])(state, [
                    $d93828abd5d8ef12$var$findByClientActivityID(action.meta.clientActivityID)
                ], function(activity) {
                    activity = (0, $d93828abd5d8ef12$var$_simpleUpdateIn["default"])(activity, [
                        "channelData",
                        "state"
                    ], function() {
                        return $jsYZG.SEND_FAILED;
                    });
                    return (0, $d93828abd5d8ef12$var$_simpleUpdateIn["default"])(activity, [
                        "channelData",
                        "webchat:send-status"
                    ], function() {
                        return $jsYZG.SEND_FAILED;
                    });
                });
                break;
            case $lnNkF.POST_ACTIVITY_FULFILLED:
                state = (0, $d93828abd5d8ef12$var$_simpleUpdateIn["default"])(state, [
                    $d93828abd5d8ef12$var$findByClientActivityID(action.meta.clientActivityID)
                ], function() {
                    // We will replace the activity with the version from the server
                    var activity = (0, $d93828abd5d8ef12$var$_simpleUpdateIn["default"])($d93828abd5d8ef12$var$patchActivity(action.payload.activity, state[state.length - 1], ponyfill), // Please refer to #4362 for details. Remove on or after 2024-07-31.
                    [
                        "channelData",
                        "state"
                    ], function() {
                        return $jsYZG.SENT;
                    });
                    return (0, $d93828abd5d8ef12$var$_simpleUpdateIn["default"])(activity, [
                        "channelData",
                        "webchat:send-status"
                    ], function() {
                        return $jsYZG.SENT;
                    });
                });
                break;
            case $89rfh.INCOMING_ACTIVITY:
                var _activity2 = action.payload.activity; // If the incoming activity is an echo back, we should keep the existing `channelData['webchat:send-status']` field.
                //
                // Otherwise, it will fail following scenario:
                //
                // 1. Send an activity to the service
                // 2. Service echoed back the activity
                // 3. Service did NOT return `postActivity` call
                // -  EXPECT: `channelData['webchat:send-status']` should be "sending".
                // -  ACTUAL: `channelData['webchat:send-status']` is `undefined` because the activity get overwritten by the echo back activity.
                //            The echo back activity contains no `channelData['webchat:send-status']`.
                //
                // While we are looking out for the scenario above, we should also look at the following scenarios:
                //
                // 1. Service restore chat history, including activities sent from the user. These activities has the following characteristics:
                //    - They do not have `channelData['webchat:send-status']`;
                //    - They do not have an ongoing `postActivitySaga`;
                //    - They should not previously appear in the chat history.
                // 2. We need to mark these activities as "sent".
                //
                // In the future, when we revamp our object model, we could use a different signal so we don't need the code below, for example:
                //
                // -  If `activity.id` is set, it is "sent", because the chat service assigned an ID to the activity;
                // -  If `activity.id` is not set, it is either "sending" or "send failed";
                //    - If `activity.channelData['webchat:send-failed-reason']` is set, it is "send failed" with the reason, otherwise;
                //    - It is sending.
                if (_activity2.from.role === "user") {
                    var _activity3 = _activity2, id = _activity3.id;
                    var clientActivityID = $d93828abd5d8ef12$var$getClientActivityID(_activity2);
                    var existingActivity = state.find(function(activity) {
                        return clientActivityID && $d93828abd5d8ef12$var$getClientActivityID(activity) === clientActivityID || id && activity.id === id;
                    });
                    if (existingActivity) {
                        var sendStatus = existingActivity.channelData["webchat:send-status"];
                        if (sendStatus === $jsYZG.SENDING || sendStatus === $jsYZG.SEND_FAILED || sendStatus === $jsYZG.SENT) _activity2 = (0, $d93828abd5d8ef12$var$_simpleUpdateIn["default"])(_activity2, [
                            "channelData",
                            "webchat:send-status"
                        ], function() {
                            return sendStatus;
                        });
                    } else // If there are no existing activity, probably this activity is restored from chat history.
                    // All outgoing activities restored from service means they arrived at the service successfully.
                    // Thus, we are marking them as "sent".
                    _activity2 = (0, $d93828abd5d8ef12$var$_simpleUpdateIn["default"])(_activity2, [
                        "channelData",
                        "webchat:send-status"
                    ], function() {
                        return $jsYZG.SENT;
                    });
                }
                state = $d93828abd5d8ef12$var$upsertActivityWithSort(state, _activity2, ponyfill);
                break;
            default:
                break;
        }
        return state;
    };
}

});
parcelRequire.register("7qq3H", function(module, exports) {
!function(t, e) {
    module.exports = e();
}(module.exports, function() {
    "use strict";
    function l(t) {
        return (l = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t) {
            return typeof t;
        } : function(t) {
            return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
        })(t);
    }
    function c(t, e, r, n, o, a, i) {
        try {
            var u = t[a](i), c = u.value;
        } catch (t) {
            return void r(t);
        }
        u.done ? e(c) : Promise.resolve(c).then(n, o);
    }
    function t(u) {
        return function() {
            var t = this, i = arguments;
            return new Promise(function(e, r) {
                var n = u.apply(t, i);
                function o(t) {
                    c(n, e, r, o, a, "next", t);
                }
                function a(t) {
                    c(n, e, r, o, a, "throw", t);
                }
                o(void 0);
            });
        };
    }
    function p(t, e, r) {
        return e in t ? Object.defineProperty(t, e, {
            value: r,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }) : t[e] = r, t;
    }
    function n(e, t) {
        var r, n = Object.keys(e);
        return Object.getOwnPropertySymbols && (r = Object.getOwnPropertySymbols(e), t && (r = r.filter(function(t) {
            return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), n.push.apply(n, r)), n;
    }
    function y(e) {
        for(var t = 1; t < arguments.length; t++){
            var r = null != arguments[t] ? arguments[t] : {};
            t % 2 ? n(Object(r), !0).forEach(function(t) {
                p(e, t, r[t]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : n(Object(r)).forEach(function(t) {
                Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
            });
        }
        return e;
    }
    function b(t) {
        return function(t) {
            if (Array.isArray(t)) return t;
        }(t) || e(t) || u(t) || function() {
            throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
        }();
    }
    function v(t) {
        return function(t) {
            if (Array.isArray(t)) return o(t);
        }(t) || e(t) || u(t) || function() {
            throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
        }();
    }
    function e(t) {
        if ("undefined" != typeof Symbol && Symbol.iterator in Object(t)) return Array.from(t);
    }
    function u(t, e) {
        if (t) {
            if ("string" == typeof t) return o(t, e);
            var r = Object.prototype.toString.call(t).slice(8, -1);
            return "Object" === r && t.constructor && (r = t.constructor.name), "Map" === r || "Set" === r ? Array.from(t) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? o(t, e) : void 0;
        }
    }
    function o(t, e) {
        (null == e || e > t.length) && (e = t.length);
        for(var r = 0, n = new Array(e); r < e; r++)n[r] = t[r];
        return n;
    }
    function f(t) {
        if ("undefined" == typeof Symbol || null == t[Symbol.iterator]) {
            if (Array.isArray(t) || (t = u(t))) {
                var e = 0, r = function() {};
                return {
                    s: r,
                    n: function() {
                        return e >= t.length ? {
                            done: !0
                        } : {
                            done: !1,
                            value: t[e++]
                        };
                    },
                    e: function(t) {
                        throw t;
                    },
                    f: r
                };
            }
            throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
        }
        var n, o, a = !0, i = !1;
        return {
            s: function() {
                n = t[Symbol.iterator]();
            },
            n: function() {
                var t = n.next();
                return a = t.done, t;
            },
            e: function(t) {
                i = !0, o = t;
            },
            f: function() {
                try {
                    a || null == n.return || n.return();
                } finally{
                    if (i) throw o;
                }
            }
        };
    }
    var d = Object.is || function(t, e) {
        return t === e ? 0 !== t || 1 / t == 1 / e : t != t && e != e;
    };
    function r(t, e, r) {
        s(e);
        var n, o = f(function t(e, r) {
            if (!r.length) return;
            var n = b(r), o = n[0], a = n.slice(1);
            if ("function" == typeof o) {
                var i = [];
                if (Array.isArray(e)) for(var u = 0, c = e.length; u < c; u++)o.call(e, e[u], u) && i.push.apply(i, v(t(e, [
                    u
                ].concat(v(a)))));
                else for(var f in e || {})o.call(e, e[f], f) && i.push.apply(i, v(t(e, [
                    f
                ].concat(v(a)))));
                return i;
            }
            var s = t(void 0 !== e && e[o], a);
            return s ? s.map(function(t) {
                return [
                    o
                ].concat(v(t));
            }) : [
                [
                    o
                ]
            ];
        }(t, e));
        try {
            for(o.s(); !(n = o.n()).done;){
                var a = n.value;
                t = g(t, a, r ? r(x(t, a)) : void 0);
            }
        } catch (t) {
            o.e(t);
        } finally{
            o.f();
        }
        return t;
    }
    function a() {
        return (a = t(regeneratorRuntime.mark(function t(e, r, n) {
            var o, a, i, u;
            return regeneratorRuntime.wrap(function(t) {
                for(;;)switch(t.prev = t.next){
                    case 0:
                        return s(r), t.next = 3, h(e, r);
                    case 3:
                        o = t.sent, a = f(o), t.prev = 5, a.s();
                    case 7:
                        if ((i = a.n()).done) {
                            t.next = 23;
                            break;
                        }
                        if (u = i.value, t.t0 = g, t.t1 = e, t.t2 = u, n) return t.next = 15, n(x(e, u));
                        t.next = 18;
                        break;
                    case 15:
                        t.t3 = t.sent, t.next = 19;
                        break;
                    case 18:
                        t.t3 = void 0;
                    case 19:
                        t.t4 = t.t3, e = (0, t.t0)(t.t1, t.t2, t.t4);
                    case 21:
                        t.next = 7;
                        break;
                    case 23:
                        t.next = 28;
                        break;
                    case 25:
                        t.prev = 25, t.t5 = t.catch(5), a.e(t.t5);
                    case 28:
                        return t.prev = 28, a.f(), t.finish(28);
                    case 31:
                        return t.abrupt("return", e);
                    case 32:
                    case "end":
                        return t.stop();
                }
            }, t, null, [
                [
                    5,
                    25,
                    28,
                    31
                ]
            ]);
        }))).apply(this, arguments);
    }
    function s(t) {
        if (!Array.isArray(t)) throw new Error("path must be an array");
    }
    r.updateInAsync = function(t, e, r) {
        return a.apply(this, arguments);
    };
    var m = [
        "__proto__",
        "constructor",
        "prototype"
    ];
    function h() {
        return i.apply(this, arguments);
    }
    function i() {
        return (i = t(regeneratorRuntime.mark(function t(e, r) {
            var n, o, a, i, u, c, f, s;
            return regeneratorRuntime.wrap(function(t) {
                for(;;)switch(t.prev = t.next){
                    case 0:
                        if (r.length) {
                            t.next = 2;
                            break;
                        }
                        return t.abrupt("return");
                    case 2:
                        if (n = b(r), o = n[0], a = n.slice(1), "function" != typeof o) {
                            t.next = 43;
                            break;
                        }
                        if (i = [], !Array.isArray(e)) {
                            t.next = 25;
                            break;
                        }
                        u = 0, c = e.length;
                    case 7:
                        if (u < c) return t.next = 10, o.call(e, e[u], u);
                        t.next = 23;
                        break;
                    case 10:
                        if (t.t0 = t.sent, t.t0) return t.t1 = i.push, t.t2 = i, t.t3 = v, t.next = 17, h(e, [
                            u
                        ].concat(v(a)));
                        t.next = 20;
                        break;
                    case 17:
                        t.t4 = t.sent, t.t5 = (0, t.t3)(t.t4), t.t1.apply.call(t.t1, t.t2, t.t5);
                    case 20:
                        u++, t.next = 7;
                        break;
                    case 23:
                        t.next = 42;
                        break;
                    case 25:
                        t.t6 = regeneratorRuntime.keys(e || {});
                    case 26:
                        if ((t.t7 = t.t6()).done) {
                            t.next = 42;
                            break;
                        }
                        return f = t.t7.value, t.next = 30, o.call(e, e[f], f);
                    case 30:
                        if (t.t8 = t.sent, t.t8) return t.t9 = i.push, t.t10 = i, t.t11 = v, t.next = 37, h(e, [
                            f
                        ].concat(v(a)));
                        t.next = 40;
                        break;
                    case 37:
                        t.t12 = t.sent, t.t13 = (0, t.t11)(t.t12), t.t9.apply.call(t.t9, t.t10, t.t13);
                    case 40:
                        t.next = 26;
                        break;
                    case 42:
                        return t.abrupt("return", i);
                    case 43:
                        return t.next = 45, h(void 0 !== e && e[o], a);
                    case 45:
                        return s = t.sent, t.abrupt("return", s ? s.map(function(t) {
                            return [
                                o
                            ].concat(v(t));
                        }) : [
                            [
                                o
                            ]
                        ]);
                    case 47:
                    case "end":
                        return t.stop();
                }
            }, t);
        }))).apply(this, arguments);
    }
    function x(t, e) {
        return e.reduce(function(t, e) {
            return t && t[e];
        }, t);
    }
    function g(t, e, r) {
        if (!e.length) return r;
        var n, o = b(e), a = o[0], i = o.slice(1), u = void 0 !== t && t[a], c = t;
        if (n = a, m.includes(n)) return t;
        if ("string" != typeof a || "object" === l(c) && !Array.isArray(c) ? "number" != typeof a || Array.isArray(c) || (c = []) : c = {}, "number" == typeof a) {
            var f = g(u, i, r);
            return void 0 === f ? void 0 === t ? t : (a in c && (c = v(c)).splice(a, 1), c) : d(f, u) ? t : ((c = v(c))[a] = f, c);
        }
        var s = g(u, i, r);
        return void 0 === s ? void 0 === t ? t : (a in c && delete (c = y({}, c))[a], c) : d(s, u) ? t : y(y({}, c), {}, p({}, a, s));
    }
    return r;
});

});

parcelRequire.register("d3IPn", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = module.exports.DELETE_ACTIVITY = void 0;
var $981e5402fd3f239e$var$DELETE_ACTIVITY = "DIRECT_LINE/DELETE_ACTIVITY";
module.exports.DELETE_ACTIVITY = $981e5402fd3f239e$var$DELETE_ACTIVITY;
function $981e5402fd3f239e$var$deleteActivity(activityID) {
    return {
        type: $981e5402fd3f239e$var$DELETE_ACTIVITY,
        payload: {
            activityID: activityID
        }
    };
}
var $981e5402fd3f239e$var$_default = $981e5402fd3f239e$var$deleteActivity;
module.exports["default"] = $981e5402fd3f239e$var$_default;

});

parcelRequire.register("89rfh", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = module.exports.INCOMING_ACTIVITY = void 0;
var $5ef44c59ffe1a98a$var$INCOMING_ACTIVITY = "DIRECT_LINE/INCOMING_ACTIVITY";
module.exports.INCOMING_ACTIVITY = $5ef44c59ffe1a98a$var$INCOMING_ACTIVITY;
function $5ef44c59ffe1a98a$var$incomingActivity(activity) {
    return {
        type: $5ef44c59ffe1a98a$var$INCOMING_ACTIVITY,
        payload: {
            activity: activity
        }
    };
}
var $5ef44c59ffe1a98a$var$_default = $5ef44c59ffe1a98a$var$incomingActivity;
module.exports["default"] = $5ef44c59ffe1a98a$var$_default;

});

parcelRequire.register("ciuoj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = module.exports.MARK_ACTIVITY = void 0;
var $8f3ebd8a51999f13$var$MARK_ACTIVITY = "WEB_CHAT/MARK_ACTIVITY";
module.exports.MARK_ACTIVITY = $8f3ebd8a51999f13$var$MARK_ACTIVITY;
function $8f3ebd8a51999f13$var$markActivity(_ref, name, value) {
    var activityID = _ref.id;
    return {
        type: $8f3ebd8a51999f13$var$MARK_ACTIVITY,
        payload: {
            activityID: activityID,
            name: name,
            value: value
        }
    };
}
var $8f3ebd8a51999f13$var$_default = $8f3ebd8a51999f13$var$markActivity;
module.exports["default"] = $8f3ebd8a51999f13$var$_default;

});

parcelRequire.register("lnNkF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = module.exports.POST_ACTIVITY_REJECTED = module.exports.POST_ACTIVITY_PENDING = module.exports.POST_ACTIVITY_IMPEDED = module.exports.POST_ACTIVITY_FULFILLED = module.exports.POST_ACTIVITY = void 0;
var $f912034e5bfd8eff$var$POST_ACTIVITY = "DIRECT_LINE/POST_ACTIVITY";
module.exports.POST_ACTIVITY = $f912034e5bfd8eff$var$POST_ACTIVITY;
var $f912034e5bfd8eff$var$POST_ACTIVITY_FULFILLED = "".concat($f912034e5bfd8eff$var$POST_ACTIVITY, "_FULFILLED");
module.exports.POST_ACTIVITY_FULFILLED = $f912034e5bfd8eff$var$POST_ACTIVITY_FULFILLED;
var $f912034e5bfd8eff$var$POST_ACTIVITY_IMPEDED = "".concat($f912034e5bfd8eff$var$POST_ACTIVITY, "_IMPEDED");
module.exports.POST_ACTIVITY_IMPEDED = $f912034e5bfd8eff$var$POST_ACTIVITY_IMPEDED;
var $f912034e5bfd8eff$var$POST_ACTIVITY_PENDING = "".concat($f912034e5bfd8eff$var$POST_ACTIVITY, "_PENDING");
module.exports.POST_ACTIVITY_PENDING = $f912034e5bfd8eff$var$POST_ACTIVITY_PENDING;
var $f912034e5bfd8eff$var$POST_ACTIVITY_REJECTED = "".concat($f912034e5bfd8eff$var$POST_ACTIVITY, "_REJECTED");
module.exports.POST_ACTIVITY_REJECTED = $f912034e5bfd8eff$var$POST_ACTIVITY_REJECTED;
function $f912034e5bfd8eff$var$postActivity(activity) {
    var method = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "keyboard";
    return {
        type: $f912034e5bfd8eff$var$POST_ACTIVITY,
        meta: {
            method: method
        },
        payload: {
            activity: activity
        }
    };
}
var $f912034e5bfd8eff$var$_default = $f912034e5bfd8eff$var$postActivity;
module.exports["default"] = $f912034e5bfd8eff$var$_default;

});

parcelRequire.register("jsYZG", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SENT = module.exports.SEND_FAILED = module.exports.SENDING = void 0;
// This type is only for this package only and help reducing size of the bundle.
// Externals should use the string literal directly instead.
// TODO: [P3] #4040 When improve treeshaking with named exports, we could export internals from `core` package.
//       import { SENDING, SEND_FAILED, SENT } from 'botframework-webchat-core/internal/SendStatus';
var $e2bff1fce4e54d54$var$SENDING = "sending";
module.exports.SENDING = $e2bff1fce4e54d54$var$SENDING;
var $e2bff1fce4e54d54$var$SEND_FAILED = "send failed";
module.exports.SEND_FAILED = $e2bff1fce4e54d54$var$SEND_FAILED;
var $e2bff1fce4e54d54$var$SENT = "sent";
module.exports.SENT = $e2bff1fce4e54d54$var$SENT;

});


parcelRequire.register("aaSXY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = $768579b78a07345e$var$createInternalReducer;
/**
 * Creates a Redux reducer to store the ponyfill.
 *
 * The ponyfill is used to check if React and Redux does not use a matching ponyfill.
 */ function $768579b78a07345e$var$createInternalReducer(ponyfill) {
    return function() {
        return {
            ponyfill: ponyfill
        };
    };
}

});

parcelRequire.register("8aEFh", function(module, exports) {
"use strict";

var $8usDI = parcelRequire("8usDI");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = $5f2ecd17e4a4473e$var$createNotificationsReducer;

var $5f2ecd17e4a4473e$var$_simpleUpdateIn = $8usDI((parcelRequire("7qq3H")));

var $cIHCl = parcelRequire("cIHCl");

var $1Kju1 = parcelRequire("1Kju1");

var $11xig = parcelRequire("11xig");

var $5f2ecd17e4a4473e$var$_isForbiddenPropertyName = $8usDI((parcelRequire("1BBNC")));
var $5f2ecd17e4a4473e$var$DEFAULT_STATE = {};
function $5f2ecd17e4a4473e$var$createNotificationsReducer(_ref) {
    var Date = _ref.Date;
    return function notifications() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : $5f2ecd17e4a4473e$var$DEFAULT_STATE;
        var action = arguments.length > 1 ? arguments[1] : undefined;
        var type = action.type;
        var now = Date.now();
        if (type === $cIHCl.DISMISS_NOTIFICATION) state = (0, $5f2ecd17e4a4473e$var$_simpleUpdateIn["default"])(state, [
            action.payload.id
        ]);
        else if (type === $1Kju1.SAGA_ERROR) state = (0, $5f2ecd17e4a4473e$var$_simpleUpdateIn["default"])(state, [
            "connectivitystatus",
            "message"
        ], function() {
            return "javascripterror";
        });
        else if (type === $11xig.SET_NOTIFICATION) {
            var _action$payload = action.payload, alt = _action$payload.alt, data = _action$payload.data, id = _action$payload.id, level = _action$payload.level, message = _action$payload.message;
            if (!(0, $5f2ecd17e4a4473e$var$_isForbiddenPropertyName["default"])(id)) {
                // Mitigated through denylisting.
                // eslint-disable-next-line security/detect-object-injection
                var notification = state[id];
                if (!notification || alt !== notification.alt || !Object.is(data, notification.data) || level !== notification.level || message !== notification.message) state = (0, $5f2ecd17e4a4473e$var$_simpleUpdateIn["default"])(state, [
                    id
                ], function() {
                    return {
                        alt: alt,
                        data: data,
                        id: id,
                        level: level,
                        message: message,
                        timestamp: now
                    };
                });
            }
        }
        return state;
    };
}

});
parcelRequire.register("cIHCl", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = module.exports.DISMISS_NOTIFICATION = void 0;
var $942b6d97c4f32d9d$var$DISMISS_NOTIFICATION = "WEB_CHAT/DISMISS_NOTIFICATION";
module.exports.DISMISS_NOTIFICATION = $942b6d97c4f32d9d$var$DISMISS_NOTIFICATION;
function $942b6d97c4f32d9d$var$dismissNotification(id) {
    return {
        payload: {
            id: id
        },
        type: $942b6d97c4f32d9d$var$DISMISS_NOTIFICATION
    };
}
var $942b6d97c4f32d9d$var$_default = $942b6d97c4f32d9d$var$dismissNotification;
module.exports["default"] = $942b6d97c4f32d9d$var$_default;

});

parcelRequire.register("1Kju1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SAGA_ERROR = void 0;
module.exports["default"] = $1459334e4dc3f35b$var$sagaError;
var $1459334e4dc3f35b$var$SAGA_ERROR = "WEB_CHAT/SAGA_ERROR";
module.exports.SAGA_ERROR = $1459334e4dc3f35b$var$SAGA_ERROR;
function $1459334e4dc3f35b$var$sagaError() {
    return {
        type: $1459334e4dc3f35b$var$SAGA_ERROR
    };
}

});

parcelRequire.register("11xig", function(module, exports) {
"use strict";

var $8usDI = parcelRequire("8usDI");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SET_NOTIFICATION = void 0;
module.exports["default"] = $0befb5db6cf3a579$var$setNotification;

var $0befb5db6cf3a579$var$_uniqueID = $8usDI((parcelRequire("cvpfA")));
var $0befb5db6cf3a579$var$SET_NOTIFICATION = "WEB_CHAT/SET_NOTIFICATION";
module.exports.SET_NOTIFICATION = $0befb5db6cf3a579$var$SET_NOTIFICATION;
function $0befb5db6cf3a579$var$setNotification(_ref) {
    var alt = _ref.alt, data = _ref.data, id = _ref.id, level = _ref.level, message = _ref.message;
    if (!id || typeof id !== "string") {
        console.warn('botframework-webchat: The "id" argument passed to "setNotification" must be a string; defaulting to a random value.');
        id = (0, $0befb5db6cf3a579$var$_uniqueID["default"])();
    }
    if (!level || typeof level !== "string") {
        console.warn('botframework-webchat: The "level" argument passed to "setNotification" must be a string; defaulting to "info".');
        level = "info";
    }
    return {
        type: $0befb5db6cf3a579$var$SET_NOTIFICATION,
        payload: {
            alt: alt,
            data: data,
            id: id,
            level: level,
            message: message
        }
    };
}

});
parcelRequire.register("cvpfA", function(module, exports) {
"use strict";

var $8usDI = parcelRequire("8usDI");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = $91abf780225453b9$var$uniqueID;

var $91abf780225453b9$var$_mathRandom = $8usDI((parcelRequire("atZsr")));
/* eslint no-magic-numbers: ["error", { "ignore": [2, 36] }] */ function $91abf780225453b9$var$uniqueID() {
    return (0, $91abf780225453b9$var$_mathRandom["default"])().toString(36).substring(2);
}

});
parcelRequire.register("atZsr", function(module, exports) {

module.exports = function(crypto) {
    if (!crypto) return Math.random;
    var max = Math.pow(2, 32);
    var u32 = new Uint32Array(1);
    return function random() {
        return crypto.getRandomValues(u32)[0] / max;
    };
}((parcelRequire("b9nAV")));

});
parcelRequire.register("b9nAV", function(module, exports) {
var $81e2d65fa825ffaf$var$global = typeof window !== "undefined" ? window : self;
module.exports = $81e2d65fa825ffaf$var$global.crypto || $81e2d65fa825ffaf$var$global.msCrypto;

});




parcelRequire.register("1BBNC", function(module, exports) {
"use strict";

var $8usDI = parcelRequire("8usDI");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = $12b6914818db3b90$var$isForbiddenPropertyName;

var $12b6914818db3b90$var$_toConsumableArray2 = $8usDI((parcelRequire("2NQov")));
var $12b6914818db3b90$var$FORBIDDEN_PROPERTY_NAMES;
function $12b6914818db3b90$var$getForbiddenPropertyNames() {
    return $12b6914818db3b90$var$FORBIDDEN_PROPERTY_NAMES || ($12b6914818db3b90$var$FORBIDDEN_PROPERTY_NAMES = Object.freeze(Array.from(new Set([].concat((0, $12b6914818db3b90$var$_toConsumableArray2["default"])(Object.getOwnPropertyNames(Object.prototype)), [
        "prototype"
    ])))));
}
function $12b6914818db3b90$var$isForbiddenPropertyName(propertyName) {
    return $12b6914818db3b90$var$getForbiddenPropertyNames().includes(propertyName);
}

});
parcelRequire.register("2NQov", function(module, exports) {

var $3iKPJ = parcelRequire("3iKPJ");

var $5uRVr = parcelRequire("5uRVr");

var $2NDUB = parcelRequire("2NDUB");

var $crEh5 = parcelRequire("crEh5");
function $20a8ccc3eacd7e00$var$_toConsumableArray(arr) {
    return $3iKPJ(arr) || $5uRVr(arr) || $2NDUB(arr) || $crEh5();
}
module.exports = $20a8ccc3eacd7e00$var$_toConsumableArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRequire.register("3iKPJ", function(module, exports) {

var $elBFx = parcelRequire("elBFx");
function $267761b152cb7ea1$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $elBFx(arr);
}
module.exports = $267761b152cb7ea1$var$_arrayWithoutHoles, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRequire.register("elBFx", function(module, exports) {
function $a7203f1cbbf0ca6f$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
module.exports = $a7203f1cbbf0ca6f$var$_arrayLikeToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRequire.register("5uRVr", function(module, exports) {
function $4009959715ad5385$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
module.exports = $4009959715ad5385$var$_iterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRequire.register("2NDUB", function(module, exports) {

var $elBFx = parcelRequire("elBFx");
function $209f1e13823aadef$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $elBFx(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $elBFx(o, minLen);
}
module.exports = $209f1e13823aadef$var$_unsupportedIterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRequire.register("crEh5", function(module, exports) {
function $90f73f5c6febcacd$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
module.exports = $90f73f5c6febcacd$var$_nonIterableSpread, module.exports.__esModule = true, module.exports["default"] = module.exports;

});




parcelRequire.register("iN8Vt", function(module, exports) {
"use strict";

var $8usDI = parcelRequire("8usDI");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = $dae3ba1a39600964$var$createLastTypingReducer;

var $dae3ba1a39600964$var$_simpleUpdateIn = $8usDI((parcelRequire("7qq3H")));

var $89rfh = parcelRequire("89rfh");

var $lnNkF = parcelRequire("lnNkF");
/* eslint no-case-declarations: "off" */ /* eslint no-unused-vars: "off" */ var $dae3ba1a39600964$var$DEFAULT_STATE = {};
function $dae3ba1a39600964$var$createLastTypingReducer(_ref) {
    var Date = _ref.Date;
    return function lastTyping() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : $dae3ba1a39600964$var$DEFAULT_STATE;
        var _ref2 = arguments.length > 1 ? arguments[1] : undefined, payload = _ref2.payload, type = _ref2.type;
        if (type === $89rfh.INCOMING_ACTIVITY || type === $lnNkF.POST_ACTIVITY_PENDING) {
            var _payload$activity = payload.activity, _payload$activity$fro = _payload$activity.from, id = _payload$activity$fro.id, name = _payload$activity$fro.name, role = _payload$activity$fro.role, activityType = _payload$activity.type;
            if (activityType === "typing") {
                var now = Date.now();
                state = (0, $dae3ba1a39600964$var$_simpleUpdateIn["default"])(state, [
                    id,
                    "at"
                ], function(at) {
                    return at || now;
                });
                state = (0, $dae3ba1a39600964$var$_simpleUpdateIn["default"])(state, [
                    id,
                    "last"
                ], function() {
                    return now;
                });
                state = (0, $dae3ba1a39600964$var$_simpleUpdateIn["default"])(state, [
                    id,
                    "name"
                ], function() {
                    return name;
                });
                state = (0, $dae3ba1a39600964$var$_simpleUpdateIn["default"])(state, [
                    id,
                    "role"
                ], function() {
                    return role;
                });
            } else if (activityType === "message") state = (0, $dae3ba1a39600964$var$_simpleUpdateIn["default"])(state, [
                id
            ]);
        }
        return state;
    };
}

});

parcelRequire.register("gcEGo", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = $bcbd531800ce681f$var$connectivityStatus;

var $dd04G = parcelRequire("dd04G");

var $hbk3x = parcelRequire("hbk3x");

var $arcsH = parcelRequire("arcsH");

var $1Kju1 = parcelRequire("1Kju1");
var $bcbd531800ce681f$var$DEFAULT_STATE = "uninitialized";
function $bcbd531800ce681f$var$connectivityStatus() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : $bcbd531800ce681f$var$DEFAULT_STATE;
    var _ref = arguments.length > 1 ? arguments[1] : undefined, type = _ref.type, meta = _ref.meta;
    if (state !== "sagaerror") switch(type){
        case $dd04G.CONNECT_PENDING:
        case $hbk3x.RECONNECT_PENDING:
            if (state !== "uninitialized") state = "reconnecting";
            break;
        case $dd04G.CONNECT_FULFILLED:
            state = "connected";
            break;
        case $hbk3x.RECONNECT_FULFILLED:
            state = "reconnected";
            break;
        case $dd04G.CONNECT_REJECTED:
            state = "error";
            break;
        case $dd04G.CONNECT_STILL_PENDING:
            state = "connectingslow";
            break;
        case $arcsH.DISCONNECT_FULFILLED:
            state = meta && meta.error ? "error" : "notconnected";
            break;
        case $1Kju1.SAGA_ERROR:
            state = "sagaerror";
            break;
        default:
            break;
    }
    return state;
}

});
parcelRequire.register("hbk3x", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RECONNECT_REJECTED = module.exports.RECONNECT_PENDING = module.exports.RECONNECT_FULFILLING = module.exports.RECONNECT_FULFILLED = module.exports.RECONNECT = void 0;
var $c8230573fda1a9db$var$RECONNECT = "DIRECT_LINE/RECONNECT";
module.exports.RECONNECT = $c8230573fda1a9db$var$RECONNECT;
var $c8230573fda1a9db$var$RECONNECT_FULFILLED = "".concat($c8230573fda1a9db$var$RECONNECT, "_FULFILLED");
module.exports.RECONNECT_FULFILLED = $c8230573fda1a9db$var$RECONNECT_FULFILLED;
var $c8230573fda1a9db$var$RECONNECT_FULFILLING = "".concat($c8230573fda1a9db$var$RECONNECT, "_FULFILLING");
module.exports.RECONNECT_FULFILLING = $c8230573fda1a9db$var$RECONNECT_FULFILLING;
var $c8230573fda1a9db$var$RECONNECT_PENDING = "".concat($c8230573fda1a9db$var$RECONNECT, "_PENDING");
module.exports.RECONNECT_PENDING = $c8230573fda1a9db$var$RECONNECT_PENDING;
var $c8230573fda1a9db$var$RECONNECT_REJECTED = "".concat($c8230573fda1a9db$var$RECONNECT, "_REJECTED");
module.exports.RECONNECT_REJECTED = $c8230573fda1a9db$var$RECONNECT_REJECTED;

});

parcelRequire.register("arcsH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DISCONNECT_REJECTED = module.exports.DISCONNECT_PENDING = module.exports.DISCONNECT_FULFILLED = module.exports.DISCONNECT = void 0;
module.exports["default"] = $799617ad2ae3b8f0$var$disconnect;
var $799617ad2ae3b8f0$var$DISCONNECT = "DIRECT_LINE/DISCONNECT";
module.exports.DISCONNECT = $799617ad2ae3b8f0$var$DISCONNECT;
var $799617ad2ae3b8f0$var$DISCONNECT_PENDING = "".concat($799617ad2ae3b8f0$var$DISCONNECT, "_PENDING");
module.exports.DISCONNECT_PENDING = $799617ad2ae3b8f0$var$DISCONNECT_PENDING;
var $799617ad2ae3b8f0$var$DISCONNECT_REJECTED = "".concat($799617ad2ae3b8f0$var$DISCONNECT, "_REJECTED");
module.exports.DISCONNECT_REJECTED = $799617ad2ae3b8f0$var$DISCONNECT_REJECTED;
var $799617ad2ae3b8f0$var$DISCONNECT_FULFILLED = "".concat($799617ad2ae3b8f0$var$DISCONNECT, "_FULFILLED");
module.exports.DISCONNECT_FULFILLED = $799617ad2ae3b8f0$var$DISCONNECT_FULFILLED;
function $799617ad2ae3b8f0$var$disconnect() {
    return {
        type: $799617ad2ae3b8f0$var$DISCONNECT
    };
}

});


parcelRequire.register("fqITb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = $b3bc1abc0647a997$var$dictateInterims;

var $5LTDK = parcelRequire("5LTDK");
var $b3bc1abc0647a997$var$DEFAULT_STATE = [];
function $b3bc1abc0647a997$var$dictateInterims() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : $b3bc1abc0647a997$var$DEFAULT_STATE;
    var _ref = arguments.length > 1 ? arguments[1] : undefined, payload = _ref.payload, type = _ref.type;
    switch(type){
        case $5LTDK.SET_DICTATE_INTERIMS:
            state = payload.dictateInterims;
            break;
        default:
            break;
    }
    return state;
}

});
parcelRequire.register("5LTDK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SET_DICTATE_INTERIMS = void 0;
module.exports["default"] = $433c8085609adfc6$var$setDictateInterims;
var $433c8085609adfc6$var$SET_DICTATE_INTERIMS = "WEB_CHAT/SET_DICTATE_INTERIMS";
module.exports.SET_DICTATE_INTERIMS = $433c8085609adfc6$var$SET_DICTATE_INTERIMS;
function $433c8085609adfc6$var$setDictateInterims(dictateInterims) {
    return {
        type: $433c8085609adfc6$var$SET_DICTATE_INTERIMS,
        payload: {
            dictateInterims: dictateInterims
        }
    };
}

});


parcelRequire.register("9pAzK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = $6da2d1fc04ce7368$var$dictateState;

var $5iNAf = parcelRequire("5iNAf");

var $eKwpg = parcelRequire("eKwpg");

var $1tniU = parcelRequire("1tniU");

var $5Nb9e = parcelRequire("5Nb9e");
var $6da2d1fc04ce7368$var$DEFAULT_STATE = $5iNAf.IDLE;
function $6da2d1fc04ce7368$var$dictateState() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : $6da2d1fc04ce7368$var$DEFAULT_STATE;
    var _ref = arguments.length > 1 ? arguments[1] : undefined, payload = _ref.payload, type = _ref.type;
    switch(type){
        case $eKwpg.SET_DICTATE_STATE:
            state = payload.dictateState;
            break;
        case $1tniU.START_DICTATE:
            if (state === $5iNAf.IDLE || state === $5iNAf.STOPPING || state === $5iNAf.WILL_START) state = $5iNAf.STARTING;
            break;
        case $5Nb9e.STOP_DICTATE:
            if (state === $5iNAf.STARTING || state === $5iNAf.DICTATING) state = $5iNAf.STOPPING;
            else if (state === $5iNAf.WILL_START) state = $5iNAf.IDLE;
            break;
        default:
            break;
    }
    return state;
}

});
parcelRequire.register("eKwpg", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SET_DICTATE_STATE = void 0;
module.exports["default"] = $abce7fd3283e701e$var$setDictateState;
var $abce7fd3283e701e$var$SET_DICTATE_STATE = "WEB_CHAT/SET_DICTATE_STATE";
module.exports.SET_DICTATE_STATE = $abce7fd3283e701e$var$SET_DICTATE_STATE;
function $abce7fd3283e701e$var$setDictateState(dictateState) {
    return {
        type: $abce7fd3283e701e$var$SET_DICTATE_STATE,
        payload: {
            dictateState: dictateState
        }
    };
}

});

parcelRequire.register("1tniU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.START_DICTATE = void 0;
module.exports["default"] = $112a9392a4162ef4$var$startDictate;
var $112a9392a4162ef4$var$START_DICTATE = "WEB_CHAT/START_DICTATE";
module.exports.START_DICTATE = $112a9392a4162ef4$var$START_DICTATE;
function $112a9392a4162ef4$var$startDictate() {
    return {
        type: $112a9392a4162ef4$var$START_DICTATE
    };
}

});

parcelRequire.register("5Nb9e", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.STOP_DICTATE = void 0;
module.exports["default"] = $437a2d19f5afb819$var$stopDictate;
var $437a2d19f5afb819$var$STOP_DICTATE = "WEB_CHAT/STOP_DICTATE";
module.exports.STOP_DICTATE = $437a2d19f5afb819$var$STOP_DICTATE;
function $437a2d19f5afb819$var$stopDictate() {
    return {
        type: $437a2d19f5afb819$var$STOP_DICTATE
    };
}

});


parcelRequire.register("cLEuH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = $94b9491b8316babf$var$language;

var $hx0hD = parcelRequire("hx0hD");
var $94b9491b8316babf$var$DEFAULT_STATE = "en-US";
function $94b9491b8316babf$var$language() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : $94b9491b8316babf$var$DEFAULT_STATE;
    var _ref = arguments.length > 1 ? arguments[1] : undefined, payload = _ref.payload, type = _ref.type;
    switch(type){
        case $hx0hD.SET_LANGUAGE:
            state = payload.language;
            break;
        default:
            break;
    }
    return state;
}

});
parcelRequire.register("hx0hD", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SET_LANGUAGE = void 0;
module.exports["default"] = $cc35bd04da800ea6$var$setLanguage;
var $cc35bd04da800ea6$var$SET_LANGUAGE = "WEB_CHAT/SET_LANGUAGE";
module.exports.SET_LANGUAGE = $cc35bd04da800ea6$var$SET_LANGUAGE;
function $cc35bd04da800ea6$var$setLanguage(language) {
    return {
        type: $cc35bd04da800ea6$var$SET_LANGUAGE,
        payload: {
            language: language
        }
    };
}

});


parcelRequire.register("4SrXH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = $38d1e53d4a9a6546$var$readyState;

var $iFJVn = parcelRequire("iFJVn");
var $38d1e53d4a9a6546$var$DEFAULT_STATE = 0;
function $38d1e53d4a9a6546$var$readyState() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : $38d1e53d4a9a6546$var$DEFAULT_STATE;
    var _ref = arguments.length > 1 ? arguments[1] : undefined, payload = _ref.payload, type = _ref.type;
    switch(type){
        case $iFJVn.CONNECTION_STATUS_UPDATE:
            state = payload.connectionStatus;
            break;
        default:
            break;
    }
    return state;
}

});
parcelRequire.register("iFJVn", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CONNECTION_STATUS_UPDATE = void 0;
module.exports["default"] = $d97fadf3aa49074b$var$connectionStatusUpdate;
// TODO: [P3] We should obsolete this action in favor of DIRECT_LINE/UPDATE_CONNECTION_STATUS.
//       But today, both actions behave differently, this one only dispatch after connected and not dispatched when disconnected.
var $d97fadf3aa49074b$var$CONNECTION_STATUS_UPDATE = "DIRECT_LINE/CONNECTION_STATUS_UPDATE";
module.exports.CONNECTION_STATUS_UPDATE = $d97fadf3aa49074b$var$CONNECTION_STATUS_UPDATE;
function $d97fadf3aa49074b$var$connectionStatusUpdate(connectionStatus) {
    return {
        type: $d97fadf3aa49074b$var$CONNECTION_STATUS_UPDATE,
        payload: {
            connectionStatus: connectionStatus
        }
    };
}

});


parcelRequire.register("8NAat", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = $667ef484eb51e758$var$referenceGrammarID;

var $i318c = parcelRequire("i318c");
var $667ef484eb51e758$var$DEFAULT_STATE = null;
function $667ef484eb51e758$var$referenceGrammarID() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : $667ef484eb51e758$var$DEFAULT_STATE;
    var _ref = arguments.length > 1 ? arguments[1] : undefined, payload = _ref.payload, type = _ref.type;
    switch(type){
        case $i318c.SET_REFERENCE_GRAMMAR_ID:
            state = payload.referenceGrammarID || null;
            break;
        default:
            break;
    }
    return state;
}

});
parcelRequire.register("i318c", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SET_REFERENCE_GRAMMAR_ID = void 0;
module.exports["default"] = $d239627818f7010a$var$setReferenceGrammarID;
var $d239627818f7010a$var$SET_REFERENCE_GRAMMAR_ID = "WEB_CHAT/SET_REFERENCE_GRAMMAR_ID";
module.exports.SET_REFERENCE_GRAMMAR_ID = $d239627818f7010a$var$SET_REFERENCE_GRAMMAR_ID;
function $d239627818f7010a$var$setReferenceGrammarID(referenceGrammarID) {
    return {
        type: $d239627818f7010a$var$SET_REFERENCE_GRAMMAR_ID,
        payload: {
            referenceGrammarID: referenceGrammarID
        }
    };
}

});


parcelRequire.register("4v3Uv", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = $346d1731b0a30081$var$sendBoxValue;

var $bu0xL = parcelRequire("bu0xL");
var $346d1731b0a30081$var$DEFAULT_STATE = "";
function $346d1731b0a30081$var$sendBoxValue() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : $346d1731b0a30081$var$DEFAULT_STATE;
    var _ref = arguments.length > 1 ? arguments[1] : undefined, payload = _ref.payload, type = _ref.type;
    switch(type){
        case $bu0xL.SET_SEND_BOX:
            state = payload.text;
            break;
        default:
            break;
    }
    return state;
}

});
parcelRequire.register("bu0xL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SET_SEND_BOX = void 0;
module.exports["default"] = $85c2eb04a599a637$var$setSendBox;
var $85c2eb04a599a637$var$SET_SEND_BOX = "WEB_CHAT/SET_SEND_BOX";
module.exports.SET_SEND_BOX = $85c2eb04a599a637$var$SET_SEND_BOX;
function $85c2eb04a599a637$var$setSendBox(text) {
    return {
        type: $85c2eb04a599a637$var$SET_SEND_BOX,
        payload: {
            text: text
        }
    };
}

});


parcelRequire.register("gPu4g", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = $03296e6168761a0d$var$sendTimeout;

var $9Ynym = parcelRequire("9Ynym");
var $03296e6168761a0d$var$DEFAULT_STATE = 20000;
function $03296e6168761a0d$var$sendTimeout() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : $03296e6168761a0d$var$DEFAULT_STATE;
    var _ref = arguments.length > 1 ? arguments[1] : undefined, payload = _ref.payload, type = _ref.type;
    switch(type){
        case $9Ynym.SET_SEND_TIMEOUT:
            state = payload.sendTimeout;
            break;
        default:
            break;
    }
    return state;
}

});
parcelRequire.register("9Ynym", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SET_SEND_TIMEOUT = void 0;
module.exports["default"] = $742bfcd4cd26c385$var$setSendTimeout;
var $742bfcd4cd26c385$var$SET_SEND_TIMEOUT = "WEB_CHAT/SET_SEND_TIMEOUT";
module.exports.SET_SEND_TIMEOUT = $742bfcd4cd26c385$var$SET_SEND_TIMEOUT;
function $742bfcd4cd26c385$var$setSendTimeout(sendTimeout) {
    return {
        type: $742bfcd4cd26c385$var$SET_SEND_TIMEOUT,
        payload: {
            sendTimeout: sendTimeout
        }
    };
}

});


parcelRequire.register("gwSkZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = $c089c8d1a891eb37$var$sendTypingIndicator;

var $gYgS6 = parcelRequire("gYgS6");
var $c089c8d1a891eb37$var$DEFAULT_STATE = false;
function $c089c8d1a891eb37$var$sendTypingIndicator() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : $c089c8d1a891eb37$var$DEFAULT_STATE;
    var _ref = arguments.length > 1 ? arguments[1] : undefined, payload = _ref.payload, type = _ref.type;
    switch(type){
        case $gYgS6.SET_SEND_TYPING_INDICATOR:
            state = payload.sendTypingIndicator;
            break;
        default:
            break;
    }
    return state;
}

});
parcelRequire.register("gYgS6", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SET_SEND_TYPING_INDICATOR = void 0;
module.exports["default"] = $c5af5645b8aab32f$var$setSendTypingIndicator;
var $c5af5645b8aab32f$var$SET_SEND_TYPING_INDICATOR = "WEB_CHAT/SET_SEND_TYPING_INDICATOR";
module.exports.SET_SEND_TYPING_INDICATOR = $c5af5645b8aab32f$var$SET_SEND_TYPING_INDICATOR;
function $c5af5645b8aab32f$var$setSendTypingIndicator(value) {
    return {
        payload: {
            sendTypingIndicator: !!value
        },
        type: $c5af5645b8aab32f$var$SET_SEND_TYPING_INDICATOR
    };
}

});


parcelRequire.register("3Hq1k", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = $2b199263177998f0$var$shouldSpeakIncomingActivity;

var $chC6e = parcelRequire("chC6e");

var $cbRU8 = parcelRequire("cbRU8");
function $2b199263177998f0$var$shouldSpeakIncomingActivity() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    var _ref = arguments.length > 1 ? arguments[1] : undefined, type = _ref.type;
    switch(type){
        case $chC6e.START_SPEAKING_ACTIVITY:
            state = true;
            break;
        case $cbRU8.STOP_SPEAKING_ACTIVITY:
            state = false;
            break;
        default:
            break;
    }
    return state;
}

});
parcelRequire.register("chC6e", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.START_SPEAKING_ACTIVITY = void 0;
module.exports["default"] = $8f14a059de3844f4$var$startSpeakingActivity;
var $8f14a059de3844f4$var$START_SPEAKING_ACTIVITY = "WEB_CHAT/START_SPEAKING";
module.exports.START_SPEAKING_ACTIVITY = $8f14a059de3844f4$var$START_SPEAKING_ACTIVITY;
function $8f14a059de3844f4$var$startSpeakingActivity() {
    return {
        type: $8f14a059de3844f4$var$START_SPEAKING_ACTIVITY
    };
}

});

parcelRequire.register("cbRU8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.STOP_SPEAKING_ACTIVITY = void 0;
module.exports["default"] = $8e00536b787bbb64$var$stopSpeakingActivity;
var $8e00536b787bbb64$var$STOP_SPEAKING_ACTIVITY = "WEB_CHAT/STOP_SPEAKING";
module.exports.STOP_SPEAKING_ACTIVITY = $8e00536b787bbb64$var$STOP_SPEAKING_ACTIVITY;
function $8e00536b787bbb64$var$stopSpeakingActivity() {
    return {
        type: $8e00536b787bbb64$var$STOP_SPEAKING_ACTIVITY
    };
}

});


parcelRequire.register("NKTom", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = $0958f393446bdaae$var$suggestedActions;

var $c2kkc = parcelRequire("c2kkc");

var $9fqWO = parcelRequire("9fqWO");
var $0958f393446bdaae$var$DEFAULT_STATE = [];
function $0958f393446bdaae$var$suggestedActions() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : $0958f393446bdaae$var$DEFAULT_STATE;
    var _ref = arguments.length > 1 ? arguments[1] : undefined, _ref$payload = _ref.payload, payload = _ref$payload === void 0 ? {} : _ref$payload, type = _ref.type;
    switch(type){
        case $9fqWO.SET_SUGGESTED_ACTIONS:
            if ((payload.suggestedActions || []).length) state = [].slice.call(payload.suggestedActions);
            else state = $0958f393446bdaae$var$DEFAULT_STATE;
            break;
        case $c2kkc.CLEAR_SUGGESTED_ACTIONS:
            state = $0958f393446bdaae$var$DEFAULT_STATE;
            break;
        default:
            break;
    }
    return state;
}

});
parcelRequire.register("9fqWO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SET_SUGGESTED_ACTIONS = void 0;
module.exports["default"] = $6bba6afb3f81e2cb$var$setSuggestedActions;
var $6bba6afb3f81e2cb$var$EMPTY_ARRAY = [];
var $6bba6afb3f81e2cb$var$SET_SUGGESTED_ACTIONS = "WEB_CHAT/SET_SUGGESTED_ACTIONS";
module.exports.SET_SUGGESTED_ACTIONS = $6bba6afb3f81e2cb$var$SET_SUGGESTED_ACTIONS;
function $6bba6afb3f81e2cb$var$setSuggestedActions() {
    var suggestedActions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : $6bba6afb3f81e2cb$var$EMPTY_ARRAY;
    return {
        type: $6bba6afb3f81e2cb$var$SET_SUGGESTED_ACTIONS,
        payload: {
            suggestedActions: suggestedActions
        }
    };
}

});



parcelRequire.register("4nGOs", function(module, exports) {
"use strict";

var $8usDI = parcelRequire("8usDI");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = $330a851fbfaa7f32$var$createSagas;

var $330a851fbfaa7f32$var$_regenerator = $8usDI((parcelRequire("7MKKk")));
parcelRequire("6Nc1h");
var $7McF6 = parcelRequire("7McF6");

var $330a851fbfaa7f32$var$_clearSuggestedActionsOnPostActivitySaga = $8usDI((parcelRequire("4XoSw")));

var $330a851fbfaa7f32$var$_connectionStatusToNotificationSaga = $8usDI((parcelRequire("iZ15U")));

var $330a851fbfaa7f32$var$_connectionStatusUpdateSaga = $8usDI((parcelRequire("8dbkx")));

var $330a851fbfaa7f32$var$_connectSaga = $8usDI((parcelRequire("ekmqx")));

var $330a851fbfaa7f32$var$_detectSlowConnectionSaga = $8usDI((parcelRequire("e2Nqh")));

var $330a851fbfaa7f32$var$_emitTypingIndicatorToPostActivitySaga = $8usDI((parcelRequire("9g9Uw")));

var $330a851fbfaa7f32$var$_markAllAsSpokenOnStopSpeakActivitySaga = $8usDI((parcelRequire("8uD3A")));

var $330a851fbfaa7f32$var$_observeActivitySaga = $8usDI((parcelRequire("keU8q")));

var $330a851fbfaa7f32$var$_postActivitySaga = $8usDI((parcelRequire("65J3X")));

var $330a851fbfaa7f32$var$_queueIncomingActivitySaga = $8usDI((parcelRequire("8zrav")));

var $330a851fbfaa7f32$var$_sendEventToPostActivitySaga = $8usDI((parcelRequire("gyTa8")));

var $330a851fbfaa7f32$var$_sendFilesToPostActivitySaga = $8usDI((parcelRequire("7Fci7")));

var $330a851fbfaa7f32$var$_sendMessageBackToPostActivitySaga = $8usDI((parcelRequire("1GBTh")));

var $330a851fbfaa7f32$var$_sendMessageToPostActivitySaga = $8usDI((parcelRequire("jgUWN")));

var $330a851fbfaa7f32$var$_sendPostBackToPostActivitySaga = $8usDI((parcelRequire("4tXts")));

var $330a851fbfaa7f32$var$_sendTypingIndicatorOnSetSendBoxSaga = $8usDI((parcelRequire("1tIUv")));

var $330a851fbfaa7f32$var$_speakActivityAndStartDictateOnIncomingActivityFromOthersSaga = $8usDI((parcelRequire("8dqf7")));

var $330a851fbfaa7f32$var$_startDictateOnSpeakCompleteSaga = $8usDI((parcelRequire("luGut")));

var $330a851fbfaa7f32$var$_startSpeakActivityOnPostActivitySaga = $8usDI((parcelRequire("dji9G")));

var $330a851fbfaa7f32$var$_stopDictateOnCardActionSaga = $8usDI((parcelRequire("8NJnY")));

var $330a851fbfaa7f32$var$_stopSpeakingActivityOnInputSaga = $8usDI((parcelRequire("bpTOL")));

var $330a851fbfaa7f32$var$_submitSendBoxSaga = $8usDI((parcelRequire("fpIvC")));
function $330a851fbfaa7f32$var$createSagas(_ref) {
    var ponyfill = _ref.ponyfill;
    return /*#__PURE__*/ $330a851fbfaa7f32$var$_regenerator["default"].mark(function _callee() {
        return $330a851fbfaa7f32$var$_regenerator["default"].wrap(function _callee$(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    _context.next = 2;
                    return (0, $7McF6.L)($330a851fbfaa7f32$var$_clearSuggestedActionsOnPostActivitySaga["default"]);
                case 2:
                    _context.next = 4;
                    return (0, $7McF6.L)($330a851fbfaa7f32$var$_connectionStatusToNotificationSaga["default"]);
                case 4:
                    _context.next = 6;
                    return (0, $7McF6.L)($330a851fbfaa7f32$var$_connectionStatusUpdateSaga["default"]);
                case 6:
                    _context.next = 8;
                    return (0, $7McF6.L)($330a851fbfaa7f32$var$_connectSaga["default"]);
                case 8:
                    _context.next = 10;
                    return (0, $7McF6.L)($330a851fbfaa7f32$var$_detectSlowConnectionSaga["default"], ponyfill);
                case 10:
                    _context.next = 12;
                    return (0, $7McF6.L)($330a851fbfaa7f32$var$_emitTypingIndicatorToPostActivitySaga["default"]);
                case 12:
                    _context.next = 14;
                    return (0, $7McF6.L)($330a851fbfaa7f32$var$_markAllAsSpokenOnStopSpeakActivitySaga["default"]);
                case 14:
                    _context.next = 16;
                    return (0, $7McF6.L)($330a851fbfaa7f32$var$_observeActivitySaga["default"]);
                case 16:
                    _context.next = 18;
                    return (0, $7McF6.L)($330a851fbfaa7f32$var$_postActivitySaga["default"], ponyfill);
                case 18:
                    _context.next = 20;
                    return (0, $7McF6.L)($330a851fbfaa7f32$var$_queueIncomingActivitySaga["default"], ponyfill);
                case 20:
                    _context.next = 22;
                    return (0, $7McF6.L)($330a851fbfaa7f32$var$_sendEventToPostActivitySaga["default"]);
                case 22:
                    _context.next = 24;
                    return (0, $7McF6.L)($330a851fbfaa7f32$var$_sendFilesToPostActivitySaga["default"]);
                case 24:
                    _context.next = 26;
                    return (0, $7McF6.L)($330a851fbfaa7f32$var$_sendMessageBackToPostActivitySaga["default"]);
                case 26:
                    _context.next = 28;
                    return (0, $7McF6.L)($330a851fbfaa7f32$var$_sendMessageToPostActivitySaga["default"]);
                case 28:
                    _context.next = 30;
                    return (0, $7McF6.L)($330a851fbfaa7f32$var$_sendPostBackToPostActivitySaga["default"]);
                case 30:
                    _context.next = 32;
                    return (0, $7McF6.L)($330a851fbfaa7f32$var$_sendTypingIndicatorOnSetSendBoxSaga["default"], ponyfill);
                case 32:
                    _context.next = 34;
                    return (0, $7McF6.L)($330a851fbfaa7f32$var$_speakActivityAndStartDictateOnIncomingActivityFromOthersSaga["default"]);
                case 34:
                    _context.next = 36;
                    return (0, $7McF6.L)($330a851fbfaa7f32$var$_startDictateOnSpeakCompleteSaga["default"]);
                case 36:
                    _context.next = 38;
                    return (0, $7McF6.L)($330a851fbfaa7f32$var$_startSpeakActivityOnPostActivitySaga["default"]);
                case 38:
                    _context.next = 40;
                    return (0, $7McF6.L)($330a851fbfaa7f32$var$_stopDictateOnCardActionSaga["default"]);
                case 40:
                    _context.next = 42;
                    return (0, $7McF6.L)($330a851fbfaa7f32$var$_stopSpeakingActivityOnInputSaga["default"]);
                case 42:
                    _context.next = 44;
                    return (0, $7McF6.L)($330a851fbfaa7f32$var$_submitSendBoxSaga["default"]);
                case 44:
                case "end":
                    return _context.stop();
            }
        }, _callee);
    });
}

});
parcelRequire.register("7MKKk", function(module, exports) {
// TODO(Babel 8): Remove this file.

var $5ab146ea02b70b67$var$runtime = (parcelRequire("epFi6"))();
module.exports = $5ab146ea02b70b67$var$runtime;
// Copied from https://github.com/facebook/regenerator/blob/main/packages/runtime/runtime.js#L736=
try {
    regeneratorRuntime = $5ab146ea02b70b67$var$runtime;
} catch (accidentalStrictMode) {
    if (typeof globalThis === "object") globalThis.regeneratorRuntime = $5ab146ea02b70b67$var$runtime;
    else Function("r", "regeneratorRuntime = r")($5ab146ea02b70b67$var$runtime);
}

});
parcelRequire.register("epFi6", function(module, exports) {

var $UAGsq = parcelRequire("UAGsq");
var $a7e36e0962b91888$var$_typeof = $UAGsq.default;
function $a7e36e0962b91888$var$_regeneratorRuntime() {
    "use strict";
    /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ module.exports = $a7e36e0962b91888$var$_regeneratorRuntime = function _regeneratorRuntime() {
        return exports;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports;
    var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
    function define(obj, key, value) {
        return Object.defineProperty(obj, key, {
            value: value,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }), obj[key];
    }
    try {
        define({}, "");
    } catch (err) {
        define = function define(obj, key, value) {
            return obj[key] = value;
        };
    }
    function wrap(innerFn, outerFn, self, tryLocsList) {
        var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []);
        return generator._invoke = function(innerFn, self, context) {
            var state = "suspendedStart";
            return function(method, arg) {
                if ("executing" === state) throw new Error("Generator is already running");
                if ("completed" === state) {
                    if ("throw" === method) throw arg;
                    return doneResult();
                }
                for(context.method = method, context.arg = arg;;){
                    var delegate = context.delegate;
                    if (delegate) {
                        var delegateResult = maybeInvokeDelegate(delegate, context);
                        if (delegateResult) {
                            if (delegateResult === ContinueSentinel) continue;
                            return delegateResult;
                        }
                    }
                    if ("next" === context.method) context.sent = context._sent = context.arg;
                    else if ("throw" === context.method) {
                        if ("suspendedStart" === state) throw state = "completed", context.arg;
                        context.dispatchException(context.arg);
                    } else "return" === context.method && context.abrupt("return", context.arg);
                    state = "executing";
                    var record = tryCatch(innerFn, self, context);
                    if ("normal" === record.type) {
                        if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue;
                        return {
                            value: record.arg,
                            done: context.done
                        };
                    }
                    "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg);
                }
            };
        }(innerFn, self, context), generator;
    }
    function tryCatch(fn, obj, arg) {
        try {
            return {
                type: "normal",
                arg: fn.call(obj, arg)
            };
        } catch (err) {
            return {
                type: "throw",
                arg: err
            };
        }
    }
    exports.wrap = wrap;
    var ContinueSentinel = {};
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    var IteratorPrototype = {};
    define(IteratorPrototype, iteratorSymbol, function() {
        return this;
    });
    var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([])));
    NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype);
    var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
    function defineIteratorMethods(prototype) {
        [
            "next",
            "throw",
            "return"
        ].forEach(function(method) {
            define(prototype, method, function(arg) {
                return this._invoke(method, arg);
            });
        });
    }
    function AsyncIterator(generator, PromiseImpl) {
        function invoke(method, arg, resolve, reject) {
            var record = tryCatch(generator[method], generator, arg);
            if ("throw" !== record.type) {
                var result = record.arg, value = result.value;
                return value && "object" == $a7e36e0962b91888$var$_typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function(value) {
                    invoke("next", value, resolve, reject);
                }, function(err) {
                    invoke("throw", err, resolve, reject);
                }) : PromiseImpl.resolve(value).then(function(unwrapped) {
                    result.value = unwrapped, resolve(result);
                }, function(error) {
                    return invoke("throw", error, resolve, reject);
                });
            }
            reject(record.arg);
        }
        var previousPromise;
        this._invoke = function(method, arg) {
            function callInvokeWithMethodAndArg() {
                return new PromiseImpl(function(resolve, reject) {
                    invoke(method, arg, resolve, reject);
                });
            }
            return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
        };
    }
    function maybeInvokeDelegate(delegate, context) {
        var method = delegate.iterator[context.method];
        if (undefined === method) {
            if (context.delegate = null, "throw" === context.method) {
                if (delegate.iterator["return"] && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel;
                context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method");
            }
            return ContinueSentinel;
        }
        var record = tryCatch(method, delegate.iterator, context.arg);
        if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel;
        var info = record.arg;
        return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel);
    }
    function pushTryEntry(locs) {
        var entry = {
            tryLoc: locs[0]
        };
        1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry);
    }
    function resetTryEntry(entry) {
        var record = entry.completion || {};
        record.type = "normal", delete record.arg, entry.completion = record;
    }
    function Context(tryLocsList) {
        this.tryEntries = [
            {
                tryLoc: "root"
            }
        ], tryLocsList.forEach(pushTryEntry, this), this.reset(!0);
    }
    function values(iterable) {
        if (iterable) {
            var iteratorMethod = iterable[iteratorSymbol];
            if (iteratorMethod) return iteratorMethod.call(iterable);
            if ("function" == typeof iterable.next) return iterable;
            if (!isNaN(iterable.length)) {
                var i = -1, next = function next() {
                    for(; ++i < iterable.length;){
                        if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next;
                    }
                    return next.value = undefined, next.done = !0, next;
                };
                return next.next = next;
            }
        }
        return {
            next: doneResult
        };
    }
    function doneResult() {
        return {
            value: undefined,
            done: !0
        };
    }
    return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function(genFun) {
        var ctor = "function" == typeof genFun && genFun.constructor;
        return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name));
    }, exports.mark = function(genFun) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun;
    }, exports.awrap = function(arg) {
        return {
            __await: arg
        };
    }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function() {
        return this;
    }), exports.AsyncIterator = AsyncIterator, exports.async = function(innerFn, outerFn, self, tryLocsList, PromiseImpl) {
        void 0 === PromiseImpl && (PromiseImpl = Promise);
        var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
        return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function(result) {
            return result.done ? result.value : iter.next();
        });
    }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function() {
        return this;
    }), define(Gp, "toString", function() {
        return "[object Generator]";
    }), exports.keys = function(object) {
        var keys = [];
        for(var key in object)keys.push(key);
        return keys.reverse(), function next() {
            for(; keys.length;){
                var key = keys.pop();
                if (key in object) return next.value = key, next.done = !1, next;
            }
            return next.done = !0, next;
        };
    }, exports.values = values, Context.prototype = {
        constructor: Context,
        reset: function reset(skipTempReset) {
            if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for(var name in this)"t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined);
        },
        stop: function stop() {
            this.done = !0;
            var rootRecord = this.tryEntries[0].completion;
            if ("throw" === rootRecord.type) throw rootRecord.arg;
            return this.rval;
        },
        dispatchException: function dispatchException(exception) {
            if (this.done) throw exception;
            var context = this;
            function handle(loc, caught) {
                return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught;
            }
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i], record = entry.completion;
                if ("root" === entry.tryLoc) return handle("end");
                if (entry.tryLoc <= this.prev) {
                    var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc");
                    if (hasCatch && hasFinally) {
                        if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
                        if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
                    } else if (hasCatch) {
                        if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
                    } else {
                        if (!hasFinally) throw new Error("try statement without catch or finally");
                        if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
                    }
                }
            }
        },
        abrupt: function abrupt(type, arg) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
                    var finallyEntry = entry;
                    break;
                }
            }
            finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null);
            var record = finallyEntry ? finallyEntry.completion : {};
            return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record);
        },
        complete: function complete(record, afterLoc) {
            if ("throw" === record.type) throw record.arg;
            return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel;
        },
        finish: function finish(finallyLoc) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel;
            }
        },
        "catch": function _catch(tryLoc) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.tryLoc === tryLoc) {
                    var record = entry.completion;
                    if ("throw" === record.type) {
                        var thrown = record.arg;
                        resetTryEntry(entry);
                    }
                    return thrown;
                }
            }
            throw new Error("illegal catch attempt");
        },
        delegateYield: function delegateYield(iterable, resultName, nextLoc) {
            return this.delegate = {
                iterator: values(iterable),
                resultName: resultName,
                nextLoc: nextLoc
            }, "next" === this.method && (this.arg = undefined), ContinueSentinel;
        }
    }, exports;
}
module.exports = $a7e36e0962b91888$var$_regeneratorRuntime, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRequire.register("UAGsq", function(module, exports) {
function $0aa1afb746aa471f$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return module.exports = $0aa1afb746aa471f$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $0aa1afb746aa471f$var$_typeof(obj);
}
module.exports = $0aa1afb746aa471f$var$_typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

});



parcelRequire.register("6Nc1h", function(module, exports) {
$parcel$export(module.exports, "all", () => (parcelRequire("7McF6"))._);
$parcel$export(module.exports, "call", () => (parcelRequire("7McF6")).N);
$parcel$export(module.exports, "cancel", () => (parcelRequire("7McF6")).M);
$parcel$export(module.exports, "cancelled", () => (parcelRequire("7McF6")).a4);
$parcel$export(module.exports, "fork", () => (parcelRequire("7McF6")).L);
$parcel$export(module.exports, "put", () => (parcelRequire("7McF6")).Y);
$parcel$export(module.exports, "race", () => (parcelRequire("7McF6")).V);
$parcel$export(module.exports, "select", () => (parcelRequire("7McF6")).a3);
$parcel$export(module.exports, "take", () => (parcelRequire("7McF6")).K);
$parcel$export(module.exports, "takeEvery", () => (parcelRequire("7PPVh")).takeEvery);
$parcel$export(module.exports, "takeLatest", () => (parcelRequire("7PPVh")).takeLatest);
parcelRequire("7PPVh");

});
parcelRequire.register("7PPVh", function(module, exports) {

$parcel$export(module.exports, "takeEvery", () => $5b45929dc0ccb88e$export$4e24be1e1c9d5c69);
$parcel$export(module.exports, "takeLatest", () => $5b45929dc0ccb88e$export$ca010cea618a298a);
$parcel$export(module.exports, "all", () => (parcelRequire("7McF6"))._);
$parcel$export(module.exports, "call", () => (parcelRequire("7McF6")).N);
$parcel$export(module.exports, "cancel", () => (parcelRequire("7McF6")).M);
$parcel$export(module.exports, "cancelled", () => (parcelRequire("7McF6")).a4);
$parcel$export(module.exports, "fork", () => (parcelRequire("7McF6")).L);
$parcel$export(module.exports, "put", () => (parcelRequire("7McF6")).Y);
$parcel$export(module.exports, "race", () => (parcelRequire("7McF6")).V);
$parcel$export(module.exports, "select", () => (parcelRequire("7McF6")).a3);
$parcel$export(module.exports, "take", () => (parcelRequire("7McF6")).K);
parcelRequire("6LdGn");
parcelRequire("aO5a1");

var $a6awc = parcelRequire("a6awc");

var $7McF6 = parcelRequire("7McF6");
parcelRequire("35th6");
var $5b45929dc0ccb88e$var$done = function done(value) {
    return {
        done: true,
        value: value
    };
};
var $5b45929dc0ccb88e$var$qEnd = {};
function $5b45929dc0ccb88e$var$safeName(patternOrChannel) {
    if ((0, $a6awc.channel)(patternOrChannel)) return "channel";
    if ((0, $a6awc.stringableFunc)(patternOrChannel)) return String(patternOrChannel);
    if ((0, $a6awc.func)(patternOrChannel)) return patternOrChannel.name;
    return String(patternOrChannel);
}
function $5b45929dc0ccb88e$var$fsmIterator(fsm, startState, name) {
    var stateUpdater, errorState, effect, nextState = startState;
    function next(arg, error) {
        if (nextState === $5b45929dc0ccb88e$var$qEnd) return $5b45929dc0ccb88e$var$done(arg);
        if (error && !errorState) {
            nextState = $5b45929dc0ccb88e$var$qEnd;
            throw error;
        } else {
            stateUpdater && stateUpdater(arg);
            var currentState = error ? fsm[errorState](error) : fsm[nextState]();
            nextState = currentState.nextState;
            effect = currentState.effect;
            stateUpdater = currentState.stateUpdater;
            errorState = currentState.errorState;
            return nextState === $5b45929dc0ccb88e$var$qEnd ? $5b45929dc0ccb88e$var$done(arg) : effect;
        }
    }
    return (0, $7McF6.q)(next, function(error) {
        return next(null, error);
    }, name);
}
function $5b45929dc0ccb88e$var$takeEvery(patternOrChannel, worker) {
    for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)args[_key - 2] = arguments[_key];
    var yTake = {
        done: false,
        value: (0, $7McF6.K)(patternOrChannel)
    };
    var yFork = function yFork(ac) {
        return {
            done: false,
            value: (0, $7McF6.L).apply(void 0, [
                worker
            ].concat(args, [
                ac
            ]))
        };
    };
    var action, setAction = function setAction(ac) {
        return action = ac;
    };
    return $5b45929dc0ccb88e$var$fsmIterator({
        q1: function q1() {
            return {
                nextState: "q2",
                effect: yTake,
                stateUpdater: setAction
            };
        },
        q2: function q2() {
            return {
                nextState: "q1",
                effect: yFork(action)
            };
        }
    }, "q1", "takeEvery(" + $5b45929dc0ccb88e$var$safeName(patternOrChannel) + ", " + worker.name + ")");
}
function $5b45929dc0ccb88e$var$takeLatest(patternOrChannel, worker) {
    for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)args[_key - 2] = arguments[_key];
    var yTake = {
        done: false,
        value: (0, $7McF6.K)(patternOrChannel)
    };
    var yFork = function yFork(ac) {
        return {
            done: false,
            value: (0, $7McF6.L).apply(void 0, [
                worker
            ].concat(args, [
                ac
            ]))
        };
    };
    var yCancel = function yCancel(task) {
        return {
            done: false,
            value: (0, $7McF6.M)(task)
        };
    };
    var task, action;
    var setTask = function setTask(t) {
        return task = t;
    };
    var setAction = function setAction(ac) {
        return action = ac;
    };
    return $5b45929dc0ccb88e$var$fsmIterator({
        q1: function q1() {
            return {
                nextState: "q2",
                effect: yTake,
                stateUpdater: setAction
            };
        },
        q2: function q2() {
            return task ? {
                nextState: "q3",
                effect: yCancel(task)
            } : {
                nextState: "q1",
                effect: yFork(action),
                stateUpdater: setTask
            };
        },
        q3: function q3() {
            return {
                nextState: "q1",
                effect: yFork(action),
                stateUpdater: setTask
            };
        }
    }, "q1", "takeLatest(" + $5b45929dc0ccb88e$var$safeName(patternOrChannel) + ", " + worker.name + ")");
}
function $5b45929dc0ccb88e$var$takeLeading(patternOrChannel, worker) {
    for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)args[_key - 2] = arguments[_key];
    var yTake = {
        done: false,
        value: (0, $7McF6.K)(patternOrChannel)
    };
    var yCall = function yCall(ac) {
        return {
            done: false,
            value: (0, $7McF6.N).apply(void 0, [
                worker
            ].concat(args, [
                ac
            ]))
        };
    };
    var action;
    var setAction = function setAction(ac) {
        return action = ac;
    };
    return $5b45929dc0ccb88e$var$fsmIterator({
        q1: function q1() {
            return {
                nextState: "q2",
                effect: yTake,
                stateUpdater: setAction
            };
        },
        q2: function q2() {
            return {
                nextState: "q1",
                effect: yCall(action)
            };
        }
    }, "q1", "takeLeading(" + $5b45929dc0ccb88e$var$safeName(patternOrChannel) + ", " + worker.name + ")");
}
function $5b45929dc0ccb88e$var$throttle(delayLength, patternOrChannel, worker) {
    for(var _len = arguments.length, args = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++)args[_key - 3] = arguments[_key];
    var action, channel$1;
    var yTake = function yTake() {
        return {
            done: false,
            value: (0, $7McF6.K)(channel$1)
        };
    };
    var yFork = function yFork(ac) {
        return {
            done: false,
            value: (0, $7McF6.L).apply(void 0, [
                worker
            ].concat(args, [
                ac
            ]))
        };
    };
    var yDelay = {
        done: false,
        value: (0, $7McF6.O)(delayLength)
    };
    var setAction = function setAction(ac) {
        return action = ac;
    };
    var setChannel = function setChannel(ch) {
        return channel$1 = ch;
    };
    var needsChannel = !(0, $a6awc.channel)(patternOrChannel);
    if (!needsChannel) setChannel(patternOrChannel);
    return $5b45929dc0ccb88e$var$fsmIterator({
        q1: function q1() {
            var yActionChannel = {
                done: false,
                value: (0, $7McF6.Q)(patternOrChannel, (0, $7McF6.U)(1))
            };
            return {
                nextState: "q2",
                effect: yActionChannel,
                stateUpdater: setChannel
            };
        },
        q2: function q2() {
            return {
                nextState: "q3",
                effect: yTake(),
                stateUpdater: setAction
            };
        },
        q3: function q3() {
            return {
                nextState: "q4",
                effect: yFork(action)
            };
        },
        q4: function q4() {
            return {
                nextState: "q2",
                effect: yDelay
            };
        }
    }, needsChannel ? "q1" : "q2", "throttle(" + $5b45929dc0ccb88e$var$safeName(patternOrChannel) + ", " + worker.name + ")");
}
function $5b45929dc0ccb88e$var$retry(maxTries, delayLength, fn) {
    var counter = maxTries;
    for(var _len = arguments.length, args = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++)args[_key - 3] = arguments[_key];
    var yCall = {
        done: false,
        value: (0, $7McF6.N).apply(void 0, [
            fn
        ].concat(args))
    };
    var yDelay = {
        done: false,
        value: (0, $7McF6.O)(delayLength)
    };
    return $5b45929dc0ccb88e$var$fsmIterator({
        q1: function q1() {
            return {
                nextState: "q2",
                effect: yCall,
                errorState: "q10"
            };
        },
        q2: function q2() {
            return {
                nextState: $5b45929dc0ccb88e$var$qEnd
            };
        },
        q10: function q10(error) {
            counter -= 1;
            if (counter <= 0) throw error;
            return {
                nextState: "q1",
                effect: yDelay
            };
        }
    }, "q1", "retry(" + fn.name + ")");
}
function $5b45929dc0ccb88e$var$debounceHelper(delayLength, patternOrChannel, worker) {
    for(var _len = arguments.length, args = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++)args[_key - 3] = arguments[_key];
    var action, raceOutput;
    var yTake = {
        done: false,
        value: (0, $7McF6.K)(patternOrChannel)
    };
    var yRace = {
        done: false,
        value: (0, $7McF6.V)({
            action: (0, $7McF6.K)(patternOrChannel),
            debounce: (0, $7McF6.O)(delayLength)
        })
    };
    var yFork = function yFork(ac) {
        return {
            done: false,
            value: (0, $7McF6.L).apply(void 0, [
                worker
            ].concat(args, [
                ac
            ]))
        };
    };
    var yNoop = function yNoop(value) {
        return {
            done: false,
            value: value
        };
    };
    var setAction = function setAction(ac) {
        return action = ac;
    };
    var setRaceOutput = function setRaceOutput(ro) {
        return raceOutput = ro;
    };
    return $5b45929dc0ccb88e$var$fsmIterator({
        q1: function q1() {
            return {
                nextState: "q2",
                effect: yTake,
                stateUpdater: setAction
            };
        },
        q2: function q2() {
            return {
                nextState: "q3",
                effect: yRace,
                stateUpdater: setRaceOutput
            };
        },
        q3: function q3() {
            return raceOutput.debounce ? {
                nextState: "q1",
                effect: yFork(action)
            } : {
                nextState: "q2",
                effect: yNoop(raceOutput.action),
                stateUpdater: setAction
            };
        }
    }, "q1", "debounce(" + $5b45929dc0ccb88e$var$safeName(patternOrChannel) + ", " + worker.name + ")");
}
var $5b45929dc0ccb88e$var$validateTakeEffect = function validateTakeEffect(fn, patternOrChannel, worker) {
    (0, $7McF6.c)(patternOrChannel, (0, $a6awc.notUndef), fn.name + " requires a pattern or channel");
    (0, $7McF6.c)(worker, (0, $a6awc.notUndef), fn.name + " requires a saga parameter");
};
function $5b45929dc0ccb88e$export$4e24be1e1c9d5c69(patternOrChannel, worker) {
    for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)args[_key - 2] = arguments[_key];
    return (0, $7McF6.L).apply(void 0, [
        $5b45929dc0ccb88e$var$takeEvery,
        patternOrChannel,
        worker
    ].concat(args));
}
function $5b45929dc0ccb88e$export$ca010cea618a298a(patternOrChannel, worker) {
    for(var _len2 = arguments.length, args = new Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++)args[_key2 - 2] = arguments[_key2];
    return (0, $7McF6.L).apply(void 0, [
        $5b45929dc0ccb88e$var$takeLatest,
        patternOrChannel,
        worker
    ].concat(args));
}
function $5b45929dc0ccb88e$export$ab18f80dcccecca4(patternOrChannel, worker) {
    for(var _len3 = arguments.length, args = new Array(_len3 > 2 ? _len3 - 2 : 0), _key3 = 2; _key3 < _len3; _key3++)args[_key3 - 2] = arguments[_key3];
    return (0, $7McF6.L).apply(void 0, [
        $5b45929dc0ccb88e$var$takeLeading,
        patternOrChannel,
        worker
    ].concat(args));
}
function $5b45929dc0ccb88e$export$de363e709c412c8a(ms, patternOrChannel, worker) {
    for(var _len4 = arguments.length, args = new Array(_len4 > 3 ? _len4 - 3 : 0), _key4 = 3; _key4 < _len4; _key4++)args[_key4 - 3] = arguments[_key4];
    return (0, $7McF6.L).apply(void 0, [
        $5b45929dc0ccb88e$var$throttle,
        ms,
        patternOrChannel,
        worker
    ].concat(args));
}
function $5b45929dc0ccb88e$export$9369b12211e1fce4(maxTries, delayLength, worker) {
    for(var _len5 = arguments.length, args = new Array(_len5 > 3 ? _len5 - 3 : 0), _key5 = 3; _key5 < _len5; _key5++)args[_key5 - 3] = arguments[_key5];
    return (0, $7McF6.N).apply(void 0, [
        $5b45929dc0ccb88e$var$retry,
        maxTries,
        delayLength,
        worker
    ].concat(args));
}
function $5b45929dc0ccb88e$export$61fc7d43ac8f84b0(delayLength, pattern, worker) {
    for(var _len6 = arguments.length, args = new Array(_len6 > 3 ? _len6 - 3 : 0), _key6 = 3; _key6 < _len6; _key6++)args[_key6 - 3] = arguments[_key6];
    return (0, $7McF6.L).apply(void 0, [
        $5b45929dc0ccb88e$var$debounceHelper,
        delayLength,
        pattern,
        worker
    ].concat(args));
}

});


parcelRequire.register("4XoSw", function(module, exports) {
"use strict";

var $8usDI = parcelRequire("8usDI");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = $39bff8732eb34da8$var$clearSuggestedActionsOnPostActivitySaga;

var $39bff8732eb34da8$var$_regenerator = $8usDI((parcelRequire("7MKKk")));
parcelRequire("6Nc1h");
var $7McF6 = parcelRequire("7McF6");
var $7PPVh = parcelRequire("7PPVh");

var $lnNkF = parcelRequire("lnNkF");

var $39bff8732eb34da8$var$_setSuggestedActions = $8usDI((parcelRequire("9fqWO")));

var $39bff8732eb34da8$var$_whileConnected = $8usDI((parcelRequire("6qcDb")));
var $39bff8732eb34da8$var$_marked = /*#__PURE__*/ $39bff8732eb34da8$var$_regenerator["default"].mark($39bff8732eb34da8$var$clearSuggestedActions), $39bff8732eb34da8$var$_marked2 = /*#__PURE__*/ $39bff8732eb34da8$var$_regenerator["default"].mark($39bff8732eb34da8$var$clearSuggestedActionsOnPostActivity), $39bff8732eb34da8$var$_marked3 = /*#__PURE__*/ $39bff8732eb34da8$var$_regenerator["default"].mark($39bff8732eb34da8$var$clearSuggestedActionsOnPostActivitySaga);
function $39bff8732eb34da8$var$clearSuggestedActions() {
    return $39bff8732eb34da8$var$_regenerator["default"].wrap(function clearSuggestedActions$(_context) {
        while(true)switch(_context.prev = _context.next){
            case 0:
                _context.next = 2;
                return (0, $7McF6.Y)((0, $39bff8732eb34da8$var$_setSuggestedActions["default"])());
            case 2:
            case "end":
                return _context.stop();
        }
    }, $39bff8732eb34da8$var$_marked);
}
function $39bff8732eb34da8$var$clearSuggestedActionsOnPostActivity() {
    return $39bff8732eb34da8$var$_regenerator["default"].wrap(function clearSuggestedActionsOnPostActivity$(_context2) {
        while(true)switch(_context2.prev = _context2.next){
            case 0:
                _context2.next = 2;
                return (0, $7PPVh.takeEvery)(function(_ref) {
                    var payload = _ref.payload, type = _ref.type;
                    return type === $lnNkF.POST_ACTIVITY_PENDING && payload.activity.type === "message";
                }, $39bff8732eb34da8$var$clearSuggestedActions);
            case 2:
            case "end":
                return _context2.stop();
        }
    }, $39bff8732eb34da8$var$_marked2);
}
function $39bff8732eb34da8$var$clearSuggestedActionsOnPostActivitySaga() {
    return $39bff8732eb34da8$var$_regenerator["default"].wrap(function clearSuggestedActionsOnPostActivitySaga$(_context3) {
        while(true)switch(_context3.prev = _context3.next){
            case 0:
                _context3.next = 2;
                return (0, $39bff8732eb34da8$var$_whileConnected["default"])($39bff8732eb34da8$var$clearSuggestedActionsOnPostActivity);
            case 2:
            case "end":
                return _context3.stop();
        }
    }, $39bff8732eb34da8$var$_marked3);
}

});
parcelRequire.register("6qcDb", function(module, exports) {
"use strict";

var $8usDI = parcelRequire("8usDI");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = $4acef805aff8e450$var$whileConnectedEffect;

var $4acef805aff8e450$var$_regenerator = $8usDI((parcelRequire("7MKKk")));
parcelRequire("6Nc1h");
var $7McF6 = parcelRequire("7McF6");

var $dd04G = parcelRequire("dd04G");

var $arcsH = parcelRequire("arcsH");

var $hbk3x = parcelRequire("hbk3x");
function $4acef805aff8e450$var$whileConnectedEffect(fn) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
    return (0, $7McF6.N)(/*#__PURE__*/ $4acef805aff8e450$var$_regenerator["default"].mark(function whileConnected() {
        var _yield$take, _yield$take$meta, userID, username, directLine, task;
        return $4acef805aff8e450$var$_regenerator["default"].wrap(function whileConnected$(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    _context.next = 2;
                    return (0, $7McF6.K)([
                        $dd04G.CONNECT_FULFILLING,
                        $hbk3x.RECONNECT_FULFILLING
                    ]);
                case 2:
                    _yield$take = _context.sent;
                    _yield$take$meta = _yield$take.meta;
                    userID = _yield$take$meta.userID;
                    username = _yield$take$meta.username;
                    directLine = _yield$take.payload.directLine;
                    _context.next = 9;
                    return $7McF6.L.apply(void 0, [
                        fn,
                        {
                            directLine: directLine,
                            userID: userID,
                            username: username
                        }
                    ].concat(args));
                case 9:
                    task = _context.sent;
                    _context.next = 12;
                    return (0, $7McF6.K)([
                        $arcsH.DISCONNECT_PENDING,
                        $hbk3x.RECONNECT_PENDING
                    ]);
                case 12:
                    _context.next = 14;
                    return (0, $7McF6.M)(task);
                case 14:
                    _context.next = 0;
                    break;
                case 16:
                case "end":
                    return _context.stop();
            }
        }, whileConnected);
    }));
}

});


parcelRequire.register("iZ15U", function(module, exports) {
"use strict";

var $8usDI = parcelRequire("8usDI");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = $dd1ec5d3767eba7c$var$_callee;

var $dd1ec5d3767eba7c$var$_regenerator = $8usDI((parcelRequire("7MKKk")));
parcelRequire("6Nc1h");
var $7McF6 = parcelRequire("7McF6");
var $7PPVh = parcelRequire("7PPVh");

var $dd04G = parcelRequire("dd04G");

var $dd1ec5d3767eba7c$var$_createPromiseQueue2 = $8usDI((parcelRequire("jZhmM")));

var $dd1ec5d3767eba7c$var$_setNotification = $8usDI((parcelRequire("11xig")));
var $dd1ec5d3767eba7c$var$_marked = /*#__PURE__*/ $dd1ec5d3767eba7c$var$_regenerator["default"].mark($dd1ec5d3767eba7c$var$connectionStatusToNotification), $dd1ec5d3767eba7c$var$_marked2 = /*#__PURE__*/ $dd1ec5d3767eba7c$var$_regenerator["default"].mark($dd1ec5d3767eba7c$var$_callee);
var $dd1ec5d3767eba7c$var$CONNECTIVITY_STATUS_NOTIFICATION_ID = "connectivitystatus";
function $dd1ec5d3767eba7c$var$subscribeToPromiseQueue(observable) {
    var _createPromiseQueue = (0, $dd1ec5d3767eba7c$var$_createPromiseQueue2["default"])(), push = _createPromiseQueue.push, shift = _createPromiseQueue.shift;
    var subscription = observable.subscribe({
        next: push
    });
    return {
        shift: shift,
        unsubscribe: function unsubscribe() {
            subscription.unsubscribe();
        }
    };
}
function $dd1ec5d3767eba7c$var$connectionStatusToNotification(_ref) {
    var directLine, _subscribeToPromiseQu, shift, unsubscribe, reconnecting, value;
    return $dd1ec5d3767eba7c$var$_regenerator["default"].wrap(function connectionStatusToNotification$(_context) {
        while(true)switch(_context.prev = _context.next){
            case 0:
                directLine = _ref.payload.directLine;
                _subscribeToPromiseQu = $dd1ec5d3767eba7c$var$subscribeToPromiseQueue(directLine.connectionStatus$), shift = _subscribeToPromiseQu.shift, unsubscribe = _subscribeToPromiseQu.unsubscribe;
                _context.prev = 2;
            case 3:
                _context.next = 5;
                return (0, $7McF6.N)(shift);
            case 5:
                value = _context.sent;
                _context.t0 = value;
                _context.next = _context.t0 === 0 ? 9 : _context.t0 === 1 ? 9 : _context.t0 === 2 ? 12 : _context.t0 === 3 ? 16 : _context.t0 === 4 ? 16 : 20;
                break;
            case 9:
                _context.next = 11;
                return (0, $7McF6.Y)((0, $dd1ec5d3767eba7c$var$_setNotification["default"])({
                    id: $dd1ec5d3767eba7c$var$CONNECTIVITY_STATUS_NOTIFICATION_ID,
                    level: "info",
                    message: reconnecting ? "reconnecting" : "connecting"
                }));
            case 11:
                return _context.abrupt("break", 21);
            case 12:
                reconnecting = 1;
                _context.next = 15;
                return (0, $7McF6.Y)((0, $dd1ec5d3767eba7c$var$_setNotification["default"])({
                    id: $dd1ec5d3767eba7c$var$CONNECTIVITY_STATUS_NOTIFICATION_ID,
                    level: "success",
                    message: "connected"
                }));
            case 15:
                return _context.abrupt("break", 21);
            case 16:
                reconnecting = 1;
                _context.next = 19;
                return (0, $7McF6.Y)((0, $dd1ec5d3767eba7c$var$_setNotification["default"])({
                    id: $dd1ec5d3767eba7c$var$CONNECTIVITY_STATUS_NOTIFICATION_ID,
                    level: "error",
                    message: "failedtoconnect"
                }));
            case 19:
                return _context.abrupt("break", 21);
            case 20:
                return _context.abrupt("break", 21);
            case 21:
                _context.next = 3;
                break;
            case 23:
                _context.prev = 23;
                unsubscribe();
                return _context.finish(23);
            case 26:
            case "end":
                return _context.stop();
        }
    }, $dd1ec5d3767eba7c$var$_marked, null, [
        [
            2,
            ,
            23,
            26
        ]
    ]);
}
function $dd1ec5d3767eba7c$var$_callee() {
    return $dd1ec5d3767eba7c$var$_regenerator["default"].wrap(function _callee$(_context2) {
        while(true)switch(_context2.prev = _context2.next){
            case 0:
                _context2.next = 2;
                return (0, $7PPVh.takeLatest)($dd04G.CONNECT, $dd1ec5d3767eba7c$var$connectionStatusToNotification);
            case 2:
            case "end":
                return _context2.stop();
        }
    }, $dd1ec5d3767eba7c$var$_marked2);
}

});
parcelRequire.register("jZhmM", function(module, exports) {
"use strict";

var $8usDI = parcelRequire("8usDI");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = $e8d12f73b771f3c3$var$createPromiseQueue;

var $e8d12f73b771f3c3$var$_pDeferEs = $8usDI((parcelRequire("5la41")));
function $e8d12f73b771f3c3$var$createPromiseQueue() {
    var deferred;
    var queue = [];
    var push = function push(value) {
        if (deferred) {
            var _deferred = deferred, resolve = _deferred.resolve;
            deferred = null;
            resolve(value);
        } else queue.push(value);
    };
    var shift = function shift() {
        return queue.length ? Promise.resolve(queue.shift()) : (deferred || (deferred = (0, $e8d12f73b771f3c3$var$_pDeferEs["default"])())).promise;
    };
    return {
        push: push,
        shift: shift
    };
}

});
parcelRequire.register("5la41", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $cd4854316a4a48a6$export$2e2bcd8739ae039);

var $bp0j7 = parcelRequire("bp0j7");
// ../p-defer/index.js
function $cd4854316a4a48a6$var$pDefer() {
    var deferred = {};
    deferred.promise = new (0, (/*@__PURE__*/$parcel$interopDefault($bp0j7)))(function(resolve, reject) {
        deferred.resolve = resolve;
        deferred.reject = reject;
    });
    return deferred;
}
// src/index.mjs
var $cd4854316a4a48a6$export$2e2bcd8739ae039 = $cd4854316a4a48a6$var$pDefer;

});
parcelRequire.register("bp0j7", function(module, exports) {

module.exports = (parcelRequire("fYHuX"));

});
parcelRequire.register("fYHuX", function(module, exports) {

var $eu2Av = parcelRequire("eu2Av");
parcelRequire("a8ZHm");
module.exports = $eu2Av;

});
parcelRequire.register("eu2Av", function(module, exports) {
parcelRequire("fM4fv");
parcelRequire("7V1Sz");
parcelRequire("evDrA");
parcelRequire("ihzDZ");
parcelRequire("1qg05");
parcelRequire("dUrYj");
parcelRequire("34eo6");
parcelRequire("vGpAn");

var $lahb7 = parcelRequire("lahb7");
module.exports = $lahb7.Promise;

});
parcelRequire.register("fM4fv", function(module, exports) {
// TODO: Remove this module from `core-js@4` since it's replaced to module below
parcelRequire("9Hber");

});
parcelRequire.register("9Hber", function(module, exports) {
"use strict";

var $2iwSV = parcelRequire("2iwSV");

var $53bMe = parcelRequire("53bMe");

var $2T3Ss = parcelRequire("2T3Ss");

var $a7qOu = parcelRequire("a7qOu");

var $luR3G = parcelRequire("luR3G");

var $6m5Sk = parcelRequire("6m5Sk");

var $b77ug = parcelRequire("b77ug");

var $80p84 = parcelRequire("80p84");

var $kqpd3 = parcelRequire("kqpd3");

var $6i9F1 = parcelRequire("6i9F1");

var $gCDer = parcelRequire("gCDer");

var $rtmqR = parcelRequire("rtmqR");

var $jUcq5 = parcelRequire("jUcq5");
var $70f0d7a44f84b861$var$TO_STRING_TAG = $jUcq5("toStringTag");
var $70f0d7a44f84b861$var$$Error = Error;
var $70f0d7a44f84b861$var$push = [].push;
var $70f0d7a44f84b861$var$$AggregateError = function AggregateError(errors, message /* , options */ ) {
    var isInstance = $53bMe($70f0d7a44f84b861$var$AggregateErrorPrototype, this);
    var that;
    if ($a7qOu) that = $a7qOu($70f0d7a44f84b861$var$$Error(), isInstance ? $2T3Ss(this) : $70f0d7a44f84b861$var$AggregateErrorPrototype);
    else {
        that = isInstance ? this : $6m5Sk($70f0d7a44f84b861$var$AggregateErrorPrototype);
        $b77ug(that, $70f0d7a44f84b861$var$TO_STRING_TAG, "Error");
    }
    if (message !== undefined) $b77ug(that, "message", $rtmqR(message));
    $6i9F1(that, $70f0d7a44f84b861$var$$AggregateError, that.stack, 1);
    if (arguments.length > 2) $kqpd3(that, arguments[2]);
    var errorsArray = [];
    $gCDer(errors, $70f0d7a44f84b861$var$push, {
        that: errorsArray
    });
    $b77ug(that, "errors", errorsArray);
    return that;
};
if ($a7qOu) $a7qOu($70f0d7a44f84b861$var$$AggregateError, $70f0d7a44f84b861$var$$Error);
else $luR3G($70f0d7a44f84b861$var$$AggregateError, $70f0d7a44f84b861$var$$Error, {
    name: true
});
var $70f0d7a44f84b861$var$AggregateErrorPrototype = $70f0d7a44f84b861$var$$AggregateError.prototype = $6m5Sk($70f0d7a44f84b861$var$$Error.prototype, {
    constructor: $80p84(1, $70f0d7a44f84b861$var$$AggregateError),
    message: $80p84(1, ""),
    name: $80p84(1, "AggregateError")
});
// `AggregateError` constructor
// https://tc39.es/ecma262/#sec-aggregate-error-constructor
$2iwSV({
    global: true,
    constructor: true,
    arity: 2
}, {
    AggregateError: $70f0d7a44f84b861$var$$AggregateError
});

});
parcelRequire.register("2iwSV", function(module, exports) {
"use strict";

var $bbWQF = parcelRequire("bbWQF");

var $9ujZx = parcelRequire("9ujZx");

var $7vOhs = parcelRequire("7vOhs");

var $g0TxJ = parcelRequire("g0TxJ");

var $4cXMl = parcelRequire("4cXMl");
var $1ac6c577d57cae57$require$getOwnPropertyDescriptor = $4cXMl.f;

var $hz0Pa = parcelRequire("hz0Pa");

var $lahb7 = parcelRequire("lahb7");

var $jjTxh = parcelRequire("jjTxh");

var $b77ug = parcelRequire("b77ug");

var $dj4ij = parcelRequire("dj4ij");
var $1ac6c577d57cae57$var$wrapConstructor = function(NativeConstructor) {
    var Wrapper = function(a, b, c) {
        if (this instanceof Wrapper) {
            switch(arguments.length){
                case 0:
                    return new NativeConstructor();
                case 1:
                    return new NativeConstructor(a);
                case 2:
                    return new NativeConstructor(a, b);
            }
            return new NativeConstructor(a, b, c);
        }
        return $9ujZx(NativeConstructor, this, arguments);
    };
    Wrapper.prototype = NativeConstructor.prototype;
    return Wrapper;
};
/*
  options.target         - name of the target object
  options.global         - target is the global object
  options.stat           - export as static methods of target
  options.proto          - export as prototype methods of target
  options.real           - real prototype method for the `pure` version
  options.forced         - export even if the native feature is available
  options.bind           - bind methods to the target, required for the `pure` version
  options.wrap           - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe         - use the simple assignment of property instead of delete + defineProperty
  options.sham           - add a flag to not completely full polyfills
  options.enumerable     - export as enumerable property
  options.dontCallGetSet - prevent calling a getter on target
  options.name           - the .name of the function if it does not match the key
*/ module.exports = function(options, source) {
    var TARGET = options.target;
    var GLOBAL = options.global;
    var STATIC = options.stat;
    var PROTO = options.proto;
    var nativeSource = GLOBAL ? $bbWQF : STATIC ? $bbWQF[TARGET] : ($bbWQF[TARGET] || {}).prototype;
    var target = GLOBAL ? $lahb7 : $lahb7[TARGET] || $b77ug($lahb7, TARGET, {})[TARGET];
    var targetPrototype = target.prototype;
    var FORCED, USE_NATIVE, VIRTUAL_PROTOTYPE;
    var key, sourceProperty, targetProperty, nativeProperty, resultProperty, descriptor;
    for(key in source){
        FORCED = $hz0Pa(GLOBAL ? key : TARGET + (STATIC ? "." : "#") + key, options.forced);
        // contains in native
        USE_NATIVE = !FORCED && nativeSource && $dj4ij(nativeSource, key);
        targetProperty = target[key];
        if (USE_NATIVE) {
            if (options.dontCallGetSet) {
                descriptor = $1ac6c577d57cae57$require$getOwnPropertyDescriptor(nativeSource, key);
                nativeProperty = descriptor && descriptor.value;
            } else nativeProperty = nativeSource[key];
        }
        // export native or implementation
        sourceProperty = USE_NATIVE && nativeProperty ? nativeProperty : source[key];
        if (USE_NATIVE && typeof targetProperty == typeof sourceProperty) continue;
        // bind methods to global for calling from export context
        if (options.bind && USE_NATIVE) resultProperty = $jjTxh(sourceProperty, $bbWQF);
        else if (options.wrap && USE_NATIVE) resultProperty = $1ac6c577d57cae57$var$wrapConstructor(sourceProperty);
        else if (PROTO && $g0TxJ(sourceProperty)) resultProperty = $7vOhs(sourceProperty);
        else resultProperty = sourceProperty;
        // add a flag to not completely full polyfills
        if (options.sham || sourceProperty && sourceProperty.sham || targetProperty && targetProperty.sham) $b77ug(resultProperty, "sham", true);
        $b77ug(target, key, resultProperty);
        if (PROTO) {
            VIRTUAL_PROTOTYPE = TARGET + "Prototype";
            if (!$dj4ij($lahb7, VIRTUAL_PROTOTYPE)) $b77ug($lahb7, VIRTUAL_PROTOTYPE, {});
            // export virtual prototype methods
            $b77ug($lahb7[VIRTUAL_PROTOTYPE], key, sourceProperty);
            // export real prototype methods
            if (options.real && targetPrototype && (FORCED || !targetPrototype[key])) $b77ug(targetPrototype, key, sourceProperty);
        }
    }
};

});
parcelRequire.register("bbWQF", function(module, exports) {
var $825e5ee1a6d13c5f$var$check = function(it) {
    return it && it.Math == Math && it;
};
// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
module.exports = // eslint-disable-next-line es/no-global-this -- safe
$825e5ee1a6d13c5f$var$check(typeof globalThis == "object" && globalThis) || $825e5ee1a6d13c5f$var$check(typeof window == "object" && window) || // eslint-disable-next-line no-restricted-globals -- safe
$825e5ee1a6d13c5f$var$check(typeof self == "object" && self) || $825e5ee1a6d13c5f$var$check(typeof $parcel$global == "object" && $parcel$global) || // eslint-disable-next-line no-new-func -- fallback
function() {
    return this;
}() || module.exports || Function("return this")();

});

parcelRequire.register("9ujZx", function(module, exports) {

var $5ycCS = parcelRequire("5ycCS");
var $6e866c510a66ac2c$var$FunctionPrototype = Function.prototype;
var $6e866c510a66ac2c$var$apply = $6e866c510a66ac2c$var$FunctionPrototype.apply;
var $6e866c510a66ac2c$var$call = $6e866c510a66ac2c$var$FunctionPrototype.call;
// eslint-disable-next-line es/no-reflect -- safe
module.exports = typeof Reflect == "object" && Reflect.apply || ($5ycCS ? $6e866c510a66ac2c$var$call.bind($6e866c510a66ac2c$var$apply) : function() {
    return $6e866c510a66ac2c$var$call.apply($6e866c510a66ac2c$var$apply, arguments);
});

});
parcelRequire.register("5ycCS", function(module, exports) {

var $bSIUO = parcelRequire("bSIUO");
module.exports = !$bSIUO(function() {
    // eslint-disable-next-line es/no-function-prototype-bind -- safe
    var test = (function() {}).bind();
    // eslint-disable-next-line no-prototype-builtins -- safe
    return typeof test != "function" || test.hasOwnProperty("prototype");
});

});
parcelRequire.register("bSIUO", function(module, exports) {
module.exports = function(exec) {
    try {
        return !!exec();
    } catch (error) {
        return true;
    }
};

});



parcelRequire.register("7vOhs", function(module, exports) {

var $gir1t = parcelRequire("gir1t");

var $dqhay = parcelRequire("dqhay");
module.exports = function(fn) {
    // Nashorn bug:
    //   https://github.com/zloirock/core-js/issues/1128
    //   https://github.com/zloirock/core-js/issues/1130
    if ($gir1t(fn) === "Function") return $dqhay(fn);
};

});
parcelRequire.register("gir1t", function(module, exports) {

var $dqhay = parcelRequire("dqhay");
var $bdd349f1ba0f166a$var$toString = $dqhay({}.toString);
var $bdd349f1ba0f166a$var$stringSlice = $dqhay("".slice);
module.exports = function(it) {
    return $bdd349f1ba0f166a$var$stringSlice($bdd349f1ba0f166a$var$toString(it), 8, -1);
};

});
parcelRequire.register("dqhay", function(module, exports) {

var $5ycCS = parcelRequire("5ycCS");
var $9c5b0582ce8df2b4$var$FunctionPrototype = Function.prototype;
var $9c5b0582ce8df2b4$var$call = $9c5b0582ce8df2b4$var$FunctionPrototype.call;
var $9c5b0582ce8df2b4$var$uncurryThisWithBind = $5ycCS && $9c5b0582ce8df2b4$var$FunctionPrototype.bind.bind($9c5b0582ce8df2b4$var$call, $9c5b0582ce8df2b4$var$call);
module.exports = $5ycCS ? $9c5b0582ce8df2b4$var$uncurryThisWithBind : function(fn) {
    return function() {
        return $9c5b0582ce8df2b4$var$call.apply(fn, arguments);
    };
};

});



parcelRequire.register("g0TxJ", function(module, exports) {

var $cTlAE = parcelRequire("cTlAE");
var $ba87bb1a15b6eb33$var$documentAll = $cTlAE.all;
// `IsCallable` abstract operation
// https://tc39.es/ecma262/#sec-iscallable
module.exports = $cTlAE.IS_HTMLDDA ? function(argument) {
    return typeof argument == "function" || argument === $ba87bb1a15b6eb33$var$documentAll;
} : function(argument) {
    return typeof argument == "function";
};

});
parcelRequire.register("cTlAE", function(module, exports) {
var $962b5e6ca1a2c484$var$documentAll = typeof document == "object" && document.all;
// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot
// eslint-disable-next-line unicorn/no-typeof-undefined -- required for testing
var $962b5e6ca1a2c484$var$IS_HTMLDDA = typeof $962b5e6ca1a2c484$var$documentAll == "undefined" && $962b5e6ca1a2c484$var$documentAll !== undefined;
module.exports = {
    all: $962b5e6ca1a2c484$var$documentAll,
    IS_HTMLDDA: $962b5e6ca1a2c484$var$IS_HTMLDDA
};

});


parcelRequire.register("4cXMl", function(module, exports) {

$parcel$export(module.exports, "f", () => $3106a73932a28c1c$export$2d1720544b23b823, (v) => $3106a73932a28c1c$export$2d1720544b23b823 = v);
// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
var $3106a73932a28c1c$export$2d1720544b23b823;

var $awFtp = parcelRequire("awFtp");

var $boD6Z = parcelRequire("boD6Z");

var $fsYnl = parcelRequire("fsYnl");

var $80p84 = parcelRequire("80p84");

var $gYLVQ = parcelRequire("gYLVQ");

var $jdr5b = parcelRequire("jdr5b");

var $dj4ij = parcelRequire("dj4ij");

var $b2CU7 = parcelRequire("b2CU7");
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $3106a73932a28c1c$var$$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
$3106a73932a28c1c$export$2d1720544b23b823 = $awFtp ? $3106a73932a28c1c$var$$getOwnPropertyDescriptor : function getOwnPropertyDescriptor(O, P) {
    O = $gYLVQ(O);
    P = $jdr5b(P);
    if ($b2CU7) try {
        return $3106a73932a28c1c$var$$getOwnPropertyDescriptor(O, P);
    } catch (error) {}
    if ($dj4ij(O, P)) return $80p84(!$boD6Z($fsYnl.f, O, P), O[P]);
};

});
parcelRequire.register("awFtp", function(module, exports) {

var $bSIUO = parcelRequire("bSIUO");
// Detect IE8's incomplete defineProperty implementation
module.exports = !$bSIUO(function() {
    // eslint-disable-next-line es/no-object-defineproperty -- required for testing
    return Object.defineProperty({}, 1, {
        get: function() {
            return 7;
        }
    })[1] != 7;
});

});

parcelRequire.register("boD6Z", function(module, exports) {

var $5ycCS = parcelRequire("5ycCS");
var $84c046632aaa1a4d$var$call = Function.prototype.call;
module.exports = $5ycCS ? $84c046632aaa1a4d$var$call.bind($84c046632aaa1a4d$var$call) : function() {
    return $84c046632aaa1a4d$var$call.apply($84c046632aaa1a4d$var$call, arguments);
};

});

parcelRequire.register("fsYnl", function(module, exports) {

$parcel$export(module.exports, "f", () => $b4284dd904678cff$export$2d1720544b23b823, (v) => $b4284dd904678cff$export$2d1720544b23b823 = v);
// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable
var $b4284dd904678cff$export$2d1720544b23b823;
"use strict";
var $b4284dd904678cff$var$$propertyIsEnumerable = {}.propertyIsEnumerable;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $b4284dd904678cff$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
// Nashorn ~ JDK8 bug
var $b4284dd904678cff$var$NASHORN_BUG = $b4284dd904678cff$var$getOwnPropertyDescriptor && !$b4284dd904678cff$var$$propertyIsEnumerable.call({
    1: 2
}, 1);
$b4284dd904678cff$export$2d1720544b23b823 = $b4284dd904678cff$var$NASHORN_BUG ? function propertyIsEnumerable(V) {
    var descriptor = $b4284dd904678cff$var$getOwnPropertyDescriptor(this, V);
    return !!descriptor && descriptor.enumerable;
} : $b4284dd904678cff$var$$propertyIsEnumerable;

});

parcelRequire.register("80p84", function(module, exports) {
module.exports = function(bitmap, value) {
    return {
        enumerable: !(bitmap & 1),
        configurable: !(bitmap & 2),
        writable: !(bitmap & 4),
        value: value
    };
};

});

parcelRequire.register("gYLVQ", function(module, exports) {
// toObject with fallback for non-array-like ES3 strings

var $letw9 = parcelRequire("letw9");

var $2Oek2 = parcelRequire("2Oek2");
module.exports = function(it) {
    return $letw9($2Oek2(it));
};

});
parcelRequire.register("letw9", function(module, exports) {

var $dqhay = parcelRequire("dqhay");

var $bSIUO = parcelRequire("bSIUO");

var $gir1t = parcelRequire("gir1t");
var $f751cd59f67e742e$var$$Object = Object;
var $f751cd59f67e742e$var$split = $dqhay("".split);
// fallback for non-array-like ES3 and non-enumerable old V8 strings
module.exports = $bSIUO(function() {
    // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
    // eslint-disable-next-line no-prototype-builtins -- safe
    return !$f751cd59f67e742e$var$$Object("z").propertyIsEnumerable(0);
}) ? function(it) {
    return $gir1t(it) == "String" ? $f751cd59f67e742e$var$split(it, "") : $f751cd59f67e742e$var$$Object(it);
} : $f751cd59f67e742e$var$$Object;

});

parcelRequire.register("2Oek2", function(module, exports) {

var $cp3Nc = parcelRequire("cp3Nc");
var $20bb5c6482a762df$var$$TypeError = TypeError;
// `RequireObjectCoercible` abstract operation
// https://tc39.es/ecma262/#sec-requireobjectcoercible
module.exports = function(it) {
    if ($cp3Nc(it)) throw $20bb5c6482a762df$var$$TypeError("Can't call method on " + it);
    return it;
};

});
parcelRequire.register("cp3Nc", function(module, exports) {
// we can't use just `it == null` since of `document.all` special case
// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot-aec
module.exports = function(it) {
    return it === null || it === undefined;
};

});



parcelRequire.register("jdr5b", function(module, exports) {

var $e1hKN = parcelRequire("e1hKN");

var $6MMdo = parcelRequire("6MMdo");
// `ToPropertyKey` abstract operation
// https://tc39.es/ecma262/#sec-topropertykey
module.exports = function(argument) {
    var key = $e1hKN(argument, "string");
    return $6MMdo(key) ? key : key + "";
};

});
parcelRequire.register("e1hKN", function(module, exports) {

var $boD6Z = parcelRequire("boD6Z");

var $2IxWL = parcelRequire("2IxWL");

var $6MMdo = parcelRequire("6MMdo");

var $hsQiW = parcelRequire("hsQiW");

var $5NUT2 = parcelRequire("5NUT2");

var $jUcq5 = parcelRequire("jUcq5");
var $a34eee31a50683b8$var$$TypeError = TypeError;
var $a34eee31a50683b8$var$TO_PRIMITIVE = $jUcq5("toPrimitive");
// `ToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-toprimitive
module.exports = function(input, pref) {
    if (!$2IxWL(input) || $6MMdo(input)) return input;
    var exoticToPrim = $hsQiW(input, $a34eee31a50683b8$var$TO_PRIMITIVE);
    var result;
    if (exoticToPrim) {
        if (pref === undefined) pref = "default";
        result = $boD6Z(exoticToPrim, input, pref);
        if (!$2IxWL(result) || $6MMdo(result)) return result;
        throw $a34eee31a50683b8$var$$TypeError("Can't convert object to primitive value");
    }
    if (pref === undefined) pref = "number";
    return $5NUT2(input, pref);
};

});
parcelRequire.register("2IxWL", function(module, exports) {

var $g0TxJ = parcelRequire("g0TxJ");

var $cTlAE = parcelRequire("cTlAE");
var $1faa05fa23283af6$var$documentAll = $cTlAE.all;
module.exports = $cTlAE.IS_HTMLDDA ? function(it) {
    return typeof it == "object" ? it !== null : $g0TxJ(it) || it === $1faa05fa23283af6$var$documentAll;
} : function(it) {
    return typeof it == "object" ? it !== null : $g0TxJ(it);
};

});

parcelRequire.register("6MMdo", function(module, exports) {

var $7J5vx = parcelRequire("7J5vx");

var $g0TxJ = parcelRequire("g0TxJ");

var $53bMe = parcelRequire("53bMe");

var $4RkJG = parcelRequire("4RkJG");
var $4f0ca043b626cb5d$var$$Object = Object;
module.exports = $4RkJG ? function(it) {
    return typeof it == "symbol";
} : function(it) {
    var $Symbol = $7J5vx("Symbol");
    return $g0TxJ($Symbol) && $53bMe($Symbol.prototype, $4f0ca043b626cb5d$var$$Object(it));
};

});
parcelRequire.register("7J5vx", function(module, exports) {

var $lahb7 = parcelRequire("lahb7");

var $bbWQF = parcelRequire("bbWQF");

var $g0TxJ = parcelRequire("g0TxJ");
var $5a010210aa483583$var$aFunction = function(variable) {
    return $g0TxJ(variable) ? variable : undefined;
};
module.exports = function(namespace, method) {
    return arguments.length < 2 ? $5a010210aa483583$var$aFunction($lahb7[namespace]) || $5a010210aa483583$var$aFunction($bbWQF[namespace]) : $lahb7[namespace] && $lahb7[namespace][method] || $bbWQF[namespace] && $bbWQF[namespace][method];
};

});
parcelRequire.register("lahb7", function(module, exports) {
module.exports = {};

});


parcelRequire.register("53bMe", function(module, exports) {

var $dqhay = parcelRequire("dqhay");
module.exports = $dqhay({}.isPrototypeOf);

});

parcelRequire.register("4RkJG", function(module, exports) {
/* eslint-disable es/no-symbol -- required for testing */ 
var $gLq14 = parcelRequire("gLq14");
module.exports = $gLq14 && !Symbol.sham && typeof Symbol.iterator == "symbol";

});
parcelRequire.register("gLq14", function(module, exports) {
/* eslint-disable es/no-symbol -- required for testing */ 
var $aPgVB = parcelRequire("aPgVB");

var $bSIUO = parcelRequire("bSIUO");

var $bbWQF = parcelRequire("bbWQF");
var $c345376f78518e24$var$$String = $bbWQF.String;
// eslint-disable-next-line es/no-object-getownpropertysymbols -- required for testing
module.exports = !!Object.getOwnPropertySymbols && !$bSIUO(function() {
    var symbol = Symbol();
    // Chrome 38 Symbol has incorrect toString conversion
    // `get-own-property-symbols` polyfill symbols converted to object are not Symbol instances
    // nb: Do not call `String` directly to avoid this being optimized out to `symbol+''` which will,
    // of course, fail.
    return !$c345376f78518e24$var$$String(symbol) || !(Object(symbol) instanceof Symbol) || // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
    !Symbol.sham && $aPgVB && $aPgVB < 41;
});

});
parcelRequire.register("aPgVB", function(module, exports) {

var $bbWQF = parcelRequire("bbWQF");

var $d0QM8 = parcelRequire("d0QM8");
var $7e1bcc575231d214$var$process = $bbWQF.process;
var $7e1bcc575231d214$var$Deno = $bbWQF.Deno;
var $7e1bcc575231d214$var$versions = $7e1bcc575231d214$var$process && $7e1bcc575231d214$var$process.versions || $7e1bcc575231d214$var$Deno && $7e1bcc575231d214$var$Deno.version;
var $7e1bcc575231d214$var$v8 = $7e1bcc575231d214$var$versions && $7e1bcc575231d214$var$versions.v8;
var $7e1bcc575231d214$var$match, $7e1bcc575231d214$var$version;
if ($7e1bcc575231d214$var$v8) {
    $7e1bcc575231d214$var$match = $7e1bcc575231d214$var$v8.split(".");
    // in old Chrome, versions of V8 isn't V8 = Chrome / 10
    // but their correct versions are not interesting for us
    $7e1bcc575231d214$var$version = $7e1bcc575231d214$var$match[0] > 0 && $7e1bcc575231d214$var$match[0] < 4 ? 1 : +($7e1bcc575231d214$var$match[0] + $7e1bcc575231d214$var$match[1]);
}
// BrowserFS NodeJS `process` polyfill incorrectly set `.v8` to `0.0`
// so check `userAgent` even if `.v8` exists, but 0
if (!$7e1bcc575231d214$var$version && $d0QM8) {
    $7e1bcc575231d214$var$match = $d0QM8.match(/Edge\/(\d+)/);
    if (!$7e1bcc575231d214$var$match || $7e1bcc575231d214$var$match[1] >= 74) {
        $7e1bcc575231d214$var$match = $d0QM8.match(/Chrome\/(\d+)/);
        if ($7e1bcc575231d214$var$match) $7e1bcc575231d214$var$version = +$7e1bcc575231d214$var$match[1];
    }
}
module.exports = $7e1bcc575231d214$var$version;

});
parcelRequire.register("d0QM8", function(module, exports) {
module.exports = typeof navigator != "undefined" && String(navigator.userAgent) || "";

});





parcelRequire.register("hsQiW", function(module, exports) {

var $f9Leu = parcelRequire("f9Leu");

var $cp3Nc = parcelRequire("cp3Nc");
// `GetMethod` abstract operation
// https://tc39.es/ecma262/#sec-getmethod
module.exports = function(V, P) {
    var func = V[P];
    return $cp3Nc(func) ? undefined : $f9Leu(func);
};

});
parcelRequire.register("f9Leu", function(module, exports) {

var $g0TxJ = parcelRequire("g0TxJ");

var $ieZRC = parcelRequire("ieZRC");
var $02d8f91fc36fea48$var$$TypeError = TypeError;
// `Assert: IsCallable(argument) is true`
module.exports = function(argument) {
    if ($g0TxJ(argument)) return argument;
    throw $02d8f91fc36fea48$var$$TypeError($ieZRC(argument) + " is not a function");
};

});
parcelRequire.register("ieZRC", function(module, exports) {
var $d47985ad739727c7$var$$String = String;
module.exports = function(argument) {
    try {
        return $d47985ad739727c7$var$$String(argument);
    } catch (error) {
        return "Object";
    }
};

});



parcelRequire.register("5NUT2", function(module, exports) {

var $boD6Z = parcelRequire("boD6Z");

var $g0TxJ = parcelRequire("g0TxJ");

var $2IxWL = parcelRequire("2IxWL");
var $439da7e262b4d3ed$var$$TypeError = TypeError;
// `OrdinaryToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-ordinarytoprimitive
module.exports = function(input, pref) {
    var fn, val;
    if (pref === "string" && $g0TxJ(fn = input.toString) && !$2IxWL(val = $boD6Z(fn, input))) return val;
    if ($g0TxJ(fn = input.valueOf) && !$2IxWL(val = $boD6Z(fn, input))) return val;
    if (pref !== "string" && $g0TxJ(fn = input.toString) && !$2IxWL(val = $boD6Z(fn, input))) return val;
    throw $439da7e262b4d3ed$var$$TypeError("Can't convert object to primitive value");
};

});

parcelRequire.register("jUcq5", function(module, exports) {

var $bbWQF = parcelRequire("bbWQF");

var $hKCfh = parcelRequire("hKCfh");

var $dj4ij = parcelRequire("dj4ij");

var $kzqqN = parcelRequire("kzqqN");

var $gLq14 = parcelRequire("gLq14");

var $4RkJG = parcelRequire("4RkJG");
var $e7dce191efa10fa9$var$Symbol = $bbWQF.Symbol;
var $e7dce191efa10fa9$var$WellKnownSymbolsStore = $hKCfh("wks");
var $e7dce191efa10fa9$var$createWellKnownSymbol = $4RkJG ? $e7dce191efa10fa9$var$Symbol["for"] || $e7dce191efa10fa9$var$Symbol : $e7dce191efa10fa9$var$Symbol && $e7dce191efa10fa9$var$Symbol.withoutSetter || $kzqqN;
module.exports = function(name) {
    if (!$dj4ij($e7dce191efa10fa9$var$WellKnownSymbolsStore, name)) $e7dce191efa10fa9$var$WellKnownSymbolsStore[name] = $gLq14 && $dj4ij($e7dce191efa10fa9$var$Symbol, name) ? $e7dce191efa10fa9$var$Symbol[name] : $e7dce191efa10fa9$var$createWellKnownSymbol("Symbol." + name);
    return $e7dce191efa10fa9$var$WellKnownSymbolsStore[name];
};

});
parcelRequire.register("hKCfh", function(module, exports) {

var $bRYhZ = parcelRequire("bRYhZ");

var $fOCTs = parcelRequire("fOCTs");
(module.exports = function(key, value) {
    return $fOCTs[key] || ($fOCTs[key] = value !== undefined ? value : {});
})("versions", []).push({
    version: "3.30.2",
    mode: $bRYhZ ? "pure" : "global",
    copyright: "\xa9 2014-2023 Denis Pushkarev (zloirock.ru)",
    license: "https://github.com/zloirock/core-js/blob/v3.30.2/LICENSE",
    source: "https://github.com/zloirock/core-js"
});

});
parcelRequire.register("bRYhZ", function(module, exports) {
module.exports = true;

});

parcelRequire.register("fOCTs", function(module, exports) {

var $bbWQF = parcelRequire("bbWQF");

var $kIRuS = parcelRequire("kIRuS");
var $b839b1fbda0cd5d9$var$SHARED = "__core-js_shared__";
var $b839b1fbda0cd5d9$var$store = $bbWQF[$b839b1fbda0cd5d9$var$SHARED] || $kIRuS($b839b1fbda0cd5d9$var$SHARED, {});
module.exports = $b839b1fbda0cd5d9$var$store;

});
parcelRequire.register("kIRuS", function(module, exports) {

var $bbWQF = parcelRequire("bbWQF");
// eslint-disable-next-line es/no-object-defineproperty -- safe
var $f1616a19a198bdf9$var$defineProperty = Object.defineProperty;
module.exports = function(key, value) {
    try {
        $f1616a19a198bdf9$var$defineProperty($bbWQF, key, {
            value: value,
            configurable: true,
            writable: true
        });
    } catch (error) {
        $bbWQF[key] = value;
    }
    return value;
};

});



parcelRequire.register("dj4ij", function(module, exports) {

var $dqhay = parcelRequire("dqhay");

var $h90HQ = parcelRequire("h90HQ");
var $9b006180301f1b02$var$hasOwnProperty = $dqhay({}.hasOwnProperty);
// `HasOwnProperty` abstract operation
// https://tc39.es/ecma262/#sec-hasownproperty
// eslint-disable-next-line es/no-object-hasown -- safe
module.exports = Object.hasOwn || function hasOwn(it, key) {
    return $9b006180301f1b02$var$hasOwnProperty($h90HQ(it), key);
};

});
parcelRequire.register("h90HQ", function(module, exports) {

var $2Oek2 = parcelRequire("2Oek2");
var $c7b3d32d3b0784d0$var$$Object = Object;
// `ToObject` abstract operation
// https://tc39.es/ecma262/#sec-toobject
module.exports = function(argument) {
    return $c7b3d32d3b0784d0$var$$Object($2Oek2(argument));
};

});


parcelRequire.register("kzqqN", function(module, exports) {

var $dqhay = parcelRequire("dqhay");
var $ef9b9431019c9b89$var$id = 0;
var $ef9b9431019c9b89$var$postfix = Math.random();
var $ef9b9431019c9b89$var$toString = $dqhay(1.0.toString);
module.exports = function(key) {
    return "Symbol(" + (key === undefined ? "" : key) + ")_" + $ef9b9431019c9b89$var$toString(++$ef9b9431019c9b89$var$id + $ef9b9431019c9b89$var$postfix, 36);
};

});




parcelRequire.register("b2CU7", function(module, exports) {

var $awFtp = parcelRequire("awFtp");

var $bSIUO = parcelRequire("bSIUO");

var $ip0m4 = parcelRequire("ip0m4");
// Thanks to IE8 for its funny defineProperty
module.exports = !$awFtp && !$bSIUO(function() {
    // eslint-disable-next-line es/no-object-defineproperty -- required for testing
    return Object.defineProperty($ip0m4("div"), "a", {
        get: function() {
            return 7;
        }
    }).a != 7;
});

});
parcelRequire.register("ip0m4", function(module, exports) {

var $bbWQF = parcelRequire("bbWQF");

var $2IxWL = parcelRequire("2IxWL");
var $d65ad6426e88a367$var$document = $bbWQF.document;
// typeof document.createElement is 'object' in old IE
var $d65ad6426e88a367$var$EXISTS = $2IxWL($d65ad6426e88a367$var$document) && $2IxWL($d65ad6426e88a367$var$document.createElement);
module.exports = function(it) {
    return $d65ad6426e88a367$var$EXISTS ? $d65ad6426e88a367$var$document.createElement(it) : {};
};

});



parcelRequire.register("hz0Pa", function(module, exports) {

var $bSIUO = parcelRequire("bSIUO");

var $g0TxJ = parcelRequire("g0TxJ");
var $cc965839ca2d88c3$var$replacement = /#|\.prototype\./;
var $cc965839ca2d88c3$var$isForced = function(feature, detection) {
    var value = $cc965839ca2d88c3$var$data[$cc965839ca2d88c3$var$normalize(feature)];
    return value == $cc965839ca2d88c3$var$POLYFILL ? true : value == $cc965839ca2d88c3$var$NATIVE ? false : $g0TxJ(detection) ? $bSIUO(detection) : !!detection;
};
var $cc965839ca2d88c3$var$normalize = $cc965839ca2d88c3$var$isForced.normalize = function(string) {
    return String(string).replace($cc965839ca2d88c3$var$replacement, ".").toLowerCase();
};
var $cc965839ca2d88c3$var$data = $cc965839ca2d88c3$var$isForced.data = {};
var $cc965839ca2d88c3$var$NATIVE = $cc965839ca2d88c3$var$isForced.NATIVE = "N";
var $cc965839ca2d88c3$var$POLYFILL = $cc965839ca2d88c3$var$isForced.POLYFILL = "P";
module.exports = $cc965839ca2d88c3$var$isForced;

});

parcelRequire.register("jjTxh", function(module, exports) {

var $7vOhs = parcelRequire("7vOhs");

var $f9Leu = parcelRequire("f9Leu");

var $5ycCS = parcelRequire("5ycCS");
var $e10adeead19e9df7$var$bind = $7vOhs($7vOhs.bind);
// optional / simple context binding
module.exports = function(fn, that) {
    $f9Leu(fn);
    return that === undefined ? fn : $5ycCS ? $e10adeead19e9df7$var$bind(fn, that) : function() {
        return fn.apply(that, arguments);
    };
};

});

parcelRequire.register("b77ug", function(module, exports) {

var $awFtp = parcelRequire("awFtp");

var $8wt5F = parcelRequire("8wt5F");

var $80p84 = parcelRequire("80p84");
module.exports = $awFtp ? function(object, key, value) {
    return $8wt5F.f(object, key, $80p84(1, value));
} : function(object, key, value) {
    object[key] = value;
    return object;
};

});
parcelRequire.register("8wt5F", function(module, exports) {

$parcel$export(module.exports, "f", () => $6347e0a21a792b6a$export$2d1720544b23b823, (v) => $6347e0a21a792b6a$export$2d1720544b23b823 = v);
// `Object.defineProperty` method
// https://tc39.es/ecma262/#sec-object.defineproperty
var $6347e0a21a792b6a$export$2d1720544b23b823;

var $awFtp = parcelRequire("awFtp");

var $b2CU7 = parcelRequire("b2CU7");

var $6U4Vu = parcelRequire("6U4Vu");

var $3CMpt = parcelRequire("3CMpt");

var $jdr5b = parcelRequire("jdr5b");
var $6347e0a21a792b6a$var$$TypeError = TypeError;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var $6347e0a21a792b6a$var$$defineProperty = Object.defineProperty;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $6347e0a21a792b6a$var$$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $6347e0a21a792b6a$var$ENUMERABLE = "enumerable";
var $6347e0a21a792b6a$var$CONFIGURABLE = "configurable";
var $6347e0a21a792b6a$var$WRITABLE = "writable";
$6347e0a21a792b6a$export$2d1720544b23b823 = $awFtp ? $6U4Vu ? function defineProperty(O, P, Attributes) {
    $3CMpt(O);
    P = $jdr5b(P);
    $3CMpt(Attributes);
    if (typeof O === "function" && P === "prototype" && "value" in Attributes && $6347e0a21a792b6a$var$WRITABLE in Attributes && !Attributes[$6347e0a21a792b6a$var$WRITABLE]) {
        var current = $6347e0a21a792b6a$var$$getOwnPropertyDescriptor(O, P);
        if (current && current[$6347e0a21a792b6a$var$WRITABLE]) {
            O[P] = Attributes.value;
            Attributes = {
                configurable: $6347e0a21a792b6a$var$CONFIGURABLE in Attributes ? Attributes[$6347e0a21a792b6a$var$CONFIGURABLE] : current[$6347e0a21a792b6a$var$CONFIGURABLE],
                enumerable: $6347e0a21a792b6a$var$ENUMERABLE in Attributes ? Attributes[$6347e0a21a792b6a$var$ENUMERABLE] : current[$6347e0a21a792b6a$var$ENUMERABLE],
                writable: false
            };
        }
    }
    return $6347e0a21a792b6a$var$$defineProperty(O, P, Attributes);
} : $6347e0a21a792b6a$var$$defineProperty : function defineProperty(O, P, Attributes) {
    $3CMpt(O);
    P = $jdr5b(P);
    $3CMpt(Attributes);
    if ($b2CU7) try {
        return $6347e0a21a792b6a$var$$defineProperty(O, P, Attributes);
    } catch (error) {}
    if ("get" in Attributes || "set" in Attributes) throw $6347e0a21a792b6a$var$$TypeError("Accessors not supported");
    if ("value" in Attributes) O[P] = Attributes.value;
    return O;
};

});
parcelRequire.register("6U4Vu", function(module, exports) {

var $awFtp = parcelRequire("awFtp");

var $bSIUO = parcelRequire("bSIUO");
// V8 ~ Chrome 36-
// https://bugs.chromium.org/p/v8/issues/detail?id=3334
module.exports = $awFtp && $bSIUO(function() {
    // eslint-disable-next-line es/no-object-defineproperty -- required for testing
    return Object.defineProperty(function() {}, "prototype", {
        value: 42,
        writable: false
    }).prototype != 42;
});

});

parcelRequire.register("3CMpt", function(module, exports) {

var $2IxWL = parcelRequire("2IxWL");
var $2a3a78e04ee78c44$var$$String = String;
var $2a3a78e04ee78c44$var$$TypeError = TypeError;
// `Assert: Type(argument) is Object`
module.exports = function(argument) {
    if ($2IxWL(argument)) return argument;
    throw $2a3a78e04ee78c44$var$$TypeError($2a3a78e04ee78c44$var$$String(argument) + " is not an object");
};

});




parcelRequire.register("2T3Ss", function(module, exports) {

var $dj4ij = parcelRequire("dj4ij");

var $g0TxJ = parcelRequire("g0TxJ");

var $h90HQ = parcelRequire("h90HQ");

var $grXcd = parcelRequire("grXcd");

var $1yZLG = parcelRequire("1yZLG");
var $21a3b9c7e4da4d21$var$IE_PROTO = $grXcd("IE_PROTO");
var $21a3b9c7e4da4d21$var$$Object = Object;
var $21a3b9c7e4da4d21$var$ObjectPrototype = $21a3b9c7e4da4d21$var$$Object.prototype;
// `Object.getPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.getprototypeof
// eslint-disable-next-line es/no-object-getprototypeof -- safe
module.exports = $1yZLG ? $21a3b9c7e4da4d21$var$$Object.getPrototypeOf : function(O) {
    var object = $h90HQ(O);
    if ($dj4ij(object, $21a3b9c7e4da4d21$var$IE_PROTO)) return object[$21a3b9c7e4da4d21$var$IE_PROTO];
    var constructor = object.constructor;
    if ($g0TxJ(constructor) && object instanceof constructor) return constructor.prototype;
    return object instanceof $21a3b9c7e4da4d21$var$$Object ? $21a3b9c7e4da4d21$var$ObjectPrototype : null;
};

});
parcelRequire.register("grXcd", function(module, exports) {

var $hKCfh = parcelRequire("hKCfh");

var $kzqqN = parcelRequire("kzqqN");
var $bf9d161189c9c636$var$keys = $hKCfh("keys");
module.exports = function(key) {
    return $bf9d161189c9c636$var$keys[key] || ($bf9d161189c9c636$var$keys[key] = $kzqqN(key));
};

});

parcelRequire.register("1yZLG", function(module, exports) {

var $bSIUO = parcelRequire("bSIUO");
module.exports = !$bSIUO(function() {
    function F() {}
    F.prototype.constructor = null;
    // eslint-disable-next-line es/no-object-getprototypeof -- required for testing
    return Object.getPrototypeOf(new F()) !== F.prototype;
});

});


parcelRequire.register("a7qOu", function(module, exports) {
/* eslint-disable no-proto -- safe */ 
var $lupXU = parcelRequire("lupXU");

var $3CMpt = parcelRequire("3CMpt");

var $gsMdt = parcelRequire("gsMdt");
// `Object.setPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.setprototypeof
// Works with __proto__ only. Old v8 can't work with null proto objects.
// eslint-disable-next-line es/no-object-setprototypeof -- safe
module.exports = Object.setPrototypeOf || ("__proto__" in {} ? function() {
    var CORRECT_SETTER = false;
    var test = {};
    var setter;
    try {
        setter = $lupXU(Object.prototype, "__proto__", "set");
        setter(test, []);
        CORRECT_SETTER = test instanceof Array;
    } catch (error) {}
    return function setPrototypeOf(O, proto) {
        $3CMpt(O);
        $gsMdt(proto);
        if (CORRECT_SETTER) setter(O, proto);
        else O.__proto__ = proto;
        return O;
    };
}() : undefined);

});
parcelRequire.register("lupXU", function(module, exports) {

var $dqhay = parcelRequire("dqhay");

var $f9Leu = parcelRequire("f9Leu");
module.exports = function(object, key, method) {
    try {
        // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
        return $dqhay($f9Leu(Object.getOwnPropertyDescriptor(object, key)[method]));
    } catch (error) {}
};

});

parcelRequire.register("gsMdt", function(module, exports) {

var $g0TxJ = parcelRequire("g0TxJ");
var $0317d12ff75734a2$var$$String = String;
var $0317d12ff75734a2$var$$TypeError = TypeError;
module.exports = function(argument) {
    if (typeof argument == "object" || $g0TxJ(argument)) return argument;
    throw $0317d12ff75734a2$var$$TypeError("Can't set " + $0317d12ff75734a2$var$$String(argument) + " as a prototype");
};

});


parcelRequire.register("luR3G", function(module, exports) {

var $dj4ij = parcelRequire("dj4ij");

var $agEVI = parcelRequire("agEVI");

var $4cXMl = parcelRequire("4cXMl");

var $8wt5F = parcelRequire("8wt5F");
module.exports = function(target, source, exceptions) {
    var keys = $agEVI(source);
    var defineProperty = $8wt5F.f;
    var getOwnPropertyDescriptor = $4cXMl.f;
    for(var i = 0; i < keys.length; i++){
        var key = keys[i];
        if (!$dj4ij(target, key) && !(exceptions && $dj4ij(exceptions, key))) defineProperty(target, key, getOwnPropertyDescriptor(source, key));
    }
};

});
parcelRequire.register("agEVI", function(module, exports) {

var $7J5vx = parcelRequire("7J5vx");

var $dqhay = parcelRequire("dqhay");

var $aTQ7d = parcelRequire("aTQ7d");

var $3R41N = parcelRequire("3R41N");

var $3CMpt = parcelRequire("3CMpt");
var $779b25dae9693423$var$concat = $dqhay([].concat);
// all object keys, includes non-enumerable and symbols
module.exports = $7J5vx("Reflect", "ownKeys") || function ownKeys(it) {
    var keys = $aTQ7d.f($3CMpt(it));
    var getOwnPropertySymbols = $3R41N.f;
    return getOwnPropertySymbols ? $779b25dae9693423$var$concat(keys, getOwnPropertySymbols(it)) : keys;
};

});
parcelRequire.register("aTQ7d", function(module, exports) {

$parcel$export(module.exports, "f", () => $7ef77775e479a0b7$export$2d1720544b23b823, (v) => $7ef77775e479a0b7$export$2d1720544b23b823 = v);
// `Object.getOwnPropertyNames` method
// https://tc39.es/ecma262/#sec-object.getownpropertynames
// eslint-disable-next-line es/no-object-getownpropertynames -- safe
var $7ef77775e479a0b7$export$2d1720544b23b823;

var $151rb = parcelRequire("151rb");

var $4eajX = parcelRequire("4eajX");
var $7ef77775e479a0b7$var$hiddenKeys = $4eajX.concat("length", "prototype");
$7ef77775e479a0b7$export$2d1720544b23b823 = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
    return $151rb(O, $7ef77775e479a0b7$var$hiddenKeys);
};

});
parcelRequire.register("151rb", function(module, exports) {

var $dqhay = parcelRequire("dqhay");

var $dj4ij = parcelRequire("dj4ij");

var $gYLVQ = parcelRequire("gYLVQ");

var $eejJb = parcelRequire("eejJb");
var $0c975f82ab2cffa4$require$indexOf = $eejJb.indexOf;

var $aBDiK = parcelRequire("aBDiK");
var $0c975f82ab2cffa4$var$push = $dqhay([].push);
module.exports = function(object, names) {
    var O = $gYLVQ(object);
    var i = 0;
    var result = [];
    var key;
    for(key in O)!$dj4ij($aBDiK, key) && $dj4ij(O, key) && $0c975f82ab2cffa4$var$push(result, key);
    // Don't enum bug & hidden keys
    while(names.length > i)if ($dj4ij(O, key = names[i++])) ~$0c975f82ab2cffa4$require$indexOf(result, key) || $0c975f82ab2cffa4$var$push(result, key);
    return result;
};

});
parcelRequire.register("eejJb", function(module, exports) {

var $gYLVQ = parcelRequire("gYLVQ");

var $98Q42 = parcelRequire("98Q42");

var $f8kjp = parcelRequire("f8kjp");
// `Array.prototype.{ indexOf, includes }` methods implementation
var $a5c1ad0618b736e6$var$createMethod = function(IS_INCLUDES) {
    return function($this, el, fromIndex) {
        var O = $gYLVQ($this);
        var length = $f8kjp(O);
        var index = $98Q42(fromIndex, length);
        var value;
        // Array#includes uses SameValueZero equality algorithm
        // eslint-disable-next-line no-self-compare -- NaN check
        if (IS_INCLUDES && el != el) while(length > index){
            value = O[index++];
            // eslint-disable-next-line no-self-compare -- NaN check
            if (value != value) return true;
        // Array#indexOf ignores holes, Array#includes - not
        }
        else for(; length > index; index++){
            if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
        }
        return !IS_INCLUDES && -1;
    };
};
module.exports = {
    // `Array.prototype.includes` method
    // https://tc39.es/ecma262/#sec-array.prototype.includes
    includes: $a5c1ad0618b736e6$var$createMethod(true),
    // `Array.prototype.indexOf` method
    // https://tc39.es/ecma262/#sec-array.prototype.indexof
    indexOf: $a5c1ad0618b736e6$var$createMethod(false)
};

});
parcelRequire.register("98Q42", function(module, exports) {

var $cazda = parcelRequire("cazda");
var $6a7d3f478485a4d1$var$max = Math.max;
var $6a7d3f478485a4d1$var$min = Math.min;
// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
module.exports = function(index, length) {
    var integer = $cazda(index);
    return integer < 0 ? $6a7d3f478485a4d1$var$max(integer + length, 0) : $6a7d3f478485a4d1$var$min(integer, length);
};

});
parcelRequire.register("cazda", function(module, exports) {

var $9fvrI = parcelRequire("9fvrI");
// `ToIntegerOrInfinity` abstract operation
// https://tc39.es/ecma262/#sec-tointegerorinfinity
module.exports = function(argument) {
    var number = +argument;
    // eslint-disable-next-line no-self-compare -- NaN check
    return number !== number || number === 0 ? 0 : $9fvrI(number);
};

});
parcelRequire.register("9fvrI", function(module, exports) {
var $6bbde8520925285d$var$ceil = Math.ceil;
var $6bbde8520925285d$var$floor = Math.floor;
// `Math.trunc` method
// https://tc39.es/ecma262/#sec-math.trunc
// eslint-disable-next-line es/no-math-trunc -- safe
module.exports = Math.trunc || function trunc(x) {
    var n = +x;
    return (n > 0 ? $6bbde8520925285d$var$floor : $6bbde8520925285d$var$ceil)(n);
};

});



parcelRequire.register("f8kjp", function(module, exports) {

var $2VHMu = parcelRequire("2VHMu");
// `LengthOfArrayLike` abstract operation
// https://tc39.es/ecma262/#sec-lengthofarraylike
module.exports = function(obj) {
    return $2VHMu(obj.length);
};

});
parcelRequire.register("2VHMu", function(module, exports) {

var $cazda = parcelRequire("cazda");
var $2222dda165373ada$var$min = Math.min;
// `ToLength` abstract operation
// https://tc39.es/ecma262/#sec-tolength
module.exports = function(argument) {
    return argument > 0 ? $2222dda165373ada$var$min($cazda(argument), 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};

});



parcelRequire.register("aBDiK", function(module, exports) {
module.exports = {};

});


parcelRequire.register("4eajX", function(module, exports) {
// IE8- don't enum bug keys
module.exports = [
    "constructor",
    "hasOwnProperty",
    "isPrototypeOf",
    "propertyIsEnumerable",
    "toLocaleString",
    "toString",
    "valueOf"
];

});


parcelRequire.register("3R41N", function(module, exports) {

$parcel$export(module.exports, "f", () => $2ce9722f6b4c09b5$export$2d1720544b23b823, (v) => $2ce9722f6b4c09b5$export$2d1720544b23b823 = v);
// eslint-disable-next-line es/no-object-getownpropertysymbols -- safe
var $2ce9722f6b4c09b5$export$2d1720544b23b823;
$2ce9722f6b4c09b5$export$2d1720544b23b823 = Object.getOwnPropertySymbols;

});



parcelRequire.register("6m5Sk", function(module, exports) {
/* global ActiveXObject -- old IE, WSH */ 
var $3CMpt = parcelRequire("3CMpt");

var $crfP8 = parcelRequire("crfP8");

var $4eajX = parcelRequire("4eajX");

var $aBDiK = parcelRequire("aBDiK");

var $cgF7G = parcelRequire("cgF7G");

var $ip0m4 = parcelRequire("ip0m4");

var $grXcd = parcelRequire("grXcd");
var $4a095add39a9b8a4$var$GT = ">";
var $4a095add39a9b8a4$var$LT = "<";
var $4a095add39a9b8a4$var$PROTOTYPE = "prototype";
var $4a095add39a9b8a4$var$SCRIPT = "script";
var $4a095add39a9b8a4$var$IE_PROTO = $grXcd("IE_PROTO");
var $4a095add39a9b8a4$var$EmptyConstructor = function() {};
var $4a095add39a9b8a4$var$scriptTag = function(content) {
    return $4a095add39a9b8a4$var$LT + $4a095add39a9b8a4$var$SCRIPT + $4a095add39a9b8a4$var$GT + content + $4a095add39a9b8a4$var$LT + "/" + $4a095add39a9b8a4$var$SCRIPT + $4a095add39a9b8a4$var$GT;
};
// Create object with fake `null` prototype: use ActiveX Object with cleared prototype
var $4a095add39a9b8a4$var$NullProtoObjectViaActiveX = function(activeXDocument) {
    activeXDocument.write($4a095add39a9b8a4$var$scriptTag(""));
    activeXDocument.close();
    var temp = activeXDocument.parentWindow.Object;
    activeXDocument = null; // avoid memory leak
    return temp;
};
// Create object with fake `null` prototype: use iframe Object with cleared prototype
var $4a095add39a9b8a4$var$NullProtoObjectViaIFrame = function() {
    // Thrash, waste and sodomy: IE GC bug
    var iframe = $ip0m4("iframe");
    var JS = "java" + $4a095add39a9b8a4$var$SCRIPT + ":";
    var iframeDocument;
    iframe.style.display = "none";
    $cgF7G.appendChild(iframe);
    // https://github.com/zloirock/core-js/issues/475
    iframe.src = String(JS);
    iframeDocument = iframe.contentWindow.document;
    iframeDocument.open();
    iframeDocument.write($4a095add39a9b8a4$var$scriptTag("document.F=Object"));
    iframeDocument.close();
    return iframeDocument.F;
};
// Check for document.domain and active x support
// No need to use active x approach when document.domain is not set
// see https://github.com/es-shims/es5-shim/issues/150
// variation of https://github.com/kitcambridge/es5-shim/commit/4f738ac066346
// avoid IE GC bug
var $4a095add39a9b8a4$var$activeXDocument;
var $4a095add39a9b8a4$var$NullProtoObject = function() {
    try {
        $4a095add39a9b8a4$var$activeXDocument = new ActiveXObject("htmlfile");
    } catch (error) {}
    $4a095add39a9b8a4$var$NullProtoObject = typeof document != "undefined" ? document.domain && $4a095add39a9b8a4$var$activeXDocument ? $4a095add39a9b8a4$var$NullProtoObjectViaActiveX($4a095add39a9b8a4$var$activeXDocument) // old IE
     : $4a095add39a9b8a4$var$NullProtoObjectViaIFrame() : $4a095add39a9b8a4$var$NullProtoObjectViaActiveX($4a095add39a9b8a4$var$activeXDocument); // WSH
    var length = $4eajX.length;
    while(length--)delete $4a095add39a9b8a4$var$NullProtoObject[$4a095add39a9b8a4$var$PROTOTYPE][$4eajX[length]];
    return $4a095add39a9b8a4$var$NullProtoObject();
};
$aBDiK[$4a095add39a9b8a4$var$IE_PROTO] = true;
// `Object.create` method
// https://tc39.es/ecma262/#sec-object.create
// eslint-disable-next-line es/no-object-create -- safe
module.exports = Object.create || function create(O, Properties) {
    var result;
    if (O !== null) {
        $4a095add39a9b8a4$var$EmptyConstructor[$4a095add39a9b8a4$var$PROTOTYPE] = $3CMpt(O);
        result = new $4a095add39a9b8a4$var$EmptyConstructor();
        $4a095add39a9b8a4$var$EmptyConstructor[$4a095add39a9b8a4$var$PROTOTYPE] = null;
        // add "__proto__" for Object.getPrototypeOf polyfill
        result[$4a095add39a9b8a4$var$IE_PROTO] = O;
    } else result = $4a095add39a9b8a4$var$NullProtoObject();
    return Properties === undefined ? result : $crfP8.f(result, Properties);
};

});
parcelRequire.register("crfP8", function(module, exports) {

$parcel$export(module.exports, "f", () => $90e447ea788c47f1$export$2d1720544b23b823, (v) => $90e447ea788c47f1$export$2d1720544b23b823 = v);
// `Object.defineProperties` method
// https://tc39.es/ecma262/#sec-object.defineproperties
// eslint-disable-next-line es/no-object-defineproperties -- safe
var $90e447ea788c47f1$export$2d1720544b23b823;

var $awFtp = parcelRequire("awFtp");

var $6U4Vu = parcelRequire("6U4Vu");

var $8wt5F = parcelRequire("8wt5F");

var $3CMpt = parcelRequire("3CMpt");

var $gYLVQ = parcelRequire("gYLVQ");

var $hQAxZ = parcelRequire("hQAxZ");
$90e447ea788c47f1$export$2d1720544b23b823 = $awFtp && !$6U4Vu ? Object.defineProperties : function defineProperties(O, Properties) {
    $3CMpt(O);
    var props = $gYLVQ(Properties);
    var keys = $hQAxZ(Properties);
    var length = keys.length;
    var index = 0;
    var key;
    while(length > index)$8wt5F.f(O, key = keys[index++], props[key]);
    return O;
};

});
parcelRequire.register("hQAxZ", function(module, exports) {

var $151rb = parcelRequire("151rb");

var $4eajX = parcelRequire("4eajX");
// `Object.keys` method
// https://tc39.es/ecma262/#sec-object.keys
// eslint-disable-next-line es/no-object-keys -- safe
module.exports = Object.keys || function keys(O) {
    return $151rb(O, $4eajX);
};

});


parcelRequire.register("cgF7G", function(module, exports) {

var $7J5vx = parcelRequire("7J5vx");
module.exports = $7J5vx("document", "documentElement");

});


parcelRequire.register("kqpd3", function(module, exports) {

var $2IxWL = parcelRequire("2IxWL");

var $b77ug = parcelRequire("b77ug");
// `InstallErrorCause` abstract operation
// https://tc39.es/proposal-error-cause/#sec-errorobjects-install-error-cause
module.exports = function(O, options) {
    if ($2IxWL(options) && "cause" in options) $b77ug(O, "cause", options.cause);
};

});

parcelRequire.register("6i9F1", function(module, exports) {

var $b77ug = parcelRequire("b77ug");

var $8GmDe = parcelRequire("8GmDe");

var $9LvL7 = parcelRequire("9LvL7");
// non-standard V8
var $494beaeaeb6418c9$var$captureStackTrace = Error.captureStackTrace;
module.exports = function(error, C, stack, dropEntries) {
    if ($9LvL7) {
        if ($494beaeaeb6418c9$var$captureStackTrace) $494beaeaeb6418c9$var$captureStackTrace(error, C);
        else $b77ug(error, "stack", $8GmDe(stack, dropEntries));
    }
};

});
parcelRequire.register("8GmDe", function(module, exports) {

var $dqhay = parcelRequire("dqhay");
var $6523cd27944e0e57$var$$Error = Error;
var $6523cd27944e0e57$var$replace = $dqhay("".replace);
var $6523cd27944e0e57$var$TEST = function(arg) {
    return String($6523cd27944e0e57$var$$Error(arg).stack);
}("zxcasd");
// eslint-disable-next-line redos/no-vulnerable -- safe
var $6523cd27944e0e57$var$V8_OR_CHAKRA_STACK_ENTRY = /\n\s*at [^:]*:[^\n]*/;
var $6523cd27944e0e57$var$IS_V8_OR_CHAKRA_STACK = $6523cd27944e0e57$var$V8_OR_CHAKRA_STACK_ENTRY.test($6523cd27944e0e57$var$TEST);
module.exports = function(stack, dropEntries) {
    if ($6523cd27944e0e57$var$IS_V8_OR_CHAKRA_STACK && typeof stack == "string" && !$6523cd27944e0e57$var$$Error.prepareStackTrace) while(dropEntries--)stack = $6523cd27944e0e57$var$replace(stack, $6523cd27944e0e57$var$V8_OR_CHAKRA_STACK_ENTRY, "");
    return stack;
};

});

parcelRequire.register("9LvL7", function(module, exports) {

var $bSIUO = parcelRequire("bSIUO");

var $80p84 = parcelRequire("80p84");
module.exports = !$bSIUO(function() {
    var error = Error("a");
    if (!("stack" in error)) return true;
    // eslint-disable-next-line es/no-object-defineproperty -- safe
    Object.defineProperty(error, "stack", $80p84(1, 7));
    return error.stack !== 7;
});

});


parcelRequire.register("gCDer", function(module, exports) {

var $jjTxh = parcelRequire("jjTxh");

var $boD6Z = parcelRequire("boD6Z");

var $3CMpt = parcelRequire("3CMpt");

var $ieZRC = parcelRequire("ieZRC");

var $cLgYu = parcelRequire("cLgYu");

var $f8kjp = parcelRequire("f8kjp");

var $53bMe = parcelRequire("53bMe");

var $jzIAy = parcelRequire("jzIAy");

var $4ARxr = parcelRequire("4ARxr");

var $cjnDg = parcelRequire("cjnDg");
var $c19ea0923a07c3a3$var$$TypeError = TypeError;
var $c19ea0923a07c3a3$var$Result = function(stopped, result) {
    this.stopped = stopped;
    this.result = result;
};
var $c19ea0923a07c3a3$var$ResultPrototype = $c19ea0923a07c3a3$var$Result.prototype;
module.exports = function(iterable, unboundFunction, options) {
    var that = options && options.that;
    var AS_ENTRIES = !!(options && options.AS_ENTRIES);
    var IS_RECORD = !!(options && options.IS_RECORD);
    var IS_ITERATOR = !!(options && options.IS_ITERATOR);
    var INTERRUPTED = !!(options && options.INTERRUPTED);
    var fn = $jjTxh(unboundFunction, that);
    var iterator, iterFn, index, length, result, next, step;
    var stop = function(condition) {
        if (iterator) $cjnDg(iterator, "normal", condition);
        return new $c19ea0923a07c3a3$var$Result(true, condition);
    };
    var callFn = function(value) {
        if (AS_ENTRIES) {
            $3CMpt(value);
            return INTERRUPTED ? fn(value[0], value[1], stop) : fn(value[0], value[1]);
        }
        return INTERRUPTED ? fn(value, stop) : fn(value);
    };
    if (IS_RECORD) iterator = iterable.iterator;
    else if (IS_ITERATOR) iterator = iterable;
    else {
        iterFn = $4ARxr(iterable);
        if (!iterFn) throw $c19ea0923a07c3a3$var$$TypeError($ieZRC(iterable) + " is not iterable");
        // optimisation for array iterators
        if ($cLgYu(iterFn)) {
            for(index = 0, length = $f8kjp(iterable); length > index; index++){
                result = callFn(iterable[index]);
                if (result && $53bMe($c19ea0923a07c3a3$var$ResultPrototype, result)) return result;
            }
            return new $c19ea0923a07c3a3$var$Result(false);
        }
        iterator = $jzIAy(iterable, iterFn);
    }
    next = IS_RECORD ? iterable.next : iterator.next;
    while(!(step = $boD6Z(next, iterator)).done){
        try {
            result = callFn(step.value);
        } catch (error) {
            $cjnDg(iterator, "throw", error);
        }
        if (typeof result == "object" && result && $53bMe($c19ea0923a07c3a3$var$ResultPrototype, result)) return result;
    }
    return new $c19ea0923a07c3a3$var$Result(false);
};

});
parcelRequire.register("cLgYu", function(module, exports) {

var $jUcq5 = parcelRequire("jUcq5");

var $f1Wuv = parcelRequire("f1Wuv");
var $94a70aa398366c19$var$ITERATOR = $jUcq5("iterator");
var $94a70aa398366c19$var$ArrayPrototype = Array.prototype;
// check on default Array iterator
module.exports = function(it) {
    return it !== undefined && ($f1Wuv.Array === it || $94a70aa398366c19$var$ArrayPrototype[$94a70aa398366c19$var$ITERATOR] === it);
};

});
parcelRequire.register("f1Wuv", function(module, exports) {
module.exports = {};

});


parcelRequire.register("jzIAy", function(module, exports) {

var $boD6Z = parcelRequire("boD6Z");

var $f9Leu = parcelRequire("f9Leu");

var $3CMpt = parcelRequire("3CMpt");

var $ieZRC = parcelRequire("ieZRC");

var $4ARxr = parcelRequire("4ARxr");
var $e403df93f048ab8c$var$$TypeError = TypeError;
module.exports = function(argument, usingIterator) {
    var iteratorMethod = arguments.length < 2 ? $4ARxr(argument) : usingIterator;
    if ($f9Leu(iteratorMethod)) return $3CMpt($boD6Z(iteratorMethod, argument));
    throw $e403df93f048ab8c$var$$TypeError($ieZRC(argument) + " is not iterable");
};

});
parcelRequire.register("4ARxr", function(module, exports) {

var $jv1hF = parcelRequire("jv1hF");

var $hsQiW = parcelRequire("hsQiW");

var $cp3Nc = parcelRequire("cp3Nc");

var $f1Wuv = parcelRequire("f1Wuv");

var $jUcq5 = parcelRequire("jUcq5");
var $35840dd21dfe2a77$var$ITERATOR = $jUcq5("iterator");
module.exports = function(it) {
    if (!$cp3Nc(it)) return $hsQiW(it, $35840dd21dfe2a77$var$ITERATOR) || $hsQiW(it, "@@iterator") || $f1Wuv[$jv1hF(it)];
};

});
parcelRequire.register("jv1hF", function(module, exports) {

var $6An9r = parcelRequire("6An9r");

var $g0TxJ = parcelRequire("g0TxJ");

var $gir1t = parcelRequire("gir1t");

var $jUcq5 = parcelRequire("jUcq5");
var $e321e8857130e510$var$TO_STRING_TAG = $jUcq5("toStringTag");
var $e321e8857130e510$var$$Object = Object;
// ES3 wrong here
var $e321e8857130e510$var$CORRECT_ARGUMENTS = $gir1t(function() {
    return arguments;
}()) == "Arguments";
// fallback for IE11 Script Access Denied error
var $e321e8857130e510$var$tryGet = function(it, key) {
    try {
        return it[key];
    } catch (error) {}
};
// getting tag from ES6+ `Object.prototype.toString`
module.exports = $6An9r ? $gir1t : function(it) {
    var O, tag, result;
    return it === undefined ? "Undefined" : it === null ? "Null" : typeof (tag = $e321e8857130e510$var$tryGet(O = $e321e8857130e510$var$$Object(it), $e321e8857130e510$var$TO_STRING_TAG)) == "string" ? tag : $e321e8857130e510$var$CORRECT_ARGUMENTS ? $gir1t(O) : (result = $gir1t(O)) == "Object" && $g0TxJ(O.callee) ? "Arguments" : result;
};

});
parcelRequire.register("6An9r", function(module, exports) {

var $jUcq5 = parcelRequire("jUcq5");
var $4cb8103be6dfa54c$var$TO_STRING_TAG = $jUcq5("toStringTag");
var $4cb8103be6dfa54c$var$test = {};
$4cb8103be6dfa54c$var$test[$4cb8103be6dfa54c$var$TO_STRING_TAG] = "z";
module.exports = String($4cb8103be6dfa54c$var$test) === "[object z]";

});




parcelRequire.register("cjnDg", function(module, exports) {

var $boD6Z = parcelRequire("boD6Z");

var $3CMpt = parcelRequire("3CMpt");

var $hsQiW = parcelRequire("hsQiW");
module.exports = function(iterator, kind, value) {
    var innerResult, innerError;
    $3CMpt(iterator);
    try {
        innerResult = $hsQiW(iterator, "return");
        if (!innerResult) {
            if (kind === "throw") throw value;
            return value;
        }
        innerResult = $boD6Z(innerResult, iterator);
    } catch (error) {
        innerError = true;
        innerResult = error;
    }
    if (kind === "throw") throw value;
    if (innerError) throw innerResult;
    $3CMpt(innerResult);
    return value;
};

});


parcelRequire.register("rtmqR", function(module, exports) {

var $elG1Y = parcelRequire("elG1Y");
module.exports = function(argument, $default) {
    return argument === undefined ? arguments.length < 2 ? "" : $default : $elG1Y(argument);
};

});
parcelRequire.register("elG1Y", function(module, exports) {

var $jv1hF = parcelRequire("jv1hF");
var $a723a14e5dc764a4$var$$String = String;
module.exports = function(argument) {
    if ($jv1hF(argument) === "Symbol") throw TypeError("Cannot convert a Symbol value to a string");
    return $a723a14e5dc764a4$var$$String(argument);
};

});




parcelRequire.register("7V1Sz", function(module, exports) {
"use strict";

var $gYLVQ = parcelRequire("gYLVQ");

var $3Gtyn = parcelRequire("3Gtyn");

var $f1Wuv = parcelRequire("f1Wuv");

var $cDGcw = parcelRequire("cDGcw");

var $8wt5F = parcelRequire("8wt5F");
var $5c3f5071cda19d3a$require$defineProperty = $8wt5F.f;

var $17u0H = parcelRequire("17u0H");

var $9xi7m = parcelRequire("9xi7m");

var $bRYhZ = parcelRequire("bRYhZ");

var $awFtp = parcelRequire("awFtp");
var $5c3f5071cda19d3a$var$ARRAY_ITERATOR = "Array Iterator";
var $5c3f5071cda19d3a$var$setInternalState = $cDGcw.set;
var $5c3f5071cda19d3a$var$getInternalState = $cDGcw.getterFor($5c3f5071cda19d3a$var$ARRAY_ITERATOR);
// `Array.prototype.entries` method
// https://tc39.es/ecma262/#sec-array.prototype.entries
// `Array.prototype.keys` method
// https://tc39.es/ecma262/#sec-array.prototype.keys
// `Array.prototype.values` method
// https://tc39.es/ecma262/#sec-array.prototype.values
// `Array.prototype[@@iterator]` method
// https://tc39.es/ecma262/#sec-array.prototype-@@iterator
// `CreateArrayIterator` internal method
// https://tc39.es/ecma262/#sec-createarrayiterator
module.exports = $17u0H(Array, "Array", function(iterated, kind) {
    $5c3f5071cda19d3a$var$setInternalState(this, {
        type: $5c3f5071cda19d3a$var$ARRAY_ITERATOR,
        target: $gYLVQ(iterated),
        index: 0,
        kind: kind // kind
    });
// `%ArrayIteratorPrototype%.next` method
// https://tc39.es/ecma262/#sec-%arrayiteratorprototype%.next
}, function() {
    var state = $5c3f5071cda19d3a$var$getInternalState(this);
    var target = state.target;
    var kind = state.kind;
    var index = state.index++;
    if (!target || index >= target.length) {
        state.target = undefined;
        return $9xi7m(undefined, true);
    }
    if (kind == "keys") return $9xi7m(index, false);
    if (kind == "values") return $9xi7m(target[index], false);
    return $9xi7m([
        index,
        target[index]
    ], false);
}, "values");
// argumentsList[@@iterator] is %ArrayProto_values%
// https://tc39.es/ecma262/#sec-createunmappedargumentsobject
// https://tc39.es/ecma262/#sec-createmappedargumentsobject
var $5c3f5071cda19d3a$var$values = $f1Wuv.Arguments = $f1Wuv.Array;
// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
$3Gtyn("keys");
$3Gtyn("values");
$3Gtyn("entries");
// V8 ~ Chrome 45- bug
if (!$bRYhZ && $awFtp && $5c3f5071cda19d3a$var$values.name !== "values") try {
    $5c3f5071cda19d3a$require$defineProperty($5c3f5071cda19d3a$var$values, "name", {
        value: "values"
    });
} catch (error) {}

});
parcelRequire.register("3Gtyn", function(module, exports) {
module.exports = function() {};

});

parcelRequire.register("cDGcw", function(module, exports) {

var $hYhNw = parcelRequire("hYhNw");

var $bbWQF = parcelRequire("bbWQF");

var $2IxWL = parcelRequire("2IxWL");

var $b77ug = parcelRequire("b77ug");

var $dj4ij = parcelRequire("dj4ij");

var $fOCTs = parcelRequire("fOCTs");

var $grXcd = parcelRequire("grXcd");

var $aBDiK = parcelRequire("aBDiK");
var $9339dcca79a9abb1$var$OBJECT_ALREADY_INITIALIZED = "Object already initialized";
var $9339dcca79a9abb1$var$TypeError = $bbWQF.TypeError;
var $9339dcca79a9abb1$var$WeakMap = $bbWQF.WeakMap;
var $9339dcca79a9abb1$var$set, $9339dcca79a9abb1$var$get, $9339dcca79a9abb1$var$has;
var $9339dcca79a9abb1$var$enforce = function(it) {
    return $9339dcca79a9abb1$var$has(it) ? $9339dcca79a9abb1$var$get(it) : $9339dcca79a9abb1$var$set(it, {});
};
var $9339dcca79a9abb1$var$getterFor = function(TYPE) {
    return function(it) {
        var state;
        if (!$2IxWL(it) || (state = $9339dcca79a9abb1$var$get(it)).type !== TYPE) throw $9339dcca79a9abb1$var$TypeError("Incompatible receiver, " + TYPE + " required");
        return state;
    };
};
if ($hYhNw || $fOCTs.state) {
    var $9339dcca79a9abb1$var$store = $fOCTs.state || ($fOCTs.state = new $9339dcca79a9abb1$var$WeakMap());
    /* eslint-disable no-self-assign -- prototype methods protection */ $9339dcca79a9abb1$var$store.get = $9339dcca79a9abb1$var$store.get;
    $9339dcca79a9abb1$var$store.has = $9339dcca79a9abb1$var$store.has;
    $9339dcca79a9abb1$var$store.set = $9339dcca79a9abb1$var$store.set;
    /* eslint-enable no-self-assign -- prototype methods protection */ $9339dcca79a9abb1$var$set = function(it, metadata) {
        if ($9339dcca79a9abb1$var$store.has(it)) throw $9339dcca79a9abb1$var$TypeError($9339dcca79a9abb1$var$OBJECT_ALREADY_INITIALIZED);
        metadata.facade = it;
        $9339dcca79a9abb1$var$store.set(it, metadata);
        return metadata;
    };
    $9339dcca79a9abb1$var$get = function(it) {
        return $9339dcca79a9abb1$var$store.get(it) || {};
    };
    $9339dcca79a9abb1$var$has = function(it) {
        return $9339dcca79a9abb1$var$store.has(it);
    };
} else {
    var $9339dcca79a9abb1$var$STATE = $grXcd("state");
    $aBDiK[$9339dcca79a9abb1$var$STATE] = true;
    $9339dcca79a9abb1$var$set = function(it, metadata) {
        if ($dj4ij(it, $9339dcca79a9abb1$var$STATE)) throw $9339dcca79a9abb1$var$TypeError($9339dcca79a9abb1$var$OBJECT_ALREADY_INITIALIZED);
        metadata.facade = it;
        $b77ug(it, $9339dcca79a9abb1$var$STATE, metadata);
        return metadata;
    };
    $9339dcca79a9abb1$var$get = function(it) {
        return $dj4ij(it, $9339dcca79a9abb1$var$STATE) ? it[$9339dcca79a9abb1$var$STATE] : {};
    };
    $9339dcca79a9abb1$var$has = function(it) {
        return $dj4ij(it, $9339dcca79a9abb1$var$STATE);
    };
}
module.exports = {
    set: $9339dcca79a9abb1$var$set,
    get: $9339dcca79a9abb1$var$get,
    has: $9339dcca79a9abb1$var$has,
    enforce: $9339dcca79a9abb1$var$enforce,
    getterFor: $9339dcca79a9abb1$var$getterFor
};

});
parcelRequire.register("hYhNw", function(module, exports) {

var $bbWQF = parcelRequire("bbWQF");

var $g0TxJ = parcelRequire("g0TxJ");
var $d155d88b1e008d88$var$WeakMap = $bbWQF.WeakMap;
module.exports = $g0TxJ($d155d88b1e008d88$var$WeakMap) && /native code/.test(String($d155d88b1e008d88$var$WeakMap));

});


parcelRequire.register("17u0H", function(module, exports) {
"use strict";

var $2iwSV = parcelRequire("2iwSV");

var $boD6Z = parcelRequire("boD6Z");

var $bRYhZ = parcelRequire("bRYhZ");

var $ftZ8i = parcelRequire("ftZ8i");

var $g0TxJ = parcelRequire("g0TxJ");

var $bvlAf = parcelRequire("bvlAf");

var $2T3Ss = parcelRequire("2T3Ss");

var $a7qOu = parcelRequire("a7qOu");

var $7dwMK = parcelRequire("7dwMK");

var $b77ug = parcelRequire("b77ug");

var $hY10v = parcelRequire("hY10v");

var $jUcq5 = parcelRequire("jUcq5");

var $f1Wuv = parcelRequire("f1Wuv");

var $eADf6 = parcelRequire("eADf6");
var $0d0db94a018ca5d8$var$PROPER_FUNCTION_NAME = $ftZ8i.PROPER;
var $0d0db94a018ca5d8$var$CONFIGURABLE_FUNCTION_NAME = $ftZ8i.CONFIGURABLE;
var $0d0db94a018ca5d8$var$IteratorPrototype = $eADf6.IteratorPrototype;
var $0d0db94a018ca5d8$var$BUGGY_SAFARI_ITERATORS = $eADf6.BUGGY_SAFARI_ITERATORS;
var $0d0db94a018ca5d8$var$ITERATOR = $jUcq5("iterator");
var $0d0db94a018ca5d8$var$KEYS = "keys";
var $0d0db94a018ca5d8$var$VALUES = "values";
var $0d0db94a018ca5d8$var$ENTRIES = "entries";
var $0d0db94a018ca5d8$var$returnThis = function() {
    return this;
};
module.exports = function(Iterable, NAME, IteratorConstructor, next, DEFAULT, IS_SET, FORCED) {
    $bvlAf(IteratorConstructor, NAME, next);
    var getIterationMethod = function(KIND) {
        if (KIND === DEFAULT && defaultIterator) return defaultIterator;
        if (!$0d0db94a018ca5d8$var$BUGGY_SAFARI_ITERATORS && KIND in IterablePrototype) return IterablePrototype[KIND];
        switch(KIND){
            case $0d0db94a018ca5d8$var$KEYS:
                return function keys() {
                    return new IteratorConstructor(this, KIND);
                };
            case $0d0db94a018ca5d8$var$VALUES:
                return function values() {
                    return new IteratorConstructor(this, KIND);
                };
            case $0d0db94a018ca5d8$var$ENTRIES:
                return function entries() {
                    return new IteratorConstructor(this, KIND);
                };
        }
        return function() {
            return new IteratorConstructor(this);
        };
    };
    var TO_STRING_TAG = NAME + " Iterator";
    var INCORRECT_VALUES_NAME = false;
    var IterablePrototype = Iterable.prototype;
    var nativeIterator = IterablePrototype[$0d0db94a018ca5d8$var$ITERATOR] || IterablePrototype["@@iterator"] || DEFAULT && IterablePrototype[DEFAULT];
    var defaultIterator = !$0d0db94a018ca5d8$var$BUGGY_SAFARI_ITERATORS && nativeIterator || getIterationMethod(DEFAULT);
    var anyNativeIterator = NAME == "Array" ? IterablePrototype.entries || nativeIterator : nativeIterator;
    var CurrentIteratorPrototype, methods, KEY;
    // fix native
    if (anyNativeIterator) {
        CurrentIteratorPrototype = $2T3Ss(anyNativeIterator.call(new Iterable()));
        if (CurrentIteratorPrototype !== Object.prototype && CurrentIteratorPrototype.next) {
            if (!$bRYhZ && $2T3Ss(CurrentIteratorPrototype) !== $0d0db94a018ca5d8$var$IteratorPrototype) {
                if ($a7qOu) $a7qOu(CurrentIteratorPrototype, $0d0db94a018ca5d8$var$IteratorPrototype);
                else if (!$g0TxJ(CurrentIteratorPrototype[$0d0db94a018ca5d8$var$ITERATOR])) $hY10v(CurrentIteratorPrototype, $0d0db94a018ca5d8$var$ITERATOR, $0d0db94a018ca5d8$var$returnThis);
            }
            // Set @@toStringTag to native iterators
            $7dwMK(CurrentIteratorPrototype, TO_STRING_TAG, true, true);
            if ($bRYhZ) $f1Wuv[TO_STRING_TAG] = $0d0db94a018ca5d8$var$returnThis;
        }
    }
    // fix Array.prototype.{ values, @@iterator }.name in V8 / FF
    if ($0d0db94a018ca5d8$var$PROPER_FUNCTION_NAME && DEFAULT == $0d0db94a018ca5d8$var$VALUES && nativeIterator && nativeIterator.name !== $0d0db94a018ca5d8$var$VALUES) {
        if (!$bRYhZ && $0d0db94a018ca5d8$var$CONFIGURABLE_FUNCTION_NAME) $b77ug(IterablePrototype, "name", $0d0db94a018ca5d8$var$VALUES);
        else {
            INCORRECT_VALUES_NAME = true;
            defaultIterator = function values() {
                return $boD6Z(nativeIterator, this);
            };
        }
    }
    // export additional methods
    if (DEFAULT) {
        methods = {
            values: getIterationMethod($0d0db94a018ca5d8$var$VALUES),
            keys: IS_SET ? defaultIterator : getIterationMethod($0d0db94a018ca5d8$var$KEYS),
            entries: getIterationMethod($0d0db94a018ca5d8$var$ENTRIES)
        };
        if (FORCED) {
            for(KEY in methods)if ($0d0db94a018ca5d8$var$BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME || !(KEY in IterablePrototype)) $hY10v(IterablePrototype, KEY, methods[KEY]);
        } else $2iwSV({
            target: NAME,
            proto: true,
            forced: $0d0db94a018ca5d8$var$BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME
        }, methods);
    }
    // define iterator
    if ((!$bRYhZ || FORCED) && IterablePrototype[$0d0db94a018ca5d8$var$ITERATOR] !== defaultIterator) $hY10v(IterablePrototype, $0d0db94a018ca5d8$var$ITERATOR, defaultIterator, {
        name: DEFAULT
    });
    $f1Wuv[NAME] = defaultIterator;
    return methods;
};

});
parcelRequire.register("ftZ8i", function(module, exports) {

var $awFtp = parcelRequire("awFtp");

var $dj4ij = parcelRequire("dj4ij");
var $b458fc24748bacf8$var$FunctionPrototype = Function.prototype;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $b458fc24748bacf8$var$getDescriptor = $awFtp && Object.getOwnPropertyDescriptor;
var $b458fc24748bacf8$var$EXISTS = $dj4ij($b458fc24748bacf8$var$FunctionPrototype, "name");
// additional protection from minified / mangled / dropped function names
var $b458fc24748bacf8$var$PROPER = $b458fc24748bacf8$var$EXISTS && (function something() {}).name === "something";
var $b458fc24748bacf8$var$CONFIGURABLE = $b458fc24748bacf8$var$EXISTS && (!$awFtp || $awFtp && $b458fc24748bacf8$var$getDescriptor($b458fc24748bacf8$var$FunctionPrototype, "name").configurable);
module.exports = {
    EXISTS: $b458fc24748bacf8$var$EXISTS,
    PROPER: $b458fc24748bacf8$var$PROPER,
    CONFIGURABLE: $b458fc24748bacf8$var$CONFIGURABLE
};

});

parcelRequire.register("bvlAf", function(module, exports) {
"use strict";

var $eADf6 = parcelRequire("eADf6");
var $8603550693e2ae10$require$IteratorPrototype = $eADf6.IteratorPrototype;

var $6m5Sk = parcelRequire("6m5Sk");

var $80p84 = parcelRequire("80p84");

var $7dwMK = parcelRequire("7dwMK");

var $f1Wuv = parcelRequire("f1Wuv");
var $8603550693e2ae10$var$returnThis = function() {
    return this;
};
module.exports = function(IteratorConstructor, NAME, next, ENUMERABLE_NEXT) {
    var TO_STRING_TAG = NAME + " Iterator";
    IteratorConstructor.prototype = $6m5Sk($8603550693e2ae10$require$IteratorPrototype, {
        next: $80p84(+!ENUMERABLE_NEXT, next)
    });
    $7dwMK(IteratorConstructor, TO_STRING_TAG, false, true);
    $f1Wuv[TO_STRING_TAG] = $8603550693e2ae10$var$returnThis;
    return IteratorConstructor;
};

});
parcelRequire.register("eADf6", function(module, exports) {
"use strict";

var $bSIUO = parcelRequire("bSIUO");

var $g0TxJ = parcelRequire("g0TxJ");

var $2IxWL = parcelRequire("2IxWL");

var $6m5Sk = parcelRequire("6m5Sk");

var $2T3Ss = parcelRequire("2T3Ss");

var $hY10v = parcelRequire("hY10v");

var $jUcq5 = parcelRequire("jUcq5");

var $bRYhZ = parcelRequire("bRYhZ");
var $a9f2de3f59241c76$var$ITERATOR = $jUcq5("iterator");
var $a9f2de3f59241c76$var$BUGGY_SAFARI_ITERATORS = false;
// `%IteratorPrototype%` object
// https://tc39.es/ecma262/#sec-%iteratorprototype%-object
var $a9f2de3f59241c76$var$IteratorPrototype, $a9f2de3f59241c76$var$PrototypeOfArrayIteratorPrototype, $a9f2de3f59241c76$var$arrayIterator;
/* eslint-disable es/no-array-prototype-keys -- safe */ if ([].keys) {
    $a9f2de3f59241c76$var$arrayIterator = [].keys();
    // Safari 8 has buggy iterators w/o `next`
    if (!("next" in $a9f2de3f59241c76$var$arrayIterator)) $a9f2de3f59241c76$var$BUGGY_SAFARI_ITERATORS = true;
    else {
        $a9f2de3f59241c76$var$PrototypeOfArrayIteratorPrototype = $2T3Ss($2T3Ss($a9f2de3f59241c76$var$arrayIterator));
        if ($a9f2de3f59241c76$var$PrototypeOfArrayIteratorPrototype !== Object.prototype) $a9f2de3f59241c76$var$IteratorPrototype = $a9f2de3f59241c76$var$PrototypeOfArrayIteratorPrototype;
    }
}
var $a9f2de3f59241c76$var$NEW_ITERATOR_PROTOTYPE = !$2IxWL($a9f2de3f59241c76$var$IteratorPrototype) || $bSIUO(function() {
    var test = {};
    // FF44- legacy iterators case
    return $a9f2de3f59241c76$var$IteratorPrototype[$a9f2de3f59241c76$var$ITERATOR].call(test) !== test;
});
if ($a9f2de3f59241c76$var$NEW_ITERATOR_PROTOTYPE) $a9f2de3f59241c76$var$IteratorPrototype = {};
else if ($bRYhZ) $a9f2de3f59241c76$var$IteratorPrototype = $6m5Sk($a9f2de3f59241c76$var$IteratorPrototype);
// `%IteratorPrototype%[@@iterator]()` method
// https://tc39.es/ecma262/#sec-%iteratorprototype%-@@iterator
if (!$g0TxJ($a9f2de3f59241c76$var$IteratorPrototype[$a9f2de3f59241c76$var$ITERATOR])) $hY10v($a9f2de3f59241c76$var$IteratorPrototype, $a9f2de3f59241c76$var$ITERATOR, function() {
    return this;
});
module.exports = {
    IteratorPrototype: $a9f2de3f59241c76$var$IteratorPrototype,
    BUGGY_SAFARI_ITERATORS: $a9f2de3f59241c76$var$BUGGY_SAFARI_ITERATORS
};

});
parcelRequire.register("hY10v", function(module, exports) {

var $b77ug = parcelRequire("b77ug");
module.exports = function(target, key, value, options) {
    if (options && options.enumerable) target[key] = value;
    else $b77ug(target, key, value);
    return target;
};

});


parcelRequire.register("7dwMK", function(module, exports) {

var $6An9r = parcelRequire("6An9r");

var $8wt5F = parcelRequire("8wt5F");
var $54132dbf1f3593a2$require$defineProperty = $8wt5F.f;

var $b77ug = parcelRequire("b77ug");

var $dj4ij = parcelRequire("dj4ij");

var $80GvJ = parcelRequire("80GvJ");

var $jUcq5 = parcelRequire("jUcq5");
var $54132dbf1f3593a2$var$TO_STRING_TAG = $jUcq5("toStringTag");
module.exports = function(it, TAG, STATIC, SET_METHOD) {
    if (it) {
        var target = STATIC ? it : it.prototype;
        if (!$dj4ij(target, $54132dbf1f3593a2$var$TO_STRING_TAG)) $54132dbf1f3593a2$require$defineProperty(target, $54132dbf1f3593a2$var$TO_STRING_TAG, {
            configurable: true,
            value: TAG
        });
        if (SET_METHOD && !$6An9r) $b77ug(target, "toString", $80GvJ);
    }
};

});
parcelRequire.register("80GvJ", function(module, exports) {
"use strict";

var $6An9r = parcelRequire("6An9r");

var $jv1hF = parcelRequire("jv1hF");
// `Object.prototype.toString` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.tostring
module.exports = $6An9r ? ({}).toString : function toString() {
    return "[object " + $jv1hF(this) + "]";
};

});




parcelRequire.register("9xi7m", function(module, exports) {
// `CreateIterResultObject` abstract operation
// https://tc39.es/ecma262/#sec-createiterresultobject
module.exports = function(value, done) {
    return {
        value: value,
        done: done
    };
};

});


parcelRequire.register("evDrA", function(module, exports) {
// empty

});

parcelRequire.register("ihzDZ", function(module, exports) {
// TODO: Remove this module from `core-js@4` since it's split to modules listed below
parcelRequire("985Sz");
parcelRequire("aOeGS");
parcelRequire("b2wwM");
parcelRequire("2e23o");
parcelRequire("5Oqis");
parcelRequire("fhrRC");

});
parcelRequire.register("985Sz", function(module, exports) {
"use strict";

var $2iwSV = parcelRequire("2iwSV");

var $bRYhZ = parcelRequire("bRYhZ");

var $9sRxI = parcelRequire("9sRxI");

var $bbWQF = parcelRequire("bbWQF");

var $boD6Z = parcelRequire("boD6Z");

var $hY10v = parcelRequire("hY10v");

var $a7qOu = parcelRequire("a7qOu");

var $7dwMK = parcelRequire("7dwMK");

var $6eNI9 = parcelRequire("6eNI9");

var $f9Leu = parcelRequire("f9Leu");

var $g0TxJ = parcelRequire("g0TxJ");

var $2IxWL = parcelRequire("2IxWL");

var $cAgU5 = parcelRequire("cAgU5");

var $cchD4 = parcelRequire("cchD4");

var $1Y3YL = parcelRequire("1Y3YL");
var $6a596be71e67b735$require$task = $1Y3YL.set;

var $5c0v0 = parcelRequire("5c0v0");

var $4H38s = parcelRequire("4H38s");

var $hFxjr = parcelRequire("hFxjr");

var $6i6LS = parcelRequire("6i6LS");

var $cDGcw = parcelRequire("cDGcw");

var $7Xg1f = parcelRequire("7Xg1f");

var $8hl4h = parcelRequire("8hl4h");

var $h4XGr = parcelRequire("h4XGr");
var $6a596be71e67b735$var$PROMISE = "Promise";
var $6a596be71e67b735$var$FORCED_PROMISE_CONSTRUCTOR = $8hl4h.CONSTRUCTOR;
var $6a596be71e67b735$var$NATIVE_PROMISE_REJECTION_EVENT = $8hl4h.REJECTION_EVENT;
var $6a596be71e67b735$var$NATIVE_PROMISE_SUBCLASSING = $8hl4h.SUBCLASSING;
var $6a596be71e67b735$var$getInternalPromiseState = $cDGcw.getterFor($6a596be71e67b735$var$PROMISE);
var $6a596be71e67b735$var$setInternalState = $cDGcw.set;
var $6a596be71e67b735$var$NativePromisePrototype = $7Xg1f && $7Xg1f.prototype;
var $6a596be71e67b735$var$PromiseConstructor = $7Xg1f;
var $6a596be71e67b735$var$PromisePrototype = $6a596be71e67b735$var$NativePromisePrototype;
var $6a596be71e67b735$var$TypeError = $bbWQF.TypeError;
var $6a596be71e67b735$var$document = $bbWQF.document;
var $6a596be71e67b735$var$process = $bbWQF.process;
var $6a596be71e67b735$var$newPromiseCapability = $h4XGr.f;
var $6a596be71e67b735$var$newGenericPromiseCapability = $6a596be71e67b735$var$newPromiseCapability;
var $6a596be71e67b735$var$DISPATCH_EVENT = !!($6a596be71e67b735$var$document && $6a596be71e67b735$var$document.createEvent && $bbWQF.dispatchEvent);
var $6a596be71e67b735$var$UNHANDLED_REJECTION = "unhandledrejection";
var $6a596be71e67b735$var$REJECTION_HANDLED = "rejectionhandled";
var $6a596be71e67b735$var$PENDING = 0;
var $6a596be71e67b735$var$FULFILLED = 1;
var $6a596be71e67b735$var$REJECTED = 2;
var $6a596be71e67b735$var$HANDLED = 1;
var $6a596be71e67b735$var$UNHANDLED = 2;
var $6a596be71e67b735$var$Internal, $6a596be71e67b735$var$OwnPromiseCapability, $6a596be71e67b735$var$PromiseWrapper, $6a596be71e67b735$var$nativeThen;
// helpers
var $6a596be71e67b735$var$isThenable = function(it) {
    var then;
    return $2IxWL(it) && $g0TxJ(then = it.then) ? then : false;
};
var $6a596be71e67b735$var$callReaction = function(reaction, state) {
    var value = state.value;
    var ok = state.state == $6a596be71e67b735$var$FULFILLED;
    var handler = ok ? reaction.ok : reaction.fail;
    var resolve = reaction.resolve;
    var reject = reaction.reject;
    var domain = reaction.domain;
    var result, then, exited;
    try {
        if (handler) {
            if (!ok) {
                if (state.rejection === $6a596be71e67b735$var$UNHANDLED) $6a596be71e67b735$var$onHandleUnhandled(state);
                state.rejection = $6a596be71e67b735$var$HANDLED;
            }
            if (handler === true) result = value;
            else {
                if (domain) domain.enter();
                result = handler(value); // can throw
                if (domain) {
                    domain.exit();
                    exited = true;
                }
            }
            if (result === reaction.promise) reject($6a596be71e67b735$var$TypeError("Promise-chain cycle"));
            else if (then = $6a596be71e67b735$var$isThenable(result)) $boD6Z(then, result, resolve, reject);
            else resolve(result);
        } else reject(value);
    } catch (error) {
        if (domain && !exited) domain.exit();
        reject(error);
    }
};
var $6a596be71e67b735$var$notify = function(state, isReject) {
    if (state.notified) return;
    state.notified = true;
    $5c0v0(function() {
        var reactions = state.reactions;
        var reaction;
        while(reaction = reactions.get())$6a596be71e67b735$var$callReaction(reaction, state);
        state.notified = false;
        if (isReject && !state.rejection) $6a596be71e67b735$var$onUnhandled(state);
    });
};
var $6a596be71e67b735$var$dispatchEvent = function(name, promise, reason) {
    var event, handler;
    if ($6a596be71e67b735$var$DISPATCH_EVENT) {
        event = $6a596be71e67b735$var$document.createEvent("Event");
        event.promise = promise;
        event.reason = reason;
        event.initEvent(name, false, true);
        $bbWQF.dispatchEvent(event);
    } else event = {
        promise: promise,
        reason: reason
    };
    if (!$6a596be71e67b735$var$NATIVE_PROMISE_REJECTION_EVENT && (handler = $bbWQF["on" + name])) handler(event);
    else if (name === $6a596be71e67b735$var$UNHANDLED_REJECTION) $4H38s("Unhandled promise rejection", reason);
};
var $6a596be71e67b735$var$onUnhandled = function(state) {
    $boD6Z($6a596be71e67b735$require$task, $bbWQF, function() {
        var promise = state.facade;
        var value = state.value;
        var IS_UNHANDLED = $6a596be71e67b735$var$isUnhandled(state);
        var result;
        if (IS_UNHANDLED) {
            result = $hFxjr(function() {
                if ($9sRxI) $6a596be71e67b735$var$process.emit("unhandledRejection", value, promise);
                else $6a596be71e67b735$var$dispatchEvent($6a596be71e67b735$var$UNHANDLED_REJECTION, promise, value);
            });
            // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
            state.rejection = $9sRxI || $6a596be71e67b735$var$isUnhandled(state) ? $6a596be71e67b735$var$UNHANDLED : $6a596be71e67b735$var$HANDLED;
            if (result.error) throw result.value;
        }
    });
};
var $6a596be71e67b735$var$isUnhandled = function(state) {
    return state.rejection !== $6a596be71e67b735$var$HANDLED && !state.parent;
};
var $6a596be71e67b735$var$onHandleUnhandled = function(state) {
    $boD6Z($6a596be71e67b735$require$task, $bbWQF, function() {
        var promise = state.facade;
        if ($9sRxI) $6a596be71e67b735$var$process.emit("rejectionHandled", promise);
        else $6a596be71e67b735$var$dispatchEvent($6a596be71e67b735$var$REJECTION_HANDLED, promise, state.value);
    });
};
var $6a596be71e67b735$var$bind = function(fn, state, unwrap) {
    return function(value) {
        fn(state, value, unwrap);
    };
};
var $6a596be71e67b735$var$internalReject = function(state, value, unwrap) {
    if (state.done) return;
    state.done = true;
    if (unwrap) state = unwrap;
    state.value = value;
    state.state = $6a596be71e67b735$var$REJECTED;
    $6a596be71e67b735$var$notify(state, true);
};
var $6a596be71e67b735$var$internalResolve = function(state, value, unwrap) {
    if (state.done) return;
    state.done = true;
    if (unwrap) state = unwrap;
    try {
        if (state.facade === value) throw $6a596be71e67b735$var$TypeError("Promise can't be resolved itself");
        var then = $6a596be71e67b735$var$isThenable(value);
        if (then) $5c0v0(function() {
            var wrapper = {
                done: false
            };
            try {
                $boD6Z(then, value, $6a596be71e67b735$var$bind($6a596be71e67b735$var$internalResolve, wrapper, state), $6a596be71e67b735$var$bind($6a596be71e67b735$var$internalReject, wrapper, state));
            } catch (error) {
                $6a596be71e67b735$var$internalReject(wrapper, error, state);
            }
        });
        else {
            state.value = value;
            state.state = $6a596be71e67b735$var$FULFILLED;
            $6a596be71e67b735$var$notify(state, false);
        }
    } catch (error) {
        $6a596be71e67b735$var$internalReject({
            done: false
        }, error, state);
    }
};
// constructor polyfill
if ($6a596be71e67b735$var$FORCED_PROMISE_CONSTRUCTOR) {
    // 25.4.3.1 Promise(executor)
    $6a596be71e67b735$var$PromiseConstructor = function Promise(executor) {
        $cAgU5(this, $6a596be71e67b735$var$PromisePrototype);
        $f9Leu(executor);
        $boD6Z($6a596be71e67b735$var$Internal, this);
        var state = $6a596be71e67b735$var$getInternalPromiseState(this);
        try {
            executor($6a596be71e67b735$var$bind($6a596be71e67b735$var$internalResolve, state), $6a596be71e67b735$var$bind($6a596be71e67b735$var$internalReject, state));
        } catch (error) {
            $6a596be71e67b735$var$internalReject(state, error);
        }
    };
    $6a596be71e67b735$var$PromisePrototype = $6a596be71e67b735$var$PromiseConstructor.prototype;
    // eslint-disable-next-line no-unused-vars -- required for `.length`
    $6a596be71e67b735$var$Internal = function Promise(executor) {
        $6a596be71e67b735$var$setInternalState(this, {
            type: $6a596be71e67b735$var$PROMISE,
            done: false,
            notified: false,
            parent: false,
            reactions: new $6i6LS(),
            rejection: false,
            state: $6a596be71e67b735$var$PENDING,
            value: undefined
        });
    };
    // `Promise.prototype.then` method
    // https://tc39.es/ecma262/#sec-promise.prototype.then
    $6a596be71e67b735$var$Internal.prototype = $hY10v($6a596be71e67b735$var$PromisePrototype, "then", function then(onFulfilled, onRejected) {
        var state = $6a596be71e67b735$var$getInternalPromiseState(this);
        var reaction = $6a596be71e67b735$var$newPromiseCapability($cchD4(this, $6a596be71e67b735$var$PromiseConstructor));
        state.parent = true;
        reaction.ok = $g0TxJ(onFulfilled) ? onFulfilled : true;
        reaction.fail = $g0TxJ(onRejected) && onRejected;
        reaction.domain = $9sRxI ? $6a596be71e67b735$var$process.domain : undefined;
        if (state.state == $6a596be71e67b735$var$PENDING) state.reactions.add(reaction);
        else $5c0v0(function() {
            $6a596be71e67b735$var$callReaction(reaction, state);
        });
        return reaction.promise;
    });
    $6a596be71e67b735$var$OwnPromiseCapability = function() {
        var promise = new $6a596be71e67b735$var$Internal();
        var state = $6a596be71e67b735$var$getInternalPromiseState(promise);
        this.promise = promise;
        this.resolve = $6a596be71e67b735$var$bind($6a596be71e67b735$var$internalResolve, state);
        this.reject = $6a596be71e67b735$var$bind($6a596be71e67b735$var$internalReject, state);
    };
    $h4XGr.f = $6a596be71e67b735$var$newPromiseCapability = function(C) {
        return C === $6a596be71e67b735$var$PromiseConstructor || C === $6a596be71e67b735$var$PromiseWrapper ? new $6a596be71e67b735$var$OwnPromiseCapability(C) : $6a596be71e67b735$var$newGenericPromiseCapability(C);
    };
    if (!$bRYhZ && $g0TxJ($7Xg1f) && $6a596be71e67b735$var$NativePromisePrototype !== Object.prototype) {
        $6a596be71e67b735$var$nativeThen = $6a596be71e67b735$var$NativePromisePrototype.then;
        if (!$6a596be71e67b735$var$NATIVE_PROMISE_SUBCLASSING) // make `Promise#then` return a polyfilled `Promise` for native promise-based APIs
        $hY10v($6a596be71e67b735$var$NativePromisePrototype, "then", function then(onFulfilled, onRejected) {
            var that = this;
            return new $6a596be71e67b735$var$PromiseConstructor(function(resolve, reject) {
                $boD6Z($6a596be71e67b735$var$nativeThen, that, resolve, reject);
            }).then(onFulfilled, onRejected);
        // https://github.com/zloirock/core-js/issues/640
        }, {
            unsafe: true
        });
        // make `.constructor === Promise` work for native promise-based APIs
        try {
            delete $6a596be71e67b735$var$NativePromisePrototype.constructor;
        } catch (error) {}
        // make `instanceof Promise` work for native promise-based APIs
        if ($a7qOu) $a7qOu($6a596be71e67b735$var$NativePromisePrototype, $6a596be71e67b735$var$PromisePrototype);
    }
}
$2iwSV({
    global: true,
    constructor: true,
    wrap: true,
    forced: $6a596be71e67b735$var$FORCED_PROMISE_CONSTRUCTOR
}, {
    Promise: $6a596be71e67b735$var$PromiseConstructor
});
$7dwMK($6a596be71e67b735$var$PromiseConstructor, $6a596be71e67b735$var$PROMISE, false, true);
$6eNI9($6a596be71e67b735$var$PROMISE);

});
parcelRequire.register("9sRxI", function(module, exports) {

var $hIXGI = parcelRequire("hIXGI");

var $gir1t = parcelRequire("gir1t");
module.exports = typeof $hIXGI != "undefined" && $gir1t($hIXGI) == "process";

});
parcelRequire.register("hIXGI", function(module, exports) {
// shim for using process in browser
var $ce74d88631dafa59$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $ce74d88631dafa59$var$cachedSetTimeout;
var $ce74d88631dafa59$var$cachedClearTimeout;
function $ce74d88631dafa59$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $ce74d88631dafa59$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $ce74d88631dafa59$var$cachedSetTimeout = setTimeout;
        else $ce74d88631dafa59$var$cachedSetTimeout = $ce74d88631dafa59$var$defaultSetTimout;
    } catch (e) {
        $ce74d88631dafa59$var$cachedSetTimeout = $ce74d88631dafa59$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $ce74d88631dafa59$var$cachedClearTimeout = clearTimeout;
        else $ce74d88631dafa59$var$cachedClearTimeout = $ce74d88631dafa59$var$defaultClearTimeout;
    } catch (e) {
        $ce74d88631dafa59$var$cachedClearTimeout = $ce74d88631dafa59$var$defaultClearTimeout;
    }
})();
function $ce74d88631dafa59$var$runTimeout(fun) {
    if ($ce74d88631dafa59$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($ce74d88631dafa59$var$cachedSetTimeout === $ce74d88631dafa59$var$defaultSetTimout || !$ce74d88631dafa59$var$cachedSetTimeout) && setTimeout) {
        $ce74d88631dafa59$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $ce74d88631dafa59$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $ce74d88631dafa59$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $ce74d88631dafa59$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $ce74d88631dafa59$var$runClearTimeout(marker) {
    if ($ce74d88631dafa59$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($ce74d88631dafa59$var$cachedClearTimeout === $ce74d88631dafa59$var$defaultClearTimeout || !$ce74d88631dafa59$var$cachedClearTimeout) && clearTimeout) {
        $ce74d88631dafa59$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $ce74d88631dafa59$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $ce74d88631dafa59$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $ce74d88631dafa59$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $ce74d88631dafa59$var$queue = [];
var $ce74d88631dafa59$var$draining = false;
var $ce74d88631dafa59$var$currentQueue;
var $ce74d88631dafa59$var$queueIndex = -1;
function $ce74d88631dafa59$var$cleanUpNextTick() {
    if (!$ce74d88631dafa59$var$draining || !$ce74d88631dafa59$var$currentQueue) return;
    $ce74d88631dafa59$var$draining = false;
    if ($ce74d88631dafa59$var$currentQueue.length) $ce74d88631dafa59$var$queue = $ce74d88631dafa59$var$currentQueue.concat($ce74d88631dafa59$var$queue);
    else $ce74d88631dafa59$var$queueIndex = -1;
    if ($ce74d88631dafa59$var$queue.length) $ce74d88631dafa59$var$drainQueue();
}
function $ce74d88631dafa59$var$drainQueue() {
    if ($ce74d88631dafa59$var$draining) return;
    var timeout = $ce74d88631dafa59$var$runTimeout($ce74d88631dafa59$var$cleanUpNextTick);
    $ce74d88631dafa59$var$draining = true;
    var len = $ce74d88631dafa59$var$queue.length;
    while(len){
        $ce74d88631dafa59$var$currentQueue = $ce74d88631dafa59$var$queue;
        $ce74d88631dafa59$var$queue = [];
        while(++$ce74d88631dafa59$var$queueIndex < len)if ($ce74d88631dafa59$var$currentQueue) $ce74d88631dafa59$var$currentQueue[$ce74d88631dafa59$var$queueIndex].run();
        $ce74d88631dafa59$var$queueIndex = -1;
        len = $ce74d88631dafa59$var$queue.length;
    }
    $ce74d88631dafa59$var$currentQueue = null;
    $ce74d88631dafa59$var$draining = false;
    $ce74d88631dafa59$var$runClearTimeout(timeout);
}
$ce74d88631dafa59$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $ce74d88631dafa59$var$queue.push(new $ce74d88631dafa59$var$Item(fun, args));
    if ($ce74d88631dafa59$var$queue.length === 1 && !$ce74d88631dafa59$var$draining) $ce74d88631dafa59$var$runTimeout($ce74d88631dafa59$var$drainQueue);
};
// v8 likes predictible objects
function $ce74d88631dafa59$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$ce74d88631dafa59$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$ce74d88631dafa59$var$process.title = "browser";
$ce74d88631dafa59$var$process.browser = true;
$ce74d88631dafa59$var$process.env = {};
$ce74d88631dafa59$var$process.argv = [];
$ce74d88631dafa59$var$process.version = ""; // empty string to avoid regexp issues
$ce74d88631dafa59$var$process.versions = {};
function $ce74d88631dafa59$var$noop() {}
$ce74d88631dafa59$var$process.on = $ce74d88631dafa59$var$noop;
$ce74d88631dafa59$var$process.addListener = $ce74d88631dafa59$var$noop;
$ce74d88631dafa59$var$process.once = $ce74d88631dafa59$var$noop;
$ce74d88631dafa59$var$process.off = $ce74d88631dafa59$var$noop;
$ce74d88631dafa59$var$process.removeListener = $ce74d88631dafa59$var$noop;
$ce74d88631dafa59$var$process.removeAllListeners = $ce74d88631dafa59$var$noop;
$ce74d88631dafa59$var$process.emit = $ce74d88631dafa59$var$noop;
$ce74d88631dafa59$var$process.prependListener = $ce74d88631dafa59$var$noop;
$ce74d88631dafa59$var$process.prependOnceListener = $ce74d88631dafa59$var$noop;
$ce74d88631dafa59$var$process.listeners = function(name) {
    return [];
};
$ce74d88631dafa59$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$ce74d88631dafa59$var$process.cwd = function() {
    return "/";
};
$ce74d88631dafa59$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$ce74d88631dafa59$var$process.umask = function() {
    return 0;
};

});


parcelRequire.register("6eNI9", function(module, exports) {
"use strict";

var $7J5vx = parcelRequire("7J5vx");

var $9L6Pl = parcelRequire("9L6Pl");

var $jUcq5 = parcelRequire("jUcq5");

var $awFtp = parcelRequire("awFtp");
var $48aa9c778a21b54f$var$SPECIES = $jUcq5("species");
module.exports = function(CONSTRUCTOR_NAME) {
    var Constructor = $7J5vx(CONSTRUCTOR_NAME);
    if ($awFtp && Constructor && !Constructor[$48aa9c778a21b54f$var$SPECIES]) $9L6Pl(Constructor, $48aa9c778a21b54f$var$SPECIES, {
        configurable: true,
        get: function() {
            return this;
        }
    });
};

});
parcelRequire.register("9L6Pl", function(module, exports) {

var $8wt5F = parcelRequire("8wt5F");
module.exports = function(target, name, descriptor) {
    return $8wt5F.f(target, name, descriptor);
};

});


parcelRequire.register("cAgU5", function(module, exports) {

var $53bMe = parcelRequire("53bMe");
var $9295f5852f3f417b$var$$TypeError = TypeError;
module.exports = function(it, Prototype) {
    if ($53bMe(Prototype, it)) return it;
    throw $9295f5852f3f417b$var$$TypeError("Incorrect invocation");
};

});

parcelRequire.register("cchD4", function(module, exports) {

var $3CMpt = parcelRequire("3CMpt");

var $kpyQh = parcelRequire("kpyQh");

var $cp3Nc = parcelRequire("cp3Nc");

var $jUcq5 = parcelRequire("jUcq5");
var $8e1447cc6729ca52$var$SPECIES = $jUcq5("species");
// `SpeciesConstructor` abstract operation
// https://tc39.es/ecma262/#sec-speciesconstructor
module.exports = function(O, defaultConstructor) {
    var C = $3CMpt(O).constructor;
    var S;
    return C === undefined || $cp3Nc(S = $3CMpt(C)[$8e1447cc6729ca52$var$SPECIES]) ? defaultConstructor : $kpyQh(S);
};

});
parcelRequire.register("kpyQh", function(module, exports) {

var $HaMz3 = parcelRequire("HaMz3");

var $ieZRC = parcelRequire("ieZRC");
var $edc12b6025a81591$var$$TypeError = TypeError;
// `Assert: IsConstructor(argument) is true`
module.exports = function(argument) {
    if ($HaMz3(argument)) return argument;
    throw $edc12b6025a81591$var$$TypeError($ieZRC(argument) + " is not a constructor");
};

});
parcelRequire.register("HaMz3", function(module, exports) {

var $dqhay = parcelRequire("dqhay");

var $bSIUO = parcelRequire("bSIUO");

var $g0TxJ = parcelRequire("g0TxJ");

var $jv1hF = parcelRequire("jv1hF");

var $7J5vx = parcelRequire("7J5vx");

var $17w8e = parcelRequire("17w8e");
var $081c61680a9c3b0d$var$noop = function() {};
var $081c61680a9c3b0d$var$empty = [];
var $081c61680a9c3b0d$var$construct = $7J5vx("Reflect", "construct");
var $081c61680a9c3b0d$var$constructorRegExp = /^\s*(?:class|function)\b/;
var $081c61680a9c3b0d$var$exec = $dqhay($081c61680a9c3b0d$var$constructorRegExp.exec);
var $081c61680a9c3b0d$var$INCORRECT_TO_STRING = !$081c61680a9c3b0d$var$constructorRegExp.exec($081c61680a9c3b0d$var$noop);
var $081c61680a9c3b0d$var$isConstructorModern = function isConstructor(argument) {
    if (!$g0TxJ(argument)) return false;
    try {
        $081c61680a9c3b0d$var$construct($081c61680a9c3b0d$var$noop, $081c61680a9c3b0d$var$empty, argument);
        return true;
    } catch (error) {
        return false;
    }
};
var $081c61680a9c3b0d$var$isConstructorLegacy = function isConstructor(argument) {
    if (!$g0TxJ(argument)) return false;
    switch($jv1hF(argument)){
        case "AsyncFunction":
        case "GeneratorFunction":
        case "AsyncGeneratorFunction":
            return false;
    }
    try {
        // we can't check .prototype since constructors produced by .bind haven't it
        // `Function#toString` throws on some built-it function in some legacy engines
        // (for example, `DOMQuad` and similar in FF41-)
        return $081c61680a9c3b0d$var$INCORRECT_TO_STRING || !!$081c61680a9c3b0d$var$exec($081c61680a9c3b0d$var$constructorRegExp, $17w8e(argument));
    } catch (error) {
        return true;
    }
};
$081c61680a9c3b0d$var$isConstructorLegacy.sham = true;
// `IsConstructor` abstract operation
// https://tc39.es/ecma262/#sec-isconstructor
module.exports = !$081c61680a9c3b0d$var$construct || $bSIUO(function() {
    var called;
    return $081c61680a9c3b0d$var$isConstructorModern($081c61680a9c3b0d$var$isConstructorModern.call) || !$081c61680a9c3b0d$var$isConstructorModern(Object) || !$081c61680a9c3b0d$var$isConstructorModern(function() {
        called = true;
    }) || called;
}) ? $081c61680a9c3b0d$var$isConstructorLegacy : $081c61680a9c3b0d$var$isConstructorModern;

});
parcelRequire.register("17w8e", function(module, exports) {

var $dqhay = parcelRequire("dqhay");

var $g0TxJ = parcelRequire("g0TxJ");

var $fOCTs = parcelRequire("fOCTs");
var $0d0f5e97379c0bfc$var$functionToString = $dqhay(Function.toString);
// this helper broken in `core-js@3.4.1-3.4.4`, so we can't use `shared` helper
if (!$g0TxJ($fOCTs.inspectSource)) $fOCTs.inspectSource = function(it) {
    return $0d0f5e97379c0bfc$var$functionToString(it);
};
module.exports = $fOCTs.inspectSource;

});




parcelRequire.register("1Y3YL", function(module, exports) {

var $bbWQF = parcelRequire("bbWQF");

var $9ujZx = parcelRequire("9ujZx");

var $jjTxh = parcelRequire("jjTxh");

var $g0TxJ = parcelRequire("g0TxJ");

var $dj4ij = parcelRequire("dj4ij");

var $bSIUO = parcelRequire("bSIUO");

var $cgF7G = parcelRequire("cgF7G");

var $iEWV5 = parcelRequire("iEWV5");

var $ip0m4 = parcelRequire("ip0m4");

var $1dq59 = parcelRequire("1dq59");

var $2t5ah = parcelRequire("2t5ah");

var $9sRxI = parcelRequire("9sRxI");
var $16ee7b376c304893$var$set = $bbWQF.setImmediate;
var $16ee7b376c304893$var$clear = $bbWQF.clearImmediate;
var $16ee7b376c304893$var$process = $bbWQF.process;
var $16ee7b376c304893$var$Dispatch = $bbWQF.Dispatch;
var $16ee7b376c304893$var$Function = $bbWQF.Function;
var $16ee7b376c304893$var$MessageChannel = $bbWQF.MessageChannel;
var $16ee7b376c304893$var$String = $bbWQF.String;
var $16ee7b376c304893$var$counter = 0;
var $16ee7b376c304893$var$queue = {};
var $16ee7b376c304893$var$ONREADYSTATECHANGE = "onreadystatechange";
var $16ee7b376c304893$var$$location, $16ee7b376c304893$var$defer, $16ee7b376c304893$var$channel, $16ee7b376c304893$var$port;
$bSIUO(function() {
    // Deno throws a ReferenceError on `location` access without `--location` flag
    $16ee7b376c304893$var$$location = $bbWQF.location;
});
var $16ee7b376c304893$var$run = function(id) {
    if ($dj4ij($16ee7b376c304893$var$queue, id)) {
        var fn = $16ee7b376c304893$var$queue[id];
        delete $16ee7b376c304893$var$queue[id];
        fn();
    }
};
var $16ee7b376c304893$var$runner = function(id) {
    return function() {
        $16ee7b376c304893$var$run(id);
    };
};
var $16ee7b376c304893$var$eventListener = function(event) {
    $16ee7b376c304893$var$run(event.data);
};
var $16ee7b376c304893$var$globalPostMessageDefer = function(id) {
    // old engines have not location.origin
    $bbWQF.postMessage($16ee7b376c304893$var$String(id), $16ee7b376c304893$var$$location.protocol + "//" + $16ee7b376c304893$var$$location.host);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!$16ee7b376c304893$var$set || !$16ee7b376c304893$var$clear) {
    $16ee7b376c304893$var$set = function setImmediate(handler) {
        $1dq59(arguments.length, 1);
        var fn = $g0TxJ(handler) ? handler : $16ee7b376c304893$var$Function(handler);
        var args = $iEWV5(arguments, 1);
        $16ee7b376c304893$var$queue[++$16ee7b376c304893$var$counter] = function() {
            $9ujZx(fn, undefined, args);
        };
        $16ee7b376c304893$var$defer($16ee7b376c304893$var$counter);
        return $16ee7b376c304893$var$counter;
    };
    $16ee7b376c304893$var$clear = function clearImmediate(id) {
        delete $16ee7b376c304893$var$queue[id];
    };
    // Node.js 0.8-
    if ($9sRxI) $16ee7b376c304893$var$defer = function(id) {
        $16ee7b376c304893$var$process.nextTick($16ee7b376c304893$var$runner(id));
    };
    else if ($16ee7b376c304893$var$Dispatch && $16ee7b376c304893$var$Dispatch.now) $16ee7b376c304893$var$defer = function(id) {
        $16ee7b376c304893$var$Dispatch.now($16ee7b376c304893$var$runner(id));
    };
    else if ($16ee7b376c304893$var$MessageChannel && !$2t5ah) {
        $16ee7b376c304893$var$channel = new $16ee7b376c304893$var$MessageChannel();
        $16ee7b376c304893$var$port = $16ee7b376c304893$var$channel.port2;
        $16ee7b376c304893$var$channel.port1.onmessage = $16ee7b376c304893$var$eventListener;
        $16ee7b376c304893$var$defer = $jjTxh($16ee7b376c304893$var$port.postMessage, $16ee7b376c304893$var$port);
    // Browsers with postMessage, skip WebWorkers
    // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
    } else if ($bbWQF.addEventListener && $g0TxJ($bbWQF.postMessage) && !$bbWQF.importScripts && $16ee7b376c304893$var$$location && $16ee7b376c304893$var$$location.protocol !== "file:" && !$bSIUO($16ee7b376c304893$var$globalPostMessageDefer)) {
        $16ee7b376c304893$var$defer = $16ee7b376c304893$var$globalPostMessageDefer;
        $bbWQF.addEventListener("message", $16ee7b376c304893$var$eventListener, false);
    // IE8-
    } else if ($16ee7b376c304893$var$ONREADYSTATECHANGE in $ip0m4("script")) $16ee7b376c304893$var$defer = function(id) {
        $cgF7G.appendChild($ip0m4("script"))[$16ee7b376c304893$var$ONREADYSTATECHANGE] = function() {
            $cgF7G.removeChild(this);
            $16ee7b376c304893$var$run(id);
        };
    };
    else $16ee7b376c304893$var$defer = function(id) {
        setTimeout($16ee7b376c304893$var$runner(id), 0);
    };
}
module.exports = {
    set: $16ee7b376c304893$var$set,
    clear: $16ee7b376c304893$var$clear
};

});
parcelRequire.register("iEWV5", function(module, exports) {

var $dqhay = parcelRequire("dqhay");
module.exports = $dqhay([].slice);

});

parcelRequire.register("1dq59", function(module, exports) {
var $0e2b3cb36bf91863$var$$TypeError = TypeError;
module.exports = function(passed, required) {
    if (passed < required) throw $0e2b3cb36bf91863$var$$TypeError("Not enough arguments");
    return passed;
};

});

parcelRequire.register("2t5ah", function(module, exports) {

var $d0QM8 = parcelRequire("d0QM8");
// eslint-disable-next-line redos/no-vulnerable -- safe
module.exports = /(?:ipad|iphone|ipod).*applewebkit/i.test($d0QM8);

});


parcelRequire.register("5c0v0", function(module, exports) {

var $bbWQF = parcelRequire("bbWQF");

var $jjTxh = parcelRequire("jjTxh");

var $4cXMl = parcelRequire("4cXMl");
var $3c7e75d66240289f$require$getOwnPropertyDescriptor = $4cXMl.f;

var $1Y3YL = parcelRequire("1Y3YL");
var $3c7e75d66240289f$require$macrotask = $1Y3YL.set;

var $6i6LS = parcelRequire("6i6LS");

var $2t5ah = parcelRequire("2t5ah");

var $803A7 = parcelRequire("803A7");

var $g4NY6 = parcelRequire("g4NY6");

var $9sRxI = parcelRequire("9sRxI");
var $3c7e75d66240289f$var$MutationObserver = $bbWQF.MutationObserver || $bbWQF.WebKitMutationObserver;
var $3c7e75d66240289f$var$document = $bbWQF.document;
var $3c7e75d66240289f$var$process = $bbWQF.process;
var $3c7e75d66240289f$var$Promise = $bbWQF.Promise;
// Node.js 11 shows ExperimentalWarning on getting `queueMicrotask`
var $3c7e75d66240289f$var$queueMicrotaskDescriptor = $3c7e75d66240289f$require$getOwnPropertyDescriptor($bbWQF, "queueMicrotask");
var $3c7e75d66240289f$var$microtask = $3c7e75d66240289f$var$queueMicrotaskDescriptor && $3c7e75d66240289f$var$queueMicrotaskDescriptor.value;
var $3c7e75d66240289f$var$notify, $3c7e75d66240289f$var$toggle, $3c7e75d66240289f$var$node, $3c7e75d66240289f$var$promise, $3c7e75d66240289f$var$then;
// modern engines have queueMicrotask method
if (!$3c7e75d66240289f$var$microtask) {
    var $3c7e75d66240289f$var$queue = new $6i6LS();
    var $3c7e75d66240289f$var$flush = function() {
        var parent, fn;
        if ($9sRxI && (parent = $3c7e75d66240289f$var$process.domain)) parent.exit();
        while(fn = $3c7e75d66240289f$var$queue.get())try {
            fn();
        } catch (error) {
            if ($3c7e75d66240289f$var$queue.head) $3c7e75d66240289f$var$notify();
            throw error;
        }
        if (parent) parent.enter();
    };
    // browsers with MutationObserver, except iOS - https://github.com/zloirock/core-js/issues/339
    // also except WebOS Webkit https://github.com/zloirock/core-js/issues/898
    if (!$2t5ah && !$9sRxI && !$g4NY6 && $3c7e75d66240289f$var$MutationObserver && $3c7e75d66240289f$var$document) {
        $3c7e75d66240289f$var$toggle = true;
        $3c7e75d66240289f$var$node = $3c7e75d66240289f$var$document.createTextNode("");
        new $3c7e75d66240289f$var$MutationObserver($3c7e75d66240289f$var$flush).observe($3c7e75d66240289f$var$node, {
            characterData: true
        });
        $3c7e75d66240289f$var$notify = function() {
            $3c7e75d66240289f$var$node.data = $3c7e75d66240289f$var$toggle = !$3c7e75d66240289f$var$toggle;
        };
    // environments with maybe non-completely correct, but existent Promise
    } else if (!$803A7 && $3c7e75d66240289f$var$Promise && $3c7e75d66240289f$var$Promise.resolve) {
        // Promise.resolve without an argument throws an error in LG WebOS 2
        $3c7e75d66240289f$var$promise = $3c7e75d66240289f$var$Promise.resolve(undefined);
        // workaround of WebKit ~ iOS Safari 10.1 bug
        $3c7e75d66240289f$var$promise.constructor = $3c7e75d66240289f$var$Promise;
        $3c7e75d66240289f$var$then = $jjTxh($3c7e75d66240289f$var$promise.then, $3c7e75d66240289f$var$promise);
        $3c7e75d66240289f$var$notify = function() {
            $3c7e75d66240289f$var$then($3c7e75d66240289f$var$flush);
        };
    // Node.js without promises
    } else if ($9sRxI) $3c7e75d66240289f$var$notify = function() {
        $3c7e75d66240289f$var$process.nextTick($3c7e75d66240289f$var$flush);
    };
    else {
        // `webpack` dev server bug on IE global methods - use bind(fn, global)
        $3c7e75d66240289f$require$macrotask = $jjTxh($3c7e75d66240289f$require$macrotask, $bbWQF);
        $3c7e75d66240289f$var$notify = function() {
            $3c7e75d66240289f$require$macrotask($3c7e75d66240289f$var$flush);
        };
    }
    $3c7e75d66240289f$var$microtask = function(fn) {
        if (!$3c7e75d66240289f$var$queue.head) $3c7e75d66240289f$var$notify();
        $3c7e75d66240289f$var$queue.add(fn);
    };
}
module.exports = $3c7e75d66240289f$var$microtask;

});
parcelRequire.register("6i6LS", function(module, exports) {
var $4949ad21c7408579$var$Queue = function() {
    this.head = null;
    this.tail = null;
};
$4949ad21c7408579$var$Queue.prototype = {
    add: function(item) {
        var entry = {
            item: item,
            next: null
        };
        var tail = this.tail;
        if (tail) tail.next = entry;
        else this.head = entry;
        this.tail = entry;
    },
    get: function() {
        var entry = this.head;
        if (entry) {
            var next = this.head = entry.next;
            if (next === null) this.tail = null;
            return entry.item;
        }
    }
};
module.exports = $4949ad21c7408579$var$Queue;

});

parcelRequire.register("803A7", function(module, exports) {

var $d0QM8 = parcelRequire("d0QM8");
module.exports = /ipad|iphone|ipod/i.test($d0QM8) && typeof Pebble != "undefined";

});

parcelRequire.register("g4NY6", function(module, exports) {

var $d0QM8 = parcelRequire("d0QM8");
module.exports = /web0s(?!.*chrome)/i.test($d0QM8);

});


parcelRequire.register("4H38s", function(module, exports) {
module.exports = function(a, b) {
    try {
        // eslint-disable-next-line no-console -- safe
        arguments.length == 1 ? console.error(a) : console.error(a, b);
    } catch (error) {}
};

});

parcelRequire.register("hFxjr", function(module, exports) {
module.exports = function(exec) {
    try {
        return {
            error: false,
            value: exec()
        };
    } catch (error) {
        return {
            error: true,
            value: error
        };
    }
};

});

parcelRequire.register("7Xg1f", function(module, exports) {

var $bbWQF = parcelRequire("bbWQF");
module.exports = $bbWQF.Promise;

});

parcelRequire.register("8hl4h", function(module, exports) {

var $bbWQF = parcelRequire("bbWQF");

var $7Xg1f = parcelRequire("7Xg1f");

var $g0TxJ = parcelRequire("g0TxJ");

var $hz0Pa = parcelRequire("hz0Pa");

var $17w8e = parcelRequire("17w8e");

var $jUcq5 = parcelRequire("jUcq5");

var $1lR5O = parcelRequire("1lR5O");

var $2lIT9 = parcelRequire("2lIT9");

var $bRYhZ = parcelRequire("bRYhZ");

var $aPgVB = parcelRequire("aPgVB");
var $607040f05f5551cf$var$NativePromisePrototype = $7Xg1f && $7Xg1f.prototype;
var $607040f05f5551cf$var$SPECIES = $jUcq5("species");
var $607040f05f5551cf$var$SUBCLASSING = false;
var $607040f05f5551cf$var$NATIVE_PROMISE_REJECTION_EVENT = $g0TxJ($bbWQF.PromiseRejectionEvent);
var $607040f05f5551cf$var$FORCED_PROMISE_CONSTRUCTOR = $hz0Pa("Promise", function() {
    var PROMISE_CONSTRUCTOR_SOURCE = $17w8e($7Xg1f);
    var GLOBAL_CORE_JS_PROMISE = PROMISE_CONSTRUCTOR_SOURCE !== String($7Xg1f);
    // V8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
    // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
    // We can't detect it synchronously, so just check versions
    if (!GLOBAL_CORE_JS_PROMISE && $aPgVB === 66) return true;
    // We need Promise#{ catch, finally } in the pure version for preventing prototype pollution
    if ($bRYhZ && !($607040f05f5551cf$var$NativePromisePrototype["catch"] && $607040f05f5551cf$var$NativePromisePrototype["finally"])) return true;
    // We can't use @@species feature detection in V8 since it causes
    // deoptimization and performance degradation
    // https://github.com/zloirock/core-js/issues/679
    if (!$aPgVB || $aPgVB < 51 || !/native code/.test(PROMISE_CONSTRUCTOR_SOURCE)) {
        // Detect correctness of subclassing with @@species support
        var promise = new $7Xg1f(function(resolve) {
            resolve(1);
        });
        var FakePromise = function(exec) {
            exec(function() {}, function() {});
        };
        var constructor = promise.constructor = {};
        constructor[$607040f05f5551cf$var$SPECIES] = FakePromise;
        $607040f05f5551cf$var$SUBCLASSING = promise.then(function() {}) instanceof FakePromise;
        if (!$607040f05f5551cf$var$SUBCLASSING) return true;
    // Unhandled rejections tracking support, NodeJS Promise without it fails @@species test
    }
    return !GLOBAL_CORE_JS_PROMISE && ($1lR5O || $2lIT9) && !$607040f05f5551cf$var$NATIVE_PROMISE_REJECTION_EVENT;
});
module.exports = {
    CONSTRUCTOR: $607040f05f5551cf$var$FORCED_PROMISE_CONSTRUCTOR,
    REJECTION_EVENT: $607040f05f5551cf$var$NATIVE_PROMISE_REJECTION_EVENT,
    SUBCLASSING: $607040f05f5551cf$var$SUBCLASSING
};

});
parcelRequire.register("1lR5O", function(module, exports) {

var $2lIT9 = parcelRequire("2lIT9");

var $9sRxI = parcelRequire("9sRxI");
module.exports = !$2lIT9 && !$9sRxI && typeof window == "object" && typeof document == "object";

});
parcelRequire.register("2lIT9", function(module, exports) {
/* global Deno -- Deno case */ module.exports = typeof Deno == "object" && Deno && typeof Deno.version == "object";

});



parcelRequire.register("h4XGr", function(module, exports) {

$parcel$export(module.exports, "f", () => $c6f11b455b733bd0$export$2d1720544b23b823, (v) => $c6f11b455b733bd0$export$2d1720544b23b823 = v);
// `NewPromiseCapability` abstract operation
// https://tc39.es/ecma262/#sec-newpromisecapability
var $c6f11b455b733bd0$export$2d1720544b23b823;
"use strict";

var $f9Leu = parcelRequire("f9Leu");
var $c6f11b455b733bd0$var$$TypeError = TypeError;
var $c6f11b455b733bd0$var$PromiseCapability = function(C) {
    var resolve, reject;
    this.promise = new C(function($$resolve, $$reject) {
        if (resolve !== undefined || reject !== undefined) throw $c6f11b455b733bd0$var$$TypeError("Bad Promise constructor");
        resolve = $$resolve;
        reject = $$reject;
    });
    this.resolve = $f9Leu(resolve);
    this.reject = $f9Leu(reject);
};
$c6f11b455b733bd0$export$2d1720544b23b823 = function(C) {
    return new $c6f11b455b733bd0$var$PromiseCapability(C);
};

});


parcelRequire.register("aOeGS", function(module, exports) {
"use strict";

var $2iwSV = parcelRequire("2iwSV");

var $boD6Z = parcelRequire("boD6Z");

var $f9Leu = parcelRequire("f9Leu");

var $h4XGr = parcelRequire("h4XGr");

var $hFxjr = parcelRequire("hFxjr");

var $gCDer = parcelRequire("gCDer");

var $9kJSk = parcelRequire("9kJSk");
// `Promise.all` method
// https://tc39.es/ecma262/#sec-promise.all
$2iwSV({
    target: "Promise",
    stat: true,
    forced: $9kJSk
}, {
    all: function all(iterable) {
        var C = this;
        var capability = $h4XGr.f(C);
        var resolve = capability.resolve;
        var reject = capability.reject;
        var result = $hFxjr(function() {
            var $promiseResolve = $f9Leu(C.resolve);
            var values = [];
            var counter = 0;
            var remaining = 1;
            $gCDer(iterable, function(promise) {
                var index = counter++;
                var alreadyCalled = false;
                remaining++;
                $boD6Z($promiseResolve, C, promise).then(function(value) {
                    if (alreadyCalled) return;
                    alreadyCalled = true;
                    values[index] = value;
                    --remaining || resolve(values);
                }, reject);
            });
            --remaining || resolve(values);
        });
        if (result.error) reject(result.value);
        return capability.promise;
    }
});

});
parcelRequire.register("9kJSk", function(module, exports) {

var $7Xg1f = parcelRequire("7Xg1f");

var $78PmU = parcelRequire("78PmU");

var $8hl4h = parcelRequire("8hl4h");
var $6cb9912a85c7d79f$require$FORCED_PROMISE_CONSTRUCTOR = $8hl4h.CONSTRUCTOR;
module.exports = $6cb9912a85c7d79f$require$FORCED_PROMISE_CONSTRUCTOR || !$78PmU(function(iterable) {
    $7Xg1f.all(iterable).then(undefined, function() {});
});

});
parcelRequire.register("78PmU", function(module, exports) {

var $jUcq5 = parcelRequire("jUcq5");
var $5331207294cd88c2$var$ITERATOR = $jUcq5("iterator");
var $5331207294cd88c2$var$SAFE_CLOSING = false;
try {
    var $5331207294cd88c2$var$called = 0;
    var $5331207294cd88c2$var$iteratorWithReturn = {
        next: function() {
            return {
                done: !!$5331207294cd88c2$var$called++
            };
        },
        "return": function() {
            $5331207294cd88c2$var$SAFE_CLOSING = true;
        }
    };
    $5331207294cd88c2$var$iteratorWithReturn[$5331207294cd88c2$var$ITERATOR] = function() {
        return this;
    };
    // eslint-disable-next-line es/no-array-from, no-throw-literal -- required for testing
    Array.from($5331207294cd88c2$var$iteratorWithReturn, function() {
        throw 2;
    });
} catch (error) {}
module.exports = function(exec, SKIP_CLOSING) {
    if (!SKIP_CLOSING && !$5331207294cd88c2$var$SAFE_CLOSING) return false;
    var ITERATION_SUPPORT = false;
    try {
        var object = {};
        object[$5331207294cd88c2$var$ITERATOR] = function() {
            return {
                next: function() {
                    return {
                        done: ITERATION_SUPPORT = true
                    };
                }
            };
        };
        exec(object);
    } catch (error) {}
    return ITERATION_SUPPORT;
};

});



parcelRequire.register("b2wwM", function(module, exports) {
"use strict";

var $2iwSV = parcelRequire("2iwSV");

var $bRYhZ = parcelRequire("bRYhZ");

var $8hl4h = parcelRequire("8hl4h");
var $80991cf67a10a897$require$FORCED_PROMISE_CONSTRUCTOR = $8hl4h.CONSTRUCTOR;

var $7Xg1f = parcelRequire("7Xg1f");

var $7J5vx = parcelRequire("7J5vx");

var $g0TxJ = parcelRequire("g0TxJ");

var $hY10v = parcelRequire("hY10v");
var $80991cf67a10a897$var$NativePromisePrototype = $7Xg1f && $7Xg1f.prototype;
// `Promise.prototype.catch` method
// https://tc39.es/ecma262/#sec-promise.prototype.catch
$2iwSV({
    target: "Promise",
    proto: true,
    forced: $80991cf67a10a897$require$FORCED_PROMISE_CONSTRUCTOR,
    real: true
}, {
    "catch": function(onRejected) {
        return this.then(undefined, onRejected);
    }
});
// makes sure that native promise-based APIs `Promise#catch` properly works with patched `Promise#then`
if (!$bRYhZ && $g0TxJ($7Xg1f)) {
    var $80991cf67a10a897$var$method = $7J5vx("Promise").prototype["catch"];
    if ($80991cf67a10a897$var$NativePromisePrototype["catch"] !== $80991cf67a10a897$var$method) $hY10v($80991cf67a10a897$var$NativePromisePrototype, "catch", $80991cf67a10a897$var$method, {
        unsafe: true
    });
}

});

parcelRequire.register("2e23o", function(module, exports) {
"use strict";

var $2iwSV = parcelRequire("2iwSV");

var $boD6Z = parcelRequire("boD6Z");

var $f9Leu = parcelRequire("f9Leu");

var $h4XGr = parcelRequire("h4XGr");

var $hFxjr = parcelRequire("hFxjr");

var $gCDer = parcelRequire("gCDer");

var $9kJSk = parcelRequire("9kJSk");
// `Promise.race` method
// https://tc39.es/ecma262/#sec-promise.race
$2iwSV({
    target: "Promise",
    stat: true,
    forced: $9kJSk
}, {
    race: function race(iterable) {
        var C = this;
        var capability = $h4XGr.f(C);
        var reject = capability.reject;
        var result = $hFxjr(function() {
            var $promiseResolve = $f9Leu(C.resolve);
            $gCDer(iterable, function(promise) {
                $boD6Z($promiseResolve, C, promise).then(capability.resolve, reject);
            });
        });
        if (result.error) reject(result.value);
        return capability.promise;
    }
});

});

parcelRequire.register("5Oqis", function(module, exports) {
"use strict";

var $2iwSV = parcelRequire("2iwSV");

var $boD6Z = parcelRequire("boD6Z");

var $h4XGr = parcelRequire("h4XGr");

var $8hl4h = parcelRequire("8hl4h");
var $43b6053893e1f15b$require$FORCED_PROMISE_CONSTRUCTOR = $8hl4h.CONSTRUCTOR;
// `Promise.reject` method
// https://tc39.es/ecma262/#sec-promise.reject
$2iwSV({
    target: "Promise",
    stat: true,
    forced: $43b6053893e1f15b$require$FORCED_PROMISE_CONSTRUCTOR
}, {
    reject: function reject(r) {
        var capability = $h4XGr.f(this);
        $boD6Z(capability.reject, undefined, r);
        return capability.promise;
    }
});

});

parcelRequire.register("fhrRC", function(module, exports) {
"use strict";

var $2iwSV = parcelRequire("2iwSV");

var $7J5vx = parcelRequire("7J5vx");

var $bRYhZ = parcelRequire("bRYhZ");

var $7Xg1f = parcelRequire("7Xg1f");

var $8hl4h = parcelRequire("8hl4h");
var $b1fe0eb827f10932$require$FORCED_PROMISE_CONSTRUCTOR = $8hl4h.CONSTRUCTOR;

var $lSUiR = parcelRequire("lSUiR");
var $b1fe0eb827f10932$var$PromiseConstructorWrapper = $7J5vx("Promise");
var $b1fe0eb827f10932$var$CHECK_WRAPPER = $bRYhZ && !$b1fe0eb827f10932$require$FORCED_PROMISE_CONSTRUCTOR;
// `Promise.resolve` method
// https://tc39.es/ecma262/#sec-promise.resolve
$2iwSV({
    target: "Promise",
    stat: true,
    forced: $bRYhZ || $b1fe0eb827f10932$require$FORCED_PROMISE_CONSTRUCTOR
}, {
    resolve: function resolve(x) {
        return $lSUiR($b1fe0eb827f10932$var$CHECK_WRAPPER && this === $b1fe0eb827f10932$var$PromiseConstructorWrapper ? $7Xg1f : this, x);
    }
});

});
parcelRequire.register("lSUiR", function(module, exports) {

var $3CMpt = parcelRequire("3CMpt");

var $2IxWL = parcelRequire("2IxWL");

var $h4XGr = parcelRequire("h4XGr");
module.exports = function(C, x) {
    $3CMpt(C);
    if ($2IxWL(x) && x.constructor === C) return x;
    var promiseCapability = $h4XGr.f(C);
    var resolve = promiseCapability.resolve;
    resolve(x);
    return promiseCapability.promise;
};

});



parcelRequire.register("1qg05", function(module, exports) {
"use strict";

var $2iwSV = parcelRequire("2iwSV");

var $boD6Z = parcelRequire("boD6Z");

var $f9Leu = parcelRequire("f9Leu");

var $h4XGr = parcelRequire("h4XGr");

var $hFxjr = parcelRequire("hFxjr");

var $gCDer = parcelRequire("gCDer");

var $9kJSk = parcelRequire("9kJSk");
// `Promise.allSettled` method
// https://tc39.es/ecma262/#sec-promise.allsettled
$2iwSV({
    target: "Promise",
    stat: true,
    forced: $9kJSk
}, {
    allSettled: function allSettled(iterable) {
        var C = this;
        var capability = $h4XGr.f(C);
        var resolve = capability.resolve;
        var reject = capability.reject;
        var result = $hFxjr(function() {
            var promiseResolve = $f9Leu(C.resolve);
            var values = [];
            var counter = 0;
            var remaining = 1;
            $gCDer(iterable, function(promise) {
                var index = counter++;
                var alreadyCalled = false;
                remaining++;
                $boD6Z(promiseResolve, C, promise).then(function(value) {
                    if (alreadyCalled) return;
                    alreadyCalled = true;
                    values[index] = {
                        status: "fulfilled",
                        value: value
                    };
                    --remaining || resolve(values);
                }, function(error) {
                    if (alreadyCalled) return;
                    alreadyCalled = true;
                    values[index] = {
                        status: "rejected",
                        reason: error
                    };
                    --remaining || resolve(values);
                });
            });
            --remaining || resolve(values);
        });
        if (result.error) reject(result.value);
        return capability.promise;
    }
});

});

parcelRequire.register("dUrYj", function(module, exports) {
"use strict";

var $2iwSV = parcelRequire("2iwSV");

var $boD6Z = parcelRequire("boD6Z");

var $f9Leu = parcelRequire("f9Leu");

var $7J5vx = parcelRequire("7J5vx");

var $h4XGr = parcelRequire("h4XGr");

var $hFxjr = parcelRequire("hFxjr");

var $gCDer = parcelRequire("gCDer");

var $9kJSk = parcelRequire("9kJSk");
var $a20633efe11ab8c5$var$PROMISE_ANY_ERROR = "No one promise resolved";
// `Promise.any` method
// https://tc39.es/ecma262/#sec-promise.any
$2iwSV({
    target: "Promise",
    stat: true,
    forced: $9kJSk
}, {
    any: function any(iterable) {
        var C = this;
        var AggregateError = $7J5vx("AggregateError");
        var capability = $h4XGr.f(C);
        var resolve = capability.resolve;
        var reject = capability.reject;
        var result = $hFxjr(function() {
            var promiseResolve = $f9Leu(C.resolve);
            var errors = [];
            var counter = 0;
            var remaining = 1;
            var alreadyResolved = false;
            $gCDer(iterable, function(promise) {
                var index = counter++;
                var alreadyRejected = false;
                remaining++;
                $boD6Z(promiseResolve, C, promise).then(function(value) {
                    if (alreadyRejected || alreadyResolved) return;
                    alreadyResolved = true;
                    resolve(value);
                }, function(error) {
                    if (alreadyRejected || alreadyResolved) return;
                    alreadyRejected = true;
                    errors[index] = error;
                    --remaining || reject(new AggregateError(errors, $a20633efe11ab8c5$var$PROMISE_ANY_ERROR));
                });
            });
            --remaining || reject(new AggregateError(errors, $a20633efe11ab8c5$var$PROMISE_ANY_ERROR));
        });
        if (result.error) reject(result.value);
        return capability.promise;
    }
});

});

parcelRequire.register("34eo6", function(module, exports) {
"use strict";

var $2iwSV = parcelRequire("2iwSV");

var $bRYhZ = parcelRequire("bRYhZ");

var $7Xg1f = parcelRequire("7Xg1f");

var $bSIUO = parcelRequire("bSIUO");

var $7J5vx = parcelRequire("7J5vx");

var $g0TxJ = parcelRequire("g0TxJ");

var $cchD4 = parcelRequire("cchD4");

var $lSUiR = parcelRequire("lSUiR");

var $hY10v = parcelRequire("hY10v");
var $23bce7e7467abfc1$var$NativePromisePrototype = $7Xg1f && $7Xg1f.prototype;
// Safari bug https://bugs.webkit.org/show_bug.cgi?id=200829
var $23bce7e7467abfc1$var$NON_GENERIC = !!$7Xg1f && $bSIUO(function() {
    // eslint-disable-next-line unicorn/no-thenable -- required for testing
    $23bce7e7467abfc1$var$NativePromisePrototype["finally"].call({
        then: function() {}
    }, function() {});
});
// `Promise.prototype.finally` method
// https://tc39.es/ecma262/#sec-promise.prototype.finally
$2iwSV({
    target: "Promise",
    proto: true,
    real: true,
    forced: $23bce7e7467abfc1$var$NON_GENERIC
}, {
    "finally": function(onFinally) {
        var C = $cchD4(this, $7J5vx("Promise"));
        var isFunction = $g0TxJ(onFinally);
        return this.then(isFunction ? function(x) {
            return $lSUiR(C, onFinally()).then(function() {
                return x;
            });
        } : onFinally, isFunction ? function(e) {
            return $lSUiR(C, onFinally()).then(function() {
                throw e;
            });
        } : onFinally);
    }
});
// makes sure that native promise-based APIs `Promise#finally` properly works with patched `Promise#then`
if (!$bRYhZ && $g0TxJ($7Xg1f)) {
    var $23bce7e7467abfc1$var$method = $7J5vx("Promise").prototype["finally"];
    if ($23bce7e7467abfc1$var$NativePromisePrototype["finally"] !== $23bce7e7467abfc1$var$method) $hY10v($23bce7e7467abfc1$var$NativePromisePrototype, "finally", $23bce7e7467abfc1$var$method, {
        unsafe: true
    });
}

});

parcelRequire.register("vGpAn", function(module, exports) {
"use strict";

var $ax5ui = parcelRequire("ax5ui");
var $05f3cb709e77b4ad$require$charAt = $ax5ui.charAt;

var $elG1Y = parcelRequire("elG1Y");

var $cDGcw = parcelRequire("cDGcw");

var $17u0H = parcelRequire("17u0H");

var $9xi7m = parcelRequire("9xi7m");
var $05f3cb709e77b4ad$var$STRING_ITERATOR = "String Iterator";
var $05f3cb709e77b4ad$var$setInternalState = $cDGcw.set;
var $05f3cb709e77b4ad$var$getInternalState = $cDGcw.getterFor($05f3cb709e77b4ad$var$STRING_ITERATOR);
// `String.prototype[@@iterator]` method
// https://tc39.es/ecma262/#sec-string.prototype-@@iterator
$17u0H(String, "String", function(iterated) {
    $05f3cb709e77b4ad$var$setInternalState(this, {
        type: $05f3cb709e77b4ad$var$STRING_ITERATOR,
        string: $elG1Y(iterated),
        index: 0
    });
// `%StringIteratorPrototype%.next` method
// https://tc39.es/ecma262/#sec-%stringiteratorprototype%.next
}, function next() {
    var state = $05f3cb709e77b4ad$var$getInternalState(this);
    var string = state.string;
    var index = state.index;
    var point;
    if (index >= string.length) return $9xi7m(undefined, true);
    point = $05f3cb709e77b4ad$require$charAt(string, index);
    state.index += point.length;
    return $9xi7m(point, false);
});

});
parcelRequire.register("ax5ui", function(module, exports) {

var $dqhay = parcelRequire("dqhay");

var $cazda = parcelRequire("cazda");

var $elG1Y = parcelRequire("elG1Y");

var $2Oek2 = parcelRequire("2Oek2");
var $7ab13e2b4a592839$var$charAt = $dqhay("".charAt);
var $7ab13e2b4a592839$var$charCodeAt = $dqhay("".charCodeAt);
var $7ab13e2b4a592839$var$stringSlice = $dqhay("".slice);
var $7ab13e2b4a592839$var$createMethod = function(CONVERT_TO_STRING) {
    return function($this, pos) {
        var S = $elG1Y($2Oek2($this));
        var position = $cazda(pos);
        var size = S.length;
        var first, second;
        if (position < 0 || position >= size) return CONVERT_TO_STRING ? "" : undefined;
        first = $7ab13e2b4a592839$var$charCodeAt(S, position);
        return first < 0xD800 || first > 0xDBFF || position + 1 === size || (second = $7ab13e2b4a592839$var$charCodeAt(S, position + 1)) < 0xDC00 || second > 0xDFFF ? CONVERT_TO_STRING ? $7ab13e2b4a592839$var$charAt(S, position) : first : CONVERT_TO_STRING ? $7ab13e2b4a592839$var$stringSlice(S, position, position + 2) : (first - 0xD800 << 10) + (second - 0xDC00) + 0x10000;
    };
};
module.exports = {
    // `String.prototype.codePointAt` method
    // https://tc39.es/ecma262/#sec-string.prototype.codepointat
    codeAt: $7ab13e2b4a592839$var$createMethod(false),
    // `String.prototype.at` method
    // https://github.com/mathiasbynens/String.prototype.at
    charAt: $7ab13e2b4a592839$var$createMethod(true)
};

});



parcelRequire.register("a8ZHm", function(module, exports) {
parcelRequire("7V1Sz");

var $aWo01 = parcelRequire("aWo01");

var $bbWQF = parcelRequire("bbWQF");

var $jv1hF = parcelRequire("jv1hF");

var $b77ug = parcelRequire("b77ug");

var $f1Wuv = parcelRequire("f1Wuv");

var $jUcq5 = parcelRequire("jUcq5");
var $762a82c21194eb08$var$TO_STRING_TAG = $jUcq5("toStringTag");
for(var $762a82c21194eb08$var$COLLECTION_NAME in $aWo01){
    var $762a82c21194eb08$var$Collection = $bbWQF[$762a82c21194eb08$var$COLLECTION_NAME];
    var $762a82c21194eb08$var$CollectionPrototype = $762a82c21194eb08$var$Collection && $762a82c21194eb08$var$Collection.prototype;
    if ($762a82c21194eb08$var$CollectionPrototype && $jv1hF($762a82c21194eb08$var$CollectionPrototype) !== $762a82c21194eb08$var$TO_STRING_TAG) $b77ug($762a82c21194eb08$var$CollectionPrototype, $762a82c21194eb08$var$TO_STRING_TAG, $762a82c21194eb08$var$COLLECTION_NAME);
    $f1Wuv[$762a82c21194eb08$var$COLLECTION_NAME] = $f1Wuv.Array;
}

});
parcelRequire.register("aWo01", function(module, exports) {
// iterable DOM collections
// flag - `iterable` interface - 'entries', 'keys', 'values', 'forEach' methods
module.exports = {
    CSSRuleList: 0,
    CSSStyleDeclaration: 0,
    CSSValueList: 0,
    ClientRectList: 0,
    DOMRectList: 0,
    DOMStringList: 0,
    DOMTokenList: 1,
    DataTransferItemList: 0,
    FileList: 0,
    HTMLAllCollection: 0,
    HTMLCollection: 0,
    HTMLFormElement: 0,
    HTMLSelectElement: 0,
    MediaList: 0,
    MimeTypeArray: 0,
    NamedNodeMap: 0,
    NodeList: 1,
    PaintRequestList: 0,
    Plugin: 0,
    PluginArray: 0,
    SVGLengthList: 0,
    SVGNumberList: 0,
    SVGPathSegList: 0,
    SVGPointList: 0,
    SVGStringList: 0,
    SVGTransformList: 0,
    SourceBufferList: 0,
    StyleSheetList: 0,
    TextTrackCueList: 0,
    TextTrackList: 0,
    TouchList: 0
};

});







parcelRequire.register("8dbkx", function(module, exports) {
"use strict";


var $8usDI = parcelRequire("8usDI");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = $5fa8538ff42014e3$var$connectionStatusUpdateSaga;

var $5fa8538ff42014e3$var$_regenerator = $8usDI((parcelRequire("7MKKk")));
parcelRequire("6Nc1h");
var $7McF6 = parcelRequire("7McF6");

var $5fa8538ff42014e3$var$_connectionStatusUpdate = $8usDI((parcelRequire("iFJVn")));

var $5fa8538ff42014e3$var$_observeEach = $8usDI((parcelRequire("dfAvB")));

var $5fa8538ff42014e3$var$_setReferenceGrammarID = $8usDI((parcelRequire("i318c")));

var $5fa8538ff42014e3$var$_whileConnected = $8usDI((parcelRequire("6qcDb")));
var $5fa8538ff42014e3$var$_marked = /*#__PURE__*/ (parcelRequire("7MKKk")).mark($5fa8538ff42014e3$var$observeConnectionStatus), $5fa8538ff42014e3$var$_marked2 = /*#__PURE__*/ (parcelRequire("7MKKk")).mark($5fa8538ff42014e3$var$connectionStatusUpdateSaga);
function $5fa8538ff42014e3$var$observeConnectionStatus(_ref) {
    var directLine;
    return $5fa8538ff42014e3$var$_regenerator["default"].wrap(function observeConnectionStatus$(_context2) {
        while(true)switch(_context2.prev = _context2.next){
            case 0:
                directLine = _ref.directLine;
                _context2.next = 3;
                return (0, $5fa8538ff42014e3$var$_observeEach["default"])(directLine.connectionStatus$, /*#__PURE__*/ $5fa8538ff42014e3$var$_regenerator["default"].mark(function updateConnectionStatus(connectionStatus) {
                    return $5fa8538ff42014e3$var$_regenerator["default"].wrap(function updateConnectionStatus$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                _context.next = 2;
                                return (0, $7McF6.Y)((0, $5fa8538ff42014e3$var$_connectionStatusUpdate["default"])(connectionStatus));
                            case 2:
                                _context.next = 4;
                                return (0, $7McF6.Y)((0, $5fa8538ff42014e3$var$_setReferenceGrammarID["default"])(directLine.referenceGrammarId));
                            case 4:
                            case "end":
                                return _context.stop();
                        }
                    }, updateConnectionStatus);
                }));
            case 3:
            case "end":
                return _context2.stop();
        }
    }, $5fa8538ff42014e3$var$_marked);
}
function $5fa8538ff42014e3$var$connectionStatusUpdateSaga() {
    return $5fa8538ff42014e3$var$_regenerator["default"].wrap(function connectionStatusUpdateSaga$(_context3) {
        while(true)switch(_context3.prev = _context3.next){
            case 0:
                _context3.next = 2;
                return (0, $5fa8538ff42014e3$var$_whileConnected["default"])($5fa8538ff42014e3$var$observeConnectionStatus);
            case 2:
            case "end":
                return _context3.stop();
        }
    }, $5fa8538ff42014e3$var$_marked2);
}

});
parcelRequire.register("dfAvB", function(module, exports) {
"use strict";

var $8usDI = parcelRequire("8usDI");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = $9a58fef0892cef48$var$observeEachEffect;

var $9a58fef0892cef48$var$_regenerator = $8usDI((parcelRequire("7MKKk")));
parcelRequire("6Nc1h");
var $7McF6 = parcelRequire("7McF6");

var $9a58fef0892cef48$var$_createPromiseQueue = $8usDI((parcelRequire("jZhmM")));
function $9a58fef0892cef48$var$observeEachEffect(observable, saga) {
    return (0, $7McF6.N)(/*#__PURE__*/ $9a58fef0892cef48$var$_regenerator["default"].mark(function observeEach() {
        var queue, subscription, result;
        return $9a58fef0892cef48$var$_regenerator["default"].wrap(function observeEach$(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    queue = (0, $9a58fef0892cef48$var$_createPromiseQueue["default"])();
                    subscription = observable.subscribe({
                        next: queue.push
                    });
                    _context.prev = 2;
                case 3:
                    _context.next = 5;
                    return (0, $7McF6.N)(queue.shift);
                case 5:
                    result = _context.sent;
                    _context.next = 8;
                    return (0, $7McF6.N)(saga, result);
                case 8:
                    _context.next = 3;
                    break;
                case 10:
                    _context.prev = 10;
                    subscription.unsubscribe();
                    return _context.finish(10);
                case 13:
                case "end":
                    return _context.stop();
            }
        }, observeEach, null, [
            [
                2,
                ,
                10,
                13
            ]
        ]);
    }));
}

});


parcelRequire.register("ekmqx", function(module, exports) {
"use strict";

var $8usDI = parcelRequire("8usDI");

var $UAGsq = parcelRequire("UAGsq");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = $a6e4547e16bc5fcc$var$_callee;

var $a6e4547e16bc5fcc$var$_regenerator = $8usDI((parcelRequire("7MKKk")));
parcelRequire("6Nc1h");
var $7McF6 = parcelRequire("7McF6");

var $a6e4547e16bc5fcc$var$_jwtDecode = $8usDI((parcelRequire("jWtCV")));

var $dd04G = parcelRequire("dd04G");

var $a6e4547e16bc5fcc$var$_createPromiseQueue = $8usDI((parcelRequire("jZhmM")));

var $a6e4547e16bc5fcc$var$_forkPut = $8usDI((parcelRequire("ihEfk")));

var $a6e4547e16bc5fcc$var$_uniqueID = $8usDI((parcelRequire("cvpfA")));

var $a6e4547e16bc5fcc$var$_updateConnectionStatus = $a6e4547e16bc5fcc$var$_interopRequireWildcard((parcelRequire("feZCd")));

var $arcsH = parcelRequire("arcsH");

var $hbk3x = parcelRequire("hbk3x");
function $a6e4547e16bc5fcc$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($a6e4547e16bc5fcc$var$_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $a6e4547e16bc5fcc$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || $UAGsq(obj) !== "object" && typeof obj !== "function") return {
        "default": obj
    };
    var cache = $a6e4547e16bc5fcc$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj["default"] = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
var $a6e4547e16bc5fcc$var$_marked = /*#__PURE__*/ $a6e4547e16bc5fcc$var$_regenerator["default"].mark($a6e4547e16bc5fcc$var$observeAndPutConnectionStatusUpdate), $a6e4547e16bc5fcc$var$_marked2 = /*#__PURE__*/ $a6e4547e16bc5fcc$var$_regenerator["default"].mark($a6e4547e16bc5fcc$var$connectSaga), $a6e4547e16bc5fcc$var$_marked3 = /*#__PURE__*/ $a6e4547e16bc5fcc$var$_regenerator["default"].mark($a6e4547e16bc5fcc$var$reconnectSaga), $a6e4547e16bc5fcc$var$_marked4 = /*#__PURE__*/ $a6e4547e16bc5fcc$var$_regenerator["default"].mark($a6e4547e16bc5fcc$var$runAsyncEffect), $a6e4547e16bc5fcc$var$_marked5 = /*#__PURE__*/ $a6e4547e16bc5fcc$var$_regenerator["default"].mark($a6e4547e16bc5fcc$var$takeDisconnectAsError), $a6e4547e16bc5fcc$var$_marked6 = /*#__PURE__*/ $a6e4547e16bc5fcc$var$_regenerator["default"].mark($a6e4547e16bc5fcc$var$_callee);
var $a6e4547e16bc5fcc$var$CONNECTING = 1;
var $a6e4547e16bc5fcc$var$ONLINE = 2;
var $a6e4547e16bc5fcc$var$UNINITIALIZED = 0;
function $a6e4547e16bc5fcc$var$randomUserID() {
    return "r_".concat((0, $a6e4547e16bc5fcc$var$_uniqueID["default"])().substring(0, 10));
}
function $a6e4547e16bc5fcc$var$observeAndPutConnectionStatusUpdate(directLine) {
    var connectionStatusQueue, connectionStatusSubscription, connectionStatus;
    return $a6e4547e16bc5fcc$var$_regenerator["default"].wrap(function observeAndPutConnectionStatusUpdate$(_context) {
        while(true)switch(_context.prev = _context.next){
            case 0:
                connectionStatusQueue = (0, $a6e4547e16bc5fcc$var$_createPromiseQueue["default"])();
                connectionStatusSubscription = directLine.connectionStatus$.subscribe({
                    next: connectionStatusQueue.push
                });
                _context.prev = 2;
            case 3:
                _context.next = 5;
                return (0, $7McF6.N)(connectionStatusQueue.shift);
            case 5:
                connectionStatus = _context.sent;
                _context.next = 8;
                return (0, $7McF6.Y)((0, $a6e4547e16bc5fcc$var$_updateConnectionStatus["default"])(connectionStatus));
            case 8:
                _context.next = 3;
                break;
            case 10:
                _context.prev = 10;
                connectionStatusSubscription.unsubscribe();
                return _context.finish(10);
            case 13:
            case "end":
                return _context.stop();
        }
    }, $a6e4547e16bc5fcc$var$_marked, null, [
        [
            2,
            ,
            10,
            13
        ]
    ]);
} // TODO: [P2] We should move this check and rectification to DirectLineJS.
function $a6e4547e16bc5fcc$var$rectifyUserID(directLine, userIDFromAction) {
    var token = directLine.token;
    var userIDFromToken; // TODO: Add test to make sure "jwt-decode" work as expected.
    try {
        userIDFromToken = ((0, $a6e4547e16bc5fcc$var$_jwtDecode["default"])(token) || {}).user; // eslint-disable-next-line no-empty
    } catch (err) {}
    var result = {
        fromAction: userIDFromAction,
        fromToken: userIDFromToken
    };
    if (userIDFromToken) {
        if (userIDFromAction && userIDFromAction !== userIDFromToken) console.warn("Web Chat: user ID is both specified in the Direct Line token and passed in, will use the user ID from the token.");
        result["final"] = userIDFromToken;
    } else if (userIDFromAction) {
        if (typeof userIDFromAction !== "string") {
            console.warn("Web Chat: user ID must be a string.");
            result["final"] = $a6e4547e16bc5fcc$var$randomUserID();
        } else if (/^dl_/.test(userIDFromAction)) {
            console.warn('Web Chat: user ID prefixed with "dl_" is reserved and must be embedded into the Direct Line token to prevent forgery.');
            result["final"] = $a6e4547e16bc5fcc$var$randomUserID();
        } else result["final"] = userIDFromAction;
    } else result["final"] = $a6e4547e16bc5fcc$var$randomUserID();
    return result;
} // We could make this a Promise instead of saga (function generator) to make the code cleaner, if:
// 1. We found a way to cancel Promise
// 2. subscribe() are shared amongst all subscriptions, e.g. turn Observable into events
function $a6e4547e16bc5fcc$var$connectSaga(directLine) {
    var activitySubscription, unsubscribeActivity, _yield$take, connectionStatus;
    return $a6e4547e16bc5fcc$var$_regenerator["default"].wrap(function connectSaga$(_context2) {
        while(true)switch(_context2.prev = _context2.next){
            case 0:
                // DirectLineJS starts the connection only after the first subscriber for activity$, not connectionStatus$
                activitySubscription = directLine.activity$.subscribe({
                    next: function next() {
                        return 0;
                    }
                });
                unsubscribeActivity = activitySubscription.unsubscribe.bind(activitySubscription);
                _context2.prev = 2;
            case 3:
                _context2.next = 5;
                return (0, $7McF6.K)($a6e4547e16bc5fcc$var$_updateConnectionStatus.UPDATE_CONNECTION_STATUS);
            case 5:
                _yield$take = _context2.sent;
                connectionStatus = _yield$take.payload.connectionStatus;
                if (!(connectionStatus === $a6e4547e16bc5fcc$var$ONLINE)) {
                    _context2.next = 11;
                    break;
                }
                return _context2.abrupt("return", function() {
                    unsubscribeActivity();
                    directLine.end();
                });
            case 11:
                if (!(connectionStatus !== $a6e4547e16bc5fcc$var$UNINITIALIZED && connectionStatus !== $a6e4547e16bc5fcc$var$CONNECTING)) {
                    _context2.next = 13;
                    break;
                }
                throw new Error("Failed to connect, DirectLineJS returned ".concat(connectionStatus, "."));
            case 13:
                _context2.next = 3;
                break;
            case 15:
                _context2.next = 21;
                break;
            case 17:
                _context2.prev = 17;
                _context2.t0 = _context2["catch"](2);
                // We will unsubscribe if we failed to connect or got cancelled only.
                // We should not unsubscribe in happy case, because DirectLineJS should relying on the subscription to connect/disconnect.
                unsubscribeActivity();
                throw _context2.t0;
            case 21:
                _context2.prev = 21;
                _context2.next = 24;
                return (0, $7McF6.a4)();
            case 24:
                if (!_context2.sent) {
                    _context2.next = 26;
                    break;
                }
                unsubscribeActivity();
            case 26:
                return _context2.finish(21);
            case 27:
            case "end":
                return _context2.stop();
        }
    }, $a6e4547e16bc5fcc$var$_marked2, null, [
        [
            2,
            17,
            21,
            27
        ]
    ]);
}
function $a6e4547e16bc5fcc$var$reconnectSaga() {
    var _yield$take2, connectionStatus;
    return $a6e4547e16bc5fcc$var$_regenerator["default"].wrap(function reconnectSaga$(_context3) {
        while(true)switch(_context3.prev = _context3.next){
            case 0:
                _context3.next = 2;
                return (0, $7McF6.K)($a6e4547e16bc5fcc$var$_updateConnectionStatus.UPDATE_CONNECTION_STATUS);
            case 2:
                _yield$take2 = _context3.sent;
                connectionStatus = _yield$take2.payload.connectionStatus;
                if (!(connectionStatus === $a6e4547e16bc5fcc$var$ONLINE)) {
                    _context3.next = 8;
                    break;
                }
                return _context3.abrupt("break", 12);
            case 8:
                if (!(connectionStatus !== $a6e4547e16bc5fcc$var$CONNECTING)) {
                    _context3.next = 10;
                    break;
                }
                throw new Error("Failed to reconnect. DirectLineJS returned ".concat(connectionStatus, "."));
            case 10:
                _context3.next = 0;
                break;
            case 12:
            case "end":
                return _context3.stop();
        }
    }, $a6e4547e16bc5fcc$var$_marked3);
} // This is similar to behavior of redux-promise-middleware, but using saga instead of Promise.
// We guarantee PENDING -> FULFILLING -> FULFILLED, or PENDING -> REJECTED. This will help us simplify logic in other part of code.
// Note that after the saga is cancelled, subsequent call to put() will be ignored silently.
function $a6e4547e16bc5fcc$var$runAsyncEffect(_ref, callEffectFactory) {
    var type, meta, payload, result;
    return $a6e4547e16bc5fcc$var$_regenerator["default"].wrap(function runAsyncEffect$(_context4) {
        while(true)switch(_context4.prev = _context4.next){
            case 0:
                type = _ref.type, meta = _ref.meta, payload = _ref.payload;
                _context4.prev = 1;
                _context4.next = 4;
                return (0, $a6e4547e16bc5fcc$var$_forkPut["default"])({
                    type: "".concat(type, "_PENDING"),
                    meta: meta,
                    payload: payload
                });
            case 4:
                _context4.next = 6;
                return callEffectFactory();
            case 6:
                result = _context4.sent;
                _context4.next = 9;
                return (0, $a6e4547e16bc5fcc$var$_forkPut["default"])({
                    type: "".concat(type, "_FULFILLING"),
                    meta: meta,
                    payload: payload
                }, {
                    type: "".concat(type, "_FULFILLED"),
                    meta: meta,
                    payload: payload
                });
            case 9:
                return _context4.abrupt("return", result);
            case 12:
                _context4.prev = 12;
                _context4.t0 = _context4["catch"](1);
                _context4.next = 16;
                return (0, $a6e4547e16bc5fcc$var$_forkPut["default"])({
                    type: "".concat(type, "_REJECTED"),
                    error: true,
                    meta: meta,
                    payload: _context4.t0
                });
            case 16:
                throw _context4.t0;
            case 17:
            case "end":
                return _context4.stop();
        }
    }, $a6e4547e16bc5fcc$var$_marked4, null, [
        [
            1,
            12
        ]
    ]);
}
function $a6e4547e16bc5fcc$var$takeDisconnectAsError() {
    return $a6e4547e16bc5fcc$var$_regenerator["default"].wrap(function takeDisconnectAsError$(_context5) {
        while(true)switch(_context5.prev = _context5.next){
            case 0:
                _context5.next = 2;
                return (0, $7McF6.K)($arcsH.DISCONNECT);
            case 2:
                throw new Error("disconnected");
            case 3:
            case "end":
                return _context5.stop();
        }
    }, $a6e4547e16bc5fcc$var$_marked5);
}
function $a6e4547e16bc5fcc$var$runAsyncEffectUntilDisconnect(baseAction, callEffectFactory) {
    // We cannot use saga cancel() here, because cancelling saga will prohibit us from sending *_REJECTED.
    // Without REJECTED, it impacts our assumptions around PENDING/FULFILLED/REJECTED.
    return $a6e4547e16bc5fcc$var$runAsyncEffect(baseAction, /*#__PURE__*/ $a6e4547e16bc5fcc$var$_regenerator["default"].mark(function runUntilDisconnect() {
        var _yield$race, result;
        return $a6e4547e16bc5fcc$var$_regenerator["default"].wrap(function runUntilDisconnect$(_context6) {
            while(true)switch(_context6.prev = _context6.next){
                case 0:
                    _context6.next = 2;
                    return (0, $7McF6.V)({
                        _: $a6e4547e16bc5fcc$var$takeDisconnectAsError(),
                        result: callEffectFactory()
                    });
                case 2:
                    _yield$race = _context6.sent;
                    result = _yield$race.result;
                    return _context6.abrupt("return", result);
                case 5:
                case "end":
                    return _context6.stop();
            }
        }, runUntilDisconnect);
    }));
}
function $a6e4547e16bc5fcc$var$_callee() {
    var _loop;
    return $a6e4547e16bc5fcc$var$_regenerator["default"].wrap(function _callee$(_context8) {
        while(true)switch(_context8.prev = _context8.next){
            case 0:
                _loop = /*#__PURE__*/ $a6e4547e16bc5fcc$var$_regenerator["default"].mark(function _loop() {
                    var _yield$take3, _yield$take3$payload, directLine, userIDFromAction, username, updateConnectionStatusTask, rectifiedUserID, meta, disconnectMeta, endDirectLine, _yield$race2, _yield$race2$updateCo, _yield$race2$updateCo2, connectionStatus;
                    return $a6e4547e16bc5fcc$var$_regenerator["default"].wrap(function _loop$(_context7) {
                        while(true)switch(_context7.prev = _context7.next){
                            case 0:
                                _context7.next = 2;
                                return (0, $7McF6.K)($dd04G.CONNECT);
                            case 2:
                                _yield$take3 = _context7.sent;
                                _yield$take3$payload = _yield$take3.payload;
                                directLine = _yield$take3$payload.directLine;
                                userIDFromAction = _yield$take3$payload.userID;
                                username = _yield$take3$payload.username;
                                _context7.next = 9;
                                return (0, $7McF6.L)($a6e4547e16bc5fcc$var$observeAndPutConnectionStatusUpdate, directLine);
                            case 9:
                                updateConnectionStatusTask = _context7.sent;
                                rectifiedUserID = $a6e4547e16bc5fcc$var$rectifyUserID(directLine, userIDFromAction); // TODO: [P2] Checks if this attached subtask will get killed if the parent task is complete (peacefully), errored out, or cancelled.
                                meta = {
                                    userID: rectifiedUserID["final"],
                                    username: username
                                }; // Send user ID to DirectLineJS if it was specified from props of <API.Composer>.
                                // However, DirectLineJS may still prefer the user ID from token if it is burnt into the token.
                                // To prevent DirectLineJS giving false warnings, we will only call setUserId() if it is different than the token.
                                directLine.setUserId && rectifiedUserID.fromToken !== meta.userID && directLine.setUserId(meta.userID);
                                disconnectMeta = void 0; // We will dispatch CONNECT_PENDING, wait for connect completed, errored, or cancelled (thru disconnect).
                                // Then dispatch CONNECT_FULFILLED/CONNECT_REJECTED as needed.
                                _context7.prev = 14;
                                _context7.next = 17;
                                return $a6e4547e16bc5fcc$var$runAsyncEffectUntilDisconnect({
                                    type: $dd04G.CONNECT,
                                    meta: meta,
                                    payload: {
                                        directLine: directLine
                                    }
                                }, function() {
                                    return (0, $7McF6.N)($a6e4547e16bc5fcc$var$connectSaga, directLine);
                                });
                            case 17:
                                endDirectLine = _context7.sent;
                                _context7.prev = 18;
                            case 19:
                                _context7.next = 21;
                                return (0, $7McF6.V)({
                                    _: (0, $7McF6.K)($arcsH.DISCONNECT),
                                    updateConnectionStatusAction: (0, $7McF6.K)($a6e4547e16bc5fcc$var$_updateConnectionStatus.UPDATE_CONNECTION_STATUS)
                                });
                            case 21:
                                _yield$race2 = _context7.sent;
                                _yield$race2$updateCo = _yield$race2.updateConnectionStatusAction;
                                _yield$race2$updateCo = _yield$race2$updateCo === void 0 ? {} : _yield$race2$updateCo;
                                _yield$race2$updateCo2 = _yield$race2$updateCo.payload;
                                _yield$race2$updateCo2 = _yield$race2$updateCo2 === void 0 ? {} : _yield$race2$updateCo2;
                                connectionStatus = _yield$race2$updateCo2.connectionStatus; // If it is not disconnect action, connectionStatus will not be undefined.
                                if (!(connectionStatus === $a6e4547e16bc5fcc$var$CONNECTING)) {
                                    _context7.next = 32;
                                    break;
                                }
                                _context7.next = 30;
                                return $a6e4547e16bc5fcc$var$runAsyncEffectUntilDisconnect({
                                    type: $hbk3x.RECONNECT,
                                    meta: meta,
                                    payload: {
                                        directLine: directLine
                                    }
                                }, function() {
                                    return (0, $7McF6.N)($a6e4547e16bc5fcc$var$reconnectSaga);
                                });
                            case 30:
                                _context7.next = 38;
                                break;
                            case 32:
                                if (!(connectionStatus !== $a6e4547e16bc5fcc$var$ONLINE)) {
                                    _context7.next = 38;
                                    break;
                                }
                                if (!(typeof connectionStatus !== "undefined")) {
                                    _context7.next = 37;
                                    break;
                                }
                                throw new Error("Connection status changed to ".concat(connectionStatus));
                            case 37:
                                return _context7.abrupt("break", 40);
                            case 38:
                                _context7.next = 19;
                                break;
                            case 40:
                                _context7.prev = 40;
                                endDirectLine();
                                return _context7.finish(40);
                            case 43:
                                _context7.next = 48;
                                break;
                            case 45:
                                _context7.prev = 45;
                                _context7.t0 = _context7["catch"](14);
                                disconnectMeta = {
                                    error: _context7.t0
                                };
                            case 48:
                                _context7.prev = 48;
                                _context7.next = 51;
                                return (0, $7McF6.M)(updateConnectionStatusTask);
                            case 51:
                                _context7.next = 53;
                                return (0, $a6e4547e16bc5fcc$var$_forkPut["default"])({
                                    type: $arcsH.DISCONNECT_PENDING,
                                    meta: disconnectMeta,
                                    payload: {
                                        directLine: directLine
                                    }
                                }, {
                                    type: $arcsH.DISCONNECT_FULFILLED,
                                    meta: disconnectMeta,
                                    payload: {
                                        directLine: directLine
                                    }
                                });
                            case 53:
                                return _context7.finish(48);
                            case 54:
                            case "end":
                                return _context7.stop();
                        }
                    }, _loop, null, [
                        [
                            14,
                            45,
                            48,
                            54
                        ],
                        [
                            18,
                            ,
                            40,
                            43
                        ]
                    ]);
                });
            case 1:
                return _context8.delegateYield(_loop(), "t0", 2);
            case 2:
                _context8.next = 1;
                break;
            case 4:
            case "end":
                return _context8.stop();
        }
    }, $a6e4547e16bc5fcc$var$_marked6);
}

});
parcelRequire.register("jWtCV", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "InvalidTokenError", () => $e84a6a60681b79b7$export$b9721ef022f71a68);
$parcel$export(module.exports, "default", () => $e84a6a60681b79b7$export$2e2bcd8739ae039);
function $e84a6a60681b79b7$var$e(e) {
    this.message = e;
}
$e84a6a60681b79b7$var$e.prototype = new Error, $e84a6a60681b79b7$var$e.prototype.name = "InvalidCharacterError";
var $e84a6a60681b79b7$var$r = "undefined" != typeof window && window.atob && window.atob.bind(window) || function(r) {
    var t = String(r).replace(/=+$/, "");
    if (t.length % 4 == 1) throw new $e84a6a60681b79b7$var$e("'atob' failed: The string to be decoded is not correctly encoded.");
    for(var n, o, a = 0, i = 0, c = ""; o = t.charAt(i++); ~o && (n = a % 4 ? 64 * n + o : o, a++ % 4) && (c += String.fromCharCode(255 & n >> (-2 * a & 6))))o = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=".indexOf(o);
    return c;
};
function $e84a6a60681b79b7$var$t(e) {
    var t = e.replace(/-/g, "+").replace(/_/g, "/");
    switch(t.length % 4){
        case 0:
            break;
        case 2:
            t += "==";
            break;
        case 3:
            t += "=";
            break;
        default:
            throw "Illegal base64url string!";
    }
    try {
        return function(e) {
            return decodeURIComponent($e84a6a60681b79b7$var$r(e).replace(/(.)/g, function(e, r) {
                var t = r.charCodeAt(0).toString(16).toUpperCase();
                return t.length < 2 && (t = "0" + t), "%" + t;
            }));
        }(t);
    } catch (e) {
        return $e84a6a60681b79b7$var$r(t);
    }
}
function $e84a6a60681b79b7$export$b9721ef022f71a68(e) {
    this.message = e;
}
function $e84a6a60681b79b7$var$o(e, r) {
    if ("string" != typeof e) throw new $e84a6a60681b79b7$export$b9721ef022f71a68("Invalid token specified");
    var o = !0 === (r = r || {}).header ? 0 : 1;
    try {
        return JSON.parse($e84a6a60681b79b7$var$t(e.split(".")[o]));
    } catch (e) {
        throw new $e84a6a60681b79b7$export$b9721ef022f71a68("Invalid token specified: " + e.message);
    }
}
$e84a6a60681b79b7$export$b9721ef022f71a68.prototype = new Error, $e84a6a60681b79b7$export$b9721ef022f71a68.prototype.name = "InvalidTokenError";
var $e84a6a60681b79b7$export$2e2bcd8739ae039 = $e84a6a60681b79b7$var$o;

});

parcelRequire.register("ihEfk", function(module, exports) {
"use strict";

var $8usDI = parcelRequire("8usDI");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = $d4f90891cab49ce3$var$forkPutEffect;

var $d4f90891cab49ce3$var$_regenerator = $8usDI((parcelRequire("7MKKk")));
parcelRequire("6Nc1h");
var $7McF6 = parcelRequire("7McF6");
function $d4f90891cab49ce3$var$_createForOfIteratorHelper(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (!it) {
        if (Array.isArray(o) || (it = $d4f90891cab49ce3$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
            if (it) o = it;
            var i = 0;
            var F = function F() {};
            return {
                s: F,
                n: function n() {
                    if (i >= o.length) return {
                        done: true
                    };
                    return {
                        done: false,
                        value: o[i++]
                    };
                },
                e: function e(_e) {
                    throw _e;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var normalCompletion = true, didErr = false, err;
    return {
        s: function s() {
            it = it.call(o);
        },
        n: function n() {
            var step = it.next();
            normalCompletion = step.done;
            return step;
        },
        e: function e(_e2) {
            didErr = true;
            err = _e2;
        },
        f: function f() {
            try {
                if (!normalCompletion && it["return"] != null) it["return"]();
            } finally{
                if (didErr) throw err;
            }
        }
    };
}
function $d4f90891cab49ce3$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $d4f90891cab49ce3$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $d4f90891cab49ce3$var$_arrayLikeToArray(o, minLen);
}
function $d4f90891cab49ce3$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
// In redux-saga, if we call the following effects in order, we might miss the take('C').
// 1. take('A')
// 2. put({ type: 'B' })
// 3. take('C')
// We need to modify step 2 to:
// 2. fork(function* () { yield put({ type: 'B' }) })
// This is a helper function for this purpose.
function $d4f90891cab49ce3$var$forkPutEffect() {
    for(var _len = arguments.length, actions = new Array(_len), _key = 0; _key < _len; _key++)actions[_key] = arguments[_key];
    return (0, $7McF6.L)(/*#__PURE__*/ $d4f90891cab49ce3$var$_regenerator["default"].mark(function forkPut() {
        var _iterator, _step, action;
        return $d4f90891cab49ce3$var$_regenerator["default"].wrap(function forkPut$(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    _iterator = $d4f90891cab49ce3$var$_createForOfIteratorHelper(actions);
                    _context.prev = 1;
                    _iterator.s();
                case 3:
                    if ((_step = _iterator.n()).done) {
                        _context.next = 9;
                        break;
                    }
                    action = _step.value;
                    _context.next = 7;
                    return (0, $7McF6.Y)(action);
                case 7:
                    _context.next = 3;
                    break;
                case 9:
                    _context.next = 14;
                    break;
                case 11:
                    _context.prev = 11;
                    _context.t0 = _context["catch"](1);
                    _iterator.e(_context.t0);
                case 14:
                    _context.prev = 14;
                    _iterator.f();
                    return _context.finish(14);
                case 17:
                case "end":
                    return _context.stop();
            }
        }, forkPut, null, [
            [
                1,
                11,
                14,
                17
            ]
        ]);
    }));
}

});

parcelRequire.register("feZCd", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.UPDATE_CONNECTION_STATUS = void 0;
module.exports["default"] = $b187f554c6c0e3df$var$updateConnectionStatus;
var $b187f554c6c0e3df$var$UPDATE_CONNECTION_STATUS = "DIRECT_LINE/UPDATE_CONNECTION_STATUS";
module.exports.UPDATE_CONNECTION_STATUS = $b187f554c6c0e3df$var$UPDATE_CONNECTION_STATUS;
function $b187f554c6c0e3df$var$updateConnectionStatus(connectionStatus) {
    return {
        type: $b187f554c6c0e3df$var$UPDATE_CONNECTION_STATUS,
        payload: {
            connectionStatus: connectionStatus
        }
    };
}

});


parcelRequire.register("e2Nqh", function(module, exports) {
"use strict";

var $8usDI = parcelRequire("8usDI");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = $a39796f6471d3319$var$detectSlowConnectionSaga;

var $a39796f6471d3319$var$_regenerator = $8usDI((parcelRequire("7MKKk")));
parcelRequire("6Nc1h");
var $7McF6 = parcelRequire("7McF6");

var $dd04G = parcelRequire("dd04G");

var $hbk3x = parcelRequire("hbk3x");

var $a39796f6471d3319$var$_sleep = $8usDI((parcelRequire("2nXdi")));
var $a39796f6471d3319$var$_marked = /*#__PURE__*/ $a39796f6471d3319$var$_regenerator["default"].mark($a39796f6471d3319$var$detectSlowConnectionSaga);
var $a39796f6471d3319$var$SLOW_CONNECTION_AFTER = 15000;
function $a39796f6471d3319$var$detectSlowConnectionSaga(ponyfill) {
    var connectivityRace;
    return $a39796f6471d3319$var$_regenerator["default"].wrap(function detectSlowConnectionSaga$(_context) {
        while(true)switch(_context.prev = _context.next){
            case 0:
                _context.next = 2;
                return (0, $7McF6.K)([
                    $dd04G.CONNECT_PENDING,
                    $hbk3x.RECONNECT_PENDING
                ]);
            case 2:
                _context.next = 4;
                return (0, $7McF6.V)({
                    fulfilled: (0, $7McF6.K)([
                        $dd04G.CONNECT_FULFILLED,
                        $hbk3x.RECONNECT_FULFILLED
                    ]),
                    rejected: (0, $7McF6.K)([
                        $dd04G.CONNECT_REJECTED,
                        $hbk3x.RECONNECT_REJECTED
                    ]),
                    slow: (0, $7McF6.N)($a39796f6471d3319$var$_sleep["default"], $a39796f6471d3319$var$SLOW_CONNECTION_AFTER, ponyfill)
                });
            case 4:
                connectivityRace = _context.sent;
                if (!("slow" in connectivityRace)) {
                    _context.next = 8;
                    break;
                }
                _context.next = 8;
                return (0, $7McF6.Y)({
                    type: $dd04G.CONNECT_STILL_PENDING
                });
            case 8:
                _context.next = 0;
                break;
            case 10:
            case "end":
                return _context.stop();
        }
    }, $a39796f6471d3319$var$_marked);
}

});
parcelRequire.register("2nXdi", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = $1bcba950a65a3f64$var$sleep;
function $1bcba950a65a3f64$var$sleep(interval, ponyfill) {
    return new Promise(function(resolve) {
        return ponyfill.setTimeout(resolve, Math.max(interval, 0));
    });
}

});


parcelRequire.register("9g9Uw", function(module, exports) {
"use strict";

var $8usDI = parcelRequire("8usDI");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = $6bdd4bbf5303f130$var$emitTypingActivityToPostActivitySaga;

var $6bdd4bbf5303f130$var$_regenerator = $8usDI((parcelRequire("7MKKk")));
parcelRequire("6Nc1h");
var $7McF6 = parcelRequire("7McF6");
var $7PPVh = parcelRequire("7PPVh");

var $4I2lF = parcelRequire("4I2lF");

var $6bdd4bbf5303f130$var$_postActivity = $8usDI((parcelRequire("lnNkF")));

var $6bdd4bbf5303f130$var$_whileConnected = $8usDI((parcelRequire("6qcDb")));
var $6bdd4bbf5303f130$var$_marked = /*#__PURE__*/ $6bdd4bbf5303f130$var$_regenerator["default"].mark($6bdd4bbf5303f130$var$postTypingActivity), $6bdd4bbf5303f130$var$_marked2 = /*#__PURE__*/ $6bdd4bbf5303f130$var$_regenerator["default"].mark($6bdd4bbf5303f130$var$emitTypingActivityToPostActivity), $6bdd4bbf5303f130$var$_marked3 = /*#__PURE__*/ $6bdd4bbf5303f130$var$_regenerator["default"].mark($6bdd4bbf5303f130$var$emitTypingActivityToPostActivitySaga);
function $6bdd4bbf5303f130$var$postTypingActivity() {
    return $6bdd4bbf5303f130$var$_regenerator["default"].wrap(function postTypingActivity$(_context) {
        while(true)switch(_context.prev = _context.next){
            case 0:
                _context.next = 2;
                return (0, $7McF6.Y)((0, $6bdd4bbf5303f130$var$_postActivity["default"])({
                    type: "typing"
                }));
            case 2:
            case "end":
                return _context.stop();
        }
    }, $6bdd4bbf5303f130$var$_marked);
}
function $6bdd4bbf5303f130$var$emitTypingActivityToPostActivity() {
    return $6bdd4bbf5303f130$var$_regenerator["default"].wrap(function emitTypingActivityToPostActivity$(_context2) {
        while(true)switch(_context2.prev = _context2.next){
            case 0:
                _context2.next = 2;
                return (0, $7PPVh.takeEvery)(function(_ref) {
                    var type = _ref.type;
                    return type === $4I2lF.EMIT_TYPING_INDICATOR;
                }, $6bdd4bbf5303f130$var$postTypingActivity);
            case 2:
            case "end":
                return _context2.stop();
        }
    }, $6bdd4bbf5303f130$var$_marked2);
}
function $6bdd4bbf5303f130$var$emitTypingActivityToPostActivitySaga() {
    return $6bdd4bbf5303f130$var$_regenerator["default"].wrap(function emitTypingActivityToPostActivitySaga$(_context3) {
        while(true)switch(_context3.prev = _context3.next){
            case 0:
                _context3.next = 2;
                return (0, $6bdd4bbf5303f130$var$_whileConnected["default"])($6bdd4bbf5303f130$var$emitTypingActivityToPostActivity);
            case 2:
            case "end":
                return _context3.stop();
        }
    }, $6bdd4bbf5303f130$var$_marked3);
}

});
parcelRequire.register("4I2lF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.EMIT_TYPING_INDICATOR = void 0;
module.exports["default"] = $36dd17d1b9dea710$var$emitTypingIndicator;
var $36dd17d1b9dea710$var$EMIT_TYPING_INDICATOR = "WEB_CHAT/EMIT_TYPING_INDICATOR";
module.exports.EMIT_TYPING_INDICATOR = $36dd17d1b9dea710$var$EMIT_TYPING_INDICATOR;
function $36dd17d1b9dea710$var$emitTypingIndicator() {
    return {
        type: $36dd17d1b9dea710$var$EMIT_TYPING_INDICATOR
    };
}

});


parcelRequire.register("8uD3A", function(module, exports) {
"use strict";


var $8usDI = parcelRequire("8usDI");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = $62ef6bf58bf3be91$var$markAllAsSpokenOnStopSpeakActivitySaga;

var $62ef6bf58bf3be91$var$_regenerator = $8usDI((parcelRequire("7MKKk")));
parcelRequire("6Nc1h");
var $7McF6 = parcelRequire("7McF6");
var $7PPVh = parcelRequire("7PPVh");

var $ltJDo = parcelRequire("ltJDo");

var $cbRU8 = parcelRequire("cbRU8");

var $62ef6bf58bf3be91$var$_markActivity = $8usDI((parcelRequire("ciuoj")));

var $62ef6bf58bf3be91$var$_speakingActivity = $8usDI((parcelRequire("5yi6J")));
var $62ef6bf58bf3be91$var$_marked = /*#__PURE__*/ (parcelRequire("7MKKk")).mark($62ef6bf58bf3be91$var$markAllAsSpoken), $62ef6bf58bf3be91$var$_marked2 = /*#__PURE__*/ (parcelRequire("7MKKk")).mark($62ef6bf58bf3be91$var$markAllAsSpokenOnStopSpeakActivitySaga);
function $62ef6bf58bf3be91$var$_createForOfIteratorHelper(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (!it) {
        if (Array.isArray(o) || (it = $62ef6bf58bf3be91$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
            if (it) o = it;
            var i = 0;
            var F = function F() {};
            return {
                s: F,
                n: function n() {
                    if (i >= o.length) return {
                        done: true
                    };
                    return {
                        done: false,
                        value: o[i++]
                    };
                },
                e: function e(_e) {
                    throw _e;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var normalCompletion = true, didErr = false, err;
    return {
        s: function s() {
            it = it.call(o);
        },
        n: function n() {
            var step = it.next();
            normalCompletion = step.done;
            return step;
        },
        e: function e(_e2) {
            didErr = true;
            err = _e2;
        },
        f: function f() {
            try {
                if (!normalCompletion && it["return"] != null) it["return"]();
            } finally{
                if (didErr) throw err;
            }
        }
    };
}
function $62ef6bf58bf3be91$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $62ef6bf58bf3be91$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $62ef6bf58bf3be91$var$_arrayLikeToArray(o, minLen);
}
function $62ef6bf58bf3be91$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $62ef6bf58bf3be91$var$markAllAsSpoken() {
    var speakingActivities, _iterator, _step, activity;
    return $62ef6bf58bf3be91$var$_regenerator["default"].wrap(function markAllAsSpoken$(_context) {
        while(true)switch(_context.prev = _context.next){
            case 0:
                _context.next = 2;
                return (0, $7McF6.a3)((0, $ltJDo.of)($62ef6bf58bf3be91$var$_speakingActivity["default"]));
            case 2:
                speakingActivities = _context.sent;
                _iterator = $62ef6bf58bf3be91$var$_createForOfIteratorHelper(speakingActivities);
                _context.prev = 4;
                _iterator.s();
            case 6:
                if ((_step = _iterator.n()).done) {
                    _context.next = 12;
                    break;
                }
                activity = _step.value;
                _context.next = 10;
                return (0, $7McF6.Y)((0, $62ef6bf58bf3be91$var$_markActivity["default"])(activity, "speak", false));
            case 10:
                _context.next = 6;
                break;
            case 12:
                _context.next = 17;
                break;
            case 14:
                _context.prev = 14;
                _context.t0 = _context["catch"](4);
                _iterator.e(_context.t0);
            case 17:
                _context.prev = 17;
                _iterator.f();
                return _context.finish(17);
            case 20:
            case "end":
                return _context.stop();
        }
    }, $62ef6bf58bf3be91$var$_marked, null, [
        [
            4,
            14,
            17,
            20
        ]
    ]);
} // TODO: [P4] We should turn this into a reducer instead
function $62ef6bf58bf3be91$var$markAllAsSpokenOnStopSpeakActivitySaga() {
    return $62ef6bf58bf3be91$var$_regenerator["default"].wrap(function markAllAsSpokenOnStopSpeakActivitySaga$(_context2) {
        while(true)switch(_context2.prev = _context2.next){
            case 0:
                _context2.next = 2;
                return (0, $7PPVh.takeEvery)($cbRU8.STOP_SPEAKING_ACTIVITY, $62ef6bf58bf3be91$var$markAllAsSpoken);
            case 2:
            case "end":
                return _context2.stop();
        }
    }, $62ef6bf58bf3be91$var$_marked2);
}

});
parcelRequire.register("ltJDo", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ofType = module.exports.ofID = module.exports.of = module.exports["default"] = void 0;
var $fa2fb47686e76a5e$var$activities = function activities(_ref) {
    var activities = _ref.activities;
    return activities;
};
var $fa2fb47686e76a5e$var$of = function of(predicate) {
    return function(state) {
        return $fa2fb47686e76a5e$var$activities(state).filter(predicate);
    };
};
module.exports.of = $fa2fb47686e76a5e$var$of;
var $fa2fb47686e76a5e$var$ofID = function ofID(targetID) {
    return $fa2fb47686e76a5e$var$of(function(_ref2) {
        var id = _ref2.id;
        return id === targetID;
    });
};
module.exports.ofID = $fa2fb47686e76a5e$var$ofID;
var $fa2fb47686e76a5e$var$ofType = function ofType(targetType) {
    return $fa2fb47686e76a5e$var$of(function(_ref3) {
        var type = _ref3.type;
        return type === targetType;
    });
};
module.exports.ofType = $fa2fb47686e76a5e$var$ofType;
var $fa2fb47686e76a5e$var$_default = $fa2fb47686e76a5e$var$activities;
module.exports["default"] = $fa2fb47686e76a5e$var$_default;

});

parcelRequire.register("5yi6J", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = $40ae2c89d898585b$var$speakingActivity;
// If true, the activity is in the queue and needs to be spoken.
function $40ae2c89d898585b$var$speakingActivity(activity) {
    var _activity$channelData;
    return (_activity$channelData = activity.channelData) === null || _activity$channelData === void 0 ? void 0 : _activity$channelData.speak;
}

});


parcelRequire.register("keU8q", function(module, exports) {
"use strict";


var $8usDI = parcelRequire("8usDI");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = $ebc0a8a90c9ca591$var$observeActivitySaga;

var $ebc0a8a90c9ca591$var$_regenerator = $8usDI((parcelRequire("7MKKk")));
parcelRequire("6Nc1h");
var $7McF6 = parcelRequire("7McF6");

var $ebc0a8a90c9ca591$var$_simpleUpdateIn = $8usDI((parcelRequire("7qq3H")));

var $ebc0a8a90c9ca591$var$_observeEach = $8usDI((parcelRequire("dfAvB")));

var $ebc0a8a90c9ca591$var$_queueIncomingActivity = $8usDI((parcelRequire("6ugJG")));

var $ebc0a8a90c9ca591$var$_whileConnected = $8usDI((parcelRequire("6qcDb")));
var $ebc0a8a90c9ca591$var$_marked = /*#__PURE__*/ (parcelRequire("7MKKk")).mark($ebc0a8a90c9ca591$var$observeActivity), $ebc0a8a90c9ca591$var$_marked2 = /*#__PURE__*/ (parcelRequire("7MKKk")).mark($ebc0a8a90c9ca591$var$observeActivitySaga);
var $ebc0a8a90c9ca591$var$PASSTHRU_FN = function PASSTHRU_FN(value) {
    return value;
};
function $ebc0a8a90c9ca591$var$patchActivityWithFromRole(activity, userID) {
    // Some activities, such as "ConversationUpdate", does not have "from" defined.
    // And although "role" is defined in Direct Line spec, it was not sent over the wire.
    // We normalize the activity here to simplify null-check and logic later.
    // Patch activity.from.role to make sure its either "bot", "user", or "channel"
    if (!activity.from) activity = (0, $ebc0a8a90c9ca591$var$_simpleUpdateIn["default"])(activity, [
        "from",
        "role"
    ], function() {
        return "channel";
    });
    else if (!activity.from.role) {
        if (activity.from.id === userID) activity = (0, $ebc0a8a90c9ca591$var$_simpleUpdateIn["default"])(activity, [
            "from",
            "role"
        ], function() {
            return "user";
        });
        else if (activity.from.id) activity = (0, $ebc0a8a90c9ca591$var$_simpleUpdateIn["default"])(activity, [
            "from",
            "role"
        ], function() {
            return "bot";
        });
        else activity = (0, $ebc0a8a90c9ca591$var$_simpleUpdateIn["default"])(activity, [
            "from",
            "role"
        ], function() {
            return "channel";
        });
    }
    return activity;
}
function $ebc0a8a90c9ca591$var$patchNullAsUndefined(activity) {
    // These fields are known used in Web Chat and in any cases, they should not be null, but undefined.
    // The only field omitted is "value", as it could be null purposefully.
    return [
        "attachmentLayout",
        "attachments",
        "channelData",
        "conversation",
        "entities",
        "from",
        "inputHint",
        "locale",
        "name",
        "recipient",
        "speak",
        "suggestedActions",
        "text",
        "textFormat",
        "timestamp",
        "type"
    ].reduce(function(activity, name) {
        var value = activity[name];
        return (0, $ebc0a8a90c9ca591$var$_simpleUpdateIn["default"])(activity, [
            name
        ], typeof value === "undefined" || value === null ? undefined : $ebc0a8a90c9ca591$var$PASSTHRU_FN);
    }, activity);
} // Patching the `from.name` to be a human readable name.
// We use the `from.name` for typing indicator, such that it read "John is typing...".
function $ebc0a8a90c9ca591$var$patchFromName(activity) {
    return (0, $ebc0a8a90c9ca591$var$_simpleUpdateIn["default"])(activity, [
        "from",
        "name"
    ], function(name) {
        var channelId = activity.channelId, _activity$from = activity.from, from = _activity$from === void 0 ? {} : _activity$from;
        if ((channelId === "directline" || channelId === "webchat") && from.id === from.name && from.role === "bot") return "Bot";
        return name;
    });
}
function $ebc0a8a90c9ca591$var$observeActivity(_ref) {
    var directLine, userID;
    return $ebc0a8a90c9ca591$var$_regenerator["default"].wrap(function observeActivity$(_context2) {
        while(true)switch(_context2.prev = _context2.next){
            case 0:
                directLine = _ref.directLine, userID = _ref.userID;
                _context2.next = 3;
                return (0, $ebc0a8a90c9ca591$var$_observeEach["default"])(directLine.activity$, /*#__PURE__*/ $ebc0a8a90c9ca591$var$_regenerator["default"].mark(function observeActivity(activity) {
                    return $ebc0a8a90c9ca591$var$_regenerator["default"].wrap(function observeActivity$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                // TODO: [P2] #3953 Move the patching logic to a DirectLineJS wrapper, instead of too close to inners of Web Chat.
                                activity = $ebc0a8a90c9ca591$var$patchNullAsUndefined(activity);
                                activity = $ebc0a8a90c9ca591$var$patchActivityWithFromRole(activity, userID);
                                activity = $ebc0a8a90c9ca591$var$patchFromName(activity);
                                _context.next = 5;
                                return (0, $7McF6.Y)((0, $ebc0a8a90c9ca591$var$_queueIncomingActivity["default"])(activity));
                            case 5:
                            case "end":
                                return _context.stop();
                        }
                    }, observeActivity);
                }));
            case 3:
            case "end":
                return _context2.stop();
        }
    }, $ebc0a8a90c9ca591$var$_marked);
}
function $ebc0a8a90c9ca591$var$observeActivitySaga() {
    return $ebc0a8a90c9ca591$var$_regenerator["default"].wrap(function observeActivitySaga$(_context3) {
        while(true)switch(_context3.prev = _context3.next){
            case 0:
                _context3.next = 2;
                return (0, $ebc0a8a90c9ca591$var$_whileConnected["default"])($ebc0a8a90c9ca591$var$observeActivity);
            case 2:
            case "end":
                return _context3.stop();
        }
    }, $ebc0a8a90c9ca591$var$_marked2);
}

});
parcelRequire.register("6ugJG", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.QUEUE_INCOMING_ACTIVITY = void 0;
module.exports["default"] = $4b9286d4e3855236$var$queueIncomingActivity;
var $4b9286d4e3855236$var$QUEUE_INCOMING_ACTIVITY = "DIRECT_LINE/QUEUE_INCOMING_ACTIVITY";
module.exports.QUEUE_INCOMING_ACTIVITY = $4b9286d4e3855236$var$QUEUE_INCOMING_ACTIVITY;
function $4b9286d4e3855236$var$queueIncomingActivity(activity) {
    return {
        type: $4b9286d4e3855236$var$QUEUE_INCOMING_ACTIVITY,
        payload: {
            activity: activity
        }
    };
}

});


parcelRequire.register("65J3X", function(module, exports) {
"use strict";


var $8usDI = parcelRequire("8usDI");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = $46f62a450c8d6fa0$var$postActivitySaga;

var $46f62a450c8d6fa0$var$_regenerator = $8usDI((parcelRequire("7MKKk")));

var $46f62a450c8d6fa0$var$_toConsumableArray2 = $8usDI((parcelRequire("2NQov")));

var $46f62a450c8d6fa0$var$_defineProperty2 = $8usDI((parcelRequire("bQSfK")));
parcelRequire("6Nc1h");
var $7McF6 = parcelRequire("7McF6");
var $7PPVh = parcelRequire("7PPVh");

var $89rfh = parcelRequire("89rfh");

var $lnNkF = parcelRequire("lnNkF");

var $46f62a450c8d6fa0$var$_dateToLocaleISOString = $8usDI((parcelRequire("erLb0")));

var $46f62a450c8d6fa0$var$_deleteKey = $8usDI((parcelRequire("lgniO")));

var $46f62a450c8d6fa0$var$_language = $8usDI((parcelRequire("2tEcw")));

var $46f62a450c8d6fa0$var$_observeOnce = $8usDI((parcelRequire("kSiMO")));

var $46f62a450c8d6fa0$var$_sendTimeout = $8usDI((parcelRequire("h4ohv")));

var $46f62a450c8d6fa0$var$_sleep = $8usDI((parcelRequire("2nXdi")));

var $46f62a450c8d6fa0$var$_uniqueID = $8usDI((parcelRequire("cvpfA")));

var $46f62a450c8d6fa0$var$_whileConnected = $8usDI((parcelRequire("6qcDb")));
var $46f62a450c8d6fa0$var$_marked = /*#__PURE__*/ (parcelRequire("7MKKk")).mark($46f62a450c8d6fa0$var$postActivity), $46f62a450c8d6fa0$var$_marked2 = /*#__PURE__*/ (parcelRequire("7MKKk")).mark($46f62a450c8d6fa0$var$postActivitySaga);
function $46f62a450c8d6fa0$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $46f62a450c8d6fa0$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $46f62a450c8d6fa0$var$ownKeys(Object(source), !0).forEach(function(key) {
            (0, $46f62a450c8d6fa0$var$_defineProperty2["default"])(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $46f62a450c8d6fa0$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
// After 5 minutes, the saga will stop from listening for echo backs and consider the outgoing message as permanently undeliverable.
// This value must be equals to or larger than the user-defined `styleOptions.sendTimeout`.
var $46f62a450c8d6fa0$var$HARD_SEND_TIMEOUT = 300000;
function $46f62a450c8d6fa0$var$postActivity(directLine, userID, username, numActivitiesPosted, _ref, ponyfill) {
    var method, activity, attachments, clientActivityID, locale, localTimeZone, now, outgoingActivity, meta, echoed, echoBackCall, sendTimeout, _yield$race, echoBack;
    return $46f62a450c8d6fa0$var$_regenerator["default"].wrap(function postActivity$(_context3) {
        while(true)switch(_context3.prev = _context3.next){
            case 0:
                method = _ref.meta.method, activity = _ref.payload.activity;
                attachments = activity.type === "message" && activity.attachments || [];
                clientActivityID = (0, $46f62a450c8d6fa0$var$_uniqueID["default"])();
                _context3.next = 5;
                return (0, $7McF6.a3)($46f62a450c8d6fa0$var$_language["default"]);
            case 5:
                locale = _context3.sent;
                localTimeZone = typeof window.Intl === "undefined" ? undefined : new Intl.DateTimeFormat().resolvedOptions().timeZone;
                now = new ponyfill.Date(); // Currently, we allow untyped outgoing activity as long as the chat adapter can deliver.
                // In the future, we should warn if the outgoing activity is not matching the type.
                outgoingActivity = $46f62a450c8d6fa0$var$_objectSpread($46f62a450c8d6fa0$var$_objectSpread({}, (0, $46f62a450c8d6fa0$var$_deleteKey["default"])(activity, "id")), {}, {
                    channelData: $46f62a450c8d6fa0$var$_objectSpread($46f62a450c8d6fa0$var$_objectSpread({}, (0, $46f62a450c8d6fa0$var$_deleteKey["default"])(activity.channelData, "state", "webchat:send-status")), {}, {
                        clientActivityID: clientActivityID
                    }),
                    channelId: "webchat",
                    from: {
                        id: userID,
                        name: username,
                        role: "user"
                    },
                    locale: locale,
                    localTimestamp: (0, $46f62a450c8d6fa0$var$_dateToLocaleISOString["default"])(now),
                    localTimezone: localTimeZone
                }, activity.type === "message" ? {
                    attachments: attachments && attachments.map(function(_ref2) {
                        var contentType = _ref2.contentType, contentUrl = _ref2.contentUrl, name = _ref2.name, thumbnailUrl = _ref2.thumbnailUrl;
                        return {
                            contentType: contentType,
                            contentUrl: contentUrl,
                            name: name,
                            thumbnailUrl: thumbnailUrl
                        };
                    }),
                    text: activity.text
                } : activity.type === "event" ? {
                    name: activity.name,
                    value: activity.value
                } : {});
                if (!numActivitiesPosted) outgoingActivity.entities = [].concat((0, $46f62a450c8d6fa0$var$_toConsumableArray2["default"])(outgoingActivity.entities || []), [
                    {
                        // TODO: [P4] Currently in v3, we send the capabilities although the client might not actually have them
                        //       We need to understand why we need to send these, and only send capabilities the client have
                        requiresBotState: true,
                        supportsListening: true,
                        supportsTts: true,
                        type: "ClientCapabilities"
                    }
                ]);
                meta = {
                    clientActivityID: clientActivityID,
                    method: method
                };
                _context3.next = 13;
                return (0, $7McF6.Y)({
                    type: $lnNkF.POST_ACTIVITY_PENDING,
                    meta: meta,
                    payload: {
                        activity: outgoingActivity
                    }
                });
            case 13:
                _context3.prev = 13;
                // Quirks: We might receive INCOMING_ACTIVITY before the postActivity call completed
                //         So, we setup expectation first, then postActivity afterward
                echoBackCall = (0, $7McF6.N)(/*#__PURE__*/ $46f62a450c8d6fa0$var$_regenerator["default"].mark(function _callee() {
                    var _activity$channelData, _yield$take, _activity;
                    return $46f62a450c8d6fa0$var$_regenerator["default"].wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                _context.next = 2;
                                return (0, $7McF6.K)($89rfh.INCOMING_ACTIVITY);
                            case 2:
                                _yield$take = _context.sent;
                                _activity = _yield$take.payload.activity;
                                if (!(((_activity$channelData = _activity.channelData) === null || _activity$channelData === void 0 ? void 0 : _activity$channelData.clientActivityID) === clientActivityID && _activity.id)) {
                                    _context.next = 7;
                                    break;
                                }
                                echoed = true;
                                return _context.abrupt("return", _activity);
                            case 7:
                                _context.next = 0;
                                break;
                            case 9:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee);
                })); // Timeout could be due to either:
                // - Post activity call may take too long time to complete
                //   - Direct Line service only respond on HTTP after bot respond to Direct Line
                // - Activity may take too long time to echo back
                _context3.next = 17;
                return (0, $7McF6.a3)($46f62a450c8d6fa0$var$_sendTimeout["default"]);
            case 17:
                sendTimeout = _context3.sent;
                _context3.next = 20;
                return (0, $7McF6.V)({
                    send: (0, $7McF6._)({
                        echoBack: echoBackCall,
                        postActivity: (0, $46f62a450c8d6fa0$var$_observeOnce["default"])(directLine.postActivity(outgoingActivity))
                    }),
                    timeout: (0, $7McF6.N)(/*#__PURE__*/ $46f62a450c8d6fa0$var$_regenerator["default"].mark(function _callee2() {
                        return $46f62a450c8d6fa0$var$_regenerator["default"].wrap(function _callee2$(_context2) {
                            while(true)switch(_context2.prev = _context2.next){
                                case 0:
                                    _context2.next = 2;
                                    return (0, $7McF6.N)($46f62a450c8d6fa0$var$_sleep["default"], sendTimeout, ponyfill);
                                case 2:
                                    _context2.next = 4;
                                    return (0, $7McF6.Y)({
                                        type: $lnNkF.POST_ACTIVITY_IMPEDED,
                                        meta: meta,
                                        payload: {
                                            activity: outgoingActivity
                                        }
                                    });
                                case 4:
                                    _context2.next = 6;
                                    return (0, $7McF6.N)($46f62a450c8d6fa0$var$_sleep["default"], $46f62a450c8d6fa0$var$HARD_SEND_TIMEOUT - sendTimeout, ponyfill);
                                case 6:
                                    throw !echoed ? new Error("timed out while waiting for outgoing message to echo back") : new Error("timed out while waiting for postActivity to return any values");
                                case 7:
                                case "end":
                                    return _context2.stop();
                            }
                        }, _callee2);
                    }))
                });
            case 20:
                _yield$race = _context3.sent;
                echoBack = _yield$race.send.echoBack;
                _context3.next = 24;
                return (0, $7McF6.Y)({
                    type: $lnNkF.POST_ACTIVITY_FULFILLED,
                    meta: meta,
                    payload: {
                        activity: echoBack
                    }
                });
            case 24:
                _context3.next = 31;
                break;
            case 26:
                _context3.prev = 26;
                _context3.t0 = _context3["catch"](13);
                console.error("botframework-webchat: Failed to post activity to chat adapter.", _context3.t0);
                _context3.next = 31;
                return (0, $7McF6.Y)({
                    type: $lnNkF.POST_ACTIVITY_REJECTED,
                    error: true,
                    meta: meta,
                    payload: _context3.t0
                });
            case 31:
                _context3.prev = 31;
                _context3.next = 34;
                return (0, $7McF6.a4)();
            case 34:
                if (!_context3.sent) {
                    _context3.next = 37;
                    break;
                }
                _context3.next = 37;
                return (0, $7McF6.Y)({
                    type: $lnNkF.POST_ACTIVITY_REJECTED,
                    error: true,
                    meta: meta,
                    payload: new Error("cancelled")
                });
            case 37:
                return _context3.finish(31);
            case 38:
            case "end":
                return _context3.stop();
        }
    }, $46f62a450c8d6fa0$var$_marked, null, [
        [
            13,
            26,
            31,
            38
        ]
    ]);
}
function $46f62a450c8d6fa0$var$postActivitySaga(ponyfill) {
    return $46f62a450c8d6fa0$var$_regenerator["default"].wrap(function postActivitySaga$(_context6) {
        while(true)switch(_context6.prev = _context6.next){
            case 0:
                _context6.next = 2;
                return (0, $46f62a450c8d6fa0$var$_whileConnected["default"])(/*#__PURE__*/ $46f62a450c8d6fa0$var$_regenerator["default"].mark(function postActivityWhileConnected(_ref3) {
                    var directLine, userID, username, numActivitiesPosted;
                    return $46f62a450c8d6fa0$var$_regenerator["default"].wrap(function postActivityWhileConnected$(_context5) {
                        while(true)switch(_context5.prev = _context5.next){
                            case 0:
                                directLine = _ref3.directLine, userID = _ref3.userID, username = _ref3.username;
                                numActivitiesPosted = 0;
                                _context5.next = 4;
                                return (0, $7PPVh.takeEvery)($lnNkF.POST_ACTIVITY, /*#__PURE__*/ $46f62a450c8d6fa0$var$_regenerator["default"].mark(function postActivityWrapper(action) {
                                    return $46f62a450c8d6fa0$var$_regenerator["default"].wrap(function postActivityWrapper$(_context4) {
                                        while(true)switch(_context4.prev = _context4.next){
                                            case 0:
                                                return _context4.delegateYield($46f62a450c8d6fa0$var$postActivity(directLine, userID, username, numActivitiesPosted++, action, ponyfill), "t0", 1);
                                            case 1:
                                            case "end":
                                                return _context4.stop();
                                        }
                                    }, postActivityWrapper);
                                }));
                            case 4:
                            case "end":
                                return _context5.stop();
                        }
                    }, postActivityWhileConnected);
                }));
            case 2:
            case "end":
                return _context6.stop();
        }
    }, $46f62a450c8d6fa0$var$_marked2);
}

});
parcelRequire.register("bQSfK", function(module, exports) {
function $8a0ea290bb1901e2$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
module.exports = $8a0ea290bb1901e2$var$_defineProperty, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRequire.register("erLb0", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = $02b6d775e5f3dc0c$var$dateToLocaleISOString;
/* eslint no-magic-numbers: ["off", { "ignore": [1, 2, 3, 60] }] */ function $02b6d775e5f3dc0c$var$pad(value) {
    var count = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
    if (typeof value !== "number") throw new Error("First argument must be a number");
    var stringValue = value + "";
    while(stringValue.length < count)stringValue = "0" + stringValue;
    return stringValue;
} // Adopted from https://stackoverflow.com/questions/17415579/how-to-iso-8601-format-a-date-with-timezone-offset-in-javascript.
// Use typing of `Date` from globalThis.
// eslint-disable-next-line no-restricted-globals
function $02b6d775e5f3dc0c$var$dateToLocaleISOString(date) {
    var isDateLike = date.getTimezoneOffset && // @ts-ignore TypeScript think this is always true.
    date.getFullYear && // @ts-ignore TypeScript think this is always true.
    date.getMonth && // @ts-ignore TypeScript think this is always true.
    date.getDate && // @ts-ignore TypeScript think this is always true.
    date.getHours && // @ts-ignore TypeScript think this is always true.
    date.getMinutes && // @ts-ignore TypeScript think this is always true.
    date.getSeconds && date.getMilliseconds;
    if (!isDateLike) throw new Error("First argument must be a Date-like object.");
    var timezoneOffset = -date.getTimezoneOffset();
    var timezoneSign = timezoneOffset < 0 ? "-" : "+"; // "yyyy-MM-DDTHH:mm:ss.fff+08:00" for GMT+08
    // "yyyy-MM-DDTHH:mm:ss.fffZ" for UTC
    return "".concat(date.getFullYear(), "-").concat($02b6d775e5f3dc0c$var$pad(date.getMonth() + 1), "-").concat($02b6d775e5f3dc0c$var$pad(date.getDate()), "T").concat($02b6d775e5f3dc0c$var$pad(date.getHours()), ":").concat($02b6d775e5f3dc0c$var$pad(date.getMinutes()), ":").concat($02b6d775e5f3dc0c$var$pad(date.getSeconds()), ".").concat($02b6d775e5f3dc0c$var$pad(date.getMilliseconds(), 3)).concat(timezoneOffset ? "".concat(timezoneSign).concat($02b6d775e5f3dc0c$var$pad(~~(Math.abs(timezoneOffset) / 60)), ":").concat($02b6d775e5f3dc0c$var$pad(timezoneOffset % 60)) : "Z");
}

});

parcelRequire.register("lgniO", function(module, exports) {
"use strict";

var $8usDI = parcelRequire("8usDI");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = $f7ad2afe600c594b$var$deleteKey;

var $f7ad2afe600c594b$var$_defineProperty2 = $8usDI((parcelRequire("bQSfK")));

var $f7ad2afe600c594b$var$_isForbiddenPropertyName = $8usDI((parcelRequire("1BBNC")));
function $f7ad2afe600c594b$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $f7ad2afe600c594b$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $f7ad2afe600c594b$var$ownKeys(Object(source), !0).forEach(function(key) {
            (0, $f7ad2afe600c594b$var$_defineProperty2["default"])(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $f7ad2afe600c594b$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $f7ad2afe600c594b$var$deleteKey(map) {
    if (!map) return map;
    var nextMap = $f7ad2afe600c594b$var$_objectSpread({}, map);
    for(var _len = arguments.length, keys = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)keys[_key - 1] = arguments[_key];
    for(var _i = 0, _keys = keys; _i < _keys.length; _i++){
        var key = _keys[_i];
        if (typeof key !== "string" || !(0, $f7ad2afe600c594b$var$_isForbiddenPropertyName["default"])(key)) // Mitigation through denylisting.
        // eslint-disable-next-line security/detect-object-injection
        delete nextMap[key];
    }
    return nextMap;
}

});

parcelRequire.register("2tEcw", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;
var $1cdd7945e1cd99e1$var$_default = function _default(_ref) {
    var language = _ref.language;
    return language;
};
module.exports["default"] = $1cdd7945e1cd99e1$var$_default;

});

parcelRequire.register("kSiMO", function(module, exports) {
"use strict";

var $8usDI = parcelRequire("8usDI");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = $f3276c5d9ad5b742$var$observeOnceEffect;

var $f3276c5d9ad5b742$var$_regenerator = $8usDI((parcelRequire("7MKKk")));
parcelRequire("6Nc1h");
var $7McF6 = parcelRequire("7McF6");
function $f3276c5d9ad5b742$var$observeOnceEffect(observable) {
    return (0, $7McF6.N)(/*#__PURE__*/ $f3276c5d9ad5b742$var$_regenerator["default"].mark(function observeOnce() {
        var subscription;
        return $f3276c5d9ad5b742$var$_regenerator["default"].wrap(function observeOnce$(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    _context.prev = 0;
                    _context.next = 3;
                    return (0, $7McF6.N)(function() {
                        return new Promise(function(resolve, reject) {
                            subscription = observable.subscribe({
                                complete: resolve,
                                error: reject,
                                next: resolve
                            });
                        });
                    });
                case 3:
                    return _context.abrupt("return", _context.sent);
                case 4:
                    _context.prev = 4;
                    subscription && subscription.unsubscribe();
                    return _context.finish(4);
                case 7:
                case "end":
                    return _context.stop();
            }
        }, observeOnce, null, [
            [
                0,
                ,
                4,
                7
            ]
        ]);
    }));
}

});

parcelRequire.register("h4ohv", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;
var $c6d5a52f1c3ac132$var$_default = function _default(_ref) {
    var sendTimeout = _ref.sendTimeout;
    return sendTimeout;
};
module.exports["default"] = $c6d5a52f1c3ac132$var$_default;

});


parcelRequire.register("8zrav", function(module, exports) {
"use strict";

var $8usDI = parcelRequire("8usDI");

var $UAGsq = parcelRequire("UAGsq");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = $63d6aab87b1939bd$var$queueIncomingActivitySaga;

var $63d6aab87b1939bd$var$_regenerator = $8usDI((parcelRequire("7MKKk")));
parcelRequire("6Nc1h");
var $7McF6 = parcelRequire("7McF6");

var $6ugJG = parcelRequire("6ugJG");

var $63d6aab87b1939bd$var$_activities = $63d6aab87b1939bd$var$_interopRequireWildcard((parcelRequire("ltJDo")));

var $63d6aab87b1939bd$var$_activityFromBot = $8usDI((parcelRequire("e4LRo")));

var $63d6aab87b1939bd$var$_incomingActivity = $63d6aab87b1939bd$var$_interopRequireWildcard((parcelRequire("89rfh")));

var $63d6aab87b1939bd$var$_setSuggestedActions = $8usDI((parcelRequire("9fqWO")));

var $63d6aab87b1939bd$var$_sleep = $8usDI((parcelRequire("2nXdi")));

var $63d6aab87b1939bd$var$_whileConnected = $8usDI((parcelRequire("6qcDb")));
function $63d6aab87b1939bd$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($63d6aab87b1939bd$var$_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $63d6aab87b1939bd$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || $UAGsq(obj) !== "object" && typeof obj !== "function") return {
        "default": obj
    };
    var cache = $63d6aab87b1939bd$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj["default"] = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
var $63d6aab87b1939bd$var$_marked = /*#__PURE__*/ $63d6aab87b1939bd$var$_regenerator["default"].mark($63d6aab87b1939bd$var$takeEveryAndSelect), $63d6aab87b1939bd$var$_marked2 = /*#__PURE__*/ $63d6aab87b1939bd$var$_regenerator["default"].mark($63d6aab87b1939bd$var$waitForActivityId), $63d6aab87b1939bd$var$_marked3 = /*#__PURE__*/ $63d6aab87b1939bd$var$_regenerator["default"].mark($63d6aab87b1939bd$var$queueIncomingActivity), $63d6aab87b1939bd$var$_marked4 = /*#__PURE__*/ $63d6aab87b1939bd$var$_regenerator["default"].mark($63d6aab87b1939bd$var$queueIncomingActivitySaga);
// We will hold up the replying activity if the originating activity did not arrive, up to 5 seconds.
var $63d6aab87b1939bd$var$REPLY_TIMEOUT = 5000;
function $63d6aab87b1939bd$var$takeEveryAndSelect(actionType, selector, fn) {
    var action, state;
    return $63d6aab87b1939bd$var$_regenerator["default"].wrap(function takeEveryAndSelect$(_context) {
        while(true)switch(_context.prev = _context.next){
            case 0:
                _context.next = 2;
                return (0, $7McF6.a4)();
            case 2:
                if (_context.sent) {
                    _context.next = 13;
                    break;
                }
                _context.next = 5;
                return (0, $7McF6.K)(actionType);
            case 5:
                action = _context.sent;
                _context.next = 8;
                return (0, $7McF6.a3)(selector);
            case 8:
                state = _context.sent;
                _context.next = 11;
                return (0, $7McF6.L)(fn, action, state);
            case 11:
                _context.next = 0;
                break;
            case 13:
            case "end":
                return _context.stop();
        }
    }, $63d6aab87b1939bd$var$_marked);
} // Wait for specific activity to arrive in the transcript.
// We will use the initial set of activities to close time gaps between select() and take().
// If another activity with the same "replyToId" is already rendered (in the "activities" array),
// we will skip the wait as we already waited long enough for the missing activity to show up.
function $63d6aab87b1939bd$var$waitForActivityId(replyToId, initialActivities) {
    var activities, replied, _yield$take, activity;
    return $63d6aab87b1939bd$var$_regenerator["default"].wrap(function waitForActivityId$(_context2) {
        while(true)switch(_context2.prev = _context2.next){
            case 0:
                activities = initialActivities;
            case 1:
                replied = activities.find(function(activity) {
                    return activity.id === replyToId || activity.replyToId === replyToId;
                });
                if (!replied) {
                    _context2.next = 4;
                    break;
                }
                return _context2.abrupt("break", 15);
            case 4:
                _context2.next = 6;
                return (0, $7McF6.K)($63d6aab87b1939bd$var$_incomingActivity.INCOMING_ACTIVITY);
            case 6:
                _yield$take = _context2.sent;
                activity = _yield$take.payload.activity;
                if (!(activity.id === replyToId)) {
                    _context2.next = 10;
                    break;
                }
                return _context2.abrupt("break", 15);
            case 10:
                _context2.next = 12;
                return (0, $7McF6.a3)($63d6aab87b1939bd$var$_activities["default"]);
            case 12:
                activities = _context2.sent;
            case 13:
                _context2.next = 1;
                break;
            case 15:
            case "end":
                return _context2.stop();
        }
    }, $63d6aab87b1939bd$var$_marked2);
}
function $63d6aab87b1939bd$var$queueIncomingActivity(_ref, ponyfill) {
    var userID;
    return $63d6aab87b1939bd$var$_regenerator["default"].wrap(function queueIncomingActivity$(_context4) {
        while(true)switch(_context4.prev = _context4.next){
            case 0:
                userID = _ref.userID;
                _context4.next = 3;
                return $63d6aab87b1939bd$var$takeEveryAndSelect($6ugJG.QUEUE_INCOMING_ACTIVITY, $63d6aab87b1939bd$var$_activities["default"], /*#__PURE__*/ $63d6aab87b1939bd$var$_regenerator["default"].mark(function queueIncomingActivity(_ref2, initialActivities) {
                    var activity, replyToId, initialBotActivities, result, messageActivities, lastMessageActivity, _lastMessageActivity$, actions, to;
                    return $63d6aab87b1939bd$var$_regenerator["default"].wrap(function queueIncomingActivity$(_context3) {
                        while(true)switch(_context3.prev = _context3.next){
                            case 0:
                                activity = _ref2.payload.activity;
                                // This is for resolving an accessibility issue.
                                // If the incoming activity has "replyToId" field, hold on it until the activity replied to is in the transcript, then release this one.
                                replyToId = activity.replyToId;
                                initialBotActivities = initialActivities.filter(function(_ref3) {
                                    var role = _ref3.from.role;
                                    return role === "bot";
                                }); // To speed up the first activity render time, we do not delay the first activity from the bot.
                                // Even if it is the first activity from the bot, the bot might be "replying" to the "conversationUpdate" event.
                                // Thus, the "replyToId" will always be there even it is the first activity in the conversation.
                                if (!(replyToId && initialBotActivities.length)) {
                                    _context3.next = 8;
                                    break;
                                }
                                _context3.next = 6;
                                return (0, $7McF6.V)({
                                    _: $63d6aab87b1939bd$var$waitForActivityId(replyToId, initialActivities),
                                    timeout: (0, $7McF6.N)($63d6aab87b1939bd$var$_sleep["default"], $63d6aab87b1939bd$var$REPLY_TIMEOUT, ponyfill)
                                });
                            case 6:
                                result = _context3.sent;
                                if ("timeout" in result) console.warn('botframework-webchat: Timed out while waiting for activity "'.concat(replyToId, '" which activity "').concat(activity.id, '" is replying to.'), {
                                    activity: activity,
                                    replyToId: replyToId
                                });
                            case 8:
                                _context3.next = 10;
                                return (0, $7McF6.Y)((0, $63d6aab87b1939bd$var$_incomingActivity["default"])(activity));
                            case 10:
                                _context3.next = 12;
                                return (0, $7McF6.a3)((0, $63d6aab87b1939bd$var$_activities.ofType)("message"));
                            case 12:
                                messageActivities = _context3.sent;
                                lastMessageActivity = messageActivities[messageActivities.length - 1];
                                if (!(0, $63d6aab87b1939bd$var$_activityFromBot["default"])(lastMessageActivity)) {
                                    _context3.next = 20;
                                    break;
                                }
                                _lastMessageActivity$ = lastMessageActivity.suggestedActions;
                                _lastMessageActivity$ = _lastMessageActivity$ === void 0 ? {
                                    actions: undefined,
                                    to: undefined
                                } : _lastMessageActivity$;
                                actions = _lastMessageActivity$.actions, to = _lastMessageActivity$.to; // If suggested actions is not destined to anyone, or is destined to the user, show it.
                                // In other words, if suggested actions is destined to someone else, don't show it.
                                _context3.next = 20;
                                return (0, $7McF6.Y)((0, $63d6aab87b1939bd$var$_setSuggestedActions["default"])(to !== null && to !== void 0 && to.length && !to.includes(userID) ? null : actions));
                            case 20:
                            case "end":
                                return _context3.stop();
                        }
                    }, queueIncomingActivity);
                }));
            case 3:
            case "end":
                return _context4.stop();
        }
    }, $63d6aab87b1939bd$var$_marked3);
}
function $63d6aab87b1939bd$var$queueIncomingActivitySaga(ponyfill) {
    return $63d6aab87b1939bd$var$_regenerator["default"].wrap(function queueIncomingActivitySaga$(_context5) {
        while(true)switch(_context5.prev = _context5.next){
            case 0:
                _context5.next = 2;
                return (0, $63d6aab87b1939bd$var$_whileConnected["default"])($63d6aab87b1939bd$var$queueIncomingActivity, ponyfill);
            case 2:
            case "end":
                return _context5.stop();
        }
    }, $63d6aab87b1939bd$var$_marked4);
}

});
parcelRequire.register("e4LRo", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;
var $a3f69072bc05bfd2$var$_default = function _default(activity) {
    return activity && activity.from.role === "bot";
};
module.exports["default"] = $a3f69072bc05bfd2$var$_default;

});


parcelRequire.register("gyTa8", function(module, exports) {
"use strict";

var $8usDI = parcelRequire("8usDI");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = $c0ea9c75c63f7d98$var$sendEventToPostActivitySaga;

var $c0ea9c75c63f7d98$var$_regenerator = $8usDI((parcelRequire("7MKKk")));
parcelRequire("6Nc1h");
var $7McF6 = parcelRequire("7McF6");
var $7PPVh = parcelRequire("7PPVh");

var $by2Od = parcelRequire("by2Od");

var $c0ea9c75c63f7d98$var$_postActivity = $8usDI((parcelRequire("lnNkF")));

var $c0ea9c75c63f7d98$var$_whileConnected = $8usDI((parcelRequire("6qcDb")));
var $c0ea9c75c63f7d98$var$_marked = /*#__PURE__*/ $c0ea9c75c63f7d98$var$_regenerator["default"].mark($c0ea9c75c63f7d98$var$postActivityWithEvent), $c0ea9c75c63f7d98$var$_marked2 = /*#__PURE__*/ $c0ea9c75c63f7d98$var$_regenerator["default"].mark($c0ea9c75c63f7d98$var$sendEventToPostActivity), $c0ea9c75c63f7d98$var$_marked3 = /*#__PURE__*/ $c0ea9c75c63f7d98$var$_regenerator["default"].mark($c0ea9c75c63f7d98$var$sendEventToPostActivitySaga);
function $c0ea9c75c63f7d98$var$postActivityWithEvent(_ref) {
    var _ref$payload, name, value;
    return $c0ea9c75c63f7d98$var$_regenerator["default"].wrap(function postActivityWithEvent$(_context) {
        while(true)switch(_context.prev = _context.next){
            case 0:
                _ref$payload = _ref.payload, name = _ref$payload.name, value = _ref$payload.value;
                _context.next = 3;
                return (0, $7McF6.Y)((0, $c0ea9c75c63f7d98$var$_postActivity["default"])({
                    name: name,
                    type: "event",
                    value: value
                }));
            case 3:
            case "end":
                return _context.stop();
        }
    }, $c0ea9c75c63f7d98$var$_marked);
}
function $c0ea9c75c63f7d98$var$sendEventToPostActivity() {
    return $c0ea9c75c63f7d98$var$_regenerator["default"].wrap(function sendEventToPostActivity$(_context2) {
        while(true)switch(_context2.prev = _context2.next){
            case 0:
                _context2.next = 2;
                return (0, $7PPVh.takeEvery)(function(_ref2) {
                    var payload = _ref2.payload, type = _ref2.type;
                    return type === $by2Od.SEND_EVENT && payload.name;
                }, $c0ea9c75c63f7d98$var$postActivityWithEvent);
            case 2:
            case "end":
                return _context2.stop();
        }
    }, $c0ea9c75c63f7d98$var$_marked2);
}
function $c0ea9c75c63f7d98$var$sendEventToPostActivitySaga() {
    return $c0ea9c75c63f7d98$var$_regenerator["default"].wrap(function sendEventToPostActivitySaga$(_context3) {
        while(true)switch(_context3.prev = _context3.next){
            case 0:
                _context3.next = 2;
                return (0, $c0ea9c75c63f7d98$var$_whileConnected["default"])($c0ea9c75c63f7d98$var$sendEventToPostActivity);
            case 2:
            case "end":
                return _context3.stop();
        }
    }, $c0ea9c75c63f7d98$var$_marked3);
}

});
parcelRequire.register("by2Od", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SEND_EVENT = void 0;
module.exports["default"] = $86850c7acc91b7c6$var$sendEvent;
var $86850c7acc91b7c6$var$SEND_EVENT = "WEB_CHAT/SEND_EVENT";
module.exports.SEND_EVENT = $86850c7acc91b7c6$var$SEND_EVENT;
function $86850c7acc91b7c6$var$sendEvent(name, value) {
    return {
        type: $86850c7acc91b7c6$var$SEND_EVENT,
        payload: {
            name: name,
            value: value
        }
    };
}

});


parcelRequire.register("7Fci7", function(module, exports) {
"use strict";

var $8usDI = parcelRequire("8usDI");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = $5945e58953c1c591$var$sendFilesToPostActivitySaga;

var $5945e58953c1c591$var$_regenerator = $8usDI((parcelRequire("7MKKk")));
parcelRequire("6Nc1h");
var $7McF6 = parcelRequire("7McF6");
var $7PPVh = parcelRequire("7PPVh");

var $5945e58953c1c591$var$_mime = $8usDI((parcelRequire("dH0fZ")));

var $7ZJF5 = parcelRequire("7ZJF5");

var $5945e58953c1c591$var$_postActivity = $8usDI((parcelRequire("lnNkF")));

var $5945e58953c1c591$var$_whileConnected = $8usDI((parcelRequire("6qcDb")));
var $5945e58953c1c591$var$_marked = /*#__PURE__*/ $5945e58953c1c591$var$_regenerator["default"].mark($5945e58953c1c591$var$postActivityWithFiles), $5945e58953c1c591$var$_marked2 = /*#__PURE__*/ $5945e58953c1c591$var$_regenerator["default"].mark($5945e58953c1c591$var$sendFilesToPostActivity), $5945e58953c1c591$var$_marked3 = /*#__PURE__*/ $5945e58953c1c591$var$_regenerator["default"].mark($5945e58953c1c591$var$sendFilesToPostActivitySaga);
var $5945e58953c1c591$var$getType = $5945e58953c1c591$var$_mime["default"].getType.bind($5945e58953c1c591$var$_mime["default"]);
function $5945e58953c1c591$var$postActivityWithFiles(_ref) {
    var files;
    return $5945e58953c1c591$var$_regenerator["default"].wrap(function postActivityWithFiles$(_context) {
        while(true)switch(_context.prev = _context.next){
            case 0:
                files = _ref.payload.files;
                _context.next = 3;
                return (0, $7McF6.Y)((0, $5945e58953c1c591$var$_postActivity["default"])({
                    attachments: [].map.call(files, function(_ref2) {
                        var name = _ref2.name, thumbnail = _ref2.thumbnail, url = _ref2.url;
                        return {
                            contentType: $5945e58953c1c591$var$getType(name) || "application/octet-stream",
                            contentUrl: url,
                            name: name,
                            thumbnailUrl: thumbnail
                        };
                    }),
                    channelData: {
                        attachmentSizes: [].map.call(files, function(_ref3) {
                            var size = _ref3.size;
                            return size;
                        })
                    },
                    type: "message"
                }));
            case 3:
            case "end":
                return _context.stop();
        }
    }, $5945e58953c1c591$var$_marked);
}
function $5945e58953c1c591$var$sendFilesToPostActivity() {
    return $5945e58953c1c591$var$_regenerator["default"].wrap(function sendFilesToPostActivity$(_context2) {
        while(true)switch(_context2.prev = _context2.next){
            case 0:
                _context2.next = 2;
                return (0, $7PPVh.takeEvery)(function(_ref4) {
                    var payload = _ref4.payload, type = _ref4.type;
                    return type === $7ZJF5.SEND_FILES && payload.files.length;
                }, $5945e58953c1c591$var$postActivityWithFiles);
            case 2:
            case "end":
                return _context2.stop();
        }
    }, $5945e58953c1c591$var$_marked2);
}
function $5945e58953c1c591$var$sendFilesToPostActivitySaga() {
    return $5945e58953c1c591$var$_regenerator["default"].wrap(function sendFilesToPostActivitySaga$(_context3) {
        while(true)switch(_context3.prev = _context3.next){
            case 0:
                _context3.next = 2;
                return (0, $5945e58953c1c591$var$_whileConnected["default"])($5945e58953c1c591$var$sendFilesToPostActivity);
            case 2:
            case "end":
                return _context3.stop();
        }
    }, $5945e58953c1c591$var$_marked3);
}

});
parcelRequire.register("dH0fZ", function(module, exports) {
"use strict";

var $5I7zM = parcelRequire("5I7zM");


module.exports = new $5I7zM((parcelRequire("9a3Km")), (parcelRequire("1doyX")));

});
parcelRequire.register("5I7zM", function(module, exports) {
"use strict";
/**
 * @param typeMap [Object] Map of MIME type -> Array[extensions]
 * @param ...
 */ function $4286f03fb0b96042$var$Mime() {
    this._types = Object.create(null);
    this._extensions = Object.create(null);
    for(let i = 0; i < arguments.length; i++)this.define(arguments[i]);
    this.define = this.define.bind(this);
    this.getType = this.getType.bind(this);
    this.getExtension = this.getExtension.bind(this);
}
/**
 * Define mimetype -> extension mappings.  Each key is a mime-type that maps
 * to an array of extensions associated with the type.  The first extension is
 * used as the default extension for the type.
 *
 * e.g. mime.define({'audio/ogg', ['oga', 'ogg', 'spx']});
 *
 * If a type declares an extension that has already been defined, an error will
 * be thrown.  To suppress this error and force the extension to be associated
 * with the new type, pass `force`=true.  Alternatively, you may prefix the
 * extension with "*" to map the type to extension, without mapping the
 * extension to the type.
 *
 * e.g. mime.define({'audio/wav', ['wav']}, {'audio/x-wav', ['*wav']});
 *
 *
 * @param map (Object) type definitions
 * @param force (Boolean) if true, force overriding of existing definitions
 */ $4286f03fb0b96042$var$Mime.prototype.define = function(typeMap, force) {
    for(let type in typeMap){
        let extensions = typeMap[type].map(function(t) {
            return t.toLowerCase();
        });
        type = type.toLowerCase();
        for(let i = 0; i < extensions.length; i++){
            const ext = extensions[i];
            // '*' prefix = not the preferred type for this extension.  So fixup the
            // extension, and skip it.
            if (ext[0] === "*") continue;
            if (!force && ext in this._types) throw new Error('Attempt to change mapping for "' + ext + '" extension from "' + this._types[ext] + '" to "' + type + '". Pass `force=true` to allow this, otherwise remove "' + ext + '" from the list of extensions for "' + type + '".');
            this._types[ext] = type;
        }
        // Use first extension as default
        if (force || !this._extensions[type]) {
            const ext = extensions[0];
            this._extensions[type] = ext[0] !== "*" ? ext : ext.substr(1);
        }
    }
};
/**
 * Lookup a mime type based on extension
 */ $4286f03fb0b96042$var$Mime.prototype.getType = function(path) {
    path = String(path);
    let last = path.replace(/^.*[/\\]/, "").toLowerCase();
    let ext = last.replace(/^.*\./, "").toLowerCase();
    let hasPath = last.length < path.length;
    let hasDot = ext.length < last.length - 1;
    return (hasDot || !hasPath) && this._types[ext] || null;
};
/**
 * Return file extension associated with a mime type
 */ $4286f03fb0b96042$var$Mime.prototype.getExtension = function(type) {
    type = /^\s*([^;\s]*)/.test(type) && RegExp.$1;
    return type && this._extensions[type.toLowerCase()] || null;
};
module.exports = $4286f03fb0b96042$var$Mime;

});

parcelRequire.register("9a3Km", function(module, exports) {
module.exports = {
    "application/andrew-inset": [
        "ez"
    ],
    "application/applixware": [
        "aw"
    ],
    "application/atom+xml": [
        "atom"
    ],
    "application/atomcat+xml": [
        "atomcat"
    ],
    "application/atomdeleted+xml": [
        "atomdeleted"
    ],
    "application/atomsvc+xml": [
        "atomsvc"
    ],
    "application/atsc-dwd+xml": [
        "dwd"
    ],
    "application/atsc-held+xml": [
        "held"
    ],
    "application/atsc-rsat+xml": [
        "rsat"
    ],
    "application/bdoc": [
        "bdoc"
    ],
    "application/calendar+xml": [
        "xcs"
    ],
    "application/ccxml+xml": [
        "ccxml"
    ],
    "application/cdfx+xml": [
        "cdfx"
    ],
    "application/cdmi-capability": [
        "cdmia"
    ],
    "application/cdmi-container": [
        "cdmic"
    ],
    "application/cdmi-domain": [
        "cdmid"
    ],
    "application/cdmi-object": [
        "cdmio"
    ],
    "application/cdmi-queue": [
        "cdmiq"
    ],
    "application/cu-seeme": [
        "cu"
    ],
    "application/dash+xml": [
        "mpd"
    ],
    "application/davmount+xml": [
        "davmount"
    ],
    "application/docbook+xml": [
        "dbk"
    ],
    "application/dssc+der": [
        "dssc"
    ],
    "application/dssc+xml": [
        "xdssc"
    ],
    "application/ecmascript": [
        "es",
        "ecma"
    ],
    "application/emma+xml": [
        "emma"
    ],
    "application/emotionml+xml": [
        "emotionml"
    ],
    "application/epub+zip": [
        "epub"
    ],
    "application/exi": [
        "exi"
    ],
    "application/express": [
        "exp"
    ],
    "application/fdt+xml": [
        "fdt"
    ],
    "application/font-tdpfr": [
        "pfr"
    ],
    "application/geo+json": [
        "geojson"
    ],
    "application/gml+xml": [
        "gml"
    ],
    "application/gpx+xml": [
        "gpx"
    ],
    "application/gxf": [
        "gxf"
    ],
    "application/gzip": [
        "gz"
    ],
    "application/hjson": [
        "hjson"
    ],
    "application/hyperstudio": [
        "stk"
    ],
    "application/inkml+xml": [
        "ink",
        "inkml"
    ],
    "application/ipfix": [
        "ipfix"
    ],
    "application/its+xml": [
        "its"
    ],
    "application/java-archive": [
        "jar",
        "war",
        "ear"
    ],
    "application/java-serialized-object": [
        "ser"
    ],
    "application/java-vm": [
        "class"
    ],
    "application/javascript": [
        "js",
        "mjs"
    ],
    "application/json": [
        "json",
        "map"
    ],
    "application/json5": [
        "json5"
    ],
    "application/jsonml+json": [
        "jsonml"
    ],
    "application/ld+json": [
        "jsonld"
    ],
    "application/lgr+xml": [
        "lgr"
    ],
    "application/lost+xml": [
        "lostxml"
    ],
    "application/mac-binhex40": [
        "hqx"
    ],
    "application/mac-compactpro": [
        "cpt"
    ],
    "application/mads+xml": [
        "mads"
    ],
    "application/manifest+json": [
        "webmanifest"
    ],
    "application/marc": [
        "mrc"
    ],
    "application/marcxml+xml": [
        "mrcx"
    ],
    "application/mathematica": [
        "ma",
        "nb",
        "mb"
    ],
    "application/mathml+xml": [
        "mathml"
    ],
    "application/mbox": [
        "mbox"
    ],
    "application/mediaservercontrol+xml": [
        "mscml"
    ],
    "application/metalink+xml": [
        "metalink"
    ],
    "application/metalink4+xml": [
        "meta4"
    ],
    "application/mets+xml": [
        "mets"
    ],
    "application/mmt-aei+xml": [
        "maei"
    ],
    "application/mmt-usd+xml": [
        "musd"
    ],
    "application/mods+xml": [
        "mods"
    ],
    "application/mp21": [
        "m21",
        "mp21"
    ],
    "application/mp4": [
        "mp4s",
        "m4p"
    ],
    "application/msword": [
        "doc",
        "dot"
    ],
    "application/mxf": [
        "mxf"
    ],
    "application/n-quads": [
        "nq"
    ],
    "application/n-triples": [
        "nt"
    ],
    "application/node": [
        "cjs"
    ],
    "application/octet-stream": [
        "bin",
        "dms",
        "lrf",
        "mar",
        "so",
        "dist",
        "distz",
        "pkg",
        "bpk",
        "dump",
        "elc",
        "deploy",
        "exe",
        "dll",
        "deb",
        "dmg",
        "iso",
        "img",
        "msi",
        "msp",
        "msm",
        "buffer"
    ],
    "application/oda": [
        "oda"
    ],
    "application/oebps-package+xml": [
        "opf"
    ],
    "application/ogg": [
        "ogx"
    ],
    "application/omdoc+xml": [
        "omdoc"
    ],
    "application/onenote": [
        "onetoc",
        "onetoc2",
        "onetmp",
        "onepkg"
    ],
    "application/oxps": [
        "oxps"
    ],
    "application/p2p-overlay+xml": [
        "relo"
    ],
    "application/patch-ops-error+xml": [
        "xer"
    ],
    "application/pdf": [
        "pdf"
    ],
    "application/pgp-encrypted": [
        "pgp"
    ],
    "application/pgp-signature": [
        "asc",
        "sig"
    ],
    "application/pics-rules": [
        "prf"
    ],
    "application/pkcs10": [
        "p10"
    ],
    "application/pkcs7-mime": [
        "p7m",
        "p7c"
    ],
    "application/pkcs7-signature": [
        "p7s"
    ],
    "application/pkcs8": [
        "p8"
    ],
    "application/pkix-attr-cert": [
        "ac"
    ],
    "application/pkix-cert": [
        "cer"
    ],
    "application/pkix-crl": [
        "crl"
    ],
    "application/pkix-pkipath": [
        "pkipath"
    ],
    "application/pkixcmp": [
        "pki"
    ],
    "application/pls+xml": [
        "pls"
    ],
    "application/postscript": [
        "ai",
        "eps",
        "ps"
    ],
    "application/provenance+xml": [
        "provx"
    ],
    "application/pskc+xml": [
        "pskcxml"
    ],
    "application/raml+yaml": [
        "raml"
    ],
    "application/rdf+xml": [
        "rdf",
        "owl"
    ],
    "application/reginfo+xml": [
        "rif"
    ],
    "application/relax-ng-compact-syntax": [
        "rnc"
    ],
    "application/resource-lists+xml": [
        "rl"
    ],
    "application/resource-lists-diff+xml": [
        "rld"
    ],
    "application/rls-services+xml": [
        "rs"
    ],
    "application/route-apd+xml": [
        "rapd"
    ],
    "application/route-s-tsid+xml": [
        "sls"
    ],
    "application/route-usd+xml": [
        "rusd"
    ],
    "application/rpki-ghostbusters": [
        "gbr"
    ],
    "application/rpki-manifest": [
        "mft"
    ],
    "application/rpki-roa": [
        "roa"
    ],
    "application/rsd+xml": [
        "rsd"
    ],
    "application/rss+xml": [
        "rss"
    ],
    "application/rtf": [
        "rtf"
    ],
    "application/sbml+xml": [
        "sbml"
    ],
    "application/scvp-cv-request": [
        "scq"
    ],
    "application/scvp-cv-response": [
        "scs"
    ],
    "application/scvp-vp-request": [
        "spq"
    ],
    "application/scvp-vp-response": [
        "spp"
    ],
    "application/sdp": [
        "sdp"
    ],
    "application/senml+xml": [
        "senmlx"
    ],
    "application/sensml+xml": [
        "sensmlx"
    ],
    "application/set-payment-initiation": [
        "setpay"
    ],
    "application/set-registration-initiation": [
        "setreg"
    ],
    "application/shf+xml": [
        "shf"
    ],
    "application/sieve": [
        "siv",
        "sieve"
    ],
    "application/smil+xml": [
        "smi",
        "smil"
    ],
    "application/sparql-query": [
        "rq"
    ],
    "application/sparql-results+xml": [
        "srx"
    ],
    "application/srgs": [
        "gram"
    ],
    "application/srgs+xml": [
        "grxml"
    ],
    "application/sru+xml": [
        "sru"
    ],
    "application/ssdl+xml": [
        "ssdl"
    ],
    "application/ssml+xml": [
        "ssml"
    ],
    "application/swid+xml": [
        "swidtag"
    ],
    "application/tei+xml": [
        "tei",
        "teicorpus"
    ],
    "application/thraud+xml": [
        "tfi"
    ],
    "application/timestamped-data": [
        "tsd"
    ],
    "application/toml": [
        "toml"
    ],
    "application/trig": [
        "trig"
    ],
    "application/ttml+xml": [
        "ttml"
    ],
    "application/ubjson": [
        "ubj"
    ],
    "application/urc-ressheet+xml": [
        "rsheet"
    ],
    "application/urc-targetdesc+xml": [
        "td"
    ],
    "application/voicexml+xml": [
        "vxml"
    ],
    "application/wasm": [
        "wasm"
    ],
    "application/widget": [
        "wgt"
    ],
    "application/winhlp": [
        "hlp"
    ],
    "application/wsdl+xml": [
        "wsdl"
    ],
    "application/wspolicy+xml": [
        "wspolicy"
    ],
    "application/xaml+xml": [
        "xaml"
    ],
    "application/xcap-att+xml": [
        "xav"
    ],
    "application/xcap-caps+xml": [
        "xca"
    ],
    "application/xcap-diff+xml": [
        "xdf"
    ],
    "application/xcap-el+xml": [
        "xel"
    ],
    "application/xcap-ns+xml": [
        "xns"
    ],
    "application/xenc+xml": [
        "xenc"
    ],
    "application/xhtml+xml": [
        "xhtml",
        "xht"
    ],
    "application/xliff+xml": [
        "xlf"
    ],
    "application/xml": [
        "xml",
        "xsl",
        "xsd",
        "rng"
    ],
    "application/xml-dtd": [
        "dtd"
    ],
    "application/xop+xml": [
        "xop"
    ],
    "application/xproc+xml": [
        "xpl"
    ],
    "application/xslt+xml": [
        "*xsl",
        "xslt"
    ],
    "application/xspf+xml": [
        "xspf"
    ],
    "application/xv+xml": [
        "mxml",
        "xhvml",
        "xvml",
        "xvm"
    ],
    "application/yang": [
        "yang"
    ],
    "application/yin+xml": [
        "yin"
    ],
    "application/zip": [
        "zip"
    ],
    "audio/3gpp": [
        "*3gpp"
    ],
    "audio/adpcm": [
        "adp"
    ],
    "audio/amr": [
        "amr"
    ],
    "audio/basic": [
        "au",
        "snd"
    ],
    "audio/midi": [
        "mid",
        "midi",
        "kar",
        "rmi"
    ],
    "audio/mobile-xmf": [
        "mxmf"
    ],
    "audio/mp3": [
        "*mp3"
    ],
    "audio/mp4": [
        "m4a",
        "mp4a"
    ],
    "audio/mpeg": [
        "mpga",
        "mp2",
        "mp2a",
        "mp3",
        "m2a",
        "m3a"
    ],
    "audio/ogg": [
        "oga",
        "ogg",
        "spx",
        "opus"
    ],
    "audio/s3m": [
        "s3m"
    ],
    "audio/silk": [
        "sil"
    ],
    "audio/wav": [
        "wav"
    ],
    "audio/wave": [
        "*wav"
    ],
    "audio/webm": [
        "weba"
    ],
    "audio/xm": [
        "xm"
    ],
    "font/collection": [
        "ttc"
    ],
    "font/otf": [
        "otf"
    ],
    "font/ttf": [
        "ttf"
    ],
    "font/woff": [
        "woff"
    ],
    "font/woff2": [
        "woff2"
    ],
    "image/aces": [
        "exr"
    ],
    "image/apng": [
        "apng"
    ],
    "image/avif": [
        "avif"
    ],
    "image/bmp": [
        "bmp"
    ],
    "image/cgm": [
        "cgm"
    ],
    "image/dicom-rle": [
        "drle"
    ],
    "image/emf": [
        "emf"
    ],
    "image/fits": [
        "fits"
    ],
    "image/g3fax": [
        "g3"
    ],
    "image/gif": [
        "gif"
    ],
    "image/heic": [
        "heic"
    ],
    "image/heic-sequence": [
        "heics"
    ],
    "image/heif": [
        "heif"
    ],
    "image/heif-sequence": [
        "heifs"
    ],
    "image/hej2k": [
        "hej2"
    ],
    "image/hsj2": [
        "hsj2"
    ],
    "image/ief": [
        "ief"
    ],
    "image/jls": [
        "jls"
    ],
    "image/jp2": [
        "jp2",
        "jpg2"
    ],
    "image/jpeg": [
        "jpeg",
        "jpg",
        "jpe"
    ],
    "image/jph": [
        "jph"
    ],
    "image/jphc": [
        "jhc"
    ],
    "image/jpm": [
        "jpm"
    ],
    "image/jpx": [
        "jpx",
        "jpf"
    ],
    "image/jxr": [
        "jxr"
    ],
    "image/jxra": [
        "jxra"
    ],
    "image/jxrs": [
        "jxrs"
    ],
    "image/jxs": [
        "jxs"
    ],
    "image/jxsc": [
        "jxsc"
    ],
    "image/jxsi": [
        "jxsi"
    ],
    "image/jxss": [
        "jxss"
    ],
    "image/ktx": [
        "ktx"
    ],
    "image/ktx2": [
        "ktx2"
    ],
    "image/png": [
        "png"
    ],
    "image/sgi": [
        "sgi"
    ],
    "image/svg+xml": [
        "svg",
        "svgz"
    ],
    "image/t38": [
        "t38"
    ],
    "image/tiff": [
        "tif",
        "tiff"
    ],
    "image/tiff-fx": [
        "tfx"
    ],
    "image/webp": [
        "webp"
    ],
    "image/wmf": [
        "wmf"
    ],
    "message/disposition-notification": [
        "disposition-notification"
    ],
    "message/global": [
        "u8msg"
    ],
    "message/global-delivery-status": [
        "u8dsn"
    ],
    "message/global-disposition-notification": [
        "u8mdn"
    ],
    "message/global-headers": [
        "u8hdr"
    ],
    "message/rfc822": [
        "eml",
        "mime"
    ],
    "model/3mf": [
        "3mf"
    ],
    "model/gltf+json": [
        "gltf"
    ],
    "model/gltf-binary": [
        "glb"
    ],
    "model/iges": [
        "igs",
        "iges"
    ],
    "model/mesh": [
        "msh",
        "mesh",
        "silo"
    ],
    "model/mtl": [
        "mtl"
    ],
    "model/obj": [
        "obj"
    ],
    "model/step+xml": [
        "stpx"
    ],
    "model/step+zip": [
        "stpz"
    ],
    "model/step-xml+zip": [
        "stpxz"
    ],
    "model/stl": [
        "stl"
    ],
    "model/vrml": [
        "wrl",
        "vrml"
    ],
    "model/x3d+binary": [
        "*x3db",
        "x3dbz"
    ],
    "model/x3d+fastinfoset": [
        "x3db"
    ],
    "model/x3d+vrml": [
        "*x3dv",
        "x3dvz"
    ],
    "model/x3d+xml": [
        "x3d",
        "x3dz"
    ],
    "model/x3d-vrml": [
        "x3dv"
    ],
    "text/cache-manifest": [
        "appcache",
        "manifest"
    ],
    "text/calendar": [
        "ics",
        "ifb"
    ],
    "text/coffeescript": [
        "coffee",
        "litcoffee"
    ],
    "text/css": [
        "css"
    ],
    "text/csv": [
        "csv"
    ],
    "text/html": [
        "html",
        "htm",
        "shtml"
    ],
    "text/jade": [
        "jade"
    ],
    "text/jsx": [
        "jsx"
    ],
    "text/less": [
        "less"
    ],
    "text/markdown": [
        "markdown",
        "md"
    ],
    "text/mathml": [
        "mml"
    ],
    "text/mdx": [
        "mdx"
    ],
    "text/n3": [
        "n3"
    ],
    "text/plain": [
        "txt",
        "text",
        "conf",
        "def",
        "list",
        "log",
        "in",
        "ini"
    ],
    "text/richtext": [
        "rtx"
    ],
    "text/rtf": [
        "*rtf"
    ],
    "text/sgml": [
        "sgml",
        "sgm"
    ],
    "text/shex": [
        "shex"
    ],
    "text/slim": [
        "slim",
        "slm"
    ],
    "text/spdx": [
        "spdx"
    ],
    "text/stylus": [
        "stylus",
        "styl"
    ],
    "text/tab-separated-values": [
        "tsv"
    ],
    "text/troff": [
        "t",
        "tr",
        "roff",
        "man",
        "me",
        "ms"
    ],
    "text/turtle": [
        "ttl"
    ],
    "text/uri-list": [
        "uri",
        "uris",
        "urls"
    ],
    "text/vcard": [
        "vcard"
    ],
    "text/vtt": [
        "vtt"
    ],
    "text/xml": [
        "*xml"
    ],
    "text/yaml": [
        "yaml",
        "yml"
    ],
    "video/3gpp": [
        "3gp",
        "3gpp"
    ],
    "video/3gpp2": [
        "3g2"
    ],
    "video/h261": [
        "h261"
    ],
    "video/h263": [
        "h263"
    ],
    "video/h264": [
        "h264"
    ],
    "video/iso.segment": [
        "m4s"
    ],
    "video/jpeg": [
        "jpgv"
    ],
    "video/jpm": [
        "*jpm",
        "jpgm"
    ],
    "video/mj2": [
        "mj2",
        "mjp2"
    ],
    "video/mp2t": [
        "ts"
    ],
    "video/mp4": [
        "mp4",
        "mp4v",
        "mpg4"
    ],
    "video/mpeg": [
        "mpeg",
        "mpg",
        "mpe",
        "m1v",
        "m2v"
    ],
    "video/ogg": [
        "ogv"
    ],
    "video/quicktime": [
        "qt",
        "mov"
    ],
    "video/webm": [
        "webm"
    ]
};

});

parcelRequire.register("1doyX", function(module, exports) {
module.exports = {
    "application/prs.cww": [
        "cww"
    ],
    "application/vnd.1000minds.decision-model+xml": [
        "1km"
    ],
    "application/vnd.3gpp.pic-bw-large": [
        "plb"
    ],
    "application/vnd.3gpp.pic-bw-small": [
        "psb"
    ],
    "application/vnd.3gpp.pic-bw-var": [
        "pvb"
    ],
    "application/vnd.3gpp2.tcap": [
        "tcap"
    ],
    "application/vnd.3m.post-it-notes": [
        "pwn"
    ],
    "application/vnd.accpac.simply.aso": [
        "aso"
    ],
    "application/vnd.accpac.simply.imp": [
        "imp"
    ],
    "application/vnd.acucobol": [
        "acu"
    ],
    "application/vnd.acucorp": [
        "atc",
        "acutc"
    ],
    "application/vnd.adobe.air-application-installer-package+zip": [
        "air"
    ],
    "application/vnd.adobe.formscentral.fcdt": [
        "fcdt"
    ],
    "application/vnd.adobe.fxp": [
        "fxp",
        "fxpl"
    ],
    "application/vnd.adobe.xdp+xml": [
        "xdp"
    ],
    "application/vnd.adobe.xfdf": [
        "xfdf"
    ],
    "application/vnd.ahead.space": [
        "ahead"
    ],
    "application/vnd.airzip.filesecure.azf": [
        "azf"
    ],
    "application/vnd.airzip.filesecure.azs": [
        "azs"
    ],
    "application/vnd.amazon.ebook": [
        "azw"
    ],
    "application/vnd.americandynamics.acc": [
        "acc"
    ],
    "application/vnd.amiga.ami": [
        "ami"
    ],
    "application/vnd.android.package-archive": [
        "apk"
    ],
    "application/vnd.anser-web-certificate-issue-initiation": [
        "cii"
    ],
    "application/vnd.anser-web-funds-transfer-initiation": [
        "fti"
    ],
    "application/vnd.antix.game-component": [
        "atx"
    ],
    "application/vnd.apple.installer+xml": [
        "mpkg"
    ],
    "application/vnd.apple.keynote": [
        "key"
    ],
    "application/vnd.apple.mpegurl": [
        "m3u8"
    ],
    "application/vnd.apple.numbers": [
        "numbers"
    ],
    "application/vnd.apple.pages": [
        "pages"
    ],
    "application/vnd.apple.pkpass": [
        "pkpass"
    ],
    "application/vnd.aristanetworks.swi": [
        "swi"
    ],
    "application/vnd.astraea-software.iota": [
        "iota"
    ],
    "application/vnd.audiograph": [
        "aep"
    ],
    "application/vnd.balsamiq.bmml+xml": [
        "bmml"
    ],
    "application/vnd.blueice.multipass": [
        "mpm"
    ],
    "application/vnd.bmi": [
        "bmi"
    ],
    "application/vnd.businessobjects": [
        "rep"
    ],
    "application/vnd.chemdraw+xml": [
        "cdxml"
    ],
    "application/vnd.chipnuts.karaoke-mmd": [
        "mmd"
    ],
    "application/vnd.cinderella": [
        "cdy"
    ],
    "application/vnd.citationstyles.style+xml": [
        "csl"
    ],
    "application/vnd.claymore": [
        "cla"
    ],
    "application/vnd.cloanto.rp9": [
        "rp9"
    ],
    "application/vnd.clonk.c4group": [
        "c4g",
        "c4d",
        "c4f",
        "c4p",
        "c4u"
    ],
    "application/vnd.cluetrust.cartomobile-config": [
        "c11amc"
    ],
    "application/vnd.cluetrust.cartomobile-config-pkg": [
        "c11amz"
    ],
    "application/vnd.commonspace": [
        "csp"
    ],
    "application/vnd.contact.cmsg": [
        "cdbcmsg"
    ],
    "application/vnd.cosmocaller": [
        "cmc"
    ],
    "application/vnd.crick.clicker": [
        "clkx"
    ],
    "application/vnd.crick.clicker.keyboard": [
        "clkk"
    ],
    "application/vnd.crick.clicker.palette": [
        "clkp"
    ],
    "application/vnd.crick.clicker.template": [
        "clkt"
    ],
    "application/vnd.crick.clicker.wordbank": [
        "clkw"
    ],
    "application/vnd.criticaltools.wbs+xml": [
        "wbs"
    ],
    "application/vnd.ctc-posml": [
        "pml"
    ],
    "application/vnd.cups-ppd": [
        "ppd"
    ],
    "application/vnd.curl.car": [
        "car"
    ],
    "application/vnd.curl.pcurl": [
        "pcurl"
    ],
    "application/vnd.dart": [
        "dart"
    ],
    "application/vnd.data-vision.rdz": [
        "rdz"
    ],
    "application/vnd.dbf": [
        "dbf"
    ],
    "application/vnd.dece.data": [
        "uvf",
        "uvvf",
        "uvd",
        "uvvd"
    ],
    "application/vnd.dece.ttml+xml": [
        "uvt",
        "uvvt"
    ],
    "application/vnd.dece.unspecified": [
        "uvx",
        "uvvx"
    ],
    "application/vnd.dece.zip": [
        "uvz",
        "uvvz"
    ],
    "application/vnd.denovo.fcselayout-link": [
        "fe_launch"
    ],
    "application/vnd.dna": [
        "dna"
    ],
    "application/vnd.dolby.mlp": [
        "mlp"
    ],
    "application/vnd.dpgraph": [
        "dpg"
    ],
    "application/vnd.dreamfactory": [
        "dfac"
    ],
    "application/vnd.ds-keypoint": [
        "kpxx"
    ],
    "application/vnd.dvb.ait": [
        "ait"
    ],
    "application/vnd.dvb.service": [
        "svc"
    ],
    "application/vnd.dynageo": [
        "geo"
    ],
    "application/vnd.ecowin.chart": [
        "mag"
    ],
    "application/vnd.enliven": [
        "nml"
    ],
    "application/vnd.epson.esf": [
        "esf"
    ],
    "application/vnd.epson.msf": [
        "msf"
    ],
    "application/vnd.epson.quickanime": [
        "qam"
    ],
    "application/vnd.epson.salt": [
        "slt"
    ],
    "application/vnd.epson.ssf": [
        "ssf"
    ],
    "application/vnd.eszigno3+xml": [
        "es3",
        "et3"
    ],
    "application/vnd.ezpix-album": [
        "ez2"
    ],
    "application/vnd.ezpix-package": [
        "ez3"
    ],
    "application/vnd.fdf": [
        "fdf"
    ],
    "application/vnd.fdsn.mseed": [
        "mseed"
    ],
    "application/vnd.fdsn.seed": [
        "seed",
        "dataless"
    ],
    "application/vnd.flographit": [
        "gph"
    ],
    "application/vnd.fluxtime.clip": [
        "ftc"
    ],
    "application/vnd.framemaker": [
        "fm",
        "frame",
        "maker",
        "book"
    ],
    "application/vnd.frogans.fnc": [
        "fnc"
    ],
    "application/vnd.frogans.ltf": [
        "ltf"
    ],
    "application/vnd.fsc.weblaunch": [
        "fsc"
    ],
    "application/vnd.fujitsu.oasys": [
        "oas"
    ],
    "application/vnd.fujitsu.oasys2": [
        "oa2"
    ],
    "application/vnd.fujitsu.oasys3": [
        "oa3"
    ],
    "application/vnd.fujitsu.oasysgp": [
        "fg5"
    ],
    "application/vnd.fujitsu.oasysprs": [
        "bh2"
    ],
    "application/vnd.fujixerox.ddd": [
        "ddd"
    ],
    "application/vnd.fujixerox.docuworks": [
        "xdw"
    ],
    "application/vnd.fujixerox.docuworks.binder": [
        "xbd"
    ],
    "application/vnd.fuzzysheet": [
        "fzs"
    ],
    "application/vnd.genomatix.tuxedo": [
        "txd"
    ],
    "application/vnd.geogebra.file": [
        "ggb"
    ],
    "application/vnd.geogebra.tool": [
        "ggt"
    ],
    "application/vnd.geometry-explorer": [
        "gex",
        "gre"
    ],
    "application/vnd.geonext": [
        "gxt"
    ],
    "application/vnd.geoplan": [
        "g2w"
    ],
    "application/vnd.geospace": [
        "g3w"
    ],
    "application/vnd.gmx": [
        "gmx"
    ],
    "application/vnd.google-apps.document": [
        "gdoc"
    ],
    "application/vnd.google-apps.presentation": [
        "gslides"
    ],
    "application/vnd.google-apps.spreadsheet": [
        "gsheet"
    ],
    "application/vnd.google-earth.kml+xml": [
        "kml"
    ],
    "application/vnd.google-earth.kmz": [
        "kmz"
    ],
    "application/vnd.grafeq": [
        "gqf",
        "gqs"
    ],
    "application/vnd.groove-account": [
        "gac"
    ],
    "application/vnd.groove-help": [
        "ghf"
    ],
    "application/vnd.groove-identity-message": [
        "gim"
    ],
    "application/vnd.groove-injector": [
        "grv"
    ],
    "application/vnd.groove-tool-message": [
        "gtm"
    ],
    "application/vnd.groove-tool-template": [
        "tpl"
    ],
    "application/vnd.groove-vcard": [
        "vcg"
    ],
    "application/vnd.hal+xml": [
        "hal"
    ],
    "application/vnd.handheld-entertainment+xml": [
        "zmm"
    ],
    "application/vnd.hbci": [
        "hbci"
    ],
    "application/vnd.hhe.lesson-player": [
        "les"
    ],
    "application/vnd.hp-hpgl": [
        "hpgl"
    ],
    "application/vnd.hp-hpid": [
        "hpid"
    ],
    "application/vnd.hp-hps": [
        "hps"
    ],
    "application/vnd.hp-jlyt": [
        "jlt"
    ],
    "application/vnd.hp-pcl": [
        "pcl"
    ],
    "application/vnd.hp-pclxl": [
        "pclxl"
    ],
    "application/vnd.hydrostatix.sof-data": [
        "sfd-hdstx"
    ],
    "application/vnd.ibm.minipay": [
        "mpy"
    ],
    "application/vnd.ibm.modcap": [
        "afp",
        "listafp",
        "list3820"
    ],
    "application/vnd.ibm.rights-management": [
        "irm"
    ],
    "application/vnd.ibm.secure-container": [
        "sc"
    ],
    "application/vnd.iccprofile": [
        "icc",
        "icm"
    ],
    "application/vnd.igloader": [
        "igl"
    ],
    "application/vnd.immervision-ivp": [
        "ivp"
    ],
    "application/vnd.immervision-ivu": [
        "ivu"
    ],
    "application/vnd.insors.igm": [
        "igm"
    ],
    "application/vnd.intercon.formnet": [
        "xpw",
        "xpx"
    ],
    "application/vnd.intergeo": [
        "i2g"
    ],
    "application/vnd.intu.qbo": [
        "qbo"
    ],
    "application/vnd.intu.qfx": [
        "qfx"
    ],
    "application/vnd.ipunplugged.rcprofile": [
        "rcprofile"
    ],
    "application/vnd.irepository.package+xml": [
        "irp"
    ],
    "application/vnd.is-xpr": [
        "xpr"
    ],
    "application/vnd.isac.fcs": [
        "fcs"
    ],
    "application/vnd.jam": [
        "jam"
    ],
    "application/vnd.jcp.javame.midlet-rms": [
        "rms"
    ],
    "application/vnd.jisp": [
        "jisp"
    ],
    "application/vnd.joost.joda-archive": [
        "joda"
    ],
    "application/vnd.kahootz": [
        "ktz",
        "ktr"
    ],
    "application/vnd.kde.karbon": [
        "karbon"
    ],
    "application/vnd.kde.kchart": [
        "chrt"
    ],
    "application/vnd.kde.kformula": [
        "kfo"
    ],
    "application/vnd.kde.kivio": [
        "flw"
    ],
    "application/vnd.kde.kontour": [
        "kon"
    ],
    "application/vnd.kde.kpresenter": [
        "kpr",
        "kpt"
    ],
    "application/vnd.kde.kspread": [
        "ksp"
    ],
    "application/vnd.kde.kword": [
        "kwd",
        "kwt"
    ],
    "application/vnd.kenameaapp": [
        "htke"
    ],
    "application/vnd.kidspiration": [
        "kia"
    ],
    "application/vnd.kinar": [
        "kne",
        "knp"
    ],
    "application/vnd.koan": [
        "skp",
        "skd",
        "skt",
        "skm"
    ],
    "application/vnd.kodak-descriptor": [
        "sse"
    ],
    "application/vnd.las.las+xml": [
        "lasxml"
    ],
    "application/vnd.llamagraphics.life-balance.desktop": [
        "lbd"
    ],
    "application/vnd.llamagraphics.life-balance.exchange+xml": [
        "lbe"
    ],
    "application/vnd.lotus-1-2-3": [
        "123"
    ],
    "application/vnd.lotus-approach": [
        "apr"
    ],
    "application/vnd.lotus-freelance": [
        "pre"
    ],
    "application/vnd.lotus-notes": [
        "nsf"
    ],
    "application/vnd.lotus-organizer": [
        "org"
    ],
    "application/vnd.lotus-screencam": [
        "scm"
    ],
    "application/vnd.lotus-wordpro": [
        "lwp"
    ],
    "application/vnd.macports.portpkg": [
        "portpkg"
    ],
    "application/vnd.mapbox-vector-tile": [
        "mvt"
    ],
    "application/vnd.mcd": [
        "mcd"
    ],
    "application/vnd.medcalcdata": [
        "mc1"
    ],
    "application/vnd.mediastation.cdkey": [
        "cdkey"
    ],
    "application/vnd.mfer": [
        "mwf"
    ],
    "application/vnd.mfmp": [
        "mfm"
    ],
    "application/vnd.micrografx.flo": [
        "flo"
    ],
    "application/vnd.micrografx.igx": [
        "igx"
    ],
    "application/vnd.mif": [
        "mif"
    ],
    "application/vnd.mobius.daf": [
        "daf"
    ],
    "application/vnd.mobius.dis": [
        "dis"
    ],
    "application/vnd.mobius.mbk": [
        "mbk"
    ],
    "application/vnd.mobius.mqy": [
        "mqy"
    ],
    "application/vnd.mobius.msl": [
        "msl"
    ],
    "application/vnd.mobius.plc": [
        "plc"
    ],
    "application/vnd.mobius.txf": [
        "txf"
    ],
    "application/vnd.mophun.application": [
        "mpn"
    ],
    "application/vnd.mophun.certificate": [
        "mpc"
    ],
    "application/vnd.mozilla.xul+xml": [
        "xul"
    ],
    "application/vnd.ms-artgalry": [
        "cil"
    ],
    "application/vnd.ms-cab-compressed": [
        "cab"
    ],
    "application/vnd.ms-excel": [
        "xls",
        "xlm",
        "xla",
        "xlc",
        "xlt",
        "xlw"
    ],
    "application/vnd.ms-excel.addin.macroenabled.12": [
        "xlam"
    ],
    "application/vnd.ms-excel.sheet.binary.macroenabled.12": [
        "xlsb"
    ],
    "application/vnd.ms-excel.sheet.macroenabled.12": [
        "xlsm"
    ],
    "application/vnd.ms-excel.template.macroenabled.12": [
        "xltm"
    ],
    "application/vnd.ms-fontobject": [
        "eot"
    ],
    "application/vnd.ms-htmlhelp": [
        "chm"
    ],
    "application/vnd.ms-ims": [
        "ims"
    ],
    "application/vnd.ms-lrm": [
        "lrm"
    ],
    "application/vnd.ms-officetheme": [
        "thmx"
    ],
    "application/vnd.ms-outlook": [
        "msg"
    ],
    "application/vnd.ms-pki.seccat": [
        "cat"
    ],
    "application/vnd.ms-pki.stl": [
        "*stl"
    ],
    "application/vnd.ms-powerpoint": [
        "ppt",
        "pps",
        "pot"
    ],
    "application/vnd.ms-powerpoint.addin.macroenabled.12": [
        "ppam"
    ],
    "application/vnd.ms-powerpoint.presentation.macroenabled.12": [
        "pptm"
    ],
    "application/vnd.ms-powerpoint.slide.macroenabled.12": [
        "sldm"
    ],
    "application/vnd.ms-powerpoint.slideshow.macroenabled.12": [
        "ppsm"
    ],
    "application/vnd.ms-powerpoint.template.macroenabled.12": [
        "potm"
    ],
    "application/vnd.ms-project": [
        "mpp",
        "mpt"
    ],
    "application/vnd.ms-word.document.macroenabled.12": [
        "docm"
    ],
    "application/vnd.ms-word.template.macroenabled.12": [
        "dotm"
    ],
    "application/vnd.ms-works": [
        "wps",
        "wks",
        "wcm",
        "wdb"
    ],
    "application/vnd.ms-wpl": [
        "wpl"
    ],
    "application/vnd.ms-xpsdocument": [
        "xps"
    ],
    "application/vnd.mseq": [
        "mseq"
    ],
    "application/vnd.musician": [
        "mus"
    ],
    "application/vnd.muvee.style": [
        "msty"
    ],
    "application/vnd.mynfc": [
        "taglet"
    ],
    "application/vnd.neurolanguage.nlu": [
        "nlu"
    ],
    "application/vnd.nitf": [
        "ntf",
        "nitf"
    ],
    "application/vnd.noblenet-directory": [
        "nnd"
    ],
    "application/vnd.noblenet-sealer": [
        "nns"
    ],
    "application/vnd.noblenet-web": [
        "nnw"
    ],
    "application/vnd.nokia.n-gage.ac+xml": [
        "*ac"
    ],
    "application/vnd.nokia.n-gage.data": [
        "ngdat"
    ],
    "application/vnd.nokia.n-gage.symbian.install": [
        "n-gage"
    ],
    "application/vnd.nokia.radio-preset": [
        "rpst"
    ],
    "application/vnd.nokia.radio-presets": [
        "rpss"
    ],
    "application/vnd.novadigm.edm": [
        "edm"
    ],
    "application/vnd.novadigm.edx": [
        "edx"
    ],
    "application/vnd.novadigm.ext": [
        "ext"
    ],
    "application/vnd.oasis.opendocument.chart": [
        "odc"
    ],
    "application/vnd.oasis.opendocument.chart-template": [
        "otc"
    ],
    "application/vnd.oasis.opendocument.database": [
        "odb"
    ],
    "application/vnd.oasis.opendocument.formula": [
        "odf"
    ],
    "application/vnd.oasis.opendocument.formula-template": [
        "odft"
    ],
    "application/vnd.oasis.opendocument.graphics": [
        "odg"
    ],
    "application/vnd.oasis.opendocument.graphics-template": [
        "otg"
    ],
    "application/vnd.oasis.opendocument.image": [
        "odi"
    ],
    "application/vnd.oasis.opendocument.image-template": [
        "oti"
    ],
    "application/vnd.oasis.opendocument.presentation": [
        "odp"
    ],
    "application/vnd.oasis.opendocument.presentation-template": [
        "otp"
    ],
    "application/vnd.oasis.opendocument.spreadsheet": [
        "ods"
    ],
    "application/vnd.oasis.opendocument.spreadsheet-template": [
        "ots"
    ],
    "application/vnd.oasis.opendocument.text": [
        "odt"
    ],
    "application/vnd.oasis.opendocument.text-master": [
        "odm"
    ],
    "application/vnd.oasis.opendocument.text-template": [
        "ott"
    ],
    "application/vnd.oasis.opendocument.text-web": [
        "oth"
    ],
    "application/vnd.olpc-sugar": [
        "xo"
    ],
    "application/vnd.oma.dd2+xml": [
        "dd2"
    ],
    "application/vnd.openblox.game+xml": [
        "obgx"
    ],
    "application/vnd.openofficeorg.extension": [
        "oxt"
    ],
    "application/vnd.openstreetmap.data+xml": [
        "osm"
    ],
    "application/vnd.openxmlformats-officedocument.presentationml.presentation": [
        "pptx"
    ],
    "application/vnd.openxmlformats-officedocument.presentationml.slide": [
        "sldx"
    ],
    "application/vnd.openxmlformats-officedocument.presentationml.slideshow": [
        "ppsx"
    ],
    "application/vnd.openxmlformats-officedocument.presentationml.template": [
        "potx"
    ],
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": [
        "xlsx"
    ],
    "application/vnd.openxmlformats-officedocument.spreadsheetml.template": [
        "xltx"
    ],
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document": [
        "docx"
    ],
    "application/vnd.openxmlformats-officedocument.wordprocessingml.template": [
        "dotx"
    ],
    "application/vnd.osgeo.mapguide.package": [
        "mgp"
    ],
    "application/vnd.osgi.dp": [
        "dp"
    ],
    "application/vnd.osgi.subsystem": [
        "esa"
    ],
    "application/vnd.palm": [
        "pdb",
        "pqa",
        "oprc"
    ],
    "application/vnd.pawaafile": [
        "paw"
    ],
    "application/vnd.pg.format": [
        "str"
    ],
    "application/vnd.pg.osasli": [
        "ei6"
    ],
    "application/vnd.picsel": [
        "efif"
    ],
    "application/vnd.pmi.widget": [
        "wg"
    ],
    "application/vnd.pocketlearn": [
        "plf"
    ],
    "application/vnd.powerbuilder6": [
        "pbd"
    ],
    "application/vnd.previewsystems.box": [
        "box"
    ],
    "application/vnd.proteus.magazine": [
        "mgz"
    ],
    "application/vnd.publishare-delta-tree": [
        "qps"
    ],
    "application/vnd.pvi.ptid1": [
        "ptid"
    ],
    "application/vnd.quark.quarkxpress": [
        "qxd",
        "qxt",
        "qwd",
        "qwt",
        "qxl",
        "qxb"
    ],
    "application/vnd.rar": [
        "rar"
    ],
    "application/vnd.realvnc.bed": [
        "bed"
    ],
    "application/vnd.recordare.musicxml": [
        "mxl"
    ],
    "application/vnd.recordare.musicxml+xml": [
        "musicxml"
    ],
    "application/vnd.rig.cryptonote": [
        "cryptonote"
    ],
    "application/vnd.rim.cod": [
        "cod"
    ],
    "application/vnd.rn-realmedia": [
        "rm"
    ],
    "application/vnd.rn-realmedia-vbr": [
        "rmvb"
    ],
    "application/vnd.route66.link66+xml": [
        "link66"
    ],
    "application/vnd.sailingtracker.track": [
        "st"
    ],
    "application/vnd.seemail": [
        "see"
    ],
    "application/vnd.sema": [
        "sema"
    ],
    "application/vnd.semd": [
        "semd"
    ],
    "application/vnd.semf": [
        "semf"
    ],
    "application/vnd.shana.informed.formdata": [
        "ifm"
    ],
    "application/vnd.shana.informed.formtemplate": [
        "itp"
    ],
    "application/vnd.shana.informed.interchange": [
        "iif"
    ],
    "application/vnd.shana.informed.package": [
        "ipk"
    ],
    "application/vnd.simtech-mindmapper": [
        "twd",
        "twds"
    ],
    "application/vnd.smaf": [
        "mmf"
    ],
    "application/vnd.smart.teacher": [
        "teacher"
    ],
    "application/vnd.software602.filler.form+xml": [
        "fo"
    ],
    "application/vnd.solent.sdkm+xml": [
        "sdkm",
        "sdkd"
    ],
    "application/vnd.spotfire.dxp": [
        "dxp"
    ],
    "application/vnd.spotfire.sfs": [
        "sfs"
    ],
    "application/vnd.stardivision.calc": [
        "sdc"
    ],
    "application/vnd.stardivision.draw": [
        "sda"
    ],
    "application/vnd.stardivision.impress": [
        "sdd"
    ],
    "application/vnd.stardivision.math": [
        "smf"
    ],
    "application/vnd.stardivision.writer": [
        "sdw",
        "vor"
    ],
    "application/vnd.stardivision.writer-global": [
        "sgl"
    ],
    "application/vnd.stepmania.package": [
        "smzip"
    ],
    "application/vnd.stepmania.stepchart": [
        "sm"
    ],
    "application/vnd.sun.wadl+xml": [
        "wadl"
    ],
    "application/vnd.sun.xml.calc": [
        "sxc"
    ],
    "application/vnd.sun.xml.calc.template": [
        "stc"
    ],
    "application/vnd.sun.xml.draw": [
        "sxd"
    ],
    "application/vnd.sun.xml.draw.template": [
        "std"
    ],
    "application/vnd.sun.xml.impress": [
        "sxi"
    ],
    "application/vnd.sun.xml.impress.template": [
        "sti"
    ],
    "application/vnd.sun.xml.math": [
        "sxm"
    ],
    "application/vnd.sun.xml.writer": [
        "sxw"
    ],
    "application/vnd.sun.xml.writer.global": [
        "sxg"
    ],
    "application/vnd.sun.xml.writer.template": [
        "stw"
    ],
    "application/vnd.sus-calendar": [
        "sus",
        "susp"
    ],
    "application/vnd.svd": [
        "svd"
    ],
    "application/vnd.symbian.install": [
        "sis",
        "sisx"
    ],
    "application/vnd.syncml+xml": [
        "xsm"
    ],
    "application/vnd.syncml.dm+wbxml": [
        "bdm"
    ],
    "application/vnd.syncml.dm+xml": [
        "xdm"
    ],
    "application/vnd.syncml.dmddf+xml": [
        "ddf"
    ],
    "application/vnd.tao.intent-module-archive": [
        "tao"
    ],
    "application/vnd.tcpdump.pcap": [
        "pcap",
        "cap",
        "dmp"
    ],
    "application/vnd.tmobile-livetv": [
        "tmo"
    ],
    "application/vnd.trid.tpt": [
        "tpt"
    ],
    "application/vnd.triscape.mxs": [
        "mxs"
    ],
    "application/vnd.trueapp": [
        "tra"
    ],
    "application/vnd.ufdl": [
        "ufd",
        "ufdl"
    ],
    "application/vnd.uiq.theme": [
        "utz"
    ],
    "application/vnd.umajin": [
        "umj"
    ],
    "application/vnd.unity": [
        "unityweb"
    ],
    "application/vnd.uoml+xml": [
        "uoml"
    ],
    "application/vnd.vcx": [
        "vcx"
    ],
    "application/vnd.visio": [
        "vsd",
        "vst",
        "vss",
        "vsw"
    ],
    "application/vnd.visionary": [
        "vis"
    ],
    "application/vnd.vsf": [
        "vsf"
    ],
    "application/vnd.wap.wbxml": [
        "wbxml"
    ],
    "application/vnd.wap.wmlc": [
        "wmlc"
    ],
    "application/vnd.wap.wmlscriptc": [
        "wmlsc"
    ],
    "application/vnd.webturbo": [
        "wtb"
    ],
    "application/vnd.wolfram.player": [
        "nbp"
    ],
    "application/vnd.wordperfect": [
        "wpd"
    ],
    "application/vnd.wqd": [
        "wqd"
    ],
    "application/vnd.wt.stf": [
        "stf"
    ],
    "application/vnd.xara": [
        "xar"
    ],
    "application/vnd.xfdl": [
        "xfdl"
    ],
    "application/vnd.yamaha.hv-dic": [
        "hvd"
    ],
    "application/vnd.yamaha.hv-script": [
        "hvs"
    ],
    "application/vnd.yamaha.hv-voice": [
        "hvp"
    ],
    "application/vnd.yamaha.openscoreformat": [
        "osf"
    ],
    "application/vnd.yamaha.openscoreformat.osfpvg+xml": [
        "osfpvg"
    ],
    "application/vnd.yamaha.smaf-audio": [
        "saf"
    ],
    "application/vnd.yamaha.smaf-phrase": [
        "spf"
    ],
    "application/vnd.yellowriver-custom-menu": [
        "cmp"
    ],
    "application/vnd.zul": [
        "zir",
        "zirz"
    ],
    "application/vnd.zzazz.deck+xml": [
        "zaz"
    ],
    "application/x-7z-compressed": [
        "7z"
    ],
    "application/x-abiword": [
        "abw"
    ],
    "application/x-ace-compressed": [
        "ace"
    ],
    "application/x-apple-diskimage": [
        "*dmg"
    ],
    "application/x-arj": [
        "arj"
    ],
    "application/x-authorware-bin": [
        "aab",
        "x32",
        "u32",
        "vox"
    ],
    "application/x-authorware-map": [
        "aam"
    ],
    "application/x-authorware-seg": [
        "aas"
    ],
    "application/x-bcpio": [
        "bcpio"
    ],
    "application/x-bdoc": [
        "*bdoc"
    ],
    "application/x-bittorrent": [
        "torrent"
    ],
    "application/x-blorb": [
        "blb",
        "blorb"
    ],
    "application/x-bzip": [
        "bz"
    ],
    "application/x-bzip2": [
        "bz2",
        "boz"
    ],
    "application/x-cbr": [
        "cbr",
        "cba",
        "cbt",
        "cbz",
        "cb7"
    ],
    "application/x-cdlink": [
        "vcd"
    ],
    "application/x-cfs-compressed": [
        "cfs"
    ],
    "application/x-chat": [
        "chat"
    ],
    "application/x-chess-pgn": [
        "pgn"
    ],
    "application/x-chrome-extension": [
        "crx"
    ],
    "application/x-cocoa": [
        "cco"
    ],
    "application/x-conference": [
        "nsc"
    ],
    "application/x-cpio": [
        "cpio"
    ],
    "application/x-csh": [
        "csh"
    ],
    "application/x-debian-package": [
        "*deb",
        "udeb"
    ],
    "application/x-dgc-compressed": [
        "dgc"
    ],
    "application/x-director": [
        "dir",
        "dcr",
        "dxr",
        "cst",
        "cct",
        "cxt",
        "w3d",
        "fgd",
        "swa"
    ],
    "application/x-doom": [
        "wad"
    ],
    "application/x-dtbncx+xml": [
        "ncx"
    ],
    "application/x-dtbook+xml": [
        "dtb"
    ],
    "application/x-dtbresource+xml": [
        "res"
    ],
    "application/x-dvi": [
        "dvi"
    ],
    "application/x-envoy": [
        "evy"
    ],
    "application/x-eva": [
        "eva"
    ],
    "application/x-font-bdf": [
        "bdf"
    ],
    "application/x-font-ghostscript": [
        "gsf"
    ],
    "application/x-font-linux-psf": [
        "psf"
    ],
    "application/x-font-pcf": [
        "pcf"
    ],
    "application/x-font-snf": [
        "snf"
    ],
    "application/x-font-type1": [
        "pfa",
        "pfb",
        "pfm",
        "afm"
    ],
    "application/x-freearc": [
        "arc"
    ],
    "application/x-futuresplash": [
        "spl"
    ],
    "application/x-gca-compressed": [
        "gca"
    ],
    "application/x-glulx": [
        "ulx"
    ],
    "application/x-gnumeric": [
        "gnumeric"
    ],
    "application/x-gramps-xml": [
        "gramps"
    ],
    "application/x-gtar": [
        "gtar"
    ],
    "application/x-hdf": [
        "hdf"
    ],
    "application/x-httpd-php": [
        "php"
    ],
    "application/x-install-instructions": [
        "install"
    ],
    "application/x-iso9660-image": [
        "*iso"
    ],
    "application/x-iwork-keynote-sffkey": [
        "*key"
    ],
    "application/x-iwork-numbers-sffnumbers": [
        "*numbers"
    ],
    "application/x-iwork-pages-sffpages": [
        "*pages"
    ],
    "application/x-java-archive-diff": [
        "jardiff"
    ],
    "application/x-java-jnlp-file": [
        "jnlp"
    ],
    "application/x-keepass2": [
        "kdbx"
    ],
    "application/x-latex": [
        "latex"
    ],
    "application/x-lua-bytecode": [
        "luac"
    ],
    "application/x-lzh-compressed": [
        "lzh",
        "lha"
    ],
    "application/x-makeself": [
        "run"
    ],
    "application/x-mie": [
        "mie"
    ],
    "application/x-mobipocket-ebook": [
        "prc",
        "mobi"
    ],
    "application/x-ms-application": [
        "application"
    ],
    "application/x-ms-shortcut": [
        "lnk"
    ],
    "application/x-ms-wmd": [
        "wmd"
    ],
    "application/x-ms-wmz": [
        "wmz"
    ],
    "application/x-ms-xbap": [
        "xbap"
    ],
    "application/x-msaccess": [
        "mdb"
    ],
    "application/x-msbinder": [
        "obd"
    ],
    "application/x-mscardfile": [
        "crd"
    ],
    "application/x-msclip": [
        "clp"
    ],
    "application/x-msdos-program": [
        "*exe"
    ],
    "application/x-msdownload": [
        "*exe",
        "*dll",
        "com",
        "bat",
        "*msi"
    ],
    "application/x-msmediaview": [
        "mvb",
        "m13",
        "m14"
    ],
    "application/x-msmetafile": [
        "*wmf",
        "*wmz",
        "*emf",
        "emz"
    ],
    "application/x-msmoney": [
        "mny"
    ],
    "application/x-mspublisher": [
        "pub"
    ],
    "application/x-msschedule": [
        "scd"
    ],
    "application/x-msterminal": [
        "trm"
    ],
    "application/x-mswrite": [
        "wri"
    ],
    "application/x-netcdf": [
        "nc",
        "cdf"
    ],
    "application/x-ns-proxy-autoconfig": [
        "pac"
    ],
    "application/x-nzb": [
        "nzb"
    ],
    "application/x-perl": [
        "pl",
        "pm"
    ],
    "application/x-pilot": [
        "*prc",
        "*pdb"
    ],
    "application/x-pkcs12": [
        "p12",
        "pfx"
    ],
    "application/x-pkcs7-certificates": [
        "p7b",
        "spc"
    ],
    "application/x-pkcs7-certreqresp": [
        "p7r"
    ],
    "application/x-rar-compressed": [
        "*rar"
    ],
    "application/x-redhat-package-manager": [
        "rpm"
    ],
    "application/x-research-info-systems": [
        "ris"
    ],
    "application/x-sea": [
        "sea"
    ],
    "application/x-sh": [
        "sh"
    ],
    "application/x-shar": [
        "shar"
    ],
    "application/x-shockwave-flash": [
        "swf"
    ],
    "application/x-silverlight-app": [
        "xap"
    ],
    "application/x-sql": [
        "sql"
    ],
    "application/x-stuffit": [
        "sit"
    ],
    "application/x-stuffitx": [
        "sitx"
    ],
    "application/x-subrip": [
        "srt"
    ],
    "application/x-sv4cpio": [
        "sv4cpio"
    ],
    "application/x-sv4crc": [
        "sv4crc"
    ],
    "application/x-t3vm-image": [
        "t3"
    ],
    "application/x-tads": [
        "gam"
    ],
    "application/x-tar": [
        "tar"
    ],
    "application/x-tcl": [
        "tcl",
        "tk"
    ],
    "application/x-tex": [
        "tex"
    ],
    "application/x-tex-tfm": [
        "tfm"
    ],
    "application/x-texinfo": [
        "texinfo",
        "texi"
    ],
    "application/x-tgif": [
        "*obj"
    ],
    "application/x-ustar": [
        "ustar"
    ],
    "application/x-virtualbox-hdd": [
        "hdd"
    ],
    "application/x-virtualbox-ova": [
        "ova"
    ],
    "application/x-virtualbox-ovf": [
        "ovf"
    ],
    "application/x-virtualbox-vbox": [
        "vbox"
    ],
    "application/x-virtualbox-vbox-extpack": [
        "vbox-extpack"
    ],
    "application/x-virtualbox-vdi": [
        "vdi"
    ],
    "application/x-virtualbox-vhd": [
        "vhd"
    ],
    "application/x-virtualbox-vmdk": [
        "vmdk"
    ],
    "application/x-wais-source": [
        "src"
    ],
    "application/x-web-app-manifest+json": [
        "webapp"
    ],
    "application/x-x509-ca-cert": [
        "der",
        "crt",
        "pem"
    ],
    "application/x-xfig": [
        "fig"
    ],
    "application/x-xliff+xml": [
        "*xlf"
    ],
    "application/x-xpinstall": [
        "xpi"
    ],
    "application/x-xz": [
        "xz"
    ],
    "application/x-zmachine": [
        "z1",
        "z2",
        "z3",
        "z4",
        "z5",
        "z6",
        "z7",
        "z8"
    ],
    "audio/vnd.dece.audio": [
        "uva",
        "uvva"
    ],
    "audio/vnd.digital-winds": [
        "eol"
    ],
    "audio/vnd.dra": [
        "dra"
    ],
    "audio/vnd.dts": [
        "dts"
    ],
    "audio/vnd.dts.hd": [
        "dtshd"
    ],
    "audio/vnd.lucent.voice": [
        "lvp"
    ],
    "audio/vnd.ms-playready.media.pya": [
        "pya"
    ],
    "audio/vnd.nuera.ecelp4800": [
        "ecelp4800"
    ],
    "audio/vnd.nuera.ecelp7470": [
        "ecelp7470"
    ],
    "audio/vnd.nuera.ecelp9600": [
        "ecelp9600"
    ],
    "audio/vnd.rip": [
        "rip"
    ],
    "audio/x-aac": [
        "aac"
    ],
    "audio/x-aiff": [
        "aif",
        "aiff",
        "aifc"
    ],
    "audio/x-caf": [
        "caf"
    ],
    "audio/x-flac": [
        "flac"
    ],
    "audio/x-m4a": [
        "*m4a"
    ],
    "audio/x-matroska": [
        "mka"
    ],
    "audio/x-mpegurl": [
        "m3u"
    ],
    "audio/x-ms-wax": [
        "wax"
    ],
    "audio/x-ms-wma": [
        "wma"
    ],
    "audio/x-pn-realaudio": [
        "ram",
        "ra"
    ],
    "audio/x-pn-realaudio-plugin": [
        "rmp"
    ],
    "audio/x-realaudio": [
        "*ra"
    ],
    "audio/x-wav": [
        "*wav"
    ],
    "chemical/x-cdx": [
        "cdx"
    ],
    "chemical/x-cif": [
        "cif"
    ],
    "chemical/x-cmdf": [
        "cmdf"
    ],
    "chemical/x-cml": [
        "cml"
    ],
    "chemical/x-csml": [
        "csml"
    ],
    "chemical/x-xyz": [
        "xyz"
    ],
    "image/prs.btif": [
        "btif"
    ],
    "image/prs.pti": [
        "pti"
    ],
    "image/vnd.adobe.photoshop": [
        "psd"
    ],
    "image/vnd.airzip.accelerator.azv": [
        "azv"
    ],
    "image/vnd.dece.graphic": [
        "uvi",
        "uvvi",
        "uvg",
        "uvvg"
    ],
    "image/vnd.djvu": [
        "djvu",
        "djv"
    ],
    "image/vnd.dvb.subtitle": [
        "*sub"
    ],
    "image/vnd.dwg": [
        "dwg"
    ],
    "image/vnd.dxf": [
        "dxf"
    ],
    "image/vnd.fastbidsheet": [
        "fbs"
    ],
    "image/vnd.fpx": [
        "fpx"
    ],
    "image/vnd.fst": [
        "fst"
    ],
    "image/vnd.fujixerox.edmics-mmr": [
        "mmr"
    ],
    "image/vnd.fujixerox.edmics-rlc": [
        "rlc"
    ],
    "image/vnd.microsoft.icon": [
        "ico"
    ],
    "image/vnd.ms-dds": [
        "dds"
    ],
    "image/vnd.ms-modi": [
        "mdi"
    ],
    "image/vnd.ms-photo": [
        "wdp"
    ],
    "image/vnd.net-fpx": [
        "npx"
    ],
    "image/vnd.pco.b16": [
        "b16"
    ],
    "image/vnd.tencent.tap": [
        "tap"
    ],
    "image/vnd.valve.source.texture": [
        "vtf"
    ],
    "image/vnd.wap.wbmp": [
        "wbmp"
    ],
    "image/vnd.xiff": [
        "xif"
    ],
    "image/vnd.zbrush.pcx": [
        "pcx"
    ],
    "image/x-3ds": [
        "3ds"
    ],
    "image/x-cmu-raster": [
        "ras"
    ],
    "image/x-cmx": [
        "cmx"
    ],
    "image/x-freehand": [
        "fh",
        "fhc",
        "fh4",
        "fh5",
        "fh7"
    ],
    "image/x-icon": [
        "*ico"
    ],
    "image/x-jng": [
        "jng"
    ],
    "image/x-mrsid-image": [
        "sid"
    ],
    "image/x-ms-bmp": [
        "*bmp"
    ],
    "image/x-pcx": [
        "*pcx"
    ],
    "image/x-pict": [
        "pic",
        "pct"
    ],
    "image/x-portable-anymap": [
        "pnm"
    ],
    "image/x-portable-bitmap": [
        "pbm"
    ],
    "image/x-portable-graymap": [
        "pgm"
    ],
    "image/x-portable-pixmap": [
        "ppm"
    ],
    "image/x-rgb": [
        "rgb"
    ],
    "image/x-tga": [
        "tga"
    ],
    "image/x-xbitmap": [
        "xbm"
    ],
    "image/x-xpixmap": [
        "xpm"
    ],
    "image/x-xwindowdump": [
        "xwd"
    ],
    "message/vnd.wfa.wsc": [
        "wsc"
    ],
    "model/vnd.collada+xml": [
        "dae"
    ],
    "model/vnd.dwf": [
        "dwf"
    ],
    "model/vnd.gdl": [
        "gdl"
    ],
    "model/vnd.gtw": [
        "gtw"
    ],
    "model/vnd.mts": [
        "mts"
    ],
    "model/vnd.opengex": [
        "ogex"
    ],
    "model/vnd.parasolid.transmit.binary": [
        "x_b"
    ],
    "model/vnd.parasolid.transmit.text": [
        "x_t"
    ],
    "model/vnd.sap.vds": [
        "vds"
    ],
    "model/vnd.usdz+zip": [
        "usdz"
    ],
    "model/vnd.valve.source.compiled-map": [
        "bsp"
    ],
    "model/vnd.vtu": [
        "vtu"
    ],
    "text/prs.lines.tag": [
        "dsc"
    ],
    "text/vnd.curl": [
        "curl"
    ],
    "text/vnd.curl.dcurl": [
        "dcurl"
    ],
    "text/vnd.curl.mcurl": [
        "mcurl"
    ],
    "text/vnd.curl.scurl": [
        "scurl"
    ],
    "text/vnd.dvb.subtitle": [
        "sub"
    ],
    "text/vnd.fly": [
        "fly"
    ],
    "text/vnd.fmi.flexstor": [
        "flx"
    ],
    "text/vnd.graphviz": [
        "gv"
    ],
    "text/vnd.in3d.3dml": [
        "3dml"
    ],
    "text/vnd.in3d.spot": [
        "spot"
    ],
    "text/vnd.sun.j2me.app-descriptor": [
        "jad"
    ],
    "text/vnd.wap.wml": [
        "wml"
    ],
    "text/vnd.wap.wmlscript": [
        "wmls"
    ],
    "text/x-asm": [
        "s",
        "asm"
    ],
    "text/x-c": [
        "c",
        "cc",
        "cxx",
        "cpp",
        "h",
        "hh",
        "dic"
    ],
    "text/x-component": [
        "htc"
    ],
    "text/x-fortran": [
        "f",
        "for",
        "f77",
        "f90"
    ],
    "text/x-handlebars-template": [
        "hbs"
    ],
    "text/x-java-source": [
        "java"
    ],
    "text/x-lua": [
        "lua"
    ],
    "text/x-markdown": [
        "mkd"
    ],
    "text/x-nfo": [
        "nfo"
    ],
    "text/x-opml": [
        "opml"
    ],
    "text/x-org": [
        "*org"
    ],
    "text/x-pascal": [
        "p",
        "pas"
    ],
    "text/x-processing": [
        "pde"
    ],
    "text/x-sass": [
        "sass"
    ],
    "text/x-scss": [
        "scss"
    ],
    "text/x-setext": [
        "etx"
    ],
    "text/x-sfv": [
        "sfv"
    ],
    "text/x-suse-ymp": [
        "ymp"
    ],
    "text/x-uuencode": [
        "uu"
    ],
    "text/x-vcalendar": [
        "vcs"
    ],
    "text/x-vcard": [
        "vcf"
    ],
    "video/vnd.dece.hd": [
        "uvh",
        "uvvh"
    ],
    "video/vnd.dece.mobile": [
        "uvm",
        "uvvm"
    ],
    "video/vnd.dece.pd": [
        "uvp",
        "uvvp"
    ],
    "video/vnd.dece.sd": [
        "uvs",
        "uvvs"
    ],
    "video/vnd.dece.video": [
        "uvv",
        "uvvv"
    ],
    "video/vnd.dvb.file": [
        "dvb"
    ],
    "video/vnd.fvt": [
        "fvt"
    ],
    "video/vnd.mpegurl": [
        "mxu",
        "m4u"
    ],
    "video/vnd.ms-playready.media.pyv": [
        "pyv"
    ],
    "video/vnd.uvvu.mp4": [
        "uvu",
        "uvvu"
    ],
    "video/vnd.vivo": [
        "viv"
    ],
    "video/x-f4v": [
        "f4v"
    ],
    "video/x-fli": [
        "fli"
    ],
    "video/x-flv": [
        "flv"
    ],
    "video/x-m4v": [
        "m4v"
    ],
    "video/x-matroska": [
        "mkv",
        "mk3d",
        "mks"
    ],
    "video/x-mng": [
        "mng"
    ],
    "video/x-ms-asf": [
        "asf",
        "asx"
    ],
    "video/x-ms-vob": [
        "vob"
    ],
    "video/x-ms-wm": [
        "wm"
    ],
    "video/x-ms-wmv": [
        "wmv"
    ],
    "video/x-ms-wmx": [
        "wmx"
    ],
    "video/x-ms-wvx": [
        "wvx"
    ],
    "video/x-msvideo": [
        "avi"
    ],
    "video/x-sgi-movie": [
        "movie"
    ],
    "video/x-smv": [
        "smv"
    ],
    "x-conference/x-cooltalk": [
        "ice"
    ]
};

});


parcelRequire.register("7ZJF5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SEND_FILES = void 0;
module.exports["default"] = $5d21a65d8e6a042e$var$sendFiles;
var $5d21a65d8e6a042e$var$SEND_FILES = "WEB_CHAT/SEND_FILES";
module.exports.SEND_FILES = $5d21a65d8e6a042e$var$SEND_FILES;
function $5d21a65d8e6a042e$var$sendFiles(files) {
    return {
        type: $5d21a65d8e6a042e$var$SEND_FILES,
        payload: {
            files: files
        }
    };
}

});


parcelRequire.register("1GBTh", function(module, exports) {
"use strict";

var $8usDI = parcelRequire("8usDI");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = $13a71af3cdc19960$var$sendMessageBackToPostActivitySaga;

var $13a71af3cdc19960$var$_regenerator = $8usDI((parcelRequire("7MKKk")));
parcelRequire("6Nc1h");
var $7McF6 = parcelRequire("7McF6");
var $7PPVh = parcelRequire("7PPVh");

var $13a71af3cdc19960$var$_postActivity = $8usDI((parcelRequire("lnNkF")));

var $cVxSW = parcelRequire("cVxSW");

var $13a71af3cdc19960$var$_whileConnected = $8usDI((parcelRequire("6qcDb")));
var $13a71af3cdc19960$var$_marked = /*#__PURE__*/ $13a71af3cdc19960$var$_regenerator["default"].mark($13a71af3cdc19960$var$postActivityWithMessageBack), $13a71af3cdc19960$var$_marked2 = /*#__PURE__*/ $13a71af3cdc19960$var$_regenerator["default"].mark($13a71af3cdc19960$var$sendMessageBackToPostActivity), $13a71af3cdc19960$var$_marked3 = /*#__PURE__*/ $13a71af3cdc19960$var$_regenerator["default"].mark($13a71af3cdc19960$var$sendMessageBackToPostActivitySaga);
// https://github.com/microsoft/botframework-sdk/blob/main/specs/botframework-activity/botframework-activity.md#message-back
function $13a71af3cdc19960$var$postActivityWithMessageBack(_ref) {
    var _ref$payload, displayText, text, value;
    return $13a71af3cdc19960$var$_regenerator["default"].wrap(function postActivityWithMessageBack$(_context) {
        while(true)switch(_context.prev = _context.next){
            case 0:
                _ref$payload = _ref.payload, displayText = _ref$payload.displayText, text = _ref$payload.text, value = _ref$payload.value;
                _context.next = 3;
                return (0, $7McF6.Y)((0, $13a71af3cdc19960$var$_postActivity["default"])({
                    channelData: {
                        messageBack: {
                            displayText: displayText
                        }
                    },
                    text: text,
                    type: "message",
                    value: value
                }));
            case 3:
            case "end":
                return _context.stop();
        }
    }, $13a71af3cdc19960$var$_marked);
}
function $13a71af3cdc19960$var$sendMessageBackToPostActivity() {
    return $13a71af3cdc19960$var$_regenerator["default"].wrap(function sendMessageBackToPostActivity$(_context2) {
        while(true)switch(_context2.prev = _context2.next){
            case 0:
                _context2.next = 2;
                return (0, $7PPVh.takeEvery)($cVxSW.SEND_MESSAGE_BACK, $13a71af3cdc19960$var$postActivityWithMessageBack);
            case 2:
            case "end":
                return _context2.stop();
        }
    }, $13a71af3cdc19960$var$_marked2);
}
function $13a71af3cdc19960$var$sendMessageBackToPostActivitySaga() {
    return $13a71af3cdc19960$var$_regenerator["default"].wrap(function sendMessageBackToPostActivitySaga$(_context3) {
        while(true)switch(_context3.prev = _context3.next){
            case 0:
                _context3.next = 2;
                return (0, $13a71af3cdc19960$var$_whileConnected["default"])($13a71af3cdc19960$var$sendMessageBackToPostActivity);
            case 2:
            case "end":
                return _context3.stop();
        }
    }, $13a71af3cdc19960$var$_marked3);
}

});
parcelRequire.register("cVxSW", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SEND_MESSAGE_BACK = void 0;
module.exports["default"] = $969517c4e9e9311e$var$sendMessageback;
var $969517c4e9e9311e$var$SEND_MESSAGE_BACK = "WEB_CHAT/SEND_MESSAGE_BACK";
module.exports.SEND_MESSAGE_BACK = $969517c4e9e9311e$var$SEND_MESSAGE_BACK;
function $969517c4e9e9311e$var$sendMessageback(value, text, displayText) {
    return {
        type: $969517c4e9e9311e$var$SEND_MESSAGE_BACK,
        payload: {
            displayText: displayText,
            text: text,
            value: value
        }
    };
}

});


parcelRequire.register("jgUWN", function(module, exports) {
"use strict";

var $8usDI = parcelRequire("8usDI");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = $e07baf833512212e$var$sendMessageToPostActivitySaga;

var $e07baf833512212e$var$_regenerator = $8usDI((parcelRequire("7MKKk")));
parcelRequire("6Nc1h");
var $7McF6 = parcelRequire("7McF6");
var $7PPVh = parcelRequire("7PPVh");

var $bfXvF = parcelRequire("bfXvF");

var $e07baf833512212e$var$_postActivity = $8usDI((parcelRequire("lnNkF")));

var $e07baf833512212e$var$_whileConnected = $8usDI((parcelRequire("6qcDb")));
var $e07baf833512212e$var$_marked = /*#__PURE__*/ $e07baf833512212e$var$_regenerator["default"].mark($e07baf833512212e$var$postActivityWithMessage), $e07baf833512212e$var$_marked2 = /*#__PURE__*/ $e07baf833512212e$var$_regenerator["default"].mark($e07baf833512212e$var$sendMessageToPostActivity), $e07baf833512212e$var$_marked3 = /*#__PURE__*/ $e07baf833512212e$var$_regenerator["default"].mark($e07baf833512212e$var$sendMessageToPostActivitySaga);
function $e07baf833512212e$var$postActivityWithMessage(_ref) {
    var _ref$payload, channelData, method, text;
    return $e07baf833512212e$var$_regenerator["default"].wrap(function postActivityWithMessage$(_context) {
        while(true)switch(_context.prev = _context.next){
            case 0:
                _ref$payload = _ref.payload, channelData = _ref$payload.channelData, method = _ref$payload.method, text = _ref$payload.text;
                _context.next = 3;
                return (0, $7McF6.Y)((0, $e07baf833512212e$var$_postActivity["default"])({
                    channelData: channelData,
                    text: text,
                    textFormat: "plain",
                    type: "message"
                }, method));
            case 3:
            case "end":
                return _context.stop();
        }
    }, $e07baf833512212e$var$_marked);
}
function $e07baf833512212e$var$sendMessageToPostActivity() {
    return $e07baf833512212e$var$_regenerator["default"].wrap(function sendMessageToPostActivity$(_context2) {
        while(true)switch(_context2.prev = _context2.next){
            case 0:
                _context2.next = 2;
                return (0, $7PPVh.takeEvery)(function(_ref2) {
                    var payload = _ref2.payload, type = _ref2.type;
                    return type === $bfXvF.SEND_MESSAGE && payload.text;
                }, $e07baf833512212e$var$postActivityWithMessage);
            case 2:
            case "end":
                return _context2.stop();
        }
    }, $e07baf833512212e$var$_marked2);
}
function $e07baf833512212e$var$sendMessageToPostActivitySaga() {
    return $e07baf833512212e$var$_regenerator["default"].wrap(function sendMessageToPostActivitySaga$(_context3) {
        while(true)switch(_context3.prev = _context3.next){
            case 0:
                _context3.next = 2;
                return (0, $e07baf833512212e$var$_whileConnected["default"])($e07baf833512212e$var$sendMessageToPostActivity);
            case 2:
            case "end":
                return _context3.stop();
        }
    }, $e07baf833512212e$var$_marked3);
}

});
parcelRequire.register("bfXvF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SEND_MESSAGE = void 0;
module.exports["default"] = $831f41d63502b223$var$sendMessage;
var $831f41d63502b223$var$SEND_MESSAGE = "WEB_CHAT/SEND_MESSAGE";
module.exports.SEND_MESSAGE = $831f41d63502b223$var$SEND_MESSAGE;
function $831f41d63502b223$var$sendMessage(text, method) {
    var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {}, channelData = _ref.channelData;
    return {
        type: $831f41d63502b223$var$SEND_MESSAGE,
        payload: {
            channelData: channelData,
            method: method,
            text: text
        }
    };
}

});


parcelRequire.register("4tXts", function(module, exports) {
"use strict";

var $8usDI = parcelRequire("8usDI");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = $3438012eda755727$var$sendPostBackToPostActivitySaga;

var $3438012eda755727$var$_regenerator = $8usDI((parcelRequire("7MKKk")));
parcelRequire("6Nc1h");
var $7McF6 = parcelRequire("7McF6");
var $7PPVh = parcelRequire("7PPVh");

var $3438012eda755727$var$_postActivity = $8usDI((parcelRequire("lnNkF")));

var $doIlR = parcelRequire("doIlR");

var $3438012eda755727$var$_whileConnected = $8usDI((parcelRequire("6qcDb")));
var $3438012eda755727$var$_marked = /*#__PURE__*/ $3438012eda755727$var$_regenerator["default"].mark($3438012eda755727$var$postActivityWithPostBack), $3438012eda755727$var$_marked2 = /*#__PURE__*/ $3438012eda755727$var$_regenerator["default"].mark($3438012eda755727$var$sendPostBackToPostActivity), $3438012eda755727$var$_marked3 = /*#__PURE__*/ $3438012eda755727$var$_regenerator["default"].mark($3438012eda755727$var$sendPostBackToPostActivitySaga);
// https://github.com/microsoft/botframework-sdk/blob/main/specs/botframework-activity/botframework-activity.md#post-back
function $3438012eda755727$var$postActivityWithPostBack(_ref) {
    var value;
    return $3438012eda755727$var$_regenerator["default"].wrap(function postActivityWithPostBack$(_context) {
        while(true)switch(_context.prev = _context.next){
            case 0:
                value = _ref.payload.value;
                _context.next = 3;
                return (0, $7McF6.Y)((0, $3438012eda755727$var$_postActivity["default"])({
                    channelData: {
                        postBack: true
                    },
                    text: typeof value === "string" ? value : undefined,
                    type: "message",
                    value: typeof value !== "string" ? value : undefined
                }));
            case 3:
            case "end":
                return _context.stop();
        }
    }, $3438012eda755727$var$_marked);
}
function $3438012eda755727$var$sendPostBackToPostActivity() {
    return $3438012eda755727$var$_regenerator["default"].wrap(function sendPostBackToPostActivity$(_context2) {
        while(true)switch(_context2.prev = _context2.next){
            case 0:
                _context2.next = 2;
                return (0, $7PPVh.takeEvery)($doIlR.SEND_POST_BACK, $3438012eda755727$var$postActivityWithPostBack);
            case 2:
            case "end":
                return _context2.stop();
        }
    }, $3438012eda755727$var$_marked2);
}
function $3438012eda755727$var$sendPostBackToPostActivitySaga() {
    return $3438012eda755727$var$_regenerator["default"].wrap(function sendPostBackToPostActivitySaga$(_context3) {
        while(true)switch(_context3.prev = _context3.next){
            case 0:
                _context3.next = 2;
                return (0, $3438012eda755727$var$_whileConnected["default"])($3438012eda755727$var$sendPostBackToPostActivity);
            case 2:
            case "end":
                return _context3.stop();
        }
    }, $3438012eda755727$var$_marked3);
}

});
parcelRequire.register("doIlR", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SEND_POST_BACK = void 0;
module.exports["default"] = $9c0feb94afb72de6$var$sendPostback;
var $9c0feb94afb72de6$var$SEND_POST_BACK = "WEB_CHAT/SEND_POST_BACK";
module.exports.SEND_POST_BACK = $9c0feb94afb72de6$var$SEND_POST_BACK;
function $9c0feb94afb72de6$var$sendPostback(value) {
    return {
        type: $9c0feb94afb72de6$var$SEND_POST_BACK,
        payload: {
            value: value
        }
    };
}

});


parcelRequire.register("1tIUv", function(module, exports) {
"use strict";


var $8usDI = parcelRequire("8usDI");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = $113b5625153b2741$var$sendTypingIndicatorOnSetSendBoxSaga;

var $113b5625153b2741$var$_regenerator = $8usDI((parcelRequire("7MKKk")));
parcelRequire("6Nc1h");
var $7McF6 = parcelRequire("7McF6");
var $7PPVh = parcelRequire("7PPVh");

var $bu0xL = parcelRequire("bu0xL");

var $gYgS6 = parcelRequire("gYgS6");

var $lnNkF = parcelRequire("lnNkF");

var $113b5625153b2741$var$_emitTypingIndicator = $8usDI((parcelRequire("4I2lF")));

var $113b5625153b2741$var$_sendTypingIndicator = $8usDI((parcelRequire("d3IZ8")));

var $113b5625153b2741$var$_sleep = $8usDI((parcelRequire("2nXdi")));

var $113b5625153b2741$var$_whileConnected = $8usDI((parcelRequire("6qcDb")));
var $113b5625153b2741$var$_marked = /*#__PURE__*/ (parcelRequire("7MKKk")).mark($113b5625153b2741$var$sendTypingIndicatorOnSetSendBox), $113b5625153b2741$var$_marked2 = /*#__PURE__*/ (parcelRequire("7MKKk")).mark($113b5625153b2741$var$sendTypingIndicatorOnSetSendBoxSaga);
var $113b5625153b2741$var$SEND_INTERVAL = 3000;
function $113b5625153b2741$var$takeSendTypingIndicator(value) {
    return (0, $7McF6.K)(function(_ref) {
        var payload = _ref.payload, type = _ref.type;
        return type === $gYgS6.SET_SEND_TYPING_INDICATOR && !payload.sendTypingIndicator === !value;
    });
}
function $113b5625153b2741$var$sendTypingIndicatorOnSetSendBox(_, ponyfill) {
    var Date, sendTypingIndicator, _loop;
    return $113b5625153b2741$var$_regenerator["default"].wrap(function sendTypingIndicatorOnSetSendBox$(_context3) {
        while(true)switch(_context3.prev = _context3.next){
            case 0:
                Date = ponyfill.Date;
                _context3.next = 3;
                return (0, $7McF6.a3)($113b5625153b2741$var$_sendTypingIndicator["default"]);
            case 3:
                sendTypingIndicator = _context3.sent;
                if (sendTypingIndicator) {
                    _context3.next = 7;
                    break;
                }
                _context3.next = 7;
                return $113b5625153b2741$var$takeSendTypingIndicator(true);
            case 7:
                _loop = /*#__PURE__*/ $113b5625153b2741$var$_regenerator["default"].mark(function _loop() {
                    var lastSend, task;
                    return $113b5625153b2741$var$_regenerator["default"].wrap(function _loop$(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                lastSend = -Infinity;
                                _context2.next = 3;
                                return (0, $7PPVh.takeLatest)(function(_ref2) {
                                    var payload = _ref2.payload, type = _ref2.type;
                                    return type === $bu0xL.SET_SEND_BOX && payload.text || // Stop sending pending typing indicator if the user has posted anything.
                                    // We send typing indicator in a debounce way (t = 0, t = 3000, t = 6000).
                                    // When the user type, and then post the activity at t = 1500, we still have a pending typing indicator at t = 3000.
                                    // This code is to cancel the typing indicator at t = 3000.
                                    type === $lnNkF.POST_ACTIVITY && payload.activity.type !== "typing";
                                }, /*#__PURE__*/ $113b5625153b2741$var$_regenerator["default"].mark(function _callee(_ref3) {
                                    var payload, type, interval;
                                    return $113b5625153b2741$var$_regenerator["default"].wrap(function _callee$(_context) {
                                        while(true)switch(_context.prev = _context.next){
                                            case 0:
                                                payload = _ref3.payload, type = _ref3.type;
                                                if (!(type === $bu0xL.SET_SEND_BOX)) {
                                                    _context.next = 11;
                                                    break;
                                                }
                                                interval = $113b5625153b2741$var$SEND_INTERVAL - Date.now() + lastSend;
                                                if (!(interval > 0)) {
                                                    _context.next = 6;
                                                    break;
                                                }
                                                _context.next = 6;
                                                return (0, $7McF6.N)($113b5625153b2741$var$_sleep["default"], interval, ponyfill);
                                            case 6:
                                                _context.next = 8;
                                                return (0, $7McF6.Y)((0, $113b5625153b2741$var$_emitTypingIndicator["default"])());
                                            case 8:
                                                lastSend = Date.now();
                                                _context.next = 12;
                                                break;
                                            case 11:
                                                if (payload.activity.type === "message") lastSend = -Infinity;
                                            case 12:
                                            case "end":
                                                return _context.stop();
                                        }
                                    }, _callee);
                                }));
                            case 3:
                                task = _context2.sent;
                                _context2.next = 6;
                                return $113b5625153b2741$var$takeSendTypingIndicator(false);
                            case 6:
                                _context2.next = 8;
                                return (0, $7McF6.M)(task);
                            case 8:
                                _context2.next = 10;
                                return $113b5625153b2741$var$takeSendTypingIndicator(true);
                            case 10:
                            case "end":
                                return _context2.stop();
                        }
                    }, _loop);
                });
            case 8:
                return _context3.delegateYield(_loop(), "t0", 9);
            case 9:
                _context3.next = 8;
                break;
            case 11:
            case "end":
                return _context3.stop();
        }
    }, $113b5625153b2741$var$_marked);
}
function $113b5625153b2741$var$sendTypingIndicatorOnSetSendBoxSaga(ponyfill) {
    return $113b5625153b2741$var$_regenerator["default"].wrap(function sendTypingIndicatorOnSetSendBoxSaga$(_context4) {
        while(true)switch(_context4.prev = _context4.next){
            case 0:
                _context4.next = 2;
                return (0, $113b5625153b2741$var$_whileConnected["default"])($113b5625153b2741$var$sendTypingIndicatorOnSetSendBox, ponyfill);
            case 2:
            case "end":
                return _context4.stop();
        }
    }, $113b5625153b2741$var$_marked2);
}

});
parcelRequire.register("d3IZ8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;
var $981e73494e982427$var$_default = function _default(_ref) {
    var sendTypingIndicator = _ref.sendTypingIndicator;
    return sendTypingIndicator;
};
module.exports["default"] = $981e73494e982427$var$_default;

});


parcelRequire.register("8dqf7", function(module, exports) {
"use strict";


var $8usDI = parcelRequire("8usDI");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = $5fb3e4e559ce99ee$var$speakActivityAndStartDictateOnIncomingActivityFromOthersSaga;

var $5fb3e4e559ce99ee$var$_regenerator = $8usDI((parcelRequire("7MKKk")));
parcelRequire("6Nc1h");
var $7PPVh = parcelRequire("7PPVh");
var $7McF6 = parcelRequire("7McF6");

var $89rfh = parcelRequire("89rfh");

var $5iNAf = parcelRequire("5iNAf");

var $5fb3e4e559ce99ee$var$_markActivity = $8usDI((parcelRequire("ciuoj")));

var $5fb3e4e559ce99ee$var$_setDictateState = $8usDI((parcelRequire("eKwpg")));

var $5fb3e4e559ce99ee$var$_shouldSpeakIncomingActivity = $8usDI((parcelRequire("OgBqp")));

var $5fb3e4e559ce99ee$var$_speakableActivity = $8usDI((parcelRequire("jTNjo")));

var $5fb3e4e559ce99ee$var$_stopDictate = $8usDI((parcelRequire("5Nb9e")));

var $5fb3e4e559ce99ee$var$_whileConnected = $8usDI((parcelRequire("6qcDb")));
var $5fb3e4e559ce99ee$var$_marked = /*#__PURE__*/ (parcelRequire("7MKKk")).mark($5fb3e4e559ce99ee$var$speakActivityAndStartDictateOnIncomingActivityFromOthers), $5fb3e4e559ce99ee$var$_marked2 = /*#__PURE__*/ (parcelRequire("7MKKk")).mark($5fb3e4e559ce99ee$var$speakActivityAndStartDictateOnIncomingActivityFromOthersSaga);
function $5fb3e4e559ce99ee$var$speakActivityAndStartDictateOnIncomingActivityFromOthers(_ref) {
    var userID;
    return $5fb3e4e559ce99ee$var$_regenerator["default"].wrap(function speakActivityAndStartDictateOnIncomingActivityFromOthers$(_context2) {
        while(true)switch(_context2.prev = _context2.next){
            case 0:
                userID = _ref.userID;
                _context2.next = 3;
                return (0, $7PPVh.takeEvery)(function(_ref2) {
                    var payload = _ref2.payload, type = _ref2.type;
                    return(// In Direct Line Speech, we do not know the user ID, but "role" is filled with "bot" or "user".
                    // Here, we do two checks: the speakable activity must not have user ID, and must not have role === 'user'
                    type === $89rfh.INCOMING_ACTIVITY && payload.activity.from.id !== userID && payload.activity.from.role !== "user");
                }, /*#__PURE__*/ $5fb3e4e559ce99ee$var$_regenerator["default"].mark(function _callee(_ref3) {
                    var activity, shouldSpeakIncomingActivity, shouldSpeak;
                    return $5fb3e4e559ce99ee$var$_regenerator["default"].wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                activity = _ref3.payload.activity;
                                _context.next = 3;
                                return (0, $7McF6.a3)($5fb3e4e559ce99ee$var$_shouldSpeakIncomingActivity["default"]);
                            case 3:
                                shouldSpeakIncomingActivity = _context.sent;
                                shouldSpeak = (0, $5fb3e4e559ce99ee$var$_speakableActivity["default"])(activity) && shouldSpeakIncomingActivity;
                                if (!(shouldSpeak && (activity.speak || activity.text || ~(activity.attachments || []).findIndex(function(_ref4) {
                                    var _ref4$content = _ref4.content;
                                    _ref4$content = _ref4$content === void 0 ? {} : _ref4$content;
                                    var speak = _ref4$content.speak;
                                    return speak;
                                })))) {
                                    _context.next = 8;
                                    break;
                                }
                                _context.next = 8;
                                return (0, $7McF6.Y)((0, $5fb3e4e559ce99ee$var$_markActivity["default"])(activity, "speak", true));
                            case 8:
                                if (!(shouldSpeak && activity.inputHint === "expectingInput")) {
                                    _context.next = 13;
                                    break;
                                }
                                _context.next = 11;
                                return (0, $7McF6.Y)((0, $5fb3e4e559ce99ee$var$_setDictateState["default"])($5iNAf.WILL_START));
                            case 11:
                                _context.next = 16;
                                break;
                            case 13:
                                if (!(activity.inputHint === "ignoringInput")) {
                                    _context.next = 16;
                                    break;
                                }
                                _context.next = 16;
                                return (0, $7McF6.Y)((0, $5fb3e4e559ce99ee$var$_stopDictate["default"])());
                            case 16:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee);
                }));
            case 3:
            case "end":
                return _context2.stop();
        }
    }, $5fb3e4e559ce99ee$var$_marked);
}
function $5fb3e4e559ce99ee$var$speakActivityAndStartDictateOnIncomingActivityFromOthersSaga() {
    return $5fb3e4e559ce99ee$var$_regenerator["default"].wrap(function speakActivityAndStartDictateOnIncomingActivityFromOthersSaga$(_context3) {
        while(true)switch(_context3.prev = _context3.next){
            case 0:
                _context3.next = 2;
                return (0, $5fb3e4e559ce99ee$var$_whileConnected["default"])($5fb3e4e559ce99ee$var$speakActivityAndStartDictateOnIncomingActivityFromOthers);
            case 2:
            case "end":
                return _context3.stop();
        }
    }, $5fb3e4e559ce99ee$var$_marked2);
}

});
parcelRequire.register("OgBqp", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;
var $09718c8ff758824f$var$_default = function _default(_ref) {
    var shouldSpeakIncomingActivity = _ref.shouldSpeakIncomingActivity;
    return shouldSpeakIncomingActivity;
};
module.exports["default"] = $09718c8ff758824f$var$_default;

});

parcelRequire.register("jTNjo", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = $e7c967a5c49e90e6$var$speakableActivity;
function $e7c967a5c49e90e6$var$speakableActivity(activity) {
    return activity && activity.from && activity.type === "message";
}

});


parcelRequire.register("luGut", function(module, exports) {
"use strict";

var $8usDI = parcelRequire("8usDI");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = $fa5d5c0e291df653$var$startDictateOnSpeakCompleteSaga;

var $fa5d5c0e291df653$var$_regenerator = $8usDI((parcelRequire("7MKKk")));
parcelRequire("6Nc1h");
var $7McF6 = parcelRequire("7McF6");
var $7PPVh = parcelRequire("7PPVh");

var $ciuoj = parcelRequire("ciuoj");

var $ltJDo = parcelRequire("ltJDo");

var $eKwpg = parcelRequire("eKwpg");

var $5iNAf = parcelRequire("5iNAf");

var $fa5d5c0e291df653$var$_dictateState = $8usDI((parcelRequire("hwRvy")));

var $fa5d5c0e291df653$var$_speakingActivity = $8usDI((parcelRequire("5yi6J")));

var $fa5d5c0e291df653$var$_startDictate = $8usDI((parcelRequire("1tniU")));
var $fa5d5c0e291df653$var$_marked = /*#__PURE__*/ $fa5d5c0e291df653$var$_regenerator["default"].mark($fa5d5c0e291df653$var$startDictateOnSpeakComplete), $fa5d5c0e291df653$var$_marked2 = /*#__PURE__*/ $fa5d5c0e291df653$var$_regenerator["default"].mark($fa5d5c0e291df653$var$startDictateOnSpeakCompleteSaga);
function $fa5d5c0e291df653$var$startDictateOnSpeakComplete() {
    var speakingActivities, dictateState;
    return $fa5d5c0e291df653$var$_regenerator["default"].wrap(function startDictateOnSpeakComplete$(_context) {
        while(true)switch(_context.prev = _context.next){
            case 0:
                _context.next = 2;
                return (0, $7McF6.a3)((0, $ltJDo.of)($fa5d5c0e291df653$var$_speakingActivity["default"]));
            case 2:
                speakingActivities = _context.sent;
                _context.next = 5;
                return (0, $7McF6.a3)($fa5d5c0e291df653$var$_dictateState["default"]);
            case 5:
                dictateState = _context.sent;
                if (!(dictateState === $5iNAf.WILL_START && !speakingActivities.length)) {
                    _context.next = 9;
                    break;
                }
                _context.next = 9;
                return (0, $7McF6.Y)((0, $fa5d5c0e291df653$var$_startDictate["default"])());
            case 9:
            case "end":
                return _context.stop();
        }
    }, $fa5d5c0e291df653$var$_marked);
} // TODO: [P4] We should turn this into a reducer instead
function $fa5d5c0e291df653$var$startDictateOnSpeakCompleteSaga() {
    return $fa5d5c0e291df653$var$_regenerator["default"].wrap(function startDictateOnSpeakCompleteSaga$(_context2) {
        while(true)switch(_context2.prev = _context2.next){
            case 0:
                _context2.next = 2;
                return (0, $7PPVh.takeEvery)(function(_ref) {
                    var type = _ref.type;
                    return type === $ciuoj.MARK_ACTIVITY || type === $eKwpg.SET_DICTATE_STATE;
                }, $fa5d5c0e291df653$var$startDictateOnSpeakComplete);
            case 2:
            case "end":
                return _context2.stop();
        }
    }, $fa5d5c0e291df653$var$_marked2);
}

});
parcelRequire.register("hwRvy", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;
var $cc2eee5e411a35be$var$_default = function _default(_ref) {
    var dictateState = _ref.dictateState;
    return dictateState;
};
module.exports["default"] = $cc2eee5e411a35be$var$_default;

});


parcelRequire.register("dji9G", function(module, exports) {
"use strict";


var $8usDI = parcelRequire("8usDI");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = $9b0b21ef63cb8083$var$startSpeakActivityOnPostActivitySaga;

var $9b0b21ef63cb8083$var$_regenerator = $8usDI((parcelRequire("7MKKk")));
parcelRequire("6Nc1h");
var $7PPVh = parcelRequire("7PPVh");
var $7McF6 = parcelRequire("7McF6");

var $lnNkF = parcelRequire("lnNkF");

var $9b0b21ef63cb8083$var$_startSpeakingActivity = $8usDI((parcelRequire("chC6e")));

var $9b0b21ef63cb8083$var$_whileConnected = $8usDI((parcelRequire("6qcDb")));
var $9b0b21ef63cb8083$var$_marked = /*#__PURE__*/ (parcelRequire("7MKKk")).mark($9b0b21ef63cb8083$var$startSpeakActivityOnPostActivity), $9b0b21ef63cb8083$var$_marked2 = /*#__PURE__*/ (parcelRequire("7MKKk")).mark($9b0b21ef63cb8083$var$startSpeakActivityOnPostActivitySaga);
function $9b0b21ef63cb8083$var$startSpeakActivityOnPostActivity() {
    return $9b0b21ef63cb8083$var$_regenerator["default"].wrap(function startSpeakActivityOnPostActivity$(_context2) {
        while(true)switch(_context2.prev = _context2.next){
            case 0:
                _context2.next = 2;
                return (0, $7PPVh.takeEvery)(function(_ref) {
                    var meta = _ref.meta, payload = _ref.payload, type = _ref.type;
                    return type === $lnNkF.POST_ACTIVITY_PENDING && meta.method === "speech" && payload.activity.type === "message";
                }, /*#__PURE__*/ $9b0b21ef63cb8083$var$_regenerator["default"].mark(function _callee() {
                    return $9b0b21ef63cb8083$var$_regenerator["default"].wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                _context.next = 2;
                                return (0, $7McF6.Y)((0, $9b0b21ef63cb8083$var$_startSpeakingActivity["default"])());
                            case 2:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee);
                }));
            case 2:
            case "end":
                return _context2.stop();
        }
    }, $9b0b21ef63cb8083$var$_marked);
}
function $9b0b21ef63cb8083$var$startSpeakActivityOnPostActivitySaga() {
    return $9b0b21ef63cb8083$var$_regenerator["default"].wrap(function startSpeakActivityOnPostActivitySaga$(_context3) {
        while(true)switch(_context3.prev = _context3.next){
            case 0:
                _context3.next = 2;
                return (0, $9b0b21ef63cb8083$var$_whileConnected["default"])($9b0b21ef63cb8083$var$startSpeakActivityOnPostActivity);
            case 2:
            case "end":
                return _context3.stop();
        }
    }, $9b0b21ef63cb8083$var$_marked2);
}

});

parcelRequire.register("8NJnY", function(module, exports) {
"use strict";


var $8usDI = parcelRequire("8usDI");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = $66861afbc0c35dec$var$stopDictateOnCardActionSaga;

var $66861afbc0c35dec$var$_regenerator = $8usDI((parcelRequire("7MKKk")));
parcelRequire("6Nc1h");
var $7PPVh = parcelRequire("7PPVh");
var $7McF6 = parcelRequire("7McF6");

var $lnNkF = parcelRequire("lnNkF");

var $66861afbc0c35dec$var$_stopDictate = $8usDI((parcelRequire("5Nb9e")));

var $66861afbc0c35dec$var$_whileConnected = $8usDI((parcelRequire("6qcDb")));
var $66861afbc0c35dec$var$_marked = /*#__PURE__*/ (parcelRequire("7MKKk")).mark($66861afbc0c35dec$var$stopDictateOnCardAction), $66861afbc0c35dec$var$_marked2 = /*#__PURE__*/ (parcelRequire("7MKKk")).mark($66861afbc0c35dec$var$stopDictateOnCardActionSaga);
function $66861afbc0c35dec$var$stopDictateOnCardAction() {
    return $66861afbc0c35dec$var$_regenerator["default"].wrap(function stopDictateOnCardAction$(_context2) {
        while(true)switch(_context2.prev = _context2.next){
            case 0:
                _context2.next = 2;
                return (0, $7PPVh.takeEvery)(// For now, we are using POST_ACTIVITY of a "message" activity
                // In the future, if we have an action for card input, we should use that instead
                function(_ref) {
                    var payload = _ref.payload, type = _ref.type;
                    return type === $lnNkF.POST_ACTIVITY_PENDING && payload.activity.type === "message";
                }, /*#__PURE__*/ $66861afbc0c35dec$var$_regenerator["default"].mark(function putStopDictate() {
                    return $66861afbc0c35dec$var$_regenerator["default"].wrap(function putStopDictate$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                _context.next = 2;
                                return (0, $7McF6.Y)((0, $66861afbc0c35dec$var$_stopDictate["default"])());
                            case 2:
                            case "end":
                                return _context.stop();
                        }
                    }, putStopDictate);
                }));
            case 2:
            case "end":
                return _context2.stop();
        }
    }, $66861afbc0c35dec$var$_marked);
}
function $66861afbc0c35dec$var$stopDictateOnCardActionSaga() {
    return $66861afbc0c35dec$var$_regenerator["default"].wrap(function stopDictateOnCardActionSaga$(_context3) {
        while(true)switch(_context3.prev = _context3.next){
            case 0:
                _context3.next = 2;
                return (0, $66861afbc0c35dec$var$_whileConnected["default"])($66861afbc0c35dec$var$stopDictateOnCardAction);
            case 2:
            case "end":
                return _context3.stop();
        }
    }, $66861afbc0c35dec$var$_marked2);
}

});

parcelRequire.register("bpTOL", function(module, exports) {
"use strict";


var $8usDI = parcelRequire("8usDI");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = $84fd53be68efa09f$var$stopSpeakingActivityOnInputSaga;

var $84fd53be68efa09f$var$_regenerator = $8usDI((parcelRequire("7MKKk")));
parcelRequire("6Nc1h");
var $7PPVh = parcelRequire("7PPVh");
var $7McF6 = parcelRequire("7McF6");

var $lnNkF = parcelRequire("lnNkF");

var $bu0xL = parcelRequire("bu0xL");

var $84fd53be68efa09f$var$_stopSpeakingActivity = $8usDI((parcelRequire("cbRU8")));

var $84fd53be68efa09f$var$_whileConnected = $8usDI((parcelRequire("6qcDb")));
var $84fd53be68efa09f$var$_marked = /*#__PURE__*/ (parcelRequire("7MKKk")).mark($84fd53be68efa09f$var$stopSpeakingActivityOnInput), $84fd53be68efa09f$var$_marked2 = /*#__PURE__*/ (parcelRequire("7MKKk")).mark($84fd53be68efa09f$var$stopSpeakingActivityOnInputSaga);
function $84fd53be68efa09f$var$stopSpeakingActivityOnInput() {
    return $84fd53be68efa09f$var$_regenerator["default"].wrap(function stopSpeakingActivityOnInput$(_context2) {
        while(true)switch(_context2.prev = _context2.next){
            case 0:
                _context2.next = 2;
                return (0, $7PPVh.takeEvery)(function(_ref) {
                    var meta = _ref.meta, payload = _ref.payload, type = _ref.type;
                    return type === $bu0xL.SET_SEND_BOX && payload.text || // We want to stop speaking activity when the user click on a card action
                    // But currently there are no actions generated out of a card action
                    // So, right now, we are using best-effort by listening to POST_ACTIVITY_PENDING with a "message" event
                    // We filter out speech because we will call startSpeakingActivity() for POST_ACTIVITY_PENDING dispatched by speech
                    type === $lnNkF.POST_ACTIVITY_PENDING && meta.method !== "speech" && payload.activity.type === "message";
                }, /*#__PURE__*/ $84fd53be68efa09f$var$_regenerator["default"].mark(function _callee() {
                    return $84fd53be68efa09f$var$_regenerator["default"].wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                _context.next = 2;
                                return (0, $7McF6.Y)((0, $84fd53be68efa09f$var$_stopSpeakingActivity["default"])());
                            case 2:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee);
                }));
            case 2:
            case "end":
                return _context2.stop();
        }
    }, $84fd53be68efa09f$var$_marked);
}
function $84fd53be68efa09f$var$stopSpeakingActivityOnInputSaga() {
    return $84fd53be68efa09f$var$_regenerator["default"].wrap(function stopSpeakingActivityOnInputSaga$(_context3) {
        while(true)switch(_context3.prev = _context3.next){
            case 0:
                _context3.next = 2;
                return (0, $84fd53be68efa09f$var$_whileConnected["default"])($84fd53be68efa09f$var$stopSpeakingActivityOnInput);
            case 2:
            case "end":
                return _context3.stop();
        }
    }, $84fd53be68efa09f$var$_marked2);
}

});

parcelRequire.register("fpIvC", function(module, exports) {
"use strict";


var $8usDI = parcelRequire("8usDI");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = $b38bb7612cd7f7f1$var$submitSendBoxSaga;

var $b38bb7612cd7f7f1$var$_regenerator = $8usDI((parcelRequire("7MKKk")));
parcelRequire("6Nc1h");
var $7PPVh = parcelRequire("7PPVh");
var $7McF6 = parcelRequire("7McF6");

var $gW4yE = parcelRequire("gW4yE");

var $b38bb7612cd7f7f1$var$_sendBoxValue = $8usDI((parcelRequire("lKKXq")));

var $b38bb7612cd7f7f1$var$_sendMessage = $8usDI((parcelRequire("bfXvF")));

var $b38bb7612cd7f7f1$var$_setSendBox = $8usDI((parcelRequire("bu0xL")));

var $b38bb7612cd7f7f1$var$_whileConnected = $8usDI((parcelRequire("6qcDb")));
var $b38bb7612cd7f7f1$var$_marked = /*#__PURE__*/ (parcelRequire("7MKKk")).mark($b38bb7612cd7f7f1$var$submitSendBox), $b38bb7612cd7f7f1$var$_marked2 = /*#__PURE__*/ (parcelRequire("7MKKk")).mark($b38bb7612cd7f7f1$var$submitSendBoxSaga);
function $b38bb7612cd7f7f1$var$submitSendBox() {
    return $b38bb7612cd7f7f1$var$_regenerator["default"].wrap(function submitSendBox$(_context2) {
        while(true)switch(_context2.prev = _context2.next){
            case 0:
                _context2.next = 2;
                return (0, $7PPVh.takeEvery)($gW4yE.SUBMIT_SEND_BOX, /*#__PURE__*/ $b38bb7612cd7f7f1$var$_regenerator["default"].mark(function _callee(_ref) {
                    var _ref$payload, channelData, method, sendBoxValue;
                    return $b38bb7612cd7f7f1$var$_regenerator["default"].wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                _ref$payload = _ref.payload, channelData = _ref$payload.channelData, method = _ref$payload.method;
                                _context.next = 3;
                                return (0, $7McF6.a3)($b38bb7612cd7f7f1$var$_sendBoxValue["default"]);
                            case 3:
                                sendBoxValue = _context.sent;
                                if (!sendBoxValue) {
                                    _context.next = 9;
                                    break;
                                }
                                _context.next = 7;
                                return (0, $7McF6.Y)((0, $b38bb7612cd7f7f1$var$_sendMessage["default"])(sendBoxValue.trim(), method, {
                                    channelData: channelData
                                }));
                            case 7:
                                _context.next = 9;
                                return (0, $7McF6.Y)((0, $b38bb7612cd7f7f1$var$_setSendBox["default"])(""));
                            case 9:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee);
                }));
            case 2:
            case "end":
                return _context2.stop();
        }
    }, $b38bb7612cd7f7f1$var$_marked);
}
function $b38bb7612cd7f7f1$var$submitSendBoxSaga() {
    return $b38bb7612cd7f7f1$var$_regenerator["default"].wrap(function submitSendBoxSaga$(_context3) {
        while(true)switch(_context3.prev = _context3.next){
            case 0:
                _context3.next = 2;
                return (0, $b38bb7612cd7f7f1$var$_whileConnected["default"])($b38bb7612cd7f7f1$var$submitSendBox);
            case 2:
            case "end":
                return _context3.stop();
        }
    }, $b38bb7612cd7f7f1$var$_marked2);
}

});
parcelRequire.register("gW4yE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SUBMIT_SEND_BOX = void 0;
module.exports["default"] = $c5459933b9720057$var$submitSendBox;
var $c5459933b9720057$var$SUBMIT_SEND_BOX = "WEB_CHAT/SUBMIT_SEND_BOX";
module.exports.SUBMIT_SEND_BOX = $c5459933b9720057$var$SUBMIT_SEND_BOX;
function $c5459933b9720057$var$submitSendBox() {
    var method = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "keyboard";
    var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {}, channelData = _ref.channelData;
    return {
        type: $c5459933b9720057$var$SUBMIT_SEND_BOX,
        payload: {
            channelData: channelData,
            method: method
        }
    };
}

});

parcelRequire.register("lKKXq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;
var $fd6251a0bf629523$var$_default = function _default(_ref) {
    var sendBoxValue = _ref.sendBoxValue;
    return sendBoxValue;
};
module.exports["default"] = $fd6251a0bf629523$var$_default;

});




parcelRequire.register("4gh84", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = $31a5f187d72dcea7$var$singleToArray;
function $31a5f187d72dcea7$var$singleToArray(singleOrArray) {
    return singleOrArray ? Array.isArray(singleOrArray) ? singleOrArray : [
        singleOrArray
    ] : [];
}

});

parcelRequire.register("3hXJH", function(module, exports) {
"use strict";

var $8usDI = parcelRequire("8usDI");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = $26514bfdd63a1578$var$warnOnce;

var $26514bfdd63a1578$var$_once = $8usDI((parcelRequire("cMB6a")));
function $26514bfdd63a1578$var$warnOnce(message) {
    return (0, $26514bfdd63a1578$var$_once["default"])(function() {
        return console.warn("botframework-webchat: ".concat(message, "."));
    });
}

});
parcelRequire.register("cMB6a", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = $94e6beba4541bedd$var$once;
function $94e6beba4541bedd$var$once(fn) {
    var done;
    return function() {
        if (!done) {
            fn();
            done = 1;
        }
    };
}

});


parcelRequire.register("fD7D4", function(module, exports) {
"use strict";
function $b6106a83ef1d6ba5$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $b6106a83ef1d6ba5$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $b6106a83ef1d6ba5$var$_typeof(obj);
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Components = void 0;
Object.defineProperty(module.exports, "Context", {
    enumerable: true,
    get: function get() {
        return $b6106a83ef1d6ba5$var$_WebChatUIContext.default;
    }
});
Object.defineProperty(module.exports, "concatMiddleware", {
    enumerable: true,
    get: function get() {
        return $hd4g0.concatMiddleware;
    }
});
Object.defineProperty(module.exports, "connectToWebChat", {
    enumerable: true,
    get: function get() {
        return $b6106a83ef1d6ba5$var$_connectToWebChat.default;
    }
});
Object.defineProperty(module.exports, "createCoreActivityMiddleware", {
    enumerable: true,
    get: function get() {
        return $b6106a83ef1d6ba5$var$_createCoreMiddleware.default;
    }
});
Object.defineProperty(module.exports, "createCoreActivityStatusMiddleware", {
    enumerable: true,
    get: function get() {
        return $b6106a83ef1d6ba5$var$_createCoreMiddleware2.default;
    }
});
Object.defineProperty(module.exports, "createCoreAttachmentMiddleware", {
    enumerable: true,
    get: function get() {
        return $b6106a83ef1d6ba5$var$_createCoreMiddleware3.default;
    }
});
Object.defineProperty(module.exports, "createStyleSet", {
    enumerable: true,
    get: function get() {
        return $b6106a83ef1d6ba5$var$_createStyleSet.default;
    }
});
module.exports.default = void 0;
Object.defineProperty(module.exports, "getTabIndex", {
    enumerable: true,
    get: function get() {
        return $b6106a83ef1d6ba5$var$_getTabIndex.default;
    }
});
module.exports.hooks = void 0;
Object.defineProperty(module.exports, "localize", {
    enumerable: true,
    get: function get() {
        return $hd4g0.localize;
    }
});
module.exports.version = void 0;

var $hd4g0 = parcelRequire("hd4g0");

var $b6106a83ef1d6ba5$var$_ReactWebChat = $b6106a83ef1d6ba5$var$_interopRequireDefault((parcelRequire("18zyh")));

var $b6106a83ef1d6ba5$var$_Composer = $b6106a83ef1d6ba5$var$_interopRequireDefault((parcelRequire("9a3YE")));

var $b6106a83ef1d6ba5$var$_Surface = $b6106a83ef1d6ba5$var$_interopRequireDefault((parcelRequire("fFnOT")));

var $b6106a83ef1d6ba5$var$_BasicWebChat = $b6106a83ef1d6ba5$var$_interopRequireDefault((parcelRequire("lLEbi")));

var $b6106a83ef1d6ba5$var$_BasicConnectivityStatus = $b6106a83ef1d6ba5$var$_interopRequireDefault((parcelRequire("8ehZJ")));

var $b6106a83ef1d6ba5$var$_BasicSendBox = $b6106a83ef1d6ba5$var$_interopRequireDefault((parcelRequire("ha8W8")));

var $b6106a83ef1d6ba5$var$_BasicToaster = $b6106a83ef1d6ba5$var$_interopRequireDefault((parcelRequire("9XbRk")));

var $b6106a83ef1d6ba5$var$_BasicTranscript = $b6106a83ef1d6ba5$var$_interopRequireDefault((parcelRequire("4FrFa")));

var $b6106a83ef1d6ba5$var$_Avatar = $b6106a83ef1d6ba5$var$_interopRequireDefault((parcelRequire("8nM1g")));

var $b6106a83ef1d6ba5$var$_Bubble = $b6106a83ef1d6ba5$var$_interopRequireDefault((parcelRequire("esGjx")));

var $b6106a83ef1d6ba5$var$_ErrorBox = $b6106a83ef1d6ba5$var$_interopRequireDefault((parcelRequire("foWLx")));

var $b6106a83ef1d6ba5$var$_SendStatus = $b6106a83ef1d6ba5$var$_interopRequireWildcard((parcelRequire("cZ0iP")));

var $b6106a83ef1d6ba5$var$_Speak = $b6106a83ef1d6ba5$var$_interopRequireWildcard((parcelRequire("dsDZo")));

var $b6106a83ef1d6ba5$var$_Timestamp = $b6106a83ef1d6ba5$var$_interopRequireDefault((parcelRequire("6QRL7")));

var $b6106a83ef1d6ba5$var$_AudioContent = $b6106a83ef1d6ba5$var$_interopRequireDefault((parcelRequire("9p94T")));

var $b6106a83ef1d6ba5$var$_FileContent = $b6106a83ef1d6ba5$var$_interopRequireDefault((parcelRequire("dShpd")));

var $b6106a83ef1d6ba5$var$_HTMLVideoContent = $b6106a83ef1d6ba5$var$_interopRequireDefault((parcelRequire("3LRa6")));

var $b6106a83ef1d6ba5$var$_ImageContent = $b6106a83ef1d6ba5$var$_interopRequireDefault((parcelRequire("11gyx")));

var $b6106a83ef1d6ba5$var$_TextContent = $b6106a83ef1d6ba5$var$_interopRequireDefault((parcelRequire("cBkf0")));

var $b6106a83ef1d6ba5$var$_VideoContent = $b6106a83ef1d6ba5$var$_interopRequireDefault((parcelRequire("6QoBQ")));

var $b6106a83ef1d6ba5$var$_VimeoContent = $b6106a83ef1d6ba5$var$_interopRequireDefault((parcelRequire("60GsU")));

var $b6106a83ef1d6ba5$var$_YouTubeContent = $b6106a83ef1d6ba5$var$_interopRequireDefault((parcelRequire("gPSfP")));

var $b6106a83ef1d6ba5$var$_DictationInterims = $b6106a83ef1d6ba5$var$_interopRequireWildcard((parcelRequire("kGvuG")));

var $b6106a83ef1d6ba5$var$_MicrophoneButton = $b6106a83ef1d6ba5$var$_interopRequireWildcard((parcelRequire("dtULG")));

var $b6106a83ef1d6ba5$var$_SendButton = $b6106a83ef1d6ba5$var$_interopRequireWildcard((parcelRequire("64e5f")));

var $b6106a83ef1d6ba5$var$_TextBox = $b6106a83ef1d6ba5$var$_interopRequireWildcard((parcelRequire("6sNkp")));

var $b6106a83ef1d6ba5$var$_SuggestedActions = $b6106a83ef1d6ba5$var$_interopRequireWildcard((parcelRequire("lP26E")));

var $b6106a83ef1d6ba5$var$_UploadButton = $b6106a83ef1d6ba5$var$_interopRequireWildcard((parcelRequire("b4v9C")));

var $b6106a83ef1d6ba5$var$_connectToWebChat = $b6106a83ef1d6ba5$var$_interopRequireDefault((parcelRequire("86vmQ")));

var $b6106a83ef1d6ba5$var$_WebChatUIContext = $b6106a83ef1d6ba5$var$_interopRequireDefault((parcelRequire("59jaJ")));

var $b6106a83ef1d6ba5$var$_createCoreMiddleware = $b6106a83ef1d6ba5$var$_interopRequireDefault((parcelRequire("9AQhK")));

var $b6106a83ef1d6ba5$var$_createCoreMiddleware2 = $b6106a83ef1d6ba5$var$_interopRequireDefault((parcelRequire("elZtZ")));

var $b6106a83ef1d6ba5$var$_createCoreMiddleware3 = $b6106a83ef1d6ba5$var$_interopRequireDefault((parcelRequire("l1gyp")));

var $b6106a83ef1d6ba5$var$_createStyleSet = $b6106a83ef1d6ba5$var$_interopRequireDefault((parcelRequire("1MGBN")));

var $b6106a83ef1d6ba5$var$_getTabIndex = $b6106a83ef1d6ba5$var$_interopRequireDefault((parcelRequire("5wWAs")));

var $b6106a83ef1d6ba5$var$componentHooks = $b6106a83ef1d6ba5$var$_interopRequireWildcard((parcelRequire("kssQU")));
function $b6106a83ef1d6ba5$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($b6106a83ef1d6ba5$var$_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $b6106a83ef1d6ba5$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || $b6106a83ef1d6ba5$var$_typeof(obj) !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $b6106a83ef1d6ba5$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $b6106a83ef1d6ba5$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $b6106a83ef1d6ba5$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $b6106a83ef1d6ba5$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $b6106a83ef1d6ba5$var$ownKeys(Object(source), !0).forEach(function(key) {
            $b6106a83ef1d6ba5$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $b6106a83ef1d6ba5$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $b6106a83ef1d6ba5$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $b6106a83ef1d6ba5$var$hooks = $b6106a83ef1d6ba5$var$_objectSpread($b6106a83ef1d6ba5$var$_objectSpread({}, $hd4g0.hooks), $b6106a83ef1d6ba5$var$componentHooks);
module.exports.hooks = $b6106a83ef1d6ba5$var$hooks;
var $b6106a83ef1d6ba5$var$version = "4.15.8";
module.exports.version = $b6106a83ef1d6ba5$var$version;
var $b6106a83ef1d6ba5$var$Components = {
    BasicWebChat: $b6106a83ef1d6ba5$var$_BasicWebChat.default,
    Composer: $b6106a83ef1d6ba5$var$_Composer.default,
    // Components for restructuring BasicWebChat
    AccessKeySinkSurface: $b6106a83ef1d6ba5$var$_Surface.default,
    BasicConnectivityStatus: $b6106a83ef1d6ba5$var$_BasicConnectivityStatus.default,
    BasicSendBox: $b6106a83ef1d6ba5$var$_BasicSendBox.default,
    BasicToaster: $b6106a83ef1d6ba5$var$_BasicToaster.default,
    BasicTranscript: $b6106a83ef1d6ba5$var$_BasicTranscript.default,
    // Components for recomposing activities and attachments
    AudioContent: $b6106a83ef1d6ba5$var$_AudioContent.default,
    FileContent: $b6106a83ef1d6ba5$var$_FileContent.default,
    HTMLVideoContent: $b6106a83ef1d6ba5$var$_HTMLVideoContent.default,
    ImageContent: $b6106a83ef1d6ba5$var$_ImageContent.default,
    TextContent: $b6106a83ef1d6ba5$var$_TextContent.default,
    VideoContent: $b6106a83ef1d6ba5$var$_VideoContent.default,
    VimeoContent: $b6106a83ef1d6ba5$var$_VimeoContent.default,
    YouTubeContent: $b6106a83ef1d6ba5$var$_YouTubeContent.default,
    // Components for recomposing transcript
    Avatar: $b6106a83ef1d6ba5$var$_Avatar.default,
    Bubble: $b6106a83ef1d6ba5$var$_Bubble.default,
    ErrorBox: $b6106a83ef1d6ba5$var$_ErrorBox.default,
    SendStatus: $b6106a83ef1d6ba5$var$_SendStatus.default,
    SpeakActivity: $b6106a83ef1d6ba5$var$_Speak.default,
    Timestamp: $b6106a83ef1d6ba5$var$_Timestamp.default,
    connectSendStatus: $b6106a83ef1d6ba5$var$_SendStatus.connectSendStatus,
    connectSpeakActivity: $b6106a83ef1d6ba5$var$_Speak.connectSpeakActivity,
    // Components for recomposing send box
    DictationInterims: $b6106a83ef1d6ba5$var$_DictationInterims.default,
    MicrophoneButton: $b6106a83ef1d6ba5$var$_MicrophoneButton.default,
    SendButton: $b6106a83ef1d6ba5$var$_SendButton.default,
    SendTextBox: $b6106a83ef1d6ba5$var$_TextBox.default,
    SuggestedActions: $b6106a83ef1d6ba5$var$_SuggestedActions.default,
    UploadButton: $b6106a83ef1d6ba5$var$_UploadButton.default,
    connectDictationInterims: $b6106a83ef1d6ba5$var$_DictationInterims.connectDictationInterims,
    connectMicrophoneButton: $b6106a83ef1d6ba5$var$_MicrophoneButton.connectMicrophoneButton,
    connectSendButton: $b6106a83ef1d6ba5$var$_SendButton.connectSendButton,
    connectSendTextBox: $b6106a83ef1d6ba5$var$_TextBox.connectSendTextBox,
    connectSuggestedActions: $b6106a83ef1d6ba5$var$_SuggestedActions.connectSuggestedActions,
    connectUploadButton: $b6106a83ef1d6ba5$var$_UploadButton.connectUploadButton
};
module.exports.Components = $b6106a83ef1d6ba5$var$Components;
var $b6106a83ef1d6ba5$var$_default = $b6106a83ef1d6ba5$var$_ReactWebChat.default;
module.exports.default = $b6106a83ef1d6ba5$var$_default;

});
parcelRequire.register("hd4g0", function(module, exports) {
"use strict";
function $c876f3ed9450d00a$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $c876f3ed9450d00a$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $c876f3ed9450d00a$var$_typeof(obj);
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "Composer", {
    enumerable: true,
    get: function get() {
        return $c876f3ed9450d00a$var$_Composer.default;
    }
});
Object.defineProperty(module.exports, "concatMiddleware", {
    enumerable: true,
    get: function get() {
        return $c876f3ed9450d00a$var$_concatMiddleware.default;
    }
});
Object.defineProperty(module.exports, "defaultStyleOptions", {
    enumerable: true,
    get: function get() {
        return $c876f3ed9450d00a$var$_defaultStyleOptions.default;
    }
});
module.exports.hooks = void 0;
Object.defineProperty(module.exports, "localize", {
    enumerable: true,
    get: function get() {
        return $2c5dV.localize;
    }
});
Object.defineProperty(module.exports, "normalizeStyleOptions", {
    enumerable: true,
    get: function get() {
        return $c876f3ed9450d00a$var$_normalizeStyleOptions.default;
    }
});

var $2c5dV = parcelRequire("2c5dV");

var $c876f3ed9450d00a$var$hooks = $c876f3ed9450d00a$var$_interopRequireWildcard((parcelRequire("gySRD")));
module.exports.hooks = $c876f3ed9450d00a$var$hooks;

var $c876f3ed9450d00a$var$_Composer = $c876f3ed9450d00a$var$_interopRequireDefault((parcelRequire("a6Izx")));

var $c876f3ed9450d00a$var$_concatMiddleware = $c876f3ed9450d00a$var$_interopRequireDefault((parcelRequire("8tA2t")));

var $c876f3ed9450d00a$var$_defaultStyleOptions = $c876f3ed9450d00a$var$_interopRequireDefault((parcelRequire("eBJPD")));

var $c876f3ed9450d00a$var$_normalizeStyleOptions = $c876f3ed9450d00a$var$_interopRequireDefault((parcelRequire("hOQU1")));
function $c876f3ed9450d00a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $c876f3ed9450d00a$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($c876f3ed9450d00a$var$_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $c876f3ed9450d00a$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || $c876f3ed9450d00a$var$_typeof(obj) !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $c876f3ed9450d00a$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}

});
parcelRequire.register("2c5dV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "getRTLList", {
    enumerable: true,
    get: function get() {
        return $1990c112eb33dcb1$var$_getRTLList.default;
    }
});
module.exports.localize = $1990c112eb33dcb1$var$localize;

var $cG9B9 = parcelRequire("cG9B9");

var $1990c112eb33dcb1$var$_getAllLocalizedStrings = $1990c112eb33dcb1$var$_interopRequireDefault((parcelRequire("k99nF")));

var $1990c112eb33dcb1$var$_getRTLList = $1990c112eb33dcb1$var$_interopRequireDefault((parcelRequire("4sDgs")));

var $1990c112eb33dcb1$var$_normalizeLanguage = $1990c112eb33dcb1$var$_interopRequireDefault((parcelRequire("dv55n")));
function $1990c112eb33dcb1$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $1990c112eb33dcb1$var$_slicedToArray(arr, i) {
    return $1990c112eb33dcb1$var$_arrayWithHoles(arr) || $1990c112eb33dcb1$var$_iterableToArrayLimit(arr, i) || $1990c112eb33dcb1$var$_unsupportedIterableToArray(arr, i) || $1990c112eb33dcb1$var$_nonIterableRest();
}
function $1990c112eb33dcb1$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $1990c112eb33dcb1$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $1990c112eb33dcb1$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $1990c112eb33dcb1$var$_arrayLikeToArray(o, minLen);
}
function $1990c112eb33dcb1$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $1990c112eb33dcb1$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $1990c112eb33dcb1$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
var $1990c112eb33dcb1$var$deprecationNotesShown;
function $1990c112eb33dcb1$var$localize(id, language) {
    if (!$1990c112eb33dcb1$var$deprecationNotesShown) {
        console.warn("botframework-webchat: localize() is deprecated. Please use the useLocalizer() hooks instead. This function will be removed on or after 2022-02-12.");
        $1990c112eb33dcb1$var$deprecationNotesShown = true;
    }
    var allStrings = (0, $1990c112eb33dcb1$var$_getAllLocalizedStrings.default)();
    var normalizedLanguage = (0, $1990c112eb33dcb1$var$_normalizeLanguage.default)(language); // Mitigation through denylisting.
    // eslint-disable-next-line security/detect-object-injection
    var localizedStrings = (0, $cG9B9.isForbiddenPropertyName)(language) ? undefined : allStrings[normalizedLanguage];
    for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)args[_key - 2] = arguments[_key];
    return Object.entries(args).reduce(function(value, _ref) {
        var _ref2 = $1990c112eb33dcb1$var$_slicedToArray(_ref, 2), index = _ref2[0], arg = _ref2[1];
        return typeof value === "string" ? value.replace("$".concat(+index + 1), arg) : value;
    }, // eslint-disable-next-line security/detect-object-injection
    (0, $cG9B9.isForbiddenPropertyName)(id) ? "" : localizedStrings && localizedStrings[id] || allStrings["en-US"][id] || "");
}

});
parcelRequire.register("cG9B9", function(module, exports) {
"use strict";

var $8usDI = parcelRequire("8usDI");

var $UAGsq = parcelRequire("UAGsq");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Constants = void 0;
Object.defineProperty(module.exports, "clearSuggestedActions", {
    enumerable: true,
    get: function get() {
        return $93b0da4e2a54e77c$var$_clearSuggestedActions["default"];
    }
});
Object.defineProperty(module.exports, "connect", {
    enumerable: true,
    get: function get() {
        return $93b0da4e2a54e77c$var$_connect["default"];
    }
});
Object.defineProperty(module.exports, "createStore", {
    enumerable: true,
    get: function get() {
        return $93b0da4e2a54e77c$var$_createStore["default"];
    }
});
Object.defineProperty(module.exports, "createStoreWithDevTools", {
    enumerable: true,
    get: function get() {
        return $93b0da4e2a54e77c$var$_createStore.withDevTools;
    }
});
Object.defineProperty(module.exports, "createStoreWithOptions", {
    enumerable: true,
    get: function get() {
        return $93b0da4e2a54e77c$var$_createStore.withOptions;
    }
});
Object.defineProperty(module.exports, "disconnect", {
    enumerable: true,
    get: function get() {
        return $93b0da4e2a54e77c$var$_disconnect["default"];
    }
});
Object.defineProperty(module.exports, "dismissNotification", {
    enumerable: true,
    get: function get() {
        return $93b0da4e2a54e77c$var$_dismissNotification["default"];
    }
});
Object.defineProperty(module.exports, "emitTypingIndicator", {
    enumerable: true,
    get: function get() {
        return $93b0da4e2a54e77c$var$_emitTypingIndicator["default"];
    }
});
Object.defineProperty(module.exports, "isForbiddenPropertyName", {
    enumerable: true,
    get: function get() {
        return $93b0da4e2a54e77c$var$_isForbiddenPropertyName["default"];
    }
});
Object.defineProperty(module.exports, "markActivity", {
    enumerable: true,
    get: function get() {
        return $93b0da4e2a54e77c$var$_markActivity["default"];
    }
});
Object.defineProperty(module.exports, "postActivity", {
    enumerable: true,
    get: function get() {
        return $93b0da4e2a54e77c$var$_postActivity["default"];
    }
});
Object.defineProperty(module.exports, "sendEvent", {
    enumerable: true,
    get: function get() {
        return $93b0da4e2a54e77c$var$_sendEvent["default"];
    }
});
Object.defineProperty(module.exports, "sendFiles", {
    enumerable: true,
    get: function get() {
        return $93b0da4e2a54e77c$var$_sendFiles["default"];
    }
});
Object.defineProperty(module.exports, "sendMessage", {
    enumerable: true,
    get: function get() {
        return $93b0da4e2a54e77c$var$_sendMessage["default"];
    }
});
Object.defineProperty(module.exports, "sendMessageBack", {
    enumerable: true,
    get: function get() {
        return $93b0da4e2a54e77c$var$_sendMessageBack["default"];
    }
});
Object.defineProperty(module.exports, "sendPostBack", {
    enumerable: true,
    get: function get() {
        return $93b0da4e2a54e77c$var$_sendPostBack["default"];
    }
});
Object.defineProperty(module.exports, "setDictateInterims", {
    enumerable: true,
    get: function get() {
        return $93b0da4e2a54e77c$var$_setDictateInterims["default"];
    }
});
Object.defineProperty(module.exports, "setDictateState", {
    enumerable: true,
    get: function get() {
        return $93b0da4e2a54e77c$var$_setDictateState["default"];
    }
});
Object.defineProperty(module.exports, "setLanguage", {
    enumerable: true,
    get: function get() {
        return $93b0da4e2a54e77c$var$_setLanguage["default"];
    }
});
Object.defineProperty(module.exports, "setNotification", {
    enumerable: true,
    get: function get() {
        return $93b0da4e2a54e77c$var$_setNotification["default"];
    }
});
Object.defineProperty(module.exports, "setSendBox", {
    enumerable: true,
    get: function get() {
        return $93b0da4e2a54e77c$var$_setSendBox["default"];
    }
});
Object.defineProperty(module.exports, "setSendTimeout", {
    enumerable: true,
    get: function get() {
        return $93b0da4e2a54e77c$var$_setSendTimeout["default"];
    }
});
Object.defineProperty(module.exports, "setSendTypingIndicator", {
    enumerable: true,
    get: function get() {
        return $93b0da4e2a54e77c$var$_setSendTypingIndicator["default"];
    }
});
Object.defineProperty(module.exports, "singleToArray", {
    enumerable: true,
    get: function get() {
        return $93b0da4e2a54e77c$var$_singleToArray["default"];
    }
});
Object.defineProperty(module.exports, "startDictate", {
    enumerable: true,
    get: function get() {
        return $93b0da4e2a54e77c$var$_startDictate["default"];
    }
});
Object.defineProperty(module.exports, "startSpeakingActivity", {
    enumerable: true,
    get: function get() {
        return $93b0da4e2a54e77c$var$_startSpeakingActivity["default"];
    }
});
Object.defineProperty(module.exports, "stopDictate", {
    enumerable: true,
    get: function get() {
        return $93b0da4e2a54e77c$var$_stopDictate["default"];
    }
});
Object.defineProperty(module.exports, "stopSpeakingActivity", {
    enumerable: true,
    get: function get() {
        return $93b0da4e2a54e77c$var$_stopSpeakingActivity["default"];
    }
});
Object.defineProperty(module.exports, "submitSendBox", {
    enumerable: true,
    get: function get() {
        return $93b0da4e2a54e77c$var$_submitSendBox["default"];
    }
});
module.exports.version = void 0;
Object.defineProperty(module.exports, "warnOnce", {
    enumerable: true,
    get: function get() {
        return $93b0da4e2a54e77c$var$_warnOnce["default"];
    }
});

var $93b0da4e2a54e77c$var$ActivityClientState = $93b0da4e2a54e77c$var$_interopRequireWildcard((parcelRequire("hOWci")));

var $93b0da4e2a54e77c$var$DictateState = $93b0da4e2a54e77c$var$_interopRequireWildcard((parcelRequire("5iNAf")));

var $93b0da4e2a54e77c$var$_clearSuggestedActions = $8usDI((parcelRequire("c2kkc")));

var $93b0da4e2a54e77c$var$_connect = $8usDI((parcelRequire("dd04G")));

var $93b0da4e2a54e77c$var$_createStore = $93b0da4e2a54e77c$var$_interopRequireWildcard((parcelRequire("gohnK")));

var $93b0da4e2a54e77c$var$_disconnect = $8usDI((parcelRequire("arcsH")));

var $93b0da4e2a54e77c$var$_dismissNotification = $8usDI((parcelRequire("cIHCl")));

var $93b0da4e2a54e77c$var$_emitTypingIndicator = $8usDI((parcelRequire("4I2lF")));

var $93b0da4e2a54e77c$var$_isForbiddenPropertyName = $8usDI((parcelRequire("1BBNC")));

var $93b0da4e2a54e77c$var$_markActivity = $8usDI((parcelRequire("ciuoj")));

var $93b0da4e2a54e77c$var$_postActivity = $8usDI((parcelRequire("lnNkF")));

var $93b0da4e2a54e77c$var$_sendEvent = $8usDI((parcelRequire("by2Od")));

var $93b0da4e2a54e77c$var$_sendFiles = $8usDI((parcelRequire("7ZJF5")));

var $93b0da4e2a54e77c$var$_sendMessage = $8usDI((parcelRequire("bfXvF")));

var $93b0da4e2a54e77c$var$_sendMessageBack = $8usDI((parcelRequire("cVxSW")));

var $93b0da4e2a54e77c$var$_sendPostBack = $8usDI((parcelRequire("doIlR")));

var $93b0da4e2a54e77c$var$_setDictateInterims = $8usDI((parcelRequire("5LTDK")));

var $93b0da4e2a54e77c$var$_setDictateState = $8usDI((parcelRequire("eKwpg")));

var $93b0da4e2a54e77c$var$_setLanguage = $8usDI((parcelRequire("hx0hD")));

var $93b0da4e2a54e77c$var$_setNotification = $8usDI((parcelRequire("11xig")));

var $93b0da4e2a54e77c$var$_setSendBox = $8usDI((parcelRequire("bu0xL")));

var $93b0da4e2a54e77c$var$_setSendTimeout = $8usDI((parcelRequire("9Ynym")));

var $93b0da4e2a54e77c$var$_setSendTypingIndicator = $8usDI((parcelRequire("gYgS6")));

var $93b0da4e2a54e77c$var$_singleToArray = $8usDI((parcelRequire("4gh84")));

var $93b0da4e2a54e77c$var$_startDictate = $8usDI((parcelRequire("1tniU")));

var $93b0da4e2a54e77c$var$_startSpeakingActivity = $8usDI((parcelRequire("chC6e")));

var $93b0da4e2a54e77c$var$_stopDictate = $8usDI((parcelRequire("5Nb9e")));

var $93b0da4e2a54e77c$var$_stopSpeakingActivity = $8usDI((parcelRequire("cbRU8")));

var $93b0da4e2a54e77c$var$_submitSendBox = $8usDI((parcelRequire("gW4yE")));

var $93b0da4e2a54e77c$var$_warnOnce = $8usDI((parcelRequire("3hXJH")));
function $93b0da4e2a54e77c$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($93b0da4e2a54e77c$var$_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $93b0da4e2a54e77c$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || $UAGsq(obj) !== "object" && typeof obj !== "function") return {
        "default": obj
    };
    var cache = $93b0da4e2a54e77c$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj["default"] = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
var $93b0da4e2a54e77c$var$Constants = {
    ActivityClientState: $93b0da4e2a54e77c$var$ActivityClientState,
    DictateState: $93b0da4e2a54e77c$var$DictateState
};
module.exports.Constants = $93b0da4e2a54e77c$var$Constants;
var $93b0da4e2a54e77c$var$version = "4.15.8";
module.exports.version = $93b0da4e2a54e77c$var$version;

});

parcelRequire.register("k99nF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $eaabecb5f6d97aa5$var$_arEG = $eaabecb5f6d97aa5$var$_interopRequireDefault((parcelRequire("fJ3ns")));

var $eaabecb5f6d97aa5$var$_arJO = $eaabecb5f6d97aa5$var$_interopRequireDefault((parcelRequire("gJpWG")));

var $eaabecb5f6d97aa5$var$_arSA = $eaabecb5f6d97aa5$var$_interopRequireDefault((parcelRequire("luhvd")));

var $eaabecb5f6d97aa5$var$_bgBG = $eaabecb5f6d97aa5$var$_interopRequireDefault((parcelRequire("aQ3Or")));

var $eaabecb5f6d97aa5$var$_caES = $eaabecb5f6d97aa5$var$_interopRequireDefault((parcelRequire("i9plw")));

var $eaabecb5f6d97aa5$var$_csCZ = $eaabecb5f6d97aa5$var$_interopRequireDefault((parcelRequire("1GRZ0")));

var $eaabecb5f6d97aa5$var$_daDK = $eaabecb5f6d97aa5$var$_interopRequireDefault((parcelRequire("lvjF5")));

var $eaabecb5f6d97aa5$var$_deDE = $eaabecb5f6d97aa5$var$_interopRequireDefault((parcelRequire("jIDt0")));

var $eaabecb5f6d97aa5$var$_elGR = $eaabecb5f6d97aa5$var$_interopRequireDefault((parcelRequire("50BGy")));

var $eaabecb5f6d97aa5$var$_enUS = $eaabecb5f6d97aa5$var$_interopRequireDefault((parcelRequire("c0YBH")));

var $eaabecb5f6d97aa5$var$_esES = $eaabecb5f6d97aa5$var$_interopRequireDefault((parcelRequire("hxnEE")));

var $eaabecb5f6d97aa5$var$_etEE = $eaabecb5f6d97aa5$var$_interopRequireDefault((parcelRequire("2OzYo")));

var $eaabecb5f6d97aa5$var$_euES = $eaabecb5f6d97aa5$var$_interopRequireDefault((parcelRequire("4TByh")));

var $eaabecb5f6d97aa5$var$_fiFI = $eaabecb5f6d97aa5$var$_interopRequireDefault((parcelRequire("cbhcs")));

var $eaabecb5f6d97aa5$var$_frFR = $eaabecb5f6d97aa5$var$_interopRequireDefault((parcelRequire("5Qphx")));

var $eaabecb5f6d97aa5$var$_glES = $eaabecb5f6d97aa5$var$_interopRequireDefault((parcelRequire("lb8Vn")));

var $eaabecb5f6d97aa5$var$_heIL = $eaabecb5f6d97aa5$var$_interopRequireDefault((parcelRequire("lM2kF")));

var $eaabecb5f6d97aa5$var$_hiIN = $eaabecb5f6d97aa5$var$_interopRequireDefault((parcelRequire("cpYux")));

var $eaabecb5f6d97aa5$var$_hrHR = $eaabecb5f6d97aa5$var$_interopRequireDefault((parcelRequire("fS9bC")));

var $eaabecb5f6d97aa5$var$_huHU = $eaabecb5f6d97aa5$var$_interopRequireDefault((parcelRequire("kP2Yl")));

var $eaabecb5f6d97aa5$var$_idID = $eaabecb5f6d97aa5$var$_interopRequireDefault((parcelRequire("1LUJi")));

var $eaabecb5f6d97aa5$var$_itIT = $eaabecb5f6d97aa5$var$_interopRequireDefault((parcelRequire("dc1HK")));

var $eaabecb5f6d97aa5$var$_jaJP = $eaabecb5f6d97aa5$var$_interopRequireDefault((parcelRequire("hamQs")));

var $eaabecb5f6d97aa5$var$_kkKZ = $eaabecb5f6d97aa5$var$_interopRequireDefault((parcelRequire("1x8UP")));

var $eaabecb5f6d97aa5$var$_koKR = $eaabecb5f6d97aa5$var$_interopRequireDefault((parcelRequire("9kaYl")));

var $eaabecb5f6d97aa5$var$_ltLT = $eaabecb5f6d97aa5$var$_interopRequireDefault((parcelRequire("60Z0a")));

var $eaabecb5f6d97aa5$var$_lvLV = $eaabecb5f6d97aa5$var$_interopRequireDefault((parcelRequire("6OVKM")));

var $eaabecb5f6d97aa5$var$_msMY = $eaabecb5f6d97aa5$var$_interopRequireDefault((parcelRequire("emUnE")));

var $eaabecb5f6d97aa5$var$_nbNO = $eaabecb5f6d97aa5$var$_interopRequireDefault((parcelRequire("7zhqW")));

var $eaabecb5f6d97aa5$var$_nlNL = $eaabecb5f6d97aa5$var$_interopRequireDefault((parcelRequire("g3fnr")));

var $eaabecb5f6d97aa5$var$_plPL = $eaabecb5f6d97aa5$var$_interopRequireDefault((parcelRequire("fgJZj")));

var $eaabecb5f6d97aa5$var$_ptBR = $eaabecb5f6d97aa5$var$_interopRequireDefault((parcelRequire("dBJNg")));

var $eaabecb5f6d97aa5$var$_ptPT = $eaabecb5f6d97aa5$var$_interopRequireDefault((parcelRequire("1qvwv")));

var $eaabecb5f6d97aa5$var$_roRO = $eaabecb5f6d97aa5$var$_interopRequireDefault((parcelRequire("l4t9G")));

var $eaabecb5f6d97aa5$var$_ruRU = $eaabecb5f6d97aa5$var$_interopRequireDefault((parcelRequire("4MlL2")));

var $eaabecb5f6d97aa5$var$_skSK = $eaabecb5f6d97aa5$var$_interopRequireDefault((parcelRequire("4TRE2")));

var $eaabecb5f6d97aa5$var$_slSI = $eaabecb5f6d97aa5$var$_interopRequireDefault((parcelRequire("llOan")));

var $eaabecb5f6d97aa5$var$_srCyrlCS = $eaabecb5f6d97aa5$var$_interopRequireDefault((parcelRequire("4QVZI")));

var $eaabecb5f6d97aa5$var$_srLatnCS = $eaabecb5f6d97aa5$var$_interopRequireDefault((parcelRequire("9sLtU")));

var $eaabecb5f6d97aa5$var$_svSE = $eaabecb5f6d97aa5$var$_interopRequireDefault((parcelRequire("4a58f")));

var $eaabecb5f6d97aa5$var$_thTH = $eaabecb5f6d97aa5$var$_interopRequireDefault((parcelRequire("9CH30")));

var $eaabecb5f6d97aa5$var$_trTR = $eaabecb5f6d97aa5$var$_interopRequireDefault((parcelRequire("l3zzC")));

var $eaabecb5f6d97aa5$var$_ukUA = $eaabecb5f6d97aa5$var$_interopRequireDefault((parcelRequire("8RIRv")));

var $eaabecb5f6d97aa5$var$_viVN = $eaabecb5f6d97aa5$var$_interopRequireDefault((parcelRequire("6N7IJ")));

var $eaabecb5f6d97aa5$var$_yue = $eaabecb5f6d97aa5$var$_interopRequireDefault((parcelRequire("4nwq4")));

var $eaabecb5f6d97aa5$var$_zhCN = $eaabecb5f6d97aa5$var$_interopRequireDefault((parcelRequire("NDOZ2")));

var $eaabecb5f6d97aa5$var$_zhHK = $eaabecb5f6d97aa5$var$_interopRequireDefault((parcelRequire("l2l1P")));

var $eaabecb5f6d97aa5$var$_zhTW = $eaabecb5f6d97aa5$var$_interopRequireDefault((parcelRequire("185Py")));

var $eaabecb5f6d97aa5$var$_overrides = $eaabecb5f6d97aa5$var$_interopRequireDefault((parcelRequire("9KRJw")));

var $eaabecb5f6d97aa5$var$_mergeLocalizedStrings = $eaabecb5f6d97aa5$var$_interopRequireDefault((parcelRequire("4cVop")));
function $eaabecb5f6d97aa5$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
// Strings commented out are pending official translations
var $eaabecb5f6d97aa5$var$localizedStrings;
function $eaabecb5f6d97aa5$var$getAllLocalizedStrings() {
    return $eaabecb5f6d97aa5$var$localizedStrings || ($eaabecb5f6d97aa5$var$localizedStrings = (0, $eaabecb5f6d97aa5$var$_mergeLocalizedStrings.default)({
        "ar-EG": $eaabecb5f6d97aa5$var$_arEG.default,
        "ar-JO": $eaabecb5f6d97aa5$var$_arJO.default,
        "ar-SA": $eaabecb5f6d97aa5$var$_arSA.default,
        "bg-BG": $eaabecb5f6d97aa5$var$_bgBG.default,
        "ca-ES": $eaabecb5f6d97aa5$var$_caES.default,
        "cs-CZ": $eaabecb5f6d97aa5$var$_csCZ.default,
        "da-DK": $eaabecb5f6d97aa5$var$_daDK.default,
        "de-DE": $eaabecb5f6d97aa5$var$_deDE.default,
        "el-GR": $eaabecb5f6d97aa5$var$_elGR.default,
        "en-US": $eaabecb5f6d97aa5$var$_enUS.default,
        "es-ES": $eaabecb5f6d97aa5$var$_esES.default,
        "et-EE": $eaabecb5f6d97aa5$var$_etEE.default,
        "eu-ES": $eaabecb5f6d97aa5$var$_euES.default,
        "fi-FI": $eaabecb5f6d97aa5$var$_fiFI.default,
        "fr-FR": $eaabecb5f6d97aa5$var$_frFR.default,
        "gl-ES": $eaabecb5f6d97aa5$var$_glES.default,
        "he-IL": $eaabecb5f6d97aa5$var$_heIL.default,
        "hi-IN": $eaabecb5f6d97aa5$var$_hiIN.default,
        "hr-HR": $eaabecb5f6d97aa5$var$_hrHR.default,
        "hu-HU": $eaabecb5f6d97aa5$var$_huHU.default,
        "id-ID": $eaabecb5f6d97aa5$var$_idID.default,
        "it-IT": $eaabecb5f6d97aa5$var$_itIT.default,
        "ja-JP": $eaabecb5f6d97aa5$var$_jaJP.default,
        "kk-KZ": $eaabecb5f6d97aa5$var$_kkKZ.default,
        "ko-KR": $eaabecb5f6d97aa5$var$_koKR.default,
        "lt-LT": $eaabecb5f6d97aa5$var$_ltLT.default,
        "lv-LV": $eaabecb5f6d97aa5$var$_lvLV.default,
        "ms-MY": $eaabecb5f6d97aa5$var$_msMY.default,
        "nb-NO": $eaabecb5f6d97aa5$var$_nbNO.default,
        "nl-NL": $eaabecb5f6d97aa5$var$_nlNL.default,
        "pl-PL": $eaabecb5f6d97aa5$var$_plPL.default,
        "pt-BR": $eaabecb5f6d97aa5$var$_ptBR.default,
        "pt-PT": $eaabecb5f6d97aa5$var$_ptPT.default,
        "ro-RO": $eaabecb5f6d97aa5$var$_roRO.default,
        "ru-RU": $eaabecb5f6d97aa5$var$_ruRU.default,
        "sk-SK": $eaabecb5f6d97aa5$var$_skSK.default,
        "sl-SI": $eaabecb5f6d97aa5$var$_slSI.default,
        "sr-Cyrl": $eaabecb5f6d97aa5$var$_srCyrlCS.default,
        "sr-Latn": $eaabecb5f6d97aa5$var$_srLatnCS.default,
        "sv-SE": $eaabecb5f6d97aa5$var$_svSE.default,
        "th-TH": $eaabecb5f6d97aa5$var$_thTH.default,
        "tr-TR": $eaabecb5f6d97aa5$var$_trTR.default,
        "uk-UA": $eaabecb5f6d97aa5$var$_ukUA.default,
        "vi-VN": $eaabecb5f6d97aa5$var$_viVN.default,
        yue: $eaabecb5f6d97aa5$var$_yue.default,
        "zh-Hans": $eaabecb5f6d97aa5$var$_zhCN.default,
        "zh-Hant": $eaabecb5f6d97aa5$var$_zhTW.default,
        "zh-Hans-SG": $eaabecb5f6d97aa5$var$_zhCN.default,
        "zh-Hant-HK": $eaabecb5f6d97aa5$var$_zhHK.default,
        "zh-Hant-MO": $eaabecb5f6d97aa5$var$_zhTW.default
    }, $eaabecb5f6d97aa5$var$_overrides.default));
}
var $eaabecb5f6d97aa5$var$_default = $eaabecb5f6d97aa5$var$getAllLocalizedStrings;
module.exports.default = $eaabecb5f6d97aa5$var$_default;

});
parcelRequire.register("fJ3ns", function(module, exports) {
module.exports = JSON.parse('{"_.comment":"The content of this file is contributed by the community.","ACTIVITY_BOT_SAID":"البوت $1 قال, $2 أرسل: $3","ACTIVITY_ERROR_BOX_TITLE":"رسالة خطأ","ACTIVITY_STATUS_SEND_FAILED_RETRY":"[إعادة المحاولة][RETRY]. فشل في الإرسال.","ACTIVITY_STATUS_SEND_STATUS_ALT_SENDING":"أرسال","ACTIVITY_STATUS_SEND_STATUS_ALT_SENT_AT":"أرسل: $1","ACTIVITY_STATUS_SEND_STATUS_ALT":"ارسل الحالة: $1","ACTIVITY_STATUS_TIMESTAMP_JUST_NOW":"حالا","ACTIVITY_STATUS_TIMESTAMP_ONE_HOUR_AGO":"حالا","ACTIVITY_STATUS_TIMESTAMP_ONE_MINUTE_AGO":"حالا","ACTIVITY_STATUS_TIMESTAMP_TODAY":"حالا","ACTIVITY_STATUS_TIMESTAMP_YESTERDAY":"حالا","ACTIVITY_USER_SAID":"المستخدم $1 قال, $2 أرسل: $3","CAROUSEL_ATTACHMENTS_BOT_ALT":"البوت ارسل:","CAROUSEL_ATTACHMENTS_USER_ALT":"المستخدم أرسل: ","CAROUSEL_FLIPPER_LEFT_ALT":"يسار","CAROUSEL_FLIPPER_RIGHT_ALT":"يمين","CONNECTIVITY_STATUS_ALT_CONNECTED":"متصل","CONNECTIVITY_STATUS_ALT_CONNECTING":"يتم التوصيل…","CONNECTIVITY_STATUS_ALT_FATAL":"غير قادر على الاتصال.","CONNECTIVITY_STATUS_ALT_RECONNECTING":"حدث انقطاع في الشبكة. إعادة التوصيل…","CONNECTIVITY_STATUS_ALT_RENDER_ERROR":"خطأ في التقديم. يرجى التحقق من وحدة التحكم أو الاتصال بمطور البوت.","CONNECTIVITY_STATUS_ALT_SLOW_CONNECTION":"يستغرق وقتا أطول من المعتاد للاتصال.","FILE_CONTENT_ALT":"\'$1\'","FILE_CONTENT_DOWNLOADABLE_ALT":"تحميل الملف \'$1\'","FILE_CONTENT_DOWNLOADABLE_WITH_SIZE_ALT":"تحميل ملف تحميل الملف $1 بحجم $2","FILE_CONTENT_WITH_SIZE_ALT":"$1 بحجم $2","RECEIPT_CARD_TAX":"ضريبة","RECEIPT_CARD_TOTAL":"المجموع","RECEIPT_CARD_VAT":"ضريبة القيمة المضافة","SPEECH_INPUT_LISTENING":"يستمع…","SPEECH_INPUT_MICROPHONE_BUTTON_CLOSE_ALT":"الميكروفون مغلق","SPEECH_INPUT_MICROPHONE_BUTTON_OPEN_ALT":"الميكروفون قيد التشغيل","SPEECH_INPUT_STARTING":"يبدأ…","TEXT_INPUT_PLACEHOLDER":"اكتب رسالتك","TEXT_INPUT_SEND_BUTTON_ALT":"أرسل","TEXT_INPUT_SPEAK_BUTTON_ALT":"تكلم","TEXT_INPUT_UPLOAD_BUTTON_ALT":"رفع الملف","TRANSCRIPT_NEW_MESSAGES":"رسائل جديدة","TYPING_INDICATOR_ALT":"عرض مؤشر الكتابة"}');

});

parcelRequire.register("gJpWG", function(module, exports) {
module.exports = JSON.parse('{"_.comment":"The content of this file is contributed by the community.","ACTIVITY_BOT_SAID":"رد الآلي $1 قال, $2 أرسل ب: $3","ACTIVITY_ERROR_BOX_TITLE":"رسالة المشكلة","ACTIVITY_STATUS_SEND_FAILED_RETRY":"فشل في الارسال. [إعادة المحوالة][RETRY].","ACTIVITY_STATUS_SEND_STATUS_ALT_SENDING":"جاري الإرسال","ACTIVITY_STATUS_SEND_STATUS_ALT_SENT_AT":"أرسل ب: $1","ACTIVITY_STATUS_SEND_STATUS_ALT":"حالة الإرسال: $1","ACTIVITY_STATUS_TIMESTAMP_JUST_NOW":"الآن","ACTIVITY_STATUS_TIMESTAMP_ONE_HOUR_AGO":"الآن","ACTIVITY_STATUS_TIMESTAMP_ONE_MINUTE_AGO":"الآن","ACTIVITY_STATUS_TIMESTAMP_TODAY":"الآن","ACTIVITY_STATUS_TIMESTAMP_YESTERDAY":"الآن","ACTIVITY_USER_SAID":"المستخدم $1 قال, $2 أرسل ب: $3","ADAPTIVE_CARD_ERROR_BOX_TITLE_PARSE":"غير قادر على تفصيل بطاقة التكيف","ADAPTIVE_CARD_ERROR_BOX_TITLE_RENDER":"غير قادر على عرض بطاقة التكيف","CAROUSEL_ATTACHMENTS_BOT_ALT":"الرد الآلي أرسل: ","CAROUSEL_ATTACHMENTS_USER_ALT":"المستخدم أرسل: ","CAROUSEL_FLIPPER_LEFT_ALT":"يسار","CAROUSEL_FLIPPER_RIGHT_ALT":"يمين","CONNECTIVITY_STATUS_ALT_CONNECTED":"تم الإتصال","CONNECTIVITY_STATUS_ALT_CONNECTING":"يتم الاتصال…","CONNECTIVITY_STATUS_ALT_FATAL":"غير قادر عالإتصال.","CONNECTIVITY_STATUS_ALT_RECONNECTING":"حدث انقطاع في الشبكة. إعادة الاتصال…","CONNECTIVITY_STATUS_ALT_RENDER_ERROR":"خطأ تقديم. يرجى التحقق من وحدة التحكم أو الاتصال مطور الروبوت.","CONNECTIVITY_STATUS_ALT_SLOW_CONNECTION":"الإتصال يستغرق اكثر من المعتاد.","FILE_CONTENT_ALT":"\'$1\'","FILE_CONTENT_DOWNLOADABLE_ALT":"تحميل الملف \'$1\'","FILE_CONTENT_DOWNLOADABLE_WITH_SIZE_ALT":"تحميل الملف $1 بحجم $2","FILE_CONTENT_WITH_SIZE_ALT":"بحجم $1","RECEIPT_CARD_TAX":"ضريبة","RECEIPT_CARD_TOTAL":"المجموع","RECEIPT_CARD_VAT":"VAT","SPEECH_INPUT_LISTENING":"جاري الإستماع…","SPEECH_INPUT_MICROPHONE_BUTTON_CLOSE_ALT":"المايكروفون مغلق","SPEECH_INPUT_MICROPHONE_BUTTON_OPEN_ALT":"المايكروفون يعمل","SPEECH_INPUT_STARTING":"جاري البدء…","TEXT_INPUT_ALT":"صندوق الإرسال","TEXT_INPUT_PLACEHOLDER":"اكتب رسالتك","TEXT_INPUT_SEND_BUTTON_ALT":"إرسال","TEXT_INPUT_SPEAK_BUTTON_ALT":"تكلم","TEXT_INPUT_UPLOAD_BUTTON_ALT":"رفع الملف","TRANSCRIPT_NEW_MESSAGES":"رسائل جديدة","TYPING_INDICATOR_ALT":"يتم عرض مؤشر الكتابة"}');

});

parcelRequire.register("luhvd", function(module, exports) {
module.exports = JSON.parse('{"_comment":"[CI-LOCKED] محتوى هذا الملف مؤمن. نرحب بالمساهمات، ولكن التحقق من صحة التغيير قد يتأخر.","ACCESS_KEY_ALT":"Alt Shift $1","ACCESS_KEY_FOR_MAC_ALT":"Control Option $1","ACTIVITY_BOT_SAID_ALT":"قابل الروبوت $1:","ACTIVITY_YOU_SAID_ALT":"لقد قلت:","ACTIVITY_BOT_ATTACHED_ALT":"قام الروبوت بإرفاق:","ACTIVITY_ERROR_BOX_TITLE":"رسالة الخطأ","ACTIVITY_INTERACTIVE_FOOTNOTE_ALT":"انقر للتفاعل.","ACTIVITY_INTERACTIVE_REASON_INTERACTIVE_CONTENT_ALT":"الرسالة تفاعلية.","ACTIVITY_INTERACTIVE_REASON_LINK_ALT":"ارتباط واحد أو أكثر في الرسالة.","ACTIVITY_INTERACTIVE_REASON_SEND_FAILED_ALT":"فشل الإرسال.","ACTIVITY_YOU_ATTACHED_ALT":"لقد قمت بإرفاق:","ACTIVITY_NUM_ATTACHMENTS_ONE_ALT":"‏‏مرفق واحد.","ACTIVITY_NUM_ATTACHMENTS_FEW_ALT":"$1 مرفق (مرفقات).","ACTIVITY_NUM_ATTACHMENTS_MANY_ALT":"$1 مرفق (مرفقات).","ACTIVITY_NUM_ATTACHMENTS_OTHER_ALT":"$1 مرفق (مرفقات).","ACTIVITY_NUM_ATTACHMENTS_TWO_ALT":"$1 مرفق (مرفقات).","ACTIVITY_STATUS_SEND_FAILED_RETRY":"فشل الإرسال. [إعادة المحاولة][RETRY].","ACTIVITY_STATUS_SEND_STATUS_ALT_SENDING":"جارٍ الإرسال","ACTIVITY_STATUS_SEND_STATUS_ALT_SENT_AT":"تم إرسالها عند الساعة $1","ACTIVITY_STATUS_TIMESTAMP_JUST_NOW":"الآن","ACTIVITY_STATUS_TIMESTAMP_ONE_HOUR_AGO":"قبل ساعة","ACTIVITY_STATUS_TIMESTAMP_ONE_MINUTE_AGO":"قبل دقيقة","ACTIVITY_STATUS_TIMESTAMP_TODAY":"اليوم","ACTIVITY_STATUS_TIMESTAMP_YESTERDAY":"الأمس","ADAPTIVE_CARD_ERROR_BOX_TITLE_PARSE":"خطأ في تحليل البطاقة الموائمة","ADAPTIVE_CARD_ERROR_BOX_TITLE_RENDER":"خطأ في عرض البطاقة الموائمة","ATTACHMENT_AUDIO":"مقطع صوتي.","ATTACHMENT_CARD":"بطاقة: $1 $2 $3","ATTACHMENT_FILE":"ملف: $1","ATTACHMENT_IMAGE":"صورة","ATTACHMENT_TEXT":"نص: $1","ATTACHMENT_VIDEO":"مقطع فيديو","CAROUSEL_FLIPPER_LEFT_ALT":"يسار","CAROUSEL_FLIPPER_RIGHT_ALT":"يمين","CONNECTIVITY_STATUS_ALT_CONNECTED":"متصل","CONNECTIVITY_STATUS_ALT_CONNECTING":"جارٍ الاتصال…","CONNECTIVITY_STATUS_ALT_FATAL":"يتعذر الاتصال.","CONNECTIVITY_STATUS_ALT_RECONNECTING":"حدث انقطاع في الشبكة. جارٍ إعادة الاتصال…","CONNECTIVITY_STATUS_ALT_RENDER_ERROR":"خطأ في العرض. الرجاء فحص وحدة التحكم أو الاتصال بمطور الروبوت.","CONNECTIVITY_STATUS_ALT_SLOW_CONNECTION":"يستغرق وقتًا أطول من المعتاد للاتصال.","CONNECTIVITY_STATUS_ALT":"حالة الاتصال: $1","FILE_CONTENT_ALT":"\'$1\'","FILE_CONTENT_DOWNLOADABLE_ALT":"تنزيل ملف \'$1\'","FILE_CONTENT_DOWNLOADABLE_WITH_SIZE_ALT":"تنزيل الملف \'$1\' بحجم $2","FILE_CONTENT_WITH_SIZE_ALT":"\'$1\' بحجم $2","KEYBOARD_HELP_CHAT_HISTORY_ACCESS_ITEMS_IN_MESSAGE_BODY":"مفتاح Enter","KEYBOARD_HELP_CHAT_HISTORY_ACCESS_ITEMS_IN_MESSAGE_HEADER":"الوصول إلى العناصر في الرسالة","KEYBOARD_HELP_CHAT_HISTORY_HEADER":"محفوظات الدردشة","KEYBOARD_HELP_CHAT_HISTORY_LEAVE_MESSAGE_BODY":"مفتاح Escape","KEYBOARD_HELP_CHAT_HISTORY_LEAVE_MESSAGE_HEADER":"الخروج من الرسالة","KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_ITEMS_BODY":"مفتاح Tab\\nمفتاح Shift + tab","KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_ITEMS_HEADER":"التنقل بين العناصر في رسالة","KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_MESSAGES_BODY":"مفتاح السهم لأعلى\\nمفتاح السهم لأسفل","KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_MESSAGES_HEADER":"التنقل بين الرسائل","KEYBOARD_HELP_CHAT_WINDOW_BODY_DO_ACTION_BODY":"مفتاح Enter","KEYBOARD_HELP_CHAT_WINDOW_BODY_DO_ACTION_HEADER":"القيام بالإجراء","KEYBOARD_HELP_CHAT_WINDOW_BODY_MOVE_BETWEEN_ITEMS_BODY":"مفتاح Tab\\nمفتاح Shift + tab","KEYBOARD_HELP_CHAT_WINDOW_BODY_MOVE_BETWEEN_ITEMS_HEADER":"التنقل بين العناصر في نافذة الدردشة","KEYBOARD_HELP_CHAT_WINDOW_HEADER":"نافذة الدردشة","KEYBOARD_HELP_CLOSE_BUTTON_ALT":"إغلاق","KEYBOARD_HELP_HEADER":"عناصر تحكم لوحة المفاتيح","MARKDOWN_EXTERNAL_LINK_ALT":"فتح في نافذة جديدة؛ خارجية.","RECEIPT_CARD_TAX":"الضريبة","RECEIPT_CARD_TOTAL":"الإجمالي‬","RECEIPT_CARD_VAT":"ضريبة القيمة المضافة","SEND_BOX_IS_EMPTY_TOOLTIP_ALT":"لا يمكن إرسال رسالة فارغة.","SPEECH_INPUT_LISTENING":"جارٍ الاستماع…","SPEECH_INPUT_MICROPHONE_BUTTON_CLOSE_ALT":"الميكروفون متوقف عن التشغيل","SPEECH_INPUT_MICROPHONE_BUTTON_OPEN_ALT":"الميكروفون قيد التشغيل","SPEECH_INPUT_STARTING":"البدء…","SUGGESTED_ACTIONS_LABEL_ALT":"الإجراءات المقترحة","TEXT_INPUT_ALT":"مربع إدخال الرسالة","TEXT_INPUT_PLACEHOLDER":"اكتب رسالتك","TEXT_INPUT_SEND_BUTTON_ALT":"‏‏إرسال","TEXT_INPUT_SPEAK_BUTTON_ALT":"تحدّث","TEXT_INPUT_UPLOAD_BUTTON_ALT":"تحميل الملف","TOAST_ACCORDION_FEW":"$1 إعلامات: انقر هنا للاطلاع على التفاصيل","TOAST_ACCORDION_MANY":"$1 إعلامات: انقر هنا للاطلاع على التفاصيل","TOAST_ACCORDION_OTHER":"$1 إعلامات: انقر هنا للاطلاع على التفاصيل","TOAST_ACCORDION_TWO":"$1 إعلامات: انقر هنا للاطلاع على التفاصيل","TOAST_ALT_ERROR":"‏‏الخطأ","TOAST_ALT_INFO":"المعلومات","TOAST_ALT_SUCCESS":"نجاح","TOAST_ALT_WARN":"تحذير","TOAST_DISMISS_BUTTON":"رفض","TOAST_TITLE_ALT":"الإعلام","TRANSCRIPT_ARIA_LABEL_ALT":"محفوظات الدردشة، اضغط على مفاتيح الأسهم للتنقل.","TRANSCRIPT_ARIA_ROLE_ALT":"محفوظات الدردشة","TRANSCRIPT_LIVE_REGION_INTERACTIVE_LABEL_ALT":"الرسالة تفاعلية. اضغط على مفتاح shift tab من مرتين إلى 3 مرات للتبديل إلى محفوظات الدردشة. ثم انقر فوق الرسالة للتفاعل.","TRANSCRIPT_LIVE_REGION_INTERACTIVE_WITH_LINKS_LABEL_ALT":"هناك ارتباط أو أكثر في الرسالة. اضغط على مفتاح shift tab من مرتين إلى 3 مرات للتبديل إلى محفوظات الدردشة. ثم انقر فوق الرسالة للتفاعل.","TRANSCRIPT_LIVE_REGION_SUGGESTED_ACTIONS_LABEL_ALT":"تتضمن الرسالة إجراءات مقترحة. اضغط على shift tab من مرتين إلى 3 مرات لتحديدها.","TRANSCRIPT_LIVE_REGION_SUGGESTED_ACTIONS_WITH_ACCESS_KEY_LABEL_ALT":"تتضمن الرسالة إجراءات مقترحة. اضغط على $1 لتحديدها.","TRANSCRIPT_LIVE_REGION_SEND_FAILED_ALT":"فشل إرسال الرسالة.","TRANSCRIPT_MORE_MESSAGES":"المزيد من الرسائل","TRANSCRIPT_NEW_MESSAGES":"رسائل جديدة","TRANSCRIPT_TERMINATOR_TEXT":"نهاية محفوظات الدردشة","TYPING_INDICATOR_ALT":"إظهار مؤشر الكتابة","TYPING_INDICATOR_SINGLE_TEXT":"$1 يكتب الآن.","TYPING_INDICATOR_MULTIPLE_TEXT":"$1 وغيره يكتبون الآن."}');

});

parcelRequire.register("aQ3Or", function(module, exports) {
module.exports = JSON.parse('{"_comment":"[CI-LOCKED] Съдържанието на този файл е заключено. Приносът е добре дошъл, но валидирането на промените може да се забави.","ACCESS_KEY_ALT":"Alt Shift $1","ACCESS_KEY_FOR_MAC_ALT":"Control Option $1","ACTIVITY_BOT_SAID_ALT":"Бот $1 каза:","ACTIVITY_YOU_SAID_ALT":"Вие казахте:","ACTIVITY_BOT_ATTACHED_ALT":"Прикачен бот:","ACTIVITY_ERROR_BOX_TITLE":"Съобщение за грешка","ACTIVITY_INTERACTIVE_FOOTNOTE_ALT":"Щракнете за взаимодействие.","ACTIVITY_INTERACTIVE_REASON_INTERACTIVE_CONTENT_ALT":"Съобщението е интерактивно.","ACTIVITY_INTERACTIVE_REASON_LINK_ALT":"Една или повече връзки в съобщението.","ACTIVITY_INTERACTIVE_REASON_SEND_FAILED_ALT":"Изпращането е неуспешно.","ACTIVITY_YOU_ATTACHED_ALT":"Вие прикачихте:","ACTIVITY_NUM_ATTACHMENTS_ONE_ALT":"1 прикачен файл.","ACTIVITY_NUM_ATTACHMENTS_FEW_ALT":"$1 прикачени файлове.","ACTIVITY_NUM_ATTACHMENTS_MANY_ALT":"$1 прикачени файлове.","ACTIVITY_NUM_ATTACHMENTS_OTHER_ALT":"$1 прикачени файлове.","ACTIVITY_NUM_ATTACHMENTS_TWO_ALT":"$1 прикачени файлове.","ACTIVITY_STATUS_SEND_FAILED_RETRY":"Изпращането е неуспешно. [Повторен опит][RETRY].","ACTIVITY_STATUS_SEND_STATUS_ALT_SENDING":"Изпращане","ACTIVITY_STATUS_SEND_STATUS_ALT_SENT_AT":"Изпратено в $1","ACTIVITY_STATUS_TIMESTAMP_JUST_NOW":"Преди малко","ACTIVITY_STATUS_TIMESTAMP_ONE_HOUR_AGO":"Преди час","ACTIVITY_STATUS_TIMESTAMP_ONE_MINUTE_AGO":"Преди минута","ACTIVITY_STATUS_TIMESTAMP_TODAY":"Днес","ACTIVITY_STATUS_TIMESTAMP_YESTERDAY":"Вчера","ADAPTIVE_CARD_ERROR_BOX_TITLE_PARSE":"Грешка при анализиране на адаптивна карта","ADAPTIVE_CARD_ERROR_BOX_TITLE_RENDER":"Грешка при рендиране на адаптивна карта","ATTACHMENT_AUDIO":"Аудиоклип.","ATTACHMENT_CARD":"Карта: $1 $2 $3","ATTACHMENT_FILE":"Файл: $1","ATTACHMENT_IMAGE":"Изображение","ATTACHMENT_TEXT":"Текст: $1","ATTACHMENT_VIDEO":"Видеоклип","CAROUSEL_FLIPPER_LEFT_ALT":"Ляво","CAROUSEL_FLIPPER_RIGHT_ALT":"Дясно","CONNECTIVITY_STATUS_ALT_CONNECTED":"Установена връзка","CONNECTIVITY_STATUS_ALT_CONNECTING":"Свързване...","CONNECTIVITY_STATUS_ALT_FATAL":"Свързването не е възможно.","CONNECTIVITY_STATUS_ALT_RECONNECTING":"Възникна прекъсване на мрежата. Повторно свързване...","CONNECTIVITY_STATUS_ALT_RENDER_ERROR":"Грешка при рендиране. Моля, проверете конзолата или се свържете с разработчика на бота.","CONNECTIVITY_STATUS_ALT_SLOW_CONNECTION":"Свързването отнема повече време от обикновено.","CONNECTIVITY_STATUS_ALT":"Състояние на възможността за връзка: $1","FILE_CONTENT_ALT":"„$1”","FILE_CONTENT_DOWNLOADABLE_ALT":"Изтегляне на файл „$1”","FILE_CONTENT_DOWNLOADABLE_WITH_SIZE_ALT":"Изтегляне на файл „$1” с размер $2","FILE_CONTENT_WITH_SIZE_ALT":"„$1” с размер $2","KEYBOARD_HELP_CHAT_HISTORY_ACCESS_ITEMS_IN_MESSAGE_BODY":"Клавиш Enter","KEYBOARD_HELP_CHAT_HISTORY_ACCESS_ITEMS_IN_MESSAGE_HEADER":"Достъп до елементи в съобщението","KEYBOARD_HELP_CHAT_HISTORY_HEADER":"Хронология на чата","KEYBOARD_HELP_CHAT_HISTORY_LEAVE_MESSAGE_BODY":"Клавиш Escape","KEYBOARD_HELP_CHAT_HISTORY_LEAVE_MESSAGE_HEADER":"Съобщение за излизане","KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_ITEMS_BODY":"Клавиш Tab\\nShift + клавиш Tab","KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_ITEMS_HEADER":"Придвижване между елементи в съобщение","KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_MESSAGES_BODY":"Клавиш за стрелка нагоре\\nКлавиш за стрелка надолу","KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_MESSAGES_HEADER":"Придвижване между съобщения","KEYBOARD_HELP_CHAT_WINDOW_BODY_DO_ACTION_BODY":"Клавиш Enter","KEYBOARD_HELP_CHAT_WINDOW_BODY_DO_ACTION_HEADER":"Извършване на действие","KEYBOARD_HELP_CHAT_WINDOW_BODY_MOVE_BETWEEN_ITEMS_BODY":"Клавиш Tab\\nShift + клавиш Tab","KEYBOARD_HELP_CHAT_WINDOW_BODY_MOVE_BETWEEN_ITEMS_HEADER":"Придвижване между елементите в прозореца за чат","KEYBOARD_HELP_CHAT_WINDOW_HEADER":"Прозорец за чат","KEYBOARD_HELP_CLOSE_BUTTON_ALT":"Затваряне","KEYBOARD_HELP_HEADER":"Контроли на клавиатурата","MARKDOWN_EXTERNAL_LINK_ALT":"Отваря се в нов прозорец; външен.","RECEIPT_CARD_TAX":"Данък","RECEIPT_CARD_TOTAL":"Обща сума","RECEIPT_CARD_VAT":"ДДС","SEND_BOX_IS_EMPTY_TOOLTIP_ALT":"Не може да се изпрати празно съобщение.","SPEECH_INPUT_LISTENING":"Слушане...","SPEECH_INPUT_MICROPHONE_BUTTON_CLOSE_ALT":"Микрофонът е изключен","SPEECH_INPUT_MICROPHONE_BUTTON_OPEN_ALT":"Микрофонът е включен","SPEECH_INPUT_STARTING":"Начало...","SUGGESTED_ACTIONS_LABEL_ALT":"Предложени действия","TEXT_INPUT_ALT":"Поле за въвеждане на съобщение","TEXT_INPUT_PLACEHOLDER":"Въведете съобщението си","TEXT_INPUT_SEND_BUTTON_ALT":"Изпрати","TEXT_INPUT_SPEAK_BUTTON_ALT":"Говорете","TEXT_INPUT_UPLOAD_BUTTON_ALT":"Качване на файл","TOAST_ACCORDION_FEW":"$1 Известия: Щракнете тук, за да видите подробности","TOAST_ACCORDION_MANY":"$1 Известия: Щракнете тук, за да видите подробности","TOAST_ACCORDION_OTHER":"$1 Известия: Щракнете тук, за да видите подробности","TOAST_ACCORDION_TWO":"$1 Известия: Щракнете тук, за да видите подробности","TOAST_ALT_ERROR":"Грешка","TOAST_ALT_INFO":"Информация","TOAST_ALT_SUCCESS":"Успех","TOAST_ALT_WARN":"Предупреждение","TOAST_DISMISS_BUTTON":"Отхвърляне","TOAST_TITLE_ALT":"Известяване","TRANSCRIPT_ARIA_LABEL_ALT":"Хронология на чата, натиснете клавишите със стрелки, за да навигирате.","TRANSCRIPT_ARIA_ROLE_ALT":"хронология на чата","TRANSCRIPT_LIVE_REGION_INTERACTIVE_LABEL_ALT":"Съобщението е интерактивно. Натиснете клавишите Shift и Tab 2 до 3 пъти, за да превключите към хронологията на чата. След това щракнете върху съобщението, за да взаимодействате.","TRANSCRIPT_LIVE_REGION_INTERACTIVE_WITH_LINKS_LABEL_ALT":"Има една или повече връзки в съобщението. Натиснете клавишите Shift и Tab 2 до 3 пъти, за да превключите към хронологията на чата. След това щракнете върху съобщението, за да взаимодействате.","TRANSCRIPT_LIVE_REGION_SUGGESTED_ACTIONS_LABEL_ALT":"В съобщението са предложени действия. Натиснете Shift Tab 2 до 3 пъти, за да ги изберете.","TRANSCRIPT_LIVE_REGION_SUGGESTED_ACTIONS_WITH_ACCESS_KEY_LABEL_ALT":"В съобщението са предложени действия. Натиснете $1, за да ги изберете.","TRANSCRIPT_LIVE_REGION_SEND_FAILED_ALT":"Неуспешно изпращане на съобщението.","TRANSCRIPT_MORE_MESSAGES":"Още съобщения","TRANSCRIPT_NEW_MESSAGES":"Нови съобщения","TRANSCRIPT_TERMINATOR_TEXT":"Край на хронологията на чата","TYPING_INDICATOR_ALT":"Показване на индикатор за въвеждане","TYPING_INDICATOR_SINGLE_TEXT":"$1 пише.","TYPING_INDICATOR_MULTIPLE_TEXT":"$1 и други пишат."}');

});

parcelRequire.register("i9plw", function(module, exports) {
module.exports = JSON.parse('{"_comment":"[CI-LOCKED] El contingut d\'aquest fitxer est\xe0 bloquejat. Les aportacions s\xf3n benvingudes, per\xf2 la validaci\xf3 dels canvis es pot retardar.","ACCESS_KEY_ALT":"Alt Maj $1","ACCESS_KEY_FOR_MAC_ALT":"Control Opci\xf3 $1","ACTIVITY_BOT_SAID_ALT":"El bot $1 ha dit:","ACTIVITY_YOU_SAID_ALT":"Heu dit:","ACTIVITY_BOT_ATTACHED_ALT":"Bot adjuntat:","ACTIVITY_ERROR_BOX_TITLE":"Missatge d\'error","ACTIVITY_INTERACTIVE_FOOTNOTE_ALT":"Feu clic per interactuar.","ACTIVITY_INTERACTIVE_REASON_INTERACTIVE_CONTENT_ALT":"El missatge \xe9s interactiu.","ACTIVITY_INTERACTIVE_REASON_LINK_ALT":"Un o m\xe9s enlla\xe7os del missatge.","ACTIVITY_INTERACTIVE_REASON_SEND_FAILED_ALT":"L\'enviament ha fallat.","ACTIVITY_YOU_ATTACHED_ALT":"Heu adjuntat:","ACTIVITY_NUM_ATTACHMENTS_ONE_ALT":"1 fitxer adjunt.","ACTIVITY_NUM_ATTACHMENTS_FEW_ALT":"$1 fitxers adjunts.","ACTIVITY_NUM_ATTACHMENTS_MANY_ALT":"$1 fitxers adjunts.","ACTIVITY_NUM_ATTACHMENTS_OTHER_ALT":"$1 fitxers adjunts.","ACTIVITY_NUM_ATTACHMENTS_TWO_ALT":"$1 fitxers adjunts.","ACTIVITY_STATUS_SEND_FAILED_RETRY":"L\'enviament ha fallat. [Torna-ho a provar][RETRY].","ACTIVITY_STATUS_SEND_STATUS_ALT_SENDING":"S\'est\xe0 enviant","ACTIVITY_STATUS_SEND_STATUS_ALT_SENT_AT":"S\'ha enviat a les $1","ACTIVITY_STATUS_TIMESTAMP_JUST_NOW":"Ara mateix","ACTIVITY_STATUS_TIMESTAMP_ONE_HOUR_AGO":"Fa una hora","ACTIVITY_STATUS_TIMESTAMP_ONE_MINUTE_AGO":"Fa un minut","ACTIVITY_STATUS_TIMESTAMP_TODAY":"Avui","ACTIVITY_STATUS_TIMESTAMP_YESTERDAY":"Ahir","ADAPTIVE_CARD_ERROR_BOX_TITLE_PARSE":"Error d\'an\xe0lisi de la targeta adaptativa","ADAPTIVE_CARD_ERROR_BOX_TITLE_RENDER":"Error de representaci\xf3 de la targeta adaptativa","ATTACHMENT_AUDIO":"Un clip d’\xe0udio.","ATTACHMENT_CARD":"Una targeta: $1 $2 $3","ATTACHMENT_FILE":"Un fitxer: $1","ATTACHMENT_IMAGE":"Una imatge","ATTACHMENT_TEXT":"Un text: $1","ATTACHMENT_VIDEO":"Un clip de v\xeddeo","CAROUSEL_FLIPPER_LEFT_ALT":"Left","CAROUSEL_FLIPPER_RIGHT_ALT":"Right","CONNECTIVITY_STATUS_ALT_CONNECTED":"Connectat","CONNECTIVITY_STATUS_ALT_CONNECTING":"S\'est\xe0 connectant…","CONNECTIVITY_STATUS_ALT_FATAL":"No es pot connectar.","CONNECTIVITY_STATUS_ALT_RECONNECTING":"S\'ha produ\xeft una interrupci\xf3 de la xarxa. S\'est\xe0 reconnectant…","CONNECTIVITY_STATUS_ALT_RENDER_ERROR":"Error de representaci\xf3. Consulteu la consola o poseu-vos en contacte amb el desenvolupador del bot.","CONNECTIVITY_STATUS_ALT_SLOW_CONNECTION":"S\'est\xe0 trigant m\xe9s de l\'habitual per establir una connexi\xf3.","CONNECTIVITY_STATUS_ALT":"Estat de la connectivitat: $1","FILE_CONTENT_ALT":"\\"$1\\"","FILE_CONTENT_DOWNLOADABLE_ALT":"Baixa el fitxer \\"$1\\"","FILE_CONTENT_DOWNLOADABLE_WITH_SIZE_ALT":"Baixa el fitxer \\"$1\\" amb una mida de $2","FILE_CONTENT_WITH_SIZE_ALT":"\\"$1\\" amb una mida de $2","KEYBOARD_HELP_CHAT_HISTORY_ACCESS_ITEMS_IN_MESSAGE_BODY":"Introdu\xefu una clau","KEYBOARD_HELP_CHAT_HISTORY_ACCESS_ITEMS_IN_MESSAGE_HEADER":"Accediu als elements del missatge","KEYBOARD_HELP_CHAT_HISTORY_HEADER":"Historial de xat","KEYBOARD_HELP_CHAT_HISTORY_LEAVE_MESSAGE_BODY":"Tecla Esc","KEYBOARD_HELP_CHAT_HISTORY_LEAVE_MESSAGE_HEADER":"Missatge de sortida","KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_ITEMS_BODY":"Tecla de tabulaci\xf3\\nTecla Maj + tabulaci\xf3","KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_ITEMS_HEADER":"Permet despla\xe7ar-se entre els elements d\'un missatge","KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_MESSAGES_BODY":"Tecla fletxa amunt\\nTecla fletxa avall","KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_MESSAGES_HEADER":"Permet despla\xe7ar-se entre els missatges","KEYBOARD_HELP_CHAT_WINDOW_BODY_DO_ACTION_BODY":"Introdu\xefu una clau","KEYBOARD_HELP_CHAT_WINDOW_BODY_DO_ACTION_HEADER":"Executa l\'acci\xf3","KEYBOARD_HELP_CHAT_WINDOW_BODY_MOVE_BETWEEN_ITEMS_BODY":"Tecla de tabulaci\xf3\\nTecla Maj + tabulaci\xf3","KEYBOARD_HELP_CHAT_WINDOW_BODY_MOVE_BETWEEN_ITEMS_HEADER":"Permet despla\xe7ar-se entre els elements de la finestra de xat","KEYBOARD_HELP_CHAT_WINDOW_HEADER":"Finestra del xat","KEYBOARD_HELP_CLOSE_BUTTON_ALT":"Tanca","KEYBOARD_HELP_HEADER":"Controls de teclat","MARKDOWN_EXTERNAL_LINK_ALT":"S’obre en una finestra nova; externa.","RECEIPT_CARD_TAX":"Impost","RECEIPT_CARD_TOTAL":"Total","RECEIPT_CARD_VAT":"IVA","SEND_BOX_IS_EMPTY_TOOLTIP_ALT":"No es pot enviar un missatge buit.","SPEECH_INPUT_LISTENING":"Escoltant…","SPEECH_INPUT_MICROPHONE_BUTTON_CLOSE_ALT":"Micr\xf2fon desactivat","SPEECH_INPUT_MICROPHONE_BUTTON_OPEN_ALT":"Micr\xf2fon activat","SPEECH_INPUT_STARTING":"Iniciant…","SUGGESTED_ACTIONS_LABEL_ALT":"Accions suggerides","TEXT_INPUT_ALT":"Quadre d\'entrada del missatge","TEXT_INPUT_PLACEHOLDER":"Escriviu el missatge","TEXT_INPUT_SEND_BUTTON_ALT":"Envia","TEXT_INPUT_SPEAK_BUTTON_ALT":"Parlar","TEXT_INPUT_UPLOAD_BUTTON_ALT":"Carrega el fitxer","TOAST_ACCORDION_FEW":"$1 notificacions: feu clic aqu\xed per veure detalls","TOAST_ACCORDION_MANY":"$1 notificacions: feu clic aqu\xed per veure detalls","TOAST_ACCORDION_OTHER":"$1 notificacions: feu clic aqu\xed per veure detalls","TOAST_ACCORDION_TWO":"$1 notificacions: feu clic aqu\xed per veure detalls","TOAST_ALT_ERROR":"Error","TOAST_ALT_INFO":"Informaci\xf3","TOAST_ALT_SUCCESS":"Correcta","TOAST_ALT_WARN":"Advertiment","TOAST_DISMISS_BUTTON":"Descarta","TOAST_TITLE_ALT":"Notificaci\xf3","TRANSCRIPT_ARIA_LABEL_ALT":"Historial de xat, premeu les tecles amunt/avall per despla\xe7ar-vos.","TRANSCRIPT_ARIA_ROLE_ALT":"historial de xat","TRANSCRIPT_LIVE_REGION_INTERACTIVE_LABEL_ALT":"El missatge \xe9s interactiu. Premeu la tecla de tabulaci\xf3 entre 2 i 3 vegades per canviar a l\'historial de xat. A continuaci\xf3, feu clic al missatge per interactuar.","TRANSCRIPT_LIVE_REGION_INTERACTIVE_WITH_LINKS_LABEL_ALT":"Un o m\xe9s enlla\xe7os al missatge. Premeu la tecla de tabulaci\xf3 entre 2 i 3 vegades per canviar a l\'historial de xat. A continuaci\xf3, feu clic al missatge per interactuar.","TRANSCRIPT_LIVE_REGION_SUGGESTED_ACTIONS_LABEL_ALT":"El missatge ha suggerit accions. Premeu la tecla de tabulaci\xf3 entre 2 i 3 vegades per seleccionar-les.","TRANSCRIPT_LIVE_REGION_SUGGESTED_ACTIONS_WITH_ACCESS_KEY_LABEL_ALT":"El missatge ha suggerit accions. Premeu $1 per seleccionar-les.","TRANSCRIPT_LIVE_REGION_SEND_FAILED_ALT":"No s\'ha pogut enviar el missatge.","TRANSCRIPT_MORE_MESSAGES":"M\xe9s missatges","TRANSCRIPT_NEW_MESSAGES":"Missatges nous","TRANSCRIPT_TERMINATOR_TEXT":"Fi de l\'historial de xat","TYPING_INDICATOR_ALT":"S\'est\xe0 mostrant l\'indicador d\'escriptura","TYPING_INDICATOR_SINGLE_TEXT":"$1 est\xe0 escrivint.","TYPING_INDICATOR_MULTIPLE_TEXT":"$1 i altres persones estan escrivint."}');

});

parcelRequire.register("1GRZ0", function(module, exports) {
module.exports = JSON.parse('{"_comment":"[CI-LOCKED] Obsah tohoto souboru je uzamčen. Př\xedspěvky jsou v\xedt\xe1ny, ale ověřen\xed změny může b\xfdt zpožděno.","ACCESS_KEY_ALT":"Alt + Shift + $1","ACCESS_KEY_FOR_MAC_ALT":"Control + Option + $1","ACTIVITY_BOT_SAID_ALT":"Robot $1 řekl:","ACTIVITY_YOU_SAID_ALT":"Řekli jste:","ACTIVITY_BOT_ATTACHED_ALT":"Robot byl připojen:","ACTIVITY_ERROR_BOX_TITLE":"Chybov\xe1 zpr\xe1va","ACTIVITY_INTERACTIVE_FOOTNOTE_ALT":"Kliknut\xedm provedete interakci.","ACTIVITY_INTERACTIVE_REASON_INTERACTIVE_CONTENT_ALT":"Zpr\xe1va je interaktivn\xed.","ACTIVITY_INTERACTIVE_REASON_LINK_ALT":"Zpr\xe1va obsahuje nejm\xe9ně jeden odkaz.","ACTIVITY_INTERACTIVE_REASON_SEND_FAILED_ALT":"Odesl\xe1n\xed se nezdařilo.","ACTIVITY_YOU_ATTACHED_ALT":"Připojili jste:","ACTIVITY_NUM_ATTACHMENTS_ONE_ALT":"1 př\xedloha","ACTIVITY_NUM_ATTACHMENTS_FEW_ALT":"$1 př\xedlohy","ACTIVITY_NUM_ATTACHMENTS_MANY_ALT":"$1 př\xedloh","ACTIVITY_NUM_ATTACHMENTS_OTHER_ALT":"$1 př\xedloh","ACTIVITY_NUM_ATTACHMENTS_TWO_ALT":"$1 př\xedlohy","ACTIVITY_STATUS_SEND_FAILED_RETRY":"Odesl\xe1n\xed se nezdařilo. [Opakovat][RETRY]","ACTIVITY_STATUS_SEND_STATUS_ALT_SENDING":"Odes\xedl\xe1n\xed","ACTIVITY_STATUS_SEND_STATUS_ALT_SENT_AT":"Odesl\xe1no v $1","ACTIVITY_STATUS_TIMESTAMP_JUST_NOW":"Pr\xe1vě teď","ACTIVITY_STATUS_TIMESTAMP_ONE_HOUR_AGO":"Před 1 hodinou","ACTIVITY_STATUS_TIMESTAMP_ONE_MINUTE_AGO":"Před 1 minutou","ACTIVITY_STATUS_TIMESTAMP_TODAY":"Dnes","ACTIVITY_STATUS_TIMESTAMP_YESTERDAY":"Včera","ADAPTIVE_CARD_ERROR_BOX_TITLE_PARSE":"Chyba analyzov\xe1n\xed adaptivn\xed karty","ADAPTIVE_CARD_ERROR_BOX_TITLE_RENDER":"Chyba vykreslov\xe1n\xed adaptivn\xed karty","ATTACHMENT_AUDIO":"Zvukov\xfd klip","ATTACHMENT_CARD":"Karta: $1 $2 $3","ATTACHMENT_FILE":"Soubor: $1","ATTACHMENT_IMAGE":"Obr\xe1zek","ATTACHMENT_TEXT":"Text: $1","ATTACHMENT_VIDEO":"Videoklip","CAROUSEL_FLIPPER_LEFT_ALT":"Vlevo","CAROUSEL_FLIPPER_RIGHT_ALT":"Vpravo","CONNECTIVITY_STATUS_ALT_CONNECTED":"Připojeno","CONNECTIVITY_STATUS_ALT_CONNECTING":"Připojov\xe1n\xed…","CONNECTIVITY_STATUS_ALT_FATAL":"Nelze nav\xe1zat připojen\xed.","CONNECTIVITY_STATUS_ALT_RECONNECTING":"Došlo k přerušen\xed s\xedtě. Znovu se připojuje…","CONNECTIVITY_STATUS_ALT_RENDER_ERROR":"Chyba vykreslov\xe1n\xed. Zkontrolujte konzolu nebo kontaktujte v\xfdvoj\xe1ře botů.","CONNECTIVITY_STATUS_ALT_SLOW_CONNECTION":"Připojen\xed trv\xe1 d\xe9le než obvykle.","CONNECTIVITY_STATUS_ALT":"Stav připojen\xed: $1","FILE_CONTENT_ALT":"$1","FILE_CONTENT_DOWNLOADABLE_ALT":"St\xe1hnout soubor $1","FILE_CONTENT_DOWNLOADABLE_WITH_SIZE_ALT":"St\xe1hnout soubor $1 o velikosti $2","FILE_CONTENT_WITH_SIZE_ALT":"$1 o velikosti $2","KEYBOARD_HELP_CHAT_HISTORY_ACCESS_ITEMS_IN_MESSAGE_BODY":"Enter","KEYBOARD_HELP_CHAT_HISTORY_ACCESS_ITEMS_IN_MESSAGE_HEADER":"Př\xedstup k položk\xe1m ve zpr\xe1vě","KEYBOARD_HELP_CHAT_HISTORY_HEADER":"Historie chatu","KEYBOARD_HELP_CHAT_HISTORY_LEAVE_MESSAGE_BODY":"Escape","KEYBOARD_HELP_CHAT_HISTORY_LEAVE_MESSAGE_HEADER":"Opustit zpr\xe1vu","KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_ITEMS_BODY":"Tabul\xe1tor\\nShift + tabul\xe1tor","KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_ITEMS_HEADER":"Pohyb mezi položkami ve zpr\xe1vě","KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_MESSAGES_BODY":"Šipka nahoru\\nŠipka dolů","KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_MESSAGES_HEADER":"Pohyb mezi zpr\xe1vami","KEYBOARD_HELP_CHAT_WINDOW_BODY_DO_ACTION_BODY":"Enter","KEYBOARD_HELP_CHAT_WINDOW_BODY_DO_ACTION_HEADER":"Proveden\xed akce","KEYBOARD_HELP_CHAT_WINDOW_BODY_MOVE_BETWEEN_ITEMS_BODY":"Tabul\xe1tor\\nShift + tabul\xe1tor","KEYBOARD_HELP_CHAT_WINDOW_BODY_MOVE_BETWEEN_ITEMS_HEADER":"Pohyb mezi položkami v okně chatu","KEYBOARD_HELP_CHAT_WINDOW_HEADER":"Okno chatu","KEYBOARD_HELP_CLOSE_BUTTON_ALT":"Zavř\xedt","KEYBOARD_HELP_HEADER":"Ovl\xe1d\xe1n\xed pomoc\xed kl\xe1vesnice","MARKDOWN_EXTERNAL_LINK_ALT":"Otevře se v nov\xe9m okně; extern\xed.","RECEIPT_CARD_TAX":"Daň","RECEIPT_CARD_TOTAL":"Celkem","RECEIPT_CARD_VAT":"DPH","SEND_BOX_IS_EMPTY_TOOLTIP_ALT":"Pr\xe1zdnou zpr\xe1vu nelze odeslat.","SPEECH_INPUT_LISTENING":"Naslouch\xe1n\xed…","SPEECH_INPUT_MICROPHONE_BUTTON_CLOSE_ALT":"Mikrofon vypnout","SPEECH_INPUT_MICROPHONE_BUTTON_OPEN_ALT":"Mikrofon zapnout","SPEECH_INPUT_STARTING":"Spouštěn\xed…","SUGGESTED_ACTIONS_LABEL_ALT":"Navrhovan\xe9 akce","TEXT_INPUT_ALT":"Pole pro zad\xe1n\xed zpr\xe1vy","TEXT_INPUT_PLACEHOLDER":"Zadejte svou zpr\xe1vu","TEXT_INPUT_SEND_BUTTON_ALT":"Odeslat","TEXT_INPUT_SPEAK_BUTTON_ALT":"Mluvit","TEXT_INPUT_UPLOAD_BUTTON_ALT":"Nahr\xe1t soubor","TOAST_ACCORDION_FEW":"$1 ozn\xe1men\xed: kliknut\xedm sem zobraz\xedte podrobnosti.","TOAST_ACCORDION_MANY":"$1 ozn\xe1men\xed: kliknut\xedm sem zobraz\xedte podrobnosti.","TOAST_ACCORDION_OTHER":"$1 ozn\xe1men\xed: kliknut\xedm sem zobraz\xedte podrobnosti.","TOAST_ACCORDION_TWO":"$1 ozn\xe1men\xed: kliknut\xedm sem zobraz\xedte podrobnosti.","TOAST_ALT_ERROR":"Chyba","TOAST_ALT_INFO":"Informace","TOAST_ALT_SUCCESS":"\xdaspěch","TOAST_ALT_WARN":"Upozorněn\xed","TOAST_DISMISS_BUTTON":"Zavř\xedt","TOAST_TITLE_ALT":"Ozn\xe1men\xed","TRANSCRIPT_ARIA_LABEL_ALT":"Historie chatu, k navigaci použijte šipkov\xe9 kl\xe1vesy.","TRANSCRIPT_ARIA_ROLE_ALT":"historie chatu","TRANSCRIPT_LIVE_REGION_INTERACTIVE_LABEL_ALT":"Zpr\xe1va je interaktivn\xed. Dvoj\xedm až troj\xedm stisknut\xedm kl\xe1ves Shift + tabul\xe1tor přejdete do historie chatu. Interakci zah\xe1j\xedte kliknut\xedm na zpr\xe1vu.","TRANSCRIPT_LIVE_REGION_INTERACTIVE_WITH_LINKS_LABEL_ALT":"Zpr\xe1va obsahuje nejm\xe9ně jeden odkaz. Dvoj\xedm až troj\xedm stisknut\xedm kl\xe1ves Shift + tabul\xe1tor přejdete do historie chatu. Interakci zah\xe1j\xedte kliknut\xedm na zpr\xe1vu.","TRANSCRIPT_LIVE_REGION_SUGGESTED_ACTIONS_LABEL_ALT":"Zpr\xe1va obsahuje navrhovan\xe9 akce. Pokud je chcete vybrat, stiskněte 2 až 3kr\xe1t kl\xe1vesy Shift + tabul\xe1tor.","TRANSCRIPT_LIVE_REGION_SUGGESTED_ACTIONS_WITH_ACCESS_KEY_LABEL_ALT":"Zpr\xe1va obsahuje navrhovan\xe9 akce. Pokud je chcete vybrat, stiskněte kl\xe1vesu $1.","TRANSCRIPT_LIVE_REGION_SEND_FAILED_ALT":"Zpr\xe1vu se nepodařilo odeslat.","TRANSCRIPT_MORE_MESSAGES":"Dalš\xed zpr\xe1vy","TRANSCRIPT_NEW_MESSAGES":"Nov\xe9 zpr\xe1vy","TRANSCRIPT_TERMINATOR_TEXT":"Konec historie chatu","TYPING_INDICATOR_ALT":"Zobrazuje se indik\xe1tor psan\xed","TYPING_INDICATOR_SINGLE_TEXT":"$1 p\xedše.","TYPING_INDICATOR_MULTIPLE_TEXT":"$1 a dalš\xed p\xedšou."}');

});

parcelRequire.register("lvjF5", function(module, exports) {
module.exports = JSON.parse('{"_comment":"[CI-LOCKED] Indholdet af denne fil er l\xe5st. Bidrag er velkomne, men valideringen af \xe6ndringer bliver muligvis forsinket.","ACCESS_KEY_ALT":"Alt Skift $1","ACCESS_KEY_FOR_MAC_ALT":"Control option $1","ACTIVITY_BOT_SAID_ALT":"Robotten $1 sagde:","ACTIVITY_YOU_SAID_ALT":"Du sagde:","ACTIVITY_BOT_ATTACHED_ALT":"Vedh\xe6ftet af robot:","ACTIVITY_ERROR_BOX_TITLE":"Fejlmeddelelse","ACTIVITY_INTERACTIVE_FOOTNOTE_ALT":"Klik for at interagere.","ACTIVITY_INTERACTIVE_REASON_INTERACTIVE_CONTENT_ALT":"Meddelelsen er interaktiv.","ACTIVITY_INTERACTIVE_REASON_LINK_ALT":"\xc9t eller flere links i meddelelsen.","ACTIVITY_INTERACTIVE_REASON_SEND_FAILED_ALT":"Afsendelse mislykkedes.","ACTIVITY_YOU_ATTACHED_ALT":"Du vedh\xe6ftede:","ACTIVITY_NUM_ATTACHMENTS_ONE_ALT":"1 vedh\xe6ftet fil.","ACTIVITY_NUM_ATTACHMENTS_FEW_ALT":"$1 vedh\xe6ftede filer.","ACTIVITY_NUM_ATTACHMENTS_MANY_ALT":"$1 vedh\xe6ftede filer.","ACTIVITY_NUM_ATTACHMENTS_OTHER_ALT":"$1 vedh\xe6ftede filer.","ACTIVITY_NUM_ATTACHMENTS_TWO_ALT":"$1 vedh\xe6ftede filer.","ACTIVITY_STATUS_SEND_FAILED_RETRY":"Afsendelse mislykkedes. [Pr\xf8v igen][RETRY].","ACTIVITY_STATUS_SEND_STATUS_ALT_SENDING":"Sender","ACTIVITY_STATUS_SEND_STATUS_ALT_SENT_AT":"Sendt kl. $1","ACTIVITY_STATUS_TIMESTAMP_JUST_NOW":"Lige nu","ACTIVITY_STATUS_TIMESTAMP_ONE_HOUR_AGO":"For en time siden","ACTIVITY_STATUS_TIMESTAMP_ONE_MINUTE_AGO":"For et minut siden","ACTIVITY_STATUS_TIMESTAMP_TODAY":"I dag","ACTIVITY_STATUS_TIMESTAMP_YESTERDAY":"I g\xe5r","ADAPTIVE_CARD_ERROR_BOX_TITLE_PARSE":"Fortolkningsfejl i AdaptiveCard","ADAPTIVE_CARD_ERROR_BOX_TITLE_RENDER":"Renderingsfejl i AdaptiveCard","ATTACHMENT_AUDIO":"Et lydklip.","ATTACHMENT_CARD":"Et kort: $1 $2 $3","ATTACHMENT_FILE":"En fil: $1","ATTACHMENT_IMAGE":"Et billede","ATTACHMENT_TEXT":"En tekst: $1","ATTACHMENT_VIDEO":"Et videoklip","CAROUSEL_FLIPPER_LEFT_ALT":"Venstre","CAROUSEL_FLIPPER_RIGHT_ALT":"H\xf8jre","CONNECTIVITY_STATUS_ALT_CONNECTED":"Forbundet","CONNECTIVITY_STATUS_ALT_CONNECTING":"Opretter forbindelse ...","CONNECTIVITY_STATUS_ALT_FATAL":"Det var ikke muligt at oprette forbindelse.","CONNECTIVITY_STATUS_ALT_RECONNECTING":"Der opstod en netv\xe6rksafbrydelse. Opretter forbindelse igen ...","CONNECTIVITY_STATUS_ALT_RENDER_ERROR":"Gengivelsesfejl. Kontroll\xe9r konsollen, eller kontakt robotudvikleren.","CONNECTIVITY_STATUS_ALT_SLOW_CONNECTION":"Det tager l\xe6ngere tid end normalt at oprette forbindelse.","CONNECTIVITY_STATUS_ALT":"Forbindelsesstatus: $1","FILE_CONTENT_ALT":"\'$1\'","FILE_CONTENT_DOWNLOADABLE_ALT":"Download filen \'$1\'","FILE_CONTENT_DOWNLOADABLE_WITH_SIZE_ALT":"Hent filen \'$1\', som fylder $2","FILE_CONTENT_WITH_SIZE_ALT":"\'$1\', som fylder $2","KEYBOARD_HELP_CHAT_HISTORY_ACCESS_ITEMS_IN_MESSAGE_BODY":"Enter-tast","KEYBOARD_HELP_CHAT_HISTORY_ACCESS_ITEMS_IN_MESSAGE_HEADER":"Adgangselementer i meddelelse","KEYBOARD_HELP_CHAT_HISTORY_HEADER":"Chathistorik","KEYBOARD_HELP_CHAT_HISTORY_LEAVE_MESSAGE_BODY":"Escape-tast","KEYBOARD_HELP_CHAT_HISTORY_LEAVE_MESSAGE_HEADER":"Afslut meddelelse","KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_ITEMS_BODY":"Tabulatortast\\nSkift + tabulatortast","KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_ITEMS_HEADER":"Flyt mellem elementer i en meddelelse","KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_MESSAGES_BODY":"Pil op-tast\\nPil ned-tast","KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_MESSAGES_HEADER":"Flyt mellem meddelelser","KEYBOARD_HELP_CHAT_WINDOW_BODY_DO_ACTION_BODY":"Enter-tast","KEYBOARD_HELP_CHAT_WINDOW_BODY_DO_ACTION_HEADER":"Udf\xf8r handling","KEYBOARD_HELP_CHAT_WINDOW_BODY_MOVE_BETWEEN_ITEMS_BODY":"Tabulatortast\\nSkift + tabulatortast","KEYBOARD_HELP_CHAT_WINDOW_BODY_MOVE_BETWEEN_ITEMS_HEADER":"Flyt mellem elementer i chatvinduet","KEYBOARD_HELP_CHAT_WINDOW_HEADER":"Chatvindue","KEYBOARD_HELP_CLOSE_BUTTON_ALT":"Luk","KEYBOARD_HELP_HEADER":"Tastaturets kontrolelementer","MARKDOWN_EXTERNAL_LINK_ALT":"\xc5bner i et nyt vindue, eksternt.","RECEIPT_CARD_TAX":"Moms","RECEIPT_CARD_TOTAL":"I alt","RECEIPT_CARD_VAT":"Moms","SEND_BOX_IS_EMPTY_TOOLTIP_ALT":"Der kan ikke sendes en tom meddelelse.","SPEECH_INPUT_LISTENING":"Lytter ...","SPEECH_INPUT_MICROPHONE_BUTTON_CLOSE_ALT":"Mikrofon Fra","SPEECH_INPUT_MICROPHONE_BUTTON_OPEN_ALT":"Mikrofon Til","SPEECH_INPUT_STARTING":"Starter ...","SUGGESTED_ACTIONS_LABEL_ALT":"Foresl\xe5ede handlinger","TEXT_INPUT_ALT":"Meddelelsesinputfelt","TEXT_INPUT_PLACEHOLDER":"Skriv din meddelelse","TEXT_INPUT_SEND_BUTTON_ALT":"Send","TEXT_INPUT_SPEAK_BUTTON_ALT":"Tal","TEXT_INPUT_UPLOAD_BUTTON_ALT":"Overf\xf8r fil","TOAST_ACCORDION_FEW":"$1 Meddelelser: Klik her for at f\xe5 vist detaljer","TOAST_ACCORDION_MANY":"$1 Meddelelser: Klik her for at f\xe5 vist detaljer","TOAST_ACCORDION_OTHER":"$1 Meddelelser: Klik her for at f\xe5 vist detaljer","TOAST_ACCORDION_TWO":"$1 Meddelelser: Klik her for at f\xe5 vist detaljer","TOAST_ALT_ERROR":"Fejl","TOAST_ALT_INFO":"Oplysninger","TOAST_ALT_SUCCESS":"Fuldf\xf8rt","TOAST_ALT_WARN":"Advarsel!","TOAST_DISMISS_BUTTON":"Afvis","TOAST_TITLE_ALT":"Meddelelse","TRANSCRIPT_ARIA_LABEL_ALT":"Chat-historik. Tryk p\xe5 piletasterne for at navigere.","TRANSCRIPT_ARIA_ROLE_ALT":"chathistorik","TRANSCRIPT_LIVE_REGION_INTERACTIVE_LABEL_ALT":"Meddelelsen er interaktiv. Tryk p\xe5 Skift og tabulatortast 2 til 3 gange for at skifte til chathistorikken. Klik derefter p\xe5 meddelelsen for at interagere.","TRANSCRIPT_LIVE_REGION_INTERACTIVE_WITH_LINKS_LABEL_ALT":"\xc9t eller flere links i meddelelsen. Tryk p\xe5 Skift og tabulatortast 2 til 3 gange for at skifte til chathistorikken. Klik derefter p\xe5 meddelelsen for at interagere.","TRANSCRIPT_LIVE_REGION_SUGGESTED_ACTIONS_LABEL_ALT":"Meddelelsen har foresl\xe5ede handlinger. Tryk p\xe5 skift tab 2 til 3 gange for at v\xe6lge dem.","TRANSCRIPT_LIVE_REGION_SUGGESTED_ACTIONS_WITH_ACCESS_KEY_LABEL_ALT":"Meddelelsen har foresl\xe5ede handlinger. Tryk p\xe5 $1 for at v\xe6lge dem.","TRANSCRIPT_LIVE_REGION_SEND_FAILED_ALT":"Meddelelsen blev ikke sendt.","TRANSCRIPT_MORE_MESSAGES":"Flere meddelelser","TRANSCRIPT_NEW_MESSAGES":"Nye meddelelser","TRANSCRIPT_TERMINATOR_TEXT":"Slut p\xe5 chathistorik","TYPING_INDICATOR_ALT":"Viser indtastningsindikator","TYPING_INDICATOR_SINGLE_TEXT":"$1 skriver.","TYPING_INDICATOR_MULTIPLE_TEXT":"$1 og andre skriver."}');

});

parcelRequire.register("jIDt0", function(module, exports) {
module.exports = JSON.parse('{"_comment":"[CI-LOCKED] Der Inhalt dieser Datei ist gesperrt. Beitr\xe4ge sind willkommen, die \xc4nderungs\xfcberpr\xfcfung kann jedoch verz\xf6gert werden.","ACCESS_KEY_ALT":"ALT UMSCHALT $1","ACCESS_KEY_FOR_MAC_ALT":"CONTROL OPTION $1","ACTIVITY_BOT_SAID_ALT":"Bot $1 sagte:","ACTIVITY_YOU_SAID_ALT":"Sie sagten:","ACTIVITY_BOT_ATTACHED_ALT":"Bot angef\xfcgt:","ACTIVITY_ERROR_BOX_TITLE":"Fehlermeldung","ACTIVITY_INTERACTIVE_FOOTNOTE_ALT":"Zum Interagieren klicken.","ACTIVITY_INTERACTIVE_REASON_INTERACTIVE_CONTENT_ALT":"Die Nachricht ist interaktiv.","ACTIVITY_INTERACTIVE_REASON_LINK_ALT":"Die Nachricht enth\xe4lt mindestens einen Link.","ACTIVITY_INTERACTIVE_REASON_SEND_FAILED_ALT":"Fehler beim Senden.","ACTIVITY_YOU_ATTACHED_ALT":"Sie haben angef\xfcgt:","ACTIVITY_NUM_ATTACHMENTS_ONE_ALT":"1 Anhang.","ACTIVITY_NUM_ATTACHMENTS_FEW_ALT":"$1 Anh\xe4nge.","ACTIVITY_NUM_ATTACHMENTS_MANY_ALT":"$1 Anh\xe4nge.","ACTIVITY_NUM_ATTACHMENTS_OTHER_ALT":"$1 Anh\xe4nge.","ACTIVITY_NUM_ATTACHMENTS_TWO_ALT":"$1 Anh\xe4nge.","ACTIVITY_STATUS_SEND_FAILED_RETRY":"Fehler beim Senden. [Wiederholen][RETRY].","ACTIVITY_STATUS_SEND_STATUS_ALT_SENDING":"Wird gesendet\xa0...","ACTIVITY_STATUS_SEND_STATUS_ALT_SENT_AT":"Gesendet um $1","ACTIVITY_STATUS_TIMESTAMP_JUST_NOW":"Jetzt","ACTIVITY_STATUS_TIMESTAMP_ONE_HOUR_AGO":"Vor einer Stunde","ACTIVITY_STATUS_TIMESTAMP_ONE_MINUTE_AGO":"Vor einer Minute","ACTIVITY_STATUS_TIMESTAMP_TODAY":"Heute","ACTIVITY_STATUS_TIMESTAMP_YESTERDAY":"Gestern","ADAPTIVE_CARD_ERROR_BOX_TITLE_PARSE":"Fehler beim Analysieren der adaptiven Karte","ADAPTIVE_CARD_ERROR_BOX_TITLE_RENDER":"Fehler beim Rendern der adaptiven Karte","ATTACHMENT_AUDIO":"Ein Audioclip.","ATTACHMENT_CARD":"Eine Karte: $1 $2 $3","ATTACHMENT_FILE":"Eine Datei: $1","ATTACHMENT_IMAGE":"Ein Bild","ATTACHMENT_TEXT":"Ein Text: $1","ATTACHMENT_VIDEO":"Ein Videoclip","CAROUSEL_FLIPPER_LEFT_ALT":"Links","CAROUSEL_FLIPPER_RIGHT_ALT":"Berechtigung","CONNECTIVITY_STATUS_ALT_CONNECTED":"Verbunden","CONNECTIVITY_STATUS_ALT_CONNECTING":"Verbindung wird hergestellt\xa0...","CONNECTIVITY_STATUS_ALT_FATAL":"Verbindung konnte nicht aufgebaut werden.","CONNECTIVITY_STATUS_ALT_RECONNECTING":"Netzwerkunterbrechung ist aufgetreten. Verbindung wird wiederhergestellt\xa0...","CONNECTIVITY_STATUS_ALT_RENDER_ERROR":"Fehler beim Rendern. \xdcberpr\xfcfen Sie die Konsole, oder wenden Sie sich an den Botentwickler.","CONNECTIVITY_STATUS_ALT_SLOW_CONNECTION":"Der Verbindungsvorgang dauert l\xe4nger als erwartet.","CONNECTIVITY_STATUS_ALT":"Verbindungsstatus: $1","FILE_CONTENT_ALT":"„$1“","FILE_CONTENT_DOWNLOADABLE_ALT":"Datei „$1“ herunterladen","FILE_CONTENT_DOWNLOADABLE_WITH_SIZE_ALT":"Datei „$1“ mit einer Gr\xf6\xdfe von $2 herunterladen","FILE_CONTENT_WITH_SIZE_ALT":"„$1“ mit einer Gr\xf6\xdfe von $2","KEYBOARD_HELP_CHAT_HISTORY_ACCESS_ITEMS_IN_MESSAGE_BODY":"Eingabetaste","KEYBOARD_HELP_CHAT_HISTORY_ACCESS_ITEMS_IN_MESSAGE_HEADER":"Auf Elemente in einer Nachricht zugreifen","KEYBOARD_HELP_CHAT_HISTORY_HEADER":"Chatverlauf","KEYBOARD_HELP_CHAT_HISTORY_LEAVE_MESSAGE_BODY":"ESC-Taste","KEYBOARD_HELP_CHAT_HISTORY_LEAVE_MESSAGE_HEADER":"Meldung schlie\xdfen","KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_ITEMS_BODY":"TAB-Taste\\nUMSCHALT + TAB-Taste","KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_ITEMS_HEADER":"Zwischen Elementen in einer Nachricht wechseln","KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_MESSAGES_BODY":"Pfeiltaste nach oben\\nPfeiltaste nach unten","KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_MESSAGES_HEADER":"Zwischen Nachrichten wechseln","KEYBOARD_HELP_CHAT_WINDOW_BODY_DO_ACTION_BODY":"Eingabetaste","KEYBOARD_HELP_CHAT_WINDOW_BODY_DO_ACTION_HEADER":"Aktion durchf\xfchren","KEYBOARD_HELP_CHAT_WINDOW_BODY_MOVE_BETWEEN_ITEMS_BODY":"TAB-Taste\\nUMSCHALT + TAB-Taste","KEYBOARD_HELP_CHAT_WINDOW_BODY_MOVE_BETWEEN_ITEMS_HEADER":"Zwischen Elementen im Chatfenster wechseln","KEYBOARD_HELP_CHAT_WINDOW_HEADER":"Chatfenster","KEYBOARD_HELP_CLOSE_BUTTON_ALT":"Schlie\xdfen","KEYBOARD_HELP_HEADER":"Tastatursteuerung","MARKDOWN_EXTERNAL_LINK_ALT":"Wird in einem neuen Fenster ge\xf6ffnet, extern.","RECEIPT_CARD_TAX":"Steuer","RECEIPT_CARD_TOTAL":"Gesamt","RECEIPT_CARD_VAT":"Umsatzsteuer","SEND_BOX_IS_EMPTY_TOOLTIP_ALT":"Eine leere Nachricht kann nicht gesendet werden.","SPEECH_INPUT_LISTENING":"Zuh\xf6ren\xa0...","SPEECH_INPUT_MICROPHONE_BUTTON_CLOSE_ALT":"Mikrofon aus","SPEECH_INPUT_MICROPHONE_BUTTON_OPEN_ALT":"Mikrofon an","SPEECH_INPUT_STARTING":"Wird gestartet\xa0...","SUGGESTED_ACTIONS_LABEL_ALT":"Empfohlene Aktionen","TEXT_INPUT_ALT":"Eingabefeld f\xfcr Nachricht","TEXT_INPUT_PLACEHOLDER":"Nachricht eingeben","TEXT_INPUT_SEND_BUTTON_ALT":"Senden","TEXT_INPUT_SPEAK_BUTTON_ALT":"Sprechen","TEXT_INPUT_UPLOAD_BUTTON_ALT":"Datei hochladen","TOAST_ACCORDION_FEW":"$1 Benachrichtigungen: Klicken Sie hier, um die Details anzuzeigen.","TOAST_ACCORDION_MANY":"$1 Benachrichtigungen: Klicken Sie hier, um die Details anzuzeigen.","TOAST_ACCORDION_OTHER":"$1 Benachrichtigungen: Klicken Sie hier, um die Details anzuzeigen.","TOAST_ACCORDION_TWO":"$1 Benachrichtigungen: Klicken Sie hier, um die Details anzuzeigen.","TOAST_ALT_ERROR":"Fehler","TOAST_ALT_INFO":"Informationen","TOAST_ALT_SUCCESS":"Erfolg","TOAST_ALT_WARN":"Warnung","TOAST_DISMISS_BUTTON":"Schlie\xdfen","TOAST_TITLE_ALT":"Benachrichtigung","TRANSCRIPT_ARIA_LABEL_ALT":"Zum Navigieren im Chatverlauf die Pfeiltasten verwenden.","TRANSCRIPT_ARIA_ROLE_ALT":"Chatverlauf","TRANSCRIPT_LIVE_REGION_INTERACTIVE_LABEL_ALT":"Die Nachricht ist interaktiv. Dr\xfccken Sie 2-3 mal UMSCHALT + TAB-Taste, um in den Chatverlauf zu wechseln. Klicken Sie dann auf die Nachricht, um zu interagieren.","TRANSCRIPT_LIVE_REGION_INTERACTIVE_WITH_LINKS_LABEL_ALT":"Die Nachricht enth\xe4lt mindestens einen Link. Dr\xfccken Sie 2-3 mal UMSCHALT + TAB-Taste, um in den Chatverlauf zu wechseln. Klicken Sie dann auf die Nachricht, um zu interagieren.","TRANSCRIPT_LIVE_REGION_SUGGESTED_ACTIONS_LABEL_ALT":"In der Nachricht sind Aktionen vorgeschlagen worden. Dr\xfccken Sie die UMSCHALT + TAB-Taste 2 bis 3 Mal, um sie auszuw\xe4hlen.","TRANSCRIPT_LIVE_REGION_SUGGESTED_ACTIONS_WITH_ACCESS_KEY_LABEL_ALT":"In der Nachricht sind Aktionen vorgeschlagen worden. Dr\xfccken Sie $1, um sie auszuw\xe4hlen.","TRANSCRIPT_LIVE_REGION_SEND_FAILED_ALT":"Fehler beim Senden der Nachricht.","TRANSCRIPT_MORE_MESSAGES":"Weitere Meldungen","TRANSCRIPT_NEW_MESSAGES":"Neue Nachrichten","TRANSCRIPT_TERMINATOR_TEXT":"Ende des Chatverlaufs","TYPING_INDICATOR_ALT":"Anzeigen des Eingabeindikators","TYPING_INDICATOR_SINGLE_TEXT":"$1 gibt gerade ein.","TYPING_INDICATOR_MULTIPLE_TEXT":"$1 und weitere geben gerade ein."}');

});

parcelRequire.register("50BGy", function(module, exports) {
module.exports = JSON.parse('{"_comment":"[CI-LOCKED] Το περιεχόμενο αυτού του αρχείου είναι κλειδωμένο. Οι συνεισφορές είναι ευπρόσδεκτες, αλλά η επικύρωση αλλαγών μπορεί να καθυστερήσει.","ACCESS_KEY_ALT":"Alt Shift $1","ACCESS_KEY_FOR_MAC_ALT":"Control Option $1","ACTIVITY_BOT_SAID_ALT":"Το bot $1 είπε:","ACTIVITY_YOU_SAID_ALT":"Είπατε:","ACTIVITY_BOT_ATTACHED_ALT":"Συνημμένο bot:","ACTIVITY_ERROR_BOX_TITLE":"Μήνυμα σφάλματος","ACTIVITY_INTERACTIVE_FOOTNOTE_ALT":"Κάντε κλικ για διαδραστική χρήση.","ACTIVITY_INTERACTIVE_REASON_INTERACTIVE_CONTENT_ALT":"Το μήνυμα έχει αλληλεπίδραση.","ACTIVITY_INTERACTIVE_REASON_LINK_ALT":"Μία ή περισσότερες συνδέσεις στο μήνυμα.","ACTIVITY_INTERACTIVE_REASON_SEND_FAILED_ALT":"Η αποστολή απέτυχε.","ACTIVITY_YOU_ATTACHED_ALT":"Επισυνάψατε:","ACTIVITY_NUM_ATTACHMENTS_ONE_ALT":"1 συνημμένο.","ACTIVITY_NUM_ATTACHMENTS_FEW_ALT":"$1 συνημμένα.","ACTIVITY_NUM_ATTACHMENTS_MANY_ALT":"$1 συνημμένα.","ACTIVITY_NUM_ATTACHMENTS_OTHER_ALT":"$1 συνημμένα.","ACTIVITY_NUM_ATTACHMENTS_TWO_ALT":"$1 συνημμένα.","ACTIVITY_STATUS_SEND_FAILED_RETRY":"Η αποστολή απέτυχε. [Επανάληψη][RETRY].","ACTIVITY_STATUS_SEND_STATUS_ALT_SENDING":"Αποστολή","ACTIVITY_STATUS_SEND_STATUS_ALT_SENT_AT":"Στάλθηκε στις $1","ACTIVITY_STATUS_TIMESTAMP_JUST_NOW":"Μόλις τώρα","ACTIVITY_STATUS_TIMESTAMP_ONE_HOUR_AGO":"Πριν από μία ώρα","ACTIVITY_STATUS_TIMESTAMP_ONE_MINUTE_AGO":"Πριν από ένα λεπτό","ACTIVITY_STATUS_TIMESTAMP_TODAY":"Σήμερα","ACTIVITY_STATUS_TIMESTAMP_YESTERDAY":"Εχθές","ADAPTIVE_CARD_ERROR_BOX_TITLE_PARSE":"Σφάλμα ανάλυσης προσαρμοστικής κάρτας","ADAPTIVE_CARD_ERROR_BOX_TITLE_RENDER":"Σφάλμα απόδοσης προσαρμοστικής κάρτας","ATTACHMENT_AUDIO":"Ένα απόσπασμα ήχου.","ATTACHMENT_CARD":"Μια κάρτα: $1 $2 $3","ATTACHMENT_FILE":"Ένα αρχείο: $1","ATTACHMENT_IMAGE":"Μια εικόνα","ATTACHMENT_TEXT":"Ένα κείμενο: $1","ATTACHMENT_VIDEO":"Ένα απόσπασμα βίντεο","CAROUSEL_FLIPPER_LEFT_ALT":"Αριστερά","CAROUSEL_FLIPPER_RIGHT_ALT":"Δεξιά","CONNECTIVITY_STATUS_ALT_CONNECTED":"Συνδέθηκε","CONNECTIVITY_STATUS_ALT_CONNECTING":"Σύνδεση…","CONNECTIVITY_STATUS_ALT_FATAL":"Αδυναμία σύνδεσης.","CONNECTIVITY_STATUS_ALT_RECONNECTING":"Παρουσιάστηκε διακοπή δικτύου. Επανασύνδεση...","CONNECTIVITY_STATUS_ALT_RENDER_ERROR":"Σφάλμα απόδοσης. Ελέγξτε την κονσόλα ή επικοινωνήστε με τον προγραμματιστή bot.","CONNECTIVITY_STATUS_ALT_SLOW_CONNECTION":"Η σύνδεση διαρκεί περισσότερο χρόνο από το συνηθισμένο.","CONNECTIVITY_STATUS_ALT":"Κατάσταση συνδεσιμότητας: $1","FILE_CONTENT_ALT":"\\"$1\\"","FILE_CONTENT_DOWNLOADABLE_ALT":"Λήψη αρχείου \\"$1\\"","FILE_CONTENT_DOWNLOADABLE_WITH_SIZE_ALT":"Λήψη αρχείου \\"$1\\" μεγέθους $2","FILE_CONTENT_WITH_SIZE_ALT":"\\"$1\\" μεγέθους $2","KEYBOARD_HELP_CHAT_HISTORY_ACCESS_ITEMS_IN_MESSAGE_BODY":"Πλήκτρο Enter","KEYBOARD_HELP_CHAT_HISTORY_ACCESS_ITEMS_IN_MESSAGE_HEADER":"Πρόσβαση σε στοιχεία στο μήνυμα","KEYBOARD_HELP_CHAT_HISTORY_HEADER":"Ιστορικό συνομιλίας","KEYBOARD_HELP_CHAT_HISTORY_LEAVE_MESSAGE_BODY":"Πλήκτρο Escape","KEYBOARD_HELP_CHAT_HISTORY_LEAVE_MESSAGE_HEADER":"Μήνυμα εξόδου","KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_ITEMS_BODY":"Πλήκτρο Tab\\nShift + πλήκτρο Tab","KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_ITEMS_HEADER":"Μετακινηθείτε μεταξύ στοιχείων σε ένα μήνυμα","KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_MESSAGES_BODY":"Πλήκτρο βέλους προς τα επάνω\\nΠλήκτρο βέλους προς τα κάτω","KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_MESSAGES_HEADER":"Μετακίνηση μεταξύ μηνυμάτων","KEYBOARD_HELP_CHAT_WINDOW_BODY_DO_ACTION_BODY":"Πλήκτρο Enter","KEYBOARD_HELP_CHAT_WINDOW_BODY_DO_ACTION_HEADER":"Εκτέλεση ενέργειας","KEYBOARD_HELP_CHAT_WINDOW_BODY_MOVE_BETWEEN_ITEMS_BODY":"Πλήκτρο Tab\\nShift + πλήκτρο Tab","KEYBOARD_HELP_CHAT_WINDOW_BODY_MOVE_BETWEEN_ITEMS_HEADER":"Μετακίνηση μεταξύ στοιχείων στο παράθυρο συνομιλίας","KEYBOARD_HELP_CHAT_WINDOW_HEADER":"Παράθυρο συνομιλίας","KEYBOARD_HELP_CLOSE_BUTTON_ALT":"Κλείσιμο","KEYBOARD_HELP_HEADER":"Στοιχεία ελέγχου πληκτρολόγιου","MARKDOWN_EXTERNAL_LINK_ALT":"Ανοίγει νέο παράθυρο – εξωτερικό.","RECEIPT_CARD_TAX":"Φόρος","RECEIPT_CARD_TOTAL":"Σύνολο","RECEIPT_CARD_VAT":"ΦΠΑ","SEND_BOX_IS_EMPTY_TOOLTIP_ALT":"Δεν είναι η αποστολή κενού μηνύματος.","SPEECH_INPUT_LISTENING":"Ακρόαση...","SPEECH_INPUT_MICROPHONE_BUTTON_CLOSE_ALT":"Μικρόφωνο ανενεργό","SPEECH_INPUT_MICROPHONE_BUTTON_OPEN_ALT":"Μικρόφωνο ενεργό","SPEECH_INPUT_STARTING":"Έναρξη…","SUGGESTED_ACTIONS_LABEL_ALT":"Προτεινόμενες ενέργειες","TEXT_INPUT_ALT":"Πλαίσιο εισαγωγής μηνύματος","TEXT_INPUT_PLACEHOLDER":"Πληκτρολογήστε το μήνυμά σας","TEXT_INPUT_SEND_BUTTON_ALT":"Αποστολή","TEXT_INPUT_SPEAK_BUTTON_ALT":"Ομιλία","TEXT_INPUT_UPLOAD_BUTTON_ALT":"Αποστολή αρχείου","TOAST_ACCORDION_FEW":"$1 Ειδοποιήσεις: Κάντε κλικ εδώ για να δείτε λεπτομέρειες","TOAST_ACCORDION_MANY":"$1 Ειδοποιήσεις: Κάντε κλικ εδώ για να δείτε λεπτομέρειες","TOAST_ACCORDION_OTHER":"$1 Ειδοποιήσεις: Κάντε κλικ εδώ για να δείτε λεπτομέρειες","TOAST_ACCORDION_TWO":"$1 Ειδοποιήσεις: Κάντε κλικ εδώ για να δείτε λεπτομέρειες","TOAST_ALT_ERROR":"Σφάλμα","TOAST_ALT_INFO":"Πληροφορίες","TOAST_ALT_SUCCESS":"Επιτυχία","TOAST_ALT_WARN":"Προειδοποίηση","TOAST_DISMISS_BUTTON":"Ματαίωση","TOAST_TITLE_ALT":"Ειδοποίηση","TRANSCRIPT_ARIA_LABEL_ALT":"Ιστορικό συνομιλίας, πιέστε τα πλήκτρα βέλους για περιήγηση.","TRANSCRIPT_ARIA_ROLE_ALT":"ιστορικό συνομιλίας","TRANSCRIPT_LIVE_REGION_INTERACTIVE_LABEL_ALT":"Το μήνυμα είναι αλληλεπιδραστικό. Πιέστε τον συνδυασμό πλήκτρων Shift και Tab 2 έως 3 φορές για να μεταβείτε στο ιστορικό συνομιλίας. Στη συνέχεια, κάντε κλικ στο μήνυμα για αλληλεπίδραση.","TRANSCRIPT_LIVE_REGION_INTERACTIVE_WITH_LINKS_LABEL_ALT":"Μία ή περισσότερες συνδέσεις στο μήνυμα. Πιέστε τον συνδυασμό πλήκτρων Shift και Tab 2 έως 3 φορές για να μεταβείτε στο ιστορικό συνομιλίας. Στη συνέχεια, κάντε κλικ στο μήνυμα για αλληλεπίδραση.","TRANSCRIPT_LIVE_REGION_SUGGESTED_ACTIONS_LABEL_ALT":"Το μήνυμα έχει προτεινόμενες ενέργειες. Πιέστε τον συνδυασμό πλήκτρων Shift και Tab 2 έως 3 φορές για να τις επιλέξετε.","TRANSCRIPT_LIVE_REGION_SUGGESTED_ACTIONS_WITH_ACCESS_KEY_LABEL_ALT":"Το μήνυμα έχει προτεινόμενες ενέργειες. Πιέστε $1 για να τις επιλέξετε.","TRANSCRIPT_LIVE_REGION_SEND_FAILED_ALT":"Δεν ήταν δυνατή η αποστολή του μηνύματος.","TRANSCRIPT_MORE_MESSAGES":"Περισσότερα μηνύματα","TRANSCRIPT_NEW_MESSAGES":"Νέα μηνύματα","TRANSCRIPT_TERMINATOR_TEXT":"Λήξη ιστορικού συνομιλίας","TYPING_INDICATOR_ALT":"Εμφάνιση δείκτη πληκτρολόγησης","TYPING_INDICATOR_SINGLE_TEXT":"Ο/Η $1 πληκτρολογεί.","TYPING_INDICATOR_MULTIPLE_TEXT":"Ο/Η $1 και άλλοι πληκτρολογούν."}');

});

parcelRequire.register("c0YBH", function(module, exports) {
module.exports = JSON.parse('{"_comment":"[CI-LOCKED] The content of this file is locked. Contributions are welcome, but change validation may be delayed.","ACCESS_KEY_ALT":"Alt Shift $1","_ACCESS_KEY_ALT.comment":"These are keyboard modifier keys for screen reader.","ACCESS_KEY_FOR_MAC_ALT":"Control Option $1","_ACCESS_KEY_FOR_MAC_ALT.comment":"These are keyboard modifier keys for screen reader on a Mac.","ACTIVITY_BOT_SAID_ALT":"Bot $1 said:","_ACTIVITY_BOT_SAID_ALT.comment":"This is for screen reader only. $1 is the initials for the bot (e.g. \\"JD\\").","ACTIVITY_YOU_SAID_ALT":"You said:","_ACTIVITY_YOU_SAID_ALT.comment":"This is for screen reader only.","ACTIVITY_BOT_ATTACHED_ALT":"Bot attached:","_ACTIVITY_BOT_ATTACHED_ALT.comment":"This is for screen reader and is narrated before each attachments sent by the bot.","ACTIVITY_ERROR_BOX_TITLE":"Error message","ACTIVITY_INTERACTIVE_FOOTNOTE_ALT":"Click to interact.","_ACTIVITY_INTERACTIVE_FOOTNOTE_ALT.comment":"This is for screen reader. When the user is navigating to this message which is either contains interactive elements, contains links, or failed to send (with a retry button), it will give this hint.","ACTIVITY_INTERACTIVE_REASON_INTERACTIVE_CONTENT_ALT":"Message is interactive.","_ACTIVITY_INTERACTIVE_REASON_INTERACTIVE_CONTENT_ALT.comment":"This is for screen reader. When the user is navigating to this message which contains interactive elements (excluding links), it will give this hint.","ACTIVITY_INTERACTIVE_REASON_LINK_ALT":"One or more links in the message.","_ACTIVITY_INTERACTIVE_REASON_LINK_ALT.comment":"This is for screen reader. When the user is navigating to this message which contains links, it will give this hint.","ACTIVITY_INTERACTIVE_REASON_SEND_FAILED_ALT":"Send failed.","_ACTIVITY_INTERACTIVE_REASON_SEND_FAILED_ALT.comment":"This is for screen reader. When the user is navigating to this message which was failed to send, it will give this hint.","ACTIVITY_YOU_ATTACHED_ALT":"You attached:","_ACTIVITY_YOU_ATTACHED_ALT.comment":"This is for screen reader and is narrated before each attachments sent by the user.","ACTIVITY_NUM_ATTACHMENTS_ONE_ALT":"1 attachment.","_ACTIVITY_NUM_ATTACHMENTS_ONE_ALT.comment":"This is for screen reader and only narrated when the message arrive. The narration when the message arrive, could be \\"Bot WC said: Hello, World! 1 attachment. Sent at 2020-01-02 12:34 PM.\\". This is for plural rule of \\"one\\".","ACTIVITY_NUM_ATTACHMENTS_FEW_ALT":"$1 attachments.","_ACTIVITY_NUM_ATTACHMENTS_FEW_ALT.comment":"$1 is the number of attachments. This is for plural rule of \\"few\\".","ACTIVITY_NUM_ATTACHMENTS_MANY_ALT":"$1 attachments.","_ACTIVITY_NUM_ATTACHMENTS_MANY_ALT.comment":"$1 is the number of attachments. This is for plural rule of \\"many\\".","ACTIVITY_NUM_ATTACHMENTS_OTHER_ALT":"$1 attachments.","_ACTIVITY_NUM_ATTACHMENTS_OTHER_ALT.comment":"$1 is the number of attachments. This is for plural rule of \\"other\\".","ACTIVITY_NUM_ATTACHMENTS_TWO_ALT":"$1 attachments.","_ACTIVITY_NUM_ATTACHMENTS_TWO_ALT.comment":"$1 is the number of attachments. This is for plural rule of \\"two\\".","ACTIVITY_STATUS_SEND_FAILED_RETRY":"Send failed. [Retry][RETRY].","_ACTIVITY_STATUS_SEND_FAILED_RETRY.comment":"This is Markdown. Do not localize \\"[RETRY]\\" (the one in uppercase).","ACTIVITY_STATUS_SEND_STATUS_ALT_SENDING":"Sending","ACTIVITY_STATUS_SEND_STATUS_ALT_SENT_AT":"Sent at $1","_ACTIVITY_STATUS_SEND_STATUS_ALT_SENT_AT.comment":"$1 is the time when the message is successfully sent, in absolute format, e.g. 12:34 PM.","ACTIVITY_STATUS_TIMESTAMP_JUST_NOW":"Just now","ACTIVITY_STATUS_TIMESTAMP_ONE_HOUR_AGO":"An hour ago","ACTIVITY_STATUS_TIMESTAMP_ONE_MINUTE_AGO":"A minute ago","ACTIVITY_STATUS_TIMESTAMP_TODAY":"Today","ACTIVITY_STATUS_TIMESTAMP_YESTERDAY":"Yesterday","ADAPTIVE_CARD_ERROR_BOX_TITLE_PARSE":"Adaptive Card parse error","ADAPTIVE_CARD_ERROR_BOX_TITLE_RENDER":"Adaptive Card render error","ATTACHMENT_AUDIO":"An audio clip.","ATTACHMENT_CARD":"A card: $1 $2 $3","_ATTACHMENT_CARD.comment":"$1 is the title of the card. $2 is the subtitle. $3 is the text content.","ATTACHMENT_FILE":"A file: $1","_ATTACHMENT_FILE.comment":"$1 is the filename.","ATTACHMENT_IMAGE":"An image","ATTACHMENT_TEXT":"A text: $1","_ATTACHMENT_TEXT.comment":"$1 is the content.","ATTACHMENT_VIDEO":"A video clip","CAROUSEL_FLIPPER_NEXT_ALT":"Next","_CAROUSEL_FLIPPER_NEXT_ALT.comment":"This is for screen reader for the label of the right flipper button for carousels for left-to-right language or left flipper button for right-to-left (RTL) languages. To support RTL, the language used in this text should be less directional.","CAROUSEL_FLIPPER_PREVIOUS_ALT":"Previous","_CAROUSEL_FLIPPER_PREVIOUS_ALT.comment":"This is for screen reader for the label of the left flipper button for carousels for left-to-right language or right flipper button for right-to-left (RTL) languages. To support RTL, the language used in this text should be less directional.","CONNECTIVITY_STATUS_ALT_CONNECTED":"Connected","CONNECTIVITY_STATUS_ALT_CONNECTING":"Connecting…","CONNECTIVITY_STATUS_ALT_FATAL":"Unable to connect.","CONNECTIVITY_STATUS_ALT_RECONNECTING":"Network interruption occurred. Reconnecting…","CONNECTIVITY_STATUS_ALT_RENDER_ERROR":"Render error. Please check the console or contact the bot developer.","CONNECTIVITY_STATUS_ALT_SLOW_CONNECTION":"Taking longer than usual to connect.","CONNECTIVITY_STATUS_ALT":"Connectivity Status: $1","_CONNECTIVITY_STATUS_ALT.comment":"This is for screen reader. $1 will be one of \\"CONNECTIVITY_STATUS_ALT_\\"*.","FILE_CONTENT_ALT":"\'$1\'","FILE_CONTENT_DOWNLOADABLE_ALT":"Download file \'$1\'","FILE_CONTENT_DOWNLOADABLE_WITH_SIZE_ALT":"Download file \'$1\' of size $2","FILE_CONTENT_WITH_SIZE_ALT":"\'$1\' of size $2","_FILE_CONTENT_ALT.comment":"$1 is the name of the file, e.g. document.docx. $2 is the file size, e.g. 12 MB","KEYBOARD_HELP_CHAT_HISTORY_ACCESS_ITEMS_IN_MESSAGE_BODY":"Enter key","KEYBOARD_HELP_CHAT_HISTORY_ACCESS_ITEMS_IN_MESSAGE_HEADER":"Access items in message","KEYBOARD_HELP_CHAT_HISTORY_HEADER":"Chat history","KEYBOARD_HELP_CHAT_HISTORY_LEAVE_MESSAGE_BODY":"Escape key","KEYBOARD_HELP_CHAT_HISTORY_LEAVE_MESSAGE_HEADER":"Exit message","_KEYBOARD_HELP_CHAT_HISTORY_LEAVE_MESSAGE_HEADER.comment":"While focus is on the message, when the user press ESCAPE key, it should exit the message focus mode and focus back on the text box in the send box.","KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_ITEMS_BODY":"Tab key\\nShift + tab key","KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_ITEMS_HEADER":"Move between items in a message","KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_MESSAGES_BODY":"Arrow up key\\nArrow down key","KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_MESSAGES_HEADER":"Move between messages","KEYBOARD_HELP_CHAT_WINDOW_BODY_DO_ACTION_BODY":"Enter key","KEYBOARD_HELP_CHAT_WINDOW_BODY_DO_ACTION_HEADER":"Do action","KEYBOARD_HELP_CHAT_WINDOW_BODY_MOVE_BETWEEN_ITEMS_BODY":"Tab key\\nShift + tab key","KEYBOARD_HELP_CHAT_WINDOW_BODY_MOVE_BETWEEN_ITEMS_HEADER":"Move between items in the chat window","KEYBOARD_HELP_CHAT_WINDOW_HEADER":"Chat window","KEYBOARD_HELP_CLOSE_BUTTON_ALT":"Close","KEYBOARD_HELP_HEADER":"Keyboard controls","MARKDOWN_EXTERNAL_LINK_ALT":"Opens in a new window; external.","_MARKDOWN_EXTERNAL_LINK_ALT.comment":"This is for the screen reader and is added to the label of the hyperlink. When clicked, the hyperlink will open in a new tab or window.","RECEIPT_CARD_TAX":"Tax","RECEIPT_CARD_TOTAL":"Total","RECEIPT_CARD_VAT":"VAT","SEND_BOX_IS_EMPTY_TOOLTIP_ALT":"Cannot send empty message.","_SEND_BOX_IS_EMPTY_TOOLTIP_ALT.comment":"This is for screen reader on the send button. When the send text box is empty, the send button is disabled and this text on the send button explain why the button is disabled.","SPEECH_INPUT_LISTENING":"Listening…","SPEECH_INPUT_MICROPHONE_BUTTON_CLOSE_ALT":"Microphone off","_SPEECH_INPUT_MICROPHONE_BUTTON_CLOSE_ALT.comment":"This is for screen reader and is the label of the microphone button, when clicked, will close microphone.","SPEECH_INPUT_MICROPHONE_BUTTON_OPEN_ALT":"Microphone on","_SPEECH_INPUT_MICROPHONE_BUTTON_OPEN_ALT.comment":"This is for screen reader and is the label of the microphone button, when clicked, will open microphone.","SPEECH_INPUT_STARTING":"Starting…","SUGGESTED_ACTIONS_FLIPPER_NEXT_ALT":"Next","_SUGGESTED_ACTIONS_FLIPPER_NEXT_ALT.comment":"This is for screen reader for the label of the right flipper button for suggested actions. Probably can re-use the value from CAROUSEL_FLIPPER_NEXT_ALT.","SUGGESTED_ACTIONS_FLIPPER_PREVIOUS_ALT":"Previous","_SUGGESTED_ACTIONS_FLIPPER_PREVIOUS_ALT.comment":"This is for screen reader for the label of the left flipper button for suggested actions. Probably can re-use the value from CAROUSEL_FLIPPER_PREVIOUS_ALT.","SUGGESTED_ACTIONS_LABEL_ALT":"Suggested actions","_SUGGESTED_ACTIONS_LABEL_ALT.comment":"This is for screen reader. Browser will read as \\"Suggested actions toolbar\\", where \\"toolbar\\" is a role name appended by browser.","TEXT_INPUT_ALT":"Message input box","_TEXT_INPUT_ALT.comment":"This is for screen reader for the label of the message input box.","TEXT_INPUT_PLACEHOLDER":"Type your message","TEXT_INPUT_SEND_BUTTON_ALT":"Send","TEXT_INPUT_SPEAK_BUTTON_ALT":"Speak","TEXT_INPUT_UPLOAD_BUTTON_ALT":"Upload file","TOAST_ACCORDION_FEW":"$1 Notifications: Click here to see details","_TOAST_ACCORDION_FEW.comment":"$1 is the number of notifications. This is for plural rule of \\"few\\".","TOAST_ACCORDION_MANY":"$1 Notifications: Click here to see details","_TOAST_ACCORDION_MANY.comment":"$1 is the number of notifications. This is for plural rule of \\"many\\".","TOAST_ACCORDION_OTHER":"$1 Notifications: Click here to see details","_TOAST_ACCORDION_OTHER.comment":"$1 is the number of notifications. This is for plural rule of \\"other\\".","TOAST_ACCORDION_TWO":"$1 Notifications: Click here to see details","_TOAST_ACCORDION_TWO.comment":"$1 is the number of notifications. This is for plural rule of \\"two\\".","TOAST_ALT_ERROR":"Error","_TOAST_ALT_ERROR.comment":"This is for screen reader.","TOAST_ALT_INFO":"Information","_TOAST_ALT_INFO.comment":"This is for screen reader.","TOAST_ALT_SUCCESS":"Success","_TOAST_ALT_SUCCESS.comment":"This is for screen reader.","TOAST_ALT_WARN":"Warning","_TOAST_ALT_WARN.comment":"This is for screen reader.","TOAST_DISMISS_BUTTON":"Dismiss","TOAST_TITLE_ALT":"Notification","_TOAST_TITLE_ALT.comment":"This is for screen reader. The label for individiual notification.","TRANSCRIPT_ARIA_LABEL_ALT":"Chat history, press arrow keys to navigate.","_TRANSCRIPT_ARIA_LABEL_ALT.comment":"This is for screen reader for the label that will be narrated when the chat history is focused.","TRANSCRIPT_ARIA_ROLE_ALT":"chat history","_TRANSCRIPT_ARIA_ROLE_ALT.comment":"This is for screen reader for the aria-roledescription of the chat history container.","TRANSCRIPT_LIVE_REGION_INTERACTIVE_LABEL_ALT":"Message is interactive. Press shift tab key 2 to 3 times to switch to the chat history. Then click on the message to interact.","_TRANSCRIPT_LIVE_REGION_INTERACTIVE_LABEL_ALT.comment":"This is for screen reader. When one or more activities arrived with interactive elements (no links) attached, the chat history (live region) will give this hint.","TRANSCRIPT_LIVE_REGION_INTERACTIVE_WITH_LINKS_LABEL_ALT":"One or more links in the message. Press shift tab key 2 to 3 times to switch to the chat history. Then click on the message to interact.","_TRANSCRIPT_LIVE_REGION_INTERACTIVE_WITH_LINKS_LABEL_ALT.comment":"This is for screen reader. When one or more activities arrived with links attached, the chat history (live region) will give this hint.","TRANSCRIPT_LIVE_REGION_SUGGESTED_ACTIONS_LABEL_ALT":"Message has suggested actions. Press shift tab 2 to 3 times to select them.","TRANSCRIPT_LIVE_REGION_SUGGESTED_ACTIONS_WITH_ACCESS_KEY_LABEL_ALT":"Message has suggested actions. Press $1 to select them.","_TRANSCRIPT_LIVE_REGION_SUGGESTED_ACTIONS_WITH_ACCESS_KEY_LABEL_ALT.comment":"$1 will be \\"ACCESS_KEY_ALT\\".","TRANSCRIPT_LIVE_REGION_SEND_FAILED_ALT":"Failed to send message.","TRANSCRIPT_MORE_MESSAGES":"More messages","TRANSCRIPT_NEW_MESSAGES":"New messages","TRANSCRIPT_TERMINATOR_TEXT":"End of chat history","TYPING_INDICATOR_ALT":"Showing typing indicator","_TYPING_INDICATOR_SINGLE_TEXT.comment":"This shows when a single user is typing.","TYPING_INDICATOR_SINGLE_TEXT":"$1 is typing.","_TYPING_INDICATOR_MULTIPLE_TEXT.comment":"This shows when two or more users are typing simultaneously.","TYPING_INDICATOR_MULTIPLE_TEXT":"$1 and others are typing."}');

});

parcelRequire.register("hxnEE", function(module, exports) {
module.exports = JSON.parse('{"_comment":"[CI-LOCKED] El contenido de este archivo est\xe1 bloqueado. Todas las aportaciones son bienvenidas, pero la validaci\xf3n de cambios se puede retrasar.","ACCESS_KEY_ALT":"Alt May\xfas $1","ACCESS_KEY_FOR_MAC_ALT":"Control Opci\xf3n $1","ACTIVITY_BOT_SAID_ALT":"El bot $1 dijo:","ACTIVITY_YOU_SAID_ALT":"Usted dijo:","ACTIVITY_BOT_ATTACHED_ALT":"Bot adjunto:","ACTIVITY_ERROR_BOX_TITLE":"Mensaje de error","ACTIVITY_INTERACTIVE_FOOTNOTE_ALT":"Haga clic para interactuar.","ACTIVITY_INTERACTIVE_REASON_INTERACTIVE_CONTENT_ALT":"El mensaje es interactivo.","ACTIVITY_INTERACTIVE_REASON_LINK_ALT":"Uno o varios v\xednculos en el mensaje.","ACTIVITY_INTERACTIVE_REASON_SEND_FAILED_ALT":"Errores de env\xedo.","ACTIVITY_YOU_ATTACHED_ALT":"Usted adjunt\xf3:","ACTIVITY_NUM_ATTACHMENTS_ONE_ALT":"1 archivo adjunto.","ACTIVITY_NUM_ATTACHMENTS_FEW_ALT":"$1 datos adjuntos.","ACTIVITY_NUM_ATTACHMENTS_MANY_ALT":"$1 datos adjuntos.","ACTIVITY_NUM_ATTACHMENTS_OTHER_ALT":"$1 datos adjuntos.","ACTIVITY_NUM_ATTACHMENTS_TWO_ALT":"$1 datos adjuntos.","ACTIVITY_STATUS_SEND_FAILED_RETRY":"No se pudo enviar. [Reintentar][RETRY].","ACTIVITY_STATUS_SEND_STATUS_ALT_SENDING":"Enviando","ACTIVITY_STATUS_SEND_STATUS_ALT_SENT_AT":"Enviado a las $1","ACTIVITY_STATUS_TIMESTAMP_JUST_NOW":"Ahora mismo","ACTIVITY_STATUS_TIMESTAMP_ONE_HOUR_AGO":"Hace una hora","ACTIVITY_STATUS_TIMESTAMP_ONE_MINUTE_AGO":"Hace un minuto","ACTIVITY_STATUS_TIMESTAMP_TODAY":"Hoy","ACTIVITY_STATUS_TIMESTAMP_YESTERDAY":"Ayer","ADAPTIVE_CARD_ERROR_BOX_TITLE_PARSE":"Error de an\xe1lisis de tarjeta adaptable","ADAPTIVE_CARD_ERROR_BOX_TITLE_RENDER":"Error de representaci\xf3n de tarjeta adaptable","ATTACHMENT_AUDIO":"Clip de audio.","ATTACHMENT_CARD":"Tarjeta: $1 $2 $3","ATTACHMENT_FILE":"Archivo: $1","ATTACHMENT_IMAGE":"Imagen","ATTACHMENT_TEXT":"Texto: $1","ATTACHMENT_VIDEO":"Clip de v\xeddeo","CAROUSEL_FLIPPER_LEFT_ALT":"Izquierdo","CAROUSEL_FLIPPER_RIGHT_ALT":"Derecho","CONNECTIVITY_STATUS_ALT_CONNECTED":"Conectado","CONNECTIVITY_STATUS_ALT_CONNECTING":"Conectando…","CONNECTIVITY_STATUS_ALT_FATAL":"No se puede conectar.","CONNECTIVITY_STATUS_ALT_RECONNECTING":"Interrupci\xf3n de la red. Conectando de nuevo…","CONNECTIVITY_STATUS_ALT_RENDER_ERROR":"Error de representaci\xf3n. Compruebe la consola o p\xf3ngase en contacto con el desarrollador del bot.","CONNECTIVITY_STATUS_ALT_SLOW_CONNECTION":"Se est\xe1 tardando m\xe1s de lo habitual en conectarse.","CONNECTIVITY_STATUS_ALT":"Estado de conexi\xf3n: $1","FILE_CONTENT_ALT":"\'$1\'","FILE_CONTENT_DOWNLOADABLE_ALT":"Descargar archivo \'$1\'","FILE_CONTENT_DOWNLOADABLE_WITH_SIZE_ALT":"Descargar el archivo \'$1\' de tama\xf1o $2","FILE_CONTENT_WITH_SIZE_ALT":"\'$1\' de tama\xf1o $2","KEYBOARD_HELP_CHAT_HISTORY_ACCESS_ITEMS_IN_MESSAGE_BODY":"Tecla Entrar","KEYBOARD_HELP_CHAT_HISTORY_ACCESS_ITEMS_IN_MESSAGE_HEADER":"Acceder a elementos del mensaje","KEYBOARD_HELP_CHAT_HISTORY_HEADER":"Historial de chats","KEYBOARD_HELP_CHAT_HISTORY_LEAVE_MESSAGE_BODY":"Tecla Escape","KEYBOARD_HELP_CHAT_HISTORY_LEAVE_MESSAGE_HEADER":"Salir del mensaje","KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_ITEMS_BODY":"Tecla Tab\\nTeclas May\xfas + Tab","KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_ITEMS_HEADER":"Moverse entre elementos de un mensaje","KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_MESSAGES_BODY":"Tecla Flecha arriba\\nTecla Flecha abajo","KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_MESSAGES_HEADER":"Moverse entre mensajes","KEYBOARD_HELP_CHAT_WINDOW_BODY_DO_ACTION_BODY":"Tecla Entrar","KEYBOARD_HELP_CHAT_WINDOW_BODY_DO_ACTION_HEADER":"Ejecutar acci\xf3n","KEYBOARD_HELP_CHAT_WINDOW_BODY_MOVE_BETWEEN_ITEMS_BODY":"Tecla Tab\\nTeclas May\xfas + Tab","KEYBOARD_HELP_CHAT_WINDOW_BODY_MOVE_BETWEEN_ITEMS_HEADER":"Moverse entre elementos de la ventana de chat","KEYBOARD_HELP_CHAT_WINDOW_HEADER":"Ventana de chat","KEYBOARD_HELP_CLOSE_BUTTON_ALT":"Cerrar","KEYBOARD_HELP_HEADER":"Controles de teclado","MARKDOWN_EXTERNAL_LINK_ALT":"Se abre en una ventana nueva; externo.","RECEIPT_CARD_TAX":"Impuesto","RECEIPT_CARD_TOTAL":"Total","RECEIPT_CARD_VAT":"IVA","SEND_BOX_IS_EMPTY_TOOLTIP_ALT":"No se puede enviar un mensaje vac\xedo.","SPEECH_INPUT_LISTENING":"Escuchando…","SPEECH_INPUT_MICROPHONE_BUTTON_CLOSE_ALT":"Micr\xf3fono desactivado","SPEECH_INPUT_MICROPHONE_BUTTON_OPEN_ALT":"Micr\xf3fono activado","SPEECH_INPUT_STARTING":"Iniciando…","SUGGESTED_ACTIONS_LABEL_ALT":"Acciones sugeridas","TEXT_INPUT_ALT":"Cuadro de entrada de mensajes","TEXT_INPUT_PLACEHOLDER":"Escriba su mensaje","TEXT_INPUT_SEND_BUTTON_ALT":"Enviar","TEXT_INPUT_SPEAK_BUTTON_ALT":"Hablar","TEXT_INPUT_UPLOAD_BUTTON_ALT":"Cargar archivo","TOAST_ACCORDION_FEW":"$1 notificaciones: Haga clic aqu\xed para ver m\xe1s detalles","TOAST_ACCORDION_MANY":"$1 notificaciones: Haga clic aqu\xed para ver m\xe1s detalles","TOAST_ACCORDION_OTHER":"$1 notificaciones: Haga clic aqu\xed para ver m\xe1s detalles","TOAST_ACCORDION_TWO":"$1 notificaciones: Haga clic aqu\xed para ver m\xe1s detalles","TOAST_ALT_ERROR":"Error","TOAST_ALT_INFO":"Informaci\xf3n","TOAST_ALT_SUCCESS":"Correcta","TOAST_ALT_WARN":"Advertencia","TOAST_DISMISS_BUTTON":"Descartar","TOAST_TITLE_ALT":"Notificaci\xf3n","TRANSCRIPT_ARIA_LABEL_ALT":"Historial de chats, presione las teclas de direcci\xf3n para navegar.","TRANSCRIPT_ARIA_ROLE_ALT":"historial de chats","TRANSCRIPT_LIVE_REGION_INTERACTIVE_LABEL_ALT":"El mensaje es interactivo. Presione May\xfas + Tab de 2\xa0a 3 veces para cambiar al historial de chats. Despu\xe9s, haga clic en el mensaje para interactuar.","TRANSCRIPT_LIVE_REGION_INTERACTIVE_WITH_LINKS_LABEL_ALT":"El mensaje contiene uno o varios v\xednculos. Presione May\xfas +Tab de 2\xa0a 3 veces para cambiar al historial de chats. Despu\xe9s, haga clic en el mensaje para interactuar.","TRANSCRIPT_LIVE_REGION_SUGGESTED_ACTIONS_LABEL_ALT":"El mensaje ha sugerido acciones. Presione May\xfas + Tab de 2\xa0a 3 veces para seleccionarlas.","TRANSCRIPT_LIVE_REGION_SUGGESTED_ACTIONS_WITH_ACCESS_KEY_LABEL_ALT":"El mensaje ha sugerido acciones. Presione $1 para seleccionarlas.","TRANSCRIPT_LIVE_REGION_SEND_FAILED_ALT":"No se pudo enviar el mensaje.","TRANSCRIPT_MORE_MESSAGES":"M\xe1s mensajes","TRANSCRIPT_NEW_MESSAGES":"Mensajes nuevos","TRANSCRIPT_TERMINATOR_TEXT":"Final del historial de chats","TYPING_INDICATOR_ALT":"Mostrando indicador de escritura","TYPING_INDICATOR_SINGLE_TEXT":"$1 est\xe1 escribiendo.","TYPING_INDICATOR_MULTIPLE_TEXT":"$1 y otros usuarios est\xe1n escribiendo."}');

});

parcelRequire.register("2OzYo", function(module, exports) {
module.exports = JSON.parse('{"_comment":"[CI-LOCKED] Selle faili sisu on lukus. Panused on teretulnud, kuid muudatuste valideerimine v\xf5ib aega v\xf5tta.","ACCESS_KEY_ALT":"Alt Shift $1","ACCESS_KEY_FOR_MAC_ALT":"Control Option $1","ACTIVITY_BOT_SAID_ALT":"Robot $1 \xfctles:","ACTIVITY_YOU_SAID_ALT":"Te \xfctlesite:","ACTIVITY_BOT_ATTACHED_ALT":"Manustatud robot:","ACTIVITY_ERROR_BOX_TITLE":"T\xf5rketeade","ACTIVITY_INTERACTIVE_FOOTNOTE_ALT":"Kl\xf5psake kasutamiseks.","ACTIVITY_INTERACTIVE_REASON_INTERACTIVE_CONTENT_ALT":"S\xf5num on interaktiivne.","ACTIVITY_INTERACTIVE_REASON_LINK_ALT":"S\xf5numis on v\xe4hemalt \xfcks link.","ACTIVITY_INTERACTIVE_REASON_SEND_FAILED_ALT":"Saatmine nurjus.","ACTIVITY_YOU_ATTACHED_ALT":"Manustasite:","ACTIVITY_NUM_ATTACHMENTS_ONE_ALT":"1 manus.","ACTIVITY_NUM_ATTACHMENTS_FEW_ALT":"$1 manust.","ACTIVITY_NUM_ATTACHMENTS_MANY_ALT":"$1 manust.","ACTIVITY_NUM_ATTACHMENTS_OTHER_ALT":"$1 manust.","ACTIVITY_NUM_ATTACHMENTS_TWO_ALT":"$1 manust.","ACTIVITY_STATUS_SEND_FAILED_RETRY":"Saatmine nurjus. [Proovi uuesti][RETRY].","ACTIVITY_STATUS_SEND_STATUS_ALT_SENDING":"Saatmine","ACTIVITY_STATUS_SEND_STATUS_ALT_SENT_AT":"Saadetud kell $1","ACTIVITY_STATUS_TIMESTAMP_JUST_NOW":"Just praegu","ACTIVITY_STATUS_TIMESTAMP_ONE_HOUR_AGO":"Tund tagasi","ACTIVITY_STATUS_TIMESTAMP_ONE_MINUTE_AGO":"Minut tagasi","ACTIVITY_STATUS_TIMESTAMP_TODAY":"T\xe4na","ACTIVITY_STATUS_TIMESTAMP_YESTERDAY":"Eile","ADAPTIVE_CARD_ERROR_BOX_TITLE_PARSE":"Kohandatava kaardi s\xf5elumise t\xf5rge","ADAPTIVE_CARD_ERROR_BOX_TITLE_RENDER":"Kohandatava kaardi renderdamise t\xf5rge","ATTACHMENT_AUDIO":"Heliklipp.","ATTACHMENT_CARD":"Kaart: $1 $2 $3","ATTACHMENT_FILE":"Fail: $1","ATTACHMENT_IMAGE":"Pilt","ATTACHMENT_TEXT":"Tekst: $1","ATTACHMENT_VIDEO":"Videoklipp","CAROUSEL_FLIPPER_LEFT_ALT":"Vasak","CAROUSEL_FLIPPER_RIGHT_ALT":"Parem","CONNECTIVITY_STATUS_ALT_CONNECTED":"\xdchendatud","CONNECTIVITY_STATUS_ALT_CONNECTING":"\xdchenduse loomine…","CONNECTIVITY_STATUS_ALT_FATAL":"\xdchendamine nurjus.","CONNECTIVITY_STATUS_ALT_RECONNECTING":"Ilmnes v\xf5rgukatkestus. Uuesti \xfchendamine…","CONNECTIVITY_STATUS_ALT_RENDER_ERROR":"Renderdamise t\xf5rge. Kontrollige konsooli v\xf5i p\xf6\xf6rduge roboti arendaja poole.","CONNECTIVITY_STATUS_ALT_SLOW_CONNECTION":"\xdchenduse loomiseks l\xe4heb tavap\xe4rasest kauem aega.","CONNECTIVITY_STATUS_ALT":"\xdchenduse olek: $1","FILE_CONTENT_ALT":"„$1“","FILE_CONTENT_DOWNLOADABLE_ALT":"Laadi alla fail „$1“","FILE_CONTENT_DOWNLOADABLE_WITH_SIZE_ALT":"Laadi alla fail „$1” mahuga $2","FILE_CONTENT_WITH_SIZE_ALT":"„$1” mahuga $2","KEYBOARD_HELP_CHAT_HISTORY_ACCESS_ITEMS_IN_MESSAGE_BODY":"Sisestusklahv","KEYBOARD_HELP_CHAT_HISTORY_ACCESS_ITEMS_IN_MESSAGE_HEADER":"Juurdep\xe4\xe4s s\xf5numi \xfcksustele","KEYBOARD_HELP_CHAT_HISTORY_HEADER":"Vestluse ajalugu","KEYBOARD_HELP_CHAT_HISTORY_LEAVE_MESSAGE_BODY":"Paoklahv","KEYBOARD_HELP_CHAT_HISTORY_LEAVE_MESSAGE_HEADER":"V\xe4lju s\xf5numist","KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_ITEMS_BODY":"Tabeldusklahv\\nT\xf5stuklahv + tabeldusklahv","KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_ITEMS_HEADER":"S\xf5numis \xfchest \xfcksusest teise liikumine","KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_MESSAGES_BODY":"\xdclesnooleklahv\\nAllanooleklahv","KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_MESSAGES_HEADER":"\xdchest s\xf5numist teise liikumine","KEYBOARD_HELP_CHAT_WINDOW_BODY_DO_ACTION_BODY":"Sisestusklahv","KEYBOARD_HELP_CHAT_WINDOW_BODY_DO_ACTION_HEADER":"Tee toiming","KEYBOARD_HELP_CHAT_WINDOW_BODY_MOVE_BETWEEN_ITEMS_BODY":"Tabeldusklahv\\nT\xf5stuklahv + tabeldusklahv","KEYBOARD_HELP_CHAT_WINDOW_BODY_MOVE_BETWEEN_ITEMS_HEADER":"Vestlusaknas \xfchest \xfcksusest teise liikumine","KEYBOARD_HELP_CHAT_WINDOW_HEADER":"Vestlusaken","KEYBOARD_HELP_CLOSE_BUTTON_ALT":"Sule","KEYBOARD_HELP_HEADER":"Klaviatuuri juhtelemendid","MARKDOWN_EXTERNAL_LINK_ALT":"Avab uues aknas; v\xe4line.","RECEIPT_CARD_TAX":"Maks","RECEIPT_CARD_TOTAL":"Kokku","RECEIPT_CARD_VAT":"KM","SEND_BOX_IS_EMPTY_TOOLTIP_ALT":"T\xfchja s\xf5numit ei saa saata.","SPEECH_INPUT_LISTENING":"Kuulamine…","SPEECH_INPUT_MICROPHONE_BUTTON_CLOSE_ALT":"Mikrofon v\xe4ljas","SPEECH_INPUT_MICROPHONE_BUTTON_OPEN_ALT":"Mikrofon sees","SPEECH_INPUT_STARTING":"Algus…","SUGGESTED_ACTIONS_LABEL_ALT":"Soovitatavad tegevused","TEXT_INPUT_ALT":"S\xf5numi sisestuse v\xe4li","TEXT_INPUT_PLACEHOLDER":"Tippige oma s\xf5num","TEXT_INPUT_SEND_BUTTON_ALT":"Saada","TEXT_INPUT_SPEAK_BUTTON_ALT":"R\xe4\xe4gi","TEXT_INPUT_UPLOAD_BUTTON_ALT":"Laadi fail \xfcles","TOAST_ACCORDION_FEW":"$1 teatist: \xfcksikasjade kuvamiseks kl\xf5psake siin","TOAST_ACCORDION_MANY":"$1 teatist: \xfcksikasjade kuvamiseks kl\xf5psake siin","TOAST_ACCORDION_OTHER":"$1 teatist: \xfcksikasjade kuvamiseks kl\xf5psake siin","TOAST_ACCORDION_TWO":"$1 teatist: \xfcksikasjade kuvamiseks kl\xf5psake siin","TOAST_ALT_ERROR":"T\xf5rge","TOAST_ALT_INFO":"Teave","TOAST_ALT_SUCCESS":"Tehtud","TOAST_ALT_WARN":"Hoiatus","TOAST_DISMISS_BUTTON":"Sule","TOAST_TITLE_ALT":"Teatis","TRANSCRIPT_ARIA_LABEL_ALT":"Vestluse ajalugu, navigeerimiseks vajutage nooleklahvi.","TRANSCRIPT_ARIA_ROLE_ALT":"vestluse ajalugu","TRANSCRIPT_LIVE_REGION_INTERACTIVE_LABEL_ALT":"S\xf5num on interaktiivne. Vestluse ajaloo avamiseks vajutage 2–3 korda t\xf5stu- ja tabeldusklahvi. Seej\xe4rel kl\xf5psake suhtlemiseks s\xf5numit.","TRANSCRIPT_LIVE_REGION_INTERACTIVE_WITH_LINKS_LABEL_ALT":"S\xf5numis on v\xe4hemalt \xfcks link. Vestluse ajaloo avamiseks vajutage 2–3 korda t\xf5stu- ja tabeldusklahvi. Seej\xe4rel kl\xf5psake suhtlemiseks s\xf5numit.","TRANSCRIPT_LIVE_REGION_SUGGESTED_ACTIONS_LABEL_ALT":"S\xf5numil on soovitatavad tegevused. Nende valimiseks vajutage 2–3 korda klahvi Shift.","TRANSCRIPT_LIVE_REGION_SUGGESTED_ACTIONS_WITH_ACCESS_KEY_LABEL_ALT":"S\xf5numil on soovitatavad tegevused. Nende valimiseks vajutage $1.","TRANSCRIPT_LIVE_REGION_SEND_FAILED_ALT":"S\xf5numi saatmine nurjus.","TRANSCRIPT_MORE_MESSAGES":"Rohkem s\xf5numeid","TRANSCRIPT_NEW_MESSAGES":"Uued s\xf5numid","TRANSCRIPT_TERMINATOR_TEXT":"Vestluse ajaloo l\xf5pp","TYPING_INDICATOR_ALT":"Tippimise n\xe4idiku kuvamine","TYPING_INDICATOR_SINGLE_TEXT":"$1 kirjutab.","TYPING_INDICATOR_MULTIPLE_TEXT":"$1 ja teised kirjutavad."}');

});

parcelRequire.register("4TByh", function(module, exports) {
module.exports = JSON.parse('{"_comment":"[CI-LOCKED] Fitxategi honen edukia blokeatuta dago. Ekarpenak onartzen dira, baina baliteke aldaketen balidazioa atzeratzea.","ACCESS_KEY_ALT":"Alt + Maius + $1","ACCESS_KEY_FOR_MAC_ALT":"Ktrl + Aukera + $1","ACTIVITY_BOT_SAID_ALT":"$1 bot-ak hau esan du:","ACTIVITY_YOU_SAID_ALT":"Hau esan duzu:","ACTIVITY_BOT_ATTACHED_ALT":"Bot-ak hau erantsi du:","ACTIVITY_ERROR_BOX_TITLE":"Errore-mezua","ACTIVITY_INTERACTIVE_FOOTNOTE_ALT":"Sakatu hau interakzioa hasteko.","ACTIVITY_INTERACTIVE_REASON_INTERACTIVE_CONTENT_ALT":"Mezua interaktiboa da.","ACTIVITY_INTERACTIVE_REASON_LINK_ALT":"Esteka bat edo gehiago dago mezuan.","ACTIVITY_INTERACTIVE_REASON_SEND_FAILED_ALT":"Ezin izan da bidali.","ACTIVITY_YOU_ATTACHED_ALT":"Hau erantsi duzu:","ACTIVITY_NUM_ATTACHMENTS_ONE_ALT":"1 eranskin.","ACTIVITY_NUM_ATTACHMENTS_FEW_ALT":"$1 eranskin.","ACTIVITY_NUM_ATTACHMENTS_MANY_ALT":"$1 eranskin.","ACTIVITY_NUM_ATTACHMENTS_OTHER_ALT":"$1 eranskin.","ACTIVITY_NUM_ATTACHMENTS_TWO_ALT":"$1 eranskin.","ACTIVITY_STATUS_SEND_FAILED_RETRY":"Ezin izan da bidali. [Saiatu berriro][RETRY].","ACTIVITY_STATUS_SEND_STATUS_ALT_SENDING":"Bidaltzen","ACTIVITY_STATUS_SEND_STATUS_ALT_SENT_AT":"Bidaltze-ordua: $1","ACTIVITY_STATUS_TIMESTAMP_JUST_NOW":"Oraintxe bertan","ACTIVITY_STATUS_TIMESTAMP_ONE_HOUR_AGO":"Duela ordubete","ACTIVITY_STATUS_TIMESTAMP_ONE_MINUTE_AGO":"Duela minutu bat","ACTIVITY_STATUS_TIMESTAMP_TODAY":"Gaur","ACTIVITY_STATUS_TIMESTAMP_YESTERDAY":"Atzo","ADAPTIVE_CARD_ERROR_BOX_TITLE_PARSE":"Txartel moldagarriaren analisi-errorea","ADAPTIVE_CARD_ERROR_BOX_TITLE_RENDER":"Txartel moldagarriaren errendatze-errorea","ATTACHMENT_AUDIO":"Audio zati bat.","ATTACHMENT_CARD":"Txartel bat: $1 $2 $3","ATTACHMENT_FILE":"Fitxategi bat: $1","ATTACHMENT_IMAGE":"Irudi bat","ATTACHMENT_TEXT":"Testu bat: $1","ATTACHMENT_VIDEO":"Bideo zati bat","CAROUSEL_FLIPPER_LEFT_ALT":"Ezkerra","CAROUSEL_FLIPPER_RIGHT_ALT":"Eskuina","CONNECTIVITY_STATUS_ALT_CONNECTED":"Konektatu da","CONNECTIVITY_STATUS_ALT_CONNECTING":"Konektatzen…","CONNECTIVITY_STATUS_ALT_FATAL":"Ezin da konektatu.","CONNECTIVITY_STATUS_ALT_RECONNECTING":"Sareko konexioa eten egin da. Berriro konektatzen…","CONNECTIVITY_STATUS_ALT_RENDER_ERROR":"Errendatze-errorea. Egiaztatu kontsola edo jarri harremanetan botaren garatzailearekin.","CONNECTIVITY_STATUS_ALT_SLOW_CONNECTION":"Ohi baino denbora gehiago behar izaten ari gara konektatzeko.","CONNECTIVITY_STATUS_ALT":"Konexioaren egoera: $1","FILE_CONTENT_ALT":"\\"$1\\"","FILE_CONTENT_DOWNLOADABLE_ALT":"Deskargatu \\"$1\\" fitxategia","FILE_CONTENT_DOWNLOADABLE_WITH_SIZE_ALT":"Deskargatu \\"$1\\" fitxategia (tamaina: $2)","FILE_CONTENT_WITH_SIZE_ALT":"\\"$1\\" (tamaina: $2)","KEYBOARD_HELP_CHAT_HISTORY_ACCESS_ITEMS_IN_MESSAGE_BODY":"\\"Sartu\\" tekla","KEYBOARD_HELP_CHAT_HISTORY_ACCESS_ITEMS_IN_MESSAGE_HEADER":"Atzitu mezuko elementuak","KEYBOARD_HELP_CHAT_HISTORY_HEADER":"Berriketa-historia","KEYBOARD_HELP_CHAT_HISTORY_LEAVE_MESSAGE_BODY":"Ihes tekla","KEYBOARD_HELP_CHAT_HISTORY_LEAVE_MESSAGE_HEADER":"Irten mezutik","KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_ITEMS_BODY":"Tabulazio-tekla\\nMaius + tabulazio-tekla","KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_ITEMS_HEADER":"Mugitu mezu bateko elementuen artean","KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_MESSAGES_BODY":"Gora gezia\\nBehera gezia","KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_MESSAGES_HEADER":"Mugitu mezuen artean","KEYBOARD_HELP_CHAT_WINDOW_BODY_DO_ACTION_BODY":"\\"Sartu\\" tekla","KEYBOARD_HELP_CHAT_WINDOW_BODY_DO_ACTION_HEADER":"Egin ekintza","KEYBOARD_HELP_CHAT_WINDOW_BODY_MOVE_BETWEEN_ITEMS_BODY":"Tabulazio-tekla\\nMaius + tabulazio-tekla","KEYBOARD_HELP_CHAT_WINDOW_BODY_MOVE_BETWEEN_ITEMS_HEADER":"Mugitu berriketa-leihoko elementuen artean","KEYBOARD_HELP_CHAT_WINDOW_HEADER":"Berriketaren leihoa","KEYBOARD_HELP_CLOSE_BUTTON_ALT":"Itxi","KEYBOARD_HELP_HEADER":"Teklatuaren kontrolak","MARKDOWN_EXTERNAL_LINK_ALT":"Beste leiho batean irekitzen da; kanpokoa.","RECEIPT_CARD_TAX":"Zerga","RECEIPT_CARD_TOTAL":"Guztira","RECEIPT_CARD_VAT":"BEZ","SEND_BOX_IS_EMPTY_TOOLTIP_ALT":"Ezin da mezu hutsik bidali.","SPEECH_INPUT_LISTENING":"Entzuten…","SPEECH_INPUT_MICROPHONE_BUTTON_CLOSE_ALT":"Mikrofonoa desaktibatuta dago","SPEECH_INPUT_MICROPHONE_BUTTON_OPEN_ALT":"Mikrofonoa aktibatuta dago","SPEECH_INPUT_STARTING":"Hasten…","SUGGESTED_ACTIONS_LABEL_ALT":"Iradokitako ekintzak","TEXT_INPUT_ALT":"Mezua idazteko koadroa","TEXT_INPUT_PLACEHOLDER":"Idatzi mezua","TEXT_INPUT_SEND_BUTTON_ALT":"Bidali","TEXT_INPUT_SPEAK_BUTTON_ALT":"Hitz egin","TEXT_INPUT_UPLOAD_BUTTON_ALT":"Kargatu fitxategia","TOAST_ACCORDION_FEW":"$1 jakinarazpen. Egin klik hemen xehetasunak ikusteko","TOAST_ACCORDION_MANY":"$1 jakinarazpen. Egin klik hemen xehetasunak ikusteko","TOAST_ACCORDION_OTHER":"$1 jakinarazpen. Egin klik hemen xehetasunak ikusteko","TOAST_ACCORDION_TWO":"$1 jakinarazpen. Egin klik hemen xehetasunak ikusteko","TOAST_ALT_ERROR":"Errorea","TOAST_ALT_INFO":"Informazioa","TOAST_ALT_SUCCESS":"Gauzatu da","TOAST_ALT_WARN":"Abisua","TOAST_DISMISS_BUTTON":"Baztertu","TOAST_TITLE_ALT":"Jakinarazpena","TRANSCRIPT_ARIA_LABEL_ALT":"Berriketa-historia. Nabigatzeko, erabili Gora eta Behera geziak.","TRANSCRIPT_ARIA_ROLE_ALT":"berriketa-historia","TRANSCRIPT_LIVE_REGION_INTERACTIVE_LABEL_ALT":"Mezua interaktiboa da. Sakatu Maius + tabulazio-tekla 2 edo 3 aldiz berriketa-historiara aldatzeko. Ondoren, sakatu mezua harekin elkarrekintzan jarduteko.","TRANSCRIPT_LIVE_REGION_INTERACTIVE_WITH_LINKS_LABEL_ALT":"Esteka bat edo gehiago daude mezuan. Sakatu Maius + tabulazio-tekla 2 edo 3 aldiz berriketa-historiara aldatzeko. Ondoren, sakatu mezua harekin elkarrekintzan jarduteko.","TRANSCRIPT_LIVE_REGION_SUGGESTED_ACTIONS_LABEL_ALT":"Mezuarekin lotutako ekintza iradokiak daude. Haiek hautatzeko, sakatu Maius fitxa 2 edo 3 aldiz.","TRANSCRIPT_LIVE_REGION_SUGGESTED_ACTIONS_WITH_ACCESS_KEY_LABEL_ALT":"Mezuarekin lotutako ekintza iradokiak daude. Haiek hautatzeko, sakatu $1.","TRANSCRIPT_LIVE_REGION_SEND_FAILED_ALT":"Ezin izan da bidali mezua.","TRANSCRIPT_MORE_MESSAGES":"Mezu gehiago","TRANSCRIPT_NEW_MESSAGES":"Mezu berriak","TRANSCRIPT_TERMINATOR_TEXT":"Berriketa-historiaren amaiera","TYPING_INDICATOR_ALT":"Idazketa-adierazlea ikusgai dago","TYPING_INDICATOR_SINGLE_TEXT":"$1 idazten ari da.","TYPING_INDICATOR_MULTIPLE_TEXT":"$1 eta beste batzuk idazten ari dira."}');

});

parcelRequire.register("cbhcs", function(module, exports) {
module.exports = JSON.parse('{"_comment":"[CI-LOCKED] T\xe4m\xe4n tiedoston sis\xe4lt\xf6 on lukittu. Osallistuminen on tervetullutta, mutta muutosten tarkistamisessa saattaa olla viivett\xe4.","ACCESS_KEY_ALT":"Alt + Vaihto + $1","ACCESS_KEY_FOR_MAC_ALT":"Control + Option + $1","ACTIVITY_BOT_SAID_ALT":"Botti $1 sanoi:","ACTIVITY_YOU_SAID_ALT":"Sanoit:","ACTIVITY_BOT_ATTACHED_ALT":"Botti lis\xe4si liitteen:","ACTIVITY_ERROR_BOX_TITLE":"Virhesanoma","ACTIVITY_INTERACTIVE_FOOTNOTE_ALT":"Siirry vuorovaikutukseen napsauttamalla.","ACTIVITY_INTERACTIVE_REASON_INTERACTIVE_CONTENT_ALT":"Viesti on vuorovaikutteinen.","ACTIVITY_INTERACTIVE_REASON_LINK_ALT":"Viestiss\xe4 on v\xe4hint\xe4\xe4n yksi linkki.","ACTIVITY_INTERACTIVE_REASON_SEND_FAILED_ALT":"L\xe4hetys ep\xe4onnistui.","ACTIVITY_YOU_ATTACHED_ALT":"Lis\xe4sit liitteen:","ACTIVITY_NUM_ATTACHMENTS_ONE_ALT":"1 liite.","ACTIVITY_NUM_ATTACHMENTS_FEW_ALT":"$1 liitett\xe4.","ACTIVITY_NUM_ATTACHMENTS_MANY_ALT":"$1 liitett\xe4.","ACTIVITY_NUM_ATTACHMENTS_OTHER_ALT":"$1 liitett\xe4.","ACTIVITY_NUM_ATTACHMENTS_TWO_ALT":"$1 liitett\xe4.","ACTIVITY_STATUS_SEND_FAILED_RETRY":"L\xe4hetys ep\xe4onnistui. [Yrit\xe4 uudelleen][RETRY].","ACTIVITY_STATUS_SEND_STATUS_ALT_SENDING":"L\xe4hetet\xe4\xe4n","ACTIVITY_STATUS_SEND_STATUS_ALT_SENT_AT":"L\xe4hetetty $1","ACTIVITY_STATUS_TIMESTAMP_JUST_NOW":"Juuri nyt","ACTIVITY_STATUS_TIMESTAMP_ONE_HOUR_AGO":"Tunti sitten","ACTIVITY_STATUS_TIMESTAMP_ONE_MINUTE_AGO":"Minuutti sitten","ACTIVITY_STATUS_TIMESTAMP_TODAY":"T\xe4n\xe4\xe4n","ACTIVITY_STATUS_TIMESTAMP_YESTERDAY":"Eilen","ADAPTIVE_CARD_ERROR_BOX_TITLE_PARSE":"Mukautuvan kortin j\xe4sennysvirhe","ADAPTIVE_CARD_ERROR_BOX_TITLE_RENDER":"Mukautuvan kortin muodostusvirhe","ATTACHMENT_AUDIO":"\xc4\xe4nileike.","ATTACHMENT_CARD":"Kortti: $1 $2 $3","ATTACHMENT_FILE":"Tiedosto: $1","ATTACHMENT_IMAGE":"Kuva","ATTACHMENT_TEXT":"Teksti: $1","ATTACHMENT_VIDEO":"Videoleike","CAROUSEL_FLIPPER_LEFT_ALT":"Vasen","CAROUSEL_FLIPPER_RIGHT_ALT":"Oikea","CONNECTIVITY_STATUS_ALT_CONNECTED":"Yhdistetty","CONNECTIVITY_STATUS_ALT_CONNECTING":"Muodostetaan yhteytt\xe4…","CONNECTIVITY_STATUS_ALT_FATAL":"Yhdist\xe4minen ei onnistu.","CONNECTIVITY_STATUS_ALT_RECONNECTING":"Verkkoyhteys keskeytyi. Yhdistet\xe4\xe4n uudelleen…","CONNECTIVITY_STATUS_ALT_RENDER_ERROR":"Muodostusvirhe. Tarkista konsoli tai ota yhteytt\xe4 botin kehitt\xe4j\xe4\xe4n.","CONNECTIVITY_STATUS_ALT_SLOW_CONNECTION":"Yhteyden muodostaminen kest\xe4\xe4 tavallista kauemmin.","CONNECTIVITY_STATUS_ALT":"Yhteyden tila: $1","FILE_CONTENT_ALT":"$1","FILE_CONTENT_DOWNLOADABLE_ALT":"Lataa tiedosto $1","FILE_CONTENT_DOWNLOADABLE_WITH_SIZE_ALT":"Lataa tiedosto $1 (koko $2)","FILE_CONTENT_WITH_SIZE_ALT":"$1 (koko $2)","KEYBOARD_HELP_CHAT_HISTORY_ACCESS_ITEMS_IN_MESSAGE_BODY":"Enter-n\xe4pp\xe4in","KEYBOARD_HELP_CHAT_HISTORY_ACCESS_ITEMS_IN_MESSAGE_HEADER":"Viestin kohteiden k\xe4ytt\xf6","KEYBOARD_HELP_CHAT_HISTORY_HEADER":"Keskusteluhistoria","KEYBOARD_HELP_CHAT_HISTORY_LEAVE_MESSAGE_BODY":"Esc-n\xe4pp\xe4in","KEYBOARD_HELP_CHAT_HISTORY_LEAVE_MESSAGE_HEADER":"Poistu viestist\xe4","KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_ITEMS_BODY":"Sarkainn\xe4pp\xe4in\\nVaihto + sarkainn\xe4pp\xe4in","KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_ITEMS_HEADER":"Siirry viestin kohteiden v\xe4lill\xe4","KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_MESSAGES_BODY":"Yl\xe4nuolin\xe4pp\xe4in\\nAlanuolin\xe4pp\xe4in","KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_MESSAGES_HEADER":"Siirry viestien v\xe4lill\xe4","KEYBOARD_HELP_CHAT_WINDOW_BODY_DO_ACTION_BODY":"Enter-n\xe4pp\xe4in","KEYBOARD_HELP_CHAT_WINDOW_BODY_DO_ACTION_HEADER":"Suorita toiminto","KEYBOARD_HELP_CHAT_WINDOW_BODY_MOVE_BETWEEN_ITEMS_BODY":"Sarkainn\xe4pp\xe4in\\nVaihto + sarkainn\xe4pp\xe4in","KEYBOARD_HELP_CHAT_WINDOW_BODY_MOVE_BETWEEN_ITEMS_HEADER":"Siirry keskusteluikkunan kohteiden v\xe4lill\xe4","KEYBOARD_HELP_CHAT_WINDOW_HEADER":"Keskusteluikkuna","KEYBOARD_HELP_CLOSE_BUTTON_ALT":"Sulje","KEYBOARD_HELP_HEADER":"N\xe4pp\xe4imist\xf6komennot","MARKDOWN_EXTERNAL_LINK_ALT":"Avautuu uudessa ikkunassa; ulkoinen.","RECEIPT_CARD_TAX":"Vero","RECEIPT_CARD_TOTAL":"Yhteens\xe4","RECEIPT_CARD_VAT":"ALV","SEND_BOX_IS_EMPTY_TOOLTIP_ALT":"Tyhj\xe4\xe4 viesti\xe4 ei voi l\xe4hett\xe4\xe4.","SPEECH_INPUT_LISTENING":"Kuunnellaan…","SPEECH_INPUT_MICROPHONE_BUTTON_CLOSE_ALT":"Mikrofoni pois p\xe4\xe4lt\xe4","SPEECH_INPUT_MICROPHONE_BUTTON_OPEN_ALT":"Mikrofoni p\xe4\xe4ll\xe4","SPEECH_INPUT_STARTING":"Aloitetaan…","SUGGESTED_ACTIONS_LABEL_ALT":"Ehdotetut toiminnot","TEXT_INPUT_ALT":"Viestin sy\xf6tt\xf6ruutu","TEXT_INPUT_PLACEHOLDER":"Kirjoita viestisi","TEXT_INPUT_SEND_BUTTON_ALT":"L\xe4het\xe4","TEXT_INPUT_SPEAK_BUTTON_ALT":"Puhu","TEXT_INPUT_UPLOAD_BUTTON_ALT":"Lataa tiedosto palvelimeen","TOAST_ACCORDION_FEW":"$1 ilmoitusta: Katso lis\xe4tietoja napsauttamalla t\xe4st\xe4","TOAST_ACCORDION_MANY":"$1 ilmoitusta: Katso lis\xe4tietoja napsauttamalla t\xe4st\xe4","TOAST_ACCORDION_OTHER":"$1 ilmoitusta: Katso lis\xe4tietoja napsauttamalla t\xe4st\xe4","TOAST_ACCORDION_TWO":"$1 ilmoitusta: Katso lis\xe4tietoja napsauttamalla t\xe4st\xe4","TOAST_ALT_ERROR":"Virhe","TOAST_ALT_INFO":"Tiedot","TOAST_ALT_SUCCESS":"Onnistui","TOAST_ALT_WARN":"Varoitus","TOAST_DISMISS_BUTTON":"Hylk\xe4\xe4","TOAST_TITLE_ALT":"Ilmoitus","TRANSCRIPT_ARIA_LABEL_ALT":"Keskusteluhistoria, siirry nuolin\xe4pp\xe4imill\xe4.","TRANSCRIPT_ARIA_ROLE_ALT":"keskusteluhistoria","TRANSCRIPT_LIVE_REGION_INTERACTIVE_LABEL_ALT":"Viesti on vuorovaikutteinen. Siirry keskusteluhistoriaan painamalla vaihto- ja sarkainn\xe4pp\xe4imi\xe4 2–3 kertaa. Aloita sitten vuorovaikutus napsauttamalla viesti\xe4.","TRANSCRIPT_LIVE_REGION_INTERACTIVE_WITH_LINKS_LABEL_ALT":"Viestiss\xe4 on v\xe4hint\xe4\xe4n yksi linkki. Siirry keskusteluhistoriaan painamalla vaihto- ja sarkainn\xe4pp\xe4imi\xe4 2–3 kertaa. Aloita sitten vuorovaikutus napsauttamalla viesti\xe4.","TRANSCRIPT_LIVE_REGION_SUGGESTED_ACTIONS_LABEL_ALT":"Viestiss\xe4 on ehdotettuja toimintoja. Valitse ne painamalla vaihto + sarkain 2–3 kertaa.","TRANSCRIPT_LIVE_REGION_SUGGESTED_ACTIONS_WITH_ACCESS_KEY_LABEL_ALT":"Viestiss\xe4 on ehdotettuja toimintoja. Valitse ne painamalla $1.","TRANSCRIPT_LIVE_REGION_SEND_FAILED_ALT":"Viestin l\xe4hett\xe4minen ep\xe4onnistui.","TRANSCRIPT_MORE_MESSAGES":"Lis\xe4\xe4 viestej\xe4","TRANSCRIPT_NEW_MESSAGES":"Uudet viestit","TRANSCRIPT_TERMINATOR_TEXT":"Keskusteluhistorian loppu","TYPING_INDICATOR_ALT":"N\xe4ytet\xe4\xe4n kirjoittamisen ilmaisin","TYPING_INDICATOR_SINGLE_TEXT":"$1 kirjoittaa.","TYPING_INDICATOR_MULTIPLE_TEXT":"$1 ja muut kirjoittavat."}');

});

parcelRequire.register("5Qphx", function(module, exports) {
module.exports = JSON.parse('{"_comment":"[CI-LOCKED] Le contenu de ce fichier est verrouill\xe9. Les contributions sont les bienvenues, mais la validation des modifications peut \xeatre retard\xe9e.","ACCESS_KEY_ALT":"Alt + Maj + $1","ACCESS_KEY_FOR_MAC_ALT":"Contr\xf4le + Option + $1","ACTIVITY_BOT_SAID_ALT":"Le bot $1 a dit\xa0:","ACTIVITY_YOU_SAID_ALT":"Vous avez dit\xa0:","ACTIVITY_BOT_ATTACHED_ALT":"Bot joint\xa0:","ACTIVITY_ERROR_BOX_TITLE":"Message d\'erreur","ACTIVITY_INTERACTIVE_FOOTNOTE_ALT":"Cliquez pour interagir.","ACTIVITY_INTERACTIVE_REASON_INTERACTIVE_CONTENT_ALT":"Le message est interactif.","ACTIVITY_INTERACTIVE_REASON_LINK_ALT":"Un ou plusieurs liens dans le message.","ACTIVITY_INTERACTIVE_REASON_SEND_FAILED_ALT":"\xc9chec de l’envoi.","ACTIVITY_YOU_ATTACHED_ALT":"Vous avez joint\xa0:","ACTIVITY_NUM_ATTACHMENTS_ONE_ALT":"1\xa0pi\xe8ce jointe.","ACTIVITY_NUM_ATTACHMENTS_FEW_ALT":"$1\xa0pi\xe8ces jointes.","ACTIVITY_NUM_ATTACHMENTS_MANY_ALT":"$1\xa0pi\xe8ces jointes.","ACTIVITY_NUM_ATTACHMENTS_OTHER_ALT":"$1\xa0pi\xe8ces jointes.","ACTIVITY_NUM_ATTACHMENTS_TWO_ALT":"$1\xa0pi\xe8ces jointes.","ACTIVITY_STATUS_SEND_FAILED_RETRY":"\xc9chec de l\'envoi. [R\xe9essayez][RETRY].","ACTIVITY_STATUS_SEND_STATUS_ALT_SENDING":"Envoi en cours","ACTIVITY_STATUS_SEND_STATUS_ALT_SENT_AT":"Envoy\xe9 \xe0 $1","ACTIVITY_STATUS_TIMESTAMP_JUST_NOW":"\xc0 l\'instant","ACTIVITY_STATUS_TIMESTAMP_ONE_HOUR_AGO":"Il y a une heure","ACTIVITY_STATUS_TIMESTAMP_ONE_MINUTE_AGO":"Il y a une minute","ACTIVITY_STATUS_TIMESTAMP_TODAY":"Aujourd\'hui","ACTIVITY_STATUS_TIMESTAMP_YESTERDAY":"Hier","ADAPTIVE_CARD_ERROR_BOX_TITLE_PARSE":"Erreur d\'analyse de la carte adaptative","ADAPTIVE_CARD_ERROR_BOX_TITLE_RENDER":"Erreur d\'affichage de la carte adaptative","ATTACHMENT_AUDIO":"Un clip audio.","ATTACHMENT_CARD":"Une carte\xa0: $1 $2 $3","ATTACHMENT_FILE":"Un fichier\xa0: $1","ATTACHMENT_IMAGE":"Une image","ATTACHMENT_TEXT":"Un texte\xa0: $1","ATTACHMENT_VIDEO":"Un clip vid\xe9o","CAROUSEL_FLIPPER_LEFT_ALT":"Gauche","CAROUSEL_FLIPPER_RIGHT_ALT":"Droit","CONNECTIVITY_STATUS_ALT_CONNECTED":"Connect\xe9","CONNECTIVITY_STATUS_ALT_CONNECTING":"Connexion en cours...","CONNECTIVITY_STATUS_ALT_FATAL":"Impossible de se connecter.","CONNECTIVITY_STATUS_ALT_RECONNECTING":"Une interruption du r\xe9seau s\'est produite. Reconnexion en cours...","CONNECTIVITY_STATUS_ALT_RENDER_ERROR":"Erreur de rendu. V\xe9rifiez la console ou contactez le d\xe9veloppeur du bot.","CONNECTIVITY_STATUS_ALT_SLOW_CONNECTION":"La connexion prend plus de temps que d\'habitude.","CONNECTIVITY_STATUS_ALT":"Statut de la connectivit\xe9\xa0: $1","FILE_CONTENT_ALT":"\'$1\'","FILE_CONTENT_DOWNLOADABLE_ALT":"T\xe9l\xe9charger le fichier \'$1\'","FILE_CONTENT_DOWNLOADABLE_WITH_SIZE_ALT":"T\xe9l\xe9charger le fichier \'$1\' de taille $2","FILE_CONTENT_WITH_SIZE_ALT":"\'$1\' de taille $2","KEYBOARD_HELP_CHAT_HISTORY_ACCESS_ITEMS_IN_MESSAGE_BODY":"Touche Entr\xe9e","KEYBOARD_HELP_CHAT_HISTORY_ACCESS_ITEMS_IN_MESSAGE_HEADER":"Acc\xe9der aux \xe9l\xe9ments du message","KEYBOARD_HELP_CHAT_HISTORY_HEADER":"Historique des conversations instantan\xe9es","KEYBOARD_HELP_CHAT_HISTORY_LEAVE_MESSAGE_BODY":"Touche \xc9chap","KEYBOARD_HELP_CHAT_HISTORY_LEAVE_MESSAGE_HEADER":"Message de sortie","KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_ITEMS_BODY":"Touche Tab\\nTouche Maj + Tab","KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_ITEMS_HEADER":"Se d\xe9placer entre les \xe9l\xe9ments d’un message","KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_MESSAGES_BODY":"Touche Fl\xe8che haut\\nTouche Fl\xe8che bas","KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_MESSAGES_HEADER":"Se d\xe9placer entre les messages","KEYBOARD_HELP_CHAT_WINDOW_BODY_DO_ACTION_BODY":"Touche Entr\xe9e","KEYBOARD_HELP_CHAT_WINDOW_BODY_DO_ACTION_HEADER":"Effectuer une action","KEYBOARD_HELP_CHAT_WINDOW_BODY_MOVE_BETWEEN_ITEMS_BODY":"Touche Tab\\nTouche Maj + Tab","KEYBOARD_HELP_CHAT_WINDOW_BODY_MOVE_BETWEEN_ITEMS_HEADER":"Se d\xe9placer entre les \xe9l\xe9ments de la fen\xeatre de conversation instantan\xe9e","KEYBOARD_HELP_CHAT_WINDOW_HEADER":"Fen\xeatre de conversation instantan\xe9e","KEYBOARD_HELP_CLOSE_BUTTON_ALT":"Fermer","KEYBOARD_HELP_HEADER":"Contr\xf4les du clavier","MARKDOWN_EXTERNAL_LINK_ALT":"S’ouvre dans une nouvelle fen\xeatre\xa0; externe.","RECEIPT_CARD_TAX":"Taxe","RECEIPT_CARD_TOTAL":"Total","RECEIPT_CARD_VAT":"TVA","SEND_BOX_IS_EMPTY_TOOLTIP_ALT":"Impossible d’envoyer un message vide.","SPEECH_INPUT_LISTENING":"\xc9coute en cours...","SPEECH_INPUT_MICROPHONE_BUTTON_CLOSE_ALT":"Microphone d\xe9sactiv\xe9","SPEECH_INPUT_MICROPHONE_BUTTON_OPEN_ALT":"Microphone activ\xe9","SPEECH_INPUT_STARTING":"D\xe9marrage en cours...","SUGGESTED_ACTIONS_LABEL_ALT":"Actions sugg\xe9r\xe9es","TEXT_INPUT_ALT":"Zone de saisie du message","TEXT_INPUT_PLACEHOLDER":"Tapez votre message","TEXT_INPUT_SEND_BUTTON_ALT":"Envoyer","TEXT_INPUT_SPEAK_BUTTON_ALT":"Parler","TEXT_INPUT_UPLOAD_BUTTON_ALT":"Charger le fichier","TOAST_ACCORDION_FEW":"$1 Notifications\xa0: cliquez ici pour afficher les d\xe9tails","TOAST_ACCORDION_MANY":"$1 Notifications\xa0: cliquez ici pour afficher les d\xe9tails","TOAST_ACCORDION_OTHER":"$1 Notifications\xa0: cliquez ici pour afficher les d\xe9tails","TOAST_ACCORDION_TWO":"$1 Notifications\xa0: cliquez ici pour afficher les d\xe9tails","TOAST_ALT_ERROR":"Erreur","TOAST_ALT_INFO":"Informations","TOAST_ALT_SUCCESS":"R\xe9ussite","TOAST_ALT_WARN":"Avertissement","TOAST_DISMISS_BUTTON":"Ignorer","TOAST_TITLE_ALT":"Notification","TRANSCRIPT_ARIA_LABEL_ALT":"Historique des conversations instantan\xe9es, appuyez sur les touches de direction pour naviguer.","TRANSCRIPT_ARIA_ROLE_ALT":"historique des conversations instantan\xe9es","TRANSCRIPT_LIVE_REGION_INTERACTIVE_LABEL_ALT":"Le message est interactif. Appuyez sur la touche Maj + Tab 2 \xe0 3\xa0fois pour passer \xe0 l’historique des conversations instantan\xe9es. Ensuite, cliquez sur le message pour interagir.","TRANSCRIPT_LIVE_REGION_INTERACTIVE_WITH_LINKS_LABEL_ALT":"Un ou plusieurs liens dans le message. Appuyez sur la touche Maj + Tab 2 \xe0 3\xa0fois pour passer \xe0 l’historique des conversations instantan\xe9es. Ensuite, cliquez sur le message pour interagir.","TRANSCRIPT_LIVE_REGION_SUGGESTED_ACTIONS_LABEL_ALT":"Le message a des actions sugg\xe9r\xe9es. Appuyez sur Maj + Tab 2 \xe0 3\xa0fois pour les s\xe9lectionner.","TRANSCRIPT_LIVE_REGION_SUGGESTED_ACTIONS_WITH_ACCESS_KEY_LABEL_ALT":"Le message a des actions sugg\xe9r\xe9es. Appuyez sur $1 pour les s\xe9lectionner.","TRANSCRIPT_LIVE_REGION_SEND_FAILED_ALT":"Impossible d’envoyer le message.","TRANSCRIPT_MORE_MESSAGES":"Plus de messages","TRANSCRIPT_NEW_MESSAGES":"Nouveaux messages","TRANSCRIPT_TERMINATOR_TEXT":"Fin de l’historique des conversations instantan\xe9es","TYPING_INDICATOR_ALT":"Affichage de l\'indicateur de saisie","TYPING_INDICATOR_SINGLE_TEXT":"$1 effectue une saisie.","TYPING_INDICATOR_MULTIPLE_TEXT":"$1 et d’autres effectuent une saisie."}');

});

parcelRequire.register("lb8Vn", function(module, exports) {
module.exports = JSON.parse('{"_comment":"[CI-LOCKED] O contido deste ficheiro est\xe1 bloqueado. As contribuci\xf3ns son benvidas, pero a validaci\xf3n da modificaci\xf3n pode demorarse.","ACCESS_KEY_ALT":"ALT MAI\xdaS $1","ACCESS_KEY_FOR_MAC_ALT":"Control Opci\xf3n $1","ACTIVITY_BOT_SAID_ALT":"O bot $1 dixo:","ACTIVITY_YOU_SAID_ALT":"Dixo:","ACTIVITY_BOT_ATTACHED_ALT":"Anexado ao bot:","ACTIVITY_ERROR_BOX_TITLE":"Mensaxe de erro","ACTIVITY_INTERACTIVE_FOOTNOTE_ALT":"Prema para interactuar.","ACTIVITY_INTERACTIVE_REASON_INTERACTIVE_CONTENT_ALT":"A mensaxe \xe9 interactiva.","ACTIVITY_INTERACTIVE_REASON_LINK_ALT":"Unha ou varias ligaz\xf3ns na mensaxe.","ACTIVITY_INTERACTIVE_REASON_SEND_FAILED_ALT":"Erro ao enviar.","ACTIVITY_YOU_ATTACHED_ALT":"Anexou:","ACTIVITY_NUM_ATTACHMENTS_ONE_ALT":"Un anexo.","ACTIVITY_NUM_ATTACHMENTS_FEW_ALT":"$1 anexos.","ACTIVITY_NUM_ATTACHMENTS_MANY_ALT":"$1 anexos.","ACTIVITY_NUM_ATTACHMENTS_OTHER_ALT":"$1 anexos.","ACTIVITY_NUM_ATTACHMENTS_TWO_ALT":"$1 anexos.","ACTIVITY_STATUS_SEND_FAILED_RETRY":"Erro no env\xedo. [Tentar de novo][RETRY].","ACTIVITY_STATUS_SEND_STATUS_ALT_SENDING":"Enviando","ACTIVITY_STATUS_SEND_STATUS_ALT_SENT_AT":"Enviada \xe1s $1","ACTIVITY_STATUS_TIMESTAMP_JUST_NOW":"Agora mesmo","ACTIVITY_STATUS_TIMESTAMP_ONE_HOUR_AGO":"Hai unha hora","ACTIVITY_STATUS_TIMESTAMP_ONE_MINUTE_AGO":"Hai un minuto","ACTIVITY_STATUS_TIMESTAMP_TODAY":"Hoxe","ACTIVITY_STATUS_TIMESTAMP_YESTERDAY":"Onte","ADAPTIVE_CARD_ERROR_BOX_TITLE_PARSE":"Erro de an\xe1lise do cart\xf3n adaptable","ADAPTIVE_CARD_ERROR_BOX_TITLE_RENDER":"Erro de procesamento do cart\xf3n adaptable","ATTACHMENT_AUDIO":"Un clip de audio.","ATTACHMENT_CARD":"Un cart\xf3n: $1 $2 $3","ATTACHMENT_FILE":"Un ficheiro: $1","ATTACHMENT_IMAGE":"Unha imaxe","ATTACHMENT_TEXT":"Un texto: $1","ATTACHMENT_VIDEO":"Un clip de v\xeddeo","CAROUSEL_FLIPPER_LEFT_ALT":"Esquerda","CAROUSEL_FLIPPER_RIGHT_ALT":"Dereita","CONNECTIVITY_STATUS_ALT_CONNECTED":"Conectado","CONNECTIVITY_STATUS_ALT_CONNECTING":"Conectando…","CONNECTIVITY_STATUS_ALT_FATAL":"Non \xe9 posible conectarse.","CONNECTIVITY_STATUS_ALT_RECONNECTING":"Produciuse unha interrupci\xf3n da rede. Conectando de novo…","CONNECTIVITY_STATUS_ALT_RENDER_ERROR":"Erro de procesamento. Comprobe a consola ou p\xf3\xf1ase en contacto co programador do bot.","CONNECTIVITY_STATUS_ALT_SLOW_CONNECTION":"A conexi\xf3n est\xe1 a tardar m\xe1is do normal.","CONNECTIVITY_STATUS_ALT":"Estado da conectividade: $1","FILE_CONTENT_ALT":"\\"$1\\"","FILE_CONTENT_DOWNLOADABLE_ALT":"Descargar o ficheiro \\"$1\\"","FILE_CONTENT_DOWNLOADABLE_WITH_SIZE_ALT":"Descargar o ficheiro \\"$1\\" cun tama\xf1o de $2","FILE_CONTENT_WITH_SIZE_ALT":"\\"$1\\" cun tama\xf1o de $2","KEYBOARD_HELP_CHAT_HISTORY_ACCESS_ITEMS_IN_MESSAGE_BODY":"Tecla INTRO","KEYBOARD_HELP_CHAT_HISTORY_ACCESS_ITEMS_IN_MESSAGE_HEADER":"Acceder aos elementos da mensaxe","KEYBOARD_HELP_CHAT_HISTORY_HEADER":"Historial de chat","KEYBOARD_HELP_CHAT_HISTORY_LEAVE_MESSAGE_BODY":"Tecla Escape","KEYBOARD_HELP_CHAT_HISTORY_LEAVE_MESSAGE_HEADER":"Sa\xedr da mensaxe","KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_ITEMS_BODY":"Tecla TAB\\nTeclas MAI\xdaS + TAB","KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_ITEMS_HEADER":"Moverse entre os elementos dunha mensaxe","KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_MESSAGES_BODY":"Tecla Frecha cara a arriba\\nTecla Frecha cara a abaixo","KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_MESSAGES_HEADER":"Moverse entre as mensaxes","KEYBOARD_HELP_CHAT_WINDOW_BODY_DO_ACTION_BODY":"Tecla INTRO","KEYBOARD_HELP_CHAT_WINDOW_BODY_DO_ACTION_HEADER":"Realizar acci\xf3n","KEYBOARD_HELP_CHAT_WINDOW_BODY_MOVE_BETWEEN_ITEMS_BODY":"Tecla TAB\\nTeclas MAI\xdaS + TAB","KEYBOARD_HELP_CHAT_WINDOW_BODY_MOVE_BETWEEN_ITEMS_HEADER":"Moverse entre os elementos da vent\xe1 de chat","KEYBOARD_HELP_CHAT_WINDOW_HEADER":"Vent\xe1 de chat","KEYBOARD_HELP_CLOSE_BUTTON_ALT":"Pechar","KEYBOARD_HELP_HEADER":"Controis de teclado","MARKDOWN_EXTERNAL_LINK_ALT":"\xc1brese nunha vent\xe1 nova; externa.","RECEIPT_CARD_TAX":"Imposto","RECEIPT_CARD_TOTAL":"Total","RECEIPT_CARD_VAT":"IVE","SEND_BOX_IS_EMPTY_TOOLTIP_ALT":"Non se pode enviar unha mensaxe baleira.","SPEECH_INPUT_LISTENING":"Escoitando…","SPEECH_INPUT_MICROPHONE_BUTTON_CLOSE_ALT":"Apagar Micr\xf3fono","SPEECH_INPUT_MICROPHONE_BUTTON_OPEN_ALT":"Acender micr\xf3fono","SPEECH_INPUT_STARTING":"Iniciando…","SUGGESTED_ACTIONS_LABEL_ALT":"Acci\xf3ns suxeridas","TEXT_INPUT_ALT":"Caixa de entrada de mensaxes","TEXT_INPUT_PLACEHOLDER":"Escriba a mensaxe","TEXT_INPUT_SEND_BUTTON_ALT":"Enviar","TEXT_INPUT_SPEAK_BUTTON_ALT":"Falar","TEXT_INPUT_UPLOAD_BUTTON_ALT":"Cargar ficheiro","TOAST_ACCORDION_FEW":"$1 notificaci\xf3ns: prema aqu\xed para ver os detalles","TOAST_ACCORDION_MANY":"$1 notificaci\xf3ns: prema aqu\xed para ver os detalles","TOAST_ACCORDION_OTHER":"$1 notificaci\xf3ns: prema aqu\xed para ver os detalles","TOAST_ACCORDION_TWO":"$1 notificaci\xf3ns: prema aqu\xed para ver os detalles","TOAST_ALT_ERROR":"Erro","TOAST_ALT_INFO":"Informaci\xf3n","TOAST_ALT_SUCCESS":"Correcto","TOAST_ALT_WARN":"Aviso","TOAST_DISMISS_BUTTON":"Rexeitar","TOAST_TITLE_ALT":"Notificaci\xf3n","TRANSCRIPT_ARIA_LABEL_ALT":"Historial de chat, prema as teclas de frecha para navegar.","TRANSCRIPT_ARIA_ROLE_ALT":"historial de chat","TRANSCRIPT_LIVE_REGION_INTERACTIVE_LABEL_ALT":"A mensaxe \xe9 interactiva. Prema as teclas MAI\xdaS e TAB d\xfaas ou tres veces para cambiar ao historial de chat. A continuaci\xf3n, prema na mensaxe para interactuar.","TRANSCRIPT_LIVE_REGION_INTERACTIVE_WITH_LINKS_LABEL_ALT":"Unha ou varias ligaz\xf3ns da mensaxe. Prema as teclas MAI\xdaS e TAB d\xfaas ou tres veces para cambiar ao historial de chat. A continuaci\xf3n, prema na mensaxe para interactuar.","TRANSCRIPT_LIVE_REGION_SUGGESTED_ACTIONS_LABEL_ALT":"A mensaxe ten acci\xf3ns suxeridas. Prema MAI\xdaS e TAB d\xfaas ou tres veces para seleccionalas.","TRANSCRIPT_LIVE_REGION_SUGGESTED_ACTIONS_WITH_ACCESS_KEY_LABEL_ALT":"A mensaxe ten acci\xf3ns suxeridas. Prema $1 para seleccionalas.","TRANSCRIPT_LIVE_REGION_SEND_FAILED_ALT":"Non foi posible enviar a mensaxe.","TRANSCRIPT_MORE_MESSAGES":"M\xe1is mensaxes","TRANSCRIPT_NEW_MESSAGES":"Mensaxes novas","TRANSCRIPT_TERMINATOR_TEXT":"Fin do historial de chat","TYPING_INDICATOR_ALT":"Mostrando o indicador de escritura","TYPING_INDICATOR_SINGLE_TEXT":"$1 est\xe1 a escribir.","TYPING_INDICATOR_MULTIPLE_TEXT":"$1 e outras persoas est\xe1n a escribir."}');

});

parcelRequire.register("lM2kF", function(module, exports) {
module.exports = JSON.parse('{"_comment":"[CI-LOCKED] תוכן קובץ זה נעול. תרומות יתקבלו בברכה, אך אימות השינויים עשוי להתעכב.","ACCESS_KEY_ALT":"Alt Shift $1","ACCESS_KEY_FOR_MAC_ALT":"Control Option $1","ACTIVITY_BOT_SAID_ALT":"תוכנית ה- Bot‏ $1 אמרה:","ACTIVITY_YOU_SAID_ALT":"אמרת:","ACTIVITY_BOT_ATTACHED_ALT":"תוכנית Bot צירפה:","ACTIVITY_ERROR_BOX_TITLE":"הודעת שגיאה","ACTIVITY_INTERACTIVE_FOOTNOTE_ALT":"לחץ כדי לקיים אינטראקציה.","ACTIVITY_INTERACTIVE_REASON_INTERACTIVE_CONTENT_ALT":"ההודעה היא אינטראקטיבית.","ACTIVITY_INTERACTIVE_REASON_LINK_ALT":"יש קישור אחד או יותר בהודעה.","ACTIVITY_INTERACTIVE_REASON_SEND_FAILED_ALT":"השליחה נכשלה.","ACTIVITY_YOU_ATTACHED_ALT":"צירפת:","ACTIVITY_NUM_ATTACHMENTS_ONE_ALT":"קובץ מצורף אחד.","ACTIVITY_NUM_ATTACHMENTS_FEW_ALT":"$1 קבצים מצורפים.","ACTIVITY_NUM_ATTACHMENTS_MANY_ALT":"$1 קבצים מצורפים.","ACTIVITY_NUM_ATTACHMENTS_OTHER_ALT":"$1 קבצים מצורפים.","ACTIVITY_NUM_ATTACHMENTS_TWO_ALT":"$1 קבצים מצורפים.","ACTIVITY_STATUS_SEND_FAILED_RETRY":"השליחה נכשלה. [נסה שנית][RETRY].","ACTIVITY_STATUS_SEND_STATUS_ALT_SENDING":"שולח","ACTIVITY_STATUS_SEND_STATUS_ALT_SENT_AT":"נשלח בשעה $1","ACTIVITY_STATUS_TIMESTAMP_JUST_NOW":"ממש עכשיו","ACTIVITY_STATUS_TIMESTAMP_ONE_HOUR_AGO":"לפני שעה","ACTIVITY_STATUS_TIMESTAMP_ONE_MINUTE_AGO":"לפני דקה","ACTIVITY_STATUS_TIMESTAMP_TODAY":"היום","ACTIVITY_STATUS_TIMESTAMP_YESTERDAY":"אתמול","ADAPTIVE_CARD_ERROR_BOX_TITLE_PARSE":"שגיאה בניתוח מבנה טקסט של כרטיס מסתגל","ADAPTIVE_CARD_ERROR_BOX_TITLE_RENDER":"שגיאה בעיבוד כרטיס מסתגל","ATTACHMENT_AUDIO":"קליפ שמע.","ATTACHMENT_CARD":"כרטיס: $1 $2 $3","ATTACHMENT_FILE":"קובץ: $1","ATTACHMENT_IMAGE":"תמונה","ATTACHMENT_TEXT":"טקסט: $1","ATTACHMENT_VIDEO":"קליפ וידאו","CAROUSEL_FLIPPER_LEFT_ALT":"שמאל","CAROUSEL_FLIPPER_RIGHT_ALT":"ימין","CONNECTIVITY_STATUS_ALT_CONNECTED":"מחובר","CONNECTIVITY_STATUS_ALT_CONNECTING":"מתחבר...","CONNECTIVITY_STATUS_ALT_FATAL":"לא ניתן להתחבר.","CONNECTIVITY_STATUS_ALT_RECONNECTING":"אירעה הפרעה ברשת. מתחבר מחדש...","CONNECTIVITY_STATUS_ALT_RENDER_ERROR":"שגיאת עיבוד. בדוק את המסוף או פנה אל מפתח הבוט.","CONNECTIVITY_STATUS_ALT_SLOW_CONNECTION":"ההתחברות נמשכת זמן רב מהרגיל.","CONNECTIVITY_STATUS_ALT":"מצב קישוריות: $1","FILE_CONTENT_ALT":"\'$1\'","FILE_CONTENT_DOWNLOADABLE_ALT":"הורד את הקובץ \'$1\'","FILE_CONTENT_DOWNLOADABLE_WITH_SIZE_ALT":"הורד את הקובץ \'$1\' בגודל $2","FILE_CONTENT_WITH_SIZE_ALT":"‏\'$1\' בגודל $2","KEYBOARD_HELP_CHAT_HISTORY_ACCESS_ITEMS_IN_MESSAGE_BODY":"מקש Enter","KEYBOARD_HELP_CHAT_HISTORY_ACCESS_ITEMS_IN_MESSAGE_HEADER":"גישה לפריטים בהודעה","KEYBOARD_HELP_CHAT_HISTORY_HEADER":"היסטוריית צ\'אט","KEYBOARD_HELP_CHAT_HISTORY_LEAVE_MESSAGE_BODY":"מקש Escape","KEYBOARD_HELP_CHAT_HISTORY_LEAVE_MESSAGE_HEADER":"יציאה מההודעה","KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_ITEMS_BODY":"מקש Tab\\nמקש Shift + Tab","KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_ITEMS_HEADER":"מעבר בין פריטים בהודעה","KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_MESSAGES_BODY":"מקש חץ למעלה\\nמקש חץ למטה","KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_MESSAGES_HEADER":"מעבר בין הודעות","KEYBOARD_HELP_CHAT_WINDOW_BODY_DO_ACTION_BODY":"מקש Enter","KEYBOARD_HELP_CHAT_WINDOW_BODY_DO_ACTION_HEADER":"ביצוע פעולה","KEYBOARD_HELP_CHAT_WINDOW_BODY_MOVE_BETWEEN_ITEMS_BODY":"מקש Tab\\nמקש Shift + Tab","KEYBOARD_HELP_CHAT_WINDOW_BODY_MOVE_BETWEEN_ITEMS_HEADER":"מעבר בין פריטים בחלון הצ\'אט","KEYBOARD_HELP_CHAT_WINDOW_HEADER":"חלון צ\'אט","KEYBOARD_HELP_CLOSE_BUTTON_ALT":"סגור","KEYBOARD_HELP_HEADER":"פקדי לוח מקשים","MARKDOWN_EXTERNAL_LINK_ALT":"נפתח בחלון חדש; חיצוני.","RECEIPT_CARD_TAX":"מס","RECEIPT_CARD_TOTAL":"סך הכל","RECEIPT_CARD_VAT":"מע\\"מ","SEND_BOX_IS_EMPTY_TOOLTIP_ALT":"לא ניתן לשלוח הודעה ריקה.","SPEECH_INPUT_LISTENING":"מאזין…","SPEECH_INPUT_MICROPHONE_BUTTON_CLOSE_ALT":"כבה מיקרופון","SPEECH_INPUT_MICROPHONE_BUTTON_OPEN_ALT":"הפעל מיקרופון","SPEECH_INPUT_STARTING":"מתחיל...","SUGGESTED_ACTIONS_LABEL_ALT":"פעולות מוצעות","TEXT_INPUT_ALT":"תיבה להזנת הודעה","TEXT_INPUT_PLACEHOLDER":"הקלד את ההודעה שלך","TEXT_INPUT_SEND_BUTTON_ALT":"שלח","TEXT_INPUT_SPEAK_BUTTON_ALT":"דבר","TEXT_INPUT_UPLOAD_BUTTON_ALT":"העלה קובץ","TOAST_ACCORDION_FEW":"$1 הודעות: לחץ כאן להצגת פרטים","TOAST_ACCORDION_MANY":"$1 הודעות: לחץ כאן להצגת פרטים","TOAST_ACCORDION_OTHER":"$1 הודעות: לחץ כאן להצגת פרטים","TOAST_ACCORDION_TWO":"$1 הודעות: לחץ כאן להצגת פרטים","TOAST_ALT_ERROR":"‏‏שגיאה","TOAST_ALT_INFO":"מידע","TOAST_ALT_SUCCESS":"הצלחה","TOAST_ALT_WARN":"אזהרה","TOAST_DISMISS_BUTTON":"בטל","TOAST_TITLE_ALT":"הודעה","TRANSCRIPT_ARIA_LABEL_ALT":"היסטוריית צ\'אט, הקש על מקשי החצים כדי לנווט.","TRANSCRIPT_ARIA_ROLE_ALT":"היסטוריית צ\'אט","TRANSCRIPT_LIVE_REGION_INTERACTIVE_LABEL_ALT":"ההודעה היא אינטראקטיבית. הקש על המקשים Shift ו- Tab פעמיים עד שלוש פעמים כדי לעבור להיסטוריית הצ\'אט. לאחר מכן לחץ על ההודעה כדי ליצור אינטראקציה.","TRANSCRIPT_LIVE_REGION_INTERACTIVE_WITH_LINKS_LABEL_ALT":"יש קישור אחד או יותר בהודעה. הקש על המקשים Shift ו- Tab פעמיים עד שלוש פעמים כדי לעבור להיסטוריית הצ\'אט. לאחר מכן לחץ על ההודעה כדי ליצור אינטראקציה.","TRANSCRIPT_LIVE_REGION_SUGGESTED_ACTIONS_LABEL_ALT":"ההודעה כוללת פעולות מוצעות. הקש Shift Tab פעמיים או שלוש פעמים כדי לבחור אותן.","TRANSCRIPT_LIVE_REGION_SUGGESTED_ACTIONS_WITH_ACCESS_KEY_LABEL_ALT":"ההודעה כוללת פעולות מוצעות. הקש $1 כדי לבחור אותן.","TRANSCRIPT_LIVE_REGION_SEND_FAILED_ALT":"שליחת ההודעה נכשלה.","TRANSCRIPT_MORE_MESSAGES":"הודעות נוספות","TRANSCRIPT_NEW_MESSAGES":"הודעות חדשות","TRANSCRIPT_TERMINATOR_TEXT":"סוף היסטוריית הצ\'אט","TYPING_INDICATOR_ALT":"מחוון שמציג הקלדה","TYPING_INDICATOR_SINGLE_TEXT":"$1 מקליד/ה.","TYPING_INDICATOR_MULTIPLE_TEXT":"$1 ואחרים מקלידים/ות."}');

});

parcelRequire.register("cpYux", function(module, exports) {
module.exports = JSON.parse('{"_comment":"[CI-LOCKED] इस फ़ाइल की सामग्री लॉक है. योगदानकर्ताओं का स्वागत है, लेकिन परिवर्तन सत्यापन में देरी हो सकती है.","ACCESS_KEY_ALT":"Alt Shift $1","ACCESS_KEY_FOR_MAC_ALT":"नियंत्रण विकल्प $1","ACTIVITY_BOT_SAID_ALT":"बॉट $1 ने कहा:","ACTIVITY_YOU_SAID_ALT":"आपने कहा:","ACTIVITY_BOT_ATTACHED_ALT":"बॉट संलग्न किया गया:","ACTIVITY_ERROR_BOX_TITLE":"त्रुटि संदेश","ACTIVITY_INTERACTIVE_FOOTNOTE_ALT":"सहभागिता करने के लिए क्लिक करें.","ACTIVITY_INTERACTIVE_REASON_INTERACTIVE_CONTENT_ALT":"संदेश इंटरैक्टिव है.","ACTIVITY_INTERACTIVE_REASON_LINK_ALT":"संदेश में एक या अधिक लिंक हैं.","ACTIVITY_INTERACTIVE_REASON_SEND_FAILED_ALT":"भेजना विफल रहा.","ACTIVITY_YOU_ATTACHED_ALT":"आपने यह संलग्न किया है:","ACTIVITY_NUM_ATTACHMENTS_ONE_ALT":"1 अनुलग्नक.","ACTIVITY_NUM_ATTACHMENTS_FEW_ALT":"$1 अनुलग्नक.","ACTIVITY_NUM_ATTACHMENTS_MANY_ALT":"$1 अनुलग्नक.","ACTIVITY_NUM_ATTACHMENTS_OTHER_ALT":"$1 अनुलग्नक.","ACTIVITY_NUM_ATTACHMENTS_TWO_ALT":"$1 अनुलग्नक.","ACTIVITY_STATUS_SEND_FAILED_RETRY":"भेजना विफल. [पुन: प्रयास करें][RETRY].","ACTIVITY_STATUS_SEND_STATUS_ALT_SENDING":"भेजी जा रही है","ACTIVITY_STATUS_SEND_STATUS_ALT_SENT_AT":"$1 पर भेजी गई","ACTIVITY_STATUS_TIMESTAMP_JUST_NOW":"अभी-अभी","ACTIVITY_STATUS_TIMESTAMP_ONE_HOUR_AGO":"एक घंटा पहले","ACTIVITY_STATUS_TIMESTAMP_ONE_MINUTE_AGO":"1 मिनट पहले","ACTIVITY_STATUS_TIMESTAMP_TODAY":"आज","ACTIVITY_STATUS_TIMESTAMP_YESTERDAY":"बीता हुआ कल","ADAPTIVE_CARD_ERROR_BOX_TITLE_PARSE":"एडेप्टिव कार्ड पार्स त्रुटि","ADAPTIVE_CARD_ERROR_BOX_TITLE_RENDER":"एडेप्टिव कार्ड रेंडर त्रुटि","ATTACHMENT_AUDIO":"एक ऑडियो क्लिप.","ATTACHMENT_CARD":"एक कार्ड: $1 $2 $3","ATTACHMENT_FILE":"एक फ़ाइल: $1","ATTACHMENT_IMAGE":"एक छवि","ATTACHMENT_TEXT":"एक पाठ: $1","ATTACHMENT_VIDEO":"एक वीडियो क्लिप","CAROUSEL_FLIPPER_LEFT_ALT":"बाएँ","CAROUSEL_FLIPPER_RIGHT_ALT":"दाएँ","CONNECTIVITY_STATUS_ALT_CONNECTED":"कनेक्ट किया गया","CONNECTIVITY_STATUS_ALT_CONNECTING":"कनेक्ट किया जा रहा है...","CONNECTIVITY_STATUS_ALT_FATAL":"कनेक्ट करने में असमर्थ.","CONNECTIVITY_STATUS_ALT_RECONNECTING":"नेटवर्क व्यवधान उत्पन्न हुआ. पुन: कनेक्ट करें...","CONNECTIVITY_STATUS_ALT_RENDER_ERROR":"रेंडर त्रुटि. कृपया कंसोल की जाँच करें या बॉट डेवलपर से संपर्क करें.","CONNECTIVITY_STATUS_ALT_SLOW_CONNECTION":"कनेक्ट होने में सामान्य से अधिक समय ले रहा है.","CONNECTIVITY_STATUS_ALT":"कनेक्टिविटी स्थिति: $1","FILE_CONTENT_ALT":"\'$1\'","FILE_CONTENT_DOWNLOADABLE_ALT":"\'$1\' फ़ाइल डाउनलोड करें","FILE_CONTENT_DOWNLOADABLE_WITH_SIZE_ALT":"$2 के आकार की \'$1\' फ़ाइल डाउनलोड करें","FILE_CONTENT_WITH_SIZE_ALT":"$2 के आकार की \'$1\'","KEYBOARD_HELP_CHAT_HISTORY_ACCESS_ITEMS_IN_MESSAGE_BODY":"Enter कुंजी","KEYBOARD_HELP_CHAT_HISTORY_ACCESS_ITEMS_IN_MESSAGE_HEADER":"संदेश में आइटम एक्सेस करें","KEYBOARD_HELP_CHAT_HISTORY_HEADER":"चैट इतिहास","KEYBOARD_HELP_CHAT_HISTORY_LEAVE_MESSAGE_BODY":"Escape कुंजी","KEYBOARD_HELP_CHAT_HISTORY_LEAVE_MESSAGE_HEADER":"संदेश बंद करें","KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_ITEMS_BODY":"Tab कुंजी\\nShift + Tab कुंजी","KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_ITEMS_HEADER":"संदेश में आइटम के बीच जाएं","KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_MESSAGES_BODY":"ऊपर तीर कुंजी\\nनीचे तीर कुंजी","KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_MESSAGES_HEADER":"संदेशों के बीच जाएं","KEYBOARD_HELP_CHAT_WINDOW_BODY_DO_ACTION_BODY":"Enter कुंजी","KEYBOARD_HELP_CHAT_WINDOW_BODY_DO_ACTION_HEADER":"क्रिया करें","KEYBOARD_HELP_CHAT_WINDOW_BODY_MOVE_BETWEEN_ITEMS_BODY":"Tab कुंजी\\nShift + Tab कुंजी","KEYBOARD_HELP_CHAT_WINDOW_BODY_MOVE_BETWEEN_ITEMS_HEADER":"चैट विंडो में आइटम के बीच जाएं","KEYBOARD_HELP_CHAT_WINDOW_HEADER":"चैट विंडो","KEYBOARD_HELP_CLOSE_BUTTON_ALT":"बंद करें","KEYBOARD_HELP_HEADER":"कीबोर्ड नियंत्रण","MARKDOWN_EXTERNAL_LINK_ALT":"एक नई विंडो में खोलता है; बाहरी.","RECEIPT_CARD_TAX":"कर","RECEIPT_CARD_TOTAL":"योग","RECEIPT_CARD_VAT":"VAT","SEND_BOX_IS_EMPTY_TOOLTIP_ALT":"रिक्त संदेश भेज नहीं सकते.","SPEECH_INPUT_LISTENING":"सुन रहा है...","SPEECH_INPUT_MICROPHONE_BUTTON_CLOSE_ALT":"माइक्रोफ़ोन बंद करें","SPEECH_INPUT_MICROPHONE_BUTTON_OPEN_ALT":"माइक्रोफ़ोन चालू करें","SPEECH_INPUT_STARTING":"आरंभ हो रहा है…","SUGGESTED_ACTIONS_LABEL_ALT":"सुझाई गई क्रियाएँ","TEXT_INPUT_ALT":"संदेश इनपुट बॉक्स","TEXT_INPUT_PLACEHOLDER":"अपना संदेश लिखें","TEXT_INPUT_SEND_BUTTON_ALT":"भेजें","TEXT_INPUT_SPEAK_BUTTON_ALT":"बोलें","TEXT_INPUT_UPLOAD_BUTTON_ALT":"फ़ाइल अपलोड करें","TOAST_ACCORDION_FEW":"$1 सूचनाएँ: विवरण देखने के लिए यहाँ क्लिक करें","TOAST_ACCORDION_MANY":"$1 सूचनाएँ: विवरण देखने के लिए यहाँ क्लिक करें","TOAST_ACCORDION_OTHER":"$1 सूचनाएँ: विवरण देखने के लिए यहाँ क्लिक करें","TOAST_ACCORDION_TWO":"$1 सूचनाएँ: विवरण देखने के लिए यहाँ क्लिक करें","TOAST_ALT_ERROR":"त्रुटि","TOAST_ALT_INFO":"जानकारी","TOAST_ALT_SUCCESS":"सफल","TOAST_ALT_WARN":"चेतावनी","TOAST_DISMISS_BUTTON":"खारिज करें","TOAST_TITLE_ALT":"सूचना","TRANSCRIPT_ARIA_LABEL_ALT":"चैट इतिहास, नेविगेट करने के लिए एरो कुंजियां दबाएं.","TRANSCRIPT_ARIA_ROLE_ALT":"चैट इतिहास","TRANSCRIPT_LIVE_REGION_INTERACTIVE_LABEL_ALT":"संदेश इंटरैक्टिव है. चैट इतिहास में जाने के लिए Shift Tab कुंजी को 2 से 3 बार दबाएं. फिर सहभागिता करने के लिए संदेश पर क्लिक करें.","TRANSCRIPT_LIVE_REGION_INTERACTIVE_WITH_LINKS_LABEL_ALT":"संदेश में एक या अधिक लिंक हैं. चैट इतिहास में जाने के लिए Shift Tab कुंजी को 2 से 3 बार दबाएं. फिर संदेश पर क्लिक करके सहभागिता करें.","TRANSCRIPT_LIVE_REGION_SUGGESTED_ACTIONS_LABEL_ALT":"संदेश में सुझाई गई क्रियाएँ हैं. उन्हें चुनने के लिए shift टैब को 2 से 3 बार दबाएँ.","TRANSCRIPT_LIVE_REGION_SUGGESTED_ACTIONS_WITH_ACCESS_KEY_LABEL_ALT":"संदेश में सुझाई गई क्रियाएँ हैं. उन्हें चुनने के लिए $1 दबाएँ.","TRANSCRIPT_LIVE_REGION_SEND_FAILED_ALT":"संदेश भेजा नहीं जा सका.","TRANSCRIPT_MORE_MESSAGES":"अधिक संदेश","TRANSCRIPT_NEW_MESSAGES":"नए संदेश","TRANSCRIPT_TERMINATOR_TEXT":"चैट इतिहास का अंत","TYPING_INDICATOR_ALT":"टाइप करने वाला संकेतक दिखा रहा है","TYPING_INDICATOR_SINGLE_TEXT":"$1 टाइप कर रहा है.","TYPING_INDICATOR_MULTIPLE_TEXT":"$1 और अन्य लिख रहे हैं."}');

});

parcelRequire.register("fS9bC", function(module, exports) {
module.exports = JSON.parse('{"_comment":"[CI-LOCKED] Sadržaj ove datoteke blokiran je. Doprinosi su dobrodošli, ali provjera valjanosti promjena može biti odgođena.","ACCESS_KEY_ALT":"Alt Shift $1","ACCESS_KEY_FOR_MAC_ALT":"Control Option $1","ACTIVITY_BOT_SAID_ALT":"Bot $1 rekao je:","ACTIVITY_YOU_SAID_ALT":"Vi ste rekli:","ACTIVITY_BOT_ATTACHED_ALT":"Priloženi bot:","ACTIVITY_ERROR_BOX_TITLE":"Poruka o pogrešci","ACTIVITY_INTERACTIVE_FOOTNOTE_ALT":"Kliknite za interakciju.","ACTIVITY_INTERACTIVE_REASON_INTERACTIVE_CONTENT_ALT":"Poruka je interaktivna.","ACTIVITY_INTERACTIVE_REASON_LINK_ALT":"U poruci se nalazi jedna ili više veza.","ACTIVITY_INTERACTIVE_REASON_SEND_FAILED_ALT":"Slanje nije uspjelo.","ACTIVITY_YOU_ATTACHED_ALT":"Priložili ste:","ACTIVITY_NUM_ATTACHMENTS_ONE_ALT":"1 privitak.","ACTIVITY_NUM_ATTACHMENTS_FEW_ALT":"$1 privitka.","ACTIVITY_NUM_ATTACHMENTS_MANY_ALT":"$1 privitaka.","ACTIVITY_NUM_ATTACHMENTS_OTHER_ALT":"$1 privitaka.","ACTIVITY_NUM_ATTACHMENTS_TWO_ALT":"$1 privitka.","ACTIVITY_STATUS_SEND_FAILED_RETRY":"Slanije nije uspjelo. [Pokušaj ponovno][RETRY].","ACTIVITY_STATUS_SEND_STATUS_ALT_SENDING":"Slanje","ACTIVITY_STATUS_SEND_STATUS_ALT_SENT_AT":"Poslano u $1","ACTIVITY_STATUS_TIMESTAMP_JUST_NOW":"Upravo sada","ACTIVITY_STATUS_TIMESTAMP_ONE_HOUR_AGO":"Prije 1 h","ACTIVITY_STATUS_TIMESTAMP_ONE_MINUTE_AGO":"Prije 1 minute","ACTIVITY_STATUS_TIMESTAMP_TODAY":"Danas","ACTIVITY_STATUS_TIMESTAMP_YESTERDAY":"Jučer","ADAPTIVE_CARD_ERROR_BOX_TITLE_PARSE":"Pogreška pri raščlambi prilagodljive kartice","ADAPTIVE_CARD_ERROR_BOX_TITLE_RENDER":"Pogreška pri renderiranju prilagodljive kartice","ATTACHMENT_AUDIO":"Audioisječak.","ATTACHMENT_CARD":"Kartica: $1 $2 $3","ATTACHMENT_FILE":"Datoteka: $1","ATTACHMENT_IMAGE":"Slika","ATTACHMENT_TEXT":"Tekst: $1","ATTACHMENT_VIDEO":"Videoisječak","CAROUSEL_FLIPPER_LEFT_ALT":"Lijevo","CAROUSEL_FLIPPER_RIGHT_ALT":"Desno","CONNECTIVITY_STATUS_ALT_CONNECTED":"Povezano","CONNECTIVITY_STATUS_ALT_CONNECTING":"Povezivanje u tijeku...","CONNECTIVITY_STATUS_ALT_FATAL":"Povezivanje nije moguće.","CONNECTIVITY_STATUS_ALT_RECONNECTING":"Došlo je do prekida mreže. U tijeku je ponovno povezivanje...","CONNECTIVITY_STATUS_ALT_RENDER_ERROR":"Pogreška pri renderiranju. Provjerite konzolu ili se obratite razvojnom inženjeru bota.","CONNECTIVITY_STATUS_ALT_SLOW_CONNECTION":"Povezivanje traje dulje nego obično.","CONNECTIVITY_STATUS_ALT":"Status veze: $1","FILE_CONTENT_ALT":"„$1”","FILE_CONTENT_DOWNLOADABLE_ALT":"Preuzimanje datoteke „$1”","FILE_CONTENT_DOWNLOADABLE_WITH_SIZE_ALT":"Preuzimanje datoteke „$1” veličine $2","FILE_CONTENT_WITH_SIZE_ALT":"„$1” veličine $2","KEYBOARD_HELP_CHAT_HISTORY_ACCESS_ITEMS_IN_MESSAGE_BODY":"Tipka Enter","KEYBOARD_HELP_CHAT_HISTORY_ACCESS_ITEMS_IN_MESSAGE_HEADER":"Pristup stavkama u poruci","KEYBOARD_HELP_CHAT_HISTORY_HEADER":"Povijest čavrljanja","KEYBOARD_HELP_CHAT_HISTORY_LEAVE_MESSAGE_BODY":"Tipka Esc","KEYBOARD_HELP_CHAT_HISTORY_LEAVE_MESSAGE_HEADER":"Izađi iz poruke","KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_ITEMS_BODY":"Tipka Tab\\nTipka Shift + Tab","KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_ITEMS_HEADER":"Pomicanje među stavkama u poruci","KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_MESSAGES_BODY":"Tipka sa strelicom prema gore\\nTipka sa strelicom prema dolje","KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_MESSAGES_HEADER":"Pomicanje među porukama","KEYBOARD_HELP_CHAT_WINDOW_BODY_DO_ACTION_BODY":"Tipka Enter","KEYBOARD_HELP_CHAT_WINDOW_BODY_DO_ACTION_HEADER":"Izvršavanje radnje","KEYBOARD_HELP_CHAT_WINDOW_BODY_MOVE_BETWEEN_ITEMS_BODY":"Tipka Tab\\nTipka Shift + Tab","KEYBOARD_HELP_CHAT_WINDOW_BODY_MOVE_BETWEEN_ITEMS_HEADER":"Pomicanje među stavkama u prozoru za čavrljanje","KEYBOARD_HELP_CHAT_WINDOW_HEADER":"Prozor čavrljanja","KEYBOARD_HELP_CLOSE_BUTTON_ALT":"Zatvori","KEYBOARD_HELP_HEADER":"Kontrole na tipkovnici","MARKDOWN_EXTERNAL_LINK_ALT":"Otvara se u novom prozoru, vanjskom.","RECEIPT_CARD_TAX":"Porez","RECEIPT_CARD_TOTAL":"Ukupno","RECEIPT_CARD_VAT":"PDV","SEND_BOX_IS_EMPTY_TOOLTIP_ALT":"Prazna poruka se ne može poslati.","SPEECH_INPUT_LISTENING":"Slušanje...","SPEECH_INPUT_MICROPHONE_BUTTON_CLOSE_ALT":"Mikrofon je isključen","SPEECH_INPUT_MICROPHONE_BUTTON_OPEN_ALT":"Mikrofon je uključen","SPEECH_INPUT_STARTING":"Započinje...","SUGGESTED_ACTIONS_LABEL_ALT":"Predložene akcije","TEXT_INPUT_ALT":"Okvir za unos poruke","TEXT_INPUT_PLACEHOLDER":"Unesite poruku","TEXT_INPUT_SEND_BUTTON_ALT":"Pošalji","TEXT_INPUT_SPEAK_BUTTON_ALT":"Govor","TEXT_INPUT_UPLOAD_BUTTON_ALT":"Prijenos datoteke","TOAST_ACCORDION_FEW":"Obavijesti: $1. Kliknite ovdje za prikaz pojedinosti","TOAST_ACCORDION_MANY":"Obavijesti: $1. Kliknite ovdje za prikaz pojedinosti","TOAST_ACCORDION_OTHER":"Obavijesti: $1. Kliknite ovdje za prikaz pojedinosti","TOAST_ACCORDION_TWO":"Obavijesti: $1. Kliknite ovdje za prikaz pojedinosti","TOAST_ALT_ERROR":"Pogreška","TOAST_ALT_INFO":"Informacije","TOAST_ALT_SUCCESS":"Uspjeh","TOAST_ALT_WARN":"Upozorenje","TOAST_DISMISS_BUTTON":"Odbaci","TOAST_TITLE_ALT":"Obavijest","TRANSCRIPT_ARIA_LABEL_ALT":"Povijest čavrljanja, pritisnite tipke sa strelicama za navigaciju.","TRANSCRIPT_ARIA_ROLE_ALT":"povijest čavrljanja","TRANSCRIPT_LIVE_REGION_INTERACTIVE_LABEL_ALT":"Poruka je interaktivna. Pritisnite tipke Shift i Tab 2 do 3 puta da biste se prebacili na povijest čavrljanja. Zatim za interakciju kliknite poruku.","TRANSCRIPT_LIVE_REGION_INTERACTIVE_WITH_LINKS_LABEL_ALT":"U poruci se nalazi jedna ili više veza. Pritisnite tipke Shift i Tab 2 do 3 puta da biste se prebacili na povijest čavrljanja. Zatim za interakciju kliknite poruku.","TRANSCRIPT_LIVE_REGION_SUGGESTED_ACTIONS_LABEL_ALT":"Poruka sadrži predložene akcije. Pritisnite shift i tabulator 2 do 3 puta da biste ih odabrali.","TRANSCRIPT_LIVE_REGION_SUGGESTED_ACTIONS_WITH_ACCESS_KEY_LABEL_ALT":"Poruka sadrži predložene akcije. Pritisnite $1 da biste ih odabrali.","TRANSCRIPT_LIVE_REGION_SEND_FAILED_ALT":"Slanje poruke nije uspjelo.","TRANSCRIPT_MORE_MESSAGES":"Više poruka","TRANSCRIPT_NEW_MESSAGES":"Nove poruke","TRANSCRIPT_TERMINATOR_TEXT":"Kraj povijesti čavrljanja","TYPING_INDICATOR_ALT":"Prikaz pokazatelja tipkanja","TYPING_INDICATOR_SINGLE_TEXT":"$1 tipka.","TYPING_INDICATOR_MULTIPLE_TEXT":"$1 i drugi tipkaju."}');

});

parcelRequire.register("kP2Yl", function(module, exports) {
module.exports = JSON.parse('{"_comment":"[CI-LOCKED] A f\xe1jl tartalma z\xe1rolva van. Sz\xedvesen fogadjuk a hozz\xe1j\xe1rul\xe1sokat, de a m\xf3dos\xedt\xe1sok \xe9rv\xe9nyes\xedt\xe9se elh\xfaz\xf3dhat.","ACCESS_KEY_ALT":"Alt Shift $1","ACCESS_KEY_FOR_MAC_ALT":"Control Option $1","ACTIVITY_BOT_SAID_ALT":"A(z) $1 robot azt mondta:","ACTIVITY_YOU_SAID_ALT":"\xd6n azt mondta:","ACTIVITY_BOT_ATTACHED_ALT":"Robot \xe1ltal csatolva:","ACTIVITY_ERROR_BOX_TITLE":"Hiba\xfczenet","ACTIVITY_INTERACTIVE_FOOTNOTE_ALT":"Kattintson az interakci\xf3hoz.","ACTIVITY_INTERACTIVE_REASON_INTERACTIVE_CONTENT_ALT":"Az \xfczenet interakt\xedv.","ACTIVITY_INTERACTIVE_REASON_LINK_ALT":"Egy vagy t\xf6bb hivatkoz\xe1s van az \xfczenetben.","ACTIVITY_INTERACTIVE_REASON_SEND_FAILED_ALT":"Sikertelen k\xfcld\xe9s.","ACTIVITY_YOU_ATTACHED_ALT":"\xd6n \xe1ltal csatolva:","ACTIVITY_NUM_ATTACHMENTS_ONE_ALT":"1 mell\xe9klet.","ACTIVITY_NUM_ATTACHMENTS_FEW_ALT":"$1 mell\xe9klet.","ACTIVITY_NUM_ATTACHMENTS_MANY_ALT":"$1 mell\xe9klet.","ACTIVITY_NUM_ATTACHMENTS_OTHER_ALT":"$1 mell\xe9klet.","ACTIVITY_NUM_ATTACHMENTS_TWO_ALT":"$1 mell\xe9klet.","ACTIVITY_STATUS_SEND_FAILED_RETRY":"A k\xfcld\xe9s sikertelen. [\xdajra][RETRY].","ACTIVITY_STATUS_SEND_STATUS_ALT_SENDING":"K\xfcld\xe9s","ACTIVITY_STATUS_SEND_STATUS_ALT_SENT_AT":"Elk\xfcldve: $1","ACTIVITY_STATUS_TIMESTAMP_JUST_NOW":"\xc9ppen most","ACTIVITY_STATUS_TIMESTAMP_ONE_HOUR_AGO":"Egy \xf3r\xe1ja","ACTIVITY_STATUS_TIMESTAMP_ONE_MINUTE_AGO":"Egy perce","ACTIVITY_STATUS_TIMESTAMP_TODAY":"Ma","ACTIVITY_STATUS_TIMESTAMP_YESTERDAY":"Tegnap","ADAPTIVE_CARD_ERROR_BOX_TITLE_PARSE":"Elemz\xe9si hiba az adapt\xedv k\xe1rty\xe1n\xe1l","ADAPTIVE_CARD_ERROR_BOX_TITLE_RENDER":"Renderel\xe9si hiba az adapt\xedv k\xe1rty\xe1n\xe1l","ATTACHMENT_AUDIO":"Egy hangklip.","ATTACHMENT_CARD":"Egy k\xe1rtya: $1 $2 $3","ATTACHMENT_FILE":"Egy f\xe1jl: $1","ATTACHMENT_IMAGE":"Egy k\xe9p","ATTACHMENT_TEXT":"Egy sz\xf6veg: $1","ATTACHMENT_VIDEO":"Egy videoklip","CAROUSEL_FLIPPER_LEFT_ALT":"Bal","CAROUSEL_FLIPPER_RIGHT_ALT":"Jobb","CONNECTIVITY_STATUS_ALT_CONNECTED":"Csatlakoztatva","CONNECTIVITY_STATUS_ALT_CONNECTING":"Csatlakoz\xe1s...","CONNECTIVITY_STATUS_ALT_FATAL":"Nem lehet csatlakozni.","CONNECTIVITY_STATUS_ALT_RECONNECTING":"A h\xe1l\xf3zati kapcsolat megszakadt. \xdajracsatlakoz\xe1s...","CONNECTIVITY_STATUS_ALT_RENDER_ERROR":"Renderel\xe9si hiba. Ellenőrizze a konzolt, vagy forduljon a robot fejlesztőj\xe9hez.","CONNECTIVITY_STATUS_ALT_SLOW_CONNECTION":"A szok\xe1sosn\xe1l tov\xe1bb tart a csatlakoz\xe1s.","CONNECTIVITY_STATUS_ALT":"Kapcsolat \xe1llapota: $1","FILE_CONTENT_ALT":"$1","FILE_CONTENT_DOWNLOADABLE_ALT":"$1 f\xe1jl let\xf6lt\xe9se","FILE_CONTENT_DOWNLOADABLE_WITH_SIZE_ALT":"A(z) $1 f\xe1jl let\xf6lt\xe9se. M\xe9ret: $2","FILE_CONTENT_WITH_SIZE_ALT":"$1 m\xe9rete: $2","KEYBOARD_HELP_CHAT_HISTORY_ACCESS_ITEMS_IN_MESSAGE_BODY":"Enter billentyű","KEYBOARD_HELP_CHAT_HISTORY_ACCESS_ITEMS_IN_MESSAGE_HEADER":"Az \xfczenet elemeinek el\xe9r\xe9se","KEYBOARD_HELP_CHAT_HISTORY_HEADER":"Cseveg\xe9s előzm\xe9nyei","KEYBOARD_HELP_CHAT_HISTORY_LEAVE_MESSAGE_BODY":"Escape billentyű","KEYBOARD_HELP_CHAT_HISTORY_LEAVE_MESSAGE_HEADER":"Kil\xe9p\xe9s az \xfczenetből","KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_ITEMS_BODY":"Tabul\xe1tor billentyű\\nShift + tabul\xe1tor billentyű","KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_ITEMS_HEADER":"Az \xfczenetben l\xe9vő elemek k\xf6z\xf6tti navig\xe1ci\xf3","KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_MESSAGES_BODY":"Felfel\xe9 mutat\xf3 ny\xedl\\nLefel\xe9 mutat\xf3 ny\xedl","KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_MESSAGES_HEADER":"Navig\xe1ci\xf3 az \xfczenetek k\xf6z\xf6tt","KEYBOARD_HELP_CHAT_WINDOW_BODY_DO_ACTION_BODY":"Enter billentyű","KEYBOARD_HELP_CHAT_WINDOW_BODY_DO_ACTION_HEADER":"Művelet v\xe9grehajt\xe1sa","KEYBOARD_HELP_CHAT_WINDOW_BODY_MOVE_BETWEEN_ITEMS_BODY":"Tabul\xe1tor billentyű\\nShift + tabul\xe1tor billentyű","KEYBOARD_HELP_CHAT_WINDOW_BODY_MOVE_BETWEEN_ITEMS_HEADER":"A csevegőablakban l\xe9vő elemek k\xf6z\xf6tti navig\xe1ci\xf3","KEYBOARD_HELP_CHAT_WINDOW_HEADER":"Csevegőablak","KEYBOARD_HELP_CLOSE_BUTTON_ALT":"Bez\xe1r\xe1s","KEYBOARD_HELP_HEADER":"Billentyűzetvez\xe9rlők","MARKDOWN_EXTERNAL_LINK_ALT":"Megnyitja egy \xfaj ablakban; k\xfclső hivatkoz\xe1s.","RECEIPT_CARD_TAX":"Ad\xf3","RECEIPT_CARD_TOTAL":"\xd6sszesen","RECEIPT_CARD_VAT":"\xc1FA","SEND_BOX_IS_EMPTY_TOOLTIP_ALT":"Nem lehet \xfcres \xfczenetet k\xfcldeni.","SPEECH_INPUT_LISTENING":"Hallgat\xe1s...","SPEECH_INPUT_MICROPHONE_BUTTON_CLOSE_ALT":"Mikrofon kikapcsolva","SPEECH_INPUT_MICROPHONE_BUTTON_OPEN_ALT":"Mikrofon bekapcsolva","SPEECH_INPUT_STARTING":"Kezd\xe9s...","SUGGESTED_ACTIONS_LABEL_ALT":"Javasolt műveletek","TEXT_INPUT_ALT":"\xdczenet beviteli mezője","TEXT_INPUT_PLACEHOLDER":"\xcdrja be az \xfczenet\xe9t","TEXT_INPUT_SEND_BUTTON_ALT":"K\xfcld\xe9s","TEXT_INPUT_SPEAK_BUTTON_ALT":"Besz\xe9d","TEXT_INPUT_UPLOAD_BUTTON_ALT":"F\xe1jl felt\xf6lt\xe9se","TOAST_ACCORDION_FEW":"$1 \xe9rtes\xedt\xe9s: Kattintson ide a r\xe9szletek megtekint\xe9s\xe9hez","TOAST_ACCORDION_MANY":"$1 \xe9rtes\xedt\xe9s: Kattintson ide a r\xe9szletek megtekint\xe9s\xe9hez","TOAST_ACCORDION_OTHER":"$1 \xe9rtes\xedt\xe9s: Kattintson ide a r\xe9szletek megtekint\xe9s\xe9hez","TOAST_ACCORDION_TWO":"$1 \xe9rtes\xedt\xe9s: Kattintson ide a r\xe9szletek megtekint\xe9s\xe9hez","TOAST_ALT_ERROR":"Hiba","TOAST_ALT_INFO":"Inform\xe1ci\xf3k","TOAST_ALT_SUCCESS":"Sikeres","TOAST_ALT_WARN":"Figyelmeztet\xe9s","TOAST_DISMISS_BUTTON":"Elvet\xe9s","TOAST_TITLE_ALT":"\xc9rtes\xedt\xe9s","TRANSCRIPT_ARIA_LABEL_ALT":"Cseveg\xe9si előzm\xe9nyek; a navig\xe1l\xe1shoz haszn\xe1lja a ny\xedlbillentyűket.","TRANSCRIPT_ARIA_ROLE_ALT":"cseveg\xe9s előzm\xe9nyei","TRANSCRIPT_LIVE_REGION_INTERACTIVE_LABEL_ALT":"Az \xfczenet interakt\xedv. A cseveg\xe9si előzm\xe9nyekre v\xe1lt\xe1shoz nyomja le 2-3 alkalommal a shift \xe9s tabul\xe1tor billentyűket. Ezut\xe1n kattintson az \xfczenetre az interakci\xf3hoz.","TRANSCRIPT_LIVE_REGION_INTERACTIVE_WITH_LINKS_LABEL_ALT":"Egy vagy t\xf6bb hivatkoz\xe1s van az \xfczenetben. A cseveg\xe9si előzm\xe9nyekre v\xe1lt\xe1shoz nyomja le 2-3 alkalommal a shift \xe9s tabul\xe1tor billentyűket. Ezut\xe1n kattintson az \xfczenetre az interakci\xf3hoz.","TRANSCRIPT_LIVE_REGION_SUGGESTED_ACTIONS_LABEL_ALT":"Az \xfczenet javasolt int\xe9zked\xe9seket tartalmaz. Nyomja meg 2-3 alkalommal a Shift+Tab billentyűket a kiv\xe1laszt\xe1sukhoz.","TRANSCRIPT_LIVE_REGION_SUGGESTED_ACTIONS_WITH_ACCESS_KEY_LABEL_ALT":"Az \xfczenet javasolt int\xe9zked\xe9seket tartalmaz. Nyomja meg a $1 billentyűt a kiv\xe1laszt\xe1sukhoz.","TRANSCRIPT_LIVE_REGION_SEND_FAILED_ALT":"Nem siker\xfclt elk\xfcldeni az \xfczenetet.","TRANSCRIPT_MORE_MESSAGES":"Tov\xe1bbi \xfczenetek","TRANSCRIPT_NEW_MESSAGES":"\xdaj \xfczenetek","TRANSCRIPT_TERMINATOR_TEXT":"A cseveg\xe9si előzm\xe9nyek v\xe9ge","TYPING_INDICATOR_ALT":"G\xe9pel\xe9sjelző megjelen\xedt\xe9se","TYPING_INDICATOR_SINGLE_TEXT":"1 $ \xe9s \xedr.","TYPING_INDICATOR_MULTIPLE_TEXT":"1 $ \xe9s m\xe1sok m\xe9g \xedrnak."}');

});

parcelRequire.register("1LUJi", function(module, exports) {
module.exports = JSON.parse('{"_comment":"[CI-LOCKED] Konten file ini terkunci. Kontribusi diterima, namun validasi perubahan mungkin tertunda.","ACCESS_KEY_ALT":"Alt Shift $1","ACCESS_KEY_FOR_MAC_ALT":"Control Option $1","ACTIVITY_BOT_SAID_ALT":"Bot $1 berkata:","ACTIVITY_YOU_SAID_ALT":"Anda berkata:","ACTIVITY_BOT_ATTACHED_ALT":"Bot melampirkan:","ACTIVITY_ERROR_BOX_TITLE":"Pesan kesalahan","ACTIVITY_INTERACTIVE_FOOTNOTE_ALT":"Klik untuk berinteraksi.","ACTIVITY_INTERACTIVE_REASON_INTERACTIVE_CONTENT_ALT":"Pesan ini interaktif.","ACTIVITY_INTERACTIVE_REASON_LINK_ALT":"Ada satu atau beberapa tautan dalam pesan ini.","ACTIVITY_INTERACTIVE_REASON_SEND_FAILED_ALT":"Gagal terkirim.","ACTIVITY_YOU_ATTACHED_ALT":"Anda melampirkan:","ACTIVITY_NUM_ATTACHMENTS_ONE_ALT":"1 lampiran.","ACTIVITY_NUM_ATTACHMENTS_FEW_ALT":"$1 lampiran.","ACTIVITY_NUM_ATTACHMENTS_MANY_ALT":"$1 lampiran.","ACTIVITY_NUM_ATTACHMENTS_OTHER_ALT":"$1 lampiran.","ACTIVITY_NUM_ATTACHMENTS_TWO_ALT":"$1 lampiran.","ACTIVITY_STATUS_SEND_FAILED_RETRY":"Gagal mengirim. [Coba lagi][RETRY].","ACTIVITY_STATUS_SEND_STATUS_ALT_SENDING":"Mengirim","ACTIVITY_STATUS_SEND_STATUS_ALT_SENT_AT":"Dikirim pada $1","ACTIVITY_STATUS_TIMESTAMP_JUST_NOW":"Baru saja","ACTIVITY_STATUS_TIMESTAMP_ONE_HOUR_AGO":"Satu jam yang lalu","ACTIVITY_STATUS_TIMESTAMP_ONE_MINUTE_AGO":"Satu menit yang lalu","ACTIVITY_STATUS_TIMESTAMP_TODAY":"Hari Ini","ACTIVITY_STATUS_TIMESTAMP_YESTERDAY":"Kemarin","ADAPTIVE_CARD_ERROR_BOX_TITLE_PARSE":"Kesalahan penguraian Kartu Adaptif","ADAPTIVE_CARD_ERROR_BOX_TITLE_RENDER":"Kesalahan render Kartu Adaptif","ATTACHMENT_AUDIO":"Klip audio.","ATTACHMENT_CARD":"Kartu: $1 $2 $3","ATTACHMENT_FILE":"File: $1","ATTACHMENT_IMAGE":"Gambar","ATTACHMENT_TEXT":"Teks: $1","ATTACHMENT_VIDEO":"Klip video","CAROUSEL_FLIPPER_LEFT_ALT":"Kiri","CAROUSEL_FLIPPER_RIGHT_ALT":"Kanan","CONNECTIVITY_STATUS_ALT_CONNECTED":"Tersambung","CONNECTIVITY_STATUS_ALT_CONNECTING":"Menyambungkan…","CONNECTIVITY_STATUS_ALT_FATAL":"Tidak dapat menyambungkan.","CONNECTIVITY_STATUS_ALT_RECONNECTING":"Terjadi gangguan jaringan. Menyambungkan kembali…","CONNECTIVITY_STATUS_ALT_RENDER_ERROR":"Kesalahan render. Periksa konsol atau hubungi pengembang bot.","CONNECTIVITY_STATUS_ALT_SLOW_CONNECTION":"Memakan waktu lebih lama dari biasanya untuk menyambungkan.","CONNECTIVITY_STATUS_ALT":"Status Konektivitas: $1","FILE_CONTENT_ALT":"\'$1\'","FILE_CONTENT_DOWNLOADABLE_ALT":"Unduh file \'$1\'","FILE_CONTENT_DOWNLOADABLE_WITH_SIZE_ALT":"Unduh file \'$1\' dengan ukuran $2","FILE_CONTENT_WITH_SIZE_ALT":"\'$1\' dengan ukuran $2","KEYBOARD_HELP_CHAT_HISTORY_ACCESS_ITEMS_IN_MESSAGE_BODY":"Tombol Enter","KEYBOARD_HELP_CHAT_HISTORY_ACCESS_ITEMS_IN_MESSAGE_HEADER":"Akses item dalam pesan","KEYBOARD_HELP_CHAT_HISTORY_HEADER":"Riwayat obrolan","KEYBOARD_HELP_CHAT_HISTORY_LEAVE_MESSAGE_BODY":"Tombol Escape","KEYBOARD_HELP_CHAT_HISTORY_LEAVE_MESSAGE_HEADER":"Pesan keluar","KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_ITEMS_BODY":"Tombol Tab\\nTombol Shift + Tab","KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_ITEMS_HEADER":"Pindahkan di antara item dalam pesan","KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_MESSAGES_BODY":"Tombol panah atas\\nTombol panah bawah","KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_MESSAGES_HEADER":"Pindahkan antarpesan","KEYBOARD_HELP_CHAT_WINDOW_BODY_DO_ACTION_BODY":"Tombol Enter","KEYBOARD_HELP_CHAT_WINDOW_BODY_DO_ACTION_HEADER":"Lakukan tindakan","KEYBOARD_HELP_CHAT_WINDOW_BODY_MOVE_BETWEEN_ITEMS_BODY":"Tombol Tab\\nTombol Shift + Tab","KEYBOARD_HELP_CHAT_WINDOW_BODY_MOVE_BETWEEN_ITEMS_HEADER":"Pindahkan di antara item dalam jendela obrolan","KEYBOARD_HELP_CHAT_WINDOW_HEADER":"Jendela obrolan","KEYBOARD_HELP_CLOSE_BUTTON_ALT":"Tutup","KEYBOARD_HELP_HEADER":"Kontrol keyboard","MARKDOWN_EXTERNAL_LINK_ALT":"Membuka di jendela baru; eksternal.","RECEIPT_CARD_TAX":"Pajak","RECEIPT_CARD_TOTAL":"Total","RECEIPT_CARD_VAT":"PPN","SEND_BOX_IS_EMPTY_TOOLTIP_ALT":"Tidak dapat mengirim pesan kosong.","SPEECH_INPUT_LISTENING":"Mendengarkan…","SPEECH_INPUT_MICROPHONE_BUTTON_CLOSE_ALT":"Mikrofon tidak aktif","SPEECH_INPUT_MICROPHONE_BUTTON_OPEN_ALT":"Mikrofon aktif","SPEECH_INPUT_STARTING":"Memulai…","SUGGESTED_ACTIONS_LABEL_ALT":"Tindakan yang disarankan","TEXT_INPUT_ALT":"Kotak input pesan","TEXT_INPUT_PLACEHOLDER":"Ketik pesan Anda","TEXT_INPUT_SEND_BUTTON_ALT":"Kirim","TEXT_INPUT_SPEAK_BUTTON_ALT":"Ucapkan","TEXT_INPUT_UPLOAD_BUTTON_ALT":"Unggah file","TOAST_ACCORDION_FEW":"$1 Pemberitahuan: Klik di sini untuk melihat detail","TOAST_ACCORDION_MANY":"$1 Pemberitahuan: Klik di sini untuk melihat detail","TOAST_ACCORDION_OTHER":"$1 Pemberitahuan: Klik di sini untuk melihat detail","TOAST_ACCORDION_TWO":"$1 Pemberitahuan: Klik di sini untuk melihat detail","TOAST_ALT_ERROR":"Kesalahan","TOAST_ALT_INFO":"Informasi","TOAST_ALT_SUCCESS":"Berhasil","TOAST_ALT_WARN":"Peringatan","TOAST_DISMISS_BUTTON":"Tutup","TOAST_TITLE_ALT":"Pemberitahuan","TRANSCRIPT_ARIA_LABEL_ALT":"Riwayat obrolan, tekan tombol panah untuk menavigasi.","TRANSCRIPT_ARIA_ROLE_ALT":"riwayat obrolan","TRANSCRIPT_LIVE_REGION_INTERACTIVE_LABEL_ALT":"Pesan interaktif. Tekan tombol tab shift 2 hingga 3 kali untuk beralih ke riwayat obrolan. Setelah itu, klik pesan untuk berinteraksi.","TRANSCRIPT_LIVE_REGION_INTERACTIVE_WITH_LINKS_LABEL_ALT":"Satu atau beberapa klik dalam pesan. Tekan tombol tab shift 2 hingga 3 kali untuk beralih ke riwayat obrolan. Setelah itu, klik pesan untuk berinteraksi.","TRANSCRIPT_LIVE_REGION_SUGGESTED_ACTIONS_LABEL_ALT":"Pesan memiliki tindakan yang disarankan. Tekan tab shift sebanyak 2 hingga 3 kali untuk memilihnya.","TRANSCRIPT_LIVE_REGION_SUGGESTED_ACTIONS_WITH_ACCESS_KEY_LABEL_ALT":"Pesan memiliki tindakan yang disarankan. Tekan $1 untuk memilihnya.","TRANSCRIPT_LIVE_REGION_SEND_FAILED_ALT":"Pesan gagal terkirim.","TRANSCRIPT_MORE_MESSAGES":"Pesan lainnya","TRANSCRIPT_NEW_MESSAGES":"Pesan baru","TRANSCRIPT_TERMINATOR_TEXT":"Akhir riwayat obrolan","TYPING_INDICATOR_ALT":"Menampilkan indikator pengetikan","TYPING_INDICATOR_SINGLE_TEXT":"$1 sedang mengetik.","TYPING_INDICATOR_MULTIPLE_TEXT":"$1 dan lainnya sedang mengetik."}');

});

parcelRequire.register("dc1HK", function(module, exports) {
module.exports = JSON.parse('{"_comment":"[CI-LOCKED] Il contenuto del file \xe8 bloccato. I contributi sono ben accetti, ma la convalida delle modifiche potrebbe essere posticipata.","ACCESS_KEY_ALT":"ALT MAIUSC $1","ACCESS_KEY_FOR_MAC_ALT":"Controllo Opzione $1","ACTIVITY_BOT_SAID_ALT":"Il bot $1 ha detto:","ACTIVITY_YOU_SAID_ALT":"Hai detto:","ACTIVITY_BOT_ATTACHED_ALT":"Il bot ha allegato:","ACTIVITY_ERROR_BOX_TITLE":"Messaggio di errore","ACTIVITY_INTERACTIVE_FOOTNOTE_ALT":"Fare clic per interagire.","ACTIVITY_INTERACTIVE_REASON_INTERACTIVE_CONTENT_ALT":"Messaggio inattivo.","ACTIVITY_INTERACTIVE_REASON_LINK_ALT":"Uno o pi\xf9 collegamenti nel messaggio.","ACTIVITY_INTERACTIVE_REASON_SEND_FAILED_ALT":"Invio non riuscito.","ACTIVITY_YOU_ATTACHED_ALT":"Hai allegato:","ACTIVITY_NUM_ATTACHMENTS_ONE_ALT":"1 allegato.","ACTIVITY_NUM_ATTACHMENTS_FEW_ALT":"$1 allegati.","ACTIVITY_NUM_ATTACHMENTS_MANY_ALT":"$1 allegati.","ACTIVITY_NUM_ATTACHMENTS_OTHER_ALT":"$1 allegati.","ACTIVITY_NUM_ATTACHMENTS_TWO_ALT":"$1 allegati.","ACTIVITY_STATUS_SEND_FAILED_RETRY":"Invio non riuscito. [tentativo][RETRY].","ACTIVITY_STATUS_SEND_STATUS_ALT_SENDING":"Invio in corso","ACTIVITY_STATUS_SEND_STATUS_ALT_SENT_AT":"Inviato alle $1","ACTIVITY_STATUS_TIMESTAMP_JUST_NOW":"Adesso","ACTIVITY_STATUS_TIMESTAMP_ONE_HOUR_AGO":"Un\'ora fa","ACTIVITY_STATUS_TIMESTAMP_ONE_MINUTE_AGO":"Un minuto fa","ACTIVITY_STATUS_TIMESTAMP_TODAY":"Oggi","ACTIVITY_STATUS_TIMESTAMP_YESTERDAY":"Ieri","ADAPTIVE_CARD_ERROR_BOX_TITLE_PARSE":"Errore di analisi scheda adattiva","ADAPTIVE_CARD_ERROR_BOX_TITLE_RENDER":"Errore di rendering scheda adattiva","ATTACHMENT_AUDIO":"Clip audio.","ATTACHMENT_CARD":"Scheda: $1 $2 $3","ATTACHMENT_FILE":"File: $1","ATTACHMENT_IMAGE":"Immagine","ATTACHMENT_TEXT":"Testo: $1","ATTACHMENT_VIDEO":"Clip video","CAROUSEL_FLIPPER_LEFT_ALT":"A sinistra","CAROUSEL_FLIPPER_RIGHT_ALT":"Diritti","CONNECTIVITY_STATUS_ALT_CONNECTED":"Connesso","CONNECTIVITY_STATUS_ALT_CONNECTING":"Connessione in corso…","CONNECTIVITY_STATUS_ALT_FATAL":"Impossibile connettersi.","CONNECTIVITY_STATUS_ALT_RECONNECTING":"Interruzione di rete. Riconnessione in corso…","CONNECTIVITY_STATUS_ALT_RENDER_ERROR":"Errore di rendering. Controlla la console o contatta lo sviluppatore del bot.","CONNECTIVITY_STATUS_ALT_SLOW_CONNECTION":"La connessione sta richiedendo pi\xf9 tempo del solito.","CONNECTIVITY_STATUS_ALT":"Stato connettivit\xe0: $1","FILE_CONTENT_ALT":"\\"$1\\"","FILE_CONTENT_DOWNLOADABLE_ALT":"Scarica file \\"$1\\"","FILE_CONTENT_DOWNLOADABLE_WITH_SIZE_ALT":"Scarica il file \\"$1\\" con dimensioni pari a $2","FILE_CONTENT_WITH_SIZE_ALT":"\\"$1\\" con dimensioni pari a $2","KEYBOARD_HELP_CHAT_HISTORY_ACCESS_ITEMS_IN_MESSAGE_BODY":"Tasto INVIO","KEYBOARD_HELP_CHAT_HISTORY_ACCESS_ITEMS_IN_MESSAGE_HEADER":"Accedi agli elementi nel messaggio","KEYBOARD_HELP_CHAT_HISTORY_HEADER":"Cronologia chat","KEYBOARD_HELP_CHAT_HISTORY_LEAVE_MESSAGE_BODY":"Tasto ESC","KEYBOARD_HELP_CHAT_HISTORY_LEAVE_MESSAGE_HEADER":"Messaggio di uscita","KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_ITEMS_BODY":"Tasto TAB\\nTasto MAIUSC + TAB","KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_ITEMS_HEADER":"Spostati tra gli elementi di un messaggio","KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_MESSAGES_BODY":"Tasto freccia SU\\nTasto freccia GI\xd9","KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_MESSAGES_HEADER":"Spostati tra i messaggi","KEYBOARD_HELP_CHAT_WINDOW_BODY_DO_ACTION_BODY":"Tasto INVIO","KEYBOARD_HELP_CHAT_WINDOW_BODY_DO_ACTION_HEADER":"Esegui azione","KEYBOARD_HELP_CHAT_WINDOW_BODY_MOVE_BETWEEN_ITEMS_BODY":"Tasto TAB\\nTasto MAIUSC + TAB","KEYBOARD_HELP_CHAT_WINDOW_BODY_MOVE_BETWEEN_ITEMS_HEADER":"Spostati tra elementi nella finestra di chat","KEYBOARD_HELP_CHAT_WINDOW_HEADER":"Finestra di chat","KEYBOARD_HELP_CLOSE_BUTTON_ALT":"Chiudi","KEYBOARD_HELP_HEADER":"Comandi della tastiera","MARKDOWN_EXTERNAL_LINK_ALT":"Apre in una nuova finestra; esterna.","RECEIPT_CARD_TAX":"Imposte","RECEIPT_CARD_TOTAL":"Totali","RECEIPT_CARD_VAT":"IVA","SEND_BOX_IS_EMPTY_TOOLTIP_ALT":"Impossibile inviare un messaggio vuoto.","SPEECH_INPUT_LISTENING":"In ascolto…","SPEECH_INPUT_MICROPHONE_BUTTON_CLOSE_ALT":"Microfono disattivato","SPEECH_INPUT_MICROPHONE_BUTTON_OPEN_ALT":"Microfono attivo","SPEECH_INPUT_STARTING":"Avvio in corso…","SUGGESTED_ACTIONS_LABEL_ALT":"Azioni suggerite","TEXT_INPUT_ALT":"Casella di input messaggio","TEXT_INPUT_PLACEHOLDER":"Digita il tuo messaggio","TEXT_INPUT_SEND_BUTTON_ALT":"Invia","TEXT_INPUT_SPEAK_BUTTON_ALT":"Parla","TEXT_INPUT_UPLOAD_BUTTON_ALT":"Carica file","TOAST_ACCORDION_FEW":"$1 notifiche: fai clic qui per visualizzare i dettagli","TOAST_ACCORDION_MANY":"$1 notifiche: fai clic qui per visualizzare i dettagli","TOAST_ACCORDION_OTHER":"$1 notifiche: fai clic qui per visualizzare i dettagli","TOAST_ACCORDION_TWO":"$1 notifiche: fai clic qui per visualizzare i dettagli","TOAST_ALT_ERROR":"Errore","TOAST_ALT_INFO":"Informazioni","TOAST_ALT_SUCCESS":"Riuscito","TOAST_ALT_WARN":"Avviso","TOAST_DISMISS_BUTTON":"Ignora","TOAST_TITLE_ALT":"Notifica","TRANSCRIPT_ARIA_LABEL_ALT":"Cronologia chat, premi i tasti freccia per spostarti.","TRANSCRIPT_ARIA_ROLE_ALT":"cronologia chat","TRANSCRIPT_LIVE_REGION_INTERACTIVE_LABEL_ALT":"Il messaggio \xe8 interattivo. Premi MAIUSC +TAB da 2 a 3 volte per passare alla cronologia della chat. Fai clic sul messaggio per interagire.","TRANSCRIPT_LIVE_REGION_INTERACTIVE_WITH_LINKS_LABEL_ALT":"Uno o pi\xf9 collegamenti nel messaggio. Premi MAIUSC +TAB da 2 a 3 volte per passare alla cronologia della chat. Fai clic sul messaggio per interagire.","TRANSCRIPT_LIVE_REGION_SUGGESTED_ACTIONS_LABEL_ALT":"Azioni suggerite per il messaggio. Premi TAB MAIUSC da 2 a 3 volte per selezionarle.","TRANSCRIPT_LIVE_REGION_SUGGESTED_ACTIONS_WITH_ACCESS_KEY_LABEL_ALT":"Azioni suggerite per il messaggio. Premi $1 per selezionarle.","TRANSCRIPT_LIVE_REGION_SEND_FAILED_ALT":"Impossibile inviare il messaggio.","TRANSCRIPT_MORE_MESSAGES":"Altri messaggi","TRANSCRIPT_NEW_MESSAGES":"Nuovi messaggi","TRANSCRIPT_TERMINATOR_TEXT":"Fine della cronologia chat","TYPING_INDICATOR_ALT":"Visualizzazione dell\'indicatore di digitazione in corso","TYPING_INDICATOR_SINGLE_TEXT":"$1 sta digitando.","TYPING_INDICATOR_MULTIPLE_TEXT":"$1 e altri stanno digitando."}');

});

parcelRequire.register("hamQs", function(module, exports) {
module.exports = JSON.parse('{"_comment":"[CI-LOCKED] このファイルのコンテンツはロックされています。投稿は歓迎しますが、変更の検証は遅れる可能性があります。","ACCESS_KEY_ALT":"Alt + Shift + $1","ACCESS_KEY_FOR_MAC_ALT":"control + option + $1","ACTIVITY_BOT_SAID_ALT":"ボット $1 の発言:","ACTIVITY_YOU_SAID_ALT":"あなたの発言:","ACTIVITY_BOT_ATTACHED_ALT":"ボットの添付:","ACTIVITY_ERROR_BOX_TITLE":"エラー メッセージ","ACTIVITY_INTERACTIVE_FOOTNOTE_ALT":"クリックして対話します。","ACTIVITY_INTERACTIVE_REASON_INTERACTIVE_CONTENT_ALT":"メッセージはインタラクティブです。","ACTIVITY_INTERACTIVE_REASON_LINK_ALT":"メッセージ内に 1 つ以上のリンクがあります。","ACTIVITY_INTERACTIVE_REASON_SEND_FAILED_ALT":"送信に失敗しました。","ACTIVITY_YOU_ATTACHED_ALT":"あなたの添付:","ACTIVITY_NUM_ATTACHMENTS_ONE_ALT":"1 個の添付ファイル。","ACTIVITY_NUM_ATTACHMENTS_FEW_ALT":"$1 添付ファイル。","ACTIVITY_NUM_ATTACHMENTS_MANY_ALT":"$1 添付ファイル。","ACTIVITY_NUM_ATTACHMENTS_OTHER_ALT":"$1 添付ファイル。","ACTIVITY_NUM_ATTACHMENTS_TWO_ALT":"$1 添付ファイル。","ACTIVITY_STATUS_SEND_FAILED_RETRY":"送信に失敗しました。[再試行][RETRY]。","ACTIVITY_STATUS_SEND_STATUS_ALT_SENDING":"送信中","ACTIVITY_STATUS_SEND_STATUS_ALT_SENT_AT":"送信時刻: $1","ACTIVITY_STATUS_TIMESTAMP_JUST_NOW":"たった今","ACTIVITY_STATUS_TIMESTAMP_ONE_HOUR_AGO":"1 時間前","ACTIVITY_STATUS_TIMESTAMP_ONE_MINUTE_AGO":"1 分前","ACTIVITY_STATUS_TIMESTAMP_TODAY":"今日","ACTIVITY_STATUS_TIMESTAMP_YESTERDAY":"昨日","ADAPTIVE_CARD_ERROR_BOX_TITLE_PARSE":"アダプティブ カードの解析エラー","ADAPTIVE_CARD_ERROR_BOX_TITLE_RENDER":"アダプティブ カードの表示エラー","ATTACHMENT_AUDIO":"オーディオクリップです。","ATTACHMENT_CARD":"カード: $1 $2 $3","ATTACHMENT_FILE":"ファイル: $1","ATTACHMENT_IMAGE":"画像","ATTACHMENT_TEXT":"テキスト: $1","ATTACHMENT_VIDEO":"ビデオ クリップ","CAROUSEL_FLIPPER_LEFT_ALT":"左方向","CAROUSEL_FLIPPER_RIGHT_ALT":"右方向","CONNECTIVITY_STATUS_ALT_CONNECTED":"接続済み","CONNECTIVITY_STATUS_ALT_CONNECTING":"接続中…","CONNECTIVITY_STATUS_ALT_FATAL":"接続できません。","CONNECTIVITY_STATUS_ALT_RECONNECTING":"ネットワークの中断が発生しました。再接続しています...","CONNECTIVITY_STATUS_ALT_RENDER_ERROR":"表示エラー。コンソールを確認するかボット開発者にお問合せください。","CONNECTIVITY_STATUS_ALT_SLOW_CONNECTION":"通常より接続に時間がかかっています。","CONNECTIVITY_STATUS_ALT":"接続状態: $1","FILE_CONTENT_ALT":"\'$1\'","FILE_CONTENT_DOWNLOADABLE_ALT":"ファイル \'$1\' のダウンロード","FILE_CONTENT_DOWNLOADABLE_WITH_SIZE_ALT":"ファイル \'$1\' (サイズ: $2) をダウンロードする","FILE_CONTENT_WITH_SIZE_ALT":"\'$1\' (サイズ: $2)","KEYBOARD_HELP_CHAT_HISTORY_ACCESS_ITEMS_IN_MESSAGE_BODY":"Enter キー","KEYBOARD_HELP_CHAT_HISTORY_ACCESS_ITEMS_IN_MESSAGE_HEADER":"メッセージ内のアイテムにアクセスする","KEYBOARD_HELP_CHAT_HISTORY_HEADER":"チャット履歴","KEYBOARD_HELP_CHAT_HISTORY_LEAVE_MESSAGE_BODY":"Esc キー","KEYBOARD_HELP_CHAT_HISTORY_LEAVE_MESSAGE_HEADER":"終了メッセージ","KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_ITEMS_BODY":"Tab キー\\nShift + Tab キー","KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_ITEMS_HEADER":"メッセージ内のアイテム間を移動する","KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_MESSAGES_BODY":"上方向キー\\n下方向キー","KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_MESSAGES_HEADER":"メッセージ間を移動する","KEYBOARD_HELP_CHAT_WINDOW_BODY_DO_ACTION_BODY":"Enter キー","KEYBOARD_HELP_CHAT_WINDOW_BODY_DO_ACTION_HEADER":"アクション実行","KEYBOARD_HELP_CHAT_WINDOW_BODY_MOVE_BETWEEN_ITEMS_BODY":"Tab キー\\nShift + Tab キー","KEYBOARD_HELP_CHAT_WINDOW_BODY_MOVE_BETWEEN_ITEMS_HEADER":"チャット ウィンドウ内のアイテム間を移動する","KEYBOARD_HELP_CHAT_WINDOW_HEADER":"チャット ウィンドウ","KEYBOARD_HELP_CLOSE_BUTTON_ALT":"閉じる","KEYBOARD_HELP_HEADER":"キーボード コントロール","MARKDOWN_EXTERNAL_LINK_ALT":"新しいウィンドウ (外部) でレコードを開きます。","RECEIPT_CARD_TAX":"税額","RECEIPT_CARD_TOTAL":"合計","RECEIPT_CARD_VAT":"VAT","SEND_BOX_IS_EMPTY_TOOLTIP_ALT":"空のメッセージは送信できません。","SPEECH_INPUT_LISTENING":"聞いています…","SPEECH_INPUT_MICROPHONE_BUTTON_CLOSE_ALT":"マイクが無効","SPEECH_INPUT_MICROPHONE_BUTTON_OPEN_ALT":"マイクが有効","SPEECH_INPUT_STARTING":"開始しています…","SUGGESTED_ACTIONS_LABEL_ALT":"推奨されるアクション","TEXT_INPUT_ALT":"メッセージ入力ボックス","TEXT_INPUT_PLACEHOLDER":"メッセージを入力してください","TEXT_INPUT_SEND_BUTTON_ALT":"送信","TEXT_INPUT_SPEAK_BUTTON_ALT":"話す","TEXT_INPUT_UPLOAD_BUTTON_ALT":"ファイルのアップロード","TOAST_ACCORDION_FEW":"$1 件の通知: ここをクリックして詳細を確認する","TOAST_ACCORDION_MANY":"$1 件の通知: ここをクリックして詳細を確認する","TOAST_ACCORDION_OTHER":"$1 件の通知: ここをクリックして詳細を確認する","TOAST_ACCORDION_TWO":"$1 件の通知: ここをクリックして詳細を確認する","TOAST_ALT_ERROR":"エラー","TOAST_ALT_INFO":"情報","TOAST_ALT_SUCCESS":"成功","TOAST_ALT_WARN":"警告","TOAST_DISMISS_BUTTON":"解除","TOAST_TITLE_ALT":"通知","TRANSCRIPT_ARIA_LABEL_ALT":"チャット履歴。方向キーを押して移動します。","TRANSCRIPT_ARIA_ROLE_ALT":"チャット履歴","TRANSCRIPT_LIVE_REGION_INTERACTIVE_LABEL_ALT":"メッセージは対話型です。Shift + Tab キーを 2 ～ 3 回押してチャット履歴に切り替えます。その後、メッセージをクリックして対話します。","TRANSCRIPT_LIVE_REGION_INTERACTIVE_WITH_LINKS_LABEL_ALT":"メッセージ内に 1 つ以上のリンクがあります。Shift + Tab キーを 2 ～ 3 回押してチャット履歴に切り替えます。その後、メッセージをクリックして対話します。","TRANSCRIPT_LIVE_REGION_SUGGESTED_ACTIONS_LABEL_ALT":"メッセージに推奨されるアクションがあります。Shift + Tab を 2 ～ 3 回押して選択します。","TRANSCRIPT_LIVE_REGION_SUGGESTED_ACTIONS_WITH_ACCESS_KEY_LABEL_ALT":"メッセージに推奨されるアクションがあります。$1 を押して選択します。","TRANSCRIPT_LIVE_REGION_SEND_FAILED_ALT":"メッセージを送信できませんでした。","TRANSCRIPT_MORE_MESSAGES":"その他のメッセージ","TRANSCRIPT_NEW_MESSAGES":"新しいメッセージ","TRANSCRIPT_TERMINATOR_TEXT":"チャット履歴の終了","TYPING_INDICATOR_ALT":"入力インジケーターを表示しています","TYPING_INDICATOR_SINGLE_TEXT":"$1 が入力しています。","TYPING_INDICATOR_MULTIPLE_TEXT":"$1 と他のユーザーが入力しています。"}');

});

parcelRequire.register("1x8UP", function(module, exports) {
module.exports = JSON.parse('{"_comment":"[CI-LOCKED] Бұл файлдың мазмұны құлыпталған. Жарналар қабылданады, бірақ өзгертулерді тексеру кейінге қалдырылуы мүмкін.","ACCESS_KEY_ALT":"Alt Shift $1","ACCESS_KEY_FOR_MAC_ALT":"Control Option $1","ACTIVITY_BOT_SAID_ALT":"$1 боттың айтуы бойынша:","ACTIVITY_YOU_SAID_ALT":"Сіздің айтуы бойынша:","ACTIVITY_BOT_ATTACHED_ALT":"Бекітілген бот:","ACTIVITY_ERROR_BOX_TITLE":"Қате туралы хабар","ACTIVITY_INTERACTIVE_FOOTNOTE_ALT":"Өзара әрекеттесу үшін басыңыз.","ACTIVITY_INTERACTIVE_REASON_INTERACTIVE_CONTENT_ALT":"Хабар интерактивті.","ACTIVITY_INTERACTIVE_REASON_LINK_ALT":"Хабардағы бір немесе бірнеше сілтеме.","ACTIVITY_INTERACTIVE_REASON_SEND_FAILED_ALT":"Жіберілмеді.","ACTIVITY_YOU_ATTACHED_ALT":"Сіз бекіттіңіз:","ACTIVITY_NUM_ATTACHMENTS_ONE_ALT":"1 тіркеме.","ACTIVITY_NUM_ATTACHMENTS_FEW_ALT":"$1 тіркемелері.","ACTIVITY_NUM_ATTACHMENTS_MANY_ALT":"$1 тіркемелері.","ACTIVITY_NUM_ATTACHMENTS_OTHER_ALT":"$1 тіркемелері.","ACTIVITY_NUM_ATTACHMENTS_TWO_ALT":"$1 тіркемелері.","ACTIVITY_STATUS_SEND_FAILED_RETRY":"Жіберу сәтсіз аяқталды. (Қайталау][RETRY].","ACTIVITY_STATUS_SEND_STATUS_ALT_SENDING":"Жіберілуде","ACTIVITY_STATUS_SEND_STATUS_ALT_SENT_AT":"Сағат $1 жіберілген","ACTIVITY_STATUS_TIMESTAMP_JUST_NOW":"Дәл қазір","ACTIVITY_STATUS_TIMESTAMP_ONE_HOUR_AGO":"1 сағат бұрын","ACTIVITY_STATUS_TIMESTAMP_ONE_MINUTE_AGO":"1 минут бұрын","ACTIVITY_STATUS_TIMESTAMP_TODAY":"Бүгін","ACTIVITY_STATUS_TIMESTAMP_YESTERDAY":"Кеше","ADAPTIVE_CARD_ERROR_BOX_TITLE_PARSE":"Бейімделгіш картаны талдау қатесі","ADAPTIVE_CARD_ERROR_BOX_TITLE_RENDER":"Бейімделгіш картаны көрсету қатесі","ATTACHMENT_AUDIO":"Дыбысклип.","ATTACHMENT_CARD":"Карта: $1 $2 $3","ATTACHMENT_FILE":"Файл: $1","ATTACHMENT_IMAGE":"Кескін","ATTACHMENT_TEXT":"Мәтін: $1","ATTACHMENT_VIDEO":"Бейнеклип","CAROUSEL_FLIPPER_LEFT_ALT":"Сол жақ","CAROUSEL_FLIPPER_RIGHT_ALT":"Оң жақ","CONNECTIVITY_STATUS_ALT_CONNECTED":"Қосылған","CONNECTIVITY_STATUS_ALT_CONNECTING":"Қосылуда...","CONNECTIVITY_STATUS_ALT_FATAL":"Қосу мүмкін емес.","CONNECTIVITY_STATUS_ALT_RECONNECTING":"Желі жұмысында іркіліс болды. Қайта қосылуда…","CONNECTIVITY_STATUS_ALT_RENDER_ERROR":"Көрсету қатесі. Консольді тексеріңіз немесе бот әзірлеушісімен хабарласыңыз.","CONNECTIVITY_STATUS_ALT_SLOW_CONNECTION":"Қосылу әдеттегіден ұзақ уақыт алуда.","CONNECTIVITY_STATUS_ALT":"Қосылым күйі: $1","FILE_CONTENT_ALT":"\xab$1\xbb","FILE_CONTENT_DOWNLOADABLE_ALT":"$1 файлын жүктеп алу","FILE_CONTENT_DOWNLOADABLE_WITH_SIZE_ALT":"$2 өлшемді $1 файлын жүктеу","FILE_CONTENT_WITH_SIZE_ALT":"$2 өлшемді $1","KEYBOARD_HELP_CHAT_HISTORY_ACCESS_ITEMS_IN_MESSAGE_BODY":"Enter пернесі","KEYBOARD_HELP_CHAT_HISTORY_ACCESS_ITEMS_IN_MESSAGE_HEADER":"Хабарламадағы элементтерге қол жеткізу","KEYBOARD_HELP_CHAT_HISTORY_HEADER":"Сөйлесу журналы","KEYBOARD_HELP_CHAT_HISTORY_LEAVE_MESSAGE_BODY":"Escape пернесі","KEYBOARD_HELP_CHAT_HISTORY_LEAVE_MESSAGE_HEADER":"Хабардан шығу","KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_ITEMS_BODY":"Tab пернесі\\nShift + tab пернесі","KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_ITEMS_HEADER":"Хабарламадағы элементтер арасында жылжу","KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_MESSAGES_BODY":"Жоғары көрсеткі пернесі\\nТөмен көрсеткі пернесі","KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_MESSAGES_HEADER":"Хабарламалар арасында жылжу","KEYBOARD_HELP_CHAT_WINDOW_BODY_DO_ACTION_BODY":"Enter пернесі","KEYBOARD_HELP_CHAT_WINDOW_BODY_DO_ACTION_HEADER":"Әрекет жасау","KEYBOARD_HELP_CHAT_WINDOW_BODY_MOVE_BETWEEN_ITEMS_BODY":"Tab пернесі\\nShift + tab пернесі","KEYBOARD_HELP_CHAT_WINDOW_BODY_MOVE_BETWEEN_ITEMS_HEADER":"Сөйлесу терезесіндегі элементтер арасында жылжу","KEYBOARD_HELP_CHAT_WINDOW_HEADER":"Сөйлесу терезесі","KEYBOARD_HELP_CLOSE_BUTTON_ALT":"Жабу","KEYBOARD_HELP_HEADER":"Пернетақтаның басқару элементтері","MARKDOWN_EXTERNAL_LINK_ALT":"Жаңа терезеде ашады; сыртқы.","RECEIPT_CARD_TAX":"Салық","RECEIPT_CARD_TOTAL":"Барлығы","RECEIPT_CARD_VAT":"VAT","SEND_BOX_IS_EMPTY_TOOLTIP_ALT":"Бос хабар жіберу мүмкін емес.","SPEECH_INPUT_LISTENING":"Тыңдалуда...","SPEECH_INPUT_MICROPHONE_BUTTON_CLOSE_ALT":"Микрофон өшірулі","SPEECH_INPUT_MICROPHONE_BUTTON_OPEN_ALT":"Микрофон","SPEECH_INPUT_STARTING":"Басталуда...","SUGGESTED_ACTIONS_LABEL_ALT":"Ұсынылған әрекеттер","TEXT_INPUT_ALT":"Хабарды енгізу өрісі","TEXT_INPUT_PLACEHOLDER":"Хабарды теріңіз","TEXT_INPUT_SEND_BUTTON_ALT":"Жіберу","TEXT_INPUT_SPEAK_BUTTON_ALT":"Сөйлеу","TEXT_INPUT_UPLOAD_BUTTON_ALT":"Файлды кері жүктеу","TOAST_ACCORDION_FEW":"$1 Хабарландырулар: мәліметтерді көру үшін осы жерді басыңыз","TOAST_ACCORDION_MANY":"$1 Хабарландырулар: мәліметтерді көру үшін осы жерді басыңыз","TOAST_ACCORDION_OTHER":"$1 Хабарландырулар: мәліметтерді көру үшін осы жерді басыңыз","TOAST_ACCORDION_TWO":"$1 Хабарландырулар: мәліметтерді көру үшін осы жерді басыңыз","TOAST_ALT_ERROR":"Қате","TOAST_ALT_INFO":"Ақпарат","TOAST_ALT_SUCCESS":"Сәтті орындалды","TOAST_ALT_WARN":"Ескерту","TOAST_DISMISS_BUTTON":"Жою","TOAST_TITLE_ALT":"Хабарландыру","TRANSCRIPT_ARIA_LABEL_ALT":"Сөйлесу журналы, шарлау үшін көрсеткі пернелерін басыңыз.","TRANSCRIPT_ARIA_ROLE_ALT":"сөйлесу журналы","TRANSCRIPT_LIVE_REGION_INTERACTIVE_LABEL_ALT":"Хабарлама интерактивті. Сөйлесу журналына ауысу үшін shift tab пернесін 2-3 рет басыңыз. Одан кейін өзара әрекеттесу үшін хабарламаны басыңыз.","TRANSCRIPT_LIVE_REGION_INTERACTIVE_WITH_LINKS_LABEL_ALT":"Хабарламадағы бір немесе бірнеше сілтеме. Сөйлесу журналына ауысу үшін shift tab пернесін 2-3 рет басыңыз. Одан кейін өзара әрекеттесу үшін хабарламаны басыңыз.","TRANSCRIPT_LIVE_REGION_SUGGESTED_ACTIONS_LABEL_ALT":"Хабарда ұсынылған әрекеттер бар. Оларды таңдау үшін Shift және Tab пернелерін 2-3 рет басыңыз.","TRANSCRIPT_LIVE_REGION_SUGGESTED_ACTIONS_WITH_ACCESS_KEY_LABEL_ALT":"Хабарда ұсынылған әрекеттер бар. Оларды таңдау үшін $1 пернесін басыңыз.","TRANSCRIPT_LIVE_REGION_SEND_FAILED_ALT":"Хабар жіберілмеді.","TRANSCRIPT_MORE_MESSAGES":"Қосымша хабарлар","TRANSCRIPT_NEW_MESSAGES":"Жаңа хабарлар","TRANSCRIPT_TERMINATOR_TEXT":"Сөйлесу журналының соңы","TYPING_INDICATOR_ALT":"Мәтін теру индикаторын көрсету","TYPING_INDICATOR_SINGLE_TEXT":"$1 теруде.","TYPING_INDICATOR_MULTIPLE_TEXT":"$1 және басқалар теруде."}');

});

parcelRequire.register("9kaYl", function(module, exports) {
module.exports = JSON.parse('{"_comment":"[CI-LOCKED] 이 파일의 내용이 잠겼습니다. 기여를 환영하지만 변경 유효성 검사가 지연될 수 있습니다.","ACCESS_KEY_ALT":"Alt Shift $1","ACCESS_KEY_FOR_MAC_ALT":"Control Option $1","ACTIVITY_BOT_SAID_ALT":"봇 $1의 말:","ACTIVITY_YOU_SAID_ALT":"나의 말:","ACTIVITY_BOT_ATTACHED_ALT":"봇이 첨부함:","ACTIVITY_ERROR_BOX_TITLE":"오류 메시지","ACTIVITY_INTERACTIVE_FOOTNOTE_ALT":"상호 작용하려면 클릭하세요.","ACTIVITY_INTERACTIVE_REASON_INTERACTIVE_CONTENT_ALT":"대화형 메시지입니다.","ACTIVITY_INTERACTIVE_REASON_LINK_ALT":"메시지에 링크가 하나 이상 있습니다.","ACTIVITY_INTERACTIVE_REASON_SEND_FAILED_ALT":"전송 실패.","ACTIVITY_YOU_ATTACHED_ALT":"내가 첨부함:","ACTIVITY_NUM_ATTACHMENTS_ONE_ALT":"첨부 파일 1개.","ACTIVITY_NUM_ATTACHMENTS_FEW_ALT":"첨부 파일 $1개.","ACTIVITY_NUM_ATTACHMENTS_MANY_ALT":"첨부 파일 $1개.","ACTIVITY_NUM_ATTACHMENTS_OTHER_ALT":"첨부 파일 $1개.","ACTIVITY_NUM_ATTACHMENTS_TWO_ALT":"첨부 파일 $1개.","ACTIVITY_STATUS_SEND_FAILED_RETRY":"보내기 실패. [다시 시도][RETRY].","ACTIVITY_STATUS_SEND_STATUS_ALT_SENDING":"보내는 중","ACTIVITY_STATUS_SEND_STATUS_ALT_SENT_AT":"$1에 보냄","ACTIVITY_STATUS_TIMESTAMP_JUST_NOW":"방금","ACTIVITY_STATUS_TIMESTAMP_ONE_HOUR_AGO":"1시간 전","ACTIVITY_STATUS_TIMESTAMP_ONE_MINUTE_AGO":"1분 전","ACTIVITY_STATUS_TIMESTAMP_TODAY":"오늘","ACTIVITY_STATUS_TIMESTAMP_YESTERDAY":"어제","ADAPTIVE_CARD_ERROR_BOX_TITLE_PARSE":"적응형 카드 구문 분석 오류","ADAPTIVE_CARD_ERROR_BOX_TITLE_RENDER":"적응형 카드 렌더링 오류","ATTACHMENT_AUDIO":"오디오 클립입니다.","ATTACHMENT_CARD":"카드: $1 $2 $3","ATTACHMENT_FILE":"파일: $1","ATTACHMENT_IMAGE":"이미지","ATTACHMENT_TEXT":"텍스트: $1","ATTACHMENT_VIDEO":"비디오 클립","CAROUSEL_FLIPPER_LEFT_ALT":"왼쪽","CAROUSEL_FLIPPER_RIGHT_ALT":"오른쪽","CONNECTIVITY_STATUS_ALT_CONNECTED":"연결됨","CONNECTIVITY_STATUS_ALT_CONNECTING":"연결 중…","CONNECTIVITY_STATUS_ALT_FATAL":"연결할 수 없습니다.","CONNECTIVITY_STATUS_ALT_RECONNECTING":"네트워크 중단이 발생했습니다. 다시 연결하는 중입니다...","CONNECTIVITY_STATUS_ALT_RENDER_ERROR":"렌더링 오류입니다. 콘솔을 확인하거나 봇 개발자에게 문의하십시오.","CONNECTIVITY_STATUS_ALT_SLOW_CONNECTION":"연결하는 데 평소보다 오래 걸립니다.","CONNECTIVITY_STATUS_ALT":"연결 상태: $1","FILE_CONTENT_ALT":"\'$1\'","FILE_CONTENT_DOWNLOADABLE_ALT":"\'$1\' 파일 다운로드","FILE_CONTENT_DOWNLOADABLE_WITH_SIZE_ALT":"$2 크기의 다운로드 파일 \'$1\'","FILE_CONTENT_WITH_SIZE_ALT":"$2 크기의 \'$1\'","KEYBOARD_HELP_CHAT_HISTORY_ACCESS_ITEMS_IN_MESSAGE_BODY":"Enter 키","KEYBOARD_HELP_CHAT_HISTORY_ACCESS_ITEMS_IN_MESSAGE_HEADER":"메시지 내 항목 액세스","KEYBOARD_HELP_CHAT_HISTORY_HEADER":"채팅 기록","KEYBOARD_HELP_CHAT_HISTORY_LEAVE_MESSAGE_BODY":"ESC 키","KEYBOARD_HELP_CHAT_HISTORY_LEAVE_MESSAGE_HEADER":"메시지 나가기","KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_ITEMS_BODY":"Tab 키\\nShift + Tab 키","KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_ITEMS_HEADER":"메시지 내 항목 사이 이동","KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_MESSAGES_BODY":"위쪽 화살표 키\\n아래쪽 화살표 키","KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_MESSAGES_HEADER":"메시지 사이 이동","KEYBOARD_HELP_CHAT_WINDOW_BODY_DO_ACTION_BODY":"Enter 키","KEYBOARD_HELP_CHAT_WINDOW_BODY_DO_ACTION_HEADER":"작업 수행","KEYBOARD_HELP_CHAT_WINDOW_BODY_MOVE_BETWEEN_ITEMS_BODY":"Tab 키\\nShift + Tab 키","KEYBOARD_HELP_CHAT_WINDOW_BODY_MOVE_BETWEEN_ITEMS_HEADER":"채팅 창에서 항목 사이 이동","KEYBOARD_HELP_CHAT_WINDOW_HEADER":"채팅 창","KEYBOARD_HELP_CLOSE_BUTTON_ALT":"닫기","KEYBOARD_HELP_HEADER":"키보드 컨트롤","MARKDOWN_EXTERNAL_LINK_ALT":"새 창으로 엽니다. 외부.","RECEIPT_CARD_TAX":"세금","RECEIPT_CARD_TOTAL":"합계","RECEIPT_CARD_VAT":"VAT","SEND_BOX_IS_EMPTY_TOOLTIP_ALT":"빈 메시지는 보낼 수 없습니다.","SPEECH_INPUT_LISTENING":"듣는 중...","SPEECH_INPUT_MICROPHONE_BUTTON_CLOSE_ALT":"마이크 끄기","SPEECH_INPUT_MICROPHONE_BUTTON_OPEN_ALT":"마이크 켜기","SPEECH_INPUT_STARTING":"시작하는 중…","SUGGESTED_ACTIONS_LABEL_ALT":"제안된 작업","TEXT_INPUT_ALT":"메시지 입력 상자","TEXT_INPUT_PLACEHOLDER":"메시지 입력","TEXT_INPUT_SEND_BUTTON_ALT":"보내기","TEXT_INPUT_SPEAK_BUTTON_ALT":"말하기","TEXT_INPUT_UPLOAD_BUTTON_ALT":"파일 업로드","TOAST_ACCORDION_FEW":"$1개 알림: 자세한 내용을 보려면 여기를 클릭하십시오.","TOAST_ACCORDION_MANY":"$1개 알림: 자세한 내용을 보려면 여기를 클릭하십시오.","TOAST_ACCORDION_OTHER":"$1개 알림: 자세한 내용을 보려면 여기를 클릭하십시오.","TOAST_ACCORDION_TWO":"$1개 알림: 자세한 내용을 보려면 여기를 클릭하십시오.","TOAST_ALT_ERROR":"오류","TOAST_ALT_INFO":"정보","TOAST_ALT_SUCCESS":"성공","TOAST_ALT_WARN":"경고","TOAST_DISMISS_BUTTON":"해제","TOAST_TITLE_ALT":"알림","TRANSCRIPT_ARIA_LABEL_ALT":"채팅 기록, 아래쪽 화살표 키를 사용하여 탐색합니다.","TRANSCRIPT_ARIA_ROLE_ALT":"채팅 기록","TRANSCRIPT_LIVE_REGION_INTERACTIVE_LABEL_ALT":"메시지가 대화형입니다. 채팅 기록으로 전환하기 위해 Shift Tab 키를 2~3회 누르세요. 그런 다음 상호 작용할 메시지를 클릭하세요.","TRANSCRIPT_LIVE_REGION_INTERACTIVE_WITH_LINKS_LABEL_ALT":"메시지에 링크가 하나 이상 있습니다. 채팅 기록으로 전환하기 위해 Shift Tab 키를 2~3회 누르세요. 그런 다음 상호 작용할 메시지를 클릭하세요.","TRANSCRIPT_LIVE_REGION_SUGGESTED_ACTIONS_LABEL_ALT":"메시지가 작업을 제안했습니다. 선택하려면 Shift 탭을 2~3번 누르세요.","TRANSCRIPT_LIVE_REGION_SUGGESTED_ACTIONS_WITH_ACCESS_KEY_LABEL_ALT":"메시지가 작업을 제안했습니다. 선택하려면 $1을 누르세요.","TRANSCRIPT_LIVE_REGION_SEND_FAILED_ALT":"메시지를 보내지 못했습니다.","TRANSCRIPT_MORE_MESSAGES":"추가 메시지","TRANSCRIPT_NEW_MESSAGES":"새 메시지","TRANSCRIPT_TERMINATOR_TEXT":"채팅 기록의 끝 부분","TYPING_INDICATOR_ALT":"입력 표시기 표시","TYPING_INDICATOR_SINGLE_TEXT":"$1님이 입력 중입니다.","TYPING_INDICATOR_MULTIPLE_TEXT":"$1님과 다른 사용자가 입력 중입니다."}');

});

parcelRequire.register("60Z0a", function(module, exports) {
module.exports = JSON.parse('{"_comment":"[CI-LOCKED] Šio failo turinys užrakintas. Galite prisidėti, tačiau gali užtrukti, kol keitimai bus patikrinti.","ACCESS_KEY_ALT":"Alt Shift $1","ACCESS_KEY_FOR_MAC_ALT":"Control Option $1","ACTIVITY_BOT_SAID_ALT":"Robotas $1 pasakė:","ACTIVITY_YOU_SAID_ALT":"Pasakėte:","ACTIVITY_BOT_ATTACHED_ALT":"Robotas pridėjo:","ACTIVITY_ERROR_BOX_TITLE":"Klaidos pranešimas","ACTIVITY_INTERACTIVE_FOOTNOTE_ALT":"Spustelėkite norėdami sąveikauti.","ACTIVITY_INTERACTIVE_REASON_INTERACTIVE_CONTENT_ALT":"Pranešimas yra interaktyvus.","ACTIVITY_INTERACTIVE_REASON_LINK_ALT":"Pranešime yra vienas ar keli saitai.","ACTIVITY_INTERACTIVE_REASON_SEND_FAILED_ALT":"Išsiųsti nepavyko.","ACTIVITY_YOU_ATTACHED_ALT":"Pridėjote:","ACTIVITY_NUM_ATTACHMENTS_ONE_ALT":"1 priedą.","ACTIVITY_NUM_ATTACHMENTS_FEW_ALT":"$1 priedus.","ACTIVITY_NUM_ATTACHMENTS_MANY_ALT":"$1 priedų.","ACTIVITY_NUM_ATTACHMENTS_OTHER_ALT":"$1 priedus.","ACTIVITY_NUM_ATTACHMENTS_TWO_ALT":"$1 priedus.","ACTIVITY_STATUS_SEND_FAILED_RETRY":"Nepavyko išsiųsti. [Bandyti dar kartą][RETRY].","ACTIVITY_STATUS_SEND_STATUS_ALT_SENDING":"Siunčiama","ACTIVITY_STATUS_SEND_STATUS_ALT_SENT_AT":"Išsiųsta $1","ACTIVITY_STATUS_TIMESTAMP_JUST_NOW":"Ką tik","ACTIVITY_STATUS_TIMESTAMP_ONE_HOUR_AGO":"Prieš valandą","ACTIVITY_STATUS_TIMESTAMP_ONE_MINUTE_AGO":"Prieš minutę","ACTIVITY_STATUS_TIMESTAMP_TODAY":"Šiandien","ACTIVITY_STATUS_TIMESTAMP_YESTERDAY":"Vakar","ADAPTIVE_CARD_ERROR_BOX_TITLE_PARSE":"Adaptyviosios kortelės analizės klaida","ADAPTIVE_CARD_ERROR_BOX_TITLE_RENDER":"Adaptyviosios kortelės atvaizdavimo klaida","ATTACHMENT_AUDIO":"Garso įrašas.","ATTACHMENT_CARD":"Kortelė: $1 $2 $3","ATTACHMENT_FILE":"Failas: $1","ATTACHMENT_IMAGE":"Vaizdas","ATTACHMENT_TEXT":"Teksto žinutė: $1","ATTACHMENT_VIDEO":"Vaizdo įrašas","CAROUSEL_FLIPPER_LEFT_ALT":"Kairė","CAROUSEL_FLIPPER_RIGHT_ALT":"Dešinė","CONNECTIVITY_STATUS_ALT_CONNECTED":"Prijungta","CONNECTIVITY_STATUS_ALT_CONNECTING":"Jungiamasi…","CONNECTIVITY_STATUS_ALT_FATAL":"Nepavyko prijungti.","CONNECTIVITY_STATUS_ALT_RECONNECTING":"Nutrūko tinklo ryšys. Jungiamasi iš naujo...","CONNECTIVITY_STATUS_ALT_RENDER_ERROR":"Atvaizdavimo klaida. Patikrinkite konsolę arba kreipkitės į roboto kūrėją.","CONNECTIVITY_STATUS_ALT_SLOW_CONNECTION":"Prisijungimas trunka ilgiau nei įprasta.","CONNECTIVITY_STATUS_ALT":"Ryšio būsena: $1","FILE_CONTENT_ALT":"$1","FILE_CONTENT_DOWNLOADABLE_ALT":"Atsisiųsti failą $1","FILE_CONTENT_DOWNLOADABLE_WITH_SIZE_ALT":"Atsisiųsti failą $1, kurio dydis $2","FILE_CONTENT_WITH_SIZE_ALT":"$1, kurio dydis $2","KEYBOARD_HELP_CHAT_HISTORY_ACCESS_ITEMS_IN_MESSAGE_BODY":"Klavišas „Enter“","KEYBOARD_HELP_CHAT_HISTORY_ACCESS_ITEMS_IN_MESSAGE_HEADER":"Pasiekti pranešimo elementus","KEYBOARD_HELP_CHAT_HISTORY_HEADER":"Pokalbio retrospektyva","KEYBOARD_HELP_CHAT_HISTORY_LEAVE_MESSAGE_BODY":"Klavišas „Escape“","KEYBOARD_HELP_CHAT_HISTORY_LEAVE_MESSAGE_HEADER":"Išeiti iš pranešimo","KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_ITEMS_BODY":"Tabuliavimo klavišas\\n„Shift“ ir tabuliavimo klavišas","KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_ITEMS_HEADER":"Judėti tarp pranešimo elementų","KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_MESSAGES_BODY":"Rodyklės aukštyn klavišas\\nRodyklės žemyn klavišas","KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_MESSAGES_HEADER":"Judėti tarp pranešimų","KEYBOARD_HELP_CHAT_WINDOW_BODY_DO_ACTION_BODY":"Klavišas „Enter“","KEYBOARD_HELP_CHAT_WINDOW_BODY_DO_ACTION_HEADER":"Atlikti veiksmą","KEYBOARD_HELP_CHAT_WINDOW_BODY_MOVE_BETWEEN_ITEMS_BODY":"Tabuliavimo klavišas\\n„Shift“ ir tabuliavimo klavišas","KEYBOARD_HELP_CHAT_WINDOW_BODY_MOVE_BETWEEN_ITEMS_HEADER":"Judėti tarp pokalbio lango elementų","KEYBOARD_HELP_CHAT_WINDOW_HEADER":"Pokalbio langas","KEYBOARD_HELP_CLOSE_BUTTON_ALT":"Uždaryti","KEYBOARD_HELP_HEADER":"Klaviatūros valdikliai","MARKDOWN_EXTERNAL_LINK_ALT":"Atidaroma naujame lange; išorinis.","RECEIPT_CARD_TAX":"Mokestis","RECEIPT_CARD_TOTAL":"Iš viso","RECEIPT_CARD_VAT":"PVM","SEND_BOX_IS_EMPTY_TOOLTIP_ALT":"Negali siųsti tuščio pranešimo.","SPEECH_INPUT_LISTENING":"Klausomasi…","SPEECH_INPUT_MICROPHONE_BUTTON_CLOSE_ALT":"Mikrofonas išjungtas","SPEECH_INPUT_MICROPHONE_BUTTON_OPEN_ALT":"Mikrofonas įjungtas","SPEECH_INPUT_STARTING":"Pradedama…","SUGGESTED_ACTIONS_LABEL_ALT":"Siūlomi veiksmai","TEXT_INPUT_ALT":"Pranešimo įvedimo laukas","TEXT_INPUT_PLACEHOLDER":"Įveskite savo pranešimą","TEXT_INPUT_SEND_BUTTON_ALT":"Siųsti","TEXT_INPUT_SPEAK_BUTTON_ALT":"Kalbėti","TEXT_INPUT_UPLOAD_BUTTON_ALT":"Nusiųsti failą","TOAST_ACCORDION_FEW":"Pranešimų: $1. Spustelėkite čia, kad pamatytumėte išsamesnę informaciją","TOAST_ACCORDION_MANY":"Pranešimų: $1. Spustelėkite čia, kad pamatytumėte išsamesnę informaciją","TOAST_ACCORDION_OTHER":"Pranešimų: $1. Spustelėkite čia, kad pamatytumėte išsamesnę informaciją","TOAST_ACCORDION_TWO":"Pranešimų: $1. Spustelėkite čia, kad pamatytumėte išsamesnę informaciją","TOAST_ALT_ERROR":"Klaida","TOAST_ALT_INFO":"Informacija","TOAST_ALT_SUCCESS":"Sėkmingai","TOAST_ALT_WARN":"Įspėjimas","TOAST_DISMISS_BUTTON":"Išjungti","TOAST_TITLE_ALT":"Pranešimas","TRANSCRIPT_ARIA_LABEL_ALT":"Pokalbio retrospektyva, naršykite naudodami rodyklių klavišus.","TRANSCRIPT_ARIA_ROLE_ALT":"pokalbio retrospektyva","TRANSCRIPT_LIVE_REGION_INTERACTIVE_LABEL_ALT":"Pranešimas yra interaktyvus. Norėdami perjungti į pokalbio retrospektyvą, 2–3 kartus paspauskite klavišą „Shift“ ir tabuliavimo klavišą. Tada spustelėkite pranešimą, kad sąveikautumėte.","TRANSCRIPT_LIVE_REGION_INTERACTIVE_WITH_LINKS_LABEL_ALT":"Pranešime yra vienas ar keli saitai. Norėdami perjungti į pokalbio retrospektyvą, 2–3 kartus paspauskite klavišą „Shift“ ir tabuliavimo klavišą. Tada spustelėkite pranešimą, kad sąveikautumėte.","TRANSCRIPT_LIVE_REGION_SUGGESTED_ACTIONS_LABEL_ALT":"Pranešime siūlomi veiksmai. Norėdami juos pasirinkti, 2–3 kartus paspauskite klavišą „Shift“.","TRANSCRIPT_LIVE_REGION_SUGGESTED_ACTIONS_WITH_ACCESS_KEY_LABEL_ALT":"Pranešime siūlomi veiksmai. Norėdami juos pasirinkti, paspauskite klavišą $1.","TRANSCRIPT_LIVE_REGION_SEND_FAILED_ALT":"Nepavyko išsiųsti pranešimo.","TRANSCRIPT_MORE_MESSAGES":"Daugiau pranešimų","TRANSCRIPT_NEW_MESSAGES":"Nauji pranešimai","TRANSCRIPT_TERMINATOR_TEXT":"Pokalbio retrospektyvos pabaiga","TYPING_INDICATOR_ALT":"Rodomas teksto įvedimo indikatorius","TYPING_INDICATOR_SINGLE_TEXT":"$1 rašo.","TYPING_INDICATOR_MULTIPLE_TEXT":"Rašo $1 ir kiti."}');

});

parcelRequire.register("6OVKM", function(module, exports) {
module.exports = JSON.parse('{"_comment":"[CI-LOCKED] Šī faila saturs ir bloķēts. Ieguldījumi tiek gaidīti, taču izmaiņu validācija var tikt aizkavēta.","ACCESS_KEY_ALT":"Alt Shift $1","ACCESS_KEY_FOR_MAC_ALT":"Control Option $1","ACTIVITY_BOT_SAID_ALT":"Robots $1 teica:","ACTIVITY_YOU_SAID_ALT":"Jūs teicāt:","ACTIVITY_BOT_ATTACHED_ALT":"Robots pievienots:","ACTIVITY_ERROR_BOX_TITLE":"Kļūdas ziņojums","ACTIVITY_INTERACTIVE_FOOTNOTE_ALT":"Noklikšķiniet, lai mijiedarbotos.","ACTIVITY_INTERACTIVE_REASON_INTERACTIVE_CONTENT_ALT":"Ziņojums ir interaktīvs.","ACTIVITY_INTERACTIVE_REASON_LINK_ALT":"Ziņojumā ir viena vai vairākas saites.","ACTIVITY_INTERACTIVE_REASON_SEND_FAILED_ALT":"Nosūtīšana neizdevās.","ACTIVITY_YOU_ATTACHED_ALT":"Jūs pievienojāt:","ACTIVITY_NUM_ATTACHMENTS_ONE_ALT":"1\xa0pielikums.","ACTIVITY_NUM_ATTACHMENTS_FEW_ALT":"$1\xa0pielikumi.","ACTIVITY_NUM_ATTACHMENTS_MANY_ALT":"$1\xa0pielikumi.","ACTIVITY_NUM_ATTACHMENTS_OTHER_ALT":"$1\xa0pielikumi.","ACTIVITY_NUM_ATTACHMENTS_TWO_ALT":"$1\xa0pielikumi.","ACTIVITY_STATUS_SEND_FAILED_RETRY":"Neizdevās nosūtīt. [Mēģināt vēlreiz][RETRY].","ACTIVITY_STATUS_SEND_STATUS_ALT_SENDING":"Notiek sūtīšana","ACTIVITY_STATUS_SEND_STATUS_ALT_SENT_AT":"Nosūtīts plkst.\xa0$1","ACTIVITY_STATUS_TIMESTAMP_JUST_NOW":"Tikko","ACTIVITY_STATUS_TIMESTAMP_ONE_HOUR_AGO":"Pirms stundas","ACTIVITY_STATUS_TIMESTAMP_ONE_MINUTE_AGO":"Pirms minūtes","ACTIVITY_STATUS_TIMESTAMP_TODAY":"Šodien","ACTIVITY_STATUS_TIMESTAMP_YESTERDAY":"Vakardien","ADAPTIVE_CARD_ERROR_BOX_TITLE_PARSE":"Adaptīvās kartītes parsēšanas kļūda","ADAPTIVE_CARD_ERROR_BOX_TITLE_RENDER":"Adaptīvās kartītes atveides kļūda","ATTACHMENT_AUDIO":"Audioklips.","ATTACHMENT_CARD":"Kartīte: $1 $2 $3","ATTACHMENT_FILE":"Fails: $1","ATTACHMENT_IMAGE":"Attēls","ATTACHMENT_TEXT":"Teksts: $1","ATTACHMENT_VIDEO":"Videoklips","CAROUSEL_FLIPPER_LEFT_ALT":"Pa kreisi","CAROUSEL_FLIPPER_RIGHT_ALT":"Pa labi","CONNECTIVITY_STATUS_ALT_CONNECTED":"Izveidots savienojums","CONNECTIVITY_STATUS_ALT_CONNECTING":"Notiek savienojuma izveide…","CONNECTIVITY_STATUS_ALT_FATAL":"Nevar izveidot savienojumu.","CONNECTIVITY_STATUS_ALT_RECONNECTING":"Radās tīkla darbības pārtraukums. Notiek atkārtota savienojuma izveide…","CONNECTIVITY_STATUS_ALT_RENDER_ERROR":"Atveides kļūda. Lūdzu, pārbaudiet konsoli vai sazinieties ar robota izstrādātāju.","CONNECTIVITY_STATUS_ALT_SLOW_CONNECTION":"Savienojuma izveide notiek ilgāk nekā parasti.","CONNECTIVITY_STATUS_ALT":"Savienojuma statuss. $1","FILE_CONTENT_ALT":"“$1”","FILE_CONTENT_DOWNLOADABLE_ALT":"Lejupielādēt failu “$1”","FILE_CONTENT_DOWNLOADABLE_WITH_SIZE_ALT":"Lejupielādēt failu “$1”, kura lielums ir $2","FILE_CONTENT_WITH_SIZE_ALT":"“$1”, kura lielums ir $2","KEYBOARD_HELP_CHAT_HISTORY_ACCESS_ITEMS_IN_MESSAGE_BODY":"Taustiņš Enter","KEYBOARD_HELP_CHAT_HISTORY_ACCESS_ITEMS_IN_MESSAGE_HEADER":"Piekļūstiet ziņojuma elementiem","KEYBOARD_HELP_CHAT_HISTORY_HEADER":"Tērzēšanas vēsture","KEYBOARD_HELP_CHAT_HISTORY_LEAVE_MESSAGE_BODY":"Taustiņš Esc","KEYBOARD_HELP_CHAT_HISTORY_LEAVE_MESSAGE_HEADER":"Iziet no ziņojuma","KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_ITEMS_BODY":"Tabulēšanas taustiņš\\nShift + tabulēšanas taustiņš","KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_ITEMS_HEADER":"Pārvietojieties starp ziņojuma elementiem","KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_MESSAGES_BODY":"Augšupvērstā bultiņa\\nLejupvērstā bultiņa","KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_MESSAGES_HEADER":"Pārvietojieties starp ziņojumiem","KEYBOARD_HELP_CHAT_WINDOW_BODY_DO_ACTION_BODY":"Taustiņš Enter","KEYBOARD_HELP_CHAT_WINDOW_BODY_DO_ACTION_HEADER":"Veiciet darbību","KEYBOARD_HELP_CHAT_WINDOW_BODY_MOVE_BETWEEN_ITEMS_BODY":"Tabulēšanas taustiņš\\nShift + tabulēšanas taustiņš","KEYBOARD_HELP_CHAT_WINDOW_BODY_MOVE_BETWEEN_ITEMS_HEADER":"Pārvietojieties starp elementiem tērzēšanas logā","KEYBOARD_HELP_CHAT_WINDOW_HEADER":"Tērzēšanas logs","KEYBOARD_HELP_CLOSE_BUTTON_ALT":"Aizvērt","KEYBOARD_HELP_HEADER":"Tastatūras vadīklas","MARKDOWN_EXTERNAL_LINK_ALT":"Tiek atvērts jaunā logā (ārējā).","RECEIPT_CARD_TAX":"Nodoklis","RECEIPT_CARD_TOTAL":"Kopā","RECEIPT_CARD_VAT":"PVN","SEND_BOX_IS_EMPTY_TOOLTIP_ALT":"Nevar nosūtīt tukšu ziņojumu.","SPEECH_INPUT_LISTENING":"Notiek klausīšanās…","SPEECH_INPUT_MICROPHONE_BUTTON_CLOSE_ALT":"Izslēgt mikrofonu","SPEECH_INPUT_MICROPHONE_BUTTON_OPEN_ALT":"Ieslēgt mikrofonu","SPEECH_INPUT_STARTING":"Sākas ievade…","SUGGESTED_ACTIONS_LABEL_ALT":"Ieteicamās darbības","TEXT_INPUT_ALT":"Ziņojuma ievades lodziņš","TEXT_INPUT_PLACEHOLDER":"Ierakstiet ziņojumu","TEXT_INPUT_SEND_BUTTON_ALT":"Nosūtīt","TEXT_INPUT_SPEAK_BUTTON_ALT":"Runāt","TEXT_INPUT_UPLOAD_BUTTON_ALT":"Augšupielādēt failu","TOAST_ACCORDION_FEW":"$1 paziņojumi. Noklikšķiniet šeit, lai skatītu detalizētu informāciju","TOAST_ACCORDION_MANY":"$1 paziņojumi. Noklikšķiniet šeit, lai skatītu detalizētu informāciju","TOAST_ACCORDION_OTHER":"$1 paziņojumi. Noklikšķiniet šeit, lai skatītu detalizētu informāciju","TOAST_ACCORDION_TWO":"$1 paziņojumi. Noklikšķiniet šeit, lai skatītu detalizētu informāciju","TOAST_ALT_ERROR":"Kļūda","TOAST_ALT_INFO":"Informācija","TOAST_ALT_SUCCESS":"Veiksmīgi","TOAST_ALT_WARN":"Brīdinājums","TOAST_DISMISS_BUTTON":"Nerādīt","TOAST_TITLE_ALT":"Paziņojums","TRANSCRIPT_ARIA_LABEL_ALT":"Tērzēšanas vēsture, izmantojiet bulttaustiņus, lai naviģētu.","TRANSCRIPT_ARIA_ROLE_ALT":"tērzēšanas vēsture","TRANSCRIPT_LIVE_REGION_INTERACTIVE_LABEL_ALT":"Ziņojums ir interaktīvs. Nospiediet taustiņu Shift un tabulēšanas taustiņu 2–3 reizes, lai pārslēgtu uz tērzēšanas vēsturi. Pēc tam noklikšķiniet uz ziņojuma, lai veiktu mijiedarbību.","TRANSCRIPT_LIVE_REGION_INTERACTIVE_WITH_LINKS_LABEL_ALT":"Ziņojumā ir viena vai vairākas saites. Nospiediet taustiņu Shift un tabulēšanas taustiņu 2–3 reizes, lai pārslēgtu uz tērzēšanas vēsturi. Pēc tam noklikšķiniet uz ziņojuma, lai veiktu mijiedarbību.","TRANSCRIPT_LIVE_REGION_SUGGESTED_ACTIONS_LABEL_ALT":"Ziņojumam ir ieteicamās darbības. Lai tās atlasītu, 2–3\xa0reizes nospiediet taustiņu kombināciju Shift Tab.","TRANSCRIPT_LIVE_REGION_SUGGESTED_ACTIONS_WITH_ACCESS_KEY_LABEL_ALT":"Ziņojumam ir ieteicamās darbības. Lai tās atlasītu, nospiediet $1.","TRANSCRIPT_LIVE_REGION_SEND_FAILED_ALT":"Neizdevās nosūtīt ziņojumu.","TRANSCRIPT_MORE_MESSAGES":"Vairāk ziņojumu","TRANSCRIPT_NEW_MESSAGES":"Jauni ziņojumi","TRANSCRIPT_TERMINATOR_TEXT":"Tērzēšanas vēstures beigas","TYPING_INDICATOR_ALT":"Rāda rakstīšanas indikatoru","TYPING_INDICATOR_SINGLE_TEXT":"$1 raksta.","TYPING_INDICATOR_MULTIPLE_TEXT":"$1 un citi raksta."}');

});

parcelRequire.register("emUnE", function(module, exports) {
module.exports = JSON.parse('{"_comment":"[CI-LOCKED] Kandungan fail ini telah dikunci. Sumbangan dialu-alukan, tetapi pengesahan perubahan mungkin ditunda.","ACCESS_KEY_ALT":"Alt Shift $1","ACCESS_KEY_FOR_MAC_ALT":"Control Option $1","ACTIVITY_BOT_SAID_ALT":"Bot $1 berkata:","ACTIVITY_YOU_SAID_ALT":"Anda berkata:","ACTIVITY_BOT_ATTACHED_ALT":"Bot lampirkan:","ACTIVITY_ERROR_BOX_TITLE":"Mesej ralat","ACTIVITY_INTERACTIVE_FOOTNOTE_ALT":"Klik untuk berinteraksi.","ACTIVITY_INTERACTIVE_REASON_INTERACTIVE_CONTENT_ALT":"Mesej adalah interaktif.","ACTIVITY_INTERACTIVE_REASON_LINK_ALT":"Satu atau beberapa pautan dalam mesej.","ACTIVITY_INTERACTIVE_REASON_SEND_FAILED_ALT":"Penghantaran telah gagal.","ACTIVITY_YOU_ATTACHED_ALT":"Anda lampirkan:","ACTIVITY_NUM_ATTACHMENTS_ONE_ALT":"1 lampiran.","ACTIVITY_NUM_ATTACHMENTS_FEW_ALT":"$1 lampiran.","ACTIVITY_NUM_ATTACHMENTS_MANY_ALT":"$1 lampiran.","ACTIVITY_NUM_ATTACHMENTS_OTHER_ALT":"$1 lampiran.","ACTIVITY_NUM_ATTACHMENTS_TWO_ALT":"$1 lampiran.","ACTIVITY_STATUS_SEND_FAILED_RETRY":"Gagal dihantar. [Cuba Semula][RETRY].","ACTIVITY_STATUS_SEND_STATUS_ALT_SENDING":"Menghantar","ACTIVITY_STATUS_SEND_STATUS_ALT_SENT_AT":"Dihantar pada $1","ACTIVITY_STATUS_TIMESTAMP_JUST_NOW":"Sebentar tadi","ACTIVITY_STATUS_TIMESTAMP_ONE_HOUR_AGO":"Sejam yang lalu","ACTIVITY_STATUS_TIMESTAMP_ONE_MINUTE_AGO":"Seminit yang lalu","ACTIVITY_STATUS_TIMESTAMP_TODAY":"Hari Ini","ACTIVITY_STATUS_TIMESTAMP_YESTERDAY":"Semalam","ADAPTIVE_CARD_ERROR_BOX_TITLE_PARSE":"Ralat penguraian Kad Mudah Suai","ADAPTIVE_CARD_ERROR_BOX_TITLE_RENDER":"Ralat pemaparan Kad Mudah Suai","ATTACHMENT_AUDIO":"Klip audio.","ATTACHMENT_CARD":"Kad: $1 $2 $3","ATTACHMENT_FILE":"Fail: $1","ATTACHMENT_IMAGE":"Imej","ATTACHMENT_TEXT":"Teks: $1","ATTACHMENT_VIDEO":"Klip video","CAROUSEL_FLIPPER_LEFT_ALT":"Kiri","CAROUSEL_FLIPPER_RIGHT_ALT":"Kanan","CONNECTIVITY_STATUS_ALT_CONNECTED":"Disambungkan","CONNECTIVITY_STATUS_ALT_CONNECTING":"Bersambung…","CONNECTIVITY_STATUS_ALT_FATAL":"Tidak dapat bersambung.","CONNECTIVITY_STATUS_ALT_RECONNECTING":"Gangguan rangkaian telah berlaku. Bersambung semula…","CONNECTIVITY_STATUS_ALT_RENDER_ERROR":"Ralat telah berlaku. Sila semak konsol atau hubungi pembangun bot.","CONNECTIVITY_STATUS_ALT_SLOW_CONNECTION":"Masa yang lebih lama daripada biasa diambil untuk bersambung.","CONNECTIVITY_STATUS_ALT":"Status Sambungan: $1","FILE_CONTENT_ALT":"\'$1\'","FILE_CONTENT_DOWNLOADABLE_ALT":"Muat turun fail \'$1\'","FILE_CONTENT_DOWNLOADABLE_WITH_SIZE_ALT":"Muat turun fail \'$1\' dengan saiz $2","FILE_CONTENT_WITH_SIZE_ALT":"\'$1\' dengan saiz $2","KEYBOARD_HELP_CHAT_HISTORY_ACCESS_ITEMS_IN_MESSAGE_BODY":"Kekunci enter","KEYBOARD_HELP_CHAT_HISTORY_ACCESS_ITEMS_IN_MESSAGE_HEADER":"Akses item dalam mesej","KEYBOARD_HELP_CHAT_HISTORY_HEADER":"Sejarah sembang","KEYBOARD_HELP_CHAT_HISTORY_LEAVE_MESSAGE_BODY":"Kekunci escape","KEYBOARD_HELP_CHAT_HISTORY_LEAVE_MESSAGE_HEADER":"Mesej keluar","KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_ITEMS_BODY":"Kekunci tab\\nKekunci shift + tab","KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_ITEMS_HEADER":"Gerakkan antara item dalam mesej","KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_MESSAGES_BODY":"Kekunci anak panah atas\\nKekunci anak panah bawah","KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_MESSAGES_HEADER":"Gerakkan antara mesej","KEYBOARD_HELP_CHAT_WINDOW_BODY_DO_ACTION_BODY":"Kekunci enter","KEYBOARD_HELP_CHAT_WINDOW_BODY_DO_ACTION_HEADER":"Lakukan tindakan","KEYBOARD_HELP_CHAT_WINDOW_BODY_MOVE_BETWEEN_ITEMS_BODY":"Kekunci tab\\nKekunci shift + tab","KEYBOARD_HELP_CHAT_WINDOW_BODY_MOVE_BETWEEN_ITEMS_HEADER":"Gerakkan antara item dalam tetingkap sembang","KEYBOARD_HELP_CHAT_WINDOW_HEADER":"Tetingkap sembang","KEYBOARD_HELP_CLOSE_BUTTON_ALT":"Tutup","KEYBOARD_HELP_HEADER":"Kawalan papan kekunci","MARKDOWN_EXTERNAL_LINK_ALT":"Buka dalam tetingkap yang baharu; luaran.","RECEIPT_CARD_TAX":"Cukai","RECEIPT_CARD_TOTAL":"Jumlah","RECEIPT_CARD_VAT":"VAT","SEND_BOX_IS_EMPTY_TOOLTIP_ALT":"Tidak boleh menghantar mesej kosong.","SPEECH_INPUT_LISTENING":"Mendengar…","SPEECH_INPUT_MICROPHONE_BUTTON_CLOSE_ALT":"Mikrofon dimatikan","SPEECH_INPUT_MICROPHONE_BUTTON_OPEN_ALT":"Mikrofon dihidupkan","SPEECH_INPUT_STARTING":"Bermula…","SUGGESTED_ACTIONS_LABEL_ALT":"Tindakan dicadangkan","TEXT_INPUT_ALT":"Kotak input mesej","TEXT_INPUT_PLACEHOLDER":"Taip mesej anda","TEXT_INPUT_SEND_BUTTON_ALT":"Hantar","TEXT_INPUT_SPEAK_BUTTON_ALT":"Cakap","TEXT_INPUT_UPLOAD_BUTTON_ALT":"Muat naik fail","TOAST_ACCORDION_FEW":"$1 Pemberitahuan: Klik di sini untuk melihat butiran","TOAST_ACCORDION_MANY":"$1 Pemberitahuan: Klik di sini untuk melihat butiran","TOAST_ACCORDION_OTHER":"$1 Pemberitahuan: Klik di sini untuk melihat butiran","TOAST_ACCORDION_TWO":"$1 Pemberitahuan: Klik di sini untuk melihat butiran","TOAST_ALT_ERROR":"Ralat","TOAST_ALT_INFO":"Maklumat","TOAST_ALT_SUCCESS":"Berjaya","TOAST_ALT_WARN":"Amaran","TOAST_DISMISS_BUTTON":"Tolak","TOAST_TITLE_ALT":"Pemberitahuan","TRANSCRIPT_ARIA_LABEL_ALT":"Sejarah sembang, tekan kekunci anak panah untuk menavigasi.","TRANSCRIPT_ARIA_ROLE_ALT":"sejarah sembang","TRANSCRIPT_LIVE_REGION_INTERACTIVE_LABEL_ALT":"Mesej adalah interaktif. Tekan kekunci shift tab 2 hingga 3 kali untuk bertukar ke sejarah sembang. Kemudian klik pada mesej untuk berinteraksi.","TRANSCRIPT_LIVE_REGION_INTERACTIVE_WITH_LINKS_LABEL_ALT":"Satu atau lebih pautan dalam mesej. Tekan kekunci shift tab 2 hingga 3 kali untuk bertukar ke sejarah sembang. Kemudian klik pada mesej untuk berinteraksi.","TRANSCRIPT_LIVE_REGION_SUGGESTED_ACTIONS_LABEL_ALT":"Mesej mempunyai tindakan dicadangkan. Tekan shift tab 2 hingga 3 kali untuk memilih tindakan.","TRANSCRIPT_LIVE_REGION_SUGGESTED_ACTIONS_WITH_ACCESS_KEY_LABEL_ALT":"Mesej mempunyai tindakan dicadangkan. Tekan $1 untuk memilih tindakan.","TRANSCRIPT_LIVE_REGION_SEND_FAILED_ALT":"Mesej gagal dihantar.","TRANSCRIPT_MORE_MESSAGES":"Lebih banyak mesej","TRANSCRIPT_NEW_MESSAGES":"Mesej baharu","TRANSCRIPT_TERMINATOR_TEXT":"Tamat sejarah sembang","TYPING_INDICATOR_ALT":"Menunjukkan penunjuk menaip","TYPING_INDICATOR_SINGLE_TEXT":"$1 sedang menaip.","TYPING_INDICATOR_MULTIPLE_TEXT":"$1 dan lain-lain sedang menaip."}');

});

parcelRequire.register("7zhqW", function(module, exports) {
module.exports = JSON.parse('{"_comment":"[CI-LOCKED] Innholdet i denne filen er l\xe5st. Bidrag er velkomne, men validering av endring kan bli forsinket.","ACCESS_KEY_ALT":"Alt Skift $1","ACCESS_KEY_FOR_MAC_ALT":"Kontroll Tilvalg $1","ACTIVITY_BOT_SAID_ALT":"Roboten $1 sa:","ACTIVITY_YOU_SAID_ALT":"Du sa:","ACTIVITY_BOT_ATTACHED_ALT":"Roboten la ved:","ACTIVITY_ERROR_BOX_TITLE":"Feilmelding","ACTIVITY_INTERACTIVE_FOOTNOTE_ALT":"Klikk for \xe5 samhandle.","ACTIVITY_INTERACTIVE_REASON_INTERACTIVE_CONTENT_ALT":"Meldingen er interaktiv.","ACTIVITY_INTERACTIVE_REASON_LINK_ALT":"En eller flere koblinger i meldingen.","ACTIVITY_INTERACTIVE_REASON_SEND_FAILED_ALT":"Sending mislyktes.","ACTIVITY_YOU_ATTACHED_ALT":"Du la ved:","ACTIVITY_NUM_ATTACHMENTS_ONE_ALT":"1 vedlegg.","ACTIVITY_NUM_ATTACHMENTS_FEW_ALT":"$1 vedlegg.","ACTIVITY_NUM_ATTACHMENTS_MANY_ALT":"$1 vedlegg.","ACTIVITY_NUM_ATTACHMENTS_OTHER_ALT":"$1 vedlegg.","ACTIVITY_NUM_ATTACHMENTS_TWO_ALT":"$1 vedlegg.","ACTIVITY_STATUS_SEND_FAILED_RETRY":"Sending mislyktes. [Pr\xf8v p\xe5 nytt][RETRY].","ACTIVITY_STATUS_SEND_STATUS_ALT_SENDING":"Sender","ACTIVITY_STATUS_SEND_STATUS_ALT_SENT_AT":"Sendt klokken $1","ACTIVITY_STATUS_TIMESTAMP_JUST_NOW":"Akkurat n\xe5","ACTIVITY_STATUS_TIMESTAMP_ONE_HOUR_AGO":"For en time siden","ACTIVITY_STATUS_TIMESTAMP_ONE_MINUTE_AGO":"For et minutt siden","ACTIVITY_STATUS_TIMESTAMP_TODAY":"I dag","ACTIVITY_STATUS_TIMESTAMP_YESTERDAY":"I g\xe5r","ADAPTIVE_CARD_ERROR_BOX_TITLE_PARSE":"Feil ved analyse av AdaptiveCard","ADAPTIVE_CARD_ERROR_BOX_TITLE_RENDER":"Feil ved gjengivelse av AdaptiveCard","ATTACHMENT_AUDIO":"Et lydklipp.","ATTACHMENT_CARD":"Et kort: $1 $2 $3","ATTACHMENT_FILE":"En fil: $1","ATTACHMENT_IMAGE":"Et bilde","ATTACHMENT_TEXT":"En tekst: $1","ATTACHMENT_VIDEO":"Et videoklipp","CAROUSEL_FLIPPER_LEFT_ALT":"Venstre","CAROUSEL_FLIPPER_RIGHT_ALT":"Rettigheter","CONNECTIVITY_STATUS_ALT_CONNECTED":"Tilkoblet","CONNECTIVITY_STATUS_ALT_CONNECTING":"Kobler til ...","CONNECTIVITY_STATUS_ALT_FATAL":"Kan ikke koble til.","CONNECTIVITY_STATUS_ALT_RECONNECTING":"Det oppstod et nettverksbrudd. Kobler til p\xe5 nytt ...","CONNECTIVITY_STATUS_ALT_RENDER_ERROR":"Gjengivelsesfeil. Kontroller konsollen eller kontakt robotutvikleren.","CONNECTIVITY_STATUS_ALT_SLOW_CONNECTION":"Tar lengre tid enn vanlig \xe5 koble til.","CONNECTIVITY_STATUS_ALT":"Tilkoblingsstatus: $1","FILE_CONTENT_ALT":"$1","FILE_CONTENT_DOWNLOADABLE_ALT":"Last ned filen $1","FILE_CONTENT_DOWNLOADABLE_WITH_SIZE_ALT":"Last ned filen $1 med st\xf8rrelsen $2","FILE_CONTENT_WITH_SIZE_ALT":"$1 med st\xf8rrelsen $2","KEYBOARD_HELP_CHAT_HISTORY_ACCESS_ITEMS_IN_MESSAGE_BODY":"Enter-tast","KEYBOARD_HELP_CHAT_HISTORY_ACCESS_ITEMS_IN_MESSAGE_HEADER":"F\xe5 tilgang til elementer i meldingen","KEYBOARD_HELP_CHAT_HISTORY_HEADER":"Chattelogg","KEYBOARD_HELP_CHAT_HISTORY_LEAVE_MESSAGE_BODY":"ESC-tast","KEYBOARD_HELP_CHAT_HISTORY_LEAVE_MESSAGE_HEADER":"Lukk melding","KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_ITEMS_BODY":"Tabulatortast\\nSkift + tabulatortast","KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_ITEMS_HEADER":"Flytt mellom elementer i en melding","KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_MESSAGES_BODY":"Pil opp-tast\\nPil ned-tast","KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_MESSAGES_HEADER":"Flytt mellom meldinger","KEYBOARD_HELP_CHAT_WINDOW_BODY_DO_ACTION_BODY":"Enter-tast","KEYBOARD_HELP_CHAT_WINDOW_BODY_DO_ACTION_HEADER":"Utf\xf8r handling","KEYBOARD_HELP_CHAT_WINDOW_BODY_MOVE_BETWEEN_ITEMS_BODY":"Tabulatortast\\nSkift + tabulatortast","KEYBOARD_HELP_CHAT_WINDOW_BODY_MOVE_BETWEEN_ITEMS_HEADER":"Flytt mellom elementer i chatvinduet","KEYBOARD_HELP_CHAT_WINDOW_HEADER":"Chatvindu","KEYBOARD_HELP_CLOSE_BUTTON_ALT":"Lukk","KEYBOARD_HELP_HEADER":"Tastaturkontroller","MARKDOWN_EXTERNAL_LINK_ALT":"\xc5pnes i et nytt vindu, eksternt.","RECEIPT_CARD_TAX":"Avgift","RECEIPT_CARD_TOTAL":"Totalt","RECEIPT_CARD_VAT":"Merverdiavgift","SEND_BOX_IS_EMPTY_TOOLTIP_ALT":"Kan ikke sende tom melding.","SPEECH_INPUT_LISTENING":"Lytter ...","SPEECH_INPUT_MICROPHONE_BUTTON_CLOSE_ALT":"Mikrofon av","SPEECH_INPUT_MICROPHONE_BUTTON_OPEN_ALT":"Mikrofon p\xe5","SPEECH_INPUT_STARTING":"Starter ...","SUGGESTED_ACTIONS_LABEL_ALT":"Foresl\xe5tte handlinger","TEXT_INPUT_ALT":"Meldingsinndataboks","TEXT_INPUT_PLACEHOLDER":"Skriv inn meldingen","TEXT_INPUT_SEND_BUTTON_ALT":"Send","TEXT_INPUT_SPEAK_BUTTON_ALT":"Tal","TEXT_INPUT_UPLOAD_BUTTON_ALT":"Last opp fil","TOAST_ACCORDION_FEW":"$1 varslinger: Klikk her for \xe5 se detaljer","TOAST_ACCORDION_MANY":"$1 varslinger: Klikk her for \xe5 se detaljer","TOAST_ACCORDION_OTHER":"$1 varslinger: Klikk her for \xe5 se detaljer","TOAST_ACCORDION_TWO":"$1 varslinger: Klikk her for \xe5 se detaljer","TOAST_ALT_ERROR":"Feil","TOAST_ALT_INFO":"Informasjon","TOAST_ALT_SUCCESS":"Vellykket","TOAST_ALT_WARN":"Advarsel!","TOAST_DISMISS_BUTTON":"Forkast","TOAST_TITLE_ALT":"Varsling","TRANSCRIPT_ARIA_LABEL_ALT":"Chattelogg, trykk p\xe5 piltastene for \xe5 navigere.","TRANSCRIPT_ARIA_ROLE_ALT":"chattelogg","TRANSCRIPT_LIVE_REGION_INTERACTIVE_LABEL_ALT":"Meldingen er interaktiv. Trykk p\xe5 skift tabulatortasten to til tre ganger for \xe5 bytte til chatteloggen. Deretter klikker du p\xe5 meldingen for \xe5 samhandle.","TRANSCRIPT_LIVE_REGION_INTERACTIVE_WITH_LINKS_LABEL_ALT":"En eller flere koblinger i meldingen. Trykk p\xe5 skift tabulatortasten to til tre ganger for \xe5 bytte til chatteloggen. Deretter klikker du p\xe5 meldingen for \xe5 samhandle.","TRANSCRIPT_LIVE_REGION_SUGGESTED_ACTIONS_LABEL_ALT":"Meldingen har foresl\xe5tte handlinger. Trykk p\xe5 skift tab to til tre ganger for \xe5 velge dem.","TRANSCRIPT_LIVE_REGION_SUGGESTED_ACTIONS_WITH_ACCESS_KEY_LABEL_ALT":"Meldingen har foresl\xe5tte handlinger. Trykk p\xe5 $1 for \xe5 velge dem.","TRANSCRIPT_LIVE_REGION_SEND_FAILED_ALT":"Kan ikke sende meldingen.","TRANSCRIPT_MORE_MESSAGES":"Flere meldinger","TRANSCRIPT_NEW_MESSAGES":"Nye meldinger","TRANSCRIPT_TERMINATOR_TEXT":"Slutten p\xe5 chatteloggen","TYPING_INDICATOR_ALT":"Viser skriveindikatoren","TYPING_INDICATOR_SINGLE_TEXT":"$1 skriver.","TYPING_INDICATOR_MULTIPLE_TEXT":"$1 og andre skriver."}');

});

parcelRequire.register("g3fnr", function(module, exports) {
module.exports = JSON.parse('{"_comment":"[CI-LOCKED] De inhoud van dit bestand is vergrendeld. Bijdragen zijn welkom, maar wijzigingen in de validatie zijn mogelijk vertraagd.","ACCESS_KEY_ALT":"Alt Shift $1","ACCESS_KEY_FOR_MAC_ALT":"Control Option $1","ACTIVITY_BOT_SAID_ALT":"Bot $1 zei:","ACTIVITY_YOU_SAID_ALT":"U zei:","ACTIVITY_BOT_ATTACHED_ALT":"Bot heeft bijgevoegd:","ACTIVITY_ERROR_BOX_TITLE":"Foutbericht","ACTIVITY_INTERACTIVE_FOOTNOTE_ALT":"Klik om te communiceren.","ACTIVITY_INTERACTIVE_REASON_INTERACTIVE_CONTENT_ALT":"Bericht is interactief.","ACTIVITY_INTERACTIVE_REASON_LINK_ALT":"Een of meer koppelingen in het bericht.","ACTIVITY_INTERACTIVE_REASON_SEND_FAILED_ALT":"Verzenden mislukt.","ACTIVITY_YOU_ATTACHED_ALT":"U hebt bijgevoegd:","ACTIVITY_NUM_ATTACHMENTS_ONE_ALT":"1 bijlage.","ACTIVITY_NUM_ATTACHMENTS_FEW_ALT":"$1 bijlagen.","ACTIVITY_NUM_ATTACHMENTS_MANY_ALT":"$1 bijlagen.","ACTIVITY_NUM_ATTACHMENTS_OTHER_ALT":"$1 bijlagen.","ACTIVITY_NUM_ATTACHMENTS_TWO_ALT":"$1 bijlagen.","ACTIVITY_STATUS_SEND_FAILED_RETRY":"Verzenden mislukt. [Opnieuw][RETRY].","ACTIVITY_STATUS_SEND_STATUS_ALT_SENDING":"Wordt verzonden","ACTIVITY_STATUS_SEND_STATUS_ALT_SENT_AT":"Verzonden om $1","ACTIVITY_STATUS_TIMESTAMP_JUST_NOW":"Zojuist","ACTIVITY_STATUS_TIMESTAMP_ONE_HOUR_AGO":"Een uur geleden","ACTIVITY_STATUS_TIMESTAMP_ONE_MINUTE_AGO":"Een minuut geleden","ACTIVITY_STATUS_TIMESTAMP_TODAY":"Vandaag","ACTIVITY_STATUS_TIMESTAMP_YESTERDAY":"Gisteren","ADAPTIVE_CARD_ERROR_BOX_TITLE_PARSE":"Parseerfout adaptieve kaart","ADAPTIVE_CARD_ERROR_BOX_TITLE_RENDER":"Weergavefout adaptieve kaart","ATTACHMENT_AUDIO":"Een audioclip.","ATTACHMENT_CARD":"Een kaart: $1 $2 $3","ATTACHMENT_FILE":"Een bestand: $1","ATTACHMENT_IMAGE":"Een afbeelding","ATTACHMENT_TEXT":"Een tekst: $1","ATTACHMENT_VIDEO":"Een videoclip","CAROUSEL_FLIPPER_LEFT_ALT":"Links","CAROUSEL_FLIPPER_RIGHT_ALT":"Recht","CONNECTIVITY_STATUS_ALT_CONNECTED":"Verbonden","CONNECTIVITY_STATUS_ALT_CONNECTING":"Verbinding maken...","CONNECTIVITY_STATUS_ALT_FATAL":"Kan geen verbinding maken.","CONNECTIVITY_STATUS_ALT_RECONNECTING":"Er is een netwerkonderbreking opgetreden. Verbinding wordt hersteld...","CONNECTIVITY_STATUS_ALT_RENDER_ERROR":"Fout bij genereren. Controleer de console of neem contact op met de bot-ontwikkelaar.","CONNECTIVITY_STATUS_ALT_SLOW_CONNECTION":"Het duurt langer dan gewoonlijk om verbinding te maken.","CONNECTIVITY_STATUS_ALT":"Verbindingsstatus: $1","FILE_CONTENT_ALT":"\'$1\'","FILE_CONTENT_DOWNLOADABLE_ALT":"Bestand \'$1\' downloaden","FILE_CONTENT_DOWNLOADABLE_WITH_SIZE_ALT":"Downloadbestand \'$1\' van grootte $2","FILE_CONTENT_WITH_SIZE_ALT":"\'$1\' van grootte $2","KEYBOARD_HELP_CHAT_HISTORY_ACCESS_ITEMS_IN_MESSAGE_BODY":"Enter-toets","KEYBOARD_HELP_CHAT_HISTORY_ACCESS_ITEMS_IN_MESSAGE_HEADER":"Toegang tot items in bericht","KEYBOARD_HELP_CHAT_HISTORY_HEADER":"Chatgeschiedenis","KEYBOARD_HELP_CHAT_HISTORY_LEAVE_MESSAGE_BODY":"Escape-toets","KEYBOARD_HELP_CHAT_HISTORY_LEAVE_MESSAGE_HEADER":"Afsluitbericht","KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_ITEMS_BODY":"Tabtoets\\nShift + tabtoets","KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_ITEMS_HEADER":"Heen en weer gaan tussen items in een bericht","KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_MESSAGES_BODY":"Pijl-omhoog\\nPijl-omlaag","KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_MESSAGES_HEADER":"Heen en weer gaan tussen berichten","KEYBOARD_HELP_CHAT_WINDOW_BODY_DO_ACTION_BODY":"Enter-toets","KEYBOARD_HELP_CHAT_WINDOW_BODY_DO_ACTION_HEADER":"Actie uitvoeren","KEYBOARD_HELP_CHAT_WINDOW_BODY_MOVE_BETWEEN_ITEMS_BODY":"Tabtoets\\nShift + tabtoets","KEYBOARD_HELP_CHAT_WINDOW_BODY_MOVE_BETWEEN_ITEMS_HEADER":"Heen en weer gaan tussen items in het chatvenster","KEYBOARD_HELP_CHAT_WINDOW_HEADER":"Chatvenster","KEYBOARD_HELP_CLOSE_BUTTON_ALT":"Sluiten","KEYBOARD_HELP_HEADER":"Toetsenbordbesturingselementen","MARKDOWN_EXTERNAL_LINK_ALT":"Wordt geopend in een nieuw venster; extern.","RECEIPT_CARD_TAX":"Belastingen","RECEIPT_CARD_TOTAL":"Totaal","RECEIPT_CARD_VAT":"Btw","SEND_BOX_IS_EMPTY_TOOLTIP_ALT":"Kan geen leeg bericht verzenden.","SPEECH_INPUT_LISTENING":"Luisteren...","SPEECH_INPUT_MICROPHONE_BUTTON_CLOSE_ALT":"Microfoon uit","SPEECH_INPUT_MICROPHONE_BUTTON_OPEN_ALT":"Microfoon aan","SPEECH_INPUT_STARTING":"Starten...","SUGGESTED_ACTIONS_LABEL_ALT":"Voorgestelde acties","TEXT_INPUT_ALT":"Vak voor berichtinvoer","TEXT_INPUT_PLACEHOLDER":"Typ uw bericht","TEXT_INPUT_SEND_BUTTON_ALT":"Verzenden","TEXT_INPUT_SPEAK_BUTTON_ALT":"Spreken","TEXT_INPUT_UPLOAD_BUTTON_ALT":"Bestand uploaden","TOAST_ACCORDION_FEW":"$1 meldingen: klik hier voor details","TOAST_ACCORDION_MANY":"$1 meldingen: klik hier voor details","TOAST_ACCORDION_OTHER":"$1 meldingen: klik hier voor details","TOAST_ACCORDION_TWO":"$1 meldingen: klik hier voor details","TOAST_ALT_ERROR":"Fout","TOAST_ALT_INFO":"Informatie","TOAST_ALT_SUCCESS":"Gelukt","TOAST_ALT_WARN":"Waarschuwing","TOAST_DISMISS_BUTTON":"Negeren","TOAST_TITLE_ALT":"Melding","TRANSCRIPT_ARIA_LABEL_ALT":"Chatgeschiedenis, druk op de pijltoetsen om te navigeren.","TRANSCRIPT_ARIA_ROLE_ALT":"chatgeschiedenis","TRANSCRIPT_LIVE_REGION_INTERACTIVE_LABEL_ALT":"Bericht is interactief. Druk 2 tot 3 keer op Shift en tabtoets om over te schakelen naar de chatgeschiedenis. Klik vervolgens op het bericht voor interactie.","TRANSCRIPT_LIVE_REGION_INTERACTIVE_WITH_LINKS_LABEL_ALT":"Een of meer koppelingen in het bericht. Druk 2 tot 3 keer op Shift en tabtoets om over te schakelen naar de chatgeschiedenis. Klik vervolgens op het bericht voor interactie.","TRANSCRIPT_LIVE_REGION_SUGGESTED_ACTIONS_LABEL_ALT":"Bericht heeft voorgestelde acties. Druk 2 tot 3 keer op Shift en tabtoets om deze te selecteren.","TRANSCRIPT_LIVE_REGION_SUGGESTED_ACTIONS_WITH_ACCESS_KEY_LABEL_ALT":"Bericht heeft voorgestelde acties. Druk op $1 om deze te selecteren.","TRANSCRIPT_LIVE_REGION_SEND_FAILED_ALT":"Het bericht is niet verzonden.","TRANSCRIPT_MORE_MESSAGES":"Meer berichten","TRANSCRIPT_NEW_MESSAGES":"Nieuwe berichten","TRANSCRIPT_TERMINATOR_TEXT":"Einde chatgeschiedenis","TYPING_INDICATOR_ALT":"Indicator voor typen weergeven","TYPING_INDICATOR_SINGLE_TEXT":"$1 is bezig met typen.","TYPING_INDICATOR_MULTIPLE_TEXT":"$1 en anderen zijn bezig met typen."}');

});

parcelRequire.register("fgJZj", function(module, exports) {
module.exports = JSON.parse('{"_comment":"[CI-LOCKED] Zawartość tego pliku jest zablokowana. Wkład tw\xf3rczy jest mile widziany, ale weryfikacja zmian może być op\xf3źniona.","ACCESS_KEY_ALT":"Alt + Shift + $1","ACCESS_KEY_FOR_MAC_ALT":"Control + Option + $1","ACTIVITY_BOT_SAID_ALT":"Bot $1 powiedział:","ACTIVITY_YOU_SAID_ALT":"Ty m\xf3wisz:","ACTIVITY_BOT_ATTACHED_ALT":"Bot dołączył:","ACTIVITY_ERROR_BOX_TITLE":"Komunikat o błędzie","ACTIVITY_INTERACTIVE_FOOTNOTE_ALT":"Kliknij, aby wejść w interakcję.","ACTIVITY_INTERACTIVE_REASON_INTERACTIVE_CONTENT_ALT":"Wiadomość jest interakcyjna.","ACTIVITY_INTERACTIVE_REASON_LINK_ALT":"Wiadomość zawiera co najmniej jeden link.","ACTIVITY_INTERACTIVE_REASON_SEND_FAILED_ALT":"Wysyłanie nie powiodło się.","ACTIVITY_YOU_ATTACHED_ALT":"Ty dołączasz:","ACTIVITY_NUM_ATTACHMENTS_ONE_ALT":"1 załącznik.","ACTIVITY_NUM_ATTACHMENTS_FEW_ALT":"$1 załączniki.","ACTIVITY_NUM_ATTACHMENTS_MANY_ALT":"$1 załącznik\xf3w.","ACTIVITY_NUM_ATTACHMENTS_OTHER_ALT":"$1 załącznika.","ACTIVITY_NUM_ATTACHMENTS_TWO_ALT":"$1 załączniki.","ACTIVITY_STATUS_SEND_FAILED_RETRY":"Wysyłanie nie powiodło się. [Pon\xf3w pr\xf3bę][RETRY].","ACTIVITY_STATUS_SEND_STATUS_ALT_SENDING":"Wysyłanie","ACTIVITY_STATUS_SEND_STATUS_ALT_SENT_AT":"Wysłano o $1","ACTIVITY_STATUS_TIMESTAMP_JUST_NOW":"Teraz","ACTIVITY_STATUS_TIMESTAMP_ONE_HOUR_AGO":"Godzinę temu","ACTIVITY_STATUS_TIMESTAMP_ONE_MINUTE_AGO":"Minutę temu","ACTIVITY_STATUS_TIMESTAMP_TODAY":"Dzisiaj","ACTIVITY_STATUS_TIMESTAMP_YESTERDAY":"Wczoraj","ADAPTIVE_CARD_ERROR_BOX_TITLE_PARSE":"Błąd analizowania karty adaptacyjnej","ADAPTIVE_CARD_ERROR_BOX_TITLE_RENDER":"Błąd renderowania karty adaptacyjnej","ATTACHMENT_AUDIO":"Klip audio.","ATTACHMENT_CARD":"Karta: $1 $2 $3","ATTACHMENT_FILE":"Plik: $1","ATTACHMENT_IMAGE":"Obraz","ATTACHMENT_TEXT":"Tekst: $1","ATTACHMENT_VIDEO":"Klip wideo","CAROUSEL_FLIPPER_LEFT_ALT":"W lewo","CAROUSEL_FLIPPER_RIGHT_ALT":"W prawo","CONNECTIVITY_STATUS_ALT_CONNECTED":"Połączono","CONNECTIVITY_STATUS_ALT_CONNECTING":"Trwa nawiązywanie połączenia...","CONNECTIVITY_STATUS_ALT_FATAL":"Nie można nawiązać połączenia.","CONNECTIVITY_STATUS_ALT_RECONNECTING":"Wystąpiła przerwa w działaniu sieci. Trwa ponowne nawiązywanie połączenia...","CONNECTIVITY_STATUS_ALT_RENDER_ERROR":"Błąd renderowania. Sprawdź konsolę lub skontaktuj się z deweloperem bota.","CONNECTIVITY_STATUS_ALT_SLOW_CONNECTION":"Nawiązywanie połączenia trwa dłużej niż zazwyczaj.","CONNECTIVITY_STATUS_ALT":"Stan łączności: $1","FILE_CONTENT_ALT":"„$1”","FILE_CONTENT_DOWNLOADABLE_ALT":"Pobierz plik „$1”","FILE_CONTENT_DOWNLOADABLE_WITH_SIZE_ALT":"Pobierz plik „$1” o rozmiarze $2","FILE_CONTENT_WITH_SIZE_ALT":"Plik „$1” o rozmiarze $2","KEYBOARD_HELP_CHAT_HISTORY_ACCESS_ITEMS_IN_MESSAGE_BODY":"Klawisz Enter","KEYBOARD_HELP_CHAT_HISTORY_ACCESS_ITEMS_IN_MESSAGE_HEADER":"Uzyskaj dostęp do element\xf3w w wiadomości","KEYBOARD_HELP_CHAT_HISTORY_HEADER":"Historia czatu","KEYBOARD_HELP_CHAT_HISTORY_LEAVE_MESSAGE_BODY":"Klawisz Escape","KEYBOARD_HELP_CHAT_HISTORY_LEAVE_MESSAGE_HEADER":"Zamknij komunikat","KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_ITEMS_BODY":"Klawisz Tab\\nKlawisze Shift + Tab","KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_ITEMS_HEADER":"Przechodź między elementami w wiadomości","KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_MESSAGES_BODY":"Klawisz Strzałka w g\xf3rę\\nKlawisz Strzałka w d\xf3ł","KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_MESSAGES_HEADER":"Przechodź między wiadomościami","KEYBOARD_HELP_CHAT_WINDOW_BODY_DO_ACTION_BODY":"Klawisz Enter","KEYBOARD_HELP_CHAT_WINDOW_BODY_DO_ACTION_HEADER":"Wykonaj akcję","KEYBOARD_HELP_CHAT_WINDOW_BODY_MOVE_BETWEEN_ITEMS_BODY":"Klawisz Tab\\nKlawisze Shift + Tab","KEYBOARD_HELP_CHAT_WINDOW_BODY_MOVE_BETWEEN_ITEMS_HEADER":"Przechodź między elementami w oknie czatu","KEYBOARD_HELP_CHAT_WINDOW_HEADER":"Okno czatu","KEYBOARD_HELP_CLOSE_BUTTON_ALT":"Zamknij","KEYBOARD_HELP_HEADER":"Sterowanie za pomocą klawiatury","MARKDOWN_EXTERNAL_LINK_ALT":"Powoduje otwarcie w nowym oknie; link zewnętrzny.","RECEIPT_CARD_TAX":"Podatek","RECEIPT_CARD_TOTAL":"Suma","RECEIPT_CARD_VAT":"Podatek VAT","SEND_BOX_IS_EMPTY_TOOLTIP_ALT":"Nie można wysłać pustej wiadomości.","SPEECH_INPUT_LISTENING":"Trwa słuchanie...","SPEECH_INPUT_MICROPHONE_BUTTON_CLOSE_ALT":"Mikrofon wyłączony","SPEECH_INPUT_MICROPHONE_BUTTON_OPEN_ALT":"Mikrofon włączony","SPEECH_INPUT_STARTING":"Trwa rozpoczynanie...","SUGGESTED_ACTIONS_LABEL_ALT":"Sugerowane akcje","TEXT_INPUT_ALT":"Pole wprowadzania wiadomości","TEXT_INPUT_PLACEHOLDER":"Wpisz wiadomość","TEXT_INPUT_SEND_BUTTON_ALT":"Wyślij","TEXT_INPUT_SPEAK_BUTTON_ALT":"M\xf3w","TEXT_INPUT_UPLOAD_BUTTON_ALT":"Przekaż plik","TOAST_ACCORDION_FEW":"$1 powiadomienia: kliknij tutaj, aby wyświetlić szczeg\xf3ły","TOAST_ACCORDION_MANY":"$1 powiadomienia: kliknij tutaj, aby wyświetlić szczeg\xf3ły","TOAST_ACCORDION_OTHER":"$1 powiadomienia: kliknij tutaj, aby wyświetlić szczeg\xf3ły","TOAST_ACCORDION_TWO":"$1 powiadomienia: kliknij tutaj, aby wyświetlić szczeg\xf3ły","TOAST_ALT_ERROR":"Błąd","TOAST_ALT_INFO":"Informacje","TOAST_ALT_SUCCESS":"Sukces","TOAST_ALT_WARN":"Ostrzeżenie","TOAST_DISMISS_BUTTON":"Odrzuć","TOAST_TITLE_ALT":"Powiadomienie","TRANSCRIPT_ARIA_LABEL_ALT":"Historia czatu, naciskaj klawisze strzałek, aby nawigować.","TRANSCRIPT_ARIA_ROLE_ALT":"historia czatu","TRANSCRIPT_LIVE_REGION_INTERACTIVE_LABEL_ALT":"Wiadomość jest interakcyjna. Naciśnij 2-3 razy klawisze Shift+Tab, aby przełączyć się do historii czatu. Następnie kliknij w wiadomości, aby wejść w interakcję.","TRANSCRIPT_LIVE_REGION_INTERACTIVE_WITH_LINKS_LABEL_ALT":"Wiadomość zawiera co najmniej jeden link. Naciśnij 2-3 razy klawisze Shift+Tab, aby przełączyć się do historii czatu. Następnie kliknij w wiadomości, aby wejść w interakcję.","TRANSCRIPT_LIVE_REGION_SUGGESTED_ACTIONS_LABEL_ALT":"Wiadomość zawiera sugerowane akcje. Naciśnij klawisze Shift + Tab 2 lub 3 razy, aby je wybrać.","TRANSCRIPT_LIVE_REGION_SUGGESTED_ACTIONS_WITH_ACCESS_KEY_LABEL_ALT":"Wiadomość zawiera sugerowane akcje. Naciśnij klawisz $1, aby je wybrać.","TRANSCRIPT_LIVE_REGION_SEND_FAILED_ALT":"Nie można wysłać wiadomości.","TRANSCRIPT_MORE_MESSAGES":"Więcej wiadomości","TRANSCRIPT_NEW_MESSAGES":"Nowe wiadomości","TRANSCRIPT_TERMINATOR_TEXT":"Koniec historii czatu","TYPING_INDICATOR_ALT":"Wyświetlanie wskaźnika wpisywania","TYPING_INDICATOR_SINGLE_TEXT":"$1 pisze.","TYPING_INDICATOR_MULTIPLE_TEXT":"$1 i inni piszą."}');

});

parcelRequire.register("dBJNg", function(module, exports) {
module.exports = JSON.parse('{"_comment":"[CI-LOCKED] O conte\xfado deste arquivo est\xe1 bloqueado. Contribui\xe7\xf5es s\xe3o bem-vindas, mas pode haver atrasos na valida\xe7\xe3o das altera\xe7\xf5es.","ACCESS_KEY_ALT":"Alt Shift $1","ACCESS_KEY_FOR_MAC_ALT":"Control Option $1","ACTIVITY_BOT_SAID_ALT":"O bot $1 disse:","ACTIVITY_YOU_SAID_ALT":"Voc\xea disse:","ACTIVITY_BOT_ATTACHED_ALT":"Bot anexado:","ACTIVITY_ERROR_BOX_TITLE":"Mensagem de erro","ACTIVITY_INTERACTIVE_FOOTNOTE_ALT":"Clique para interagir.","ACTIVITY_INTERACTIVE_REASON_INTERACTIVE_CONTENT_ALT":"A mensagem \xe9 interativa.","ACTIVITY_INTERACTIVE_REASON_LINK_ALT":"Um ou mais links na mensagem.","ACTIVITY_INTERACTIVE_REASON_SEND_FAILED_ALT":"Falha no envio.","ACTIVITY_YOU_ATTACHED_ALT":"Voc\xea anexou:","ACTIVITY_NUM_ATTACHMENTS_ONE_ALT":"1 anexo.","ACTIVITY_NUM_ATTACHMENTS_FEW_ALT":"$1 anexos.","ACTIVITY_NUM_ATTACHMENTS_MANY_ALT":"$1 anexos.","ACTIVITY_NUM_ATTACHMENTS_OTHER_ALT":"$1 anexos.","ACTIVITY_NUM_ATTACHMENTS_TWO_ALT":"$1 anexos.","ACTIVITY_STATUS_SEND_FAILED_RETRY":"Falha no envio. [Repetir][RETRY].","ACTIVITY_STATUS_SEND_STATUS_ALT_SENDING":"Enviando","ACTIVITY_STATUS_SEND_STATUS_ALT_SENT_AT":"Enviado \xe0s $1","ACTIVITY_STATUS_TIMESTAMP_JUST_NOW":"Agora","ACTIVITY_STATUS_TIMESTAMP_ONE_HOUR_AGO":"H\xe1 uma hora","ACTIVITY_STATUS_TIMESTAMP_ONE_MINUTE_AGO":"H\xe1 um minuto","ACTIVITY_STATUS_TIMESTAMP_TODAY":"Hoje","ACTIVITY_STATUS_TIMESTAMP_YESTERDAY":"Ontem","ADAPTIVE_CARD_ERROR_BOX_TITLE_PARSE":"Erro de an\xe1lise do Cart\xe3o Adapt\xe1vel","ADAPTIVE_CARD_ERROR_BOX_TITLE_RENDER":"Erro de renderiza\xe7\xe3o do Cart\xe3o Adapt\xe1vel","ATTACHMENT_AUDIO":"Um clipe de \xe1udio.","ATTACHMENT_CARD":"Um cart\xe3o: $1 $2 $3","ATTACHMENT_FILE":"Um arquivo: $1","ATTACHMENT_IMAGE":"Uma imagem","ATTACHMENT_TEXT":"Um texto: $1","ATTACHMENT_VIDEO":"Um videoclipe","CAROUSEL_FLIPPER_LEFT_ALT":"Esquerdo","CAROUSEL_FLIPPER_RIGHT_ALT":"Direito","CONNECTIVITY_STATUS_ALT_CONNECTED":"Conectado","CONNECTIVITY_STATUS_ALT_CONNECTING":"Conectando…","CONNECTIVITY_STATUS_ALT_FATAL":"N\xe3o \xe9 poss\xedvel conectar.","CONNECTIVITY_STATUS_ALT_RECONNECTING":"Ocorreu uma interrup\xe7\xe3o da rede. Reconectando…","CONNECTIVITY_STATUS_ALT_RENDER_ERROR":"Erro de renderiza\xe7\xe3o. Verifique o console ou contate o desenvolvedor de bot.","CONNECTIVITY_STATUS_ALT_SLOW_CONNECTION":"A conex\xe3o est\xe1 demorando mais do que o habitual.","CONNECTIVITY_STATUS_ALT":"Status da Conectividade: $1","FILE_CONTENT_ALT":"\'$1\'","FILE_CONTENT_DOWNLOADABLE_ALT":"Baixar o arquivo \'$1\'","FILE_CONTENT_DOWNLOADABLE_WITH_SIZE_ALT":"Baixar o arquivo \'$1\' de tamanho $2","FILE_CONTENT_WITH_SIZE_ALT":"\'$1\' de tamanho $2","KEYBOARD_HELP_CHAT_HISTORY_ACCESS_ITEMS_IN_MESSAGE_BODY":"Tecla Enter","KEYBOARD_HELP_CHAT_HISTORY_ACCESS_ITEMS_IN_MESSAGE_HEADER":"Acessar itens na mensagem","KEYBOARD_HELP_CHAT_HISTORY_HEADER":"Hist\xf3rico de chat","KEYBOARD_HELP_CHAT_HISTORY_LEAVE_MESSAGE_BODY":"Tecla Escape","KEYBOARD_HELP_CHAT_HISTORY_LEAVE_MESSAGE_HEADER":"Sair da mensagem","KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_ITEMS_BODY":"Tecla Tab\\nTecla Shift + tab","KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_ITEMS_HEADER":"Mover entre itens em uma mensagem","KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_MESSAGES_BODY":"Tecla de seta para cima\\nTecla de seta para baixo","KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_MESSAGES_HEADER":"Mover entre mensagens","KEYBOARD_HELP_CHAT_WINDOW_BODY_DO_ACTION_BODY":"Tecla Enter","KEYBOARD_HELP_CHAT_WINDOW_BODY_DO_ACTION_HEADER":"Realizar a\xe7\xe3o","KEYBOARD_HELP_CHAT_WINDOW_BODY_MOVE_BETWEEN_ITEMS_BODY":"Tecla Tab\\nTecla Shift + tab","KEYBOARD_HELP_CHAT_WINDOW_BODY_MOVE_BETWEEN_ITEMS_HEADER":"Mover entre itens na janela de chat","KEYBOARD_HELP_CHAT_WINDOW_HEADER":"Janela de chat","KEYBOARD_HELP_CLOSE_BUTTON_ALT":"Fechar","KEYBOARD_HELP_HEADER":"Controles do teclado","MARKDOWN_EXTERNAL_LINK_ALT":"Abre em uma nova janela externa.","RECEIPT_CARD_TAX":"Imposto","RECEIPT_CARD_TOTAL":"Total","RECEIPT_CARD_VAT":"IVA","SEND_BOX_IS_EMPTY_TOOLTIP_ALT":"N\xe3o \xe9 poss\xedvel enviar uma mensagem vazia.","SPEECH_INPUT_LISTENING":"Escutando…","SPEECH_INPUT_MICROPHONE_BUTTON_CLOSE_ALT":"Microfone desligado","SPEECH_INPUT_MICROPHONE_BUTTON_OPEN_ALT":"Microfone ligado","SPEECH_INPUT_STARTING":"Iniciando…","SUGGESTED_ACTIONS_LABEL_ALT":"A\xe7\xf5es sugeridas","TEXT_INPUT_ALT":"Caixa de entrada de mensagens","TEXT_INPUT_PLACEHOLDER":"Digite sua mensagem","TEXT_INPUT_SEND_BUTTON_ALT":"Enviar","TEXT_INPUT_SPEAK_BUTTON_ALT":"Falar","TEXT_INPUT_UPLOAD_BUTTON_ALT":"Carregar arquivo","TOAST_ACCORDION_FEW":"$1 Notifica\xe7\xf5es: clique aqui para ver os detalhes","TOAST_ACCORDION_MANY":"$1 Notifica\xe7\xf5es: clique aqui para ver os detalhes","TOAST_ACCORDION_OTHER":"$1 Notifica\xe7\xf5es: clique aqui para ver os detalhes","TOAST_ACCORDION_TWO":"$1 Notifica\xe7\xf5es: clique aqui para ver os detalhes","TOAST_ALT_ERROR":"Erro","TOAST_ALT_INFO":"Informa\xe7\xe3o","TOAST_ALT_SUCCESS":"Sucesso","TOAST_ALT_WARN":"Aviso","TOAST_DISMISS_BUTTON":"Ignorar","TOAST_TITLE_ALT":"Notifica\xe7\xe3o","TRANSCRIPT_ARIA_LABEL_ALT":"Hist\xf3rico de chat, use as teclas de seta para navegar.","TRANSCRIPT_ARIA_ROLE_ALT":"hist\xf3rico de chat","TRANSCRIPT_LIVE_REGION_INTERACTIVE_LABEL_ALT":"A mensagem \xe9 interativa. Pressione a tecla Shift Tab de 2 para 3 vezes para alternar para o hist\xf3rico do chat. Depois, clique na mensagem para interagir.","TRANSCRIPT_LIVE_REGION_INTERACTIVE_WITH_LINKS_LABEL_ALT":"Um ou mais links na mensagem. A mensagem \xe9 interativa. Pressione a tecla Shift Tab de 2 para 3 vezes para alternar para o hist\xf3rico do chat. Depois, clique na mensagem para interagir.","TRANSCRIPT_LIVE_REGION_SUGGESTED_ACTIONS_LABEL_ALT":"A mensagem tem a\xe7\xf5es sugeridas. Pressione shift tab de 2 a 3 vezes para selecion\xe1-las.","TRANSCRIPT_LIVE_REGION_SUGGESTED_ACTIONS_WITH_ACCESS_KEY_LABEL_ALT":"A mensagem tem a\xe7\xf5es sugeridas. Pressione $1 para selecion\xe1-las.","TRANSCRIPT_LIVE_REGION_SEND_FAILED_ALT":"Falha ao enviar a mensagem.","TRANSCRIPT_MORE_MESSAGES":"Mais mensagens","TRANSCRIPT_NEW_MESSAGES":"Novas mensagens","TRANSCRIPT_TERMINATOR_TEXT":"T\xe9rmino do hist\xf3rico de chat","TYPING_INDICATOR_ALT":"Mostrando o indicador de digita\xe7\xe3o","TYPING_INDICATOR_SINGLE_TEXT":"$1 est\xe1 digitando.","TYPING_INDICATOR_MULTIPLE_TEXT":"$1 e outros est\xe3o digitando."}');

});

parcelRequire.register("1qvwv", function(module, exports) {
module.exports = JSON.parse('{"_comment":"[CI-LOCKED] O conte\xfado deste ficheiro est\xe1 bloqueado. S\xe3o aceites contribui\xe7\xf5es, mas a valida\xe7\xe3o das altera\xe7\xf5es pode registar atrasos.","ACCESS_KEY_ALT":"Alt Shift $1","ACCESS_KEY_FOR_MAC_ALT":"Controlo Op\xe7\xe3o $1","ACTIVITY_BOT_SAID_ALT":"O bot $1 disse:","ACTIVITY_YOU_SAID_ALT":"Disse:","ACTIVITY_BOT_ATTACHED_ALT":"Bot anexado:","ACTIVITY_ERROR_BOX_TITLE":"Mensagem de erro","ACTIVITY_INTERACTIVE_FOOTNOTE_ALT":"Clique para interagir.","ACTIVITY_INTERACTIVE_REASON_INTERACTIVE_CONTENT_ALT":"A mensagem \xe9 interativa.","ACTIVITY_INTERACTIVE_REASON_LINK_ALT":"A mensagem cont\xe9m uma ou mais liga\xe7\xf5es.","ACTIVITY_INTERACTIVE_REASON_SEND_FAILED_ALT":"Falha ao enviar.","ACTIVITY_YOU_ATTACHED_ALT":"Anexou:","ACTIVITY_NUM_ATTACHMENTS_ONE_ALT":"1 anexo.","ACTIVITY_NUM_ATTACHMENTS_FEW_ALT":"$1 anexos.","ACTIVITY_NUM_ATTACHMENTS_MANY_ALT":"$1 anexos.","ACTIVITY_NUM_ATTACHMENTS_OTHER_ALT":"$1 anexos.","ACTIVITY_NUM_ATTACHMENTS_TWO_ALT":"$1 anexos.","ACTIVITY_STATUS_SEND_FAILED_RETRY":"Falha ao enviar. [Repetir][RETRY].","ACTIVITY_STATUS_SEND_STATUS_ALT_SENDING":"A enviar","ACTIVITY_STATUS_SEND_STATUS_ALT_SENT_AT":"Enviado \xe0s $1","ACTIVITY_STATUS_TIMESTAMP_JUST_NOW":"Agora mesmo","ACTIVITY_STATUS_TIMESTAMP_ONE_HOUR_AGO":"H\xe1 uma hora","ACTIVITY_STATUS_TIMESTAMP_ONE_MINUTE_AGO":"H\xe1 um minuto","ACTIVITY_STATUS_TIMESTAMP_TODAY":"Hoje","ACTIVITY_STATUS_TIMESTAMP_YESTERDAY":"Ontem","ADAPTIVE_CARD_ERROR_BOX_TITLE_PARSE":"Erro de an\xe1lise de Cart\xe3o Adapt\xe1vel","ADAPTIVE_CARD_ERROR_BOX_TITLE_RENDER":"Erro de composi\xe7\xe3o de Cart\xe3o Adapt\xe1vel","ATTACHMENT_AUDIO":"Um clip de \xe1udio.","ATTACHMENT_CARD":"Um cart\xe3o: $1 $2 $3","ATTACHMENT_FILE":"Um ficheiro: $1","ATTACHMENT_IMAGE":"Uma imagem","ATTACHMENT_TEXT":"Um texto: $1","ATTACHMENT_VIDEO":"Um clip de v\xeddeo","CAROUSEL_FLIPPER_LEFT_ALT":"Esquerda","CAROUSEL_FLIPPER_RIGHT_ALT":"Direita","CONNECTIVITY_STATUS_ALT_CONNECTED":"Ligado","CONNECTIVITY_STATUS_ALT_CONNECTING":"A ligar…","CONNECTIVITY_STATUS_ALT_FATAL":"N\xe3o \xe9 poss\xedvel ligar.","CONNECTIVITY_STATUS_ALT_RECONNECTING":"Ocorreu uma interrup\xe7\xe3o de rede. A restabelecer liga\xe7\xe3o…","CONNECTIVITY_STATUS_ALT_RENDER_ERROR":"Erro de composi\xe7\xe3o. Verifique a consola ou contacte o programador do bot.","CONNECTIVITY_STATUS_ALT_SLOW_CONNECTION":"O estabelecimento da liga\xe7\xe3o est\xe1 a demorar mais tempo do que o esperado.","CONNECTIVITY_STATUS_ALT":"Estado de Conectividade: $1","FILE_CONTENT_ALT":"\\"$1\\"","FILE_CONTENT_DOWNLOADABLE_ALT":"Transferir o ficheiro \\"$1\\"","FILE_CONTENT_DOWNLOADABLE_WITH_SIZE_ALT":"Transferir o ficheiro \\"$1\\" com um tamanho de $2","FILE_CONTENT_WITH_SIZE_ALT":"\\"$1\\" com um tamanho de $2","KEYBOARD_HELP_CHAT_HISTORY_ACCESS_ITEMS_IN_MESSAGE_BODY":"Tecla Enter","KEYBOARD_HELP_CHAT_HISTORY_ACCESS_ITEMS_IN_MESSAGE_HEADER":"Aceder a itens na mensagem","KEYBOARD_HELP_CHAT_HISTORY_HEADER":"Hist\xf3rico de chat","KEYBOARD_HELP_CHAT_HISTORY_LEAVE_MESSAGE_BODY":"Tecla Esc","KEYBOARD_HELP_CHAT_HISTORY_LEAVE_MESSAGE_HEADER":"Sair da mensagem","KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_ITEMS_BODY":"Tecla de tabula\xe7\xe3o\\nShift + tecla de tabula\xe7\xe3o","KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_ITEMS_HEADER":"Mover-se entre itens numa mensagem","KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_MESSAGES_BODY":"Tecla de seta para cima\\nTecla de seta para baixo","KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_MESSAGES_HEADER":"Mover-se entre mensagens","KEYBOARD_HELP_CHAT_WINDOW_BODY_DO_ACTION_BODY":"Tecla Enter","KEYBOARD_HELP_CHAT_WINDOW_BODY_DO_ACTION_HEADER":"Efetuar a\xe7\xe3o","KEYBOARD_HELP_CHAT_WINDOW_BODY_MOVE_BETWEEN_ITEMS_BODY":"Tecla de tabula\xe7\xe3o\\nShift + tecla de tabula\xe7\xe3o","KEYBOARD_HELP_CHAT_WINDOW_BODY_MOVE_BETWEEN_ITEMS_HEADER":"Mover-se entre itens na janela de chat","KEYBOARD_HELP_CHAT_WINDOW_HEADER":"Janela de chat","KEYBOARD_HELP_CLOSE_BUTTON_ALT":"Fechar","KEYBOARD_HELP_HEADER":"Controlos do teclado","MARKDOWN_EXTERNAL_LINK_ALT":"Abre numa nova janela externa.","RECEIPT_CARD_TAX":"Imposto","RECEIPT_CARD_TOTAL":"Total","RECEIPT_CARD_VAT":"IVA","SEND_BOX_IS_EMPTY_TOOLTIP_ALT":"N\xe3o \xe9 poss\xedvel enviar uma mensagem vazia.","SPEECH_INPUT_LISTENING":"A escutar…","SPEECH_INPUT_MICROPHONE_BUTTON_CLOSE_ALT":"Microfone desativado","SPEECH_INPUT_MICROPHONE_BUTTON_OPEN_ALT":"Microfone ativado","SPEECH_INPUT_STARTING":"A iniciar…","SUGGESTED_ACTIONS_LABEL_ALT":"A\xe7\xf5es sugeridas","TEXT_INPUT_ALT":"Caixa de entrada de mensagens","TEXT_INPUT_PLACEHOLDER":"Escreva a sua mensagem","TEXT_INPUT_SEND_BUTTON_ALT":"Enviar","TEXT_INPUT_SPEAK_BUTTON_ALT":"Falar","TEXT_INPUT_UPLOAD_BUTTON_ALT":"Carregar ficheiro","TOAST_ACCORDION_FEW":"$1 Notifica\xe7\xf5es: clique aqui para ver os detalhes","TOAST_ACCORDION_MANY":"$1 Notifica\xe7\xf5es: clique aqui para ver os detalhes","TOAST_ACCORDION_OTHER":"$1 Notifica\xe7\xf5es: clique aqui para ver os detalhes","TOAST_ACCORDION_TWO":"$1 Notifica\xe7\xf5es: clique aqui para ver os detalhes","TOAST_ALT_ERROR":"Erro","TOAST_ALT_INFO":"Informa\xe7\xf5es","TOAST_ALT_SUCCESS":"\xcaxito","TOAST_ALT_WARN":"Aviso","TOAST_DISMISS_BUTTON":"Dispensar","TOAST_TITLE_ALT":"Notifica\xe7\xe3o","TRANSCRIPT_ARIA_LABEL_ALT":"Hist\xf3rico de chat, prima as teclas de seta para navegar.","TRANSCRIPT_ARIA_ROLE_ALT":"hist\xf3rico de chat","TRANSCRIPT_LIVE_REGION_INTERACTIVE_LABEL_ALT":"A mensagem \xe9 interativa. Prima Shift + tecla de tabula\xe7\xe3o 2 a 3 vezes para mudar para o hist\xf3rico de chat. Em seguida, clique na mensagem para interagir.","TRANSCRIPT_LIVE_REGION_INTERACTIVE_WITH_LINKS_LABEL_ALT":"A mensagem cont\xe9m uma ou mais liga\xe7\xf5es. Prima Shift + tecla de tabula\xe7\xe3o 2 a 3 vezes para mudar para o hist\xf3rico de chat. Em seguida, clique na mensagem para interagir.","TRANSCRIPT_LIVE_REGION_SUGGESTED_ACTIONS_LABEL_ALT":"A mensagem tem a\xe7\xf5es sugeridas. Prima Shift Tabula\xe7\xe3o 2 a 3 vezes para as selecionar.","TRANSCRIPT_LIVE_REGION_SUGGESTED_ACTIONS_WITH_ACCESS_KEY_LABEL_ALT":"A mensagem tem a\xe7\xf5es sugeridas. Prima $1 para as selecionar.","TRANSCRIPT_LIVE_REGION_SEND_FAILED_ALT":"Falha ao enviar a mensagem.","TRANSCRIPT_MORE_MESSAGES":"Mais mensagens","TRANSCRIPT_NEW_MESSAGES":"Novas mensagens","TRANSCRIPT_TERMINATOR_TEXT":"Fim do hist\xf3rico de chat","TYPING_INDICATOR_ALT":"A mostrar o indicador de escrita","TYPING_INDICATOR_SINGLE_TEXT":"$1 est\xe1 a escrever.","TYPING_INDICATOR_MULTIPLE_TEXT":"$1 e outros utilizadores est\xe3o a escrever."}');

});

parcelRequire.register("l4t9G", function(module, exports) {
module.exports = JSON.parse('{"_comment":"[CI-LOCKED] Conținutul acestui fișier este blocat. Contribuțiile sunt binevenite, dar validarea schimbării poate fi \xeent\xe2rziată.","ACCESS_KEY_ALT":"Alt Shift $1","ACCESS_KEY_FOR_MAC_ALT":"Control Option $1","ACTIVITY_BOT_SAID_ALT":"Robotul $1 a spus:","ACTIVITY_YOU_SAID_ALT":"Ați spus:","ACTIVITY_BOT_ATTACHED_ALT":"Robot atașat:","ACTIVITY_ERROR_BOX_TITLE":"Mesaj de eroare","ACTIVITY_INTERACTIVE_FOOTNOTE_ALT":"Faceți clic pentru a interacționa.","ACTIVITY_INTERACTIVE_REASON_INTERACTIVE_CONTENT_ALT":"Mesajul este interactiv.","ACTIVITY_INTERACTIVE_REASON_LINK_ALT":"\xcen mesaj există unul sau mai multe linkuri.","ACTIVITY_INTERACTIVE_REASON_SEND_FAILED_ALT":"Trimitere nereușită.","ACTIVITY_YOU_ATTACHED_ALT":"Ați atașat:","ACTIVITY_NUM_ATTACHMENTS_ONE_ALT":"1 atașare.","ACTIVITY_NUM_ATTACHMENTS_FEW_ALT":"$1 atașări.","ACTIVITY_NUM_ATTACHMENTS_MANY_ALT":"$1 atașări.","ACTIVITY_NUM_ATTACHMENTS_OTHER_ALT":"$1 de atașări.","ACTIVITY_NUM_ATTACHMENTS_TWO_ALT":"$1 atașări.","ACTIVITY_STATUS_SEND_FAILED_RETRY":"Trimiterea nu a reușit. [Re\xeencercați][RETRY].","ACTIVITY_STATUS_SEND_STATUS_ALT_SENDING":"Se trimite","ACTIVITY_STATUS_SEND_STATUS_ALT_SENT_AT":"Trimis la $1","ACTIVITY_STATUS_TIMESTAMP_JUST_NOW":"Chiar acum","ACTIVITY_STATUS_TIMESTAMP_ONE_HOUR_AGO":"Acum o oră","ACTIVITY_STATUS_TIMESTAMP_ONE_MINUTE_AGO":"Acum un minut","ACTIVITY_STATUS_TIMESTAMP_TODAY":"Azi","ACTIVITY_STATUS_TIMESTAMP_YESTERDAY":"Ieri","ADAPTIVE_CARD_ERROR_BOX_TITLE_PARSE":"Eroare de analiză a cardului adaptiv","ADAPTIVE_CARD_ERROR_BOX_TITLE_RENDER":"Eroare de redare a cardului adaptiv","ATTACHMENT_AUDIO":"Un clip audio.","ATTACHMENT_CARD":"Un card: $1 $2 $3","ATTACHMENT_FILE":"Un fișier: $1","ATTACHMENT_IMAGE":"O imagine","ATTACHMENT_TEXT":"Un text: $1","ATTACHMENT_VIDEO":"Un videoclip","CAROUSEL_FLIPPER_LEFT_ALT":"St\xe2nga","CAROUSEL_FLIPPER_RIGHT_ALT":"Dreapta","CONNECTIVITY_STATUS_ALT_CONNECTED":"Conectat","CONNECTIVITY_STATUS_ALT_CONNECTING":"Se conectează…","CONNECTIVITY_STATUS_ALT_FATAL":"Imposibil de conectat.","CONNECTIVITY_STATUS_ALT_RECONNECTING":"A avut loc o \xeentrerupere \xeen rețea. Se reconectează…","CONNECTIVITY_STATUS_ALT_RENDER_ERROR":"Eroare de randare. Verificați consola sau contactați dezvoltatorul robotului.","CONNECTIVITY_STATUS_ALT_SLOW_CONNECTION":"Conectarea durează mai mult dec\xe2t de obicei.","CONNECTIVITY_STATUS_ALT":"Stare de conectivitate: $1","FILE_CONTENT_ALT":"„$1”","FILE_CONTENT_DOWNLOADABLE_ALT":"Descărcați fișierul „$1”","FILE_CONTENT_DOWNLOADABLE_WITH_SIZE_ALT":"Descărcați fișierul „$1” de dimensiune $2","FILE_CONTENT_WITH_SIZE_ALT":"„$1” de dimensiune $2","KEYBOARD_HELP_CHAT_HISTORY_ACCESS_ITEMS_IN_MESSAGE_BODY":"Tasta Enter","KEYBOARD_HELP_CHAT_HISTORY_ACCESS_ITEMS_IN_MESSAGE_HEADER":"Accesați elementele din mesaj","KEYBOARD_HELP_CHAT_HISTORY_HEADER":"Istoric chat","KEYBOARD_HELP_CHAT_HISTORY_LEAVE_MESSAGE_BODY":"Tasta Esc","KEYBOARD_HELP_CHAT_HISTORY_LEAVE_MESSAGE_HEADER":"Ieșiți din mesaj","KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_ITEMS_BODY":"Tasta Tab\\nTastele Shift + Tab","KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_ITEMS_HEADER":"Deplasați-vă \xeentre elementele dintr-un mesaj","KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_MESSAGES_BODY":"Tasta Săgeată \xeen sus\\nTasta Săgeată \xeen jos","KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_MESSAGES_HEADER":"Deplasați-vă \xeentre mesaje","KEYBOARD_HELP_CHAT_WINDOW_BODY_DO_ACTION_BODY":"Tasta Enter","KEYBOARD_HELP_CHAT_WINDOW_BODY_DO_ACTION_HEADER":"Efectuați acțiunea","KEYBOARD_HELP_CHAT_WINDOW_BODY_MOVE_BETWEEN_ITEMS_BODY":"Tasta Tab\\nTastele Shift + Tab","KEYBOARD_HELP_CHAT_WINDOW_BODY_MOVE_BETWEEN_ITEMS_HEADER":"Deplasați-vă \xeentre elementele din fereastra de chat","KEYBOARD_HELP_CHAT_WINDOW_HEADER":"Fereastră de chat","KEYBOARD_HELP_CLOSE_BUTTON_ALT":"\xcenchideți","KEYBOARD_HELP_HEADER":"Comenzi de la tastatură","MARKDOWN_EXTERNAL_LINK_ALT":"Se deschide \xeentr-o fereastră nouă; extern.","RECEIPT_CARD_TAX":"Impozit","RECEIPT_CARD_TOTAL":"Total","RECEIPT_CARD_VAT":"TVA","SEND_BOX_IS_EMPTY_TOOLTIP_ALT":"Nu se poate trimite un mesaj gol.","SPEECH_INPUT_LISTENING":"Se ascultă…","SPEECH_INPUT_MICROPHONE_BUTTON_CLOSE_ALT":"Microfon dezactivat","SPEECH_INPUT_MICROPHONE_BUTTON_OPEN_ALT":"Microfon activat","SPEECH_INPUT_STARTING":"\xcencepe…","SUGGESTED_ACTIONS_LABEL_ALT":"Acțiuni sugerate","TEXT_INPUT_ALT":"Caseta de introducere a mesajelor","TEXT_INPUT_PLACEHOLDER":"Tastați mesajul","TEXT_INPUT_SEND_BUTTON_ALT":"Trimitere","TEXT_INPUT_SPEAK_BUTTON_ALT":"Vorbire","TEXT_INPUT_UPLOAD_BUTTON_ALT":"\xcencărcare fișier","TOAST_ACCORDION_FEW":"$1 notificări: Faceți clic aici pentru a vedea detaliile","TOAST_ACCORDION_MANY":"$1 notificări: Faceți clic aici pentru a vedea detaliile","TOAST_ACCORDION_OTHER":"$1 notificări: Faceți clic aici pentru a vedea detaliile","TOAST_ACCORDION_TWO":"$1 notificări: Faceți clic aici pentru a vedea detaliile","TOAST_ALT_ERROR":"Eroare","TOAST_ALT_INFO":"Informații","TOAST_ALT_SUCCESS":"Succes","TOAST_ALT_WARN":"Avertisment","TOAST_DISMISS_BUTTON":"\xcendepărtare","TOAST_TITLE_ALT":"Notificare","TRANSCRIPT_ARIA_LABEL_ALT":"Istoric chat, apăsați tastele săgeți pentru a naviga.","TRANSCRIPT_ARIA_ROLE_ALT":"istoric chat","TRANSCRIPT_LIVE_REGION_INTERACTIVE_LABEL_ALT":"Mesajul este interactiv. Apăsați tastele Shift și Tab de 2 p\xe2nă la 3 ori, pentru a comuta la istoricul chatului. Apoi faceți clic pe mesaj pentru a interacționa.","TRANSCRIPT_LIVE_REGION_INTERACTIVE_WITH_LINKS_LABEL_ALT":"\xcen mesaj există unul sau mai multe linkuri. Apăsați tastele Shift și Tab de 2 p\xe2nă la 3 ori, pentru a comuta la istoricul chatului. Apoi faceți clic pe mesaj pentru a interacționa.","TRANSCRIPT_LIVE_REGION_SUGGESTED_ACTIONS_LABEL_ALT":"Mesajul are acțiuni sugerate. Apăsați tastele Shift și Tab de 2 p\xe2nă la 3 ori pentru a le selecta.","TRANSCRIPT_LIVE_REGION_SUGGESTED_ACTIONS_WITH_ACCESS_KEY_LABEL_ALT":"Mesajul are acțiuni sugerate. Apăsați $1 pentru a le selecta.","TRANSCRIPT_LIVE_REGION_SEND_FAILED_ALT":"Trimiterea mesajului nu a reușit.","TRANSCRIPT_MORE_MESSAGES":"Mai multe mesaje","TRANSCRIPT_NEW_MESSAGES":"Mesaje noi","TRANSCRIPT_TERMINATOR_TEXT":"Sf\xe2rșit istoric chat","TYPING_INDICATOR_ALT":"Se afișează indicatorul de tastare","TYPING_INDICATOR_SINGLE_TEXT":"$1 tastează.","TYPING_INDICATOR_MULTIPLE_TEXT":"$1 și alții tastează."}');

});

parcelRequire.register("4MlL2", function(module, exports) {
module.exports = JSON.parse('{"_comment":"[CI-LOCKED] Содержимое этого файла заблокировано. Вы можете вносить изменения, но их проверка может быть задержана.","ACCESS_KEY_ALT":"ALT SHIFT $1","ACCESS_KEY_FOR_MAC_ALT":"CONTROL OPTION $1","ACTIVITY_BOT_SAID_ALT":"Бот $1 сказал:","ACTIVITY_YOU_SAID_ALT":"Вы сказали:","ACTIVITY_BOT_ATTACHED_ALT":"Прикреплено ботом:","ACTIVITY_ERROR_BOX_TITLE":"Сообщение об ошибке","ACTIVITY_INTERACTIVE_FOOTNOTE_ALT":"Щелкните, чтобы взаимодействовать с сообщением.","ACTIVITY_INTERACTIVE_REASON_INTERACTIVE_CONTENT_ALT":"Сообщение является интерактивным.","ACTIVITY_INTERACTIVE_REASON_LINK_ALT":"В сообщении есть одна или несколько ссылок.","ACTIVITY_INTERACTIVE_REASON_SEND_FAILED_ALT":"Сбой отправки.","ACTIVITY_YOU_ATTACHED_ALT":"Прикреплено вами:","ACTIVITY_NUM_ATTACHMENTS_ONE_ALT":"1 вложение.","ACTIVITY_NUM_ATTACHMENTS_FEW_ALT":"$1 вложений.","ACTIVITY_NUM_ATTACHMENTS_MANY_ALT":"$1 вложений.","ACTIVITY_NUM_ATTACHMENTS_OTHER_ALT":"$1 вложения.","ACTIVITY_NUM_ATTACHMENTS_TWO_ALT":"$1 вложения.","ACTIVITY_STATUS_SEND_FAILED_RETRY":"Сбой отправки. [Повторить][RETRY].","ACTIVITY_STATUS_SEND_STATUS_ALT_SENDING":"Отправка","ACTIVITY_STATUS_SEND_STATUS_ALT_SENT_AT":"Отправлено в $1","ACTIVITY_STATUS_TIMESTAMP_JUST_NOW":"Только что","ACTIVITY_STATUS_TIMESTAMP_ONE_HOUR_AGO":"Час назад","ACTIVITY_STATUS_TIMESTAMP_ONE_MINUTE_AGO":"Минуту назад","ACTIVITY_STATUS_TIMESTAMP_TODAY":"Сегодня","ACTIVITY_STATUS_TIMESTAMP_YESTERDAY":"Вчера","ADAPTIVE_CARD_ERROR_BOX_TITLE_PARSE":"Ошибка анализа адаптивной карточки","ADAPTIVE_CARD_ERROR_BOX_TITLE_RENDER":"Ошибка преобразования для просмотра адаптивной карточки","ATTACHMENT_AUDIO":"Аудиоклип.","ATTACHMENT_CARD":"Карточка: $1 $2 $3","ATTACHMENT_FILE":"Файл: $1","ATTACHMENT_IMAGE":"Изображение","ATTACHMENT_TEXT":"Текст: $1","ATTACHMENT_VIDEO":"Видеоклип","CAROUSEL_FLIPPER_LEFT_ALT":"Влево","CAROUSEL_FLIPPER_RIGHT_ALT":"Вправо","CONNECTIVITY_STATUS_ALT_CONNECTED":"Подключено","CONNECTIVITY_STATUS_ALT_CONNECTING":"Подключение…","CONNECTIVITY_STATUS_ALT_FATAL":"Не удается подключиться.","CONNECTIVITY_STATUS_ALT_RECONNECTING":"Произошло прерывание соединения с сетью. Выполняется восстановление связи…","CONNECTIVITY_STATUS_ALT_RENDER_ERROR":"Ошибка преобразования для просмотра. Проверьте консоль или обратитесь к разработчику бота.","CONNECTIVITY_STATUS_ALT_SLOW_CONNECTION":"Для подключения требуется больше времени, чем обычно.","CONNECTIVITY_STATUS_ALT":"Состояние подключения: $1","FILE_CONTENT_ALT":"\'$1\'","FILE_CONTENT_DOWNLOADABLE_ALT":"Загрузить файл \'$1\'","FILE_CONTENT_DOWNLOADABLE_WITH_SIZE_ALT":"Загрузить файл \'$1\' размера $2","FILE_CONTENT_WITH_SIZE_ALT":"\'$1\' размера $2","KEYBOARD_HELP_CHAT_HISTORY_ACCESS_ITEMS_IN_MESSAGE_BODY":"Клавиша ВВОД","KEYBOARD_HELP_CHAT_HISTORY_ACCESS_ITEMS_IN_MESSAGE_HEADER":"Доступ к элементами в сообщении","KEYBOARD_HELP_CHAT_HISTORY_HEADER":"История чата","KEYBOARD_HELP_CHAT_HISTORY_LEAVE_MESSAGE_BODY":"Клавиша ESC","KEYBOARD_HELP_CHAT_HISTORY_LEAVE_MESSAGE_HEADER":"Сообщение при выходе","KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_ITEMS_BODY":"Клавиша TAB\\nКлавиши SHIFT + TAB","KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_ITEMS_HEADER":"Перемещаться между элементами в сообщении","KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_MESSAGES_BODY":"Стрелка вверх\\nСтрелка вниз","KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_MESSAGES_HEADER":"Перемещаться между сообщениями","KEYBOARD_HELP_CHAT_WINDOW_BODY_DO_ACTION_BODY":"Клавиша ВВОД","KEYBOARD_HELP_CHAT_WINDOW_BODY_DO_ACTION_HEADER":"Выполнить действие","KEYBOARD_HELP_CHAT_WINDOW_BODY_MOVE_BETWEEN_ITEMS_BODY":"Клавиша TAB\\nКлавиши SHIFT + TAB","KEYBOARD_HELP_CHAT_WINDOW_BODY_MOVE_BETWEEN_ITEMS_HEADER":"Перемещаться между элементами в окне чата","KEYBOARD_HELP_CHAT_WINDOW_HEADER":"Окно чата","KEYBOARD_HELP_CLOSE_BUTTON_ALT":"Закрыть","KEYBOARD_HELP_HEADER":"Элементы управления клавиатурой","MARKDOWN_EXTERNAL_LINK_ALT":"Открывает в новом окне; внешняя.","RECEIPT_CARD_TAX":"Налог","RECEIPT_CARD_TOTAL":"Итого","RECEIPT_CARD_VAT":"НДС","SEND_BOX_IS_EMPTY_TOOLTIP_ALT":"Невозможно отправить пустое сообщение.","SPEECH_INPUT_LISTENING":"Слушаю…","SPEECH_INPUT_MICROPHONE_BUTTON_CLOSE_ALT":"Микрофон выкл.","SPEECH_INPUT_MICROPHONE_BUTTON_OPEN_ALT":"Микрофон вкл.","SPEECH_INPUT_STARTING":"Начало…","SUGGESTED_ACTIONS_LABEL_ALT":"Предлагаемые действия","TEXT_INPUT_ALT":"Поле ввода сообщения","TEXT_INPUT_PLACEHOLDER":"Введите сообщение","TEXT_INPUT_SEND_BUTTON_ALT":"Отправить","TEXT_INPUT_SPEAK_BUTTON_ALT":"Говорить","TEXT_INPUT_UPLOAD_BUTTON_ALT":"Отправить файл","TOAST_ACCORDION_FEW":"Уведомлений: $1. Щелкните здесь для просмотра сведений","TOAST_ACCORDION_MANY":"Уведомлений: $1. Щелкните здесь для просмотра сведений","TOAST_ACCORDION_OTHER":"Уведомлений: $1. Щелкните здесь для просмотра сведений","TOAST_ACCORDION_TWO":"Уведомлений: $1. Щелкните здесь для просмотра сведений","TOAST_ALT_ERROR":"Ошибка","TOAST_ALT_INFO":"Сведения","TOAST_ALT_SUCCESS":"Успешно завершено","TOAST_ALT_WARN":"Предупреждение","TOAST_DISMISS_BUTTON":"Закрыть","TOAST_TITLE_ALT":"Уведомление","TRANSCRIPT_ARIA_LABEL_ALT":"История чата, используйте клавиши со стрелками для перемещения.","TRANSCRIPT_ARIA_ROLE_ALT":"история чата","TRANSCRIPT_LIVE_REGION_INTERACTIVE_LABEL_ALT":"Сообщение интерактивно. Для перехода к истории чата нажмите клавиши SHIFT + TAB 2-3 раза. Затем выберите сообщение для взаимодействия.","TRANSCRIPT_LIVE_REGION_INTERACTIVE_WITH_LINKS_LABEL_ALT":"В сообщении есть одна или несколько ссылок. Для перехода к истории чата нажмите клавиши SHIFT + TAB 2-3 раза. Затем выберите сообщение для взаимодействия.","TRANSCRIPT_LIVE_REGION_SUGGESTED_ACTIONS_LABEL_ALT":"Для сообщения есть предлагаемые действия. Нажмите SHIFT TAB 2 или 3 раза, чтобы выбрать нужное.","TRANSCRIPT_LIVE_REGION_SUGGESTED_ACTIONS_WITH_ACCESS_KEY_LABEL_ALT":"Для сообщения есть предлагаемые действия. Нажмите $1, чтобы выбрать нужное.","TRANSCRIPT_LIVE_REGION_SEND_FAILED_ALT":"Не удалось отправить сообщение.","TRANSCRIPT_MORE_MESSAGES":"Другие сообщения","TRANSCRIPT_NEW_MESSAGES":"Новые сообщения","TRANSCRIPT_TERMINATOR_TEXT":"Конец истории чата","TYPING_INDICATOR_ALT":"Отображение индикатора ввода","TYPING_INDICATOR_SINGLE_TEXT":"$1 вводит текст.","TYPING_INDICATOR_MULTIPLE_TEXT":"$1 и другие вводят текст."}');

});

parcelRequire.register("4TRE2", function(module, exports) {
module.exports = JSON.parse('{"_comment":"[CI-LOCKED] Obsah tohto s\xfaboru je zamknut\xfd. Pr\xedspevky s\xfa v\xedtan\xe9, ale overenie zmien sa m\xf4že oneskoriť.","ACCESS_KEY_ALT":"Alt + Shift + $1","ACCESS_KEY_FOR_MAC_ALT":"Control + Option + $1","ACTIVITY_BOT_SAID_ALT":"Robot $1 povedal:","ACTIVITY_YOU_SAID_ALT":"Povedali ste:","ACTIVITY_BOT_ATTACHED_ALT":"Robot priložil:","ACTIVITY_ERROR_BOX_TITLE":"Chybov\xe9 hl\xe1senie","ACTIVITY_INTERACTIVE_FOOTNOTE_ALT":"Kliknut\xedm m\xf4žete vykonať interakciu.","ACTIVITY_INTERACTIVE_REASON_INTERACTIVE_CONTENT_ALT":"Spr\xe1va je interakt\xedvna.","ACTIVITY_INTERACTIVE_REASON_LINK_ALT":"Najmenej jedno prepojenie v\xa0spr\xe1ve.","ACTIVITY_INTERACTIVE_REASON_SEND_FAILED_ALT":"Odoslanie zlyhalo.","ACTIVITY_YOU_ATTACHED_ALT":"Priložili ste:","ACTIVITY_NUM_ATTACHMENTS_ONE_ALT":"1\xa0pr\xedloha.","ACTIVITY_NUM_ATTACHMENTS_FEW_ALT":"$1 pr\xedlohy.","ACTIVITY_NUM_ATTACHMENTS_MANY_ALT":"$1 pr\xedlohy.","ACTIVITY_NUM_ATTACHMENTS_OTHER_ALT":"$1 pr\xedloh.","ACTIVITY_NUM_ATTACHMENTS_TWO_ALT":"$1 pr\xedlohy.","ACTIVITY_STATUS_SEND_FAILED_RETRY":"Odoslanie zlyhalo. [Sk\xfasiť znova][RETRY]","ACTIVITY_STATUS_SEND_STATUS_ALT_SENDING":"Odosiela sa","ACTIVITY_STATUS_SEND_STATUS_ALT_SENT_AT":"Odoslan\xe9 o\xa0$1","ACTIVITY_STATUS_TIMESTAMP_JUST_NOW":"Pr\xe1ve teraz","ACTIVITY_STATUS_TIMESTAMP_ONE_HOUR_AGO":"Pred hodinou","ACTIVITY_STATUS_TIMESTAMP_ONE_MINUTE_AGO":"Pred min\xfatou","ACTIVITY_STATUS_TIMESTAMP_TODAY":"Dnes","ACTIVITY_STATUS_TIMESTAMP_YESTERDAY":"Včera","ADAPTIVE_CARD_ERROR_BOX_TITLE_PARSE":"Chyba anal\xfdzy adapt\xedvnej karty","ADAPTIVE_CARD_ERROR_BOX_TITLE_RENDER":"Chyba vykreslenia adapt\xedvnej karty","ATTACHMENT_AUDIO":"Zvukov\xfd klip.","ATTACHMENT_CARD":"Karta: $1 $2 $3","ATTACHMENT_FILE":"S\xfabor: $1","ATTACHMENT_IMAGE":"Obr\xe1zok","ATTACHMENT_TEXT":"Text: $1","ATTACHMENT_VIDEO":"Videoklip","CAROUSEL_FLIPPER_LEFT_ALT":"Vľavo","CAROUSEL_FLIPPER_RIGHT_ALT":"Vpravo","CONNECTIVITY_STATUS_ALT_CONNECTED":"Pripojen\xe9","CONNECTIVITY_STATUS_ALT_CONNECTING":"Prip\xe1ja sa...","CONNECTIVITY_STATUS_ALT_FATAL":"Pripojenie sa nepodarilo.","CONNECTIVITY_STATUS_ALT_RECONNECTING":"Vyskytlo sa prerušenie siete. Prebieha op\xe4tovn\xe9 prip\xe1janie...","CONNECTIVITY_STATUS_ALT_RENDER_ERROR":"Chyba vykreslenia. Skontrolujte konzolu alebo sa obr\xe1ťte na v\xfdvoj\xe1ra bota.","CONNECTIVITY_STATUS_ALT_SLOW_CONNECTION":"Pripojenie trv\xe1 dlhšie ako zvyčajne.","CONNECTIVITY_STATUS_ALT":"Stav pripojenia: $1","FILE_CONTENT_ALT":"$1","FILE_CONTENT_DOWNLOADABLE_ALT":"Stiahnuť s\xfabor $1","FILE_CONTENT_DOWNLOADABLE_WITH_SIZE_ALT":"Stiahnuť s\xfabor $1 s\xa0veľkosťou $2","FILE_CONTENT_WITH_SIZE_ALT":"$1 s\xa0veľkosťou $2","KEYBOARD_HELP_CHAT_HISTORY_ACCESS_ITEMS_IN_MESSAGE_BODY":"Kl\xe1ves Enter","KEYBOARD_HELP_CHAT_HISTORY_ACCESS_ITEMS_IN_MESSAGE_HEADER":"Z\xedskajte pr\xedstup k\xa0položk\xe1m v\xa0spr\xe1ve","KEYBOARD_HELP_CHAT_HISTORY_HEADER":"Hist\xf3ria konverz\xe1cie","KEYBOARD_HELP_CHAT_HISTORY_LEAVE_MESSAGE_BODY":"Kl\xe1ves Escape","KEYBOARD_HELP_CHAT_HISTORY_LEAVE_MESSAGE_HEADER":"Ukončiť zobrazenie spr\xe1vy","KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_ITEMS_BODY":"Kl\xe1ves Tab\\nKl\xe1vesy Shift + Tab","KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_ITEMS_HEADER":"Prech\xe1dzajte medzi položkami v\xa0spr\xe1ve","KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_MESSAGES_BODY":"Kl\xe1ves so š\xedpkou nahor\\nKl\xe1ves so š\xedpkou nadol","KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_MESSAGES_HEADER":"Prech\xe1dzajte medzi spr\xe1vami","KEYBOARD_HELP_CHAT_WINDOW_BODY_DO_ACTION_BODY":"Kl\xe1ves Enter","KEYBOARD_HELP_CHAT_WINDOW_BODY_DO_ACTION_HEADER":"Vykonajte akciu","KEYBOARD_HELP_CHAT_WINDOW_BODY_MOVE_BETWEEN_ITEMS_BODY":"Kl\xe1ves Tab\\nKl\xe1vesy Shift + Tab","KEYBOARD_HELP_CHAT_WINDOW_BODY_MOVE_BETWEEN_ITEMS_HEADER":"Prech\xe1dzajte medzi položkami v\xa0okne konverz\xe1cie","KEYBOARD_HELP_CHAT_WINDOW_HEADER":"Okno konverz\xe1cie","KEYBOARD_HELP_CLOSE_BUTTON_ALT":"Zavrieť","KEYBOARD_HELP_HEADER":"Ovl\xe1dacie prvky kl\xe1vesnice","MARKDOWN_EXTERNAL_LINK_ALT":"Otvor\xed sa v\xa0novom okne, extern\xe9.","RECEIPT_CARD_TAX":"Daň","RECEIPT_CARD_TOTAL":"Celkov\xfd počet","RECEIPT_CARD_VAT":"DPH","SEND_BOX_IS_EMPTY_TOOLTIP_ALT":"Pr\xe1zdnu spr\xe1vu nemožno odoslať.","SPEECH_INPUT_LISTENING":"Poč\xfavanie...","SPEECH_INPUT_MICROPHONE_BUTTON_CLOSE_ALT":"Vypn\xfať mikrof\xf3n","SPEECH_INPUT_MICROPHONE_BUTTON_OPEN_ALT":"Zapn\xfať mikrof\xf3n","SPEECH_INPUT_STARTING":"Sp\xfašťa sa...","SUGGESTED_ACTIONS_LABEL_ALT":"Navrhovan\xe9 akcie","TEXT_INPUT_ALT":"Vstupn\xe9 pole pre spr\xe1vu","TEXT_INPUT_PLACEHOLDER":"Zadajte svoju spr\xe1vu","TEXT_INPUT_SEND_BUTTON_ALT":"Odoslať","TEXT_INPUT_SPEAK_BUTTON_ALT":"Č\xedtať","TEXT_INPUT_UPLOAD_BUTTON_ALT":"Nahrať s\xfabor","TOAST_ACCORDION_FEW":"Počet ozn\xe1men\xed: $1 – kliknut\xedm sem sa zobrazia podrobnosti","TOAST_ACCORDION_MANY":"Počet ozn\xe1men\xed: $1 – kliknut\xedm sem sa zobrazia podrobnosti","TOAST_ACCORDION_OTHER":"Počet ozn\xe1men\xed: $1 – kliknut\xedm sem sa zobrazia podrobnosti","TOAST_ACCORDION_TWO":"Počet ozn\xe1men\xed: $1 – kliknut\xedm sem sa zobrazia podrobnosti","TOAST_ALT_ERROR":"Chyba","TOAST_ALT_INFO":"Inform\xe1cie","TOAST_ALT_SUCCESS":"\xdaspešn\xe9","TOAST_ALT_WARN":"Upozornenie","TOAST_DISMISS_BUTTON":"Zrušiť","TOAST_TITLE_ALT":"Ozn\xe1menie","TRANSCRIPT_ARIA_LABEL_ALT":"Hist\xf3ria konverz\xe1cie – na navig\xe1ciu stlačte kl\xe1vesy so š\xedpkami.","TRANSCRIPT_ARIA_ROLE_ALT":"hist\xf3ria konverz\xe1cie","TRANSCRIPT_LIVE_REGION_INTERACTIVE_LABEL_ALT":"Spr\xe1va je interakt\xedvna. Stlačen\xedm kl\xe1vesov Shift a\xa0Tab 2- až 3-kr\xe1t prepnete do hist\xf3rie konverz\xe1cie. Potom m\xf4žete interagovať kliknut\xedm na spr\xe1vu.","TRANSCRIPT_LIVE_REGION_INTERACTIVE_WITH_LINKS_LABEL_ALT":"Najmenej jedno prepojenie v\xa0spr\xe1ve. Stlačen\xedm kl\xe1vesov Shift a\xa0Tab 2- až 3-kr\xe1t prepnete do hist\xf3rie konverz\xe1cie. Potom m\xf4žete interagovať kliknut\xedm na spr\xe1vu.","TRANSCRIPT_LIVE_REGION_SUGGESTED_ACTIONS_LABEL_ALT":"Spr\xe1va obsahuje navrhovan\xe9 akcie. Vyberte ich stlačen\xedm kl\xe1vesov Shift + Tab 2 až 3-kr\xe1t.","TRANSCRIPT_LIVE_REGION_SUGGESTED_ACTIONS_WITH_ACCESS_KEY_LABEL_ALT":"Spr\xe1va obsahuje navrhovan\xe9 akcie. Vyberte ich stlačen\xedm kl\xe1vesu $1.","TRANSCRIPT_LIVE_REGION_SEND_FAILED_ALT":"Nepodarilo sa odoslať spr\xe1vu.","TRANSCRIPT_MORE_MESSAGES":"Ďalšie spr\xe1vy","TRANSCRIPT_NEW_MESSAGES":"Nov\xe9 spr\xe1vy","TRANSCRIPT_TERMINATOR_TEXT":"Koniec hist\xf3rie konverz\xe1cie","TYPING_INDICATOR_ALT":"Zobrazuje sa indik\xe1tor p\xedsania","TYPING_INDICATOR_SINGLE_TEXT":"$1\xa0p\xedše.","TYPING_INDICATOR_MULTIPLE_TEXT":"$1\xa0a\xa0ďalš\xed p\xedšu."}');

});

parcelRequire.register("llOan", function(module, exports) {
module.exports = JSON.parse('{"_comment":"[CI-LOCKED] Vsebina te datoteke je zaklenjena. Prispevki so dobrodošli, vendar je preverjanje sprememb lahko zakasnjeno.","ACCESS_KEY_ALT":"Alt Shift $1","ACCESS_KEY_FOR_MAC_ALT":"Control Option $1","ACTIVITY_BOT_SAID_ALT":"Bot $1 je rekel:","ACTIVITY_YOU_SAID_ALT":"Rekli ste:","ACTIVITY_BOT_ATTACHED_ALT":"Bot je priložil:","ACTIVITY_ERROR_BOX_TITLE":"Sporočilo o napaki","ACTIVITY_INTERACTIVE_FOOTNOTE_ALT":"Kliknite za interakcijo.","ACTIVITY_INTERACTIVE_REASON_INTERACTIVE_CONTENT_ALT":"Sporočilo je interaktivno.","ACTIVITY_INTERACTIVE_REASON_LINK_ALT":"V sporočilu je ena ali več povezav.","ACTIVITY_INTERACTIVE_REASON_SEND_FAILED_ALT":"Pošiljanje ni uspelo.","ACTIVITY_YOU_ATTACHED_ALT":"Priložili ste:","ACTIVITY_NUM_ATTACHMENTS_ONE_ALT":"1 priloga.","ACTIVITY_NUM_ATTACHMENTS_FEW_ALT":"$1 priloge.","ACTIVITY_NUM_ATTACHMENTS_MANY_ALT":"$1 prilog.","ACTIVITY_NUM_ATTACHMENTS_OTHER_ALT":"$1 prilog.","ACTIVITY_NUM_ATTACHMENTS_TWO_ALT":"$1 prilogi.","ACTIVITY_STATUS_SEND_FAILED_RETRY":"Pošiljanje ni uspelo. [Vnovični poskus][RETRY].","ACTIVITY_STATUS_SEND_STATUS_ALT_SENDING":"Pošiljanje","ACTIVITY_STATUS_SEND_STATUS_ALT_SENT_AT":"Poslano: $1","ACTIVITY_STATUS_TIMESTAMP_JUST_NOW":"Zdaj","ACTIVITY_STATUS_TIMESTAMP_ONE_HOUR_AGO":"Pred uro","ACTIVITY_STATUS_TIMESTAMP_ONE_MINUTE_AGO":"Pred minuto","ACTIVITY_STATUS_TIMESTAMP_TODAY":"danes","ACTIVITY_STATUS_TIMESTAMP_YESTERDAY":"včeraj","ADAPTIVE_CARD_ERROR_BOX_TITLE_PARSE":"Napaka pri razčlenjevanju prilagodljive kartice","ADAPTIVE_CARD_ERROR_BOX_TITLE_RENDER":"Napaka pri upodabljanju prilagodljive kartice","ATTACHMENT_AUDIO":"Zvočni posnetek.","ATTACHMENT_CARD":"Kartica: $1 $2 $3","ATTACHMENT_FILE":"Datoteka: $1","ATTACHMENT_IMAGE":"Slika","ATTACHMENT_TEXT":"Besedilo: $1","ATTACHMENT_VIDEO":"Videoposnetek","CAROUSEL_FLIPPER_LEFT_ALT":"Levo","CAROUSEL_FLIPPER_RIGHT_ALT":"Desno","CONNECTIVITY_STATUS_ALT_CONNECTED":"Povezava je vzpostavljena.","CONNECTIVITY_STATUS_ALT_CONNECTING":"Povezovanje …","CONNECTIVITY_STATUS_ALT_FATAL":"Povezave ni mogoče vzpostaviti.","CONNECTIVITY_STATUS_ALT_RECONNECTING":"Prišlo je do omrežne prekinitve. Vnovično povezovanje …","CONNECTIVITY_STATUS_ALT_RENDER_ERROR":"Napaka pri upodabljanju. Preverite konzolo ali se obrnite na razvijalca bota.","CONNECTIVITY_STATUS_ALT_SLOW_CONNECTION":"Povezovanje traja dlje kot običajno.","CONNECTIVITY_STATUS_ALT":"Stanje povezave: $1","FILE_CONTENT_ALT":"\xbb$1\xab","FILE_CONTENT_DOWNLOADABLE_ALT":"Prenesi datoteko \xbb$1\xab","FILE_CONTENT_DOWNLOADABLE_WITH_SIZE_ALT":"Prenos datoteke \xbb$1\xab velikosti $2","FILE_CONTENT_WITH_SIZE_ALT":"\xbb$1\xab velikosti $2","KEYBOARD_HELP_CHAT_HISTORY_ACCESS_ITEMS_IN_MESSAGE_BODY":"Tipka Enter","KEYBOARD_HELP_CHAT_HISTORY_ACCESS_ITEMS_IN_MESSAGE_HEADER":"Dostop do elementov v sporočilu","KEYBOARD_HELP_CHAT_HISTORY_HEADER":"Zgodovina klepeta","KEYBOARD_HELP_CHAT_HISTORY_LEAVE_MESSAGE_BODY":"Tipka Escape","KEYBOARD_HELP_CHAT_HISTORY_LEAVE_MESSAGE_HEADER":"Izhod iz sporočila","KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_ITEMS_BODY":"Tabulatorka\\nShift + tabulatorka","KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_ITEMS_HEADER":"Premikanje med elementi v sporočilu","KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_MESSAGES_BODY":"Tipka s puščico gor\\nTipka s puščico dol","KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_MESSAGES_HEADER":"Premikanje med sporočili","KEYBOARD_HELP_CHAT_WINDOW_BODY_DO_ACTION_BODY":"Tipka Enter","KEYBOARD_HELP_CHAT_WINDOW_BODY_DO_ACTION_HEADER":"Izvedba dejanja","KEYBOARD_HELP_CHAT_WINDOW_BODY_MOVE_BETWEEN_ITEMS_BODY":"Tabulatorka\\nShift + tabulatorka","KEYBOARD_HELP_CHAT_WINDOW_BODY_MOVE_BETWEEN_ITEMS_HEADER":"Pomikanje med elementi v oknu za klepet","KEYBOARD_HELP_CHAT_WINDOW_HEADER":"Okno za klepet","KEYBOARD_HELP_CLOSE_BUTTON_ALT":"Zapri","KEYBOARD_HELP_HEADER":"Kontrolniki na tipkovnici","MARKDOWN_EXTERNAL_LINK_ALT":"Odpre se v novem oknu; zunanje.","RECEIPT_CARD_TAX":"Davek","RECEIPT_CARD_TOTAL":"Skupaj","RECEIPT_CARD_VAT":"DDV","SEND_BOX_IS_EMPTY_TOOLTIP_ALT":"Praznega sporočila ni mogoče poslati.","SPEECH_INPUT_LISTENING":"Poslušanje …","SPEECH_INPUT_MICROPHONE_BUTTON_CLOSE_ALT":"Mikrofon je izklopljen","SPEECH_INPUT_MICROPHONE_BUTTON_OPEN_ALT":"Mikrofon je vklopljen","SPEECH_INPUT_STARTING":"Začetek …","SUGGESTED_ACTIONS_LABEL_ALT":"Predlagana dejanja","TEXT_INPUT_ALT":"Polje za vnos sporočila","TEXT_INPUT_PLACEHOLDER":"Vnesite sporočilo","TEXT_INPUT_SEND_BUTTON_ALT":"Pošlji","TEXT_INPUT_SPEAK_BUTTON_ALT":"Govor","TEXT_INPUT_UPLOAD_BUTTON_ALT":"Naloži datoteko","TOAST_ACCORDION_FEW":"Obvestila: $1 – za podrobnosti kliknite tukaj","TOAST_ACCORDION_MANY":"Obvestila: $1 – za podrobnosti kliknite tukaj","TOAST_ACCORDION_OTHER":"Obvestila: $1 – za podrobnosti kliknite tukaj","TOAST_ACCORDION_TWO":"Obvestila: $1 – za podrobnosti kliknite tukaj","TOAST_ALT_ERROR":"Napaka","TOAST_ALT_INFO":"Informacije","TOAST_ALT_SUCCESS":"Uspelo je","TOAST_ALT_WARN":"Opozorilo","TOAST_DISMISS_BUTTON":"Opusti","TOAST_TITLE_ALT":"Obvestilo","TRANSCRIPT_ARIA_LABEL_ALT":"Zgodovina klepeta – za pomikanje pritisnite tipke s puščico.","TRANSCRIPT_ARIA_ROLE_ALT":"zgodovina klepeta","TRANSCRIPT_LIVE_REGION_INTERACTIVE_LABEL_ALT":"Sporočilo je interaktivno. Dvakrat ali trikrat pritisnite tipko shift in tabulatorko, da preklopite na zgodovino klepeta. Nato kliknite sporočilo za interakcijo z njim.","TRANSCRIPT_LIVE_REGION_INTERACTIVE_WITH_LINKS_LABEL_ALT":"V sporočilu je ena ali več povezav. Dvakrat ali trikrat pritisnite tipko shift in tabulatorko, da preklopite na zgodovino klepeta. Nato kliknite sporočilo za interakcijo z njim.","TRANSCRIPT_LIVE_REGION_SUGGESTED_ACTIONS_LABEL_ALT":"Sporočilo ima predlagana dejanja. 2- do 3-krat pritisnite dvigalko in tabulatorko, da jih izberete.","TRANSCRIPT_LIVE_REGION_SUGGESTED_ACTIONS_WITH_ACCESS_KEY_LABEL_ALT":"Sporočilo ima predlagana dejanja. Pritisnite $1, da jih izberete.","TRANSCRIPT_LIVE_REGION_SEND_FAILED_ALT":"Sporočila ni bilo mogoče poslati.","TRANSCRIPT_MORE_MESSAGES":"Več sporočil","TRANSCRIPT_NEW_MESSAGES":"Nova sporočila","TRANSCRIPT_TERMINATOR_TEXT":"Konec zgodovine klepeta","TYPING_INDICATOR_ALT":"Prikaz indikatorja tipkanja","TYPING_INDICATOR_SINGLE_TEXT":"$1 tipka.","TYPING_INDICATOR_MULTIPLE_TEXT":"$1 in drugi tipkajo."}');

});

parcelRequire.register("4QVZI", function(module, exports) {
module.exports = JSON.parse('{"_comment":"[CI-LOCKED] Садржај ове датотеке је закључан. Доприноси су добродошли, али потврда промене може бити одложена.","ACCESS_KEY_ALT":"Alt Shift $1","ACCESS_KEY_FOR_MAC_ALT":"Control Option $1","ACTIVITY_BOT_SAID_ALT":"Робот $1 је рекао:","ACTIVITY_YOU_SAID_ALT":"Ви сте рекли:","ACTIVITY_BOT_ATTACHED_ALT":"Робот је приложио:","ACTIVITY_ERROR_BOX_TITLE":"Порука о грешци","ACTIVITY_INTERACTIVE_FOOTNOTE_ALT":"Кликните за интеракцију.","ACTIVITY_INTERACTIVE_REASON_INTERACTIVE_CONTENT_ALT":"Поруке су неактивне.","ACTIVITY_INTERACTIVE_REASON_LINK_ALT":"Порука садржи везе.","ACTIVITY_INTERACTIVE_REASON_SEND_FAILED_ALT":"Слање није успело.","ACTIVITY_YOU_ATTACHED_ALT":"Приложили сте:","ACTIVITY_NUM_ATTACHMENTS_ONE_ALT":"1 прилог.","ACTIVITY_NUM_ATTACHMENTS_FEW_ALT":"$1 прилога.","ACTIVITY_NUM_ATTACHMENTS_MANY_ALT":"$1 прилога.","ACTIVITY_NUM_ATTACHMENTS_OTHER_ALT":"$1 прилога.","ACTIVITY_NUM_ATTACHMENTS_TWO_ALT":"$1 прилога.","ACTIVITY_STATUS_SEND_FAILED_RETRY":"Слање није успело. [Поново покушај] [RETRY].","ACTIVITY_STATUS_SEND_STATUS_ALT_SENDING":"Слање","ACTIVITY_STATUS_SEND_STATUS_ALT_SENT_AT":"Послато у $1","ACTIVITY_STATUS_TIMESTAMP_JUST_NOW":"Малопре","ACTIVITY_STATUS_TIMESTAMP_ONE_HOUR_AGO":"Пре сат времена","ACTIVITY_STATUS_TIMESTAMP_ONE_MINUTE_AGO":"Пре једног минута","ACTIVITY_STATUS_TIMESTAMP_TODAY":"Данас","ACTIVITY_STATUS_TIMESTAMP_YESTERDAY":"Јуче","ADAPTIVE_CARD_ERROR_BOX_TITLE_PARSE":"Грешка у рашчлањивању прилагодљиве картице","ADAPTIVE_CARD_ERROR_BOX_TITLE_RENDER":"Грешка у приказивању прилагодљиве картице","ATTACHMENT_AUDIO":"Аудио клип.","ATTACHMENT_CARD":"Картица: $1 $2 $3","ATTACHMENT_FILE":"Датотека: $1","ATTACHMENT_IMAGE":"Слика","ATTACHMENT_TEXT":"Текст: $1","ATTACHMENT_VIDEO":"Видео клип","CAROUSEL_FLIPPER_LEFT_ALT":"Лево","CAROUSEL_FLIPPER_RIGHT_ALT":"Десно","CONNECTIVITY_STATUS_ALT_CONNECTED":"Повезано","CONNECTIVITY_STATUS_ALT_CONNECTING":"Повезивање…","CONNECTIVITY_STATUS_ALT_FATAL":"Повезивање није могуће.","CONNECTIVITY_STATUS_ALT_RECONNECTING":"Дошло је до прекида мреже. Поновно повезивање…","CONNECTIVITY_STATUS_ALT_RENDER_ERROR":"Грешка у приказивању. Проверите конзолу или се обратите програмеру робота.","CONNECTIVITY_STATUS_ALT_SLOW_CONNECTION":"Повезивање траје дуже него иначе.","CONNECTIVITY_STATUS_ALT":"Статус повезивања: $1","FILE_CONTENT_ALT":"„$1“","FILE_CONTENT_DOWNLOADABLE_ALT":"Преузимање датотеке „$1“","FILE_CONTENT_DOWNLOADABLE_WITH_SIZE_ALT":"Преузмите датотеку „$1“ величине $2","FILE_CONTENT_WITH_SIZE_ALT":"„$1“ величине $2","KEYBOARD_HELP_CHAT_HISTORY_ACCESS_ITEMS_IN_MESSAGE_BODY":"Тастер Enter","KEYBOARD_HELP_CHAT_HISTORY_ACCESS_ITEMS_IN_MESSAGE_HEADER":"Приступ ставкама у поруци","KEYBOARD_HELP_CHAT_HISTORY_HEADER":"Историја ћаскања","KEYBOARD_HELP_CHAT_HISTORY_LEAVE_MESSAGE_BODY":"Тастер Escape","KEYBOARD_HELP_CHAT_HISTORY_LEAVE_MESSAGE_HEADER":"Порука на излазу","KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_ITEMS_BODY":"Тастер Tab\\nShift + тастер Tab","KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_ITEMS_HEADER":"Прелазак са једне ставке на другу у поруци","KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_MESSAGES_BODY":"Тастер са стрелицом нагоре\\nТастер са стрелицом надоле","KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_MESSAGES_HEADER":"Прелазак са једне поруке на другу","KEYBOARD_HELP_CHAT_WINDOW_BODY_DO_ACTION_BODY":"Тастер Enter","KEYBOARD_HELP_CHAT_WINDOW_BODY_DO_ACTION_HEADER":"Обављање радње","KEYBOARD_HELP_CHAT_WINDOW_BODY_MOVE_BETWEEN_ITEMS_BODY":"Тастер Tab\\nShift + тастер Tab","KEYBOARD_HELP_CHAT_WINDOW_BODY_MOVE_BETWEEN_ITEMS_HEADER":"Прелазак са једне ставке на другу у прозору за ћаскање","KEYBOARD_HELP_CHAT_WINDOW_HEADER":"Прозор за ћаскање","KEYBOARD_HELP_CLOSE_BUTTON_ALT":"Затвори","KEYBOARD_HELP_HEADER":"Тастерске контроле","MARKDOWN_EXTERNAL_LINK_ALT":"Отвара се у новом прозору; спољно.","RECEIPT_CARD_TAX":"Порез","RECEIPT_CARD_TOTAL":"Укупно","RECEIPT_CARD_VAT":"ПДВ","SEND_BOX_IS_EMPTY_TOOLTIP_ALT":"Није могуће послати празну поруку.","SPEECH_INPUT_LISTENING":"Слушамо...","SPEECH_INPUT_MICROPHONE_BUTTON_CLOSE_ALT":"Микрофон је искључен","SPEECH_INPUT_MICROPHONE_BUTTON_OPEN_ALT":"Микрофон је укључен","SPEECH_INPUT_STARTING":"Почиње…","SUGGESTED_ACTIONS_LABEL_ALT":"Предложене радње","TEXT_INPUT_ALT":"Поље за унос поруке","TEXT_INPUT_PLACEHOLDER":"Откуцајте поруку","TEXT_INPUT_SEND_BUTTON_ALT":"Пошаљи","TEXT_INPUT_SPEAK_BUTTON_ALT":"Изговорите","TEXT_INPUT_UPLOAD_BUTTON_ALT":"Отпреми датотеку","TOAST_ACCORDION_FEW":"$1 обавештења: Кликните овде да бисте видели детаље","TOAST_ACCORDION_MANY":"$1 обавештења: Кликните овде да бисте видели детаље","TOAST_ACCORDION_OTHER":"$1 обавештења: Кликните овде да бисте видели детаље","TOAST_ACCORDION_TWO":"$1 обавештења: Кликните овде да бисте видели детаље","TOAST_ALT_ERROR":"Грешка","TOAST_ALT_INFO":"Информације","TOAST_ALT_SUCCESS":"Успешно","TOAST_ALT_WARN":"Упозорење","TOAST_DISMISS_BUTTON":"Одбаци","TOAST_TITLE_ALT":"Обавештење","TRANSCRIPT_ARIA_LABEL_ALT":"Историја ћаскања, користите тастере са стрелицом да бисте се кретали.","TRANSCRIPT_ARIA_ROLE_ALT":"историја ћаскања","TRANSCRIPT_LIVE_REGION_INTERACTIVE_LABEL_ALT":"Порука је интерактивна. Притисните тастере Shift и Тab 2 до 3 пута да бисте се пребацили на историју ћаскања. Затим кликните на поруку да бисте остварили интеракцију.","TRANSCRIPT_LIVE_REGION_INTERACTIVE_WITH_LINKS_LABEL_ALT":"Порука садржи везе. Притисните тастере Shift и Тab 2 до 3 пута да бисте се пребацили на историју ћаскања. Затим кликните на поруку да бисте остварили интеракцију.","TRANSCRIPT_LIVE_REGION_SUGGESTED_ACTIONS_LABEL_ALT":"Порука има предложене радње. Притисните тастере shift tab 2 до 3 пута како бисте их изабрали.","TRANSCRIPT_LIVE_REGION_SUGGESTED_ACTIONS_WITH_ACCESS_KEY_LABEL_ALT":"Порука има предложене радње. Притисните $1 како бисте их изабрали.","TRANSCRIPT_LIVE_REGION_SEND_FAILED_ALT":"Слање поруке није успело.","TRANSCRIPT_MORE_MESSAGES":"Још порука","TRANSCRIPT_NEW_MESSAGES":"Нове поруке","TRANSCRIPT_TERMINATOR_TEXT":"Крај историје ћаскања","TYPING_INDICATOR_ALT":"Приказује се индикатор куцања","TYPING_INDICATOR_SINGLE_TEXT":"$1 куца.","TYPING_INDICATOR_MULTIPLE_TEXT":"$1 и други куцају."}');

});

parcelRequire.register("9sLtU", function(module, exports) {
module.exports = JSON.parse('{"_comment":"[CI-LOCKED] Sadržaj ove datoteke je zaključan. Doprinosi su dobrodošli, ali potvrda promene može biti odložena.","ACCESS_KEY_ALT":"Alt Shift $1","ACCESS_KEY_FOR_MAC_ALT":"Control Option $1","ACTIVITY_BOT_SAID_ALT":"Robot $1 je rekao:","ACTIVITY_YOU_SAID_ALT":"Vi ste rekli:","ACTIVITY_BOT_ATTACHED_ALT":"Robot je priložio:","ACTIVITY_ERROR_BOX_TITLE":"Poruka o grešci","ACTIVITY_INTERACTIVE_FOOTNOTE_ALT":"Kliknite za interakciju.","ACTIVITY_INTERACTIVE_REASON_INTERACTIVE_CONTENT_ALT":"Poruka je interaktivna.","ACTIVITY_INTERACTIVE_REASON_LINK_ALT":"Poruka sadrži jednu vez ili više njih.","ACTIVITY_INTERACTIVE_REASON_SEND_FAILED_ALT":"Slanje nije uspelo.","ACTIVITY_YOU_ATTACHED_ALT":"Priložili ste:","ACTIVITY_NUM_ATTACHMENTS_ONE_ALT":"1 prilog.","ACTIVITY_NUM_ATTACHMENTS_FEW_ALT":"$1 priloga.","ACTIVITY_NUM_ATTACHMENTS_MANY_ALT":"$1 priloga.","ACTIVITY_NUM_ATTACHMENTS_OTHER_ALT":"$1 priloga.","ACTIVITY_NUM_ATTACHMENTS_TWO_ALT":"$1 priloga.","ACTIVITY_STATUS_SEND_FAILED_RETRY":"Slanje nije uspelo. [Ponovo pokušaj] [RETRY].","ACTIVITY_STATUS_SEND_STATUS_ALT_SENDING":"Slanje","ACTIVITY_STATUS_SEND_STATUS_ALT_SENT_AT":"Poslato u $1","ACTIVITY_STATUS_TIMESTAMP_JUST_NOW":"Malopre","ACTIVITY_STATUS_TIMESTAMP_ONE_HOUR_AGO":"Pre sat vremena","ACTIVITY_STATUS_TIMESTAMP_ONE_MINUTE_AGO":"Pre jednog minuta","ACTIVITY_STATUS_TIMESTAMP_TODAY":"Danas","ACTIVITY_STATUS_TIMESTAMP_YESTERDAY":"Juče","ADAPTIVE_CARD_ERROR_BOX_TITLE_PARSE":"Greška u raščlanjivanju prilagodljive kartice","ADAPTIVE_CARD_ERROR_BOX_TITLE_RENDER":"Greška u prikazivanju prilagodljive kartice","ATTACHMENT_AUDIO":"Audio klip.","ATTACHMENT_CARD":"Kartica: $1 $2 $3","ATTACHMENT_FILE":"Datoteka: $1","ATTACHMENT_IMAGE":"Slika","ATTACHMENT_TEXT":"Tekst: $1","ATTACHMENT_VIDEO":"Video klip","CAROUSEL_FLIPPER_LEFT_ALT":"Levo","CAROUSEL_FLIPPER_RIGHT_ALT":"Desno","CONNECTIVITY_STATUS_ALT_CONNECTED":"Povezano","CONNECTIVITY_STATUS_ALT_CONNECTING":"Povezivanje…","CONNECTIVITY_STATUS_ALT_FATAL":"Povezivanje nije moguće.","CONNECTIVITY_STATUS_ALT_RECONNECTING":"Došlo je do prekida mreže. Ponovno povezivanje…","CONNECTIVITY_STATUS_ALT_RENDER_ERROR":"Greška u prikazivanju. Proverite konzolu ili se obratite programeru robota.","CONNECTIVITY_STATUS_ALT_SLOW_CONNECTION":"Povezivanje traje duže nego inače.","CONNECTIVITY_STATUS_ALT":"Status povezivanja: $1","FILE_CONTENT_ALT":"„$1“","FILE_CONTENT_DOWNLOADABLE_ALT":"Preuzimanje datoteke „$1“","FILE_CONTENT_DOWNLOADABLE_WITH_SIZE_ALT":"Preuzmite datoteku „$1“ veličine $2","FILE_CONTENT_WITH_SIZE_ALT":"„$1“ veličine $2","KEYBOARD_HELP_CHAT_HISTORY_ACCESS_ITEMS_IN_MESSAGE_BODY":"Taster Enter","KEYBOARD_HELP_CHAT_HISTORY_ACCESS_ITEMS_IN_MESSAGE_HEADER":"Pristup stavkama u poruci","KEYBOARD_HELP_CHAT_HISTORY_HEADER":"Istorija ćaskanja","KEYBOARD_HELP_CHAT_HISTORY_LEAVE_MESSAGE_BODY":"Taster Escape","KEYBOARD_HELP_CHAT_HISTORY_LEAVE_MESSAGE_HEADER":"Zatvori poruku","KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_ITEMS_BODY":"Taster Tab\\nShift + taster Tab","KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_ITEMS_HEADER":"Prelazak sa jedne stavke na drugu u poruci","KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_MESSAGES_BODY":"Taster sa strelicom nagore\\nTaster sa strelicom nadole","KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_MESSAGES_HEADER":"Prelazak sa jedne poruke na drugu","KEYBOARD_HELP_CHAT_WINDOW_BODY_DO_ACTION_BODY":"Taster Enter","KEYBOARD_HELP_CHAT_WINDOW_BODY_DO_ACTION_HEADER":"Obavljanje radnje","KEYBOARD_HELP_CHAT_WINDOW_BODY_MOVE_BETWEEN_ITEMS_BODY":"Taster Tab\\nShift + taster Tab","KEYBOARD_HELP_CHAT_WINDOW_BODY_MOVE_BETWEEN_ITEMS_HEADER":"Prelazak sa jedne stavke na drugu u prozoru za ćaskanje","KEYBOARD_HELP_CHAT_WINDOW_HEADER":"Prozor za ćaskanje","KEYBOARD_HELP_CLOSE_BUTTON_ALT":"Zatvori","KEYBOARD_HELP_HEADER":"Tasterske kontrole","MARKDOWN_EXTERNAL_LINK_ALT":"Otvara se u novom prozoru; spoljno.","RECEIPT_CARD_TAX":"Porez","RECEIPT_CARD_TOTAL":"Ukupno","RECEIPT_CARD_VAT":"PDV","SEND_BOX_IS_EMPTY_TOOLTIP_ALT":"Nije moguće poslati praznu poruku.","SPEECH_INPUT_LISTENING":"Slušamo…","SPEECH_INPUT_MICROPHONE_BUTTON_CLOSE_ALT":"Mikrofon je isključen","SPEECH_INPUT_MICROPHONE_BUTTON_OPEN_ALT":"Mikrofon je uključen","SPEECH_INPUT_STARTING":"Počinje…","SUGGESTED_ACTIONS_LABEL_ALT":"Predložene radnje","TEXT_INPUT_ALT":"Polje za unos poruke","TEXT_INPUT_PLACEHOLDER":"Otkucajte poruku","TEXT_INPUT_SEND_BUTTON_ALT":"Pošalji","TEXT_INPUT_SPEAK_BUTTON_ALT":"Izgovorite","TEXT_INPUT_UPLOAD_BUTTON_ALT":"Otpremi datoteku","TOAST_ACCORDION_FEW":"$1 obaveštenja: Kliknite ovde da biste videli detalje","TOAST_ACCORDION_MANY":"$1 obaveštenja: Kliknite ovde da biste videli detalje","TOAST_ACCORDION_OTHER":"$1 obaveštenja: Kliknite ovde da biste videli detalje","TOAST_ACCORDION_TWO":"$1 obaveštenja: Kliknite ovde da biste videli detalje","TOAST_ALT_ERROR":"Greška","TOAST_ALT_INFO":"Informacije","TOAST_ALT_SUCCESS":"Uspešno","TOAST_ALT_WARN":"Upozorenje","TOAST_DISMISS_BUTTON":"Odbaci","TOAST_TITLE_ALT":"Obaveštenje","TRANSCRIPT_ARIA_LABEL_ALT":"Istorija ćaskanja, koristite tastere sa strelicom da biste se kretali.","TRANSCRIPT_ARIA_ROLE_ALT":"istorija ćaskanja","TRANSCRIPT_LIVE_REGION_INTERACTIVE_LABEL_ALT":"Poruka je interaktivna. Pritisnite tastere Shift i Tab 2 do 3 puta da biste se prebacili na istoriju ćaskanja. Zatim kliknite na poruku da biste ostvarili interakciju.","TRANSCRIPT_LIVE_REGION_INTERACTIVE_WITH_LINKS_LABEL_ALT":"Poruka sadrži veze. Pritisnite tastere Shift i Tab 2 do 3 puta da biste se prebacili na istoriju ćaskanja. Zatim kliknite na poruku da biste ostvarili interakciju.","TRANSCRIPT_LIVE_REGION_SUGGESTED_ACTIONS_LABEL_ALT":"Poruka ima predložene radnje. Pritisnite tastere shift tab 2 do 3 puta kako biste ih izabrali.","TRANSCRIPT_LIVE_REGION_SUGGESTED_ACTIONS_WITH_ACCESS_KEY_LABEL_ALT":"Poruka ima predložene radnje. Pritisnite $1 kako biste ih izabrali.","TRANSCRIPT_LIVE_REGION_SEND_FAILED_ALT":"Slanje poruke nije uspelo.","TRANSCRIPT_MORE_MESSAGES":"Još poruka","TRANSCRIPT_NEW_MESSAGES":"Nove poruke","TRANSCRIPT_TERMINATOR_TEXT":"Kraj istorije ćaskanja","TYPING_INDICATOR_ALT":"Prikazuje se indikator kucanja","TYPING_INDICATOR_SINGLE_TEXT":"$1 kuca.","TYPING_INDICATOR_MULTIPLE_TEXT":"$1 i drugi kucaju."}');

});

parcelRequire.register("4a58f", function(module, exports) {
module.exports = JSON.parse('{"_comment":"[CI-LOCKED] Inneh\xe5llet i den h\xe4r filen \xe4r l\xe5st. Bidrag v\xe4lkomnas men verifieringen av \xe4ndrar kan f\xf6rdr\xf6jas.","ACCESS_KEY_ALT":"Alt Skift $1","ACCESS_KEY_FOR_MAC_ALT":"Ctrl Alt $1","ACTIVITY_BOT_SAID_ALT":"Roboten $1 sade:","ACTIVITY_YOU_SAID_ALT":"Du sade:","ACTIVITY_BOT_ATTACHED_ALT":"Robot bifogad:","ACTIVITY_ERROR_BOX_TITLE":"Felmeddelande","ACTIVITY_INTERACTIVE_FOOTNOTE_ALT":"Klicka f\xf6r att interagera.","ACTIVITY_INTERACTIVE_REASON_INTERACTIVE_CONTENT_ALT":"Meddelandet \xe4r interaktivt.","ACTIVITY_INTERACTIVE_REASON_LINK_ALT":"Det finns en eller flera l\xe4nkar i meddelandet.","ACTIVITY_INTERACTIVE_REASON_SEND_FAILED_ALT":"Det gick inte att skicka.","ACTIVITY_YOU_ATTACHED_ALT":"Du bifogade:","ACTIVITY_NUM_ATTACHMENTS_ONE_ALT":"En bilaga.","ACTIVITY_NUM_ATTACHMENTS_FEW_ALT":"$1-bilagor.","ACTIVITY_NUM_ATTACHMENTS_MANY_ALT":"$1-bilagor.","ACTIVITY_NUM_ATTACHMENTS_OTHER_ALT":"$1-bilagor.","ACTIVITY_NUM_ATTACHMENTS_TWO_ALT":"$1-bilagor.","ACTIVITY_STATUS_SEND_FAILED_RETRY":"Det gick inte att skicka. [F\xf6rs\xf6k igen med][RETRY].","ACTIVITY_STATUS_SEND_STATUS_ALT_SENDING":"Skickar","ACTIVITY_STATUS_SEND_STATUS_ALT_SENT_AT":"Skickades klockan $1","ACTIVITY_STATUS_TIMESTAMP_JUST_NOW":"Just nu","ACTIVITY_STATUS_TIMESTAMP_ONE_HOUR_AGO":"En timme sedan","ACTIVITY_STATUS_TIMESTAMP_ONE_MINUTE_AGO":"En minut sedan","ACTIVITY_STATUS_TIMESTAMP_TODAY":"I dag","ACTIVITY_STATUS_TIMESTAMP_YESTERDAY":"I g\xe5r","ADAPTIVE_CARD_ERROR_BOX_TITLE_PARSE":"Fel vid parsning av adaptivt kort","ADAPTIVE_CARD_ERROR_BOX_TITLE_RENDER":"Fel vid \xe5tergivning av adaptivt kort","ATTACHMENT_AUDIO":"Ett ljudklipp.","ATTACHMENT_CARD":"Ett kort: $1 $2 $3","ATTACHMENT_FILE":"En fil: $1","ATTACHMENT_IMAGE":"En bild","ATTACHMENT_TEXT":"En text: $1","ATTACHMENT_VIDEO":"Ett videoklipp","CAROUSEL_FLIPPER_LEFT_ALT":"V\xe4nster","CAROUSEL_FLIPPER_RIGHT_ALT":"H\xf6ger","CONNECTIVITY_STATUS_ALT_CONNECTED":"Ansluten","CONNECTIVITY_STATUS_ALT_CONNECTING":"Ansluter ...","CONNECTIVITY_STATUS_ALT_FATAL":"Det gick inte att ansluta.","CONNECTIVITY_STATUS_ALT_RECONNECTING":"Ett n\xe4tverksavbrott intr\xe4ffade. Ansluter igen ...","CONNECTIVITY_STATUS_ALT_RENDER_ERROR":"\xc5terge fel. Kontrollera konsolen eller kontakta robotutvecklaren.","CONNECTIVITY_STATUS_ALT_SLOW_CONNECTION":"Det tar l\xe4ngre tid \xe4n vanligt att ansluta.","CONNECTIVITY_STATUS_ALT":"Anslutningsstatus: $1","FILE_CONTENT_ALT":"$1","FILE_CONTENT_DOWNLOADABLE_ALT":"H\xe4mta filen $1","FILE_CONTENT_DOWNLOADABLE_WITH_SIZE_ALT":"Ladda ned filen $1 med storleken $2","FILE_CONTENT_WITH_SIZE_ALT":"$1 med storleken $2","KEYBOARD_HELP_CHAT_HISTORY_ACCESS_ITEMS_IN_MESSAGE_BODY":"Returtangent","KEYBOARD_HELP_CHAT_HISTORY_ACCESS_ITEMS_IN_MESSAGE_HEADER":"F\xe5 \xe5tkomst till objekt i meddelandet","KEYBOARD_HELP_CHAT_HISTORY_HEADER":"Chatthistorik","KEYBOARD_HELP_CHAT_HISTORY_LEAVE_MESSAGE_BODY":"Esc-tangent","KEYBOARD_HELP_CHAT_HISTORY_LEAVE_MESSAGE_HEADER":"L\xe4mna meddelandet","KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_ITEMS_BODY":"Tabbtangent\\nSkift + tabbtangent","KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_ITEMS_HEADER":"Flytta mellan objekt i ett meddelande","KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_MESSAGES_BODY":"Upp\xe5tpil\\nNed\xe5tpil","KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_MESSAGES_HEADER":"Flytta mellan meddelanden","KEYBOARD_HELP_CHAT_WINDOW_BODY_DO_ACTION_BODY":"Returtangent","KEYBOARD_HELP_CHAT_WINDOW_BODY_DO_ACTION_HEADER":"Utf\xf6r \xe5tg\xe4rd","KEYBOARD_HELP_CHAT_WINDOW_BODY_MOVE_BETWEEN_ITEMS_BODY":"Tabbtangent\\nSkift + tabbtangent","KEYBOARD_HELP_CHAT_WINDOW_BODY_MOVE_BETWEEN_ITEMS_HEADER":"Flytta mellan objekt i chattf\xf6nstret","KEYBOARD_HELP_CHAT_WINDOW_HEADER":"Chattf\xf6nster","KEYBOARD_HELP_CLOSE_BUTTON_ALT":"St\xe4ng","KEYBOARD_HELP_HEADER":"Tangentbordskontroller","MARKDOWN_EXTERNAL_LINK_ALT":"\xd6ppnas i ett nytt f\xf6nster; externt.","RECEIPT_CARD_TAX":"Skatt","RECEIPT_CARD_TOTAL":"Summa","RECEIPT_CARD_VAT":"Moms","SEND_BOX_IS_EMPTY_TOOLTIP_ALT":"Det g\xe5r inte att skicka ett tomt meddelande.","SPEECH_INPUT_LISTENING":"Lyssnar ...","SPEECH_INPUT_MICROPHONE_BUTTON_CLOSE_ALT":"Mikrofon av","SPEECH_INPUT_MICROPHONE_BUTTON_OPEN_ALT":"Mikrofon p\xe5","SPEECH_INPUT_STARTING":"Startar ...","SUGGESTED_ACTIONS_LABEL_ALT":"F\xf6reslagna \xe5tg\xe4rder","TEXT_INPUT_ALT":"Inmatningsruta f\xf6r meddelande","TEXT_INPUT_PLACEHOLDER":"Skriv ditt meddelande","TEXT_INPUT_SEND_BUTTON_ALT":"Skicka","TEXT_INPUT_SPEAK_BUTTON_ALT":"L\xe4s upp","TEXT_INPUT_UPLOAD_BUTTON_ALT":"Ladda upp fil","TOAST_ACCORDION_FEW":"$1 aviseringar: Klicka h\xe4r f\xf6r att visa mer information.","TOAST_ACCORDION_MANY":"$1 aviseringar: Klicka h\xe4r f\xf6r att visa mer information.","TOAST_ACCORDION_OTHER":"$1 aviseringar: Klicka h\xe4r f\xf6r att visa mer information.","TOAST_ACCORDION_TWO":"$1 aviseringar: Klicka h\xe4r f\xf6r att visa mer information.","TOAST_ALT_ERROR":"Fel","TOAST_ALT_INFO":"Information","TOAST_ALT_SUCCESS":"Lyckades","TOAST_ALT_WARN":"Varning","TOAST_DISMISS_BUTTON":"St\xe4ng","TOAST_TITLE_ALT":"Avisering","TRANSCRIPT_ARIA_LABEL_ALT":"Chatthistorik, tryck p\xe5 piltangenterna f\xf6r att navigera.","TRANSCRIPT_ARIA_ROLE_ALT":"chatthistorik","TRANSCRIPT_LIVE_REGION_INTERACTIVE_LABEL_ALT":"Meddelandet \xe4r interaktivt. Tryck p\xe5 Skift+Tabbtangenten 2 till 3 g\xe5nger f\xf6r att v\xe4xla till chatthistoriken. Klicka sedan p\xe5 meddelandet f\xf6r att interagera.","TRANSCRIPT_LIVE_REGION_INTERACTIVE_WITH_LINKS_LABEL_ALT":"Det finns en eller flera l\xe4nkar i meddelandet. Tryck p\xe5 Skift+Tabbtangenten 2 till 3 g\xe5nger f\xf6r att v\xe4xla till chatthistoriken. Klicka sedan p\xe5 meddelandet f\xf6r att interagera.","TRANSCRIPT_LIVE_REGION_SUGGESTED_ACTIONS_LABEL_ALT":"Meddelandet har f\xf6reslagit \xe5tg\xe4rder. Tryck p\xe5 Skift Tabb 2 till 3 g\xe5nger f\xf6r att v\xe4lja dem.","TRANSCRIPT_LIVE_REGION_SUGGESTED_ACTIONS_WITH_ACCESS_KEY_LABEL_ALT":"Meddelandet har f\xf6reslagit \xe5tg\xe4rder. Tryck p\xe5 $1 f\xf6r att v\xe4lja dem.","TRANSCRIPT_LIVE_REGION_SEND_FAILED_ALT":"Det gick inte att skicka meddelandet.","TRANSCRIPT_MORE_MESSAGES":"Fler meddelanden","TRANSCRIPT_NEW_MESSAGES":"Nya meddelanden","TRANSCRIPT_TERMINATOR_TEXT":"Slut p\xe5 chatthistorik","TYPING_INDICATOR_ALT":"Visar skrivindikatorn","TYPING_INDICATOR_SINGLE_TEXT":"$1 skriver.","TYPING_INDICATOR_MULTIPLE_TEXT":"$1 och andra skriver."}');

});

parcelRequire.register("9CH30", function(module, exports) {
module.exports = JSON.parse('{"_comment":"[CI-LOCKED] เนื้อหาของไฟล์นี้ถูกล็อก ยินดีรับการสนับสนุน แต่การตรวจสอบความถูกต้องของการเปลี่ยนแปลงอาจล่าช้า","ACCESS_KEY_ALT":"Alt Shift $1","ACCESS_KEY_FOR_MAC_ALT":"Control Option $1","ACTIVITY_BOT_SAID_ALT":"บอท $1 กล่าวว่า:","ACTIVITY_YOU_SAID_ALT":"คุณพูดว่า:","ACTIVITY_BOT_ATTACHED_ALT":"บอทแนบ:","ACTIVITY_ERROR_BOX_TITLE":"ข้อความแสดงข้อผิดพลาด","ACTIVITY_INTERACTIVE_FOOTNOTE_ALT":"คลิกเพื่อโต้ตอบ","ACTIVITY_INTERACTIVE_REASON_INTERACTIVE_CONTENT_ALT":"ข้อความเป็นแบบโต้ตอบ","ACTIVITY_INTERACTIVE_REASON_LINK_ALT":"มีลิงก์อย่างน้อยหนึ่งลิงก์ในข้อความ","ACTIVITY_INTERACTIVE_REASON_SEND_FAILED_ALT":"การส่งไม่สำเร็จ","ACTIVITY_YOU_ATTACHED_ALT":"คุณแนบ:","ACTIVITY_NUM_ATTACHMENTS_ONE_ALT":"สิ่งที่แนบ 1 รายการ","ACTIVITY_NUM_ATTACHMENTS_FEW_ALT":"สิ่งที่แนบ $1 รายการ","ACTIVITY_NUM_ATTACHMENTS_MANY_ALT":"สิ่งที่แนบ $1 รายการ","ACTIVITY_NUM_ATTACHMENTS_OTHER_ALT":"สิ่งที่แนบ $1 รายการ","ACTIVITY_NUM_ATTACHMENTS_TWO_ALT":"สิ่งที่แนบ $1 รายการ","ACTIVITY_STATUS_SEND_FAILED_RETRY":"ส่งไม่สำเร็จ [ลองใหม่][RETRY]","ACTIVITY_STATUS_SEND_STATUS_ALT_SENDING":"กำลังส่ง","ACTIVITY_STATUS_SEND_STATUS_ALT_SENT_AT":"ส่งเมื่อ $1","ACTIVITY_STATUS_TIMESTAMP_JUST_NOW":"ตอนนี้","ACTIVITY_STATUS_TIMESTAMP_ONE_HOUR_AGO":"ชั่วโมงที่แล้ว","ACTIVITY_STATUS_TIMESTAMP_ONE_MINUTE_AGO":"นาทีที่แล้ว","ACTIVITY_STATUS_TIMESTAMP_TODAY":"วันนี้","ACTIVITY_STATUS_TIMESTAMP_YESTERDAY":"เมื่อวานนี้","ADAPTIVE_CARD_ERROR_BOX_TITLE_PARSE":"ข้อผิดพลาดในการแยกวิเคราะห์ Adaptive Card","ADAPTIVE_CARD_ERROR_BOX_TITLE_RENDER":"ข้อผิดพลาดในการแสดงผล Adaptive Card","ATTACHMENT_AUDIO":"คลิปเสียง","ATTACHMENT_CARD":"การ์ด: $1 $2 $3","ATTACHMENT_FILE":"ไฟล์: $1","ATTACHMENT_IMAGE":"รูปภาพ","ATTACHMENT_TEXT":"ข้อความ: $1","ATTACHMENT_VIDEO":"คลิปวิดีโอ","CAROUSEL_FLIPPER_LEFT_ALT":"ซ้าย","CAROUSEL_FLIPPER_RIGHT_ALT":"ขวา","CONNECTIVITY_STATUS_ALT_CONNECTED":"เชื่อมต่อแล้ว","CONNECTIVITY_STATUS_ALT_CONNECTING":"กำลังเชื่อมต่อ...","CONNECTIVITY_STATUS_ALT_FATAL":"ไม่สามารถเชื่อมต่อได้","CONNECTIVITY_STATUS_ALT_RECONNECTING":"เครือข่ายขัดข้อง กำลังเชื่อมต่อใหม่...","CONNECTIVITY_STATUS_ALT_RENDER_ERROR":"แสดงข้อผิดพลาด โปรดตรวจสอบคอนโซลหรือติดต่อนักพัฒนาบอท","CONNECTIVITY_STATUS_ALT_SLOW_CONNECTION":"ใช้เวลาเชื่อมต่อนานกว่าปกติ","CONNECTIVITY_STATUS_ALT":"สถานะของการเชื่อมต่อ: $1","FILE_CONTENT_ALT":"\'$1\'","FILE_CONTENT_DOWNLOADABLE_ALT":"ดาวน์โหลดไฟล์ \'$1\'","FILE_CONTENT_DOWNLOADABLE_WITH_SIZE_ALT":"ดาวน์โหลดไฟล์ \'$1\' ขนาด $2","FILE_CONTENT_WITH_SIZE_ALT":"\'$1\' ขนาด $2","KEYBOARD_HELP_CHAT_HISTORY_ACCESS_ITEMS_IN_MESSAGE_BODY":"แป้น Enter","KEYBOARD_HELP_CHAT_HISTORY_ACCESS_ITEMS_IN_MESSAGE_HEADER":"เข้าถึงรายการในข้อความ","KEYBOARD_HELP_CHAT_HISTORY_HEADER":"ประวัติการแชท","KEYBOARD_HELP_CHAT_HISTORY_LEAVE_MESSAGE_BODY":"แป้น Escape","KEYBOARD_HELP_CHAT_HISTORY_LEAVE_MESSAGE_HEADER":"ออกจากข้อความ","KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_ITEMS_BODY":"แป้น Tab\\nแป้น Shift + Tab","KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_ITEMS_HEADER":"เลื่อนไปมาระหว่างรายการในข้อความ","KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_MESSAGES_BODY":"แป้นลูกศรขึ้น\\nแป้นลูกศรลง","KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_MESSAGES_HEADER":"เลื่อนไปมาระหว่างข้อความ","KEYBOARD_HELP_CHAT_WINDOW_BODY_DO_ACTION_BODY":"แป้น Enter","KEYBOARD_HELP_CHAT_WINDOW_BODY_DO_ACTION_HEADER":"ทำการดำเนินการ","KEYBOARD_HELP_CHAT_WINDOW_BODY_MOVE_BETWEEN_ITEMS_BODY":"แป้น Tab\\nแป้น Shift + Tab","KEYBOARD_HELP_CHAT_WINDOW_BODY_MOVE_BETWEEN_ITEMS_HEADER":"เลื่อนไปมาระหว่างรายการในหน้าต่างแชท","KEYBOARD_HELP_CHAT_WINDOW_HEADER":"หน้าต่างแชท","KEYBOARD_HELP_CLOSE_BUTTON_ALT":"ปิด","KEYBOARD_HELP_HEADER":"ตัวควบคุมบนแป้นพิมพ์","MARKDOWN_EXTERNAL_LINK_ALT":"เปิดในหน้าต่างใหม่; ภายนอก","RECEIPT_CARD_TAX":"ภาษี","RECEIPT_CARD_TOTAL":"ยอดรวม","RECEIPT_CARD_VAT":"ภาษีมูลค่าเพิ่ม","SEND_BOX_IS_EMPTY_TOOLTIP_ALT":"ไม่สามารถส่งข้อความที่ว่างเปล่า","SPEECH_INPUT_LISTENING":"กำลังฟัง...","SPEECH_INPUT_MICROPHONE_BUTTON_CLOSE_ALT":"ปิดไมโครโฟน","SPEECH_INPUT_MICROPHONE_BUTTON_OPEN_ALT":"เปิดไมโครโฟน","SPEECH_INPUT_STARTING":"กำลังเริ่ม...","SUGGESTED_ACTIONS_LABEL_ALT":"การดำเนินการที่แนะนำ","TEXT_INPUT_ALT":"กล่องป้อนข้อความ","TEXT_INPUT_PLACEHOLDER":"พิมพ์ข้อความของคุณ","TEXT_INPUT_SEND_BUTTON_ALT":"ส่ง","TEXT_INPUT_SPEAK_BUTTON_ALT":"พูด","TEXT_INPUT_UPLOAD_BUTTON_ALT":"อัปโหลดไฟล์","TOAST_ACCORDION_FEW":"$1 การแจ้งเตือน: คลิกที่นี่เพื่อดูรายละเอียด","TOAST_ACCORDION_MANY":"$1 การแจ้งเตือน: คลิกที่นี่เพื่อดูรายละเอียด","TOAST_ACCORDION_OTHER":"$1 การแจ้งเตือน: คลิกที่นี่เพื่อดูรายละเอียด","TOAST_ACCORDION_TWO":"$1 การแจ้งเตือน: คลิกที่นี่เพื่อดูรายละเอียด","TOAST_ALT_ERROR":"ผิดพลาด","TOAST_ALT_INFO":"ข้อมูล","TOAST_ALT_SUCCESS":"สำเร็จ","TOAST_ALT_WARN":"คำเตือน","TOAST_DISMISS_BUTTON":"ปิดการเตือน","TOAST_TITLE_ALT":"การแจ้งเตือน","TRANSCRIPT_ARIA_LABEL_ALT":"ประวัติการแชท กดแป้นลูกศรเพื่อนำทาง","TRANSCRIPT_ARIA_ROLE_ALT":"ประวัติการแชท","TRANSCRIPT_LIVE_REGION_INTERACTIVE_LABEL_ALT":"ข้อความเป็นแบบโต้ตอบ กดแป้น Shift Tab 2 ถึง 3 ครั้งเพื่อสลับไปที่ประวัติการแชท จากนั้นคลิกที่ข้อความเพื่อโต้ตอบ","TRANSCRIPT_LIVE_REGION_INTERACTIVE_WITH_LINKS_LABEL_ALT":"มีลิงก์อย่างน้อยหนึ่งลิงก์ในข้อความ กดแป้น Shift Tab 2 ถึง 3 ครั้งเพื่อสลับไปที่ประวัติการแชท จากนั้นคลิกที่ข้อความเพื่อโต้ตอบ","TRANSCRIPT_LIVE_REGION_SUGGESTED_ACTIONS_LABEL_ALT":"ข้อความมีการดำเนินการที่แนะนำ กด Shift Tab 2 ถึง 3 ครั้งเพื่อเลือก","TRANSCRIPT_LIVE_REGION_SUGGESTED_ACTIONS_WITH_ACCESS_KEY_LABEL_ALT":"ข้อความมีการดำเนินการที่แนะนำ กด $1 เพื่อเลือก","TRANSCRIPT_LIVE_REGION_SEND_FAILED_ALT":"ไม่สามารถส่งข้อความได้","TRANSCRIPT_MORE_MESSAGES":"ข้อความเพิ่มเติม","TRANSCRIPT_NEW_MESSAGES":"ข้อความใหม่","TRANSCRIPT_TERMINATOR_TEXT":"สิ้นสุดประวัติการแชท","TYPING_INDICATOR_ALT":"แสดงตัวแสดงการพิมพ์","TYPING_INDICATOR_SINGLE_TEXT":"$1 กำลังพิมพ์","TYPING_INDICATOR_MULTIPLE_TEXT":"$1 และคนอื่นๆ กำลังพิมพ์"}');

});

parcelRequire.register("l3zzC", function(module, exports) {
module.exports = JSON.parse('{"_comment":"[CI-LOCKED] Bu dosyanın i\xe7eriği kilitli. Katılımcılar dosyayı kullanabilir ancak değişikliğin doğrulanması gecikebilir.","ACCESS_KEY_ALT":"Alt Shift $1","ACCESS_KEY_FOR_MAC_ALT":"Control Option $1","ACTIVITY_BOT_SAID_ALT":"$1 botu ş\xf6yle diyor:","ACTIVITY_YOU_SAID_ALT":"Ş\xf6yle dediniz:","ACTIVITY_BOT_ATTACHED_ALT":"Bot eklendi:","ACTIVITY_ERROR_BOX_TITLE":"Hata iletisi","ACTIVITY_INTERACTIVE_FOOTNOTE_ALT":"Etkileşim kurmak i\xe7in tıklayın.","ACTIVITY_INTERACTIVE_REASON_INTERACTIVE_CONTENT_ALT":"İleti etkileşimli.","ACTIVITY_INTERACTIVE_REASON_LINK_ALT":"İletide bir veya daha fazla bağlantı var.","ACTIVITY_INTERACTIVE_REASON_SEND_FAILED_ALT":"G\xf6nderilemedi.","ACTIVITY_YOU_ATTACHED_ALT":"Şunu eklediniz:","ACTIVITY_NUM_ATTACHMENTS_ONE_ALT":"1 ek.","ACTIVITY_NUM_ATTACHMENTS_FEW_ALT":"$1 ek.","ACTIVITY_NUM_ATTACHMENTS_MANY_ALT":"$1 ek.","ACTIVITY_NUM_ATTACHMENTS_OTHER_ALT":"$1 ekler.","ACTIVITY_NUM_ATTACHMENTS_TWO_ALT":"$1 ek.","ACTIVITY_STATUS_SEND_FAILED_RETRY":"G\xf6nderme başarısız. [Yeniden Dene][RETRY].","ACTIVITY_STATUS_SEND_STATUS_ALT_SENDING":"G\xf6nderiliyor","ACTIVITY_STATUS_SEND_STATUS_ALT_SENT_AT":"$1 itibarıyla g\xf6nderildi","ACTIVITY_STATUS_TIMESTAMP_JUST_NOW":"Hemen şimdi","ACTIVITY_STATUS_TIMESTAMP_ONE_HOUR_AGO":"Bir saat \xf6nce","ACTIVITY_STATUS_TIMESTAMP_ONE_MINUTE_AGO":"Bir dakika \xf6nce","ACTIVITY_STATUS_TIMESTAMP_TODAY":"Bug\xfcn","ACTIVITY_STATUS_TIMESTAMP_YESTERDAY":"D\xfcn","ADAPTIVE_CARD_ERROR_BOX_TITLE_PARSE":"Uyarlamalı Kart ayrıştırma hatası","ADAPTIVE_CARD_ERROR_BOX_TITLE_RENDER":"Uyarlamalı Kart işleme hatası","ATTACHMENT_AUDIO":"Ses klibi.","ATTACHMENT_CARD":"Kart: $1 $2 $3","ATTACHMENT_FILE":"Dosya: $1","ATTACHMENT_IMAGE":"G\xf6r\xfcnt\xfc","ATTACHMENT_TEXT":"Metin: $1","ATTACHMENT_VIDEO":"Video klibi","CAROUSEL_FLIPPER_LEFT_ALT":"Sol","CAROUSEL_FLIPPER_RIGHT_ALT":"Sağ","CONNECTIVITY_STATUS_ALT_CONNECTED":"Bağlı","CONNECTIVITY_STATUS_ALT_CONNECTING":"Bağlantı kuruluyor...","CONNECTIVITY_STATUS_ALT_FATAL":"Bağlantı kurulamadı.","CONNECTIVITY_STATUS_ALT_RECONNECTING":"Ağ kesintisi oluştu. Yeniden bağlanıyor...","CONNECTIVITY_STATUS_ALT_RENDER_ERROR":"İşleme hatası. L\xfctfen konsolu denetleyin veya bot geliştiricisine başvurun.","CONNECTIVITY_STATUS_ALT_SLOW_CONNECTION":"Bağlantı kurmak normalden uzun s\xfcr\xfcyor.","CONNECTIVITY_STATUS_ALT":"Bağlantı Durumu: $1","FILE_CONTENT_ALT":"\\"$1\\"","FILE_CONTENT_DOWNLOADABLE_ALT":"\\"$1\\" dosyasını indir","FILE_CONTENT_DOWNLOADABLE_WITH_SIZE_ALT":"$2 boyutlu \\"$1\\" dosyasını indir","FILE_CONTENT_WITH_SIZE_ALT":"$2 boyutlu \\"$1\\" dosyası","KEYBOARD_HELP_CHAT_HISTORY_ACCESS_ITEMS_IN_MESSAGE_BODY":"Enter tuşu","KEYBOARD_HELP_CHAT_HISTORY_ACCESS_ITEMS_IN_MESSAGE_HEADER":"Mesajdaki \xf6ğelere erişin","KEYBOARD_HELP_CHAT_HISTORY_HEADER":"Sohbet ge\xe7mişi","KEYBOARD_HELP_CHAT_HISTORY_LEAVE_MESSAGE_BODY":"Escape tuşu","KEYBOARD_HELP_CHAT_HISTORY_LEAVE_MESSAGE_HEADER":"İletiden \xe7ık","KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_ITEMS_BODY":"Sekme tuşu\\nShift + sekme tuşu","KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_ITEMS_HEADER":"Mesajdaki \xf6ğeler arasında gezinin","KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_MESSAGES_BODY":"Yukarı ok tuşu\\nAşağı ok tuşu","KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_MESSAGES_HEADER":"Mesajlar arasında gezinin","KEYBOARD_HELP_CHAT_WINDOW_BODY_DO_ACTION_BODY":"Enter tuşu","KEYBOARD_HELP_CHAT_WINDOW_BODY_DO_ACTION_HEADER":"Eylem ger\xe7ekleştirin","KEYBOARD_HELP_CHAT_WINDOW_BODY_MOVE_BETWEEN_ITEMS_BODY":"Sekme tuşu\\nShift + sekme tuşu","KEYBOARD_HELP_CHAT_WINDOW_BODY_MOVE_BETWEEN_ITEMS_HEADER":"Sohbet penceresindeki \xf6ğeler arasında gezinin","KEYBOARD_HELP_CHAT_WINDOW_HEADER":"Sohbet penceresi","KEYBOARD_HELP_CLOSE_BUTTON_ALT":"Kapat","KEYBOARD_HELP_HEADER":"Klavye denetimleri","MARKDOWN_EXTERNAL_LINK_ALT":"Yeni bir pencerede a\xe7ılır; harici.","RECEIPT_CARD_TAX":"Vergi","RECEIPT_CARD_TOTAL":"Toplam","RECEIPT_CARD_VAT":"KDV","SEND_BOX_IS_EMPTY_TOOLTIP_ALT":"Boş ileti g\xf6nderilemez.","SPEECH_INPUT_LISTENING":"Dinliyor…","SPEECH_INPUT_MICROPHONE_BUTTON_CLOSE_ALT":"Mikrofon kapalı","SPEECH_INPUT_MICROPHONE_BUTTON_OPEN_ALT":"Mikrofon a\xe7ık","SPEECH_INPUT_STARTING":"Başlatılıyor...","SUGGESTED_ACTIONS_LABEL_ALT":"\xd6nerilen eylemler","TEXT_INPUT_ALT":"İleti gelen kutusu","TEXT_INPUT_PLACEHOLDER":"İletinizi yazın","TEXT_INPUT_SEND_BUTTON_ALT":"G\xf6nder","TEXT_INPUT_SPEAK_BUTTON_ALT":"Konuş","TEXT_INPUT_UPLOAD_BUTTON_ALT":"Dosya y\xfckle","TOAST_ACCORDION_FEW":"$1 Bildirim: Ayrıntıları g\xf6rmek i\xe7in buraya tıklayın","TOAST_ACCORDION_MANY":"$1 Bildirim: Ayrıntıları g\xf6rmek i\xe7in buraya tıklayın","TOAST_ACCORDION_OTHER":"$1 Bildirim: Ayrıntıları g\xf6rmek i\xe7in buraya tıklayın","TOAST_ACCORDION_TWO":"$1 Bildirim: Ayrıntıları g\xf6rmek i\xe7in buraya tıklayın","TOAST_ALT_ERROR":"Hata","TOAST_ALT_INFO":"Bilgiler","TOAST_ALT_SUCCESS":"Başarılı","TOAST_ALT_WARN":"Uyarı","TOAST_DISMISS_BUTTON":"Kapat","TOAST_TITLE_ALT":"Bildirim","TRANSCRIPT_ARIA_LABEL_ALT":"Sohbet ge\xe7mişi, gezinmek i\xe7in ok tuşlarını kullanın.","TRANSCRIPT_ARIA_ROLE_ALT":"sohbet ge\xe7mişi","TRANSCRIPT_LIVE_REGION_INTERACTIVE_LABEL_ALT":"Mesaj etkileşimlidir. Sohbet ge\xe7mişine ge\xe7mek i\xe7in shift sekme tuşuna 2 ila 3 kez basın. Ardından etkileşim kurmak i\xe7in mesaja tıklayın.","TRANSCRIPT_LIVE_REGION_INTERACTIVE_WITH_LINKS_LABEL_ALT":"Mesajda bir veya daha fazla bağlantı var. Sohbet ge\xe7mişine ge\xe7mek i\xe7in shift sekme tuşuna 2 ila 3 kez basın. Ardından etkileşim kurmak i\xe7in mesaja tıklayın.","TRANSCRIPT_LIVE_REGION_SUGGESTED_ACTIONS_LABEL_ALT":"İletide \xf6nerilen eylemler var. Se\xe7mek i\xe7in Shift + sekme tuşlarına 2-3 kez basın.","TRANSCRIPT_LIVE_REGION_SUGGESTED_ACTIONS_WITH_ACCESS_KEY_LABEL_ALT":"İletide \xf6nerilen eylemler var. Se\xe7mek i\xe7in $1 tuşuna basın.","TRANSCRIPT_LIVE_REGION_SEND_FAILED_ALT":"İleti g\xf6nderilemedi.","TRANSCRIPT_MORE_MESSAGES":"Diğer iletiler","TRANSCRIPT_NEW_MESSAGES":"Yeni iletiler","TRANSCRIPT_TERMINATOR_TEXT":"Sohbet ge\xe7mişinin sonu","TYPING_INDICATOR_ALT":"Yazma g\xf6stergesi g\xf6steriliyor","TYPING_INDICATOR_SINGLE_TEXT":"$1 yazıyor.","TYPING_INDICATOR_MULTIPLE_TEXT":"$1 ve diğer kişiler yazıyor."}');

});

parcelRequire.register("8RIRv", function(module, exports) {
module.exports = JSON.parse('{"_comment":"[CI-LOCKED] Вміст цього файлу заблоковано. Внески вітаються, але перевірка змін може зайняти певний час.","ACCESS_KEY_ALT":"Alt\xa0+\xa0Shift\xa0+\xa0$1","ACCESS_KEY_FOR_MAC_ALT":"Control\xa0+\xa0Option\xa0+\xa0$1","ACTIVITY_BOT_SAID_ALT":"Бот $1 каже:","ACTIVITY_YOU_SAID_ALT":"Ви кажете:","ACTIVITY_BOT_ATTACHED_ALT":"Бот вкладає:","ACTIVITY_ERROR_BOX_TITLE":"Повідомлення про помилку","ACTIVITY_INTERACTIVE_FOOTNOTE_ALT":"Клацніть, щоб взаємодіяти.","ACTIVITY_INTERACTIVE_REASON_INTERACTIVE_CONTENT_ALT":"Повідомлення інтерактивне.","ACTIVITY_INTERACTIVE_REASON_LINK_ALT":"Повідомлення містить одне або кілька посилань.","ACTIVITY_INTERACTIVE_REASON_SEND_FAILED_ALT":"Помилка надсилання.","ACTIVITY_YOU_ATTACHED_ALT":"Ви вкладаєте:","ACTIVITY_NUM_ATTACHMENTS_ONE_ALT":"1 вкладення.","ACTIVITY_NUM_ATTACHMENTS_FEW_ALT":"$1 вкладення.","ACTIVITY_NUM_ATTACHMENTS_MANY_ALT":"$1 вкладення.","ACTIVITY_NUM_ATTACHMENTS_OTHER_ALT":"$1 вкладення.","ACTIVITY_NUM_ATTACHMENTS_TWO_ALT":"$1 вкладення.","ACTIVITY_STATUS_SEND_FAILED_RETRY":"Не вдалося надіслати. [Повторити][RETRY].","ACTIVITY_STATUS_SEND_STATUS_ALT_SENDING":"Надсилання","ACTIVITY_STATUS_SEND_STATUS_ALT_SENT_AT":"Надіслано о $1","ACTIVITY_STATUS_TIMESTAMP_JUST_NOW":"Щойно","ACTIVITY_STATUS_TIMESTAMP_ONE_HOUR_AGO":"Годину тому","ACTIVITY_STATUS_TIMESTAMP_ONE_MINUTE_AGO":"Хвилину тому","ACTIVITY_STATUS_TIMESTAMP_TODAY":"Сьогодні","ACTIVITY_STATUS_TIMESTAMP_YESTERDAY":"Учора","ADAPTIVE_CARD_ERROR_BOX_TITLE_PARSE":"Помилка аналізу адаптивної картки","ADAPTIVE_CARD_ERROR_BOX_TITLE_RENDER":"Помилка відображення адаптивної картки","ATTACHMENT_AUDIO":"Аудіокліп.","ATTACHMENT_CARD":"Картка: $1 $2 $3","ATTACHMENT_FILE":"Файл: $1","ATTACHMENT_IMAGE":"Зображення","ATTACHMENT_TEXT":"Текст: $1","ATTACHMENT_VIDEO":"Відеокліп","CAROUSEL_FLIPPER_LEFT_ALT":"Ліворуч","CAROUSEL_FLIPPER_RIGHT_ALT":"Праворуч","CONNECTIVITY_STATUS_ALT_CONNECTED":"Підключено","CONNECTIVITY_STATUS_ALT_CONNECTING":"Підключення…","CONNECTIVITY_STATUS_ALT_FATAL":"Не вдалося підключити.","CONNECTIVITY_STATUS_ALT_RECONNECTING":"Підключення до мережі перервано. Відновлення підключення...","CONNECTIVITY_STATUS_ALT_RENDER_ERROR":"Помилка відображення. Перевірте консоль або зверніться до розробника бота.","CONNECTIVITY_STATUS_ALT_SLOW_CONNECTION":"Підключення триває більше часу, ніж зазвичай.","CONNECTIVITY_STATUS_ALT":"Стан підключення: $1","FILE_CONTENT_ALT":"\'$1\'","FILE_CONTENT_DOWNLOADABLE_ALT":"Завантажити файл \'$1\'","FILE_CONTENT_DOWNLOADABLE_WITH_SIZE_ALT":"Завантажити файл \\"$1\\" завбільшки $2","FILE_CONTENT_WITH_SIZE_ALT":"\\"$1\\" завбільшки $2","KEYBOARD_HELP_CHAT_HISTORY_ACCESS_ITEMS_IN_MESSAGE_BODY":"Enter","KEYBOARD_HELP_CHAT_HISTORY_ACCESS_ITEMS_IN_MESSAGE_HEADER":"Перейти до елементів у повідомленні","KEYBOARD_HELP_CHAT_HISTORY_HEADER":"Історія чату","KEYBOARD_HELP_CHAT_HISTORY_LEAVE_MESSAGE_BODY":"Esc","KEYBOARD_HELP_CHAT_HISTORY_LEAVE_MESSAGE_HEADER":"Повідомлення про вихід","KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_ITEMS_BODY":"Tab\\nShift+Tab","KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_ITEMS_HEADER":"Перейти між елементами повідомлення","KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_MESSAGES_BODY":"Стрілка вгору\\nСтрілка вниз","KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_MESSAGES_HEADER":"Перейти між повідомленнями","KEYBOARD_HELP_CHAT_WINDOW_BODY_DO_ACTION_BODY":"Enter","KEYBOARD_HELP_CHAT_WINDOW_BODY_DO_ACTION_HEADER":"Виконати дію","KEYBOARD_HELP_CHAT_WINDOW_BODY_MOVE_BETWEEN_ITEMS_BODY":"Tab\\nShift+Tab","KEYBOARD_HELP_CHAT_WINDOW_BODY_MOVE_BETWEEN_ITEMS_HEADER":"Перейти між елементами у вікні чату","KEYBOARD_HELP_CHAT_WINDOW_HEADER":"Вікно чату","KEYBOARD_HELP_CLOSE_BUTTON_ALT":"Закрити","KEYBOARD_HELP_HEADER":"Елементи керування клавіатурою","MARKDOWN_EXTERNAL_LINK_ALT":"Відкривається в новому вікні; зовнішнє.","RECEIPT_CARD_TAX":"Податок","RECEIPT_CARD_TOTAL":"Усього","RECEIPT_CARD_VAT":"ПДВ","SEND_BOX_IS_EMPTY_TOOLTIP_ALT":"Не можна надсилати пусті повідомлення.","SPEECH_INPUT_LISTENING":"Слухання…","SPEECH_INPUT_MICROPHONE_BUTTON_CLOSE_ALT":"Мікрофон вимкнуто","SPEECH_INPUT_MICROPHONE_BUTTON_OPEN_ALT":"Мікрофон увімкнуто","SPEECH_INPUT_STARTING":"Початок…","SUGGESTED_ACTIONS_LABEL_ALT":"Рекомендовані дії","TEXT_INPUT_ALT":"Вікно вводу повідомлень","TEXT_INPUT_PLACEHOLDER":"Введіть повідомлення","TEXT_INPUT_SEND_BUTTON_ALT":"Надіслати","TEXT_INPUT_SPEAK_BUTTON_ALT":"Говорити","TEXT_INPUT_UPLOAD_BUTTON_ALT":"Передати файл","TOAST_ACCORDION_FEW":"Сповіщень: $1. Натисніть нижче, щоб побачити відомості","TOAST_ACCORDION_MANY":"Сповіщень: $1. Натисніть нижче, щоб побачити відомості","TOAST_ACCORDION_OTHER":"Сповіщень: $1. Натисніть нижче, щоб побачити відомості","TOAST_ACCORDION_TWO":"Сповіщень: $1. Натисніть нижче, щоб побачити відомості","TOAST_ALT_ERROR":"Помилка","TOAST_ALT_INFO":"Відомості","TOAST_ALT_SUCCESS":"Виконано","TOAST_ALT_WARN":"Попередження!","TOAST_DISMISS_BUTTON":"Закрити","TOAST_TITLE_ALT":"Сповіщення","TRANSCRIPT_ARIA_LABEL_ALT":"Історія чату: натискайте клавіші зі стрілками, щоб переходити між елементами.","TRANSCRIPT_ARIA_ROLE_ALT":"історія чату","TRANSCRIPT_LIVE_REGION_INTERACTIVE_LABEL_ALT":"Це інтерактивне повідомлення. Натисніть клавіші Shift+Tab 2–3 рази, щоб перейди до історії чату. Потім клацніть повідомлення, щоб взаємодіяти.","TRANSCRIPT_LIVE_REGION_INTERACTIVE_WITH_LINKS_LABEL_ALT":"Повідомлення містить одне або кілька посилань. Натисніть клавіші Shift+Tab 2–3 рази, щоб перейди до історії чату. Потім клацніть повідомлення, щоб взаємодіяти.","TRANSCRIPT_LIVE_REGION_SUGGESTED_ACTIONS_LABEL_ALT":"Повідомлення містить рекомендовані дії. Натисніть клавіші Shift\xa0+\xa0Tab 2–3 рази, щоб вибрати їх.","TRANSCRIPT_LIVE_REGION_SUGGESTED_ACTIONS_WITH_ACCESS_KEY_LABEL_ALT":"Повідомлення містить рекомендовані дії. Натисніть клавішу $1, щоб вибрати їх.","TRANSCRIPT_LIVE_REGION_SEND_FAILED_ALT":"Не вдалося надіслати повідомлення.","TRANSCRIPT_MORE_MESSAGES":"Інші повідомлення","TRANSCRIPT_NEW_MESSAGES":"Нові повідомлення","TRANSCRIPT_TERMINATOR_TEXT":"Кінець історії чату","TYPING_INDICATOR_ALT":"Показує індикатор набору","TYPING_INDICATOR_SINGLE_TEXT":"$1 вводить повідомлення.","TYPING_INDICATOR_MULTIPLE_TEXT":"$1 та інші вводять повідомлення."}');

});

parcelRequire.register("6N7IJ", function(module, exports) {
module.exports = JSON.parse('{"_comment":"[CI-LOCKED] Nội dung của tệp n\xe0y đ\xe3 bị kh\xf3a. Hoan ngh\xeanh \xfd kiến đ\xf3ng g\xf3p, nhưng việc x\xe1c nhận thay đổi c\xf3 thể bị tr\xec ho\xe3n.","ACCESS_KEY_ALT":"Alt Shift $1","ACCESS_KEY_FOR_MAC_ALT":"Control Option $1","ACTIVITY_BOT_SAID_ALT":"Bot $1 đ\xe3 n\xf3i:","ACTIVITY_YOU_SAID_ALT":"Bạn đ\xe3 n\xf3i:","ACTIVITY_BOT_ATTACHED_ALT":"Bot đ\xe3 đ\xednh k\xe8m:","ACTIVITY_ERROR_BOX_TITLE":"Th\xf4ng b\xe1o lỗi","ACTIVITY_INTERACTIVE_FOOTNOTE_ALT":"Nhấp để tương t\xe1c.","ACTIVITY_INTERACTIVE_REASON_INTERACTIVE_CONTENT_ALT":"Th\xf4ng b\xe1o c\xf3 t\xednh tương t\xe1c.","ACTIVITY_INTERACTIVE_REASON_LINK_ALT":"C\xf3 một hoặc nhiều đường li\xean kết trong tin nhắn.","ACTIVITY_INTERACTIVE_REASON_SEND_FAILED_ALT":"Kh\xf4ng gửi được.","ACTIVITY_YOU_ATTACHED_ALT":"Bạn đ\xe3 đ\xednh k\xe8m:","ACTIVITY_NUM_ATTACHMENTS_ONE_ALT":"1 tệp đ\xednh k\xe8m.","ACTIVITY_NUM_ATTACHMENTS_FEW_ALT":"$1 tệp đ\xednh k\xe8m.","ACTIVITY_NUM_ATTACHMENTS_MANY_ALT":"$1 tệp đ\xednh k\xe8m.","ACTIVITY_NUM_ATTACHMENTS_OTHER_ALT":"$1 tệp đ\xednh k\xe8m.","ACTIVITY_NUM_ATTACHMENTS_TWO_ALT":"$1 tệp đ\xednh k\xe8m.","ACTIVITY_STATUS_SEND_FAILED_RETRY":"Đ\xe3 kh\xf4ng gửi được. [Thử lại][RETRY].","ACTIVITY_STATUS_SEND_STATUS_ALT_SENDING":"Đang gửi","ACTIVITY_STATUS_SEND_STATUS_ALT_SENT_AT":"Đ\xe3 gửi v\xe0o l\xfac $1","ACTIVITY_STATUS_TIMESTAMP_JUST_NOW":"Vừa xong","ACTIVITY_STATUS_TIMESTAMP_ONE_HOUR_AGO":"Một giờ trước","ACTIVITY_STATUS_TIMESTAMP_ONE_MINUTE_AGO":"Một ph\xfat trước","ACTIVITY_STATUS_TIMESTAMP_TODAY":"H\xf4m nay","ACTIVITY_STATUS_TIMESTAMP_YESTERDAY":"H\xf4m qua","ADAPTIVE_CARD_ERROR_BOX_TITLE_PARSE":"Lỗi ph\xe2n t\xedch Thẻ th\xedch nghi","ADAPTIVE_CARD_ERROR_BOX_TITLE_RENDER":"Lỗi kết xuất Thẻ th\xedch nghi","ATTACHMENT_AUDIO":"Đoạn \xe2m thanh.","ATTACHMENT_CARD":"Thẻ: $1 $2 $3","ATTACHMENT_FILE":"Tệp: $1","ATTACHMENT_IMAGE":"H\xecnh ảnh","ATTACHMENT_TEXT":"Văn bản: $1","ATTACHMENT_VIDEO":"Đoạn video","CAROUSEL_FLIPPER_LEFT_ALT":"Tr\xe1i","CAROUSEL_FLIPPER_RIGHT_ALT":"Phải","CONNECTIVITY_STATUS_ALT_CONNECTED":"Đ\xe3 kết nối","CONNECTIVITY_STATUS_ALT_CONNECTING":"Đang kết nối...","CONNECTIVITY_STATUS_ALT_FATAL":"Kh\xf4ng thể kết nối.","CONNECTIVITY_STATUS_ALT_RECONNECTING":"Đ\xe3 bị gi\xe1n đoạn mạng. Đang kết nối lại...","CONNECTIVITY_STATUS_ALT_RENDER_ERROR":"Lỗi kết xuất. Vui l\xf2ng kiểm tra bảng điều khiển hoặc li\xean hệ với nh\xe0 ph\xe1t triển bot.","CONNECTIVITY_STATUS_ALT_SLOW_CONNECTION":"Việc kết nối đang mất nhiều thời gian hơn b\xecnh thường.","CONNECTIVITY_STATUS_ALT":"Trạng th\xe1i Kết nối: $1","FILE_CONTENT_ALT":"\'$1\'","FILE_CONTENT_DOWNLOADABLE_ALT":"Tải tệp \'$1\' xuống","FILE_CONTENT_DOWNLOADABLE_WITH_SIZE_ALT":"Tải tệp \'$1\' k\xedch thước $2 xuống","FILE_CONTENT_WITH_SIZE_ALT":"\'$1\' k\xedch thước $2","KEYBOARD_HELP_CHAT_HISTORY_ACCESS_ITEMS_IN_MESSAGE_BODY":"Ph\xedm Enter","KEYBOARD_HELP_CHAT_HISTORY_ACCESS_ITEMS_IN_MESSAGE_HEADER":"Truy nhập c\xe1c mục trong tin nhắn","KEYBOARD_HELP_CHAT_HISTORY_HEADER":"Lịch sử tr\xf2 chuyện","KEYBOARD_HELP_CHAT_HISTORY_LEAVE_MESSAGE_BODY":"Ph\xedm Escape","KEYBOARD_HELP_CHAT_HISTORY_LEAVE_MESSAGE_HEADER":"Tho\xe1t khỏi th\xf4ng b\xe1o","KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_ITEMS_BODY":"Ph\xedm tab\\nShift + ph\xedm tab","KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_ITEMS_HEADER":"Di chuyển giữa c\xe1c mục trong một tin nhắn","KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_MESSAGES_BODY":"Ph\xedm mũi t\xean l\xean\\nPh\xedm mũi t\xean xuống","KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_MESSAGES_HEADER":"Di chuyển giữa c\xe1c tin nhắn","KEYBOARD_HELP_CHAT_WINDOW_BODY_DO_ACTION_BODY":"Ph\xedm Enter","KEYBOARD_HELP_CHAT_WINDOW_BODY_DO_ACTION_HEADER":"Thực hiện h\xe0nh động","KEYBOARD_HELP_CHAT_WINDOW_BODY_MOVE_BETWEEN_ITEMS_BODY":"Ph\xedm tab\\nShift + ph\xedm tab","KEYBOARD_HELP_CHAT_WINDOW_BODY_MOVE_BETWEEN_ITEMS_HEADER":"Di chuyển giữa c\xe1c mục trong cửa sổ tr\xf2 chuyện","KEYBOARD_HELP_CHAT_WINDOW_HEADER":"Cửa sổ tr\xf2 chuyện","KEYBOARD_HELP_CLOSE_BUTTON_ALT":"Đ\xf3ng","KEYBOARD_HELP_HEADER":"B\xe0n ph\xedm điều khiển","MARKDOWN_EXTERNAL_LINK_ALT":"Mở trong cửa sổ mới; b\xean ngo\xe0i.","RECEIPT_CARD_TAX":"Thuế","RECEIPT_CARD_TOTAL":"Tổng số","RECEIPT_CARD_VAT":"Thuế GTGT","SEND_BOX_IS_EMPTY_TOOLTIP_ALT":"Kh\xf4ng thể gửi tin nhắn.","SPEECH_INPUT_LISTENING":"Đang nghe…","SPEECH_INPUT_MICROPHONE_BUTTON_CLOSE_ALT":"Tắt micr\xf4","SPEECH_INPUT_MICROPHONE_BUTTON_OPEN_ALT":"Bật micr\xf4","SPEECH_INPUT_STARTING":"Đang bắt đầu...","SUGGESTED_ACTIONS_LABEL_ALT":"H\xe0nh động được đề xuất","TEXT_INPUT_ALT":"Hộp nhập tin nhắn","TEXT_INPUT_PLACEHOLDER":"Nhập tin nhắn của bạn","TEXT_INPUT_SEND_BUTTON_ALT":"Gửi","TEXT_INPUT_SPEAK_BUTTON_ALT":"N\xf3i","TEXT_INPUT_UPLOAD_BUTTON_ALT":"Tải l\xean tệp","TOAST_ACCORDION_FEW":"$1 Th\xf4ng b\xe1o: Bấm v\xe0o đ\xe2y để xem chi tiết","TOAST_ACCORDION_MANY":"$1 Th\xf4ng b\xe1o: Bấm v\xe0o đ\xe2y để xem chi tiết","TOAST_ACCORDION_OTHER":"$1 Th\xf4ng b\xe1o: Bấm v\xe0o đ\xe2y để xem chi tiết","TOAST_ACCORDION_TWO":"$1 Th\xf4ng b\xe1o: Bấm v\xe0o đ\xe2y để xem chi tiết","TOAST_ALT_ERROR":"Lỗi","TOAST_ALT_INFO":"Th\xf4ng tin","TOAST_ALT_SUCCESS":"Th\xe0nh c\xf4ng","TOAST_ALT_WARN":"Cảnh b\xe1o","TOAST_DISMISS_BUTTON":"Bỏ qua","TOAST_TITLE_ALT":"Th\xf4ng b\xe1o","TRANSCRIPT_ARIA_LABEL_ALT":"Lịch sử tr\xf2 chuyện, nhấn c\xe1c ph\xedm mũi t\xean để điều hướng.","TRANSCRIPT_ARIA_ROLE_ALT":"lịch sử tr\xf2 chuyện","TRANSCRIPT_LIVE_REGION_INTERACTIVE_LABEL_ALT":"Tin nhắn c\xf3 t\xednh tương t\xe1c. Bấm ph\xedm shift tab 2 đến 3 lần để chuyển sang lịch sử tr\xf2 chuyện. Sau đ\xf3 bấm v\xe0o tin nhắn để tương t\xe1c.","TRANSCRIPT_LIVE_REGION_INTERACTIVE_WITH_LINKS_LABEL_ALT":"Một hoặc nhiều li\xean kết trong tin nhắn. Bấm ph\xedm shift tab 2 đến 3 lần để chuyển sang lịch sử tr\xf2 chuyện. Sau đ\xf3 bấm v\xe0o tin nhắn để tương t\xe1c.","TRANSCRIPT_LIVE_REGION_SUGGESTED_ACTIONS_LABEL_ALT":"Th\xf4ng b\xe1o c\xf3 c\xe1c h\xe0nh động được đề xuất. Nhấn tổ hợp ph\xedm shift tab 2 đến 3 lần để chọn c\xe1c h\xe0nh động đ\xf3.","TRANSCRIPT_LIVE_REGION_SUGGESTED_ACTIONS_WITH_ACCESS_KEY_LABEL_ALT":"Th\xf4ng b\xe1o c\xf3 c\xe1c h\xe0nh động được đề xuất. Nhấn $1 để chọn c\xe1c h\xe0nh động đ\xf3.","TRANSCRIPT_LIVE_REGION_SEND_FAILED_ALT":"Kh\xf4ng thể gửi tin nhắn.","TRANSCRIPT_MORE_MESSAGES":"C\xe1c tin nhắn kh\xe1c","TRANSCRIPT_NEW_MESSAGES":"Tin nhắn mới","TRANSCRIPT_TERMINATOR_TEXT":"Kết th\xfac lịch sử tr\xf2 chuyện","TYPING_INDICATOR_ALT":"Hiển thị chỉ b\xe1o đang nhập","TYPING_INDICATOR_SINGLE_TEXT":"$1 đang nhập.","TYPING_INDICATOR_MULTIPLE_TEXT":"$1 v\xe0 những người kh\xe1c đang nhập."}');

});

parcelRequire.register("4nwq4", function(module, exports) {
module.exports = JSON.parse('{"_.comment":"The content of this file is contributed by the community.","ACCESS_KEY_ALT":"Alt Shift $1","ACCESS_KEY_MAC_ALT":"Ctrl Option $1","ACTIVITY_BOT_ATTACHED_ALT":"Bot 嘅附件：","ACTIVITY_BOT_SAID_ALT":"Bot $1 話：","ACTIVITY_ERROR_BOX_TITLE":"錯嘅信息","ACTIVITY_INTERACTIVE_FOOTNOTE_ALT":"襟呢度前往信息入面嘅項目。","ACTIVITY_INTERACTIVE_REASON_INTERACTIVE_CONTENT_ALT":"信息可以互動。","ACTIVITY_INTERACTIVE_REASON_LINK_ALT":"信息入面有網頁連結。","ACTIVITY_INTERACTIVE_REASON_SEND_FAILED_ALT":"傳送唔倒。","ACTIVITY_NUM_ATTACHMENTS_FEW_ALT":"$1 件附件。","ACTIVITY_NUM_ATTACHMENTS_MANY_ALT":"$1 件附件。","ACTIVITY_NUM_ATTACHMENTS_ONE_ALT":"一件附件。","ACTIVITY_NUM_ATTACHMENTS_OTHER_ALT":"$1 件附件。","ACTIVITY_NUM_ATTACHMENTS_TWO_ALT":"兩件附件。","ACTIVITY_STATUS_SEND_FAILED_RETRY":"傳送唔倒。[再嚟一次][RETRY]。","ACTIVITY_STATUS_SEND_STATUS_ALT_SENDING":"而家傳送緊","ACTIVITY_STATUS_SEND_STATUS_ALT_SENT_AT":"送出嘅時間：$1","ACTIVITY_STATUS_TIMESTAMP_JUST_NOW":"啱啱","ACTIVITY_STATUS_TIMESTAMP_ONE_HOUR_AGO":"一個鐘前","ACTIVITY_STATUS_TIMESTAMP_ONE_MINUTE_AGO":"一分鐘前","ACTIVITY_STATUS_TIMESTAMP_TODAY":"今日","ACTIVITY_STATUS_TIMESTAMP_YESTERDAY":"尋日","ACTIVITY_YOU_ATTACHED_ALT":"你嘅附件：","ACTIVITY_YOU_SAID_ALT":"你話：","ADAPTIVE_CARD_ERROR_BOX_TITLE_PARSE":"Adaptive Card 解析出事","ADAPTIVE_CARD_ERROR_BOX_TITLE_RENDER":"Adaptive Card render 出事","ATTACHMENT_AUDIO":"一段錄音","ATTACHMENT_CARD":"一張卡：$1 $2 $3","ATTACHMENT_FILE":"一個檔案：$1","ATTACHMENT_IMAGE":"一幅圖","ATTACHMENT_TEXT":"一段文字：$1","ATTACHMENT_VIDEO":"一段錄像","CAROUSEL_FLIPPER_NEXT_ALT":"後","CAROUSEL_FLIPPER_PREVIOUS_ALT":"前","CONNECTIVITY_STATUS_ALT_CONNECTED":"接駁到","CONNECTIVITY_STATUS_ALT_CONNECTING":"接駁緊…","CONNECTIVITY_STATUS_ALT_FATAL":"接駁唔倒。","CONNECTIVITY_STATUS_ALT_RECONNECTING":"網絡暫時斷咗，試緊再駁返…","CONNECTIVITY_STATUS_ALT_RENDER_ERROR":"Render 出事，請睇下 console 或者同 bot 開發人員聯絡。","CONNECTIVITY_STATUS_ALT_SLOW_CONNECTION":"接駁嘅時間比平時長。","CONNECTIVITY_STATUS_ALT":"接駁情況：$1","FILE_CONTENT_ALT":"\'$1\'","FILE_CONTENT_DOWNLOADABLE_ALT":"下載檔案 \'$1\'","FILE_CONTENT_DOWNLOADABLE_WITH_SIZE_ALT":"下載檔案 \'$1\' 檔案大小 $2","FILE_CONTENT_WITH_SIZE_ALT":"\'$1\' 檔案大小 $2","KEYBOARD_HELP_CHAT_HISTORY_ACCESS_ITEMS_IN_MESSAGE_BODY":"Enter 掣","KEYBOARD_HELP_CHAT_HISTORY_ACCESS_ITEMS_IN_MESSAGE_HEADER":"前往信息入面嘅項目","KEYBOARD_HELP_CHAT_HISTORY_HEADER":"聊天記錄","KEYBOARD_HELP_CHAT_HISTORY_LEAVE_MESSAGE_BODY":"Escape 掣","KEYBOARD_HELP_CHAT_HISTORY_LEAVE_MESSAGE_HEADER":"離開信息","KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_ITEMS_BODY":"Tab 掣\\nShift 加 tab 掣","KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_ITEMS_HEADER":"喺信息入面揀項目","KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_MESSAGES_BODY":"向上箭咀\\n向下箭咀","KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_MESSAGES_HEADER":"揀信息","KEYBOARD_HELP_CHAT_WINDOW_BODY_DO_ACTION_BODY":"Enter 掣","KEYBOARD_HELP_CHAT_WINDOW_BODY_DO_ACTION_HEADER":"執行動作","KEYBOARD_HELP_CHAT_WINDOW_BODY_MOVE_BETWEEN_ITEMS_BODY":"Tab 掣\\nShift 加 tab 掣","KEYBOARD_HELP_CHAT_WINDOW_BODY_MOVE_BETWEEN_ITEMS_HEADER":"喺聊天視窗入面揀項目","KEYBOARD_HELP_CHAT_WINDOW_HEADER":"聊天視窗","KEYBOARD_HELP_CLOSE_BUTTON_ALT":"閂咗佢","KEYBOARD_HELP_HEADER":"鍵盤控制","MARKDOWN_EXTERNAL_LINK_ALT":"喺新嘅視窗開啟外部連結。","RECEIPT_CARD_TAX":"稅","RECEIPT_CARD_TOTAL":"總共","RECEIPT_CARD_VAT":"消費稅","SEND_BOX_IS_EMPTY_TOOLTIP_ALT":"唔可以傳送空白嘅訊息。","SPEECH_INPUT_LISTENING":"聽緊你講嘢…","SPEECH_INPUT_MICROPHONE_BUTTON_CLOSE_ALT":"閂咪","SPEECH_INPUT_MICROPHONE_BUTTON_OPEN_ALT":"開咪","SPEECH_INPUT_STARTING":"開始緊…","SUGGESTED_ACTIONS_FLIPPER_NEXT_ALT":"後","SUGGESTED_ACTIONS_FLIPPER_PREVIOUS_ALT":"前","SUGGESTED_ACTIONS_LABEL_ALT":"建議㩒嘅掣","TEXT_INPUT_ALT":"訊息輸入盒","TEXT_INPUT_PLACEHOLDER":"輸入你嘅訊息","TEXT_INPUT_SEND_BUTTON_ALT":"傳送","TEXT_INPUT_SPEAK_BUTTON_ALT":"講嘢","TEXT_INPUT_UPLOAD_BUTTON_ALT":"上載檔案","TOAST_ACCORDION_FEW":"$1 項通知：襟呢度睇詳情","TOAST_ACCORDION_MANY":"$1 項通知：襟呢度睇詳情","TOAST_ACCORDION_OTHER":"$1 項通知：襟呢度睇詳情","TOAST_ACCORDION_TWO":"兩項通知：襟呢度睇詳情","TOAST_ALT_ERROR":"錯誤：$1","TOAST_ALT_INFO":"資訊：$1","TOAST_ALT_SUCCESS":"成功：$1","TOAST_ALT_WARN":"警告：$1","TOAST_DISMISS_BUTTON":"閂咗佢","TOAST_TITLE_ALT":"通知","TRANSCRIPT_ARIA_LABEL_ALT":"聊天記錄，襟方向箭咀嚟瀏覽。","TRANSCRIPT_ARIA_ROLE_ALT":"聊天記錄","TRANSCRIPT_LIVE_REGION_INTERACTIVE_LABEL_ALT":"信息可以互動，襟 shift tab 兩三下去聊天記錄，再襟個信息前往佢入面嘅項目。","TRANSCRIPT_LIVE_REGION_INTERACTIVE_WITH_LINKS_LABEL_ALT":"信息入面有網頁連結，襟 shift tab 兩三下去聊天記錄，再襟個信息前往佢入面嘅項目。","TRANSCRIPT_LIVE_REGION_SEND_FAILED_ALT":"有信息傳送唔倒。","TRANSCRIPT_LIVE_REGION_SUGGESTED_ACTIONS_LABEL_ALT":"信息有建議㩒嘅掣，可以襟 shift tab 兩三下揀佢哋。","TRANSCRIPT_LIVE_REGION_SUGGESTED_ACTIONS_WITH_ACCESS_KEY_LABEL_ALT":"信息有建議㩒嘅掣，可以襟 $1 揀佢哋。","TRANSCRIPT_MORE_MESSAGES":"更多訊息","TRANSCRIPT_NEW_MESSAGES":"新訊息","TRANSCRIPT_TERMINATOR_TEXT":"聊天記錄結束","TYPING_INDICATOR_ALT":"對方打緊字"}');

});

parcelRequire.register("NDOZ2", function(module, exports) {
module.exports = JSON.parse('{"_comment":"[CI-LOCKED] 此文件的内容已锁定。欢迎发布内容，但更改验证可能会延迟。","ACCESS_KEY_ALT":"Alt + Shift + $1","ACCESS_KEY_FOR_MAC_ALT":"控制键 + 选项键 + $1","ACTIVITY_BOT_SAID_ALT":"机器人 $1 说:","ACTIVITY_YOU_SAID_ALT":"您说:","ACTIVITY_BOT_ATTACHED_ALT":"机器人附加了:","ACTIVITY_ERROR_BOX_TITLE":"错误消息","ACTIVITY_INTERACTIVE_FOOTNOTE_ALT":"单击以进行交互。","ACTIVITY_INTERACTIVE_REASON_INTERACTIVE_CONTENT_ALT":"消息是交互式消息。","ACTIVITY_INTERACTIVE_REASON_LINK_ALT":"消息中有一个或多个链接。","ACTIVITY_INTERACTIVE_REASON_SEND_FAILED_ALT":"发送失败。","ACTIVITY_YOU_ATTACHED_ALT":"您附加了:","ACTIVITY_NUM_ATTACHMENTS_ONE_ALT":"1 个附件。","ACTIVITY_NUM_ATTACHMENTS_FEW_ALT":"$1 个附件。","ACTIVITY_NUM_ATTACHMENTS_MANY_ALT":"$1 个附件。","ACTIVITY_NUM_ATTACHMENTS_OTHER_ALT":"$1 个附件。","ACTIVITY_NUM_ATTACHMENTS_TWO_ALT":"$1 个附件。","ACTIVITY_STATUS_SEND_FAILED_RETRY":"发送失败。[重试][RETRY]。","ACTIVITY_STATUS_SEND_STATUS_ALT_SENDING":"正在发送","ACTIVITY_STATUS_SEND_STATUS_ALT_SENT_AT":"已于 $1 发送","ACTIVITY_STATUS_TIMESTAMP_JUST_NOW":"刚刚","ACTIVITY_STATUS_TIMESTAMP_ONE_HOUR_AGO":"1 小时前","ACTIVITY_STATUS_TIMESTAMP_ONE_MINUTE_AGO":"1 分钟前","ACTIVITY_STATUS_TIMESTAMP_TODAY":"今天","ACTIVITY_STATUS_TIMESTAMP_YESTERDAY":"昨天","ADAPTIVE_CARD_ERROR_BOX_TITLE_PARSE":"自适应卡分析错误","ADAPTIVE_CARD_ERROR_BOX_TITLE_RENDER":"自适应卡呈现错误","ATTACHMENT_AUDIO":"音频剪辑。","ATTACHMENT_CARD":"卡片: $1 $2 $3","ATTACHMENT_FILE":"文件: $1","ATTACHMENT_IMAGE":"图像","ATTACHMENT_TEXT":"文本: $1","ATTACHMENT_VIDEO":"视频剪辑","CAROUSEL_FLIPPER_LEFT_ALT":"左","CAROUSEL_FLIPPER_RIGHT_ALT":"右","CONNECTIVITY_STATUS_ALT_CONNECTED":"已连接","CONNECTIVITY_STATUS_ALT_CONNECTING":"正在连接...","CONNECTIVITY_STATUS_ALT_FATAL":"无法连接。","CONNECTIVITY_STATUS_ALT_RECONNECTING":"发生网络中断。正在重新连接...","CONNECTIVITY_STATUS_ALT_RENDER_ERROR":"呈现错误。请检查控制台或联系机器人开发者。","CONNECTIVITY_STATUS_ALT_SLOW_CONNECTION":"连接所花费的时间长于平时。","CONNECTIVITY_STATUS_ALT":"连接状态: $1","FILE_CONTENT_ALT":"\'$1\'","FILE_CONTENT_DOWNLOADABLE_ALT":"下载文件 \'$1\'","FILE_CONTENT_DOWNLOADABLE_WITH_SIZE_ALT":"下载文件 \'$1\'，大小为 $2","FILE_CONTENT_WITH_SIZE_ALT":"\'$1\' 的大小为 $2","KEYBOARD_HELP_CHAT_HISTORY_ACCESS_ITEMS_IN_MESSAGE_BODY":"Enter 键","KEYBOARD_HELP_CHAT_HISTORY_ACCESS_ITEMS_IN_MESSAGE_HEADER":"访问消息中的项目","KEYBOARD_HELP_CHAT_HISTORY_HEADER":"聊天历史记录","KEYBOARD_HELP_CHAT_HISTORY_LEAVE_MESSAGE_BODY":"Escape 键","KEYBOARD_HELP_CHAT_HISTORY_LEAVE_MESSAGE_HEADER":"退出消息","KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_ITEMS_BODY":"Tab 键\\nShift + Tab 键","KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_ITEMS_HEADER":"在消息中的项目之间移动","KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_MESSAGES_BODY":"向上键\\n向下键","KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_MESSAGES_HEADER":"在消息之间移动","KEYBOARD_HELP_CHAT_WINDOW_BODY_DO_ACTION_BODY":"Enter 键","KEYBOARD_HELP_CHAT_WINDOW_BODY_DO_ACTION_HEADER":"执行操作","KEYBOARD_HELP_CHAT_WINDOW_BODY_MOVE_BETWEEN_ITEMS_BODY":"Tab 键\\nShift + Tab 键","KEYBOARD_HELP_CHAT_WINDOW_BODY_MOVE_BETWEEN_ITEMS_HEADER":"在聊天窗口中的项目之间移动","KEYBOARD_HELP_CHAT_WINDOW_HEADER":"聊天窗口","KEYBOARD_HELP_CLOSE_BUTTON_ALT":"关闭","KEYBOARD_HELP_HEADER":"键盘控件","MARKDOWN_EXTERNAL_LINK_ALT":"在新窗口中打开；外部。","RECEIPT_CARD_TAX":"税款","RECEIPT_CARD_TOTAL":"总额","RECEIPT_CARD_VAT":"增值税","SEND_BOX_IS_EMPTY_TOOLTIP_ALT":"无法发送空消息。","SPEECH_INPUT_LISTENING":"正在倾听...","SPEECH_INPUT_MICROPHONE_BUTTON_CLOSE_ALT":"麦克风关闭","SPEECH_INPUT_MICROPHONE_BUTTON_OPEN_ALT":"麦克风打开","SPEECH_INPUT_STARTING":"正在启动...","SUGGESTED_ACTIONS_LABEL_ALT":"建议的操作","TEXT_INPUT_ALT":"消息输入框","TEXT_INPUT_PLACEHOLDER":"键入消息","TEXT_INPUT_SEND_BUTTON_ALT":"发送","TEXT_INPUT_SPEAK_BUTTON_ALT":"咨询","TEXT_INPUT_UPLOAD_BUTTON_ALT":"上传文件","TOAST_ACCORDION_FEW":"$1 条通知: 单击此处以查看详细信息","TOAST_ACCORDION_MANY":"$1 条通知: 单击此处以查看详细信息","TOAST_ACCORDION_OTHER":"$1 条通知: 单击此处以查看详细信息","TOAST_ACCORDION_TWO":"$1 条通知: 单击此处以查看详细信息","TOAST_ALT_ERROR":"出错","TOAST_ALT_INFO":"信息","TOAST_ALT_SUCCESS":"成功","TOAST_ALT_WARN":"警告","TOAST_DISMISS_BUTTON":"取消","TOAST_TITLE_ALT":"通知","TRANSCRIPT_ARIA_LABEL_ALT":"聊天历史记录，按箭头键导航。","TRANSCRIPT_ARIA_ROLE_ALT":"聊天历史记录","TRANSCRIPT_LIVE_REGION_INTERACTIVE_LABEL_ALT":"消息是交互式消息。按 Shift Tab 键 2 到 3 次切换到聊天历史记录。然后单击消息以进行交互。","TRANSCRIPT_LIVE_REGION_INTERACTIVE_WITH_LINKS_LABEL_ALT":"消息中有一个或多个链接。按 Shift Tab 键 2 到 3 次切换到聊天历史记录。然后单击消息以进行交互。","TRANSCRIPT_LIVE_REGION_SUGGESTED_ACTIONS_LABEL_ALT":"消息提供了建议的操作。请按 Shift + Tab 键 2 到 3 次进行选择。","TRANSCRIPT_LIVE_REGION_SUGGESTED_ACTIONS_WITH_ACCESS_KEY_LABEL_ALT":"消息提供了建议的操作。请按 $1 进行选择。","TRANSCRIPT_LIVE_REGION_SEND_FAILED_ALT":"无法发送消息。","TRANSCRIPT_MORE_MESSAGES":"更多消息","TRANSCRIPT_NEW_MESSAGES":"新消息","TRANSCRIPT_TERMINATOR_TEXT":"聊天历史记录结束","TYPING_INDICATOR_ALT":"显示键入指示器","TYPING_INDICATOR_SINGLE_TEXT":"$1 正在键入。","TYPING_INDICATOR_MULTIPLE_TEXT":"$1 和其他人正在键入。"}');

});

parcelRequire.register("l2l1P", function(module, exports) {
module.exports = JSON.parse('{"_comment":"[CI-LOCKED] 此檔案的內容已鎖定。歡迎提供意見，但變更驗證可能會有所延遲。","ACCESS_KEY_ALT":"Alt Shift $1","ACCESS_KEY_FOR_MAC_ALT":"Control Option $1","ACTIVITY_BOT_SAID_ALT":"機器人 $1 說:","ACTIVITY_YOU_SAID_ALT":"您說:","ACTIVITY_BOT_ATTACHED_ALT":"機器人附加了:","ACTIVITY_ERROR_BOX_TITLE":"錯誤訊息","ACTIVITY_INTERACTIVE_FOOTNOTE_ALT":"按一下以進行互動。","ACTIVITY_INTERACTIVE_REASON_INTERACTIVE_CONTENT_ALT":"訊息為互動式訊息。","ACTIVITY_INTERACTIVE_REASON_LINK_ALT":"訊息中有一或多個連結。","ACTIVITY_INTERACTIVE_REASON_SEND_FAILED_ALT":"傳送失敗。","ACTIVITY_YOU_ATTACHED_ALT":"您附加了:","ACTIVITY_NUM_ATTACHMENTS_ONE_ALT":"1 個附件。","ACTIVITY_NUM_ATTACHMENTS_FEW_ALT":"$1 個附件。","ACTIVITY_NUM_ATTACHMENTS_MANY_ALT":"$1 個附件。","ACTIVITY_NUM_ATTACHMENTS_OTHER_ALT":"$1 個附件。","ACTIVITY_NUM_ATTACHMENTS_TWO_ALT":"$1 個附件。","ACTIVITY_STATUS_SEND_FAILED_RETRY":"傳送失敗。[重試][RETRY]。","ACTIVITY_STATUS_SEND_STATUS_ALT_SENDING":"正在傳送","ACTIVITY_STATUS_SEND_STATUS_ALT_SENT_AT":"於 $1 傳送","ACTIVITY_STATUS_TIMESTAMP_JUST_NOW":"剛剛","ACTIVITY_STATUS_TIMESTAMP_ONE_HOUR_AGO":"1 小時前","ACTIVITY_STATUS_TIMESTAMP_ONE_MINUTE_AGO":"1 分鐘前","ACTIVITY_STATUS_TIMESTAMP_TODAY":"今天","ACTIVITY_STATUS_TIMESTAMP_YESTERDAY":"昨天","ADAPTIVE_CARD_ERROR_BOX_TITLE_PARSE":"調適型卡片剖析錯誤","ADAPTIVE_CARD_ERROR_BOX_TITLE_RENDER":"調適型卡片轉譯錯誤","ATTACHMENT_AUDIO":"音訊剪輯。","ATTACHMENT_CARD":"卡片: $1 $2 $3","ATTACHMENT_FILE":"檔案: $1","ATTACHMENT_IMAGE":"影像","ATTACHMENT_TEXT":"文字: $1","ATTACHMENT_VIDEO":"視訊剪輯","CAROUSEL_FLIPPER_LEFT_ALT":"向左翻轉","CAROUSEL_FLIPPER_RIGHT_ALT":"向右翻轉","CONNECTIVITY_STATUS_ALT_CONNECTED":"已連線","CONNECTIVITY_STATUS_ALT_CONNECTING":"正在連線…","CONNECTIVITY_STATUS_ALT_FATAL":"無法連線。","CONNECTIVITY_STATUS_ALT_RECONNECTING":"發生網路中斷。正在重新連線…","CONNECTIVITY_STATUS_ALT_RENDER_ERROR":"轉譯錯誤。請檢查主控台或連絡機器人開發人員。","CONNECTIVITY_STATUS_ALT_SLOW_CONNECTION":"連線所需的時間比平時更長。","CONNECTIVITY_STATUS_ALT":"連線狀態: $1","FILE_CONTENT_ALT":"\'$1\'","FILE_CONTENT_DOWNLOADABLE_ALT":"下載 \'$1\' 檔案","FILE_CONTENT_DOWNLOADABLE_WITH_SIZE_ALT":"下載 \'$1\' 檔案，大小為 $2","FILE_CONTENT_WITH_SIZE_ALT":"\'$1\'，大小為 $2","KEYBOARD_HELP_CHAT_HISTORY_ACCESS_ITEMS_IN_MESSAGE_BODY":"ENTER 鍵","KEYBOARD_HELP_CHAT_HISTORY_ACCESS_ITEMS_IN_MESSAGE_HEADER":"存取訊息中的項目","KEYBOARD_HELP_CHAT_HISTORY_HEADER":"聊天記錄","KEYBOARD_HELP_CHAT_HISTORY_LEAVE_MESSAGE_BODY":"ESC 鍵","KEYBOARD_HELP_CHAT_HISTORY_LEAVE_MESSAGE_HEADER":"結束訊息","KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_ITEMS_BODY":"Tab 鍵\\nShift + Tab 鍵","KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_ITEMS_HEADER":"在訊息中的項目之間移動","KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_MESSAGES_BODY":"向上鍵\\n向下鍵","KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_MESSAGES_HEADER":"在訊息之間移動","KEYBOARD_HELP_CHAT_WINDOW_BODY_DO_ACTION_BODY":"ENTER 鍵","KEYBOARD_HELP_CHAT_WINDOW_BODY_DO_ACTION_HEADER":"執行動作","KEYBOARD_HELP_CHAT_WINDOW_BODY_MOVE_BETWEEN_ITEMS_BODY":"Tab 鍵\\nShift + Tab 鍵","KEYBOARD_HELP_CHAT_WINDOW_BODY_MOVE_BETWEEN_ITEMS_HEADER":"在聊天視窗中的項目之間移動","KEYBOARD_HELP_CHAT_WINDOW_HEADER":"聊天視窗","KEYBOARD_HELP_CLOSE_BUTTON_ALT":"關閉","KEYBOARD_HELP_HEADER":"鍵盤控制項","MARKDOWN_EXTERNAL_LINK_ALT":"在新視窗中開啟; 外部。","RECEIPT_CARD_TAX":"稅金","RECEIPT_CARD_TOTAL":"總計","RECEIPT_CARD_VAT":"加值稅","SEND_BOX_IS_EMPTY_TOOLTIP_ALT":"無法傳送空白訊息。","SPEECH_INPUT_LISTENING":"正在聆聽…","SPEECH_INPUT_MICROPHONE_BUTTON_CLOSE_ALT":"關閉麥克風","SPEECH_INPUT_MICROPHONE_BUTTON_OPEN_ALT":"開啟麥克風","SPEECH_INPUT_STARTING":"正在啟動…","SUGGESTED_ACTIONS_LABEL_ALT":"建議的動作","TEXT_INPUT_ALT":"訊息輸入方塊","TEXT_INPUT_PLACEHOLDER":"輸入您的訊息","TEXT_INPUT_SEND_BUTTON_ALT":"傳送","TEXT_INPUT_SPEAK_BUTTON_ALT":"說話","TEXT_INPUT_UPLOAD_BUTTON_ALT":"上傳檔案","TOAST_ACCORDION_FEW":"$1 則通知: 按一下這裡來查看詳細資料","TOAST_ACCORDION_MANY":"$1 則通知: 按一下這裡來查看詳細資料","TOAST_ACCORDION_OTHER":"$1 則通知: 按一下這裡來查看詳細資料","TOAST_ACCORDION_TWO":"$1 則通知: 按一下這裡來查看詳細資料","TOAST_ALT_ERROR":"錯誤","TOAST_ALT_INFO":"資訊","TOAST_ALT_SUCCESS":"成功","TOAST_ALT_WARN":"警告","TOAST_DISMISS_BUTTON":"關閉","TOAST_TITLE_ALT":"通知","TRANSCRIPT_ARIA_LABEL_ALT":"聊天記錄，按方向鍵進行瀏覽。","TRANSCRIPT_ARIA_ROLE_ALT":"聊天記錄","TRANSCRIPT_LIVE_REGION_INTERACTIVE_LABEL_ALT":"訊息為互動式。請按 Shift Tab 鍵 2 到 3 次切換至聊天記錄，然後按一下訊息進行互動。","TRANSCRIPT_LIVE_REGION_INTERACTIVE_WITH_LINKS_LABEL_ALT":"訊息中的一或多個連結。請按 Shift Tab 鍵 2 到 3 次切換至聊天記錄，然後按一下訊息進行互動。","TRANSCRIPT_LIVE_REGION_SUGGESTED_ACTIONS_LABEL_ALT":"訊息有建議的動作。請按下 Shift Tab 2 至 3 次選取它們。","TRANSCRIPT_LIVE_REGION_SUGGESTED_ACTIONS_WITH_ACCESS_KEY_LABEL_ALT":"訊息有建議的動作。請按下 $1 選取它們。","TRANSCRIPT_LIVE_REGION_SEND_FAILED_ALT":"無法傳送訊息。","TRANSCRIPT_MORE_MESSAGES":"更多訊息","TRANSCRIPT_NEW_MESSAGES":"新訊息","TRANSCRIPT_TERMINATOR_TEXT":"聊天記錄結尾","TYPING_INDICATOR_ALT":"顯示輸入指示器","TYPING_INDICATOR_SINGLE_TEXT":"$1 正在鍵入。","TYPING_INDICATOR_MULTIPLE_TEXT":"$1 和其他人正在鍵入。"}');

});

parcelRequire.register("185Py", function(module, exports) {
module.exports = JSON.parse('{"_comment":"[CI-LOCKED] 此檔案的內容已鎖定。歡迎提供意見，但變更驗證可能會有所延遲。","ACCESS_KEY_ALT":"Alt Shift $1","ACCESS_KEY_FOR_MAC_ALT":"Control Option $1","ACTIVITY_BOT_SAID_ALT":"機器人 $1 說:","ACTIVITY_YOU_SAID_ALT":"您說:","ACTIVITY_BOT_ATTACHED_ALT":"機器人附加了:","ACTIVITY_ERROR_BOX_TITLE":"錯誤訊息","ACTIVITY_INTERACTIVE_FOOTNOTE_ALT":"按一下以進行互動。","ACTIVITY_INTERACTIVE_REASON_INTERACTIVE_CONTENT_ALT":"訊息為互動式訊息。","ACTIVITY_INTERACTIVE_REASON_LINK_ALT":"訊息中有一或多個連結。","ACTIVITY_INTERACTIVE_REASON_SEND_FAILED_ALT":"傳送失敗。","ACTIVITY_YOU_ATTACHED_ALT":"您附加了:","ACTIVITY_NUM_ATTACHMENTS_ONE_ALT":"1 個附件。","ACTIVITY_NUM_ATTACHMENTS_FEW_ALT":"$1 個附件。","ACTIVITY_NUM_ATTACHMENTS_MANY_ALT":"$1 個附件。","ACTIVITY_NUM_ATTACHMENTS_OTHER_ALT":"$1 個附件。","ACTIVITY_NUM_ATTACHMENTS_TWO_ALT":"$1 個附件。","ACTIVITY_STATUS_SEND_FAILED_RETRY":"傳送失敗。[重試][RETRY]。","ACTIVITY_STATUS_SEND_STATUS_ALT_SENDING":"正在傳送","ACTIVITY_STATUS_SEND_STATUS_ALT_SENT_AT":"於 $1 傳送","ACTIVITY_STATUS_TIMESTAMP_JUST_NOW":"剛剛","ACTIVITY_STATUS_TIMESTAMP_ONE_HOUR_AGO":"1 小時前","ACTIVITY_STATUS_TIMESTAMP_ONE_MINUTE_AGO":"1 分鐘前","ACTIVITY_STATUS_TIMESTAMP_TODAY":"今天","ACTIVITY_STATUS_TIMESTAMP_YESTERDAY":"昨天","ADAPTIVE_CARD_ERROR_BOX_TITLE_PARSE":"調適型卡片剖析錯誤","ADAPTIVE_CARD_ERROR_BOX_TITLE_RENDER":"調適型卡片轉譯錯誤","ATTACHMENT_AUDIO":"音訊剪輯。","ATTACHMENT_CARD":"卡片: $1 $2 $3","ATTACHMENT_FILE":"檔案: $1","ATTACHMENT_IMAGE":"影像","ATTACHMENT_TEXT":"文字: $1","ATTACHMENT_VIDEO":"視訊剪輯","CAROUSEL_FLIPPER_LEFT_ALT":"向左翻轉","CAROUSEL_FLIPPER_RIGHT_ALT":"向右翻轉","CONNECTIVITY_STATUS_ALT_CONNECTED":"已連線","CONNECTIVITY_STATUS_ALT_CONNECTING":"正在連線…","CONNECTIVITY_STATUS_ALT_FATAL":"無法連線。","CONNECTIVITY_STATUS_ALT_RECONNECTING":"發生網路中斷。正在重新連線…","CONNECTIVITY_STATUS_ALT_RENDER_ERROR":"轉譯錯誤。請檢查主控台或連絡機器人開發人員。","CONNECTIVITY_STATUS_ALT_SLOW_CONNECTION":"連線所需的時間比平時更長。","CONNECTIVITY_STATUS_ALT":"連線狀態: $1","FILE_CONTENT_ALT":"\'$1\'","FILE_CONTENT_DOWNLOADABLE_ALT":"下載 \'$1\' 檔案","FILE_CONTENT_DOWNLOADABLE_WITH_SIZE_ALT":"下載 \'$1\' 檔案，大小為 $2","FILE_CONTENT_WITH_SIZE_ALT":"\'$1\'，大小為 $2","KEYBOARD_HELP_CHAT_HISTORY_ACCESS_ITEMS_IN_MESSAGE_BODY":"ENTER 鍵","KEYBOARD_HELP_CHAT_HISTORY_ACCESS_ITEMS_IN_MESSAGE_HEADER":"存取訊息中的項目","KEYBOARD_HELP_CHAT_HISTORY_HEADER":"聊天記錄","KEYBOARD_HELP_CHAT_HISTORY_LEAVE_MESSAGE_BODY":"ESC 鍵","KEYBOARD_HELP_CHAT_HISTORY_LEAVE_MESSAGE_HEADER":"結束訊息","KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_ITEMS_BODY":"Tab 鍵\\nShift + Tab 鍵","KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_ITEMS_HEADER":"在訊息中的項目之間移動","KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_MESSAGES_BODY":"向上鍵\\n向下鍵","KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_MESSAGES_HEADER":"在訊息之間移動","KEYBOARD_HELP_CHAT_WINDOW_BODY_DO_ACTION_BODY":"ENTER 鍵","KEYBOARD_HELP_CHAT_WINDOW_BODY_DO_ACTION_HEADER":"執行動作","KEYBOARD_HELP_CHAT_WINDOW_BODY_MOVE_BETWEEN_ITEMS_BODY":"Tab 鍵\\nShift + Tab 鍵","KEYBOARD_HELP_CHAT_WINDOW_BODY_MOVE_BETWEEN_ITEMS_HEADER":"在聊天視窗中的項目之間移動","KEYBOARD_HELP_CHAT_WINDOW_HEADER":"聊天視窗","KEYBOARD_HELP_CLOSE_BUTTON_ALT":"關閉","KEYBOARD_HELP_HEADER":"鍵盤控制項","MARKDOWN_EXTERNAL_LINK_ALT":"在新視窗中開啟; 外部。","RECEIPT_CARD_TAX":"稅金","RECEIPT_CARD_TOTAL":"總計","RECEIPT_CARD_VAT":"加值稅","SEND_BOX_IS_EMPTY_TOOLTIP_ALT":"無法傳送空白訊息。","SPEECH_INPUT_LISTENING":"正在聆聽…","SPEECH_INPUT_MICROPHONE_BUTTON_CLOSE_ALT":"關閉麥克風","SPEECH_INPUT_MICROPHONE_BUTTON_OPEN_ALT":"開啟麥克風","SPEECH_INPUT_STARTING":"正在啟動…","SUGGESTED_ACTIONS_LABEL_ALT":"建議的動作","TEXT_INPUT_ALT":"訊息輸入方塊","TEXT_INPUT_PLACEHOLDER":"輸入您的訊息","TEXT_INPUT_SEND_BUTTON_ALT":"傳送","TEXT_INPUT_SPEAK_BUTTON_ALT":"說話","TEXT_INPUT_UPLOAD_BUTTON_ALT":"上傳檔案","TOAST_ACCORDION_FEW":"$1 則通知: 按一下這裡來查看詳細資料","TOAST_ACCORDION_MANY":"$1 則通知: 按一下這裡來查看詳細資料","TOAST_ACCORDION_OTHER":"$1 則通知: 按一下這裡來查看詳細資料","TOAST_ACCORDION_TWO":"$1 則通知: 按一下這裡來查看詳細資料","TOAST_ALT_ERROR":"錯誤","TOAST_ALT_INFO":"資訊","TOAST_ALT_SUCCESS":"成功","TOAST_ALT_WARN":"警告","TOAST_DISMISS_BUTTON":"關閉","TOAST_TITLE_ALT":"通知","TRANSCRIPT_ARIA_LABEL_ALT":"聊天記錄，按方向鍵進行瀏覽。","TRANSCRIPT_ARIA_ROLE_ALT":"聊天記錄","TRANSCRIPT_LIVE_REGION_INTERACTIVE_LABEL_ALT":"訊息為互動式。請按 Shift Tab 鍵 2 到 3 次切換至聊天記錄，然後按一下訊息進行互動。","TRANSCRIPT_LIVE_REGION_INTERACTIVE_WITH_LINKS_LABEL_ALT":"訊息中的一或多個連結。請按 Shift Tab 鍵 2 到 3 次切換至聊天記錄，然後按一下訊息進行互動。","TRANSCRIPT_LIVE_REGION_SUGGESTED_ACTIONS_LABEL_ALT":"訊息有建議的動作。請按下 Shift Tab 2 至 3 次選取它們。","TRANSCRIPT_LIVE_REGION_SUGGESTED_ACTIONS_WITH_ACCESS_KEY_LABEL_ALT":"訊息有建議的動作。請按下 $1 選取它們。","TRANSCRIPT_LIVE_REGION_SEND_FAILED_ALT":"無法傳送訊息。","TRANSCRIPT_MORE_MESSAGES":"更多訊息","TRANSCRIPT_NEW_MESSAGES":"新訊息","TRANSCRIPT_TERMINATOR_TEXT":"聊天記錄結尾","TYPING_INDICATOR_ALT":"顯示輸入指示器","TYPING_INDICATOR_SINGLE_TEXT":"$1 正在鍵入。","TYPING_INDICATOR_MULTIPLE_TEXT":"$1 和其他人正在鍵入。"}');

});

parcelRequire.register("9KRJw", function(module, exports) {
module.exports = JSON.parse('{"ar-EG":{"COGNITIVE_SERVICES_SPEECH_TO_TEXT":true,"COGNITIVE_SERVICES_TEXT_TO_SPEECH":true,"GLOBALIZE_LANGUAGE":"ar-EG","SPEECH_LANGUAGE":"ar-EG"},"ar-SA":{"COGNITIVE_SERVICES_SPEECH_TO_TEXT":true,"COGNITIVE_SERVICES_TEXT_TO_SPEECH":true,"GLOBALIZE_LANGUAGE":"ar-SA","SPEECH_LANGUAGE":"ar-SA"},"bg-BG":{"COGNITIVE_SERVICES_TEXT_TO_SPEECH":true,"GLOBALIZE_LANGUAGE":"bg","SPEECH_LANGUAGE":"bg-BG"},"ca-ES":{"COGNITIVE_SERVICES_SPEECH_TO_TEXT":true,"COGNITIVE_SERVICES_TEXT_TO_SPEECH":true,"GLOBALIZE_LANGUAGE":"ca","SPEECH_LANGUAGE":"ca-ES"},"cs-CZ":{"COGNITIVE_SERVICES_TEXT_TO_SPEECH":true,"GLOBALIZE_LANGUAGE":"cs","SPEECH_LANGUAGE":"cs-CZ"},"da-DK":{"COGNITIVE_SERVICES_SPEECH_TO_TEXT":true,"COGNITIVE_SERVICES_TEXT_TO_SPEECH":true,"GLOBALIZE_LANGUAGE":"da","SPEECH_LANGUAGE":"da-DK"},"de-DE":{"COGNITIVE_SERVICES_SPEECH_TO_TEXT":true,"COGNITIVE_SERVICES_TEXT_TO_SPEECH":"neural","GLOBALIZE_LANGUAGE":"de","SPEECH_LANGUAGE":"de-DE"},"el-GR":{"COGNITIVE_SERVICES_TEXT_TO_SPEECH":true,"GLOBALIZE_LANGUAGE":"el","SPEECH_LANGUAGE":"el-GR"},"en-US":{"COGNITIVE_SERVICES_SPEECH_TO_TEXT":true,"COGNITIVE_SERVICES_TEXT_TO_SPEECH":"neural","GLOBALIZE_LANGUAGE":"en","SPEECH_LANGUAGE":"en-US"},"es-ES":{"COGNITIVE_SERVICES_SPEECH_TO_TEXT":true,"COGNITIVE_SERVICES_TEXT_TO_SPEECH":true,"GLOBALIZE_LANGUAGE":"es","SPEECH_LANGUAGE":"es-ES"},"et-EE":{"GLOBALIZE_LANGUAGE":"et"},"eu-ES":{"GLOBALIZE_LANGUAGE":"eu"},"fi-FI":{"COGNITIVE_SERVICES_SPEECH_TO_TEXT":true,"COGNITIVE_SERVICES_TEXT_TO_SPEECH":true,"GLOBALIZE_LANGUAGE":"fi","SPEECH_LANGUAGE":"fi-FI"},"fr-FR":{"COGNITIVE_SERVICES_SPEECH_TO_TEXT":true,"COGNITIVE_SERVICES_TEXT_TO_SPEECH":true,"GLOBALIZE_LANGUAGE":"fr","SPEECH_LANGUAGE":"fr-FR"},"gl-ES":{"GLOBALIZE_LANGUAGE":"gl"},"he-IL":{"COGNITIVE_SERVICES_TEXT_TO_SPEECH":true,"GLOBALIZE_LANGUAGE":"he","SPEECH_LANGUAGE":"he-IL"},"hi-IN":{"COGNITIVE_SERVICES_SPEECH_TO_TEXT":true,"COGNITIVE_SERVICES_TEXT_TO_SPEECH":true,"GLOBALIZE_LANGUAGE":"hi","SPEECH_LANGUAGE":"hi-IN"},"hr-HR":{"COGNITIVE_SERVICES_TEXT_TO_SPEECH":true,"GLOBALIZE_LANGUAGE":"hr","SPEECH_LANGUAGE":"hr-HR"},"hu-HU":{"COGNITIVE_SERVICES_TEXT_TO_SPEECH":true,"GLOBALIZE_LANGUAGE":"hu","SPEECH_LANGUAGE":"hu-HU"},"id-ID":{"COGNITIVE_SERVICES_TEXT_TO_SPEECH":true,"GLOBALIZE_LANGUAGE":"id","SPEECH_LANGUAGE":"id-ID"},"it-IT":{"COGNITIVE_SERVICES_SPEECH_TO_TEXT":true,"COGNITIVE_SERVICES_TEXT_TO_SPEECH":"neural","GLOBALIZE_LANGUAGE":"it","SPEECH_LANGUAGE":"it-IT"},"ja-JP":{"COGNITIVE_SERVICES_SPEECH_TO_TEXT":true,"COGNITIVE_SERVICES_TEXT_TO_SPEECH":true,"GLOBALIZE_LANGUAGE":"ja","SPEECH_LANGUAGE":"ja-JP"},"kk-KZ":{"GLOBALIZE_LANGUAGE":"kk"},"ko-KR":{"COGNITIVE_SERVICES_SPEECH_TO_TEXT":true,"COGNITIVE_SERVICES_TEXT_TO_SPEECH":true,"GLOBALIZE_LANGUAGE":"ko","SPEECH_LANGUAGE":"ko-KR"},"lt-LT":{"GLOBALIZE_LANGUAGE":"lt"},"lv-LV":{"GLOBALIZE_LANGUAGE":"lv"},"ms-MY":{"COGNITIVE_SERVICES_TEXT_TO_SPEECH":true,"GLOBALIZE_LANGUAGE":"ms","SPEECH_LANGUAGE":"ms-MY"},"nb-NO":{"COGNITIVE_SERVICES_SPEECH_TO_TEXT":true,"COGNITIVE_SERVICES_TEXT_TO_SPEECH":true,"GLOBALIZE_LANGUAGE":"nb","SPEECH_LANGUAGE":"nb-NO"},"nl-NL":{"COGNITIVE_SERVICES_SPEECH_TO_TEXT":true,"COGNITIVE_SERVICES_TEXT_TO_SPEECH":true,"GLOBALIZE_LANGUAGE":"nl","SPEECH_LANGUAGE":"nl-NL"},"pl-PL":{"COGNITIVE_SERVICES_SPEECH_TO_TEXT":true,"COGNITIVE_SERVICES_TEXT_TO_SPEECH":true,"GLOBALIZE_LANGUAGE":"pl","SPEECH_LANGUAGE":"pl-PL"},"pt-BR":{"COGNITIVE_SERVICES_SPEECH_TO_TEXT":true,"COGNITIVE_SERVICES_TEXT_TO_SPEECH":true,"GLOBALIZE_LANGUAGE":"pt","SPEECH_LANGUAGE":"pt-BR"},"pt-PT":{"COGNITIVE_SERVICES_SPEECH_TO_TEXT":true,"COGNITIVE_SERVICES_TEXT_TO_SPEECH":true,"GLOBALIZE_LANGUAGE":"pt-PT","SPEECH_LANGUAGE":"pt-PT"},"ro-RO":{"COGNITIVE_SERVICES_TEXT_TO_SPEECH":true,"GLOBALIZE_LANGUAGE":"ro","SPEECH_LANGUAGE":"ro-RO"},"ru-RU":{"COGNITIVE_SERVICES_SPEECH_TO_TEXT":true,"COGNITIVE_SERVICES_TEXT_TO_SPEECH":true,"GLOBALIZE_LANGUAGE":"ru","SPEECH_LANGUAGE":"ru-RU"},"sk-SK":{"COGNITIVE_SERVICES_TEXT_TO_SPEECH":true,"GLOBALIZE_LANGUAGE":"sk","SPEECH_LANGUAGE":"sk-SK"},"sl-SI":{"COGNITIVE_SERVICES_TEXT_TO_SPEECH":true,"GLOBALIZE_LANGUAGE":"sl","SPEECH_LANGUAGE":"sl-SI"},"sr-Cyrl":{"GLOBALIZE_LANGUAGE":"sr-Cyrl"},"sr-Latn":{"GLOBALIZE_LANGUAGE":"sr-Latn"},"sv-SE":{"COGNITIVE_SERVICES_SPEECH_TO_TEXT":true,"COGNITIVE_SERVICES_TEXT_TO_SPEECH":true,"GLOBALIZE_LANGUAGE":"sv","SPEECH_LANGUAGE":"sv-SE"},"th-TH":{"COGNITIVE_SERVICES_SPEECH_TO_TEXT":true,"COGNITIVE_SERVICES_TEXT_TO_SPEECH":true,"GLOBALIZE_LANGUAGE":"th","SPEECH_LANGUAGE":"th-TH"},"tr-TR":{"COGNITIVE_SERVICES_SPEECH_TO_TEXT":true,"COGNITIVE_SERVICES_TEXT_TO_SPEECH":true,"GLOBALIZE_LANGUAGE":"tr","SPEECH_LANGUAGE":"tr-TR"},"uk-UA":{"GLOBALIZE_LANGUAGE":"uk"},"vi-VN":{"COGNITIVE_SERVICES_TEXT_TO_SPEECH":true,"GLOBALIZE_LANGUAGE":"vi","SPEECH_LANGUAGE":"vi-VN"},"yue":{"COGNITIVE_SERVICES_SPEECH_TO_TEXT":true,"COGNITIVE_SERVICES_TEXT_TO_SPEECH":true,"GLOBALIZE_LANGUAGE":"yue","SPEECH_LANGUAGE":"zh-HK"},"zh-Hans":{"COGNITIVE_SERVICES_SPEECH_TO_TEXT":true,"COGNITIVE_SERVICES_TEXT_TO_SPEECH":"neural","GLOBALIZE_LANGUAGE":"zh-Hans","SPEECH_LANGUAGE":"zh-CN"},"zh-Hans-SG":{"COGNITIVE_SERVICES_SPEECH_TO_TEXT":true,"COGNITIVE_SERVICES_TEXT_TO_SPEECH":"neural","GLOBALIZE_LANGUAGE":"zh-Hans-SG","SPEECH_LANGUAGE":"zh-CN"},"zh-Hant":{"COGNITIVE_SERVICES_SPEECH_TO_TEXT":true,"COGNITIVE_SERVICES_TEXT_TO_SPEECH":true,"GLOBALIZE_LANGUAGE":"zh-Hant","SPEECH_LANGUAGE":"zh-TW"},"zh-Hant-HK":{"COGNITIVE_SERVICES_SPEECH_TO_TEXT":true,"COGNITIVE_SERVICES_TEXT_TO_SPEECH":true,"GLOBALIZE_LANGUAGE":"zh-Hant-HK","SPEECH_LANGUAGE":"zh-HK"},"zh-Hant-MO":{"COGNITIVE_SERVICES_SPEECH_TO_TEXT":true,"COGNITIVE_SERVICES_TEXT_TO_SPEECH":true,"GLOBALIZE_LANGUAGE":"zh-Hant-MO","SPEECH_LANGUAGE":"zh-HK"}}');

});

parcelRequire.register("4cVop", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $3104cd6365901447$var$mergeLocalizedStrings;

var $cG9B9 = parcelRequire("cG9B9");
function $3104cd6365901447$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $3104cd6365901447$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $3104cd6365901447$var$ownKeys(Object(source), !0).forEach(function(key) {
            $3104cd6365901447$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $3104cd6365901447$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $3104cd6365901447$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $3104cd6365901447$var$_createForOfIteratorHelper(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (!it) {
        if (Array.isArray(o) || (it = $3104cd6365901447$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
            if (it) o = it;
            var i = 0;
            var F = function F() {};
            return {
                s: F,
                n: function n() {
                    if (i >= o.length) return {
                        done: true
                    };
                    return {
                        done: false,
                        value: o[i++]
                    };
                },
                e: function e(_e) {
                    throw _e;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var normalCompletion = true, didErr = false, err;
    return {
        s: function s() {
            it = it.call(o);
        },
        n: function n() {
            var step = it.next();
            normalCompletion = step.done;
            return step;
        },
        e: function e(_e2) {
            didErr = true;
            err = _e2;
        },
        f: function f() {
            try {
                if (!normalCompletion && it.return != null) it.return();
            } finally{
                if (didErr) throw err;
            }
        }
    };
}
function $3104cd6365901447$var$_toConsumableArray(arr) {
    return $3104cd6365901447$var$_arrayWithoutHoles(arr) || $3104cd6365901447$var$_iterableToArray(arr) || $3104cd6365901447$var$_unsupportedIterableToArray(arr) || $3104cd6365901447$var$_nonIterableSpread();
}
function $3104cd6365901447$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $3104cd6365901447$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $3104cd6365901447$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $3104cd6365901447$var$_arrayLikeToArray(o, minLen);
}
function $3104cd6365901447$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $3104cd6365901447$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $3104cd6365901447$var$_arrayLikeToArray(arr);
}
function $3104cd6365901447$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $3104cd6365901447$var$mergeLocalizedStrings() {
    var merged = {};
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    var languages = args.reduce(function(keys, arg) {
        return [].concat($3104cd6365901447$var$_toConsumableArray(keys), $3104cd6365901447$var$_toConsumableArray(Object.keys(arg)));
    }, []);
    var _iterator = $3104cd6365901447$var$_createForOfIteratorHelper(new Set(languages)), _step;
    try {
        var _loop = function _loop() {
            var language = _step.value;
            if (!(0, $cG9B9.isForbiddenPropertyName)(language)) // Mitigation through denylisting.
            // eslint-disable-next-line security/detect-object-injection
            merged[language] = args.reduce(function(merged, arg) {
                return $3104cd6365901447$var$_objectSpread($3104cd6365901447$var$_objectSpread({}, merged), arg[language]);
            }, {});
        };
        for(_iterator.s(); !(_step = _iterator.n()).done;)_loop();
    } catch (err) {
        _iterator.e(err);
    } finally{
        _iterator.f();
    }
    return merged;
}

});


parcelRequire.register("4sDgs", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $33f83c08c6e06a7a$var$getRTLList;
// This list tracks which languages should display in Right-to-Left format by default
// When a new language is added, be sure to update this list.
// These values are intentionally hard-coded
// Should the following language be displayed in RTL by default?
// 'ar-EG' yes
// 'ar-JO' yes
// 'bg-BG'
// 'cs-CZ'
// 'da-DK'
// 'de-DE'
// 'el-GR'
// 'en-US'
// 'es-ES'
// 'fi-FI'
// 'fr-FR'
// 'he-IL' yes
// 'hu-HU'
// 'it-IT'
// 'ja-JP'
// 'ko-KR'
// 'lv-LV'
// 'nb-NO'
// 'nl-NL'
// 'pl-PL'
// 'pt-BR'
// 'pt-PT'
// 'ru-RU'
// 'sv-SE'
// 'tr-TR'
// 'zh-HANS'
// 'zh-HANT'
// 'zh-YUE'
function $33f83c08c6e06a7a$var$getRTLList() {
    var rtlList = [
        "ar-EG",
        "ar-JO",
        "ar-SA",
        "he-IL"
    ];
    return rtlList;
}

});

parcelRequire.register("dv55n", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $9d421d8cc4df76d2$var$normalizeLanguage;
/* eslint complexity: ["error", 100] */ // https://docs.microsoft.com/en-us/azure/cognitive-services/speech-service/language-support
function $9d421d8cc4df76d2$var$normalizeLanguage(language) {
    language = language.toLowerCase();
    if (language === "ar-eg") return "ar-EG";
    else if (language === "ar-jo") return "ar-JO";
    else if (language.startsWith("ar")) return "ar-SA";
    else if (language.startsWith("bg")) return "bg-BG";
    else if (language.startsWith("ca")) return "ca-ES";
    else if (language.startsWith("cs")) return "cs-CZ";
    else if (language.startsWith("da")) return "da-DK";
    else if (language.startsWith("de")) return "de-DE";
    else if (language.startsWith("el")) return "el-GR";
    else if (language.startsWith("es")) return "es-ES";
    else if (language.startsWith("et")) return "et-EE";
    else if (language.startsWith("eu")) return "eu-ES";
    else if (language.startsWith("fi")) return "fi-FI";
    else if (language.startsWith("fr")) return "fr-FR";
    else if (language.startsWith("gl")) return "gl-ES";
    else if (language.startsWith("he")) return "he-IL";
    else if (language.startsWith("hi")) return "hi-IN";
    else if (language.startsWith("hr")) return "hr-HR";
    else if (language.startsWith("hu")) return "hu-HU";
    else if (language.startsWith("id")) return "id-ID";
    else if (language.startsWith("it")) return "it-IT";
    else if (language.startsWith("ja")) return "ja-JP";
    else if (language.startsWith("kk")) return "kk-KZ";
    else if (language.startsWith("ko")) return "ko-KR";
    else if (language.startsWith("lt")) return "lt-LT";
    else if (language.startsWith("lv")) return "lv-LV";
    else if (language.startsWith("ms")) return "ms-MY";
    else if (language.startsWith("nb") || language.startsWith("nn") || language.startsWith("no")) return "nb-NO";
    else if (language.startsWith("nl")) return "nl-NL";
    else if (language.startsWith("pl")) return "pl-PL";
    else if (language === "pt-br") return "pt-BR";
    else if (language.startsWith("pt")) return "pt-PT";
    else if (language.startsWith("ro")) return "ro-RO";
    else if (language.startsWith("ru")) return "ru-RU";
    else if (language.startsWith("sk")) return "sk-SK";
    else if (language.startsWith("sl")) return "sl-SI";
    else if (language.startsWith("sr-cyrl")) return "sr-Cyrl";
    else if (language.startsWith("sr-latn")) return "sr-Latn";
    else if (language.startsWith("sv")) return "sv-SE";
    else if (language.startsWith("th")) return "th-TH";
    else if (language.startsWith("tr")) return "tr-TR";
    else if (language.startsWith("uk")) return "uk-UA";
    else if (language.startsWith("vi")) return "vi-VN";
    else if (language.startsWith("yue") || language === "zh-yue") {
        language === "zh-yue" && console.warn('botframework-webchat: The locale "zh-YUE" is being renamed to "yue" and deprecated. It will be removed on or after 2022-02-12.');
        return "yue";
    } else if (language === "zh-hant" || language === "zh-tw") return "zh-Hant";
    else if (language === "zh-hant-hk" || language === "zh-hk") return "zh-Hant-HK";
    else if (language === "zh-hant-mo" || language === "zh-mo") return "zh-Hant-MO";
    else if (language === "zh-hans-sg" || language === "zh-sg") return "zh-Hans-SG";
    else if (language.startsWith("zh")) return "zh-Hans";
    return "en-US";
}

});


parcelRequire.register("gySRD", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "useActiveTyping", {
    enumerable: true,
    get: function get() {
        return $c0ea6129a0f8c9fc$var$_useActiveTyping.default;
    }
});
Object.defineProperty(module.exports, "useActivities", {
    enumerable: true,
    get: function get() {
        return $c0ea6129a0f8c9fc$var$_useActivities.default;
    }
});
Object.defineProperty(module.exports, "useActivityKeys", {
    enumerable: true,
    get: function get() {
        return $c0ea6129a0f8c9fc$var$_useActivityKeys.default;
    }
});
Object.defineProperty(module.exports, "useActivityKeysByRead", {
    enumerable: true,
    get: function get() {
        return $c0ea6129a0f8c9fc$var$_useActivityKeysByRead.default;
    }
});
Object.defineProperty(module.exports, "useAvatarForBot", {
    enumerable: true,
    get: function get() {
        return $c0ea6129a0f8c9fc$var$_useAvatarForBot.default;
    }
});
Object.defineProperty(module.exports, "useAvatarForUser", {
    enumerable: true,
    get: function get() {
        return $c0ea6129a0f8c9fc$var$_useAvatarForUser.default;
    }
});
Object.defineProperty(module.exports, "useByteFormatter", {
    enumerable: true,
    get: function get() {
        return $c0ea6129a0f8c9fc$var$_useByteFormatter.default;
    }
});
Object.defineProperty(module.exports, "useConnectivityStatus", {
    enumerable: true,
    get: function get() {
        return $c0ea6129a0f8c9fc$var$_useConnectivityStatus.default;
    }
});
Object.defineProperty(module.exports, "useCreateActivityRenderer", {
    enumerable: true,
    get: function get() {
        return $c0ea6129a0f8c9fc$var$_useCreateActivityRenderer.default;
    }
});
Object.defineProperty(module.exports, "useCreateActivityStatusRenderer", {
    enumerable: true,
    get: function get() {
        return $c0ea6129a0f8c9fc$var$_useCreateActivityStatusRenderer.default;
    }
});
Object.defineProperty(module.exports, "useCreateAttachmentForScreenReaderRenderer", {
    enumerable: true,
    get: function get() {
        return $c0ea6129a0f8c9fc$var$_useCreateAttachmentForScreenReaderRenderer.default;
    }
});
Object.defineProperty(module.exports, "useCreateAvatarRenderer", {
    enumerable: true,
    get: function get() {
        return $c0ea6129a0f8c9fc$var$_useCreateAvatarRenderer.default;
    }
});
Object.defineProperty(module.exports, "useCreateScrollToEndButtonRenderer", {
    enumerable: true,
    get: function get() {
        return $c0ea6129a0f8c9fc$var$_useCreateScrollToEndButtonRenderer.default;
    }
});
Object.defineProperty(module.exports, "useDateFormatter", {
    enumerable: true,
    get: function get() {
        return $c0ea6129a0f8c9fc$var$_useDateFormatter.default;
    }
});
Object.defineProperty(module.exports, "useDebouncedNotifications", {
    enumerable: true,
    get: function get() {
        return $c0ea6129a0f8c9fc$var$_useDebouncedNotifications.default;
    }
});
Object.defineProperty(module.exports, "useDictateInterims", {
    enumerable: true,
    get: function get() {
        return $c0ea6129a0f8c9fc$var$_useDictateInterims.default;
    }
});
Object.defineProperty(module.exports, "useDictateState", {
    enumerable: true,
    get: function get() {
        return $c0ea6129a0f8c9fc$var$_useDictateState.default;
    }
});
Object.defineProperty(module.exports, "useDirection", {
    enumerable: true,
    get: function get() {
        return $c0ea6129a0f8c9fc$var$_useDirection.default;
    }
});
Object.defineProperty(module.exports, "useDisabled", {
    enumerable: true,
    get: function get() {
        return $c0ea6129a0f8c9fc$var$_useDisabled.default;
    }
});
Object.defineProperty(module.exports, "useDismissNotification", {
    enumerable: true,
    get: function get() {
        return $c0ea6129a0f8c9fc$var$_useDismissNotification.default;
    }
});
Object.defineProperty(module.exports, "useEmitTypingIndicator", {
    enumerable: true,
    get: function get() {
        return $c0ea6129a0f8c9fc$var$_useEmitTypingIndicator.default;
    }
});
Object.defineProperty(module.exports, "useGetActivityByKey", {
    enumerable: true,
    get: function get() {
        return $c0ea6129a0f8c9fc$var$_useGetActivityByKey.default;
    }
});
Object.defineProperty(module.exports, "useGetHasAcknowledgedByActivityKey", {
    enumerable: true,
    get: function get() {
        return $c0ea6129a0f8c9fc$var$_useGetHasAcknowledgedByActivityKey.default;
    }
});
Object.defineProperty(module.exports, "useGetKeyByActivity", {
    enumerable: true,
    get: function get() {
        return $c0ea6129a0f8c9fc$var$_useGetKeyByActivity.default;
    }
});
Object.defineProperty(module.exports, "useGetKeyByActivityId", {
    enumerable: true,
    get: function get() {
        return $c0ea6129a0f8c9fc$var$_useGetKeyByActivityId.default;
    }
});
Object.defineProperty(module.exports, "useGetSendTimeoutForActivity", {
    enumerable: true,
    get: function get() {
        return $c0ea6129a0f8c9fc$var$_useGetSendTimeoutForActivity.default;
    }
});
Object.defineProperty(module.exports, "useGrammars", {
    enumerable: true,
    get: function get() {
        return $c0ea6129a0f8c9fc$var$_useGrammars.default;
    }
});
Object.defineProperty(module.exports, "useGroupActivities", {
    enumerable: true,
    get: function get() {
        return $c0ea6129a0f8c9fc$var$_useGroupActivities.default;
    }
});
Object.defineProperty(module.exports, "useGroupTimestamp", {
    enumerable: true,
    get: function get() {
        return $c0ea6129a0f8c9fc$var$_useGroupTimestamp.default;
    }
});
Object.defineProperty(module.exports, "useLanguage", {
    enumerable: true,
    get: function get() {
        return $c0ea6129a0f8c9fc$var$_useLanguage.default;
    }
});
Object.defineProperty(module.exports, "useLastAcknowledgedActivityKey", {
    enumerable: true,
    get: function get() {
        return $c0ea6129a0f8c9fc$var$_useLastAcknowledgedActivityKey.default;
    }
});
Object.defineProperty(module.exports, "useLastReadActivityKey", {
    enumerable: true,
    get: function get() {
        return $c0ea6129a0f8c9fc$var$_useLastReadActivityKey.default;
    }
});
Object.defineProperty(module.exports, "useLocalizer", {
    enumerable: true,
    get: function get() {
        return $c0ea6129a0f8c9fc$var$_useLocalizer.default;
    }
});
Object.defineProperty(module.exports, "useMarkActivityAsSpoken", {
    enumerable: true,
    get: function get() {
        return $c0ea6129a0f8c9fc$var$_useMarkActivityAsSpoken.default;
    }
});
Object.defineProperty(module.exports, "useMarkActivityKeyAsRead", {
    enumerable: true,
    get: function get() {
        return $c0ea6129a0f8c9fc$var$_useMarkActivityKeyAsRead.default;
    }
});
Object.defineProperty(module.exports, "useMarkAllAsAcknowledged", {
    enumerable: true,
    get: function get() {
        return $c0ea6129a0f8c9fc$var$_useMarkAllAsAcknowledged.default;
    }
});
Object.defineProperty(module.exports, "usePerformCardAction", {
    enumerable: true,
    get: function get() {
        return $c0ea6129a0f8c9fc$var$_usePerformCardAction.default;
    }
});
Object.defineProperty(module.exports, "usePonyfill", {
    enumerable: true,
    get: function get() {
        return $c0ea6129a0f8c9fc$var$_usePonyfill.default;
    }
});
Object.defineProperty(module.exports, "usePostActivity", {
    enumerable: true,
    get: function get() {
        return $c0ea6129a0f8c9fc$var$_usePostActivity.default;
    }
});
Object.defineProperty(module.exports, "useReferenceGrammarID", {
    enumerable: true,
    get: function get() {
        return $c0ea6129a0f8c9fc$var$_useReferenceGrammarID.default;
    }
});
Object.defineProperty(module.exports, "useRelativeTimeFormatter", {
    enumerable: true,
    get: function get() {
        return $c0ea6129a0f8c9fc$var$_useRelativeTimeFormatter.default;
    }
});
Object.defineProperty(module.exports, "useRenderActivity", {
    enumerable: true,
    get: function get() {
        return $c0ea6129a0f8c9fc$var$_useRenderActivity.default;
    }
});
Object.defineProperty(module.exports, "useRenderActivityStatus", {
    enumerable: true,
    get: function get() {
        return $c0ea6129a0f8c9fc$var$_useRenderActivityStatus.default;
    }
});
Object.defineProperty(module.exports, "useRenderAttachment", {
    enumerable: true,
    get: function get() {
        return $c0ea6129a0f8c9fc$var$_useRenderAttachment.default;
    }
});
Object.defineProperty(module.exports, "useRenderAvatar", {
    enumerable: true,
    get: function get() {
        return $c0ea6129a0f8c9fc$var$_useRenderAvatar.default;
    }
});
Object.defineProperty(module.exports, "useRenderToast", {
    enumerable: true,
    get: function get() {
        return $c0ea6129a0f8c9fc$var$_useRenderToast.default;
    }
});
Object.defineProperty(module.exports, "useRenderTypingIndicator", {
    enumerable: true,
    get: function get() {
        return $c0ea6129a0f8c9fc$var$_useRenderTypingIndicator.default;
    }
});
Object.defineProperty(module.exports, "useSendBoxValue", {
    enumerable: true,
    get: function get() {
        return $c0ea6129a0f8c9fc$var$_useSendBoxValue.default;
    }
});
Object.defineProperty(module.exports, "useSendEvent", {
    enumerable: true,
    get: function get() {
        return $c0ea6129a0f8c9fc$var$_useSendEvent.default;
    }
});
Object.defineProperty(module.exports, "useSendFiles", {
    enumerable: true,
    get: function get() {
        return $c0ea6129a0f8c9fc$var$_useSendFiles.default;
    }
});
Object.defineProperty(module.exports, "useSendMessage", {
    enumerable: true,
    get: function get() {
        return $c0ea6129a0f8c9fc$var$_useSendMessage.default;
    }
});
Object.defineProperty(module.exports, "useSendMessageBack", {
    enumerable: true,
    get: function get() {
        return $c0ea6129a0f8c9fc$var$_useSendMessageBack.default;
    }
});
Object.defineProperty(module.exports, "useSendPostBack", {
    enumerable: true,
    get: function get() {
        return $c0ea6129a0f8c9fc$var$_useSendPostBack.default;
    }
});
Object.defineProperty(module.exports, "useSendStatusByActivityKey", {
    enumerable: true,
    get: function get() {
        return $c0ea6129a0f8c9fc$var$_useSendStatusByActivityKey.default;
    }
});
Object.defineProperty(module.exports, "useSendTimeoutForActivity", {
    enumerable: true,
    get: function get() {
        return $c0ea6129a0f8c9fc$var$_useSendTimeoutForActivity.default;
    }
});
Object.defineProperty(module.exports, "useSendTypingIndicator", {
    enumerable: true,
    get: function get() {
        return $c0ea6129a0f8c9fc$var$_useSendTypingIndicator.default;
    }
});
Object.defineProperty(module.exports, "useSetNotification", {
    enumerable: true,
    get: function get() {
        return $c0ea6129a0f8c9fc$var$_useSetNotification.default;
    }
});
Object.defineProperty(module.exports, "useShouldSpeakIncomingActivity", {
    enumerable: true,
    get: function get() {
        return $c0ea6129a0f8c9fc$var$_useShouldSpeakIncomingActivity.default;
    }
});
Object.defineProperty(module.exports, "useStartDictate", {
    enumerable: true,
    get: function get() {
        return $c0ea6129a0f8c9fc$var$_useStartDictate.default;
    }
});
Object.defineProperty(module.exports, "useStopDictate", {
    enumerable: true,
    get: function get() {
        return $c0ea6129a0f8c9fc$var$_useStopDictate.default;
    }
});
Object.defineProperty(module.exports, "useStyleOptions", {
    enumerable: true,
    get: function get() {
        return $c0ea6129a0f8c9fc$var$_useStyleOptions.default;
    }
});
Object.defineProperty(module.exports, "useSubmitSendBox", {
    enumerable: true,
    get: function get() {
        return $c0ea6129a0f8c9fc$var$_useSubmitSendBox.default;
    }
});
Object.defineProperty(module.exports, "useSuggestedActions", {
    enumerable: true,
    get: function get() {
        return $c0ea6129a0f8c9fc$var$_useSuggestedActions.default;
    }
});
Object.defineProperty(module.exports, "useTimeoutForSend", {
    enumerable: true,
    get: function get() {
        return $c0ea6129a0f8c9fc$var$_useTimeoutForSend.default;
    }
});
Object.defineProperty(module.exports, "useTrackDimension", {
    enumerable: true,
    get: function get() {
        return $c0ea6129a0f8c9fc$var$_useTrackDimension.default;
    }
});
Object.defineProperty(module.exports, "useTrackEvent", {
    enumerable: true,
    get: function get() {
        return $c0ea6129a0f8c9fc$var$_useTrackEvent.default;
    }
});
Object.defineProperty(module.exports, "useTrackException", {
    enumerable: true,
    get: function get() {
        return $c0ea6129a0f8c9fc$var$_useTrackException.default;
    }
});
Object.defineProperty(module.exports, "useTrackTiming", {
    enumerable: true,
    get: function get() {
        return $c0ea6129a0f8c9fc$var$_useTrackTiming.default;
    }
});
Object.defineProperty(module.exports, "useUserID", {
    enumerable: true,
    get: function get() {
        return $c0ea6129a0f8c9fc$var$_useUserID.default;
    }
});
Object.defineProperty(module.exports, "useUsername", {
    enumerable: true,
    get: function get() {
        return $c0ea6129a0f8c9fc$var$_useUsername.default;
    }
});
Object.defineProperty(module.exports, "useVoiceSelector", {
    enumerable: true,
    get: function get() {
        return $c0ea6129a0f8c9fc$var$_useVoiceSelector.default;
    }
});

var $c0ea6129a0f8c9fc$var$_useActiveTyping = $c0ea6129a0f8c9fc$var$_interopRequireDefault((parcelRequire("o07fR")));

var $c0ea6129a0f8c9fc$var$_useActivities = $c0ea6129a0f8c9fc$var$_interopRequireDefault((parcelRequire("3GEzF")));

var $c0ea6129a0f8c9fc$var$_useActivityKeys = $c0ea6129a0f8c9fc$var$_interopRequireDefault((parcelRequire("9sekQ")));

var $c0ea6129a0f8c9fc$var$_useActivityKeysByRead = $c0ea6129a0f8c9fc$var$_interopRequireDefault((parcelRequire("lpcyL")));

var $c0ea6129a0f8c9fc$var$_useAvatarForBot = $c0ea6129a0f8c9fc$var$_interopRequireDefault((parcelRequire("dGflF")));

var $c0ea6129a0f8c9fc$var$_useAvatarForUser = $c0ea6129a0f8c9fc$var$_interopRequireDefault((parcelRequire("7CkSv")));

var $c0ea6129a0f8c9fc$var$_useByteFormatter = $c0ea6129a0f8c9fc$var$_interopRequireDefault((parcelRequire("6LGrP")));

var $c0ea6129a0f8c9fc$var$_useConnectivityStatus = $c0ea6129a0f8c9fc$var$_interopRequireDefault((parcelRequire("jXJ2c")));

var $c0ea6129a0f8c9fc$var$_useCreateActivityRenderer = $c0ea6129a0f8c9fc$var$_interopRequireDefault((parcelRequire("58lAO")));

var $c0ea6129a0f8c9fc$var$_useCreateActivityStatusRenderer = $c0ea6129a0f8c9fc$var$_interopRequireDefault((parcelRequire("6dbay")));

var $c0ea6129a0f8c9fc$var$_useCreateAttachmentForScreenReaderRenderer = $c0ea6129a0f8c9fc$var$_interopRequireDefault((parcelRequire("4t1wo")));

var $c0ea6129a0f8c9fc$var$_useCreateAvatarRenderer = $c0ea6129a0f8c9fc$var$_interopRequireDefault((parcelRequire("50yWS")));

var $c0ea6129a0f8c9fc$var$_useCreateScrollToEndButtonRenderer = $c0ea6129a0f8c9fc$var$_interopRequireDefault((parcelRequire("OUH3C")));

var $c0ea6129a0f8c9fc$var$_useDateFormatter = $c0ea6129a0f8c9fc$var$_interopRequireDefault((parcelRequire("hl4fj")));

var $c0ea6129a0f8c9fc$var$_useDebouncedNotifications = $c0ea6129a0f8c9fc$var$_interopRequireDefault((parcelRequire("7hJ5F")));

var $c0ea6129a0f8c9fc$var$_useDictateInterims = $c0ea6129a0f8c9fc$var$_interopRequireDefault((parcelRequire("7wLcT")));

var $c0ea6129a0f8c9fc$var$_useDictateState = $c0ea6129a0f8c9fc$var$_interopRequireDefault((parcelRequire("3KHpv")));

var $c0ea6129a0f8c9fc$var$_useDirection = $c0ea6129a0f8c9fc$var$_interopRequireDefault((parcelRequire("hSqkZ")));

var $c0ea6129a0f8c9fc$var$_useDisabled = $c0ea6129a0f8c9fc$var$_interopRequireDefault((parcelRequire("e9Pg5")));

var $c0ea6129a0f8c9fc$var$_useDismissNotification = $c0ea6129a0f8c9fc$var$_interopRequireDefault((parcelRequire("lhEh6")));

var $c0ea6129a0f8c9fc$var$_useEmitTypingIndicator = $c0ea6129a0f8c9fc$var$_interopRequireDefault((parcelRequire("6aSFV")));

var $c0ea6129a0f8c9fc$var$_useGetActivityByKey = $c0ea6129a0f8c9fc$var$_interopRequireDefault((parcelRequire("1vzZN")));

var $c0ea6129a0f8c9fc$var$_useGetHasAcknowledgedByActivityKey = $c0ea6129a0f8c9fc$var$_interopRequireDefault((parcelRequire("6JDE4")));

var $c0ea6129a0f8c9fc$var$_useGetKeyByActivity = $c0ea6129a0f8c9fc$var$_interopRequireDefault((parcelRequire("9aUPz")));

var $c0ea6129a0f8c9fc$var$_useGetKeyByActivityId = $c0ea6129a0f8c9fc$var$_interopRequireDefault((parcelRequire("iJk3o")));

var $c0ea6129a0f8c9fc$var$_useGetSendTimeoutForActivity = $c0ea6129a0f8c9fc$var$_interopRequireDefault((parcelRequire("jjkwr")));

var $c0ea6129a0f8c9fc$var$_useGrammars = $c0ea6129a0f8c9fc$var$_interopRequireDefault((parcelRequire("czu2f")));

var $c0ea6129a0f8c9fc$var$_useGroupActivities = $c0ea6129a0f8c9fc$var$_interopRequireDefault((parcelRequire("2UqqE")));

var $c0ea6129a0f8c9fc$var$_useGroupTimestamp = $c0ea6129a0f8c9fc$var$_interopRequireDefault((parcelRequire("iW4GA")));

var $c0ea6129a0f8c9fc$var$_useLanguage = $c0ea6129a0f8c9fc$var$_interopRequireDefault((parcelRequire("aMPp7")));

var $c0ea6129a0f8c9fc$var$_useLastAcknowledgedActivityKey = $c0ea6129a0f8c9fc$var$_interopRequireDefault((parcelRequire("b0u7Y")));

var $c0ea6129a0f8c9fc$var$_useLastReadActivityKey = $c0ea6129a0f8c9fc$var$_interopRequireDefault((parcelRequire("9otH1")));

var $c0ea6129a0f8c9fc$var$_useLocalizer = $c0ea6129a0f8c9fc$var$_interopRequireDefault((parcelRequire("2IAYP")));

var $c0ea6129a0f8c9fc$var$_useMarkActivityAsSpoken = $c0ea6129a0f8c9fc$var$_interopRequireDefault((parcelRequire("8ElhC")));

var $c0ea6129a0f8c9fc$var$_useMarkActivityKeyAsRead = $c0ea6129a0f8c9fc$var$_interopRequireDefault((parcelRequire("joSJM")));

var $c0ea6129a0f8c9fc$var$_useMarkAllAsAcknowledged = $c0ea6129a0f8c9fc$var$_interopRequireDefault((parcelRequire("5c4UP")));

var $c0ea6129a0f8c9fc$var$_usePerformCardAction = $c0ea6129a0f8c9fc$var$_interopRequireDefault((parcelRequire("2Pnkq")));

var $c0ea6129a0f8c9fc$var$_usePonyfill = $c0ea6129a0f8c9fc$var$_interopRequireDefault((parcelRequire("44MU5")));

var $c0ea6129a0f8c9fc$var$_usePostActivity = $c0ea6129a0f8c9fc$var$_interopRequireDefault((parcelRequire("lONRC")));

var $c0ea6129a0f8c9fc$var$_useReferenceGrammarID = $c0ea6129a0f8c9fc$var$_interopRequireDefault((parcelRequire("5V3T4")));

var $c0ea6129a0f8c9fc$var$_useRelativeTimeFormatter = $c0ea6129a0f8c9fc$var$_interopRequireDefault((parcelRequire("3hnUi")));

var $c0ea6129a0f8c9fc$var$_useRenderActivity = $c0ea6129a0f8c9fc$var$_interopRequireDefault((parcelRequire("4ZeyW")));

var $c0ea6129a0f8c9fc$var$_useRenderActivityStatus = $c0ea6129a0f8c9fc$var$_interopRequireDefault((parcelRequire("a5W78")));

var $c0ea6129a0f8c9fc$var$_useRenderAttachment = $c0ea6129a0f8c9fc$var$_interopRequireDefault((parcelRequire("iYUPV")));

var $c0ea6129a0f8c9fc$var$_useRenderAvatar = $c0ea6129a0f8c9fc$var$_interopRequireDefault((parcelRequire("i6TPF")));

var $c0ea6129a0f8c9fc$var$_useRenderToast = $c0ea6129a0f8c9fc$var$_interopRequireDefault((parcelRequire("87kNX")));

var $c0ea6129a0f8c9fc$var$_useRenderTypingIndicator = $c0ea6129a0f8c9fc$var$_interopRequireDefault((parcelRequire("4wysF")));

var $c0ea6129a0f8c9fc$var$_useSendBoxValue = $c0ea6129a0f8c9fc$var$_interopRequireDefault((parcelRequire("e8zRO")));

var $c0ea6129a0f8c9fc$var$_useSendEvent = $c0ea6129a0f8c9fc$var$_interopRequireDefault((parcelRequire("fGYM8")));

var $c0ea6129a0f8c9fc$var$_useSendFiles = $c0ea6129a0f8c9fc$var$_interopRequireDefault((parcelRequire("8QzbZ")));

var $c0ea6129a0f8c9fc$var$_useSendMessage = $c0ea6129a0f8c9fc$var$_interopRequireDefault((parcelRequire("iG8sS")));

var $c0ea6129a0f8c9fc$var$_useSendMessageBack = $c0ea6129a0f8c9fc$var$_interopRequireDefault((parcelRequire("gkv00")));

var $c0ea6129a0f8c9fc$var$_useSendPostBack = $c0ea6129a0f8c9fc$var$_interopRequireDefault((parcelRequire("k6309")));

var $c0ea6129a0f8c9fc$var$_useSendStatusByActivityKey = $c0ea6129a0f8c9fc$var$_interopRequireDefault((parcelRequire("9Kvhn")));

var $c0ea6129a0f8c9fc$var$_useSendTimeoutForActivity = $c0ea6129a0f8c9fc$var$_interopRequireDefault((parcelRequire("cieis")));

var $c0ea6129a0f8c9fc$var$_useSendTypingIndicator = $c0ea6129a0f8c9fc$var$_interopRequireDefault((parcelRequire("kBjvJ")));

var $c0ea6129a0f8c9fc$var$_useSetNotification = $c0ea6129a0f8c9fc$var$_interopRequireDefault((parcelRequire("CsY1S")));

var $c0ea6129a0f8c9fc$var$_useShouldSpeakIncomingActivity = $c0ea6129a0f8c9fc$var$_interopRequireDefault((parcelRequire("gXEVs")));

var $c0ea6129a0f8c9fc$var$_useStartDictate = $c0ea6129a0f8c9fc$var$_interopRequireDefault((parcelRequire("dyPiT")));

var $c0ea6129a0f8c9fc$var$_useStopDictate = $c0ea6129a0f8c9fc$var$_interopRequireDefault((parcelRequire("luOtz")));

var $c0ea6129a0f8c9fc$var$_useStyleOptions = $c0ea6129a0f8c9fc$var$_interopRequireDefault((parcelRequire("fvJx2")));

var $c0ea6129a0f8c9fc$var$_useSubmitSendBox = $c0ea6129a0f8c9fc$var$_interopRequireDefault((parcelRequire("14JZO")));

var $c0ea6129a0f8c9fc$var$_useSuggestedActions = $c0ea6129a0f8c9fc$var$_interopRequireDefault((parcelRequire("2cUUK")));

var $c0ea6129a0f8c9fc$var$_useTimeoutForSend = $c0ea6129a0f8c9fc$var$_interopRequireDefault((parcelRequire("9umIc")));

var $c0ea6129a0f8c9fc$var$_useTrackDimension = $c0ea6129a0f8c9fc$var$_interopRequireDefault((parcelRequire("hg8oI")));

var $c0ea6129a0f8c9fc$var$_useTrackEvent = $c0ea6129a0f8c9fc$var$_interopRequireDefault((parcelRequire("f6yDt")));

var $c0ea6129a0f8c9fc$var$_useTrackException = $c0ea6129a0f8c9fc$var$_interopRequireDefault((parcelRequire("icwbb")));

var $c0ea6129a0f8c9fc$var$_useTrackTiming = $c0ea6129a0f8c9fc$var$_interopRequireDefault((parcelRequire("jQXaX")));

var $c0ea6129a0f8c9fc$var$_useUserID = $c0ea6129a0f8c9fc$var$_interopRequireDefault((parcelRequire("32oBN")));

var $c0ea6129a0f8c9fc$var$_useUsername = $c0ea6129a0f8c9fc$var$_interopRequireDefault((parcelRequire("hFcak")));

var $c0ea6129a0f8c9fc$var$_useVoiceSelector = $c0ea6129a0f8c9fc$var$_interopRequireDefault((parcelRequire("jl40b")));
function $c0ea6129a0f8c9fc$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}

});
parcelRequire.register("o07fR", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $eO7Kz = parcelRequire("eO7Kz");

var $kSc9m = parcelRequire("kSc9m");

var $0482550b0b66d56d$var$_useForceRender = $0482550b0b66d56d$var$_interopRequireDefault((parcelRequire("dC5YF")));

var $0482550b0b66d56d$var$_usePonyfill3 = $0482550b0b66d56d$var$_interopRequireDefault((parcelRequire("44MU5")));

var $0482550b0b66d56d$var$_useStyleOptions3 = $0482550b0b66d56d$var$_interopRequireDefault((parcelRequire("fvJx2")));
function $0482550b0b66d56d$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $0482550b0b66d56d$var$_toConsumableArray(arr) {
    return $0482550b0b66d56d$var$_arrayWithoutHoles(arr) || $0482550b0b66d56d$var$_iterableToArray(arr) || $0482550b0b66d56d$var$_unsupportedIterableToArray(arr) || $0482550b0b66d56d$var$_nonIterableSpread();
}
function $0482550b0b66d56d$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $0482550b0b66d56d$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $0482550b0b66d56d$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $0482550b0b66d56d$var$_arrayLikeToArray(arr);
}
function $0482550b0b66d56d$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $0482550b0b66d56d$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $0482550b0b66d56d$var$ownKeys(Object(source), !0).forEach(function(key) {
            $0482550b0b66d56d$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $0482550b0b66d56d$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $0482550b0b66d56d$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $0482550b0b66d56d$var$_slicedToArray(arr, i) {
    return $0482550b0b66d56d$var$_arrayWithHoles(arr) || $0482550b0b66d56d$var$_iterableToArrayLimit(arr, i) || $0482550b0b66d56d$var$_unsupportedIterableToArray(arr, i) || $0482550b0b66d56d$var$_nonIterableRest();
}
function $0482550b0b66d56d$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $0482550b0b66d56d$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $0482550b0b66d56d$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $0482550b0b66d56d$var$_arrayLikeToArray(o, minLen);
}
function $0482550b0b66d56d$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $0482550b0b66d56d$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $0482550b0b66d56d$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $0482550b0b66d56d$var$useActiveTyping(expireAfter) {
    var _usePonyfill = (0, $0482550b0b66d56d$var$_usePonyfill3.default)(), _usePonyfill2 = $0482550b0b66d56d$var$_slicedToArray(_usePonyfill, 1), _usePonyfill2$ = _usePonyfill2[0], clearTimeout = _usePonyfill2$.clearTimeout, Date = _usePonyfill2$.Date, setTimeout = _usePonyfill2$.setTimeout;
    var _useStyleOptions = (0, $0482550b0b66d56d$var$_useStyleOptions3.default)(), _useStyleOptions2 = $0482550b0b66d56d$var$_slicedToArray(_useStyleOptions, 1), typingAnimationDuration = _useStyleOptions2[0].typingAnimationDuration;
    var forceRender = (0, $0482550b0b66d56d$var$_useForceRender.default)();
    var typing = (0, $kSc9m.useSelector)(function(_ref) {
        var typing = _ref.typing;
        return typing;
    });
    var now = Date.now();
    if (typeof expireAfter !== "number") expireAfter = typingAnimationDuration;
    var activeTyping = Object.entries(typing).reduce(function(activeTyping, _ref2) {
        var _ref3 = $0482550b0b66d56d$var$_slicedToArray(_ref2, 2), id = _ref3[0], _ref3$ = _ref3[1], at = _ref3$.at, last = _ref3$.last, name = _ref3$.name, role = _ref3$.role;
        var until = last + expireAfter;
        if (until > now) return $0482550b0b66d56d$var$_objectSpread($0482550b0b66d56d$var$_objectSpread({}, activeTyping), {}, $0482550b0b66d56d$var$_defineProperty({}, id, {
            at: at,
            expireAt: until,
            name: name,
            role: role
        }));
        return activeTyping;
    }, {});
    var earliestExpireAt = Math.min.apply(Math, $0482550b0b66d56d$var$_toConsumableArray(Object.values(activeTyping).map(function(_ref4) {
        var expireAt = _ref4.expireAt;
        return expireAt;
    })));
    var timeToRender = earliestExpireAt && earliestExpireAt - now;
    (0, $eO7Kz.useEffect)(function() {
        if (timeToRender && isFinite(timeToRender)) {
            var timeout = setTimeout(forceRender, Math.max(0, timeToRender));
            return function() {
                return clearTimeout(timeout);
            };
        }
    }, [
        clearTimeout,
        forceRender,
        setTimeout,
        timeToRender
    ]);
    return [
        activeTyping
    ];
}
var $0482550b0b66d56d$var$_default = $0482550b0b66d56d$var$useActiveTyping;
module.exports.default = $0482550b0b66d56d$var$_default;

});
parcelRequire.register("kSc9m", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useSelector = module.exports.useDispatch = module.exports.default = void 0;

var $eO7Kz = parcelRequire("eO7Kz");
parcelRequire("7MIGR");
var $cXlDU = parcelRequire("cXlDU");
var $g5ZFo = parcelRequire("g5ZFo");
var $f3224683e6801495$var$context = /*#__PURE__*/ (0, $eO7Kz.createContext)();
var $f3224683e6801495$var$useDispatch = (0, $cXlDU.createDispatchHook)($f3224683e6801495$var$context);
module.exports.useDispatch = $f3224683e6801495$var$useDispatch;
var $f3224683e6801495$var$useSelector = (0, $g5ZFo.createSelectorHook)($f3224683e6801495$var$context);
module.exports.useSelector = $f3224683e6801495$var$useSelector;
$f3224683e6801495$var$context.displayName = "WebChatReduxContext";
var $f3224683e6801495$var$_default = $f3224683e6801495$var$context;
module.exports.default = $f3224683e6801495$var$_default;

});
parcelRequire.register("7MIGR", function(module, exports) {
$parcel$export(module.exports, "createDispatchHook", () => (parcelRequire("cXlDU")).createDispatchHook);
$parcel$export(module.exports, "createSelectorHook", () => (parcelRequire("g5ZFo")).createSelectorHook);
$parcel$export(module.exports, "Provider", () => (parcelRequire("g4TkW")).default);
parcelRequire("8dkKs");
parcelRequire("e0Pel");
var $kz03S = parcelRequire("kz03S");

var $55eY6 = parcelRequire("55eY6");
// with standard React renderers (ReactDOM, React Native)
(0, $55eY6.setBatch)((0, $kz03S.unstable_batchedUpdates));

});
parcelRequire.register("8dkKs", function(module, exports) {

$parcel$export(module.exports, "Provider", () => (parcelRequire("g4TkW")).default);
$parcel$export(module.exports, "createDispatchHook", () => (parcelRequire("cXlDU")).createDispatchHook);
$parcel$export(module.exports, "createSelectorHook", () => (parcelRequire("g5ZFo")).createSelectorHook);

var $g4TkW = parcelRequire("g4TkW");

var $9jigF = parcelRequire("9jigF");

var $lQ6Kh = parcelRequire("lQ6Kh");

var $4wTzX = parcelRequire("4wTzX");

var $cXlDU = parcelRequire("cXlDU");

var $g5ZFo = parcelRequire("g5ZFo");

var $lRLOM = parcelRequire("lRLOM");

var $bMzGX = parcelRequire("bMzGX");

});
parcelRequire.register("g4TkW", function(module, exports) {

$parcel$export(module.exports, "default", () => $bb47f1d00675d3fe$export$2e2bcd8739ae039);

var $eO7Kz = parcelRequire("eO7Kz");


var $lQ6Kh = parcelRequire("lQ6Kh");

var $aGRlO = parcelRequire("aGRlO");

var $doDZW = parcelRequire("doDZW");
function $bb47f1d00675d3fe$var$Provider(_ref) {
    var store = _ref.store, context = _ref.context, children = _ref.children;
    var contextValue = (0, $eO7Kz.useMemo)(function() {
        var subscription = (0, $aGRlO.createSubscription)(store);
        return {
            store: store,
            subscription: subscription
        };
    }, [
        store
    ]);
    var previousState = (0, $eO7Kz.useMemo)(function() {
        return store.getState();
    }, [
        store
    ]);
    (0, $doDZW.useIsomorphicLayoutEffect)(function() {
        var subscription = contextValue.subscription;
        subscription.onStateChange = subscription.notifyNestedSubs;
        subscription.trySubscribe();
        if (previousState !== store.getState()) subscription.notifyNestedSubs();
        return function() {
            subscription.tryUnsubscribe();
            subscription.onStateChange = null;
        };
    }, [
        contextValue,
        previousState
    ]);
    var Context = context || (0, $lQ6Kh.ReactReduxContext);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eO7Kz))).createElement(Context.Provider, {
        value: contextValue
    }, children);
}
var $bb47f1d00675d3fe$export$2e2bcd8739ae039 = $bb47f1d00675d3fe$var$Provider;

});
parcelRequire.register("lQ6Kh", function(module, exports) {

$parcel$export(module.exports, "ReactReduxContext", () => $fe63afcc5269bdcc$export$cc80c08dc91f1c00);

var $eO7Kz = parcelRequire("eO7Kz");
var $fe63afcc5269bdcc$export$cc80c08dc91f1c00 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eO7Kz))).createContext(null);
var $fe63afcc5269bdcc$export$2e2bcd8739ae039 = $fe63afcc5269bdcc$export$cc80c08dc91f1c00;

});

parcelRequire.register("aGRlO", function(module, exports) {

$parcel$export(module.exports, "createSubscription", () => $7c8735f8095b4cb4$export$d567d2b9af322f8f);

var $55eY6 = parcelRequire("55eY6");
// well as nesting subscriptions of descendant components, so that we can ensure the
// ancestor components re-render before descendants
function $7c8735f8095b4cb4$var$createListenerCollection() {
    var batch = (0, $55eY6.getBatch)();
    var first = null;
    var last = null;
    return {
        clear: function clear() {
            first = null;
            last = null;
        },
        notify: function notify() {
            batch(function() {
                var listener = first;
                while(listener){
                    listener.callback();
                    listener = listener.next;
                }
            });
        },
        get: function get() {
            var listeners = [];
            var listener = first;
            while(listener){
                listeners.push(listener);
                listener = listener.next;
            }
            return listeners;
        },
        subscribe: function subscribe(callback) {
            var isSubscribed = true;
            var listener = last = {
                callback: callback,
                next: null,
                prev: last
            };
            if (listener.prev) listener.prev.next = listener;
            else first = listener;
            return function unsubscribe() {
                if (!isSubscribed || first === null) return;
                isSubscribed = false;
                if (listener.next) listener.next.prev = listener.prev;
                else last = listener.prev;
                if (listener.prev) listener.prev.next = listener.next;
                else first = listener.next;
            };
        }
    };
}
var $7c8735f8095b4cb4$var$nullListeners = {
    notify: function notify() {},
    get: function get() {
        return [];
    }
};
function $7c8735f8095b4cb4$export$d567d2b9af322f8f(store, parentSub) {
    var unsubscribe;
    var listeners = $7c8735f8095b4cb4$var$nullListeners;
    function addNestedSub(listener) {
        trySubscribe();
        return listeners.subscribe(listener);
    }
    function notifyNestedSubs() {
        listeners.notify();
    }
    function handleChangeWrapper() {
        if (subscription.onStateChange) subscription.onStateChange();
    }
    function isSubscribed() {
        return Boolean(unsubscribe);
    }
    function trySubscribe() {
        if (!unsubscribe) {
            unsubscribe = parentSub ? parentSub.addNestedSub(handleChangeWrapper) : store.subscribe(handleChangeWrapper);
            listeners = $7c8735f8095b4cb4$var$createListenerCollection();
        }
    }
    function tryUnsubscribe() {
        if (unsubscribe) {
            unsubscribe();
            unsubscribe = undefined;
            listeners.clear();
            listeners = $7c8735f8095b4cb4$var$nullListeners;
        }
    }
    var subscription = {
        addNestedSub: addNestedSub,
        notifyNestedSubs: notifyNestedSubs,
        handleChangeWrapper: handleChangeWrapper,
        isSubscribed: isSubscribed,
        trySubscribe: trySubscribe,
        tryUnsubscribe: tryUnsubscribe,
        getListeners: function getListeners() {
            return listeners;
        }
    };
    return subscription;
}

});
parcelRequire.register("55eY6", function(module, exports) {

$parcel$export(module.exports, "setBatch", () => $3b3907d103ebea65$export$4b9874722d0da7bc);
$parcel$export(module.exports, "getBatch", () => $3b3907d103ebea65$export$fc47d4c0ba3bd2c6);
// Default to a dummy "batch" implementation that just runs the callback
function $3b3907d103ebea65$var$defaultNoopBatch(callback) {
    callback();
}
var $3b3907d103ebea65$var$batch = $3b3907d103ebea65$var$defaultNoopBatch; // Allow injecting another batching function later
var $3b3907d103ebea65$export$4b9874722d0da7bc = function setBatch(newBatch) {
    return $3b3907d103ebea65$var$batch = newBatch;
}; // Supply a getter just to skip dealing with ESM bindings
var $3b3907d103ebea65$export$fc47d4c0ba3bd2c6 = function getBatch() {
    return $3b3907d103ebea65$var$batch;
};

});


parcelRequire.register("doDZW", function(module, exports) {

$parcel$export(module.exports, "useIsomorphicLayoutEffect", () => $9c0c8b0f3da5e0a8$export$700979bc83e7db82);

var $eO7Kz = parcelRequire("eO7Kz");
var $9c0c8b0f3da5e0a8$export$700979bc83e7db82 = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined" ? (0, $eO7Kz.useLayoutEffect) : (0, $eO7Kz.useEffect);

});


parcelRequire.register("9jigF", function(module, exports) {

$parcel$export(module.exports, "default", () => $6c740f0534287cd1$export$2e2bcd8739ae039);

var $aO5a1 = parcelRequire("aO5a1");

var $akilq = parcelRequire("akilq");

var $hKDRv = parcelRequire("hKDRv");

var $eO7Kz = parcelRequire("eO7Kz");

var $aZLSG = parcelRequire("aZLSG");

var $aGRlO = parcelRequire("aGRlO");

var $doDZW = parcelRequire("doDZW");

var $lQ6Kh = parcelRequire("lQ6Kh");
var $6c740f0534287cd1$var$_excluded = [
    "getDisplayName",
    "methodName",
    "renderCountProp",
    "shouldHandleStateChanges",
    "storeKey",
    "withRef",
    "forwardRef",
    "context"
], $6c740f0534287cd1$var$_excluded2 = [
    "reactReduxForwardedRef"
];
var $6c740f0534287cd1$var$EMPTY_ARRAY = [];
var $6c740f0534287cd1$var$NO_SUBSCRIPTION_ARRAY = [
    null,
    null
];
var $6c740f0534287cd1$var$stringifyComponent = function stringifyComponent(Comp) {
    try {
        return JSON.stringify(Comp);
    } catch (err) {
        return String(Comp);
    }
};
function $6c740f0534287cd1$var$storeStateUpdatesReducer(state, action) {
    var updateCount = state[1];
    return [
        action.payload,
        updateCount + 1
    ];
}
function $6c740f0534287cd1$var$useIsomorphicLayoutEffectWithArgs(effectFunc, effectArgs, dependencies) {
    (0, $doDZW.useIsomorphicLayoutEffect)(function() {
        return effectFunc.apply(void 0, effectArgs);
    }, dependencies);
}
function $6c740f0534287cd1$var$captureWrapperProps(lastWrapperProps, lastChildProps, renderIsScheduled, wrapperProps, actualChildProps, childPropsFromStoreUpdate, notifyNestedSubs) {
    // We want to capture the wrapper props and child props we used for later comparisons
    lastWrapperProps.current = wrapperProps;
    lastChildProps.current = actualChildProps;
    renderIsScheduled.current = false; // If the render was from a store update, clear out that reference and cascade the subscriber update
    if (childPropsFromStoreUpdate.current) {
        childPropsFromStoreUpdate.current = null;
        notifyNestedSubs();
    }
}
function $6c740f0534287cd1$var$subscribeUpdates(shouldHandleStateChanges, store, subscription, childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, childPropsFromStoreUpdate, notifyNestedSubs, forceComponentUpdateDispatch) {
    // If we're not subscribed to the store, nothing to do here
    if (!shouldHandleStateChanges) return; // Capture values for checking if and when this component unmounts
    var didUnsubscribe = false;
    var lastThrownError = null; // We'll run this callback every time a store subscription update propagates to this component
    var checkForUpdates = function checkForUpdates() {
        if (didUnsubscribe) // Don't run stale listeners.
        // Redux doesn't guarantee unsubscriptions happen until next dispatch.
        return;
        var latestStoreState = store.getState();
        var newChildProps, error;
        try {
            // Actually run the selector with the most recent store state and wrapper props
            // to determine what the child props should be
            newChildProps = childPropsSelector(latestStoreState, lastWrapperProps.current);
        } catch (e) {
            error = e;
            lastThrownError = e;
        }
        if (!error) lastThrownError = null;
         // If the child props haven't changed, nothing to do here - cascade the subscription update
        if (newChildProps === lastChildProps.current) {
            if (!renderIsScheduled.current) notifyNestedSubs();
        } else {
            // Save references to the new child props.  Note that we track the "child props from store update"
            // as a ref instead of a useState/useReducer because we need a way to determine if that value has
            // been processed.  If this went into useState/useReducer, we couldn't clear out the value without
            // forcing another re-render, which we don't want.
            lastChildProps.current = newChildProps;
            childPropsFromStoreUpdate.current = newChildProps;
            renderIsScheduled.current = true; // If the child props _did_ change (or we caught an error), this wrapper component needs to re-render
            forceComponentUpdateDispatch({
                type: "STORE_UPDATED",
                payload: {
                    error: error
                }
            });
        }
    }; // Actually subscribe to the nearest connected ancestor (or store)
    subscription.onStateChange = checkForUpdates;
    subscription.trySubscribe(); // Pull data from the store after first render in case the store has
    // changed since we began.
    checkForUpdates();
    var unsubscribeWrapper = function unsubscribeWrapper() {
        didUnsubscribe = true;
        subscription.tryUnsubscribe();
        subscription.onStateChange = null;
        if (lastThrownError) // It's possible that we caught an error due to a bad mapState function, but the
        // parent re-rendered without this component and we're about to unmount.
        // This shouldn't happen as long as we do top-down subscriptions correctly, but
        // if we ever do those wrong, this throw will surface the error in our tests.
        // In that case, throw the error from here so it doesn't get lost.
        throw lastThrownError;
    };
    return unsubscribeWrapper;
}
var $6c740f0534287cd1$var$initStateUpdates = function initStateUpdates() {
    return [
        null,
        0
    ];
};
function $6c740f0534287cd1$export$2e2bcd8739ae039(/*
  selectorFactory is a func that is responsible for returning the selector function used to
  compute new props from state, props, and dispatch. For example:
      export default connectAdvanced((dispatch, options) => (state, props) => ({
      thing: state.things[props.thingId],
      saveThing: fields => dispatch(actionCreators.saveThing(props.thingId, fields)),
    }))(YourComponent)
    Access to dispatch is provided to the factory so selectorFactories can bind actionCreators
  outside of their selector as an optimization. Options passed to connectAdvanced are passed to
  the selectorFactory, along with displayName and WrappedComponent, as the second argument.
    Note that selectorFactory is responsible for all caching/memoization of inbound and outbound
  props. Do not use connectAdvanced directly without memoizing results between calls to your
  selector, otherwise the Connect component will re-render on every state or props change.
*/ selectorFactory, _ref) {
    if (_ref === void 0) _ref = {};
    var _ref2 = _ref, _ref2$getDisplayName = _ref2.getDisplayName, getDisplayName = _ref2$getDisplayName === void 0 ? function(name) {
        return "ConnectAdvanced(" + name + ")";
    } : _ref2$getDisplayName, _ref2$methodName = _ref2.methodName, methodName = _ref2$methodName === void 0 ? "connectAdvanced" : _ref2$methodName, _ref2$renderCountProp = _ref2.renderCountProp, renderCountProp = _ref2$renderCountProp === void 0 ? undefined : _ref2$renderCountProp, _ref2$shouldHandleSta = _ref2.shouldHandleStateChanges, shouldHandleStateChanges = _ref2$shouldHandleSta === void 0 ? true : _ref2$shouldHandleSta, _ref2$storeKey = _ref2.storeKey, storeKey = _ref2$storeKey === void 0 ? "store" : _ref2$storeKey, _ref2$withRef = _ref2.withRef, withRef = _ref2$withRef === void 0 ? false : _ref2$withRef, _ref2$forwardRef = _ref2.forwardRef, forwardRef = _ref2$forwardRef === void 0 ? false : _ref2$forwardRef, _ref2$context = _ref2.context, context = _ref2$context === void 0 ? (0, $lQ6Kh.ReactReduxContext) : _ref2$context, connectOptions = (0, $akilq.default)(_ref2, $6c740f0534287cd1$var$_excluded);
    var customStoreWarningMessage;
    var Context = context;
    return function wrapWithConnect(WrappedComponent) {
        var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || "Component";
        var displayName = getDisplayName(wrappedComponentName);
        var selectorFactoryOptions = (0, $aO5a1.default)({}, connectOptions, {
            getDisplayName: getDisplayName,
            methodName: methodName,
            renderCountProp: renderCountProp,
            shouldHandleStateChanges: shouldHandleStateChanges,
            storeKey: storeKey,
            displayName: displayName,
            wrappedComponentName: wrappedComponentName,
            WrappedComponent: WrappedComponent
        });
        var pure = connectOptions.pure;
        function createChildSelector(store) {
            return selectorFactory(store.dispatch, selectorFactoryOptions);
        } // If we aren't running in "pure" mode, we don't want to memoize values.
        // To avoid conditionally calling hooks, we fall back to a tiny wrapper
        // that just executes the given callback immediately.
        var usePureOnlyMemo = pure ? (0, $eO7Kz.useMemo) : function(callback) {
            return callback();
        };
        function ConnectFunction(props) {
            var _useMemo = (0, $eO7Kz.useMemo)(function() {
                // Distinguish between actual "data" props that were passed to the wrapper component,
                // and values needed to control behavior (forwarded refs, alternate context instances).
                // To maintain the wrapperProps object reference, memoize this destructuring.
                var reactReduxForwardedRef = props.reactReduxForwardedRef, wrapperProps = (0, $akilq.default)(props, $6c740f0534287cd1$var$_excluded2);
                return [
                    props.context,
                    reactReduxForwardedRef,
                    wrapperProps
                ];
            }, [
                props
            ]), propsContext = _useMemo[0], reactReduxForwardedRef = _useMemo[1], wrapperProps = _useMemo[2];
            var ContextToUse = (0, $eO7Kz.useMemo)(function() {
                // Users may optionally pass in a custom context instance to use instead of our ReactReduxContext.
                // Memoize the check that determines which context instance we should use.
                return propsContext && propsContext.Consumer && (0, $aZLSG.isContextConsumer)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eO7Kz))).createElement(propsContext.Consumer, null)) ? propsContext : Context;
            }, [
                propsContext,
                Context
            ]); // Retrieve the store and ancestor subscription via context, if available
            var contextValue = (0, $eO7Kz.useContext)(ContextToUse); // The store _must_ exist as either a prop or in context.
            // We'll check to see if it _looks_ like a Redux store first.
            // This allows us to pass through a `store` prop that is just a plain value.
            var didStoreComeFromProps = Boolean(props.store) && Boolean(props.store.getState) && Boolean(props.store.dispatch);
            var didStoreComeFromContext = Boolean(contextValue) && Boolean(contextValue.store);
            var store = didStoreComeFromProps ? props.store : contextValue.store;
            var childPropsSelector = (0, $eO7Kz.useMemo)(function() {
                // The child props selector needs the store reference as an input.
                // Re-create this selector whenever the store changes.
                return createChildSelector(store);
            }, [
                store
            ]);
            var _useMemo2 = (0, $eO7Kz.useMemo)(function() {
                if (!shouldHandleStateChanges) return $6c740f0534287cd1$var$NO_SUBSCRIPTION_ARRAY; // This Subscription's source should match where store came from: props vs. context. A component
                // connected to the store via props shouldn't use subscription from context, or vice versa.
                // This Subscription's source should match where store came from: props vs. context. A component
                // connected to the store via props shouldn't use subscription from context, or vice versa.
                var subscription = (0, $aGRlO.createSubscription)(store, didStoreComeFromProps ? null : contextValue.subscription); // `notifyNestedSubs` is duplicated to handle the case where the component is unmounted in
                // the middle of the notification loop, where `subscription` will then be null. This can
                // probably be avoided if Subscription's listeners logic is changed to not call listeners
                // that have been unsubscribed in the  middle of the notification loop.
                // `notifyNestedSubs` is duplicated to handle the case where the component is unmounted in
                // the middle of the notification loop, where `subscription` will then be null. This can
                // probably be avoided if Subscription's listeners logic is changed to not call listeners
                // that have been unsubscribed in the  middle of the notification loop.
                var notifyNestedSubs = subscription.notifyNestedSubs.bind(subscription);
                return [
                    subscription,
                    notifyNestedSubs
                ];
            }, [
                store,
                didStoreComeFromProps,
                contextValue
            ]), subscription = _useMemo2[0], notifyNestedSubs = _useMemo2[1]; // Determine what {store, subscription} value should be put into nested context, if necessary,
            // and memoize that value to avoid unnecessary context updates.
            var overriddenContextValue = (0, $eO7Kz.useMemo)(function() {
                if (didStoreComeFromProps) // This component is directly subscribed to a store from props.
                // We don't want descendants reading from this store - pass down whatever
                // the existing context value is from the nearest connected ancestor.
                return contextValue;
                 // Otherwise, put this component's subscription instance into context, so that
                // connected descendants won't update until after this component is done
                return (0, $aO5a1.default)({}, contextValue, {
                    subscription: subscription
                });
            }, [
                didStoreComeFromProps,
                contextValue,
                subscription
            ]); // We need to force this wrapper component to re-render whenever a Redux store update
            // causes a change to the calculated child component props (or we caught an error in mapState)
            var _useReducer = (0, $eO7Kz.useReducer)($6c740f0534287cd1$var$storeStateUpdatesReducer, $6c740f0534287cd1$var$EMPTY_ARRAY, $6c740f0534287cd1$var$initStateUpdates), _useReducer$ = _useReducer[0], previousStateUpdateResult = _useReducer$[0], forceComponentUpdateDispatch = _useReducer[1]; // Propagate any mapState/mapDispatch errors upwards
            if (previousStateUpdateResult && previousStateUpdateResult.error) throw previousStateUpdateResult.error;
             // Set up refs to coordinate values between the subscription effect and the render logic
            var lastChildProps = (0, $eO7Kz.useRef)();
            var lastWrapperProps = (0, $eO7Kz.useRef)(wrapperProps);
            var childPropsFromStoreUpdate = (0, $eO7Kz.useRef)();
            var renderIsScheduled = (0, $eO7Kz.useRef)(false);
            var actualChildProps = usePureOnlyMemo(function() {
                // Tricky logic here:
                // - This render may have been triggered by a Redux store update that produced new child props
                // - However, we may have gotten new wrapper props after that
                // If we have new child props, and the same wrapper props, we know we should use the new child props as-is.
                // But, if we have new wrapper props, those might change the child props, so we have to recalculate things.
                // So, we'll use the child props from store update only if the wrapper props are the same as last time.
                if (childPropsFromStoreUpdate.current && wrapperProps === lastWrapperProps.current) return childPropsFromStoreUpdate.current;
                 // TODO We're reading the store directly in render() here. Bad idea?
                // This will likely cause Bad Things (TM) to happen in Concurrent Mode.
                // Note that we do this because on renders _not_ caused by store updates, we need the latest store state
                // to determine what the child props should be.
                return childPropsSelector(store.getState(), wrapperProps);
            }, [
                store,
                previousStateUpdateResult,
                wrapperProps
            ]); // We need this to execute synchronously every time we re-render. However, React warns
            // about useLayoutEffect in SSR, so we try to detect environment and fall back to
            // just useEffect instead to avoid the warning, since neither will run anyway.
            $6c740f0534287cd1$var$useIsomorphicLayoutEffectWithArgs($6c740f0534287cd1$var$captureWrapperProps, [
                lastWrapperProps,
                lastChildProps,
                renderIsScheduled,
                wrapperProps,
                actualChildProps,
                childPropsFromStoreUpdate,
                notifyNestedSubs
            ]); // Our re-subscribe logic only runs when the store/subscription setup changes
            $6c740f0534287cd1$var$useIsomorphicLayoutEffectWithArgs($6c740f0534287cd1$var$subscribeUpdates, [
                shouldHandleStateChanges,
                store,
                subscription,
                childPropsSelector,
                lastWrapperProps,
                lastChildProps,
                renderIsScheduled,
                childPropsFromStoreUpdate,
                notifyNestedSubs,
                forceComponentUpdateDispatch
            ], [
                store,
                subscription,
                childPropsSelector
            ]); // Now that all that's done, we can finally try to actually render the child component.
            // We memoize the elements for the rendered child component as an optimization.
            var renderedWrappedComponent = (0, $eO7Kz.useMemo)(function() {
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eO7Kz))).createElement(WrappedComponent, (0, $aO5a1.default)({}, actualChildProps, {
                    ref: reactReduxForwardedRef
                }));
            }, [
                reactReduxForwardedRef,
                WrappedComponent,
                actualChildProps
            ]); // If React sees the exact same element reference as last time, it bails out of re-rendering
            // that child, same as if it was wrapped in React.memo() or returned false from shouldComponentUpdate.
            var renderedChild = (0, $eO7Kz.useMemo)(function() {
                if (shouldHandleStateChanges) // If this component is subscribed to store updates, we need to pass its own
                // subscription instance down to our descendants. That means rendering the same
                // Context instance, and putting a different value into the context.
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eO7Kz))).createElement(ContextToUse.Provider, {
                    value: overriddenContextValue
                }, renderedWrappedComponent);
                return renderedWrappedComponent;
            }, [
                ContextToUse,
                renderedWrappedComponent,
                overriddenContextValue
            ]);
            return renderedChild;
        } // If we're in "pure" mode, ensure our wrapper component only re-renders when incoming props have changed.
        var Connect = pure ? (0, (/*@__PURE__*/$parcel$interopDefault($eO7Kz))).memo(ConnectFunction) : ConnectFunction;
        Connect.WrappedComponent = WrappedComponent;
        Connect.displayName = ConnectFunction.displayName = displayName;
        if (forwardRef) {
            var forwarded = (0, (/*@__PURE__*/$parcel$interopDefault($eO7Kz))).forwardRef(function forwardConnectRef(props, ref) {
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eO7Kz))).createElement(Connect, (0, $aO5a1.default)({}, props, {
                    reactReduxForwardedRef: ref
                }));
            });
            forwarded.displayName = displayName;
            forwarded.WrappedComponent = WrappedComponent;
            return (0, (/*@__PURE__*/$parcel$interopDefault($hKDRv)))(forwarded, WrappedComponent);
        }
        return (0, (/*@__PURE__*/$parcel$interopDefault($hKDRv)))(Connect, WrappedComponent);
    };
}

});
parcelRequire.register("hKDRv", function(module, exports) {
"use strict";

var $k6W7P = parcelRequire("k6W7P");
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var $cec5a74ebb45c8ca$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $cec5a74ebb45c8ca$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $cec5a74ebb45c8ca$var$FORWARD_REF_STATICS = {
    "$$typeof": true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $cec5a74ebb45c8ca$var$MEMO_STATICS = {
    "$$typeof": true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $cec5a74ebb45c8ca$var$TYPE_STATICS = {};
$cec5a74ebb45c8ca$var$TYPE_STATICS[$k6W7P.ForwardRef] = $cec5a74ebb45c8ca$var$FORWARD_REF_STATICS;
$cec5a74ebb45c8ca$var$TYPE_STATICS[$k6W7P.Memo] = $cec5a74ebb45c8ca$var$MEMO_STATICS;
function $cec5a74ebb45c8ca$var$getStatics(component) {
    // React v16.11 and below
    if ($k6W7P.isMemo(component)) return $cec5a74ebb45c8ca$var$MEMO_STATICS;
     // React v16.12 and above
    return $cec5a74ebb45c8ca$var$TYPE_STATICS[component["$$typeof"]] || $cec5a74ebb45c8ca$var$REACT_STATICS;
}
var $cec5a74ebb45c8ca$var$defineProperty = Object.defineProperty;
var $cec5a74ebb45c8ca$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $cec5a74ebb45c8ca$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $cec5a74ebb45c8ca$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $cec5a74ebb45c8ca$var$getPrototypeOf = Object.getPrototypeOf;
var $cec5a74ebb45c8ca$var$objectPrototype = Object.prototype;
function $cec5a74ebb45c8ca$var$hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== "string") {
        // don't hoist over string (html) components
        if ($cec5a74ebb45c8ca$var$objectPrototype) {
            var inheritedComponent = $cec5a74ebb45c8ca$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $cec5a74ebb45c8ca$var$objectPrototype) $cec5a74ebb45c8ca$var$hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = $cec5a74ebb45c8ca$var$getOwnPropertyNames(sourceComponent);
        if ($cec5a74ebb45c8ca$var$getOwnPropertySymbols) keys = keys.concat($cec5a74ebb45c8ca$var$getOwnPropertySymbols(sourceComponent));
        var targetStatics = $cec5a74ebb45c8ca$var$getStatics(targetComponent);
        var sourceStatics = $cec5a74ebb45c8ca$var$getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!$cec5a74ebb45c8ca$var$KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = $cec5a74ebb45c8ca$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    $cec5a74ebb45c8ca$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
module.exports = $cec5a74ebb45c8ca$var$hoistNonReactStatics;

});
parcelRequire.register("k6W7P", function(module, exports) {
"use strict";

module.exports = (parcelRequire("fdsEQ"));

});
parcelRequire.register("fdsEQ", function(module, exports) {

$parcel$export(module.exports, "AsyncMode", () => $b13e4cba58762fc5$export$2b8d127b894957b9, (v) => $b13e4cba58762fc5$export$2b8d127b894957b9 = v);
$parcel$export(module.exports, "ConcurrentMode", () => $b13e4cba58762fc5$export$cea3a54a6425200c, (v) => $b13e4cba58762fc5$export$cea3a54a6425200c = v);
$parcel$export(module.exports, "ContextConsumer", () => $b13e4cba58762fc5$export$a7c73072b1a182ae, (v) => $b13e4cba58762fc5$export$a7c73072b1a182ae = v);
$parcel$export(module.exports, "ContextProvider", () => $b13e4cba58762fc5$export$9f27bc3417b4524d, (v) => $b13e4cba58762fc5$export$9f27bc3417b4524d = v);
$parcel$export(module.exports, "Element", () => $b13e4cba58762fc5$export$db77ccec0bb4ccac, (v) => $b13e4cba58762fc5$export$db77ccec0bb4ccac = v);
$parcel$export(module.exports, "ForwardRef", () => $b13e4cba58762fc5$export$8392c0c9d3dcbd35, (v) => $b13e4cba58762fc5$export$8392c0c9d3dcbd35 = v);
$parcel$export(module.exports, "Fragment", () => $b13e4cba58762fc5$export$ffb0004e005737fa, (v) => $b13e4cba58762fc5$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Lazy", () => $b13e4cba58762fc5$export$b624eff549462981, (v) => $b13e4cba58762fc5$export$b624eff549462981 = v);
$parcel$export(module.exports, "Memo", () => $b13e4cba58762fc5$export$7897aa7841a5380c, (v) => $b13e4cba58762fc5$export$7897aa7841a5380c = v);
$parcel$export(module.exports, "Portal", () => $b13e4cba58762fc5$export$602eac185826482c, (v) => $b13e4cba58762fc5$export$602eac185826482c = v);
$parcel$export(module.exports, "Profiler", () => $b13e4cba58762fc5$export$e2c29f18771995cb, (v) => $b13e4cba58762fc5$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "StrictMode", () => $b13e4cba58762fc5$export$5f8d39834fd61797, (v) => $b13e4cba58762fc5$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $b13e4cba58762fc5$export$74bf444e3cd11ea5, (v) => $b13e4cba58762fc5$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "isAsyncMode", () => $b13e4cba58762fc5$export$92387174baf9b227, (v) => $b13e4cba58762fc5$export$92387174baf9b227 = v);
$parcel$export(module.exports, "isConcurrentMode", () => $b13e4cba58762fc5$export$ec112efeb987d9c6, (v) => $b13e4cba58762fc5$export$ec112efeb987d9c6 = v);
$parcel$export(module.exports, "isContextConsumer", () => $b13e4cba58762fc5$export$b706b080d889d2c9, (v) => $b13e4cba58762fc5$export$b706b080d889d2c9 = v);
$parcel$export(module.exports, "isContextProvider", () => $b13e4cba58762fc5$export$5be5a87408f70ddc, (v) => $b13e4cba58762fc5$export$5be5a87408f70ddc = v);
$parcel$export(module.exports, "isElement", () => $b13e4cba58762fc5$export$45a5e7f76e0caa8d, (v) => $b13e4cba58762fc5$export$45a5e7f76e0caa8d = v);
$parcel$export(module.exports, "isForwardRef", () => $b13e4cba58762fc5$export$455c2e768291efa6, (v) => $b13e4cba58762fc5$export$455c2e768291efa6 = v);
$parcel$export(module.exports, "isFragment", () => $b13e4cba58762fc5$export$9522e17588c12572, (v) => $b13e4cba58762fc5$export$9522e17588c12572 = v);
$parcel$export(module.exports, "isLazy", () => $b13e4cba58762fc5$export$2110ac352bb060b9, (v) => $b13e4cba58762fc5$export$2110ac352bb060b9 = v);
$parcel$export(module.exports, "isMemo", () => $b13e4cba58762fc5$export$56885ab8b9c456ab, (v) => $b13e4cba58762fc5$export$56885ab8b9c456ab = v);
$parcel$export(module.exports, "isPortal", () => $b13e4cba58762fc5$export$d927fcb6adf8f9de, (v) => $b13e4cba58762fc5$export$d927fcb6adf8f9de = v);
$parcel$export(module.exports, "isProfiler", () => $b13e4cba58762fc5$export$b82d16f27459e05a, (v) => $b13e4cba58762fc5$export$b82d16f27459e05a = v);
$parcel$export(module.exports, "isStrictMode", () => $b13e4cba58762fc5$export$522c17b4f5e123e8, (v) => $b13e4cba58762fc5$export$522c17b4f5e123e8 = v);
$parcel$export(module.exports, "isSuspense", () => $b13e4cba58762fc5$export$1aabd8a0274ecfd6, (v) => $b13e4cba58762fc5$export$1aabd8a0274ecfd6 = v);
$parcel$export(module.exports, "isValidElementType", () => $b13e4cba58762fc5$export$9b621391a187a31a, (v) => $b13e4cba58762fc5$export$9b621391a187a31a = v);
$parcel$export(module.exports, "typeOf", () => $b13e4cba58762fc5$export$f5bbd400c2f4426f, (v) => $b13e4cba58762fc5$export$f5bbd400c2f4426f = v);
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $b13e4cba58762fc5$export$2b8d127b894957b9;
var $b13e4cba58762fc5$export$cea3a54a6425200c;
var $b13e4cba58762fc5$export$a7c73072b1a182ae;
var $b13e4cba58762fc5$export$9f27bc3417b4524d;
var $b13e4cba58762fc5$export$db77ccec0bb4ccac;
var $b13e4cba58762fc5$export$8392c0c9d3dcbd35;
var $b13e4cba58762fc5$export$ffb0004e005737fa;
var $b13e4cba58762fc5$export$b624eff549462981;
var $b13e4cba58762fc5$export$7897aa7841a5380c;
var $b13e4cba58762fc5$export$602eac185826482c;
var $b13e4cba58762fc5$export$e2c29f18771995cb;
var $b13e4cba58762fc5$export$5f8d39834fd61797;
var $b13e4cba58762fc5$export$74bf444e3cd11ea5;
var $b13e4cba58762fc5$export$92387174baf9b227;
var $b13e4cba58762fc5$export$ec112efeb987d9c6;
var $b13e4cba58762fc5$export$b706b080d889d2c9;
var $b13e4cba58762fc5$export$5be5a87408f70ddc;
var $b13e4cba58762fc5$export$45a5e7f76e0caa8d;
var $b13e4cba58762fc5$export$455c2e768291efa6;
var $b13e4cba58762fc5$export$9522e17588c12572;
var $b13e4cba58762fc5$export$2110ac352bb060b9;
var $b13e4cba58762fc5$export$56885ab8b9c456ab;
var $b13e4cba58762fc5$export$d927fcb6adf8f9de;
var $b13e4cba58762fc5$export$b82d16f27459e05a;
var $b13e4cba58762fc5$export$522c17b4f5e123e8;
var $b13e4cba58762fc5$export$1aabd8a0274ecfd6;
var $b13e4cba58762fc5$export$9b621391a187a31a;
var $b13e4cba58762fc5$export$f5bbd400c2f4426f;
"use strict";
var $b13e4cba58762fc5$var$b = "function" === typeof Symbol && Symbol.for, $b13e4cba58762fc5$var$c = $b13e4cba58762fc5$var$b ? Symbol.for("react.element") : 60103, $b13e4cba58762fc5$var$d = $b13e4cba58762fc5$var$b ? Symbol.for("react.portal") : 60106, $b13e4cba58762fc5$var$e = $b13e4cba58762fc5$var$b ? Symbol.for("react.fragment") : 60107, $b13e4cba58762fc5$var$f = $b13e4cba58762fc5$var$b ? Symbol.for("react.strict_mode") : 60108, $b13e4cba58762fc5$var$g = $b13e4cba58762fc5$var$b ? Symbol.for("react.profiler") : 60114, $b13e4cba58762fc5$var$h = $b13e4cba58762fc5$var$b ? Symbol.for("react.provider") : 60109, $b13e4cba58762fc5$var$k = $b13e4cba58762fc5$var$b ? Symbol.for("react.context") : 60110, $b13e4cba58762fc5$var$l = $b13e4cba58762fc5$var$b ? Symbol.for("react.async_mode") : 60111, $b13e4cba58762fc5$var$m = $b13e4cba58762fc5$var$b ? Symbol.for("react.concurrent_mode") : 60111, $b13e4cba58762fc5$var$n = $b13e4cba58762fc5$var$b ? Symbol.for("react.forward_ref") : 60112, $b13e4cba58762fc5$var$p = $b13e4cba58762fc5$var$b ? Symbol.for("react.suspense") : 60113, $b13e4cba58762fc5$var$q = $b13e4cba58762fc5$var$b ? Symbol.for("react.suspense_list") : 60120, $b13e4cba58762fc5$var$r = $b13e4cba58762fc5$var$b ? Symbol.for("react.memo") : 60115, $b13e4cba58762fc5$var$t = $b13e4cba58762fc5$var$b ? Symbol.for("react.lazy") : 60116, $b13e4cba58762fc5$var$v = $b13e4cba58762fc5$var$b ? Symbol.for("react.block") : 60121, $b13e4cba58762fc5$var$w = $b13e4cba58762fc5$var$b ? Symbol.for("react.fundamental") : 60117, $b13e4cba58762fc5$var$x = $b13e4cba58762fc5$var$b ? Symbol.for("react.responder") : 60118, $b13e4cba58762fc5$var$y = $b13e4cba58762fc5$var$b ? Symbol.for("react.scope") : 60119;
function $b13e4cba58762fc5$var$z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case $b13e4cba58762fc5$var$c:
                switch(a = a.type, a){
                    case $b13e4cba58762fc5$var$l:
                    case $b13e4cba58762fc5$var$m:
                    case $b13e4cba58762fc5$var$e:
                    case $b13e4cba58762fc5$var$g:
                    case $b13e4cba58762fc5$var$f:
                    case $b13e4cba58762fc5$var$p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $b13e4cba58762fc5$var$k:
                            case $b13e4cba58762fc5$var$n:
                            case $b13e4cba58762fc5$var$t:
                            case $b13e4cba58762fc5$var$r:
                            case $b13e4cba58762fc5$var$h:
                                return a;
                            default:
                                return u;
                        }
                }
            case $b13e4cba58762fc5$var$d:
                return u;
        }
    }
}
function $b13e4cba58762fc5$var$A(a) {
    return $b13e4cba58762fc5$var$z(a) === $b13e4cba58762fc5$var$m;
}
$b13e4cba58762fc5$export$2b8d127b894957b9 = $b13e4cba58762fc5$var$l;
$b13e4cba58762fc5$export$cea3a54a6425200c = $b13e4cba58762fc5$var$m;
$b13e4cba58762fc5$export$a7c73072b1a182ae = $b13e4cba58762fc5$var$k;
$b13e4cba58762fc5$export$9f27bc3417b4524d = $b13e4cba58762fc5$var$h;
$b13e4cba58762fc5$export$db77ccec0bb4ccac = $b13e4cba58762fc5$var$c;
$b13e4cba58762fc5$export$8392c0c9d3dcbd35 = $b13e4cba58762fc5$var$n;
$b13e4cba58762fc5$export$ffb0004e005737fa = $b13e4cba58762fc5$var$e;
$b13e4cba58762fc5$export$b624eff549462981 = $b13e4cba58762fc5$var$t;
$b13e4cba58762fc5$export$7897aa7841a5380c = $b13e4cba58762fc5$var$r;
$b13e4cba58762fc5$export$602eac185826482c = $b13e4cba58762fc5$var$d;
$b13e4cba58762fc5$export$e2c29f18771995cb = $b13e4cba58762fc5$var$g;
$b13e4cba58762fc5$export$5f8d39834fd61797 = $b13e4cba58762fc5$var$f;
$b13e4cba58762fc5$export$74bf444e3cd11ea5 = $b13e4cba58762fc5$var$p;
$b13e4cba58762fc5$export$92387174baf9b227 = function(a) {
    return $b13e4cba58762fc5$var$A(a) || $b13e4cba58762fc5$var$z(a) === $b13e4cba58762fc5$var$l;
};
$b13e4cba58762fc5$export$ec112efeb987d9c6 = $b13e4cba58762fc5$var$A;
$b13e4cba58762fc5$export$b706b080d889d2c9 = function(a) {
    return $b13e4cba58762fc5$var$z(a) === $b13e4cba58762fc5$var$k;
};
$b13e4cba58762fc5$export$5be5a87408f70ddc = function(a) {
    return $b13e4cba58762fc5$var$z(a) === $b13e4cba58762fc5$var$h;
};
$b13e4cba58762fc5$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $b13e4cba58762fc5$var$c;
};
$b13e4cba58762fc5$export$455c2e768291efa6 = function(a) {
    return $b13e4cba58762fc5$var$z(a) === $b13e4cba58762fc5$var$n;
};
$b13e4cba58762fc5$export$9522e17588c12572 = function(a) {
    return $b13e4cba58762fc5$var$z(a) === $b13e4cba58762fc5$var$e;
};
$b13e4cba58762fc5$export$2110ac352bb060b9 = function(a) {
    return $b13e4cba58762fc5$var$z(a) === $b13e4cba58762fc5$var$t;
};
$b13e4cba58762fc5$export$56885ab8b9c456ab = function(a) {
    return $b13e4cba58762fc5$var$z(a) === $b13e4cba58762fc5$var$r;
};
$b13e4cba58762fc5$export$d927fcb6adf8f9de = function(a) {
    return $b13e4cba58762fc5$var$z(a) === $b13e4cba58762fc5$var$d;
};
$b13e4cba58762fc5$export$b82d16f27459e05a = function(a) {
    return $b13e4cba58762fc5$var$z(a) === $b13e4cba58762fc5$var$g;
};
$b13e4cba58762fc5$export$522c17b4f5e123e8 = function(a) {
    return $b13e4cba58762fc5$var$z(a) === $b13e4cba58762fc5$var$f;
};
$b13e4cba58762fc5$export$1aabd8a0274ecfd6 = function(a) {
    return $b13e4cba58762fc5$var$z(a) === $b13e4cba58762fc5$var$p;
};
$b13e4cba58762fc5$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $b13e4cba58762fc5$var$e || a === $b13e4cba58762fc5$var$m || a === $b13e4cba58762fc5$var$g || a === $b13e4cba58762fc5$var$f || a === $b13e4cba58762fc5$var$p || a === $b13e4cba58762fc5$var$q || "object" === typeof a && null !== a && (a.$$typeof === $b13e4cba58762fc5$var$t || a.$$typeof === $b13e4cba58762fc5$var$r || a.$$typeof === $b13e4cba58762fc5$var$h || a.$$typeof === $b13e4cba58762fc5$var$k || a.$$typeof === $b13e4cba58762fc5$var$n || a.$$typeof === $b13e4cba58762fc5$var$w || a.$$typeof === $b13e4cba58762fc5$var$x || a.$$typeof === $b13e4cba58762fc5$var$y || a.$$typeof === $b13e4cba58762fc5$var$v);
};
$b13e4cba58762fc5$export$f5bbd400c2f4426f = $b13e4cba58762fc5$var$z;

});



parcelRequire.register("aZLSG", function(module, exports) {
"use strict";

module.exports = (parcelRequire("4gvzI"));

});
parcelRequire.register("4gvzI", function(module, exports) {

$parcel$export(module.exports, "ContextConsumer", () => $31b126343219cc93$export$a7c73072b1a182ae, (v) => $31b126343219cc93$export$a7c73072b1a182ae = v);
$parcel$export(module.exports, "ContextProvider", () => $31b126343219cc93$export$9f27bc3417b4524d, (v) => $31b126343219cc93$export$9f27bc3417b4524d = v);
$parcel$export(module.exports, "Element", () => $31b126343219cc93$export$db77ccec0bb4ccac, (v) => $31b126343219cc93$export$db77ccec0bb4ccac = v);
$parcel$export(module.exports, "ForwardRef", () => $31b126343219cc93$export$8392c0c9d3dcbd35, (v) => $31b126343219cc93$export$8392c0c9d3dcbd35 = v);
$parcel$export(module.exports, "Fragment", () => $31b126343219cc93$export$ffb0004e005737fa, (v) => $31b126343219cc93$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Lazy", () => $31b126343219cc93$export$b624eff549462981, (v) => $31b126343219cc93$export$b624eff549462981 = v);
$parcel$export(module.exports, "Memo", () => $31b126343219cc93$export$7897aa7841a5380c, (v) => $31b126343219cc93$export$7897aa7841a5380c = v);
$parcel$export(module.exports, "Portal", () => $31b126343219cc93$export$602eac185826482c, (v) => $31b126343219cc93$export$602eac185826482c = v);
$parcel$export(module.exports, "Profiler", () => $31b126343219cc93$export$e2c29f18771995cb, (v) => $31b126343219cc93$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "StrictMode", () => $31b126343219cc93$export$5f8d39834fd61797, (v) => $31b126343219cc93$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $31b126343219cc93$export$74bf444e3cd11ea5, (v) => $31b126343219cc93$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "isAsyncMode", () => $31b126343219cc93$export$92387174baf9b227, (v) => $31b126343219cc93$export$92387174baf9b227 = v);
$parcel$export(module.exports, "isConcurrentMode", () => $31b126343219cc93$export$ec112efeb987d9c6, (v) => $31b126343219cc93$export$ec112efeb987d9c6 = v);
$parcel$export(module.exports, "isContextConsumer", () => $31b126343219cc93$export$b706b080d889d2c9, (v) => $31b126343219cc93$export$b706b080d889d2c9 = v);
$parcel$export(module.exports, "isContextProvider", () => $31b126343219cc93$export$5be5a87408f70ddc, (v) => $31b126343219cc93$export$5be5a87408f70ddc = v);
$parcel$export(module.exports, "isElement", () => $31b126343219cc93$export$45a5e7f76e0caa8d, (v) => $31b126343219cc93$export$45a5e7f76e0caa8d = v);
$parcel$export(module.exports, "isForwardRef", () => $31b126343219cc93$export$455c2e768291efa6, (v) => $31b126343219cc93$export$455c2e768291efa6 = v);
$parcel$export(module.exports, "isFragment", () => $31b126343219cc93$export$9522e17588c12572, (v) => $31b126343219cc93$export$9522e17588c12572 = v);
$parcel$export(module.exports, "isLazy", () => $31b126343219cc93$export$2110ac352bb060b9, (v) => $31b126343219cc93$export$2110ac352bb060b9 = v);
$parcel$export(module.exports, "isMemo", () => $31b126343219cc93$export$56885ab8b9c456ab, (v) => $31b126343219cc93$export$56885ab8b9c456ab = v);
$parcel$export(module.exports, "isPortal", () => $31b126343219cc93$export$d927fcb6adf8f9de, (v) => $31b126343219cc93$export$d927fcb6adf8f9de = v);
$parcel$export(module.exports, "isProfiler", () => $31b126343219cc93$export$b82d16f27459e05a, (v) => $31b126343219cc93$export$b82d16f27459e05a = v);
$parcel$export(module.exports, "isStrictMode", () => $31b126343219cc93$export$522c17b4f5e123e8, (v) => $31b126343219cc93$export$522c17b4f5e123e8 = v);
$parcel$export(module.exports, "isSuspense", () => $31b126343219cc93$export$1aabd8a0274ecfd6, (v) => $31b126343219cc93$export$1aabd8a0274ecfd6 = v);
$parcel$export(module.exports, "isValidElementType", () => $31b126343219cc93$export$9b621391a187a31a, (v) => $31b126343219cc93$export$9b621391a187a31a = v);
$parcel$export(module.exports, "typeOf", () => $31b126343219cc93$export$f5bbd400c2f4426f, (v) => $31b126343219cc93$export$f5bbd400c2f4426f = v);
/** @license React v17.0.2
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $31b126343219cc93$export$a7c73072b1a182ae;
var $31b126343219cc93$export$9f27bc3417b4524d;
var $31b126343219cc93$export$db77ccec0bb4ccac;
var $31b126343219cc93$export$8392c0c9d3dcbd35;
var $31b126343219cc93$export$ffb0004e005737fa;
var $31b126343219cc93$export$b624eff549462981;
var $31b126343219cc93$export$7897aa7841a5380c;
var $31b126343219cc93$export$602eac185826482c;
var $31b126343219cc93$export$e2c29f18771995cb;
var $31b126343219cc93$export$5f8d39834fd61797;
var $31b126343219cc93$export$74bf444e3cd11ea5;
var $31b126343219cc93$export$92387174baf9b227;
var $31b126343219cc93$export$ec112efeb987d9c6;
var $31b126343219cc93$export$b706b080d889d2c9;
var $31b126343219cc93$export$5be5a87408f70ddc;
var $31b126343219cc93$export$45a5e7f76e0caa8d;
var $31b126343219cc93$export$455c2e768291efa6;
var $31b126343219cc93$export$9522e17588c12572;
var $31b126343219cc93$export$2110ac352bb060b9;
var $31b126343219cc93$export$56885ab8b9c456ab;
var $31b126343219cc93$export$d927fcb6adf8f9de;
var $31b126343219cc93$export$b82d16f27459e05a;
var $31b126343219cc93$export$522c17b4f5e123e8;
var $31b126343219cc93$export$1aabd8a0274ecfd6;
var $31b126343219cc93$export$9b621391a187a31a;
var $31b126343219cc93$export$f5bbd400c2f4426f;
"use strict";
var $31b126343219cc93$var$b = 60103, $31b126343219cc93$var$c = 60106, $31b126343219cc93$var$d = 60107, $31b126343219cc93$var$e = 60108, $31b126343219cc93$var$f = 60114, $31b126343219cc93$var$g = 60109, $31b126343219cc93$var$h = 60110, $31b126343219cc93$var$k = 60112, $31b126343219cc93$var$l = 60113, $31b126343219cc93$var$m = 60120, $31b126343219cc93$var$n = 60115, $31b126343219cc93$var$p = 60116, $31b126343219cc93$var$q = 60121, $31b126343219cc93$var$r = 60122, $31b126343219cc93$var$u = 60117, $31b126343219cc93$var$v = 60129, $31b126343219cc93$var$w = 60131;
if ("function" === typeof Symbol && Symbol.for) {
    var $31b126343219cc93$var$x = Symbol.for;
    $31b126343219cc93$var$b = $31b126343219cc93$var$x("react.element");
    $31b126343219cc93$var$c = $31b126343219cc93$var$x("react.portal");
    $31b126343219cc93$var$d = $31b126343219cc93$var$x("react.fragment");
    $31b126343219cc93$var$e = $31b126343219cc93$var$x("react.strict_mode");
    $31b126343219cc93$var$f = $31b126343219cc93$var$x("react.profiler");
    $31b126343219cc93$var$g = $31b126343219cc93$var$x("react.provider");
    $31b126343219cc93$var$h = $31b126343219cc93$var$x("react.context");
    $31b126343219cc93$var$k = $31b126343219cc93$var$x("react.forward_ref");
    $31b126343219cc93$var$l = $31b126343219cc93$var$x("react.suspense");
    $31b126343219cc93$var$m = $31b126343219cc93$var$x("react.suspense_list");
    $31b126343219cc93$var$n = $31b126343219cc93$var$x("react.memo");
    $31b126343219cc93$var$p = $31b126343219cc93$var$x("react.lazy");
    $31b126343219cc93$var$q = $31b126343219cc93$var$x("react.block");
    $31b126343219cc93$var$r = $31b126343219cc93$var$x("react.server.block");
    $31b126343219cc93$var$u = $31b126343219cc93$var$x("react.fundamental");
    $31b126343219cc93$var$v = $31b126343219cc93$var$x("react.debug_trace_mode");
    $31b126343219cc93$var$w = $31b126343219cc93$var$x("react.legacy_hidden");
}
function $31b126343219cc93$var$y(a) {
    if ("object" === typeof a && null !== a) {
        var t = a.$$typeof;
        switch(t){
            case $31b126343219cc93$var$b:
                switch(a = a.type, a){
                    case $31b126343219cc93$var$d:
                    case $31b126343219cc93$var$f:
                    case $31b126343219cc93$var$e:
                    case $31b126343219cc93$var$l:
                    case $31b126343219cc93$var$m:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $31b126343219cc93$var$h:
                            case $31b126343219cc93$var$k:
                            case $31b126343219cc93$var$p:
                            case $31b126343219cc93$var$n:
                            case $31b126343219cc93$var$g:
                                return a;
                            default:
                                return t;
                        }
                }
            case $31b126343219cc93$var$c:
                return t;
        }
    }
}
var $31b126343219cc93$var$z = $31b126343219cc93$var$g, $31b126343219cc93$var$A = $31b126343219cc93$var$b, $31b126343219cc93$var$B = $31b126343219cc93$var$k, $31b126343219cc93$var$C = $31b126343219cc93$var$d, $31b126343219cc93$var$D = $31b126343219cc93$var$p, $31b126343219cc93$var$E = $31b126343219cc93$var$n, $31b126343219cc93$var$F = $31b126343219cc93$var$c, $31b126343219cc93$var$G = $31b126343219cc93$var$f, $31b126343219cc93$var$H = $31b126343219cc93$var$e, $31b126343219cc93$var$I = $31b126343219cc93$var$l;
$31b126343219cc93$export$a7c73072b1a182ae = $31b126343219cc93$var$h;
$31b126343219cc93$export$9f27bc3417b4524d = $31b126343219cc93$var$z;
$31b126343219cc93$export$db77ccec0bb4ccac = $31b126343219cc93$var$A;
$31b126343219cc93$export$8392c0c9d3dcbd35 = $31b126343219cc93$var$B;
$31b126343219cc93$export$ffb0004e005737fa = $31b126343219cc93$var$C;
$31b126343219cc93$export$b624eff549462981 = $31b126343219cc93$var$D;
$31b126343219cc93$export$7897aa7841a5380c = $31b126343219cc93$var$E;
$31b126343219cc93$export$602eac185826482c = $31b126343219cc93$var$F;
$31b126343219cc93$export$e2c29f18771995cb = $31b126343219cc93$var$G;
$31b126343219cc93$export$5f8d39834fd61797 = $31b126343219cc93$var$H;
$31b126343219cc93$export$74bf444e3cd11ea5 = $31b126343219cc93$var$I;
$31b126343219cc93$export$92387174baf9b227 = function() {
    return !1;
};
$31b126343219cc93$export$ec112efeb987d9c6 = function() {
    return !1;
};
$31b126343219cc93$export$b706b080d889d2c9 = function(a) {
    return $31b126343219cc93$var$y(a) === $31b126343219cc93$var$h;
};
$31b126343219cc93$export$5be5a87408f70ddc = function(a) {
    return $31b126343219cc93$var$y(a) === $31b126343219cc93$var$g;
};
$31b126343219cc93$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $31b126343219cc93$var$b;
};
$31b126343219cc93$export$455c2e768291efa6 = function(a) {
    return $31b126343219cc93$var$y(a) === $31b126343219cc93$var$k;
};
$31b126343219cc93$export$9522e17588c12572 = function(a) {
    return $31b126343219cc93$var$y(a) === $31b126343219cc93$var$d;
};
$31b126343219cc93$export$2110ac352bb060b9 = function(a) {
    return $31b126343219cc93$var$y(a) === $31b126343219cc93$var$p;
};
$31b126343219cc93$export$56885ab8b9c456ab = function(a) {
    return $31b126343219cc93$var$y(a) === $31b126343219cc93$var$n;
};
$31b126343219cc93$export$d927fcb6adf8f9de = function(a) {
    return $31b126343219cc93$var$y(a) === $31b126343219cc93$var$c;
};
$31b126343219cc93$export$b82d16f27459e05a = function(a) {
    return $31b126343219cc93$var$y(a) === $31b126343219cc93$var$f;
};
$31b126343219cc93$export$522c17b4f5e123e8 = function(a) {
    return $31b126343219cc93$var$y(a) === $31b126343219cc93$var$e;
};
$31b126343219cc93$export$1aabd8a0274ecfd6 = function(a) {
    return $31b126343219cc93$var$y(a) === $31b126343219cc93$var$l;
};
$31b126343219cc93$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $31b126343219cc93$var$d || a === $31b126343219cc93$var$f || a === $31b126343219cc93$var$v || a === $31b126343219cc93$var$e || a === $31b126343219cc93$var$l || a === $31b126343219cc93$var$m || a === $31b126343219cc93$var$w || "object" === typeof a && null !== a && (a.$$typeof === $31b126343219cc93$var$p || a.$$typeof === $31b126343219cc93$var$n || a.$$typeof === $31b126343219cc93$var$g || a.$$typeof === $31b126343219cc93$var$h || a.$$typeof === $31b126343219cc93$var$k || a.$$typeof === $31b126343219cc93$var$u || a.$$typeof === $31b126343219cc93$var$q || a[0] === $31b126343219cc93$var$r) ? !0 : !1;
};
$31b126343219cc93$export$f5bbd400c2f4426f = $31b126343219cc93$var$y;

});



parcelRequire.register("4wTzX", function(module, exports) {

var $aO5a1 = parcelRequire("aO5a1");

var $akilq = parcelRequire("akilq");

var $9jigF = parcelRequire("9jigF");

var $bMzGX = parcelRequire("bMzGX");

var $bKF8l = parcelRequire("bKF8l");

var $2qlVA = parcelRequire("2qlVA");

var $877DX = parcelRequire("877DX");

var $8WHQT = parcelRequire("8WHQT");
var $34c5436dce7cb4c2$var$_excluded = [
    "pure",
    "areStatesEqual",
    "areOwnPropsEqual",
    "areStatePropsEqual",
    "areMergedPropsEqual"
];
/*
  connect is a facade over connectAdvanced. It turns its args into a compatible
  selectorFactory, which has the signature:

    (dispatch, options) => (nextState, nextOwnProps) => nextFinalProps
  
  connect passes its args to connectAdvanced as options, which will in turn pass them to
  selectorFactory each time a Connect component instance is instantiated or hot reloaded.

  selectorFactory returns a final props selector from its mapStateToProps,
  mapStateToPropsFactories, mapDispatchToProps, mapDispatchToPropsFactories, mergeProps,
  mergePropsFactories, and pure args.

  The resulting final props selector is called by the Connect component instance whenever
  it receives new props or store state.
 */ function $34c5436dce7cb4c2$var$match(arg, factories, name) {
    for(var i = factories.length - 1; i >= 0; i--){
        var result = factories[i](arg);
        if (result) return result;
    }
    return function(dispatch, options) {
        throw new Error("Invalid value of type " + typeof arg + " for " + name + " argument when connecting component " + options.wrappedComponentName + ".");
    };
}
function $34c5436dce7cb4c2$var$strictEqual(a, b) {
    return a === b;
} // createConnect with default args builds the 'official' connect behavior. Calling it with
function $34c5436dce7cb4c2$export$9f9feb656dec1fc4(_temp) {
    var _ref = _temp === void 0 ? {} : _temp, _ref$connectHOC = _ref.connectHOC, connectHOC = _ref$connectHOC === void 0 ? (0, $9jigF.default) : _ref$connectHOC, _ref$mapStateToPropsF = _ref.mapStateToPropsFactories, mapStateToPropsFactories = _ref$mapStateToPropsF === void 0 ? (0, $2qlVA.default) : _ref$mapStateToPropsF, _ref$mapDispatchToPro = _ref.mapDispatchToPropsFactories, mapDispatchToPropsFactories = _ref$mapDispatchToPro === void 0 ? (0, $bKF8l.default) : _ref$mapDispatchToPro, _ref$mergePropsFactor = _ref.mergePropsFactories, mergePropsFactories = _ref$mergePropsFactor === void 0 ? (0, $877DX.default) : _ref$mergePropsFactor, _ref$selectorFactory = _ref.selectorFactory, selectorFactory = _ref$selectorFactory === void 0 ? (0, $8WHQT.default) : _ref$selectorFactory;
    return function connect(mapStateToProps, mapDispatchToProps, mergeProps, _ref2) {
        if (_ref2 === void 0) _ref2 = {};
        var _ref3 = _ref2, _ref3$pure = _ref3.pure, pure = _ref3$pure === void 0 ? true : _ref3$pure, _ref3$areStatesEqual = _ref3.areStatesEqual, areStatesEqual = _ref3$areStatesEqual === void 0 ? $34c5436dce7cb4c2$var$strictEqual : _ref3$areStatesEqual, _ref3$areOwnPropsEqua = _ref3.areOwnPropsEqual, areOwnPropsEqual = _ref3$areOwnPropsEqua === void 0 ? (0, $bMzGX.default) : _ref3$areOwnPropsEqua, _ref3$areStatePropsEq = _ref3.areStatePropsEqual, areStatePropsEqual = _ref3$areStatePropsEq === void 0 ? (0, $bMzGX.default) : _ref3$areStatePropsEq, _ref3$areMergedPropsE = _ref3.areMergedPropsEqual, areMergedPropsEqual = _ref3$areMergedPropsE === void 0 ? (0, $bMzGX.default) : _ref3$areMergedPropsE, extraOptions = (0, $akilq.default)(_ref3, $34c5436dce7cb4c2$var$_excluded);
        var initMapStateToProps = $34c5436dce7cb4c2$var$match(mapStateToProps, mapStateToPropsFactories, "mapStateToProps");
        var initMapDispatchToProps = $34c5436dce7cb4c2$var$match(mapDispatchToProps, mapDispatchToPropsFactories, "mapDispatchToProps");
        var initMergeProps = $34c5436dce7cb4c2$var$match(mergeProps, mergePropsFactories, "mergeProps");
        return connectHOC(selectorFactory, (0, $aO5a1.default)({
            // used in error messages
            methodName: "connect",
            // used to compute Connect's displayName from the wrapped component's displayName.
            getDisplayName: function getDisplayName(name) {
                return "Connect(" + name + ")";
            },
            // if mapStateToProps is falsy, the Connect component doesn't subscribe to store state changes
            shouldHandleStateChanges: Boolean(mapStateToProps),
            // passed through to selectorFactory
            initMapStateToProps: initMapStateToProps,
            initMapDispatchToProps: initMapDispatchToProps,
            initMergeProps: initMergeProps,
            pure: pure,
            areStatesEqual: areStatesEqual,
            areOwnPropsEqual: areOwnPropsEqual,
            areStatePropsEqual: areStatePropsEqual,
            areMergedPropsEqual: areMergedPropsEqual
        }, extraOptions));
    };
}
var $34c5436dce7cb4c2$export$2e2bcd8739ae039 = /*#__PURE__*/ $34c5436dce7cb4c2$export$9f9feb656dec1fc4();

});
parcelRequire.register("bMzGX", function(module, exports) {

$parcel$export(module.exports, "default", () => $893fdd0b975c2006$export$2e2bcd8739ae039);
function $893fdd0b975c2006$var$is(x, y) {
    if (x === y) return x !== 0 || y !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
function $893fdd0b975c2006$export$2e2bcd8739ae039(objA, objB) {
    if ($893fdd0b975c2006$var$is(objA, objB)) return true;
    if (typeof objA !== "object" || objA === null || typeof objB !== "object" || objB === null) return false;
    var keysA = Object.keys(objA);
    var keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    for(var i = 0; i < keysA.length; i++){
        if (!Object.prototype.hasOwnProperty.call(objB, keysA[i]) || !$893fdd0b975c2006$var$is(objA[keysA[i]], objB[keysA[i]])) return false;
    }
    return true;
}

});

parcelRequire.register("bKF8l", function(module, exports) {

$parcel$export(module.exports, "default", () => $88e3e5d924c4524a$export$2e2bcd8739ae039);

var $iPehb = parcelRequire("iPehb");

var $9bkq0 = parcelRequire("9bkq0");
function $88e3e5d924c4524a$export$a9f27b4b187c1166(mapDispatchToProps) {
    return typeof mapDispatchToProps === "function" ? (0, $9bkq0.wrapMapToPropsFunc)(mapDispatchToProps, "mapDispatchToProps") : undefined;
}
function $88e3e5d924c4524a$export$ba20d1a7aa0c4a90(mapDispatchToProps) {
    return !mapDispatchToProps ? (0, $9bkq0.wrapMapToPropsConstant)(function(dispatch) {
        return {
            dispatch: dispatch
        };
    }) : undefined;
}
function $88e3e5d924c4524a$export$94a6e55709d4d961(mapDispatchToProps) {
    return mapDispatchToProps && typeof mapDispatchToProps === "object" ? (0, $9bkq0.wrapMapToPropsConstant)(function(dispatch) {
        return (0, $iPehb.default)(mapDispatchToProps, dispatch);
    }) : undefined;
}
var $88e3e5d924c4524a$export$2e2bcd8739ae039 = [
    $88e3e5d924c4524a$export$a9f27b4b187c1166,
    $88e3e5d924c4524a$export$ba20d1a7aa0c4a90,
    $88e3e5d924c4524a$export$94a6e55709d4d961
];

});
parcelRequire.register("iPehb", function(module, exports) {

$parcel$export(module.exports, "default", () => $db481056a19b7e47$export$2e2bcd8739ae039);
function $db481056a19b7e47$export$2e2bcd8739ae039(actionCreators, dispatch) {
    var boundActionCreators = {};
    var _loop = function _loop(key) {
        var actionCreator = actionCreators[key];
        if (typeof actionCreator === "function") boundActionCreators[key] = function() {
            return dispatch(actionCreator.apply(void 0, arguments));
        };
    };
    for(var key in actionCreators)_loop(key);
    return boundActionCreators;
}

});

parcelRequire.register("9bkq0", function(module, exports) {

$parcel$export(module.exports, "wrapMapToPropsConstant", () => $6af4facac7c9b801$export$710f7c60f68acd3e);
$parcel$export(module.exports, "wrapMapToPropsFunc", () => $6af4facac7c9b801$export$8d46c7f53c8c602f);
parcelRequire("8tJBx");
function $6af4facac7c9b801$export$710f7c60f68acd3e(getConstant) {
    return function initConstantSelector(dispatch, options) {
        var constant = getConstant(dispatch, options);
        function constantSelector() {
            return constant;
        }
        constantSelector.dependsOnOwnProps = false;
        return constantSelector;
    };
} // dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
function $6af4facac7c9b801$export$e561b938df936d57(mapToProps) {
    return mapToProps.dependsOnOwnProps !== null && mapToProps.dependsOnOwnProps !== undefined ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
} // Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
function $6af4facac7c9b801$export$8d46c7f53c8c602f(mapToProps, methodName) {
    return function initProxySelector(dispatch, _ref) {
        var displayName = _ref.displayName;
        var proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
            return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch);
        }; // allow detectFactoryAndVerify to get ownProps
        proxy.dependsOnOwnProps = true;
        proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
            proxy.mapToProps = mapToProps;
            proxy.dependsOnOwnProps = $6af4facac7c9b801$export$e561b938df936d57(mapToProps);
            var props = proxy(stateOrDispatch, ownProps);
            if (typeof props === "function") {
                proxy.mapToProps = props;
                proxy.dependsOnOwnProps = $6af4facac7c9b801$export$e561b938df936d57(props);
                props = proxy(stateOrDispatch, ownProps);
            }
            return props;
        };
        return proxy;
    };
}

});
parcelRequire.register("8tJBx", function(module, exports) {

var $2wCrJ = parcelRequire("2wCrJ");

var $kMkjN = parcelRequire("kMkjN");
function $62c4683cad31a6a0$export$2e2bcd8739ae039(value, displayName, methodName) {
    if (!(0, $2wCrJ.default)(value)) (0, $kMkjN.default)(methodName + "() in " + displayName + " must return a plain object. Instead received " + value + ".");
}

});
parcelRequire.register("2wCrJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $1d6c648dc15cb0a3$export$2e2bcd8739ae039);
/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */ function $1d6c648dc15cb0a3$export$2e2bcd8739ae039(obj) {
    if (typeof obj !== "object" || obj === null) return false;
    var proto = Object.getPrototypeOf(obj);
    if (proto === null) return true;
    var baseProto = proto;
    while(Object.getPrototypeOf(baseProto) !== null)baseProto = Object.getPrototypeOf(baseProto);
    return proto === baseProto;
}

});

parcelRequire.register("kMkjN", function(module, exports) {

$parcel$export(module.exports, "default", () => $f2080d27fbccb270$export$2e2bcd8739ae039);
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */ function $f2080d27fbccb270$export$2e2bcd8739ae039(message) {
    /* eslint-disable no-console */ if (typeof console !== "undefined" && typeof console.error === "function") console.error(message);
    /* eslint-enable no-console */ try {
        // This error was thrown as a convenience so that if you enable
        // "break on all exceptions" in your console,
        // it would pause the execution at this line.
        throw new Error(message);
    /* eslint-disable no-empty */ } catch (e) {}
/* eslint-enable no-empty */ }

});




parcelRequire.register("2qlVA", function(module, exports) {

$parcel$export(module.exports, "default", () => $1c3f04e249046bae$export$2e2bcd8739ae039);

var $9bkq0 = parcelRequire("9bkq0");
function $1c3f04e249046bae$export$23fc470827b14aa(mapStateToProps) {
    return typeof mapStateToProps === "function" ? (0, $9bkq0.wrapMapToPropsFunc)(mapStateToProps, "mapStateToProps") : undefined;
}
function $1c3f04e249046bae$export$514bc8c1a53c1d66(mapStateToProps) {
    return !mapStateToProps ? (0, $9bkq0.wrapMapToPropsConstant)(function() {
        return {};
    }) : undefined;
}
var $1c3f04e249046bae$export$2e2bcd8739ae039 = [
    $1c3f04e249046bae$export$23fc470827b14aa,
    $1c3f04e249046bae$export$514bc8c1a53c1d66
];

});

parcelRequire.register("877DX", function(module, exports) {

$parcel$export(module.exports, "default", () => $5e84e7fdad73046a$export$2e2bcd8739ae039);

var $aO5a1 = parcelRequire("aO5a1");
parcelRequire("8tJBx");
function $5e84e7fdad73046a$export$691c327fc30bc857(stateProps, dispatchProps, ownProps) {
    return (0, $aO5a1.default)({}, ownProps, stateProps, dispatchProps);
}
function $5e84e7fdad73046a$export$5b105939c84b5234(mergeProps) {
    return function initMergePropsProxy(dispatch, _ref) {
        var displayName = _ref.displayName, pure = _ref.pure, areMergedPropsEqual = _ref.areMergedPropsEqual;
        var hasRunOnce = false;
        var mergedProps;
        return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
            var nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);
            if (hasRunOnce) {
                if (!pure || !areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
            } else {
                hasRunOnce = true;
                mergedProps = nextMergedProps;
            }
            return mergedProps;
        };
    };
}
function $5e84e7fdad73046a$export$d61b680184bc3f00(mergeProps) {
    return typeof mergeProps === "function" ? $5e84e7fdad73046a$export$5b105939c84b5234(mergeProps) : undefined;
}
function $5e84e7fdad73046a$export$a13ba70ef50dda6d(mergeProps) {
    return !mergeProps ? function() {
        return $5e84e7fdad73046a$export$691c327fc30bc857;
    } : undefined;
}
var $5e84e7fdad73046a$export$2e2bcd8739ae039 = [
    $5e84e7fdad73046a$export$d61b680184bc3f00,
    $5e84e7fdad73046a$export$a13ba70ef50dda6d
];

});

parcelRequire.register("8WHQT", function(module, exports) {

$parcel$export(module.exports, "default", () => $6835c19c36481e83$export$2e2bcd8739ae039);

var $akilq = parcelRequire("akilq");
parcelRequire("5P5yZ");
var $6835c19c36481e83$var$_excluded = [
    "initMapStateToProps",
    "initMapDispatchToProps",
    "initMergeProps"
];
function $6835c19c36481e83$export$68c2c73bda6aa4b0(mapStateToProps, mapDispatchToProps, mergeProps, dispatch) {
    return function impureFinalPropsSelector(state, ownProps) {
        return mergeProps(mapStateToProps(state, ownProps), mapDispatchToProps(dispatch, ownProps), ownProps);
    };
}
function $6835c19c36481e83$export$d20c0c2ca6eb2b6f(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, _ref) {
    var areStatesEqual = _ref.areStatesEqual, areOwnPropsEqual = _ref.areOwnPropsEqual, areStatePropsEqual = _ref.areStatePropsEqual;
    var hasRunAtLeastOnce = false;
    var state;
    var ownProps;
    var stateProps;
    var dispatchProps;
    var mergedProps;
    function handleFirstCall(firstState, firstOwnProps) {
        state = firstState;
        ownProps = firstOwnProps;
        stateProps = mapStateToProps(state, ownProps);
        dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        hasRunAtLeastOnce = true;
        return mergedProps;
    }
    function handleNewPropsAndNewState() {
        stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewProps() {
        if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewState() {
        var nextStateProps = mapStateToProps(state, ownProps);
        var statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
        stateProps = nextStateProps;
        if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleSubsequentCalls(nextState, nextOwnProps) {
        var propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
        var stateChanged = !areStatesEqual(nextState, state, nextOwnProps, ownProps);
        state = nextState;
        ownProps = nextOwnProps;
        if (propsChanged && stateChanged) return handleNewPropsAndNewState();
        if (propsChanged) return handleNewProps();
        if (stateChanged) return handleNewState();
        return mergedProps;
    }
    return function pureFinalPropsSelector(nextState, nextOwnProps) {
        return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
    };
} // TODO: Add more comments
function $6835c19c36481e83$export$2e2bcd8739ae039(dispatch, _ref2) {
    var initMapStateToProps = _ref2.initMapStateToProps, initMapDispatchToProps = _ref2.initMapDispatchToProps, initMergeProps = _ref2.initMergeProps, options = (0, $akilq.default)(_ref2, $6835c19c36481e83$var$_excluded);
    var mapStateToProps = initMapStateToProps(dispatch, options);
    var mapDispatchToProps = initMapDispatchToProps(dispatch, options);
    var mergeProps = initMergeProps(dispatch, options);
    var selectorFactory = options.pure ? $6835c19c36481e83$export$d20c0c2ca6eb2b6f : $6835c19c36481e83$export$68c2c73bda6aa4b0;
    return selectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}

});
parcelRequire.register("5P5yZ", function(module, exports) {

var $kMkjN = parcelRequire("kMkjN");
function $43d607f4712edf55$var$verify(selector, methodName, displayName) {
    if (!selector) throw new Error("Unexpected value for " + methodName + " in " + displayName + ".");
    else if (methodName === "mapStateToProps" || methodName === "mapDispatchToProps") {
        if (!Object.prototype.hasOwnProperty.call(selector, "dependsOnOwnProps")) (0, $kMkjN.default)("The selector for " + methodName + " of " + displayName + " did not specify a value for dependsOnOwnProps.");
    }
}
function $43d607f4712edf55$export$2e2bcd8739ae039(mapStateToProps, mapDispatchToProps, mergeProps, displayName) {
    $43d607f4712edf55$var$verify(mapStateToProps, "mapStateToProps", displayName);
    $43d607f4712edf55$var$verify(mapDispatchToProps, "mapDispatchToProps", displayName);
    $43d607f4712edf55$var$verify(mergeProps, "mergeProps", displayName);
}

});



parcelRequire.register("cXlDU", function(module, exports) {

$parcel$export(module.exports, "createDispatchHook", () => $96ebc8895716e114$export$bc9b55530897c558);

var $lQ6Kh = parcelRequire("lQ6Kh");

var $lRLOM = parcelRequire("lRLOM");
function $96ebc8895716e114$export$bc9b55530897c558(context) {
    if (context === void 0) context = (0, $lQ6Kh.ReactReduxContext);
    var useStore = context === (0, $lQ6Kh.ReactReduxContext) ? (0, $lRLOM.useStore) : (0, $lRLOM.createStoreHook)(context);
    return function useDispatch() {
        var store = useStore();
        return store.dispatch;
    };
}
var $96ebc8895716e114$export$8ad76b76a4c905f8 = /*#__PURE__*/ $96ebc8895716e114$export$bc9b55530897c558();

});
parcelRequire.register("lRLOM", function(module, exports) {

$parcel$export(module.exports, "createStoreHook", () => $feb3a3e452a10a3a$export$671dba69185d0304);
$parcel$export(module.exports, "useStore", () => $feb3a3e452a10a3a$export$6ccbb43953eebf8);

var $eO7Kz = parcelRequire("eO7Kz");

var $lQ6Kh = parcelRequire("lQ6Kh");

var $9EAjX = parcelRequire("9EAjX");
function $feb3a3e452a10a3a$export$671dba69185d0304(context) {
    if (context === void 0) context = (0, $lQ6Kh.ReactReduxContext);
    var useReduxContext = context === (0, $lQ6Kh.ReactReduxContext) ? (0, $9EAjX.useReduxContext) : function() {
        return (0, $eO7Kz.useContext)(context);
    };
    return function useStore() {
        var _useReduxContext = useReduxContext(), store = _useReduxContext.store;
        return store;
    };
}
var $feb3a3e452a10a3a$export$6ccbb43953eebf8 = /*#__PURE__*/ $feb3a3e452a10a3a$export$671dba69185d0304();

});
parcelRequire.register("9EAjX", function(module, exports) {

$parcel$export(module.exports, "useReduxContext", () => $7074060e3d508edd$export$c1275ca9a6fd3ec5);

var $eO7Kz = parcelRequire("eO7Kz");

var $lQ6Kh = parcelRequire("lQ6Kh");
function $7074060e3d508edd$export$c1275ca9a6fd3ec5() {
    var contextValue = (0, $eO7Kz.useContext)((0, $lQ6Kh.ReactReduxContext));
    return contextValue;
}

});



parcelRequire.register("g5ZFo", function(module, exports) {

$parcel$export(module.exports, "createSelectorHook", () => $bb7cf2a91fc180dc$export$2b53f90d2bd1cbfb);

var $eO7Kz = parcelRequire("eO7Kz");

var $9EAjX = parcelRequire("9EAjX");

var $aGRlO = parcelRequire("aGRlO");

var $doDZW = parcelRequire("doDZW");

var $lQ6Kh = parcelRequire("lQ6Kh");
var $bb7cf2a91fc180dc$var$refEquality = function refEquality(a, b) {
    return a === b;
};
function $bb7cf2a91fc180dc$var$useSelectorWithStoreAndSubscription(selector, equalityFn, store, contextSub) {
    var _useReducer = (0, $eO7Kz.useReducer)(function(s) {
        return s + 1;
    }, 0), forceRender = _useReducer[1];
    var subscription = (0, $eO7Kz.useMemo)(function() {
        return (0, $aGRlO.createSubscription)(store, contextSub);
    }, [
        store,
        contextSub
    ]);
    var latestSubscriptionCallbackError = (0, $eO7Kz.useRef)();
    var latestSelector = (0, $eO7Kz.useRef)();
    var latestStoreState = (0, $eO7Kz.useRef)();
    var latestSelectedState = (0, $eO7Kz.useRef)();
    var storeState = store.getState();
    var selectedState;
    try {
        if (selector !== latestSelector.current || storeState !== latestStoreState.current || latestSubscriptionCallbackError.current) {
            var newSelectedState = selector(storeState); // ensure latest selected state is reused so that a custom equality function can result in identical references
            if (latestSelectedState.current === undefined || !equalityFn(newSelectedState, latestSelectedState.current)) selectedState = newSelectedState;
            else selectedState = latestSelectedState.current;
        } else selectedState = latestSelectedState.current;
    } catch (err) {
        if (latestSubscriptionCallbackError.current) err.message += "\nThe error may be correlated with this previous error:\n" + latestSubscriptionCallbackError.current.stack + "\n\n";
        throw err;
    }
    (0, $doDZW.useIsomorphicLayoutEffect)(function() {
        latestSelector.current = selector;
        latestStoreState.current = storeState;
        latestSelectedState.current = selectedState;
        latestSubscriptionCallbackError.current = undefined;
    });
    (0, $doDZW.useIsomorphicLayoutEffect)(function() {
        function checkForUpdates() {
            try {
                var newStoreState = store.getState(); // Avoid calling selector multiple times if the store's state has not changed
                if (newStoreState === latestStoreState.current) return;
                var _newSelectedState = latestSelector.current(newStoreState);
                if (equalityFn(_newSelectedState, latestSelectedState.current)) return;
                latestSelectedState.current = _newSelectedState;
                latestStoreState.current = newStoreState;
            } catch (err) {
                // we ignore all errors here, since when the component
                // is re-rendered, the selectors are called again, and
                // will throw again, if neither props nor store state
                // changed
                latestSubscriptionCallbackError.current = err;
            }
            forceRender();
        }
        subscription.onStateChange = checkForUpdates;
        subscription.trySubscribe();
        checkForUpdates();
        return function() {
            return subscription.tryUnsubscribe();
        };
    }, [
        store,
        subscription
    ]);
    return selectedState;
}
function $bb7cf2a91fc180dc$export$2b53f90d2bd1cbfb(context) {
    if (context === void 0) context = (0, $lQ6Kh.ReactReduxContext);
    var useReduxContext = context === (0, $lQ6Kh.ReactReduxContext) ? (0, $9EAjX.useReduxContext) : function() {
        return (0, $eO7Kz.useContext)(context);
    };
    return function useSelector(selector, equalityFn) {
        if (equalityFn === void 0) equalityFn = $bb7cf2a91fc180dc$var$refEquality;
        var _useReduxContext = useReduxContext(), store = _useReduxContext.store, contextSub = _useReduxContext.subscription;
        var selectedState = $bb7cf2a91fc180dc$var$useSelectorWithStoreAndSubscription(selector, equalityFn, store, contextSub);
        (0, $eO7Kz.useDebugValue)(selectedState);
        return selectedState;
    };
}
var $bb7cf2a91fc180dc$export$2105062e25df4afe = /*#__PURE__*/ $bb7cf2a91fc180dc$export$2b53f90d2bd1cbfb();

});


parcelRequire.register("e0Pel", function(module, exports) {

$parcel$export(module.exports, "unstable_batchedUpdates", () => (parcelRequire("kz03S")).unstable_batchedUpdates);
/* eslint-disable import/no-unresolved */ 
var $kz03S = parcelRequire("kz03S");

});



parcelRequire.register("dC5YF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $eO7Kz = parcelRequire("eO7Kz");
function $9e9375fd4d37e90e$var$_slicedToArray(arr, i) {
    return $9e9375fd4d37e90e$var$_arrayWithHoles(arr) || $9e9375fd4d37e90e$var$_iterableToArrayLimit(arr, i) || $9e9375fd4d37e90e$var$_unsupportedIterableToArray(arr, i) || $9e9375fd4d37e90e$var$_nonIterableRest();
}
function $9e9375fd4d37e90e$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $9e9375fd4d37e90e$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $9e9375fd4d37e90e$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $9e9375fd4d37e90e$var$_arrayLikeToArray(o, minLen);
}
function $9e9375fd4d37e90e$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $9e9375fd4d37e90e$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $9e9375fd4d37e90e$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $9e9375fd4d37e90e$var$useForceRender() {
    var _useState = (0, $eO7Kz.useState)(), _useState2 = $9e9375fd4d37e90e$var$_slicedToArray(_useState, 2), setForceRender = _useState2[1];
    return (0, $eO7Kz.useCallback)(function() {
        return setForceRender({});
    }, [
        setForceRender
    ]);
}
var $9e9375fd4d37e90e$var$_default = $9e9375fd4d37e90e$var$useForceRender;
module.exports.default = $9e9375fd4d37e90e$var$_default;

});

parcelRequire.register("44MU5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2f7d7862ad0290f5$var$_usePonyfill = $2f7d7862ad0290f5$var$_interopRequireDefault((parcelRequire("dn1f8")));
function $2f7d7862ad0290f5$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $2f7d7862ad0290f5$var$_default = $2f7d7862ad0290f5$var$_usePonyfill.default;
module.exports.default = $2f7d7862ad0290f5$var$_default;

});
parcelRequire.register("dn1f8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $9bbe633560f0b17d$var$usePonyfill;

var $9bbe633560f0b17d$var$_useContext = $9bbe633560f0b17d$var$_interopRequireDefault((parcelRequire("eJ1k1")));
function $9bbe633560f0b17d$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $9bbe633560f0b17d$var$usePonyfill() {
    return (0, $9bbe633560f0b17d$var$_useContext.default)().ponyfillState;
}

});
parcelRequire.register("eJ1k1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $ab864b2d8f356b97$var$usePonyfillContext;

var $eO7Kz = parcelRequire("eO7Kz");

var $ab864b2d8f356b97$var$_PonyfillContext = $ab864b2d8f356b97$var$_interopRequireDefault((parcelRequire("hF14E")));
function $ab864b2d8f356b97$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $ab864b2d8f356b97$var$usePonyfillContext() {
    var context = (0, $eO7Kz.useContext)($ab864b2d8f356b97$var$_PonyfillContext.default);
    if (!context) throw new Error("botframework-webchat: This hook can only be used under <PonyfillContext>.");
    return context;
}

});
parcelRequire.register("hF14E", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $eO7Kz = parcelRequire("eO7Kz");
var $cdb719477d3f0379$var$_default = /*#__PURE__*/ (0, $eO7Kz.createContext)(undefined);
module.exports.default = $cdb719477d3f0379$var$_default;

});




parcelRequire.register("fvJx2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $b4ad11f1b563293d$var$useStyleOptions;

var $b4ad11f1b563293d$var$_useWebChatAPIContext = $b4ad11f1b563293d$var$_interopRequireDefault((parcelRequire("iJOsw")));
function $b4ad11f1b563293d$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $b4ad11f1b563293d$var$useStyleOptions() {
    return [
        (0, $b4ad11f1b563293d$var$_useWebChatAPIContext.default)().styleOptions
    ];
}

});
parcelRequire.register("iJOsw", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $da4392165ee528c6$var$useWebChatAPIContext;

var $eO7Kz = parcelRequire("eO7Kz");

var $da4392165ee528c6$var$_WebChatAPIContext = $da4392165ee528c6$var$_interopRequireDefault((parcelRequire("aHcFB")));
function $da4392165ee528c6$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $da4392165ee528c6$var$useWebChatAPIContext() {
    var context = (0, $eO7Kz.useContext)($da4392165ee528c6$var$_WebChatAPIContext.default);
    if (!context) throw new Error("This hook can only be used on a component that is a descendant of <Composer>");
    return context;
}

});
parcelRequire.register("aHcFB", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $eO7Kz = parcelRequire("eO7Kz");
var $7c97bf835f03790d$var$context = /*#__PURE__*/ (0, $eO7Kz.createContext)(undefined);
$7c97bf835f03790d$var$context.displayName = "WebChatAPIContext";
var $7c97bf835f03790d$var$_default = $7c97bf835f03790d$var$context;
module.exports.default = $7c97bf835f03790d$var$_default;

});




parcelRequire.register("3GEzF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $2af4c48b43597f02$var$useActivities;

var $kSc9m = parcelRequire("kSc9m");
function $2af4c48b43597f02$var$useActivities() {
    return [
        (0, $kSc9m.useSelector)(function(_ref) {
            var activities = _ref.activities;
            return activities;
        })
    ];
}

});

parcelRequire.register("9sekQ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6e21d94063f41ec6$var$_useActivityKeys = $6e21d94063f41ec6$var$_interopRequireDefault((parcelRequire("cZiTX")));
function $6e21d94063f41ec6$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $6e21d94063f41ec6$var$_default = $6e21d94063f41ec6$var$_useActivityKeys.default;
module.exports.default = $6e21d94063f41ec6$var$_default;

});
parcelRequire.register("cZiTX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $9749d803a4305443$var$useActivityKeys;

var $9749d803a4305443$var$_useContext = $9749d803a4305443$var$_interopRequireDefault((parcelRequire("bR8cL")));
function $9749d803a4305443$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $9749d803a4305443$var$useActivityKeys() {
    return (0, $9749d803a4305443$var$_useContext.default)().activityKeysState;
}

});
parcelRequire.register("bR8cL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $023a3df8c4dd9f03$var$useActivityKeyerContext;

var $eO7Kz = parcelRequire("eO7Kz");

var $023a3df8c4dd9f03$var$_Context = $023a3df8c4dd9f03$var$_interopRequireDefault((parcelRequire("29tYV")));
function $023a3df8c4dd9f03$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $023a3df8c4dd9f03$var$useActivityKeyerContext() {
    var thrownOnUndefined = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
    var contextValue = (0, $eO7Kz.useContext)($023a3df8c4dd9f03$var$_Context.default);
    if (thrownOnUndefined && !contextValue) throw new Error("botframework-webchat internal: This hook can only be used under <ActivityKeyerComposer>.");
    return contextValue;
}

});
parcelRequire.register("29tYV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $eO7Kz = parcelRequire("eO7Kz");
var $1913adc44fbe16ea$var$_default = /*#__PURE__*/ (0, $eO7Kz.createContext)(undefined);
module.exports.default = $1913adc44fbe16ea$var$_default;

});




parcelRequire.register("lpcyL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f955ace2c8dfc427$var$_useActivityKeysByRead = $f955ace2c8dfc427$var$_interopRequireDefault((parcelRequire("iuvgq")));
function $f955ace2c8dfc427$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $f955ace2c8dfc427$var$_default = $f955ace2c8dfc427$var$_useActivityKeysByRead.default;
module.exports.default = $f955ace2c8dfc427$var$_default;

});
parcelRequire.register("iuvgq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $d76347af1cb10699$var$useActivityKeysByRead;

var $d76347af1cb10699$var$_useContext = $d76347af1cb10699$var$_interopRequireDefault((parcelRequire("6Lcxt")));
function $d76347af1cb10699$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * Returns an arrays of two list of activity keys: read and unread.
 */ function $d76347af1cb10699$var$useActivityKeysByRead() {
    return (0, $d76347af1cb10699$var$_useContext.default)().activityKeysByReadState;
}

});
parcelRequire.register("6Lcxt", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $4ec0dbd18a9c5931$var$useActivityAcknowledgementContext;

var $eO7Kz = parcelRequire("eO7Kz");

var $4ec0dbd18a9c5931$var$_Context = $4ec0dbd18a9c5931$var$_interopRequireDefault((parcelRequire("5GUvE")));
function $4ec0dbd18a9c5931$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $4ec0dbd18a9c5931$var$useActivityAcknowledgementContext() {
    var thrownOnUndefined = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
    var contextValue = (0, $eO7Kz.useContext)($4ec0dbd18a9c5931$var$_Context.default);
    if (thrownOnUndefined && !contextValue) throw new Error("botframework-webchat internal: This hook can only be used under <ActivityAcknowledgementContext>.");
    return contextValue;
}

});
parcelRequire.register("5GUvE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $eO7Kz = parcelRequire("eO7Kz");
var $424cb59dc4483ffc$var$ActivityAcknowledgementContext = /*#__PURE__*/ (0, $eO7Kz.createContext)(undefined);
var $424cb59dc4483ffc$var$_default = $424cb59dc4483ffc$var$ActivityAcknowledgementContext;
module.exports.default = $424cb59dc4483ffc$var$_default;

});




parcelRequire.register("dGflF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $9f5b1a7f1e105bb9$var$useAvatarForBot;

var $9f5b1a7f1e105bb9$var$_useStyleOptions3 = $9f5b1a7f1e105bb9$var$_interopRequireDefault((parcelRequire("fvJx2")));
function $9f5b1a7f1e105bb9$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $9f5b1a7f1e105bb9$var$_slicedToArray(arr, i) {
    return $9f5b1a7f1e105bb9$var$_arrayWithHoles(arr) || $9f5b1a7f1e105bb9$var$_iterableToArrayLimit(arr, i) || $9f5b1a7f1e105bb9$var$_unsupportedIterableToArray(arr, i) || $9f5b1a7f1e105bb9$var$_nonIterableRest();
}
function $9f5b1a7f1e105bb9$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $9f5b1a7f1e105bb9$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $9f5b1a7f1e105bb9$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $9f5b1a7f1e105bb9$var$_arrayLikeToArray(o, minLen);
}
function $9f5b1a7f1e105bb9$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $9f5b1a7f1e105bb9$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $9f5b1a7f1e105bb9$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $9f5b1a7f1e105bb9$var$useAvatarForBot() {
    var _useStyleOptions = (0, $9f5b1a7f1e105bb9$var$_useStyleOptions3.default)(), _useStyleOptions2 = $9f5b1a7f1e105bb9$var$_slicedToArray(_useStyleOptions, 1), _useStyleOptions2$ = _useStyleOptions2[0], image = _useStyleOptions2$.botAvatarImage, initials = _useStyleOptions2$.botAvatarInitials;
    return [
        {
            image: image,
            initials: initials
        }
    ];
}

});

parcelRequire.register("7CkSv", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $58bc46fe91386541$var$useAvatarForUser;

var $58bc46fe91386541$var$_useStyleOptions3 = $58bc46fe91386541$var$_interopRequireDefault((parcelRequire("fvJx2")));
function $58bc46fe91386541$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $58bc46fe91386541$var$_slicedToArray(arr, i) {
    return $58bc46fe91386541$var$_arrayWithHoles(arr) || $58bc46fe91386541$var$_iterableToArrayLimit(arr, i) || $58bc46fe91386541$var$_unsupportedIterableToArray(arr, i) || $58bc46fe91386541$var$_nonIterableRest();
}
function $58bc46fe91386541$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $58bc46fe91386541$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $58bc46fe91386541$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $58bc46fe91386541$var$_arrayLikeToArray(o, minLen);
}
function $58bc46fe91386541$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $58bc46fe91386541$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $58bc46fe91386541$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $58bc46fe91386541$var$useAvatarForUser() {
    var _useStyleOptions = (0, $58bc46fe91386541$var$_useStyleOptions3.default)(), _useStyleOptions2 = $58bc46fe91386541$var$_slicedToArray(_useStyleOptions, 1), _useStyleOptions2$ = _useStyleOptions2[0], image = _useStyleOptions2$.userAvatarImage, initials = _useStyleOptions2$.userAvatarInitials;
    return [
        {
            image: image,
            initials: initials
        }
    ];
}

});

parcelRequire.register("6LGrP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $4ed80f1e0c535a74$var$useByteFormatter;

var $eO7Kz = parcelRequire("eO7Kz");

var $4ed80f1e0c535a74$var$_useLocalizedGlobalize = $4ed80f1e0c535a74$var$_interopRequireDefault((parcelRequire("bOdWr")));
function $4ed80f1e0c535a74$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $4ed80f1e0c535a74$var$_slicedToArray(arr, i) {
    return $4ed80f1e0c535a74$var$_arrayWithHoles(arr) || $4ed80f1e0c535a74$var$_iterableToArrayLimit(arr, i) || $4ed80f1e0c535a74$var$_unsupportedIterableToArray(arr, i) || $4ed80f1e0c535a74$var$_nonIterableRest();
}
function $4ed80f1e0c535a74$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $4ed80f1e0c535a74$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $4ed80f1e0c535a74$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $4ed80f1e0c535a74$var$_arrayLikeToArray(o, minLen);
}
function $4ed80f1e0c535a74$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $4ed80f1e0c535a74$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $4ed80f1e0c535a74$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
var $4ed80f1e0c535a74$var$KILOBYTE = 1024;
var $4ed80f1e0c535a74$var$MEGABYTE = 1048576;
var $4ed80f1e0c535a74$var$GIGABYTE = 1073741824;
var $4ed80f1e0c535a74$var$LONG_FORM = {
    form: "long"
};
var $4ed80f1e0c535a74$var$SHORT_FORM = {
    form: "short"
};
function $4ed80f1e0c535a74$var$useByteFormatter() {
    var _useLocalizedGlobaliz = (0, $4ed80f1e0c535a74$var$_useLocalizedGlobalize.default)(), _useLocalizedGlobaliz2 = $4ed80f1e0c535a74$var$_slicedToArray(_useLocalizedGlobaliz, 1), globalize = _useLocalizedGlobaliz2[0];
    return (0, $eO7Kz.useMemo)(function() {
        var unitFormatter = globalize.unitFormatter.bind(globalize);
        return function(bytes) {
            if (bytes < $4ed80f1e0c535a74$var$KILOBYTE) return unitFormatter("byte", $4ed80f1e0c535a74$var$LONG_FORM)(bytes);
            else if (bytes < $4ed80f1e0c535a74$var$MEGABYTE) return unitFormatter("kilobyte", $4ed80f1e0c535a74$var$SHORT_FORM)(~~(bytes / $4ed80f1e0c535a74$var$KILOBYTE));
            else if (bytes < $4ed80f1e0c535a74$var$GIGABYTE) return unitFormatter("megabyte", $4ed80f1e0c535a74$var$SHORT_FORM)(~~(bytes / $4ed80f1e0c535a74$var$MEGABYTE));
            return unitFormatter("gigabyte", $4ed80f1e0c535a74$var$SHORT_FORM)(~~(bytes / $4ed80f1e0c535a74$var$GIGABYTE));
        };
    }, [
        globalize
    ]);
}

});
parcelRequire.register("bOdWr", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $898f2db6fc3c7da4$var$useLocalizedGlobalize;

var $898f2db6fc3c7da4$var$_useWebChatAPIContext = $898f2db6fc3c7da4$var$_interopRequireDefault((parcelRequire("iJOsw")));
function $898f2db6fc3c7da4$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $898f2db6fc3c7da4$var$useLocalizedGlobalize() {
    return (0, $898f2db6fc3c7da4$var$_useWebChatAPIContext.default)().localizedGlobalizeState;
}

});


parcelRequire.register("jXJ2c", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $e88675e4a35f20d9$var$useConnectivityStatus;

var $kSc9m = parcelRequire("kSc9m");
function $e88675e4a35f20d9$var$useConnectivityStatus() {
    return [
        (0, $kSc9m.useSelector)(function(_ref) {
            var connectivityStatus = _ref.connectivityStatus;
            return connectivityStatus;
        })
    ];
}

});

parcelRequire.register("58lAO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $3bce72fdd287a614$var$useCreateActivityRenderer;

var $3bce72fdd287a614$var$_useCreateActivityRendererInternal = $3bce72fdd287a614$var$_interopRequireDefault((parcelRequire("kMzjA")));
function $3bce72fdd287a614$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
// The newer useCreateActivityRenderer() hook does not support override renderAttachment().
// Only the deprecated useRenderActivity() hook support overriding renderAttachment().
function $3bce72fdd287a614$var$useCreateActivityRenderer() {
    return (0, $3bce72fdd287a614$var$_useCreateActivityRendererInternal.default)();
}

});
parcelRequire.register("kMzjA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $f213af23e26635f3$var$useCreateActivityRendererInternal;

var $eO7Kz = parcelRequire("eO7Kz");

var $f213af23e26635f3$var$_useRenderAttachment = $f213af23e26635f3$var$_interopRequireDefault((parcelRequire("iYUPV")));

var $f213af23e26635f3$var$_useWebChatAPIContext2 = $f213af23e26635f3$var$_interopRequireDefault((parcelRequire("iJOsw")));
function $f213af23e26635f3$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $f213af23e26635f3$var$useCreateActivityRendererInternal(renderAttachmentOverride) {
    var _useWebChatAPIContext = (0, $f213af23e26635f3$var$_useWebChatAPIContext2.default)(), createActivityRenderer = _useWebChatAPIContext.activityRenderer;
    var defaultRenderAttachment = (0, $f213af23e26635f3$var$_useRenderAttachment.default)();
    var renderAttachment = renderAttachmentOverride || defaultRenderAttachment;
    return (0, $eO7Kz.useMemo)(function() {
        return function() {
            var renderActivity = createActivityRenderer.apply(void 0, arguments);
            if (!renderActivity) return false;
            return function(renderActivityOptions) {
                if (/*#__PURE__*/ (0, $eO7Kz.isValidElement)(renderActivity)) return renderActivity;
                var activityElement = renderActivity(function() {
                    return renderAttachment.apply(void 0, arguments);
                }, renderActivityOptions); // "activityElement" cannot be false. If the middleware want to hide the "activityElement", it should return "false" when we call createActivityRenderer().
                activityElement || console.warn("botframework-webchat: To hide an activity, the activity renderer should return false. It should not return a function that will return false when called.");
                return activityElement;
            };
        };
    }, [
        createActivityRenderer,
        renderAttachment
    ]);
}

});
parcelRequire.register("iYUPV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $dd19eb1e1d9c111b$var$useRenderAttachment;

var $dd19eb1e1d9c111b$var$_useWebChatAPIContext2 = $dd19eb1e1d9c111b$var$_interopRequireDefault((parcelRequire("iJOsw")));
function $dd19eb1e1d9c111b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $dd19eb1e1d9c111b$var$useRenderAttachment() {
    var _useWebChatAPIContext = (0, $dd19eb1e1d9c111b$var$_useWebChatAPIContext2.default)(), attachmentRenderer = _useWebChatAPIContext.attachmentRenderer;
    return attachmentRenderer;
}

});



parcelRequire.register("6dbay", function(module, exports) {
"use strict";
function $485c9eed4ad9b0c3$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $485c9eed4ad9b0c3$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $485c9eed4ad9b0c3$var$_typeof(obj);
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $485c9eed4ad9b0c3$var$useCreateActivityStatusRenderer;

var $485c9eed4ad9b0c3$var$_propTypes = $485c9eed4ad9b0c3$var$_interopRequireDefault((parcelRequire("f7UXb")));

var $485c9eed4ad9b0c3$var$_react = $485c9eed4ad9b0c3$var$_interopRequireWildcard((parcelRequire("eO7Kz")));

var $hLqEr = parcelRequire("hLqEr");

var $485c9eed4ad9b0c3$var$_useGetKeyByActivity = $485c9eed4ad9b0c3$var$_interopRequireDefault((parcelRequire("9aUPz")));

var $485c9eed4ad9b0c3$var$_useSendStatusByActivityKey = $485c9eed4ad9b0c3$var$_interopRequireDefault((parcelRequire("9Kvhn")));

var $485c9eed4ad9b0c3$var$_useWebChatAPIContext2 = $485c9eed4ad9b0c3$var$_interopRequireDefault((parcelRequire("iJOsw")));
function $485c9eed4ad9b0c3$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($485c9eed4ad9b0c3$var$_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $485c9eed4ad9b0c3$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || $485c9eed4ad9b0c3$var$_typeof(obj) !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $485c9eed4ad9b0c3$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $485c9eed4ad9b0c3$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $485c9eed4ad9b0c3$var$_slicedToArray(arr, i) {
    return $485c9eed4ad9b0c3$var$_arrayWithHoles(arr) || $485c9eed4ad9b0c3$var$_iterableToArrayLimit(arr, i) || $485c9eed4ad9b0c3$var$_unsupportedIterableToArray(arr, i) || $485c9eed4ad9b0c3$var$_nonIterableRest();
}
function $485c9eed4ad9b0c3$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $485c9eed4ad9b0c3$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $485c9eed4ad9b0c3$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $485c9eed4ad9b0c3$var$_arrayLikeToArray(o, minLen);
}
function $485c9eed4ad9b0c3$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $485c9eed4ad9b0c3$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $485c9eed4ad9b0c3$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
var $485c9eed4ad9b0c3$var$ActivityStatusContainerCore = /*#__PURE__*/ (0, $485c9eed4ad9b0c3$var$_react.memo)(function(_ref) {
    var activity = _ref.activity, hideTimestamp = _ref.hideTimestamp, nextVisibleActivity = _ref.nextVisibleActivity, sendStatus = _ref.sendStatus;
    var _useWebChatAPIContext = (0, $485c9eed4ad9b0c3$var$_useWebChatAPIContext2.default)(), createActivityStatusRenderer = _useWebChatAPIContext.activityStatusRenderer;
    return createActivityStatusRenderer({
        activity: activity,
        hideTimestamp: hideTimestamp,
        nextVisibleActivity: nextVisibleActivity,
        // "nextVisibleActivity" is for backward compatibility, please remove this line on or after 2022-07-22.
        sameTimestampGroup: hideTimestamp,
        // "sameTimestampGroup" is for backward compatibility, please remove this line on or after 2022-07-22.
        sendState: sendStatus === $hLqEr.SEND_FAILED || sendStatus === $hLqEr.SENT ? sendStatus : $hLqEr.SENDING
    });
});
$485c9eed4ad9b0c3$var$ActivityStatusContainerCore.propTypes = {
    // PropTypes cannot fully capture TypeScript types.
    // @ts-ignore
    activity: $485c9eed4ad9b0c3$var$_propTypes.default.shape({
        from: $485c9eed4ad9b0c3$var$_propTypes.default.shape({
            role: $485c9eed4ad9b0c3$var$_propTypes.default.string
        }).isRequired,
        localTimestamp: $485c9eed4ad9b0c3$var$_propTypes.default.string
    }).isRequired,
    hideTimestamp: $485c9eed4ad9b0c3$var$_propTypes.default.bool.isRequired,
    nextVisibleActivity: $485c9eed4ad9b0c3$var$_propTypes.default.any,
    sendStatus: $485c9eed4ad9b0c3$var$_propTypes.default.oneOf([
        $hLqEr.SENDING,
        $hLqEr.SEND_FAILED,
        $hLqEr.SENT
    ])
};
var $485c9eed4ad9b0c3$var$ActivityStatusContainer = /*#__PURE__*/ (0, $485c9eed4ad9b0c3$var$_react.memo)(function(_ref2) {
    var activity = _ref2.activity, hideTimestamp = _ref2.hideTimestamp, nextVisibleActivity = _ref2.nextVisibleActivity;
    var _useSendStatusByActiv = (0, $485c9eed4ad9b0c3$var$_useSendStatusByActivityKey.default)(), _useSendStatusByActiv2 = $485c9eed4ad9b0c3$var$_slicedToArray(_useSendStatusByActiv, 1), sendStatusByActivityKey = _useSendStatusByActiv2[0];
    var getKeyByActivity = (0, $485c9eed4ad9b0c3$var$_useGetKeyByActivity.default)();
    var key = getKeyByActivity(activity);
    var sendStatus = typeof key === "string" && sendStatusByActivityKey.get(key) || $hLqEr.SENT;
    return /*#__PURE__*/ $485c9eed4ad9b0c3$var$_react.default.createElement($485c9eed4ad9b0c3$var$ActivityStatusContainerCore, {
        activity: activity,
        hideTimestamp: hideTimestamp,
        nextVisibleActivity: nextVisibleActivity,
        sendStatus: sendStatus
    });
});
$485c9eed4ad9b0c3$var$ActivityStatusContainer.defaultProps = {
    hideTimestamp: false,
    nextVisibleActivity: undefined
};
$485c9eed4ad9b0c3$var$ActivityStatusContainer.propTypes = {
    // PropTypes cannot fully capture TypeScript types.
    // @ts-ignore
    activity: $485c9eed4ad9b0c3$var$_propTypes.default.shape({
        from: $485c9eed4ad9b0c3$var$_propTypes.default.shape({
            role: $485c9eed4ad9b0c3$var$_propTypes.default.string
        }).isRequired,
        localTimestamp: $485c9eed4ad9b0c3$var$_propTypes.default.string
    }).isRequired,
    hideTimestamp: $485c9eed4ad9b0c3$var$_propTypes.default.bool,
    nextVisibleActivity: $485c9eed4ad9b0c3$var$_propTypes.default.any
};
function $485c9eed4ad9b0c3$var$useCreateActivityStatusRenderer() {
    return (0, $485c9eed4ad9b0c3$var$_react.useMemo)(function() {
        return function(_ref3) {
            var activity = _ref3.activity, nextVisibleActivity = _ref3.nextVisibleActivity;
            return function() {
                var _ref4 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, hideTimestamp = _ref4.hideTimestamp;
                return /*#__PURE__*/ $485c9eed4ad9b0c3$var$_react.default.createElement($485c9eed4ad9b0c3$var$ActivityStatusContainer, {
                    activity: activity,
                    hideTimestamp: hideTimestamp,
                    nextVisibleActivity: nextVisibleActivity
                });
            };
        };
    }, []);
}

});
parcelRequire.register("hLqEr", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SENT = module.exports.SEND_FAILED = module.exports.SENDING = void 0;
// This type is only for this package only and help reducing size of the bundle.
// Externals should use the string literal directly instead.
// TODO: [P3] #4040 When improve treeshaking with named exports, we could export internals from `core` package.
//       import { SENDING, SEND_FAILED, SENT } from 'botframework-webchat-core/internal/SendStatus';
var $ceeb7fd2db6bf685$var$SENDING = "sending";
module.exports.SENDING = $ceeb7fd2db6bf685$var$SENDING;
var $ceeb7fd2db6bf685$var$SEND_FAILED = "send failed";
module.exports.SEND_FAILED = $ceeb7fd2db6bf685$var$SEND_FAILED;
var $ceeb7fd2db6bf685$var$SENT = "sent";
module.exports.SENT = $ceeb7fd2db6bf685$var$SENT;

});

parcelRequire.register("9aUPz", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6ae1219ddf9bdb53$var$_useGetKeyByActivity = $6ae1219ddf9bdb53$var$_interopRequireDefault((parcelRequire("9eAGy")));
function $6ae1219ddf9bdb53$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $6ae1219ddf9bdb53$var$_default = $6ae1219ddf9bdb53$var$_useGetKeyByActivity.default;
module.exports.default = $6ae1219ddf9bdb53$var$_default;

});
parcelRequire.register("9eAGy", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $6b91e0cd47e91b00$var$useGetKeyByActivity;

var $6b91e0cd47e91b00$var$_useContext = $6b91e0cd47e91b00$var$_interopRequireDefault((parcelRequire("bR8cL")));
function $6b91e0cd47e91b00$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $6b91e0cd47e91b00$var$useGetKeyByActivity() {
    return (0, $6b91e0cd47e91b00$var$_useContext.default)().getKeyByActivity;
}

});


parcelRequire.register("9Kvhn", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7190ac5c256c05b1$var$_useSendStatusByActivityKey = $7190ac5c256c05b1$var$_interopRequireDefault((parcelRequire("jE1Zj")));
function $7190ac5c256c05b1$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
// This JSDoc is copied from `/providers/ActivityStatus/useSendStatusByActivityKey`.
/**
 * Returns a key/value map which stores the outgoing activity send status by activity key:
 *
 * - `"sending"`, the activity is currently in transit;
 * - `"sent"`, the activity is sent and acknowledged by the platform;
 * - `"send failed"`, the activity failed to send.
 *
 * If the send status is `"send failed"`, it could be due to (non-exhaustive):
 *
 * - Immediate or almost immediate failures, such as network error;
 * - It took longer than `styleOptions.sendTimeout` or `styleOptions.sendTimeoutForAttachments` to send.
 *
 * The send status of an activity could turn from `"send failed"` back to `"sending"` if (non-exhaustive):
 *
 * - The platform support resend and the activity is being resend;
 * - The `styleOptions.sendTimeout` or `styleOptions.sendTimeoutForAttachments` has increased past the expiry, overthrown the previous decision for timeout.
 *
 * If the activity key does not exists in this map, the activity is not an outgoing activity.
 */ var $7190ac5c256c05b1$var$_default = $7190ac5c256c05b1$var$_useSendStatusByActivityKey.default;
module.exports.default = $7190ac5c256c05b1$var$_default;

});
parcelRequire.register("jE1Zj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $e4d34b7fd0129d28$var$useSendStatus;

var $e4d34b7fd0129d28$var$_useContext = $e4d34b7fd0129d28$var$_interopRequireDefault((parcelRequire("gCl4j")));
function $e4d34b7fd0129d28$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * Returns a key/value map which stores the outgoing activity send status by activity key:
 *
 * - `"sending"`, the activity is currently in transit;
 * - `"sent"`, the activity is sent and acknowledged by the platform;
 * - `"send failed"`, the activity failed to send.
 *
 * If the send status is `"send failed"`, it could be due to (non-exhaustive):
 *
 * - Immediate or almost immediate failures, such as network error;
 * - It took longer than `styleOptions.sendTimeout` or `styleOptions.sendTimeoutForAttachments` to send.
 *
 * The send status of an activity could turn from `"send failed"` back to `"sending"` if (non-exhaustive):
 *
 * - The platform support resend and the activity is being resend;
 * - The `styleOptions.sendTimeout` or `styleOptions.sendTimeoutForAttachments` has increased past the expiry, overthrown the previous decision for timeout.
 *
 * If the activity key does not exists in this map, the activity is not an outgoing activity.
 */ function $e4d34b7fd0129d28$var$useSendStatus() {
    return (0, $e4d34b7fd0129d28$var$_useContext.default)().sendStatusByActivityKeyState;
}

});
parcelRequire.register("gCl4j", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $c19089b88a5002db$var$useActivitySendStatusContext;

var $eO7Kz = parcelRequire("eO7Kz");

var $c19089b88a5002db$var$_Context = $c19089b88a5002db$var$_interopRequireDefault((parcelRequire("1p0Hj")));
function $c19089b88a5002db$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $c19089b88a5002db$var$useActivitySendStatusContext() {
    var thrownOnUndefined = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
    var contextValue = (0, $eO7Kz.useContext)($c19089b88a5002db$var$_Context.default);
    if (thrownOnUndefined && !contextValue) throw new Error("botframework-webchat internal: This hook can only be used under <ActivitySendStatusComposer>.");
    return contextValue;
}

});
parcelRequire.register("1p0Hj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $eO7Kz = parcelRequire("eO7Kz");
var $1058aac9369b99df$var$ActivitySendStatusContext = /*#__PURE__*/ (0, $eO7Kz.createContext)(undefined);
var $1058aac9369b99df$var$_default = $1058aac9369b99df$var$ActivitySendStatusContext;
module.exports.default = $1058aac9369b99df$var$_default;

});





parcelRequire.register("4t1wo", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $340b0cf8367d89e0$var$useCreateAttachmentForScreenReaderRenderer;

var $340b0cf8367d89e0$var$_useWebChatAPIContext = $340b0cf8367d89e0$var$_interopRequireDefault((parcelRequire("iJOsw")));
function $340b0cf8367d89e0$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $340b0cf8367d89e0$var$useCreateAttachmentForScreenReaderRenderer() {
    return (0, $340b0cf8367d89e0$var$_useWebChatAPIContext.default)().attachmentForScreenReaderRenderer;
}

});

parcelRequire.register("50yWS", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $3a580fe5e9dbee30$var$useCreateAvatarRenderer;

var $eO7Kz = parcelRequire("eO7Kz");

var $3a580fe5e9dbee30$var$_useStyleOptions3 = $3a580fe5e9dbee30$var$_interopRequireDefault((parcelRequire("fvJx2")));

var $3a580fe5e9dbee30$var$_useWebChatAPIContext2 = $3a580fe5e9dbee30$var$_interopRequireDefault((parcelRequire("iJOsw")));
function $3a580fe5e9dbee30$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $3a580fe5e9dbee30$var$_slicedToArray(arr, i) {
    return $3a580fe5e9dbee30$var$_arrayWithHoles(arr) || $3a580fe5e9dbee30$var$_iterableToArrayLimit(arr, i) || $3a580fe5e9dbee30$var$_unsupportedIterableToArray(arr, i) || $3a580fe5e9dbee30$var$_nonIterableRest();
}
function $3a580fe5e9dbee30$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $3a580fe5e9dbee30$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $3a580fe5e9dbee30$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $3a580fe5e9dbee30$var$_arrayLikeToArray(o, minLen);
}
function $3a580fe5e9dbee30$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $3a580fe5e9dbee30$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $3a580fe5e9dbee30$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $3a580fe5e9dbee30$var$useCreateAvatarRenderer() {
    var _useStyleOptions = (0, $3a580fe5e9dbee30$var$_useStyleOptions3.default)(), _useStyleOptions2 = $3a580fe5e9dbee30$var$_slicedToArray(_useStyleOptions, 1), styleOptions = _useStyleOptions2[0];
    var _useWebChatAPIContext = (0, $3a580fe5e9dbee30$var$_useWebChatAPIContext2.default)(), avatarRenderer = _useWebChatAPIContext.avatarRenderer;
    return (0, $eO7Kz.useMemo)(function() {
        return function(_ref) {
            var activity = _ref.activity;
            var _activity$from = activity.from;
            _activity$from = _activity$from === void 0 ? {} : _activity$from;
            var role = _activity$from.role;
            var result = avatarRenderer({
                activity: activity,
                fromUser: role === "user",
                styleOptions: styleOptions
            });
            if (result !== false && typeof result !== "function") {
                console.warn("botframework-webchat: avatarMiddleware should return a function to render the avatar, or return false if avatar should be hidden. Please refer to HOOKS.md for details.");
                return function() {
                    return result;
                };
            }
            return result;
        };
    }, [
        avatarRenderer,
        styleOptions
    ]);
}

});

parcelRequire.register("OUH3C", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $0990a5c4dc911103$var$useCreateScrollToEndButtonRenderer;

var $0990a5c4dc911103$var$_useWebChatAPIContext = $0990a5c4dc911103$var$_interopRequireDefault((parcelRequire("iJOsw")));
function $0990a5c4dc911103$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $0990a5c4dc911103$var$useCreateScrollToEndButtonRenderer() {
    return (0, $0990a5c4dc911103$var$_useWebChatAPIContext.default)().scrollToEndButtonRenderer;
}

});

parcelRequire.register("hl4fj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $c9f7b0fe32bc8b23$var$useDateFormatter;

var $eO7Kz = parcelRequire("eO7Kz");

var $c9f7b0fe32bc8b23$var$_useLocalizedGlobalize = $c9f7b0fe32bc8b23$var$_interopRequireDefault((parcelRequire("bOdWr")));

var $c9f7b0fe32bc8b23$var$_usePonyfill3 = $c9f7b0fe32bc8b23$var$_interopRequireDefault((parcelRequire("44MU5")));
function $c9f7b0fe32bc8b23$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $c9f7b0fe32bc8b23$var$_slicedToArray(arr, i) {
    return $c9f7b0fe32bc8b23$var$_arrayWithHoles(arr) || $c9f7b0fe32bc8b23$var$_iterableToArrayLimit(arr, i) || $c9f7b0fe32bc8b23$var$_unsupportedIterableToArray(arr, i) || $c9f7b0fe32bc8b23$var$_nonIterableRest();
}
function $c9f7b0fe32bc8b23$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $c9f7b0fe32bc8b23$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $c9f7b0fe32bc8b23$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $c9f7b0fe32bc8b23$var$_arrayLikeToArray(o, minLen);
}
function $c9f7b0fe32bc8b23$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $c9f7b0fe32bc8b23$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $c9f7b0fe32bc8b23$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
// False positive: we are using `Date` as a type.
// eslint-disable-next-line no-restricted-globals
function $c9f7b0fe32bc8b23$var$useDateFormatter() {
    var _usePonyfill = (0, $c9f7b0fe32bc8b23$var$_usePonyfill3.default)(), _usePonyfill2 = $c9f7b0fe32bc8b23$var$_slicedToArray(_usePonyfill, 1), Date = _usePonyfill2[0].Date;
    var _useLocalizedGlobaliz = (0, $c9f7b0fe32bc8b23$var$_useLocalizedGlobalize.default)(), _useLocalizedGlobaliz2 = $c9f7b0fe32bc8b23$var$_slicedToArray(_useLocalizedGlobaliz, 1), globalize = _useLocalizedGlobaliz2[0];
    var formatDate = (0, $eO7Kz.useMemo)(function() {
        return function(date) {
            return globalize.dateFormatter({
                skeleton: "MMMMdhm"
            })(new Date(date));
        };
    }, [
        Date,
        globalize
    ]);
    return formatDate;
}

});

parcelRequire.register("7hJ5F", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getEarliestUpdateNotBefore = $54dd18eefc537305$var$getEarliestUpdateNotBefore;

var $eO7Kz = parcelRequire("eO7Kz");

var $54dd18eefc537305$var$_simpleUpdateIn = $54dd18eefc537305$var$_interopRequireDefault((parcelRequire("7qq3H")));

var $54dd18eefc537305$var$_findMin = $54dd18eefc537305$var$_interopRequireDefault((parcelRequire("jxVC9")));

var $54dd18eefc537305$var$_useForceRender = $54dd18eefc537305$var$_interopRequireDefault((parcelRequire("dC5YF")));

var $54dd18eefc537305$var$_useNotifications3 = $54dd18eefc537305$var$_interopRequireDefault((parcelRequire("5W3Db")));

var $54dd18eefc537305$var$_usePonyfill3 = $54dd18eefc537305$var$_interopRequireDefault((parcelRequire("44MU5")));

var $54dd18eefc537305$var$_useStyleOptions3 = $54dd18eefc537305$var$_interopRequireDefault((parcelRequire("fvJx2")));

var $54dd18eefc537305$var$_useTimer = $54dd18eefc537305$var$_interopRequireDefault((parcelRequire("35gVy")));
function $54dd18eefc537305$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $54dd18eefc537305$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $54dd18eefc537305$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $54dd18eefc537305$var$ownKeys(Object(source), !0).forEach(function(key) {
            $54dd18eefc537305$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $54dd18eefc537305$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $54dd18eefc537305$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $54dd18eefc537305$var$_createForOfIteratorHelper(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (!it) {
        if (Array.isArray(o) || (it = $54dd18eefc537305$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
            if (it) o = it;
            var i = 0;
            var F = function F() {};
            return {
                s: F,
                n: function n() {
                    if (i >= o.length) return {
                        done: true
                    };
                    return {
                        done: false,
                        value: o[i++]
                    };
                },
                e: function e(_e2) {
                    throw _e2;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var normalCompletion = true, didErr = false, err;
    return {
        s: function s() {
            it = it.call(o);
        },
        n: function n() {
            var step = it.next();
            normalCompletion = step.done;
            return step;
        },
        e: function e(_e3) {
            didErr = true;
            err = _e3;
        },
        f: function f() {
            try {
                if (!normalCompletion && it.return != null) it.return();
            } finally{
                if (didErr) throw err;
            }
        }
    };
}
function $54dd18eefc537305$var$_slicedToArray(arr, i) {
    return $54dd18eefc537305$var$_arrayWithHoles(arr) || $54dd18eefc537305$var$_iterableToArrayLimit(arr, i) || $54dd18eefc537305$var$_unsupportedIterableToArray(arr, i) || $54dd18eefc537305$var$_nonIterableRest();
}
function $54dd18eefc537305$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $54dd18eefc537305$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $54dd18eefc537305$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $54dd18eefc537305$var$_arrayLikeToArray(o, minLen);
}
function $54dd18eefc537305$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $54dd18eefc537305$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $54dd18eefc537305$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $54dd18eefc537305$var$getEarliestUpdateNotBefore(notificationMap) {
    return (0, $54dd18eefc537305$var$_findMin.default)(Object.values(notificationMap).filter(function(_ref) {
        var outOfDate = _ref.outOfDate;
        return outOfDate;
    }).map(function(_ref2) {
        var updateNotBefore = _ref2.updateNotBefore;
        return updateNotBefore;
    }));
}
function $54dd18eefc537305$var$useDebouncedNotifications() {
    var _usePonyfill = (0, $54dd18eefc537305$var$_usePonyfill3.default)(), _usePonyfill2 = $54dd18eefc537305$var$_slicedToArray(_usePonyfill, 1), Date = _usePonyfill2[0].Date;
    var _useStyleOptions = (0, $54dd18eefc537305$var$_useStyleOptions3.default)(), _useStyleOptions2 = $54dd18eefc537305$var$_slicedToArray(_useStyleOptions, 1), notificationDebounceTimeout = _useStyleOptions2[0].notificationDebounceTimeout;
    var _useNotifications = (0, $54dd18eefc537305$var$_useNotifications3.default)(), _useNotifications2 = $54dd18eefc537305$var$_slicedToArray(_useNotifications, 1), notifications = _useNotifications2[0];
    var debouncedNotificationsRef = (0, $eO7Kz.useRef)({});
    var forceRender = (0, $54dd18eefc537305$var$_useForceRender.default)();
    var now = Date.now(); // Delete notifications or mark them to be deleted if debouncing.
    var _iterator = $54dd18eefc537305$var$_createForOfIteratorHelper(Object.keys(debouncedNotificationsRef.current).filter(function(id) {
        return !(id in notifications);
    })), _step;
    try {
        for(_iterator.s(); !(_step = _iterator.n()).done;){
            var _id = _step.value;
            debouncedNotificationsRef.current = (0, $54dd18eefc537305$var$_simpleUpdateIn.default)(debouncedNotificationsRef.current, [
                _id
            ], function(debouncedNotification) {
                if (now < debouncedNotification.updateNotBefore) // The update need to be postponed.
                return $54dd18eefc537305$var$_objectSpread($54dd18eefc537305$var$_objectSpread({}, debouncedNotification), {}, {
                    outOfDate: true
                });
                 // Otherwise, return undefined will remove it.
            });
        } // For any changes, update notifications or mark them to be updated if debouncing.
    } catch (err) {
        _iterator.e(err);
    } finally{
        _iterator.f();
    }
    var _loop = function _loop() {
        var _Object$entries$_i = $54dd18eefc537305$var$_slicedToArray(_Object$entries[_i2], 2), _Object$entries$_i$ = _Object$entries$_i[1], alt = _Object$entries$_i$.alt, data = _Object$entries$_i$.data, id = _Object$entries$_i$.id, level = _Object$entries$_i$.level, message = _Object$entries$_i$.message, timestamp = _Object$entries$_i$.timestamp;
        debouncedNotificationsRef.current = (0, $54dd18eefc537305$var$_simpleUpdateIn.default)(debouncedNotificationsRef.current, [
            id
        ], function(debouncedNotification) {
            if (debouncedNotification && alt === debouncedNotification.alt && Object.is(data, debouncedNotification.data) && level === debouncedNotification.level && message === debouncedNotification.message && timestamp === debouncedNotification.timestamp) // If nothing changed, return as-is.
            return debouncedNotification;
            if (debouncedNotification && now < debouncedNotification.updateNotBefore) // The update need to be postponed.
            return $54dd18eefc537305$var$_objectSpread($54dd18eefc537305$var$_objectSpread({}, debouncedNotification), {}, {
                outOfDate: true
            });
             // Update the notification.
            return $54dd18eefc537305$var$_objectSpread($54dd18eefc537305$var$_objectSpread({}, debouncedNotification), {}, {
                alt: alt,
                data: data,
                id: id,
                level: level,
                message: message,
                outOfDate: false,
                timestamp: timestamp,
                updateNotBefore: now + notificationDebounceTimeout
            });
        });
    };
    for(var _i2 = 0, _Object$entries = Object.entries(notifications); _i2 < _Object$entries.length; _i2++)_loop();
    (0, $54dd18eefc537305$var$_useTimer.default)($54dd18eefc537305$var$getEarliestUpdateNotBefore(debouncedNotificationsRef.current), forceRender);
    return [
        debouncedNotificationsRef.current
    ];
}
var $54dd18eefc537305$var$_default = $54dd18eefc537305$var$useDebouncedNotifications;
module.exports.default = $54dd18eefc537305$var$_default;

});
parcelRequire.register("jxVC9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.map = $e3adca5fb1762ee2$var$map;
function $e3adca5fb1762ee2$var$_slicedToArray(arr, i) {
    return $e3adca5fb1762ee2$var$_arrayWithHoles(arr) || $e3adca5fb1762ee2$var$_iterableToArrayLimit(arr, i) || $e3adca5fb1762ee2$var$_unsupportedIterableToArray(arr, i) || $e3adca5fb1762ee2$var$_nonIterableRest();
}
function $e3adca5fb1762ee2$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $e3adca5fb1762ee2$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $e3adca5fb1762ee2$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $e3adca5fb1762ee2$var$_arrayLikeToArray(o, minLen);
}
function $e3adca5fb1762ee2$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $e3adca5fb1762ee2$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $e3adca5fb1762ee2$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $e3adca5fb1762ee2$var$isUndefined(obj) {
    return typeof obj === "undefined";
}
var $e3adca5fb1762ee2$var$DEFAULT_SELECTOR = function DEFAULT_SELECTOR(value) {
    return value;
};
function $e3adca5fb1762ee2$var$findMin(array) {
    var selector = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $e3adca5fb1762ee2$var$DEFAULT_SELECTOR;
    return array.reduce(function(minValue, value) {
        var minScore = $e3adca5fb1762ee2$var$isUndefined(minValue) ? minValue : selector(minValue);
        var score = $e3adca5fb1762ee2$var$isUndefined(value) ? value : selector(value);
        if ($e3adca5fb1762ee2$var$isUndefined(minScore)) return value;
        else if ($e3adca5fb1762ee2$var$isUndefined(score)) return minValue;
        return minScore < score ? minValue : value;
    }, undefined);
}
function $e3adca5fb1762ee2$var$map(map) {
    var selector = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $e3adca5fb1762ee2$var$DEFAULT_SELECTOR;
    return $e3adca5fb1762ee2$var$findMin(Object.entries(map).map(function(entry) {
        return $e3adca5fb1762ee2$var$isUndefined(entry[1]) ? undefined : entry;
    }), function(_ref) {
        var _ref2 = $e3adca5fb1762ee2$var$_slicedToArray(_ref, 2), key = _ref2[0], value = _ref2[1];
        return selector.call(map, value, key);
    });
}
var $e3adca5fb1762ee2$var$_default = $e3adca5fb1762ee2$var$findMin;
module.exports.default = $e3adca5fb1762ee2$var$_default;

});

parcelRequire.register("5W3Db", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $45252f8cd1dbdd4e$var$useNotifications;

var $kSc9m = parcelRequire("kSc9m");
function $45252f8cd1dbdd4e$var$useNotifications() {
    return [
        (0, $kSc9m.useSelector)(function(_ref) {
            var notifications = _ref.notifications;
            return notifications;
        })
    ];
}

});

parcelRequire.register("35gVy", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $23eef828ed904534$var$useTimer;

var $eO7Kz = parcelRequire("eO7Kz");

var $23eef828ed904534$var$_usePonyfill3 = $23eef828ed904534$var$_interopRequireDefault((parcelRequire("dn1f8")));
function $23eef828ed904534$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $23eef828ed904534$var$_slicedToArray(arr, i) {
    return $23eef828ed904534$var$_arrayWithHoles(arr) || $23eef828ed904534$var$_iterableToArrayLimit(arr, i) || $23eef828ed904534$var$_unsupportedIterableToArray(arr, i) || $23eef828ed904534$var$_nonIterableRest();
}
function $23eef828ed904534$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $23eef828ed904534$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $23eef828ed904534$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $23eef828ed904534$var$_arrayLikeToArray(o, minLen);
}
function $23eef828ed904534$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $23eef828ed904534$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $23eef828ed904534$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
/**
 * Calls a callback function at a specific time.
 */ function $23eef828ed904534$var$useTimer(at, fn) {
    var _usePonyfill = (0, $23eef828ed904534$var$_usePonyfill3.default)(), _usePonyfill2 = $23eef828ed904534$var$_slicedToArray(_usePonyfill, 1), _usePonyfill2$ = _usePonyfill2[0], clearTimeout = _usePonyfill2$.clearTimeout, Date = _usePonyfill2$.Date, setTimeout = _usePonyfill2$.setTimeout;
    (0, $eO7Kz.useEffect)(function() {
        if (typeof at === "number") {
            var ms = Math.max(0, at - Date.now()); // useEffect() is running after yielding to sync code via setImmediate (IE), MessageChannel (4ms), or setTimeout.
            // Thus, when calling setTimeout(..., 0), under Lolex, it will be waited for another loop.
            // In other words, setTimeout(..., 0) won't fire right away. It will be fired after clock.tick(<any number>).
            if (ms) {
                var timeout = setTimeout(fn, ms);
                return function() {
                    return clearTimeout(timeout);
                };
            }
            fn();
        }
    }, [
        at,
        clearTimeout,
        Date,
        fn,
        setTimeout
    ]);
}

});


parcelRequire.register("7wLcT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $57b023dc0fede3ff$var$useDictateInterims;

var $kSc9m = parcelRequire("kSc9m");

var $57b023dc0fede3ff$var$_useWebChatAPIContext = $57b023dc0fede3ff$var$_interopRequireDefault((parcelRequire("iJOsw")));
function $57b023dc0fede3ff$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $57b023dc0fede3ff$var$useDictateInterims() {
    return [
        (0, $kSc9m.useSelector)(function(_ref) {
            var dictateInterims = _ref.dictateInterims;
            return dictateInterims;
        }) || [],
        (0, $57b023dc0fede3ff$var$_useWebChatAPIContext.default)().setDictateInterims
    ];
}

});

parcelRequire.register("3KHpv", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $2bb7575d3dd7b920$var$useDictateState;

var $kSc9m = parcelRequire("kSc9m");
// TODO: [P3] We should update this code to use core/src/selectors/dictateState.js
function $2bb7575d3dd7b920$var$useDictateState() {
    return [
        (0, $kSc9m.useSelector)(function(_ref) {
            var dictateState = _ref.dictateState;
            return dictateState;
        })
    ];
}

});

parcelRequire.register("hSqkZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $d03be8e0aac04481$var$useDirection;

var $eO7Kz = parcelRequire("eO7Kz");

var $d03be8e0aac04481$var$_getRTLList = $d03be8e0aac04481$var$_interopRequireDefault((parcelRequire("4sDgs")));

var $d03be8e0aac04481$var$_useDirFromProps3 = $d03be8e0aac04481$var$_interopRequireDefault((parcelRequire("eHgyP")));

var $d03be8e0aac04481$var$_useLanguage3 = $d03be8e0aac04481$var$_interopRequireDefault((parcelRequire("aMPp7")));
function $d03be8e0aac04481$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $d03be8e0aac04481$var$_slicedToArray(arr, i) {
    return $d03be8e0aac04481$var$_arrayWithHoles(arr) || $d03be8e0aac04481$var$_iterableToArrayLimit(arr, i) || $d03be8e0aac04481$var$_unsupportedIterableToArray(arr, i) || $d03be8e0aac04481$var$_nonIterableRest();
}
function $d03be8e0aac04481$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $d03be8e0aac04481$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $d03be8e0aac04481$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $d03be8e0aac04481$var$_arrayLikeToArray(o, minLen);
}
function $d03be8e0aac04481$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $d03be8e0aac04481$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $d03be8e0aac04481$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $d03be8e0aac04481$var$determineDirection(dir, language) {
    if (dir !== "auto") return dir;
    else if ((0, $d03be8e0aac04481$var$_getRTLList.default)().includes(language)) return "rtl";
    return "ltr";
}
function $d03be8e0aac04481$var$useDirection() {
    var _useDirFromProps = (0, $d03be8e0aac04481$var$_useDirFromProps3.default)(), _useDirFromProps2 = $d03be8e0aac04481$var$_slicedToArray(_useDirFromProps, 1), dir = _useDirFromProps2[0];
    var _useLanguage = (0, $d03be8e0aac04481$var$_useLanguage3.default)(), _useLanguage2 = $d03be8e0aac04481$var$_slicedToArray(_useLanguage, 1), language = _useLanguage2[0];
    var determinedDirection = (0, $eO7Kz.useMemo)(function() {
        return $d03be8e0aac04481$var$determineDirection(dir, language);
    }, [
        dir,
        language
    ]);
    return [
        determinedDirection
    ];
}

});
parcelRequire.register("eHgyP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $02c2deab1775592c$var$useDirFromProps;

var $02c2deab1775592c$var$_useWebChatAPIContext = $02c2deab1775592c$var$_interopRequireDefault((parcelRequire("iJOsw")));
function $02c2deab1775592c$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $02c2deab1775592c$var$useDirFromProps() {
    return [
        (0, $02c2deab1775592c$var$_useWebChatAPIContext.default)().dir
    ];
}

});

parcelRequire.register("aMPp7", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $7da642e04dc60b63$var$useLanguage;

var $7da642e04dc60b63$var$_useLocalizedStrings = $7da642e04dc60b63$var$_interopRequireDefault((parcelRequire("eOdCk")));

var $7da642e04dc60b63$var$_useWebChatAPIContext2 = $7da642e04dc60b63$var$_interopRequireDefault((parcelRequire("iJOsw")));
function $7da642e04dc60b63$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $7da642e04dc60b63$var$useLanguage(options) {
    var _useWebChatAPIContext = (0, $7da642e04dc60b63$var$_useWebChatAPIContext2.default)(), language = _useWebChatAPIContext.language;
    var localizedStrings = (0, $7da642e04dc60b63$var$_useLocalizedStrings.default)();
    if (options === "speech") return [
        localizedStrings.SPEECH_LANGUAGE || language
    ];
    return [
        language
    ];
}

});
parcelRequire.register("eOdCk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $ac804c4c5834aea7$var$useLocalizedStrings;

var $ac804c4c5834aea7$var$_useWebChatAPIContext2 = $ac804c4c5834aea7$var$_interopRequireDefault((parcelRequire("iJOsw")));
function $ac804c4c5834aea7$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $ac804c4c5834aea7$var$useLocalizedStrings() {
    var _useWebChatAPIContext = (0, $ac804c4c5834aea7$var$_useWebChatAPIContext2.default)(), localizedStrings = _useWebChatAPIContext.localizedStrings;
    return localizedStrings;
}

});



parcelRequire.register("e9Pg5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $a4e9aad05070a951$var$useDisabled;

var $a4e9aad05070a951$var$_useWebChatAPIContext = $a4e9aad05070a951$var$_interopRequireDefault((parcelRequire("iJOsw")));
function $a4e9aad05070a951$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $a4e9aad05070a951$var$useDisabled() {
    return [
        (0, $a4e9aad05070a951$var$_useWebChatAPIContext.default)().disabled
    ];
}

});

parcelRequire.register("lhEh6", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $f7ea6d431ed9c661$var$useDismissNotification;

var $f7ea6d431ed9c661$var$_useWebChatAPIContext = $f7ea6d431ed9c661$var$_interopRequireDefault((parcelRequire("iJOsw")));
function $f7ea6d431ed9c661$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $f7ea6d431ed9c661$var$useDismissNotification() {
    return (0, $f7ea6d431ed9c661$var$_useWebChatAPIContext.default)().dismissNotification;
}

});

parcelRequire.register("6aSFV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $47ee169ac0f74a52$var$useEmitTypingIndicator;

var $47ee169ac0f74a52$var$_useWebChatAPIContext = $47ee169ac0f74a52$var$_interopRequireDefault((parcelRequire("iJOsw")));
function $47ee169ac0f74a52$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $47ee169ac0f74a52$var$useEmitTypingIndicator() {
    return (0, $47ee169ac0f74a52$var$_useWebChatAPIContext.default)().emitTypingIndicator;
}

});

parcelRequire.register("1vzZN", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $11949bb20388c351$var$_useGetActivityByKey = $11949bb20388c351$var$_interopRequireDefault((parcelRequire("hEJKt")));
function $11949bb20388c351$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $11949bb20388c351$var$_default = $11949bb20388c351$var$_useGetActivityByKey.default;
module.exports.default = $11949bb20388c351$var$_default;

});
parcelRequire.register("hEJKt", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $cda9a8cc193b454b$var$useGetActivityByKey;

var $cda9a8cc193b454b$var$_useContext = $cda9a8cc193b454b$var$_interopRequireDefault((parcelRequire("bR8cL")));
function $cda9a8cc193b454b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $cda9a8cc193b454b$var$useGetActivityByKey() {
    return (0, $cda9a8cc193b454b$var$_useContext.default)().getActivityByKey;
}

});


parcelRequire.register("6JDE4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4e75b2ca25365623$var$_useGetHasAcknowledgedByActivityKey = $4e75b2ca25365623$var$_interopRequireDefault((parcelRequire("g0saI")));
function $4e75b2ca25365623$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $4e75b2ca25365623$var$_default = $4e75b2ca25365623$var$_useGetHasAcknowledgedByActivityKey.default;
module.exports.default = $4e75b2ca25365623$var$_default;

});
parcelRequire.register("g0saI", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $ba727fca412bc53b$var$useGetHasAcknoweledgedByActivityKey;

var $ba727fca412bc53b$var$_useContext = $ba727fca412bc53b$var$_interopRequireDefault((parcelRequire("6Lcxt")));
function $ba727fca412bc53b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $ba727fca412bc53b$var$useGetHasAcknoweledgedByActivityKey() {
    return (0, $ba727fca412bc53b$var$_useContext.default)().getHasAcknowledgedByActivityKey;
}

});


parcelRequire.register("iJk3o", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $da2bfc356204d2b0$var$_useGetKeyByActivityId = $da2bfc356204d2b0$var$_interopRequireDefault((parcelRequire("gRenS")));
function $da2bfc356204d2b0$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $da2bfc356204d2b0$var$_default = $da2bfc356204d2b0$var$_useGetKeyByActivityId.default;
module.exports.default = $da2bfc356204d2b0$var$_default;

});
parcelRequire.register("gRenS", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $c45cc0f73a731809$var$useGetKeyByActivityId;

var $c45cc0f73a731809$var$_useContext = $c45cc0f73a731809$var$_interopRequireDefault((parcelRequire("bR8cL")));
function $c45cc0f73a731809$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $c45cc0f73a731809$var$useGetKeyByActivityId() {
    return (0, $c45cc0f73a731809$var$_useContext.default)().getKeyByActivityId;
}

});


parcelRequire.register("jjkwr", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $e0efb5f7f16e668a$var$useGetSendTimeoutForActivity;

var $eO7Kz = parcelRequire("eO7Kz");

var $e0efb5f7f16e668a$var$_useStyleOptions3 = $e0efb5f7f16e668a$var$_interopRequireDefault((parcelRequire("fvJx2")));
function $e0efb5f7f16e668a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $e0efb5f7f16e668a$var$_slicedToArray(arr, i) {
    return $e0efb5f7f16e668a$var$_arrayWithHoles(arr) || $e0efb5f7f16e668a$var$_iterableToArrayLimit(arr, i) || $e0efb5f7f16e668a$var$_unsupportedIterableToArray(arr, i) || $e0efb5f7f16e668a$var$_nonIterableRest();
}
function $e0efb5f7f16e668a$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $e0efb5f7f16e668a$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $e0efb5f7f16e668a$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $e0efb5f7f16e668a$var$_arrayLikeToArray(o, minLen);
}
function $e0efb5f7f16e668a$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $e0efb5f7f16e668a$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $e0efb5f7f16e668a$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $e0efb5f7f16e668a$var$useGetSendTimeoutForActivity() {
    var _useStyleOptions = (0, $e0efb5f7f16e668a$var$_useStyleOptions3.default)(), _useStyleOptions2 = $e0efb5f7f16e668a$var$_slicedToArray(_useStyleOptions, 1), _useStyleOptions2$ = _useStyleOptions2[0], sendTimeout = _useStyleOptions2$.sendTimeout, sendTimeoutForAttachments = _useStyleOptions2$.sendTimeoutForAttachments;
    return (0, $eO7Kz.useMemo)(function() {
        return function(_ref) {
            var _activity$attachments;
            var activity = _ref.activity;
            if (typeof sendTimeout === "function") return sendTimeout(activity);
            return activity.type === "message" && (_activity$attachments = activity.attachments) !== null && _activity$attachments !== void 0 && _activity$attachments.length ? sendTimeoutForAttachments : sendTimeout;
        };
    }, [
        sendTimeout,
        sendTimeoutForAttachments
    ]);
}

});

parcelRequire.register("czu2f", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $92700d50f9444c0f$var$useGrammars;

var $92700d50f9444c0f$var$_useWebChatAPIContext = $92700d50f9444c0f$var$_interopRequireDefault((parcelRequire("iJOsw")));
function $92700d50f9444c0f$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $92700d50f9444c0f$var$useGrammars() {
    return [
        (0, $92700d50f9444c0f$var$_useWebChatAPIContext.default)().grammars
    ];
}

});

parcelRequire.register("2UqqE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $21e54ff27242d89d$var$useGroupActivities;

var $21e54ff27242d89d$var$_useWebChatAPIContext = $21e54ff27242d89d$var$_interopRequireDefault((parcelRequire("iJOsw")));
function $21e54ff27242d89d$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $21e54ff27242d89d$var$useGroupActivities() {
    return (0, $21e54ff27242d89d$var$_useWebChatAPIContext.default)().groupActivities;
}

});

parcelRequire.register("iW4GA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $dc914744729cb14c$var$useGroupTimestamp;

var $dc914744729cb14c$var$_useStyleOptions3 = $dc914744729cb14c$var$_interopRequireDefault((parcelRequire("fvJx2")));
function $dc914744729cb14c$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $dc914744729cb14c$var$_slicedToArray(arr, i) {
    return $dc914744729cb14c$var$_arrayWithHoles(arr) || $dc914744729cb14c$var$_iterableToArrayLimit(arr, i) || $dc914744729cb14c$var$_unsupportedIterableToArray(arr, i) || $dc914744729cb14c$var$_nonIterableRest();
}
function $dc914744729cb14c$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $dc914744729cb14c$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $dc914744729cb14c$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $dc914744729cb14c$var$_arrayLikeToArray(o, minLen);
}
function $dc914744729cb14c$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $dc914744729cb14c$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $dc914744729cb14c$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $dc914744729cb14c$var$useGroupTimestamp() {
    var _useStyleOptions = (0, $dc914744729cb14c$var$_useStyleOptions3.default)(), _useStyleOptions2 = $dc914744729cb14c$var$_slicedToArray(_useStyleOptions, 1), groupTimestamp = _useStyleOptions2[0].groupTimestamp;
    return [
        groupTimestamp
    ];
}

});

parcelRequire.register("b0u7Y", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $803710884a2a361d$var$_useLastAcknowledgedActivityKey = $803710884a2a361d$var$_interopRequireDefault((parcelRequire("l3nZc")));
function $803710884a2a361d$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $803710884a2a361d$var$_default = $803710884a2a361d$var$_useLastAcknowledgedActivityKey.default;
module.exports.default = $803710884a2a361d$var$_default;

});
parcelRequire.register("l3nZc", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $f53c7beb5fd8af28$var$useLastAcknowledgedActivityKey;

var $f53c7beb5fd8af28$var$_useContext = $f53c7beb5fd8af28$var$_interopRequireDefault((parcelRequire("6Lcxt")));
function $f53c7beb5fd8af28$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $f53c7beb5fd8af28$var$useLastAcknowledgedActivityKey() {
    return (0, $f53c7beb5fd8af28$var$_useContext.default)().lastAcknowledgedActivityKeyState;
}

});


parcelRequire.register("9otH1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6d6d6353ff5a1722$var$_useLastReadActivityKey = $6d6d6353ff5a1722$var$_interopRequireDefault((parcelRequire("2WkYr")));
function $6d6d6353ff5a1722$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $6d6d6353ff5a1722$var$_default = $6d6d6353ff5a1722$var$_useLastReadActivityKey.default;
module.exports.default = $6d6d6353ff5a1722$var$_default;

});
parcelRequire.register("2WkYr", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $22414481c8bd66a6$var$useLastReadActivityKey;

var $22414481c8bd66a6$var$_useContext = $22414481c8bd66a6$var$_interopRequireDefault((parcelRequire("6Lcxt")));
function $22414481c8bd66a6$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $22414481c8bd66a6$var$useLastReadActivityKey() {
    return (0, $22414481c8bd66a6$var$_useContext.default)().lastReadActivityKeyState;
}

});


parcelRequire.register("2IAYP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $1fac60520fee9491$var$useLocalizer;

var $cG9B9 = parcelRequire("cG9B9");

var $eO7Kz = parcelRequire("eO7Kz");

var $1fac60520fee9491$var$_getAllLocalizedStrings = $1fac60520fee9491$var$_interopRequireDefault((parcelRequire("k99nF")));

var $1fac60520fee9491$var$_useLocalizedGlobalize = $1fac60520fee9491$var$_interopRequireDefault((parcelRequire("bOdWr")));

var $1fac60520fee9491$var$_useLocalizedStrings = $1fac60520fee9491$var$_interopRequireDefault((parcelRequire("eOdCk")));

var $1fac60520fee9491$var$_isObject = $1fac60520fee9491$var$_interopRequireDefault((parcelRequire("cmMIo")));
function $1fac60520fee9491$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $1fac60520fee9491$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $1fac60520fee9491$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $1fac60520fee9491$var$_typeof(obj);
}
function $1fac60520fee9491$var$_slicedToArray(arr, i) {
    return $1fac60520fee9491$var$_arrayWithHoles(arr) || $1fac60520fee9491$var$_iterableToArrayLimit(arr, i) || $1fac60520fee9491$var$_unsupportedIterableToArray(arr, i) || $1fac60520fee9491$var$_nonIterableRest();
}
function $1fac60520fee9491$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $1fac60520fee9491$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $1fac60520fee9491$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $1fac60520fee9491$var$_arrayLikeToArray(o, minLen);
}
function $1fac60520fee9491$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $1fac60520fee9491$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $1fac60520fee9491$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
var $1fac60520fee9491$var$DEFAULT_STRINGS = (0, $1fac60520fee9491$var$_getAllLocalizedStrings.default)()["en-US"];
function $1fac60520fee9491$var$useLocalizer() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, plural = _ref.plural;
    var _useLocalizedGlobaliz = (0, $1fac60520fee9491$var$_useLocalizedGlobalize.default)(), _useLocalizedGlobaliz2 = $1fac60520fee9491$var$_slicedToArray(_useLocalizedGlobaliz, 1), globalize = _useLocalizedGlobaliz2[0];
    var localizedStrings = (0, $1fac60520fee9491$var$_useLocalizedStrings.default)();
    return (0, $eO7Kz.useCallback)(function(id) {
        var stringId = id;
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
        if (plural) {
            var pluralId = id;
            if (!(0, $1fac60520fee9491$var$_isObject.default)(pluralId)) throw new Error('useLocalizer: Plural string must pass "id" as a map instead of string.');
            else if (typeof pluralId.other !== "string") throw new Error('useLocalizer: Plural string must have "id.other" of string.');
            else if (typeof args[0] !== "number") throw new Error("useLocalizer: Plural string must have first argument as a number.");
            for(var _i2 = 0, _arr2 = [
                "zero",
                "one",
                "two",
                "few",
                "many"
            ]; _i2 < _arr2.length; _i2++){
                var pluralForm = _arr2[_i2];
                // Mitigation through allowlisting.
                // eslint-disable-next-line security/detect-object-injection
                var type = $1fac60520fee9491$var$_typeof(id[pluralForm]);
                if (type !== "string" && type !== "undefined") throw new Error('useLocalizer: Plural string must have "id.'.concat(pluralForm, '" of string or undefined.'));
            }
            var unsupportedPluralForms = Object.keys(id).filter(function(pluralForm) {
                return ![
                    "zero",
                    "one",
                    "two",
                    "few",
                    "many",
                    "other"
                ].includes(pluralForm);
            });
            if (unsupportedPluralForms.length) throw new Error('useLocalizer: Plural string "id" must be either "zero", "one", "two", "few", "many", "other". But not '.concat(unsupportedPluralForms.map(function(pluralForm) {
                return '"'.concat(pluralForm, '"');
            }).join(", "), "."));
            stringId = pluralId[globalize.plural(args[0])] || pluralId.other;
        } else if (typeof id !== "string") throw new Error('useLocalizer: "id" must be a string.');
        return Object.entries(args).reduce(function(str, _ref2) {
            var _ref3 = $1fac60520fee9491$var$_slicedToArray(_ref2, 2), index = _ref3[0], arg = _ref3[1];
            return str.replace("$".concat(+index + 1), arg);
        }, // eslint-disable-next-line security/detect-object-injection
        (0, $cG9B9.isForbiddenPropertyName)(stringId) ? "" : localizedStrings[stringId] || $1fac60520fee9491$var$DEFAULT_STRINGS[stringId] || "");
    }, [
        globalize,
        localizedStrings,
        plural
    ]);
}

});
parcelRequire.register("cmMIo", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $900d53e63f19f6a2$var$isObject;
var $900d53e63f19f6a2$var$_ref = {}, $900d53e63f19f6a2$var$toString = $900d53e63f19f6a2$var$_ref.toString;
function $900d53e63f19f6a2$var$isObject(obj) {
    return $900d53e63f19f6a2$var$toString.call(obj) === "[object Object]";
}

});


parcelRequire.register("8ElhC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $64c29191c4de5903$var$useMarkActivityAsSpoken;

var $eO7Kz = parcelRequire("eO7Kz");

var $64c29191c4de5903$var$_useMarkActivity = $64c29191c4de5903$var$_interopRequireDefault((parcelRequire("kor76")));
function $64c29191c4de5903$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $64c29191c4de5903$var$useMarkActivityAsSpoken() {
    var markActivity = (0, $64c29191c4de5903$var$_useMarkActivity.default)();
    return (0, $eO7Kz.useCallback)(function(activity) {
        return markActivity(activity, "speak", false);
    }, [
        markActivity
    ]);
}

});
parcelRequire.register("kor76", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $ed8b14b67fdbe488$var$useMarkActivity;

var $ed8b14b67fdbe488$var$_useWebChatAPIContext = $ed8b14b67fdbe488$var$_interopRequireDefault((parcelRequire("iJOsw")));
function $ed8b14b67fdbe488$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $ed8b14b67fdbe488$var$useMarkActivity() {
    return (0, $ed8b14b67fdbe488$var$_useWebChatAPIContext.default)().markActivity;
}

});


parcelRequire.register("joSJM", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e1fab7ea68da9af0$var$_useMarkActivityKeyAsRead = $e1fab7ea68da9af0$var$_interopRequireDefault((parcelRequire("3wdBo")));
function $e1fab7ea68da9af0$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $e1fab7ea68da9af0$var$_default = $e1fab7ea68da9af0$var$_useMarkActivityKeyAsRead.default;
module.exports.default = $e1fab7ea68da9af0$var$_default;

});
parcelRequire.register("3wdBo", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $28fee95d83758aff$var$useMarkActivityKeyAsRead;

var $28fee95d83758aff$var$_useContext = $28fee95d83758aff$var$_interopRequireDefault((parcelRequire("6Lcxt")));
function $28fee95d83758aff$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $28fee95d83758aff$var$useMarkActivityKeyAsRead() {
    return (0, $28fee95d83758aff$var$_useContext.default)().markActivityKeyAsRead;
}

});


parcelRequire.register("5c4UP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3c81e2e2ed2ce41a$var$_useMarkAllAsAcknowledged = $3c81e2e2ed2ce41a$var$_interopRequireDefault((parcelRequire("bJaIQ")));
function $3c81e2e2ed2ce41a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $3c81e2e2ed2ce41a$var$_default = $3c81e2e2ed2ce41a$var$_useMarkAllAsAcknowledged.default;
module.exports.default = $3c81e2e2ed2ce41a$var$_default;

});
parcelRequire.register("bJaIQ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $889c36eb13860477$var$useMarkAllAsAcknowledged;

var $889c36eb13860477$var$_useContext = $889c36eb13860477$var$_interopRequireDefault((parcelRequire("6Lcxt")));
function $889c36eb13860477$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $889c36eb13860477$var$useMarkAllAsAcknowledged() {
    return (0, $889c36eb13860477$var$_useContext.default)().markAllAsAcknowledged;
}

});


parcelRequire.register("2Pnkq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $20f270bf772b2ff2$var$usePerformCardAction;

var $20f270bf772b2ff2$var$_useWebChatAPIContext = $20f270bf772b2ff2$var$_interopRequireDefault((parcelRequire("iJOsw")));
function $20f270bf772b2ff2$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $20f270bf772b2ff2$var$usePerformCardAction() {
    return (0, $20f270bf772b2ff2$var$_useWebChatAPIContext.default)().onCardAction;
}

});

parcelRequire.register("lONRC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $fe24f26c8a82718d$var$usePostActivity;

var $fe24f26c8a82718d$var$_useWebChatAPIContext = $fe24f26c8a82718d$var$_interopRequireDefault((parcelRequire("iJOsw")));
function $fe24f26c8a82718d$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $fe24f26c8a82718d$var$usePostActivity() {
    return (0, $fe24f26c8a82718d$var$_useWebChatAPIContext.default)().postActivity;
}

});

parcelRequire.register("5V3T4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $44f54a900ce90d7b$var$useReferenceGrammarID;

var $kSc9m = parcelRequire("kSc9m");
function $44f54a900ce90d7b$var$useReferenceGrammarID() {
    return [
        (0, $kSc9m.useSelector)(function(_ref) {
            var referenceGrammarID = _ref.referenceGrammarID;
            return referenceGrammarID;
        })
    ];
}

});

parcelRequire.register("3hnUi", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $26358113bf6c6757$var$useRelativeTimeFormatter;

var $eO7Kz = parcelRequire("eO7Kz");

var $26358113bf6c6757$var$_useDateFormatter = $26358113bf6c6757$var$_interopRequireDefault((parcelRequire("hl4fj")));

var $26358113bf6c6757$var$_useLocalizedGlobalize = $26358113bf6c6757$var$_interopRequireDefault((parcelRequire("bOdWr")));

var $26358113bf6c6757$var$_useLocalizer = $26358113bf6c6757$var$_interopRequireDefault((parcelRequire("2IAYP")));

var $26358113bf6c6757$var$_usePonyfill3 = $26358113bf6c6757$var$_interopRequireDefault((parcelRequire("44MU5")));
function $26358113bf6c6757$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $26358113bf6c6757$var$_slicedToArray(arr, i) {
    return $26358113bf6c6757$var$_arrayWithHoles(arr) || $26358113bf6c6757$var$_iterableToArrayLimit(arr, i) || $26358113bf6c6757$var$_unsupportedIterableToArray(arr, i) || $26358113bf6c6757$var$_nonIterableRest();
}
function $26358113bf6c6757$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $26358113bf6c6757$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $26358113bf6c6757$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $26358113bf6c6757$var$_arrayLikeToArray(o, minLen);
}
function $26358113bf6c6757$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $26358113bf6c6757$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $26358113bf6c6757$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
// False positive: we are using `Date` as a type.
// eslint-disable-next-line no-restricted-globals
function $26358113bf6c6757$var$useRelativeTimeFormatter() {
    var _usePonyfill = (0, $26358113bf6c6757$var$_usePonyfill3.default)(), _usePonyfill2 = $26358113bf6c6757$var$_slicedToArray(_usePonyfill, 1), Date = _usePonyfill2[0].Date;
    var _useLocalizedGlobaliz = (0, $26358113bf6c6757$var$_useLocalizedGlobalize.default)(), _useLocalizedGlobaliz2 = $26358113bf6c6757$var$_slicedToArray(_useLocalizedGlobaliz, 1), globalize = _useLocalizedGlobaliz2[0];
    var formatDate = (0, $26358113bf6c6757$var$_useDateFormatter.default)();
    var localize = (0, $26358113bf6c6757$var$_useLocalizer.default)();
    return (0, $eO7Kz.useMemo)(function() {
        var relativeTimeFormatter = globalize.relativeTimeFormatter.bind(globalize);
        return function(dateOrString) {
            var date = new Date(dateOrString);
            var dateTime = date.getTime();
            if (isNaN(dateTime)) return dateOrString;
            var now = Date.now();
            var deltaInMs = now - dateTime;
            var deltaInMinutes = Math.floor(deltaInMs / 60000);
            var deltaInHours = Math.floor(deltaInMs / 3600000);
            if (deltaInMinutes < 1) return localize("ACTIVITY_STATUS_TIMESTAMP_JUST_NOW");
            else if (deltaInMinutes === 1) return localize("ACTIVITY_STATUS_TIMESTAMP_ONE_MINUTE_AGO");
            else if (deltaInHours < 1) return relativeTimeFormatter("minute")(-deltaInMinutes);
            else if (deltaInHours === 1) return localize("ACTIVITY_STATUS_TIMESTAMP_ONE_HOUR_AGO");
            else if (deltaInHours < 5) return relativeTimeFormatter("hour")(-deltaInHours);
            else if (deltaInHours <= 24) return localize("ACTIVITY_STATUS_TIMESTAMP_TODAY");
            else if (deltaInHours <= 48) return localize("ACTIVITY_STATUS_TIMESTAMP_YESTERDAY");
            return formatDate(date);
        };
    }, [
        Date,
        formatDate,
        globalize,
        localize
    ]);
}

});

parcelRequire.register("4ZeyW", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $3a1827bd7fd938af$var$useRenderActivity;

var $eO7Kz = parcelRequire("eO7Kz");

var $3a1827bd7fd938af$var$_useCreateActivityRendererInternal = $3a1827bd7fd938af$var$_interopRequireDefault((parcelRequire("kMzjA")));
function $3a1827bd7fd938af$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
// In the old days, the useRenderActivity() will be called like this:
//
// const renderActivity = useRenderActivity();
// const element = renderActivity({ activity, nextVisibleActivity });
// In the new days, the useCreateActivityRenderer() is a 3-pass function:
//
// const createActivityRenderer = useCreateActivityRenderer();
// const renderActivity = createActivityRenderer({ activity, nextVisibleActivity });
// const element = renderActivity && renderActivity(undefined, { renderActivityStatus, renderAvatar, showCallout });
// Despite deprecation, useRenderActivity() can be retrofitted using useCreateActivityRenderer().
var $3a1827bd7fd938af$var$showDeprecationNotes = true;
/** @deprecated Please use `useCreateActivityRenderer()` instead. */ function $3a1827bd7fd938af$var$useRenderActivity(renderAttachment) {
    if ($3a1827bd7fd938af$var$showDeprecationNotes) {
        console.warn('botframework-webchat: "useRenderActivity" is deprecated and will be removed on or after 2022-07-22. Please use "useCreateActivityRenderer()" instead.');
        $3a1827bd7fd938af$var$showDeprecationNotes = false;
    }
    if (typeof renderAttachment !== "function") throw new Error('botframework-webchat: First argument passed to "useRenderActivity" must be a function.');
    var createActivityRenderer = (0, $3a1827bd7fd938af$var$_useCreateActivityRendererInternal.default)(renderAttachment);
    return (0, $eO7Kz.useMemo)(function() {
        return function(renderActivityArg) {
            var renderOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
            var _ref = renderActivityArg || {}, activity = _ref.activity;
            if (!activity) throw new Error('botframework-webchat: First argument passed to the callback of useRenderActivity() must contain an "activity" property.');
            var renderActivity = createActivityRenderer(renderActivityArg);
            return !!renderActivity && renderActivity(renderOptions);
        };
    }, [
        createActivityRenderer
    ]);
}

});

parcelRequire.register("a5W78", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $7597733fcb2435d2$var$useRenderActivityStatus;

var $eO7Kz = parcelRequire("eO7Kz");

var $7597733fcb2435d2$var$_useCreateActivityStatusRenderer = $7597733fcb2435d2$var$_interopRequireDefault((parcelRequire("6dbay")));
function $7597733fcb2435d2$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
// Previously, useRenderActivity() was called like this:
//
// const element = useRenderActivityStatus({ activity, nextVisibleActivity });
// Now, the useCreateActivityRenderer() is a 3-pass function:
//
// const createActivityStatusRenderer = useCreateActivityStatusRenderer();
// const renderActivityStatus = createActivityStatusRenderer({ activity, hideTimestamp });
// const element = renderActivityStatus && renderActivityStatus(undefined);
// Despite deprecation, useRenderActivityStatus() can be retrofitted using useCreateActivityStatusRenderer().
var $7597733fcb2435d2$var$showDeprecationNotes = true;
/** @deprecated Please use `useCreateActivityStatusRenderer()` instead. */ function $7597733fcb2435d2$var$useRenderActivityStatus(_ref) {
    var activity = _ref.activity, nextVisibleActivity = _ref.nextVisibleActivity;
    if ($7597733fcb2435d2$var$showDeprecationNotes) {
        console.warn('botframework-webchat: "useRenderActivityStatus" is deprecated and will be removed on or after 2022-07-22. Please use "useCreateActivityStatusRenderer()" instead.');
        $7597733fcb2435d2$var$showDeprecationNotes = false;
    }
    var createActivityStatusRenderer = (0, $7597733fcb2435d2$var$_useCreateActivityStatusRenderer.default)();
    return (0, $eO7Kz.useMemo)(function() {
        var renderActivityStatus = createActivityStatusRenderer({
            activity: activity,
            nextVisibleActivity: nextVisibleActivity
        });
        return !!renderActivityStatus && renderActivityStatus;
    }, [
        activity,
        createActivityStatusRenderer,
        nextVisibleActivity
    ]);
}

});

parcelRequire.register("i6TPF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $d2f418b23b64d80a$var$useRenderAvatar;

var $d2f418b23b64d80a$var$_useCreateAvatarRenderer = $d2f418b23b64d80a$var$_interopRequireDefault((parcelRequire("50yWS")));
function $d2f418b23b64d80a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $d2f418b23b64d80a$var$showDeprecationNotes = true;
/** @deprecated Please use "useRenderAvatar()" instead. */ function $d2f418b23b64d80a$var$useRenderAvatar(_ref) {
    var activity = _ref.activity;
    if ($d2f418b23b64d80a$var$showDeprecationNotes) {
        console.warn('botframework-webchat: "useRenderAvatar" is deprecated and will be removed on or after 2022-07-28. Please use "useRenderAvatar()" instead.');
        $d2f418b23b64d80a$var$showDeprecationNotes = false;
    }
    var createAvatarRenderer = (0, $d2f418b23b64d80a$var$_useCreateAvatarRenderer.default)();
    return createAvatarRenderer({
        activity: activity
    });
}

});

parcelRequire.register("87kNX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $5e8f1d946d261ee0$var$useRenderToast;

var $5e8f1d946d261ee0$var$_useWebChatAPIContext = $5e8f1d946d261ee0$var$_interopRequireDefault((parcelRequire("iJOsw")));
function $5e8f1d946d261ee0$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $5e8f1d946d261ee0$var$useRenderToast() {
    return (0, $5e8f1d946d261ee0$var$_useWebChatAPIContext.default)().toastRenderer;
}

});

parcelRequire.register("4wysF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $34b4e1ded4d2b5b9$var$useRenderTypingIndicator;

var $34b4e1ded4d2b5b9$var$_useWebChatAPIContext = $34b4e1ded4d2b5b9$var$_interopRequireDefault((parcelRequire("iJOsw")));
function $34b4e1ded4d2b5b9$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $34b4e1ded4d2b5b9$var$useRenderTypingIndicator() {
    return (0, $34b4e1ded4d2b5b9$var$_useWebChatAPIContext.default)().typingIndicatorRenderer;
}

});

parcelRequire.register("e8zRO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $a4ada276c79a2a20$var$useSendBoxValue;

var $kSc9m = parcelRequire("kSc9m");

var $a4ada276c79a2a20$var$_useWebChatAPIContext = $a4ada276c79a2a20$var$_interopRequireDefault((parcelRequire("iJOsw")));
function $a4ada276c79a2a20$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $a4ada276c79a2a20$var$useSendBoxValue() {
    return [
        (0, $kSc9m.useSelector)(function(_ref) {
            var sendBoxValue = _ref.sendBoxValue;
            return sendBoxValue;
        }),
        (0, $a4ada276c79a2a20$var$_useWebChatAPIContext.default)().setSendBox
    ];
}

});

parcelRequire.register("fGYM8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $b6c9ebf736364a4b$var$useSendEvent;

var $b6c9ebf736364a4b$var$_useWebChatAPIContext = $b6c9ebf736364a4b$var$_interopRequireDefault((parcelRequire("iJOsw")));
function $b6c9ebf736364a4b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $b6c9ebf736364a4b$var$useSendEvent() {
    return (0, $b6c9ebf736364a4b$var$_useWebChatAPIContext.default)().sendEvent;
}

});

parcelRequire.register("8QzbZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $670e7a86be4e239d$var$useSendFiles;

var $eO7Kz = parcelRequire("eO7Kz");

var $670e7a86be4e239d$var$_useTrackEvent = $670e7a86be4e239d$var$_interopRequireDefault((parcelRequire("f6yDt")));

var $670e7a86be4e239d$var$_useWebChatAPIContext2 = $670e7a86be4e239d$var$_interopRequireDefault((parcelRequire("iJOsw")));
function $670e7a86be4e239d$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/* eslint no-magic-numbers: ["error", { "ignore": [0, 1024] }] */ function $670e7a86be4e239d$var$useSendFiles() {
    var _useWebChatAPIContext = (0, $670e7a86be4e239d$var$_useWebChatAPIContext2.default)(), sendFiles = _useWebChatAPIContext.sendFiles;
    var trackEvent = (0, $670e7a86be4e239d$var$_useTrackEvent.default)();
    return (0, $eO7Kz.useCallback)(function(files) {
        if (files && files.length) {
            sendFiles(files);
            trackEvent("sendFiles", {
                numFiles: files.length,
                sumSizeInKB: Math.round(files.reduce(function(total, _ref) {
                    var size = _ref.size;
                    return total + size;
                }, 0) / 1024)
            });
        }
    }, [
        sendFiles,
        trackEvent
    ]);
}

});
parcelRequire.register("f6yDt", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $aff2487a2c7108a1$var$useTrackEvent;

var $eO7Kz = parcelRequire("eO7Kz");

var $aff2487a2c7108a1$var$_createCustomEvent = $aff2487a2c7108a1$var$_interopRequireDefault((parcelRequire("cViyF")));

var $aff2487a2c7108a1$var$_isObject = $aff2487a2c7108a1$var$_interopRequireDefault((parcelRequire("cmMIo")));

var $aff2487a2c7108a1$var$_useReadTelemetryDimensions = $aff2487a2c7108a1$var$_interopRequireDefault((parcelRequire("1TnPI")));

var $aff2487a2c7108a1$var$_useWebChatAPIContext2 = $aff2487a2c7108a1$var$_interopRequireDefault((parcelRequire("iJOsw")));
function $aff2487a2c7108a1$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $aff2487a2c7108a1$var$isNonNegativeFiniteNumberOrString(value) {
    return typeof value === "number" && isFinite(value) && value >= 0 || typeof value === "string";
}
function $aff2487a2c7108a1$var$useTrackEvent() {
    var _useWebChatAPIContext = (0, $aff2487a2c7108a1$var$_useWebChatAPIContext2.default)(), onTelemetry = _useWebChatAPIContext.onTelemetry;
    var readTelemetryDimensions = (0, $aff2487a2c7108a1$var$_useReadTelemetryDimensions.default)();
    var trackEvent = (0, $eO7Kz.useCallback)(function(level, name, data) {
        if (!name || typeof name !== "string") return console.warn('botframework-webchat: "name" passed to "useTrackEvent" hook must be a string.');
        if (typeof data !== "undefined") {
            if ((0, $aff2487a2c7108a1$var$_isObject.default)(data)) {
                if (!Object.values(data).every(function(value) {
                    return $aff2487a2c7108a1$var$isNonNegativeFiniteNumberOrString(value);
                })) return console.warn('botframework-webchat: Every value in "data" map passed to "useTrackEvent" hook must be a non-negative finite number or string.');
            } else if (!$aff2487a2c7108a1$var$isNonNegativeFiniteNumberOrString(data)) return console.warn('botframework-webchat: "data" passed to "useTrackEvent" hook must be a non-negative finite number or string.');
        }
        onTelemetry && onTelemetry((0, $aff2487a2c7108a1$var$_createCustomEvent.default)("event", {
            data: data,
            dimensions: readTelemetryDimensions(),
            level: level,
            name: name
        }));
    }, [
        onTelemetry,
        readTelemetryDimensions
    ]);
    return (0, $eO7Kz.useMemo)(function() {
        var info = trackEvent.bind(null, "info");
        info.debug = trackEvent.bind(null, "debug");
        info.error = trackEvent.bind(null, "error");
        info.info = info;
        info.warn = trackEvent.bind(null, "warn");
        return info;
    }, [
        trackEvent
    ]);
}

});
parcelRequire.register("cViyF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $9689342fcad80067$var$createCustomEvent;

var $cG9B9 = parcelRequire("cG9B9");
function $9689342fcad80067$var$_slicedToArray(arr, i) {
    return $9689342fcad80067$var$_arrayWithHoles(arr) || $9689342fcad80067$var$_iterableToArrayLimit(arr, i) || $9689342fcad80067$var$_unsupportedIterableToArray(arr, i) || $9689342fcad80067$var$_nonIterableRest();
}
function $9689342fcad80067$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $9689342fcad80067$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $9689342fcad80067$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $9689342fcad80067$var$_arrayLikeToArray(o, minLen);
}
function $9689342fcad80067$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $9689342fcad80067$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $9689342fcad80067$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $9689342fcad80067$var$createCustomEvent(name, eventInitDict) {
    var event;
    if (typeof CustomEvent === "function") event = new CustomEvent(name);
    else {
        event = document.createEvent("Event");
        event.initEvent(name, true, true);
    }
    Object.entries(eventInitDict).forEach(function(_ref) {
        var _ref2 = $9689342fcad80067$var$_slicedToArray(_ref, 2), key = _ref2[0], value = _ref2[1];
        if (!(0, $cG9B9.isForbiddenPropertyName)(key)) // Mitigation through denylisting.
        // eslint-disable-next-line security/detect-object-injection
        event[key] = value;
    });
    return event;
}

});

parcelRequire.register("1TnPI", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $160d6a3d24b3b651$var$useReadTelemetryDimensions;

var $eO7Kz = parcelRequire("eO7Kz");

var $160d6a3d24b3b651$var$_useWebChatAPIContext2 = $160d6a3d24b3b651$var$_interopRequireDefault((parcelRequire("iJOsw")));
function $160d6a3d24b3b651$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $160d6a3d24b3b651$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $160d6a3d24b3b651$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $160d6a3d24b3b651$var$ownKeys(Object(source), !0).forEach(function(key) {
            $160d6a3d24b3b651$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $160d6a3d24b3b651$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $160d6a3d24b3b651$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $160d6a3d24b3b651$var$useReadTelemetryDimensions() {
    var _useWebChatAPIContext = (0, $160d6a3d24b3b651$var$_useWebChatAPIContext2.default)(), telemetryDimensionsRef = _useWebChatAPIContext.telemetryDimensionsRef;
    return (0, $eO7Kz.useCallback)(function() {
        return $160d6a3d24b3b651$var$_objectSpread({}, telemetryDimensionsRef.current);
    }, [
        telemetryDimensionsRef
    ]);
}

});



parcelRequire.register("iG8sS", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $d992b727bc013ade$var$useSendMessage;

var $d992b727bc013ade$var$_useWebChatAPIContext = $d992b727bc013ade$var$_interopRequireDefault((parcelRequire("iJOsw")));
function $d992b727bc013ade$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $d992b727bc013ade$var$useSendMessage() {
    return (0, $d992b727bc013ade$var$_useWebChatAPIContext.default)().sendMessage;
}

});

parcelRequire.register("gkv00", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $be368f5d2ac59acf$var$useSendMessageBack;

var $be368f5d2ac59acf$var$_useWebChatAPIContext = $be368f5d2ac59acf$var$_interopRequireDefault((parcelRequire("iJOsw")));
function $be368f5d2ac59acf$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $be368f5d2ac59acf$var$useSendMessageBack() {
    return (0, $be368f5d2ac59acf$var$_useWebChatAPIContext.default)().sendMessageBack;
}

});

parcelRequire.register("k6309", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $ea16b2340e3e8128$var$useSendPostBack;

var $ea16b2340e3e8128$var$_useWebChatAPIContext = $ea16b2340e3e8128$var$_interopRequireDefault((parcelRequire("iJOsw")));
function $ea16b2340e3e8128$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $ea16b2340e3e8128$var$useSendPostBack() {
    return (0, $ea16b2340e3e8128$var$_useWebChatAPIContext.default)().sendPostBack;
}

});

parcelRequire.register("cieis", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $8f32417fe750f78e$var$useSendTimeoutForActivity;

var $8f32417fe750f78e$var$_useGetSendTimeoutForActivity = $8f32417fe750f78e$var$_interopRequireDefault((parcelRequire("jjkwr")));
function $8f32417fe750f78e$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $8f32417fe750f78e$var$showDeprecationNotes = true;
/** @deprecated Please use "useGetSendTimeoutForActivity()" instead. */ function $8f32417fe750f78e$var$useSendTimeoutForActivity(activity) {
    if ($8f32417fe750f78e$var$showDeprecationNotes) {
        console.warn('botframework-webchat: "useSendTimeoutForActivity" is deprecated and will be removed on or after 2022-07-28. Please use "useGetSendTimeoutForActivity()" instead.');
        $8f32417fe750f78e$var$showDeprecationNotes = false;
    }
    var getSendTimeoutForActivity = (0, $8f32417fe750f78e$var$_useGetSendTimeoutForActivity.default)();
    return getSendTimeoutForActivity({
        activity: activity
    });
}

});

parcelRequire.register("kBjvJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $eff665c9cf10d084$var$useSendTypingIndicator;

var $kSc9m = parcelRequire("kSc9m");
function $eff665c9cf10d084$var$useSendTypingIndicator() {
    return [
        (0, $kSc9m.useSelector)(function(_ref) {
            var sendTypingIndicator = _ref.sendTypingIndicator;
            return sendTypingIndicator;
        })
    ];
}

});

parcelRequire.register("CsY1S", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $073a0502733a45e8$var$useSetNotification;

var $073a0502733a45e8$var$_useWebChatAPIContext = $073a0502733a45e8$var$_interopRequireDefault((parcelRequire("iJOsw")));
function $073a0502733a45e8$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $073a0502733a45e8$var$useSetNotification() {
    return (0, $073a0502733a45e8$var$_useWebChatAPIContext.default)().setNotification;
}

});

parcelRequire.register("gXEVs", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $c591e70713393f8d$var$useShouldSpeakIncomingActivity;

var $eO7Kz = parcelRequire("eO7Kz");

var $kSc9m = parcelRequire("kSc9m");

var $c591e70713393f8d$var$_useWebChatAPIContext2 = $c591e70713393f8d$var$_interopRequireDefault((parcelRequire("iJOsw")));
function $c591e70713393f8d$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $c591e70713393f8d$var$useShouldSpeakIncomingActivity() {
    var _useWebChatAPIContext = (0, $c591e70713393f8d$var$_useWebChatAPIContext2.default)(), startSpeakingActivity = _useWebChatAPIContext.startSpeakingActivity, stopSpeakingActivity = _useWebChatAPIContext.stopSpeakingActivity;
    return [
        (0, $kSc9m.useSelector)(function(_ref) {
            var shouldSpeakIncomingActivity = _ref.shouldSpeakIncomingActivity;
            return shouldSpeakIncomingActivity;
        }),
        (0, $eO7Kz.useCallback)(function(value) {
            value ? startSpeakingActivity() : stopSpeakingActivity();
        }, [
            startSpeakingActivity,
            stopSpeakingActivity
        ])
    ];
}

});

parcelRequire.register("dyPiT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $9df63f2ffff57cb4$var$useStartDictate;

var $9df63f2ffff57cb4$var$_useWebChatAPIContext = $9df63f2ffff57cb4$var$_interopRequireDefault((parcelRequire("iJOsw")));
function $9df63f2ffff57cb4$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $9df63f2ffff57cb4$var$useStartDictate() {
    return (0, $9df63f2ffff57cb4$var$_useWebChatAPIContext.default)().startDictate;
}

});

parcelRequire.register("luOtz", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $fa638dcb5d094cb0$var$useStopDictate;

var $fa638dcb5d094cb0$var$_useWebChatAPIContext = $fa638dcb5d094cb0$var$_interopRequireDefault((parcelRequire("iJOsw")));
function $fa638dcb5d094cb0$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $fa638dcb5d094cb0$var$useStopDictate() {
    return (0, $fa638dcb5d094cb0$var$_useWebChatAPIContext.default)().stopDictate;
}

});

parcelRequire.register("14JZO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $0c89d8069fbb74e2$var$useSubmitSendBox;

var $eO7Kz = parcelRequire("eO7Kz");

var $0c89d8069fbb74e2$var$_useTrackEvent = $0c89d8069fbb74e2$var$_interopRequireDefault((parcelRequire("f6yDt")));

var $0c89d8069fbb74e2$var$_useWebChatAPIContext2 = $0c89d8069fbb74e2$var$_interopRequireDefault((parcelRequire("iJOsw")));
function $0c89d8069fbb74e2$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $0c89d8069fbb74e2$var$useSubmitSendBox() {
    var _useWebChatAPIContext = (0, $0c89d8069fbb74e2$var$_useWebChatAPIContext2.default)(), submitSendBox = _useWebChatAPIContext.submitSendBox;
    var trackEvent = (0, $0c89d8069fbb74e2$var$_useTrackEvent.default)();
    return (0, $eO7Kz.useCallback)(function(method) {
        var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {}, channelData = _ref.channelData;
        trackEvent("submitSendBox", method);
        return submitSendBox(method, channelData && {
            channelData: channelData
        });
    }, [
        submitSendBox,
        trackEvent
    ]);
}

});

parcelRequire.register("2cUUK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $19b8d9c5e154280d$var$useSuggestedActions;

var $eO7Kz = parcelRequire("eO7Kz");

var $kSc9m = parcelRequire("kSc9m");

var $19b8d9c5e154280d$var$_useWebChatAPIContext2 = $19b8d9c5e154280d$var$_interopRequireDefault((parcelRequire("iJOsw")));
function $19b8d9c5e154280d$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $19b8d9c5e154280d$var$useSuggestedActions() {
    var value = (0, $kSc9m.useSelector)(function(_ref) {
        var suggestedActions = _ref.suggestedActions;
        return suggestedActions;
    });
    var _useWebChatAPIContext = (0, $19b8d9c5e154280d$var$_useWebChatAPIContext2.default)(), clearSuggestedActions = _useWebChatAPIContext.clearSuggestedActions;
    return [
        value,
        (0, $eO7Kz.useCallback)(function(value) {
            if (value && value.length) throw new Error("SuggestedActions cannot be set to values other than empty.");
            clearSuggestedActions();
        }, [
            clearSuggestedActions
        ])
    ];
}

});

parcelRequire.register("9umIc", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $6e88887d8e5652fd$var$useTimeoutForSend;

var $6e88887d8e5652fd$var$_useStyleOptions3 = $6e88887d8e5652fd$var$_interopRequireDefault((parcelRequire("fvJx2")));
function $6e88887d8e5652fd$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $6e88887d8e5652fd$var$_slicedToArray(arr, i) {
    return $6e88887d8e5652fd$var$_arrayWithHoles(arr) || $6e88887d8e5652fd$var$_iterableToArrayLimit(arr, i) || $6e88887d8e5652fd$var$_unsupportedIterableToArray(arr, i) || $6e88887d8e5652fd$var$_nonIterableRest();
}
function $6e88887d8e5652fd$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $6e88887d8e5652fd$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $6e88887d8e5652fd$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $6e88887d8e5652fd$var$_arrayLikeToArray(o, minLen);
}
function $6e88887d8e5652fd$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $6e88887d8e5652fd$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $6e88887d8e5652fd$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $6e88887d8e5652fd$var$useTimeoutForSend() {
    var _useStyleOptions = (0, $6e88887d8e5652fd$var$_useStyleOptions3.default)(), _useStyleOptions2 = $6e88887d8e5652fd$var$_slicedToArray(_useStyleOptions, 1), sendTimeout = _useStyleOptions2[0].sendTimeout;
    return [
        sendTimeout
    ];
}

});

parcelRequire.register("hg8oI", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $c90a71e1a8123e2a$var$useTrackDimension;

var $c90a71e1a8123e2a$var$_useWebChatAPIContext2 = $c90a71e1a8123e2a$var$_interopRequireDefault((parcelRequire("iJOsw")));
function $c90a71e1a8123e2a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $c90a71e1a8123e2a$var$useTrackDimension() {
    var _useWebChatAPIContext = (0, $c90a71e1a8123e2a$var$_useWebChatAPIContext2.default)(), trackDimension = _useWebChatAPIContext.trackDimension;
    return trackDimension;
}

});

parcelRequire.register("icwbb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $d4024f23ac1e625e$var$useTrackException;

var $eO7Kz = parcelRequire("eO7Kz");

var $d4024f23ac1e625e$var$_createCustomEvent = $d4024f23ac1e625e$var$_interopRequireDefault((parcelRequire("cViyF")));

var $d4024f23ac1e625e$var$_useReadTelemetryDimensions = $d4024f23ac1e625e$var$_interopRequireDefault((parcelRequire("1TnPI")));

var $d4024f23ac1e625e$var$_useWebChatAPIContext2 = $d4024f23ac1e625e$var$_interopRequireDefault((parcelRequire("iJOsw")));
function $d4024f23ac1e625e$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $d4024f23ac1e625e$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $d4024f23ac1e625e$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $d4024f23ac1e625e$var$ownKeys(Object(source), !0).forEach(function(key) {
            $d4024f23ac1e625e$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $d4024f23ac1e625e$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $d4024f23ac1e625e$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $d4024f23ac1e625e$var$useTrackException() {
    var _useWebChatAPIContext = (0, $d4024f23ac1e625e$var$_useWebChatAPIContext2.default)(), onTelemetry = _useWebChatAPIContext.onTelemetry;
    var readTelemetryDimensions = (0, $d4024f23ac1e625e$var$_useReadTelemetryDimensions.default)();
    return (0, $eO7Kz.useCallback)(function(error) {
        var fatal = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
        if (!(error instanceof Error)) return console.warn('botframework-webchat: "error" passed to "useTrackException" must be specified and of type Error.');
        onTelemetry && onTelemetry((0, $d4024f23ac1e625e$var$_createCustomEvent.default)("exception", {
            dimensions: $d4024f23ac1e625e$var$_objectSpread({}, readTelemetryDimensions()),
            error: error,
            fatal: !!fatal
        }));
    }, [
        onTelemetry,
        readTelemetryDimensions
    ]);
}

});

parcelRequire.register("jQXaX", function(module, exports) {
"use strict";
function $e740c6b1a5c9d375$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $e740c6b1a5c9d375$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $e740c6b1a5c9d375$var$_typeof(obj);
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $e740c6b1a5c9d375$var$useTrackTiming;

var $eO7Kz = parcelRequire("eO7Kz");

var $e740c6b1a5c9d375$var$_createCustomEvent = $e740c6b1a5c9d375$var$_interopRequireDefault((parcelRequire("cViyF")));

var $e740c6b1a5c9d375$var$_randomId = $e740c6b1a5c9d375$var$_interopRequireDefault((parcelRequire("e0DTc")));

var $e740c6b1a5c9d375$var$_usePonyfill3 = $e740c6b1a5c9d375$var$_interopRequireDefault((parcelRequire("44MU5")));

var $e740c6b1a5c9d375$var$_useReadTelemetryDimensions = $e740c6b1a5c9d375$var$_interopRequireDefault((parcelRequire("1TnPI")));

var $e740c6b1a5c9d375$var$_useTrackException = $e740c6b1a5c9d375$var$_interopRequireDefault((parcelRequire("icwbb")));

var $e740c6b1a5c9d375$var$_useWebChatAPIContext2 = $e740c6b1a5c9d375$var$_interopRequireDefault((parcelRequire("iJOsw")));
function $e740c6b1a5c9d375$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $e740c6b1a5c9d375$var$_regeneratorRuntime() {
    "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ 
    $e740c6b1a5c9d375$var$_regeneratorRuntime = function _regeneratorRuntime() {
        return exports;
    };
    var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
    function define(obj, key, value) {
        return Object.defineProperty(obj, key, {
            value: value,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }), obj[key];
    }
    try {
        define({}, "");
    } catch (err) {
        define = function define(obj, key, value) {
            return obj[key] = value;
        };
    }
    function wrap(innerFn, outerFn, self, tryLocsList) {
        var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []);
        return generator._invoke = function(innerFn, self, context) {
            var state = "suspendedStart";
            return function(method, arg) {
                if ("executing" === state) throw new Error("Generator is already running");
                if ("completed" === state) {
                    if ("throw" === method) throw arg;
                    return doneResult();
                }
                for(context.method = method, context.arg = arg;;){
                    var delegate = context.delegate;
                    if (delegate) {
                        var delegateResult = maybeInvokeDelegate(delegate, context);
                        if (delegateResult) {
                            if (delegateResult === ContinueSentinel) continue;
                            return delegateResult;
                        }
                    }
                    if ("next" === context.method) context.sent = context._sent = context.arg;
                    else if ("throw" === context.method) {
                        if ("suspendedStart" === state) throw state = "completed", context.arg;
                        context.dispatchException(context.arg);
                    } else "return" === context.method && context.abrupt("return", context.arg);
                    state = "executing";
                    var record = tryCatch(innerFn, self, context);
                    if ("normal" === record.type) {
                        if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue;
                        return {
                            value: record.arg,
                            done: context.done
                        };
                    }
                    "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg);
                }
            };
        }(innerFn, self, context), generator;
    }
    function tryCatch(fn, obj, arg) {
        try {
            return {
                type: "normal",
                arg: fn.call(obj, arg)
            };
        } catch (err) {
            return {
                type: "throw",
                arg: err
            };
        }
    }
    exports.wrap = wrap;
    var ContinueSentinel = {};
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    var IteratorPrototype = {};
    define(IteratorPrototype, iteratorSymbol, function() {
        return this;
    });
    var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([])));
    NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype);
    var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
    function defineIteratorMethods(prototype) {
        [
            "next",
            "throw",
            "return"
        ].forEach(function(method) {
            define(prototype, method, function(arg) {
                return this._invoke(method, arg);
            });
        });
    }
    function AsyncIterator(generator, PromiseImpl) {
        function invoke(method, arg, resolve, reject) {
            var record = tryCatch(generator[method], generator, arg);
            if ("throw" !== record.type) {
                var result = record.arg, value = result.value;
                return value && "object" == $e740c6b1a5c9d375$var$_typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function(value) {
                    invoke("next", value, resolve, reject);
                }, function(err) {
                    invoke("throw", err, resolve, reject);
                }) : PromiseImpl.resolve(value).then(function(unwrapped) {
                    result.value = unwrapped, resolve(result);
                }, function(error) {
                    return invoke("throw", error, resolve, reject);
                });
            }
            reject(record.arg);
        }
        var previousPromise;
        this._invoke = function(method, arg) {
            function callInvokeWithMethodAndArg() {
                return new PromiseImpl(function(resolve, reject) {
                    invoke(method, arg, resolve, reject);
                });
            }
            return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
        };
    }
    function maybeInvokeDelegate(delegate, context) {
        var method = delegate.iterator[context.method];
        if (undefined === method) {
            if (context.delegate = null, "throw" === context.method) {
                if (delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel;
                context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method");
            }
            return ContinueSentinel;
        }
        var record = tryCatch(method, delegate.iterator, context.arg);
        if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel;
        var info = record.arg;
        return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel);
    }
    function pushTryEntry(locs) {
        var entry = {
            tryLoc: locs[0]
        };
        1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry);
    }
    function resetTryEntry(entry) {
        var record = entry.completion || {};
        record.type = "normal", delete record.arg, entry.completion = record;
    }
    function Context(tryLocsList) {
        this.tryEntries = [
            {
                tryLoc: "root"
            }
        ], tryLocsList.forEach(pushTryEntry, this), this.reset(!0);
    }
    function values(iterable) {
        if (iterable) {
            var iteratorMethod = iterable[iteratorSymbol];
            if (iteratorMethod) return iteratorMethod.call(iterable);
            if ("function" == typeof iterable.next) return iterable;
            if (!isNaN(iterable.length)) {
                var i = -1, next = function next() {
                    for(; ++i < iterable.length;){
                        if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next;
                    }
                    return next.value = undefined, next.done = !0, next;
                };
                return next.next = next;
            }
        }
        return {
            next: doneResult
        };
    }
    function doneResult() {
        return {
            value: undefined,
            done: !0
        };
    }
    return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function(genFun) {
        var ctor = "function" == typeof genFun && genFun.constructor;
        return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name));
    }, exports.mark = function(genFun) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun;
    }, exports.awrap = function(arg) {
        return {
            __await: arg
        };
    }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function() {
        return this;
    }), exports.AsyncIterator = AsyncIterator, exports.async = function(innerFn, outerFn, self, tryLocsList, PromiseImpl) {
        void 0 === PromiseImpl && (PromiseImpl = Promise);
        var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
        return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function(result) {
            return result.done ? result.value : iter.next();
        });
    }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function() {
        return this;
    }), define(Gp, "toString", function() {
        return "[object Generator]";
    }), exports.keys = function(object) {
        var keys = [];
        for(var key in object)keys.push(key);
        return keys.reverse(), function next() {
            for(; keys.length;){
                var key = keys.pop();
                if (key in object) return next.value = key, next.done = !1, next;
            }
            return next.done = !0, next;
        };
    }, exports.values = values, Context.prototype = {
        constructor: Context,
        reset: function reset(skipTempReset) {
            if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for(var name in this)"t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined);
        },
        stop: function stop() {
            this.done = !0;
            var rootRecord = this.tryEntries[0].completion;
            if ("throw" === rootRecord.type) throw rootRecord.arg;
            return this.rval;
        },
        dispatchException: function dispatchException(exception) {
            if (this.done) throw exception;
            var context = this;
            function handle(loc, caught) {
                return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught;
            }
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i], record = entry.completion;
                if ("root" === entry.tryLoc) return handle("end");
                if (entry.tryLoc <= this.prev) {
                    var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc");
                    if (hasCatch && hasFinally) {
                        if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
                        if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
                    } else if (hasCatch) {
                        if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
                    } else {
                        if (!hasFinally) throw new Error("try statement without catch or finally");
                        if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
                    }
                }
            }
        },
        abrupt: function abrupt(type, arg) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
                    var finallyEntry = entry;
                    break;
                }
            }
            finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null);
            var record = finallyEntry ? finallyEntry.completion : {};
            return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record);
        },
        complete: function complete(record, afterLoc) {
            if ("throw" === record.type) throw record.arg;
            return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel;
        },
        finish: function finish(finallyLoc) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel;
            }
        },
        catch: function _catch(tryLoc) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.tryLoc === tryLoc) {
                    var record = entry.completion;
                    if ("throw" === record.type) {
                        var thrown = record.arg;
                        resetTryEntry(entry);
                    }
                    return thrown;
                }
            }
            throw new Error("illegal catch attempt");
        },
        delegateYield: function delegateYield(iterable, resultName, nextLoc) {
            return this.delegate = {
                iterator: values(iterable),
                resultName: resultName,
                nextLoc: nextLoc
            }, "next" === this.method && (this.arg = undefined), ContinueSentinel;
        }
    }, exports;
}
function $e740c6b1a5c9d375$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) resolve(value);
    else Promise.resolve(value).then(_next, _throw);
}
function $e740c6b1a5c9d375$var$_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                $e740c6b1a5c9d375$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                $e740c6b1a5c9d375$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function $e740c6b1a5c9d375$var$_slicedToArray(arr, i) {
    return $e740c6b1a5c9d375$var$_arrayWithHoles(arr) || $e740c6b1a5c9d375$var$_iterableToArrayLimit(arr, i) || $e740c6b1a5c9d375$var$_unsupportedIterableToArray(arr, i) || $e740c6b1a5c9d375$var$_nonIterableRest();
}
function $e740c6b1a5c9d375$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $e740c6b1a5c9d375$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $e740c6b1a5c9d375$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $e740c6b1a5c9d375$var$_arrayLikeToArray(o, minLen);
}
function $e740c6b1a5c9d375$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $e740c6b1a5c9d375$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $e740c6b1a5c9d375$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $e740c6b1a5c9d375$var$useTrackTiming() {
    var _usePonyfill = (0, $e740c6b1a5c9d375$var$_usePonyfill3.default)(), _usePonyfill2 = $e740c6b1a5c9d375$var$_slicedToArray(_usePonyfill, 1), Date = _usePonyfill2[0].Date;
    var _useWebChatAPIContext = (0, $e740c6b1a5c9d375$var$_useWebChatAPIContext2.default)(), onTelemetry = _useWebChatAPIContext.onTelemetry;
    var readTelemetryDimensions = (0, $e740c6b1a5c9d375$var$_useReadTelemetryDimensions.default)();
    var trackException = (0, $e740c6b1a5c9d375$var$_useTrackException.default)();
    return (0, $eO7Kz.useCallback)(/*#__PURE__*/ function() {
        var _ref = $e740c6b1a5c9d375$var$_asyncToGenerator(/*#__PURE__*/ $e740c6b1a5c9d375$var$_regeneratorRuntime().mark(function _callee(name, functionOrPromise) {
            var timingId, startTime, duration;
            return $e740c6b1a5c9d375$var$_regeneratorRuntime().wrap(function _callee$(_context) {
                while(true)switch(_context.prev = _context.next){
                    case 0:
                        if (!(!name || typeof name !== "string")) {
                            _context.next = 4;
                            break;
                        }
                        return _context.abrupt("return", console.warn('botframework-webchat: "name" passed to "useTrackTiming" hook must be specified and of type string.'));
                    case 4:
                        if (!(typeof functionOrPromise !== "function" && typeof functionOrPromise.then !== "function")) {
                            _context.next = 6;
                            break;
                        }
                        return _context.abrupt("return", console.warn('botframework-webchat: "functionOrPromise" passed to "useTrackTiming" hook must be specified, of type function or Promise.'));
                    case 6:
                        timingId = (0, $e740c6b1a5c9d375$var$_randomId.default)();
                        onTelemetry && onTelemetry((0, $e740c6b1a5c9d375$var$_createCustomEvent.default)("timingstart", {
                            dimensions: readTelemetryDimensions(),
                            name: name,
                            timingId: timingId
                        }));
                        startTime = Date.now();
                        _context.prev = 9;
                        _context.next = 12;
                        return typeof functionOrPromise === "function" ? functionOrPromise() : functionOrPromise;
                    case 12:
                        return _context.abrupt("return", _context.sent);
                    case 15:
                        _context.prev = 15;
                        _context.t0 = _context["catch"](9);
                        trackException(_context.t0, false);
                        throw _context.t0;
                    case 19:
                        _context.prev = 19;
                        duration = Date.now() - startTime;
                        onTelemetry && onTelemetry((0, $e740c6b1a5c9d375$var$_createCustomEvent.default)("timingend", {
                            dimensions: readTelemetryDimensions(),
                            duration: duration,
                            name: name,
                            timingId: timingId
                        }));
                        return _context.finish(19);
                    case 23:
                    case "end":
                        return _context.stop();
                }
            }, _callee, null, [
                [
                    9,
                    15,
                    19,
                    23
                ]
            ]);
        }));
        return function(_x, _x2) {
            return _ref.apply(this, arguments);
        };
    }(), [
        Date,
        onTelemetry,
        readTelemetryDimensions,
        trackException
    ]);
}

});
parcelRequire.register("e0DTc", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $a33001faed14840e$var$randomId;

var $a33001faed14840e$var$_mathRandom = $a33001faed14840e$var$_interopRequireDefault((parcelRequire("atZsr")));
function $a33001faed14840e$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/* eslint no-magic-numbers: ["error", { "ignore": [2, 5, 36] }] */ function $a33001faed14840e$var$randomId() {
    var maxLength = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 5;
    return (0, $a33001faed14840e$var$_mathRandom.default)().toString(36).substr(2, maxLength);
}

});


parcelRequire.register("32oBN", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $2364a5bc5fff4a0e$var$useUserID;

var $2364a5bc5fff4a0e$var$_useWebChatAPIContext = $2364a5bc5fff4a0e$var$_interopRequireDefault((parcelRequire("iJOsw")));
function $2364a5bc5fff4a0e$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $2364a5bc5fff4a0e$var$useUserID() {
    return [
        (0, $2364a5bc5fff4a0e$var$_useWebChatAPIContext.default)().userID
    ];
}

});

parcelRequire.register("hFcak", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $cdbfb3db3bca27f1$var$useUsername;

var $cdbfb3db3bca27f1$var$_useWebChatAPIContext = $cdbfb3db3bca27f1$var$_interopRequireDefault((parcelRequire("iJOsw")));
function $cdbfb3db3bca27f1$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $cdbfb3db3bca27f1$var$useUsername() {
    return [
        (0, $cdbfb3db3bca27f1$var$_useWebChatAPIContext.default)().username
    ];
}

});

parcelRequire.register("jl40b", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $e1431533391ac328$var$useVoiceSelector;

var $eO7Kz = parcelRequire("eO7Kz");

var $e1431533391ac328$var$_useWebChatAPIContext = $e1431533391ac328$var$_interopRequireDefault((parcelRequire("iJOsw")));
function $e1431533391ac328$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $e1431533391ac328$var$useVoiceSelector(activity) {
    var context = (0, $e1431533391ac328$var$_useWebChatAPIContext.default)();
    return (0, $eO7Kz.useCallback)(function(voices) {
        return context.selectVoice(voices, activity);
    }, [
        activity,
        context
    ]);
}

});


parcelRequire.register("a6Izx", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
parcelRequire("7MIGR");
var $g4TkW = parcelRequire("g4TkW");

var $75bd0a0b757f1168$var$_propTypes = $75bd0a0b757f1168$var$_interopRequireDefault((parcelRequire("f7UXb")));

var $75bd0a0b757f1168$var$_react = $75bd0a0b757f1168$var$_interopRequireWildcard((parcelRequire("eO7Kz")));

var $75bd0a0b757f1168$var$_simpleUpdateIn = $75bd0a0b757f1168$var$_interopRequireDefault((parcelRequire("7qq3H")));

var $cG9B9 = parcelRequire("cG9B9");

var $75bd0a0b757f1168$var$_WebChatAPIContext = $75bd0a0b757f1168$var$_interopRequireDefault((parcelRequire("aHcFB")));

var $75bd0a0b757f1168$var$_ActivityAcknowledgementComposer = $75bd0a0b757f1168$var$_interopRequireDefault((parcelRequire("jFWUk")));

var $75bd0a0b757f1168$var$_ActivityKeyerComposer = $75bd0a0b757f1168$var$_interopRequireDefault((parcelRequire("e4ypX")));

var $75bd0a0b757f1168$var$_ActivitySendStatusComposer = $75bd0a0b757f1168$var$_interopRequireDefault((parcelRequire("9KqWE")));

var $75bd0a0b757f1168$var$_ActivitySendStatusTelemetryComposer = $75bd0a0b757f1168$var$_interopRequireDefault((parcelRequire("dDdBM")));

var $75bd0a0b757f1168$var$_createCustomEvent = $75bd0a0b757f1168$var$_interopRequireDefault((parcelRequire("cViyF")));

var $75bd0a0b757f1168$var$_createDefaultCardActionMiddleware = $75bd0a0b757f1168$var$_interopRequireDefault((parcelRequire("9NiB7")));

var $75bd0a0b757f1168$var$_createDefaultGroupActivitiesMiddleware = $75bd0a0b757f1168$var$_interopRequireDefault((parcelRequire("d5ubR")));

var $75bd0a0b757f1168$var$_defaultSelectVoice = $75bd0a0b757f1168$var$_interopRequireDefault((parcelRequire("3IrWT")));

var $75bd0a0b757f1168$var$_ErrorBoundary = $75bd0a0b757f1168$var$_interopRequireDefault((parcelRequire("fokl9")));

var $75bd0a0b757f1168$var$_getAllLocalizedStrings = $75bd0a0b757f1168$var$_interopRequireDefault((parcelRequire("k99nF")));

var $75bd0a0b757f1168$var$_isObject = $75bd0a0b757f1168$var$_interopRequireDefault((parcelRequire("cmMIo")));

var $75bd0a0b757f1168$var$_mapMap = $75bd0a0b757f1168$var$_interopRequireDefault((parcelRequire("d3MXM")));

var $75bd0a0b757f1168$var$_normalizeLanguage = $75bd0a0b757f1168$var$_interopRequireDefault((parcelRequire("dv55n")));

var $75bd0a0b757f1168$var$_normalizeStyleOptions = $75bd0a0b757f1168$var$_interopRequireDefault((parcelRequire("hOQU1")));

var $75bd0a0b757f1168$var$_observableToPromise = $75bd0a0b757f1168$var$_interopRequireDefault((parcelRequire("566u6")));

var $75bd0a0b757f1168$var$_patchStyleOptionsFromDeprecatedProps = $75bd0a0b757f1168$var$_interopRequireDefault((parcelRequire("gW2Ds")));

var $75bd0a0b757f1168$var$_PonyfillComposer = $75bd0a0b757f1168$var$_interopRequireDefault((parcelRequire("bDr9U")));

var $75bd0a0b757f1168$var$_Tracker = $75bd0a0b757f1168$var$_interopRequireDefault((parcelRequire("4ldnr")));

var $75bd0a0b757f1168$var$_useMarkAllAsAcknowledged = $75bd0a0b757f1168$var$_interopRequireDefault((parcelRequire("5c4UP")));

var $75bd0a0b757f1168$var$_usePonyfill5 = $75bd0a0b757f1168$var$_interopRequireDefault((parcelRequire("44MU5")));

var $75bd0a0b757f1168$var$_WebChatReduxContext = $75bd0a0b757f1168$var$_interopRequireWildcard((parcelRequire("kSc9m")));

var $75bd0a0b757f1168$var$_applyMiddleware = $75bd0a0b757f1168$var$_interopRequireWildcard((parcelRequire("hvz7t")));

var $75bd0a0b757f1168$var$_PrecompiledGlobalize = $75bd0a0b757f1168$var$_interopRequireDefault((parcelRequire("bpS5X")));
var $75bd0a0b757f1168$var$_excluded = [
    "onTelemetry",
    "store"
], $75bd0a0b757f1168$var$_excluded2 = [
    "internalRenderErrorBox",
    "onTelemetry",
    "ponyfill"
];
function $75bd0a0b757f1168$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($75bd0a0b757f1168$var$_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $75bd0a0b757f1168$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || $75bd0a0b757f1168$var$_typeof(obj) !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $75bd0a0b757f1168$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $75bd0a0b757f1168$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $75bd0a0b757f1168$var$_extends() {
    $75bd0a0b757f1168$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $75bd0a0b757f1168$var$_extends.apply(this, arguments);
}
function $75bd0a0b757f1168$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $75bd0a0b757f1168$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $75bd0a0b757f1168$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $75bd0a0b757f1168$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $75bd0a0b757f1168$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $75bd0a0b757f1168$var$_typeof(obj);
}
function $75bd0a0b757f1168$var$_slicedToArray(arr, i) {
    return $75bd0a0b757f1168$var$_arrayWithHoles(arr) || $75bd0a0b757f1168$var$_iterableToArrayLimit(arr, i) || $75bd0a0b757f1168$var$_unsupportedIterableToArray(arr, i) || $75bd0a0b757f1168$var$_nonIterableRest();
}
function $75bd0a0b757f1168$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $75bd0a0b757f1168$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $75bd0a0b757f1168$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $75bd0a0b757f1168$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $75bd0a0b757f1168$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $75bd0a0b757f1168$var$ownKeys(Object(source), !0).forEach(function(key) {
            $75bd0a0b757f1168$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $75bd0a0b757f1168$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $75bd0a0b757f1168$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $75bd0a0b757f1168$var$_toConsumableArray(arr) {
    return $75bd0a0b757f1168$var$_arrayWithoutHoles(arr) || $75bd0a0b757f1168$var$_iterableToArray(arr) || $75bd0a0b757f1168$var$_unsupportedIterableToArray(arr) || $75bd0a0b757f1168$var$_nonIterableSpread();
}
function $75bd0a0b757f1168$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $75bd0a0b757f1168$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $75bd0a0b757f1168$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $75bd0a0b757f1168$var$_arrayLikeToArray(o, minLen);
}
function $75bd0a0b757f1168$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $75bd0a0b757f1168$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $75bd0a0b757f1168$var$_arrayLikeToArray(arr);
}
function $75bd0a0b757f1168$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
// List of Redux actions factory we are hoisting as Web Chat functions
var $75bd0a0b757f1168$var$DISPATCHERS = {
    clearSuggestedActions: $cG9B9.clearSuggestedActions,
    dismissNotification: $cG9B9.dismissNotification,
    emitTypingIndicator: $cG9B9.emitTypingIndicator,
    markActivity: $cG9B9.markActivity,
    postActivity: $cG9B9.postActivity,
    sendEvent: $cG9B9.sendEvent,
    sendFiles: $cG9B9.sendFiles,
    sendMessage: $cG9B9.sendMessage,
    sendMessageBack: $cG9B9.sendMessageBack,
    sendPostBack: $cG9B9.sendPostBack,
    setDictateInterims: $cG9B9.setDictateInterims,
    setDictateState: $cG9B9.setDictateState,
    setNotification: $cG9B9.setNotification,
    setSendBox: $cG9B9.setSendBox,
    setSendTimeout: $cG9B9.setSendTimeout,
    startDictate: $cG9B9.startDictate,
    startSpeakingActivity: $cG9B9.startSpeakingActivity,
    stopDictate: $cG9B9.stopDictate,
    stopSpeakingActivity: $cG9B9.stopSpeakingActivity,
    submitSendBox: $cG9B9.submitSendBox
};
function $75bd0a0b757f1168$var$createCardActionContext(_ref) {
    var cardActionMiddleware = _ref.cardActionMiddleware, directLine = _ref.directLine, dispatch = _ref.dispatch, markAllAsAcknowledged = _ref.markAllAsAcknowledged, ponyfill = _ref.ponyfill;
    var runMiddleware = $75bd0a0b757f1168$var$_applyMiddleware.default.apply(void 0, [
        "card action"
    ].concat($75bd0a0b757f1168$var$_toConsumableArray((0, $cG9B9.singleToArray)(cardActionMiddleware)), [
        (0, $75bd0a0b757f1168$var$_createDefaultCardActionMiddleware.default)()
    ]))({
        dispatch: dispatch
    });
    return {
        onCardAction: function onCardAction(cardAction) {
            var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {}, target = _ref2.target;
            markAllAsAcknowledged();
            return runMiddleware({
                cardAction: cardAction,
                getSignInUrl: cardAction.type === "signin" ? function() {
                    var value = cardAction.value;
                    if (directLine.getSessionId) /**
             * @todo TODO: [P3] We should change this one to async/await.
             *       This is the first place in this project to use async.
             *       Thus, we need to add @babel/plugin-transform-runtime and @babel/runtime.
             */ return (0, $75bd0a0b757f1168$var$_observableToPromise.default)(directLine.getSessionId(), ponyfill).then(function(sessionId) {
                        return "".concat(value).concat(encodeURIComponent("&code_challenge=".concat(sessionId)));
                    });
                    console.warn("botframework-webchat: OAuth is not supported on this Direct Line adapter.");
                    return value;
                } : null,
                target: target
            });
        }
    };
}
function $75bd0a0b757f1168$var$createGroupActivitiesContext(_ref3) {
    var groupActivitiesMiddleware = _ref3.groupActivitiesMiddleware, groupTimestamp = _ref3.groupTimestamp, ponyfill = _ref3.ponyfill;
    var runMiddleware = $75bd0a0b757f1168$var$_applyMiddleware.default.apply(void 0, [
        "group activities"
    ].concat($75bd0a0b757f1168$var$_toConsumableArray((0, $cG9B9.singleToArray)(groupActivitiesMiddleware)), [
        (0, $75bd0a0b757f1168$var$_createDefaultGroupActivitiesMiddleware.default)({
            groupTimestamp: groupTimestamp,
            ponyfill: ponyfill
        })
    ]));
    return {
        groupActivities: runMiddleware({})
    };
}
function $75bd0a0b757f1168$var$mergeStringsOverrides(localizedStrings, language, overrideLocalizedStrings) {
    if (!overrideLocalizedStrings) return localizedStrings;
    else if (typeof overrideLocalizedStrings === "function") {
        var merged = overrideLocalizedStrings(localizedStrings, language);
        if (!(0, $75bd0a0b757f1168$var$_isObject.default)(merged)) throw new Error("botframework-webchat: overrideLocalizedStrings function must return an object.");
        return merged;
    }
    if (!(0, $75bd0a0b757f1168$var$_isObject.default)(overrideLocalizedStrings)) throw new Error("botframework-webchat: overrideLocalizedStrings must be either a function, an object, or falsy.");
    return $75bd0a0b757f1168$var$_objectSpread($75bd0a0b757f1168$var$_objectSpread({}, localizedStrings), overrideLocalizedStrings);
} // It seems "react/require-default-props" did not pick up `ComposerCore.defaultProps`.
// And it falsely complaint `optional?: string` must have a corresponding `ComposerCore.defaultProps.optional = undefined`, even we already set it below.
// Since we set both TypeScript `Props` class and `ComposerCore.propTypes`, this check will be done there as well.
// Ignoring it in TypeScript version should be safe, as we have `propTypes` version to protect us.
/* eslint-disable react/require-default-props */ /* eslint-enable react/require-default-props */ var $75bd0a0b757f1168$var$ComposerCore = function ComposerCore(_ref4) {
    var activityMiddleware = _ref4.activityMiddleware, activityRenderer = _ref4.activityRenderer, activityStatusMiddleware = _ref4.activityStatusMiddleware, activityStatusRenderer = _ref4.activityStatusRenderer, attachmentForScreenReaderMiddleware = _ref4.attachmentForScreenReaderMiddleware, attachmentMiddleware = _ref4.attachmentMiddleware, attachmentRenderer = _ref4.attachmentRenderer, avatarMiddleware = _ref4.avatarMiddleware, avatarRenderer = _ref4.avatarRenderer, cardActionMiddleware = _ref4.cardActionMiddleware, children = _ref4.children, dir = _ref4.dir, directLine = _ref4.directLine, disabled = _ref4.disabled, downscaleImageToDataURL = _ref4.downscaleImageToDataURL, grammars = _ref4.grammars, groupActivitiesMiddleware = _ref4.groupActivitiesMiddleware, groupTimestamp = _ref4.groupTimestamp, internalErrorBoxClass = _ref4.internalErrorBoxClass, locale = _ref4.locale, onTelemetry = _ref4.onTelemetry, overrideLocalizedStrings = _ref4.overrideLocalizedStrings, renderMarkdown = _ref4.renderMarkdown, scrollToEndButtonMiddleware = _ref4.scrollToEndButtonMiddleware, selectVoice = _ref4.selectVoice, sendTimeout = _ref4.sendTimeout, sendTypingIndicator = _ref4.sendTypingIndicator, styleOptions = _ref4.styleOptions, toastMiddleware = _ref4.toastMiddleware, toastRenderer = _ref4.toastRenderer, typingIndicatorMiddleware = _ref4.typingIndicatorMiddleware, typingIndicatorRenderer = _ref4.typingIndicatorRenderer, userID = _ref4.userID, username = _ref4.username;
    var _usePonyfill = (0, $75bd0a0b757f1168$var$_usePonyfill5.default)(), _usePonyfill2 = $75bd0a0b757f1168$var$_slicedToArray(_usePonyfill, 1), ponyfill = _usePonyfill2[0];
    var dispatch = (0, $75bd0a0b757f1168$var$_WebChatReduxContext.useDispatch)();
    var telemetryDimensionsRef = (0, $75bd0a0b757f1168$var$_react.useRef)({});
    var patchedDir = (0, $75bd0a0b757f1168$var$_react.useMemo)(function() {
        return dir === "ltr" || dir === "rtl" ? dir : "auto";
    }, [
        dir
    ]);
    var patchedGrammars = (0, $75bd0a0b757f1168$var$_react.useMemo)(function() {
        return grammars || [];
    }, [
        grammars
    ]);
    var patchedStyleOptions = (0, $75bd0a0b757f1168$var$_react.useMemo)(function() {
        return (0, $75bd0a0b757f1168$var$_normalizeStyleOptions.default)((0, $75bd0a0b757f1168$var$_patchStyleOptionsFromDeprecatedProps.default)(styleOptions, {
            groupTimestamp: groupTimestamp,
            sendTimeout: sendTimeout
        }));
    }, [
        groupTimestamp,
        sendTimeout,
        styleOptions
    ]);
    (0, $75bd0a0b757f1168$var$_react.useEffect)(function() {
        dispatch((0, $cG9B9.setLanguage)(locale));
    }, [
        dispatch,
        locale
    ]);
    (0, $75bd0a0b757f1168$var$_react.useEffect)(function() {
        typeof sendTimeout === "number" && dispatch((0, $cG9B9.setSendTimeout)(sendTimeout));
    }, [
        dispatch,
        sendTimeout
    ]);
    (0, $75bd0a0b757f1168$var$_react.useEffect)(function() {
        dispatch((0, $cG9B9.setSendTypingIndicator)(!!sendTypingIndicator));
    }, [
        dispatch,
        sendTypingIndicator
    ]);
    (0, $75bd0a0b757f1168$var$_react.useEffect)(function() {
        dispatch((0, $cG9B9.connect)({
            directLine: directLine,
            userID: userID,
            username: username
        }));
        return function() {
            /**
       * @todo TODO: [P3] disconnect() is an async call (pending -> fulfilled), we need to wait, or change it to reconnect()
       */ dispatch((0, $cG9B9.disconnect)());
        };
    }, [
        dispatch,
        directLine,
        userID,
        username
    ]);
    var markAllAsAcknowledged = (0, $75bd0a0b757f1168$var$_useMarkAllAsAcknowledged.default)();
    var cardActionContext = (0, $75bd0a0b757f1168$var$_react.useMemo)(function() {
        return $75bd0a0b757f1168$var$createCardActionContext({
            cardActionMiddleware: cardActionMiddleware,
            directLine: directLine,
            dispatch: dispatch,
            markAllAsAcknowledged: markAllAsAcknowledged,
            ponyfill: ponyfill
        });
    }, [
        cardActionMiddleware,
        directLine,
        dispatch,
        markAllAsAcknowledged,
        ponyfill
    ]);
    var patchedSelectVoice = (0, $75bd0a0b757f1168$var$_react.useMemo)(function() {
        return selectVoice || $75bd0a0b757f1168$var$_defaultSelectVoice.default.bind(null, {
            language: locale
        });
    }, [
        locale,
        selectVoice
    ]);
    var groupActivitiesContext = (0, $75bd0a0b757f1168$var$_react.useMemo)(function() {
        return $75bd0a0b757f1168$var$createGroupActivitiesContext({
            groupActivitiesMiddleware: groupActivitiesMiddleware,
            groupTimestamp: patchedStyleOptions.groupTimestamp,
            ponyfill: ponyfill
        });
    }, [
        groupActivitiesMiddleware,
        patchedStyleOptions.groupTimestamp,
        ponyfill
    ]);
    var hoistedDispatchers = (0, $75bd0a0b757f1168$var$_react.useMemo)(function() {
        return (0, $75bd0a0b757f1168$var$_mapMap.default)($75bd0a0b757f1168$var$DISPATCHERS, function(dispatcher) {
            return function() {
                return dispatch(dispatcher.apply(void 0, arguments));
            };
        });
    }, [
        dispatch
    ]);
    var patchedLocalizedStrings = (0, $75bd0a0b757f1168$var$_react.useMemo)(function() {
        return $75bd0a0b757f1168$var$mergeStringsOverrides((0, $75bd0a0b757f1168$var$_getAllLocalizedStrings.default)()[(0, $75bd0a0b757f1168$var$_normalizeLanguage.default)(locale)], locale, overrideLocalizedStrings);
    }, [
        locale,
        overrideLocalizedStrings
    ]);
    var localizedGlobalize = (0, $75bd0a0b757f1168$var$_react.useMemo)(function() {
        var _ref5 = patchedLocalizedStrings || {}, GLOBALIZE = _ref5.GLOBALIZE, GLOBALIZE_LANGUAGE = _ref5.GLOBALIZE_LANGUAGE;
        return GLOBALIZE || GLOBALIZE_LANGUAGE && (0, $75bd0a0b757f1168$var$_PrecompiledGlobalize.default)(GLOBALIZE_LANGUAGE) || (0, $75bd0a0b757f1168$var$_PrecompiledGlobalize.default)("en");
    }, [
        patchedLocalizedStrings
    ]);
    var trackDimension = (0, $75bd0a0b757f1168$var$_react.useCallback)(function(name, data) {
        if (!name || typeof name !== "string") return console.warn("botframework-webchat: Telemetry dimension name must be a string.");
        var type = $75bd0a0b757f1168$var$_typeof(data);
        if (type !== "string" && type !== "undefined") return console.warn("botframework-webchat: Telemetry dimension data must be a string or undefined.");
        telemetryDimensionsRef.current = (0, $75bd0a0b757f1168$var$_simpleUpdateIn.default)(telemetryDimensionsRef.current, [
            name
        ], type === "undefined" ? data : function() {
            return data;
        });
    }, [
        telemetryDimensionsRef
    ]);
    var patchedActivityRenderer = (0, $75bd0a0b757f1168$var$_react.useMemo)(function() {
        activityRenderer && console.warn('Web Chat: "activityRenderer" is deprecated and will be removed on 2022-06-15, please use "activityMiddleware" instead.');
        return activityRenderer || $75bd0a0b757f1168$var$_applyMiddleware.forRenderer.apply(void 0, [
            "activity",
            {
                strict: false
            }
        ].concat($75bd0a0b757f1168$var$_toConsumableArray((0, $cG9B9.singleToArray)(activityMiddleware)), [
            function() {
                return function() {
                    return function(_ref6) {
                        var activity = _ref6.activity;
                        if (activity) throw new Error('No renderer for activity of type "'.concat(activity.type, '"'));
                        else throw new Error("No activity to render");
                    };
                };
            }
        ]))({});
    }, [
        activityMiddleware,
        activityRenderer
    ]);
    var patchedActivityStatusRenderer = (0, $75bd0a0b757f1168$var$_react.useMemo)(function() {
        activityStatusRenderer && console.warn('Web Chat: "activityStatusRenderer" is deprecated and will be removed on 2022-06-15, please use "activityStatusMiddleware" instead.');
        return activityStatusRenderer || $75bd0a0b757f1168$var$_applyMiddleware.forRenderer.apply(void 0, [
            "activity status",
            {
                strict: false
            }
        ].concat($75bd0a0b757f1168$var$_toConsumableArray((0, $cG9B9.singleToArray)(activityStatusMiddleware)), [
            function() {
                return function() {
                    return function() {
                        return false;
                    };
                };
            }
        ]))({});
    }, [
        activityStatusMiddleware,
        activityStatusRenderer
    ]);
    var patchedAttachmentForScreenReaderRenderer = (0, $75bd0a0b757f1168$var$_react.useMemo)(function() {
        return $75bd0a0b757f1168$var$_applyMiddleware.forRenderer.apply(void 0, [
            "attachment for screen reader",
            {
                strict: true
            }
        ].concat($75bd0a0b757f1168$var$_toConsumableArray((0, $cG9B9.singleToArray)(attachmentForScreenReaderMiddleware)), [
            function() {
                return function() {
                    return function(_ref7) {
                        var attachment = _ref7.attachment;
                        if (attachment) {
                            console.warn('No renderer for attachment for screen reader of type "'.concat(attachment.contentType, '"'));
                            return false;
                        }
                        return function() {
                            /**
             * @todo TODO: [P4] Might be able to throw without returning a function -- investigate and possibly fix
             */ throw new Error("No attachment to render");
                        };
                    };
                };
            }
        ]))({});
    }, [
        attachmentForScreenReaderMiddleware
    ]);
    var patchedAttachmentRenderer = (0, $75bd0a0b757f1168$var$_react.useMemo)(function() {
        if (attachmentRenderer) {
            console.warn('Web Chat: "attachmentRenderer" is deprecated and will be removed on 2022-06-15, please use "attachmentMiddleware" instead.');
            return attachmentRenderer;
        } // Attachment renderer
        return $75bd0a0b757f1168$var$_applyMiddleware.forLegacyRenderer.apply(void 0, [
            "attachment"
        ].concat($75bd0a0b757f1168$var$_toConsumableArray((0, $cG9B9.singleToArray)(attachmentMiddleware)), [
            function() {
                return function() {
                    return function(_ref8) {
                        var attachment = _ref8.attachment;
                        if (attachment) throw new Error('No renderer for attachment of type "'.concat(attachment.contentType, '"'));
                        else throw new Error("No attachment to render");
                    };
                };
            }
        ]))({});
    }, [
        attachmentMiddleware,
        attachmentRenderer
    ]);
    var patchedAvatarRenderer = (0, $75bd0a0b757f1168$var$_react.useMemo)(function() {
        avatarRenderer && console.warn('Web Chat: "avatarRenderer" is deprecated and will be removed on 2022-06-15, please use "avatarMiddleware" instead.');
        return avatarRenderer || $75bd0a0b757f1168$var$_applyMiddleware.forRenderer.apply(void 0, [
            "avatar",
            {
                strict: false
            }
        ].concat($75bd0a0b757f1168$var$_toConsumableArray((0, $cG9B9.singleToArray)(avatarMiddleware)), [
            function() {
                return function() {
                    return function() {
                        return false;
                    };
                };
            }
        ]))({});
    }, [
        avatarMiddleware,
        avatarRenderer
    ]);
    var patchedToastRenderer = (0, $75bd0a0b757f1168$var$_react.useMemo)(function() {
        toastRenderer && console.warn('Web Chat: "toastRenderer" is deprecated and will be removed on 2022-06-15, please use "toastMiddleware" instead.');
        return toastRenderer || $75bd0a0b757f1168$var$_applyMiddleware.forRenderer.apply(void 0, [
            "toast",
            {
                strict: false
            }
        ].concat($75bd0a0b757f1168$var$_toConsumableArray((0, $cG9B9.singleToArray)(toastMiddleware)), [
            function() {
                return function() {
                    return function(_ref9) {
                        var notification = _ref9.notification;
                        if (notification) throw new Error('No renderer for notification of type "'.concat(notification.contentType, '"'));
                        else throw new Error("No notification to render");
                    };
                };
            }
        ]))({});
    }, [
        toastMiddleware,
        toastRenderer
    ]);
    var patchedTypingIndicatorRenderer = (0, $75bd0a0b757f1168$var$_react.useMemo)(function() {
        typingIndicatorRenderer && console.warn('Web Chat: "typingIndicatorRenderer" is deprecated and will be removed on 2022-06-15, please use "typingIndicatorMiddleware" instead.');
        return typingIndicatorRenderer || $75bd0a0b757f1168$var$_applyMiddleware.forRenderer.apply(void 0, [
            "typing indicator",
            {
                strict: false
            }
        ].concat($75bd0a0b757f1168$var$_toConsumableArray((0, $cG9B9.singleToArray)(typingIndicatorMiddleware)), [
            function() {
                return function() {
                    return function() {
                        return false;
                    };
                };
            }
        ]))({});
    }, [
        typingIndicatorMiddleware,
        typingIndicatorRenderer
    ]);
    var scrollToEndButtonRenderer = (0, $75bd0a0b757f1168$var$_react.useMemo)(function() {
        return $75bd0a0b757f1168$var$_applyMiddleware.forRenderer.apply(void 0, [
            "scroll to end button",
            {
                strict: true
            }
        ].concat($75bd0a0b757f1168$var$_toConsumableArray((0, $cG9B9.singleToArray)(scrollToEndButtonMiddleware)), [
            function() {
                return function() {
                    return function() {
                        return false;
                    };
                };
            }
        ]))();
    }, [
        scrollToEndButtonMiddleware
    ]);
    /**
   * This is a heavy function, and it is expected to be only called when there is a need to recreate business logic, e.g.
   * - User ID changed, causing all send* functions to be updated
   * - send
   * @todo TODO: [P3] We should think about if we allow the user to change onSendBoxValueChanged/sendBoxValue, e.g.
   * 1. Turns text into UPPERCASE
   * 2. Filter out profanity
   * @todo TODO: [P4] Revisit all members of context
   *       This context should consist of members that are not in the Redux store
   *       i.e. members that are not interested in other types of UIs
   */ var context = (0, $75bd0a0b757f1168$var$_react.useMemo)(function() {
        return $75bd0a0b757f1168$var$_objectSpread($75bd0a0b757f1168$var$_objectSpread($75bd0a0b757f1168$var$_objectSpread($75bd0a0b757f1168$var$_objectSpread({}, cardActionContext), groupActivitiesContext), hoistedDispatchers), {}, {
            activityRenderer: patchedActivityRenderer,
            activityStatusRenderer: patchedActivityStatusRenderer,
            attachmentForScreenReaderRenderer: patchedAttachmentForScreenReaderRenderer,
            attachmentRenderer: patchedAttachmentRenderer,
            avatarRenderer: patchedAvatarRenderer,
            dir: patchedDir,
            directLine: directLine,
            disabled: disabled,
            downscaleImageToDataURL: downscaleImageToDataURL,
            grammars: patchedGrammars,
            internalErrorBoxClass: internalErrorBoxClass,
            language: locale,
            localizedGlobalizeState: [
                localizedGlobalize
            ],
            localizedStrings: patchedLocalizedStrings,
            onTelemetry: onTelemetry,
            renderMarkdown: renderMarkdown,
            scrollToEndButtonRenderer: scrollToEndButtonRenderer,
            selectVoice: patchedSelectVoice,
            sendTypingIndicator: sendTypingIndicator,
            styleOptions: patchedStyleOptions,
            telemetryDimensionsRef: telemetryDimensionsRef,
            toastRenderer: patchedToastRenderer,
            trackDimension: trackDimension,
            typingIndicatorRenderer: patchedTypingIndicatorRenderer,
            userID: userID,
            username: username
        });
    }, [
        cardActionContext,
        directLine,
        disabled,
        downscaleImageToDataURL,
        groupActivitiesContext,
        hoistedDispatchers,
        internalErrorBoxClass,
        locale,
        localizedGlobalize,
        onTelemetry,
        patchedActivityRenderer,
        patchedActivityStatusRenderer,
        patchedAttachmentForScreenReaderRenderer,
        patchedAttachmentRenderer,
        patchedAvatarRenderer,
        patchedDir,
        patchedGrammars,
        patchedLocalizedStrings,
        patchedSelectVoice,
        patchedStyleOptions,
        patchedToastRenderer,
        patchedTypingIndicatorRenderer,
        renderMarkdown,
        scrollToEndButtonRenderer,
        sendTypingIndicator,
        telemetryDimensionsRef,
        trackDimension,
        userID,
        username
    ]);
    return /*#__PURE__*/ $75bd0a0b757f1168$var$_react.default.createElement($75bd0a0b757f1168$var$_WebChatAPIContext.default.Provider, {
        value: context
    }, /*#__PURE__*/ $75bd0a0b757f1168$var$_react.default.createElement($75bd0a0b757f1168$var$_ActivitySendStatusComposer.default, null, typeof children === "function" ? children(context) : children, /*#__PURE__*/ $75bd0a0b757f1168$var$_react.default.createElement($75bd0a0b757f1168$var$_ActivitySendStatusTelemetryComposer.default, null)), onTelemetry && /*#__PURE__*/ $75bd0a0b757f1168$var$_react.default.createElement($75bd0a0b757f1168$var$_Tracker.default, null));
};
/**
 * @todo TODO: [P3] We should consider moving some data from Redux store to props
 *       Although we use `connectToWebChat` to hide the details of accessor of Redux store,
 *       we should clean up the responsibility between Context and Redux store
 *       We should decide which data is needed for React but not in other environment such as CLI/VSCode
 */ $75bd0a0b757f1168$var$ComposerCore.defaultProps = {
    activityMiddleware: undefined,
    activityRenderer: undefined,
    activityStatusMiddleware: undefined,
    activityStatusRenderer: undefined,
    attachmentForScreenReaderMiddleware: undefined,
    attachmentMiddleware: undefined,
    attachmentRenderer: undefined,
    avatarMiddleware: undefined,
    avatarRenderer: undefined,
    cardActionMiddleware: undefined,
    children: undefined,
    dir: "auto",
    disabled: false,
    downscaleImageToDataURL: undefined,
    grammars: [],
    groupActivitiesMiddleware: undefined,
    groupTimestamp: undefined,
    internalErrorBoxClass: undefined,
    locale: window.navigator.language || "en-US",
    onTelemetry: undefined,
    overrideLocalizedStrings: undefined,
    renderMarkdown: undefined,
    scrollToEndButtonMiddleware: undefined,
    selectVoice: undefined,
    sendTimeout: undefined,
    sendTypingIndicator: false,
    styleOptions: {},
    toastMiddleware: undefined,
    toastRenderer: undefined,
    typingIndicatorMiddleware: undefined,
    typingIndicatorRenderer: undefined,
    userID: "",
    username: ""
};
$75bd0a0b757f1168$var$ComposerCore.propTypes = {
    activityMiddleware: $75bd0a0b757f1168$var$_propTypes.default.oneOfType([
        $75bd0a0b757f1168$var$_propTypes.default.arrayOf($75bd0a0b757f1168$var$_propTypes.default.func),
        $75bd0a0b757f1168$var$_propTypes.default.func
    ]),
    activityRenderer: $75bd0a0b757f1168$var$_propTypes.default.func,
    activityStatusMiddleware: $75bd0a0b757f1168$var$_propTypes.default.oneOfType([
        $75bd0a0b757f1168$var$_propTypes.default.arrayOf($75bd0a0b757f1168$var$_propTypes.default.func),
        $75bd0a0b757f1168$var$_propTypes.default.func
    ]),
    activityStatusRenderer: $75bd0a0b757f1168$var$_propTypes.default.func,
    attachmentForScreenReaderMiddleware: $75bd0a0b757f1168$var$_propTypes.default.oneOfType([
        $75bd0a0b757f1168$var$_propTypes.default.arrayOf($75bd0a0b757f1168$var$_propTypes.default.func),
        $75bd0a0b757f1168$var$_propTypes.default.func
    ]),
    attachmentMiddleware: $75bd0a0b757f1168$var$_propTypes.default.oneOfType([
        $75bd0a0b757f1168$var$_propTypes.default.arrayOf($75bd0a0b757f1168$var$_propTypes.default.func),
        $75bd0a0b757f1168$var$_propTypes.default.func
    ]),
    attachmentRenderer: $75bd0a0b757f1168$var$_propTypes.default.func,
    avatarMiddleware: $75bd0a0b757f1168$var$_propTypes.default.oneOfType([
        $75bd0a0b757f1168$var$_propTypes.default.arrayOf($75bd0a0b757f1168$var$_propTypes.default.func),
        $75bd0a0b757f1168$var$_propTypes.default.func
    ]),
    avatarRenderer: $75bd0a0b757f1168$var$_propTypes.default.func,
    cardActionMiddleware: $75bd0a0b757f1168$var$_propTypes.default.oneOfType([
        $75bd0a0b757f1168$var$_propTypes.default.arrayOf($75bd0a0b757f1168$var$_propTypes.default.func),
        $75bd0a0b757f1168$var$_propTypes.default.func
    ]),
    children: $75bd0a0b757f1168$var$_propTypes.default.any,
    dir: $75bd0a0b757f1168$var$_propTypes.default.oneOf([
        "auto",
        "ltr",
        "rtl"
    ]),
    // PropTypes.shape({ ... }) did not honor isRequired for its members.
    // @ts-ignore
    directLine: $75bd0a0b757f1168$var$_propTypes.default.shape({
        activity$: $75bd0a0b757f1168$var$_propTypes.default.shape({
            subscribe: $75bd0a0b757f1168$var$_propTypes.default.func.isRequired
        }).isRequired,
        connectionStatus$: $75bd0a0b757f1168$var$_propTypes.default.shape({
            subscribe: $75bd0a0b757f1168$var$_propTypes.default.func.isRequired
        }).isRequired,
        end: $75bd0a0b757f1168$var$_propTypes.default.func,
        getSessionId: $75bd0a0b757f1168$var$_propTypes.default.func,
        postActivity: $75bd0a0b757f1168$var$_propTypes.default.func.isRequired,
        referenceGrammarID: $75bd0a0b757f1168$var$_propTypes.default.string,
        token: $75bd0a0b757f1168$var$_propTypes.default.string
    }).isRequired,
    disabled: $75bd0a0b757f1168$var$_propTypes.default.bool,
    downscaleImageToDataURL: $75bd0a0b757f1168$var$_propTypes.default.func,
    grammars: $75bd0a0b757f1168$var$_propTypes.default.arrayOf($75bd0a0b757f1168$var$_propTypes.default.string),
    groupActivitiesMiddleware: $75bd0a0b757f1168$var$_propTypes.default.oneOfType([
        $75bd0a0b757f1168$var$_propTypes.default.arrayOf($75bd0a0b757f1168$var$_propTypes.default.func),
        $75bd0a0b757f1168$var$_propTypes.default.func
    ]),
    groupTimestamp: $75bd0a0b757f1168$var$_propTypes.default.oneOfType([
        $75bd0a0b757f1168$var$_propTypes.default.bool,
        $75bd0a0b757f1168$var$_propTypes.default.number
    ]),
    internalErrorBoxClass: $75bd0a0b757f1168$var$_propTypes.default.func,
    // This is for internal use only. We don't allow customization of error box.
    locale: $75bd0a0b757f1168$var$_propTypes.default.string,
    onTelemetry: $75bd0a0b757f1168$var$_propTypes.default.func,
    overrideLocalizedStrings: $75bd0a0b757f1168$var$_propTypes.default.oneOfType([
        $75bd0a0b757f1168$var$_propTypes.default.any,
        $75bd0a0b757f1168$var$_propTypes.default.func
    ]),
    renderMarkdown: $75bd0a0b757f1168$var$_propTypes.default.func,
    scrollToEndButtonMiddleware: $75bd0a0b757f1168$var$_propTypes.default.oneOfType([
        $75bd0a0b757f1168$var$_propTypes.default.arrayOf($75bd0a0b757f1168$var$_propTypes.default.func),
        $75bd0a0b757f1168$var$_propTypes.default.func
    ]),
    selectVoice: $75bd0a0b757f1168$var$_propTypes.default.func,
    sendTimeout: $75bd0a0b757f1168$var$_propTypes.default.number,
    sendTypingIndicator: $75bd0a0b757f1168$var$_propTypes.default.bool,
    styleOptions: $75bd0a0b757f1168$var$_propTypes.default.any,
    toastMiddleware: $75bd0a0b757f1168$var$_propTypes.default.oneOfType([
        $75bd0a0b757f1168$var$_propTypes.default.arrayOf($75bd0a0b757f1168$var$_propTypes.default.func),
        $75bd0a0b757f1168$var$_propTypes.default.func
    ]),
    toastRenderer: $75bd0a0b757f1168$var$_propTypes.default.func,
    typingIndicatorMiddleware: $75bd0a0b757f1168$var$_propTypes.default.oneOfType([
        $75bd0a0b757f1168$var$_propTypes.default.arrayOf($75bd0a0b757f1168$var$_propTypes.default.func),
        $75bd0a0b757f1168$var$_propTypes.default.func
    ]),
    typingIndicatorRenderer: $75bd0a0b757f1168$var$_propTypes.default.func,
    userID: $75bd0a0b757f1168$var$_propTypes.default.string,
    username: $75bd0a0b757f1168$var$_propTypes.default.string
};
// We will create a Redux store if it was not passed in
var $75bd0a0b757f1168$var$ComposerWithStore = function ComposerWithStore(_ref10) {
    var onTelemetry = _ref10.onTelemetry, store = _ref10.store, props = $75bd0a0b757f1168$var$_objectWithoutProperties(_ref10, $75bd0a0b757f1168$var$_excluded);
    var _usePonyfill3 = (0, $75bd0a0b757f1168$var$_usePonyfill5.default)(), _usePonyfill4 = $75bd0a0b757f1168$var$_slicedToArray(_usePonyfill3, 1), ponyfill = _usePonyfill4[0];
    var memoizedStore = (0, $75bd0a0b757f1168$var$_react.useMemo)(function() {
        var _nextStore$getState$i;
        var nextStore = store || (0, $cG9B9.createStoreWithOptions)({
            ponyfill: ponyfill
        });
        var storePonyfill = ((_nextStore$getState$i = nextStore.getState().internal) === null || _nextStore$getState$i === void 0 ? void 0 : _nextStore$getState$i.ponyfill) || {};
        var keys = new Set([].concat($75bd0a0b757f1168$var$_toConsumableArray(Object.keys(storePonyfill)), $75bd0a0b757f1168$var$_toConsumableArray(Object.keys(ponyfill)))); // Filter out forbidden properties.
        keys.delete("prototype");
        Object.getOwnPropertyNames(Object.prototype).forEach(function(key) {
            keys.delete(key);
        });
        var nativeFunction = function nativeFunction(fn) {
            return typeof fn === "function" && ("" + fn).endsWith("() { [native code] }");
        };
        var ponyfillFunctionEquals = function ponyfillFunctionEquals(x, y) {
            return nativeFunction(x) && nativeFunction(y) || x === y;
        }; // We have filtered out all forbidden properties.
        // eslint-disable-next-line security/detect-object-injection
        var differentKeys = Array.from(keys).filter(function(key) {
            return !ponyfillFunctionEquals(storePonyfill[key], ponyfill[key]);
        });
        if (differentKeys.length) console.warn("botframework-webchat: Ponyfill used in store should match the ponyfill passed in props: ".concat(differentKeys.join(", ")));
        return nextStore;
    }, [
        ponyfill,
        store
    ]);
    return /*#__PURE__*/ $75bd0a0b757f1168$var$_react.default.createElement($g4TkW.default, {
        context: $75bd0a0b757f1168$var$_WebChatReduxContext.default,
        store: memoizedStore
    }, /*#__PURE__*/ $75bd0a0b757f1168$var$_react.default.createElement($75bd0a0b757f1168$var$_ActivityKeyerComposer.default, null, /*#__PURE__*/ $75bd0a0b757f1168$var$_react.default.createElement($75bd0a0b757f1168$var$_ActivityAcknowledgementComposer.default, null, /*#__PURE__*/ $75bd0a0b757f1168$var$_react.default.createElement($75bd0a0b757f1168$var$ComposerCore, $75bd0a0b757f1168$var$_extends({
        onTelemetry: onTelemetry
    }, props)))));
};
$75bd0a0b757f1168$var$ComposerWithStore.defaultProps = {
    onTelemetry: undefined,
    store: undefined
};
$75bd0a0b757f1168$var$ComposerWithStore.propTypes = {
    onTelemetry: $75bd0a0b757f1168$var$_propTypes.default.func,
    store: $75bd0a0b757f1168$var$_propTypes.default.any
};
var $75bd0a0b757f1168$var$Composer = function Composer(_ref11) {
    var internalRenderErrorBox = _ref11.internalRenderErrorBox, onTelemetry = _ref11.onTelemetry, ponyfill = _ref11.ponyfill, props = $75bd0a0b757f1168$var$_objectWithoutProperties(_ref11, $75bd0a0b757f1168$var$_excluded2);
    var _useState = (0, $75bd0a0b757f1168$var$_react.useState)(), _useState2 = $75bd0a0b757f1168$var$_slicedToArray(_useState, 2), error = _useState2[0], setError = _useState2[1];
    var handleError = (0, $75bd0a0b757f1168$var$_react.useCallback)(function(error) {
        console.error("botframework-webchat: Uncaught exception", {
            error: error
        });
        onTelemetry && onTelemetry((0, $75bd0a0b757f1168$var$_createCustomEvent.default)("exception", {
            error: error,
            fatal: true
        }));
        setError(error);
    }, [
        onTelemetry,
        setError
    ]);
    return error ? !!internalRenderErrorBox && internalRenderErrorBox({
        error: error,
        type: "uncaught exception"
    }) : /*#__PURE__*/ $75bd0a0b757f1168$var$_react.default.createElement($75bd0a0b757f1168$var$_ErrorBoundary.default, {
        onError: handleError
    }, /*#__PURE__*/ $75bd0a0b757f1168$var$_react.default.createElement($75bd0a0b757f1168$var$_PonyfillComposer.default, {
        ponyfill: ponyfill
    }, /*#__PURE__*/ $75bd0a0b757f1168$var$_react.default.createElement($75bd0a0b757f1168$var$ComposerWithStore, $75bd0a0b757f1168$var$_extends({
        onTelemetry: onTelemetry
    }, props))));
};
$75bd0a0b757f1168$var$Composer.defaultProps = $75bd0a0b757f1168$var$_objectSpread($75bd0a0b757f1168$var$_objectSpread({}, $75bd0a0b757f1168$var$ComposerWithStore.defaultProps), {}, {
    internalRenderErrorBox: undefined,
    onTelemetry: undefined,
    ponyfill: undefined
});
$75bd0a0b757f1168$var$Composer.propTypes = $75bd0a0b757f1168$var$_objectSpread($75bd0a0b757f1168$var$_objectSpread({}, $75bd0a0b757f1168$var$ComposerWithStore.propTypes), {}, {
    internalRenderErrorBox: $75bd0a0b757f1168$var$_propTypes.default.any,
    onTelemetry: $75bd0a0b757f1168$var$_propTypes.default.func,
    ponyfill: $75bd0a0b757f1168$var$_propTypes.default.any
});
var $75bd0a0b757f1168$var$_default = $75bd0a0b757f1168$var$Composer;
module.exports.default = $75bd0a0b757f1168$var$_default;

});
parcelRequire.register("jFWUk", function(module, exports) {
"use strict";
function $e52f8a76543cbf8d$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $e52f8a76543cbf8d$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $e52f8a76543cbf8d$var$_typeof(obj);
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e52f8a76543cbf8d$var$_react = $e52f8a76543cbf8d$var$_interopRequireWildcard((parcelRequire("eO7Kz")));

var $e52f8a76543cbf8d$var$_Context = $e52f8a76543cbf8d$var$_interopRequireDefault((parcelRequire("5GUvE")));

var $e52f8a76543cbf8d$var$_findLastIndex = $e52f8a76543cbf8d$var$_interopRequireDefault((parcelRequire("fg1YP")));

var $e52f8a76543cbf8d$var$_useActivities3 = $e52f8a76543cbf8d$var$_interopRequireDefault((parcelRequire("3GEzF")));

var $e52f8a76543cbf8d$var$_useActivityKeys3 = $e52f8a76543cbf8d$var$_interopRequireDefault((parcelRequire("cZiTX")));

var $e52f8a76543cbf8d$var$_usePrevious = $e52f8a76543cbf8d$var$_interopRequireDefault((parcelRequire("29KxH")));

var $e52f8a76543cbf8d$var$_useValueRef = $e52f8a76543cbf8d$var$_interopRequireDefault((parcelRequire("2mOk0")));
function $e52f8a76543cbf8d$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $e52f8a76543cbf8d$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($e52f8a76543cbf8d$var$_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $e52f8a76543cbf8d$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || $e52f8a76543cbf8d$var$_typeof(obj) !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $e52f8a76543cbf8d$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $e52f8a76543cbf8d$var$_slicedToArray(arr, i) {
    return $e52f8a76543cbf8d$var$_arrayWithHoles(arr) || $e52f8a76543cbf8d$var$_iterableToArrayLimit(arr, i) || $e52f8a76543cbf8d$var$_unsupportedIterableToArray(arr, i) || $e52f8a76543cbf8d$var$_nonIterableRest();
}
function $e52f8a76543cbf8d$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $e52f8a76543cbf8d$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $e52f8a76543cbf8d$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $e52f8a76543cbf8d$var$_createForOfIteratorHelper(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (!it) {
        if (Array.isArray(o) || (it = $e52f8a76543cbf8d$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
            if (it) o = it;
            var i = 0;
            var F = function F() {};
            return {
                s: F,
                n: function n() {
                    if (i >= o.length) return {
                        done: true
                    };
                    return {
                        done: false,
                        value: o[i++]
                    };
                },
                e: function e(_e2) {
                    throw _e2;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var normalCompletion = true, didErr = false, err;
    return {
        s: function s() {
            it = it.call(o);
        },
        n: function n() {
            var step = it.next();
            normalCompletion = step.done;
            return step;
        },
        e: function e(_e3) {
            didErr = true;
            err = _e3;
        },
        f: function f() {
            try {
                if (!normalCompletion && it.return != null) it.return();
            } finally{
                if (didErr) throw err;
            }
        }
    };
}
function $e52f8a76543cbf8d$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $e52f8a76543cbf8d$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $e52f8a76543cbf8d$var$_arrayLikeToArray(o, minLen);
}
function $e52f8a76543cbf8d$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $e52f8a76543cbf8d$var$findClosestActivityKeyIfNotExists(activityKey, keys, prevKeys) {
    if (keys.includes(activityKey)) return activityKey;
    else if (!prevKeys || !activityKey) // Initially, when the transcript was empty, there should be nothing read.
    return;
     // If the last activity key is no longer in this activities (say, deleted), we try to find the closest one.
    var prevIndex = prevKeys.indexOf(activityKey);
    if (~prevIndex) {
        // List out all previously activity keys, find the closest one that is in the new transcript.
        var acknowledgedActivityKeys = prevKeys.slice(0, prevIndex).reverse();
        var _iterator = $e52f8a76543cbf8d$var$_createForOfIteratorHelper(acknowledgedActivityKeys), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var prevAcknowledgedActivityKey = _step.value;
                if (keys.includes(prevAcknowledgedActivityKey)) return prevAcknowledgedActivityKey;
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
    } // If nothing is found, return `undefined`.
}
var $e52f8a76543cbf8d$var$ActivityAcknowledgementComposer = function ActivityAcknowledgementComposer(_ref) {
    var children = _ref.children;
    var _useActivities = (0, $e52f8a76543cbf8d$var$_useActivities3.default)(), _useActivities2 = $e52f8a76543cbf8d$var$_slicedToArray(_useActivities, 1), activities = _useActivities2[0];
    var _useActivityKeys = (0, $e52f8a76543cbf8d$var$_useActivityKeys3.default)(), _useActivityKeys2 = $e52f8a76543cbf8d$var$_slicedToArray(_useActivityKeys, 1), allActivityKeys = _useActivityKeys2[0];
    var _useState = (0, $e52f8a76543cbf8d$var$_react.useState)(), _useState2 = $e52f8a76543cbf8d$var$_slicedToArray(_useState, 2), rawLastAcknowledgedActivityKey = _useState2[0], setRawLastAcknowledgedActivityKey = _useState2[1];
    var _useState3 = (0, $e52f8a76543cbf8d$var$_react.useState)(), _useState4 = $e52f8a76543cbf8d$var$_slicedToArray(_useState3, 2), rawLastReadActivityKey = _useState4[0], setRawLastReadActivityKey = _useState4[1];
    var allActivityKeysRef = (0, $e52f8a76543cbf8d$var$_useValueRef.default)(allActivityKeys);
    var prevAllActivityKeys = (0, $e52f8a76543cbf8d$var$_usePrevious.default)(allActivityKeys);
    var lastOutgoingActivityKeyIndex = (0, $e52f8a76543cbf8d$var$_react.useMemo)(function() {
        return (0, $e52f8a76543cbf8d$var$_findLastIndex.default)(activities, function(activity) {
            var _activity$from;
            return ((_activity$from = activity.from) === null || _activity$from === void 0 ? void 0 : _activity$from.role) === "user";
        });
    }, [
        activities
    ]); // Make sure when we return "lastReadActivityKey" exists in the current transcript.
    var lastReadActivityKey = (0, $e52f8a76543cbf8d$var$_react.useMemo)(function() {
        rawLastReadActivityKey && !~prevAllActivityKeys.includes(rawLastReadActivityKey) && console.warn('botframework-webchat internal assertion: "rawLastReadActivityKey" of value '.concat(rawLastReadActivityKey, ' should be in the "prevAllActivityKeys" array.'));
        return $e52f8a76543cbf8d$var$findClosestActivityKeyIfNotExists(rawLastReadActivityKey, allActivityKeys, prevAllActivityKeys);
    }, [
        allActivityKeys,
        prevAllActivityKeys,
        rawLastReadActivityKey
    ]);
    var lastReadActivityKeyRef = (0, $e52f8a76543cbf8d$var$_useValueRef.default)(lastReadActivityKey); // Make sure when we return "lastAcknowledgedActivityKey" exists in the current transcript.
    var lastAcknowledgedActivityKey = (0, $e52f8a76543cbf8d$var$_react.useMemo)(function() {
        rawLastAcknowledgedActivityKey && !~prevAllActivityKeys.includes(rawLastAcknowledgedActivityKey) && console.warn('botframework-webchat internal assertion: "rawLastAcknowledgedActivityKey" of value '.concat(rawLastAcknowledgedActivityKey, ' should be in the "prevAllActivityKeys" array.'));
        var lastAcknowledgedActivityKey = $e52f8a76543cbf8d$var$findClosestActivityKeyIfNotExists(rawLastAcknowledgedActivityKey, allActivityKeys, prevAllActivityKeys); // TODO: [P2] Since Direct Line may send history and does not have read receipt.
        //            Thus, if we don't assume everything is acknowledged initially, while displaying the history,
        //            the transcript would soon stop scrolling.
        //            Thus, before the first outgoing activity is detected, we need to assume everything is acknowledged.
        return allActivityKeys[Math.max(allActivityKeys.indexOf(lastAcknowledgedActivityKey), lastOutgoingActivityKeyIndex)] || allActivityKeys[allActivityKeys.length - 1];
    }, [
        allActivityKeys,
        lastOutgoingActivityKeyIndex,
        prevAllActivityKeys,
        rawLastAcknowledgedActivityKey
    ]);
    var activityAcknowledgements = (0, $e52f8a76543cbf8d$var$_react.useMemo)(function() {
        var activityAcknowledgements = new Map();
        var lastAcknowledgedIndex = allActivityKeys.indexOf(lastAcknowledgedActivityKey);
        var lastReadIndex = allActivityKeys.indexOf(lastReadActivityKey);
        allActivityKeys.forEach(function(activityKey, index) {
            activityAcknowledgements.set(activityKey, {
                acknowledged: index <= lastAcknowledgedIndex,
                read: index <= lastReadIndex
            });
        });
        return Object.freeze(activityAcknowledgements);
    }, [
        allActivityKeys,
        lastAcknowledgedActivityKey,
        lastReadActivityKey
    ]);
    var activityAcknowledgementsRef = (0, $e52f8a76543cbf8d$var$_useValueRef.default)(activityAcknowledgements);
    var getHasAcknowledgedByActivityKey = (0, $e52f8a76543cbf8d$var$_react.useCallback)(function(activityKey) {
        var _activityAcknowledgem;
        return (_activityAcknowledgem = activityAcknowledgementsRef.current.get(activityKey)) === null || _activityAcknowledgem === void 0 ? void 0 : _activityAcknowledgem.acknowledged;
    }, [
        activityAcknowledgementsRef
    ]); // TODO: [P2] Memoize with `useMemoWithPrevious` for better memoization of arrays.
    var activityKeysByReadState = (0, $e52f8a76543cbf8d$var$_react.useMemo)(function() {
        var index = allActivityKeys.indexOf(lastReadActivityKey);
        return Object.freeze([
            Object.freeze(allActivityKeys.slice(0, index + 1)),
            Object.freeze(allActivityKeys.slice(index + 1))
        ]);
    }, [
        allActivityKeys,
        lastReadActivityKey
    ]);
    var markAllAsAcknowledged = (0, $e52f8a76543cbf8d$var$_react.useCallback)(function() {
        var allActivityKeys = allActivityKeysRef.current;
        setRawLastAcknowledgedActivityKey(allActivityKeys[allActivityKeys.length - 1]);
    }, [
        allActivityKeysRef,
        setRawLastAcknowledgedActivityKey
    ]);
    var markActivityKeyAsRead = (0, $e52f8a76543cbf8d$var$_react.useCallback)(function(activityKey) {
        var allActivityKeys = allActivityKeysRef.current;
        var index = allActivityKeys.indexOf(activityKey);
        if (!~index) return console.warn("botframework-webchat: Cannot mark activity with key ".concat(activityKey, " as read because it is not in the transcript."));
        index > allActivityKeys.indexOf(lastReadActivityKeyRef.current) && setRawLastReadActivityKey(activityKey);
    }, [
        allActivityKeysRef,
        lastReadActivityKeyRef,
        setRawLastReadActivityKey
    ]);
    if (activityKeysByReadState[0].length + activityKeysByReadState[1].length !== allActivityKeys.length) console.warn("botframework-webchat internal: Sum of count of read and unread activity keys MUST equals to total number of activity keys.");
    var contextValue = (0, $e52f8a76543cbf8d$var$_react.useMemo)(function() {
        return {
            activityKeysByReadState: activityKeysByReadState,
            getHasAcknowledgedByActivityKey: getHasAcknowledgedByActivityKey,
            lastAcknowledgedActivityKeyState: Object.freeze([
                lastAcknowledgedActivityKey
            ]),
            lastReadActivityKeyState: Object.freeze([
                lastReadActivityKey
            ]),
            markActivityKeyAsRead: markActivityKeyAsRead,
            markAllAsAcknowledged: markAllAsAcknowledged
        };
    }, [
        activityKeysByReadState,
        getHasAcknowledgedByActivityKey,
        lastAcknowledgedActivityKey,
        lastReadActivityKey,
        markActivityKeyAsRead,
        markAllAsAcknowledged
    ]);
    return /*#__PURE__*/ $e52f8a76543cbf8d$var$_react.default.createElement($e52f8a76543cbf8d$var$_Context.default.Provider, {
        value: contextValue
    }, children);
};
var $e52f8a76543cbf8d$var$_default = $e52f8a76543cbf8d$var$ActivityAcknowledgementComposer;
module.exports.default = $e52f8a76543cbf8d$var$_default;

});
parcelRequire.register("fg1YP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $b1b9e2d85ccc0c8c$var$findLastIndex;
function $b1b9e2d85ccc0c8c$var$_toConsumableArray(arr) {
    return $b1b9e2d85ccc0c8c$var$_arrayWithoutHoles(arr) || $b1b9e2d85ccc0c8c$var$_iterableToArray(arr) || $b1b9e2d85ccc0c8c$var$_unsupportedIterableToArray(arr) || $b1b9e2d85ccc0c8c$var$_nonIterableSpread();
}
function $b1b9e2d85ccc0c8c$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $b1b9e2d85ccc0c8c$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $b1b9e2d85ccc0c8c$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $b1b9e2d85ccc0c8c$var$_arrayLikeToArray(o, minLen);
}
function $b1b9e2d85ccc0c8c$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $b1b9e2d85ccc0c8c$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $b1b9e2d85ccc0c8c$var$_arrayLikeToArray(arr);
}
function $b1b9e2d85ccc0c8c$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $b1b9e2d85ccc0c8c$var$findLastIndex(array, predicate) {
    var index = $b1b9e2d85ccc0c8c$var$_toConsumableArray(array).reverse().findIndex(predicate);
    if (~index) {
        var _ref = array || [], length = _ref.length;
        return length - index - 1;
    }
    return index;
}

});

parcelRequire.register("29KxH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $19208665945d1f22$var$usePrevious;

var $eO7Kz = parcelRequire("eO7Kz");
function $19208665945d1f22$var$usePrevious(value) {
    var ref = (0, $eO7Kz.useRef)();
    (0, $eO7Kz.useEffect)(function() {
        ref.current = value;
    });
    return ref.current;
}

});

parcelRequire.register("2mOk0", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $1b94abac1cba0820$var$useValueRef;

var $eO7Kz = parcelRequire("eO7Kz");
function $1b94abac1cba0820$var$useValueRef(value) {
    var ref = (0, $eO7Kz.useRef)();
    var readOnlyRef = (0, $eO7Kz.useMemo)(function() {
        return Object.create({}, {
            current: {
                get: function get() {
                    return ref.current;
                }
            }
        });
    }, []);
    ref.current = value;
    return readOnlyRef;
}

});


parcelRequire.register("e4ypX", function(module, exports) {
"use strict";
function $a3ec2310640f5278$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $a3ec2310640f5278$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $a3ec2310640f5278$var$_typeof(obj);
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a3ec2310640f5278$var$_propTypes = $a3ec2310640f5278$var$_interopRequireDefault((parcelRequire("f7UXb")));

var $a3ec2310640f5278$var$_react = $a3ec2310640f5278$var$_interopRequireWildcard((parcelRequire("eO7Kz")));

var $a3ec2310640f5278$var$_Context = $a3ec2310640f5278$var$_interopRequireDefault((parcelRequire("29tYV")));

var $a3ec2310640f5278$var$_getActivityId = $a3ec2310640f5278$var$_interopRequireDefault((parcelRequire("f6UdP")));

var $a3ec2310640f5278$var$_getClientActivityId = $a3ec2310640f5278$var$_interopRequireDefault((parcelRequire("8YxVH")));

var $a3ec2310640f5278$var$_uniqueId = $a3ec2310640f5278$var$_interopRequireDefault((parcelRequire("hgp66")));

var $a3ec2310640f5278$var$_useActivities3 = $a3ec2310640f5278$var$_interopRequireDefault((parcelRequire("3GEzF")));

var $a3ec2310640f5278$var$_useContext = $a3ec2310640f5278$var$_interopRequireDefault((parcelRequire("bR8cL")));
function $a3ec2310640f5278$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($a3ec2310640f5278$var$_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $a3ec2310640f5278$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || $a3ec2310640f5278$var$_typeof(obj) !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $a3ec2310640f5278$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $a3ec2310640f5278$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $a3ec2310640f5278$var$_slicedToArray(arr, i) {
    return $a3ec2310640f5278$var$_arrayWithHoles(arr) || $a3ec2310640f5278$var$_iterableToArrayLimit(arr, i) || $a3ec2310640f5278$var$_unsupportedIterableToArray(arr, i) || $a3ec2310640f5278$var$_nonIterableRest();
}
function $a3ec2310640f5278$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $a3ec2310640f5278$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $a3ec2310640f5278$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $a3ec2310640f5278$var$_arrayLikeToArray(o, minLen);
}
function $a3ec2310640f5278$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $a3ec2310640f5278$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $a3ec2310640f5278$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
/**
 * React context composer component to assign a perma-key to every activity.
 * This will support both `useGetActivityByKey` and `useGetKeyByActivity` custom hooks.
 *
 * Today, `activity.id` is only guaranteed for activity from others.
 * Not all activities sent by the local user has `activity.id`.
 *
 * To track outgoing activities, we added `activity.channelData.clientActivityId`.
 *
 * This component will create a local key, which can be used to track both
 * incoming and outgoing activities in a consistent way.
 *
 * Local key are only persisted in memory. On refresh, they will be a new random key.
 */ var $a3ec2310640f5278$var$ActivityKeyerComposer = function ActivityKeyerComposer(_ref) {
    var children = _ref.children;
    var existingContext = (0, $a3ec2310640f5278$var$_useContext.default)(false);
    if (existingContext) throw new Error("botframework-webchat internal: <ActivityKeyerComposer> should not be nested.");
    var _useActivities = (0, $a3ec2310640f5278$var$_useActivities3.default)(), _useActivities2 = $a3ec2310640f5278$var$_slicedToArray(_useActivities, 1), activities = _useActivities2[0];
    var activityIdToKeyMapRef = (0, $a3ec2310640f5278$var$_react.useRef)(Object.freeze(new Map()));
    var activityToKeyMapRef = (0, $a3ec2310640f5278$var$_react.useRef)(Object.freeze(new Map()));
    var clientActivityIdToKeyMapRef = (0, $a3ec2310640f5278$var$_react.useRef)(Object.freeze(new Map()));
    var keyToActivityMapRef = (0, $a3ec2310640f5278$var$_react.useRef)(Object.freeze(new Map())); // TODO: [P1] `useMemoWithPrevious` to check and cache the resulting array if it hasn't changed.
    var activityKeysState = (0, $a3ec2310640f5278$var$_react.useMemo)(function() {
        var activityIdToKeyMap = activityIdToKeyMapRef.current;
        var activityToKeyMap = activityToKeyMapRef.current;
        var clientActivityIdToKeyMap = clientActivityIdToKeyMapRef.current;
        var nextActivityIdToKeyMap = new Map();
        var nextActivityKeys = [];
        var nextActivityToKeyMap = new Map();
        var nextClientActivityIdToKeyMap = new Map();
        var nextKeyToActivityMap = new Map();
        activities.forEach(function(activity) {
            var activityId = (0, $a3ec2310640f5278$var$_getActivityId.default)(activity);
            var clientActivityId = (0, $a3ec2310640f5278$var$_getClientActivityId.default)(activity);
            var key = clientActivityId && clientActivityIdToKeyMap.get(clientActivityId) || activityId && activityIdToKeyMap.get(activityId) || activityToKeyMap.get(activity) || (0, $a3ec2310640f5278$var$_uniqueId.default)();
            activityId && nextActivityIdToKeyMap.set(activityId, key);
            clientActivityId && nextClientActivityIdToKeyMap.set(clientActivityId, key);
            nextActivityToKeyMap.set(activity, key);
            nextKeyToActivityMap.set(key, activity);
            nextActivityKeys.push(key);
        });
        activityIdToKeyMapRef.current = Object.freeze(nextActivityIdToKeyMap);
        activityToKeyMapRef.current = Object.freeze(nextActivityToKeyMap);
        clientActivityIdToKeyMapRef.current = Object.freeze(nextClientActivityIdToKeyMap);
        keyToActivityMapRef.current = Object.freeze(nextKeyToActivityMap); // `nextActivityKeys` could potentially same as `prevActivityKeys` despite reference differences, we should memoize it.
        return Object.freeze([
            Object.freeze(nextActivityKeys)
        ]);
    }, [
        activities,
        activityIdToKeyMapRef,
        activityToKeyMapRef,
        clientActivityIdToKeyMapRef,
        keyToActivityMapRef
    ]);
    var getActivityByKey = (0, $a3ec2310640f5278$var$_react.useCallback)(function(key) {
        return key && keyToActivityMapRef.current.get(key);
    }, [
        keyToActivityMapRef
    ]);
    var getKeyByActivity = (0, $a3ec2310640f5278$var$_react.useCallback)(function(activity) {
        return activity && activityToKeyMapRef.current.get(activity);
    }, [
        activityToKeyMapRef
    ]);
    var getKeyByActivityId = (0, $a3ec2310640f5278$var$_react.useCallback)(function(activityId) {
        return activityId && activityIdToKeyMapRef.current.get(activityId);
    }, [
        activityIdToKeyMapRef
    ]);
    var contextValue = (0, $a3ec2310640f5278$var$_react.useMemo)(function() {
        return {
            activityKeysState: activityKeysState,
            getActivityByKey: getActivityByKey,
            getKeyByActivity: getKeyByActivity,
            getKeyByActivityId: getKeyByActivityId
        };
    }, [
        activityKeysState,
        getActivityByKey,
        getKeyByActivity,
        getKeyByActivityId
    ]);
    var numActivities = activities.length;
    if (activityIdToKeyMapRef.current.size > numActivities) console.warn('botframework-webchat internal assertion: "activityIdToKeyMap.size" should be equal or less than "activities.length".');
    if (activityToKeyMapRef.current.size !== numActivities) console.warn('botframework-webchat internal assertion: "activityToKeyMap.size" should be same as "activities.length".');
    if (clientActivityIdToKeyMapRef.current.size > numActivities) console.warn('botframework-webchat internal assertion: "clientActivityIdToKeyMap.size" should be equal or less than "activities.length".');
    if (keyToActivityMapRef.current.size !== numActivities) console.warn('botframework-webchat internal assertion: "keyToActivityMap.size" should be same as "activities.length".');
    if (activityKeysState[0].length !== numActivities) console.warn('botframework-webchat internal assertion: "activityKeys.length" should be same as "activities.length".');
    return /*#__PURE__*/ $a3ec2310640f5278$var$_react.default.createElement($a3ec2310640f5278$var$_Context.default.Provider, {
        value: contextValue
    }, children);
};
$a3ec2310640f5278$var$ActivityKeyerComposer.defaultProps = {
    children: undefined
};
$a3ec2310640f5278$var$ActivityKeyerComposer.propTypes = {
    children: $a3ec2310640f5278$var$_propTypes.default.any
};
var $a3ec2310640f5278$var$_default = $a3ec2310640f5278$var$ActivityKeyerComposer;
module.exports.default = $a3ec2310640f5278$var$_default;

});
parcelRequire.register("f6UdP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $b003071494d3c6f4$var$getActivityId;
function $b003071494d3c6f4$var$getActivityId(activity) {
    return activity.id;
}

});

parcelRequire.register("8YxVH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $688e3f0c2a7ba984$var$getClientActivityId;
function $688e3f0c2a7ba984$var$getClientActivityId(activity) {
    var _activity$channelData;
    return (_activity$channelData = activity.channelData) === null || _activity$channelData === void 0 ? void 0 : _activity$channelData.clientActivityID;
}

});

parcelRequire.register("hgp66", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $c917661f79194233$var$uniqueId;

var $c917661f79194233$var$_mathRandom = $c917661f79194233$var$_interopRequireDefault((parcelRequire("atZsr")));
function $c917661f79194233$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
// This format ID must be compatible with HTML "className" and "id" attribute.
// It will be suffixed as "webchat__activity--{id}".
function $c917661f79194233$var$uniqueId() {
    // eslint-disable-next-line no-magic-numbers
    return (0, $c917661f79194233$var$_mathRandom.default)().toString(36).substring(2, 7);
}

});


parcelRequire.register("9KqWE", function(module, exports) {
"use strict";
function $718d4fa0fa578018$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $718d4fa0fa578018$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $718d4fa0fa578018$var$_typeof(obj);
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $718d4fa0fa578018$var$_react = $718d4fa0fa578018$var$_interopRequireWildcard((parcelRequire("eO7Kz")));

var $hLqEr = parcelRequire("hLqEr");

var $718d4fa0fa578018$var$_Context = $718d4fa0fa578018$var$_interopRequireDefault((parcelRequire("1p0Hj")));

var $718d4fa0fa578018$var$_freezeArray = $718d4fa0fa578018$var$_interopRequireDefault((parcelRequire("12IGi")));

var $718d4fa0fa578018$var$_isMapEqual = $718d4fa0fa578018$var$_interopRequireDefault((parcelRequire("6QBHf")));

var $718d4fa0fa578018$var$_useActivities3 = $718d4fa0fa578018$var$_interopRequireDefault((parcelRequire("3GEzF")));

var $718d4fa0fa578018$var$_useForceRender = $718d4fa0fa578018$var$_interopRequireDefault((parcelRequire("dC5YF")));

var $718d4fa0fa578018$var$_useGetKeyByActivity = $718d4fa0fa578018$var$_interopRequireDefault((parcelRequire("9eAGy")));

var $718d4fa0fa578018$var$_useGetSendTimeoutForActivity = $718d4fa0fa578018$var$_interopRequireDefault((parcelRequire("jjkwr")));

var $718d4fa0fa578018$var$_usePonyfill3 = $718d4fa0fa578018$var$_interopRequireDefault((parcelRequire("44MU5")));
function $718d4fa0fa578018$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $718d4fa0fa578018$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($718d4fa0fa578018$var$_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $718d4fa0fa578018$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || $718d4fa0fa578018$var$_typeof(obj) !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $718d4fa0fa578018$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $718d4fa0fa578018$var$_createForOfIteratorHelper(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (!it) {
        if (Array.isArray(o) || (it = $718d4fa0fa578018$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
            if (it) o = it;
            var i = 0;
            var F = function F() {};
            return {
                s: F,
                n: function n() {
                    if (i >= o.length) return {
                        done: true
                    };
                    return {
                        done: false,
                        value: o[i++]
                    };
                },
                e: function e(_e2) {
                    throw _e2;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var normalCompletion = true, didErr = false, err;
    return {
        s: function s() {
            it = it.call(o);
        },
        n: function n() {
            var step = it.next();
            normalCompletion = step.done;
            return step;
        },
        e: function e(_e3) {
            didErr = true;
            err = _e3;
        },
        f: function f() {
            try {
                if (!normalCompletion && it.return != null) it.return();
            } finally{
                if (didErr) throw err;
            }
        }
    };
}
function $718d4fa0fa578018$var$_slicedToArray(arr, i) {
    return $718d4fa0fa578018$var$_arrayWithHoles(arr) || $718d4fa0fa578018$var$_iterableToArrayLimit(arr, i) || $718d4fa0fa578018$var$_unsupportedIterableToArray(arr, i) || $718d4fa0fa578018$var$_nonIterableRest();
}
function $718d4fa0fa578018$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $718d4fa0fa578018$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $718d4fa0fa578018$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $718d4fa0fa578018$var$_arrayLikeToArray(o, minLen);
}
function $718d4fa0fa578018$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $718d4fa0fa578018$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $718d4fa0fa578018$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
// Magic numbers for `expiryByActivityKey`.
var $718d4fa0fa578018$var$EXPIRY_SEND_FAILED = -Infinity;
var $718d4fa0fa578018$var$EXPIRY_SENT = Infinity;
var $718d4fa0fa578018$var$ActivitySendStatusComposer = function ActivitySendStatusComposer(_ref) {
    var children = _ref.children;
    var _useActivities = (0, $718d4fa0fa578018$var$_useActivities3.default)(), _useActivities2 = $718d4fa0fa578018$var$_slicedToArray(_useActivities, 1), activities = _useActivities2[0];
    var _usePonyfill = (0, $718d4fa0fa578018$var$_usePonyfill3.default)(), _usePonyfill2 = $718d4fa0fa578018$var$_slicedToArray(_usePonyfill, 1), _usePonyfill2$ = _usePonyfill2[0], clearTimeout = _usePonyfill2$.clearTimeout, Date = _usePonyfill2$.Date, setTimeout = _usePonyfill2$.setTimeout;
    var forceRender = (0, $718d4fa0fa578018$var$_useForceRender.default)();
    var getKeyByActivity = (0, $718d4fa0fa578018$var$_useGetKeyByActivity.default)();
    var getSendTimeoutForActivity = (0, $718d4fa0fa578018$var$_useGetSendTimeoutForActivity.default)();
    var sendStatusByActivityKeyRef = (0, $718d4fa0fa578018$var$_react.useRef)(Object.freeze(new Map()));
    /**
   * Map of outgoing activities and their respective expiry.
   *
   * The key is the activity key.
   *
   * The value is:
   *
   * - `Infinity` if the activity is already sent (and will never expire), otherwise;
   * - `-Infinity` if the activity failed to send (a.k.a. already expired), otherwise;
   * - An epoch time of when the activity will be expired.
   */ var expiryByActivityKey = (0, $718d4fa0fa578018$var$_react.useMemo)(function() {
        return Object.freeze(activities.reduce(function(expiryByActivityKey, activity) {
            if (activity.from.role === "user") {
                var key = getKeyByActivity(activity);
                if (key) {
                    var _activity$channelData = activity.channelData, state = _activity$channelData.state, sendStatus = _activity$channelData["webchat:send-status"]; // `channelData.state` is being deprecated in favor of `channelData['webchat:send-status']`.
                    // Please refer to #4362 for details. Remove on or after 2024-07-31.
                    var rectifiedSendStatus = sendStatus || (state === $hLqEr.SENT ? $hLqEr.SENT : $hLqEr.SENDING);
                    if (rectifiedSendStatus === $hLqEr.SENT) expiryByActivityKey.set(key, $718d4fa0fa578018$var$EXPIRY_SENT);
                    else if (rectifiedSendStatus === $hLqEr.SEND_FAILED) expiryByActivityKey.set(key, $718d4fa0fa578018$var$EXPIRY_SEND_FAILED);
                    else {
                        var expiry = +new Date(activity.localTimestamp) + getSendTimeoutForActivity({
                            activity: activity
                        });
                        expiry && expiryByActivityKey.set(key, expiry);
                    }
                }
            }
            return expiryByActivityKey;
        }, new Map()));
    }, [
        activities,
        Date,
        getKeyByActivity,
        getSendTimeoutForActivity
    ]);
    /** Map of outgoing activities and their respective send status. */ var nextSendStatusByActivityKey = new Map();
    var now = Date.now(); // Turns the expiry (epoch time) into `SendStatus`, which is based on current clock.
    var _iterator = $718d4fa0fa578018$var$_createForOfIteratorHelper(expiryByActivityKey), _step;
    try {
        for(_iterator.s(); !(_step = _iterator.n()).done;){
            var _step$value = $718d4fa0fa578018$var$_slicedToArray(_step.value, 2), key = _step$value[0], expiry = _step$value[1];
            nextSendStatusByActivityKey.set(key, expiry === $718d4fa0fa578018$var$EXPIRY_SENT ? $hLqEr.SENT : now >= expiry ? $hLqEr.SEND_FAILED : $hLqEr.SENDING);
        } // Only memoize the new result if it has changed.
    } catch (err) {
        _iterator.e(err);
    } finally{
        _iterator.f();
    }
    if (!(0, $718d4fa0fa578018$var$_isMapEqual.default)(sendStatusByActivityKeyRef.current, nextSendStatusByActivityKey)) sendStatusByActivityKeyRef.current = Object.freeze(nextSendStatusByActivityKey);
     // Gets/realizes the `current` from `ref` because we need to use it for `deps` array in hooks for memoization.
    var sendStatusByActivityKey = sendStatusByActivityKeyRef.current;
    var sendStatusByActivityKeyState = (0, $718d4fa0fa578018$var$_react.useMemo)(function() {
        return (0, $718d4fa0fa578018$var$_freezeArray.default)([
            sendStatusByActivityKey
        ]);
    }, [
        sendStatusByActivityKey
    ]);
    var context = (0, $718d4fa0fa578018$var$_react.useMemo)(function() {
        return {
            sendStatusByActivityKeyState: sendStatusByActivityKeyState
        };
    }, [
        sendStatusByActivityKeyState
    ]); // Finds the closest expiry. This is the time we should recompute `sendStatusByActivityKey`.
    var nextExpiry = Array.from(expiryByActivityKey.values()) // Ignores activities which are already marked as `"send failed"`, because the magic number its `-Infinity`.
    // We don't need to recompute them because `"send failed"` cannot change back to `"sending"` without modifying `activities` or `styleOptions`.
    .reduce(function(nextExpiry, expiry) {
        // Finds the next closest expiry, exclude those that already expired.
        if (expiry > now && expiry < nextExpiry) return expiry;
        return nextExpiry;
    }, Infinity); // When the activity with closest expiry expire, recomputes everything so the `sendStatusByActivityKey` will be updated.
    (0, $718d4fa0fa578018$var$_react.useEffect)(function() {
        if (nextExpiry) {
            var timeout = setTimeout(forceRender, nextExpiry - Date.now());
            return function() {
                return clearTimeout(timeout);
            };
        }
    }, [
        clearTimeout,
        Date,
        forceRender,
        nextExpiry,
        setTimeout
    ]);
    return /*#__PURE__*/ $718d4fa0fa578018$var$_react.default.createElement($718d4fa0fa578018$var$_Context.default.Provider, {
        value: context
    }, children);
};
var $718d4fa0fa578018$var$_default = $718d4fa0fa578018$var$ActivitySendStatusComposer;
module.exports.default = $718d4fa0fa578018$var$_default;

});
parcelRequire.register("12IGi", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
/**
 * This is same as `Object.freeze` with improved typing for typed arrays.
 *
 * In TypeScript, `Object.freeze([1])` is `number[]`.
 *
 * Instead, `freezeArray([1])` is `[number]` and supports up to 5 elements in the array.
 */ function $0c28a318580eba28$var$freezeArray(array) {
    return Object.freeze(array);
}
var $0c28a318580eba28$var$_default = $0c28a318580eba28$var$freezeArray;
module.exports.default = $0c28a318580eba28$var$_default;

});

parcelRequire.register("6QBHf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $4fc4d72e07a958d3$var$isMapEqual;
function $4fc4d72e07a958d3$var$_createForOfIteratorHelper(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (!it) {
        if (Array.isArray(o) || (it = $4fc4d72e07a958d3$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
            if (it) o = it;
            var i = 0;
            var F = function F() {};
            return {
                s: F,
                n: function n() {
                    if (i >= o.length) return {
                        done: true
                    };
                    return {
                        done: false,
                        value: o[i++]
                    };
                },
                e: function e(_e) {
                    throw _e;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var normalCompletion = true, didErr = false, err;
    return {
        s: function s() {
            it = it.call(o);
        },
        n: function n() {
            var step = it.next();
            normalCompletion = step.done;
            return step;
        },
        e: function e(_e2) {
            didErr = true;
            err = _e2;
        },
        f: function f() {
            try {
                if (!normalCompletion && it.return != null) it.return();
            } finally{
                if (didErr) throw err;
            }
        }
    };
}
function $4fc4d72e07a958d3$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $4fc4d72e07a958d3$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $4fc4d72e07a958d3$var$_arrayLikeToArray(o, minLen);
}
function $4fc4d72e07a958d3$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
/**
 * Returns `true` if both `Map` are different, otherwise, `false`.
 *
 * The equality of the value is compared using `Object.is`.
 */ function $4fc4d72e07a958d3$var$isMapEqual(x, y) {
    if (!x && y || x && !y) return false;
    var xKeys = new Set(x === null || x === void 0 ? void 0 : x.keys());
    var yKeys = new Set(y === null || y === void 0 ? void 0 : y.keys());
    if (xKeys.size !== yKeys.size) return false;
    var _iterator = $4fc4d72e07a958d3$var$_createForOfIteratorHelper(yKeys), _step;
    try {
        for(_iterator.s(); !(_step = _iterator.n()).done;){
            var key = _step.value;
            xKeys.add(key);
        }
    } catch (err) {
        _iterator.e(err);
    } finally{
        _iterator.f();
    }
    if (xKeys.size !== yKeys.size) return false;
    var _iterator2 = $4fc4d72e07a958d3$var$_createForOfIteratorHelper(xKeys), _step2;
    try {
        for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
            var _key = _step2.value;
            if (!Object.is(x.get(_key), y.get(_key))) return false;
        }
    } catch (err) {
        _iterator2.e(err);
    } finally{
        _iterator2.f();
    }
    return true;
}

});


parcelRequire.register("dDdBM", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $gySRD = parcelRequire("gySRD");

var $9ec9793a499e715d$var$_usePrevious = $9ec9793a499e715d$var$_interopRequireDefault((parcelRequire("29KxH")));
function $9ec9793a499e715d$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $9ec9793a499e715d$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $9ec9793a499e715d$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $9ec9793a499e715d$var$ownKeys(Object(source), !0).forEach(function(key) {
            $9ec9793a499e715d$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $9ec9793a499e715d$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $9ec9793a499e715d$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $9ec9793a499e715d$var$_createForOfIteratorHelper(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (!it) {
        if (Array.isArray(o) || (it = $9ec9793a499e715d$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
            if (it) o = it;
            var i = 0;
            var F = function F() {};
            return {
                s: F,
                n: function n() {
                    if (i >= o.length) return {
                        done: true
                    };
                    return {
                        done: false,
                        value: o[i++]
                    };
                },
                e: function e(_e2) {
                    throw _e2;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var normalCompletion = true, didErr = false, err;
    return {
        s: function s() {
            it = it.call(o);
        },
        n: function n() {
            var step = it.next();
            normalCompletion = step.done;
            return step;
        },
        e: function e(_e3) {
            didErr = true;
            err = _e3;
        },
        f: function f() {
            try {
                if (!normalCompletion && it.return != null) it.return();
            } finally{
                if (didErr) throw err;
            }
        }
    };
}
function $9ec9793a499e715d$var$_slicedToArray(arr, i) {
    return $9ec9793a499e715d$var$_arrayWithHoles(arr) || $9ec9793a499e715d$var$_iterableToArrayLimit(arr, i) || $9ec9793a499e715d$var$_unsupportedIterableToArray(arr, i) || $9ec9793a499e715d$var$_nonIterableRest();
}
function $9ec9793a499e715d$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $9ec9793a499e715d$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $9ec9793a499e715d$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $9ec9793a499e715d$var$_arrayLikeToArray(o, minLen);
}
function $9ec9793a499e715d$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $9ec9793a499e715d$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $9ec9793a499e715d$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
var $9ec9793a499e715d$var$ActivitySendStatusTelemetryComposer = function ActivitySendStatusTelemetryComposer() {
    var _useSendStatusByActiv = (0, $gySRD.useSendStatusByActivityKey)(), _useSendStatusByActiv2 = $9ec9793a499e715d$var$_slicedToArray(_useSendStatusByActiv, 1), activityToSendStatusMap = _useSendStatusByActiv2[0];
    var prevActivityToSendStatusMap = (0, $9ec9793a499e715d$var$_usePrevious.default)(activityToSendStatusMap);
    var getActivityByKey = (0, $gySRD.useGetActivityByKey)();
    var trackEvent = (0, $gySRD.useTrackEvent)();
    if (prevActivityToSendStatusMap) {
        var _iterator = $9ec9793a499e715d$var$_createForOfIteratorHelper(activityToSendStatusMap.keys()), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var key = _step.value;
                var status = activityToSendStatusMap.get(key);
                var prevStatus = prevActivityToSendStatusMap.get(key); // `status` is falsy if it is not an outgoing activity.
                // `prevStatus` is undefined or a valid status, if it is undefined, it is newly added
                // This telemetry data point only emit changes in outgoing activities.
                if (status && status !== prevStatus) {
                    var _activity$attachments;
                    var activity = getActivityByKey(key);
                    var clientActivityID = activity === null || activity === void 0 ? void 0 : activity.channelData.clientActivityID;
                    var type = activity === null || activity === void 0 ? void 0 : activity.type;
                    var telemetryPayload = $9ec9793a499e715d$var$_objectSpread($9ec9793a499e715d$var$_objectSpread({
                        hasAttachment: (activity === null || activity === void 0 ? void 0 : activity.type) === "message" && ((_activity$attachments = activity.attachments) === null || _activity$attachments === void 0 ? void 0 : _activity$attachments.length) > 0 ? "true" : "false",
                        key: key,
                        status: status
                    }, clientActivityID ? {
                        clientActivityID: clientActivityID
                    } : {}), type ? {
                        type: type
                    } : {}); // Only add prevStatus if it is NOT null/undefined
                    if (prevStatus) telemetryPayload.prevStatus = prevStatus;
                    trackEvent("send-status:change", telemetryPayload);
                }
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
    }
    return null;
};
var $9ec9793a499e715d$var$_default = $9ec9793a499e715d$var$ActivitySendStatusTelemetryComposer;
module.exports.default = $9ec9793a499e715d$var$_default;

});

parcelRequire.register("9NiB7", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $72171dc3011f53dd$var$createDefaultCardActionMiddleware;

var $cG9B9 = parcelRequire("cG9B9");
function $72171dc3011f53dd$var$createDefaultCardActionMiddleware() {
    return function(_ref) {
        var dispatch = _ref.dispatch;
        return function(next) {
            return function() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                var _args$ = args[0], cardAction = _args$.cardAction, value = _args$.cardAction.value; // We cannot use destructured "type" here because TypeScript don't recognize "messageBack" is "MessageBackCardAction".
                switch(cardAction.type){
                    case "imBack":
                        if (typeof value === "string") // TODO: [P4] Instead of calling dispatch, we should move to dispatchers instead for completeness
                        dispatch((0, $cG9B9.sendMessage)(value, "imBack"));
                        else throw new Error('cannot send "imBack" with a non-string value');
                        break;
                    case "messageBack":
                        dispatch((0, $cG9B9.sendMessageBack)(value, cardAction.text, cardAction.displayText));
                        break;
                    case "postBack":
                        dispatch((0, $cG9B9.sendPostBack)(value));
                        break;
                    default:
                        return next.apply(void 0, args);
                }
            };
        };
    };
}

});

parcelRequire.register("d5ubR", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $9873292361dd841e$var$createDefaultGroupActivitiesMiddleware;

var $hLqEr = parcelRequire("hLqEr");
function $9873292361dd841e$var$bin(items, grouping) {
    var lastBin;
    var bins = [];
    var lastItem;
    items.forEach(function(item) {
        if (lastItem && grouping(lastItem, item)) lastBin.push(item);
        else {
            lastBin = [
                item
            ];
            bins.push(lastBin);
        }
        lastItem = item;
    });
    return bins;
}
function $9873292361dd841e$var$sending(activity) {
    if (activity.from.role === "user") {
        var _activity$channelData = activity.channelData, state = _activity$channelData.state, sendStatus = _activity$channelData["webchat:send-status"]; // `channelData.state` is being deprecated in favor of `channelData['webchat:send-status']`.
        // Please refer to #4362 for details. Remove on or after 2024-07-31.
        return sendStatus || (state === $hLqEr.SENT ? $hLqEr.SENT : $hLqEr.SENDING);
    }
}
function $9873292361dd841e$var$shouldGroupTimestamp(activityX, activityY, groupTimestamp, _ref) {
    var Date = _ref.Date;
    if (groupTimestamp === false) // Hide timestamp for all activities.
    return true;
    else if (activityX && activityY) {
        if ($9873292361dd841e$var$sending(activityX) !== $9873292361dd841e$var$sending(activityY)) return false;
        groupTimestamp = typeof groupTimestamp === "number" ? groupTimestamp : Infinity;
        var timeX = new Date(activityX.timestamp).getTime();
        var timeY = new Date(activityY.timestamp).getTime();
        return Math.abs(timeX - timeY) <= groupTimestamp;
    }
    return false;
}
function $9873292361dd841e$var$createDefaultGroupActivitiesMiddleware(_ref2) {
    var groupTimestamp = _ref2.groupTimestamp, ponyfill = _ref2.ponyfill;
    return function() {
        return function() {
            return function(_ref3) {
                var activities = _ref3.activities;
                return {
                    sender: $9873292361dd841e$var$bin(activities, function(x, y) {
                        return x.from.role === y.from.role;
                    }),
                    status: $9873292361dd841e$var$bin(activities, function(x, y) {
                        return $9873292361dd841e$var$shouldGroupTimestamp(x, y, groupTimestamp, ponyfill);
                    })
                };
            };
        };
    };
}

});

parcelRequire.register("3IrWT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $2b4b293e99749646$var$_default;
function $2b4b293e99749646$var$_default(_ref, voices, activity) {
    var language = _ref.language;
    // Find the first voice based on this order:
    // 1. Voice with language same as locale as defined in the activity
    // 2. Voice with language same as locale as passed into Web Chat
    // 3. Voice with language same as browser
    // 4. English (United States)
    // 5. First voice
    // We also prioritize voices powered by deep neural network (with keyword "neural" in the voice name).
    return [
        activity.locale,
        language,
        window.navigator.language,
        "en-US"
    ].reduce(function(result, targetLanguage) {
        return result || voices.find(function(_ref2) {
            var lang = _ref2.lang, name = _ref2.name;
            return lang === targetLanguage && /neural/i.test(name);
        }) || voices.find(function(_ref3) {
            var lang = _ref3.lang;
            return lang === targetLanguage;
        });
    }, null) || voices[0];
}

});

parcelRequire.register("fokl9", function(module, exports) {
"use strict";
function $b348e003dfa7db55$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $b348e003dfa7db55$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $b348e003dfa7db55$var$_typeof(obj);
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b348e003dfa7db55$var$_react = $b348e003dfa7db55$var$_interopRequireWildcard((parcelRequire("eO7Kz")));

var $b348e003dfa7db55$var$_propTypes = $b348e003dfa7db55$var$_interopRequireDefault((parcelRequire("f7UXb")));
function $b348e003dfa7db55$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $b348e003dfa7db55$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($b348e003dfa7db55$var$_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $b348e003dfa7db55$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || $b348e003dfa7db55$var$_typeof(obj) !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $b348e003dfa7db55$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $b348e003dfa7db55$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $b348e003dfa7db55$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $b348e003dfa7db55$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $b348e003dfa7db55$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $b348e003dfa7db55$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $b348e003dfa7db55$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $b348e003dfa7db55$var$_setPrototypeOf(subClass, superClass);
}
function $b348e003dfa7db55$var$_setPrototypeOf(o, p) {
    $b348e003dfa7db55$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $b348e003dfa7db55$var$_setPrototypeOf(o, p);
}
function $b348e003dfa7db55$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $b348e003dfa7db55$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $b348e003dfa7db55$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $b348e003dfa7db55$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $b348e003dfa7db55$var$_possibleConstructorReturn(this, result);
    };
}
function $b348e003dfa7db55$var$_possibleConstructorReturn(self, call) {
    if (call && ($b348e003dfa7db55$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $b348e003dfa7db55$var$_assertThisInitialized(self);
}
function $b348e003dfa7db55$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $b348e003dfa7db55$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $b348e003dfa7db55$var$_getPrototypeOf(o) {
    $b348e003dfa7db55$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $b348e003dfa7db55$var$_getPrototypeOf(o);
}
var $b348e003dfa7db55$var$RenderChildrenFunction = function RenderChildrenFunction(_ref) {
    var children = _ref.children;
    return typeof children === "function" ? children() : children;
};
var $b348e003dfa7db55$var$ErrorBoundary = /*#__PURE__*/ function(_Component) {
    $b348e003dfa7db55$var$_inherits(ErrorBoundary, _Component);
    var _super = $b348e003dfa7db55$var$_createSuper(ErrorBoundary);
    function ErrorBoundary() {
        var _this;
        $b348e003dfa7db55$var$_classCallCheck(this, ErrorBoundary);
        _this = _super.call(this);
        _this.state = {
            hasError: false
        };
        return _this;
    }
    $b348e003dfa7db55$var$_createClass(ErrorBoundary, [
        {
            key: "componentDidCatch",
            value: function componentDidCatch(error) {
                var onError = this.props.onError;
                this.setState({
                    hasError: true
                });
                onError(error);
            }
        },
        {
            key: "render",
            value: function render() {
                var children = this.props.children;
                var hasError = this.state.hasError;
                return !hasError && /*#__PURE__*/ $b348e003dfa7db55$var$_react.default.createElement($b348e003dfa7db55$var$RenderChildrenFunction, null, children);
            }
        }
    ]);
    return ErrorBoundary;
}($b348e003dfa7db55$var$_react.Component);
$b348e003dfa7db55$var$ErrorBoundary.defaultProps = {
    children: undefined,
    onError: undefined
};
$b348e003dfa7db55$var$ErrorBoundary.propTypes = {
    children: $b348e003dfa7db55$var$_propTypes.default.any,
    onError: $b348e003dfa7db55$var$_propTypes.default.func
};
var $b348e003dfa7db55$var$_default = $b348e003dfa7db55$var$ErrorBoundary;
module.exports.default = $b348e003dfa7db55$var$_default;

});

parcelRequire.register("d3MXM", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $9821893f46fa7af4$var$mapMap;

var $cG9B9 = parcelRequire("cG9B9");
function $9821893f46fa7af4$var$_slicedToArray(arr, i) {
    return $9821893f46fa7af4$var$_arrayWithHoles(arr) || $9821893f46fa7af4$var$_iterableToArrayLimit(arr, i) || $9821893f46fa7af4$var$_unsupportedIterableToArray(arr, i) || $9821893f46fa7af4$var$_nonIterableRest();
}
function $9821893f46fa7af4$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $9821893f46fa7af4$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $9821893f46fa7af4$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $9821893f46fa7af4$var$_arrayLikeToArray(o, minLen);
}
function $9821893f46fa7af4$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $9821893f46fa7af4$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $9821893f46fa7af4$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $9821893f46fa7af4$var$mapMap(map, mapper) {
    return Object.entries(map).reduce(function(result, _ref) {
        var _ref2 = $9821893f46fa7af4$var$_slicedToArray(_ref, 2), key = _ref2[0], value = _ref2[1];
        if (!(0, $cG9B9.isForbiddenPropertyName)(key)) // Mitigation through denylisting.
        // eslint-disable-next-line security/detect-object-injection
        result[key] = mapper(value, key);
        return result;
    }, {});
}

});

parcelRequire.register("hOQU1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $cf902489a3a7cb63$var$normalizeStyleOptions;

var $cG9B9 = parcelRequire("cG9B9");

var $cf902489a3a7cb63$var$_defaultStyleOptions = $cf902489a3a7cb63$var$_interopRequireDefault((parcelRequire("eBJPD")));
var $cf902489a3a7cb63$var$_excluded = [
    "hideScrollToEndButton",
    "newMessagesButtonFontSize"
];
function $cf902489a3a7cb63$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $cf902489a3a7cb63$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $cf902489a3a7cb63$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $cf902489a3a7cb63$var$ownKeys(Object(source), !0).forEach(function(key) {
            $cf902489a3a7cb63$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $cf902489a3a7cb63$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $cf902489a3a7cb63$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $cf902489a3a7cb63$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $cf902489a3a7cb63$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $cf902489a3a7cb63$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $cf902489a3a7cb63$var$hideScrollToEndButtonDeprecation = (0, $cG9B9.warnOnce)('"styleOptions.hideScrollToEndButton" has been deprecated. To hide scroll to end button, set "scrollToEndBehavior" to false. This deprecation migration will be removed on or after 2023-06-02.');
var $cf902489a3a7cb63$var$newMessagesButtonFontSizeDeprecation = (0, $cG9B9.warnOnce)('"styleOptions.newMessagesButtonFontSize" has been renamed to "styleOptions.scrollToEndButtonFontSize". This deprecation migration will be removed on or after 2023-06-02.');
var $cf902489a3a7cb63$var$suggestedActionBackgroundDeprecation = (0, $cG9B9.warnOnce)('"styleOptions.suggestedActionBackground" has been deprecated. Please use "styleOptions.suggestedActionBackgroundColor" instead. This deprecation migration will be removed on or after 2021-09-16.');
var $cf902489a3a7cb63$var$suggestedActionXXXBackgroundDeprecation = (0, $cG9B9.warnOnce)('"styleOptions.suggestedActionXXXBackground" has been deprecated. Please use "styleOptions.suggestedActionBackgroundColorOnXXX" instead. This deprecation migration will be removed on or after 2021-09-16.');
var $cf902489a3a7cb63$var$suggestedActionDisabledDeprecation = (0, $cG9B9.warnOnce)('"styleOptions.suggestedActionDisabledXXX" has been renamed to "styleOptions.suggestedActionXXXOnDisabled". This deprecation migration will be removed on or after 2021-09-16.'); // TODO: [P4] We should add a notice for people who want to use "styleSet" instead of "styleOptions".
//       "styleSet" is actually CSS stylesheet and it is based on the DOM tree.
//       DOM tree may change from time to time, thus, maintaining "styleSet" becomes a constant effort.
// eslint-disable-next-line complexity
function $cf902489a3a7cb63$var$normalizeStyleOptions() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, hideScrollToEndButton = _ref.hideScrollToEndButton, newMessagesButtonFontSize = _ref.newMessagesButtonFontSize, options = $cf902489a3a7cb63$var$_objectWithoutProperties(_ref, $cf902489a3a7cb63$var$_excluded);
    var filledOptions = $cf902489a3a7cb63$var$_objectSpread($cf902489a3a7cb63$var$_objectSpread({}, $cf902489a3a7cb63$var$_defaultStyleOptions.default), options); // Keep this list flat (no nested style) and serializable (no functions)
    var bubbleFromUserNubOffset = filledOptions.bubbleFromUserNubOffset, bubbleNubOffset = filledOptions.bubbleNubOffset, emojiSet = filledOptions.emojiSet;
    var normalizedBubbleFromUserNubOffset;
    var normalizedBubbleNubOffset;
    var normalizedEmojiSet;
    if (bubbleFromUserNubOffset === "top") normalizedBubbleFromUserNubOffset = 0;
    else if (typeof bubbleFromUserNubOffset !== "number") normalizedBubbleFromUserNubOffset = -0;
    else normalizedBubbleFromUserNubOffset = bubbleFromUserNubOffset;
    if (bubbleNubOffset === "top") normalizedBubbleNubOffset = 0;
    else if (typeof bubbleNubOffset !== "number") normalizedBubbleNubOffset = -0;
    else normalizedBubbleNubOffset = bubbleNubOffset;
    if (emojiSet === true) normalizedEmojiSet = {
        ":)": "\uD83D\uDE0A",
        ":-)": "\uD83D\uDE0A",
        "(:": "\uD83D\uDE0A",
        "(-:": "\uD83D\uDE0A",
        ":-|": "\uD83D\uDE10",
        ":|": "\uD83D\uDE10",
        ":-(": "☹️",
        ":(": "☹️",
        ":-D": "\uD83D\uDE00",
        ":D": "\uD83D\uDE00",
        ":-p": "\uD83D\uDE1B",
        ":p": "\uD83D\uDE1B",
        ":-P": "\uD83D\uDE1B",
        ":P": "\uD83D\uDE1B",
        ":-o": "\uD83D\uDE32",
        ":o": "\uD83D\uDE32",
        ":O": "\uD83D\uDE32",
        ":-O": "\uD83D\uDE32",
        ":-0": "\uD83D\uDE32",
        ":0": "\uD83D\uDE32",
        ";-)": "\uD83D\uDE09",
        ";)": "\uD83D\uDE09",
        "<3": "❤️",
        "</3": "\uD83D\uDC94",
        "<\\3": "\uD83D\uDC94"
    };
    else if (Object.prototype.toString.call(emojiSet) !== "[object Object]") {
        console.warn("botframework-webchat: emojiSet must be a boolean or an object with emoticon: emojiValues");
        normalizedEmojiSet = false;
    } else normalizedEmojiSet = emojiSet;
    if (hideScrollToEndButton) {
        $cf902489a3a7cb63$var$hideScrollToEndButtonDeprecation(); // Only set if the "scrollToEndButtonBehavior" is not set.
        // If it has been set, the developer should know the older "hideScrollToEndButton" option is deprecated.
        filledOptions.scrollToEndButtonBehavior = options.scrollToEndButtonBehavior || false;
    }
    var patchedScrollToEndButtonBehavior = filledOptions.scrollToEndButtonBehavior;
    if (patchedScrollToEndButtonBehavior !== "any" && patchedScrollToEndButtonBehavior !== false) {
        patchedScrollToEndButtonBehavior === "unread" || console.warn('Web Chat: "scrollToEndButtonBehavior" must be either "unread", "any", or false, will set to "unread".');
        patchedScrollToEndButtonBehavior = "unread";
    }
    if (newMessagesButtonFontSize) {
        $cf902489a3a7cb63$var$newMessagesButtonFontSizeDeprecation(); // Only set if the "scrollToEndButtonFontSize" is not set.
        filledOptions.scrollToEndButtonFontSize = options.scrollToEndButtonFontSize || newMessagesButtonFontSize;
    }
    options.suggestedActionBackground && $cf902489a3a7cb63$var$suggestedActionBackgroundDeprecation();
    if (options.suggestedActionActiveBackground) {
        $cf902489a3a7cb63$var$suggestedActionXXXBackgroundDeprecation();
        filledOptions.suggestedActionBackgroundColorOnActive = options.suggestedActionBackgroundColorOnActive || options.suggestedActionActiveBackground;
    }
    if (options.suggestedActionFocusBackground) {
        $cf902489a3a7cb63$var$suggestedActionXXXBackgroundDeprecation();
        filledOptions.suggestedActionBackgroundColorOnFocus = options.suggestedActionBackgroundColorOnFocus || options.suggestedActionFocusBackground;
    }
    if (options.suggestedActionHoverBackground) {
        $cf902489a3a7cb63$var$suggestedActionXXXBackgroundDeprecation();
        filledOptions.suggestedActionBackgroundColorOnHover = options.suggestedActionBackgroundColorOnHover || options.suggestedActionHoverBackground;
    }
    if (options.suggestedActionDisabledBackground) {
        $cf902489a3a7cb63$var$suggestedActionXXXBackgroundDeprecation();
        filledOptions.suggestedActionBackgroundColorOnDisabled = options.suggestedActionBackgroundColorOnDisabled || options.suggestedActionDisabledBackground;
    }
    if (options.suggestedActionDisabledBorderColor) {
        $cf902489a3a7cb63$var$suggestedActionDisabledDeprecation();
        filledOptions.suggestedActionBorderColorOnDisabled = options.suggestedActionBorderColorOnDisabled || options.suggestedActionDisabledBorderColor;
    }
    if (options.suggestedActionDisabledBorderStyle) {
        $cf902489a3a7cb63$var$suggestedActionDisabledDeprecation();
        filledOptions.suggestedActionBorderStyleOnDisabled = options.suggestedActionBorderStyleOnDisabled || options.suggestedActionDisabledBorderStyle;
    }
    if (options.suggestedActionDisabledBorderWidth) {
        $cf902489a3a7cb63$var$suggestedActionDisabledDeprecation();
        filledOptions.suggestedActionBorderWidthOnDisabled = options.suggestedActionBorderWidthOnDisabled || options.suggestedActionDisabledBorderWidth;
    }
    if (options.suggestedActionDisabledTextColor) {
        $cf902489a3a7cb63$var$suggestedActionDisabledDeprecation();
        filledOptions.suggestedActionTextColorOnDisabled = options.suggestedActionTextColorOnDisabled || options.suggestedActionDisabledTextColor;
    }
    return $cf902489a3a7cb63$var$_objectSpread($cf902489a3a7cb63$var$_objectSpread({}, filledOptions), {}, {
        bubbleFromUserNubOffset: normalizedBubbleFromUserNubOffset,
        bubbleNubOffset: normalizedBubbleNubOffset,
        emojiSet: normalizedEmojiSet,
        scrollToEndButtonBehavior: patchedScrollToEndButtonBehavior
    });
}

});
parcelRequire.register("eBJPD", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
/* eslint no-magic-numbers: "off" */ function $aa2812a8f458e45d$var$fontFamily(fonts) {
    return fonts.map(function(font) {
        return "'".concat(font, "'");
    }).join(", ");
}
var $aa2812a8f458e45d$var$DEFAULT_ACCENT = "#0063B1";
var $aa2812a8f458e45d$var$DEFAULT_SUBTLE = "#767676"; // With contrast 4.5:1 to white
var $aa2812a8f458e45d$var$PADDING_REGULAR = 10;
var $aa2812a8f458e45d$var$DEFAULT_OPTIONS = {
    // Basic styling
    accent: $aa2812a8f458e45d$var$DEFAULT_ACCENT,
    backgroundColor: "White",
    subtle: $aa2812a8f458e45d$var$DEFAULT_SUBTLE,
    paddingRegular: $aa2812a8f458e45d$var$PADDING_REGULAR,
    paddingWide: $aa2812a8f458e45d$var$PADDING_REGULAR * 2,
    fontSizeSmall: "80%",
    monospaceFont: $aa2812a8f458e45d$var$fontFamily([
        "Consolas",
        "Courier New",
        "monospace"
    ]),
    primaryFont: $aa2812a8f458e45d$var$fontFamily([
        "Calibri",
        "Helvetica Neue",
        "Arial",
        "sans-serif"
    ]),
    // Root
    rootHeight: "100%",
    rootWidth: "100%",
    rootZIndex: 0,
    // "z-index" for the root container of Web Chat. This will form a new stacking context so "z-index" used in children won't pollute.
    transitionDuration: "0s",
    // Avatar
    avatarBorderRadius: "50%",
    avatarSize: 40,
    botAvatarBackgroundColor: undefined,
    botAvatarImage: undefined,
    botAvatarInitials: undefined,
    userAvatarBackgroundColor: undefined,
    userAvatarImage: undefined,
    userAvatarInitials: undefined,
    showAvatarInGroup: "status",
    // Bubble
    // TODO: Should we make a bubbleFromBot*
    bubbleBackground: "White",
    bubbleBorderColor: "#E6E6E6",
    bubbleBorderRadius: 2,
    bubbleBorderStyle: "solid",
    bubbleBorderWidth: 1,
    bubbleFromUserBackground: "White",
    bubbleFromUserBorderColor: "#E6E6E6",
    bubbleFromUserBorderRadius: 2,
    bubbleFromUserBorderStyle: "solid",
    bubbleFromUserBorderWidth: 1,
    bubbleFromUserNubOffset: 0,
    bubbleFromUserNubSize: undefined,
    bubbleFromUserTextColor: "Black",
    bubbleImageHeight: 240,
    bubbleMaxWidth: 480,
    // Based off screen width = 600px
    bubbleMinHeight: 40,
    bubbleMinWidth: 250,
    // min screen width = 300px; Microsoft Edge requires 372px (https://developer.microsoft.com/en-us/microsoft-edge/platform/issues/13621468/)
    bubbleNubOffset: 0,
    bubbleNubSize: undefined,
    bubbleTextColor: "Black",
    messageActivityWordBreak: "break-word",
    // Connectivity UI
    connectivityIconPadding: $aa2812a8f458e45d$var$PADDING_REGULAR * 1.2,
    connectivityMarginLeftRight: $aa2812a8f458e45d$var$PADDING_REGULAR * 1.4,
    connectivityMarginTopBottom: $aa2812a8f458e45d$var$PADDING_REGULAR * 0.8,
    connectivityTextSize: "75%",
    failedConnectivity: "#C50F1F",
    slowConnectivity: "#EAA300",
    notificationText: "#5E5E5E",
    slowConnectionAfter: 15000,
    // Emoji
    emojiSet: true,
    // Live region - Accessibility
    internalLiveRegionFadeAfter: 1000,
    // Markdown
    markdownExternalLinkIconImage: "url(data:image/svg+xml;base64,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)",
    markdownRespectCRLF: true,
    // Scroll behavior
    hideScrollToEndButton: undefined,
    // Deprecated as of 4.14.0. Use "scrollToEndButtonBehavior" instead. Remove on or after 2023-06-02.
    autoScrollSnapOnActivity: false,
    autoScrollSnapOnActivityOffset: 0,
    autoScrollSnapOnPage: false,
    autoScrollSnapOnPageOffset: 0,
    // TODO: Rename from "autoScrollSnapOnPageoffset".
    // Send box
    hideSendBox: false,
    hideUploadButton: false,
    microphoneButtonColorOnDictate: "#F33",
    sendBoxBackground: "White",
    // Send box buttons
    sendBoxButtonColor: undefined,
    sendBoxButtonShadeColor: undefined,
    sendBoxButtonColorOnActive: undefined,
    sendBoxButtonShadeColorOnActive: "#EDEBE9",
    sendBoxButtonColorOnDisabled: "#A19F9D",
    sendBoxButtonShadeColorOnDisabled: "#F3F2F1",
    sendBoxButtonColorOnFocus: undefined,
    sendBoxButtonShadeColorOnFocus: undefined,
    sendBoxButtonColorOnHover: undefined,
    sendBoxButtonShadeColorOnHover: "#F3F2F1",
    sendBoxButtonShadeBorderRadius: 2,
    sendBoxButtonShadeInset: 2,
    sendBoxButtonKeyboardFocusIndicatorBorderColor: "#605E5C",
    sendBoxButtonKeyboardFocusIndicatorBorderRadius: 0,
    sendBoxButtonKeyboardFocusIndicatorBorderStyle: "solid",
    sendBoxButtonKeyboardFocusIndicatorBorderWidth: 1,
    sendBoxButtonKeyboardFocusIndicatorInset: 4,
    sendBoxDisabledTextColor: undefined,
    sendBoxHeight: 40,
    sendBoxMaxHeight: 200,
    sendBoxTextColor: "Black",
    // TODO: We should deprecate this because there isn't an easy way to make the width of the send box narrower than the transcript
    sendBoxBorderBottom: undefined,
    sendBoxBorderLeft: undefined,
    sendBoxBorderRight: undefined,
    sendBoxBorderTop: "solid 1px #E6E6E6",
    sendBoxPlaceholderColor: undefined,
    sendBoxTextWrap: false,
    sendBoxButtonAlignment: "stretch",
    // Visually show spoken text
    showSpokenText: false,
    spinnerAnimationBackgroundImage: undefined,
    spinnerAnimationHeight: 16,
    spinnerAnimationWidth: 16,
    spinnerAnimationPadding: 12,
    // Suggested actions
    suggestedActionBorderRadius: 0,
    suggestedActionHeight: 40,
    suggestedActionImageHeight: 20,
    suggestedActionLayout: "carousel",
    suggestedActionBackgroundColor: "White",
    suggestedActionBorderColor: undefined,
    suggestedActionBorderStyle: "solid",
    suggestedActionBorderWidth: 2,
    suggestedActionTextColor: undefined,
    suggestedActionBackgroundColorOnActive: "#EDEBE9",
    suggestedActionBorderColorOnActive: undefined,
    suggestedActionBorderStyleOnActive: undefined,
    suggestedActionBorderWidthOnActive: undefined,
    suggestedActionTextColorOnActive: undefined,
    suggestedActionBackgroundColorOnDisabled: undefined,
    suggestedActionBorderColorOnDisabled: "#E6E6E6",
    suggestedActionBorderStyleOnDisabled: undefined,
    suggestedActionBorderWidthOnDisabled: undefined,
    suggestedActionTextColorOnDisabled: undefined,
    suggestedActionBackgroundColorOnFocus: undefined,
    suggestedActionBorderColorOnFocus: undefined,
    suggestedActionBorderStyleOnFocus: undefined,
    suggestedActionBorderWidthOnFocus: undefined,
    suggestedActionTextColorOnFocus: undefined,
    suggestedActionBackgroundColorOnHover: "#F3F2F1",
    suggestedActionBorderColorOnHover: undefined,
    suggestedActionBorderStyleOnHover: undefined,
    suggestedActionBorderWidthOnHover: undefined,
    suggestedActionTextColorOnHover: undefined,
    suggestedActionKeyboardFocusIndicatorBorderColor: "#605E5C",
    suggestedActionKeyboardFocusIndicatorBorderRadius: 0,
    suggestedActionKeyboardFocusIndicatorBorderStyle: "dashed",
    suggestedActionKeyboardFocusIndicatorBorderWidth: 1,
    suggestedActionKeyboardFocusIndicatorInset: 2,
    suggestedActionActiveBackground: undefined,
    // Deprecated as of 4.15.0. Remove on or after 2023-09-16.
    suggestedActionBackground: undefined,
    // Deprecated as of 4.15.0. Remove on or after 2023-09-16.
    suggestedActionDisabledBackground: undefined,
    // Deprecated as of 4.15.0. Remove on or after 2023-09-16.
    suggestedActionDisabledBorderColor: undefined,
    // Deprecated as of 4.15.0. Remove on or after 2023-09-16.
    suggestedActionDisabledBorderStyle: undefined,
    // Deprecated as of 4.15.0. Remove on or after 2023-09-16.
    suggestedActionDisabledBorderWidth: undefined,
    // Deprecated as of 4.15.0. Remove on or after 2023-09-16.
    suggestedActionDisabledTextColor: undefined,
    // Deprecated as of 4.15.0. Remove on or after 2023-09-16.
    suggestedActionFocusBackground: undefined,
    // Deprecated as of 4.15.0. Remove on or after 2023-09-16.
    suggestedActionHoverBackground: undefined,
    // Deprecated as of 4.15.0. Remove on or after 2023-09-16.
    // Suggested actions carousel layout
    suggestedActionsCarouselFlipperCursor: undefined,
    suggestedActionsCarouselFlipperBoxWidth: 40,
    suggestedActionsCarouselFlipperSize: 20,
    // Suggested actions flow layout
    suggestedActionsFlowMaxHeight: undefined,
    // Suggested actions stacked layout
    suggestedActionsStackedHeight: undefined,
    suggestedActionsStackedOverflow: undefined,
    suggestedActionsStackedLayoutButtonMaxHeight: undefined,
    suggestedActionsStackedLayoutButtonTextWrap: false,
    suggestedActionsVisualKeyboardIndicatorColor: "Black",
    suggestedActionsVisualKeyboardIndicatorStyle: "solid",
    suggestedActionsVisualKeyboardIndicatorWidth: 2,
    // Timestamp
    groupTimestamp: true,
    sendTimeout: 20000,
    sendTimeoutForAttachments: 120000,
    timestampColor: undefined,
    timestampFormat: "relative",
    // Transcript overlay buttons
    scrollToEndButtonBehavior: "unread",
    scrollToEndButtonFontSize: "85%",
    newMessagesButtonFontSize: undefined,
    // Deprecated as of 4.14.0, renamed to "scrollToEndButtonFontSize". Remove on or after 2023-06-02.
    transcriptOverlayButtonBackground: "rgba(0, 0, 0, .6)",
    transcriptOverlayButtonBackgroundOnDisabled: "rgba(0, 0, 0, .6)",
    transcriptOverlayButtonBackgroundOnFocus: "rgba(0, 0, 0, .8)",
    transcriptOverlayButtonBackgroundOnHover: "rgba(0, 0, 0, .8)",
    transcriptOverlayButtonColor: "White",
    transcriptOverlayButtonColorOnDisabled: "White",
    transcriptOverlayButtonColorOnFocus: undefined,
    transcriptOverlayButtonColorOnHover: undefined,
    // Toast UI
    notificationDebounceTimeout: 400,
    hideToaster: false,
    toasterHeight: 32,
    toasterMaxHeight: 160,
    toasterSingularMaxHeight: 50,
    toastFontSize: "87.5%",
    toastIconWidth: 36,
    toastSeparatorColor: "#E8EAEC",
    toastTextPadding: 6,
    toastErrorBackgroundColor: "#FDE7E9",
    toastErrorColor: "#A80000",
    toastInfoBackgroundColor: "#CEF1FF",
    toastInfoColor: "#105E7D",
    toastSuccessBackgroundColor: "#DFF6DD",
    toastSuccessColor: "#107C10",
    toastWarnBackgroundColor: "#FFF4CE",
    toastWarnColor: "#3B3A39",
    // Transcript
    transcriptTerminatorBackgroundColor: "#595959",
    transcriptTerminatorBorderRadius: 5,
    transcriptTerminatorColor: "White",
    transcriptTerminatorFontSize: 12,
    transcriptActivityVisualKeyboardIndicatorColor: $aa2812a8f458e45d$var$DEFAULT_SUBTLE,
    transcriptActivityVisualKeyboardIndicatorStyle: "dashed",
    transcriptActivityVisualKeyboardIndicatorWidth: 1,
    transcriptVisualKeyboardIndicatorColor: "Black",
    transcriptVisualKeyboardIndicatorStyle: "solid",
    transcriptVisualKeyboardIndicatorWidth: 2,
    // Typing animation
    typingAnimationBackgroundImage: undefined,
    typingAnimationDuration: 5000,
    typingAnimationHeight: 20,
    typingAnimationWidth: 64,
    // Upload thumbnail
    // TODO: [P0] #3322 This is only supported in HTML.
    enableUploadThumbnail: true,
    uploadThumbnailContentType: "image/jpeg",
    uploadThumbnailHeight: 360,
    uploadThumbnailQuality: 0.6,
    uploadThumbnailWidth: 720,
    // Video
    videoHeight: 270 // based on bubbleMaxWidth: 480 / 16 * 9 = 270
};
var $aa2812a8f458e45d$var$_default = $aa2812a8f458e45d$var$DEFAULT_OPTIONS;
module.exports.default = $aa2812a8f458e45d$var$_default;

});


parcelRequire.register("566u6", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $3b628b015b2fb4f1$var$observableToPromise;
function $3b628b015b2fb4f1$var$observableToPromise(observable, _ref) {
    var setTimeout = _ref.setTimeout;
    return new Promise(function(resolve, reject) {
        var subscription = observable.subscribe(function(sessionId) {
            resolve(sessionId); // HACK: Sometimes, the call complete asynchronously and we cannot unsubscribe.
            //       Need to wait some short time here to make sure the subscription variable has setup.
            //       Potentially, this can be fixed by assigning to `subscription` variable thru `Observer.start`.
            //       However, we should do some testing because we are not sure if RxJS@5 supports `Observer.start`.
            setTimeout(function() {
                return subscription.unsubscribe();
            }, 0);
        }, function(error) {
            reject(error);
            setTimeout(function() {
                return subscription.unsubscribe();
            }, 0);
        });
    });
}

});

parcelRequire.register("gW2Ds", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $c5441b7bd524dc00$var$patchStyleOptionsFromDeprecatedProps;

var $c5441b7bd524dc00$var$_simpleUpdateIn = $c5441b7bd524dc00$var$_interopRequireDefault((parcelRequire("7qq3H")));
function $c5441b7bd524dc00$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
// TODO: [P4] We should add a notice for people who want to use "styleSet" instead of "styleOptions".
//       "styleSet" is actually CSS stylesheet and it is based on the DOM tree.
//       DOM tree may change from time to time, thus, maintaining "styleSet" becomes a constant effort.
function $c5441b7bd524dc00$var$patchStyleOptionsFromDeprecatedProps(styleOptions, _ref) {
    var groupTimestampFromProps = _ref.groupTimestamp, sendTimeoutFromProps = _ref.sendTimeout;
    if (typeof groupTimestampFromProps !== "undefined" && typeof styleOptions.groupTimestamp === "undefined") {
        console.warn('Web Chat: "groupTimestamp" has been moved to "styleOptions". This deprecation migration will be removed on or after January 1 2022.');
        styleOptions = (0, $c5441b7bd524dc00$var$_simpleUpdateIn.default)(styleOptions, [
            "groupTimestamp"
        ], function() {
            return groupTimestampFromProps;
        });
    }
    if (typeof sendTimeoutFromProps !== "undefined" && typeof styleOptions.sendTimeout === "undefined") {
        console.warn('Web Chat: "sendTimeout" has been moved to "styleOptions". This deprecation migration will be removed on or after January 1 2022.');
        styleOptions = (0, $c5441b7bd524dc00$var$_simpleUpdateIn.default)(styleOptions, [
            "sendTimeout"
        ], function() {
            return sendTimeoutFromProps;
        });
    }
    if (styleOptions.slowConnectionAfter < 0) {
        console.warn('Web Chat: "slowConnectionAfter" cannot be negative, will set to 0.');
        styleOptions = (0, $c5441b7bd524dc00$var$_simpleUpdateIn.default)(styleOptions, [
            "slowConnectionAfter"
        ], function() {
            return 0;
        });
    }
    return styleOptions;
}

});

parcelRequire.register("bDr9U", function(module, exports) {
"use strict";
function $8788676dd6cc8921$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $8788676dd6cc8921$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $8788676dd6cc8921$var$_typeof(obj);
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8788676dd6cc8921$var$_propTypes = $8788676dd6cc8921$var$_interopRequireDefault((parcelRequire("f7UXb")));

var $8788676dd6cc8921$var$_react = $8788676dd6cc8921$var$_interopRequireWildcard((parcelRequire("eO7Kz")));

var $8788676dd6cc8921$var$_PonyfillContext = $8788676dd6cc8921$var$_interopRequireDefault((parcelRequire("hF14E")));
function $8788676dd6cc8921$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($8788676dd6cc8921$var$_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $8788676dd6cc8921$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || $8788676dd6cc8921$var$_typeof(obj) !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $8788676dd6cc8921$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $8788676dd6cc8921$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $8788676dd6cc8921$var$PonyfillComposer = function PonyfillComposer(_ref) {
    var children = _ref.children, partialPonyfill = _ref.ponyfill;
    // Note: `useRef(value)` always return the initial value that was called with.
    if ((0, $8788676dd6cc8921$var$_react.useRef)(partialPonyfill).current !== partialPonyfill) // We does not support changing ponyfill.
    // This is because ponyfill is used to create Redux store (if not passed via props).
    // Once the store is created, we cannot change its ponyfill.
    // However, we could rework the `createStore` function to support changing ponyfill.
    // Locking down ponyfill is just for code simplicity.
    throw new Error('botframework-webchat: "ponyfill" props cannot be changed after initial render.');
     // TODO: [P2] Dedupe: when we have an utility package, move this code there and mark it as internal use.
    var ponyfill = (0, $8788676dd6cc8921$var$_react.useMemo)(// eslint-disable-next-line complexity
    function() {
        // IE Mode does not have `globalThis`.
        var globalThisOrWindow = typeof globalThis === "undefined" ? window : globalThis;
        return {
            cancelAnimationFrame: (partialPonyfill === null || partialPonyfill === void 0 ? void 0 : partialPonyfill.cancelAnimationFrame) || // eslint-disable-next-line no-restricted-globals
            (typeof cancelAnimationFrame === "function" ? cancelAnimationFrame.bind(globalThisOrWindow) : undefined),
            cancelIdleCallback: (partialPonyfill === null || partialPonyfill === void 0 ? void 0 : partialPonyfill.cancelIdleCallback) || (typeof cancelIdleCallback === "function" ? cancelIdleCallback.bind(globalThisOrWindow) : undefined),
            clearImmediate: (partialPonyfill === null || partialPonyfill === void 0 ? void 0 : partialPonyfill.clearImmediate) || (typeof clearImmediate === "function" ? clearImmediate.bind(globalThisOrWindow) : undefined),
            clearInterval: (partialPonyfill === null || partialPonyfill === void 0 ? void 0 : partialPonyfill.clearInterval) || (typeof clearInterval === "function" ? clearInterval.bind(globalThisOrWindow) : undefined),
            clearTimeout: (partialPonyfill === null || partialPonyfill === void 0 ? void 0 : partialPonyfill.clearTimeout) || (typeof clearTimeout === "function" ? clearTimeout.bind(globalThisOrWindow) : undefined),
            // eslint-disable-next-line no-restricted-globals
            Date: (partialPonyfill === null || partialPonyfill === void 0 ? void 0 : partialPonyfill.Date) || Date,
            requestAnimationFrame: (partialPonyfill === null || partialPonyfill === void 0 ? void 0 : partialPonyfill.requestAnimationFrame) || (typeof requestAnimationFrame === "function" ? requestAnimationFrame.bind(globalThisOrWindow) : undefined),
            requestIdleCallback: (partialPonyfill === null || partialPonyfill === void 0 ? void 0 : partialPonyfill.requestIdleCallback) || (typeof requestIdleCallback === "function" ? requestIdleCallback.bind(globalThisOrWindow) : undefined),
            setImmediate: (partialPonyfill === null || partialPonyfill === void 0 ? void 0 : partialPonyfill.setImmediate) || (typeof setImmediate === "function" ? setImmediate.bind(globalThisOrWindow) : undefined),
            setInterval: (partialPonyfill === null || partialPonyfill === void 0 ? void 0 : partialPonyfill.setInterval) || (typeof setInterval === "function" ? setInterval.bind(globalThisOrWindow) : undefined),
            setTimeout: (partialPonyfill === null || partialPonyfill === void 0 ? void 0 : partialPonyfill.setTimeout) || (typeof setTimeout === "function" ? setTimeout.bind(globalThisOrWindow) : undefined)
        };
    }, [
        partialPonyfill
    ]);
    var contextValue = (0, $8788676dd6cc8921$var$_react.useMemo)(function() {
        return {
            ponyfillState: Object.freeze([
                ponyfill
            ])
        };
    }, [
        ponyfill
    ]);
    return /*#__PURE__*/ $8788676dd6cc8921$var$_react.default.createElement($8788676dd6cc8921$var$_PonyfillContext.default.Provider, {
        value: contextValue
    }, children);
};
$8788676dd6cc8921$var$PonyfillComposer.defaultProps = {
    ponyfill: undefined
};
$8788676dd6cc8921$var$PonyfillComposer.propTypes = {
    ponyfill: $8788676dd6cc8921$var$_propTypes.default.any
};
var $8788676dd6cc8921$var$_default = $8788676dd6cc8921$var$PonyfillComposer;
module.exports.default = $8788676dd6cc8921$var$_default;

});

parcelRequire.register("4ldnr", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $32937fffa6c1a5f1$var$_useTracker = $32937fffa6c1a5f1$var$_interopRequireDefault((parcelRequire("3hwsM")));
function $32937fffa6c1a5f1$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $32937fffa6c1a5f1$var$Tracker = function Tracker() {
    (0, $32937fffa6c1a5f1$var$_useTracker.default)();
    return null;
};
var $32937fffa6c1a5f1$var$_default = $32937fffa6c1a5f1$var$Tracker;
module.exports.default = $32937fffa6c1a5f1$var$_default;

});
parcelRequire.register("3hwsM", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $eO7Kz = parcelRequire("eO7Kz");

var $263c241ee775e481$var$_useLanguage3 = $263c241ee775e481$var$_interopRequireDefault((parcelRequire("aMPp7")));

var $263c241ee775e481$var$_useTrackDimension = $263c241ee775e481$var$_interopRequireDefault((parcelRequire("hg8oI")));

var $263c241ee775e481$var$_useTrackEvent = $263c241ee775e481$var$_interopRequireDefault((parcelRequire("f6yDt")));
function $263c241ee775e481$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $263c241ee775e481$var$_slicedToArray(arr, i) {
    return $263c241ee775e481$var$_arrayWithHoles(arr) || $263c241ee775e481$var$_iterableToArrayLimit(arr, i) || $263c241ee775e481$var$_unsupportedIterableToArray(arr, i) || $263c241ee775e481$var$_nonIterableRest();
}
function $263c241ee775e481$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $263c241ee775e481$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $263c241ee775e481$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $263c241ee775e481$var$_arrayLikeToArray(o, minLen);
}
function $263c241ee775e481$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $263c241ee775e481$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $263c241ee775e481$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $263c241ee775e481$var$useTracker() {
    var _useLanguage = (0, $263c241ee775e481$var$_useLanguage3.default)(), _useLanguage2 = $263c241ee775e481$var$_slicedToArray(_useLanguage, 1), language = _useLanguage2[0];
    var trackDimension = (0, $263c241ee775e481$var$_useTrackDimension.default)();
    var trackEvent = (0, $263c241ee775e481$var$_useTrackEvent.default)(); // TODO: [P2] #2937 Track how many of them customized the following:
    // - activityMiddleware
    // - activityStatusMiddleware
    // - attachmentMiddleware
    // - cardActionMiddleware
    // - toastMiddleware
    // - styleOptions
    (0, $eO7Kz.useEffect)(function() {
        trackDimension("prop:locale", language);
    }, [
        language,
        trackDimension
    ]);
    (0, $eO7Kz.useEffect)(function() {
        trackEvent("init");
    }, [
        trackEvent
    ]);
}
var $263c241ee775e481$var$_default = $263c241ee775e481$var$useTracker;
module.exports.default = $263c241ee775e481$var$_default;

});


parcelRequire.register("hvz7t", function(module, exports) {
"use strict";
function $cbf092f0186ad391$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $cbf092f0186ad391$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $cbf092f0186ad391$var$_typeof(obj);
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $cbf092f0186ad391$var$applyMiddleware;
module.exports.forLegacyRenderer = $cbf092f0186ad391$var$forLegacyRenderer;
module.exports.forRenderer = $cbf092f0186ad391$var$forRenderer;

var $cbf092f0186ad391$var$_react = $cbf092f0186ad391$var$_interopRequireWildcard((parcelRequire("eO7Kz")));

var $cbf092f0186ad391$var$_ErrorBox = $cbf092f0186ad391$var$_interopRequireDefault((parcelRequire("1FllN")));

var $cbf092f0186ad391$var$_concatMiddleware = $cbf092f0186ad391$var$_interopRequireDefault((parcelRequire("8tA2t")));

var $cbf092f0186ad391$var$_UserlandBoundary = $cbf092f0186ad391$var$_interopRequireDefault((parcelRequire("BHQzm")));
function $cbf092f0186ad391$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $cbf092f0186ad391$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($cbf092f0186ad391$var$_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $cbf092f0186ad391$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || $cbf092f0186ad391$var$_typeof(obj) !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $cbf092f0186ad391$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $cbf092f0186ad391$var$applyMiddleware(type) {
    for(var _len = arguments.length, middleware = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)middleware[_key - 1] = arguments[_key];
    return function() {
        return $cbf092f0186ad391$var$_concatMiddleware.default.apply(void 0, middleware).apply(void 0, arguments)(function() {
            throw new Error("reached terminator of ".concat(type));
        });
    };
}
function $cbf092f0186ad391$var$forLegacyRenderer(type) {
    for(var _len2 = arguments.length, middleware = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)middleware[_key2 - 1] = arguments[_key2];
    return function() {
        var fn = $cbf092f0186ad391$var$_concatMiddleware.default.apply(void 0, middleware).apply(void 0, arguments)(function() {
            throw new Error("reached terminator of ".concat(type));
        });
        return function() {
            for(var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)args[_key3] = arguments[_key3];
            return /*#__PURE__*/ $cbf092f0186ad391$var$_react.default.createElement($cbf092f0186ad391$var$_UserlandBoundary.default, {
                type: "render of ".concat(type)
            }, function() {
                try {
                    return fn.apply(void 0, args);
                } catch (err) {
                    return /*#__PURE__*/ $cbf092f0186ad391$var$_react.default.createElement($cbf092f0186ad391$var$_ErrorBox.default, {
                        error: err,
                        type: "render of ".concat(type)
                    });
                }
            });
        };
    };
}
/**
 *
 * @param {string} type Required. String equivalent of type of container to be rendered.
 * @param { strict = false } - Used to enforce new middleware format which cooperates with new activity grouping.
 * @see See {@link https://github.com/microsoft/BotFramework-WebChat/blob/main/CHANGELOG.md#4100---2020-08-18} and {@link https://github.com/microsoft/BotFramework-WebChat/pull/3365} for middleware breaking changes.
 * @param  {middleware[]} middleware list of middleware to be applied.
 * 'createRendererArgs' is "what to render"; for example, an activity.
 * @returns  Returns a function if there is a renderer *committed* to render OR returns false if nothing should be rendered.
 */ function $cbf092f0186ad391$var$forRenderer(type) {
    var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {}, _ref$strict = _ref.strict, strict = _ref$strict === void 0 ? false : _ref$strict;
    for(var _len4 = arguments.length, middleware = new Array(_len4 > 2 ? _len4 - 2 : 0), _key4 = 2; _key4 < _len4; _key4++)middleware[_key4 - 2] = arguments[_key4];
    return function() {
        var runMiddleware = $cbf092f0186ad391$var$_concatMiddleware.default.apply(void 0, middleware).apply(void 0, arguments)(function() {
            return /*#__PURE__*/ $cbf092f0186ad391$var$_react.default.createElement($cbf092f0186ad391$var$_ErrorBox.default, {
                error: new Error("reached terminator of ".concat(type)),
                type: type
            });
        });
        return function() {
            try {
                var render = runMiddleware.apply(void 0, arguments);
                if (!render) return false;
                else if (/*#__PURE__*/ (0, $cbf092f0186ad391$var$_react.isValidElement)(render)) {
                    if (strict) {
                        console.error("botframework-webchat: ".concat(type, " should only return either false or a render function."));
                        return false;
                    }
                    return /*#__PURE__*/ $cbf092f0186ad391$var$_react.default.createElement($cbf092f0186ad391$var$_UserlandBoundary.default, {
                        type: "render of ".concat(type)
                    }, render);
                }
                return function() {
                    for(var _len5 = arguments.length, renderTimeArgs = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++)renderTimeArgs[_key5] = arguments[_key5];
                    return /*#__PURE__*/ $cbf092f0186ad391$var$_react.default.createElement($cbf092f0186ad391$var$_UserlandBoundary.default, {
                        type: "render of ".concat(type)
                    }, function() {
                        try {
                            var element = render.apply(void 0, renderTimeArgs);
                            if (strict && !/*#__PURE__*/ (0, $cbf092f0186ad391$var$_react.isValidElement)(element)) console.error("botframework-webchat: ".concat(type, " should return React element only."));
                            return element;
                        } catch (err) {
                            return /*#__PURE__*/ $cbf092f0186ad391$var$_react.default.createElement($cbf092f0186ad391$var$_ErrorBox.default, {
                                error: err,
                                type: "render of ".concat(type)
                            });
                        }
                    });
                };
            } catch (err) {
                return /*#__PURE__*/ $cbf092f0186ad391$var$_react.default.createElement($cbf092f0186ad391$var$_ErrorBox.default, {
                    error: err,
                    type: "render of ".concat(type)
                });
            }
        };
    };
}

});
parcelRequire.register("1FllN", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $eO7Kz = parcelRequire("eO7Kz");

var $136a2e8909971aa1$var$_propTypes = $136a2e8909971aa1$var$_interopRequireDefault((parcelRequire("f7UXb")));

var $136a2e8909971aa1$var$_useErrorBoxClass3 = $136a2e8909971aa1$var$_interopRequireDefault((parcelRequire("hSZPN")));

var $136a2e8909971aa1$var$_useTrackException = $136a2e8909971aa1$var$_interopRequireDefault((parcelRequire("icwbb")));
function $136a2e8909971aa1$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $136a2e8909971aa1$var$_slicedToArray(arr, i) {
    return $136a2e8909971aa1$var$_arrayWithHoles(arr) || $136a2e8909971aa1$var$_iterableToArrayLimit(arr, i) || $136a2e8909971aa1$var$_unsupportedIterableToArray(arr, i) || $136a2e8909971aa1$var$_nonIterableRest();
}
function $136a2e8909971aa1$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $136a2e8909971aa1$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $136a2e8909971aa1$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $136a2e8909971aa1$var$_arrayLikeToArray(o, minLen);
}
function $136a2e8909971aa1$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $136a2e8909971aa1$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $136a2e8909971aa1$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
var $136a2e8909971aa1$var$ErrorBox = function ErrorBox(_ref) {
    var error = _ref.error, type = _ref.type;
    var _useErrorBoxClass = (0, $136a2e8909971aa1$var$_useErrorBoxClass3.default)(), _useErrorBoxClass2 = $136a2e8909971aa1$var$_slicedToArray(_useErrorBoxClass, 1), errorBoxClass = _useErrorBoxClass2[0];
    var trackException = (0, $136a2e8909971aa1$var$_useTrackException.default)();
    (0, $eO7Kz.useEffect)(function() {
        trackException(error, false);
    }, [
        error,
        trackException
    ]);
    (0, $eO7Kz.useEffect)(function() {
        console.group("botframework-webchat: ".concat(type));
        console.error(error);
        console.groupEnd();
    }, [
        error,
        type
    ]);
    return !!errorBoxClass && /*#__PURE__*/ (0, $eO7Kz.createElement)(errorBoxClass, {
        error: error,
        type: type
    });
};
$136a2e8909971aa1$var$ErrorBox.defaultProps = {
    type: undefined
};
$136a2e8909971aa1$var$ErrorBox.propTypes = {
    error: $136a2e8909971aa1$var$_propTypes.default.any.isRequired,
    type: $136a2e8909971aa1$var$_propTypes.default.string
};
var $136a2e8909971aa1$var$_default = $136a2e8909971aa1$var$ErrorBox;
module.exports.default = $136a2e8909971aa1$var$_default;

});
parcelRequire.register("hSZPN", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $d05771d7b6c38a1c$var$useErrorBoxClass;

var $d05771d7b6c38a1c$var$_useWebChatAPIContext2 = $d05771d7b6c38a1c$var$_interopRequireDefault((parcelRequire("iJOsw")));
function $d05771d7b6c38a1c$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $d05771d7b6c38a1c$var$useErrorBoxClass() {
    var _useWebChatAPIContext = (0, $d05771d7b6c38a1c$var$_useWebChatAPIContext2.default)(), internalErrorBoxClass = _useWebChatAPIContext.internalErrorBoxClass;
    return [
        internalErrorBoxClass
    ];
}

});


parcelRequire.register("8tA2t", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $62bcfcbbffeb21f4$var$concatMiddleware;
function $62bcfcbbffeb21f4$var$_toConsumableArray(arr) {
    return $62bcfcbbffeb21f4$var$_arrayWithoutHoles(arr) || $62bcfcbbffeb21f4$var$_iterableToArray(arr) || $62bcfcbbffeb21f4$var$_unsupportedIterableToArray(arr) || $62bcfcbbffeb21f4$var$_nonIterableSpread();
}
function $62bcfcbbffeb21f4$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $62bcfcbbffeb21f4$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $62bcfcbbffeb21f4$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $62bcfcbbffeb21f4$var$_arrayLikeToArray(o, minLen);
}
function $62bcfcbbffeb21f4$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $62bcfcbbffeb21f4$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $62bcfcbbffeb21f4$var$_arrayLikeToArray(arr);
}
function $62bcfcbbffeb21f4$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $62bcfcbbffeb21f4$var$concatMiddleware() {
    for(var _len = arguments.length, middleware = new Array(_len), _key = 0; _key < _len; _key++)middleware[_key] = arguments[_key];
    return function(setupArgs) {
        var setup = middleware.reduce(function(setup, middleware) {
            return middleware ? [].concat($62bcfcbbffeb21f4$var$_toConsumableArray(setup), [
                middleware(setupArgs)
            ]) : setup;
        }, []);
        return function(last) {
            var stack = setup.slice();
            var work = function work(index) {
                return function() {
                    var next = stack[+index];
                    return (next ? next(work(index + 1)) : last).apply(void 0, arguments);
                };
            };
            return work(0);
        };
    };
}

});

parcelRequire.register("BHQzm", function(module, exports) {
"use strict";
function $071577e537677ba8$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $071577e537677ba8$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $071577e537677ba8$var$_typeof(obj);
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $071577e537677ba8$var$_propTypes = $071577e537677ba8$var$_interopRequireDefault((parcelRequire("f7UXb")));

var $071577e537677ba8$var$_react = $071577e537677ba8$var$_interopRequireWildcard((parcelRequire("eO7Kz")));

var $071577e537677ba8$var$_ErrorBoundary = $071577e537677ba8$var$_interopRequireDefault((parcelRequire("fokl9")));

var $071577e537677ba8$var$_ErrorBox = $071577e537677ba8$var$_interopRequireDefault((parcelRequire("1FllN")));
function $071577e537677ba8$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($071577e537677ba8$var$_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $071577e537677ba8$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || $071577e537677ba8$var$_typeof(obj) !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $071577e537677ba8$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $071577e537677ba8$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $071577e537677ba8$var$_slicedToArray(arr, i) {
    return $071577e537677ba8$var$_arrayWithHoles(arr) || $071577e537677ba8$var$_iterableToArrayLimit(arr, i) || $071577e537677ba8$var$_unsupportedIterableToArray(arr, i) || $071577e537677ba8$var$_nonIterableRest();
}
function $071577e537677ba8$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $071577e537677ba8$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $071577e537677ba8$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $071577e537677ba8$var$_arrayLikeToArray(o, minLen);
}
function $071577e537677ba8$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $071577e537677ba8$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $071577e537677ba8$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
var $071577e537677ba8$var$UserlandBoundary = function UserlandBoundary(_ref) {
    var children = _ref.children, type = _ref.type;
    var _useState = (0, $071577e537677ba8$var$_react.useState)(), _useState2 = $071577e537677ba8$var$_slicedToArray(_useState, 2), error = _useState2[0], setError = _useState2[1];
    var handleError = (0, $071577e537677ba8$var$_react.useCallback)(function(error) {
        return setError(error);
    }, []);
    return error ? /*#__PURE__*/ $071577e537677ba8$var$_react.default.createElement($071577e537677ba8$var$_ErrorBox.default, {
        error: error,
        type: type
    }) : /*#__PURE__*/ $071577e537677ba8$var$_react.default.createElement($071577e537677ba8$var$_ErrorBoundary.default, {
        onError: handleError
    }, children);
};
$071577e537677ba8$var$UserlandBoundary.defaultProps = {
    children: undefined,
    type: undefined
};
$071577e537677ba8$var$UserlandBoundary.propTypes = {
    children: $071577e537677ba8$var$_propTypes.default.any,
    type: $071577e537677ba8$var$_propTypes.default.string
};
var $071577e537677ba8$var$_default = $071577e537677ba8$var$UserlandBoundary;
module.exports.default = $071577e537677ba8$var$_default;

});


parcelRequire.register("bpS5X", function(module, exports) {





(function(root, factory) {
    // UMD returnExports
    if (typeof define === "function" && define.amd) // AMD
    define([
        "globalize/dist/globalize-runtime/number",
        "globalize/dist/globalize-runtime/plural",
        "globalize/dist/globalize-runtime/date",
        "globalize/dist/globalize-runtime/relative-time",
        "globalize/dist/globalize-runtime/unit"
    ], factory);
    else // Node, CommonJS
    module.exports = factory((parcelRequire("kNVX6")), (parcelRequire("Tuopc")), (parcelRequire("eqT18")), (parcelRequire("iHvJ8")), (parcelRequire("aXfaC")));
})(module.exports, function(Globalize) {
    var numberRound = Globalize._numberRound;
    var numberToPartsFormatterFn = Globalize._numberToPartsFormatterFn;
    var numberFormatterFn = Globalize._numberFormatterFn;
    var pluralGeneratorFn = Globalize._pluralGeneratorFn;
    var dateToPartsFormatterFn = Globalize._dateToPartsFormatterFn;
    var dateFormatterFn = Globalize._dateFormatterFn;
    var relativeTimeFormatterFn = Globalize._relativeTimeFormatterFn;
    var unitFormatterFn = Globalize._unitFormatterFn;
    Globalize.a1941952454 = numberToPartsFormatterFn([
        "",
        ,
        1,
        0,
        0,
        ,
        ,
        ,
        ,
        ,
        "",
        "0",
        "-0",
        "-",
        "",
        numberRound(),
        "∞",
        "ليس\xa0رقم",
        {
            ".": "٫",
            ",": "٬",
            "%": "٪؜",
            "+": "؜+",
            "-": "؜-",
            E: "اس",
            "‰": "؉"
        },
        "٠١٢٣٤٥٦٧٨٩"
    ]);
    Globalize.a71314638 = numberToPartsFormatterFn([
        "",
        ,
        2,
        0,
        0,
        ,
        ,
        ,
        ,
        ,
        "",
        "00",
        "-00",
        "-",
        "",
        numberRound(),
        "∞",
        "ليس\xa0رقم",
        {
            ".": "٫",
            ",": "٬",
            "%": "٪؜",
            "+": "؜+",
            "-": "؜-",
            E: "اس",
            "‰": "؉"
        },
        "٠١٢٣٤٥٦٧٨٩"
    ]);
    Globalize.b1800711952 = numberToPartsFormatterFn([
        "",
        ,
        1,
        0,
        3,
        ,
        ,
        ,
        3,
        ,
        "",
        "#,##0.###",
        "-#,##0.###",
        "-",
        "",
        numberRound(),
        "∞",
        "ليس\xa0رقم",
        {
            ".": "٫",
            ",": "٬",
            "%": "٪؜",
            "+": "؜+",
            "-": "؜-",
            E: "اس",
            "‰": "؉"
        },
        "٠١٢٣٤٥٦٧٨٩"
    ]);
    Globalize.a311225754 = numberToPartsFormatterFn([
        "",
        ,
        1,
        0,
        0,
        ,
        ,
        ,
        ,
        ,
        "",
        "0",
        "-0",
        "-",
        "",
        numberRound(),
        "∞",
        "ليس\xa0رقم",
        {
            ".": "٫",
            ",": "٬",
            "%": "٪؜",
            "+": "؜+",
            "-": "؜-",
            E: "اس",
            "‰": "؉"
        },
        "٠١٢٣٤٥٦٧٨٩"
    ]);
    Globalize.a1058394490 = numberToPartsFormatterFn([
        "",
        ,
        2,
        0,
        0,
        ,
        ,
        ,
        ,
        ,
        "",
        "00",
        "-00",
        "-",
        "",
        numberRound(),
        "∞",
        "ليس\xa0رقم",
        {
            ".": "٫",
            ",": "٬",
            "%": "٪؜",
            "+": "؜+",
            "-": "؜-",
            E: "اس",
            "‰": "؉"
        },
        "٠١٢٣٤٥٦٧٨٩"
    ]);
    Globalize.b1405444964 = numberToPartsFormatterFn([
        "",
        ,
        1,
        0,
        3,
        ,
        ,
        ,
        3,
        ,
        "",
        "#,##0.###",
        "-#,##0.###",
        "-",
        "",
        numberRound(),
        "∞",
        "ليس\xa0رقم",
        {
            ".": "٫",
            ",": "٬",
            "%": "٪؜",
            "+": "؜+",
            "-": "؜-",
            E: "اس",
            "‰": "؉"
        },
        "٠١٢٣٤٥٦٧٨٩"
    ]);
    Globalize.b162621629 = numberToPartsFormatterFn([
        "",
        ,
        1,
        0,
        0,
        ,
        ,
        ,
        ,
        ,
        "",
        "0",
        "-0",
        "-",
        "",
        numberRound(),
        "∞",
        "NaN",
        {
            ".": ",",
            ",": "\xa0",
            "%": "%",
            "+": "+",
            "-": "-",
            E: "E",
            "‰": "‰"
        }
    ]);
    Globalize.b745972495 = numberToPartsFormatterFn([
        "",
        ,
        2,
        0,
        0,
        ,
        ,
        ,
        ,
        ,
        "",
        "00",
        "-00",
        "-",
        "",
        numberRound(),
        "∞",
        "NaN",
        {
            ".": ",",
            ",": "\xa0",
            "%": "%",
            "+": "+",
            "-": "-",
            E: "E",
            "‰": "‰"
        }
    ]);
    Globalize.a1541980371 = numberToPartsFormatterFn([
        "",
        ,
        1,
        0,
        3,
        ,
        ,
        ,
        3,
        ,
        "",
        "#,##0.###",
        "-#,##0.###",
        "-",
        "",
        numberRound(),
        "∞",
        "NaN",
        {
            ".": ",",
            ",": "\xa0",
            "%": "%",
            "+": "+",
            "-": "-",
            E: "E",
            "‰": "‰"
        }
    ]);
    Globalize.a83314634 = numberToPartsFormatterFn([
        "",
        ,
        1,
        0,
        0,
        ,
        ,
        ,
        ,
        ,
        "",
        "0",
        "-0",
        "-",
        "",
        numberRound(),
        "∞",
        "NaN",
        {
            ".": ",",
            ",": ".",
            "%": "%",
            "+": "+",
            "-": "-",
            E: "E",
            "‰": "‰"
        }
    ]);
    Globalize.b1711882934 = numberToPartsFormatterFn([
        "",
        ,
        2,
        0,
        0,
        ,
        ,
        ,
        ,
        ,
        "",
        "00",
        "-00",
        "-",
        "",
        numberRound(),
        "∞",
        "NaN",
        {
            ".": ",",
            ",": ".",
            "%": "%",
            "+": "+",
            "-": "-",
            E: "E",
            "‰": "‰"
        }
    ]);
    Globalize.a1565068396 = numberToPartsFormatterFn([
        "",
        ,
        1,
        0,
        3,
        ,
        ,
        ,
        3,
        ,
        "",
        "#,##0.###",
        "-#,##0.###",
        "-",
        "",
        numberRound(),
        "∞",
        "NaN",
        {
            ".": ",",
            ",": ".",
            "%": "%",
            "+": "+",
            "-": "-",
            E: "E",
            "‰": "‰"
        }
    ]);
    Globalize.b426806024 = numberToPartsFormatterFn([
        "",
        ,
        1,
        0,
        0,
        ,
        ,
        ,
        ,
        ,
        "",
        "0",
        "-0",
        "-",
        "",
        numberRound(),
        "∞",
        "NaN",
        {
            ".": ",",
            ",": "\xa0",
            "%": "%",
            "+": "+",
            "-": "-",
            E: "E",
            "‰": "‰"
        }
    ]);
    Globalize.b345754148 = numberToPartsFormatterFn([
        "",
        ,
        2,
        0,
        0,
        ,
        ,
        ,
        ,
        ,
        "",
        "00",
        "-00",
        "-",
        "",
        numberRound(),
        "∞",
        "NaN",
        {
            ".": ",",
            ",": "\xa0",
            "%": "%",
            "+": "+",
            "-": "-",
            E: "E",
            "‰": "‰"
        }
    ]);
    Globalize.a1581691774 = numberToPartsFormatterFn([
        "",
        ,
        1,
        0,
        3,
        ,
        ,
        ,
        3,
        ,
        "",
        "#,##0.###",
        "-#,##0.###",
        "-",
        "",
        numberRound(),
        "∞",
        "NaN",
        {
            ".": ",",
            ",": "\xa0",
            "%": "%",
            "+": "+",
            "-": "-",
            E: "E",
            "‰": "‰"
        }
    ]);
    Globalize.a1590866443 = numberToPartsFormatterFn([
        "",
        ,
        1,
        0,
        0,
        ,
        ,
        ,
        ,
        ,
        "",
        "0",
        "-0",
        "-",
        "",
        numberRound(),
        "∞",
        "NaN",
        {
            ".": ",",
            ",": ".",
            "%": "%",
            "+": "+",
            "-": "-",
            E: "E",
            "‰": "‰"
        }
    ]);
    Globalize.a2072550185 = numberToPartsFormatterFn([
        "",
        ,
        2,
        0,
        0,
        ,
        ,
        ,
        ,
        ,
        "",
        "00",
        "-00",
        "-",
        "",
        numberRound(),
        "∞",
        "NaN",
        {
            ".": ",",
            ",": ".",
            "%": "%",
            "+": "+",
            "-": "-",
            E: "E",
            "‰": "‰"
        }
    ]);
    Globalize.a1593697547 = numberToPartsFormatterFn([
        "",
        ,
        1,
        0,
        3,
        ,
        ,
        ,
        3,
        ,
        "",
        "#,##0.###",
        "-#,##0.###",
        "-",
        "",
        numberRound(),
        "∞",
        "NaN",
        {
            ".": ",",
            ",": ".",
            "%": "%",
            "+": "+",
            "-": "-",
            E: "E",
            "‰": "‰"
        }
    ]);
    Globalize.b431368057 = numberToPartsFormatterFn([
        "",
        ,
        1,
        0,
        0,
        ,
        ,
        ,
        ,
        ,
        "",
        "0",
        "-0",
        "-",
        "",
        numberRound(),
        "∞",
        "NaN",
        {
            ".": ",",
            ",": ".",
            "%": "%",
            "+": "+",
            "-": "-",
            E: "E",
            "‰": "‰"
        }
    ]);
    Globalize.b487177171 = numberToPartsFormatterFn([
        "",
        ,
        2,
        0,
        0,
        ,
        ,
        ,
        ,
        ,
        "",
        "00",
        "-00",
        "-",
        "",
        numberRound(),
        "∞",
        "NaN",
        {
            ".": ",",
            ",": ".",
            "%": "%",
            "+": "+",
            "-": "-",
            E: "E",
            "‰": "‰"
        }
    ]);
    Globalize.a1597391631 = numberToPartsFormatterFn([
        "",
        ,
        1,
        0,
        3,
        ,
        ,
        ,
        3,
        ,
        "",
        "#,##0.###",
        "-#,##0.###",
        "-",
        "",
        numberRound(),
        "∞",
        "NaN",
        {
            ".": ",",
            ",": ".",
            "%": "%",
            "+": "+",
            "-": "-",
            E: "E",
            "‰": "‰"
        }
    ]);
    Globalize.a1832240673 = numberToPartsFormatterFn([
        "",
        ,
        1,
        0,
        0,
        ,
        ,
        ,
        ,
        ,
        "",
        "0",
        "-0",
        "-",
        "",
        numberRound(),
        "∞",
        "NaN",
        {
            ".": ",",
            ",": ".",
            "%": "%",
            "+": "+",
            "-": "-",
            E: "e",
            "‰": "‰"
        }
    ]);
    Globalize.a965216723 = numberToPartsFormatterFn([
        "",
        ,
        2,
        0,
        0,
        ,
        ,
        ,
        ,
        ,
        "",
        "00",
        "-00",
        "-",
        "",
        numberRound(),
        "∞",
        "NaN",
        {
            ".": ",",
            ",": ".",
            "%": "%",
            "+": "+",
            "-": "-",
            E: "e",
            "‰": "‰"
        }
    ]);
    Globalize.a1632485429 = numberToPartsFormatterFn([
        "",
        ,
        1,
        0,
        3,
        ,
        ,
        ,
        3,
        ,
        "",
        "#,##0.###",
        "-#,##0.###",
        "-",
        "",
        numberRound(),
        "∞",
        "NaN",
        {
            ".": ",",
            ",": ".",
            "%": "%",
            "+": "+",
            "-": "-",
            E: "e",
            "‰": "‰"
        }
    ]);
    Globalize.a821123423 = numberToPartsFormatterFn([
        "",
        ,
        1,
        0,
        0,
        ,
        ,
        ,
        ,
        ,
        "",
        "0",
        "-0",
        "-",
        "",
        numberRound(),
        "∞",
        "NaN",
        {
            ".": ".",
            ",": ",",
            "%": "%",
            "+": "+",
            "-": "-",
            E: "E",
            "‰": "‰"
        }
    ]);
    Globalize.b314646955 = numberToPartsFormatterFn([
        "",
        ,
        2,
        0,
        0,
        ,
        ,
        ,
        ,
        ,
        "",
        "00",
        "-00",
        "-",
        "",
        numberRound(),
        "∞",
        "NaN",
        {
            ".": ".",
            ",": ",",
            "%": "%",
            "+": "+",
            "-": "-",
            E: "E",
            "‰": "‰"
        }
    ]);
    Globalize.a1634332471 = numberToPartsFormatterFn([
        "",
        ,
        1,
        0,
        3,
        ,
        ,
        ,
        3,
        ,
        "",
        "#,##0.###",
        "-#,##0.###",
        "-",
        "",
        numberRound(),
        "∞",
        "NaN",
        {
            ".": ".",
            ",": ",",
            "%": "%",
            "+": "+",
            "-": "-",
            E: "E",
            "‰": "‰"
        }
    ]);
    Globalize.b1706669702 = numberToPartsFormatterFn([
        "",
        ,
        1,
        0,
        0,
        ,
        ,
        ,
        ,
        ,
        "",
        "0",
        "-0",
        "-",
        "",
        numberRound(),
        "∞",
        "NaN",
        {
            ".": ",",
            ",": ".",
            "%": "%",
            "+": "+",
            "-": "-",
            E: "E",
            "‰": "‰"
        }
    ]);
    Globalize.b1366822502 = numberToPartsFormatterFn([
        "",
        ,
        2,
        0,
        0,
        ,
        ,
        ,
        ,
        ,
        "",
        "00",
        "-00",
        "-",
        "",
        numberRound(),
        "∞",
        "NaN",
        {
            ".": ",",
            ",": ".",
            "%": "%",
            "+": "+",
            "-": "-",
            E: "E",
            "‰": "‰"
        }
    ]);
    Globalize.a1638950076 = numberToPartsFormatterFn([
        "",
        ,
        1,
        0,
        3,
        ,
        ,
        ,
        3,
        ,
        "",
        "#,##0.###",
        "-#,##0.###",
        "-",
        "",
        numberRound(),
        "∞",
        "NaN",
        {
            ".": ",",
            ",": ".",
            "%": "%",
            "+": "+",
            "-": "-",
            E: "E",
            "‰": "‰"
        }
    ]);
    Globalize.a2082738969 = numberToPartsFormatterFn([
        "",
        ,
        1,
        0,
        0,
        ,
        ,
        ,
        ,
        ,
        "",
        "0",
        "-0",
        "-",
        "",
        numberRound(),
        "∞",
        "NaN",
        {
            ".": ",",
            ",": "\xa0",
            "%": "%",
            "+": "+",
            "-": "−",
            E: "\xd710^",
            "‰": "‰"
        }
    ]);
    Globalize.a140729307 = numberToPartsFormatterFn([
        "",
        ,
        2,
        0,
        0,
        ,
        ,
        ,
        ,
        ,
        "",
        "00",
        "-00",
        "-",
        "",
        numberRound(),
        "∞",
        "NaN",
        {
            ".": ",",
            ",": "\xa0",
            "%": "%",
            "+": "+",
            "-": "−",
            E: "\xd710^",
            "‰": "‰"
        }
    ]);
    Globalize.a1639873597 = numberToPartsFormatterFn([
        "",
        ,
        1,
        0,
        3,
        ,
        ,
        ,
        3,
        ,
        "",
        "#,##0.###",
        "-#,##0.###",
        "-",
        "",
        numberRound(),
        "∞",
        "NaN",
        {
            ".": ",",
            ",": "\xa0",
            "%": "%",
            "+": "+",
            "-": "−",
            E: "\xd710^",
            "‰": "‰"
        }
    ]);
    Globalize.a1577180344 = numberToPartsFormatterFn([
        "",
        ,
        1,
        0,
        0,
        ,
        ,
        ,
        ,
        ,
        "",
        "0",
        "-0",
        "-",
        "",
        numberRound(),
        "∞",
        "NaN",
        {
            ".": ",",
            ",": ".",
            "%": "%",
            "+": "+",
            "-": "−",
            E: "E",
            "‰": "‰"
        }
    ]);
    Globalize.a1648281116 = numberToPartsFormatterFn([
        "",
        ,
        2,
        0,
        0,
        ,
        ,
        ,
        ,
        ,
        "",
        "00",
        "-00",
        "-",
        "",
        numberRound(),
        "∞",
        "NaN",
        {
            ".": ",",
            ",": ".",
            "%": "%",
            "+": "+",
            "-": "−",
            E: "E",
            "‰": "‰"
        }
    ]);
    Globalize.a1640797118 = numberToPartsFormatterFn([
        "",
        ,
        1,
        0,
        3,
        ,
        ,
        ,
        3,
        ,
        "",
        "#,##0.###",
        "-#,##0.###",
        "-",
        "",
        numberRound(),
        "∞",
        "NaN",
        {
            ".": ",",
            ",": ".",
            "%": "%",
            "+": "+",
            "-": "−",
            E: "E",
            "‰": "‰"
        }
    ]);
    Globalize.a561501061 = numberToPartsFormatterFn([
        "",
        ,
        1,
        0,
        0,
        ,
        ,
        ,
        ,
        ,
        "",
        "0",
        "-0",
        "-",
        "",
        numberRound(),
        "∞",
        "ep\xe4luku",
        {
            ".": ",",
            ",": "\xa0",
            "%": "%",
            "+": "+",
            "-": "−",
            E: "E",
            "‰": "‰"
        }
    ]);
    Globalize.a226994415 = numberToPartsFormatterFn([
        "",
        ,
        2,
        0,
        0,
        ,
        ,
        ,
        ,
        ,
        "",
        "00",
        "-00",
        "-",
        "",
        numberRound(),
        "∞",
        "ep\xe4luku",
        {
            ".": ",",
            ",": "\xa0",
            "%": "%",
            "+": "+",
            "-": "−",
            E: "E",
            "‰": "‰"
        }
    ]);
    Globalize.a1658344017 = numberToPartsFormatterFn([
        "",
        ,
        1,
        0,
        3,
        ,
        ,
        ,
        3,
        ,
        "",
        "#,##0.###",
        "-#,##0.###",
        "-",
        "",
        numberRound(),
        "∞",
        "ep\xe4luku",
        {
            ".": ",",
            ",": "\xa0",
            "%": "%",
            "+": "+",
            "-": "−",
            E: "E",
            "‰": "‰"
        }
    ]);
    Globalize.a306440732 = numberToPartsFormatterFn([
        "",
        ,
        1,
        0,
        0,
        ,
        ,
        ,
        ,
        ,
        "",
        "0",
        "-0",
        "-",
        "",
        numberRound(),
        "∞",
        "NaN",
        {
            ".": ",",
            ",": " ",
            "%": "%",
            "+": "+",
            "-": "-",
            E: "E",
            "‰": "‰"
        }
    ]);
    Globalize.a910058808 = numberToPartsFormatterFn([
        "",
        ,
        2,
        0,
        0,
        ,
        ,
        ,
        ,
        ,
        "",
        "00",
        "-00",
        "-",
        "",
        numberRound(),
        "∞",
        "NaN",
        {
            ".": ",",
            ",": " ",
            "%": "%",
            "+": "+",
            "-": "-",
            E: "E",
            "‰": "‰"
        }
    ]);
    Globalize.a1666655706 = numberToPartsFormatterFn([
        "",
        ,
        1,
        0,
        3,
        ,
        ,
        ,
        3,
        ,
        "",
        "#,##0.###",
        "-#,##0.###",
        "-",
        "",
        numberRound(),
        "∞",
        "NaN",
        {
            ".": ",",
            ",": " ",
            "%": "%",
            "+": "+",
            "-": "-",
            E: "E",
            "‰": "‰"
        }
    ]);
    Globalize.a552376995 = numberToPartsFormatterFn([
        "",
        ,
        1,
        0,
        0,
        ,
        ,
        ,
        ,
        ,
        "",
        "0",
        "-0",
        "-",
        "",
        numberRound(),
        "∞",
        "NaN",
        {
            ".": ",",
            ",": ".",
            "%": "%",
            "+": "+",
            "-": "-",
            E: "E",
            "‰": "‰"
        }
    ]);
    Globalize.b55851631 = numberToPartsFormatterFn([
        "",
        ,
        2,
        0,
        0,
        ,
        ,
        ,
        ,
        ,
        "",
        "00",
        "-00",
        "-",
        "",
        numberRound(),
        "∞",
        "NaN",
        {
            ".": ",",
            ",": ".",
            "%": "%",
            "+": "+",
            "-": "-",
            E: "E",
            "‰": "‰"
        }
    ]);
    Globalize.a1689743731 = numberToPartsFormatterFn([
        "",
        ,
        1,
        0,
        3,
        ,
        ,
        ,
        3,
        ,
        "",
        "#,##0.###",
        "-#,##0.###",
        "-",
        "",
        numberRound(),
        "∞",
        "NaN",
        {
            ".": ",",
            ",": ".",
            "%": "%",
            "+": "+",
            "-": "-",
            E: "E",
            "‰": "‰"
        }
    ]);
    Globalize.a1303871883 = numberToPartsFormatterFn([
        "",
        ,
        1,
        0,
        0,
        ,
        ,
        ,
        ,
        ,
        "",
        "0",
        "-0",
        "-",
        "",
        numberRound(),
        "∞",
        "NaN",
        {
            ".": ".",
            ",": ",",
            "%": "%",
            "+": "‎+",
            "-": "‎-",
            E: "E",
            "‰": "‰"
        }
    ]);
    Globalize.a1765653417 = numberToPartsFormatterFn([
        "",
        ,
        2,
        0,
        0,
        ,
        ,
        ,
        ,
        ,
        "",
        "00",
        "-00",
        "-",
        "",
        numberRound(),
        "∞",
        "NaN",
        {
            ".": ".",
            ",": ",",
            "%": "%",
            "+": "‎+",
            "-": "‎-",
            E: "E",
            "‰": "‰"
        }
    ]);
    Globalize.a1711908235 = numberToPartsFormatterFn([
        "",
        ,
        1,
        0,
        3,
        ,
        ,
        ,
        3,
        ,
        "",
        "#,##0.###",
        "-#,##0.###",
        "-",
        "",
        numberRound(),
        "∞",
        "NaN",
        {
            ".": ".",
            ",": ",",
            "%": "%",
            "+": "‎+",
            "-": "‎-",
            E: "E",
            "‰": "‰"
        }
    ]);
    Globalize.b718362617 = numberToPartsFormatterFn([
        "",
        ,
        1,
        0,
        0,
        ,
        ,
        ,
        ,
        ,
        "",
        "0",
        "-0",
        "-",
        "",
        numberRound(),
        "∞",
        "NaN",
        {
            ".": ".",
            ",": ",",
            "%": "%",
            "+": "+",
            "-": "-",
            E: "E",
            "‰": "‰"
        }
    ]);
    Globalize.b794073939 = numberToPartsFormatterFn([
        "",
        ,
        2,
        0,
        0,
        ,
        ,
        ,
        ,
        ,
        "",
        "00",
        "-00",
        "-",
        "",
        numberRound(),
        "∞",
        "NaN",
        {
            ".": ".",
            ",": ",",
            "%": "%",
            "+": "+",
            "-": "-",
            E: "E",
            "‰": "‰"
        }
    ]);
    Globalize.a1715602319 = numberToPartsFormatterFn([
        "",
        ,
        1,
        0,
        3,
        ,
        ,
        ,
        3,
        2,
        "",
        "#,##,##0.###",
        "-#,##,##0.###",
        "-",
        "",
        numberRound(),
        "∞",
        "NaN",
        {
            ".": ".",
            ",": ",",
            "%": "%",
            "+": "+",
            "-": "-",
            E: "E",
            "‰": "‰"
        }
    ]);
    Globalize.b973422946 = numberToPartsFormatterFn([
        "",
        ,
        1,
        0,
        0,
        ,
        ,
        ,
        ,
        ,
        "",
        "0",
        "-0",
        "-",
        "",
        numberRound(),
        "∞",
        "NaN",
        {
            ".": ",",
            ",": ".",
            "%": "%",
            "+": "+",
            "-": "-",
            E: "E",
            "‰": "‰"
        }
    ]);
    Globalize.b111009546 = numberToPartsFormatterFn([
        "",
        ,
        2,
        0,
        0,
        ,
        ,
        ,
        ,
        ,
        "",
        "00",
        "-00",
        "-",
        "",
        numberRound(),
        "∞",
        "NaN",
        {
            ".": ",",
            ",": ".",
            "%": "%",
            "+": "+",
            "-": "-",
            E: "E",
            "‰": "‰"
        }
    ]);
    Globalize.a1723914008 = numberToPartsFormatterFn([
        "",
        ,
        1,
        0,
        3,
        ,
        ,
        ,
        3,
        ,
        "",
        "#,##0.###",
        "-#,##0.###",
        "-",
        "",
        numberRound(),
        "∞",
        "NaN",
        {
            ".": ",",
            ",": ".",
            "%": "%",
            "+": "+",
            "-": "-",
            E: "E",
            "‰": "‰"
        }
    ]);
    Globalize.a1804868475 = numberToPartsFormatterFn([
        "",
        ,
        1,
        0,
        0,
        ,
        ,
        ,
        ,
        ,
        "",
        "0",
        "-0",
        "-",
        "",
        numberRound(),
        "∞",
        "NaN",
        {
            ".": ",",
            ",": "\xa0",
            "%": "%",
            "+": "+",
            "-": "-",
            E: "E",
            "‰": "‰"
        }
    ]);
    Globalize.a116678585 = numberToPartsFormatterFn([
        "",
        ,
        2,
        0,
        0,
        ,
        ,
        ,
        ,
        ,
        "",
        "00",
        "-00",
        "-",
        "",
        numberRound(),
        "∞",
        "NaN",
        {
            ".": ",",
            ",": "\xa0",
            "%": "%",
            "+": "+",
            "-": "-",
            E: "E",
            "‰": "‰"
        }
    ]);
    Globalize.a1726684571 = numberToPartsFormatterFn([
        "",
        ,
        1,
        0,
        3,
        ,
        ,
        ,
        3,
        ,
        "",
        "#,##0.###",
        "-#,##0.###",
        "-",
        "",
        numberRound(),
        "∞",
        "NaN",
        {
            ".": ",",
            ",": "\xa0",
            "%": "%",
            "+": "+",
            "-": "-",
            E: "E",
            "‰": "‰"
        }
    ]);
    Globalize.b977984979 = numberToPartsFormatterFn([
        "",
        ,
        1,
        0,
        0,
        ,
        ,
        ,
        ,
        ,
        "",
        "0",
        "-0",
        "-",
        "",
        numberRound(),
        "∞",
        "NaN",
        {
            ".": ",",
            ",": ".",
            "%": "%",
            "+": "+",
            "-": "-",
            E: "E",
            "‰": "‰"
        }
    ]);
    Globalize.b252432569 = numberToPartsFormatterFn([
        "",
        ,
        2,
        0,
        0,
        ,
        ,
        ,
        ,
        ,
        "",
        "00",
        "-00",
        "-",
        "",
        numberRound(),
        "∞",
        "NaN",
        {
            ".": ",",
            ",": ".",
            "%": "%",
            "+": "+",
            "-": "-",
            E: "E",
            "‰": "‰"
        }
    ]);
    Globalize.a1739613865 = numberToPartsFormatterFn([
        "",
        ,
        1,
        0,
        3,
        ,
        ,
        ,
        3,
        ,
        "",
        "#,##0.###",
        "-#,##0.###",
        "-",
        "",
        numberRound(),
        "∞",
        "NaN",
        {
            ".": ",",
            ",": ".",
            "%": "%",
            "+": "+",
            "-": "-",
            E: "E",
            "‰": "‰"
        }
    ]);
    Globalize.b476988387 = numberToPartsFormatterFn([
        "",
        ,
        1,
        0,
        0,
        ,
        ,
        ,
        ,
        ,
        "",
        "0",
        "-0",
        "-",
        "",
        numberRound(),
        "∞",
        "NaN",
        {
            ".": ",",
            ",": ".",
            "%": "%",
            "+": "+",
            "-": "-",
            E: "E",
            "‰": "‰"
        }
    ]);
    Globalize.b1901407401 = numberToPartsFormatterFn([
        "",
        ,
        2,
        0,
        0,
        ,
        ,
        ,
        ,
        ,
        "",
        "00",
        "-00",
        "-",
        "",
        numberRound(),
        "∞",
        "NaN",
        {
            ".": ",",
            ",": ".",
            "%": "%",
            "+": "+",
            "-": "-",
            E: "E",
            "‰": "‰"
        }
    ]);
    Globalize.a1754390201 = numberToPartsFormatterFn([
        "",
        ,
        1,
        0,
        3,
        ,
        ,
        ,
        3,
        ,
        "",
        "#,##0.###",
        "-#,##0.###",
        "-",
        "",
        numberRound(),
        "∞",
        "NaN",
        {
            ".": ",",
            ",": ".",
            "%": "%",
            "+": "+",
            "-": "-",
            E: "E",
            "‰": "‰"
        }
    ]);
    Globalize.a2046242705 = numberToPartsFormatterFn([
        "",
        ,
        1,
        0,
        0,
        ,
        ,
        ,
        ,
        ,
        "",
        "0",
        "-0",
        "-",
        "",
        numberRound(),
        "∞",
        "NaN",
        {
            ".": ".",
            ",": ",",
            "%": "%",
            "+": "+",
            "-": "-",
            E: "E",
            "‰": "‰"
        }
    ]);
    Globalize.b990654877 = numberToPartsFormatterFn([
        "",
        ,
        2,
        0,
        0,
        ,
        ,
        ,
        ,
        ,
        "",
        "00",
        "-00",
        "-",
        "",
        numberRound(),
        "∞",
        "NaN",
        {
            ".": ".",
            ",": ",",
            "%": "%",
            "+": "+",
            "-": "-",
            E: "E",
            "‰": "‰"
        }
    ]);
    Globalize.a1765472453 = numberToPartsFormatterFn([
        "",
        ,
        1,
        0,
        3,
        ,
        ,
        ,
        3,
        ,
        "",
        "#,##0.###",
        "-#,##0.###",
        "-",
        "",
        numberRound(),
        "∞",
        "NaN",
        {
            ".": ".",
            ",": ",",
            "%": "%",
            "+": "+",
            "-": "-",
            E: "E",
            "‰": "‰"
        }
    ]);
    Globalize.b1501791736 = numberToPartsFormatterFn([
        "",
        ,
        1,
        0,
        0,
        ,
        ,
        ,
        ,
        ,
        "",
        "0",
        "-0",
        "-",
        "",
        numberRound(),
        "∞",
        "сан\xa0емес",
        {
            ".": ",",
            ",": "\xa0",
            "%": "%",
            "+": "+",
            "-": "-",
            E: "E",
            "‰": "‰"
        }
    ]);
    Globalize.a689427148 = numberToPartsFormatterFn([
        "",
        ,
        2,
        0,
        0,
        ,
        ,
        ,
        ,
        ,
        "",
        "00",
        "-00",
        "-",
        "",
        numberRound(),
        "∞",
        "сан\xa0емес",
        {
            ".": ",",
            ",": "\xa0",
            "%": "%",
            "+": "+",
            "-": "-",
            E: "E",
            "‰": "‰"
        }
    ]);
    Globalize.a1803336814 = numberToPartsFormatterFn([
        "",
        ,
        1,
        0,
        3,
        ,
        ,
        ,
        3,
        ,
        "",
        "#,##0.###",
        "-#,##0.###",
        "-",
        "",
        numberRound(),
        "∞",
        "сан\xa0емес",
        {
            ".": ",",
            ",": "\xa0",
            "%": "%",
            "+": "+",
            "-": "-",
            E: "E",
            "‰": "‰"
        }
    ]);
    Globalize.a770941060 = numberToPartsFormatterFn([
        "",
        ,
        1,
        0,
        0,
        ,
        ,
        ,
        ,
        ,
        "",
        "0",
        "-0",
        "-",
        "",
        numberRound(),
        "∞",
        "NaN",
        {
            ".": ".",
            ",": ",",
            "%": "%",
            "+": "+",
            "-": "-",
            E: "E",
            "‰": "‰"
        }
    ]);
    Globalize.b1870300208 = numberToPartsFormatterFn([
        "",
        ,
        2,
        0,
        0,
        ,
        ,
        ,
        ,
        ,
        "",
        "00",
        "-00",
        "-",
        "",
        numberRound(),
        "∞",
        "NaN",
        {
            ".": ".",
            ",": ",",
            "%": "%",
            "+": "+",
            "-": "-",
            E: "E",
            "‰": "‰"
        }
    ]);
    Globalize.a1807030898 = numberToPartsFormatterFn([
        "",
        ,
        1,
        0,
        3,
        ,
        ,
        ,
        3,
        ,
        "",
        "#,##0.###",
        "-#,##0.###",
        "-",
        "",
        numberRound(),
        "∞",
        "NaN",
        {
            ".": ".",
            ",": ",",
            "%": "%",
            "+": "+",
            "-": "-",
            E: "E",
            "‰": "‰"
        }
    ]);
    Globalize.b249300256 = numberToPartsFormatterFn([
        "",
        ,
        1,
        0,
        0,
        ,
        ,
        ,
        ,
        ,
        "",
        "0",
        "-0",
        "-",
        "",
        numberRound(),
        "∞",
        "NaN",
        {
            ".": ",",
            ",": "\xa0",
            "%": "%",
            "+": "+",
            "-": "−",
            E: "\xd710^",
            "‰": "‰"
        }
    ]);
    Globalize.a861957364 = numberToPartsFormatterFn([
        "",
        ,
        2,
        0,
        0,
        ,
        ,
        ,
        ,
        ,
        "",
        "00",
        "-00",
        "-",
        "",
        numberRound(),
        "∞",
        "NaN",
        {
            ".": ",",
            ",": "\xa0",
            "%": "%",
            "+": "+",
            "-": "−",
            E: "\xd710^",
            "‰": "‰"
        }
    ]);
    Globalize.a1840277654 = numberToPartsFormatterFn([
        "",
        ,
        1,
        0,
        3,
        ,
        ,
        ,
        3,
        ,
        "",
        "#,##0.###",
        "-#,##0.###",
        "-",
        "",
        numberRound(),
        "∞",
        "NaN",
        {
            ".": ",",
            ",": "\xa0",
            "%": "%",
            "+": "+",
            "-": "−",
            E: "\xd710^",
            "‰": "‰"
        }
    ]);
    Globalize.b1260417506 = numberToPartsFormatterFn([
        "",
        ,
        1,
        0,
        0,
        ,
        ,
        ,
        ,
        ,
        "",
        "0",
        "-0",
        "-",
        "",
        numberRound(),
        "∞",
        "NS",
        {
            ".": ",",
            ",": "\xa0",
            "%": "%",
            "+": "+",
            "-": "-",
            E: "E",
            "‰": "‰"
        }
    ]);
    Globalize.b417906314 = numberToPartsFormatterFn([
        "",
        ,
        2,
        0,
        0,
        ,
        ,
        ,
        ,
        ,
        "",
        "00",
        "-00",
        "-",
        "",
        numberRound(),
        "∞",
        "NS",
        {
            ".": ",",
            ",": "\xa0",
            "%": "%",
            "+": "+",
            "-": "-",
            E: "E",
            "‰": "‰"
        }
    ]);
    Globalize.a1842124696 = numberToPartsFormatterFn([
        "",
        ,
        1,
        0,
        3,
        ,
        ,
        ,
        3,
        ,
        "",
        "#,##0.###",
        "-#,##0.###",
        "-",
        "",
        numberRound(),
        "∞",
        "NS",
        {
            ".": ",",
            ",": "\xa0",
            "%": "%",
            "+": "+",
            "-": "-",
            E: "E",
            "‰": "‰"
        }
    ]);
    Globalize.a1763810178 = numberToPartsFormatterFn([
        "",
        ,
        1,
        0,
        0,
        ,
        ,
        ,
        ,
        ,
        "",
        "0",
        "-0",
        "-",
        "",
        numberRound(),
        "∞",
        "NaN",
        {
            ".": ".",
            ",": ",",
            "%": "%",
            "+": "+",
            "-": "-",
            E: "E",
            "‰": "‰"
        }
    ]);
    Globalize.b1156128622 = numberToPartsFormatterFn([
        "",
        ,
        2,
        0,
        0,
        ,
        ,
        ,
        ,
        ,
        "",
        "00",
        "-00",
        "-",
        "",
        numberRound(),
        "∞",
        "NaN",
        {
            ".": ".",
            ",": ",",
            "%": "%",
            "+": "+",
            "-": "-",
            E: "E",
            "‰": "‰"
        }
    ]);
    Globalize.a1867983284 = numberToPartsFormatterFn([
        "",
        ,
        1,
        0,
        3,
        ,
        ,
        ,
        3,
        ,
        "",
        "#,##0.###",
        "-#,##0.###",
        "-",
        "",
        numberRound(),
        "∞",
        "NaN",
        {
            ".": ".",
            ",": ",",
            "%": "%",
            "+": "+",
            "-": "-",
            E: "E",
            "‰": "‰"
        }
    ]);
    Globalize.b1019043276 = numberToPartsFormatterFn([
        "",
        ,
        1,
        0,
        0,
        ,
        ,
        ,
        ,
        ,
        "",
        "0",
        "-0",
        "-",
        "",
        numberRound(),
        "∞",
        "NaN",
        {
            ".": ",",
            ",": "\xa0",
            "%": "%",
            "+": "+",
            "-": "−",
            E: "E",
            "‰": "‰"
        }
    ]);
    Globalize.b1525239776 = numberToPartsFormatterFn([
        "",
        ,
        2,
        0,
        0,
        ,
        ,
        ,
        ,
        ,
        "",
        "00",
        "-00",
        "-",
        "",
        numberRound(),
        "∞",
        "NaN",
        {
            ".": ",",
            ",": "\xa0",
            "%": "%",
            "+": "+",
            "-": "−",
            E: "E",
            "‰": "‰"
        }
    ]);
    Globalize.a1880912578 = numberToPartsFormatterFn([
        "",
        ,
        1,
        0,
        3,
        ,
        ,
        ,
        3,
        ,
        "",
        "#,##0.###",
        "-#,##0.###",
        "-",
        "",
        numberRound(),
        "∞",
        "NaN",
        {
            ".": ",",
            ",": "\xa0",
            "%": "%",
            "+": "+",
            "-": "−",
            E: "E",
            "‰": "‰"
        }
    ]);
    Globalize.b1779662230 = numberToPartsFormatterFn([
        "",
        ,
        1,
        0,
        0,
        ,
        ,
        ,
        ,
        ,
        "",
        "0",
        "-0",
        "-",
        "",
        numberRound(),
        "∞",
        "NaN",
        {
            ".": ",",
            ",": ".",
            "%": "%",
            "+": "+",
            "-": "-",
            E: "E",
            "‰": "‰"
        }
    ]);
    Globalize.a665376426 = numberToPartsFormatterFn([
        "",
        ,
        2,
        0,
        0,
        ,
        ,
        ,
        ,
        ,
        "",
        "00",
        "-00",
        "-",
        "",
        numberRound(),
        "∞",
        "NaN",
        {
            ".": ",",
            ",": ".",
            "%": "%",
            "+": "+",
            "-": "-",
            E: "E",
            "‰": "‰"
        }
    ]);
    Globalize.a1890147788 = numberToPartsFormatterFn([
        "",
        ,
        1,
        0,
        3,
        ,
        ,
        ,
        3,
        ,
        "",
        "#,##0.###",
        "-#,##0.###",
        "-",
        "",
        numberRound(),
        "∞",
        "NaN",
        {
            ".": ",",
            ",": ".",
            "%": "%",
            "+": "+",
            "-": "-",
            E: "E",
            "‰": "‰"
        }
    ]);
    Globalize.a1235441388 = numberToPartsFormatterFn([
        "",
        ,
        1,
        0,
        0,
        ,
        ,
        ,
        ,
        ,
        "",
        "0",
        "-0",
        "-",
        "",
        numberRound(),
        "∞",
        "NaN",
        {
            ".": ",",
            ",": "\xa0",
            "%": "%",
            "+": "+",
            "-": "-",
            E: "E",
            "‰": "‰"
        }
    ]);
    Globalize.b355691928 = numberToPartsFormatterFn([
        "",
        ,
        2,
        0,
        0,
        ,
        ,
        ,
        ,
        ,
        "",
        "00",
        "-00",
        "-",
        "",
        numberRound(),
        "∞",
        "NaN",
        {
            ".": ",",
            ",": "\xa0",
            "%": "%",
            "+": "+",
            "-": "-",
            E: "E",
            "‰": "‰"
        }
    ]);
    Globalize.a1947406090 = numberToPartsFormatterFn([
        "",
        ,
        1,
        0,
        3,
        ,
        ,
        ,
        3,
        ,
        "",
        "#,##0.###",
        "-#,##0.###",
        "-",
        "",
        numberRound(),
        "∞",
        "NaN",
        {
            ".": ",",
            ",": "\xa0",
            "%": "%",
            "+": "+",
            "-": "-",
            E: "E",
            "‰": "‰"
        }
    ]);
    Globalize.a1485939684 = numberToPartsFormatterFn([
        "",
        ,
        1,
        0,
        0,
        ,
        ,
        ,
        ,
        ,
        "",
        "0",
        "-0",
        "-",
        "",
        numberRound(),
        "∞",
        "NaN",
        {
            ".": ",",
            ",": ".",
            "%": "%",
            "+": "+",
            "-": "-",
            E: "E",
            "‰": "‰"
        }
    ]);
    Globalize.b1180179344 = numberToPartsFormatterFn([
        "",
        ,
        2,
        0,
        0,
        ,
        ,
        ,
        ,
        ,
        "",
        "00",
        "-00",
        "-",
        "",
        numberRound(),
        "∞",
        "NaN",
        {
            ".": ",",
            ",": ".",
            "%": "%",
            "+": "+",
            "-": "-",
            E: "E",
            "‰": "‰"
        }
    ]);
    Globalize.a1954794258 = numberToPartsFormatterFn([
        "",
        ,
        1,
        0,
        3,
        ,
        ,
        ,
        3,
        ,
        "",
        "#,##0.###",
        "-#,##0.###",
        "-",
        "",
        numberRound(),
        "∞",
        "NaN",
        {
            ".": ",",
            ",": ".",
            "%": "%",
            "+": "+",
            "-": "-",
            E: "E",
            "‰": "‰"
        }
    ]);
    Globalize.b296705673 = numberToPartsFormatterFn([
        "",
        ,
        1,
        0,
        0,
        ,
        ,
        ,
        ,
        ,
        "",
        "0",
        "-0",
        "-",
        "",
        numberRound(),
        "∞",
        "NaN",
        {
            ".": ",",
            ",": "\xa0",
            "%": "%",
            "+": "+",
            "-": "-",
            E: "E",
            "‰": "‰"
        }
    ]);
    Globalize.b607610563 = numberToPartsFormatterFn([
        "",
        ,
        2,
        0,
        0,
        ,
        ,
        ,
        ,
        ,
        "",
        "00",
        "-00",
        "-",
        "",
        numberRound(),
        "∞",
        "NaN",
        {
            ".": ",",
            ",": "\xa0",
            "%": "%",
            "+": "+",
            "-": "-",
            E: "E",
            "‰": "‰"
        }
    ]);
    Globalize.a669821983 = numberToPartsFormatterFn([
        "",
        ,
        1,
        0,
        3,
        ,
        ,
        ,
        3,
        ,
        "",
        "#,##0.###",
        "-#,##0.###",
        "-",
        "",
        numberRound(),
        "∞",
        "NaN",
        {
            ".": ",",
            ",": "\xa0",
            "%": "%",
            "+": "+",
            "-": "-",
            E: "E",
            "‰": "‰"
        }
    ]);
    Globalize.b1561098165 = numberToPartsFormatterFn([
        "",
        ,
        1,
        0,
        0,
        ,
        ,
        ,
        ,
        ,
        "",
        "0",
        "-0",
        "-",
        "",
        numberRound(),
        "∞",
        "NaN",
        {
            ".": ",",
            ",": ".",
            "%": "%",
            "+": "+",
            "-": "-",
            E: "E",
            "‰": "‰"
        }
    ]);
    Globalize.b1149072151 = numberToPartsFormatterFn([
        "",
        ,
        2,
        0,
        0,
        ,
        ,
        ,
        ,
        ,
        "",
        "00",
        "-00",
        "-",
        "",
        numberRound(),
        "∞",
        "NaN",
        {
            ".": ",",
            ",": ".",
            "%": "%",
            "+": "+",
            "-": "-",
            E: "E",
            "‰": "‰"
        }
    ]);
    Globalize.a2007434955 = numberToPartsFormatterFn([
        "",
        ,
        1,
        0,
        3,
        ,
        ,
        ,
        3,
        ,
        "",
        "#,##0.###",
        "-#,##0.###",
        "-",
        "",
        numberRound(),
        "∞",
        "NaN",
        {
            ".": ",",
            ",": ".",
            "%": "%",
            "+": "+",
            "-": "-",
            E: "E",
            "‰": "‰"
        }
    ]);
    Globalize.b299482619 = numberToPartsFormatterFn([
        "",
        ,
        1,
        0,
        0,
        ,
        ,
        ,
        ,
        ,
        "",
        "0",
        "-0",
        "-",
        "",
        numberRound(),
        "∞",
        "не\xa0число",
        {
            ".": ",",
            ",": "\xa0",
            "%": "%",
            "+": "+",
            "-": "-",
            E: "E",
            "‰": "‰"
        }
    ]);
    Globalize.b693695889 = numberToPartsFormatterFn([
        "",
        ,
        2,
        0,
        0,
        ,
        ,
        ,
        ,
        ,
        "",
        "00",
        "-00",
        "-",
        "",
        numberRound(),
        "∞",
        "не\xa0число",
        {
            ".": ",",
            ",": "\xa0",
            "%": "%",
            "+": "+",
            "-": "-",
            E: "E",
            "‰": "‰"
        }
    ]);
    Globalize.a2012976081 = numberToPartsFormatterFn([
        "",
        ,
        1,
        0,
        3,
        ,
        ,
        ,
        3,
        ,
        "",
        "#,##0.###",
        "-#,##0.###",
        "-",
        "",
        numberRound(),
        "∞",
        "не\xa0число",
        {
            ".": ",",
            ",": "\xa0",
            "%": "%",
            "+": "+",
            "-": "-",
            E: "E",
            "‰": "‰"
        }
    ]);
    Globalize.a1968688144 = numberToPartsFormatterFn([
        "",
        ,
        1,
        0,
        0,
        ,
        ,
        ,
        ,
        ,
        "",
        "0",
        "-0",
        "-",
        "",
        numberRound(),
        "∞",
        "NaN",
        {
            ".": ",",
            ",": "\xa0",
            "%": "%",
            "+": "+",
            "-": "-",
            E: "e",
            "‰": "‰"
        }
    ]);
    Globalize.a900121028 = numberToPartsFormatterFn([
        "",
        ,
        2,
        0,
        0,
        ,
        ,
        ,
        ,
        ,
        "",
        "00",
        "-00",
        "-",
        "",
        numberRound(),
        "∞",
        "NaN",
        {
            ".": ",",
            ",": "\xa0",
            "%": "%",
            "+": "+",
            "-": "-",
            E: "e",
            "‰": "‰"
        }
    ]);
    Globalize.a2032370022 = numberToPartsFormatterFn([
        "",
        ,
        1,
        0,
        3,
        ,
        ,
        ,
        3,
        ,
        "",
        "#,##0.###",
        "-#,##0.###",
        "-",
        "",
        numberRound(),
        "∞",
        "NaN",
        {
            ".": ",",
            ",": "\xa0",
            "%": "%",
            "+": "+",
            "-": "-",
            E: "e",
            "‰": "‰"
        }
    ]);
    Globalize.a1463129519 = numberToPartsFormatterFn([
        "",
        ,
        1,
        0,
        0,
        ,
        ,
        ,
        ,
        ,
        "",
        "0",
        "-0",
        "-",
        "",
        numberRound(),
        "∞",
        "NaN",
        {
            ".": ",",
            ",": ".",
            "%": "%",
            "+": "+",
            "-": "−",
            E: "e",
            "‰": "‰"
        }
    ]);
    Globalize.b1887294459 = numberToPartsFormatterFn([
        "",
        ,
        2,
        0,
        0,
        ,
        ,
        ,
        ,
        ,
        "",
        "00",
        "-00",
        "-",
        "",
        numberRound(),
        "∞",
        "NaN",
        {
            ".": ",",
            ",": ".",
            "%": "%",
            "+": "+",
            "-": "−",
            E: "e",
            "‰": "‰"
        }
    ]);
    Globalize.a2033293543 = numberToPartsFormatterFn([
        "",
        ,
        1,
        0,
        3,
        ,
        ,
        ,
        3,
        ,
        "",
        "#,##0.###",
        "-#,##0.###",
        "-",
        "",
        numberRound(),
        "∞",
        "NaN",
        {
            ".": ",",
            ",": ".",
            "%": "%",
            "+": "+",
            "-": "−",
            E: "e",
            "‰": "‰"
        }
    ]);
    Globalize.a1435181062 = numberToPartsFormatterFn([
        "",
        ,
        1,
        0,
        0,
        ,
        ,
        ,
        ,
        ,
        "",
        "0",
        "-0",
        "-",
        "",
        numberRound(),
        "∞",
        "NaN",
        {
            ".": ",",
            ",": ".",
            "%": "%",
            "+": "+",
            "-": "-",
            E: "E",
            "‰": "‰"
        }
    ]);
    Globalize.a1541270670 = numberToPartsFormatterFn([
        "",
        ,
        2,
        0,
        0,
        ,
        ,
        ,
        ,
        ,
        "",
        "00",
        "-00",
        "-",
        "",
        numberRound(),
        "∞",
        "NaN",
        {
            ".": ",",
            ",": ".",
            "%": "%",
            "+": "+",
            "-": "-",
            E: "E",
            "‰": "‰"
        }
    ]);
    Globalize.a985776304 = numberToPartsFormatterFn([
        "",
        ,
        1,
        0,
        3,
        ,
        ,
        ,
        3,
        ,
        "",
        "#,##0.###",
        "-#,##0.###",
        "-",
        "",
        numberRound(),
        "∞",
        "NaN",
        {
            ".": ",",
            ",": ".",
            "%": "%",
            "+": "+",
            "-": "-",
            E: "E",
            "‰": "‰"
        }
    ]);
    Globalize.a2101971175 = numberToPartsFormatterFn([
        "",
        ,
        1,
        0,
        0,
        ,
        ,
        ,
        ,
        ,
        "",
        "0",
        "-0",
        "-",
        "",
        numberRound(),
        "∞",
        "NaN",
        {
            ".": ",",
            ",": ".",
            "%": "%",
            "+": "+",
            "-": "-",
            E: "E",
            "‰": "‰"
        }
    ]);
    Globalize.a736927693 = numberToPartsFormatterFn([
        "",
        ,
        2,
        0,
        0,
        ,
        ,
        ,
        ,
        ,
        "",
        "00",
        "-00",
        "-",
        "",
        numberRound(),
        "∞",
        "NaN",
        {
            ".": ",",
            ",": ".",
            "%": "%",
            "+": "+",
            "-": "-",
            E: "E",
            "‰": "‰"
        }
    ]);
    Globalize.b274946385 = numberToPartsFormatterFn([
        "",
        ,
        1,
        0,
        3,
        ,
        ,
        ,
        3,
        ,
        "",
        "#,##0.###",
        "-#,##0.###",
        "-",
        "",
        numberRound(),
        "∞",
        "NaN",
        {
            ".": ",",
            ",": ".",
            "%": "%",
            "+": "+",
            "-": "-",
            E: "E",
            "‰": "‰"
        }
    ]);
    Globalize.a702510565 = numberToPartsFormatterFn([
        "",
        ,
        1,
        0,
        0,
        ,
        ,
        ,
        ,
        ,
        "",
        "0",
        "-0",
        "-",
        "",
        numberRound(),
        "∞",
        "NaN",
        {
            ".": ",",
            ",": "\xa0",
            "%": "%",
            "+": "+",
            "-": "−",
            E: "\xd710^",
            "‰": "‰"
        }
    ]);
    Globalize.a303321743 = numberToPartsFormatterFn([
        "",
        ,
        2,
        0,
        0,
        ,
        ,
        ,
        ,
        ,
        "",
        "00",
        "-00",
        "-",
        "",
        numberRound(),
        "∞",
        "NaN",
        {
            ".": ",",
            ",": "\xa0",
            "%": "%",
            "+": "+",
            "-": "−",
            E: "\xd710^",
            "‰": "‰"
        }
    ]);
    Globalize.a2042528753 = numberToPartsFormatterFn([
        "",
        ,
        1,
        0,
        3,
        ,
        ,
        ,
        3,
        ,
        "",
        "#,##0.###",
        "-#,##0.###",
        "-",
        "",
        numberRound(),
        "∞",
        "NaN",
        {
            ".": ",",
            ",": "\xa0",
            "%": "%",
            "+": "+",
            "-": "−",
            E: "\xd710^",
            "‰": "‰"
        }
    ]);
    Globalize.a697948532 = numberToPartsFormatterFn([
        "",
        ,
        1,
        0,
        0,
        ,
        ,
        ,
        ,
        ,
        "",
        "0",
        "-0",
        "-",
        "",
        numberRound(),
        "∞",
        "NaN",
        {
            ".": ".",
            ",": ",",
            "%": "%",
            "+": "+",
            "-": "-",
            E: "E",
            "‰": "‰"
        }
    ]);
    Globalize.a161898720 = numberToPartsFormatterFn([
        "",
        ,
        2,
        0,
        0,
        ,
        ,
        ,
        ,
        ,
        "",
        "00",
        "-00",
        "-",
        "",
        numberRound(),
        "∞",
        "NaN",
        {
            ".": ".",
            ",": ",",
            "%": "%",
            "+": "+",
            "-": "-",
            E: "E",
            "‰": "‰"
        }
    ]);
    Globalize.a2058228610 = numberToPartsFormatterFn([
        "",
        ,
        1,
        0,
        3,
        ,
        ,
        ,
        3,
        ,
        "",
        "#,##0.###",
        "-#,##0.###",
        "-",
        "",
        numberRound(),
        "∞",
        "NaN",
        {
            ".": ".",
            ",": ",",
            "%": "%",
            "+": "+",
            "-": "-",
            E: "E",
            "‰": "‰"
        }
    ]);
    Globalize.b62670422 = numberToPartsFormatterFn([
        "",
        ,
        1,
        0,
        0,
        ,
        ,
        ,
        ,
        ,
        "",
        "0",
        "-0",
        "-",
        "",
        numberRound(),
        "∞",
        "NaN",
        {
            ".": ",",
            ",": ".",
            "%": "%",
            "+": "+",
            "-": "-",
            E: "E",
            "‰": "‰"
        }
    ]);
    Globalize.b1942452374 = numberToPartsFormatterFn([
        "",
        ,
        2,
        0,
        0,
        ,
        ,
        ,
        ,
        ,
        "",
        "00",
        "-00",
        "-",
        "",
        numberRound(),
        "∞",
        "NaN",
        {
            ".": ",",
            ",": ".",
            "%": "%",
            "+": "+",
            "-": "-",
            E: "E",
            "‰": "‰"
        }
    ]);
    Globalize.a2067463820 = numberToPartsFormatterFn([
        "",
        ,
        1,
        0,
        3,
        ,
        ,
        ,
        3,
        ,
        "",
        "#,##0.###",
        "-#,##0.###",
        "-",
        "",
        numberRound(),
        "∞",
        "NaN",
        {
            ".": ",",
            ",": ".",
            "%": "%",
            "+": "+",
            "-": "-",
            E: "E",
            "‰": "‰"
        }
    ]);
    Globalize.a688824466 = numberToPartsFormatterFn([
        "",
        ,
        1,
        0,
        0,
        ,
        ,
        ,
        ,
        ,
        "",
        "0",
        "-0",
        "-",
        "",
        numberRound(),
        "∞",
        "NaN",
        {
            ".": ",",
            ",": "\xa0",
            "%": "%",
            "+": "+",
            "-": "-",
            E: "Е",
            "‰": "‰"
        }
    ]);
    Globalize.b120947326 = numberToPartsFormatterFn([
        "",
        ,
        2,
        0,
        0,
        ,
        ,
        ,
        ,
        ,
        "",
        "00",
        "-00",
        "-",
        "",
        numberRound(),
        "∞",
        "NaN",
        {
            ".": ",",
            ",": "\xa0",
            "%": "%",
            "+": "+",
            "-": "-",
            E: "Е",
            "‰": "‰"
        }
    ]);
    Globalize.a2089628324 = numberToPartsFormatterFn([
        "",
        ,
        1,
        0,
        3,
        ,
        ,
        ,
        3,
        ,
        "",
        "#,##0.###",
        "-#,##0.###",
        "-",
        "",
        numberRound(),
        "∞",
        "NaN",
        {
            ".": ",",
            ",": "\xa0",
            "%": "%",
            "+": "+",
            "-": "-",
            E: "Е",
            "‰": "‰"
        }
    ]);
    Globalize.b1087473771 = numberToPartsFormatterFn([
        "",
        ,
        1,
        0,
        0,
        ,
        ,
        ,
        ,
        ,
        "",
        "0",
        "-0",
        "-",
        "",
        numberRound(),
        "∞",
        "NaN",
        {
            ".": ",",
            ",": ".",
            "%": "%",
            "+": "+",
            "-": "-",
            E: "E",
            "‰": "‰"
        }
    ]);
    Globalize.a648382175 = numberToPartsFormatterFn([
        "",
        ,
        2,
        0,
        0,
        ,
        ,
        ,
        ,
        ,
        "",
        "00",
        "-00",
        "-",
        "",
        numberRound(),
        "∞",
        "NaN",
        {
            ".": ",",
            ",": ".",
            "%": "%",
            "+": "+",
            "-": "-",
            E: "E",
            "‰": "‰"
        }
    ]);
    Globalize.a2116410433 = numberToPartsFormatterFn([
        "",
        ,
        1,
        0,
        3,
        ,
        ,
        ,
        3,
        ,
        "",
        "#,##0.###",
        "-#,##0.###",
        "-",
        "",
        numberRound(),
        "∞",
        "NaN",
        {
            ".": ",",
            ",": ".",
            "%": "%",
            "+": "+",
            "-": "-",
            E: "E",
            "‰": "‰"
        }
    ]);
    Globalize.a1418994715 = numberToPartsFormatterFn([
        "",
        ,
        1,
        0,
        0,
        ,
        ,
        ,
        ,
        ,
        "",
        "0",
        "-0",
        "-",
        "",
        numberRound(),
        "∞",
        "非數值",
        {
            ".": ".",
            ",": ",",
            "%": "%",
            "+": "+",
            "-": "-",
            E: "E",
            "‰": "‰"
        }
    ]);
    Globalize.a1039493913 = numberToPartsFormatterFn([
        "",
        ,
        2,
        0,
        0,
        ,
        ,
        ,
        ,
        ,
        "",
        "00",
        "-00",
        "-",
        "",
        numberRound(),
        "∞",
        "非數值",
        {
            ".": ".",
            ",": ",",
            "%": "%",
            "+": "+",
            "-": "-",
            E: "E",
            "‰": "‰"
        }
    ]);
    Globalize.b96411397 = numberToPartsFormatterFn([
        "",
        ,
        1,
        0,
        3,
        ,
        ,
        ,
        3,
        ,
        "",
        "#,##0.###",
        "-#,##0.###",
        "-",
        "",
        numberRound(),
        "∞",
        "非數值",
        {
            ".": ".",
            ",": ",",
            "%": "%",
            "+": "+",
            "-": "-",
            E: "E",
            "‰": "‰"
        }
    ]);
    Globalize.b711487865 = numberToPartsFormatterFn([
        "",
        ,
        1,
        0,
        0,
        ,
        ,
        ,
        ,
        ,
        "",
        "0",
        "-0",
        "-",
        "",
        numberRound(),
        "∞",
        "NaN",
        {
            ".": ".",
            ",": ",",
            "%": "%",
            "+": "+",
            "-": "-",
            E: "E",
            "‰": "‰"
        }
    ]);
    Globalize.b580956627 = numberToPartsFormatterFn([
        "",
        ,
        2,
        0,
        0,
        ,
        ,
        ,
        ,
        ,
        "",
        "00",
        "-00",
        "-",
        "",
        numberRound(),
        "∞",
        "NaN",
        {
            ".": ".",
            ",": ",",
            "%": "%",
            "+": "+",
            "-": "-",
            E: "E",
            "‰": "‰"
        }
    ]);
    Globalize.b847000305 = numberToPartsFormatterFn([
        "",
        ,
        1,
        0,
        3,
        ,
        ,
        ,
        3,
        ,
        "",
        "#,##0.###",
        "-#,##0.###",
        "-",
        "",
        numberRound(),
        "∞",
        "NaN",
        {
            ".": ".",
            ",": ",",
            "%": "%",
            "+": "+",
            "-": "-",
            E: "E",
            "‰": "‰"
        }
    ]);
    Globalize.b1759276636 = numberToPartsFormatterFn([
        "",
        ,
        1,
        0,
        0,
        ,
        ,
        ,
        ,
        ,
        "",
        "0",
        "-0",
        "-",
        "",
        numberRound(),
        "∞",
        "NaN",
        {
            ".": ".",
            ",": ",",
            "%": "%",
            "+": "+",
            "-": "-",
            E: "E",
            "‰": "‰"
        }
    ]);
    Globalize.a1297329840 = numberToPartsFormatterFn([
        "",
        ,
        2,
        0,
        0,
        ,
        ,
        ,
        ,
        ,
        "",
        "00",
        "-00",
        "-",
        "",
        numberRound(),
        "∞",
        "NaN",
        {
            ".": ".",
            ",": ",",
            "%": "%",
            "+": "+",
            "-": "-",
            E: "E",
            "‰": "‰"
        }
    ]);
    Globalize.a876307794 = numberToPartsFormatterFn([
        "",
        ,
        1,
        0,
        3,
        ,
        ,
        ,
        3,
        ,
        "",
        "#,##0.###",
        "-#,##0.###",
        "-",
        "",
        numberRound(),
        "∞",
        "NaN",
        {
            ".": ".",
            ",": ",",
            "%": "%",
            "+": "+",
            "-": "-",
            E: "E",
            "‰": "‰"
        }
    ]);
    Globalize.b1217046490 = numberToPartsFormatterFn([
        "",
        ,
        1,
        0,
        0,
        ,
        ,
        ,
        ,
        ,
        "",
        "0",
        "-0",
        "-",
        "",
        numberRound(),
        "∞",
        "非數值",
        {
            ".": ".",
            ",": ",",
            "%": "%",
            "+": "+",
            "-": "-",
            E: "E",
            "‰": "‰"
        }
    ]);
    Globalize.a926595182 = numberToPartsFormatterFn([
        "",
        ,
        2,
        0,
        0,
        ,
        ,
        ,
        ,
        ,
        "",
        "00",
        "-00",
        "-",
        "",
        numberRound(),
        "∞",
        "非數值",
        {
            ".": ".",
            ",": ",",
            "%": "%",
            "+": "+",
            "-": "-",
            E: "E",
            "‰": "‰"
        }
    ]);
    Globalize.b846076784 = numberToPartsFormatterFn([
        "",
        ,
        1,
        0,
        3,
        ,
        ,
        ,
        3,
        ,
        "",
        "#,##0.###",
        "-#,##0.###",
        "-",
        "",
        numberRound(),
        "∞",
        "非數值",
        {
            ".": ".",
            ",": ",",
            "%": "%",
            "+": "+",
            "-": "-",
            E: "E",
            "‰": "‰"
        }
    ]);
    Globalize.b1831402154 = numberToPartsFormatterFn([
        "",
        ,
        1,
        0,
        0,
        ,
        ,
        ,
        ,
        ,
        "",
        "0",
        "-0",
        "-",
        "",
        numberRound(),
        "∞",
        "非數值",
        {
            ".": ".",
            ",": ",",
            "%": "%",
            "+": "+",
            "-": "-",
            E: "E",
            "‰": "‰"
        }
    ]);
    Globalize.b938561218 = numberToPartsFormatterFn([
        "",
        ,
        2,
        0,
        0,
        ,
        ,
        ,
        ,
        ,
        "",
        "00",
        "-00",
        "-",
        "",
        numberRound(),
        "∞",
        "非數值",
        {
            ".": ".",
            ",": ",",
            "%": "%",
            "+": "+",
            "-": "-",
            E: "E",
            "‰": "‰"
        }
    ]);
    Globalize.b1987075744 = numberToPartsFormatterFn([
        "",
        ,
        1,
        0,
        3,
        ,
        ,
        ,
        3,
        ,
        "",
        "#,##0.###",
        "-#,##0.###",
        "-",
        "",
        numberRound(),
        "∞",
        "非數值",
        {
            ".": ".",
            ",": ",",
            "%": "%",
            "+": "+",
            "-": "-",
            E: "E",
            "‰": "‰"
        }
    ]);
    Globalize.b610844905 = numberToPartsFormatterFn([
        "",
        ,
        1,
        0,
        0,
        ,
        ,
        ,
        ,
        ,
        "",
        "0",
        "-0",
        "-",
        "",
        numberRound(),
        "∞",
        "非數值",
        {
            ".": ".",
            ",": ",",
            "%": "%",
            "+": "+",
            "-": "-",
            E: "E",
            "‰": "‰"
        }
    ]);
    Globalize.b1755992163 = numberToPartsFormatterFn([
        "",
        ,
        2,
        0,
        0,
        ,
        ,
        ,
        ,
        ,
        "",
        "00",
        "-00",
        "-",
        "",
        numberRound(),
        "∞",
        "非數值",
        {
            ".": ".",
            ",": ",",
            "%": "%",
            "+": "+",
            "-": "-",
            E: "E",
            "‰": "‰"
        }
    ]);
    Globalize.b1840235905 = numberToPartsFormatterFn([
        "",
        ,
        1,
        0,
        3,
        ,
        ,
        ,
        3,
        ,
        "",
        "#,##0.###",
        "-#,##0.###",
        "-",
        "",
        numberRound(),
        "∞",
        "非數值",
        {
            ".": ".",
            ",": ",",
            "%": "%",
            "+": "+",
            "-": "-",
            E: "E",
            "‰": "‰"
        }
    ]);
    Globalize.a1038316025 = numberFormatterFn(Globalize("ar-EG").numberToPartsFormatter({
        raw: "0"
    }));
    Globalize.a2123356411 = numberFormatterFn(Globalize("ar-EG").numberToPartsFormatter({
        raw: "00"
    }));
    Globalize.b1798381219 = numberFormatterFn(Globalize("ar-EG").numberToPartsFormatter({}));
    Globalize.b592410675 = numberFormatterFn(Globalize("ar-SA").numberToPartsFormatter({
        raw: "0"
    }));
    Globalize.b1184531033 = numberFormatterFn(Globalize("ar-SA").numberToPartsFormatter({
        raw: "00"
    }));
    Globalize.b1403114231 = numberFormatterFn(Globalize("ar-SA").numberToPartsFormatter({}));
    Globalize.a395141616 = numberFormatterFn(Globalize("bg").numberToPartsFormatter({
        raw: "0"
    }));
    Globalize.b635181084 = numberFormatterFn(Globalize("bg").numberToPartsFormatter({
        raw: "00"
    }));
    Globalize.b560738426 = numberFormatterFn(Globalize("bg").numberToPartsFormatter({}));
    Globalize.a641077879 = numberFormatterFn(Globalize("ca").numberToPartsFormatter({
        raw: "0"
    }));
    Globalize.b1601091523 = numberFormatterFn(Globalize("ca").numberToPartsFormatter({
        raw: "00"
    }));
    Globalize.b537650401 = numberFormatterFn(Globalize("ca").numberToPartsFormatter({}));
    Globalize.a130957221 = numberFormatterFn(Globalize("cs").numberToPartsFormatter({
        raw: "0"
    }));
    Globalize.b234962737 = numberFormatterFn(Globalize("cs").numberToPartsFormatter({
        raw: "00"
    }));
    Globalize.b521027023 = numberFormatterFn(Globalize("cs").numberToPartsFormatter({}));
    Globalize.b2146337608 = numberFormatterFn(Globalize("da").numberToPartsFormatter({
        raw: "0"
    }));
    Globalize.b2111625700 = numberFormatterFn(Globalize("da").numberToPartsFormatter({
        raw: "00"
    }));
    Globalize.b509021250 = numberFormatterFn(Globalize("da").numberToPartsFormatter({}));
    Globalize.a126395188 = numberFormatterFn(Globalize("de").numberToPartsFormatter({
        raw: "0"
    }));
    Globalize.b376385760 = numberFormatterFn(Globalize("de").numberToPartsFormatter({
        raw: "00"
    }));
    Globalize.b505327166 = numberFormatterFn(Globalize("de").numberToPartsFormatter({}));
    Globalize.b1904963378 = numberFormatterFn(Globalize("el").numberToPartsFormatter({
        raw: "0"
    }));
    Globalize.a1076008134 = numberFormatterFn(Globalize("el").numberToPartsFormatter({
        raw: "00"
    }));
    Globalize.b470233368 = numberFormatterFn(Globalize("el").numberToPartsFormatter({}));
    Globalize.a1378886668 = numberFormatterFn(Globalize("en").numberToPartsFormatter({
        raw: "0"
    }));
    Globalize.b203855544 = numberFormatterFn(Globalize("en").numberToPartsFormatter({
        raw: "00"
    }));
    Globalize.b468386326 = numberFormatterFn(Globalize("en").numberToPartsFormatter({}));
    Globalize.b1148906457 = numberFormatterFn(Globalize("es").numberToPartsFormatter({
        raw: "0"
    }));
    Globalize.b1256031091 = numberFormatterFn(Globalize("es").numberToPartsFormatter({
        raw: "00"
    }));
    Globalize.b463768721 = numberFormatterFn(Globalize("es").numberToPartsFormatter({}));
    Globalize.b1654465082 = numberFormatterFn(Globalize("et").numberToPartsFormatter({
        raw: "0"
    }));
    Globalize.a251520718 = numberFormatterFn(Globalize("et").numberToPartsFormatter({
        raw: "00"
    }));
    Globalize.b462845200 = numberFormatterFn(Globalize("et").numberToPartsFormatter({}));
    Globalize.a2134943589 = numberFormatterFn(Globalize("eu").numberToPartsFormatter({
        raw: "0"
    }));
    Globalize.a1759072527 = numberFormatterFn(Globalize("eu").numberToPartsFormatter({
        raw: "00"
    }));
    Globalize.b461921679 = numberFormatterFn(Globalize("eu").numberToPartsFormatter({}));
    Globalize.a1119264306 = numberFormatterFn(Globalize("fi").numberToPartsFormatter({
        raw: "0"
    }));
    Globalize.a337785826 = numberFormatterFn(Globalize("fi").numberToPartsFormatter({
        raw: "00"
    }));
    Globalize.b444374780 = numberFormatterFn(Globalize("fi").numberToPartsFormatter({}));
    Globalize.a864203977 = numberFormatterFn(Globalize("fr").numberToPartsFormatter({
        raw: "0"
    }));
    Globalize.a1020850219 = numberFormatterFn(Globalize("fr").numberToPartsFormatter({
        raw: "00"
    }));
    Globalize.b436063091 = numberFormatterFn(Globalize("fr").numberToPartsFormatter({}));
    Globalize.a1110140240 = numberFormatterFn(Globalize("gl").numberToPartsFormatter({
        raw: "0"
    }));
    Globalize.a54939780 = numberFormatterFn(Globalize("gl").numberToPartsFormatter({
        raw: "00"
    }));
    Globalize.b412975066 = numberFormatterFn(Globalize("gl").numberToPartsFormatter({}));
    Globalize.a1861635128 = numberFormatterFn(Globalize("he").numberToPartsFormatter({
        raw: "0"
    }));
    Globalize.a1876444828 = numberFormatterFn(Globalize("he").numberToPartsFormatter({
        raw: "00"
    }));
    Globalize.b390810562 = numberFormatterFn(Globalize("he").numberToPartsFormatter({}));
    Globalize.b160599372 = numberFormatterFn(Globalize("hi").numberToPartsFormatter({
        raw: "0"
    }));
    Globalize.b683282528 = numberFormatterFn(Globalize("hi").numberToPartsFormatter({
        raw: "00"
    }));
    Globalize.b387116478 = numberFormatterFn(Globalize("hi").numberToPartsFormatter({}));
    Globalize.b415659701 = numberFormatterFn(Globalize("hr").numberToPartsFormatter({
        raw: "0"
    }));
    Globalize.b218135 = numberFormatterFn(Globalize("hr").numberToPartsFormatter({
        raw: "00"
    }));
    Globalize.b378804789 = numberFormatterFn(Globalize("hr").numberToPartsFormatter({}));
    Globalize.b1932335576 = numberFormatterFn(Globalize("hu").numberToPartsFormatter({
        raw: "0"
    }));
    Globalize.a227469996 = numberFormatterFn(Globalize("hu").numberToPartsFormatter({
        raw: "00"
    }));
    Globalize.b376034226 = numberFormatterFn(Globalize("hu").numberToPartsFormatter({}));
    Globalize.b420221734 = numberFormatterFn(Globalize("id").numberToPartsFormatter({
        raw: "0"
    }));
    Globalize.b141641158 = numberFormatterFn(Globalize("id").numberToPartsFormatter({
        raw: "00"
    }));
    Globalize.b363104932 = numberFormatterFn(Globalize("id").numberToPartsFormatter({}));
    Globalize.a80774858 = numberFormatterFn(Globalize("it").numberToPartsFormatter({
        raw: "0"
    }));
    Globalize.b1790615990 = numberFormatterFn(Globalize("it").numberToPartsFormatter({
        raw: "00"
    }));
    Globalize.b348328596 = numberFormatterFn(Globalize("it").numberToPartsFormatter({}));
    Globalize.b1690961346 = numberFormatterFn(Globalize("ja").numberToPartsFormatter({
        raw: "0"
    }));
    Globalize.b879863466 = numberFormatterFn(Globalize("ja").numberToPartsFormatter({
        raw: "00"
    }));
    Globalize.b337246344 = numberFormatterFn(Globalize("ja").numberToPartsFormatter({}));
    Globalize.b944028491 = numberFormatterFn(Globalize("kk").numberToPartsFormatter({
        raw: "0"
    }));
    Globalize.a800218559 = numberFormatterFn(Globalize("kk").numberToPartsFormatter({
        raw: "00"
    }));
    Globalize.b299381983 = numberFormatterFn(Globalize("kk").numberToPartsFormatter({}));
    Globalize.a1328704305 = numberFormatterFn(Globalize("ko").numberToPartsFormatter({
        raw: "0"
    }));
    Globalize.b1759508797 = numberFormatterFn(Globalize("ko").numberToPartsFormatter({
        raw: "00"
    }));
    Globalize.b295687899 = numberFormatterFn(Globalize("ko").numberToPartsFormatter({}));
    Globalize.a308462989 = numberFormatterFn(Globalize("lt").numberToPartsFormatter({
        raw: "0"
    }));
    Globalize.a972748775 = numberFormatterFn(Globalize("lt").numberToPartsFormatter({
        raw: "00"
    }));
    Globalize.b262441143 = numberFormatterFn(Globalize("lt").numberToPartsFormatter({}));
    Globalize.b702654261 = numberFormatterFn(Globalize("lv").numberToPartsFormatter({
        raw: "0"
    }));
    Globalize.b307114903 = numberFormatterFn(Globalize("lv").numberToPartsFormatter({
        raw: "00"
    }));
    Globalize.b260594101 = numberFormatterFn(Globalize("lv").numberToPartsFormatter({}));
    Globalize.b1973393873 = numberFormatterFn(Globalize("ms").numberToPartsFormatter({
        raw: "0"
    }));
    Globalize.b1045337211 = numberFormatterFn(Globalize("ms").numberToPartsFormatter({
        raw: "00"
    }));
    Globalize.b234735513 = numberFormatterFn(Globalize("ms").numberToPartsFormatter({}));
    Globalize.b461280031 = numberFormatterFn(Globalize("nb").numberToPartsFormatter({
        raw: "0"
    }));
    Globalize.b1414448365 = numberFormatterFn(Globalize("nb").numberToPartsFormatter({
        raw: "00"
    }));
    Globalize.b221806219 = numberFormatterFn(Globalize("nb").numberToPartsFormatter({}));
    Globalize.b1221898985 = numberFormatterFn(Globalize("nl").numberToPartsFormatter({
        raw: "0"
    }));
    Globalize.a776167837 = numberFormatterFn(Globalize("nl").numberToPartsFormatter({
        raw: "00"
    }));
    Globalize.b212571009 = numberFormatterFn(Globalize("nl").numberToPartsFormatter({}));
    Globalize.a1793204633 = numberFormatterFn(Globalize("pl").numberToPartsFormatter({
        raw: "0"
    }));
    Globalize.b244900517 = numberFormatterFn(Globalize("pl").numberToPartsFormatter({
        raw: "00"
    }));
    Globalize.b155312707 = numberFormatterFn(Globalize("pl").numberToPartsFormatter({}));
    Globalize.a2043702929 = numberFormatterFn(Globalize("pt").numberToPartsFormatter({
        raw: "0"
    }));
    Globalize.b1069387933 = numberFormatterFn(Globalize("pt").numberToPartsFormatter({
        raw: "00"
    }));
    Globalize.b147924539 = numberFormatterFn(Globalize("pt").numberToPartsFormatter({}));
    Globalize.b1200342102 = numberFormatterFn(Globalize("pt-PT").numberToPartsFormatter({
        raw: "0"
    }));
    Globalize.a1444431210 = numberFormatterFn(Globalize("pt-PT").numberToPartsFormatter({
        raw: "00"
    }));
    Globalize.a672152716 = numberFormatterFn(Globalize("pt-PT").numberToPartsFormatter({}));
    Globalize.b1003334920 = numberFormatterFn(Globalize("ro").numberToPartsFormatter({
        raw: "0"
    }));
    Globalize.b1038280740 = numberFormatterFn(Globalize("ro").numberToPartsFormatter({
        raw: "00"
    }));
    Globalize.b95283842 = numberFormatterFn(Globalize("ro").numberToPartsFormatter({}));
    Globalize.a258280626 = numberFormatterFn(Globalize("ru").numberToPartsFormatter({
        raw: "0"
    }));
    Globalize.b582904478 = numberFormatterFn(Globalize("ru").numberToPartsFormatter({
        raw: "00"
    }));
    Globalize.b89742716 = numberFormatterFn(Globalize("ru").numberToPartsFormatter({}));
    Globalize.b1768515907 = numberFormatterFn(Globalize("sk").numberToPartsFormatter({
        raw: "0"
    }));
    Globalize.a1010912439 = numberFormatterFn(Globalize("sk").numberToPartsFormatter({
        raw: "00"
    }));
    Globalize.b70348775 = numberFormatterFn(Globalize("sk").numberToPartsFormatter({}));
    Globalize.a2020892764 = numberFormatterFn(Globalize("sl").numberToPartsFormatter({
        raw: "0"
    }));
    Globalize.b1776503048 = numberFormatterFn(Globalize("sl").numberToPartsFormatter({
        raw: "00"
    }));
    Globalize.b69425254 = numberFormatterFn(Globalize("sl").numberToPartsFormatter({}));
    Globalize.a623966585 = numberFormatterFn(Globalize("sr-Cyrl").numberToPartsFormatter({
        raw: "0"
    }));
    Globalize.b2131541637 = numberFormatterFn(Globalize("sr-Cyrl").numberToPartsFormatter({
        raw: "00"
    }));
    Globalize.b1069356579 = numberFormatterFn(Globalize("sr-Cyrl").numberToPartsFormatter({}));
    Globalize.a1290756698 = numberFormatterFn(Globalize("sr-Latn").numberToPartsFormatter({
        raw: "0"
    }));
    Globalize.a1359082682 = numberFormatterFn(Globalize("sr-Latn").numberToPartsFormatter({
        raw: "00"
    }));
    Globalize.a1964888028 = numberFormatterFn(Globalize("sr-Latn").numberToPartsFormatter({}));
    Globalize.a1260273810 = numberFormatterFn(Globalize("sv").numberToPartsFormatter({
        raw: "0"
    }));
    Globalize.a414113154 = numberFormatterFn(Globalize("sv").numberToPartsFormatter({
        raw: "00"
    }));
    Globalize.b60190044 = numberFormatterFn(Globalize("sv").numberToPartsFormatter({}));
    Globalize.a1255711777 = numberFormatterFn(Globalize("th").numberToPartsFormatter({
        raw: "0"
    }));
    Globalize.a272690131 = numberFormatterFn(Globalize("th").numberToPartsFormatter({
        raw: "00"
    }));
    Globalize.b44490187 = numberFormatterFn(Globalize("th").numberToPartsFormatter({}));
    Globalize.a495092823 = numberFormatterFn(Globalize("tr").numberToPartsFormatter({
        raw: "0"
    }));
    Globalize.b1831660963 = numberFormatterFn(Globalize("tr").numberToPartsFormatter({
        raw: "00"
    }));
    Globalize.b35254977 = numberFormatterFn(Globalize("tr").numberToPartsFormatter({}));
    Globalize.a1246587711 = numberFormatterFn(Globalize("uk").numberToPartsFormatter({
        raw: "0"
    }));
    Globalize.b10155915 = numberFormatterFn(Globalize("uk").numberToPartsFormatter({
        raw: "00"
    }));
    Globalize.b13090473 = numberFormatterFn(Globalize("uk").numberToPartsFormatter({}));
    Globalize.b529710526 = numberFormatterFn(Globalize("vi").numberToPartsFormatter({
        raw: "0"
    }));
    Globalize.a759173586 = numberFormatterFn(Globalize("vi").numberToPartsFormatter({
        raw: "00"
    }));
    Globalize.a13691636 = numberFormatterFn(Globalize("vi").numberToPartsFormatter({}));
    Globalize.a1529786126 = numberFormatterFn(Globalize("yue").numberToPartsFormatter({
        raw: "0"
    }));
    Globalize.a179060358 = numberFormatterFn(Globalize("yue").numberToPartsFormatter({
        raw: "00"
    }));
    Globalize.b856184664 = numberFormatterFn(Globalize("yue").numberToPartsFormatter({}));
    Globalize.b1522702342 = numberFormatterFn(Globalize("zh-Hans").numberToPartsFormatter({
        raw: "0"
    }));
    Globalize.a41198362 = numberFormatterFn(Globalize("zh-Hans").numberToPartsFormatter({
        raw: "00"
    }));
    Globalize.a1392834108 = numberFormatterFn(Globalize("zh-Hans").numberToPartsFormatter({}));
    Globalize.b868786351 = numberFormatterFn(Globalize("zh-Hans-SG").numberToPartsFormatter({
        raw: "0"
    }));
    Globalize.b1162242397 = numberFormatterFn(Globalize("zh-Hans-SG").numberToPartsFormatter({
        raw: "00"
    }));
    Globalize.a1171394821 = numberFormatterFn(Globalize("zh-Hans-SG").numberToPartsFormatter({}));
    Globalize.b2028260967 = numberFormatterFn(Globalize("zh-Hant").numberToPartsFormatter({
        raw: "0"
    }));
    Globalize.a1548750171 = numberFormatterFn(Globalize("zh-Hant").numberToPartsFormatter({
        raw: "00"
    }));
    Globalize.a1393757629 = numberFormatterFn(Globalize("zh-Hant").numberToPartsFormatter({}));
    Globalize.b940911869 = numberFormatterFn(Globalize("zh-Hant-HK").numberToPartsFormatter({
        raw: "0"
    }));
    Globalize.a896833841 = numberFormatterFn(Globalize("zh-Hant-HK").numberToPartsFormatter({
        raw: "00"
    }));
    Globalize.b1691988717 = numberFormatterFn(Globalize("zh-Hant-HK").numberToPartsFormatter({}));
    Globalize.a279645380 = numberFormatterFn(Globalize("zh-Hant-MO").numberToPartsFormatter({
        raw: "0"
    }));
    Globalize.a79402896 = numberFormatterFn(Globalize("zh-Hant-MO").numberToPartsFormatter({
        raw: "00"
    }));
    Globalize.b1545148878 = numberFormatterFn(Globalize("zh-Hant-MO").numberToPartsFormatter({}));
    Globalize.b469273361 = pluralGeneratorFn(function(n) {
        var s = String(n).split("."), t0 = Number(s[0]) == n, n100 = t0 && s[0].slice(-2);
        return n == 0 ? "zero" : n == 1 ? "one" : n == 2 ? "two" : n100 >= 3 && n100 <= 10 ? "few" : n100 >= 11 && n100 <= 99 ? "many" : "other";
    });
    Globalize.b74006373 = pluralGeneratorFn(function(n) {
        var s = String(n).split("."), t0 = Number(s[0]) == n, n100 = t0 && s[0].slice(-2);
        return n == 0 ? "zero" : n == 1 ? "one" : n == 2 ? "two" : n100 >= 3 && n100 <= 10 ? "few" : n100 >= 11 && n100 <= 99 ? "many" : "other";
    });
    Globalize.a1569994036 = pluralGeneratorFn(function(n) {
        return n == 1 ? "one" : "other";
    });
    Globalize.a1593082061 = pluralGeneratorFn(function(n) {
        var s = String(n).split("."), v0 = !s[1];
        return n == 1 && v0 ? "one" : "other";
    });
    Globalize.a1609705439 = pluralGeneratorFn(function(n) {
        var s = String(n).split("."), i = s[0], v0 = !s[1];
        return n == 1 && v0 ? "one" : i >= 2 && i <= 4 && v0 ? "few" : !v0 ? "many" : "other";
    });
    Globalize.a1621711212 = pluralGeneratorFn(function(n) {
        var s = String(n).split("."), i = s[0], t0 = Number(s[0]) == n;
        return n == 1 || !t0 && (i == 0 || i == 1) ? "one" : "other";
    });
    Globalize.a1625405296 = pluralGeneratorFn(function(n) {
        var s = String(n).split("."), v0 = !s[1];
        return n == 1 && v0 ? "one" : "other";
    });
    Globalize.a1660499094 = pluralGeneratorFn(function(n) {
        return n == 1 ? "one" : "other";
    });
    Globalize.a1662346136 = pluralGeneratorFn(function(n) {
        var s = String(n).split("."), v0 = !s[1];
        return n == 1 && v0 ? "one" : "other";
    });
    Globalize.a1666963741 = pluralGeneratorFn(function(n) {
        return n == 1 ? "one" : "other";
    });
    Globalize.a1667887262 = pluralGeneratorFn(function(n) {
        var s = String(n).split("."), v0 = !s[1];
        return n == 1 && v0 ? "one" : "other";
    });
    Globalize.a1668810783 = pluralGeneratorFn(function(n) {
        return n == 1 ? "one" : "other";
    });
    Globalize.a1686357682 = pluralGeneratorFn(function(n) {
        var s = String(n).split("."), v0 = !s[1];
        return n == 1 && v0 ? "one" : "other";
    });
    Globalize.a1694669371 = pluralGeneratorFn(function(n) {
        return n >= 0 && n < 2 ? "one" : "other";
    });
    Globalize.a1717757396 = pluralGeneratorFn(function(n) {
        var s = String(n).split("."), v0 = !s[1];
        return n == 1 && v0 ? "one" : "other";
    });
    Globalize.a1739921900 = pluralGeneratorFn(function(n) {
        var s = String(n).split("."), i = s[0], v0 = !s[1], t0 = Number(s[0]) == n, n10 = t0 && s[0].slice(-1);
        return n == 1 && v0 ? "one" : i == 2 && v0 ? "two" : v0 && (n < 0 || n > 10) && t0 && n10 == 0 ? "many" : "other";
    });
    Globalize.a1743615984 = pluralGeneratorFn(function(n) {
        return n >= 0 && n <= 1 ? "one" : "other";
    });
    Globalize.a1751927673 = pluralGeneratorFn(function(n) {
        var s = String(n).split("."), i = s[0], f = s[1] || "", v0 = !s[1], i10 = i.slice(-1), i100 = i.slice(-2), f10 = f.slice(-1), f100 = f.slice(-2);
        return v0 && i10 == 1 && i100 != 11 || f10 == 1 && f100 != 11 ? "one" : v0 && i10 >= 2 && i10 <= 4 && (i100 < 12 || i100 > 14) || f10 >= 2 && f10 <= 4 && (f100 < 12 || f100 > 14) ? "few" : "other";
    });
    Globalize.a1754698236 = pluralGeneratorFn(function(n) {
        return n == 1 ? "one" : "other";
    });
    Globalize.a1767627530 = pluralGeneratorFn(function(n) {
        return "other";
    });
    Globalize.a1782403866 = pluralGeneratorFn(function(n) {
        var s = String(n).split("."), v0 = !s[1];
        return n == 1 && v0 ? "one" : "other";
    });
    Globalize.a1793486118 = pluralGeneratorFn(function(n) {
        return "other";
    });
    Globalize.a1831350479 = pluralGeneratorFn(function(n) {
        return n == 1 ? "one" : "other";
    });
    Globalize.a1835044563 = pluralGeneratorFn(function(n) {
        return "other";
    });
    Globalize.a1868291319 = pluralGeneratorFn(function(n) {
        var s = String(n).split("."), f = s[1] || "", t0 = Number(s[0]) == n, n10 = t0 && s[0].slice(-1), n100 = t0 && s[0].slice(-2);
        return n10 == 1 && (n100 < 11 || n100 > 19) ? "one" : n10 >= 2 && n10 <= 9 && (n100 < 11 || n100 > 19) ? "few" : f != 0 ? "many" : "other";
    });
    Globalize.a1870138361 = pluralGeneratorFn(function(n) {
        var s = String(n).split("."), f = s[1] || "", v = f.length, t0 = Number(s[0]) == n, n10 = t0 && s[0].slice(-1), n100 = t0 && s[0].slice(-2), f100 = f.slice(-2), f10 = f.slice(-1);
        return t0 && n10 == 0 || n100 >= 11 && n100 <= 19 || v == 2 && f100 >= 11 && f100 <= 19 ? "zero" : n10 == 1 && n100 != 11 || v == 2 && f10 == 1 && f100 != 11 || v != 2 && f10 == 1 ? "one" : "other";
    });
    Globalize.a1895996949 = pluralGeneratorFn(function(n) {
        return "other";
    });
    Globalize.a1908926243 = pluralGeneratorFn(function(n) {
        return n == 1 ? "one" : "other";
    });
    Globalize.a1918161453 = pluralGeneratorFn(function(n) {
        var s = String(n).split("."), v0 = !s[1];
        return n == 1 && v0 ? "one" : "other";
    });
    Globalize.a1975419755 = pluralGeneratorFn(function(n) {
        var s = String(n).split("."), i = s[0], v0 = !s[1], i10 = i.slice(-1), i100 = i.slice(-2);
        return n == 1 && v0 ? "one" : v0 && i10 >= 2 && i10 <= 4 && (i100 < 12 || i100 > 14) ? "few" : v0 && i != 1 && (i10 == 0 || i10 == 1) || v0 && i10 >= 5 && i10 <= 9 || v0 && i100 >= 12 && i100 <= 14 ? "many" : "other";
    });
    Globalize.a1982807923 = pluralGeneratorFn(function(n) {
        var s = String(n).split("."), i = s[0];
        return i == 0 || i == 1 ? "one" : "other";
    });
    Globalize.a2001260574 = pluralGeneratorFn(function(n) {
        var s = String(n).split("."), i = s[0];
        return i == 0 || i == 1 ? "one" : "other";
    });
    Globalize.a2035448620 = pluralGeneratorFn(function(n) {
        var s = String(n).split("."), v0 = !s[1], t0 = Number(s[0]) == n, n100 = t0 && s[0].slice(-2);
        return n == 1 && v0 ? "one" : !v0 || n == 0 || n100 >= 2 && n100 <= 19 ? "few" : "other";
    });
    Globalize.a2040989746 = pluralGeneratorFn(function(n) {
        var s = String(n).split("."), i = s[0], v0 = !s[1], i10 = i.slice(-1), i100 = i.slice(-2);
        return v0 && i10 == 1 && i100 != 11 ? "one" : v0 && i10 >= 2 && i10 <= 4 && (i100 < 12 || i100 > 14) ? "few" : v0 && i10 == 0 || v0 && i10 >= 5 && i10 <= 9 || v0 && i100 >= 11 && i100 <= 14 ? "many" : "other";
    });
    Globalize.a2060383687 = pluralGeneratorFn(function(n) {
        var s = String(n).split("."), i = s[0], v0 = !s[1];
        return n == 1 && v0 ? "one" : i >= 2 && i <= 4 && v0 ? "few" : !v0 ? "many" : "other";
    });
    Globalize.a2061307208 = pluralGeneratorFn(function(n) {
        var s = String(n).split("."), i = s[0], v0 = !s[1], i100 = i.slice(-2);
        return v0 && i100 == 1 ? "one" : v0 && i100 == 2 ? "two" : v0 && (i100 == 3 || i100 == 4) || !v0 ? "few" : "other";
    });
    Globalize.a598008047 = pluralGeneratorFn(function(n) {
        var s = String(n).split("."), i = s[0], f = s[1] || "", v0 = !s[1], i10 = i.slice(-1), i100 = i.slice(-2), f10 = f.slice(-1), f100 = f.slice(-2);
        return v0 && i10 == 1 && i100 != 11 || f10 == 1 && f100 != 11 ? "one" : v0 && i10 >= 2 && i10 <= 4 && (i100 < 12 || i100 > 14) || f10 >= 2 && f10 <= 4 && (f100 < 12 || f100 > 14) ? "few" : "other";
    });
    Globalize.b662714642 = pluralGeneratorFn(function(n) {
        var s = String(n).split("."), i = s[0], f = s[1] || "", v0 = !s[1], i10 = i.slice(-1), i100 = i.slice(-2), f10 = f.slice(-1), f100 = f.slice(-2);
        return v0 && i10 == 1 && i100 != 11 || f10 == 1 && f100 != 11 ? "one" : v0 && i10 >= 2 && i10 <= 4 && (i100 < 12 || i100 > 14) || f10 >= 2 && f10 <= 4 && (f100 < 12 || f100 > 14) ? "few" : "other";
    });
    Globalize.a2070542418 = pluralGeneratorFn(function(n) {
        var s = String(n).split("."), v0 = !s[1];
        return n == 1 && v0 ? "one" : "other";
    });
    Globalize.a2086242275 = pluralGeneratorFn(function(n) {
        return "other";
    });
    Globalize.a2095477485 = pluralGeneratorFn(function(n) {
        return n == 1 ? "one" : "other";
    });
    Globalize.a2117641989 = pluralGeneratorFn(function(n) {
        var s = String(n).split("."), i = s[0], v0 = !s[1], i10 = i.slice(-1), i100 = i.slice(-2);
        return v0 && i10 == 1 && i100 != 11 ? "one" : v0 && i10 >= 2 && i10 <= 4 && (i100 < 12 || i100 > 14) ? "few" : v0 && i10 == 0 || v0 && i10 >= 5 && i10 <= 9 || v0 && i100 >= 11 && i100 <= 14 ? "many" : "other";
    });
    Globalize.a2144424098 = pluralGeneratorFn(function(n) {
        return "other";
    });
    Globalize.a772012218 = pluralGeneratorFn(function(n) {
        return "other";
    });
    Globalize.b1234768562 = pluralGeneratorFn(function(n) {
        return "other";
    });
    Globalize.b1960777549 = pluralGeneratorFn(function(n) {
        return "other";
    });
    Globalize.b1233845041 = pluralGeneratorFn(function(n) {
        return "other";
    });
    Globalize.b529193791 = pluralGeneratorFn(function(n) {
        return "other";
    });
    Globalize.b382353952 = pluralGeneratorFn(function(n) {
        return "other";
    });
    Globalize.a1178402495 = dateToPartsFormatterFn({
        1: Globalize("ar-EG").numberFormatter({
            raw: "0"
        }),
        2: Globalize("ar-EG").numberFormatter({
            raw: "00"
        })
    }, {
        pattern: "d MMMM h:mm a",
        timeSeparator: ":",
        months: {
            M: {
                4: {
                    1: "يناير",
                    2: "فبراير",
                    3: "مارس",
                    4: "أبريل",
                    5: "مايو",
                    6: "يونيو",
                    7: "يوليو",
                    8: "أغسطس",
                    9: "سبتمبر",
                    10: "أكتوبر",
                    11: "نوفمبر",
                    12: "ديسمبر"
                }
            }
        },
        dayPeriods: {
            am: "ص",
            pm: "م"
        }
    });
    Globalize.a1191033963 = dateToPartsFormatterFn({
        1: Globalize("ar-SA").numberFormatter({
            raw: "0"
        }),
        2: Globalize("ar-SA").numberFormatter({
            raw: "00"
        })
    }, {
        pattern: "d MMMM h:mm a",
        timeSeparator: ":",
        months: {
            M: {
                4: {
                    1: "يناير",
                    2: "فبراير",
                    3: "مارس",
                    4: "أبريل",
                    5: "مايو",
                    6: "يونيو",
                    7: "يوليو",
                    8: "أغسطس",
                    9: "سبتمبر",
                    10: "أكتوبر",
                    11: "نوفمبر",
                    12: "ديسمبر"
                }
            }
        },
        dayPeriods: {
            am: "ص",
            pm: "م"
        }
    });
    Globalize.b474539636 = dateToPartsFormatterFn({
        1: Globalize("bg").numberFormatter({
            raw: "0"
        }),
        2: Globalize("bg").numberFormatter({
            raw: "00"
        })
    }, {
        pattern: "d MMMM, h:mm a",
        timeSeparator: ":",
        months: {
            M: {
                4: {
                    1: "януари",
                    2: "февруари",
                    3: "март",
                    4: "април",
                    5: "май",
                    6: "юни",
                    7: "юли",
                    8: "август",
                    9: "септември",
                    10: "октомври",
                    11: "ноември",
                    12: "декември"
                }
            }
        },
        dayPeriods: {
            am: "пр.об.",
            pm: "сл.об."
        }
    });
    Globalize.b865165659 = dateToPartsFormatterFn({
        1: Globalize("ca").numberFormatter({
            raw: "0"
        }),
        2: Globalize("ca").numberFormatter({
            raw: "00"
        })
    }, {
        pattern: "d MMMM 'a' 'les' h:mm a",
        timeSeparator: ":",
        months: {
            M: {
                4: {
                    1: "de gener",
                    2: "de febrer",
                    3: "de mar\xe7",
                    4: "d’abril",
                    5: "de maig",
                    6: "de juny",
                    7: "de juliol",
                    8: "d’agost",
                    9: "de setembre",
                    10: "d’octubre",
                    11: "de novembre",
                    12: "de desembre"
                }
            }
        },
        dayPeriods: {
            am: "a.\xa0m.",
            pm: "p.\xa0m."
        }
    });
    Globalize.a399771831 = dateToPartsFormatterFn({
        1: Globalize("cs").numberFormatter({
            raw: "0"
        }),
        2: Globalize("cs").numberFormatter({
            raw: "00"
        })
    }, {
        pattern: "d. MMMM h:mm a",
        timeSeparator: ":",
        months: {
            M: {
                4: {
                    1: "ledna",
                    2: "\xfanora",
                    3: "března",
                    4: "dubna",
                    5: "května",
                    6: "června",
                    7: "července",
                    8: "srpna",
                    9: "z\xe1ř\xed",
                    10: "ř\xedjna",
                    11: "listopadu",
                    12: "prosince"
                }
            }
        },
        dayPeriods: {
            am: "dop.",
            pm: "odp."
        }
    });
    Globalize.b834145852 = dateToPartsFormatterFn({
        1: Globalize("da").numberFormatter({
            raw: "0"
        }),
        2: Globalize("da").numberFormatter({
            raw: "00"
        })
    }, {
        pattern: "d. MMMM 'kl'. h.mm a",
        timeSeparator: ".",
        months: {
            M: {
                4: {
                    1: "januar",
                    2: "februar",
                    3: "marts",
                    4: "april",
                    5: "maj",
                    6: "juni",
                    7: "juli",
                    8: "august",
                    9: "september",
                    10: "oktober",
                    11: "november",
                    12: "december"
                }
            }
        },
        dayPeriods: {
            am: "AM",
            pm: "PM"
        }
    });
    Globalize.b553048632 = dateToPartsFormatterFn({
        1: Globalize("de").numberFormatter({
            raw: "0"
        }),
        2: Globalize("de").numberFormatter({
            raw: "00"
        })
    }, {
        pattern: "d. MMMM 'um' h:mm a",
        timeSeparator: ":",
        months: {
            M: {
                4: {
                    1: "Januar",
                    2: "Februar",
                    3: "M\xe4rz",
                    4: "April",
                    5: "Mai",
                    6: "Juni",
                    7: "Juli",
                    8: "August",
                    9: "September",
                    10: "Oktober",
                    11: "November",
                    12: "Dezember"
                }
            }
        },
        dayPeriods: {
            am: "AM",
            pm: "PM"
        }
    });
    Globalize.a2117374958 = dateToPartsFormatterFn({
        1: Globalize("el").numberFormatter({
            raw: "0"
        }),
        2: Globalize("el").numberFormatter({
            raw: "00"
        })
    }, {
        pattern: "d MMMM - h:mm a",
        timeSeparator: ":",
        months: {
            M: {
                4: {
                    1: "Ιανουαρίου",
                    2: "Φεβρουαρίου",
                    3: "Μαρτίου",
                    4: "Απριλίου",
                    5: "Μαΐου",
                    6: "Ιουνίου",
                    7: "Ιουλίου",
                    8: "Αυγούστου",
                    9: "Σεπτεμβρίου",
                    10: "Οκτωβρίου",
                    11: "Νοεμβρίου",
                    12: "Δεκεμβρίου"
                }
            }
        },
        dayPeriods: {
            am: "π.μ.",
            pm: "μ.μ."
        }
    });
    Globalize.b2037043728 = dateToPartsFormatterFn({
        1: Globalize("en").numberFormatter({
            raw: "0"
        }),
        2: Globalize("en").numberFormatter({
            raw: "00"
        })
    }, {
        pattern: "MMMM d 'at' h:mm a",
        timeSeparator: ":",
        months: {
            M: {
                4: {
                    1: "January",
                    2: "February",
                    3: "March",
                    4: "April",
                    5: "May",
                    6: "June",
                    7: "July",
                    8: "August",
                    9: "September",
                    10: "October",
                    11: "November",
                    12: "December"
                }
            }
        },
        dayPeriods: {
            am: "AM",
            pm: "PM"
        }
    });
    Globalize.a461811445 = dateToPartsFormatterFn({
        1: Globalize("es").numberFormatter({
            raw: "0"
        }),
        2: Globalize("es").numberFormatter({
            raw: "00"
        })
    }, {
        pattern: "d 'de' MMMM, h:mm a",
        timeSeparator: ":",
        months: {
            M: {
                4: {
                    1: "enero",
                    2: "febrero",
                    3: "marzo",
                    4: "abril",
                    5: "mayo",
                    6: "junio",
                    7: "julio",
                    8: "agosto",
                    9: "septiembre",
                    10: "octubre",
                    11: "noviembre",
                    12: "diciembre"
                }
            }
        },
        dayPeriods: {
            am: "a.\xa0m.",
            pm: "p.\xa0m."
        }
    });
    Globalize.b1615397898 = dateToPartsFormatterFn({
        1: Globalize("et").numberFormatter({
            raw: "0"
        }),
        2: Globalize("et").numberFormatter({
            raw: "00"
        })
    }, {
        pattern: "d. MMMM h:mm a",
        timeSeparator: ":",
        months: {
            M: {
                4: {
                    1: "jaanuar",
                    2: "veebruar",
                    3: "m\xe4rts",
                    4: "aprill",
                    5: "mai",
                    6: "juuni",
                    7: "juuli",
                    8: "august",
                    9: "september",
                    10: "oktoober",
                    11: "november",
                    12: "detsember"
                }
            }
        },
        dayPeriods: {
            am: "AM",
            pm: "PM"
        }
    });
    Globalize.a602360055 = dateToPartsFormatterFn({
        1: Globalize("eu").numberFormatter({
            raw: "0"
        }),
        2: Globalize("eu").numberFormatter({
            raw: "00"
        })
    }, {
        pattern: "MMMM d h:mm a",
        timeSeparator: ":",
        months: {
            M: {
                4: {
                    1: "urtarrila",
                    2: "otsaila",
                    3: "martxoa",
                    4: "apirila",
                    5: "maiatza",
                    6: "ekaina",
                    7: "uztaila",
                    8: "abuztua",
                    9: "iraila",
                    10: "urria",
                    11: "azaroa",
                    12: "abendua"
                }
            }
        },
        dayPeriods: {
            am: "AM",
            pm: "PM"
        }
    });
    Globalize.b209911798 = dateToPartsFormatterFn({
        1: Globalize("fi").numberFormatter({
            raw: "0"
        }),
        2: Globalize("fi").numberFormatter({
            raw: "00"
        })
    }, {
        pattern: "d. MMMM 'klo' h.mm a",
        timeSeparator: ".",
        months: {
            M: {
                4: {
                    1: "tammikuuta",
                    2: "helmikuuta",
                    3: "maaliskuuta",
                    4: "huhtikuuta",
                    5: "toukokuuta",
                    6: "kes\xe4kuuta",
                    7: "hein\xe4kuuta",
                    8: "elokuuta",
                    9: "syyskuuta",
                    10: "lokakuuta",
                    11: "marraskuuta",
                    12: "joulukuuta"
                }
            }
        },
        dayPeriods: {
            am: "ap.",
            pm: "ip."
        }
    });
    Globalize.b1724926701 = dateToPartsFormatterFn({
        1: Globalize("fr").numberFormatter({
            raw: "0"
        }),
        2: Globalize("fr").numberFormatter({
            raw: "00"
        })
    }, {
        pattern: "d MMMM '\xe0' h:mm a",
        timeSeparator: ":",
        months: {
            M: {
                4: {
                    1: "janvier",
                    2: "f\xe9vrier",
                    3: "mars",
                    4: "avril",
                    5: "mai",
                    6: "juin",
                    7: "juillet",
                    8: "ao\xfbt",
                    9: "septembre",
                    10: "octobre",
                    11: "novembre",
                    12: "d\xe9cembre"
                }
            }
        },
        dayPeriods: {
            am: "AM",
            pm: "PM"
        }
    });
    Globalize.b2115552724 = dateToPartsFormatterFn({
        1: Globalize("gl").numberFormatter({
            raw: "0"
        }),
        2: Globalize("gl").numberFormatter({
            raw: "00"
        })
    }, {
        pattern: "h:mm a 'do' d 'de' MMMM",
        timeSeparator: ":",
        dayPeriods: {
            am: "a.m.",
            pm: "p.m."
        },
        months: {
            M: {
                4: {
                    1: "xaneiro",
                    2: "febreiro",
                    3: "marzo",
                    4: "abril",
                    5: "maio",
                    6: "xu\xf1o",
                    7: "xullo",
                    8: "agosto",
                    9: "setembro",
                    10: "outubro",
                    11: "novembro",
                    12: "decembro"
                }
            }
        }
    });
    Globalize.b428969404 = dateToPartsFormatterFn({
        1: Globalize("he").numberFormatter({
            raw: "0"
        }),
        2: Globalize("he").numberFormatter({
            raw: "00"
        })
    }, {
        pattern: "d בMMMM בשעה h:mm a",
        timeSeparator: ":",
        months: {
            M: {
                4: {
                    1: "ינואר",
                    2: "פברואר",
                    3: "מרץ",
                    4: "אפריל",
                    5: "מאי",
                    6: "יוני",
                    7: "יולי",
                    8: "אוגוסט",
                    9: "ספטמבר",
                    10: "אוקטובר",
                    11: "נובמבר",
                    12: "דצמבר"
                }
            }
        },
        dayPeriods: {
            am: "לפנה״צ",
            pm: "אחה״צ"
        }
    });
    Globalize.b147872184 = dateToPartsFormatterFn({
        1: Globalize("hi").numberFormatter({
            raw: "0"
        }),
        2: Globalize("hi").numberFormatter({
            raw: "00"
        })
    }, {
        pattern: "d MMMM को h:mm a",
        timeSeparator: ":",
        months: {
            M: {
                4: {
                    1: "जनवरी",
                    2: "फ़रवरी",
                    3: "मार्च",
                    4: "अप्रैल",
                    5: "मई",
                    6: "जून",
                    7: "जुलाई",
                    8: "अगस्त",
                    9: "सितंबर",
                    10: "अक्तूबर",
                    11: "नवंबर",
                    12: "दिसंबर"
                }
            }
        },
        dayPeriods: {
            am: "am",
            pm: "pm"
        }
    });
    Globalize.b1662887087 = dateToPartsFormatterFn({
        1: Globalize("hr").numberFormatter({
            raw: "0"
        }),
        2: Globalize("hr").numberFormatter({
            raw: "00"
        })
    }, {
        pattern: "d. MMMM 'u' hh:mm a",
        timeSeparator: ":",
        months: {
            M: {
                4: {
                    1: "siječnja",
                    2: "veljače",
                    3: "ožujka",
                    4: "travnja",
                    5: "svibnja",
                    6: "lipnja",
                    7: "srpnja",
                    8: "kolovoza",
                    9: "rujna",
                    10: "listopada",
                    11: "studenoga",
                    12: "prosinca"
                }
            }
        },
        dayPeriods: {
            am: "AM",
            pm: "PM"
        }
    });
    Globalize.a695419476 = dateToPartsFormatterFn({
        1: Globalize("hu").numberFormatter({
            raw: "0"
        }),
        2: Globalize("hu").numberFormatter({
            raw: "00"
        })
    }, {
        pattern: "MMMM d. a h:mm",
        timeSeparator: ":",
        months: {
            M: {
                4: {
                    1: "janu\xe1r",
                    2: "febru\xe1r",
                    3: "m\xe1rcius",
                    4: "\xe1prilis",
                    5: "m\xe1jus",
                    6: "j\xfanius",
                    7: "j\xfalius",
                    8: "augusztus",
                    9: "szeptember",
                    10: "okt\xf3ber",
                    11: "november",
                    12: "december"
                }
            }
        },
        dayPeriods: {
            am: "de.",
            pm: "du."
        }
    });
    Globalize.a1679259746 = dateToPartsFormatterFn({
        1: Globalize("id").numberFormatter({
            raw: "0"
        }),
        2: Globalize("id").numberFormatter({
            raw: "00"
        })
    }, {
        pattern: "d MMMM h.mm a",
        timeSeparator: ".",
        months: {
            M: {
                4: {
                    1: "Januari",
                    2: "Februari",
                    3: "Maret",
                    4: "April",
                    5: "Mei",
                    6: "Juni",
                    7: "Juli",
                    8: "Agustus",
                    9: "September",
                    10: "Oktober",
                    11: "November",
                    12: "Desember"
                }
            }
        },
        dayPeriods: {
            am: "AM",
            pm: "PM"
        }
    });
    Globalize.b1491318670 = dateToPartsFormatterFn({
        1: Globalize("it").numberFormatter({
            raw: "0"
        }),
        2: Globalize("it").numberFormatter({
            raw: "00"
        })
    }, {
        pattern: "d MMMM h:mm a",
        timeSeparator: ":",
        months: {
            M: {
                4: {
                    1: "gennaio",
                    2: "febbraio",
                    3: "marzo",
                    4: "aprile",
                    5: "maggio",
                    6: "giugno",
                    7: "luglio",
                    8: "agosto",
                    9: "settembre",
                    10: "ottobre",
                    11: "novembre",
                    12: "dicembre"
                }
            }
        },
        dayPeriods: {
            am: "AM",
            pm: "PM"
        }
    });
    Globalize.b648027010 = dateToPartsFormatterFn({
        1: Globalize("ja").numberFormatter({
            raw: "0"
        }),
        2: Globalize("ja").numberFormatter({
            raw: "00"
        })
    }, {
        pattern: "M月d日 aK:mm",
        timeSeparator: ":",
        dayPeriods: {
            am: "午前",
            pm: "午後"
        }
    });
    Globalize.a85735847 = dateToPartsFormatterFn({
        1: Globalize("kk").numberFormatter({
            raw: "0"
        }),
        2: Globalize("kk").numberFormatter({
            raw: "00"
        })
    }, {
        pattern: "d MMMM, h:mm a",
        timeSeparator: ":",
        months: {
            M: {
                4: {
                    1: "қаңтар",
                    2: "ақпан",
                    3: "наурыз",
                    4: "сәуір",
                    5: "мамыр",
                    6: "маусым",
                    7: "шілде",
                    8: "тамыз",
                    9: "қыркүйек",
                    10: "қазан",
                    11: "қараша",
                    12: "желтоқсан"
                }
            }
        },
        dayPeriods: {
            am: "AM",
            pm: "PM"
        }
    });
    Globalize.a366833067 = dateToPartsFormatterFn({
        1: Globalize("ko").numberFormatter({
            raw: "0"
        }),
        2: Globalize("ko").numberFormatter({
            raw: "00"
        })
    }, {
        pattern: "MMMM d일 a h:mm",
        timeSeparator: ":",
        months: {
            M: {
                4: {
                    1: "1월",
                    2: "2월",
                    3: "3월",
                    4: "4월",
                    5: "5월",
                    6: "6월",
                    7: "7월",
                    8: "8월",
                    9: "9월",
                    10: "10월",
                    11: "11월",
                    12: "12월"
                }
            }
        },
        dayPeriods: {
            am: "오전",
            pm: "오후"
        }
    });
    Globalize.b1398259249 = dateToPartsFormatterFn({
        1: Globalize("lt").numberFormatter({
            raw: "0"
        }),
        2: Globalize("lt").numberFormatter({
            raw: "00"
        })
    }, {
        pattern: "MMMM d 'd'. hh:mm a",
        timeSeparator: ":",
        months: {
            M: {
                4: {
                    1: "sausio",
                    2: "vasario",
                    3: "kovo",
                    4: "balandžio",
                    5: "gegužės",
                    6: "birželio",
                    7: "liepos",
                    8: "rugpjūčio",
                    9: "rugsėjo",
                    10: "spalio",
                    11: "lapkričio",
                    12: "gruodžio"
                }
            }
        },
        dayPeriods: {
            am: "priešpiet",
            pm: "popiet"
        }
    });
    Globalize.b1257710639 = dateToPartsFormatterFn({
        1: Globalize("lv").numberFormatter({
            raw: "0"
        }),
        2: Globalize("lv").numberFormatter({
            raw: "00"
        })
    }, {
        pattern: "d. MMMM h:mm a",
        timeSeparator: ":",
        months: {
            M: {
                4: {
                    1: "janvāris",
                    2: "februāris",
                    3: "marts",
                    4: "aprīlis",
                    5: "maijs",
                    6: "jūnijs",
                    7: "jūlijs",
                    8: "augusts",
                    9: "septembris",
                    10: "oktobris",
                    11: "novembris",
                    12: "decembris"
                }
            }
        },
        dayPeriods: {
            am: "priekšpusdienā",
            pm: "pēcpusdienā"
        }
    });
    Globalize.a709969901 = dateToPartsFormatterFn({
        1: Globalize("ms").numberFormatter({
            raw: "0"
        }),
        2: Globalize("ms").numberFormatter({
            raw: "00"
        })
    }, {
        pattern: "d MMMM h:mm a",
        timeSeparator: ":",
        months: {
            M: {
                4: {
                    1: "Januari",
                    2: "Februari",
                    3: "Mac",
                    4: "April",
                    5: "Mei",
                    6: "Jun",
                    7: "Julai",
                    8: "Ogos",
                    9: "September",
                    10: "Oktober",
                    11: "November",
                    12: "Disember"
                }
            }
        },
        dayPeriods: {
            am: "PG",
            pm: "PTG"
        }
    });
    Globalize.a1693810171 = dateToPartsFormatterFn({
        1: Globalize("nb").numberFormatter({
            raw: "0"
        }),
        2: Globalize("nb").numberFormatter({
            raw: "00"
        })
    }, {
        pattern: "d. MMMM 'kl'. h:mm a",
        timeSeparator: ":",
        months: {
            M: {
                4: {
                    1: "januar",
                    2: "februar",
                    3: "mars",
                    4: "april",
                    5: "mai",
                    6: "juni",
                    7: "juli",
                    8: "august",
                    9: "september",
                    10: "oktober",
                    11: "november",
                    12: "desember"
                }
            }
        },
        dayPeriods: {
            am: "a.m.",
            pm: "p.m."
        }
    });
    Globalize.b1898414075 = dateToPartsFormatterFn({
        1: Globalize("nl").numberFormatter({
            raw: "0"
        }),
        2: Globalize("nl").numberFormatter({
            raw: "00"
        })
    }, {
        pattern: "d MMMM 'om' h:mm a",
        timeSeparator: ":",
        months: {
            M: {
                4: {
                    1: "januari",
                    2: "februari",
                    3: "maart",
                    4: "april",
                    5: "mei",
                    6: "juni",
                    7: "juli",
                    8: "augustus",
                    9: "september",
                    10: "oktober",
                    11: "november",
                    12: "december"
                }
            }
        },
        dayPeriods: {
            am: "a.m.",
            pm: "p.m."
        }
    });
    Globalize.b1836374461 = dateToPartsFormatterFn({
        1: Globalize("pl").numberFormatter({
            raw: "0"
        }),
        2: Globalize("pl").numberFormatter({
            raw: "00"
        })
    }, {
        pattern: "d MMMM h:mm a",
        timeSeparator: ":",
        months: {
            M: {
                4: {
                    1: "stycznia",
                    2: "lutego",
                    3: "marca",
                    4: "kwietnia",
                    5: "maja",
                    6: "czerwca",
                    7: "lipca",
                    8: "sierpnia",
                    9: "września",
                    10: "października",
                    11: "listopada",
                    12: "grudnia"
                }
            }
        },
        dayPeriods: {
            am: "AM",
            pm: "PM"
        }
    });
    Globalize.b1274180021 = dateToPartsFormatterFn({
        1: Globalize("pt").numberFormatter({
            raw: "0"
        }),
        2: Globalize("pt").numberFormatter({
            raw: "00"
        })
    }, {
        pattern: "d 'de' MMMM h:mm a",
        timeSeparator: ":",
        months: {
            M: {
                4: {
                    1: "janeiro",
                    2: "fevereiro",
                    3: "mar\xe7o",
                    4: "abril",
                    5: "maio",
                    6: "junho",
                    7: "julho",
                    8: "agosto",
                    9: "setembro",
                    10: "outubro",
                    11: "novembro",
                    12: "dezembro"
                }
            }
        },
        dayPeriods: {
            am: "AM",
            pm: "PM"
        }
    });
    Globalize.a1582820462 = dateToPartsFormatterFn({
        1: Globalize("pt-PT").numberFormatter({
            raw: "0"
        }),
        2: Globalize("pt-PT").numberFormatter({
            raw: "00"
        })
    }, {
        pattern: "d 'de' MMMM '\xe0s' h:mm a",
        timeSeparator: ":",
        months: {
            M: {
                4: {
                    1: "janeiro",
                    2: "fevereiro",
                    3: "mar\xe7o",
                    4: "abril",
                    5: "maio",
                    6: "junho",
                    7: "julho",
                    8: "agosto",
                    9: "setembro",
                    10: "outubro",
                    11: "novembro",
                    12: "dezembro"
                }
            }
        },
        dayPeriods: {
            am: "da manh\xe3",
            pm: "da tarde"
        }
    });
    Globalize.a583971716 = dateToPartsFormatterFn({
        1: Globalize("ro").numberFormatter({
            raw: "0"
        }),
        2: Globalize("ro").numberFormatter({
            raw: "00"
        })
    }, {
        pattern: "d MMMM, h:mm a",
        timeSeparator: ":",
        months: {
            M: {
                4: {
                    1: "ianuarie",
                    2: "februarie",
                    3: "martie",
                    4: "aprilie",
                    5: "mai",
                    6: "iunie",
                    7: "iulie",
                    8: "august",
                    9: "septembrie",
                    10: "octombrie",
                    11: "noiembrie",
                    12: "decembrie"
                }
            }
        },
        dayPeriods: {
            am: "a.m.",
            pm: "p.m."
        }
    });
    Globalize.a1005617546 = dateToPartsFormatterFn({
        1: Globalize("ru").numberFormatter({
            raw: "0"
        }),
        2: Globalize("ru").numberFormatter({
            raw: "00"
        })
    }, {
        pattern: "d MMMM, h:mm a",
        timeSeparator: ":",
        months: {
            M: {
                4: {
                    1: "января",
                    2: "февраля",
                    3: "марта",
                    4: "апреля",
                    5: "мая",
                    6: "июня",
                    7: "июля",
                    8: "августа",
                    9: "сентября",
                    10: "октября",
                    11: "ноября",
                    12: "декабря"
                }
            }
        },
        dayPeriods: {
            am: "AM",
            pm: "PM"
        }
    });
    Globalize.a333894303 = dateToPartsFormatterFn({
        1: Globalize("sk").numberFormatter({
            raw: "0"
        }),
        2: Globalize("sk").numberFormatter({
            raw: "00"
        })
    }, {
        pattern: "d. MMMM, h:mm a",
        timeSeparator: ":",
        months: {
            M: {
                4: {
                    1: "janu\xe1ra",
                    2: "febru\xe1ra",
                    3: "marca",
                    4: "apr\xedla",
                    5: "m\xe1ja",
                    6: "j\xfana",
                    7: "j\xfala",
                    8: "augusta",
                    9: "septembra",
                    10: "okt\xf3bra",
                    11: "novembra",
                    12: "decembra"
                }
            }
        },
        dayPeriods: {
            am: "AM",
            pm: "PM"
        }
    });
    Globalize.b1743315040 = dateToPartsFormatterFn({
        1: Globalize("sl").numberFormatter({
            raw: "0"
        }),
        2: Globalize("sl").numberFormatter({
            raw: "00"
        })
    }, {
        pattern: "d. MMMM h:mm a",
        timeSeparator: ":",
        months: {
            M: {
                4: {
                    1: "januar",
                    2: "februar",
                    3: "marec",
                    4: "april",
                    5: "maj",
                    6: "junij",
                    7: "julij",
                    8: "avgust",
                    9: "september",
                    10: "oktober",
                    11: "november",
                    12: "december"
                }
            }
        },
        dayPeriods: {
            am: "dop.",
            pm: "pop."
        }
    });
    Globalize.a374999999 = dateToPartsFormatterFn({
        1: Globalize("sr-Cyrl").numberFormatter({
            raw: "0"
        }),
        2: Globalize("sr-Cyrl").numberFormatter({
            raw: "00"
        })
    }, {
        pattern: "d. MMMM h:mm a",
        timeSeparator: ":",
        months: {
            M: {
                4: {
                    1: "јануар",
                    2: "фебруар",
                    3: "март",
                    4: "април",
                    5: "мај",
                    6: "јун",
                    7: "јул",
                    8: "август",
                    9: "септембар",
                    10: "октобар",
                    11: "новембар",
                    12: "децембар"
                }
            }
        },
        dayPeriods: {
            am: "пре подне",
            pm: "по подне"
        }
    });
    Globalize.a976026686 = dateToPartsFormatterFn({
        1: Globalize("sr-Latn").numberFormatter({
            raw: "0"
        }),
        2: Globalize("sr-Latn").numberFormatter({
            raw: "00"
        })
    }, {
        pattern: "d. MMMM h:mm a",
        timeSeparator: ":",
        months: {
            M: {
                4: {
                    1: "januar",
                    2: "februar",
                    3: "mart",
                    4: "april",
                    5: "maj",
                    6: "jun",
                    7: "jul",
                    8: "avgust",
                    9: "septembar",
                    10: "oktobar",
                    11: "novembar",
                    12: "decembar"
                }
            }
        },
        dayPeriods: {
            am: "pre podne",
            pm: "po podne"
        }
    });
    Globalize.b1040571990 = dateToPartsFormatterFn({
        1: Globalize("sv").numberFormatter({
            raw: "0"
        }),
        2: Globalize("sv").numberFormatter({
            raw: "00"
        })
    }, {
        pattern: "d MMMM h:mm a",
        timeSeparator: ":",
        months: {
            M: {
                4: {
                    1: "januari",
                    2: "februari",
                    3: "mars",
                    4: "april",
                    5: "maj",
                    6: "juni",
                    7: "juli",
                    8: "augusti",
                    9: "september",
                    10: "oktober",
                    11: "november",
                    12: "december"
                }
            }
        },
        dayPeriods: {
            am: "fm",
            pm: "em"
        }
    });
    Globalize.b1993392453 = dateToPartsFormatterFn({
        1: Globalize("th").numberFormatter({
            raw: "0"
        }),
        2: Globalize("th").numberFormatter({
            raw: "00"
        })
    }, {
        pattern: "d MMMM h:mm a",
        timeSeparator: ":",
        months: {
            M: {
                4: {
                    1: "มกราคม",
                    2: "กุมภาพันธ์",
                    3: "มีนาคม",
                    4: "เมษายน",
                    5: "พฤษภาคม",
                    6: "มิถุนายน",
                    7: "กรกฎาคม",
                    8: "สิงหาคม",
                    9: "กันยายน",
                    10: "ตุลาคม",
                    11: "พฤศจิกายน",
                    12: "ธันวาคม"
                }
            }
        },
        dayPeriods: {
            am: "ก่อนเที่ยง",
            pm: "หลังเที่ยง"
        }
    });
    Globalize.b1290649403 = dateToPartsFormatterFn({
        1: Globalize("tr").numberFormatter({
            raw: "0"
        }),
        2: Globalize("tr").numberFormatter({
            raw: "00"
        })
    }, {
        pattern: "d MMMM a h:mm",
        timeSeparator: ":",
        months: {
            M: {
                4: {
                    1: "Ocak",
                    2: "Şubat",
                    3: "Mart",
                    4: "Nisan",
                    5: "Mayıs",
                    6: "Haziran",
                    7: "Temmuz",
                    8: "Ağustos",
                    9: "Eyl\xfcl",
                    10: "Ekim",
                    11: "Kasım",
                    12: "Aralık"
                }
            }
        },
        dayPeriods: {
            am: "\xd6\xd6",
            pm: "\xd6S"
        }
    });
    Globalize.a395933917 = dateToPartsFormatterFn({
        1: Globalize("uk").numberFormatter({
            raw: "0"
        }),
        2: Globalize("uk").numberFormatter({
            raw: "00"
        })
    }, {
        pattern: "d MMMM 'о' h:mm a",
        timeSeparator: ":",
        months: {
            M: {
                4: {
                    1: "січня",
                    2: "лютого",
                    3: "березня",
                    4: "квітня",
                    5: "травня",
                    6: "червня",
                    7: "липня",
                    8: "серпня",
                    9: "вересня",
                    10: "жовтня",
                    11: "листопада",
                    12: "грудня"
                }
            }
        },
        dayPeriods: {
            am: "дп",
            pm: "пп"
        }
    });
    Globalize.a286405114 = dateToPartsFormatterFn({
        1: Globalize("vi").numberFormatter({
            raw: "0"
        }),
        2: Globalize("vi").numberFormatter({
            raw: "00"
        })
    }, {
        pattern: "h:mm a d MMMM",
        timeSeparator: ":",
        dayPeriods: {
            am: "SA",
            pm: "CH"
        },
        months: {
            M: {
                4: {
                    1: "th\xe1ng 1",
                    2: "th\xe1ng 2",
                    3: "th\xe1ng 3",
                    4: "th\xe1ng 4",
                    5: "th\xe1ng 5",
                    6: "th\xe1ng 6",
                    7: "th\xe1ng 7",
                    8: "th\xe1ng 8",
                    9: "th\xe1ng 9",
                    10: "th\xe1ng 10",
                    11: "th\xe1ng 11",
                    12: "th\xe1ng 12"
                }
            }
        }
    });
    Globalize.b222114294 = dateToPartsFormatterFn({
        1: Globalize("yue").numberFormatter({
            raw: "0"
        }),
        2: Globalize("yue").numberFormatter({
            raw: "00"
        })
    }, {
        pattern: "M月d日 ah:mm",
        timeSeparator: ":",
        dayPeriods: {
            am: "上午",
            pm: "下午"
        }
    });
    Globalize.b1939787106 = dateToPartsFormatterFn({
        1: Globalize("zh-Hans").numberFormatter({
            raw: "0"
        }),
        2: Globalize("zh-Hans").numberFormatter({
            raw: "00"
        })
    }, {
        pattern: "M月d日 ah:mm",
        timeSeparator: ":",
        dayPeriods: {
            am: "上午",
            pm: "下午"
        }
    });
    Globalize.b621833333 = dateToPartsFormatterFn({
        1: Globalize("zh-Hans-SG").numberFormatter({
            raw: "0"
        }),
        2: Globalize("zh-Hans-SG").numberFormatter({
            raw: "00"
        })
    }, {
        pattern: "M月d日 ah:mm",
        timeSeparator: ":",
        dayPeriods: {
            am: "上午",
            pm: "下午"
        }
    });
    Globalize.a277970847 = dateToPartsFormatterFn({
        1: Globalize("zh-Hant").numberFormatter({
            raw: "0"
        }),
        2: Globalize("zh-Hant").numberFormatter({
            raw: "00"
        })
    }, {
        pattern: "M月d日 ah:mm",
        timeSeparator: ":",
        dayPeriods: {
            am: "上午",
            pm: "下午"
        }
    });
    Globalize.b936690535 = dateToPartsFormatterFn({
        1: Globalize("zh-Hant-HK").numberFormatter({
            raw: "0"
        }),
        2: Globalize("zh-Hant-HK").numberFormatter({
            raw: "00"
        })
    }, {
        pattern: "M月d日 ah:mm",
        timeSeparator: ":",
        dayPeriods: {
            am: "上午",
            pm: "下午"
        }
    });
    Globalize.b500494280 = dateToPartsFormatterFn({
        1: Globalize("zh-Hant-MO").numberFormatter({
            raw: "0"
        }),
        2: Globalize("zh-Hant-MO").numberFormatter({
            raw: "00"
        })
    }, {
        pattern: "M月d日 ah:mm",
        timeSeparator: ":",
        dayPeriods: {
            am: "上午",
            pm: "下午"
        }
    });
    Globalize.a50097046 = dateFormatterFn(Globalize("ar-EG").dateToPartsFormatter({
        skeleton: "MMMMdhm"
    }));
    Globalize.a62728514 = dateFormatterFn(Globalize("ar-SA").dateToPartsFormatter({
        skeleton: "MMMMdhm"
    }));
    Globalize.b46681067 = dateFormatterFn(Globalize("bg").dateToPartsFormatter({
        skeleton: "MMMMdhm"
    }));
    Globalize.b437307090 = dateFormatterFn(Globalize("ca").dateToPartsFormatter({
        skeleton: "MMMMdhm"
    }));
    Globalize.a827630400 = dateFormatterFn(Globalize("cs").dateToPartsFormatter({
        skeleton: "MMMMdhm"
    }));
    Globalize.b406287283 = dateFormatterFn(Globalize("da").dateToPartsFormatter({
        skeleton: "MMMMdhm"
    }));
    Globalize.b125190063 = dateFormatterFn(Globalize("de").dateToPartsFormatter({
        skeleton: "MMMMdhm"
    }));
    Globalize.b1749733769 = dateFormatterFn(Globalize("el").dateToPartsFormatter({
        skeleton: "MMMMdhm"
    }));
    Globalize.b1609185159 = dateFormatterFn(Globalize("en").dateToPartsFormatter({
        skeleton: "MMMMdhm"
    }));
    Globalize.a889670014 = dateFormatterFn(Globalize("es").dateToPartsFormatter({
        skeleton: "MMMMdhm"
    }));
    Globalize.b1187539329 = dateFormatterFn(Globalize("et").dateToPartsFormatter({
        skeleton: "MMMMdhm"
    }));
    Globalize.a1030218624 = dateFormatterFn(Globalize("eu").dateToPartsFormatter({
        skeleton: "MMMMdhm"
    }));
    Globalize.a217946771 = dateFormatterFn(Globalize("fi").dateToPartsFormatter({
        skeleton: "MMMMdhm"
    }));
    Globalize.b1297068132 = dateFormatterFn(Globalize("fr").dateToPartsFormatter({
        skeleton: "MMMMdhm"
    }));
    Globalize.b1687694155 = dateFormatterFn(Globalize("gl").dateToPartsFormatter({
        skeleton: "MMMMdhm"
    }));
    Globalize.b1110835 = dateFormatterFn(Globalize("he").dateToPartsFormatter({
        skeleton: "MMMMdhm"
    }));
    Globalize.a279986385 = dateFormatterFn(Globalize("hi").dateToPartsFormatter({
        skeleton: "MMMMdhm"
    }));
    Globalize.b1235028518 = dateFormatterFn(Globalize("hr").dateToPartsFormatter({
        skeleton: "MMMMdhm"
    }));
    Globalize.a1123278045 = dateFormatterFn(Globalize("hu").dateToPartsFormatter({
        skeleton: "MMMMdhm"
    }));
    Globalize.a2107118315 = dateFormatterFn(Globalize("id").dateToPartsFormatter({
        skeleton: "MMMMdhm"
    }));
    Globalize.b1063460101 = dateFormatterFn(Globalize("it").dateToPartsFormatter({
        skeleton: "MMMMdhm"
    }));
    Globalize.b220168441 = dateFormatterFn(Globalize("ja").dateToPartsFormatter({
        skeleton: "MMMMdhm"
    }));
    Globalize.a513594416 = dateFormatterFn(Globalize("kk").dateToPartsFormatter({
        skeleton: "MMMMdhm"
    }));
    Globalize.a794691636 = dateFormatterFn(Globalize("ko").dateToPartsFormatter({
        skeleton: "MMMMdhm"
    }));
    Globalize.b970400680 = dateFormatterFn(Globalize("lt").dateToPartsFormatter({
        skeleton: "MMMMdhm"
    }));
    Globalize.b829852070 = dateFormatterFn(Globalize("lv").dateToPartsFormatter({
        skeleton: "MMMMdhm"
    }));
    Globalize.a1137828470 = dateFormatterFn(Globalize("ms").dateToPartsFormatter({
        skeleton: "MMMMdhm"
    }));
    Globalize.a2121668740 = dateFormatterFn(Globalize("nb").dateToPartsFormatter({
        skeleton: "MMMMdhm"
    }));
    Globalize.b1470555506 = dateFormatterFn(Globalize("nl").dateToPartsFormatter({
        skeleton: "MMMMdhm"
    }));
    Globalize.b1408515892 = dateFormatterFn(Globalize("pl").dateToPartsFormatter({
        skeleton: "MMMMdhm"
    }));
    Globalize.b846321452 = dateFormatterFn(Globalize("pt").dateToPartsFormatter({
        skeleton: "MMMMdhm"
    }));
    Globalize.a454515013 = dateFormatterFn(Globalize("pt-PT").dateToPartsFormatter({
        skeleton: "MMMMdhm"
    }));
    Globalize.a1011830285 = dateFormatterFn(Globalize("ro").dateToPartsFormatter({
        skeleton: "MMMMdhm"
    }));
    Globalize.a1433476115 = dateFormatterFn(Globalize("ru").dateToPartsFormatter({
        skeleton: "MMMMdhm"
    }));
    Globalize.a761752872 = dateFormatterFn(Globalize("sk").dateToPartsFormatter({
        skeleton: "MMMMdhm"
    }));
    Globalize.b1315456471 = dateFormatterFn(Globalize("sl").dateToPartsFormatter({
        skeleton: "MMMMdhm"
    }));
    Globalize.b1594777898 = dateFormatterFn(Globalize("sr-Cyrl").dateToPartsFormatter({
        skeleton: "MMMMdhm"
    }));
    Globalize.b993751211 = dateFormatterFn(Globalize("sr-Latn").dateToPartsFormatter({
        skeleton: "MMMMdhm"
    }));
    Globalize.b612713421 = dateFormatterFn(Globalize("sv").dateToPartsFormatter({
        skeleton: "MMMMdhm"
    }));
    Globalize.b1565533884 = dateFormatterFn(Globalize("th").dateToPartsFormatter({
        skeleton: "MMMMdhm"
    }));
    Globalize.b862790834 = dateFormatterFn(Globalize("tr").dateToPartsFormatter({
        skeleton: "MMMMdhm"
    }));
    Globalize.a823792486 = dateFormatterFn(Globalize("uk").dateToPartsFormatter({
        skeleton: "MMMMdhm"
    }));
    Globalize.a714263683 = dateFormatterFn(Globalize("vi").dateToPartsFormatter({
        skeleton: "MMMMdhm"
    }));
    Globalize.a156599457 = dateFormatterFn(Globalize("yue").dateToPartsFormatter({
        skeleton: "MMMMdhm"
    }));
    Globalize.a385402293 = dateFormatterFn(Globalize("zh-Hans").dateToPartsFormatter({
        skeleton: "MMMMdhm"
    }));
    Globalize.b136997612 = dateFormatterFn(Globalize("zh-Hans-SG").dateToPartsFormatter({
        skeleton: "MMMMdhm"
    }));
    Globalize.b1691807050 = dateFormatterFn(Globalize("zh-Hant").dateToPartsFormatter({
        skeleton: "MMMMdhm"
    }));
    Globalize.b451854814 = dateFormatterFn(Globalize("zh-Hant-HK").dateToPartsFormatter({
        skeleton: "MMMMdhm"
    }));
    Globalize.b15658559 = dateFormatterFn(Globalize("zh-Hant-MO").dateToPartsFormatter({
        skeleton: "MMMMdhm"
    }));
    Globalize.b1129493863 = relativeTimeFormatterFn(Globalize("ar-EG").numberFormatter({}), Globalize("ar-EG").pluralGenerator({}), {
        "relativeTime-type-future": {
            "relativeTimePattern-count-zero": "خلال {0} ساعة",
            "relativeTimePattern-count-one": "خلال ساعة واحدة",
            "relativeTimePattern-count-two": "خلال ساعتين",
            "relativeTimePattern-count-few": "خلال {0} ساعات",
            "relativeTimePattern-count-many": "خلال {0} ساعة",
            "relativeTimePattern-count-other": "خلال {0} ساعة"
        },
        "relativeTime-type-past": {
            "relativeTimePattern-count-zero": "قبل {0} ساعة",
            "relativeTimePattern-count-one": "قبل ساعة واحدة",
            "relativeTimePattern-count-two": "قبل ساعتين",
            "relativeTimePattern-count-few": "قبل {0} ساعات",
            "relativeTimePattern-count-many": "قبل {0} ساعة",
            "relativeTimePattern-count-other": "قبل {0} ساعة"
        },
        "relative-type-0": "الساعة الحالية"
    });
    Globalize.b318696087 = relativeTimeFormatterFn(Globalize("ar-EG").numberFormatter({}), Globalize("ar-EG").pluralGenerator({}), {
        "relativeTime-type-future": {
            "relativeTimePattern-count-zero": "خلال {0} دقيقة",
            "relativeTimePattern-count-one": "خلال دقيقة واحدة",
            "relativeTimePattern-count-two": "خلال دقيقتين",
            "relativeTimePattern-count-few": "خلال {0} دقائق",
            "relativeTimePattern-count-many": "خلال {0} دقيقة",
            "relativeTimePattern-count-other": "خلال {0} دقيقة"
        },
        "relativeTime-type-past": {
            "relativeTimePattern-count-zero": "قبل {0} دقيقة",
            "relativeTimePattern-count-one": "قبل دقيقة واحدة",
            "relativeTimePattern-count-two": "قبل دقيقتين",
            "relativeTimePattern-count-few": "قبل {0} دقائق",
            "relativeTimePattern-count-many": "قبل {0} دقيقة",
            "relativeTimePattern-count-other": "قبل {0} دقيقة"
        },
        "relative-type-0": "هذه الدقيقة"
    });
    Globalize.b1716664979 = relativeTimeFormatterFn(Globalize("ar-SA").numberFormatter({}), Globalize("ar-SA").pluralGenerator({}), {
        "relativeTime-type-future": {
            "relativeTimePattern-count-zero": "خلال {0} ساعة",
            "relativeTimePattern-count-one": "خلال ساعة واحدة",
            "relativeTimePattern-count-two": "خلال ساعتين",
            "relativeTimePattern-count-few": "خلال {0} ساعات",
            "relativeTimePattern-count-many": "خلال {0} ساعة",
            "relativeTimePattern-count-other": "خلال {0} ساعة"
        },
        "relativeTime-type-past": {
            "relativeTimePattern-count-zero": "قبل {0} ساعة",
            "relativeTimePattern-count-one": "قبل ساعة واحدة",
            "relativeTimePattern-count-two": "قبل ساعتين",
            "relativeTimePattern-count-few": "قبل {0} ساعات",
            "relativeTimePattern-count-many": "قبل {0} ساعة",
            "relativeTimePattern-count-other": "قبل {0} ساعة"
        },
        "relative-type-0": "الساعة الحالية"
    });
    Globalize.b1949422787 = relativeTimeFormatterFn(Globalize("ar-SA").numberFormatter({}), Globalize("ar-SA").pluralGenerator({}), {
        "relativeTime-type-future": {
            "relativeTimePattern-count-zero": "خلال {0} دقيقة",
            "relativeTimePattern-count-one": "خلال دقيقة واحدة",
            "relativeTimePattern-count-two": "خلال دقيقتين",
            "relativeTimePattern-count-few": "خلال {0} دقائق",
            "relativeTimePattern-count-many": "خلال {0} دقيقة",
            "relativeTimePattern-count-other": "خلال {0} دقيقة"
        },
        "relativeTime-type-past": {
            "relativeTimePattern-count-zero": "قبل {0} دقيقة",
            "relativeTimePattern-count-one": "قبل دقيقة واحدة",
            "relativeTimePattern-count-two": "قبل دقيقتين",
            "relativeTimePattern-count-few": "قبل {0} دقائق",
            "relativeTimePattern-count-many": "قبل {0} دقيقة",
            "relativeTimePattern-count-other": "قبل {0} دقيقة"
        },
        "relative-type-0": "هذه الدقيقة"
    });
    Globalize.b1132152016 = relativeTimeFormatterFn(Globalize("bg").numberFormatter({}), Globalize("bg").pluralGenerator({}), {
        "relativeTime-type-future": {
            "relativeTimePattern-count-one": "след {0} час",
            "relativeTimePattern-count-other": "след {0} часа"
        },
        "relativeTime-type-past": {
            "relativeTimePattern-count-one": "преди {0} час",
            "relativeTimePattern-count-other": "преди {0} часа"
        },
        "relative-type-0": "в този час"
    });
    Globalize.a1421786176 = relativeTimeFormatterFn(Globalize("bg").numberFormatter({}), Globalize("bg").pluralGenerator({}), {
        "relativeTime-type-future": {
            "relativeTimePattern-count-one": "след {0} минута",
            "relativeTimePattern-count-other": "след {0} минути"
        },
        "relativeTime-type-past": {
            "relativeTimePattern-count-one": "преди {0} минута",
            "relativeTimePattern-count-other": "преди {0} минути"
        },
        "relative-type-0": "в тази минута"
    });
    Globalize.a2094915959 = relativeTimeFormatterFn(Globalize("ca").numberFormatter({}), Globalize("ca").pluralGenerator({}), {
        "relativeTime-type-future": {
            "relativeTimePattern-count-one": "d’aqu\xed a {0} hora",
            "relativeTimePattern-count-other": "d’aqu\xed a {0} hores"
        },
        "relativeTime-type-past": {
            "relativeTimePattern-count-one": "fa {0} hora",
            "relativeTimePattern-count-other": "fa {0} hores"
        },
        "relative-type-0": "aquesta hora"
    });
    Globalize.a1667722439 = relativeTimeFormatterFn(Globalize("ca").numberFormatter({}), Globalize("ca").pluralGenerator({}), {
        "relativeTime-type-future": {
            "relativeTimePattern-count-one": "d’aqu\xed a {0} minut",
            "relativeTimePattern-count-other": "d’aqu\xed a {0} minuts"
        },
        "relativeTime-type-past": {
            "relativeTimePattern-count-one": "fa {0} minut",
            "relativeTimePattern-count-other": "fa {0} minuts"
        },
        "relative-type-0": "aquest minut"
    });
    Globalize.a123437605 = relativeTimeFormatterFn(Globalize("cs").numberFormatter({}), Globalize("cs").pluralGenerator({}), {
        "relativeTime-type-future": {
            "relativeTimePattern-count-one": "za {0} hodinu",
            "relativeTimePattern-count-few": "za {0} hodiny",
            "relativeTimePattern-count-many": "za {0} hodiny",
            "relativeTimePattern-count-other": "za {0} hodin"
        },
        "relativeTime-type-past": {
            "relativeTimePattern-count-one": "před {0} hodinou",
            "relativeTimePattern-count-few": "před {0} hodinami",
            "relativeTimePattern-count-many": "před {0} hodiny",
            "relativeTimePattern-count-other": "před {0} hodinami"
        },
        "relative-type-0": "tuto hodinu"
    });
    Globalize.a1157601781 = relativeTimeFormatterFn(Globalize("cs").numberFormatter({}), Globalize("cs").pluralGenerator({}), {
        "relativeTime-type-future": {
            "relativeTimePattern-count-one": "za {0} minutu",
            "relativeTimePattern-count-few": "za {0} minuty",
            "relativeTimePattern-count-many": "za {0} minuty",
            "relativeTimePattern-count-other": "za {0} minut"
        },
        "relativeTime-type-past": {
            "relativeTimePattern-count-one": "před {0} minutou",
            "relativeTimePattern-count-few": "před {0} minutami",
            "relativeTimePattern-count-many": "před {0} minuty",
            "relativeTimePattern-count-other": "před {0} minutami"
        },
        "relative-type-0": "tuto minutu"
    });
    Globalize.a1801512952 = relativeTimeFormatterFn(Globalize("da").numberFormatter({}), Globalize("da").pluralGenerator({}), {
        "relativeTime-type-future": {
            "relativeTimePattern-count-one": "om {0} time",
            "relativeTimePattern-count-other": "om {0} timer"
        },
        "relativeTime-type-past": {
            "relativeTimePattern-count-one": "for {0} time siden",
            "relativeTimePattern-count-other": "for {0} timer siden"
        },
        "relative-type-0": "i den kommende time"
    });
    Globalize.b1119693048 = relativeTimeFormatterFn(Globalize("da").numberFormatter({}), Globalize("da").pluralGenerator({}), {
        "relativeTime-type-future": {
            "relativeTimePattern-count-one": "om {0} minut",
            "relativeTimePattern-count-other": "om {0} minutter"
        },
        "relativeTime-type-past": {
            "relativeTimePattern-count-one": "for {0} minut siden",
            "relativeTimePattern-count-other": "for {0} minutter siden"
        },
        "relative-type-0": "i det kommende minut"
    });
    Globalize.b1977123468 = relativeTimeFormatterFn(Globalize("de").numberFormatter({}), Globalize("de").pluralGenerator({}), {
        "relativeTime-type-future": {
            "relativeTimePattern-count-one": "in {0} Stunde",
            "relativeTimePattern-count-other": "in {0} Stunden"
        },
        "relativeTime-type-past": {
            "relativeTimePattern-count-one": "vor {0} Stunde",
            "relativeTimePattern-count-other": "vor {0} Stunden"
        },
        "relative-type-0": "in dieser Stunde"
    });
    Globalize.a1153039748 = relativeTimeFormatterFn(Globalize("de").numberFormatter({}), Globalize("de").pluralGenerator({}), {
        "relativeTime-type-future": {
            "relativeTimePattern-count-one": "in {0} Minute",
            "relativeTimePattern-count-other": "in {0} Minuten"
        },
        "relativeTime-type-past": {
            "relativeTimePattern-count-one": "vor {0} Minute",
            "relativeTimePattern-count-other": "vor {0} Minuten"
        },
        "relative-type-0": "in dieser Minute"
    });
    Globalize.b1366947442 = relativeTimeFormatterFn(Globalize("el").numberFormatter({}), Globalize("el").pluralGenerator({}), {
        "relativeTime-type-future": {
            "relativeTimePattern-count-one": "σε {0} ώρα",
            "relativeTimePattern-count-other": "σε {0} ώρες"
        },
        "relativeTime-type-past": {
            "relativeTimePattern-count-one": "πριν από {0} ώρα",
            "relativeTimePattern-count-other": "πριν από {0} ώρες"
        },
        "relative-type-0": "τρέχουσα ώρα"
    });
    Globalize.b878318818 = relativeTimeFormatterFn(Globalize("el").numberFormatter({}), Globalize("el").pluralGenerator({}), {
        "relativeTime-type-future": {
            "relativeTimePattern-count-one": "σε {0} λεπτό",
            "relativeTimePattern-count-other": "σε {0} λεπτά"
        },
        "relativeTime-type-past": {
            "relativeTimePattern-count-one": "πριν από {0} λεπτό",
            "relativeTimePattern-count-other": "πριν από {0} λεπτά"
        },
        "relative-type-0": "τρέχον λεπτό"
    });
    Globalize.b1108782004 = relativeTimeFormatterFn(Globalize("en").numberFormatter({}), Globalize("en").pluralGenerator({}), {
        "relativeTime-type-future": {
            "relativeTimePattern-count-one": "in {0} hour",
            "relativeTimePattern-count-other": "in {0} hours"
        },
        "relativeTime-type-past": {
            "relativeTimePattern-count-one": "{0} hour ago",
            "relativeTimePattern-count-other": "{0} hours ago"
        },
        "relative-type-0": "this hour"
    });
    Globalize.b1889436068 = relativeTimeFormatterFn(Globalize("en").numberFormatter({}), Globalize("en").pluralGenerator({}), {
        "relativeTime-type-future": {
            "relativeTimePattern-count-one": "in {0} minute",
            "relativeTimePattern-count-other": "in {0} minutes"
        },
        "relativeTime-type-past": {
            "relativeTimePattern-count-one": "{0} minute ago",
            "relativeTimePattern-count-other": "{0} minutes ago"
        },
        "relative-type-0": "this minute"
    });
    Globalize.b463368409 = relativeTimeFormatterFn(Globalize("es").numberFormatter({}), Globalize("es").pluralGenerator({}), {
        "relativeTime-type-future": {
            "relativeTimePattern-count-one": "dentro de {0} hora",
            "relativeTimePattern-count-other": "dentro de {0} horas"
        },
        "relativeTime-type-past": {
            "relativeTimePattern-count-one": "hace {0} hora",
            "relativeTimePattern-count-other": "hace {0} horas"
        },
        "relative-type-0": "esta hora"
    });
    Globalize.b122261897 = relativeTimeFormatterFn(Globalize("es").numberFormatter({}), Globalize("es").pluralGenerator({}), {
        "relativeTime-type-future": {
            "relativeTimePattern-count-one": "dentro de {0} minuto",
            "relativeTimePattern-count-other": "dentro de {0} minutos"
        },
        "relativeTime-type-past": {
            "relativeTimePattern-count-one": "hace {0} minuto",
            "relativeTimePattern-count-other": "hace {0} minutos"
        },
        "relative-type-0": "este minuto"
    });
    Globalize.b334285690 = relativeTimeFormatterFn(Globalize("et").numberFormatter({}), Globalize("et").pluralGenerator({}), {
        "relativeTime-type-future": {
            "relativeTimePattern-count-one": "{0} tunni p\xe4rast",
            "relativeTimePattern-count-other": "{0} tunni p\xe4rast"
        },
        "relativeTime-type-past": {
            "relativeTimePattern-count-one": "{0} tunni eest",
            "relativeTimePattern-count-other": "{0} tunni eest"
        },
        "relative-type-0": "praegusel tunnil"
    });
    Globalize.b627820522 = relativeTimeFormatterFn(Globalize("et").numberFormatter({}), Globalize("et").pluralGenerator({}), {
        "relativeTime-type-future": {
            "relativeTimePattern-count-one": "{0} minuti p\xe4rast",
            "relativeTimePattern-count-other": "{0} minuti p\xe4rast"
        },
        "relativeTime-type-past": {
            "relativeTimePattern-count-one": "{0} minuti eest",
            "relativeTimePattern-count-other": "{0} minuti eest"
        },
        "relative-type-0": "praegusel minutil"
    });
    Globalize.b205202971 = relativeTimeFormatterFn(Globalize("eu").numberFormatter({}), Globalize("eu").pluralGenerator({}), {
        "relativeTime-type-future": {
            "relativeTimePattern-count-one": "{0} ordu barru",
            "relativeTimePattern-count-other": "{0} ordu barru"
        },
        "relativeTime-type-past": {
            "relativeTimePattern-count-one": "Duela {0} ordu",
            "relativeTimePattern-count-other": "Duela {0} ordu"
        },
        "relative-type-0": "ordu honetan"
    });
    Globalize.b1133379147 = relativeTimeFormatterFn(Globalize("eu").numberFormatter({}), Globalize("eu").pluralGenerator({}), {
        "relativeTime-type-future": {
            "relativeTimePattern-count-one": "{0} minutu barru",
            "relativeTimePattern-count-other": "{0} minutu barru"
        },
        "relativeTime-type-past": {
            "relativeTimePattern-count-one": "Duela {0} minutu",
            "relativeTimePattern-count-other": "Duela {0} minutu"
        },
        "relative-type-0": "minutu honetan"
    });
    Globalize.b2047598606 = relativeTimeFormatterFn(Globalize("fi").numberFormatter({}), Globalize("fi").pluralGenerator({}), {
        "relativeTime-type-future": {
            "relativeTimePattern-count-one": "{0} tunnin p\xe4\xe4st\xe4",
            "relativeTimePattern-count-other": "{0} tunnin p\xe4\xe4st\xe4"
        },
        "relativeTime-type-past": {
            "relativeTimePattern-count-one": "{0} tunti sitten",
            "relativeTimePattern-count-other": "{0} tuntia sitten"
        },
        "relative-type-0": "t\xe4m\xe4n tunnin aikana"
    });
    Globalize.a2145908866 = relativeTimeFormatterFn(Globalize("fi").numberFormatter({}), Globalize("fi").pluralGenerator({}), {
        "relativeTime-type-future": {
            "relativeTimePattern-count-one": "{0} minuutin p\xe4\xe4st\xe4",
            "relativeTimePattern-count-other": "{0} minuutin p\xe4\xe4st\xe4"
        },
        "relativeTime-type-past": {
            "relativeTimePattern-count-one": "{0} minuutti sitten",
            "relativeTimePattern-count-other": "{0} minuuttia sitten"
        },
        "relative-type-0": "t\xe4m\xe4n minuutin aikana"
    });
    Globalize.b885854135 = relativeTimeFormatterFn(Globalize("fr").numberFormatter({}), Globalize("fr").pluralGenerator({}), {
        "relativeTime-type-future": {
            "relativeTimePattern-count-one": "dans {0} heure",
            "relativeTimePattern-count-other": "dans {0} heures"
        },
        "relativeTime-type-past": {
            "relativeTimePattern-count-one": "il y a {0} heure",
            "relativeTimePattern-count-other": "il y a {0} heures"
        },
        "relative-type-0": "cette heure-ci"
    });
    Globalize.a1890848537 = relativeTimeFormatterFn(Globalize("fr").numberFormatter({}), Globalize("fr").pluralGenerator({}), {
        "relativeTime-type-future": {
            "relativeTimePattern-count-one": "dans {0} minute",
            "relativeTimePattern-count-other": "dans {0} minutes"
        },
        "relativeTime-type-past": {
            "relativeTimePattern-count-one": "il y a {0} minute",
            "relativeTimePattern-count-other": "il y a {0} minutes"
        },
        "relative-type-0": "cette minute-ci"
    });
    Globalize.b1953753456 = relativeTimeFormatterFn(Globalize("gl").numberFormatter({}), Globalize("gl").pluralGenerator({}), {
        "relativeTime-type-future": {
            "relativeTimePattern-count-one": "en {0} hora",
            "relativeTimePattern-count-other": "en {0} horas"
        },
        "relativeTime-type-past": {
            "relativeTimePattern-count-one": "hai {0} hora",
            "relativeTimePattern-count-other": "hai {0} horas"
        },
        "relative-type-0": "esta hora"
    });
    Globalize.a2136784800 = relativeTimeFormatterFn(Globalize("gl").numberFormatter({}), Globalize("gl").pluralGenerator({}), {
        "relativeTime-type-future": {
            "relativeTimePattern-count-one": "en {0} minuto",
            "relativeTimePattern-count-other": "en {0} minutos"
        },
        "relativeTime-type-past": {
            "relativeTimePattern-count-one": "hai {0} minuto",
            "relativeTimePattern-count-other": "hai {0} minutos"
        },
        "relative-type-0": "este minuto"
    });
    Globalize.a1144231800 = relativeTimeFormatterFn(Globalize("he").numberFormatter({}), Globalize("he").pluralGenerator({}), {
        "relativeTime-type-future": {
            "relativeTimePattern-count-one": "בעוד שעה",
            "relativeTimePattern-count-two": "בעוד שעתיים",
            "relativeTimePattern-count-many": "בעוד {0} שעות",
            "relativeTimePattern-count-other": "בעוד {0} שעות"
        },
        "relativeTime-type-past": {
            "relativeTimePattern-count-one": "לפני שעה",
            "relativeTimePattern-count-two": "לפני שעתיים",
            "relativeTimePattern-count-many": "לפני {0} שעות",
            "relativeTimePattern-count-other": "לפני {0} שעות"
        },
        "relative-type-0": "בשעה זו"
    });
    Globalize.b1406687608 = relativeTimeFormatterFn(Globalize("he").numberFormatter({}), Globalize("he").pluralGenerator({}), {
        "relativeTime-type-future": {
            "relativeTimePattern-count-one": "בעוד דקה",
            "relativeTimePattern-count-two": "בעוד שתי דקות",
            "relativeTimePattern-count-many": "בעוד {0} דקות",
            "relativeTimePattern-count-other": "בעוד {0} דקות"
        },
        "relativeTime-type-past": {
            "relativeTimePattern-count-one": "לפני דקה",
            "relativeTimePattern-count-two": "לפני שתי דקות",
            "relativeTimePattern-count-many": "לפני {0} דקות",
            "relativeTimePattern-count-other": "לפני {0} דקות"
        },
        "relative-type-0": "בדקה זו"
    });
    Globalize.a1660562676 = relativeTimeFormatterFn(Globalize("hi").numberFormatter({}), Globalize("hi").pluralGenerator({}), {
        "relativeTime-type-future": {
            "relativeTimePattern-count-one": "{0} घंटे में",
            "relativeTimePattern-count-other": "{0} घंटे में"
        },
        "relativeTime-type-past": {
            "relativeTimePattern-count-one": "{0} घंटे पहले",
            "relativeTimePattern-count-other": "{0} घंटे पहले"
        },
        "relative-type-0": "यह घंटा"
    });
    Globalize.a866045188 = relativeTimeFormatterFn(Globalize("hi").numberFormatter({}), Globalize("hi").pluralGenerator({}), {
        "relativeTime-type-future": {
            "relativeTimePattern-count-one": "{0} मिनट में",
            "relativeTimePattern-count-other": "{0} मिनट में"
        },
        "relativeTime-type-past": {
            "relativeTimePattern-count-one": "{0} मिनट पहले",
            "relativeTimePattern-count-other": "{0} मिनट पहले"
        },
        "relative-type-0": "यह मिनट"
    });
    Globalize.b1472660149 = relativeTimeFormatterFn(Globalize("hr").numberFormatter({}), Globalize("hr").pluralGenerator({}), {
        "relativeTime-type-future": {
            "relativeTimePattern-count-one": "za {0} sat",
            "relativeTimePattern-count-few": "za {0} sata",
            "relativeTimePattern-count-other": "za {0} sati"
        },
        "relativeTime-type-past": {
            "relativeTimePattern-count-one": "prije {0} sat",
            "relativeTimePattern-count-few": "prije {0} sata",
            "relativeTimePattern-count-other": "prije {0} sati"
        },
        "relative-type-0": "ovaj sat"
    });
    Globalize.a610984859 = relativeTimeFormatterFn(Globalize("hr").numberFormatter({}), Globalize("hr").pluralGenerator({}), {
        "relativeTime-type-future": {
            "relativeTimePattern-count-one": "za {0} minutu",
            "relativeTimePattern-count-few": "za {0} minute",
            "relativeTimePattern-count-other": "za {0} minuta"
        },
        "relativeTime-type-past": {
            "relativeTimePattern-count-one": "prije {0} minutu",
            "relativeTimePattern-count-few": "prije {0} minute",
            "relativeTimePattern-count-other": "prije {0} minuta"
        },
        "relative-type-0": "ova minuta"
    });
    Globalize.b1085411992 = relativeTimeFormatterFn(Globalize("hu").numberFormatter({}), Globalize("hu").pluralGenerator({}), {
        "relativeTime-type-future": {
            "relativeTimePattern-count-one": "{0} \xf3ra m\xfalva",
            "relativeTimePattern-count-other": "{0} \xf3ra m\xfalva"
        },
        "relativeTime-type-past": {
            "relativeTimePattern-count-one": "{0} \xf3r\xe1val ezelőtt",
            "relativeTimePattern-count-other": "{0} \xf3r\xe1val ezelőtt"
        },
        "relative-type-0": "ebben az \xf3r\xe1ban"
    });
    Globalize.b905691016 = relativeTimeFormatterFn(Globalize("hu").numberFormatter({}), Globalize("hu").pluralGenerator({}), {
        "relativeTime-type-future": {
            "relativeTimePattern-count-one": "{0} perc m\xfalva",
            "relativeTimePattern-count-other": "{0} perc m\xfalva"
        },
        "relativeTime-type-past": {
            "relativeTimePattern-count-one": "{0} perccel ezelőtt",
            "relativeTimePattern-count-other": "{0} perccel ezelőtt"
        },
        "relative-type-0": "ebben a percben"
    });
    Globalize.a721746074 = relativeTimeFormatterFn(Globalize("id").numberFormatter({}), Globalize("id").pluralGenerator({}), {
        "relativeTime-type-future": {
            "relativeTimePattern-count-other": "dalam {0} jam"
        },
        "relativeTime-type-past": {
            "relativeTimePattern-count-other": "{0} jam yang lalu"
        },
        "relative-type-0": "jam ini"
    });
    Globalize.a606422826 = relativeTimeFormatterFn(Globalize("id").numberFormatter({}), Globalize("id").pluralGenerator({}), {
        "relativeTime-type-future": {
            "relativeTimePattern-count-other": "dalam {0} menit"
        },
        "relativeTime-type-past": {
            "relativeTimePattern-count-other": "{0} menit yang lalu"
        },
        "relative-type-0": "menit ini"
    });
    Globalize.b1507897718 = relativeTimeFormatterFn(Globalize("it").numberFormatter({}), Globalize("it").pluralGenerator({}), {
        "relativeTime-type-future": {
            "relativeTimePattern-count-one": "tra {0} ora",
            "relativeTimePattern-count-other": "tra {0} ore"
        },
        "relativeTime-type-past": {
            "relativeTimePattern-count-one": "{0} ora fa",
            "relativeTimePattern-count-other": "{0} ore fa"
        },
        "relative-type-0": "quest’ora"
    });
    Globalize.a1107419418 = relativeTimeFormatterFn(Globalize("it").numberFormatter({}), Globalize("it").pluralGenerator({}), {
        "relativeTime-type-future": {
            "relativeTimePattern-count-one": "tra {0} minuto",
            "relativeTimePattern-count-other": "tra {0} minuti"
        },
        "relativeTime-type-past": {
            "relativeTimePattern-count-one": "{0} minuto fa",
            "relativeTimePattern-count-other": "{0} minuti fa"
        },
        "relative-type-0": "questo minuto"
    });
    Globalize.a41094910 = relativeTimeFormatterFn(Globalize("ja").numberFormatter({}), Globalize("ja").pluralGenerator({}), {
        "relativeTime-type-future": {
            "relativeTimePattern-count-other": "{0} 時間後"
        },
        "relativeTime-type-past": {
            "relativeTimePattern-count-other": "{0} 時間前"
        },
        "relative-type-0": "1 時間以内"
    });
    Globalize.b664316786 = relativeTimeFormatterFn(Globalize("ja").numberFormatter({}), Globalize("ja").pluralGenerator({}), {
        "relativeTime-type-future": {
            "relativeTimePattern-count-other": "{0} 分後"
        },
        "relativeTime-type-past": {
            "relativeTimePattern-count-other": "{0} 分前"
        },
        "relative-type-0": "1 分以内"
    });
    Globalize.a1038519093 = relativeTimeFormatterFn(Globalize("kk").numberFormatter({}), Globalize("kk").pluralGenerator({}), {
        "relativeTime-type-future": {
            "relativeTimePattern-count-one": "{0} сағаттан кейін",
            "relativeTimePattern-count-other": "{0} сағаттан кейін"
        },
        "relativeTime-type-past": {
            "relativeTimePattern-count-one": "{0} сағат бұрын",
            "relativeTimePattern-count-other": "{0} сағат бұрын"
        },
        "relative-type-0": "осы сағат"
    });
    Globalize.a82616069 = relativeTimeFormatterFn(Globalize("kk").numberFormatter({}), Globalize("kk").pluralGenerator({}), {
        "relativeTime-type-future": {
            "relativeTimePattern-count-one": "{0} минуттан кейін",
            "relativeTimePattern-count-other": "{0} минуттан кейін"
        },
        "relativeTime-type-past": {
            "relativeTimePattern-count-one": "{0} минут бұрын",
            "relativeTimePattern-count-other": "{0} минут бұрын"
        },
        "relative-type-0": "осы минут"
    });
    Globalize.a1554849969 = relativeTimeFormatterFn(Globalize("ko").numberFormatter({}), Globalize("ko").pluralGenerator({}), {
        "relativeTime-type-future": {
            "relativeTimePattern-count-other": "{0}시간 후"
        },
        "relativeTime-type-past": {
            "relativeTimePattern-count-other": "{0}시간 전"
        },
        "relative-type-0": "현재 시간"
    });
    Globalize.b1939618431 = relativeTimeFormatterFn(Globalize("ko").numberFormatter({}), Globalize("ko").pluralGenerator({}), {
        "relativeTime-type-future": {
            "relativeTimePattern-count-other": "{0}분 후"
        },
        "relativeTime-type-past": {
            "relativeTimePattern-count-other": "{0}분 전"
        },
        "relative-type-0": "현재 분"
    });
    Globalize.a1906860557 = relativeTimeFormatterFn(Globalize("lt").numberFormatter({}), Globalize("lt").pluralGenerator({}), {
        "relativeTime-type-future": {
            "relativeTimePattern-count-one": "po {0} valandos",
            "relativeTimePattern-count-few": "po {0} valandų",
            "relativeTimePattern-count-many": "po {0} valandos",
            "relativeTimePattern-count-other": "po {0} valandų"
        },
        "relativeTime-type-past": {
            "relativeTimePattern-count-one": "prieš {0} valandą",
            "relativeTimePattern-count-few": "prieš {0} valandas",
            "relativeTimePattern-count-many": "prieš {0} valandos",
            "relativeTimePattern-count-other": "prieš {0} valandų"
        },
        "relative-type-0": "šią valandą"
    });
    Globalize.a1335107549 = relativeTimeFormatterFn(Globalize("lt").numberFormatter({}), Globalize("lt").pluralGenerator({}), {
        "relativeTime-type-future": {
            "relativeTimePattern-count-one": "po {0} minutės",
            "relativeTimePattern-count-few": "po {0} minučių",
            "relativeTimePattern-count-many": "po {0} minutės",
            "relativeTimePattern-count-other": "po {0} minučių"
        },
        "relativeTime-type-past": {
            "relativeTimePattern-count-one": "prieš {0} minutę",
            "relativeTimePattern-count-few": "prieš {0} minutes",
            "relativeTimePattern-count-many": "prieš {0} minutės",
            "relativeTimePattern-count-other": "prieš {0} minučių"
        },
        "relative-type-0": "šią minutę"
    });
    Globalize.b2129941301 = relativeTimeFormatterFn(Globalize("lv").numberFormatter({}), Globalize("lv").pluralGenerator({}), {
        "relativeTime-type-future": {
            "relativeTimePattern-count-zero": "pēc {0} stundām",
            "relativeTimePattern-count-one": "pēc {0} stundas",
            "relativeTimePattern-count-other": "pēc {0} stundām"
        },
        "relativeTime-type-past": {
            "relativeTimePattern-count-zero": "pirms {0} stundām",
            "relativeTimePattern-count-one": "pirms {0} stundas",
            "relativeTimePattern-count-other": "pirms {0} stundām"
        },
        "relative-type-0": "šajā stundā"
    });
    Globalize.a323990299 = relativeTimeFormatterFn(Globalize("lv").numberFormatter({}), Globalize("lv").pluralGenerator({}), {
        "relativeTime-type-future": {
            "relativeTimePattern-count-zero": "pēc {0} minūtēm",
            "relativeTimePattern-count-one": "pēc {0} minūtes",
            "relativeTimePattern-count-other": "pēc {0} minūtēm"
        },
        "relativeTime-type-past": {
            "relativeTimePattern-count-zero": "pirms {0} minūtēm",
            "relativeTimePattern-count-one": "pirms {0} minūtes",
            "relativeTimePattern-count-other": "pirms {0} minūtēm"
        },
        "relative-type-0": "šajā minūtē"
    });
    Globalize.a1484374831 = relativeTimeFormatterFn(Globalize("ms").numberFormatter({}), Globalize("ms").pluralGenerator({}), {
        "relativeTime-type-future": {
            "relativeTimePattern-count-other": "dalam {0} jam"
        },
        "relativeTime-type-past": {
            "relativeTimePattern-count-other": "{0} jam lalu"
        },
        "relative-type-0": "jam ini"
    });
    Globalize.b946749313 = relativeTimeFormatterFn(Globalize("ms").numberFormatter({}), Globalize("ms").pluralGenerator({}), {
        "relativeTime-type-future": {
            "relativeTimePattern-count-other": "dalam {0} minit"
        },
        "relativeTime-type-past": {
            "relativeTimePattern-count-other": "{0} minit lalu"
        },
        "relative-type-0": "pada minit ini"
    });
    Globalize.b1003434399 = relativeTimeFormatterFn(Globalize("nb").numberFormatter({}), Globalize("nb").pluralGenerator({}), {
        "relativeTime-type-future": {
            "relativeTimePattern-count-one": "om {0} time",
            "relativeTimePattern-count-other": "om {0} timer"
        },
        "relativeTime-type-past": {
            "relativeTimePattern-count-one": "for {0} time siden",
            "relativeTimePattern-count-other": "for {0} timer siden"
        },
        "relative-type-0": "denne timen"
    });
    Globalize.a565364529 = relativeTimeFormatterFn(Globalize("nb").numberFormatter({}), Globalize("nb").pluralGenerator({}), {
        "relativeTime-type-future": {
            "relativeTimePattern-count-one": "om {0} minutt",
            "relativeTimePattern-count-other": "om {0} minutter"
        },
        "relativeTime-type-past": {
            "relativeTimePattern-count-one": "for {0} minutt siden",
            "relativeTimePattern-count-other": "for {0} minutter siden"
        },
        "relative-type-0": "dette minuttet"
    });
    Globalize.a287392791 = relativeTimeFormatterFn(Globalize("nl").numberFormatter({}), Globalize("nl").pluralGenerator({}), {
        "relativeTime-type-future": {
            "relativeTimePattern-count-one": "over {0} uur",
            "relativeTimePattern-count-other": "over {0} uur"
        },
        "relativeTime-type-past": {
            "relativeTimePattern-count-one": "{0} uur geleden",
            "relativeTimePattern-count-other": "{0} uur geleden"
        },
        "relative-type-0": "binnen een uur"
    });
    Globalize.b195254425 = relativeTimeFormatterFn(Globalize("nl").numberFormatter({}), Globalize("nl").pluralGenerator({}), {
        "relativeTime-type-future": {
            "relativeTimePattern-count-one": "over {0} minuut",
            "relativeTimePattern-count-other": "over {0} minuten"
        },
        "relativeTime-type-past": {
            "relativeTimePattern-count-one": "{0} minuut geleden",
            "relativeTimePattern-count-other": "{0} minuten geleden"
        },
        "relative-type-0": "binnen een minuut"
    });
    Globalize.b299413223 = relativeTimeFormatterFn(Globalize("pl").numberFormatter({}), Globalize("pl").pluralGenerator({}), {
        "relativeTime-type-future": {
            "relativeTimePattern-count-one": "za {0} godzinę",
            "relativeTimePattern-count-few": "za {0} godziny",
            "relativeTimePattern-count-many": "za {0} godzin",
            "relativeTimePattern-count-other": "za {0} godziny"
        },
        "relativeTime-type-past": {
            "relativeTimePattern-count-one": "{0} godzinę temu",
            "relativeTimePattern-count-few": "{0} godziny temu",
            "relativeTimePattern-count-many": "{0} godzin temu",
            "relativeTimePattern-count-other": "{0} godziny temu"
        },
        "relative-type-0": "ta godzina"
    });
    Globalize.b1475118103 = relativeTimeFormatterFn(Globalize("pl").numberFormatter({}), Globalize("pl").pluralGenerator({}), {
        "relativeTime-type-future": {
            "relativeTimePattern-count-one": "za {0} minutę",
            "relativeTimePattern-count-few": "za {0} minuty",
            "relativeTimePattern-count-many": "za {0} minut",
            "relativeTimePattern-count-other": "za {0} minuty"
        },
        "relativeTime-type-past": {
            "relativeTimePattern-count-one": "{0} minutę temu",
            "relativeTimePattern-count-few": "{0} minuty temu",
            "relativeTimePattern-count-many": "{0} minut temu",
            "relativeTimePattern-count-other": "{0} minuty temu"
        },
        "relative-type-0": "ta minuta"
    });
    Globalize.a733248529 = relativeTimeFormatterFn(Globalize("pt").numberFormatter({}), Globalize("pt").pluralGenerator({}), {
        "relativeTime-type-future": {
            "relativeTimePattern-count-one": "em {0} hora",
            "relativeTimePattern-count-other": "em {0} horas"
        },
        "relativeTime-type-past": {
            "relativeTimePattern-count-one": "h\xe1 {0} hora",
            "relativeTimePattern-count-other": "h\xe1 {0} horas"
        },
        "relative-type-0": "esta hora"
    });
    Globalize.b1224619807 = relativeTimeFormatterFn(Globalize("pt").numberFormatter({}), Globalize("pt").pluralGenerator({}), {
        "relativeTime-type-future": {
            "relativeTimePattern-count-one": "em {0} minuto",
            "relativeTimePattern-count-other": "em {0} minutos"
        },
        "relativeTime-type-past": {
            "relativeTimePattern-count-one": "h\xe1 {0} minuto",
            "relativeTimePattern-count-other": "h\xe1 {0} minutos"
        },
        "relative-type-0": "este minuto"
    });
    Globalize.a1268173962 = relativeTimeFormatterFn(Globalize("pt-PT").numberFormatter({}), Globalize("pt-PT").pluralGenerator({}), {
        "relativeTime-type-future": {
            "relativeTimePattern-count-one": "dentro de {0} hora",
            "relativeTimePattern-count-other": "dentro de {0} horas"
        },
        "relativeTime-type-past": {
            "relativeTimePattern-count-one": "h\xe1 {0} hora",
            "relativeTimePattern-count-other": "h\xe1 {0} horas"
        },
        "relative-type-0": "esta hora"
    });
    Globalize.a1737613082 = relativeTimeFormatterFn(Globalize("pt-PT").numberFormatter({}), Globalize("pt-PT").pluralGenerator({}), {
        "relativeTime-type-future": {
            "relativeTimePattern-count-one": "dentro de {0} minuto",
            "relativeTimePattern-count-other": "dentro de {0} minutos"
        },
        "relativeTime-type-past": {
            "relativeTimePattern-count-one": "h\xe1 {0} minuto",
            "relativeTimePattern-count-other": "h\xe1 {0} minutos"
        },
        "relative-type-0": "este minuto"
    });
    Globalize.b498971080 = relativeTimeFormatterFn(Globalize("ro").numberFormatter({}), Globalize("ro").pluralGenerator({}), {
        "relativeTime-type-future": {
            "relativeTimePattern-count-one": "peste {0} oră",
            "relativeTimePattern-count-few": "peste {0} ore",
            "relativeTimePattern-count-other": "peste {0} de ore"
        },
        "relativeTime-type-past": {
            "relativeTimePattern-count-one": "acum {0} oră",
            "relativeTimePattern-count-few": "acum {0} ore",
            "relativeTimePattern-count-other": "acum {0} de ore"
        },
        "relative-type-0": "ora aceasta"
    });
    Globalize.a23309640 = relativeTimeFormatterFn(Globalize("ro").numberFormatter({}), Globalize("ro").pluralGenerator({}), {
        "relativeTime-type-future": {
            "relativeTimePattern-count-one": "peste {0} minut",
            "relativeTimePattern-count-few": "peste {0} minute",
            "relativeTimePattern-count-other": "peste {0} de minute"
        },
        "relativeTime-type-past": {
            "relativeTimePattern-count-one": "acum {0} minut",
            "relativeTimePattern-count-few": "acum {0} minute",
            "relativeTimePattern-count-other": "acum {0} de minute"
        },
        "relative-type-0": "minutul acesta"
    });
    Globalize.a275525234 = relativeTimeFormatterFn(Globalize("ru").numberFormatter({}), Globalize("ru").pluralGenerator({}), {
        "relativeTime-type-future": {
            "relativeTimePattern-count-one": "через {0} час",
            "relativeTimePattern-count-few": "через {0} часа",
            "relativeTimePattern-count-many": "через {0} часов",
            "relativeTimePattern-count-other": "через {0} часа"
        },
        "relativeTime-type-past": {
            "relativeTimePattern-count-one": "{0} час назад",
            "relativeTimePattern-count-few": "{0} часа назад",
            "relativeTimePattern-count-many": "{0} часов назад",
            "relativeTimePattern-count-other": "{0} часа назад"
        },
        "relative-type-0": "в этот час"
    });
    Globalize.a1284925186 = relativeTimeFormatterFn(Globalize("ru").numberFormatter({}), Globalize("ru").pluralGenerator({}), {
        "relativeTime-type-future": {
            "relativeTimePattern-count-one": "через {0} минуту",
            "relativeTimePattern-count-few": "через {0} минуты",
            "relativeTimePattern-count-many": "через {0} минут",
            "relativeTimePattern-count-other": "через {0} минуты"
        },
        "relativeTime-type-past": {
            "relativeTimePattern-count-one": "{0} минуту назад",
            "relativeTimePattern-count-few": "{0} минуты назад",
            "relativeTimePattern-count-many": "{0} минут назад",
            "relativeTimePattern-count-other": "{0} минуты назад"
        },
        "relative-type-0": "в эту минуту"
    });
    Globalize.b1308704963 = relativeTimeFormatterFn(Globalize("sk").numberFormatter({}), Globalize("sk").pluralGenerator({}), {
        "relativeTime-type-future": {
            "relativeTimePattern-count-one": "o {0} hodinu",
            "relativeTimePattern-count-few": "o {0} hodiny",
            "relativeTimePattern-count-many": "o {0} hodiny",
            "relativeTimePattern-count-other": "o {0} hod\xedn"
        },
        "relativeTime-type-past": {
            "relativeTimePattern-count-one": "pred {0} hodinou",
            "relativeTimePattern-count-few": "pred {0} hodinami",
            "relativeTimePattern-count-many": "pred {0} hodinou",
            "relativeTimePattern-count-other": "pred {0} hodinami"
        },
        "relative-type-0": "v tejto hodine"
    });
    Globalize.b741871347 = relativeTimeFormatterFn(Globalize("sk").numberFormatter({}), Globalize("sk").pluralGenerator({}), {
        "relativeTime-type-future": {
            "relativeTimePattern-count-one": "o {0} min\xfatu",
            "relativeTimePattern-count-few": "o {0} min\xfaty",
            "relativeTimePattern-count-many": "o {0} min\xfaty",
            "relativeTimePattern-count-other": "o {0} min\xfat"
        },
        "relativeTime-type-past": {
            "relativeTimePattern-count-one": "pred {0} min\xfatou",
            "relativeTimePattern-count-few": "pred {0} min\xfatami",
            "relativeTimePattern-count-many": "pred {0} min\xfaty",
            "relativeTimePattern-count-other": "pred {0} min\xfatami"
        },
        "relative-type-0": "v tejto min\xfate"
    });
    Globalize.b1179622244 = relativeTimeFormatterFn(Globalize("sl").numberFormatter({}), Globalize("sl").pluralGenerator({}), {
        "relativeTime-type-future": {
            "relativeTimePattern-count-one": "čez {0} uro",
            "relativeTimePattern-count-two": "čez {0} uri",
            "relativeTimePattern-count-few": "čez {0} ure",
            "relativeTimePattern-count-other": "čez {0} ur"
        },
        "relativeTime-type-past": {
            "relativeTimePattern-count-one": "pred {0} uro",
            "relativeTimePattern-count-two": "pred {0} urama",
            "relativeTimePattern-count-few": "pred {0} urami",
            "relativeTimePattern-count-other": "pred {0} urami"
        },
        "relative-type-0": "v tej uri"
    });
    Globalize.b1247429972 = relativeTimeFormatterFn(Globalize("sl").numberFormatter({}), Globalize("sl").pluralGenerator({}), {
        "relativeTime-type-future": {
            "relativeTimePattern-count-one": "čez {0} minuto",
            "relativeTimePattern-count-two": "čez {0} minuti",
            "relativeTimePattern-count-few": "čez {0} minute",
            "relativeTimePattern-count-other": "čez {0} minut"
        },
        "relativeTime-type-past": {
            "relativeTimePattern-count-one": "pred {0} minuto",
            "relativeTimePattern-count-two": "pred {0} minutama",
            "relativeTimePattern-count-few": "pred {0} minutami",
            "relativeTimePattern-count-other": "pred {0} minutami"
        },
        "relative-type-0": "to minuto"
    });
    Globalize.b105017831 = relativeTimeFormatterFn(Globalize("sr-Cyrl").numberFormatter({}), Globalize("sr-Cyrl").pluralGenerator({}), {
        "relativeTime-type-future": {
            "relativeTimePattern-count-one": "за {0} сат",
            "relativeTimePattern-count-few": "за {0} сата",
            "relativeTimePattern-count-other": "за {0} сати"
        },
        "relativeTime-type-past": {
            "relativeTimePattern-count-one": "пре {0} сата",
            "relativeTimePattern-count-few": "пре {0} сата",
            "relativeTimePattern-count-other": "пре {0} сати"
        },
        "relative-type-0": "овог сата"
    });
    Globalize.a655259881 = relativeTimeFormatterFn(Globalize("sr-Cyrl").numberFormatter({}), Globalize("sr-Cyrl").pluralGenerator({}), {
        "relativeTime-type-future": {
            "relativeTimePattern-count-one": "за {0} минут",
            "relativeTimePattern-count-few": "за {0} минута",
            "relativeTimePattern-count-other": "за {0} минута"
        },
        "relativeTime-type-past": {
            "relativeTimePattern-count-one": "пре {0} минута",
            "relativeTimePattern-count-few": "пре {0} минута",
            "relativeTimePattern-count-other": "пре {0} минута"
        },
        "relative-type-0": "овог минута"
    });
    Globalize.b502088902 = relativeTimeFormatterFn(Globalize("sr-Latn").numberFormatter({}), Globalize("sr-Latn").pluralGenerator({}), {
        "relativeTime-type-future": {
            "relativeTimePattern-count-one": "za {0} sat",
            "relativeTimePattern-count-few": "za {0} sata",
            "relativeTimePattern-count-other": "za {0} sati"
        },
        "relativeTime-type-past": {
            "relativeTimePattern-count-one": "pre {0} sata",
            "relativeTimePattern-count-few": "pre {0} sata",
            "relativeTimePattern-count-other": "pre {0} sati"
        },
        "relative-type-0": "ovog sata"
    });
    Globalize.a1322049994 = relativeTimeFormatterFn(Globalize("sr-Latn").numberFormatter({}), Globalize("sr-Latn").pluralGenerator({}), {
        "relativeTime-type-future": {
            "relativeTimePattern-count-one": "za {0} minut",
            "relativeTimePattern-count-few": "za {0} minuta",
            "relativeTimePattern-count-other": "za {0} minuta"
        },
        "relativeTime-type-past": {
            "relativeTimePattern-count-one": "pre {0} minuta",
            "relativeTimePattern-count-few": "pre {0} minuta",
            "relativeTimePattern-count-other": "pre {0} minuta"
        },
        "relative-type-0": "ovog minuta"
    });
    Globalize.a111204946 = relativeTimeFormatterFn(Globalize("sv").numberFormatter({}), Globalize("sv").pluralGenerator({}), {
        "relativeTime-type-future": {
            "relativeTimePattern-count-one": "om {0} timme",
            "relativeTimePattern-count-other": "om {0} timmar"
        },
        "relativeTime-type-past": {
            "relativeTimePattern-count-one": "f\xf6r {0} timme sedan",
            "relativeTimePattern-count-other": "f\xf6r {0} timmar sedan"
        },
        "relative-type-0": "denna timme"
    });
    Globalize.b2008048926 = relativeTimeFormatterFn(Globalize("sv").numberFormatter({}), Globalize("sv").pluralGenerator({}), {
        "relativeTime-type-future": {
            "relativeTimePattern-count-one": "om {0} minut",
            "relativeTimePattern-count-other": "om {0} minuter"
        },
        "relativeTime-type-past": {
            "relativeTimePattern-count-one": "f\xf6r {0} minut sedan",
            "relativeTimePattern-count-other": "f\xf6r {0} minuter sedan"
        },
        "relative-type-0": "denna minut"
    });
    Globalize.b1989356127 = relativeTimeFormatterFn(Globalize("th").numberFormatter({}), Globalize("th").pluralGenerator({}), {
        "relativeTime-type-future": {
            "relativeTimePattern-count-other": "ในอีก {0} ชั่วโมง"
        },
        "relativeTime-type-past": {
            "relativeTimePattern-count-other": "{0} ชั่วโมงที่ผ่านมา"
        },
        "relative-type-0": "ชั่วโมงนี้"
    });
    Globalize.b2012610959 = relativeTimeFormatterFn(Globalize("th").numberFormatter({}), Globalize("th").pluralGenerator({}), {
        "relativeTime-type-future": {
            "relativeTimePattern-count-other": "ในอีก {0} นาที"
        },
        "relativeTime-type-past": {
            "relativeTimePattern-count-other": "{0} นาทีที่ผ่านมา"
        },
        "relative-type-0": "นาทีนี้"
    });
    Globalize.b698528937 = relativeTimeFormatterFn(Globalize("tr").numberFormatter({}), Globalize("tr").pluralGenerator({}), {
        "relativeTime-type-future": {
            "relativeTimePattern-count-one": "{0} saat sonra",
            "relativeTimePattern-count-other": "{0} saat sonra"
        },
        "relativeTime-type-past": {
            "relativeTimePattern-count-one": "{0} saat \xf6nce",
            "relativeTimePattern-count-other": "{0} saat \xf6nce"
        },
        "relative-type-0": "bu saat"
    });
    Globalize.a1521737383 = relativeTimeFormatterFn(Globalize("tr").numberFormatter({}), Globalize("tr").pluralGenerator({}), {
        "relativeTime-type-future": {
            "relativeTimePattern-count-one": "{0} dakika sonra",
            "relativeTimePattern-count-other": "{0} dakika sonra"
        },
        "relativeTime-type-past": {
            "relativeTimePattern-count-one": "{0} dakika \xf6nce",
            "relativeTimePattern-count-other": "{0} dakika \xf6nce"
        },
        "relative-type-0": "bu dakika"
    });
    Globalize.b1895510977 = relativeTimeFormatterFn(Globalize("uk").numberFormatter({}), Globalize("uk").pluralGenerator({}), {
        "relativeTime-type-future": {
            "relativeTimePattern-count-one": "через {0} годину",
            "relativeTimePattern-count-few": "через {0} години",
            "relativeTimePattern-count-many": "через {0} годин",
            "relativeTimePattern-count-other": "через {0} години"
        },
        "relativeTime-type-past": {
            "relativeTimePattern-count-one": "{0} годину тому",
            "relativeTimePattern-count-few": "{0} години тому",
            "relativeTimePattern-count-many": "{0} годин тому",
            "relativeTimePattern-count-other": "{0} години тому"
        },
        "relative-type-0": "цієї години"
    });
    Globalize.b2021735025 = relativeTimeFormatterFn(Globalize("uk").numberFormatter({}), Globalize("uk").pluralGenerator({}), {
        "relativeTime-type-future": {
            "relativeTimePattern-count-one": "через {0} хвилину",
            "relativeTimePattern-count-few": "через {0} хвилини",
            "relativeTimePattern-count-many": "через {0} хвилин",
            "relativeTimePattern-count-other": "через {0} хвилини"
        },
        "relativeTime-type-past": {
            "relativeTimePattern-count-one": "{0} хвилину тому",
            "relativeTimePattern-count-few": "{0} хвилини тому",
            "relativeTimePattern-count-many": "{0} хвилин тому",
            "relativeTimePattern-count-other": "{0} хвилини тому"
        },
        "relative-type-0": "цієї хвилини"
    });
    Globalize.a1847887874 = relativeTimeFormatterFn(Globalize("vi").numberFormatter({}), Globalize("vi").pluralGenerator({}), {
        "relativeTime-type-future": {
            "relativeTimePattern-count-other": "sau {0} giờ nữa"
        },
        "relativeTime-type-past": {
            "relativeTimePattern-count-other": "{0} giờ trước"
        },
        "relative-type-0": "giờ n\xe0y"
    });
    Globalize.a496934034 = relativeTimeFormatterFn(Globalize("vi").numberFormatter({}), Globalize("vi").pluralGenerator({}), {
        "relativeTime-type-future": {
            "relativeTimePattern-count-other": "sau {0} ph\xfat nữa"
        },
        "relativeTime-type-past": {
            "relativeTimePattern-count-other": "{0} ph\xfat trước"
        },
        "relative-type-0": "ph\xfat n\xe0y"
    });
    Globalize.a2068901102 = relativeTimeFormatterFn(Globalize("yue").numberFormatter({}), Globalize("yue").pluralGenerator({}), {
        "relativeTime-type-future": {
            "relativeTimePattern-count-other": "{0} 小時後"
        },
        "relativeTime-type-past": {
            "relativeTimePattern-count-other": "{0} 小時前"
        },
        "relative-type-0": "呢個小時"
    });
    Globalize.b1857718658 = relativeTimeFormatterFn(Globalize("yue").numberFormatter({}), Globalize("yue").pluralGenerator({}), {
        "relativeTime-type-future": {
            "relativeTimePattern-count-other": "{0} 分鐘後"
        },
        "relativeTime-type-past": {
            "relativeTimePattern-count-other": "{0} 分鐘前"
        },
        "relative-type-0": "呢分鐘"
    });
    Globalize.a1130735834 = relativeTimeFormatterFn(Globalize("zh-Hans").numberFormatter({}), Globalize("zh-Hans").pluralGenerator({}), {
        "relativeTime-type-future": {
            "relativeTimePattern-count-other": "{0}小时后"
        },
        "relativeTime-type-past": {
            "relativeTimePattern-count-other": "{0}小时前"
        },
        "relative-type-0": "这一时间 / 此时"
    });
    Globalize.b1491409046 = relativeTimeFormatterFn(Globalize("zh-Hans").numberFormatter({}), Globalize("zh-Hans").pluralGenerator({}), {
        "relativeTime-type-future": {
            "relativeTimePattern-count-other": "{0}分钟后"
        },
        "relativeTime-type-past": {
            "relativeTimePattern-count-other": "{0}分钟前"
        },
        "relative-type-0": "此刻"
    });
    Globalize.b970642223 = relativeTimeFormatterFn(Globalize("zh-Hans-SG").numberFormatter({}), Globalize("zh-Hans-SG").pluralGenerator({}), {
        "relativeTime-type-future": {
            "relativeTimePattern-count-other": "{0}小时后"
        },
        "relativeTime-type-past": {
            "relativeTimePattern-count-other": "{0}小时前"
        },
        "relative-type-0": "这一时间 / 此时"
    });
    Globalize.a2013874593 = relativeTimeFormatterFn(Globalize("zh-Hans-SG").numberFormatter({}), Globalize("zh-Hans-SG").pluralGenerator({}), {
        "relativeTime-type-future": {
            "relativeTimePattern-count-other": "{0}分钟后"
        },
        "relativeTime-type-past": {
            "relativeTimePattern-count-other": "{0}分钟前"
        },
        "relative-type-0": "此刻"
    });
    Globalize.a1259818553 = relativeTimeFormatterFn(Globalize("zh-Hant").numberFormatter({}), Globalize("zh-Hant").pluralGenerator({}), {
        "relativeTime-type-future": {
            "relativeTimePattern-count-other": "{0} 小時後"
        },
        "relativeTime-type-past": {
            "relativeTimePattern-count-other": "{0} 小時前"
        },
        "relative-type-0": "這一小時"
    });
    Globalize.b1996967671 = relativeTimeFormatterFn(Globalize("zh-Hant").numberFormatter({}), Globalize("zh-Hant").pluralGenerator({}), {
        "relativeTime-type-future": {
            "relativeTimePattern-count-other": "{0} 分鐘後"
        },
        "relativeTime-type-past": {
            "relativeTimePattern-count-other": "{0} 分鐘前"
        },
        "relative-type-0": "這一分鐘"
    });
    Globalize.b14293757 = relativeTimeFormatterFn(Globalize("zh-Hant-HK").numberFormatter({}), Globalize("zh-Hant-HK").pluralGenerator({}), {
        "relativeTime-type-future": {
            "relativeTimePattern-count-other": "{0} 小時後"
        },
        "relativeTime-type-past": {
            "relativeTimePattern-count-other": "{0} 小時前"
        },
        "relative-type-0": "這個小時"
    });
    Globalize.a1941749075 = relativeTimeFormatterFn(Globalize("zh-Hant-HK").numberFormatter({}), Globalize("zh-Hant-HK").pluralGenerator({}), {
        "relativeTime-type-future": {
            "relativeTimePattern-count-other": "{0} 分鐘後"
        },
        "relativeTime-type-past": {
            "relativeTimePattern-count-other": "{0} 分鐘前"
        },
        "relative-type-0": "這分鐘"
    });
    Globalize.b964977916 = relativeTimeFormatterFn(Globalize("zh-Hant-MO").numberFormatter({}), Globalize("zh-Hant-MO").pluralGenerator({}), {
        "relativeTime-type-future": {
            "relativeTimePattern-count-other": "{0} 小時後"
        },
        "relativeTime-type-past": {
            "relativeTimePattern-count-other": "{0} 小時前"
        },
        "relative-type-0": "這個小時"
    });
    Globalize.b1132660972 = relativeTimeFormatterFn(Globalize("zh-Hant-MO").numberFormatter({}), Globalize("zh-Hant-MO").pluralGenerator({}), {
        "relativeTime-type-future": {
            "relativeTimePattern-count-other": "{0} 分鐘後"
        },
        "relativeTime-type-past": {
            "relativeTimePattern-count-other": "{0} 分鐘前"
        },
        "relative-type-0": "這分鐘"
    });
    Globalize.a1260780216 = unitFormatterFn(Globalize("ar-EG").numberFormatter({}), Globalize("ar-EG").pluralGenerator({}), {
        compoundUnitPattern: "{0} لكل {1}",
        unitProperties: {
            displayName: "بايت",
            zero: "{0} بايت",
            one: "{0} بايت",
            two: "{0} بايت",
            few: "{0} بايت",
            many: "{0} بايت",
            other: "{0} بايت"
        }
    });
    Globalize.b852797741 = unitFormatterFn(Globalize("ar-EG").numberFormatter({}), Globalize("ar-EG").pluralGenerator({}), {
        compoundUnitPattern: "{0}/{1}",
        unitProperties: {
            displayName: "كيلوبايت",
            zero: "{0} كيلوبايت",
            one: "{0} كيلوبايت",
            two: "{0} كيلوبايت",
            few: "{0} كيلوبايت",
            many: "{0} كيلوبايت",
            other: "{0} كيلوبايت"
        }
    });
    Globalize.b614409566 = unitFormatterFn(Globalize("ar-EG").numberFormatter({}), Globalize("ar-EG").pluralGenerator({}), {
        compoundUnitPattern: "{0}/{1}",
        unitProperties: {
            displayName: "ميغابايت",
            zero: "{0} ميغابايت",
            one: "{0} ميغابايت",
            two: "{0} ميغابايت",
            few: "{0} ميغابايت",
            many: "{0} ميغابايت",
            other: "{0} ميغابايت"
        }
    });
    Globalize.b1965047144 = unitFormatterFn(Globalize("ar-EG").numberFormatter({}), Globalize("ar-EG").pluralGenerator({}), {
        compoundUnitPattern: "{0}/{1}",
        unitProperties: {
            displayName: "غيغابايت",
            zero: "{0} غيغابايت",
            one: "{0} غيغابايت",
            two: "{0} غيغابايت",
            few: "{0} غيغابايت",
            many: "{0} غيغابايت",
            other: "{0} غيغابايت"
        }
    });
    Globalize.a1273411684 = unitFormatterFn(Globalize("ar-SA").numberFormatter({}), Globalize("ar-SA").pluralGenerator({}), {
        compoundUnitPattern: "{0} لكل {1}",
        unitProperties: {
            displayName: "بايت",
            zero: "{0} بايت",
            one: "{0} بايت",
            two: "{0} بايت",
            few: "{0} بايت",
            many: "{0} بايت",
            other: "{0} بايت"
        }
    });
    Globalize.b304462681 = unitFormatterFn(Globalize("ar-SA").numberFormatter({}), Globalize("ar-SA").pluralGenerator({}), {
        compoundUnitPattern: "{0}/{1}",
        unitProperties: {
            displayName: "كيلوبايت",
            zero: "{0} كيلوبايت",
            one: "{0} كيلوبايت",
            two: "{0} كيلوبايت",
            few: "{0} كيلوبايت",
            many: "{0} كيلوبايت",
            other: "{0} كيلوبايت"
        }
    });
    Globalize.b66074506 = unitFormatterFn(Globalize("ar-SA").numberFormatter({}), Globalize("ar-SA").pluralGenerator({}), {
        compoundUnitPattern: "{0}/{1}",
        unitProperties: {
            displayName: "ميغابايت",
            zero: "{0} ميغابايت",
            one: "{0} ميغابايت",
            two: "{0} ميغابايت",
            few: "{0} ميغابايت",
            many: "{0} ميغابايت",
            other: "{0} ميغابايت"
        }
    });
    Globalize.b1416712084 = unitFormatterFn(Globalize("ar-SA").numberFormatter({}), Globalize("ar-SA").pluralGenerator({}), {
        compoundUnitPattern: "{0}/{1}",
        unitProperties: {
            displayName: "غيغابايت",
            zero: "{0} غيغابايت",
            one: "{0} غيغابايت",
            two: "{0} غيغابايت",
            few: "{0} غيغابايت",
            many: "{0} غيغابايت",
            other: "{0} غيغابايت"
        }
    });
    Globalize.b595460021 = unitFormatterFn(Globalize("bg").numberFormatter({}), Globalize("bg").pluralGenerator({}), {
        compoundUnitPattern: "{0} на {1}",
        unitProperties: {
            displayName: "байтове",
            one: "{0} байт",
            other: "{0} байта"
        }
    });
    Globalize.a946001184 = unitFormatterFn(Globalize("bg").numberFormatter({}), Globalize("bg").pluralGenerator({}), {
        compoundUnitPattern: "{0}/{1}",
        unitProperties: {
            displayName: "kB",
            one: "{0} kB",
            other: "{0} kB"
        }
    });
    Globalize.a1184389359 = unitFormatterFn(Globalize("bg").numberFormatter({}), Globalize("bg").pluralGenerator({}), {
        compoundUnitPattern: "{0}/{1}",
        unitProperties: {
            displayName: "MB",
            one: "{0} MB",
            other: "{0} MB"
        }
    });
    Globalize.b166248219 = unitFormatterFn(Globalize("bg").numberFormatter({}), Globalize("bg").pluralGenerator({}), {
        compoundUnitPattern: "{0}/{1}",
        unitProperties: {
            displayName: "GB",
            one: "{0} GB",
            other: "{0} GB"
        }
    });
    Globalize.b986086044 = unitFormatterFn(Globalize("ca").numberFormatter({}), Globalize("ca").pluralGenerator({}), {
        compoundUnitPattern: "{0} per {1}",
        unitProperties: {
            displayName: "bytes",
            one: "{0} byte",
            other: "{0} bytes"
        }
    });
    Globalize.a1228904359 = unitFormatterFn(Globalize("ca").numberFormatter({}), Globalize("ca").pluralGenerator({}), {
        compoundUnitPattern: "{0}/{1}",
        unitProperties: {
            displayName: "kB",
            one: "{0} kB",
            other: "{0} kB"
        }
    });
    Globalize.a1467292534 = unitFormatterFn(Globalize("ca").numberFormatter({}), Globalize("ca").pluralGenerator({}), {
        compoundUnitPattern: "{0}/{1}",
        unitProperties: {
            displayName: "MB",
            one: "{0} MB",
            other: "{0} MB"
        }
    });
    Globalize.a116654956 = unitFormatterFn(Globalize("ca").numberFormatter({}), Globalize("ca").pluralGenerator({}), {
        compoundUnitPattern: "{0}/{1}",
        unitProperties: {
            displayName: "GB",
            one: "{0} GB",
            other: "{0} GB"
        }
    });
    Globalize.a278851446 = unitFormatterFn(Globalize("cs").numberFormatter({}), Globalize("cs").pluralGenerator({}), {
        compoundUnitPattern: "{0}/{1}",
        unitProperties: {
            displayName: "bajty",
            one: "{0} bajt",
            few: "{0} bajty",
            many: "{0} bajtu",
            other: "{0} bajtů"
        }
    });
    Globalize.a1432594645 = unitFormatterFn(Globalize("cs").numberFormatter({}), Globalize("cs").pluralGenerator({}), {
        compoundUnitPattern: "{0}/{1}",
        unitProperties: {
            displayName: "kB",
            one: "{0} kB",
            few: "{0} kB",
            many: "{0} kB",
            other: "{0} kB"
        }
    });
    Globalize.a1670982820 = unitFormatterFn(Globalize("cs").numberFormatter({}), Globalize("cs").pluralGenerator({}), {
        compoundUnitPattern: "{0}/{1}",
        unitProperties: {
            displayName: "MB",
            one: "{0} MB",
            few: "{0} MB",
            many: "{0} MB",
            other: "{0} MB"
        }
    });
    Globalize.a320345242 = unitFormatterFn(Globalize("cs").numberFormatter({}), Globalize("cs").pluralGenerator({}), {
        compoundUnitPattern: "{0}/{1}",
        unitProperties: {
            displayName: "GB",
            one: "{0} GB",
            few: "{0} GB",
            many: "{0} GB",
            other: "{0} GB"
        }
    });
    Globalize.b955066237 = unitFormatterFn(Globalize("da").numberFormatter({}), Globalize("da").pluralGenerator({}), {
        compoundUnitPattern: "{0} pr. {1}",
        unitProperties: {
            displayName: "bytes",
            one: "{0} byte",
            other: "{0} bytes"
        }
    });
    Globalize.a1579704296 = unitFormatterFn(Globalize("da").numberFormatter({}), Globalize("da").pluralGenerator({}), {
        compoundUnitPattern: "{0}/{1}",
        unitProperties: {
            displayName: "kB",
            one: "{0} kB",
            other: "{0} kB"
        }
    });
    Globalize.a1818092471 = unitFormatterFn(Globalize("da").numberFormatter({}), Globalize("da").pluralGenerator({}), {
        compoundUnitPattern: "{0}/{1}",
        unitProperties: {
            displayName: "MB",
            one: "{0} MB",
            other: "{0} MB"
        }
    });
    Globalize.a467454893 = unitFormatterFn(Globalize("da").numberFormatter({}), Globalize("da").pluralGenerator({}), {
        compoundUnitPattern: "{0}/{1}",
        unitProperties: {
            displayName: "GB",
            one: "{0} GB",
            other: "{0} GB"
        }
    });
    Globalize.b673969017 = unitFormatterFn(Globalize("de").numberFormatter({}), Globalize("de").pluralGenerator({}), {
        compoundUnitPattern: "{0} pro {1}",
        unitProperties: {
            displayName: "Bytes",
            one: "{0}\xa0Byte",
            other: "{0}\xa0Bytes"
        }
    });
    Globalize.a1624968804 = unitFormatterFn(Globalize("de").numberFormatter({}), Globalize("de").pluralGenerator({}), {
        compoundUnitPattern: "{0}/{1}",
        unitProperties: {
            displayName: "kbyte",
            one: "{0} kB",
            other: "{0} kB"
        }
    });
    Globalize.a1863356979 = unitFormatterFn(Globalize("de").numberFormatter({}), Globalize("de").pluralGenerator({}), {
        compoundUnitPattern: "{0}/{1}",
        unitProperties: {
            displayName: "Mbyte",
            one: "{0} MB",
            other: "{0} MB"
        }
    });
    Globalize.a512719401 = unitFormatterFn(Globalize("de").numberFormatter({}), Globalize("de").pluralGenerator({}), {
        compoundUnitPattern: "{0}/{1}",
        unitProperties: {
            displayName: "Gigabyte",
            one: "{0}\xa0GB",
            other: "{0}\xa0GB"
        }
    });
    Globalize.a1996454573 = unitFormatterFn(Globalize("el").numberFormatter({}), Globalize("el").pluralGenerator({}), {
        compoundUnitPattern: "{0} ανά {1}",
        unitProperties: {
            displayName: "byte",
            one: "{0} byte",
            other: "{0} byte"
        }
    });
    Globalize.a2054981630 = unitFormatterFn(Globalize("el").numberFormatter({}), Globalize("el").pluralGenerator({}), {
        compoundUnitPattern: "{0}/{1}",
        unitProperties: {
            displayName: "kB",
            one: "{0} kB",
            other: "{0} kB"
        }
    });
    Globalize.b2001597491 = unitFormatterFn(Globalize("el").numberFormatter({}), Globalize("el").pluralGenerator({}), {
        compoundUnitPattern: "{0}/{1}",
        unitProperties: {
            displayName: "MB",
            one: "{0} MB",
            other: "{0} MB"
        }
    });
    Globalize.a942732227 = unitFormatterFn(Globalize("el").numberFormatter({}), Globalize("el").pluralGenerator({}), {
        compoundUnitPattern: "{0}/{1}",
        unitProperties: {
            displayName: "GB",
            one: "{0} GB",
            other: "{0} GB"
        }
    });
    Globalize.a2137003183 = unitFormatterFn(Globalize("en").numberFormatter({}), Globalize("en").pluralGenerator({}), {
        compoundUnitPattern: "{0} per {1}",
        unitProperties: {
            displayName: "bytes",
            one: "{0} byte",
            other: "{0} bytes"
        }
    });
    Globalize.a2077613884 = unitFormatterFn(Globalize("en").numberFormatter({}), Globalize("en").pluralGenerator({}), {
        compoundUnitPattern: "{0}/{1}",
        unitProperties: {
            displayName: "kByte",
            one: "{0} kB",
            other: "{0} kB"
        }
    });
    Globalize.b1978965237 = unitFormatterFn(Globalize("en").numberFormatter({}), Globalize("en").pluralGenerator({}), {
        compoundUnitPattern: "{0}/{1}",
        unitProperties: {
            displayName: "MByte",
            one: "{0} MB",
            other: "{0} MB"
        }
    });
    Globalize.a965364481 = unitFormatterFn(Globalize("en").numberFormatter({}), Globalize("en").pluralGenerator({}), {
        compoundUnitPattern: "{0}/{1}",
        unitProperties: {
            displayName: "GByte",
            one: "{0} GB",
            other: "{0} GB"
        }
    });
    Globalize.a340891060 = unitFormatterFn(Globalize("es").numberFormatter({}), Globalize("es").pluralGenerator({}), {
        compoundUnitPattern: "{0} por {1}",
        unitProperties: {
            displayName: "bytes",
            one: "{0} byte",
            other: "{0} bytes"
        }
    });
    Globalize.a2134194519 = unitFormatterFn(Globalize("es").numberFormatter({}), Globalize("es").pluralGenerator({}), {
        compoundUnitPattern: "{0}/{1}",
        unitProperties: {
            displayName: "kB",
            one: "{0} kB",
            other: "{0} kB"
        }
    });
    Globalize.b1922384602 = unitFormatterFn(Globalize("es").numberFormatter({}), Globalize("es").pluralGenerator({}), {
        compoundUnitPattern: "{0}/{1}",
        unitProperties: {
            displayName: "MB",
            one: "{0} MB",
            other: "{0} MB"
        }
    });
    Globalize.a1021945116 = unitFormatterFn(Globalize("es").numberFormatter({}), Globalize("es").pluralGenerator({}), {
        compoundUnitPattern: "{0}/{1}",
        unitProperties: {
            displayName: "GB",
            one: "{0} GB",
            other: "{0} GB"
        }
    });
    Globalize.b1736318283 = unitFormatterFn(Globalize("et").numberFormatter({}), Globalize("et").pluralGenerator({}), {
        compoundUnitPattern: "{0} {1} kohta",
        unitProperties: {
            displayName: "baidid",
            one: "{0} bait",
            other: "{0} baiti"
        }
    });
    Globalize.a2145510646 = unitFormatterFn(Globalize("et").numberFormatter({}), Globalize("et").pluralGenerator({}), {
        compoundUnitPattern: "{0}/{1}",
        unitProperties: {
            displayName: "kB",
            one: "{0} kB",
            other: "{0} kB"
        }
    });
    Globalize.b1911068475 = unitFormatterFn(Globalize("et").numberFormatter({}), Globalize("et").pluralGenerator({}), {
        compoundUnitPattern: "{0}/{1}",
        unitProperties: {
            displayName: "MB",
            one: "{0} MB",
            other: "{0} MB"
        }
    });
    Globalize.a1033261243 = unitFormatterFn(Globalize("et").numberFormatter({}), Globalize("et").pluralGenerator({}), {
        compoundUnitPattern: "{0}/{1}",
        unitProperties: {
            displayName: "GB",
            one: "{0} GB",
            other: "{0} GB"
        }
    });
    Globalize.a481439670 = unitFormatterFn(Globalize("eu").numberFormatter({}), Globalize("eu").pluralGenerator({}), {
        compoundUnitPattern: "{0}/{1}",
        unitProperties: {
            displayName: "byte-ak",
            one: "{0} byte",
            other: "{0} byte"
        }
    });
    Globalize.b2138140523 = unitFormatterFn(Globalize("eu").numberFormatter({}), Globalize("eu").pluralGenerator({}), {
        compoundUnitPattern: "{0}/{1}",
        unitProperties: {
            displayName: "kB",
            one: "{0} kB",
            other: "{0} kB"
        }
    });
    Globalize.b1899752348 = unitFormatterFn(Globalize("eu").numberFormatter({}), Globalize("eu").pluralGenerator({}), {
        compoundUnitPattern: "{0}/{1}",
        unitProperties: {
            displayName: "MB",
            one: "{0} MB",
            other: "{0} MB"
        }
    });
    Globalize.a1044577370 = unitFormatterFn(Globalize("eu").numberFormatter({}), Globalize("eu").pluralGenerator({}), {
        compoundUnitPattern: "{0}/{1}",
        unitProperties: {
            displayName: "GB",
            one: "{0} GB",
            other: "{0} GB"
        }
    });
    Globalize.b330832183 = unitFormatterFn(Globalize("fi").numberFormatter({}), Globalize("fi").pluralGenerator({}), {
        compoundUnitPattern: "{0}/{1}",
        unitProperties: {
            displayName: "tavut",
            one: "{0} tavu",
            other: "{0} tavua"
        }
    });
    Globalize.b1923134110 = unitFormatterFn(Globalize("fi").numberFormatter({}), Globalize("fi").pluralGenerator({}), {
        compoundUnitPattern: "{0}/{1}",
        unitProperties: {
            displayName: "kt",
            one: "{0} kt",
            other: "{0} kt"
        }
    });
    Globalize.b1684745935 = unitFormatterFn(Globalize("fi").numberFormatter({}), Globalize("fi").pluralGenerator({}), {
        compoundUnitPattern: "{0}/{1}",
        unitProperties: {
            displayName: "Mt",
            one: "{0} Mt",
            other: "{0} Mt"
        }
    });
    Globalize.a1259583783 = unitFormatterFn(Globalize("fi").numberFormatter({}), Globalize("fi").pluralGenerator({}), {
        compoundUnitPattern: "{0}/{1}",
        unitProperties: {
            displayName: "Gt",
            one: "{0} Gt",
            other: "{0} Gt"
        }
    });
    Globalize.b1845847086 = unitFormatterFn(Globalize("fr").numberFormatter({}), Globalize("fr").pluralGenerator({}), {
        compoundUnitPattern: "{0} par {1}",
        unitProperties: {
            displayName: "octets",
            one: "{0}\xa0octet",
            other: "{0}\xa0octets"
        }
    });
    Globalize.b1821288967 = unitFormatterFn(Globalize("fr").numberFormatter({}), Globalize("fr").pluralGenerator({}), {
        compoundUnitPattern: "{0}/{1}",
        unitProperties: {
            displayName: "ko",
            one: "{0} ko",
            other: "{0} ko"
        }
    });
    Globalize.b1582900792 = unitFormatterFn(Globalize("fr").numberFormatter({}), Globalize("fr").pluralGenerator({}), {
        compoundUnitPattern: "{0}/{1}",
        unitProperties: {
            displayName: "Mo",
            one: "{0} Mo",
            other: "{0} Mo"
        }
    });
    Globalize.a1361428926 = unitFormatterFn(Globalize("fr").numberFormatter({}), Globalize("fr").pluralGenerator({}), {
        compoundUnitPattern: "{0}/{1}",
        unitProperties: {
            displayName: "Go",
            one: "{0} Go",
            other: "{0} Go"
        }
    });
    Globalize.a2058494187 = unitFormatterFn(Globalize("gl").numberFormatter({}), Globalize("gl").pluralGenerator({}), {
        compoundUnitPattern: "{0} por {1}",
        unitProperties: {
            displayName: "bytes",
            one: "{0} byte",
            other: "{0} bytes"
        }
    });
    Globalize.b1538385792 = unitFormatterFn(Globalize("gl").numberFormatter({}), Globalize("gl").pluralGenerator({}), {
        compoundUnitPattern: "{0}/{1}",
        unitProperties: {
            displayName: "kB",
            one: "{0} kB",
            other: "{0} kB"
        }
    });
    Globalize.b1299997617 = unitFormatterFn(Globalize("gl").numberFormatter({}), Globalize("gl").pluralGenerator({}), {
        compoundUnitPattern: "{0}/{1}",
        unitProperties: {
            displayName: "MB",
            one: "{0} MB",
            other: "{0} MB"
        }
    });
    Globalize.a1644332101 = unitFormatterFn(Globalize("gl").numberFormatter({}), Globalize("gl").pluralGenerator({}), {
        compoundUnitPattern: "{0}/{1}",
        unitProperties: {
            displayName: "GB",
            one: "{0} GB",
            other: "{0} GB"
        }
    });
    Globalize.b549889789 = unitFormatterFn(Globalize("he").numberFormatter({}), Globalize("he").pluralGenerator({}), {
        compoundUnitPattern: "{0} ל{1}",
        unitProperties: {
            displayName: "בייט",
            one: "{0} בייט",
            two: "{0} בייט",
            many: "{0} בייט",
            other: "{0} בייט"
        }
    });
    Globalize.b1266798744 = unitFormatterFn(Globalize("he").numberFormatter({}), Globalize("he").pluralGenerator({}), {
        compoundUnitPattern: "{0}/{1}",
        unitProperties: {
            displayName: "kB",
            one: "{0} kB",
            two: "{0} kB",
            many: "{0} kB",
            other: "{0} kB"
        }
    });
    Globalize.b1028410569 = unitFormatterFn(Globalize("he").numberFormatter({}), Globalize("he").pluralGenerator({}), {
        compoundUnitPattern: "{0}/{1}",
        unitProperties: {
            displayName: "MB",
            one: "{0} MB",
            two: "{0} MB",
            many: "{0} MB",
            other: "{0} MB"
        }
    });
    Globalize.a1915919149 = unitFormatterFn(Globalize("he").numberFormatter({}), Globalize("he").pluralGenerator({}), {
        compoundUnitPattern: "{0}/{1}",
        unitProperties: {
            displayName: "GB",
            one: "{0} GB",
            two: "{0} GB",
            many: "{0} GB",
            other: "{0} GB"
        }
    });
    Globalize.b268792569 = unitFormatterFn(Globalize("hi").numberFormatter({}), Globalize("hi").pluralGenerator({}), {
        compoundUnitPattern: "{0} प्रति {1}",
        unitProperties: {
            displayName: "बाइट",
            one: "{0} बाइट",
            other: "{0} बाइट"
        }
    });
    Globalize.b1221534236 = unitFormatterFn(Globalize("hi").numberFormatter({}), Globalize("hi").pluralGenerator({}), {
        compoundUnitPattern: "{0}/{1}",
        unitProperties: {
            displayName: "kB",
            one: "{0} kB",
            other: "{0} kB"
        }
    });
    Globalize.b983146061 = unitFormatterFn(Globalize("hi").numberFormatter({}), Globalize("hi").pluralGenerator({}), {
        compoundUnitPattern: "{0}/{1}",
        unitProperties: {
            displayName: "MB",
            one: "{0} MB",
            other: "{0} MB"
        }
    });
    Globalize.a1961183657 = unitFormatterFn(Globalize("hi").numberFormatter({}), Globalize("hi").pluralGenerator({}), {
        compoundUnitPattern: "{0}/{1}",
        unitProperties: {
            displayName: "GB",
            one: "{0} GB",
            other: "{0} GB"
        }
    });
    Globalize.b1783807472 = unitFormatterFn(Globalize("hr").numberFormatter({}), Globalize("hr").pluralGenerator({}), {
        compoundUnitPattern: "{0}/{1}",
        unitProperties: {
            displayName: "bajtovi",
            one: "{0} bajt",
            few: "{0} bajta",
            other: "{0} bajtova"
        }
    });
    Globalize.b1119689093 = unitFormatterFn(Globalize("hr").numberFormatter({}), Globalize("hr").pluralGenerator({}), {
        compoundUnitPattern: "{0}/{1}",
        unitProperties: {
            displayName: "kB",
            one: "{0} kB",
            few: "{0} kB",
            other: "{0} kB"
        }
    });
    Globalize.b881300918 = unitFormatterFn(Globalize("hr").numberFormatter({}), Globalize("hr").pluralGenerator({}), {
        compoundUnitPattern: "{0}/{1}",
        unitProperties: {
            displayName: "MB",
            one: "{0} MB",
            few: "{0} MB",
            other: "{0} MB"
        }
    });
    Globalize.a2063028800 = unitFormatterFn(Globalize("hr").numberFormatter({}), Globalize("hr").pluralGenerator({}), {
        compoundUnitPattern: "{0}/{1}",
        unitProperties: {
            displayName: "GB",
            one: "{0} GB",
            few: "{0} GB",
            other: "{0} GB"
        }
    });
    Globalize.a574499091 = unitFormatterFn(Globalize("hu").numberFormatter({}), Globalize("hu").pluralGenerator({}), {
        compoundUnitPattern: "{0} per {1}",
        unitProperties: {
            displayName: "b\xe1jt",
            one: "{0} b\xe1jt",
            other: "{0} b\xe1jt"
        }
    });
    Globalize.b1085740712 = unitFormatterFn(Globalize("hu").numberFormatter({}), Globalize("hu").pluralGenerator({}), {
        compoundUnitPattern: "{0}/{1}",
        unitProperties: {
            displayName: "kB",
            one: "{0} kB",
            other: "{0} kB"
        }
    });
    Globalize.b847352537 = unitFormatterFn(Globalize("hu").numberFormatter({}), Globalize("hu").pluralGenerator({}), {
        compoundUnitPattern: "{0}/{1}",
        unitProperties: {
            displayName: "MB",
            one: "{0} MB",
            other: "{0} MB"
        }
    });
    Globalize.a2096977181 = unitFormatterFn(Globalize("hu").numberFormatter({}), Globalize("hu").pluralGenerator({}), {
        compoundUnitPattern: "{0}/{1}",
        unitProperties: {
            displayName: "GB",
            one: "{0} GB",
            other: "{0} GB"
        }
    });
    Globalize.a1558339361 = unitFormatterFn(Globalize("id").numberFormatter({}), Globalize("id").pluralGenerator({}), {
        compoundUnitPattern: "{0} per {1}",
        unitProperties: {
            displayName: "byte",
            other: "{0} byte"
        }
    });
    Globalize.b927314934 = unitFormatterFn(Globalize("id").numberFormatter({}), Globalize("id").pluralGenerator({}), {
        compoundUnitPattern: "{0}/{1}",
        unitProperties: {
            displayName: "kByte",
            other: "{0} kB"
        }
    });
    Globalize.b688926759 = unitFormatterFn(Globalize("id").numberFormatter({}), Globalize("id").pluralGenerator({}), {
        compoundUnitPattern: "{0}/{1}",
        unitProperties: {
            displayName: "MByte",
            other: "{0} MB"
        }
    });
    Globalize.b2039564337 = unitFormatterFn(Globalize("id").numberFormatter({}), Globalize("id").pluralGenerator({}), {
        compoundUnitPattern: "{0}/{1}",
        unitProperties: {
            displayName: "GByte",
            other: "{0} GB"
        }
    });
    Globalize.b1612239055 = unitFormatterFn(Globalize("it").numberFormatter({}), Globalize("it").pluralGenerator({}), {
        compoundUnitPattern: "{0} al {1}",
        unitProperties: {
            displayName: "byte",
            one: "{0} byte",
            other: "{0} byte"
        }
    });
    Globalize.b746256902 = unitFormatterFn(Globalize("it").numberFormatter({}), Globalize("it").pluralGenerator({}), {
        compoundUnitPattern: "{0}/{1}",
        unitProperties: {
            displayName: "kB",
            one: "{0} kB",
            other: "{0} kB"
        }
    });
    Globalize.b507868727 = unitFormatterFn(Globalize("it").numberFormatter({}), Globalize("it").pluralGenerator({}), {
        compoundUnitPattern: "{0}/{1}",
        unitProperties: {
            displayName: "MB",
            one: "{0} MB",
            other: "{0} MB"
        }
    });
    Globalize.b1858506305 = unitFormatterFn(Globalize("it").numberFormatter({}), Globalize("it").pluralGenerator({}), {
        compoundUnitPattern: "{0}/{1}",
        unitProperties: {
            displayName: "GB",
            one: "{0} GB",
            other: "{0} GB"
        }
    });
    Globalize.b768947395 = unitFormatterFn(Globalize("ja").numberFormatter({}), Globalize("ja").pluralGenerator({}), {
        compoundUnitPattern: "{0}毎{1}",
        unitProperties: {
            displayName: "バイト",
            other: "{0} バイト"
        }
    });
    Globalize.b610463378 = unitFormatterFn(Globalize("ja").numberFormatter({}), Globalize("ja").pluralGenerator({}), {
        compoundUnitPattern: "{0}/{1}",
        unitProperties: {
            displayName: "KB",
            other: "{0} KB"
        }
    });
    Globalize.b372075203 = unitFormatterFn(Globalize("ja").numberFormatter({}), Globalize("ja").pluralGenerator({}), {
        compoundUnitPattern: "{0}/{1}",
        unitProperties: {
            displayName: "MB",
            other: "{0} MB"
        }
    });
    Globalize.b1722712781 = unitFormatterFn(Globalize("ja").numberFormatter({}), Globalize("ja").pluralGenerator({}), {
        compoundUnitPattern: "{0}/{1}",
        unitProperties: {
            displayName: "GB",
            other: "{0} GB"
        }
    });
    Globalize.b35184538 = unitFormatterFn(Globalize("kk").numberFormatter({}), Globalize("kk").pluralGenerator({}), {
        compoundUnitPattern: "{0}/{1}",
        unitProperties: {
            displayName: "байт",
            one: "{0} байт",
            other: "{0} байт"
        }
    });
    Globalize.b146502171 = unitFormatterFn(Globalize("kk").numberFormatter({}), Globalize("kk").pluralGenerator({}), {
        compoundUnitPattern: "{0}/{1}",
        unitProperties: {
            displayName: "кбайт",
            one: "{0} кБ",
            other: "{0} кБ"
        }
    });
    Globalize.a91886004 = unitFormatterFn(Globalize("kk").numberFormatter({}), Globalize("kk").pluralGenerator({}), {
        compoundUnitPattern: "{0}/{1}",
        unitProperties: {
            displayName: "Мбайт",
            one: "{0} MБ",
            other: "{0} MБ"
        }
    });
    Globalize.b1258751574 = unitFormatterFn(Globalize("kk").numberFormatter({}), Globalize("kk").pluralGenerator({}), {
        compoundUnitPattern: "{0}/{1}",
        unitProperties: {
            displayName: "Гбайт",
            one: "{0} ГБ",
            other: "{0} ГБ"
        }
    });
    Globalize.a245912682 = unitFormatterFn(Globalize("ko").numberFormatter({}), Globalize("ko").pluralGenerator({}), {
        compoundUnitPattern: "{1}당 {0}",
        unitProperties: {
            displayName: "바이트",
            other: "{0}바이트"
        }
    });
    Globalize.b101237663 = unitFormatterFn(Globalize("ko").numberFormatter({}), Globalize("ko").pluralGenerator({}), {
        compoundUnitPattern: "{0}/{1}",
        unitProperties: {
            displayName: "kB",
            other: "{0}kB"
        }
    });
    Globalize.a137150512 = unitFormatterFn(Globalize("ko").numberFormatter({}), Globalize("ko").pluralGenerator({}), {
        compoundUnitPattern: "{0}/{1}",
        unitProperties: {
            displayName: "MB",
            other: "{0}MB"
        }
    });
    Globalize.b1213487066 = unitFormatterFn(Globalize("ko").numberFormatter({}), Globalize("ko").pluralGenerator({}), {
        compoundUnitPattern: "{0}/{1}",
        unitProperties: {
            displayName: "GB",
            other: "{0}GB"
        }
    });
    Globalize.b1519179634 = unitFormatterFn(Globalize("lt").numberFormatter({}), Globalize("lt").pluralGenerator({}), {
        compoundUnitPattern: "{0}/{1}",
        unitProperties: {
            displayName: "baitai",
            one: "{0} baitas",
            few: "{0} baitai",
            many: "{0} baito",
            other: "{0} baitų"
        }
    });
    Globalize.a306142909 = unitFormatterFn(Globalize("lt").numberFormatter({}), Globalize("lt").pluralGenerator({}), {
        compoundUnitPattern: "{0}/{1}",
        unitProperties: {
            displayName: "kB",
            one: "{0} kB",
            few: "{0} kB",
            many: "{0} kB",
            other: "{0} kB"
        }
    });
    Globalize.a544531084 = unitFormatterFn(Globalize("lt").numberFormatter({}), Globalize("lt").pluralGenerator({}), {
        compoundUnitPattern: "{0}/{1}",
        unitProperties: {
            displayName: "MB",
            one: "{0} MB",
            few: "{0} MB",
            many: "{0} MB",
            other: "{0} MB"
        }
    });
    Globalize.b806106494 = unitFormatterFn(Globalize("lt").numberFormatter({}), Globalize("lt").pluralGenerator({}), {
        compoundUnitPattern: "{0}/{1}",
        unitProperties: {
            displayName: "GB",
            one: "{0} GB",
            few: "{0} GB",
            many: "{0} GB",
            other: "{0} GB"
        }
    });
    Globalize.b1378631024 = unitFormatterFn(Globalize("lv").numberFormatter({}), Globalize("lv").pluralGenerator({}), {
        compoundUnitPattern: "{0}/{1}",
        unitProperties: {
            displayName: "baiti",
            zero: "{0} baitu",
            one: "{0} baits",
            other: "{0} baiti"
        }
    });
    Globalize.a328775163 = unitFormatterFn(Globalize("lv").numberFormatter({}), Globalize("lv").pluralGenerator({}), {
        compoundUnitPattern: "{0}/{1}",
        unitProperties: {
            displayName: "kB",
            zero: "{0} kB",
            one: "{0} kB",
            other: "{0} kB"
        }
    });
    Globalize.a567163338 = unitFormatterFn(Globalize("lv").numberFormatter({}), Globalize("lv").pluralGenerator({}), {
        compoundUnitPattern: "{0}/{1}",
        unitProperties: {
            displayName: "MB",
            zero: "{0} MB",
            one: "{0} MB",
            other: "{0} MB"
        }
    });
    Globalize.b783474240 = unitFormatterFn(Globalize("lv").numberFormatter({}), Globalize("lv").pluralGenerator({}), {
        compoundUnitPattern: "{0}/{1}",
        unitProperties: {
            displayName: "GB",
            zero: "{0} GB",
            one: "{0} GB",
            other: "{0} GB"
        }
    });
    Globalize.a589049516 = unitFormatterFn(Globalize("ms").numberFormatter({}), Globalize("ms").pluralGenerator({}), {
        compoundUnitPattern: "{0} per {1}",
        unitProperties: {
            displayName: "bait",
            other: "{0} bait"
        }
    });
    Globalize.a645626719 = unitFormatterFn(Globalize("ms").numberFormatter({}), Globalize("ms").pluralGenerator({}), {
        compoundUnitPattern: "{0}/{1}",
        unitProperties: {
            displayName: "kBait",
            other: "{0} kB"
        }
    });
    Globalize.a884014894 = unitFormatterFn(Globalize("ms").numberFormatter({}), Globalize("ms").pluralGenerator({}), {
        compoundUnitPattern: "{0}/{1}",
        unitProperties: {
            displayName: "MBait",
            other: "{0} MB"
        }
    });
    Globalize.b466622684 = unitFormatterFn(Globalize("ms").numberFormatter({}), Globalize("ms").pluralGenerator({}), {
        compoundUnitPattern: "{0}/{1}",
        unitProperties: {
            displayName: "GBait",
            other: "{0} GB"
        }
    });
    Globalize.a1572889786 = unitFormatterFn(Globalize("nb").numberFormatter({}), Globalize("nb").pluralGenerator({}), {
        compoundUnitPattern: "{0} per {1}",
        unitProperties: {
            displayName: "byte",
            one: "{0} byte",
            other: "{0} byte"
        }
    });
    Globalize.a804052497 = unitFormatterFn(Globalize("nb").numberFormatter({}), Globalize("nb").pluralGenerator({}), {
        compoundUnitPattern: "{0}/{1}",
        unitProperties: {
            displayName: "kB",
            one: "{0} kB",
            other: "{0} kB"
        }
    });
    Globalize.a1042440672 = unitFormatterFn(Globalize("nb").numberFormatter({}), Globalize("nb").pluralGenerator({}), {
        compoundUnitPattern: "{0}/{1}",
        unitProperties: {
            displayName: "MB",
            one: "{0} MB",
            other: "{0} MB"
        }
    });
    Globalize.b308196906 = unitFormatterFn(Globalize("nb").numberFormatter({}), Globalize("nb").pluralGenerator({}), {
        compoundUnitPattern: "{0}/{1}",
        unitProperties: {
            displayName: "GB",
            one: "{0} GB",
            other: "{0} GB"
        }
    });
    Globalize.b2019334460 = unitFormatterFn(Globalize("nl").numberFormatter({}), Globalize("nl").pluralGenerator({}), {
        compoundUnitPattern: "{0} per {1}",
        unitProperties: {
            displayName: "byte",
            one: "{0} byte",
            other: "{0} byte"
        }
    });
    Globalize.a917213767 = unitFormatterFn(Globalize("nl").numberFormatter({}), Globalize("nl").pluralGenerator({}), {
        compoundUnitPattern: "{0}/{1}",
        unitProperties: {
            displayName: "kB",
            one: "{0} kB",
            other: "{0} kB"
        }
    });
    Globalize.a1155601942 = unitFormatterFn(Globalize("nl").numberFormatter({}), Globalize("nl").pluralGenerator({}), {
        compoundUnitPattern: "{0}/{1}",
        unitProperties: {
            displayName: "MB",
            one: "{0} MB",
            other: "{0} MB"
        }
    });
    Globalize.b195035636 = unitFormatterFn(Globalize("nl").numberFormatter({}), Globalize("nl").pluralGenerator({}), {
        compoundUnitPattern: "{0}/{1}",
        unitProperties: {
            displayName: "GB",
            one: "{0} GB",
            other: "{0} GB"
        }
    });
    Globalize.b1957294846 = unitFormatterFn(Globalize("pl").numberFormatter({}), Globalize("pl").pluralGenerator({}), {
        compoundUnitPattern: "{0} na {1}",
        unitProperties: {
            displayName: "bajty",
            one: "{0} bajt",
            few: "{0} bajty",
            many: "{0} bajt\xf3w",
            other: "{0} bajta"
        }
    });
    Globalize.a1618813641 = unitFormatterFn(Globalize("pl").numberFormatter({}), Globalize("pl").pluralGenerator({}), {
        compoundUnitPattern: "{0}/{1}",
        unitProperties: {
            displayName: "kB",
            other: "{0} kB",
            one: "{0} kB",
            few: "{0} kB",
            many: "{0} kB"
        }
    });
    Globalize.a1857201816 = unitFormatterFn(Globalize("pl").numberFormatter({}), Globalize("pl").pluralGenerator({}), {
        compoundUnitPattern: "{0}/{1}",
        unitProperties: {
            displayName: "MB",
            other: "{0} MB",
            one: "{0} MB",
            few: "{0} MB",
            many: "{0} MB"
        }
    });
    Globalize.a506564238 = unitFormatterFn(Globalize("pl").numberFormatter({}), Globalize("pl").pluralGenerator({}), {
        compoundUnitPattern: "{0}/{1}",
        unitProperties: {
            displayName: "GB",
            other: "{0} GB",
            one: "{0} GB",
            few: "{0} GB",
            many: "{0} GB"
        }
    });
    Globalize.b1395100406 = unitFormatterFn(Globalize("pt").numberFormatter({}), Globalize("pt").pluralGenerator({}), {
        compoundUnitPattern: "{0} por {1}",
        unitProperties: {
            displayName: "bytes",
            one: "{0} bytes",
            other: "{0} bytes"
        }
    });
    Globalize.a1709342657 = unitFormatterFn(Globalize("pt").numberFormatter({}), Globalize("pt").pluralGenerator({}), {
        compoundUnitPattern: "{0}/{1}",
        unitProperties: {
            displayName: "kByte",
            other: "{0} kB",
            one: "{0} kB"
        }
    });
    Globalize.a1947730832 = unitFormatterFn(Globalize("pt").numberFormatter({}), Globalize("pt").pluralGenerator({}), {
        compoundUnitPattern: "{0}/{1}",
        unitProperties: {
            displayName: "MByte",
            other: "{0} MB",
            one: "{0} MB"
        }
    });
    Globalize.a597093254 = unitFormatterFn(Globalize("pt").numberFormatter({}), Globalize("pt").pluralGenerator({}), {
        compoundUnitPattern: "{0}/{1}",
        unitProperties: {
            displayName: "GByte",
            other: "{0} GB",
            one: "{0} GB"
        }
    });
    Globalize.a1665198183 = unitFormatterFn(Globalize("pt-PT").numberFormatter({}), Globalize("pt-PT").pluralGenerator({}), {
        compoundUnitPattern: "{0} por {1}",
        unitProperties: {
            displayName: "bytes",
            one: "{0} byte",
            other: "{0} bytes"
        }
    });
    Globalize.a1283235460 = unitFormatterFn(Globalize("pt-PT").numberFormatter({}), Globalize("pt-PT").pluralGenerator({}), {
        compoundUnitPattern: "{0}/{1}",
        unitProperties: {
            displayName: "kByte",
            one: "{0} kB",
            other: "{0} kB"
        }
    });
    Globalize.a1521623635 = unitFormatterFn(Globalize("pt-PT").numberFormatter({}), Globalize("pt-PT").pluralGenerator({}), {
        compoundUnitPattern: "{0}/{1}",
        unitProperties: {
            displayName: "MByte",
            one: "{0} MB",
            other: "{0} MB"
        }
    });
    Globalize.a170986057 = unitFormatterFn(Globalize("pt-PT").numberFormatter({}), Globalize("pt-PT").pluralGenerator({}), {
        compoundUnitPattern: "{0}/{1}",
        unitProperties: {
            displayName: "GByte",
            one: "{0} GB",
            other: "{0} GB"
        }
    });
    Globalize.a463051331 = unitFormatterFn(Globalize("ro").numberFormatter({}), Globalize("ro").pluralGenerator({}), {
        compoundUnitPattern: "{0} pe {1}",
        unitProperties: {
            displayName: "byți",
            one: "{0} byte",
            few: "{0} byți",
            other: "{0} de byți"
        }
    });
    Globalize.b1940605400 = unitFormatterFn(Globalize("ro").numberFormatter({}), Globalize("ro").pluralGenerator({}), {
        compoundUnitPattern: "{0}/{1}",
        unitProperties: {
            displayName: "kB",
            one: "{0} kB",
            few: "{0} kB",
            other: "{0} kB"
        }
    });
    Globalize.b1702217225 = unitFormatterFn(Globalize("ro").numberFormatter({}), Globalize("ro").pluralGenerator({}), {
        compoundUnitPattern: "{0}/{1}",
        unitProperties: {
            displayName: "MB",
            one: "{0} MB",
            few: "{0} MB",
            other: "{0} MB"
        }
    });
    Globalize.a1242112493 = unitFormatterFn(Globalize("ro").numberFormatter({}), Globalize("ro").pluralGenerator({}), {
        compoundUnitPattern: "{0}/{1}",
        unitProperties: {
            displayName: "GB",
            one: "{0} GB",
            few: "{0} GB",
            other: "{0} GB"
        }
    });
    Globalize.a884697161 = unitFormatterFn(Globalize("ru").numberFormatter({}), Globalize("ru").pluralGenerator({}), {
        compoundUnitPattern: "{0}/{1}",
        unitProperties: {
            displayName: "байты",
            one: "{0} байт",
            few: "{0} байта",
            many: "{0} байт",
            other: "{0} байта"
        }
    });
    Globalize.b1872708638 = unitFormatterFn(Globalize("ru").numberFormatter({}), Globalize("ru").pluralGenerator({}), {
        compoundUnitPattern: "{0}/{1}",
        unitProperties: {
            displayName: "кБ",
            one: "{0} кБ",
            few: "{0} кБ",
            many: "{0} кБ",
            other: "{0} кБ"
        }
    });
    Globalize.b1634320463 = unitFormatterFn(Globalize("ru").numberFormatter({}), Globalize("ru").pluralGenerator({}), {
        compoundUnitPattern: "{0}/{1}",
        unitProperties: {
            displayName: "МБ",
            one: "{0} МБ",
            few: "{0} МБ",
            many: "{0} МБ",
            other: "{0} МБ"
        }
    });
    Globalize.a1310009255 = unitFormatterFn(Globalize("ru").numberFormatter({}), Globalize("ru").pluralGenerator({}), {
        compoundUnitPattern: "{0}/{1}",
        unitProperties: {
            displayName: "ГБ",
            one: "{0} ГБ",
            few: "{0} ГБ",
            many: "{0} ГБ",
            other: "{0} ГБ"
        }
    });
    Globalize.a212973918 = unitFormatterFn(Globalize("sk").numberFormatter({}), Globalize("sk").pluralGenerator({}), {
        compoundUnitPattern: "{0}/{1}",
        unitProperties: {
            displayName: "bajty",
            one: "{0} bajt",
            few: "{0} bajty",
            many: "{0} bajtu",
            other: "{0} bajtov"
        }
    });
    Globalize.b1635069971 = unitFormatterFn(Globalize("sk").numberFormatter({}), Globalize("sk").pluralGenerator({}), {
        compoundUnitPattern: "{0}/{1}",
        unitProperties: {
            displayName: "kB",
            one: "{0} kB",
            few: "{0} kB",
            many: "{0} kB",
            other: "{0} kB"
        }
    });
    Globalize.b1396681796 = unitFormatterFn(Globalize("sk").numberFormatter({}), Globalize("sk").pluralGenerator({}), {
        compoundUnitPattern: "{0}/{1}",
        unitProperties: {
            displayName: "MB",
            one: "{0} MB",
            few: "{0} MB",
            many: "{0} MB",
            other: "{0} MB"
        }
    });
    Globalize.a1547647922 = unitFormatterFn(Globalize("sk").numberFormatter({}), Globalize("sk").pluralGenerator({}), {
        compoundUnitPattern: "{0}/{1}",
        unitProperties: {
            displayName: "GB",
            one: "{0} GB",
            few: "{0} GB",
            many: "{0} GB",
            other: "{0} GB"
        }
    });
    Globalize.b1864235425 = unitFormatterFn(Globalize("sl").numberFormatter({}), Globalize("sl").pluralGenerator({}), {
        compoundUnitPattern: "{0} na {1}",
        unitProperties: {
            displayName: "bajt",
            one: "{0} bajt",
            two: "{0} bajta",
            few: "{0} bajti",
            other: "{0} bajtov"
        }
    });
    Globalize.b1623753844 = unitFormatterFn(Globalize("sl").numberFormatter({}), Globalize("sl").pluralGenerator({}), {
        compoundUnitPattern: "{0}/{1}",
        unitProperties: {
            displayName: "kB",
            one: "{0} kB",
            two: "{0} kB",
            few: "{0} kB",
            other: "{0} kB"
        }
    });
    Globalize.b1385365669 = unitFormatterFn(Globalize("sl").numberFormatter({}), Globalize("sl").pluralGenerator({}), {
        compoundUnitPattern: "{0}/{1}",
        unitProperties: {
            displayName: "MB",
            one: "{0} MB",
            two: "{0} MB",
            few: "{0} MB",
            other: "{0} MB"
        }
    });
    Globalize.a1558964049 = unitFormatterFn(Globalize("sl").numberFormatter({}), Globalize("sl").pluralGenerator({}), {
        compoundUnitPattern: "{0}/{1}",
        unitProperties: {
            displayName: "GB",
            one: "{0} GB",
            two: "{0} GB",
            few: "{0} GB",
            other: "{0} GB"
        }
    });
    Globalize.b1064685448 = unitFormatterFn(Globalize("sr-Cyrl").numberFormatter({}), Globalize("sr-Cyrl").pluralGenerator({}), {
        compoundUnitPattern: "{0}/{1}",
        unitProperties: {
            displayName: "бајтови",
            one: "{0} бајт",
            few: "{0} бајта",
            other: "{0} бајтова"
        }
    });
    Globalize.b826099437 = unitFormatterFn(Globalize("sr-Cyrl").numberFormatter({}), Globalize("sr-Cyrl").pluralGenerator({}), {
        compoundUnitPattern: "{0}/{1}",
        unitProperties: {
            displayName: "kB",
            one: "{0} kB",
            few: "{0} kB",
            other: "{0} kB"
        }
    });
    Globalize.b587711262 = unitFormatterFn(Globalize("sr-Cyrl").numberFormatter({}), Globalize("sr-Cyrl").pluralGenerator({}), {
        compoundUnitPattern: "{0}/{1}",
        unitProperties: {
            displayName: "MB",
            one: "{0} MB",
            few: "{0} MB",
            other: "{0} MB"
        }
    });
    Globalize.b1938348840 = unitFormatterFn(Globalize("sr-Cyrl").numberFormatter({}), Globalize("sr-Cyrl").pluralGenerator({}), {
        compoundUnitPattern: "{0}/{1}",
        unitProperties: {
            displayName: "GB",
            one: "{0} GB",
            few: "{0} GB",
            other: "{0} GB"
        }
    });
    Globalize.b463658761 = unitFormatterFn(Globalize("sr-Latn").numberFormatter({}), Globalize("sr-Latn").pluralGenerator({}), {
        compoundUnitPattern: "{0}/{1}",
        unitProperties: {
            displayName: "bajtovi",
            one: "{0} bajt",
            few: "{0} bajta",
            other: "{0} bajtova"
        }
    });
    Globalize.b1577238540 = unitFormatterFn(Globalize("sr-Latn").numberFormatter({}), Globalize("sr-Latn").pluralGenerator({}), {
        compoundUnitPattern: "{0}/{1}",
        unitProperties: {
            displayName: "kB",
            one: "{0} kB",
            few: "{0} kB",
            other: "{0} kB"
        }
    });
    Globalize.b1338850365 = unitFormatterFn(Globalize("sr-Latn").numberFormatter({}), Globalize("sr-Latn").pluralGenerator({}), {
        compoundUnitPattern: "{0}/{1}",
        unitProperties: {
            displayName: "MB",
            one: "{0} MB",
            few: "{0} MB",
            other: "{0} MB"
        }
    });
    Globalize.a1605479353 = unitFormatterFn(Globalize("sr-Latn").numberFormatter({}), Globalize("sr-Latn").pluralGenerator({}), {
        compoundUnitPattern: "{0}/{1}",
        unitProperties: {
            displayName: "GB",
            one: "{0} GB",
            few: "{0} GB",
            other: "{0} GB"
        }
    });
    Globalize.b1161492375 = unitFormatterFn(Globalize("sv").numberFormatter({}), Globalize("sv").pluralGenerator({}), {
        compoundUnitPattern: "{0} per {1}",
        unitProperties: {
            displayName: "byte",
            one: "{0} byte",
            other: "{0} byte"
        }
    });
    Globalize.b1510592574 = unitFormatterFn(Globalize("sv").numberFormatter({}), Globalize("sv").pluralGenerator({}), {
        compoundUnitPattern: "{0}/{1}",
        unitProperties: {
            displayName: "kB",
            one: "{0} kB",
            other: "{0} kB"
        }
    });
    Globalize.b1272204399 = unitFormatterFn(Globalize("sv").numberFormatter({}), Globalize("sv").pluralGenerator({}), {
        compoundUnitPattern: "{0}/{1}",
        unitProperties: {
            displayName: "MB",
            one: "{0} MB",
            other: "{0} MB"
        }
    });
    Globalize.a1672125319 = unitFormatterFn(Globalize("sv").numberFormatter({}), Globalize("sv").pluralGenerator({}), {
        compoundUnitPattern: "{0}/{1}",
        unitProperties: {
            displayName: "GB",
            one: "{0} GB",
            other: "{0} GB"
        }
    });
    Globalize.b2114312838 = unitFormatterFn(Globalize("th").numberFormatter({}), Globalize("th").pluralGenerator({}), {
        compoundUnitPattern: "{0}ต่อ{1}",
        unitProperties: {
            displayName: "ไบต์",
            other: "{0} ไบต์"
        }
    });
    Globalize.b1318218415 = unitFormatterFn(Globalize("th").numberFormatter({}), Globalize("th").pluralGenerator({}), {
        compoundUnitPattern: "{0}/{1}",
        unitProperties: {
            displayName: "kB",
            other: "{0} kB"
        }
    });
    Globalize.b1079830240 = unitFormatterFn(Globalize("th").numberFormatter({}), Globalize("th").pluralGenerator({}), {
        compoundUnitPattern: "{0}/{1}",
        unitProperties: {
            displayName: "MB",
            other: "{0} MB"
        }
    });
    Globalize.a1864499478 = unitFormatterFn(Globalize("th").numberFormatter({}), Globalize("th").pluralGenerator({}), {
        compoundUnitPattern: "{0}/{1}",
        unitProperties: {
            displayName: "GB",
            other: "{0} GB"
        }
    });
    Globalize.b1411569788 = unitFormatterFn(Globalize("tr").numberFormatter({}), Globalize("tr").pluralGenerator({}), {
        compoundUnitPattern: "{0}/{1}",
        unitProperties: {
            displayName: "bayt",
            one: "{0} bayt",
            other: "{0} bayt"
        }
    });
    Globalize.b1205057145 = unitFormatterFn(Globalize("tr").numberFormatter({}), Globalize("tr").pluralGenerator({}), {
        compoundUnitPattern: "{0}/{1}",
        unitProperties: {
            displayName: "kB",
            one: "{0} kB",
            other: "{0} kB"
        }
    });
    Globalize.b966668970 = unitFormatterFn(Globalize("tr").numberFormatter({}), Globalize("tr").pluralGenerator({}), {
        compoundUnitPattern: "{0}/{1}",
        unitProperties: {
            displayName: "MB",
            one: "{0} MB",
            other: "{0} MB"
        }
    });
    Globalize.a1977660748 = unitFormatterFn(Globalize("tr").numberFormatter({}), Globalize("tr").pluralGenerator({}), {
        compoundUnitPattern: "{0}/{1}",
        unitProperties: {
            displayName: "GB",
            one: "{0} GB",
            other: "{0} GB"
        }
    });
    Globalize.a275013532 = unitFormatterFn(Globalize("uk").numberFormatter({}), Globalize("uk").pluralGenerator({}), {
        compoundUnitPattern: "{0} на {1}",
        unitProperties: {
            displayName: "байти",
            one: "{0} байт",
            few: "{0} байти",
            many: "{0} байтів",
            other: "{0} байта"
        }
    });
    Globalize.b933470097 = unitFormatterFn(Globalize("uk").numberFormatter({}), Globalize("uk").pluralGenerator({}), {
        compoundUnitPattern: "{0}/{1}",
        unitProperties: {
            displayName: "кбайт",
            one: "{0} кБ",
            few: "{0} кБ",
            many: "{0} кБ",
            other: "{0} кБ"
        }
    });
    Globalize.b695081922 = unitFormatterFn(Globalize("uk").numberFormatter({}), Globalize("uk").pluralGenerator({}), {
        compoundUnitPattern: "{0}/{1}",
        unitProperties: {
            displayName: "Мбайт",
            one: "{0} МБ",
            few: "{0} МБ",
            many: "{0} МБ",
            other: "{0} МБ"
        }
    });
    Globalize.b2045719500 = unitFormatterFn(Globalize("uk").numberFormatter({}), Globalize("uk").pluralGenerator({}), {
        compoundUnitPattern: "{0}/{1}",
        unitProperties: {
            displayName: "Гбайт",
            one: "{0} ГБ",
            few: "{0} ГБ",
            many: "{0} ГБ",
            other: "{0} ГБ"
        }
    });
    Globalize.a165484729 = unitFormatterFn(Globalize("vi").numberFormatter({}), Globalize("vi").pluralGenerator({}), {
        compoundUnitPattern: "{0}/{1}",
        unitProperties: {
            displayName: "byte",
            other: "{0} byte"
        }
    });
    Globalize.b605302414 = unitFormatterFn(Globalize("vi").numberFormatter({}), Globalize("vi").pluralGenerator({}), {
        compoundUnitPattern: "{0}/{1}",
        unitProperties: {
            displayName: "kB",
            other: "{0} kB"
        }
    });
    Globalize.b366914239 = unitFormatterFn(Globalize("vi").numberFormatter({}), Globalize("vi").pluralGenerator({}), {
        compoundUnitPattern: "{0}/{1}",
        unitProperties: {
            displayName: "MB",
            other: "{0} MB"
        }
    });
    Globalize.b1717551817 = unitFormatterFn(Globalize("vi").numberFormatter({}), Globalize("vi").pluralGenerator({}), {
        compoundUnitPattern: "{0}/{1}",
        unitProperties: {
            displayName: "GB",
            other: "{0} GB"
        }
    });
    Globalize.b1657704125 = unitFormatterFn(Globalize("yue").numberFormatter({}), Globalize("yue").pluralGenerator({}), {
        compoundUnitPattern: "每 {1} {0}",
        unitProperties: {
            displayName: "byte",
            other: "{0} byte"
        }
    });
    Globalize.a1393245992 = unitFormatterFn(Globalize("yue").numberFormatter({}), Globalize("yue").pluralGenerator({}), {
        compoundUnitPattern: "{0}/{1}",
        unitProperties: {
            displayName: "kB",
            other: "{0} kB"
        }
    });
    Globalize.a1631634167 = unitFormatterFn(Globalize("yue").numberFormatter({}), Globalize("yue").pluralGenerator({}), {
        compoundUnitPattern: "{0}/{1}",
        unitProperties: {
            displayName: "MB",
            other: "{0} MB"
        }
    });
    Globalize.a280996589 = unitFormatterFn(Globalize("yue").numberFormatter({}), Globalize("yue").pluralGenerator({}), {
        compoundUnitPattern: "{0}/{1}",
        unitProperties: {
            displayName: "GB",
            other: "{0} GB"
        }
    });
    Globalize.a915494743 = unitFormatterFn(Globalize("zh-Hans").numberFormatter({}), Globalize("zh-Hans").pluralGenerator({}), {
        compoundUnitPattern: "每{1}{0}",
        unitProperties: {
            displayName: "字节",
            other: "{0}字节"
        }
    });
    Globalize.a1506542996 = unitFormatterFn(Globalize("zh-Hans").numberFormatter({}), Globalize("zh-Hans").pluralGenerator({}), {
        compoundUnitPattern: "{0}/{1}",
        unitProperties: {
            displayName: "千字节",
            other: "{0}千字节"
        }
    });
    Globalize.a1744931171 = unitFormatterFn(Globalize("zh-Hans").numberFormatter({}), Globalize("zh-Hans").pluralGenerator({}), {
        compoundUnitPattern: "{0}/{1}",
        unitProperties: {
            displayName: "兆字节",
            other: "{0}兆字节"
        }
    });
    Globalize.a394293593 = unitFormatterFn(Globalize("zh-Hans").numberFormatter({}), Globalize("zh-Hans").pluralGenerator({}), {
        compoundUnitPattern: "{0}/{1}",
        unitProperties: {
            displayName: "吉字节",
            other: "{0}吉字节"
        }
    });
    Globalize.b1803561142 = unitFormatterFn(Globalize("zh-Hans-SG").numberFormatter({}), Globalize("zh-Hans-SG").pluralGenerator({}), {
        compoundUnitPattern: "{0}/{1}",
        unitProperties: {
            displayName: "字节",
            other: "{0}字节"
        }
    });
    Globalize.b692157055 = unitFormatterFn(Globalize("zh-Hans-SG").numberFormatter({}), Globalize("zh-Hans-SG").pluralGenerator({}), {
        compoundUnitPattern: "{0}/{1}",
        unitProperties: {
            displayName: "千字节",
            other: "{0}千字节"
        }
    });
    Globalize.b453768880 = unitFormatterFn(Globalize("zh-Hans-SG").numberFormatter({}), Globalize("zh-Hans-SG").pluralGenerator({}), {
        compoundUnitPattern: "{0}/{1}",
        unitProperties: {
            displayName: "兆字节",
            other: "{0}兆字节"
        }
    });
    Globalize.b1804406458 = unitFormatterFn(Globalize("zh-Hans-SG").numberFormatter({}), Globalize("zh-Hans-SG").pluralGenerator({}), {
        compoundUnitPattern: "{0}/{1}",
        unitProperties: {
            displayName: "吉字节",
            other: "{0}吉字节"
        }
    });
    Globalize.b1161714600 = unitFormatterFn(Globalize("zh-Hant").numberFormatter({}), Globalize("zh-Hant").pluralGenerator({}), {
        compoundUnitPattern: "每{1} {0}",
        unitProperties: {
            displayName: "byte",
            other: "{0} byte"
        }
    });
    Globalize.a1517859123 = unitFormatterFn(Globalize("zh-Hant").numberFormatter({}), Globalize("zh-Hant").pluralGenerator({}), {
        compoundUnitPattern: "{0}/{1}",
        unitProperties: {
            displayName: "kB",
            other: "{0} kB"
        }
    });
    Globalize.a1756247298 = unitFormatterFn(Globalize("zh-Hant").numberFormatter({}), Globalize("zh-Hant").pluralGenerator({}), {
        compoundUnitPattern: "{0}/{1}",
        unitProperties: {
            displayName: "MB",
            other: "{0} MB"
        }
    });
    Globalize.a405609720 = unitFormatterFn(Globalize("zh-Hant").numberFormatter({}), Globalize("zh-Hant").pluralGenerator({}), {
        compoundUnitPattern: "{0}/{1}",
        unitProperties: {
            displayName: "GB",
            other: "{0} GB"
        }
    });
    Globalize.b2118418344 = unitFormatterFn(Globalize("zh-Hant-HK").numberFormatter({}), Globalize("zh-Hant-HK").pluralGenerator({}), {
        compoundUnitPattern: "{0}每{1}",
        unitProperties: {
            displayName: "位元組",
            other: "{0} 位元組"
        }
    });
    Globalize.a1900565811 = unitFormatterFn(Globalize("zh-Hant-HK").numberFormatter({}), Globalize("zh-Hant-HK").pluralGenerator({}), {
        compoundUnitPattern: "{0}/{1}",
        unitProperties: {
            displayName: "kB",
            other: "{0} kB"
        }
    });
    Globalize.a2138953986 = unitFormatterFn(Globalize("zh-Hant-HK").numberFormatter({}), Globalize("zh-Hant-HK").pluralGenerator({}), {
        compoundUnitPattern: "{0}/{1}",
        unitProperties: {
            displayName: "MB",
            other: "{0} MB"
        }
    });
    Globalize.a788316408 = unitFormatterFn(Globalize("zh-Hant-HK").numberFormatter({}), Globalize("zh-Hant-HK").pluralGenerator({}), {
        compoundUnitPattern: "{0}/{1}",
        unitProperties: {
            displayName: "GB",
            other: "{0} GB"
        }
    });
    Globalize.b1682222089 = unitFormatterFn(Globalize("zh-Hant-MO").numberFormatter({}), Globalize("zh-Hant-MO").pluralGenerator({}), {
        compoundUnitPattern: "{0}每{1}",
        unitProperties: {
            displayName: "位元組",
            other: "{0} 位元組"
        }
    });
    Globalize.b595137292 = unitFormatterFn(Globalize("zh-Hant-MO").numberFormatter({}), Globalize("zh-Hant-MO").pluralGenerator({}), {
        compoundUnitPattern: "{0}/{1}",
        unitProperties: {
            displayName: "kB",
            other: "{0} kB"
        }
    });
    Globalize.b356749117 = unitFormatterFn(Globalize("zh-Hant-MO").numberFormatter({}), Globalize("zh-Hant-MO").pluralGenerator({}), {
        compoundUnitPattern: "{0}/{1}",
        unitProperties: {
            displayName: "MB",
            other: "{0} MB"
        }
    });
    Globalize.b1707386695 = unitFormatterFn(Globalize("zh-Hant-MO").numberFormatter({}), Globalize("zh-Hant-MO").pluralGenerator({}), {
        compoundUnitPattern: "{0}/{1}",
        unitProperties: {
            displayName: "GB",
            other: "{0} GB"
        }
    });
    return Globalize;
});

});
parcelRequire.register("kNVX6", function(module, exports) {

/**
 * Globalize Runtime v1.7.0
 *
 * https://github.com/globalizejs/globalize
 *
 * Copyright OpenJS Foundation and other contributors
 * Released under the MIT license
 * https://jquery.org/license
 *
 * Date: 2021-08-02T11:53Z
 */ /*!
 * Globalize Runtime v1.7.0 2021-08-02T11:53Z Released under the MIT license
 * http://git.io/TrdQbw
 */ (function(root, factory) {
    "use strict";
    // UMD returnExports
    if (typeof define === "function" && define.amd) // AMD
    define([
        "../globalize-runtime"
    ], factory);
    else // Node, CommonJS
    module.exports = factory((parcelRequire("3Bcu1")));
})(module.exports, function(Globalize) {
    var createError = Globalize._createError, partsJoin = Globalize._partsJoin, partsPush = Globalize._partsPush, regexpEscape = Globalize._regexpEscape, runtimeKey = Globalize._runtimeKey, stringPad = Globalize._stringPad, validateParameterType = Globalize._validateParameterType, validateParameterPresence = Globalize._validateParameterPresence, validateParameterTypeString = Globalize._validateParameterTypeString;
    var createErrorUnsupportedFeature = function(feature) {
        return createError("E_UNSUPPORTED", "Unsupported {feature}.", {
            feature: feature
        });
    };
    var validateParameterTypeNumber = function(value, name) {
        validateParameterType(value, name, value === undefined || typeof value === "number", "Number");
    };
    /**
 * EBNF representation:
 *
 * compact_pattern_re =       prefix?
 *                            number_pattern_re
 *                            suffix?
 *
 * number_pattern_re =        0+
 *
 * Regexp groups:
 *
 *  0: compact_pattern_re
 *  1: prefix
 *  2: number_pattern_re (the number pattern to use in compact mode)
 *  3: suffix
 */ var numberCompactPatternRe = /^([^0]*)(0+)([^0]*)$/;
    /**
 * goupingSeparator( number, primaryGroupingSize, secondaryGroupingSize )
 *
 * @number [Number].
 *
 * @primaryGroupingSize [Number]
 *
 * @secondaryGroupingSize [Number]
 *
 * Return the formatted number with group separator.
 */ var numberFormatGroupingSeparator = function(number, primaryGroupingSize, secondaryGroupingSize) {
        var index, currentGroupingSize = primaryGroupingSize, ret = "", sep = ",", switchToSecondary = secondaryGroupingSize ? true : false;
        number = String(number).split(".");
        index = number[0].length;
        while(index > currentGroupingSize){
            ret = number[0].slice(index - currentGroupingSize, index) + (ret.length ? sep : "") + ret;
            index -= currentGroupingSize;
            if (switchToSecondary) {
                currentGroupingSize = secondaryGroupingSize;
                switchToSecondary = false;
            }
        }
        number[0] = number[0].slice(0, index) + (ret.length ? sep : "") + ret;
        return number.join(".");
    };
    /**
 * integerFractionDigits( number, minimumIntegerDigits, minimumFractionDigits,
 * maximumFractionDigits, round, roundIncrement )
 *
 * @number [Number]
 *
 * @minimumIntegerDigits [Number]
 *
 * @minimumFractionDigits [Number]
 *
 * @maximumFractionDigits [Number]
 *
 * @round [Function]
 *
 * @roundIncrement [Function]
 *
 * Return the formatted integer and fraction digits.
 */ var numberFormatIntegerFractionDigits = function(number, minimumIntegerDigits, minimumFractionDigits, maximumFractionDigits, round, roundIncrement) {
        // Fraction
        if (maximumFractionDigits) {
            // Rounding
            if (roundIncrement) number = round(number, roundIncrement);
            else number = round(number, {
                exponent: -maximumFractionDigits
            });
        } else number = round(number);
        number = String(number);
        // Maximum integer digits (post string phase)
        if (maximumFractionDigits && /e-/.test(number)) // Use toFixed( maximumFractionDigits ) to make sure small numbers like 1e-7 are
        // displayed using plain digits instead of scientific notation.
        // 1: Remove leading decimal zeros.
        // 2: Remove leading decimal separator.
        // Note: String() is still preferred so it doesn't mess up with a number precision
        // unnecessarily, e.g., (123456789.123).toFixed(10) === "123456789.1229999959",
        // String(123456789.123) === "123456789.123".
        number = (+number).toFixed(maximumFractionDigits).replace(/0+$/, "")/* 1 */ .replace(/\.$/, ""); /* 2 */ 
        // Minimum fraction digits (post string phase)
        if (minimumFractionDigits) {
            number = number.split(".");
            number[1] = stringPad(number[1] || "", minimumFractionDigits, true);
            number = number.join(".");
        }
        // Minimum integer digits
        if (minimumIntegerDigits) {
            number = number.split(".");
            number[0] = stringPad(number[0], minimumIntegerDigits);
            number = number.join(".");
        }
        return number;
    };
    /**
 * toPrecision( number, precision, round )
 *
 * @number (Number)
 *
 * @precision (Number) significant figures precision (not decimal precision).
 *
 * @round (Function)
 *
 * Return number.toPrecision( precision ) using the given round function.
 */ var numberToPrecision = function(number, precision, round) {
        var roundOrder;
        if (number === 0) return number;
        roundOrder = Math.ceil(Math.log(Math.abs(number)) / Math.log(10));
        roundOrder -= precision;
        return round(number, {
            exponent: roundOrder
        });
    };
    /**
 * toPrecision( number, minimumSignificantDigits, maximumSignificantDigits, round )
 *
 * @number [Number]
 *
 * @minimumSignificantDigits [Number]
 *
 * @maximumSignificantDigits [Number]
 *
 * @round [Function]
 *
 * Return the formatted significant digits number.
 */ var numberFormatSignificantDigits = function(number, minimumSignificantDigits, maximumSignificantDigits, round) {
        var atMinimum, atMaximum;
        // Sanity check.
        if (minimumSignificantDigits > maximumSignificantDigits) maximumSignificantDigits = minimumSignificantDigits;
        atMinimum = numberToPrecision(number, minimumSignificantDigits, round);
        atMaximum = numberToPrecision(number, maximumSignificantDigits, round);
        // Use atMaximum only if it has more significant digits than atMinimum.
        number = +atMinimum === +atMaximum ? atMinimum : atMaximum;
        // Expand integer numbers, eg. 123e5 to 12300.
        number = (+number).toString(10);
        if (/e/.test(number)) throw createErrorUnsupportedFeature({
            feature: "integers out of (1e21, 1e-7)"
        });
        // Add trailing zeros if necessary.
        if (minimumSignificantDigits - number.replace(/^0+|\./g, "").length > 0) {
            number = number.split(".");
            number[1] = stringPad(number[1] || "", minimumSignificantDigits - number[0].replace(/^0+/, "").length, true);
            number = number.join(".");
        }
        return number;
    };
    var numberSymbolName = {
        ".": "decimal",
        ",": "group",
        "%": "percentSign",
        "+": "plusSign",
        "-": "minusSign",
        "E": "exponential",
        "‰": "perMille"
    };
    /**
 * removeLiteralQuotes( string )
 *
 * Return:
 * - `'` if input string is `''`.
 * - `o'clock` if input string is `'o''clock'`.
 * - `foo` if input string is `foo`, i.e., return the same value in case it isn't a single-quoted
 *   string.
 */ var removeLiteralQuotes = function(string) {
        if (string[0] + string[string.length - 1] !== "''") return string;
        if (string === "''") return "'";
        return string.replace(/''/g, "'").slice(1, -1);
    };
    /**
 * format( number, properties )
 *
 * @number [Number].
 *
 * @properties [Object] Output of number/format-properties.
 *
 * Return the formatted number.
 * ref: http://www.unicode.org/reports/tr35/tr35-numbers.html
 */ var numberFormat = function(number, properties, pluralGenerator) {
        var aux, compactMap, infinitySymbol, maximumFractionDigits, maximumSignificantDigits, minimumFractionDigits, minimumIntegerDigits, minimumSignificantDigits, nanSymbol, nuDigitsMap, prefix, primaryGroupingSize, pattern, round, roundIncrement, secondaryGroupingSize, stringToParts, suffix, symbolMap;
        minimumIntegerDigits = properties[2];
        minimumFractionDigits = properties[3];
        maximumFractionDigits = properties[4];
        minimumSignificantDigits = properties[5];
        maximumSignificantDigits = properties[6];
        roundIncrement = properties[7];
        primaryGroupingSize = properties[8];
        secondaryGroupingSize = properties[9];
        round = properties[15];
        infinitySymbol = properties[16];
        nanSymbol = properties[17];
        symbolMap = properties[18];
        nuDigitsMap = properties[19];
        compactMap = properties[20];
        // NaN
        if (isNaN(number)) return [
            {
                type: "nan",
                value: nanSymbol
            }
        ];
        if (number < 0) {
            pattern = properties[12];
            prefix = properties[13];
            suffix = properties[14];
        } else {
            pattern = properties[11];
            prefix = properties[0];
            suffix = properties[10];
        }
        // For prefix, suffix, and number parts.
        stringToParts = function(string) {
            var numberType = "integer", parts = [];
            // TODO Move the tokenization of all parts that don't depend on number into
            // format-properties.
            string.replace(/('([^']|'')+'|'')|./g, function(character, literal) {
                // Literals
                if (literal) {
                    partsPush(parts, "literal", removeLiteralQuotes(literal));
                    return;
                }
                // Currency symbol
                if (character === "\xa4") {
                    partsPush(parts, "currency", character);
                    return;
                }
                // Symbols
                character = character.replace(/[.,\-+E%\u2030]/, function(symbol) {
                    if (symbol === ".") numberType = "fraction";
                    partsPush(parts, numberSymbolName[symbol], symbolMap[symbol]);
                    // "Erase" handled character.
                    return "";
                });
                // Number
                character = character.replace(/[0-9]/, function(digit) {
                    // Numbering system
                    if (nuDigitsMap) digit = nuDigitsMap[+digit];
                    partsPush(parts, numberType, digit);
                    // "Erase" handled character.
                    return "";
                });
                // Etc
                character.replace(/./, function(etc) {
                    partsPush(parts, "literal", etc);
                });
            });
            return parts;
        };
        prefix = stringToParts(prefix);
        suffix = stringToParts(suffix);
        // Infinity
        if (!isFinite(number)) return prefix.concat({
            type: "infinity",
            value: infinitySymbol
        }, suffix);
        // Percent
        if (pattern.indexOf("%") !== -1) number *= 100;
        else if (pattern.indexOf("‰") !== -1) number *= 1000;
        var compactPattern, compactDigits, compactProperties, divisor, numberExponent, pluralForm;
        // Compact mode: initial number digit processing
        if (compactMap) {
            numberExponent = Math.abs(Math.floor(number)).toString().length - 1;
            numberExponent = Math.min(numberExponent, compactMap.maxExponent);
            // Use default plural form to perform initial decimal shift
            if (numberExponent >= 3) compactPattern = compactMap[numberExponent] && compactMap[numberExponent].other;
            if (compactPattern === "0") compactPattern = null;
            else if (compactPattern) {
                compactDigits = compactPattern.split("0").length - 1;
                divisor = numberExponent - (compactDigits - 1);
                number = number / Math.pow(10, divisor);
            }
        }
        // Significant digit format
        if (!isNaN(minimumSignificantDigits * maximumSignificantDigits)) number = numberFormatSignificantDigits(number, minimumSignificantDigits, maximumSignificantDigits, round);
        else number = numberFormatIntegerFractionDigits(number, minimumIntegerDigits, minimumFractionDigits, maximumFractionDigits, round, roundIncrement);
        // Compact mode: apply formatting
        if (compactMap && compactPattern) {
            // Get plural form after possible roundings
            pluralForm = pluralGenerator ? pluralGenerator(+number) : "other";
            compactPattern = compactMap[numberExponent][pluralForm] || compactPattern;
            compactProperties = compactPattern.match(numberCompactPatternRe);
            // TODO Move the tokenization of all parts that don't depend on number into
            // format-properties.
            aux = function(string) {
                var parts = [];
                string.replace(/(\s+)|([^\s0]+)/g, function(_garbage, space, compact) {
                    // Literals
                    if (space) {
                        partsPush(parts, "literal", space);
                        return;
                    }
                    // Compact value
                    if (compact) {
                        partsPush(parts, "compact", compact);
                        return;
                    }
                });
                return parts;
            };
            // update prefix/suffix with compact prefix/suffix
            prefix = prefix.concat(aux(compactProperties[1]));
            suffix = aux(compactProperties[3]).concat(suffix);
        }
        // Remove the possible number minus sign
        number = number.replace(/^-/, "");
        // Grouping separators
        if (primaryGroupingSize) number = numberFormatGroupingSeparator(number, primaryGroupingSize, secondaryGroupingSize);
        // Scientific notation
        // TODO implement here
        // Padding/'([^']|'')+'|''|[.,\-+E%\u2030]/g
        // TODO implement here
        return prefix.concat(stringToParts(number), suffix);
    };
    var numberFormatterFn = function(numberToPartsFormatter) {
        return function numberFormatter(value) {
            return partsJoin(numberToPartsFormatter(value));
        };
    };
    /**
 * Generated by:
 *
 * var regenerate = require( "regenerate" );
 * var formatSymbols = require( "@unicode/unicode-13.0.0/General_Category/Format/symbols" );
 * regenerate().add( formatSymbols ).toString();
 *
 * https://github.com/mathiasbynens/regenerate
 * https://github.com/node-unicode/unicode-13.0.0
 */ var regexpCfG = /[\xAD\u0600-\u0605\u061C\u06DD\u070F\u08E2\u180E\u200B-\u200F\u202A-\u202E\u2060-\u2064\u2066-\u206F\uFEFF\uFFF9-\uFFFB]|\uD804[\uDCBD\uDCCD]|\uD80D[\uDC30-\uDC38]|\uD82F[\uDCA0-\uDCA3]|\uD834[\uDD73-\uDD7A]|\uDB40[\uDC01\uDC20-\uDC7F]/g;
    /**
 * Generated by:
 *
 * var regenerate = require( "regenerate" );
 * var dashSymbols = require( "https://github.com/node-unicode/unicode-13.0.0/General_Category/Dash_Punctuation/symbols" );
 * regenerate().add( dashSymbols ).toString();
 *
 * https://github.com/mathiasbynens/regenerate
 * https://github.com/node-unicode/unicode-13.0.0
 *
 * NOTE: In addition to [:dash:],  the below includes MINUS SIGN U+2212.
 */ var regexpDashG = /[\x2D\u058A\u05BE\u1400\u1806\u2010-\u2015\u2E17\u2E1A\u2E3A\u2E3B\u2E40\u301C\u3030\u30A0\uFE31\uFE32\uFE58\uFE63\uFF0D\u2212]|\uD803\uDEAD/g;
    /**
 * Generated by:
 *
 * var regenerate = require( "regenerate" );
 * var spaceSeparatorSymbols = require( "@unicode/unicode-13.0.0/General_Category/Space_Separator/symbols" );
 * regenerate().add( spaceSeparatorSymbols ).toString();
 *
 * https://github.com/mathiasbynens/regenerate
 * https://github.com/node-unicode/unicode-13.0.0
 */ var regexpZsG = /[ \xA0\u1680\u2000-\u200A\u202F\u205F\u3000]/g;
    /**
 * Loose Matching:
 * - Ignore all format characters, which includes RLM, LRM or ALM used to control BIDI
 *   formatting.
 * - Map all characters in [:Zs:] to U+0020 SPACE;
 * - Map all characters in [:Dash:] to U+002D HYPHEN-MINUS;
 */ var looseMatching = function(value) {
        return value.replace(regexpCfG, "").replace(regexpDashG, "-").replace(regexpZsG, " ");
    };
    /**
 * parse( value, properties )
 *
 * @value [String].
 *
 * @properties [Object] Parser properties is a reduced pre-processed cldr
 * data set returned by numberParserProperties().
 *
 * Return the parsed Number (including Infinity) or NaN when value is invalid.
 * ref: http://www.unicode.org/reports/tr35/tr35-numbers.html
 */ var numberParse = function(value, properties) {
        var grammar, invertedNuDigitsMap, invertedSymbolMap, negative, number, prefix, prefixNSuffix, suffix, tokenizer, valid;
        // Grammar:
        // - Value <=           NaN | PositiveNumber | NegativeNumber
        // - PositiveNumber <=  PositivePrefix NumberOrInf PositiveSufix
        // - NegativeNumber <=  NegativePrefix NumberOrInf
        // - NumberOrInf <=     Number | Inf
        grammar = [
            [
                "nan"
            ],
            [
                "prefix",
                "infinity",
                "suffix"
            ],
            [
                "prefix",
                "number",
                "suffix"
            ],
            [
                "negativePrefix",
                "infinity",
                "negativeSuffix"
            ],
            [
                "negativePrefix",
                "number",
                "negativeSuffix"
            ]
        ];
        invertedSymbolMap = properties[0];
        invertedNuDigitsMap = properties[1] || {};
        tokenizer = properties[2];
        value = looseMatching(value);
        function parse(type) {
            return function(lexeme) {
                // Reverse localized symbols and numbering system.
                lexeme = lexeme.split("").map(function(character) {
                    return invertedSymbolMap[character] || invertedNuDigitsMap[character] || character;
                }).join("");
                switch(type){
                    case "infinity":
                        number = Infinity;
                        break;
                    case "nan":
                        number = NaN;
                        break;
                    case "number":
                        // Remove grouping separators.
                        lexeme = lexeme.replace(/,/g, "");
                        number = +lexeme;
                        break;
                    case "prefix":
                    case "negativePrefix":
                        prefix = lexeme;
                        break;
                    case "suffix":
                        suffix = lexeme;
                        break;
                    case "negativeSuffix":
                        suffix = lexeme;
                        negative = true;
                        break;
                    // This should never be reached.
                    default:
                        throw new Error("Internal error");
                }
                return "";
            };
        }
        function tokenizeNParse(_value, grammar) {
            return grammar.some(function(statement) {
                var value = _value;
                // The whole grammar statement should be used (i.e., .every() return true) and value be
                // entirely consumed (i.e., !value.length).
                return statement.every(function(type) {
                    if (value.match(tokenizer[type]) === null) return false;
                    // Consume and parse it.
                    value = value.replace(tokenizer[type], parse(type));
                    return true;
                }) && !value.length;
            });
        }
        valid = tokenizeNParse(value, grammar);
        // NaN
        if (!valid || isNaN(number)) return NaN;
        prefixNSuffix = "" + prefix + suffix;
        // Percent
        if (prefixNSuffix.indexOf("%") !== -1) number /= 100;
        else if (prefixNSuffix.indexOf("‰") !== -1) number /= 1000;
        // Negative number
        if (negative) number *= -1;
        return number;
    };
    var numberParserFn = function(properties) {
        return function numberParser(value) {
            validateParameterPresence(value, "value");
            validateParameterTypeString(value, "value");
            return numberParse(value, properties);
        };
    };
    var numberToPartsFormatterFn = function(properties, pluralGenerator) {
        return function numberToPartsFormatter(value) {
            validateParameterPresence(value, "value");
            validateParameterTypeNumber(value, "value");
            return numberFormat(value, properties, pluralGenerator);
        };
    };
    var numberTruncate = function(value) {
        if (isNaN(value)) return NaN;
        return Math[value < 0 ? "ceil" : "floor"](value);
    };
    /**
 * round( method )
 *
 * @method [String] with either "round", "ceil", "floor", or "truncate".
 *
 * Return function( value, incrementOrExp ):
 *
 *   @value [Number] eg. 123.45.
 *
 *   @incrementOrExp [Number] optional, eg. 0.1; or
 *     [Object] Either { increment: <value> } or { exponent: <value> }
 *
 *   Return the rounded number, eg:
 *   - round( "round" )( 123.45 ): 123;
 *   - round( "ceil" )( 123.45 ): 124;
 *   - round( "floor" )( 123.45 ): 123;
 *   - round( "truncate" )( 123.45 ): 123;
 *   - round( "round" )( 123.45, 0.1 ): 123.5;
 *   - round( "round" )( 123.45, 10 ): 120;
 *
 *   Based on https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Math/round
 *   Ref: #376
 */ var numberRound = function(method) {
        method = method || "round";
        method = method === "truncate" ? numberTruncate : Math[method];
        return function(value, incrementOrExp) {
            var exp, increment;
            value = +value;
            // If the value is not a number, return NaN.
            if (isNaN(value)) return NaN;
            // Exponent given.
            if (typeof incrementOrExp === "object" && incrementOrExp.exponent) {
                exp = +incrementOrExp.exponent;
                increment = 1;
                if (exp === 0) return method(value);
                // If the exp is not an integer, return NaN.
                if (!(typeof exp === "number" && exp % 1 === 0)) return NaN;
            // Increment given.
            } else {
                increment = +incrementOrExp || 1;
                if (increment === 1) return method(value);
                // If the increment is not a number, return NaN.
                if (isNaN(increment)) return NaN;
                increment = increment.toExponential().split("e");
                exp = +increment[1];
                increment = +increment[0];
            }
            // Shift & Round
            value = value.toString().split("e");
            value[0] = +value[0] / increment;
            value[1] = value[1] ? +value[1] - exp : -exp;
            value = method(+(value[0] + "e" + value[1]));
            // Shift back
            value = value.toString().split("e");
            value[0] = +value[0] * increment;
            value[1] = value[1] ? +value[1] + exp : exp;
            return +(value[0] + "e" + value[1]);
        };
    };
    Globalize._createErrorUnsupportedFeature = createErrorUnsupportedFeature;
    Globalize._looseMatching = looseMatching;
    Globalize._numberFormat = numberFormat;
    Globalize._numberFormatterFn = numberFormatterFn;
    Globalize._numberParse = numberParse;
    Globalize._numberParserFn = numberParserFn;
    Globalize._numberRound = numberRound;
    Globalize._numberToPartsFormatterFn = numberToPartsFormatterFn;
    Globalize._removeLiteralQuotes = removeLiteralQuotes;
    Globalize._validateParameterPresence = validateParameterPresence;
    Globalize._validateParameterTypeNumber = validateParameterTypeNumber;
    Globalize._validateParameterTypeString = validateParameterTypeString;
    // Stamp runtimeKey and return cached fn.
    // Note, this function isn't made common to all formatters and parsers, because in practice this is
    // only used (at the moment) for numberFormatter used by unitFormatter.
    // TODO: Move this function into a common place when this is used by different formatters.
    function cached(runtimeKey) {
        Globalize[runtimeKey].runtimeKey = runtimeKey;
        return Globalize[runtimeKey];
    }
    Globalize.numberFormatter = Globalize.prototype.numberFormatter = function(options) {
        options = options || {};
        return cached(runtimeKey("numberFormatter", this._locale, [
            options
        ]));
    };
    Globalize.numberToPartsFormatter = Globalize.prototype.numberToPartsFormatter = function(options) {
        options = options || {};
        return cached(runtimeKey("numberToPartsFormatter", this._locale, [
            options
        ]));
    };
    Globalize.numberParser = Globalize.prototype.numberParser = function(options) {
        options = options || {};
        return Globalize[runtimeKey("numberParser", this._locale, [
            options
        ])];
    };
    Globalize.formatNumber = Globalize.prototype.formatNumber = function(value, options) {
        validateParameterPresence(value, "value");
        validateParameterTypeNumber(value, "value");
        return this.numberFormatter(options)(value);
    };
    Globalize.formatNumberToParts = Globalize.prototype.formatNumberToParts = function(value, options) {
        validateParameterPresence(value, "value");
        validateParameterTypeNumber(value, "value");
        return this.numberFormatter(options)(value);
    };
    Globalize.parseNumber = Globalize.prototype.parseNumber = function(value, options) {
        validateParameterPresence(value, "value");
        validateParameterTypeString(value, "value");
        return this.numberParser(options)(value);
    };
    return Globalize;
});

});
parcelRequire.register("3Bcu1", function(module, exports) {
/**
 * Globalize Runtime v1.7.0
 *
 * https://github.com/globalizejs/globalize
 *
 * Copyright OpenJS Foundation and other contributors
 * Released under the MIT license
 * https://jquery.org/license
 *
 * Date: 2021-08-02T11:53Z
 */ /*!
 * Globalize Runtime v1.7.0 2021-08-02T11:53Z Released under the MIT license
 * http://git.io/TrdQbw
 */ (function(root, factory) {
    "use strict";
    // UMD returnExports
    if (typeof define === "function" && define.amd) // AMD
    define(factory);
    else // Node, CommonJS
    module.exports = factory();
})(module.exports, function() {
    /**
 * A toString method that outputs meaningful values for objects or arrays and
 * still performs as fast as a plain string in case variable is string, or as
 * fast as `"" + number` in case variable is a number.
 * Ref: http://jsperf.com/my-stringify
 */ var toString = function(variable) {
        return typeof variable === "string" ? variable : typeof variable === "number" ? "" + variable : JSON.stringify(variable);
    };
    /**
 * formatMessage( message, data )
 *
 * @message [String] A message with optional {vars} to be replaced.
 *
 * @data [Array or JSON] Object with replacing-variables content.
 *
 * Return the formatted message. For example:
 *
 * - formatMessage( "{0} second", [ 1 ] ); // 1 second
 *
 * - formatMessage( "{0}/{1}", ["m", "s"] ); // m/s
 *
 * - formatMessage( "{name} <{email}>", {
 *     name: "Foo",
 *     email: "bar@baz.qux"
 *   }); // Foo <bar@baz.qux>
 */ var formatMessage = function(message, data) {
        // Replace {attribute}'s
        message = message.replace(/{[0-9a-zA-Z-_. ]+}/g, function(name) {
            name = name.replace(/^{([^}]*)}$/, "$1");
            return toString(data[name]);
        });
        return message;
    };
    var objectExtend = function() {
        var destination = arguments[0], sources = [].slice.call(arguments, 1);
        sources.forEach(function(source) {
            var prop;
            for(prop in source)destination[prop] = source[prop];
        });
        return destination;
    };
    var createError = function(code, message, attributes) {
        var error;
        message = code + (message ? ": " + formatMessage(message, attributes) : "");
        error = new Error(message);
        error.code = code;
        objectExtend(error, attributes);
        return error;
    };
    /**
 * Pushes part to parts array, concat two consecutive parts of the same type.
 */ var partsPush = function(parts, type, value) {
        // Concat two consecutive parts of same type
        if (parts.length && parts[parts.length - 1].type === type) {
            parts[parts.length - 1].value += value;
            return;
        }
        parts.push({
            type: type,
            value: value
        });
    };
    /**
 * formatMessage( message, data )
 *
 * @message [String] A message with optional {vars} to be replaced.
 *
 * @data [Array or JSON] Object with replacing-variables content.
 *
 * Return the formatted message. For example:
 *
 * - formatMessage( "{0} second", [ 1 ] );
 * > [{type: "variable", value: "1", name: "0"}, {type: "literal", value: " second"}]
 *
 * - formatMessage( "{0}/{1}", ["m", "s"] );
 * > [
 *     { type: "variable", value: "m", name: "0" },
 *     { type: "literal", value: " /" },
 *     { type: "variable", value: "s", name: "1" }
 *   ]
 */ var formatMessageToParts = function(message, data) {
        var lastOffset = 0, parts = [];
        // Create parts.
        message.replace(/{[0-9a-zA-Z-_. ]+}/g, function(nameIncludingBrackets, offset) {
            var name = nameIncludingBrackets.slice(1, -1);
            partsPush(parts, "literal", message.slice(lastOffset, offset));
            partsPush(parts, "variable", data[name]);
            parts[parts.length - 1].name = name;
            lastOffset += offset + nameIncludingBrackets.length;
        });
        // Skip empty ones such as `{ type: 'literal', value: '' }`.
        return parts.filter(function(part) {
            return part.value !== "";
        });
    };
    /**
 * Returns joined parts values.
 */ var partsJoin = function(parts) {
        return parts.map(function(part) {
            return part.value;
        }).join("");
    };
    var runtimeStringify = function(args) {
        return JSON.stringify(args, function(_key, value) {
            if (value && value.runtimeKey) return value.runtimeKey;
            return value;
        });
    };
    // Based on http://stackoverflow.com/questions/7616461/generate-a-hash-from-string-in-javascript-jquery
    var stringHash = function(str) {
        return [].reduce.call(str, function(hash, i) {
            var chr = i.charCodeAt(0);
            hash = (hash << 5) - hash + chr;
            return hash | 0;
        }, 0);
    };
    var runtimeKey = function(fnName, locale, args, argsStr) {
        var hash;
        argsStr = argsStr || runtimeStringify(args);
        hash = stringHash(fnName + locale + argsStr);
        return hash > 0 ? "a" + hash : "b" + Math.abs(hash);
    };
    var validate = function(code, message, check, attributes) {
        if (!check) throw createError(code, message, attributes);
    };
    var validateParameterPresence = function(value, name) {
        validate("E_MISSING_PARAMETER", "Missing required parameter `{name}`.", value !== undefined, {
            name: name
        });
    };
    var validateParameterType = function(value, name, check, expected) {
        validate("E_INVALID_PAR_TYPE", "Invalid `{name}` parameter ({value}). {expected} expected.", check, {
            expected: expected,
            name: name,
            value: value
        });
    };
    var validateParameterTypeString = function(value, name) {
        validateParameterType(value, name, value === undefined || typeof value === "string", "a string");
    };
    // ref: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Guide/Regular_Expressions?redirectlocale=en-US&redirectslug=JavaScript%2FGuide%2FRegular_Expressions
    var regexpEscape = function(string) {
        return string.replace(/([.*+?^=!:${}()|\[\]\/\\])/g, "\\$1");
    };
    var stringPad = function(str, count, right) {
        var length;
        if (typeof str !== "string") str = String(str);
        for(length = str.length; length < count; length += 1)str = right ? str + "0" : "0" + str;
        return str;
    };
    function Globalize(locale) {
        if (!(this instanceof Globalize)) return new Globalize(locale);
        validateParameterPresence(locale, "locale");
        validateParameterTypeString(locale, "locale");
        this._locale = locale;
    }
    Globalize.locale = function(locale) {
        validateParameterTypeString(locale, "locale");
        if (arguments.length) this._locale = locale;
        return this._locale;
    };
    Globalize._createError = createError;
    Globalize._formatMessage = formatMessage;
    Globalize._formatMessageToParts = formatMessageToParts;
    Globalize._partsJoin = partsJoin;
    Globalize._partsPush = partsPush;
    Globalize._regexpEscape = regexpEscape;
    Globalize._runtimeKey = runtimeKey;
    Globalize._stringPad = stringPad;
    Globalize._validateParameterPresence = validateParameterPresence;
    Globalize._validateParameterTypeString = validateParameterTypeString;
    Globalize._validateParameterType = validateParameterType;
    return Globalize;
});

});


parcelRequire.register("Tuopc", function(module, exports) {

/**
 * Globalize Runtime v1.7.0
 *
 * https://github.com/globalizejs/globalize
 *
 * Copyright OpenJS Foundation and other contributors
 * Released under the MIT license
 * https://jquery.org/license
 *
 * Date: 2021-08-02T11:53Z
 */ /*!
 * Globalize Runtime v1.7.0 2021-08-02T11:53Z Released under the MIT license
 * http://git.io/TrdQbw
 */ (function(root, factory) {
    "use strict";
    // UMD returnExports
    if (typeof define === "function" && define.amd) // AMD
    define([
        "../globalize-runtime"
    ], factory);
    else // Node, CommonJS
    module.exports = factory((parcelRequire("3Bcu1")));
})(module.exports, function(Globalize) {
    var runtimeKey = Globalize._runtimeKey, validateParameterPresence = Globalize._validateParameterPresence, validateParameterType = Globalize._validateParameterType;
    var validateParameterTypeNumber = function(value, name) {
        validateParameterType(value, name, value === undefined || typeof value === "number", "Number");
    };
    var pluralGeneratorFn = function(plural) {
        return function pluralGenerator(value) {
            validateParameterPresence(value, "value");
            validateParameterTypeNumber(value, "value");
            return plural(value);
        };
    };
    Globalize._pluralGeneratorFn = pluralGeneratorFn;
    Globalize._validateParameterTypeNumber = validateParameterTypeNumber;
    Globalize.plural = Globalize.prototype.plural = function(value, options) {
        validateParameterPresence(value, "value");
        validateParameterTypeNumber(value, "value");
        return this.pluralGenerator(options)(value);
    };
    Globalize.pluralGenerator = Globalize.prototype.pluralGenerator = function(options) {
        options = options || {};
        return Globalize[runtimeKey("pluralGenerator", this._locale, [
            options
        ])];
    };
    return Globalize;
});

});

parcelRequire.register("eqT18", function(module, exports) {


/**
 * Globalize Runtime v1.7.0
 *
 * https://github.com/globalizejs/globalize
 *
 * Copyright OpenJS Foundation and other contributors
 * Released under the MIT license
 * https://jquery.org/license
 *
 * Date: 2021-08-02T11:53Z
 */ /*!
 * Globalize Runtime v1.7.0 2021-08-02T11:53Z Released under the MIT license
 * http://git.io/TrdQbw
 */ (function(root, factory) {
    "use strict";
    // UMD returnExports
    if (typeof define === "function" && define.amd) // AMD
    define([
        "../globalize-runtime",
        "./number"
    ], factory);
    else // Node, CommonJS
    module.exports = factory((parcelRequire("3Bcu1")), (parcelRequire("kNVX6")));
})(module.exports, function(Globalize) {
    var createErrorUnsupportedFeature = Globalize._createErrorUnsupportedFeature, looseMatching = Globalize._looseMatching, partsJoin = Globalize._partsJoin, partsPush = Globalize._partsPush, regexpEscape = Globalize._regexpEscape, removeLiteralQuotes = Globalize._removeLiteralQuotes, runtimeKey = Globalize._runtimeKey, stringPad = Globalize._stringPad, validateParameterPresence = Globalize._validateParameterPresence, validateParameterType = Globalize._validateParameterType, validateParameterTypeString = Globalize._validateParameterTypeString;
    var validateParameterTypeDate = function(value, name) {
        validateParameterType(value, name, value === undefined || value instanceof Date, "Date");
    };
    var ZonedDateTime = function() {
        function definePrivateProperty(object, property, value) {
            Object.defineProperty(object, property, {
                value: value
            });
        }
        function getUntilsIndex(original, untils) {
            var index = 0;
            var originalTime = original.getTime();
            // TODO Should we do binary search for improved performance?
            while(index < untils.length - 1 && originalTime >= untils[index])index++;
            return index;
        }
        function setWrap(fn) {
            var offset1 = this.getTimezoneOffset();
            var ret = fn();
            this.original.setTime(new Date(this.getTime()));
            var offset2 = this.getTimezoneOffset();
            if (offset2 - offset1) this.original.setMinutes(this.original.getMinutes() + offset2 - offset1);
            return ret;
        }
        var ZonedDateTime = function(date, timeZoneData) {
            definePrivateProperty(this, "original", new Date(date.getTime()));
            definePrivateProperty(this, "local", new Date(date.getTime()));
            definePrivateProperty(this, "timeZoneData", timeZoneData);
            definePrivateProperty(this, "setWrap", setWrap);
            if (!(timeZoneData.untils && timeZoneData.offsets && timeZoneData.isdsts)) throw new Error("Invalid IANA data");
            this.setTime(this.local.getTime() - this.getTimezoneOffset() * 60000);
        };
        ZonedDateTime.prototype.clone = function() {
            return new ZonedDateTime(this.original, this.timeZoneData);
        };
        // Date field getters.
        [
            "getFullYear",
            "getMonth",
            "getDate",
            "getDay",
            "getHours",
            "getMinutes",
            "getSeconds",
            "getMilliseconds"
        ].forEach(function(method) {
            // Corresponding UTC method, e.g., "getUTCFullYear" if method === "getFullYear".
            var utcMethod = "getUTC" + method.substr(3);
            ZonedDateTime.prototype[method] = function() {
                return this.local[utcMethod]();
            };
        });
        // Note: Define .valueOf = .getTime for arithmetic operations like date1 - date2.
        ZonedDateTime.prototype.valueOf = ZonedDateTime.prototype.getTime = function() {
            return this.local.getTime() + this.getTimezoneOffset() * 60000;
        };
        ZonedDateTime.prototype.getTimezoneOffset = function() {
            var index = getUntilsIndex(this.original, this.timeZoneData.untils);
            return this.timeZoneData.offsets[index];
        };
        // Date field setters.
        [
            "setFullYear",
            "setMonth",
            "setDate",
            "setHours",
            "setMinutes",
            "setSeconds",
            "setMilliseconds"
        ].forEach(function(method) {
            // Corresponding UTC method, e.g., "setUTCFullYear" if method === "setFullYear".
            var utcMethod = "setUTC" + method.substr(3);
            ZonedDateTime.prototype[method] = function(value) {
                var local = this.local;
                // Note setWrap is needed for seconds and milliseconds just because
                // abs(value) could be >= a minute.
                return this.setWrap(function() {
                    return local[utcMethod](value);
                });
            };
        });
        ZonedDateTime.prototype.setTime = function(time) {
            return this.local.setTime(time);
        };
        ZonedDateTime.prototype.isDST = function() {
            var index = getUntilsIndex(this.original, this.timeZoneData.untils);
            return Boolean(this.timeZoneData.isdsts[index]);
        };
        ZonedDateTime.prototype.inspect = function() {
            var index = getUntilsIndex(this.original, this.timeZoneData.untils);
            var abbrs = this.timeZoneData.abbrs;
            return this.local.toISOString().replace(/Z$/, "") + " " + (abbrs && abbrs[index] + " " || this.getTimezoneOffset() * -1 + " ") + (this.isDST() ? "(daylight savings)" : "");
        };
        ZonedDateTime.prototype.toDate = function() {
            return new Date(this.getTime());
        };
        // Type cast getters.
        [
            "toISOString",
            "toJSON",
            "toUTCString"
        ].forEach(function(method) {
            ZonedDateTime.prototype[method] = function() {
                return this.toDate()[method]();
            };
        });
        return ZonedDateTime;
    }();
    /**
 * dayOfWeek( date, firstDay )
 *
 * @date
 *
 * @firstDay the result of `dateFirstDayOfWeek( cldr )`
 *
 * Return the day of the week normalized by the territory's firstDay [0-6].
 * Eg for "mon":
 * - return 0 if territory is GB, or BR, or DE, or FR (week starts on "mon");
 * - return 1 if territory is US (week starts on "sun");
 * - return 2 if territory is EG (week starts on "sat");
 */ var dateDayOfWeek = function(date, firstDay) {
        return (date.getDay() - firstDay + 7) % 7;
    };
    /**
 * distanceInDays( from, to )
 *
 * Return the distance in days between from and to Dates.
 */ var dateDistanceInDays = function(from, to) {
        var inDays = 864e5;
        return (to.getTime() - from.getTime()) / inDays;
    };
    /**
 * startOf changes the input to the beginning of the given unit.
 *
 * For example, starting at the start of a day, resets hours, minutes
 * seconds and milliseconds to 0. Starting at the month does the same, but
 * also sets the date to 1.
 *
 * Returns the modified date
 */ var dateStartOf = function(date, unit) {
        date = date instanceof ZonedDateTime ? date.clone() : new Date(date.getTime());
        switch(unit){
            case "year":
                date.setMonth(0);
            /* falls through */ case "month":
                date.setDate(1);
            /* falls through */ case "day":
                date.setHours(0);
            /* falls through */ case "hour":
                date.setMinutes(0);
            /* falls through */ case "minute":
                date.setSeconds(0);
            /* falls through */ case "second":
                date.setMilliseconds(0);
        }
        return date;
    };
    /**
 * dayOfYear
 *
 * Return the distance in days of the date to the begin of the year [0-d].
 */ var dateDayOfYear = function(date) {
        return Math.floor(dateDistanceInDays(dateStartOf(date, "year"), date));
    };
    /**
 * Returns a new object created by using `object`'s values as keys, and the keys as values.
 */ var objectInvert = function(object, fn) {
        fn = fn || function(object, key, value) {
            object[value] = key;
            return object;
        };
        return Object.keys(object).reduce(function(newObject, key) {
            return fn(newObject, key, object[key]);
        }, {});
    };
    // Invert key and values, e.g., {"year": "yY"} ==> {"y": "year", "Y": "year"}
    var dateFieldsMap = objectInvert({
        "era": "G",
        "year": "yY",
        "quarter": "qQ",
        "month": "ML",
        "week": "wW",
        "day": "dDF",
        "weekday": "ecE",
        "dayperiod": "a",
        "hour": "hHkK",
        "minute": "m",
        "second": "sSA",
        "zone": "zvVOxX"
    }, function(object, key, value) {
        value.split("").forEach(function(symbol) {
            object[symbol] = key;
        });
        return object;
    });
    /**
 * millisecondsInDay
 */ var dateMillisecondsInDay = function(date) {
        // TODO Handle daylight savings discontinuities
        return date - dateStartOf(date, "day");
    };
    var datePatternRe = /([a-z])\1*|'([^']|'')+'|''|./ig;
    /**
 * hourFormat( date, format, timeSeparator, formatNumber )
 *
 * Return date's timezone offset according to the format passed.
 * Eg for format when timezone offset is 180:
 * - "+H;-H": -3
 * - "+HHmm;-HHmm": -0300
 * - "+HH:mm;-HH:mm": -03:00
 * - "+HH:mm:ss;-HH:mm:ss": -03:00:00
 */ var dateTimezoneHourFormat = function(date, format, timeSeparator, formatNumber) {
        var absOffset, offset = date.getTimezoneOffset();
        absOffset = Math.abs(offset);
        formatNumber = formatNumber || {
            1: function(value) {
                return stringPad(value, 1);
            },
            2: function(value) {
                return stringPad(value, 2);
            }
        };
        return format// Pick the correct sign side (+ or -).
        .split(";")[offset > 0 ? 1 : 0]// Localize time separator
        .replace(":", timeSeparator)// Update hours offset.
        .replace(/HH?/, function(match) {
            return formatNumber[match.length](Math.floor(absOffset / 60));
        })// Update minutes offset and return.
        .replace(/mm/, function() {
            return formatNumber[2](Math.floor(absOffset % 60));
        })// Update minutes offset and return.
        .replace(/ss/, function() {
            return formatNumber[2](Math.floor(absOffset % 1 * 60));
        });
    };
    var dateWeekDays = [
        "sun",
        "mon",
        "tue",
        "wed",
        "thu",
        "fri",
        "sat"
    ];
    /**
 * format( date, properties )
 *
 * @date [Date instance].
 *
 * @properties
 *
 * TODO Support other calendar types.
 *
 * Disclosure: this function borrows excerpts of dojo/date/locale.
 */ var dateFormat = function(date, numberFormatters, properties) {
        var parts = [];
        var timeSeparator = properties.timeSeparator;
        // create globalize date with given timezone data
        if (properties.timeZoneData) date = new ZonedDateTime(date, properties.timeZoneData());
        properties.pattern.replace(datePatternRe, function(current) {
            var aux, dateField, type, value, chr = current.charAt(0), length = current.length;
            if (chr === "j") // Locale preferred hHKk.
            // http://www.unicode.org/reports/tr35/tr35-dates.html#Time_Data
            chr = properties.preferredTime;
            if (chr === "Z") {
                // Z..ZZZ: same as "xxxx".
                if (length < 4) {
                    chr = "x";
                    length = 4;
                // ZZZZ: same as "OOOO".
                } else if (length < 5) {
                    chr = "O";
                    length = 4;
                // ZZZZZ: same as "XXXXX"
                } else {
                    chr = "X";
                    length = 5;
                }
            }
            // z...zzz: "{shortRegion}", e.g., "PST" or "PDT".
            // zzzz: "{regionName} {Standard Time}" or "{regionName} {Daylight Time}",
            //       e.g., "Pacific Standard Time" or "Pacific Daylight Time".
            if (chr === "z") {
                if (date.isDST) value = date.isDST() ? properties.daylightTzName : properties.standardTzName;
                // Fall back to "O" format.
                if (!value) {
                    chr = "O";
                    if (length < 4) length = 1;
                }
            }
            switch(chr){
                // Era
                case "G":
                    value = properties.eras[date.getFullYear() < 0 ? 0 : 1];
                    break;
                // Year
                case "y":
                    // Plain year.
                    // The length specifies the padding, but for two letters it also specifies the
                    // maximum length.
                    value = date.getFullYear();
                    if (length === 2) {
                        value = String(value);
                        value = +value.substr(value.length - 2);
                    }
                    break;
                case "Y":
                    // Year in "Week of Year"
                    // The length specifies the padding, but for two letters it also specifies the
                    // maximum length.
                    // yearInWeekofYear = date + DaysInAWeek - (dayOfWeek - firstDay) - minDays
                    value = new Date(date.getTime());
                    value.setDate(value.getDate() + 7 - dateDayOfWeek(date, properties.firstDay) - properties.firstDay - properties.minDays);
                    value = value.getFullYear();
                    if (length === 2) {
                        value = String(value);
                        value = +value.substr(value.length - 2);
                    }
                    break;
                // Quarter
                case "Q":
                case "q":
                    value = Math.ceil((date.getMonth() + 1) / 3);
                    if (length > 2) value = properties.quarters[chr][length][value];
                    break;
                // Month
                case "M":
                case "L":
                    value = date.getMonth() + 1;
                    if (length > 2) value = properties.months[chr][length][value];
                    break;
                // Week
                case "w":
                    // Week of Year.
                    // woy = ceil( ( doy + dow of 1/1 ) / 7 ) - minDaysStuff ? 1 : 0.
                    // TODO should pad on ww? Not documented, but I guess so.
                    value = dateDayOfWeek(dateStartOf(date, "year"), properties.firstDay);
                    value = Math.ceil((dateDayOfYear(date) + value) / 7) - (7 - value >= properties.minDays ? 0 : 1);
                    break;
                case "W":
                    // Week of Month.
                    // wom = ceil( ( dom + dow of `1/month` ) / 7 ) - minDaysStuff ? 1 : 0.
                    value = dateDayOfWeek(dateStartOf(date, "month"), properties.firstDay);
                    value = Math.ceil((date.getDate() + value) / 7) - (7 - value >= properties.minDays ? 0 : 1);
                    break;
                // Day
                case "d":
                    value = date.getDate();
                    break;
                case "D":
                    value = dateDayOfYear(date) + 1;
                    break;
                case "F":
                    // Day of Week in month. eg. 2nd Wed in July.
                    value = Math.floor(date.getDate() / 7) + 1;
                    break;
                // Week day
                case "e":
                case "c":
                    if (length <= 2) {
                        // Range is [1-7] (deduced by example provided on documentation)
                        // TODO Should pad with zeros (not specified in the docs)?
                        value = dateDayOfWeek(date, properties.firstDay) + 1;
                        break;
                    }
                /* falls through */ case "E":
                    value = dateWeekDays[date.getDay()];
                    value = properties.days[chr][length][value];
                    break;
                // Period (AM or PM)
                case "a":
                    value = properties.dayPeriods[date.getHours() < 12 ? "am" : "pm"];
                    break;
                // Hour
                case "h":
                    value = date.getHours() % 12 || 12;
                    break;
                case "H":
                    value = date.getHours();
                    break;
                case "K":
                    value = date.getHours() % 12;
                    break;
                case "k":
                    value = date.getHours() || 24;
                    break;
                // Minute
                case "m":
                    value = date.getMinutes();
                    break;
                // Second
                case "s":
                    value = date.getSeconds();
                    break;
                case "S":
                    value = Math.round(date.getMilliseconds() * Math.pow(10, length - 3));
                    break;
                case "A":
                    value = Math.round(dateMillisecondsInDay(date) * Math.pow(10, length - 3));
                    break;
                // Zone
                case "z":
                    break;
                case "v":
                    // v...vvv: "{shortRegion}", eg. "PT".
                    // vvvv: "{regionName} {Time}",
                    //       e.g., "Pacific Time".
                    if (properties.genericTzName) {
                        value = properties.genericTzName;
                        break;
                    }
                /* falls through */ case "V":
                    //VVVV: "{explarCity} {Time}", e.g., "Los Angeles Time"
                    if (properties.timeZoneName) {
                        value = properties.timeZoneName;
                        break;
                    }
                    if (current === "v") length = 1;
                /* falls through */ case "O":
                    // O: "{gmtFormat}+H;{gmtFormat}-H" or "{gmtZeroFormat}", eg. "GMT-8" or "GMT".
                    // OOOO: "{gmtFormat}{hourFormat}" or "{gmtZeroFormat}", eg. "GMT-08:00" or "GMT".
                    if (date.getTimezoneOffset() === 0) value = properties.gmtZeroFormat;
                    else {
                        // If O..OOO and timezone offset has non-zero minutes, show minutes.
                        if (length < 4) {
                            aux = date.getTimezoneOffset();
                            aux = properties.hourFormat[aux % 60 - aux % 1 === 0 ? 0 : 1];
                        } else aux = properties.hourFormat;
                        value = dateTimezoneHourFormat(date, aux, timeSeparator, numberFormatters);
                        value = properties.gmtFormat.replace(/\{0\}/, value);
                    }
                    break;
                case "X":
                    // Same as x*, except it uses "Z" for zero offset.
                    if (date.getTimezoneOffset() === 0) {
                        value = "Z";
                        break;
                    }
                /* falls through */ case "x":
                    // x: hourFormat("+HH[mm];-HH[mm]")
                    // xx: hourFormat("+HHmm;-HHmm")
                    // xxx: hourFormat("+HH:mm;-HH:mm")
                    // xxxx: hourFormat("+HHmm[ss];-HHmm[ss]")
                    // xxxxx: hourFormat("+HH:mm[:ss];-HH:mm[:ss]")
                    aux = date.getTimezoneOffset();
                    // If x and timezone offset has non-zero minutes, use xx (i.e., show minutes).
                    if (length === 1 && aux % 60 - aux % 1 !== 0) length += 1;
                    // If (xxxx or xxxxx) and timezone offset has zero seconds, use xx or xxx
                    // respectively (i.e., don't show optional seconds).
                    if ((length === 4 || length === 5) && aux % 1 === 0) length -= 2;
                    value = [
                        "+HH;-HH",
                        "+HHmm;-HHmm",
                        "+HH:mm;-HH:mm",
                        "+HHmmss;-HHmmss",
                        "+HH:mm:ss;-HH:mm:ss"
                    ][length - 1];
                    value = dateTimezoneHourFormat(date, value, ":");
                    break;
                // timeSeparator
                case ":":
                    value = timeSeparator;
                    break;
                // ' literals.
                case "'":
                    value = removeLiteralQuotes(current);
                    break;
                // Anything else is considered a literal, including [ ,:/.@#], chinese, japonese, and
                // arabic characters.
                default:
                    value = current;
            }
            if (typeof value === "number") value = numberFormatters[length](value);
            dateField = dateFieldsMap[chr];
            type = dateField ? dateField : "literal";
            partsPush(parts, type, value);
        });
        return parts;
    };
    var dateFormatterFn = function(dateToPartsFormatter) {
        return function dateFormatter(value) {
            return partsJoin(dateToPartsFormatter(value));
        };
    };
    /**
 * isLeapYear( year )
 *
 * @year [Number]
 *
 * Returns an indication whether the specified year is a leap year.
 */ var dateIsLeapYear = function(year) {
        return new Date(year, 1, 29).getMonth() === 1;
    };
    /**
 * lastDayOfMonth( date )
 *
 * @date [Date]
 *
 * Return the last day of the given date's month
 */ var dateLastDayOfMonth = function(date) {
        return new Date(date.getFullYear(), date.getMonth() + 1, 0).getDate();
    };
    /**
 * Differently from native date.setDate(), this function returns a date whose
 * day remains inside the month boundaries. For example:
 *
 * setDate( FebDate, 31 ): a "Feb 28" date.
 * setDate( SepDate, 31 ): a "Sep 30" date.
 */ var dateSetDate = function(date, day) {
        var lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0).getDate();
        date.setDate(day < 1 ? 1 : day < lastDay ? day : lastDay);
    };
    /**
 * Differently from native date.setMonth(), this function adjusts date if
 * needed, so final month is always the one set.
 *
 * setMonth( Jan31Date, 1 ): a "Feb 28" date.
 * setDate( Jan31Date, 8 ): a "Sep 30" date.
 */ var dateSetMonth = function(date, month) {
        var originalDate = date.getDate();
        date.setDate(1);
        date.setMonth(month);
        dateSetDate(date, originalDate);
    };
    var outOfRange = function(value, low, high) {
        return value < low || value > high;
    };
    /**
 * parse( value, tokens, properties )
 *
 * @value [String] string date.
 *
 * @tokens [Object] tokens returned by date/tokenizer.
 *
 * @properties [Object] output returned by date/tokenizer-properties.
 *
 * ref: http://www.unicode.org/reports/tr35/tr35-dates.html#Date_Format_Patterns
 */ var dateParse = function(_value, tokens, properties) {
        var amPm, day, daysOfYear, month, era, hour, hour12, timezoneOffset, valid, YEAR = 0, MONTH = 1, DAY = 2, HOUR = 3, MINUTE = 4, SECOND = 5, MILLISECONDS = 6, date = new Date(), truncateAt = [], units = [
            "year",
            "month",
            "day",
            "hour",
            "minute",
            "second",
            "milliseconds"
        ];
        // Create globalize date with given timezone data.
        if (properties.timeZoneData) date = new ZonedDateTime(date, properties.timeZoneData());
        if (!tokens.length) return null;
        valid = tokens.every(function(token) {
            var century, chr, value, length;
            if (token.type === "literal") // continue
            return true;
            chr = token.type.charAt(0);
            length = token.type.length;
            if (chr === "j") // Locale preferred hHKk.
            // http://www.unicode.org/reports/tr35/tr35-dates.html#Time_Data
            chr = properties.preferredTimeData;
            switch(chr){
                // Era
                case "G":
                    truncateAt.push(YEAR);
                    era = +token.value;
                    break;
                // Year
                case "y":
                    value = token.value;
                    if (length === 2) {
                        if (outOfRange(value, 0, 99)) return false;
                        // mimic dojo/date/locale: choose century to apply, according to a sliding
                        // window of 80 years before and 20 years after present year.
                        century = Math.floor(date.getFullYear() / 100) * 100;
                        value += century;
                        if (value > date.getFullYear() + 20) value -= 100;
                    }
                    date.setFullYear(value);
                    truncateAt.push(YEAR);
                    break;
                case "Y":
                    throw createErrorUnsupportedFeature({
                        feature: "year pattern `" + chr + "`"
                    });
                // Quarter (skip)
                case "Q":
                case "q":
                    break;
                // Month
                case "M":
                case "L":
                    if (length <= 2) value = token.value;
                    else value = +token.value;
                    if (outOfRange(value, 1, 12)) return false;
                    // Setting the month later so that we have the correct year and can determine
                    // the correct last day of February in case of leap year.
                    month = value;
                    truncateAt.push(MONTH);
                    break;
                // Week (skip)
                case "w":
                case "W":
                    break;
                // Day
                case "d":
                    day = token.value;
                    truncateAt.push(DAY);
                    break;
                case "D":
                    daysOfYear = token.value;
                    truncateAt.push(DAY);
                    break;
                case "F":
                    break;
                // Week day
                case "e":
                case "c":
                case "E":
                    break;
                // Period (AM or PM)
                case "a":
                    amPm = token.value;
                    break;
                // Hour
                case "h":
                    value = token.value;
                    if (outOfRange(value, 1, 12)) return false;
                    hour = hour12 = true;
                    date.setHours(value === 12 ? 0 : value);
                    truncateAt.push(HOUR);
                    break;
                case "K":
                    value = token.value;
                    if (outOfRange(value, 0, 11)) return false;
                    hour = hour12 = true;
                    date.setHours(value);
                    truncateAt.push(HOUR);
                    break;
                case "k":
                    value = token.value;
                    if (outOfRange(value, 1, 24)) return false;
                    hour = true;
                    date.setHours(value === 24 ? 0 : value);
                    truncateAt.push(HOUR);
                    break;
                case "H":
                    value = token.value;
                    if (outOfRange(value, 0, 23)) return false;
                    hour = true;
                    date.setHours(value);
                    truncateAt.push(HOUR);
                    break;
                // Minute
                case "m":
                    value = token.value;
                    if (outOfRange(value, 0, 59)) return false;
                    date.setMinutes(value);
                    truncateAt.push(MINUTE);
                    break;
                // Second
                case "s":
                    value = token.value;
                    if (outOfRange(value, 0, 59)) return false;
                    date.setSeconds(value);
                    truncateAt.push(SECOND);
                    break;
                case "A":
                    date.setHours(0);
                    date.setMinutes(0);
                    date.setSeconds(0);
                /* falls through */ case "S":
                    value = Math.round(token.value * Math.pow(10, 3 - length));
                    date.setMilliseconds(value);
                    truncateAt.push(MILLISECONDS);
                    break;
                // Zone
                case "z":
                case "Z":
                case "O":
                case "v":
                case "V":
                case "X":
                case "x":
                    if (typeof token.value === "number") timezoneOffset = token.value;
                    break;
            }
            return true;
        });
        if (!valid) return null;
        // 12-hour format needs AM or PM, 24-hour format doesn't, ie. return null
        // if amPm && !hour12 || !amPm && hour12.
        if (hour && !(!amPm ^ hour12)) return null;
        if (era === 0) // 1 BC = year 0
        date.setFullYear(date.getFullYear() * -1 + 1);
        if (month !== undefined) dateSetMonth(date, month - 1);
        if (day !== undefined) {
            if (outOfRange(day, 1, dateLastDayOfMonth(date))) return null;
            date.setDate(day);
        } else if (daysOfYear !== undefined) {
            if (outOfRange(daysOfYear, 1, dateIsLeapYear(date.getFullYear()) ? 366 : 365)) return null;
            date.setMonth(0);
            date.setDate(daysOfYear);
        }
        if (hour12 && amPm === "pm") date.setHours(date.getHours() + 12);
        if (timezoneOffset !== undefined) date.setMinutes(date.getMinutes() + timezoneOffset - date.getTimezoneOffset());
        // Truncate date at the most precise unit defined. Eg.
        // If value is "12/31", and pattern is "MM/dd":
        // => new Date( <current Year>, 12, 31, 0, 0, 0, 0 );
        truncateAt = Math.max.apply(null, truncateAt);
        date = dateStartOf(date, units[truncateAt]);
        // Get date back from globalize date.
        if (date instanceof ZonedDateTime) date = date.toDate();
        return date;
    };
    /* eslint-disable no-unused-expressions */ /**
 * tokenizer( value, numberParser, properties )
 *
 * @value [String] string date.
 *
 * @numberParser [Function]
 *
 * @properties [Object] output returned by date/tokenizer-properties.
 *
 * Returns an Array of tokens, eg. value "5 o'clock PM", pattern "h 'o''clock' a":
 * [{
 *   type: "h",
 *   lexeme: "5"
 * }, {
 *   type: "literal",
 *   lexeme: " "
 * }, {
 *   type: "literal",
 *   lexeme: "o'clock"
 * }, {
 *   type: "literal",
 *   lexeme: " "
 * }, {
 *   type: "a",
 *   lexeme: "PM",
 *   value: "pm"
 * }]
 *
 * OBS: lexeme's are always String and may return invalid ranges depending of the token type.
 * Eg. "99" for month number.
 *
 * Return an empty Array when not successfully parsed.
 */ var dateTokenizer = function(value, numberParser, properties) {
        var digitsRe, valid, tokens = [], widths = [
            "abbreviated",
            "wide",
            "narrow"
        ];
        digitsRe = properties.digitsRe;
        value = looseMatching(value);
        valid = properties.pattern.match(datePatternRe).every(function(current) {
            var aux, chr, length, numeric, tokenRe, token = {};
            function hourFormatParse(tokenRe, numberParser) {
                var aux, isPositive, match = value.match(tokenRe);
                numberParser = numberParser || function(value) {
                    return +value;
                };
                if (!match) return false;
                isPositive = match[1];
                // hourFormat containing H only, e.g., `+H;-H`
                if (match.length < 6) {
                    aux = isPositive ? 1 : 3;
                    token.value = numberParser(match[aux]) * 60;
                // hourFormat containing H and m, e.g., `+HHmm;-HHmm`
                } else if (match.length < 10) {
                    aux = isPositive ? [
                        1,
                        3
                    ] : [
                        5,
                        7
                    ];
                    token.value = numberParser(match[aux[0]]) * 60 + numberParser(match[aux[1]]);
                // hourFormat containing H, m, and s e.g., `+HHmmss;-HHmmss`
                } else {
                    aux = isPositive ? [
                        1,
                        3,
                        5
                    ] : [
                        7,
                        9,
                        11
                    ];
                    token.value = numberParser(match[aux[0]]) * 60 + numberParser(match[aux[1]]) + numberParser(match[aux[2]]) / 60;
                }
                if (isPositive) token.value *= -1;
                return true;
            }
            function oneDigitIfLengthOne() {
                if (length === 1) {
                    // Unicode equivalent to /\d/
                    numeric = true;
                    return tokenRe = digitsRe;
                }
            }
            function oneOrTwoDigitsIfLengthOne() {
                if (length === 1) {
                    // Unicode equivalent to /\d\d?/
                    numeric = true;
                    return tokenRe = new RegExp("^(" + digitsRe.source + "){1,2}");
                }
            }
            function oneOrTwoDigitsIfLengthOneOrTwo() {
                if (length === 1 || length === 2) {
                    // Unicode equivalent to /\d\d?/
                    numeric = true;
                    return tokenRe = new RegExp("^(" + digitsRe.source + "){1,2}");
                }
            }
            function twoDigitsIfLengthTwo() {
                if (length === 2) {
                    // Unicode equivalent to /\d\d/
                    numeric = true;
                    return tokenRe = new RegExp("^(" + digitsRe.source + "){2}");
                }
            }
            // Brute-force test every locale entry in an attempt to match the given value.
            // Return the first found one (and set token accordingly), or null.
            function lookup(path) {
                var array = properties[path.join("/")];
                if (!array) return null;
                // array of pairs [key, value] sorted by desc value length.
                array.some(function(item) {
                    var valueRe = item[1];
                    if (valueRe.test(value)) {
                        token.value = item[0];
                        tokenRe = item[1];
                        return true;
                    }
                });
                return null;
            }
            token.type = current;
            chr = current.charAt(0);
            length = current.length;
            if (chr === "Z") {
                // Z..ZZZ: same as "xxxx".
                if (length < 4) {
                    chr = "x";
                    length = 4;
                // ZZZZ: same as "OOOO".
                } else if (length < 5) {
                    chr = "O";
                    length = 4;
                // ZZZZZ: same as "XXXXX"
                } else {
                    chr = "X";
                    length = 5;
                }
            }
            if (chr === "z") {
                if (properties.standardOrDaylightTzName) {
                    token.value = null;
                    tokenRe = properties.standardOrDaylightTzName;
                }
            }
            // v...vvv: "{shortRegion}", eg. "PT".
            // vvvv: "{regionName} {Time}" or "{regionName} {Time}",
            // e.g., "Pacific Time"
            // http://unicode.org/reports/tr35/tr35-dates.html#Date_Format_Patterns
            if (chr === "v") {
                if (properties.genericTzName) {
                    token.value = null;
                    tokenRe = properties.genericTzName;
                // Fall back to "V" format.
                } else {
                    chr = "V";
                    length = 4;
                }
            }
            if (chr === "V" && properties.timeZoneName) {
                token.value = length === 2 ? properties.timeZoneName : null;
                tokenRe = properties.timeZoneNameRe;
            }
            switch(chr){
                // Era
                case "G":
                    lookup([
                        "gregorian/eras",
                        length <= 3 ? "eraAbbr" : length === 4 ? "eraNames" : "eraNarrow"
                    ]);
                    break;
                // Year
                case "y":
                case "Y":
                    numeric = true;
                    // number l=1:+, l=2:{2}, l=3:{3,}, l=4:{4,}, ...
                    if (length === 1) // Unicode equivalent to /\d+/.
                    tokenRe = new RegExp("^(" + digitsRe.source + ")+");
                    else if (length === 2) // Lenient parsing: there's no year pattern to indicate non-zero-padded 2-digits
                    // year, so parser accepts both zero-padded and non-zero-padded for `yy`.
                    //
                    // Unicode equivalent to /\d\d?/
                    tokenRe = new RegExp("^(" + digitsRe.source + "){1,2}");
                    else // Unicode equivalent to /\d{length,}/
                    tokenRe = new RegExp("^(" + digitsRe.source + "){" + length + ",}");
                    break;
                // Quarter
                case "Q":
                case "q":
                    // number l=1:{1}, l=2:{2}.
                    // lookup l=3...
                    oneDigitIfLengthOne() || twoDigitsIfLengthTwo() || lookup([
                        "gregorian/quarters",
                        chr === "Q" ? "format" : "stand-alone",
                        widths[length - 3]
                    ]);
                    break;
                // Month
                case "M":
                case "L":
                    // number l=1:{1,2}, l=2:{2}.
                    // lookup l=3...
                    //
                    // Lenient parsing: skeleton "yMd" (i.e., one M) may include MM for the pattern,
                    // therefore parser accepts both zero-padded and non-zero-padded for M and MM.
                    // Similar for L.
                    oneOrTwoDigitsIfLengthOneOrTwo() || lookup([
                        "gregorian/months",
                        chr === "M" ? "format" : "stand-alone",
                        widths[length - 3]
                    ]);
                    break;
                // Day
                case "D":
                    // number {l,3}.
                    if (length <= 3) {
                        // Equivalent to /\d{length,3}/
                        numeric = true;
                        tokenRe = new RegExp("^(" + digitsRe.source + "){" + length + ",3}");
                    }
                    break;
                case "W":
                case "F":
                    // number l=1:{1}.
                    oneDigitIfLengthOne();
                    break;
                // Week day
                case "e":
                case "c":
                    // number l=1:{1}, l=2:{2}.
                    // lookup for length >=3.
                    if (length <= 2) {
                        oneDigitIfLengthOne() || twoDigitsIfLengthTwo();
                        break;
                    }
                /* falls through */ case "E":
                    if (length === 6) // Note: if short day names are not explicitly specified, abbreviated day
                    // names are used instead http://www.unicode.org/reports/tr35/tr35-dates.html#months_days_quarters_eras
                    lookup([
                        "gregorian/days",
                        [
                            chr === "c" ? "stand-alone" : "format"
                        ],
                        "short"
                    ]) || lookup([
                        "gregorian/days",
                        [
                            chr === "c" ? "stand-alone" : "format"
                        ],
                        "abbreviated"
                    ]);
                    else lookup([
                        "gregorian/days",
                        [
                            chr === "c" ? "stand-alone" : "format"
                        ],
                        widths[length < 3 ? 0 : length - 3]
                    ]);
                    break;
                // Period (AM or PM)
                case "a":
                    lookup([
                        "gregorian/dayPeriods/format/wide"
                    ]);
                    break;
                // Week
                case "w":
                    // number l1:{1,2}, l2:{2}.
                    oneOrTwoDigitsIfLengthOne() || twoDigitsIfLengthTwo();
                    break;
                // Day, Hour, Minute, or Second
                case "d":
                case "h":
                case "H":
                case "K":
                case "k":
                case "j":
                case "m":
                case "s":
                    // number l1:{1,2}, l2:{2}.
                    //
                    // Lenient parsing:
                    // - skeleton "hms" (i.e., one m) always includes mm for the pattern, i.e., it's
                    //   impossible to use a different skeleton to parse non-zero-padded minutes,
                    //   therefore parser accepts both zero-padded and non-zero-padded for m. Similar
                    //   for seconds s.
                    // - skeleton "hms" (i.e., one h) may include h or hh for the pattern, i.e., it's
                    //   impossible to use a different skeleton to parser non-zero-padded hours for some
                    //   locales, therefore parser accepts both zero-padded and non-zero-padded for h.
                    //   Similar for d (in skeleton yMd).
                    oneOrTwoDigitsIfLengthOneOrTwo();
                    break;
                case "S":
                    // number {l}.
                    // Unicode equivalent to /\d{length}/
                    numeric = true;
                    tokenRe = new RegExp("^(" + digitsRe.source + "){" + length + "}");
                    break;
                case "A":
                    // number {l+5}.
                    // Unicode equivalent to /\d{length+5}/
                    numeric = true;
                    tokenRe = new RegExp("^(" + digitsRe.source + "){" + (length + 5) + "}");
                    break;
                // Zone
                case "v":
                case "V":
                case "z":
                    if (tokenRe && tokenRe.test(value)) break;
                    if (chr === "V" && length === 2) break;
                /* falls through */ case "O":
                    // O: "{gmtFormat}+H;{gmtFormat}-H" or "{gmtZeroFormat}", eg. "GMT-8" or "GMT".
                    // OOOO: "{gmtFormat}{hourFormat}" or "{gmtZeroFormat}", eg. "GMT-08:00" or "GMT".
                    if (value === properties["timeZoneNames/gmtZeroFormat"]) {
                        token.value = 0;
                        tokenRe = properties["timeZoneNames/gmtZeroFormatRe"];
                    } else {
                        aux = properties["timeZoneNames/hourFormat"].some(function(hourFormatRe) {
                            if (hourFormatParse(hourFormatRe, numberParser)) {
                                tokenRe = hourFormatRe;
                                return true;
                            }
                        });
                        if (!aux) return null;
                    }
                    break;
                case "X":
                    // Same as x*, except it uses "Z" for zero offset.
                    if (value === "Z") {
                        token.value = 0;
                        tokenRe = /^Z/;
                        break;
                    }
                /* falls through */ case "x":
                    // x: hourFormat("+HH[mm];-HH[mm]")
                    // xx: hourFormat("+HHmm;-HHmm")
                    // xxx: hourFormat("+HH:mm;-HH:mm")
                    // xxxx: hourFormat("+HHmm[ss];-HHmm[ss]")
                    // xxxxx: hourFormat("+HH:mm[:ss];-HH:mm[:ss]")
                    aux = properties.x.some(function(hourFormatRe) {
                        if (hourFormatParse(hourFormatRe)) {
                            tokenRe = hourFormatRe;
                            return true;
                        }
                    });
                    if (!aux) return null;
                    break;
                case "'":
                    token.type = "literal";
                    tokenRe = new RegExp("^" + regexpEscape(removeLiteralQuotes(current)));
                    break;
                default:
                    token.type = "literal";
                    tokenRe = new RegExp("^" + regexpEscape(current));
            }
            if (!tokenRe) return false;
            // Get lexeme and consume it.
            value = value.replace(tokenRe, function(lexeme) {
                token.lexeme = lexeme;
                if (numeric) token.value = numberParser(lexeme);
                return "";
            });
            if (!token.lexeme) return false;
            if (numeric && isNaN(token.value)) return false;
            tokens.push(token);
            return true;
        });
        if (value !== "") valid = false;
        return valid ? tokens : [];
    };
    var dateParserFn = function(numberParser, parseProperties, tokenizerProperties) {
        return function dateParser(value) {
            var tokens;
            validateParameterPresence(value, "value");
            validateParameterTypeString(value, "value");
            tokens = dateTokenizer(value, numberParser, tokenizerProperties);
            return dateParse(value, tokens, parseProperties) || null;
        };
    };
    var dateToPartsFormatterFn = function(numberFormatters, properties) {
        return function dateToPartsFormatter(value) {
            validateParameterPresence(value, "value");
            validateParameterTypeDate(value, "value");
            return dateFormat(value, numberFormatters, properties);
        };
    };
    Globalize._dateFormat = dateFormat;
    Globalize._dateFormatterFn = dateFormatterFn;
    Globalize._dateParser = dateParse;
    Globalize._dateParserFn = dateParserFn;
    Globalize._dateTokenizer = dateTokenizer;
    Globalize._dateToPartsFormatterFn = dateToPartsFormatterFn;
    Globalize._validateParameterTypeDate = validateParameterTypeDate;
    function optionsHasStyle(options) {
        return options.skeleton !== undefined || options.date !== undefined || options.time !== undefined || options.datetime !== undefined || options.raw !== undefined;
    }
    Globalize.dateFormatter = Globalize.prototype.dateFormatter = function(options) {
        options = options || {};
        if (!optionsHasStyle(options)) options.skeleton = "yMd";
        return Globalize[runtimeKey("dateFormatter", this._locale, [
            options
        ])];
    };
    Globalize.dateToPartsFormatter = Globalize.prototype.dateToPartsFormatter = function(options) {
        options = options || {};
        if (!optionsHasStyle(options)) options.skeleton = "yMd";
        return Globalize[runtimeKey("dateToPartsFormatter", this._locale, [
            options
        ])];
    };
    Globalize.dateParser = Globalize.prototype.dateParser = function(options) {
        options = options || {};
        if (!optionsHasStyle(options)) options.skeleton = "yMd";
        return Globalize[runtimeKey("dateParser", this._locale, [
            options
        ])];
    };
    Globalize.formatDate = Globalize.prototype.formatDate = function(value, options) {
        validateParameterPresence(value, "value");
        validateParameterTypeDate(value, "value");
        return this.dateFormatter(options)(value);
    };
    Globalize.formatDateToParts = Globalize.prototype.formatDateToParts = function(value, options) {
        validateParameterPresence(value, "value");
        validateParameterTypeDate(value, "value");
        return this.dateToPartsFormatter(options)(value);
    };
    Globalize.parseDate = Globalize.prototype.parseDate = function(value, options) {
        validateParameterPresence(value, "value");
        validateParameterTypeString(value, "value");
        return this.dateParser(options)(value);
    };
    return Globalize;
});

});

parcelRequire.register("iHvJ8", function(module, exports) {



/**
 * Globalize Runtime v1.7.0
 *
 * https://github.com/globalizejs/globalize
 *
 * Copyright OpenJS Foundation and other contributors
 * Released under the MIT license
 * https://jquery.org/license
 *
 * Date: 2021-08-02T11:53Z
 */ /*!
 * Globalize Runtime v1.7.0 2021-08-02T11:53Z Released under the MIT license
 * http://git.io/TrdQbw
 */ (function(root, factory) {
    "use strict";
    // UMD returnExports
    if (typeof define === "function" && define.amd) // AMD
    define([
        "../globalize-runtime",
        "./number",
        "./plural"
    ], factory);
    else // Node, CommonJS
    module.exports = factory((parcelRequire("3Bcu1")), (parcelRequire("kNVX6")), (parcelRequire("Tuopc")));
})(module.exports, function(Globalize) {
    var formatMessage = Globalize._formatMessage, runtimeKey = Globalize._runtimeKey, validateParameterPresence = Globalize._validateParameterPresence, validateParameterTypeNumber = Globalize._validateParameterTypeNumber;
    /**
 * format( value, numberFormatter, pluralGenerator, properties )
 *
 * @value [Number] The number to format
 *
 * @numberFormatter [String] A numberFormatter from Globalize.numberFormatter
 *
 * @pluralGenerator [String] A pluralGenerator from Globalize.pluralGenerator
 *
 * @properties [Object] containing relative time plural message.
 *
 * Format relative time.
 */ var relativeTimeFormat = function(value, numberFormatter, pluralGenerator, properties) {
        var relativeTime, message = properties["relative-type-" + value];
        if (message) return message;
        relativeTime = value <= 0 ? properties["relativeTime-type-past"] : properties["relativeTime-type-future"];
        value = Math.abs(value);
        message = relativeTime["relativeTimePattern-count-" + pluralGenerator(value)];
        return formatMessage(message, [
            numberFormatter(value)
        ]);
    };
    var relativeTimeFormatterFn = function(numberFormatter, pluralGenerator, properties) {
        return function relativeTimeFormatter(value) {
            validateParameterPresence(value, "value");
            validateParameterTypeNumber(value, "value");
            return relativeTimeFormat(value, numberFormatter, pluralGenerator, properties);
        };
    };
    Globalize._relativeTimeFormatterFn = relativeTimeFormatterFn;
    Globalize.formatRelativeTime = Globalize.prototype.formatRelativeTime = function(value, unit, options) {
        validateParameterPresence(value, "value");
        validateParameterTypeNumber(value, "value");
        return this.relativeTimeFormatter(unit, options)(value);
    };
    Globalize.relativeTimeFormatter = Globalize.prototype.relativeTimeFormatter = function(unit, options) {
        options = options || {};
        return Globalize[runtimeKey("relativeTimeFormatter", this._locale, [
            unit,
            options
        ])];
    };
    return Globalize;
});

});

parcelRequire.register("aXfaC", function(module, exports) {



/**
 * Globalize Runtime v1.7.0
 *
 * https://github.com/globalizejs/globalize
 *
 * Copyright OpenJS Foundation and other contributors
 * Released under the MIT license
 * https://jquery.org/license
 *
 * Date: 2021-08-02T11:53Z
 */ /*!
 * Globalize Runtime v1.7.0 2021-08-02T11:53Z Released under the MIT license
 * http://git.io/TrdQbw
 */ (function(root, factory) {
    "use strict";
    // UMD returnExports
    if (typeof define === "function" && define.amd) // AMD
    define([
        "../globalize-runtime",
        "./number",
        "./plural"
    ], factory);
    else // Node, CommonJS
    module.exports = factory((parcelRequire("3Bcu1")), (parcelRequire("kNVX6")), (parcelRequire("Tuopc")));
})(module.exports, function(Globalize) {
    var formatMessage = Globalize._formatMessage, runtimeKey = Globalize._runtimeKey, validateParameterPresence = Globalize._validateParameterPresence, validateParameterTypeNumber = Globalize._validateParameterTypeNumber;
    /**
 * format( value, numberFormatter, pluralGenerator, unitProperies )
 *
 * @value [Number]
 *
 * @numberFormatter [Object]: A numberFormatter from Globalize.numberFormatter.
 *
 * @pluralGenerator [Object]: A pluralGenerator from Globalize.pluralGenerator.
 *
 * @unitProperies [Object]: localized unit data from cldr.
 *
 * Format units such as seconds, minutes, days, weeks, etc.
 *
 * OBS:
 *
 * Unit Sequences are not implemented.
 * http://www.unicode.org/reports/tr35/tr35-35/tr35-general.html#Unit_Sequences
 *
 * Duration Unit (for composed time unit durations) is not implemented.
 * http://www.unicode.org/reports/tr35/tr35-35/tr35-general.html#durationUnit
 */ var unitFormat = function(value, numberFormatter, pluralGenerator, unitProperties) {
        var compoundUnitPattern = unitProperties.compoundUnitPattern, dividend, dividendProperties, formattedValue, divisor, divisorProperties, message, pluralValue, oneProperty;
        unitProperties = unitProperties.unitProperties;
        formattedValue = numberFormatter(value);
        pluralValue = pluralGenerator(value);
        // computed compound unit, eg. "megabyte-per-second".
        if (unitProperties instanceof Array) {
            dividendProperties = unitProperties[0];
            divisorProperties = unitProperties[1];
            oneProperty = divisorProperties.hasOwnProperty("one") ? "one" : "other";
            dividend = formatMessage(dividendProperties[pluralValue], [
                formattedValue
            ]);
            divisor = formatMessage(divisorProperties[oneProperty], [
                ""
            ]).trim();
            return formatMessage(compoundUnitPattern, [
                dividend,
                divisor
            ]);
        }
        message = unitProperties[pluralValue];
        return formatMessage(message, [
            formattedValue
        ]);
    };
    var unitFormatterFn = function(numberFormatter, pluralGenerator, unitProperties) {
        return function unitFormatter(value) {
            validateParameterPresence(value, "value");
            validateParameterTypeNumber(value, "value");
            return unitFormat(value, numberFormatter, pluralGenerator, unitProperties);
        };
    };
    Globalize._unitFormatterFn = unitFormatterFn;
    Globalize.formatUnit = Globalize.prototype.formatUnit = function(value, unit, options) {
        return this.unitFormatter(unit, options)(value);
    };
    Globalize.unitFormatter = Globalize.prototype.unitFormatter = function(unit, options) {
        options = options || {};
        return Globalize[runtimeKey("unitFormatter", this._locale, [
            unit,
            options
        ])];
    };
    return Globalize;
});

});




parcelRequire.register("18zyh", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0d421dab438edb07$var$_propTypes = $0d421dab438edb07$var$_interopRequireDefault((parcelRequire("f7UXb")));

var $0d421dab438edb07$var$_react = $0d421dab438edb07$var$_interopRequireDefault((parcelRequire("eO7Kz")));

var $0d421dab438edb07$var$_BasicWebChat = $0d421dab438edb07$var$_interopRequireDefault((parcelRequire("lLEbi")));

var $0d421dab438edb07$var$_Composer = $0d421dab438edb07$var$_interopRequireDefault((parcelRequire("9a3YE")));
var $0d421dab438edb07$var$_excluded = [
    "className",
    "role"
];
function $0d421dab438edb07$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $0d421dab438edb07$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $0d421dab438edb07$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $0d421dab438edb07$var$ownKeys(Object(source), !0).forEach(function(key) {
            $0d421dab438edb07$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $0d421dab438edb07$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $0d421dab438edb07$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $0d421dab438edb07$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $0d421dab438edb07$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $0d421dab438edb07$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
// Please keep this file as simple as possible. This is for setting up the surface (a.k.a. <Composer>) and <BasicWebChat> only.
// Web developers may choose to put things before/after <BasicWebChat> while still inside the surface.
// For example,
// - They can hide our default send box and built their own using hooks
// - They can run hooks outside of activity/attachment middleware
//   - They will put <Composer> as very top of their page, and allow buttons on their existing page to send message to bot
// Subset of landmark roles: https://w3.org/TR/wai-aria/#landmark_roles
var $0d421dab438edb07$var$ARIA_LANDMARK_ROLES = [
    "complementary",
    "contentinfo",
    "form",
    "main",
    "region"
];
var $0d421dab438edb07$var$ReactWebChat = function ReactWebChat(_ref) {
    var className = _ref.className, role = _ref.role, composerProps = $0d421dab438edb07$var$_objectWithoutProperties(_ref, $0d421dab438edb07$var$_excluded);
    return /*#__PURE__*/ $0d421dab438edb07$var$_react.default.createElement($0d421dab438edb07$var$_Composer.default, composerProps, /*#__PURE__*/ $0d421dab438edb07$var$_react.default.createElement($0d421dab438edb07$var$_BasicWebChat.default, {
        className: className,
        role: role
    }));
};
$0d421dab438edb07$var$ReactWebChat.defaultProps = $0d421dab438edb07$var$_objectSpread({
    className: undefined,
    role: undefined
}, $0d421dab438edb07$var$_Composer.default.defaultProps);
var $0d421dab438edb07$var$_Composer$propTypes = $0d421dab438edb07$var$_Composer.default.propTypes, $0d421dab438edb07$var$_ = $0d421dab438edb07$var$_Composer$propTypes.children, $0d421dab438edb07$var$composerPropTypesWithoutChildren = $0d421dab438edb07$var$_objectWithoutProperties($0d421dab438edb07$var$_Composer$propTypes, [
    "children"
]);
$0d421dab438edb07$var$ReactWebChat.propTypes = $0d421dab438edb07$var$_objectSpread({
    className: $0d421dab438edb07$var$_propTypes.default.string,
    // Ignoring deficiencies with TypeScript/PropTypes inference.
    // @ts-ignore
    role: $0d421dab438edb07$var$_propTypes.default.oneOf($0d421dab438edb07$var$ARIA_LANDMARK_ROLES)
}, $0d421dab438edb07$var$composerPropTypesWithoutChildren);
var $0d421dab438edb07$var$_default = $0d421dab438edb07$var$ReactWebChat;
module.exports.default = $0d421dab438edb07$var$_default;

});
parcelRequire.register("lLEbi", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $hd4g0 = parcelRequire("hd4g0");

var $fd8d27ea1c7493b9$var$_classnames = $fd8d27ea1c7493b9$var$_interopRequireDefault((parcelRequire("5A4MD")));

var $fd8d27ea1c7493b9$var$_propTypes = $fd8d27ea1c7493b9$var$_interopRequireDefault((parcelRequire("f7UXb")));

var $fd8d27ea1c7493b9$var$_react = $fd8d27ea1c7493b9$var$_interopRequireDefault((parcelRequire("eO7Kz")));

var $fd8d27ea1c7493b9$var$_Surface = $fd8d27ea1c7493b9$var$_interopRequireDefault((parcelRequire("fFnOT")));

var $fd8d27ea1c7493b9$var$_BasicConnectivityStatus = $fd8d27ea1c7493b9$var$_interopRequireDefault((parcelRequire("8ehZJ")));

var $fd8d27ea1c7493b9$var$_BasicSendBox = $fd8d27ea1c7493b9$var$_interopRequireDefault((parcelRequire("ha8W8")));

var $fd8d27ea1c7493b9$var$_BasicToaster = $fd8d27ea1c7493b9$var$_interopRequireDefault((parcelRequire("9XbRk")));

var $fd8d27ea1c7493b9$var$_BasicTranscript = $fd8d27ea1c7493b9$var$_interopRequireDefault((parcelRequire("4FrFa")));

var $fd8d27ea1c7493b9$var$_useStyleSet3 = $fd8d27ea1c7493b9$var$_interopRequireDefault((parcelRequire("gC6jZ")));

var $fd8d27ea1c7493b9$var$_useStyleToEmotionObject = $fd8d27ea1c7493b9$var$_interopRequireDefault((parcelRequire("6l4uV")));
function $fd8d27ea1c7493b9$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $fd8d27ea1c7493b9$var$_slicedToArray(arr, i) {
    return $fd8d27ea1c7493b9$var$_arrayWithHoles(arr) || $fd8d27ea1c7493b9$var$_iterableToArrayLimit(arr, i) || $fd8d27ea1c7493b9$var$_unsupportedIterableToArray(arr, i) || $fd8d27ea1c7493b9$var$_nonIterableRest();
}
function $fd8d27ea1c7493b9$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $fd8d27ea1c7493b9$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $fd8d27ea1c7493b9$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $fd8d27ea1c7493b9$var$_arrayLikeToArray(o, minLen);
}
function $fd8d27ea1c7493b9$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $fd8d27ea1c7493b9$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $fd8d27ea1c7493b9$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
var $fd8d27ea1c7493b9$var$useStyleOptions = $hd4g0.hooks.useStyleOptions;
var $fd8d27ea1c7493b9$var$ROOT_STYLE = {
    display: "flex",
    flexDirection: "column"
};
var $fd8d27ea1c7493b9$var$CONNECTIVITY_STATUS_STYLE = {
    flexShrink: 0
};
var $fd8d27ea1c7493b9$var$SEND_BOX_CSS = {
    flexShrink: 0
};
var $fd8d27ea1c7493b9$var$TOASTER_STYLE = {
    flexShrink: 0
};
var $fd8d27ea1c7493b9$var$TRANSCRIPT_STYLE = {
    flex: 1
}; // Subset of landmark roles: https://w3.org/TR/wai-aria/#landmark_roles
var $fd8d27ea1c7493b9$var$ARIA_LANDMARK_ROLES = [
    "complementary",
    "contentinfo",
    "form",
    "main",
    "region"
];
var $fd8d27ea1c7493b9$var$BasicWebChat = function BasicWebChat(_ref) {
    var className = _ref.className, role = _ref.role;
    var _useStyleSet = (0, $fd8d27ea1c7493b9$var$_useStyleSet3.default)(), _useStyleSet2 = $fd8d27ea1c7493b9$var$_slicedToArray(_useStyleSet, 1), rootStyleSet = _useStyleSet2[0].root;
    var _useStyleOptions = $fd8d27ea1c7493b9$var$useStyleOptions(), _useStyleOptions2 = $fd8d27ea1c7493b9$var$_slicedToArray(_useStyleOptions, 1), options = _useStyleOptions2[0];
    var styleToEmotionObject = (0, $fd8d27ea1c7493b9$var$_useStyleToEmotionObject.default)();
    var connectivityStatusClassName = styleToEmotionObject($fd8d27ea1c7493b9$var$CONNECTIVITY_STATUS_STYLE) + "";
    var rootClassName = styleToEmotionObject($fd8d27ea1c7493b9$var$ROOT_STYLE) + "";
    var sendBoxClassName = styleToEmotionObject($fd8d27ea1c7493b9$var$SEND_BOX_CSS) + "";
    var toasterClassName = styleToEmotionObject($fd8d27ea1c7493b9$var$TOASTER_STYLE) + "";
    var transcriptClassName = styleToEmotionObject($fd8d27ea1c7493b9$var$TRANSCRIPT_STYLE) + ""; // Fallback to "complementary" if specified is not a valid landmark role.
    if (!$fd8d27ea1c7493b9$var$ARIA_LANDMARK_ROLES.includes(role)) role = "complementary";
    return /*#__PURE__*/ $fd8d27ea1c7493b9$var$_react.default.createElement($fd8d27ea1c7493b9$var$_Surface.default, {
        className: (0, $fd8d27ea1c7493b9$var$_classnames.default)(rootClassName, rootStyleSet + "", (className || "") + ""),
        role: role
    }, !options.hideToaster && /*#__PURE__*/ $fd8d27ea1c7493b9$var$_react.default.createElement($fd8d27ea1c7493b9$var$_BasicToaster.default, {
        className: toasterClassName
    }), /*#__PURE__*/ $fd8d27ea1c7493b9$var$_react.default.createElement($fd8d27ea1c7493b9$var$_BasicTranscript.default, {
        className: transcriptClassName
    }), /*#__PURE__*/ $fd8d27ea1c7493b9$var$_react.default.createElement($fd8d27ea1c7493b9$var$_BasicConnectivityStatus.default, {
        className: connectivityStatusClassName
    }), !options.hideSendBox && /*#__PURE__*/ $fd8d27ea1c7493b9$var$_react.default.createElement($fd8d27ea1c7493b9$var$_BasicSendBox.default, {
        className: sendBoxClassName
    }));
};
$fd8d27ea1c7493b9$var$BasicWebChat.defaultProps = {
    className: "",
    role: "complementary"
};
$fd8d27ea1c7493b9$var$BasicWebChat.propTypes = {
    className: $fd8d27ea1c7493b9$var$_propTypes.default.string,
    // Ignoring deficiencies with TypeScript/PropTypes inference.
    // @ts-ignore
    role: $fd8d27ea1c7493b9$var$_propTypes.default.oneOf($fd8d27ea1c7493b9$var$ARIA_LANDMARK_ROLES)
};
var $fd8d27ea1c7493b9$var$_default = $fd8d27ea1c7493b9$var$BasicWebChat;
module.exports.default = $fd8d27ea1c7493b9$var$_default;

});
parcelRequire.register("5A4MD", function(module, exports) {
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/ /* global define */ (function() {
    "use strict";
    var hasOwn = {}.hasOwnProperty;
    var nativeCodeString = "[native code]";
    function classNames() {
        var classes = [];
        for(var i = 0; i < arguments.length; i++){
            var arg = arguments[i];
            if (!arg) continue;
            var argType = typeof arg;
            if (argType === "string" || argType === "number") classes.push(arg);
            else if (Array.isArray(arg)) {
                if (arg.length) {
                    var inner = classNames.apply(null, arg);
                    if (inner) classes.push(inner);
                }
            } else if (argType === "object") {
                if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes("[native code]")) {
                    classes.push(arg.toString());
                    continue;
                }
                for(var key in arg)if (hasOwn.call(arg, key) && arg[key]) classes.push(key);
            }
        }
        return classes.join(" ");
    }
    if (0, module.exports) {
        classNames.default = classNames;
        module.exports = classNames;
    } else if (typeof define === "function" && typeof define.amd === "object" && define.amd) // register as 'classnames', consistent with npm package name
    define("classnames", [], function() {
        return classNames;
    });
    else window.classNames = classNames;
})();

});

parcelRequire.register("fFnOT", function(module, exports) {
"use strict";
function $b67d297c70383c1b$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $b67d297c70383c1b$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $b67d297c70383c1b$var$_typeof(obj);
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b67d297c70383c1b$var$_propTypes = $b67d297c70383c1b$var$_interopRequireDefault((parcelRequire("f7UXb")));

var $b67d297c70383c1b$var$_react = $b67d297c70383c1b$var$_interopRequireWildcard((parcelRequire("eO7Kz")));

var $l9CLL = parcelRequire("l9CLL");

var $b67d297c70383c1b$var$_Context = $b67d297c70383c1b$var$_interopRequireDefault((parcelRequire("7MZoY")));

var $b67d297c70383c1b$var$_useNavigatorPlatform3 = $b67d297c70383c1b$var$_interopRequireDefault((parcelRequire("70juI")));
var $b67d297c70383c1b$var$_excluded = [
    "children"
];
function $b67d297c70383c1b$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($b67d297c70383c1b$var$_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $b67d297c70383c1b$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || $b67d297c70383c1b$var$_typeof(obj) !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $b67d297c70383c1b$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $b67d297c70383c1b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $b67d297c70383c1b$var$_extends() {
    $b67d297c70383c1b$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $b67d297c70383c1b$var$_extends.apply(this, arguments);
}
function $b67d297c70383c1b$var$_slicedToArray(arr, i) {
    return $b67d297c70383c1b$var$_arrayWithHoles(arr) || $b67d297c70383c1b$var$_iterableToArrayLimit(arr, i) || $b67d297c70383c1b$var$_unsupportedIterableToArray(arr, i) || $b67d297c70383c1b$var$_nonIterableRest();
}
function $b67d297c70383c1b$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $b67d297c70383c1b$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $b67d297c70383c1b$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $b67d297c70383c1b$var$_arrayLikeToArray(o, minLen);
}
function $b67d297c70383c1b$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $b67d297c70383c1b$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $b67d297c70383c1b$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $b67d297c70383c1b$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $b67d297c70383c1b$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $b67d297c70383c1b$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $b67d297c70383c1b$var$Surface = function Surface(_ref) {
    var children = _ref.children, otherProps = $b67d297c70383c1b$var$_objectWithoutProperties(_ref, $b67d297c70383c1b$var$_excluded);
    var _useNavigatorPlatform = (0, $b67d297c70383c1b$var$_useNavigatorPlatform3.default)(), _useNavigatorPlatform2 = $b67d297c70383c1b$var$_slicedToArray(_useNavigatorPlatform, 1), apple = _useNavigatorPlatform2[0].apple;
    var contextRef = (0, $b67d297c70383c1b$var$_react.useRef)({
        focii: []
    });
    var handleKeyUp = (0, $b67d297c70383c1b$var$_react.useCallback)(function(event) {
        var altKey = event.altKey, ctrlKey = event.ctrlKey, key = event.key, shiftKey = event.shiftKey; // On Apple, most modern browsers use CTRL + OPTION as modifiers.
        // Otherwise, we use ALT + SHIFT as modifierse.
        if (altKey && (apple ? ctrlKey : shiftKey)) {
            var focii = contextRef.current.focii.filter(function(entry) {
                return entry.keys.includes(key);
            });
            var currentFocus = focii.findIndex(function(_ref2) {
                var current = _ref2.ref.current;
                return current === document.activeElement || current.contains(document.activeElement);
            });
            var nextFocus = focii[(currentFocus + 1) % focii.length];
            if (nextFocus) {
                event.preventDefault();
                event.stopPropagation();
                var tabbable = (0, $l9CLL.orSelf)(nextFocus.ref.current);
                tabbable && tabbable.focus();
            }
        }
    }, [
        apple
    ]);
    return /*#__PURE__*/ $b67d297c70383c1b$var$_react.default.createElement($b67d297c70383c1b$var$_Context.default.Provider, {
        value: contextRef.current
    }, /*#__PURE__*/ $b67d297c70383c1b$var$_react.default.createElement("div", $b67d297c70383c1b$var$_extends({
        onKeyUp: handleKeyUp
    }, otherProps), children));
};
$b67d297c70383c1b$var$Surface.defaultProps = {
    children: undefined
};
$b67d297c70383c1b$var$Surface.propTypes = {
    children: $b67d297c70383c1b$var$_propTypes.default.any
};
var $b67d297c70383c1b$var$_default = $b67d297c70383c1b$var$Surface;
module.exports.default = $b67d297c70383c1b$var$_default;

});
parcelRequire.register("l9CLL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $f668830b259e7131$var$firstTabbableDescendant;
module.exports.orSelf = $f668830b259e7131$var$orSelf;

var $f668830b259e7131$var$_getTabIndex = $f668830b259e7131$var$_interopRequireDefault((parcelRequire("5wWAs")));
function $f668830b259e7131$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $f668830b259e7131$var$ALWAYS_TRUE_FN = function ALWAYS_TRUE_FN() {
    return true;
};
var $f668830b259e7131$var$SELECTOR = "a[href], audio, button, details, details summary, embed, iframe, input, object, rect, select, svg[focusable], textarea, video, [tabindex]";
function $f668830b259e7131$var$firstTabbableDescendant(element) {
    var filter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $f668830b259e7131$var$ALWAYS_TRUE_FN;
    if (!element) return;
     // This is best-effort for finding a tabbable element.
    // For a comprehensive list, please refer to https://allyjs.io/data-tables/focusable.html and update this list accordingly.
    var focusables = [].filter.call(element.querySelectorAll($f668830b259e7131$var$SELECTOR), filter);
    return [].find.call(focusables, function(focusable) {
        var tabIndex = (0, $f668830b259e7131$var$_getTabIndex.default)(focusable);
        return typeof tabIndex === "number" && tabIndex >= 0;
    });
}
function $f668830b259e7131$var$orSelf(element) {
    if (!element) return;
     // "msMatchesSelector" is vendor-prefixed version of "matches".
    // eslint-disable-next-line dot-notation
    if ((element.matches || element["msMatchesSelector"]).call(element, $f668830b259e7131$var$SELECTOR)) return element;
    return $f668830b259e7131$var$firstTabbableDescendant(element);
}

});
parcelRequire.register("5wWAs", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $406d630bf061e8cd$var$getTabIndex;
var $406d630bf061e8cd$var$_window = window, $406d630bf061e8cd$var$userAgent = $406d630bf061e8cd$var$_window.navigator.userAgent;
var $406d630bf061e8cd$var$IE_FOCUSABLE_LIST = [
    "a",
    "body",
    "button",
    "frame",
    "iframe",
    "img",
    "input",
    "isindex",
    "object",
    "select",
    "textarea"
];
var $406d630bf061e8cd$var$IS_FIREFOX = /Firefox\//i.test($406d630bf061e8cd$var$userAgent);
var $406d630bf061e8cd$var$IS_IE = /Trident\//i.test($406d630bf061e8cd$var$userAgent);
function $406d630bf061e8cd$var$getTabIndex(element) {
    var tabIndex = element.tabIndex;
    if ($406d630bf061e8cd$var$IS_IE) {
        var tabIndexAttribute = element.attributes.getNamedItem("tabindex");
        if (!tabIndexAttribute || !tabIndexAttribute.specified) return ~$406d630bf061e8cd$var$IE_FOCUSABLE_LIST.indexOf(element.nodeName.toLowerCase()) ? 0 : null;
    } else if (!~tabIndex) {
        var attr = element.getAttribute("tabindex");
        if (attr === null || attr === "" && !$406d630bf061e8cd$var$IS_FIREFOX) return null;
    }
    return tabIndex;
}

});


parcelRequire.register("7MZoY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $eO7Kz = parcelRequire("eO7Kz");
var $5abca538e9f89f9b$var$AccessKeySinkContext = /*#__PURE__*/ (0, $eO7Kz.createContext)();
var $5abca538e9f89f9b$var$_default = $5abca538e9f89f9b$var$AccessKeySinkContext;
module.exports.default = $5abca538e9f89f9b$var$_default;

});

parcelRequire.register("70juI", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $5197a7b31b0eee36$var$useNavigatorPlatform;

var $eO7Kz = parcelRequire("eO7Kz");
var $5197a7b31b0eee36$var$ANDROID_PATTERN = /^(android|linux armv7l)/gi;
var $5197a7b31b0eee36$var$APPLE_PATTERN = /^(mac|ipad|iphone|ipod)/gi;
var $5197a7b31b0eee36$var$LINUX_PATTERN = /^linux/gi;
var $5197a7b31b0eee36$var$WINDOWS_PATTERN = /^win/gi;
function $5197a7b31b0eee36$var$useNavigatorPlatform() {
    var _window = window, platform = _window.navigator.platform;
    return (0, $eO7Kz.useMemo)(function() {
        // This list is very limited. Please use with care. Please refer to this link for details.
        // https://stackoverflow.com/questions/19877924/what-is-the-list-of-possible-values-for-navigator-platform-as-of-today
        var android = $5197a7b31b0eee36$var$ANDROID_PATTERN.test(platform);
        var apple = $5197a7b31b0eee36$var$APPLE_PATTERN.test(platform);
        var windows = $5197a7b31b0eee36$var$WINDOWS_PATTERN.test(platform);
        var linux = !android && $5197a7b31b0eee36$var$LINUX_PATTERN.test(platform);
        return [
            {
                android: android,
                apple: apple,
                linux: linux,
                windows: windows
            }
        ];
    }, [
        platform
    ]);
}

});


parcelRequire.register("8ehZJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $hd4g0 = parcelRequire("hd4g0");

var $5fdd96e33bfd4d5a$var$_react = $5fdd96e33bfd4d5a$var$_interopRequireDefault((parcelRequire("eO7Kz")));

var $5fdd96e33bfd4d5a$var$_Connected = $5fdd96e33bfd4d5a$var$_interopRequireDefault((parcelRequire("kj4WK")));

var $5fdd96e33bfd4d5a$var$_Connecting = $5fdd96e33bfd4d5a$var$_interopRequireDefault((parcelRequire("GoebH")));

var $5fdd96e33bfd4d5a$var$_FailedToConnect = $5fdd96e33bfd4d5a$var$_interopRequireDefault((parcelRequire("1NqsY")));

var $5fdd96e33bfd4d5a$var$_JavaScriptError = $5fdd96e33bfd4d5a$var$_interopRequireDefault((parcelRequire("k0bmq")));
function $5fdd96e33bfd4d5a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $5fdd96e33bfd4d5a$var$_slicedToArray(arr, i) {
    return $5fdd96e33bfd4d5a$var$_arrayWithHoles(arr) || $5fdd96e33bfd4d5a$var$_iterableToArrayLimit(arr, i) || $5fdd96e33bfd4d5a$var$_unsupportedIterableToArray(arr, i) || $5fdd96e33bfd4d5a$var$_nonIterableRest();
}
function $5fdd96e33bfd4d5a$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $5fdd96e33bfd4d5a$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $5fdd96e33bfd4d5a$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $5fdd96e33bfd4d5a$var$_arrayLikeToArray(o, minLen);
}
function $5fdd96e33bfd4d5a$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $5fdd96e33bfd4d5a$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $5fdd96e33bfd4d5a$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
var $5fdd96e33bfd4d5a$var$useDebouncedNotifications = $hd4g0.hooks.useDebouncedNotifications;
var $5fdd96e33bfd4d5a$var$BasicConnectivityStatus = function BasicConnectivityStatus() {
    var _useDebouncedNotifica = $5fdd96e33bfd4d5a$var$useDebouncedNotifications(), _useDebouncedNotifica2 = $5fdd96e33bfd4d5a$var$_slicedToArray(_useDebouncedNotifica, 1), connectivityStatus = _useDebouncedNotifica2[0].connectivitystatus;
    if (!connectivityStatus) return false;
    switch(connectivityStatus.message){
        case "connecting":
            return /*#__PURE__*/ $5fdd96e33bfd4d5a$var$_react.default.createElement($5fdd96e33bfd4d5a$var$_Connecting.default, null);
        case "javascripterror":
            return /*#__PURE__*/ $5fdd96e33bfd4d5a$var$_react.default.createElement($5fdd96e33bfd4d5a$var$_JavaScriptError.default, null);
        case "failedtoconnect":
            return /*#__PURE__*/ $5fdd96e33bfd4d5a$var$_react.default.createElement($5fdd96e33bfd4d5a$var$_FailedToConnect.default, null);
        case "reconnecting":
            return /*#__PURE__*/ $5fdd96e33bfd4d5a$var$_react.default.createElement($5fdd96e33bfd4d5a$var$_Connecting.default, {
                reconnect: true
            });
        case "connected":
        default:
            return /*#__PURE__*/ $5fdd96e33bfd4d5a$var$_react.default.createElement($5fdd96e33bfd4d5a$var$_Connected.default, null);
    }
};
var $5fdd96e33bfd4d5a$var$_default = $5fdd96e33bfd4d5a$var$BasicConnectivityStatus;
module.exports.default = $5fdd96e33bfd4d5a$var$_default;

});
parcelRequire.register("kj4WK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $hd4g0 = parcelRequire("hd4g0");

var $ec896b4b630a1a1d$var$_react = $ec896b4b630a1a1d$var$_interopRequireDefault((parcelRequire("eO7Kz")));

var $ec896b4b630a1a1d$var$_ScreenReaderText = $ec896b4b630a1a1d$var$_interopRequireDefault((parcelRequire("3NTZI")));
function $ec896b4b630a1a1d$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $ec896b4b630a1a1d$var$useLocalizer = $hd4g0.hooks.useLocalizer;
var $ec896b4b630a1a1d$var$ConnectivityStatusConnected = function ConnectivityStatusConnected() {
    var localize = $ec896b4b630a1a1d$var$useLocalizer();
    return /*#__PURE__*/ $ec896b4b630a1a1d$var$_react.default.createElement($ec896b4b630a1a1d$var$_ScreenReaderText.default, {
        text: localize("CONNECTIVITY_STATUS_ALT", localize("CONNECTIVITY_STATUS_ALT_CONNECTED"))
    });
};
var $ec896b4b630a1a1d$var$_default = $ec896b4b630a1a1d$var$ConnectivityStatusConnected;
module.exports.default = $ec896b4b630a1a1d$var$_default;

});
parcelRequire.register("3NTZI", function(module, exports) {
"use strict";
function $2c516207156c5974$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $2c516207156c5974$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $2c516207156c5974$var$_typeof(obj);
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2c516207156c5974$var$_propTypes = $2c516207156c5974$var$_interopRequireDefault((parcelRequire("f7UXb")));

var $2c516207156c5974$var$_react = $2c516207156c5974$var$_interopRequireWildcard((parcelRequire("eO7Kz")));

var $2c516207156c5974$var$_useStyleToEmotionObject = $2c516207156c5974$var$_interopRequireDefault((parcelRequire("6l4uV")));
function $2c516207156c5974$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($2c516207156c5974$var$_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $2c516207156c5974$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || $2c516207156c5974$var$_typeof(obj) !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $2c516207156c5974$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $2c516207156c5974$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/* eslint react/forbid-dom-props: ["off"] */ var $2c516207156c5974$var$ROOT_STYLE = {
    // .sr-only - This component is intended to be invisible to the visual Web Chat user, but read by the AT when using a screen reader
    color: "transparent",
    height: 1,
    overflow: "hidden",
    position: "absolute",
    // We need to set top: 0, otherwise, it will repro:
    // - Run NVDA
    // - Make the transcript long enough to show the scrollbar
    // - Press SHIFT-TAB, focus on upload button
    // - Press up arrow multiple times
    top: 0,
    whiteSpace: "nowrap",
    width: 1
};
var $2c516207156c5974$var$ScreenReaderText = /*#__PURE__*/ (0, $2c516207156c5974$var$_react.forwardRef)(function(_ref, ref) {
    var ariaHidden = _ref["aria-hidden"], id = _ref.id, text = _ref.text;
    var rootClassName = (0, $2c516207156c5974$var$_useStyleToEmotionObject.default)()($2c516207156c5974$var$ROOT_STYLE) + "";
    if (ariaHidden && !id) console.warn('botframework-webchat assertion: when "aria-hidden" is set, the screen reader text should be read by "aria-labelledby". Thus, "id" must be set.');
    return /*#__PURE__*/ $2c516207156c5974$var$_react.default.createElement("div", {
        "aria-hidden": ariaHidden,
        className: rootClassName,
        id: id,
        ref: ref
    }, text);
});
$2c516207156c5974$var$ScreenReaderText.defaultProps = {
    "aria-hidden": undefined,
    id: undefined
};
$2c516207156c5974$var$ScreenReaderText.propTypes = {
    "aria-hidden": $2c516207156c5974$var$_propTypes.default.bool,
    id: $2c516207156c5974$var$_propTypes.default.string,
    text: $2c516207156c5974$var$_propTypes.default.string.isRequired
};
var $2c516207156c5974$var$_default = $2c516207156c5974$var$ScreenReaderText;
module.exports.default = $2c516207156c5974$var$_default;

});
parcelRequire.register("6l4uV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $49d831671d088f5c$var$useStyleToEmotionObject;

var $49d831671d088f5c$var$_useWebChatUIContext = $49d831671d088f5c$var$_interopRequireDefault((parcelRequire("tHuBR")));
function $49d831671d088f5c$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $49d831671d088f5c$var$useStyleToEmotionObject() {
    return (0, $49d831671d088f5c$var$_useWebChatUIContext.default)().styleToEmotionObject;
}

});
parcelRequire.register("tHuBR", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $0594724b1f05df5e$var$useWebChatUIContext;

var $eO7Kz = parcelRequire("eO7Kz");

var $0594724b1f05df5e$var$_WebChatUIContext = $0594724b1f05df5e$var$_interopRequireDefault((parcelRequire("59jaJ")));
function $0594724b1f05df5e$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $0594724b1f05df5e$var$useWebChatUIContext() {
    var context = (0, $eO7Kz.useContext)($0594724b1f05df5e$var$_WebChatUIContext.default);
    if (!context) throw new Error("This hook can only be used on a component that is a descendant of <Composer>");
    return context;
}

});
parcelRequire.register("59jaJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $eO7Kz = parcelRequire("eO7Kz");
var $3bfcaa323c88ca9c$var$context = /*#__PURE__*/ (0, $eO7Kz.createContext)();
var $3bfcaa323c88ca9c$var$_default = $3bfcaa323c88ca9c$var$context;
module.exports.default = $3bfcaa323c88ca9c$var$_default;

});





parcelRequire.register("GoebH", function(module, exports) {
"use strict";
function $07f6b7806bf892ea$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $07f6b7806bf892ea$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $07f6b7806bf892ea$var$_typeof(obj);
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $hd4g0 = parcelRequire("hd4g0");

var $07f6b7806bf892ea$var$_classnames = $07f6b7806bf892ea$var$_interopRequireDefault((parcelRequire("5A4MD")));

var $07f6b7806bf892ea$var$_propTypes = $07f6b7806bf892ea$var$_interopRequireDefault((parcelRequire("f7UXb")));

var $07f6b7806bf892ea$var$_react = $07f6b7806bf892ea$var$_interopRequireWildcard((parcelRequire("eO7Kz")));

var $07f6b7806bf892ea$var$_ScreenReaderText = $07f6b7806bf892ea$var$_interopRequireDefault((parcelRequire("3NTZI")));

var $07f6b7806bf892ea$var$_SpinnerAnimation = $07f6b7806bf892ea$var$_interopRequireDefault((parcelRequire("gpdVi")));

var $07f6b7806bf892ea$var$_useForceRender = $07f6b7806bf892ea$var$_interopRequireDefault((parcelRequire("g62YG")));

var $07f6b7806bf892ea$var$_useStyleSet3 = $07f6b7806bf892ea$var$_interopRequireDefault((parcelRequire("gC6jZ")));

var $07f6b7806bf892ea$var$_useTimer = $07f6b7806bf892ea$var$_interopRequireDefault((parcelRequire("czn4j")));

var $07f6b7806bf892ea$var$_WarningNotificationIcon = $07f6b7806bf892ea$var$_interopRequireDefault((parcelRequire("35kkb")));
function $07f6b7806bf892ea$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($07f6b7806bf892ea$var$_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $07f6b7806bf892ea$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || $07f6b7806bf892ea$var$_typeof(obj) !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $07f6b7806bf892ea$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $07f6b7806bf892ea$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $07f6b7806bf892ea$var$_slicedToArray(arr, i) {
    return $07f6b7806bf892ea$var$_arrayWithHoles(arr) || $07f6b7806bf892ea$var$_iterableToArrayLimit(arr, i) || $07f6b7806bf892ea$var$_unsupportedIterableToArray(arr, i) || $07f6b7806bf892ea$var$_nonIterableRest();
}
function $07f6b7806bf892ea$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $07f6b7806bf892ea$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $07f6b7806bf892ea$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $07f6b7806bf892ea$var$_arrayLikeToArray(o, minLen);
}
function $07f6b7806bf892ea$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $07f6b7806bf892ea$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $07f6b7806bf892ea$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
var $07f6b7806bf892ea$var$useDirection = $hd4g0.hooks.useDirection, $07f6b7806bf892ea$var$useLocalizer = $hd4g0.hooks.useLocalizer, $07f6b7806bf892ea$var$usePonyfill = $hd4g0.hooks.usePonyfill, $07f6b7806bf892ea$var$useStyleOptions = $hd4g0.hooks.useStyleOptions;
var $07f6b7806bf892ea$var$ConnectivityStatusConnecting = function ConnectivityStatusConnecting(_ref) {
    var reconnect = _ref.reconnect;
    var _usePonyfill = $07f6b7806bf892ea$var$usePonyfill(), _usePonyfill2 = $07f6b7806bf892ea$var$_slicedToArray(_usePonyfill, 1), Date = _usePonyfill2[0].Date;
    var _useStyleOptions = $07f6b7806bf892ea$var$useStyleOptions(), _useStyleOptions2 = $07f6b7806bf892ea$var$_slicedToArray(_useStyleOptions, 1), slowConnectionAfter = _useStyleOptions2[0].slowConnectionAfter;
    var _useStyleSet = (0, $07f6b7806bf892ea$var$_useStyleSet3.default)(), _useStyleSet2 = $07f6b7806bf892ea$var$_slicedToArray(_useStyleSet, 1), _useStyleSet2$ = _useStyleSet2[0], connectivityNotificationStyleSet = _useStyleSet2$.connectivityNotification, warningNotificationStyleSet = _useStyleSet2$.warningNotification;
    var _useDirection = $07f6b7806bf892ea$var$useDirection(), _useDirection2 = $07f6b7806bf892ea$var$_slicedToArray(_useDirection, 1), direction = _useDirection2[0];
    var _useState = (0, $07f6b7806bf892ea$var$_react.useState)(function() {
        return Date.now();
    }), _useState2 = $07f6b7806bf892ea$var$_slicedToArray(_useState, 1), initialRenderAt = _useState2[0];
    var forceRender = (0, $07f6b7806bf892ea$var$_useForceRender.default)();
    var localize = $07f6b7806bf892ea$var$useLocalizer();
    var initialConnectionText = localize("CONNECTIVITY_STATUS_ALT_CONNECTING");
    var interruptedConnectionText = localize("CONNECTIVITY_STATUS_ALT_RECONNECTING");
    var slowConnectionText = localize("CONNECTIVITY_STATUS_ALT_SLOW_CONNECTION");
    (0, $07f6b7806bf892ea$var$_useTimer.default)(initialRenderAt + slowConnectionAfter, forceRender);
    var now = Date.now();
    var slow = now >= initialRenderAt + slowConnectionAfter;
    return slow ? /*#__PURE__*/ $07f6b7806bf892ea$var$_react.default.createElement($07f6b7806bf892ea$var$_react.default.Fragment, null, /*#__PURE__*/ $07f6b7806bf892ea$var$_react.default.createElement($07f6b7806bf892ea$var$_ScreenReaderText.default, {
        text: localize("CONNECTIVITY_STATUS_ALT", slowConnectionText)
    }), /*#__PURE__*/ $07f6b7806bf892ea$var$_react.default.createElement("div", {
        "aria-hidden": true,
        className: (0, $07f6b7806bf892ea$var$_classnames.default)("webchat__connectivityStatus", warningNotificationStyleSet + ""),
        dir: direction
    }, /*#__PURE__*/ $07f6b7806bf892ea$var$_react.default.createElement($07f6b7806bf892ea$var$_WarningNotificationIcon.default, null), slowConnectionText)) : /*#__PURE__*/ $07f6b7806bf892ea$var$_react.default.createElement($07f6b7806bf892ea$var$_react.default.Fragment, null, /*#__PURE__*/ $07f6b7806bf892ea$var$_react.default.createElement($07f6b7806bf892ea$var$_ScreenReaderText.default, {
        text: localize("CONNECTIVITY_STATUS_ALT", reconnect ? interruptedConnectionText : initialConnectionText)
    }), /*#__PURE__*/ $07f6b7806bf892ea$var$_react.default.createElement("div", {
        "aria-hidden": true,
        className: (0, $07f6b7806bf892ea$var$_classnames.default)("webchat__connectivityStatus", connectivityNotificationStyleSet + ""),
        dir: direction
    }, /*#__PURE__*/ $07f6b7806bf892ea$var$_react.default.createElement($07f6b7806bf892ea$var$_SpinnerAnimation.default, null), reconnect ? interruptedConnectionText : initialConnectionText));
};
$07f6b7806bf892ea$var$ConnectivityStatusConnecting.defaultProps = {
    reconnect: false
};
$07f6b7806bf892ea$var$ConnectivityStatusConnecting.propTypes = {
    reconnect: $07f6b7806bf892ea$var$_propTypes.default.bool
};
var $07f6b7806bf892ea$var$_default = $07f6b7806bf892ea$var$ConnectivityStatusConnecting;
module.exports.default = $07f6b7806bf892ea$var$_default;

});
parcelRequire.register("gpdVi", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $hd4g0 = parcelRequire("hd4g0");

var $bf19c7ffd002179d$var$_classnames = $bf19c7ffd002179d$var$_interopRequireDefault((parcelRequire("5A4MD")));

var $bf19c7ffd002179d$var$_react = $bf19c7ffd002179d$var$_interopRequireDefault((parcelRequire("eO7Kz")));

var $bf19c7ffd002179d$var$_useStyleSet3 = $bf19c7ffd002179d$var$_interopRequireDefault((parcelRequire("gC6jZ")));
function $bf19c7ffd002179d$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $bf19c7ffd002179d$var$_slicedToArray(arr, i) {
    return $bf19c7ffd002179d$var$_arrayWithHoles(arr) || $bf19c7ffd002179d$var$_iterableToArrayLimit(arr, i) || $bf19c7ffd002179d$var$_unsupportedIterableToArray(arr, i) || $bf19c7ffd002179d$var$_nonIterableRest();
}
function $bf19c7ffd002179d$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $bf19c7ffd002179d$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $bf19c7ffd002179d$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $bf19c7ffd002179d$var$_arrayLikeToArray(o, minLen);
}
function $bf19c7ffd002179d$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $bf19c7ffd002179d$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $bf19c7ffd002179d$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
var $bf19c7ffd002179d$var$useDirection = $hd4g0.hooks.useDirection;
var $bf19c7ffd002179d$var$SpinnerAnimation = function SpinnerAnimation() {
    var _useStyleSet = (0, $bf19c7ffd002179d$var$_useStyleSet3.default)(), _useStyleSet2 = $bf19c7ffd002179d$var$_slicedToArray(_useStyleSet, 1), spinnerAnimationStyleSet = _useStyleSet2[0].spinnerAnimation;
    var _useDirection = $bf19c7ffd002179d$var$useDirection(), _useDirection2 = $bf19c7ffd002179d$var$_slicedToArray(_useDirection, 1), direction = _useDirection2[0];
    return /*#__PURE__*/ $bf19c7ffd002179d$var$_react.default.createElement("div", {
        className: (0, $bf19c7ffd002179d$var$_classnames.default)(spinnerAnimationStyleSet + "", direction === "rtl" && "webchat__spinner--rtl")
    });
};
var $bf19c7ffd002179d$var$_default = $bf19c7ffd002179d$var$SpinnerAnimation;
module.exports.default = $bf19c7ffd002179d$var$_default;

});
parcelRequire.register("gC6jZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $c18519439260df0a$var$useStyleSet;

var $c18519439260df0a$var$_useWebChatUIContext = $c18519439260df0a$var$_interopRequireDefault((parcelRequire("tHuBR")));
function $c18519439260df0a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $c18519439260df0a$var$useStyleSet() {
    return [
        (0, $c18519439260df0a$var$_useWebChatUIContext.default)().styleSet
    ];
}

});


parcelRequire.register("g62YG", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $eO7Kz = parcelRequire("eO7Kz");
function $bb7f84311cf5332a$var$_slicedToArray(arr, i) {
    return $bb7f84311cf5332a$var$_arrayWithHoles(arr) || $bb7f84311cf5332a$var$_iterableToArrayLimit(arr, i) || $bb7f84311cf5332a$var$_unsupportedIterableToArray(arr, i) || $bb7f84311cf5332a$var$_nonIterableRest();
}
function $bb7f84311cf5332a$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $bb7f84311cf5332a$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $bb7f84311cf5332a$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $bb7f84311cf5332a$var$_arrayLikeToArray(o, minLen);
}
function $bb7f84311cf5332a$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $bb7f84311cf5332a$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $bb7f84311cf5332a$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $bb7f84311cf5332a$var$useForceRender() {
    var _useState = (0, $eO7Kz.useState)(), _useState2 = $bb7f84311cf5332a$var$_slicedToArray(_useState, 2), setForceRender = _useState2[1];
    return (0, $eO7Kz.useCallback)(function() {
        return setForceRender({});
    }, [
        setForceRender
    ]);
}
var $bb7f84311cf5332a$var$_default = $bb7f84311cf5332a$var$useForceRender;
module.exports.default = $bb7f84311cf5332a$var$_default;

});

parcelRequire.register("czn4j", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $926aa5da85dbb5dc$var$useTimer;

var $hd4g0 = parcelRequire("hd4g0");

var $eO7Kz = parcelRequire("eO7Kz");
function $926aa5da85dbb5dc$var$_slicedToArray(arr, i) {
    return $926aa5da85dbb5dc$var$_arrayWithHoles(arr) || $926aa5da85dbb5dc$var$_iterableToArrayLimit(arr, i) || $926aa5da85dbb5dc$var$_unsupportedIterableToArray(arr, i) || $926aa5da85dbb5dc$var$_nonIterableRest();
}
function $926aa5da85dbb5dc$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $926aa5da85dbb5dc$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $926aa5da85dbb5dc$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $926aa5da85dbb5dc$var$_arrayLikeToArray(o, minLen);
}
function $926aa5da85dbb5dc$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $926aa5da85dbb5dc$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $926aa5da85dbb5dc$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
var $926aa5da85dbb5dc$var$usePonyfill = $hd4g0.hooks.usePonyfill; // TODO: [P2] Dedupe this function from "api", possibly create a new "util" package.
/**
 * Calls a callback function at a specific time.
 */ function $926aa5da85dbb5dc$var$useTimer(at, fn) {
    var _usePonyfill = $926aa5da85dbb5dc$var$usePonyfill(), _usePonyfill2 = $926aa5da85dbb5dc$var$_slicedToArray(_usePonyfill, 1), _usePonyfill2$ = _usePonyfill2[0], clearTimeout = _usePonyfill2$.clearTimeout, Date = _usePonyfill2$.Date, setTimeout = _usePonyfill2$.setTimeout;
    (0, $eO7Kz.useEffect)(function() {
        if (typeof at === "number") {
            var ms = Math.max(0, at - Date.now()); // useEffect() is running after yielding to sync code via setImmediate (IE), MessageChannel (4ms), or setTimeout.
            // Thus, when calling setTimeout(..., 0), under Lolex, it will be waited for another loop.
            // In other words, setTimeout(..., 0) won't fire right away. It will be fired after clock.tick(<any number>).
            if (ms) {
                var timeout = setTimeout(fn, ms);
                return function() {
                    return clearTimeout(timeout);
                };
            }
            fn();
        }
    }, [
        at,
        clearTimeout,
        Date,
        fn,
        setTimeout
    ]);
}

});

parcelRequire.register("35kkb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $hd4g0 = parcelRequire("hd4g0");

var $23f19ac833d0cd08$var$_classnames = $23f19ac833d0cd08$var$_interopRequireDefault((parcelRequire("5A4MD")));

var $23f19ac833d0cd08$var$_propTypes = $23f19ac833d0cd08$var$_interopRequireDefault((parcelRequire("f7UXb")));

var $23f19ac833d0cd08$var$_react = $23f19ac833d0cd08$var$_interopRequireDefault((parcelRequire("eO7Kz")));
function $23f19ac833d0cd08$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $23f19ac833d0cd08$var$_slicedToArray(arr, i) {
    return $23f19ac833d0cd08$var$_arrayWithHoles(arr) || $23f19ac833d0cd08$var$_iterableToArrayLimit(arr, i) || $23f19ac833d0cd08$var$_unsupportedIterableToArray(arr, i) || $23f19ac833d0cd08$var$_nonIterableRest();
}
function $23f19ac833d0cd08$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $23f19ac833d0cd08$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $23f19ac833d0cd08$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $23f19ac833d0cd08$var$_arrayLikeToArray(o, minLen);
}
function $23f19ac833d0cd08$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $23f19ac833d0cd08$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $23f19ac833d0cd08$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
var $23f19ac833d0cd08$var$useDirection = $hd4g0.hooks.useDirection;
var $23f19ac833d0cd08$var$ICON_SIZE_FACTOR = 16;
var $23f19ac833d0cd08$var$WarningNotificationIcon = function WarningNotificationIcon(_ref) {
    var className = _ref.className, size = _ref.size;
    var _useDirection = $23f19ac833d0cd08$var$useDirection(), _useDirection2 = $23f19ac833d0cd08$var$_slicedToArray(_useDirection, 1), direction = _useDirection2[0];
    return /*#__PURE__*/ $23f19ac833d0cd08$var$_react.default.createElement("svg", {
        alt: "",
        className: (0, $23f19ac833d0cd08$var$_classnames.default)(className + "", direction === "rtl" && "webchat_warning--rtl"),
        height: $23f19ac833d0cd08$var$ICON_SIZE_FACTOR * size,
        viewBox: "0 0 13.1 13.1",
        width: $23f19ac833d0cd08$var$ICON_SIZE_FACTOR * size
    }, /*#__PURE__*/ $23f19ac833d0cd08$var$_react.default.createElement("path", {
        d: "M13.1,13.1H0L6.6,0L13.1,13.1z M7,10.5H6.1v0.9H7V10.5z M7,9.7V5.2H6.1v4.4L7,9.7z",
        fillRule: "evenodd"
    }));
};
$23f19ac833d0cd08$var$WarningNotificationIcon.defaultProps = {
    className: "",
    size: 1
};
$23f19ac833d0cd08$var$WarningNotificationIcon.propTypes = {
    className: $23f19ac833d0cd08$var$_propTypes.default.string,
    size: $23f19ac833d0cd08$var$_propTypes.default.number
};
var $23f19ac833d0cd08$var$_default = $23f19ac833d0cd08$var$WarningNotificationIcon;
module.exports.default = $23f19ac833d0cd08$var$_default;

});


parcelRequire.register("1NqsY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $hd4g0 = parcelRequire("hd4g0");

var $14eee5bb5fc9f72c$var$_classnames = $14eee5bb5fc9f72c$var$_interopRequireDefault((parcelRequire("5A4MD")));

var $14eee5bb5fc9f72c$var$_react = $14eee5bb5fc9f72c$var$_interopRequireDefault((parcelRequire("eO7Kz")));

var $14eee5bb5fc9f72c$var$_ErrorNotificationIcon = $14eee5bb5fc9f72c$var$_interopRequireDefault((parcelRequire("743sW")));

var $14eee5bb5fc9f72c$var$_ScreenReaderText = $14eee5bb5fc9f72c$var$_interopRequireDefault((parcelRequire("3NTZI")));

var $14eee5bb5fc9f72c$var$_useStyleSet3 = $14eee5bb5fc9f72c$var$_interopRequireDefault((parcelRequire("gC6jZ")));
function $14eee5bb5fc9f72c$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $14eee5bb5fc9f72c$var$_slicedToArray(arr, i) {
    return $14eee5bb5fc9f72c$var$_arrayWithHoles(arr) || $14eee5bb5fc9f72c$var$_iterableToArrayLimit(arr, i) || $14eee5bb5fc9f72c$var$_unsupportedIterableToArray(arr, i) || $14eee5bb5fc9f72c$var$_nonIterableRest();
}
function $14eee5bb5fc9f72c$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $14eee5bb5fc9f72c$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $14eee5bb5fc9f72c$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $14eee5bb5fc9f72c$var$_arrayLikeToArray(o, minLen);
}
function $14eee5bb5fc9f72c$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $14eee5bb5fc9f72c$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $14eee5bb5fc9f72c$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
var $14eee5bb5fc9f72c$var$useDirection = $hd4g0.hooks.useDirection, $14eee5bb5fc9f72c$var$useLocalizer = $hd4g0.hooks.useLocalizer;
var $14eee5bb5fc9f72c$var$ConnectivityStatusFailedToConnect = function ConnectivityStatusFailedToConnect() {
    var _useStyleSet = (0, $14eee5bb5fc9f72c$var$_useStyleSet3.default)(), _useStyleSet2 = $14eee5bb5fc9f72c$var$_slicedToArray(_useStyleSet, 1), errorNotificationStyleSet = _useStyleSet2[0].errorNotification;
    var _useDirection = $14eee5bb5fc9f72c$var$useDirection(), _useDirection2 = $14eee5bb5fc9f72c$var$_slicedToArray(_useDirection, 1), direction = _useDirection2[0];
    var localize = $14eee5bb5fc9f72c$var$useLocalizer();
    var failedConnectionText = localize("CONNECTIVITY_STATUS_ALT_FATAL");
    return /*#__PURE__*/ $14eee5bb5fc9f72c$var$_react.default.createElement($14eee5bb5fc9f72c$var$_react.default.Fragment, null, /*#__PURE__*/ $14eee5bb5fc9f72c$var$_react.default.createElement($14eee5bb5fc9f72c$var$_ScreenReaderText.default, {
        text: localize("CONNECTIVITY_STATUS_ALT", failedConnectionText)
    }), /*#__PURE__*/ $14eee5bb5fc9f72c$var$_react.default.createElement("div", {
        "aria-hidden": true,
        className: (0, $14eee5bb5fc9f72c$var$_classnames.default)("webchat__connectivityStatus", errorNotificationStyleSet + ""),
        dir: direction
    }, /*#__PURE__*/ $14eee5bb5fc9f72c$var$_react.default.createElement($14eee5bb5fc9f72c$var$_ErrorNotificationIcon.default, null), failedConnectionText));
};
var $14eee5bb5fc9f72c$var$_default = $14eee5bb5fc9f72c$var$ConnectivityStatusFailedToConnect;
module.exports.default = $14eee5bb5fc9f72c$var$_default;

});
parcelRequire.register("743sW", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $hd4g0 = parcelRequire("hd4g0");

var $524b9856ddcfead2$var$_classnames = $524b9856ddcfead2$var$_interopRequireDefault((parcelRequire("5A4MD")));

var $524b9856ddcfead2$var$_propTypes = $524b9856ddcfead2$var$_interopRequireDefault((parcelRequire("f7UXb")));

var $524b9856ddcfead2$var$_react = $524b9856ddcfead2$var$_interopRequireDefault((parcelRequire("eO7Kz")));
function $524b9856ddcfead2$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $524b9856ddcfead2$var$_slicedToArray(arr, i) {
    return $524b9856ddcfead2$var$_arrayWithHoles(arr) || $524b9856ddcfead2$var$_iterableToArrayLimit(arr, i) || $524b9856ddcfead2$var$_unsupportedIterableToArray(arr, i) || $524b9856ddcfead2$var$_nonIterableRest();
}
function $524b9856ddcfead2$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $524b9856ddcfead2$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $524b9856ddcfead2$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $524b9856ddcfead2$var$_arrayLikeToArray(o, minLen);
}
function $524b9856ddcfead2$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $524b9856ddcfead2$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $524b9856ddcfead2$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
var $524b9856ddcfead2$var$useDirection = $hd4g0.hooks.useDirection;
var $524b9856ddcfead2$var$ICON_SIZE_FACTOR = 16;
var $524b9856ddcfead2$var$ErrorNotificationIcon = function ErrorNotificationIcon(_ref) {
    var className = _ref.className, size = _ref.size;
    var _useDirection = $524b9856ddcfead2$var$useDirection(), _useDirection2 = $524b9856ddcfead2$var$_slicedToArray(_useDirection, 1), direction = _useDirection2[0];
    return /*#__PURE__*/ $524b9856ddcfead2$var$_react.default.createElement("svg", {
        alt: "",
        className: (0, $524b9856ddcfead2$var$_classnames.default)(className + "", direction === "rtl" && "webchat__error--rtl"),
        height: $524b9856ddcfead2$var$ICON_SIZE_FACTOR * size,
        viewBox: "0 0 13.1 13.1",
        width: $524b9856ddcfead2$var$ICON_SIZE_FACTOR * size
    }, /*#__PURE__*/ $524b9856ddcfead2$var$_react.default.createElement("path", {
        d: "M6.5,13C2.9,13,0,10.1,0,6.5S2.9,0,6.5,0S13,2.9,13,6.5S10.1,13,6.5,13z M6.1,3.5v4.3h0.9V3.5H6.1z M6.1,8.7v0.9h0.9V8.7H6.1z",
        fillRule: "evenodd"
    }));
};
$524b9856ddcfead2$var$ErrorNotificationIcon.defaultProps = {
    className: "",
    size: 1
};
$524b9856ddcfead2$var$ErrorNotificationIcon.propTypes = {
    className: $524b9856ddcfead2$var$_propTypes.default.string,
    size: $524b9856ddcfead2$var$_propTypes.default.number
};
var $524b9856ddcfead2$var$_default = $524b9856ddcfead2$var$ErrorNotificationIcon;
module.exports.default = $524b9856ddcfead2$var$_default;

});


parcelRequire.register("k0bmq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $hd4g0 = parcelRequire("hd4g0");

var $e8fc9eb8703f09f2$var$_classnames = $e8fc9eb8703f09f2$var$_interopRequireDefault((parcelRequire("5A4MD")));

var $e8fc9eb8703f09f2$var$_react = $e8fc9eb8703f09f2$var$_interopRequireDefault((parcelRequire("eO7Kz")));

var $e8fc9eb8703f09f2$var$_ErrorNotificationIcon = $e8fc9eb8703f09f2$var$_interopRequireDefault((parcelRequire("743sW")));

var $e8fc9eb8703f09f2$var$_ScreenReaderText = $e8fc9eb8703f09f2$var$_interopRequireDefault((parcelRequire("3NTZI")));

var $e8fc9eb8703f09f2$var$_useStyleSet3 = $e8fc9eb8703f09f2$var$_interopRequireDefault((parcelRequire("gC6jZ")));
function $e8fc9eb8703f09f2$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $e8fc9eb8703f09f2$var$_slicedToArray(arr, i) {
    return $e8fc9eb8703f09f2$var$_arrayWithHoles(arr) || $e8fc9eb8703f09f2$var$_iterableToArrayLimit(arr, i) || $e8fc9eb8703f09f2$var$_unsupportedIterableToArray(arr, i) || $e8fc9eb8703f09f2$var$_nonIterableRest();
}
function $e8fc9eb8703f09f2$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $e8fc9eb8703f09f2$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $e8fc9eb8703f09f2$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $e8fc9eb8703f09f2$var$_arrayLikeToArray(o, minLen);
}
function $e8fc9eb8703f09f2$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $e8fc9eb8703f09f2$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $e8fc9eb8703f09f2$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
var $e8fc9eb8703f09f2$var$useDirection = $hd4g0.hooks.useDirection, $e8fc9eb8703f09f2$var$useLocalizer = $hd4g0.hooks.useLocalizer;
var $e8fc9eb8703f09f2$var$ConnectivityStatusJavaScriptError = function ConnectivityStatusJavaScriptError() {
    var _useStyleSet = (0, $e8fc9eb8703f09f2$var$_useStyleSet3.default)(), _useStyleSet2 = $e8fc9eb8703f09f2$var$_slicedToArray(_useStyleSet, 1), errorNotificationStyleSet = _useStyleSet2[0].errorNotification;
    var _useDirection = $e8fc9eb8703f09f2$var$useDirection(), _useDirection2 = $e8fc9eb8703f09f2$var$_slicedToArray(_useDirection, 1), direction = _useDirection2[0];
    var localize = $e8fc9eb8703f09f2$var$useLocalizer();
    var renderErrorNotificationText = localize("CONNECTIVITY_STATUS_ALT_RENDER_ERROR");
    return /*#__PURE__*/ $e8fc9eb8703f09f2$var$_react.default.createElement($e8fc9eb8703f09f2$var$_react.default.Fragment, null, /*#__PURE__*/ $e8fc9eb8703f09f2$var$_react.default.createElement($e8fc9eb8703f09f2$var$_ScreenReaderText.default, {
        text: localize("CONNECTIVITY_STATUS_ALT", renderErrorNotificationText)
    }), /*#__PURE__*/ $e8fc9eb8703f09f2$var$_react.default.createElement("div", {
        "aria-hidden": true,
        className: (0, $e8fc9eb8703f09f2$var$_classnames.default)("webchat__connectivityStatus", errorNotificationStyleSet + ""),
        dir: direction
    }, /*#__PURE__*/ $e8fc9eb8703f09f2$var$_react.default.createElement($e8fc9eb8703f09f2$var$_ErrorNotificationIcon.default, null), renderErrorNotificationText));
};
var $e8fc9eb8703f09f2$var$_default = $e8fc9eb8703f09f2$var$ConnectivityStatusJavaScriptError;
module.exports.default = $e8fc9eb8703f09f2$var$_default;

});


parcelRequire.register("ha8W8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.useSendBoxSpeechInterimsVisible = $c7ea4d7330e6a1a5$var$useSendBoxSpeechInterimsVisible;

var $cG9B9 = parcelRequire("cG9B9");

var $hd4g0 = parcelRequire("hd4g0");

var $c7ea4d7330e6a1a5$var$_classnames = $c7ea4d7330e6a1a5$var$_interopRequireDefault((parcelRequire("5A4MD")));

var $c7ea4d7330e6a1a5$var$_propTypes = $c7ea4d7330e6a1a5$var$_interopRequireDefault((parcelRequire("f7UXb")));

var $c7ea4d7330e6a1a5$var$_react = $c7ea4d7330e6a1a5$var$_interopRequireDefault((parcelRequire("eO7Kz")));

var $c7ea4d7330e6a1a5$var$_DictationInterims = $c7ea4d7330e6a1a5$var$_interopRequireDefault((parcelRequire("kGvuG")));

var $c7ea4d7330e6a1a5$var$_MicrophoneButton = $c7ea4d7330e6a1a5$var$_interopRequireDefault((parcelRequire("dtULG")));

var $c7ea4d7330e6a1a5$var$_SendButton = $c7ea4d7330e6a1a5$var$_interopRequireDefault((parcelRequire("64e5f")));

var $c7ea4d7330e6a1a5$var$_SuggestedActions = $c7ea4d7330e6a1a5$var$_interopRequireDefault((parcelRequire("lP26E")));

var $c7ea4d7330e6a1a5$var$_TextBox = $c7ea4d7330e6a1a5$var$_interopRequireDefault((parcelRequire("6sNkp")));

var $c7ea4d7330e6a1a5$var$_UploadButton = $c7ea4d7330e6a1a5$var$_interopRequireDefault((parcelRequire("b4v9C")));

var $c7ea4d7330e6a1a5$var$_useErrorMessageId3 = $c7ea4d7330e6a1a5$var$_interopRequireDefault((parcelRequire("gwmJ5")));

var $c7ea4d7330e6a1a5$var$_useStyleSet3 = $c7ea4d7330e6a1a5$var$_interopRequireDefault((parcelRequire("gC6jZ")));

var $c7ea4d7330e6a1a5$var$_useStyleToEmotionObject = $c7ea4d7330e6a1a5$var$_interopRequireDefault((parcelRequire("6l4uV")));

var $c7ea4d7330e6a1a5$var$_useWebSpeechPonyfill5 = $c7ea4d7330e6a1a5$var$_interopRequireDefault((parcelRequire("dCR9j")));
function $c7ea4d7330e6a1a5$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $c7ea4d7330e6a1a5$var$_slicedToArray(arr, i) {
    return $c7ea4d7330e6a1a5$var$_arrayWithHoles(arr) || $c7ea4d7330e6a1a5$var$_iterableToArrayLimit(arr, i) || $c7ea4d7330e6a1a5$var$_unsupportedIterableToArray(arr, i) || $c7ea4d7330e6a1a5$var$_nonIterableRest();
}
function $c7ea4d7330e6a1a5$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $c7ea4d7330e6a1a5$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $c7ea4d7330e6a1a5$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $c7ea4d7330e6a1a5$var$_arrayLikeToArray(o, minLen);
}
function $c7ea4d7330e6a1a5$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $c7ea4d7330e6a1a5$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $c7ea4d7330e6a1a5$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
var $c7ea4d7330e6a1a5$var$_Constants$DictateSta = $cG9B9.Constants.DictateState, $c7ea4d7330e6a1a5$var$DICTATING = $c7ea4d7330e6a1a5$var$_Constants$DictateSta.DICTATING, $c7ea4d7330e6a1a5$var$STARTING = $c7ea4d7330e6a1a5$var$_Constants$DictateSta.STARTING;
var $c7ea4d7330e6a1a5$var$useActivities = $hd4g0.hooks.useActivities, $c7ea4d7330e6a1a5$var$useDirection = $hd4g0.hooks.useDirection, $c7ea4d7330e6a1a5$var$useDictateState = $hd4g0.hooks.useDictateState, $c7ea4d7330e6a1a5$var$useStyleOptions = $hd4g0.hooks.useStyleOptions;
var $c7ea4d7330e6a1a5$var$ROOT_STYLE = {
    "&.webchat__send-box": {
        "& .webchat__send-box__button": {
            flexShrink: 0
        },
        "& .webchat__send-box__dictation-interims": {
            flex: 10000
        },
        "& .webchat__send-box__main": {
            display: "flex"
        },
        "& .webchat__send-box__microphone-button": {
            flex: 1
        },
        "& .webchat__send-box__text-box": {
            flex: 10000
        }
    }
}; // TODO: [P3] We should consider exposing core/src/definitions and use it instead
function $c7ea4d7330e6a1a5$var$activityIsSpeakingOrQueuedToSpeak(activity) {
    var _activity$channelData;
    return activity.type === "message" && ((_activity$channelData = activity.channelData) === null || _activity$channelData === void 0 ? void 0 : _activity$channelData.speak);
}
function $c7ea4d7330e6a1a5$var$useSendBoxSpeechInterimsVisible() {
    var _useActivities = $c7ea4d7330e6a1a5$var$useActivities(), _useActivities2 = $c7ea4d7330e6a1a5$var$_slicedToArray(_useActivities, 1), activities = _useActivities2[0];
    var _useDictateState = $c7ea4d7330e6a1a5$var$useDictateState(), _useDictateState2 = $c7ea4d7330e6a1a5$var$_slicedToArray(_useDictateState, 1), dictateState = _useDictateState2[0];
    return [
        (dictateState === $c7ea4d7330e6a1a5$var$STARTING || dictateState === $c7ea4d7330e6a1a5$var$DICTATING) && !activities.filter($c7ea4d7330e6a1a5$var$activityIsSpeakingOrQueuedToSpeak).length
    ];
}
var $c7ea4d7330e6a1a5$var$BasicSendBox = function BasicSendBox(_ref) {
    var className = _ref.className;
    var _useStyleOptions = $c7ea4d7330e6a1a5$var$useStyleOptions(), _useStyleOptions2 = $c7ea4d7330e6a1a5$var$_slicedToArray(_useStyleOptions, 1), _useStyleOptions2$ = _useStyleOptions2[0], hideUploadButton = _useStyleOptions2$.hideUploadButton, sendBoxButtonAlignment = _useStyleOptions2$.sendBoxButtonAlignment;
    var _useStyleSet = (0, $c7ea4d7330e6a1a5$var$_useStyleSet3.default)(), _useStyleSet2 = $c7ea4d7330e6a1a5$var$_slicedToArray(_useStyleSet, 1), sendBoxStyleSet = _useStyleSet2[0].sendBox;
    var _useWebSpeechPonyfill = (0, $c7ea4d7330e6a1a5$var$_useWebSpeechPonyfill5.default)(), _useWebSpeechPonyfill2 = $c7ea4d7330e6a1a5$var$_slicedToArray(_useWebSpeechPonyfill, 1), _useWebSpeechPonyfill3 = _useWebSpeechPonyfill2[0];
    _useWebSpeechPonyfill3 = _useWebSpeechPonyfill3 === void 0 ? {} : _useWebSpeechPonyfill3;
    var _useWebSpeechPonyfill4 = _useWebSpeechPonyfill3.SpeechRecognition, SpeechRecognition = _useWebSpeechPonyfill4 === void 0 ? undefined : _useWebSpeechPonyfill4;
    var _useDirection = $c7ea4d7330e6a1a5$var$useDirection(), _useDirection2 = $c7ea4d7330e6a1a5$var$_slicedToArray(_useDirection, 1), direction = _useDirection2[0];
    var _useErrorMessageId = (0, $c7ea4d7330e6a1a5$var$_useErrorMessageId3.default)(), _useErrorMessageId2 = $c7ea4d7330e6a1a5$var$_slicedToArray(_useErrorMessageId, 1), errorMessageId = _useErrorMessageId2[0];
    var _useSendBoxSpeechInte = $c7ea4d7330e6a1a5$var$useSendBoxSpeechInterimsVisible(), _useSendBoxSpeechInte2 = $c7ea4d7330e6a1a5$var$_slicedToArray(_useSendBoxSpeechInte, 1), speechInterimsVisible = _useSendBoxSpeechInte2[0];
    var styleToEmotionObject = (0, $c7ea4d7330e6a1a5$var$_useStyleToEmotionObject.default)();
    var rootClassName = styleToEmotionObject($c7ea4d7330e6a1a5$var$ROOT_STYLE) + "";
    var supportSpeechRecognition = !!SpeechRecognition;
    var buttonClassName = (0, $c7ea4d7330e6a1a5$var$_classnames.default)("webchat__send-box__button", {
        "webchat__send-box__button--align-bottom": sendBoxButtonAlignment === "bottom",
        "webchat__send-box__button--align-stretch": sendBoxButtonAlignment !== "bottom" && sendBoxButtonAlignment !== "top",
        "webchat__send-box__button--align-top": sendBoxButtonAlignment === "top"
    });
    return /*#__PURE__*/ $c7ea4d7330e6a1a5$var$_react.default.createElement("div", {
        "aria-errormessage": errorMessageId,
        "aria-invalid": !!errorMessageId,
        className: (0, $c7ea4d7330e6a1a5$var$_classnames.default)("webchat__send-box", sendBoxStyleSet + "", rootClassName + "", (className || "") + ""),
        dir: direction,
        role: "form"
    }, /*#__PURE__*/ $c7ea4d7330e6a1a5$var$_react.default.createElement($c7ea4d7330e6a1a5$var$_SuggestedActions.default, null), /*#__PURE__*/ $c7ea4d7330e6a1a5$var$_react.default.createElement("div", {
        className: "webchat__send-box__main"
    }, !hideUploadButton && /*#__PURE__*/ $c7ea4d7330e6a1a5$var$_react.default.createElement($c7ea4d7330e6a1a5$var$_UploadButton.default, {
        className: buttonClassName
    }), speechInterimsVisible ? /*#__PURE__*/ $c7ea4d7330e6a1a5$var$_react.default.createElement($c7ea4d7330e6a1a5$var$_DictationInterims.default, {
        className: "webchat__send-box__dictation-interims"
    }) : /*#__PURE__*/ $c7ea4d7330e6a1a5$var$_react.default.createElement($c7ea4d7330e6a1a5$var$_TextBox.default, {
        className: "webchat__send-box__text-box"
    }), supportSpeechRecognition ? /*#__PURE__*/ $c7ea4d7330e6a1a5$var$_react.default.createElement($c7ea4d7330e6a1a5$var$_MicrophoneButton.default, {
        className: (0, $c7ea4d7330e6a1a5$var$_classnames.default)(buttonClassName, "webchat__send-box__microphone-button")
    }) : /*#__PURE__*/ $c7ea4d7330e6a1a5$var$_react.default.createElement($c7ea4d7330e6a1a5$var$_SendButton.default, {
        className: buttonClassName
    })));
};
$c7ea4d7330e6a1a5$var$BasicSendBox.defaultProps = {
    className: ""
};
$c7ea4d7330e6a1a5$var$BasicSendBox.propTypes = {
    className: $c7ea4d7330e6a1a5$var$_propTypes.default.string
};
var $c7ea4d7330e6a1a5$var$_default = $c7ea4d7330e6a1a5$var$BasicSendBox;
module.exports.default = $c7ea4d7330e6a1a5$var$_default;

});
parcelRequire.register("kGvuG", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = module.exports.connectDictationInterims = void 0;

var $cG9B9 = parcelRequire("cG9B9");

var $hd4g0 = parcelRequire("hd4g0");

var $f0f028ead6211bb0$var$_classnames = $f0f028ead6211bb0$var$_interopRequireDefault((parcelRequire("5A4MD")));

var $f0f028ead6211bb0$var$_propTypes = $f0f028ead6211bb0$var$_interopRequireDefault((parcelRequire("f7UXb")));

var $f0f028ead6211bb0$var$_react = $f0f028ead6211bb0$var$_interopRequireDefault((parcelRequire("eO7Kz")));

var $f0f028ead6211bb0$var$_connectToWebChat = $f0f028ead6211bb0$var$_interopRequireDefault((parcelRequire("86vmQ")));

var $f0f028ead6211bb0$var$_useStyleSet3 = $f0f028ead6211bb0$var$_interopRequireDefault((parcelRequire("gC6jZ")));

var $f0f028ead6211bb0$var$_useStyleToEmotionObject = $f0f028ead6211bb0$var$_interopRequireDefault((parcelRequire("6l4uV")));
function $f0f028ead6211bb0$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $f0f028ead6211bb0$var$_slicedToArray(arr, i) {
    return $f0f028ead6211bb0$var$_arrayWithHoles(arr) || $f0f028ead6211bb0$var$_iterableToArrayLimit(arr, i) || $f0f028ead6211bb0$var$_unsupportedIterableToArray(arr, i) || $f0f028ead6211bb0$var$_nonIterableRest();
}
function $f0f028ead6211bb0$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $f0f028ead6211bb0$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $f0f028ead6211bb0$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $f0f028ead6211bb0$var$_arrayLikeToArray(o, minLen);
}
function $f0f028ead6211bb0$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $f0f028ead6211bb0$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $f0f028ead6211bb0$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
var $f0f028ead6211bb0$var$_Constants$DictateSta = $cG9B9.Constants.DictateState, $f0f028ead6211bb0$var$DICTATING = $f0f028ead6211bb0$var$_Constants$DictateSta.DICTATING, $f0f028ead6211bb0$var$STARTING = $f0f028ead6211bb0$var$_Constants$DictateSta.STARTING, $f0f028ead6211bb0$var$STOPPING = $f0f028ead6211bb0$var$_Constants$DictateSta.STOPPING;
var $f0f028ead6211bb0$var$useDictateInterims = $hd4g0.hooks.useDictateInterims, $f0f028ead6211bb0$var$useDictateState = $hd4g0.hooks.useDictateState, $f0f028ead6211bb0$var$useLocalizer = $hd4g0.hooks.useLocalizer;
var $f0f028ead6211bb0$var$ROOT_STYLE = {
    alignItems: "center",
    display: "flex"
};
var $f0f028ead6211bb0$var$connectDictationInterims = function connectDictationInterims() {
    for(var _len = arguments.length, selectors = new Array(_len), _key = 0; _key < _len; _key++)selectors[_key] = arguments[_key];
    return $f0f028ead6211bb0$var$_connectToWebChat.default.apply(void 0, [
        function(_ref) {
            var dictateInterims = _ref.dictateInterims, dictateState = _ref.dictateState, language = _ref.language;
            return {
                dictateInterims: dictateInterims,
                dictateState: dictateState,
                language: language
            };
        }
    ].concat(selectors));
};
module.exports.connectDictationInterims = $f0f028ead6211bb0$var$connectDictationInterims;
var $f0f028ead6211bb0$var$DictationInterims = function DictationInterims(_ref2) {
    var className = _ref2.className;
    var _useDictateInterims = $f0f028ead6211bb0$var$useDictateInterims(), _useDictateInterims2 = $f0f028ead6211bb0$var$_slicedToArray(_useDictateInterims, 1), dictateInterims = _useDictateInterims2[0];
    var _useDictateState = $f0f028ead6211bb0$var$useDictateState(), _useDictateState2 = $f0f028ead6211bb0$var$_slicedToArray(_useDictateState, 1), dictateState = _useDictateState2[0];
    var _useStyleSet = (0, $f0f028ead6211bb0$var$_useStyleSet3.default)(), _useStyleSet2 = $f0f028ead6211bb0$var$_slicedToArray(_useStyleSet, 1), dictationInterimsStyleSet = _useStyleSet2[0].dictationInterims;
    var localize = $f0f028ead6211bb0$var$useLocalizer();
    var rootClassName = (0, $f0f028ead6211bb0$var$_useStyleToEmotionObject.default)()($f0f028ead6211bb0$var$ROOT_STYLE) + "";
    return dictateState === $f0f028ead6211bb0$var$STARTING || dictateState === $f0f028ead6211bb0$var$STOPPING ? /*#__PURE__*/ $f0f028ead6211bb0$var$_react.default.createElement("p", {
        className: (0, $f0f028ead6211bb0$var$_classnames.default)(dictationInterimsStyleSet + "", rootClassName, (className || "") + "", "status")
    }, dictateState === $f0f028ead6211bb0$var$STARTING && localize("SPEECH_INPUT_STARTING")) : dictateState === $f0f028ead6211bb0$var$DICTATING && (dictateInterims.length ? /*#__PURE__*/ $f0f028ead6211bb0$var$_react.default.createElement("p", {
        className: (0, $f0f028ead6211bb0$var$_classnames.default)(dictationInterimsStyleSet + "", rootClassName, (className || "") + "", "dictating")
    }, dictateInterims.map(function(interim, index) {
        return /*#__PURE__*/ $f0f028ead6211bb0$var$_react.default.createElement("span", {
            key: index
        }, interim, "\xa0");
    })) : /*#__PURE__*/ $f0f028ead6211bb0$var$_react.default.createElement("p", {
        className: (0, $f0f028ead6211bb0$var$_classnames.default)(dictationInterimsStyleSet + "", rootClassName, (className || "") + "", "status")
    }, localize("SPEECH_INPUT_LISTENING")));
};
$f0f028ead6211bb0$var$DictationInterims.defaultProps = {
    className: ""
};
$f0f028ead6211bb0$var$DictationInterims.propTypes = {
    className: $f0f028ead6211bb0$var$_propTypes.default.string
}; // TODO: [P3] After speech started, when clicking on the transcript, it should
//       stop the dictation and allow the user to type-correct the transcript
var $f0f028ead6211bb0$var$_default = $f0f028ead6211bb0$var$DictationInterims;
module.exports.default = $f0f028ead6211bb0$var$_default;

});
parcelRequire.register("86vmQ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $5e67372dc374853b$var$connectToWebChat;
parcelRequire("b4zbW");
var $chg8Y = parcelRequire("chg8Y");

var $cG9B9 = parcelRequire("cG9B9");

var $5e67372dc374853b$var$_react = $5e67372dc374853b$var$_interopRequireDefault((parcelRequire("eO7Kz")));

var $5e67372dc374853b$var$_WebChatAPIContext = $5e67372dc374853b$var$_interopRequireDefault((parcelRequire("aHcFB")));

var $5e67372dc374853b$var$_WebChatReduxContext = $5e67372dc374853b$var$_interopRequireDefault((parcelRequire("kSc9m")));
var $5e67372dc374853b$var$_excluded = [
    "context"
];
function $5e67372dc374853b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $5e67372dc374853b$var$_extends() {
    $5e67372dc374853b$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $5e67372dc374853b$var$_extends.apply(this, arguments);
}
function $5e67372dc374853b$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $5e67372dc374853b$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $5e67372dc374853b$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $5e67372dc374853b$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $5e67372dc374853b$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $5e67372dc374853b$var$ownKeys(Object(source), !0).forEach(function(key) {
            $5e67372dc374853b$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $5e67372dc374853b$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $5e67372dc374853b$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $5e67372dc374853b$var$removeUndefinedValues(map) {
    return Object.keys(map).reduce(function(result, key) {
        if (!(0, $cG9B9.isForbiddenPropertyName)(key)) {
            // Mitigated through denylisting.
            // eslint-disable-next-line security/detect-object-injection
            var value = map[key];
            if (typeof value !== "undefined") // Mitigated through denylisting.
            // eslint-disable-next-line security/detect-object-injection
            result[key] = value;
        }
        return result;
    }, {});
}
function $5e67372dc374853b$var$combineSelectors() {
    for(var _len = arguments.length, selectors = new Array(_len), _key = 0; _key < _len; _key++)selectors[_key] = arguments[_key];
    return function() {
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        return selectors.reduce(function(result, selector) {
            return $5e67372dc374853b$var$_objectSpread($5e67372dc374853b$var$_objectSpread({}, result), $5e67372dc374853b$var$removeUndefinedValues(selector && selector.apply(void 0, args) || {}));
        }, {});
    };
}
function $5e67372dc374853b$var$connectToWebChat() {
    var combinedSelector = $5e67372dc374853b$var$combineSelectors.apply(void 0, arguments); // TODO: [P1] Instead of exposing Redux store via props, we should consider exposing via Context.
    //       We should also hide dispatch function.
    return function(Component) {
        var ConnectedComponent = (0, $chg8Y.default)(function(state, _ref) {
            var context = _ref.context, ownProps = $5e67372dc374853b$var$_objectWithoutProperties(_ref, $5e67372dc374853b$var$_excluded);
            return combinedSelector($5e67372dc374853b$var$_objectSpread($5e67372dc374853b$var$_objectSpread({}, state), context), ownProps);
        }, null, null, {
            context: $5e67372dc374853b$var$_WebChatReduxContext.default
        })(Component);
        var WebChatConnectedComponent = function WebChatConnectedComponent(props) {
            return /*#__PURE__*/ $5e67372dc374853b$var$_react.default.createElement($5e67372dc374853b$var$_WebChatAPIContext.default.Consumer, null, function(context) {
                return /*#__PURE__*/ $5e67372dc374853b$var$_react.default.createElement(ConnectedComponent, $5e67372dc374853b$var$_extends({}, props, {
                    context: context
                }));
            });
        };
        return WebChatConnectedComponent;
    };
}

});
parcelRequire.register("b4zbW", function(module, exports) {
$parcel$export(module.exports, "connect", () => (parcelRequire("chg8Y")).default);
parcelRequire("2vew5");
parcelRequire("boKHW");
var $kz03S = parcelRequire("kz03S");

var $4wOOL = parcelRequire("4wOOL");
// with standard React renderers (ReactDOM, React Native)
(0, $4wOOL.setBatch)((0, $kz03S.unstable_batchedUpdates));

});
parcelRequire.register("2vew5", function(module, exports) {

$parcel$export(module.exports, "connect", () => (parcelRequire("chg8Y")).default);

var $4EtrF = parcelRequire("4EtrF");

var $7gZ5A = parcelRequire("7gZ5A");

var $WdDjx = parcelRequire("WdDjx");

var $chg8Y = parcelRequire("chg8Y");

var $ea1kj = parcelRequire("ea1kj");

var $8KO5F = parcelRequire("8KO5F");

var $eQjAp = parcelRequire("eQjAp");

var $cgBQi = parcelRequire("cgBQi");

});
parcelRequire.register("4EtrF", function(module, exports) {

var $eO7Kz = parcelRequire("eO7Kz");


var $WdDjx = parcelRequire("WdDjx");

var $635sM = parcelRequire("635sM");

var $hWudq = parcelRequire("hWudq");
function $3631bd1608e13f65$var$Provider(_ref) {
    var store = _ref.store, context = _ref.context, children = _ref.children;
    var contextValue = (0, $eO7Kz.useMemo)(function() {
        var subscription = (0, $635sM.createSubscription)(store);
        return {
            store: store,
            subscription: subscription
        };
    }, [
        store
    ]);
    var previousState = (0, $eO7Kz.useMemo)(function() {
        return store.getState();
    }, [
        store
    ]);
    (0, $hWudq.useIsomorphicLayoutEffect)(function() {
        var subscription = contextValue.subscription;
        subscription.onStateChange = subscription.notifyNestedSubs;
        subscription.trySubscribe();
        if (previousState !== store.getState()) subscription.notifyNestedSubs();
        return function() {
            subscription.tryUnsubscribe();
            subscription.onStateChange = null;
        };
    }, [
        contextValue,
        previousState
    ]);
    var Context = context || (0, $WdDjx.ReactReduxContext);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eO7Kz))).createElement(Context.Provider, {
        value: contextValue
    }, children);
}
var $3631bd1608e13f65$export$2e2bcd8739ae039 = $3631bd1608e13f65$var$Provider;

});
parcelRequire.register("WdDjx", function(module, exports) {

$parcel$export(module.exports, "ReactReduxContext", () => $0aeffe24bf359af3$export$cc80c08dc91f1c00);

var $eO7Kz = parcelRequire("eO7Kz");
var $0aeffe24bf359af3$export$cc80c08dc91f1c00 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eO7Kz))).createContext(null);
var $0aeffe24bf359af3$export$2e2bcd8739ae039 = $0aeffe24bf359af3$export$cc80c08dc91f1c00;

});

parcelRequire.register("635sM", function(module, exports) {

$parcel$export(module.exports, "createSubscription", () => $467742c51559af8e$export$d567d2b9af322f8f);

var $4wOOL = parcelRequire("4wOOL");
// well as nesting subscriptions of descendant components, so that we can ensure the
// ancestor components re-render before descendants
function $467742c51559af8e$var$createListenerCollection() {
    var batch = (0, $4wOOL.getBatch)();
    var first = null;
    var last = null;
    return {
        clear: function clear() {
            first = null;
            last = null;
        },
        notify: function notify() {
            batch(function() {
                var listener = first;
                while(listener){
                    listener.callback();
                    listener = listener.next;
                }
            });
        },
        get: function get() {
            var listeners = [];
            var listener = first;
            while(listener){
                listeners.push(listener);
                listener = listener.next;
            }
            return listeners;
        },
        subscribe: function subscribe(callback) {
            var isSubscribed = true;
            var listener = last = {
                callback: callback,
                next: null,
                prev: last
            };
            if (listener.prev) listener.prev.next = listener;
            else first = listener;
            return function unsubscribe() {
                if (!isSubscribed || first === null) return;
                isSubscribed = false;
                if (listener.next) listener.next.prev = listener.prev;
                else last = listener.prev;
                if (listener.prev) listener.prev.next = listener.next;
                else first = listener.next;
            };
        }
    };
}
var $467742c51559af8e$var$nullListeners = {
    notify: function notify() {},
    get: function get() {
        return [];
    }
};
function $467742c51559af8e$export$d567d2b9af322f8f(store, parentSub) {
    var unsubscribe;
    var listeners = $467742c51559af8e$var$nullListeners;
    function addNestedSub(listener) {
        trySubscribe();
        return listeners.subscribe(listener);
    }
    function notifyNestedSubs() {
        listeners.notify();
    }
    function handleChangeWrapper() {
        if (subscription.onStateChange) subscription.onStateChange();
    }
    function isSubscribed() {
        return Boolean(unsubscribe);
    }
    function trySubscribe() {
        if (!unsubscribe) {
            unsubscribe = parentSub ? parentSub.addNestedSub(handleChangeWrapper) : store.subscribe(handleChangeWrapper);
            listeners = $467742c51559af8e$var$createListenerCollection();
        }
    }
    function tryUnsubscribe() {
        if (unsubscribe) {
            unsubscribe();
            unsubscribe = undefined;
            listeners.clear();
            listeners = $467742c51559af8e$var$nullListeners;
        }
    }
    var subscription = {
        addNestedSub: addNestedSub,
        notifyNestedSubs: notifyNestedSubs,
        handleChangeWrapper: handleChangeWrapper,
        isSubscribed: isSubscribed,
        trySubscribe: trySubscribe,
        tryUnsubscribe: tryUnsubscribe,
        getListeners: function getListeners() {
            return listeners;
        }
    };
    return subscription;
}

});
parcelRequire.register("4wOOL", function(module, exports) {

$parcel$export(module.exports, "setBatch", () => $34c191f19c3b7988$export$4b9874722d0da7bc);
$parcel$export(module.exports, "getBatch", () => $34c191f19c3b7988$export$fc47d4c0ba3bd2c6);
// Default to a dummy "batch" implementation that just runs the callback
function $34c191f19c3b7988$var$defaultNoopBatch(callback) {
    callback();
}
var $34c191f19c3b7988$var$batch = $34c191f19c3b7988$var$defaultNoopBatch; // Allow injecting another batching function later
var $34c191f19c3b7988$export$4b9874722d0da7bc = function setBatch(newBatch) {
    return $34c191f19c3b7988$var$batch = newBatch;
}; // Supply a getter just to skip dealing with ESM bindings
var $34c191f19c3b7988$export$fc47d4c0ba3bd2c6 = function getBatch() {
    return $34c191f19c3b7988$var$batch;
};

});


parcelRequire.register("hWudq", function(module, exports) {

$parcel$export(module.exports, "useIsomorphicLayoutEffect", () => $d0ff4aa565307638$export$700979bc83e7db82);

var $eO7Kz = parcelRequire("eO7Kz");
var $d0ff4aa565307638$export$700979bc83e7db82 = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined" ? (0, $eO7Kz.useLayoutEffect) : (0, $eO7Kz.useEffect);

});


parcelRequire.register("7gZ5A", function(module, exports) {

$parcel$export(module.exports, "default", () => $54b96a09151e353d$export$2e2bcd8739ae039);

var $aO5a1 = parcelRequire("aO5a1");

var $akilq = parcelRequire("akilq");

var $hKDRv = parcelRequire("hKDRv");

var $eO7Kz = parcelRequire("eO7Kz");

var $iM5D7 = parcelRequire("iM5D7");

var $635sM = parcelRequire("635sM");

var $hWudq = parcelRequire("hWudq");

var $WdDjx = parcelRequire("WdDjx");
var $54b96a09151e353d$var$_excluded = [
    "getDisplayName",
    "methodName",
    "renderCountProp",
    "shouldHandleStateChanges",
    "storeKey",
    "withRef",
    "forwardRef",
    "context"
], $54b96a09151e353d$var$_excluded2 = [
    "reactReduxForwardedRef"
];
var $54b96a09151e353d$var$EMPTY_ARRAY = [];
var $54b96a09151e353d$var$NO_SUBSCRIPTION_ARRAY = [
    null,
    null
];
var $54b96a09151e353d$var$stringifyComponent = function stringifyComponent(Comp) {
    try {
        return JSON.stringify(Comp);
    } catch (err) {
        return String(Comp);
    }
};
function $54b96a09151e353d$var$storeStateUpdatesReducer(state, action) {
    var updateCount = state[1];
    return [
        action.payload,
        updateCount + 1
    ];
}
function $54b96a09151e353d$var$useIsomorphicLayoutEffectWithArgs(effectFunc, effectArgs, dependencies) {
    (0, $hWudq.useIsomorphicLayoutEffect)(function() {
        return effectFunc.apply(void 0, effectArgs);
    }, dependencies);
}
function $54b96a09151e353d$var$captureWrapperProps(lastWrapperProps, lastChildProps, renderIsScheduled, wrapperProps, actualChildProps, childPropsFromStoreUpdate, notifyNestedSubs) {
    // We want to capture the wrapper props and child props we used for later comparisons
    lastWrapperProps.current = wrapperProps;
    lastChildProps.current = actualChildProps;
    renderIsScheduled.current = false; // If the render was from a store update, clear out that reference and cascade the subscriber update
    if (childPropsFromStoreUpdate.current) {
        childPropsFromStoreUpdate.current = null;
        notifyNestedSubs();
    }
}
function $54b96a09151e353d$var$subscribeUpdates(shouldHandleStateChanges, store, subscription, childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, childPropsFromStoreUpdate, notifyNestedSubs, forceComponentUpdateDispatch) {
    // If we're not subscribed to the store, nothing to do here
    if (!shouldHandleStateChanges) return; // Capture values for checking if and when this component unmounts
    var didUnsubscribe = false;
    var lastThrownError = null; // We'll run this callback every time a store subscription update propagates to this component
    var checkForUpdates = function checkForUpdates() {
        if (didUnsubscribe) // Don't run stale listeners.
        // Redux doesn't guarantee unsubscriptions happen until next dispatch.
        return;
        var latestStoreState = store.getState();
        var newChildProps, error;
        try {
            // Actually run the selector with the most recent store state and wrapper props
            // to determine what the child props should be
            newChildProps = childPropsSelector(latestStoreState, lastWrapperProps.current);
        } catch (e) {
            error = e;
            lastThrownError = e;
        }
        if (!error) lastThrownError = null;
         // If the child props haven't changed, nothing to do here - cascade the subscription update
        if (newChildProps === lastChildProps.current) {
            if (!renderIsScheduled.current) notifyNestedSubs();
        } else {
            // Save references to the new child props.  Note that we track the "child props from store update"
            // as a ref instead of a useState/useReducer because we need a way to determine if that value has
            // been processed.  If this went into useState/useReducer, we couldn't clear out the value without
            // forcing another re-render, which we don't want.
            lastChildProps.current = newChildProps;
            childPropsFromStoreUpdate.current = newChildProps;
            renderIsScheduled.current = true; // If the child props _did_ change (or we caught an error), this wrapper component needs to re-render
            forceComponentUpdateDispatch({
                type: "STORE_UPDATED",
                payload: {
                    error: error
                }
            });
        }
    }; // Actually subscribe to the nearest connected ancestor (or store)
    subscription.onStateChange = checkForUpdates;
    subscription.trySubscribe(); // Pull data from the store after first render in case the store has
    // changed since we began.
    checkForUpdates();
    var unsubscribeWrapper = function unsubscribeWrapper() {
        didUnsubscribe = true;
        subscription.tryUnsubscribe();
        subscription.onStateChange = null;
        if (lastThrownError) // It's possible that we caught an error due to a bad mapState function, but the
        // parent re-rendered without this component and we're about to unmount.
        // This shouldn't happen as long as we do top-down subscriptions correctly, but
        // if we ever do those wrong, this throw will surface the error in our tests.
        // In that case, throw the error from here so it doesn't get lost.
        throw lastThrownError;
    };
    return unsubscribeWrapper;
}
var $54b96a09151e353d$var$initStateUpdates = function initStateUpdates() {
    return [
        null,
        0
    ];
};
function $54b96a09151e353d$export$2e2bcd8739ae039(/*
  selectorFactory is a func that is responsible for returning the selector function used to
  compute new props from state, props, and dispatch. For example:
      export default connectAdvanced((dispatch, options) => (state, props) => ({
      thing: state.things[props.thingId],
      saveThing: fields => dispatch(actionCreators.saveThing(props.thingId, fields)),
    }))(YourComponent)
    Access to dispatch is provided to the factory so selectorFactories can bind actionCreators
  outside of their selector as an optimization. Options passed to connectAdvanced are passed to
  the selectorFactory, along with displayName and WrappedComponent, as the second argument.
    Note that selectorFactory is responsible for all caching/memoization of inbound and outbound
  props. Do not use connectAdvanced directly without memoizing results between calls to your
  selector, otherwise the Connect component will re-render on every state or props change.
*/ selectorFactory, _ref) {
    if (_ref === void 0) _ref = {};
    var _ref2 = _ref, _ref2$getDisplayName = _ref2.getDisplayName, getDisplayName = _ref2$getDisplayName === void 0 ? function(name) {
        return "ConnectAdvanced(" + name + ")";
    } : _ref2$getDisplayName, _ref2$methodName = _ref2.methodName, methodName = _ref2$methodName === void 0 ? "connectAdvanced" : _ref2$methodName, _ref2$renderCountProp = _ref2.renderCountProp, renderCountProp = _ref2$renderCountProp === void 0 ? undefined : _ref2$renderCountProp, _ref2$shouldHandleSta = _ref2.shouldHandleStateChanges, shouldHandleStateChanges = _ref2$shouldHandleSta === void 0 ? true : _ref2$shouldHandleSta, _ref2$storeKey = _ref2.storeKey, storeKey = _ref2$storeKey === void 0 ? "store" : _ref2$storeKey, _ref2$withRef = _ref2.withRef, withRef = _ref2$withRef === void 0 ? false : _ref2$withRef, _ref2$forwardRef = _ref2.forwardRef, forwardRef = _ref2$forwardRef === void 0 ? false : _ref2$forwardRef, _ref2$context = _ref2.context, context = _ref2$context === void 0 ? (0, $WdDjx.ReactReduxContext) : _ref2$context, connectOptions = (0, $akilq.default)(_ref2, $54b96a09151e353d$var$_excluded);
    var customStoreWarningMessage;
    var Context = context;
    return function wrapWithConnect(WrappedComponent) {
        var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || "Component";
        var displayName = getDisplayName(wrappedComponentName);
        var selectorFactoryOptions = (0, $aO5a1.default)({}, connectOptions, {
            getDisplayName: getDisplayName,
            methodName: methodName,
            renderCountProp: renderCountProp,
            shouldHandleStateChanges: shouldHandleStateChanges,
            storeKey: storeKey,
            displayName: displayName,
            wrappedComponentName: wrappedComponentName,
            WrappedComponent: WrappedComponent
        });
        var pure = connectOptions.pure;
        function createChildSelector(store) {
            return selectorFactory(store.dispatch, selectorFactoryOptions);
        } // If we aren't running in "pure" mode, we don't want to memoize values.
        // To avoid conditionally calling hooks, we fall back to a tiny wrapper
        // that just executes the given callback immediately.
        var usePureOnlyMemo = pure ? (0, $eO7Kz.useMemo) : function(callback) {
            return callback();
        };
        function ConnectFunction(props) {
            var _useMemo = (0, $eO7Kz.useMemo)(function() {
                // Distinguish between actual "data" props that were passed to the wrapper component,
                // and values needed to control behavior (forwarded refs, alternate context instances).
                // To maintain the wrapperProps object reference, memoize this destructuring.
                var reactReduxForwardedRef = props.reactReduxForwardedRef, wrapperProps = (0, $akilq.default)(props, $54b96a09151e353d$var$_excluded2);
                return [
                    props.context,
                    reactReduxForwardedRef,
                    wrapperProps
                ];
            }, [
                props
            ]), propsContext = _useMemo[0], reactReduxForwardedRef = _useMemo[1], wrapperProps = _useMemo[2];
            var ContextToUse = (0, $eO7Kz.useMemo)(function() {
                // Users may optionally pass in a custom context instance to use instead of our ReactReduxContext.
                // Memoize the check that determines which context instance we should use.
                return propsContext && propsContext.Consumer && (0, $iM5D7.isContextConsumer)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eO7Kz))).createElement(propsContext.Consumer, null)) ? propsContext : Context;
            }, [
                propsContext,
                Context
            ]); // Retrieve the store and ancestor subscription via context, if available
            var contextValue = (0, $eO7Kz.useContext)(ContextToUse); // The store _must_ exist as either a prop or in context.
            // We'll check to see if it _looks_ like a Redux store first.
            // This allows us to pass through a `store` prop that is just a plain value.
            var didStoreComeFromProps = Boolean(props.store) && Boolean(props.store.getState) && Boolean(props.store.dispatch);
            var didStoreComeFromContext = Boolean(contextValue) && Boolean(contextValue.store);
            var store = didStoreComeFromProps ? props.store : contextValue.store;
            var childPropsSelector = (0, $eO7Kz.useMemo)(function() {
                // The child props selector needs the store reference as an input.
                // Re-create this selector whenever the store changes.
                return createChildSelector(store);
            }, [
                store
            ]);
            var _useMemo2 = (0, $eO7Kz.useMemo)(function() {
                if (!shouldHandleStateChanges) return $54b96a09151e353d$var$NO_SUBSCRIPTION_ARRAY; // This Subscription's source should match where store came from: props vs. context. A component
                // connected to the store via props shouldn't use subscription from context, or vice versa.
                // This Subscription's source should match where store came from: props vs. context. A component
                // connected to the store via props shouldn't use subscription from context, or vice versa.
                var subscription = (0, $635sM.createSubscription)(store, didStoreComeFromProps ? null : contextValue.subscription); // `notifyNestedSubs` is duplicated to handle the case where the component is unmounted in
                // the middle of the notification loop, where `subscription` will then be null. This can
                // probably be avoided if Subscription's listeners logic is changed to not call listeners
                // that have been unsubscribed in the  middle of the notification loop.
                // `notifyNestedSubs` is duplicated to handle the case where the component is unmounted in
                // the middle of the notification loop, where `subscription` will then be null. This can
                // probably be avoided if Subscription's listeners logic is changed to not call listeners
                // that have been unsubscribed in the  middle of the notification loop.
                var notifyNestedSubs = subscription.notifyNestedSubs.bind(subscription);
                return [
                    subscription,
                    notifyNestedSubs
                ];
            }, [
                store,
                didStoreComeFromProps,
                contextValue
            ]), subscription = _useMemo2[0], notifyNestedSubs = _useMemo2[1]; // Determine what {store, subscription} value should be put into nested context, if necessary,
            // and memoize that value to avoid unnecessary context updates.
            var overriddenContextValue = (0, $eO7Kz.useMemo)(function() {
                if (didStoreComeFromProps) // This component is directly subscribed to a store from props.
                // We don't want descendants reading from this store - pass down whatever
                // the existing context value is from the nearest connected ancestor.
                return contextValue;
                 // Otherwise, put this component's subscription instance into context, so that
                // connected descendants won't update until after this component is done
                return (0, $aO5a1.default)({}, contextValue, {
                    subscription: subscription
                });
            }, [
                didStoreComeFromProps,
                contextValue,
                subscription
            ]); // We need to force this wrapper component to re-render whenever a Redux store update
            // causes a change to the calculated child component props (or we caught an error in mapState)
            var _useReducer = (0, $eO7Kz.useReducer)($54b96a09151e353d$var$storeStateUpdatesReducer, $54b96a09151e353d$var$EMPTY_ARRAY, $54b96a09151e353d$var$initStateUpdates), _useReducer$ = _useReducer[0], previousStateUpdateResult = _useReducer$[0], forceComponentUpdateDispatch = _useReducer[1]; // Propagate any mapState/mapDispatch errors upwards
            if (previousStateUpdateResult && previousStateUpdateResult.error) throw previousStateUpdateResult.error;
             // Set up refs to coordinate values between the subscription effect and the render logic
            var lastChildProps = (0, $eO7Kz.useRef)();
            var lastWrapperProps = (0, $eO7Kz.useRef)(wrapperProps);
            var childPropsFromStoreUpdate = (0, $eO7Kz.useRef)();
            var renderIsScheduled = (0, $eO7Kz.useRef)(false);
            var actualChildProps = usePureOnlyMemo(function() {
                // Tricky logic here:
                // - This render may have been triggered by a Redux store update that produced new child props
                // - However, we may have gotten new wrapper props after that
                // If we have new child props, and the same wrapper props, we know we should use the new child props as-is.
                // But, if we have new wrapper props, those might change the child props, so we have to recalculate things.
                // So, we'll use the child props from store update only if the wrapper props are the same as last time.
                if (childPropsFromStoreUpdate.current && wrapperProps === lastWrapperProps.current) return childPropsFromStoreUpdate.current;
                 // TODO We're reading the store directly in render() here. Bad idea?
                // This will likely cause Bad Things (TM) to happen in Concurrent Mode.
                // Note that we do this because on renders _not_ caused by store updates, we need the latest store state
                // to determine what the child props should be.
                return childPropsSelector(store.getState(), wrapperProps);
            }, [
                store,
                previousStateUpdateResult,
                wrapperProps
            ]); // We need this to execute synchronously every time we re-render. However, React warns
            // about useLayoutEffect in SSR, so we try to detect environment and fall back to
            // just useEffect instead to avoid the warning, since neither will run anyway.
            $54b96a09151e353d$var$useIsomorphicLayoutEffectWithArgs($54b96a09151e353d$var$captureWrapperProps, [
                lastWrapperProps,
                lastChildProps,
                renderIsScheduled,
                wrapperProps,
                actualChildProps,
                childPropsFromStoreUpdate,
                notifyNestedSubs
            ]); // Our re-subscribe logic only runs when the store/subscription setup changes
            $54b96a09151e353d$var$useIsomorphicLayoutEffectWithArgs($54b96a09151e353d$var$subscribeUpdates, [
                shouldHandleStateChanges,
                store,
                subscription,
                childPropsSelector,
                lastWrapperProps,
                lastChildProps,
                renderIsScheduled,
                childPropsFromStoreUpdate,
                notifyNestedSubs,
                forceComponentUpdateDispatch
            ], [
                store,
                subscription,
                childPropsSelector
            ]); // Now that all that's done, we can finally try to actually render the child component.
            // We memoize the elements for the rendered child component as an optimization.
            var renderedWrappedComponent = (0, $eO7Kz.useMemo)(function() {
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eO7Kz))).createElement(WrappedComponent, (0, $aO5a1.default)({}, actualChildProps, {
                    ref: reactReduxForwardedRef
                }));
            }, [
                reactReduxForwardedRef,
                WrappedComponent,
                actualChildProps
            ]); // If React sees the exact same element reference as last time, it bails out of re-rendering
            // that child, same as if it was wrapped in React.memo() or returned false from shouldComponentUpdate.
            var renderedChild = (0, $eO7Kz.useMemo)(function() {
                if (shouldHandleStateChanges) // If this component is subscribed to store updates, we need to pass its own
                // subscription instance down to our descendants. That means rendering the same
                // Context instance, and putting a different value into the context.
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eO7Kz))).createElement(ContextToUse.Provider, {
                    value: overriddenContextValue
                }, renderedWrappedComponent);
                return renderedWrappedComponent;
            }, [
                ContextToUse,
                renderedWrappedComponent,
                overriddenContextValue
            ]);
            return renderedChild;
        } // If we're in "pure" mode, ensure our wrapper component only re-renders when incoming props have changed.
        var Connect = pure ? (0, (/*@__PURE__*/$parcel$interopDefault($eO7Kz))).memo(ConnectFunction) : ConnectFunction;
        Connect.WrappedComponent = WrappedComponent;
        Connect.displayName = ConnectFunction.displayName = displayName;
        if (forwardRef) {
            var forwarded = (0, (/*@__PURE__*/$parcel$interopDefault($eO7Kz))).forwardRef(function forwardConnectRef(props, ref) {
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eO7Kz))).createElement(Connect, (0, $aO5a1.default)({}, props, {
                    reactReduxForwardedRef: ref
                }));
            });
            forwarded.displayName = displayName;
            forwarded.WrappedComponent = WrappedComponent;
            return (0, (/*@__PURE__*/$parcel$interopDefault($hKDRv)))(forwarded, WrappedComponent);
        }
        return (0, (/*@__PURE__*/$parcel$interopDefault($hKDRv)))(Connect, WrappedComponent);
    };
}

});
parcelRequire.register("iM5D7", function(module, exports) {
"use strict";

module.exports = (parcelRequire("lLMwm"));

});
parcelRequire.register("lLMwm", function(module, exports) {

$parcel$export(module.exports, "ContextConsumer", () => $fd93a0011eeb0a6b$export$a7c73072b1a182ae, (v) => $fd93a0011eeb0a6b$export$a7c73072b1a182ae = v);
$parcel$export(module.exports, "ContextProvider", () => $fd93a0011eeb0a6b$export$9f27bc3417b4524d, (v) => $fd93a0011eeb0a6b$export$9f27bc3417b4524d = v);
$parcel$export(module.exports, "Element", () => $fd93a0011eeb0a6b$export$db77ccec0bb4ccac, (v) => $fd93a0011eeb0a6b$export$db77ccec0bb4ccac = v);
$parcel$export(module.exports, "ForwardRef", () => $fd93a0011eeb0a6b$export$8392c0c9d3dcbd35, (v) => $fd93a0011eeb0a6b$export$8392c0c9d3dcbd35 = v);
$parcel$export(module.exports, "Fragment", () => $fd93a0011eeb0a6b$export$ffb0004e005737fa, (v) => $fd93a0011eeb0a6b$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Lazy", () => $fd93a0011eeb0a6b$export$b624eff549462981, (v) => $fd93a0011eeb0a6b$export$b624eff549462981 = v);
$parcel$export(module.exports, "Memo", () => $fd93a0011eeb0a6b$export$7897aa7841a5380c, (v) => $fd93a0011eeb0a6b$export$7897aa7841a5380c = v);
$parcel$export(module.exports, "Portal", () => $fd93a0011eeb0a6b$export$602eac185826482c, (v) => $fd93a0011eeb0a6b$export$602eac185826482c = v);
$parcel$export(module.exports, "Profiler", () => $fd93a0011eeb0a6b$export$e2c29f18771995cb, (v) => $fd93a0011eeb0a6b$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "StrictMode", () => $fd93a0011eeb0a6b$export$5f8d39834fd61797, (v) => $fd93a0011eeb0a6b$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $fd93a0011eeb0a6b$export$74bf444e3cd11ea5, (v) => $fd93a0011eeb0a6b$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "isAsyncMode", () => $fd93a0011eeb0a6b$export$92387174baf9b227, (v) => $fd93a0011eeb0a6b$export$92387174baf9b227 = v);
$parcel$export(module.exports, "isConcurrentMode", () => $fd93a0011eeb0a6b$export$ec112efeb987d9c6, (v) => $fd93a0011eeb0a6b$export$ec112efeb987d9c6 = v);
$parcel$export(module.exports, "isContextConsumer", () => $fd93a0011eeb0a6b$export$b706b080d889d2c9, (v) => $fd93a0011eeb0a6b$export$b706b080d889d2c9 = v);
$parcel$export(module.exports, "isContextProvider", () => $fd93a0011eeb0a6b$export$5be5a87408f70ddc, (v) => $fd93a0011eeb0a6b$export$5be5a87408f70ddc = v);
$parcel$export(module.exports, "isElement", () => $fd93a0011eeb0a6b$export$45a5e7f76e0caa8d, (v) => $fd93a0011eeb0a6b$export$45a5e7f76e0caa8d = v);
$parcel$export(module.exports, "isForwardRef", () => $fd93a0011eeb0a6b$export$455c2e768291efa6, (v) => $fd93a0011eeb0a6b$export$455c2e768291efa6 = v);
$parcel$export(module.exports, "isFragment", () => $fd93a0011eeb0a6b$export$9522e17588c12572, (v) => $fd93a0011eeb0a6b$export$9522e17588c12572 = v);
$parcel$export(module.exports, "isLazy", () => $fd93a0011eeb0a6b$export$2110ac352bb060b9, (v) => $fd93a0011eeb0a6b$export$2110ac352bb060b9 = v);
$parcel$export(module.exports, "isMemo", () => $fd93a0011eeb0a6b$export$56885ab8b9c456ab, (v) => $fd93a0011eeb0a6b$export$56885ab8b9c456ab = v);
$parcel$export(module.exports, "isPortal", () => $fd93a0011eeb0a6b$export$d927fcb6adf8f9de, (v) => $fd93a0011eeb0a6b$export$d927fcb6adf8f9de = v);
$parcel$export(module.exports, "isProfiler", () => $fd93a0011eeb0a6b$export$b82d16f27459e05a, (v) => $fd93a0011eeb0a6b$export$b82d16f27459e05a = v);
$parcel$export(module.exports, "isStrictMode", () => $fd93a0011eeb0a6b$export$522c17b4f5e123e8, (v) => $fd93a0011eeb0a6b$export$522c17b4f5e123e8 = v);
$parcel$export(module.exports, "isSuspense", () => $fd93a0011eeb0a6b$export$1aabd8a0274ecfd6, (v) => $fd93a0011eeb0a6b$export$1aabd8a0274ecfd6 = v);
$parcel$export(module.exports, "isValidElementType", () => $fd93a0011eeb0a6b$export$9b621391a187a31a, (v) => $fd93a0011eeb0a6b$export$9b621391a187a31a = v);
$parcel$export(module.exports, "typeOf", () => $fd93a0011eeb0a6b$export$f5bbd400c2f4426f, (v) => $fd93a0011eeb0a6b$export$f5bbd400c2f4426f = v);
/** @license React v17.0.2
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $fd93a0011eeb0a6b$export$a7c73072b1a182ae;
var $fd93a0011eeb0a6b$export$9f27bc3417b4524d;
var $fd93a0011eeb0a6b$export$db77ccec0bb4ccac;
var $fd93a0011eeb0a6b$export$8392c0c9d3dcbd35;
var $fd93a0011eeb0a6b$export$ffb0004e005737fa;
var $fd93a0011eeb0a6b$export$b624eff549462981;
var $fd93a0011eeb0a6b$export$7897aa7841a5380c;
var $fd93a0011eeb0a6b$export$602eac185826482c;
var $fd93a0011eeb0a6b$export$e2c29f18771995cb;
var $fd93a0011eeb0a6b$export$5f8d39834fd61797;
var $fd93a0011eeb0a6b$export$74bf444e3cd11ea5;
var $fd93a0011eeb0a6b$export$92387174baf9b227;
var $fd93a0011eeb0a6b$export$ec112efeb987d9c6;
var $fd93a0011eeb0a6b$export$b706b080d889d2c9;
var $fd93a0011eeb0a6b$export$5be5a87408f70ddc;
var $fd93a0011eeb0a6b$export$45a5e7f76e0caa8d;
var $fd93a0011eeb0a6b$export$455c2e768291efa6;
var $fd93a0011eeb0a6b$export$9522e17588c12572;
var $fd93a0011eeb0a6b$export$2110ac352bb060b9;
var $fd93a0011eeb0a6b$export$56885ab8b9c456ab;
var $fd93a0011eeb0a6b$export$d927fcb6adf8f9de;
var $fd93a0011eeb0a6b$export$b82d16f27459e05a;
var $fd93a0011eeb0a6b$export$522c17b4f5e123e8;
var $fd93a0011eeb0a6b$export$1aabd8a0274ecfd6;
var $fd93a0011eeb0a6b$export$9b621391a187a31a;
var $fd93a0011eeb0a6b$export$f5bbd400c2f4426f;
"use strict";
var $fd93a0011eeb0a6b$var$b = 60103, $fd93a0011eeb0a6b$var$c = 60106, $fd93a0011eeb0a6b$var$d = 60107, $fd93a0011eeb0a6b$var$e = 60108, $fd93a0011eeb0a6b$var$f = 60114, $fd93a0011eeb0a6b$var$g = 60109, $fd93a0011eeb0a6b$var$h = 60110, $fd93a0011eeb0a6b$var$k = 60112, $fd93a0011eeb0a6b$var$l = 60113, $fd93a0011eeb0a6b$var$m = 60120, $fd93a0011eeb0a6b$var$n = 60115, $fd93a0011eeb0a6b$var$p = 60116, $fd93a0011eeb0a6b$var$q = 60121, $fd93a0011eeb0a6b$var$r = 60122, $fd93a0011eeb0a6b$var$u = 60117, $fd93a0011eeb0a6b$var$v = 60129, $fd93a0011eeb0a6b$var$w = 60131;
if ("function" === typeof Symbol && Symbol.for) {
    var $fd93a0011eeb0a6b$var$x = Symbol.for;
    $fd93a0011eeb0a6b$var$b = $fd93a0011eeb0a6b$var$x("react.element");
    $fd93a0011eeb0a6b$var$c = $fd93a0011eeb0a6b$var$x("react.portal");
    $fd93a0011eeb0a6b$var$d = $fd93a0011eeb0a6b$var$x("react.fragment");
    $fd93a0011eeb0a6b$var$e = $fd93a0011eeb0a6b$var$x("react.strict_mode");
    $fd93a0011eeb0a6b$var$f = $fd93a0011eeb0a6b$var$x("react.profiler");
    $fd93a0011eeb0a6b$var$g = $fd93a0011eeb0a6b$var$x("react.provider");
    $fd93a0011eeb0a6b$var$h = $fd93a0011eeb0a6b$var$x("react.context");
    $fd93a0011eeb0a6b$var$k = $fd93a0011eeb0a6b$var$x("react.forward_ref");
    $fd93a0011eeb0a6b$var$l = $fd93a0011eeb0a6b$var$x("react.suspense");
    $fd93a0011eeb0a6b$var$m = $fd93a0011eeb0a6b$var$x("react.suspense_list");
    $fd93a0011eeb0a6b$var$n = $fd93a0011eeb0a6b$var$x("react.memo");
    $fd93a0011eeb0a6b$var$p = $fd93a0011eeb0a6b$var$x("react.lazy");
    $fd93a0011eeb0a6b$var$q = $fd93a0011eeb0a6b$var$x("react.block");
    $fd93a0011eeb0a6b$var$r = $fd93a0011eeb0a6b$var$x("react.server.block");
    $fd93a0011eeb0a6b$var$u = $fd93a0011eeb0a6b$var$x("react.fundamental");
    $fd93a0011eeb0a6b$var$v = $fd93a0011eeb0a6b$var$x("react.debug_trace_mode");
    $fd93a0011eeb0a6b$var$w = $fd93a0011eeb0a6b$var$x("react.legacy_hidden");
}
function $fd93a0011eeb0a6b$var$y(a) {
    if ("object" === typeof a && null !== a) {
        var t = a.$$typeof;
        switch(t){
            case $fd93a0011eeb0a6b$var$b:
                switch(a = a.type, a){
                    case $fd93a0011eeb0a6b$var$d:
                    case $fd93a0011eeb0a6b$var$f:
                    case $fd93a0011eeb0a6b$var$e:
                    case $fd93a0011eeb0a6b$var$l:
                    case $fd93a0011eeb0a6b$var$m:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $fd93a0011eeb0a6b$var$h:
                            case $fd93a0011eeb0a6b$var$k:
                            case $fd93a0011eeb0a6b$var$p:
                            case $fd93a0011eeb0a6b$var$n:
                            case $fd93a0011eeb0a6b$var$g:
                                return a;
                            default:
                                return t;
                        }
                }
            case $fd93a0011eeb0a6b$var$c:
                return t;
        }
    }
}
var $fd93a0011eeb0a6b$var$z = $fd93a0011eeb0a6b$var$g, $fd93a0011eeb0a6b$var$A = $fd93a0011eeb0a6b$var$b, $fd93a0011eeb0a6b$var$B = $fd93a0011eeb0a6b$var$k, $fd93a0011eeb0a6b$var$C = $fd93a0011eeb0a6b$var$d, $fd93a0011eeb0a6b$var$D = $fd93a0011eeb0a6b$var$p, $fd93a0011eeb0a6b$var$E = $fd93a0011eeb0a6b$var$n, $fd93a0011eeb0a6b$var$F = $fd93a0011eeb0a6b$var$c, $fd93a0011eeb0a6b$var$G = $fd93a0011eeb0a6b$var$f, $fd93a0011eeb0a6b$var$H = $fd93a0011eeb0a6b$var$e, $fd93a0011eeb0a6b$var$I = $fd93a0011eeb0a6b$var$l;
$fd93a0011eeb0a6b$export$a7c73072b1a182ae = $fd93a0011eeb0a6b$var$h;
$fd93a0011eeb0a6b$export$9f27bc3417b4524d = $fd93a0011eeb0a6b$var$z;
$fd93a0011eeb0a6b$export$db77ccec0bb4ccac = $fd93a0011eeb0a6b$var$A;
$fd93a0011eeb0a6b$export$8392c0c9d3dcbd35 = $fd93a0011eeb0a6b$var$B;
$fd93a0011eeb0a6b$export$ffb0004e005737fa = $fd93a0011eeb0a6b$var$C;
$fd93a0011eeb0a6b$export$b624eff549462981 = $fd93a0011eeb0a6b$var$D;
$fd93a0011eeb0a6b$export$7897aa7841a5380c = $fd93a0011eeb0a6b$var$E;
$fd93a0011eeb0a6b$export$602eac185826482c = $fd93a0011eeb0a6b$var$F;
$fd93a0011eeb0a6b$export$e2c29f18771995cb = $fd93a0011eeb0a6b$var$G;
$fd93a0011eeb0a6b$export$5f8d39834fd61797 = $fd93a0011eeb0a6b$var$H;
$fd93a0011eeb0a6b$export$74bf444e3cd11ea5 = $fd93a0011eeb0a6b$var$I;
$fd93a0011eeb0a6b$export$92387174baf9b227 = function() {
    return !1;
};
$fd93a0011eeb0a6b$export$ec112efeb987d9c6 = function() {
    return !1;
};
$fd93a0011eeb0a6b$export$b706b080d889d2c9 = function(a) {
    return $fd93a0011eeb0a6b$var$y(a) === $fd93a0011eeb0a6b$var$h;
};
$fd93a0011eeb0a6b$export$5be5a87408f70ddc = function(a) {
    return $fd93a0011eeb0a6b$var$y(a) === $fd93a0011eeb0a6b$var$g;
};
$fd93a0011eeb0a6b$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $fd93a0011eeb0a6b$var$b;
};
$fd93a0011eeb0a6b$export$455c2e768291efa6 = function(a) {
    return $fd93a0011eeb0a6b$var$y(a) === $fd93a0011eeb0a6b$var$k;
};
$fd93a0011eeb0a6b$export$9522e17588c12572 = function(a) {
    return $fd93a0011eeb0a6b$var$y(a) === $fd93a0011eeb0a6b$var$d;
};
$fd93a0011eeb0a6b$export$2110ac352bb060b9 = function(a) {
    return $fd93a0011eeb0a6b$var$y(a) === $fd93a0011eeb0a6b$var$p;
};
$fd93a0011eeb0a6b$export$56885ab8b9c456ab = function(a) {
    return $fd93a0011eeb0a6b$var$y(a) === $fd93a0011eeb0a6b$var$n;
};
$fd93a0011eeb0a6b$export$d927fcb6adf8f9de = function(a) {
    return $fd93a0011eeb0a6b$var$y(a) === $fd93a0011eeb0a6b$var$c;
};
$fd93a0011eeb0a6b$export$b82d16f27459e05a = function(a) {
    return $fd93a0011eeb0a6b$var$y(a) === $fd93a0011eeb0a6b$var$f;
};
$fd93a0011eeb0a6b$export$522c17b4f5e123e8 = function(a) {
    return $fd93a0011eeb0a6b$var$y(a) === $fd93a0011eeb0a6b$var$e;
};
$fd93a0011eeb0a6b$export$1aabd8a0274ecfd6 = function(a) {
    return $fd93a0011eeb0a6b$var$y(a) === $fd93a0011eeb0a6b$var$l;
};
$fd93a0011eeb0a6b$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $fd93a0011eeb0a6b$var$d || a === $fd93a0011eeb0a6b$var$f || a === $fd93a0011eeb0a6b$var$v || a === $fd93a0011eeb0a6b$var$e || a === $fd93a0011eeb0a6b$var$l || a === $fd93a0011eeb0a6b$var$m || a === $fd93a0011eeb0a6b$var$w || "object" === typeof a && null !== a && (a.$$typeof === $fd93a0011eeb0a6b$var$p || a.$$typeof === $fd93a0011eeb0a6b$var$n || a.$$typeof === $fd93a0011eeb0a6b$var$g || a.$$typeof === $fd93a0011eeb0a6b$var$h || a.$$typeof === $fd93a0011eeb0a6b$var$k || a.$$typeof === $fd93a0011eeb0a6b$var$u || a.$$typeof === $fd93a0011eeb0a6b$var$q || a[0] === $fd93a0011eeb0a6b$var$r) ? !0 : !1;
};
$fd93a0011eeb0a6b$export$f5bbd400c2f4426f = $fd93a0011eeb0a6b$var$y;

});



parcelRequire.register("chg8Y", function(module, exports) {

$parcel$export(module.exports, "default", () => $8f039864da6b860e$export$2e2bcd8739ae039);

var $aO5a1 = parcelRequire("aO5a1");

var $akilq = parcelRequire("akilq");

var $7gZ5A = parcelRequire("7gZ5A");

var $cgBQi = parcelRequire("cgBQi");

var $dUctU = parcelRequire("dUctU");

var $kCzUW = parcelRequire("kCzUW");

var $kCJoi = parcelRequire("kCJoi");

var $652ci = parcelRequire("652ci");
var $8f039864da6b860e$var$_excluded = [
    "pure",
    "areStatesEqual",
    "areOwnPropsEqual",
    "areStatePropsEqual",
    "areMergedPropsEqual"
];
/*
  connect is a facade over connectAdvanced. It turns its args into a compatible
  selectorFactory, which has the signature:

    (dispatch, options) => (nextState, nextOwnProps) => nextFinalProps
  
  connect passes its args to connectAdvanced as options, which will in turn pass them to
  selectorFactory each time a Connect component instance is instantiated or hot reloaded.

  selectorFactory returns a final props selector from its mapStateToProps,
  mapStateToPropsFactories, mapDispatchToProps, mapDispatchToPropsFactories, mergeProps,
  mergePropsFactories, and pure args.

  The resulting final props selector is called by the Connect component instance whenever
  it receives new props or store state.
 */ function $8f039864da6b860e$var$match(arg, factories, name) {
    for(var i = factories.length - 1; i >= 0; i--){
        var result = factories[i](arg);
        if (result) return result;
    }
    return function(dispatch, options) {
        throw new Error("Invalid value of type " + typeof arg + " for " + name + " argument when connecting component " + options.wrappedComponentName + ".");
    };
}
function $8f039864da6b860e$var$strictEqual(a, b) {
    return a === b;
} // createConnect with default args builds the 'official' connect behavior. Calling it with
function $8f039864da6b860e$export$9f9feb656dec1fc4(_temp) {
    var _ref = _temp === void 0 ? {} : _temp, _ref$connectHOC = _ref.connectHOC, connectHOC = _ref$connectHOC === void 0 ? (0, $7gZ5A.default) : _ref$connectHOC, _ref$mapStateToPropsF = _ref.mapStateToPropsFactories, mapStateToPropsFactories = _ref$mapStateToPropsF === void 0 ? (0, $kCzUW.default) : _ref$mapStateToPropsF, _ref$mapDispatchToPro = _ref.mapDispatchToPropsFactories, mapDispatchToPropsFactories = _ref$mapDispatchToPro === void 0 ? (0, $dUctU.default) : _ref$mapDispatchToPro, _ref$mergePropsFactor = _ref.mergePropsFactories, mergePropsFactories = _ref$mergePropsFactor === void 0 ? (0, $kCJoi.default) : _ref$mergePropsFactor, _ref$selectorFactory = _ref.selectorFactory, selectorFactory = _ref$selectorFactory === void 0 ? (0, $652ci.default) : _ref$selectorFactory;
    return function connect(mapStateToProps, mapDispatchToProps, mergeProps, _ref2) {
        if (_ref2 === void 0) _ref2 = {};
        var _ref3 = _ref2, _ref3$pure = _ref3.pure, pure = _ref3$pure === void 0 ? true : _ref3$pure, _ref3$areStatesEqual = _ref3.areStatesEqual, areStatesEqual = _ref3$areStatesEqual === void 0 ? $8f039864da6b860e$var$strictEqual : _ref3$areStatesEqual, _ref3$areOwnPropsEqua = _ref3.areOwnPropsEqual, areOwnPropsEqual = _ref3$areOwnPropsEqua === void 0 ? (0, $cgBQi.default) : _ref3$areOwnPropsEqua, _ref3$areStatePropsEq = _ref3.areStatePropsEqual, areStatePropsEqual = _ref3$areStatePropsEq === void 0 ? (0, $cgBQi.default) : _ref3$areStatePropsEq, _ref3$areMergedPropsE = _ref3.areMergedPropsEqual, areMergedPropsEqual = _ref3$areMergedPropsE === void 0 ? (0, $cgBQi.default) : _ref3$areMergedPropsE, extraOptions = (0, $akilq.default)(_ref3, $8f039864da6b860e$var$_excluded);
        var initMapStateToProps = $8f039864da6b860e$var$match(mapStateToProps, mapStateToPropsFactories, "mapStateToProps");
        var initMapDispatchToProps = $8f039864da6b860e$var$match(mapDispatchToProps, mapDispatchToPropsFactories, "mapDispatchToProps");
        var initMergeProps = $8f039864da6b860e$var$match(mergeProps, mergePropsFactories, "mergeProps");
        return connectHOC(selectorFactory, (0, $aO5a1.default)({
            // used in error messages
            methodName: "connect",
            // used to compute Connect's displayName from the wrapped component's displayName.
            getDisplayName: function getDisplayName(name) {
                return "Connect(" + name + ")";
            },
            // if mapStateToProps is falsy, the Connect component doesn't subscribe to store state changes
            shouldHandleStateChanges: Boolean(mapStateToProps),
            // passed through to selectorFactory
            initMapStateToProps: initMapStateToProps,
            initMapDispatchToProps: initMapDispatchToProps,
            initMergeProps: initMergeProps,
            pure: pure,
            areStatesEqual: areStatesEqual,
            areOwnPropsEqual: areOwnPropsEqual,
            areStatePropsEqual: areStatePropsEqual,
            areMergedPropsEqual: areMergedPropsEqual
        }, extraOptions));
    };
}
var $8f039864da6b860e$export$2e2bcd8739ae039 = /*#__PURE__*/ $8f039864da6b860e$export$9f9feb656dec1fc4();

});
parcelRequire.register("cgBQi", function(module, exports) {

$parcel$export(module.exports, "default", () => $8ee45560dbc00353$export$2e2bcd8739ae039);
function $8ee45560dbc00353$var$is(x, y) {
    if (x === y) return x !== 0 || y !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
function $8ee45560dbc00353$export$2e2bcd8739ae039(objA, objB) {
    if ($8ee45560dbc00353$var$is(objA, objB)) return true;
    if (typeof objA !== "object" || objA === null || typeof objB !== "object" || objB === null) return false;
    var keysA = Object.keys(objA);
    var keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    for(var i = 0; i < keysA.length; i++){
        if (!Object.prototype.hasOwnProperty.call(objB, keysA[i]) || !$8ee45560dbc00353$var$is(objA[keysA[i]], objB[keysA[i]])) return false;
    }
    return true;
}

});

parcelRequire.register("dUctU", function(module, exports) {

$parcel$export(module.exports, "default", () => $a1fa2fe34d52c057$export$2e2bcd8739ae039);

var $jTuVQ = parcelRequire("jTuVQ");

var $93lOZ = parcelRequire("93lOZ");
function $a1fa2fe34d52c057$export$a9f27b4b187c1166(mapDispatchToProps) {
    return typeof mapDispatchToProps === "function" ? (0, $93lOZ.wrapMapToPropsFunc)(mapDispatchToProps, "mapDispatchToProps") : undefined;
}
function $a1fa2fe34d52c057$export$ba20d1a7aa0c4a90(mapDispatchToProps) {
    return !mapDispatchToProps ? (0, $93lOZ.wrapMapToPropsConstant)(function(dispatch) {
        return {
            dispatch: dispatch
        };
    }) : undefined;
}
function $a1fa2fe34d52c057$export$94a6e55709d4d961(mapDispatchToProps) {
    return mapDispatchToProps && typeof mapDispatchToProps === "object" ? (0, $93lOZ.wrapMapToPropsConstant)(function(dispatch) {
        return (0, $jTuVQ.default)(mapDispatchToProps, dispatch);
    }) : undefined;
}
var $a1fa2fe34d52c057$export$2e2bcd8739ae039 = [
    $a1fa2fe34d52c057$export$a9f27b4b187c1166,
    $a1fa2fe34d52c057$export$ba20d1a7aa0c4a90,
    $a1fa2fe34d52c057$export$94a6e55709d4d961
];

});
parcelRequire.register("jTuVQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $e7bb25ced60f5691$export$2e2bcd8739ae039);
function $e7bb25ced60f5691$export$2e2bcd8739ae039(actionCreators, dispatch) {
    var boundActionCreators = {};
    var _loop = function _loop(key) {
        var actionCreator = actionCreators[key];
        if (typeof actionCreator === "function") boundActionCreators[key] = function() {
            return dispatch(actionCreator.apply(void 0, arguments));
        };
    };
    for(var key in actionCreators)_loop(key);
    return boundActionCreators;
}

});

parcelRequire.register("93lOZ", function(module, exports) {

$parcel$export(module.exports, "wrapMapToPropsConstant", () => $697552265bb637e3$export$710f7c60f68acd3e);
$parcel$export(module.exports, "wrapMapToPropsFunc", () => $697552265bb637e3$export$8d46c7f53c8c602f);
parcelRequire("7Qlp6");
function $697552265bb637e3$export$710f7c60f68acd3e(getConstant) {
    return function initConstantSelector(dispatch, options) {
        var constant = getConstant(dispatch, options);
        function constantSelector() {
            return constant;
        }
        constantSelector.dependsOnOwnProps = false;
        return constantSelector;
    };
} // dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
function $697552265bb637e3$export$e561b938df936d57(mapToProps) {
    return mapToProps.dependsOnOwnProps !== null && mapToProps.dependsOnOwnProps !== undefined ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
} // Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
function $697552265bb637e3$export$8d46c7f53c8c602f(mapToProps, methodName) {
    return function initProxySelector(dispatch, _ref) {
        var displayName = _ref.displayName;
        var proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
            return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch);
        }; // allow detectFactoryAndVerify to get ownProps
        proxy.dependsOnOwnProps = true;
        proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
            proxy.mapToProps = mapToProps;
            proxy.dependsOnOwnProps = $697552265bb637e3$export$e561b938df936d57(mapToProps);
            var props = proxy(stateOrDispatch, ownProps);
            if (typeof props === "function") {
                proxy.mapToProps = props;
                proxy.dependsOnOwnProps = $697552265bb637e3$export$e561b938df936d57(props);
                props = proxy(stateOrDispatch, ownProps);
            }
            return props;
        };
        return proxy;
    };
}

});
parcelRequire.register("7Qlp6", function(module, exports) {

var $cgJhI = parcelRequire("cgJhI");

var $6hrWU = parcelRequire("6hrWU");
function $5b5dfe152c191e91$export$2e2bcd8739ae039(value, displayName, methodName) {
    if (!(0, $cgJhI.default)(value)) (0, $6hrWU.default)(methodName + "() in " + displayName + " must return a plain object. Instead received " + value + ".");
}

});
parcelRequire.register("cgJhI", function(module, exports) {

$parcel$export(module.exports, "default", () => $8eea1b45b9793db3$export$2e2bcd8739ae039);
/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */ function $8eea1b45b9793db3$export$2e2bcd8739ae039(obj) {
    if (typeof obj !== "object" || obj === null) return false;
    var proto = Object.getPrototypeOf(obj);
    if (proto === null) return true;
    var baseProto = proto;
    while(Object.getPrototypeOf(baseProto) !== null)baseProto = Object.getPrototypeOf(baseProto);
    return proto === baseProto;
}

});

parcelRequire.register("6hrWU", function(module, exports) {

$parcel$export(module.exports, "default", () => $492a02bfd2a81c56$export$2e2bcd8739ae039);
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */ function $492a02bfd2a81c56$export$2e2bcd8739ae039(message) {
    /* eslint-disable no-console */ if (typeof console !== "undefined" && typeof console.error === "function") console.error(message);
    /* eslint-enable no-console */ try {
        // This error was thrown as a convenience so that if you enable
        // "break on all exceptions" in your console,
        // it would pause the execution at this line.
        throw new Error(message);
    /* eslint-disable no-empty */ } catch (e) {}
/* eslint-enable no-empty */ }

});




parcelRequire.register("kCzUW", function(module, exports) {

$parcel$export(module.exports, "default", () => $f03337ba365f0a07$export$2e2bcd8739ae039);

var $93lOZ = parcelRequire("93lOZ");
function $f03337ba365f0a07$export$23fc470827b14aa(mapStateToProps) {
    return typeof mapStateToProps === "function" ? (0, $93lOZ.wrapMapToPropsFunc)(mapStateToProps, "mapStateToProps") : undefined;
}
function $f03337ba365f0a07$export$514bc8c1a53c1d66(mapStateToProps) {
    return !mapStateToProps ? (0, $93lOZ.wrapMapToPropsConstant)(function() {
        return {};
    }) : undefined;
}
var $f03337ba365f0a07$export$2e2bcd8739ae039 = [
    $f03337ba365f0a07$export$23fc470827b14aa,
    $f03337ba365f0a07$export$514bc8c1a53c1d66
];

});

parcelRequire.register("kCJoi", function(module, exports) {

$parcel$export(module.exports, "default", () => $f03a90f6537d9a34$export$2e2bcd8739ae039);

var $aO5a1 = parcelRequire("aO5a1");
parcelRequire("7Qlp6");
function $f03a90f6537d9a34$export$691c327fc30bc857(stateProps, dispatchProps, ownProps) {
    return (0, $aO5a1.default)({}, ownProps, stateProps, dispatchProps);
}
function $f03a90f6537d9a34$export$5b105939c84b5234(mergeProps) {
    return function initMergePropsProxy(dispatch, _ref) {
        var displayName = _ref.displayName, pure = _ref.pure, areMergedPropsEqual = _ref.areMergedPropsEqual;
        var hasRunOnce = false;
        var mergedProps;
        return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
            var nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);
            if (hasRunOnce) {
                if (!pure || !areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
            } else {
                hasRunOnce = true;
                mergedProps = nextMergedProps;
            }
            return mergedProps;
        };
    };
}
function $f03a90f6537d9a34$export$d61b680184bc3f00(mergeProps) {
    return typeof mergeProps === "function" ? $f03a90f6537d9a34$export$5b105939c84b5234(mergeProps) : undefined;
}
function $f03a90f6537d9a34$export$a13ba70ef50dda6d(mergeProps) {
    return !mergeProps ? function() {
        return $f03a90f6537d9a34$export$691c327fc30bc857;
    } : undefined;
}
var $f03a90f6537d9a34$export$2e2bcd8739ae039 = [
    $f03a90f6537d9a34$export$d61b680184bc3f00,
    $f03a90f6537d9a34$export$a13ba70ef50dda6d
];

});

parcelRequire.register("652ci", function(module, exports) {

$parcel$export(module.exports, "default", () => $46d4ea124fb632d8$export$2e2bcd8739ae039);

var $akilq = parcelRequire("akilq");
parcelRequire("6v3QP");
var $46d4ea124fb632d8$var$_excluded = [
    "initMapStateToProps",
    "initMapDispatchToProps",
    "initMergeProps"
];
function $46d4ea124fb632d8$export$68c2c73bda6aa4b0(mapStateToProps, mapDispatchToProps, mergeProps, dispatch) {
    return function impureFinalPropsSelector(state, ownProps) {
        return mergeProps(mapStateToProps(state, ownProps), mapDispatchToProps(dispatch, ownProps), ownProps);
    };
}
function $46d4ea124fb632d8$export$d20c0c2ca6eb2b6f(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, _ref) {
    var areStatesEqual = _ref.areStatesEqual, areOwnPropsEqual = _ref.areOwnPropsEqual, areStatePropsEqual = _ref.areStatePropsEqual;
    var hasRunAtLeastOnce = false;
    var state;
    var ownProps;
    var stateProps;
    var dispatchProps;
    var mergedProps;
    function handleFirstCall(firstState, firstOwnProps) {
        state = firstState;
        ownProps = firstOwnProps;
        stateProps = mapStateToProps(state, ownProps);
        dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        hasRunAtLeastOnce = true;
        return mergedProps;
    }
    function handleNewPropsAndNewState() {
        stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewProps() {
        if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewState() {
        var nextStateProps = mapStateToProps(state, ownProps);
        var statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
        stateProps = nextStateProps;
        if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleSubsequentCalls(nextState, nextOwnProps) {
        var propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
        var stateChanged = !areStatesEqual(nextState, state, nextOwnProps, ownProps);
        state = nextState;
        ownProps = nextOwnProps;
        if (propsChanged && stateChanged) return handleNewPropsAndNewState();
        if (propsChanged) return handleNewProps();
        if (stateChanged) return handleNewState();
        return mergedProps;
    }
    return function pureFinalPropsSelector(nextState, nextOwnProps) {
        return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
    };
} // TODO: Add more comments
function $46d4ea124fb632d8$export$2e2bcd8739ae039(dispatch, _ref2) {
    var initMapStateToProps = _ref2.initMapStateToProps, initMapDispatchToProps = _ref2.initMapDispatchToProps, initMergeProps = _ref2.initMergeProps, options = (0, $akilq.default)(_ref2, $46d4ea124fb632d8$var$_excluded);
    var mapStateToProps = initMapStateToProps(dispatch, options);
    var mapDispatchToProps = initMapDispatchToProps(dispatch, options);
    var mergeProps = initMergeProps(dispatch, options);
    var selectorFactory = options.pure ? $46d4ea124fb632d8$export$d20c0c2ca6eb2b6f : $46d4ea124fb632d8$export$68c2c73bda6aa4b0;
    return selectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}

});
parcelRequire.register("6v3QP", function(module, exports) {

var $6hrWU = parcelRequire("6hrWU");
function $4bb8a0189690e57f$var$verify(selector, methodName, displayName) {
    if (!selector) throw new Error("Unexpected value for " + methodName + " in " + displayName + ".");
    else if (methodName === "mapStateToProps" || methodName === "mapDispatchToProps") {
        if (!Object.prototype.hasOwnProperty.call(selector, "dependsOnOwnProps")) (0, $6hrWU.default)("The selector for " + methodName + " of " + displayName + " did not specify a value for dependsOnOwnProps.");
    }
}
function $4bb8a0189690e57f$export$2e2bcd8739ae039(mapStateToProps, mapDispatchToProps, mergeProps, displayName) {
    $4bb8a0189690e57f$var$verify(mapStateToProps, "mapStateToProps", displayName);
    $4bb8a0189690e57f$var$verify(mapDispatchToProps, "mapDispatchToProps", displayName);
    $4bb8a0189690e57f$var$verify(mergeProps, "mergeProps", displayName);
}

});



parcelRequire.register("ea1kj", function(module, exports) {

var $WdDjx = parcelRequire("WdDjx");

var $eQjAp = parcelRequire("eQjAp");
function $a4f3074a1b17d5cd$export$bc9b55530897c558(context) {
    if (context === void 0) context = (0, $WdDjx.ReactReduxContext);
    var useStore = context === (0, $WdDjx.ReactReduxContext) ? (0, $eQjAp.useStore) : (0, $eQjAp.createStoreHook)(context);
    return function useDispatch() {
        var store = useStore();
        return store.dispatch;
    };
}
var $a4f3074a1b17d5cd$export$8ad76b76a4c905f8 = /*#__PURE__*/ $a4f3074a1b17d5cd$export$bc9b55530897c558();

});
parcelRequire.register("eQjAp", function(module, exports) {

$parcel$export(module.exports, "createStoreHook", () => $ace51d747c820792$export$671dba69185d0304);
$parcel$export(module.exports, "useStore", () => $ace51d747c820792$export$6ccbb43953eebf8);

var $eO7Kz = parcelRequire("eO7Kz");

var $WdDjx = parcelRequire("WdDjx");

var $fTNMk = parcelRequire("fTNMk");
function $ace51d747c820792$export$671dba69185d0304(context) {
    if (context === void 0) context = (0, $WdDjx.ReactReduxContext);
    var useReduxContext = context === (0, $WdDjx.ReactReduxContext) ? (0, $fTNMk.useReduxContext) : function() {
        return (0, $eO7Kz.useContext)(context);
    };
    return function useStore() {
        var _useReduxContext = useReduxContext(), store = _useReduxContext.store;
        return store;
    };
}
var $ace51d747c820792$export$6ccbb43953eebf8 = /*#__PURE__*/ $ace51d747c820792$export$671dba69185d0304();

});
parcelRequire.register("fTNMk", function(module, exports) {

$parcel$export(module.exports, "useReduxContext", () => $b9329b07cdfc735e$export$c1275ca9a6fd3ec5);

var $eO7Kz = parcelRequire("eO7Kz");

var $WdDjx = parcelRequire("WdDjx");
function $b9329b07cdfc735e$export$c1275ca9a6fd3ec5() {
    var contextValue = (0, $eO7Kz.useContext)((0, $WdDjx.ReactReduxContext));
    return contextValue;
}

});



parcelRequire.register("8KO5F", function(module, exports) {

var $eO7Kz = parcelRequire("eO7Kz");

var $fTNMk = parcelRequire("fTNMk");

var $635sM = parcelRequire("635sM");

var $hWudq = parcelRequire("hWudq");

var $WdDjx = parcelRequire("WdDjx");
var $65f979817caa24fa$var$refEquality = function refEquality(a, b) {
    return a === b;
};
function $65f979817caa24fa$var$useSelectorWithStoreAndSubscription(selector, equalityFn, store, contextSub) {
    var _useReducer = (0, $eO7Kz.useReducer)(function(s) {
        return s + 1;
    }, 0), forceRender = _useReducer[1];
    var subscription = (0, $eO7Kz.useMemo)(function() {
        return (0, $635sM.createSubscription)(store, contextSub);
    }, [
        store,
        contextSub
    ]);
    var latestSubscriptionCallbackError = (0, $eO7Kz.useRef)();
    var latestSelector = (0, $eO7Kz.useRef)();
    var latestStoreState = (0, $eO7Kz.useRef)();
    var latestSelectedState = (0, $eO7Kz.useRef)();
    var storeState = store.getState();
    var selectedState;
    try {
        if (selector !== latestSelector.current || storeState !== latestStoreState.current || latestSubscriptionCallbackError.current) {
            var newSelectedState = selector(storeState); // ensure latest selected state is reused so that a custom equality function can result in identical references
            if (latestSelectedState.current === undefined || !equalityFn(newSelectedState, latestSelectedState.current)) selectedState = newSelectedState;
            else selectedState = latestSelectedState.current;
        } else selectedState = latestSelectedState.current;
    } catch (err) {
        if (latestSubscriptionCallbackError.current) err.message += "\nThe error may be correlated with this previous error:\n" + latestSubscriptionCallbackError.current.stack + "\n\n";
        throw err;
    }
    (0, $hWudq.useIsomorphicLayoutEffect)(function() {
        latestSelector.current = selector;
        latestStoreState.current = storeState;
        latestSelectedState.current = selectedState;
        latestSubscriptionCallbackError.current = undefined;
    });
    (0, $hWudq.useIsomorphicLayoutEffect)(function() {
        function checkForUpdates() {
            try {
                var newStoreState = store.getState(); // Avoid calling selector multiple times if the store's state has not changed
                if (newStoreState === latestStoreState.current) return;
                var _newSelectedState = latestSelector.current(newStoreState);
                if (equalityFn(_newSelectedState, latestSelectedState.current)) return;
                latestSelectedState.current = _newSelectedState;
                latestStoreState.current = newStoreState;
            } catch (err) {
                // we ignore all errors here, since when the component
                // is re-rendered, the selectors are called again, and
                // will throw again, if neither props nor store state
                // changed
                latestSubscriptionCallbackError.current = err;
            }
            forceRender();
        }
        subscription.onStateChange = checkForUpdates;
        subscription.trySubscribe();
        checkForUpdates();
        return function() {
            return subscription.tryUnsubscribe();
        };
    }, [
        store,
        subscription
    ]);
    return selectedState;
}
function $65f979817caa24fa$export$2b53f90d2bd1cbfb(context) {
    if (context === void 0) context = (0, $WdDjx.ReactReduxContext);
    var useReduxContext = context === (0, $WdDjx.ReactReduxContext) ? (0, $fTNMk.useReduxContext) : function() {
        return (0, $eO7Kz.useContext)(context);
    };
    return function useSelector(selector, equalityFn) {
        if (equalityFn === void 0) equalityFn = $65f979817caa24fa$var$refEquality;
        var _useReduxContext = useReduxContext(), store = _useReduxContext.store, contextSub = _useReduxContext.subscription;
        var selectedState = $65f979817caa24fa$var$useSelectorWithStoreAndSubscription(selector, equalityFn, store, contextSub);
        (0, $eO7Kz.useDebugValue)(selectedState);
        return selectedState;
    };
}
var $65f979817caa24fa$export$2105062e25df4afe = /*#__PURE__*/ $65f979817caa24fa$export$2b53f90d2bd1cbfb();

});


parcelRequire.register("boKHW", function(module, exports) {

$parcel$export(module.exports, "unstable_batchedUpdates", () => (parcelRequire("kz03S")).unstable_batchedUpdates);
/* eslint-disable import/no-unresolved */ 
var $kz03S = parcelRequire("kz03S");

});




parcelRequire.register("dtULG", function(module, exports) {
"use strict";
function $9d0a04c6e9af3523$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $9d0a04c6e9af3523$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $9d0a04c6e9af3523$var$_typeof(obj);
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = module.exports.connectMicrophoneButton = void 0;
module.exports.useMicrophoneButtonClick = $9d0a04c6e9af3523$var$useMicrophoneButtonClick;
module.exports.useMicrophoneButtonDisabled = $9d0a04c6e9af3523$var$useMicrophoneButtonDisabled;

var $cG9B9 = parcelRequire("cG9B9");

var $hd4g0 = parcelRequire("hd4g0");

var $9d0a04c6e9af3523$var$_classnames = $9d0a04c6e9af3523$var$_interopRequireDefault((parcelRequire("5A4MD")));

var $9d0a04c6e9af3523$var$_memoizeOne = $9d0a04c6e9af3523$var$_interopRequireDefault((parcelRequire("9gRzx")));

var $9d0a04c6e9af3523$var$_propTypes = $9d0a04c6e9af3523$var$_interopRequireDefault((parcelRequire("f7UXb")));

var $9d0a04c6e9af3523$var$_react = $9d0a04c6e9af3523$var$_interopRequireWildcard((parcelRequire("eO7Kz")));

var $9d0a04c6e9af3523$var$_connectToWebChat = $9d0a04c6e9af3523$var$_interopRequireDefault((parcelRequire("86vmQ")));

var $9d0a04c6e9af3523$var$_IconButton = $9d0a04c6e9af3523$var$_interopRequireDefault((parcelRequire("eA5Zo")));

var $9d0a04c6e9af3523$var$_MicrophoneIcon = $9d0a04c6e9af3523$var$_interopRequireDefault((parcelRequire("a8tV9")));

var $9d0a04c6e9af3523$var$_useDictateAbortable3 = $9d0a04c6e9af3523$var$_interopRequireDefault((parcelRequire("erCqX")));

var $9d0a04c6e9af3523$var$_useStyleSet3 = $9d0a04c6e9af3523$var$_interopRequireDefault((parcelRequire("gC6jZ")));

var $9d0a04c6e9af3523$var$_useStyleToEmotionObject = $9d0a04c6e9af3523$var$_interopRequireDefault((parcelRequire("6l4uV")));

var $9d0a04c6e9af3523$var$_useWebSpeechPonyfill3 = $9d0a04c6e9af3523$var$_interopRequireDefault((parcelRequire("dCR9j")));
function $9d0a04c6e9af3523$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($9d0a04c6e9af3523$var$_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $9d0a04c6e9af3523$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || $9d0a04c6e9af3523$var$_typeof(obj) !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $9d0a04c6e9af3523$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $9d0a04c6e9af3523$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $9d0a04c6e9af3523$var$_slicedToArray(arr, i) {
    return $9d0a04c6e9af3523$var$_arrayWithHoles(arr) || $9d0a04c6e9af3523$var$_iterableToArrayLimit(arr, i) || $9d0a04c6e9af3523$var$_unsupportedIterableToArray(arr, i) || $9d0a04c6e9af3523$var$_nonIterableRest();
}
function $9d0a04c6e9af3523$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $9d0a04c6e9af3523$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $9d0a04c6e9af3523$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $9d0a04c6e9af3523$var$_arrayLikeToArray(o, minLen);
}
function $9d0a04c6e9af3523$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $9d0a04c6e9af3523$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $9d0a04c6e9af3523$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
var $9d0a04c6e9af3523$var$DictateState = $cG9B9.Constants.DictateState;
var $9d0a04c6e9af3523$var$useDictateInterims = $hd4g0.hooks.useDictateInterims, $9d0a04c6e9af3523$var$useDictateState = $hd4g0.hooks.useDictateState, $9d0a04c6e9af3523$var$useDisabled = $hd4g0.hooks.useDisabled, $9d0a04c6e9af3523$var$useLocalizer = $hd4g0.hooks.useLocalizer, $9d0a04c6e9af3523$var$useSendBoxValue = $hd4g0.hooks.useSendBoxValue, $9d0a04c6e9af3523$var$useShouldSpeakIncomingActivity = $hd4g0.hooks.useShouldSpeakIncomingActivity, $9d0a04c6e9af3523$var$useStartDictate = $hd4g0.hooks.useStartDictate, $9d0a04c6e9af3523$var$useStopDictate = $hd4g0.hooks.useStopDictate;
var $9d0a04c6e9af3523$var$ROOT_STYLE = {
    display: "flex",
    // .sr-only - This component is intended to be invisible to the visual Web Chat user, but read by the AT when using a screen reader
    "& > .sr-only": {
        color: "transparent",
        height: 1,
        left: -10000,
        overflow: "hidden",
        position: "absolute",
        top: 0,
        whiteSpace: "nowrap",
        width: 1
    }
};
var $9d0a04c6e9af3523$var$connectMicrophoneButton = function connectMicrophoneButton() {
    var primeSpeechSynthesis = (0, $9d0a04c6e9af3523$var$_memoizeOne.default)(function(speechSynthesis, SpeechSynthesisUtterance) {
        if (speechSynthesis && SpeechSynthesisUtterance) {
            var utterance = new SpeechSynthesisUtterance("");
            var _speechSynthesis$getV = speechSynthesis.getVoices();
            var _speechSynthesis$getV2 = $9d0a04c6e9af3523$var$_slicedToArray(_speechSynthesis$getV, 1);
            utterance.voice = _speechSynthesis$getV2[0];
            speechSynthesis.speak(utterance);
        }
    });
    for(var _len = arguments.length, selectors = new Array(_len), _key = 0; _key < _len; _key++)selectors[_key] = arguments[_key];
    return $9d0a04c6e9af3523$var$_connectToWebChat.default.apply(void 0, [
        function(_ref) {
            var disabled = _ref.disabled, dictateInterims = _ref.dictateInterims, dictateState = _ref.dictateState, language = _ref.language, setSendBox = _ref.setSendBox, startDictate = _ref.startDictate, stopDictate = _ref.stopDictate, stopSpeakingActivity = _ref.stopSpeakingActivity, webSpeechPonyfill = _ref.webSpeechPonyfill;
            var _ref2 = webSpeechPonyfill || {}, speechSynthesis = _ref2.speechSynthesis, SpeechSynthesisUtterance = _ref2.SpeechSynthesisUtterance;
            return {
                click: function click() {
                    if (dictateState === $9d0a04c6e9af3523$var$DictateState.WILL_START) stopSpeakingActivity();
                    else if (dictateState === $9d0a04c6e9af3523$var$DictateState.DICTATING) {
                        stopDictate();
                        setSendBox(dictateInterims.join(" "));
                    } else {
                        stopSpeakingActivity();
                        startDictate();
                    }
                    primeSpeechSynthesis(speechSynthesis, SpeechSynthesisUtterance);
                },
                dictating: dictateState === $9d0a04c6e9af3523$var$DictateState.DICTATING,
                disabled: disabled || dictateState === $9d0a04c6e9af3523$var$DictateState.STARTING && dictateState === $9d0a04c6e9af3523$var$DictateState.STOPPING,
                language: language
            };
        }
    ].concat(selectors));
};
module.exports.connectMicrophoneButton = $9d0a04c6e9af3523$var$connectMicrophoneButton;
function $9d0a04c6e9af3523$var$useMicrophoneButtonClick() {
    var _useSendBoxValue = $9d0a04c6e9af3523$var$useSendBoxValue(), _useSendBoxValue2 = $9d0a04c6e9af3523$var$_slicedToArray(_useSendBoxValue, 2), setSendBox = _useSendBoxValue2[1];
    var _useShouldSpeakIncomi = $9d0a04c6e9af3523$var$useShouldSpeakIncomingActivity(), _useShouldSpeakIncomi2 = $9d0a04c6e9af3523$var$_slicedToArray(_useShouldSpeakIncomi, 2), setShouldSpeakIncomingActivity = _useShouldSpeakIncomi2[1];
    var _useDictateInterims = $9d0a04c6e9af3523$var$useDictateInterims(), _useDictateInterims2 = $9d0a04c6e9af3523$var$_slicedToArray(_useDictateInterims, 1), dictateInterims = _useDictateInterims2[0];
    var _useDictateState = $9d0a04c6e9af3523$var$useDictateState(), _useDictateState2 = $9d0a04c6e9af3523$var$_slicedToArray(_useDictateState, 1), dictateState = _useDictateState2[0];
    var _useWebSpeechPonyfill = (0, $9d0a04c6e9af3523$var$_useWebSpeechPonyfill3.default)(), _useWebSpeechPonyfill2 = $9d0a04c6e9af3523$var$_slicedToArray(_useWebSpeechPonyfill, 1), webSpeechPonyfill = _useWebSpeechPonyfill2[0];
    var startDictate = $9d0a04c6e9af3523$var$useStartDictate();
    var stopDictate = $9d0a04c6e9af3523$var$useStopDictate();
    var _ref3 = webSpeechPonyfill || {}, speechSynthesis = _ref3.speechSynthesis, SpeechSynthesisUtterance = _ref3.SpeechSynthesisUtterance;
    var _useState = (0, $9d0a04c6e9af3523$var$_react.useState)(function() {
        return (0, $9d0a04c6e9af3523$var$_memoizeOne.default)(function(speechSynthesis, SpeechSynthesisUtterance) {
            if (speechSynthesis && SpeechSynthesisUtterance) {
                var utterance = new SpeechSynthesisUtterance("");
                var _speechSynthesis$getV3 = speechSynthesis.getVoices();
                var _speechSynthesis$getV4 = $9d0a04c6e9af3523$var$_slicedToArray(_speechSynthesis$getV3, 1);
                utterance.voice = _speechSynthesis$getV4[0];
                speechSynthesis.speak(utterance);
            }
        });
    }), _useState2 = $9d0a04c6e9af3523$var$_slicedToArray(_useState, 1), primeSpeechSynthesis = _useState2[0]; // TODO: [P2] We should revisit this function later
    //       The click() logic seems local to the component, but may not be generalized across all implementations.
    return (0, $9d0a04c6e9af3523$var$_react.useCallback)(function() {
        if (dictateState === $9d0a04c6e9af3523$var$DictateState.WILL_START) setShouldSpeakIncomingActivity(false);
        else if (dictateState === $9d0a04c6e9af3523$var$DictateState.DICTATING) {
            stopDictate();
            setSendBox(dictateInterims.join(" "));
        } else {
            setShouldSpeakIncomingActivity(false);
            startDictate();
        }
        primeSpeechSynthesis(speechSynthesis, SpeechSynthesisUtterance);
    }, [
        dictateInterims,
        dictateState,
        primeSpeechSynthesis,
        setSendBox,
        setShouldSpeakIncomingActivity,
        speechSynthesis,
        SpeechSynthesisUtterance,
        startDictate,
        stopDictate
    ]);
}
function $9d0a04c6e9af3523$var$useMicrophoneButtonDisabled() {
    var _useDictateAbortable = (0, $9d0a04c6e9af3523$var$_useDictateAbortable3.default)(), _useDictateAbortable2 = $9d0a04c6e9af3523$var$_slicedToArray(_useDictateAbortable, 1), abortable = _useDictateAbortable2[0];
    var _useDictateState3 = $9d0a04c6e9af3523$var$useDictateState(), _useDictateState4 = $9d0a04c6e9af3523$var$_slicedToArray(_useDictateState3, 1), dictateState = _useDictateState4[0];
    var _useDisabled = $9d0a04c6e9af3523$var$useDisabled(), _useDisabled2 = $9d0a04c6e9af3523$var$_slicedToArray(_useDisabled, 1), disabled = _useDisabled2[0];
    return [
        disabled || dictateState === $9d0a04c6e9af3523$var$DictateState.STARTING || dictateState === $9d0a04c6e9af3523$var$DictateState.STOPPING || dictateState === $9d0a04c6e9af3523$var$DictateState.DICTATING && !abortable
    ];
}
var $9d0a04c6e9af3523$var$MicrophoneButton = function MicrophoneButton(_ref4) {
    var className = _ref4.className;
    var _useStyleSet = (0, $9d0a04c6e9af3523$var$_useStyleSet3.default)(), _useStyleSet2 = $9d0a04c6e9af3523$var$_slicedToArray(_useStyleSet, 1), microphoneButtonStyleSet = _useStyleSet2[0].microphoneButton;
    var _useDictateState5 = $9d0a04c6e9af3523$var$useDictateState(), _useDictateState6 = $9d0a04c6e9af3523$var$_slicedToArray(_useDictateState5, 1), dictateState = _useDictateState6[0];
    var _useMicrophoneButtonD = $9d0a04c6e9af3523$var$useMicrophoneButtonDisabled(), _useMicrophoneButtonD2 = $9d0a04c6e9af3523$var$_slicedToArray(_useMicrophoneButtonD, 1), disabled = _useMicrophoneButtonD2[0];
    var click = $9d0a04c6e9af3523$var$useMicrophoneButtonClick();
    var localize = $9d0a04c6e9af3523$var$useLocalizer();
    var rootClassName = (0, $9d0a04c6e9af3523$var$_useStyleToEmotionObject.default)()($9d0a04c6e9af3523$var$ROOT_STYLE) + "";
    var dictating = dictateState === $9d0a04c6e9af3523$var$DictateState.DICTATING;
    return /*#__PURE__*/ $9d0a04c6e9af3523$var$_react.default.createElement("div", {
        "aria-controls": "webchatSendBoxMicrophoneButton",
        className: (0, $9d0a04c6e9af3523$var$_classnames.default)("webchat__microphone-button", {
            "webchat__microphone-button--dictating": dictating
        }, microphoneButtonStyleSet + "", rootClassName, (className || "") + "")
    }, /*#__PURE__*/ $9d0a04c6e9af3523$var$_react.default.createElement($9d0a04c6e9af3523$var$_IconButton.default, {
        alt: localize("TEXT_INPUT_SPEAK_BUTTON_ALT"),
        className: "webchat__microphone-button__button",
        disabled: disabled,
        onClick: click
    }, /*#__PURE__*/ $9d0a04c6e9af3523$var$_react.default.createElement($9d0a04c6e9af3523$var$_MicrophoneIcon.default, {
        className: "webchat__microphone-button__icon"
    })), /*#__PURE__*/ $9d0a04c6e9af3523$var$_react.default.createElement("div", {
        "aria-live": "polite",
        className: "sr-only",
        id: "webchatSendBoxMicrophoneButton",
        role: "status"
    }, localize(dictating ? "SPEECH_INPUT_MICROPHONE_BUTTON_OPEN_ALT" : "SPEECH_INPUT_MICROPHONE_BUTTON_CLOSE_ALT")));
};
$9d0a04c6e9af3523$var$MicrophoneButton.defaultProps = {
    className: ""
};
$9d0a04c6e9af3523$var$MicrophoneButton.propTypes = {
    className: $9d0a04c6e9af3523$var$_propTypes.default.string
};
var $9d0a04c6e9af3523$var$_default = $9d0a04c6e9af3523$var$MicrophoneButton;
module.exports.default = $9d0a04c6e9af3523$var$_default;

});
parcelRequire.register("9gRzx", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $6bff2a069f41e1f0$export$2e2bcd8739ae039);
var $6bff2a069f41e1f0$var$safeIsNaN = Number.isNaN || function ponyfill(value) {
    return typeof value === "number" && value !== value;
};
function $6bff2a069f41e1f0$var$isEqual(first, second) {
    if (first === second) return true;
    if ($6bff2a069f41e1f0$var$safeIsNaN(first) && $6bff2a069f41e1f0$var$safeIsNaN(second)) return true;
    return false;
}
function $6bff2a069f41e1f0$var$areInputsEqual(newInputs, lastInputs) {
    if (newInputs.length !== lastInputs.length) return false;
    for(var i = 0; i < newInputs.length; i++){
        if (!$6bff2a069f41e1f0$var$isEqual(newInputs[i], lastInputs[i])) return false;
    }
    return true;
}
function $6bff2a069f41e1f0$export$2e2bcd8739ae039(resultFn, isEqual) {
    if (isEqual === void 0) isEqual = $6bff2a069f41e1f0$var$areInputsEqual;
    var cache = null;
    function memoized() {
        var newArgs = [];
        for(var _i = 0; _i < arguments.length; _i++)newArgs[_i] = arguments[_i];
        if (cache && cache.lastThis === this && isEqual(newArgs, cache.lastArgs)) return cache.lastResult;
        var lastResult = resultFn.apply(this, newArgs);
        cache = {
            lastResult: lastResult,
            lastArgs: newArgs,
            lastThis: this
        };
        return lastResult;
    }
    memoized.clear = function clear() {
        cache = null;
    };
    return memoized;
}

});

parcelRequire.register("eA5Zo", function(module, exports) {
"use strict";
function $a9d912cac7a21d69$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $a9d912cac7a21d69$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $a9d912cac7a21d69$var$_typeof(obj);
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $hd4g0 = parcelRequire("hd4g0");

var $a9d912cac7a21d69$var$_classnames = $a9d912cac7a21d69$var$_interopRequireDefault((parcelRequire("5A4MD")));

var $a9d912cac7a21d69$var$_propTypes = $a9d912cac7a21d69$var$_interopRequireDefault((parcelRequire("f7UXb")));

var $a9d912cac7a21d69$var$_react = $a9d912cac7a21d69$var$_interopRequireWildcard((parcelRequire("eO7Kz")));

var $a9d912cac7a21d69$var$_AccessibleButton = $a9d912cac7a21d69$var$_interopRequireDefault((parcelRequire("i4zc7")));

var $a9d912cac7a21d69$var$_useFocusVisible3 = $a9d912cac7a21d69$var$_interopRequireDefault((parcelRequire("cp2aW")));

var $a9d912cac7a21d69$var$_useStyleSet3 = $a9d912cac7a21d69$var$_interopRequireDefault((parcelRequire("gC6jZ")));
function $a9d912cac7a21d69$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($a9d912cac7a21d69$var$_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $a9d912cac7a21d69$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || $a9d912cac7a21d69$var$_typeof(obj) !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $a9d912cac7a21d69$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $a9d912cac7a21d69$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $a9d912cac7a21d69$var$_slicedToArray(arr, i) {
    return $a9d912cac7a21d69$var$_arrayWithHoles(arr) || $a9d912cac7a21d69$var$_iterableToArrayLimit(arr, i) || $a9d912cac7a21d69$var$_unsupportedIterableToArray(arr, i) || $a9d912cac7a21d69$var$_nonIterableRest();
}
function $a9d912cac7a21d69$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $a9d912cac7a21d69$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $a9d912cac7a21d69$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $a9d912cac7a21d69$var$_arrayLikeToArray(o, minLen);
}
function $a9d912cac7a21d69$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $a9d912cac7a21d69$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $a9d912cac7a21d69$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
var $a9d912cac7a21d69$var$useStyleOptions = $hd4g0.hooks.useStyleOptions;
var $a9d912cac7a21d69$var$IconButton = function IconButton(_ref) {
    var alt = _ref.alt, children = _ref.children, className = _ref.className, disabled = _ref.disabled, onClick = _ref.onClick;
    var _useStyleSet = (0, $a9d912cac7a21d69$var$_useStyleSet3.default)(), _useStyleSet2 = $a9d912cac7a21d69$var$_slicedToArray(_useStyleSet, 1), sendBoxButtonStyleSet = _useStyleSet2[0].sendBoxButton;
    var _useStyleOptions = $a9d912cac7a21d69$var$useStyleOptions(), _useStyleOptions2 = $a9d912cac7a21d69$var$_slicedToArray(_useStyleOptions, 1), sendBoxButtonAlignment = _useStyleOptions2[0].sendBoxButtonAlignment;
    var buttonRef = (0, $a9d912cac7a21d69$var$_react.useRef)();
    var _useFocusVisible = (0, $a9d912cac7a21d69$var$_useFocusVisible3.default)(buttonRef), _useFocusVisible2 = $a9d912cac7a21d69$var$_slicedToArray(_useFocusVisible, 1), focusVisible = _useFocusVisible2[0];
    return /*#__PURE__*/ $a9d912cac7a21d69$var$_react.default.createElement($a9d912cac7a21d69$var$_AccessibleButton.default, {
        className: (0, $a9d912cac7a21d69$var$_classnames.default)(sendBoxButtonStyleSet + "", "webchat__icon-button", {
            "webchat__icon-button--focus-visible": focusVisible,
            "webchat__icon-button--stretch": sendBoxButtonAlignment !== "bottom" && sendBoxButtonAlignment !== "top"
        }, className + ""),
        disabled: disabled,
        onClick: disabled ? undefined : onClick,
        ref: buttonRef,
        title: alt,
        type: "button"
    }, /*#__PURE__*/ $a9d912cac7a21d69$var$_react.default.createElement("div", {
        className: "webchat__icon-button__shade"
    }), children, /*#__PURE__*/ $a9d912cac7a21d69$var$_react.default.createElement("div", {
        className: "webchat__icon-button__keyboard-focus-indicator"
    }));
};
$a9d912cac7a21d69$var$IconButton.defaultProps = {
    alt: "",
    children: undefined,
    className: "",
    disabled: false,
    onClick: undefined
};
$a9d912cac7a21d69$var$IconButton.propTypes = {
    alt: $a9d912cac7a21d69$var$_propTypes.default.string,
    children: $a9d912cac7a21d69$var$_propTypes.default.any,
    className: $a9d912cac7a21d69$var$_propTypes.default.string,
    disabled: $a9d912cac7a21d69$var$_propTypes.default.bool,
    onClick: $a9d912cac7a21d69$var$_propTypes.default.func
};
var $a9d912cac7a21d69$var$_default = $a9d912cac7a21d69$var$IconButton;
module.exports.default = $a9d912cac7a21d69$var$_default;

});
parcelRequire.register("i4zc7", function(module, exports) {
"use strict";
function $d283e6977a5517b4$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $d283e6977a5517b4$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $d283e6977a5517b4$var$_typeof(obj);
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d283e6977a5517b4$var$_propTypes = $d283e6977a5517b4$var$_interopRequireDefault((parcelRequire("f7UXb")));

var $d283e6977a5517b4$var$_react = $d283e6977a5517b4$var$_interopRequireWildcard((parcelRequire("eO7Kz")));
var $d283e6977a5517b4$var$_excluded = [
    "aria-hidden",
    "children",
    "disabled",
    "onClick",
    "tabIndex"
];
function $d283e6977a5517b4$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($d283e6977a5517b4$var$_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $d283e6977a5517b4$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || $d283e6977a5517b4$var$_typeof(obj) !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $d283e6977a5517b4$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $d283e6977a5517b4$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $d283e6977a5517b4$var$_extends() {
    $d283e6977a5517b4$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $d283e6977a5517b4$var$_extends.apply(this, arguments);
}
function $d283e6977a5517b4$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $d283e6977a5517b4$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $d283e6977a5517b4$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $d283e6977a5517b4$var$PREVENT_DEFAULT_HANDLER = function PREVENT_DEFAULT_HANDLER(event) {
    return event.preventDefault();
};
// Differences between <button> and <AccessibleButton>:
// - Disable behavior
//   - When the widget is disabled
//     - Set "aria-disabled" attribute to "true"
//     - Set "readonly" attribute
//     - Set "tabIndex" to -1
//     - Remove "onClick" handler
//   - Why this is needed
//     - Browser compatibility: when the widget is disabled, different browser send focus to different places
//     - When the widget become disabled, it's reasonable to keep the focus on the same widget for an extended period of time
//       - When the user presses TAB after the current widget is disabled, it should jump to the next non-disabled widget
// Developers using this accessible widget will need to:
// - Style the disabled widget themselves, using CSS query `:disabled, [aria-disabled="true"] {}`
// - Modify all code that check disabled through "disabled" attribute to use aria-disabled="true" instead
//   - aria-disabled="true" is the source of truth
// - If the widget is contained by a <form>, the developer need to filter out some `onSubmit` event caused by this widget
var $d283e6977a5517b4$var$AccessibleButton = /*#__PURE__*/ (0, $d283e6977a5517b4$var$_react.forwardRef)(function(_ref, forwardedRef) {
    var ariaHidden = _ref["aria-hidden"], children = _ref.children, disabled = _ref.disabled, onClick = _ref.onClick, tabIndex = _ref.tabIndex, props = $d283e6977a5517b4$var$_objectWithoutProperties(_ref, $d283e6977a5517b4$var$_excluded);
    var targetRef = (0, $d283e6977a5517b4$var$_react.useRef)();
    var ref = forwardedRef || targetRef;
    return /*#__PURE__*/ $d283e6977a5517b4$var$_react.default.createElement("button", $d283e6977a5517b4$var$_extends({
        "aria-disabled": disabled || undefined,
        "aria-hidden": ariaHidden,
        onClick: disabled ? $d283e6977a5517b4$var$PREVENT_DEFAULT_HANDLER : onClick,
        ref: ref,
        tabIndex: disabled ? -1 : tabIndex
    }, props, {
        type: "button"
    }), children);
});
$d283e6977a5517b4$var$AccessibleButton.defaultProps = {
    "aria-hidden": undefined,
    children: undefined,
    disabled: undefined,
    onClick: undefined,
    tabIndex: undefined
};
$d283e6977a5517b4$var$AccessibleButton.displayName = "AccessibleButton";
$d283e6977a5517b4$var$AccessibleButton.propTypes = {
    "aria-hidden": $d283e6977a5517b4$var$_propTypes.default.bool,
    children: $d283e6977a5517b4$var$_propTypes.default.any,
    disabled: $d283e6977a5517b4$var$_propTypes.default.bool,
    onClick: $d283e6977a5517b4$var$_propTypes.default.func,
    tabIndex: $d283e6977a5517b4$var$_propTypes.default.number,
    // TypeScript class is not mappable to PropTypes.oneOf(['button'])
    // @ts-ignore
    type: $d283e6977a5517b4$var$_propTypes.default.oneOf([
        "button"
    ]).isRequired
};
var $d283e6977a5517b4$var$_default = $d283e6977a5517b4$var$AccessibleButton;
module.exports.default = $d283e6977a5517b4$var$_default;

});

parcelRequire.register("cp2aW", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $907981d925379b3e$var$useFocusVisible;

var $eO7Kz = parcelRequire("eO7Kz");

var $907981d925379b3e$var$_useObserveFocusVisible = $907981d925379b3e$var$_interopRequireDefault((parcelRequire("90Wbb")));
function $907981d925379b3e$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $907981d925379b3e$var$_slicedToArray(arr, i) {
    return $907981d925379b3e$var$_arrayWithHoles(arr) || $907981d925379b3e$var$_iterableToArrayLimit(arr, i) || $907981d925379b3e$var$_unsupportedIterableToArray(arr, i) || $907981d925379b3e$var$_nonIterableRest();
}
function $907981d925379b3e$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $907981d925379b3e$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $907981d925379b3e$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $907981d925379b3e$var$_arrayLikeToArray(o, minLen);
}
function $907981d925379b3e$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $907981d925379b3e$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $907981d925379b3e$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $907981d925379b3e$var$useFocusVisible(targetRef) {
    var _useState = (0, $eO7Kz.useState)(false), _useState2 = $907981d925379b3e$var$_slicedToArray(_useState, 2), focusVisible = _useState2[0], setFocusVisible = _useState2[1];
    var handleBlur = (0, $eO7Kz.useCallback)(function() {
        return setFocusVisible(false);
    }, [
        setFocusVisible
    ]);
    var handleFocusVisible = (0, $eO7Kz.useCallback)(function() {
        return setFocusVisible(true);
    }, [
        setFocusVisible
    ]);
    (0, $907981d925379b3e$var$_useObserveFocusVisible.default)(targetRef, handleFocusVisible);
    (0, $eO7Kz.useEffect)(function() {
        var current = targetRef.current;
        current.addEventListener("blur", handleBlur);
        return function() {
            return current.removeEventListener("blur", handleBlur);
        };
    }, [
        handleBlur,
        targetRef
    ]);
    return [
        focusVisible
    ];
}

});
parcelRequire.register("90Wbb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $69013e5491ad2064$var$useObserveFocusVisible;

var $hd4g0 = parcelRequire("hd4g0");

var $eO7Kz = parcelRequire("eO7Kz");

var $69013e5491ad2064$var$_supportPseudoClass = $69013e5491ad2064$var$_interopRequireDefault((parcelRequire("fh5YY")));

var $69013e5491ad2064$var$_useNonce3 = $69013e5491ad2064$var$_interopRequireDefault((parcelRequire("1PWhL")));

var $69013e5491ad2064$var$_useValueRef = $69013e5491ad2064$var$_interopRequireDefault((parcelRequire("4Dn0F")));
function $69013e5491ad2064$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $69013e5491ad2064$var$_slicedToArray(arr, i) {
    return $69013e5491ad2064$var$_arrayWithHoles(arr) || $69013e5491ad2064$var$_iterableToArrayLimit(arr, i) || $69013e5491ad2064$var$_unsupportedIterableToArray(arr, i) || $69013e5491ad2064$var$_nonIterableRest();
}
function $69013e5491ad2064$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $69013e5491ad2064$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $69013e5491ad2064$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $69013e5491ad2064$var$_arrayLikeToArray(o, minLen);
}
function $69013e5491ad2064$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $69013e5491ad2064$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $69013e5491ad2064$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
var $69013e5491ad2064$var$usePonyfill = $hd4g0.hooks.usePonyfill;
var $69013e5491ad2064$var$INPUT_TYPES_ALLOW_LIST = [
    "date",
    "datetime-local",
    "datetime",
    "email",
    "month",
    "number",
    "password",
    "search",
    "tel",
    "text",
    "time",
    "url",
    "week"
];
/**
 * Computes whether the given element should automatically trigger the
 * `focus-visible` class being added, i.e. whether it should always match
 * `:focus-visible` when focused.
 * @param {Element} el
 * @return {boolean}
 */ function $69013e5491ad2064$var$focusTriggersKeyboardModality(el) {
    var isContentEditable = el.isContentEditable, readOnly = el.readOnly, tagName = el.tagName, type = el.type;
    return tagName === "INPUT" && $69013e5491ad2064$var$INPUT_TYPES_ALLOW_LIST.includes(type) && !readOnly || tagName === "TEXTAREA" && !readOnly || isContentEditable;
}
function $69013e5491ad2064$var$createEventSubscription(target, types, handler) {
    var subscribed;
    var subscribe = function subscribe() {
        if (!subscribed) {
            types.forEach(function(type) {
                return target.addEventListener(type, handler);
            });
            subscribed = true;
        }
    };
    var unsubscribe = function unsubscribe() {
        if (subscribed) {
            types.forEach(function(type) {
                return target.removeEventListener(type, handler);
            });
            subscribed = undefined;
        }
    };
    return {
        pause: unsubscribe,
        resume: subscribe
    };
} // TODO: Add tests
//       1. Focus via keyboard vs. mouse
//       2. Focus via keyboard, switch app, switch back (expect to get another focusVisible after switch back)
//       3. Focus via mouse, switch app, switch back (do NOT expect to get another focusVisible after switch back)
function $69013e5491ad2064$var$useObserveFocusVisibleForLegacyBrowsers(targetRef, onFocusVisibleRef) {
    var _usePonyfill = $69013e5491ad2064$var$usePonyfill(), _usePonyfill2 = $69013e5491ad2064$var$_slicedToArray(_usePonyfill, 1), Date = _usePonyfill2[0].Date; // This polyfill algorithm is adopted from https://github.com/WICG/focus-visible.
    var blurSinceRef = (0, $eO7Kz.useRef)(0);
    var hadKeyboardEventRef = (0, $eO7Kz.useRef)(true);
    var hasFocusVisibleRef = (0, $eO7Kz.useRef)(false);
    var eventSubscription = (0, $eO7Kz.useMemo)(function() {
        return $69013e5491ad2064$var$createEventSubscription(document, [
            "mousemove",
            "mousedown",
            "mouseup",
            "pointermove",
            "pointerdown",
            "pointerup",
            "touchmove",
            "touchstart",
            "touchend"
        ], function(event) {
            var _nodeName;
            if (((_nodeName = event.target.nodeName) === null || _nodeName === void 0 ? void 0 : _nodeName.toLowerCase()) !== "html") {
                hadKeyboardEventRef.current = false;
                eventSubscription.pause();
            }
        });
    }, [
        hadKeyboardEventRef
    ]);
    var setHasFocusVisible = (0, $eO7Kz.useCallback)(function(nextHasFocusVisible) {
        if (hasFocusVisibleRef.current !== nextHasFocusVisible) {
            hasFocusVisibleRef.current = nextHasFocusVisible;
            nextHasFocusVisible && (onFocusVisibleRef === null || onFocusVisibleRef === void 0 || onFocusVisibleRef.current());
        }
    }, [
        hasFocusVisibleRef,
        onFocusVisibleRef
    ]);
    var handleKeyDown = (0, $eO7Kz.useCallback)(function(event) {
        if (event.altKey || event.ctrlKey || event.metaKey) return;
        if (event.target === targetRef.current) setHasFocusVisible(true);
        hadKeyboardEventRef.current = true;
    }, [
        hadKeyboardEventRef,
        setHasFocusVisible,
        targetRef
    ]);
    var handlePointerDown = (0, $eO7Kz.useCallback)(function() {
        hadKeyboardEventRef.current = false;
    }, [
        hadKeyboardEventRef
    ]);
    var handleFocus = (0, $eO7Kz.useCallback)(function(_ref) {
        var target = _ref.target;
        target === targetRef.current && (hadKeyboardEventRef.current || $69013e5491ad2064$var$focusTriggersKeyboardModality(target)) && setHasFocusVisible(true);
    }, [
        hadKeyboardEventRef,
        setHasFocusVisible,
        targetRef
    ]);
    var handleBlur = (0, $eO7Kz.useCallback)(function(event) {
        if (event.target === targetRef.current && hasFocusVisibleRef.current) {
            blurSinceRef.current = Date.now();
            setHasFocusVisible(false);
        }
    }, [
        blurSinceRef,
        Date,
        hasFocusVisibleRef,
        setHasFocusVisible,
        targetRef
    ]);
    var handleVisibilityChange = (0, $eO7Kz.useCallback)(function() {
        if (document.visibilityState === "hidden") {
            // The element is blurred due to "visibilityState" set to "hidden".
            // 100ms is referenced from the WICG polyfill.
            // eslint-disable-next-line no-magic-numbers
            if (Date.now() - blurSinceRef.current < 100) hadKeyboardEventRef.current = true;
            eventSubscription.resume();
        }
    }, [
        blurSinceRef,
        Date,
        eventSubscription,
        hadKeyboardEventRef
    ]);
    (0, $eO7Kz.useEffect)(function() {
        document.addEventListener("keydown", handleKeyDown, true);
        document.addEventListener("mousedown", handlePointerDown, true);
        document.addEventListener("pointerdown", handlePointerDown, true);
        document.addEventListener("touchstart", handlePointerDown, true);
        document.addEventListener("visibilitychange", handleVisibilityChange, true);
        return function() {
            document.removeEventListener("keydown", handleKeyDown);
            document.removeEventListener("mousedown", handlePointerDown);
            document.removeEventListener("pointerdown", handlePointerDown);
            document.removeEventListener("touchstart", handlePointerDown);
            document.removeEventListener("visibilitychange", handleVisibilityChange);
        };
    }, [
        handleKeyDown,
        handlePointerDown,
        handleVisibilityChange
    ]);
    (0, $eO7Kz.useEffect)(function() {
        var target = targetRef.current;
        target.addEventListener("blur", handleBlur, true);
        target.addEventListener("focus", handleFocus, true);
        return function() {
            target.removeEventListener("blur", handleBlur);
            target.removeEventListener("focus", handleFocus);
        }; // We specifically add "targetRef.current" here.
    // If the target element changed, we should reattach our event listeners.
    }, [
        handleBlur,
        handleFocus,
        targetRef
    ]);
    (0, $eO7Kz.useEffect)(function() {
        eventSubscription.resume();
        return function() {
            return eventSubscription.pause();
        };
    }, [
        eventSubscription
    ]);
}
function $69013e5491ad2064$var$useObserveFocusVisibleForModernBrowsers(targetRef, onFocusVisibleRef) {
    var handleFocus = (0, $eO7Kz.useCallback)(function() {
        var current = targetRef.current;
        if (// eslint-disable-next-line dot-notation
        (current.matches || current["msMatchesSelector"]).call(current, ":focus-visible")) onFocusVisibleRef === null || onFocusVisibleRef === void 0 || onFocusVisibleRef.current();
    }, [
        onFocusVisibleRef,
        targetRef
    ]);
    (0, $eO7Kz.useEffect)(function() {
        var target = targetRef.current;
        target.addEventListener("focus", handleFocus);
        return function() {
            return target.removeEventListener("focus", handleFocus);
        }; // We specifically add "targetRef.current" here.
    // If the target element changed, we should reattach our event listeners.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        handleFocus,
        targetRef,
        targetRef.current
    ]);
}
function $69013e5491ad2064$var$useObserveFocusVisible(targetRef, onFocusVisible) {
    var _useNonce = (0, $69013e5491ad2064$var$_useNonce3.default)(), _useNonce2 = $69013e5491ad2064$var$_slicedToArray(_useNonce, 1), nonce = _useNonce2[0];
    var onFocusVisibleRef = (0, $69013e5491ad2064$var$_useValueRef.default)(onFocusVisible); // The nonce is use for browser capabilities. Just in case the "nonce" had changed unexpectedly, the capabilities of the browser should never change.
    // Thus, we are using an initial version of "nonce". In case web devs changed the "nonce" to an invalid value, we won't break rules of hooks (as stated below).
    var nonceRef = (0, $eO7Kz.useRef)(nonce); // ":focus-visible" selector is supported from Chrome/Edge 86+ and not supported in IE11 or Safari.
    // Doing a capability check on pseudo classes requires injecting a stylesheet, thus nonce is needed.
    var supportFocusVisible = (0, $eO7Kz.useMemo)(function() {
        return (0, $69013e5491ad2064$var$_supportPseudoClass.default)(":focus-visible", nonceRef.current);
    }, [
        nonceRef
    ]); // Since "supportPseudoClass" is a browser capability, the result should be constant during the page lifetime.
    // Thus, running hooks conditionally is okay here.
    if (supportFocusVisible) // eslint-disable-next-line react-hooks/rules-of-hooks
    $69013e5491ad2064$var$useObserveFocusVisibleForModernBrowsers(targetRef, onFocusVisibleRef);
    else // eslint-disable-next-line react-hooks/rules-of-hooks
    $69013e5491ad2064$var$useObserveFocusVisibleForLegacyBrowsers(targetRef, onFocusVisibleRef);
}

});
parcelRequire.register("fh5YY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $b1ed158b74447bc3$var$supportPseudoClass;
// This function is adopted from https://stackoverflow.com/questions/8531940/how-to-detect-if-browser-support-specified-css-pseudo-class
function $b1ed158b74447bc3$var$supportPseudoClass(pseudoClass, nonce) {
    var styleElement = document.createElement("style");
    nonce && styleElement.setAttribute("nonce", nonce);
    document.head.appendChild(styleElement);
    try {
        styleElement.sheet.insertRule("html" + pseudoClass + "{}", 0);
        return true;
    } catch (error) {
        return false;
    } finally{
        document.head.removeChild(styleElement);
    }
}

});

parcelRequire.register("1PWhL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $1567c4269c6d984b$var$useNonce;

var $1567c4269c6d984b$var$_useWebChatUIContext2 = $1567c4269c6d984b$var$_interopRequireDefault((parcelRequire("tHuBR")));
function $1567c4269c6d984b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $1567c4269c6d984b$var$useNonce() {
    var _useWebChatUIContext = (0, $1567c4269c6d984b$var$_useWebChatUIContext2.default)(), nonce = _useWebChatUIContext.nonce;
    return [
        nonce
    ];
}

});

parcelRequire.register("4Dn0F", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $35fca72fc142c553$var$useValueRef;

var $eO7Kz = parcelRequire("eO7Kz");
// TODO: [P0] #4133 Don't copy.
function $35fca72fc142c553$var$useValueRef(value) {
    var ref = (0, $eO7Kz.useRef)();
    var readOnlyRef = (0, $eO7Kz.useMemo)(function() {
        return Object.create({}, {
            current: {
                get: function get() {
                    return ref.current;
                }
            }
        });
    }, []);
    ref.current = value;
    return readOnlyRef;
}

});




parcelRequire.register("a8tV9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7611dc5e29d4d4fa$var$_react = $7611dc5e29d4d4fa$var$_interopRequireDefault((parcelRequire("eO7Kz")));
function $7611dc5e29d4d4fa$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
// eslint-disable-next-line react/prop-types
var $7611dc5e29d4d4fa$var$MicrophoneIcon = function MicrophoneIcon(_ref) {
    var className = _ref.className;
    return /*#__PURE__*/ $7611dc5e29d4d4fa$var$_react.default.createElement("svg", {
        className: className,
        focusable: false,
        height: 28,
        role: "presentation",
        viewBox: "0 0 34.75 46",
        width: 28
    }, /*#__PURE__*/ $7611dc5e29d4d4fa$var$_react.default.createElement("path", {
        className: "a",
        d: "M29.75,23v6.36a7,7,0,0,1-.56,2.78,7.16,7.16,0,0,1-3.8,3.8,7,7,0,0,1-2.78.56H18.5v2.25H23V41H11.75v-2.25h4.5V36.5h-4.11a7,7,0,0,1-2.78-.56,7.16,7.16,0,0,1-3.8-3.8,7,7,0,0,1-.56-2.78V23h2.25v6.36a4.72,4.72,0,0,0,.39,1.9,4.78,4.78,0,0,0,2.6,2.6,4.72,4.72,0,0,0,1.9.39h10.47a4.72,4.72,0,0,0,1.9-.39,4.78,4.78,0,0,0,2.6-2.6,4.72,4.72,0,0,0,.39-1.9V23Zm-18,5.62a1.13,1.13,0,0,0,1.13,1.13h9a1.13,1.13,0,0,0,1.12-1.13V8.38a1.13,1.13,0,0,0-1.12-1.13h-9a1.13,1.13,0,0,0-1.13,1.13Zm1.13,3.38a3.41,3.41,0,0,1-1.32-.26,3.31,3.31,0,0,1-1.8-1.8,3.41,3.41,0,0,1-.26-1.32V8.38a3.41,3.41,0,0,1,.26-1.32,3.31,3.31,0,0,1,1.8-1.8,3.41,3.41,0,0,1,1.32-.26h9a3.4,3.4,0,0,1,1.31.26,3.31,3.31,0,0,1,1.8,1.8,3.41,3.41,0,0,1,.26,1.32v20.24a3.41,3.41,0,0,1-.26,1.32,3.31,3.31,0,0,1-1.8,1.8,3.4,3.4,0,0,1-1.31.26Z"
    }));
};
var $7611dc5e29d4d4fa$var$_default = $7611dc5e29d4d4fa$var$MicrophoneIcon;
module.exports.default = $7611dc5e29d4d4fa$var$_default;

});

parcelRequire.register("erCqX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $a841666f94cec427$var$useDictateAbortable;

var $a841666f94cec427$var$_useSettableDictateAbortable = $a841666f94cec427$var$_interopRequireDefault((parcelRequire("7VcQr")));
function $a841666f94cec427$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $a841666f94cec427$var$_slicedToArray(arr, i) {
    return $a841666f94cec427$var$_arrayWithHoles(arr) || $a841666f94cec427$var$_iterableToArrayLimit(arr, i) || $a841666f94cec427$var$_unsupportedIterableToArray(arr, i) || $a841666f94cec427$var$_nonIterableRest();
}
function $a841666f94cec427$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $a841666f94cec427$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $a841666f94cec427$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $a841666f94cec427$var$_arrayLikeToArray(o, minLen);
}
function $a841666f94cec427$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $a841666f94cec427$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $a841666f94cec427$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $a841666f94cec427$var$useDictateAbortable() {
    // We are only exporting a read-only version of dictateAbortable.
    var _useSettableDictateAb = (0, $a841666f94cec427$var$_useSettableDictateAbortable.default)(), _useSettableDictateAb2 = $a841666f94cec427$var$_slicedToArray(_useSettableDictateAb, 1), dictateAbortable = _useSettableDictateAb2[0];
    return [
        dictateAbortable
    ];
}

});
parcelRequire.register("7VcQr", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $5c47d1f87f6a50f0$var$useSettableDictateAbortable;

var $5c47d1f87f6a50f0$var$_useWebChatUIContext2 = $5c47d1f87f6a50f0$var$_interopRequireDefault((parcelRequire("tHuBR")));
function $5c47d1f87f6a50f0$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $5c47d1f87f6a50f0$var$useSettableDictateAbortable() {
    var _useWebChatUIContext = (0, $5c47d1f87f6a50f0$var$_useWebChatUIContext2.default)(), dictateAbortable = _useWebChatUIContext.dictateAbortable, setDictateAbortable = _useWebChatUIContext.setDictateAbortable;
    return [
        dictateAbortable,
        setDictateAbortable
    ];
}

});


parcelRequire.register("dCR9j", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $9eb80d4a685b6f60$var$useWebSpeechPonyfill;

var $9eb80d4a685b6f60$var$_useWebChatUIContext = $9eb80d4a685b6f60$var$_interopRequireDefault((parcelRequire("tHuBR")));
function $9eb80d4a685b6f60$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $9eb80d4a685b6f60$var$useWebSpeechPonyfill() {
    return [
        (0, $9eb80d4a685b6f60$var$_useWebChatUIContext.default)().webSpeechPonyfill
    ];
}

});


parcelRequire.register("64e5f", function(module, exports) {
"use strict";
function $46ae0a860c0a3b1a$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $46ae0a860c0a3b1a$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $46ae0a860c0a3b1a$var$_typeof(obj);
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = module.exports.connectSendButton = void 0;

var $hd4g0 = parcelRequire("hd4g0");

var $46ae0a860c0a3b1a$var$_classnames = $46ae0a860c0a3b1a$var$_interopRequireDefault((parcelRequire("5A4MD")));

var $46ae0a860c0a3b1a$var$_propTypes = $46ae0a860c0a3b1a$var$_interopRequireDefault((parcelRequire("f7UXb")));

var $46ae0a860c0a3b1a$var$_react = $46ae0a860c0a3b1a$var$_interopRequireWildcard((parcelRequire("eO7Kz")));

var $46ae0a860c0a3b1a$var$_connectToWebChat = $46ae0a860c0a3b1a$var$_interopRequireDefault((parcelRequire("86vmQ")));

var $46ae0a860c0a3b1a$var$_IconButton = $46ae0a860c0a3b1a$var$_interopRequireDefault((parcelRequire("eA5Zo")));

var $46ae0a860c0a3b1a$var$_SendIcon = $46ae0a860c0a3b1a$var$_interopRequireDefault((parcelRequire("3fzfZ")));

var $46ae0a860c0a3b1a$var$_useSubmit = $46ae0a860c0a3b1a$var$_interopRequireDefault((parcelRequire("jJf8H")));
function $46ae0a860c0a3b1a$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($46ae0a860c0a3b1a$var$_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $46ae0a860c0a3b1a$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || $46ae0a860c0a3b1a$var$_typeof(obj) !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $46ae0a860c0a3b1a$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $46ae0a860c0a3b1a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $46ae0a860c0a3b1a$var$_slicedToArray(arr, i) {
    return $46ae0a860c0a3b1a$var$_arrayWithHoles(arr) || $46ae0a860c0a3b1a$var$_iterableToArrayLimit(arr, i) || $46ae0a860c0a3b1a$var$_unsupportedIterableToArray(arr, i) || $46ae0a860c0a3b1a$var$_nonIterableRest();
}
function $46ae0a860c0a3b1a$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $46ae0a860c0a3b1a$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $46ae0a860c0a3b1a$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $46ae0a860c0a3b1a$var$_arrayLikeToArray(o, minLen);
}
function $46ae0a860c0a3b1a$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $46ae0a860c0a3b1a$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $46ae0a860c0a3b1a$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
var $46ae0a860c0a3b1a$var$useDisabled = $hd4g0.hooks.useDisabled, $46ae0a860c0a3b1a$var$useLocalizer = $hd4g0.hooks.useLocalizer;
var $46ae0a860c0a3b1a$var$connectSendButton = function connectSendButton() {
    for(var _len = arguments.length, selectors = new Array(_len), _key = 0; _key < _len; _key++)selectors[_key] = arguments[_key];
    return $46ae0a860c0a3b1a$var$_connectToWebChat.default.apply(void 0, [
        function(_ref) {
            var disabled = _ref.disabled, language = _ref.language, submitSendBox = _ref.submitSendBox;
            return {
                disabled: disabled,
                language: language,
                submitSendBox: submitSendBox
            };
        }
    ].concat(selectors));
};
module.exports.connectSendButton = $46ae0a860c0a3b1a$var$connectSendButton;
var $46ae0a860c0a3b1a$var$SendButton = function SendButton(_ref2) {
    var className = _ref2.className;
    var _useDisabled = $46ae0a860c0a3b1a$var$useDisabled(), _useDisabled2 = $46ae0a860c0a3b1a$var$_slicedToArray(_useDisabled, 1), disabled = _useDisabled2[0];
    var localize = $46ae0a860c0a3b1a$var$useLocalizer();
    var submit = (0, $46ae0a860c0a3b1a$var$_useSubmit.default)();
    var handleClick = (0, $46ae0a860c0a3b1a$var$_react.useCallback)(function() {
        return submit({
            setFocus: "sendBoxWithoutKeyboard"
        });
    }, [
        submit
    ]);
    return /*#__PURE__*/ $46ae0a860c0a3b1a$var$_react.default.createElement($46ae0a860c0a3b1a$var$_IconButton.default, {
        alt: localize("TEXT_INPUT_SEND_BUTTON_ALT"),
        className: (0, $46ae0a860c0a3b1a$var$_classnames.default)("webchat__send-button", className),
        disabled: disabled,
        onClick: handleClick
    }, /*#__PURE__*/ $46ae0a860c0a3b1a$var$_react.default.createElement($46ae0a860c0a3b1a$var$_SendIcon.default, null));
};
$46ae0a860c0a3b1a$var$SendButton.defaultProps = {
    className: undefined
};
$46ae0a860c0a3b1a$var$SendButton.propTypes = {
    className: $46ae0a860c0a3b1a$var$_propTypes.default.string
};
var $46ae0a860c0a3b1a$var$_default = $46ae0a860c0a3b1a$var$SendButton;
module.exports.default = $46ae0a860c0a3b1a$var$_default;

});
parcelRequire.register("3fzfZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $hd4g0 = parcelRequire("hd4g0");

var $25de1f17f6be7df4$var$_classnames = $25de1f17f6be7df4$var$_interopRequireDefault((parcelRequire("5A4MD")));

var $25de1f17f6be7df4$var$_react = $25de1f17f6be7df4$var$_interopRequireDefault((parcelRequire("eO7Kz")));

var $25de1f17f6be7df4$var$_useStyleToEmotionObject = $25de1f17f6be7df4$var$_interopRequireDefault((parcelRequire("6l4uV")));
function $25de1f17f6be7df4$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $25de1f17f6be7df4$var$_slicedToArray(arr, i) {
    return $25de1f17f6be7df4$var$_arrayWithHoles(arr) || $25de1f17f6be7df4$var$_iterableToArrayLimit(arr, i) || $25de1f17f6be7df4$var$_unsupportedIterableToArray(arr, i) || $25de1f17f6be7df4$var$_nonIterableRest();
}
function $25de1f17f6be7df4$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $25de1f17f6be7df4$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $25de1f17f6be7df4$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $25de1f17f6be7df4$var$_arrayLikeToArray(o, minLen);
}
function $25de1f17f6be7df4$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $25de1f17f6be7df4$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $25de1f17f6be7df4$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
var $25de1f17f6be7df4$var$useDirection = $hd4g0.hooks.useDirection;
var $25de1f17f6be7df4$var$ROOT_STYLE = {
    "&.webchat__send-icon": {
        "&.webchat__send-icon--rtl": {
            transform: "scale(-1, 1)"
        }
    }
};
var $25de1f17f6be7df4$var$SendIcon = function SendIcon() {
    var _useDirection = $25de1f17f6be7df4$var$useDirection(), _useDirection2 = $25de1f17f6be7df4$var$_slicedToArray(_useDirection, 1), direction = _useDirection2[0];
    var rootClassName = (0, $25de1f17f6be7df4$var$_useStyleToEmotionObject.default)()($25de1f17f6be7df4$var$ROOT_STYLE) + "";
    return /*#__PURE__*/ $25de1f17f6be7df4$var$_react.default.createElement("svg", {
        className: (0, $25de1f17f6be7df4$var$_classnames.default)("webchat__send-icon", {
            "webchat__send-icon--rtl": direction === "rtl"
        }, rootClassName),
        height: 28,
        viewBox: "0 0 45.7 33.8",
        width: 28
    }, /*#__PURE__*/ $25de1f17f6be7df4$var$_react.default.createElement("path", {
        clipRule: "evenodd",
        d: "M8.55 25.25l21.67-7.25H11zm2.41-9.47h19.26l-21.67-7.23zm-6 13l4-11.9L5 5l35.7 11.9z"
    }));
};
var $25de1f17f6be7df4$var$_default = $25de1f17f6be7df4$var$SendIcon;
module.exports.default = $25de1f17f6be7df4$var$_default;

});

parcelRequire.register("jJf8H", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $e5cdf6a6a552dda9$var$useSubmit;

var $e5cdf6a6a552dda9$var$_useContext = $e5cdf6a6a552dda9$var$_interopRequireDefault((parcelRequire("93z0q")));
function $e5cdf6a6a552dda9$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * Returns a callback function, when called, will send the value of the text box as a message.
 *
 * If the message cannot be send immediately, for example, the message is empty. An error message will be read
 * and the error message element can be referenced by `useErrorMessageId()` hook.
 *
 * If the message can be send, after the message is queued, regardless whether it send successfully or not, the text box will be cleared.
 */ function $e5cdf6a6a552dda9$var$useSubmit() {
    return (0, $e5cdf6a6a552dda9$var$_useContext.default)().submit;
}

});
parcelRequire.register("93z0q", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $697f8c5433440e8b$var$useSendBoxContext;

var $eO7Kz = parcelRequire("eO7Kz");

var $697f8c5433440e8b$var$_Context = $697f8c5433440e8b$var$_interopRequireDefault((parcelRequire("gWEqo")));
function $697f8c5433440e8b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $697f8c5433440e8b$var$useSendBoxContext() {
    var context = (0, $eO7Kz.useContext)($697f8c5433440e8b$var$_Context.default);
    if (!context) throw new Error("botframework-webchat internal: This hook can only be used under <SendBoxComposer>.");
    return context;
}

});
parcelRequire.register("gWEqo", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $eO7Kz = parcelRequire("eO7Kz");
var $c5616ba0cdadb7cc$var$SendBoxContext = /*#__PURE__*/ (0, $eO7Kz.createContext)(undefined);
var $c5616ba0cdadb7cc$var$_default = $c5616ba0cdadb7cc$var$SendBoxContext;
module.exports.default = $c5616ba0cdadb7cc$var$_default;

});




parcelRequire.register("lP26E", function(module, exports) {
"use strict";
function $fe2ffea53a45e774$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $fe2ffea53a45e774$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $fe2ffea53a45e774$var$_typeof(obj);
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = module.exports.connectSuggestedActions = void 0;

var $hd4g0 = parcelRequire("hd4g0");

var $fe2ffea53a45e774$var$_reactFilm = $fe2ffea53a45e774$var$_interopRequireWildcard((parcelRequire("28Cd0")));

var $fe2ffea53a45e774$var$_classnames = $fe2ffea53a45e774$var$_interopRequireDefault((parcelRequire("5A4MD")));

var $fe2ffea53a45e774$var$_propTypes = $fe2ffea53a45e774$var$_interopRequireDefault((parcelRequire("f7UXb")));

var $fe2ffea53a45e774$var$_react = $fe2ffea53a45e774$var$_interopRequireWildcard((parcelRequire("eO7Kz")));

var $fe2ffea53a45e774$var$_computeSuggestedActionText = $fe2ffea53a45e774$var$_interopRequireDefault((parcelRequire("kbcsp")));

var $fe2ffea53a45e774$var$_connectToWebChat = $fe2ffea53a45e774$var$_interopRequireDefault((parcelRequire("86vmQ")));

var $fe2ffea53a45e774$var$_RovingTabIndexComposer = $fe2ffea53a45e774$var$_interopRequireDefault((parcelRequire("8tT0c")));

var $fe2ffea53a45e774$var$_SuggestedAction = $fe2ffea53a45e774$var$_interopRequireDefault((parcelRequire("5pUEO")));

var $fe2ffea53a45e774$var$_useFocus = $fe2ffea53a45e774$var$_interopRequireDefault((parcelRequire("kPV7d")));

var $fe2ffea53a45e774$var$_useFocusWithin3 = $fe2ffea53a45e774$var$_interopRequireDefault((parcelRequire("dw1oV")));

var $fe2ffea53a45e774$var$_useNonce3 = $fe2ffea53a45e774$var$_interopRequireDefault((parcelRequire("1PWhL")));

var $fe2ffea53a45e774$var$_useStyleSet7 = $fe2ffea53a45e774$var$_interopRequireDefault((parcelRequire("gC6jZ")));

var $fe2ffea53a45e774$var$_useStyleToEmotionObject = $fe2ffea53a45e774$var$_interopRequireDefault((parcelRequire("6l4uV")));
function $fe2ffea53a45e774$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $fe2ffea53a45e774$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($fe2ffea53a45e774$var$_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $fe2ffea53a45e774$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || $fe2ffea53a45e774$var$_typeof(obj) !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $fe2ffea53a45e774$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $fe2ffea53a45e774$var$_slicedToArray(arr, i) {
    return $fe2ffea53a45e774$var$_arrayWithHoles(arr) || $fe2ffea53a45e774$var$_iterableToArrayLimit(arr, i) || $fe2ffea53a45e774$var$_unsupportedIterableToArray(arr, i) || $fe2ffea53a45e774$var$_nonIterableRest();
}
function $fe2ffea53a45e774$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $fe2ffea53a45e774$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $fe2ffea53a45e774$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $fe2ffea53a45e774$var$_arrayLikeToArray(o, minLen);
}
function $fe2ffea53a45e774$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $fe2ffea53a45e774$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $fe2ffea53a45e774$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
var $fe2ffea53a45e774$var$useDirection = $hd4g0.hooks.useDirection, $fe2ffea53a45e774$var$useLocalizer = $hd4g0.hooks.useLocalizer, $fe2ffea53a45e774$var$useStyleOptions = $hd4g0.hooks.useStyleOptions;
var $fe2ffea53a45e774$var$ROOT_STYLE = {
    "&.webchat__suggested-actions": {
        "&.webchat__suggested-actions--flow-layout .webchat__suggested-actions__flow-box": {
            display: "flex",
            flexWrap: "wrap"
        },
        "&.webchat__suggested-actions--stack-layout .webchat__suggested-actions__stack": {
            display: "flex",
            flexDirection: "column"
        }
    }
};
var $fe2ffea53a45e774$var$connectSuggestedActions = function connectSuggestedActions() {
    for(var _len = arguments.length, selectors = new Array(_len), _key = 0; _key < _len; _key++)selectors[_key] = arguments[_key];
    return $fe2ffea53a45e774$var$_connectToWebChat.default.apply(void 0, [
        function(_ref) {
            var language = _ref.language, suggestedActions = _ref.suggestedActions;
            return {
                language: language,
                suggestedActions: suggestedActions
            };
        }
    ].concat(selectors));
};
module.exports.connectSuggestedActions = $fe2ffea53a45e774$var$connectSuggestedActions;
var $fe2ffea53a45e774$var$SuggestedActionCarouselContainer = function SuggestedActionCarouselContainer(_ref2) {
    var children = _ref2.children, className = _ref2.className, label = _ref2.label;
    var _useStyleOptions = $fe2ffea53a45e774$var$useStyleOptions(), _useStyleOptions2 = $fe2ffea53a45e774$var$_slicedToArray(_useStyleOptions, 1), _useStyleOptions2$ = _useStyleOptions2[0], suggestedActionsCarouselFlipperBoxWidth = _useStyleOptions2$.suggestedActionsCarouselFlipperBoxWidth, suggestedActionsCarouselFlipperCursor = _useStyleOptions2$.suggestedActionsCarouselFlipperCursor, suggestedActionsCarouselFlipperSize = _useStyleOptions2$.suggestedActionsCarouselFlipperSize;
    var _useStyleSet = (0, $fe2ffea53a45e774$var$_useStyleSet7.default)(), _useStyleSet2 = $fe2ffea53a45e774$var$_slicedToArray(_useStyleSet, 1), suggestedActionsStyleSet = _useStyleSet2[0].suggestedActions;
    var _useDirection = $fe2ffea53a45e774$var$useDirection(), _useDirection2 = $fe2ffea53a45e774$var$_slicedToArray(_useDirection, 1), direction = _useDirection2[0];
    var _useNonce = (0, $fe2ffea53a45e774$var$_useNonce3.default)(), _useNonce2 = $fe2ffea53a45e774$var$_slicedToArray(_useNonce, 1), nonce = _useNonce2[0];
    var localize = $fe2ffea53a45e774$var$useLocalizer();
    var ref = (0, $fe2ffea53a45e774$var$_react.useRef)();
    var rootClassName = (0, $fe2ffea53a45e774$var$_useStyleToEmotionObject.default)()($fe2ffea53a45e774$var$ROOT_STYLE) + "";
    var filmStyleSet = (0, $fe2ffea53a45e774$var$_react.useMemo)(function() {
        return (0, $fe2ffea53a45e774$var$_reactFilm.createBasicStyleSet)({
            autoHide: false,
            cursor: suggestedActionsCarouselFlipperCursor,
            flipperBoxWidth: suggestedActionsCarouselFlipperBoxWidth,
            flipperSize: suggestedActionsCarouselFlipperSize
        });
    }, [
        suggestedActionsCarouselFlipperBoxWidth,
        suggestedActionsCarouselFlipperCursor,
        suggestedActionsCarouselFlipperSize
    ]);
    var nextFlipperAriaLabel = localize("SUGGESTED_ACTIONS_FLIPPER_NEXT_ALT");
    var previousFlipperAriaLabel = localize("SUGGESTED_ACTIONS_FLIPPER_PREVIOUS_ALT");
    var _useFocusWithin = (0, $fe2ffea53a45e774$var$_useFocusWithin3.default)(ref), _useFocusWithin2 = $fe2ffea53a45e774$var$_slicedToArray(_useFocusWithin, 1), focusedWithin = _useFocusWithin2[0];
    var leftFlipperAriaLabel = direction === "rtl" ? nextFlipperAriaLabel : previousFlipperAriaLabel;
    var rightFlipperAriaLabel = direction === "rtl" ? previousFlipperAriaLabel : nextFlipperAriaLabel;
    return(/*#__PURE__*/ // TODO: The content of suggested actions should be the labelled by the activity.
    //       That means, when the user focus into the suggested actions, it should read similar to "Bot said, what's your preference of today? Suggested actions has items: apple button, orange button, banana button."
    $fe2ffea53a45e774$var$_react.default.createElement("div", {
        "aria-label": label,
        "aria-orientation": "horizontal",
        className: (0, $fe2ffea53a45e774$var$_classnames.default)("webchat__suggested-actions", "webchat__suggested-actions--carousel-layout", {
            "webchat__suggested-actions--focus-within": focusedWithin,
            "webchat__suggested-actions--rtl": direction === "rtl"
        }, rootClassName, suggestedActionsStyleSet + "", (className || "") + ""),
        ref: ref,
        role: "toolbar"
    }, !!children && !!$fe2ffea53a45e774$var$_react.default.Children.count(children) && /*#__PURE__*/ $fe2ffea53a45e774$var$_react.default.createElement($fe2ffea53a45e774$var$_reactFilm.default, {
        autoCenter: false,
        className: "webchat__suggested-actions__carousel",
        dir: direction,
        flipperBlurFocusOnClick: true,
        leftFlipperAriaLabel: leftFlipperAriaLabel,
        nonce: nonce,
        rightFlipperAriaLabel: rightFlipperAriaLabel,
        showDots: false,
        showScrollBar: false,
        styleSet: filmStyleSet
    }, children), /*#__PURE__*/ $fe2ffea53a45e774$var$_react.default.createElement("div", {
        className: "webchat__suggested-actions__focus-indicator"
    })));
};
$fe2ffea53a45e774$var$SuggestedActionCarouselContainer.defaultProps = {
    children: undefined,
    className: undefined
};
$fe2ffea53a45e774$var$SuggestedActionCarouselContainer.propTypes = {
    children: $fe2ffea53a45e774$var$_propTypes.default.any,
    className: $fe2ffea53a45e774$var$_propTypes.default.string,
    label: $fe2ffea53a45e774$var$_propTypes.default.string.isRequired
};
var $fe2ffea53a45e774$var$SuggestedActionFlowContainer = function SuggestedActionFlowContainer(_ref3) {
    var children = _ref3.children, className = _ref3.className, label = _ref3.label;
    var _useStyleSet3 = (0, $fe2ffea53a45e774$var$_useStyleSet7.default)(), _useStyleSet4 = $fe2ffea53a45e774$var$_slicedToArray(_useStyleSet3, 1), suggestedActionsStyleSet = _useStyleSet4[0].suggestedActions;
    var rootClassName = (0, $fe2ffea53a45e774$var$_useStyleToEmotionObject.default)()($fe2ffea53a45e774$var$ROOT_STYLE) + "";
    return /*#__PURE__*/ $fe2ffea53a45e774$var$_react.default.createElement("div", {
        "aria-label": label,
        "aria-live": "polite",
        "aria-orientation": "horizontal",
        className: (0, $fe2ffea53a45e774$var$_classnames.default)("webchat__suggested-actions", "webchat__suggested-actions--flow-layout", rootClassName, suggestedActionsStyleSet + "", (className || "") + ""),
        role: "toolbar"
    }, !!children && !!$fe2ffea53a45e774$var$_react.default.Children.count(children) && /*#__PURE__*/ $fe2ffea53a45e774$var$_react.default.createElement("div", {
        className: "webchat__suggested-actions__flow-box"
    }, $fe2ffea53a45e774$var$_react.default.Children.map(children, function(child) {
        return /*#__PURE__*/ $fe2ffea53a45e774$var$_react.default.createElement("div", {
            className: "webchat__suggested-actions__flow-item-box"
        }, child);
    })), /*#__PURE__*/ $fe2ffea53a45e774$var$_react.default.createElement("div", {
        className: "webchat__suggested-actions__focus-indicator"
    }));
};
$fe2ffea53a45e774$var$SuggestedActionFlowContainer.defaultProps = {
    children: undefined,
    className: undefined
};
$fe2ffea53a45e774$var$SuggestedActionFlowContainer.propTypes = {
    children: $fe2ffea53a45e774$var$_propTypes.default.any,
    className: $fe2ffea53a45e774$var$_propTypes.default.string,
    label: $fe2ffea53a45e774$var$_propTypes.default.string.isRequired
};
var $fe2ffea53a45e774$var$SuggestedActionStackedContainer = function SuggestedActionStackedContainer(_ref4) {
    var children = _ref4.children, className = _ref4.className, label = _ref4.label;
    var _useStyleSet5 = (0, $fe2ffea53a45e774$var$_useStyleSet7.default)(), _useStyleSet6 = $fe2ffea53a45e774$var$_slicedToArray(_useStyleSet5, 1), suggestedActionsStyleSet = _useStyleSet6[0].suggestedActions;
    var rootClassName = (0, $fe2ffea53a45e774$var$_useStyleToEmotionObject.default)()($fe2ffea53a45e774$var$ROOT_STYLE) + "";
    return /*#__PURE__*/ $fe2ffea53a45e774$var$_react.default.createElement("div", {
        "aria-label": label,
        "aria-live": "polite",
        "aria-orientation": "vertical",
        className: (0, $fe2ffea53a45e774$var$_classnames.default)("webchat__suggested-actions", "webchat__suggested-actions--stacked-layout", rootClassName, suggestedActionsStyleSet + "", (className || "") + ""),
        role: "toolbar"
    }, !!children && !!$fe2ffea53a45e774$var$_react.default.Children.count(children) && /*#__PURE__*/ $fe2ffea53a45e774$var$_react.default.createElement("div", {
        className: "webchat__suggested-actions__stack"
    }, children), /*#__PURE__*/ $fe2ffea53a45e774$var$_react.default.createElement("div", {
        className: "webchat__suggested-actions__focus-indicator"
    }));
};
$fe2ffea53a45e774$var$SuggestedActionStackedContainer.defaultProps = {
    children: undefined,
    className: undefined
};
$fe2ffea53a45e774$var$SuggestedActionStackedContainer.propTypes = {
    children: $fe2ffea53a45e774$var$_propTypes.default.any,
    className: $fe2ffea53a45e774$var$_propTypes.default.string,
    label: $fe2ffea53a45e774$var$_propTypes.default.string.isRequired
};
var $fe2ffea53a45e774$var$SuggestedActions = function SuggestedActions(_ref5) {
    var className = _ref5.className, _ref5$suggestedAction = _ref5.suggestedActions, suggestedActions = _ref5$suggestedAction === void 0 ? [] : _ref5$suggestedAction;
    var _useStyleOptions3 = $fe2ffea53a45e774$var$useStyleOptions(), _useStyleOptions4 = $fe2ffea53a45e774$var$_slicedToArray(_useStyleOptions3, 1), _useStyleOptions4$ = _useStyleOptions4[0], suggestedActionLayout = _useStyleOptions4$.suggestedActionLayout, suggestedActionsStackedLayoutButtonTextWrap = _useStyleOptions4$.suggestedActionsStackedLayoutButtonTextWrap;
    var localize = $fe2ffea53a45e774$var$useLocalizer();
    var focus = (0, $fe2ffea53a45e774$var$_useFocus.default)();
    var handleEscapeKey = (0, $fe2ffea53a45e774$var$_react.useCallback)(function() {
        focus("sendBox");
    }, [
        focus
    ]);
    var label = localize("SUGGESTED_ACTIONS_LABEL_ALT");
    var children = suggestedActions.map(function(cardAction, index) {
        var _ref6 = cardAction, displayText = _ref6.displayText, image = _ref6.image, imageAltText = _ref6.imageAltText, text = _ref6.text, type = _ref6.type, value = _ref6.value;
        return /*#__PURE__*/ $fe2ffea53a45e774$var$_react.default.createElement("div", {
            className: "webchat__suggested-actions__item-box",
            key: index
        }, /*#__PURE__*/ $fe2ffea53a45e774$var$_react.default.createElement($fe2ffea53a45e774$var$_SuggestedAction.default, {
            buttonText: (0, $fe2ffea53a45e774$var$_computeSuggestedActionText.default)(cardAction),
            className: "webchat__suggested-actions__button",
            displayText: displayText,
            image: image // Image alt text should use `imageAltText` field and fallback to `text` field.
            ,
            imageAlt: image && (imageAltText || text),
            itemIndex: index,
            text: text,
            textClassName: suggestedActionLayout === "stacked" && suggestedActionsStackedLayoutButtonTextWrap ? "webchat__suggested-actions__button-text-stacked-text-wrap" : "webchat__suggested-actions__button-text",
            type: type,
            value: value
        }));
    }); // If there are no suggested actions, we will render nothing.
    if (!children.length) return null;
    if (suggestedActionLayout === "flow") return /*#__PURE__*/ $fe2ffea53a45e774$var$_react.default.createElement($fe2ffea53a45e774$var$_RovingTabIndexComposer.default, {
        onEscapeKey: handleEscapeKey
    }, /*#__PURE__*/ $fe2ffea53a45e774$var$_react.default.createElement($fe2ffea53a45e774$var$SuggestedActionFlowContainer, {
        className: className,
        label: label
    }, children));
    else if (suggestedActionLayout === "stacked") return /*#__PURE__*/ $fe2ffea53a45e774$var$_react.default.createElement($fe2ffea53a45e774$var$_RovingTabIndexComposer.default, {
        onEscapeKey: handleEscapeKey,
        orientation: "vertical"
    }, /*#__PURE__*/ $fe2ffea53a45e774$var$_react.default.createElement($fe2ffea53a45e774$var$SuggestedActionStackedContainer, {
        className: className,
        label: label
    }, children));
    return /*#__PURE__*/ $fe2ffea53a45e774$var$_react.default.createElement($fe2ffea53a45e774$var$_RovingTabIndexComposer.default, {
        onEscapeKey: handleEscapeKey
    }, /*#__PURE__*/ $fe2ffea53a45e774$var$_react.default.createElement($fe2ffea53a45e774$var$SuggestedActionCarouselContainer, {
        className: className,
        label: label
    }, children));
};
$fe2ffea53a45e774$var$SuggestedActions.defaultProps = {
    className: ""
};
$fe2ffea53a45e774$var$SuggestedActions.propTypes = {
    className: $fe2ffea53a45e774$var$_propTypes.default.string,
    // TypeScript class is not mappable to PropTypes.func
    // @ts-ignore
    suggestedActions: $fe2ffea53a45e774$var$_propTypes.default.arrayOf($fe2ffea53a45e774$var$_propTypes.default.shape({
        displayText: $fe2ffea53a45e774$var$_propTypes.default.string,
        image: $fe2ffea53a45e774$var$_propTypes.default.string,
        imageAltText: $fe2ffea53a45e774$var$_propTypes.default.string,
        text: $fe2ffea53a45e774$var$_propTypes.default.string,
        title: $fe2ffea53a45e774$var$_propTypes.default.string,
        type: $fe2ffea53a45e774$var$_propTypes.default.string.isRequired,
        value: $fe2ffea53a45e774$var$_propTypes.default.any
    })).isRequired
};
var $fe2ffea53a45e774$var$_default = $fe2ffea53a45e774$var$connectSuggestedActions()($fe2ffea53a45e774$var$SuggestedActions);
module.exports.default = $fe2ffea53a45e774$var$_default;

});
parcelRequire.register("28Cd0", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $18e9f7912483f0fd$export$2e2bcd8739ae039);
$parcel$export(module.exports, "BasicFilm", () => (parcelRequire("2pBaw")).default);
$parcel$export(module.exports, "Composer", () => (parcelRequire("9rtoc")).default);
$parcel$export(module.exports, "Context", () => (parcelRequire("dBwSo")).default);
$parcel$export(module.exports, "createBasicStyleSet", () => (parcelRequire("2tzI6")).default);
$parcel$export(module.exports, "FilmStrip", () => (parcelRequire("4tLNN")).default);
$parcel$export(module.exports, "Dots", () => (parcelRequire("8XbN8")).default);
$parcel$export(module.exports, "Filmstrip", () => (parcelRequire("d7ywg")).default);
$parcel$export(module.exports, "Flipper", () => (parcelRequire("1w92p")).default);
$parcel$export(module.exports, "ScrollBar", () => (parcelRequire("inmhv")).default);
$parcel$export(module.exports, "useDir", () => (parcelRequire("26H2c")).default);
$parcel$export(module.exports, "useHeight", () => (parcelRequire("aQ78f")).default);
$parcel$export(module.exports, "useIndex", () => (parcelRequire("kBXs7")).default);
$parcel$export(module.exports, "useIndexFraction", () => (parcelRequire("6UtLI")).default);
$parcel$export(module.exports, "useItemContainerCallbackRef", () => (parcelRequire("8xjyx")).default);
$parcel$export(module.exports, "useNumItems", () => (parcelRequire("51FGD")).default);
$parcel$export(module.exports, "useScrollableCallbackRef", () => (parcelRequire("4ibPa")).default);
$parcel$export(module.exports, "useScrollBarPercentage", () => (parcelRequire("Xq3pF")).default);
$parcel$export(module.exports, "useScrollBarWidth", () => (parcelRequire("29LnK")).default);
$parcel$export(module.exports, "useScrolling", () => (parcelRequire("kPoIH")).default);
$parcel$export(module.exports, "useScrollOneLeft", () => (parcelRequire("6Nn0k")).default);
$parcel$export(module.exports, "useScrollOneRight", () => (parcelRequire("dnHr4")).default);
$parcel$export(module.exports, "useScrollTo", () => (parcelRequire("F8IqC")).default);
$parcel$export(module.exports, "useStyleOptions", () => (parcelRequire("fYCA4")).default);
$parcel$export(module.exports, "useStyleSetClassNames", () => (parcelRequire("jz9Ub")).default);

var $2pBaw = parcelRequire("2pBaw");

var $9rtoc = parcelRequire("9rtoc");

var $dBwSo = parcelRequire("dBwSo");

var $2tzI6 = parcelRequire("2tzI6");

var $4tLNN = parcelRequire("4tLNN");

var $8XbN8 = parcelRequire("8XbN8");

var $d7ywg = parcelRequire("d7ywg");

var $1w92p = parcelRequire("1w92p");

var $jJK6r = parcelRequire("jJK6r");

var $inmhv = parcelRequire("inmhv");

var $26H2c = parcelRequire("26H2c");

var $aQ78f = parcelRequire("aQ78f");

var $kBXs7 = parcelRequire("kBXs7");

var $6UtLI = parcelRequire("6UtLI");

var $8xjyx = parcelRequire("8xjyx");

var $51FGD = parcelRequire("51FGD");

var $4ibPa = parcelRequire("4ibPa");

var $Xq3pF = parcelRequire("Xq3pF");

var $29LnK = parcelRequire("29LnK");

var $kPoIH = parcelRequire("kPoIH");

var $6Nn0k = parcelRequire("6Nn0k");

var $dnHr4 = parcelRequire("dnHr4");

var $F8IqC = parcelRequire("F8IqC");

var $fYCA4 = parcelRequire("fYCA4");

var $jz9Ub = parcelRequire("jz9Ub");
var $18e9f7912483f0fd$export$2e2bcd8739ae039 = (0, $jJK6r.default);
if (typeof document !== "undefined" && document.head) {
    var $18e9f7912483f0fd$var$meta = document.createElement("meta");
    $18e9f7912483f0fd$var$meta.setAttribute("name", "react-film");
    // eslint-disable-next-line no-undef
    $18e9f7912483f0fd$var$meta.setAttribute("content", "version=".concat("3.1.1-main.df870ea"));
    document.head.appendChild($18e9f7912483f0fd$var$meta);
}

});
parcelRequire.register("2pBaw", function(module, exports) {

$parcel$export(module.exports, "default", () => $1c1abf7e492d2f1c$export$2e2bcd8739ae039);

var $cUZUF = parcelRequire("cUZUF");

var $5A4MD = parcelRequire("5A4MD");

var $f7UXb = parcelRequire("f7UXb");

var $eO7Kz = parcelRequire("eO7Kz");

var $8XbN8 = parcelRequire("8XbN8");

var $d7ywg = parcelRequire("d7ywg");

var $1w92p = parcelRequire("1w92p");

var $inmhv = parcelRequire("inmhv");

var $26H2c = parcelRequire("26H2c");

var $aQ78f = parcelRequire("aQ78f");

var $51FGD = parcelRequire("51FGD");

var $29LnK = parcelRequire("29LnK");

var $kPoIH = parcelRequire("kPoIH");

var $fYCA4 = parcelRequire("fYCA4");

var $jz9Ub = parcelRequire("jz9Ub");
var $1c1abf7e492d2f1c$var$BasicFilm = function BasicFilm(_ref) {
    var children = _ref.children, className = _ref.className;
    var _useDir = (0, $26H2c.default)(), _useDir2 = (0, (/*@__PURE__*/$parcel$interopDefault($cUZUF)))(_useDir, 1), dir = _useDir2[0];
    var _useHeight = (0, $aQ78f.default)(), _useHeight2 = (0, (/*@__PURE__*/$parcel$interopDefault($cUZUF)))(_useHeight, 1), height = _useHeight2[0];
    var _useNumItems = (0, $51FGD.default)(), _useNumItems2 = (0, (/*@__PURE__*/$parcel$interopDefault($cUZUF)))(_useNumItems, 1), numItems = _useNumItems2[0];
    var _useScrollBarWidth = (0, $29LnK.default)(), _useScrollBarWidth2 = (0, (/*@__PURE__*/$parcel$interopDefault($cUZUF)))(_useScrollBarWidth, 1), scrollBarWidth = _useScrollBarWidth2[0];
    var _useScrolling = (0, $kPoIH.default)(), _useScrolling2 = (0, (/*@__PURE__*/$parcel$interopDefault($cUZUF)))(_useScrolling, 1), scrolling = _useScrolling2[0];
    var _useStyleSetClassName = (0, $jz9Ub.default)(), _useStyleSetClassName2 = (0, (/*@__PURE__*/$parcel$interopDefault($cUZUF)))(_useStyleSetClassName, 1), rootClassName = _useStyleSetClassName2[0].root;
    var _useStyleOptions = (0, $fYCA4.default)(), _useStyleOptions2 = (0, (/*@__PURE__*/$parcel$interopDefault($cUZUF)))(_useStyleOptions, 1), _useStyleOptions2$ = _useStyleOptions2[0], flipperBlurFocusOnClick = _useStyleOptions2$.flipperBlurFocusOnClick, leftFlipperAriaLabel = _useStyleOptions2$.leftFlipperAriaLabel, leftFlipperText = _useStyleOptions2$.leftFlipperText, rightFlipperAriaLabel = _useStyleOptions2$.rightFlipperAriaLabel, rightFlipperText = _useStyleOptions2$.rightFlipperText, showDots = _useStyleOptions2$.showDots, showFlipper = _useStyleOptions2$.showFlipper, showScrollBar = _useStyleOptions2$.showScrollBar;
    var contentStyle = (0, $eO7Kz.useMemo)(function() {
        return {
            height: height
        };
    }, [
        height
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eO7Kz))).createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($5A4MD)))(rootClassName, (className || "") + ""),
        dir: dir
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eO7Kz))).createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($5A4MD)))("react-film__main", {
            "react-film__main--scrolling": scrolling
        }),
        style: contentStyle
    }, !!numItems && scrollBarWidth !== "100%" && !!showFlipper && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eO7Kz))).createElement((0, $1w92p.default), {
        "aria-label": leftFlipperAriaLabel,
        blurFocusOnClick: flipperBlurFocusOnClick,
        mode: "left"
    }, leftFlipperText), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eO7Kz))).createElement((0, $d7ywg.default), null, children), !!numItems && scrollBarWidth !== "100%" && !!showFlipper && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eO7Kz))).createElement((0, $1w92p.default), {
        "aria-label": rightFlipperAriaLabel,
        blurFocusOnClick: flipperBlurFocusOnClick,
        mode: "right"
    }, rightFlipperText), !!numItems && scrollBarWidth !== "100%" && !!showScrollBar && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eO7Kz))).createElement((0, $inmhv.default), null)), !!numItems && scrollBarWidth !== "100%" && !!showDots && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eO7Kz))).createElement((0, $8XbN8.default), null));
};
// TODO: Move from styleSet to styleSheet.
$1c1abf7e492d2f1c$var$BasicFilm.defaultProps = {
    children: undefined,
    className: undefined
};
$1c1abf7e492d2f1c$var$BasicFilm.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($f7UXb))).any,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($f7UXb))).string
};
var $1c1abf7e492d2f1c$export$2e2bcd8739ae039 = $1c1abf7e492d2f1c$var$BasicFilm;

});
parcelRequire.register("cUZUF", function(module, exports) {

var $b4X2N = parcelRequire("b4X2N");

var $8R7xV = parcelRequire("8R7xV");

var $eg03m = parcelRequire("eg03m");

var $dZe0i = parcelRequire("dZe0i");
function $967abda283c39ca5$var$_slicedToArray(arr, i) {
    return $b4X2N(arr) || $8R7xV(arr, i) || $eg03m(arr, i) || $dZe0i();
}
module.exports = $967abda283c39ca5$var$_slicedToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRequire.register("b4X2N", function(module, exports) {

var $bi0nH = parcelRequire("bi0nH");
function $810dde61246b17b8$var$_arrayWithHoles(arr) {
    if ($bi0nH(arr)) return arr;
}
module.exports = $810dde61246b17b8$var$_arrayWithHoles, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRequire.register("bi0nH", function(module, exports) {

module.exports = (parcelRequire("6jPy4"));

});
parcelRequire.register("6jPy4", function(module, exports) {

module.exports = (parcelRequire("9efwu"));

});
parcelRequire.register("9efwu", function(module, exports) {

var $lkAyt = parcelRequire("lkAyt");
module.exports = $lkAyt;

});
parcelRequire.register("lkAyt", function(module, exports) {

var $cC4VF = parcelRequire("cC4VF");
module.exports = $cC4VF;

});
parcelRequire.register("cC4VF", function(module, exports) {

var $dgX76 = parcelRequire("dgX76");
module.exports = $dgX76;

});
parcelRequire.register("dgX76", function(module, exports) {
parcelRequire("frsF5");

var $lahb7 = parcelRequire("lahb7");
module.exports = $lahb7.Array.isArray;

});
parcelRequire.register("frsF5", function(module, exports) {

var $2iwSV = parcelRequire("2iwSV");

var $fnf29 = parcelRequire("fnf29");
// `Array.isArray` method
// https://tc39.es/ecma262/#sec-array.isarray
$2iwSV({
    target: "Array",
    stat: true
}, {
    isArray: $fnf29
});

});
parcelRequire.register("fnf29", function(module, exports) {

var $gir1t = parcelRequire("gir1t");
// `IsArray` abstract operation
// https://tc39.es/ecma262/#sec-isarray
// eslint-disable-next-line es/no-array-isarray -- safe
module.exports = Array.isArray || function isArray(argument) {
    return $gir1t(argument) == "Array";
};

});









parcelRequire.register("8R7xV", function(module, exports) {

var $d2Q2y = parcelRequire("d2Q2y");

var $64PSb = parcelRequire("64PSb");
function $67292077fc5b55f1$var$_iterableToArrayLimit(arr, i) {
    var _i = null == arr ? null : "undefined" != typeof $d2Q2y && $64PSb(arr) || arr["@@iterator"];
    if (null != _i) {
        var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1;
        try {
            if (_x = (_i = _i.call(arr)).next, 0 === i) {
                if (Object(_i) !== _i) return;
                _n = !1;
            } else for(; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
        } catch (err) {
            _d = !0, _e = err;
        } finally{
            try {
                if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return;
            } finally{
                if (_d) throw _e;
            }
        }
        return _arr;
    }
}
module.exports = $67292077fc5b55f1$var$_iterableToArrayLimit, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRequire.register("d2Q2y", function(module, exports) {

module.exports = (parcelRequire("5XC68"));

});
parcelRequire.register("5XC68", function(module, exports) {

module.exports = (parcelRequire("cdJiG"));

});
parcelRequire.register("cdJiG", function(module, exports) {

var $40D2Y = parcelRequire("40D2Y");
parcelRequire("agVYW");
parcelRequire("8IST6");
parcelRequire("jbEjZ");
parcelRequire("68qOE");
parcelRequire("1N8zF");
parcelRequire("49KZx");
parcelRequire("34LQT");
parcelRequire("3mV0C");
parcelRequire("1kgKV");
module.exports = $40D2Y;

});
parcelRequire.register("40D2Y", function(module, exports) {

var $V091A = parcelRequire("V091A");
parcelRequire("kuY3b");
module.exports = $V091A;

});
parcelRequire.register("V091A", function(module, exports) {

var $wmkBC = parcelRequire("wmkBC");
parcelRequire("a8ZHm");
module.exports = $wmkBC;

});
parcelRequire.register("wmkBC", function(module, exports) {
parcelRequire("ivmPy");
parcelRequire("evDrA");
parcelRequire("fkgpX");
parcelRequire("5bGz8");
parcelRequire("5PeJn");
parcelRequire("ag585");
parcelRequire("7yZwG");
parcelRequire("lhWJ7");
parcelRequire("klnFE");
parcelRequire("8IKGL");
parcelRequire("f5p5m");
parcelRequire("9NTCP");
parcelRequire("hSaAd");
parcelRequire("aIlZU");
parcelRequire("eMf7X");
parcelRequire("1Mz4D");
parcelRequire("da5hM");
parcelRequire("fMP2K");
parcelRequire("53Jre");
parcelRequire("aOnxa");

var $lahb7 = parcelRequire("lahb7");
module.exports = $lahb7.Symbol;

});
parcelRequire.register("ivmPy", function(module, exports) {
"use strict";

var $2iwSV = parcelRequire("2iwSV");

var $bSIUO = parcelRequire("bSIUO");

var $fnf29 = parcelRequire("fnf29");

var $2IxWL = parcelRequire("2IxWL");

var $h90HQ = parcelRequire("h90HQ");

var $f8kjp = parcelRequire("f8kjp");

var $a99UF = parcelRequire("a99UF");

var $dPMro = parcelRequire("dPMro");

var $9JW6X = parcelRequire("9JW6X");

var $ffyhk = parcelRequire("ffyhk");

var $jUcq5 = parcelRequire("jUcq5");

var $aPgVB = parcelRequire("aPgVB");
var $d78cd4e4995a18e5$var$IS_CONCAT_SPREADABLE = $jUcq5("isConcatSpreadable");
// We can't use this feature detection in V8 since it causes
// deoptimization and serious performance degradation
// https://github.com/zloirock/core-js/issues/679
var $d78cd4e4995a18e5$var$IS_CONCAT_SPREADABLE_SUPPORT = $aPgVB >= 51 || !$bSIUO(function() {
    var array = [];
    array[$d78cd4e4995a18e5$var$IS_CONCAT_SPREADABLE] = false;
    return array.concat()[0] !== array;
});
var $d78cd4e4995a18e5$var$isConcatSpreadable = function(O) {
    if (!$2IxWL(O)) return false;
    var spreadable = O[$d78cd4e4995a18e5$var$IS_CONCAT_SPREADABLE];
    return spreadable !== undefined ? !!spreadable : $fnf29(O);
};
var $d78cd4e4995a18e5$var$FORCED = !$d78cd4e4995a18e5$var$IS_CONCAT_SPREADABLE_SUPPORT || !$ffyhk("concat");
// `Array.prototype.concat` method
// https://tc39.es/ecma262/#sec-array.prototype.concat
// with adding support of @@isConcatSpreadable and @@species
$2iwSV({
    target: "Array",
    proto: true,
    arity: 1,
    forced: $d78cd4e4995a18e5$var$FORCED
}, {
    // eslint-disable-next-line no-unused-vars -- required for `.length`
    concat: function concat(arg) {
        var O = $h90HQ(this);
        var A = $9JW6X(O, 0);
        var n = 0;
        var i, k, length, len, E;
        for(i = -1, length = arguments.length; i < length; i++){
            E = i === -1 ? O : arguments[i];
            if ($d78cd4e4995a18e5$var$isConcatSpreadable(E)) {
                len = $f8kjp(E);
                $a99UF(n + len);
                for(k = 0; k < len; k++, n++)if (k in E) $dPMro(A, n, E[k]);
            } else {
                $a99UF(n + 1);
                $dPMro(A, n++, E);
            }
        }
        A.length = n;
        return A;
    }
});

});
parcelRequire.register("a99UF", function(module, exports) {
var $76326f22ec2ea601$var$$TypeError = TypeError;
var $76326f22ec2ea601$var$MAX_SAFE_INTEGER = 0x1FFFFFFFFFFFFF; // 2 ** 53 - 1 == 9007199254740991
module.exports = function(it) {
    if (it > $76326f22ec2ea601$var$MAX_SAFE_INTEGER) throw $76326f22ec2ea601$var$$TypeError("Maximum allowed index exceeded");
    return it;
};

});

parcelRequire.register("dPMro", function(module, exports) {
"use strict";

var $jdr5b = parcelRequire("jdr5b");

var $8wt5F = parcelRequire("8wt5F");

var $80p84 = parcelRequire("80p84");
module.exports = function(object, key, value) {
    var propertyKey = $jdr5b(key);
    if (propertyKey in object) $8wt5F.f(object, propertyKey, $80p84(0, value));
    else object[propertyKey] = value;
};

});

parcelRequire.register("9JW6X", function(module, exports) {

var $4HfHA = parcelRequire("4HfHA");
// `ArraySpeciesCreate` abstract operation
// https://tc39.es/ecma262/#sec-arrayspeciescreate
module.exports = function(originalArray, length) {
    return new ($4HfHA(originalArray))(length === 0 ? 0 : length);
};

});
parcelRequire.register("4HfHA", function(module, exports) {

var $fnf29 = parcelRequire("fnf29");

var $HaMz3 = parcelRequire("HaMz3");

var $2IxWL = parcelRequire("2IxWL");

var $jUcq5 = parcelRequire("jUcq5");
var $36b75ba887a4828a$var$SPECIES = $jUcq5("species");
var $36b75ba887a4828a$var$$Array = Array;
// a part of `ArraySpeciesCreate` abstract operation
// https://tc39.es/ecma262/#sec-arrayspeciescreate
module.exports = function(originalArray) {
    var C;
    if ($fnf29(originalArray)) {
        C = originalArray.constructor;
        // cross-realm fallback
        if ($HaMz3(C) && (C === $36b75ba887a4828a$var$$Array || $fnf29(C.prototype))) C = undefined;
        else if ($2IxWL(C)) {
            C = C[$36b75ba887a4828a$var$SPECIES];
            if (C === null) C = undefined;
        }
    }
    return C === undefined ? $36b75ba887a4828a$var$$Array : C;
};

});


parcelRequire.register("ffyhk", function(module, exports) {

var $bSIUO = parcelRequire("bSIUO");

var $jUcq5 = parcelRequire("jUcq5");

var $aPgVB = parcelRequire("aPgVB");
var $b1a2d8b9f7dd2e87$var$SPECIES = $jUcq5("species");
module.exports = function(METHOD_NAME) {
    // We can't use this feature detection in V8 since it causes
    // deoptimization and serious performance degradation
    // https://github.com/zloirock/core-js/issues/677
    return $aPgVB >= 51 || !$bSIUO(function() {
        var array = [];
        var constructor = array.constructor = {};
        constructor[$b1a2d8b9f7dd2e87$var$SPECIES] = function() {
            return {
                foo: 1
            };
        };
        return array[METHOD_NAME](Boolean).foo !== 1;
    });
};

});


parcelRequire.register("fkgpX", function(module, exports) {
// TODO: Remove this module from `core-js@4` since it's split to modules listed below
parcelRequire("jrsjf");
parcelRequire("4wqkP");
parcelRequire("lV1V3");
parcelRequire("ccNnm");
parcelRequire("1FCOF");

});
parcelRequire.register("jrsjf", function(module, exports) {
"use strict";

var $2iwSV = parcelRequire("2iwSV");

var $bbWQF = parcelRequire("bbWQF");

var $boD6Z = parcelRequire("boD6Z");

var $dqhay = parcelRequire("dqhay");

var $bRYhZ = parcelRequire("bRYhZ");

var $awFtp = parcelRequire("awFtp");

var $gLq14 = parcelRequire("gLq14");

var $bSIUO = parcelRequire("bSIUO");

var $dj4ij = parcelRequire("dj4ij");

var $53bMe = parcelRequire("53bMe");

var $3CMpt = parcelRequire("3CMpt");

var $gYLVQ = parcelRequire("gYLVQ");

var $jdr5b = parcelRequire("jdr5b");

var $elG1Y = parcelRequire("elG1Y");

var $80p84 = parcelRequire("80p84");

var $6m5Sk = parcelRequire("6m5Sk");

var $hQAxZ = parcelRequire("hQAxZ");

var $aTQ7d = parcelRequire("aTQ7d");

var $aiPMg = parcelRequire("aiPMg");

var $3R41N = parcelRequire("3R41N");

var $4cXMl = parcelRequire("4cXMl");

var $8wt5F = parcelRequire("8wt5F");

var $crfP8 = parcelRequire("crfP8");

var $fsYnl = parcelRequire("fsYnl");

var $hY10v = parcelRequire("hY10v");

var $9L6Pl = parcelRequire("9L6Pl");

var $hKCfh = parcelRequire("hKCfh");

var $grXcd = parcelRequire("grXcd");

var $aBDiK = parcelRequire("aBDiK");

var $kzqqN = parcelRequire("kzqqN");

var $jUcq5 = parcelRequire("jUcq5");

var $b5crT = parcelRequire("b5crT");

var $3EoHU = parcelRequire("3EoHU");

var $2ccSe = parcelRequire("2ccSe");

var $7dwMK = parcelRequire("7dwMK");

var $cDGcw = parcelRequire("cDGcw");

var $9e7Wd = parcelRequire("9e7Wd");
var $e2767f96d10c1fbc$require$$forEach = $9e7Wd.forEach;
var $e2767f96d10c1fbc$var$HIDDEN = $grXcd("hidden");
var $e2767f96d10c1fbc$var$SYMBOL = "Symbol";
var $e2767f96d10c1fbc$var$PROTOTYPE = "prototype";
var $e2767f96d10c1fbc$var$setInternalState = $cDGcw.set;
var $e2767f96d10c1fbc$var$getInternalState = $cDGcw.getterFor($e2767f96d10c1fbc$var$SYMBOL);
var $e2767f96d10c1fbc$var$ObjectPrototype = Object[$e2767f96d10c1fbc$var$PROTOTYPE];
var $e2767f96d10c1fbc$var$$Symbol = $bbWQF.Symbol;
var $e2767f96d10c1fbc$var$SymbolPrototype = $e2767f96d10c1fbc$var$$Symbol && $e2767f96d10c1fbc$var$$Symbol[$e2767f96d10c1fbc$var$PROTOTYPE];
var $e2767f96d10c1fbc$var$TypeError = $bbWQF.TypeError;
var $e2767f96d10c1fbc$var$QObject = $bbWQF.QObject;
var $e2767f96d10c1fbc$var$nativeGetOwnPropertyDescriptor = $4cXMl.f;
var $e2767f96d10c1fbc$var$nativeDefineProperty = $8wt5F.f;
var $e2767f96d10c1fbc$var$nativeGetOwnPropertyNames = $aiPMg.f;
var $e2767f96d10c1fbc$var$nativePropertyIsEnumerable = $fsYnl.f;
var $e2767f96d10c1fbc$var$push = $dqhay([].push);
var $e2767f96d10c1fbc$var$AllSymbols = $hKCfh("symbols");
var $e2767f96d10c1fbc$var$ObjectPrototypeSymbols = $hKCfh("op-symbols");
var $e2767f96d10c1fbc$var$WellKnownSymbolsStore = $hKCfh("wks");
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var $e2767f96d10c1fbc$var$USE_SETTER = !$e2767f96d10c1fbc$var$QObject || !$e2767f96d10c1fbc$var$QObject[$e2767f96d10c1fbc$var$PROTOTYPE] || !$e2767f96d10c1fbc$var$QObject[$e2767f96d10c1fbc$var$PROTOTYPE].findChild;
// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var $e2767f96d10c1fbc$var$setSymbolDescriptor = $awFtp && $bSIUO(function() {
    return $6m5Sk($e2767f96d10c1fbc$var$nativeDefineProperty({}, "a", {
        get: function() {
            return $e2767f96d10c1fbc$var$nativeDefineProperty(this, "a", {
                value: 7
            }).a;
        }
    })).a != 7;
}) ? function(O, P, Attributes) {
    var ObjectPrototypeDescriptor = $e2767f96d10c1fbc$var$nativeGetOwnPropertyDescriptor($e2767f96d10c1fbc$var$ObjectPrototype, P);
    if (ObjectPrototypeDescriptor) delete $e2767f96d10c1fbc$var$ObjectPrototype[P];
    $e2767f96d10c1fbc$var$nativeDefineProperty(O, P, Attributes);
    if (ObjectPrototypeDescriptor && O !== $e2767f96d10c1fbc$var$ObjectPrototype) $e2767f96d10c1fbc$var$nativeDefineProperty($e2767f96d10c1fbc$var$ObjectPrototype, P, ObjectPrototypeDescriptor);
} : $e2767f96d10c1fbc$var$nativeDefineProperty;
var $e2767f96d10c1fbc$var$wrap = function(tag, description) {
    var symbol = $e2767f96d10c1fbc$var$AllSymbols[tag] = $6m5Sk($e2767f96d10c1fbc$var$SymbolPrototype);
    $e2767f96d10c1fbc$var$setInternalState(symbol, {
        type: $e2767f96d10c1fbc$var$SYMBOL,
        tag: tag,
        description: description
    });
    if (!$awFtp) symbol.description = description;
    return symbol;
};
var $e2767f96d10c1fbc$var$$defineProperty = function defineProperty(O, P, Attributes) {
    if (O === $e2767f96d10c1fbc$var$ObjectPrototype) $e2767f96d10c1fbc$var$$defineProperty($e2767f96d10c1fbc$var$ObjectPrototypeSymbols, P, Attributes);
    $3CMpt(O);
    var key = $jdr5b(P);
    $3CMpt(Attributes);
    if ($dj4ij($e2767f96d10c1fbc$var$AllSymbols, key)) {
        if (!Attributes.enumerable) {
            if (!$dj4ij(O, $e2767f96d10c1fbc$var$HIDDEN)) $e2767f96d10c1fbc$var$nativeDefineProperty(O, $e2767f96d10c1fbc$var$HIDDEN, $80p84(1, {}));
            O[$e2767f96d10c1fbc$var$HIDDEN][key] = true;
        } else {
            if ($dj4ij(O, $e2767f96d10c1fbc$var$HIDDEN) && O[$e2767f96d10c1fbc$var$HIDDEN][key]) O[$e2767f96d10c1fbc$var$HIDDEN][key] = false;
            Attributes = $6m5Sk(Attributes, {
                enumerable: $80p84(0, false)
            });
        }
        return $e2767f96d10c1fbc$var$setSymbolDescriptor(O, key, Attributes);
    }
    return $e2767f96d10c1fbc$var$nativeDefineProperty(O, key, Attributes);
};
var $e2767f96d10c1fbc$var$$defineProperties = function defineProperties(O, Properties) {
    $3CMpt(O);
    var properties = $gYLVQ(Properties);
    var keys = $hQAxZ(properties).concat($e2767f96d10c1fbc$var$$getOwnPropertySymbols(properties));
    $e2767f96d10c1fbc$require$$forEach(keys, function(key) {
        if (!$awFtp || $boD6Z($e2767f96d10c1fbc$var$$propertyIsEnumerable, properties, key)) $e2767f96d10c1fbc$var$$defineProperty(O, key, properties[key]);
    });
    return O;
};
var $e2767f96d10c1fbc$var$$create = function create(O, Properties) {
    return Properties === undefined ? $6m5Sk(O) : $e2767f96d10c1fbc$var$$defineProperties($6m5Sk(O), Properties);
};
var $e2767f96d10c1fbc$var$$propertyIsEnumerable = function propertyIsEnumerable(V) {
    var P = $jdr5b(V);
    var enumerable = $boD6Z($e2767f96d10c1fbc$var$nativePropertyIsEnumerable, this, P);
    if (this === $e2767f96d10c1fbc$var$ObjectPrototype && $dj4ij($e2767f96d10c1fbc$var$AllSymbols, P) && !$dj4ij($e2767f96d10c1fbc$var$ObjectPrototypeSymbols, P)) return false;
    return enumerable || !$dj4ij(this, P) || !$dj4ij($e2767f96d10c1fbc$var$AllSymbols, P) || $dj4ij(this, $e2767f96d10c1fbc$var$HIDDEN) && this[$e2767f96d10c1fbc$var$HIDDEN][P] ? enumerable : true;
};
var $e2767f96d10c1fbc$var$$getOwnPropertyDescriptor = function getOwnPropertyDescriptor(O, P) {
    var it = $gYLVQ(O);
    var key = $jdr5b(P);
    if (it === $e2767f96d10c1fbc$var$ObjectPrototype && $dj4ij($e2767f96d10c1fbc$var$AllSymbols, key) && !$dj4ij($e2767f96d10c1fbc$var$ObjectPrototypeSymbols, key)) return;
    var descriptor = $e2767f96d10c1fbc$var$nativeGetOwnPropertyDescriptor(it, key);
    if (descriptor && $dj4ij($e2767f96d10c1fbc$var$AllSymbols, key) && !($dj4ij(it, $e2767f96d10c1fbc$var$HIDDEN) && it[$e2767f96d10c1fbc$var$HIDDEN][key])) descriptor.enumerable = true;
    return descriptor;
};
var $e2767f96d10c1fbc$var$$getOwnPropertyNames = function getOwnPropertyNames(O) {
    var names = $e2767f96d10c1fbc$var$nativeGetOwnPropertyNames($gYLVQ(O));
    var result = [];
    $e2767f96d10c1fbc$require$$forEach(names, function(key) {
        if (!$dj4ij($e2767f96d10c1fbc$var$AllSymbols, key) && !$dj4ij($aBDiK, key)) $e2767f96d10c1fbc$var$push(result, key);
    });
    return result;
};
var $e2767f96d10c1fbc$var$$getOwnPropertySymbols = function(O) {
    var IS_OBJECT_PROTOTYPE = O === $e2767f96d10c1fbc$var$ObjectPrototype;
    var names = $e2767f96d10c1fbc$var$nativeGetOwnPropertyNames(IS_OBJECT_PROTOTYPE ? $e2767f96d10c1fbc$var$ObjectPrototypeSymbols : $gYLVQ(O));
    var result = [];
    $e2767f96d10c1fbc$require$$forEach(names, function(key) {
        if ($dj4ij($e2767f96d10c1fbc$var$AllSymbols, key) && (!IS_OBJECT_PROTOTYPE || $dj4ij($e2767f96d10c1fbc$var$ObjectPrototype, key))) $e2767f96d10c1fbc$var$push(result, $e2767f96d10c1fbc$var$AllSymbols[key]);
    });
    return result;
};
// `Symbol` constructor
// https://tc39.es/ecma262/#sec-symbol-constructor
if (!$gLq14) {
    $e2767f96d10c1fbc$var$$Symbol = function Symbol() {
        if ($53bMe($e2767f96d10c1fbc$var$SymbolPrototype, this)) throw $e2767f96d10c1fbc$var$TypeError("Symbol is not a constructor");
        var description = !arguments.length || arguments[0] === undefined ? undefined : $elG1Y(arguments[0]);
        var tag = $kzqqN(description);
        var setter = function(value) {
            if (this === $e2767f96d10c1fbc$var$ObjectPrototype) $boD6Z(setter, $e2767f96d10c1fbc$var$ObjectPrototypeSymbols, value);
            if ($dj4ij(this, $e2767f96d10c1fbc$var$HIDDEN) && $dj4ij(this[$e2767f96d10c1fbc$var$HIDDEN], tag)) this[$e2767f96d10c1fbc$var$HIDDEN][tag] = false;
            $e2767f96d10c1fbc$var$setSymbolDescriptor(this, tag, $80p84(1, value));
        };
        if ($awFtp && $e2767f96d10c1fbc$var$USE_SETTER) $e2767f96d10c1fbc$var$setSymbolDescriptor($e2767f96d10c1fbc$var$ObjectPrototype, tag, {
            configurable: true,
            set: setter
        });
        return $e2767f96d10c1fbc$var$wrap(tag, description);
    };
    $e2767f96d10c1fbc$var$SymbolPrototype = $e2767f96d10c1fbc$var$$Symbol[$e2767f96d10c1fbc$var$PROTOTYPE];
    $hY10v($e2767f96d10c1fbc$var$SymbolPrototype, "toString", function toString() {
        return $e2767f96d10c1fbc$var$getInternalState(this).tag;
    });
    $hY10v($e2767f96d10c1fbc$var$$Symbol, "withoutSetter", function(description) {
        return $e2767f96d10c1fbc$var$wrap($kzqqN(description), description);
    });
    $fsYnl.f = $e2767f96d10c1fbc$var$$propertyIsEnumerable;
    $8wt5F.f = $e2767f96d10c1fbc$var$$defineProperty;
    $crfP8.f = $e2767f96d10c1fbc$var$$defineProperties;
    $4cXMl.f = $e2767f96d10c1fbc$var$$getOwnPropertyDescriptor;
    $aTQ7d.f = $aiPMg.f = $e2767f96d10c1fbc$var$$getOwnPropertyNames;
    $3R41N.f = $e2767f96d10c1fbc$var$$getOwnPropertySymbols;
    $b5crT.f = function(name) {
        return $e2767f96d10c1fbc$var$wrap($jUcq5(name), name);
    };
    if ($awFtp) {
        // https://github.com/tc39/proposal-Symbol-description
        $9L6Pl($e2767f96d10c1fbc$var$SymbolPrototype, "description", {
            configurable: true,
            get: function description() {
                return $e2767f96d10c1fbc$var$getInternalState(this).description;
            }
        });
        if (!$bRYhZ) $hY10v($e2767f96d10c1fbc$var$ObjectPrototype, "propertyIsEnumerable", $e2767f96d10c1fbc$var$$propertyIsEnumerable, {
            unsafe: true
        });
    }
}
$2iwSV({
    global: true,
    constructor: true,
    wrap: true,
    forced: !$gLq14,
    sham: !$gLq14
}, {
    Symbol: $e2767f96d10c1fbc$var$$Symbol
});
$e2767f96d10c1fbc$require$$forEach($hQAxZ($e2767f96d10c1fbc$var$WellKnownSymbolsStore), function(name) {
    $3EoHU(name);
});
$2iwSV({
    target: $e2767f96d10c1fbc$var$SYMBOL,
    stat: true,
    forced: !$gLq14
}, {
    useSetter: function() {
        $e2767f96d10c1fbc$var$USE_SETTER = true;
    },
    useSimple: function() {
        $e2767f96d10c1fbc$var$USE_SETTER = false;
    }
});
$2iwSV({
    target: "Object",
    stat: true,
    forced: !$gLq14,
    sham: !$awFtp
}, {
    // `Object.create` method
    // https://tc39.es/ecma262/#sec-object.create
    create: $e2767f96d10c1fbc$var$$create,
    // `Object.defineProperty` method
    // https://tc39.es/ecma262/#sec-object.defineproperty
    defineProperty: $e2767f96d10c1fbc$var$$defineProperty,
    // `Object.defineProperties` method
    // https://tc39.es/ecma262/#sec-object.defineproperties
    defineProperties: $e2767f96d10c1fbc$var$$defineProperties,
    // `Object.getOwnPropertyDescriptor` method
    // https://tc39.es/ecma262/#sec-object.getownpropertydescriptors
    getOwnPropertyDescriptor: $e2767f96d10c1fbc$var$$getOwnPropertyDescriptor
});
$2iwSV({
    target: "Object",
    stat: true,
    forced: !$gLq14
}, {
    // `Object.getOwnPropertyNames` method
    // https://tc39.es/ecma262/#sec-object.getownpropertynames
    getOwnPropertyNames: $e2767f96d10c1fbc$var$$getOwnPropertyNames
});
// `Symbol.prototype[@@toPrimitive]` method
// https://tc39.es/ecma262/#sec-symbol.prototype-@@toprimitive
$2ccSe();
// `Symbol.prototype[@@toStringTag]` property
// https://tc39.es/ecma262/#sec-symbol.prototype-@@tostringtag
$7dwMK($e2767f96d10c1fbc$var$$Symbol, $e2767f96d10c1fbc$var$SYMBOL);
$aBDiK[$e2767f96d10c1fbc$var$HIDDEN] = true;

});
parcelRequire.register("aiPMg", function(module, exports) {

$parcel$export(module.exports, "f", () => $7803bfbe9f886ff0$export$2d1720544b23b823, (v) => $7803bfbe9f886ff0$export$2d1720544b23b823 = v);
/* eslint-disable es/no-object-getownpropertynames -- safe */ // fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var $7803bfbe9f886ff0$export$2d1720544b23b823;

var $gir1t = parcelRequire("gir1t");

var $gYLVQ = parcelRequire("gYLVQ");

var $aTQ7d = parcelRequire("aTQ7d");
var $7803bfbe9f886ff0$require$$getOwnPropertyNames = $aTQ7d.f;

var $jeZk0 = parcelRequire("jeZk0");
var $7803bfbe9f886ff0$var$windowNames = typeof window == "object" && window && Object.getOwnPropertyNames ? Object.getOwnPropertyNames(window) : [];
var $7803bfbe9f886ff0$var$getWindowNames = function(it) {
    try {
        return $7803bfbe9f886ff0$require$$getOwnPropertyNames(it);
    } catch (error) {
        return $jeZk0($7803bfbe9f886ff0$var$windowNames);
    }
};
$7803bfbe9f886ff0$export$2d1720544b23b823 = function getOwnPropertyNames(it) {
    return $7803bfbe9f886ff0$var$windowNames && $gir1t(it) == "Window" ? $7803bfbe9f886ff0$var$getWindowNames(it) : $7803bfbe9f886ff0$require$$getOwnPropertyNames($gYLVQ(it));
};

});
parcelRequire.register("jeZk0", function(module, exports) {

var $98Q42 = parcelRequire("98Q42");

var $f8kjp = parcelRequire("f8kjp");

var $dPMro = parcelRequire("dPMro");
var $e01ee4528d9a7361$var$$Array = Array;
var $e01ee4528d9a7361$var$max = Math.max;
module.exports = function(O, start, end) {
    var length = $f8kjp(O);
    var k = $98Q42(start, length);
    var fin = $98Q42(end === undefined ? length : end, length);
    var result = $e01ee4528d9a7361$var$$Array($e01ee4528d9a7361$var$max(fin - k, 0));
    for(var n = 0; k < fin; k++, n++)$dPMro(result, n, O[k]);
    result.length = n;
    return result;
};

});


parcelRequire.register("b5crT", function(module, exports) {

$parcel$export(module.exports, "f", () => $8119d1705020e18c$export$2d1720544b23b823, (v) => $8119d1705020e18c$export$2d1720544b23b823 = v);
var $8119d1705020e18c$export$2d1720544b23b823;

var $jUcq5 = parcelRequire("jUcq5");
$8119d1705020e18c$export$2d1720544b23b823 = $jUcq5;

});

parcelRequire.register("3EoHU", function(module, exports) {

var $lahb7 = parcelRequire("lahb7");

var $dj4ij = parcelRequire("dj4ij");

var $b5crT = parcelRequire("b5crT");

var $8wt5F = parcelRequire("8wt5F");
var $2a8845e2a1fc4d7a$require$defineProperty = $8wt5F.f;
module.exports = function(NAME) {
    var Symbol = $lahb7.Symbol || ($lahb7.Symbol = {});
    if (!$dj4ij(Symbol, NAME)) $2a8845e2a1fc4d7a$require$defineProperty(Symbol, NAME, {
        value: $b5crT.f(NAME)
    });
};

});

parcelRequire.register("2ccSe", function(module, exports) {

var $boD6Z = parcelRequire("boD6Z");

var $7J5vx = parcelRequire("7J5vx");

var $jUcq5 = parcelRequire("jUcq5");

var $hY10v = parcelRequire("hY10v");
module.exports = function() {
    var Symbol = $7J5vx("Symbol");
    var SymbolPrototype = Symbol && Symbol.prototype;
    var valueOf = SymbolPrototype && SymbolPrototype.valueOf;
    var TO_PRIMITIVE = $jUcq5("toPrimitive");
    if (SymbolPrototype && !SymbolPrototype[TO_PRIMITIVE]) // `Symbol.prototype[@@toPrimitive]` method
    // https://tc39.es/ecma262/#sec-symbol.prototype-@@toprimitive
    // eslint-disable-next-line no-unused-vars -- required for .length
    $hY10v(SymbolPrototype, TO_PRIMITIVE, function(hint) {
        return $boD6Z(valueOf, this);
    }, {
        arity: 1
    });
};

});

parcelRequire.register("9e7Wd", function(module, exports) {

var $jjTxh = parcelRequire("jjTxh");

var $dqhay = parcelRequire("dqhay");

var $letw9 = parcelRequire("letw9");

var $h90HQ = parcelRequire("h90HQ");

var $f8kjp = parcelRequire("f8kjp");

var $9JW6X = parcelRequire("9JW6X");
var $6b7b942ecdb1d50e$var$push = $dqhay([].push);
// `Array.prototype.{ forEach, map, filter, some, every, find, findIndex, filterReject }` methods implementation
var $6b7b942ecdb1d50e$var$createMethod = function(TYPE) {
    var IS_MAP = TYPE == 1;
    var IS_FILTER = TYPE == 2;
    var IS_SOME = TYPE == 3;
    var IS_EVERY = TYPE == 4;
    var IS_FIND_INDEX = TYPE == 6;
    var IS_FILTER_REJECT = TYPE == 7;
    var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
    return function($this, callbackfn, that, specificCreate) {
        var O = $h90HQ($this);
        var self = $letw9(O);
        var boundFunction = $jjTxh(callbackfn, that);
        var length = $f8kjp(self);
        var index = 0;
        var create = specificCreate || $9JW6X;
        var target = IS_MAP ? create($this, length) : IS_FILTER || IS_FILTER_REJECT ? create($this, 0) : undefined;
        var value, result;
        for(; length > index; index++)if (NO_HOLES || index in self) {
            value = self[index];
            result = boundFunction(value, index, O);
            if (TYPE) {
                if (IS_MAP) target[index] = result; // map
                else if (result) switch(TYPE){
                    case 3:
                        return true; // some
                    case 5:
                        return value; // find
                    case 6:
                        return index; // findIndex
                    case 2:
                        $6b7b942ecdb1d50e$var$push(target, value); // filter
                }
                else switch(TYPE){
                    case 4:
                        return false; // every
                    case 7:
                        $6b7b942ecdb1d50e$var$push(target, value); // filterReject
                }
            }
        }
        return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : target;
    };
};
module.exports = {
    // `Array.prototype.forEach` method
    // https://tc39.es/ecma262/#sec-array.prototype.foreach
    forEach: $6b7b942ecdb1d50e$var$createMethod(0),
    // `Array.prototype.map` method
    // https://tc39.es/ecma262/#sec-array.prototype.map
    map: $6b7b942ecdb1d50e$var$createMethod(1),
    // `Array.prototype.filter` method
    // https://tc39.es/ecma262/#sec-array.prototype.filter
    filter: $6b7b942ecdb1d50e$var$createMethod(2),
    // `Array.prototype.some` method
    // https://tc39.es/ecma262/#sec-array.prototype.some
    some: $6b7b942ecdb1d50e$var$createMethod(3),
    // `Array.prototype.every` method
    // https://tc39.es/ecma262/#sec-array.prototype.every
    every: $6b7b942ecdb1d50e$var$createMethod(4),
    // `Array.prototype.find` method
    // https://tc39.es/ecma262/#sec-array.prototype.find
    find: $6b7b942ecdb1d50e$var$createMethod(5),
    // `Array.prototype.findIndex` method
    // https://tc39.es/ecma262/#sec-array.prototype.findIndex
    findIndex: $6b7b942ecdb1d50e$var$createMethod(6),
    // `Array.prototype.filterReject` method
    // https://github.com/tc39/proposal-array-filtering
    filterReject: $6b7b942ecdb1d50e$var$createMethod(7)
};

});


parcelRequire.register("4wqkP", function(module, exports) {

var $2iwSV = parcelRequire("2iwSV");

var $7J5vx = parcelRequire("7J5vx");

var $dj4ij = parcelRequire("dj4ij");

var $elG1Y = parcelRequire("elG1Y");

var $hKCfh = parcelRequire("hKCfh");

var $fHwWz = parcelRequire("fHwWz");
var $34ae942293f67b98$var$StringToSymbolRegistry = $hKCfh("string-to-symbol-registry");
var $34ae942293f67b98$var$SymbolToStringRegistry = $hKCfh("symbol-to-string-registry");
// `Symbol.for` method
// https://tc39.es/ecma262/#sec-symbol.for
$2iwSV({
    target: "Symbol",
    stat: true,
    forced: !$fHwWz
}, {
    "for": function(key) {
        var string = $elG1Y(key);
        if ($dj4ij($34ae942293f67b98$var$StringToSymbolRegistry, string)) return $34ae942293f67b98$var$StringToSymbolRegistry[string];
        var symbol = $7J5vx("Symbol")(string);
        $34ae942293f67b98$var$StringToSymbolRegistry[string] = symbol;
        $34ae942293f67b98$var$SymbolToStringRegistry[symbol] = string;
        return symbol;
    }
});

});
parcelRequire.register("fHwWz", function(module, exports) {

var $gLq14 = parcelRequire("gLq14");
/* eslint-disable es/no-symbol -- safe */ module.exports = $gLq14 && !!Symbol["for"] && !!Symbol.keyFor;

});


parcelRequire.register("lV1V3", function(module, exports) {

var $2iwSV = parcelRequire("2iwSV");

var $dj4ij = parcelRequire("dj4ij");

var $6MMdo = parcelRequire("6MMdo");

var $ieZRC = parcelRequire("ieZRC");

var $hKCfh = parcelRequire("hKCfh");

var $fHwWz = parcelRequire("fHwWz");
var $ff5068f1ad320b71$var$SymbolToStringRegistry = $hKCfh("symbol-to-string-registry");
// `Symbol.keyFor` method
// https://tc39.es/ecma262/#sec-symbol.keyfor
$2iwSV({
    target: "Symbol",
    stat: true,
    forced: !$fHwWz
}, {
    keyFor: function keyFor(sym) {
        if (!$6MMdo(sym)) throw TypeError($ieZRC(sym) + " is not a symbol");
        if ($dj4ij($ff5068f1ad320b71$var$SymbolToStringRegistry, sym)) return $ff5068f1ad320b71$var$SymbolToStringRegistry[sym];
    }
});

});

parcelRequire.register("ccNnm", function(module, exports) {

var $2iwSV = parcelRequire("2iwSV");

var $7J5vx = parcelRequire("7J5vx");

var $9ujZx = parcelRequire("9ujZx");

var $boD6Z = parcelRequire("boD6Z");

var $dqhay = parcelRequire("dqhay");

var $bSIUO = parcelRequire("bSIUO");

var $g0TxJ = parcelRequire("g0TxJ");

var $6MMdo = parcelRequire("6MMdo");

var $iEWV5 = parcelRequire("iEWV5");

var $kgfZW = parcelRequire("kgfZW");

var $gLq14 = parcelRequire("gLq14");
var $8e2ce805ab0061ae$var$$String = String;
var $8e2ce805ab0061ae$var$$stringify = $7J5vx("JSON", "stringify");
var $8e2ce805ab0061ae$var$exec = $dqhay(/./.exec);
var $8e2ce805ab0061ae$var$charAt = $dqhay("".charAt);
var $8e2ce805ab0061ae$var$charCodeAt = $dqhay("".charCodeAt);
var $8e2ce805ab0061ae$var$replace = $dqhay("".replace);
var $8e2ce805ab0061ae$var$numberToString = $dqhay(1.0.toString);
var $8e2ce805ab0061ae$var$tester = /[\uD800-\uDFFF]/g;
var $8e2ce805ab0061ae$var$low = /^[\uD800-\uDBFF]$/;
var $8e2ce805ab0061ae$var$hi = /^[\uDC00-\uDFFF]$/;
var $8e2ce805ab0061ae$var$WRONG_SYMBOLS_CONVERSION = !$gLq14 || $bSIUO(function() {
    var symbol = $7J5vx("Symbol")();
    // MS Edge converts symbol values to JSON as {}
    return $8e2ce805ab0061ae$var$$stringify([
        symbol
    ]) != "[null]" || $8e2ce805ab0061ae$var$$stringify({
        a: symbol
    }) != "{}" || $8e2ce805ab0061ae$var$$stringify(Object(symbol)) != "{}";
});
// https://github.com/tc39/proposal-well-formed-stringify
var $8e2ce805ab0061ae$var$ILL_FORMED_UNICODE = $bSIUO(function() {
    return $8e2ce805ab0061ae$var$$stringify("\uDF06\uD834") !== '"\udf06\ud834"' || $8e2ce805ab0061ae$var$$stringify("\uDEAD") !== '"\udead"';
});
var $8e2ce805ab0061ae$var$stringifyWithSymbolsFix = function(it, replacer) {
    var args = $iEWV5(arguments);
    var $replacer = $kgfZW(replacer);
    if (!$g0TxJ($replacer) && (it === undefined || $6MMdo(it))) return; // IE8 returns string on undefined
    args[1] = function(key, value) {
        // some old implementations (like WebKit) could pass numbers as keys
        if ($g0TxJ($replacer)) value = $boD6Z($replacer, this, $8e2ce805ab0061ae$var$$String(key), value);
        if (!$6MMdo(value)) return value;
    };
    return $9ujZx($8e2ce805ab0061ae$var$$stringify, null, args);
};
var $8e2ce805ab0061ae$var$fixIllFormed = function(match, offset, string) {
    var prev = $8e2ce805ab0061ae$var$charAt(string, offset - 1);
    var next = $8e2ce805ab0061ae$var$charAt(string, offset + 1);
    if ($8e2ce805ab0061ae$var$exec($8e2ce805ab0061ae$var$low, match) && !$8e2ce805ab0061ae$var$exec($8e2ce805ab0061ae$var$hi, next) || $8e2ce805ab0061ae$var$exec($8e2ce805ab0061ae$var$hi, match) && !$8e2ce805ab0061ae$var$exec($8e2ce805ab0061ae$var$low, prev)) return "\\u" + $8e2ce805ab0061ae$var$numberToString($8e2ce805ab0061ae$var$charCodeAt(match, 0), 16);
    return match;
};
if ($8e2ce805ab0061ae$var$$stringify) // `JSON.stringify` method
// https://tc39.es/ecma262/#sec-json.stringify
$2iwSV({
    target: "JSON",
    stat: true,
    arity: 3,
    forced: $8e2ce805ab0061ae$var$WRONG_SYMBOLS_CONVERSION || $8e2ce805ab0061ae$var$ILL_FORMED_UNICODE
}, {
    // eslint-disable-next-line no-unused-vars -- required for `.length`
    stringify: function stringify(it, replacer, space) {
        var args = $iEWV5(arguments);
        var result = $9ujZx($8e2ce805ab0061ae$var$WRONG_SYMBOLS_CONVERSION ? $8e2ce805ab0061ae$var$stringifyWithSymbolsFix : $8e2ce805ab0061ae$var$$stringify, null, args);
        return $8e2ce805ab0061ae$var$ILL_FORMED_UNICODE && typeof result == "string" ? $8e2ce805ab0061ae$var$replace(result, $8e2ce805ab0061ae$var$tester, $8e2ce805ab0061ae$var$fixIllFormed) : result;
    }
});

});
parcelRequire.register("kgfZW", function(module, exports) {

var $dqhay = parcelRequire("dqhay");

var $fnf29 = parcelRequire("fnf29");

var $g0TxJ = parcelRequire("g0TxJ");

var $gir1t = parcelRequire("gir1t");

var $elG1Y = parcelRequire("elG1Y");
var $ec01b6298aca6acf$var$push = $dqhay([].push);
module.exports = function(replacer) {
    if ($g0TxJ(replacer)) return replacer;
    if (!$fnf29(replacer)) return;
    var rawLength = replacer.length;
    var keys = [];
    for(var i = 0; i < rawLength; i++){
        var element = replacer[i];
        if (typeof element == "string") $ec01b6298aca6acf$var$push(keys, element);
        else if (typeof element == "number" || $gir1t(element) == "Number" || $gir1t(element) == "String") $ec01b6298aca6acf$var$push(keys, $elG1Y(element));
    }
    var keysLength = keys.length;
    var root = true;
    return function(key, value) {
        if (root) {
            root = false;
            return value;
        }
        if ($fnf29(this)) return value;
        for(var j = 0; j < keysLength; j++)if (keys[j] === key) return value;
    };
};

});


parcelRequire.register("1FCOF", function(module, exports) {

var $2iwSV = parcelRequire("2iwSV");

var $gLq14 = parcelRequire("gLq14");

var $bSIUO = parcelRequire("bSIUO");

var $3R41N = parcelRequire("3R41N");

var $h90HQ = parcelRequire("h90HQ");
// V8 ~ Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
// https://bugs.chromium.org/p/v8/issues/detail?id=3443
var $1377badc6c6b2ff8$var$FORCED = !$gLq14 || $bSIUO(function() {
    $3R41N.f(1);
});
// `Object.getOwnPropertySymbols` method
// https://tc39.es/ecma262/#sec-object.getownpropertysymbols
$2iwSV({
    target: "Object",
    stat: true,
    forced: $1377badc6c6b2ff8$var$FORCED
}, {
    getOwnPropertySymbols: function getOwnPropertySymbols(it) {
        var $getOwnPropertySymbols = $3R41N.f;
        return $getOwnPropertySymbols ? $getOwnPropertySymbols($h90HQ(it)) : [];
    }
});

});


parcelRequire.register("5bGz8", function(module, exports) {

var $3EoHU = parcelRequire("3EoHU");
// `Symbol.asyncIterator` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.asynciterator
$3EoHU("asyncIterator");

});

parcelRequire.register("5PeJn", function(module, exports) {
// empty

});

parcelRequire.register("ag585", function(module, exports) {

var $3EoHU = parcelRequire("3EoHU");
// `Symbol.hasInstance` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.hasinstance
$3EoHU("hasInstance");

});

parcelRequire.register("7yZwG", function(module, exports) {

var $3EoHU = parcelRequire("3EoHU");
// `Symbol.isConcatSpreadable` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.isconcatspreadable
$3EoHU("isConcatSpreadable");

});

parcelRequire.register("lhWJ7", function(module, exports) {

var $3EoHU = parcelRequire("3EoHU");
// `Symbol.iterator` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.iterator
$3EoHU("iterator");

});

parcelRequire.register("klnFE", function(module, exports) {

var $3EoHU = parcelRequire("3EoHU");
// `Symbol.match` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.match
$3EoHU("match");

});

parcelRequire.register("8IKGL", function(module, exports) {

var $3EoHU = parcelRequire("3EoHU");
// `Symbol.matchAll` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.matchall
$3EoHU("matchAll");

});

parcelRequire.register("f5p5m", function(module, exports) {

var $3EoHU = parcelRequire("3EoHU");
// `Symbol.replace` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.replace
$3EoHU("replace");

});

parcelRequire.register("9NTCP", function(module, exports) {

var $3EoHU = parcelRequire("3EoHU");
// `Symbol.search` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.search
$3EoHU("search");

});

parcelRequire.register("hSaAd", function(module, exports) {

var $3EoHU = parcelRequire("3EoHU");
// `Symbol.species` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.species
$3EoHU("species");

});

parcelRequire.register("aIlZU", function(module, exports) {

var $3EoHU = parcelRequire("3EoHU");
// `Symbol.split` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.split
$3EoHU("split");

});

parcelRequire.register("eMf7X", function(module, exports) {

var $3EoHU = parcelRequire("3EoHU");

var $2ccSe = parcelRequire("2ccSe");
// `Symbol.toPrimitive` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.toprimitive
$3EoHU("toPrimitive");
// `Symbol.prototype[@@toPrimitive]` method
// https://tc39.es/ecma262/#sec-symbol.prototype-@@toprimitive
$2ccSe();

});

parcelRequire.register("1Mz4D", function(module, exports) {

var $7J5vx = parcelRequire("7J5vx");

var $3EoHU = parcelRequire("3EoHU");

var $7dwMK = parcelRequire("7dwMK");
// `Symbol.toStringTag` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.tostringtag
$3EoHU("toStringTag");
// `Symbol.prototype[@@toStringTag]` property
// https://tc39.es/ecma262/#sec-symbol.prototype-@@tostringtag
$7dwMK($7J5vx("Symbol"), "Symbol");

});

parcelRequire.register("da5hM", function(module, exports) {

var $3EoHU = parcelRequire("3EoHU");
// `Symbol.unscopables` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.unscopables
$3EoHU("unscopables");

});

parcelRequire.register("fMP2K", function(module, exports) {

var $bbWQF = parcelRequire("bbWQF");

var $7dwMK = parcelRequire("7dwMK");
// JSON[@@toStringTag] property
// https://tc39.es/ecma262/#sec-json-@@tostringtag
$7dwMK($bbWQF.JSON, "JSON", true);

});

parcelRequire.register("53Jre", function(module, exports) {
// empty

});

parcelRequire.register("aOnxa", function(module, exports) {
// empty

});



parcelRequire.register("kuY3b", function(module, exports) {

var $3EoHU = parcelRequire("3EoHU");
// `Symbol.dispose` well-known symbol
// https://github.com/tc39/proposal-explicit-resource-management
$3EoHU("dispose");

});


parcelRequire.register("agVYW", function(module, exports) {

var $3EoHU = parcelRequire("3EoHU");
// `Symbol.asyncDispose` well-known symbol
// https://github.com/tc39/proposal-async-explicit-resource-management
$3EoHU("asyncDispose");

});

parcelRequire.register("8IST6", function(module, exports) {

var $2iwSV = parcelRequire("2iwSV");

var $7J5vx = parcelRequire("7J5vx");

var $dqhay = parcelRequire("dqhay");
var $659d025ac6d54c03$var$Symbol = $7J5vx("Symbol");
var $659d025ac6d54c03$var$keyFor = $659d025ac6d54c03$var$Symbol.keyFor;
var $659d025ac6d54c03$var$thisSymbolValue = $dqhay($659d025ac6d54c03$var$Symbol.prototype.valueOf);
// `Symbol.isRegistered` method
// https://tc39.es/proposal-symbol-predicates/#sec-symbol-isregistered
$2iwSV({
    target: "Symbol",
    stat: true
}, {
    isRegistered: function isRegistered(value) {
        try {
            return $659d025ac6d54c03$var$keyFor($659d025ac6d54c03$var$thisSymbolValue(value)) !== undefined;
        } catch (error) {
            return false;
        }
    }
});

});

parcelRequire.register("jbEjZ", function(module, exports) {

var $2iwSV = parcelRequire("2iwSV");

var $hKCfh = parcelRequire("hKCfh");

var $7J5vx = parcelRequire("7J5vx");

var $dqhay = parcelRequire("dqhay");

var $6MMdo = parcelRequire("6MMdo");

var $jUcq5 = parcelRequire("jUcq5");
var $df7e5266941bbfb5$var$Symbol = $7J5vx("Symbol");
var $df7e5266941bbfb5$var$$isWellKnown = $df7e5266941bbfb5$var$Symbol.isWellKnown;
var $df7e5266941bbfb5$var$getOwnPropertyNames = $7J5vx("Object", "getOwnPropertyNames");
var $df7e5266941bbfb5$var$thisSymbolValue = $dqhay($df7e5266941bbfb5$var$Symbol.prototype.valueOf);
var $df7e5266941bbfb5$var$WellKnownSymbolsStore = $hKCfh("wks");
for(var $df7e5266941bbfb5$var$i = 0, $df7e5266941bbfb5$var$symbolKeys = $df7e5266941bbfb5$var$getOwnPropertyNames($df7e5266941bbfb5$var$Symbol), $df7e5266941bbfb5$var$symbolKeysLength = $df7e5266941bbfb5$var$symbolKeys.length; $df7e5266941bbfb5$var$i < $df7e5266941bbfb5$var$symbolKeysLength; $df7e5266941bbfb5$var$i++)// some old engines throws on access to some keys like `arguments` or `caller`
try {
    var $df7e5266941bbfb5$var$symbolKey = $df7e5266941bbfb5$var$symbolKeys[$df7e5266941bbfb5$var$i];
    if ($6MMdo($df7e5266941bbfb5$var$Symbol[$df7e5266941bbfb5$var$symbolKey])) $jUcq5($df7e5266941bbfb5$var$symbolKey);
} catch (error) {}
// `Symbol.isWellKnown` method
// https://tc39.es/proposal-symbol-predicates/#sec-symbol-iswellknown
// We should patch it for newly added well-known symbols. If it's not required, this module just will not be injected
$2iwSV({
    target: "Symbol",
    stat: true,
    forced: true
}, {
    isWellKnown: function isWellKnown(value) {
        if ($df7e5266941bbfb5$var$$isWellKnown && $df7e5266941bbfb5$var$$isWellKnown(value)) return true;
        try {
            var symbol = $df7e5266941bbfb5$var$thisSymbolValue(value);
            for(var j = 0, keys = $df7e5266941bbfb5$var$getOwnPropertyNames($df7e5266941bbfb5$var$WellKnownSymbolsStore), keysLength = keys.length; j < keysLength; j++){
                if ($df7e5266941bbfb5$var$WellKnownSymbolsStore[keys[j]] == symbol) return true;
            }
        } catch (error) {}
        return false;
    }
});

});

parcelRequire.register("68qOE", function(module, exports) {

var $3EoHU = parcelRequire("3EoHU");
// `Symbol.matcher` well-known symbol
// https://github.com/tc39/proposal-pattern-matching
$3EoHU("matcher");

});

parcelRequire.register("1N8zF", function(module, exports) {

var $3EoHU = parcelRequire("3EoHU");
// `Symbol.metadataKey` well-known symbol
// https://github.com/tc39/proposal-decorator-metadata
$3EoHU("metadataKey");

});

parcelRequire.register("49KZx", function(module, exports) {

var $3EoHU = parcelRequire("3EoHU");
// `Symbol.observable` well-known symbol
// https://github.com/tc39/proposal-observable
$3EoHU("observable");

});

parcelRequire.register("34LQT", function(module, exports) {
// TODO: Remove from `core-js@4`

var $3EoHU = parcelRequire("3EoHU");
// `Symbol.metadata` well-known symbol
// https://github.com/tc39/proposal-decorators
$3EoHU("metadata");

});

parcelRequire.register("3mV0C", function(module, exports) {
// TODO: remove from `core-js@4`

var $3EoHU = parcelRequire("3EoHU");
// `Symbol.patternMatch` well-known symbol
// https://github.com/tc39/proposal-pattern-matching
$3EoHU("patternMatch");

});

parcelRequire.register("1kgKV", function(module, exports) {
// TODO: remove from `core-js@4`

var $3EoHU = parcelRequire("3EoHU");
$3EoHU("replaceAll");

});




parcelRequire.register("64PSb", function(module, exports) {

module.exports = (parcelRequire("aoWGW"));

});
parcelRequire.register("aoWGW", function(module, exports) {

module.exports = (parcelRequire("85mvA"));

});
parcelRequire.register("85mvA", function(module, exports) {

var $MEtAG = parcelRequire("MEtAG");
module.exports = $MEtAG;

});
parcelRequire.register("MEtAG", function(module, exports) {

var $aJaHU = parcelRequire("aJaHU");
module.exports = $aJaHU;

});
parcelRequire.register("aJaHU", function(module, exports) {

var $btDvm = parcelRequire("btDvm");
parcelRequire("a8ZHm");
module.exports = $btDvm;

});
parcelRequire.register("btDvm", function(module, exports) {
parcelRequire("7V1Sz");
parcelRequire("vGpAn");

var $4ARxr = parcelRequire("4ARxr");
module.exports = $4ARxr;

});







parcelRequire.register("eg03m", function(module, exports) {

var $544fY = parcelRequire("544fY");

var $8fviW = parcelRequire("8fviW");

var $5SgwI = parcelRequire("5SgwI");
function $a61299dd249ecfdc$var$_unsupportedIterableToArray(o, minLen) {
    var _context;
    if (!o) return;
    if (typeof o === "string") return $5SgwI(o, minLen);
    var n = $544fY(_context = Object.prototype.toString.call(o)).call(_context, 8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return $8fviW(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $5SgwI(o, minLen);
}
module.exports = $a61299dd249ecfdc$var$_unsupportedIterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRequire.register("544fY", function(module, exports) {

module.exports = (parcelRequire("jvWcZ"));

});
parcelRequire.register("jvWcZ", function(module, exports) {

module.exports = (parcelRequire("1gMBt"));

});
parcelRequire.register("1gMBt", function(module, exports) {

var $6BWLp = parcelRequire("6BWLp");
module.exports = $6BWLp;

});
parcelRequire.register("6BWLp", function(module, exports) {

var $aqKUS = parcelRequire("aqKUS");
module.exports = $aqKUS;

});
parcelRequire.register("aqKUS", function(module, exports) {

var $hSeMH = parcelRequire("hSeMH");
module.exports = $hSeMH;

});
parcelRequire.register("hSeMH", function(module, exports) {

var $53bMe = parcelRequire("53bMe");

var $l6o8a = parcelRequire("l6o8a");
var $d032f2b9af3f80e7$var$ArrayPrototype = Array.prototype;
module.exports = function(it) {
    var own = it.slice;
    return it === $d032f2b9af3f80e7$var$ArrayPrototype || $53bMe($d032f2b9af3f80e7$var$ArrayPrototype, it) && own === $d032f2b9af3f80e7$var$ArrayPrototype.slice ? $l6o8a : own;
};

});
parcelRequire.register("l6o8a", function(module, exports) {
parcelRequire("hsUE1");

var $5zMeE = parcelRequire("5zMeE");
module.exports = $5zMeE("Array").slice;

});
parcelRequire.register("hsUE1", function(module, exports) {
"use strict";

var $2iwSV = parcelRequire("2iwSV");

var $fnf29 = parcelRequire("fnf29");

var $HaMz3 = parcelRequire("HaMz3");

var $2IxWL = parcelRequire("2IxWL");

var $98Q42 = parcelRequire("98Q42");

var $f8kjp = parcelRequire("f8kjp");

var $gYLVQ = parcelRequire("gYLVQ");

var $dPMro = parcelRequire("dPMro");

var $jUcq5 = parcelRequire("jUcq5");

var $ffyhk = parcelRequire("ffyhk");

var $iEWV5 = parcelRequire("iEWV5");
var $cb70fd995bd7c928$var$HAS_SPECIES_SUPPORT = $ffyhk("slice");
var $cb70fd995bd7c928$var$SPECIES = $jUcq5("species");
var $cb70fd995bd7c928$var$$Array = Array;
var $cb70fd995bd7c928$var$max = Math.max;
// `Array.prototype.slice` method
// https://tc39.es/ecma262/#sec-array.prototype.slice
// fallback for not array-like ES3 strings and DOM objects
$2iwSV({
    target: "Array",
    proto: true,
    forced: !$cb70fd995bd7c928$var$HAS_SPECIES_SUPPORT
}, {
    slice: function slice(start, end) {
        var O = $gYLVQ(this);
        var length = $f8kjp(O);
        var k = $98Q42(start, length);
        var fin = $98Q42(end === undefined ? length : end, length);
        // inline `ArraySpeciesCreate` for usage native `Array#slice` where it's possible
        var Constructor, result, n;
        if ($fnf29(O)) {
            Constructor = O.constructor;
            // cross-realm fallback
            if ($HaMz3(Constructor) && (Constructor === $cb70fd995bd7c928$var$$Array || $fnf29(Constructor.prototype))) Constructor = undefined;
            else if ($2IxWL(Constructor)) {
                Constructor = Constructor[$cb70fd995bd7c928$var$SPECIES];
                if (Constructor === null) Constructor = undefined;
            }
            if (Constructor === $cb70fd995bd7c928$var$$Array || Constructor === undefined) return $iEWV5(O, k, fin);
        }
        result = new (Constructor === undefined ? $cb70fd995bd7c928$var$$Array : Constructor)($cb70fd995bd7c928$var$max(fin - k, 0));
        for(n = 0; k < fin; k++, n++)if (k in O) $dPMro(result, n, O[k]);
        result.length = n;
        return result;
    }
});

});

parcelRequire.register("5zMeE", function(module, exports) {

var $lahb7 = parcelRequire("lahb7");
module.exports = function(CONSTRUCTOR) {
    return $lahb7[CONSTRUCTOR + "Prototype"];
};

});








parcelRequire.register("8fviW", function(module, exports) {

module.exports = (parcelRequire("fXTCZ"));

});
parcelRequire.register("fXTCZ", function(module, exports) {

module.exports = (parcelRequire("6KR3D"));

});
parcelRequire.register("6KR3D", function(module, exports) {

var $6yP9w = parcelRequire("6yP9w");
module.exports = $6yP9w;

});
parcelRequire.register("6yP9w", function(module, exports) {

var $kO1w3 = parcelRequire("kO1w3");
module.exports = $kO1w3;

});
parcelRequire.register("kO1w3", function(module, exports) {

var $X7xnA = parcelRequire("X7xnA");
module.exports = $X7xnA;

});
parcelRequire.register("X7xnA", function(module, exports) {
parcelRequire("vGpAn");
parcelRequire("89SLR");

var $lahb7 = parcelRequire("lahb7");
module.exports = $lahb7.Array.from;

});
parcelRequire.register("89SLR", function(module, exports) {

var $2iwSV = parcelRequire("2iwSV");

var $hk4rO = parcelRequire("hk4rO");

var $78PmU = parcelRequire("78PmU");
var $5f09a6599962a5c7$var$INCORRECT_ITERATION = !$78PmU(function(iterable) {
    // eslint-disable-next-line es/no-array-from -- required for testing
    Array.from(iterable);
});
// `Array.from` method
// https://tc39.es/ecma262/#sec-array.from
$2iwSV({
    target: "Array",
    stat: true,
    forced: $5f09a6599962a5c7$var$INCORRECT_ITERATION
}, {
    from: $hk4rO
});

});
parcelRequire.register("hk4rO", function(module, exports) {
"use strict";

var $jjTxh = parcelRequire("jjTxh");

var $boD6Z = parcelRequire("boD6Z");

var $h90HQ = parcelRequire("h90HQ");

var $iBFNK = parcelRequire("iBFNK");

var $cLgYu = parcelRequire("cLgYu");

var $HaMz3 = parcelRequire("HaMz3");

var $f8kjp = parcelRequire("f8kjp");

var $dPMro = parcelRequire("dPMro");

var $jzIAy = parcelRequire("jzIAy");

var $4ARxr = parcelRequire("4ARxr");
var $c9c7c121c8def163$var$$Array = Array;
// `Array.from` method implementation
// https://tc39.es/ecma262/#sec-array.from
module.exports = function from(arrayLike /* , mapfn = undefined, thisArg = undefined */ ) {
    var O = $h90HQ(arrayLike);
    var IS_CONSTRUCTOR = $HaMz3(this);
    var argumentsLength = arguments.length;
    var mapfn = argumentsLength > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    if (mapping) mapfn = $jjTxh(mapfn, argumentsLength > 2 ? arguments[2] : undefined);
    var iteratorMethod = $4ARxr(O);
    var index = 0;
    var length, result, step, iterator, next, value;
    // if the target is not iterable or it's an array with the default iterator - use a simple case
    if (iteratorMethod && !(this === $c9c7c121c8def163$var$$Array && $cLgYu(iteratorMethod))) {
        iterator = $jzIAy(O, iteratorMethod);
        next = iterator.next;
        result = IS_CONSTRUCTOR ? new this() : [];
        for(; !(step = $boD6Z(next, iterator)).done; index++){
            value = mapping ? $iBFNK(iterator, mapfn, [
                step.value,
                index
            ], true) : step.value;
            $dPMro(result, index, value);
        }
    } else {
        length = $f8kjp(O);
        result = IS_CONSTRUCTOR ? new this(length) : $c9c7c121c8def163$var$$Array(length);
        for(; length > index; index++){
            value = mapping ? mapfn(O[index], index) : O[index];
            $dPMro(result, index, value);
        }
    }
    result.length = index;
    return result;
};

});
parcelRequire.register("iBFNK", function(module, exports) {

var $3CMpt = parcelRequire("3CMpt");

var $cjnDg = parcelRequire("cjnDg");
// call something on iterator step with safe closing on error
module.exports = function(iterator, fn, value, ENTRIES) {
    try {
        return ENTRIES ? fn($3CMpt(value)[0], value[1]) : fn(value);
    } catch (error) {
        $cjnDg(iterator, "throw", error);
    }
};

});









parcelRequire.register("5SgwI", function(module, exports) {
function $446ed0c135fe729c$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
module.exports = $446ed0c135fe729c$var$_arrayLikeToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRequire.register("dZe0i", function(module, exports) {
function $a2ebd5b943983279$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
module.exports = $a2ebd5b943983279$var$_nonIterableRest, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRequire.register("8XbN8", function(module, exports) {

$parcel$export(module.exports, "default", () => $684cfafacf05d13e$export$2e2bcd8739ae039);

var $cUZUF = parcelRequire("cUZUF");

var $kYFzi = parcelRequire("kYFzi");

var $8rI2l = parcelRequire("8rI2l");

var $eO7Kz = parcelRequire("eO7Kz");

var $9NSTH = parcelRequire("9NSTH");

var $51FGD = parcelRequire("51FGD");
var $684cfafacf05d13e$var$Dots = function Dots() {
    var _context, _context2;
    var _useNumItems = (0, $51FGD.default)(), _useNumItems2 = (0, (/*@__PURE__*/$parcel$interopDefault($cUZUF)))(_useNumItems, 1), numItems = _useNumItems2[0];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eO7Kz))).createElement("ul", {
        className: "react-film__dots"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($kYFzi)))(_context = (0, (/*@__PURE__*/$parcel$interopDefault($8rI2l)))(_context2 = new Array(numItems)).call(_context2)).call(_context, function(_, itemIndex) {
        return /*#__PURE__*/ /* eslint-disable-next-line react/no-array-index-key */ (0, (/*@__PURE__*/$parcel$interopDefault($eO7Kz))).createElement((0, $9NSTH.default), {
            "aria-label": itemIndex + 1 + "",
            itemIndex: itemIndex,
            key: itemIndex
        });
    }));
};
var $684cfafacf05d13e$export$2e2bcd8739ae039 = $684cfafacf05d13e$var$Dots;

});
parcelRequire.register("kYFzi", function(module, exports) {

module.exports = (parcelRequire("bN2Yz"));

});
parcelRequire.register("bN2Yz", function(module, exports) {

var $hVSxd = parcelRequire("hVSxd");
module.exports = $hVSxd;

});
parcelRequire.register("hVSxd", function(module, exports) {

var $53bMe = parcelRequire("53bMe");

var $SMvjv = parcelRequire("SMvjv");
var $d0e210023c005a7c$var$ArrayPrototype = Array.prototype;
module.exports = function(it) {
    var own = it.map;
    return it === $d0e210023c005a7c$var$ArrayPrototype || $53bMe($d0e210023c005a7c$var$ArrayPrototype, it) && own === $d0e210023c005a7c$var$ArrayPrototype.map ? $SMvjv : own;
};

});
parcelRequire.register("SMvjv", function(module, exports) {
parcelRequire("kNmGn");

var $5zMeE = parcelRequire("5zMeE");
module.exports = $5zMeE("Array").map;

});
parcelRequire.register("kNmGn", function(module, exports) {
"use strict";

var $2iwSV = parcelRequire("2iwSV");

var $9e7Wd = parcelRequire("9e7Wd");
var $f239fa886bf17626$require$$map = $9e7Wd.map;

var $ffyhk = parcelRequire("ffyhk");
var $f239fa886bf17626$var$HAS_SPECIES_SUPPORT = $ffyhk("map");
// `Array.prototype.map` method
// https://tc39.es/ecma262/#sec-array.prototype.map
// with adding support of @@species
$2iwSV({
    target: "Array",
    proto: true,
    forced: !$f239fa886bf17626$var$HAS_SPECIES_SUPPORT
}, {
    map: function map(callbackfn /* , thisArg */ ) {
        return $f239fa886bf17626$require$$map(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    }
});

});





parcelRequire.register("8rI2l", function(module, exports) {

module.exports = (parcelRequire("fwPRO"));

});
parcelRequire.register("fwPRO", function(module, exports) {

var $7NMya = parcelRequire("7NMya");
module.exports = $7NMya;

});
parcelRequire.register("7NMya", function(module, exports) {

var $53bMe = parcelRequire("53bMe");

var $eY3hY = parcelRequire("eY3hY");
var $5ae2c50ba1459fc7$var$ArrayPrototype = Array.prototype;
module.exports = function(it) {
    var own = it.fill;
    return it === $5ae2c50ba1459fc7$var$ArrayPrototype || $53bMe($5ae2c50ba1459fc7$var$ArrayPrototype, it) && own === $5ae2c50ba1459fc7$var$ArrayPrototype.fill ? $eY3hY : own;
};

});
parcelRequire.register("eY3hY", function(module, exports) {
parcelRequire("9HnV4");

var $5zMeE = parcelRequire("5zMeE");
module.exports = $5zMeE("Array").fill;

});
parcelRequire.register("9HnV4", function(module, exports) {

var $2iwSV = parcelRequire("2iwSV");

var $6fjlB = parcelRequire("6fjlB");

var $3Gtyn = parcelRequire("3Gtyn");
// `Array.prototype.fill` method
// https://tc39.es/ecma262/#sec-array.prototype.fill
$2iwSV({
    target: "Array",
    proto: true
}, {
    fill: $6fjlB
});
// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
$3Gtyn("fill");

});
parcelRequire.register("6fjlB", function(module, exports) {
"use strict";

var $h90HQ = parcelRequire("h90HQ");

var $98Q42 = parcelRequire("98Q42");

var $f8kjp = parcelRequire("f8kjp");
// `Array.prototype.fill` method implementation
// https://tc39.es/ecma262/#sec-array.prototype.fill
module.exports = function fill(value /* , start = 0, end = @length */ ) {
    var O = $h90HQ(this);
    var length = $f8kjp(O);
    var argumentsLength = arguments.length;
    var index = $98Q42(argumentsLength > 1 ? arguments[1] : undefined, length);
    var end = argumentsLength > 2 ? arguments[2] : undefined;
    var endPos = end === undefined ? length : $98Q42(end, length);
    while(endPos > index)O[index++] = value;
    return O;
};

});






parcelRequire.register("9NSTH", function(module, exports) {

$parcel$export(module.exports, "default", () => $723346200226ee4c$export$2e2bcd8739ae039);

var $cUZUF = parcelRequire("cUZUF");

var $f7UXb = parcelRequire("f7UXb");

var $eO7Kz = parcelRequire("eO7Kz");

var $kBXs7 = parcelRequire("kBXs7");

var $F8IqC = parcelRequire("F8IqC");
var $723346200226ee4c$var$Dot = function Dot(_ref) {
    var ariaLabel = _ref["aria-label"], itemIndex = _ref.itemIndex;
    var _useIndex = (0, $kBXs7.default)(), _useIndex2 = (0, (/*@__PURE__*/$parcel$interopDefault($cUZUF)))(_useIndex, 1), index = _useIndex2[0];
    var scrollTo = (0, $F8IqC.default)();
    var checked = index === itemIndex;
    var handleChange = (0, $eO7Kz.useCallback)(function() {
        return scrollTo(function() {
            return itemIndex;
        });
    }, [
        itemIndex,
        scrollTo
    ]);
    var handleKeyPress = (0, $eO7Kz.useCallback)(function(event) {
        var keyCode = event.keyCode;
        // 13 is ENTER, 32 is SPACEBAR.
        // eslint-disable-next-line no-magic-numbers
        if (keyCode === 13 || keyCode === 32) {
            event.preventDefault();
            event.stopPropagation();
            handleChange();
        }
    }, [
        handleChange
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eO7Kz))).createElement("li", {
        className: "react-film__dot"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eO7Kz))).createElement("input", {
        "aria-label": ariaLabel,
        "aria-pressed": checked,
        checked: checked,
        className: "react-film__dot__input",
        onChange: handleChange,
        onKeyPress: handleKeyPress,
        role: "button",
        type: "checkbox"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eO7Kz))).createElement("div", {
        className: "react-film__dot__handle"
    }));
};
$723346200226ee4c$var$Dot.defaultProps = {
    "aria-label": undefined
};
$723346200226ee4c$var$Dot.propTypes = {
    "aria-label": (0, (/*@__PURE__*/$parcel$interopDefault($f7UXb))).string,
    itemIndex: (0, (/*@__PURE__*/$parcel$interopDefault($f7UXb))).number.isRequired
};
var $723346200226ee4c$export$2e2bcd8739ae039 = $723346200226ee4c$var$Dot;

});
parcelRequire.register("kBXs7", function(module, exports) {

$parcel$export(module.exports, "default", () => $f015616519e326a0$export$2e2bcd8739ae039);

var $etP1P = parcelRequire("etP1P");
function $f015616519e326a0$export$2e2bcd8739ae039() {
    var _useViewContext = (0, $etP1P.default)(), index = _useViewContext.index;
    return [
        index
    ];
}

});
parcelRequire.register("etP1P", function(module, exports) {

$parcel$export(module.exports, "default", () => $a8ab5b515c276620$export$2e2bcd8739ae039);

var $eO7Kz = parcelRequire("eO7Kz");

var $6oK5Q = parcelRequire("6oK5Q");
function $a8ab5b515c276620$export$2e2bcd8739ae039() {
    return (0, $eO7Kz.useContext)((0, $6oK5Q.default));
}

});
parcelRequire.register("6oK5Q", function(module, exports) {

$parcel$export(module.exports, "default", () => $4a88bd1eb10df454$export$2e2bcd8739ae039);

var $eO7Kz = parcelRequire("eO7Kz");
var $4a88bd1eb10df454$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eO7Kz.createContext)();

});



parcelRequire.register("F8IqC", function(module, exports) {

$parcel$export(module.exports, "default", () => $07ba972efe826e64$export$2e2bcd8739ae039);

var $aUY6K = parcelRequire("aUY6K");
function $07ba972efe826e64$export$2e2bcd8739ae039() {
    var _useFunctionContext = (0, $aUY6K.default)(), scrollTo = _useFunctionContext.scrollTo;
    return scrollTo;
}

});
parcelRequire.register("aUY6K", function(module, exports) {

$parcel$export(module.exports, "default", () => $7f2dc27ea7c7d512$export$2e2bcd8739ae039);

var $eO7Kz = parcelRequire("eO7Kz");

var $goo9V = parcelRequire("goo9V");
function $7f2dc27ea7c7d512$export$2e2bcd8739ae039() {
    var context = (0, $eO7Kz.useContext)((0, $goo9V.default));
    if (!context) throw new Error("react-film: Hooks can only be used inside the component.");
    return context;
}

});
parcelRequire.register("goo9V", function(module, exports) {

$parcel$export(module.exports, "default", () => $bef1a0bd764d3358$export$2e2bcd8739ae039);

var $eO7Kz = parcelRequire("eO7Kz");
var $bef1a0bd764d3358$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eO7Kz.createContext)();

});




parcelRequire.register("51FGD", function(module, exports) {

$parcel$export(module.exports, "default", () => $3a8d61d4d09c0393$export$2e2bcd8739ae039);

var $9CZVE = parcelRequire("9CZVE");
function $3a8d61d4d09c0393$export$2e2bcd8739ae039() {
    var _usePropsContext = (0, $9CZVE.default)(), numItems = _usePropsContext.numItems;
    return [
        numItems
    ];
}

});
parcelRequire.register("9CZVE", function(module, exports) {

$parcel$export(module.exports, "default", () => $7027b36f858a6574$export$2e2bcd8739ae039);

var $eO7Kz = parcelRequire("eO7Kz");

var $dQdw0 = parcelRequire("dQdw0");
function $7027b36f858a6574$export$2e2bcd8739ae039() {
    var context = (0, $eO7Kz.useContext)((0, $dQdw0.default));
    if (!context) throw new Error("react-film: Hooks can only be used inside the component.");
    return context;
}

});
parcelRequire.register("dQdw0", function(module, exports) {

$parcel$export(module.exports, "default", () => $a13a9d8a4616b035$export$2e2bcd8739ae039);

var $eO7Kz = parcelRequire("eO7Kz");
var $a13a9d8a4616b035$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eO7Kz.createContext)();

});




parcelRequire.register("d7ywg", function(module, exports) {

$parcel$export(module.exports, "default", () => $98d6b4a49f362141$export$2e2bcd8739ae039);

var $kYFzi = parcelRequire("kYFzi");

var $f7UXb = parcelRequire("f7UXb");

var $eO7Kz = parcelRequire("eO7Kz");

var $8xjyx = parcelRequire("8xjyx");

var $4ibPa = parcelRequire("4ibPa");
var $98d6b4a49f362141$var$Filmstrip = function Filmstrip(_ref) {
    var children = _ref.children;
    var itemContainerCallbackRef = (0, $8xjyx.default)();
    var scrollableCallbackRef = (0, $4ibPa.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eO7Kz))).createElement("div", {
        className: "react-film__filmstrip",
        ref: scrollableCallbackRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eO7Kz))).createElement("ul", {
        className: "react-film__filmstrip__list",
        ref: itemContainerCallbackRef
    }, (0, (/*@__PURE__*/$parcel$interopDefault($kYFzi)))((0, $eO7Kz.Children)).call((0, $eO7Kz.Children), children, function(child) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eO7Kz))).createElement("li", {
            className: "react-film__filmstrip__item"
        }, child);
    })));
};
$98d6b4a49f362141$var$Filmstrip.defaultProps = {
    children: undefined
};
$98d6b4a49f362141$var$Filmstrip.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($f7UXb))).any
};
var $98d6b4a49f362141$export$2e2bcd8739ae039 = $98d6b4a49f362141$var$Filmstrip;

});
parcelRequire.register("8xjyx", function(module, exports) {

$parcel$export(module.exports, "default", () => $6370933d446569ee$export$2e2bcd8739ae039);

var $eO7Kz = parcelRequire("eO7Kz");

var $evKct = parcelRequire("evKct");
function $6370933d446569ee$export$2e2bcd8739ae039() {
    var _useInternalContext = (0, $evKct.default)(), itemContainerCallbackRefWithSubscribe = _useInternalContext.itemContainerCallbackRefWithSubscribe;
    return (0, $eO7Kz.useCallback)(function(element) {
        return itemContainerCallbackRefWithSubscribe(element);
    }, [
        itemContainerCallbackRefWithSubscribe
    ]);
}

});
parcelRequire.register("evKct", function(module, exports) {

$parcel$export(module.exports, "default", () => $a907cc549cfd8c8c$export$2e2bcd8739ae039);

var $eO7Kz = parcelRequire("eO7Kz");

var $9TyHx = parcelRequire("9TyHx");
function $a907cc549cfd8c8c$export$2e2bcd8739ae039() {
    var context = (0, $eO7Kz.useContext)((0, $9TyHx.default));
    if (!context) throw new Error("react-film: Hooks can only be used inside the component.");
    return context;
}

});
parcelRequire.register("9TyHx", function(module, exports) {

$parcel$export(module.exports, "default", () => $73442b06dbad21db$export$2e2bcd8739ae039);

var $eO7Kz = parcelRequire("eO7Kz");
var $73442b06dbad21db$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eO7Kz.createContext)();

});



parcelRequire.register("4ibPa", function(module, exports) {

$parcel$export(module.exports, "default", () => $320203eb9341d3f5$export$2e2bcd8739ae039);

var $eO7Kz = parcelRequire("eO7Kz");

var $evKct = parcelRequire("evKct");
function $320203eb9341d3f5$export$2e2bcd8739ae039() {
    var _useInternalContext = (0, $evKct.default)(), scrollableCallbackRefWithSubscribe = _useInternalContext.scrollableCallbackRefWithSubscribe;
    return (0, $eO7Kz.useCallback)(function(element) {
        return scrollableCallbackRefWithSubscribe(element);
    }, [
        scrollableCallbackRefWithSubscribe
    ]);
}

});


parcelRequire.register("1w92p", function(module, exports) {

$parcel$export(module.exports, "default", () => $11afca53b4407cd9$export$2e2bcd8739ae039);

var $cUZUF = parcelRequire("cUZUF");

var $5A4MD = parcelRequire("5A4MD");

var $f7UXb = parcelRequire("f7UXb");

var $eO7Kz = parcelRequire("eO7Kz");

var $26H2c = parcelRequire("26H2c");

var $Xq3pF = parcelRequire("Xq3pF");

var $6Nn0k = parcelRequire("6Nn0k");

var $dnHr4 = parcelRequire("dnHr4");
var $11afca53b4407cd9$var$Flipper = function Flipper(_ref) {
    var ariaLabel = _ref["aria-label"], blurFocusOnClick = _ref.blurFocusOnClick, children = _ref.children, mode = _ref.mode;
    var _useDir = (0, $26H2c.default)(), _useDir2 = (0, (/*@__PURE__*/$parcel$interopDefault($cUZUF)))(_useDir, 1), dir = _useDir2[0];
    var _useScrollBarPercenta = (0, $Xq3pF.default)(), _useScrollBarPercenta2 = (0, (/*@__PURE__*/$parcel$interopDefault($cUZUF)))(_useScrollBarPercenta, 1), scrollBarPercentage = _useScrollBarPercenta2[0];
    var buttonRef = (0, $eO7Kz.useRef)();
    var left = mode === "left";
    var scrollOneLeft = (0, $6Nn0k.default)();
    var scrollOneRight = (0, $dnHr4.default)();
    var handleClick = (0, $eO7Kz.useCallback)(function() {
        left ? scrollOneLeft() : scrollOneRight();
        blurFocusOnClick && buttonRef.current && buttonRef.current.blur();
    }, [
        blurFocusOnClick,
        buttonRef,
        left,
        scrollOneLeft,
        scrollOneRight
    ]);
    var handleKeyDown = (0, $eO7Kz.useCallback)(function(event) {
        var key = event.key;
        if (key === "Enter" || key === " ") {
            event.preventDefault();
            left ? scrollOneLeft() : scrollOneRight();
        }
    }, [
        left,
        scrollOneLeft,
        scrollOneRight
    ]);
    var hide;
    if (dir === "rtl") {
        if (left) hide = scrollBarPercentage === "100%" || scrollBarPercentage === "-100%";
        else hide = scrollBarPercentage === "0%";
    } else if (left) hide = scrollBarPercentage === "0%";
    else hide = scrollBarPercentage === "100%";
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eO7Kz))).createElement("button", {
        "aria-label": ariaLabel || (left ? "left" : "right"),
        className: (0, (/*@__PURE__*/$parcel$interopDefault($5A4MD)))("react-film__flipper", "react-film__main__overlay", {
            "react-film__flipper--left": left,
            "react-film__flipper--right": !left
        }),
        onClick: handleClick,
        onKeyDown: handleKeyDown,
        ref: buttonRef,
        type: "button"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eO7Kz))).createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($5A4MD)))("react-film__flipper__slider", "react-film__main__slider", {
            "react-film__main__slider--hide": hide,
            "react-film__main__slider--left": left,
            "react-film__main__slider--right": !left
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eO7Kz))).createElement("div", {
        className: "react-film__flipper__body"
    }, children)));
};
$11afca53b4407cd9$var$Flipper.defaultProps = {
    "aria-label": undefined,
    blurFocusOnClick: false,
    children: undefined,
    mode: "left"
};
$11afca53b4407cd9$var$Flipper.propTypes = {
    "aria-label": (0, (/*@__PURE__*/$parcel$interopDefault($f7UXb))).string,
    blurFocusOnClick: (0, (/*@__PURE__*/$parcel$interopDefault($f7UXb))).bool,
    children: (0, (/*@__PURE__*/$parcel$interopDefault($f7UXb))).any,
    mode: (0, (/*@__PURE__*/$parcel$interopDefault($f7UXb))).oneOf([
        "left",
        "right"
    ])
};
var $11afca53b4407cd9$export$2e2bcd8739ae039 = $11afca53b4407cd9$var$Flipper;

});
parcelRequire.register("26H2c", function(module, exports) {

$parcel$export(module.exports, "default", () => $188d861113a25379$export$2e2bcd8739ae039);

var $9CZVE = parcelRequire("9CZVE");
function $188d861113a25379$export$2e2bcd8739ae039() {
    var _usePropsContext = (0, $9CZVE.default)(), dir = _usePropsContext.dir;
    return [
        dir
    ];
}

});

parcelRequire.register("Xq3pF", function(module, exports) {

$parcel$export(module.exports, "default", () => $0b29b8981fdea727$export$2e2bcd8739ae039);

var $etP1P = parcelRequire("etP1P");
function $0b29b8981fdea727$export$2e2bcd8739ae039() {
    var _useViewContext = (0, $etP1P.default)(), scrollBarPercentage = _useViewContext.scrollBarPercentage;
    return [
        scrollBarPercentage
    ];
}

});

parcelRequire.register("6Nn0k", function(module, exports) {

$parcel$export(module.exports, "default", () => $0146db837b5fb831$export$2e2bcd8739ae039);

var $aUY6K = parcelRequire("aUY6K");
function $0146db837b5fb831$export$2e2bcd8739ae039() {
    var _useFunctionContext = (0, $aUY6K.default)(), scrollOneLeft = _useFunctionContext.scrollOneLeft;
    return scrollOneLeft;
}

});

parcelRequire.register("dnHr4", function(module, exports) {

$parcel$export(module.exports, "default", () => $9bdf1dc4223400da$export$2e2bcd8739ae039);

var $aUY6K = parcelRequire("aUY6K");
function $9bdf1dc4223400da$export$2e2bcd8739ae039() {
    var _useFunctionContext = (0, $aUY6K.default)(), scrollOneRight = _useFunctionContext.scrollOneRight;
    return scrollOneRight;
}

});


parcelRequire.register("inmhv", function(module, exports) {

$parcel$export(module.exports, "default", () => $d60ba8980baaf15a$export$2e2bcd8739ae039);

var $k0QRm = parcelRequire("k0QRm");

var $cUZUF = parcelRequire("cUZUF");

var $8Qifd = parcelRequire("8Qifd");

var $eO7Kz = parcelRequire("eO7Kz");

var $gFPHP = parcelRequire("gFPHP");

var $26H2c = parcelRequire("26H2c");

var $Xq3pF = parcelRequire("Xq3pF");

var $29LnK = parcelRequire("29LnK");
var $d60ba8980baaf15a$var$ScrollBar = function ScrollBar() {
    var _useDir = (0, $26H2c.default)(), _useDir2 = (0, (/*@__PURE__*/$parcel$interopDefault($cUZUF)))(_useDir, 1), dir = _useDir2[0];
    var _useScrollBarPercenta = (0, $Xq3pF.default)(), _useScrollBarPercenta2 = (0, (/*@__PURE__*/$parcel$interopDefault($cUZUF)))(_useScrollBarPercenta, 1), scrollBarPercentage = _useScrollBarPercenta2[0];
    var _useScrollBarWidth = (0, $29LnK.default)(), _useScrollBarWidth2 = (0, (/*@__PURE__*/$parcel$interopDefault($cUZUF)))(_useScrollBarWidth, 1), scrollBarWidth = _useScrollBarWidth2[0];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eO7Kz))).createElement("div", {
        className: "react-film__scroll-bar react-film__main__slider react-film__main__slider--bottom"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eO7Kz))).createElement("div", {
        className: "react-film__scroll-bar__handle",
        style: (0, (/*@__PURE__*/$parcel$interopDefault($k0QRm)))((0, (/*@__PURE__*/$parcel$interopDefault($k0QRm)))({}, dir === "rtl" ? $gFPHP.edgeUWP || $gFPHP.internetExplorer ? {
            marginRight: "".concat((1 - (0, (/*@__PURE__*/$parcel$interopDefault($8Qifd)))(scrollBarWidth) / 100) * (0, (/*@__PURE__*/$parcel$interopDefault($8Qifd)))(scrollBarPercentage), "%")
        } : {
            marginRight: "".concat(((0, (/*@__PURE__*/$parcel$interopDefault($8Qifd)))(scrollBarWidth) / 100 - 1) * (0, (/*@__PURE__*/$parcel$interopDefault($8Qifd)))(scrollBarPercentage), "%")
        } : {
            marginLeft: "".concat((1 - (0, (/*@__PURE__*/$parcel$interopDefault($8Qifd)))(scrollBarWidth) / 100) * (0, (/*@__PURE__*/$parcel$interopDefault($8Qifd)))(scrollBarPercentage), "%")
        }), {}, {
            width: scrollBarWidth
        })
    }));
};
var $d60ba8980baaf15a$export$2e2bcd8739ae039 = $d60ba8980baaf15a$var$ScrollBar;

});
parcelRequire.register("k0QRm", function(module, exports) {

var $ixxgJ = parcelRequire("ixxgJ");

var $85aYK = parcelRequire("85aYK");

var $amzbe = parcelRequire("amzbe");

var $hhEET = parcelRequire("hhEET");

var $hbxdt = parcelRequire("hbxdt");

var $9qJGS = parcelRequire("9qJGS");

var $gARNe = parcelRequire("gARNe");

var $l6gPz = parcelRequire("l6gPz");

var $iCd34 = parcelRequire("iCd34");
function $e91ccf8dad8ae925$var$ownKeys(object, enumerableOnly) {
    var keys = $ixxgJ(object);
    if ($85aYK) {
        var symbols = $85aYK(object);
        enumerableOnly && (symbols = $amzbe(symbols).call(symbols, function(sym) {
            return $hhEET(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $e91ccf8dad8ae925$var$_objectSpread2(target) {
    for(var i = 1; i < arguments.length; i++){
        var _context, _context2;
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $hbxdt(_context = $e91ccf8dad8ae925$var$ownKeys(Object(source), !0)).call(_context, function(key) {
            $iCd34(target, key, source[key]);
        }) : $9qJGS ? $gARNe(target, $9qJGS(source)) : $hbxdt(_context2 = $e91ccf8dad8ae925$var$ownKeys(Object(source))).call(_context2, function(key) {
            $l6gPz(target, key, $hhEET(source, key));
        });
    }
    return target;
}
module.exports = $e91ccf8dad8ae925$var$_objectSpread2, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRequire.register("ixxgJ", function(module, exports) {

module.exports = (parcelRequire("g3Zwt"));

});
parcelRequire.register("g3Zwt", function(module, exports) {

module.exports = (parcelRequire("kksiU"));

});
parcelRequire.register("kksiU", function(module, exports) {

var $dBstM = parcelRequire("dBstM");
module.exports = $dBstM;

});
parcelRequire.register("dBstM", function(module, exports) {

var $9sBSh = parcelRequire("9sBSh");
module.exports = $9sBSh;

});
parcelRequire.register("9sBSh", function(module, exports) {

var $cOYDK = parcelRequire("cOYDK");
module.exports = $cOYDK;

});
parcelRequire.register("cOYDK", function(module, exports) {
parcelRequire("5I4Sd");

var $lahb7 = parcelRequire("lahb7");
module.exports = $lahb7.Object.keys;

});
parcelRequire.register("5I4Sd", function(module, exports) {

var $2iwSV = parcelRequire("2iwSV");

var $h90HQ = parcelRequire("h90HQ");

var $hQAxZ = parcelRequire("hQAxZ");

var $bSIUO = parcelRequire("bSIUO");
var $4284d78dfeace18f$var$FAILS_ON_PRIMITIVES = $bSIUO(function() {
    $hQAxZ(1);
});
// `Object.keys` method
// https://tc39.es/ecma262/#sec-object.keys
$2iwSV({
    target: "Object",
    stat: true,
    forced: $4284d78dfeace18f$var$FAILS_ON_PRIMITIVES
}, {
    keys: function keys(it) {
        return $hQAxZ($h90HQ(it));
    }
});

});







parcelRequire.register("85aYK", function(module, exports) {

module.exports = (parcelRequire("a97Cy"));

});
parcelRequire.register("a97Cy", function(module, exports) {

module.exports = (parcelRequire("15pRQ"));

});
parcelRequire.register("15pRQ", function(module, exports) {

var $fQRkc = parcelRequire("fQRkc");
module.exports = $fQRkc;

});
parcelRequire.register("fQRkc", function(module, exports) {

var $22OqT = parcelRequire("22OqT");
module.exports = $22OqT;

});
parcelRequire.register("22OqT", function(module, exports) {

var $hqQ77 = parcelRequire("hqQ77");
module.exports = $hqQ77;

});
parcelRequire.register("hqQ77", function(module, exports) {
parcelRequire("fkgpX");

var $lahb7 = parcelRequire("lahb7");
module.exports = $lahb7.Object.getOwnPropertySymbols;

});






parcelRequire.register("amzbe", function(module, exports) {

module.exports = (parcelRequire("ePXa4"));

});
parcelRequire.register("ePXa4", function(module, exports) {

module.exports = (parcelRequire("1wwUL"));

});
parcelRequire.register("1wwUL", function(module, exports) {

var $iBf8x = parcelRequire("iBf8x");
module.exports = $iBf8x;

});
parcelRequire.register("iBf8x", function(module, exports) {

var $dUm40 = parcelRequire("dUm40");
module.exports = $dUm40;

});
parcelRequire.register("dUm40", function(module, exports) {

var $bmYhJ = parcelRequire("bmYhJ");
module.exports = $bmYhJ;

});
parcelRequire.register("bmYhJ", function(module, exports) {

var $53bMe = parcelRequire("53bMe");

var $7dhVg = parcelRequire("7dhVg");
var $847083211c9c7a4d$var$ArrayPrototype = Array.prototype;
module.exports = function(it) {
    var own = it.filter;
    return it === $847083211c9c7a4d$var$ArrayPrototype || $53bMe($847083211c9c7a4d$var$ArrayPrototype, it) && own === $847083211c9c7a4d$var$ArrayPrototype.filter ? $7dhVg : own;
};

});
parcelRequire.register("7dhVg", function(module, exports) {
parcelRequire("b7Gzl");

var $5zMeE = parcelRequire("5zMeE");
module.exports = $5zMeE("Array").filter;

});
parcelRequire.register("b7Gzl", function(module, exports) {
"use strict";

var $2iwSV = parcelRequire("2iwSV");

var $9e7Wd = parcelRequire("9e7Wd");
var $81915e7d5f6ffa5a$require$$filter = $9e7Wd.filter;

var $ffyhk = parcelRequire("ffyhk");
var $81915e7d5f6ffa5a$var$HAS_SPECIES_SUPPORT = $ffyhk("filter");
// `Array.prototype.filter` method
// https://tc39.es/ecma262/#sec-array.prototype.filter
// with adding support of @@species
$2iwSV({
    target: "Array",
    proto: true,
    forced: !$81915e7d5f6ffa5a$var$HAS_SPECIES_SUPPORT
}, {
    filter: function filter(callbackfn /* , thisArg */ ) {
        return $81915e7d5f6ffa5a$require$$filter(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    }
});

});








parcelRequire.register("hhEET", function(module, exports) {

module.exports = (parcelRequire("cW2H6"));

});
parcelRequire.register("cW2H6", function(module, exports) {

module.exports = (parcelRequire("1k8dT"));

});
parcelRequire.register("1k8dT", function(module, exports) {

var $4yItW = parcelRequire("4yItW");
module.exports = $4yItW;

});
parcelRequire.register("4yItW", function(module, exports) {

var $37Hff = parcelRequire("37Hff");
module.exports = $37Hff;

});
parcelRequire.register("37Hff", function(module, exports) {

var $cQ5ND = parcelRequire("cQ5ND");
module.exports = $cQ5ND;

});
parcelRequire.register("cQ5ND", function(module, exports) {
parcelRequire("fSwv1");

var $lahb7 = parcelRequire("lahb7");
var $958ed70c5c9da8e9$var$Object = $lahb7.Object;
var $958ed70c5c9da8e9$var$getOwnPropertyDescriptor = module.exports = function getOwnPropertyDescriptor(it, key) {
    return $958ed70c5c9da8e9$var$Object.getOwnPropertyDescriptor(it, key);
};
if ($958ed70c5c9da8e9$var$Object.getOwnPropertyDescriptor.sham) $958ed70c5c9da8e9$var$getOwnPropertyDescriptor.sham = true;

});
parcelRequire.register("fSwv1", function(module, exports) {

var $2iwSV = parcelRequire("2iwSV");

var $bSIUO = parcelRequire("bSIUO");

var $gYLVQ = parcelRequire("gYLVQ");

var $4cXMl = parcelRequire("4cXMl");
var $b8f51bdedb710f61$require$nativeGetOwnPropertyDescriptor = $4cXMl.f;

var $awFtp = parcelRequire("awFtp");
var $b8f51bdedb710f61$var$FORCED = !$awFtp || $bSIUO(function() {
    $b8f51bdedb710f61$require$nativeGetOwnPropertyDescriptor(1);
});
// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
$2iwSV({
    target: "Object",
    stat: true,
    forced: $b8f51bdedb710f61$var$FORCED,
    sham: !$awFtp
}, {
    getOwnPropertyDescriptor: function getOwnPropertyDescriptor(it, key) {
        return $b8f51bdedb710f61$require$nativeGetOwnPropertyDescriptor($gYLVQ(it), key);
    }
});

});







parcelRequire.register("hbxdt", function(module, exports) {

module.exports = (parcelRequire("hpW6c"));

});
parcelRequire.register("hpW6c", function(module, exports) {

module.exports = (parcelRequire("iFzx0"));

});
parcelRequire.register("iFzx0", function(module, exports) {

var $fvTNl = parcelRequire("fvTNl");
module.exports = $fvTNl;

});
parcelRequire.register("fvTNl", function(module, exports) {

var $yUPG4 = parcelRequire("yUPG4");
module.exports = $yUPG4;

});
parcelRequire.register("yUPG4", function(module, exports) {
parcelRequire("a8ZHm");

var $jv1hF = parcelRequire("jv1hF");

var $dj4ij = parcelRequire("dj4ij");

var $53bMe = parcelRequire("53bMe");

var $8cJCO = parcelRequire("8cJCO");
var $068f42d7be3eedf1$var$ArrayPrototype = Array.prototype;
var $068f42d7be3eedf1$var$DOMIterables = {
    DOMTokenList: true,
    NodeList: true
};
module.exports = function(it) {
    var own = it.forEach;
    return it === $068f42d7be3eedf1$var$ArrayPrototype || $53bMe($068f42d7be3eedf1$var$ArrayPrototype, it) && own === $068f42d7be3eedf1$var$ArrayPrototype.forEach || $dj4ij($068f42d7be3eedf1$var$DOMIterables, $jv1hF(it)) ? $8cJCO : own;
};

});
parcelRequire.register("8cJCO", function(module, exports) {

var $8fj53 = parcelRequire("8fj53");
module.exports = $8fj53;

});
parcelRequire.register("8fj53", function(module, exports) {
parcelRequire("12Ts2");

var $5zMeE = parcelRequire("5zMeE");
module.exports = $5zMeE("Array").forEach;

});
parcelRequire.register("12Ts2", function(module, exports) {
"use strict";

var $2iwSV = parcelRequire("2iwSV");

var $bcSeJ = parcelRequire("bcSeJ");
// `Array.prototype.forEach` method
// https://tc39.es/ecma262/#sec-array.prototype.foreach
// eslint-disable-next-line es/no-array-prototype-foreach -- safe
$2iwSV({
    target: "Array",
    proto: true,
    forced: [].forEach != $bcSeJ
}, {
    forEach: $bcSeJ
});

});
parcelRequire.register("bcSeJ", function(module, exports) {
"use strict";

var $9e7Wd = parcelRequire("9e7Wd");
var $828ae2f98ab0899c$require$$forEach = $9e7Wd.forEach;

var $gH3K8 = parcelRequire("gH3K8");
var $828ae2f98ab0899c$var$STRICT_METHOD = $gH3K8("forEach");
// `Array.prototype.forEach` method implementation
// https://tc39.es/ecma262/#sec-array.prototype.foreach
module.exports = !$828ae2f98ab0899c$var$STRICT_METHOD ? function forEach(callbackfn /* , thisArg */ ) {
    return $828ae2f98ab0899c$require$$forEach(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
// eslint-disable-next-line es/no-array-prototype-foreach -- safe
} : [].forEach;

});
parcelRequire.register("gH3K8", function(module, exports) {
"use strict";

var $bSIUO = parcelRequire("bSIUO");
module.exports = function(METHOD_NAME, argument) {
    var method = [][METHOD_NAME];
    return !!method && $bSIUO(function() {
        // eslint-disable-next-line no-useless-call -- required for testing
        method.call(null, argument || function() {
            return 1;
        }, 1);
    });
};

});










parcelRequire.register("9qJGS", function(module, exports) {

module.exports = (parcelRequire("6HFxv"));

});
parcelRequire.register("6HFxv", function(module, exports) {

module.exports = (parcelRequire("fHY0j"));

});
parcelRequire.register("fHY0j", function(module, exports) {

var $d34Zi = parcelRequire("d34Zi");
module.exports = $d34Zi;

});
parcelRequire.register("d34Zi", function(module, exports) {

var $2Jh1Q = parcelRequire("2Jh1Q");
module.exports = $2Jh1Q;

});
parcelRequire.register("2Jh1Q", function(module, exports) {

var $lwr9v = parcelRequire("lwr9v");
module.exports = $lwr9v;

});
parcelRequire.register("lwr9v", function(module, exports) {
parcelRequire("hnWNl");

var $lahb7 = parcelRequire("lahb7");
module.exports = $lahb7.Object.getOwnPropertyDescriptors;

});
parcelRequire.register("hnWNl", function(module, exports) {

var $2iwSV = parcelRequire("2iwSV");

var $awFtp = parcelRequire("awFtp");

var $agEVI = parcelRequire("agEVI");

var $gYLVQ = parcelRequire("gYLVQ");

var $4cXMl = parcelRequire("4cXMl");

var $dPMro = parcelRequire("dPMro");
// `Object.getOwnPropertyDescriptors` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptors
$2iwSV({
    target: "Object",
    stat: true,
    sham: !$awFtp
}, {
    getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object) {
        var O = $gYLVQ(object);
        var getOwnPropertyDescriptor = $4cXMl.f;
        var keys = $agEVI(O);
        var result = {};
        var index = 0;
        var key, descriptor;
        while(keys.length > index){
            descriptor = getOwnPropertyDescriptor(O, key = keys[index++]);
            if (descriptor !== undefined) $dPMro(result, key, descriptor);
        }
        return result;
    }
});

});







parcelRequire.register("gARNe", function(module, exports) {

module.exports = (parcelRequire("hSSnG"));

});
parcelRequire.register("hSSnG", function(module, exports) {

module.exports = (parcelRequire("9RmE6"));

});
parcelRequire.register("9RmE6", function(module, exports) {

var $dZ7nE = parcelRequire("dZ7nE");
module.exports = $dZ7nE;

});
parcelRequire.register("dZ7nE", function(module, exports) {

var $cRvva = parcelRequire("cRvva");
module.exports = $cRvva;

});
parcelRequire.register("cRvva", function(module, exports) {

var $5x0iA = parcelRequire("5x0iA");
module.exports = $5x0iA;

});
parcelRequire.register("5x0iA", function(module, exports) {
parcelRequire("76hzG");

var $lahb7 = parcelRequire("lahb7");
var $4070442813e6a45d$var$Object = $lahb7.Object;
var $4070442813e6a45d$var$defineProperties = module.exports = function defineProperties(T, D) {
    return $4070442813e6a45d$var$Object.defineProperties(T, D);
};
if ($4070442813e6a45d$var$Object.defineProperties.sham) $4070442813e6a45d$var$defineProperties.sham = true;

});
parcelRequire.register("76hzG", function(module, exports) {

var $2iwSV = parcelRequire("2iwSV");

var $awFtp = parcelRequire("awFtp");

var $crfP8 = parcelRequire("crfP8");
var $52b6b9e20b640e82$require$defineProperties = $crfP8.f;
// `Object.defineProperties` method
// https://tc39.es/ecma262/#sec-object.defineproperties
// eslint-disable-next-line es/no-object-defineproperties -- safe
$2iwSV({
    target: "Object",
    stat: true,
    forced: Object.defineProperties !== $52b6b9e20b640e82$require$defineProperties,
    sham: !$awFtp
}, {
    defineProperties: $52b6b9e20b640e82$require$defineProperties
});

});







parcelRequire.register("l6gPz", function(module, exports) {

module.exports = (parcelRequire("jODSY"));

});
parcelRequire.register("jODSY", function(module, exports) {

module.exports = (parcelRequire("694tl"));

});
parcelRequire.register("694tl", function(module, exports) {

var $7ncV5 = parcelRequire("7ncV5");
module.exports = $7ncV5;

});
parcelRequire.register("7ncV5", function(module, exports) {

var $dJg8N = parcelRequire("dJg8N");
module.exports = $dJg8N;

});
parcelRequire.register("dJg8N", function(module, exports) {

var $hn5Qu = parcelRequire("hn5Qu");
module.exports = $hn5Qu;

});
parcelRequire.register("hn5Qu", function(module, exports) {
parcelRequire("dFiRb");

var $lahb7 = parcelRequire("lahb7");
var $ca591e7995ac10a4$var$Object = $lahb7.Object;
var $ca591e7995ac10a4$var$defineProperty = module.exports = function defineProperty(it, key, desc) {
    return $ca591e7995ac10a4$var$Object.defineProperty(it, key, desc);
};
if ($ca591e7995ac10a4$var$Object.defineProperty.sham) $ca591e7995ac10a4$var$defineProperty.sham = true;

});
parcelRequire.register("dFiRb", function(module, exports) {

var $2iwSV = parcelRequire("2iwSV");

var $awFtp = parcelRequire("awFtp");

var $8wt5F = parcelRequire("8wt5F");
var $9f2dbb3d9bdbff45$require$defineProperty = $8wt5F.f;
// `Object.defineProperty` method
// https://tc39.es/ecma262/#sec-object.defineproperty
// eslint-disable-next-line es/no-object-defineproperty -- safe
$2iwSV({
    target: "Object",
    stat: true,
    forced: Object.defineProperty !== $9f2dbb3d9bdbff45$require$defineProperty,
    sham: !$awFtp
}, {
    defineProperty: $9f2dbb3d9bdbff45$require$defineProperty
});

});







parcelRequire.register("iCd34", function(module, exports) {

var $l6gPz = parcelRequire("l6gPz");

var $jIGl4 = parcelRequire("jIGl4");
function $d8d5e5c259a48610$var$_defineProperty(obj, key, value) {
    key = $jIGl4(key);
    if (key in obj) $l6gPz(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
module.exports = $d8d5e5c259a48610$var$_defineProperty, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRequire.register("jIGl4", function(module, exports) {

var $iAigI = parcelRequire("iAigI");
var $e5b2f7ffbba9f3bb$var$_typeof = $iAigI.default;

var $ft5ND = parcelRequire("ft5ND");
function $e5b2f7ffbba9f3bb$var$_toPropertyKey(arg) {
    var key = $ft5ND(arg, "string");
    return $e5b2f7ffbba9f3bb$var$_typeof(key) === "symbol" ? key : String(key);
}
module.exports = $e5b2f7ffbba9f3bb$var$_toPropertyKey, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRequire.register("iAigI", function(module, exports) {

var $d2Q2y = parcelRequire("d2Q2y");

var $9EocT = parcelRequire("9EocT");
function $037dd5b7e731f274$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return module.exports = $037dd5b7e731f274$var$_typeof = "function" == typeof $d2Q2y && "symbol" == typeof $9EocT ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof $d2Q2y && obj.constructor === $d2Q2y && obj !== $d2Q2y.prototype ? "symbol" : typeof obj;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $037dd5b7e731f274$var$_typeof(obj);
}
module.exports = $037dd5b7e731f274$var$_typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRequire.register("9EocT", function(module, exports) {

module.exports = (parcelRequire("2iQ0J"));

});
parcelRequire.register("2iQ0J", function(module, exports) {

module.exports = (parcelRequire("7S88K"));

});
parcelRequire.register("7S88K", function(module, exports) {

var $jwG0o = parcelRequire("jwG0o");
module.exports = $jwG0o;

});
parcelRequire.register("jwG0o", function(module, exports) {

var $a9Ga2 = parcelRequire("a9Ga2");
module.exports = $a9Ga2;

});
parcelRequire.register("a9Ga2", function(module, exports) {

var $bxLCg = parcelRequire("bxLCg");
parcelRequire("a8ZHm");
module.exports = $bxLCg;

});
parcelRequire.register("bxLCg", function(module, exports) {
parcelRequire("7V1Sz");
parcelRequire("evDrA");
parcelRequire("vGpAn");
parcelRequire("lhWJ7");

var $b5crT = parcelRequire("b5crT");
module.exports = $b5crT.f("iterator");

});







parcelRequire.register("ft5ND", function(module, exports) {

var $j3MBC = parcelRequire("j3MBC");

var $iAigI = parcelRequire("iAigI");
var $b42e101e3fc76bad$var$_typeof = $iAigI.default;
function $b42e101e3fc76bad$var$_toPrimitive(input, hint) {
    if ($b42e101e3fc76bad$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[$j3MBC];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($b42e101e3fc76bad$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
module.exports = $b42e101e3fc76bad$var$_toPrimitive, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRequire.register("j3MBC", function(module, exports) {

module.exports = (parcelRequire("f0uka"));

});
parcelRequire.register("f0uka", function(module, exports) {

module.exports = (parcelRequire("73ok6"));

});
parcelRequire.register("73ok6", function(module, exports) {

var $9a5Zo = parcelRequire("9a5Zo");
module.exports = $9a5Zo;

});
parcelRequire.register("9a5Zo", function(module, exports) {

var $ePJRB = parcelRequire("ePJRB");
module.exports = $ePJRB;

});
parcelRequire.register("ePJRB", function(module, exports) {

var $dOWRl = parcelRequire("dOWRl");
module.exports = $dOWRl;

});
parcelRequire.register("dOWRl", function(module, exports) {
parcelRequire("lWgup");
parcelRequire("eMf7X");

var $b5crT = parcelRequire("b5crT");
module.exports = $b5crT.f("toPrimitive");

});
parcelRequire.register("lWgup", function(module, exports) {
// empty

});











parcelRequire.register("8Qifd", function(module, exports) {

module.exports = (parcelRequire("4zPzM"));

});
parcelRequire.register("4zPzM", function(module, exports) {

var $ciXsC = parcelRequire("ciXsC");
module.exports = $ciXsC;

});
parcelRequire.register("ciXsC", function(module, exports) {
parcelRequire("9ItbZ");

var $lahb7 = parcelRequire("lahb7");
module.exports = $lahb7.parseFloat;

});
parcelRequire.register("9ItbZ", function(module, exports) {

var $2iwSV = parcelRequire("2iwSV");

var $a7icz = parcelRequire("a7icz");
// `parseFloat` method
// https://tc39.es/ecma262/#sec-parsefloat-string
$2iwSV({
    global: true,
    forced: parseFloat != $a7icz
}, {
    parseFloat: $a7icz
});

});
parcelRequire.register("a7icz", function(module, exports) {

var $bbWQF = parcelRequire("bbWQF");

var $bSIUO = parcelRequire("bSIUO");

var $dqhay = parcelRequire("dqhay");

var $elG1Y = parcelRequire("elG1Y");

var $3YwSD = parcelRequire("3YwSD");
var $75d8ad4f12a0dd91$require$trim = $3YwSD.trim;

var $a24VM = parcelRequire("a24VM");
var $75d8ad4f12a0dd91$var$charAt = $dqhay("".charAt);
var $75d8ad4f12a0dd91$var$$parseFloat = $bbWQF.parseFloat;
var $75d8ad4f12a0dd91$var$Symbol = $bbWQF.Symbol;
var $75d8ad4f12a0dd91$var$ITERATOR = $75d8ad4f12a0dd91$var$Symbol && $75d8ad4f12a0dd91$var$Symbol.iterator;
var $75d8ad4f12a0dd91$var$FORCED = 1 / $75d8ad4f12a0dd91$var$$parseFloat($a24VM + "-0") !== -Infinity || $75d8ad4f12a0dd91$var$ITERATOR && !$bSIUO(function() {
    $75d8ad4f12a0dd91$var$$parseFloat(Object($75d8ad4f12a0dd91$var$ITERATOR));
});
// `parseFloat` method
// https://tc39.es/ecma262/#sec-parsefloat-string
module.exports = $75d8ad4f12a0dd91$var$FORCED ? function parseFloat(string) {
    var trimmedString = $75d8ad4f12a0dd91$require$trim($elG1Y(string));
    var result = $75d8ad4f12a0dd91$var$$parseFloat(trimmedString);
    return result === 0 && $75d8ad4f12a0dd91$var$charAt(trimmedString, 0) == "-" ? -0 : result;
} : $75d8ad4f12a0dd91$var$$parseFloat;

});
parcelRequire.register("3YwSD", function(module, exports) {

var $dqhay = parcelRequire("dqhay");

var $2Oek2 = parcelRequire("2Oek2");

var $elG1Y = parcelRequire("elG1Y");

var $a24VM = parcelRequire("a24VM");
var $2e507b00d3e48e7a$var$replace = $dqhay("".replace);
var $2e507b00d3e48e7a$var$ltrim = RegExp("^[" + $a24VM + "]+");
var $2e507b00d3e48e7a$var$rtrim = RegExp("(^|[^" + $a24VM + "])[" + $a24VM + "]+$");
// `String.prototype.{ trim, trimStart, trimEnd, trimLeft, trimRight }` methods implementation
var $2e507b00d3e48e7a$var$createMethod = function(TYPE) {
    return function($this) {
        var string = $elG1Y($2Oek2($this));
        if (TYPE & 1) string = $2e507b00d3e48e7a$var$replace(string, $2e507b00d3e48e7a$var$ltrim, "");
        if (TYPE & 2) string = $2e507b00d3e48e7a$var$replace(string, $2e507b00d3e48e7a$var$rtrim, "$1");
        return string;
    };
};
module.exports = {
    // `String.prototype.{ trimLeft, trimStart }` methods
    // https://tc39.es/ecma262/#sec-string.prototype.trimstart
    start: $2e507b00d3e48e7a$var$createMethod(1),
    // `String.prototype.{ trimRight, trimEnd }` methods
    // https://tc39.es/ecma262/#sec-string.prototype.trimend
    end: $2e507b00d3e48e7a$var$createMethod(2),
    // `String.prototype.trim` method
    // https://tc39.es/ecma262/#sec-string.prototype.trim
    trim: $2e507b00d3e48e7a$var$createMethod(3)
};

});
parcelRequire.register("a24VM", function(module, exports) {
// a string of all valid unicode whitespaces
module.exports = "	\n\v\f\r \xa0              　\u2028\u2029\uFEFF";

});







parcelRequire.register("gFPHP", function(module, exports) {

$parcel$export(module.exports, "edgeUWP", () => $c2389569c080afd8$export$f71f6104b6e82119);
$parcel$export(module.exports, "internetExplorer", () => $c2389569c080afd8$export$8b2918e604fb2769);
var $c2389569c080afd8$var$_navigator = navigator, $c2389569c080afd8$var$userAgent = $c2389569c080afd8$var$_navigator.userAgent;
var $c2389569c080afd8$export$7353b4fe0a64b23b = !/Edge\//.test($c2389569c080afd8$var$userAgent) && /Chrome\//.test($c2389569c080afd8$var$userAgent);
var $c2389569c080afd8$export$1ffb198ea00b642b = /Edg\//.test($c2389569c080afd8$var$userAgent);
var $c2389569c080afd8$export$f71f6104b6e82119 = /Edge\//.test($c2389569c080afd8$var$userAgent);
var $c2389569c080afd8$export$bbe03eaf052676c9 = /Firefox\//.test($c2389569c080afd8$var$userAgent);
var $c2389569c080afd8$export$8b2918e604fb2769 = /Trident\/7(?:[\0-\t\x0B\f\x0E-\u2027\u202A-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])0/.test($c2389569c080afd8$var$userAgent);
var $c2389569c080afd8$export$7b60a2159daa9614 = $c2389569c080afd8$export$7353b4fe0a64b23b && !$c2389569c080afd8$export$1ffb198ea00b642b;
var $c2389569c080afd8$export$432e1e12f062b2af = !($c2389569c080afd8$export$7b60a2159daa9614 || $c2389569c080afd8$export$f71f6104b6e82119 || $c2389569c080afd8$export$8b2918e604fb2769 || $c2389569c080afd8$export$bbe03eaf052676c9);

});

parcelRequire.register("29LnK", function(module, exports) {

$parcel$export(module.exports, "default", () => $19212d1dc83e26ba$export$2e2bcd8739ae039);

var $etP1P = parcelRequire("etP1P");
function $19212d1dc83e26ba$export$2e2bcd8739ae039() {
    var _useViewContext = (0, $etP1P.default)(), scrollBarWidth = _useViewContext.scrollBarWidth;
    return [
        scrollBarWidth
    ];
}

});


parcelRequire.register("aQ78f", function(module, exports) {

$parcel$export(module.exports, "default", () => $7e444af8e4f6f94c$export$2e2bcd8739ae039);

var $9CZVE = parcelRequire("9CZVE");
function $7e444af8e4f6f94c$export$2e2bcd8739ae039() {
    var _usePropsContext = (0, $9CZVE.default)(), height = _usePropsContext.height;
    return [
        height
    ];
}

});

parcelRequire.register("kPoIH", function(module, exports) {

$parcel$export(module.exports, "default", () => $f29bbef309e83990$export$2e2bcd8739ae039);

var $etP1P = parcelRequire("etP1P");
function $f29bbef309e83990$export$2e2bcd8739ae039() {
    var _useViewContext = (0, $etP1P.default)(), scrolling = _useViewContext.scrolling;
    return [
        scrolling
    ];
}

});

parcelRequire.register("fYCA4", function(module, exports) {

$parcel$export(module.exports, "default", () => $ba1a62f2ca1025cc$export$2e2bcd8739ae039);

var $9CZVE = parcelRequire("9CZVE");
function $ba1a62f2ca1025cc$export$2e2bcd8739ae039() {
    var _usePropsContext = (0, $9CZVE.default)(), styleOptions = _usePropsContext.styleOptions;
    return [
        styleOptions
    ];
}

});

parcelRequire.register("jz9Ub", function(module, exports) {

$parcel$export(module.exports, "default", () => $e3e8f830ddeb5ec1$export$2e2bcd8739ae039);

var $9CZVE = parcelRequire("9CZVE");
function $e3e8f830ddeb5ec1$export$2e2bcd8739ae039() {
    var _usePropsContext = (0, $9CZVE.default)(), styleSetClassNames = _usePropsContext.styleSetClassNames;
    return [
        styleSetClassNames
    ];
}

});


parcelRequire.register("9rtoc", function(module, exports) {

$parcel$export(module.exports, "default", () => $6dfd6ec4397dacf5$export$2e2bcd8739ae039);

var $k0QRm = parcelRequire("k0QRm");

var $cUZUF = parcelRequire("cUZUF");

var $lfcSg = parcelRequire("lfcSg");

var $kYFzi = parcelRequire("kYFzi");

var $n971Z = parcelRequire("n971Z");

var $gV225 = parcelRequire("gV225");

var $aEQyb = parcelRequire("aEQyb");

var $f7UXb = parcelRequire("f7UXb");

var $eO7Kz = parcelRequire("eO7Kz");

var $8wn6k = parcelRequire("8wn6k");

var $3Ckoo = parcelRequire("3Ckoo");

var $2tzI6 = parcelRequire("2tzI6");

var $6Brns = parcelRequire("6Brns");

var $goo9V = parcelRequire("goo9V");

var $gVJb0 = parcelRequire("gVJb0");

var $9TyHx = parcelRequire("9TyHx");

var $dBwSo = parcelRequire("dBwSo");

var $jJkAT = parcelRequire("jJkAT");

var $dQdw0 = parcelRequire("dQdw0");

var $dMjp1 = parcelRequire("dMjp1");

var $6eRuw = parcelRequire("6eRuw");

var $l8hnx = parcelRequire("l8hnx");

var $6oK5Q = parcelRequire("6oK5Q");
// We pool the emotion, so we don't create a new set of <style> for every component and reuse as much as we could.
var $6dfd6ec4397dacf5$var$emotionPool = {};
var $6dfd6ec4397dacf5$var$Composer = function Composer(_ref) {
    var children = _ref.children, dir = _ref.dir, height = _ref.height, nonce = _ref.nonce, numItems = _ref.numItems, styleOptions = _ref.styleOptions, styleSet = _ref.styleSet;
    dir = dir === "ltr" || dir === "rtl" ? dir : undefined;
    var patchedStyleOptions = (0, $eO7Kz.useMemo)(function() {
        return (0, $jJkAT.default)(styleOptions);
    }, [
        styleOptions
    ]);
    var patchedStyleSet = (0, $eO7Kz.useMemo)(function() {
        return styleSet || (0, $2tzI6.default)(patchedStyleOptions);
    }, [
        patchedStyleOptions,
        styleSet
    ]);
    var styleSetClassNames = (0, $eO7Kz.useMemo)(function() {
        var _context;
        var emotion = $6dfd6ec4397dacf5$var$emotionPool[nonce] || ($6dfd6ec4397dacf5$var$emotionPool[nonce] = (0, $aEQyb.default)({
            key: "react-film--css-".concat((0, $6Brns.default)()),
            nonce: nonce
        }));
        return (0, (/*@__PURE__*/$parcel$interopDefault($lfcSg)))((0, (/*@__PURE__*/$parcel$interopDefault($kYFzi)))(_context = (0, (/*@__PURE__*/$parcel$interopDefault($n971Z)))(patchedStyleSet)).call(_context, function(_ref2) {
            var _ref3 = (0, (/*@__PURE__*/$parcel$interopDefault($cUZUF)))(_ref2, 2), name = _ref3[0], style = _ref3[1];
            return [
                name,
                emotion.css(style) + ""
            ];
        }));
    }, [
        nonce,
        patchedStyleSet
    ]);
    var _useState = (0, $eO7Kz.useState)(), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($cUZUF)))(_useState, 2), _ = _useState2[0], forceRender = _useState2[1];
    var itemContainerCallbackRefWithSubscribe = (0, $6eRuw.default)();
    var scrollableCallbackRefWithSubscribe = (0, $6eRuw.default)();
    var scrollLeftRef = (0, $eO7Kz.useRef)(null);
    var scrollTimeoutRef = (0, $eO7Kz.useRef)();
    (0, $eO7Kz.useEffect)(function() {
        return function() {
            return clearTimeout(scrollTimeoutRef.current);
        };
    }, [
        scrollTimeoutRef
    ]);
    var scrollTo = (0, $eO7Kz.useCallback)(function(scrollFn) {
        var view = (0, $gVJb0.default)(dir, scrollableCallbackRefWithSubscribe.current, itemContainerCallbackRefWithSubscribe.current, scrollLeftRef.current);
        if (view) {
            var index = view.index, indexFraction = view.indexFraction;
            var targetIndex = scrollFn({
                index: index,
                indexFraction: indexFraction
            });
            if (typeof targetIndex === "number") {
                scrollLeftRef.current = (0, $3Ckoo.default)(dir, scrollableCallbackRefWithSubscribe.current, itemContainerCallbackRefWithSubscribe.current, targetIndex);
                forceRender({});
            }
        }
    }, [
        dir,
        forceRender,
        itemContainerCallbackRefWithSubscribe,
        scrollableCallbackRefWithSubscribe,
        scrollLeftRef
    ]);
    var scrollOneLeft = (0, $eO7Kz.useCallback)(function() {
        scrollTo(function(_ref4) {
            var indexFraction = _ref4.indexFraction;
            return dir === "rtl" ? Math.floor(indexFraction) + 1 : Math.ceil(indexFraction) - 1;
        });
    }, [
        dir,
        scrollTo
    ]);
    var scrollOneRight = (0, $eO7Kz.useCallback)(function() {
        scrollTo(function(_ref5) {
            var indexFraction = _ref5.indexFraction;
            return dir === "rtl" ? Math.ceil(indexFraction) - 1 : Math.floor(indexFraction) + 1;
        });
    }, [
        dir,
        scrollTo
    ]);
    var functionContext = (0, $eO7Kz.useMemo)(function() {
        return {
            scrollTo: scrollTo,
            scrollOneLeft: scrollOneLeft,
            scrollOneRight: scrollOneRight
        };
    }, [
        scrollTo,
        scrollOneLeft,
        scrollOneRight
    ]);
    var internalContext = (0, $eO7Kz.useMemo)(function() {
        return {
            itemContainerCallbackRefWithSubscribe: itemContainerCallbackRefWithSubscribe,
            scrollableCallbackRefWithSubscribe: scrollableCallbackRefWithSubscribe
        };
    }, [
        itemContainerCallbackRefWithSubscribe,
        scrollableCallbackRefWithSubscribe
    ]);
    var propsContext = (0, $eO7Kz.useMemo)(function() {
        return {
            dir: dir,
            height: height,
            nonce: nonce,
            numItems: numItems,
            styleOptions: patchedStyleOptions,
            styleSetClassNames: styleSetClassNames
        };
    }, [
        dir,
        height,
        nonce,
        numItems,
        patchedStyleOptions,
        styleSetClassNames
    ]);
    var _useState3 = (0, $eO7Kz.useState)({
        index: 0,
        indexFraction: 0,
        scrollBarPercentage: "0%",
        scrollBarWidth: "0%",
        scrolling: false
    }), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($cUZUF)))(_useState3, 2), viewContext = _useState4[0], setViewContext = _useState4[1];
    // This will setViewContext and reset the "scrolling" flag after a period of time.
    var setViewContext2 = (0, $eO7Kz.useCallback)(function(nextViewContext) {
        setViewContext(nextViewContext);
        clearTimeout(scrollTimeoutRef.current);
        if (nextViewContext.scrolling) scrollTimeoutRef.current = (0, (/*@__PURE__*/$parcel$interopDefault($gV225)))(function() {
            return setViewContext((0, (/*@__PURE__*/$parcel$interopDefault($k0QRm)))((0, (/*@__PURE__*/$parcel$interopDefault($k0QRm)))({}, nextViewContext), {}, {
                scrolling: false
            }));
        }, // eslint-disable-next-line no-magic-numbers
        500);
    }, [
        scrollTimeoutRef,
        setViewContext
    ]);
    var handleScroll = (0, $eO7Kz.useCallback)(function(_ref6) {
        var scrollBarPercentage = _ref6.fraction, initial = _ref6.initial, scrollBarWidth = _ref6.width;
        var view = (0, $gVJb0.default)(dir, scrollableCallbackRefWithSubscribe.current, itemContainerCallbackRefWithSubscribe.current, scrollLeftRef.current);
        if (view) {
            var index = view.index, indexFraction = view.indexFraction;
            setViewContext2({
                index: index,
                indexFraction: indexFraction,
                scrolling: !initial,
                scrollBarPercentage: scrollBarPercentage,
                scrollBarWidth: scrollBarWidth
            });
        }
    }, [
        dir,
        itemContainerCallbackRefWithSubscribe,
        scrollableCallbackRefWithSubscribe,
        scrollLeftRef,
        setViewContext2
    ]);
    var handleScrollToEnd = (0, $eO7Kz.useCallback)(function() {
        scrollLeftRef.current = null;
        forceRender({});
    }, [
        forceRender,
        scrollLeftRef
    ]);
    var legacyContext = (0, $eO7Kz.useMemo)(function() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($k0QRm)))((0, (/*@__PURE__*/$parcel$interopDefault($k0QRm)))((0, (/*@__PURE__*/$parcel$interopDefault($k0QRm)))((0, (/*@__PURE__*/$parcel$interopDefault($k0QRm)))({}, functionContext), internalContext), propsContext), viewContext);
    }, [
        functionContext,
        internalContext,
        propsContext,
        viewContext
    ]);
    (0, $dMjp1.default)(typeof scrollLeftRef.current === "number" && scrollableCallbackRefWithSubscribe.current, scrollLeftRef.current, handleScrollToEnd);
    (0, $eO7Kz.useEffect)(function() {
        return scrollableCallbackRefWithSubscribe.subscribe(function(current) {
            if (current) {
                current.addEventListener("pointerdown", handleScrollToEnd, {
                    passive: true
                });
                return function() {
                    return current.removeEventListener("pointerdown", handleScrollToEnd);
                };
            }
        });
    }, [
        handleScrollToEnd,
        scrollableCallbackRefWithSubscribe
    ]);
    (0, $l8hnx.default)(scrollableCallbackRefWithSubscribe, handleScroll);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eO7Kz))).createElement((0, $dQdw0.default).Provider, {
        value: propsContext
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eO7Kz))).createElement((0, $9TyHx.default).Provider, {
        value: internalContext
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eO7Kz))).createElement((0, $goo9V.default).Provider, {
        value: functionContext
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eO7Kz))).createElement((0, $6oK5Q.default).Provider, {
        value: viewContext
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eO7Kz))).createElement((0, $dBwSo.default).Provider, {
        value: legacyContext
    }, children, patchedStyleOptions.autoCenter && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eO7Kz))).createElement((0, $8wn6k.default), null))))));
};
$6dfd6ec4397dacf5$var$Composer.defaultProps = {
    children: undefined,
    dir: undefined,
    height: undefined,
    nonce: undefined,
    styleOptions: undefined,
    styleSet: undefined
};
$6dfd6ec4397dacf5$var$Composer.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($f7UXb))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($f7UXb))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($f7UXb))).element),
        (0, (/*@__PURE__*/$parcel$interopDefault($f7UXb))).element
    ]),
    dir: (0, (/*@__PURE__*/$parcel$interopDefault($f7UXb))).oneOf([
        "ltr",
        "rtl"
    ]),
    height: (0, (/*@__PURE__*/$parcel$interopDefault($f7UXb))).number,
    nonce: (0, (/*@__PURE__*/$parcel$interopDefault($f7UXb))).string,
    numItems: (0, (/*@__PURE__*/$parcel$interopDefault($f7UXb))).number.isRequired,
    styleOptions: (0, (/*@__PURE__*/$parcel$interopDefault($f7UXb))).any,
    styleSet: (0, (/*@__PURE__*/$parcel$interopDefault($f7UXb))).any
};
var $6dfd6ec4397dacf5$export$2e2bcd8739ae039 = $6dfd6ec4397dacf5$var$Composer;

});
parcelRequire.register("lfcSg", function(module, exports) {

module.exports = (parcelRequire("aohQx"));

});
parcelRequire.register("aohQx", function(module, exports) {

var $ijPen = parcelRequire("ijPen");
parcelRequire("a8ZHm");
module.exports = $ijPen;

});
parcelRequire.register("ijPen", function(module, exports) {
parcelRequire("7V1Sz");
parcelRequire("51w5s");

var $lahb7 = parcelRequire("lahb7");
module.exports = $lahb7.Object.fromEntries;

});
parcelRequire.register("51w5s", function(module, exports) {

var $2iwSV = parcelRequire("2iwSV");

var $gCDer = parcelRequire("gCDer");

var $dPMro = parcelRequire("dPMro");
// `Object.fromEntries` method
// https://github.com/tc39/proposal-object-from-entries
$2iwSV({
    target: "Object",
    stat: true
}, {
    fromEntries: function fromEntries(iterable) {
        var obj = {};
        $gCDer(iterable, function(k, v) {
            $dPMro(obj, k, v);
        }, {
            AS_ENTRIES: true
        });
        return obj;
    }
});

});




parcelRequire.register("n971Z", function(module, exports) {

module.exports = (parcelRequire("9mJ0d"));

});
parcelRequire.register("9mJ0d", function(module, exports) {

var $1dWYd = parcelRequire("1dWYd");
module.exports = $1dWYd;

});
parcelRequire.register("1dWYd", function(module, exports) {
parcelRequire("5gbij");

var $lahb7 = parcelRequire("lahb7");
module.exports = $lahb7.Object.entries;

});
parcelRequire.register("5gbij", function(module, exports) {

var $2iwSV = parcelRequire("2iwSV");

var $1ajaN = parcelRequire("1ajaN");
var $3d473530fee5d729$require$$entries = $1ajaN.entries;
// `Object.entries` method
// https://tc39.es/ecma262/#sec-object.entries
$2iwSV({
    target: "Object",
    stat: true
}, {
    entries: function entries(O) {
        return $3d473530fee5d729$require$$entries(O);
    }
});

});
parcelRequire.register("1ajaN", function(module, exports) {

var $awFtp = parcelRequire("awFtp");

var $dqhay = parcelRequire("dqhay");

var $hQAxZ = parcelRequire("hQAxZ");

var $gYLVQ = parcelRequire("gYLVQ");

var $fsYnl = parcelRequire("fsYnl");
var $0d9599047c6c9b0d$require$$propertyIsEnumerable = $fsYnl.f;
var $0d9599047c6c9b0d$var$propertyIsEnumerable = $dqhay($0d9599047c6c9b0d$require$$propertyIsEnumerable);
var $0d9599047c6c9b0d$var$push = $dqhay([].push);
// `Object.{ entries, values }` methods implementation
var $0d9599047c6c9b0d$var$createMethod = function(TO_ENTRIES) {
    return function(it) {
        var O = $gYLVQ(it);
        var keys = $hQAxZ(O);
        var length = keys.length;
        var i = 0;
        var result = [];
        var key;
        while(length > i){
            key = keys[i++];
            if (!$awFtp || $0d9599047c6c9b0d$var$propertyIsEnumerable(O, key)) $0d9599047c6c9b0d$var$push(result, TO_ENTRIES ? [
                key,
                O[key]
            ] : O[key]);
        }
        return result;
    };
};
module.exports = {
    // `Object.entries` method
    // https://tc39.es/ecma262/#sec-object.entries
    entries: $0d9599047c6c9b0d$var$createMethod(true),
    // `Object.values` method
    // https://tc39.es/ecma262/#sec-object.values
    values: $0d9599047c6c9b0d$var$createMethod(false)
};

});





parcelRequire.register("gV225", function(module, exports) {

module.exports = (parcelRequire("fJ9jw"));

});
parcelRequire.register("fJ9jw", function(module, exports) {
parcelRequire("i9UxW");

var $lahb7 = parcelRequire("lahb7");
module.exports = $lahb7.setTimeout;

});
parcelRequire.register("i9UxW", function(module, exports) {
// TODO: Remove this module from `core-js@4` since it's split to modules listed below
parcelRequire("fnucj");
parcelRequire("2hj1m");

});
parcelRequire.register("fnucj", function(module, exports) {

var $2iwSV = parcelRequire("2iwSV");

var $bbWQF = parcelRequire("bbWQF");

var $fPV2b = parcelRequire("fPV2b");
var $b3206d9cfbc6d8a0$var$setInterval = $fPV2b($bbWQF.setInterval, true);
// Bun / IE9- setInterval additional parameters fix
// https://html.spec.whatwg.org/multipage/timers-and-user-prompts.html#dom-setinterval
$2iwSV({
    global: true,
    bind: true,
    forced: $bbWQF.setInterval !== $b3206d9cfbc6d8a0$var$setInterval
}, {
    setInterval: $b3206d9cfbc6d8a0$var$setInterval
});

});
parcelRequire.register("fPV2b", function(module, exports) {
"use strict";

var $bbWQF = parcelRequire("bbWQF");

var $9ujZx = parcelRequire("9ujZx");

var $g0TxJ = parcelRequire("g0TxJ");

var $7h6ld = parcelRequire("7h6ld");

var $d0QM8 = parcelRequire("d0QM8");

var $iEWV5 = parcelRequire("iEWV5");

var $1dq59 = parcelRequire("1dq59");
var $b877dc4013741b31$var$Function = $bbWQF.Function;
// dirty IE9- and Bun 0.3.0- checks
var $b877dc4013741b31$var$WRAP = /MSIE .\./.test($d0QM8) || $7h6ld && function() {
    var version = $bbWQF.Bun.version.split(".");
    return version.length < 3 || version[0] == 0 && (version[1] < 3 || version[1] == 3 && version[2] == 0);
}();
// IE9- / Bun 0.3.0- setTimeout / setInterval / setImmediate additional parameters fix
// https://html.spec.whatwg.org/multipage/timers-and-user-prompts.html#timers
// https://github.com/oven-sh/bun/issues/1633
module.exports = function(scheduler, hasTimeArg) {
    var firstParamIndex = hasTimeArg ? 2 : 1;
    return $b877dc4013741b31$var$WRAP ? function(handler, timeout /* , ...arguments */ ) {
        var boundArgs = $1dq59(arguments.length, 1) > firstParamIndex;
        var fn = $g0TxJ(handler) ? handler : $b877dc4013741b31$var$Function(handler);
        var params = boundArgs ? $iEWV5(arguments, firstParamIndex) : [];
        var callback = boundArgs ? function() {
            $9ujZx(fn, this, params);
        } : fn;
        return hasTimeArg ? scheduler(callback, timeout) : scheduler(callback);
    } : scheduler;
};

});
parcelRequire.register("7h6ld", function(module, exports) {
/* global Bun -- Deno case */ module.exports = typeof Bun == "function" && Bun && typeof Bun.version == "string";

});



parcelRequire.register("2hj1m", function(module, exports) {

var $2iwSV = parcelRequire("2iwSV");

var $bbWQF = parcelRequire("bbWQF");

var $fPV2b = parcelRequire("fPV2b");
var $1a8bec77a6aae475$var$setTimeout = $fPV2b($bbWQF.setTimeout, true);
// Bun / IE9- setTimeout additional parameters fix
// https://html.spec.whatwg.org/multipage/timers-and-user-prompts.html#dom-settimeout
$2iwSV({
    global: true,
    bind: true,
    forced: $bbWQF.setTimeout !== $1a8bec77a6aae475$var$setTimeout
}, {
    setTimeout: $1a8bec77a6aae475$var$setTimeout
});

});




parcelRequire.register("aEQyb", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $7c26673965b54b17$export$2e2bcd8739ae039);

var $g3JES = parcelRequire("g3JES");

var $8ATmK = parcelRequire("8ATmK");

var $krJU9 = parcelRequire("krJU9");
function $7c26673965b54b17$var$insertWithoutScoping(cache, serialized) {
    if (cache.inserted[serialized.name] === undefined) return cache.insert("", serialized, cache.sheet, true);
}
function $7c26673965b54b17$var$merge(registered, css, className) {
    var registeredStyles = [];
    var rawClassName = (0, $krJU9.getRegisteredStyles)(registered, registeredStyles, className);
    if (registeredStyles.length < 2) return className;
    return rawClassName + css(registeredStyles);
}
var $7c26673965b54b17$var$createEmotion = function createEmotion(options) {
    var cache = (0, $g3JES.default)(options); // $FlowFixMe
    cache.sheet.speedy = function(value) {
        this.isSpeedy = value;
    };
    cache.compat = true;
    var css = function css() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var serialized = (0, $8ATmK.serializeStyles)(args, cache.registered, undefined);
        (0, $krJU9.insertStyles)(cache, serialized, false);
        return cache.key + "-" + serialized.name;
    };
    var keyframes = function keyframes() {
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        var serialized = (0, $8ATmK.serializeStyles)(args, cache.registered);
        var animation = "animation-" + serialized.name;
        $7c26673965b54b17$var$insertWithoutScoping(cache, {
            name: serialized.name,
            styles: "@keyframes " + animation + "{" + serialized.styles + "}"
        });
        return animation;
    };
    var injectGlobal = function injectGlobal() {
        for(var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)args[_key3] = arguments[_key3];
        var serialized = (0, $8ATmK.serializeStyles)(args, cache.registered);
        $7c26673965b54b17$var$insertWithoutScoping(cache, serialized);
    };
    var cx = function cx() {
        for(var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++)args[_key4] = arguments[_key4];
        return $7c26673965b54b17$var$merge(cache.registered, css, $7c26673965b54b17$var$classnames(args));
    };
    return {
        css: css,
        cx: cx,
        injectGlobal: injectGlobal,
        keyframes: keyframes,
        hydrate: function hydrate(ids) {
            ids.forEach(function(key) {
                cache.inserted[key] = true;
            });
        },
        flush: function flush() {
            cache.registered = {};
            cache.inserted = {};
            cache.sheet.flush();
        },
        // $FlowFixMe
        sheet: cache.sheet,
        cache: cache,
        getRegisteredStyles: (0, $krJU9.getRegisteredStyles).bind(null, cache.registered),
        merge: $7c26673965b54b17$var$merge.bind(null, cache.registered, css)
    };
};
var $7c26673965b54b17$var$classnames = function classnames(args) {
    var cls = "";
    for(var i = 0; i < args.length; i++){
        var arg = args[i];
        if (arg == null) continue;
        var toAdd = void 0;
        switch(typeof arg){
            case "boolean":
                break;
            case "object":
                if (Array.isArray(arg)) toAdd = classnames(arg);
                else {
                    toAdd = "";
                    for(var k in arg)if (arg[k] && k) {
                        toAdd && (toAdd += " ");
                        toAdd += k;
                    }
                }
                break;
            default:
                toAdd = arg;
        }
        if (toAdd) {
            cls && (cls += " ");
            cls += toAdd;
        }
    }
    return cls;
};
var $7c26673965b54b17$export$2e2bcd8739ae039 = $7c26673965b54b17$var$createEmotion;

});
parcelRequire.register("g3JES", function(module, exports) {

$parcel$export(module.exports, "default", () => $03046483de7f7b26$export$2e2bcd8739ae039);

var $6VCZP = parcelRequire("6VCZP");

var $fmezh = parcelRequire("fmezh");
parcelRequire("j9PTG");
parcelRequire("7kvbA");
var $03046483de7f7b26$var$identifierWithPointTracking = function identifierWithPointTracking(begin, points, index) {
    var previous = 0;
    var character = 0;
    while(true){
        previous = character;
        character = (0, $fmezh.peek)(); // &\f
        if (previous === 38 && character === 12) points[index] = 1;
        if ((0, $fmezh.token)(character)) break;
        (0, $fmezh.next)();
    }
    return (0, $fmezh.slice)(begin, (0, $fmezh.position));
};
var $03046483de7f7b26$var$toRules = function toRules(parsed, points) {
    // pretend we've started with a comma
    var index = -1;
    var character = 44;
    do switch((0, $fmezh.token)(character)){
        case 0:
            // &\f
            if (character === 38 && (0, $fmezh.peek)() === 12) // this is not 100% correct, we don't account for literal sequences here - like for example quoted strings
            // stylis inserts \f after & to know when & where it should replace this sequence with the context selector
            // and when it should just concatenate the outer and inner selectors
            // it's very unlikely for this sequence to actually appear in a different context, so we just leverage this fact here
            points[index] = 1;
            parsed[index] += $03046483de7f7b26$var$identifierWithPointTracking((0, $fmezh.position) - 1, points, index);
            break;
        case 2:
            parsed[index] += (0, $fmezh.delimit)(character);
            break;
        case 4:
            // comma
            if (character === 44) {
                // colon
                parsed[++index] = (0, $fmezh.peek)() === 58 ? "&\f" : "";
                points[index] = parsed[index].length;
                break;
            }
        // fallthrough
        default:
            parsed[index] += (0, $fmezh.from)(character);
    }
    while (character = (0, $fmezh.next)());
    return parsed;
};
var $03046483de7f7b26$var$getRules = function getRules(value, points) {
    return (0, $fmezh.dealloc)($03046483de7f7b26$var$toRules((0, $fmezh.alloc)(value), points));
}; // WeakSet would be more appropriate, but only WeakMap is supported in IE11
var $03046483de7f7b26$var$fixedElements = /* #__PURE__ */ new WeakMap();
var $03046483de7f7b26$var$compat = function compat(element) {
    if (element.type !== "rule" || !element.parent || // positive .length indicates that this rule contains pseudo
    // negative .length indicates that this rule has been already prefixed
    element.length < 1) return;
    var value = element.value, parent = element.parent;
    var isImplicitRule = element.column === parent.column && element.line === parent.line;
    while(parent.type !== "rule"){
        parent = parent.parent;
        if (!parent) return;
    } // short-circuit for the simplest case
    if (element.props.length === 1 && value.charCodeAt(0) !== 58 && !$03046483de7f7b26$var$fixedElements.get(parent)) return;
     // if this is an implicitly inserted rule (the one eagerly inserted at the each new nested level)
    // then the props has already been manipulated beforehand as they that array is shared between it and its "rule parent"
    if (isImplicitRule) return;
    $03046483de7f7b26$var$fixedElements.set(element, true);
    var points = [];
    var rules = $03046483de7f7b26$var$getRules(value, points);
    var parentRules = parent.props;
    for(var i = 0, k = 0; i < rules.length; i++)for(var j = 0; j < parentRules.length; j++, k++)element.props[k] = points[i] ? rules[i].replace(/&\f/g, parentRules[j]) : parentRules[j] + " " + rules[i];
};
var $03046483de7f7b26$var$removeLabel = function removeLabel(element) {
    if (element.type === "decl") {
        var value = element.value;
        if (value.charCodeAt(0) === 108 && // charcode for b
        value.charCodeAt(2) === 98) {
            // this ignores label
            element["return"] = "";
            element.value = "";
        }
    }
};
var $03046483de7f7b26$var$ignoreFlag = "emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason";
var $03046483de7f7b26$var$isIgnoringComment = function isIgnoringComment(element) {
    return element.type === "comm" && element.children.indexOf($03046483de7f7b26$var$ignoreFlag) > -1;
};
var $03046483de7f7b26$var$createUnsafeSelectorsAlarm = function createUnsafeSelectorsAlarm(cache) {
    return function(element, index, children) {
        if (element.type !== "rule" || cache.compat) return;
        var unsafePseudoClasses = element.value.match(/(:first|:nth|:nth-last)-child/g);
        if (unsafePseudoClasses) {
            var isNested = !!element.parent; // in nested rules comments become children of the "auto-inserted" rule and that's always the `element.parent`
            //
            // considering this input:
            // .a {
            //   .b /* comm */ {}
            //   color: hotpink;
            // }
            // we get output corresponding to this:
            // .a {
            //   & {
            //     /* comm */
            //     color: hotpink;
            //   }
            //   .b {}
            // }
            var commentContainer = isNested ? element.parent.children : children;
            for(var i = commentContainer.length - 1; i >= 0; i--){
                var node = commentContainer[i];
                if (node.line < element.line) break;
                 // it is quite weird but comments are *usually* put at `column: element.column - 1`
                // so we seek *from the end* for the node that is earlier than the rule's `element` and check that
                // this will also match inputs like this:
                // .a {
                //   /* comm */
                //   .b {}
                // }
                //
                // but that is fine
                //
                // it would be the easiest to change the placement of the comment to be the first child of the rule:
                // .a {
                //   .b { /* comm */ }
                // }
                // with such inputs we wouldn't have to search for the comment at all
                // TODO: consider changing this comment placement in the next major version
                if (node.column < element.column) {
                    if ($03046483de7f7b26$var$isIgnoringComment(node)) return;
                    break;
                }
            }
            unsafePseudoClasses.forEach(function(unsafePseudoClass) {
                console.error('The pseudo class "' + unsafePseudoClass + '" is potentially unsafe when doing server-side rendering. Try changing it to "' + unsafePseudoClass.split("-child")[0] + '-of-type".');
            });
        }
    };
};
var $03046483de7f7b26$var$isImportRule = function isImportRule(element) {
    return element.type.charCodeAt(1) === 105 && element.type.charCodeAt(0) === 64;
};
var $03046483de7f7b26$var$isPrependedWithRegularRules = function isPrependedWithRegularRules(index, children) {
    for(var i = index - 1; i >= 0; i--){
        if (!$03046483de7f7b26$var$isImportRule(children[i])) return true;
    }
    return false;
}; // use this to remove incorrect elements from further processing
// so they don't get handed to the `sheet` (or anything else)
// as that could potentially lead to additional logs which in turn could be overhelming to the user
var $03046483de7f7b26$var$nullifyElement = function nullifyElement(element) {
    element.type = "";
    element.value = "";
    element["return"] = "";
    element.children = "";
    element.props = "";
};
var $03046483de7f7b26$var$incorrectImportAlarm = function incorrectImportAlarm(element, index, children) {
    if (!$03046483de7f7b26$var$isImportRule(element)) return;
    if (element.parent) {
        console.error("`@import` rules can't be nested inside other rules. Please move it to the top level and put it before regular rules. Keep in mind that they can only be used within global styles.");
        $03046483de7f7b26$var$nullifyElement(element);
    } else if ($03046483de7f7b26$var$isPrependedWithRegularRules(index, children)) {
        console.error("`@import` rules can't be after other rules. Please put your `@import` rules before your other rules.");
        $03046483de7f7b26$var$nullifyElement(element);
    }
};
/* eslint-disable no-fallthrough */ function $03046483de7f7b26$var$prefix(value, length) {
    switch((0, $fmezh.hash)(value, length)){
        // color-adjust
        case 5103:
            return (0, $fmezh.WEBKIT) + "print-" + value + value;
        // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return (0, $fmezh.WEBKIT) + value + value;
        // appearance, user-select, transform, hyphens, text-size-adjust
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return (0, $fmezh.WEBKIT) + value + (0, $fmezh.MOZ) + value + (0, $fmezh.MS) + value + value;
        // flex, flex-direction
        case 6828:
        case 4268:
            return (0, $fmezh.WEBKIT) + value + (0, $fmezh.MS) + value + value;
        // order
        case 6165:
            return (0, $fmezh.WEBKIT) + value + (0, $fmezh.MS) + "flex-" + value + value;
        // align-items
        case 5187:
            return (0, $fmezh.WEBKIT) + value + (0, $fmezh.replace)(value, /(\w+).+(:[^]+)/, (0, $fmezh.WEBKIT) + "box-$1$2" + (0, $fmezh.MS) + "flex-$1$2") + value;
        // align-self
        case 5443:
            return (0, $fmezh.WEBKIT) + value + (0, $fmezh.MS) + "flex-item-" + (0, $fmezh.replace)(value, /flex-|-self/, "") + value;
        // align-content
        case 4675:
            return (0, $fmezh.WEBKIT) + value + (0, $fmezh.MS) + "flex-line-pack" + (0, $fmezh.replace)(value, /align-content|flex-|-self/, "") + value;
        // flex-shrink
        case 5548:
            return (0, $fmezh.WEBKIT) + value + (0, $fmezh.MS) + (0, $fmezh.replace)(value, "shrink", "negative") + value;
        // flex-basis
        case 5292:
            return (0, $fmezh.WEBKIT) + value + (0, $fmezh.MS) + (0, $fmezh.replace)(value, "basis", "preferred-size") + value;
        // flex-grow
        case 6060:
            return (0, $fmezh.WEBKIT) + "box-" + (0, $fmezh.replace)(value, "-grow", "") + (0, $fmezh.WEBKIT) + value + (0, $fmezh.MS) + (0, $fmezh.replace)(value, "grow", "positive") + value;
        // transition
        case 4554:
            return (0, $fmezh.WEBKIT) + (0, $fmezh.replace)(value, /([^-])(transform)/g, "$1" + (0, $fmezh.WEBKIT) + "$2") + value;
        // cursor
        case 6187:
            return (0, $fmezh.replace)((0, $fmezh.replace)((0, $fmezh.replace)(value, /(zoom-|grab)/, (0, $fmezh.WEBKIT) + "$1"), /(image-set)/, (0, $fmezh.WEBKIT) + "$1"), value, "") + value;
        // background, background-image
        case 5495:
        case 3959:
            return (0, $fmezh.replace)(value, /(image-set\([^]*)/, (0, $fmezh.WEBKIT) + "$1" + "$`$1");
        // justify-content
        case 4968:
            return (0, $fmezh.replace)((0, $fmezh.replace)(value, /(.+:)(flex-)?(.*)/, (0, $fmezh.WEBKIT) + "box-pack:$3" + (0, $fmezh.MS) + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + (0, $fmezh.WEBKIT) + value + value;
        // (margin|padding)-inline-(start|end)
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return (0, $fmezh.replace)(value, /(.+)-inline(.+)/, (0, $fmezh.WEBKIT) + "$1$2") + value;
        // (min|max)?(width|height|inline-size|block-size)
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            // stretch, max-content, min-content, fill-available
            if ((0, $fmezh.strlen)(value) - 1 - length > 6) switch((0, $fmezh.charat)(value, length + 1)){
                // (m)ax-content, (m)in-content
                case 109:
                    // -
                    if ((0, $fmezh.charat)(value, length + 4) !== 45) break;
                // (f)ill-available, (f)it-content
                case 102:
                    return (0, $fmezh.replace)(value, /(.+:)(.+)-([^]+)/, "$1" + (0, $fmezh.WEBKIT) + "$2-$3" + "$1" + (0, $fmezh.MOZ) + ((0, $fmezh.charat)(value, length + 3) == 108 ? "$3" : "$2-$3")) + value;
                // (s)tretch
                case 115:
                    return ~(0, $fmezh.indexof)(value, "stretch") ? $03046483de7f7b26$var$prefix((0, $fmezh.replace)(value, "stretch", "fill-available"), length) + value : value;
            }
            break;
        // position: sticky
        case 4949:
            // (s)ticky?
            if ((0, $fmezh.charat)(value, length + 1) !== 115) break;
        // display: (flex|inline-flex)
        case 6444:
            switch((0, $fmezh.charat)(value, (0, $fmezh.strlen)(value) - 3 - (~(0, $fmezh.indexof)(value, "!important") && 10))){
                // stic(k)y
                case 107:
                    return (0, $fmezh.replace)(value, ":", ":" + (0, $fmezh.WEBKIT)) + value;
                // (inline-)?fl(e)x
                case 101:
                    return (0, $fmezh.replace)(value, /(.+:)([^;!]+)(;|!.+)?/, "$1" + (0, $fmezh.WEBKIT) + ((0, $fmezh.charat)(value, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + (0, $fmezh.WEBKIT) + "$2$3" + "$1" + (0, $fmezh.MS) + "$2box$3") + value;
            }
            break;
        // writing-mode
        case 5936:
            switch((0, $fmezh.charat)(value, length + 11)){
                // vertical-l(r)
                case 114:
                    return (0, $fmezh.WEBKIT) + value + (0, $fmezh.MS) + (0, $fmezh.replace)(value, /[svh]\w+-[tblr]{2}/, "tb") + value;
                // vertical-r(l)
                case 108:
                    return (0, $fmezh.WEBKIT) + value + (0, $fmezh.MS) + (0, $fmezh.replace)(value, /[svh]\w+-[tblr]{2}/, "tb-rl") + value;
                // horizontal(-)tb
                case 45:
                    return (0, $fmezh.WEBKIT) + value + (0, $fmezh.MS) + (0, $fmezh.replace)(value, /[svh]\w+-[tblr]{2}/, "lr") + value;
            }
            return (0, $fmezh.WEBKIT) + value + (0, $fmezh.MS) + value + value;
    }
    return value;
}
var $03046483de7f7b26$var$prefixer = function prefixer(element, index, children, callback) {
    if (element.length > -1) {
        if (!element["return"]) switch(element.type){
            case 0, $fmezh.DECLARATION:
                element["return"] = $03046483de7f7b26$var$prefix(element.value, element.length);
                break;
            case 0, $fmezh.KEYFRAMES:
                return (0, $fmezh.serialize)([
                    (0, $fmezh.copy)(element, {
                        value: (0, $fmezh.replace)(element.value, "@", "@" + (0, $fmezh.WEBKIT))
                    })
                ], callback);
            case 0, $fmezh.RULESET:
                if (element.length) return (0, $fmezh.combine)(element.props, function(value) {
                    switch((0, $fmezh.match)(value, /(::plac\w+|:read-\w+)/)){
                        // :read-(only|write)
                        case ":read-only":
                        case ":read-write":
                            return (0, $fmezh.serialize)([
                                (0, $fmezh.copy)(element, {
                                    props: [
                                        (0, $fmezh.replace)(value, /:(read-\w+)/, ":" + (0, $fmezh.MOZ) + "$1")
                                    ]
                                })
                            ], callback);
                        // :placeholder
                        case "::placeholder":
                            return (0, $fmezh.serialize)([
                                (0, $fmezh.copy)(element, {
                                    props: [
                                        (0, $fmezh.replace)(value, /:(plac\w+)/, ":" + (0, $fmezh.WEBKIT) + "input-$1")
                                    ]
                                }),
                                (0, $fmezh.copy)(element, {
                                    props: [
                                        (0, $fmezh.replace)(value, /:(plac\w+)/, ":" + (0, $fmezh.MOZ) + "$1")
                                    ]
                                }),
                                (0, $fmezh.copy)(element, {
                                    props: [
                                        (0, $fmezh.replace)(value, /:(plac\w+)/, (0, $fmezh.MS) + "input-$1")
                                    ]
                                })
                            ], callback);
                    }
                    return "";
                });
        }
    }
};
var $03046483de7f7b26$var$defaultStylisPlugins = [
    $03046483de7f7b26$var$prefixer
];
var $03046483de7f7b26$export$2e2bcd8739ae039 = function createCache(options) {
    var key = options.key;
    if (key === "css") {
        var ssrStyles = document.querySelectorAll("style[data-emotion]:not([data-s])"); // get SSRed styles out of the way of React's hydration
        // document.head is a safe place to move them to(though note document.head is not necessarily the last place they will be)
        // note this very very intentionally targets all style elements regardless of the key to ensure
        // that creating a cache works inside of render of a React component
        Array.prototype.forEach.call(ssrStyles, function(node) {
            // we want to only move elements which have a space in the data-emotion attribute value
            // because that indicates that it is an Emotion 11 server-side rendered style elements
            // while we will already ignore Emotion 11 client-side inserted styles because of the :not([data-s]) part in the selector
            // Emotion 10 client-side inserted styles did not have data-s (but importantly did not have a space in their data-emotion attributes)
            // so checking for the space ensures that loading Emotion 11 after Emotion 10 has inserted some styles
            // will not result in the Emotion 10 styles being destroyed
            var dataEmotionAttribute = node.getAttribute("data-emotion");
            if (dataEmotionAttribute.indexOf(" ") === -1) return;
            document.head.appendChild(node);
            node.setAttribute("data-s", "");
        });
    }
    var stylisPlugins = options.stylisPlugins || $03046483de7f7b26$var$defaultStylisPlugins;
    var inserted = {};
    var container;
    var nodesToHydrate = [];
    container = options.container || document.head;
    Array.prototype.forEach.call(// means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll('style[data-emotion^="' + key + ' "]'), function(node) {
        var attrib = node.getAttribute("data-emotion").split(" "); // $FlowFixMe
        for(var i = 1; i < attrib.length; i++)inserted[attrib[i]] = true;
        nodesToHydrate.push(node);
    });
    var _insert;
    var omnipresentPlugins = [
        $03046483de7f7b26$var$compat,
        $03046483de7f7b26$var$removeLabel
    ];
    var currentSheet;
    var finalizingPlugins = [
        (0, $fmezh.stringify),
        (0, $fmezh.rulesheet)(function(rule) {
            currentSheet.insert(rule);
        })
    ];
    var serializer = (0, $fmezh.middleware)(omnipresentPlugins.concat(stylisPlugins, finalizingPlugins));
    var stylis = function stylis(styles) {
        return (0, $fmezh.serialize)((0, $fmezh.compile)(styles), serializer);
    };
    _insert = function insert(selector, serialized, sheet, shouldCache) {
        currentSheet = sheet;
        stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
        if (shouldCache) cache.inserted[serialized.name] = true;
    };
    var cache = {
        key: key,
        sheet: new (0, $6VCZP.StyleSheet)({
            key: key,
            container: container,
            nonce: options.nonce,
            speedy: options.speedy,
            prepend: options.prepend,
            insertionPoint: options.insertionPoint
        }),
        nonce: options.nonce,
        inserted: inserted,
        registered: {},
        insert: _insert
    };
    cache.sheet.hydrate(nodesToHydrate);
    return cache;
};

});
parcelRequire.register("6VCZP", function(module, exports) {

$parcel$export(module.exports, "StyleSheet", () => $50b650cfa703c1c5$export$9d753cd7ae895cce);
/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/ // $FlowFixMe
function $50b650cfa703c1c5$var$sheetForTag(tag) {
    if (tag.sheet) // $FlowFixMe
    return tag.sheet;
     // this weirdness brought to you by firefox
    /* istanbul ignore next */ for(var i = 0; i < document.styleSheets.length; i++){
        if (document.styleSheets[i].ownerNode === tag) // $FlowFixMe
        return document.styleSheets[i];
    }
}
function $50b650cfa703c1c5$var$createStyleElement(options) {
    var tag = document.createElement("style");
    tag.setAttribute("data-emotion", options.key);
    if (options.nonce !== undefined) tag.setAttribute("nonce", options.nonce);
    tag.appendChild(document.createTextNode(""));
    tag.setAttribute("data-s", "");
    return tag;
}
var $50b650cfa703c1c5$export$9d753cd7ae895cce = /*#__PURE__*/ function() {
    // Using Node instead of HTMLElement since container may be a ShadowRoot
    function StyleSheet(options) {
        var _this = this;
        this._insertTag = function(tag) {
            var before;
            if (_this.tags.length === 0) {
                if (_this.insertionPoint) before = _this.insertionPoint.nextSibling;
                else if (_this.prepend) before = _this.container.firstChild;
                else before = _this.before;
            } else before = _this.tags[_this.tags.length - 1].nextSibling;
            _this.container.insertBefore(tag, before);
            _this.tags.push(tag);
        };
        this.isSpeedy = options.speedy === undefined ? true : options.speedy;
        this.tags = [];
        this.ctr = 0;
        this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets
        this.key = options.key;
        this.container = options.container;
        this.prepend = options.prepend;
        this.insertionPoint = options.insertionPoint;
        this.before = null;
    }
    var _proto = StyleSheet.prototype;
    _proto.hydrate = function hydrate(nodes) {
        nodes.forEach(this._insertTag);
    };
    _proto.insert = function insert(rule) {
        // the max length is how many rules we have per style tag, it's 65000 in speedy mode
        // it's 1 in dev because we insert source maps that map a single rule to a location
        // and you can only have one source map per style tag
        if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) this._insertTag($50b650cfa703c1c5$var$createStyleElement(this));
        var tag = this.tags[this.tags.length - 1];
        var isImportRule;
        if (this.isSpeedy) {
            var sheet = $50b650cfa703c1c5$var$sheetForTag(tag);
            try {
                // this is the ultrafast version, works across browsers
                // the big drawback is that the css won't be editable in devtools
                sheet.insertRule(rule, sheet.cssRules.length);
            } catch (e) {}
        } else tag.appendChild(document.createTextNode(rule));
        this.ctr++;
    };
    _proto.flush = function flush() {
        // $FlowFixMe
        this.tags.forEach(function(tag) {
            return tag.parentNode && tag.parentNode.removeChild(tag);
        });
        this.tags = [];
        this.ctr = 0;
    };
    return StyleSheet;
}();

});

parcelRequire.register("fmezh", function(module, exports) {

$parcel$export(module.exports, "MS", () => $1ab441a42a00260e$export$71ad59f2e432cfe8);
$parcel$export(module.exports, "MOZ", () => $1ab441a42a00260e$export$2c0f367103c8d01c);
$parcel$export(module.exports, "WEBKIT", () => $1ab441a42a00260e$export$39dfd62a25e0fe93);
$parcel$export(module.exports, "RULESET", () => $1ab441a42a00260e$export$aa3a2e812ca8570d);
$parcel$export(module.exports, "DECLARATION", () => $1ab441a42a00260e$export$527d108ccf083c2b);
$parcel$export(module.exports, "KEYFRAMES", () => $1ab441a42a00260e$export$b44a8529a35fcb60);
$parcel$export(module.exports, "from", () => $1ab441a42a00260e$export$6788812c4e6611e6);
$parcel$export(module.exports, "hash", () => $1ab441a42a00260e$export$d6af199866bfb566);
$parcel$export(module.exports, "charat", () => $1ab441a42a00260e$export$a9db5e087081082d);
$parcel$export(module.exports, "match", () => $1ab441a42a00260e$export$4659b591c19bdf3d);
$parcel$export(module.exports, "replace", () => $1ab441a42a00260e$export$77ad94ebf1c2b9ed);
$parcel$export(module.exports, "indexof", () => $1ab441a42a00260e$export$f8e21b1e77979a08);
$parcel$export(module.exports, "strlen", () => $1ab441a42a00260e$export$36776f635604f274);
$parcel$export(module.exports, "combine", () => $1ab441a42a00260e$export$1be1fc439b849fdf);
$parcel$export(module.exports, "position", () => $1ab441a42a00260e$export$5880b8b5730aff45);
$parcel$export(module.exports, "copy", () => $1ab441a42a00260e$export$784d13d8ee351f07);
$parcel$export(module.exports, "next", () => $1ab441a42a00260e$export$48cfd1e771a65c4f);
$parcel$export(module.exports, "peek", () => $1ab441a42a00260e$export$4d3fb11e950abb9e);
$parcel$export(module.exports, "slice", () => $1ab441a42a00260e$export$58adb3bec8346d0f);
$parcel$export(module.exports, "token", () => $1ab441a42a00260e$export$9e1725a4cfeada27);
$parcel$export(module.exports, "alloc", () => $1ab441a42a00260e$export$2de70f21292aac9e);
$parcel$export(module.exports, "dealloc", () => $1ab441a42a00260e$export$45918ac1574455b1);
$parcel$export(module.exports, "delimit", () => $1ab441a42a00260e$export$410ac95b9ec204b8);
$parcel$export(module.exports, "compile", () => $1ab441a42a00260e$export$ef7acd7185315e22);
$parcel$export(module.exports, "serialize", () => $1ab441a42a00260e$export$dfdc1655ccc5b9cb);
$parcel$export(module.exports, "stringify", () => $1ab441a42a00260e$export$fac44ee5b035f737);
$parcel$export(module.exports, "middleware", () => $1ab441a42a00260e$export$5a7767152ae0305f);
$parcel$export(module.exports, "rulesheet", () => $1ab441a42a00260e$export$38bcb760f1d4871c);
var $1ab441a42a00260e$export$71ad59f2e432cfe8 = "-ms-";
var $1ab441a42a00260e$export$2c0f367103c8d01c = "-moz-";
var $1ab441a42a00260e$export$39dfd62a25e0fe93 = "-webkit-";
var $1ab441a42a00260e$export$a29989082612d0d9 = "comm";
var $1ab441a42a00260e$export$aa3a2e812ca8570d = "rule";
var $1ab441a42a00260e$export$527d108ccf083c2b = "decl";
var $1ab441a42a00260e$export$d3d35020fa5b54f0 = "@page";
var $1ab441a42a00260e$export$500415a86c544f73 = "@media";
var $1ab441a42a00260e$export$a763edbf796b780a = "@import";
var $1ab441a42a00260e$export$2790aeb8b4e5c826 = "@charset";
var $1ab441a42a00260e$export$1cc683e23b84b133 = "@viewport";
var $1ab441a42a00260e$export$9447a5efea57e862 = "@supports";
var $1ab441a42a00260e$export$ef011b4e114b1fba = "@document";
var $1ab441a42a00260e$export$6aad947bda0f3f46 = "@namespace";
var $1ab441a42a00260e$export$b44a8529a35fcb60 = "@keyframes";
var $1ab441a42a00260e$export$2c16de31893252e6 = "@font-face";
var $1ab441a42a00260e$export$3d846dd52e150c6f = "@counter-style";
var $1ab441a42a00260e$export$22314bfbb57653fe = "@font-feature-values";
var $1ab441a42a00260e$export$d773506282b3cfe6 = "@layer";
var $1ab441a42a00260e$export$2335f513bbd82c6d = Math.abs;
var $1ab441a42a00260e$export$6788812c4e6611e6 = String.fromCharCode;
var $1ab441a42a00260e$export$e6e34fd1f2686227 = Object.assign;
function $1ab441a42a00260e$export$d6af199866bfb566(e, r) {
    return $1ab441a42a00260e$export$a9db5e087081082d(e, 0) ^ 45 ? (((r << 2 ^ $1ab441a42a00260e$export$a9db5e087081082d(e, 0)) << 2 ^ $1ab441a42a00260e$export$a9db5e087081082d(e, 1)) << 2 ^ $1ab441a42a00260e$export$a9db5e087081082d(e, 2)) << 2 ^ $1ab441a42a00260e$export$a9db5e087081082d(e, 3) : 0;
}
function $1ab441a42a00260e$export$87c2784dc9fc4ab(e) {
    return e.trim();
}
function $1ab441a42a00260e$export$4659b591c19bdf3d(e, r) {
    return (e = r.exec(e)) ? e[0] : e;
}
function $1ab441a42a00260e$export$77ad94ebf1c2b9ed(e, r, a) {
    return e.replace(r, a);
}
function $1ab441a42a00260e$export$f8e21b1e77979a08(e, r) {
    return e.indexOf(r);
}
function $1ab441a42a00260e$export$a9db5e087081082d(e, r) {
    return e.charCodeAt(r) | 0;
}
function $1ab441a42a00260e$export$2f35ab04d2335697(e, r, a) {
    return e.slice(r, a);
}
function $1ab441a42a00260e$export$36776f635604f274(e) {
    return e.length;
}
function $1ab441a42a00260e$export$f9084667e487ed46(e) {
    return e.length;
}
function $1ab441a42a00260e$export$10d8903dec122b9d(e, r) {
    return r.push(e), e;
}
function $1ab441a42a00260e$export$1be1fc439b849fdf(e, r) {
    return e.map(r).join("");
}
var $1ab441a42a00260e$export$53f1d5ea8de3d7c = 1;
var $1ab441a42a00260e$export$4e0c71f277ca26b3 = 1;
var $1ab441a42a00260e$export$f24224f1c91d8156 = 0;
var $1ab441a42a00260e$export$5880b8b5730aff45 = 0;
var $1ab441a42a00260e$export$c0306caf338ac095 = 0;
var $1ab441a42a00260e$export$30a86d91af8ff6e6 = "";
function $1ab441a42a00260e$export$35059013cd4a06db(e, r, a, n, c, s, t) {
    return {
        value: e,
        root: r,
        parent: a,
        type: n,
        props: c,
        children: s,
        line: $1ab441a42a00260e$export$53f1d5ea8de3d7c,
        column: $1ab441a42a00260e$export$4e0c71f277ca26b3,
        length: t,
        return: ""
    };
}
function $1ab441a42a00260e$export$784d13d8ee351f07(e, r) {
    return $1ab441a42a00260e$export$e6e34fd1f2686227($1ab441a42a00260e$export$35059013cd4a06db("", null, null, "", null, null, 0), e, {
        length: -e.length
    }, r);
}
function $1ab441a42a00260e$export$eba6f6f03b0a92e7() {
    return $1ab441a42a00260e$export$c0306caf338ac095;
}
function $1ab441a42a00260e$export$232faf9add678146() {
    $1ab441a42a00260e$export$c0306caf338ac095 = $1ab441a42a00260e$export$5880b8b5730aff45 > 0 ? $1ab441a42a00260e$export$a9db5e087081082d($1ab441a42a00260e$export$30a86d91af8ff6e6, --$1ab441a42a00260e$export$5880b8b5730aff45) : 0;
    if ($1ab441a42a00260e$export$4e0c71f277ca26b3--, $1ab441a42a00260e$export$c0306caf338ac095 === 10) $1ab441a42a00260e$export$4e0c71f277ca26b3 = 1, $1ab441a42a00260e$export$53f1d5ea8de3d7c--;
    return $1ab441a42a00260e$export$c0306caf338ac095;
}
function $1ab441a42a00260e$export$48cfd1e771a65c4f() {
    $1ab441a42a00260e$export$c0306caf338ac095 = $1ab441a42a00260e$export$5880b8b5730aff45 < $1ab441a42a00260e$export$f24224f1c91d8156 ? $1ab441a42a00260e$export$a9db5e087081082d($1ab441a42a00260e$export$30a86d91af8ff6e6, $1ab441a42a00260e$export$5880b8b5730aff45++) : 0;
    if ($1ab441a42a00260e$export$4e0c71f277ca26b3++, $1ab441a42a00260e$export$c0306caf338ac095 === 10) $1ab441a42a00260e$export$4e0c71f277ca26b3 = 1, $1ab441a42a00260e$export$53f1d5ea8de3d7c++;
    return $1ab441a42a00260e$export$c0306caf338ac095;
}
function $1ab441a42a00260e$export$4d3fb11e950abb9e() {
    return $1ab441a42a00260e$export$a9db5e087081082d($1ab441a42a00260e$export$30a86d91af8ff6e6, $1ab441a42a00260e$export$5880b8b5730aff45);
}
function $1ab441a42a00260e$export$e88cb2efb12ae807() {
    return $1ab441a42a00260e$export$5880b8b5730aff45;
}
function $1ab441a42a00260e$export$58adb3bec8346d0f(e, r) {
    return $1ab441a42a00260e$export$2f35ab04d2335697($1ab441a42a00260e$export$30a86d91af8ff6e6, e, r);
}
function $1ab441a42a00260e$export$9e1725a4cfeada27(e) {
    switch(e){
        case 0:
        case 9:
        case 10:
        case 13:
        case 32:
            return 5;
        case 33:
        case 43:
        case 44:
        case 47:
        case 62:
        case 64:
        case 126:
        case 59:
        case 123:
        case 125:
            return 4;
        case 58:
            return 3;
        case 34:
        case 39:
        case 40:
        case 91:
            return 2;
        case 41:
        case 93:
            return 1;
    }
    return 0;
}
function $1ab441a42a00260e$export$2de70f21292aac9e(e) {
    return $1ab441a42a00260e$export$53f1d5ea8de3d7c = $1ab441a42a00260e$export$4e0c71f277ca26b3 = 1, $1ab441a42a00260e$export$f24224f1c91d8156 = $1ab441a42a00260e$export$36776f635604f274($1ab441a42a00260e$export$30a86d91af8ff6e6 = e), $1ab441a42a00260e$export$5880b8b5730aff45 = 0, [];
}
function $1ab441a42a00260e$export$45918ac1574455b1(e) {
    return $1ab441a42a00260e$export$30a86d91af8ff6e6 = "", e;
}
function $1ab441a42a00260e$export$410ac95b9ec204b8(e) {
    return $1ab441a42a00260e$export$87c2784dc9fc4ab($1ab441a42a00260e$export$58adb3bec8346d0f($1ab441a42a00260e$export$5880b8b5730aff45 - 1, $1ab441a42a00260e$export$c889f2fcc19dbf12(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function $1ab441a42a00260e$export$660b2ee2d4fb4eff(e) {
    return $1ab441a42a00260e$export$45918ac1574455b1($1ab441a42a00260e$export$5f8c09e3ae6f64e1($1ab441a42a00260e$export$2de70f21292aac9e(e)));
}
function $1ab441a42a00260e$export$7af1228ff777d175(e) {
    while($1ab441a42a00260e$export$c0306caf338ac095 = $1ab441a42a00260e$export$4d3fb11e950abb9e())if ($1ab441a42a00260e$export$c0306caf338ac095 < 33) $1ab441a42a00260e$export$48cfd1e771a65c4f();
    else break;
    return $1ab441a42a00260e$export$9e1725a4cfeada27(e) > 2 || $1ab441a42a00260e$export$9e1725a4cfeada27($1ab441a42a00260e$export$c0306caf338ac095) > 3 ? "" : " ";
}
function $1ab441a42a00260e$export$5f8c09e3ae6f64e1(e) {
    while($1ab441a42a00260e$export$48cfd1e771a65c4f())switch($1ab441a42a00260e$export$9e1725a4cfeada27($1ab441a42a00260e$export$c0306caf338ac095)){
        case 0:
            $1ab441a42a00260e$export$10d8903dec122b9d($1ab441a42a00260e$export$c2ab62c7bf24634($1ab441a42a00260e$export$5880b8b5730aff45 - 1), e);
            break;
        case 2:
            $1ab441a42a00260e$export$10d8903dec122b9d($1ab441a42a00260e$export$410ac95b9ec204b8($1ab441a42a00260e$export$c0306caf338ac095), e);
            break;
        default:
            $1ab441a42a00260e$export$10d8903dec122b9d($1ab441a42a00260e$export$6788812c4e6611e6($1ab441a42a00260e$export$c0306caf338ac095), e);
    }
    return e;
}
function $1ab441a42a00260e$export$955ba06d119e085e(e, r) {
    while(--r && $1ab441a42a00260e$export$48cfd1e771a65c4f())if ($1ab441a42a00260e$export$c0306caf338ac095 < 48 || $1ab441a42a00260e$export$c0306caf338ac095 > 102 || $1ab441a42a00260e$export$c0306caf338ac095 > 57 && $1ab441a42a00260e$export$c0306caf338ac095 < 65 || $1ab441a42a00260e$export$c0306caf338ac095 > 70 && $1ab441a42a00260e$export$c0306caf338ac095 < 97) break;
    return $1ab441a42a00260e$export$58adb3bec8346d0f(e, $1ab441a42a00260e$export$e88cb2efb12ae807() + (r < 6 && $1ab441a42a00260e$export$4d3fb11e950abb9e() == 32 && $1ab441a42a00260e$export$48cfd1e771a65c4f() == 32));
}
function $1ab441a42a00260e$export$c889f2fcc19dbf12(e) {
    while($1ab441a42a00260e$export$48cfd1e771a65c4f())switch($1ab441a42a00260e$export$c0306caf338ac095){
        case e:
            return $1ab441a42a00260e$export$5880b8b5730aff45;
        case 34:
        case 39:
            if (e !== 34 && e !== 39) $1ab441a42a00260e$export$c889f2fcc19dbf12($1ab441a42a00260e$export$c0306caf338ac095);
            break;
        case 40:
            if (e === 41) $1ab441a42a00260e$export$c889f2fcc19dbf12(e);
            break;
        case 92:
            $1ab441a42a00260e$export$48cfd1e771a65c4f();
            break;
    }
    return $1ab441a42a00260e$export$5880b8b5730aff45;
}
function $1ab441a42a00260e$export$4254d4e2b3745c4c(e, r) {
    while($1ab441a42a00260e$export$48cfd1e771a65c4f())if (e + $1ab441a42a00260e$export$c0306caf338ac095 === 57) break;
    else if (e + $1ab441a42a00260e$export$c0306caf338ac095 === 84 && $1ab441a42a00260e$export$4d3fb11e950abb9e() === 47) break;
    return "/*" + $1ab441a42a00260e$export$58adb3bec8346d0f(r, $1ab441a42a00260e$export$5880b8b5730aff45 - 1) + "*" + $1ab441a42a00260e$export$6788812c4e6611e6(e === 47 ? e : $1ab441a42a00260e$export$48cfd1e771a65c4f());
}
function $1ab441a42a00260e$export$c2ab62c7bf24634(e) {
    while(!$1ab441a42a00260e$export$9e1725a4cfeada27($1ab441a42a00260e$export$4d3fb11e950abb9e()))$1ab441a42a00260e$export$48cfd1e771a65c4f();
    return $1ab441a42a00260e$export$58adb3bec8346d0f(e, $1ab441a42a00260e$export$5880b8b5730aff45);
}
function $1ab441a42a00260e$export$ef7acd7185315e22(e) {
    return $1ab441a42a00260e$export$45918ac1574455b1($1ab441a42a00260e$export$98e6a39c04603d36("", null, null, null, [
        ""
    ], e = $1ab441a42a00260e$export$2de70f21292aac9e(e), 0, [
        0
    ], e));
}
function $1ab441a42a00260e$export$98e6a39c04603d36(e, r, a, n, c, s, t, u, i) {
    var f = 0;
    var o = 0;
    var l = t;
    var v = 0;
    var p = 0;
    var h = 0;
    var b = 1;
    var w = 1;
    var d = 1;
    var $ = 0;
    var g = "";
    var m = c;
    var x = s;
    var y = n;
    var j = g;
    while(w)switch(h = $, $ = $1ab441a42a00260e$export$48cfd1e771a65c4f()){
        case 40:
            if (h != 108 && $1ab441a42a00260e$export$a9db5e087081082d(j, l - 1) == 58) {
                if ($1ab441a42a00260e$export$f8e21b1e77979a08(j += $1ab441a42a00260e$export$77ad94ebf1c2b9ed($1ab441a42a00260e$export$410ac95b9ec204b8($), "&", "&\f"), "&\f") != -1) d = -1;
                break;
            }
        case 34:
        case 39:
        case 91:
            j += $1ab441a42a00260e$export$410ac95b9ec204b8($);
            break;
        case 9:
        case 10:
        case 13:
        case 32:
            j += $1ab441a42a00260e$export$7af1228ff777d175(h);
            break;
        case 92:
            j += $1ab441a42a00260e$export$955ba06d119e085e($1ab441a42a00260e$export$e88cb2efb12ae807() - 1, 7);
            continue;
        case 47:
            switch($1ab441a42a00260e$export$4d3fb11e950abb9e()){
                case 42:
                case 47:
                    $1ab441a42a00260e$export$10d8903dec122b9d($1ab441a42a00260e$export$4a34f930e789283c($1ab441a42a00260e$export$4254d4e2b3745c4c($1ab441a42a00260e$export$48cfd1e771a65c4f(), $1ab441a42a00260e$export$e88cb2efb12ae807()), r, a), i);
                    break;
                default:
                    j += "/";
            }
            break;
        case 123 * b:
            u[f++] = $1ab441a42a00260e$export$36776f635604f274(j) * d;
        case 125 * b:
        case 59:
        case 0:
            switch($){
                case 0:
                case 125:
                    w = 0;
                case 59 + o:
                    if (d == -1) j = $1ab441a42a00260e$export$77ad94ebf1c2b9ed(j, /\f/g, "");
                    if (p > 0 && $1ab441a42a00260e$export$36776f635604f274(j) - l) $1ab441a42a00260e$export$10d8903dec122b9d(p > 32 ? $1ab441a42a00260e$export$f8483753829ec8f3(j + ";", n, a, l - 1) : $1ab441a42a00260e$export$f8483753829ec8f3($1ab441a42a00260e$export$77ad94ebf1c2b9ed(j, " ", "") + ";", n, a, l - 2), i);
                    break;
                case 59:
                    j += ";";
                default:
                    $1ab441a42a00260e$export$10d8903dec122b9d(y = $1ab441a42a00260e$export$3307ffa7023ede1e(j, r, a, f, o, c, u, g, m = [], x = [], l), s);
                    if ($ === 123) {
                        if (o === 0) $1ab441a42a00260e$export$98e6a39c04603d36(j, r, y, y, m, s, l, u, x);
                        else switch(v === 99 && $1ab441a42a00260e$export$a9db5e087081082d(j, 3) === 110 ? 100 : v){
                            case 100:
                            case 108:
                            case 109:
                            case 115:
                                $1ab441a42a00260e$export$98e6a39c04603d36(e, y, y, n && $1ab441a42a00260e$export$10d8903dec122b9d($1ab441a42a00260e$export$3307ffa7023ede1e(e, y, y, 0, 0, c, u, g, c, m = [], l), x), c, x, l, u, n ? m : x);
                                break;
                            default:
                                $1ab441a42a00260e$export$98e6a39c04603d36(j, y, y, y, [
                                    ""
                                ], x, 0, u, x);
                        }
                    }
            }
            f = o = p = 0, b = d = 1, g = j = "", l = t;
            break;
        case 58:
            l = 1 + $1ab441a42a00260e$export$36776f635604f274(j), p = h;
        default:
            if (b < 1) {
                if ($ == 123) --b;
                else if ($ == 125 && b++ == 0 && $1ab441a42a00260e$export$232faf9add678146() == 125) continue;
            }
            switch(j += $1ab441a42a00260e$export$6788812c4e6611e6($), $ * b){
                case 38:
                    d = o > 0 ? 1 : (j += "\f", -1);
                    break;
                case 44:
                    u[f++] = ($1ab441a42a00260e$export$36776f635604f274(j) - 1) * d, d = 1;
                    break;
                case 64:
                    if ($1ab441a42a00260e$export$4d3fb11e950abb9e() === 45) j += $1ab441a42a00260e$export$410ac95b9ec204b8($1ab441a42a00260e$export$48cfd1e771a65c4f());
                    v = $1ab441a42a00260e$export$4d3fb11e950abb9e(), o = l = $1ab441a42a00260e$export$36776f635604f274(g = j += $1ab441a42a00260e$export$c2ab62c7bf24634($1ab441a42a00260e$export$e88cb2efb12ae807())), $++;
                    break;
                case 45:
                    if (h === 45 && $1ab441a42a00260e$export$36776f635604f274(j) == 2) b = 0;
            }
    }
    return s;
}
function $1ab441a42a00260e$export$3307ffa7023ede1e(e, r, a, n, s, t, u, i, f, o, l) {
    var v = s - 1;
    var p = s === 0 ? t : [
        ""
    ];
    var h = $1ab441a42a00260e$export$f9084667e487ed46(p);
    for(var b = 0, w = 0, d = 0; b < n; ++b)for(var $ = 0, k = $1ab441a42a00260e$export$2f35ab04d2335697(e, v + 1, v = $1ab441a42a00260e$export$2335f513bbd82c6d(w = u[b])), m = e; $ < h; ++$)if (m = $1ab441a42a00260e$export$87c2784dc9fc4ab(w > 0 ? p[$] + " " + k : $1ab441a42a00260e$export$77ad94ebf1c2b9ed(k, /&\f/g, p[$]))) f[d++] = m;
    return $1ab441a42a00260e$export$35059013cd4a06db(e, r, a, s === 0 ? $1ab441a42a00260e$export$aa3a2e812ca8570d : i, f, o, l);
}
function $1ab441a42a00260e$export$4a34f930e789283c(e, r, a) {
    return $1ab441a42a00260e$export$35059013cd4a06db(e, r, a, $1ab441a42a00260e$export$a29989082612d0d9, $1ab441a42a00260e$export$6788812c4e6611e6($1ab441a42a00260e$export$eba6f6f03b0a92e7()), $1ab441a42a00260e$export$2f35ab04d2335697(e, 2, -2), 0);
}
function $1ab441a42a00260e$export$f8483753829ec8f3(e, r, a, n) {
    return $1ab441a42a00260e$export$35059013cd4a06db(e, r, a, $1ab441a42a00260e$export$527d108ccf083c2b, $1ab441a42a00260e$export$2f35ab04d2335697(e, 0, n), $1ab441a42a00260e$export$2f35ab04d2335697(e, n + 1, -1), n);
}
function $1ab441a42a00260e$export$82e9f45cca5ba907(n, c, s) {
    switch($1ab441a42a00260e$export$d6af199866bfb566(n, c)){
        case 5103:
            return $1ab441a42a00260e$export$39dfd62a25e0fe93 + "print-" + n + n;
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return $1ab441a42a00260e$export$39dfd62a25e0fe93 + n + n;
        case 4789:
            return $1ab441a42a00260e$export$2c0f367103c8d01c + n + n;
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return $1ab441a42a00260e$export$39dfd62a25e0fe93 + n + $1ab441a42a00260e$export$2c0f367103c8d01c + n + $1ab441a42a00260e$export$71ad59f2e432cfe8 + n + n;
        case 5936:
            switch($1ab441a42a00260e$export$a9db5e087081082d(n, c + 11)){
                case 114:
                    return $1ab441a42a00260e$export$39dfd62a25e0fe93 + n + $1ab441a42a00260e$export$71ad59f2e432cfe8 + $1ab441a42a00260e$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb") + n;
                case 108:
                    return $1ab441a42a00260e$export$39dfd62a25e0fe93 + n + $1ab441a42a00260e$export$71ad59f2e432cfe8 + $1ab441a42a00260e$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb-rl") + n;
                case 45:
                    return $1ab441a42a00260e$export$39dfd62a25e0fe93 + n + $1ab441a42a00260e$export$71ad59f2e432cfe8 + $1ab441a42a00260e$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "lr") + n;
            }
        case 6828:
        case 4268:
        case 2903:
            return $1ab441a42a00260e$export$39dfd62a25e0fe93 + n + $1ab441a42a00260e$export$71ad59f2e432cfe8 + n + n;
        case 6165:
            return $1ab441a42a00260e$export$39dfd62a25e0fe93 + n + $1ab441a42a00260e$export$71ad59f2e432cfe8 + "flex-" + n + n;
        case 5187:
            return $1ab441a42a00260e$export$39dfd62a25e0fe93 + n + $1ab441a42a00260e$export$77ad94ebf1c2b9ed(n, /(\w+).+(:[^]+)/, $1ab441a42a00260e$export$39dfd62a25e0fe93 + "box-$1$2" + $1ab441a42a00260e$export$71ad59f2e432cfe8 + "flex-$1$2") + n;
        case 5443:
            return $1ab441a42a00260e$export$39dfd62a25e0fe93 + n + $1ab441a42a00260e$export$71ad59f2e432cfe8 + "flex-item-" + $1ab441a42a00260e$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") + (!$1ab441a42a00260e$export$4659b591c19bdf3d(n, /flex-|baseline/) ? $1ab441a42a00260e$export$71ad59f2e432cfe8 + "grid-row-" + $1ab441a42a00260e$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") : "") + n;
        case 4675:
            return $1ab441a42a00260e$export$39dfd62a25e0fe93 + n + $1ab441a42a00260e$export$71ad59f2e432cfe8 + "flex-line-pack" + $1ab441a42a00260e$export$77ad94ebf1c2b9ed(n, /align-content|flex-|-self/g, "") + n;
        case 5548:
            return $1ab441a42a00260e$export$39dfd62a25e0fe93 + n + $1ab441a42a00260e$export$71ad59f2e432cfe8 + $1ab441a42a00260e$export$77ad94ebf1c2b9ed(n, "shrink", "negative") + n;
        case 5292:
            return $1ab441a42a00260e$export$39dfd62a25e0fe93 + n + $1ab441a42a00260e$export$71ad59f2e432cfe8 + $1ab441a42a00260e$export$77ad94ebf1c2b9ed(n, "basis", "preferred-size") + n;
        case 6060:
            return $1ab441a42a00260e$export$39dfd62a25e0fe93 + "box-" + $1ab441a42a00260e$export$77ad94ebf1c2b9ed(n, "-grow", "") + $1ab441a42a00260e$export$39dfd62a25e0fe93 + n + $1ab441a42a00260e$export$71ad59f2e432cfe8 + $1ab441a42a00260e$export$77ad94ebf1c2b9ed(n, "grow", "positive") + n;
        case 4554:
            return $1ab441a42a00260e$export$39dfd62a25e0fe93 + $1ab441a42a00260e$export$77ad94ebf1c2b9ed(n, /([^-])(transform)/g, "$1" + $1ab441a42a00260e$export$39dfd62a25e0fe93 + "$2") + n;
        case 6187:
            return $1ab441a42a00260e$export$77ad94ebf1c2b9ed($1ab441a42a00260e$export$77ad94ebf1c2b9ed($1ab441a42a00260e$export$77ad94ebf1c2b9ed(n, /(zoom-|grab)/, $1ab441a42a00260e$export$39dfd62a25e0fe93 + "$1"), /(image-set)/, $1ab441a42a00260e$export$39dfd62a25e0fe93 + "$1"), n, "") + n;
        case 5495:
        case 3959:
            return $1ab441a42a00260e$export$77ad94ebf1c2b9ed(n, /(image-set\([^]*)/, $1ab441a42a00260e$export$39dfd62a25e0fe93 + "$1" + "$`$1");
        case 4968:
            return $1ab441a42a00260e$export$77ad94ebf1c2b9ed($1ab441a42a00260e$export$77ad94ebf1c2b9ed(n, /(.+:)(flex-)?(.*)/, $1ab441a42a00260e$export$39dfd62a25e0fe93 + "box-pack:$3" + $1ab441a42a00260e$export$71ad59f2e432cfe8 + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + $1ab441a42a00260e$export$39dfd62a25e0fe93 + n + n;
        case 4200:
            if (!$1ab441a42a00260e$export$4659b591c19bdf3d(n, /flex-|baseline/)) return $1ab441a42a00260e$export$71ad59f2e432cfe8 + "grid-column-align" + $1ab441a42a00260e$export$2f35ab04d2335697(n, c) + n;
            break;
        case 2592:
        case 3360:
            return $1ab441a42a00260e$export$71ad59f2e432cfe8 + $1ab441a42a00260e$export$77ad94ebf1c2b9ed(n, "template-", "") + n;
        case 4384:
        case 3616:
            if (s && s.some(function(e, r) {
                return c = r, $1ab441a42a00260e$export$4659b591c19bdf3d(e.props, /grid-\w+-end/);
            })) return ~$1ab441a42a00260e$export$f8e21b1e77979a08(n + (s = s[c].value), "span") ? n : $1ab441a42a00260e$export$71ad59f2e432cfe8 + $1ab441a42a00260e$export$77ad94ebf1c2b9ed(n, "-start", "") + n + $1ab441a42a00260e$export$71ad59f2e432cfe8 + "grid-row-span:" + (~$1ab441a42a00260e$export$f8e21b1e77979a08(s, "span") ? $1ab441a42a00260e$export$4659b591c19bdf3d(s, /\d+/) : +$1ab441a42a00260e$export$4659b591c19bdf3d(s, /\d+/) - +$1ab441a42a00260e$export$4659b591c19bdf3d(n, /\d+/)) + ";";
            return $1ab441a42a00260e$export$71ad59f2e432cfe8 + $1ab441a42a00260e$export$77ad94ebf1c2b9ed(n, "-start", "") + n;
        case 4896:
        case 4128:
            return s && s.some(function(e) {
                return $1ab441a42a00260e$export$4659b591c19bdf3d(e.props, /grid-\w+-start/);
            }) ? n : $1ab441a42a00260e$export$71ad59f2e432cfe8 + $1ab441a42a00260e$export$77ad94ebf1c2b9ed($1ab441a42a00260e$export$77ad94ebf1c2b9ed(n, "-end", "-span"), "span ", "") + n;
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return $1ab441a42a00260e$export$77ad94ebf1c2b9ed(n, /(.+)-inline(.+)/, $1ab441a42a00260e$export$39dfd62a25e0fe93 + "$1$2") + n;
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            if ($1ab441a42a00260e$export$36776f635604f274(n) - 1 - c > 6) switch($1ab441a42a00260e$export$a9db5e087081082d(n, c + 1)){
                case 109:
                    if ($1ab441a42a00260e$export$a9db5e087081082d(n, c + 4) !== 45) break;
                case 102:
                    return $1ab441a42a00260e$export$77ad94ebf1c2b9ed(n, /(.+:)(.+)-([^]+)/, "$1" + $1ab441a42a00260e$export$39dfd62a25e0fe93 + "$2-$3" + "$1" + $1ab441a42a00260e$export$2c0f367103c8d01c + ($1ab441a42a00260e$export$a9db5e087081082d(n, c + 3) == 108 ? "$3" : "$2-$3")) + n;
                case 115:
                    return ~$1ab441a42a00260e$export$f8e21b1e77979a08(n, "stretch") ? $1ab441a42a00260e$export$82e9f45cca5ba907($1ab441a42a00260e$export$77ad94ebf1c2b9ed(n, "stretch", "fill-available"), c, s) + n : n;
            }
            break;
        case 5152:
        case 5920:
            return $1ab441a42a00260e$export$77ad94ebf1c2b9ed(n, /(.+?):(\d+)(\s*\/\s*(span)?\s*(\d+))?(.*)/, function(r, a, c, s, t, u, i) {
                return $1ab441a42a00260e$export$71ad59f2e432cfe8 + a + ":" + c + i + (s ? $1ab441a42a00260e$export$71ad59f2e432cfe8 + a + "-span:" + (t ? u : +u - +c) + i : "") + n;
            });
        case 4949:
            if ($1ab441a42a00260e$export$a9db5e087081082d(n, c + 6) === 121) return $1ab441a42a00260e$export$77ad94ebf1c2b9ed(n, ":", ":" + $1ab441a42a00260e$export$39dfd62a25e0fe93) + n;
            break;
        case 6444:
            switch($1ab441a42a00260e$export$a9db5e087081082d(n, $1ab441a42a00260e$export$a9db5e087081082d(n, 14) === 45 ? 18 : 11)){
                case 120:
                    return $1ab441a42a00260e$export$77ad94ebf1c2b9ed(n, /(.+:)([^;\s!]+)(;|(\s+)?!.+)?/, "$1" + $1ab441a42a00260e$export$39dfd62a25e0fe93 + ($1ab441a42a00260e$export$a9db5e087081082d(n, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + $1ab441a42a00260e$export$39dfd62a25e0fe93 + "$2$3" + "$1" + $1ab441a42a00260e$export$71ad59f2e432cfe8 + "$2box$3") + n;
                case 100:
                    return $1ab441a42a00260e$export$77ad94ebf1c2b9ed(n, ":", ":" + $1ab441a42a00260e$export$71ad59f2e432cfe8) + n;
            }
            break;
        case 5719:
        case 2647:
        case 2135:
        case 3927:
        case 2391:
            return $1ab441a42a00260e$export$77ad94ebf1c2b9ed(n, "scroll-", "scroll-snap-") + n;
    }
    return n;
}
function $1ab441a42a00260e$export$dfdc1655ccc5b9cb(e, r) {
    var a = "";
    var n = $1ab441a42a00260e$export$f9084667e487ed46(e);
    for(var c = 0; c < n; c++)a += r(e[c], c, e, r) || "";
    return a;
}
function $1ab441a42a00260e$export$fac44ee5b035f737(e, r, a, t) {
    switch(e.type){
        case $1ab441a42a00260e$export$d773506282b3cfe6:
            if (e.children.length) break;
        case $1ab441a42a00260e$export$a763edbf796b780a:
        case $1ab441a42a00260e$export$527d108ccf083c2b:
            return e.return = e.return || e.value;
        case $1ab441a42a00260e$export$a29989082612d0d9:
            return "";
        case $1ab441a42a00260e$export$b44a8529a35fcb60:
            return e.return = e.value + "{" + $1ab441a42a00260e$export$dfdc1655ccc5b9cb(e.children, t) + "}";
        case $1ab441a42a00260e$export$aa3a2e812ca8570d:
            e.value = e.props.join(",");
    }
    return $1ab441a42a00260e$export$36776f635604f274(a = $1ab441a42a00260e$export$dfdc1655ccc5b9cb(e.children, t)) ? e.return = e.value + "{" + a + "}" : "";
}
function $1ab441a42a00260e$export$5a7767152ae0305f(e) {
    var r = $1ab441a42a00260e$export$f9084667e487ed46(e);
    return function(a, n, c, s) {
        var t = "";
        for(var u = 0; u < r; u++)t += e[u](a, n, c, s) || "";
        return t;
    };
}
function $1ab441a42a00260e$export$38bcb760f1d4871c(e) {
    return function(r) {
        if (!r.root) {
            if (r = r.return) e(r);
        }
    };
}
function $1ab441a42a00260e$export$e08c7d021b829b7a(n, t, u, i) {
    if (n.length > -1) {
        if (!n.return) switch(n.type){
            case $1ab441a42a00260e$export$527d108ccf083c2b:
                n.return = $1ab441a42a00260e$export$82e9f45cca5ba907(n.value, n.length, u);
                return;
            case $1ab441a42a00260e$export$b44a8529a35fcb60:
                return $1ab441a42a00260e$export$dfdc1655ccc5b9cb([
                    $1ab441a42a00260e$export$784d13d8ee351f07(n, {
                        value: $1ab441a42a00260e$export$77ad94ebf1c2b9ed(n.value, "@", "@" + $1ab441a42a00260e$export$39dfd62a25e0fe93)
                    })
                ], i);
            case $1ab441a42a00260e$export$aa3a2e812ca8570d:
                if (n.length) return $1ab441a42a00260e$export$1be1fc439b849fdf(n.props, function(c) {
                    switch($1ab441a42a00260e$export$4659b591c19bdf3d(c, /(::plac\w+|:read-\w+)/)){
                        case ":read-only":
                        case ":read-write":
                            return $1ab441a42a00260e$export$dfdc1655ccc5b9cb([
                                $1ab441a42a00260e$export$784d13d8ee351f07(n, {
                                    props: [
                                        $1ab441a42a00260e$export$77ad94ebf1c2b9ed(c, /:(read-\w+)/, ":" + $1ab441a42a00260e$export$2c0f367103c8d01c + "$1")
                                    ]
                                })
                            ], i);
                        case "::placeholder":
                            return $1ab441a42a00260e$export$dfdc1655ccc5b9cb([
                                $1ab441a42a00260e$export$784d13d8ee351f07(n, {
                                    props: [
                                        $1ab441a42a00260e$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $1ab441a42a00260e$export$39dfd62a25e0fe93 + "input-$1")
                                    ]
                                }),
                                $1ab441a42a00260e$export$784d13d8ee351f07(n, {
                                    props: [
                                        $1ab441a42a00260e$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $1ab441a42a00260e$export$2c0f367103c8d01c + "$1")
                                    ]
                                }),
                                $1ab441a42a00260e$export$784d13d8ee351f07(n, {
                                    props: [
                                        $1ab441a42a00260e$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, $1ab441a42a00260e$export$71ad59f2e432cfe8 + "input-$1")
                                    ]
                                })
                            ], i);
                    }
                    return "";
                });
        }
    }
}
function $1ab441a42a00260e$export$76a88f7de6507443(e) {
    switch(e.type){
        case $1ab441a42a00260e$export$aa3a2e812ca8570d:
            e.props = e.props.map(function(r) {
                return $1ab441a42a00260e$export$1be1fc439b849fdf($1ab441a42a00260e$export$660b2ee2d4fb4eff(r), function(r, a, n) {
                    switch($1ab441a42a00260e$export$a9db5e087081082d(r, 0)){
                        case 12:
                            return $1ab441a42a00260e$export$2f35ab04d2335697(r, 1, $1ab441a42a00260e$export$36776f635604f274(r));
                        case 0:
                        case 40:
                        case 43:
                        case 62:
                        case 126:
                            return r;
                        case 58:
                            if (n[++a] === "global") n[a] = "", n[++a] = "\f" + $1ab441a42a00260e$export$2f35ab04d2335697(n[a], a = 1, -1);
                        case 32:
                            return a === 1 ? "" : r;
                        default:
                            switch(a){
                                case 0:
                                    e = r;
                                    return $1ab441a42a00260e$export$f9084667e487ed46(n) > 1 ? "" : r;
                                case a = $1ab441a42a00260e$export$f9084667e487ed46(n) - 1:
                                case 2:
                                    return a === 2 ? r + e + e : r + e;
                                default:
                                    return r;
                            }
                    }
                });
            });
    }
}

});

parcelRequire.register("j9PTG", function(module, exports) {
var $df271d43db7a402c$export$2e2bcd8739ae039 = function weakMemoize(func) {
    // $FlowFixMe flow doesn't include all non-primitive types as allowed for weakmaps
    var cache = new WeakMap();
    return function(arg) {
        if (cache.has(arg)) // $FlowFixMe
        return cache.get(arg);
        var ret = func(arg);
        cache.set(arg, ret);
        return ret;
    };
};

});

parcelRequire.register("7kvbA", function(module, exports) {

$parcel$export(module.exports, "default", () => $5562978bc0f88c82$export$2e2bcd8739ae039);
function $5562978bc0f88c82$export$2e2bcd8739ae039(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}

});


parcelRequire.register("8ATmK", function(module, exports) {

$parcel$export(module.exports, "serializeStyles", () => $641ca20a5bba83b7$export$6321afa313b251b5);

var $1ICPS = parcelRequire("1ICPS");

var $7xSOg = parcelRequire("7xSOg");

var $7kvbA = parcelRequire("7kvbA");
var $641ca20a5bba83b7$var$ILLEGAL_ESCAPE_SEQUENCE_ERROR = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";
var $641ca20a5bba83b7$var$UNDEFINED_AS_OBJECT_KEY_ERROR = "You have passed in falsy value as style object's key (can happen when in example you pass unexported component as computed key).";
var $641ca20a5bba83b7$var$hyphenateRegex = /[A-Z]|^ms/g;
var $641ca20a5bba83b7$var$animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;
var $641ca20a5bba83b7$var$isCustomProperty = function isCustomProperty(property) {
    return property.charCodeAt(1) === 45;
};
var $641ca20a5bba83b7$var$isProcessableValue = function isProcessableValue(value) {
    return value != null && typeof value !== "boolean";
};
var $641ca20a5bba83b7$var$processStyleName = /* #__PURE__ */ (0, $7kvbA.default)(function(styleName) {
    return $641ca20a5bba83b7$var$isCustomProperty(styleName) ? styleName : styleName.replace($641ca20a5bba83b7$var$hyphenateRegex, "-$&").toLowerCase();
});
var $641ca20a5bba83b7$var$processStyleValue = function processStyleValue(key, value) {
    switch(key){
        case "animation":
        case "animationName":
            if (typeof value === "string") return value.replace($641ca20a5bba83b7$var$animationRegex, function(match, p1, p2) {
                $641ca20a5bba83b7$var$cursor = {
                    name: p1,
                    styles: p2,
                    next: $641ca20a5bba83b7$var$cursor
                };
                return p1;
            });
    }
    if ((0, $7xSOg.default)[key] !== 1 && !$641ca20a5bba83b7$var$isCustomProperty(key) && typeof value === "number" && value !== 0) return value + "px";
    return value;
};
var $641ca20a5bba83b7$var$contentValuePattern, $641ca20a5bba83b7$var$contentValues, $641ca20a5bba83b7$var$oldProcessStyleValue, $641ca20a5bba83b7$var$msPattern, $641ca20a5bba83b7$var$hyphenPattern, $641ca20a5bba83b7$var$hyphenatedCache;
var $641ca20a5bba83b7$var$noComponentSelectorMessage = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function $641ca20a5bba83b7$var$handleInterpolation(mergedProps, registered, interpolation) {
    if (interpolation == null) return "";
    if (interpolation.__emotion_styles !== undefined) return interpolation;
    switch(typeof interpolation){
        case "boolean":
            return "";
        case "object":
            if (interpolation.anim === 1) {
                $641ca20a5bba83b7$var$cursor = {
                    name: interpolation.name,
                    styles: interpolation.styles,
                    next: $641ca20a5bba83b7$var$cursor
                };
                return interpolation.name;
            }
            if (interpolation.styles !== undefined) {
                var next = interpolation.next;
                if (next !== undefined) // not the most efficient thing ever but this is a pretty rare case
                // and there will be very few iterations of this generally
                while(next !== undefined){
                    $641ca20a5bba83b7$var$cursor = {
                        name: next.name,
                        styles: next.styles,
                        next: $641ca20a5bba83b7$var$cursor
                    };
                    next = next.next;
                }
                var styles = interpolation.styles + ";";
                return styles;
            }
            return $641ca20a5bba83b7$var$createStringFromObject(mergedProps, registered, interpolation);
        case "function":
            if (mergedProps !== undefined) {
                var previousCursor = $641ca20a5bba83b7$var$cursor;
                var result = interpolation(mergedProps);
                $641ca20a5bba83b7$var$cursor = previousCursor;
                return $641ca20a5bba83b7$var$handleInterpolation(mergedProps, registered, result);
            }
            break;
        case "string":
            var matched, replaced;
            break;
    } // finalize string values (regular strings and functions interpolated into css calls)
    if (registered == null) return interpolation;
    var cached = registered[interpolation];
    return cached !== undefined ? cached : interpolation;
}
function $641ca20a5bba83b7$var$createStringFromObject(mergedProps, registered, obj) {
    var string = "";
    if (Array.isArray(obj)) for(var i = 0; i < obj.length; i++)string += $641ca20a5bba83b7$var$handleInterpolation(mergedProps, registered, obj[i]) + ";";
    else for(var _key in obj){
        var value = obj[_key];
        if (typeof value !== "object") {
            if (registered != null && registered[value] !== undefined) string += _key + "{" + registered[value] + "}";
            else if ($641ca20a5bba83b7$var$isProcessableValue(value)) string += $641ca20a5bba83b7$var$processStyleName(_key) + ":" + $641ca20a5bba83b7$var$processStyleValue(_key, value) + ";";
        } else if (Array.isArray(value) && typeof value[0] === "string" && (registered == null || registered[value[0]] === undefined)) {
            for(var _i = 0; _i < value.length; _i++)if ($641ca20a5bba83b7$var$isProcessableValue(value[_i])) string += $641ca20a5bba83b7$var$processStyleName(_key) + ":" + $641ca20a5bba83b7$var$processStyleValue(_key, value[_i]) + ";";
        } else {
            var interpolated = $641ca20a5bba83b7$var$handleInterpolation(mergedProps, registered, value);
            switch(_key){
                case "animation":
                case "animationName":
                    string += $641ca20a5bba83b7$var$processStyleName(_key) + ":" + interpolated + ";";
                    break;
                default:
                    string += _key + "{" + interpolated + "}";
            }
        }
    }
    return string;
}
var $641ca20a5bba83b7$var$labelPattern = /label:\s*([^\s;\n{]+)\s*(;|$)/g;
var $641ca20a5bba83b7$var$sourceMapPattern;
// keyframes are stored on the SerializedStyles object as a linked list
var $641ca20a5bba83b7$var$cursor;
var $641ca20a5bba83b7$export$6321afa313b251b5 = function serializeStyles(args, registered, mergedProps) {
    if (args.length === 1 && typeof args[0] === "object" && args[0] !== null && args[0].styles !== undefined) return args[0];
    var stringMode = true;
    var styles = "";
    $641ca20a5bba83b7$var$cursor = undefined;
    var strings = args[0];
    if (strings == null || strings.raw === undefined) {
        stringMode = false;
        styles += $641ca20a5bba83b7$var$handleInterpolation(mergedProps, registered, strings);
    } else styles += strings[0];
     // we start at 1 since we've already handled the first arg
    for(var i = 1; i < args.length; i++){
        styles += $641ca20a5bba83b7$var$handleInterpolation(mergedProps, registered, args[i]);
        if (stringMode) styles += strings[i];
    }
    var sourceMap;
    $641ca20a5bba83b7$var$labelPattern.lastIndex = 0;
    var identifierName = "";
    var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5
    while((match = $641ca20a5bba83b7$var$labelPattern.exec(styles)) !== null)identifierName += "-" + // $FlowFixMe we know it's not null
    match[1];
    var name = (0, $1ICPS.default)(styles) + identifierName;
    return {
        name: name,
        styles: styles,
        next: $641ca20a5bba83b7$var$cursor
    };
};

});
parcelRequire.register("1ICPS", function(module, exports) {

$parcel$export(module.exports, "default", () => $1408067e922e0fd3$export$2e2bcd8739ae039);
/* eslint-disable */ // Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function $1408067e922e0fd3$export$2e2bcd8739ae039(str) {
    // 'm' and 'r' are mixing constants generated offline.
    // They're not really 'magic', they just happen to work well.
    // const m = 0x5bd1e995;
    // const r = 24;
    // Initialize the hash
    var h = 0; // Mix 4 bytes at a time into the hash
    var k, i = 0, len = str.length;
    for(; len >= 4; ++i, len -= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
        k ^= /* k >>> r: */ k >>> 24;
        h = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^ /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Handle the last few bytes of the input array
    switch(len){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Do a few final mixes of the hash to ensure the last few
    // bytes are well-incorporated.
    h ^= h >>> 13;
    h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    return ((h ^ h >>> 15) >>> 0).toString(36);
}

});

parcelRequire.register("7xSOg", function(module, exports) {

$parcel$export(module.exports, "default", () => $57e621896d214318$export$2e2bcd8739ae039);
var $57e621896d214318$export$2e2bcd8739ae039 = {
    animationIterationCount: 1,
    aspectRatio: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};

});


parcelRequire.register("krJU9", function(module, exports) {

$parcel$export(module.exports, "getRegisteredStyles", () => $ee29eff5b5ff8931$export$95d99596f328fd52);
$parcel$export(module.exports, "insertStyles", () => $ee29eff5b5ff8931$export$6f077d94b33a01aa);
var $ee29eff5b5ff8931$var$isBrowser = true;
function $ee29eff5b5ff8931$export$95d99596f328fd52(registered, registeredStyles, classNames) {
    var rawClassName = "";
    classNames.split(" ").forEach(function(className) {
        if (registered[className] !== undefined) registeredStyles.push(registered[className] + ";");
        else rawClassName += className + " ";
    });
    return rawClassName;
}
var $ee29eff5b5ff8931$export$580009a5da2a8b4b = function registerStyles(cache, serialized, isStringTag) {
    var className = cache.key + "-" + serialized.name;
    if (// class name could be used further down
    // the tree but if it's a string tag, we know it won't
    // so we don't have to add it to registered cache.
    // this improves memory usage since we can avoid storing the whole style string
    (isStringTag === false || // we need to always store it if we're in compat mode and
    // in node since emotion-server relies on whether a style is in
    // the registered cache to know whether a style is global or not
    // also, note that this check will be dead code eliminated in the browser
    $ee29eff5b5ff8931$var$isBrowser === false) && cache.registered[className] === undefined) cache.registered[className] = serialized.styles;
};
var $ee29eff5b5ff8931$export$6f077d94b33a01aa = function insertStyles(cache, serialized, isStringTag) {
    $ee29eff5b5ff8931$export$580009a5da2a8b4b(cache, serialized, isStringTag);
    var className = cache.key + "-" + serialized.name;
    if (cache.inserted[serialized.name] === undefined) {
        var current = serialized;
        do {
            cache.insert(serialized === current ? "." + className : "", current, cache.sheet, true);
            current = current.next;
        }while (current !== undefined);
    }
};

});


parcelRequire.register("8wn6k", function(module, exports) {

$parcel$export(module.exports, "default", () => $63433b4baa07a49b$export$2e2bcd8739ae039);

var $9auDB = parcelRequire("9auDB");
var $63433b4baa07a49b$var$AutoCenter = function AutoCenter() {
    (0, $9auDB.default)();
    return false;
};
var $63433b4baa07a49b$export$2e2bcd8739ae039 = $63433b4baa07a49b$var$AutoCenter;

});
parcelRequire.register("9auDB", function(module, exports) {

$parcel$export(module.exports, "default", () => $6accd03bac410d54$export$2e2bcd8739ae039);

var $cUZUF = parcelRequire("cUZUF");

var $eO7Kz = parcelRequire("eO7Kz");

var $kPoIH = parcelRequire("kPoIH");

var $F8IqC = parcelRequire("F8IqC");

var $fYCA4 = parcelRequire("fYCA4");

var $gwZPm = parcelRequire("gwZPm");
function $6accd03bac410d54$export$2e2bcd8739ae039() {
    var _useStyleOptions = (0, $fYCA4.default)(), _useStyleOptions2 = (0, (/*@__PURE__*/$parcel$interopDefault($cUZUF)))(_useStyleOptions, 1), autoCenter = _useStyleOptions2[0].autoCenter;
    var _useScrolling = (0, $kPoIH.default)(), _useScrolling2 = (0, (/*@__PURE__*/$parcel$interopDefault($cUZUF)))(_useScrolling, 1), scrolling = _useScrolling2[0];
    var scrollTo = (0, $F8IqC.default)();
    var handleTrigger = (0, $eO7Kz.useCallback)(function() {
        return scrollTo(function(_ref) {
            var index = _ref.index;
            return index;
        });
    }, [
        scrollTo
    ]);
    (0, $gwZPm.default)(!autoCenter || scrolling ? undefined : handleTrigger, 0);
}

});
parcelRequire.register("gwZPm", function(module, exports) {

$parcel$export(module.exports, "default", () => $c08f9827aa251281$export$2e2bcd8739ae039);

var $gV225 = parcelRequire("gV225");

var $eO7Kz = parcelRequire("eO7Kz");
function $c08f9827aa251281$export$2e2bcd8739ae039(onTrigger, duration) {
    (0, $eO7Kz.useEffect)(function() {
        if (onTrigger) {
            var timeout = (0, (/*@__PURE__*/$parcel$interopDefault($gV225)))(onTrigger, duration);
            return function() {
                return clearTimeout(timeout);
            };
        }
    }, [
        duration,
        onTrigger
    ]);
}

});



parcelRequire.register("3Ckoo", function(module, exports) {

$parcel$export(module.exports, "default", () => $2a24bd3c071db7a8$export$2e2bcd8739ae039);

var $gFPHP = parcelRequire("gFPHP");
function $2a24bd3c071db7a8$export$2e2bcd8739ae039(dir, scrollable, itemContainer, index) {
    var rtl = dir === "rtl";
    if (itemContainer && scrollable) {
        var items = itemContainer.children; // This will enumerate <li> inside <FilmStrip>
        var item = items[Math.max(0, Math.min(items.length - 1, index))];
        if (item) {
            if (scrollable.offsetWidth === scrollable.scrollWidth) return 0;
            // eslint-disable-next-line no-magic-numbers
            var result = item.offsetLeft + (item.offsetWidth - scrollable.offsetWidth) / 2;
            if (rtl) {
                result = Math.min(result, 0);
                result = Math.max(result, scrollable.offsetWidth - scrollable.scrollWidth);
            } else {
                result = Math.max(result, 0);
                result = Math.min(result, scrollable.scrollWidth - scrollable.offsetWidth);
            }
            if (rtl && ($gFPHP.edgeUWP || $gFPHP.internetExplorer)) result = -result;
            return result;
        }
    }
}

});

parcelRequire.register("2tzI6", function(module, exports) {

$parcel$export(module.exports, "default", () => $1cd9fd83ce3e1979$export$2e2bcd8739ae039);

var $iCd34 = parcelRequire("iCd34");

var $k0QRm = parcelRequire("k0QRm");

var $kYFzi = parcelRequire("kYFzi");

var $jJkAT = parcelRequire("jJkAT");
var $1cd9fd83ce3e1979$var$createDotsStyle = function createDotsStyle(_ref) {
    var dotBoxSize = _ref.dotBoxSize;
    return {
        "& .react-film__dots": {
            alignItems: "center",
            bottom: 0,
            display: "flex",
            height: dotBoxSize,
            justifyContent: "center",
            listStyleType: "none",
            margin: 0,
            padding: 0,
            width: "100%"
        }
    };
};
var $1cd9fd83ce3e1979$var$createDotStyle = function createDotStyle(_ref2) {
    var cursor = _ref2.cursor, dotBoxSize = _ref2.dotBoxSize, dotSize = _ref2.dotSize;
    return {
        "& .react-film__dot": {
            alignItems: "center",
            display: "flex",
            height: dotBoxSize,
            justifyContent: "center",
            position: "relative",
            width: dotBoxSize,
            "& .react-film__dot__input": (0, (/*@__PURE__*/$parcel$interopDefault($k0QRm)))((0, (/*@__PURE__*/$parcel$interopDefault($k0QRm)))({}, cursor ? {
                cursor: cursor
            } : {}), {}, {
                height: "100%",
                left: 0,
                margin: 0,
                opacity: 0,
                position: "absolute",
                top: 0,
                touchAction: "none",
                userSelect: "none",
                width: "100%"
            }),
            "& .react-film__dot__handle": {
                background: "rgba(0, 0, 0, .2)",
                borderRadius: dotSize / 2,
                height: dotSize,
                width: dotSize
            },
            "&:hover .react-film__dot__handle, & .react-film__dot__input:focus + .react-film__dot__handle": {
                background: "rgba(0, 0, 0, .4)"
            },
            "& .react-film__dot__input:active + .react-film__dot__handle": {
                background: "rgba(0, 0, 0, .8)"
            },
            "& .react-film__dot__input:checked:not(:active) + .react-film__dot__handle": {
                background: "rgba(0, 0, 0, .6)"
            }
        }
    };
};
var $1cd9fd83ce3e1979$var$createFlipperStyle = function createFlipperStyle(_ref3) {
    var _context;
    var cursor = _ref3.cursor, flipperBoxWidth = _ref3.flipperBoxWidth, flipperSize = _ref3.flipperSize;
    return {
        "& .react-film__flipper": (0, (/*@__PURE__*/$parcel$interopDefault($k0QRm)))((0, (/*@__PURE__*/$parcel$interopDefault($k0QRm)))({}, cursor ? {
            cursor: cursor
        } : {}), {}, {
            background: "Transparent",
            border: 0,
            height: "100%",
            outline: 0,
            overflow: "hidden",
            position: "absolute",
            top: 0,
            touchAction: "none",
            userSelect: "none",
            width: flipperBoxWidth,
            zIndex: 1,
            "&.react-film__flipper--left": {
                left: 0,
                "& .react-film__flipper__slider": {
                    left: 0
                }
            },
            "&.react-film__flipper--right": {
                right: 0,
                "& .react-film__flipper__slider": {
                    right: 0
                }
            },
            "& .react-film__flipper__slider": {
                alignItems: "center",
                display: "flex",
                height: "100%",
                justifyContent: "center",
                position: "absolute",
                top: 0,
                width: "100%"
            },
            "& .react-film__flipper__body": {
                backgroundColor: "rgba(0, 0, 0, .6)",
                borderRadius: "50%",
                color: "rgba(255, 255, 255, .6)",
                fontFamily: (0, (/*@__PURE__*/$parcel$interopDefault($kYFzi)))(_context = [
                    "Consolas",
                    "monospace"
                ]).call(_context, function(font) {
                    return "'".concat(font, "'");
                }).join(", "),
                fontSize: 16,
                height: flipperSize,
                lineHeight: "".concat(flipperSize, "px"),
                overflow: "hidden",
                position: "relative",
                transitionDuration: "100ms",
                transitionProperty: "background-color",
                width: flipperSize
            },
            "&:hover, &:focus": {
                "& .react-film__flipper__body": {
                    backgroundColor: "rgba(0, 0, 0, .8)",
                    color: "rgba(255, 255, 255, .8)",
                    transitionDuration: 0
                }
            },
            "&:active .react-film__flipper__body": {
                backgroundColor: "Black",
                color: "White",
                transitionDuration: 0
            }
        })
    };
};
var $1cd9fd83ce3e1979$var$createFilmstripStyle = function createFilmstripStyle() {
    return {
        "& .react-film__filmstrip": {
            MsOverflowStyle: "none",
            overflowX: "scroll",
            overflowY: "hidden",
            overscrollBehaviorX: "contain",
            position: "relative",
            touchAction: "manipulation",
            zIndex: 0,
            "&::-webkit-scrollbar": {
                display: "none"
            },
            "& .react-film__filmstrip__list": {
                display: "flex",
                listStyleType: "none",
                margin: 0,
                padding: 0
            }
        }
    };
};
var $1cd9fd83ce3e1979$var$createScrollBarStyle = function createScrollBarStyle(_ref4) {
    var autoHide = _ref4.autoHide, scrollBarHeight = _ref4.scrollBarHeight, scrollBarMargin = _ref4.scrollBarMargin;
    return {
        "& .react-film__scroll-bar": {
            bottom: autoHide ? -30 : 0,
            boxSizing: "border-box",
            padding: scrollBarMargin,
            position: "absolute",
            transitionDelay: "1s",
            transitionDuration: "300ms",
            transitionProperty: "bottom",
            width: "100%",
            "& .react-film__scroll-bar__handle": {
                backdropFilter: "blur(4px)",
                background: "rgba(255, 255, 255, .4)",
                borderRadius: scrollBarHeight / 2,
                height: scrollBarHeight
            }
        }
    };
};
var $1cd9fd83ce3e1979$var$createRootStyle = function createRootStyle(_ref5) {
    var autoHide = _ref5.autoHide, autoHideFlipperOnEdge = _ref5.autoHideFlipperOnEdge, flipperBoxWidth = _ref5.flipperBoxWidth, flipperSize = _ref5.flipperSize;
    return {
        "& .react-film__main": (0, (/*@__PURE__*/$parcel$interopDefault($k0QRm)))({
            overflow: "hidden",
            position: "relative"
        }, autoHide ? {
            "&:hover, &.react-film__main--scrolling": {
                "& .react-film__main__slider": {
                    transitionDelay: "0s",
                    "&.react-film__main__slider--bottom": {
                        bottom: 0
                    },
                    "&.react-film__main__slider--left": (0, (/*@__PURE__*/$parcel$interopDefault($iCd34)))({}, autoHideFlipperOnEdge ? "&:not(.react-film__main__slider--hide)" : "&", {
                        left: 0
                    }),
                    "&.react-film__main__slider--right": (0, (/*@__PURE__*/$parcel$interopDefault($iCd34)))({}, autoHideFlipperOnEdge ? "&:not(.react-film__main__slider--hide)" : "&", {
                        right: 0
                    })
                }
            },
            "& .react-film__main__overlay:focus .react-film__main__slider:not(.react-film__main__slider--hide)": {
                transitionDelay: "0s",
                "&.react-film__main__slider--left": {
                    left: 0
                },
                "&.react-film__main__slider--right": {
                    right: 0
                }
            },
            "& .react-film__main__slider": {
                transitionDelay: "1s",
                transitionDuration: "300ms",
                "&.react-film__main__slider--left": {
                    left: (flipperBoxWidth + flipperSize) / -2,
                    transitionProperty: "left"
                },
                "&.react-film__main__slider--right": {
                    right: (flipperBoxWidth + flipperSize) / -2,
                    transitionProperty: "right"
                }
            }
        } : {})
    };
};
function $1cd9fd83ce3e1979$export$2e2bcd8739ae039(styleOptions) {
    styleOptions = (0, $jJkAT.default)(styleOptions);
    return {
        root: (0, (/*@__PURE__*/$parcel$interopDefault($k0QRm)))((0, (/*@__PURE__*/$parcel$interopDefault($k0QRm)))((0, (/*@__PURE__*/$parcel$interopDefault($k0QRm)))((0, (/*@__PURE__*/$parcel$interopDefault($k0QRm)))((0, (/*@__PURE__*/$parcel$interopDefault($k0QRm)))((0, (/*@__PURE__*/$parcel$interopDefault($k0QRm)))({}, $1cd9fd83ce3e1979$var$createDotsStyle(styleOptions)), $1cd9fd83ce3e1979$var$createDotStyle(styleOptions)), $1cd9fd83ce3e1979$var$createFilmstripStyle(styleOptions)), $1cd9fd83ce3e1979$var$createFlipperStyle(styleOptions)), $1cd9fd83ce3e1979$var$createRootStyle(styleOptions)), $1cd9fd83ce3e1979$var$createScrollBarStyle(styleOptions))
    };
}

});
parcelRequire.register("jJkAT", function(module, exports) {

$parcel$export(module.exports, "default", () => $e5d231d9138e56e9$export$2e2bcd8739ae039);
var $e5d231d9138e56e9$var$DOT_BOX_SIZE = 20;
var $e5d231d9138e56e9$var$DOT_SIZE = 6;
var $e5d231d9138e56e9$var$FLIPPER_BOX_WIDTH = 60;
var $e5d231d9138e56e9$var$FLIPPER_SIZE = 40;
var $e5d231d9138e56e9$var$SCROLL_BAR_HEIGHT = 8;
var $e5d231d9138e56e9$var$SCROLL_BAR_MARGIN = 4;
function $e5d231d9138e56e9$export$2e2bcd8739ae039() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, autoCenter = _ref.autoCenter, autoHide = _ref.autoHide, autoHideFlipperOnEdge = _ref.autoHideFlipperOnEdge, cursor = _ref.cursor, dir = _ref.dir, dotBoxSize = _ref.dotBoxSize, dotSize = _ref.dotSize, flipperBlurFocusOnClick = _ref.flipperBlurFocusOnClick, flipperBoxWidth = _ref.flipperBoxWidth, flipperSize = _ref.flipperSize, leftFlipperAriaLabel = _ref.leftFlipperAriaLabel, leftFlipperText = _ref.leftFlipperText, rightFlipperAriaLabel = _ref.rightFlipperAriaLabel, rightFlipperText = _ref.rightFlipperText, scrollBarHeight = _ref.scrollBarHeight, scrollBarMargin = _ref.scrollBarMargin, showDots = _ref.showDots, showFlipper = _ref.showFlipper, showScrollBar = _ref.showScrollBar;
    var rtl = dir === "rtl";
    return {
        autoCenter: autoCenter !== false,
        autoHide: autoHide !== false,
        autoHideFlipperOnEdge: autoHideFlipperOnEdge !== false,
        cursor: typeof cursor === "undefined" ? "pointer" : cursor,
        dotBoxSize: typeof dotBoxSize === "number" ? dotBoxSize : $e5d231d9138e56e9$var$DOT_BOX_SIZE,
        dotSize: typeof dotSize === "number" ? dotSize : $e5d231d9138e56e9$var$DOT_SIZE,
        flipperBlurFocusOnClick: flipperBlurFocusOnClick === true,
        flipperBoxWidth: typeof flipperBoxWidth === "number" ? flipperBoxWidth : $e5d231d9138e56e9$var$FLIPPER_BOX_WIDTH,
        flipperSize: typeof flipperSize === "number" ? flipperSize : $e5d231d9138e56e9$var$FLIPPER_SIZE,
        leftFlipperAriaLabel: leftFlipperAriaLabel || "left",
        leftFlipperText: leftFlipperText || (rtl ? ">" : "<"),
        rightFlipperAriaLabel: rightFlipperAriaLabel || "right",
        rightFlipperText: rightFlipperText || (rtl ? "<" : ">"),
        scrollBarHeight: typeof scrollBarHeight === "number" ? scrollBarHeight : $e5d231d9138e56e9$var$SCROLL_BAR_HEIGHT,
        scrollBarMargin: typeof scrollBarMargin === "number" ? scrollBarMargin : $e5d231d9138e56e9$var$SCROLL_BAR_MARGIN,
        showDots: showDots !== false,
        showFlipper: showFlipper !== false,
        showScrollBar: showScrollBar !== false
    };
}

});


parcelRequire.register("6Brns", function(module, exports) {

$parcel$export(module.exports, "default", () => $4ceb6f5d8d0858ff$export$2e2bcd8739ae039);
/* eslint no-magic-numbers: ["error", { "ignore": [0, 2, 5, 26, 65] }] */ 
var $atZsr = parcelRequire("atZsr");
function $4ceb6f5d8d0858ff$export$2e2bcd8739ae039() {
    return (0, (/*@__PURE__*/$parcel$interopDefault($atZsr)))().toString(26).substr(2, 5).replace(/[0-9]/g, function(value) {
        return String.fromCharCode(value.charCodeAt(0) + 65);
    });
}

});

parcelRequire.register("gVJb0", function(module, exports) {

$parcel$export(module.exports, "default", () => $c5350356f4253702$export$2e2bcd8739ae039);

var $8n6ez = parcelRequire("8n6ez");

var $gFPHP = parcelRequire("gFPHP");

var $9C5Cg = parcelRequire("9C5Cg");
function $c5350356f4253702$export$2e2bcd8739ae039(dir, scrollable, itemContainer, scrollingTo) {
    var rtl = dir === "rtl";
    if (itemContainer && scrollable) {
        var scrollLeft = scrollingTo || scrollable.scrollLeft;
        var trueScrollLeft = rtl && ($gFPHP.edgeUWP || $gFPHP.internetExplorer) ? -scrollLeft : scrollLeft;
        var items = itemContainer.children; // This will enumerate <li> inside <FilmStrip>
        var scrollCenter = trueScrollLeft + scrollable.offsetWidth / 2;
        var index = (0, $9C5Cg.default)((0, (/*@__PURE__*/$parcel$interopDefault($8n6ez)))([]).call(items), function(item) {
            var offsetCenter = item.offsetLeft + item.offsetWidth / 2;
            return 1 / Math.abs(scrollCenter - offsetCenter);
        });
        if (~index) {
            var item = items[index];
            var offsetCenter = item.offsetLeft + item.offsetWidth / 2;
            var indexFraction = index + (scrollCenter - offsetCenter) / item.offsetWidth * (rtl ? -1 : 1);
            // We "fix" indexFraction if the viewport is at the start/end of the content
            // This is to simplify code that use Math.round(indexFraction) to find the scrollable index
            // if (scrollLeft === 0) {
            //   indexFraction = 0;
            // } else if (scrollLeft >= scrollable.scrollWidth - scrollable.offsetWidth) {
            //   indexFraction = items.length - 1;
            // } else if (indexFraction % 1 > .99 || indexFraction % 1 < .01) {
            //   indexFraction = Math.round(indexFraction);
            // }
            if (indexFraction % 1 > 0.99 || indexFraction % 1 < 0.01) indexFraction = Math.round(indexFraction);
            var selectedIndex;
            if (Math.abs(trueScrollLeft) < 1) selectedIndex = 0;
            else if (rtl ? trueScrollLeft <= scrollable.offsetWidth - scrollable.scrollWidth : trueScrollLeft >= scrollable.scrollWidth - scrollable.offsetWidth) selectedIndex = items.length - 1;
            else selectedIndex = Math.round(indexFraction);
            return {
                index: selectedIndex,
                indexFraction: indexFraction
            };
        }
    }
}

});
parcelRequire.register("8n6ez", function(module, exports) {

module.exports = (parcelRequire("aqKUS"));

});

parcelRequire.register("9C5Cg", function(module, exports) {

$parcel$export(module.exports, "default", () => $6ffc04edb6d8af21$export$2e2bcd8739ae039);

var $lvBaD = parcelRequire("lvBaD");
function $6ffc04edb6d8af21$export$2e2bcd8739ae039(array, scorer) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($lvBaD)))(array).call(array, function(best, item, index) {
        var score = scorer.call(array, item, index);
        if (score > best.score) return {
            index: index,
            score: score
        };
        return best;
    }, {
        index: -1,
        score: -Infinity
    }).index;
}

});
parcelRequire.register("lvBaD", function(module, exports) {

module.exports = (parcelRequire("8NZ3u"));

});
parcelRequire.register("8NZ3u", function(module, exports) {

var $bwqVD = parcelRequire("bwqVD");
module.exports = $bwqVD;

});
parcelRequire.register("bwqVD", function(module, exports) {

var $53bMe = parcelRequire("53bMe");

var $aTKH8 = parcelRequire("aTKH8");
var $863792570ace83a4$var$ArrayPrototype = Array.prototype;
module.exports = function(it) {
    var own = it.reduce;
    return it === $863792570ace83a4$var$ArrayPrototype || $53bMe($863792570ace83a4$var$ArrayPrototype, it) && own === $863792570ace83a4$var$ArrayPrototype.reduce ? $aTKH8 : own;
};

});
parcelRequire.register("aTKH8", function(module, exports) {
parcelRequire("bV0zv");

var $5zMeE = parcelRequire("5zMeE");
module.exports = $5zMeE("Array").reduce;

});
parcelRequire.register("bV0zv", function(module, exports) {
"use strict";

var $2iwSV = parcelRequire("2iwSV");

var $3kFNO = parcelRequire("3kFNO");
var $8ad57615a0424d3f$require$$reduce = $3kFNO.left;

var $gH3K8 = parcelRequire("gH3K8");

var $aPgVB = parcelRequire("aPgVB");

var $9sRxI = parcelRequire("9sRxI");
// Chrome 80-82 has a critical bug
// https://bugs.chromium.org/p/chromium/issues/detail?id=1049982
var $8ad57615a0424d3f$var$CHROME_BUG = !$9sRxI && $aPgVB > 79 && $aPgVB < 83;
var $8ad57615a0424d3f$var$FORCED = $8ad57615a0424d3f$var$CHROME_BUG || !$gH3K8("reduce");
// `Array.prototype.reduce` method
// https://tc39.es/ecma262/#sec-array.prototype.reduce
$2iwSV({
    target: "Array",
    proto: true,
    forced: $8ad57615a0424d3f$var$FORCED
}, {
    reduce: function reduce(callbackfn /* , initialValue */ ) {
        var length = arguments.length;
        return $8ad57615a0424d3f$require$$reduce(this, callbackfn, length, length > 1 ? arguments[1] : undefined);
    }
});

});
parcelRequire.register("3kFNO", function(module, exports) {

var $f9Leu = parcelRequire("f9Leu");

var $h90HQ = parcelRequire("h90HQ");

var $letw9 = parcelRequire("letw9");

var $f8kjp = parcelRequire("f8kjp");
var $26d3aa6d050945cf$var$$TypeError = TypeError;
// `Array.prototype.{ reduce, reduceRight }` methods implementation
var $26d3aa6d050945cf$var$createMethod = function(IS_RIGHT) {
    return function(that, callbackfn, argumentsLength, memo) {
        $f9Leu(callbackfn);
        var O = $h90HQ(that);
        var self = $letw9(O);
        var length = $f8kjp(O);
        var index = IS_RIGHT ? length - 1 : 0;
        var i = IS_RIGHT ? -1 : 1;
        if (argumentsLength < 2) while(true){
            if (index in self) {
                memo = self[index];
                index += i;
                break;
            }
            index += i;
            if (IS_RIGHT ? index < 0 : length <= index) throw $26d3aa6d050945cf$var$$TypeError("Reduce of empty array with no initial value");
        }
        for(; IS_RIGHT ? index >= 0 : length > index; index += i)if (index in self) memo = callbackfn(memo, self[index], index, O);
        return memo;
    };
};
module.exports = {
    // `Array.prototype.reduce` method
    // https://tc39.es/ecma262/#sec-array.prototype.reduce
    left: $26d3aa6d050945cf$var$createMethod(false),
    // `Array.prototype.reduceRight` method
    // https://tc39.es/ecma262/#sec-array.prototype.reduceright
    right: $26d3aa6d050945cf$var$createMethod(true)
};

});








parcelRequire.register("dBwSo", function(module, exports) {

$parcel$export(module.exports, "default", () => $9e783b9a4812424f$export$2e2bcd8739ae039);

var $eO7Kz = parcelRequire("eO7Kz");
var $9e783b9a4812424f$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eO7Kz.createContext)();

});

parcelRequire.register("dMjp1", function(module, exports) {

$parcel$export(module.exports, "default", () => $a07ecf027787f777$export$2e2bcd8739ae039);

var $3atap = parcelRequire("3atap");

var $166Cb = parcelRequire("166Cb");

var $eO7Kz = parcelRequire("eO7Kz");
function $a07ecf027787f777$var$step(from, to, stepper, index) {
    var next = from;
    for(var i = 0; i < index; i++)next = stepper(next, to);
    return next;
}
function $a07ecf027787f777$var$squareStepper(current, to) {
    var sign = (0, (/*@__PURE__*/$parcel$interopDefault($3atap)))(to - current);
    var step = Math.sqrt(Math.abs(to - current));
    var next = current + step * sign;
    if (sign > 0) return Math.min(to, next);
    return Math.max(to, next);
}
function $a07ecf027787f777$export$2e2bcd8739ae039(element, to, onEnd) {
    (0, $eO7Kz.useEffect)(function() {
        if (element) {
            var start = (0, (/*@__PURE__*/$parcel$interopDefault($166Cb)))();
            var animator;
            var animate = function animate(from) {
                animator = requestAnimationFrame(function() {
                    // eslint-disable-next-line no-magic-numbers
                    var nextValue = $a07ecf027787f777$var$step(from, to, $a07ecf027787f777$var$squareStepper, ((0, (/*@__PURE__*/$parcel$interopDefault($166Cb)))() - start) / 5);
                    // eslint-disable-next-line no-magic-numbers
                    if (Math.abs(to - nextValue) < 0.5) nextValue = to;
                    element.scrollLeft = nextValue;
                    if (to === nextValue) onEnd && onEnd(true);
                    else animate(from);
                });
            };
            animate(element.scrollLeft);
            return function() {
                return cancelAnimationFrame(animator);
            };
        }
    }, [
        element,
        to,
        onEnd
    ]);
}

});
parcelRequire.register("3atap", function(module, exports) {

module.exports = (parcelRequire("8Nq7h"));

});
parcelRequire.register("8Nq7h", function(module, exports) {

var $cn14l = parcelRequire("cn14l");
module.exports = $cn14l;

});
parcelRequire.register("cn14l", function(module, exports) {
parcelRequire("kRXXt");

var $lahb7 = parcelRequire("lahb7");
module.exports = $lahb7.Math.sign;

});
parcelRequire.register("kRXXt", function(module, exports) {

var $2iwSV = parcelRequire("2iwSV");

var $aKg8R = parcelRequire("aKg8R");
// `Math.sign` method
// https://tc39.es/ecma262/#sec-math.sign
$2iwSV({
    target: "Math",
    stat: true
}, {
    sign: $aKg8R
});

});
parcelRequire.register("aKg8R", function(module, exports) {
// `Math.sign` method implementation
// https://tc39.es/ecma262/#sec-math.sign
// eslint-disable-next-line es/no-math-sign -- safe
module.exports = Math.sign || function sign(x) {
    var n = +x;
    // eslint-disable-next-line no-self-compare -- NaN check
    return n == 0 || n != n ? n : n < 0 ? -1 : 1;
};

});





parcelRequire.register("166Cb", function(module, exports) {

module.exports = (parcelRequire("aMvcW"));

});
parcelRequire.register("aMvcW", function(module, exports) {

var $PVS8j = parcelRequire("PVS8j");
module.exports = $PVS8j;

});
parcelRequire.register("PVS8j", function(module, exports) {
parcelRequire("45N3j");

var $lahb7 = parcelRequire("lahb7");
module.exports = $lahb7.Date.now;

});
parcelRequire.register("45N3j", function(module, exports) {
// TODO: Remove from `core-js@4`

var $2iwSV = parcelRequire("2iwSV");

var $dqhay = parcelRequire("dqhay");
var $2fadaddca311f219$var$$Date = Date;
var $2fadaddca311f219$var$thisTimeValue = $dqhay($2fadaddca311f219$var$$Date.prototype.getTime);
// `Date.now` method
// https://tc39.es/ecma262/#sec-date.now
$2iwSV({
    target: "Date",
    stat: true
}, {
    now: function now() {
        return $2fadaddca311f219$var$thisTimeValue(new $2fadaddca311f219$var$$Date());
    }
});

});





parcelRequire.register("6eRuw", function(module, exports) {

$parcel$export(module.exports, "default", () => $48ad8b1f8f9ec9ee$export$2e2bcd8739ae039);

var $2F07w = parcelRequire("2F07w");

var $1nCnG = parcelRequire("1nCnG");

var $4yjim = parcelRequire("4yjim");

var $eO7Kz = parcelRequire("eO7Kz");
var $48ad8b1f8f9ec9ee$var$SUBSCRIBER_LIMIT = 10;
function $48ad8b1f8f9ec9ee$export$2e2bcd8739ae039() {
    return (0, $eO7Kz.useMemo)(function() {
        var subscriptions = [];
        var callbackRef = function callbackRef(current) {
            callbackRef.current = current;
            (0, (/*@__PURE__*/$parcel$interopDefault($2F07w)))(subscriptions).call(subscriptions, function(subscription) {
                subscription.cleanup && subscription.cleanup();
                subscription.cleanup = subscription.callback(current);
            });
        };
        callbackRef.subscribe = function(callback) {
            var subscription = {
                callback: callback
            };
            subscriptions.push(subscription);
            if (subscriptions.length >= $48ad8b1f8f9ec9ee$var$SUBSCRIBER_LIMIT) console.warn("useSubscribe: Reaching maximum limit of subscribers (".concat($48ad8b1f8f9ec9ee$var$SUBSCRIBER_LIMIT, "), please make sure your code did clean up properly."));
            subscription.cleanup = callback(callbackRef.current);
            return function() {
                subscription.cleanup && subscription.cleanup();
                var index = (0, (/*@__PURE__*/$parcel$interopDefault($1nCnG)))(subscriptions).call(subscriptions, subscription);
                ~index && (0, (/*@__PURE__*/$parcel$interopDefault($4yjim)))(subscriptions).call(subscriptions, index, 1);
            };
        };
        return callbackRef;
    }, []);
}

});
parcelRequire.register("2F07w", function(module, exports) {

module.exports = (parcelRequire("yUPG4"));

});

parcelRequire.register("1nCnG", function(module, exports) {

module.exports = (parcelRequire("1ORIy"));

});
parcelRequire.register("1ORIy", function(module, exports) {

var $7REDd = parcelRequire("7REDd");
module.exports = $7REDd;

});
parcelRequire.register("7REDd", function(module, exports) {

var $53bMe = parcelRequire("53bMe");

var $d8s5O = parcelRequire("d8s5O");
var $5b9d0039b020331c$var$ArrayPrototype = Array.prototype;
module.exports = function(it) {
    var own = it.indexOf;
    return it === $5b9d0039b020331c$var$ArrayPrototype || $53bMe($5b9d0039b020331c$var$ArrayPrototype, it) && own === $5b9d0039b020331c$var$ArrayPrototype.indexOf ? $d8s5O : own;
};

});
parcelRequire.register("d8s5O", function(module, exports) {
parcelRequire("kZzRP");

var $5zMeE = parcelRequire("5zMeE");
module.exports = $5zMeE("Array").indexOf;

});
parcelRequire.register("kZzRP", function(module, exports) {
"use strict";

var $2iwSV = parcelRequire("2iwSV");

var $7vOhs = parcelRequire("7vOhs");

var $eejJb = parcelRequire("eejJb");
var $f48553a020e0e4f4$require$$indexOf = $eejJb.indexOf;

var $gH3K8 = parcelRequire("gH3K8");
var $f48553a020e0e4f4$var$nativeIndexOf = $7vOhs([].indexOf);
var $f48553a020e0e4f4$var$NEGATIVE_ZERO = !!$f48553a020e0e4f4$var$nativeIndexOf && 1 / $f48553a020e0e4f4$var$nativeIndexOf([
    1
], 1, -0) < 0;
var $f48553a020e0e4f4$var$FORCED = $f48553a020e0e4f4$var$NEGATIVE_ZERO || !$gH3K8("indexOf");
// `Array.prototype.indexOf` method
// https://tc39.es/ecma262/#sec-array.prototype.indexof
$2iwSV({
    target: "Array",
    proto: true,
    forced: $f48553a020e0e4f4$var$FORCED
}, {
    indexOf: function indexOf(searchElement /* , fromIndex = 0 */ ) {
        var fromIndex = arguments.length > 1 ? arguments[1] : undefined;
        return $f48553a020e0e4f4$var$NEGATIVE_ZERO ? $f48553a020e0e4f4$var$nativeIndexOf(this, searchElement, fromIndex) || 0 : $f48553a020e0e4f4$require$$indexOf(this, searchElement, fromIndex);
    }
});

});





parcelRequire.register("4yjim", function(module, exports) {

module.exports = (parcelRequire("2GR1F"));

});
parcelRequire.register("2GR1F", function(module, exports) {

var $4cYrU = parcelRequire("4cYrU");
module.exports = $4cYrU;

});
parcelRequire.register("4cYrU", function(module, exports) {

var $53bMe = parcelRequire("53bMe");

var $6i8gB = parcelRequire("6i8gB");
var $31072c5de0c93823$var$ArrayPrototype = Array.prototype;
module.exports = function(it) {
    var own = it.splice;
    return it === $31072c5de0c93823$var$ArrayPrototype || $53bMe($31072c5de0c93823$var$ArrayPrototype, it) && own === $31072c5de0c93823$var$ArrayPrototype.splice ? $6i8gB : own;
};

});
parcelRequire.register("6i8gB", function(module, exports) {
parcelRequire("8hIsk");

var $5zMeE = parcelRequire("5zMeE");
module.exports = $5zMeE("Array").splice;

});
parcelRequire.register("8hIsk", function(module, exports) {
"use strict";

var $2iwSV = parcelRequire("2iwSV");

var $h90HQ = parcelRequire("h90HQ");

var $98Q42 = parcelRequire("98Q42");

var $cazda = parcelRequire("cazda");

var $f8kjp = parcelRequire("f8kjp");

var $83Bmy = parcelRequire("83Bmy");

var $a99UF = parcelRequire("a99UF");

var $9JW6X = parcelRequire("9JW6X");

var $dPMro = parcelRequire("dPMro");

var $i9tcV = parcelRequire("i9tcV");

var $ffyhk = parcelRequire("ffyhk");
var $60826545951affa5$var$HAS_SPECIES_SUPPORT = $ffyhk("splice");
var $60826545951affa5$var$max = Math.max;
var $60826545951affa5$var$min = Math.min;
// `Array.prototype.splice` method
// https://tc39.es/ecma262/#sec-array.prototype.splice
// with adding support of @@species
$2iwSV({
    target: "Array",
    proto: true,
    forced: !$60826545951affa5$var$HAS_SPECIES_SUPPORT
}, {
    splice: function splice(start, deleteCount /* , ...items */ ) {
        var O = $h90HQ(this);
        var len = $f8kjp(O);
        var actualStart = $98Q42(start, len);
        var argumentsLength = arguments.length;
        var insertCount, actualDeleteCount, A, k, from, to;
        if (argumentsLength === 0) insertCount = actualDeleteCount = 0;
        else if (argumentsLength === 1) {
            insertCount = 0;
            actualDeleteCount = len - actualStart;
        } else {
            insertCount = argumentsLength - 2;
            actualDeleteCount = $60826545951affa5$var$min($60826545951affa5$var$max($cazda(deleteCount), 0), len - actualStart);
        }
        $a99UF(len + insertCount - actualDeleteCount);
        A = $9JW6X(O, actualDeleteCount);
        for(k = 0; k < actualDeleteCount; k++){
            from = actualStart + k;
            if (from in O) $dPMro(A, k, O[from]);
        }
        A.length = actualDeleteCount;
        if (insertCount < actualDeleteCount) {
            for(k = actualStart; k < len - actualDeleteCount; k++){
                from = k + actualDeleteCount;
                to = k + insertCount;
                if (from in O) O[to] = O[from];
                else $i9tcV(O, to);
            }
            for(k = len; k > len - actualDeleteCount + insertCount; k--)$i9tcV(O, k - 1);
        } else if (insertCount > actualDeleteCount) for(k = len - actualDeleteCount; k > actualStart; k--){
            from = k + actualDeleteCount - 1;
            to = k + insertCount - 1;
            if (from in O) O[to] = O[from];
            else $i9tcV(O, to);
        }
        for(k = 0; k < insertCount; k++)O[k + actualStart] = arguments[k + 2];
        $83Bmy(O, len - actualDeleteCount + insertCount);
        return A;
    }
});

});
parcelRequire.register("83Bmy", function(module, exports) {
"use strict";

var $awFtp = parcelRequire("awFtp");

var $fnf29 = parcelRequire("fnf29");
var $5ddb960918591616$var$$TypeError = TypeError;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $5ddb960918591616$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
// Safari < 13 does not throw an error in this case
var $5ddb960918591616$var$SILENT_ON_NON_WRITABLE_LENGTH_SET = $awFtp && !function() {
    // makes no sense without proper strict mode support
    if (this !== undefined) return true;
    try {
        // eslint-disable-next-line es/no-object-defineproperty -- safe
        Object.defineProperty([], "length", {
            writable: false
        }).length = 1;
    } catch (error) {
        return error instanceof TypeError;
    }
}();
module.exports = $5ddb960918591616$var$SILENT_ON_NON_WRITABLE_LENGTH_SET ? function(O, length) {
    if ($fnf29(O) && !$5ddb960918591616$var$getOwnPropertyDescriptor(O, "length").writable) throw $5ddb960918591616$var$$TypeError("Cannot set read only .length");
    return O.length = length;
} : function(O, length) {
    return O.length = length;
};

});

parcelRequire.register("i9tcV", function(module, exports) {
"use strict";

var $ieZRC = parcelRequire("ieZRC");
var $d36fb9449bd5193b$var$$TypeError = TypeError;
module.exports = function(O, P) {
    if (!delete O[P]) throw $d36fb9449bd5193b$var$$TypeError("Cannot delete property " + $ieZRC(P) + " of " + $ieZRC(O));
};

});







parcelRequire.register("l8hnx", function(module, exports) {

$parcel$export(module.exports, "default", () => $f627d36231c082fb$export$2e2bcd8739ae039);

var $aPoVw = parcelRequire("aPoVw");

var $8zZXT = parcelRequire("8zZXT");

var $gI8ui = parcelRequire("gI8ui");

var $gV225 = parcelRequire("gV225");

var $9gRzx = parcelRequire("9gRzx");

var $eO7Kz = parcelRequire("eO7Kz");

var $bGXcU = parcelRequire("bGXcU");
function $f627d36231c082fb$var$sleepZero() {
    return new (0, (/*@__PURE__*/$parcel$interopDefault($gI8ui)))(function(resolve) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($gV225)))(function() {
            return resolve();
        });
    });
}
function $f627d36231c082fb$export$2e2bcd8739ae039(callbackRefWithSubscribe, observer) {
    (0, $eO7Kz.useEffect)(function() {
        return callbackRefWithSubscribe.subscribe(function(current) {
            if (!current) return;
            var memoizedEmitValue = (0, $9gRzx.default)(function(initial, fraction, width) {
                return observer && observer({
                    initial: initial,
                    fraction: fraction,
                    width: width
                });
            });
            var emitValue = function emitValue(initial) {
                var offsetWidth = current.offsetWidth, scrollLeft = current.scrollLeft, scrollWidth = current.scrollWidth;
                memoizedEmitValue(initial, "".concat(scrollWidth === offsetWidth ? 0 : scrollLeft / (scrollWidth - offsetWidth) * 100, "%"), "".concat(offsetWidth / scrollWidth * 100, "%"));
            };
            var handleScroll = function handleScroll() {
                return emitValue(false);
            };
            var handlePointerOver = (0, $bGXcU.default)(function() {
                // We need to send "onScroll" because "scrollWidth" might have changed
                // For example, the container resized, the scroll width will be incorrect
                // We will debounce to prevent "pointerOver" calculating too often
                // We will memoize to prevent firing unnecessary "onScroll"
                emitValue(false);
            });
            current.addEventListener("pointerover", handlePointerOver, {
                passive: true
            });
            current.addEventListener("scroll", handleScroll, {
                passive: true
            });
            // eslint-disable-next-line wrap-iife
            (0, (/*@__PURE__*/$parcel$interopDefault($8zZXT)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aPoVw)))().mark(function _callee() {
                return (0, (/*@__PURE__*/$parcel$interopDefault($aPoVw)))().wrap(function _callee$(_context) {
                    while(true)switch(_context.prev = _context.next){
                        case 0:
                            if (!(current.scrollWidth === current.offsetWidth)) {
                                _context.next = 3;
                                break;
                            }
                            _context.next = 3;
                            return $f627d36231c082fb$var$sleepZero();
                        case 3:
                            emitValue(true);
                        case 4:
                        case "end":
                            return _context.stop();
                    }
                }, _callee);
            }))();
            return function() {
                current.removeEventListener("pointerover", handlePointerOver);
                current.removeEventListener("scroll", handleScroll);
            };
        });
    }, [
        callbackRefWithSubscribe,
        observer
    ]);
}

});
parcelRequire.register("aPoVw", function(module, exports) {

var $iAigI = parcelRequire("iAigI");
var $7e2200b7b0ea30ba$var$_typeof = $iAigI.default;

var $l6gPz = parcelRequire("l6gPz");

var $d2Q2y = parcelRequire("d2Q2y");

var $ggHjh = parcelRequire("ggHjh");

var $i7fNi = parcelRequire("i7fNi");

var $hbxdt = parcelRequire("hbxdt");

var $874LH = parcelRequire("874LH");

var $hsB2l = parcelRequire("hsB2l");

var $jT8XT = parcelRequire("jT8XT");

var $544fY = parcelRequire("544fY");
function $7e2200b7b0ea30ba$var$_regeneratorRuntime() {
    "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ 
    module.exports = $7e2200b7b0ea30ba$var$_regeneratorRuntime = function _regeneratorRuntime() {
        return exports;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports;
    var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = $l6gPz || function(obj, key, desc) {
        obj[key] = desc.value;
    }, $Symbol = "function" == typeof $d2Q2y ? $d2Q2y : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
    function define(obj, key, value) {
        return $l6gPz(obj, key, {
            value: value,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }), obj[key];
    }
    try {
        define({}, "");
    } catch (err) {
        define = function define(obj, key, value) {
            return obj[key] = value;
        };
    }
    function wrap(innerFn, outerFn, self, tryLocsList) {
        var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = $ggHjh(protoGenerator.prototype), context = new Context(tryLocsList || []);
        return defineProperty(generator, "_invoke", {
            value: makeInvokeMethod(innerFn, self, context)
        }), generator;
    }
    function tryCatch(fn, obj, arg) {
        try {
            return {
                type: "normal",
                arg: fn.call(obj, arg)
            };
        } catch (err) {
            return {
                type: "throw",
                arg: err
            };
        }
    }
    exports.wrap = wrap;
    var ContinueSentinel = {};
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    var IteratorPrototype = {};
    define(IteratorPrototype, iteratorSymbol, function() {
        return this;
    });
    var getProto = $i7fNi, NativeIteratorPrototype = getProto && getProto(getProto(values([])));
    NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype);
    var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = $ggHjh(IteratorPrototype);
    function defineIteratorMethods(prototype) {
        var _context;
        $hbxdt(_context = [
            "next",
            "throw",
            "return"
        ]).call(_context, function(method) {
            define(prototype, method, function(arg) {
                return this._invoke(method, arg);
            });
        });
    }
    function AsyncIterator(generator, PromiseImpl) {
        function invoke(method, arg, resolve, reject) {
            var record = tryCatch(generator[method], generator, arg);
            if ("throw" !== record.type) {
                var result = record.arg, value = result.value;
                return value && "object" == $7e2200b7b0ea30ba$var$_typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function(value) {
                    invoke("next", value, resolve, reject);
                }, function(err) {
                    invoke("throw", err, resolve, reject);
                }) : PromiseImpl.resolve(value).then(function(unwrapped) {
                    result.value = unwrapped, resolve(result);
                }, function(error) {
                    return invoke("throw", error, resolve, reject);
                });
            }
            reject(record.arg);
        }
        var previousPromise;
        defineProperty(this, "_invoke", {
            value: function value(method, arg) {
                function callInvokeWithMethodAndArg() {
                    return new PromiseImpl(function(resolve, reject) {
                        invoke(method, arg, resolve, reject);
                    });
                }
                return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
            }
        });
    }
    function makeInvokeMethod(innerFn, self, context) {
        var state = "suspendedStart";
        return function(method, arg) {
            if ("executing" === state) throw new Error("Generator is already running");
            if ("completed" === state) {
                if ("throw" === method) throw arg;
                return doneResult();
            }
            for(context.method = method, context.arg = arg;;){
                var delegate = context.delegate;
                if (delegate) {
                    var delegateResult = maybeInvokeDelegate(delegate, context);
                    if (delegateResult) {
                        if (delegateResult === ContinueSentinel) continue;
                        return delegateResult;
                    }
                }
                if ("next" === context.method) context.sent = context._sent = context.arg;
                else if ("throw" === context.method) {
                    if ("suspendedStart" === state) throw state = "completed", context.arg;
                    context.dispatchException(context.arg);
                } else "return" === context.method && context.abrupt("return", context.arg);
                state = "executing";
                var record = tryCatch(innerFn, self, context);
                if ("normal" === record.type) {
                    if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue;
                    return {
                        value: record.arg,
                        done: context.done
                    };
                }
                "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg);
            }
        };
    }
    function maybeInvokeDelegate(delegate, context) {
        var methodName = context.method, method = delegate.iterator[methodName];
        if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator["return"] && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel;
        var record = tryCatch(method, delegate.iterator, context.arg);
        if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel;
        var info = record.arg;
        return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel);
    }
    function pushTryEntry(locs) {
        var entry = {
            tryLoc: locs[0]
        };
        1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry);
    }
    function resetTryEntry(entry) {
        var record = entry.completion || {};
        record.type = "normal", delete record.arg, entry.completion = record;
    }
    function Context(tryLocsList) {
        this.tryEntries = [
            {
                tryLoc: "root"
            }
        ], $hbxdt(tryLocsList).call(tryLocsList, pushTryEntry, this), this.reset(!0);
    }
    function values(iterable) {
        if (iterable) {
            var iteratorMethod = iterable[iteratorSymbol];
            if (iteratorMethod) return iteratorMethod.call(iterable);
            if ("function" == typeof iterable.next) return iterable;
            if (!isNaN(iterable.length)) {
                var i = -1, next = function next() {
                    for(; ++i < iterable.length;)if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next;
                    return next.value = undefined, next.done = !0, next;
                };
                return next.next = next;
            }
        }
        return {
            next: doneResult
        };
    }
    function doneResult() {
        return {
            value: undefined,
            done: !0
        };
    }
    return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", {
        value: GeneratorFunctionPrototype,
        configurable: !0
    }), defineProperty(GeneratorFunctionPrototype, "constructor", {
        value: GeneratorFunction,
        configurable: !0
    }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function(genFun) {
        var ctor = "function" == typeof genFun && genFun.constructor;
        return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name));
    }, exports.mark = function(genFun) {
        return $874LH ? $874LH(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = $ggHjh(Gp), genFun;
    }, exports.awrap = function(arg) {
        return {
            __await: arg
        };
    }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function() {
        return this;
    }), exports.AsyncIterator = AsyncIterator, exports.async = function(innerFn, outerFn, self, tryLocsList, PromiseImpl) {
        void 0 === PromiseImpl && (PromiseImpl = $hsB2l);
        var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
        return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function(result) {
            return result.done ? result.value : iter.next();
        });
    }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function() {
        return this;
    }), define(Gp, "toString", function() {
        return "[object Generator]";
    }), exports.keys = function(val) {
        var object = Object(val), keys = [];
        for(var key in object)keys.push(key);
        return $jT8XT(keys).call(keys), function next() {
            for(; keys.length;){
                var key = keys.pop();
                if (key in object) return next.value = key, next.done = !1, next;
            }
            return next.done = !0, next;
        };
    }, exports.values = values, Context.prototype = {
        constructor: Context,
        reset: function reset(skipTempReset) {
            var _context2;
            if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, $hbxdt(_context2 = this.tryEntries).call(_context2, resetTryEntry), !skipTempReset) for(var name in this)"t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+$544fY(name).call(name, 1)) && (this[name] = undefined);
        },
        stop: function stop() {
            this.done = !0;
            var rootRecord = this.tryEntries[0].completion;
            if ("throw" === rootRecord.type) throw rootRecord.arg;
            return this.rval;
        },
        dispatchException: function dispatchException(exception) {
            if (this.done) throw exception;
            var context = this;
            function handle(loc, caught) {
                return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught;
            }
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i], record = entry.completion;
                if ("root" === entry.tryLoc) return handle("end");
                if (entry.tryLoc <= this.prev) {
                    var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc");
                    if (hasCatch && hasFinally) {
                        if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
                        if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
                    } else if (hasCatch) {
                        if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
                    } else {
                        if (!hasFinally) throw new Error("try statement without catch or finally");
                        if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
                    }
                }
            }
        },
        abrupt: function abrupt(type, arg) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
                    var finallyEntry = entry;
                    break;
                }
            }
            finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null);
            var record = finallyEntry ? finallyEntry.completion : {};
            return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record);
        },
        complete: function complete(record, afterLoc) {
            if ("throw" === record.type) throw record.arg;
            return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel;
        },
        finish: function finish(finallyLoc) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel;
            }
        },
        "catch": function _catch(tryLoc) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.tryLoc === tryLoc) {
                    var record = entry.completion;
                    if ("throw" === record.type) {
                        var thrown = record.arg;
                        resetTryEntry(entry);
                    }
                    return thrown;
                }
            }
            throw new Error("illegal catch attempt");
        },
        delegateYield: function delegateYield(iterable, resultName, nextLoc) {
            return this.delegate = {
                iterator: values(iterable),
                resultName: resultName,
                nextLoc: nextLoc
            }, "next" === this.method && (this.arg = undefined), ContinueSentinel;
        }
    }, exports;
}
module.exports = $7e2200b7b0ea30ba$var$_regeneratorRuntime, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRequire.register("ggHjh", function(module, exports) {

module.exports = (parcelRequire("1crzi"));

});
parcelRequire.register("1crzi", function(module, exports) {

module.exports = (parcelRequire("5tERq"));

});
parcelRequire.register("5tERq", function(module, exports) {

var $cKbBn = parcelRequire("cKbBn");
module.exports = $cKbBn;

});
parcelRequire.register("cKbBn", function(module, exports) {

var $6Z7dL = parcelRequire("6Z7dL");
module.exports = $6Z7dL;

});
parcelRequire.register("6Z7dL", function(module, exports) {

var $kFyZu = parcelRequire("kFyZu");
module.exports = $kFyZu;

});
parcelRequire.register("kFyZu", function(module, exports) {
parcelRequire("8WUfh");

var $lahb7 = parcelRequire("lahb7");
var $f0c2c767bce20058$var$Object = $lahb7.Object;
module.exports = function create(P, D) {
    return $f0c2c767bce20058$var$Object.create(P, D);
};

});
parcelRequire.register("8WUfh", function(module, exports) {
// TODO: Remove from `core-js@4`

var $2iwSV = parcelRequire("2iwSV");

var $awFtp = parcelRequire("awFtp");

var $6m5Sk = parcelRequire("6m5Sk");
// `Object.create` method
// https://tc39.es/ecma262/#sec-object.create
$2iwSV({
    target: "Object",
    stat: true,
    sham: !$awFtp
}, {
    create: $6m5Sk
});

});







parcelRequire.register("i7fNi", function(module, exports) {

module.exports = (parcelRequire("djYKm"));

});
parcelRequire.register("djYKm", function(module, exports) {

module.exports = (parcelRequire("leTej"));

});
parcelRequire.register("leTej", function(module, exports) {

var $aMVcB = parcelRequire("aMVcB");
module.exports = $aMVcB;

});
parcelRequire.register("aMVcB", function(module, exports) {

var $yj0fK = parcelRequire("yj0fK");
module.exports = $yj0fK;

});
parcelRequire.register("yj0fK", function(module, exports) {

var $c6C4Y = parcelRequire("c6C4Y");
module.exports = $c6C4Y;

});
parcelRequire.register("c6C4Y", function(module, exports) {
parcelRequire("7wcJ2");

var $lahb7 = parcelRequire("lahb7");
module.exports = $lahb7.Object.getPrototypeOf;

});
parcelRequire.register("7wcJ2", function(module, exports) {

var $2iwSV = parcelRequire("2iwSV");

var $bSIUO = parcelRequire("bSIUO");

var $h90HQ = parcelRequire("h90HQ");

var $2T3Ss = parcelRequire("2T3Ss");

var $1yZLG = parcelRequire("1yZLG");
var $57956493fd24633e$var$FAILS_ON_PRIMITIVES = $bSIUO(function() {
    $2T3Ss(1);
});
// `Object.getPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.getprototypeof
$2iwSV({
    target: "Object",
    stat: true,
    forced: $57956493fd24633e$var$FAILS_ON_PRIMITIVES,
    sham: !$1yZLG
}, {
    getPrototypeOf: function getPrototypeOf(it) {
        return $2T3Ss($h90HQ(it));
    }
});

});







parcelRequire.register("874LH", function(module, exports) {

module.exports = (parcelRequire("jwvn9"));

});
parcelRequire.register("jwvn9", function(module, exports) {

module.exports = (parcelRequire("edz2H"));

});
parcelRequire.register("edz2H", function(module, exports) {

var $e5NlR = parcelRequire("e5NlR");
module.exports = $e5NlR;

});
parcelRequire.register("e5NlR", function(module, exports) {

var $1Y2Sh = parcelRequire("1Y2Sh");
module.exports = $1Y2Sh;

});
parcelRequire.register("1Y2Sh", function(module, exports) {

var $1fNmI = parcelRequire("1fNmI");
module.exports = $1fNmI;

});
parcelRequire.register("1fNmI", function(module, exports) {
parcelRequire("3Md1l");

var $lahb7 = parcelRequire("lahb7");
module.exports = $lahb7.Object.setPrototypeOf;

});
parcelRequire.register("3Md1l", function(module, exports) {

var $2iwSV = parcelRequire("2iwSV");

var $a7qOu = parcelRequire("a7qOu");
// `Object.setPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.setprototypeof
$2iwSV({
    target: "Object",
    stat: true
}, {
    setPrototypeOf: $a7qOu
});

});







parcelRequire.register("hsB2l", function(module, exports) {

module.exports = (parcelRequire("aSKFr"));

});
parcelRequire.register("aSKFr", function(module, exports) {

module.exports = (parcelRequire("aQuid"));

});
parcelRequire.register("aQuid", function(module, exports) {

var $3N3Ww = parcelRequire("3N3Ww");
parcelRequire("5NGUq");
parcelRequire("lmwAm");
parcelRequire("bvi8o");
parcelRequire("l7Moj");
module.exports = $3N3Ww;

});
parcelRequire.register("3N3Ww", function(module, exports) {

var $fYHuX = parcelRequire("fYHuX");
module.exports = $fYHuX;

});

parcelRequire.register("5NGUq", function(module, exports) {
// TODO: Remove from `core-js@4`
parcelRequire("fM4fv");

});

parcelRequire.register("lmwAm", function(module, exports) {
// TODO: Remove from `core-js@4`
parcelRequire("1qg05");

});

parcelRequire.register("bvi8o", function(module, exports) {
"use strict";

var $2iwSV = parcelRequire("2iwSV");

var $h4XGr = parcelRequire("h4XGr");

var $hFxjr = parcelRequire("hFxjr");
// `Promise.try` method
// https://github.com/tc39/proposal-promise-try
$2iwSV({
    target: "Promise",
    stat: true,
    forced: true
}, {
    "try": function(callbackfn) {
        var promiseCapability = $h4XGr.f(this);
        var result = $hFxjr(callbackfn);
        (result.error ? promiseCapability.reject : promiseCapability.resolve)(result.value);
        return promiseCapability.promise;
    }
});

});

parcelRequire.register("l7Moj", function(module, exports) {
// TODO: Remove from `core-js@4`
parcelRequire("dUrYj");

});




parcelRequire.register("jT8XT", function(module, exports) {

module.exports = (parcelRequire("6kkl0"));

});
parcelRequire.register("6kkl0", function(module, exports) {

module.exports = (parcelRequire("dgp1l"));

});
parcelRequire.register("dgp1l", function(module, exports) {

var $5TSXS = parcelRequire("5TSXS");
module.exports = $5TSXS;

});
parcelRequire.register("5TSXS", function(module, exports) {

var $ixtpH = parcelRequire("ixtpH");
module.exports = $ixtpH;

});
parcelRequire.register("ixtpH", function(module, exports) {

var $1yPAc = parcelRequire("1yPAc");
module.exports = $1yPAc;

});
parcelRequire.register("1yPAc", function(module, exports) {

var $53bMe = parcelRequire("53bMe");

var $8dLZc = parcelRequire("8dLZc");
var $1230fab8d65a2941$var$ArrayPrototype = Array.prototype;
module.exports = function(it) {
    var own = it.reverse;
    return it === $1230fab8d65a2941$var$ArrayPrototype || $53bMe($1230fab8d65a2941$var$ArrayPrototype, it) && own === $1230fab8d65a2941$var$ArrayPrototype.reverse ? $8dLZc : own;
};

});
parcelRequire.register("8dLZc", function(module, exports) {
parcelRequire("7UliM");

var $5zMeE = parcelRequire("5zMeE");
module.exports = $5zMeE("Array").reverse;

});
parcelRequire.register("7UliM", function(module, exports) {
"use strict";

var $2iwSV = parcelRequire("2iwSV");

var $dqhay = parcelRequire("dqhay");

var $fnf29 = parcelRequire("fnf29");
var $5c1e497a02ca77dc$var$nativeReverse = $dqhay([].reverse);
var $5c1e497a02ca77dc$var$test = [
    1,
    2
];
// `Array.prototype.reverse` method
// https://tc39.es/ecma262/#sec-array.prototype.reverse
// fix for Safari 12.0 bug
// https://bugs.webkit.org/show_bug.cgi?id=188794
$2iwSV({
    target: "Array",
    proto: true,
    forced: String($5c1e497a02ca77dc$var$test) === String($5c1e497a02ca77dc$var$test.reverse())
}, {
    reverse: function reverse() {
        // eslint-disable-next-line no-self-assign -- dirty hack
        if ($fnf29(this)) this.length = this.length;
        return $5c1e497a02ca77dc$var$nativeReverse(this);
    }
});

});









parcelRequire.register("8zZXT", function(module, exports) {

var $hsB2l = parcelRequire("hsB2l");
function $63f1a88fffd0fb24$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) resolve(value);
    else $hsB2l.resolve(value).then(_next, _throw);
}
function $63f1a88fffd0fb24$var$_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new $hsB2l(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                $63f1a88fffd0fb24$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                $63f1a88fffd0fb24$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
module.exports = $63f1a88fffd0fb24$var$_asyncToGenerator, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRequire.register("gI8ui", function(module, exports) {

module.exports = (parcelRequire("fYHuX"));

});

parcelRequire.register("bGXcU", function(module, exports) {

$parcel$export(module.exports, "default", () => $88318b4b21ccd567$export$2e2bcd8739ae039);

var $gV225 = parcelRequire("gV225");

var $166Cb = parcelRequire("166Cb");
function $88318b4b21ccd567$var$later(fn, interval) {
    if (interval > 0) return (0, (/*@__PURE__*/$parcel$interopDefault($gV225)))(fn, interval);
    fn();
}
function $88318b4b21ccd567$export$2e2bcd8739ae039(fn, interval) {
    var last = 0;
    var timeout;
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        timeout || (timeout = $88318b4b21ccd567$var$later(function() {
            timeout = null;
            last = (0, (/*@__PURE__*/$parcel$interopDefault($166Cb)))();
            fn.apply(void 0, args);
        }, interval + last - (0, (/*@__PURE__*/$parcel$interopDefault($166Cb)))()));
    };
}

});



parcelRequire.register("4tLNN", function(module, exports) {

$parcel$export(module.exports, "default", () => $342ef364ab18cb1d$export$2e2bcd8739ae039);

var $eO7Kz = parcelRequire("eO7Kz");

var $d7ywg = parcelRequire("d7ywg");
var $342ef364ab18cb1d$var$deprecationNotesShown;
var $342ef364ab18cb1d$var$DeprecatedFilmStrip = function DeprecatedFilmStrip(props) {
    if (!$342ef364ab18cb1d$var$deprecationNotesShown) {
        console.warn("react-film: <FilmStrip> is being renamed to <Filmstrip>.");
        $342ef364ab18cb1d$var$deprecationNotesShown = true;
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eO7Kz))).createElement((0, $d7ywg.default), props);
};
$342ef364ab18cb1d$var$DeprecatedFilmStrip.defaultProps = (0, $d7ywg.default).defaultProps;
$342ef364ab18cb1d$var$DeprecatedFilmStrip.propTypes = (0, $d7ywg.default).propTypes;
var $342ef364ab18cb1d$export$2e2bcd8739ae039 = $342ef364ab18cb1d$var$DeprecatedFilmStrip;

});

parcelRequire.register("jJK6r", function(module, exports) {

$parcel$export(module.exports, "default", () => $e5e5fb609a6c776f$export$2e2bcd8739ae039);

var $k0QRm = parcelRequire("k0QRm");

var $f7UXb = parcelRequire("f7UXb");

var $eO7Kz = parcelRequire("eO7Kz");

var $2pBaw = parcelRequire("2pBaw");

var $9rtoc = parcelRequire("9rtoc");
var $e5e5fb609a6c776f$var$ReactFilm = function ReactFilm(_ref) {
    var autoCenter = _ref.autoCenter, autoHide = _ref.autoHide, autoHideFlipperOnEdge = _ref.autoHideFlipperOnEdge, children = _ref.children, className = _ref.className, dir = _ref.dir, flipperBlurFocusOnClick = _ref.flipperBlurFocusOnClick, height = _ref.height, leftFlipperAriaLabel = _ref.leftFlipperAriaLabel, leftFlipperText = _ref.leftFlipperText, nonce = _ref.nonce, rightFlipperAriaLabel = _ref.rightFlipperAriaLabel, rightFlipperText = _ref.rightFlipperText, showDots = _ref.showDots, showFlipper = _ref.showFlipper, showScrollBar = _ref.showScrollBar, styleSet = _ref.styleSet;
    var styleOptions = (0, $eO7Kz.useMemo)(function() {
        return {
            autoCenter: autoCenter,
            autoHide: autoHide,
            autoHideFlipperOnEdge: autoHideFlipperOnEdge,
            dir: dir,
            leftFlipperAriaLabel: leftFlipperAriaLabel,
            leftFlipperText: leftFlipperText,
            flipperBlurFocusOnClick: flipperBlurFocusOnClick,
            rightFlipperAriaLabel: rightFlipperAriaLabel,
            rightFlipperText: rightFlipperText,
            showDots: showDots,
            showFlipper: showFlipper,
            showScrollBar: showScrollBar
        };
    }, [
        autoCenter,
        autoHide,
        autoHideFlipperOnEdge,
        dir,
        leftFlipperAriaLabel,
        leftFlipperText,
        flipperBlurFocusOnClick,
        rightFlipperAriaLabel,
        rightFlipperText,
        showDots,
        showFlipper,
        showScrollBar
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eO7Kz))).createElement((0, $9rtoc.default), {
        dir: dir,
        height: height,
        nonce: nonce,
        numItems: children ? (0, $eO7Kz.Children).count(children) : 0,
        styleOptions: styleOptions,
        styleSet: styleSet
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eO7Kz))).createElement((0, $2pBaw.default), {
        className: className
    }, children));
};
$e5e5fb609a6c776f$var$ReactFilm.defaultProps = (0, (/*@__PURE__*/$parcel$interopDefault($k0QRm)))((0, (/*@__PURE__*/$parcel$interopDefault($k0QRm)))({}, (0, $2pBaw.default).defaultProps), {}, {
    autoCenter: undefined,
    autoHide: undefined,
    autoHideFlipperOnEdge: undefined,
    children: undefined,
    className: undefined,
    dir: undefined,
    flipperBlurFocusOnClick: undefined,
    leftFlipperAriaLabel: undefined,
    leftFlipperText: undefined,
    nonce: undefined,
    rightFlipperAriaLabel: undefined,
    rightFlipperText: undefined,
    showDots: undefined,
    showFlipper: undefined,
    showScrollBar: undefined,
    styleSet: undefined
});
$e5e5fb609a6c776f$var$ReactFilm.propTypes = (0, (/*@__PURE__*/$parcel$interopDefault($k0QRm)))((0, (/*@__PURE__*/$parcel$interopDefault($k0QRm)))({}, (0, $2pBaw.default).propTypes), {}, {
    autoCenter: (0, (/*@__PURE__*/$parcel$interopDefault($f7UXb))).bool,
    autoHide: (0, (/*@__PURE__*/$parcel$interopDefault($f7UXb))).bool,
    autoHideFlipperOnEdge: (0, (/*@__PURE__*/$parcel$interopDefault($f7UXb))).bool,
    children: (0, (/*@__PURE__*/$parcel$interopDefault($f7UXb))).any,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($f7UXb))).string,
    dir: (0, (/*@__PURE__*/$parcel$interopDefault($f7UXb))).oneOf([
        "auto",
        "ltr",
        "rtl"
    ]),
    flipperBlurFocusOnClick: (0, (/*@__PURE__*/$parcel$interopDefault($f7UXb))).bool,
    height: (0, (/*@__PURE__*/$parcel$interopDefault($f7UXb))).number,
    leftFlipperAriaLabel: (0, (/*@__PURE__*/$parcel$interopDefault($f7UXb))).string,
    leftFlipperText: (0, (/*@__PURE__*/$parcel$interopDefault($f7UXb))).string,
    nonce: (0, (/*@__PURE__*/$parcel$interopDefault($f7UXb))).string,
    rightFlipperAriaLabel: (0, (/*@__PURE__*/$parcel$interopDefault($f7UXb))).string,
    rightFlipperText: (0, (/*@__PURE__*/$parcel$interopDefault($f7UXb))).string,
    showDots: (0, (/*@__PURE__*/$parcel$interopDefault($f7UXb))).bool,
    showFlipper: (0, (/*@__PURE__*/$parcel$interopDefault($f7UXb))).bool,
    showScrollBar: (0, (/*@__PURE__*/$parcel$interopDefault($f7UXb))).bool,
    styleSet: (0, (/*@__PURE__*/$parcel$interopDefault($f7UXb))).any
});
var $e5e5fb609a6c776f$export$2e2bcd8739ae039 = $e5e5fb609a6c776f$var$ReactFilm;

});

parcelRequire.register("6UtLI", function(module, exports) {

$parcel$export(module.exports, "default", () => $507f107263ca74c4$export$2e2bcd8739ae039);

var $etP1P = parcelRequire("etP1P");
function $507f107263ca74c4$export$2e2bcd8739ae039() {
    var _useViewContext = (0, $etP1P.default)(), indexFraction = _useViewContext.indexFraction;
    return [
        indexFraction
    ];
}

});


parcelRequire.register("kbcsp", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $eb0e7f724c2612e6$var$computeSuggestedActionText;
// Please refer to this article to find out how to compute the "button text" for suggested action.
// https://github.com/Microsoft/botframework-sdk/blob/main/specs/botframework-activity/botframework-activity.md#card-action
function $eb0e7f724c2612e6$var$computeSuggestedActionText(cardAction) {
    // "CardAction" must contains at least image or title.
    var _ref = cardAction, title = _ref.title;
    var type = cardAction.type, value = cardAction.value;
    if (type === "messageBack") return title || cardAction.displayText;
    else if (title) return title;
    else if (typeof value === "string") return value;
    return JSON.stringify(value);
}

});

parcelRequire.register("8tT0c", function(module, exports) {
"use strict";
function $62cbb26eb443e6b0$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $62cbb26eb443e6b0$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $62cbb26eb443e6b0$var$_typeof(obj);
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $62cbb26eb443e6b0$var$_propTypes = $62cbb26eb443e6b0$var$_interopRequireDefault((parcelRequire("f7UXb")));

var $62cbb26eb443e6b0$var$_react = $62cbb26eb443e6b0$var$_interopRequireWildcard((parcelRequire("eO7Kz")));

var $62cbb26eb443e6b0$var$_Context = $62cbb26eb443e6b0$var$_interopRequireDefault((parcelRequire("l3eK3")));
function $62cbb26eb443e6b0$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($62cbb26eb443e6b0$var$_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $62cbb26eb443e6b0$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || $62cbb26eb443e6b0$var$_typeof(obj) !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $62cbb26eb443e6b0$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $62cbb26eb443e6b0$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/* eslint complexity: ["error", 50] */ var $62cbb26eb443e6b0$var$RovingTabIndexComposer = function RovingTabIndexComposer(_ref) {
    var children = _ref.children, onEscapeKey = _ref.onEscapeKey, orientation = _ref.orientation;
    var activeItemIndexRef = (0, $62cbb26eb443e6b0$var$_react.useRef)(0);
    var itemRefsRef = (0, $62cbb26eb443e6b0$var$_react.useRef)([]);
    var refreshTabIndices = (0, $62cbb26eb443e6b0$var$_react.useCallback)(function() {
        var activeItemIndex = activeItemIndexRef.current;
        itemRefsRef.current.forEach(function(_ref2, index) {
            var current = _ref2.current;
            current === null || current === void 0 || current.setAttribute("tabindex", activeItemIndex === index ? "0" : "-1");
        });
    }, [
        activeItemIndexRef
    ]);
    var setActiveItemIndex = (0, $62cbb26eb443e6b0$var$_react.useCallback)(function(valueOrFunction) {
        var _itemRefsRef$current$;
        // All calls to this function is expected to be under event handlers (post-rendering).
        var nextActiveItemIndex;
        if (typeof valueOrFunction === "number") nextActiveItemIndex = valueOrFunction;
        else nextActiveItemIndex = valueOrFunction(activeItemIndexRef.current);
         // If the index points to no item, fallback to the first item.
        // This make sure at least one of the item in the container is selected.
        if (nextActiveItemIndex && !((_itemRefsRef$current$ = itemRefsRef.current[+nextActiveItemIndex]) !== null && _itemRefsRef$current$ !== void 0 && _itemRefsRef$current$.current)) nextActiveItemIndex = 0;
        if (activeItemIndexRef.current !== nextActiveItemIndex) {
            var _itemRefsRef$current$2, _itemRefsRef$current$3;
            activeItemIndexRef.current = nextActiveItemIndex;
            refreshTabIndices();
            (_itemRefsRef$current$2 = itemRefsRef.current[+nextActiveItemIndex]) === null || _itemRefsRef$current$2 === void 0 || (_itemRefsRef$current$3 = _itemRefsRef$current$2.current) === null || _itemRefsRef$current$3 === void 0 || _itemRefsRef$current$3.focus();
        }
    }, [
        activeItemIndexRef,
        itemRefsRef,
        refreshTabIndices
    ]);
    var handleFocus = (0, $62cbb26eb443e6b0$var$_react.useCallback)(function(event) {
        var target = event.target;
        var index = itemRefsRef.current.findIndex(function(_ref3) {
            var current = _ref3.current;
            return current === target;
        });
        ~index && setActiveItemIndex(index);
    }, [
        itemRefsRef,
        setActiveItemIndex
    ]);
    var handleKeyDown = (0, $62cbb26eb443e6b0$var$_react.useCallback)(function(event) {
        var key = event.key;
        var vertical = orientation === "vertical";
        switch(key){
            case "ArrowDown":
            case "ArrowRight":
            case "Down":
            case "Right":
                // IE11
                if (vertical && key === "ArrowRight" || !vertical && key === "ArrowDown") return;
                setActiveItemIndex(function(value) {
                    // The `itemRefsRef` array could be a sparse array.
                    // Thus, the next item may not be immediately next to the current one.
                    var itemIndices = itemRefsRef.current.map(function(_, index) {
                        return index;
                    });
                    var nextIndex = itemIndices.indexOf(value) + 1;
                    if (nextIndex >= itemIndices.length) return itemIndices[0];
                    return itemIndices[+nextIndex];
                });
                break;
            case "ArrowLeft":
            case "ArrowUp":
            case "Left":
            case "Up":
                // IE11
                if (vertical && key === "ArrowLeft" || !vertical && key === "ArrowUp") return;
                setActiveItemIndex(function(value) {
                    // The `itemRefsRef` array could be a sparse array.
                    // Thus, the next item may not be immediately next to the current one.
                    var itemIndices = itemRefsRef.current.map(function(_, index) {
                        return index;
                    });
                    var nextIndex = itemIndices.indexOf(value) - 1;
                    if (nextIndex < 0) return itemIndices[itemIndices.length - 1];
                    return itemIndices[+nextIndex];
                });
                break;
            case "Home":
                setActiveItemIndex(0);
                break;
            case "End":
                setActiveItemIndex(Infinity);
                break;
            case "Escape":
                if (!onEscapeKey) // If the "onEscapeKey" prop is not passed, don't call preventDefault() and stopPropagation().
                return;
                onEscapeKey();
                break;
            default:
                return;
        }
        event.preventDefault();
        event.stopPropagation();
    }, [
        setActiveItemIndex,
        onEscapeKey,
        orientation
    ]);
    var itemEffector = (0, $62cbb26eb443e6b0$var$_react.useCallback)(function(ref, index) {
        var current = ref.current;
        itemRefsRef.current[+index] = ref;
        current.addEventListener("focus", handleFocus);
        current.addEventListener("keydown", handleKeyDown);
        current.setAttribute("tabindex", activeItemIndexRef.current === index ? "0" : "-1");
        return function() {
            current.removeEventListener("focus", handleFocus);
            current.removeEventListener("keydown", handleKeyDown);
            delete itemRefsRef.current[+index];
        };
    }, [
        activeItemIndexRef,
        handleFocus,
        handleKeyDown
    ]);
    var contextValue = (0, $62cbb26eb443e6b0$var$_react.useMemo)(function() {
        return {
            itemEffector: itemEffector
        };
    }, [
        itemEffector
    ]); // This hook run on every render to rectify `activeItemIndexRef`.
    // So it will always point to an existing item or first item if available.
    (0, $62cbb26eb443e6b0$var$_react.useEffect)(function() {
        setActiveItemIndex(function(value) {
            return value;
        });
    });
    return /*#__PURE__*/ $62cbb26eb443e6b0$var$_react.default.createElement($62cbb26eb443e6b0$var$_Context.default.Provider, {
        value: contextValue
    }, children);
};
$62cbb26eb443e6b0$var$RovingTabIndexComposer.defaultProps = {
    onEscapeKey: undefined,
    orientation: "horizontal"
};
$62cbb26eb443e6b0$var$RovingTabIndexComposer.propTypes = {
    onEscapeKey: $62cbb26eb443e6b0$var$_propTypes.default.func,
    orientation: $62cbb26eb443e6b0$var$_propTypes.default.oneOf([
        "horizontal",
        "vertical"
    ])
};
var $62cbb26eb443e6b0$var$_default = $62cbb26eb443e6b0$var$RovingTabIndexComposer;
module.exports.default = $62cbb26eb443e6b0$var$_default;

});
parcelRequire.register("l3eK3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $eO7Kz = parcelRequire("eO7Kz");
var $f535502dd84c8722$var$RovingTabIndexContext = /*#__PURE__*/ (0, $eO7Kz.createContext)({
    itemEffector: function itemEffector() {
        // This will be implemented when using in <RovingTabIndexComposer>.
        // We have a check over there to make sure we did implement it.
        throw new Error("botframework-webchat internal: Not implemented.");
    }
});
var $f535502dd84c8722$var$_default = $f535502dd84c8722$var$RovingTabIndexContext;
module.exports.default = $f535502dd84c8722$var$_default;

});


parcelRequire.register("5pUEO", function(module, exports) {
"use strict";
function $3f1b3c8376ea15d1$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $3f1b3c8376ea15d1$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $3f1b3c8376ea15d1$var$_typeof(obj);
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = module.exports.connectSuggestedAction = void 0;

var $hd4g0 = parcelRequire("hd4g0");

var $3f1b3c8376ea15d1$var$_classnames = $3f1b3c8376ea15d1$var$_interopRequireDefault((parcelRequire("5A4MD")));

var $3f1b3c8376ea15d1$var$_propTypes = $3f1b3c8376ea15d1$var$_interopRequireDefault((parcelRequire("f7UXb")));

var $3f1b3c8376ea15d1$var$_react = $3f1b3c8376ea15d1$var$_interopRequireWildcard((parcelRequire("eO7Kz")));

var $3f1b3c8376ea15d1$var$_AccessibleButton = $3f1b3c8376ea15d1$var$_interopRequireDefault((parcelRequire("i4zc7")));

var $3f1b3c8376ea15d1$var$_connectToWebChat = $3f1b3c8376ea15d1$var$_interopRequireDefault((parcelRequire("86vmQ")));

var $3f1b3c8376ea15d1$var$_useFocus = $3f1b3c8376ea15d1$var$_interopRequireDefault((parcelRequire("kPV7d")));

var $3f1b3c8376ea15d1$var$_useFocusAccessKeyEffect = $3f1b3c8376ea15d1$var$_interopRequireDefault((parcelRequire("gi2A6")));

var $3f1b3c8376ea15d1$var$_useFocusVisible3 = $3f1b3c8376ea15d1$var$_interopRequireDefault((parcelRequire("cp2aW")));

var $3f1b3c8376ea15d1$var$_useItemRef = $3f1b3c8376ea15d1$var$_interopRequireDefault((parcelRequire("epwVF")));

var $3f1b3c8376ea15d1$var$_useLocalizeAccessKey = $3f1b3c8376ea15d1$var$_interopRequireDefault((parcelRequire("5FNn4")));

var $3f1b3c8376ea15d1$var$_useScrollToEnd = $3f1b3c8376ea15d1$var$_interopRequireDefault((parcelRequire("gaC1T")));

var $3f1b3c8376ea15d1$var$_useStyleSet3 = $3f1b3c8376ea15d1$var$_interopRequireDefault((parcelRequire("gC6jZ")));

var $3f1b3c8376ea15d1$var$_useStyleToEmotionObject = $3f1b3c8376ea15d1$var$_interopRequireDefault((parcelRequire("6l4uV")));

var $3f1b3c8376ea15d1$var$_useSuggestedActionsAccessKey = $3f1b3c8376ea15d1$var$_interopRequireDefault((parcelRequire("aZ6Uh")));
function $3f1b3c8376ea15d1$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($3f1b3c8376ea15d1$var$_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $3f1b3c8376ea15d1$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || $3f1b3c8376ea15d1$var$_typeof(obj) !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $3f1b3c8376ea15d1$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $3f1b3c8376ea15d1$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $3f1b3c8376ea15d1$var$_extends() {
    $3f1b3c8376ea15d1$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $3f1b3c8376ea15d1$var$_extends.apply(this, arguments);
}
function $3f1b3c8376ea15d1$var$_slicedToArray(arr, i) {
    return $3f1b3c8376ea15d1$var$_arrayWithHoles(arr) || $3f1b3c8376ea15d1$var$_iterableToArrayLimit(arr, i) || $3f1b3c8376ea15d1$var$_unsupportedIterableToArray(arr, i) || $3f1b3c8376ea15d1$var$_nonIterableRest();
}
function $3f1b3c8376ea15d1$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $3f1b3c8376ea15d1$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $3f1b3c8376ea15d1$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $3f1b3c8376ea15d1$var$_arrayLikeToArray(o, minLen);
}
function $3f1b3c8376ea15d1$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $3f1b3c8376ea15d1$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $3f1b3c8376ea15d1$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
var $3f1b3c8376ea15d1$var$useDirection = $hd4g0.hooks.useDirection, $3f1b3c8376ea15d1$var$useDisabled = $hd4g0.hooks.useDisabled, $3f1b3c8376ea15d1$var$usePerformCardAction = $hd4g0.hooks.usePerformCardAction, $3f1b3c8376ea15d1$var$useStyleOptions = $hd4g0.hooks.useStyleOptions, $3f1b3c8376ea15d1$var$useSuggestedActions = $hd4g0.hooks.useSuggestedActions;
var $3f1b3c8376ea15d1$var$ROOT_STYLE = {
    "&.webchat__suggested-action": {
        display: "flex",
        overflow: "hidden" // Prevent image from leaking; object-fit does not work with IE11
    }
};
var $3f1b3c8376ea15d1$var$connectSuggestedAction = function connectSuggestedAction() {
    for(var _len = arguments.length, selectors = new Array(_len), _key = 0; _key < _len; _key++)selectors[_key] = arguments[_key];
    return $3f1b3c8376ea15d1$var$_connectToWebChat.default.apply(void 0, [
        function(_ref, _ref2) {
            var clearSuggestedActions = _ref.clearSuggestedActions, disabled = _ref.disabled, language = _ref.language, onCardAction = _ref.onCardAction;
            var displayText = _ref2.displayText, text = _ref2.text, type = _ref2.type, value = _ref2.value;
            return {
                click: function click() {
                    onCardAction({
                        displayText: displayText,
                        text: text,
                        type: type,
                        value: value
                    });
                    type === "openUrl" && clearSuggestedActions();
                },
                disabled: disabled,
                language: language
            };
        }
    ].concat(selectors));
};
module.exports.connectSuggestedAction = $3f1b3c8376ea15d1$var$connectSuggestedAction;
var $3f1b3c8376ea15d1$var$SuggestedAction = function SuggestedAction(_ref3) {
    var buttonText = _ref3.buttonText, className = _ref3.className, displayText = _ref3.displayText, image = _ref3.image, imageAlt = _ref3.imageAlt, itemIndex = _ref3.itemIndex, text = _ref3.text, textClassName = _ref3.textClassName, type = _ref3.type, value = _ref3.value;
    var _useSuggestedActions = $3f1b3c8376ea15d1$var$useSuggestedActions(), _useSuggestedActions2 = $3f1b3c8376ea15d1$var$_slicedToArray(_useSuggestedActions, 2), _ = _useSuggestedActions2[0], setSuggestedActions = _useSuggestedActions2[1];
    var _useStyleOptions = $3f1b3c8376ea15d1$var$useStyleOptions(), _useStyleOptions2 = $3f1b3c8376ea15d1$var$_slicedToArray(_useStyleOptions, 1), suggestedActionsStackedLayoutButtonTextWrap = _useStyleOptions2[0].suggestedActionsStackedLayoutButtonTextWrap;
    var _useStyleSet = (0, $3f1b3c8376ea15d1$var$_useStyleSet3.default)(), _useStyleSet2 = $3f1b3c8376ea15d1$var$_slicedToArray(_useStyleSet, 1), suggestedActionStyleSet = _useStyleSet2[0].suggestedAction;
    var _useSuggestedActionsA = (0, $3f1b3c8376ea15d1$var$_useSuggestedActionsAccessKey.default)(), _useSuggestedActionsA2 = $3f1b3c8376ea15d1$var$_slicedToArray(_useSuggestedActionsA, 1), accessKey = _useSuggestedActionsA2[0];
    var _useDirection = $3f1b3c8376ea15d1$var$useDirection(), _useDirection2 = $3f1b3c8376ea15d1$var$_slicedToArray(_useDirection, 1), direction = _useDirection2[0];
    var _useDisabled = $3f1b3c8376ea15d1$var$useDisabled(), _useDisabled2 = $3f1b3c8376ea15d1$var$_slicedToArray(_useDisabled, 1), disabled = _useDisabled2[0];
    var focus = (0, $3f1b3c8376ea15d1$var$_useFocus.default)();
    var focusRef = (0, $3f1b3c8376ea15d1$var$_useItemRef.default)(itemIndex);
    var localizeAccessKeyAsAriaKeyShortcuts = (0, $3f1b3c8376ea15d1$var$_useLocalizeAccessKey.default)("aria-keyshortcuts");
    var performCardAction = $3f1b3c8376ea15d1$var$usePerformCardAction();
    var rootClassName = (0, $3f1b3c8376ea15d1$var$_useStyleToEmotionObject.default)()($3f1b3c8376ea15d1$var$ROOT_STYLE) + "";
    var scrollToEnd = (0, $3f1b3c8376ea15d1$var$_useScrollToEnd.default)();
    var _useFocusVisible = (0, $3f1b3c8376ea15d1$var$_useFocusVisible3.default)(focusRef), _useFocusVisible2 = $3f1b3c8376ea15d1$var$_slicedToArray(_useFocusVisible, 1), focusVisible = _useFocusVisible2[0];
    var handleClick = (0, $3f1b3c8376ea15d1$var$_react.useCallback)(function(_ref4) {
        var target = _ref4.target;
        // TODO: [P3] #XXX We should not destruct DirectLineCardAction into React props and pass them in. It makes typings difficult.
        //       Instead, we should pass a "cardAction" props.
        performCardAction({
            displayText: displayText,
            text: text,
            type: type,
            value: value
        }, {
            target: target
        }); // Since "openUrl" action do not submit, the suggested action buttons do not hide after click.
        type === "openUrl" && setSuggestedActions([]);
        focus("sendBoxWithoutKeyboard");
        scrollToEnd();
    }, [
        displayText,
        focus,
        performCardAction,
        scrollToEnd,
        setSuggestedActions,
        text,
        type,
        value
    ]);
    (0, $3f1b3c8376ea15d1$var$_useFocusAccessKeyEffect.default)(accessKey, focusRef);
    return /*#__PURE__*/ $3f1b3c8376ea15d1$var$_react.default.createElement($3f1b3c8376ea15d1$var$_AccessibleButton.default, $3f1b3c8376ea15d1$var$_extends({}, accessKey ? {
        "aria-keyshortcuts": localizeAccessKeyAsAriaKeyShortcuts(accessKey)
    } : {}, {
        className: (0, $3f1b3c8376ea15d1$var$_classnames.default)("webchat__suggested-action", {
            "webchat__suggested-action--focus-visible": focusVisible,
            "webchat__suggested-action--rtl": direction === "rtl",
            "webchat__suggested-action--wrapping": suggestedActionsStackedLayoutButtonTextWrap
        }, rootClassName, suggestedActionStyleSet + "", (className || "") + ""),
        disabled: disabled,
        onClick: handleClick,
        ref: focusRef,
        type: "button"
    }), image && /*#__PURE__*/ $3f1b3c8376ea15d1$var$_react.default.createElement("img", {
        alt: imageAlt,
        className: (0, $3f1b3c8376ea15d1$var$_classnames.default)("webchat__suggested-action__image", direction === "rtl" && "webchat__suggested-action__image--rtl"),
        src: image
    }), /*#__PURE__*/ $3f1b3c8376ea15d1$var$_react.default.createElement("span", {
        className: (0, $3f1b3c8376ea15d1$var$_classnames.default)("webchat__suggested-action__text", (textClassName || "") + "")
    }, buttonText), /*#__PURE__*/ $3f1b3c8376ea15d1$var$_react.default.createElement("div", {
        className: "webchat__suggested-action__keyboard-focus-indicator"
    }));
};
$3f1b3c8376ea15d1$var$SuggestedAction.defaultProps = {
    className: "",
    displayText: "",
    image: "",
    imageAlt: undefined,
    text: "",
    textClassName: "",
    type: undefined,
    value: undefined
};
$3f1b3c8376ea15d1$var$SuggestedAction.propTypes = {
    buttonText: $3f1b3c8376ea15d1$var$_propTypes.default.string.isRequired,
    className: $3f1b3c8376ea15d1$var$_propTypes.default.string,
    displayText: $3f1b3c8376ea15d1$var$_propTypes.default.string,
    image: $3f1b3c8376ea15d1$var$_propTypes.default.string,
    imageAlt: $3f1b3c8376ea15d1$var$_propTypes.default.string,
    itemIndex: $3f1b3c8376ea15d1$var$_propTypes.default.number.isRequired,
    text: $3f1b3c8376ea15d1$var$_propTypes.default.string,
    textClassName: $3f1b3c8376ea15d1$var$_propTypes.default.string,
    // TypeScript class is not mappable to PropTypes.
    // @ts-ignore
    type: $3f1b3c8376ea15d1$var$_propTypes.default.string,
    value: $3f1b3c8376ea15d1$var$_propTypes.default.any
};
var $3f1b3c8376ea15d1$var$_default = $3f1b3c8376ea15d1$var$SuggestedAction;
module.exports.default = $3f1b3c8376ea15d1$var$_default;

});
parcelRequire.register("kPV7d", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $f2b4dff89c2dbc99$var$useFocus;

var $eO7Kz = parcelRequire("eO7Kz");

var $f2b4dff89c2dbc99$var$_useWebChatUIContext2 = $f2b4dff89c2dbc99$var$_interopRequireDefault((parcelRequire("tHuBR")));
function $f2b4dff89c2dbc99$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $f2b4dff89c2dbc99$var$useFocus() {
    var _useWebChatUIContext = (0, $f2b4dff89c2dbc99$var$_useWebChatUIContext2.default)(), focusSendBoxCallbacksRef = _useWebChatUIContext.focusSendBoxCallbacksRef, focusTranscriptCallbacksRef = _useWebChatUIContext.focusTranscriptCallbacksRef;
    return (0, $eO7Kz.useCallback)(function(where) {
        if (where === "sendBoxWithoutKeyboard") return focusSendBoxCallbacksRef.current.forEach(function(callback) {
            return callback({
                noKeyboard: true
            });
        });
        var _ref = where === "sendBox" ? focusSendBoxCallbacksRef : focusTranscriptCallbacksRef, current = _ref.current;
        current.forEach(function(callback) {
            return callback();
        });
    }, [
        focusSendBoxCallbacksRef,
        focusTranscriptCallbacksRef
    ]);
}

});

parcelRequire.register("gi2A6", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $030f7d3b48861fc2$var$useFocusAccessKeyEffect;

var $eO7Kz = parcelRequire("eO7Kz");

var $030f7d3b48861fc2$var$_useContext = $030f7d3b48861fc2$var$_interopRequireDefault((parcelRequire("kjq7e")));
function $030f7d3b48861fc2$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $030f7d3b48861fc2$var$removeInline(array, item) {
    var index = array.indexOf(item);
    ~index && array.splice(index, 1);
}
function $030f7d3b48861fc2$var$useFocusAccessKeyEffect(key, ref) {
    if (key && typeof key !== "string") throw new Error('useFocusAccessKeyEffect: If defined, "key" must be of type "string".');
    else if (!ref || !("current" in ref)) throw new Error('useFocusAccessKeyEffect: "ref" must be defined and has "current" property.');
    var context = (0, $030f7d3b48861fc2$var$_useContext.default)();
    (0, $eO7Kz.useEffect)(function() {
        if (key) {
            var entry = {
                keys: key.split(/[\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]+/g),
                ref: ref
            };
            context.focii.push(entry);
            return function() {
                return $030f7d3b48861fc2$var$removeInline(context.focii, entry);
            };
        }
    }, [
        context,
        key,
        ref
    ]);
}

});
parcelRequire.register("kjq7e", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $ec99d6ff3994c373$var$useAccessKeySinkContext;

var $eO7Kz = parcelRequire("eO7Kz");

var $ec99d6ff3994c373$var$_Context = $ec99d6ff3994c373$var$_interopRequireDefault((parcelRequire("7MZoY")));
function $ec99d6ff3994c373$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $ec99d6ff3994c373$var$useAccessKeySinkContext() {
    return (0, $eO7Kz.useContext)($ec99d6ff3994c373$var$_Context.default);
}

});


parcelRequire.register("epwVF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $a7dcf18031b85f63$var$useItemRef;

var $eO7Kz = parcelRequire("eO7Kz");

var $a7dcf18031b85f63$var$_useContext2 = $a7dcf18031b85f63$var$_interopRequireDefault((parcelRequire("2DTNV")));
function $a7dcf18031b85f63$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $a7dcf18031b85f63$var$useItemRef(itemIndex) {
    var ref = (0, $eO7Kz.useRef)();
    var _useContext = (0, $a7dcf18031b85f63$var$_useContext2.default)(), itemEffector = _useContext.itemEffector;
    (0, $eO7Kz.useEffect)(function() {
        itemEffector(ref, itemIndex);
    });
    return ref;
}

});
parcelRequire.register("2DTNV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $1eca82da31d1d532$var$useRovingTabIndexContext;

var $eO7Kz = parcelRequire("eO7Kz");

var $1eca82da31d1d532$var$_Context = $1eca82da31d1d532$var$_interopRequireDefault((parcelRequire("l3eK3")));
function $1eca82da31d1d532$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $1eca82da31d1d532$var$useRovingTabIndexContext() {
    var throwOnUndefined = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
    var contextValue = (0, $eO7Kz.useContext)($1eca82da31d1d532$var$_Context.default);
    if (throwOnUndefined && !contextValue) throw new Error("botframework-webchat internal: This hook can only be used under <RovingTabIndexComposer>.");
    return contextValue;
}

});


parcelRequire.register("5FNn4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $4217142ad68b30ee$var$useLocalizeAccessKey;

var $hd4g0 = parcelRequire("hd4g0");

var $eO7Kz = parcelRequire("eO7Kz");

var $4217142ad68b30ee$var$_useNavigatorPlatform3 = $4217142ad68b30ee$var$_interopRequireDefault((parcelRequire("70juI")));
function $4217142ad68b30ee$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $4217142ad68b30ee$var$_slicedToArray(arr, i) {
    return $4217142ad68b30ee$var$_arrayWithHoles(arr) || $4217142ad68b30ee$var$_iterableToArrayLimit(arr, i) || $4217142ad68b30ee$var$_unsupportedIterableToArray(arr, i) || $4217142ad68b30ee$var$_nonIterableRest();
}
function $4217142ad68b30ee$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $4217142ad68b30ee$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $4217142ad68b30ee$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $4217142ad68b30ee$var$_arrayLikeToArray(o, minLen);
}
function $4217142ad68b30ee$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $4217142ad68b30ee$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $4217142ad68b30ee$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
var $4217142ad68b30ee$var$useLocalizer = $hd4g0.hooks.useLocalizer;
function $4217142ad68b30ee$var$useLocalizeAccessKey(type) {
    var _useNavigatorPlatform = (0, $4217142ad68b30ee$var$_useNavigatorPlatform3.default)(), _useNavigatorPlatform2 = $4217142ad68b30ee$var$_slicedToArray(_useNavigatorPlatform, 1), apple = _useNavigatorPlatform2[0].apple;
    var localize = $4217142ad68b30ee$var$useLocalizer();
    return (0, $eO7Kz.useCallback)(function(accessKey) {
        if (!accessKey || typeof accessKey !== "string" || !accessKey.length) throw new Error('useLocalizeAccessKey: "accessKey" must be a non-empty string');
        if (type === "accessible name") // This will localize as "Alt + Shift + A".
        return localize(apple ? "ACCESS_KEY_FOR_MAC_ALT" : "ACCESS_KEY_ALT", accessKey[0]);
         // "aria-keyshortcuts" do not need to be localized, it should be "alt+shift+a".
        // On Mac, "AltGraph" is preferred over "Option" key.
        // https://w3c.github.io/aria/#aria-keyshortcuts
        return (apple ? "Control+AltGraph+" : "Alt+Shift+") + accessKey[0];
    }, [
        apple,
        localize,
        type
    ]);
}

});

parcelRequire.register("gaC1T", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $bc5b1464b2511c02$var$useScrollToEnd;

var $eO7Kz = parcelRequire("eO7Kz");

var $bc5b1464b2511c02$var$_useWebChatUIContext2 = $bc5b1464b2511c02$var$_interopRequireDefault((parcelRequire("tHuBR")));
function $bc5b1464b2511c02$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $bc5b1464b2511c02$var$useScrollToEnd() {
    var _useWebChatUIContext = (0, $bc5b1464b2511c02$var$_useWebChatUIContext2.default)(), scrollToEndCallbacksRef = _useWebChatUIContext.scrollToEndCallbacksRef;
    return (0, $eO7Kz.useCallback)(function() {
        return scrollToEndCallbacksRef.current.forEach(function(callback) {
            return callback({
                behavior: "smooth"
            });
        });
    }, [
        scrollToEndCallbacksRef
    ]);
}

});

parcelRequire.register("aZ6Uh", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $7ff4f56d6ca5b206$var$useSuggestedActionsAccessKey;

var $7ff4f56d6ca5b206$var$_useWebChatUIContext2 = $7ff4f56d6ca5b206$var$_interopRequireDefault((parcelRequire("tHuBR")));
function $7ff4f56d6ca5b206$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $7ff4f56d6ca5b206$var$useSuggestedActionsAccessKey() {
    var _useWebChatUIContext = (0, $7ff4f56d6ca5b206$var$_useWebChatUIContext2.default)(), suggestedActionsAccessKey = _useWebChatUIContext.suggestedActionsAccessKey;
    return [
        suggestedActionsAccessKey
    ];
}

});


parcelRequire.register("dw1oV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $9d6f59c01ee0e4a4$var$useFocusWithin;

var $eO7Kz = parcelRequire("eO7Kz");
function $9d6f59c01ee0e4a4$var$_slicedToArray(arr, i) {
    return $9d6f59c01ee0e4a4$var$_arrayWithHoles(arr) || $9d6f59c01ee0e4a4$var$_iterableToArrayLimit(arr, i) || $9d6f59c01ee0e4a4$var$_unsupportedIterableToArray(arr, i) || $9d6f59c01ee0e4a4$var$_nonIterableRest();
}
function $9d6f59c01ee0e4a4$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $9d6f59c01ee0e4a4$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $9d6f59c01ee0e4a4$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $9d6f59c01ee0e4a4$var$_arrayLikeToArray(o, minLen);
}
function $9d6f59c01ee0e4a4$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $9d6f59c01ee0e4a4$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $9d6f59c01ee0e4a4$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $9d6f59c01ee0e4a4$var$useFocusWithin(targetRef) {
    var _useState = (0, $eO7Kz.useState)(false), _useState2 = $9d6f59c01ee0e4a4$var$_slicedToArray(_useState, 2), focusWithin = _useState2[0], setFocusWithin = _useState2[1];
    var handleBlur = (0, $eO7Kz.useCallback)(function() {
        return setFocusWithin(false);
    }, [
        setFocusWithin
    ]);
    var handleFocus = (0, $eO7Kz.useCallback)(function(_ref) {
        var _targetRef$current;
        var target = _ref.target;
        var targetElement = target;
        setFocusWithin(targetRef.current === targetElement || !!((_targetRef$current = targetRef.current) !== null && _targetRef$current !== void 0 && _targetRef$current.contains(targetElement)));
    }, [
        setFocusWithin,
        targetRef
    ]);
    (0, $eO7Kz.useEffect)(function() {
        document.addEventListener("blur", handleBlur);
        document.addEventListener("focus", handleFocus);
        return function() {
            document.removeEventListener("blur", handleBlur);
            document.removeEventListener("focus", handleFocus);
        };
    }, [
        handleBlur,
        handleFocus
    ]);
    return Object.freeze([
        focusWithin
    ]);
}

});


parcelRequire.register("6sNkp", function(module, exports) {
"use strict";
function $4b4b9f29589e4d23$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $4b4b9f29589e4d23$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $4b4b9f29589e4d23$var$_typeof(obj);
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = module.exports.connectSendTextBox = void 0;
module.exports.useTextBoxSubmit = $4b4b9f29589e4d23$var$useTextBoxSubmit;
module.exports.useTextBoxValue = $4b4b9f29589e4d23$var$useTextBoxValue;

var $hd4g0 = parcelRequire("hd4g0");

var $4b4b9f29589e4d23$var$_classnames = $4b4b9f29589e4d23$var$_interopRequireDefault((parcelRequire("5A4MD")));

var $4b4b9f29589e4d23$var$_propTypes = $4b4b9f29589e4d23$var$_interopRequireDefault((parcelRequire("f7UXb")));

var $4b4b9f29589e4d23$var$_react = $4b4b9f29589e4d23$var$_interopRequireWildcard((parcelRequire("eO7Kz")));

var $gLt36 = parcelRequire("gLt36");

var $4b4b9f29589e4d23$var$_AccessibleInputText = $4b4b9f29589e4d23$var$_interopRequireDefault((parcelRequire("hxXnE")));

var $4b4b9f29589e4d23$var$_AutoResizeTextArea = $4b4b9f29589e4d23$var$_interopRequireDefault((parcelRequire("xoHdt")));

var $4b4b9f29589e4d23$var$_connectToWebChat = $4b4b9f29589e4d23$var$_interopRequireDefault((parcelRequire("86vmQ")));

var $4b4b9f29589e4d23$var$_navigableEvent = $4b4b9f29589e4d23$var$_interopRequireDefault((parcelRequire("lnMj1")));

var $4b4b9f29589e4d23$var$_useRegisterFocusSendBox = $4b4b9f29589e4d23$var$_interopRequireDefault((parcelRequire("i5uBe")));

var $4b4b9f29589e4d23$var$_useReplaceEmoticon = $4b4b9f29589e4d23$var$_interopRequireDefault((parcelRequire("liA8I")));

var $4b4b9f29589e4d23$var$_useScrollDown = $4b4b9f29589e4d23$var$_interopRequireDefault((parcelRequire("lgVAh")));

var $4b4b9f29589e4d23$var$_useScrollUp = $4b4b9f29589e4d23$var$_interopRequireDefault((parcelRequire("k6SGM")));

var $4b4b9f29589e4d23$var$_useStyleSet3 = $4b4b9f29589e4d23$var$_interopRequireDefault((parcelRequire("gC6jZ")));

var $4b4b9f29589e4d23$var$_useStyleToEmotionObject = $4b4b9f29589e4d23$var$_interopRequireDefault((parcelRequire("6l4uV")));

var $4b4b9f29589e4d23$var$_useSubmit = $4b4b9f29589e4d23$var$_interopRequireDefault((parcelRequire("jJf8H")));
function $4b4b9f29589e4d23$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($4b4b9f29589e4d23$var$_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $4b4b9f29589e4d23$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || $4b4b9f29589e4d23$var$_typeof(obj) !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $4b4b9f29589e4d23$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $4b4b9f29589e4d23$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $4b4b9f29589e4d23$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $4b4b9f29589e4d23$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $4b4b9f29589e4d23$var$ownKeys(Object(source), !0).forEach(function(key) {
            $4b4b9f29589e4d23$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $4b4b9f29589e4d23$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $4b4b9f29589e4d23$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $4b4b9f29589e4d23$var$_slicedToArray(arr, i) {
    return $4b4b9f29589e4d23$var$_arrayWithHoles(arr) || $4b4b9f29589e4d23$var$_iterableToArrayLimit(arr, i) || $4b4b9f29589e4d23$var$_unsupportedIterableToArray(arr, i) || $4b4b9f29589e4d23$var$_nonIterableRest();
}
function $4b4b9f29589e4d23$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $4b4b9f29589e4d23$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $4b4b9f29589e4d23$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $4b4b9f29589e4d23$var$_arrayLikeToArray(o, minLen);
}
function $4b4b9f29589e4d23$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $4b4b9f29589e4d23$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $4b4b9f29589e4d23$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
var $4b4b9f29589e4d23$var$useDisabled = $hd4g0.hooks.useDisabled, $4b4b9f29589e4d23$var$useLocalizer = $hd4g0.hooks.useLocalizer, $4b4b9f29589e4d23$var$usePonyfill = $hd4g0.hooks.usePonyfill, $4b4b9f29589e4d23$var$useSendBoxValue = $hd4g0.hooks.useSendBoxValue, $4b4b9f29589e4d23$var$useStopDictate = $hd4g0.hooks.useStopDictate, $4b4b9f29589e4d23$var$useStyleOptions = $hd4g0.hooks.useStyleOptions;
var $4b4b9f29589e4d23$var$ROOT_STYLE = {
    "&.webchat__send-box-text-box": {
        display: "flex",
        "& .webchat__send-box-text-box__input, & .webchat__send-box-text-box__text-area": {
            flex: 1
        }
    }
};
var $4b4b9f29589e4d23$var$connectSendTextBox = function connectSendTextBox() {
    for(var _len = arguments.length, selectors = new Array(_len), _key = 0; _key < _len; _key++)selectors[_key] = arguments[_key];
    return $4b4b9f29589e4d23$var$_connectToWebChat.default.apply(void 0, [
        function(_ref) {
            var disabled = _ref.disabled, focusSendBox = _ref.focusSendBox, language = _ref.language, scrollToEnd = _ref.scrollToEnd, sendBoxValue = _ref.sendBoxValue, setSendBox = _ref.setSendBox, stopDictate = _ref.stopDictate, submitSendBox = _ref.submitSendBox;
            return {
                disabled: disabled,
                language: language,
                onChange: function onChange(_ref2) {
                    var value = _ref2.target.value;
                    setSendBox(value);
                    stopDictate();
                },
                onKeyPress: function onKeyPress(event) {
                    var key = event.key, shiftKey = event.shiftKey;
                    if (key === "Enter" && !shiftKey) {
                        event.preventDefault();
                        if (sendBoxValue) {
                            scrollToEnd();
                            submitSendBox();
                            focusSendBox();
                        }
                    }
                },
                onSubmit: function onSubmit(event) {
                    event.preventDefault(); // Consider clearing the send box only after we received POST_ACTIVITY_PENDING
                    // E.g. if the connection is bad, sending the message essentially do nothing but just clearing the send box
                    if (sendBoxValue) {
                        scrollToEnd();
                        submitSendBox();
                    }
                },
                value: sendBoxValue
            };
        }
    ].concat(selectors));
};
/**
 * Submits the text box and optionally set the focus after send.
 */ module.exports.connectSendTextBox = $4b4b9f29589e4d23$var$connectSendTextBox;
function $4b4b9f29589e4d23$var$useTextBoxSubmit() {
    var submit = (0, $4b4b9f29589e4d23$var$_useSubmit.default)();
    return (0, $4b4b9f29589e4d23$var$_react.useCallback)(function(setFocus) {
        return submit({
            setFocus: setFocus || undefined
        });
    }, [
        submit
    ]);
}
function $4b4b9f29589e4d23$var$useTextBoxValue() {
    var _useSendBoxValue = $4b4b9f29589e4d23$var$useSendBoxValue(), _useSendBoxValue2 = $4b4b9f29589e4d23$var$_slicedToArray(_useSendBoxValue, 2), value = _useSendBoxValue2[0], setValue = _useSendBoxValue2[1];
    var replaceEmoticon = (0, $4b4b9f29589e4d23$var$_useReplaceEmoticon.default)();
    var stopDictate = $4b4b9f29589e4d23$var$useStopDictate();
    var setter = (0, $4b4b9f29589e4d23$var$_react.useCallback)(function(nextValue) {
        var _ref3 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
            selectionEnd: undefined,
            selectionStart: undefined
        }, selectionEnd = _ref3.selectionEnd, selectionStart = _ref3.selectionStart;
        if (typeof nextValue !== "string") throw new Error("botframework-webchat: First argument passed to useTextBoxValue() must be a string.");
         // Currently, we cannot detect whether the change is due to clipboard paste or pressing a key on the keyboard.
        // We should not change to emoji when the user is pasting text.
        // We would assume, for a single character addition, the user must be pressing a key.
        if (nextValue.length === value.length + 1) {
            var _replaceEmoticon = replaceEmoticon({
                selectionEnd: selectionEnd,
                selectionStart: selectionStart,
                value: nextValue
            }), nextSelectionEnd = _replaceEmoticon.selectionEnd, nextSelectionStart = _replaceEmoticon.selectionStart, nextValueWithEmoji = _replaceEmoticon.value;
            selectionEnd = nextSelectionEnd;
            selectionStart = nextSelectionStart;
            nextValue = nextValueWithEmoji;
        }
        setValue(nextValue);
        stopDictate();
        return {
            selectionEnd: selectionEnd,
            selectionStart: selectionStart,
            value: nextValue
        };
    }, [
        replaceEmoticon,
        setValue,
        stopDictate,
        value
    ]);
    return [
        value,
        setter
    ];
}
var $4b4b9f29589e4d23$var$PREVENT_DEFAULT_HANDLER = function PREVENT_DEFAULT_HANDLER(event) {
    return event.preventDefault();
};
var $4b4b9f29589e4d23$var$TextBox = function TextBox(_ref4) {
    var className = _ref4.className;
    var _useSendBoxValue3 = $4b4b9f29589e4d23$var$useSendBoxValue(), _useSendBoxValue4 = $4b4b9f29589e4d23$var$_slicedToArray(_useSendBoxValue3, 2), setSendBox = _useSendBoxValue4[1];
    var _useStyleSet = (0, $4b4b9f29589e4d23$var$_useStyleSet3.default)(), _useStyleSet2 = $4b4b9f29589e4d23$var$_slicedToArray(_useStyleSet, 1), sendBoxTextBoxStyleSet = _useStyleSet2[0].sendBoxTextBox;
    var _useStyleOptions = $4b4b9f29589e4d23$var$useStyleOptions(), _useStyleOptions2 = $4b4b9f29589e4d23$var$_slicedToArray(_useStyleOptions, 1), sendBoxTextWrap = _useStyleOptions2[0].sendBoxTextWrap;
    var _usePonyfill = $4b4b9f29589e4d23$var$usePonyfill(), _usePonyfill2 = $4b4b9f29589e4d23$var$_slicedToArray(_usePonyfill, 1), setTimeout = _usePonyfill2[0].setTimeout;
    var _useDisabled = $4b4b9f29589e4d23$var$useDisabled(), _useDisabled2 = $4b4b9f29589e4d23$var$_slicedToArray(_useDisabled, 1), disabled = _useDisabled2[0];
    var _useTextBoxValue = $4b4b9f29589e4d23$var$useTextBoxValue(), _useTextBoxValue2 = $4b4b9f29589e4d23$var$_slicedToArray(_useTextBoxValue, 2), textBoxValue = _useTextBoxValue2[0], setTextBoxValue = _useTextBoxValue2[1];
    var inputElementRef = (0, $4b4b9f29589e4d23$var$_react.useRef)();
    var localize = $4b4b9f29589e4d23$var$useLocalizer();
    var placeCheckpointOnChangeRef = (0, $4b4b9f29589e4d23$var$_react.useRef)(false);
    var prevInputStateRef = (0, $4b4b9f29589e4d23$var$_react.useRef)();
    var rootClassName = (0, $4b4b9f29589e4d23$var$_useStyleToEmotionObject.default)()($4b4b9f29589e4d23$var$ROOT_STYLE) + "";
    var scrollDown = (0, $4b4b9f29589e4d23$var$_useScrollDown.default)();
    var scrollUp = (0, $4b4b9f29589e4d23$var$_useScrollUp.default)();
    var submitTextBox = $4b4b9f29589e4d23$var$useTextBoxSubmit();
    var undoStackRef = (0, $4b4b9f29589e4d23$var$_react.useRef)([]);
    var sendBoxString = localize("TEXT_INPUT_ALT");
    var typeYourMessageString = localize("TEXT_INPUT_PLACEHOLDER");
    var rememberInputState = (0, $4b4b9f29589e4d23$var$_react.useCallback)(function() {
        var _inputElementRef$curr = inputElementRef.current, selectionEnd = _inputElementRef$curr.selectionEnd, selectionStart = _inputElementRef$curr.selectionStart, value = _inputElementRef$curr.value;
        prevInputStateRef.current = {
            selectionEnd: selectionEnd,
            selectionStart: selectionStart,
            value: value
        };
    }, [
        inputElementRef,
        prevInputStateRef
    ]); // This is for TypeFocusSink. When the focus in on the script, then starting press "a", without this line, it would cause errors.
    // We call rememberInputState() when "onFocus" event is fired, but since this is from TypeFocusSink, we are not able to receive "onFocus" event before it happen.
    (0, $4b4b9f29589e4d23$var$_react.useEffect)(rememberInputState, [
        rememberInputState
    ]); // This is for moving the selection while setting the send box value.
    // If we only use setSendBox, we will need to wait for the next render cycle to get the value in, before we can set selectionEnd/Start.
    var setSelectionRangeAndValue = (0, $4b4b9f29589e4d23$var$_react.useCallback)(function(_ref5) {
        var selectionEnd = _ref5.selectionEnd, selectionStart = _ref5.selectionStart, value = _ref5.value;
        if (inputElementRef.current) {
            // We need to set the value, before selectionStart/selectionEnd.
            inputElementRef.current.value = value;
            inputElementRef.current.selectionStart = selectionStart;
            inputElementRef.current.selectionEnd = selectionEnd;
        }
        setSendBox(value);
    }, [
        inputElementRef,
        setSendBox
    ]);
    var handleChange = (0, $4b4b9f29589e4d23$var$_react.useCallback)(function(event) {
        var _event$target = event.target, selectionEnd = _event$target.selectionEnd, selectionStart = _event$target.selectionStart, value = _event$target.value;
        if (placeCheckpointOnChangeRef.current) {
            undoStackRef.current.push($4b4b9f29589e4d23$var$_objectSpread({}, prevInputStateRef.current));
            placeCheckpointOnChangeRef.current = false;
        }
        var nextInputState = setTextBoxValue(value, {
            selectionEnd: selectionEnd,
            selectionStart: selectionStart
        }); // If an emoticon is converted to emoji, place another checkpoint.
        if (nextInputState.value !== value) {
            undoStackRef.current.push({
                selectionEnd: selectionEnd,
                selectionStart: selectionStart,
                value: value
            });
            placeCheckpointOnChangeRef.current = true;
            setSelectionRangeAndValue(nextInputState);
        }
    }, [
        placeCheckpointOnChangeRef,
        prevInputStateRef,
        setSelectionRangeAndValue,
        setTextBoxValue,
        undoStackRef
    ]);
    var handleFocus = (0, $4b4b9f29589e4d23$var$_react.useCallback)(function() {
        rememberInputState();
        placeCheckpointOnChangeRef.current = true;
    }, [
        placeCheckpointOnChangeRef,
        rememberInputState
    ]);
    var handleKeyDown = (0, $4b4b9f29589e4d23$var$_react.useCallback)(function(event) {
        var ctrlKey = event.ctrlKey, key = event.key, metaKey = event.metaKey;
        if ((ctrlKey || metaKey) && (key === "Z" || key === "z")) {
            event.preventDefault();
            var poppedInputState = undoStackRef.current.pop();
            if (poppedInputState) prevInputStateRef.current = $4b4b9f29589e4d23$var$_objectSpread({}, poppedInputState);
            else prevInputStateRef.current = {
                selectionEnd: 0,
                selectionStart: 0,
                value: ""
            };
            setSelectionRangeAndValue(prevInputStateRef.current);
        }
    }, [
        prevInputStateRef,
        setSelectionRangeAndValue,
        undoStackRef
    ]);
    var handleKeyPress = (0, $4b4b9f29589e4d23$var$_react.useCallback)(function(event) {
        var key = event.key, shiftKey = event.shiftKey;
        if (key === "Enter" && !shiftKey) {
            event.preventDefault(); // If text box is submitted, focus on the send box
            submitTextBox("sendBox"); // After submit, we will clear the undo stack.
            undoStackRef.current = [];
        }
    }, [
        submitTextBox,
        undoStackRef
    ]);
    var handleSelect = (0, $4b4b9f29589e4d23$var$_react.useCallback)(function(_ref6) {
        var _ref6$currentTarget = _ref6.currentTarget, selectionEnd = _ref6$currentTarget.selectionEnd, selectionStart = _ref6$currentTarget.selectionStart, value = _ref6$currentTarget.value;
        if (value === prevInputStateRef.current.value) // When caret move, we should push to undo stack on change.
        placeCheckpointOnChangeRef.current = true;
        prevInputStateRef.current = {
            selectionEnd: selectionEnd,
            selectionStart: selectionStart,
            value: value
        };
    }, [
        placeCheckpointOnChangeRef,
        prevInputStateRef
    ]);
    var handleSubmit = (0, $4b4b9f29589e4d23$var$_react.useCallback)(function(event) {
        event.preventDefault(); // Consider clearing the send box only after we received POST_ACTIVITY_PENDING
        // E.g. if the connection is bad, sending the message essentially do nothing but just clearing the send box
        submitTextBox(); // After submit, we will clear the undo stack.
        undoStackRef.current = [];
    }, [
        submitTextBox,
        undoStackRef
    ]);
    var handleKeyDownCapture = (0, $4b4b9f29589e4d23$var$_react.useCallback)(function(event) {
        var ctrlKey = event.ctrlKey, metaKey = event.metaKey, shiftKey = event.shiftKey;
        if (ctrlKey || metaKey || shiftKey) return;
         // Navigable event means the end-user is focusing on an inputtable element, but it is okay to capture the arrow keys.
        if ((0, $4b4b9f29589e4d23$var$_navigableEvent.default)(event)) {
            var handled = true;
            switch(event.key){
                case "End":
                    scrollDown({
                        displacement: Infinity
                    });
                    break;
                case "Home":
                    scrollUp({
                        displacement: Infinity
                    });
                    break;
                case "PageDown":
                    scrollDown();
                    break;
                case "PageUp":
                    scrollUp();
                    break;
                default:
                    handled = false;
                    break;
            }
            if (handled) {
                event.preventDefault();
                event.stopPropagation();
            }
        }
    }, [
        scrollDown,
        scrollUp
    ]);
    var focusCallback = (0, $4b4b9f29589e4d23$var$_react.useCallback)(function() {
        var _ref7 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, noKeyboard = _ref7.noKeyboard;
        var current = inputElementRef.current;
        if (current) {
            // The "disable soft keyboard on mobile devices" logic will not work on IE11. It will cause the <input> to become read-only until next focus.
            // Thus, no mobile devices carry IE11 so we don't need to explicitly disable soft keyboard on IE11.
            // See #3757 for repro and details.
            if (noKeyboard && !$gLt36.ie11) {
                // To not activate the virtual keyboard while changing focus to an input, we will temporarily set it as read-only and flip it back.
                // https://stackoverflow.com/questions/7610758/prevent-iphone-default-keyboard-when-focusing-an-input/7610923
                var readOnly = current.getAttribute("readonly");
                current.setAttribute("readonly", "readonly"); // TODO: [P2] We should update this logic to handle quickly-successive `focusCallback`.
                //       If a succeeding `focusCallback` is being called, the `setTimeout` should run immediately.
                //       Or the second `focusCallback` should not set `readonly` to `true`.
                setTimeout(function() {
                    var current = inputElementRef.current;
                    if (current) {
                        current.focus();
                        readOnly ? current.setAttribute("readonly", readOnly) : current.removeAttribute("readonly");
                    }
                }, 0);
            } else current.focus();
        }
    }, [
        inputElementRef,
        setTimeout
    ]);
    (0, $4b4b9f29589e4d23$var$_useRegisterFocusSendBox.default)(focusCallback);
    return /*#__PURE__*/ $4b4b9f29589e4d23$var$_react.default.createElement("form", {
        "aria-disabled": disabled,
        className: (0, $4b4b9f29589e4d23$var$_classnames.default)("webchat__send-box-text-box", rootClassName, sendBoxTextBoxStyleSet + "", (className || "") + ""),
        onSubmit: disabled ? $4b4b9f29589e4d23$var$PREVENT_DEFAULT_HANDLER : handleSubmit
    }, !sendBoxTextWrap ? /*#__PURE__*/ $4b4b9f29589e4d23$var$_react.default.createElement($4b4b9f29589e4d23$var$_AccessibleInputText.default, {
        "aria-label": sendBoxString,
        className: "webchat__send-box-text-box__input",
        "data-id": "webchat-sendbox-input",
        disabled: disabled,
        enterKeyHint: "send",
        inputMode: "text",
        onChange: disabled ? undefined : handleChange,
        onFocus: disabled ? undefined : handleFocus,
        onKeyDown: disabled ? undefined : handleKeyDown,
        onKeyDownCapture: disabled ? undefined : handleKeyDownCapture,
        onKeyPress: disabled ? undefined : handleKeyPress,
        onSelect: disabled ? undefined : handleSelect,
        placeholder: typeYourMessageString,
        readOnly: disabled,
        ref: inputElementRef,
        type: "text",
        value: textBoxValue
    }) : /*#__PURE__*/ $4b4b9f29589e4d23$var$_react.default.createElement($4b4b9f29589e4d23$var$_AutoResizeTextArea.default, {
        "aria-label": sendBoxString,
        className: "webchat__send-box-text-box__text-area",
        "data-id": "webchat-sendbox-input",
        disabled: disabled,
        enterKeyHint: "send",
        inputMode: "text",
        onChange: disabled ? undefined : handleChange,
        onFocus: disabled ? undefined : handleFocus,
        onKeyDown: disabled ? undefined : handleKeyDown,
        onKeyDownCapture: disabled ? undefined : handleKeyDownCapture,
        onKeyPress: disabled ? undefined : handleKeyPress,
        onSelect: disabled ? undefined : handleSelect,
        placeholder: typeYourMessageString,
        readOnly: disabled,
        ref: inputElementRef,
        rows: 1,
        textAreaClassName: "webchat__send-box-text-box__html-text-area",
        value: textBoxValue
    }), disabled && /*#__PURE__*/ $4b4b9f29589e4d23$var$_react.default.createElement("div", {
        className: "webchat__send-box-text-box__glass"
    }));
};
$4b4b9f29589e4d23$var$TextBox.defaultProps = {
    className: ""
};
$4b4b9f29589e4d23$var$TextBox.propTypes = {
    className: $4b4b9f29589e4d23$var$_propTypes.default.string
};
var $4b4b9f29589e4d23$var$_default = $4b4b9f29589e4d23$var$TextBox;
module.exports.default = $4b4b9f29589e4d23$var$_default;

});
parcelRequire.register("gLt36", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.safari = module.exports.ie11 = module.exports.firefox = module.exports.edgeUWP = module.exports.edgeAnaheim = module.exports.chromium = module.exports.chrome = module.exports.android = void 0;
var $c34791ac41652ab4$var$_navigator = navigator, $c34791ac41652ab4$var$userAgent = $c34791ac41652ab4$var$_navigator.userAgent; // not DRY so that list can be alphabetical
var $c34791ac41652ab4$var$android = /Linux; Android/.test($c34791ac41652ab4$var$userAgent);
module.exports.android = $c34791ac41652ab4$var$android;
var $c34791ac41652ab4$var$chromium = !/Edge\//.test($c34791ac41652ab4$var$userAgent) && /Chrome\//.test($c34791ac41652ab4$var$userAgent);
module.exports.chromium = $c34791ac41652ab4$var$chromium;
var $c34791ac41652ab4$var$edgeAnaheim = /Edg\//.test($c34791ac41652ab4$var$userAgent);
module.exports.edgeAnaheim = $c34791ac41652ab4$var$edgeAnaheim;
var $c34791ac41652ab4$var$edgeUWP = /Edge\//.test($c34791ac41652ab4$var$userAgent);
module.exports.edgeUWP = $c34791ac41652ab4$var$edgeUWP;
var $c34791ac41652ab4$var$firefox = /Firefox\//.test($c34791ac41652ab4$var$userAgent);
module.exports.firefox = $c34791ac41652ab4$var$firefox;
var $c34791ac41652ab4$var$ie11 = /Trident\/7(?:[\0-\t\x0B\f\x0E-\u2027\u202A-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])0/.test($c34791ac41652ab4$var$userAgent);
module.exports.ie11 = $c34791ac41652ab4$var$ie11;
var $c34791ac41652ab4$var$chrome = $c34791ac41652ab4$var$chromium && !$c34791ac41652ab4$var$edgeAnaheim;
module.exports.chrome = $c34791ac41652ab4$var$chrome;
var $c34791ac41652ab4$var$safari = !($c34791ac41652ab4$var$chrome || $c34791ac41652ab4$var$edgeUWP || $c34791ac41652ab4$var$ie11 || $c34791ac41652ab4$var$firefox);
module.exports.safari = $c34791ac41652ab4$var$safari;

});

parcelRequire.register("hxXnE", function(module, exports) {
"use strict";
function $cc63947a732e36a1$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $cc63947a732e36a1$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $cc63947a732e36a1$var$_typeof(obj);
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $cc63947a732e36a1$var$_propTypes = $cc63947a732e36a1$var$_interopRequireDefault((parcelRequire("f7UXb")));

var $cc63947a732e36a1$var$_react = $cc63947a732e36a1$var$_interopRequireWildcard((parcelRequire("eO7Kz")));

var $cc63947a732e36a1$var$_useEnterKeyHint = $cc63947a732e36a1$var$_interopRequireDefault((parcelRequire("jPW1C")));
var $cc63947a732e36a1$var$_excluded = [
    "aria-errormessage",
    "className",
    "disabled",
    "enterKeyHint",
    "onChange",
    "onFocus",
    "onKeyDown",
    "onKeyDownCapture",
    "onKeyPress",
    "onSelect",
    "placeholder",
    "readOnly",
    "tabIndex",
    "value"
];
function $cc63947a732e36a1$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($cc63947a732e36a1$var$_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $cc63947a732e36a1$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || $cc63947a732e36a1$var$_typeof(obj) !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $cc63947a732e36a1$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $cc63947a732e36a1$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $cc63947a732e36a1$var$_extends() {
    $cc63947a732e36a1$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $cc63947a732e36a1$var$_extends.apply(this, arguments);
}
function $cc63947a732e36a1$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $cc63947a732e36a1$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $cc63947a732e36a1$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $cc63947a732e36a1$var$AccessibleInputText = /*#__PURE__*/ (0, $cc63947a732e36a1$var$_react.forwardRef)(function(_ref, forwardedRef) {
    var ariaErrorMessage = _ref["aria-errormessage"], className = _ref.className, disabled = _ref.disabled, enterKeyHint = _ref.enterKeyHint, onChange = _ref.onChange, onFocus = _ref.onFocus, onKeyDown = _ref.onKeyDown, onKeyDownCapture = _ref.onKeyDownCapture, onKeyPress = _ref.onKeyPress, onSelect = _ref.onSelect, placeholder = _ref.placeholder, readOnly = _ref.readOnly, tabIndex = _ref.tabIndex, value = _ref.value, props = $cc63947a732e36a1$var$_objectWithoutProperties(_ref, $cc63947a732e36a1$var$_excluded);
    var targetRef = (0, $cc63947a732e36a1$var$_react.useRef)();
    var ref = forwardedRef || targetRef;
    (0, $cc63947a732e36a1$var$_useEnterKeyHint.default)(ref, enterKeyHint);
    return /*#__PURE__*/ $cc63947a732e36a1$var$_react.default.createElement("input", $cc63947a732e36a1$var$_extends({
        "aria-disabled": disabled || undefined,
        "aria-errormessage": ariaErrorMessage,
        className: className,
        onChange: disabled ? undefined : onChange,
        onFocus: disabled ? undefined : onFocus,
        onKeyDown: disabled ? undefined : onKeyDown,
        onKeyDownCapture: disabled ? undefined : onKeyDownCapture,
        onKeyPress: disabled ? undefined : onKeyPress,
        onSelect: disabled ? undefined : onSelect,
        placeholder: placeholder,
        readOnly: readOnly || disabled,
        ref: ref,
        tabIndex: disabled ? -1 : tabIndex,
        value: value
    }, props, {
        type: "text"
    }));
});
$cc63947a732e36a1$var$AccessibleInputText.defaultProps = {
    "aria-errormessage": undefined,
    className: undefined,
    disabled: undefined,
    enterKeyHint: undefined,
    inputMode: undefined,
    onChange: undefined,
    onFocus: undefined,
    onKeyDown: undefined,
    onKeyDownCapture: undefined,
    onKeyPress: undefined,
    onSelect: undefined,
    placeholder: undefined,
    readOnly: undefined,
    tabIndex: undefined,
    value: undefined
};
$cc63947a732e36a1$var$AccessibleInputText.displayName = "AccessibleInputText";
$cc63947a732e36a1$var$AccessibleInputText.propTypes = {
    "aria-errormessage": $cc63947a732e36a1$var$_propTypes.default.string,
    className: $cc63947a732e36a1$var$_propTypes.default.string,
    disabled: $cc63947a732e36a1$var$_propTypes.default.bool,
    enterKeyHint: $cc63947a732e36a1$var$_propTypes.default.string,
    inputMode: $cc63947a732e36a1$var$_propTypes.default.oneOf([
        "text",
        "none",
        "tel",
        "url",
        "email",
        "numeric",
        "decimal",
        "search"
    ]),
    onChange: $cc63947a732e36a1$var$_propTypes.default.func,
    onFocus: $cc63947a732e36a1$var$_propTypes.default.func,
    onKeyDown: $cc63947a732e36a1$var$_propTypes.default.func,
    onKeyDownCapture: $cc63947a732e36a1$var$_propTypes.default.func,
    onKeyPress: $cc63947a732e36a1$var$_propTypes.default.func,
    onSelect: $cc63947a732e36a1$var$_propTypes.default.func,
    placeholder: $cc63947a732e36a1$var$_propTypes.default.string,
    readOnly: $cc63947a732e36a1$var$_propTypes.default.bool,
    tabIndex: $cc63947a732e36a1$var$_propTypes.default.number,
    // @ts-ignore PropTypes and TypeScript type do not well understood each other.
    type: $cc63947a732e36a1$var$_propTypes.default.oneOf([
        "text"
    ]).isRequired,
    value: $cc63947a732e36a1$var$_propTypes.default.string
};
var $cc63947a732e36a1$var$_default = $cc63947a732e36a1$var$AccessibleInputText;
module.exports.default = $cc63947a732e36a1$var$_default;

});
parcelRequire.register("jPW1C", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $e70fca4e0eaff61a$var$useEnterKeyHint;

var $eO7Kz = parcelRequire("eO7Kz");
function $e70fca4e0eaff61a$var$useEnterKeyHint(elementRef, enterKeyHint) {
    // The version of React we are using does not support the capitalized version of "enterKeyHint" yet.
    // To prevent warnings from React, we need to set it manually using attributes.
    (0, $eO7Kz.useEffect)(function() {
        var current = elementRef.current;
        if (current) current.enterKeyHint = enterKeyHint;
    }, [
        enterKeyHint,
        elementRef
    ]);
}

});


parcelRequire.register("xoHdt", function(module, exports) {
"use strict";
function $06463d4ce4605438$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $06463d4ce4605438$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $06463d4ce4605438$var$_typeof(obj);
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $06463d4ce4605438$var$_classnames = $06463d4ce4605438$var$_interopRequireDefault((parcelRequire("5A4MD")));

var $06463d4ce4605438$var$_propTypes = $06463d4ce4605438$var$_interopRequireDefault((parcelRequire("f7UXb")));

var $06463d4ce4605438$var$_react = $06463d4ce4605438$var$_interopRequireWildcard((parcelRequire("eO7Kz")));

var $06463d4ce4605438$var$_AccessibleTextArea = $06463d4ce4605438$var$_interopRequireDefault((parcelRequire("7RUOI")));

var $06463d4ce4605438$var$_useEnterKeyHint = $06463d4ce4605438$var$_interopRequireDefault((parcelRequire("jPW1C")));

var $06463d4ce4605438$var$_useStyleSet3 = $06463d4ce4605438$var$_interopRequireDefault((parcelRequire("gC6jZ")));
function $06463d4ce4605438$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($06463d4ce4605438$var$_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $06463d4ce4605438$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || $06463d4ce4605438$var$_typeof(obj) !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $06463d4ce4605438$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $06463d4ce4605438$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $06463d4ce4605438$var$_slicedToArray(arr, i) {
    return $06463d4ce4605438$var$_arrayWithHoles(arr) || $06463d4ce4605438$var$_iterableToArrayLimit(arr, i) || $06463d4ce4605438$var$_unsupportedIterableToArray(arr, i) || $06463d4ce4605438$var$_nonIterableRest();
}
function $06463d4ce4605438$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $06463d4ce4605438$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $06463d4ce4605438$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $06463d4ce4605438$var$_arrayLikeToArray(o, minLen);
}
function $06463d4ce4605438$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $06463d4ce4605438$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $06463d4ce4605438$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
var $06463d4ce4605438$var$AutoResizeTextArea = /*#__PURE__*/ (0, $06463d4ce4605438$var$_react.forwardRef)(function(_ref, ref) {
    var ariaErrorMessage = _ref["aria-errormessage"], ariaLabel = _ref["aria-label"], className = _ref.className, dataId = _ref["data-id"], disabled = _ref.disabled, enterKeyHint = _ref.enterKeyHint, inputMode = _ref.inputMode, onChange = _ref.onChange, onFocus = _ref.onFocus, onKeyDown = _ref.onKeyDown, onKeyDownCapture = _ref.onKeyDownCapture, onKeyPress = _ref.onKeyPress, onSelect = _ref.onSelect, placeholder = _ref.placeholder, readOnly = _ref.readOnly, rows = _ref.rows, textAreaClassName = _ref.textAreaClassName, value = _ref.value;
    var _useStyleSet = (0, $06463d4ce4605438$var$_useStyleSet3.default)(), _useStyleSet2 = $06463d4ce4605438$var$_slicedToArray(_useStyleSet, 1), autoResizeTextAreaStyleSet = _useStyleSet2[0].autoResizeTextArea;
    (0, $06463d4ce4605438$var$_useEnterKeyHint.default)(ref, enterKeyHint);
    return /*#__PURE__*/ $06463d4ce4605438$var$_react.default.createElement("div", {
        className: (0, $06463d4ce4605438$var$_classnames.default)("webchat__auto-resize-textarea", autoResizeTextAreaStyleSet + "", className)
    }, /*#__PURE__*/ $06463d4ce4605438$var$_react.default.createElement("div", {
        "aria-hidden": true,
        className: "webchat__auto-resize-textarea__doppelganger"
    }, value, "\xa0"), /*#__PURE__*/ $06463d4ce4605438$var$_react.default.createElement($06463d4ce4605438$var$_AccessibleTextArea.default, {
        "aria-errormessage": ariaErrorMessage,
        "aria-label": ariaLabel,
        className: (0, $06463d4ce4605438$var$_classnames.default)("webchat__auto-resize-textarea__textarea", textAreaClassName),
        "data-id": dataId,
        disabled: disabled,
        inputMode: inputMode,
        onChange: onChange,
        onFocus: onFocus,
        onKeyDown: onKeyDown,
        onKeyDownCapture: onKeyDownCapture,
        onKeyPress: onKeyPress,
        onSelect: onSelect,
        placeholder: placeholder,
        readOnly: readOnly,
        ref: ref,
        rows: rows,
        value: value
    }));
});
$06463d4ce4605438$var$AutoResizeTextArea.defaultProps = {
    "aria-errormessage": undefined,
    "aria-label": undefined,
    "data-id": undefined,
    className: undefined,
    disabled: undefined,
    enterKeyHint: undefined,
    inputMode: undefined,
    onChange: undefined,
    onFocus: undefined,
    onKeyDown: undefined,
    onKeyDownCapture: undefined,
    onKeyPress: undefined,
    onSelect: undefined,
    placeholder: undefined,
    readOnly: undefined,
    rows: undefined,
    textAreaClassName: undefined,
    value: ""
};
$06463d4ce4605438$var$AutoResizeTextArea.propTypes = {
    "aria-errormessage": $06463d4ce4605438$var$_propTypes.default.string,
    "aria-label": $06463d4ce4605438$var$_propTypes.default.string,
    className: $06463d4ce4605438$var$_propTypes.default.string,
    "data-id": $06463d4ce4605438$var$_propTypes.default.string,
    disabled: $06463d4ce4605438$var$_propTypes.default.bool,
    enterKeyHint: $06463d4ce4605438$var$_propTypes.default.string,
    inputMode: $06463d4ce4605438$var$_propTypes.default.oneOf([
        "text",
        "none",
        "tel",
        "url",
        "email",
        "numeric",
        "decimal",
        "search"
    ]),
    onChange: $06463d4ce4605438$var$_propTypes.default.func,
    onFocus: $06463d4ce4605438$var$_propTypes.default.func,
    onKeyDown: $06463d4ce4605438$var$_propTypes.default.func,
    onKeyDownCapture: $06463d4ce4605438$var$_propTypes.default.func,
    onKeyPress: $06463d4ce4605438$var$_propTypes.default.func,
    onSelect: $06463d4ce4605438$var$_propTypes.default.func,
    placeholder: $06463d4ce4605438$var$_propTypes.default.string,
    readOnly: $06463d4ce4605438$var$_propTypes.default.bool,
    rows: $06463d4ce4605438$var$_propTypes.default.number,
    textAreaClassName: $06463d4ce4605438$var$_propTypes.default.string,
    value: $06463d4ce4605438$var$_propTypes.default.string
};
var $06463d4ce4605438$var$_default = $06463d4ce4605438$var$AutoResizeTextArea;
module.exports.default = $06463d4ce4605438$var$_default;

});
parcelRequire.register("7RUOI", function(module, exports) {
"use strict";
function $017a7a099041ff06$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $017a7a099041ff06$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $017a7a099041ff06$var$_typeof(obj);
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $017a7a099041ff06$var$_propTypes = $017a7a099041ff06$var$_interopRequireDefault((parcelRequire("f7UXb")));

var $017a7a099041ff06$var$_react = $017a7a099041ff06$var$_interopRequireWildcard((parcelRequire("eO7Kz")));
var $017a7a099041ff06$var$_excluded = [
    "className",
    "disabled",
    "inputMode",
    "onChange",
    "onFocus",
    "onKeyDown",
    "onKeyDownCapture",
    "onKeyPress",
    "onSelect",
    "placeholder",
    "readOnly",
    "rows",
    "tabIndex"
];
function $017a7a099041ff06$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($017a7a099041ff06$var$_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $017a7a099041ff06$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || $017a7a099041ff06$var$_typeof(obj) !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $017a7a099041ff06$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $017a7a099041ff06$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $017a7a099041ff06$var$_extends() {
    $017a7a099041ff06$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $017a7a099041ff06$var$_extends.apply(this, arguments);
}
function $017a7a099041ff06$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $017a7a099041ff06$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $017a7a099041ff06$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $017a7a099041ff06$var$AccessibleTextArea = /*#__PURE__*/ (0, $017a7a099041ff06$var$_react.forwardRef)(function(_ref, forwardedRef) {
    var className = _ref.className, disabled = _ref.disabled, inputMode = _ref.inputMode, onChange = _ref.onChange, onFocus = _ref.onFocus, onKeyDown = _ref.onKeyDown, onKeyDownCapture = _ref.onKeyDownCapture, onKeyPress = _ref.onKeyPress, onSelect = _ref.onSelect, placeholder = _ref.placeholder, readOnly = _ref.readOnly, rows = _ref.rows, tabIndex = _ref.tabIndex, props = $017a7a099041ff06$var$_objectWithoutProperties(_ref, $017a7a099041ff06$var$_excluded);
    var targetRef = (0, $017a7a099041ff06$var$_react.useRef)();
    var ref = forwardedRef || targetRef;
    return /*#__PURE__*/ $017a7a099041ff06$var$_react.default.createElement("textarea", $017a7a099041ff06$var$_extends({
        "aria-disabled": disabled || undefined,
        className: className,
        inputMode: inputMode,
        onChange: disabled ? undefined : onChange,
        onFocus: disabled ? undefined : onFocus,
        onKeyDown: disabled ? undefined : onKeyDown,
        onKeyDownCapture: disabled ? undefined : onKeyDownCapture,
        onKeyPress: disabled ? undefined : onKeyPress,
        onSelect: disabled ? undefined : onSelect,
        placeholder: placeholder,
        readOnly: readOnly || disabled,
        ref: ref,
        rows: rows,
        tabIndex: disabled ? -1 : tabIndex
    }, props));
});
$017a7a099041ff06$var$AccessibleTextArea.defaultProps = {
    className: undefined,
    disabled: undefined,
    inputMode: undefined,
    onChange: undefined,
    onFocus: undefined,
    onKeyDown: undefined,
    onKeyDownCapture: undefined,
    onKeyPress: undefined,
    onSelect: undefined,
    placeholder: undefined,
    readOnly: undefined,
    rows: undefined,
    tabIndex: undefined,
    value: undefined
};
$017a7a099041ff06$var$AccessibleTextArea.displayName = "AccessibleTextArea";
$017a7a099041ff06$var$AccessibleTextArea.propTypes = {
    className: $017a7a099041ff06$var$_propTypes.default.string,
    disabled: $017a7a099041ff06$var$_propTypes.default.bool,
    inputMode: $017a7a099041ff06$var$_propTypes.default.oneOf([
        "text",
        "none",
        "tel",
        "url",
        "email",
        "numeric",
        "decimal",
        "search"
    ]),
    onChange: $017a7a099041ff06$var$_propTypes.default.func,
    onFocus: $017a7a099041ff06$var$_propTypes.default.func,
    onKeyDown: $017a7a099041ff06$var$_propTypes.default.func,
    onKeyDownCapture: $017a7a099041ff06$var$_propTypes.default.func,
    onKeyPress: $017a7a099041ff06$var$_propTypes.default.func,
    onSelect: $017a7a099041ff06$var$_propTypes.default.func,
    placeholder: $017a7a099041ff06$var$_propTypes.default.string,
    readOnly: $017a7a099041ff06$var$_propTypes.default.bool,
    rows: $017a7a099041ff06$var$_propTypes.default.number,
    tabIndex: $017a7a099041ff06$var$_propTypes.default.number,
    value: $017a7a099041ff06$var$_propTypes.default.string
};
var $017a7a099041ff06$var$_default = $017a7a099041ff06$var$AccessibleTextArea;
module.exports.default = $017a7a099041ff06$var$_default;

});


parcelRequire.register("lnMj1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $f911377542a1b50b$var$navigableEvent;
// Navigable event means the end-user is focusing on an inputtable element, but it is okay to capture the arrow keys.
// For example, if the end-user is on <button>, we can capture the arrow keys.
// We can also capture arrow keys when the user is on a <textarea> without contents.
// eslint-disable-next-line complexity
function $f911377542a1b50b$var$navigableEvent(event) {
    var altKey = event.altKey, target = event.target, tagName = event.target.tagName;
    var autocompleteAttribute = target.getAttribute("autocomplete");
    var autocomplete = autocompleteAttribute && autocompleteAttribute !== "off"; // Generally, we allow up/down arrow keys on all elements captured here, except those handled by the user agent.
    // For example, if it is on <select>, we will ignore up/down arrow keys. Also true for textbox with autocomplete.
    // For some elements, user agent doesn't handle arrow keys when ALT key is held, so we can still handle ALT + UP/DOWN keys.
    // For example, user agent ignores ALT + UP/DOWN on <input type="text"> with content.
    // Counter-example: user agent continues to handle ALT + UP/DOWN on <input type="number">.
    if (tagName === "INPUT") {
        var list = target.list, type = target.type, value = target.value; // These are buttons, up/down arrow keys are not handled by the user agent.
        if (type === "button" || type === "checkbox" || type === "file" || type === "image" || type === "radio" || type === "reset" || type === "submit") return true;
        else if (type === "email" || type === "password" || type === "search" || type === "tel" || type === "text" || type === "url") {
            if (autocomplete || list) // "autocomplete" and "list" are comboboxes. Up/down arrow keys may be handled by the user agent.
            return true;
            else if (altKey || !value) // If the input has content, user agent will handle up/down arrow and it work similar to HOME/END keys.
            // "altKey" can be used; user agent ignores ALT + UP/DOWN.
            return true;
        }
    } else if (tagName === "SELECT") // User agent handles up/down arrow keys for dropdown list.
    return false;
    else if (tagName === "TEXTAREA") {
        if (!autocomplete && (altKey || !target.value)) // User agent handles up/down arrow keys for multiline text box if it has content or is auto-complete.
        return true;
    } else if (target.getAttribute("contenteditable") === "true") {
        if (altKey || !target.innerHTML) // "contenteditable" element works like <textarea> minus "autocomplete".
        return true;
    } else return true;
}

});

parcelRequire.register("i5uBe", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $d2b06e0cf204f343$var$useRegisterFocusSendBox;

var $eO7Kz = parcelRequire("eO7Kz");

var $d2b06e0cf204f343$var$_removeInline = $d2b06e0cf204f343$var$_interopRequireDefault((parcelRequire("6gxgd")));

var $d2b06e0cf204f343$var$_useWebChatUIContext2 = $d2b06e0cf204f343$var$_interopRequireDefault((parcelRequire("tHuBR")));
function $d2b06e0cf204f343$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
// This hook is for registering and unregister a callback, used by <BasicSendBox>.
// When called, the callback should focus on the text box of the send box.
function $d2b06e0cf204f343$var$useRegisterFocusSendBox(callback) {
    var _useWebChatUIContext = (0, $d2b06e0cf204f343$var$_useWebChatUIContext2.default)(), focusSendBoxCallbacksRef = _useWebChatUIContext.focusSendBoxCallbacksRef;
    (0, $eO7Kz.useEffect)(function() {
        if (callback) {
            var focusSendBoxCallbacks = focusSendBoxCallbacksRef.current;
            focusSendBoxCallbacks.push(callback);
            return function() {
                return (0, $d2b06e0cf204f343$var$_removeInline.default)(focusSendBoxCallbacks, callback);
            };
        }
    }, [
        callback,
        focusSendBoxCallbacksRef
    ]);
}

});
parcelRequire.register("6gxgd", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $48fe098a41e8c40e$var$removeInline;
function $48fe098a41e8c40e$var$removeInline(array) {
    for(var _len = arguments.length, items = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)items[_key - 1] = arguments[_key];
    items.forEach(function(item) {
        var index;
        while(~(index = array.indexOf(item)))array.splice(index, 1);
    });
}

});


parcelRequire.register("liA8I", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $f8174ff916453766$var$useReplaceEmoticon;

var $hd4g0 = parcelRequire("hd4g0");

var $eO7Kz = parcelRequire("eO7Kz");
function $f8174ff916453766$var$_slicedToArray(arr, i) {
    return $f8174ff916453766$var$_arrayWithHoles(arr) || $f8174ff916453766$var$_iterableToArrayLimit(arr, i) || $f8174ff916453766$var$_unsupportedIterableToArray(arr, i) || $f8174ff916453766$var$_nonIterableRest();
}
function $f8174ff916453766$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $f8174ff916453766$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $f8174ff916453766$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $f8174ff916453766$var$_arrayLikeToArray(o, minLen);
}
function $f8174ff916453766$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $f8174ff916453766$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $f8174ff916453766$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
var $f8174ff916453766$var$useStyleOptions = $hd4g0.hooks.useStyleOptions;
function $f8174ff916453766$var$useReplaceEmoticon() {
    var _useStyleOptions = $f8174ff916453766$var$useStyleOptions(), _useStyleOptions2 = $f8174ff916453766$var$_slicedToArray(_useStyleOptions, 1), emojiSet = _useStyleOptions2[0].emojiSet;
    return (0, $eO7Kz.useCallback)(// We need to distinguish in this case, string change from "abc:)xyz" to "abc:))xyz".
    // If the caret position is after the first parenthesis, we will change it to "abc😊)xyz".
    // But if the caret position is after the second parenthesis, we will not change it but leave it as "abc:))xyz".
    // This is because the user already decided to undo the emoji and just added a parenthesis after the emoticon. It should not affect the emoticon.
    function(_ref) {
        var selectionEnd = _ref.selectionEnd, selectionStart = _ref.selectionStart, value = _ref.value;
        if (typeof selectionEnd !== "number") console.warn('botframework-webchat: The first argument passed to "useReplaceEmoticon" must contains "selectionEnd" of type number, indicating the caret position.');
        else if (typeof selectionStart !== "number") console.warn('botframework-webchat: The first argument passed to "useReplaceEmoticon" must contains "selectionStart" of type number, indicating the caret position.');
        else if (typeof value !== "string") console.warn('botframework-webchat: The first argument passed to "useReplaceEmoticon" must contains "value" of type string.');
         // We only change when the user is not selecting anything.
        selectionEnd === selectionStart && Object.entries(emojiSet).every(function(_ref2) {
            var _ref3 = $f8174ff916453766$var$_slicedToArray(_ref2, 2), emoticon = _ref3[0], emoji = _ref3[1];
            var length = emoticon.length;
            if (value.slice(selectionStart - length, selectionStart) === emoticon) {
                value = "".concat(value.slice(0, selectionStart - length)).concat(emoji).concat(value.slice(selectionStart));
                selectionEnd = selectionStart += emoji.length - length;
                return false;
            }
            return true;
        });
        return {
            selectionEnd: selectionEnd,
            selectionStart: selectionStart,
            value: value
        };
    }, [
        emojiSet
    ]);
}

});

parcelRequire.register("lgVAh", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $f7c7c2a0aeb1c029$var$useScrollDown;

var $eO7Kz = parcelRequire("eO7Kz");

var $f7c7c2a0aeb1c029$var$_useScrollRelative = $f7c7c2a0aeb1c029$var$_interopRequireDefault((parcelRequire("k45S6")));
function $f7c7c2a0aeb1c029$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $f7c7c2a0aeb1c029$var$useScrollDown() {
    var scrollRelative = (0, $f7c7c2a0aeb1c029$var$_useScrollRelative.default)();
    return (0, $eO7Kz.useCallback)(function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return scrollRelative.apply(void 0, [
            "down"
        ].concat(args));
    }, [
        scrollRelative
    ]);
}

});
parcelRequire.register("k45S6", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $e9b8bc5b5056b477$var$useScrollRelative;

var $eO7Kz = parcelRequire("eO7Kz");

var $e9b8bc5b5056b477$var$_useWebChatUIContext2 = $e9b8bc5b5056b477$var$_interopRequireDefault((parcelRequire("tHuBR")));
function $e9b8bc5b5056b477$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $e9b8bc5b5056b477$var$useScrollRelative() {
    var _useWebChatUIContext = (0, $e9b8bc5b5056b477$var$_useWebChatUIContext2.default)(), scrollRelativeCallbacksRef = _useWebChatUIContext.scrollRelativeCallbacksRef;
    return (0, $eO7Kz.useCallback)(function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return scrollRelativeCallbacksRef.current.forEach(function(callback) {
            return callback.apply(void 0, args);
        });
    }, [
        scrollRelativeCallbacksRef
    ]);
}

});


parcelRequire.register("k6SGM", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $ea3eca45b6f75361$var$useScrollUp;

var $eO7Kz = parcelRequire("eO7Kz");

var $ea3eca45b6f75361$var$_useScrollRelative = $ea3eca45b6f75361$var$_interopRequireDefault((parcelRequire("k45S6")));
function $ea3eca45b6f75361$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $ea3eca45b6f75361$var$useScrollUp() {
    var scrollRelative = (0, $ea3eca45b6f75361$var$_useScrollRelative.default)();
    return (0, $eO7Kz.useCallback)(function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return scrollRelative.apply(void 0, [
            "up"
        ].concat(args));
    }, [
        scrollRelative
    ]);
}

});


parcelRequire.register("b4v9C", function(module, exports) {
"use strict";
function $80f83bf841e4cf98$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $80f83bf841e4cf98$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $80f83bf841e4cf98$var$_typeof(obj);
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = module.exports.connectUploadButton = void 0;

var $hd4g0 = parcelRequire("hd4g0");

var $80f83bf841e4cf98$var$_classnames = $80f83bf841e4cf98$var$_interopRequireDefault((parcelRequire("5A4MD")));

var $80f83bf841e4cf98$var$_propTypes = $80f83bf841e4cf98$var$_interopRequireDefault((parcelRequire("f7UXb")));

var $80f83bf841e4cf98$var$_react = $80f83bf841e4cf98$var$_interopRequireWildcard((parcelRequire("eO7Kz")));

var $80f83bf841e4cf98$var$_AttachmentIcon = $80f83bf841e4cf98$var$_interopRequireDefault((parcelRequire("boTB3")));

var $80f83bf841e4cf98$var$_connectToWebChat = $80f83bf841e4cf98$var$_interopRequireDefault((parcelRequire("86vmQ")));

var $80f83bf841e4cf98$var$_index = $80f83bf841e4cf98$var$_interopRequireDefault((parcelRequire("gvacg")));

var $80f83bf841e4cf98$var$_IconButton = $80f83bf841e4cf98$var$_interopRequireDefault((parcelRequire("eA5Zo")));

var $80f83bf841e4cf98$var$_useSendFiles = $80f83bf841e4cf98$var$_interopRequireDefault((parcelRequire("bo3v7")));

var $80f83bf841e4cf98$var$_useStyleSet3 = $80f83bf841e4cf98$var$_interopRequireDefault((parcelRequire("gC6jZ")));

var $80f83bf841e4cf98$var$_useStyleToEmotionObject = $80f83bf841e4cf98$var$_interopRequireDefault((parcelRequire("6l4uV")));
function $80f83bf841e4cf98$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($80f83bf841e4cf98$var$_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $80f83bf841e4cf98$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || $80f83bf841e4cf98$var$_typeof(obj) !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $80f83bf841e4cf98$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $80f83bf841e4cf98$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $80f83bf841e4cf98$var$_slicedToArray(arr, i) {
    return $80f83bf841e4cf98$var$_arrayWithHoles(arr) || $80f83bf841e4cf98$var$_iterableToArrayLimit(arr, i) || $80f83bf841e4cf98$var$_unsupportedIterableToArray(arr, i) || $80f83bf841e4cf98$var$_nonIterableRest();
}
function $80f83bf841e4cf98$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $80f83bf841e4cf98$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $80f83bf841e4cf98$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $80f83bf841e4cf98$var$_arrayLikeToArray(o, minLen);
}
function $80f83bf841e4cf98$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $80f83bf841e4cf98$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $80f83bf841e4cf98$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $80f83bf841e4cf98$var$_regeneratorRuntime() {
    "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ 
    $80f83bf841e4cf98$var$_regeneratorRuntime = function _regeneratorRuntime() {
        return exports;
    };
    var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
    function define(obj, key, value) {
        return Object.defineProperty(obj, key, {
            value: value,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }), obj[key];
    }
    try {
        define({}, "");
    } catch (err) {
        define = function define(obj, key, value) {
            return obj[key] = value;
        };
    }
    function wrap(innerFn, outerFn, self, tryLocsList) {
        var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []);
        return generator._invoke = function(innerFn, self, context) {
            var state = "suspendedStart";
            return function(method, arg) {
                if ("executing" === state) throw new Error("Generator is already running");
                if ("completed" === state) {
                    if ("throw" === method) throw arg;
                    return doneResult();
                }
                for(context.method = method, context.arg = arg;;){
                    var delegate = context.delegate;
                    if (delegate) {
                        var delegateResult = maybeInvokeDelegate(delegate, context);
                        if (delegateResult) {
                            if (delegateResult === ContinueSentinel) continue;
                            return delegateResult;
                        }
                    }
                    if ("next" === context.method) context.sent = context._sent = context.arg;
                    else if ("throw" === context.method) {
                        if ("suspendedStart" === state) throw state = "completed", context.arg;
                        context.dispatchException(context.arg);
                    } else "return" === context.method && context.abrupt("return", context.arg);
                    state = "executing";
                    var record = tryCatch(innerFn, self, context);
                    if ("normal" === record.type) {
                        if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue;
                        return {
                            value: record.arg,
                            done: context.done
                        };
                    }
                    "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg);
                }
            };
        }(innerFn, self, context), generator;
    }
    function tryCatch(fn, obj, arg) {
        try {
            return {
                type: "normal",
                arg: fn.call(obj, arg)
            };
        } catch (err) {
            return {
                type: "throw",
                arg: err
            };
        }
    }
    exports.wrap = wrap;
    var ContinueSentinel = {};
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    var IteratorPrototype = {};
    define(IteratorPrototype, iteratorSymbol, function() {
        return this;
    });
    var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([])));
    NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype);
    var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
    function defineIteratorMethods(prototype) {
        [
            "next",
            "throw",
            "return"
        ].forEach(function(method) {
            define(prototype, method, function(arg) {
                return this._invoke(method, arg);
            });
        });
    }
    function AsyncIterator(generator, PromiseImpl) {
        function invoke(method, arg, resolve, reject) {
            var record = tryCatch(generator[method], generator, arg);
            if ("throw" !== record.type) {
                var result = record.arg, value = result.value;
                return value && "object" == $80f83bf841e4cf98$var$_typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function(value) {
                    invoke("next", value, resolve, reject);
                }, function(err) {
                    invoke("throw", err, resolve, reject);
                }) : PromiseImpl.resolve(value).then(function(unwrapped) {
                    result.value = unwrapped, resolve(result);
                }, function(error) {
                    return invoke("throw", error, resolve, reject);
                });
            }
            reject(record.arg);
        }
        var previousPromise;
        this._invoke = function(method, arg) {
            function callInvokeWithMethodAndArg() {
                return new PromiseImpl(function(resolve, reject) {
                    invoke(method, arg, resolve, reject);
                });
            }
            return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
        };
    }
    function maybeInvokeDelegate(delegate, context) {
        var method = delegate.iterator[context.method];
        if (undefined === method) {
            if (context.delegate = null, "throw" === context.method) {
                if (delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel;
                context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method");
            }
            return ContinueSentinel;
        }
        var record = tryCatch(method, delegate.iterator, context.arg);
        if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel;
        var info = record.arg;
        return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel);
    }
    function pushTryEntry(locs) {
        var entry = {
            tryLoc: locs[0]
        };
        1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry);
    }
    function resetTryEntry(entry) {
        var record = entry.completion || {};
        record.type = "normal", delete record.arg, entry.completion = record;
    }
    function Context(tryLocsList) {
        this.tryEntries = [
            {
                tryLoc: "root"
            }
        ], tryLocsList.forEach(pushTryEntry, this), this.reset(!0);
    }
    function values(iterable) {
        if (iterable) {
            var iteratorMethod = iterable[iteratorSymbol];
            if (iteratorMethod) return iteratorMethod.call(iterable);
            if ("function" == typeof iterable.next) return iterable;
            if (!isNaN(iterable.length)) {
                var i = -1, next = function next() {
                    for(; ++i < iterable.length;){
                        if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next;
                    }
                    return next.value = undefined, next.done = !0, next;
                };
                return next.next = next;
            }
        }
        return {
            next: doneResult
        };
    }
    function doneResult() {
        return {
            value: undefined,
            done: !0
        };
    }
    return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function(genFun) {
        var ctor = "function" == typeof genFun && genFun.constructor;
        return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name));
    }, exports.mark = function(genFun) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun;
    }, exports.awrap = function(arg) {
        return {
            __await: arg
        };
    }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function() {
        return this;
    }), exports.AsyncIterator = AsyncIterator, exports.async = function(innerFn, outerFn, self, tryLocsList, PromiseImpl) {
        void 0 === PromiseImpl && (PromiseImpl = Promise);
        var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
        return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function(result) {
            return result.done ? result.value : iter.next();
        });
    }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function() {
        return this;
    }), define(Gp, "toString", function() {
        return "[object Generator]";
    }), exports.keys = function(object) {
        var keys = [];
        for(var key in object)keys.push(key);
        return keys.reverse(), function next() {
            for(; keys.length;){
                var key = keys.pop();
                if (key in object) return next.value = key, next.done = !1, next;
            }
            return next.done = !0, next;
        };
    }, exports.values = values, Context.prototype = {
        constructor: Context,
        reset: function reset(skipTempReset) {
            if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for(var name in this)"t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined);
        },
        stop: function stop() {
            this.done = !0;
            var rootRecord = this.tryEntries[0].completion;
            if ("throw" === rootRecord.type) throw rootRecord.arg;
            return this.rval;
        },
        dispatchException: function dispatchException(exception) {
            if (this.done) throw exception;
            var context = this;
            function handle(loc, caught) {
                return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught;
            }
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i], record = entry.completion;
                if ("root" === entry.tryLoc) return handle("end");
                if (entry.tryLoc <= this.prev) {
                    var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc");
                    if (hasCatch && hasFinally) {
                        if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
                        if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
                    } else if (hasCatch) {
                        if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
                    } else {
                        if (!hasFinally) throw new Error("try statement without catch or finally");
                        if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
                    }
                }
            }
        },
        abrupt: function abrupt(type, arg) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
                    var finallyEntry = entry;
                    break;
                }
            }
            finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null);
            var record = finallyEntry ? finallyEntry.completion : {};
            return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record);
        },
        complete: function complete(record, afterLoc) {
            if ("throw" === record.type) throw record.arg;
            return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel;
        },
        finish: function finish(finallyLoc) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel;
            }
        },
        catch: function _catch(tryLoc) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.tryLoc === tryLoc) {
                    var record = entry.completion;
                    if ("throw" === record.type) {
                        var thrown = record.arg;
                        resetTryEntry(entry);
                    }
                    return thrown;
                }
            }
            throw new Error("illegal catch attempt");
        },
        delegateYield: function delegateYield(iterable, resultName, nextLoc) {
            return this.delegate = {
                iterator: values(iterable),
                resultName: resultName,
                nextLoc: nextLoc
            }, "next" === this.method && (this.arg = undefined), ContinueSentinel;
        }
    }, exports;
}
function $80f83bf841e4cf98$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $80f83bf841e4cf98$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $80f83bf841e4cf98$var$ownKeys(Object(source), !0).forEach(function(key) {
            $80f83bf841e4cf98$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $80f83bf841e4cf98$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $80f83bf841e4cf98$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $80f83bf841e4cf98$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) resolve(value);
    else Promise.resolve(value).then(_next, _throw);
}
function $80f83bf841e4cf98$var$_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                $80f83bf841e4cf98$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                $80f83bf841e4cf98$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
var $80f83bf841e4cf98$var$useDisabled = $hd4g0.hooks.useDisabled, $80f83bf841e4cf98$var$useLocalizer = $hd4g0.hooks.useLocalizer;
var $80f83bf841e4cf98$var$ROOT_STYLE = {
    "&.webchat__upload-button": {
        display: "flex",
        overflow: "hidden",
        position: "relative",
        "& .webchat__upload-button--file-input": {
            height: 0,
            width: 0,
            opacity: 0,
            position: "absolute",
            left: 0,
            top: 0
        }
    }
};
var $80f83bf841e4cf98$var$PREVENT_DEFAULT_HANDLER = function PREVENT_DEFAULT_HANDLER(event) {
    return event.preventDefault();
};
function $80f83bf841e4cf98$var$makeThumbnail(_x, _x2, _x3, _x4, _x5) {
    return $80f83bf841e4cf98$var$_makeThumbnail.apply(this, arguments);
}
function $80f83bf841e4cf98$var$_makeThumbnail() {
    $80f83bf841e4cf98$var$_makeThumbnail = $80f83bf841e4cf98$var$_asyncToGenerator(/*#__PURE__*/ $80f83bf841e4cf98$var$_regeneratorRuntime().mark(function _callee3(file, width, height, contentType, quality) {
        return $80f83bf841e4cf98$var$_regeneratorRuntime().wrap(function _callee3$(_context3) {
            while(true)switch(_context3.prev = _context3.next){
                case 0:
                    if (!/\.(gif|jpe?g|png)$/i.test(file.name)) {
                        _context3.next = 10;
                        break;
                    }
                    _context3.prev = 1;
                    _context3.next = 4;
                    return (0, $80f83bf841e4cf98$var$_index.default)(file, width, height, contentType, quality);
                case 4:
                    return _context3.abrupt("return", _context3.sent);
                case 7:
                    _context3.prev = 7;
                    _context3.t0 = _context3["catch"](1);
                    console.warn("Web Chat: Failed to downscale image due to ".concat(_context3.t0, "."));
                case 10:
                case "end":
                    return _context3.stop();
            }
        }, _callee3, null, [
            [
                1,
                7
            ]
        ]);
    }));
    return $80f83bf841e4cf98$var$_makeThumbnail.apply(this, arguments);
}
var $80f83bf841e4cf98$var$connectUploadButton = function connectUploadButton() {
    for(var _len = arguments.length, selectors = new Array(_len), _key = 0; _key < _len; _key++)selectors[_key] = arguments[_key];
    return $80f83bf841e4cf98$var$_connectToWebChat.default.apply(void 0, [
        function(_ref) {
            var disabled = _ref.disabled, language = _ref.language, _sendFiles = _ref.sendFiles, _ref$styleSet$options = _ref.styleSet.options, enableUploadThumbnail = _ref$styleSet$options.enableUploadThumbnail, uploadThumbnailContentType = _ref$styleSet$options.uploadThumbnailContentType, uploadThumbnailHeight = _ref$styleSet$options.uploadThumbnailHeight, uploadThumbnailQuality = _ref$styleSet$options.uploadThumbnailQuality, uploadThumbnailWidth = _ref$styleSet$options.uploadThumbnailWidth;
            return {
                disabled: disabled,
                language: language,
                sendFiles: function() {
                    var _sendFiles2 = $80f83bf841e4cf98$var$_asyncToGenerator(/*#__PURE__*/ $80f83bf841e4cf98$var$_regeneratorRuntime().mark(function _callee2(files) {
                        return $80f83bf841e4cf98$var$_regeneratorRuntime().wrap(function _callee2$(_context2) {
                            while(true)switch(_context2.prev = _context2.next){
                                case 0:
                                    if (!(files && files.length)) {
                                        _context2.next = 6;
                                        break;
                                    }
                                    _context2.t0 = _sendFiles;
                                    _context2.next = 4;
                                    return Promise.all([].map.call(files, /*#__PURE__*/ function() {
                                        var _ref2 = $80f83bf841e4cf98$var$_asyncToGenerator(/*#__PURE__*/ $80f83bf841e4cf98$var$_regeneratorRuntime().mark(function _callee(file) {
                                            return $80f83bf841e4cf98$var$_regeneratorRuntime().wrap(function _callee$(_context) {
                                                while(true)switch(_context.prev = _context.next){
                                                    case 0:
                                                        _context.t0 = $80f83bf841e4cf98$var$_objectSpread;
                                                        _context.t1 = {
                                                            name: file.name,
                                                            size: file.size,
                                                            url: window.URL.createObjectURL(file)
                                                        };
                                                        _context.t2 = enableUploadThumbnail;
                                                        if (!_context.t2) {
                                                            _context.next = 8;
                                                            break;
                                                        }
                                                        _context.next = 6;
                                                        return $80f83bf841e4cf98$var$makeThumbnail(file, uploadThumbnailWidth, uploadThumbnailHeight, uploadThumbnailContentType, uploadThumbnailQuality);
                                                    case 6:
                                                        _context.t3 = _context.sent;
                                                        _context.t2 = {
                                                            thumbnail: _context.t3
                                                        };
                                                    case 8:
                                                        _context.t4 = _context.t2;
                                                        return _context.abrupt("return", (0, _context.t0)(_context.t1, _context.t4));
                                                    case 10:
                                                    case "end":
                                                        return _context.stop();
                                                }
                                            }, _callee);
                                        }));
                                        return function(_x7) {
                                            return _ref2.apply(this, arguments);
                                        };
                                    }()));
                                case 4:
                                    _context2.t1 = _context2.sent;
                                    (0, _context2.t0)(_context2.t1);
                                case 6:
                                case "end":
                                    return _context2.stop();
                            }
                        }, _callee2);
                    }));
                    function sendFiles(_x6) {
                        return _sendFiles2.apply(this, arguments);
                    }
                    return sendFiles;
                }()
            };
        }
    ].concat(selectors));
};
module.exports.connectUploadButton = $80f83bf841e4cf98$var$connectUploadButton;
var $80f83bf841e4cf98$var$UploadButton = function UploadButton(_ref3) {
    var className = _ref3.className;
    var _useStyleSet = (0, $80f83bf841e4cf98$var$_useStyleSet3.default)(), _useStyleSet2 = $80f83bf841e4cf98$var$_slicedToArray(_useStyleSet, 1), uploadButtonStyleSet = _useStyleSet2[0].uploadButton;
    var _useDisabled = $80f83bf841e4cf98$var$useDisabled(), _useDisabled2 = $80f83bf841e4cf98$var$_slicedToArray(_useDisabled, 1), disabled = _useDisabled2[0];
    var inputRef = (0, $80f83bf841e4cf98$var$_react.useRef)();
    var localize = $80f83bf841e4cf98$var$useLocalizer();
    var rootClassName = (0, $80f83bf841e4cf98$var$_useStyleToEmotionObject.default)()($80f83bf841e4cf98$var$ROOT_STYLE) + "";
    var sendFiles = (0, $80f83bf841e4cf98$var$_useSendFiles.default)();
    var current = inputRef.current;
    var uploadFileString = localize("TEXT_INPUT_UPLOAD_BUTTON_ALT");
    var handleClick = (0, $80f83bf841e4cf98$var$_react.useCallback)(function() {
        current && current.click();
    }, [
        current
    ]);
    var handleFileChange = (0, $80f83bf841e4cf98$var$_react.useCallback)(function(_ref4) {
        var files = _ref4.target.files;
        sendFiles(files);
        if (current) current.value = null;
    }, [
        current,
        sendFiles
    ]);
    return /*#__PURE__*/ $80f83bf841e4cf98$var$_react.default.createElement("div", {
        className: (0, $80f83bf841e4cf98$var$_classnames.default)(rootClassName, "webchat__upload-button", uploadButtonStyleSet + "", className)
    }, /*#__PURE__*/ $80f83bf841e4cf98$var$_react.default.createElement("input", {
        "aria-disabled": disabled,
        "aria-hidden": "true",
        className: "webchat__upload-button--file-input",
        multiple: true,
        onChange: disabled ? undefined : handleFileChange,
        onClick: disabled ? $80f83bf841e4cf98$var$PREVENT_DEFAULT_HANDLER : undefined,
        readOnly: disabled,
        ref: inputRef,
        role: "button",
        tabIndex: -1,
        type: "file"
    }), /*#__PURE__*/ $80f83bf841e4cf98$var$_react.default.createElement($80f83bf841e4cf98$var$_IconButton.default, {
        alt: uploadFileString,
        "aria-label": uploadFileString,
        disabled: disabled,
        onClick: handleClick
    }, /*#__PURE__*/ $80f83bf841e4cf98$var$_react.default.createElement($80f83bf841e4cf98$var$_AttachmentIcon.default, null)));
};
$80f83bf841e4cf98$var$UploadButton.defaultProps = {
    className: undefined
};
$80f83bf841e4cf98$var$UploadButton.propTypes = {
    className: $80f83bf841e4cf98$var$_propTypes.default.string
};
var $80f83bf841e4cf98$var$_default = $80f83bf841e4cf98$var$UploadButton;
module.exports.default = $80f83bf841e4cf98$var$_default;

});
parcelRequire.register("boTB3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $84cd0fed37dd3230$var$_react = $84cd0fed37dd3230$var$_interopRequireDefault((parcelRequire("eO7Kz")));
function $84cd0fed37dd3230$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $84cd0fed37dd3230$var$AttachmentIcon = function AttachmentIcon() {
    return /*#__PURE__*/ $84cd0fed37dd3230$var$_react.default.createElement("svg", {
        focusable: false,
        height: 28,
        role: "presentation",
        viewBox: "0 0 25.75 46",
        width: 28
    }, /*#__PURE__*/ $84cd0fed37dd3230$var$_react.default.createElement("path", {
        clipRule: "evenodd",
        d: "M20.75 11.75v21.37a7.69 7.69 0 0 1-.62 3.07 7.95 7.95 0 0 1-4.19 4.19 7.89 7.89 0 0 1-6.13 0 7.95 7.95 0 0 1-4.19-4.19 7.69 7.69 0 0 1-.62-3.07v-22.5a5.27 5.27 0 0 1 .45-2.17 5.69 5.69 0 0 1 3-3 5.48 5.48 0 0 1 4.35 0 5.69 5.69 0 0 1 3 3 5.27 5.27 0 0 1 .45 2.17v22.5a3.41 3.41 0 0 1-.26 1.32 3.31 3.31 0 0 1-1.8 1.8 3.46 3.46 0 0 1-2.63 0 3.31 3.31 0 0 1-1.8-1.8 3.41 3.41 0 0 1-.26-1.32V14h2.25v19.12a1.13 1.13 0 1 0 2.25 0v-22.5a3.4 3.4 0 0 0-.26-1.31 3.31 3.31 0 0 0-1.8-1.8 3.46 3.46 0 0 0-2.63 0 3.31 3.31 0 0 0-1.8 1.8 3.4 3.4 0 0 0-.26 1.31v22.5a5.32 5.32 0 0 0 .45 2.18 5.69 5.69 0 0 0 3 3 5.48 5.48 0 0 0 4.35 0 5.69 5.69 0 0 0 3-3 5.32 5.32 0 0 0 .45-2.18v-21.37z"
    }));
};
var $84cd0fed37dd3230$var$_default = $84cd0fed37dd3230$var$AttachmentIcon;
module.exports.default = $84cd0fed37dd3230$var$_default;

});

parcelRequire.register("gvacg", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $c037737956f2ab2a$var$downscaleImageToDataURL;

var $c037737956f2ab2a$var$_downscaleImageToDataURLUsingBrowser = $c037737956f2ab2a$var$_interopRequireDefault((parcelRequire("ak6nI")));

var $c037737956f2ab2a$var$_downscaleImageToDataURLUsingWorker = $c037737956f2ab2a$var$_interopRequireWildcard((parcelRequire("cKPu1")));
function $c037737956f2ab2a$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($c037737956f2ab2a$var$_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $c037737956f2ab2a$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || $c037737956f2ab2a$var$_typeof(obj) !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $c037737956f2ab2a$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $c037737956f2ab2a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $c037737956f2ab2a$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $c037737956f2ab2a$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $c037737956f2ab2a$var$_typeof(obj);
}
function $c037737956f2ab2a$var$_regeneratorRuntime() {
    "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ 
    $c037737956f2ab2a$var$_regeneratorRuntime = function _regeneratorRuntime() {
        return exports;
    };
    var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
    function define(obj, key, value) {
        return Object.defineProperty(obj, key, {
            value: value,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }), obj[key];
    }
    try {
        define({}, "");
    } catch (err) {
        define = function define(obj, key, value) {
            return obj[key] = value;
        };
    }
    function wrap(innerFn, outerFn, self, tryLocsList) {
        var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []);
        return generator._invoke = function(innerFn, self, context) {
            var state = "suspendedStart";
            return function(method, arg) {
                if ("executing" === state) throw new Error("Generator is already running");
                if ("completed" === state) {
                    if ("throw" === method) throw arg;
                    return doneResult();
                }
                for(context.method = method, context.arg = arg;;){
                    var delegate = context.delegate;
                    if (delegate) {
                        var delegateResult = maybeInvokeDelegate(delegate, context);
                        if (delegateResult) {
                            if (delegateResult === ContinueSentinel) continue;
                            return delegateResult;
                        }
                    }
                    if ("next" === context.method) context.sent = context._sent = context.arg;
                    else if ("throw" === context.method) {
                        if ("suspendedStart" === state) throw state = "completed", context.arg;
                        context.dispatchException(context.arg);
                    } else "return" === context.method && context.abrupt("return", context.arg);
                    state = "executing";
                    var record = tryCatch(innerFn, self, context);
                    if ("normal" === record.type) {
                        if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue;
                        return {
                            value: record.arg,
                            done: context.done
                        };
                    }
                    "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg);
                }
            };
        }(innerFn, self, context), generator;
    }
    function tryCatch(fn, obj, arg) {
        try {
            return {
                type: "normal",
                arg: fn.call(obj, arg)
            };
        } catch (err) {
            return {
                type: "throw",
                arg: err
            };
        }
    }
    exports.wrap = wrap;
    var ContinueSentinel = {};
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    var IteratorPrototype = {};
    define(IteratorPrototype, iteratorSymbol, function() {
        return this;
    });
    var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([])));
    NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype);
    var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
    function defineIteratorMethods(prototype) {
        [
            "next",
            "throw",
            "return"
        ].forEach(function(method) {
            define(prototype, method, function(arg) {
                return this._invoke(method, arg);
            });
        });
    }
    function AsyncIterator(generator, PromiseImpl) {
        function invoke(method, arg, resolve, reject) {
            var record = tryCatch(generator[method], generator, arg);
            if ("throw" !== record.type) {
                var result = record.arg, value = result.value;
                return value && "object" == $c037737956f2ab2a$var$_typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function(value) {
                    invoke("next", value, resolve, reject);
                }, function(err) {
                    invoke("throw", err, resolve, reject);
                }) : PromiseImpl.resolve(value).then(function(unwrapped) {
                    result.value = unwrapped, resolve(result);
                }, function(error) {
                    return invoke("throw", error, resolve, reject);
                });
            }
            reject(record.arg);
        }
        var previousPromise;
        this._invoke = function(method, arg) {
            function callInvokeWithMethodAndArg() {
                return new PromiseImpl(function(resolve, reject) {
                    invoke(method, arg, resolve, reject);
                });
            }
            return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
        };
    }
    function maybeInvokeDelegate(delegate, context) {
        var method = delegate.iterator[context.method];
        if (undefined === method) {
            if (context.delegate = null, "throw" === context.method) {
                if (delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel;
                context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method");
            }
            return ContinueSentinel;
        }
        var record = tryCatch(method, delegate.iterator, context.arg);
        if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel;
        var info = record.arg;
        return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel);
    }
    function pushTryEntry(locs) {
        var entry = {
            tryLoc: locs[0]
        };
        1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry);
    }
    function resetTryEntry(entry) {
        var record = entry.completion || {};
        record.type = "normal", delete record.arg, entry.completion = record;
    }
    function Context(tryLocsList) {
        this.tryEntries = [
            {
                tryLoc: "root"
            }
        ], tryLocsList.forEach(pushTryEntry, this), this.reset(!0);
    }
    function values(iterable) {
        if (iterable) {
            var iteratorMethod = iterable[iteratorSymbol];
            if (iteratorMethod) return iteratorMethod.call(iterable);
            if ("function" == typeof iterable.next) return iterable;
            if (!isNaN(iterable.length)) {
                var i = -1, next = function next() {
                    for(; ++i < iterable.length;){
                        if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next;
                    }
                    return next.value = undefined, next.done = !0, next;
                };
                return next.next = next;
            }
        }
        return {
            next: doneResult
        };
    }
    function doneResult() {
        return {
            value: undefined,
            done: !0
        };
    }
    return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function(genFun) {
        var ctor = "function" == typeof genFun && genFun.constructor;
        return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name));
    }, exports.mark = function(genFun) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun;
    }, exports.awrap = function(arg) {
        return {
            __await: arg
        };
    }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function() {
        return this;
    }), exports.AsyncIterator = AsyncIterator, exports.async = function(innerFn, outerFn, self, tryLocsList, PromiseImpl) {
        void 0 === PromiseImpl && (PromiseImpl = Promise);
        var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
        return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function(result) {
            return result.done ? result.value : iter.next();
        });
    }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function() {
        return this;
    }), define(Gp, "toString", function() {
        return "[object Generator]";
    }), exports.keys = function(object) {
        var keys = [];
        for(var key in object)keys.push(key);
        return keys.reverse(), function next() {
            for(; keys.length;){
                var key = keys.pop();
                if (key in object) return next.value = key, next.done = !1, next;
            }
            return next.done = !0, next;
        };
    }, exports.values = values, Context.prototype = {
        constructor: Context,
        reset: function reset(skipTempReset) {
            if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for(var name in this)"t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined);
        },
        stop: function stop() {
            this.done = !0;
            var rootRecord = this.tryEntries[0].completion;
            if ("throw" === rootRecord.type) throw rootRecord.arg;
            return this.rval;
        },
        dispatchException: function dispatchException(exception) {
            if (this.done) throw exception;
            var context = this;
            function handle(loc, caught) {
                return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught;
            }
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i], record = entry.completion;
                if ("root" === entry.tryLoc) return handle("end");
                if (entry.tryLoc <= this.prev) {
                    var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc");
                    if (hasCatch && hasFinally) {
                        if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
                        if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
                    } else if (hasCatch) {
                        if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
                    } else {
                        if (!hasFinally) throw new Error("try statement without catch or finally");
                        if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
                    }
                }
            }
        },
        abrupt: function abrupt(type, arg) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
                    var finallyEntry = entry;
                    break;
                }
            }
            finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null);
            var record = finallyEntry ? finallyEntry.completion : {};
            return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record);
        },
        complete: function complete(record, afterLoc) {
            if ("throw" === record.type) throw record.arg;
            return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel;
        },
        finish: function finish(finallyLoc) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel;
            }
        },
        catch: function _catch(tryLoc) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.tryLoc === tryLoc) {
                    var record = entry.completion;
                    if ("throw" === record.type) {
                        var thrown = record.arg;
                        resetTryEntry(entry);
                    }
                    return thrown;
                }
            }
            throw new Error("illegal catch attempt");
        },
        delegateYield: function delegateYield(iterable, resultName, nextLoc) {
            return this.delegate = {
                iterator: values(iterable),
                resultName: resultName,
                nextLoc: nextLoc
            }, "next" === this.method && (this.arg = undefined), ContinueSentinel;
        }
    }, exports;
}
function $c037737956f2ab2a$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) resolve(value);
    else Promise.resolve(value).then(_next, _throw);
}
function $c037737956f2ab2a$var$_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                $c037737956f2ab2a$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                $c037737956f2ab2a$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function $c037737956f2ab2a$var$downscaleImageToDataURL(_x, _x2, _x3, _x4, _x5) {
    return $c037737956f2ab2a$var$_downscaleImageToDataURL.apply(this, arguments);
}
function $c037737956f2ab2a$var$_downscaleImageToDataURL() {
    $c037737956f2ab2a$var$_downscaleImageToDataURL = $c037737956f2ab2a$var$_asyncToGenerator(/*#__PURE__*/ $c037737956f2ab2a$var$_regeneratorRuntime().mark(function _callee(blob, maxWidth, maxHeight, type, quality) {
        return $c037737956f2ab2a$var$_regeneratorRuntime().wrap(function _callee$(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    _context.next = 2;
                    return (0, $c037737956f2ab2a$var$_downscaleImageToDataURLUsingWorker.checkSupport)();
                case 2:
                    if (!_context.sent) {
                        _context.next = 4;
                        break;
                    }
                    return _context.abrupt("return", (0, $c037737956f2ab2a$var$_downscaleImageToDataURLUsingWorker.default)(blob, maxWidth, maxHeight, type, quality));
                case 4:
                    return _context.abrupt("return", (0, $c037737956f2ab2a$var$_downscaleImageToDataURLUsingBrowser.default)(blob, maxWidth, maxHeight, type, quality));
                case 5:
                case "end":
                    return _context.stop();
            }
        }, _callee);
    }));
    return $c037737956f2ab2a$var$_downscaleImageToDataURL.apply(this, arguments);
}

});
parcelRequire.register("ak6nI", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $7840b8db0f6d7528$var$downscaleImageToDataURLUsingBrowser;
function $7840b8db0f6d7528$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $7840b8db0f6d7528$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $7840b8db0f6d7528$var$_typeof(obj);
}
function $7840b8db0f6d7528$var$_regeneratorRuntime() {
    "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ 
    $7840b8db0f6d7528$var$_regeneratorRuntime = function _regeneratorRuntime() {
        return exports;
    };
    var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
    function define(obj, key, value) {
        return Object.defineProperty(obj, key, {
            value: value,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }), obj[key];
    }
    try {
        define({}, "");
    } catch (err) {
        define = function define(obj, key, value) {
            return obj[key] = value;
        };
    }
    function wrap(innerFn, outerFn, self, tryLocsList) {
        var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []);
        return generator._invoke = function(innerFn, self, context) {
            var state = "suspendedStart";
            return function(method, arg) {
                if ("executing" === state) throw new Error("Generator is already running");
                if ("completed" === state) {
                    if ("throw" === method) throw arg;
                    return doneResult();
                }
                for(context.method = method, context.arg = arg;;){
                    var delegate = context.delegate;
                    if (delegate) {
                        var delegateResult = maybeInvokeDelegate(delegate, context);
                        if (delegateResult) {
                            if (delegateResult === ContinueSentinel) continue;
                            return delegateResult;
                        }
                    }
                    if ("next" === context.method) context.sent = context._sent = context.arg;
                    else if ("throw" === context.method) {
                        if ("suspendedStart" === state) throw state = "completed", context.arg;
                        context.dispatchException(context.arg);
                    } else "return" === context.method && context.abrupt("return", context.arg);
                    state = "executing";
                    var record = tryCatch(innerFn, self, context);
                    if ("normal" === record.type) {
                        if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue;
                        return {
                            value: record.arg,
                            done: context.done
                        };
                    }
                    "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg);
                }
            };
        }(innerFn, self, context), generator;
    }
    function tryCatch(fn, obj, arg) {
        try {
            return {
                type: "normal",
                arg: fn.call(obj, arg)
            };
        } catch (err) {
            return {
                type: "throw",
                arg: err
            };
        }
    }
    exports.wrap = wrap;
    var ContinueSentinel = {};
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    var IteratorPrototype = {};
    define(IteratorPrototype, iteratorSymbol, function() {
        return this;
    });
    var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([])));
    NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype);
    var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
    function defineIteratorMethods(prototype) {
        [
            "next",
            "throw",
            "return"
        ].forEach(function(method) {
            define(prototype, method, function(arg) {
                return this._invoke(method, arg);
            });
        });
    }
    function AsyncIterator(generator, PromiseImpl) {
        function invoke(method, arg, resolve, reject) {
            var record = tryCatch(generator[method], generator, arg);
            if ("throw" !== record.type) {
                var result = record.arg, value = result.value;
                return value && "object" == $7840b8db0f6d7528$var$_typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function(value) {
                    invoke("next", value, resolve, reject);
                }, function(err) {
                    invoke("throw", err, resolve, reject);
                }) : PromiseImpl.resolve(value).then(function(unwrapped) {
                    result.value = unwrapped, resolve(result);
                }, function(error) {
                    return invoke("throw", error, resolve, reject);
                });
            }
            reject(record.arg);
        }
        var previousPromise;
        this._invoke = function(method, arg) {
            function callInvokeWithMethodAndArg() {
                return new PromiseImpl(function(resolve, reject) {
                    invoke(method, arg, resolve, reject);
                });
            }
            return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
        };
    }
    function maybeInvokeDelegate(delegate, context) {
        var method = delegate.iterator[context.method];
        if (undefined === method) {
            if (context.delegate = null, "throw" === context.method) {
                if (delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel;
                context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method");
            }
            return ContinueSentinel;
        }
        var record = tryCatch(method, delegate.iterator, context.arg);
        if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel;
        var info = record.arg;
        return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel);
    }
    function pushTryEntry(locs) {
        var entry = {
            tryLoc: locs[0]
        };
        1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry);
    }
    function resetTryEntry(entry) {
        var record = entry.completion || {};
        record.type = "normal", delete record.arg, entry.completion = record;
    }
    function Context(tryLocsList) {
        this.tryEntries = [
            {
                tryLoc: "root"
            }
        ], tryLocsList.forEach(pushTryEntry, this), this.reset(!0);
    }
    function values(iterable) {
        if (iterable) {
            var iteratorMethod = iterable[iteratorSymbol];
            if (iteratorMethod) return iteratorMethod.call(iterable);
            if ("function" == typeof iterable.next) return iterable;
            if (!isNaN(iterable.length)) {
                var i = -1, next = function next() {
                    for(; ++i < iterable.length;){
                        if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next;
                    }
                    return next.value = undefined, next.done = !0, next;
                };
                return next.next = next;
            }
        }
        return {
            next: doneResult
        };
    }
    function doneResult() {
        return {
            value: undefined,
            done: !0
        };
    }
    return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function(genFun) {
        var ctor = "function" == typeof genFun && genFun.constructor;
        return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name));
    }, exports.mark = function(genFun) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun;
    }, exports.awrap = function(arg) {
        return {
            __await: arg
        };
    }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function() {
        return this;
    }), exports.AsyncIterator = AsyncIterator, exports.async = function(innerFn, outerFn, self, tryLocsList, PromiseImpl) {
        void 0 === PromiseImpl && (PromiseImpl = Promise);
        var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
        return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function(result) {
            return result.done ? result.value : iter.next();
        });
    }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function() {
        return this;
    }), define(Gp, "toString", function() {
        return "[object Generator]";
    }), exports.keys = function(object) {
        var keys = [];
        for(var key in object)keys.push(key);
        return keys.reverse(), function next() {
            for(; keys.length;){
                var key = keys.pop();
                if (key in object) return next.value = key, next.done = !1, next;
            }
            return next.done = !0, next;
        };
    }, exports.values = values, Context.prototype = {
        constructor: Context,
        reset: function reset(skipTempReset) {
            if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for(var name in this)"t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined);
        },
        stop: function stop() {
            this.done = !0;
            var rootRecord = this.tryEntries[0].completion;
            if ("throw" === rootRecord.type) throw rootRecord.arg;
            return this.rval;
        },
        dispatchException: function dispatchException(exception) {
            if (this.done) throw exception;
            var context = this;
            function handle(loc, caught) {
                return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught;
            }
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i], record = entry.completion;
                if ("root" === entry.tryLoc) return handle("end");
                if (entry.tryLoc <= this.prev) {
                    var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc");
                    if (hasCatch && hasFinally) {
                        if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
                        if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
                    } else if (hasCatch) {
                        if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
                    } else {
                        if (!hasFinally) throw new Error("try statement without catch or finally");
                        if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
                    }
                }
            }
        },
        abrupt: function abrupt(type, arg) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
                    var finallyEntry = entry;
                    break;
                }
            }
            finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null);
            var record = finallyEntry ? finallyEntry.completion : {};
            return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record);
        },
        complete: function complete(record, afterLoc) {
            if ("throw" === record.type) throw record.arg;
            return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel;
        },
        finish: function finish(finallyLoc) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel;
            }
        },
        catch: function _catch(tryLoc) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.tryLoc === tryLoc) {
                    var record = entry.completion;
                    if ("throw" === record.type) {
                        var thrown = record.arg;
                        resetTryEntry(entry);
                    }
                    return thrown;
                }
            }
            throw new Error("illegal catch attempt");
        },
        delegateYield: function delegateYield(iterable, resultName, nextLoc) {
            return this.delegate = {
                iterator: values(iterable),
                resultName: resultName,
                nextLoc: nextLoc
            }, "next" === this.method && (this.arg = undefined), ContinueSentinel;
        }
    }, exports;
}
function $7840b8db0f6d7528$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) resolve(value);
    else Promise.resolve(value).then(_next, _throw);
}
function $7840b8db0f6d7528$var$_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                $7840b8db0f6d7528$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                $7840b8db0f6d7528$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function $7840b8db0f6d7528$var$keepAspectRatio(width, height, maxWidth, maxHeight) {
    if (width < maxWidth && height < maxHeight) // Photo is smaller than both maximum dimensions, take it as-is
    return {
        height: height,
        width: width
    };
    var aspectRatio = width / height;
    if (aspectRatio > maxWidth / maxHeight) // Photo is wider than maximum dimension, downscale it based on maxWidth.
    return {
        height: maxWidth / aspectRatio,
        width: maxWidth
    };
     // Photo is taller than maximum dimension, downscale it based on maxHeight.
    return {
        height: maxHeight,
        width: maxHeight * aspectRatio
    };
}
function $7840b8db0f6d7528$var$createCanvas(width, height) {
    var canvas = document.createElement("canvas");
    canvas.height = height;
    canvas.width = width;
    return canvas;
}
function $7840b8db0f6d7528$var$loadImageFromBlob(blob) {
    var blobURL = URL.createObjectURL(blob);
    return new Promise(function(resolve, reject) {
        var image = document.createElement("img");
        image.addEventListener("error", function(_ref) {
            var error = _ref.error;
            return reject(error);
        });
        image.addEventListener("load", function() {
            return resolve(image);
        });
        image.setAttribute("src", blobURL);
    }).finally(function() {
        URL.revokeObjectURL(blobURL);
    });
}
function $7840b8db0f6d7528$var$downscaleImageToDataURLUsingBrowser(_x, _x2, _x3, _x4, _x5) {
    return $7840b8db0f6d7528$var$_downscaleImageToDataURLUsingBrowser.apply(this, arguments);
}
function $7840b8db0f6d7528$var$_downscaleImageToDataURLUsingBrowser() {
    $7840b8db0f6d7528$var$_downscaleImageToDataURLUsingBrowser = $7840b8db0f6d7528$var$_asyncToGenerator(/*#__PURE__*/ $7840b8db0f6d7528$var$_regeneratorRuntime().mark(function _callee(blob, maxWidth, maxHeight, type, quality) {
        var image, _keepAspectRatio, height, width, canvas, context;
        return $7840b8db0f6d7528$var$_regeneratorRuntime().wrap(function _callee$(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    _context.next = 2;
                    return $7840b8db0f6d7528$var$loadImageFromBlob(blob);
                case 2:
                    image = _context.sent;
                    _keepAspectRatio = $7840b8db0f6d7528$var$keepAspectRatio(image.width, image.height, maxWidth, maxHeight), height = _keepAspectRatio.height, width = _keepAspectRatio.width;
                    canvas = $7840b8db0f6d7528$var$createCanvas(width, height);
                    context = canvas.getContext("2d");
                    context.drawImage(image, 0, 0, width, height);
                    return _context.abrupt("return", canvas.toDataURL(type, quality));
                case 8:
                case "end":
                    return _context.stop();
            }
        }, _callee);
    }));
    return $7840b8db0f6d7528$var$_downscaleImageToDataURLUsingBrowser.apply(this, arguments);
}

});

parcelRequire.register("cKPu1", function(module, exports) {
"use strict";
function $9491b76f043cbd18$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $9491b76f043cbd18$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $9491b76f043cbd18$var$_typeof(obj);
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.checkSupport = $9491b76f043cbd18$var$checkSupport;
module.exports.default = $9491b76f043cbd18$var$downscaleImageToDataURLUsingWorker;

var $9491b76f043cbd18$var$_blobToArrayBuffer = $9491b76f043cbd18$var$_interopRequireDefault((parcelRequire("gicLa")));

var $9491b76f043cbd18$var$_downscaleImageToDataURLUsingWorker = $9491b76f043cbd18$var$_interopRequireDefault((parcelRequire("kOrSA")));
function $9491b76f043cbd18$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $9491b76f043cbd18$var$_slicedToArray(arr, i) {
    return $9491b76f043cbd18$var$_arrayWithHoles(arr) || $9491b76f043cbd18$var$_iterableToArrayLimit(arr, i) || $9491b76f043cbd18$var$_unsupportedIterableToArray(arr, i) || $9491b76f043cbd18$var$_nonIterableRest();
}
function $9491b76f043cbd18$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $9491b76f043cbd18$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $9491b76f043cbd18$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $9491b76f043cbd18$var$_arrayLikeToArray(o, minLen);
}
function $9491b76f043cbd18$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $9491b76f043cbd18$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $9491b76f043cbd18$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $9491b76f043cbd18$var$_regeneratorRuntime() {
    "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ 
    $9491b76f043cbd18$var$_regeneratorRuntime = function _regeneratorRuntime() {
        return exports;
    };
    var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
    function define(obj, key, value) {
        return Object.defineProperty(obj, key, {
            value: value,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }), obj[key];
    }
    try {
        define({}, "");
    } catch (err) {
        define = function define(obj, key, value) {
            return obj[key] = value;
        };
    }
    function wrap(innerFn, outerFn, self, tryLocsList) {
        var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []);
        return generator._invoke = function(innerFn, self, context) {
            var state = "suspendedStart";
            return function(method, arg) {
                if ("executing" === state) throw new Error("Generator is already running");
                if ("completed" === state) {
                    if ("throw" === method) throw arg;
                    return doneResult();
                }
                for(context.method = method, context.arg = arg;;){
                    var delegate = context.delegate;
                    if (delegate) {
                        var delegateResult = maybeInvokeDelegate(delegate, context);
                        if (delegateResult) {
                            if (delegateResult === ContinueSentinel) continue;
                            return delegateResult;
                        }
                    }
                    if ("next" === context.method) context.sent = context._sent = context.arg;
                    else if ("throw" === context.method) {
                        if ("suspendedStart" === state) throw state = "completed", context.arg;
                        context.dispatchException(context.arg);
                    } else "return" === context.method && context.abrupt("return", context.arg);
                    state = "executing";
                    var record = tryCatch(innerFn, self, context);
                    if ("normal" === record.type) {
                        if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue;
                        return {
                            value: record.arg,
                            done: context.done
                        };
                    }
                    "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg);
                }
            };
        }(innerFn, self, context), generator;
    }
    function tryCatch(fn, obj, arg) {
        try {
            return {
                type: "normal",
                arg: fn.call(obj, arg)
            };
        } catch (err) {
            return {
                type: "throw",
                arg: err
            };
        }
    }
    exports.wrap = wrap;
    var ContinueSentinel = {};
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    var IteratorPrototype = {};
    define(IteratorPrototype, iteratorSymbol, function() {
        return this;
    });
    var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([])));
    NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype);
    var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
    function defineIteratorMethods(prototype) {
        [
            "next",
            "throw",
            "return"
        ].forEach(function(method) {
            define(prototype, method, function(arg) {
                return this._invoke(method, arg);
            });
        });
    }
    function AsyncIterator(generator, PromiseImpl) {
        function invoke(method, arg, resolve, reject) {
            var record = tryCatch(generator[method], generator, arg);
            if ("throw" !== record.type) {
                var result = record.arg, value = result.value;
                return value && "object" == $9491b76f043cbd18$var$_typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function(value) {
                    invoke("next", value, resolve, reject);
                }, function(err) {
                    invoke("throw", err, resolve, reject);
                }) : PromiseImpl.resolve(value).then(function(unwrapped) {
                    result.value = unwrapped, resolve(result);
                }, function(error) {
                    return invoke("throw", error, resolve, reject);
                });
            }
            reject(record.arg);
        }
        var previousPromise;
        this._invoke = function(method, arg) {
            function callInvokeWithMethodAndArg() {
                return new PromiseImpl(function(resolve, reject) {
                    invoke(method, arg, resolve, reject);
                });
            }
            return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
        };
    }
    function maybeInvokeDelegate(delegate, context) {
        var method = delegate.iterator[context.method];
        if (undefined === method) {
            if (context.delegate = null, "throw" === context.method) {
                if (delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel;
                context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method");
            }
            return ContinueSentinel;
        }
        var record = tryCatch(method, delegate.iterator, context.arg);
        if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel;
        var info = record.arg;
        return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel);
    }
    function pushTryEntry(locs) {
        var entry = {
            tryLoc: locs[0]
        };
        1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry);
    }
    function resetTryEntry(entry) {
        var record = entry.completion || {};
        record.type = "normal", delete record.arg, entry.completion = record;
    }
    function Context(tryLocsList) {
        this.tryEntries = [
            {
                tryLoc: "root"
            }
        ], tryLocsList.forEach(pushTryEntry, this), this.reset(!0);
    }
    function values(iterable) {
        if (iterable) {
            var iteratorMethod = iterable[iteratorSymbol];
            if (iteratorMethod) return iteratorMethod.call(iterable);
            if ("function" == typeof iterable.next) return iterable;
            if (!isNaN(iterable.length)) {
                var i = -1, next = function next() {
                    for(; ++i < iterable.length;){
                        if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next;
                    }
                    return next.value = undefined, next.done = !0, next;
                };
                return next.next = next;
            }
        }
        return {
            next: doneResult
        };
    }
    function doneResult() {
        return {
            value: undefined,
            done: !0
        };
    }
    return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function(genFun) {
        var ctor = "function" == typeof genFun && genFun.constructor;
        return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name));
    }, exports.mark = function(genFun) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun;
    }, exports.awrap = function(arg) {
        return {
            __await: arg
        };
    }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function() {
        return this;
    }), exports.AsyncIterator = AsyncIterator, exports.async = function(innerFn, outerFn, self, tryLocsList, PromiseImpl) {
        void 0 === PromiseImpl && (PromiseImpl = Promise);
        var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
        return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function(result) {
            return result.done ? result.value : iter.next();
        });
    }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function() {
        return this;
    }), define(Gp, "toString", function() {
        return "[object Generator]";
    }), exports.keys = function(object) {
        var keys = [];
        for(var key in object)keys.push(key);
        return keys.reverse(), function next() {
            for(; keys.length;){
                var key = keys.pop();
                if (key in object) return next.value = key, next.done = !1, next;
            }
            return next.done = !0, next;
        };
    }, exports.values = values, Context.prototype = {
        constructor: Context,
        reset: function reset(skipTempReset) {
            if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for(var name in this)"t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined);
        },
        stop: function stop() {
            this.done = !0;
            var rootRecord = this.tryEntries[0].completion;
            if ("throw" === rootRecord.type) throw rootRecord.arg;
            return this.rval;
        },
        dispatchException: function dispatchException(exception) {
            if (this.done) throw exception;
            var context = this;
            function handle(loc, caught) {
                return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught;
            }
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i], record = entry.completion;
                if ("root" === entry.tryLoc) return handle("end");
                if (entry.tryLoc <= this.prev) {
                    var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc");
                    if (hasCatch && hasFinally) {
                        if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
                        if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
                    } else if (hasCatch) {
                        if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
                    } else {
                        if (!hasFinally) throw new Error("try statement without catch or finally");
                        if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
                    }
                }
            }
        },
        abrupt: function abrupt(type, arg) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
                    var finallyEntry = entry;
                    break;
                }
            }
            finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null);
            var record = finallyEntry ? finallyEntry.completion : {};
            return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record);
        },
        complete: function complete(record, afterLoc) {
            if ("throw" === record.type) throw record.arg;
            return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel;
        },
        finish: function finish(finallyLoc) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel;
            }
        },
        catch: function _catch(tryLoc) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.tryLoc === tryLoc) {
                    var record = entry.completion;
                    if ("throw" === record.type) {
                        var thrown = record.arg;
                        resetTryEntry(entry);
                    }
                    return thrown;
                }
            }
            throw new Error("illegal catch attempt");
        },
        delegateYield: function delegateYield(iterable, resultName, nextLoc) {
            return this.delegate = {
                iterator: values(iterable),
                resultName: resultName,
                nextLoc: nextLoc
            }, "next" === this.method && (this.arg = undefined), ContinueSentinel;
        }
    }, exports;
}
function $9491b76f043cbd18$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) resolve(value);
    else Promise.resolve(value).then(_next, _throw);
}
function $9491b76f043cbd18$var$_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                $9491b76f043cbd18$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                $9491b76f043cbd18$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function $9491b76f043cbd18$var$createWorker(fn) {
    var blob = new Blob([
        "(".concat(fn, ")()")
    ], {
        type: "text/javascript"
    });
    var url = window.URL.createObjectURL(blob);
    return new Promise(function(resolve, reject) {
        var worker = new Worker(url);
        worker.onerror = function(_ref) {
            var error = _ref.error, message = _ref.message;
            return reject(error || new Error(message));
        };
        worker.onmessage = function(_ref2) {
            var data = _ref2.data;
            return data === "ready" && resolve(worker);
        };
    }).finally(function() {
        window.URL.revokeObjectURL(url);
    });
}
var $9491b76f043cbd18$var$workerPromise;
function $9491b76f043cbd18$var$getWorker() {
    return $9491b76f043cbd18$var$_getWorker.apply(this, arguments);
} // We are using a lazy-check because:
// 1. OffscreenCanvas.getContext has a toll
// 2. Developers could bring polyfills
function $9491b76f043cbd18$var$_getWorker() {
    $9491b76f043cbd18$var$_getWorker = $9491b76f043cbd18$var$_asyncToGenerator(/*#__PURE__*/ $9491b76f043cbd18$var$_regeneratorRuntime().mark(function _callee3() {
        var worker;
        return $9491b76f043cbd18$var$_regeneratorRuntime().wrap(function _callee3$(_context3) {
            while(true)switch(_context3.prev = _context3.next){
                case 0:
                    if (!$9491b76f043cbd18$var$workerPromise) {
                        _context3.next = 6;
                        break;
                    }
                    _context3.next = 3;
                    return $9491b76f043cbd18$var$workerPromise;
                case 3:
                    worker = _context3.sent;
                    _context3.next = 11;
                    break;
                case 6:
                    $9491b76f043cbd18$var$workerPromise = $9491b76f043cbd18$var$createWorker($9491b76f043cbd18$var$_downscaleImageToDataURLUsingWorker.default);
                    _context3.next = 9;
                    return $9491b76f043cbd18$var$workerPromise;
                case 9:
                    worker = _context3.sent;
                    worker.addEventListener("error", function() {
                        // Current worker errored out, will create a new worker next time.
                        $9491b76f043cbd18$var$workerPromise = null;
                        worker.terminate();
                    });
                case 11:
                    return _context3.abrupt("return", worker);
                case 12:
                case "end":
                    return _context3.stop();
            }
        }, _callee3);
    }));
    return $9491b76f043cbd18$var$_getWorker.apply(this, arguments);
}
var $9491b76f043cbd18$var$checkSupportOffscreenCanvas = function checkSupportOffscreenCanvas() {
    var hasOffscreenCanvas = typeof window.OffscreenCanvas !== "undefined" && (typeof window.OffscreenCanvas.prototype.convertToBlob !== "undefined" || typeof window.OffscreenCanvas.prototype.toBlob !== "undefined");
    var isOffscreenCanvasSupportGetContext2D;
    if (hasOffscreenCanvas) try {
        new OffscreenCanvas(1, 1).getContext("2d");
        isOffscreenCanvasSupportGetContext2D = true;
    } catch (err) {
        isOffscreenCanvasSupportGetContext2D = false;
    }
    return typeof window.createImageBitmap !== "undefined" && hasOffscreenCanvas && isOffscreenCanvasSupportGetContext2D;
};
var $9491b76f043cbd18$var$checkSupportWebWorkerPromise;
function $9491b76f043cbd18$var$checkSupportWebWorker() {
    return $9491b76f043cbd18$var$checkSupportWebWorkerPromise || ($9491b76f043cbd18$var$checkSupportWebWorkerPromise = $9491b76f043cbd18$var$_asyncToGenerator(/*#__PURE__*/ $9491b76f043cbd18$var$_regeneratorRuntime().mark(function _callee() {
        var worker;
        return $9491b76f043cbd18$var$_regeneratorRuntime().wrap(function _callee$(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    if (!(typeof window.MessageChannel === "undefined" || typeof window.Worker === "undefined")) {
                        _context.next = 2;
                        break;
                    }
                    return _context.abrupt("return", false);
                case 2:
                    _context.prev = 2;
                    _context.next = 5;
                    return $9491b76f043cbd18$var$createWorker('function(){postMessage("ready")}');
                case 5:
                    worker = _context.sent;
                    _context.next = 11;
                    break;
                case 8:
                    _context.prev = 8;
                    _context.t0 = _context["catch"](2);
                    return _context.abrupt("return", false);
                case 11:
                    worker.terminate();
                    return _context.abrupt("return", true);
                case 13:
                case "end":
                    return _context.stop();
            }
        }, _callee, null, [
            [
                2,
                8
            ]
        ]);
    }))());
}
var $9491b76f043cbd18$var$checkSupportPromise;
function $9491b76f043cbd18$var$checkSupport() {
    return $9491b76f043cbd18$var$checkSupportPromise || ($9491b76f043cbd18$var$checkSupportPromise = $9491b76f043cbd18$var$_asyncToGenerator(/*#__PURE__*/ $9491b76f043cbd18$var$_regeneratorRuntime().mark(function _callee2() {
        var results;
        return $9491b76f043cbd18$var$_regeneratorRuntime().wrap(function _callee2$(_context2) {
            while(true)switch(_context2.prev = _context2.next){
                case 0:
                    _context2.prev = 0;
                    _context2.next = 3;
                    return Promise.all([
                        $9491b76f043cbd18$var$checkSupportOffscreenCanvas(),
                        $9491b76f043cbd18$var$checkSupportWebWorker()
                    ]);
                case 3:
                    results = _context2.sent;
                    return _context2.abrupt("return", results.every(function(result) {
                        return result;
                    }));
                case 7:
                    _context2.prev = 7;
                    _context2.t0 = _context2["catch"](0);
                    return _context2.abrupt("return", false);
                case 10:
                case "end":
                    return _context2.stop();
            }
        }, _callee2, null, [
            [
                0,
                7
            ]
        ]);
    }))());
}
function $9491b76f043cbd18$var$downscaleImageToDataURLUsingWorker(blob, maxWidth, maxHeight, type, quality) {
    return new Promise(function(resolve, reject) {
        var _MessageChannel = new MessageChannel(), port1 = _MessageChannel.port1, port2 = _MessageChannel.port2;
        port1.onmessage = function(_ref5) {
            var _ref5$data = _ref5.data, error = _ref5$data.error, result = _ref5$data.result;
            if (error) {
                var err = new Error(error.message);
                err.stack = error.stack;
                reject(err);
            } else resolve(result);
            port1.close();
            port2.close();
        };
        Promise.all([
            (0, $9491b76f043cbd18$var$_blobToArrayBuffer.default)(blob),
            $9491b76f043cbd18$var$getWorker()
        ]).then(function(_ref6) {
            var _ref7 = $9491b76f043cbd18$var$_slicedToArray(_ref6, 2), arrayBuffer = _ref7[0], worker = _ref7[1];
            return worker.postMessage({
                arrayBuffer: arrayBuffer,
                maxHeight: maxHeight,
                maxWidth: maxWidth,
                quality: quality,
                type: type
            }, [
                arrayBuffer,
                port2
            ]);
        });
    });
}

});
parcelRequire.register("gicLa", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $bdc8399fd8b8a1ac$var$blobToArrayBuffer;
function $bdc8399fd8b8a1ac$var$blobToArrayBuffer(file) {
    return new Promise(function(resolve, reject) {
        var reader = new FileReader();
        reader.onerror = function(_ref) {
            var error = _ref.error, message = _ref.message;
            return reject(error || new Error(message));
        };
        reader.onloadend = function() {
            return resolve(reader.result);
        };
        reader.readAsArrayBuffer(file);
    });
}

});

parcelRequire.register("kOrSA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $f26e1a715d52d910$var$_default;
/* eslint object-shorthand: "off" */ /* eslint prefer-destructuring: "off" */ /* eslint prefer-arrow-callback: "off" */ // This file is the entrypoint of Web Worker and is minimally transpiled through Babel.
// Do not include any dependencies here because they will not be bundled.
// This file will also get loaded by IE11, please make sure you hand-transpile it correctly.
function $f26e1a715d52d910$var$_default() {
    function blobToDataURL(blob) {
        return new Promise(function(resolve, reject) {
            const reader = new FileReader();
            reader.onerror = function(event) {
                reject(event.error || new Error(event.message));
            };
            reader.onloadend = function() {
                resolve(reader.result);
            };
            reader.readAsDataURL(blob);
        });
    }
    function keepAspectRatio(width, height, maxWidth, maxHeight) {
        if (width < maxWidth && height < maxHeight) // Photo is smaller than both maximum dimensions, take it as-is
        return {
            height: height,
            width: width
        };
        const aspectRatio = width / height;
        if (aspectRatio > maxWidth / maxHeight) // Photo is wider than maximum dimension, downscale it based on maxWidth.
        return {
            height: maxWidth / aspectRatio,
            width: maxWidth
        };
         // Photo is taller than maximum dimension, downscale it based on maxHeight.
        return {
            height: maxHeight,
            width: maxHeight * aspectRatio
        };
    }
    onmessage = function(event) {
        const data = event.data;
        const arrayBuffer = data.arrayBuffer;
        const maxHeight = data.maxHeight;
        const maxWidth = data.maxWidth;
        const type = data.type;
        const quality = data.quality;
        const port = event.ports[0];
        return Promise.resolve().then(function() {
            return createImageBitmap(new Blob([
                arrayBuffer
            ], {
                resizeQuality: "high"
            }));
        }).then(function(imageBitmap) {
            const dimension = keepAspectRatio(imageBitmap.width, imageBitmap.height, maxWidth, maxHeight);
            const height = dimension.height;
            const width = dimension.width;
            const offscreenCanvas = new OffscreenCanvas(width, height);
            const context = offscreenCanvas.getContext("2d");
            context.drawImage(imageBitmap, 0, 0, width, height); // Firefox quirks: 68.0.1 call named OffscreenCanvas.convertToBlob as OffscreenCanvas.toBlob.
            const convertToBlob = (offscreenCanvas.convertToBlob || offscreenCanvas.toBlob).bind(offscreenCanvas);
            return convertToBlob({
                type: type,
                quality: quality
            });
        }).then(function(blob) {
            return blobToDataURL(blob);
        }).then(function(dataURL) {
            return port.postMessage({
                result: dataURL
            });
        }).catch(function(err) {
            console.error(err);
            port.postMessage({
                error: {
                    message: err.message,
                    stack: err.stack
                }
            });
        });
    };
    postMessage("ready");
}

});



parcelRequire.register("bo3v7", function(module, exports) {
"use strict";
function $84a4a6cb61c6f7dd$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $84a4a6cb61c6f7dd$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $84a4a6cb61c6f7dd$var$_typeof(obj);
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $84a4a6cb61c6f7dd$var$useSendFiles;

var $hd4g0 = parcelRequire("hd4g0");

var $eO7Kz = parcelRequire("eO7Kz");

var $84a4a6cb61c6f7dd$var$_index = $84a4a6cb61c6f7dd$var$_interopRequireDefault((parcelRequire("gvacg")));
function $84a4a6cb61c6f7dd$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $84a4a6cb61c6f7dd$var$_regeneratorRuntime() {
    "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ 
    $84a4a6cb61c6f7dd$var$_regeneratorRuntime = function _regeneratorRuntime() {
        return exports;
    };
    var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
    function define(obj, key, value) {
        return Object.defineProperty(obj, key, {
            value: value,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }), obj[key];
    }
    try {
        define({}, "");
    } catch (err) {
        define = function define(obj, key, value) {
            return obj[key] = value;
        };
    }
    function wrap(innerFn, outerFn, self, tryLocsList) {
        var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []);
        return generator._invoke = function(innerFn, self, context) {
            var state = "suspendedStart";
            return function(method, arg) {
                if ("executing" === state) throw new Error("Generator is already running");
                if ("completed" === state) {
                    if ("throw" === method) throw arg;
                    return doneResult();
                }
                for(context.method = method, context.arg = arg;;){
                    var delegate = context.delegate;
                    if (delegate) {
                        var delegateResult = maybeInvokeDelegate(delegate, context);
                        if (delegateResult) {
                            if (delegateResult === ContinueSentinel) continue;
                            return delegateResult;
                        }
                    }
                    if ("next" === context.method) context.sent = context._sent = context.arg;
                    else if ("throw" === context.method) {
                        if ("suspendedStart" === state) throw state = "completed", context.arg;
                        context.dispatchException(context.arg);
                    } else "return" === context.method && context.abrupt("return", context.arg);
                    state = "executing";
                    var record = tryCatch(innerFn, self, context);
                    if ("normal" === record.type) {
                        if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue;
                        return {
                            value: record.arg,
                            done: context.done
                        };
                    }
                    "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg);
                }
            };
        }(innerFn, self, context), generator;
    }
    function tryCatch(fn, obj, arg) {
        try {
            return {
                type: "normal",
                arg: fn.call(obj, arg)
            };
        } catch (err) {
            return {
                type: "throw",
                arg: err
            };
        }
    }
    exports.wrap = wrap;
    var ContinueSentinel = {};
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    var IteratorPrototype = {};
    define(IteratorPrototype, iteratorSymbol, function() {
        return this;
    });
    var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([])));
    NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype);
    var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
    function defineIteratorMethods(prototype) {
        [
            "next",
            "throw",
            "return"
        ].forEach(function(method) {
            define(prototype, method, function(arg) {
                return this._invoke(method, arg);
            });
        });
    }
    function AsyncIterator(generator, PromiseImpl) {
        function invoke(method, arg, resolve, reject) {
            var record = tryCatch(generator[method], generator, arg);
            if ("throw" !== record.type) {
                var result = record.arg, value = result.value;
                return value && "object" == $84a4a6cb61c6f7dd$var$_typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function(value) {
                    invoke("next", value, resolve, reject);
                }, function(err) {
                    invoke("throw", err, resolve, reject);
                }) : PromiseImpl.resolve(value).then(function(unwrapped) {
                    result.value = unwrapped, resolve(result);
                }, function(error) {
                    return invoke("throw", error, resolve, reject);
                });
            }
            reject(record.arg);
        }
        var previousPromise;
        this._invoke = function(method, arg) {
            function callInvokeWithMethodAndArg() {
                return new PromiseImpl(function(resolve, reject) {
                    invoke(method, arg, resolve, reject);
                });
            }
            return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
        };
    }
    function maybeInvokeDelegate(delegate, context) {
        var method = delegate.iterator[context.method];
        if (undefined === method) {
            if (context.delegate = null, "throw" === context.method) {
                if (delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel;
                context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method");
            }
            return ContinueSentinel;
        }
        var record = tryCatch(method, delegate.iterator, context.arg);
        if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel;
        var info = record.arg;
        return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel);
    }
    function pushTryEntry(locs) {
        var entry = {
            tryLoc: locs[0]
        };
        1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry);
    }
    function resetTryEntry(entry) {
        var record = entry.completion || {};
        record.type = "normal", delete record.arg, entry.completion = record;
    }
    function Context(tryLocsList) {
        this.tryEntries = [
            {
                tryLoc: "root"
            }
        ], tryLocsList.forEach(pushTryEntry, this), this.reset(!0);
    }
    function values(iterable) {
        if (iterable) {
            var iteratorMethod = iterable[iteratorSymbol];
            if (iteratorMethod) return iteratorMethod.call(iterable);
            if ("function" == typeof iterable.next) return iterable;
            if (!isNaN(iterable.length)) {
                var i = -1, next = function next() {
                    for(; ++i < iterable.length;){
                        if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next;
                    }
                    return next.value = undefined, next.done = !0, next;
                };
                return next.next = next;
            }
        }
        return {
            next: doneResult
        };
    }
    function doneResult() {
        return {
            value: undefined,
            done: !0
        };
    }
    return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function(genFun) {
        var ctor = "function" == typeof genFun && genFun.constructor;
        return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name));
    }, exports.mark = function(genFun) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun;
    }, exports.awrap = function(arg) {
        return {
            __await: arg
        };
    }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function() {
        return this;
    }), exports.AsyncIterator = AsyncIterator, exports.async = function(innerFn, outerFn, self, tryLocsList, PromiseImpl) {
        void 0 === PromiseImpl && (PromiseImpl = Promise);
        var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
        return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function(result) {
            return result.done ? result.value : iter.next();
        });
    }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function() {
        return this;
    }), define(Gp, "toString", function() {
        return "[object Generator]";
    }), exports.keys = function(object) {
        var keys = [];
        for(var key in object)keys.push(key);
        return keys.reverse(), function next() {
            for(; keys.length;){
                var key = keys.pop();
                if (key in object) return next.value = key, next.done = !1, next;
            }
            return next.done = !0, next;
        };
    }, exports.values = values, Context.prototype = {
        constructor: Context,
        reset: function reset(skipTempReset) {
            if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for(var name in this)"t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined);
        },
        stop: function stop() {
            this.done = !0;
            var rootRecord = this.tryEntries[0].completion;
            if ("throw" === rootRecord.type) throw rootRecord.arg;
            return this.rval;
        },
        dispatchException: function dispatchException(exception) {
            if (this.done) throw exception;
            var context = this;
            function handle(loc, caught) {
                return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught;
            }
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i], record = entry.completion;
                if ("root" === entry.tryLoc) return handle("end");
                if (entry.tryLoc <= this.prev) {
                    var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc");
                    if (hasCatch && hasFinally) {
                        if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
                        if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
                    } else if (hasCatch) {
                        if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
                    } else {
                        if (!hasFinally) throw new Error("try statement without catch or finally");
                        if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
                    }
                }
            }
        },
        abrupt: function abrupt(type, arg) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
                    var finallyEntry = entry;
                    break;
                }
            }
            finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null);
            var record = finallyEntry ? finallyEntry.completion : {};
            return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record);
        },
        complete: function complete(record, afterLoc) {
            if ("throw" === record.type) throw record.arg;
            return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel;
        },
        finish: function finish(finallyLoc) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel;
            }
        },
        catch: function _catch(tryLoc) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.tryLoc === tryLoc) {
                    var record = entry.completion;
                    if ("throw" === record.type) {
                        var thrown = record.arg;
                        resetTryEntry(entry);
                    }
                    return thrown;
                }
            }
            throw new Error("illegal catch attempt");
        },
        delegateYield: function delegateYield(iterable, resultName, nextLoc) {
            return this.delegate = {
                iterator: values(iterable),
                resultName: resultName,
                nextLoc: nextLoc
            }, "next" === this.method && (this.arg = undefined), ContinueSentinel;
        }
    }, exports;
}
function $84a4a6cb61c6f7dd$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $84a4a6cb61c6f7dd$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $84a4a6cb61c6f7dd$var$ownKeys(Object(source), !0).forEach(function(key) {
            $84a4a6cb61c6f7dd$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $84a4a6cb61c6f7dd$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $84a4a6cb61c6f7dd$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $84a4a6cb61c6f7dd$var$_slicedToArray(arr, i) {
    return $84a4a6cb61c6f7dd$var$_arrayWithHoles(arr) || $84a4a6cb61c6f7dd$var$_iterableToArrayLimit(arr, i) || $84a4a6cb61c6f7dd$var$_unsupportedIterableToArray(arr, i) || $84a4a6cb61c6f7dd$var$_nonIterableRest();
}
function $84a4a6cb61c6f7dd$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $84a4a6cb61c6f7dd$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $84a4a6cb61c6f7dd$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $84a4a6cb61c6f7dd$var$_arrayLikeToArray(o, minLen);
}
function $84a4a6cb61c6f7dd$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $84a4a6cb61c6f7dd$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $84a4a6cb61c6f7dd$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $84a4a6cb61c6f7dd$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) resolve(value);
    else Promise.resolve(value).then(_next, _throw);
}
function $84a4a6cb61c6f7dd$var$_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                $84a4a6cb61c6f7dd$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                $84a4a6cb61c6f7dd$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
var $84a4a6cb61c6f7dd$var$useAPISendFiles = $hd4g0.hooks.useSendFiles, $84a4a6cb61c6f7dd$var$useStyleOptions = $hd4g0.hooks.useStyleOptions, $84a4a6cb61c6f7dd$var$useTrackTiming = $hd4g0.hooks.useTrackTiming;
function $84a4a6cb61c6f7dd$var$canMakeThumbnail(_ref) {
    var name = _ref.name;
    return /\.(gif|jpe?g|png)$/i.test(name);
}
function $84a4a6cb61c6f7dd$var$makeThumbnail(_x, _x2, _x3, _x4, _x5) {
    return $84a4a6cb61c6f7dd$var$_makeThumbnail.apply(this, arguments);
}
function $84a4a6cb61c6f7dd$var$_makeThumbnail() {
    $84a4a6cb61c6f7dd$var$_makeThumbnail = $84a4a6cb61c6f7dd$var$_asyncToGenerator(/*#__PURE__*/ $84a4a6cb61c6f7dd$var$_regeneratorRuntime().mark(function _callee3(file, width, height, contentType, quality) {
        return $84a4a6cb61c6f7dd$var$_regeneratorRuntime().wrap(function _callee3$(_context3) {
            while(true)switch(_context3.prev = _context3.next){
                case 0:
                    _context3.prev = 0;
                    _context3.next = 3;
                    return (0, $84a4a6cb61c6f7dd$var$_index.default)(file, width, height, contentType, quality);
                case 3:
                    return _context3.abrupt("return", _context3.sent);
                case 6:
                    _context3.prev = 6;
                    _context3.t0 = _context3["catch"](0);
                    console.warn("Web Chat: Failed to downscale image due to ".concat(_context3.t0, "."));
                case 9:
                case "end":
                    return _context3.stop();
            }
        }, _callee3, null, [
            [
                0,
                6
            ]
        ]);
    }));
    return $84a4a6cb61c6f7dd$var$_makeThumbnail.apply(this, arguments);
}
function $84a4a6cb61c6f7dd$var$useSendFiles() {
    var sendFiles = $84a4a6cb61c6f7dd$var$useAPISendFiles();
    var _useStyleOptions = $84a4a6cb61c6f7dd$var$useStyleOptions(), _useStyleOptions2 = $84a4a6cb61c6f7dd$var$_slicedToArray(_useStyleOptions, 1), _useStyleOptions2$ = _useStyleOptions2[0], enableUploadThumbnail = _useStyleOptions2$.enableUploadThumbnail, uploadThumbnailContentType = _useStyleOptions2$.uploadThumbnailContentType, uploadThumbnailHeight = _useStyleOptions2$.uploadThumbnailHeight, uploadThumbnailQuality = _useStyleOptions2$.uploadThumbnailQuality, uploadThumbnailWidth = _useStyleOptions2$.uploadThumbnailWidth;
    var trackTiming = $84a4a6cb61c6f7dd$var$useTrackTiming();
    return (0, $eO7Kz.useCallback)(/*#__PURE__*/ function() {
        var _ref2 = $84a4a6cb61c6f7dd$var$_asyncToGenerator(/*#__PURE__*/ $84a4a6cb61c6f7dd$var$_regeneratorRuntime().mark(function _callee2(files) {
            var attachments;
            return $84a4a6cb61c6f7dd$var$_regeneratorRuntime().wrap(function _callee2$(_context2) {
                while(true)switch(_context2.prev = _context2.next){
                    case 0:
                        if (!(files && files.length)) {
                            _context2.next = 6;
                            break;
                        }
                        files = [].slice.call(files); // TODO: [P3] We need to find revokeObjectURL on the UI side
                        //       Redux store should not know about the browser environment
                        //       One fix is to use ArrayBuffer instead of object URL, but that would requires change to DirectLineJS
                        _context2.next = 4;
                        return Promise.all(Array.from(files).map(/*#__PURE__*/ function() {
                            var _ref3 = $84a4a6cb61c6f7dd$var$_asyncToGenerator(/*#__PURE__*/ $84a4a6cb61c6f7dd$var$_regeneratorRuntime().mark(function _callee(file) {
                                var thumbnail;
                                return $84a4a6cb61c6f7dd$var$_regeneratorRuntime().wrap(function _callee$(_context) {
                                    while(true)switch(_context.prev = _context.next){
                                        case 0:
                                            if (!($84a4a6cb61c6f7dd$var$_index.default && enableUploadThumbnail && $84a4a6cb61c6f7dd$var$canMakeThumbnail(file))) {
                                                _context.next = 4;
                                                break;
                                            }
                                            _context.next = 3;
                                            return trackTiming("sendFiles:makeThumbnail", $84a4a6cb61c6f7dd$var$makeThumbnail(file, uploadThumbnailWidth, uploadThumbnailHeight, uploadThumbnailContentType, uploadThumbnailQuality));
                                        case 3:
                                            thumbnail = _context.sent;
                                        case 4:
                                            return _context.abrupt("return", $84a4a6cb61c6f7dd$var$_objectSpread({
                                                name: file.name,
                                                size: file.size,
                                                url: window.URL.createObjectURL(file)
                                            }, thumbnail && {
                                                thumbnail: thumbnail
                                            }));
                                        case 5:
                                        case "end":
                                            return _context.stop();
                                    }
                                }, _callee);
                            }));
                            return function(_x7) {
                                return _ref3.apply(this, arguments);
                            };
                        }()));
                    case 4:
                        attachments = _context2.sent;
                        sendFiles(attachments);
                    case 6:
                    case "end":
                        return _context2.stop();
                }
            }, _callee2);
        }));
        return function(_x6) {
            return _ref2.apply(this, arguments);
        };
    }(), [
        enableUploadThumbnail,
        sendFiles,
        trackTiming,
        uploadThumbnailContentType,
        uploadThumbnailHeight,
        uploadThumbnailQuality,
        uploadThumbnailWidth
    ]);
}

});


parcelRequire.register("gwmJ5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $c07143754c8d4f61$var$useSubmitErrorMessageId;

var $c07143754c8d4f61$var$_useContext = $c07143754c8d4f61$var$_interopRequireDefault((parcelRequire("93z0q")));
function $c07143754c8d4f61$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * Subscribes to the `IDREF` of the error message occurred when the user submit the send box.
 *
 * This `IDREF` is intended to be use as the value for `aria-errormessage` and `aria-invalid` attribute.
 *
 * For example, if the user is clicking on the send button without a message, we will read an alert saying "cannot
 * send empty message." This `IDREF` will be the HTML element of the hidden alert element.
 *
 * If there are no errors when submitting the send box, the `IDREF` will be `undefined`.
 */ function $c07143754c8d4f61$var$useSubmitErrorMessageId() {
    return (0, $c07143754c8d4f61$var$_useContext.default)().submitErrorMessageIdState;
}

});


parcelRequire.register("9XbRk", function(module, exports) {
"use strict";
function $73f2d2b5b6a0ba10$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $73f2d2b5b6a0ba10$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $73f2d2b5b6a0ba10$var$_typeof(obj);
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $hd4g0 = parcelRequire("hd4g0");

var $73f2d2b5b6a0ba10$var$_classnames = $73f2d2b5b6a0ba10$var$_interopRequireDefault((parcelRequire("5A4MD")));

var $73f2d2b5b6a0ba10$var$_react = $73f2d2b5b6a0ba10$var$_interopRequireWildcard((parcelRequire("eO7Kz")));

var $73f2d2b5b6a0ba10$var$_CollapseIcon = $73f2d2b5b6a0ba10$var$_interopRequireDefault((parcelRequire("98kVH")));

var $73f2d2b5b6a0ba10$var$_ExpandIcon = $73f2d2b5b6a0ba10$var$_interopRequireDefault((parcelRequire("HeHz8")));

var $73f2d2b5b6a0ba10$var$_NotificationIcon = $73f2d2b5b6a0ba10$var$_interopRequireDefault((parcelRequire("iOb1o")));

var $73f2d2b5b6a0ba10$var$_randomId = $73f2d2b5b6a0ba10$var$_interopRequireDefault((parcelRequire("gJ3hG")));

var $73f2d2b5b6a0ba10$var$_useStyleSet3 = $73f2d2b5b6a0ba10$var$_interopRequireDefault((parcelRequire("gC6jZ")));

var $73f2d2b5b6a0ba10$var$_useStyleToEmotionObject = $73f2d2b5b6a0ba10$var$_interopRequireDefault((parcelRequire("6l4uV")));
function $73f2d2b5b6a0ba10$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($73f2d2b5b6a0ba10$var$_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $73f2d2b5b6a0ba10$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || $73f2d2b5b6a0ba10$var$_typeof(obj) !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $73f2d2b5b6a0ba10$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $73f2d2b5b6a0ba10$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $73f2d2b5b6a0ba10$var$_slicedToArray(arr, i) {
    return $73f2d2b5b6a0ba10$var$_arrayWithHoles(arr) || $73f2d2b5b6a0ba10$var$_iterableToArrayLimit(arr, i) || $73f2d2b5b6a0ba10$var$_unsupportedIterableToArray(arr, i) || $73f2d2b5b6a0ba10$var$_nonIterableRest();
}
function $73f2d2b5b6a0ba10$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $73f2d2b5b6a0ba10$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $73f2d2b5b6a0ba10$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $73f2d2b5b6a0ba10$var$_arrayLikeToArray(o, minLen);
}
function $73f2d2b5b6a0ba10$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $73f2d2b5b6a0ba10$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $73f2d2b5b6a0ba10$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
var $73f2d2b5b6a0ba10$var$useDebouncedNotifications = $hd4g0.hooks.useDebouncedNotifications, $73f2d2b5b6a0ba10$var$useLocalizer = $hd4g0.hooks.useLocalizer, $73f2d2b5b6a0ba10$var$useRenderToast = $hd4g0.hooks.useRenderToast;
var $73f2d2b5b6a0ba10$var$ROOT_STYLE = {
    display: "flex",
    flexDirection: "column",
    "& .webchat__toaster__header": {
        display: "flex",
        flexShrink: 0
    },
    "& .webchat__toaster__expandText": {
        flex: 1
    },
    "& .webchat__toaster__list": {
        display: "block",
        listStyleType: "none"
    }
};
var $73f2d2b5b6a0ba10$var$LEVEL_AS_NUMBER = {
    error: 1,
    warn: 2,
    info: 3,
    success: 4
};
var $73f2d2b5b6a0ba10$var$LEVEL_AS_NUMBER_KEYS = Object.keys($73f2d2b5b6a0ba10$var$LEVEL_AS_NUMBER);
function $73f2d2b5b6a0ba10$var$getLevelAsNumber(level) {
    // Mitigated through allowlisting.
    // eslint-disable-next-line security/detect-object-injection
    return $73f2d2b5b6a0ba10$var$LEVEL_AS_NUMBER_KEYS.includes(level) ? $73f2d2b5b6a0ba10$var$LEVEL_AS_NUMBER[level] : 5;
}
function $73f2d2b5b6a0ba10$var$compareLevel(x, y) {
    return $73f2d2b5b6a0ba10$var$getLevelAsNumber(x) - $73f2d2b5b6a0ba10$var$getLevelAsNumber(y);
}
function $73f2d2b5b6a0ba10$var$sortNotifications(map) {
    return Object.values(map) // We want the order reversed, most recent on top.
    .sort(function(_ref, _ref2) {
        var x = _ref.timestamp;
        var y = _ref2.timestamp;
        return y - x;
    });
}
var $73f2d2b5b6a0ba10$var$PASSTHRU_FN = function PASSTHRU_FN(value) {
    return value;
};
var $73f2d2b5b6a0ba10$var$TOAST_ACCORDION_IDS = {
    two: "TOAST_ACCORDION_TWO",
    few: "TOAST_ACCORDION_FEW",
    many: "TOAST_ACCORDION_MANY",
    other: "TOAST_ACCORDION_OTHER"
};
var $73f2d2b5b6a0ba10$var$BasicToaster = function BasicToaster() {
    var instanceId = (0, $73f2d2b5b6a0ba10$var$_react.useMemo)($73f2d2b5b6a0ba10$var$_randomId.default, []);
    var _useStyleSet = (0, $73f2d2b5b6a0ba10$var$_useStyleSet3.default)(), _useStyleSet2 = $73f2d2b5b6a0ba10$var$_slicedToArray(_useStyleSet, 1), toasterStyleSet = _useStyleSet2[0].toaster;
    var _useDebouncedNotifica = $73f2d2b5b6a0ba10$var$useDebouncedNotifications(), _useDebouncedNotifica2 = $73f2d2b5b6a0ba10$var$_slicedToArray(_useDebouncedNotifica, 1), debouncedNotifications = _useDebouncedNotifica2[0];
    var _useState = (0, $73f2d2b5b6a0ba10$var$_react.useState)(false), _useState2 = $73f2d2b5b6a0ba10$var$_slicedToArray(_useState, 2), expanded = _useState2[0], setExpanded = _useState2[1];
    var localizeWithPlural = $73f2d2b5b6a0ba10$var$useLocalizer({
        plural: true
    });
    var renderToast = $73f2d2b5b6a0ba10$var$useRenderToast();
    var rootClassName = (0, $73f2d2b5b6a0ba10$var$_useStyleToEmotionObject.default)()($73f2d2b5b6a0ba10$var$ROOT_STYLE) + "";
    var handleToggleExpand = (0, $73f2d2b5b6a0ba10$var$_react.useCallback)(function() {
        return setExpanded(!expanded);
    }, [
        expanded,
        setExpanded
    ]);
    var sortedNotifications = (0, $73f2d2b5b6a0ba10$var$_react.useMemo)(function() {
        return $73f2d2b5b6a0ba10$var$sortNotifications(debouncedNotifications);
    }, [
        debouncedNotifications
    ]);
    var sortedNotificationsWithChildren = (0, $73f2d2b5b6a0ba10$var$_react.useMemo)(function() {
        return sortedNotifications.map(function(notification) {
            var children = renderToast({
                notification: notification
            });
            return children && {
                children: children,
                notification: notification
            };
        }).filter($73f2d2b5b6a0ba10$var$PASSTHRU_FN);
    }, [
        renderToast,
        sortedNotifications
    ]);
    var expandable = sortedNotificationsWithChildren.length > 1;
    var _sortedNotificationsW = sortedNotificationsWithChildren.map(function(_ref3) {
        var level = _ref3.notification.level;
        return level;
    }).sort($73f2d2b5b6a0ba10$var$compareLevel), _sortedNotificationsW2 = $73f2d2b5b6a0ba10$var$_slicedToArray(_sortedNotificationsW, 1), highestLevel = _sortedNotificationsW2[0];
    var expandableElementId = (0, $73f2d2b5b6a0ba10$var$_react.useMemo)(function() {
        return !expandable || expanded ? "webchat__toaster__list__".concat(instanceId) : undefined;
    }, [
        expandable,
        expanded,
        instanceId
    ]);
    var headerElementId = (0, $73f2d2b5b6a0ba10$var$_react.useMemo)(function() {
        return expandable ? "webchat__toaster__header__".concat(instanceId) : undefined;
    }, [
        expandable,
        instanceId
    ]);
    (0, $73f2d2b5b6a0ba10$var$_react.useEffect)(function() {
        !expandable && setExpanded(false);
    }, [
        expandable
    ]);
    return /*#__PURE__*/ $73f2d2b5b6a0ba10$var$_react.default.createElement("div", {
        "aria-labelledby": headerElementId,
        "aria-live": "polite",
        "aria-relevant": "all",
        className: (0, $73f2d2b5b6a0ba10$var$_classnames.default)("webchat__toaster", {
            "webchat__toaster--expandable": expandable,
            "webchat__toaster--expanded": expanded,
            "webchat__toaster--error": highestLevel === "error",
            "webchat__toaster--info": highestLevel === "info",
            "webchat__toaster--success": highestLevel === "success",
            "webchat__toaster--warn": highestLevel === "warn"
        }, rootClassName, toasterStyleSet + ""),
        role: "log"
    }, expandable && /*#__PURE__*/ $73f2d2b5b6a0ba10$var$_react.default.createElement("button", {
        "aria-controls": expandableElementId,
        "aria-expanded": expanded,
        className: "webchat__toaster__header",
        id: headerElementId,
        onClick: handleToggleExpand,
        type: "button"
    }, /*#__PURE__*/ $73f2d2b5b6a0ba10$var$_react.default.createElement("div", {
        "aria-hidden": true,
        className: "webchat__toaster__expandLevelIconBox"
    }, /*#__PURE__*/ $73f2d2b5b6a0ba10$var$_react.default.createElement($73f2d2b5b6a0ba10$var$_NotificationIcon.default, {
        className: "webchat__toaster__expandLevelIcon",
        level: highestLevel
    })), /*#__PURE__*/ $73f2d2b5b6a0ba10$var$_react.default.createElement("div", {
        className: "webchat__toaster__expandText"
    }, localizeWithPlural($73f2d2b5b6a0ba10$var$TOAST_ACCORDION_IDS, sortedNotificationsWithChildren.length)), /*#__PURE__*/ $73f2d2b5b6a0ba10$var$_react.default.createElement("div", {
        "aria-hidden": true,
        className: "webchat__toaster__expandIcon"
    }, /*#__PURE__*/ $73f2d2b5b6a0ba10$var$_react.default.createElement("div", {
        className: "webchat__toaster__expandIconFocus"
    }, expanded ? /*#__PURE__*/ $73f2d2b5b6a0ba10$var$_react.default.createElement($73f2d2b5b6a0ba10$var$_CollapseIcon.default, null) : /*#__PURE__*/ $73f2d2b5b6a0ba10$var$_react.default.createElement($73f2d2b5b6a0ba10$var$_ExpandIcon.default, null)))), (!expandable || expanded) && /*#__PURE__*/ $73f2d2b5b6a0ba10$var$_react.default.createElement("div", {
        "aria-labelledby": headerElementId,
        className: "webchat__toaster__list",
        id: expandableElementId
    }, sortedNotificationsWithChildren.map(function(_ref4) {
        var children = _ref4.children, id = _ref4.notification.id;
        return /*#__PURE__*/ $73f2d2b5b6a0ba10$var$_react.default.createElement("div", {
            "aria-atomic": true,
            className: "webchat__toaster__listItem",
            key: id
        }, children);
    })));
};
var $73f2d2b5b6a0ba10$var$_default = $73f2d2b5b6a0ba10$var$BasicToaster;
module.exports.default = $73f2d2b5b6a0ba10$var$_default;

});
parcelRequire.register("98kVH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6a651897dcbaa2d7$var$_propTypes = $6a651897dcbaa2d7$var$_interopRequireDefault((parcelRequire("f7UXb")));

var $6a651897dcbaa2d7$var$_react = $6a651897dcbaa2d7$var$_interopRequireDefault((parcelRequire("eO7Kz")));
function $6a651897dcbaa2d7$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $6a651897dcbaa2d7$var$CollapseIcon = function CollapseIcon(_ref) {
    var className = _ref.className;
    return /*#__PURE__*/ $6a651897dcbaa2d7$var$_react.default.createElement("svg", {
        className: (className || "") + "",
        focusable: false,
        height: "9",
        role: "presentation",
        viewBox: "0 0 16 9",
        width: "16",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ $6a651897dcbaa2d7$var$_react.default.createElement("path", {
        d: "M15.2734 8.97656L8 1.71094L0.726563 8.97656L0.0234375 8.27344L8 0.289062L15.9766 8.27344L15.2734 8.97656Z"
    }));
};
$6a651897dcbaa2d7$var$CollapseIcon.defaultProps = {
    className: undefined
};
$6a651897dcbaa2d7$var$CollapseIcon.propTypes = {
    className: $6a651897dcbaa2d7$var$_propTypes.default.string
};
var $6a651897dcbaa2d7$var$_default = $6a651897dcbaa2d7$var$CollapseIcon;
module.exports.default = $6a651897dcbaa2d7$var$_default;

});

parcelRequire.register("HeHz8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $081f6bb682f76fe0$var$_propTypes = $081f6bb682f76fe0$var$_interopRequireDefault((parcelRequire("f7UXb")));

var $081f6bb682f76fe0$var$_react = $081f6bb682f76fe0$var$_interopRequireDefault((parcelRequire("eO7Kz")));
function $081f6bb682f76fe0$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $081f6bb682f76fe0$var$ExpandIcon = function ExpandIcon(_ref) {
    var className = _ref.className;
    return /*#__PURE__*/ $081f6bb682f76fe0$var$_react.default.createElement("svg", {
        className: (className || "") + "",
        focusable: false,
        height: "10",
        role: "presentation",
        viewBox: "0 0 16 10",
        width: "16",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ $081f6bb682f76fe0$var$_react.default.createElement("path", {
        d: "M15.1484 0.648437L15.8516 1.35156L8 9.20312L0.148438 1.35156L0.851563 0.648438L8 7.79687L15.1484 0.648437Z"
    }));
};
$081f6bb682f76fe0$var$ExpandIcon.defaultProps = {
    className: undefined
};
$081f6bb682f76fe0$var$ExpandIcon.propTypes = {
    className: $081f6bb682f76fe0$var$_propTypes.default.string
};
var $081f6bb682f76fe0$var$_default = $081f6bb682f76fe0$var$ExpandIcon;
module.exports.default = $081f6bb682f76fe0$var$_default;

});

parcelRequire.register("iOb1o", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $hd4g0 = parcelRequire("hd4g0");

var $cG9B9 = parcelRequire("cG9B9");

var $db1572295ecb4930$var$_propTypes = $db1572295ecb4930$var$_interopRequireDefault((parcelRequire("f7UXb")));

var $db1572295ecb4930$var$_react = $db1572295ecb4930$var$_interopRequireDefault((parcelRequire("eO7Kz")));

var $db1572295ecb4930$var$_CheckMarkIcon = $db1572295ecb4930$var$_interopRequireDefault((parcelRequire("l6fm9")));

var $db1572295ecb4930$var$_ExclamationMarkIcon = $db1572295ecb4930$var$_interopRequireDefault((parcelRequire("7uaur")));
function $db1572295ecb4930$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $db1572295ecb4930$var$useLocalizer = $hd4g0.hooks.useLocalizer;
var $db1572295ecb4930$var$NotificationIcon = function NotificationIcon(_ref) {
    var className = _ref.className, level = _ref.level;
    var localize = $db1572295ecb4930$var$useLocalizer();
    var prefixes = {
        error: localize("TOAST_ALT_ERROR"),
        info: localize("TOAST_ALT_INFO"),
        success: localize("TOAST_ALT_SUCCESS"),
        warn: localize("TOAST_ALT_WARN")
    }; // Mitigated through denylisting.
    // eslint-disable-next-line security/detect-object-injection
    var prefix = !(0, $cG9B9.isForbiddenPropertyName)(level) && prefixes[level] || "";
    return /*#__PURE__*/ $db1572295ecb4930$var$_react.default.createElement($db1572295ecb4930$var$_react.default.Fragment, null, level === "success" ? /*#__PURE__*/ $db1572295ecb4930$var$_react.default.createElement($db1572295ecb4930$var$_CheckMarkIcon.default, {
        "aria-label": prefix,
        className: className
    }) : /*#__PURE__*/ $db1572295ecb4930$var$_react.default.createElement($db1572295ecb4930$var$_ExclamationMarkIcon.default, {
        "aria-label": prefix,
        className: className
    }));
};
$db1572295ecb4930$var$NotificationIcon.defaultProps = {
    className: undefined
};
$db1572295ecb4930$var$NotificationIcon.propTypes = {
    className: $db1572295ecb4930$var$_propTypes.default.string,
    level: $db1572295ecb4930$var$_propTypes.default.oneOf([
        "error",
        "info",
        "success",
        "warn"
    ]).isRequired
};
var $db1572295ecb4930$var$_default = $db1572295ecb4930$var$NotificationIcon;
module.exports.default = $db1572295ecb4930$var$_default;

});
parcelRequire.register("l6fm9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f5c611ee87ed107b$var$_propTypes = $f5c611ee87ed107b$var$_interopRequireDefault((parcelRequire("f7UXb")));

var $f5c611ee87ed107b$var$_react = $f5c611ee87ed107b$var$_interopRequireDefault((parcelRequire("eO7Kz")));
function $f5c611ee87ed107b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $f5c611ee87ed107b$var$CheckMarkIcon = function CheckMarkIcon(_ref) {
    var ariaLabel = _ref["aria-label"], className = _ref.className;
    return /*#__PURE__*/ $f5c611ee87ed107b$var$_react.default.createElement("svg", {
        "aria-label": ariaLabel,
        className: (className || "") + "",
        fill: "none",
        height: "20",
        viewBox: "0 0 20 20",
        width: "20",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ $f5c611ee87ed107b$var$_react.default.createElement("path", {
        d: "M14.5605 5.81055L15.4395 6.68945L8.125 14.0039L4.56055 10.4395L5.43945 9.56055L8.125 12.2461L14.5605 5.81055ZM10 0C10.918 0 11.8034 0.120443 12.6562 0.361328C13.5091 0.595703 14.3066 0.93099 15.0488 1.36719C15.791 1.79688 16.4648 2.31771 17.0703 2.92969C17.6823 3.53516 18.2031 4.20898 18.6328 4.95117C19.069 5.69336 19.4043 6.49089 19.6387 7.34375C19.8796 8.19661 20 9.08203 20 10C20 10.918 19.8796 11.8034 19.6387 12.6562C19.4043 13.5091 19.069 14.3066 18.6328 15.0488C18.2031 15.791 17.6823 16.4681 17.0703 17.0801C16.4648 17.6855 15.791 18.2064 15.0488 18.6426C14.3066 19.0723 13.5091 19.4076 12.6562 19.6484C11.8034 19.8828 10.918 20 10 20C9.08203 20 8.19661 19.8828 7.34375 19.6484C6.49089 19.4076 5.69336 19.0723 4.95117 18.6426C4.20898 18.2064 3.5319 17.6855 2.91992 17.0801C2.31445 16.4681 1.79362 15.791 1.35742 15.0488C0.927734 14.3066 0.592448 13.5124 0.351562 12.666C0.117188 11.8132 0 10.9245 0 10C0 9.08203 0.117188 8.19661 0.351562 7.34375C0.592448 6.49089 0.927734 5.69336 1.35742 4.95117C1.79362 4.20898 2.31445 3.53516 2.91992 2.92969C3.5319 2.31771 4.20898 1.79688 4.95117 1.36719C5.69336 0.93099 6.48763 0.595703 7.33398 0.361328C8.18685 0.120443 9.07552 0 10 0ZM10 18.75C10.8008 18.75 11.5723 18.6458 12.3145 18.4375C13.0632 18.2292 13.7598 17.9362 14.4043 17.5586C15.0553 17.1745 15.6478 16.7155 16.1816 16.1816C16.7155 15.6478 17.1712 15.0586 17.5488 14.4141C17.9329 13.763 18.2292 13.0664 18.4375 12.3242C18.6458 11.582 18.75 10.8073 18.75 10C18.75 9.19922 18.6458 8.42773 18.4375 7.68555C18.2292 6.93685 17.9329 6.24023 17.5488 5.5957C17.1712 4.94466 16.7155 4.35221 16.1816 3.81836C15.6478 3.28451 15.0553 2.82878 14.4043 2.45117C13.7598 2.06706 13.0632 1.77083 12.3145 1.5625C11.5723 1.35417 10.8008 1.25 10 1.25C9.19922 1.25 8.42448 1.35417 7.67578 1.5625C6.93359 1.77083 6.23698 2.06706 5.58594 2.45117C4.94141 2.82878 4.35221 3.28451 3.81836 3.81836C3.28451 4.35221 2.82552 4.94466 2.44141 5.5957C2.0638 6.24023 1.77083 6.93685 1.5625 7.68555C1.35417 8.42773 1.25 9.19922 1.25 10C1.25 10.8008 1.35417 11.5755 1.5625 12.3242C1.77083 13.0664 2.0638 13.763 2.44141 14.4141C2.82552 15.0586 3.28451 15.6478 3.81836 16.1816C4.35221 16.7155 4.94141 17.1745 5.58594 17.5586C6.23698 17.9362 6.93359 18.2292 7.67578 18.4375C8.41797 18.6458 9.19271 18.75 10 18.75Z",
        fill: "#107C10"
    }));
};
$f5c611ee87ed107b$var$CheckMarkIcon.defaultProps = {
    "aria-label": undefined,
    className: undefined
};
$f5c611ee87ed107b$var$CheckMarkIcon.propTypes = {
    "aria-label": $f5c611ee87ed107b$var$_propTypes.default.string,
    className: $f5c611ee87ed107b$var$_propTypes.default.string
};
var $f5c611ee87ed107b$var$_default = $f5c611ee87ed107b$var$CheckMarkIcon;
module.exports.default = $f5c611ee87ed107b$var$_default;

});

parcelRequire.register("7uaur", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $573378d9e3f99c25$var$_propTypes = $573378d9e3f99c25$var$_interopRequireDefault((parcelRequire("f7UXb")));

var $573378d9e3f99c25$var$_react = $573378d9e3f99c25$var$_interopRequireDefault((parcelRequire("eO7Kz")));
function $573378d9e3f99c25$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $573378d9e3f99c25$var$ExclamationMarkIcon = function ExclamationMarkIcon(_ref) {
    var ariaLabel = _ref["aria-label"], className = _ref.className;
    return /*#__PURE__*/ $573378d9e3f99c25$var$_react.default.createElement("svg", {
        "aria-label": ariaLabel,
        className: (className || "") + "",
        height: "19",
        viewBox: "0 0 19 19",
        width: "19",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ $573378d9e3f99c25$var$_react.default.createElement("path", {
        d: "M9.375 0C10.2409 0 11.071 0.110677 11.8652 0.332031C12.666 0.553385 13.4147 0.869141 14.1113 1.2793C14.8079 1.68294 15.4395 2.17122 16.0059 2.74414C16.5788 3.31055 17.0671 3.94206 17.4707 4.63867C17.8809 5.33529 18.1966 6.08398 18.418 6.88477C18.6393 7.67904 18.75 8.50911 18.75 9.375C18.75 10.2409 18.6393 11.0742 18.418 11.875C18.1966 12.6693 17.8809 13.4147 17.4707 14.1113C17.0671 14.8079 16.5788 15.4427 16.0059 16.0156C15.4395 16.582 14.8079 17.0703 14.1113 17.4805C13.4147 17.8841 12.666 18.1966 11.8652 18.418C11.071 18.6393 10.2409 18.75 9.375 18.75C8.50911 18.75 7.67578 18.6393 6.875 18.418C6.08073 18.1966 5.33529 17.8841 4.63867 17.4805C3.94206 17.0703 3.30729 16.582 2.73438 16.0156C2.16797 15.4427 1.67969 14.8079 1.26953 14.1113C0.865885 13.4147 0.553385 12.6693 0.332031 11.875C0.110677 11.0742 0 10.2409 0 9.375C0 8.50911 0.110677 7.67904 0.332031 6.88477C0.553385 6.08398 0.865885 5.33529 1.26953 4.63867C1.67969 3.94206 2.16797 3.31055 2.73438 2.74414C3.30729 2.17122 3.94206 1.68294 4.63867 1.2793C5.33529 0.869141 6.08073 0.553385 6.875 0.332031C7.67578 0.110677 8.50911 0 9.375 0ZM9.375 17.5C10.1172 17.5 10.8333 17.4023 11.5234 17.207C12.2201 17.0117 12.8678 16.7383 13.4668 16.3867C14.0723 16.0352 14.6224 15.612 15.1172 15.1172C15.612 14.6224 16.0352 14.0755 16.3867 13.4766C16.7383 12.8711 17.0117 12.2233 17.207 11.5332C17.4023 10.8431 17.5 10.1237 17.5 9.375C17.5 8.63281 17.4023 7.91667 17.207 7.22656C17.0117 6.52995 16.7383 5.88216 16.3867 5.2832C16.0352 4.67773 15.612 4.1276 15.1172 3.63281C14.6224 3.13802 14.0723 2.71484 13.4668 2.36328C12.8678 2.01172 12.2201 1.73828 11.5234 1.54297C10.8333 1.34766 10.1172 1.25 9.375 1.25C8.6263 1.25 7.9069 1.34766 7.2168 1.54297C6.52669 1.73828 5.87891 2.01172 5.27344 2.36328C4.67448 2.71484 4.1276 3.13802 3.63281 3.63281C3.13802 4.1276 2.71484 4.67773 2.36328 5.2832C2.01172 5.88216 1.73828 6.52995 1.54297 7.22656C1.34766 7.91667 1.25 8.63281 1.25 9.375C1.25 10.1172 1.34766 10.8366 1.54297 11.5332C1.73828 12.2233 2.01172 12.8711 2.36328 13.4766C2.71484 14.0755 3.13802 14.6224 3.63281 15.1172C4.1276 15.612 4.67448 16.0352 5.27344 16.3867C5.87891 16.7383 6.52669 17.0117 7.2168 17.207C7.9069 17.4023 8.6263 17.5 9.375 17.5ZM8.75 5H10V11.25H8.75V5ZM8.75 12.5H10V13.75H8.75V12.5Z"
    }));
};
$573378d9e3f99c25$var$ExclamationMarkIcon.defaultProps = {
    "aria-label": undefined,
    className: undefined
};
$573378d9e3f99c25$var$ExclamationMarkIcon.propTypes = {
    "aria-label": $573378d9e3f99c25$var$_propTypes.default.string,
    className: $573378d9e3f99c25$var$_propTypes.default.string
};
var $573378d9e3f99c25$var$_default = $573378d9e3f99c25$var$ExclamationMarkIcon;
module.exports.default = $573378d9e3f99c25$var$_default;

});


parcelRequire.register("gJ3hG", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $c2d3657a080d790d$var$randomId;

var $c2d3657a080d790d$var$_mathRandom = $c2d3657a080d790d$var$_interopRequireDefault((parcelRequire("atZsr")));
function $c2d3657a080d790d$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/* eslint no-magic-numbers: ["error", { "ignore": [2, 5, 36] }] */ function $c2d3657a080d790d$var$randomId() {
    var maxLength = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 5;
    return (0, $c2d3657a080d790d$var$_mathRandom.default)().toString(36).substr(2, maxLength);
}

});


parcelRequire.register("4FrFa", function(module, exports) {
"use strict";
function $3660730fed410921$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $3660730fed410921$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $3660730fed410921$var$_typeof(obj);
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $hd4g0 = parcelRequire("hd4g0");
parcelRequire("4CrIE");
var $YbbaU = parcelRequire("YbbaU");
var $ijKjl = parcelRequire("ijKjl");
var $l5G4z = parcelRequire("l5G4z");
var $29Opo = parcelRequire("29Opo");
var $kTzTj = parcelRequire("kTzTj");
var $fL6wD = parcelRequire("fL6wD");
var $13VWp = parcelRequire("13VWp");
var $jJkLv = parcelRequire("jJkLv");

var $3660730fed410921$var$_classnames = $3660730fed410921$var$_interopRequireDefault((parcelRequire("5A4MD")));

var $3660730fed410921$var$_propTypes = $3660730fed410921$var$_interopRequireDefault((parcelRequire("f7UXb")));

var $3660730fed410921$var$_react = $3660730fed410921$var$_interopRequireWildcard((parcelRequire("eO7Kz")));

var $gLt36 = parcelRequire("gLt36");

var $3660730fed410921$var$_ActivityRow = $3660730fed410921$var$_interopRequireDefault((parcelRequire("gz2Et")));

var $3660730fed410921$var$_BasicTypingIndicator = $3660730fed410921$var$_interopRequireDefault((parcelRequire("56gdr")));

var $3660730fed410921$var$_FocusRedirector = $3660730fed410921$var$_interopRequireDefault((parcelRequire("9uhn3")));

var $3660730fed410921$var$_inputtableKey = $3660730fed410921$var$_interopRequireDefault((parcelRequire("dKsHQ")));

var $3660730fed410921$var$_isZeroOrPositive = $3660730fed410921$var$_interopRequireDefault((parcelRequire("fFkLN")));

var $3660730fed410921$var$_KeyboardHelp = $3660730fed410921$var$_interopRequireDefault((parcelRequire("klg6W")));

var $3660730fed410921$var$_LiveRegionTranscript = $3660730fed410921$var$_interopRequireDefault((parcelRequire("e3ZIb")));

var $3660730fed410921$var$_tabbableElements = $3660730fed410921$var$_interopRequireDefault((parcelRequire("1ySa1")));

var $3660730fed410921$var$_TranscriptFocusComposer = $3660730fed410921$var$_interopRequireDefault((parcelRequire("2hDw6")));

var $3660730fed410921$var$_useActiveDescendantId = $3660730fed410921$var$_interopRequireDefault((parcelRequire("kUkhJ")));

var $3660730fed410921$var$_useActivityTreeWithRenderer = $3660730fed410921$var$_interopRequireDefault((parcelRequire("5TnSK")));

var $3660730fed410921$var$_useDispatchScrollPosition = $3660730fed410921$var$_interopRequireDefault((parcelRequire("iVV3d")));

var $3660730fed410921$var$_useDispatchTranscriptFocusByActivityKey = $3660730fed410921$var$_interopRequireDefault((parcelRequire("3bISN")));

var $3660730fed410921$var$_useFocus = $3660730fed410921$var$_interopRequireDefault((parcelRequire("kPV7d")));

var $3660730fed410921$var$_useFocusByActivityKey = $3660730fed410921$var$_interopRequireDefault((parcelRequire("f1kWf")));

var $3660730fed410921$var$_useFocusedActivityKey = $3660730fed410921$var$_interopRequireDefault((parcelRequire("fRh7R")));

var $3660730fed410921$var$_useFocusedExplicitly3 = $3660730fed410921$var$_interopRequireDefault((parcelRequire("ci4oR")));

var $3660730fed410921$var$_useFocusRelativeActivity = $3660730fed410921$var$_interopRequireDefault((parcelRequire("9NUBQ")));

var $3660730fed410921$var$_useObserveFocusVisible = $3660730fed410921$var$_interopRequireDefault((parcelRequire("90Wbb")));

var $3660730fed410921$var$_usePrevious = $3660730fed410921$var$_interopRequireDefault((parcelRequire("8vHzd")));

var $3660730fed410921$var$_useRegisterFocusTranscript = $3660730fed410921$var$_interopRequireDefault((parcelRequire("j8BzJ")));

var $3660730fed410921$var$_useRegisterScrollRelative = $3660730fed410921$var$_interopRequireDefault((parcelRequire("kiEmy")));

var $3660730fed410921$var$_useRegisterScrollTo = $3660730fed410921$var$_interopRequireDefault((parcelRequire("7fA1J")));

var $3660730fed410921$var$_useRegisterScrollToEnd = $3660730fed410921$var$_interopRequireDefault((parcelRequire("6351u")));

var $3660730fed410921$var$_useStyleSet5 = $3660730fed410921$var$_interopRequireDefault((parcelRequire("gC6jZ")));

var $3660730fed410921$var$_useStyleToEmotionObject = $3660730fed410921$var$_interopRequireDefault((parcelRequire("6l4uV")));

var $3660730fed410921$var$_useUniqueId = $3660730fed410921$var$_interopRequireDefault((parcelRequire("cdwtx")));

var $3660730fed410921$var$_useValueRef = $3660730fed410921$var$_interopRequireDefault((parcelRequire("4Dn0F")));
function $3660730fed410921$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($3660730fed410921$var$_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $3660730fed410921$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || $3660730fed410921$var$_typeof(obj) !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $3660730fed410921$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $3660730fed410921$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $3660730fed410921$var$_createForOfIteratorHelper(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (!it) {
        if (Array.isArray(o) || (it = $3660730fed410921$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
            if (it) o = it;
            var i = 0;
            var F = function F() {};
            return {
                s: F,
                n: function n() {
                    if (i >= o.length) return {
                        done: true
                    };
                    return {
                        done: false,
                        value: o[i++]
                    };
                },
                e: function e(_e2) {
                    throw _e2;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var normalCompletion = true, didErr = false, err;
    return {
        s: function s() {
            it = it.call(o);
        },
        n: function n() {
            var step = it.next();
            normalCompletion = step.done;
            return step;
        },
        e: function e(_e3) {
            didErr = true;
            err = _e3;
        },
        f: function f() {
            try {
                if (!normalCompletion && it.return != null) it.return();
            } finally{
                if (didErr) throw err;
            }
        }
    };
}
function $3660730fed410921$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $3660730fed410921$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $3660730fed410921$var$ownKeys(Object(source), !0).forEach(function(key) {
            $3660730fed410921$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $3660730fed410921$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $3660730fed410921$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $3660730fed410921$var$_slicedToArray(arr, i) {
    return $3660730fed410921$var$_arrayWithHoles(arr) || $3660730fed410921$var$_iterableToArrayLimit(arr, i) || $3660730fed410921$var$_unsupportedIterableToArray(arr, i) || $3660730fed410921$var$_nonIterableRest();
}
function $3660730fed410921$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $3660730fed410921$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $3660730fed410921$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $3660730fed410921$var$_arrayLikeToArray(o, minLen);
}
function $3660730fed410921$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $3660730fed410921$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $3660730fed410921$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
var $3660730fed410921$var$useActivityKeys = $hd4g0.hooks.useActivityKeys, $3660730fed410921$var$useActivityKeysByRead = $hd4g0.hooks.useActivityKeysByRead, $3660730fed410921$var$useCreateActivityStatusRenderer = $hd4g0.hooks.useCreateActivityStatusRenderer, $3660730fed410921$var$useCreateAvatarRenderer = $hd4g0.hooks.useCreateAvatarRenderer, $3660730fed410921$var$useCreateScrollToEndButtonRenderer = $hd4g0.hooks.useCreateScrollToEndButtonRenderer, $3660730fed410921$var$useDirection = $hd4g0.hooks.useDirection, $3660730fed410921$var$useGetActivityByKey = $hd4g0.hooks.useGetActivityByKey, $3660730fed410921$var$useGetKeyByActivity = $hd4g0.hooks.useGetKeyByActivity, $3660730fed410921$var$useGetKeyByActivityId = $hd4g0.hooks.useGetKeyByActivityId, $3660730fed410921$var$useLastAcknowledgedActivityKey = $hd4g0.hooks.useLastAcknowledgedActivityKey, $3660730fed410921$var$useLocalizer = $hd4g0.hooks.useLocalizer, $3660730fed410921$var$useMarkActivityKeyAsRead = $hd4g0.hooks.useMarkActivityKeyAsRead, $3660730fed410921$var$useMarkAllAsAcknowledged = $hd4g0.hooks.useMarkAllAsAcknowledged, $3660730fed410921$var$useStyleOptions = $hd4g0.hooks.useStyleOptions;
var $3660730fed410921$var$ROOT_STYLE = {
    "&.webchat__basic-transcript": {
        display: "flex",
        flexDirection: "column",
        overflow: "hidden",
        // Make sure to set "position: relative" here to form another stacking context for the scroll-to-end button.
        // Stacking context help isolating elements that use "z-index" from global pollution.
        // https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Positioning/Understanding_z_index/The_stacking_context
        position: "relative",
        "& .webchat__basic-transcript__filler": {
            flex: 1
        },
        "& .webchat__basic-transcript__scrollable": {
            display: "flex",
            flexDirection: "column",
            overflowX: "hidden",
            WebkitOverflowScrolling: "touch"
        },
        "& .webchat__basic-transcript__transcript": {
            listStyleType: "none"
        }
    }
};
// TODO: [P1] #4133 Add telemetry for computing how many re-render done so far.
var $3660730fed410921$var$InternalTranscript = /*#__PURE__*/ (0, $3660730fed410921$var$_react.forwardRef)(function(_ref, ref) {
    var activityElementMapRef = _ref.activityElementMapRef, className = _ref.className;
    var _useStyleSet = (0, $3660730fed410921$var$_useStyleSet5.default)(), _useStyleSet2 = $3660730fed410921$var$_slicedToArray(_useStyleSet, 1), basicTranscriptStyleSet = _useStyleSet2[0].basicTranscript;
    var _useStyleOptions = $3660730fed410921$var$useStyleOptions(), _useStyleOptions2 = $3660730fed410921$var$_slicedToArray(_useStyleOptions, 1), _useStyleOptions2$ = _useStyleOptions2[0], bubbleFromUserNubOffset = _useStyleOptions2$.bubbleFromUserNubOffset, bubbleNubOffset = _useStyleOptions2$.bubbleNubOffset, groupTimestamp = _useStyleOptions2$.groupTimestamp, showAvatarInGroup = _useStyleOptions2$.showAvatarInGroup;
    var _useActiveDescendantI = (0, $3660730fed410921$var$_useActiveDescendantId.default)(), _useActiveDescendantI2 = $3660730fed410921$var$_slicedToArray(_useActiveDescendantI, 1), activeDescendantId = _useActiveDescendantI2[0];
    var _useActivityTreeWithR = (0, $3660730fed410921$var$_useActivityTreeWithRenderer.default)(), _useActivityTreeWithR2 = $3660730fed410921$var$_slicedToArray(_useActivityTreeWithR, 1), activityWithRendererTree = _useActivityTreeWithR2[0];
    var _useDirection = $3660730fed410921$var$useDirection(), _useDirection2 = $3660730fed410921$var$_slicedToArray(_useDirection, 1), direction = _useDirection2[0];
    var _useFocusedActivityKe = (0, $3660730fed410921$var$_useFocusedActivityKey.default)(), _useFocusedActivityKe2 = $3660730fed410921$var$_slicedToArray(_useFocusedActivityKe, 1), focusedActivityKey = _useFocusedActivityKe2[0];
    var _useFocusedExplicitly = (0, $3660730fed410921$var$_useFocusedExplicitly3.default)(), _useFocusedExplicitly2 = $3660730fed410921$var$_slicedToArray(_useFocusedExplicitly, 1), focusedExplicitly = _useFocusedExplicitly2[0];
    var createActivityStatusRenderer = $3660730fed410921$var$useCreateActivityStatusRenderer();
    var createAvatarRenderer = $3660730fed410921$var$useCreateAvatarRenderer();
    var focus = (0, $3660730fed410921$var$_useFocus.default)();
    var focusByActivityKey = (0, $3660730fed410921$var$_useFocusByActivityKey.default)();
    var focusRelativeActivity = (0, $3660730fed410921$var$_useFocusRelativeActivity.default)();
    var getActivityByKey = $3660730fed410921$var$useGetActivityByKey();
    var getKeyByActivity = $3660730fed410921$var$useGetKeyByActivity();
    var getKeyByActivityId = $3660730fed410921$var$useGetKeyByActivityId();
    var localize = $3660730fed410921$var$useLocalizer();
    var rootClassName = (0, $3660730fed410921$var$_useStyleToEmotionObject.default)()($3660730fed410921$var$ROOT_STYLE) + "";
    var rootElementRef = (0, $3660730fed410921$var$_react.useRef)();
    var terminatorLabelId = (0, $3660730fed410921$var$_useUniqueId.default)("webchat__basic-transcript__terminator-label");
    var terminatorRef = (0, $3660730fed410921$var$_react.useRef)();
    var focusedActivityKeyRef = (0, $3660730fed410921$var$_useValueRef.default)(focusedActivityKey);
    var hideAllTimestamps = groupTimestamp === false;
    var terminatorText = localize("TRANSCRIPT_TERMINATOR_TEXT");
    var transcriptAriaLabel = localize("TRANSCRIPT_ARIA_LABEL_ALT");
    var callbackRef = (0, $3660730fed410921$var$_react.useCallback)(function(element) {
        if (typeof ref === "function") ref(element);
        else ref.current = element;
        rootElementRef.current = element;
    }, [
        ref,
        rootElementRef
    ]); // Flatten the tree back into an array with information related to rendering.
    var renderingElements = (0, $3660730fed410921$var$_react.useMemo)(function() {
        var renderingElements = [];
        var topSideBotNub = (0, $3660730fed410921$var$_isZeroOrPositive.default)(bubbleNubOffset);
        var topSideUserNub = (0, $3660730fed410921$var$_isZeroOrPositive.default)(bubbleFromUserNubOffset);
        activityWithRendererTree.forEach(function(entriesWithSameSender) {
            var _entriesWithSameSende = $3660730fed410921$var$_slicedToArray(entriesWithSameSender, 1), _entriesWithSameSende2 = $3660730fed410921$var$_slicedToArray(_entriesWithSameSende[0], 1), firstActivity = _entriesWithSameSende2[0].activity;
            var renderAvatar = createAvatarRenderer({
                activity: firstActivity
            });
            entriesWithSameSender.forEach(function(entriesWithSameSenderAndStatus, indexWithinSenderGroup) {
                var firstInSenderGroup = !indexWithinSenderGroup;
                var lastInSenderGroup = indexWithinSenderGroup === entriesWithSameSender.length - 1;
                entriesWithSameSenderAndStatus.forEach(function(_ref2, indexWithinSenderAndStatusGroup) {
                    var _activity$from;
                    var activity = _ref2.activity, renderActivity = _ref2.renderActivity;
                    // We only show the timestamp at the end of the sender group. But we always show the "Send failed, retry" prompt.
                    var firstInSenderAndStatusGroup = !indexWithinSenderAndStatusGroup;
                    var key = getKeyByActivity(activity);
                    var lastInSenderAndStatusGroup = indexWithinSenderAndStatusGroup === entriesWithSameSenderAndStatus.length - 1;
                    var renderActivityStatus = createActivityStatusRenderer({
                        activity: activity,
                        nextVisibleActivity: undefined
                    });
                    var topSideNub = ((_activity$from = activity.from) === null || _activity$from === void 0 ? void 0 : _activity$from.role) === "user" ? topSideUserNub : topSideBotNub;
                    var showCallout; // Depending on the "showAvatarInGroup" setting, the avatar will render in different positions.
                    if (showAvatarInGroup === "sender") {
                        if (topSideNub) showCallout = firstInSenderGroup && firstInSenderAndStatusGroup;
                        else showCallout = lastInSenderGroup && lastInSenderAndStatusGroup;
                    } else if (showAvatarInGroup === "status") {
                        if (topSideNub) showCallout = firstInSenderAndStatusGroup;
                        else showCallout = lastInSenderAndStatusGroup;
                    } else showCallout = true;
                    renderingElements.push({
                        activity: activity,
                        // After the element is mounted, set it to activityElementsRef.
                        callbackRef: function callbackRef(activityElement) {
                            activityElement ? activityElementMapRef.current.set(key, activityElement) : activityElementMapRef.current.delete(key);
                        },
                        // "hideTimestamp" is a render-time parameter for renderActivityStatus().
                        // If true, it will hide the timestamp, but it will continue to show the
                        // retry prompt. And show the screen reader version of the timestamp.
                        hideTimestamp: hideAllTimestamps || indexWithinSenderAndStatusGroup !== entriesWithSameSenderAndStatus.length - 1,
                        key: key,
                        renderActivity: renderActivity,
                        renderActivityStatus: renderActivityStatus,
                        renderAvatar: renderAvatar,
                        showCallout: showCallout
                    });
                });
            });
        });
        return renderingElements;
    }, [
        activityElementMapRef,
        activityWithRendererTree,
        bubbleFromUserNubOffset,
        bubbleNubOffset,
        createActivityStatusRenderer,
        createAvatarRenderer,
        getKeyByActivity,
        hideAllTimestamps,
        showAvatarInGroup
    ]);
    var scrollToBottomScrollTo = (0, $YbbaU.default)();
    var scrollToBottomScrollToEnd = (0, $ijKjl.default)();
    var scrollTo = (0, $3660730fed410921$var$_react.useCallback)(function(position) {
        var _ref3 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {}, _ref3$behavior = _ref3.behavior, behavior = _ref3$behavior === void 0 ? "auto" : _ref3$behavior;
        if (!position) throw new Error('botframework-webchat: First argument passed to "useScrollTo" must be a ScrollPosition object.');
        var activityId = position.activityID, scrollTop = position.scrollTop;
        if (typeof scrollTop !== "undefined") scrollToBottomScrollTo(scrollTop, {
            behavior: behavior
        });
        else if (typeof activityId !== "undefined") {
            var _activityElementMapRe;
            var activityBoundingBoxElement = (_activityElementMapRe = activityElementMapRef.current.get(getKeyByActivityId(activityId))) === null || _activityElementMapRe === void 0 ? void 0 : _activityElementMapRe.querySelector(".webchat__basic-transcript__activity-active-descendant");
            var scrollableElement = rootElementRef.current.querySelector(".webchat__basic-transcript__scrollable");
            if (scrollableElement && activityBoundingBoxElement) {
                // ESLint conflict with TypeScript. The result of getClientRects() is not an Array but DOMRectList, and cannot be destructured.
                // eslint-disable-next-line prefer-destructuring
                var activityBoundingBoxElementClientRect = activityBoundingBoxElement.getClientRects()[0]; // ESLint conflict with TypeScript. The result of getClientRects() is not an Array but DOMRectList, and cannot be destructured.
                // eslint-disable-next-line prefer-destructuring
                var scrollableElementClientRect = scrollableElement.getClientRects()[0]; // If either the activity or the transcript scrollable is not on DOM, we will not scroll the view.
                if (activityBoundingBoxElementClientRect && scrollableElementClientRect) {
                    var activityHeight = activityBoundingBoxElementClientRect.height, activityY = activityBoundingBoxElementClientRect.y;
                    var scrollableHeight = scrollableElementClientRect.height;
                    var activityOffsetTop = activityY + scrollableElement.scrollTop;
                    var _scrollTop = Math.min(activityOffsetTop, activityOffsetTop - scrollableHeight + activityHeight);
                    scrollToBottomScrollTo(_scrollTop, {
                        behavior: behavior
                    });
                }
            }
        }
    }, [
        activityElementMapRef,
        getKeyByActivityId,
        rootElementRef,
        scrollToBottomScrollTo
    ]);
    var scrollToEnd = (0, $3660730fed410921$var$_react.useCallback)(function() {
        return scrollToBottomScrollToEnd({
            behavior: "smooth"
        });
    }, [
        scrollToBottomScrollToEnd
    ]);
    var scrollRelative = (0, $3660730fed410921$var$_react.useCallback)(function(direction) {
        var _ref4 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {}, displacement = _ref4.displacement;
        var rootElement = rootElementRef.current;
        if (!rootElement) return;
        var scrollable = rootElement.querySelector(".webchat__basic-transcript__scrollable");
        var nextScrollTop;
        if (typeof displacement === "number") // eslint-disable-next-line no-magic-numbers
        nextScrollTop = scrollable.scrollTop + (direction === "down" ? 1 : -1) * displacement;
        else // eslint-disable-next-line no-magic-numbers
        nextScrollTop = scrollable.scrollTop + (direction === "down" ? 1 : -1) * scrollable.offsetHeight;
        scrollTo({
            scrollTop: Math.max(0, Math.min(scrollable.scrollHeight - scrollable.offsetHeight, nextScrollTop))
        }, {
            behavior: "smooth"
        });
    }, [
        rootElementRef,
        scrollTo
    ]); // Since there could be multiple instances of <BasicTranscript> inside the <Composer>, when the developer calls `scrollXXX`, we need to call it on all instances.
    // We call `useRegisterScrollXXX` to register a callback function, the `useScrollXXX` will multiplex the call into each instance of <BasicTranscript>.
    (0, $3660730fed410921$var$_useRegisterScrollTo.default)(scrollTo);
    (0, $3660730fed410921$var$_useRegisterScrollToEnd.default)(scrollToEnd);
    (0, $3660730fed410921$var$_useRegisterScrollRelative.default)(scrollRelative);
    var markActivityKeyAsRead = $3660730fed410921$var$useMarkActivityKeyAsRead();
    var dispatchScrollPositionWithActivityId = (0, $3660730fed410921$var$_useDispatchScrollPosition.default)(); // TODO: [P2] We should use IntersectionObserver to track what activity is in the scrollable.
    //            However, IntersectionObserver is not available on IE11, we need to make a limited polyfill in React style.
    var handleScrollPosition = (0, $3660730fed410921$var$_react.useCallback)(function(_ref5) {
        var _ref6;
        var scrollTop = _ref5.scrollTop;
        var rootElement = rootElementRef.current;
        if (!rootElement) return;
        var scrollableElement = rootElement.querySelector(".webchat__basic-transcript__scrollable"); // "getClientRects()" is not returning an array, thus, it is not destructurable.
        // eslint-disable-next-line prefer-destructuring
        var scrollableElementClientRect = scrollableElement.getClientRects()[0]; // If the scrollable is not mounted, we cannot measure which activity is in view. Thus, we will not fire any events.
        if (!scrollableElementClientRect) return;
        var scrollableClientBottom = scrollableElementClientRect.bottom; // Find the activity just above scroll view bottom.
        // If the scroll view is already on top, get the first activity.
        var activityElements = Array.from(activityElementMapRef.current.entries());
        var activityKeyJustAboveScrollBottom = (_ref6 = scrollableElement.scrollTop ? activityElements.reverse() // Add subpixel tolerance
        .find(function(_ref7) {
            var _ref8 = $3660730fed410921$var$_slicedToArray(_ref7, 2), element = _ref8[1];
            // "getClientRects()" is not returning an array, thus, it is not destructurable.
            // eslint-disable-next-line prefer-destructuring
            var elementClientRect = element.getClientRects()[0]; // If the activity is not attached to DOM tree, we should not count it as "bottommost visible activity", as it is not visible.
            return elementClientRect && elementClientRect.bottom < scrollableClientBottom + 1;
        }) : activityElements[0]) === null || _ref6 === void 0 ? void 0 : _ref6[0]; // When the end-user slowly scrolling the view down, we will mark activity as read when the message fully appear on the screen.
        activityKeyJustAboveScrollBottom && markActivityKeyAsRead(activityKeyJustAboveScrollBottom);
        if (dispatchScrollPositionWithActivityId) {
            var activity = getActivityByKey(activityKeyJustAboveScrollBottom);
            dispatchScrollPositionWithActivityId($3660730fed410921$var$_objectSpread($3660730fed410921$var$_objectSpread({}, activity ? {
                activityID: activity.id
            } : {}), {}, {
                scrollTop: scrollTop
            }));
        }
    }, [
        activityElementMapRef,
        dispatchScrollPositionWithActivityId,
        getActivityByKey,
        markActivityKeyAsRead,
        rootElementRef
    ]);
    (0, $l5G4z.default)(handleScrollPosition);
    var handleTranscriptKeyDown = (0, $3660730fed410921$var$_react.useCallback)(function(event) {
        var target = event.target;
        var fromEndOfTranscriptIndicator = target === terminatorRef.current;
        var fromTranscript = target === event.currentTarget;
        if (!fromEndOfTranscriptIndicator && !fromTranscript) return;
        var handled = true;
        switch(event.key){
            case "ArrowDown":
                focusRelativeActivity(fromEndOfTranscriptIndicator ? 0 : 1);
                break;
            case "ArrowUp":
                // eslint-disable-next-line no-magic-numbers
                focusRelativeActivity(fromEndOfTranscriptIndicator ? 0 : -1);
                break;
            case "End":
                focusRelativeActivity(Infinity);
                break;
            case "Enter":
                // This is capturing plain ENTER.
                // When screen reader is not running, or screen reader is running outside of scan mode, the ENTER key will be captured here.
                if (!fromEndOfTranscriptIndicator) {
                    var _activityElementMapRe2, _tabbableElements$;
                    var body = (_activityElementMapRe2 = activityElementMapRef.current.get(focusedActivityKeyRef.current)) === null || _activityElementMapRe2 === void 0 ? void 0 : _activityElementMapRe2.querySelector(".webchat__basic-transcript__activity-body");
                    (_tabbableElements$ = (0, $3660730fed410921$var$_tabbableElements.default)(body)[0]) === null || _tabbableElements$ === void 0 || _tabbableElements$.focus();
                }
                break;
            case "Escape":
                focus("sendBoxWithoutKeyboard");
                break;
            case "Home":
                focusRelativeActivity(-Infinity);
                break;
            default:
                handled = false;
                break;
        }
        if (handled) {
            event.preventDefault(); // If a custom HTML control wants to handle up/down arrow, we will prevent them from listening to this event to prevent bugs due to handling arrow keys twice.
            event.stopPropagation();
        }
    }, [
        activityElementMapRef,
        focus,
        focusedActivityKeyRef,
        focusRelativeActivity,
        terminatorRef
    ]);
    var handleTranscriptKeyDownCapture = (0, $3660730fed410921$var$_react.useCallback)(function(event) {
        var altKey = event.altKey, ctrlKey = event.ctrlKey, key = event.key, metaKey = event.metaKey, target = event.target;
        if (altKey || ctrlKey && key !== "v" || metaKey || !(0, $3660730fed410921$var$_inputtableKey.default)(key) && key !== "Backspace") // Ignore if one of the utility key (except SHIFT) is pressed
        // E.g. CTRL-C on a link in one of the message should not jump to chat box
        // E.g. "A" or "Backspace" should jump to chat box
        return;
         // Send keystrokes to send box if we are focusing on the transcript or terminator.
        if (target === event.currentTarget || target === terminatorRef.current) {
            event.stopPropagation();
            focus("sendBox");
        }
    }, [
        focus
    ]);
    (0, $3660730fed410921$var$_useRegisterFocusTranscript.default)((0, $3660730fed410921$var$_react.useCallback)(function() {
        return focusByActivityKey(undefined);
    }, [
        focusByActivityKey
    ])); // When the focusing activity has changed, dispatch an event to observers of "useObserveTranscriptFocus".
    var dispatchTranscriptFocusByActivityKey = (0, $3660730fed410921$var$_useDispatchTranscriptFocusByActivityKey.default)(); // Dispatch a "transcript focus" event based on user selection.
    // We should not dispatch "transcript focus" when a new activity come. Although the selection change, it is not initiated from the user.
    (0, $3660730fed410921$var$_react.useMemo)(function() {
        return dispatchTranscriptFocusByActivityKey(focusedExplicitly ? focusedActivityKey : undefined);
    }, [
        dispatchTranscriptFocusByActivityKey,
        focusedActivityKey,
        focusedExplicitly
    ]); // When the transcript is being focused on, we should dispatch a "transcriptfocus" event.
    var handleFocus = (0, $3660730fed410921$var$_react.useCallback)(// It means, tries to focus on anything.
    function(_ref9) {
        var currentTarget = _ref9.currentTarget, target = _ref9.target;
        return target === currentTarget && focusByActivityKey(true, false);
    }, [
        focusByActivityKey
    ]); // This is required by IE11.
    // When the user clicks on and empty space (a.k.a. filler) in an empty transcript, IE11 says the focus is on the <div className="filler">,
    // despite the fact there are no "tabIndex" attributes set on the filler.
    // We need to artificially send the focus back to the transcript.
    var handleFocusFiller = (0, $3660730fed410921$var$_react.useCallback)(function() {
        return focusByActivityKey(undefined);
    }, [
        focusByActivityKey
    ]); // When focus into the transcript using TAB/SHIFT-TAB, scroll the focused activity into view.
    (0, $3660730fed410921$var$_useObserveFocusVisible.default)(rootElementRef, (0, $3660730fed410921$var$_react.useCallback)(function() {
        return focusByActivityKey(undefined);
    }, [
        focusByActivityKey
    ]));
    return /*#__PURE__*/ $3660730fed410921$var$_react.default.createElement("div", {
        // Although Android TalkBack 12.1 does not support `aria-activedescendant`, when used, it become buggy and will narrate content twice.
        // We are disabling `aria-activedescendant` for Android. See <ActivityRow> for details.
        "aria-activedescendant": $gLt36.android ? undefined : activeDescendantId,
        "aria-label": transcriptAriaLabel,
        className: (0, $3660730fed410921$var$_classnames.default)("webchat__basic-transcript", basicTranscriptStyleSet + "", rootClassName, (className || "") + ""),
        dir: direction,
        onFocus: handleFocus,
        onKeyDown: handleTranscriptKeyDown,
        onKeyDownCapture: handleTranscriptKeyDownCapture,
        ref: callbackRef // "aria-activedescendant" will only works with a number of roles and it must be explicitly set.
        ,
        role: "group" // For up/down arrow key navigation across activities, this component must be included in the tab sequence.
        ,
        tabIndex: 0
    }, /*#__PURE__*/ $3660730fed410921$var$_react.default.createElement($3660730fed410921$var$_LiveRegionTranscript.default, {
        activityElementMapRef: activityElementMapRef
    }), /*#__PURE__*/ $3660730fed410921$var$_react.default.createElement($3660730fed410921$var$InternalTranscriptScrollable, {
        onFocusFiller: handleFocusFiller,
        terminatorRef: terminatorRef
    }, renderingElements.map(function(_ref10) {
        var activity = _ref10.activity, callbackRef = _ref10.callbackRef, hideTimestamp = _ref10.hideTimestamp, key = _ref10.key, renderActivity = _ref10.renderActivity, renderActivityStatus = _ref10.renderActivityStatus, renderAvatar = _ref10.renderAvatar, showCallout = _ref10.showCallout;
        return /*#__PURE__*/ $3660730fed410921$var$_react.default.createElement($3660730fed410921$var$_ActivityRow.default, {
            activity: activity,
            key: key,
            ref: callbackRef
        }, renderActivity({
            hideTimestamp: hideTimestamp,
            renderActivityStatus: renderActivityStatus,
            renderAvatar: renderAvatar,
            showCallout: showCallout
        }));
    })), !!renderingElements.length && /*#__PURE__*/ $3660730fed410921$var$_react.default.createElement($3660730fed410921$var$_react.Fragment, null, /*#__PURE__*/ $3660730fed410921$var$_react.default.createElement($3660730fed410921$var$_FocusRedirector.default, {
        redirectRef: rootElementRef
    }), /*#__PURE__*/ $3660730fed410921$var$_react.default.createElement("div", {
        "aria-labelledby": terminatorLabelId,
        className: "webchat__basic-transcript__terminator",
        ref: terminatorRef,
        role: "note",
        tabIndex: 0
    }, /*#__PURE__*/ $3660730fed410921$var$_react.default.createElement("div", {
        className: "webchat__basic-transcript__terminator-body"
    }, /*#__PURE__*/ $3660730fed410921$var$_react.default.createElement("div", {
        className: "webchat__basic-transcript__terminator-text",
        id: terminatorLabelId
    }, terminatorText)))), /*#__PURE__*/ $3660730fed410921$var$_react.default.createElement("div", {
        className: "webchat__basic-transcript__focus-indicator"
    }));
});
$3660730fed410921$var$InternalTranscript.defaultProps = {
    className: ""
};
$3660730fed410921$var$InternalTranscript.displayName = "InternalTranscript";
$3660730fed410921$var$InternalTranscript.propTypes = {
    // PropTypes cannot validate precisely with its TypeScript counterpart.
    // @ts-ignore
    activityElementMapRef: $3660730fed410921$var$_propTypes.default.shape({
        current: $3660730fed410921$var$_propTypes.default.instanceOf(Map)
    }).isRequired,
    className: $3660730fed410921$var$_propTypes.default.string
};
// Separating high-frequency hooks to improve performance.
var $3660730fed410921$var$InternalTranscriptScrollable = function InternalTranscriptScrollable(_ref11) {
    var children = _ref11.children, onFocusFiller = _ref11.onFocusFiller, terminatorRef = _ref11.terminatorRef;
    var _useStyleSet3 = (0, $3660730fed410921$var$_useStyleSet5.default)(), _useStyleSet4 = $3660730fed410921$var$_slicedToArray(_useStyleSet3, 1), activitiesStyleSet = _useStyleSet4[0].activities;
    var _useAnimatingToEnd = (0, $29Opo.default)(), _useAnimatingToEnd2 = $3660730fed410921$var$_slicedToArray(_useAnimatingToEnd, 1), animatingToEnd = _useAnimatingToEnd2[0];
    var _useAtEnd = (0, $kTzTj.default)(), _useAtEnd2 = $3660730fed410921$var$_slicedToArray(_useAtEnd, 1), atEnd = _useAtEnd2[0];
    var _useActivityKeysByRea = $3660730fed410921$var$useActivityKeysByRead(), _useActivityKeysByRea2 = $3660730fed410921$var$_slicedToArray(_useActivityKeysByRea, 2), unreadActivityKeys = _useActivityKeysByRea2[1];
    var _useSticky = (0, $fL6wD.default)(), _useSticky2 = $3660730fed410921$var$_slicedToArray(_useSticky, 1), sticky = _useSticky2[0];
    var _useStyleOptions3 = $3660730fed410921$var$useStyleOptions(), _useStyleOptions4 = $3660730fed410921$var$_slicedToArray(_useStyleOptions3, 1), styleOptions = _useStyleOptions4[0];
    var focusByActivityKey = (0, $3660730fed410921$var$_useFocusByActivityKey.default)();
    var localize = $3660730fed410921$var$useLocalizer();
    var markActivityKeyAsRead = $3660730fed410921$var$useMarkActivityKeyAsRead();
    var markAllAsAcknowledged = $3660730fed410921$var$useMarkAllAsAcknowledged();
    var scrollToEnd = (0, $ijKjl.default)();
    var prevSticky = (0, $3660730fed410921$var$_usePrevious.default)(sticky);
    var transcriptRoleDescription = localize("TRANSCRIPT_ARIA_ROLE_ALT");
    var stickyChangedToTrue = prevSticky !== sticky && sticky; // Acknowledged means either:
    // 1. The user sent a message
    //    - We don't need a condition here. When Web Chat sends the user's message, it will scroll to bottom, and it will trigger condition 2 below.
    // 2. The user scroll to the bottom of the transcript, from a non-bottom scroll position
    //    - If the transcript is already at the bottom, the user needs to scroll up and then go back down
    //    - What happens if we are relaxing "scrolled from a non-bottom scroll position":
    //      1. The condition will become solely "at the bottom of the transcript"
    //      2. Auto-scroll will always scroll the transcript to the bottom
    //      3. Web Chat will always acknowledge all activities as it is at the bottom
    //      4. Acknowledge flag become useless
    //      5. Therefore, even the developer set "pause after 3 activities", if activities are coming in at a slow pace (not batched in a single render)
    //         Web Chat will keep scrolling and not snapped/paused
    // Note: When Web Chat is loaded, there are no activities acknowledged. We need to assume all arriving activities are acknowledged until end-user sends their first activity.
    //       Activities loaded initially could be from conversation history. Without assuming acknowledgement, Web Chat will not scroll initially (as everything is not acknowledged).
    //       It would be better if the chat adapter should let Web Chat know if the activity is loaded from history or not.
    // TODO: [P2] #3670 Move the "conversation history acknowledgement" logic mentioned above to polyfill of chat adapters.
    //       1. Chat adapter should send "acknowledged" as part of "channelData"
    //       2. If "acknowledged" is "undefined", we set it to:
    //          a. true, if there are no egress activities yet
    //          b. Otherwise, false
    (0, $3660730fed410921$var$_react.useMemo)(function() {
        return stickyChangedToTrue && // TODO: [P2] Both `markActivityKeyAsRead` and `markAllAsAcknowledged` hook are setters of useState.
        //       This means, in a render loop, we will be calling setter and will cause another re-render.
        //       This is not trivial but we should think if there is a way to avoid this.
        markAllAsAcknowledged();
    }, [
        markAllAsAcknowledged,
        stickyChangedToTrue
    ]);
    var _useActivityTreeWithR3 = (0, $3660730fed410921$var$_useActivityTreeWithRenderer.default)({
        flat: true
    }), _useActivityTreeWithR4 = $3660730fed410921$var$_slicedToArray(_useActivityTreeWithR3, 1), flattenedActivityTreeWithRenderer = _useActivityTreeWithR4[0];
    var getKeyByActivity = $3660730fed410921$var$useGetKeyByActivity();
    var renderingActivityKeys = (0, $3660730fed410921$var$_react.useMemo)(function() {
        return flattenedActivityTreeWithRenderer.map(function(_ref12) {
            var activity = _ref12.activity;
            return getKeyByActivity(activity);
        });
    }, [
        flattenedActivityTreeWithRenderer,
        getKeyByActivity
    ]);
    var renderingActivityKeysRef = (0, $3660730fed410921$var$_useValueRef.default)(renderingActivityKeys); // To prevent flashy button, we are not waiting for another render loop to update the `[readActivityKeys, unreadActivityKeys]` state.
    // Instead, we are building the next one in this `useMemo` call.
    var nextUnreadActivityKeys = (0, $3660730fed410921$var$_react.useMemo)(function() {
        // This code need to be careful reviewed as it will cause another render. The code should be converging.
        // After we call `markActivityKeyAsRead`, everything will be read and nothing will be unread.
        // That means, in next render, `unreadActivityKeys` will be emptied and the `markActivityKeyAsRead` will not get called again.
        if (sticky && unreadActivityKeys.length) {
            markActivityKeyAsRead(unreadActivityKeys[unreadActivityKeys.length - 1]);
            return [];
        }
        return unreadActivityKeys;
    }, [
        markActivityKeyAsRead,
        sticky,
        unreadActivityKeys
    ]);
    var nextUnreadActivityKeysRef = (0, $3660730fed410921$var$_useValueRef.default)(nextUnreadActivityKeys); // If we are rendering anything that is unread, we should show the "New messages" button.
    // Not everything in the `unreadActivityKeys` are rendered, say, bot typing indicator.
    // We should not show the "New messages" button for bot typing indicator as it will confuse the user.
    var unread = (0, $3660730fed410921$var$_react.useMemo)(function() {
        return nextUnreadActivityKeys.some(function(key) {
            return renderingActivityKeys.includes(key);
        });
    }, [
        renderingActivityKeys,
        nextUnreadActivityKeys
    ]);
    var handleScrollToEndButtonClick = (0, $3660730fed410921$var$_react.useCallback)(function() {
        scrollToEnd({
            behavior: "smooth"
        });
        var renderingActivityKeys = renderingActivityKeysRef.current; // After the "New message" button is clicked, focus on the first unread activity which will be rendered.
        var firstUnreadRenderingActivityKey = nextUnreadActivityKeysRef.current.find(function(key) {
            return renderingActivityKeys.includes(key);
        });
        if (firstUnreadRenderingActivityKey) focusByActivityKey(firstUnreadRenderingActivityKey);
        else {
            var _terminatorRef$curren;
            // If no unread activity, send the focus to the terminator block.
            (_terminatorRef$curren = terminatorRef.current) === null || _terminatorRef$curren === void 0 || _terminatorRef$curren.focus();
        }
    }, [
        focusByActivityKey,
        nextUnreadActivityKeysRef,
        renderingActivityKeysRef,
        scrollToEnd,
        terminatorRef
    ]);
    var renderScrollToEndButton = $3660730fed410921$var$useCreateScrollToEndButtonRenderer()({
        atEnd: animatingToEnd || atEnd || sticky,
        styleOptions: styleOptions,
        unread: unread
    });
    var hasAnyChild = !!$3660730fed410921$var$_react.default.Children.count(children);
    return /*#__PURE__*/ $3660730fed410921$var$_react.default.createElement($3660730fed410921$var$_react.default.Fragment, null, renderScrollToEndButton && renderScrollToEndButton({
        onClick: handleScrollToEndButtonClick
    }), hasAnyChild && /*#__PURE__*/ $3660730fed410921$var$_react.default.createElement($3660730fed410921$var$_FocusRedirector.default, {
        redirectRef: terminatorRef
    }), /*#__PURE__*/ $3660730fed410921$var$_react.default.createElement($13VWp.default, {
        className: "webchat__basic-transcript__scrollable"
    }, /*#__PURE__*/ $3660730fed410921$var$_react.default.createElement("div", {
        "aria-hidden": true,
        className: "webchat__basic-transcript__filler",
        onFocus: onFocusFiller
    }), hasAnyChild && /*#__PURE__*/ $3660730fed410921$var$_react.default.createElement("section", {
        "aria-roledescription": transcriptRoleDescription,
        className: (0, $3660730fed410921$var$_classnames.default)(activitiesStyleSet + "", "webchat__basic-transcript__transcript"),
        role: "feed"
    }, children), /*#__PURE__*/ $3660730fed410921$var$_react.default.createElement($3660730fed410921$var$_BasicTypingIndicator.default, null)));
};
$3660730fed410921$var$InternalTranscriptScrollable.propTypes = {
    children: $3660730fed410921$var$_propTypes.default.any.isRequired,
    onFocusFiller: $3660730fed410921$var$_propTypes.default.func.isRequired,
    terminatorRef: $3660730fed410921$var$_propTypes.default.any.isRequired
};
// "scroller" is the auto-scroll limiter, a.k.a. auto scroll snap.
var $3660730fed410921$var$useScroller = function useScroller(activityElementMapRef) {
    var _useActivityKeys = $3660730fed410921$var$useActivityKeys(), _useActivityKeys2 = $3660730fed410921$var$_slicedToArray(_useActivityKeys, 1), activityKeys = _useActivityKeys2[0];
    var _useLastAcknowledgedA = $3660730fed410921$var$useLastAcknowledgedActivityKey(), _useLastAcknowledgedA2 = $3660730fed410921$var$_slicedToArray(_useLastAcknowledgedA, 1), lastAcknowledgedActivityKey = _useLastAcknowledgedA2[0];
    var _useStyleOptions5 = $3660730fed410921$var$useStyleOptions(), _useStyleOptions6 = $3660730fed410921$var$_slicedToArray(_useStyleOptions5, 1), styleOptions = _useStyleOptions6[0];
    var activityKeysRef = (0, $3660730fed410921$var$_useValueRef.default)(activityKeys);
    var lastAcknowledgedActivityKeyRef = (0, $3660730fed410921$var$_useValueRef.default)(lastAcknowledgedActivityKey);
    var styleOptionsRef = (0, $3660730fed410921$var$_useValueRef.default)(styleOptions);
    return (0, $3660730fed410921$var$_react.useCallback)(function(_ref13) {
        var offsetHeight = _ref13.offsetHeight, scrollTop = _ref13.scrollTop;
        var _styleOptionsRef$curr = styleOptionsRef.current, autoScrollSnapOnActivity = _styleOptionsRef$curr.autoScrollSnapOnActivity, autoScrollSnapOnActivityOffset = _styleOptionsRef$curr.autoScrollSnapOnActivityOffset, autoScrollSnapOnPage = _styleOptionsRef$curr.autoScrollSnapOnPage, autoScrollSnapOnPageOffset = _styleOptionsRef$curr.autoScrollSnapOnPageOffset;
        var patchedAutoScrollSnapOnActivity = typeof autoScrollSnapOnActivity === "number" ? Math.max(0, autoScrollSnapOnActivity) : autoScrollSnapOnActivity ? 1 : 0;
        var patchedAutoScrollSnapOnPage = typeof autoScrollSnapOnPage === "number" ? Math.max(0, Math.min(1, autoScrollSnapOnPage)) : autoScrollSnapOnPage ? 1 : 0;
        var patchedAutoScrollSnapOnActivityOffset = typeof autoScrollSnapOnActivityOffset === "number" ? autoScrollSnapOnActivityOffset : 0;
        var patchedAutoScrollSnapOnPageOffset = typeof autoScrollSnapOnPageOffset === "number" ? autoScrollSnapOnPageOffset : 0;
        if (patchedAutoScrollSnapOnActivity || patchedAutoScrollSnapOnPage) {
            var activityElementMap = activityElementMapRef.current;
            var _activityKeys = activityKeysRef.current;
            var _lastAcknowledgedActivityKey = lastAcknowledgedActivityKeyRef.current;
            var values = [];
            var lastAcknowledgedActivityKeyIndex = _activityKeys.indexOf(_lastAcknowledgedActivityKey);
            if (~lastAcknowledgedActivityKeyIndex) {
                // The activity that we acknowledged could be not rendered, such as post back activity.
                // When calculating scroll snap, we can only base on the first unacknowledged-and-rendering activity.
                var renderingActivityKeys = Array.from(activityElementMap.keys());
                var firstUnacknowledgedActivityElementIndex = -1;
                var _iterator = $3660730fed410921$var$_createForOfIteratorHelper(_activityKeys.slice(0, lastAcknowledgedActivityKeyIndex + 1).reverse()), _step;
                try {
                    for(_iterator.s(); !(_step = _iterator.n()).done;){
                        var acknowledgedActivityKey = _step.value;
                        var index = renderingActivityKeys.indexOf(acknowledgedActivityKey);
                        if (~index) {
                            if (index !== renderingActivityKeys.length - 1) firstUnacknowledgedActivityElementIndex = index + 1;
                            break;
                        }
                    }
                } catch (err) {
                    _iterator.e(err);
                } finally{
                    _iterator.f();
                }
                if (~firstUnacknowledgedActivityElementIndex) {
                    var activityElements = Array.from(activityElementMap.values());
                    if (patchedAutoScrollSnapOnActivity) {
                        // Gets the activity element which we should snap to.
                        var nthUnacknowledgedActivityElement = activityElements[firstUnacknowledgedActivityElementIndex + patchedAutoScrollSnapOnActivity - 1];
                        if (nthUnacknowledgedActivityElement) {
                            var nthUnacknowledgedActivityBoundingBoxElement = nthUnacknowledgedActivityElement === null || nthUnacknowledgedActivityElement === void 0 ? void 0 : nthUnacknowledgedActivityElement.querySelector(".webchat__basic-transcript__activity-active-descendant");
                            var nthUnacknowledgedActivityOffsetTop = nthUnacknowledgedActivityElement.offsetTop + nthUnacknowledgedActivityBoundingBoxElement.offsetTop;
                            values.push(nthUnacknowledgedActivityOffsetTop + nthUnacknowledgedActivityBoundingBoxElement.offsetHeight - offsetHeight - scrollTop + patchedAutoScrollSnapOnActivityOffset);
                        }
                    }
                    if (patchedAutoScrollSnapOnPage) {
                        var firstUnacknowledgedActivityElement = activityElements[+firstUnacknowledgedActivityElementIndex];
                        var firstUnacknowledgedActivityBoundingBoxElement = firstUnacknowledgedActivityElement.querySelector(".webchat__basic-transcript__activity-active-descendant");
                        var firstUnacknowledgedActivityOffsetTop = firstUnacknowledgedActivityElement.offsetTop + firstUnacknowledgedActivityBoundingBoxElement.offsetTop;
                        values.push(firstUnacknowledgedActivityOffsetTop - scrollTop - offsetHeight * (1 - patchedAutoScrollSnapOnPage) + patchedAutoScrollSnapOnPageOffset);
                    }
                }
            }
            return Math.min.apply(Math, values);
        }
        return Infinity;
    }, [
        activityElementMapRef,
        activityKeysRef,
        lastAcknowledgedActivityKeyRef,
        styleOptionsRef
    ]);
};
var $3660730fed410921$var$BasicTranscript = function BasicTranscript(_ref14) {
    var className = _ref14.className;
    var activityElementMapRef = (0, $3660730fed410921$var$_react.useRef)(new Map());
    var containerRef = (0, $3660730fed410921$var$_react.useRef)();
    var scroller = $3660730fed410921$var$useScroller(activityElementMapRef);
    return /*#__PURE__*/ $3660730fed410921$var$_react.default.createElement($3660730fed410921$var$_TranscriptFocusComposer.default, {
        containerRef: containerRef
    }, /*#__PURE__*/ $3660730fed410921$var$_react.default.createElement($jJkLv.default, {
        scroller: scroller
    }, /*#__PURE__*/ $3660730fed410921$var$_react.default.createElement($3660730fed410921$var$_KeyboardHelp.default, null), /*#__PURE__*/ $3660730fed410921$var$_react.default.createElement($3660730fed410921$var$InternalTranscript, {
        activityElementMapRef: activityElementMapRef,
        className: className,
        ref: containerRef
    })));
};
$3660730fed410921$var$BasicTranscript.defaultProps = {
    className: ""
};
$3660730fed410921$var$BasicTranscript.propTypes = {
    className: $3660730fed410921$var$_propTypes.default.string
};
var $3660730fed410921$var$_default = $3660730fed410921$var$BasicTranscript;
module.exports.default = $3660730fed410921$var$_default;

});
parcelRequire.register("4CrIE", function(module, exports) {

$parcel$export(module.exports, "Composer", () => (parcelRequire("jJkLv")).default);
$parcel$export(module.exports, "Panel", () => (parcelRequire("13VWp")).default);
$parcel$export(module.exports, "useAnimatingToEnd", () => (parcelRequire("29Opo")).default);
$parcel$export(module.exports, "useAtEnd", () => (parcelRequire("kTzTj")).default);
$parcel$export(module.exports, "useObserveScrollPosition", () => (parcelRequire("l5G4z")).default);
$parcel$export(module.exports, "useScrollTo", () => (parcelRequire("YbbaU")).default);
$parcel$export(module.exports, "useScrollToEnd", () => (parcelRequire("ijKjl")).default);
$parcel$export(module.exports, "useSticky", () => (parcelRequire("fL6wD")).default);

var $8mCmk = parcelRequire("8mCmk");

var $dv8ws = parcelRequire("dv8ws");

var $DvL5R = parcelRequire("DvL5R");

var $jJkLv = parcelRequire("jJkLv");

var $HhFfQ = parcelRequire("HhFfQ");

var $13VWp = parcelRequire("13VWp");

var $jXKa9 = parcelRequire("jXKa9");

var $cwfkv = parcelRequire("cwfkv");

var $29Opo = parcelRequire("29Opo");

var $aVmwt = parcelRequire("aVmwt");

var $kTzTj = parcelRequire("kTzTj");

var $3k8Bz = parcelRequire("3k8Bz");

var $4DHYB = parcelRequire("4DHYB");

var $47d4H = parcelRequire("47d4H");

var $l5G4z = parcelRequire("l5G4z");

var $YbbaU = parcelRequire("YbbaU");

var $kkhU3 = parcelRequire("kkhU3");

var $ijKjl = parcelRequire("ijKjl");

var $iCZnZ = parcelRequire("iCZnZ");

var $2VoIm = parcelRequire("2VoIm");

var $fL6wD = parcelRequire("fL6wD");
var $35d03676fc7036ab$export$2e2bcd8739ae039 = (0, $DvL5R.default);
(0, $8mCmk.default)();

});
parcelRequire.register("8mCmk", function(module, exports) {

$parcel$export(module.exports, "default", () => $616e22278919a391$export$2e2bcd8739ae039);
/* global global:readonly, process:readonly */ /* eslint no-empty: ["error", { "allowEmptyCatch": true }] */ function $616e22278919a391$var$setMetaTag(name, content) {
    try {
        var _global = $parcel$global, document = _global.document;
        if (typeof document !== "undefined" && document.createElement && document.head && document.head.appendChild) {
            var meta = document.querySelector('html meta[name="'.concat(encodeURI(name), '"]')) || document.createElement("meta");
            meta.setAttribute("name", name);
            meta.setAttribute("content", content);
            document.head.appendChild(meta);
        }
    } catch (err) {}
}
function $616e22278919a391$export$2e2bcd8739ae039() {
    $616e22278919a391$var$setMetaTag("react-scroll-to-bottom:version", "4.2.0");
}

});

parcelRequire.register("dv8ws", function(module, exports) {

$parcel$export(module.exports, "default", () => $9d44c8008b293ccb$export$2e2bcd8739ae039);

var $7SyKb = parcelRequire("7SyKb");

var $5D5HB = parcelRequire("5D5HB");

var $iqqHp = parcelRequire("iqqHp");

var $eO7Kz = parcelRequire("eO7Kz");

var $ijKjl = parcelRequire("ijKjl");

var $fL6wD = parcelRequire("fL6wD");

var $6vdhG = parcelRequire("6vdhG");
var $9d44c8008b293ccb$var$ROOT_STYLE = {
    backgroundColor: "rgba(0, 0, 0, .2)",
    borderRadius: 10,
    borderWidth: 0,
    bottom: 5,
    cursor: "pointer",
    height: 20,
    outline: 0,
    position: "absolute",
    right: 20,
    width: 20,
    "&:hover": {
        backgroundColor: "rgba(0, 0, 0, .4)"
    },
    "&:active": {
        backgroundColor: "rgba(0, 0, 0, .6)"
    }
};
var $9d44c8008b293ccb$var$AutoHideFollowButton = function AutoHideFollowButton(_ref) {
    var children = _ref.children, className = _ref.className;
    var _useSticky = (0, $fL6wD.default)(), _useSticky2 = (0, (/*@__PURE__*/$parcel$interopDefault($7SyKb)))(_useSticky, 1), sticky = _useSticky2[0];
    var rootCSS = (0, $6vdhG.default)()($9d44c8008b293ccb$var$ROOT_STYLE);
    var scrollToEnd = (0, $ijKjl.default)();
    return !sticky && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eO7Kz))).createElement("button", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($5D5HB)))(rootCSS, (className || "") + ""),
        onClick: scrollToEnd,
        type: "button"
    }, children);
};
$9d44c8008b293ccb$var$AutoHideFollowButton.defaultProps = {
    children: undefined,
    className: ""
};
$9d44c8008b293ccb$var$AutoHideFollowButton.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($iqqHp))).any,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($iqqHp))).string
};
var $9d44c8008b293ccb$export$2e2bcd8739ae039 = $9d44c8008b293ccb$var$AutoHideFollowButton;

});
parcelRequire.register("7SyKb", function(module, exports) {

var $bUrIu = parcelRequire("bUrIu");

var $hhctX = parcelRequire("hhctX");

var $gANtj = parcelRequire("gANtj");

var $g6mDn = parcelRequire("g6mDn");
function $5bc886f6fab0f7c7$var$_slicedToArray(arr, i) {
    return $bUrIu(arr) || $hhctX(arr, i) || $gANtj(arr, i) || $g6mDn();
}
module.exports = $5bc886f6fab0f7c7$var$_slicedToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRequire.register("bUrIu", function(module, exports) {

var $6jPy4 = parcelRequire("6jPy4");
function $8aba6ca0fb78de36$var$_arrayWithHoles(arr) {
    if ($6jPy4(arr)) return arr;
}
module.exports = $8aba6ca0fb78de36$var$_arrayWithHoles, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRequire.register("hhctX", function(module, exports) {

var $5XC68 = parcelRequire("5XC68");

var $aoWGW = parcelRequire("aoWGW");

var $lAVDG = parcelRequire("lAVDG");
function $c93db4ec31e6f21b$var$_iterableToArrayLimit(arr, i) {
    var _i = null == arr ? null : "undefined" != typeof $5XC68 && $aoWGW(arr) || arr["@@iterator"];
    if (null != _i) {
        var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1;
        try {
            if (_x = (_i = _i.call(arr)).next, 0 === i) {
                if (Object(_i) !== _i) return;
                _n = !1;
            } else for(; !(_n = (_s = _x.call(_i)).done) && ($lAVDG(_arr).call(_arr, _s.value), _arr.length !== i); _n = !0);
        } catch (err) {
            _d = !0, _e = err;
        } finally{
            try {
                if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return;
            } finally{
                if (_d) throw _e;
            }
        }
        return _arr;
    }
}
module.exports = $c93db4ec31e6f21b$var$_iterableToArrayLimit, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRequire.register("lAVDG", function(module, exports) {

module.exports = (parcelRequire("f2F0Z"));

});
parcelRequire.register("f2F0Z", function(module, exports) {

var $fLpgh = parcelRequire("fLpgh");
module.exports = $fLpgh;

});
parcelRequire.register("fLpgh", function(module, exports) {

var $5Hvo4 = parcelRequire("5Hvo4");
module.exports = $5Hvo4;

});
parcelRequire.register("5Hvo4", function(module, exports) {

var $bgO3H = parcelRequire("bgO3H");
module.exports = $bgO3H;

});
parcelRequire.register("bgO3H", function(module, exports) {

var $53bMe = parcelRequire("53bMe");

var $9VMWn = parcelRequire("9VMWn");
var $834804f2d5e2d30e$var$ArrayPrototype = Array.prototype;
module.exports = function(it) {
    var own = it.push;
    return it === $834804f2d5e2d30e$var$ArrayPrototype || $53bMe($834804f2d5e2d30e$var$ArrayPrototype, it) && own === $834804f2d5e2d30e$var$ArrayPrototype.push ? $9VMWn : own;
};

});
parcelRequire.register("9VMWn", function(module, exports) {
parcelRequire("9tw5L");

var $5zMeE = parcelRequire("5zMeE");
module.exports = $5zMeE("Array").push;

});
parcelRequire.register("9tw5L", function(module, exports) {
"use strict";

var $2iwSV = parcelRequire("2iwSV");

var $h90HQ = parcelRequire("h90HQ");

var $f8kjp = parcelRequire("f8kjp");

var $83Bmy = parcelRequire("83Bmy");

var $a99UF = parcelRequire("a99UF");

var $bSIUO = parcelRequire("bSIUO");
var $6e5fb74587e963c4$var$INCORRECT_TO_LENGTH = $bSIUO(function() {
    return [].push.call({
        length: 0x100000000
    }, 1) !== 4294967297;
});
// V8 and Safari <= 15.4, FF < 23 throws InternalError
// https://bugs.chromium.org/p/v8/issues/detail?id=12681
var $6e5fb74587e963c4$var$properErrorOnNonWritableLength = function() {
    try {
        // eslint-disable-next-line es/no-object-defineproperty -- safe
        Object.defineProperty([], "length", {
            writable: false
        }).push();
    } catch (error) {
        return error instanceof TypeError;
    }
};
var $6e5fb74587e963c4$var$FORCED = $6e5fb74587e963c4$var$INCORRECT_TO_LENGTH || !$6e5fb74587e963c4$var$properErrorOnNonWritableLength();
// `Array.prototype.push` method
// https://tc39.es/ecma262/#sec-array.prototype.push
$2iwSV({
    target: "Array",
    proto: true,
    arity: 1,
    forced: $6e5fb74587e963c4$var$FORCED
}, {
    // eslint-disable-next-line no-unused-vars -- required for `.length`
    push: function push(item) {
        var O = $h90HQ(this);
        var len = $f8kjp(O);
        var argCount = arguments.length;
        $a99UF(len + argCount);
        for(var i = 0; i < argCount; i++){
            O[len] = arguments[i];
            len++;
        }
        $83Bmy(O, len);
        return len;
    }
});

});








parcelRequire.register("gANtj", function(module, exports) {

var $jvWcZ = parcelRequire("jvWcZ");

var $fXTCZ = parcelRequire("fXTCZ");

var $9ROZd = parcelRequire("9ROZd");
function $c1466230d6ba71a1$var$_unsupportedIterableToArray(o, minLen) {
    var _context;
    if (!o) return;
    if (typeof o === "string") return $9ROZd(o, minLen);
    var n = $jvWcZ(_context = Object.prototype.toString.call(o)).call(_context, 8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return $fXTCZ(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $9ROZd(o, minLen);
}
module.exports = $c1466230d6ba71a1$var$_unsupportedIterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRequire.register("9ROZd", function(module, exports) {
function $72f09d1aa0ab7d3a$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
module.exports = $72f09d1aa0ab7d3a$var$_arrayLikeToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRequire.register("g6mDn", function(module, exports) {
function $bb8ec3849837e8d3$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
module.exports = $bb8ec3849837e8d3$var$_nonIterableRest, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRequire.register("5D5HB", function(module, exports) {
/*!
  Copyright (c) 2018 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/ /* global define */ (function() {
    "use strict";
    var hasOwn = {}.hasOwnProperty;
    function classNames() {
        var classes = [];
        for(var i = 0; i < arguments.length; i++){
            var arg = arguments[i];
            if (!arg) continue;
            var argType = typeof arg;
            if (argType === "string" || argType === "number") classes.push(arg);
            else if (Array.isArray(arg)) {
                if (arg.length) {
                    var inner = classNames.apply(null, arg);
                    if (inner) classes.push(inner);
                }
            } else if (argType === "object") {
                if (arg.toString === Object.prototype.toString) {
                    for(var key in arg)if (hasOwn.call(arg, key) && arg[key]) classes.push(key);
                } else classes.push(arg.toString());
            }
        }
        return classes.join(" ");
    }
    if (0, module.exports) {
        classNames.default = classNames;
        module.exports = classNames;
    } else if (typeof define === "function" && typeof define.amd === "object" && define.amd) // register as 'classnames', consistent with npm package name
    define("classnames", [], function() {
        return classNames;
    });
    else window.classNames = classNames;
})();

});

parcelRequire.register("iqqHp", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $d69f5d948197a053$var$ReactIs, $d69f5d948197a053$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
module.exports = (parcelRequire("ghSns"))();

});
parcelRequire.register("ghSns", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";

var $6RJ8c = parcelRequire("6RJ8c");
function $bdb86a19588ec7a0$var$emptyFunction() {}
function $bdb86a19588ec7a0$var$emptyFunctionWithReset() {}
$bdb86a19588ec7a0$var$emptyFunctionWithReset.resetWarningCache = $bdb86a19588ec7a0$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $6RJ8c) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = "Invariant Violation";
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $bdb86a19588ec7a0$var$emptyFunctionWithReset,
        resetWarningCache: $bdb86a19588ec7a0$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRequire.register("6RJ8c", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var $4ffab36fe9e0f8f5$var$ReactPropTypesSecret = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
module.exports = $4ffab36fe9e0f8f5$var$ReactPropTypesSecret;

});



parcelRequire.register("ijKjl", function(module, exports) {

$parcel$export(module.exports, "default", () => $d55decbc8625015a$export$2e2bcd8739ae039);

var $b5zLI = parcelRequire("b5zLI");
function $d55decbc8625015a$export$2e2bcd8739ae039() {
    var _useFunctionContext = (0, $b5zLI.default)(), scrollToEnd = _useFunctionContext.scrollToEnd;
    return scrollToEnd;
}

});
parcelRequire.register("b5zLI", function(module, exports) {

$parcel$export(module.exports, "default", () => $812be83f8dab66da$export$2e2bcd8739ae039);

var $eO7Kz = parcelRequire("eO7Kz");

var $HhFfQ = parcelRequire("HhFfQ");
function $812be83f8dab66da$export$2e2bcd8739ae039() {
    return (0, $eO7Kz.useContext)((0, $HhFfQ.default));
}

});
parcelRequire.register("HhFfQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $0821b80c41d96cf0$export$2e2bcd8739ae039);

var $eO7Kz = parcelRequire("eO7Kz");
var $0821b80c41d96cf0$var$context = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eO7Kz))).createContext({
    scrollTo: function scrollTo() {
        return 0;
    },
    scrollToBottom: function scrollToBottom() {
        return 0;
    },
    scrollToEnd: function scrollToEnd() {
        return 0;
    },
    scrollToStart: function scrollToStart() {
        return 0;
    },
    scrollToTop: function scrollToTop() {
        return 0;
    }
});
$0821b80c41d96cf0$var$context.displayName = "ScrollToBottomFunctionContext";
var $0821b80c41d96cf0$export$2e2bcd8739ae039 = $0821b80c41d96cf0$var$context;

});



parcelRequire.register("fL6wD", function(module, exports) {

$parcel$export(module.exports, "default", () => $b7904e9d27b2e748$export$2e2bcd8739ae039);
/* eslint no-magic-numbers: ["error", { "ignore": [2] }] */ 
var $aIMfi = parcelRequire("aIMfi");
function $b7904e9d27b2e748$export$2e2bcd8739ae039() {
    var _useStateContext = (0, $aIMfi.default)(2), sticky = _useStateContext.sticky;
    return [
        sticky
    ];
}

});
parcelRequire.register("aIMfi", function(module, exports) {

$parcel$export(module.exports, "default", () => $7ce3700c3e4cec89$export$2e2bcd8739ae039);

var $eO7Kz = parcelRequire("eO7Kz");

var $mnLzW = parcelRequire("mnLzW");

var $gkJ0k = parcelRequire("gkJ0k");

var $jXKa9 = parcelRequire("jXKa9");
var $7ce3700c3e4cec89$var$stateContexts = [
    (0, $jXKa9.default),
    (0, $mnLzW.default),
    (0, $gkJ0k.default)
];
function $7ce3700c3e4cec89$export$2e2bcd8739ae039(tier) {
    return (0, $eO7Kz.useContext)($7ce3700c3e4cec89$var$stateContexts[tier] || $7ce3700c3e4cec89$var$stateContexts[0]);
}

});
parcelRequire.register("mnLzW", function(module, exports) {

$parcel$export(module.exports, "default", () => $04347db345fe48c6$export$2e2bcd8739ae039);

var $eO7Kz = parcelRequire("eO7Kz");
var $04347db345fe48c6$var$context = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eO7Kz))).createContext({
    atBottom: true,
    atEnd: true,
    atStart: false,
    atTop: true,
    mode: "bottom"
});
$04347db345fe48c6$var$context.displayName = "ScrollToBottomState1Context";
var $04347db345fe48c6$export$2e2bcd8739ae039 = $04347db345fe48c6$var$context;

});

parcelRequire.register("gkJ0k", function(module, exports) {

$parcel$export(module.exports, "default", () => $be416c7e73993c9b$export$2e2bcd8739ae039);

var $eO7Kz = parcelRequire("eO7Kz");
var $be416c7e73993c9b$var$context = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eO7Kz))).createContext({
    animating: false,
    animatingToEnd: false,
    sticky: true
});
$be416c7e73993c9b$var$context.displayName = "ScrollToBottomState2Context";
var $be416c7e73993c9b$export$2e2bcd8739ae039 = $be416c7e73993c9b$var$context;

});

parcelRequire.register("jXKa9", function(module, exports) {

$parcel$export(module.exports, "default", () => $e88755f14d0eb97c$export$2e2bcd8739ae039);

var $eO7Kz = parcelRequire("eO7Kz");
var $e88755f14d0eb97c$var$context = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eO7Kz))).createContext({
    animating: false,
    animatingToEnd: false,
    atBottom: true,
    atEnd: true,
    atStart: false,
    atTop: true,
    mode: "bottom",
    sticky: true
});
$e88755f14d0eb97c$var$context.displayName = "ScrollToBottomStateContext";
var $e88755f14d0eb97c$export$2e2bcd8739ae039 = $e88755f14d0eb97c$var$context;

});



parcelRequire.register("6vdhG", function(module, exports) {

$parcel$export(module.exports, "default", () => $4bbff15160844827$export$2e2bcd8739ae039);

var $7HMxu = parcelRequire("7HMxu");
function $4bbff15160844827$export$2e2bcd8739ae039() {
    var _useInternalContext = (0, $7HMxu.default)(), styleToClassName = _useInternalContext.styleToClassName;
    return styleToClassName;
}

});
parcelRequire.register("7HMxu", function(module, exports) {

$parcel$export(module.exports, "default", () => $59c233690e0d325e$export$2e2bcd8739ae039);

var $eO7Kz = parcelRequire("eO7Kz");

var $2cPvv = parcelRequire("2cPvv");
function $59c233690e0d325e$export$2e2bcd8739ae039() {
    return (0, $eO7Kz.useContext)((0, $2cPvv.default));
}

});
parcelRequire.register("2cPvv", function(module, exports) {

$parcel$export(module.exports, "default", () => $19b4a8000458e77c$export$2e2bcd8739ae039);

var $eO7Kz = parcelRequire("eO7Kz");
var $19b4a8000458e77c$var$context = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eO7Kz))).createContext({
    offsetHeight: 0,
    scrollHeight: 0,
    setTarget: function setTarget() {
        return 0;
    },
    styleToClassName: function styleToClassName() {
        return "";
    }
});
$19b4a8000458e77c$var$context.displayName = "ScrollToBottomInternalContext";
var $19b4a8000458e77c$export$2e2bcd8739ae039 = $19b4a8000458e77c$var$context;

});




parcelRequire.register("DvL5R", function(module, exports) {

$parcel$export(module.exports, "default", () => $076c47394d42750f$export$2e2bcd8739ae039);

var $5D5HB = parcelRequire("5D5HB");

var $iqqHp = parcelRequire("iqqHp");

var $eO7Kz = parcelRequire("eO7Kz");

var $dv8ws = parcelRequire("dv8ws");

var $jJkLv = parcelRequire("jJkLv");

var $13VWp = parcelRequire("13VWp");

var $6vdhG = parcelRequire("6vdhG");
var $076c47394d42750f$var$ROOT_STYLE = {
    position: "relative"
};
var $076c47394d42750f$var$BasicScrollToBottomCore = function BasicScrollToBottomCore(_ref) {
    var children = _ref.children, className = _ref.className, followButtonClassName = _ref.followButtonClassName, scrollViewClassName = _ref.scrollViewClassName;
    var rootCSS = (0, $6vdhG.default)()($076c47394d42750f$var$ROOT_STYLE);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eO7Kz))).createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($5D5HB)))(rootCSS, (className || "") + "")
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eO7Kz))).createElement((0, $13VWp.default), {
        className: (scrollViewClassName || "") + ""
    }, children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eO7Kz))).createElement((0, $dv8ws.default), {
        className: (followButtonClassName || "") + ""
    }));
};
$076c47394d42750f$var$BasicScrollToBottomCore.defaultProps = {
    children: undefined,
    className: undefined,
    followButtonClassName: undefined,
    scrollViewClassName: undefined
};
$076c47394d42750f$var$BasicScrollToBottomCore.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($iqqHp))).any,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($iqqHp))).string,
    followButtonClassName: (0, (/*@__PURE__*/$parcel$interopDefault($iqqHp))).string,
    scrollViewClassName: (0, (/*@__PURE__*/$parcel$interopDefault($iqqHp))).string
};
var $076c47394d42750f$var$BasicScrollToBottom = function BasicScrollToBottom(_ref2) {
    var checkInterval = _ref2.checkInterval, children = _ref2.children, className = _ref2.className, debounce = _ref2.debounce, debug = _ref2.debug, followButtonClassName = _ref2.followButtonClassName, initialScrollBehavior = _ref2.initialScrollBehavior, mode = _ref2.mode, nonce = _ref2.nonce, scroller = _ref2.scroller, scrollViewClassName = _ref2.scrollViewClassName;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eO7Kz))).createElement((0, $jJkLv.default), {
        checkInterval: checkInterval,
        debounce: debounce,
        debug: debug,
        initialScrollBehavior: initialScrollBehavior,
        mode: mode,
        nonce: nonce,
        scroller: scroller
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eO7Kz))).createElement($076c47394d42750f$var$BasicScrollToBottomCore, {
        className: className,
        followButtonClassName: followButtonClassName,
        scrollViewClassName: scrollViewClassName
    }, children));
};
$076c47394d42750f$var$BasicScrollToBottom.defaultProps = {
    checkInterval: undefined,
    children: undefined,
    className: undefined,
    debounce: undefined,
    debug: undefined,
    followButtonClassName: undefined,
    initialScrollBehavior: "smooth",
    mode: undefined,
    nonce: undefined,
    scroller: undefined,
    scrollViewClassName: undefined
};
$076c47394d42750f$var$BasicScrollToBottom.propTypes = {
    checkInterval: (0, (/*@__PURE__*/$parcel$interopDefault($iqqHp))).number,
    children: (0, (/*@__PURE__*/$parcel$interopDefault($iqqHp))).any,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($iqqHp))).string,
    debounce: (0, (/*@__PURE__*/$parcel$interopDefault($iqqHp))).number,
    debug: (0, (/*@__PURE__*/$parcel$interopDefault($iqqHp))).bool,
    followButtonClassName: (0, (/*@__PURE__*/$parcel$interopDefault($iqqHp))).string,
    initialScrollBehavior: (0, (/*@__PURE__*/$parcel$interopDefault($iqqHp))).oneOf([
        "auto",
        "smooth"
    ]),
    mode: (0, (/*@__PURE__*/$parcel$interopDefault($iqqHp))).oneOf([
        "bottom",
        "top"
    ]),
    nonce: (0, (/*@__PURE__*/$parcel$interopDefault($iqqHp))).string,
    scroller: (0, (/*@__PURE__*/$parcel$interopDefault($iqqHp))).func,
    scrollViewClassName: (0, (/*@__PURE__*/$parcel$interopDefault($iqqHp))).string
};
var $076c47394d42750f$export$2e2bcd8739ae039 = $076c47394d42750f$var$BasicScrollToBottom;

});
parcelRequire.register("jJkLv", function(module, exports) {

$parcel$export(module.exports, "default", () => $e5d253d6dea9759c$export$2e2bcd8739ae039);

var $asVh6 = parcelRequire("asVh6");

var $60po4 = parcelRequire("60po4");

var $7SyKb = parcelRequire("7SyKb");
parcelRequire("cx6cd");
parcelRequire("1d9nZ");

var $iihxo = parcelRequire("iihxo");

var $8hNpw = parcelRequire("8hNpw");

var $13zC8 = parcelRequire("13zC8");

var $3pOgb = parcelRequire("3pOgb");

var $bUr91 = parcelRequire("bUr91");

var $1Gk4M = parcelRequire("1Gk4M");

var $iPwyO = parcelRequire("iPwyO");

var $hxEKj = parcelRequire("hxEKj");

var $gSduy = parcelRequire("gSduy");

var $8JKeG = parcelRequire("8JKeG");

var $bFMiT = parcelRequire("bFMiT");

var $erh1S = parcelRequire("erh1S");

var $bzi9N = parcelRequire("bzi9N");

var $d3vsa = parcelRequire("d3vsa");

var $iqqHp = parcelRequire("iqqHp");

var $eO7Kz = parcelRequire("eO7Kz");

var $6XRm4 = parcelRequire("6XRm4");

var $fqCdG = parcelRequire("fqCdG");

var $hXFIe = parcelRequire("hXFIe");

var $HhFfQ = parcelRequire("HhFfQ");

var $2cPvv = parcelRequire("2cPvv");

var $gcrVz = parcelRequire("gcrVz");

var $mnLzW = parcelRequire("mnLzW");

var $gkJ0k = parcelRequire("gkJ0k");

var $jXKa9 = parcelRequire("jXKa9");

var $cwbRD = parcelRequire("cwbRD");

var $12AF3 = parcelRequire("12AF3");
function $e5d253d6dea9759c$var$ownKeys(object, enumerableOnly) {
    var keys = (0, (/*@__PURE__*/$parcel$interopDefault($iPwyO)))(object);
    if (0, (/*@__PURE__*/$parcel$interopDefault($hxEKj))) {
        var symbols = (0, (/*@__PURE__*/$parcel$interopDefault($hxEKj)))(object);
        if (enumerableOnly) symbols = (0, (/*@__PURE__*/$parcel$interopDefault($gSduy)))(symbols).call(symbols, function(sym) {
            return (0, (/*@__PURE__*/$parcel$interopDefault($8JKeG)))(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $e5d253d6dea9759c$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) {
            var _context21;
            (0, (/*@__PURE__*/$parcel$interopDefault($1Gk4M)))(_context21 = $e5d253d6dea9759c$var$ownKeys(Object(source), true)).call(_context21, function(key) {
                (0, (/*@__PURE__*/$parcel$interopDefault($asVh6)))(target, key, source[key]);
            });
        } else if (0, (/*@__PURE__*/$parcel$interopDefault($bFMiT))) (0, (/*@__PURE__*/$parcel$interopDefault($erh1S)))(target, (0, (/*@__PURE__*/$parcel$interopDefault($bFMiT)))(source));
        else {
            var _context22;
            (0, (/*@__PURE__*/$parcel$interopDefault($1Gk4M)))(_context22 = $e5d253d6dea9759c$var$ownKeys(Object(source))).call(_context22, function(key) {
                (0, (/*@__PURE__*/$parcel$interopDefault($bzi9N)))(target, key, (0, (/*@__PURE__*/$parcel$interopDefault($8JKeG)))(source, key));
            });
        }
    }
    return target;
}
var $e5d253d6dea9759c$var$DEFAULT_SCROLLER = function DEFAULT_SCROLLER() {
    return Infinity;
};
var $e5d253d6dea9759c$var$MIN_CHECK_INTERVAL = 17; // 1 frame
var $e5d253d6dea9759c$var$MODE_BOTTOM = "bottom";
var $e5d253d6dea9759c$var$MODE_TOP = "top";
var $e5d253d6dea9759c$var$NEAR_END_THRESHOLD = 1;
var $e5d253d6dea9759c$var$SCROLL_DECISION_DURATION = 34; // 2 frames
// We pool the emotion object by nonce.
// This is to make sure we don't generate too many unneeded <style> tags.
var $e5d253d6dea9759c$var$emotionPool = {};
function $e5d253d6dea9759c$var$setImmediateInterval(fn, ms) {
    fn();
    return (0, (/*@__PURE__*/$parcel$interopDefault($iihxo)))(fn, ms);
}
function $e5d253d6dea9759c$var$computeViewState(_ref) {
    var mode = _ref.mode, _ref$target = _ref.target, offsetHeight = _ref$target.offsetHeight, scrollHeight = _ref$target.scrollHeight, scrollTop = _ref$target.scrollTop;
    var atBottom = scrollHeight - scrollTop - offsetHeight < $e5d253d6dea9759c$var$NEAR_END_THRESHOLD;
    var atTop = scrollTop < $e5d253d6dea9759c$var$NEAR_END_THRESHOLD;
    var atEnd = mode === $e5d253d6dea9759c$var$MODE_TOP ? atTop : atBottom;
    var atStart = mode !== $e5d253d6dea9759c$var$MODE_TOP ? atTop : atBottom;
    return {
        atBottom: atBottom,
        atEnd: atEnd,
        atStart: atStart,
        atTop: atTop
    };
}
function $e5d253d6dea9759c$var$isEnd(animateTo, mode) {
    return animateTo === (mode === $e5d253d6dea9759c$var$MODE_TOP ? 0 : "100%");
}
var $e5d253d6dea9759c$var$Composer = function Composer(_ref2) {
    var checkInterval = _ref2.checkInterval, children = _ref2.children, debounce = _ref2.debounce, debugFromProp = _ref2.debug, initialScrollBehavior = _ref2.initialScrollBehavior, mode = _ref2.mode, nonce = _ref2.nonce, scroller = _ref2.scroller;
    var debug = (0, $eO7Kz.useMemo)(function() {
        return (0, $fqCdG.default)("<ScrollToBottom>", {
            force: debugFromProp
        });
    }, [
        debugFromProp
    ]);
    mode = mode === $e5d253d6dea9759c$var$MODE_TOP ? $e5d253d6dea9759c$var$MODE_TOP : $e5d253d6dea9759c$var$MODE_BOTTOM;
    var ignoreScrollEventBeforeRef = (0, $eO7Kz.useRef)(0);
    var initialScrollBehaviorRef = (0, $eO7Kz.useRef)(initialScrollBehavior);
    var _useStateRef = (0, $12AF3.default)(mode === $e5d253d6dea9759c$var$MODE_TOP ? 0 : "100%"), _useStateRef2 = (0, (/*@__PURE__*/$parcel$interopDefault($7SyKb)))(_useStateRef, 3), animateTo = _useStateRef2[0], setAnimateTo = _useStateRef2[1], animateToRef = _useStateRef2[2];
    var _useStateRef3 = (0, $12AF3.default)(null), _useStateRef4 = (0, (/*@__PURE__*/$parcel$interopDefault($7SyKb)))(_useStateRef3, 3), target = _useStateRef4[0], setTarget = _useStateRef4[1], targetRef = _useStateRef4[2]; // Internal context
    var animateFromRef = (0, $eO7Kz.useRef)(0);
    var offsetHeightRef = (0, $eO7Kz.useRef)(0);
    var scrollHeightRef = (0, $eO7Kz.useRef)(0); // State context
    var _useState = (0, $eO7Kz.useState)(true), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($7SyKb)))(_useState, 2), atBottom = _useState2[0], setAtBottom = _useState2[1];
    var _useState3 = (0, $eO7Kz.useState)(true), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($7SyKb)))(_useState3, 2), atEnd = _useState4[0], setAtEnd = _useState4[1];
    var _useState5 = (0, $eO7Kz.useState)(true), _useState6 = (0, (/*@__PURE__*/$parcel$interopDefault($7SyKb)))(_useState5, 2), atTop = _useState6[0], setAtTop = _useState6[1];
    var _useState7 = (0, $eO7Kz.useState)(false), _useState8 = (0, (/*@__PURE__*/$parcel$interopDefault($7SyKb)))(_useState7, 2), atStart = _useState8[0], setAtStart = _useState8[1];
    var _useStateRef5 = (0, $12AF3.default)(true), _useStateRef6 = (0, (/*@__PURE__*/$parcel$interopDefault($7SyKb)))(_useStateRef5, 3), sticky = _useStateRef6[0], setSticky = _useStateRef6[1], stickyRef = _useStateRef6[2]; // High-rate state context
    var scrollPositionObserversRef = (0, $eO7Kz.useRef)([]);
    var observeScrollPosition = (0, $eO7Kz.useCallback)(function(fn) {
        var target = targetRef.current;
        scrollPositionObserversRef.current.push(fn);
        target && fn({
            scrollTop: target.scrollTop
        });
        return function() {
            var scrollPositionObservers = scrollPositionObserversRef.current;
            var index = (0, (/*@__PURE__*/$parcel$interopDefault($8hNpw)))(scrollPositionObservers).call(scrollPositionObservers, fn);
            ~index && (0, (/*@__PURE__*/$parcel$interopDefault($13zC8)))(scrollPositionObservers).call(scrollPositionObservers, index, 1);
        };
    }, [
        scrollPositionObserversRef,
        targetRef
    ]);
    var handleSpineToEnd = (0, $eO7Kz.useCallback)(function() {
        var animateTo = animateToRef.current;
        debug(function() {
            var _context;
            return (0, (/*@__PURE__*/$parcel$interopDefault($3pOgb)))(_context = [
                "%cSpineTo%c: %conEnd%c is fired."
            ]).call(_context, (0, (/*@__PURE__*/$parcel$interopDefault($60po4)))((0, $cwbRD.default)("magenta")), (0, (/*@__PURE__*/$parcel$interopDefault($60po4)))((0, $cwbRD.default)("orange")), [
                {
                    animateTo: animateTo
                }
            ]);
        });
        ignoreScrollEventBeforeRef.current = (0, (/*@__PURE__*/$parcel$interopDefault($bUr91)))(); // handleScrollEnd may end at a position which should lose stickiness.
        // In that case, we will need to set sticky to false to stop the interval check.
        // Test case:
        // 1. Add a scroller that always return 0
        // 2. Show a panel with mode === MODE_BOTTOM
        // 3. Programmatically scroll to 0 (set element.scrollTop = 0)
        // Expected: it should not repetitively call scrollTo(0)
        //           it should set stickiness to false
        $e5d253d6dea9759c$var$isEnd(animateTo, mode) || setSticky(false);
        setAnimateTo(null);
    }, [
        animateToRef,
        debug,
        ignoreScrollEventBeforeRef,
        mode,
        setAnimateTo,
        setSticky
    ]); // Function context
    var scrollTo = (0, $eO7Kz.useCallback)(function(nextAnimateTo) {
        var _ref3 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {}, behavior = _ref3.behavior;
        var target = targetRef.current;
        if (typeof nextAnimateTo !== "number" && nextAnimateTo !== "100%") return console.warn('react-scroll-to-bottom: Arguments passed to scrollTo() must be either number or "100%".');
         // If it is trying to scroll to a position which is not "atEnd", it should set sticky to false after scroll ended.
        debug(function() {
            var _context2;
            return [
                (0, (/*@__PURE__*/$parcel$interopDefault($3pOgb)))(_context2 = [
                    "%cscrollTo%c: Will scroll to %c".concat(typeof nextAnimateTo === "number" ? nextAnimateTo + "px" : nextAnimateTo.replace(/%/g, "%%"), "%c")
                ]).call(_context2, (0, (/*@__PURE__*/$parcel$interopDefault($60po4)))((0, $cwbRD.default)("lime", "")), (0, (/*@__PURE__*/$parcel$interopDefault($60po4)))((0, $cwbRD.default)("purple"))),
                {
                    behavior: behavior,
                    nextAnimateTo: nextAnimateTo,
                    target: target
                }
            ];
        });
        if (behavior === "auto") {
            // Stop any existing animation
            handleSpineToEnd();
            if (target) // Jump to the scroll position
            target.scrollTop = nextAnimateTo === "100%" ? target.scrollHeight - target.offsetHeight : nextAnimateTo;
        } else {
            behavior !== "smooth" && console.warn('react-scroll-to-bottom: Please set "behavior" when calling "scrollTo". In future versions, the default behavior will be changed from smooth scrolling to discrete scrolling to align with HTML Standard.');
            setAnimateTo(nextAnimateTo);
        } // This is for handling a case. When calling scrollTo('100%', { behavior: 'auto' }) multiple times, it would lose stickiness.
        if ($e5d253d6dea9759c$var$isEnd(nextAnimateTo, mode)) {
            debug(function() {
                var _context3;
                return [
                    (0, (/*@__PURE__*/$parcel$interopDefault($3pOgb)))(_context3 = [
                        "%cscrollTo%c: Scrolling to end, will set sticky to %ctrue%c."
                    ]).call(_context3, (0, (/*@__PURE__*/$parcel$interopDefault($60po4)))((0, $cwbRD.default)("lime", "")), (0, (/*@__PURE__*/$parcel$interopDefault($60po4)))((0, $cwbRD.default)("purple"))),
                    [
                        {
                            mode: mode,
                            nextAnimateTo: nextAnimateTo
                        }
                    ]
                ];
            });
            setSticky(true);
        }
    }, [
        debug,
        handleSpineToEnd,
        mode,
        setAnimateTo,
        setSticky,
        targetRef
    ]);
    var scrollToBottom = (0, $eO7Kz.useCallback)(function() {
        var _ref4 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, behavior = _ref4.behavior;
        debug(function() {
            var _context4;
            return (0, (/*@__PURE__*/$parcel$interopDefault($3pOgb)))(_context4 = [
                "%cscrollToBottom%c: Called"
            ]).call(_context4, (0, (/*@__PURE__*/$parcel$interopDefault($60po4)))((0, $cwbRD.default)("yellow", "")));
        });
        behavior !== "smooth" && console.warn('react-scroll-to-bottom: Please set "behavior" when calling "scrollToBottom". In future versions, the default behavior will be changed from smooth scrolling to discrete scrolling to align with HTML Standard.');
        scrollTo("100%", {
            behavior: behavior || "smooth"
        });
    }, [
        debug,
        scrollTo
    ]);
    var scrollToTop = (0, $eO7Kz.useCallback)(function() {
        var _ref5 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, behavior = _ref5.behavior;
        debug(function() {
            var _context5;
            return (0, (/*@__PURE__*/$parcel$interopDefault($3pOgb)))(_context5 = [
                "%cscrollToTop%c: Called"
            ]).call(_context5, (0, (/*@__PURE__*/$parcel$interopDefault($60po4)))((0, $cwbRD.default)("yellow", "")));
        });
        behavior !== "smooth" && console.warn('react-scroll-to-bottom: Please set "behavior" when calling "scrollToTop". In future versions, the default behavior will be changed from smooth scrolling to discrete scrolling to align with HTML Standard.');
        scrollTo(0, {
            behavior: behavior || "smooth"
        });
    }, [
        debug,
        scrollTo
    ]);
    var scrollToEnd = (0, $eO7Kz.useCallback)(function() {
        var _ref6 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, behavior = _ref6.behavior;
        debug(function() {
            var _context6;
            return (0, (/*@__PURE__*/$parcel$interopDefault($3pOgb)))(_context6 = [
                "%cscrollToEnd%c: Called"
            ]).call(_context6, (0, (/*@__PURE__*/$parcel$interopDefault($60po4)))((0, $cwbRD.default)("yellow", "")));
        });
        behavior !== "smooth" && console.warn('react-scroll-to-bottom: Please set "behavior" when calling "scrollToEnd". In future versions, the default behavior will be changed from smooth scrolling to discrete scrolling to align with HTML Standard.');
        var options = {
            behavior: behavior || "smooth"
        };
        mode === $e5d253d6dea9759c$var$MODE_TOP ? scrollToTop(options) : scrollToBottom(options);
    }, [
        debug,
        mode,
        scrollToBottom,
        scrollToTop
    ]);
    var scrollToStart = (0, $eO7Kz.useCallback)(function() {
        var _ref7 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, behavior = _ref7.behavior;
        debug(function() {
            var _context7;
            return (0, (/*@__PURE__*/$parcel$interopDefault($3pOgb)))(_context7 = [
                "%cscrollToStart%c: Called"
            ]).call(_context7, (0, (/*@__PURE__*/$parcel$interopDefault($60po4)))((0, $cwbRD.default)("yellow", "")));
        });
        behavior !== "smooth" && console.warn('react-scroll-to-bottom: Please set "behavior" when calling "scrollToStart". In future versions, the default behavior will be changed from smooth scrolling to discrete scrolling to align with HTML Standard.');
        var options = {
            behavior: behavior || "smooth"
        };
        mode === $e5d253d6dea9759c$var$MODE_TOP ? scrollToBottom(options) : scrollToTop(options);
    }, [
        debug,
        mode,
        scrollToBottom,
        scrollToTop
    ]);
    var scrollToSticky = (0, $eO7Kz.useCallback)(function() {
        var target = targetRef.current;
        if (target) {
            if (initialScrollBehaviorRef.current === "auto") {
                debug(function() {
                    var _context8;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($3pOgb)))(_context8 = [
                        "%ctarget changed%c: Initial scroll"
                    ]).call(_context8, (0, (/*@__PURE__*/$parcel$interopDefault($60po4)))((0, $cwbRD.default)("blue")));
                });
                target.scrollTop = mode === $e5d253d6dea9759c$var$MODE_TOP ? 0 : target.scrollHeight - target.offsetHeight;
                initialScrollBehaviorRef.current = false;
                return;
            } // This is very similar to scrollToEnd().
            // Instead of scrolling to end, it will call props.scroller() to determines how far it should scroll.
            // This function could be called while it is auto-scrolling.
            var animateFrom = animateFromRef.current;
            var offsetHeight = target.offsetHeight, scrollHeight = target.scrollHeight, scrollTop = target.scrollTop;
            var maxValue = mode === $e5d253d6dea9759c$var$MODE_TOP ? 0 : Math.max(0, scrollHeight - offsetHeight - scrollTop);
            var minValue = Math.max(0, animateFrom - scrollTop);
            var rawNextValue = scroller({
                maxValue: maxValue,
                minValue: minValue,
                offsetHeight: offsetHeight,
                scrollHeight: scrollHeight,
                scrollTop: scrollTop
            });
            var nextValue = Math.max(0, Math.min(maxValue, rawNextValue));
            var nextAnimateTo;
            if (mode === $e5d253d6dea9759c$var$MODE_TOP || nextValue !== maxValue) nextAnimateTo = scrollTop + nextValue;
            else // When scrolling to bottom, we should scroll to "100%".
            // Otherwise, if we scroll to any number, it will lose stickiness when elements are adding too fast.
            // "100%" is a special argument intended to make sure stickiness is not lost while new elements are being added.
            nextAnimateTo = "100%";
            debug(function() {
                var _context9, _context10, _context11;
                return [
                    (0, (/*@__PURE__*/$parcel$interopDefault($3pOgb)))(_context9 = [
                        (0, (/*@__PURE__*/$parcel$interopDefault($3pOgb)))(_context10 = (0, (/*@__PURE__*/$parcel$interopDefault($3pOgb)))(_context11 = "%cscrollToSticky%c: Will animate from %c".concat(animateFrom, "px%c to %c")).call(_context11, typeof nextAnimateTo === "number" ? nextAnimateTo + "px" : nextAnimateTo.replace(/%/g, "%%"), "%c (%c")).call(_context10, (nextAnimateTo === "100%" ? maxValue : nextAnimateTo) + animateFrom, "px%c)")
                    ]).call(_context9, (0, (/*@__PURE__*/$parcel$interopDefault($60po4)))((0, $cwbRD.default)("orange")), (0, (/*@__PURE__*/$parcel$interopDefault($60po4)))((0, $cwbRD.default)("purple")), (0, (/*@__PURE__*/$parcel$interopDefault($60po4)))((0, $cwbRD.default)("purple")), (0, (/*@__PURE__*/$parcel$interopDefault($60po4)))((0, $cwbRD.default)("purple"))),
                    {
                        animateFrom: animateFrom,
                        maxValue: maxValue,
                        minValue: minValue,
                        nextAnimateTo: nextAnimateTo,
                        nextValue: nextValue,
                        offsetHeight: offsetHeight,
                        rawNextValue: rawNextValue,
                        scrollHeight: scrollHeight,
                        scrollTop: scrollTop
                    }
                ];
            });
            scrollTo(nextAnimateTo, {
                behavior: "smooth"
            });
        }
    }, [
        animateFromRef,
        debug,
        mode,
        scroller,
        scrollTo,
        targetRef
    ]);
    var handleScroll = (0, $eO7Kz.useCallback)(function(_ref8) {
        var _context17;
        var timeStampLow = _ref8.timeStampLow;
        var animateTo = animateToRef.current;
        var target = targetRef.current;
        var animating = animateTo !== null; // Currently, there are no reliable way to check if the "scroll" event is trigger due to
        // user gesture, programmatic scrolling, or Chrome-synthesized "scroll" event to compensate size change.
        // Thus, we use our best-effort to guess if it is triggered by user gesture, and disable sticky if it is heading towards the start direction.
        if (timeStampLow <= ignoreScrollEventBeforeRef.current || !target) // Since we debounce "scroll" event, this handler might be called after spineTo.onEnd (a.k.a. artificial scrolling).
        // We should ignore debounced event fired after scrollEnd, because without skipping them, the userInitiatedScroll calculated below will not be accurate.
        // Thus, on a fast machine, adding elements super fast will lose the "stickiness".
        return;
        var _computeViewState = $e5d253d6dea9759c$var$computeViewState({
            mode: mode,
            target: target
        }), atBottom = _computeViewState.atBottom, atEnd = _computeViewState.atEnd, atStart = _computeViewState.atStart, atTop = _computeViewState.atTop;
        setAtBottom(atBottom);
        setAtEnd(atEnd);
        setAtStart(atStart);
        setAtTop(atTop); // Chrome will emit "synthetic" scroll event if the container is resized or an element is added
        // We need to ignore these "synthetic" events
        // Repro: In playground, press 4-1-5-1-1 (small, add one, normal, add one, add one)
        //        Nomatter how fast or slow the sequence is being pressed, it should still stick to the bottom
        var nextOffsetHeight = target.offsetHeight, nextScrollHeight = target.scrollHeight;
        var offsetHeight = offsetHeightRef.current;
        var scrollHeight = scrollHeightRef.current;
        var offsetHeightChanged = nextOffsetHeight !== offsetHeight;
        var scrollHeightChanged = nextScrollHeight !== scrollHeight;
        if (offsetHeightChanged) offsetHeightRef.current = nextOffsetHeight;
        if (scrollHeightChanged) scrollHeightRef.current = nextScrollHeight;
         // Sticky means:
        // - If it is scrolled programatically, we are still in sticky mode
        // - If it is scrolled by the user, then sticky means if we are at the end
        // Only update stickiness if the scroll event is not due to synthetic scroll done by Chrome
        if (!offsetHeightChanged && !scrollHeightChanged) {
            // We are sticky if we are animating to the end, or we are already at the end.
            // We can be "animating but not sticky" by calling "scrollTo(100)" where the container scrollHeight is 200px.
            var nextSticky = animating && $e5d253d6dea9759c$var$isEnd(animateTo, mode) || atEnd;
            if (stickyRef.current !== nextSticky) {
                debug(function() {
                    var _context12, _context13, _context14, _context15;
                    return [
                        (0, (/*@__PURE__*/$parcel$interopDefault($3pOgb)))(_context12 = [
                            "%conScroll%c: %csetSticky%c(%c".concat(nextSticky, "%c)")
                        ]).call(_context12, (0, (/*@__PURE__*/$parcel$interopDefault($60po4)))((0, $cwbRD.default)("red")), (0, (/*@__PURE__*/$parcel$interopDefault($60po4)))((0, $cwbRD.default)("red")), (0, (/*@__PURE__*/$parcel$interopDefault($60po4)))((0, $cwbRD.default)("purple"))),
                        (0, (/*@__PURE__*/$parcel$interopDefault($3pOgb)))(_context13 = [
                            (0, (/*@__PURE__*/$parcel$interopDefault($3pOgb)))(_context14 = (0, (/*@__PURE__*/$parcel$interopDefault($3pOgb)))(_context15 = "(animating = %c".concat(animating, "%c && isEnd = %c")).call(_context15, $e5d253d6dea9759c$var$isEnd(animateTo, mode), "%c) || atEnd = %c")).call(_context14, atEnd, "%c")
                        ]).call(_context13, (0, (/*@__PURE__*/$parcel$interopDefault($60po4)))((0, $cwbRD.default)("purple")), (0, (/*@__PURE__*/$parcel$interopDefault($60po4)))((0, $cwbRD.default)("purple")), (0, (/*@__PURE__*/$parcel$interopDefault($60po4)))((0, $cwbRD.default)("purple")), [
                            {
                                animating: animating,
                                animateTo: animateTo,
                                atEnd: atEnd,
                                mode: mode,
                                offsetHeight: target.offsetHeight,
                                scrollHeight: target.scrollHeight,
                                sticky: stickyRef.current,
                                nextSticky: nextSticky
                            }
                        ])
                    ];
                });
                setSticky(nextSticky);
            }
        } else if (stickyRef.current) {
            debug(function() {
                var _context16;
                return [
                    (0, (/*@__PURE__*/$parcel$interopDefault($3pOgb)))(_context16 = [
                        "%conScroll%c: Size changed while sticky, calling %cscrollToSticky()%c"
                    ]).call(_context16, (0, (/*@__PURE__*/$parcel$interopDefault($60po4)))((0, $cwbRD.default)("red")), (0, (/*@__PURE__*/$parcel$interopDefault($60po4)))((0, $cwbRD.default)("orange")), [
                        {
                            offsetHeightChanged: offsetHeightChanged,
                            scrollHeightChanged: scrollHeightChanged
                        }
                    ]),
                    {
                        nextOffsetHeight: nextOffsetHeight,
                        prevOffsetHeight: offsetHeight,
                        nextScrollHeight: nextScrollHeight,
                        prevScrollHeight: scrollHeight
                    }
                ];
            });
            scrollToSticky();
        }
        var actualScrollTop = target.scrollTop;
        (0, (/*@__PURE__*/$parcel$interopDefault($1Gk4M)))(_context17 = scrollPositionObserversRef.current).call(_context17, function(observer) {
            return observer({
                scrollTop: actualScrollTop
            });
        });
    }, [
        animateToRef,
        debug,
        ignoreScrollEventBeforeRef,
        mode,
        offsetHeightRef,
        scrollHeightRef,
        scrollPositionObserversRef,
        scrollToSticky,
        setAtBottom,
        setAtEnd,
        setAtStart,
        setAtTop,
        setSticky,
        stickyRef,
        targetRef
    ]);
    (0, $eO7Kz.useEffect)(function() {
        if (target) {
            var stickyButNotAtEndSince = false;
            var timeout = $e5d253d6dea9759c$var$setImmediateInterval(function() {
                var target = targetRef.current;
                var animating = animateToRef.current !== null;
                if (stickyRef.current) {
                    if (!$e5d253d6dea9759c$var$computeViewState({
                        mode: mode,
                        target: target
                    }).atEnd) {
                        if (!stickyButNotAtEndSince) stickyButNotAtEndSince = (0, (/*@__PURE__*/$parcel$interopDefault($bUr91)))();
                        else if ((0, (/*@__PURE__*/$parcel$interopDefault($bUr91)))() - stickyButNotAtEndSince > $e5d253d6dea9759c$var$SCROLL_DECISION_DURATION) {
                            // Quirks: In Firefox, after user scroll down, Firefox do two things:
                            //         1. Set to a new "scrollTop"
                            //         2. Fire "scroll" event
                            //         For what we observed, #1 is fired about 20ms before #2. There is a chance that this stickyCheckTimeout is being scheduled between 1 and 2.
                            //         That means, if we just look at #1 to decide if we should scroll, we will always scroll, in oppose to the user's intention.
                            // Repro: Open Firefox, set checkInterval to a lower number, and try to scroll by dragging the scroll handler. It will jump back.
                            // The "animating" check will make sure stickiness is not lost when elements are adding at a very fast pace.
                            if (!animating) {
                                animateFromRef.current = target.scrollTop;
                                debug(function() {
                                    var _context18;
                                    return (0, (/*@__PURE__*/$parcel$interopDefault($3pOgb)))(_context18 = [
                                        "%cInterval check%c: Should sticky but not at end, calling %cscrollToSticky()%c to scroll"
                                    ]).call(_context18, (0, (/*@__PURE__*/$parcel$interopDefault($60po4)))((0, $cwbRD.default)("navy")), (0, (/*@__PURE__*/$parcel$interopDefault($60po4)))((0, $cwbRD.default)("orange")));
                                });
                                scrollToSticky();
                            }
                            stickyButNotAtEndSince = false;
                        }
                    } else stickyButNotAtEndSince = false;
                } else if (target.scrollHeight <= target.offsetHeight && !stickyRef.current) {
                    // When the container is emptied, we will set sticky back to true.
                    debug(function() {
                        var _context19;
                        return [
                            (0, (/*@__PURE__*/$parcel$interopDefault($3pOgb)))(_context19 = [
                                "%cInterval check%c: Container is emptied, setting sticky back to %ctrue%c"
                            ]).call(_context19, (0, (/*@__PURE__*/$parcel$interopDefault($60po4)))((0, $cwbRD.default)("navy")), (0, (/*@__PURE__*/$parcel$interopDefault($60po4)))((0, $cwbRD.default)("purple"))),
                            [
                                {
                                    offsetHeight: target.offsetHeight,
                                    scrollHeight: target.scrollHeight,
                                    sticky: stickyRef.current
                                }
                            ]
                        ];
                    });
                    setSticky(true);
                }
            }, Math.max($e5d253d6dea9759c$var$MIN_CHECK_INTERVAL, checkInterval) || $e5d253d6dea9759c$var$MIN_CHECK_INTERVAL);
            return function() {
                return clearInterval(timeout);
            };
        }
    }, [
        animateToRef,
        checkInterval,
        debug,
        mode,
        scrollToSticky,
        setSticky,
        stickyRef,
        target,
        targetRef
    ]);
    var styleToClassName = (0, $eO7Kz.useMemo)(function() {
        var emotion = $e5d253d6dea9759c$var$emotionPool[nonce] || ($e5d253d6dea9759c$var$emotionPool[nonce] = (0, $d3vsa.default)({
            key: "react-scroll-to-bottom--css-" + (0, $6XRm4.default)(),
            nonce: nonce
        }));
        return function(style) {
            return emotion.css(style) + "";
        };
    }, [
        nonce
    ]);
    var internalContext = (0, $eO7Kz.useMemo)(function() {
        return {
            observeScrollPosition: observeScrollPosition,
            setTarget: setTarget,
            styleToClassName: styleToClassName
        };
    }, [
        observeScrollPosition,
        setTarget,
        styleToClassName
    ]);
    var state1Context = (0, $eO7Kz.useMemo)(function() {
        return {
            atBottom: atBottom,
            atEnd: atEnd,
            atStart: atStart,
            atTop: atTop,
            mode: mode
        };
    }, [
        atBottom,
        atEnd,
        atStart,
        atTop,
        mode
    ]);
    var state2Context = (0, $eO7Kz.useMemo)(function() {
        var animating = animateTo !== null;
        return {
            animating: animating,
            animatingToEnd: animating && $e5d253d6dea9759c$var$isEnd(animateTo, mode),
            sticky: sticky
        };
    }, [
        animateTo,
        mode,
        sticky
    ]);
    var combinedStateContext = (0, $eO7Kz.useMemo)(function() {
        return $e5d253d6dea9759c$var$_objectSpread($e5d253d6dea9759c$var$_objectSpread({}, state1Context), state2Context);
    }, [
        state1Context,
        state2Context
    ]);
    var functionContext = (0, $eO7Kz.useMemo)(function() {
        return {
            scrollTo: scrollTo,
            scrollToBottom: scrollToBottom,
            scrollToEnd: scrollToEnd,
            scrollToStart: scrollToStart,
            scrollToTop: scrollToTop
        };
    }, [
        scrollTo,
        scrollToBottom,
        scrollToEnd,
        scrollToStart,
        scrollToTop
    ]);
    (0, $eO7Kz.useEffect)(function() {
        // We need to update the "scrollHeight" value to latest when the user do a focus inside the box.
        //
        // This is because:
        // - In our code that mitigate Chrome synthetic scrolling, that code will look at whether "scrollHeight" value is latest or not.
        // - That code only run on "scroll" event.
        // - That means, on every "scroll" event, if the "scrollHeight" value is not latest, we will skip modifying the stickiness.
        // - That means, if the user "focus" to an element that cause the scroll view to scroll to the bottom, the user agent will fire "scroll" event.
        //   Since the "scrollHeight" is not latest value, this "scroll" event will be ignored and stickiness will not be modified.
        // - That means, if the user "focus" to a newly added element that is at the end of the scroll view, the "scroll to bottom" button will continue to show.
        //
        // Repro in Chrome:
        // 1. Fill up a scroll view
        // 2. Scroll up, the "scroll to bottom" button should show up
        // 3. Click "Add a button"
        // 4. Click on the scroll view (to pseudo-focus on it)
        // 5. Press TAB, the scroll view will be at the bottom
        //
        // Expect:
        // - The "scroll to bottom" button should be gone.
        if (target) {
            var handleFocus = function handleFocus() {
                scrollHeightRef.current = target.scrollHeight;
            };
            target.addEventListener("focus", handleFocus, {
                capture: true,
                passive: true
            });
            return function() {
                return target.removeEventListener("focus", handleFocus);
            };
        }
    }, [
        target
    ]);
    debug(function() {
        var _context20;
        return [
            (0, (/*@__PURE__*/$parcel$interopDefault($3pOgb)))(_context20 = [
                "%cRender%c: Render"
            ]).call(_context20, (0, (/*@__PURE__*/$parcel$interopDefault($60po4)))((0, $cwbRD.default)("cyan", ""))),
            {
                animateTo: animateTo,
                animating: animateTo !== null,
                sticky: sticky,
                target: target
            }
        ];
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eO7Kz))).createElement((0, $2cPvv.default).Provider, {
        value: internalContext
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eO7Kz))).createElement((0, $HhFfQ.default).Provider, {
        value: functionContext
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eO7Kz))).createElement((0, $jXKa9.default).Provider, {
        value: combinedStateContext
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eO7Kz))).createElement((0, $mnLzW.default).Provider, {
        value: state1Context
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eO7Kz))).createElement((0, $gkJ0k.default).Provider, {
        value: state2Context
    }, children, target && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eO7Kz))).createElement((0, $hXFIe.default), {
        debounce: debounce,
        name: "scroll",
        onEvent: handleScroll,
        target: target
    }), target && animateTo !== null && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eO7Kz))).createElement((0, $gcrVz.default), {
        name: "scrollTop",
        onEnd: handleSpineToEnd,
        target: target,
        value: animateTo
    }))))));
};
$e5d253d6dea9759c$var$Composer.defaultProps = {
    checkInterval: 100,
    children: undefined,
    debounce: 17,
    debug: undefined,
    initialScrollBehavior: "smooth",
    mode: undefined,
    nonce: undefined,
    scroller: $e5d253d6dea9759c$var$DEFAULT_SCROLLER
};
$e5d253d6dea9759c$var$Composer.propTypes = {
    checkInterval: (0, (/*@__PURE__*/$parcel$interopDefault($iqqHp))).number,
    children: (0, (/*@__PURE__*/$parcel$interopDefault($iqqHp))).any,
    debounce: (0, (/*@__PURE__*/$parcel$interopDefault($iqqHp))).number,
    debug: (0, (/*@__PURE__*/$parcel$interopDefault($iqqHp))).bool,
    initialScrollBehavior: (0, (/*@__PURE__*/$parcel$interopDefault($iqqHp))).oneOf([
        "auto",
        "smooth"
    ]),
    mode: (0, (/*@__PURE__*/$parcel$interopDefault($iqqHp))).oneOf([
        "bottom",
        "top"
    ]),
    nonce: (0, (/*@__PURE__*/$parcel$interopDefault($iqqHp))).string,
    scroller: (0, (/*@__PURE__*/$parcel$interopDefault($iqqHp))).func
};
var $e5d253d6dea9759c$export$2e2bcd8739ae039 = $e5d253d6dea9759c$var$Composer;

});
parcelRequire.register("asVh6", function(module, exports) {

var $jODSY = parcelRequire("jODSY");

var $kY1PA = parcelRequire("kY1PA");
function $79e8f27fa4199c90$var$_defineProperty(obj, key, value) {
    key = $kY1PA(key);
    if (key in obj) $jODSY(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
module.exports = $79e8f27fa4199c90$var$_defineProperty, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRequire.register("kY1PA", function(module, exports) {

var $hBFcN = parcelRequire("hBFcN");
var $f43ad4d4599d75f4$var$_typeof = $hBFcN.default;

var $8MfN0 = parcelRequire("8MfN0");
function $f43ad4d4599d75f4$var$_toPropertyKey(arg) {
    var key = $8MfN0(arg, "string");
    return $f43ad4d4599d75f4$var$_typeof(key) === "symbol" ? key : String(key);
}
module.exports = $f43ad4d4599d75f4$var$_toPropertyKey, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRequire.register("hBFcN", function(module, exports) {

var $5XC68 = parcelRequire("5XC68");

var $2iQ0J = parcelRequire("2iQ0J");
function $cd15dae0bc6bfa75$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return module.exports = $cd15dae0bc6bfa75$var$_typeof = "function" == typeof $5XC68 && "symbol" == typeof $2iQ0J ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof $5XC68 && obj.constructor === $5XC68 && obj !== $5XC68.prototype ? "symbol" : typeof obj;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $cd15dae0bc6bfa75$var$_typeof(obj);
}
module.exports = $cd15dae0bc6bfa75$var$_typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRequire.register("8MfN0", function(module, exports) {

var $f0uka = parcelRequire("f0uka");

var $hBFcN = parcelRequire("hBFcN");
var $663f0de102837929$var$_typeof = $hBFcN.default;
function $663f0de102837929$var$_toPrimitive(input, hint) {
    if ($663f0de102837929$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[$f0uka];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($663f0de102837929$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
module.exports = $663f0de102837929$var$_toPrimitive, module.exports.__esModule = true, module.exports["default"] = module.exports;

});



parcelRequire.register("60po4", function(module, exports) {

var $eAQY5 = parcelRequire("eAQY5");

var $m4xD9 = parcelRequire("m4xD9");

var $gANtj = parcelRequire("gANtj");

var $idvoZ = parcelRequire("idvoZ");
function $45f66f8f4d112548$var$_toConsumableArray(arr) {
    return $eAQY5(arr) || $m4xD9(arr) || $gANtj(arr) || $idvoZ();
}
module.exports = $45f66f8f4d112548$var$_toConsumableArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRequire.register("eAQY5", function(module, exports) {

var $6jPy4 = parcelRequire("6jPy4");

var $9ROZd = parcelRequire("9ROZd");
function $a9fd83da2b93c4a8$var$_arrayWithoutHoles(arr) {
    if ($6jPy4(arr)) return $9ROZd(arr);
}
module.exports = $a9fd83da2b93c4a8$var$_arrayWithoutHoles, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRequire.register("m4xD9", function(module, exports) {

var $5XC68 = parcelRequire("5XC68");

var $aoWGW = parcelRequire("aoWGW");

var $fXTCZ = parcelRequire("fXTCZ");
function $0425940566c15f1f$var$_iterableToArray(iter) {
    if (typeof $5XC68 !== "undefined" && $aoWGW(iter) != null || iter["@@iterator"] != null) return $fXTCZ(iter);
}
module.exports = $0425940566c15f1f$var$_iterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRequire.register("idvoZ", function(module, exports) {
function $d431ccad24e30302$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
module.exports = $d431ccad24e30302$var$_nonIterableSpread, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRequire.register("cx6cd", function(module, exports) {
"use strict";

var $bz3fR = parcelRequire("bz3fR");

var $aJWrQ = parcelRequire("aJWrQ");
// `RegExp.prototype.exec` method
// https://tc39.es/ecma262/#sec-regexp.prototype.exec
$bz3fR({
    target: "RegExp",
    proto: true,
    forced: /./.exec !== $aJWrQ
}, {
    exec: $aJWrQ
});

});
parcelRequire.register("bz3fR", function(module, exports) {

var $37Rkl = parcelRequire("37Rkl");

var $04VBW = parcelRequire("04VBW");
var $86b57cedad102951$require$getOwnPropertyDescriptor = $04VBW.f;

var $7dP0H = parcelRequire("7dP0H");

var $jwwDv = parcelRequire("jwwDv");

var $cNHSE = parcelRequire("cNHSE");

var $h4YmI = parcelRequire("h4YmI");

var $70Jxv = parcelRequire("70Jxv");
/*
  options.target      - name of the target object
  options.global      - target is the global object
  options.stat        - export as static methods of target
  options.proto       - export as prototype methods of target
  options.real        - real prototype method for the `pure` version
  options.forced      - export even if the native feature is available
  options.bind        - bind methods to the target, required for the `pure` version
  options.wrap        - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe      - use the simple assignment of property instead of delete + defineProperty
  options.sham        - add a flag to not completely full polyfills
  options.enumerable  - export as enumerable property
  options.noTargetGet - prevent calling a getter on target
  options.name        - the .name of the function if it does not match the key
*/ module.exports = function(options, source) {
    var TARGET = options.target;
    var GLOBAL = options.global;
    var STATIC = options.stat;
    var FORCED, target, key, targetProperty, sourceProperty, descriptor;
    if (GLOBAL) target = $37Rkl;
    else if (STATIC) target = $37Rkl[TARGET] || $cNHSE(TARGET, {});
    else target = ($37Rkl[TARGET] || {}).prototype;
    if (target) for(key in source){
        sourceProperty = source[key];
        if (options.noTargetGet) {
            descriptor = $86b57cedad102951$require$getOwnPropertyDescriptor(target, key);
            targetProperty = descriptor && descriptor.value;
        } else targetProperty = target[key];
        FORCED = $70Jxv(GLOBAL ? key : TARGET + (STATIC ? "." : "#") + key, options.forced);
        // contained in target
        if (!FORCED && targetProperty !== undefined) {
            if (typeof sourceProperty === typeof targetProperty) continue;
            $h4YmI(sourceProperty, targetProperty);
        }
        // add a flag to not completely full polyfills
        if (options.sham || targetProperty && targetProperty.sham) $7dP0H(sourceProperty, "sham", true);
        // extend global
        $jwwDv(target, key, sourceProperty, options);
    }
};

});
parcelRequire.register("37Rkl", function(module, exports) {
var $246b6437b88061a9$var$check = function(it) {
    return it && it.Math == Math && it;
};
// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
module.exports = // eslint-disable-next-line es/no-global-this -- safe
$246b6437b88061a9$var$check(typeof globalThis == "object" && globalThis) || $246b6437b88061a9$var$check(typeof window == "object" && window) || // eslint-disable-next-line no-restricted-globals -- safe
$246b6437b88061a9$var$check(typeof self == "object" && self) || $246b6437b88061a9$var$check(typeof $parcel$global == "object" && $parcel$global) || // eslint-disable-next-line no-new-func -- fallback
function() {
    return this;
}() || Function("return this")();

});

parcelRequire.register("04VBW", function(module, exports) {

$parcel$export(module.exports, "f", () => $00ed102f0e16506b$export$2d1720544b23b823, (v) => $00ed102f0e16506b$export$2d1720544b23b823 = v);
// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
var $00ed102f0e16506b$export$2d1720544b23b823;

var $fmfcF = parcelRequire("fmfcF");

var $gF8hE = parcelRequire("gF8hE");

var $iQ4Aq = parcelRequire("iQ4Aq");

var $iF2V1 = parcelRequire("iF2V1");

var $4SxP3 = parcelRequire("4SxP3");

var $iKbD9 = parcelRequire("iKbD9");

var $jCPV4 = parcelRequire("jCPV4");
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $00ed102f0e16506b$var$$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
$00ed102f0e16506b$export$2d1720544b23b823 = $fmfcF ? $00ed102f0e16506b$var$$getOwnPropertyDescriptor : function getOwnPropertyDescriptor(O, P) {
    O = $iF2V1(O);
    P = $4SxP3(P);
    if ($jCPV4) try {
        return $00ed102f0e16506b$var$$getOwnPropertyDescriptor(O, P);
    } catch (error) {}
    if ($iKbD9(O, P)) return $iQ4Aq(!$gF8hE.f.call(O, P), O[P]);
};

});
parcelRequire.register("fmfcF", function(module, exports) {

var $62TeD = parcelRequire("62TeD");
// Detect IE8's incomplete defineProperty implementation
module.exports = !$62TeD(function() {
    // eslint-disable-next-line es/no-object-defineproperty -- required for testing
    return Object.defineProperty({}, 1, {
        get: function() {
            return 7;
        }
    })[1] != 7;
});

});
parcelRequire.register("62TeD", function(module, exports) {
module.exports = function(exec) {
    try {
        return !!exec();
    } catch (error) {
        return true;
    }
};

});


parcelRequire.register("gF8hE", function(module, exports) {

$parcel$export(module.exports, "f", () => $c216e6aa717f60c0$export$2d1720544b23b823, (v) => $c216e6aa717f60c0$export$2d1720544b23b823 = v);
// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable
var $c216e6aa717f60c0$export$2d1720544b23b823;
"use strict";
var $c216e6aa717f60c0$var$$propertyIsEnumerable = {}.propertyIsEnumerable;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $c216e6aa717f60c0$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
// Nashorn ~ JDK8 bug
var $c216e6aa717f60c0$var$NASHORN_BUG = $c216e6aa717f60c0$var$getOwnPropertyDescriptor && !$c216e6aa717f60c0$var$$propertyIsEnumerable.call({
    1: 2
}, 1);
$c216e6aa717f60c0$export$2d1720544b23b823 = $c216e6aa717f60c0$var$NASHORN_BUG ? function propertyIsEnumerable(V) {
    var descriptor = $c216e6aa717f60c0$var$getOwnPropertyDescriptor(this, V);
    return !!descriptor && descriptor.enumerable;
} : $c216e6aa717f60c0$var$$propertyIsEnumerable;

});

parcelRequire.register("iQ4Aq", function(module, exports) {
module.exports = function(bitmap, value) {
    return {
        enumerable: !(bitmap & 1),
        configurable: !(bitmap & 2),
        writable: !(bitmap & 4),
        value: value
    };
};

});

parcelRequire.register("iF2V1", function(module, exports) {
// toObject with fallback for non-array-like ES3 strings

var $hvy9T = parcelRequire("hvy9T");

var $21Mei = parcelRequire("21Mei");
module.exports = function(it) {
    return $hvy9T($21Mei(it));
};

});
parcelRequire.register("hvy9T", function(module, exports) {

var $62TeD = parcelRequire("62TeD");

var $5i93Z = parcelRequire("5i93Z");
var $cbefd41a692f634b$var$split = "".split;
// fallback for non-array-like ES3 and non-enumerable old V8 strings
module.exports = $62TeD(function() {
    // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
    // eslint-disable-next-line no-prototype-builtins -- safe
    return !Object("z").propertyIsEnumerable(0);
}) ? function(it) {
    return $5i93Z(it) == "String" ? $cbefd41a692f634b$var$split.call(it, "") : Object(it);
} : Object;

});
parcelRequire.register("5i93Z", function(module, exports) {
var $3da5a9f85fb6edc8$var$toString = {}.toString;
module.exports = function(it) {
    return $3da5a9f85fb6edc8$var$toString.call(it).slice(8, -1);
};

});


parcelRequire.register("21Mei", function(module, exports) {
// `RequireObjectCoercible` abstract operation
// https://tc39.es/ecma262/#sec-requireobjectcoercible
module.exports = function(it) {
    if (it == undefined) throw TypeError("Can't call method on " + it);
    return it;
};

});


parcelRequire.register("4SxP3", function(module, exports) {

var $dVrO8 = parcelRequire("dVrO8");

var $eaSZU = parcelRequire("eaSZU");
// `ToPropertyKey` abstract operation
// https://tc39.es/ecma262/#sec-topropertykey
module.exports = function(argument) {
    var key = $dVrO8(argument, "string");
    return $eaSZU(key) ? key : String(key);
};

});
parcelRequire.register("dVrO8", function(module, exports) {

var $kYoIs = parcelRequire("kYoIs");

var $eaSZU = parcelRequire("eaSZU");

var $hJm3h = parcelRequire("hJm3h");

var $ddKV3 = parcelRequire("ddKV3");

var $17MDU = parcelRequire("17MDU");
var $a2362b45b580341e$var$TO_PRIMITIVE = $17MDU("toPrimitive");
// `ToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-toprimitive
module.exports = function(input, pref) {
    if (!$kYoIs(input) || $eaSZU(input)) return input;
    var exoticToPrim = $hJm3h(input, $a2362b45b580341e$var$TO_PRIMITIVE);
    var result;
    if (exoticToPrim) {
        if (pref === undefined) pref = "default";
        result = exoticToPrim.call(input, pref);
        if (!$kYoIs(result) || $eaSZU(result)) return result;
        throw TypeError("Can't convert object to primitive value");
    }
    if (pref === undefined) pref = "number";
    return $ddKV3(input, pref);
};

});
parcelRequire.register("kYoIs", function(module, exports) {

var $gFh7K = parcelRequire("gFh7K");
module.exports = function(it) {
    return typeof it === "object" ? it !== null : $gFh7K(it);
};

});
parcelRequire.register("gFh7K", function(module, exports) {
// `IsCallable` abstract operation
// https://tc39.es/ecma262/#sec-iscallable
module.exports = function(argument) {
    return typeof argument === "function";
};

});


parcelRequire.register("eaSZU", function(module, exports) {

var $gFh7K = parcelRequire("gFh7K");

var $eQ8UB = parcelRequire("eQ8UB");

var $5KF29 = parcelRequire("5KF29");
module.exports = $5KF29 ? function(it) {
    return typeof it == "symbol";
} : function(it) {
    var $Symbol = $eQ8UB("Symbol");
    return $gFh7K($Symbol) && Object(it) instanceof $Symbol;
};

});
parcelRequire.register("eQ8UB", function(module, exports) {

var $37Rkl = parcelRequire("37Rkl");

var $gFh7K = parcelRequire("gFh7K");
var $acdcd5bb93d39af9$var$aFunction = function(argument) {
    return $gFh7K(argument) ? argument : undefined;
};
module.exports = function(namespace, method) {
    return arguments.length < 2 ? $acdcd5bb93d39af9$var$aFunction($37Rkl[namespace]) : $37Rkl[namespace] && $37Rkl[namespace][method];
};

});

parcelRequire.register("5KF29", function(module, exports) {
/* eslint-disable es/no-symbol -- required for testing */ 
var $e4Od9 = parcelRequire("e4Od9");
module.exports = $e4Od9 && !Symbol.sham && typeof Symbol.iterator == "symbol";

});
parcelRequire.register("e4Od9", function(module, exports) {
/* eslint-disable es/no-symbol -- required for testing */ 
var $1GAyI = parcelRequire("1GAyI");

var $62TeD = parcelRequire("62TeD");
// eslint-disable-next-line es/no-object-getownpropertysymbols -- required for testing
module.exports = !!Object.getOwnPropertySymbols && !$62TeD(function() {
    var symbol = Symbol();
    // Chrome 38 Symbol has incorrect toString conversion
    // `get-own-property-symbols` polyfill symbols converted to object are not Symbol instances
    return !String(symbol) || !(Object(symbol) instanceof Symbol) || // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
    !Symbol.sham && $1GAyI && $1GAyI < 41;
});

});
parcelRequire.register("1GAyI", function(module, exports) {

var $37Rkl = parcelRequire("37Rkl");

var $fQnZT = parcelRequire("fQnZT");
var $13a612880c36bbbc$var$process = $37Rkl.process;
var $13a612880c36bbbc$var$Deno = $37Rkl.Deno;
var $13a612880c36bbbc$var$versions = $13a612880c36bbbc$var$process && $13a612880c36bbbc$var$process.versions || $13a612880c36bbbc$var$Deno && $13a612880c36bbbc$var$Deno.version;
var $13a612880c36bbbc$var$v8 = $13a612880c36bbbc$var$versions && $13a612880c36bbbc$var$versions.v8;
var $13a612880c36bbbc$var$match, $13a612880c36bbbc$var$version;
if ($13a612880c36bbbc$var$v8) {
    $13a612880c36bbbc$var$match = $13a612880c36bbbc$var$v8.split(".");
    $13a612880c36bbbc$var$version = $13a612880c36bbbc$var$match[0] < 4 ? 1 : $13a612880c36bbbc$var$match[0] + $13a612880c36bbbc$var$match[1];
} else if ($fQnZT) {
    $13a612880c36bbbc$var$match = $fQnZT.match(/Edge\/(\d+)/);
    if (!$13a612880c36bbbc$var$match || $13a612880c36bbbc$var$match[1] >= 74) {
        $13a612880c36bbbc$var$match = $fQnZT.match(/Chrome\/(\d+)/);
        if ($13a612880c36bbbc$var$match) $13a612880c36bbbc$var$version = $13a612880c36bbbc$var$match[1];
    }
}
module.exports = $13a612880c36bbbc$var$version && +$13a612880c36bbbc$var$version;

});
parcelRequire.register("fQnZT", function(module, exports) {

var $eQ8UB = parcelRequire("eQ8UB");
module.exports = $eQ8UB("navigator", "userAgent") || "";

});





parcelRequire.register("hJm3h", function(module, exports) {

var $jQlt5 = parcelRequire("jQlt5");
// `GetMethod` abstract operation
// https://tc39.es/ecma262/#sec-getmethod
module.exports = function(V, P) {
    var func = V[P];
    return func == null ? undefined : $jQlt5(func);
};

});
parcelRequire.register("jQlt5", function(module, exports) {

var $gFh7K = parcelRequire("gFh7K");

var $cHfyJ = parcelRequire("cHfyJ");
// `Assert: IsCallable(argument) is true`
module.exports = function(argument) {
    if ($gFh7K(argument)) return argument;
    throw TypeError($cHfyJ(argument) + " is not a function");
};

});
parcelRequire.register("cHfyJ", function(module, exports) {
module.exports = function(argument) {
    try {
        return String(argument);
    } catch (error) {
        return "Object";
    }
};

});



parcelRequire.register("ddKV3", function(module, exports) {

var $gFh7K = parcelRequire("gFh7K");

var $kYoIs = parcelRequire("kYoIs");
// `OrdinaryToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-ordinarytoprimitive
module.exports = function(input, pref) {
    var fn, val;
    if (pref === "string" && $gFh7K(fn = input.toString) && !$kYoIs(val = fn.call(input))) return val;
    if ($gFh7K(fn = input.valueOf) && !$kYoIs(val = fn.call(input))) return val;
    if (pref !== "string" && $gFh7K(fn = input.toString) && !$kYoIs(val = fn.call(input))) return val;
    throw TypeError("Can't convert object to primitive value");
};

});

parcelRequire.register("17MDU", function(module, exports) {

var $37Rkl = parcelRequire("37Rkl");

var $wetcs = parcelRequire("wetcs");

var $iKbD9 = parcelRequire("iKbD9");

var $gKS42 = parcelRequire("gKS42");

var $e4Od9 = parcelRequire("e4Od9");

var $5KF29 = parcelRequire("5KF29");
var $0d1c2d54535a78a5$var$WellKnownSymbolsStore = $wetcs("wks");
var $0d1c2d54535a78a5$var$Symbol = $37Rkl.Symbol;
var $0d1c2d54535a78a5$var$createWellKnownSymbol = $5KF29 ? $0d1c2d54535a78a5$var$Symbol : $0d1c2d54535a78a5$var$Symbol && $0d1c2d54535a78a5$var$Symbol.withoutSetter || $gKS42;
module.exports = function(name) {
    if (!$iKbD9($0d1c2d54535a78a5$var$WellKnownSymbolsStore, name) || !($e4Od9 || typeof $0d1c2d54535a78a5$var$WellKnownSymbolsStore[name] == "string")) {
        if ($e4Od9 && $iKbD9($0d1c2d54535a78a5$var$Symbol, name)) $0d1c2d54535a78a5$var$WellKnownSymbolsStore[name] = $0d1c2d54535a78a5$var$Symbol[name];
        else $0d1c2d54535a78a5$var$WellKnownSymbolsStore[name] = $0d1c2d54535a78a5$var$createWellKnownSymbol("Symbol." + name);
    }
    return $0d1c2d54535a78a5$var$WellKnownSymbolsStore[name];
};

});
parcelRequire.register("wetcs", function(module, exports) {

var $jjeeA = parcelRequire("jjeeA");

var $3t0l6 = parcelRequire("3t0l6");
(module.exports = function(key, value) {
    return $3t0l6[key] || ($3t0l6[key] = value !== undefined ? value : {});
})("versions", []).push({
    version: "3.18.3",
    mode: $jjeeA ? "pure" : "global",
    copyright: "\xa9 2021 Denis Pushkarev (zloirock.ru)"
});

});
parcelRequire.register("jjeeA", function(module, exports) {
module.exports = false;

});

parcelRequire.register("3t0l6", function(module, exports) {

var $37Rkl = parcelRequire("37Rkl");

var $cNHSE = parcelRequire("cNHSE");
var $286457f0103828b0$var$SHARED = "__core-js_shared__";
var $286457f0103828b0$var$store = $37Rkl[$286457f0103828b0$var$SHARED] || $cNHSE($286457f0103828b0$var$SHARED, {});
module.exports = $286457f0103828b0$var$store;

});
parcelRequire.register("cNHSE", function(module, exports) {

var $37Rkl = parcelRequire("37Rkl");
module.exports = function(key, value) {
    try {
        // eslint-disable-next-line es/no-object-defineproperty -- safe
        Object.defineProperty($37Rkl, key, {
            value: value,
            configurable: true,
            writable: true
        });
    } catch (error) {
        $37Rkl[key] = value;
    }
    return value;
};

});



parcelRequire.register("iKbD9", function(module, exports) {

var $2as9U = parcelRequire("2as9U");
var $da558b768c5510e0$var$hasOwnProperty = {}.hasOwnProperty;
// `HasOwnProperty` abstract operation
// https://tc39.es/ecma262/#sec-hasownproperty
module.exports = Object.hasOwn || function hasOwn(it, key) {
    return $da558b768c5510e0$var$hasOwnProperty.call($2as9U(it), key);
};

});
parcelRequire.register("2as9U", function(module, exports) {

var $21Mei = parcelRequire("21Mei");
// `ToObject` abstract operation
// https://tc39.es/ecma262/#sec-toobject
module.exports = function(argument) {
    return Object($21Mei(argument));
};

});


parcelRequire.register("gKS42", function(module, exports) {
var $c32ae13d97174cf5$var$id = 0;
var $c32ae13d97174cf5$var$postfix = Math.random();
module.exports = function(key) {
    return "Symbol(" + String(key === undefined ? "" : key) + ")_" + (++$c32ae13d97174cf5$var$id + $c32ae13d97174cf5$var$postfix).toString(36);
};

});




parcelRequire.register("jCPV4", function(module, exports) {

var $fmfcF = parcelRequire("fmfcF");

var $62TeD = parcelRequire("62TeD");

var $d1TyQ = parcelRequire("d1TyQ");
// Thank's IE8 for his funny defineProperty
module.exports = !$fmfcF && !$62TeD(function() {
    // eslint-disable-next-line es/no-object-defineproperty -- requied for testing
    return Object.defineProperty($d1TyQ("div"), "a", {
        get: function() {
            return 7;
        }
    }).a != 7;
});

});
parcelRequire.register("d1TyQ", function(module, exports) {

var $37Rkl = parcelRequire("37Rkl");

var $kYoIs = parcelRequire("kYoIs");
var $97c6779bde170f0a$var$document = $37Rkl.document;
// typeof document.createElement is 'object' in old IE
var $97c6779bde170f0a$var$EXISTS = $kYoIs($97c6779bde170f0a$var$document) && $kYoIs($97c6779bde170f0a$var$document.createElement);
module.exports = function(it) {
    return $97c6779bde170f0a$var$EXISTS ? $97c6779bde170f0a$var$document.createElement(it) : {};
};

});



parcelRequire.register("7dP0H", function(module, exports) {

var $fmfcF = parcelRequire("fmfcF");

var $aGY0C = parcelRequire("aGY0C");

var $iQ4Aq = parcelRequire("iQ4Aq");
module.exports = $fmfcF ? function(object, key, value) {
    return $aGY0C.f(object, key, $iQ4Aq(1, value));
} : function(object, key, value) {
    object[key] = value;
    return object;
};

});
parcelRequire.register("aGY0C", function(module, exports) {

$parcel$export(module.exports, "f", () => $7c8c6023b780bb65$export$2d1720544b23b823, (v) => $7c8c6023b780bb65$export$2d1720544b23b823 = v);
// `Object.defineProperty` method
// https://tc39.es/ecma262/#sec-object.defineproperty
var $7c8c6023b780bb65$export$2d1720544b23b823;

var $fmfcF = parcelRequire("fmfcF");

var $jCPV4 = parcelRequire("jCPV4");

var $5ctHK = parcelRequire("5ctHK");

var $4SxP3 = parcelRequire("4SxP3");
// eslint-disable-next-line es/no-object-defineproperty -- safe
var $7c8c6023b780bb65$var$$defineProperty = Object.defineProperty;
$7c8c6023b780bb65$export$2d1720544b23b823 = $fmfcF ? $7c8c6023b780bb65$var$$defineProperty : function defineProperty(O, P, Attributes) {
    $5ctHK(O);
    P = $4SxP3(P);
    $5ctHK(Attributes);
    if ($jCPV4) try {
        return $7c8c6023b780bb65$var$$defineProperty(O, P, Attributes);
    } catch (error) {}
    if ("get" in Attributes || "set" in Attributes) throw TypeError("Accessors not supported");
    if ("value" in Attributes) O[P] = Attributes.value;
    return O;
};

});
parcelRequire.register("5ctHK", function(module, exports) {

var $kYoIs = parcelRequire("kYoIs");
// `Assert: Type(argument) is Object`
module.exports = function(argument) {
    if ($kYoIs(argument)) return argument;
    throw TypeError(String(argument) + " is not an object");
};

});



parcelRequire.register("jwwDv", function(module, exports) {

var $37Rkl = parcelRequire("37Rkl");

var $gFh7K = parcelRequire("gFh7K");

var $iKbD9 = parcelRequire("iKbD9");

var $7dP0H = parcelRequire("7dP0H");

var $cNHSE = parcelRequire("cNHSE");

var $fbFcO = parcelRequire("fbFcO");

var $hlm9n = parcelRequire("hlm9n");

var $9jNV5 = parcelRequire("9jNV5");
var $e36a5252ac0cd2dc$require$CONFIGURABLE_FUNCTION_NAME = $9jNV5.CONFIGURABLE;
var $e36a5252ac0cd2dc$var$getInternalState = $hlm9n.get;
var $e36a5252ac0cd2dc$var$enforceInternalState = $hlm9n.enforce;
var $e36a5252ac0cd2dc$var$TEMPLATE = String(String).split("String");
(module.exports = function(O, key, value, options) {
    var unsafe = options ? !!options.unsafe : false;
    var simple = options ? !!options.enumerable : false;
    var noTargetGet = options ? !!options.noTargetGet : false;
    var name = options && options.name !== undefined ? options.name : key;
    var state;
    if ($gFh7K(value)) {
        if (String(name).slice(0, 7) === "Symbol(") name = "[" + String(name).replace(/^Symbol\(([^)]*)\)/, "$1") + "]";
        if (!$iKbD9(value, "name") || $e36a5252ac0cd2dc$require$CONFIGURABLE_FUNCTION_NAME && value.name !== name) $7dP0H(value, "name", name);
        state = $e36a5252ac0cd2dc$var$enforceInternalState(value);
        if (!state.source) state.source = $e36a5252ac0cd2dc$var$TEMPLATE.join(typeof name == "string" ? name : "");
    }
    if (O === $37Rkl) {
        if (simple) O[key] = value;
        else $cNHSE(key, value);
        return;
    } else if (!unsafe) delete O[key];
    else if (!noTargetGet && O[key]) simple = true;
    if (simple) O[key] = value;
    else $7dP0H(O, key, value);
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
})(Function.prototype, "toString", function toString() {
    return $gFh7K(this) && $e36a5252ac0cd2dc$var$getInternalState(this).source || $fbFcO(this);
});

});
parcelRequire.register("fbFcO", function(module, exports) {

var $gFh7K = parcelRequire("gFh7K");

var $3t0l6 = parcelRequire("3t0l6");
var $b0e7d8a7f3b6e6cf$var$functionToString = Function.toString;
// this helper broken in `core-js@3.4.1-3.4.4`, so we can't use `shared` helper
if (!$gFh7K($3t0l6.inspectSource)) $3t0l6.inspectSource = function(it) {
    return $b0e7d8a7f3b6e6cf$var$functionToString.call(it);
};
module.exports = $3t0l6.inspectSource;

});

parcelRequire.register("hlm9n", function(module, exports) {

var $4sSAX = parcelRequire("4sSAX");

var $37Rkl = parcelRequire("37Rkl");

var $kYoIs = parcelRequire("kYoIs");

var $7dP0H = parcelRequire("7dP0H");

var $iKbD9 = parcelRequire("iKbD9");

var $3t0l6 = parcelRequire("3t0l6");

var $6c33k = parcelRequire("6c33k");

var $7UjRB = parcelRequire("7UjRB");
var $0342278e2b2600b4$var$OBJECT_ALREADY_INITIALIZED = "Object already initialized";
var $0342278e2b2600b4$var$WeakMap = $37Rkl.WeakMap;
var $0342278e2b2600b4$var$set, $0342278e2b2600b4$var$get, $0342278e2b2600b4$var$has;
var $0342278e2b2600b4$var$enforce = function(it) {
    return $0342278e2b2600b4$var$has(it) ? $0342278e2b2600b4$var$get(it) : $0342278e2b2600b4$var$set(it, {});
};
var $0342278e2b2600b4$var$getterFor = function(TYPE) {
    return function(it) {
        var state;
        if (!$kYoIs(it) || (state = $0342278e2b2600b4$var$get(it)).type !== TYPE) throw TypeError("Incompatible receiver, " + TYPE + " required");
        return state;
    };
};
if ($4sSAX || $3t0l6.state) {
    var $0342278e2b2600b4$var$store = $3t0l6.state || ($3t0l6.state = new $0342278e2b2600b4$var$WeakMap());
    var $0342278e2b2600b4$var$wmget = $0342278e2b2600b4$var$store.get;
    var $0342278e2b2600b4$var$wmhas = $0342278e2b2600b4$var$store.has;
    var $0342278e2b2600b4$var$wmset = $0342278e2b2600b4$var$store.set;
    $0342278e2b2600b4$var$set = function(it, metadata) {
        if ($0342278e2b2600b4$var$wmhas.call($0342278e2b2600b4$var$store, it)) throw new TypeError($0342278e2b2600b4$var$OBJECT_ALREADY_INITIALIZED);
        metadata.facade = it;
        $0342278e2b2600b4$var$wmset.call($0342278e2b2600b4$var$store, it, metadata);
        return metadata;
    };
    $0342278e2b2600b4$var$get = function(it) {
        return $0342278e2b2600b4$var$wmget.call($0342278e2b2600b4$var$store, it) || {};
    };
    $0342278e2b2600b4$var$has = function(it) {
        return $0342278e2b2600b4$var$wmhas.call($0342278e2b2600b4$var$store, it);
    };
} else {
    var $0342278e2b2600b4$var$STATE = $6c33k("state");
    $7UjRB[$0342278e2b2600b4$var$STATE] = true;
    $0342278e2b2600b4$var$set = function(it, metadata) {
        if ($iKbD9(it, $0342278e2b2600b4$var$STATE)) throw new TypeError($0342278e2b2600b4$var$OBJECT_ALREADY_INITIALIZED);
        metadata.facade = it;
        $7dP0H(it, $0342278e2b2600b4$var$STATE, metadata);
        return metadata;
    };
    $0342278e2b2600b4$var$get = function(it) {
        return $iKbD9(it, $0342278e2b2600b4$var$STATE) ? it[$0342278e2b2600b4$var$STATE] : {};
    };
    $0342278e2b2600b4$var$has = function(it) {
        return $iKbD9(it, $0342278e2b2600b4$var$STATE);
    };
}
module.exports = {
    set: $0342278e2b2600b4$var$set,
    get: $0342278e2b2600b4$var$get,
    has: $0342278e2b2600b4$var$has,
    enforce: $0342278e2b2600b4$var$enforce,
    getterFor: $0342278e2b2600b4$var$getterFor
};

});
parcelRequire.register("4sSAX", function(module, exports) {

var $37Rkl = parcelRequire("37Rkl");

var $gFh7K = parcelRequire("gFh7K");

var $fbFcO = parcelRequire("fbFcO");
var $340420664799cc66$var$WeakMap = $37Rkl.WeakMap;
module.exports = $gFh7K($340420664799cc66$var$WeakMap) && /native code/.test($fbFcO($340420664799cc66$var$WeakMap));

});

parcelRequire.register("6c33k", function(module, exports) {

var $wetcs = parcelRequire("wetcs");

var $gKS42 = parcelRequire("gKS42");
var $48263b3d7db3aefa$var$keys = $wetcs("keys");
module.exports = function(key) {
    return $48263b3d7db3aefa$var$keys[key] || ($48263b3d7db3aefa$var$keys[key] = $gKS42(key));
};

});

parcelRequire.register("7UjRB", function(module, exports) {
module.exports = {};

});


parcelRequire.register("9jNV5", function(module, exports) {

var $fmfcF = parcelRequire("fmfcF");

var $iKbD9 = parcelRequire("iKbD9");
var $6c8c9c6f8f327a78$var$FunctionPrototype = Function.prototype;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $6c8c9c6f8f327a78$var$getDescriptor = $fmfcF && Object.getOwnPropertyDescriptor;
var $6c8c9c6f8f327a78$var$EXISTS = $iKbD9($6c8c9c6f8f327a78$var$FunctionPrototype, "name");
// additional protection from minified / mangled / dropped function names
var $6c8c9c6f8f327a78$var$PROPER = $6c8c9c6f8f327a78$var$EXISTS && (function something() {}).name === "something";
var $6c8c9c6f8f327a78$var$CONFIGURABLE = $6c8c9c6f8f327a78$var$EXISTS && (!$fmfcF || $fmfcF && $6c8c9c6f8f327a78$var$getDescriptor($6c8c9c6f8f327a78$var$FunctionPrototype, "name").configurable);
module.exports = {
    EXISTS: $6c8c9c6f8f327a78$var$EXISTS,
    PROPER: $6c8c9c6f8f327a78$var$PROPER,
    CONFIGURABLE: $6c8c9c6f8f327a78$var$CONFIGURABLE
};

});


parcelRequire.register("h4YmI", function(module, exports) {

var $iKbD9 = parcelRequire("iKbD9");

var $fSw74 = parcelRequire("fSw74");

var $04VBW = parcelRequire("04VBW");

var $aGY0C = parcelRequire("aGY0C");
module.exports = function(target, source) {
    var keys = $fSw74(source);
    var defineProperty = $aGY0C.f;
    var getOwnPropertyDescriptor = $04VBW.f;
    for(var i = 0; i < keys.length; i++){
        var key = keys[i];
        if (!$iKbD9(target, key)) defineProperty(target, key, getOwnPropertyDescriptor(source, key));
    }
};

});
parcelRequire.register("fSw74", function(module, exports) {

var $eQ8UB = parcelRequire("eQ8UB");

var $aGyPp = parcelRequire("aGyPp");

var $jhXBl = parcelRequire("jhXBl");

var $5ctHK = parcelRequire("5ctHK");
// all object keys, includes non-enumerable and symbols
module.exports = $eQ8UB("Reflect", "ownKeys") || function ownKeys(it) {
    var keys = $aGyPp.f($5ctHK(it));
    var getOwnPropertySymbols = $jhXBl.f;
    return getOwnPropertySymbols ? keys.concat(getOwnPropertySymbols(it)) : keys;
};

});
parcelRequire.register("aGyPp", function(module, exports) {

$parcel$export(module.exports, "f", () => $7c78d7c793bb95cd$export$2d1720544b23b823, (v) => $7c78d7c793bb95cd$export$2d1720544b23b823 = v);
// `Object.getOwnPropertyNames` method
// https://tc39.es/ecma262/#sec-object.getownpropertynames
// eslint-disable-next-line es/no-object-getownpropertynames -- safe
var $7c78d7c793bb95cd$export$2d1720544b23b823;

var $73u3Q = parcelRequire("73u3Q");

var $eLF4y = parcelRequire("eLF4y");
var $7c78d7c793bb95cd$var$hiddenKeys = $eLF4y.concat("length", "prototype");
$7c78d7c793bb95cd$export$2d1720544b23b823 = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
    return $73u3Q(O, $7c78d7c793bb95cd$var$hiddenKeys);
};

});
parcelRequire.register("73u3Q", function(module, exports) {

var $iKbD9 = parcelRequire("iKbD9");

var $iF2V1 = parcelRequire("iF2V1");

var $kmscd = parcelRequire("kmscd");
var $523021b551d787f1$require$indexOf = $kmscd.indexOf;

var $7UjRB = parcelRequire("7UjRB");
module.exports = function(object, names) {
    var O = $iF2V1(object);
    var i = 0;
    var result = [];
    var key;
    for(key in O)!$iKbD9($7UjRB, key) && $iKbD9(O, key) && result.push(key);
    // Don't enum bug & hidden keys
    while(names.length > i)if ($iKbD9(O, key = names[i++])) ~$523021b551d787f1$require$indexOf(result, key) || result.push(key);
    return result;
};

});
parcelRequire.register("kmscd", function(module, exports) {

var $iF2V1 = parcelRequire("iF2V1");

var $5oOzk = parcelRequire("5oOzk");

var $dZojt = parcelRequire("dZojt");
// `Array.prototype.{ indexOf, includes }` methods implementation
var $ed2bbbda378ccc4c$var$createMethod = function(IS_INCLUDES) {
    return function($this, el, fromIndex) {
        var O = $iF2V1($this);
        var length = $dZojt(O);
        var index = $5oOzk(fromIndex, length);
        var value;
        // Array#includes uses SameValueZero equality algorithm
        // eslint-disable-next-line no-self-compare -- NaN check
        if (IS_INCLUDES && el != el) while(length > index){
            value = O[index++];
            // eslint-disable-next-line no-self-compare -- NaN check
            if (value != value) return true;
        // Array#indexOf ignores holes, Array#includes - not
        }
        else for(; length > index; index++){
            if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
        }
        return !IS_INCLUDES && -1;
    };
};
module.exports = {
    // `Array.prototype.includes` method
    // https://tc39.es/ecma262/#sec-array.prototype.includes
    includes: $ed2bbbda378ccc4c$var$createMethod(true),
    // `Array.prototype.indexOf` method
    // https://tc39.es/ecma262/#sec-array.prototype.indexof
    indexOf: $ed2bbbda378ccc4c$var$createMethod(false)
};

});
parcelRequire.register("5oOzk", function(module, exports) {

var $2WK5G = parcelRequire("2WK5G");
var $3ee66b8a9f1bf7e3$var$max = Math.max;
var $3ee66b8a9f1bf7e3$var$min = Math.min;
// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
module.exports = function(index, length) {
    var integer = $2WK5G(index);
    return integer < 0 ? $3ee66b8a9f1bf7e3$var$max(integer + length, 0) : $3ee66b8a9f1bf7e3$var$min(integer, length);
};

});
parcelRequire.register("2WK5G", function(module, exports) {
var $2254c02e78196d63$var$ceil = Math.ceil;
var $2254c02e78196d63$var$floor = Math.floor;
// `ToIntegerOrInfinity` abstract operation
// https://tc39.es/ecma262/#sec-tointegerorinfinity
module.exports = function(argument) {
    var number = +argument;
    // eslint-disable-next-line no-self-compare -- safe
    return number !== number || number === 0 ? 0 : (number > 0 ? $2254c02e78196d63$var$floor : $2254c02e78196d63$var$ceil)(number);
};

});


parcelRequire.register("dZojt", function(module, exports) {

var $hSaYb = parcelRequire("hSaYb");
// `LengthOfArrayLike` abstract operation
// https://tc39.es/ecma262/#sec-lengthofarraylike
module.exports = function(obj) {
    return $hSaYb(obj.length);
};

});
parcelRequire.register("hSaYb", function(module, exports) {

var $2WK5G = parcelRequire("2WK5G");
var $035b9cdb6de86b74$var$min = Math.min;
// `ToLength` abstract operation
// https://tc39.es/ecma262/#sec-tolength
module.exports = function(argument) {
    return argument > 0 ? $035b9cdb6de86b74$var$min($2WK5G(argument), 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};

});




parcelRequire.register("eLF4y", function(module, exports) {
// IE8- don't enum bug keys
module.exports = [
    "constructor",
    "hasOwnProperty",
    "isPrototypeOf",
    "propertyIsEnumerable",
    "toLocaleString",
    "toString",
    "valueOf"
];

});


parcelRequire.register("jhXBl", function(module, exports) {

$parcel$export(module.exports, "f", () => $e0add6694a49a773$export$2d1720544b23b823, (v) => $e0add6694a49a773$export$2d1720544b23b823 = v);
// eslint-disable-next-line es/no-object-getownpropertysymbols -- safe
var $e0add6694a49a773$export$2d1720544b23b823;
$e0add6694a49a773$export$2d1720544b23b823 = Object.getOwnPropertySymbols;

});



parcelRequire.register("70Jxv", function(module, exports) {

var $62TeD = parcelRequire("62TeD");

var $gFh7K = parcelRequire("gFh7K");
var $51abdba787f583e3$var$replacement = /#|\.prototype\./;
var $51abdba787f583e3$var$isForced = function(feature, detection) {
    var value = $51abdba787f583e3$var$data[$51abdba787f583e3$var$normalize(feature)];
    return value == $51abdba787f583e3$var$POLYFILL ? true : value == $51abdba787f583e3$var$NATIVE ? false : $gFh7K(detection) ? $62TeD(detection) : !!detection;
};
var $51abdba787f583e3$var$normalize = $51abdba787f583e3$var$isForced.normalize = function(string) {
    return String(string).replace($51abdba787f583e3$var$replacement, ".").toLowerCase();
};
var $51abdba787f583e3$var$data = $51abdba787f583e3$var$isForced.data = {};
var $51abdba787f583e3$var$NATIVE = $51abdba787f583e3$var$isForced.NATIVE = "N";
var $51abdba787f583e3$var$POLYFILL = $51abdba787f583e3$var$isForced.POLYFILL = "P";
module.exports = $51abdba787f583e3$var$isForced;

});


parcelRequire.register("aJWrQ", function(module, exports) {
"use strict";

var $eMjwX = parcelRequire("eMjwX");

var $iitxL = parcelRequire("iitxL");

var $lB0w7 = parcelRequire("lB0w7");

var $wetcs = parcelRequire("wetcs");

var $5dDZE = parcelRequire("5dDZE");

var $hlm9n = parcelRequire("hlm9n");
var $7d1b71e8be9dea7e$require$getInternalState = $hlm9n.get;

var $gGENt = parcelRequire("gGENt");

var $6cV4E = parcelRequire("6cV4E");
var $7d1b71e8be9dea7e$var$nativeExec = RegExp.prototype.exec;
var $7d1b71e8be9dea7e$var$nativeReplace = $wetcs("native-string-replace", String.prototype.replace);
var $7d1b71e8be9dea7e$var$patchedExec = $7d1b71e8be9dea7e$var$nativeExec;
var $7d1b71e8be9dea7e$var$UPDATES_LAST_INDEX_WRONG = function() {
    var re1 = /a/;
    var re2 = /b*/g;
    $7d1b71e8be9dea7e$var$nativeExec.call(re1, "a");
    $7d1b71e8be9dea7e$var$nativeExec.call(re2, "a");
    return re1.lastIndex !== 0 || re2.lastIndex !== 0;
}();
var $7d1b71e8be9dea7e$var$UNSUPPORTED_Y = $lB0w7.UNSUPPORTED_Y || $lB0w7.BROKEN_CARET;
// nonparticipating capturing group, copied from es5-shim's String#split patch.
var $7d1b71e8be9dea7e$var$NPCG_INCLUDED = /()??/.exec("")[1] !== undefined;
var $7d1b71e8be9dea7e$var$PATCH = $7d1b71e8be9dea7e$var$UPDATES_LAST_INDEX_WRONG || $7d1b71e8be9dea7e$var$NPCG_INCLUDED || $7d1b71e8be9dea7e$var$UNSUPPORTED_Y || $gGENt || $6cV4E;
if ($7d1b71e8be9dea7e$var$PATCH) // eslint-disable-next-line max-statements -- TODO
$7d1b71e8be9dea7e$var$patchedExec = function exec(string) {
    var re = this;
    var state = $7d1b71e8be9dea7e$require$getInternalState(re);
    var str = $eMjwX(string);
    var raw = state.raw;
    var result, reCopy, lastIndex, match, i, object, group;
    if (raw) {
        raw.lastIndex = re.lastIndex;
        result = $7d1b71e8be9dea7e$var$patchedExec.call(raw, str);
        re.lastIndex = raw.lastIndex;
        return result;
    }
    var groups = state.groups;
    var sticky = $7d1b71e8be9dea7e$var$UNSUPPORTED_Y && re.sticky;
    var flags = $iitxL.call(re);
    var source = re.source;
    var charsAdded = 0;
    var strCopy = str;
    if (sticky) {
        flags = flags.replace("y", "");
        if (flags.indexOf("g") === -1) flags += "g";
        strCopy = str.slice(re.lastIndex);
        // Support anchored sticky behavior.
        if (re.lastIndex > 0 && (!re.multiline || re.multiline && str.charAt(re.lastIndex - 1) !== "\n")) {
            source = "(?: " + source + ")";
            strCopy = " " + strCopy;
            charsAdded++;
        }
        // ^(? + rx + ) is needed, in combination with some str slicing, to
        // simulate the 'y' flag.
        reCopy = new RegExp("^(?:" + source + ")", flags);
    }
    if ($7d1b71e8be9dea7e$var$NPCG_INCLUDED) reCopy = new RegExp("^" + source + "$(?!\\s)", flags);
    if ($7d1b71e8be9dea7e$var$UPDATES_LAST_INDEX_WRONG) lastIndex = re.lastIndex;
    match = $7d1b71e8be9dea7e$var$nativeExec.call(sticky ? reCopy : re, strCopy);
    if (sticky) {
        if (match) {
            match.input = match.input.slice(charsAdded);
            match[0] = match[0].slice(charsAdded);
            match.index = re.lastIndex;
            re.lastIndex += match[0].length;
        } else re.lastIndex = 0;
    } else if ($7d1b71e8be9dea7e$var$UPDATES_LAST_INDEX_WRONG && match) re.lastIndex = re.global ? match.index + match[0].length : lastIndex;
    if ($7d1b71e8be9dea7e$var$NPCG_INCLUDED && match && match.length > 1) // Fix browsers whose `exec` methods don't consistently return `undefined`
    // for NPCG, like IE8. NOTE: This doesn' work for /(.?)?/
    $7d1b71e8be9dea7e$var$nativeReplace.call(match[0], reCopy, function() {
        for(i = 1; i < arguments.length - 2; i++)if (arguments[i] === undefined) match[i] = undefined;
    });
    if (match && groups) {
        match.groups = object = $5dDZE(null);
        for(i = 0; i < groups.length; i++){
            group = groups[i];
            object[group[0]] = match[group[1]];
        }
    }
    return match;
};
module.exports = $7d1b71e8be9dea7e$var$patchedExec;

});
parcelRequire.register("eMjwX", function(module, exports) {

var $1pu0U = parcelRequire("1pu0U");
module.exports = function(argument) {
    if ($1pu0U(argument) === "Symbol") throw TypeError("Cannot convert a Symbol value to a string");
    return String(argument);
};

});
parcelRequire.register("1pu0U", function(module, exports) {

var $fTAyK = parcelRequire("fTAyK");

var $gFh7K = parcelRequire("gFh7K");

var $5i93Z = parcelRequire("5i93Z");

var $17MDU = parcelRequire("17MDU");
var $106f684ec48c66d5$var$TO_STRING_TAG = $17MDU("toStringTag");
// ES3 wrong here
var $106f684ec48c66d5$var$CORRECT_ARGUMENTS = $5i93Z(function() {
    return arguments;
}()) == "Arguments";
// fallback for IE11 Script Access Denied error
var $106f684ec48c66d5$var$tryGet = function(it, key) {
    try {
        return it[key];
    } catch (error) {}
};
// getting tag from ES6+ `Object.prototype.toString`
module.exports = $fTAyK ? $5i93Z : function(it) {
    var O, tag, result;
    return it === undefined ? "Undefined" : it === null ? "Null" : typeof (tag = $106f684ec48c66d5$var$tryGet(O = Object(it), $106f684ec48c66d5$var$TO_STRING_TAG)) == "string" ? tag : $106f684ec48c66d5$var$CORRECT_ARGUMENTS ? $5i93Z(O) : (result = $5i93Z(O)) == "Object" && $gFh7K(O.callee) ? "Arguments" : result;
};

});
parcelRequire.register("fTAyK", function(module, exports) {

var $17MDU = parcelRequire("17MDU");
var $b9285a0760884fd8$var$TO_STRING_TAG = $17MDU("toStringTag");
var $b9285a0760884fd8$var$test = {};
$b9285a0760884fd8$var$test[$b9285a0760884fd8$var$TO_STRING_TAG] = "z";
module.exports = String($b9285a0760884fd8$var$test) === "[object z]";

});



parcelRequire.register("iitxL", function(module, exports) {
"use strict";

var $5ctHK = parcelRequire("5ctHK");
// `RegExp.prototype.flags` getter implementation
// https://tc39.es/ecma262/#sec-get-regexp.prototype.flags
module.exports = function() {
    var that = $5ctHK(this);
    var result = "";
    if (that.global) result += "g";
    if (that.ignoreCase) result += "i";
    if (that.multiline) result += "m";
    if (that.dotAll) result += "s";
    if (that.unicode) result += "u";
    if (that.sticky) result += "y";
    return result;
};

});

parcelRequire.register("lB0w7", function(module, exports) {

$parcel$export(module.exports, "UNSUPPORTED_Y", () => $fb8d7453b96a34c1$export$b0fd0ca1c5a3f02d, (v) => $fb8d7453b96a34c1$export$b0fd0ca1c5a3f02d = v);
$parcel$export(module.exports, "BROKEN_CARET", () => $fb8d7453b96a34c1$export$98ecc64ba9a7065f, (v) => $fb8d7453b96a34c1$export$98ecc64ba9a7065f = v);
var $fb8d7453b96a34c1$export$b0fd0ca1c5a3f02d;
var $fb8d7453b96a34c1$export$98ecc64ba9a7065f;

var $62TeD = parcelRequire("62TeD");

var $37Rkl = parcelRequire("37Rkl");
// babel-minify and Closure Compiler transpiles RegExp('a', 'y') -> /a/y and it causes SyntaxError
var $fb8d7453b96a34c1$var$$RegExp = $37Rkl.RegExp;
$fb8d7453b96a34c1$export$b0fd0ca1c5a3f02d = $62TeD(function() {
    var re = $fb8d7453b96a34c1$var$$RegExp("a", "y");
    re.lastIndex = 2;
    return re.exec("abcd") != null;
});
$fb8d7453b96a34c1$export$98ecc64ba9a7065f = $62TeD(function() {
    // https://bugzilla.mozilla.org/show_bug.cgi?id=773687
    var re = $fb8d7453b96a34c1$var$$RegExp("^r", "gy");
    re.lastIndex = 2;
    return re.exec("str") != null;
});

});

parcelRequire.register("5dDZE", function(module, exports) {
/* global ActiveXObject -- old IE, WSH */ 
var $5ctHK = parcelRequire("5ctHK");

var $7fFuP = parcelRequire("7fFuP");

var $eLF4y = parcelRequire("eLF4y");

var $7UjRB = parcelRequire("7UjRB");

var $jnwiG = parcelRequire("jnwiG");

var $d1TyQ = parcelRequire("d1TyQ");

var $6c33k = parcelRequire("6c33k");
var $3ccd307defa9bfde$var$GT = ">";
var $3ccd307defa9bfde$var$LT = "<";
var $3ccd307defa9bfde$var$PROTOTYPE = "prototype";
var $3ccd307defa9bfde$var$SCRIPT = "script";
var $3ccd307defa9bfde$var$IE_PROTO = $6c33k("IE_PROTO");
var $3ccd307defa9bfde$var$EmptyConstructor = function() {};
var $3ccd307defa9bfde$var$scriptTag = function(content) {
    return $3ccd307defa9bfde$var$LT + $3ccd307defa9bfde$var$SCRIPT + $3ccd307defa9bfde$var$GT + content + $3ccd307defa9bfde$var$LT + "/" + $3ccd307defa9bfde$var$SCRIPT + $3ccd307defa9bfde$var$GT;
};
// Create object with fake `null` prototype: use ActiveX Object with cleared prototype
var $3ccd307defa9bfde$var$NullProtoObjectViaActiveX = function(activeXDocument) {
    activeXDocument.write($3ccd307defa9bfde$var$scriptTag(""));
    activeXDocument.close();
    var temp = activeXDocument.parentWindow.Object;
    activeXDocument = null; // avoid memory leak
    return temp;
};
// Create object with fake `null` prototype: use iframe Object with cleared prototype
var $3ccd307defa9bfde$var$NullProtoObjectViaIFrame = function() {
    // Thrash, waste and sodomy: IE GC bug
    var iframe = $d1TyQ("iframe");
    var JS = "java" + $3ccd307defa9bfde$var$SCRIPT + ":";
    var iframeDocument;
    iframe.style.display = "none";
    $jnwiG.appendChild(iframe);
    // https://github.com/zloirock/core-js/issues/475
    iframe.src = String(JS);
    iframeDocument = iframe.contentWindow.document;
    iframeDocument.open();
    iframeDocument.write($3ccd307defa9bfde$var$scriptTag("document.F=Object"));
    iframeDocument.close();
    return iframeDocument.F;
};
// Check for document.domain and active x support
// No need to use active x approach when document.domain is not set
// see https://github.com/es-shims/es5-shim/issues/150
// variation of https://github.com/kitcambridge/es5-shim/commit/4f738ac066346
// avoid IE GC bug
var $3ccd307defa9bfde$var$activeXDocument;
var $3ccd307defa9bfde$var$NullProtoObject = function() {
    try {
        $3ccd307defa9bfde$var$activeXDocument = new ActiveXObject("htmlfile");
    } catch (error) {}
    $3ccd307defa9bfde$var$NullProtoObject = typeof document != "undefined" ? document.domain && $3ccd307defa9bfde$var$activeXDocument ? $3ccd307defa9bfde$var$NullProtoObjectViaActiveX($3ccd307defa9bfde$var$activeXDocument) // old IE
     : $3ccd307defa9bfde$var$NullProtoObjectViaIFrame() : $3ccd307defa9bfde$var$NullProtoObjectViaActiveX($3ccd307defa9bfde$var$activeXDocument); // WSH
    var length = $eLF4y.length;
    while(length--)delete $3ccd307defa9bfde$var$NullProtoObject[$3ccd307defa9bfde$var$PROTOTYPE][$eLF4y[length]];
    return $3ccd307defa9bfde$var$NullProtoObject();
};
$7UjRB[$3ccd307defa9bfde$var$IE_PROTO] = true;
// `Object.create` method
// https://tc39.es/ecma262/#sec-object.create
module.exports = Object.create || function create(O, Properties) {
    var result;
    if (O !== null) {
        $3ccd307defa9bfde$var$EmptyConstructor[$3ccd307defa9bfde$var$PROTOTYPE] = $5ctHK(O);
        result = new $3ccd307defa9bfde$var$EmptyConstructor();
        $3ccd307defa9bfde$var$EmptyConstructor[$3ccd307defa9bfde$var$PROTOTYPE] = null;
        // add "__proto__" for Object.getPrototypeOf polyfill
        result[$3ccd307defa9bfde$var$IE_PROTO] = O;
    } else result = $3ccd307defa9bfde$var$NullProtoObject();
    return Properties === undefined ? result : $7fFuP(result, Properties);
};

});
parcelRequire.register("7fFuP", function(module, exports) {

var $fmfcF = parcelRequire("fmfcF");

var $aGY0C = parcelRequire("aGY0C");

var $5ctHK = parcelRequire("5ctHK");

var $38VJs = parcelRequire("38VJs");
// `Object.defineProperties` method
// https://tc39.es/ecma262/#sec-object.defineproperties
// eslint-disable-next-line es/no-object-defineproperties -- safe
module.exports = $fmfcF ? Object.defineProperties : function defineProperties(O, Properties) {
    $5ctHK(O);
    var keys = $38VJs(Properties);
    var length = keys.length;
    var index = 0;
    var key;
    while(length > index)$aGY0C.f(O, key = keys[index++], Properties[key]);
    return O;
};

});
parcelRequire.register("38VJs", function(module, exports) {

var $73u3Q = parcelRequire("73u3Q");

var $eLF4y = parcelRequire("eLF4y");
// `Object.keys` method
// https://tc39.es/ecma262/#sec-object.keys
// eslint-disable-next-line es/no-object-keys -- safe
module.exports = Object.keys || function keys(O) {
    return $73u3Q(O, $eLF4y);
};

});


parcelRequire.register("jnwiG", function(module, exports) {

var $eQ8UB = parcelRequire("eQ8UB");
module.exports = $eQ8UB("document", "documentElement");

});


parcelRequire.register("gGENt", function(module, exports) {

var $62TeD = parcelRequire("62TeD");

var $37Rkl = parcelRequire("37Rkl");
// babel-minify and Closure Compiler transpiles RegExp('.', 's') -> /./s and it causes SyntaxError
var $c26037076fae7d61$var$$RegExp = $37Rkl.RegExp;
module.exports = $62TeD(function() {
    var re = $c26037076fae7d61$var$$RegExp(".", "s");
    return !(re.dotAll && re.exec("\n") && re.flags === "s");
});

});

parcelRequire.register("6cV4E", function(module, exports) {

var $62TeD = parcelRequire("62TeD");

var $37Rkl = parcelRequire("37Rkl");
// babel-minify and Closure Compiler transpiles RegExp('(?<a>b)', 'g') -> /(?<a>b)/g and it causes SyntaxError
var $485022c8ad65b22a$var$$RegExp = $37Rkl.RegExp;
module.exports = $62TeD(function() {
    var re = $485022c8ad65b22a$var$$RegExp("(?<a>b)", "g");
    return re.exec("b").groups.a !== "b" || "b".replace(re, "$<a>c") !== "bc";
});

});



parcelRequire.register("1d9nZ", function(module, exports) {
"use strict";

var $dyWSt = parcelRequire("dyWSt");

var $62TeD = parcelRequire("62TeD");

var $5ctHK = parcelRequire("5ctHK");

var $gFh7K = parcelRequire("gFh7K");

var $2WK5G = parcelRequire("2WK5G");

var $hSaYb = parcelRequire("hSaYb");

var $eMjwX = parcelRequire("eMjwX");

var $21Mei = parcelRequire("21Mei");

var $hXViK = parcelRequire("hXViK");

var $hJm3h = parcelRequire("hJm3h");

var $7tCjo = parcelRequire("7tCjo");

var $cnQUP = parcelRequire("cnQUP");

var $17MDU = parcelRequire("17MDU");
var $0e1e49302fab6594$var$REPLACE = $17MDU("replace");
var $0e1e49302fab6594$var$max = Math.max;
var $0e1e49302fab6594$var$min = Math.min;
var $0e1e49302fab6594$var$maybeToString = function(it) {
    return it === undefined ? it : String(it);
};
// IE <= 11 replaces $0 with the whole match, as if it was $&
// https://stackoverflow.com/questions/6024666/getting-ie-to-replace-a-regex-with-the-literal-string-0
var $0e1e49302fab6594$var$REPLACE_KEEPS_$0 = function() {
    // eslint-disable-next-line regexp/prefer-escape-replacement-dollar-char -- required for testing
    return "a".replace(/./, "$0") === "$0";
}();
// Safari <= 13.0.3(?) substitutes nth capture where n>m with an empty string
var $0e1e49302fab6594$var$REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE = function() {
    if (/./[$0e1e49302fab6594$var$REPLACE]) return /./[$0e1e49302fab6594$var$REPLACE]("a", "$0") === "";
    return false;
}();
var $0e1e49302fab6594$var$REPLACE_SUPPORTS_NAMED_GROUPS = !$62TeD(function() {
    var re = /./;
    re.exec = function() {
        var result = [];
        result.groups = {
            a: "7"
        };
        return result;
    };
    // eslint-disable-next-line regexp/no-useless-dollar-replacements -- false positive
    return "".replace(re, "$<a>") !== "7";
});
// @@replace logic
$dyWSt("replace", function(_, nativeReplace, maybeCallNative) {
    var UNSAFE_SUBSTITUTE = $0e1e49302fab6594$var$REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE ? "$" : "$0";
    return [
        // `String.prototype.replace` method
        // https://tc39.es/ecma262/#sec-string.prototype.replace
        function replace(searchValue, replaceValue) {
            var O = $21Mei(this);
            var replacer = searchValue == undefined ? undefined : $hJm3h(searchValue, $0e1e49302fab6594$var$REPLACE);
            return replacer ? replacer.call(searchValue, O, replaceValue) : nativeReplace.call($eMjwX(O), searchValue, replaceValue);
        },
        // `RegExp.prototype[@@replace]` method
        // https://tc39.es/ecma262/#sec-regexp.prototype-@@replace
        function(string, replaceValue) {
            var rx = $5ctHK(this);
            var S = $eMjwX(string);
            if (typeof replaceValue === "string" && replaceValue.indexOf(UNSAFE_SUBSTITUTE) === -1 && replaceValue.indexOf("$<") === -1) {
                var res = maybeCallNative(nativeReplace, rx, S, replaceValue);
                if (res.done) return res.value;
            }
            var functionalReplace = $gFh7K(replaceValue);
            if (!functionalReplace) replaceValue = $eMjwX(replaceValue);
            var global = rx.global;
            if (global) {
                var fullUnicode = rx.unicode;
                rx.lastIndex = 0;
            }
            var results = [];
            while(true){
                var result = $cnQUP(rx, S);
                if (result === null) break;
                results.push(result);
                if (!global) break;
                var matchStr = $eMjwX(result[0]);
                if (matchStr === "") rx.lastIndex = $hXViK(S, $hSaYb(rx.lastIndex), fullUnicode);
            }
            var accumulatedResult = "";
            var nextSourcePosition = 0;
            for(var i = 0; i < results.length; i++){
                result = results[i];
                var matched = $eMjwX(result[0]);
                var position = $0e1e49302fab6594$var$max($0e1e49302fab6594$var$min($2WK5G(result.index), S.length), 0);
                var captures = [];
                // NOTE: This is equivalent to
                //   captures = result.slice(1).map(maybeToString)
                // but for some reason `nativeSlice.call(result, 1, result.length)` (called in
                // the slice polyfill when slicing native arrays) "doesn't work" in safari 9 and
                // causes a crash (https://pastebin.com/N21QzeQA) when trying to debug it.
                for(var j = 1; j < result.length; j++)captures.push($0e1e49302fab6594$var$maybeToString(result[j]));
                var namedCaptures = result.groups;
                if (functionalReplace) {
                    var replacerArgs = [
                        matched
                    ].concat(captures, position, S);
                    if (namedCaptures !== undefined) replacerArgs.push(namedCaptures);
                    var replacement = $eMjwX(replaceValue.apply(undefined, replacerArgs));
                } else replacement = $7tCjo(matched, S, position, captures, namedCaptures, replaceValue);
                if (position >= nextSourcePosition) {
                    accumulatedResult += S.slice(nextSourcePosition, position) + replacement;
                    nextSourcePosition = position + matched.length;
                }
            }
            return accumulatedResult + S.slice(nextSourcePosition);
        }
    ];
}, !$0e1e49302fab6594$var$REPLACE_SUPPORTS_NAMED_GROUPS || !$0e1e49302fab6594$var$REPLACE_KEEPS_$0 || $0e1e49302fab6594$var$REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE);

});
parcelRequire.register("dyWSt", function(module, exports) {
"use strict";
parcelRequire("cx6cd");

var $jwwDv = parcelRequire("jwwDv");

var $aJWrQ = parcelRequire("aJWrQ");

var $62TeD = parcelRequire("62TeD");

var $17MDU = parcelRequire("17MDU");

var $7dP0H = parcelRequire("7dP0H");
var $9dfc1f3613d911ce$var$SPECIES = $17MDU("species");
var $9dfc1f3613d911ce$var$RegExpPrototype = RegExp.prototype;
module.exports = function(KEY, exec, FORCED, SHAM) {
    var SYMBOL = $17MDU(KEY);
    var DELEGATES_TO_SYMBOL = !$62TeD(function() {
        // String methods call symbol-named RegEp methods
        var O = {};
        O[SYMBOL] = function() {
            return 7;
        };
        return ""[KEY](O) != 7;
    });
    var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL && !$62TeD(function() {
        // Symbol-named RegExp methods call .exec
        var execCalled = false;
        var re = /a/;
        if (KEY === "split") {
            // We can't use real regex here since it causes deoptimization
            // and serious performance degradation in V8
            // https://github.com/zloirock/core-js/issues/306
            re = {};
            // RegExp[@@split] doesn't call the regex's exec method, but first creates
            // a new one. We need to return the patched regex when creating the new one.
            re.constructor = {};
            re.constructor[$9dfc1f3613d911ce$var$SPECIES] = function() {
                return re;
            };
            re.flags = "";
            re[SYMBOL] = /./[SYMBOL];
        }
        re.exec = function() {
            execCalled = true;
            return null;
        };
        re[SYMBOL]("");
        return !execCalled;
    });
    if (!DELEGATES_TO_SYMBOL || !DELEGATES_TO_EXEC || FORCED) {
        var nativeRegExpMethod = /./[SYMBOL];
        var methods = exec(SYMBOL, ""[KEY], function(nativeMethod, regexp, str, arg2, forceStringMethod) {
            var $exec = regexp.exec;
            if ($exec === $aJWrQ || $exec === $9dfc1f3613d911ce$var$RegExpPrototype.exec) {
                if (DELEGATES_TO_SYMBOL && !forceStringMethod) // The native String method already delegates to @@method (this
                // polyfilled function), leasing to infinite recursion.
                // We avoid it by directly calling the native @@method method.
                return {
                    done: true,
                    value: nativeRegExpMethod.call(regexp, str, arg2)
                };
                return {
                    done: true,
                    value: nativeMethod.call(str, regexp, arg2)
                };
            }
            return {
                done: false
            };
        });
        $jwwDv(String.prototype, KEY, methods[0]);
        $jwwDv($9dfc1f3613d911ce$var$RegExpPrototype, SYMBOL, methods[1]);
    }
    if (SHAM) $7dP0H($9dfc1f3613d911ce$var$RegExpPrototype[SYMBOL], "sham", true);
};

});

parcelRequire.register("hXViK", function(module, exports) {
"use strict";

var $2b27F = parcelRequire("2b27F");
var $d14465381fdd9f63$require$charAt = $2b27F.charAt;
// `AdvanceStringIndex` abstract operation
// https://tc39.es/ecma262/#sec-advancestringindex
module.exports = function(S, index, unicode) {
    return index + (unicode ? $d14465381fdd9f63$require$charAt(S, index).length : 1);
};

});
parcelRequire.register("2b27F", function(module, exports) {

var $2WK5G = parcelRequire("2WK5G");

var $eMjwX = parcelRequire("eMjwX");

var $21Mei = parcelRequire("21Mei");
var $195e415cb9d5ea37$var$createMethod = function(CONVERT_TO_STRING) {
    return function($this, pos) {
        var S = $eMjwX($21Mei($this));
        var position = $2WK5G(pos);
        var size = S.length;
        var first, second;
        if (position < 0 || position >= size) return CONVERT_TO_STRING ? "" : undefined;
        first = S.charCodeAt(position);
        return first < 0xD800 || first > 0xDBFF || position + 1 === size || (second = S.charCodeAt(position + 1)) < 0xDC00 || second > 0xDFFF ? CONVERT_TO_STRING ? S.charAt(position) : first : CONVERT_TO_STRING ? S.slice(position, position + 2) : (first - 0xD800 << 10) + (second - 0xDC00) + 0x10000;
    };
};
module.exports = {
    // `String.prototype.codePointAt` method
    // https://tc39.es/ecma262/#sec-string.prototype.codepointat
    codeAt: $195e415cb9d5ea37$var$createMethod(false),
    // `String.prototype.at` method
    // https://github.com/mathiasbynens/String.prototype.at
    charAt: $195e415cb9d5ea37$var$createMethod(true)
};

});


parcelRequire.register("7tCjo", function(module, exports) {

var $2as9U = parcelRequire("2as9U");
var $5718f5c8cc4b895d$var$floor = Math.floor;
var $5718f5c8cc4b895d$var$replace = "".replace;
var $5718f5c8cc4b895d$var$SUBSTITUTION_SYMBOLS = /\$([$&'`]|\d{1,2}|<[^>]*>)/g;
var $5718f5c8cc4b895d$var$SUBSTITUTION_SYMBOLS_NO_NAMED = /\$([$&'`]|\d{1,2})/g;
// `GetSubstitution` abstract operation
// https://tc39.es/ecma262/#sec-getsubstitution
module.exports = function(matched, str, position, captures, namedCaptures, replacement) {
    var tailPos = position + matched.length;
    var m = captures.length;
    var symbols = $5718f5c8cc4b895d$var$SUBSTITUTION_SYMBOLS_NO_NAMED;
    if (namedCaptures !== undefined) {
        namedCaptures = $2as9U(namedCaptures);
        symbols = $5718f5c8cc4b895d$var$SUBSTITUTION_SYMBOLS;
    }
    return $5718f5c8cc4b895d$var$replace.call(replacement, symbols, function(match, ch) {
        var capture;
        switch(ch.charAt(0)){
            case "$":
                return "$";
            case "&":
                return matched;
            case "`":
                return str.slice(0, position);
            case "'":
                return str.slice(tailPos);
            case "<":
                capture = namedCaptures[ch.slice(1, -1)];
                break;
            default:
                var n = +ch;
                if (n === 0) return match;
                if (n > m) {
                    var f = $5718f5c8cc4b895d$var$floor(n / 10);
                    if (f === 0) return match;
                    if (f <= m) return captures[f - 1] === undefined ? ch.charAt(1) : captures[f - 1] + ch.charAt(1);
                    return match;
                }
                capture = captures[n - 1];
        }
        return capture === undefined ? "" : capture;
    });
};

});

parcelRequire.register("cnQUP", function(module, exports) {

var $5ctHK = parcelRequire("5ctHK");

var $gFh7K = parcelRequire("gFh7K");

var $5i93Z = parcelRequire("5i93Z");

var $aJWrQ = parcelRequire("aJWrQ");
// `RegExpExec` abstract operation
// https://tc39.es/ecma262/#sec-regexpexec
module.exports = function(R, S) {
    var exec = R.exec;
    if ($gFh7K(exec)) {
        var result = exec.call(R, S);
        if (result !== null) $5ctHK(result);
        return result;
    }
    if ($5i93Z(R) === "RegExp") return $aJWrQ.call(R, S);
    throw TypeError("RegExp#exec called on incompatible receiver");
};

});


parcelRequire.register("iihxo", function(module, exports) {

module.exports = (parcelRequire("fE6j3"));

});
parcelRequire.register("fE6j3", function(module, exports) {
parcelRequire("i9UxW");

var $lahb7 = parcelRequire("lahb7");
module.exports = $lahb7.setInterval;

});


parcelRequire.register("8hNpw", function(module, exports) {

module.exports = (parcelRequire("1ORIy"));

});

parcelRequire.register("13zC8", function(module, exports) {

module.exports = (parcelRequire("2GR1F"));

});

parcelRequire.register("3pOgb", function(module, exports) {

module.exports = (parcelRequire("b7Z0Q"));

});
parcelRequire.register("b7Z0Q", function(module, exports) {

var $gBQnf = parcelRequire("gBQnf");
module.exports = $gBQnf;

});
parcelRequire.register("gBQnf", function(module, exports) {

var $53bMe = parcelRequire("53bMe");

var $5KDwl = parcelRequire("5KDwl");
var $c178ba6e5c10b433$var$ArrayPrototype = Array.prototype;
module.exports = function(it) {
    var own = it.concat;
    return it === $c178ba6e5c10b433$var$ArrayPrototype || $53bMe($c178ba6e5c10b433$var$ArrayPrototype, it) && own === $c178ba6e5c10b433$var$ArrayPrototype.concat ? $5KDwl : own;
};

});
parcelRequire.register("5KDwl", function(module, exports) {
parcelRequire("ivmPy");

var $5zMeE = parcelRequire("5zMeE");
module.exports = $5zMeE("Array").concat;

});




parcelRequire.register("bUr91", function(module, exports) {

module.exports = (parcelRequire("aMvcW"));

});

parcelRequire.register("1Gk4M", function(module, exports) {

module.exports = (parcelRequire("yUPG4"));

});

parcelRequire.register("iPwyO", function(module, exports) {

module.exports = (parcelRequire("9sBSh"));

});

parcelRequire.register("hxEKj", function(module, exports) {

module.exports = (parcelRequire("22OqT"));

});

parcelRequire.register("gSduy", function(module, exports) {

module.exports = (parcelRequire("dUm40"));

});

parcelRequire.register("8JKeG", function(module, exports) {

module.exports = (parcelRequire("37Hff"));

});

parcelRequire.register("bFMiT", function(module, exports) {

module.exports = (parcelRequire("2Jh1Q"));

});

parcelRequire.register("erh1S", function(module, exports) {

module.exports = (parcelRequire("cRvva"));

});

parcelRequire.register("bzi9N", function(module, exports) {

module.exports = (parcelRequire("dJg8N"));

});

parcelRequire.register("d3vsa", function(module, exports) {

$parcel$export(module.exports, "default", () => $9813f422f9d9d803$export$2e2bcd8739ae039);

var $g3JES = parcelRequire("g3JES");

var $8ATmK = parcelRequire("8ATmK");

var $krJU9 = parcelRequire("krJU9");
function $9813f422f9d9d803$var$insertWithoutScoping(cache, serialized) {
    if (cache.inserted[serialized.name] === undefined) return cache.insert("", serialized, cache.sheet, true);
}
function $9813f422f9d9d803$var$merge(registered, css, className) {
    var registeredStyles = [];
    var rawClassName = (0, $krJU9.getRegisteredStyles)(registered, registeredStyles, className);
    if (registeredStyles.length < 2) return className;
    return rawClassName + css(registeredStyles);
}
var $9813f422f9d9d803$var$createEmotion = function createEmotion(options) {
    var cache = (0, $g3JES.default)(options); // $FlowFixMe
    cache.sheet.speedy = function(value) {
        this.isSpeedy = value;
    };
    cache.compat = true;
    var css = function css() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var serialized = (0, $8ATmK.serializeStyles)(args, cache.registered, undefined);
        (0, $krJU9.insertStyles)(cache, serialized, false);
        return cache.key + "-" + serialized.name;
    };
    var keyframes = function keyframes() {
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        var serialized = (0, $8ATmK.serializeStyles)(args, cache.registered);
        var animation = "animation-" + serialized.name;
        $9813f422f9d9d803$var$insertWithoutScoping(cache, {
            name: serialized.name,
            styles: "@keyframes " + animation + "{" + serialized.styles + "}"
        });
        return animation;
    };
    var injectGlobal = function injectGlobal() {
        for(var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)args[_key3] = arguments[_key3];
        var serialized = (0, $8ATmK.serializeStyles)(args, cache.registered);
        $9813f422f9d9d803$var$insertWithoutScoping(cache, serialized);
    };
    var cx = function cx() {
        for(var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++)args[_key4] = arguments[_key4];
        return $9813f422f9d9d803$var$merge(cache.registered, css, $9813f422f9d9d803$var$classnames(args));
    };
    return {
        css: css,
        cx: cx,
        injectGlobal: injectGlobal,
        keyframes: keyframes,
        hydrate: function hydrate(ids) {
            ids.forEach(function(key) {
                cache.inserted[key] = true;
            });
        },
        flush: function flush() {
            cache.registered = {};
            cache.inserted = {};
            cache.sheet.flush();
        },
        // $FlowFixMe
        sheet: cache.sheet,
        cache: cache,
        getRegisteredStyles: (0, $krJU9.getRegisteredStyles).bind(null, cache.registered),
        merge: $9813f422f9d9d803$var$merge.bind(null, cache.registered, css)
    };
};
var $9813f422f9d9d803$var$classnames = function classnames(args) {
    var cls = "";
    for(var i = 0; i < args.length; i++){
        var arg = args[i];
        if (arg == null) continue;
        var toAdd = void 0;
        switch(typeof arg){
            case "boolean":
                break;
            case "object":
                if (Array.isArray(arg)) toAdd = classnames(arg);
                else {
                    toAdd = "";
                    for(var k in arg)if (arg[k] && k) {
                        toAdd && (toAdd += " ");
                        toAdd += k;
                    }
                }
                break;
            default:
                toAdd = arg;
        }
        if (toAdd) {
            cls && (cls += " ");
            cls += toAdd;
        }
    }
    return cls;
};
var $9813f422f9d9d803$export$2e2bcd8739ae039 = $9813f422f9d9d803$var$createEmotion;

});

parcelRequire.register("6XRm4", function(module, exports) {

$parcel$export(module.exports, "default", () => $5121a3f516e09ad4$export$2e2bcd8739ae039);
parcelRequire("cx6cd");
parcelRequire("1d9nZ");
parcelRequire("jj4dU");
parcelRequire("WHk0s");
parcelRequire("8El2B");

var $atZsr = parcelRequire("atZsr");
function $5121a3f516e09ad4$export$2e2bcd8739ae039() {
    return (0, (/*@__PURE__*/$parcel$interopDefault($atZsr)))().toString(26).substr(2, 5).replace(/[0-9]/g, function(value) {
        return String.fromCharCode(value.charCodeAt(0) + 65);
    });
}

});
parcelRequire.register("jj4dU", function(module, exports) {

var $jwwDv = parcelRequire("jwwDv");
var $e0e31151489c24a9$var$DatePrototype = Date.prototype;
var $e0e31151489c24a9$var$INVALID_DATE = "Invalid Date";
var $e0e31151489c24a9$var$TO_STRING = "toString";
var $e0e31151489c24a9$var$nativeDateToString = $e0e31151489c24a9$var$DatePrototype[$e0e31151489c24a9$var$TO_STRING];
var $e0e31151489c24a9$var$getTime = $e0e31151489c24a9$var$DatePrototype.getTime;
// `Date.prototype.toString` method
// https://tc39.es/ecma262/#sec-date.prototype.tostring
if (String(new Date(NaN)) != $e0e31151489c24a9$var$INVALID_DATE) $jwwDv($e0e31151489c24a9$var$DatePrototype, $e0e31151489c24a9$var$TO_STRING, function toString() {
    var value = $e0e31151489c24a9$var$getTime.call(this);
    // eslint-disable-next-line no-self-compare -- NaN check
    return value === value ? $e0e31151489c24a9$var$nativeDateToString.call(this) : $e0e31151489c24a9$var$INVALID_DATE;
});

});

parcelRequire.register("WHk0s", function(module, exports) {

var $fTAyK = parcelRequire("fTAyK");

var $jwwDv = parcelRequire("jwwDv");

var $3sl4b = parcelRequire("3sl4b");
// `Object.prototype.toString` method
// https://tc39.es/ecma262/#sec-object.prototype.tostring
if (!$fTAyK) $jwwDv(Object.prototype, "toString", $3sl4b, {
    unsafe: true
});

});
parcelRequire.register("3sl4b", function(module, exports) {
"use strict";

var $fTAyK = parcelRequire("fTAyK");

var $1pu0U = parcelRequire("1pu0U");
// `Object.prototype.toString` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.tostring
module.exports = $fTAyK ? ({}).toString : function toString() {
    return "[object " + $1pu0U(this) + "]";
};

});


parcelRequire.register("8El2B", function(module, exports) {
"use strict";

var $9jNV5 = parcelRequire("9jNV5");
var $64c2617696d52431$require$PROPER_FUNCTION_NAME = $9jNV5.PROPER;

var $jwwDv = parcelRequire("jwwDv");

var $5ctHK = parcelRequire("5ctHK");

var $eMjwX = parcelRequire("eMjwX");

var $62TeD = parcelRequire("62TeD");

var $iitxL = parcelRequire("iitxL");
var $64c2617696d52431$var$TO_STRING = "toString";
var $64c2617696d52431$var$RegExpPrototype = RegExp.prototype;
var $64c2617696d52431$var$nativeToString = $64c2617696d52431$var$RegExpPrototype[$64c2617696d52431$var$TO_STRING];
var $64c2617696d52431$var$NOT_GENERIC = $62TeD(function() {
    return $64c2617696d52431$var$nativeToString.call({
        source: "a",
        flags: "b"
    }) != "/a/b";
});
// FF44- RegExp#toString has a wrong name
var $64c2617696d52431$var$INCORRECT_NAME = $64c2617696d52431$require$PROPER_FUNCTION_NAME && $64c2617696d52431$var$nativeToString.name != $64c2617696d52431$var$TO_STRING;
// `RegExp.prototype.toString` method
// https://tc39.es/ecma262/#sec-regexp.prototype.tostring
if ($64c2617696d52431$var$NOT_GENERIC || $64c2617696d52431$var$INCORRECT_NAME) $jwwDv(RegExp.prototype, $64c2617696d52431$var$TO_STRING, function toString() {
    var R = $5ctHK(this);
    var p = $eMjwX(R.source);
    var rf = R.flags;
    var f = $eMjwX(rf === undefined && R instanceof RegExp && !("flags" in $64c2617696d52431$var$RegExpPrototype) ? $iitxL.call(R) : rf);
    return "/" + p + "/" + f;
}, {
    unsafe: true
});

});


parcelRequire.register("fqCdG", function(module, exports) {

$parcel$export(module.exports, "default", () => $b3b6ee566c31accd$export$2e2bcd8739ae039);

var $7SyKb = parcelRequire("7SyKb");

var $60po4 = parcelRequire("60po4");

var $3pOgb = parcelRequire("3pOgb");

var $77Z8P = parcelRequire("77Z8P");

var $1Gk4M = parcelRequire("1Gk4M");

var $cwbRD = parcelRequire("cwbRD");
function $b3b6ee566c31accd$var$format(category, arg0) {
    var _context, _context2;
    for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)args[_key - 2] = arguments[_key];
    return (0, (/*@__PURE__*/$parcel$interopDefault($3pOgb)))(_context = [
        (0, (/*@__PURE__*/$parcel$interopDefault($3pOgb)))(_context2 = "%c".concat(category, "%c ")).call(_context2, arg0)
    ]).call(_context, (0, (/*@__PURE__*/$parcel$interopDefault($60po4)))((0, $cwbRD.default)("green", "white")), args);
}
function $b3b6ee566c31accd$export$2e2bcd8739ae039(category) {
    var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {}, _ref$force = _ref.force, force = _ref$force === void 0 ? false : _ref$force;
    if (!force) return function() {
        return 0;
    };
    return function() {
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        if (!args.length) return;
        var _args = args, _args2 = (0, (/*@__PURE__*/$parcel$interopDefault($7SyKb)))(_args, 1), arg0 = _args2[0];
        if (typeof arg0 === "function") args = arg0();
        var lines = (0, (/*@__PURE__*/$parcel$interopDefault($77Z8P)))(args[0]) ? args : [
            args
        ];
        var oneLiner = lines.length === 1;
        (0, (/*@__PURE__*/$parcel$interopDefault($1Gk4M)))(lines).call(lines, function(line, index) {
            if (oneLiner) {
                var _console, _context3;
                (_console = console).log.apply(_console, (0, (/*@__PURE__*/$parcel$interopDefault($60po4)))($b3b6ee566c31accd$var$format.apply(void 0, (0, (/*@__PURE__*/$parcel$interopDefault($3pOgb)))(_context3 = [
                    category
                ]).call(_context3, (0, (/*@__PURE__*/$parcel$interopDefault($60po4)))(line)))));
            } else if (index) {
                var _console2;
                (_console2 = console).log.apply(_console2, (0, (/*@__PURE__*/$parcel$interopDefault($60po4)))((0, (/*@__PURE__*/$parcel$interopDefault($77Z8P)))(line) ? line : [
                    line
                ]));
            } else {
                var _console3, _context4;
                (_console3 = console).groupCollapsed.apply(_console3, (0, (/*@__PURE__*/$parcel$interopDefault($60po4)))($b3b6ee566c31accd$var$format.apply(void 0, (0, (/*@__PURE__*/$parcel$interopDefault($3pOgb)))(_context4 = [
                    category
                ]).call(_context4, (0, (/*@__PURE__*/$parcel$interopDefault($60po4)))(line)))));
            }
        });
        oneLiner || console.groupEnd();
    };
}

});
parcelRequire.register("77Z8P", function(module, exports) {

module.exports = (parcelRequire("cC4VF"));

});

parcelRequire.register("cwbRD", function(module, exports) {

$parcel$export(module.exports, "default", () => $91d1ad2b06b4b0e8$export$2e2bcd8739ae039);
function $91d1ad2b06b4b0e8$export$2e2bcd8739ae039(backgroundColor) {
    var color = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "white";
    var styles = "background-color: ".concat(backgroundColor, "; border-radius: 4px; padding: 2px 4px;");
    if (color) styles += " color: ".concat(color, ";");
    return [
        styles,
        ""
    ];
}

});


parcelRequire.register("hXFIe", function(module, exports) {

$parcel$export(module.exports, "default", () => $d1384d9360a1f962$export$2e2bcd8739ae039);

var $bUr91 = parcelRequire("bUr91");
parcelRequire("gLrdt");

var $eO7Kz = parcelRequire("eO7Kz");

var $lYhvD = parcelRequire("lYhvD");
var $d1384d9360a1f962$var$EventSpy = function EventSpy(_ref) {
    var debounce = _ref.debounce, name = _ref.name, onEvent = _ref.onEvent, target = _ref.target;
    // We need to save the "onEvent" to ref.
    // This is because "onEvent" may change from time to time, but debounce may still fire to the older callback.
    var onEventRef = (0, $eO7Kz.useRef)();
    onEventRef.current = onEvent;
    var debouncer = (0, $eO7Kz.useMemo)(function() {
        return (0, $lYhvD.default)(function(event) {
            var current = onEventRef.current;
            current && current(event);
        }, debounce);
    }, [
        debounce,
        onEventRef
    ]);
    var handleEvent = (0, $eO7Kz.useCallback)(function(event) {
        event.timeStampLow = (0, (/*@__PURE__*/$parcel$interopDefault($bUr91)))();
        debouncer(event);
    }, [
        debouncer
    ]);
    (0, $eO7Kz.useLayoutEffect)(function() {
        target.addEventListener(name, handleEvent, {
            passive: true
        });
        handleEvent({
            target: target,
            type: name
        });
        return function() {
            return target.removeEventListener(name, handleEvent);
        };
    }, [
        name,
        handleEvent,
        target
    ]);
    return false;
};
$d1384d9360a1f962$var$EventSpy.defaultProps = {
    debounce: 200
};
var $d1384d9360a1f962$export$2e2bcd8739ae039 = $d1384d9360a1f962$var$EventSpy;

});
parcelRequire.register("gLrdt", function(module, exports) {

var $fmfcF = parcelRequire("fmfcF");

var $9jNV5 = parcelRequire("9jNV5");
var $c34625b90592b504$require$FUNCTION_NAME_EXISTS = $9jNV5.EXISTS;

var $aGY0C = parcelRequire("aGY0C");
var $c34625b90592b504$require$defineProperty = $aGY0C.f;
var $c34625b90592b504$var$FunctionPrototype = Function.prototype;
var $c34625b90592b504$var$FunctionPrototypeToString = $c34625b90592b504$var$FunctionPrototype.toString;
var $c34625b90592b504$var$nameRE = /^\s*function ([^ (]*)/;
var $c34625b90592b504$var$NAME = "name";
// Function instances `.name` property
// https://tc39.es/ecma262/#sec-function-instances-name
if ($fmfcF && !$c34625b90592b504$require$FUNCTION_NAME_EXISTS) $c34625b90592b504$require$defineProperty($c34625b90592b504$var$FunctionPrototype, $c34625b90592b504$var$NAME, {
    configurable: true,
    get: function() {
        try {
            return $c34625b90592b504$var$FunctionPrototypeToString.call(this).match($c34625b90592b504$var$nameRE)[1];
        } catch (error) {
            return "";
        }
    }
});

});

parcelRequire.register("lYhvD", function(module, exports) {

$parcel$export(module.exports, "default", () => $ffecc88596e35b10$export$2e2bcd8739ae039);

var $bUr91 = parcelRequire("bUr91");

var $ldGq6 = parcelRequire("ldGq6");
function $ffecc88596e35b10$export$2e2bcd8739ae039(fn, ms) {
    if (!ms) return fn;
    var last = 0;
    var timeout = null;
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var now = (0, (/*@__PURE__*/$parcel$interopDefault($bUr91)))();
        if (now - last > ms) {
            fn.apply(void 0, args);
            last = now;
        } else {
            clearTimeout(timeout);
            timeout = (0, (/*@__PURE__*/$parcel$interopDefault($ldGq6)))(function() {
                fn.apply(void 0, args);
                last = (0, (/*@__PURE__*/$parcel$interopDefault($bUr91)))();
            }, Math.max(0, ms - now + last));
        }
    };
}

});
parcelRequire.register("ldGq6", function(module, exports) {

module.exports = (parcelRequire("fJ9jw"));

});



parcelRequire.register("gcrVz", function(module, exports) {

$parcel$export(module.exports, "default", () => $bcb36e2f5d72b014$export$2e2bcd8739ae039);
parcelRequire("gLrdt");

var $9uUKz = parcelRequire("9uUKz");

var $bUr91 = parcelRequire("bUr91");

var $iqqHp = parcelRequire("iqqHp");

var $eO7Kz = parcelRequire("eO7Kz");
function $bcb36e2f5d72b014$var$squareStepper(current, to) {
    var sign = (0, (/*@__PURE__*/$parcel$interopDefault($9uUKz)))(to - current);
    var step = Math.sqrt(Math.abs(to - current));
    var next = current + step * sign;
    if (sign > 0) return Math.min(to, next);
    return Math.max(to, next);
}
function $bcb36e2f5d72b014$var$step(from, to, stepper, index) {
    var next = from;
    for(var i = 0; i < index; i++)next = stepper(next, to);
    return next;
}
var $bcb36e2f5d72b014$var$SpineTo = function SpineTo(_ref) {
    var name = _ref.name, onEnd = _ref.onEnd, target = _ref.target, value = _ref.value;
    var animator = (0, $eO7Kz.useRef)();
    var animate = (0, $eO7Kz.useCallback)(function(name, from, to, index) {
        var start = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : (0, (/*@__PURE__*/$parcel$interopDefault($bUr91)))();
        if (to === "100%" || typeof to === "number") {
            cancelAnimationFrame(animator.current);
            animator.current = requestAnimationFrame(function() {
                if (target) {
                    var toNumber = to === "100%" ? target.scrollHeight - target.offsetHeight : to;
                    var nextValue = $bcb36e2f5d72b014$var$step(from, toNumber, $bcb36e2f5d72b014$var$squareStepper, ((0, (/*@__PURE__*/$parcel$interopDefault($bUr91)))() - start) / 5);
                    if (Math.abs(toNumber - nextValue) < 1.5) nextValue = toNumber;
                    target[name] = nextValue;
                    if (toNumber === nextValue) onEnd && onEnd(true);
                    else animate(name, from, to, index + 1, start);
                }
            });
        }
    }, [
        animator,
        onEnd,
        target
    ]);
    var handleCancelAnimation = (0, $eO7Kz.useCallback)(function() {
        cancelAnimationFrame(animator.current);
        onEnd && onEnd(false);
    }, [
        onEnd
    ]);
    (0, $eO7Kz.useLayoutEffect)(function() {
        animate(name, target[name], value, 1);
        if (target) {
            target.addEventListener("pointerdown", handleCancelAnimation, {
                passive: true
            });
            target.addEventListener("wheel", handleCancelAnimation, {
                passive: true
            });
            return function() {
                target.removeEventListener("pointerdown", handleCancelAnimation);
                target.removeEventListener("wheel", handleCancelAnimation);
                cancelAnimationFrame(animator.current);
            };
        }
        return function() {
            return cancelAnimationFrame(animator.current);
        };
    }, [
        animate,
        animator,
        handleCancelAnimation,
        name,
        target,
        value
    ]);
    return false;
};
$bcb36e2f5d72b014$var$SpineTo.propTypes = {
    name: (0, (/*@__PURE__*/$parcel$interopDefault($iqqHp))).string.isRequired,
    onEnd: (0, (/*@__PURE__*/$parcel$interopDefault($iqqHp))).func,
    target: (0, (/*@__PURE__*/$parcel$interopDefault($iqqHp))).any.isRequired,
    value: (0, (/*@__PURE__*/$parcel$interopDefault($iqqHp))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($iqqHp))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($iqqHp))).oneOf([
            "100%"
        ])
    ]).isRequired
};
var $bcb36e2f5d72b014$export$2e2bcd8739ae039 = $bcb36e2f5d72b014$var$SpineTo;

});
parcelRequire.register("9uUKz", function(module, exports) {

module.exports = (parcelRequire("8Nq7h"));

});


parcelRequire.register("12AF3", function(module, exports) {

$parcel$export(module.exports, "default", () => $0c226a7de67eddc1$export$2e2bcd8739ae039);

var $7SyKb = parcelRequire("7SyKb");

var $eO7Kz = parcelRequire("eO7Kz");
function $0c226a7de67eddc1$export$2e2bcd8739ae039(initialState) {
    var _useState = (0, $eO7Kz.useState)(initialState), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($7SyKb)))(_useState, 2), state = _useState2[0], setState = _useState2[1];
    var ref = (0, $eO7Kz.useRef)();
    var setValue = (0, $eO7Kz.useCallback)(function(nextValue) {
        if (typeof nextValue === "function") setValue(function(state) {
            nextValue = nextValue(state);
            ref.current = nextValue;
            return nextValue;
        });
        else {
            ref.current = nextValue;
            setValue(nextValue);
        }
    }, [
        ref
    ]);
    ref.current = state;
    return [
        state,
        setState,
        ref
    ];
}

});


parcelRequire.register("13VWp", function(module, exports) {

$parcel$export(module.exports, "default", () => $0c63042137b51b11$export$2e2bcd8739ae039);

var $5D5HB = parcelRequire("5D5HB");

var $iqqHp = parcelRequire("iqqHp");

var $eO7Kz = parcelRequire("eO7Kz");

var $2cPvv = parcelRequire("2cPvv");

var $6vdhG = parcelRequire("6vdhG");
var $0c63042137b51b11$var$ROOT_STYLE = {
    height: "100%",
    overflowY: "auto",
    width: "100%"
};
var $0c63042137b51b11$var$Panel = function Panel(_ref) {
    var children = _ref.children, className = _ref.className;
    var _useContext = (0, $eO7Kz.useContext)((0, $2cPvv.default)), setTarget = _useContext.setTarget;
    var rootCSS = (0, $6vdhG.default)()($0c63042137b51b11$var$ROOT_STYLE);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eO7Kz))).createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($5D5HB)))(rootCSS, (className || "") + ""),
        ref: setTarget
    }, children);
};
$0c63042137b51b11$var$Panel.defaultProps = {
    children: undefined,
    className: undefined
};
$0c63042137b51b11$var$Panel.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($iqqHp))).any,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($iqqHp))).string
};
var $0c63042137b51b11$export$2e2bcd8739ae039 = $0c63042137b51b11$var$Panel;

});


parcelRequire.register("cwfkv", function(module, exports) {
/* eslint no-magic-numbers: ["error", { "ignore": [2] }] */ 
var $aIMfi = parcelRequire("aIMfi");
function $91d45d5b1458f0c6$export$2e2bcd8739ae039() {
    var _useStateContext = (0, $aIMfi.default)(2), animating = _useStateContext.animating;
    return [
        animating
    ];
}

});

parcelRequire.register("29Opo", function(module, exports) {

$parcel$export(module.exports, "default", () => $1923861c9b7dfc7e$export$2e2bcd8739ae039);
/* eslint no-magic-numbers: ["error", { "ignore": [2] }] */ 
var $aIMfi = parcelRequire("aIMfi");
function $1923861c9b7dfc7e$export$2e2bcd8739ae039() {
    var _useStateContext = (0, $aIMfi.default)(2), animatingToEnd = _useStateContext.animatingToEnd;
    return [
        animatingToEnd
    ];
}

});

parcelRequire.register("aVmwt", function(module, exports) {

var $aIMfi = parcelRequire("aIMfi");
function $7f40b2c8ccf7854f$export$2e2bcd8739ae039() {
    var _useStateContext = (0, $aIMfi.default)(1), atBottom = _useStateContext.atBottom;
    return [
        atBottom
    ];
}

});

parcelRequire.register("kTzTj", function(module, exports) {

$parcel$export(module.exports, "default", () => $f364c8eea2693d31$export$2e2bcd8739ae039);

var $aIMfi = parcelRequire("aIMfi");
function $f364c8eea2693d31$export$2e2bcd8739ae039() {
    var _useStateContext = (0, $aIMfi.default)(1), atEnd = _useStateContext.atEnd;
    return [
        atEnd
    ];
}

});

parcelRequire.register("3k8Bz", function(module, exports) {

var $aIMfi = parcelRequire("aIMfi");
function $26b9ea1dedb2fce6$export$2e2bcd8739ae039() {
    var _useStateContext = (0, $aIMfi.default)(1), atStart = _useStateContext.atStart;
    return [
        atStart
    ];
}

});

parcelRequire.register("4DHYB", function(module, exports) {

var $aIMfi = parcelRequire("aIMfi");
function $360ceac159ec41ef$export$2e2bcd8739ae039() {
    var _useStateContext = (0, $aIMfi.default)(1), atTop = _useStateContext.atTop;
    return [
        atTop
    ];
}

});

parcelRequire.register("47d4H", function(module, exports) {

var $aIMfi = parcelRequire("aIMfi");
function $2ff1f53ddee1f9e0$export$2e2bcd8739ae039() {
    var _useStateContext = (0, $aIMfi.default)(1), mode = _useStateContext.mode;
    return [
        mode
    ];
}

});

parcelRequire.register("l5G4z", function(module, exports) {

$parcel$export(module.exports, "default", () => $f5aab3596276ffbf$export$2e2bcd8739ae039);

var $60po4 = parcelRequire("60po4");

var $77Z8P = parcelRequire("77Z8P");

var $3pOgb = parcelRequire("3pOgb");

var $eO7Kz = parcelRequire("eO7Kz");

var $7HMxu = parcelRequire("7HMxu");
function $f5aab3596276ffbf$export$2e2bcd8739ae039(observer) {
    var _context;
    var deps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    if (observer && typeof observer !== "function") console.error('react-scroll-to-bottom: First argument passed to "useObserveScrollPosition" must be a function.');
    else if (!(0, (/*@__PURE__*/$parcel$interopDefault($77Z8P)))(deps)) console.error('react-scroll-to-bottom: Second argument passed to "useObserveScrollPosition" must be an array if specified.');
    var _useInternalContext = (0, $7HMxu.default)(), observeScrollPosition = _useInternalContext.observeScrollPosition;
    /* eslint-disable-next-line react-hooks/exhaustive-deps */ (0, $eO7Kz.useEffect)(function() {
        return observer && observeScrollPosition(observer);
    }, (0, (/*@__PURE__*/$parcel$interopDefault($3pOgb)))(_context = []).call(_context, (0, (/*@__PURE__*/$parcel$interopDefault($60po4)))(deps), [
        !observer,
        observeScrollPosition
    ]));
}

});

parcelRequire.register("YbbaU", function(module, exports) {

$parcel$export(module.exports, "default", () => $0b4e46ad14aabd42$export$2e2bcd8739ae039);

var $b5zLI = parcelRequire("b5zLI");
function $0b4e46ad14aabd42$export$2e2bcd8739ae039() {
    var _useFunctionContext = (0, $b5zLI.default)(), scrollTo = _useFunctionContext.scrollTo;
    return scrollTo;
}

});

parcelRequire.register("kkhU3", function(module, exports) {

var $b5zLI = parcelRequire("b5zLI");
function $ecc39010d5c0e557$export$2e2bcd8739ae039() {
    var _useFunctionContext = (0, $b5zLI.default)(), scrollToBottom = _useFunctionContext.scrollToBottom;
    return scrollToBottom;
}

});

parcelRequire.register("iCZnZ", function(module, exports) {

var $b5zLI = parcelRequire("b5zLI");
function $d8fb648c011cf129$export$2e2bcd8739ae039() {
    var _useFunctionContext = (0, $b5zLI.default)(), scrollToStart = _useFunctionContext.scrollToStart;
    return scrollToStart;
}

});

parcelRequire.register("2VoIm", function(module, exports) {

var $b5zLI = parcelRequire("b5zLI");
function $2214136719b13b92$export$2e2bcd8739ae039() {
    var _useFunctionContext = (0, $b5zLI.default)(), scrollToTop = _useFunctionContext.scrollToTop;
    return scrollToTop;
}

});


parcelRequire.register("gz2Et", function(module, exports) {
"use strict";
function $c0f1f8cd7a1a40dd$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $c0f1f8cd7a1a40dd$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $c0f1f8cd7a1a40dd$var$_typeof(obj);
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $hd4g0 = parcelRequire("hd4g0");

var $c0f1f8cd7a1a40dd$var$_classnames = $c0f1f8cd7a1a40dd$var$_interopRequireDefault((parcelRequire("5A4MD")));

var $c0f1f8cd7a1a40dd$var$_propTypes = $c0f1f8cd7a1a40dd$var$_interopRequireDefault((parcelRequire("f7UXb")));

var $c0f1f8cd7a1a40dd$var$_react = $c0f1f8cd7a1a40dd$var$_interopRequireWildcard((parcelRequire("eO7Kz")));

var $gLt36 = parcelRequire("gLt36");

var $c0f1f8cd7a1a40dd$var$_FocusTrap = $c0f1f8cd7a1a40dd$var$_interopRequireDefault((parcelRequire("iWoIR")));

var $c0f1f8cd7a1a40dd$var$_ScreenReaderText = $c0f1f8cd7a1a40dd$var$_interopRequireDefault((parcelRequire("3NTZI")));

var $c0f1f8cd7a1a40dd$var$_Speak = $c0f1f8cd7a1a40dd$var$_interopRequireDefault((parcelRequire("dsDZo")));

var $c0f1f8cd7a1a40dd$var$_useActiveDescendantId = $c0f1f8cd7a1a40dd$var$_interopRequireDefault((parcelRequire("kUkhJ")));

var $c0f1f8cd7a1a40dd$var$_useActivityAccessibleName = $c0f1f8cd7a1a40dd$var$_interopRequireDefault((parcelRequire("baqhX")));

var $c0f1f8cd7a1a40dd$var$_useFocusByActivityKey = $c0f1f8cd7a1a40dd$var$_interopRequireDefault((parcelRequire("f1kWf")));

var $c0f1f8cd7a1a40dd$var$_useGetDescendantIdByActivityKey = $c0f1f8cd7a1a40dd$var$_interopRequireDefault((parcelRequire("2Zb4j")));

var $c0f1f8cd7a1a40dd$var$_useValueRef = $c0f1f8cd7a1a40dd$var$_interopRequireDefault((parcelRequire("4Dn0F")));
function $c0f1f8cd7a1a40dd$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($c0f1f8cd7a1a40dd$var$_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $c0f1f8cd7a1a40dd$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || $c0f1f8cd7a1a40dd$var$_typeof(obj) !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $c0f1f8cd7a1a40dd$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $c0f1f8cd7a1a40dd$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $c0f1f8cd7a1a40dd$var$_slicedToArray(arr, i) {
    return $c0f1f8cd7a1a40dd$var$_arrayWithHoles(arr) || $c0f1f8cd7a1a40dd$var$_iterableToArrayLimit(arr, i) || $c0f1f8cd7a1a40dd$var$_unsupportedIterableToArray(arr, i) || $c0f1f8cd7a1a40dd$var$_nonIterableRest();
}
function $c0f1f8cd7a1a40dd$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $c0f1f8cd7a1a40dd$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $c0f1f8cd7a1a40dd$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $c0f1f8cd7a1a40dd$var$_arrayLikeToArray(o, minLen);
}
function $c0f1f8cd7a1a40dd$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $c0f1f8cd7a1a40dd$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $c0f1f8cd7a1a40dd$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
var $c0f1f8cd7a1a40dd$var$useActivityKeysByRead = $hd4g0.hooks.useActivityKeysByRead, $c0f1f8cd7a1a40dd$var$useGetHasAcknowledgedByActivityKey = $hd4g0.hooks.useGetHasAcknowledgedByActivityKey, $c0f1f8cd7a1a40dd$var$useGetKeyByActivity = $hd4g0.hooks.useGetKeyByActivity;
var $c0f1f8cd7a1a40dd$var$ActivityRow = /*#__PURE__*/ (0, $c0f1f8cd7a1a40dd$var$_react.forwardRef)(function(_ref, ref) {
    var _activity$channelData;
    var activity = _ref.activity, children = _ref.children;
    var _useActiveDescendantI = (0, $c0f1f8cd7a1a40dd$var$_useActiveDescendantId.default)(), _useActiveDescendantI2 = $c0f1f8cd7a1a40dd$var$_slicedToArray(_useActiveDescendantI, 1), activeDescendantId = _useActiveDescendantI2[0];
    var _useActivityKeysByRea = $c0f1f8cd7a1a40dd$var$useActivityKeysByRead(), _useActivityKeysByRea2 = $c0f1f8cd7a1a40dd$var$_slicedToArray(_useActivityKeysByRea, 1), readActivityKeys = _useActivityKeysByRea2[0];
    var bodyRef = (0, $c0f1f8cd7a1a40dd$var$_react.useRef)();
    var focusByActivityKey = (0, $c0f1f8cd7a1a40dd$var$_useFocusByActivityKey.default)();
    var getKeyByActivity = $c0f1f8cd7a1a40dd$var$useGetKeyByActivity(); // TODO: [P2] #2858 We should use core/definitions/speakingActivity for this predicate instead
    var shouldSpeak = (_activity$channelData = activity.channelData) === null || _activity$channelData === void 0 ? void 0 : _activity$channelData.speak;
    var _useActivityAccessibl = (0, $c0f1f8cd7a1a40dd$var$_useActivityAccessibleName.default)(activity, bodyRef), _useActivityAccessibl2 = $c0f1f8cd7a1a40dd$var$_slicedToArray(_useActivityAccessibl, 1), accessibleName = _useActivityAccessibl2[0];
    var activityKey = getKeyByActivity(activity);
    var acknowledged = $c0f1f8cd7a1a40dd$var$useGetHasAcknowledgedByActivityKey()(activityKey);
    var activityKeyRef = (0, $c0f1f8cd7a1a40dd$var$_useValueRef.default)(activityKey);
    var descendantId = (0, $c0f1f8cd7a1a40dd$var$_useGetDescendantIdByActivityKey.default)()(activityKey);
    var descendantLabelId = "webchat__basic-transcript__active-descendant-label--".concat(activityKey);
    var isActiveDescendant = descendantId === activeDescendantId;
    var read = readActivityKeys.includes(activityKey);
    var focusSelf = (0, $c0f1f8cd7a1a40dd$var$_react.useCallback)(function(withFocus) {
        return focusByActivityKey(activityKeyRef.current, withFocus);
    }, [
        activityKeyRef,
        focusByActivityKey
    ]); // When a child of the activity receives focus, notify the transcript to set the `aria-activedescendant` to this activity.
    var handleDescendantFocus = (0, $c0f1f8cd7a1a40dd$var$_react.useCallback)(function() {
        return focusSelf(false);
    }, [
        focusSelf
    ]); // When receive Escape key from descendant, focus back to the activity.
    var handleLeaveFocusTrap = (0, $c0f1f8cd7a1a40dd$var$_react.useCallback)(function() {
        return focusSelf();
    }, [
        focusSelf
    ]); // When the user press UP/DOWN arrow keys, we put a visual focus indicator around the focused activity.
    // We should do the same for mouse, when the user click on the activity, we should also put a visual focus indicator around the activity.
    // We are doing it in event capture phase to prevent descendants from stopping event propagation to us.
    var handleMouseDownCapture = (0, $c0f1f8cd7a1a40dd$var$_react.useCallback)(function() {
        return focusSelf(false);
    }, [
        focusSelf
    ]);
    return(/*#__PURE__*/ // TODO: [P2] Add `aria-roledescription="message"` for better AX, need localization strings.
    $c0f1f8cd7a1a40dd$var$_react.default.createElement("article", {
        className: (0, $c0f1f8cd7a1a40dd$var$_classnames.default)("webchat__basic-transcript__activity", {
            "webchat__basic-transcript__activity--acknowledged": acknowledged,
            "webchat__basic-transcript__activity--read": read
        }) // When NVDA is in browse mode, using up/down arrow key to "browse" will dispatch "click" and "mousedown" events for <article> element (inside <LiveRegionActivity>).
        ,
        onMouseDownCapture: handleMouseDownCapture,
        ref: ref
    }, !$gLt36.android && /*#__PURE__*/ $c0f1f8cd7a1a40dd$var$_react.default.createElement("div", {
        "aria-labelledby": descendantLabelId,
        className: "webchat__basic-transcript__activity-active-descendant" // "id" is required for "aria-labelledby"
        ,
        id: descendantId,
        role: "article"
    }, /*#__PURE__*/ $c0f1f8cd7a1a40dd$var$_react.default.createElement($c0f1f8cd7a1a40dd$var$_ScreenReaderText.default, {
        "aria-hidden": true,
        id: descendantLabelId,
        text: accessibleName
    })), /*#__PURE__*/ $c0f1f8cd7a1a40dd$var$_react.default.createElement($c0f1f8cd7a1a40dd$var$_FocusTrap.default, {
        onFocus: handleDescendantFocus,
        onLeave: handleLeaveFocusTrap
    }, /*#__PURE__*/ $c0f1f8cd7a1a40dd$var$_react.default.createElement("div", {
        className: "webchat__basic-transcript__activity-body",
        ref: bodyRef
    }, children)), shouldSpeak && /*#__PURE__*/ $c0f1f8cd7a1a40dd$var$_react.default.createElement($c0f1f8cd7a1a40dd$var$_Speak.default, {
        activity: activity
    }), /*#__PURE__*/ $c0f1f8cd7a1a40dd$var$_react.default.createElement("div", {
        className: (0, $c0f1f8cd7a1a40dd$var$_classnames.default)("webchat__basic-transcript__activity-indicator", {
            "webchat__basic-transcript__activity-indicator--focus": isActiveDescendant
        })
    })));
});
$c0f1f8cd7a1a40dd$var$ActivityRow.defaultProps = {
    children: undefined
};
$c0f1f8cd7a1a40dd$var$ActivityRow.displayName = "ActivityRow";
$c0f1f8cd7a1a40dd$var$ActivityRow.propTypes = {
    // PropTypes cannot fully capture TypeScript type.
    // @ts-ignore
    activity: $c0f1f8cd7a1a40dd$var$_propTypes.default.shape({
        channelData: $c0f1f8cd7a1a40dd$var$_propTypes.default.shape({
            speak: $c0f1f8cd7a1a40dd$var$_propTypes.default.bool,
            "webchat:fallback-text": $c0f1f8cd7a1a40dd$var$_propTypes.default.string
        })
    }).isRequired,
    children: $c0f1f8cd7a1a40dd$var$_propTypes.default.any
};
var $c0f1f8cd7a1a40dd$var$_default = $c0f1f8cd7a1a40dd$var$ActivityRow;
module.exports.default = $c0f1f8cd7a1a40dd$var$_default;

});
parcelRequire.register("iWoIR", function(module, exports) {
"use strict";
function $dca0d228d3cbbd43$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $dca0d228d3cbbd43$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $dca0d228d3cbbd43$var$_typeof(obj);
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $dca0d228d3cbbd43$var$_propTypes = $dca0d228d3cbbd43$var$_interopRequireDefault((parcelRequire("f7UXb")));

var $dca0d228d3cbbd43$var$_react = $dca0d228d3cbbd43$var$_interopRequireWildcard((parcelRequire("eO7Kz")));

var $dca0d228d3cbbd43$var$_FocusRedirector = $dca0d228d3cbbd43$var$_interopRequireDefault((parcelRequire("9uhn3")));

var $dca0d228d3cbbd43$var$_tabbableElements = $dca0d228d3cbbd43$var$_interopRequireDefault((parcelRequire("1ySa1")));

var $dca0d228d3cbbd43$var$_useValueRef = $dca0d228d3cbbd43$var$_interopRequireDefault((parcelRequire("4Dn0F")));
function $dca0d228d3cbbd43$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($dca0d228d3cbbd43$var$_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $dca0d228d3cbbd43$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || $dca0d228d3cbbd43$var$_typeof(obj) !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $dca0d228d3cbbd43$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $dca0d228d3cbbd43$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $dca0d228d3cbbd43$var$_slicedToArray(arr, i) {
    return $dca0d228d3cbbd43$var$_arrayWithHoles(arr) || $dca0d228d3cbbd43$var$_iterableToArrayLimit(arr, i) || $dca0d228d3cbbd43$var$_unsupportedIterableToArray(arr, i) || $dca0d228d3cbbd43$var$_nonIterableRest();
}
function $dca0d228d3cbbd43$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $dca0d228d3cbbd43$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $dca0d228d3cbbd43$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $dca0d228d3cbbd43$var$_arrayLikeToArray(o, minLen);
}
function $dca0d228d3cbbd43$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $dca0d228d3cbbd43$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $dca0d228d3cbbd43$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
var $dca0d228d3cbbd43$var$FocusTrap = function FocusTrap(_ref) {
    var children = _ref.children, onFocus = _ref.onFocus, onLeave = _ref.onLeave;
    var bodyRef = (0, $dca0d228d3cbbd43$var$_react.useRef)();
    var onLeaveRef = (0, $dca0d228d3cbbd43$var$_useValueRef.default)(onLeave);
    var getTabbableElementsInBody = (0, $dca0d228d3cbbd43$var$_react.useCallback)(function() {
        return (0, $dca0d228d3cbbd43$var$_tabbableElements.default)(bodyRef.current).filter(function(element) {
            return element.getAttribute("aria-disabled") !== "true";
        });
    }, [
        bodyRef
    ]);
    var handleBodyKeyDown = (0, $dca0d228d3cbbd43$var$_react.useCallback)(function(event) {
        if (event.key === "Escape") {
            var _onLeaveRef$current;
            event.preventDefault();
            event.stopPropagation();
            (_onLeaveRef$current = onLeaveRef.current) === null || _onLeaveRef$current === void 0 || _onLeaveRef$current.call(onLeaveRef);
        }
    }, [
        onLeaveRef
    ]);
    var handleFirstSentinelFocus = (0, $dca0d228d3cbbd43$var$_react.useCallback)(function() {
        var _onLeaveRef$current2;
        var focusables = getTabbableElementsInBody();
        var lastTabbableElement = focusables[focusables.length - 1];
        lastTabbableElement ? lastTabbableElement.focus() : (_onLeaveRef$current2 = onLeaveRef.current) === null || _onLeaveRef$current2 === void 0 || _onLeaveRef$current2.call(onLeaveRef);
    }, [
        getTabbableElementsInBody,
        onLeaveRef
    ]);
    var handleLastSentinelFocus = (0, $dca0d228d3cbbd43$var$_react.useCallback)(function() {
        var _onLeaveRef$current3;
        var _getTabbableElementsI = getTabbableElementsInBody(), _getTabbableElementsI2 = $dca0d228d3cbbd43$var$_slicedToArray(_getTabbableElementsI, 1), firstTabbableElement = _getTabbableElementsI2[0];
        firstTabbableElement ? firstTabbableElement.focus() : (_onLeaveRef$current3 = onLeaveRef.current) === null || _onLeaveRef$current3 === void 0 || _onLeaveRef$current3.call(onLeaveRef);
    }, [
        getTabbableElementsInBody,
        onLeaveRef
    ]);
    return /*#__PURE__*/ $dca0d228d3cbbd43$var$_react.default.createElement($dca0d228d3cbbd43$var$_react.Fragment, null, /*#__PURE__*/ $dca0d228d3cbbd43$var$_react.default.createElement($dca0d228d3cbbd43$var$_FocusRedirector.default, {
        onFocus: handleFirstSentinelFocus
    }), /*#__PURE__*/ $dca0d228d3cbbd43$var$_react.default.createElement("div", {
        onFocus: onFocus,
        onKeyDown: handleBodyKeyDown,
        ref: bodyRef
    }, children), /*#__PURE__*/ $dca0d228d3cbbd43$var$_react.default.createElement($dca0d228d3cbbd43$var$_FocusRedirector.default, {
        onFocus: handleLastSentinelFocus
    }));
};
$dca0d228d3cbbd43$var$FocusTrap.defaultProps = {
    children: undefined,
    onFocus: undefined
};
$dca0d228d3cbbd43$var$FocusTrap.propTypes = {
    children: $dca0d228d3cbbd43$var$_propTypes.default.any,
    onFocus: $dca0d228d3cbbd43$var$_propTypes.default.func,
    onLeave: $dca0d228d3cbbd43$var$_propTypes.default.func.isRequired
};
var $dca0d228d3cbbd43$var$_default = $dca0d228d3cbbd43$var$FocusTrap;
module.exports.default = $dca0d228d3cbbd43$var$_default;

});
parcelRequire.register("9uhn3", function(module, exports) {
"use strict";
function $6e8463e665bdf2d8$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $6e8463e665bdf2d8$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $6e8463e665bdf2d8$var$_typeof(obj);
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6e8463e665bdf2d8$var$_propTypes = $6e8463e665bdf2d8$var$_interopRequireDefault((parcelRequire("f7UXb")));

var $6e8463e665bdf2d8$var$_react = $6e8463e665bdf2d8$var$_interopRequireWildcard((parcelRequire("eO7Kz")));
function $6e8463e665bdf2d8$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($6e8463e665bdf2d8$var$_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $6e8463e665bdf2d8$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || $6e8463e665bdf2d8$var$_typeof(obj) !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $6e8463e665bdf2d8$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $6e8463e665bdf2d8$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $6e8463e665bdf2d8$var$FocusRedirector = function FocusRedirector(_ref) {
    var className = _ref.className, onFocus = _ref.onFocus, redirectRef = _ref.redirectRef;
    var handleFocus = (0, $6e8463e665bdf2d8$var$_react.useCallback)(function() {
        var _redirectRef$current;
        redirectRef === null || redirectRef === void 0 || (_redirectRef$current = redirectRef.current) === null || _redirectRef$current === void 0 || _redirectRef$current.focus();
        onFocus && onFocus();
    }, [
        onFocus,
        redirectRef
    ]); // 2023-02-23: With NVDA 2022.1 and 2022.4, when in browse mode, up/down arrow keys no longer focus.
    //             We no longer need to set aria-hidden="true" to hide it from browse mode.
    // 2021-09-21: For NVDA, we should set aria-hidden="true".
    //             When using NVDA in browse mode, press up/down arrow keys will focus on this redirector.
    //             This redirector is designed to capture TAB only and should not react on browse mode.
    //             However, reacting with browse mode is currently okay. Just better to leave it alone.
    return /*#__PURE__*/ $6e8463e665bdf2d8$var$_react.default.createElement("div", {
        className: className,
        onFocus: handleFocus,
        tabIndex: 0
    });
};
$6e8463e665bdf2d8$var$FocusRedirector.defaultProps = {
    className: undefined,
    onFocus: undefined,
    redirectRef: undefined
};
$6e8463e665bdf2d8$var$FocusRedirector.propTypes = {
    className: $6e8463e665bdf2d8$var$_propTypes.default.string,
    onFocus: $6e8463e665bdf2d8$var$_propTypes.default.func,
    // PropTypes is not fully compatible with TypeScript.
    // @ts-ignore
    redirectRef: $6e8463e665bdf2d8$var$_propTypes.default.shape({
        current: $6e8463e665bdf2d8$var$_propTypes.default.instanceOf(HTMLElement)
    })
};
var $6e8463e665bdf2d8$var$_default = $6e8463e665bdf2d8$var$FocusRedirector;
module.exports.default = $6e8463e665bdf2d8$var$_default;

});

parcelRequire.register("1ySa1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $1232fa92dbb64baa$var$tabbableElements;
function $1232fa92dbb64baa$var$tabbableElements(element) {
    // This is an incomplete list, due to the complexity of testing for every scenario.
    // For full-list, please refer to https://allyjs.io/data-tables/focusable.html
    var candidates = (element === null || element === void 0 ? void 0 : element.querySelectorAll("a[href], area[href], audio[controls], button:not(:disabled), iframe, input:not(:disabled), keygen, select:not(:disabled), summary, textarea:not(:disabled), video[controls], [contenteditable], [tabindex]")) || [];
    return [].filter.call(candidates, function(element) {
        var tabIndexAttribute = element.attributes.getNamedItem("tabindex");
        if (tabIndexAttribute && tabIndexAttribute.specified) {
            var value = parseInt(tabIndexAttribute.value, 10);
            return value >= 0 || isNaN(value) && element.nodeName.toLowerCase() === "input";
        }
        return true;
    });
}

});


parcelRequire.register("dsDZo", function(module, exports) {
"use strict";
function $9ccce8ebe58c38ba$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $9ccce8ebe58c38ba$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $9ccce8ebe58c38ba$var$_typeof(obj);
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = module.exports.connectSpeakActivity = void 0;

var $hd4g0 = parcelRequire("hd4g0");

var $9ccce8ebe58c38ba$var$_propTypes = $9ccce8ebe58c38ba$var$_interopRequireDefault((parcelRequire("f7UXb")));

var $9ccce8ebe58c38ba$var$_react = $9ccce8ebe58c38ba$var$_interopRequireWildcard((parcelRequire("eO7Kz")));

var $9ccce8ebe58c38ba$var$_reactSay = $9ccce8ebe58c38ba$var$_interopRequireWildcard((parcelRequire("eM21L")));

var $9ccce8ebe58c38ba$var$_connectToWebChat = $9ccce8ebe58c38ba$var$_interopRequireDefault((parcelRequire("86vmQ")));

var $9ccce8ebe58c38ba$var$_SayAlt = $9ccce8ebe58c38ba$var$_interopRequireDefault((parcelRequire("lEScY")));
function $9ccce8ebe58c38ba$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($9ccce8ebe58c38ba$var$_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $9ccce8ebe58c38ba$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || $9ccce8ebe58c38ba$var$_typeof(obj) !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $9ccce8ebe58c38ba$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $9ccce8ebe58c38ba$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $9ccce8ebe58c38ba$var$_toConsumableArray(arr) {
    return $9ccce8ebe58c38ba$var$_arrayWithoutHoles(arr) || $9ccce8ebe58c38ba$var$_iterableToArray(arr) || $9ccce8ebe58c38ba$var$_unsupportedIterableToArray(arr) || $9ccce8ebe58c38ba$var$_nonIterableSpread();
}
function $9ccce8ebe58c38ba$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $9ccce8ebe58c38ba$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $9ccce8ebe58c38ba$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $9ccce8ebe58c38ba$var$_arrayLikeToArray(arr);
}
function $9ccce8ebe58c38ba$var$_slicedToArray(arr, i) {
    return $9ccce8ebe58c38ba$var$_arrayWithHoles(arr) || $9ccce8ebe58c38ba$var$_iterableToArrayLimit(arr, i) || $9ccce8ebe58c38ba$var$_unsupportedIterableToArray(arr, i) || $9ccce8ebe58c38ba$var$_nonIterableRest();
}
function $9ccce8ebe58c38ba$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $9ccce8ebe58c38ba$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $9ccce8ebe58c38ba$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $9ccce8ebe58c38ba$var$_arrayLikeToArray(o, minLen);
}
function $9ccce8ebe58c38ba$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $9ccce8ebe58c38ba$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $9ccce8ebe58c38ba$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
var $9ccce8ebe58c38ba$var$useMarkActivityAsSpoken = $hd4g0.hooks.useMarkActivityAsSpoken, $9ccce8ebe58c38ba$var$useStyleOptions = $hd4g0.hooks.useStyleOptions, $9ccce8ebe58c38ba$var$useVoiceSelector = $hd4g0.hooks.useVoiceSelector; // TODO: [P4] Consider moving this feature into BasicActivity
//       And it has better DOM position for showing visual spoken text
// TODO: [P3] We should add a "spoken" or "speakState" flag to indicate whether this activity is going to speak, or spoken
var $9ccce8ebe58c38ba$var$connectSpeakActivity = function connectSpeakActivity() {
    for(var _len = arguments.length, selectors = new Array(_len), _key = 0; _key < _len; _key++)selectors[_key] = arguments[_key];
    return $9ccce8ebe58c38ba$var$_connectToWebChat.default.apply(void 0, [
        function(_ref, _ref2) {
            var language = _ref.language, markActivity = _ref.markActivity, _selectVoice = _ref.selectVoice;
            var activity = _ref2.activity;
            return {
                language: language,
                markAsSpoken: function markAsSpoken() {
                    return markActivity(activity, "speak", false);
                },
                selectVoice: function selectVoice(voices) {
                    return _selectVoice(voices, activity);
                }
            };
        }
    ].concat(selectors));
};
module.exports.connectSpeakActivity = $9ccce8ebe58c38ba$var$connectSpeakActivity;
var $9ccce8ebe58c38ba$var$Speak = function Speak(_ref3) {
    var _activity$channelData;
    var activity = _ref3.activity;
    var _useStyleOptions = $9ccce8ebe58c38ba$var$useStyleOptions(), _useStyleOptions2 = $9ccce8ebe58c38ba$var$_slicedToArray(_useStyleOptions, 1), showSpokenText = _useStyleOptions2[0].showSpokenText;
    var markActivityAsSpoken = $9ccce8ebe58c38ba$var$useMarkActivityAsSpoken();
    var selectVoice = $9ccce8ebe58c38ba$var$useVoiceSelector(activity);
    var markAsSpoken = (0, $9ccce8ebe58c38ba$var$_react.useCallback)(function() {
        markActivityAsSpoken(activity);
    }, [
        activity,
        markActivityAsSpoken
    ]);
    var singleLine = (0, $9ccce8ebe58c38ba$var$_react.useMemo)(function() {
        if (activity.type !== "message") return false;
        var _activity$attachments = activity.attachments, attachments = _activity$attachments === void 0 ? [] : _activity$attachments, speak = activity.speak, text = activity.text;
        return [
            speak || text
        ].concat($9ccce8ebe58c38ba$var$_toConsumableArray(attachments.filter(function(_ref4) {
            var contentType = _ref4.contentType;
            return contentType === "application/vnd.microsoft.card.adaptive";
        }).map(function(attachment) {
            var _attachment$content;
            return attachment === null || attachment === void 0 ? void 0 : (_attachment$content = attachment.content) === null || _attachment$content === void 0 ? void 0 : _attachment$content.speak;
        }))).filter(function(line) {
            return line;
        }).join("\r\n");
    }, [
        activity
    ]);
    var speechSynthesisUtterance = activity.type === "message" && ((_activity$channelData = activity.channelData) === null || _activity$channelData === void 0 ? void 0 : _activity$channelData.speechSynthesisUtterance);
    return !!activity && /*#__PURE__*/ $9ccce8ebe58c38ba$var$_react.default.createElement($9ccce8ebe58c38ba$var$_react.default.Fragment, null, speechSynthesisUtterance ? /*#__PURE__*/ $9ccce8ebe58c38ba$var$_react.default.createElement($9ccce8ebe58c38ba$var$_reactSay.SayUtterance, {
        onEnd: markAsSpoken,
        onError: markAsSpoken,
        utterance: speechSynthesisUtterance
    }) : /*#__PURE__*/ $9ccce8ebe58c38ba$var$_react.default.createElement($9ccce8ebe58c38ba$var$_reactSay.default, {
        onEnd: markAsSpoken,
        onError: markAsSpoken,
        text: singleLine,
        voice: selectVoice
    }), !!showSpokenText && /*#__PURE__*/ $9ccce8ebe58c38ba$var$_react.default.createElement($9ccce8ebe58c38ba$var$_SayAlt.default, {
        speak: singleLine
    }));
};
$9ccce8ebe58c38ba$var$Speak.propTypes = {
    // PropTypes cannot fully capture TypeScript types.
    // @ts-ignore
    activity: $9ccce8ebe58c38ba$var$_propTypes.default.shape({
        attachments: $9ccce8ebe58c38ba$var$_propTypes.default.arrayOf($9ccce8ebe58c38ba$var$_propTypes.default.shape({
            speak: $9ccce8ebe58c38ba$var$_propTypes.default.string,
            subtitle: $9ccce8ebe58c38ba$var$_propTypes.default.string,
            text: $9ccce8ebe58c38ba$var$_propTypes.default.string,
            title: $9ccce8ebe58c38ba$var$_propTypes.default.string
        })),
        channelData: $9ccce8ebe58c38ba$var$_propTypes.default.shape({
            speechSynthesisUtterance: $9ccce8ebe58c38ba$var$_propTypes.default.any
        }),
        speak: $9ccce8ebe58c38ba$var$_propTypes.default.string,
        text: $9ccce8ebe58c38ba$var$_propTypes.default.string,
        type: $9ccce8ebe58c38ba$var$_propTypes.default.string.isRequired
    }).isRequired
};
var $9ccce8ebe58c38ba$var$_default = $9ccce8ebe58c38ba$var$Speak;
module.exports.default = $9ccce8ebe58c38ba$var$_default;

});
parcelRequire.register("eM21L", function(module, exports) {
"use strict";

var $fJbaf = parcelRequire("fJbaf");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "Composer", {
    enumerable: true,
    get: function get() {
        return $ac171efda8f69de2$var$_Composer["default"];
    }
});
Object.defineProperty(module.exports, "Context", {
    enumerable: true,
    get: function get() {
        return $ac171efda8f69de2$var$_Context["default"];
    }
});
Object.defineProperty(module.exports, "SayButton", {
    enumerable: true,
    get: function get() {
        return $ac171efda8f69de2$var$_SayButton["default"];
    }
});
Object.defineProperty(module.exports, "SayUtterance", {
    enumerable: true,
    get: function get() {
        return $ac171efda8f69de2$var$_SayUtterance["default"];
    }
});
module.exports["default"] = void 0;

var $ac171efda8f69de2$var$_Say = $fJbaf((parcelRequire("3DQH2")));

var $ac171efda8f69de2$var$_Composer = $fJbaf((parcelRequire("6aGpF")));

var $ac171efda8f69de2$var$_Context = $fJbaf((parcelRequire("iRfx4")));

var $ac171efda8f69de2$var$_SayButton = $fJbaf((parcelRequire("jj2lF")));

var $ac171efda8f69de2$var$_SayUtterance = $fJbaf((parcelRequire("6gQhv")));
var $ac171efda8f69de2$var$_default = $ac171efda8f69de2$var$_Say["default"];
module.exports["default"] = $ac171efda8f69de2$var$_default;

});
parcelRequire.register("fJbaf", function(module, exports) {
function $b733b7f80c69a40e$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
module.exports = $b733b7f80c69a40e$var$_interopRequireDefault;
module.exports["default"] = module.exports, module.exports.__esModule = true;

});

parcelRequire.register("3DQH2", function(module, exports) {
"use strict";

var $fJbaf = parcelRequire("fJbaf");

var $laaNS = parcelRequire("laaNS");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $2a6de361d6753a33$var$_defineProperty2 = $fJbaf((parcelRequire("i8ead")));

var $2a6de361d6753a33$var$_objectWithoutProperties2 = $fJbaf((parcelRequire("c3Qjm")));

var $2a6de361d6753a33$var$_readOnlyError2 = $fJbaf((parcelRequire("kmGQ3")));

var $2a6de361d6753a33$var$_propTypes = $fJbaf((parcelRequire("f7UXb")));

var $2a6de361d6753a33$var$_react = $2a6de361d6753a33$var$_interopRequireWildcard((parcelRequire("eO7Kz")));

var $2a6de361d6753a33$var$_Composer = $fJbaf((parcelRequire("6aGpF")));

var $2a6de361d6753a33$var$_Context = $fJbaf((parcelRequire("iRfx4")));

var $2a6de361d6753a33$var$_createNativeUtterance = $fJbaf((parcelRequire("6fE3q")));

var $2a6de361d6753a33$var$_migrateDeprecatedProps = $fJbaf((parcelRequire("iufls")));

var $2a6de361d6753a33$var$_SayUtterance = $fJbaf((parcelRequire("6gQhv")));
var $2a6de361d6753a33$var$_excluded = [
    "ponyfill"
];
function $2a6de361d6753a33$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($2a6de361d6753a33$var$_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $2a6de361d6753a33$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || $laaNS(obj) !== "object" && typeof obj !== "function") return {
        "default": obj
    };
    var cache = $2a6de361d6753a33$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj["default"] = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $2a6de361d6753a33$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $2a6de361d6753a33$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $2a6de361d6753a33$var$ownKeys(Object(source), true).forEach(function(key) {
            (0, $2a6de361d6753a33$var$_defineProperty2["default"])(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $2a6de361d6753a33$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var $2a6de361d6753a33$var$Say = function Say(props) {
    var _migrateDeprecatedPro = (0, $2a6de361d6753a33$var$_migrateDeprecatedProps["default"])(props, Say), lang = _migrateDeprecatedPro.lang, onBoundary = _migrateDeprecatedPro.onBoundary, onEnd = _migrateDeprecatedPro.onEnd, onError = _migrateDeprecatedPro.onError, onStart = _migrateDeprecatedPro.onStart, pitch = _migrateDeprecatedPro.pitch, rate = _migrateDeprecatedPro.rate, speak = _migrateDeprecatedPro.speak, text = _migrateDeprecatedPro.text, voice = _migrateDeprecatedPro.voice, volume = _migrateDeprecatedPro.volume;
    var _useContext = (0, $2a6de361d6753a33$var$_react.useContext)($2a6de361d6753a33$var$_Context["default"]), ponyfill = _useContext.ponyfill;
    if (speak && !text) {
        console.warn('react-say: "speak" prop is being deprecated and renamed to "text".');
        speak, (0, $2a6de361d6753a33$var$_readOnlyError2["default"])("text");
    }
    var utterance = (0, $2a6de361d6753a33$var$_react.useMemo)(function() {
        return (0, $2a6de361d6753a33$var$_createNativeUtterance["default"])(ponyfill, {
            lang: lang,
            onBoundary: onBoundary,
            pitch: pitch,
            rate: rate,
            text: text,
            voice: voice,
            volume: volume
        });
    }, [
        lang,
        onBoundary,
        pitch,
        ponyfill,
        rate,
        text,
        voice,
        volume
    ]);
    return /*#__PURE__*/ $2a6de361d6753a33$var$_react["default"].createElement($2a6de361d6753a33$var$_SayUtterance["default"], {
        onEnd: onEnd,
        onError: onError,
        onStart: onStart,
        ponyfill: ponyfill,
        utterance: utterance
    });
};
$2a6de361d6753a33$var$Say.defaultProps = {
    children: undefined,
    lang: undefined,
    onBoundary: undefined,
    onEnd: undefined,
    onError: undefined,
    onStart: undefined,
    pitch: undefined,
    rate: undefined,
    speak: undefined,
    voice: undefined,
    volume: undefined
};
$2a6de361d6753a33$var$Say.propTypes = {
    children: $2a6de361d6753a33$var$_propTypes["default"].any,
    lang: $2a6de361d6753a33$var$_propTypes["default"].string,
    onBoundary: $2a6de361d6753a33$var$_propTypes["default"].func,
    onEnd: $2a6de361d6753a33$var$_propTypes["default"].func,
    onError: $2a6de361d6753a33$var$_propTypes["default"].func,
    onStart: $2a6de361d6753a33$var$_propTypes["default"].func,
    pitch: $2a6de361d6753a33$var$_propTypes["default"].number,
    rate: $2a6de361d6753a33$var$_propTypes["default"].number,
    speak: $2a6de361d6753a33$var$_propTypes["default"].string,
    text: $2a6de361d6753a33$var$_propTypes["default"].string.isRequired,
    voice: $2a6de361d6753a33$var$_propTypes["default"].oneOfType([
        $2a6de361d6753a33$var$_propTypes["default"].any,
        $2a6de361d6753a33$var$_propTypes["default"].func
    ]),
    volume: $2a6de361d6753a33$var$_propTypes["default"].number
};
var $2a6de361d6753a33$var$SayWithContext = function SayWithContext(_ref) {
    var ponyfill = _ref.ponyfill, props = (0, $2a6de361d6753a33$var$_objectWithoutProperties2["default"])(_ref, $2a6de361d6753a33$var$_excluded);
    return /*#__PURE__*/ $2a6de361d6753a33$var$_react["default"].createElement($2a6de361d6753a33$var$_Composer["default"], {
        ponyfill: ponyfill
    }, /*#__PURE__*/ $2a6de361d6753a33$var$_react["default"].createElement($2a6de361d6753a33$var$Say, props));
};
$2a6de361d6753a33$var$SayWithContext.defaultProps = $2a6de361d6753a33$var$_objectSpread($2a6de361d6753a33$var$_objectSpread({}, $2a6de361d6753a33$var$_SayUtterance["default"].defaultProps), {}, {
    ponyfill: undefined
});
$2a6de361d6753a33$var$SayWithContext.propTypes = $2a6de361d6753a33$var$_objectSpread($2a6de361d6753a33$var$_objectSpread({}, $2a6de361d6753a33$var$_SayUtterance["default"].propTypes), {}, {
    ponyfill: $2a6de361d6753a33$var$_propTypes["default"].shape({
        speechSynthesis: $2a6de361d6753a33$var$_propTypes["default"].any.isRequired,
        SpeechSynthesisUtterance: $2a6de361d6753a33$var$_propTypes["default"].any.isRequired
    })
});
var $2a6de361d6753a33$var$_default = $2a6de361d6753a33$var$SayWithContext;
module.exports["default"] = $2a6de361d6753a33$var$_default;

});
parcelRequire.register("laaNS", function(module, exports) {
function $f682e977ecd581ff$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
        module.exports = $f682e977ecd581ff$var$_typeof = function _typeof(obj) {
            return typeof obj;
        };
        module.exports["default"] = module.exports, module.exports.__esModule = true;
    } else {
        module.exports = $f682e977ecd581ff$var$_typeof = function _typeof(obj) {
            return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
        };
        module.exports["default"] = module.exports, module.exports.__esModule = true;
    }
    return $f682e977ecd581ff$var$_typeof(obj);
}
module.exports = $f682e977ecd581ff$var$_typeof;
module.exports["default"] = module.exports, module.exports.__esModule = true;

});

parcelRequire.register("i8ead", function(module, exports) {
function $d333f5f7033cca74$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
module.exports = $d333f5f7033cca74$var$_defineProperty;
module.exports["default"] = module.exports, module.exports.__esModule = true;

});

parcelRequire.register("c3Qjm", function(module, exports) {

var $3cwCY = parcelRequire("3cwCY");
function $8c7e57c7bc133377$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $3cwCY(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
module.exports = $8c7e57c7bc133377$var$_objectWithoutProperties;
module.exports["default"] = module.exports, module.exports.__esModule = true;

});
parcelRequire.register("3cwCY", function(module, exports) {
function $254bcd42d82e4728$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
module.exports = $254bcd42d82e4728$var$_objectWithoutPropertiesLoose;
module.exports["default"] = module.exports, module.exports.__esModule = true;

});


parcelRequire.register("kmGQ3", function(module, exports) {
function $ed3717949954d683$var$_readOnlyError(name) {
    throw new TypeError('"' + name + '" is read-only');
}
module.exports = $ed3717949954d683$var$_readOnlyError;
module.exports["default"] = module.exports, module.exports.__esModule = true;

});

parcelRequire.register("6aGpF", function(module, exports) {
"use strict";

var $fJbaf = parcelRequire("fJbaf");

var $laaNS = parcelRequire("laaNS");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $47e49399f31cf5ba$var$_slicedToArray2 = $fJbaf((parcelRequire("i1oQX")));

var $47e49399f31cf5ba$var$_propTypes = $fJbaf((parcelRequire("f7UXb")));

var $47e49399f31cf5ba$var$_react = $47e49399f31cf5ba$var$_interopRequireWildcard((parcelRequire("eO7Kz")));

var $47e49399f31cf5ba$var$_Context = $fJbaf((parcelRequire("iRfx4")));

var $47e49399f31cf5ba$var$_createSynthesize = $fJbaf((parcelRequire("dKnDS")));

var $47e49399f31cf5ba$var$_migrateDeprecatedProps = $fJbaf((parcelRequire("iufls")));

var $47e49399f31cf5ba$var$_useEvent = $fJbaf((parcelRequire("30U9h")));
function $47e49399f31cf5ba$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($47e49399f31cf5ba$var$_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $47e49399f31cf5ba$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || $laaNS(obj) !== "object" && typeof obj !== "function") return {
        "default": obj
    };
    var cache = $47e49399f31cf5ba$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj["default"] = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
var $47e49399f31cf5ba$var$Composer = function Composer(props) {
    var _migrateDeprecatedPro = (0, $47e49399f31cf5ba$var$_migrateDeprecatedProps["default"])(props, Composer), children = _migrateDeprecatedPro.children, ponyfillFromProps = _migrateDeprecatedPro.ponyfill; // If we have the parent context, we will use that synthesize() function and its internal queue.
    var _ref = (0, $47e49399f31cf5ba$var$_react.useContext)($47e49399f31cf5ba$var$_Context["default"]) || {}, parentPonyfill = _ref.ponyfill, parentSynthesize = _ref.synthesize;
    var ponyfill = ponyfillFromProps || parentPonyfill || {
        speechSynthesis: window.speechSynthesis || window.webkitSpeechSynthesis,
        SpeechSynthesisUtterance: window.SpeechSynthesisUtterance || window.webkitSpeechSynthesisUtterance
    }; // If the parent context changed and no longer has a synthesize() function, we will create the queue.
    // This is very unlikely to happen.
    var synthesize = (0, $47e49399f31cf5ba$var$_react.useMemo)(function() {
        return parentSynthesize || (0, $47e49399f31cf5ba$var$_createSynthesize["default"])();
    }, [
        parentSynthesize
    ]);
    var speechSynthesis = ponyfill.speechSynthesis;
    var _useState = (0, $47e49399f31cf5ba$var$_react.useState)(speechSynthesis.getVoices()), _useState2 = (0, $47e49399f31cf5ba$var$_slicedToArray2["default"])(_useState, 2), voices = _useState2[0], setVoices = _useState2[1];
    (0, $47e49399f31cf5ba$var$_useEvent["default"])(speechSynthesis, "voiceschanged", function() {
        return setVoices(speechSynthesis.getVoices());
    });
    var context = (0, $47e49399f31cf5ba$var$_react.useMemo)(function() {
        return {
            ponyfill: ponyfill,
            synthesize: synthesize,
            voices: voices
        };
    }, [
        ponyfill,
        synthesize,
        voices
    ]);
    return /*#__PURE__*/ $47e49399f31cf5ba$var$_react["default"].createElement($47e49399f31cf5ba$var$_Context["default"].Provider, {
        value: context
    }, typeof children === "function" ? /*#__PURE__*/ $47e49399f31cf5ba$var$_react["default"].createElement($47e49399f31cf5ba$var$_Context["default"].Consumer, null, function(context) {
        return children(context);
    }) : children);
};
$47e49399f31cf5ba$var$Composer.defaultProps = {
    children: undefined,
    ponyfill: undefined
};
$47e49399f31cf5ba$var$Composer.propTypes = {
    children: $47e49399f31cf5ba$var$_propTypes["default"].any,
    ponyfill: $47e49399f31cf5ba$var$_propTypes["default"].shape({
        speechSynthesis: $47e49399f31cf5ba$var$_propTypes["default"].any,
        SpeechSynthesisUtterance: $47e49399f31cf5ba$var$_propTypes["default"].any
    })
};
var $47e49399f31cf5ba$var$_default = $47e49399f31cf5ba$var$Composer;
module.exports["default"] = $47e49399f31cf5ba$var$_default;

});
parcelRequire.register("i1oQX", function(module, exports) {

var $3NxK7 = parcelRequire("3NxK7");

var $hAZ57 = parcelRequire("hAZ57");

var $eUBmd = parcelRequire("eUBmd");

var $bgwcS = parcelRequire("bgwcS");
function $d1eb9955ab75aad4$var$_slicedToArray(arr, i) {
    return $3NxK7(arr) || $hAZ57(arr, i) || $eUBmd(arr, i) || $bgwcS();
}
module.exports = $d1eb9955ab75aad4$var$_slicedToArray;
module.exports["default"] = module.exports, module.exports.__esModule = true;

});
parcelRequire.register("3NxK7", function(module, exports) {
function $2c401f56a6dbd745$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
module.exports = $2c401f56a6dbd745$var$_arrayWithHoles;
module.exports["default"] = module.exports, module.exports.__esModule = true;

});

parcelRequire.register("hAZ57", function(module, exports) {
function $ccf52dfc0ba2553e$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
module.exports = $ccf52dfc0ba2553e$var$_iterableToArrayLimit;
module.exports["default"] = module.exports, module.exports.__esModule = true;

});

parcelRequire.register("eUBmd", function(module, exports) {

var $tuGYA = parcelRequire("tuGYA");
function $adb3460ac53a2a44$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $tuGYA(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $tuGYA(o, minLen);
}
module.exports = $adb3460ac53a2a44$var$_unsupportedIterableToArray;
module.exports["default"] = module.exports, module.exports.__esModule = true;

});
parcelRequire.register("tuGYA", function(module, exports) {
function $058a845f668517a4$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
module.exports = $058a845f668517a4$var$_arrayLikeToArray;
module.exports["default"] = module.exports, module.exports.__esModule = true;

});


parcelRequire.register("bgwcS", function(module, exports) {
function $833a2be71db78ff7$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
module.exports = $833a2be71db78ff7$var$_nonIterableRest;
module.exports["default"] = module.exports, module.exports.__esModule = true;

});


parcelRequire.register("iRfx4", function(module, exports) {
"use strict";

var $fJbaf = parcelRequire("fJbaf");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $dba939a93757fe50$var$_react = $fJbaf((parcelRequire("eO7Kz")));
var $dba939a93757fe50$var$Context = /*#__PURE__*/ $dba939a93757fe50$var$_react["default"].createContext();
var $dba939a93757fe50$var$_default = $dba939a93757fe50$var$Context;
module.exports["default"] = $dba939a93757fe50$var$_default;

});

parcelRequire.register("dKnDS", function(module, exports) {
"use strict";

var $fJbaf = parcelRequire("fJbaf");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = $a021e9194c3dd259$var$createSynthesize;

var $a021e9194c3dd259$var$_regenerator = $fJbaf((parcelRequire("38wul")));

var $a021e9194c3dd259$var$_toConsumableArray2 = $fJbaf((parcelRequire("lq84H")));

var $a021e9194c3dd259$var$_asyncToGenerator2 = $fJbaf((parcelRequire("UlhqG")));

var $a021e9194c3dd259$var$_QueuedUtterance = $fJbaf((parcelRequire("azn2b")));
function $a021e9194c3dd259$var$createSynthesize() {
    var queueWithCurrent = [];
    var running;
    var run = /*#__PURE__*/ function() {
        var _ref = (0, $a021e9194c3dd259$var$_asyncToGenerator2["default"])(/*#__PURE__*/ $a021e9194c3dd259$var$_regenerator["default"].mark(function _callee2() {
            return $a021e9194c3dd259$var$_regenerator["default"].wrap(function _callee2$(_context2) {
                while(true)switch(_context2.prev = _context2.next){
                    case 0:
                        if (!running) {
                            _context2.next = 2;
                            break;
                        }
                        return _context2.abrupt("return");
                    case 2:
                        running = true;
                        _context2.prev = 3;
                        return _context2.delegateYield(/*#__PURE__*/ $a021e9194c3dd259$var$_regenerator["default"].mark(function _callee() {
                            var queuedUtterance;
                            return $a021e9194c3dd259$var$_regenerator["default"].wrap(function _callee$(_context) {
                                while(true)switch(_context.prev = _context.next){
                                    case 0:
                                        if (!(queuedUtterance = queueWithCurrent[0])) {
                                            _context.next = 12;
                                            break;
                                        }
                                        _context.prev = 1;
                                        _context.next = 4;
                                        return queuedUtterance.speak();
                                    case 4:
                                        _context.next = 9;
                                        break;
                                    case 6:
                                        _context.prev = 6;
                                        _context.t0 = _context["catch"](1);
                                        // TODO: If the error is due to Safari restriction on user touch
                                        //       The next loop on the next audio will also fail because it was not queued with a user touch
                                        _context.t0.message !== "cancelled" && console.error(_context.t0);
                                    case 9:
                                        queueWithCurrent = queueWithCurrent.filter(function(target) {
                                            return target !== queuedUtterance;
                                        });
                                        _context.next = 0;
                                        break;
                                    case 12:
                                    case "end":
                                        return _context.stop();
                                }
                            }, _callee, null, [
                                [
                                    1,
                                    6
                                ]
                            ]);
                        })(), "t0", 5);
                    case 5:
                        _context2.prev = 5;
                        running = false;
                        return _context2.finish(5);
                    case 8:
                    case "end":
                        return _context2.stop();
                }
            }, _callee2, null, [
                [
                    3,
                    ,
                    5,
                    8
                ]
            ]);
        }));
        return function run() {
            return _ref.apply(this, arguments);
        };
    }();
    return function(ponyfill, utterance) {
        var _ref2 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {}, onEnd = _ref2.onEnd, onError = _ref2.onError, onStart = _ref2.onStart;
        if (!(utterance instanceof ponyfill.SpeechSynthesisUtterance)) throw new Error("utterance must be instance of the ponyfill");
        var queuedUtterance = new $a021e9194c3dd259$var$_QueuedUtterance["default"](ponyfill, utterance, {
            onEnd: onEnd,
            onError: onError,
            onStart: onStart
        });
        queueWithCurrent = [].concat((0, $a021e9194c3dd259$var$_toConsumableArray2["default"])(queueWithCurrent), [
            queuedUtterance
        ]);
        run();
        return {
            // The cancel() function returns a Promise
            cancel: function cancel() {
                return queuedUtterance.cancel();
            },
            promise: queuedUtterance.promise
        };
    };
}

});
parcelRequire.register("38wul", function(module, exports) {

module.exports = (parcelRequire("6D4qh"));

});
parcelRequire.register("6D4qh", function(module, exports) {
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $4d39d0df6e40952d$var$runtime = function(exports) {
    "use strict";
    var Op = Object.prototype;
    var hasOwn = Op.hasOwnProperty;
    var defineProperty = Object.defineProperty || function(obj, key, desc) {
        obj[key] = desc.value;
    };
    var undefined; // More compressible than void 0.
    var $Symbol = typeof Symbol === "function" ? Symbol : {};
    var iteratorSymbol = $Symbol.iterator || "@@iterator";
    var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
    var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
    function define(obj, key, value) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
        return obj[key];
    }
    try {
        // IE 8 has a broken Object.defineProperty that only works on DOM objects.
        define({}, "");
    } catch (err) {
        define = function(obj, key, value) {
            return obj[key] = value;
        };
    }
    function wrap(innerFn, outerFn, self, tryLocsList) {
        // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
        var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
        var generator = Object.create(protoGenerator.prototype);
        var context = new Context(tryLocsList || []);
        // The ._invoke method unifies the implementations of the .next,
        // .throw, and .return methods.
        defineProperty(generator, "_invoke", {
            value: makeInvokeMethod(innerFn, self, context)
        });
        return generator;
    }
    exports.wrap = wrap;
    // Try/catch helper to minimize deoptimizations. Returns a completion
    // record like context.tryEntries[i].completion. This interface could
    // have been (and was previously) designed to take a closure to be
    // invoked without arguments, but in all the cases we care about we
    // already have an existing method we want to call, so there's no need
    // to create a new function object. We can even get away with assuming
    // the method takes exactly one argument, since that happens to be true
    // in every case, so we don't have to touch the arguments object. The
    // only additional allocation required is the completion record, which
    // has a stable shape and so hopefully should be cheap to allocate.
    function tryCatch(fn, obj, arg) {
        try {
            return {
                type: "normal",
                arg: fn.call(obj, arg)
            };
        } catch (err) {
            return {
                type: "throw",
                arg: err
            };
        }
    }
    var GenStateSuspendedStart = "suspendedStart";
    var GenStateSuspendedYield = "suspendedYield";
    var GenStateExecuting = "executing";
    var GenStateCompleted = "completed";
    // Returning this object from the innerFn has the same effect as
    // breaking out of the dispatch switch statement.
    var ContinueSentinel = {};
    // Dummy constructor functions that we use as the .constructor and
    // .constructor.prototype properties for functions that return Generator
    // objects. For full spec compliance, you may wish to configure your
    // minifier not to mangle the names of these two functions.
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    // This is a polyfill for %IteratorPrototype% for environments that
    // don't natively support it.
    var IteratorPrototype = {};
    define(IteratorPrototype, iteratorSymbol, function() {
        return this;
    });
    var getProto = Object.getPrototypeOf;
    var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
    if (NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
    var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
    GeneratorFunction.prototype = GeneratorFunctionPrototype;
    defineProperty(Gp, "constructor", {
        value: GeneratorFunctionPrototype,
        configurable: true
    });
    defineProperty(GeneratorFunctionPrototype, "constructor", {
        value: GeneratorFunction,
        configurable: true
    });
    GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction");
    // Helper for defining the .next, .throw, and .return methods of the
    // Iterator interface in terms of a single ._invoke method.
    function defineIteratorMethods(prototype) {
        [
            "next",
            "throw",
            "return"
        ].forEach(function(method) {
            define(prototype, method, function(arg) {
                return this._invoke(method, arg);
            });
        });
    }
    exports.isGeneratorFunction = function(genFun) {
        var ctor = typeof genFun === "function" && genFun.constructor;
        return ctor ? ctor === GeneratorFunction || // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction" : false;
    };
    exports.mark = function(genFun) {
        if (Object.setPrototypeOf) Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
        else {
            genFun.__proto__ = GeneratorFunctionPrototype;
            define(genFun, toStringTagSymbol, "GeneratorFunction");
        }
        genFun.prototype = Object.create(Gp);
        return genFun;
    };
    // Within the body of any async function, `await x` is transformed to
    // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
    // `hasOwn.call(value, "__await")` to determine if the yielded value is
    // meant to be awaited.
    exports.awrap = function(arg) {
        return {
            __await: arg
        };
    };
    function AsyncIterator(generator, PromiseImpl) {
        function invoke(method, arg, resolve, reject) {
            var record = tryCatch(generator[method], generator, arg);
            if (record.type === "throw") reject(record.arg);
            else {
                var result = record.arg;
                var value = result.value;
                if (value && typeof value === "object" && hasOwn.call(value, "__await")) return PromiseImpl.resolve(value.__await).then(function(value) {
                    invoke("next", value, resolve, reject);
                }, function(err) {
                    invoke("throw", err, resolve, reject);
                });
                return PromiseImpl.resolve(value).then(function(unwrapped) {
                    // When a yielded Promise is resolved, its final value becomes
                    // the .value of the Promise<{value,done}> result for the
                    // current iteration.
                    result.value = unwrapped;
                    resolve(result);
                }, function(error) {
                    // If a rejected Promise was yielded, throw the rejection back
                    // into the async generator function so it can be handled there.
                    return invoke("throw", error, resolve, reject);
                });
            }
        }
        var previousPromise;
        function enqueue(method, arg) {
            function callInvokeWithMethodAndArg() {
                return new PromiseImpl(function(resolve, reject) {
                    invoke(method, arg, resolve, reject);
                });
            }
            return previousPromise = // If enqueue has been called before, then we want to wait until
            // all previous Promises have been resolved before calling invoke,
            // so that results are always delivered in the correct order. If
            // enqueue has not been called before, then it is important to
            // call invoke immediately, without waiting on a callback to fire,
            // so that the async generator function has the opportunity to do
            // any necessary setup in a predictable way. This predictability
            // is why the Promise constructor synchronously invokes its
            // executor callback, and why async functions synchronously
            // execute code before the first await. Since we implement simple
            // async functions in terms of async generators, it is especially
            // important to get this right, even though it requires care.
            previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, // Avoid propagating failures to Promises returned by later
            // invocations of the iterator.
            callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
        }
        // Define the unified helper method that is used to implement .next,
        // .throw, and .return (see defineIteratorMethods).
        defineProperty(this, "_invoke", {
            value: enqueue
        });
    }
    defineIteratorMethods(AsyncIterator.prototype);
    define(AsyncIterator.prototype, asyncIteratorSymbol, function() {
        return this;
    });
    exports.AsyncIterator = AsyncIterator;
    // Note that simple async functions are implemented on top of
    // AsyncIterator objects; they just return a Promise for the value of
    // the final result produced by the iterator.
    exports.async = function(innerFn, outerFn, self, tryLocsList, PromiseImpl) {
        if (PromiseImpl === void 0) PromiseImpl = Promise;
        var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
        return exports.isGeneratorFunction(outerFn) ? iter // If outerFn is a generator, return the full iterator.
         : iter.next().then(function(result) {
            return result.done ? result.value : iter.next();
        });
    };
    function makeInvokeMethod(innerFn, self, context) {
        var state = GenStateSuspendedStart;
        return function invoke(method, arg) {
            if (state === GenStateExecuting) throw new Error("Generator is already running");
            if (state === GenStateCompleted) {
                if (method === "throw") throw arg;
                // Be forgiving, per 25.3.3.3.3 of the spec:
                // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
                return doneResult();
            }
            context.method = method;
            context.arg = arg;
            while(true){
                var delegate = context.delegate;
                if (delegate) {
                    var delegateResult = maybeInvokeDelegate(delegate, context);
                    if (delegateResult) {
                        if (delegateResult === ContinueSentinel) continue;
                        return delegateResult;
                    }
                }
                if (context.method === "next") // Setting context._sent for legacy support of Babel's
                // function.sent implementation.
                context.sent = context._sent = context.arg;
                else if (context.method === "throw") {
                    if (state === GenStateSuspendedStart) {
                        state = GenStateCompleted;
                        throw context.arg;
                    }
                    context.dispatchException(context.arg);
                } else if (context.method === "return") context.abrupt("return", context.arg);
                state = GenStateExecuting;
                var record = tryCatch(innerFn, self, context);
                if (record.type === "normal") {
                    // If an exception is thrown from innerFn, we leave state ===
                    // GenStateExecuting and loop back for another invocation.
                    state = context.done ? GenStateCompleted : GenStateSuspendedYield;
                    if (record.arg === ContinueSentinel) continue;
                    return {
                        value: record.arg,
                        done: context.done
                    };
                } else if (record.type === "throw") {
                    state = GenStateCompleted;
                    // Dispatch the exception by looping back around to the
                    // context.dispatchException(context.arg) call above.
                    context.method = "throw";
                    context.arg = record.arg;
                }
            }
        };
    }
    // Call delegate.iterator[context.method](context.arg) and handle the
    // result, either by returning a { value, done } result from the
    // delegate iterator, or by modifying context.method and context.arg,
    // setting context.delegate to null, and returning the ContinueSentinel.
    function maybeInvokeDelegate(delegate, context) {
        var methodName = context.method;
        var method = delegate.iterator[methodName];
        if (method === undefined) {
            // A .throw or .return when the delegate iterator has no .throw
            // method, or a missing .next mehtod, always terminate the
            // yield* loop.
            context.delegate = null;
            // Note: ["return"] must be used for ES3 parsing compatibility.
            if (methodName === "throw" && delegate.iterator["return"]) {
                // If the delegate iterator has a return method, give it a
                // chance to clean up.
                context.method = "return";
                context.arg = undefined;
                maybeInvokeDelegate(delegate, context);
                if (context.method === "throw") // If maybeInvokeDelegate(context) changed context.method from
                // "return" to "throw", let that override the TypeError below.
                return ContinueSentinel;
            }
            if (methodName !== "return") {
                context.method = "throw";
                context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method");
            }
            return ContinueSentinel;
        }
        var record = tryCatch(method, delegate.iterator, context.arg);
        if (record.type === "throw") {
            context.method = "throw";
            context.arg = record.arg;
            context.delegate = null;
            return ContinueSentinel;
        }
        var info = record.arg;
        if (!info) {
            context.method = "throw";
            context.arg = new TypeError("iterator result is not an object");
            context.delegate = null;
            return ContinueSentinel;
        }
        if (info.done) {
            // Assign the result of the finished delegate to the temporary
            // variable specified by delegate.resultName (see delegateYield).
            context[delegate.resultName] = info.value;
            // Resume execution at the desired location (see delegateYield).
            context.next = delegate.nextLoc;
            // If context.method was "throw" but the delegate handled the
            // exception, let the outer generator proceed normally. If
            // context.method was "next", forget context.arg since it has been
            // "consumed" by the delegate iterator. If context.method was
            // "return", allow the original .return call to continue in the
            // outer generator.
            if (context.method !== "return") {
                context.method = "next";
                context.arg = undefined;
            }
        } else // Re-yield the result returned by the delegate method.
        return info;
        // The delegate iterator is finished, so forget it and continue with
        // the outer generator.
        context.delegate = null;
        return ContinueSentinel;
    }
    // Define Generator.prototype.{next,throw,return} in terms of the
    // unified ._invoke helper method.
    defineIteratorMethods(Gp);
    define(Gp, toStringTagSymbol, "Generator");
    // A Generator should always return itself as the iterator object when the
    // @@iterator function is called on it. Some browsers' implementations of the
    // iterator prototype chain incorrectly implement this, causing the Generator
    // object to not be returned from this call. This ensures that doesn't happen.
    // See https://github.com/facebook/regenerator/issues/274 for more details.
    define(Gp, iteratorSymbol, function() {
        return this;
    });
    define(Gp, "toString", function() {
        return "[object Generator]";
    });
    function pushTryEntry(locs) {
        var entry = {
            tryLoc: locs[0]
        };
        if (1 in locs) entry.catchLoc = locs[1];
        if (2 in locs) {
            entry.finallyLoc = locs[2];
            entry.afterLoc = locs[3];
        }
        this.tryEntries.push(entry);
    }
    function resetTryEntry(entry) {
        var record = entry.completion || {};
        record.type = "normal";
        delete record.arg;
        entry.completion = record;
    }
    function Context(tryLocsList) {
        // The root entry object (effectively a try statement without a catch
        // or a finally block) gives us a place to store values thrown from
        // locations where there is no enclosing try statement.
        this.tryEntries = [
            {
                tryLoc: "root"
            }
        ];
        tryLocsList.forEach(pushTryEntry, this);
        this.reset(true);
    }
    exports.keys = function(val) {
        var object = Object(val);
        var keys = [];
        for(var key in object)keys.push(key);
        keys.reverse();
        // Rather than returning an object with a next method, we keep
        // things simple and return the next function itself.
        return function next() {
            while(keys.length){
                var key = keys.pop();
                if (key in object) {
                    next.value = key;
                    next.done = false;
                    return next;
                }
            }
            // To avoid creating an additional object, we just hang the .value
            // and .done properties off the next function object itself. This
            // also ensures that the minifier will not anonymize the function.
            next.done = true;
            return next;
        };
    };
    function values(iterable) {
        if (iterable) {
            var iteratorMethod = iterable[iteratorSymbol];
            if (iteratorMethod) return iteratorMethod.call(iterable);
            if (typeof iterable.next === "function") return iterable;
            if (!isNaN(iterable.length)) {
                var i = -1, next = function next() {
                    while(++i < iterable.length)if (hasOwn.call(iterable, i)) {
                        next.value = iterable[i];
                        next.done = false;
                        return next;
                    }
                    next.value = undefined;
                    next.done = true;
                    return next;
                };
                return next.next = next;
            }
        }
        // Return an iterator with no values.
        return {
            next: doneResult
        };
    }
    exports.values = values;
    function doneResult() {
        return {
            value: undefined,
            done: true
        };
    }
    Context.prototype = {
        constructor: Context,
        reset: function(skipTempReset) {
            this.prev = 0;
            this.next = 0;
            // Resetting context._sent for legacy support of Babel's
            // function.sent implementation.
            this.sent = this._sent = undefined;
            this.done = false;
            this.delegate = null;
            this.method = "next";
            this.arg = undefined;
            this.tryEntries.forEach(resetTryEntry);
            if (!skipTempReset) {
                for(var name in this)// Not sure about the optimal order of these conditions:
                if (name.charAt(0) === "t" && hasOwn.call(this, name) && !isNaN(+name.slice(1))) this[name] = undefined;
            }
        },
        stop: function() {
            this.done = true;
            var rootEntry = this.tryEntries[0];
            var rootRecord = rootEntry.completion;
            if (rootRecord.type === "throw") throw rootRecord.arg;
            return this.rval;
        },
        dispatchException: function(exception) {
            if (this.done) throw exception;
            var context = this;
            function handle(loc, caught) {
                record.type = "throw";
                record.arg = exception;
                context.next = loc;
                if (caught) {
                    // If the dispatched exception was caught by a catch block,
                    // then let that catch block handle the exception normally.
                    context.method = "next";
                    context.arg = undefined;
                }
                return !!caught;
            }
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                var record = entry.completion;
                if (entry.tryLoc === "root") // Exception thrown outside of any try block that could handle
                // it, so set the completion value of the entire function to
                // throw the exception.
                return handle("end");
                if (entry.tryLoc <= this.prev) {
                    var hasCatch = hasOwn.call(entry, "catchLoc");
                    var hasFinally = hasOwn.call(entry, "finallyLoc");
                    if (hasCatch && hasFinally) {
                        if (this.prev < entry.catchLoc) return handle(entry.catchLoc, true);
                        else if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
                    } else if (hasCatch) {
                        if (this.prev < entry.catchLoc) return handle(entry.catchLoc, true);
                    } else if (hasFinally) {
                        if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
                    } else throw new Error("try statement without catch or finally");
                }
            }
        },
        abrupt: function(type, arg) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
                    var finallyEntry = entry;
                    break;
                }
            }
            if (finallyEntry && (type === "break" || type === "continue") && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc) // Ignore the finally entry if control is not jumping to a
            // location outside the try/catch block.
            finallyEntry = null;
            var record = finallyEntry ? finallyEntry.completion : {};
            record.type = type;
            record.arg = arg;
            if (finallyEntry) {
                this.method = "next";
                this.next = finallyEntry.finallyLoc;
                return ContinueSentinel;
            }
            return this.complete(record);
        },
        complete: function(record, afterLoc) {
            if (record.type === "throw") throw record.arg;
            if (record.type === "break" || record.type === "continue") this.next = record.arg;
            else if (record.type === "return") {
                this.rval = this.arg = record.arg;
                this.method = "return";
                this.next = "end";
            } else if (record.type === "normal" && afterLoc) this.next = afterLoc;
            return ContinueSentinel;
        },
        finish: function(finallyLoc) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.finallyLoc === finallyLoc) {
                    this.complete(entry.completion, entry.afterLoc);
                    resetTryEntry(entry);
                    return ContinueSentinel;
                }
            }
        },
        "catch": function(tryLoc) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.tryLoc === tryLoc) {
                    var record = entry.completion;
                    if (record.type === "throw") {
                        var thrown = record.arg;
                        resetTryEntry(entry);
                    }
                    return thrown;
                }
            }
            // The context.catch method must only be called with a location
            // argument that corresponds to a known catch block.
            throw new Error("illegal catch attempt");
        },
        delegateYield: function(iterable, resultName, nextLoc) {
            this.delegate = {
                iterator: values(iterable),
                resultName: resultName,
                nextLoc: nextLoc
            };
            if (this.method === "next") // Deliberately forget the last sent value so that we don't
            // accidentally pass it on to the delegate.
            this.arg = undefined;
            return ContinueSentinel;
        }
    };
    // Regardless of whether this script is executing as a CommonJS module
    // or not, return the runtime object so that we can declare the variable
    // regeneratorRuntime in the outer scope, which allows this module to be
    // injected easily by `bin/regenerator --include-runtime script.js`.
    return exports;
}(// If this script is executing as a CommonJS module, use module.exports
// as the regeneratorRuntime namespace. Otherwise create a new empty
// object. Either way, the resulting object will be used to initialize
// the regeneratorRuntime variable at the top of this file.
(0, module.exports));
try {
    regeneratorRuntime = $4d39d0df6e40952d$var$runtime;
} catch (accidentalStrictMode) {
    // This module should not be running in strict mode, so the above
    // assignment should always work unless something is misconfigured. Just
    // in case runtime.js accidentally runs in strict mode, in modern engines
    // we can explicitly access globalThis. In older engines we can escape
    // strict mode using a global Function call. This could conceivably fail
    // if a Content Security Policy forbids using Function, but in that case
    // the proper solution is to fix the accidental strict mode problem. If
    // you've misconfigured your bundler to force strict mode and applied a
    // CSP to forbid Function, and you're not willing to fix either of those
    // problems, please detail your unique predicament in a GitHub issue.
    if (typeof globalThis === "object") globalThis.regeneratorRuntime = $4d39d0df6e40952d$var$runtime;
    else Function("r", "regeneratorRuntime = r")($4d39d0df6e40952d$var$runtime);
}

});


parcelRequire.register("lq84H", function(module, exports) {

var $7kuWX = parcelRequire("7kuWX");

var $kJV8Z = parcelRequire("kJV8Z");

var $eUBmd = parcelRequire("eUBmd");

var $9Ebwz = parcelRequire("9Ebwz");
function $f9824a24f2f899df$var$_toConsumableArray(arr) {
    return $7kuWX(arr) || $kJV8Z(arr) || $eUBmd(arr) || $9Ebwz();
}
module.exports = $f9824a24f2f899df$var$_toConsumableArray;
module.exports["default"] = module.exports, module.exports.__esModule = true;

});
parcelRequire.register("7kuWX", function(module, exports) {

var $tuGYA = parcelRequire("tuGYA");
function $556268a60c13f6f7$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $tuGYA(arr);
}
module.exports = $556268a60c13f6f7$var$_arrayWithoutHoles;
module.exports["default"] = module.exports, module.exports.__esModule = true;

});

parcelRequire.register("kJV8Z", function(module, exports) {
function $f1945637b5da2e76$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
module.exports = $f1945637b5da2e76$var$_iterableToArray;
module.exports["default"] = module.exports, module.exports.__esModule = true;

});

parcelRequire.register("9Ebwz", function(module, exports) {
function $7060c9fd5c470f0f$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
module.exports = $7060c9fd5c470f0f$var$_nonIterableSpread;
module.exports["default"] = module.exports, module.exports.__esModule = true;

});


parcelRequire.register("UlhqG", function(module, exports) {
function $0a95bcdd8d1d61ef$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) resolve(value);
    else Promise.resolve(value).then(_next, _throw);
}
function $0a95bcdd8d1d61ef$var$_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                $0a95bcdd8d1d61ef$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                $0a95bcdd8d1d61ef$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
module.exports = $0a95bcdd8d1d61ef$var$_asyncToGenerator;
module.exports["default"] = module.exports, module.exports.__esModule = true;

});

parcelRequire.register("azn2b", function(module, exports) {
"use strict";

var $fJbaf = parcelRequire("fJbaf");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $7b1f0a5ce879b7c6$var$_regenerator = $fJbaf((parcelRequire("38wul")));

var $7b1f0a5ce879b7c6$var$_classCallCheck2 = $fJbaf((parcelRequire("bycDr")));

var $7b1f0a5ce879b7c6$var$_createClass2 = $fJbaf((parcelRequire("ksQqV")));

var $7b1f0a5ce879b7c6$var$_asyncToGenerator2 = $fJbaf((parcelRequire("UlhqG")));

var $7b1f0a5ce879b7c6$var$_createCustomEvent = $fJbaf((parcelRequire("3Hm7I")));

var $7b1f0a5ce879b7c6$var$_createDeferred = $fJbaf((parcelRequire("9FSCY")));

var $7b1f0a5ce879b7c6$var$_createErrorEvent = $fJbaf((parcelRequire("aRqfs")));
function $7b1f0a5ce879b7c6$var$speakUtterance(_x, _x2, _x3) {
    return $7b1f0a5ce879b7c6$var$_speakUtterance.apply(this, arguments);
}
function $7b1f0a5ce879b7c6$var$_speakUtterance() {
    $7b1f0a5ce879b7c6$var$_speakUtterance = (0, $7b1f0a5ce879b7c6$var$_asyncToGenerator2["default"])(/*#__PURE__*/ $7b1f0a5ce879b7c6$var$_regenerator["default"].mark(function _callee4(ponyfill, utterance, startCallback) {
        var speechSynthesis, startDeferred, errorDeferred, endDeferred, startEvent, finishedSpeaking, endPromise, endEvent;
        return $7b1f0a5ce879b7c6$var$_regenerator["default"].wrap(function _callee4$(_context4) {
            while(true)switch(_context4.prev = _context4.next){
                case 0:
                    speechSynthesis = ponyfill.speechSynthesis;
                    startDeferred = (0, $7b1f0a5ce879b7c6$var$_createDeferred["default"])();
                    errorDeferred = (0, $7b1f0a5ce879b7c6$var$_createDeferred["default"])();
                    endDeferred = (0, $7b1f0a5ce879b7c6$var$_createDeferred["default"])();
                    utterance.addEventListener("end", endDeferred.resolve);
                    utterance.addEventListener("error", errorDeferred.resolve);
                    utterance.addEventListener("start", startDeferred.resolve); // if (speechSynthesis.speaking) {
                    //   console.warn(`ASSERTION: speechSynthesis.speaking should not be truthy before we call speak`);
                    // }
                    speechSynthesis.speak(utterance);
                    _context4.next = 10;
                    return Promise.race([
                        errorDeferred.promise,
                        startDeferred.promise
                    ]);
                case 10:
                    startEvent = _context4.sent;
                    if (!(startEvent.type === "error")) {
                        _context4.next = 13;
                        break;
                    }
                    throw startEvent.error;
                case 13:
                    endPromise = Promise.race([
                        errorDeferred.promise,
                        endDeferred.promise
                    ]);
                    startCallback && startCallback(/*#__PURE__*/ (0, $7b1f0a5ce879b7c6$var$_asyncToGenerator2["default"])(/*#__PURE__*/ $7b1f0a5ce879b7c6$var$_regenerator["default"].mark(function _callee3() {
                        return $7b1f0a5ce879b7c6$var$_regenerator["default"].wrap(function _callee3$(_context3) {
                            while(true)switch(_context3.prev = _context3.next){
                                case 0:
                                    if (finishedSpeaking) {
                                        _context3.next = 4;
                                        break;
                                    }
                                    speechSynthesis.cancel();
                                    _context3.next = 4;
                                    return endPromise;
                                case 4:
                                case "end":
                                    return _context3.stop();
                            }
                        }, _callee3);
                    })));
                    _context4.next = 17;
                    return endPromise;
                case 17:
                    endEvent = _context4.sent;
                    finishedSpeaking = true; // if (speechSynthesis.speaking) {
                    //   console.warn(`ASSERTION: speechSynthesis.speaking should not be truthy after speak is stopped`);
                    // }
                    // console.debug(`ENDED: ${ utterance.text }`);
                    if (!(endEvent.type === "error")) {
                        _context4.next = 21;
                        break;
                    }
                    throw endEvent.error;
                case 21:
                case "end":
                    return _context4.stop();
            }
        }, _callee4);
    }));
    return $7b1f0a5ce879b7c6$var$_speakUtterance.apply(this, arguments);
}
var $7b1f0a5ce879b7c6$var$QueuedUtterance = /*#__PURE__*/ function() {
    function QueuedUtterance(ponyfill, utterance, _ref) {
        var onEnd = _ref.onEnd, onError = _ref.onError, onStart = _ref.onStart;
        (0, $7b1f0a5ce879b7c6$var$_classCallCheck2["default"])(this, QueuedUtterance);
        this._cancelled = false;
        this._deferred = (0, $7b1f0a5ce879b7c6$var$_createDeferred["default"])();
        this._onEnd = onEnd;
        this._onError = onError;
        this._onStart = onStart;
        this._ponyfill = ponyfill;
        this._speaking = false;
        this._utterance = utterance;
        this.promise = this._deferred.promise;
    }
    (0, $7b1f0a5ce879b7c6$var$_createClass2["default"])(QueuedUtterance, [
        {
            key: "cancel",
            value: function() {
                var _cancel = (0, $7b1f0a5ce879b7c6$var$_asyncToGenerator2["default"])(/*#__PURE__*/ $7b1f0a5ce879b7c6$var$_regenerator["default"].mark(function _callee() {
                    return $7b1f0a5ce879b7c6$var$_regenerator["default"].wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                this._cancelled = true;
                                _context.t0 = this._cancel;
                                if (!_context.t0) {
                                    _context.next = 5;
                                    break;
                                }
                                _context.next = 5;
                                return this._cancel();
                            case 5:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this);
                }));
                function cancel() {
                    return _cancel.apply(this, arguments);
                }
                return cancel;
            }()
        },
        {
            key: "speak",
            value: function speak() {
                var _this = this;
                if (this._speaking) console.warn("ASSERTION: QueuedUtterance is already speaking or has spoken.");
                this._speaking = true;
                (0, $7b1f0a5ce879b7c6$var$_asyncToGenerator2["default"])(/*#__PURE__*/ $7b1f0a5ce879b7c6$var$_regenerator["default"].mark(function _callee2() {
                    return $7b1f0a5ce879b7c6$var$_regenerator["default"].wrap(function _callee2$(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                if (!_this._cancelled) {
                                    _context2.next = 2;
                                    break;
                                }
                                throw new Error("cancelled");
                            case 2:
                                _context2.next = 4;
                                return $7b1f0a5ce879b7c6$var$speakUtterance(_this._ponyfill, _this._utterance, function(cancel) {
                                    if (_this._cancelled) {
                                        cancel();
                                        throw new Error("cancelled");
                                    } else {
                                        _this._cancel = cancel;
                                        _this._onStart && _this._onStart((0, $7b1f0a5ce879b7c6$var$_createCustomEvent["default"])("start"));
                                    }
                                });
                            case 4:
                                if (!_this._cancelled) {
                                    _context2.next = 6;
                                    break;
                                }
                                throw new Error("cancelled");
                            case 6:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2);
                }))().then(function() {
                    _this._onEnd && _this._onEnd((0, $7b1f0a5ce879b7c6$var$_createCustomEvent["default"])("end"));
                    _this._deferred.resolve();
                }, function(error) {
                    _this._onError && _this._onError((0, $7b1f0a5ce879b7c6$var$_createErrorEvent["default"])(error));
                    _this._deferred.reject(error);
                });
                return this.promise;
            }
        }
    ]);
    return QueuedUtterance;
}();
module.exports["default"] = $7b1f0a5ce879b7c6$var$QueuedUtterance;

});
parcelRequire.register("bycDr", function(module, exports) {
function $868cabc32e43f8ee$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
module.exports = $868cabc32e43f8ee$var$_classCallCheck;
module.exports["default"] = module.exports, module.exports.__esModule = true;

});

parcelRequire.register("ksQqV", function(module, exports) {
function $ee5f1853a07736dc$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $ee5f1853a07736dc$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $ee5f1853a07736dc$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $ee5f1853a07736dc$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
module.exports = $ee5f1853a07736dc$var$_createClass;
module.exports["default"] = module.exports, module.exports.__esModule = true;

});

parcelRequire.register("3Hm7I", function(module, exports) {
"use strict";

var $fJbaf = parcelRequire("fJbaf");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = $2b168c842ecdd48c$var$createCustomEvent;

var $2b168c842ecdd48c$var$_slicedToArray2 = $fJbaf((parcelRequire("i1oQX")));
function $2b168c842ecdd48c$var$createCustomEvent(name, eventInitDict) {
    if (name === "error") {
        if (typeof ErrorEvent === "function") return new ErrorEvent(name, eventInitDict);
    } else if (typeof CustomEvent === "function") return new CustomEvent(name, eventInitDict);
    var event = document.createEvent("Event");
    event.initEvent(name, true, true);
    Object.entries(eventInitDict || {}).forEach(function(_ref) {
        var _ref2 = (0, $2b168c842ecdd48c$var$_slicedToArray2["default"])(_ref, 2), key = _ref2[0], value = _ref2[1];
        event[key] = value;
    });
    return event;
}

});

parcelRequire.register("9FSCY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = $70b2514efae0be10$var$createDeferred;
function $70b2514efae0be10$var$createDeferred() {
    var reject, resolve;
    var promise = new Promise(function(promiseResolve, promiseReject) {
        reject = promiseReject;
        resolve = promiseResolve;
    });
    if (!reject || !resolve) throw new Error("Promise is not a ES-compliant and do not run exector immediately");
    return {
        promise: promise,
        reject: reject,
        resolve: resolve
    };
}

});

parcelRequire.register("aRqfs", function(module, exports) {
"use strict";

var $fJbaf = parcelRequire("fJbaf");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = $7e8337038fba614f$var$createErrorEvent;

var $7e8337038fba614f$var$_createCustomEvent = $fJbaf((parcelRequire("3Hm7I")));
function $7e8337038fba614f$var$createErrorEvent(error) {
    return (0, $7e8337038fba614f$var$_createCustomEvent["default"])("error", {
        error: error
    });
}

});



parcelRequire.register("iufls", function(module, exports) {
"use strict";

var $fJbaf = parcelRequire("fJbaf");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = $d756ee939345357c$var$migrateDeprecatedProps;

var $d756ee939345357c$var$_defineProperty2 = $fJbaf((parcelRequire("i8ead")));

var $d756ee939345357c$var$_objectWithoutProperties2 = $fJbaf((parcelRequire("c3Qjm")));

var $d756ee939345357c$var$_Say = $fJbaf((parcelRequire("3DQH2")));

var $d756ee939345357c$var$_SayButton = $fJbaf((parcelRequire("jj2lF")));
var $d756ee939345357c$var$_excluded = [
    "ponyfill",
    "speak",
    "speechSynthesis",
    "speechSynthesisUtterance",
    "text"
];
function $d756ee939345357c$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $d756ee939345357c$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $d756ee939345357c$var$ownKeys(Object(source), true).forEach(function(key) {
            (0, $d756ee939345357c$var$_defineProperty2["default"])(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $d756ee939345357c$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var $d756ee939345357c$var$warnings = {
    ponyfill: true,
    saySpeak: true
};
function $d756ee939345357c$var$migrateDeprecatedProps(_ref, componentType) {
    var ponyfill = _ref.ponyfill, speak = _ref.speak, speechSynthesis = _ref.speechSynthesis, speechSynthesisUtterance = _ref.speechSynthesisUtterance, text = _ref.text, otherProps = (0, $d756ee939345357c$var$_objectWithoutProperties2["default"])(_ref, $d756ee939345357c$var$_excluded);
    if (!ponyfill && (speechSynthesis || speechSynthesisUtterance)) {
        if ($d756ee939345357c$var$warnings.ponyfill) {
            console.warn('react-say: "speechSynthesis" and "speechSynthesisUtterance" props has been renamed to "ponyfill". Please update your code. The deprecated props will be removed in version >= 3.0.0.');
            $d756ee939345357c$var$warnings.ponyfill = false;
        }
        ponyfill = {
            speechSynthesis: speechSynthesis,
            SpeechSynthesisUtterance: speechSynthesisUtterance
        };
    }
    if (componentType === $d756ee939345357c$var$_Say["default"] || componentType === $d756ee939345357c$var$_SayButton["default"]) {
        if (speak && !text) {
            if ($d756ee939345357c$var$warnings.saySpeak) {
                console.warn('react-say: "speak" prop has been renamed to "text". Please update your code. The deprecated props will be removed in version >= 3.0.0.');
                $d756ee939345357c$var$warnings.saySpeak = false;
            }
            text = speak;
        }
    }
    return $d756ee939345357c$var$_objectSpread({
        ponyfill: ponyfill,
        text: text
    }, otherProps);
}

});
parcelRequire.register("jj2lF", function(module, exports) {
"use strict";

var $fJbaf = parcelRequire("fJbaf");

var $laaNS = parcelRequire("laaNS");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $e0e19d0c3dddac65$var$_slicedToArray2 = $fJbaf((parcelRequire("i1oQX")));

var $e0e19d0c3dddac65$var$_propTypes = $fJbaf((parcelRequire("f7UXb")));

var $e0e19d0c3dddac65$var$_react = $e0e19d0c3dddac65$var$_interopRequireWildcard((parcelRequire("eO7Kz")));

var $e0e19d0c3dddac65$var$_migrateDeprecatedProps = $fJbaf((parcelRequire("iufls")));

var $e0e19d0c3dddac65$var$_Say = $fJbaf((parcelRequire("3DQH2")));
function $e0e19d0c3dddac65$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($e0e19d0c3dddac65$var$_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $e0e19d0c3dddac65$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || $laaNS(obj) !== "object" && typeof obj !== "function") return {
        "default": obj
    };
    var cache = $e0e19d0c3dddac65$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj["default"] = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
var $e0e19d0c3dddac65$var$SayButton = function SayButton(props) {
    var _migrateDeprecatedPro = (0, $e0e19d0c3dddac65$var$_migrateDeprecatedProps["default"])(props, SayButton), children = _migrateDeprecatedPro.children, disabled = _migrateDeprecatedPro.disabled, lang = _migrateDeprecatedPro.lang, onBoundary = _migrateDeprecatedPro.onBoundary, _onEnd = _migrateDeprecatedPro.onEnd, onError = _migrateDeprecatedPro.onError, onStart = _migrateDeprecatedPro.onStart, pitch = _migrateDeprecatedPro.pitch, ponyfill = _migrateDeprecatedPro.ponyfill, rate = _migrateDeprecatedPro.rate, text = _migrateDeprecatedPro.text, voice = _migrateDeprecatedPro.voice, volume = _migrateDeprecatedPro.volume;
    var _useState = (0, $e0e19d0c3dddac65$var$_react.useState)(false), _useState2 = (0, $e0e19d0c3dddac65$var$_slicedToArray2["default"])(_useState, 2), busy = _useState2[0], setBusy = _useState2[1];
    var handleClick = (0, $e0e19d0c3dddac65$var$_react.useCallback)(function() {
        return setBusy(true);
    });
    var sayProps = {
        lang: lang,
        onBoundary: onBoundary,
        onEnd: function onEnd(event) {
            setBusy(false);
            _onEnd && _onEnd(event);
        },
        onError: onError,
        onStart: onStart,
        pitch: pitch,
        ponyfill: ponyfill,
        rate: rate,
        text: text,
        voice: voice,
        volume: volume
    };
    return /*#__PURE__*/ $e0e19d0c3dddac65$var$_react["default"].createElement($e0e19d0c3dddac65$var$_react["default"].Fragment, null, /*#__PURE__*/ $e0e19d0c3dddac65$var$_react["default"].createElement("button", {
        disabled: typeof disabled === "boolean" ? disabled : busy,
        onClick: handleClick
    }, children), busy && /*#__PURE__*/ $e0e19d0c3dddac65$var$_react["default"].createElement($e0e19d0c3dddac65$var$_Say["default"], sayProps));
};
$e0e19d0c3dddac65$var$SayButton.defaultProps = {
    children: undefined,
    disabled: undefined,
    lang: undefined,
    onBoundary: undefined,
    onEnd: undefined,
    onError: undefined,
    onStart: undefined,
    pitch: undefined,
    ponyfill: undefined,
    rate: undefined,
    text: undefined,
    voice: undefined,
    volume: undefined
};
$e0e19d0c3dddac65$var$SayButton.propTypes = {
    children: $e0e19d0c3dddac65$var$_propTypes["default"].any,
    disabled: $e0e19d0c3dddac65$var$_propTypes["default"].bool,
    lang: $e0e19d0c3dddac65$var$_propTypes["default"].string,
    onBoundary: $e0e19d0c3dddac65$var$_propTypes["default"].func,
    onEnd: $e0e19d0c3dddac65$var$_propTypes["default"].func,
    onError: $e0e19d0c3dddac65$var$_propTypes["default"].func,
    onStart: $e0e19d0c3dddac65$var$_propTypes["default"].func,
    pitch: $e0e19d0c3dddac65$var$_propTypes["default"].number,
    ponyfill: $e0e19d0c3dddac65$var$_propTypes["default"].shape({
        speechSynthesis: $e0e19d0c3dddac65$var$_propTypes["default"].any.isRequired,
        SpeechSynthesisUtterance: $e0e19d0c3dddac65$var$_propTypes["default"].any.isRequired
    }),
    rate: $e0e19d0c3dddac65$var$_propTypes["default"].number,
    text: $e0e19d0c3dddac65$var$_propTypes["default"].string,
    voice: $e0e19d0c3dddac65$var$_propTypes["default"].oneOfType([
        $e0e19d0c3dddac65$var$_propTypes["default"].any,
        $e0e19d0c3dddac65$var$_propTypes["default"].func
    ]),
    volume: $e0e19d0c3dddac65$var$_propTypes["default"].number
};
var $e0e19d0c3dddac65$var$_default = $e0e19d0c3dddac65$var$SayButton;
module.exports["default"] = $e0e19d0c3dddac65$var$_default;

});


parcelRequire.register("30U9h", function(module, exports) {
"use strict";

var $fJbaf = parcelRequire("fJbaf");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = $231ced25b76ae807$var$useEvent;

var $231ced25b76ae807$var$_useImmediateEffect = $fJbaf((parcelRequire("lfsS6")));
function $231ced25b76ae807$var$useEvent(target, name, listener, options) {
    (0, $231ced25b76ae807$var$_useImmediateEffect["default"])(function() {
        var handler = function handler(event) {
            return listener && listener(event);
        };
        target.addEventListener(name, handler, options);
        return function() {
            // It seems speechSynthesis.onvoiceschanged still fire after we called removeEventListener.
            // We are protecting this scenario by setting listener to falsy.
            listener = null;
            target.removeEventListener(name, handler, options);
        };
    }, [
        listener,
        name,
        options,
        target
    ]);
}

});
parcelRequire.register("lfsS6", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = $f78164ff713330e2$var$useImmediateEffect;

var $eO7Kz = parcelRequire("eO7Kz");
function $f78164ff713330e2$var$useImmediateEffect(fn, deps) {
    var unsubscribeRef = (0, $eO7Kz.useRef)({
        first: true,
        id: Math.random().toString(36).substr(2, 5),
        unsubscribe: fn()
    });
    (0, $eO7Kz.useEffect)(function() {
        var current = unsubscribeRef.current;
        if (!current.first) current.unsubscribe = fn();
        else current.first = false;
        return function() {
            current.unsubscribe && current.unsubscribe();
            current.unsubscribe = null;
        };
    }, deps);
}

});



parcelRequire.register("6fE3q", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = $48d336c19877864c$var$createNativeUtterance;
function $48d336c19877864c$var$createNativeUtterance(_ref, _ref2) {
    var speechSynthesis = _ref.speechSynthesis, SpeechSynthesisUtterance = _ref.SpeechSynthesisUtterance;
    var lang = _ref2.lang, onBoundary = _ref2.onBoundary, pitch = _ref2.pitch, rate = _ref2.rate, text = _ref2.text, voice = _ref2.voice, volume = _ref2.volume;
    var utterance = new SpeechSynthesisUtterance(text);
    var targetVoice;
    if (typeof voice === "function") targetVoice = voice.call(speechSynthesis, speechSynthesis.getVoices());
    else {
        var _ref3 = voice || {}, voiceURI = _ref3.voiceURI;
        targetVoice = voiceURI && [].find.call([].slice.call(speechSynthesis.getVoices()), function(v) {
            return v.voiceURI === voiceURI;
        });
    } // Edge will mute if "lang" is set to ""
    utterance.lang = lang || "";
    if (pitch || pitch === 0) utterance.pitch = pitch;
    if (rate || rate === 0) utterance.rate = rate;
     // Cognitive Services will error when "voice" is set to "null"
    // Edge will error when "voice" is set to "undefined"
    if (targetVoice) utterance.voice = targetVoice;
    if (volume || volume === 0) utterance.volume = volume;
     // Since browser quirks, start/error/end events are emulated for best compatibility
    // start/error/end events are emulated in QueuedUtterance
    onBoundary && utterance.addEventListener("boundary", onBoundary); // onEnd && utterance.addEventListener('end', onEnd);
    // onError && utterance.addEventListener('error', onError);
    // onStart && utterance.addEventListener('start', onStart);
    return utterance;
}

});

parcelRequire.register("6gQhv", function(module, exports) {
"use strict";

var $fJbaf = parcelRequire("fJbaf");

var $laaNS = parcelRequire("laaNS");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $490ccaaffeb5bf7b$var$_defineProperty2 = $fJbaf((parcelRequire("i8ead")));

var $490ccaaffeb5bf7b$var$_objectWithoutProperties2 = $fJbaf((parcelRequire("c3Qjm")));

var $490ccaaffeb5bf7b$var$_propTypes = $fJbaf((parcelRequire("f7UXb")));

var $490ccaaffeb5bf7b$var$_react = $490ccaaffeb5bf7b$var$_interopRequireWildcard((parcelRequire("eO7Kz")));

var $490ccaaffeb5bf7b$var$_Composer = $fJbaf((parcelRequire("6aGpF")));

var $490ccaaffeb5bf7b$var$_createCustomEvent = $fJbaf((parcelRequire("3Hm7I")));

var $490ccaaffeb5bf7b$var$_createErrorEvent = $fJbaf((parcelRequire("aRqfs")));

var $490ccaaffeb5bf7b$var$_migrateDeprecatedProps = $fJbaf((parcelRequire("iufls")));

var $490ccaaffeb5bf7b$var$_useSynthesize = $fJbaf((parcelRequire("6vltA")));
var $490ccaaffeb5bf7b$var$_excluded = [
    "ponyfill"
];
function $490ccaaffeb5bf7b$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($490ccaaffeb5bf7b$var$_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $490ccaaffeb5bf7b$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || $laaNS(obj) !== "object" && typeof obj !== "function") return {
        "default": obj
    };
    var cache = $490ccaaffeb5bf7b$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj["default"] = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $490ccaaffeb5bf7b$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $490ccaaffeb5bf7b$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $490ccaaffeb5bf7b$var$ownKeys(Object(source), true).forEach(function(key) {
            (0, $490ccaaffeb5bf7b$var$_defineProperty2["default"])(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $490ccaaffeb5bf7b$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var $490ccaaffeb5bf7b$var$SayUtterance = function SayUtterance(props) {
    var _migrateDeprecatedPro = (0, $490ccaaffeb5bf7b$var$_migrateDeprecatedProps["default"])(props), onEnd = _migrateDeprecatedPro.onEnd, onError = _migrateDeprecatedPro.onError, onStart = _migrateDeprecatedPro.onStart, utterance = _migrateDeprecatedPro.utterance;
    var started = (0, $490ccaaffeb5bf7b$var$_react.useRef)(false);
    var synthesize = (0, $490ccaaffeb5bf7b$var$_useSynthesize["default"])(); // This useEffect() is essentially converting Promise-based useSynthesize() into events.
    (0, $490ccaaffeb5bf7b$var$_react.useEffect)(function() {
        // After synthesis started, if utterance has changed, the event will be fired by the wrong target.
        // Thus, we do not allow utterance to change after synthesis started.
        if (started.current) // Since we have already cancelled the previous utterance, we are not starting a new one.
        // This is because if we start a new one, we could fire onStart event twice, which sound confusing to the developer.
        return console.warn("react-say: Should not change utterance after synthesis started.");
        var cancelled;
        var _synthesize = synthesize(utterance, function() {
            started.current = true;
            !cancelled && onStart && onStart((0, $490ccaaffeb5bf7b$var$_createCustomEvent["default"])("start"));
        }), cancel = _synthesize.cancel, promise = _synthesize.promise;
        promise.then(function() {
            return !cancelled && onEnd && onEnd((0, $490ccaaffeb5bf7b$var$_createCustomEvent["default"])("end"));
        }, function(error) {
            return !cancelled && onError && onError((0, $490ccaaffeb5bf7b$var$_createErrorEvent["default"])(error));
        });
        return function() {
            cancelled = true;
            cancel();
        };
    }, []);
    return false;
};
$490ccaaffeb5bf7b$var$SayUtterance.defaultProps = {
    onEnd: undefined,
    onError: undefined,
    onStart: undefined
};
$490ccaaffeb5bf7b$var$SayUtterance.propTypes = {
    onEnd: $490ccaaffeb5bf7b$var$_propTypes["default"].func,
    onError: $490ccaaffeb5bf7b$var$_propTypes["default"].func,
    onStart: $490ccaaffeb5bf7b$var$_propTypes["default"].func
};
var $490ccaaffeb5bf7b$var$SayUtteranceWithContext = function SayUtteranceWithContext(_ref) {
    var ponyfill = _ref.ponyfill, props = (0, $490ccaaffeb5bf7b$var$_objectWithoutProperties2["default"])(_ref, $490ccaaffeb5bf7b$var$_excluded);
    return /*#__PURE__*/ $490ccaaffeb5bf7b$var$_react["default"].createElement($490ccaaffeb5bf7b$var$_Composer["default"], {
        ponyfill: ponyfill
    }, /*#__PURE__*/ $490ccaaffeb5bf7b$var$_react["default"].createElement($490ccaaffeb5bf7b$var$SayUtterance, props));
};
$490ccaaffeb5bf7b$var$SayUtteranceWithContext.defaultProps = $490ccaaffeb5bf7b$var$_objectSpread($490ccaaffeb5bf7b$var$_objectSpread({}, $490ccaaffeb5bf7b$var$SayUtterance.defaultProps), {}, {
    ponyfill: undefined
});
$490ccaaffeb5bf7b$var$SayUtteranceWithContext.propTypes = $490ccaaffeb5bf7b$var$_objectSpread($490ccaaffeb5bf7b$var$_objectSpread({}, $490ccaaffeb5bf7b$var$SayUtterance.propTypes), {}, {
    ponyfill: $490ccaaffeb5bf7b$var$_propTypes["default"].shape({
        speechSynthesis: $490ccaaffeb5bf7b$var$_propTypes["default"].any.isRequired,
        SpeechSynthesisUtterance: $490ccaaffeb5bf7b$var$_propTypes["default"].any.isRequired
    })
});
var $490ccaaffeb5bf7b$var$_default = $490ccaaffeb5bf7b$var$SayUtteranceWithContext;
module.exports["default"] = $490ccaaffeb5bf7b$var$_default;

});
parcelRequire.register("6vltA", function(module, exports) {
"use strict";

var $fJbaf = parcelRequire("fJbaf");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = $4bc64c0ed8ba1def$var$useSynthesize;

var $eO7Kz = parcelRequire("eO7Kz");

var $4bc64c0ed8ba1def$var$_Context = $fJbaf((parcelRequire("iRfx4")));

var $4bc64c0ed8ba1def$var$_createNativeUtterance = $fJbaf((parcelRequire("6fE3q")));
function $4bc64c0ed8ba1def$var$useSynthesize() {
    var _useContext = (0, $eO7Kz.useContext)($4bc64c0ed8ba1def$var$_Context["default"]), ponyfill = _useContext.ponyfill, synthesize = _useContext.synthesize;
    return function(utteranceOrText, progressFn) {
        if (typeof utteranceOrText === "string") utteranceOrText = (0, $4bc64c0ed8ba1def$var$_createNativeUtterance["default"])(ponyfill, {
            text: utteranceOrText
        });
        return synthesize(ponyfill, utteranceOrText, {
            onStart: progressFn && function() {
                return progressFn();
            }
        });
    };
}

});




parcelRequire.register("lEScY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $fc47620bcea14e65$var$_propTypes = $fc47620bcea14e65$var$_interopRequireDefault((parcelRequire("f7UXb")));

var $fc47620bcea14e65$var$_react = $fc47620bcea14e65$var$_interopRequireDefault((parcelRequire("eO7Kz")));

var $fc47620bcea14e65$var$_useStyleToEmotionObject = $fc47620bcea14e65$var$_interopRequireDefault((parcelRequire("6l4uV")));
function $fc47620bcea14e65$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
// TODO: [P3] Although this is for development purpose, prettify it
var $fc47620bcea14e65$var$ROOT_STYLE = {
    color: "Red",
    margin: 0
};
var $fc47620bcea14e65$var$SayAlt = function SayAlt(_ref) {
    var speak = _ref.speak;
    var rootClassName = (0, $fc47620bcea14e65$var$_useStyleToEmotionObject.default)()($fc47620bcea14e65$var$ROOT_STYLE) + "";
    return !!speak && /*#__PURE__*/ $fc47620bcea14e65$var$_react.default.createElement("pre", {
        className: rootClassName
    }, speak);
};
$fc47620bcea14e65$var$SayAlt.defaultProps = {
    speak: ""
};
$fc47620bcea14e65$var$SayAlt.propTypes = {
    speak: $fc47620bcea14e65$var$_propTypes.default.string
};
var $fc47620bcea14e65$var$_default = $fc47620bcea14e65$var$SayAlt;
module.exports.default = $fc47620bcea14e65$var$_default;

});


parcelRequire.register("kUkhJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $f388c5ccb61d64d7$var$useActiveDescendantId;

var $f388c5ccb61d64d7$var$_useContext = $f388c5ccb61d64d7$var$_interopRequireDefault((parcelRequire("30hVF")));
function $f388c5ccb61d64d7$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $f388c5ccb61d64d7$var$useActiveDescendantId() {
    return (0, $f388c5ccb61d64d7$var$_useContext.default)().activeDescendantIdState;
}

});
parcelRequire.register("30hVF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $22ff478570091fe3$var$useTranscriptFocusContext;

var $eO7Kz = parcelRequire("eO7Kz");

var $22ff478570091fe3$var$_Context = $22ff478570091fe3$var$_interopRequireDefault((parcelRequire("ibQNK")));
function $22ff478570091fe3$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $22ff478570091fe3$var$useTranscriptFocusContext() {
    var throwOnUndefined = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
    var contextValue = (0, $eO7Kz.useContext)($22ff478570091fe3$var$_Context.default);
    if (throwOnUndefined && !contextValue) throw new Error("botframework-webchat internal: This hook can only be used under <TranscriptFocusComposer>.");
    return contextValue;
}

});
parcelRequire.register("ibQNK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $eO7Kz = parcelRequire("eO7Kz");
var $d3e23656e19908c9$var$TranscriptFocusContext = /*#__PURE__*/ (0, $eO7Kz.createContext)(undefined);
var $d3e23656e19908c9$var$_default = $d3e23656e19908c9$var$TranscriptFocusContext;
module.exports.default = $d3e23656e19908c9$var$_default;

});



parcelRequire.register("baqhX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $821505451291b0f7$var$useActivityAccessibleName;

var $hd4g0 = parcelRequire("hd4g0");

var $eO7Kz = parcelRequire("eO7Kz");

var $fjDvy = parcelRequire("fjDvy");

var $821505451291b0f7$var$_activityAltText = $821505451291b0f7$var$_interopRequireDefault((parcelRequire("bm4wN")));

var $821505451291b0f7$var$_tabbableElements = $821505451291b0f7$var$_interopRequireDefault((parcelRequire("1ySa1")));

var $821505451291b0f7$var$_useRenderMarkdownAsHTML = $821505451291b0f7$var$_interopRequireDefault((parcelRequire("5BkDS")));

var $821505451291b0f7$var$_useValueRef = $821505451291b0f7$var$_interopRequireDefault((parcelRequire("4Dn0F")));
function $821505451291b0f7$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $821505451291b0f7$var$_slicedToArray(arr, i) {
    return $821505451291b0f7$var$_arrayWithHoles(arr) || $821505451291b0f7$var$_iterableToArrayLimit(arr, i) || $821505451291b0f7$var$_unsupportedIterableToArray(arr, i) || $821505451291b0f7$var$_nonIterableRest();
}
function $821505451291b0f7$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $821505451291b0f7$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $821505451291b0f7$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $821505451291b0f7$var$_arrayLikeToArray(o, minLen);
}
function $821505451291b0f7$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $821505451291b0f7$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $821505451291b0f7$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
var $821505451291b0f7$var$InteractiveType;
(function(InteractiveType) {
    InteractiveType[InteractiveType["LINK"] = 0] = "LINK";
    InteractiveType[InteractiveType["WIDGET"] = 1] = "WIDGET";
})($821505451291b0f7$var$InteractiveType || ($821505451291b0f7$var$InteractiveType = {}));
var $821505451291b0f7$var$useAvatarForBot = $hd4g0.hooks.useAvatarForBot, $821505451291b0f7$var$useGetKeyByActivity = $hd4g0.hooks.useGetKeyByActivity, $821505451291b0f7$var$useLocalizer = $hd4g0.hooks.useLocalizer, $821505451291b0f7$var$useSendStatusByActivityKey = $hd4g0.hooks.useSendStatusByActivityKey;
var $821505451291b0f7$var$ACTIVITY_NUM_ATTACHMENTS_ALT_IDS = {
    few: "ACTIVITY_NUM_ATTACHMENTS_FEW_ALT",
    many: "ACTIVITY_NUM_ATTACHMENTS_MANY_ALT",
    one: "ACTIVITY_NUM_ATTACHMENTS_ONE_ALT",
    other: "ACTIVITY_NUM_ATTACHMENTS_OTHER_ALT",
    two: "ACTIVITY_NUM_ATTACHMENTS_TWO_ALT"
};
/**
 * Computes accessible name of an activity during transcript navigation.
 *
 * This text should be kept simple and short.
 *
 * Due to a bug in Safari, accessible name for active descendant must be a string but not a DOM element.
 */ function $821505451291b0f7$var$useActivityAccessibleName(activity, bodyRef) {
    var _activity$from, _activity$attachments;
    var _useAvatarForBot = $821505451291b0f7$var$useAvatarForBot(), _useAvatarForBot2 = $821505451291b0f7$var$_slicedToArray(_useAvatarForBot, 1), botInitials = _useAvatarForBot2[0].initials;
    var _useState = (0, $eO7Kz.useState)(false), _useState2 = $821505451291b0f7$var$_slicedToArray(_useState, 2), interactiveType = _useState2[0], setInteractiveType = _useState2[1];
    var _useSendStatusByActiv = $821505451291b0f7$var$useSendStatusByActivityKey(), _useSendStatusByActiv2 = $821505451291b0f7$var$_slicedToArray(_useSendStatusByActiv, 1), sendStatusByActivityKey = _useSendStatusByActiv2[0];
    var fromSelf = ((_activity$from = activity.from) === null || _activity$from === void 0 ? void 0 : _activity$from.role) === "user";
    var getKeyByActivity = $821505451291b0f7$var$useGetKeyByActivity();
    var localize = $821505451291b0f7$var$useLocalizer();
    var localizeWithPlural = $821505451291b0f7$var$useLocalizer({
        plural: true
    });
    var numAttachments = activity.type === "message" ? ((_activity$attachments = activity.attachments) === null || _activity$attachments === void 0 ? void 0 : _activity$attachments.length) || 0 : 0;
    var renderMarkdownAsHTML = (0, $821505451291b0f7$var$_useRenderMarkdownAsHTML.default)();
    /** "Click to interact." */ var activityInteractiveFootNoteAlt = localize("ACTIVITY_INTERACTIVE_FOOTNOTE_ALT");
    /** "Message is interactive." */ var activityInteractiveReasonInteractiveContentAlt = localize("ACTIVITY_INTERACTIVE_REASON_INTERACTIVE_CONTENT_ALT");
    /** "One or more links in the message." */ var activityInteractiveReasonLinkAlt = localize("ACTIVITY_INTERACTIVE_REASON_LINK_ALT");
    /** "Send failed." */ var activityInteractiveReasonSendFailedAlt = localize("ACTIVITY_INTERACTIVE_REASON_SEND_FAILED_ALT");
    var activityKey = (0, $eO7Kz.useMemo)(function() {
        return getKeyByActivity(activity);
    }, [
        activity,
        getKeyByActivity
    ]);
    var greetingAlt = (0, $eO7Kz.useMemo)(function() {
        return (fromSelf ? localize("ACTIVITY_YOU_SAID_ALT") : localize("ACTIVITY_BOT_SAID_ALT", botInitials || "")).replace(/[\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]{2,}/g, " ");
    }, [
        botInitials,
        fromSelf,
        localize
    ]);
    var interactiveTypeRef = (0, $821505451291b0f7$var$_useValueRef.default)(interactiveType);
    var messageTextAlt = (0, $eO7Kz.useMemo)(function() {
        return (0, $821505451291b0f7$var$_activityAltText.default)(activity, renderMarkdownAsHTML);
    }, [
        activity,
        renderMarkdownAsHTML
    ]);
    var numAttachmentsAlt = (0, $eO7Kz.useMemo)(function() {
        return numAttachments ? localizeWithPlural($821505451291b0f7$var$ACTIVITY_NUM_ATTACHMENTS_ALT_IDS, numAttachments) : "";
    }, [
        localizeWithPlural,
        numAttachments
    ]);
    var isSendFailed = (0, $eO7Kz.useMemo)(function() {
        return sendStatusByActivityKey.get(activityKey) === $fjDvy.SEND_FAILED;
    }, [
        activityKey,
        sendStatusByActivityKey
    ]);
    var accessibleName = (0, $eO7Kz.useMemo)(function() {
        return [
            greetingAlt,
            messageTextAlt,
            numAttachmentsAlt,
            isSendFailed ? activityInteractiveReasonSendFailedAlt : "",
            interactiveType === $821505451291b0f7$var$InteractiveType.LINK ? activityInteractiveReasonLinkAlt : interactiveType === $821505451291b0f7$var$InteractiveType.WIDGET ? activityInteractiveReasonInteractiveContentAlt : "",
            interactiveType || isSendFailed ? activityInteractiveFootNoteAlt : ""
        ].filter(Boolean).join(" ");
    }, [
        activityInteractiveFootNoteAlt,
        activityInteractiveReasonInteractiveContentAlt,
        activityInteractiveReasonLinkAlt,
        activityInteractiveReasonSendFailedAlt,
        greetingAlt,
        interactiveType,
        isSendFailed,
        messageTextAlt,
        numAttachmentsAlt
    ]);
    (0, $eO7Kz.useEffect)(function() {
        var _bodyRef$current;
        var hasLinks = !!((_bodyRef$current = bodyRef.current) !== null && _bodyRef$current !== void 0 && _bodyRef$current.querySelector("a"));
        var hasWidgets = !!(0, $821505451291b0f7$var$_tabbableElements.default)(bodyRef.current).length;
        interactiveTypeRef.current !== hasWidgets && setInteractiveType(hasLinks ? $821505451291b0f7$var$InteractiveType.LINK : hasWidgets ? $821505451291b0f7$var$InteractiveType.WIDGET : false);
    }, [
        bodyRef,
        interactiveTypeRef,
        setInteractiveType
    ]);
    return [
        accessibleName
    ];
}

});
parcelRequire.register("fjDvy", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SENT = module.exports.SEND_FAILED = module.exports.SENDING = void 0;
// This type is only for this package only and help reducing size of the bundle.
// Externals should use the string literal directly instead.
// TODO: [P3] #4040 When improve treeshaking with named exports, we could export internals from `core` package.
//       import { SENDING, SEND_FAILED, SENT } from 'botframework-webchat-core/internal/SendStatus';
var $b26746cb8035fb6f$var$SENDING = "sending";
module.exports.SENDING = $b26746cb8035fb6f$var$SENDING;
var $b26746cb8035fb6f$var$SEND_FAILED = "send failed";
module.exports.SEND_FAILED = $b26746cb8035fb6f$var$SEND_FAILED;
var $b26746cb8035fb6f$var$SENT = "sent";
module.exports.SENT = $b26746cb8035fb6f$var$SENT;

});

parcelRequire.register("bm4wN", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $844542f4a878ed2b$var$activityAltText;

var $844542f4a878ed2b$var$_textFormatToContentType = $844542f4a878ed2b$var$_interopRequireDefault((parcelRequire("eNc4R")));
function $844542f4a878ed2b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $844542f4a878ed2b$var$_toConsumableArray(arr) {
    return $844542f4a878ed2b$var$_arrayWithoutHoles(arr) || $844542f4a878ed2b$var$_iterableToArray(arr) || $844542f4a878ed2b$var$_unsupportedIterableToArray(arr) || $844542f4a878ed2b$var$_nonIterableSpread();
}
function $844542f4a878ed2b$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $844542f4a878ed2b$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $844542f4a878ed2b$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $844542f4a878ed2b$var$_arrayLikeToArray(o, minLen);
}
function $844542f4a878ed2b$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $844542f4a878ed2b$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $844542f4a878ed2b$var$_arrayLikeToArray(arr);
}
function $844542f4a878ed2b$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $844542f4a878ed2b$var$walk(document, walker) {
    var nodes = [].slice.call(document.childNodes);
    var results = [];
    while(nodes.length){
        var _node = nodes.shift();
        var childNodes = _node.childNodes;
        results.push.apply(results, $844542f4a878ed2b$var$_toConsumableArray(walker(_node) || []));
        nodes.unshift.apply(nodes, $844542f4a878ed2b$var$_toConsumableArray([].slice.call(childNodes)));
    }
    return results;
} // From https://developer.mozilla.org/en-US/docs/Web/HTML/Inline_elements
var $844542f4a878ed2b$var$HTML_INLINE_TAGS = [
    "A",
    "ABBR",
    "ACRONYM",
    "AUDIO",
    "B",
    "BDI",
    "BDO",
    "BIG",
    "BR",
    "BUTTON",
    "CANVAS",
    "CITE",
    "CODE",
    "DATA",
    "DATALIST",
    "DEL",
    "DFN",
    "EM",
    "EMBED",
    "I",
    "IFRAME",
    "IMG",
    "INPUT",
    "INS",
    "KBD",
    "LABEL",
    "MAP",
    "MARK",
    "METER",
    "NOSCRIPT",
    "OBJECT",
    "OUTPUT",
    "PICTURE",
    "PROGRESS",
    "Q",
    "RUBY",
    "S",
    "SAMP",
    "SCRIPT",
    "SELECT",
    "SLOT",
    "SMALL",
    "SPAN",
    "STRONG",
    "SUB",
    "SUP",
    "SVG",
    "TEMPLATE",
    "TEXTAREA",
    "TIME",
    "U",
    "TT",
    "VAR",
    "VIDEO",
    "WBR"
];
/**
 * Computes all text from a given HTML document as flattened array. This is best-effort.
 *
 * @param {Document} document - HTML document to computes texts from.
 */ function $844542f4a878ed2b$var$htmlTextAlternatives(document) {
    // TODO: [P2] #3923 Revisit this logic with W3C standard, we could do a better text alternatives computation.
    //       For example, <abbr title="..."> is not computed.
    //       https://www.w3.org/TR/accname-1.1/#mapping_additional_nd_name
    return $844542f4a878ed2b$var$walk(document, function(node) {
        var nodeType = node.nodeType, tagName = node.tagName, textContent = node.textContent;
        if (nodeType === Node.TEXT_NODE) return [
            textContent
        ];
        else if (tagName === "IMG") return [
            node.getAttribute("alt")
        ];
        else if (!$844542f4a878ed2b$var$HTML_INLINE_TAGS.includes(tagName)) return [
            "\n"
        ];
    });
}
/**
 * Returns the text alternatives for a message activity.
 *
 * @param {object} activity - Activity to compute the text alternatives.
 * @param {function} renderMarkdownAsHTML - Callback function to render Markdown as HTML string.
 */ function $844542f4a878ed2b$var$activityAltText(activity, renderMarkdownAsHTML) {
    var _activity$channelData, _activity$channelData2, _activity$channelData3;
    if (activity.type !== "message") return false;
    var fallbackText = activity === null || activity === void 0 ? void 0 : (_activity$channelData = activity.channelData) === null || _activity$channelData === void 0 ? void 0 : _activity$channelData["webchat:fallback-text"];
    if (typeof fallbackText === "string") // If `fallbackText` is an empty string, we will treat the activity as presentational and skip narrating it (return false).
    return fallbackText || false;
    var text = (activity === null || activity === void 0 ? void 0 : (_activity$channelData2 = activity.channelData) === null || _activity$channelData2 === void 0 ? void 0 : (_activity$channelData3 = _activity$channelData2.messageBack) === null || _activity$channelData3 === void 0 ? void 0 : _activity$channelData3.displayText) || activity.text;
    if (!text) // We will continue to narrate the activity, as empty.
    return "";
    if (renderMarkdownAsHTML && (0, $844542f4a878ed2b$var$_textFormatToContentType.default)(activity.textFormat) === "text/markdown") return $844542f4a878ed2b$var$htmlTextAlternatives(new DOMParser().parseFromString(renderMarkdownAsHTML(text), "text/html")).join("").replace(/\n{2,}/g, "\n").trim();
    return text;
}

});
parcelRequire.register("eNc4R", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $ac4f02a1ceda380c$var$textFormatToContentType;
function $ac4f02a1ceda380c$var$textFormatToContentType(textFormat) {
    switch(textFormat){
        case "plain":
            return "text/plain";
        case "xml":
            return "text/xml";
        default:
            return "text/markdown";
    }
}

});


parcelRequire.register("5BkDS", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $41406b8e6ffbf8e1$var$useRenderMarkdownAsHTML;

var $hd4g0 = parcelRequire("hd4g0");

var $eO7Kz = parcelRequire("eO7Kz");

var $41406b8e6ffbf8e1$var$_useWebChatUIContext2 = $41406b8e6ffbf8e1$var$_interopRequireDefault((parcelRequire("tHuBR")));
function $41406b8e6ffbf8e1$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $41406b8e6ffbf8e1$var$_slicedToArray(arr, i) {
    return $41406b8e6ffbf8e1$var$_arrayWithHoles(arr) || $41406b8e6ffbf8e1$var$_iterableToArrayLimit(arr, i) || $41406b8e6ffbf8e1$var$_unsupportedIterableToArray(arr, i) || $41406b8e6ffbf8e1$var$_nonIterableRest();
}
function $41406b8e6ffbf8e1$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $41406b8e6ffbf8e1$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $41406b8e6ffbf8e1$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $41406b8e6ffbf8e1$var$_arrayLikeToArray(o, minLen);
}
function $41406b8e6ffbf8e1$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $41406b8e6ffbf8e1$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $41406b8e6ffbf8e1$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
var $41406b8e6ffbf8e1$var$useLocalizer = $hd4g0.hooks.useLocalizer, $41406b8e6ffbf8e1$var$useStyleOptions = $hd4g0.hooks.useStyleOptions;
function $41406b8e6ffbf8e1$var$useRenderMarkdownAsHTML() {
    var _useWebChatUIContext = (0, $41406b8e6ffbf8e1$var$_useWebChatUIContext2.default)(), renderMarkdown = _useWebChatUIContext.renderMarkdown;
    var _useStyleOptions = $41406b8e6ffbf8e1$var$useStyleOptions(), _useStyleOptions2 = $41406b8e6ffbf8e1$var$_slicedToArray(_useStyleOptions, 1), styleOptions = _useStyleOptions2[0];
    var localize = $41406b8e6ffbf8e1$var$useLocalizer();
    var externalLinkAlt = localize("MARKDOWN_EXTERNAL_LINK_ALT");
    return (0, $eO7Kz.useMemo)(function() {
        return renderMarkdown && function(markdown) {
            return renderMarkdown(markdown, styleOptions, {
                externalLinkAlt: externalLinkAlt
            });
        };
    }, [
        externalLinkAlt,
        renderMarkdown,
        styleOptions
    ]);
}

});


parcelRequire.register("f1kWf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $aef730f33af19282$var$useFocusByActivityKey;

var $aef730f33af19282$var$_useContext = $aef730f33af19282$var$_interopRequireDefault((parcelRequire("30hVF")));
function $aef730f33af19282$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * Put the focus on an activity based on its activity key.
 *
 * @param {boolean | string | undefined} activityKey - The activity key to focus on, `false` to reset focus to most recent activity, `true` to focus on anything, `undefined` for not changing the focus.
 * @param {boolean} withFocus - `true` if the user agent focus should be sent to the transcript, otherwise, `false`.
 */ function $aef730f33af19282$var$useFocusByActivityKey() {
    return (0, $aef730f33af19282$var$_useContext.default)().focusByActivityKey;
}

});

parcelRequire.register("2Zb4j", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $22c9dd41d18dec80$var$useGetDescendantIdByActivityKey;

var $22c9dd41d18dec80$var$_useContext = $22c9dd41d18dec80$var$_interopRequireDefault((parcelRequire("30hVF")));
function $22c9dd41d18dec80$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $22c9dd41d18dec80$var$useGetDescendantIdByActivityKey() {
    return (0, $22c9dd41d18dec80$var$_useContext.default)().getDescendantIdByActivityKey;
}

});


parcelRequire.register("56gdr", function(module, exports) {
"use strict";
function $3b6a176e0fa2d8c3$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $3b6a176e0fa2d8c3$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $3b6a176e0fa2d8c3$var$_typeof(obj);
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.useTypingIndicatorVisible = $3b6a176e0fa2d8c3$var$useTypingIndicatorVisible;

var $hd4g0 = parcelRequire("hd4g0");

var $3b6a176e0fa2d8c3$var$_react = $3b6a176e0fa2d8c3$var$_interopRequireWildcard((parcelRequire("eO7Kz")));
function $3b6a176e0fa2d8c3$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($3b6a176e0fa2d8c3$var$_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $3b6a176e0fa2d8c3$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || $3b6a176e0fa2d8c3$var$_typeof(obj) !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $3b6a176e0fa2d8c3$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $3b6a176e0fa2d8c3$var$_slicedToArray(arr, i) {
    return $3b6a176e0fa2d8c3$var$_arrayWithHoles(arr) || $3b6a176e0fa2d8c3$var$_iterableToArrayLimit(arr, i) || $3b6a176e0fa2d8c3$var$_unsupportedIterableToArray(arr, i) || $3b6a176e0fa2d8c3$var$_nonIterableRest();
}
function $3b6a176e0fa2d8c3$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $3b6a176e0fa2d8c3$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $3b6a176e0fa2d8c3$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $3b6a176e0fa2d8c3$var$_arrayLikeToArray(o, minLen);
}
function $3b6a176e0fa2d8c3$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $3b6a176e0fa2d8c3$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $3b6a176e0fa2d8c3$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
var $3b6a176e0fa2d8c3$var$useActiveTyping = $hd4g0.hooks.useActiveTyping, $3b6a176e0fa2d8c3$var$useRenderTypingIndicator = $hd4g0.hooks.useRenderTypingIndicator;
function $3b6a176e0fa2d8c3$var$useTypingIndicatorVisible() {
    var _useActiveTyping = $3b6a176e0fa2d8c3$var$useActiveTyping(), _useActiveTyping2 = $3b6a176e0fa2d8c3$var$_slicedToArray(_useActiveTyping, 1), activeTyping = _useActiveTyping2[0];
    return [
        !!Object.values(activeTyping).filter(function(_ref) {
            var role = _ref.role;
            return role !== "user";
        }).length
    ];
}
var $3b6a176e0fa2d8c3$var$BasicTypingIndicator = function BasicTypingIndicator() {
    var _useActiveTyping3 = $3b6a176e0fa2d8c3$var$useActiveTyping(), _useActiveTyping4 = $3b6a176e0fa2d8c3$var$_slicedToArray(_useActiveTyping3, 1), activeTyping = _useActiveTyping4[0];
    var _useTypingIndicatorVi = $3b6a176e0fa2d8c3$var$useTypingIndicatorVisible(), _useTypingIndicatorVi2 = $3b6a176e0fa2d8c3$var$_slicedToArray(_useTypingIndicatorVi, 1), visible = _useTypingIndicatorVi2[0];
    var _useActiveTyping5 = $3b6a176e0fa2d8c3$var$useActiveTyping(Infinity), _useActiveTyping6 = $3b6a176e0fa2d8c3$var$_slicedToArray(_useActiveTyping5, 1), typing = _useActiveTyping6[0];
    var renderTypingIndicator = $3b6a176e0fa2d8c3$var$useRenderTypingIndicator();
    return /*#__PURE__*/ $3b6a176e0fa2d8c3$var$_react.default.createElement($3b6a176e0fa2d8c3$var$_react.Fragment, null, renderTypingIndicator({
        activeTyping: activeTyping,
        typing: typing,
        visible: visible
    }));
};
var $3b6a176e0fa2d8c3$var$_default = $3b6a176e0fa2d8c3$var$BasicTypingIndicator;
module.exports.default = $3b6a176e0fa2d8c3$var$_default;

});

parcelRequire.register("dKsHQ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $a025d6b137d89194$var$inputtableKey;
// For auto-focus in some browsers, we synthetically insert keys into the chatbox.
// By default, we insert keys when:
// 1. evt.key.length === 1 (e.g. "1", "A", "=" keys), or
// 2. evt.key is one of the map keys below (e.g. "Add" will insert "+", "Decimal" will insert ".")
var $a025d6b137d89194$var$INPUTTABLE_KEY = {
    Add: "+",
    // Numpad add key
    Decimal: ".",
    // Numpad decimal key
    Divide: "/",
    // Numpad divide key
    Multiply: "*",
    // Numpad multiply key
    Subtract: "-" // Numpad subtract key
};
var $a025d6b137d89194$var$INPUTTABLE_KEY_KEYS = Object.keys($a025d6b137d89194$var$INPUTTABLE_KEY);
function $a025d6b137d89194$var$inputtableKey(key) {
    // Mitigated through allowlisting.
    // eslint-disable-next-line security/detect-object-injection
    return key.length === 1 ? key : $a025d6b137d89194$var$INPUTTABLE_KEY_KEYS.includes(key) ? $a025d6b137d89194$var$INPUTTABLE_KEY[key] : undefined;
}

});

parcelRequire.register("fFkLN", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $02f176e6734edd54$var$isZeroOrPositive;
/**
 * Returns `true`, if the number is zero or positive, otherwise, `false`, including minus zeroes.
 */ function $02f176e6734edd54$var$isZeroOrPositive(value) {
    // This will handle minus-zero.
    return 1 / value >= 0;
}

});

parcelRequire.register("klg6W", function(module, exports) {
"use strict";
function $ecf24421a45e603d$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $ecf24421a45e603d$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $ecf24421a45e603d$var$_typeof(obj);
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $hd4g0 = parcelRequire("hd4g0");

var $ecf24421a45e603d$var$_classnames = $ecf24421a45e603d$var$_interopRequireDefault((parcelRequire("5A4MD")));

var $ecf24421a45e603d$var$_propTypes = $ecf24421a45e603d$var$_interopRequireDefault((parcelRequire("f7UXb")));

var $ecf24421a45e603d$var$_react = $ecf24421a45e603d$var$_interopRequireWildcard((parcelRequire("eO7Kz")));

var $ecf24421a45e603d$var$_useFocus = $ecf24421a45e603d$var$_interopRequireDefault((parcelRequire("kPV7d")));

var $ecf24421a45e603d$var$_useStyleSet3 = $ecf24421a45e603d$var$_interopRequireDefault((parcelRequire("gC6jZ")));

var $ecf24421a45e603d$var$_useUniqueId = $ecf24421a45e603d$var$_interopRequireDefault((parcelRequire("cdwtx")));
function $ecf24421a45e603d$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($ecf24421a45e603d$var$_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $ecf24421a45e603d$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || $ecf24421a45e603d$var$_typeof(obj) !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $ecf24421a45e603d$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $ecf24421a45e603d$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $ecf24421a45e603d$var$_slicedToArray(arr, i) {
    return $ecf24421a45e603d$var$_arrayWithHoles(arr) || $ecf24421a45e603d$var$_iterableToArrayLimit(arr, i) || $ecf24421a45e603d$var$_unsupportedIterableToArray(arr, i) || $ecf24421a45e603d$var$_nonIterableRest();
}
function $ecf24421a45e603d$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $ecf24421a45e603d$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $ecf24421a45e603d$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $ecf24421a45e603d$var$_arrayLikeToArray(o, minLen);
}
function $ecf24421a45e603d$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $ecf24421a45e603d$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $ecf24421a45e603d$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
var $ecf24421a45e603d$var$useLocalizer = $hd4g0.hooks.useLocalizer;
var $ecf24421a45e603d$var$Notes = function Notes(_ref) {
    var header = _ref.header, text = _ref.text;
    return /*#__PURE__*/ $ecf24421a45e603d$var$_react.default.createElement("section", {
        className: "webchat__keyboard-help__notes"
    }, /*#__PURE__*/ $ecf24421a45e603d$var$_react.default.createElement("h4", {
        className: "webchat__keyboard-help__notes-header"
    }, header), text.split("\n").map(function(line, index) {
        return(/*#__PURE__*/ // We are splitting lines into paragraphs, index as key is legitimate here.
        // eslint-disable-next-line react/no-array-index-key
        $ecf24421a45e603d$var$_react.default.createElement("p", {
            className: "webchat__keyboard-help__notes-text",
            key: index
        }, line));
    }));
};
$ecf24421a45e603d$var$Notes.propTypes = {
    header: $ecf24421a45e603d$var$_propTypes.default.string.isRequired,
    text: $ecf24421a45e603d$var$_propTypes.default.string.isRequired
};
var $ecf24421a45e603d$var$KeyboardHelp = function KeyboardHelp() {
    var _useStyleSet = (0, $ecf24421a45e603d$var$_useStyleSet3.default)(), _useStyleSet2 = $ecf24421a45e603d$var$_slicedToArray(_useStyleSet, 1), keyboardHelpStyleSet = _useStyleSet2[0].keyboardHelp;
    var _useState = (0, $ecf24421a45e603d$var$_react.useState)(false), _useState2 = $ecf24421a45e603d$var$_slicedToArray(_useState, 2), shown = _useState2[0], setShown = _useState2[1];
    var focus = (0, $ecf24421a45e603d$var$_useFocus.default)();
    var headerLabelId = (0, $ecf24421a45e603d$var$_useUniqueId.default)("webchat__keyboard-help__header");
    var localize = $ecf24421a45e603d$var$useLocalizer();
    var chatHistoryAccessItemsInMessageBody = localize("KEYBOARD_HELP_CHAT_HISTORY_ACCESS_ITEMS_IN_MESSAGE_BODY");
    var chatHistoryAccessItemsInMessageHeader = localize("KEYBOARD_HELP_CHAT_HISTORY_ACCESS_ITEMS_IN_MESSAGE_HEADER");
    var chatHistoryHeader = localize("KEYBOARD_HELP_CHAT_HISTORY_HEADER");
    var chatHistoryLeaveMessageBody = localize("KEYBOARD_HELP_CHAT_HISTORY_LEAVE_MESSAGE_BODY");
    var chatHistoryLeaveMessageHeader = localize("KEYBOARD_HELP_CHAT_HISTORY_LEAVE_MESSAGE_HEADER");
    var chatHistoryMoveBetweenItemsBody = localize("KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_ITEMS_BODY");
    var chatHistoryMoveBetweenItemsHeader = localize("KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_ITEMS_HEADER");
    var chatHistoryMoveBetweenMessagesBody = localize("KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_MESSAGES_BODY");
    var chatHistoryMoveBetweenMessagesHeader = localize("KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_MESSAGES_HEADER");
    var chatWindowBodyDoActionBody = localize("KEYBOARD_HELP_CHAT_WINDOW_BODY_DO_ACTION_BODY");
    var chatWindowBodyDoActionHeader = localize("KEYBOARD_HELP_CHAT_WINDOW_BODY_DO_ACTION_HEADER");
    var chatWindowBodyMoveBetweenItemsBody = localize("KEYBOARD_HELP_CHAT_WINDOW_BODY_MOVE_BETWEEN_ITEMS_BODY");
    var chatWindowBodyMoveBetweenItemsHeader = localize("KEYBOARD_HELP_CHAT_WINDOW_BODY_MOVE_BETWEEN_ITEMS_HEADER");
    var chatWindowHeader = localize("KEYBOARD_HELP_CHAT_WINDOW_HEADER");
    var closeButtonAlt = localize("KEYBOARD_HELP_CLOSE_BUTTON_ALT");
    var header = localize("KEYBOARD_HELP_HEADER");
    var handleBlur = (0, $ecf24421a45e603d$var$_react.useCallback)(// When switch app, `document.activeElement` will remains.
    function(event) {
        return document.activeElement !== event.target && setShown(false);
    }, [
        setShown
    ]);
    var handleCloseButtonClick = (0, $ecf24421a45e603d$var$_react.useCallback)(function() {
        return focus("main");
    }, [
        focus
    ]);
    var handleCloseButtonFocus = (0, $ecf24421a45e603d$var$_react.useCallback)(function() {
        return setShown(true);
    }, [
        setShown
    ]);
    var handleCloseButtonKeyDown = (0, $ecf24421a45e603d$var$_react.useCallback)(function(event) {
        var key = event.key;
        if (key === "Enter" || key === "Escape" || key === " ") {
            event.preventDefault();
            event.stopPropagation();
            focus("main");
        }
    }, [
        focus
    ]);
    return /*#__PURE__*/ $ecf24421a45e603d$var$_react.default.createElement("div", {
        "aria-labelledby": headerLabelId,
        className: (0, $ecf24421a45e603d$var$_classnames.default)("webchat__keyboard-help", keyboardHelpStyleSet + "", {
            // Instead of using "hidden" attribute, we are using CSS to hide the dialog.
            // - When using "hidden", the close button will not be tabbable because it is pseudo removed from the DOM
            // - When using CSS, the close button will still be tabbable
            // We prefer CSS because the focus need to land on close button, but we don't want to move the focus using JavaScript.
            "webchat__keyboard-help--shown": shown
        }),
        onBlur: handleBlur,
        role: "dialog"
    }, /*#__PURE__*/ $ecf24421a45e603d$var$_react.default.createElement("div", {
        className: "webchat__keyboard-help__border"
    }, /*#__PURE__*/ $ecf24421a45e603d$var$_react.default.createElement("div", {
        className: "webchat__keyboard-help__box"
    }, /*#__PURE__*/ $ecf24421a45e603d$var$_react.default.createElement("div", {
        className: "webchat__keyboard-help__scrollable"
    }, /*#__PURE__*/ $ecf24421a45e603d$var$_react.default.createElement("button", {
        "aria-label": closeButtonAlt,
        className: "webchat__keyboard-help__close-button",
        onClick: handleCloseButtonClick,
        onFocus: handleCloseButtonFocus,
        onKeyDown: handleCloseButtonKeyDown,
        type: "button"
    }, /*#__PURE__*/ $ecf24421a45e603d$var$_react.default.createElement("div", {
        className: "webchat__keyboard-help__close-button-border"
    }, /*#__PURE__*/ $ecf24421a45e603d$var$_react.default.createElement("svg", {
        className: "webchat__keyboard-help__close-button-image" // "focusable" attribute is only available in IE11 and "tabIndex={-1}" does not work.
        ,
        focusable: false,
        role: "presentation",
        viewBox: "0 0 2048 2048",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ $ecf24421a45e603d$var$_react.default.createElement("path", {
        d: "M2048 136l-888 888 888 888-136 136-888-888-888 888L0 1912l888-888L0 136 136 0l888 888L1912 0l136 136z"
    })))), /*#__PURE__*/ $ecf24421a45e603d$var$_react.default.createElement("h2", {
        className: "webchat__keyboard-help__header",
        id: headerLabelId
    }, header), /*#__PURE__*/ $ecf24421a45e603d$var$_react.default.createElement("article", {
        className: "webchat__keyboard-help__section"
    }, /*#__PURE__*/ $ecf24421a45e603d$var$_react.default.createElement("header", null, /*#__PURE__*/ $ecf24421a45e603d$var$_react.default.createElement("h3", {
        className: "webchat__keyboard-help__sub-header"
    }, chatWindowHeader)), /*#__PURE__*/ $ecf24421a45e603d$var$_react.default.createElement("div", {
        className: "webchat__keyboard-help__two-panes"
    }, /*#__PURE__*/ $ecf24421a45e603d$var$_react.default.createElement("svg", {
        className: "webchat__keyboard-help__image webchat__keyboard-help__image--light",
        fill: "none" // "focusable" attribute is only available in IE11 and "tabIndex={-1}" does not work.
        ,
        focusable: false,
        height: "200",
        role: "presentation",
        viewBox: "0 0 121 200",
        width: "121",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ $ecf24421a45e603d$var$_react.default.createElement("rect", {
        height: "199",
        stroke: "#C8C6C4",
        width: "109",
        x: "0.5",
        y: "0.5"
    }), /*#__PURE__*/ $ecf24421a45e603d$var$_react.default.createElement("rect", {
        height: "156",
        stroke: "#323130",
        width: "102",
        x: "3.5",
        y: "4.5"
    }), /*#__PURE__*/ $ecf24421a45e603d$var$_react.default.createElement("rect", {
        height: "42",
        stroke: "#C8C6C4",
        width: "93",
        x: "7.5",
        y: "8.5"
    }), /*#__PURE__*/ $ecf24421a45e603d$var$_react.default.createElement("rect", {
        height: "99",
        stroke: "#C8C6C4",
        width: "93",
        x: "7.5",
        y: "55.5"
    }), /*#__PURE__*/ $ecf24421a45e603d$var$_react.default.createElement("rect", {
        height: "13",
        stroke: "#323130",
        width: "102",
        x: "3.5",
        y: "182.5"
    }), /*#__PURE__*/ $ecf24421a45e603d$var$_react.default.createElement("rect", {
        height: "13",
        stroke: "#323130",
        width: "32",
        x: "3.5",
        y: "165.5"
    }), /*#__PURE__*/ $ecf24421a45e603d$var$_react.default.createElement("rect", {
        height: "13",
        stroke: "#323130",
        width: "32",
        x: "38.5",
        y: "165.5"
    }), /*#__PURE__*/ $ecf24421a45e603d$var$_react.default.createElement("rect", {
        height: "13",
        stroke: "#323130",
        width: "32",
        x: "73.5",
        y: "165.5"
    }), /*#__PURE__*/ $ecf24421a45e603d$var$_react.default.createElement("path", {
        clipRule: "evenodd",
        d: "M116.328 5.64645C116.524 5.45118 116.84 5.45118 117.036 5.64645L120.218 8.82843C120.413 9.02369 120.413 9.34027 120.218 9.53553C120.022 9.7308 119.706 9.7308 119.51 9.53553L117.182 7.20711V192.793L119.51 190.464C119.706 190.269 120.022 190.269 120.218 190.464C120.413 190.66 120.413 190.976 120.218 191.172L117.036 194.354C116.84 194.549 116.524 194.549 116.328 194.354L113.146 191.172C112.951 190.976 112.951 190.66 113.146 190.464C113.342 190.269 113.658 190.269 113.854 190.464L116.182 192.793V7.20711L113.854 9.53553C113.658 9.7308 113.342 9.7308 113.146 9.53553C112.951 9.34027 112.951 9.02369 113.146 8.82843L116.328 5.64645Z",
        fill: "#323130",
        fillRule: "evenodd"
    })), /*#__PURE__*/ $ecf24421a45e603d$var$_react.default.createElement("svg", {
        className: "webchat__keyboard-help__image webchat__keyboard-help__image--dark",
        fill: "none" // "focusable" attribute is only available in IE11 and "tabIndex={-1}" does not work.
        ,
        focusable: false,
        height: "200",
        role: "presentation",
        viewBox: "0 0 121 200",
        width: "121",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ $ecf24421a45e603d$var$_react.default.createElement("rect", {
        height: "199",
        stroke: "#484644",
        width: "109",
        x: "0.5",
        y: "0.5"
    }), /*#__PURE__*/ $ecf24421a45e603d$var$_react.default.createElement("rect", {
        height: "156",
        stroke: "#F3F2F1",
        width: "102",
        x: "3.5",
        y: "4.5"
    }), /*#__PURE__*/ $ecf24421a45e603d$var$_react.default.createElement("rect", {
        height: "42",
        stroke: "#484644",
        width: "93",
        x: "7.5",
        y: "8.5"
    }), /*#__PURE__*/ $ecf24421a45e603d$var$_react.default.createElement("rect", {
        height: "99",
        stroke: "#484644",
        width: "93",
        x: "7.5",
        y: "55.5"
    }), /*#__PURE__*/ $ecf24421a45e603d$var$_react.default.createElement("rect", {
        height: "13",
        stroke: "#F3F2F1",
        width: "102",
        x: "3.5",
        y: "182.5"
    }), /*#__PURE__*/ $ecf24421a45e603d$var$_react.default.createElement("rect", {
        height: "13",
        stroke: "#F3F2F1",
        width: "32",
        x: "3.5",
        y: "165.5"
    }), /*#__PURE__*/ $ecf24421a45e603d$var$_react.default.createElement("rect", {
        height: "13",
        stroke: "#F3F2F1",
        width: "32",
        x: "38.5",
        y: "165.5"
    }), /*#__PURE__*/ $ecf24421a45e603d$var$_react.default.createElement("rect", {
        height: "13",
        stroke: "#F3F2F1",
        width: "32",
        x: "73.5",
        y: "165.5"
    }), /*#__PURE__*/ $ecf24421a45e603d$var$_react.default.createElement("path", {
        clipRule: "evenodd",
        d: "M116.328 5.64645C116.524 5.45118 116.84 5.45118 117.036 5.64645L120.218 8.82843C120.413 9.02369 120.413 9.34027 120.218 9.53553C120.022 9.7308 119.706 9.7308 119.51 9.53553L117.182 7.20711V192.793L119.51 190.464C119.706 190.269 120.022 190.269 120.218 190.464C120.413 190.66 120.413 190.976 120.218 191.172L117.036 194.354C116.84 194.549 116.524 194.549 116.328 194.354L113.146 191.172C112.951 190.976 112.951 190.66 113.146 190.464C113.342 190.269 113.658 190.269 113.854 190.464L116.182 192.793V7.20711L113.854 9.53553C113.658 9.7308 113.342 9.7308 113.146 9.53553C112.951 9.34027 112.951 9.02369 113.146 8.82843L116.328 5.64645Z",
        fill: "#F3F2F1",
        fillRule: "evenodd"
    })), /*#__PURE__*/ $ecf24421a45e603d$var$_react.default.createElement("svg", {
        className: "webchat__keyboard-help__image webchat__keyboard-help__image--high-contrast",
        fill: "none" // "focusable" attribute is only available in IE11 and "tabIndex={-1}" does not work.
        ,
        focusable: false,
        height: "200",
        role: "presentation",
        viewBox: "0 0 121 200",
        width: "121",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ $ecf24421a45e603d$var$_react.default.createElement("rect", {
        height: "199",
        stroke: "white",
        width: "109",
        x: "0.5",
        y: "0.5"
    }), /*#__PURE__*/ $ecf24421a45e603d$var$_react.default.createElement("rect", {
        height: "156",
        stroke: "white",
        width: "102",
        x: "3.5",
        y: "4.5"
    }), /*#__PURE__*/ $ecf24421a45e603d$var$_react.default.createElement("rect", {
        height: "42",
        stroke: "white",
        width: "93",
        x: "7.5",
        y: "8.5"
    }), /*#__PURE__*/ $ecf24421a45e603d$var$_react.default.createElement("rect", {
        height: "99",
        stroke: "white",
        width: "93",
        x: "7.5",
        y: "55.5"
    }), /*#__PURE__*/ $ecf24421a45e603d$var$_react.default.createElement("rect", {
        height: "13",
        stroke: "white",
        width: "102",
        x: "3.5",
        y: "182.5"
    }), /*#__PURE__*/ $ecf24421a45e603d$var$_react.default.createElement("rect", {
        height: "13",
        stroke: "white",
        width: "32",
        x: "3.5",
        y: "165.5"
    }), /*#__PURE__*/ $ecf24421a45e603d$var$_react.default.createElement("rect", {
        height: "13",
        stroke: "white",
        width: "32",
        x: "38.5",
        y: "165.5"
    }), /*#__PURE__*/ $ecf24421a45e603d$var$_react.default.createElement("rect", {
        height: "13",
        stroke: "white",
        width: "32",
        x: "73.5",
        y: "165.5"
    }), /*#__PURE__*/ $ecf24421a45e603d$var$_react.default.createElement("path", {
        clipRule: "evenodd",
        d: "M116.328 5.64645C116.524 5.45118 116.84 5.45118 117.036 5.64645L120.218 8.82843C120.413 9.02369 120.413 9.34027 120.218 9.53553C120.022 9.7308 119.706 9.7308 119.51 9.53553L117.182 7.20711V192.793L119.51 190.464C119.706 190.269 120.022 190.269 120.218 190.464C120.413 190.66 120.413 190.976 120.218 191.172L117.036 194.354C116.84 194.549 116.524 194.549 116.328 194.354L113.146 191.172C112.951 190.976 112.951 190.66 113.146 190.464C113.342 190.269 113.658 190.269 113.854 190.464L116.182 192.793V7.20711L113.854 9.53553C113.658 9.7308 113.342 9.7308 113.146 9.53553C112.951 9.34027 112.951 9.02369 113.146 8.82843L116.328 5.64645Z",
        fill: "white",
        fillRule: "evenodd"
    })), /*#__PURE__*/ $ecf24421a45e603d$var$_react.default.createElement("div", {
        className: "webchat__keyboard-help__notes-pane"
    }, /*#__PURE__*/ $ecf24421a45e603d$var$_react.default.createElement($ecf24421a45e603d$var$Notes, {
        header: chatWindowBodyMoveBetweenItemsHeader,
        text: chatWindowBodyMoveBetweenItemsBody
    }), /*#__PURE__*/ $ecf24421a45e603d$var$_react.default.createElement($ecf24421a45e603d$var$Notes, {
        header: chatWindowBodyDoActionHeader,
        text: chatWindowBodyDoActionBody
    })))), /*#__PURE__*/ $ecf24421a45e603d$var$_react.default.createElement("article", {
        className: "webchat__keyboard-help__section"
    }, /*#__PURE__*/ $ecf24421a45e603d$var$_react.default.createElement("header", null, /*#__PURE__*/ $ecf24421a45e603d$var$_react.default.createElement("h3", {
        className: "webchat__keyboard-help__header"
    }, chatHistoryHeader)), /*#__PURE__*/ $ecf24421a45e603d$var$_react.default.createElement("div", {
        className: "webchat__keyboard-help__two-panes"
    }, /*#__PURE__*/ $ecf24421a45e603d$var$_react.default.createElement("svg", {
        className: "webchat__keyboard-help__image webchat__keyboard-help__image--light",
        fill: "none" // "focusable" attribute is only available in IE11 and "tabIndex={-1}" does not work.
        ,
        focusable: false,
        height: "200",
        role: "presentation",
        viewBox: "0 0 121 200",
        width: "121",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ $ecf24421a45e603d$var$_react.default.createElement("rect", {
        height: "199",
        stroke: "#C8C6C4",
        width: "109",
        x: "0.5",
        y: "0.5"
    }), /*#__PURE__*/ $ecf24421a45e603d$var$_react.default.createElement("rect", {
        height: "156",
        stroke: "#323130",
        width: "102",
        x: "3.5",
        y: "4.5"
    }), /*#__PURE__*/ $ecf24421a45e603d$var$_react.default.createElement("rect", {
        height: "42",
        stroke: "#323130",
        strokeDasharray: "2 2",
        width: "93",
        x: "7.5",
        y: "8.5"
    }), /*#__PURE__*/ $ecf24421a45e603d$var$_react.default.createElement("rect", {
        height: "99",
        stroke: "#323130",
        strokeDasharray: "2 2",
        width: "93",
        x: "7.5",
        y: "55.5"
    }), /*#__PURE__*/ $ecf24421a45e603d$var$_react.default.createElement("rect", {
        height: "13",
        stroke: "#C8C6C4",
        width: "102",
        x: "3.5",
        y: "182.5"
    }), /*#__PURE__*/ $ecf24421a45e603d$var$_react.default.createElement("rect", {
        height: "13",
        stroke: "#C8C6C4",
        width: "32",
        x: "3.5",
        y: "165.5"
    }), /*#__PURE__*/ $ecf24421a45e603d$var$_react.default.createElement("rect", {
        height: "13",
        stroke: "#C8C6C4",
        width: "32",
        x: "38.5",
        y: "165.5"
    }), /*#__PURE__*/ $ecf24421a45e603d$var$_react.default.createElement("rect", {
        height: "13",
        stroke: "#C8C6C4",
        width: "32",
        x: "73.5",
        y: "165.5"
    }), /*#__PURE__*/ $ecf24421a45e603d$var$_react.default.createElement("path", {
        clipRule: "evenodd",
        d: "M116.328 7.64645C116.524 7.45118 116.84 7.45118 117.036 7.64645L120.218 10.8284C120.413 11.0237 120.413 11.3403 120.218 11.5355C120.022 11.7308 119.706 11.7308 119.51 11.5355L117.182 9.20711V156.793L119.51 154.464C119.706 154.269 120.022 154.269 120.218 154.464C120.413 154.66 120.413 154.976 120.218 155.172L117.036 158.354C116.84 158.549 116.524 158.549 116.328 158.354L113.146 155.172C112.951 154.976 112.951 154.66 113.146 154.464C113.342 154.269 113.658 154.269 113.854 154.464L116.182 156.793V9.20711L113.854 11.5355C113.658 11.7308 113.342 11.7308 113.146 11.5355C112.951 11.3403 112.951 11.0237 113.146 10.8284L116.328 7.64645Z",
        fill: "#323130",
        fillRule: "evenodd"
    })), /*#__PURE__*/ $ecf24421a45e603d$var$_react.default.createElement("svg", {
        className: "webchat__keyboard-help__image webchat__keyboard-help__image--dark",
        fill: "none" // "focusable" attribute is only available in IE11 and "tabIndex={-1}" does not work.
        ,
        focusable: false,
        height: "200",
        role: "presentation",
        viewBox: "0 0 121 200",
        width: "121",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ $ecf24421a45e603d$var$_react.default.createElement("rect", {
        height: "199",
        stroke: "#484644",
        width: "109",
        x: "0.5",
        y: "0.5"
    }), /*#__PURE__*/ $ecf24421a45e603d$var$_react.default.createElement("rect", {
        height: "156",
        stroke: "#F3F2F1",
        width: "102",
        x: "3.5",
        y: "4.5"
    }), /*#__PURE__*/ $ecf24421a45e603d$var$_react.default.createElement("rect", {
        height: "42",
        stroke: "#F3F2F1",
        strokeDasharray: "2 2",
        width: "93",
        x: "7.5",
        y: "8.5"
    }), /*#__PURE__*/ $ecf24421a45e603d$var$_react.default.createElement("rect", {
        height: "99",
        stroke: "#F3F2F1",
        strokeDasharray: "2 2",
        width: "93",
        x: "7.5",
        y: "55.5"
    }), /*#__PURE__*/ $ecf24421a45e603d$var$_react.default.createElement("rect", {
        height: "13",
        stroke: "#484644",
        width: "102",
        x: "3.5",
        y: "182.5"
    }), /*#__PURE__*/ $ecf24421a45e603d$var$_react.default.createElement("rect", {
        height: "13",
        stroke: "#484644",
        width: "32",
        x: "3.5",
        y: "165.5"
    }), /*#__PURE__*/ $ecf24421a45e603d$var$_react.default.createElement("rect", {
        height: "13",
        stroke: "#484644",
        width: "32",
        x: "38.5",
        y: "165.5"
    }), /*#__PURE__*/ $ecf24421a45e603d$var$_react.default.createElement("rect", {
        height: "13",
        stroke: "#484644",
        width: "32",
        x: "73.5",
        y: "165.5"
    }), /*#__PURE__*/ $ecf24421a45e603d$var$_react.default.createElement("path", {
        clipRule: "evenodd",
        d: "M116.328 7.64645C116.524 7.45118 116.84 7.45118 117.036 7.64645L120.218 10.8284C120.413 11.0237 120.413 11.3403 120.218 11.5355C120.022 11.7308 119.706 11.7308 119.51 11.5355L117.182 9.20711V156.793L119.51 154.464C119.706 154.269 120.022 154.269 120.218 154.464C120.413 154.66 120.413 154.976 120.218 155.172L117.036 158.354C116.84 158.549 116.524 158.549 116.328 158.354L113.146 155.172C112.951 154.976 112.951 154.66 113.146 154.464C113.342 154.269 113.658 154.269 113.854 154.464L116.182 156.793V9.20711L113.854 11.5355C113.658 11.7308 113.342 11.7308 113.146 11.5355C112.951 11.3403 112.951 11.0237 113.146 10.8284L116.328 7.64645Z",
        fill: "#F3F2F1",
        fillRule: "evenodd"
    })), /*#__PURE__*/ $ecf24421a45e603d$var$_react.default.createElement("svg", {
        className: "webchat__keyboard-help__image webchat__keyboard-help__image--high-contrast",
        fill: "none" // "focusable" attribute is only available in IE11 and "tabIndex={-1}" does not work.
        ,
        focusable: false,
        height: "200",
        role: "presentation",
        viewBox: "0 0 121 200",
        width: "121",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ $ecf24421a45e603d$var$_react.default.createElement("rect", {
        height: "199",
        stroke: "white",
        width: "109",
        x: "0.5",
        y: "0.5"
    }), /*#__PURE__*/ $ecf24421a45e603d$var$_react.default.createElement("rect", {
        height: "156",
        stroke: "white",
        width: "102",
        x: "3.5",
        y: "4.5"
    }), /*#__PURE__*/ $ecf24421a45e603d$var$_react.default.createElement("rect", {
        height: "42",
        stroke: "white",
        strokeDasharray: "2 2",
        width: "93",
        x: "7.5",
        y: "8.5"
    }), /*#__PURE__*/ $ecf24421a45e603d$var$_react.default.createElement("rect", {
        height: "99",
        stroke: "white",
        strokeDasharray: "2 2",
        width: "93",
        x: "7.5",
        y: "55.5"
    }), /*#__PURE__*/ $ecf24421a45e603d$var$_react.default.createElement("rect", {
        height: "13",
        stroke: "white",
        width: "102",
        x: "3.5",
        y: "182.5"
    }), /*#__PURE__*/ $ecf24421a45e603d$var$_react.default.createElement("rect", {
        height: "13",
        stroke: "white",
        width: "32",
        x: "3.5",
        y: "165.5"
    }), /*#__PURE__*/ $ecf24421a45e603d$var$_react.default.createElement("rect", {
        height: "13",
        stroke: "white",
        width: "32",
        x: "38.5",
        y: "165.5"
    }), /*#__PURE__*/ $ecf24421a45e603d$var$_react.default.createElement("rect", {
        height: "13",
        stroke: "white",
        width: "32",
        x: "73.5",
        y: "165.5"
    }), /*#__PURE__*/ $ecf24421a45e603d$var$_react.default.createElement("path", {
        clipRule: "evenodd",
        d: "M116.328 7.64645C116.524 7.45118 116.84 7.45118 117.036 7.64645L120.218 10.8284C120.413 11.0237 120.413 11.3403 120.218 11.5355C120.022 11.7308 119.706 11.7308 119.51 11.5355L117.182 9.20711V156.793L119.51 154.464C119.706 154.269 120.022 154.269 120.218 154.464C120.413 154.66 120.413 154.976 120.218 155.172L117.036 158.354C116.84 158.549 116.524 158.549 116.328 158.354L113.146 155.172C112.951 154.976 112.951 154.66 113.146 154.464C113.342 154.269 113.658 154.269 113.854 154.464L116.182 156.793V9.20711L113.854 11.5355C113.658 11.7308 113.342 11.7308 113.146 11.5355C112.951 11.3403 112.951 11.0237 113.146 10.8284L116.328 7.64645Z",
        fill: "white",
        fillRule: "evenodd"
    })), /*#__PURE__*/ $ecf24421a45e603d$var$_react.default.createElement("div", {
        className: "webchat__keyboard-help__notes-pane"
    }, /*#__PURE__*/ $ecf24421a45e603d$var$_react.default.createElement($ecf24421a45e603d$var$Notes, {
        header: chatHistoryMoveBetweenMessagesHeader,
        text: chatHistoryMoveBetweenMessagesBody
    }), /*#__PURE__*/ $ecf24421a45e603d$var$_react.default.createElement($ecf24421a45e603d$var$Notes, {
        header: chatHistoryAccessItemsInMessageHeader,
        text: chatHistoryAccessItemsInMessageBody
    }), /*#__PURE__*/ $ecf24421a45e603d$var$_react.default.createElement($ecf24421a45e603d$var$Notes, {
        header: chatHistoryMoveBetweenItemsHeader,
        text: chatHistoryMoveBetweenItemsBody
    }), /*#__PURE__*/ $ecf24421a45e603d$var$_react.default.createElement($ecf24421a45e603d$var$Notes, {
        header: chatHistoryLeaveMessageHeader,
        text: chatHistoryLeaveMessageBody
    }))))))));
};
var $ecf24421a45e603d$var$_default = $ecf24421a45e603d$var$KeyboardHelp;
module.exports.default = $ecf24421a45e603d$var$_default;

});
parcelRequire.register("cdwtx", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $8e4fe3e175ce7cd1$var$useUniqueId;

var $eO7Kz = parcelRequire("eO7Kz");

var $8e4fe3e175ce7cd1$var$_mathRandom = $8e4fe3e175ce7cd1$var$_interopRequireDefault((parcelRequire("atZsr")));
function $8e4fe3e175ce7cd1$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/* eslint no-magic-numbers: ["error", { "ignore": [2, 5, 36] }] */ function $8e4fe3e175ce7cd1$var$useUniqueId(prefix) {
    var id = (0, $eO7Kz.useMemo)(function() {
        return (0, $8e4fe3e175ce7cd1$var$_mathRandom.default)().toString(36).substr(2, 5);
    }, []);
    prefix = prefix ? "".concat(prefix, "--") : "";
    return "".concat(prefix).concat(id);
}

});


parcelRequire.register("e3ZIb", function(module, exports) {
"use strict";
function $a3d137202dbf5bb2$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $a3d137202dbf5bb2$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $a3d137202dbf5bb2$var$_typeof(obj);
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $hd4g0 = parcelRequire("hd4g0");

var $a3d137202dbf5bb2$var$_classnames = $a3d137202dbf5bb2$var$_interopRequireDefault((parcelRequire("5A4MD")));

var $a3d137202dbf5bb2$var$_propTypes = $a3d137202dbf5bb2$var$_interopRequireDefault((parcelRequire("f7UXb")));

var $a3d137202dbf5bb2$var$_react = $a3d137202dbf5bb2$var$_interopRequireWildcard((parcelRequire("eO7Kz")));

var $a3d137202dbf5bb2$var$_isPresentational = $a3d137202dbf5bb2$var$_interopRequireDefault((parcelRequire("e70Ko")));

var $a3d137202dbf5bb2$var$_LiveRegionActivity = $a3d137202dbf5bb2$var$_interopRequireDefault((parcelRequire("5fk8k")));

var $a3d137202dbf5bb2$var$_SendFailed = $a3d137202dbf5bb2$var$_interopRequireDefault((parcelRequire("aEdHk")));

var $a3d137202dbf5bb2$var$_LiveRegionTwinComposer = $a3d137202dbf5bb2$var$_interopRequireDefault((parcelRequire("j16I8")));

var $a3d137202dbf5bb2$var$_tabbableElements = $a3d137202dbf5bb2$var$_interopRequireDefault((parcelRequire("1ySa1")));

var $a3d137202dbf5bb2$var$_useLocalizeAccessKey = $a3d137202dbf5bb2$var$_interopRequireDefault((parcelRequire("5FNn4")));

var $a3d137202dbf5bb2$var$_useQueueStaticElement = $a3d137202dbf5bb2$var$_interopRequireDefault((parcelRequire("dJQDL")));

var $a3d137202dbf5bb2$var$_useStyleToEmotionObject = $a3d137202dbf5bb2$var$_interopRequireDefault((parcelRequire("6l4uV")));

var $a3d137202dbf5bb2$var$_useSuggestedActionsAccessKey = $a3d137202dbf5bb2$var$_interopRequireDefault((parcelRequire("aZ6Uh")));

var $a3d137202dbf5bb2$var$_useTypistNames3 = $a3d137202dbf5bb2$var$_interopRequireDefault((parcelRequire("i4wAO")));
function $a3d137202dbf5bb2$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($a3d137202dbf5bb2$var$_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $a3d137202dbf5bb2$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || $a3d137202dbf5bb2$var$_typeof(obj) !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $a3d137202dbf5bb2$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $a3d137202dbf5bb2$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $a3d137202dbf5bb2$var$_createForOfIteratorHelper(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (!it) {
        if (Array.isArray(o) || (it = $a3d137202dbf5bb2$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
            if (it) o = it;
            var i = 0;
            var F = function F() {};
            return {
                s: F,
                n: function n() {
                    if (i >= o.length) return {
                        done: true
                    };
                    return {
                        done: false,
                        value: o[i++]
                    };
                },
                e: function e(_e2) {
                    throw _e2;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var normalCompletion = true, didErr = false, err;
    return {
        s: function s() {
            it = it.call(o);
        },
        n: function n() {
            var step = it.next();
            normalCompletion = step.done;
            return step;
        },
        e: function e(_e3) {
            didErr = true;
            err = _e3;
        },
        f: function f() {
            try {
                if (!normalCompletion && it.return != null) it.return();
            } finally{
                if (didErr) throw err;
            }
        }
    };
}
function $a3d137202dbf5bb2$var$_slicedToArray(arr, i) {
    return $a3d137202dbf5bb2$var$_arrayWithHoles(arr) || $a3d137202dbf5bb2$var$_iterableToArrayLimit(arr, i) || $a3d137202dbf5bb2$var$_unsupportedIterableToArray(arr, i) || $a3d137202dbf5bb2$var$_nonIterableRest();
}
function $a3d137202dbf5bb2$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $a3d137202dbf5bb2$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $a3d137202dbf5bb2$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $a3d137202dbf5bb2$var$_arrayLikeToArray(o, minLen);
}
function $a3d137202dbf5bb2$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $a3d137202dbf5bb2$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $a3d137202dbf5bb2$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
var $a3d137202dbf5bb2$var$useActivities = $hd4g0.hooks.useActivities, $a3d137202dbf5bb2$var$useGetKeyByActivity = $hd4g0.hooks.useGetKeyByActivity, $a3d137202dbf5bb2$var$useLocalizer = $hd4g0.hooks.useLocalizer, $a3d137202dbf5bb2$var$useStyleOptions = $hd4g0.hooks.useStyleOptions;
var $a3d137202dbf5bb2$var$ROOT_STYLE = {
    "&.webchat__live-region-transcript": {
        "& .webchat__live-region-transcript__note, & .webchat__live-region-transcript__note, & .webchat__live-region-transcript__text-element": {
            color: "transparent",
            height: 1,
            overflow: "hidden",
            position: "absolute",
            top: 0,
            whiteSpace: "nowrap",
            width: 1
        }
    }
};
var $a3d137202dbf5bb2$var$LiveRegionTranscriptCore = function LiveRegionTranscriptCore(_ref) {
    var activityElementMapRef = _ref.activityElementMapRef;
    // We are looking for all activities instead of just those will be rendered.
    // This is because some activities that chosen not be rendered in the chat history,
    // we might still need to be read by screen reader. Such as, suggested actions without text content.
    var _useSuggestedActionsA = (0, $a3d137202dbf5bb2$var$_useSuggestedActionsAccessKey.default)(), _useSuggestedActionsA2 = $a3d137202dbf5bb2$var$_slicedToArray(_useSuggestedActionsA, 1), accessKey = _useSuggestedActionsA2[0];
    var _useActivities = $a3d137202dbf5bb2$var$useActivities(), _useActivities2 = $a3d137202dbf5bb2$var$_slicedToArray(_useActivities, 1), activities = _useActivities2[0];
    var _useTypistNames = (0, $a3d137202dbf5bb2$var$_useTypistNames3.default)(), _useTypistNames2 = $a3d137202dbf5bb2$var$_slicedToArray(_useTypistNames, 1), typistNames = _useTypistNames2[0];
    var getKeyByActivity = $a3d137202dbf5bb2$var$useGetKeyByActivity();
    var localize = $a3d137202dbf5bb2$var$useLocalizer();
    var localizeAccessKeyAsAccessibleName = (0, $a3d137202dbf5bb2$var$_useLocalizeAccessKey.default)("accessible name");
    var queueStaticElement = (0, $a3d137202dbf5bb2$var$_useQueueStaticElement.default)();
    var liveRegionInteractiveLabelAlt = localize("TRANSCRIPT_LIVE_REGION_INTERACTIVE_LABEL_ALT");
    var liveRegionInteractiveWithLinkLabelAlt = localize("TRANSCRIPT_LIVE_REGION_INTERACTIVE_WITH_LINKS_LABEL_ALT");
    var typingIndicator = !!typistNames.length && localize(typistNames.length > 1 ? "TYPING_INDICATOR_MULTIPLE_TEXT" : "TYPING_INDICATOR_SINGLE_TEXT", typistNames[0]);
    var liveRegionSuggestedActionsLabelAlt = accessKey ? localize("TRANSCRIPT_LIVE_REGION_SUGGESTED_ACTIONS_WITH_ACCESS_KEY_LABEL_ALT", localizeAccessKeyAsAccessibleName(accessKey)) : localize("TRANSCRIPT_LIVE_REGION_SUGGESTED_ACTIONS_LABEL_ALT");
    var keyedActivities = (0, $a3d137202dbf5bb2$var$_react.useMemo)(function() {
        return Object.freeze(activities.reduce(function(intermediate, activity) {
            // Only "message" activity will be read by screen reader.
            if (activity.type === "message") return intermediate.set(getKeyByActivity(activity), activity);
            return intermediate;
        }, new Map()));
    }, [
        activities,
        getKeyByActivity
    ]);
    var prevRenderingActivitiesRef = (0, $a3d137202dbf5bb2$var$_react.useRef)();
    (0, $a3d137202dbf5bb2$var$_react.useEffect)(function() {
        var prevRenderingActivities = prevRenderingActivitiesRef.current;
        var appendedActivities = []; // Bottom-up, find activities which are recently appended (i.e. new activity will have a new key).
        // We only consider new activities added to the bottom of the chat history.
        // Based on how `aria-relevant="additions"` works, activities that are updated, deleted, or reordered, should be ignored.
        var _iterator = $a3d137202dbf5bb2$var$_createForOfIteratorHelper(Array.from(keyedActivities.entries()).reverse()), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var _step$value = $a3d137202dbf5bb2$var$_slicedToArray(_step.value, 2), key = _step$value[0], activity = _step$value[1];
                if (prevRenderingActivities !== null && prevRenderingActivities !== void 0 && prevRenderingActivities.has(key)) break;
                appendedActivities.unshift({
                    activity: activity,
                    key: key
                });
                (0, $a3d137202dbf5bb2$var$_isPresentational.default)(activity) || queueStaticElement(/*#__PURE__*/ $a3d137202dbf5bb2$var$_react.default.createElement($a3d137202dbf5bb2$var$_LiveRegionActivity.default, {
                    activity: activity
                }));
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        var hasNewLink = appendedActivities.some(function(_ref2) {
            var _activityElementMapRe;
            var key = _ref2.key;
            return (_activityElementMapRe = activityElementMapRef.current.get(key)) === null || _activityElementMapRe === void 0 ? void 0 : _activityElementMapRe.querySelector("a");
        });
        var hasNewWidget = appendedActivities.some(function(_ref3) {
            var _activityElementMapRe2;
            var key = _ref3.key;
            return !!(0, $a3d137202dbf5bb2$var$_tabbableElements.default)((_activityElementMapRe2 = activityElementMapRef.current.get(key)) === null || _activityElementMapRe2 === void 0 ? void 0 : _activityElementMapRe2.querySelector(".webchat__basic-transcript__activity-body")).length;
        });
        var hasSuggestedActions = appendedActivities.some(function(_ref4) {
            var _activity$suggestedAc, _activity$suggestedAc2;
            var activity = _ref4.activity;
            return activity.type === "message" && ((_activity$suggestedAc = activity.suggestedActions) === null || _activity$suggestedAc === void 0 ? void 0 : (_activity$suggestedAc2 = _activity$suggestedAc.actions) === null || _activity$suggestedAc2 === void 0 ? void 0 : _activity$suggestedAc2.length);
        }); // This is a footnote reading either:
        // - "Message is interactive. Press shift tab key 2 to 3 times to switch to the chat history. Then click on the message to interact.", or;
        // - "One or more links in the message. Press shift tab key 2 to 3 times to switch to the chat history. Then click on the message to interact."
        if (hasNewLink || hasNewWidget) queueStaticElement(/*#__PURE__*/ $a3d137202dbf5bb2$var$_react.default.createElement("div", {
            className: "webchat__live-region-transcript__note",
            role: "note"
        }, hasNewLink ? liveRegionInteractiveWithLinkLabelAlt : liveRegionInteractiveLabelAlt));
         // This is a footnote reading "Suggested actions container: has content. Press CTRL + SHIFT + A to select."
        if (hasSuggestedActions) queueStaticElement(/*#__PURE__*/ $a3d137202dbf5bb2$var$_react.default.createElement("div", {
            className: "webchat__live-region-transcript__note",
            role: "note"
        }, liveRegionSuggestedActionsLabelAlt));
        prevRenderingActivitiesRef.current = keyedActivities;
    }, [
        activityElementMapRef,
        liveRegionInteractiveLabelAlt,
        liveRegionInteractiveWithLinkLabelAlt,
        liveRegionSuggestedActionsLabelAlt,
        prevRenderingActivitiesRef,
        queueStaticElement,
        keyedActivities
    ]);
    (0, $a3d137202dbf5bb2$var$_react.useEffect)(function() {
        typingIndicator && queueStaticElement(typingIndicator);
    }, [
        queueStaticElement,
        typingIndicator
    ]);
    return /*#__PURE__*/ $a3d137202dbf5bb2$var$_react.default.createElement($a3d137202dbf5bb2$var$_SendFailed.default, null);
};
var $a3d137202dbf5bb2$var$LiveRegionTranscript = function LiveRegionTranscript(_ref5) {
    var activityElementMapRef = _ref5.activityElementMapRef;
    var _useStyleOptions = $a3d137202dbf5bb2$var$useStyleOptions(), _useStyleOptions2 = $a3d137202dbf5bb2$var$_slicedToArray(_useStyleOptions, 1), internalLiveRegionFadeAfter = _useStyleOptions2[0].internalLiveRegionFadeAfter;
    var localize = $a3d137202dbf5bb2$var$useLocalizer();
    var rootClassName = (0, $a3d137202dbf5bb2$var$_useStyleToEmotionObject.default)()($a3d137202dbf5bb2$var$ROOT_STYLE) + "";
    var transcriptRoleDescription = localize("TRANSCRIPT_ARIA_ROLE_ALT");
    return /*#__PURE__*/ $a3d137202dbf5bb2$var$_react.default.createElement($a3d137202dbf5bb2$var$_LiveRegionTwinComposer.default, {
        "aria-roledescription": transcriptRoleDescription,
        className: (0, $a3d137202dbf5bb2$var$_classnames.default)("webchat__live-region-transcript", rootClassName),
        fadeAfter: internalLiveRegionFadeAfter,
        role: "log",
        textElementClassName: "webchat__live-region-transcript__text-element"
    }, /*#__PURE__*/ $a3d137202dbf5bb2$var$_react.default.createElement($a3d137202dbf5bb2$var$LiveRegionTranscriptCore, {
        activityElementMapRef: activityElementMapRef
    }));
};
$a3d137202dbf5bb2$var$LiveRegionTranscript.propTypes = {
    // PropTypes cannot be fully expressed in TypeScript.
    // @ts-ignore
    activityElementMapRef: $a3d137202dbf5bb2$var$_propTypes.default.shape({
        current: $a3d137202dbf5bb2$var$_propTypes.default.instanceOf(Map)
    }).isRequired
};
var $a3d137202dbf5bb2$var$_default = $a3d137202dbf5bb2$var$LiveRegionTranscript;
module.exports.default = $a3d137202dbf5bb2$var$_default;

});
parcelRequire.register("e70Ko", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $a4624c80b15b6ab9$var$isPresentational;
/**
 * Determines if the rendering activity is presentational or not.
 * Returns `true` if the activity is presentational and should not be read by screen reader, otherwise, `false`.
 *
 * @returns {boolean} `true` if the activity is presentational and should not be read by screen reader, otherwise, `false`.
 */ function $a4624c80b15b6ab9$var$isPresentational(activity) {
    var _channelData$messageB, _activity$attachments, _activity$suggestedAc, _activity$suggestedAc2;
    if (activity.type !== "message") return true;
    var channelData = activity.channelData; // "Fallback text" includes both message text and narratives for attachments.
    // Emptying out "fallback text" essentially mute for both message and attachments.
    var fallbackText = channelData === null || channelData === void 0 ? void 0 : channelData["webchat:fallback-text"];
    if (typeof fallbackText === "string") return !fallbackText;
     // If there are "displayText" (MessageBack), "text", any attachments, or suggested actions, there are something to narrate.
    return !(channelData !== null && channelData !== void 0 && (_channelData$messageB = channelData.messageBack) !== null && _channelData$messageB !== void 0 && _channelData$messageB.displayText || activity.text || (_activity$attachments = activity.attachments) !== null && _activity$attachments !== void 0 && _activity$attachments.length || (_activity$suggestedAc = activity.suggestedActions) !== null && _activity$suggestedAc !== void 0 && (_activity$suggestedAc2 = _activity$suggestedAc.actions) !== null && _activity$suggestedAc2 !== void 0 && _activity$suggestedAc2.length);
}

});

parcelRequire.register("5fk8k", function(module, exports) {
"use strict";
function $3d1df88c81056561$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $3d1df88c81056561$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $3d1df88c81056561$var$_typeof(obj);
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $hd4g0 = parcelRequire("hd4g0");

var $3d1df88c81056561$var$_classnames = $3d1df88c81056561$var$_interopRequireDefault((parcelRequire("5A4MD")));

var $3d1df88c81056561$var$_propTypes = $3d1df88c81056561$var$_interopRequireDefault((parcelRequire("f7UXb")));

var $3d1df88c81056561$var$_react = $3d1df88c81056561$var$_interopRequireWildcard((parcelRequire("eO7Kz")));

var $3d1df88c81056561$var$_activityAltText = $3d1df88c81056561$var$_interopRequireDefault((parcelRequire("bm4wN")));

var $3d1df88c81056561$var$_LiveRegionAttachments = $3d1df88c81056561$var$_interopRequireDefault((parcelRequire("6qPbj")));

var $3d1df88c81056561$var$_LiveRegionSuggestedActions = $3d1df88c81056561$var$_interopRequireDefault((parcelRequire("Srqwf")));

var $3d1df88c81056561$var$_useRenderMarkdownAsHTML = $3d1df88c81056561$var$_interopRequireDefault((parcelRequire("5BkDS")));

var $3d1df88c81056561$var$_useStyleToEmotionObject = $3d1df88c81056561$var$_interopRequireDefault((parcelRequire("6l4uV")));
function $3d1df88c81056561$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($3d1df88c81056561$var$_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $3d1df88c81056561$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || $3d1df88c81056561$var$_typeof(obj) !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $3d1df88c81056561$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $3d1df88c81056561$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $3d1df88c81056561$var$_slicedToArray(arr, i) {
    return $3d1df88c81056561$var$_arrayWithHoles(arr) || $3d1df88c81056561$var$_iterableToArrayLimit(arr, i) || $3d1df88c81056561$var$_unsupportedIterableToArray(arr, i) || $3d1df88c81056561$var$_nonIterableRest();
}
function $3d1df88c81056561$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $3d1df88c81056561$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $3d1df88c81056561$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $3d1df88c81056561$var$_arrayLikeToArray(o, minLen);
}
function $3d1df88c81056561$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $3d1df88c81056561$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $3d1df88c81056561$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
var $3d1df88c81056561$var$useAvatarForBot = $hd4g0.hooks.useAvatarForBot, $3d1df88c81056561$var$useLocalizer = $hd4g0.hooks.useLocalizer;
var $3d1df88c81056561$var$ROOT_STYLE = {
    "&.webchat__live-region-activity": {
        color: "transparent",
        height: 1,
        opacity: 0,
        overflow: "hidden",
        position: "absolute",
        top: 0,
        whiteSpace: "nowrap",
        width: 1
    }
};
var $3d1df88c81056561$var$LiveRegionActivity = function LiveRegionActivity(_ref) {
    var activity = _ref.activity;
    var _useAvatarForBot = $3d1df88c81056561$var$useAvatarForBot(), _useAvatarForBot2 = $3d1df88c81056561$var$_slicedToArray(_useAvatarForBot, 1), botInitials = _useAvatarForBot2[0].initials;
    var role = activity.from.role, type = activity.type;
    var fallbackText = type === "message" ? activity.channelData["webchat:fallback-text"] : undefined;
    var localize = $3d1df88c81056561$var$useLocalizer();
    var renderMarkdownAsHTML = (0, $3d1df88c81056561$var$_useRenderMarkdownAsHTML.default)();
    var rootClassName = (0, $3d1df88c81056561$var$_useStyleToEmotionObject.default)()($3d1df88c81056561$var$ROOT_STYLE) + "";
    var textAlt = (0, $3d1df88c81056561$var$_react.useMemo)(function() {
        return (0, $3d1df88c81056561$var$_activityAltText.default)(activity, renderMarkdownAsHTML);
    }, [
        activity,
        renderMarkdownAsHTML
    ]);
    var greetingAlt = (role === "user" ? localize("ACTIVITY_YOU_SAID_ALT") : localize("ACTIVITY_BOT_SAID_ALT", botInitials || "")).replace(/[\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]{2,}/g, " ");
    var validFallbackText = fallbackText && typeof fallbackText === "string";
    return /*#__PURE__*/ $3d1df88c81056561$var$_react.default.createElement("article", {
        "aria-atomic": true,
        className: (0, $3d1df88c81056561$var$_classnames.default)("webchat__live-region-activity", rootClassName)
    }, /*#__PURE__*/ $3d1df88c81056561$var$_react.default.createElement("div", null, greetingAlt), validFallbackText ? /*#__PURE__*/ $3d1df88c81056561$var$_react.default.createElement("div", null, fallbackText) : /*#__PURE__*/ $3d1df88c81056561$var$_react.default.createElement($3d1df88c81056561$var$_react.Fragment, null, /*#__PURE__*/ $3d1df88c81056561$var$_react.default.createElement("div", null, textAlt), type === "message" && /*#__PURE__*/ $3d1df88c81056561$var$_react.default.createElement($3d1df88c81056561$var$_react.Fragment, null, !!activity.suggestedActions && /*#__PURE__*/ $3d1df88c81056561$var$_react.default.createElement($3d1df88c81056561$var$_LiveRegionSuggestedActions.default, {
        suggestedActions: activity.suggestedActions
    }), /*#__PURE__*/ $3d1df88c81056561$var$_react.default.createElement($3d1df88c81056561$var$_LiveRegionAttachments.default, {
        activity: activity
    }))));
};
$3d1df88c81056561$var$LiveRegionActivity.propTypes = {
    activity: $3d1df88c81056561$var$_propTypes.default.any.isRequired
};
var $3d1df88c81056561$var$_default = $3d1df88c81056561$var$LiveRegionActivity;
module.exports.default = $3d1df88c81056561$var$_default;

});
parcelRequire.register("6qPbj", function(module, exports) {
"use strict";
function $01355e70f0cd8136$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $01355e70f0cd8136$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $01355e70f0cd8136$var$_typeof(obj);
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $hd4g0 = parcelRequire("hd4g0");

var $01355e70f0cd8136$var$_propTypes = $01355e70f0cd8136$var$_interopRequireDefault((parcelRequire("f7UXb")));

var $01355e70f0cd8136$var$_react = $01355e70f0cd8136$var$_interopRequireWildcard((parcelRequire("eO7Kz")));
function $01355e70f0cd8136$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($01355e70f0cd8136$var$_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $01355e70f0cd8136$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || $01355e70f0cd8136$var$_typeof(obj) !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $01355e70f0cd8136$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $01355e70f0cd8136$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $01355e70f0cd8136$var$useCreateAttachmentForScreenReaderRenderer = $hd4g0.hooks.useCreateAttachmentForScreenReaderRenderer, $01355e70f0cd8136$var$useLocalizer = $hd4g0.hooks.useLocalizer;
var $01355e70f0cd8136$var$ACTIVITY_NUM_ATTACHMENTS_ALT_IDS = {
    few: "ACTIVITY_NUM_ATTACHMENTS_FEW_ALT",
    many: "ACTIVITY_NUM_ATTACHMENTS_MANY_ALT",
    one: "ACTIVITY_NUM_ATTACHMENTS_ONE_ALT",
    other: "ACTIVITY_NUM_ATTACHMENTS_OTHER_ALT",
    two: "ACTIVITY_NUM_ATTACHMENTS_TWO_ALT"
};
// When "renderAttachments" is false, we will not render the content of attachments.
// That means, it will only render "2 attachments", instead of "image attachment".
// This is used in the visual transcript, where we render "Press ENTER to interact."
var $01355e70f0cd8136$var$LiveRegionAttachments = function LiveRegionAttachments(_ref) {
    var activity = _ref.activity;
    var _activity$attachments = activity.attachments, attachments = _activity$attachments === void 0 ? [] : _activity$attachments;
    var createAttachmentForScreenReaderRenderer = $01355e70f0cd8136$var$useCreateAttachmentForScreenReaderRenderer();
    var localizeWithPlural = $01355e70f0cd8136$var$useLocalizer({
        plural: true
    });
    var attachmentForScreenReaderRenderers = attachments.map(function(attachment) {
        return createAttachmentForScreenReaderRenderer({
            activity: activity,
            attachment: attachment
        });
    }).filter(Boolean);
    var numGenericAttachments = attachments.length - attachmentForScreenReaderRenderers.length;
    var numAttachmentsAlt = !!numGenericAttachments && localizeWithPlural($01355e70f0cd8136$var$ACTIVITY_NUM_ATTACHMENTS_ALT_IDS, numGenericAttachments);
    return /*#__PURE__*/ $01355e70f0cd8136$var$_react.default.createElement($01355e70f0cd8136$var$_react.Fragment, null, attachmentForScreenReaderRenderers.map(function(render, index) {
        return(/*#__PURE__*/ // Direct Line does not have key for attachment other than index.
        // eslint-disable-next-line react/no-array-index-key
        $01355e70f0cd8136$var$_react.default.createElement("div", {
            key: index
        }, render()));
    }), numAttachmentsAlt && /*#__PURE__*/ $01355e70f0cd8136$var$_react.default.createElement("p", null, numAttachmentsAlt));
};
$01355e70f0cd8136$var$LiveRegionAttachments.propTypes = {
    // PropTypes is not fully compatible with TypeScript definition.
    // @ts-ignore
    activity: $01355e70f0cd8136$var$_propTypes.default.shape({
        attachments: $01355e70f0cd8136$var$_propTypes.default.array,
        type: $01355e70f0cd8136$var$_propTypes.default.oneOf([
            "message"
        ])
    }).isRequired
};
var $01355e70f0cd8136$var$_default = $01355e70f0cd8136$var$LiveRegionAttachments;
module.exports.default = $01355e70f0cd8136$var$_default;

});

parcelRequire.register("Srqwf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0a3a51a31cb69ef0$var$_propTypes = $0a3a51a31cb69ef0$var$_interopRequireDefault((parcelRequire("f7UXb")));

var $0a3a51a31cb69ef0$var$_react = $0a3a51a31cb69ef0$var$_interopRequireDefault((parcelRequire("eO7Kz")));

var $0a3a51a31cb69ef0$var$_computeSuggestedActionText = $0a3a51a31cb69ef0$var$_interopRequireDefault((parcelRequire("kbcsp")));
function $0a3a51a31cb69ef0$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $0a3a51a31cb69ef0$var$LiveRegionSuggestedActions = function LiveRegionSuggestedActions(_ref) {
    var _suggestedActions$act;
    var suggestedActions = _ref.suggestedActions;
    return ((_suggestedActions$act = suggestedActions.actions) === null || _suggestedActions$act === void 0 ? void 0 : _suggestedActions$act.length) && /*#__PURE__*/ $0a3a51a31cb69ef0$var$_react.default.createElement("p", {
        className: "webchat__live-region-activity__suggested-actions"
    }, suggestedActions.actions.map(function(action, index) {
        return(/*#__PURE__*/ // Direct Line schema does not have key other than index.
        // eslint-disable-next-line react/no-array-index-key
        $0a3a51a31cb69ef0$var$_react.default.createElement("button", {
            className: "webchat__live-region-activity__suggested-action",
            key: index,
            tabIndex: -1,
            type: "button"
        }, (0, $0a3a51a31cb69ef0$var$_computeSuggestedActionText.default)(action)));
    }));
};
$0a3a51a31cb69ef0$var$LiveRegionSuggestedActions.propTypes = {
    suggestedActions: $0a3a51a31cb69ef0$var$_propTypes.default.shape({
        actions: $0a3a51a31cb69ef0$var$_propTypes.default.array
    }).isRequired
};
var $0a3a51a31cb69ef0$var$_default = $0a3a51a31cb69ef0$var$LiveRegionSuggestedActions;
module.exports.default = $0a3a51a31cb69ef0$var$_default;

});


parcelRequire.register("aEdHk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $hd4g0 = parcelRequire("hd4g0");

var $eO7Kz = parcelRequire("eO7Kz");

var $fjDvy = parcelRequire("fjDvy");

var $7c0843efefde5d8e$var$_isPresentational = $7c0843efefde5d8e$var$_interopRequireDefault((parcelRequire("e70Ko")));

var $7c0843efefde5d8e$var$_usePrevious = $7c0843efefde5d8e$var$_interopRequireDefault((parcelRequire("8vHzd")));

var $7c0843efefde5d8e$var$_useQueueStaticElement = $7c0843efefde5d8e$var$_interopRequireDefault((parcelRequire("dJQDL")));
function $7c0843efefde5d8e$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $7c0843efefde5d8e$var$_createForOfIteratorHelper(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (!it) {
        if (Array.isArray(o) || (it = $7c0843efefde5d8e$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
            if (it) o = it;
            var i = 0;
            var F = function F() {};
            return {
                s: F,
                n: function n() {
                    if (i >= o.length) return {
                        done: true
                    };
                    return {
                        done: false,
                        value: o[i++]
                    };
                },
                e: function e(_e2) {
                    throw _e2;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var normalCompletion = true, didErr = false, err;
    return {
        s: function s() {
            it = it.call(o);
        },
        n: function n() {
            var step = it.next();
            normalCompletion = step.done;
            return step;
        },
        e: function e(_e3) {
            didErr = true;
            err = _e3;
        },
        f: function f() {
            try {
                if (!normalCompletion && it.return != null) it.return();
            } finally{
                if (didErr) throw err;
            }
        }
    };
}
function $7c0843efefde5d8e$var$_slicedToArray(arr, i) {
    return $7c0843efefde5d8e$var$_arrayWithHoles(arr) || $7c0843efefde5d8e$var$_iterableToArrayLimit(arr, i) || $7c0843efefde5d8e$var$_unsupportedIterableToArray(arr, i) || $7c0843efefde5d8e$var$_nonIterableRest();
}
function $7c0843efefde5d8e$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $7c0843efefde5d8e$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $7c0843efefde5d8e$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $7c0843efefde5d8e$var$_arrayLikeToArray(o, minLen);
}
function $7c0843efefde5d8e$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $7c0843efefde5d8e$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $7c0843efefde5d8e$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
var $7c0843efefde5d8e$var$useGetActivityByKey = $hd4g0.hooks.useGetActivityByKey, $7c0843efefde5d8e$var$useLocalizer = $hd4g0.hooks.useLocalizer, $7c0843efefde5d8e$var$useSendStatusByActivityKey = $hd4g0.hooks.useSendStatusByActivityKey;
/**
 * React component to on-demand narrate "Failed to send message" at the end of the live region.
 *
 * We cannot narrate "failed to send message" next to the activity. At the time when the activity is being sent,
 * the activity is also queued to the screen reader. And at that moment, we not yet know if the activity can be sent or not.
 *
 * We only know when the activity was failed to send at a later time.
 *
 * Thus, we need to use a live region "footnote" to indicate the message was failed to send.
 */ var $7c0843efefde5d8e$var$LiveRegionSendFailed = function LiveRegionSendFailed() {
    var _useSendStatusByActiv = $7c0843efefde5d8e$var$useSendStatusByActivityKey(), _useSendStatusByActiv2 = $7c0843efefde5d8e$var$_slicedToArray(_useSendStatusByActiv, 1), sendStatusByActivityKey = _useSendStatusByActiv2[0];
    var getActivityByKey = $7c0843efefde5d8e$var$useGetActivityByKey();
    var localize = $7c0843efefde5d8e$var$useLocalizer();
    var queueStaticElement = (0, $7c0843efefde5d8e$var$_useQueueStaticElement.default)();
    /**
   * List of keys of outgoing and non-presentational activities that are failed to send.
   *
   * Activities which are presentational, such as `event` or `typing`, are ignored to reduce confusions.
   * "Failed to send message" should not be narrated for presentational activities.
   */ var activityKeysOfSendFailed = (0, $eO7Kz.useMemo)(function() {
        return Array.from(sendStatusByActivityKey).reduce(function(activityKeysOfSendFailed, _ref) {
            var _ref2 = $7c0843efefde5d8e$var$_slicedToArray(_ref, 2), key = _ref2[0], sendStatus = _ref2[1];
            return sendStatus === $fjDvy.SEND_FAILED && !(0, $7c0843efefde5d8e$var$_isPresentational.default)(getActivityByKey(key)) ? activityKeysOfSendFailed.add(key) : activityKeysOfSendFailed;
        }, new Set());
    }, [
        getActivityByKey,
        sendStatusByActivityKey
    ]);
    /** Returns localized "Failed to send message." */ var liveRegionSendFailedAlt = localize("TRANSCRIPT_LIVE_REGION_SEND_FAILED_ALT");
    var prevActivityKeysOfSendFailed = (0, $7c0843efefde5d8e$var$_usePrevious.default)(activityKeysOfSendFailed);
    /** True, if one or more non-presentational activities start appears as "send failed", otherwise, false. */ var hasNewSendFailed = (0, $eO7Kz.useMemo)(function() {
        if (activityKeysOfSendFailed === prevActivityKeysOfSendFailed) return false;
        var _iterator = $7c0843efefde5d8e$var$_createForOfIteratorHelper(activityKeysOfSendFailed.keys()), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var key = _step.value;
                if (!prevActivityKeysOfSendFailed.has(key)) return true;
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        return false;
    }, [
        activityKeysOfSendFailed,
        prevActivityKeysOfSendFailed
    ]);
    (0, $eO7Kz.useEffect)(function() {
        hasNewSendFailed && queueStaticElement(liveRegionSendFailedAlt);
    }, [
        hasNewSendFailed,
        liveRegionSendFailedAlt,
        queueStaticElement
    ]);
    return null;
};
var $7c0843efefde5d8e$var$_default = $7c0843efefde5d8e$var$LiveRegionSendFailed;
module.exports.default = $7c0843efefde5d8e$var$_default;

});
parcelRequire.register("8vHzd", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $6323037bffc22b02$var$usePrevious;

var $eO7Kz = parcelRequire("eO7Kz");
// TODO: [P0] #4133 Don't copy.
function $6323037bffc22b02$var$usePrevious(value) {
    var ref = (0, $eO7Kz.useRef)();
    (0, $eO7Kz.useEffect)(function() {
        ref.current = value;
    });
    return ref.current;
}

});

parcelRequire.register("dJQDL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $a0084f9ed45de329$var$useQueueStaticElement;

var $a0084f9ed45de329$var$_useContext = $a0084f9ed45de329$var$_interopRequireDefault((parcelRequire("gTRIA")));
function $a0084f9ed45de329$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * Queues a static element to the live region.
 *
 * After the element is queued, screen reader will eventually narrate it and it cannot be changed.
 */ function $a0084f9ed45de329$var$useQueueStaticElement() {
    return (0, $a0084f9ed45de329$var$_useContext.default)().queueStaticElement;
}

});
parcelRequire.register("gTRIA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $c4db73b35284a491$var$useLiveRegionTwinContext;

var $eO7Kz = parcelRequire("eO7Kz");

var $c4db73b35284a491$var$_Context = $c4db73b35284a491$var$_interopRequireDefault((parcelRequire("aTgyL")));
function $c4db73b35284a491$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $c4db73b35284a491$var$useLiveRegionTwinContext() {
    var thrownOnUndefined = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
    var contextValue = (0, $eO7Kz.useContext)($c4db73b35284a491$var$_Context.default);
    if (thrownOnUndefined && !contextValue) throw new Error("botframework-webchat internal: This hook can only be used under <LiveRegionComposer>.");
    return contextValue;
}

});
parcelRequire.register("aTgyL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $eO7Kz = parcelRequire("eO7Kz");
var $7edbe2db14d3c86c$var$LiveRegionTwinContext = /*#__PURE__*/ (0, $eO7Kz.createContext)(undefined);
var $7edbe2db14d3c86c$var$_default = $7edbe2db14d3c86c$var$LiveRegionTwinContext;
module.exports.default = $7edbe2db14d3c86c$var$_default;

});




parcelRequire.register("j16I8", function(module, exports) {
"use strict";
function $dd8350f0f473f458$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $dd8350f0f473f458$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $dd8350f0f473f458$var$_typeof(obj);
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $hd4g0 = parcelRequire("hd4g0");

var $dd8350f0f473f458$var$_propTypes = $dd8350f0f473f458$var$_interopRequireDefault((parcelRequire("f7UXb")));

var $dd8350f0f473f458$var$_react = $dd8350f0f473f458$var$_interopRequireWildcard((parcelRequire("eO7Kz")));

var $dd8350f0f473f458$var$_LiveRegionTwinContainer = $dd8350f0f473f458$var$_interopRequireDefault((parcelRequire("iDD0v")));

var $dd8350f0f473f458$var$_Context = $dd8350f0f473f458$var$_interopRequireDefault((parcelRequire("aTgyL")));

var $dd8350f0f473f458$var$_useValueRef = $dd8350f0f473f458$var$_interopRequireDefault((parcelRequire("4Dn0F")));
function $dd8350f0f473f458$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($dd8350f0f473f458$var$_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $dd8350f0f473f458$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || $dd8350f0f473f458$var$_typeof(obj) !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $dd8350f0f473f458$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $dd8350f0f473f458$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $dd8350f0f473f458$var$_toConsumableArray(arr) {
    return $dd8350f0f473f458$var$_arrayWithoutHoles(arr) || $dd8350f0f473f458$var$_iterableToArray(arr) || $dd8350f0f473f458$var$_unsupportedIterableToArray(arr) || $dd8350f0f473f458$var$_nonIterableSpread();
}
function $dd8350f0f473f458$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $dd8350f0f473f458$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $dd8350f0f473f458$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $dd8350f0f473f458$var$_arrayLikeToArray(arr);
}
function $dd8350f0f473f458$var$_slicedToArray(arr, i) {
    return $dd8350f0f473f458$var$_arrayWithHoles(arr) || $dd8350f0f473f458$var$_iterableToArrayLimit(arr, i) || $dd8350f0f473f458$var$_unsupportedIterableToArray(arr, i) || $dd8350f0f473f458$var$_nonIterableRest();
}
function $dd8350f0f473f458$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $dd8350f0f473f458$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $dd8350f0f473f458$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $dd8350f0f473f458$var$_arrayLikeToArray(o, minLen);
}
function $dd8350f0f473f458$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $dd8350f0f473f458$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $dd8350f0f473f458$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
var $dd8350f0f473f458$var$usePonyfill = $hd4g0.hooks.usePonyfill;
var $dd8350f0f473f458$var$DEFAULT_ARIA_LIVE = "polite";
var $dd8350f0f473f458$var$DEFAULT_FADE_AFTER = 1000;
/**
 * Live region twin is an UI component for queueing texts or elements to the screen reader using
 * a container element with `aria-live` attribute set.
 *
 * After the text is rendered and queued, it will be removed to reduce burden on the DOM tree.
 * Currently, we assume the assistive technologies should pick up the text within 1 second of rendering.
 * This value is configurable.
 *
 * By default, the live region is visible. If is is not desirable, the caller can use `className` prop to
 * hide its visuals.
 */ var $dd8350f0f473f458$var$LiveRegionTwinComposer = function LiveRegionTwinComposer(_ref) {
    var ariaLabel = _ref["aria-label"], _ref$ariaLive = _ref["aria-live"], ariaLive = _ref$ariaLive === void 0 ? $dd8350f0f473f458$var$DEFAULT_ARIA_LIVE : _ref$ariaLive, ariaRoleDescription = _ref["aria-roledescription"], children = _ref.children, className = _ref.className, _ref$fadeAfter = _ref.fadeAfter, fadeAfter = _ref$fadeAfter === void 0 ? $dd8350f0f473f458$var$DEFAULT_FADE_AFTER : _ref$fadeAfter, role = _ref.role, textElementClassName = _ref.textElementClassName;
    var _usePonyfill = $dd8350f0f473f458$var$usePonyfill(), _usePonyfill2 = $dd8350f0f473f458$var$_slicedToArray(_usePonyfill, 1), _usePonyfill2$ = _usePonyfill2[0], clearTimeout = _usePonyfill2$.clearTimeout, setTimeout = _usePonyfill2$.setTimeout;
    var _useState = (0, $dd8350f0f473f458$var$_react.useState)([]), _useState2 = $dd8350f0f473f458$var$_slicedToArray(_useState, 2), staticElementEntries = _useState2[0], setStaticElementEntries = _useState2[1];
    var fadeAfterRef = (0, $dd8350f0f473f458$var$_useValueRef.default)(fadeAfter);
    var markAllAsRenderedTimeoutIdRef = (0, $dd8350f0f473f458$var$_react.useRef)();
    var nextKeyRef = (0, $dd8350f0f473f458$var$_react.useRef)(1);
    var staticElementEntriesRef = (0, $dd8350f0f473f458$var$_useValueRef.default)(staticElementEntries); // This function is called by an effect hook `useMarkAllAsRenderedEffect`, it must be designed with converging in mind.
    // To prevent infinite render loop, after multiple calls to this function, it should eventually no-op.
    var markAllAsRendered = (0, $dd8350f0f473f458$var$_react.useCallback)(function() {
        if (!staticElementEntriesRef.current.length) // Nothing to remove.
        return;
         // When removing each element one-by-one based on an individual timeout, Narrator would narrate them twice occasionally.
        // Possibly it think some elements that is not removed during the current cycle, are new elements and queued them twice.
        // Thus, we are removing all at once to prevent bugs in Narrator.
        markAllAsRenderedTimeoutIdRef.current && clearTimeout(markAllAsRenderedTimeoutIdRef.current);
        markAllAsRenderedTimeoutIdRef.current = setTimeout(function() {
            // We are playing safe by using value ref to check its length here.
            // If we are certain that `setStaticElements(emptyArray => emptyArray)` is a no-op,
            // we could replace it with just the setter function.
            staticElementEntriesRef.current.length && setStaticElementEntries([]);
        }, fadeAfterRef.current);
    }, [
        clearTimeout,
        fadeAfterRef,
        markAllAsRenderedTimeoutIdRef,
        setStaticElementEntries,
        setTimeout,
        staticElementEntriesRef
    ]); // When this component is unmounting, make sure all future `setTimeout` are cleared and should not be fired.
    (0, $dd8350f0f473f458$var$_react.useEffect)(function() {
        return function() {
            return markAllAsRenderedTimeoutIdRef.current && clearTimeout(markAllAsRenderedTimeoutIdRef.current);
        };
    }, [
        clearTimeout,
        markAllAsRenderedTimeoutIdRef
    ]);
    var queueStaticElement = (0, $dd8350f0f473f458$var$_react.useCallback)(function(element) {
        var key = nextKeyRef.current;
        nextKeyRef.current = nextKeyRef.current + 1;
        setStaticElementEntries(function(entries) {
            return [].concat($dd8350f0f473f458$var$_toConsumableArray(entries), [
                {
                    element: element,
                    key: key
                }
            ]);
        });
    }, [
        nextKeyRef,
        setStaticElementEntries
    ]);
    var staticElementEntriesState = (0, $dd8350f0f473f458$var$_react.useMemo)(function() {
        return Object.freeze([
            Object.freeze(staticElementEntries)
        ]);
    }, [
        staticElementEntries
    ]);
    var context = (0, $dd8350f0f473f458$var$_react.useMemo)(function() {
        return {
            markAllAsRendered: markAllAsRendered,
            queueStaticElement: queueStaticElement,
            staticElementEntriesState: staticElementEntriesState
        };
    }, [
        markAllAsRendered,
        queueStaticElement,
        staticElementEntriesState
    ]);
    return /*#__PURE__*/ $dd8350f0f473f458$var$_react.default.createElement($dd8350f0f473f458$var$_Context.default.Provider, {
        value: context
    }, /*#__PURE__*/ $dd8350f0f473f458$var$_react.default.createElement($dd8350f0f473f458$var$_LiveRegionTwinContainer.default, {
        "aria-label": ariaLabel,
        "aria-live": ariaLive,
        "aria-roledescription": ariaRoleDescription,
        className: className,
        role: role,
        textElementClassName: textElementClassName
    }), children);
};
$dd8350f0f473f458$var$LiveRegionTwinComposer.defaultProps = {
    "aria-label": undefined,
    "aria-live": $dd8350f0f473f458$var$DEFAULT_ARIA_LIVE,
    "aria-roledescription": undefined,
    children: undefined,
    className: undefined,
    fadeAfter: $dd8350f0f473f458$var$DEFAULT_FADE_AFTER,
    role: undefined,
    textElementClassName: undefined
};
$dd8350f0f473f458$var$LiveRegionTwinComposer.propTypes = {
    "aria-label": $dd8350f0f473f458$var$_propTypes.default.string,
    "aria-live": $dd8350f0f473f458$var$_propTypes.default.oneOf([
        "assertive",
        "polite"
    ]),
    "aria-roledescription": $dd8350f0f473f458$var$_propTypes.default.string,
    children: $dd8350f0f473f458$var$_propTypes.default.any,
    className: $dd8350f0f473f458$var$_propTypes.default.string,
    fadeAfter: $dd8350f0f473f458$var$_propTypes.default.number,
    role: $dd8350f0f473f458$var$_propTypes.default.string,
    textElementClassName: $dd8350f0f473f458$var$_propTypes.default.string
};
var $dd8350f0f473f458$var$_default = $dd8350f0f473f458$var$LiveRegionTwinComposer;
module.exports.default = $dd8350f0f473f458$var$_default;

});
parcelRequire.register("iDD0v", function(module, exports) {
"use strict";
function $d91a20829b7c2f1f$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $d91a20829b7c2f1f$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $d91a20829b7c2f1f$var$_typeof(obj);
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d91a20829b7c2f1f$var$_propTypes = $d91a20829b7c2f1f$var$_interopRequireDefault((parcelRequire("f7UXb")));

var $d91a20829b7c2f1f$var$_react = $d91a20829b7c2f1f$var$_interopRequireWildcard((parcelRequire("eO7Kz")));

var $d91a20829b7c2f1f$var$_useMarkAllAsRenderedEffect = $d91a20829b7c2f1f$var$_interopRequireDefault((parcelRequire("alRyq")));

var $d91a20829b7c2f1f$var$_useStaticElementEntries = $d91a20829b7c2f1f$var$_interopRequireDefault((parcelRequire("eDo6j")));
function $d91a20829b7c2f1f$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($d91a20829b7c2f1f$var$_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $d91a20829b7c2f1f$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || $d91a20829b7c2f1f$var$_typeof(obj) !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $d91a20829b7c2f1f$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $d91a20829b7c2f1f$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $d91a20829b7c2f1f$var$_slicedToArray(arr, i) {
    return $d91a20829b7c2f1f$var$_arrayWithHoles(arr) || $d91a20829b7c2f1f$var$_iterableToArrayLimit(arr, i) || $d91a20829b7c2f1f$var$_unsupportedIterableToArray(arr, i) || $d91a20829b7c2f1f$var$_nonIterableRest();
}
function $d91a20829b7c2f1f$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $d91a20829b7c2f1f$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $d91a20829b7c2f1f$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $d91a20829b7c2f1f$var$_arrayLikeToArray(o, minLen);
}
function $d91a20829b7c2f1f$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $d91a20829b7c2f1f$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $d91a20829b7c2f1f$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
// This container is marked as private because we assume there is only one instance under the <LiveRegionTwinContext>.
var $d91a20829b7c2f1f$var$LiveRegionTwinContainer = function LiveRegionTwinContainer(_ref) {
    var ariaLabel = _ref["aria-label"], ariaLive = _ref["aria-live"], ariaRoleDescription = _ref["aria-roledescription"], className = _ref.className, role = _ref.role, textElementClassName = _ref.textElementClassName;
    var _useStaticElementEntr = (0, $d91a20829b7c2f1f$var$_useStaticElementEntries.default)(), _useStaticElementEntr2 = $d91a20829b7c2f1f$var$_slicedToArray(_useStaticElementEntr, 1), staticElementEntries = _useStaticElementEntr2[0]; // We assume there is only one instance under the <LiveRegionTwinContext>.
    // The assumption made us safe to mark everything is rendered.
    // In contrary, if we have 0-to-many at different time, we may falsely mark something as rendered.
    (0, $d91a20829b7c2f1f$var$_useMarkAllAsRenderedEffect.default)();
    return /*#__PURE__*/ $d91a20829b7c2f1f$var$_react.default.createElement("div", {
        "aria-label": ariaLabel,
        "aria-live": ariaLive,
        "aria-roledescription": ariaRoleDescription,
        className: className,
        role: role
    }, staticElementEntries.map(function(_ref2) {
        var element = _ref2.element, key = _ref2.key;
        if (typeof element === "string") return /*#__PURE__*/ $d91a20829b7c2f1f$var$_react.default.createElement("div", {
            "aria-atomic": true,
            className: textElementClassName,
            key: key
        }, element);
        return /*#__PURE__*/ $d91a20829b7c2f1f$var$_react.default.createElement($d91a20829b7c2f1f$var$_react.Fragment, {
            key: key
        }, element);
    }));
};
$d91a20829b7c2f1f$var$LiveRegionTwinContainer.defaultProps = {
    "aria-label": undefined,
    "aria-roledescription": undefined,
    className: undefined,
    role: undefined,
    textElementClassName: undefined
};
$d91a20829b7c2f1f$var$LiveRegionTwinContainer.propTypes = {
    "aria-label": $d91a20829b7c2f1f$var$_propTypes.default.string,
    // PropTypes.oneOf() returns type of `string`, but not `'assertive' | 'polite'`.
    // @ts-ignore
    "aria-live": $d91a20829b7c2f1f$var$_propTypes.default.oneOf([
        "assertive",
        "polite"
    ]).isRequired,
    "aria-roledescription": $d91a20829b7c2f1f$var$_propTypes.default.string,
    className: $d91a20829b7c2f1f$var$_propTypes.default.string,
    role: $d91a20829b7c2f1f$var$_propTypes.default.string,
    textElementClassName: $d91a20829b7c2f1f$var$_propTypes.default.string
};
var $d91a20829b7c2f1f$var$_default = $d91a20829b7c2f1f$var$LiveRegionTwinContainer;
module.exports.default = $d91a20829b7c2f1f$var$_default;

});
parcelRequire.register("alRyq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $78956854efcde3e2$var$useMarkAllAsRenderedEffect;

var $eO7Kz = parcelRequire("eO7Kz");

var $78956854efcde3e2$var$_useContext = $78956854efcde3e2$var$_interopRequireDefault((parcelRequire("gTRIA")));
function $78956854efcde3e2$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
// After calling `markAllAsRendered`, it will cause a re-render.
// Since `markAllAsRendered` is a converging function, it will eventually stop re-rendering.
// We call this hook `useXXXEffect` for us to abstract the business logic here.
function $78956854efcde3e2$var$useMarkAllAsRenderedEffect() {
    var _useLiveRegionTwinCon = (0, $78956854efcde3e2$var$_useContext.default)(), markAllAsRendered = _useLiveRegionTwinCon.markAllAsRendered; // We did not set the `deps` argument as we want to run this function on every render.
    (0, $eO7Kz.useEffect)(markAllAsRendered);
}

});

parcelRequire.register("eDo6j", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $aa776719f4a81a7c$var$useStaticElementEntries;

var $aa776719f4a81a7c$var$_useContext = $aa776719f4a81a7c$var$_interopRequireDefault((parcelRequire("gTRIA")));
function $aa776719f4a81a7c$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $aa776719f4a81a7c$var$useStaticElementEntries() {
    return (0, $aa776719f4a81a7c$var$_useContext.default)().staticElementEntriesState;
}

});



parcelRequire.register("i4wAO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $d281e1f4d98a8e8a$var$useTypistNames;

var $hd4g0 = parcelRequire("hd4g0");

var $eO7Kz = parcelRequire("eO7Kz");
function $d281e1f4d98a8e8a$var$_slicedToArray(arr, i) {
    return $d281e1f4d98a8e8a$var$_arrayWithHoles(arr) || $d281e1f4d98a8e8a$var$_iterableToArrayLimit(arr, i) || $d281e1f4d98a8e8a$var$_unsupportedIterableToArray(arr, i) || $d281e1f4d98a8e8a$var$_nonIterableRest();
}
function $d281e1f4d98a8e8a$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $d281e1f4d98a8e8a$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $d281e1f4d98a8e8a$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $d281e1f4d98a8e8a$var$_arrayLikeToArray(o, minLen);
}
function $d281e1f4d98a8e8a$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $d281e1f4d98a8e8a$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $d281e1f4d98a8e8a$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
var $d281e1f4d98a8e8a$var$useActiveTyping = $hd4g0.hooks.useActiveTyping;
function $d281e1f4d98a8e8a$var$arrayEquals(x, y) {
    return x.length === y.length && x.every(function(value, index) {
        return y[+index] === value;
    });
}
/** Gets names of users who are actively typing, sorted by the time they started typing. */ function $d281e1f4d98a8e8a$var$useTypistNames() {
    var _useActiveTyping = $d281e1f4d98a8e8a$var$useActiveTyping(), _useActiveTyping2 = $d281e1f4d98a8e8a$var$_slicedToArray(_useActiveTyping, 1), activeTyping = _useActiveTyping2[0];
    var prevTypistNamesStateRef = (0, $eO7Kz.useRef)(Object.freeze([
        Object.freeze([])
    ]));
    var activeTypingFromOthersValues = Object.values(activeTyping).filter(function(_ref) {
        var role = _ref.role;
        return role !== "user";
    }); // Sort the list by the first typist.
    var sortedActiveTypingFromOthersValues = activeTypingFromOthersValues.sort(function(_ref2, _ref3) {
        var x = _ref2.at;
        var y = _ref3.at;
        return x - y;
    });
    var typistNamesState = Object.freeze([
        Object.freeze(sortedActiveTypingFromOthersValues.map(function(_ref4) {
            var name = _ref4.name;
            return name;
        }))
    ]);
    var prevTypistNamesState = prevTypistNamesStateRef.current;
    var nextTypistNamesState = $d281e1f4d98a8e8a$var$arrayEquals(typistNamesState[0], prevTypistNamesState[0]) ? prevTypistNamesState : typistNamesState;
    (0, $eO7Kz.useEffect)(function() {
        prevTypistNamesStateRef.current = nextTypistNamesState;
    }, [
        prevTypistNamesStateRef,
        nextTypistNamesState
    ]);
    return nextTypistNamesState;
}

});


parcelRequire.register("2hDw6", function(module, exports) {
"use strict";
function $1a9bd27e1111d380$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $1a9bd27e1111d380$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $1a9bd27e1111d380$var$_typeof(obj);
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $hd4g0 = parcelRequire("hd4g0");

var $1a9bd27e1111d380$var$_propTypes = $1a9bd27e1111d380$var$_interopRequireDefault((parcelRequire("f7UXb")));

var $1a9bd27e1111d380$var$_mathRandom = $1a9bd27e1111d380$var$_interopRequireDefault((parcelRequire("atZsr")));

var $1a9bd27e1111d380$var$_react = $1a9bd27e1111d380$var$_interopRequireWildcard((parcelRequire("eO7Kz")));

var $1a9bd27e1111d380$var$_scrollIntoViewWithBlockNearest = $1a9bd27e1111d380$var$_interopRequireDefault((parcelRequire("f3T34")));

var $1a9bd27e1111d380$var$_Context = $1a9bd27e1111d380$var$_interopRequireDefault((parcelRequire("ibQNK")));

var $1a9bd27e1111d380$var$_useActivityTreeWithRenderer = $1a9bd27e1111d380$var$_interopRequireDefault((parcelRequire("5TnSK")));

var $1a9bd27e1111d380$var$_usePrevious = $1a9bd27e1111d380$var$_interopRequireDefault((parcelRequire("8vHzd")));

var $1a9bd27e1111d380$var$_useStateRef3 = $1a9bd27e1111d380$var$_interopRequireDefault((parcelRequire("1Cj4d")));

var $1a9bd27e1111d380$var$_useValueRef = $1a9bd27e1111d380$var$_interopRequireDefault((parcelRequire("4Dn0F")));
function $1a9bd27e1111d380$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($1a9bd27e1111d380$var$_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $1a9bd27e1111d380$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || $1a9bd27e1111d380$var$_typeof(obj) !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $1a9bd27e1111d380$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $1a9bd27e1111d380$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $1a9bd27e1111d380$var$_slicedToArray(arr, i) {
    return $1a9bd27e1111d380$var$_arrayWithHoles(arr) || $1a9bd27e1111d380$var$_iterableToArrayLimit(arr, i) || $1a9bd27e1111d380$var$_unsupportedIterableToArray(arr, i) || $1a9bd27e1111d380$var$_nonIterableRest();
}
function $1a9bd27e1111d380$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $1a9bd27e1111d380$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $1a9bd27e1111d380$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $1a9bd27e1111d380$var$_arrayLikeToArray(o, minLen);
}
function $1a9bd27e1111d380$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $1a9bd27e1111d380$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $1a9bd27e1111d380$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
var $1a9bd27e1111d380$var$useGetKeyByActivity = $hd4g0.hooks.useGetKeyByActivity;
function $1a9bd27e1111d380$var$last(array) {
    return array[array.length - 1];
}
function $1a9bd27e1111d380$var$uniqueId() {
    var count = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Infinity;
    return (0, $1a9bd27e1111d380$var$_mathRandom.default)() // eslint-disable-next-line no-magic-numbers
    .toString(36) // eslint-disable-next-line no-magic-numbers
    .substring(2, 2 + count);
}
var $1a9bd27e1111d380$var$TranscriptFocusComposer = function TranscriptFocusComposer(_ref) {
    var _containerRef$current;
    var children = _ref.children, containerRef = _ref.containerRef;
    var _useActivityTreeWithR = (0, $1a9bd27e1111d380$var$_useActivityTreeWithRenderer.default)({
        flat: true
    }), _useActivityTreeWithR2 = $1a9bd27e1111d380$var$_slicedToArray(_useActivityTreeWithR, 1), flattenedActivityTree = _useActivityTreeWithR2[0];
    var _useStateRef = (0, $1a9bd27e1111d380$var$_useStateRef3.default)(), _useStateRef2 = $1a9bd27e1111d380$var$_slicedToArray(_useStateRef, 3), _ = _useStateRef2[0], setRawFocusedActivityKey = _useStateRef2[1], rawFocusedActivityKeyRef = _useStateRef2[2];
    var getKeyByActivity = $1a9bd27e1111d380$var$useGetKeyByActivity(); // As we need to use IDREF for `aria-activedescendant`,
    // this prefix will differentiate multiple instances of transcript on the same page.
    // eslint-disable-next-line no-magic-numbers
    var prefix = (0, $1a9bd27e1111d380$var$_react.useMemo)(function() {
        return $1a9bd27e1111d380$var$uniqueId(3);
    }, []);
    var getDescendantIdByActivityKey = (0, $1a9bd27e1111d380$var$_react.useCallback)(function(activityKey) {
        return activityKey && "webchat__transcript-focus-".concat(prefix, "__activity-").concat(activityKey);
    }, [
        prefix
    ]);
    var renderingActivityKeys = (0, $1a9bd27e1111d380$var$_react.useMemo)(function() {
        return Object.freeze(flattenedActivityTree.map(function(_ref2) {
            var activity = _ref2.activity;
            return getKeyByActivity(activity);
        }));
    }, [
        flattenedActivityTree,
        getKeyByActivity
    ]);
    var renderingActivityKeysRef = (0, $1a9bd27e1111d380$var$_useValueRef.default)(renderingActivityKeys); // While the transcript or any descendants are not focused, if the transcript is updated, reset the user-selected active descendant.
    // This will assume the last activity, if any, will be the active descendant.
    var prevRenderingActivityKeys = (0, $1a9bd27e1111d380$var$_usePrevious.default)(renderingActivityKeys);
    if (renderingActivityKeys !== prevRenderingActivityKeys && !((_containerRef$current = containerRef.current) !== null && _containerRef$current !== void 0 && _containerRef$current.contains(document.activeElement))) rawFocusedActivityKeyRef.current = undefined;
    var rawFocusedActivityKey = rawFocusedActivityKeyRef.current;
    var focusedActivityKey = (0, $1a9bd27e1111d380$var$_react.useMemo)(function() {
        return renderingActivityKeys.includes(rawFocusedActivityKey) ? rawFocusedActivityKey : $1a9bd27e1111d380$var$last(renderingActivityKeys);
    }, [
        renderingActivityKeys,
        rawFocusedActivityKey
    ]);
    var focusedActivityKeyRef = (0, $1a9bd27e1111d380$var$_useValueRef.default)(focusedActivityKey);
    var activeDescendantId = (0, $1a9bd27e1111d380$var$_react.useMemo)(function() {
        return getDescendantIdByActivityKey(focusedActivityKey);
    }, [
        getDescendantIdByActivityKey,
        focusedActivityKey
    ]);
    var focusByActivityKey = (0, $1a9bd27e1111d380$var$_react.useCallback)(function(activityKey) {
        var withFocus = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
        if (activityKey === false) // `false` means set it to nothing.
        setRawFocusedActivityKey(undefined);
        else if (activityKey === true) // `true` means set to something if it is not set.
        setRawFocusedActivityKey(function(key) {
            return key || focusedActivityKeyRef.current;
        });
        else if (activityKey) setRawFocusedActivityKey(activityKey);
        if (withFocus) {
            var _containerRef$current2;
            (_containerRef$current2 = containerRef.current) === null || _containerRef$current2 === void 0 || _containerRef$current2.focus();
            var _activeDescendantId = getDescendantIdByActivityKey(activityKey === false ? $1a9bd27e1111d380$var$last(renderingActivityKeysRef.current) : activityKey && activityKey !== true ? activityKey : // If "activityKey" is "true", it means "try to focus on anything".
            rawFocusedActivityKeyRef.current);
            var activeDescendantElement = _activeDescendantId && document.getElementById(_activeDescendantId); // Don't scroll active descendant into view if the focus is already inside it.
            // Otherwise, given the focus is on the send box, clicking on any <input> inside the Adaptive Cards may cause the view to move.
            // This UX is not desirable because click should not cause scroll.
            if (activeDescendantElement && !activeDescendantElement.contains(document.activeElement)) (0, $1a9bd27e1111d380$var$_scrollIntoViewWithBlockNearest.default)(activeDescendantElement);
        }
    }, [
        getDescendantIdByActivityKey,
        containerRef,
        focusedActivityKeyRef,
        renderingActivityKeysRef,
        rawFocusedActivityKeyRef,
        setRawFocusedActivityKey
    ]);
    var focusRelativeActivity = (0, $1a9bd27e1111d380$var$_react.useCallback)(function(delta) {
        var orderedActivityKeys = renderingActivityKeysRef.current;
        if (isNaN(delta) || !orderedActivityKeys.length) return focusByActivityKey(false, true);
        var focusedActivityKey = focusedActivityKeyRef.current;
        var index = orderedActivityKeys.indexOf(focusedActivityKey);
        var nextIndex = ~index ? Math.max(0, Math.min(orderedActivityKeys.length - 1, index + delta)) : orderedActivityKeys.length - 1;
        focusByActivityKey(orderedActivityKeys[+nextIndex], true);
    }, [
        focusedActivityKeyRef,
        renderingActivityKeysRef,
        focusByActivityKey
    ]);
    var contextValue = (0, $1a9bd27e1111d380$var$_react.useMemo)(function() {
        return {
            activeDescendantIdState: Object.freeze([
                activeDescendantId
            ]),
            getDescendantIdByActivityKey: getDescendantIdByActivityKey,
            focusByActivityKey: focusByActivityKey,
            focusedActivityKeyState: Object.freeze([
                focusedActivityKey
            ]),
            focusedExplicitlyState: Object.freeze([
                !!rawFocusedActivityKey
            ]),
            focusRelativeActivity: focusRelativeActivity
        };
    }, [
        activeDescendantId,
        getDescendantIdByActivityKey,
        focusByActivityKey,
        focusedActivityKey,
        focusRelativeActivity,
        rawFocusedActivityKey
    ]);
    return /*#__PURE__*/ $1a9bd27e1111d380$var$_react.default.createElement($1a9bd27e1111d380$var$_Context.default.Provider, {
        value: contextValue
    }, children);
};
$1a9bd27e1111d380$var$TranscriptFocusComposer.propTypes = {
    // PropTypes is not fully compatible with TypeScript.
    // @ts-ignore
    containerRef: $1a9bd27e1111d380$var$_propTypes.default.shape({
        current: $1a9bd27e1111d380$var$_propTypes.default.instanceOf(HTMLElement)
    }).isRequired
};
var $1a9bd27e1111d380$var$_default = $1a9bd27e1111d380$var$TranscriptFocusComposer;
module.exports.default = $1a9bd27e1111d380$var$_default;

});
parcelRequire.register("f3T34", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $af71d64b998d86fc$var$scrollIntoViewWithBlockNearest;

var $af71d64b998d86fc$var$_computeScrollIntoView = $af71d64b998d86fc$var$_interopRequireDefault((parcelRequire("jQYpZ")));
function $af71d64b998d86fc$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $af71d64b998d86fc$var$_slicedToArray(arr, i) {
    return $af71d64b998d86fc$var$_arrayWithHoles(arr) || $af71d64b998d86fc$var$_iterableToArrayLimit(arr, i) || $af71d64b998d86fc$var$_unsupportedIterableToArray(arr, i) || $af71d64b998d86fc$var$_nonIterableRest();
}
function $af71d64b998d86fc$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $af71d64b998d86fc$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $af71d64b998d86fc$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $af71d64b998d86fc$var$_arrayLikeToArray(o, minLen);
}
function $af71d64b998d86fc$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $af71d64b998d86fc$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $af71d64b998d86fc$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
/**
 * Calls `targetElement.scrollIntoView({ block: 'nearest' })`.
 *
 * If browser do not support options for `scrollIntoView`, fallback to polyfill.
 */ function $af71d64b998d86fc$var$scrollIntoViewWithBlockNearest(targetElement) {
    // Checks if `scrollIntoView` support options or not.
    // - https://github.com/Modernizr/Modernizr/issues/1568#issuecomment-419457972
    // - https://stackoverflow.com/questions/46919627/is-it-possible-to-test-for-scrollintoview-browser-compatibility
    if ("scrollBehavior" in document.documentElement.style) return targetElement.scrollIntoView({
        block: "nearest"
    });
     // We should only move transcript scrollable, and not other scrollable, such as document.body which is from the hosting page.
    var _computeScrollIntoVie = (0, $af71d64b998d86fc$var$_computeScrollIntoView.default)(targetElement, {
        block: "nearest"
    }), _computeScrollIntoVie2 = $af71d64b998d86fc$var$_slicedToArray(_computeScrollIntoVie, 1), action = _computeScrollIntoVie2[0];
    action.el.scrollTop = action.top;
}

});
parcelRequire.register("jQYpZ", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $7ced624145ddf41a$export$2e2bcd8739ae039);
function $7ced624145ddf41a$var$t(t) {
    return "object" == typeof t && null != t && 1 === t.nodeType;
}
function $7ced624145ddf41a$var$e(t, e) {
    return (!e || "hidden" !== t) && "visible" !== t && "clip" !== t;
}
function $7ced624145ddf41a$var$n(t, n) {
    if (t.clientHeight < t.scrollHeight || t.clientWidth < t.scrollWidth) {
        var r = getComputedStyle(t, null);
        return $7ced624145ddf41a$var$e(r.overflowY, n) || $7ced624145ddf41a$var$e(r.overflowX, n) || function(t) {
            var e = function(t) {
                if (!t.ownerDocument || !t.ownerDocument.defaultView) return null;
                try {
                    return t.ownerDocument.defaultView.frameElement;
                } catch (t) {
                    return null;
                }
            }(t);
            return !!e && (e.clientHeight < t.scrollHeight || e.clientWidth < t.scrollWidth);
        }(t);
    }
    return !1;
}
function $7ced624145ddf41a$var$r(t, e, n, r, i, o, l, d) {
    return o < t && l > e || o > t && l < e ? 0 : o <= t && d <= n || l >= e && d >= n ? o - t - r : l > e && d < n || o < t && d > n ? l - e + i : 0;
}
var $7ced624145ddf41a$export$2e2bcd8739ae039 = function(e, i) {
    var o = window, l = i.scrollMode, d = i.block, f = i.inline, h = i.boundary, u = i.skipOverflowHiddenElements, s = "function" == typeof h ? h : function(t) {
        return t !== h;
    };
    if (!$7ced624145ddf41a$var$t(e)) throw new TypeError("Invalid target");
    for(var a, c, g = document.scrollingElement || document.documentElement, p = [], m = e; $7ced624145ddf41a$var$t(m) && s(m);){
        if ((m = null == (c = (a = m).parentElement) ? a.getRootNode().host || null : c) === g) {
            p.push(m);
            break;
        }
        null != m && m === document.body && $7ced624145ddf41a$var$n(m) && !$7ced624145ddf41a$var$n(document.documentElement) || null != m && $7ced624145ddf41a$var$n(m, u) && p.push(m);
    }
    for(var w = o.visualViewport ? o.visualViewport.width : innerWidth, v = o.visualViewport ? o.visualViewport.height : innerHeight, W = window.scrollX || pageXOffset, H = window.scrollY || pageYOffset, b = e.getBoundingClientRect(), y = b.height, E = b.width, M = b.top, V = b.right, x = b.bottom, I = b.left, C = "start" === d || "nearest" === d ? M : "end" === d ? x : M + y / 2, R = "center" === f ? I + E / 2 : "end" === f ? V : I, T = [], k = 0; k < p.length; k++){
        var B = p[k], D = B.getBoundingClientRect(), O = D.height, X = D.width, Y = D.top, L = D.right, S = D.bottom, j = D.left;
        if ("if-needed" === l && M >= 0 && I >= 0 && x <= v && V <= w && M >= Y && x <= S && I >= j && V <= L) return T;
        var N = getComputedStyle(B), q = parseInt(N.borderLeftWidth, 10), z = parseInt(N.borderTopWidth, 10), A = parseInt(N.borderRightWidth, 10), F = parseInt(N.borderBottomWidth, 10), G = 0, J = 0, K = "offsetWidth" in B ? B.offsetWidth - B.clientWidth - q - A : 0, P = "offsetHeight" in B ? B.offsetHeight - B.clientHeight - z - F : 0, Q = "offsetWidth" in B ? 0 === B.offsetWidth ? 0 : X / B.offsetWidth : 0, U = "offsetHeight" in B ? 0 === B.offsetHeight ? 0 : O / B.offsetHeight : 0;
        if (g === B) G = "start" === d ? C : "end" === d ? C - v : "nearest" === d ? $7ced624145ddf41a$var$r(H, H + v, v, z, F, H + C, H + C + y, y) : C - v / 2, J = "start" === f ? R : "center" === f ? R - w / 2 : "end" === f ? R - w : $7ced624145ddf41a$var$r(W, W + w, w, q, A, W + R, W + R + E, E), G = Math.max(0, G + H), J = Math.max(0, J + W);
        else {
            G = "start" === d ? C - Y - z : "end" === d ? C - S + F + P : "nearest" === d ? $7ced624145ddf41a$var$r(Y, S, O, z, F + P, C, C + y, y) : C - (Y + O / 2) + P / 2, J = "start" === f ? R - j - q : "center" === f ? R - (j + X / 2) + K / 2 : "end" === f ? R - L + A + K : $7ced624145ddf41a$var$r(j, L, X, q, A + K, R, R + E, E);
            var Z = B.scrollLeft, $ = B.scrollTop;
            C += $ - (G = Math.max(0, Math.min($ + G / U, B.scrollHeight - O / U + P))), R += Z - (J = Math.max(0, Math.min(Z + J / Q, B.scrollWidth - X / Q + K)));
        }
        T.push({
            el: B,
            top: G,
            left: J
        });
    }
    return T;
};

});


parcelRequire.register("5TnSK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $44a49d477d106361$var$useActivityTreeWithRenderer;

var $44a49d477d106361$var$_useContext = $44a49d477d106361$var$_interopRequireDefault((parcelRequire("7QF4z")));
function $44a49d477d106361$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $44a49d477d106361$var$useActivityTreeWithRenderer() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var context = (0, $44a49d477d106361$var$_useContext.default)();
    return (options === null || options === void 0 ? void 0 : options.flat) === true ? context.flattenedActivityTreeWithRendererState : context.activityTreeWithRendererState;
}

});
parcelRequire.register("7QF4z", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $5b6d3fe74ab8db34$var$useActivityTreeContext;

var $eO7Kz = parcelRequire("eO7Kz");

var $5b6d3fe74ab8db34$var$_Context = $5b6d3fe74ab8db34$var$_interopRequireDefault((parcelRequire("cOp70")));
function $5b6d3fe74ab8db34$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $5b6d3fe74ab8db34$var$useActivityTreeContext() {
    var thrownOnUndefined = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
    var contextValue = (0, $eO7Kz.useContext)($5b6d3fe74ab8db34$var$_Context.default);
    if (thrownOnUndefined && !contextValue) throw new Error("botframework-webchat internal: This hook can only be used under <ActivityTreeComposer>.");
    return contextValue;
}

});
parcelRequire.register("cOp70", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $eO7Kz = parcelRequire("eO7Kz");
var $953da245d476b92d$var$_default = /*#__PURE__*/ (0, $eO7Kz.createContext)(undefined);
module.exports.default = $953da245d476b92d$var$_default;

});



parcelRequire.register("1Cj4d", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $12d82160cee6df29$var$useStateRef;

var $eO7Kz = parcelRequire("eO7Kz");
function $12d82160cee6df29$var$_slicedToArray(arr, i) {
    return $12d82160cee6df29$var$_arrayWithHoles(arr) || $12d82160cee6df29$var$_iterableToArrayLimit(arr, i) || $12d82160cee6df29$var$_unsupportedIterableToArray(arr, i) || $12d82160cee6df29$var$_nonIterableRest();
}
function $12d82160cee6df29$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $12d82160cee6df29$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $12d82160cee6df29$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $12d82160cee6df29$var$_arrayLikeToArray(o, minLen);
}
function $12d82160cee6df29$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $12d82160cee6df29$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $12d82160cee6df29$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $12d82160cee6df29$var$useStateRef(initialValue) {
    var _useState = (0, $eO7Kz.useState)(), _useState2 = $12d82160cee6df29$var$_slicedToArray(_useState, 2), _ = _useState2[0], forceRender = _useState2[1];
    var valueRef = (0, $eO7Kz.useRef)(initialValue);
    var setter = (0, $eO7Kz.useCallback)(function(value) {
        var current = valueRef.current;
        value = value instanceof Function ? value(current) : value;
        if (current !== value) {
            valueRef.current = value;
            forceRender({});
        }
    }, [
        forceRender,
        valueRef
    ]);
    return Object.freeze([
        valueRef.current,
        setter,
        valueRef
    ]);
}

});


parcelRequire.register("iVV3d", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $dc89cdf9adfb0cf4$var$useDispatchScrollPosition;

var $dc89cdf9adfb0cf4$var$_useWebChatUIContext = $dc89cdf9adfb0cf4$var$_interopRequireDefault((parcelRequire("tHuBR")));
function $dc89cdf9adfb0cf4$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $dc89cdf9adfb0cf4$var$useDispatchScrollPosition() {
    return (0, $dc89cdf9adfb0cf4$var$_useWebChatUIContext.default)().dispatchScrollPosition;
}

});

parcelRequire.register("3bISN", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $252536f2f77ef27b$var$useDispatchTranscriptFocusByActivityKey;

var $252536f2f77ef27b$var$_useWebChatUIContext = $252536f2f77ef27b$var$_interopRequireDefault((parcelRequire("tHuBR")));
function $252536f2f77ef27b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $252536f2f77ef27b$var$useDispatchTranscriptFocusByActivityKey() {
    return (0, $252536f2f77ef27b$var$_useWebChatUIContext.default)().dispatchTranscriptFocusByActivityKey;
}

});

parcelRequire.register("fRh7R", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $b8b9170fa685ab35$var$useFocusedActivityKey;

var $b8b9170fa685ab35$var$_useContext = $b8b9170fa685ab35$var$_interopRequireDefault((parcelRequire("30hVF")));
function $b8b9170fa685ab35$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $b8b9170fa685ab35$var$useFocusedActivityKey() {
    return (0, $b8b9170fa685ab35$var$_useContext.default)().focusedActivityKeyState;
}

});

parcelRequire.register("ci4oR", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $8f2a943cc967257a$var$useFocusedExplicitly;

var $8f2a943cc967257a$var$_useContext = $8f2a943cc967257a$var$_interopRequireDefault((parcelRequire("30hVF")));
function $8f2a943cc967257a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $8f2a943cc967257a$var$useFocusedExplicitly() {
    return (0, $8f2a943cc967257a$var$_useContext.default)().focusedExplicitlyState;
}

});

parcelRequire.register("9NUBQ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $72349a15f05fb09b$var$useFocusByActivityKey;

var $72349a15f05fb09b$var$_useContext = $72349a15f05fb09b$var$_interopRequireDefault((parcelRequire("30hVF")));
function $72349a15f05fb09b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $72349a15f05fb09b$var$useFocusByActivityKey() {
    return (0, $72349a15f05fb09b$var$_useContext.default)().focusRelativeActivity;
}

});

parcelRequire.register("j8BzJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $deebe957a46eb3e9$var$useRegisterFocusTranscript;

var $eO7Kz = parcelRequire("eO7Kz");

var $deebe957a46eb3e9$var$_removeInline = $deebe957a46eb3e9$var$_interopRequireDefault((parcelRequire("6gxgd")));

var $deebe957a46eb3e9$var$_useWebChatUIContext2 = $deebe957a46eb3e9$var$_interopRequireDefault((parcelRequire("tHuBR")));
function $deebe957a46eb3e9$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
// This hook is for registering and unregister a callback, used by <BasicTranscript>.
// When called, the callback should focus on the transcript.
function $deebe957a46eb3e9$var$useRegisterFocusTranscript(callback) {
    var _useWebChatUIContext = (0, $deebe957a46eb3e9$var$_useWebChatUIContext2.default)(), focusTranscriptCallbacksRef = _useWebChatUIContext.focusTranscriptCallbacksRef;
    (0, $eO7Kz.useEffect)(function() {
        if (callback) {
            var focusTranscriptCallbacks = focusTranscriptCallbacksRef.current;
            focusTranscriptCallbacks.push(callback);
            return function() {
                return (0, $deebe957a46eb3e9$var$_removeInline.default)(focusTranscriptCallbacks, callback);
            };
        }
    }, [
        callback,
        focusTranscriptCallbacksRef
    ]);
}

});

parcelRequire.register("kiEmy", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $ec74cc49a27c77ed$var$useRegisterScrollRelative;

var $eO7Kz = parcelRequire("eO7Kz");

var $ec74cc49a27c77ed$var$_removeInline = $ec74cc49a27c77ed$var$_interopRequireDefault((parcelRequire("6gxgd")));

var $ec74cc49a27c77ed$var$_useWebChatUIContext2 = $ec74cc49a27c77ed$var$_interopRequireDefault((parcelRequire("tHuBR")));
function $ec74cc49a27c77ed$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
// This hook is for registering and unregister a callback, used by <BasicTranscript>.
// When called, the callback should scroll the transcript in a relative motion, for example, page up and down.
function $ec74cc49a27c77ed$var$useRegisterScrollRelative(callback) {
    var _useWebChatUIContext = (0, $ec74cc49a27c77ed$var$_useWebChatUIContext2.default)(), scrollRelativeCallbacksRef = _useWebChatUIContext.scrollRelativeCallbacksRef;
    (0, $eO7Kz.useEffect)(function() {
        if (callback) {
            var scrollRelativeCallbacks = scrollRelativeCallbacksRef.current;
            scrollRelativeCallbacks.push(callback);
            return function() {
                return (0, $ec74cc49a27c77ed$var$_removeInline.default)(scrollRelativeCallbacks, callback);
            };
        }
    }, [
        callback,
        scrollRelativeCallbacksRef
    ]);
}

});

parcelRequire.register("7fA1J", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $5475e14b09926d6d$var$useRegisterScrollTo;

var $eO7Kz = parcelRequire("eO7Kz");

var $5475e14b09926d6d$var$_removeInline = $5475e14b09926d6d$var$_interopRequireDefault((parcelRequire("6gxgd")));

var $5475e14b09926d6d$var$_useWebChatUIContext2 = $5475e14b09926d6d$var$_interopRequireDefault((parcelRequire("tHuBR")));
function $5475e14b09926d6d$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
// This hook is for registering and unregister a callback, used by <BasicTranscript>.
// When called, the callback should scroll the transcript to a specific position, for example, to an activity of specified ID.
function $5475e14b09926d6d$var$useRegisterScrollTo(callback) {
    var _useWebChatUIContext = (0, $5475e14b09926d6d$var$_useWebChatUIContext2.default)(), scrollToCallbacksRef = _useWebChatUIContext.scrollToCallbacksRef;
    (0, $eO7Kz.useEffect)(function() {
        if (callback) {
            var scrollToCallbacks = scrollToCallbacksRef.current;
            scrollToCallbacks.push(callback);
            return function() {
                return (0, $5475e14b09926d6d$var$_removeInline.default)(scrollToCallbacks, callback);
            };
        }
    }, [
        callback,
        scrollToCallbacksRef
    ]);
}

});

parcelRequire.register("6351u", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $4676eb5d435f5835$var$useRegisterScrollTo;

var $eO7Kz = parcelRequire("eO7Kz");

var $4676eb5d435f5835$var$_removeInline = $4676eb5d435f5835$var$_interopRequireDefault((parcelRequire("6gxgd")));

var $4676eb5d435f5835$var$_useWebChatUIContext2 = $4676eb5d435f5835$var$_interopRequireDefault((parcelRequire("tHuBR")));
function $4676eb5d435f5835$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
// This hook is for registering and unregister a callback, used by <BasicTranscript>.
// When called, the callback should scroll the transcript to the end.
function $4676eb5d435f5835$var$useRegisterScrollTo(callback) {
    var _useWebChatUIContext = (0, $4676eb5d435f5835$var$_useWebChatUIContext2.default)(), scrollToEndCallbacksRef = _useWebChatUIContext.scrollToEndCallbacksRef;
    (0, $eO7Kz.useEffect)(function() {
        var scrollToEndCallbacks = scrollToEndCallbacksRef.current;
        scrollToEndCallbacks.push(callback);
        return function() {
            return (0, $4676eb5d435f5835$var$_removeInline.default)(scrollToEndCallbacks, callback);
        };
    }, [
        callback,
        scrollToEndCallbacksRef
    ]);
}

});



parcelRequire.register("9a3YE", function(module, exports) {
"use strict";
function $6ab82205d0dd1dbb$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $6ab82205d0dd1dbb$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $6ab82205d0dd1dbb$var$_typeof(obj);
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $hd4g0 = parcelRequire("hd4g0");

var $eM21L = parcelRequire("eM21L");

var $cG9B9 = parcelRequire("cG9B9");

var $6ab82205d0dd1dbb$var$_createInstance = $6ab82205d0dd1dbb$var$_interopRequireDefault((parcelRequire("aEQyb")));

var $6ab82205d0dd1dbb$var$_createStyleSet = $6ab82205d0dd1dbb$var$_interopRequireDefault((parcelRequire("1MGBN")));

var $6ab82205d0dd1dbb$var$_markdownIt = $6ab82205d0dd1dbb$var$_interopRequireDefault((parcelRequire("4D2tK")));

var $6ab82205d0dd1dbb$var$_propTypes = $6ab82205d0dd1dbb$var$_interopRequireDefault((parcelRequire("f7UXb")));

var $6ab82205d0dd1dbb$var$_react = $6ab82205d0dd1dbb$var$_interopRequireWildcard((parcelRequire("eO7Kz")));

var $dCjk2 = parcelRequire("dCjk2");

var $6ab82205d0dd1dbb$var$_ActivityTreeComposer = $6ab82205d0dd1dbb$var$_interopRequireDefault((parcelRequire("8WVG5")));

var $6ab82205d0dd1dbb$var$_addTargetBlankToHyperlinksMarkdown = $6ab82205d0dd1dbb$var$_interopRequireDefault((parcelRequire("aXJ2X")));

var $6ab82205d0dd1dbb$var$_createCSSKey = $6ab82205d0dd1dbb$var$_interopRequireDefault((parcelRequire("gOLiq")));

var $6ab82205d0dd1dbb$var$_createCoreMiddleware = $6ab82205d0dd1dbb$var$_interopRequireDefault((parcelRequire("9AQhK")));

var $6ab82205d0dd1dbb$var$_createCoreMiddleware2 = $6ab82205d0dd1dbb$var$_interopRequireDefault((parcelRequire("elZtZ")));

var $6ab82205d0dd1dbb$var$_createCoreMiddleware3 = $6ab82205d0dd1dbb$var$_interopRequireDefault((parcelRequire("6XjCv")));

var $6ab82205d0dd1dbb$var$_createCoreMiddleware4 = $6ab82205d0dd1dbb$var$_interopRequireDefault((parcelRequire("l1gyp")));

var $6ab82205d0dd1dbb$var$_createCoreMiddleware5 = $6ab82205d0dd1dbb$var$_interopRequireDefault((parcelRequire("bIkyU")));

var $6ab82205d0dd1dbb$var$_createCoreMiddleware6 = $6ab82205d0dd1dbb$var$_interopRequireDefault((parcelRequire("7tAMc")));

var $6ab82205d0dd1dbb$var$_createScrollToEndButtonMiddleware = $6ab82205d0dd1dbb$var$_interopRequireDefault((parcelRequire("kVlGB")));

var $6ab82205d0dd1dbb$var$_createCoreMiddleware7 = $6ab82205d0dd1dbb$var$_interopRequireDefault((parcelRequire("gRnWL")));

var $6ab82205d0dd1dbb$var$_createCoreMiddleware8 = $6ab82205d0dd1dbb$var$_interopRequireDefault((parcelRequire("gc9Ic")));

var $6ab82205d0dd1dbb$var$_Dictation = $6ab82205d0dd1dbb$var$_interopRequireDefault((parcelRequire("iRqQu")));

var $6ab82205d0dd1dbb$var$_downscaleImageToDataURL = $6ab82205d0dd1dbb$var$_interopRequireDefault((parcelRequire("gvacg")));

var $6ab82205d0dd1dbb$var$_ErrorBox = $6ab82205d0dd1dbb$var$_interopRequireDefault((parcelRequire("foWLx")));

var $6ab82205d0dd1dbb$var$_mapMap = $6ab82205d0dd1dbb$var$_interopRequireDefault((parcelRequire("jcXHG")));

var $6ab82205d0dd1dbb$var$_SendBoxComposer = $6ab82205d0dd1dbb$var$_interopRequireDefault((parcelRequire("clXbV")));

var $6ab82205d0dd1dbb$var$_UITracker = $6ab82205d0dd1dbb$var$_interopRequireDefault((parcelRequire("fJh2e")));

var $6ab82205d0dd1dbb$var$_WebChatUIContext = $6ab82205d0dd1dbb$var$_interopRequireDefault((parcelRequire("59jaJ")));
var $6ab82205d0dd1dbb$var$_excluded = [
    "activityMiddleware",
    "activityStatusMiddleware",
    "attachmentForScreenReaderMiddleware",
    "attachmentMiddleware",
    "avatarMiddleware",
    "cardActionMiddleware",
    "children",
    "extraStyleSet",
    "renderMarkdown",
    "scrollToEndButtonMiddleware",
    "styleSet",
    "suggestedActionsAccessKey",
    "toastMiddleware",
    "typingIndicatorMiddleware",
    "webSpeechPonyfillFactory"
];
function $6ab82205d0dd1dbb$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($6ab82205d0dd1dbb$var$_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $6ab82205d0dd1dbb$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || $6ab82205d0dd1dbb$var$_typeof(obj) !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $6ab82205d0dd1dbb$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $6ab82205d0dd1dbb$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $6ab82205d0dd1dbb$var$_extends() {
    $6ab82205d0dd1dbb$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $6ab82205d0dd1dbb$var$_extends.apply(this, arguments);
}
function $6ab82205d0dd1dbb$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $6ab82205d0dd1dbb$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $6ab82205d0dd1dbb$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $6ab82205d0dd1dbb$var$_toConsumableArray(arr) {
    return $6ab82205d0dd1dbb$var$_arrayWithoutHoles(arr) || $6ab82205d0dd1dbb$var$_iterableToArray(arr) || $6ab82205d0dd1dbb$var$_unsupportedIterableToArray(arr) || $6ab82205d0dd1dbb$var$_nonIterableSpread();
}
function $6ab82205d0dd1dbb$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $6ab82205d0dd1dbb$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $6ab82205d0dd1dbb$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $6ab82205d0dd1dbb$var$_arrayLikeToArray(arr);
}
function $6ab82205d0dd1dbb$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $6ab82205d0dd1dbb$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $6ab82205d0dd1dbb$var$ownKeys(Object(source), !0).forEach(function(key) {
            $6ab82205d0dd1dbb$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $6ab82205d0dd1dbb$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $6ab82205d0dd1dbb$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $6ab82205d0dd1dbb$var$_slicedToArray(arr, i) {
    return $6ab82205d0dd1dbb$var$_arrayWithHoles(arr) || $6ab82205d0dd1dbb$var$_iterableToArrayLimit(arr, i) || $6ab82205d0dd1dbb$var$_unsupportedIterableToArray(arr, i) || $6ab82205d0dd1dbb$var$_nonIterableRest();
}
function $6ab82205d0dd1dbb$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $6ab82205d0dd1dbb$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $6ab82205d0dd1dbb$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $6ab82205d0dd1dbb$var$_arrayLikeToArray(o, minLen);
}
function $6ab82205d0dd1dbb$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $6ab82205d0dd1dbb$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $6ab82205d0dd1dbb$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
var $6ab82205d0dd1dbb$var$useGetActivityByKey = $hd4g0.hooks.useGetActivityByKey, $6ab82205d0dd1dbb$var$useReferenceGrammarID = $hd4g0.hooks.useReferenceGrammarID, $6ab82205d0dd1dbb$var$useStyleOptions = $hd4g0.hooks.useStyleOptions;
var $6ab82205d0dd1dbb$var$node_env = "production";
var $6ab82205d0dd1dbb$var$emotionPool = {};
function $6ab82205d0dd1dbb$var$styleSetToEmotionObjects(styleToEmotionObject, styleSet) {
    return (0, $6ab82205d0dd1dbb$var$_mapMap.default)(styleSet, function(style, key) {
        return key === "options" ? style : styleToEmotionObject(style);
    });
}
var $6ab82205d0dd1dbb$var$ComposerCore = function ComposerCore(_ref) {
    var children = _ref.children, extraStyleSet = _ref.extraStyleSet, nonce = _ref.nonce, renderMarkdown = _ref.renderMarkdown, styleSet = _ref.styleSet, suggestedActionsAccessKey = _ref.suggestedActionsAccessKey, webSpeechPonyfillFactory = _ref.webSpeechPonyfillFactory;
    var _useState = (0, $6ab82205d0dd1dbb$var$_react.useState)(), _useState2 = $6ab82205d0dd1dbb$var$_slicedToArray(_useState, 2), dictateAbortable = _useState2[0], setDictateAbortable = _useState2[1];
    var _useReferenceGrammarI = $6ab82205d0dd1dbb$var$useReferenceGrammarID(), _useReferenceGrammarI2 = $6ab82205d0dd1dbb$var$_slicedToArray(_useReferenceGrammarI, 1), referenceGrammarID = _useReferenceGrammarI2[0];
    var _useStyleOptions = $6ab82205d0dd1dbb$var$useStyleOptions(), _useStyleOptions2 = $6ab82205d0dd1dbb$var$_slicedToArray(_useStyleOptions, 1), styleOptions = _useStyleOptions2[0];
    var focusSendBoxCallbacksRef = (0, $6ab82205d0dd1dbb$var$_react.useRef)([]);
    var focusTranscriptCallbacksRef = (0, $6ab82205d0dd1dbb$var$_react.useRef)([]);
    var internalMarkdownIt = (0, $6ab82205d0dd1dbb$var$_react.useMemo)(function() {
        return new $6ab82205d0dd1dbb$var$_markdownIt.default();
    }, []);
    var scrollToCallbacksRef = (0, $6ab82205d0dd1dbb$var$_react.useRef)([]);
    var scrollToEndCallbacksRef = (0, $6ab82205d0dd1dbb$var$_react.useRef)([]); // Instead of having a `scrollUpCallbacksRef` and `scrollDownCallbacksRef`, they are combined into a single `scrollRelativeCallbacksRef`.
    // The first argument tells whether it should go "up" or "down".
    var scrollRelativeCallbacksRef = (0, $6ab82205d0dd1dbb$var$_react.useRef)([]);
    var dictationOnError = (0, $6ab82205d0dd1dbb$var$_react.useCallback)(function(err) {
        console.error(err);
    }, []);
    var internalRenderMarkdownInline = (0, $6ab82205d0dd1dbb$var$_react.useMemo)(function() {
        return function(markdown) {
            var tree = internalMarkdownIt.parseInline(markdown); // We should add rel="noopener noreferrer" and target="_blank"
            var patchedTree = (0, $6ab82205d0dd1dbb$var$_addTargetBlankToHyperlinksMarkdown.default)(tree);
            return internalMarkdownIt.renderer.render(patchedTree);
        };
    }, [
        internalMarkdownIt
    ]);
    var styleToEmotionObject = (0, $6ab82205d0dd1dbb$var$_react.useMemo)(function() {
        // Emotion doesn't hash with nonce. We need to provide the pooling mechanism.
        // 1. If 2 instances use different nonce, they should result in different hash;
        // 2. If 2 instances are being mounted, pooling will make sure we render only 1 set of <style> tags, instead of 2.
        var emotion = $6ab82205d0dd1dbb$var$emotionPool["id-".concat(nonce)] || ($6ab82205d0dd1dbb$var$emotionPool["id-".concat(nonce)] = (0, $6ab82205d0dd1dbb$var$_createInstance.default)({
            key: "webchat--css-".concat((0, $6ab82205d0dd1dbb$var$_createCSSKey.default)()),
            nonce: nonce
        }));
        return function(style) {
            return emotion.css(style);
        };
    }, [
        nonce
    ]);
    var patchedStyleSet = (0, $6ab82205d0dd1dbb$var$_react.useMemo)(function() {
        return $6ab82205d0dd1dbb$var$styleSetToEmotionObjects(styleToEmotionObject, $6ab82205d0dd1dbb$var$_objectSpread($6ab82205d0dd1dbb$var$_objectSpread({}, styleSet || (0, $6ab82205d0dd1dbb$var$_createStyleSet.default)(styleOptions)), extraStyleSet));
    }, [
        extraStyleSet,
        styleOptions,
        styleSet,
        styleToEmotionObject
    ]);
    var webSpeechPonyfill = (0, $6ab82205d0dd1dbb$var$_react.useMemo)(function() {
        var ponyfill = webSpeechPonyfillFactory && webSpeechPonyfillFactory({
            referenceGrammarID: referenceGrammarID
        });
        var _ref2 = ponyfill || {}, speechSynthesis = _ref2.speechSynthesis, SpeechSynthesisUtterance = _ref2.SpeechSynthesisUtterance;
        return $6ab82205d0dd1dbb$var$_objectSpread($6ab82205d0dd1dbb$var$_objectSpread({}, ponyfill), {}, {
            speechSynthesis: speechSynthesis || $dCjk2.speechSynthesis,
            SpeechSynthesisUtterance: SpeechSynthesisUtterance || $dCjk2.SpeechSynthesisUtterance
        });
    }, [
        referenceGrammarID,
        webSpeechPonyfillFactory
    ]);
    var scrollPositionObserversRef = (0, $6ab82205d0dd1dbb$var$_react.useRef)([]);
    var dispatchScrollPosition = (0, $6ab82205d0dd1dbb$var$_react.useCallback)(function(event) {
        return scrollPositionObserversRef.current.forEach(function(observer) {
            return observer(event);
        });
    }, [
        scrollPositionObserversRef
    ]);
    var observeScrollPosition = (0, $6ab82205d0dd1dbb$var$_react.useCallback)(function(observer) {
        scrollPositionObserversRef.current = [].concat($6ab82205d0dd1dbb$var$_toConsumableArray(scrollPositionObserversRef.current), [
            observer
        ]);
        return function() {
            scrollPositionObserversRef.current = scrollPositionObserversRef.current.filter(function(target) {
                return target !== observer;
            });
        };
    }, [
        scrollPositionObserversRef
    ]);
    var transcriptFocusObserversRef = (0, $6ab82205d0dd1dbb$var$_react.useRef)([]);
    var _useState3 = (0, $6ab82205d0dd1dbb$var$_react.useState)(0), _useState4 = $6ab82205d0dd1dbb$var$_slicedToArray(_useState3, 2), numTranscriptFocusObservers = _useState4[0], setNumTranscriptFocusObservers = _useState4[1];
    var getActivityByKey = $6ab82205d0dd1dbb$var$useGetActivityByKey();
    var dispatchTranscriptFocusByActivityKey = (0, $6ab82205d0dd1dbb$var$_react.useMemo)(function() {
        var prevActivityKey = Symbol();
        return function(activityKey) {
            if (activityKey !== prevActivityKey) {
                prevActivityKey = activityKey;
                var event = {
                    activity: getActivityByKey(activityKey)
                };
                transcriptFocusObserversRef.current.forEach(function(observer) {
                    return observer(event);
                });
            }
        };
    }, [
        getActivityByKey,
        transcriptFocusObserversRef
    ]);
    var observeTranscriptFocus = (0, $6ab82205d0dd1dbb$var$_react.useCallback)(function(observer) {
        transcriptFocusObserversRef.current = [].concat($6ab82205d0dd1dbb$var$_toConsumableArray(transcriptFocusObserversRef.current), [
            observer
        ]);
        setNumTranscriptFocusObservers(transcriptFocusObserversRef.current.length);
        return function() {
            transcriptFocusObserversRef.current = transcriptFocusObserversRef.current.filter(function(target) {
                return target !== observer;
            });
            setNumTranscriptFocusObservers(transcriptFocusObserversRef.current.length);
        };
    }, [
        transcriptFocusObserversRef,
        setNumTranscriptFocusObservers
    ]);
    var context = (0, $6ab82205d0dd1dbb$var$_react.useMemo)(function() {
        return {
            dictateAbortable: dictateAbortable,
            dispatchScrollPosition: dispatchScrollPosition,
            dispatchTranscriptFocusByActivityKey: dispatchTranscriptFocusByActivityKey,
            focusSendBoxCallbacksRef: focusSendBoxCallbacksRef,
            focusTranscriptCallbacksRef: focusTranscriptCallbacksRef,
            internalMarkdownItState: [
                internalMarkdownIt
            ],
            internalRenderMarkdownInline: internalRenderMarkdownInline,
            nonce: nonce,
            numTranscriptFocusObservers: numTranscriptFocusObservers,
            observeScrollPosition: observeScrollPosition,
            observeTranscriptFocus: observeTranscriptFocus,
            renderMarkdown: renderMarkdown,
            scrollRelativeCallbacksRef: scrollRelativeCallbacksRef,
            scrollToCallbacksRef: scrollToCallbacksRef,
            scrollToEndCallbacksRef: scrollToEndCallbacksRef,
            setDictateAbortable: setDictateAbortable,
            styleSet: patchedStyleSet,
            styleToEmotionObject: styleToEmotionObject,
            suggestedActionsAccessKey: suggestedActionsAccessKey,
            webSpeechPonyfill: webSpeechPonyfill
        };
    }, [
        dictateAbortable,
        dispatchScrollPosition,
        dispatchTranscriptFocusByActivityKey,
        focusSendBoxCallbacksRef,
        focusTranscriptCallbacksRef,
        internalMarkdownIt,
        internalRenderMarkdownInline,
        nonce,
        numTranscriptFocusObservers,
        observeScrollPosition,
        observeTranscriptFocus,
        patchedStyleSet,
        renderMarkdown,
        scrollRelativeCallbacksRef,
        scrollToCallbacksRef,
        scrollToEndCallbacksRef,
        setDictateAbortable,
        styleToEmotionObject,
        suggestedActionsAccessKey,
        webSpeechPonyfill
    ]);
    return /*#__PURE__*/ $6ab82205d0dd1dbb$var$_react.default.createElement($eM21L.Composer, {
        ponyfill: webSpeechPonyfill
    }, /*#__PURE__*/ $6ab82205d0dd1dbb$var$_react.default.createElement($6ab82205d0dd1dbb$var$_WebChatUIContext.default.Provider, {
        value: context
    }, /*#__PURE__*/ $6ab82205d0dd1dbb$var$_react.default.createElement($6ab82205d0dd1dbb$var$_SendBoxComposer.default, null, children, /*#__PURE__*/ $6ab82205d0dd1dbb$var$_react.default.createElement($6ab82205d0dd1dbb$var$_Dictation.default, {
        onError: dictationOnError
    }))));
};
$6ab82205d0dd1dbb$var$ComposerCore.defaultProps = {
    children: undefined,
    extraStyleSet: undefined,
    nonce: undefined,
    renderMarkdown: undefined,
    styleSet: undefined,
    suggestedActionsAccessKey: "A a \xc5 \xe5",
    webSpeechPonyfillFactory: undefined
};
$6ab82205d0dd1dbb$var$ComposerCore.propTypes = {
    extraStyleSet: $6ab82205d0dd1dbb$var$_propTypes.default.any,
    nonce: $6ab82205d0dd1dbb$var$_propTypes.default.string,
    renderMarkdown: $6ab82205d0dd1dbb$var$_propTypes.default.func,
    styleSet: $6ab82205d0dd1dbb$var$_propTypes.default.any,
    suggestedActionsAccessKey: $6ab82205d0dd1dbb$var$_propTypes.default.oneOfType([
        $6ab82205d0dd1dbb$var$_propTypes.default.oneOf([
            false
        ]),
        $6ab82205d0dd1dbb$var$_propTypes.default.string
    ]),
    webSpeechPonyfillFactory: $6ab82205d0dd1dbb$var$_propTypes.default.func
};
var $6ab82205d0dd1dbb$var$Composer = function Composer(_ref3) {
    var activityMiddleware = _ref3.activityMiddleware, activityStatusMiddleware = _ref3.activityStatusMiddleware, attachmentForScreenReaderMiddleware = _ref3.attachmentForScreenReaderMiddleware, attachmentMiddleware = _ref3.attachmentMiddleware, avatarMiddleware = _ref3.avatarMiddleware, cardActionMiddleware = _ref3.cardActionMiddleware, children = _ref3.children, extraStyleSet = _ref3.extraStyleSet, renderMarkdown = _ref3.renderMarkdown, scrollToEndButtonMiddleware = _ref3.scrollToEndButtonMiddleware, styleSet = _ref3.styleSet, suggestedActionsAccessKey = _ref3.suggestedActionsAccessKey, toastMiddleware = _ref3.toastMiddleware, typingIndicatorMiddleware = _ref3.typingIndicatorMiddleware, webSpeechPonyfillFactory = _ref3.webSpeechPonyfillFactory, composerProps = $6ab82205d0dd1dbb$var$_objectWithoutProperties(_ref3, $6ab82205d0dd1dbb$var$_excluded);
    var nonce = composerProps.nonce, onTelemetry = composerProps.onTelemetry;
    var patchedActivityMiddleware = (0, $6ab82205d0dd1dbb$var$_react.useMemo)(function() {
        return [].concat($6ab82205d0dd1dbb$var$_toConsumableArray((0, $cG9B9.singleToArray)(activityMiddleware)), $6ab82205d0dd1dbb$var$_toConsumableArray((0, $6ab82205d0dd1dbb$var$_createCoreMiddleware.default)()));
    }, [
        activityMiddleware
    ]);
    var patchedActivityStatusMiddleware = (0, $6ab82205d0dd1dbb$var$_react.useMemo)(function() {
        return [].concat($6ab82205d0dd1dbb$var$_toConsumableArray((0, $cG9B9.singleToArray)(activityStatusMiddleware)), $6ab82205d0dd1dbb$var$_toConsumableArray((0, $6ab82205d0dd1dbb$var$_createCoreMiddleware2.default)()));
    }, [
        activityStatusMiddleware
    ]);
    var patchedAttachmentForScreenReaderMiddleware = (0, $6ab82205d0dd1dbb$var$_react.useMemo)(function() {
        return [].concat($6ab82205d0dd1dbb$var$_toConsumableArray((0, $cG9B9.singleToArray)(attachmentForScreenReaderMiddleware)), $6ab82205d0dd1dbb$var$_toConsumableArray((0, $6ab82205d0dd1dbb$var$_createCoreMiddleware3.default)()));
    }, [
        attachmentForScreenReaderMiddleware
    ]);
    var patchedAttachmentMiddleware = (0, $6ab82205d0dd1dbb$var$_react.useMemo)(function() {
        return [].concat($6ab82205d0dd1dbb$var$_toConsumableArray((0, $cG9B9.singleToArray)(attachmentMiddleware)), $6ab82205d0dd1dbb$var$_toConsumableArray((0, $6ab82205d0dd1dbb$var$_createCoreMiddleware4.default)()));
    }, [
        attachmentMiddleware
    ]);
    var patchedAvatarMiddleware = (0, $6ab82205d0dd1dbb$var$_react.useMemo)(function() {
        return [].concat($6ab82205d0dd1dbb$var$_toConsumableArray((0, $cG9B9.singleToArray)(avatarMiddleware)), $6ab82205d0dd1dbb$var$_toConsumableArray((0, $6ab82205d0dd1dbb$var$_createCoreMiddleware5.default)()));
    }, [
        avatarMiddleware
    ]);
    var patchedCardActionMiddleware = (0, $6ab82205d0dd1dbb$var$_react.useMemo)(function() {
        return [].concat($6ab82205d0dd1dbb$var$_toConsumableArray((0, $cG9B9.singleToArray)(cardActionMiddleware)), $6ab82205d0dd1dbb$var$_toConsumableArray((0, $6ab82205d0dd1dbb$var$_createCoreMiddleware6.default)()));
    }, [
        cardActionMiddleware
    ]);
    var patchedToastMiddleware = (0, $6ab82205d0dd1dbb$var$_react.useMemo)(function() {
        return [].concat($6ab82205d0dd1dbb$var$_toConsumableArray((0, $cG9B9.singleToArray)(toastMiddleware)), $6ab82205d0dd1dbb$var$_toConsumableArray((0, $6ab82205d0dd1dbb$var$_createCoreMiddleware7.default)()));
    }, [
        toastMiddleware
    ]);
    var patchedTypingIndicatorMiddleware = (0, $6ab82205d0dd1dbb$var$_react.useMemo)(function() {
        return [].concat($6ab82205d0dd1dbb$var$_toConsumableArray((0, $cG9B9.singleToArray)(typingIndicatorMiddleware)), $6ab82205d0dd1dbb$var$_toConsumableArray((0, $6ab82205d0dd1dbb$var$_createCoreMiddleware8.default)()));
    }, [
        typingIndicatorMiddleware
    ]);
    var defaultScrollToEndButtonMiddleware = (0, $6ab82205d0dd1dbb$var$_react.useMemo)(function() {
        return (0, $6ab82205d0dd1dbb$var$_createScrollToEndButtonMiddleware.default)();
    }, []);
    var patchedScrollToEndButtonMiddleware = (0, $6ab82205d0dd1dbb$var$_react.useMemo)(function() {
        return [].concat($6ab82205d0dd1dbb$var$_toConsumableArray((0, $cG9B9.singleToArray)(scrollToEndButtonMiddleware)), $6ab82205d0dd1dbb$var$_toConsumableArray(defaultScrollToEndButtonMiddleware));
    }, [
        defaultScrollToEndButtonMiddleware,
        scrollToEndButtonMiddleware
    ]);
    return /*#__PURE__*/ $6ab82205d0dd1dbb$var$_react.default.createElement($6ab82205d0dd1dbb$var$_react.default.Fragment, null, /*#__PURE__*/ $6ab82205d0dd1dbb$var$_react.default.createElement($hd4g0.Composer, $6ab82205d0dd1dbb$var$_extends({
        activityMiddleware: patchedActivityMiddleware,
        activityStatusMiddleware: patchedActivityStatusMiddleware,
        attachmentForScreenReaderMiddleware: patchedAttachmentForScreenReaderMiddleware,
        attachmentMiddleware: patchedAttachmentMiddleware,
        avatarMiddleware: patchedAvatarMiddleware,
        cardActionMiddleware: patchedCardActionMiddleware,
        downscaleImageToDataURL: $6ab82205d0dd1dbb$var$_downscaleImageToDataURL.default // Under dev server of create-react-app, "NODE_ENV" will be set to "development".
        ,
        internalErrorBoxClass: $6ab82205d0dd1dbb$var$node_env === "development" ? $6ab82205d0dd1dbb$var$_ErrorBox.default : undefined,
        nonce: nonce,
        scrollToEndButtonMiddleware: patchedScrollToEndButtonMiddleware,
        toastMiddleware: patchedToastMiddleware,
        typingIndicatorMiddleware: patchedTypingIndicatorMiddleware
    }, composerProps), /*#__PURE__*/ $6ab82205d0dd1dbb$var$_react.default.createElement($6ab82205d0dd1dbb$var$_ActivityTreeComposer.default, null, /*#__PURE__*/ $6ab82205d0dd1dbb$var$_react.default.createElement($6ab82205d0dd1dbb$var$ComposerCore, {
        extraStyleSet: extraStyleSet,
        nonce: nonce,
        renderMarkdown: renderMarkdown,
        styleSet: styleSet,
        suggestedActionsAccessKey: suggestedActionsAccessKey,
        webSpeechPonyfillFactory: webSpeechPonyfillFactory
    }, children, onTelemetry && /*#__PURE__*/ $6ab82205d0dd1dbb$var$_react.default.createElement($6ab82205d0dd1dbb$var$_UITracker.default, null)))));
};
$6ab82205d0dd1dbb$var$Composer.defaultProps = $6ab82205d0dd1dbb$var$_objectSpread($6ab82205d0dd1dbb$var$_objectSpread($6ab82205d0dd1dbb$var$_objectSpread({}, $hd4g0.Composer.defaultProps), $6ab82205d0dd1dbb$var$ComposerCore.defaultProps), {}, {
    children: undefined
});
$6ab82205d0dd1dbb$var$Composer.propTypes = $6ab82205d0dd1dbb$var$_objectSpread($6ab82205d0dd1dbb$var$_objectSpread($6ab82205d0dd1dbb$var$_objectSpread({}, $hd4g0.Composer.propTypes), $6ab82205d0dd1dbb$var$ComposerCore.propTypes), {}, {
    children: $6ab82205d0dd1dbb$var$_propTypes.default.any
});
var $6ab82205d0dd1dbb$var$_default = $6ab82205d0dd1dbb$var$Composer;
module.exports.default = $6ab82205d0dd1dbb$var$_default;

});
parcelRequire.register("1MGBN", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $14cb53512edde7de$var$createStyleSet;

var $hd4g0 = parcelRequire("hd4g0");

var $14cb53512edde7de$var$_Activities = $14cb53512edde7de$var$_interopRequireDefault((parcelRequire("hKHzE")));

var $14cb53512edde7de$var$_AudioAttachment = $14cb53512edde7de$var$_interopRequireDefault((parcelRequire("84iJu")));

var $14cb53512edde7de$var$_AudioContent = $14cb53512edde7de$var$_interopRequireDefault((parcelRequire("e3pnT")));

var $14cb53512edde7de$var$_AutoResizeTextArea = $14cb53512edde7de$var$_interopRequireDefault((parcelRequire("aLCwL")));

var $14cb53512edde7de$var$_Avatar = $14cb53512edde7de$var$_interopRequireDefault((parcelRequire("eBOEW")));

var $14cb53512edde7de$var$_BasicTranscript = $14cb53512edde7de$var$_interopRequireDefault((parcelRequire("bjrGC")));

var $14cb53512edde7de$var$_Bubble = $14cb53512edde7de$var$_interopRequireDefault((parcelRequire("grPpN")));

var $14cb53512edde7de$var$_CarouselFilmStrip = $14cb53512edde7de$var$_interopRequireDefault((parcelRequire("wBQrJ")));

var $14cb53512edde7de$var$_CarouselFilmStripAttachment = $14cb53512edde7de$var$_interopRequireDefault((parcelRequire("kiOUK")));

var $14cb53512edde7de$var$_CarouselFlipper = $14cb53512edde7de$var$_interopRequireDefault((parcelRequire("4QutZ")));

var $14cb53512edde7de$var$_ConnectivityNotification = $14cb53512edde7de$var$_interopRequireDefault((parcelRequire("jHv1y")));

var $14cb53512edde7de$var$_DictationInterims = $14cb53512edde7de$var$_interopRequireDefault((parcelRequire("iVL0X")));

var $14cb53512edde7de$var$_ErrorBox = $14cb53512edde7de$var$_interopRequireDefault((parcelRequire("hCSaA")));

var $14cb53512edde7de$var$_ErrorNotification = $14cb53512edde7de$var$_interopRequireDefault((parcelRequire("fLWPS")));

var $14cb53512edde7de$var$_FileContent = $14cb53512edde7de$var$_interopRequireDefault((parcelRequire("daObx")));

var $14cb53512edde7de$var$_ImageAvatar = $14cb53512edde7de$var$_interopRequireDefault((parcelRequire("i6DLC")));

var $14cb53512edde7de$var$_InitialsAvatar = $14cb53512edde7de$var$_interopRequireDefault((parcelRequire("7nRoA")));

var $14cb53512edde7de$var$_KeyboardHelp = $14cb53512edde7de$var$_interopRequireDefault((parcelRequire("d6jMs")));

var $14cb53512edde7de$var$_MicrophoneButton = $14cb53512edde7de$var$_interopRequireDefault((parcelRequire("6dTtF")));

var $14cb53512edde7de$var$_Root = $14cb53512edde7de$var$_interopRequireDefault((parcelRequire("5ql4l")));

var $14cb53512edde7de$var$_ScrollToEndButton = $14cb53512edde7de$var$_interopRequireDefault((parcelRequire("3I5mu")));

var $14cb53512edde7de$var$_SendBoxButton = $14cb53512edde7de$var$_interopRequireDefault((parcelRequire("giOHK")));

var $14cb53512edde7de$var$_SendBox = $14cb53512edde7de$var$_interopRequireDefault((parcelRequire("9blwk")));

var $14cb53512edde7de$var$_SendBoxTextBox = $14cb53512edde7de$var$_interopRequireDefault((parcelRequire("arpvQ")));

var $14cb53512edde7de$var$_SendStatus = $14cb53512edde7de$var$_interopRequireDefault((parcelRequire("e9qsg")));

var $14cb53512edde7de$var$_SingleAttachmentActivity = $14cb53512edde7de$var$_interopRequireDefault((parcelRequire("23DGM")));

var $14cb53512edde7de$var$_SpinnerAnimation = $14cb53512edde7de$var$_interopRequireDefault((parcelRequire("3WZQg")));

var $14cb53512edde7de$var$_StackedLayout = $14cb53512edde7de$var$_interopRequireDefault((parcelRequire("bJzWc")));

var $14cb53512edde7de$var$_SuggestedActions = $14cb53512edde7de$var$_interopRequireDefault((parcelRequire("g9Ltl")));

var $14cb53512edde7de$var$_SuggestedAction = $14cb53512edde7de$var$_interopRequireDefault((parcelRequire("1TzUA")));

var $14cb53512edde7de$var$_TextContent = $14cb53512edde7de$var$_interopRequireDefault((parcelRequire("bRKbk")));

var $14cb53512edde7de$var$_Toaster = $14cb53512edde7de$var$_interopRequireDefault((parcelRequire("eYqQ3")));

var $14cb53512edde7de$var$_Toast = $14cb53512edde7de$var$_interopRequireDefault((parcelRequire("kDxZF")));

var $14cb53512edde7de$var$_TypingAnimation = $14cb53512edde7de$var$_interopRequireDefault((parcelRequire("hhCgR")));

var $14cb53512edde7de$var$_TypingIndicator = $14cb53512edde7de$var$_interopRequireDefault((parcelRequire("2071W")));

var $14cb53512edde7de$var$_UploadButton = $14cb53512edde7de$var$_interopRequireDefault((parcelRequire("9KiNF")));

var $14cb53512edde7de$var$_VideoAttachment = $14cb53512edde7de$var$_interopRequireDefault((parcelRequire("8Vfqu")));

var $14cb53512edde7de$var$_VideoContent = $14cb53512edde7de$var$_interopRequireDefault((parcelRequire("5LQLQ")));

var $14cb53512edde7de$var$_VimeoContent = $14cb53512edde7de$var$_interopRequireDefault((parcelRequire("33ges")));

var $14cb53512edde7de$var$_WarningNotification = $14cb53512edde7de$var$_interopRequireDefault((parcelRequire("a6rCV")));

var $14cb53512edde7de$var$_YouTubeContent = $14cb53512edde7de$var$_interopRequireDefault((parcelRequire("8lnyc")));
function $14cb53512edde7de$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $14cb53512edde7de$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $14cb53512edde7de$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $14cb53512edde7de$var$ownKeys(Object(source), !0).forEach(function(key) {
            $14cb53512edde7de$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $14cb53512edde7de$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $14cb53512edde7de$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
// TODO: [P4] We should add a notice for people who want to use "styleSet" instead of "styleOptions".
//       "styleSet" is actually CSS stylesheet and it is based on the DOM tree.
//       DOM tree may change from time to time, thus, maintaining "styleSet" becomes a constant effort.
function $14cb53512edde7de$var$createStyleSet(styleOptions) {
    var strictStyleOptions = (0, $hd4g0.normalizeStyleOptions)(styleOptions);
    return {
        activities: (0, $14cb53512edde7de$var$_Activities.default)(),
        audioAttachment: (0, $14cb53512edde7de$var$_AudioAttachment.default)(strictStyleOptions),
        audioContent: (0, $14cb53512edde7de$var$_AudioContent.default)(),
        autoResizeTextArea: (0, $14cb53512edde7de$var$_AutoResizeTextArea.default)(strictStyleOptions),
        avatar: (0, $14cb53512edde7de$var$_Avatar.default)(strictStyleOptions),
        basicTranscript: (0, $14cb53512edde7de$var$_BasicTranscript.default)(strictStyleOptions),
        bubble: (0, $14cb53512edde7de$var$_Bubble.default)(strictStyleOptions),
        carouselFilmStrip: (0, $14cb53512edde7de$var$_CarouselFilmStrip.default)(strictStyleOptions),
        carouselFilmStripAttachment: (0, $14cb53512edde7de$var$_CarouselFilmStripAttachment.default)(strictStyleOptions),
        carouselFlipper: (0, $14cb53512edde7de$var$_CarouselFlipper.default)(strictStyleOptions),
        connectivityNotification: (0, $14cb53512edde7de$var$_ConnectivityNotification.default)(strictStyleOptions),
        dictationInterims: (0, $14cb53512edde7de$var$_DictationInterims.default)(strictStyleOptions),
        errorBox: (0, $14cb53512edde7de$var$_ErrorBox.default)(strictStyleOptions),
        errorNotification: (0, $14cb53512edde7de$var$_ErrorNotification.default)(strictStyleOptions),
        fileContent: (0, $14cb53512edde7de$var$_FileContent.default)(strictStyleOptions),
        imageAvatar: (0, $14cb53512edde7de$var$_ImageAvatar.default)(strictStyleOptions),
        initialsAvatar: (0, $14cb53512edde7de$var$_InitialsAvatar.default)(strictStyleOptions),
        keyboardHelp: (0, $14cb53512edde7de$var$_KeyboardHelp.default)(strictStyleOptions),
        microphoneButton: (0, $14cb53512edde7de$var$_MicrophoneButton.default)(strictStyleOptions),
        options: $14cb53512edde7de$var$_objectSpread({}, strictStyleOptions),
        // Cloned to make sure no additional modifications will propagate up.
        root: (0, $14cb53512edde7de$var$_Root.default)(strictStyleOptions),
        scrollToEndButton: (0, $14cb53512edde7de$var$_ScrollToEndButton.default)(strictStyleOptions),
        sendBox: (0, $14cb53512edde7de$var$_SendBox.default)(strictStyleOptions),
        sendBoxButton: (0, $14cb53512edde7de$var$_SendBoxButton.default)(strictStyleOptions),
        sendBoxTextBox: (0, $14cb53512edde7de$var$_SendBoxTextBox.default)(strictStyleOptions),
        sendStatus: (0, $14cb53512edde7de$var$_SendStatus.default)(strictStyleOptions),
        singleAttachmentActivity: (0, $14cb53512edde7de$var$_SingleAttachmentActivity.default)(strictStyleOptions),
        spinnerAnimation: (0, $14cb53512edde7de$var$_SpinnerAnimation.default)(strictStyleOptions),
        stackedLayout: (0, $14cb53512edde7de$var$_StackedLayout.default)(strictStyleOptions),
        suggestedAction: (0, $14cb53512edde7de$var$_SuggestedAction.default)(strictStyleOptions),
        suggestedActions: (0, $14cb53512edde7de$var$_SuggestedActions.default)(strictStyleOptions),
        textContent: (0, $14cb53512edde7de$var$_TextContent.default)(strictStyleOptions),
        toast: (0, $14cb53512edde7de$var$_Toast.default)(strictStyleOptions),
        toaster: (0, $14cb53512edde7de$var$_Toaster.default)(strictStyleOptions),
        typingAnimation: (0, $14cb53512edde7de$var$_TypingAnimation.default)(strictStyleOptions),
        typingIndicator: (0, $14cb53512edde7de$var$_TypingIndicator.default)(strictStyleOptions),
        uploadButton: (0, $14cb53512edde7de$var$_UploadButton.default)(strictStyleOptions),
        videoAttachment: (0, $14cb53512edde7de$var$_VideoAttachment.default)(),
        videoContent: (0, $14cb53512edde7de$var$_VideoContent.default)(strictStyleOptions),
        vimeoContent: (0, $14cb53512edde7de$var$_VimeoContent.default)(strictStyleOptions),
        warningNotification: (0, $14cb53512edde7de$var$_WarningNotification.default)(strictStyleOptions),
        youTubeContent: (0, $14cb53512edde7de$var$_YouTubeContent.default)(strictStyleOptions)
    };
}

});
parcelRequire.register("hKHzE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $cec88870ac0baaa5$var$createActivitiesStyle;
function $cec88870ac0baaa5$var$createActivitiesStyle() {
    return {
        margin: 0,
        padding: 0
    };
}

});

parcelRequire.register("84iJu", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $5dfd3a5d0c84d08f$var$AudioAttachment;
function $5dfd3a5d0c84d08f$var$AudioAttachment(_ref) {
    var avatarSize = _ref.avatarSize;
    return {
        // TODO: [P2] We should not set "display" in styleSet, this will allow the user to break the layout for no good reasons.
        display: "flex",
        minHeight: avatarSize
    };
}

});

parcelRequire.register("e3pnT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $a3b5094c246b0a4f$var$AudioContent;
function $a3b5094c246b0a4f$var$AudioContent() {
    return {
        width: "100%"
    };
}

});

parcelRequire.register("aLCwL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $7d6c2ded61aea887$var$AutoResizeTextArea;
function $7d6c2ded61aea887$var$AutoResizeTextArea(_ref) {
    var primaryFont = _ref.primaryFont;
    return {
        "&.webchat__auto-resize-textarea": {
            fontFamily: primaryFont,
            overflow: "hidden",
            position: "relative",
            "& .webchat__auto-resize-textarea__doppelganger": {
                color: "transparent",
                height: "100%",
                overflowY: "auto",
                userSelect: "none",
                width: "inherit",
                whiteSpace: "pre-wrap",
                wordBreak: "break-word"
            },
            "& .webchat__auto-resize-textarea__textarea": {
                appearance: "none",
                backgroundColor: "transparent",
                border: 0,
                color: "inherit",
                fontFamily: "inherit",
                fontSize: "inherit",
                height: "100%",
                left: 0,
                margin: 0,
                outline: 0,
                overflowY: "auto",
                padding: 0,
                position: "absolute",
                resize: "none",
                top: 0,
                width: "100%",
                wordBreak: "break-word"
            }
        }
    };
}

});

parcelRequire.register("eBOEW", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $aa2bd14491a2eaa0$var$createAvatarStyle;
function $aa2bd14491a2eaa0$var$createAvatarStyle(_ref) {
    var avatarBorderRadius = _ref.avatarBorderRadius, avatarSize = _ref.avatarSize;
    return {
        "&.webchat__defaultAvatar": {
            borderRadius: avatarBorderRadius,
            height: avatarSize,
            width: avatarSize
        }
    };
}

});

parcelRequire.register("bjrGC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $83c6f1fab17f30fa$var$createBasicTranscriptStyleSet;
/* eslint no-magic-numbers: ["error", { "ignore": [2] }] */ function $83c6f1fab17f30fa$var$createBasicTranscriptStyleSet(_ref) {
    var paddingRegular = _ref.paddingRegular, primaryFont = _ref.primaryFont, transcriptActivityVisualKeyboardIndicatorColor = _ref.transcriptActivityVisualKeyboardIndicatorColor, transcriptActivityVisualKeyboardIndicatorStyle = _ref.transcriptActivityVisualKeyboardIndicatorStyle, transcriptActivityVisualKeyboardIndicatorWidth = _ref.transcriptActivityVisualKeyboardIndicatorWidth, transcriptTerminatorBackgroundColor = _ref.transcriptTerminatorBackgroundColor, transcriptTerminatorBorderRadius = _ref.transcriptTerminatorBorderRadius, transcriptTerminatorColor = _ref.transcriptTerminatorColor, transcriptTerminatorFontSize = _ref.transcriptTerminatorFontSize, transcriptVisualKeyboardIndicatorColor = _ref.transcriptVisualKeyboardIndicatorColor, transcriptVisualKeyboardIndicatorStyle = _ref.transcriptVisualKeyboardIndicatorStyle, transcriptVisualKeyboardIndicatorWidth = _ref.transcriptVisualKeyboardIndicatorWidth;
    return {
        "&.webchat__basic-transcript": {
            "&:focus": {
                outline: 0,
                "& .webchat__basic-transcript__activity-indicator.webchat__basic-transcript__activity-indicator--focus": {
                    borderColor: transcriptActivityVisualKeyboardIndicatorColor,
                    borderStyle: transcriptActivityVisualKeyboardIndicatorStyle,
                    borderWidth: transcriptActivityVisualKeyboardIndicatorWidth,
                    boxSizing: "border-box",
                    height: "calc(100% - ".concat(paddingRegular / 2, "px)"),
                    left: 0,
                    marginBottom: 0,
                    marginLeft: paddingRegular / 2,
                    marginRight: paddingRegular / 2,
                    marginTop: 0,
                    pointerEvents: "none",
                    position: "absolute",
                    top: 0,
                    width: "calc(100% - ".concat(paddingRegular, "px)")
                }
            },
            "&:focus .webchat__basic-transcript__focus-indicator, .webchat__basic-transcript__terminator:focus + .webchat__basic-transcript__focus-indicator": {
                height: "100%",
                borderColor: transcriptVisualKeyboardIndicatorColor,
                borderStyle: transcriptVisualKeyboardIndicatorStyle,
                borderWidth: transcriptVisualKeyboardIndicatorWidth,
                boxSizing: "border-box",
                pointerEvents: "none",
                position: "absolute",
                top: 0,
                width: "100%"
            },
            "& .webchat__basic-transcript__activity": {
                paddingTop: paddingRegular / 2,
                position: "relative",
                "&:first-child": {
                    marginTop: paddingRegular / 2
                },
                "&:not(:first-child)": {
                    marginTop: -paddingRegular / 2
                }
            },
            // When the activity is focused as active descendant, `scrollIntoView()` will scroll this invisible <div> into view.
            "& .webchat__basic-transcript__activity-active-descendant": {
                height: "100%",
                left: 0,
                marginTop: -paddingRegular / 2,
                paddingBottom: paddingRegular / 2,
                // The bounding box is expanded to both top and bottom to scroll focus indicator into view.
                // We should ignore clicks to make sure this expansion don't register click as focus.
                // Otherwise, when clicking on the very bottom edge of the activity, it will focus on next activity instead.
                pointerEvents: "none",
                position: "absolute",
                top: 0,
                width: "100%"
            },
            "& .webchat__basic-transcript__activity-body:not(:empty)": {
                paddingBottom: paddingRegular
            },
            "& .webchat__basic-transcript__terminator": {
                bottom: 0,
                height: 0,
                outline: 0,
                position: "relative",
                width: "100%"
            },
            "& .webchat__basic-transcript__terminator-body": {
                bottom: 0,
                display: "flex",
                justifyContent: "center",
                position: "absolute",
                width: "100%"
            },
            "& .webchat__basic-transcript__terminator:not(:focus) .webchat__basic-transcript__terminator-body": {
                display: "none"
            },
            "& .webchat__basic-transcript__terminator-text": {
                backgroundColor: transcriptTerminatorBackgroundColor,
                borderRadius: transcriptTerminatorBorderRadius,
                color: transcriptTerminatorColor,
                fontFamily: primaryFont,
                fontSize: transcriptTerminatorFontSize,
                margin: paddingRegular / 2,
                padding: paddingRegular / 2
            }
        }
    };
}

});

parcelRequire.register("grPpN", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $bf970ce6a5c1897f$var$createBubbleStyle;

var $bf970ce6a5c1897f$var$_mirrorStyle = $bf970ce6a5c1897f$var$_interopRequireDefault((parcelRequire("gp1rj")));
function $bf970ce6a5c1897f$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $bf970ce6a5c1897f$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $bf970ce6a5c1897f$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $bf970ce6a5c1897f$var$ownKeys(Object(source), !0).forEach(function(key) {
            $bf970ce6a5c1897f$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $bf970ce6a5c1897f$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $bf970ce6a5c1897f$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $bf970ce6a5c1897f$var$createBubbleStyle(_ref) {
    var bubbleBackground = _ref.bubbleBackground, bubbleBorderColor = _ref.bubbleBorderColor, bubbleBorderRadius = _ref.bubbleBorderRadius, bubbleBorderStyle = _ref.bubbleBorderStyle, bubbleBorderWidth = _ref.bubbleBorderWidth, bubbleFromUserBackground = _ref.bubbleFromUserBackground, bubbleFromUserBorderColor = _ref.bubbleFromUserBorderColor, bubbleFromUserBorderRadius = _ref.bubbleFromUserBorderRadius, bubbleFromUserBorderStyle = _ref.bubbleFromUserBorderStyle, bubbleFromUserBorderWidth = _ref.bubbleFromUserBorderWidth, bubbleFromUserNubOffset = _ref.bubbleFromUserNubOffset, bubbleFromUserNubSize = _ref.bubbleFromUserNubSize, bubbleFromUserTextColor = _ref.bubbleFromUserTextColor, bubbleMinHeight = _ref.bubbleMinHeight, bubbleNubOffset = _ref.bubbleNubOffset, bubbleNubSize = _ref.bubbleNubSize, bubbleTextColor = _ref.bubbleTextColor, messageActivityWordBreak = _ref.messageActivityWordBreak, paddingRegular = _ref.paddingRegular, transitionDuration = _ref.transitionDuration;
    var botNubCornerRadius = typeof bubbleNubOffset === "number" ? Math.min(bubbleBorderRadius, Math.abs(bubbleNubOffset)) : bubbleBorderRadius;
    var userNubCornerRadius = typeof bubbleFromUserNubOffset === "number" ? Math.min(bubbleFromUserBorderRadius, Math.abs(bubbleFromUserNubOffset)) : bubbleFromUserBorderRadius;
    return {
        "&.webchat__bubble": $bf970ce6a5c1897f$var$_objectSpread({
            "& .webchat__bubble__content": {
                marginLeft: 0,
                marginRight: 0,
                transitionDuration: transitionDuration,
                transitionProperty: "margin-left, margin-right",
                wordBreak: messageActivityWordBreak
            },
            "& .webchat__bubble__nub": {
                overflow: "hidden",
                // This style is for IE11 because it doesn't respect SVG viewport
                position: "absolute"
            },
            "& .webchat__bubble__nub-pad": {
                transitionDuration: transitionDuration,
                transitionProperty: "width",
                width: 0
            },
            "&.webchat__bubble--hide-nub, &.webchat__bubble--show-nub": {
                "& .webchat__bubble__nub-pad": {
                    width: paddingRegular
                }
            },
            "&.webchat__bubble--rtl .webchat__bubble__nub": {
                transform: "scale(-1, 1)"
            },
            "&:not(.webchat__bubble--from-user)": $bf970ce6a5c1897f$var$_objectSpread($bf970ce6a5c1897f$var$_objectSpread({
                "& .webchat__bubble__content": {
                    background: bubbleBackground,
                    borderColor: bubbleBorderColor,
                    borderRadius: bubbleBorderRadius,
                    borderStyle: bubbleBorderStyle,
                    borderWidth: bubbleBorderWidth,
                    color: bubbleTextColor,
                    minHeight: bubbleMinHeight - bubbleBorderWidth * 2
                }
            }, typeof bubbleNubSize === "number" ? {
                "& .webchat__bubble__nub": {
                    height: bubbleNubSize,
                    width: bubbleNubSize
                }
            } : {}), {}, {
                "&:not(.webchat__bubble--nub-on-top) .webchat__bubble__nub": {
                    bottom: -bubbleNubOffset
                },
                "&.webchat__bubble--nub-on-top .webchat__bubble__nub": {
                    top: bubbleNubOffset
                },
                "& .webchat__bubble__nub-outline": {
                    fill: bubbleBackground,
                    stroke: bubbleBorderColor,
                    strokeWidth: bubbleBorderWidth
                }
            }),
            "&.webchat__bubble--from-user": $bf970ce6a5c1897f$var$_objectSpread($bf970ce6a5c1897f$var$_objectSpread({
                flexDirection: "row-reverse",
                "& .webchat__bubble__content": {
                    background: bubbleFromUserBackground,
                    borderColor: bubbleFromUserBorderColor,
                    borderRadius: bubbleFromUserBorderRadius,
                    borderStyle: bubbleFromUserBorderStyle,
                    borderWidth: bubbleFromUserBorderWidth,
                    color: bubbleFromUserTextColor,
                    minHeight: bubbleMinHeight - bubbleFromUserBorderWidth * 2
                }
            }, typeof bubbleFromUserNubSize === "number" ? {
                "& .webchat__bubble__nub": {
                    height: bubbleFromUserNubSize,
                    width: bubbleFromUserNubSize
                }
            } : {}), {}, {
                "&:not(.webchat__bubble--nub-on-top) .webchat__bubble__nub": {
                    bottom: -bubbleFromUserNubOffset
                },
                "&.webchat__bubble--nub-on-top .webchat__bubble__nub": {
                    top: bubbleFromUserNubOffset
                },
                "& .webchat__bubble__nub-outline": {
                    fill: bubbleFromUserBackground,
                    stroke: bubbleFromUserBorderColor,
                    strokeWidth: bubbleFromUserBorderWidth
                }
            })
        }, (0, $bf970ce6a5c1897f$var$_mirrorStyle.default)("&.webchat__bubble--rtl", {
            "&:not(.webchat__bubble--from-user)": $bf970ce6a5c1897f$var$_objectSpread({
                "&.webchat__bubble--show-nub": {
                    // Hide border radius if there is a nub on the top/bottom left corner
                    "&:not(.webchat__bubble--nub-on-top) .webchat__bubble__content": {
                        borderBottomLeftRadius: botNubCornerRadius
                    },
                    "&.webchat__bubble--nub-on-top .webchat__bubble__content": {
                        borderTopLeftRadius: botNubCornerRadius
                    }
                }
            }, typeof bubbleNubSize === "number" ? {
                "& .webchat__bubble__nub": {
                    left: bubbleBorderWidth - bubbleNubSize + paddingRegular
                }
            } : {}),
            "&.webchat__bubble--from-user": $bf970ce6a5c1897f$var$_objectSpread({
                "&.webchat__bubble--show-nub": {
                    // Hide border radius if there is a nub on the top/bottom right corner
                    "&:not(.webchat__bubble--nub-on-top) .webchat__bubble__content": {
                        borderBottomRightRadius: userNubCornerRadius
                    },
                    "&.webchat__bubble--nub-on-top .webchat__bubble__content": {
                        borderTopRightRadius: userNubCornerRadius
                    }
                }
            }, typeof bubbleFromUserNubSize === "number" ? {
                "& .webchat__bubble__nub": {
                    right: bubbleFromUserBorderWidth - bubbleFromUserNubSize + paddingRegular
                }
            } : {})
        }))
    };
}

});
parcelRequire.register("gp1rj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $bf1018fee55c4c19$var$mirrorStyle;

var $cG9B9 = parcelRequire("cG9B9");
function $bf1018fee55c4c19$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $bf1018fee55c4c19$var$_slicedToArray(arr, i) {
    return $bf1018fee55c4c19$var$_arrayWithHoles(arr) || $bf1018fee55c4c19$var$_iterableToArrayLimit(arr, i) || $bf1018fee55c4c19$var$_unsupportedIterableToArray(arr, i) || $bf1018fee55c4c19$var$_nonIterableRest();
}
function $bf1018fee55c4c19$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $bf1018fee55c4c19$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $bf1018fee55c4c19$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $bf1018fee55c4c19$var$_arrayLikeToArray(o, minLen);
}
function $bf1018fee55c4c19$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $bf1018fee55c4c19$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $bf1018fee55c4c19$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $bf1018fee55c4c19$var$mirrorStyle(mirrorSelector, styles) {
    var _ref;
    var mirrored = {};
    for(var _i = 0, _Object$entries = Object.entries(styles); _i < _Object$entries.length; _i++){
        var _Object$entries$_i = $bf1018fee55c4c19$var$_slicedToArray(_Object$entries[_i], 2), key = _Object$entries$_i[0], value = _Object$entries$_i[1];
        if (typeof value === "number" || typeof value === "string") {
            var patchedKey = key.replace(/(^left|^right|Left|Right)/, function(match) {
                return match === "Left" ? "Right" : match === "left" ? "right" : match === "Right" ? "Left" : "left";
            });
            if (!(0, $cG9B9.isForbiddenPropertyName)(patchedKey)) // Mitigated through denylisting.
            // eslint-disable-next-line security/detect-object-injection
            mirrored[patchedKey] = value;
        } else if (!(0, $cG9B9.isForbiddenPropertyName)(key)) // Mitigated through denylisting.
        // eslint-disable-next-line security/detect-object-injection
        mirrored[key] = $bf1018fee55c4c19$var$mirrorStyle("", value);
    }
    var relative = /^&[\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]*/g.exec(mirrorSelector) || "";
    return mirrorSelector ? (_ref = {}, $bf1018fee55c4c19$var$_defineProperty(_ref, "".concat(relative, ":not(").concat(mirrorSelector.substr(relative.length), ")"), styles), $bf1018fee55c4c19$var$_defineProperty(_ref, mirrorSelector, mirrored), _ref) : mirrored;
}

});


parcelRequire.register("wBQrJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $0620587bcb227790$var$CarouselFilmStrip;

var $0620587bcb227790$var$_mirrorStyle = $0620587bcb227790$var$_interopRequireDefault((parcelRequire("gp1rj")));
function $0620587bcb227790$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $0620587bcb227790$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $0620587bcb227790$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $0620587bcb227790$var$ownKeys(Object(source), !0).forEach(function(key) {
            $0620587bcb227790$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $0620587bcb227790$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $0620587bcb227790$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $0620587bcb227790$var$CarouselFilmStrip(_ref) {
    var avatarSize = _ref.avatarSize, bubbleMaxWidth = _ref.bubbleMaxWidth, paddingRegular = _ref.paddingRegular, transitionDuration = _ref.transitionDuration;
    return {
        "&.webchat__carousel-filmstrip": $0620587bcb227790$var$_objectSpread({
            // Browser quirks: Firefox has no way to hide scrollbar and while keeping it in function
            // https://developer.mozilla.org/en-US/docs/Web/CSS/overflow
            "@supports (-moz-appearance: none)": {
                marginBottom: -17
            },
            "& .webchat__carousel-filmstrip__message": {
                maxWidth: bubbleMaxWidth,
                transitionDuration: transitionDuration,
                transitionProperty: "max-width"
            },
            "&.webchat__carousel-filmstrip--hide-nub, &.webchat__carousel-filmstrip--show-nub, &.webchat__carousel-filmstrip--hide-avatar, &.webchat__carousel-filmstrip--show-avatar": {
                "& .webchat__carousel-filmstrip__message": {
                    maxWidth: bubbleMaxWidth + paddingRegular
                }
            },
            "& .webchat__carousel-filmstrip__alignment-pad": {
                transitionDuration: transitionDuration,
                transitionProperty: "width",
                width: paddingRegular
            },
            "&.webchat__carousel-filmstrip--extra-trailing .webchat__carousel-filmstrip__alignment-pad": {
                width: paddingRegular * 2
            },
            "&:not(.webchat__carousel-filmstrip--no-message) .webchat__carousel-filmstrip__attachments": {
                marginTop: paddingRegular
            },
            "& .webchat__carousel-filmstrip__avatar-gutter": {
                alignItems: "flex-end",
                transitionDuration: transitionDuration,
                transitionProperty: "width"
            },
            "& .webchat__carousel-filmstrip__nub-pad": {
                transitionDuration: transitionDuration,
                transitionProperty: "width",
                width: 0
            },
            "&.webchat__carousel-filmstrip--hide-avatar, &.webchat__carousel-filmstrip--show-avatar": {
                "& .webchat__carousel-filmstrip__avatar-gutter": {
                    width: avatarSize
                }
            },
            "&.webchat__carousel-filmstrip--hide-avatar, &.webchat__carousel-filmstrip--show-avatar, &.webchat__carousel-filmstrip--hide-nub, &.webchat__carousel-filmstrip--show-nub": {
                "& .webchat__carousel-filmstrip__nub-pad": {
                    width: paddingRegular
                }
            },
            "&:not(.webchat__carousel-filmstrip--top-callout) .webchat__carousel-filmstrip__avatar-gutter": {
                justifyContent: "flex-end"
            }
        }, (0, $0620587bcb227790$var$_mirrorStyle.default)("&.webchat__carousel-filmstrip--rtl", {
            "& .webchat__carousel-filmstrip__avatar-gutter": {
                marginLeft: paddingRegular
            },
            "& .webchat__carousel-filmstrip__attachments": {
                marginLeft: -paddingRegular
            },
            "&.webchat__carousel-filmstrip--hide-avatar, &.webchat__carousel-filmstrip--show-avatar": {
                "& .webchat__carousel-filmstrip__attachments": {
                    marginLeft: -(avatarSize + paddingRegular * 2)
                }
            },
            "&.webchat__carousel-filmstrip--hide-nub, &.webchat__carousel-filmstrip--show-nub": {
                "&:not(.webchat__carousel-filmstrip--hide-avatar.webchat__carousel-filmstrip--show-avatar)": {
                    "& .webchat__carousel-filmstrip__attachments": {
                        marginLeft: -paddingRegular * 2
                    }
                }
            }
        }))
    };
}

});

parcelRequire.register("kiOUK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $ec7cfb956f4717b9$var$CarouselFilmStripAttachment;

var $ec7cfb956f4717b9$var$_mirrorStyle = $ec7cfb956f4717b9$var$_interopRequireDefault((parcelRequire("gp1rj")));
function $ec7cfb956f4717b9$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $ec7cfb956f4717b9$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $ec7cfb956f4717b9$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $ec7cfb956f4717b9$var$ownKeys(Object(source), !0).forEach(function(key) {
            $ec7cfb956f4717b9$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $ec7cfb956f4717b9$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $ec7cfb956f4717b9$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $ec7cfb956f4717b9$var$CarouselFilmStripAttachment(_ref) {
    var avatarSize = _ref.avatarSize, bubbleMaxWidth = _ref.bubbleMaxWidth, bubbleMinWidth = _ref.bubbleMinWidth, paddingRegular = _ref.paddingRegular, transcriptVisualKeyboardIndicatorColor = _ref.transcriptVisualKeyboardIndicatorColor, transcriptVisualKeyboardIndicatorStyle = _ref.transcriptVisualKeyboardIndicatorStyle, transcriptVisualKeyboardIndicatorWidth = _ref.transcriptVisualKeyboardIndicatorWidth, transitionDuration = _ref.transitionDuration;
    return $ec7cfb956f4717b9$var$_objectSpread({
        "&.webchat__carousel-filmstrip-attachment": {
            minWidth: bubbleMinWidth,
            maxWidth: bubbleMaxWidth,
            transitionDuration: transitionDuration,
            transitionProperty: "max-width, min-width",
            "&:focus": {
                outline: 0
            },
            "&:focus .webchat__carousel-filmstrip-attachment--focus": {
                borderColor: transcriptVisualKeyboardIndicatorColor,
                borderStyle: transcriptVisualKeyboardIndicatorStyle,
                borderWidth: transcriptVisualKeyboardIndicatorWidth,
                boxSizing: "border-box",
                height: "calc(100% - ".concat(transcriptVisualKeyboardIndicatorWidth, "px)"),
                left: 0,
                pointerEvents: "none",
                position: "absolute",
                top: 0,
                width: "calc(100% - ".concat(transcriptVisualKeyboardIndicatorWidth, "px)")
            }
        }
    }, (0, $ec7cfb956f4717b9$var$_mirrorStyle.default)("&.webchat__carousel-filmstrip-attachment--rtl", {
        paddingLeft: paddingRegular,
        "&.webchat__carousel-filmstrip-attachment--hide-avatar, &.webchat__carousel-filmstrip-attachment--show-avatar": {
            "&:first-child": {
                paddingLeft: avatarSize + paddingRegular * 2
            }
        },
        "&.webchat__carousel-filmstrip-attachment--hide-nub, &.webchat__carousel-filmstrip-attachment--show-nub": {
            "&:not(.webchat__carousel-filmstrip-attachment--hide-avatar.webchat__carousel-filmstrip-attachment--show-avatar):first-child": {
                paddingLeft: paddingRegular * 2
            }
        }
    }));
}

});

parcelRequire.register("4QutZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $3873a9fe4e367f45$var$CarouselFlipper;
function $3873a9fe4e367f45$var$CarouselFlipper(_ref) {
    var transcriptOverlayButtonBackground = _ref.transcriptOverlayButtonBackground, transcriptOverlayButtonBackgroundOnDisabled = _ref.transcriptOverlayButtonBackgroundOnDisabled, transcriptOverlayButtonBackgroundOnFocus = _ref.transcriptOverlayButtonBackgroundOnFocus, transcriptOverlayButtonBackgroundOnHover = _ref.transcriptOverlayButtonBackgroundOnHover, transcriptOverlayButtonColor = _ref.transcriptOverlayButtonColor, transcriptOverlayButtonColorOnDisabled = _ref.transcriptOverlayButtonColorOnDisabled, transcriptOverlayButtonColorOnFocus = _ref.transcriptOverlayButtonColorOnFocus, transcriptOverlayButtonColorOnHover = _ref.transcriptOverlayButtonColorOnHover;
    return {
        "&.webchat__carousel-layout": {
            "& .react-film__flipper": {
                "& .react-film__flipper__body": {
                    backgroundColor: transcriptOverlayButtonBackground,
                    color: transcriptOverlayButtonColor,
                    outline: 0
                },
                '&:disabled, &[aria-disabled="true"]': {
                    "& .react-film__flipper__body": {
                        backgroundColor: transcriptOverlayButtonBackgroundOnDisabled,
                        color: transcriptOverlayButtonColorOnDisabled
                    }
                },
                "&:focus .react-film__flipper__body": {
                    backgroundColor: transcriptOverlayButtonBackgroundOnFocus,
                    color: transcriptOverlayButtonColorOnFocus || transcriptOverlayButtonColor
                },
                "&:hover .react-film__flipper__body": {
                    backgroundColor: transcriptOverlayButtonBackgroundOnHover,
                    color: transcriptOverlayButtonColorOnHover || transcriptOverlayButtonColor
                }
            }
        }
    };
}

});

parcelRequire.register("jHv1y", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $e57a1930f32b34ff$var$ConnectivityNotification;
function $e57a1930f32b34ff$var$ConnectivityNotification(_ref) {
    var connectivityMarginLeftRight = _ref.connectivityMarginLeftRight, connectivityMarginTopBottom = _ref.connectivityMarginTopBottom, connectivityTextSize = _ref.connectivityTextSize, notificationText = _ref.notificationText, primaryFont = _ref.primaryFont;
    return {
        alignItems: "center",
        color: notificationText,
        // TODO: [P2] We should not set "display" in styleSet, this will allow the user to break the layout for no good reasons.
        display: "flex",
        fontFamily: primaryFont,
        fontSize: connectivityTextSize,
        marginBottom: connectivityMarginTopBottom,
        marginLeft: connectivityMarginLeftRight,
        marginRight: connectivityMarginLeftRight,
        marginTop: connectivityMarginTopBottom
    };
}

});

parcelRequire.register("iVL0X", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $dc8204f34f88be80$var$createDictationInterimsStyle;
function $dc8204f34f88be80$var$createDictationInterimsStyle(_ref) {
    var paddingRegular = _ref.paddingRegular, primaryFont = _ref.primaryFont;
    return {
        fontFamily: primaryFont,
        margin: 0,
        paddingBottom: 0,
        paddingLeft: paddingRegular,
        paddingRight: paddingRegular,
        paddingTop: 0,
        "&.dictating > span:not(:first-child), &.status": {
            opacity: 0.5
        }
    };
}

});

parcelRequire.register("hCSaA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $cd500144f89d2242$var$createErrorBoxStyle;
function $cd500144f89d2242$var$createErrorBoxStyle(_ref) {
    var monospaceFont = _ref.monospaceFont, primaryFont = _ref.primaryFont;
    return {
        // TODO: [P2] We should not set "display" in styleSet, this will allow the user to break the layout for no good reasons.
        display: "flex",
        flexDirection: "column",
        fontFamily: primaryFont,
        margin: 0,
        minHeight: 20,
        maxHeight: 200,
        overflowY: "auto",
        WebkitOverflowScrolling: "touch",
        "& > :first-child": {
            backgroundColor: "#EF0000",
            color: "White",
            padding: "5px 10px"
        },
        "& > :last-child": {
            borderColor: "#EF0000",
            borderStyle: "dashed",
            borderBottomWidth: 2,
            borderLeftWidth: 2,
            borderRightWidth: 2,
            borderTopWidth: 0,
            margin: 0,
            overflowY: "auto",
            padding: 10,
            "& > pre": {
                fontFamily: monospaceFont,
                fontSize: "60%",
                margin: 0
            }
        }
    };
}

});

parcelRequire.register("fLWPS", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $b7b8e25686ee9526$var$createErrorNotificationStyle;
function $b7b8e25686ee9526$var$createErrorNotificationStyle(_ref) {
    var connectivityIconPadding = _ref.connectivityIconPadding, connectivityMarginLeftRight = _ref.connectivityMarginLeftRight, connectivityMarginTopBottom = _ref.connectivityMarginTopBottom, connectivityTextSize = _ref.connectivityTextSize, failedConnectivity = _ref.failedConnectivity, primaryFont = _ref.primaryFont;
    return {
        alignItems: "center",
        color: failedConnectivity,
        display: "flex",
        fontFamily: primaryFont,
        fontSize: connectivityTextSize,
        fontWeight: "bold",
        marginBottom: connectivityMarginTopBottom,
        marginLeft: connectivityMarginLeftRight,
        marginRight: connectivityMarginLeftRight,
        marginTop: connectivityMarginTopBottom,
        "& > svg": {
            fill: failedConnectivity,
            "&:not(.webchat__error--rtl)": {
                paddingRight: connectivityIconPadding
            },
            "&.webchat__error--rtl": {
                paddingLeft: connectivityIconPadding
            }
        }
    };
}

});

parcelRequire.register("daObx", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $99732344eca83eb8$var$createFileContentStyle;
function $99732344eca83eb8$var$createFileContentStyle(_ref) {
    var accent = _ref.accent, bubbleTextColor = _ref.bubbleTextColor, paddingRegular = _ref.paddingRegular, primaryFont = _ref.primaryFont;
    return {
        color: bubbleTextColor,
        display: "flex",
        fontFamily: primaryFont,
        padding: paddingRegular,
        "& .webchat__fileContent__badge": {
            justifyContent: "center"
        },
        "& .webchat__fileContent__buttonLink": {
            alignItems: "center",
            color: bubbleTextColor,
            textDecoration: "none",
            "&:focus": {
                backgroundColor: "rgba(0, 0, 0, .1)"
            }
        },
        "& .webchat__fileContent__downloadIcon": {
            fill: accent,
            padding: paddingRegular,
            "&:not(.webchat__fileContent__downloadIcon--rtl)": {
                marginLeft: paddingRegular
            },
            "&.webchat__fileContent__downloadIcon--rtl": {
                marginRight: paddingRegular
            }
        },
        "& .webchat__fileContent__fileName": {
            color: accent
        }
    };
}

});

parcelRequire.register("i6DLC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $d2e7a276e7cfbe6b$var$createImageAvatarStyle;
function $d2e7a276e7cfbe6b$var$createImageAvatarStyle(_ref) {
    var avatarSize = _ref.avatarSize;
    return {
        height: avatarSize,
        overflow: "hidden",
        width: avatarSize
    };
}

});

parcelRequire.register("7nRoA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $5604199b237f760c$var$createInitialsAvatarStyle;
function $5604199b237f760c$var$createInitialsAvatarStyle(_ref) {
    var accent = _ref.accent, avatarSize = _ref.avatarSize, botAvatarBackgroundColor = _ref.botAvatarBackgroundColor, primaryFont = _ref.primaryFont, userAvatarBackgroundColor = _ref.userAvatarBackgroundColor;
    return {
        "&.webchat__initialsAvatar": {
            alignItems: "center",
            color: "White",
            fontFamily: primaryFont,
            height: avatarSize,
            justifyContent: "center",
            overflow: "hidden",
            width: avatarSize,
            "&.webchat__initialsAvatar--fromUser": {
                backgroundColor: userAvatarBackgroundColor || accent
            },
            "&:not(.webchat__initialsAvatar--fromUser)": {
                backgroundColor: botAvatarBackgroundColor || accent
            }
        }
    };
}

});

parcelRequire.register("d6jMs", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $989b2de3d4337d33$var$createKeyboardHelpStyleSet;
function $989b2de3d4337d33$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
// Numbers are commonly used in CSS.
/* eslint-disable no-magic-numbers */ var $989b2de3d4337d33$var$DARK_THEME_SELECTOR = "@media (forced-colors: none) and (prefers-color-scheme: dark)";
var $989b2de3d4337d33$var$LIGHT_THEME_SELECTOR = "@media (forced-colors: none) and (prefers-color-scheme: light)";
var $989b2de3d4337d33$var$FORCED_COLORS_SELECTOR = "@media (forced-colors: active)";
function $989b2de3d4337d33$var$createKeyboardHelpStyleSet(_ref) {
    var _webchat__keyboard, _webchat__keyboard2, _webchat__keyboard3, _webchat__keyboard4;
    var paddingRegular = _ref.paddingRegular, primaryFont = _ref.primaryFont;
    return {
        "&.webchat__keyboard-help": (_webchat__keyboard4 = {
            fontFamily: primaryFont,
            fontSize: 14,
            height: "100%",
            outline: 0,
            overflow: "hidden",
            "&:not(.webchat__keyboard-help--shown)": {
                height: 0,
                margin: 0,
                overflow: "hidden",
                pointerEvents: "none",
                width: 0
            },
            "& .webchat__keyboard-help__border": {
                boxSizing: "border-box",
                height: "100%",
                padding: paddingRegular
            },
            "& .webchat__keyboard-help__box": (_webchat__keyboard = {
                // From Power BI:
                // boxShadow: '0 6.4px 14.4px rgb(0 0 0 / 13%), 0 1.2px 3.6px rgb(0 0 0 / 11%)',
                // From Fluent (depth-16 for teaching callouts):
                borderRadius: 2,
                boxShadow: "0px 8px 16px rgba(0, 0, 0, 0.14), 0px 0px 2px rgba(0, 0, 0, 0.12)",
                height: "100%",
                overflow: "hidden"
            }, $989b2de3d4337d33$var$_defineProperty(_webchat__keyboard, $989b2de3d4337d33$var$FORCED_COLORS_SELECTOR, {
                backgroundColor: "Canvas",
                boxShadow: "none",
                outlineColor: "ButtonBorder",
                outlineStyle: "solid",
                outlineWidth: 4
            }), $989b2de3d4337d33$var$_defineProperty(_webchat__keyboard, $989b2de3d4337d33$var$DARK_THEME_SELECTOR, {
                backgroundColor: "Black",
                boxShadow: "0px 8px 16px rgba(0, 0, 0, 0.28), 0px 0px 2px rgba(0, 0, 0, 0.24)"
            }), _webchat__keyboard),
            "& .webchat__keyboard-help__scrollable": {
                boxSizing: "border-box",
                height: "100%",
                overflowY: "auto",
                padding: paddingRegular * 2,
                position: "relative"
            },
            "& .webchat__keyboard-help__close-button": {
                appearance: "none",
                backgroundColor: "transparent",
                border: 0,
                outline: 0,
                padding: paddingRegular,
                // We are enlarging the bounding box of close button for scroll into view properly/cosmetically.
                // When TAB key focus on the close button, it is scrolled into view.
                // If the close button is at (10, 10), the `scrollTop` will be 10.
                // We are enlarging the bounding box, so TAB to focus on close button, `scrollTop` will be 0.
                // However, the bounding box enlarged does not means the padding are clickable.
                // We are setting `pointerEvents` to `none` to ignore mouse click on the enlarged bounding box.
                pointerEvents: "none",
                position: "absolute",
                right: 0,
                top: 0
            },
            "& .webchat__keyboard-help__close-button-border": (_webchat__keyboard2 = {
                alignItems: "center",
                borderRadius: 4,
                borderStyle: "solid",
                borderWidth: 2,
                color: "#999",
                display: "flex",
                height: 30,
                justifyContent: "center",
                // After enlarging the bounding box, we will resume pointer events (i.e. "click") inside this element.
                pointerEvents: "initial",
                width: 30
            }, $989b2de3d4337d33$var$_defineProperty(_webchat__keyboard2, $989b2de3d4337d33$var$LIGHT_THEME_SELECTOR, {
                borderColor: "black",
                "&:active": {
                    backgroundColor: "#EDEBE9" // neutralLight (gray30)
                },
                "&:not(:active):hover": {
                    backgroundColor: "#F3F2F1" // neutralLighter (gray20)
                }
            }), $989b2de3d4337d33$var$_defineProperty(_webchat__keyboard2, $989b2de3d4337d33$var$DARK_THEME_SELECTOR, {
                borderColor: "white",
                "&:active": {
                    backgroundColor: "#292827" // neutralLight (gray30)
                },
                "&:not(:active):hover": {
                    backgroundColor: "#252423" // neutralLight (gray30)
                }
            }), $989b2de3d4337d33$var$_defineProperty(_webchat__keyboard2, $989b2de3d4337d33$var$FORCED_COLORS_SELECTOR, {
                backgroundColor: "ButtonFace",
                borderColor: "ButtonBorder"
            }), _webchat__keyboard2),
            "& .webchat__keyboard-help__close-button-image": (_webchat__keyboard3 = {
                fill: "#323130",
                // neutralPrimary (gray160)
                height: 10,
                width: 10
            }, $989b2de3d4337d33$var$_defineProperty(_webchat__keyboard3, $989b2de3d4337d33$var$FORCED_COLORS_SELECTOR, {
                fill: "ButtonText"
            }), $989b2de3d4337d33$var$_defineProperty(_webchat__keyboard3, $989b2de3d4337d33$var$DARK_THEME_SELECTOR, {
                fill: "#F3F2F1" // neutralPrimary (gray160)
            }), _webchat__keyboard3),
            "& .webchat__keyboard-help__header, & .webchat__keyboard-help__sub-header": {
                marginBottom: paddingRegular / 2,
                marginTop: 0
            },
            "& .webchat__keyboard-help__section:not(:last-child)": {
                marginBottom: paddingRegular
            },
            "& .webchat__keyboard-help__two-panes": {
                alignItems: "flex-start",
                display: "flex"
            },
            "& .webchat__keyboard-help__image": {
                paddingRight: paddingRegular
            },
            "& .webchat__keyboard-help__image--dark, & .webchat__keyboard-help__image--high-contrast": {
                display: "none"
            }
        }, $989b2de3d4337d33$var$_defineProperty(_webchat__keyboard4, $989b2de3d4337d33$var$FORCED_COLORS_SELECTOR, {
            "& .webchat__keyboard-help__image--dark, & .webchat__keyboard-help__image--light": {
                display: "none"
            },
            "& .webchat__keyboard-help__image--high-contrast": {
                display: "unset",
                // "difference" will make sure SVG image is properly color in both light and dark high contrast mode.
                mixBlendMode: "difference"
            }
        }), $989b2de3d4337d33$var$_defineProperty(_webchat__keyboard4, $989b2de3d4337d33$var$DARK_THEME_SELECTOR, {
            color: "#F3F2F1",
            "& .webchat__keyboard-help__image--light": {
                display: "none"
            },
            "& .webchat__keyboard-help__image--dark": {
                display: "unset"
            }
        }), $989b2de3d4337d33$var$_defineProperty(_webchat__keyboard4, "& .webchat__keyboard-help__notes", {
            marginBottom: paddingRegular
        }), $989b2de3d4337d33$var$_defineProperty(_webchat__keyboard4, "& .webchat__keyboard-help__notes-header", {
            margin: 0
        }), $989b2de3d4337d33$var$_defineProperty(_webchat__keyboard4, "& .webchat__keyboard-help__notes-pane", {
            flexShrink: 10000
        }), $989b2de3d4337d33$var$_defineProperty(_webchat__keyboard4, "& .webchat__keyboard-help__notes-text", {
            margin: 0
        }), _webchat__keyboard4)
    };
}

});

parcelRequire.register("6dTtF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $487efda211ed2e53$var$createMicrophoneButtonStyle;
function $487efda211ed2e53$var$createMicrophoneButtonStyle(_ref) {
    var microphoneButtonColorOnDictate = _ref.microphoneButtonColorOnDictate;
    return {
        "&.webchat__microphone-button": {
            "&.webchat__microphone-button--dictating .webchat__microphone-button__button": {
                "&, &:focus, &:hover": {
                    "& .webchat__microphone-button__icon": {
                        fill: microphoneButtonColorOnDictate
                    }
                }
            }
        }
    };
}

});

parcelRequire.register("5ql4l", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $3f2fb9594f4e3011$var$_default;
function $3f2fb9594f4e3011$var$_default(_ref) {
    var backgroundColor = _ref.backgroundColor, height = _ref.rootHeight, width = _ref.rootWidth, zIndex = _ref.rootZIndex;
    return {
        backgroundColor: backgroundColor,
        height: height,
        width: width,
        zIndex: zIndex
    };
}

});

parcelRequire.register("3I5mu", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $2b39a3dcfb7877f3$var$createScrollToEndButtonStyle;
function $2b39a3dcfb7877f3$var$createScrollToEndButtonStyle(_ref) {
    var paddingRegular = _ref.paddingRegular, primaryFont = _ref.primaryFont, scrollToEndButtonFontSize = _ref.scrollToEndButtonFontSize, transcriptOverlayButtonBackground = _ref.transcriptOverlayButtonBackground, transcriptOverlayButtonBackgroundOnFocus = _ref.transcriptOverlayButtonBackgroundOnFocus, transcriptOverlayButtonBackgroundOnHover = _ref.transcriptOverlayButtonBackgroundOnHover, transcriptOverlayButtonColor = _ref.transcriptOverlayButtonColor, transcriptOverlayButtonColorOnFocus = _ref.transcriptOverlayButtonColorOnFocus, transcriptOverlayButtonColorOnHover = _ref.transcriptOverlayButtonColorOnHover;
    return {
        "&.webchat__scroll-to-end-button": {
            // TODO: [P3] Can we not to unset borderWidth and outline earlier?
            "@media screen and (forced-colors: active)": {
                borderWidth: "initial",
                outline: "initial"
            },
            appearance: "none",
            backgroundColor: transcriptOverlayButtonBackground,
            borderRadius: paddingRegular,
            borderWidth: 0,
            bottom: 5,
            color: transcriptOverlayButtonColor,
            fontFamily: primaryFont,
            fontSize: scrollToEndButtonFontSize,
            outline: 0,
            padding: paddingRegular,
            position: "absolute",
            zIndex: 1,
            // We formed a stacking context in the parent container, so we can use "z-index" here.
            "&:hover": {
                backgroundColor: transcriptOverlayButtonBackgroundOnHover,
                color: transcriptOverlayButtonColorOnHover || transcriptOverlayButtonColor
            },
            "&:focus": {
                backgroundColor: transcriptOverlayButtonBackgroundOnFocus,
                color: transcriptOverlayButtonColorOnFocus || transcriptOverlayButtonColor
            },
            "&:not(.webchat__scroll-to-end-button--rtl)": {
                right: 20
            },
            "&.webchat__scroll-to-end-button--rtl": {
                left: 20
            }
        }
    };
}

});

parcelRequire.register("giOHK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $bde5a8a3b3273795$var$createSendBoxButtonStyle;
function $bde5a8a3b3273795$var$createSendBoxButtonStyle(_ref) {
    var sendBoxButtonColor = _ref.sendBoxButtonColor, sendBoxButtonColorOnActive = _ref.sendBoxButtonColorOnActive, sendBoxButtonColorOnDisabled = _ref.sendBoxButtonColorOnDisabled, sendBoxButtonColorOnFocus = _ref.sendBoxButtonColorOnFocus, sendBoxButtonColorOnHover = _ref.sendBoxButtonColorOnHover, sendBoxButtonKeyboardFocusIndicatorBorderColor = _ref.sendBoxButtonKeyboardFocusIndicatorBorderColor, sendBoxButtonKeyboardFocusIndicatorBorderRadius = _ref.sendBoxButtonKeyboardFocusIndicatorBorderRadius, sendBoxButtonKeyboardFocusIndicatorBorderStyle = _ref.sendBoxButtonKeyboardFocusIndicatorBorderStyle, sendBoxButtonKeyboardFocusIndicatorBorderWidth = _ref.sendBoxButtonKeyboardFocusIndicatorBorderWidth, sendBoxButtonKeyboardFocusIndicatorInset = _ref.sendBoxButtonKeyboardFocusIndicatorInset, sendBoxButtonShadeBorderRadius = _ref.sendBoxButtonShadeBorderRadius, sendBoxButtonShadeColor = _ref.sendBoxButtonShadeColor, sendBoxButtonShadeColorOnActive = _ref.sendBoxButtonShadeColorOnActive, sendBoxButtonShadeColorOnDisabled = _ref.sendBoxButtonShadeColorOnDisabled, sendBoxButtonShadeColorOnFocus = _ref.sendBoxButtonShadeColorOnFocus, sendBoxButtonShadeColorOnHover = _ref.sendBoxButtonShadeColorOnHover, sendBoxButtonShadeInset = _ref.sendBoxButtonShadeInset, sendBoxHeight = _ref.sendBoxHeight, subtle = _ref.subtle;
    return {
        "&.webchat__icon-button": {
            alignItems: "center",
            appearance: "none",
            backgroundColor: "Transparent",
            border: 0,
            display: "flex",
            fill: sendBoxButtonColor || subtle,
            justifyContent: "center",
            outline: 0,
            padding: 0,
            position: "relative",
            width: sendBoxHeight,
            // We use the sendBoxHeight, so the button looks square
            "&:not(.webchat__icon-button--stretch)": {
                height: sendBoxHeight
            },
            // Order of style preferences (based on effort of user gesture): disabled > active > hover > focus.
            // Keyboard focus indicator styles applied by :focus-visible do not conflict with :active/:hover/:focus, so it is not included here.
            '&:disabled, &[aria-disabled="true"]': {
                fill: sendBoxButtonColorOnDisabled,
                "& .webchat__icon-button__shade": {
                    backgroundColor: sendBoxButtonShadeColorOnDisabled
                }
            },
            '&:not(:disabled):not([aria-disabled="true"])': {
                "&:active": {
                    fill: sendBoxButtonColorOnActive,
                    "& .webchat__icon-button__shade": {
                        backgroundColor: sendBoxButtonShadeColorOnActive
                    }
                },
                "&:not(:active)": {
                    "&:hover": {
                        fill: sendBoxButtonColorOnHover,
                        "& .webchat__icon-button__shade": {
                            backgroundColor: sendBoxButtonShadeColorOnHover
                        }
                    },
                    "&:not(:hover)": {
                        "&:focus": {
                            fill: sendBoxButtonColorOnFocus,
                            "& .webchat__icon-button__shade": {
                                backgroundColor: sendBoxButtonShadeColorOnFocus
                            }
                        }
                    }
                }
            },
            // On unsupported browser, :focus-visible and :not(:focus-visible) is always false.
            // And it will turn the whole CSS selector ":unsupported, .truthy" to false.
            "&:not(:focus-visible) .webchat__icon-button__keyboard-focus-indicator": {
                display: "none"
            },
            "&:not(.webchat__icon-button--focus-visible) .webchat__icon-button__keyboard-focus-indicator": {
                display: "none"
            },
            // Make sure all contents are in the same stacking context.
            "& > *": {
                position: "relative"
            },
            "& .webchat__icon-button__shade": {
                backgroundColor: sendBoxButtonShadeColor,
                borderRadius: sendBoxButtonShadeBorderRadius,
                bottom: sendBoxButtonShadeInset,
                left: sendBoxButtonShadeInset,
                position: "absolute",
                right: sendBoxButtonShadeInset,
                top: sendBoxButtonShadeInset
            },
            "& .webchat__icon-button__keyboard-focus-indicator": {
                borderColor: sendBoxButtonKeyboardFocusIndicatorBorderColor,
                borderRadius: sendBoxButtonKeyboardFocusIndicatorBorderRadius,
                borderStyle: sendBoxButtonKeyboardFocusIndicatorBorderStyle,
                borderWidth: sendBoxButtonKeyboardFocusIndicatorBorderWidth,
                bottom: sendBoxButtonKeyboardFocusIndicatorInset,
                left: sendBoxButtonKeyboardFocusIndicatorInset,
                position: "absolute",
                right: sendBoxButtonKeyboardFocusIndicatorInset,
                top: sendBoxButtonKeyboardFocusIndicatorInset
            }
        }
    };
}

});

parcelRequire.register("9blwk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $6af5d5aa911dbcb6$var$createSendBoxStyle;
function $6af5d5aa911dbcb6$var$createSendBoxStyle(_ref) {
    var sendBoxBackground = _ref.sendBoxBackground, sendBoxBorderBottom = _ref.sendBoxBorderBottom, sendBoxBorderLeft = _ref.sendBoxBorderLeft, sendBoxBorderRight = _ref.sendBoxBorderRight, sendBoxBorderTop = _ref.sendBoxBorderTop, sendBoxHeight = _ref.sendBoxHeight;
    return {
        "&.webchat__send-box": {
            "& .webchat__send-box__button--align-bottom": {
                alignSelf: "flex-end"
            },
            "& .webchat__send-box__button--align-stretch": {
                alignSelf: "stretch"
            },
            "& .webchat__send-box__button--align-top": {
                alignSelf: "flex-start"
            },
            "& .webchat__send-box__main": {
                alignItems: "stretch",
                backgroundColor: sendBoxBackground,
                borderBottom: sendBoxBorderBottom,
                borderLeft: sendBoxBorderLeft,
                borderRight: sendBoxBorderRight,
                borderTop: sendBoxBorderTop,
                minHeight: sendBoxHeight
            }
        }
    };
}

});

parcelRequire.register("arpvQ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $79a0373fc2917498$var$createSendBoxTextBoxStyle;
function $79a0373fc2917498$var$createSendBoxTextBoxStyle(_ref) {
    var paddingRegular = _ref.paddingRegular, primaryFont = _ref.primaryFont, sendBoxDisabledTextColor = _ref.sendBoxDisabledTextColor, sendBoxMaxHeight = _ref.sendBoxMaxHeight, sendBoxPlaceholderColor = _ref.sendBoxPlaceholderColor, sendBoxTextColor = _ref.sendBoxTextColor, subtle = _ref.subtle;
    return {
        "&.webchat__send-box-text-box": {
            alignItems: "center",
            fontFamily: primaryFont,
            padding: paddingRegular,
            position: "relative",
            "& .webchat__send-box-text-box__input": {
                border: 0,
                fontFamily: "inherit",
                fontSize: "inherit",
                height: "100%",
                outline: 0,
                padding: 0
            },
            "& .webchat__send-box-text-box__input, & .webchat__send-box-text-box__html-text-area": {
                backgroundColor: "transparent",
                // We set this to transparent because we already applied "sendBoxBackground" to a parent container.
                '&:not(:disabled):not([aria-disabled="true"])': {
                    color: sendBoxTextColor
                },
                '&:disabled, &[aria-disabled="true"]': {
                    color: sendBoxDisabledTextColor || subtle
                },
                "&::placeholder": {
                    color: sendBoxPlaceholderColor || subtle
                }
            },
            "& .webchat__send-box-text-box__input, & .webchat__send-box-text-box__text-area": {
                maxHeight: sendBoxMaxHeight
            },
            "& .webchat__send-box-text-box__glass": {
                height: "100%",
                left: 0,
                position: "absolute",
                top: 0,
                userSelect: 0,
                width: "100%"
            }
        }
    };
}

});

parcelRequire.register("e9qsg", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $a4d66d559b732cfa$var$createSendStatusStyle;
function $a4d66d559b732cfa$var$createSendStatusStyle(_ref) {
    var fontSizeSmall = _ref.fontSizeSmall, primaryFont = _ref.primaryFont, subtle = _ref.subtle, timestampColor = _ref.timestampColor;
    return {
        color: timestampColor || subtle,
        fontFamily: primaryFont,
        fontSize: fontSizeSmall,
        paddingTop: 5
    };
}

});

parcelRequire.register("23DGM", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $17faa5fde02e7fab$var$createSingleCardActivityStyle;
function $17faa5fde02e7fab$var$createSingleCardActivityStyle(_ref) {
    var bubbleMaxWidth = _ref.bubbleMaxWidth, bubbleMinWidth = _ref.bubbleMinWidth, paddingRegular = _ref.paddingRegular;
    return {
        "& > .bubble-box": {
            maxWidth: bubbleMaxWidth,
            minWidth: bubbleMinWidth
        },
        "& > .filler": {
            minWidth: paddingRegular
        }
    };
}

});

parcelRequire.register("3WZQg", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $2e06c261c4c92dc7$var$createSpinnerAnimationStyle;

var $l4PI2 = parcelRequire("l4PI2");
var $2e06c261c4c92dc7$var$DEFAULT_IMAGE_BASE64 = "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";
var $2e06c261c4c92dc7$var$DEFAULT_IMAGE_TYPE = "image/gif";
var $2e06c261c4c92dc7$var$defaultImageBlobURL;
function $2e06c261c4c92dc7$var$createSpinnerAnimationStyle(_ref) {
    var spinnerAnimationBackgroundImage = _ref.spinnerAnimationBackgroundImage, spinnerAnimationHeight = _ref.spinnerAnimationHeight, spinnerAnimationWidth = _ref.spinnerAnimationWidth, spinnerAnimationPadding = _ref.spinnerAnimationPadding;
    $2e06c261c4c92dc7$var$defaultImageBlobURL || ($2e06c261c4c92dc7$var$defaultImageBlobURL = URL.createObjectURL(new Blob([
        (0, $l4PI2.toByteArray)($2e06c261c4c92dc7$var$DEFAULT_IMAGE_BASE64)
    ], {
        type: $2e06c261c4c92dc7$var$DEFAULT_IMAGE_TYPE
    })));
    var backgroundImage = spinnerAnimationBackgroundImage || "url('".concat($2e06c261c4c92dc7$var$defaultImageBlobURL, "')");
    return {
        backgroundImage: backgroundImage,
        backgroundRepeat: "no-repeat",
        backgroundSize: "contain",
        height: spinnerAnimationHeight,
        width: spinnerAnimationWidth,
        ":not(.webchat__spinner--rtl)": {
            marginRight: spinnerAnimationPadding
        },
        ".webchat__spinner--rtl": {
            marginLeft: spinnerAnimationPadding
        }
    };
}

});
parcelRequire.register("l4PI2", function(module, exports) {

$parcel$export(module.exports, "toByteArray", () => $f5821518acdea36f$export$d622b2ad8d90c771, (v) => $f5821518acdea36f$export$d622b2ad8d90c771 = v);
$parcel$export(module.exports, "fromByteArray", () => $f5821518acdea36f$export$6100ba28696e12de, (v) => $f5821518acdea36f$export$6100ba28696e12de = v);
var $f5821518acdea36f$export$a48f0734ac7c2329;
var $f5821518acdea36f$export$d622b2ad8d90c771;
var $f5821518acdea36f$export$6100ba28696e12de;
"use strict";
$f5821518acdea36f$export$a48f0734ac7c2329 = $f5821518acdea36f$var$byteLength;
$f5821518acdea36f$export$d622b2ad8d90c771 = $f5821518acdea36f$var$toByteArray;
$f5821518acdea36f$export$6100ba28696e12de = $f5821518acdea36f$var$fromByteArray;
var $f5821518acdea36f$var$lookup = [];
var $f5821518acdea36f$var$revLookup = [];
var $f5821518acdea36f$var$Arr = typeof Uint8Array !== "undefined" ? Uint8Array : Array;
var $f5821518acdea36f$var$code = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
for(var $f5821518acdea36f$var$i = 0, $f5821518acdea36f$var$len = $f5821518acdea36f$var$code.length; $f5821518acdea36f$var$i < $f5821518acdea36f$var$len; ++$f5821518acdea36f$var$i){
    $f5821518acdea36f$var$lookup[$f5821518acdea36f$var$i] = $f5821518acdea36f$var$code[$f5821518acdea36f$var$i];
    $f5821518acdea36f$var$revLookup[$f5821518acdea36f$var$code.charCodeAt($f5821518acdea36f$var$i)] = $f5821518acdea36f$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$f5821518acdea36f$var$revLookup["-".charCodeAt(0)] = 62;
$f5821518acdea36f$var$revLookup["_".charCodeAt(0)] = 63;
function $f5821518acdea36f$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf("=");
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $f5821518acdea36f$var$byteLength(b64) {
    var lens = $f5821518acdea36f$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $f5821518acdea36f$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $f5821518acdea36f$var$toByteArray(b64) {
    var tmp;
    var lens = $f5821518acdea36f$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $f5821518acdea36f$var$Arr($f5821518acdea36f$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $f5821518acdea36f$var$revLookup[b64.charCodeAt(i)] << 18 | $f5821518acdea36f$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $f5821518acdea36f$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $f5821518acdea36f$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $f5821518acdea36f$var$revLookup[b64.charCodeAt(i)] << 2 | $f5821518acdea36f$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $f5821518acdea36f$var$revLookup[b64.charCodeAt(i)] << 10 | $f5821518acdea36f$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $f5821518acdea36f$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $f5821518acdea36f$var$tripletToBase64(num) {
    return $f5821518acdea36f$var$lookup[num >> 18 & 0x3F] + $f5821518acdea36f$var$lookup[num >> 12 & 0x3F] + $f5821518acdea36f$var$lookup[num >> 6 & 0x3F] + $f5821518acdea36f$var$lookup[num & 0x3F];
}
function $f5821518acdea36f$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($f5821518acdea36f$var$tripletToBase64(tmp));
    }
    return output.join("");
}
function $f5821518acdea36f$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($f5821518acdea36f$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($f5821518acdea36f$var$lookup[tmp >> 2] + $f5821518acdea36f$var$lookup[tmp << 4 & 0x3F] + "==");
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($f5821518acdea36f$var$lookup[tmp >> 10] + $f5821518acdea36f$var$lookup[tmp >> 4 & 0x3F] + $f5821518acdea36f$var$lookup[tmp << 2 & 0x3F] + "=");
    }
    return parts.join("");
}

});


parcelRequire.register("bJzWc", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $88afc6255a2a5f44$var$createStackedLayoutStyle;
/* eslint no-magic-numbers: ["error", { "ignore": [2] }] */ function $88afc6255a2a5f44$var$createStackedLayoutStyle(_ref) {
    var avatarSize = _ref.avatarSize, bubbleMaxWidth = _ref.bubbleMaxWidth, bubbleMinWidth = _ref.bubbleMinWidth, paddingRegular = _ref.paddingRegular, transitionDuration = _ref.transitionDuration;
    return {
        "&.webchat__stacked-layout": {
            marginLeft: paddingRegular,
            marginRight: paddingRegular,
            "& .webchat__stacked-layout__alignment-pad": {
                transitionDuration: transitionDuration,
                transitionProperty: "width",
                width: 0
            },
            "&.webchat__stacked-layout--extra-trailing .webchat__stacked-layout__alignment-pad": {
                width: paddingRegular
            },
            "& .webchat__stacked-layout__avatar-gutter": {
                transitionDuration: transitionDuration,
                transitionProperty: "width",
                width: 0
            },
            "& .webchat__stacked-layout__attachment": {
                maxWidth: bubbleMaxWidth,
                minWidth: bubbleMinWidth,
                transitionDuration: transitionDuration,
                transitionProperty: "max-width, min-width"
            },
            "& .webchat__stacked-layout__attachment-row": {
                marginTop: paddingRegular,
                width: "100%"
            },
            "&.webchat__stacked-layout--no-message .webchat__stacked-layout__attachment-row.webchat__stacked-layout__attachment-row--first": {
                marginTop: 0
            },
            "& .webchat__stacked-layout__message": {
                maxWidth: bubbleMaxWidth,
                overflow: "hidden",
                transitionDuration: transitionDuration,
                transitionProperty: "max-width"
            },
            "& .webchat__stacked-layout__nub-pad": {
                transitionDuration: transitionDuration,
                transitionProperty: "width",
                width: 0
            },
            "&.webchat__stacked-layout--hide-avatar, &.webchat__stacked-layout--show-avatar": {
                "& .webchat__stacked-layout__avatar-gutter": {
                    width: avatarSize
                }
            },
            "&.webchat__stacked-layout--hide-avatar, &.webchat__stacked-layout--show-avatar, &.webchat__stacked-layout--hide-nub, &.webchat__stacked-layout--show-nub": {
                "& .webchat__stacked-layout__attachment, & .webchat__stacked-layout__message": {
                    maxWidth: bubbleMaxWidth + paddingRegular
                },
                "& .webchat__stacked-layout__nub-pad": {
                    width: paddingRegular
                }
            },
            "&:not(.webchat__stacked-layout--top-callout)": {
                "& .webchat__stacked-layout__avatar-gutter, & .webchat__stacked-layout__content": {
                    justifyContent: "flex-end"
                }
            }
        }
    };
}

});

parcelRequire.register("g9Ltl", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $bc324fa149f71f5d$var$createSuggestedActionsStyle;
/* eslint no-empty-pattern: "off" */ /* eslint no-magic-numbers: ["error", { "ignore": [1.5, 2] }] */ function $bc324fa149f71f5d$var$createSuggestedActionsStyle(_ref) {
    var paddingRegular = _ref.paddingRegular, suggestedActionsCarouselFlipperSize = _ref.suggestedActionsCarouselFlipperSize, suggestedActionsFlowMaxHeight = _ref.suggestedActionsFlowMaxHeight, suggestedActionsStackedHeight = _ref.suggestedActionsStackedHeight, suggestedActionsStackedOverflow = _ref.suggestedActionsStackedOverflow, suggestedActionsVisualKeyboardIndicatorColor = _ref.suggestedActionsVisualKeyboardIndicatorColor, suggestedActionsVisualKeyboardIndicatorStyle = _ref.suggestedActionsVisualKeyboardIndicatorStyle, suggestedActionsVisualKeyboardIndicatorWidth = _ref.suggestedActionsVisualKeyboardIndicatorWidth, transcriptOverlayButtonBackground = _ref.transcriptOverlayButtonBackground, transcriptOverlayButtonBackgroundOnDisabled = _ref.transcriptOverlayButtonBackgroundOnDisabled, transcriptOverlayButtonBackgroundOnFocus = _ref.transcriptOverlayButtonBackgroundOnFocus, transcriptOverlayButtonBackgroundOnHover = _ref.transcriptOverlayButtonBackgroundOnHover, transcriptOverlayButtonColor = _ref.transcriptOverlayButtonColor, transcriptOverlayButtonColorOnDisabled = _ref.transcriptOverlayButtonColorOnDisabled, transcriptOverlayButtonColorOnFocus = _ref.transcriptOverlayButtonColorOnFocus, transcriptOverlayButtonColorOnHover = _ref.transcriptOverlayButtonColorOnHover;
    return {
        "&.webchat__suggested-actions": {
            position: "relative",
            "&.webchat__suggested-actions--carousel-layout": {
                "& .webchat__suggested-actions__carousel": {
                    paddingBottom: paddingRegular / 2,
                    paddingTop: paddingRegular / 2,
                    "& .webchat__suggested-actions__item-box": {
                        paddingBottom: paddingRegular / 2,
                        paddingLeft: paddingRegular / 2,
                        paddingRight: paddingRegular / 2,
                        paddingTop: paddingRegular / 2
                    },
                    "& .react-film__filmstrip": {
                        scrollbarWidth: "none"
                    },
                    "& .react-film__flipper": {
                        '&:disabled, &[aria-disabled="true"]': {
                            "& .react-film__flipper__body": {
                                backgroundColor: transcriptOverlayButtonBackgroundOnDisabled,
                                color: transcriptOverlayButtonColorOnDisabled
                            }
                        },
                        "&:focus .react-film__flipper__body": {
                            backgroundColor: transcriptOverlayButtonBackgroundOnFocus,
                            color: transcriptOverlayButtonColorOnFocus || transcriptOverlayButtonColor
                        },
                        "&:hover .react-film__flipper__body": {
                            backgroundColor: transcriptOverlayButtonBackgroundOnHover,
                            color: transcriptOverlayButtonColorOnHover || transcriptOverlayButtonColor
                        },
                        "& .react-film__flipper__body": {
                            background: transcriptOverlayButtonBackground,
                            color: transcriptOverlayButtonColor,
                            outline: 0
                        }
                    }
                },
                "&:not(.webchat__suggested-actions--rtl)": {
                    "& .react-film__filmstrip__item:first-child": {
                        paddingLeft: paddingRegular / 2
                    },
                    "& .react-film__filmstrip__item:last-child": {
                        paddingRight: paddingRegular / 2
                    },
                    "& .react-film__flipper + .react-film__filmstrip": {
                        "& .react-film__filmstrip__item:first-child": {
                            paddingLeft: suggestedActionsCarouselFlipperSize + paddingRegular * 1.5
                        },
                        "& .react-film__filmstrip__item:last-child": {
                            paddingRight: suggestedActionsCarouselFlipperSize + paddingRegular * 1.5
                        }
                    }
                },
                "&.webchat__suggested-actions--rtl": {
                    "& .react-film__filmstrip__item:first-child": {
                        paddingRight: paddingRegular / 2
                    },
                    "& .react-film__filmstrip__item:last-child": {
                        paddingLeft: paddingRegular / 2
                    },
                    "& .react-film__flipper + .react-film__filmstrip": {
                        "& .react-film__filmstrip__item:first-child": {
                            paddingRight: suggestedActionsCarouselFlipperSize + paddingRegular * 1.5
                        },
                        "& .react-film__filmstrip__item:last-child": {
                            paddingLeft: suggestedActionsCarouselFlipperSize + paddingRegular * 1.5
                        }
                    }
                }
            },
            "&.webchat__suggested-actions--flow-layout": {
                "& .webchat__suggested-actions__flow-box": {
                    maxHeight: suggestedActionsFlowMaxHeight,
                    overflowY: "auto",
                    paddingBottom: paddingRegular / 2,
                    paddingLeft: paddingRegular / 2,
                    paddingRight: paddingRegular / 2,
                    paddingTop: paddingRegular / 2
                },
                "& .webchat__suggested-actions__flow-item-box": {
                    maxWidth: "100%",
                    overflow: "hidden" // This is required in IE11
                },
                "& .webchat__suggested-actions__item-box": {
                    paddingBottom: paddingRegular / 2,
                    paddingLeft: paddingRegular / 2,
                    paddingRight: paddingRegular / 2,
                    paddingTop: paddingRegular / 2
                }
            },
            "&.webchat__suggested-actions--stacked-layout": {
                "& .webchat__suggested-actions__stack": {
                    maxHeight: suggestedActionsStackedHeight || "auto",
                    overflowY: suggestedActionsStackedOverflow || "auto",
                    paddingBottom: paddingRegular / 2,
                    paddingLeft: paddingRegular / 2,
                    paddingRight: paddingRegular / 2,
                    paddingTop: paddingRegular / 2
                },
                "& .webchat__suggested-actions__item-box": {
                    paddingBottom: paddingRegular / 2,
                    paddingLeft: paddingRegular / 2,
                    paddingRight: paddingRegular / 2,
                    paddingTop: paddingRegular / 2
                }
            },
            "&.webchat__suggested-actions--flow-layout, &.webchat__suggested-actions--stacked-layout": {
                "& .webchat__suggested-actions__button-text": {
                    overflow: "hidden",
                    textOverflow: "ellipsis"
                },
                "& .webchat__suggested-actions__button-text-stacked-text-wrap": {
                    alignItems: "center",
                    display: "flex",
                    whiteSpace: "normal"
                }
            },
            "& .webchat__suggested-actions__item-box": {
                display: "flex",
                maxWidth: "100%"
            },
            "&.webchat__suggested-actions--focus-within, &:focus-within": {
                "& .webchat__suggested-actions__focus-indicator": {
                    borderColor: suggestedActionsVisualKeyboardIndicatorColor,
                    borderStyle: suggestedActionsVisualKeyboardIndicatorStyle,
                    borderWidth: suggestedActionsVisualKeyboardIndicatorWidth,
                    boxSizing: "border-box",
                    height: "100%",
                    pointerEvents: "none",
                    position: "absolute",
                    top: 0,
                    width: "100%"
                }
            }
        }
    };
}

});

parcelRequire.register("1TzUA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $1616c8d0b71bc879$var$createSuggestedActionStyle;
/* eslint no-magic-numbers: "off" */ function $1616c8d0b71bc879$var$createSuggestedActionStyle(_ref) {
    var accent = _ref.accent, paddingRegular = _ref.paddingRegular, paddingWide = _ref.paddingWide, primaryFont = _ref.primaryFont, suggestedActionBorderRadius = _ref.suggestedActionBorderRadius, suggestedActionBackgroundColor = _ref.suggestedActionBackgroundColor, suggestedActionBorderColor = _ref.suggestedActionBorderColor, suggestedActionBorderStyle = _ref.suggestedActionBorderStyle, suggestedActionBorderWidth = _ref.suggestedActionBorderWidth, suggestedActionTextColor = _ref.suggestedActionTextColor, suggestedActionBackgroundColorOnActive = _ref.suggestedActionBackgroundColorOnActive, suggestedActionBorderColorOnActive = _ref.suggestedActionBorderColorOnActive, suggestedActionBorderStyleOnActive = _ref.suggestedActionBorderStyleOnActive, suggestedActionBorderWidthOnActive = _ref.suggestedActionBorderWidthOnActive, suggestedActionTextColorOnActive = _ref.suggestedActionTextColorOnActive, suggestedActionBackgroundColorOnDisabled = _ref.suggestedActionBackgroundColorOnDisabled, suggestedActionBorderColorOnDisabled = _ref.suggestedActionBorderColorOnDisabled, suggestedActionBorderStyleOnDisabled = _ref.suggestedActionBorderStyleOnDisabled, suggestedActionBorderWidthOnDisabled = _ref.suggestedActionBorderWidthOnDisabled, suggestedActionTextColorOnDisabled = _ref.suggestedActionTextColorOnDisabled, suggestedActionBackgroundColorOnFocus = _ref.suggestedActionBackgroundColorOnFocus, suggestedActionBorderColorOnFocus = _ref.suggestedActionBorderColorOnFocus, suggestedActionBorderStyleOnFocus = _ref.suggestedActionBorderStyleOnFocus, suggestedActionBorderWidthOnFocus = _ref.suggestedActionBorderWidthOnFocus, suggestedActionTextColorOnFocus = _ref.suggestedActionTextColorOnFocus, suggestedActionBackgroundColorOnHover = _ref.suggestedActionBackgroundColorOnHover, suggestedActionBorderColorOnHover = _ref.suggestedActionBorderColorOnHover, suggestedActionBorderStyleOnHover = _ref.suggestedActionBorderStyleOnHover, suggestedActionBorderWidthOnHover = _ref.suggestedActionBorderWidthOnHover, suggestedActionTextColorOnHover = _ref.suggestedActionTextColorOnHover, suggestedActionKeyboardFocusIndicatorBorderColor = _ref.suggestedActionKeyboardFocusIndicatorBorderColor, suggestedActionKeyboardFocusIndicatorBorderRadius = _ref.suggestedActionKeyboardFocusIndicatorBorderRadius, suggestedActionKeyboardFocusIndicatorBorderStyle = _ref.suggestedActionKeyboardFocusIndicatorBorderStyle, suggestedActionKeyboardFocusIndicatorBorderWidth = _ref.suggestedActionKeyboardFocusIndicatorBorderWidth, suggestedActionKeyboardFocusIndicatorInset = _ref.suggestedActionKeyboardFocusIndicatorInset, suggestedActionHeight = _ref.suggestedActionHeight, suggestedActionImageHeight = _ref.suggestedActionImageHeight, suggestedActionsStackedLayoutButtonMaxHeight = _ref.suggestedActionsStackedLayoutButtonMaxHeight, subtle = _ref.subtle, suggestedActionActiveBackground = _ref.suggestedActionActiveBackground, suggestedActionBackground = _ref.suggestedActionBackground, suggestedActionDisabledBackground = _ref.suggestedActionDisabledBackground, suggestedActionFocusBackground = _ref.suggestedActionFocusBackground, suggestedActionHoverBackground = _ref.suggestedActionHoverBackground;
    return {
        "&.webchat__suggested-action": {
            alignItems: "center",
            background: suggestedActionBackground,
            // Deprecated as of 4.15.0. Remove on or after 2021-09-16.
            backgroundColor: suggestedActionBackgroundColor,
            borderColor: suggestedActionBorderColor || accent,
            borderRadius: suggestedActionBorderRadius,
            borderStyle: suggestedActionBorderStyle,
            borderWidth: suggestedActionBorderWidth,
            color: suggestedActionTextColor || accent,
            fontFamily: primaryFont,
            fontSize: "inherit",
            height: suggestedActionHeight,
            justifyContent: "center",
            maxWidth: "100%",
            outline: 0,
            paddingLeft: paddingWide,
            paddingRight: paddingWide,
            position: "relative",
            whiteSpace: "nowrap",
            width: "100%",
            // Order of style preferences (based on effort of user gesture): disabled > active > hover > focus.
            // Keyboard focus indicator styles applied by :focus-visible do not conflict with :active/:hover/:focus, so it is not included here.
            '&:disabled, &[aria-disabled="true"]': {
                background: suggestedActionDisabledBackground,
                backgroundColor: suggestedActionBackgroundColorOnDisabled,
                borderColor: suggestedActionBorderColorOnDisabled,
                borderStyle: suggestedActionBorderStyleOnDisabled,
                borderWidth: suggestedActionBorderWidthOnDisabled,
                color: suggestedActionTextColorOnDisabled || subtle
            },
            '&:not(:disabled):not([aria-disabled="true"])': {
                "&:active": {
                    background: suggestedActionActiveBackground,
                    backgroundColor: suggestedActionBackgroundColorOnActive,
                    borderColor: suggestedActionBorderColorOnActive,
                    borderStyle: suggestedActionBorderStyleOnActive,
                    borderWidth: suggestedActionBorderWidthOnActive,
                    color: suggestedActionTextColorOnActive
                },
                "&:not(:active)": {
                    "&:hover": {
                        background: suggestedActionHoverBackground,
                        backgroundColor: suggestedActionBackgroundColorOnHover,
                        borderColor: suggestedActionBorderColorOnHover,
                        borderStyle: suggestedActionBorderStyleOnHover,
                        borderWidth: suggestedActionBorderWidthOnHover,
                        color: suggestedActionTextColorOnHover
                    },
                    "&:not(:hover)": {
                        "&:focus": {
                            background: suggestedActionFocusBackground,
                            backgroundColor: suggestedActionBackgroundColorOnFocus,
                            borderColor: suggestedActionBorderColorOnFocus,
                            borderStyle: suggestedActionBorderStyleOnFocus,
                            borderWidth: suggestedActionBorderWidthOnFocus,
                            color: suggestedActionTextColorOnFocus
                        }
                    }
                }
            },
            // On unsupported browser, :focus-visible and :not(:focus-visible) is always false.
            // And it will turn the whole CSS selector ":unsupported, .truthy" to false.
            "&:not(:focus-visible) .webchat__suggested-action__keyboard-focus-indicator": {
                display: "none"
            },
            "&:not(.webchat__suggested-action--focus-visible) .webchat__suggested-action__keyboard-focus-indicator": {
                display: "none"
            },
            "&:not(.webchat__suggested-action--rtl) .webchat__suggested-action__image + .webchat__suggested-action__text": {
                paddingLeft: paddingRegular
            },
            "&.webchat__suggested-action--rtl .webchat__suggested-action__image + .webchat__suggested-action__text": {
                paddingRight: paddingRegular
            },
            "&.webchat__suggested-action--wrapping": {
                height: "auto",
                maxHeight: suggestedActionsStackedLayoutButtonMaxHeight || "100%",
                minHeight: typeof suggestedActionsStackedLayoutButtonMaxHeight === "number" && typeof suggestedActionHeight === "number" ? Math.min(suggestedActionsStackedLayoutButtonMaxHeight, suggestedActionHeight) : suggestedActionHeight
            },
            "& .webchat__suggested-action__image": {
                height: suggestedActionImageHeight
            },
            "& .webchat__suggested-action__keyboard-focus-indicator": {
                borderColor: suggestedActionKeyboardFocusIndicatorBorderColor,
                borderRadius: suggestedActionKeyboardFocusIndicatorBorderRadius,
                borderStyle: suggestedActionKeyboardFocusIndicatorBorderStyle,
                borderWidth: suggestedActionKeyboardFocusIndicatorBorderWidth,
                bottom: suggestedActionKeyboardFocusIndicatorInset,
                left: suggestedActionKeyboardFocusIndicatorInset,
                position: "absolute",
                right: suggestedActionKeyboardFocusIndicatorInset,
                top: suggestedActionKeyboardFocusIndicatorInset
            }
        }
    };
}

});

parcelRequire.register("bRKbk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $8a3877adf5a54423$var$createTextContentStyle;
/* eslint no-magic-numbers: "off" */ function $8a3877adf5a54423$var$createTextContentStyle(_ref) {
    var bubbleMaxWidth = _ref.bubbleMaxWidth, bubbleMinHeight = _ref.bubbleMinHeight, markdownExternalLinkIconImage = _ref.markdownExternalLinkIconImage, primaryFont = _ref.primaryFont, paddingRegular = _ref.paddingRegular;
    return {
        fontFamily: primaryFont,
        margin: 0,
        minHeight: bubbleMinHeight - paddingRegular * 2,
        padding: paddingRegular,
        "& > :first-child": {
            marginTop: 0
        },
        "& > :last-child": {
            marginBottom: 0
        },
        "&.markdown": {
            "& img:not(.webchat__markdown__external-link-icon)": {
                maxWidth: bubbleMaxWidth,
                width: "100%"
            },
            "& img.webchat__markdown__external-link-icon": {
                backgroundImage: markdownExternalLinkIconImage,
                height: ".75em",
                marginLeft: ".25em"
            },
            "& pre": {
                overflow: "hidden"
            }
        }
    };
}

});

parcelRequire.register("eYqQ3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $ae6b7ce48e5e6cf4$var$createToasterStyle;
/* eslint no-magic-numbers: ["off"] */ function $ae6b7ce48e5e6cf4$var$createToasterStyle(_ref) {
    var primaryFont = _ref.primaryFont, toasterHeight = _ref.toasterHeight, toasterMaxHeight = _ref.toasterMaxHeight, toastErrorBackgroundColor = _ref.toastErrorBackgroundColor, toastErrorColor = _ref.toastErrorColor, toasterSingularMaxHeight = _ref.toasterSingularMaxHeight, toastFontSize = _ref.toastFontSize, toastIconWidth = _ref.toastIconWidth, toastInfoBackgroundColor = _ref.toastInfoBackgroundColor, toastInfoColor = _ref.toastInfoColor, toastSeparatorColor = _ref.toastSeparatorColor, toastSuccessBackgroundColor = _ref.toastSuccessBackgroundColor, toastSuccessColor = _ref.toastSuccessColor, toastWarnBackgroundColor = _ref.toastWarnBackgroundColor, toastWarnColor = _ref.toastWarnColor;
    return {
        overflowY: "hidden",
        "&:not(.webchat__toaster--expandable)": {
            maxHeight: toasterSingularMaxHeight
        },
        "&.webchat__toaster--expandable:not(.webchat__toaster--expanded) > ul": {
            height: 0
        },
        "&.webchat__toaster--expandable.webchat__toaster--expanded": {
            maxHeight: toasterMaxHeight
        },
        "& .webchat__toaster__header": {
            alignItems: "center",
            alignSelf: "stretch",
            appearance: "none",
            backgroundColor: "Transparent",
            border: 0,
            display: "flex",
            fontFamily: primaryFont,
            fontSize: toastFontSize,
            minHeight: toasterHeight,
            outline: 0,
            padding: 0,
            textAlign: "left",
            "&:focus .webchat__toaster__expandIconFocus": {
                borderColor: "rgba(26, 10, 0, .7)"
            },
            "&:hover .webchat__toaster__expandIconFocus": {
                backgroundColor: "rgba(0, 0, 0, .12)"
            }
        },
        "& .webchat__toaster__expandIconFocus": {
            alignItems: "center",
            borderColor: "Transparent",
            borderStyle: "solid",
            borderWidth: 1,
            borderRadius: 3,
            display: "flex",
            height: 22,
            justifyContent: "center",
            width: 22
        },
        "&.webchat__toaster--error": {
            // TODO: Checks if pass A11y contrast ratio requirement
            "&:not(.webchat__toaster--expandable), & .webchat__toaster__header": {
                backgroundColor: toastErrorBackgroundColor
            },
            "& .webchat__toaster__header": {
                color: toastErrorColor,
                fill: toastErrorColor
            }
        },
        "&.webchat__toaster--info": {
            "&:not(.webchat__toaster--expandable), & .webchat__toaster__header": {
                backgroundColor: toastInfoBackgroundColor
            },
            "& .webchat__toaster__header": {
                color: toastInfoColor,
                fill: toastInfoColor
            }
        },
        "&.webchat__toaster--success": {
            "&:not(.webchat__toaster--expandable), & .webchat__toaster__header": {
                backgroundColor: toastSuccessBackgroundColor
            },
            "& .webchat__toaster__header": {
                color: toastSuccessColor,
                fill: toastSuccessColor
            }
        },
        "&.webchat__toaster--warn": {
            "&:not(.webchat__toaster--expandable), & .webchat__toaster__header": {
                backgroundColor: toastWarnBackgroundColor
            },
            "& .webchat__toaster__header": {
                color: toastWarnColor,
                fill: toastWarnColor
            }
        },
        "& .webchat__toaster__expandLevelIconBox": {
            height: toasterHeight,
            width: toastIconWidth
        },
        "& .webchat__toaster__expandIcon": {
            height: toasterHeight,
            width: toasterHeight
        },
        "& .webchat__toaster__expandText": {
            padding: "6px 0"
        },
        "& .webchat__toaster__expandLevelIconBox, & .webchat__toaster__expandIcon": {
            alignItems: "center",
            display: "flex",
            justifyContent: "center"
        },
        "& .webchat__toaster__list": {
            margin: 0,
            overflowY: "auto",
            padding: 0
        },
        "& .webchat__toaster__listItem:first-child:last-child": {
            overflow: "hidden"
        },
        "& .webchat__toaster__listItem:not(:first-child), & .webchat__toaster__listItem:not(:last-child)": {
            borderBottomColor: toastSeparatorColor,
            borderBottomStyle: "solid",
            borderBottomWidth: 1,
            minHeight: 32
        }
    };
}

});

parcelRequire.register("kDxZF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $f061d1925555abb7$var$createToastStyle;
/* eslint no-magic-numbers: ["off"] */ function $f061d1925555abb7$var$createToastStyle(_ref) {
    var primaryFont = _ref.primaryFont, toasterHeight = _ref.toasterHeight, toastErrorColor = _ref.toastErrorColor, toastFontSize = _ref.toastFontSize, toastIconWidth = _ref.toastIconWidth, toastInfoColor = _ref.toastInfoColor, toastSuccessColor = _ref.toastSuccessColor, toastTextPadding = _ref.toastTextPadding, toastWarnColor = _ref.toastWarnColor;
    return {
        fontFamily: primaryFont,
        fontSize: toastFontSize,
        minHeight: toasterHeight,
        "&.webchat__toast--error": {
            color: toastErrorColor,
            fill: toastErrorColor
        },
        "&.webchat__toast--info": {
            color: toastInfoColor,
            fill: toastInfoColor
        },
        "&.webchat__toast--success": {
            color: toastSuccessColor,
            fill: toastSuccessColor
        },
        "&.webchat__toast--warn": {
            color: toastWarnColor,
            fill: toastWarnColor
        },
        "& .webchat__toast__iconBox": {
            alignItems: "center",
            display: "flex",
            flexShrink: 0,
            height: toasterHeight,
            justifyContent: "center",
            width: toastIconWidth
        },
        "& .webchat__toast__dismissButton": {
            alignItems: "center",
            appearance: "none",
            backgroundColor: "Transparent",
            border: 0,
            display: "flex",
            height: toasterHeight,
            justifyContent: "center",
            outline: 0,
            padding: 0,
            width: toasterHeight,
            "&:focus .webchat__toast__dismissButtonFocus": {
                borderColor: "rgba(26, 10, 0, .7)"
            },
            "&:hover .webchat__toast__dismissButtonFocus": {
                backgroundColor: "rgba(0, 0, 0, .12)"
            }
        },
        "& .webchat__toast__dismissButtonFocus": {
            alignItems: "center",
            borderColor: "Transparent",
            borderStyle: "solid",
            borderWidth: 1,
            borderRadius: 3,
            display: "flex",
            height: 22,
            justifyContent: "center",
            width: 22
        },
        "& .webchat__toast__text": {
            alignSelf: "center",
            paddingBottom: toastTextPadding,
            paddingTop: toastTextPadding
        }
    };
}

});

parcelRequire.register("hhCgR", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $c951b604e8c20057$var$createTypingAnimationStyle;

var $l4PI2 = parcelRequire("l4PI2");
var $c951b604e8c20057$var$DEFAULT_IMAGE_BASE64 = "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";
var $c951b604e8c20057$var$DEFAULT_IMAGE_TYPE = "image/gif";
var $c951b604e8c20057$var$defaultImageBlobURL;
function $c951b604e8c20057$var$createTypingAnimationStyle(_ref) {
    var typingAnimationBackgroundImage = _ref.typingAnimationBackgroundImage, typingAnimationHeight = _ref.typingAnimationHeight, typingAnimationWidth = _ref.typingAnimationWidth;
    $c951b604e8c20057$var$defaultImageBlobURL || ($c951b604e8c20057$var$defaultImageBlobURL = URL.createObjectURL(new Blob([
        (0, $l4PI2.toByteArray)($c951b604e8c20057$var$DEFAULT_IMAGE_BASE64)
    ], {
        type: $c951b604e8c20057$var$DEFAULT_IMAGE_TYPE
    })));
    var backgroundImage = typingAnimationBackgroundImage || "url('".concat($c951b604e8c20057$var$defaultImageBlobURL, "')");
    return {
        backgroundImage: backgroundImage,
        backgroundRepeat: "no-repeat",
        height: typingAnimationHeight,
        width: typingAnimationWidth
    };
}

});

parcelRequire.register("2071W", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $175108f2b8de4bc3$var$createTypingIndicatorStyle;
function $175108f2b8de4bc3$var$createTypingIndicatorStyle(_ref) {
    var paddingRegular = _ref.paddingRegular;
    return {
        paddingBottom: paddingRegular,
        "&:not(.webchat__typingIndicator--rtl)": {
            paddingLeft: paddingRegular
        },
        "&.webchat__typingIndicator--rtl": {
            paddingRight: paddingRegular
        }
    };
}

});

parcelRequire.register("9KiNF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $7186fe376a8b3961$var$createUploadButtonStyle;
function $7186fe376a8b3961$var$createUploadButtonStyle(_ref) {
    var sendBoxButtonColor = _ref.sendBoxButtonColor, sendBoxButtonColorOnFocus = _ref.sendBoxButtonColorOnFocus, sendBoxButtonColorOnHover = _ref.sendBoxButtonColorOnHover, sendBoxHeight = _ref.sendBoxHeight, subtle = _ref.subtle;
    return {
        // We use the sendBoxHeight, so the button looks square
        width: sendBoxHeight,
        "& > .icon > svg": {
            fill: sendBoxButtonColor || subtle
        },
        "& > input:hover + .icon > svg": {
            fill: sendBoxButtonColorOnHover
        },
        "& > input:focus + .icon > svg": {
            fill: sendBoxButtonColorOnFocus
        }
    };
}

});

parcelRequire.register("8Vfqu", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $67ef9cf1e641c495$var$createVideoAttachmentStyle;
function $67ef9cf1e641c495$var$createVideoAttachmentStyle() {
    return {};
}

});

parcelRequire.register("5LQLQ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $433a46adcf6d1455$var$createVideoContentStyle;
function $433a46adcf6d1455$var$createVideoContentStyle(_ref) {
    var videoHeight = _ref.videoHeight;
    return {
        height: videoHeight,
        width: "100%"
    };
}

});

parcelRequire.register("33ges", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $238e3e46b3f881a5$var$createVimeoContentStyle;
function $238e3e46b3f881a5$var$createVimeoContentStyle(_ref) {
    var videoHeight = _ref.videoHeight;
    return {
        border: 0,
        height: videoHeight,
        width: "100%"
    };
}

});

parcelRequire.register("a6rCV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $75afe50e4105a799$var$createWarningNotificationStyle;
function $75afe50e4105a799$var$createWarningNotificationStyle(_ref) {
    var connectivityIconPadding = _ref.connectivityIconPadding, connectivityMarginLeftRight = _ref.connectivityMarginLeftRight, connectivityMarginTopBottom = _ref.connectivityMarginTopBottom, connectivityTextSize = _ref.connectivityTextSize, primaryFont = _ref.primaryFont, slowConnectivity = _ref.slowConnectivity, notificationText = _ref.notificationText;
    return {
        alignItems: "center",
        color: notificationText,
        // TODO: [P2] We should not set "display" in styleSet, this will allow the user to break the layout for no good reasons.
        display: "flex",
        fontFamily: primaryFont,
        fontSize: connectivityTextSize,
        marginBottom: connectivityMarginTopBottom,
        marginLeft: connectivityMarginLeftRight,
        marginRight: connectivityMarginLeftRight,
        marginTop: connectivityMarginTopBottom,
        "& > svg": {
            fill: slowConnectivity,
            "&:not(webchat__warning--rtl)": {
                paddingRight: connectivityIconPadding
            },
            "&.webchat__warning--rtl": {
                paddingLeft: connectivityIconPadding
            }
        }
    };
}

});

parcelRequire.register("8lnyc", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $61328d8f9a3b8dbb$var$createYouTubeContentStyle;
function $61328d8f9a3b8dbb$var$createYouTubeContentStyle(_ref) {
    var videoHeight = _ref.videoHeight;
    return {
        border: 0,
        height: videoHeight,
        width: "100%"
    };
}

});


parcelRequire.register("4D2tK", function(module, exports) {
"use strict";

module.exports = (parcelRequire("44Zbv"));

});
parcelRequire.register("44Zbv", function(module, exports) {
// Main parser class
"use strict";

var $iE2q6 = parcelRequire("iE2q6");

var $hb7pH = parcelRequire("hb7pH");

var $jZ7YV = parcelRequire("jZ7YV");

var $ggOc9 = parcelRequire("ggOc9");

var $5XVT8 = parcelRequire("5XVT8");

var $6JKNt = parcelRequire("6JKNt");

var $8wtzx = parcelRequire("8wtzx");

var $e2HUE = parcelRequire("e2HUE");

var $i3uit = parcelRequire("i3uit");



var $2f86ff22662e263e$var$config = {
    default: (parcelRequire("ev7VO")),
    zero: (parcelRequire("1GwiV")),
    commonmark: (parcelRequire("cANLb"))
};
////////////////////////////////////////////////////////////////////////////////
//
// This validator can prohibit more than really needed to prevent XSS. It's a
// tradeoff to keep code simple and to be secure by default.
//
// If you need different setup - override validator method as you wish. Or
// replace it with dummy function and use external sanitizer.
//
var $2f86ff22662e263e$var$BAD_PROTO_RE = /^(vbscript|javascript|file|data):/;
var $2f86ff22662e263e$var$GOOD_DATA_RE = /^data:image\/(gif|png|jpeg|webp);/;
function $2f86ff22662e263e$var$validateLink(url) {
    // url should be normalized at this point, and existing entities are decoded
    var str = url.trim().toLowerCase();
    return $2f86ff22662e263e$var$BAD_PROTO_RE.test(str) ? $2f86ff22662e263e$var$GOOD_DATA_RE.test(str) ? true : false : true;
}
////////////////////////////////////////////////////////////////////////////////
var $2f86ff22662e263e$var$RECODE_HOSTNAME_FOR = [
    "http:",
    "https:",
    "mailto:"
];
function $2f86ff22662e263e$var$normalizeLink(url) {
    var parsed = $e2HUE.parse(url, true);
    if (parsed.hostname) {
        // Encode hostnames in urls like:
        // `http://host/`, `https://host/`, `mailto:user@host`, `//host/`
        //
        // We don't encode unknown schemas, because it's likely that we encode
        // something we shouldn't (e.g. `skype:name` treated as `skype:host`)
        //
        if (!parsed.protocol || $2f86ff22662e263e$var$RECODE_HOSTNAME_FOR.indexOf(parsed.protocol) >= 0) try {
            parsed.hostname = $i3uit.toASCII(parsed.hostname);
        } catch (er) {}
    }
    return $e2HUE.encode($e2HUE.format(parsed));
}
function $2f86ff22662e263e$var$normalizeLinkText(url) {
    var parsed = $e2HUE.parse(url, true);
    if (parsed.hostname) {
        // Encode hostnames in urls like:
        // `http://host/`, `https://host/`, `mailto:user@host`, `//host/`
        //
        // We don't encode unknown schemas, because it's likely that we encode
        // something we shouldn't (e.g. `skype:name` treated as `skype:host`)
        //
        if (!parsed.protocol || $2f86ff22662e263e$var$RECODE_HOSTNAME_FOR.indexOf(parsed.protocol) >= 0) try {
            parsed.hostname = $i3uit.toUnicode(parsed.hostname);
        } catch (er) {}
    }
    // add '%' to exclude list because of https://github.com/markdown-it/markdown-it/issues/720
    return $e2HUE.decode($e2HUE.format(parsed), $e2HUE.decode.defaultChars + "%");
}
/**
 * class MarkdownIt
 *
 * Main parser/renderer class.
 *
 * ##### Usage
 *
 * ```javascript
 * // node.js, "classic" way:
 * var MarkdownIt = require('markdown-it'),
 *     md = new MarkdownIt();
 * var result = md.render('# markdown-it rulezz!');
 *
 * // node.js, the same, but with sugar:
 * var md = require('markdown-it')();
 * var result = md.render('# markdown-it rulezz!');
 *
 * // browser without AMD, added to "window" on script load
 * // Note, there are no dash.
 * var md = window.markdownit();
 * var result = md.render('# markdown-it rulezz!');
 * ```
 *
 * Single line rendering, without paragraph wrap:
 *
 * ```javascript
 * var md = require('markdown-it')();
 * var result = md.renderInline('__markdown-it__ rulezz!');
 * ```
 **/ /**
 * new MarkdownIt([presetName, options])
 * - presetName (String): optional, `commonmark` / `zero`
 * - options (Object)
 *
 * Creates parser instanse with given config. Can be called without `new`.
 *
 * ##### presetName
 *
 * MarkdownIt provides named presets as a convenience to quickly
 * enable/disable active syntax rules and options for common use cases.
 *
 * - ["commonmark"](https://github.com/markdown-it/markdown-it/blob/master/lib/presets/commonmark.js) -
 *   configures parser to strict [CommonMark](http://commonmark.org/) mode.
 * - [default](https://github.com/markdown-it/markdown-it/blob/master/lib/presets/default.js) -
 *   similar to GFM, used when no preset name given. Enables all available rules,
 *   but still without html, typographer & autolinker.
 * - ["zero"](https://github.com/markdown-it/markdown-it/blob/master/lib/presets/zero.js) -
 *   all rules disabled. Useful to quickly setup your config via `.enable()`.
 *   For example, when you need only `bold` and `italic` markup and nothing else.
 *
 * ##### options:
 *
 * - __html__ - `false`. Set `true` to enable HTML tags in source. Be careful!
 *   That's not safe! You may need external sanitizer to protect output from XSS.
 *   It's better to extend features via plugins, instead of enabling HTML.
 * - __xhtmlOut__ - `false`. Set `true` to add '/' when closing single tags
 *   (`<br />`). This is needed only for full CommonMark compatibility. In real
 *   world you will need HTML output.
 * - __breaks__ - `false`. Set `true` to convert `\n` in paragraphs into `<br>`.
 * - __langPrefix__ - `language-`. CSS language class prefix for fenced blocks.
 *   Can be useful for external highlighters.
 * - __linkify__ - `false`. Set `true` to autoconvert URL-like text to links.
 * - __typographer__  - `false`. Set `true` to enable [some language-neutral
 *   replacement](https://github.com/markdown-it/markdown-it/blob/master/lib/rules_core/replacements.js) +
 *   quotes beautification (smartquotes).
 * - __quotes__ - `“”‘’`, String or Array. Double + single quotes replacement
 *   pairs, when typographer enabled and smartquotes on. For example, you can
 *   use `'«»„“'` for Russian, `'„“‚‘'` for German, and
 *   `['«\xA0', '\xA0»', '‹\xA0', '\xA0›']` for French (including nbsp).
 * - __highlight__ - `null`. Highlighter function for fenced code blocks.
 *   Highlighter `function (str, lang)` should return escaped HTML. It can also
 *   return empty string if the source was not changed and should be escaped
 *   externaly. If result starts with <pre... internal wrapper is skipped.
 *
 * ##### Example
 *
 * ```javascript
 * // commonmark mode
 * var md = require('markdown-it')('commonmark');
 *
 * // default mode
 * var md = require('markdown-it')();
 *
 * // enable everything
 * var md = require('markdown-it')({
 *   html: true,
 *   linkify: true,
 *   typographer: true
 * });
 * ```
 *
 * ##### Syntax highlighting
 *
 * ```js
 * var hljs = require('highlight.js') // https://highlightjs.org/
 *
 * var md = require('markdown-it')({
 *   highlight: function (str, lang) {
 *     if (lang && hljs.getLanguage(lang)) {
 *       try {
 *         return hljs.highlight(str, { language: lang, ignoreIllegals: true }).value;
 *       } catch (__) {}
 *     }
 *
 *     return ''; // use external default escaping
 *   }
 * });
 * ```
 *
 * Or with full wrapper override (if you need assign class to `<pre>`):
 *
 * ```javascript
 * var hljs = require('highlight.js') // https://highlightjs.org/
 *
 * // Actual default values
 * var md = require('markdown-it')({
 *   highlight: function (str, lang) {
 *     if (lang && hljs.getLanguage(lang)) {
 *       try {
 *         return '<pre class="hljs"><code>' +
 *                hljs.highlight(str, { language: lang, ignoreIllegals: true }).value +
 *                '</code></pre>';
 *       } catch (__) {}
 *     }
 *
 *     return '<pre class="hljs"><code>' + md.utils.escapeHtml(str) + '</code></pre>';
 *   }
 * });
 * ```
 *
 **/ function $2f86ff22662e263e$var$MarkdownIt(presetName, options) {
    if (!(this instanceof $2f86ff22662e263e$var$MarkdownIt)) return new $2f86ff22662e263e$var$MarkdownIt(presetName, options);
    if (!options) {
        if (!$iE2q6.isString(presetName)) {
            options = presetName || {};
            presetName = "default";
        }
    }
    /**
   * MarkdownIt#inline -> ParserInline
   *
   * Instance of [[ParserInline]]. You may need it to add new rules when
   * writing plugins. For simple rules control use [[MarkdownIt.disable]] and
   * [[MarkdownIt.enable]].
   **/ this.inline = new $6JKNt();
    /**
   * MarkdownIt#block -> ParserBlock
   *
   * Instance of [[ParserBlock]]. You may need it to add new rules when
   * writing plugins. For simple rules control use [[MarkdownIt.disable]] and
   * [[MarkdownIt.enable]].
   **/ this.block = new $5XVT8();
    /**
   * MarkdownIt#core -> Core
   *
   * Instance of [[Core]] chain executor. You may need it to add new rules when
   * writing plugins. For simple rules control use [[MarkdownIt.disable]] and
   * [[MarkdownIt.enable]].
   **/ this.core = new $ggOc9();
    /**
   * MarkdownIt#renderer -> Renderer
   *
   * Instance of [[Renderer]]. Use it to modify output look. Or to add rendering
   * rules for new token types, generated by plugins.
   *
   * ##### Example
   *
   * ```javascript
   * var md = require('markdown-it')();
   *
   * function myToken(tokens, idx, options, env, self) {
   *   //...
   *   return result;
   * };
   *
   * md.renderer.rules['my_token'] = myToken
   * ```
   *
   * See [[Renderer]] docs and [source code](https://github.com/markdown-it/markdown-it/blob/master/lib/renderer.js).
   **/ this.renderer = new $jZ7YV();
    /**
   * MarkdownIt#linkify -> LinkifyIt
   *
   * [linkify-it](https://github.com/markdown-it/linkify-it) instance.
   * Used by [linkify](https://github.com/markdown-it/markdown-it/blob/master/lib/rules_core/linkify.js)
   * rule.
   **/ this.linkify = new $8wtzx();
    /**
   * MarkdownIt#validateLink(url) -> Boolean
   *
   * Link validation function. CommonMark allows too much in links. By default
   * we disable `javascript:`, `vbscript:`, `file:` schemas, and almost all `data:...` schemas
   * except some embedded image types.
   *
   * You can change this behaviour:
   *
   * ```javascript
   * var md = require('markdown-it')();
   * // enable everything
   * md.validateLink = function () { return true; }
   * ```
   **/ this.validateLink = $2f86ff22662e263e$var$validateLink;
    /**
   * MarkdownIt#normalizeLink(url) -> String
   *
   * Function used to encode link url to a machine-readable format,
   * which includes url-encoding, punycode, etc.
   **/ this.normalizeLink = $2f86ff22662e263e$var$normalizeLink;
    /**
   * MarkdownIt#normalizeLinkText(url) -> String
   *
   * Function used to decode link url to a human-readable format`
   **/ this.normalizeLinkText = $2f86ff22662e263e$var$normalizeLinkText;
    // Expose utils & helpers for easy acces from plugins
    /**
   * MarkdownIt#utils -> utils
   *
   * Assorted utility functions, useful to write plugins. See details
   * [here](https://github.com/markdown-it/markdown-it/blob/master/lib/common/utils.js).
   **/ this.utils = $iE2q6;
    /**
   * MarkdownIt#helpers -> helpers
   *
   * Link components parser functions, useful to write plugins. See details
   * [here](https://github.com/markdown-it/markdown-it/blob/master/lib/helpers).
   **/ this.helpers = $iE2q6.assign({}, $hb7pH);
    this.options = {};
    this.configure(presetName);
    if (options) this.set(options);
}
/** chainable
 * MarkdownIt.set(options)
 *
 * Set parser options (in the same format as in constructor). Probably, you
 * will never need it, but you can change options after constructor call.
 *
 * ##### Example
 *
 * ```javascript
 * var md = require('markdown-it')()
 *             .set({ html: true, breaks: true })
 *             .set({ typographer, true });
 * ```
 *
 * __Note:__ To achieve the best possible performance, don't modify a
 * `markdown-it` instance options on the fly. If you need multiple configurations
 * it's best to create multiple instances and initialize each with separate
 * config.
 **/ $2f86ff22662e263e$var$MarkdownIt.prototype.set = function(options) {
    $iE2q6.assign(this.options, options);
    return this;
};
/** chainable, internal
 * MarkdownIt.configure(presets)
 *
 * Batch load of all options and compenent settings. This is internal method,
 * and you probably will not need it. But if you will - see available presets
 * and data structure [here](https://github.com/markdown-it/markdown-it/tree/master/lib/presets)
 *
 * We strongly recommend to use presets instead of direct config loads. That
 * will give better compatibility with next versions.
 **/ $2f86ff22662e263e$var$MarkdownIt.prototype.configure = function(presets) {
    var self = this, presetName;
    if ($iE2q6.isString(presets)) {
        presetName = presets;
        presets = $2f86ff22662e263e$var$config[presetName];
        if (!presets) throw new Error('Wrong `markdown-it` preset "' + presetName + '", check name');
    }
    if (!presets) throw new Error("Wrong `markdown-it` preset, can't be empty");
    if (presets.options) self.set(presets.options);
    if (presets.components) Object.keys(presets.components).forEach(function(name) {
        if (presets.components[name].rules) self[name].ruler.enableOnly(presets.components[name].rules);
        if (presets.components[name].rules2) self[name].ruler2.enableOnly(presets.components[name].rules2);
    });
    return this;
};
/** chainable
 * MarkdownIt.enable(list, ignoreInvalid)
 * - list (String|Array): rule name or list of rule names to enable
 * - ignoreInvalid (Boolean): set `true` to ignore errors when rule not found.
 *
 * Enable list or rules. It will automatically find appropriate components,
 * containing rules with given names. If rule not found, and `ignoreInvalid`
 * not set - throws exception.
 *
 * ##### Example
 *
 * ```javascript
 * var md = require('markdown-it')()
 *             .enable(['sub', 'sup'])
 *             .disable('smartquotes');
 * ```
 **/ $2f86ff22662e263e$var$MarkdownIt.prototype.enable = function(list, ignoreInvalid) {
    var result = [];
    if (!Array.isArray(list)) list = [
        list
    ];
    [
        "core",
        "block",
        "inline"
    ].forEach(function(chain) {
        result = result.concat(this[chain].ruler.enable(list, true));
    }, this);
    result = result.concat(this.inline.ruler2.enable(list, true));
    var missed = list.filter(function(name) {
        return result.indexOf(name) < 0;
    });
    if (missed.length && !ignoreInvalid) throw new Error("MarkdownIt. Failed to enable unknown rule(s): " + missed);
    return this;
};
/** chainable
 * MarkdownIt.disable(list, ignoreInvalid)
 * - list (String|Array): rule name or list of rule names to disable.
 * - ignoreInvalid (Boolean): set `true` to ignore errors when rule not found.
 *
 * The same as [[MarkdownIt.enable]], but turn specified rules off.
 **/ $2f86ff22662e263e$var$MarkdownIt.prototype.disable = function(list, ignoreInvalid) {
    var result = [];
    if (!Array.isArray(list)) list = [
        list
    ];
    [
        "core",
        "block",
        "inline"
    ].forEach(function(chain) {
        result = result.concat(this[chain].ruler.disable(list, true));
    }, this);
    result = result.concat(this.inline.ruler2.disable(list, true));
    var missed = list.filter(function(name) {
        return result.indexOf(name) < 0;
    });
    if (missed.length && !ignoreInvalid) throw new Error("MarkdownIt. Failed to disable unknown rule(s): " + missed);
    return this;
};
/** chainable
 * MarkdownIt.use(plugin, params)
 *
 * Load specified plugin with given params into current parser instance.
 * It's just a sugar to call `plugin(md, params)` with curring.
 *
 * ##### Example
 *
 * ```javascript
 * var iterator = require('markdown-it-for-inline');
 * var md = require('markdown-it')()
 *             .use(iterator, 'foo_replace', 'text', function (tokens, idx) {
 *               tokens[idx].content = tokens[idx].content.replace(/foo/g, 'bar');
 *             });
 * ```
 **/ $2f86ff22662e263e$var$MarkdownIt.prototype.use = function(plugin /*, params, ... */ ) {
    var args = [
        this
    ].concat(Array.prototype.slice.call(arguments, 1));
    plugin.apply(plugin, args);
    return this;
};
/** internal
 * MarkdownIt.parse(src, env) -> Array
 * - src (String): source string
 * - env (Object): environment sandbox
 *
 * Parse input string and return list of block tokens (special token type
 * "inline" will contain list of inline tokens). You should not call this
 * method directly, until you write custom renderer (for example, to produce
 * AST).
 *
 * `env` is used to pass data between "distributed" rules and return additional
 * metadata like reference info, needed for the renderer. It also can be used to
 * inject data in specific cases. Usually, you will be ok to pass `{}`,
 * and then pass updated object to renderer.
 **/ $2f86ff22662e263e$var$MarkdownIt.prototype.parse = function(src, env) {
    if (typeof src !== "string") throw new Error("Input data should be a String");
    var state = new this.core.State(src, this, env);
    this.core.process(state);
    return state.tokens;
};
/**
 * MarkdownIt.render(src [, env]) -> String
 * - src (String): source string
 * - env (Object): environment sandbox
 *
 * Render markdown string into html. It does all magic for you :).
 *
 * `env` can be used to inject additional metadata (`{}` by default).
 * But you will not need it with high probability. See also comment
 * in [[MarkdownIt.parse]].
 **/ $2f86ff22662e263e$var$MarkdownIt.prototype.render = function(src, env) {
    env = env || {};
    return this.renderer.render(this.parse(src, env), this.options, env);
};
/** internal
 * MarkdownIt.parseInline(src, env) -> Array
 * - src (String): source string
 * - env (Object): environment sandbox
 *
 * The same as [[MarkdownIt.parse]] but skip all block rules. It returns the
 * block tokens list with the single `inline` element, containing parsed inline
 * tokens in `children` property. Also updates `env` object.
 **/ $2f86ff22662e263e$var$MarkdownIt.prototype.parseInline = function(src, env) {
    var state = new this.core.State(src, this, env);
    state.inlineMode = true;
    this.core.process(state);
    return state.tokens;
};
/**
 * MarkdownIt.renderInline(src [, env]) -> String
 * - src (String): source string
 * - env (Object): environment sandbox
 *
 * Similar to [[MarkdownIt.render]] but for single paragraph content. Result
 * will NOT be wrapped into `<p>` tags.
 **/ $2f86ff22662e263e$var$MarkdownIt.prototype.renderInline = function(src, env) {
    env = env || {};
    return this.renderer.render(this.parseInline(src, env), this.options, env);
};
module.exports = $2f86ff22662e263e$var$MarkdownIt;

});
parcelRequire.register("iE2q6", function(module, exports) {

$parcel$export(module.exports, "lib", () => $d92dd6fb81fd705b$export$16c08b91f883959a, (v) => $d92dd6fb81fd705b$export$16c08b91f883959a = v);
$parcel$export(module.exports, "assign", () => $d92dd6fb81fd705b$export$e6e34fd1f2686227, (v) => $d92dd6fb81fd705b$export$e6e34fd1f2686227 = v);
$parcel$export(module.exports, "isString", () => $d92dd6fb81fd705b$export$844ec244b1367d54, (v) => $d92dd6fb81fd705b$export$844ec244b1367d54 = v);
$parcel$export(module.exports, "has", () => $d92dd6fb81fd705b$export$a4f4bb6b1453fff5, (v) => $d92dd6fb81fd705b$export$a4f4bb6b1453fff5 = v);
$parcel$export(module.exports, "unescapeMd", () => $d92dd6fb81fd705b$export$5ccde1ea0c14bb03, (v) => $d92dd6fb81fd705b$export$5ccde1ea0c14bb03 = v);
$parcel$export(module.exports, "unescapeAll", () => $d92dd6fb81fd705b$export$db8a17c6655f7e2c, (v) => $d92dd6fb81fd705b$export$db8a17c6655f7e2c = v);
$parcel$export(module.exports, "isValidEntityCode", () => $d92dd6fb81fd705b$export$644a8f5b13b2a36d, (v) => $d92dd6fb81fd705b$export$644a8f5b13b2a36d = v);
$parcel$export(module.exports, "fromCodePoint", () => $d92dd6fb81fd705b$export$73bfc63873071f74, (v) => $d92dd6fb81fd705b$export$73bfc63873071f74 = v);
$parcel$export(module.exports, "escapeHtml", () => $d92dd6fb81fd705b$export$4cf11838cdc2a8a8, (v) => $d92dd6fb81fd705b$export$4cf11838cdc2a8a8 = v);
$parcel$export(module.exports, "arrayReplaceAt", () => $d92dd6fb81fd705b$export$f78478f71955b6bc, (v) => $d92dd6fb81fd705b$export$f78478f71955b6bc = v);
$parcel$export(module.exports, "isSpace", () => $d92dd6fb81fd705b$export$1d5ccafae59b4926, (v) => $d92dd6fb81fd705b$export$1d5ccafae59b4926 = v);
$parcel$export(module.exports, "isWhiteSpace", () => $d92dd6fb81fd705b$export$3c52dd84024ae72c, (v) => $d92dd6fb81fd705b$export$3c52dd84024ae72c = v);
$parcel$export(module.exports, "isMdAsciiPunct", () => $d92dd6fb81fd705b$export$829a0d33ae4e744, (v) => $d92dd6fb81fd705b$export$829a0d33ae4e744 = v);
$parcel$export(module.exports, "isPunctChar", () => $d92dd6fb81fd705b$export$4888a643af800fc1, (v) => $d92dd6fb81fd705b$export$4888a643af800fc1 = v);
$parcel$export(module.exports, "escapeRE", () => $d92dd6fb81fd705b$export$bc616c8f7dc20d5d, (v) => $d92dd6fb81fd705b$export$bc616c8f7dc20d5d = v);
$parcel$export(module.exports, "normalizeReference", () => $d92dd6fb81fd705b$export$20ef46802c8744b, (v) => $d92dd6fb81fd705b$export$20ef46802c8744b = v);
// Utilities
//
////////////////////////////////////////////////////////////////////////////////
// Re-export libraries commonly used in both markdown-it and its plugins,
// so plugins won't have to depend on them explicitly, which reduces their
// bundled size (e.g. a browser build).
//
var $d92dd6fb81fd705b$export$16c08b91f883959a;
var $d92dd6fb81fd705b$export$e6e34fd1f2686227;
var $d92dd6fb81fd705b$export$844ec244b1367d54;
var $d92dd6fb81fd705b$export$a4f4bb6b1453fff5;
var $d92dd6fb81fd705b$export$5ccde1ea0c14bb03;
var $d92dd6fb81fd705b$export$db8a17c6655f7e2c;
var $d92dd6fb81fd705b$export$644a8f5b13b2a36d;
var $d92dd6fb81fd705b$export$73bfc63873071f74;
// exports.replaceEntities     = replaceEntities;
var $d92dd6fb81fd705b$export$4cf11838cdc2a8a8;
var $d92dd6fb81fd705b$export$f78478f71955b6bc;
var $d92dd6fb81fd705b$export$1d5ccafae59b4926;
var $d92dd6fb81fd705b$export$3c52dd84024ae72c;
var $d92dd6fb81fd705b$export$829a0d33ae4e744;
var $d92dd6fb81fd705b$export$4888a643af800fc1;
var $d92dd6fb81fd705b$export$bc616c8f7dc20d5d;
var $d92dd6fb81fd705b$export$20ef46802c8744b;
"use strict";
function $d92dd6fb81fd705b$var$_class(obj) {
    return Object.prototype.toString.call(obj);
}
function $d92dd6fb81fd705b$var$isString(obj) {
    return $d92dd6fb81fd705b$var$_class(obj) === "[object String]";
}
var $d92dd6fb81fd705b$var$_hasOwnProperty = Object.prototype.hasOwnProperty;
function $d92dd6fb81fd705b$var$has(object, key) {
    return $d92dd6fb81fd705b$var$_hasOwnProperty.call(object, key);
}
// Merge objects
//
function $d92dd6fb81fd705b$var$assign(obj /*from1, from2, from3, ...*/ ) {
    var sources = Array.prototype.slice.call(arguments, 1);
    sources.forEach(function(source) {
        if (!source) return;
        if (typeof source !== "object") throw new TypeError(source + "must be object");
        Object.keys(source).forEach(function(key) {
            obj[key] = source[key];
        });
    });
    return obj;
}
// Remove element from array and put another array at those position.
// Useful for some operations with tokens
function $d92dd6fb81fd705b$var$arrayReplaceAt(src, pos, newElements) {
    return [].concat(src.slice(0, pos), newElements, src.slice(pos + 1));
}
////////////////////////////////////////////////////////////////////////////////
function $d92dd6fb81fd705b$var$isValidEntityCode(c) {
    /*eslint no-bitwise:0*/ // broken sequence
    if (c >= 0xD800 && c <= 0xDFFF) return false;
    // never used
    if (c >= 0xFDD0 && c <= 0xFDEF) return false;
    if ((c & 0xFFFF) === 0xFFFF || (c & 0xFFFF) === 0xFFFE) return false;
    // control codes
    if (c >= 0x00 && c <= 0x08) return false;
    if (c === 0x0B) return false;
    if (c >= 0x0E && c <= 0x1F) return false;
    if (c >= 0x7F && c <= 0x9F) return false;
    // out of range
    if (c > 0x10FFFF) return false;
    return true;
}
function $d92dd6fb81fd705b$var$fromCodePoint(c) {
    /*eslint no-bitwise:0*/ if (c > 0xffff) {
        c -= 0x10000;
        var surrogate1 = 0xd800 + (c >> 10), surrogate2 = 0xdc00 + (c & 0x3ff);
        return String.fromCharCode(surrogate1, surrogate2);
    }
    return String.fromCharCode(c);
}
var $d92dd6fb81fd705b$var$UNESCAPE_MD_RE = /\\([!"#$%&'()*+,\-.\/:;<=>?@[\\\]^_`{|}~])/g;
var $d92dd6fb81fd705b$var$ENTITY_RE = /&([a-z#][a-z0-9]{1,31});/gi;
var $d92dd6fb81fd705b$var$UNESCAPE_ALL_RE = new RegExp($d92dd6fb81fd705b$var$UNESCAPE_MD_RE.source + "|" + $d92dd6fb81fd705b$var$ENTITY_RE.source, "gi");
var $d92dd6fb81fd705b$var$DIGITAL_ENTITY_TEST_RE = /^#((?:x[a-f0-9]{1,8}|[0-9]{1,8}))/i;

var $1WpyR = parcelRequire("1WpyR");
function $d92dd6fb81fd705b$var$replaceEntityPattern(match, name) {
    var code = 0;
    if ($d92dd6fb81fd705b$var$has($1WpyR, name)) return $1WpyR[name];
    if (name.charCodeAt(0) === 0x23 /* # */  && $d92dd6fb81fd705b$var$DIGITAL_ENTITY_TEST_RE.test(name)) {
        code = name[1].toLowerCase() === "x" ? parseInt(name.slice(2), 16) : parseInt(name.slice(1), 10);
        if ($d92dd6fb81fd705b$var$isValidEntityCode(code)) return $d92dd6fb81fd705b$var$fromCodePoint(code);
    }
    return match;
}
/*function replaceEntities(str) {
  if (str.indexOf('&') < 0) { return str; }

  return str.replace(ENTITY_RE, replaceEntityPattern);
}*/ function $d92dd6fb81fd705b$var$unescapeMd(str) {
    if (str.indexOf("\\") < 0) return str;
    return str.replace($d92dd6fb81fd705b$var$UNESCAPE_MD_RE, "$1");
}
function $d92dd6fb81fd705b$var$unescapeAll(str) {
    if (str.indexOf("\\") < 0 && str.indexOf("&") < 0) return str;
    return str.replace($d92dd6fb81fd705b$var$UNESCAPE_ALL_RE, function(match, escaped, entity) {
        if (escaped) return escaped;
        return $d92dd6fb81fd705b$var$replaceEntityPattern(match, entity);
    });
}
////////////////////////////////////////////////////////////////////////////////
var $d92dd6fb81fd705b$var$HTML_ESCAPE_TEST_RE = /[&<>"]/;
var $d92dd6fb81fd705b$var$HTML_ESCAPE_REPLACE_RE = /[&<>"]/g;
var $d92dd6fb81fd705b$var$HTML_REPLACEMENTS = {
    "&": "&amp;",
    "<": "&lt;",
    ">": "&gt;",
    '"': "&quot;"
};
function $d92dd6fb81fd705b$var$replaceUnsafeChar(ch) {
    return $d92dd6fb81fd705b$var$HTML_REPLACEMENTS[ch];
}
function $d92dd6fb81fd705b$var$escapeHtml(str) {
    if ($d92dd6fb81fd705b$var$HTML_ESCAPE_TEST_RE.test(str)) return str.replace($d92dd6fb81fd705b$var$HTML_ESCAPE_REPLACE_RE, $d92dd6fb81fd705b$var$replaceUnsafeChar);
    return str;
}
////////////////////////////////////////////////////////////////////////////////
var $d92dd6fb81fd705b$var$REGEXP_ESCAPE_RE = /[.?*+^$[\]\\(){}|-]/g;
function $d92dd6fb81fd705b$var$escapeRE(str) {
    return str.replace($d92dd6fb81fd705b$var$REGEXP_ESCAPE_RE, "\\$&");
}
////////////////////////////////////////////////////////////////////////////////
function $d92dd6fb81fd705b$var$isSpace(code) {
    switch(code){
        case 0x09:
        case 0x20:
            return true;
    }
    return false;
}
// Zs (unicode class) || [\t\f\v\r\n]
function $d92dd6fb81fd705b$var$isWhiteSpace(code) {
    if (code >= 0x2000 && code <= 0x200A) return true;
    switch(code){
        case 0x09:
        case 0x0A:
        case 0x0B:
        case 0x0C:
        case 0x0D:
        case 0x20:
        case 0xA0:
        case 0x1680:
        case 0x202F:
        case 0x205F:
        case 0x3000:
            return true;
    }
    return false;
}

var $7X6km = parcelRequire("7X6km");
// Currently without astral characters support.
function $d92dd6fb81fd705b$var$isPunctChar(ch) {
    return $7X6km.test(ch);
}
// Markdown ASCII punctuation characters.
//
// !, ", #, $, %, &, ', (, ), *, +, ,, -, ., /, :, ;, <, =, >, ?, @, [, \, ], ^, _, `, {, |, }, or ~
// http://spec.commonmark.org/0.15/#ascii-punctuation-character
//
// Don't confuse with unicode punctuation !!! It lacks some chars in ascii range.
//
function $d92dd6fb81fd705b$var$isMdAsciiPunct(ch) {
    switch(ch){
        case 0x21 /* ! */ :
        case 0x22 /* " */ :
        case 0x23 /* # */ :
        case 0x24 /* $ */ :
        case 0x25 /* % */ :
        case 0x26 /* & */ :
        case 0x27 /* ' */ :
        case 0x28 /* ( */ :
        case 0x29 /* ) */ :
        case 0x2A /* * */ :
        case 0x2B /* + */ :
        case 0x2C /* , */ :
        case 0x2D /* - */ :
        case 0x2E /* . */ :
        case 0x2F /* / */ :
        case 0x3A /* : */ :
        case 0x3B /* ; */ :
        case 0x3C /* < */ :
        case 0x3D /* = */ :
        case 0x3E /* > */ :
        case 0x3F /* ? */ :
        case 0x40 /* @ */ :
        case 0x5B /* [ */ :
        case 0x5C /* \ */ :
        case 0x5D /* ] */ :
        case 0x5E /* ^ */ :
        case 0x5F /* _ */ :
        case 0x60 /* ` */ :
        case 0x7B /* { */ :
        case 0x7C /* | */ :
        case 0x7D /* } */ :
        case 0x7E /* ~ */ :
            return true;
        default:
            return false;
    }
}
// Hepler to unify [reference labels].
//
function $d92dd6fb81fd705b$var$normalizeReference(str) {
    // Trim and collapse whitespace
    //
    str = str.trim().replace(/\s+/g, " ");
    // In node v10 'ẞ'.toLowerCase() === 'Ṿ', which is presumed to be a bug
    // fixed in v12 (couldn't find any details).
    //
    // So treat this one as a special case
    // (remove this when node v10 is no longer supported).
    //
    if ("ẞ".toLowerCase() === "Ṿ") str = str.replace(/ẞ/g, "\xdf");
    // .toLowerCase().toUpperCase() should get rid of all differences
    // between letter variants.
    //
    // Simple .toLowerCase() doesn't normalize 125 code points correctly,
    // and .toUpperCase doesn't normalize 6 of them (list of exceptions:
    // İ, ϴ, ẞ, Ω, K, Å - those are already uppercased, but have differently
    // uppercased versions).
    //
    // Here's an example showing how it happens. Lets take greek letter omega:
    // uppercase U+0398 (Θ), U+03f4 (ϴ) and lowercase U+03b8 (θ), U+03d1 (ϑ)
    //
    // Unicode entries:
    // 0398;GREEK CAPITAL LETTER THETA;Lu;0;L;;;;;N;;;;03B8;
    // 03B8;GREEK SMALL LETTER THETA;Ll;0;L;;;;;N;;;0398;;0398
    // 03D1;GREEK THETA SYMBOL;Ll;0;L;<compat> 03B8;;;;N;GREEK SMALL LETTER SCRIPT THETA;;0398;;0398
    // 03F4;GREEK CAPITAL THETA SYMBOL;Lu;0;L;<compat> 0398;;;;N;;;;03B8;
    //
    // Case-insensitive comparison should treat all of them as equivalent.
    //
    // But .toLowerCase() doesn't change ϑ (it's already lowercase),
    // and .toUpperCase() doesn't change ϴ (already uppercase).
    //
    // Applying first lower then upper case normalizes any character:
    // '\u0398\u03f4\u03b8\u03d1'.toLowerCase().toUpperCase() === '\u0398\u0398\u0398\u0398'
    //
    // Note: this is equivalent to unicode case folding; unicode normalization
    // is a different step that is not required here.
    //
    // Final result should be uppercased, because it's later stored in an object
    // (this avoid a conflict with Object.prototype members,
    // most notably, `__proto__`)
    //
    return str.toLowerCase().toUpperCase();
}
$d92dd6fb81fd705b$export$16c08b91f883959a = {};

$d92dd6fb81fd705b$export$16c08b91f883959a.mdurl = (parcelRequire("e2HUE"));

$d92dd6fb81fd705b$export$16c08b91f883959a.ucmicro = (parcelRequire("7rqQE"));
$d92dd6fb81fd705b$export$e6e34fd1f2686227 = $d92dd6fb81fd705b$var$assign;
$d92dd6fb81fd705b$export$844ec244b1367d54 = $d92dd6fb81fd705b$var$isString;
$d92dd6fb81fd705b$export$a4f4bb6b1453fff5 = $d92dd6fb81fd705b$var$has;
$d92dd6fb81fd705b$export$5ccde1ea0c14bb03 = $d92dd6fb81fd705b$var$unescapeMd;
$d92dd6fb81fd705b$export$db8a17c6655f7e2c = $d92dd6fb81fd705b$var$unescapeAll;
$d92dd6fb81fd705b$export$644a8f5b13b2a36d = $d92dd6fb81fd705b$var$isValidEntityCode;
$d92dd6fb81fd705b$export$73bfc63873071f74 = $d92dd6fb81fd705b$var$fromCodePoint;
$d92dd6fb81fd705b$export$4cf11838cdc2a8a8 = $d92dd6fb81fd705b$var$escapeHtml;
$d92dd6fb81fd705b$export$f78478f71955b6bc = $d92dd6fb81fd705b$var$arrayReplaceAt;
$d92dd6fb81fd705b$export$1d5ccafae59b4926 = $d92dd6fb81fd705b$var$isSpace;
$d92dd6fb81fd705b$export$3c52dd84024ae72c = $d92dd6fb81fd705b$var$isWhiteSpace;
$d92dd6fb81fd705b$export$829a0d33ae4e744 = $d92dd6fb81fd705b$var$isMdAsciiPunct;
$d92dd6fb81fd705b$export$4888a643af800fc1 = $d92dd6fb81fd705b$var$isPunctChar;
$d92dd6fb81fd705b$export$bc616c8f7dc20d5d = $d92dd6fb81fd705b$var$escapeRE;
$d92dd6fb81fd705b$export$20ef46802c8744b = $d92dd6fb81fd705b$var$normalizeReference;

});
parcelRequire.register("1WpyR", function(module, exports) {
// HTML5 entities map: { name -> utf16string }
//
"use strict";

/*eslint quotes:0*/ module.exports = (parcelRequire("gNdCG"));

});
parcelRequire.register("gNdCG", function(module, exports) {
module.exports = JSON.parse('{"Aacute":"\xc1","aacute":"\xe1","Abreve":"Ă","abreve":"ă","ac":"∾","acd":"∿","acE":"∾̳","Acirc":"\xc2","acirc":"\xe2","acute":"\xb4","Acy":"А","acy":"а","AElig":"\xc6","aelig":"\xe6","af":"⁡","Afr":"\uD835\uDD04","afr":"\uD835\uDD1E","Agrave":"\xc0","agrave":"\xe0","alefsym":"ℵ","aleph":"ℵ","Alpha":"Α","alpha":"α","Amacr":"Ā","amacr":"ā","amalg":"⨿","amp":"&","AMP":"&","andand":"⩕","And":"⩓","and":"∧","andd":"⩜","andslope":"⩘","andv":"⩚","ang":"∠","ange":"⦤","angle":"∠","angmsdaa":"⦨","angmsdab":"⦩","angmsdac":"⦪","angmsdad":"⦫","angmsdae":"⦬","angmsdaf":"⦭","angmsdag":"⦮","angmsdah":"⦯","angmsd":"∡","angrt":"∟","angrtvb":"⊾","angrtvbd":"⦝","angsph":"∢","angst":"\xc5","angzarr":"⍼","Aogon":"Ą","aogon":"ą","Aopf":"\uD835\uDD38","aopf":"\uD835\uDD52","apacir":"⩯","ap":"≈","apE":"⩰","ape":"≊","apid":"≋","apos":"\'","ApplyFunction":"⁡","approx":"≈","approxeq":"≊","Aring":"\xc5","aring":"\xe5","Ascr":"\uD835\uDC9C","ascr":"\uD835\uDCB6","Assign":"≔","ast":"*","asymp":"≈","asympeq":"≍","Atilde":"\xc3","atilde":"\xe3","Auml":"\xc4","auml":"\xe4","awconint":"∳","awint":"⨑","backcong":"≌","backepsilon":"϶","backprime":"‵","backsim":"∽","backsimeq":"⋍","Backslash":"∖","Barv":"⫧","barvee":"⊽","barwed":"⌅","Barwed":"⌆","barwedge":"⌅","bbrk":"⎵","bbrktbrk":"⎶","bcong":"≌","Bcy":"Б","bcy":"б","bdquo":"„","becaus":"∵","because":"∵","Because":"∵","bemptyv":"⦰","bepsi":"϶","bernou":"ℬ","Bernoullis":"ℬ","Beta":"Β","beta":"β","beth":"ℶ","between":"≬","Bfr":"\uD835\uDD05","bfr":"\uD835\uDD1F","bigcap":"⋂","bigcirc":"◯","bigcup":"⋃","bigodot":"⨀","bigoplus":"⨁","bigotimes":"⨂","bigsqcup":"⨆","bigstar":"★","bigtriangledown":"▽","bigtriangleup":"△","biguplus":"⨄","bigvee":"⋁","bigwedge":"⋀","bkarow":"⤍","blacklozenge":"⧫","blacksquare":"▪","blacktriangle":"▴","blacktriangledown":"▾","blacktriangleleft":"◂","blacktriangleright":"▸","blank":"␣","blk12":"▒","blk14":"░","blk34":"▓","block":"█","bne":"=⃥","bnequiv":"≡⃥","bNot":"⫭","bnot":"⌐","Bopf":"\uD835\uDD39","bopf":"\uD835\uDD53","bot":"⊥","bottom":"⊥","bowtie":"⋈","boxbox":"⧉","boxdl":"┐","boxdL":"╕","boxDl":"╖","boxDL":"╗","boxdr":"┌","boxdR":"╒","boxDr":"╓","boxDR":"╔","boxh":"─","boxH":"═","boxhd":"┬","boxHd":"╤","boxhD":"╥","boxHD":"╦","boxhu":"┴","boxHu":"╧","boxhU":"╨","boxHU":"╩","boxminus":"⊟","boxplus":"⊞","boxtimes":"⊠","boxul":"┘","boxuL":"╛","boxUl":"╜","boxUL":"╝","boxur":"└","boxuR":"╘","boxUr":"╙","boxUR":"╚","boxv":"│","boxV":"║","boxvh":"┼","boxvH":"╪","boxVh":"╫","boxVH":"╬","boxvl":"┤","boxvL":"╡","boxVl":"╢","boxVL":"╣","boxvr":"├","boxvR":"╞","boxVr":"╟","boxVR":"╠","bprime":"‵","breve":"˘","Breve":"˘","brvbar":"\xa6","bscr":"\uD835\uDCB7","Bscr":"ℬ","bsemi":"⁏","bsim":"∽","bsime":"⋍","bsolb":"⧅","bsol":"\\\\","bsolhsub":"⟈","bull":"•","bullet":"•","bump":"≎","bumpE":"⪮","bumpe":"≏","Bumpeq":"≎","bumpeq":"≏","Cacute":"Ć","cacute":"ć","capand":"⩄","capbrcup":"⩉","capcap":"⩋","cap":"∩","Cap":"⋒","capcup":"⩇","capdot":"⩀","CapitalDifferentialD":"ⅅ","caps":"∩︀","caret":"⁁","caron":"ˇ","Cayleys":"ℭ","ccaps":"⩍","Ccaron":"Č","ccaron":"č","Ccedil":"\xc7","ccedil":"\xe7","Ccirc":"Ĉ","ccirc":"ĉ","Cconint":"∰","ccups":"⩌","ccupssm":"⩐","Cdot":"Ċ","cdot":"ċ","cedil":"\xb8","Cedilla":"\xb8","cemptyv":"⦲","cent":"\xa2","centerdot":"\xb7","CenterDot":"\xb7","cfr":"\uD835\uDD20","Cfr":"ℭ","CHcy":"Ч","chcy":"ч","check":"✓","checkmark":"✓","Chi":"Χ","chi":"χ","circ":"ˆ","circeq":"≗","circlearrowleft":"↺","circlearrowright":"↻","circledast":"⊛","circledcirc":"⊚","circleddash":"⊝","CircleDot":"⊙","circledR":"\xae","circledS":"Ⓢ","CircleMinus":"⊖","CirclePlus":"⊕","CircleTimes":"⊗","cir":"○","cirE":"⧃","cire":"≗","cirfnint":"⨐","cirmid":"⫯","cirscir":"⧂","ClockwiseContourIntegral":"∲","CloseCurlyDoubleQuote":"”","CloseCurlyQuote":"’","clubs":"♣","clubsuit":"♣","colon":":","Colon":"∷","Colone":"⩴","colone":"≔","coloneq":"≔","comma":",","commat":"@","comp":"∁","compfn":"∘","complement":"∁","complexes":"ℂ","cong":"≅","congdot":"⩭","Congruent":"≡","conint":"∮","Conint":"∯","ContourIntegral":"∮","copf":"\uD835\uDD54","Copf":"ℂ","coprod":"∐","Coproduct":"∐","copy":"\xa9","COPY":"\xa9","copysr":"℗","CounterClockwiseContourIntegral":"∳","crarr":"↵","cross":"✗","Cross":"⨯","Cscr":"\uD835\uDC9E","cscr":"\uD835\uDCB8","csub":"⫏","csube":"⫑","csup":"⫐","csupe":"⫒","ctdot":"⋯","cudarrl":"⤸","cudarrr":"⤵","cuepr":"⋞","cuesc":"⋟","cularr":"↶","cularrp":"⤽","cupbrcap":"⩈","cupcap":"⩆","CupCap":"≍","cup":"∪","Cup":"⋓","cupcup":"⩊","cupdot":"⊍","cupor":"⩅","cups":"∪︀","curarr":"↷","curarrm":"⤼","curlyeqprec":"⋞","curlyeqsucc":"⋟","curlyvee":"⋎","curlywedge":"⋏","curren":"\xa4","curvearrowleft":"↶","curvearrowright":"↷","cuvee":"⋎","cuwed":"⋏","cwconint":"∲","cwint":"∱","cylcty":"⌭","dagger":"†","Dagger":"‡","daleth":"ℸ","darr":"↓","Darr":"↡","dArr":"⇓","dash":"‐","Dashv":"⫤","dashv":"⊣","dbkarow":"⤏","dblac":"˝","Dcaron":"Ď","dcaron":"ď","Dcy":"Д","dcy":"д","ddagger":"‡","ddarr":"⇊","DD":"ⅅ","dd":"ⅆ","DDotrahd":"⤑","ddotseq":"⩷","deg":"\xb0","Del":"∇","Delta":"Δ","delta":"δ","demptyv":"⦱","dfisht":"⥿","Dfr":"\uD835\uDD07","dfr":"\uD835\uDD21","dHar":"⥥","dharl":"⇃","dharr":"⇂","DiacriticalAcute":"\xb4","DiacriticalDot":"˙","DiacriticalDoubleAcute":"˝","DiacriticalGrave":"`","DiacriticalTilde":"˜","diam":"⋄","diamond":"⋄","Diamond":"⋄","diamondsuit":"♦","diams":"♦","die":"\xa8","DifferentialD":"ⅆ","digamma":"ϝ","disin":"⋲","div":"\xf7","divide":"\xf7","divideontimes":"⋇","divonx":"⋇","DJcy":"Ђ","djcy":"ђ","dlcorn":"⌞","dlcrop":"⌍","dollar":"$","Dopf":"\uD835\uDD3B","dopf":"\uD835\uDD55","Dot":"\xa8","dot":"˙","DotDot":"⃜","doteq":"≐","doteqdot":"≑","DotEqual":"≐","dotminus":"∸","dotplus":"∔","dotsquare":"⊡","doublebarwedge":"⌆","DoubleContourIntegral":"∯","DoubleDot":"\xa8","DoubleDownArrow":"⇓","DoubleLeftArrow":"⇐","DoubleLeftRightArrow":"⇔","DoubleLeftTee":"⫤","DoubleLongLeftArrow":"⟸","DoubleLongLeftRightArrow":"⟺","DoubleLongRightArrow":"⟹","DoubleRightArrow":"⇒","DoubleRightTee":"⊨","DoubleUpArrow":"⇑","DoubleUpDownArrow":"⇕","DoubleVerticalBar":"∥","DownArrowBar":"⤓","downarrow":"↓","DownArrow":"↓","Downarrow":"⇓","DownArrowUpArrow":"⇵","DownBreve":"̑","downdownarrows":"⇊","downharpoonleft":"⇃","downharpoonright":"⇂","DownLeftRightVector":"⥐","DownLeftTeeVector":"⥞","DownLeftVectorBar":"⥖","DownLeftVector":"↽","DownRightTeeVector":"⥟","DownRightVectorBar":"⥗","DownRightVector":"⇁","DownTeeArrow":"↧","DownTee":"⊤","drbkarow":"⤐","drcorn":"⌟","drcrop":"⌌","Dscr":"\uD835\uDC9F","dscr":"\uD835\uDCB9","DScy":"Ѕ","dscy":"ѕ","dsol":"⧶","Dstrok":"Đ","dstrok":"đ","dtdot":"⋱","dtri":"▿","dtrif":"▾","duarr":"⇵","duhar":"⥯","dwangle":"⦦","DZcy":"Џ","dzcy":"џ","dzigrarr":"⟿","Eacute":"\xc9","eacute":"\xe9","easter":"⩮","Ecaron":"Ě","ecaron":"ě","Ecirc":"\xca","ecirc":"\xea","ecir":"≖","ecolon":"≕","Ecy":"Э","ecy":"э","eDDot":"⩷","Edot":"Ė","edot":"ė","eDot":"≑","ee":"ⅇ","efDot":"≒","Efr":"\uD835\uDD08","efr":"\uD835\uDD22","eg":"⪚","Egrave":"\xc8","egrave":"\xe8","egs":"⪖","egsdot":"⪘","el":"⪙","Element":"∈","elinters":"⏧","ell":"ℓ","els":"⪕","elsdot":"⪗","Emacr":"Ē","emacr":"ē","empty":"∅","emptyset":"∅","EmptySmallSquare":"◻","emptyv":"∅","EmptyVerySmallSquare":"▫","emsp13":" ","emsp14":" ","emsp":" ","ENG":"Ŋ","eng":"ŋ","ensp":" ","Eogon":"Ę","eogon":"ę","Eopf":"\uD835\uDD3C","eopf":"\uD835\uDD56","epar":"⋕","eparsl":"⧣","eplus":"⩱","epsi":"ε","Epsilon":"Ε","epsilon":"ε","epsiv":"ϵ","eqcirc":"≖","eqcolon":"≕","eqsim":"≂","eqslantgtr":"⪖","eqslantless":"⪕","Equal":"⩵","equals":"=","EqualTilde":"≂","equest":"≟","Equilibrium":"⇌","equiv":"≡","equivDD":"⩸","eqvparsl":"⧥","erarr":"⥱","erDot":"≓","escr":"ℯ","Escr":"ℰ","esdot":"≐","Esim":"⩳","esim":"≂","Eta":"Η","eta":"η","ETH":"\xd0","eth":"\xf0","Euml":"\xcb","euml":"\xeb","euro":"€","excl":"!","exist":"∃","Exists":"∃","expectation":"ℰ","exponentiale":"ⅇ","ExponentialE":"ⅇ","fallingdotseq":"≒","Fcy":"Ф","fcy":"ф","female":"♀","ffilig":"ﬃ","fflig":"ﬀ","ffllig":"ﬄ","Ffr":"\uD835\uDD09","ffr":"\uD835\uDD23","filig":"ﬁ","FilledSmallSquare":"◼","FilledVerySmallSquare":"▪","fjlig":"fj","flat":"♭","fllig":"ﬂ","fltns":"▱","fnof":"ƒ","Fopf":"\uD835\uDD3D","fopf":"\uD835\uDD57","forall":"∀","ForAll":"∀","fork":"⋔","forkv":"⫙","Fouriertrf":"ℱ","fpartint":"⨍","frac12":"\xbd","frac13":"⅓","frac14":"\xbc","frac15":"⅕","frac16":"⅙","frac18":"⅛","frac23":"⅔","frac25":"⅖","frac34":"\xbe","frac35":"⅗","frac38":"⅜","frac45":"⅘","frac56":"⅚","frac58":"⅝","frac78":"⅞","frasl":"⁄","frown":"⌢","fscr":"\uD835\uDCBB","Fscr":"ℱ","gacute":"ǵ","Gamma":"Γ","gamma":"γ","Gammad":"Ϝ","gammad":"ϝ","gap":"⪆","Gbreve":"Ğ","gbreve":"ğ","Gcedil":"Ģ","Gcirc":"Ĝ","gcirc":"ĝ","Gcy":"Г","gcy":"г","Gdot":"Ġ","gdot":"ġ","ge":"≥","gE":"≧","gEl":"⪌","gel":"⋛","geq":"≥","geqq":"≧","geqslant":"⩾","gescc":"⪩","ges":"⩾","gesdot":"⪀","gesdoto":"⪂","gesdotol":"⪄","gesl":"⋛︀","gesles":"⪔","Gfr":"\uD835\uDD0A","gfr":"\uD835\uDD24","gg":"≫","Gg":"⋙","ggg":"⋙","gimel":"ℷ","GJcy":"Ѓ","gjcy":"ѓ","gla":"⪥","gl":"≷","glE":"⪒","glj":"⪤","gnap":"⪊","gnapprox":"⪊","gne":"⪈","gnE":"≩","gneq":"⪈","gneqq":"≩","gnsim":"⋧","Gopf":"\uD835\uDD3E","gopf":"\uD835\uDD58","grave":"`","GreaterEqual":"≥","GreaterEqualLess":"⋛","GreaterFullEqual":"≧","GreaterGreater":"⪢","GreaterLess":"≷","GreaterSlantEqual":"⩾","GreaterTilde":"≳","Gscr":"\uD835\uDCA2","gscr":"ℊ","gsim":"≳","gsime":"⪎","gsiml":"⪐","gtcc":"⪧","gtcir":"⩺","gt":">","GT":">","Gt":"≫","gtdot":"⋗","gtlPar":"⦕","gtquest":"⩼","gtrapprox":"⪆","gtrarr":"⥸","gtrdot":"⋗","gtreqless":"⋛","gtreqqless":"⪌","gtrless":"≷","gtrsim":"≳","gvertneqq":"≩︀","gvnE":"≩︀","Hacek":"ˇ","hairsp":" ","half":"\xbd","hamilt":"ℋ","HARDcy":"Ъ","hardcy":"ъ","harrcir":"⥈","harr":"↔","hArr":"⇔","harrw":"↭","Hat":"^","hbar":"ℏ","Hcirc":"Ĥ","hcirc":"ĥ","hearts":"♥","heartsuit":"♥","hellip":"…","hercon":"⊹","hfr":"\uD835\uDD25","Hfr":"ℌ","HilbertSpace":"ℋ","hksearow":"⤥","hkswarow":"⤦","hoarr":"⇿","homtht":"∻","hookleftarrow":"↩","hookrightarrow":"↪","hopf":"\uD835\uDD59","Hopf":"ℍ","horbar":"―","HorizontalLine":"─","hscr":"\uD835\uDCBD","Hscr":"ℋ","hslash":"ℏ","Hstrok":"Ħ","hstrok":"ħ","HumpDownHump":"≎","HumpEqual":"≏","hybull":"⁃","hyphen":"‐","Iacute":"\xcd","iacute":"\xed","ic":"⁣","Icirc":"\xce","icirc":"\xee","Icy":"И","icy":"и","Idot":"İ","IEcy":"Е","iecy":"е","iexcl":"\xa1","iff":"⇔","ifr":"\uD835\uDD26","Ifr":"ℑ","Igrave":"\xcc","igrave":"\xec","ii":"ⅈ","iiiint":"⨌","iiint":"∭","iinfin":"⧜","iiota":"℩","IJlig":"Ĳ","ijlig":"ĳ","Imacr":"Ī","imacr":"ī","image":"ℑ","ImaginaryI":"ⅈ","imagline":"ℐ","imagpart":"ℑ","imath":"ı","Im":"ℑ","imof":"⊷","imped":"Ƶ","Implies":"⇒","incare":"℅","in":"∈","infin":"∞","infintie":"⧝","inodot":"ı","intcal":"⊺","int":"∫","Int":"∬","integers":"ℤ","Integral":"∫","intercal":"⊺","Intersection":"⋂","intlarhk":"⨗","intprod":"⨼","InvisibleComma":"⁣","InvisibleTimes":"⁢","IOcy":"Ё","iocy":"ё","Iogon":"Į","iogon":"į","Iopf":"\uD835\uDD40","iopf":"\uD835\uDD5A","Iota":"Ι","iota":"ι","iprod":"⨼","iquest":"\xbf","iscr":"\uD835\uDCBE","Iscr":"ℐ","isin":"∈","isindot":"⋵","isinE":"⋹","isins":"⋴","isinsv":"⋳","isinv":"∈","it":"⁢","Itilde":"Ĩ","itilde":"ĩ","Iukcy":"І","iukcy":"і","Iuml":"\xcf","iuml":"\xef","Jcirc":"Ĵ","jcirc":"ĵ","Jcy":"Й","jcy":"й","Jfr":"\uD835\uDD0D","jfr":"\uD835\uDD27","jmath":"ȷ","Jopf":"\uD835\uDD41","jopf":"\uD835\uDD5B","Jscr":"\uD835\uDCA5","jscr":"\uD835\uDCBF","Jsercy":"Ј","jsercy":"ј","Jukcy":"Є","jukcy":"є","Kappa":"Κ","kappa":"κ","kappav":"ϰ","Kcedil":"Ķ","kcedil":"ķ","Kcy":"К","kcy":"к","Kfr":"\uD835\uDD0E","kfr":"\uD835\uDD28","kgreen":"ĸ","KHcy":"Х","khcy":"х","KJcy":"Ќ","kjcy":"ќ","Kopf":"\uD835\uDD42","kopf":"\uD835\uDD5C","Kscr":"\uD835\uDCA6","kscr":"\uD835\uDCC0","lAarr":"⇚","Lacute":"Ĺ","lacute":"ĺ","laemptyv":"⦴","lagran":"ℒ","Lambda":"Λ","lambda":"λ","lang":"⟨","Lang":"⟪","langd":"⦑","langle":"⟨","lap":"⪅","Laplacetrf":"ℒ","laquo":"\xab","larrb":"⇤","larrbfs":"⤟","larr":"←","Larr":"↞","lArr":"⇐","larrfs":"⤝","larrhk":"↩","larrlp":"↫","larrpl":"⤹","larrsim":"⥳","larrtl":"↢","latail":"⤙","lAtail":"⤛","lat":"⪫","late":"⪭","lates":"⪭︀","lbarr":"⤌","lBarr":"⤎","lbbrk":"❲","lbrace":"{","lbrack":"[","lbrke":"⦋","lbrksld":"⦏","lbrkslu":"⦍","Lcaron":"Ľ","lcaron":"ľ","Lcedil":"Ļ","lcedil":"ļ","lceil":"⌈","lcub":"{","Lcy":"Л","lcy":"л","ldca":"⤶","ldquo":"“","ldquor":"„","ldrdhar":"⥧","ldrushar":"⥋","ldsh":"↲","le":"≤","lE":"≦","LeftAngleBracket":"⟨","LeftArrowBar":"⇤","leftarrow":"←","LeftArrow":"←","Leftarrow":"⇐","LeftArrowRightArrow":"⇆","leftarrowtail":"↢","LeftCeiling":"⌈","LeftDoubleBracket":"⟦","LeftDownTeeVector":"⥡","LeftDownVectorBar":"⥙","LeftDownVector":"⇃","LeftFloor":"⌊","leftharpoondown":"↽","leftharpoonup":"↼","leftleftarrows":"⇇","leftrightarrow":"↔","LeftRightArrow":"↔","Leftrightarrow":"⇔","leftrightarrows":"⇆","leftrightharpoons":"⇋","leftrightsquigarrow":"↭","LeftRightVector":"⥎","LeftTeeArrow":"↤","LeftTee":"⊣","LeftTeeVector":"⥚","leftthreetimes":"⋋","LeftTriangleBar":"⧏","LeftTriangle":"⊲","LeftTriangleEqual":"⊴","LeftUpDownVector":"⥑","LeftUpTeeVector":"⥠","LeftUpVectorBar":"⥘","LeftUpVector":"↿","LeftVectorBar":"⥒","LeftVector":"↼","lEg":"⪋","leg":"⋚","leq":"≤","leqq":"≦","leqslant":"⩽","lescc":"⪨","les":"⩽","lesdot":"⩿","lesdoto":"⪁","lesdotor":"⪃","lesg":"⋚︀","lesges":"⪓","lessapprox":"⪅","lessdot":"⋖","lesseqgtr":"⋚","lesseqqgtr":"⪋","LessEqualGreater":"⋚","LessFullEqual":"≦","LessGreater":"≶","lessgtr":"≶","LessLess":"⪡","lesssim":"≲","LessSlantEqual":"⩽","LessTilde":"≲","lfisht":"⥼","lfloor":"⌊","Lfr":"\uD835\uDD0F","lfr":"\uD835\uDD29","lg":"≶","lgE":"⪑","lHar":"⥢","lhard":"↽","lharu":"↼","lharul":"⥪","lhblk":"▄","LJcy":"Љ","ljcy":"љ","llarr":"⇇","ll":"≪","Ll":"⋘","llcorner":"⌞","Lleftarrow":"⇚","llhard":"⥫","lltri":"◺","Lmidot":"Ŀ","lmidot":"ŀ","lmoustache":"⎰","lmoust":"⎰","lnap":"⪉","lnapprox":"⪉","lne":"⪇","lnE":"≨","lneq":"⪇","lneqq":"≨","lnsim":"⋦","loang":"⟬","loarr":"⇽","lobrk":"⟦","longleftarrow":"⟵","LongLeftArrow":"⟵","Longleftarrow":"⟸","longleftrightarrow":"⟷","LongLeftRightArrow":"⟷","Longleftrightarrow":"⟺","longmapsto":"⟼","longrightarrow":"⟶","LongRightArrow":"⟶","Longrightarrow":"⟹","looparrowleft":"↫","looparrowright":"↬","lopar":"⦅","Lopf":"\uD835\uDD43","lopf":"\uD835\uDD5D","loplus":"⨭","lotimes":"⨴","lowast":"∗","lowbar":"_","LowerLeftArrow":"↙","LowerRightArrow":"↘","loz":"◊","lozenge":"◊","lozf":"⧫","lpar":"(","lparlt":"⦓","lrarr":"⇆","lrcorner":"⌟","lrhar":"⇋","lrhard":"⥭","lrm":"‎","lrtri":"⊿","lsaquo":"‹","lscr":"\uD835\uDCC1","Lscr":"ℒ","lsh":"↰","Lsh":"↰","lsim":"≲","lsime":"⪍","lsimg":"⪏","lsqb":"[","lsquo":"‘","lsquor":"‚","Lstrok":"Ł","lstrok":"ł","ltcc":"⪦","ltcir":"⩹","lt":"<","LT":"<","Lt":"≪","ltdot":"⋖","lthree":"⋋","ltimes":"⋉","ltlarr":"⥶","ltquest":"⩻","ltri":"◃","ltrie":"⊴","ltrif":"◂","ltrPar":"⦖","lurdshar":"⥊","luruhar":"⥦","lvertneqq":"≨︀","lvnE":"≨︀","macr":"\xaf","male":"♂","malt":"✠","maltese":"✠","Map":"⤅","map":"↦","mapsto":"↦","mapstodown":"↧","mapstoleft":"↤","mapstoup":"↥","marker":"▮","mcomma":"⨩","Mcy":"М","mcy":"м","mdash":"—","mDDot":"∺","measuredangle":"∡","MediumSpace":" ","Mellintrf":"ℳ","Mfr":"\uD835\uDD10","mfr":"\uD835\uDD2A","mho":"℧","micro":"\xb5","midast":"*","midcir":"⫰","mid":"∣","middot":"\xb7","minusb":"⊟","minus":"−","minusd":"∸","minusdu":"⨪","MinusPlus":"∓","mlcp":"⫛","mldr":"…","mnplus":"∓","models":"⊧","Mopf":"\uD835\uDD44","mopf":"\uD835\uDD5E","mp":"∓","mscr":"\uD835\uDCC2","Mscr":"ℳ","mstpos":"∾","Mu":"Μ","mu":"μ","multimap":"⊸","mumap":"⊸","nabla":"∇","Nacute":"Ń","nacute":"ń","nang":"∠⃒","nap":"≉","napE":"⩰̸","napid":"≋̸","napos":"ŉ","napprox":"≉","natural":"♮","naturals":"ℕ","natur":"♮","nbsp":"\xa0","nbump":"≎̸","nbumpe":"≏̸","ncap":"⩃","Ncaron":"Ň","ncaron":"ň","Ncedil":"Ņ","ncedil":"ņ","ncong":"≇","ncongdot":"⩭̸","ncup":"⩂","Ncy":"Н","ncy":"н","ndash":"–","nearhk":"⤤","nearr":"↗","neArr":"⇗","nearrow":"↗","ne":"≠","nedot":"≐̸","NegativeMediumSpace":"​","NegativeThickSpace":"​","NegativeThinSpace":"​","NegativeVeryThinSpace":"​","nequiv":"≢","nesear":"⤨","nesim":"≂̸","NestedGreaterGreater":"≫","NestedLessLess":"≪","NewLine":"\\n","nexist":"∄","nexists":"∄","Nfr":"\uD835\uDD11","nfr":"\uD835\uDD2B","ngE":"≧̸","nge":"≱","ngeq":"≱","ngeqq":"≧̸","ngeqslant":"⩾̸","nges":"⩾̸","nGg":"⋙̸","ngsim":"≵","nGt":"≫⃒","ngt":"≯","ngtr":"≯","nGtv":"≫̸","nharr":"↮","nhArr":"⇎","nhpar":"⫲","ni":"∋","nis":"⋼","nisd":"⋺","niv":"∋","NJcy":"Њ","njcy":"њ","nlarr":"↚","nlArr":"⇍","nldr":"‥","nlE":"≦̸","nle":"≰","nleftarrow":"↚","nLeftarrow":"⇍","nleftrightarrow":"↮","nLeftrightarrow":"⇎","nleq":"≰","nleqq":"≦̸","nleqslant":"⩽̸","nles":"⩽̸","nless":"≮","nLl":"⋘̸","nlsim":"≴","nLt":"≪⃒","nlt":"≮","nltri":"⋪","nltrie":"⋬","nLtv":"≪̸","nmid":"∤","NoBreak":"⁠","NonBreakingSpace":"\xa0","nopf":"\uD835\uDD5F","Nopf":"ℕ","Not":"⫬","not":"\xac","NotCongruent":"≢","NotCupCap":"≭","NotDoubleVerticalBar":"∦","NotElement":"∉","NotEqual":"≠","NotEqualTilde":"≂̸","NotExists":"∄","NotGreater":"≯","NotGreaterEqual":"≱","NotGreaterFullEqual":"≧̸","NotGreaterGreater":"≫̸","NotGreaterLess":"≹","NotGreaterSlantEqual":"⩾̸","NotGreaterTilde":"≵","NotHumpDownHump":"≎̸","NotHumpEqual":"≏̸","notin":"∉","notindot":"⋵̸","notinE":"⋹̸","notinva":"∉","notinvb":"⋷","notinvc":"⋶","NotLeftTriangleBar":"⧏̸","NotLeftTriangle":"⋪","NotLeftTriangleEqual":"⋬","NotLess":"≮","NotLessEqual":"≰","NotLessGreater":"≸","NotLessLess":"≪̸","NotLessSlantEqual":"⩽̸","NotLessTilde":"≴","NotNestedGreaterGreater":"⪢̸","NotNestedLessLess":"⪡̸","notni":"∌","notniva":"∌","notnivb":"⋾","notnivc":"⋽","NotPrecedes":"⊀","NotPrecedesEqual":"⪯̸","NotPrecedesSlantEqual":"⋠","NotReverseElement":"∌","NotRightTriangleBar":"⧐̸","NotRightTriangle":"⋫","NotRightTriangleEqual":"⋭","NotSquareSubset":"⊏̸","NotSquareSubsetEqual":"⋢","NotSquareSuperset":"⊐̸","NotSquareSupersetEqual":"⋣","NotSubset":"⊂⃒","NotSubsetEqual":"⊈","NotSucceeds":"⊁","NotSucceedsEqual":"⪰̸","NotSucceedsSlantEqual":"⋡","NotSucceedsTilde":"≿̸","NotSuperset":"⊃⃒","NotSupersetEqual":"⊉","NotTilde":"≁","NotTildeEqual":"≄","NotTildeFullEqual":"≇","NotTildeTilde":"≉","NotVerticalBar":"∤","nparallel":"∦","npar":"∦","nparsl":"⫽⃥","npart":"∂̸","npolint":"⨔","npr":"⊀","nprcue":"⋠","nprec":"⊀","npreceq":"⪯̸","npre":"⪯̸","nrarrc":"⤳̸","nrarr":"↛","nrArr":"⇏","nrarrw":"↝̸","nrightarrow":"↛","nRightarrow":"⇏","nrtri":"⋫","nrtrie":"⋭","nsc":"⊁","nsccue":"⋡","nsce":"⪰̸","Nscr":"\uD835\uDCA9","nscr":"\uD835\uDCC3","nshortmid":"∤","nshortparallel":"∦","nsim":"≁","nsime":"≄","nsimeq":"≄","nsmid":"∤","nspar":"∦","nsqsube":"⋢","nsqsupe":"⋣","nsub":"⊄","nsubE":"⫅̸","nsube":"⊈","nsubset":"⊂⃒","nsubseteq":"⊈","nsubseteqq":"⫅̸","nsucc":"⊁","nsucceq":"⪰̸","nsup":"⊅","nsupE":"⫆̸","nsupe":"⊉","nsupset":"⊃⃒","nsupseteq":"⊉","nsupseteqq":"⫆̸","ntgl":"≹","Ntilde":"\xd1","ntilde":"\xf1","ntlg":"≸","ntriangleleft":"⋪","ntrianglelefteq":"⋬","ntriangleright":"⋫","ntrianglerighteq":"⋭","Nu":"Ν","nu":"ν","num":"#","numero":"№","numsp":" ","nvap":"≍⃒","nvdash":"⊬","nvDash":"⊭","nVdash":"⊮","nVDash":"⊯","nvge":"≥⃒","nvgt":">⃒","nvHarr":"⤄","nvinfin":"⧞","nvlArr":"⤂","nvle":"≤⃒","nvlt":"<⃒","nvltrie":"⊴⃒","nvrArr":"⤃","nvrtrie":"⊵⃒","nvsim":"∼⃒","nwarhk":"⤣","nwarr":"↖","nwArr":"⇖","nwarrow":"↖","nwnear":"⤧","Oacute":"\xd3","oacute":"\xf3","oast":"⊛","Ocirc":"\xd4","ocirc":"\xf4","ocir":"⊚","Ocy":"О","ocy":"о","odash":"⊝","Odblac":"Ő","odblac":"ő","odiv":"⨸","odot":"⊙","odsold":"⦼","OElig":"Œ","oelig":"œ","ofcir":"⦿","Ofr":"\uD835\uDD12","ofr":"\uD835\uDD2C","ogon":"˛","Ograve":"\xd2","ograve":"\xf2","ogt":"⧁","ohbar":"⦵","ohm":"Ω","oint":"∮","olarr":"↺","olcir":"⦾","olcross":"⦻","oline":"‾","olt":"⧀","Omacr":"Ō","omacr":"ō","Omega":"Ω","omega":"ω","Omicron":"Ο","omicron":"ο","omid":"⦶","ominus":"⊖","Oopf":"\uD835\uDD46","oopf":"\uD835\uDD60","opar":"⦷","OpenCurlyDoubleQuote":"“","OpenCurlyQuote":"‘","operp":"⦹","oplus":"⊕","orarr":"↻","Or":"⩔","or":"∨","ord":"⩝","order":"ℴ","orderof":"ℴ","ordf":"\xaa","ordm":"\xba","origof":"⊶","oror":"⩖","orslope":"⩗","orv":"⩛","oS":"Ⓢ","Oscr":"\uD835\uDCAA","oscr":"ℴ","Oslash":"\xd8","oslash":"\xf8","osol":"⊘","Otilde":"\xd5","otilde":"\xf5","otimesas":"⨶","Otimes":"⨷","otimes":"⊗","Ouml":"\xd6","ouml":"\xf6","ovbar":"⌽","OverBar":"‾","OverBrace":"⏞","OverBracket":"⎴","OverParenthesis":"⏜","para":"\xb6","parallel":"∥","par":"∥","parsim":"⫳","parsl":"⫽","part":"∂","PartialD":"∂","Pcy":"П","pcy":"п","percnt":"%","period":".","permil":"‰","perp":"⊥","pertenk":"‱","Pfr":"\uD835\uDD13","pfr":"\uD835\uDD2D","Phi":"Φ","phi":"φ","phiv":"ϕ","phmmat":"ℳ","phone":"☎","Pi":"Π","pi":"π","pitchfork":"⋔","piv":"ϖ","planck":"ℏ","planckh":"ℎ","plankv":"ℏ","plusacir":"⨣","plusb":"⊞","pluscir":"⨢","plus":"+","plusdo":"∔","plusdu":"⨥","pluse":"⩲","PlusMinus":"\xb1","plusmn":"\xb1","plussim":"⨦","plustwo":"⨧","pm":"\xb1","Poincareplane":"ℌ","pointint":"⨕","popf":"\uD835\uDD61","Popf":"ℙ","pound":"\xa3","prap":"⪷","Pr":"⪻","pr":"≺","prcue":"≼","precapprox":"⪷","prec":"≺","preccurlyeq":"≼","Precedes":"≺","PrecedesEqual":"⪯","PrecedesSlantEqual":"≼","PrecedesTilde":"≾","preceq":"⪯","precnapprox":"⪹","precneqq":"⪵","precnsim":"⋨","pre":"⪯","prE":"⪳","precsim":"≾","prime":"′","Prime":"″","primes":"ℙ","prnap":"⪹","prnE":"⪵","prnsim":"⋨","prod":"∏","Product":"∏","profalar":"⌮","profline":"⌒","profsurf":"⌓","prop":"∝","Proportional":"∝","Proportion":"∷","propto":"∝","prsim":"≾","prurel":"⊰","Pscr":"\uD835\uDCAB","pscr":"\uD835\uDCC5","Psi":"Ψ","psi":"ψ","puncsp":" ","Qfr":"\uD835\uDD14","qfr":"\uD835\uDD2E","qint":"⨌","qopf":"\uD835\uDD62","Qopf":"ℚ","qprime":"⁗","Qscr":"\uD835\uDCAC","qscr":"\uD835\uDCC6","quaternions":"ℍ","quatint":"⨖","quest":"?","questeq":"≟","quot":"\\"","QUOT":"\\"","rAarr":"⇛","race":"∽̱","Racute":"Ŕ","racute":"ŕ","radic":"√","raemptyv":"⦳","rang":"⟩","Rang":"⟫","rangd":"⦒","range":"⦥","rangle":"⟩","raquo":"\xbb","rarrap":"⥵","rarrb":"⇥","rarrbfs":"⤠","rarrc":"⤳","rarr":"→","Rarr":"↠","rArr":"⇒","rarrfs":"⤞","rarrhk":"↪","rarrlp":"↬","rarrpl":"⥅","rarrsim":"⥴","Rarrtl":"⤖","rarrtl":"↣","rarrw":"↝","ratail":"⤚","rAtail":"⤜","ratio":"∶","rationals":"ℚ","rbarr":"⤍","rBarr":"⤏","RBarr":"⤐","rbbrk":"❳","rbrace":"}","rbrack":"]","rbrke":"⦌","rbrksld":"⦎","rbrkslu":"⦐","Rcaron":"Ř","rcaron":"ř","Rcedil":"Ŗ","rcedil":"ŗ","rceil":"⌉","rcub":"}","Rcy":"Р","rcy":"р","rdca":"⤷","rdldhar":"⥩","rdquo":"”","rdquor":"”","rdsh":"↳","real":"ℜ","realine":"ℛ","realpart":"ℜ","reals":"ℝ","Re":"ℜ","rect":"▭","reg":"\xae","REG":"\xae","ReverseElement":"∋","ReverseEquilibrium":"⇋","ReverseUpEquilibrium":"⥯","rfisht":"⥽","rfloor":"⌋","rfr":"\uD835\uDD2F","Rfr":"ℜ","rHar":"⥤","rhard":"⇁","rharu":"⇀","rharul":"⥬","Rho":"Ρ","rho":"ρ","rhov":"ϱ","RightAngleBracket":"⟩","RightArrowBar":"⇥","rightarrow":"→","RightArrow":"→","Rightarrow":"⇒","RightArrowLeftArrow":"⇄","rightarrowtail":"↣","RightCeiling":"⌉","RightDoubleBracket":"⟧","RightDownTeeVector":"⥝","RightDownVectorBar":"⥕","RightDownVector":"⇂","RightFloor":"⌋","rightharpoondown":"⇁","rightharpoonup":"⇀","rightleftarrows":"⇄","rightleftharpoons":"⇌","rightrightarrows":"⇉","rightsquigarrow":"↝","RightTeeArrow":"↦","RightTee":"⊢","RightTeeVector":"⥛","rightthreetimes":"⋌","RightTriangleBar":"⧐","RightTriangle":"⊳","RightTriangleEqual":"⊵","RightUpDownVector":"⥏","RightUpTeeVector":"⥜","RightUpVectorBar":"⥔","RightUpVector":"↾","RightVectorBar":"⥓","RightVector":"⇀","ring":"˚","risingdotseq":"≓","rlarr":"⇄","rlhar":"⇌","rlm":"‏","rmoustache":"⎱","rmoust":"⎱","rnmid":"⫮","roang":"⟭","roarr":"⇾","robrk":"⟧","ropar":"⦆","ropf":"\uD835\uDD63","Ropf":"ℝ","roplus":"⨮","rotimes":"⨵","RoundImplies":"⥰","rpar":")","rpargt":"⦔","rppolint":"⨒","rrarr":"⇉","Rrightarrow":"⇛","rsaquo":"›","rscr":"\uD835\uDCC7","Rscr":"ℛ","rsh":"↱","Rsh":"↱","rsqb":"]","rsquo":"’","rsquor":"’","rthree":"⋌","rtimes":"⋊","rtri":"▹","rtrie":"⊵","rtrif":"▸","rtriltri":"⧎","RuleDelayed":"⧴","ruluhar":"⥨","rx":"℞","Sacute":"Ś","sacute":"ś","sbquo":"‚","scap":"⪸","Scaron":"Š","scaron":"š","Sc":"⪼","sc":"≻","sccue":"≽","sce":"⪰","scE":"⪴","Scedil":"Ş","scedil":"ş","Scirc":"Ŝ","scirc":"ŝ","scnap":"⪺","scnE":"⪶","scnsim":"⋩","scpolint":"⨓","scsim":"≿","Scy":"С","scy":"с","sdotb":"⊡","sdot":"⋅","sdote":"⩦","searhk":"⤥","searr":"↘","seArr":"⇘","searrow":"↘","sect":"\xa7","semi":";","seswar":"⤩","setminus":"∖","setmn":"∖","sext":"✶","Sfr":"\uD835\uDD16","sfr":"\uD835\uDD30","sfrown":"⌢","sharp":"♯","SHCHcy":"Щ","shchcy":"щ","SHcy":"Ш","shcy":"ш","ShortDownArrow":"↓","ShortLeftArrow":"←","shortmid":"∣","shortparallel":"∥","ShortRightArrow":"→","ShortUpArrow":"↑","shy":"\xad","Sigma":"Σ","sigma":"σ","sigmaf":"ς","sigmav":"ς","sim":"∼","simdot":"⩪","sime":"≃","simeq":"≃","simg":"⪞","simgE":"⪠","siml":"⪝","simlE":"⪟","simne":"≆","simplus":"⨤","simrarr":"⥲","slarr":"←","SmallCircle":"∘","smallsetminus":"∖","smashp":"⨳","smeparsl":"⧤","smid":"∣","smile":"⌣","smt":"⪪","smte":"⪬","smtes":"⪬︀","SOFTcy":"Ь","softcy":"ь","solbar":"⌿","solb":"⧄","sol":"/","Sopf":"\uD835\uDD4A","sopf":"\uD835\uDD64","spades":"♠","spadesuit":"♠","spar":"∥","sqcap":"⊓","sqcaps":"⊓︀","sqcup":"⊔","sqcups":"⊔︀","Sqrt":"√","sqsub":"⊏","sqsube":"⊑","sqsubset":"⊏","sqsubseteq":"⊑","sqsup":"⊐","sqsupe":"⊒","sqsupset":"⊐","sqsupseteq":"⊒","square":"□","Square":"□","SquareIntersection":"⊓","SquareSubset":"⊏","SquareSubsetEqual":"⊑","SquareSuperset":"⊐","SquareSupersetEqual":"⊒","SquareUnion":"⊔","squarf":"▪","squ":"□","squf":"▪","srarr":"→","Sscr":"\uD835\uDCAE","sscr":"\uD835\uDCC8","ssetmn":"∖","ssmile":"⌣","sstarf":"⋆","Star":"⋆","star":"☆","starf":"★","straightepsilon":"ϵ","straightphi":"ϕ","strns":"\xaf","sub":"⊂","Sub":"⋐","subdot":"⪽","subE":"⫅","sube":"⊆","subedot":"⫃","submult":"⫁","subnE":"⫋","subne":"⊊","subplus":"⪿","subrarr":"⥹","subset":"⊂","Subset":"⋐","subseteq":"⊆","subseteqq":"⫅","SubsetEqual":"⊆","subsetneq":"⊊","subsetneqq":"⫋","subsim":"⫇","subsub":"⫕","subsup":"⫓","succapprox":"⪸","succ":"≻","succcurlyeq":"≽","Succeeds":"≻","SucceedsEqual":"⪰","SucceedsSlantEqual":"≽","SucceedsTilde":"≿","succeq":"⪰","succnapprox":"⪺","succneqq":"⪶","succnsim":"⋩","succsim":"≿","SuchThat":"∋","sum":"∑","Sum":"∑","sung":"♪","sup1":"\xb9","sup2":"\xb2","sup3":"\xb3","sup":"⊃","Sup":"⋑","supdot":"⪾","supdsub":"⫘","supE":"⫆","supe":"⊇","supedot":"⫄","Superset":"⊃","SupersetEqual":"⊇","suphsol":"⟉","suphsub":"⫗","suplarr":"⥻","supmult":"⫂","supnE":"⫌","supne":"⊋","supplus":"⫀","supset":"⊃","Supset":"⋑","supseteq":"⊇","supseteqq":"⫆","supsetneq":"⊋","supsetneqq":"⫌","supsim":"⫈","supsub":"⫔","supsup":"⫖","swarhk":"⤦","swarr":"↙","swArr":"⇙","swarrow":"↙","swnwar":"⤪","szlig":"\xdf","Tab":"\\t","target":"⌖","Tau":"Τ","tau":"τ","tbrk":"⎴","Tcaron":"Ť","tcaron":"ť","Tcedil":"Ţ","tcedil":"ţ","Tcy":"Т","tcy":"т","tdot":"⃛","telrec":"⌕","Tfr":"\uD835\uDD17","tfr":"\uD835\uDD31","there4":"∴","therefore":"∴","Therefore":"∴","Theta":"Θ","theta":"θ","thetasym":"ϑ","thetav":"ϑ","thickapprox":"≈","thicksim":"∼","ThickSpace":"  ","ThinSpace":" ","thinsp":" ","thkap":"≈","thksim":"∼","THORN":"\xde","thorn":"\xfe","tilde":"˜","Tilde":"∼","TildeEqual":"≃","TildeFullEqual":"≅","TildeTilde":"≈","timesbar":"⨱","timesb":"⊠","times":"\xd7","timesd":"⨰","tint":"∭","toea":"⤨","topbot":"⌶","topcir":"⫱","top":"⊤","Topf":"\uD835\uDD4B","topf":"\uD835\uDD65","topfork":"⫚","tosa":"⤩","tprime":"‴","trade":"™","TRADE":"™","triangle":"▵","triangledown":"▿","triangleleft":"◃","trianglelefteq":"⊴","triangleq":"≜","triangleright":"▹","trianglerighteq":"⊵","tridot":"◬","trie":"≜","triminus":"⨺","TripleDot":"⃛","triplus":"⨹","trisb":"⧍","tritime":"⨻","trpezium":"⏢","Tscr":"\uD835\uDCAF","tscr":"\uD835\uDCC9","TScy":"Ц","tscy":"ц","TSHcy":"Ћ","tshcy":"ћ","Tstrok":"Ŧ","tstrok":"ŧ","twixt":"≬","twoheadleftarrow":"↞","twoheadrightarrow":"↠","Uacute":"\xda","uacute":"\xfa","uarr":"↑","Uarr":"↟","uArr":"⇑","Uarrocir":"⥉","Ubrcy":"Ў","ubrcy":"ў","Ubreve":"Ŭ","ubreve":"ŭ","Ucirc":"\xdb","ucirc":"\xfb","Ucy":"У","ucy":"у","udarr":"⇅","Udblac":"Ű","udblac":"ű","udhar":"⥮","ufisht":"⥾","Ufr":"\uD835\uDD18","ufr":"\uD835\uDD32","Ugrave":"\xd9","ugrave":"\xf9","uHar":"⥣","uharl":"↿","uharr":"↾","uhblk":"▀","ulcorn":"⌜","ulcorner":"⌜","ulcrop":"⌏","ultri":"◸","Umacr":"Ū","umacr":"ū","uml":"\xa8","UnderBar":"_","UnderBrace":"⏟","UnderBracket":"⎵","UnderParenthesis":"⏝","Union":"⋃","UnionPlus":"⊎","Uogon":"Ų","uogon":"ų","Uopf":"\uD835\uDD4C","uopf":"\uD835\uDD66","UpArrowBar":"⤒","uparrow":"↑","UpArrow":"↑","Uparrow":"⇑","UpArrowDownArrow":"⇅","updownarrow":"↕","UpDownArrow":"↕","Updownarrow":"⇕","UpEquilibrium":"⥮","upharpoonleft":"↿","upharpoonright":"↾","uplus":"⊎","UpperLeftArrow":"↖","UpperRightArrow":"↗","upsi":"υ","Upsi":"ϒ","upsih":"ϒ","Upsilon":"Υ","upsilon":"υ","UpTeeArrow":"↥","UpTee":"⊥","upuparrows":"⇈","urcorn":"⌝","urcorner":"⌝","urcrop":"⌎","Uring":"Ů","uring":"ů","urtri":"◹","Uscr":"\uD835\uDCB0","uscr":"\uD835\uDCCA","utdot":"⋰","Utilde":"Ũ","utilde":"ũ","utri":"▵","utrif":"▴","uuarr":"⇈","Uuml":"\xdc","uuml":"\xfc","uwangle":"⦧","vangrt":"⦜","varepsilon":"ϵ","varkappa":"ϰ","varnothing":"∅","varphi":"ϕ","varpi":"ϖ","varpropto":"∝","varr":"↕","vArr":"⇕","varrho":"ϱ","varsigma":"ς","varsubsetneq":"⊊︀","varsubsetneqq":"⫋︀","varsupsetneq":"⊋︀","varsupsetneqq":"⫌︀","vartheta":"ϑ","vartriangleleft":"⊲","vartriangleright":"⊳","vBar":"⫨","Vbar":"⫫","vBarv":"⫩","Vcy":"В","vcy":"в","vdash":"⊢","vDash":"⊨","Vdash":"⊩","VDash":"⊫","Vdashl":"⫦","veebar":"⊻","vee":"∨","Vee":"⋁","veeeq":"≚","vellip":"⋮","verbar":"|","Verbar":"‖","vert":"|","Vert":"‖","VerticalBar":"∣","VerticalLine":"|","VerticalSeparator":"❘","VerticalTilde":"≀","VeryThinSpace":" ","Vfr":"\uD835\uDD19","vfr":"\uD835\uDD33","vltri":"⊲","vnsub":"⊂⃒","vnsup":"⊃⃒","Vopf":"\uD835\uDD4D","vopf":"\uD835\uDD67","vprop":"∝","vrtri":"⊳","Vscr":"\uD835\uDCB1","vscr":"\uD835\uDCCB","vsubnE":"⫋︀","vsubne":"⊊︀","vsupnE":"⫌︀","vsupne":"⊋︀","Vvdash":"⊪","vzigzag":"⦚","Wcirc":"Ŵ","wcirc":"ŵ","wedbar":"⩟","wedge":"∧","Wedge":"⋀","wedgeq":"≙","weierp":"℘","Wfr":"\uD835\uDD1A","wfr":"\uD835\uDD34","Wopf":"\uD835\uDD4E","wopf":"\uD835\uDD68","wp":"℘","wr":"≀","wreath":"≀","Wscr":"\uD835\uDCB2","wscr":"\uD835\uDCCC","xcap":"⋂","xcirc":"◯","xcup":"⋃","xdtri":"▽","Xfr":"\uD835\uDD1B","xfr":"\uD835\uDD35","xharr":"⟷","xhArr":"⟺","Xi":"Ξ","xi":"ξ","xlarr":"⟵","xlArr":"⟸","xmap":"⟼","xnis":"⋻","xodot":"⨀","Xopf":"\uD835\uDD4F","xopf":"\uD835\uDD69","xoplus":"⨁","xotime":"⨂","xrarr":"⟶","xrArr":"⟹","Xscr":"\uD835\uDCB3","xscr":"\uD835\uDCCD","xsqcup":"⨆","xuplus":"⨄","xutri":"△","xvee":"⋁","xwedge":"⋀","Yacute":"\xdd","yacute":"\xfd","YAcy":"Я","yacy":"я","Ycirc":"Ŷ","ycirc":"ŷ","Ycy":"Ы","ycy":"ы","yen":"\xa5","Yfr":"\uD835\uDD1C","yfr":"\uD835\uDD36","YIcy":"Ї","yicy":"ї","Yopf":"\uD835\uDD50","yopf":"\uD835\uDD6A","Yscr":"\uD835\uDCB4","yscr":"\uD835\uDCCE","YUcy":"Ю","yucy":"ю","yuml":"\xff","Yuml":"Ÿ","Zacute":"Ź","zacute":"ź","Zcaron":"Ž","zcaron":"ž","Zcy":"З","zcy":"з","Zdot":"Ż","zdot":"ż","zeetrf":"ℨ","ZeroWidthSpace":"​","Zeta":"Ζ","zeta":"ζ","zfr":"\uD835\uDD37","Zfr":"ℨ","ZHcy":"Ж","zhcy":"ж","zigrarr":"⇝","zopf":"\uD835\uDD6B","Zopf":"ℤ","Zscr":"\uD835\uDCB5","zscr":"\uD835\uDCCF","zwj":"‍","zwnj":"‌"}');

});


parcelRequire.register("7X6km", function(module, exports) {
module.exports = /[!-#%-\*,-\/:;\?@\[-\]_\{\}\xA1\xA7\xAB\xB6\xB7\xBB\xBF\u037E\u0387\u055A-\u055F\u0589\u058A\u05BE\u05C0\u05C3\u05C6\u05F3\u05F4\u0609\u060A\u060C\u060D\u061B\u061E\u061F\u066A-\u066D\u06D4\u0700-\u070D\u07F7-\u07F9\u0830-\u083E\u085E\u0964\u0965\u0970\u09FD\u0A76\u0AF0\u0C84\u0DF4\u0E4F\u0E5A\u0E5B\u0F04-\u0F12\u0F14\u0F3A-\u0F3D\u0F85\u0FD0-\u0FD4\u0FD9\u0FDA\u104A-\u104F\u10FB\u1360-\u1368\u1400\u166D\u166E\u169B\u169C\u16EB-\u16ED\u1735\u1736\u17D4-\u17D6\u17D8-\u17DA\u1800-\u180A\u1944\u1945\u1A1E\u1A1F\u1AA0-\u1AA6\u1AA8-\u1AAD\u1B5A-\u1B60\u1BFC-\u1BFF\u1C3B-\u1C3F\u1C7E\u1C7F\u1CC0-\u1CC7\u1CD3\u2010-\u2027\u2030-\u2043\u2045-\u2051\u2053-\u205E\u207D\u207E\u208D\u208E\u2308-\u230B\u2329\u232A\u2768-\u2775\u27C5\u27C6\u27E6-\u27EF\u2983-\u2998\u29D8-\u29DB\u29FC\u29FD\u2CF9-\u2CFC\u2CFE\u2CFF\u2D70\u2E00-\u2E2E\u2E30-\u2E4E\u3001-\u3003\u3008-\u3011\u3014-\u301F\u3030\u303D\u30A0\u30FB\uA4FE\uA4FF\uA60D-\uA60F\uA673\uA67E\uA6F2-\uA6F7\uA874-\uA877\uA8CE\uA8CF\uA8F8-\uA8FA\uA8FC\uA92E\uA92F\uA95F\uA9C1-\uA9CD\uA9DE\uA9DF\uAA5C-\uAA5F\uAADE\uAADF\uAAF0\uAAF1\uABEB\uFD3E\uFD3F\uFE10-\uFE19\uFE30-\uFE52\uFE54-\uFE61\uFE63\uFE68\uFE6A\uFE6B\uFF01-\uFF03\uFF05-\uFF0A\uFF0C-\uFF0F\uFF1A\uFF1B\uFF1F\uFF20\uFF3B-\uFF3D\uFF3F\uFF5B\uFF5D\uFF5F-\uFF65]|\uD800[\uDD00-\uDD02\uDF9F\uDFD0]|\uD801\uDD6F|\uD802[\uDC57\uDD1F\uDD3F\uDE50-\uDE58\uDE7F\uDEF0-\uDEF6\uDF39-\uDF3F\uDF99-\uDF9C]|\uD803[\uDF55-\uDF59]|\uD804[\uDC47-\uDC4D\uDCBB\uDCBC\uDCBE-\uDCC1\uDD40-\uDD43\uDD74\uDD75\uDDC5-\uDDC8\uDDCD\uDDDB\uDDDD-\uDDDF\uDE38-\uDE3D\uDEA9]|\uD805[\uDC4B-\uDC4F\uDC5B\uDC5D\uDCC6\uDDC1-\uDDD7\uDE41-\uDE43\uDE60-\uDE6C\uDF3C-\uDF3E]|\uD806[\uDC3B\uDE3F-\uDE46\uDE9A-\uDE9C\uDE9E-\uDEA2]|\uD807[\uDC41-\uDC45\uDC70\uDC71\uDEF7\uDEF8]|\uD809[\uDC70-\uDC74]|\uD81A[\uDE6E\uDE6F\uDEF5\uDF37-\uDF3B\uDF44]|\uD81B[\uDE97-\uDE9A]|\uD82F\uDC9F|\uD836[\uDE87-\uDE8B]|\uD83A[\uDD5E\uDD5F]/;

});

parcelRequire.register("e2HUE", function(module, exports) {

$parcel$export(module.exports, "encode", () => $a39350c11025426f$export$c564cdbbe6da493, (v) => $a39350c11025426f$export$c564cdbbe6da493 = v);
$parcel$export(module.exports, "decode", () => $a39350c11025426f$export$2f872c0f2117be69, (v) => $a39350c11025426f$export$2f872c0f2117be69 = v);
$parcel$export(module.exports, "format", () => $a39350c11025426f$export$d9468344d3651243, (v) => $a39350c11025426f$export$d9468344d3651243 = v);
$parcel$export(module.exports, "parse", () => $a39350c11025426f$export$98e6a39c04603d36, (v) => $a39350c11025426f$export$98e6a39c04603d36 = v);
var $a39350c11025426f$export$c564cdbbe6da493;
var $a39350c11025426f$export$2f872c0f2117be69;
var $a39350c11025426f$export$d9468344d3651243;
var $a39350c11025426f$export$98e6a39c04603d36;
"use strict";

$a39350c11025426f$export$c564cdbbe6da493 = (parcelRequire("bF35C"));

$a39350c11025426f$export$2f872c0f2117be69 = (parcelRequire("6f556"));

$a39350c11025426f$export$d9468344d3651243 = (parcelRequire("7h9Ae"));

$a39350c11025426f$export$98e6a39c04603d36 = (parcelRequire("bFQZr"));

});
parcelRequire.register("bF35C", function(module, exports) {
"use strict";
var $87d5eb9786f3ab21$var$encodeCache = {};
// Create a lookup array where anything but characters in `chars` string
// and alphanumeric chars is percent-encoded.
//
function $87d5eb9786f3ab21$var$getEncodeCache(exclude) {
    var i, ch, cache = $87d5eb9786f3ab21$var$encodeCache[exclude];
    if (cache) return cache;
    cache = $87d5eb9786f3ab21$var$encodeCache[exclude] = [];
    for(i = 0; i < 128; i++){
        ch = String.fromCharCode(i);
        if (/^[0-9a-z]$/i.test(ch)) // always allow unencoded alphanumeric characters
        cache.push(ch);
        else cache.push("%" + ("0" + i.toString(16).toUpperCase()).slice(-2));
    }
    for(i = 0; i < exclude.length; i++)cache[exclude.charCodeAt(i)] = exclude[i];
    return cache;
}
// Encode unsafe characters with percent-encoding, skipping already
// encoded sequences.
//
//  - string       - string to encode
//  - exclude      - list of characters to ignore (in addition to a-zA-Z0-9)
//  - keepEscaped  - don't encode '%' in a correct escape sequence (default: true)
//
function $87d5eb9786f3ab21$var$encode(string, exclude, keepEscaped) {
    var i, l, code, nextCode, cache, result = "";
    if (typeof exclude !== "string") {
        // encode(string, keepEscaped)
        keepEscaped = exclude;
        exclude = $87d5eb9786f3ab21$var$encode.defaultChars;
    }
    if (typeof keepEscaped === "undefined") keepEscaped = true;
    cache = $87d5eb9786f3ab21$var$getEncodeCache(exclude);
    for(i = 0, l = string.length; i < l; i++){
        code = string.charCodeAt(i);
        if (keepEscaped && code === 0x25 /* % */  && i + 2 < l) {
            if (/^[0-9a-f]{2}$/i.test(string.slice(i + 1, i + 3))) {
                result += string.slice(i, i + 3);
                i += 2;
                continue;
            }
        }
        if (code < 128) {
            result += cache[code];
            continue;
        }
        if (code >= 0xD800 && code <= 0xDFFF) {
            if (code >= 0xD800 && code <= 0xDBFF && i + 1 < l) {
                nextCode = string.charCodeAt(i + 1);
                if (nextCode >= 0xDC00 && nextCode <= 0xDFFF) {
                    result += encodeURIComponent(string[i] + string[i + 1]);
                    i++;
                    continue;
                }
            }
            result += "%EF%BF%BD";
            continue;
        }
        result += encodeURIComponent(string[i]);
    }
    return result;
}
$87d5eb9786f3ab21$var$encode.defaultChars = ";/?:@&=+$,-_.!~*'()#";
$87d5eb9786f3ab21$var$encode.componentChars = "-_.!~*'()";
module.exports = $87d5eb9786f3ab21$var$encode;

});

parcelRequire.register("6f556", function(module, exports) {
"use strict";
/* eslint-disable no-bitwise */ var $48b815d4a965c83b$var$decodeCache = {};
function $48b815d4a965c83b$var$getDecodeCache(exclude) {
    var i, ch, cache = $48b815d4a965c83b$var$decodeCache[exclude];
    if (cache) return cache;
    cache = $48b815d4a965c83b$var$decodeCache[exclude] = [];
    for(i = 0; i < 128; i++){
        ch = String.fromCharCode(i);
        cache.push(ch);
    }
    for(i = 0; i < exclude.length; i++){
        ch = exclude.charCodeAt(i);
        cache[ch] = "%" + ("0" + ch.toString(16).toUpperCase()).slice(-2);
    }
    return cache;
}
// Decode percent-encoded string.
//
function $48b815d4a965c83b$var$decode(string, exclude) {
    var cache;
    if (typeof exclude !== "string") exclude = $48b815d4a965c83b$var$decode.defaultChars;
    cache = $48b815d4a965c83b$var$getDecodeCache(exclude);
    return string.replace(/(%[a-f0-9]{2})+/gi, function(seq) {
        var i, l, b1, b2, b3, b4, chr, result = "";
        for(i = 0, l = seq.length; i < l; i += 3){
            b1 = parseInt(seq.slice(i + 1, i + 3), 16);
            if (b1 < 0x80) {
                result += cache[b1];
                continue;
            }
            if ((b1 & 0xE0) === 0xC0 && i + 3 < l) {
                // 110xxxxx 10xxxxxx
                b2 = parseInt(seq.slice(i + 4, i + 6), 16);
                if ((b2 & 0xC0) === 0x80) {
                    chr = b1 << 6 & 0x7C0 | b2 & 0x3F;
                    if (chr < 0x80) result += "��";
                    else result += String.fromCharCode(chr);
                    i += 3;
                    continue;
                }
            }
            if ((b1 & 0xF0) === 0xE0 && i + 6 < l) {
                // 1110xxxx 10xxxxxx 10xxxxxx
                b2 = parseInt(seq.slice(i + 4, i + 6), 16);
                b3 = parseInt(seq.slice(i + 7, i + 9), 16);
                if ((b2 & 0xC0) === 0x80 && (b3 & 0xC0) === 0x80) {
                    chr = b1 << 12 & 0xF000 | b2 << 6 & 0xFC0 | b3 & 0x3F;
                    if (chr < 0x800 || chr >= 0xD800 && chr <= 0xDFFF) result += "���";
                    else result += String.fromCharCode(chr);
                    i += 6;
                    continue;
                }
            }
            if ((b1 & 0xF8) === 0xF0 && i + 9 < l) {
                // 111110xx 10xxxxxx 10xxxxxx 10xxxxxx
                b2 = parseInt(seq.slice(i + 4, i + 6), 16);
                b3 = parseInt(seq.slice(i + 7, i + 9), 16);
                b4 = parseInt(seq.slice(i + 10, i + 12), 16);
                if ((b2 & 0xC0) === 0x80 && (b3 & 0xC0) === 0x80 && (b4 & 0xC0) === 0x80) {
                    chr = b1 << 18 & 0x1C0000 | b2 << 12 & 0x3F000 | b3 << 6 & 0xFC0 | b4 & 0x3F;
                    if (chr < 0x10000 || chr > 0x10FFFF) result += "����";
                    else {
                        chr -= 0x10000;
                        result += String.fromCharCode(0xD800 + (chr >> 10), 0xDC00 + (chr & 0x3FF));
                    }
                    i += 9;
                    continue;
                }
            }
            result += "�";
        }
        return result;
    });
}
$48b815d4a965c83b$var$decode.defaultChars = ";/?:@&=+$,#";
$48b815d4a965c83b$var$decode.componentChars = "";
module.exports = $48b815d4a965c83b$var$decode;

});

parcelRequire.register("7h9Ae", function(module, exports) {
"use strict";
module.exports = function format(url) {
    var result = "";
    result += url.protocol || "";
    result += url.slashes ? "//" : "";
    result += url.auth ? url.auth + "@" : "";
    if (url.hostname && url.hostname.indexOf(":") !== -1) // ipv6 address
    result += "[" + url.hostname + "]";
    else result += url.hostname || "";
    result += url.port ? ":" + url.port : "";
    result += url.pathname || "";
    result += url.search || "";
    result += url.hash || "";
    return result;
};

});

parcelRequire.register("bFQZr", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
"use strict";
//
// Changes from joyent/node:
//
// 1. No leading slash in paths,
//    e.g. in `url.parse('http://foo?bar')` pathname is ``, not `/`
//
// 2. Backslashes are not replaced with slashes,
//    so `http:\\example.org\` is treated like a relative path
//
// 3. Trailing colon is treated like a part of the path,
//    i.e. in `http://example.org:foo` pathname is `:foo`
//
// 4. Nothing is URL-encoded in the resulting object,
//    (in joyent/node some chars in auth and paths are encoded)
//
// 5. `url.parse()` does not have `parseQueryString` argument
//
// 6. Removed extraneous result properties: `host`, `path`, `query`, etc.,
//    which can be constructed using other parts of the url.
//
function $87fca0bbad55b768$var$Url() {
    this.protocol = null;
    this.slashes = null;
    this.auth = null;
    this.port = null;
    this.hostname = null;
    this.hash = null;
    this.search = null;
    this.pathname = null;
}
// Reference: RFC 3986, RFC 1808, RFC 2396
// define these here so at least they only have to be
// compiled once on the first module load.
var $87fca0bbad55b768$var$protocolPattern = /^([a-z0-9.+-]+:)/i, $87fca0bbad55b768$var$portPattern = /:[0-9]*$/, // Special case for a simple path URL
$87fca0bbad55b768$var$simplePathPattern = /^(\/\/?(?!\/)[^\?\s]*)(\?[^\s]*)?$/, // RFC 2396: characters reserved for delimiting URLs.
// We actually just auto-escape these.
$87fca0bbad55b768$var$delims = [
    "<",
    ">",
    '"',
    "`",
    " ",
    "\r",
    "\n",
    "	"
], // RFC 2396: characters not allowed for various reasons.
$87fca0bbad55b768$var$unwise = [
    "{",
    "}",
    "|",
    "\\",
    "^",
    "`"
].concat($87fca0bbad55b768$var$delims), // Allowed by RFCs, but cause of XSS attacks.  Always escape these.
$87fca0bbad55b768$var$autoEscape = [
    "'"
].concat($87fca0bbad55b768$var$unwise), // Characters that are never ever allowed in a hostname.
// Note that any invalid chars are also handled, but these
// are the ones that are *expected* to be seen, so we fast-path
// them.
$87fca0bbad55b768$var$nonHostChars = [
    "%",
    "/",
    "?",
    ";",
    "#"
].concat($87fca0bbad55b768$var$autoEscape), $87fca0bbad55b768$var$hostEndingChars = [
    "/",
    "?",
    "#"
], $87fca0bbad55b768$var$hostnameMaxLen = 255, $87fca0bbad55b768$var$hostnamePartPattern = /^[+a-z0-9A-Z_-]{0,63}$/, $87fca0bbad55b768$var$hostnamePartStart = /^([+a-z0-9A-Z_-]{0,63})(.*)$/, // protocols that can allow "unsafe" and "unwise" chars.
/* eslint-disable no-script-url */ // protocols that never have a hostname.
$87fca0bbad55b768$var$hostlessProtocol = {
    "javascript": true,
    "javascript:": true
}, // protocols that always contain a // bit.
$87fca0bbad55b768$var$slashedProtocol = {
    "http": true,
    "https": true,
    "ftp": true,
    "gopher": true,
    "file": true,
    "http:": true,
    "https:": true,
    "ftp:": true,
    "gopher:": true,
    "file:": true
};
/* eslint-enable no-script-url */ function $87fca0bbad55b768$var$urlParse(url, slashesDenoteHost) {
    if (url && url instanceof $87fca0bbad55b768$var$Url) return url;
    var u = new $87fca0bbad55b768$var$Url();
    u.parse(url, slashesDenoteHost);
    return u;
}
$87fca0bbad55b768$var$Url.prototype.parse = function(url, slashesDenoteHost) {
    var i, l, lowerProto, hec, slashes, rest = url;
    // trim before proceeding.
    // This is to support parse stuff like "  http://foo.com  \n"
    rest = rest.trim();
    if (!slashesDenoteHost && url.split("#").length === 1) {
        // Try fast path regexp
        var simplePath = $87fca0bbad55b768$var$simplePathPattern.exec(rest);
        if (simplePath) {
            this.pathname = simplePath[1];
            if (simplePath[2]) this.search = simplePath[2];
            return this;
        }
    }
    var proto = $87fca0bbad55b768$var$protocolPattern.exec(rest);
    if (proto) {
        proto = proto[0];
        lowerProto = proto.toLowerCase();
        this.protocol = proto;
        rest = rest.substr(proto.length);
    }
    // figure out if it's got a host
    // user@server is *always* interpreted as a hostname, and url
    // resolution will treat //foo/bar as host=foo,path=bar because that's
    // how the browser resolves relative URLs.
    if (slashesDenoteHost || proto || rest.match(/^\/\/[^@\/]+@[^@\/]+/)) {
        slashes = rest.substr(0, 2) === "//";
        if (slashes && !(proto && $87fca0bbad55b768$var$hostlessProtocol[proto])) {
            rest = rest.substr(2);
            this.slashes = true;
        }
    }
    if (!$87fca0bbad55b768$var$hostlessProtocol[proto] && (slashes || proto && !$87fca0bbad55b768$var$slashedProtocol[proto])) {
        // there's a hostname.
        // the first instance of /, ?, ;, or # ends the host.
        //
        // If there is an @ in the hostname, then non-host chars *are* allowed
        // to the left of the last @ sign, unless some host-ending character
        // comes *before* the @-sign.
        // URLs are obnoxious.
        //
        // ex:
        // http://a@b@c/ => user:a@b host:c
        // http://a@b?@c => user:a host:c path:/?@c
        // v0.12 TODO(isaacs): This is not quite how Chrome does things.
        // Review our test case against browsers more comprehensively.
        // find the first instance of any hostEndingChars
        var hostEnd = -1;
        for(i = 0; i < $87fca0bbad55b768$var$hostEndingChars.length; i++){
            hec = rest.indexOf($87fca0bbad55b768$var$hostEndingChars[i]);
            if (hec !== -1 && (hostEnd === -1 || hec < hostEnd)) hostEnd = hec;
        }
        // at this point, either we have an explicit point where the
        // auth portion cannot go past, or the last @ char is the decider.
        var auth, atSign;
        if (hostEnd === -1) // atSign can be anywhere.
        atSign = rest.lastIndexOf("@");
        else // atSign must be in auth portion.
        // http://a@b/c@d => host:b auth:a path:/c@d
        atSign = rest.lastIndexOf("@", hostEnd);
        // Now we have a portion which is definitely the auth.
        // Pull that off.
        if (atSign !== -1) {
            auth = rest.slice(0, atSign);
            rest = rest.slice(atSign + 1);
            this.auth = auth;
        }
        // the host is the remaining to the left of the first non-host char
        hostEnd = -1;
        for(i = 0; i < $87fca0bbad55b768$var$nonHostChars.length; i++){
            hec = rest.indexOf($87fca0bbad55b768$var$nonHostChars[i]);
            if (hec !== -1 && (hostEnd === -1 || hec < hostEnd)) hostEnd = hec;
        }
        // if we still have not hit it, then the entire thing is a host.
        if (hostEnd === -1) hostEnd = rest.length;
        if (rest[hostEnd - 1] === ":") hostEnd--;
        var host = rest.slice(0, hostEnd);
        rest = rest.slice(hostEnd);
        // pull out port.
        this.parseHost(host);
        // we've indicated that there is a hostname,
        // so even if it's empty, it has to be present.
        this.hostname = this.hostname || "";
        // if hostname begins with [ and ends with ]
        // assume that it's an IPv6 address.
        var ipv6Hostname = this.hostname[0] === "[" && this.hostname[this.hostname.length - 1] === "]";
        // validate a little.
        if (!ipv6Hostname) {
            var hostparts = this.hostname.split(/\./);
            for(i = 0, l = hostparts.length; i < l; i++){
                var part = hostparts[i];
                if (!part) continue;
                if (!part.match($87fca0bbad55b768$var$hostnamePartPattern)) {
                    var newpart = "";
                    for(var j = 0, k = part.length; j < k; j++)if (part.charCodeAt(j) > 127) // we replace non-ASCII char with a temporary placeholder
                    // we need this to make sure size of hostname is not
                    // broken by replacing non-ASCII by nothing
                    newpart += "x";
                    else newpart += part[j];
                    // we test again with ASCII char only
                    if (!newpart.match($87fca0bbad55b768$var$hostnamePartPattern)) {
                        var validParts = hostparts.slice(0, i);
                        var notHost = hostparts.slice(i + 1);
                        var bit = part.match($87fca0bbad55b768$var$hostnamePartStart);
                        if (bit) {
                            validParts.push(bit[1]);
                            notHost.unshift(bit[2]);
                        }
                        if (notHost.length) rest = notHost.join(".") + rest;
                        this.hostname = validParts.join(".");
                        break;
                    }
                }
            }
        }
        if (this.hostname.length > $87fca0bbad55b768$var$hostnameMaxLen) this.hostname = "";
        // strip [ and ] from the hostname
        // the host field still retains them, though
        if (ipv6Hostname) this.hostname = this.hostname.substr(1, this.hostname.length - 2);
    }
    // chop off from the tail first.
    var hash = rest.indexOf("#");
    if (hash !== -1) {
        // got a fragment string.
        this.hash = rest.substr(hash);
        rest = rest.slice(0, hash);
    }
    var qm = rest.indexOf("?");
    if (qm !== -1) {
        this.search = rest.substr(qm);
        rest = rest.slice(0, qm);
    }
    if (rest) this.pathname = rest;
    if ($87fca0bbad55b768$var$slashedProtocol[lowerProto] && this.hostname && !this.pathname) this.pathname = "";
    return this;
};
$87fca0bbad55b768$var$Url.prototype.parseHost = function(host) {
    var port = $87fca0bbad55b768$var$portPattern.exec(host);
    if (port) {
        port = port[0];
        if (port !== ":") this.port = port.substr(1);
        host = host.substr(0, host.length - port.length);
    }
    if (host) this.hostname = host;
};
module.exports = $87fca0bbad55b768$var$urlParse;

});


parcelRequire.register("7rqQE", function(module, exports) {

$parcel$export(module.exports, "Any", () => $56afe18681029e8f$export$b24b633b1364b94b, (v) => $56afe18681029e8f$export$b24b633b1364b94b = v);
$parcel$export(module.exports, "Cc", () => $56afe18681029e8f$export$15dafbac7aec8a57, (v) => $56afe18681029e8f$export$15dafbac7aec8a57 = v);
$parcel$export(module.exports, "Cf", () => $56afe18681029e8f$export$239cff0cce87eb56, (v) => $56afe18681029e8f$export$239cff0cce87eb56 = v);
$parcel$export(module.exports, "P", () => $56afe18681029e8f$export$56c0d5a1e737357d, (v) => $56afe18681029e8f$export$56c0d5a1e737357d = v);
$parcel$export(module.exports, "Z", () => $56afe18681029e8f$export$dc98b0b04f4c7758, (v) => $56afe18681029e8f$export$dc98b0b04f4c7758 = v);
var $56afe18681029e8f$export$b24b633b1364b94b;
var $56afe18681029e8f$export$15dafbac7aec8a57;
var $56afe18681029e8f$export$239cff0cce87eb56;
var $56afe18681029e8f$export$56c0d5a1e737357d;
var $56afe18681029e8f$export$dc98b0b04f4c7758;
"use strict";

$56afe18681029e8f$export$b24b633b1364b94b = (parcelRequire("73OXq"));

$56afe18681029e8f$export$15dafbac7aec8a57 = (parcelRequire("c7ys3"));

$56afe18681029e8f$export$239cff0cce87eb56 = (parcelRequire("iShqo"));

$56afe18681029e8f$export$56c0d5a1e737357d = (parcelRequire("7X6km"));

$56afe18681029e8f$export$dc98b0b04f4c7758 = (parcelRequire("kWxtK"));

});
parcelRequire.register("73OXq", function(module, exports) {
module.exports = /[\0-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]/;

});

parcelRequire.register("c7ys3", function(module, exports) {
module.exports = /[\0-\x1F\x7F-\x9F]/;

});

parcelRequire.register("iShqo", function(module, exports) {
module.exports = /[\xAD\u0600-\u0605\u061C\u06DD\u070F\u08E2\u180E\u200B-\u200F\u202A-\u202E\u2060-\u2064\u2066-\u206F\uFEFF\uFFF9-\uFFFB]|\uD804[\uDCBD\uDCCD]|\uD82F[\uDCA0-\uDCA3]|\uD834[\uDD73-\uDD7A]|\uDB40[\uDC01\uDC20-\uDC7F]/;

});

parcelRequire.register("kWxtK", function(module, exports) {
module.exports = /[ \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000]/;

});



parcelRequire.register("hb7pH", function(module, exports) {

$parcel$export(module.exports, "parseLinkLabel", () => $c81936ebdbad2e68$export$2a2c8612930e58d0, (v) => $c81936ebdbad2e68$export$2a2c8612930e58d0 = v);
$parcel$export(module.exports, "parseLinkDestination", () => $c81936ebdbad2e68$export$22bd24080f95f2b3, (v) => $c81936ebdbad2e68$export$22bd24080f95f2b3 = v);
$parcel$export(module.exports, "parseLinkTitle", () => $c81936ebdbad2e68$export$89650c5477a69db9, (v) => $c81936ebdbad2e68$export$89650c5477a69db9 = v);
// Just a shortcut for bulk export
var $c81936ebdbad2e68$export$2a2c8612930e58d0;
var $c81936ebdbad2e68$export$22bd24080f95f2b3;
var $c81936ebdbad2e68$export$89650c5477a69db9;
"use strict";

$c81936ebdbad2e68$export$2a2c8612930e58d0 = (parcelRequire("K6ang"));

$c81936ebdbad2e68$export$22bd24080f95f2b3 = (parcelRequire("f1jeZ"));

$c81936ebdbad2e68$export$89650c5477a69db9 = (parcelRequire("9DuLA"));

});
parcelRequire.register("K6ang", function(module, exports) {
// Parse link label
//
// this function assumes that first character ("[") already matches;
// returns the end of the label
//
"use strict";
module.exports = function parseLinkLabel(state, start, disableNested) {
    var level, found, marker, prevPos, labelEnd = -1, max = state.posMax, oldPos = state.pos;
    state.pos = start + 1;
    level = 1;
    while(state.pos < max){
        marker = state.src.charCodeAt(state.pos);
        if (marker === 0x5D /* ] */ ) {
            level--;
            if (level === 0) {
                found = true;
                break;
            }
        }
        prevPos = state.pos;
        state.md.inline.skipToken(state);
        if (marker === 0x5B /* [ */ ) {
            if (prevPos === state.pos - 1) // increase level if we find text `[`, which is not a part of any token
            level++;
            else if (disableNested) {
                state.pos = oldPos;
                return -1;
            }
        }
    }
    if (found) labelEnd = state.pos;
    // restore old state
    state.pos = oldPos;
    return labelEnd;
};

});

parcelRequire.register("f1jeZ", function(module, exports) {
// Parse link destination
//
"use strict";

var $iE2q6 = parcelRequire("iE2q6");
var $aef5dfcdf14ce123$require$unescapeAll = $iE2q6.unescapeAll;
module.exports = function parseLinkDestination(str, pos, max) {
    var code, level, lines = 0, start = pos, result = {
        ok: false,
        pos: 0,
        lines: 0,
        str: ""
    };
    if (str.charCodeAt(pos) === 0x3C /* < */ ) {
        pos++;
        while(pos < max){
            code = str.charCodeAt(pos);
            if (code === 0x0A /* \n */ ) return result;
            if (code === 0x3C /* < */ ) return result;
            if (code === 0x3E /* > */ ) {
                result.pos = pos + 1;
                result.str = $aef5dfcdf14ce123$require$unescapeAll(str.slice(start + 1, pos));
                result.ok = true;
                return result;
            }
            if (code === 0x5C /* \ */  && pos + 1 < max) {
                pos += 2;
                continue;
            }
            pos++;
        }
        // no closing '>'
        return result;
    }
    // this should be ... } else { ... branch
    level = 0;
    while(pos < max){
        code = str.charCodeAt(pos);
        if (code === 0x20) break;
        // ascii control characters
        if (code < 0x20 || code === 0x7F) break;
        if (code === 0x5C /* \ */  && pos + 1 < max) {
            if (str.charCodeAt(pos + 1) === 0x20) break;
            pos += 2;
            continue;
        }
        if (code === 0x28 /* ( */ ) {
            level++;
            if (level > 32) return result;
        }
        if (code === 0x29 /* ) */ ) {
            if (level === 0) break;
            level--;
        }
        pos++;
    }
    if (start === pos) return result;
    if (level !== 0) return result;
    result.str = $aef5dfcdf14ce123$require$unescapeAll(str.slice(start, pos));
    result.lines = lines;
    result.pos = pos;
    result.ok = true;
    return result;
};

});

parcelRequire.register("9DuLA", function(module, exports) {
// Parse link title
//
"use strict";

var $iE2q6 = parcelRequire("iE2q6");
var $703f9f27280dd572$require$unescapeAll = $iE2q6.unescapeAll;
module.exports = function parseLinkTitle(str, pos, max) {
    var code, marker, lines = 0, start = pos, result = {
        ok: false,
        pos: 0,
        lines: 0,
        str: ""
    };
    if (pos >= max) return result;
    marker = str.charCodeAt(pos);
    if (marker !== 0x22 /* " */  && marker !== 0x27 /* ' */  && marker !== 0x28 /* ( */ ) return result;
    pos++;
    // if opening marker is "(", switch it to closing marker ")"
    if (marker === 0x28) marker = 0x29;
    while(pos < max){
        code = str.charCodeAt(pos);
        if (code === marker) {
            result.pos = pos + 1;
            result.lines = lines;
            result.str = $703f9f27280dd572$require$unescapeAll(str.slice(start + 1, pos));
            result.ok = true;
            return result;
        } else if (code === 0x28 /* ( */  && marker === 0x29 /* ) */ ) return result;
        else if (code === 0x0A) lines++;
        else if (code === 0x5C /* \ */  && pos + 1 < max) {
            pos++;
            if (str.charCodeAt(pos) === 0x0A) lines++;
        }
        pos++;
    }
    return result;
};

});


parcelRequire.register("jZ7YV", function(module, exports) {
/**
 * class Renderer
 *
 * Generates HTML from parsed token stream. Each instance has independent
 * copy of rules. Those can be rewritten with ease. Also, you can add new
 * rules if you create plugin and adds new token types.
 **/ "use strict";

var $iE2q6 = parcelRequire("iE2q6");
var $e8c9e7d4aa38f6f6$require$assign = $iE2q6.assign;

var $iE2q6 = parcelRequire("iE2q6");
var $e8c9e7d4aa38f6f6$require$unescapeAll = $iE2q6.unescapeAll;

var $iE2q6 = parcelRequire("iE2q6");
var $e8c9e7d4aa38f6f6$require$escapeHtml = $iE2q6.escapeHtml;
////////////////////////////////////////////////////////////////////////////////
var $e8c9e7d4aa38f6f6$var$default_rules = {};
$e8c9e7d4aa38f6f6$var$default_rules.code_inline = function(tokens, idx, options, env, slf) {
    var token = tokens[idx];
    return "<code" + slf.renderAttrs(token) + ">" + $e8c9e7d4aa38f6f6$require$escapeHtml(tokens[idx].content) + "</code>";
};
$e8c9e7d4aa38f6f6$var$default_rules.code_block = function(tokens, idx, options, env, slf) {
    var token = tokens[idx];
    return "<pre" + slf.renderAttrs(token) + "><code>" + $e8c9e7d4aa38f6f6$require$escapeHtml(tokens[idx].content) + "</code></pre>\n";
};
$e8c9e7d4aa38f6f6$var$default_rules.fence = function(tokens, idx, options, env, slf) {
    var token = tokens[idx], info = token.info ? $e8c9e7d4aa38f6f6$require$unescapeAll(token.info).trim() : "", langName = "", langAttrs = "", highlighted, i, arr, tmpAttrs, tmpToken;
    if (info) {
        arr = info.split(/(\s+)/g);
        langName = arr[0];
        langAttrs = arr.slice(2).join("");
    }
    if (options.highlight) highlighted = options.highlight(token.content, langName, langAttrs) || $e8c9e7d4aa38f6f6$require$escapeHtml(token.content);
    else highlighted = $e8c9e7d4aa38f6f6$require$escapeHtml(token.content);
    if (highlighted.indexOf("<pre") === 0) return highlighted + "\n";
    // If language exists, inject class gently, without modifying original token.
    // May be, one day we will add .deepClone() for token and simplify this part, but
    // now we prefer to keep things local.
    if (info) {
        i = token.attrIndex("class");
        tmpAttrs = token.attrs ? token.attrs.slice() : [];
        if (i < 0) tmpAttrs.push([
            "class",
            options.langPrefix + langName
        ]);
        else {
            tmpAttrs[i] = tmpAttrs[i].slice();
            tmpAttrs[i][1] += " " + options.langPrefix + langName;
        }
        // Fake token just to render attributes
        tmpToken = {
            attrs: tmpAttrs
        };
        return "<pre><code" + slf.renderAttrs(tmpToken) + ">" + highlighted + "</code></pre>\n";
    }
    return "<pre><code" + slf.renderAttrs(token) + ">" + highlighted + "</code></pre>\n";
};
$e8c9e7d4aa38f6f6$var$default_rules.image = function(tokens, idx, options, env, slf) {
    var token = tokens[idx];
    // "alt" attr MUST be set, even if empty. Because it's mandatory and
    // should be placed on proper position for tests.
    //
    // Replace content with actual value
    token.attrs[token.attrIndex("alt")][1] = slf.renderInlineAsText(token.children, options, env);
    return slf.renderToken(tokens, idx, options);
};
$e8c9e7d4aa38f6f6$var$default_rules.hardbreak = function(tokens, idx, options /*, env */ ) {
    return options.xhtmlOut ? "<br />\n" : "<br>\n";
};
$e8c9e7d4aa38f6f6$var$default_rules.softbreak = function(tokens, idx, options /*, env */ ) {
    return options.breaks ? options.xhtmlOut ? "<br />\n" : "<br>\n" : "\n";
};
$e8c9e7d4aa38f6f6$var$default_rules.text = function(tokens, idx /*, options, env */ ) {
    return $e8c9e7d4aa38f6f6$require$escapeHtml(tokens[idx].content);
};
$e8c9e7d4aa38f6f6$var$default_rules.html_block = function(tokens, idx /*, options, env */ ) {
    return tokens[idx].content;
};
$e8c9e7d4aa38f6f6$var$default_rules.html_inline = function(tokens, idx /*, options, env */ ) {
    return tokens[idx].content;
};
/**
 * new Renderer()
 *
 * Creates new [[Renderer]] instance and fill [[Renderer#rules]] with defaults.
 **/ function $e8c9e7d4aa38f6f6$var$Renderer() {
    /**
   * Renderer#rules -> Object
   *
   * Contains render rules for tokens. Can be updated and extended.
   *
   * ##### Example
   *
   * ```javascript
   * var md = require('markdown-it')();
   *
   * md.renderer.rules.strong_open  = function () { return '<b>'; };
   * md.renderer.rules.strong_close = function () { return '</b>'; };
   *
   * var result = md.renderInline(...);
   * ```
   *
   * Each rule is called as independent static function with fixed signature:
   *
   * ```javascript
   * function my_token_render(tokens, idx, options, env, renderer) {
   *   // ...
   *   return renderedHTML;
   * }
   * ```
   *
   * See [source code](https://github.com/markdown-it/markdown-it/blob/master/lib/renderer.js)
   * for more details and examples.
   **/ this.rules = $e8c9e7d4aa38f6f6$require$assign({}, $e8c9e7d4aa38f6f6$var$default_rules);
}
/**
 * Renderer.renderAttrs(token) -> String
 *
 * Render token attributes to string.
 **/ $e8c9e7d4aa38f6f6$var$Renderer.prototype.renderAttrs = function renderAttrs(token) {
    var i, l, result;
    if (!token.attrs) return "";
    result = "";
    for(i = 0, l = token.attrs.length; i < l; i++)result += " " + $e8c9e7d4aa38f6f6$require$escapeHtml(token.attrs[i][0]) + '="' + $e8c9e7d4aa38f6f6$require$escapeHtml(token.attrs[i][1]) + '"';
    return result;
};
/**
 * Renderer.renderToken(tokens, idx, options) -> String
 * - tokens (Array): list of tokens
 * - idx (Numbed): token index to render
 * - options (Object): params of parser instance
 *
 * Default token renderer. Can be overriden by custom function
 * in [[Renderer#rules]].
 **/ $e8c9e7d4aa38f6f6$var$Renderer.prototype.renderToken = function renderToken(tokens, idx, options) {
    var nextToken, result = "", needLf = false, token = tokens[idx];
    // Tight list paragraphs
    if (token.hidden) return "";
    // Insert a newline between hidden paragraph and subsequent opening
    // block-level tag.
    //
    // For example, here we should insert a newline before blockquote:
    //  - a
    //    >
    //
    if (token.block && token.nesting !== -1 && idx && tokens[idx - 1].hidden) result += "\n";
    // Add token name, e.g. `<img`
    result += (token.nesting === -1 ? "</" : "<") + token.tag;
    // Encode attributes, e.g. `<img src="foo"`
    result += this.renderAttrs(token);
    // Add a slash for self-closing tags, e.g. `<img src="foo" /`
    if (token.nesting === 0 && options.xhtmlOut) result += " /";
    // Check if we need to add a newline after this tag
    if (token.block) {
        needLf = true;
        if (token.nesting === 1) {
            if (idx + 1 < tokens.length) {
                nextToken = tokens[idx + 1];
                if (nextToken.type === "inline" || nextToken.hidden) // Block-level tag containing an inline tag.
                //
                needLf = false;
                else if (nextToken.nesting === -1 && nextToken.tag === token.tag) // Opening tag + closing tag of the same type. E.g. `<li></li>`.
                //
                needLf = false;
            }
        }
    }
    result += needLf ? ">\n" : ">";
    return result;
};
/**
 * Renderer.renderInline(tokens, options, env) -> String
 * - tokens (Array): list on block tokens to render
 * - options (Object): params of parser instance
 * - env (Object): additional data from parsed input (references, for example)
 *
 * The same as [[Renderer.render]], but for single token of `inline` type.
 **/ $e8c9e7d4aa38f6f6$var$Renderer.prototype.renderInline = function(tokens, options, env) {
    var type, result = "", rules = this.rules;
    for(var i = 0, len = tokens.length; i < len; i++){
        type = tokens[i].type;
        if (typeof rules[type] !== "undefined") result += rules[type](tokens, i, options, env, this);
        else result += this.renderToken(tokens, i, options);
    }
    return result;
};
/** internal
 * Renderer.renderInlineAsText(tokens, options, env) -> String
 * - tokens (Array): list on block tokens to render
 * - options (Object): params of parser instance
 * - env (Object): additional data from parsed input (references, for example)
 *
 * Special kludge for image `alt` attributes to conform CommonMark spec.
 * Don't try to use it! Spec requires to show `alt` content with stripped markup,
 * instead of simple escaping.
 **/ $e8c9e7d4aa38f6f6$var$Renderer.prototype.renderInlineAsText = function(tokens, options, env) {
    var result = "";
    for(var i = 0, len = tokens.length; i < len; i++){
        if (tokens[i].type === "text") result += tokens[i].content;
        else if (tokens[i].type === "image") result += this.renderInlineAsText(tokens[i].children, options, env);
        else if (tokens[i].type === "softbreak") result += "\n";
    }
    return result;
};
/**
 * Renderer.render(tokens, options, env) -> String
 * - tokens (Array): list on block tokens to render
 * - options (Object): params of parser instance
 * - env (Object): additional data from parsed input (references, for example)
 *
 * Takes token stream and generates HTML. Probably, you will never need to call
 * this method directly.
 **/ $e8c9e7d4aa38f6f6$var$Renderer.prototype.render = function(tokens, options, env) {
    var i, len, type, result = "", rules = this.rules;
    for(i = 0, len = tokens.length; i < len; i++){
        type = tokens[i].type;
        if (type === "inline") result += this.renderInline(tokens[i].children, options, env);
        else if (typeof rules[type] !== "undefined") result += rules[tokens[i].type](tokens, i, options, env, this);
        else result += this.renderToken(tokens, i, options, env);
    }
    return result;
};
module.exports = $e8c9e7d4aa38f6f6$var$Renderer;

});

parcelRequire.register("ggOc9", function(module, exports) {
/** internal
 * class Core
 *
 * Top-level rules executor. Glues block/inline parsers and does intermediate
 * transformations.
 **/ "use strict";

var $jRUoy = parcelRequire("jRUoy");







var $bd8513a3f8e95f1b$var$_rules = [
    [
        "normalize",
        (parcelRequire("4VrRo"))
    ],
    [
        "block",
        (parcelRequire("hb0c6"))
    ],
    [
        "inline",
        (parcelRequire("cLGVm"))
    ],
    [
        "linkify",
        (parcelRequire("9RJa4"))
    ],
    [
        "replacements",
        (parcelRequire("ew708"))
    ],
    [
        "smartquotes",
        (parcelRequire("2quzb"))
    ],
    // `text_join` finds `text_special` tokens (for escape sequences)
    // and joins them with the rest of the text
    [
        "text_join",
        (parcelRequire("2UkVL"))
    ]
];
/**
 * new Core()
 **/ function $bd8513a3f8e95f1b$var$Core() {
    /**
   * Core#ruler -> Ruler
   *
   * [[Ruler]] instance. Keep configuration of core rules.
   **/ this.ruler = new $jRUoy();
    for(var i = 0; i < $bd8513a3f8e95f1b$var$_rules.length; i++)this.ruler.push($bd8513a3f8e95f1b$var$_rules[i][0], $bd8513a3f8e95f1b$var$_rules[i][1]);
}
/**
 * Core.process(state)
 *
 * Executes core chain rules.
 **/ $bd8513a3f8e95f1b$var$Core.prototype.process = function(state) {
    var i, l, rules;
    rules = this.ruler.getRules("");
    for(i = 0, l = rules.length; i < l; i++)rules[i](state);
};

$bd8513a3f8e95f1b$var$Core.prototype.State = (parcelRequire("1qh3b"));
module.exports = $bd8513a3f8e95f1b$var$Core;

});
parcelRequire.register("jRUoy", function(module, exports) {
/**
 * class Ruler
 *
 * Helper class, used by [[MarkdownIt#core]], [[MarkdownIt#block]] and
 * [[MarkdownIt#inline]] to manage sequences of functions (rules):
 *
 * - keep rules in defined order
 * - assign the name to each rule
 * - enable/disable rules
 * - add/replace rules
 * - allow assign rules to additional named chains (in the same)
 * - cacheing lists of active rules
 *
 * You will not need use this class directly until write plugins. For simple
 * rules control use [[MarkdownIt.disable]], [[MarkdownIt.enable]] and
 * [[MarkdownIt.use]].
 **/ "use strict";
/**
 * new Ruler()
 **/ function $e76eb673f45b428b$var$Ruler() {
    // List of added rules. Each element is:
    //
    // {
    //   name: XXX,
    //   enabled: Boolean,
    //   fn: Function(),
    //   alt: [ name2, name3 ]
    // }
    //
    this.__rules__ = [];
    // Cached rule chains.
    //
    // First level - chain name, '' for default.
    // Second level - diginal anchor for fast filtering by charcodes.
    //
    this.__cache__ = null;
}
////////////////////////////////////////////////////////////////////////////////
// Helper methods, should not be used directly
// Find rule index by name
//
$e76eb673f45b428b$var$Ruler.prototype.__find__ = function(name) {
    for(var i = 0; i < this.__rules__.length; i++){
        if (this.__rules__[i].name === name) return i;
    }
    return -1;
};
// Build rules lookup cache
//
$e76eb673f45b428b$var$Ruler.prototype.__compile__ = function() {
    var self = this;
    var chains = [
        ""
    ];
    // collect unique names
    self.__rules__.forEach(function(rule) {
        if (!rule.enabled) return;
        rule.alt.forEach(function(altName) {
            if (chains.indexOf(altName) < 0) chains.push(altName);
        });
    });
    self.__cache__ = {};
    chains.forEach(function(chain) {
        self.__cache__[chain] = [];
        self.__rules__.forEach(function(rule) {
            if (!rule.enabled) return;
            if (chain && rule.alt.indexOf(chain) < 0) return;
            self.__cache__[chain].push(rule.fn);
        });
    });
};
/**
 * Ruler.at(name, fn [, options])
 * - name (String): rule name to replace.
 * - fn (Function): new rule function.
 * - options (Object): new rule options (not mandatory).
 *
 * Replace rule by name with new function & options. Throws error if name not
 * found.
 *
 * ##### Options:
 *
 * - __alt__ - array with names of "alternate" chains.
 *
 * ##### Example
 *
 * Replace existing typographer replacement rule with new one:
 *
 * ```javascript
 * var md = require('markdown-it')();
 *
 * md.core.ruler.at('replacements', function replace(state) {
 *   //...
 * });
 * ```
 **/ $e76eb673f45b428b$var$Ruler.prototype.at = function(name, fn, options) {
    var index = this.__find__(name);
    var opt = options || {};
    if (index === -1) throw new Error("Parser rule not found: " + name);
    this.__rules__[index].fn = fn;
    this.__rules__[index].alt = opt.alt || [];
    this.__cache__ = null;
};
/**
 * Ruler.before(beforeName, ruleName, fn [, options])
 * - beforeName (String): new rule will be added before this one.
 * - ruleName (String): name of added rule.
 * - fn (Function): rule function.
 * - options (Object): rule options (not mandatory).
 *
 * Add new rule to chain before one with given name. See also
 * [[Ruler.after]], [[Ruler.push]].
 *
 * ##### Options:
 *
 * - __alt__ - array with names of "alternate" chains.
 *
 * ##### Example
 *
 * ```javascript
 * var md = require('markdown-it')();
 *
 * md.block.ruler.before('paragraph', 'my_rule', function replace(state) {
 *   //...
 * });
 * ```
 **/ $e76eb673f45b428b$var$Ruler.prototype.before = function(beforeName, ruleName, fn, options) {
    var index = this.__find__(beforeName);
    var opt = options || {};
    if (index === -1) throw new Error("Parser rule not found: " + beforeName);
    this.__rules__.splice(index, 0, {
        name: ruleName,
        enabled: true,
        fn: fn,
        alt: opt.alt || []
    });
    this.__cache__ = null;
};
/**
 * Ruler.after(afterName, ruleName, fn [, options])
 * - afterName (String): new rule will be added after this one.
 * - ruleName (String): name of added rule.
 * - fn (Function): rule function.
 * - options (Object): rule options (not mandatory).
 *
 * Add new rule to chain after one with given name. See also
 * [[Ruler.before]], [[Ruler.push]].
 *
 * ##### Options:
 *
 * - __alt__ - array with names of "alternate" chains.
 *
 * ##### Example
 *
 * ```javascript
 * var md = require('markdown-it')();
 *
 * md.inline.ruler.after('text', 'my_rule', function replace(state) {
 *   //...
 * });
 * ```
 **/ $e76eb673f45b428b$var$Ruler.prototype.after = function(afterName, ruleName, fn, options) {
    var index = this.__find__(afterName);
    var opt = options || {};
    if (index === -1) throw new Error("Parser rule not found: " + afterName);
    this.__rules__.splice(index + 1, 0, {
        name: ruleName,
        enabled: true,
        fn: fn,
        alt: opt.alt || []
    });
    this.__cache__ = null;
};
/**
 * Ruler.push(ruleName, fn [, options])
 * - ruleName (String): name of added rule.
 * - fn (Function): rule function.
 * - options (Object): rule options (not mandatory).
 *
 * Push new rule to the end of chain. See also
 * [[Ruler.before]], [[Ruler.after]].
 *
 * ##### Options:
 *
 * - __alt__ - array with names of "alternate" chains.
 *
 * ##### Example
 *
 * ```javascript
 * var md = require('markdown-it')();
 *
 * md.core.ruler.push('my_rule', function replace(state) {
 *   //...
 * });
 * ```
 **/ $e76eb673f45b428b$var$Ruler.prototype.push = function(ruleName, fn, options) {
    var opt = options || {};
    this.__rules__.push({
        name: ruleName,
        enabled: true,
        fn: fn,
        alt: opt.alt || []
    });
    this.__cache__ = null;
};
/**
 * Ruler.enable(list [, ignoreInvalid]) -> Array
 * - list (String|Array): list of rule names to enable.
 * - ignoreInvalid (Boolean): set `true` to ignore errors when rule not found.
 *
 * Enable rules with given names. If any rule name not found - throw Error.
 * Errors can be disabled by second param.
 *
 * Returns list of found rule names (if no exception happened).
 *
 * See also [[Ruler.disable]], [[Ruler.enableOnly]].
 **/ $e76eb673f45b428b$var$Ruler.prototype.enable = function(list, ignoreInvalid) {
    if (!Array.isArray(list)) list = [
        list
    ];
    var result = [];
    // Search by name and enable
    list.forEach(function(name) {
        var idx = this.__find__(name);
        if (idx < 0) {
            if (ignoreInvalid) return;
            throw new Error("Rules manager: invalid rule name " + name);
        }
        this.__rules__[idx].enabled = true;
        result.push(name);
    }, this);
    this.__cache__ = null;
    return result;
};
/**
 * Ruler.enableOnly(list [, ignoreInvalid])
 * - list (String|Array): list of rule names to enable (whitelist).
 * - ignoreInvalid (Boolean): set `true` to ignore errors when rule not found.
 *
 * Enable rules with given names, and disable everything else. If any rule name
 * not found - throw Error. Errors can be disabled by second param.
 *
 * See also [[Ruler.disable]], [[Ruler.enable]].
 **/ $e76eb673f45b428b$var$Ruler.prototype.enableOnly = function(list, ignoreInvalid) {
    if (!Array.isArray(list)) list = [
        list
    ];
    this.__rules__.forEach(function(rule) {
        rule.enabled = false;
    });
    this.enable(list, ignoreInvalid);
};
/**
 * Ruler.disable(list [, ignoreInvalid]) -> Array
 * - list (String|Array): list of rule names to disable.
 * - ignoreInvalid (Boolean): set `true` to ignore errors when rule not found.
 *
 * Disable rules with given names. If any rule name not found - throw Error.
 * Errors can be disabled by second param.
 *
 * Returns list of found rule names (if no exception happened).
 *
 * See also [[Ruler.enable]], [[Ruler.enableOnly]].
 **/ $e76eb673f45b428b$var$Ruler.prototype.disable = function(list, ignoreInvalid) {
    if (!Array.isArray(list)) list = [
        list
    ];
    var result = [];
    // Search by name and disable
    list.forEach(function(name) {
        var idx = this.__find__(name);
        if (idx < 0) {
            if (ignoreInvalid) return;
            throw new Error("Rules manager: invalid rule name " + name);
        }
        this.__rules__[idx].enabled = false;
        result.push(name);
    }, this);
    this.__cache__ = null;
    return result;
};
/**
 * Ruler.getRules(chainName) -> Array
 *
 * Return array of active functions (rules) for given chain name. It analyzes
 * rules configuration, compiles caches if not exists and returns result.
 *
 * Default chain name is `''` (empty string). It can't be skipped. That's
 * done intentionally, to keep signature monomorphic for high speed.
 **/ $e76eb673f45b428b$var$Ruler.prototype.getRules = function(chainName) {
    if (this.__cache__ === null) this.__compile__();
    // Chain can be empty, if rules disabled. But we still have to return Array.
    return this.__cache__[chainName] || [];
};
module.exports = $e76eb673f45b428b$var$Ruler;

});

parcelRequire.register("4VrRo", function(module, exports) {
// Normalize input string
"use strict";
// https://spec.commonmark.org/0.29/#line-ending
var $396218ba3ccaceb2$var$NEWLINES_RE = /\r\n?|\n/g;
var $396218ba3ccaceb2$var$NULL_RE = /\0/g;
module.exports = function normalize(state) {
    var str;
    // Normalize newlines
    str = state.src.replace($396218ba3ccaceb2$var$NEWLINES_RE, "\n");
    // Replace NULL characters
    str = str.replace($396218ba3ccaceb2$var$NULL_RE, "�");
    state.src = str;
};

});

parcelRequire.register("hb0c6", function(module, exports) {
"use strict";
module.exports = function block(state) {
    var token;
    if (state.inlineMode) {
        token = new state.Token("inline", "", 0);
        token.content = state.src;
        token.map = [
            0,
            1
        ];
        token.children = [];
        state.tokens.push(token);
    } else state.md.block.parse(state.src, state.md, state.env, state.tokens);
};

});

parcelRequire.register("cLGVm", function(module, exports) {
"use strict";
module.exports = function inline(state) {
    var tokens = state.tokens, tok, i, l;
    // Parse inlines
    for(i = 0, l = tokens.length; i < l; i++){
        tok = tokens[i];
        if (tok.type === "inline") state.md.inline.parse(tok.content, state.md, state.env, tok.children);
    }
};

});

parcelRequire.register("9RJa4", function(module, exports) {
// Replace link-like texts with link nodes.
//
// Currently restricted by `md.validateLink()` to http/https/ftp
//
"use strict";

var $iE2q6 = parcelRequire("iE2q6");
var $72ec186ab958b9e7$require$arrayReplaceAt = $iE2q6.arrayReplaceAt;
function $72ec186ab958b9e7$var$isLinkOpen(str) {
    return /^<a[>\s]/i.test(str);
}
function $72ec186ab958b9e7$var$isLinkClose(str) {
    return /^<\/a\s*>/i.test(str);
}
module.exports = function linkify(state) {
    var i, j, l, tokens, token, currentToken, nodes, ln, text, pos, lastPos, level, htmlLinkLevel, url, fullUrl, urlText, blockTokens = state.tokens, links;
    if (!state.md.options.linkify) return;
    for(j = 0, l = blockTokens.length; j < l; j++){
        if (blockTokens[j].type !== "inline" || !state.md.linkify.pretest(blockTokens[j].content)) continue;
        tokens = blockTokens[j].children;
        htmlLinkLevel = 0;
        // We scan from the end, to keep position when new tags added.
        // Use reversed logic in links start/end match
        for(i = tokens.length - 1; i >= 0; i--){
            currentToken = tokens[i];
            // Skip content of markdown links
            if (currentToken.type === "link_close") {
                i--;
                while(tokens[i].level !== currentToken.level && tokens[i].type !== "link_open")i--;
                continue;
            }
            // Skip content of html tag links
            if (currentToken.type === "html_inline") {
                if ($72ec186ab958b9e7$var$isLinkOpen(currentToken.content) && htmlLinkLevel > 0) htmlLinkLevel--;
                if ($72ec186ab958b9e7$var$isLinkClose(currentToken.content)) htmlLinkLevel++;
            }
            if (htmlLinkLevel > 0) continue;
            if (currentToken.type === "text" && state.md.linkify.test(currentToken.content)) {
                text = currentToken.content;
                links = state.md.linkify.match(text);
                // Now split string to nodes
                nodes = [];
                level = currentToken.level;
                lastPos = 0;
                // forbid escape sequence at the start of the string,
                // this avoids http\://example.com/ from being linkified as
                // http:<a href="//example.com/">//example.com/</a>
                if (links.length > 0 && links[0].index === 0 && i > 0 && tokens[i - 1].type === "text_special") links = links.slice(1);
                for(ln = 0; ln < links.length; ln++){
                    url = links[ln].url;
                    fullUrl = state.md.normalizeLink(url);
                    if (!state.md.validateLink(fullUrl)) continue;
                    urlText = links[ln].text;
                    // Linkifier might send raw hostnames like "example.com", where url
                    // starts with domain name. So we prepend http:// in those cases,
                    // and remove it afterwards.
                    //
                    if (!links[ln].schema) urlText = state.md.normalizeLinkText("http://" + urlText).replace(/^http:\/\//, "");
                    else if (links[ln].schema === "mailto:" && !/^mailto:/i.test(urlText)) urlText = state.md.normalizeLinkText("mailto:" + urlText).replace(/^mailto:/, "");
                    else urlText = state.md.normalizeLinkText(urlText);
                    pos = links[ln].index;
                    if (pos > lastPos) {
                        token = new state.Token("text", "", 0);
                        token.content = text.slice(lastPos, pos);
                        token.level = level;
                        nodes.push(token);
                    }
                    token = new state.Token("link_open", "a", 1);
                    token.attrs = [
                        [
                            "href",
                            fullUrl
                        ]
                    ];
                    token.level = level++;
                    token.markup = "linkify";
                    token.info = "auto";
                    nodes.push(token);
                    token = new state.Token("text", "", 0);
                    token.content = urlText;
                    token.level = level;
                    nodes.push(token);
                    token = new state.Token("link_close", "a", -1);
                    token.level = --level;
                    token.markup = "linkify";
                    token.info = "auto";
                    nodes.push(token);
                    lastPos = links[ln].lastIndex;
                }
                if (lastPos < text.length) {
                    token = new state.Token("text", "", 0);
                    token.content = text.slice(lastPos);
                    token.level = level;
                    nodes.push(token);
                }
                // replace current node
                blockTokens[j].children = tokens = $72ec186ab958b9e7$require$arrayReplaceAt(tokens, i, nodes);
            }
        }
    }
};

});

parcelRequire.register("ew708", function(module, exports) {
// Simple typographic replacements
//
// (c) (C) → ©
// (tm) (TM) → ™
// (r) (R) → ®
// +- → ±
// (p) (P) -> §
// ... → … (also ?.... → ?.., !.... → !..)
// ???????? → ???, !!!!! → !!!, `,,` → `,`
// -- → &ndash;, --- → &mdash;
//
"use strict";
// TODO:
// - fractionals 1/2, 1/4, 3/4 -> ½, ¼, ¾
// - multiplications 2 x 4 -> 2 × 4
var $a9197c1d74a3490c$var$RARE_RE = /\+-|\.\.|\?\?\?\?|!!!!|,,|--/;
// Workaround for phantomjs - need regex without /g flag,
// or root check will fail every second time
var $a9197c1d74a3490c$var$SCOPED_ABBR_TEST_RE = /\((c|tm|r)\)/i;
var $a9197c1d74a3490c$var$SCOPED_ABBR_RE = /\((c|tm|r)\)/ig;
var $a9197c1d74a3490c$var$SCOPED_ABBR = {
    c: "\xa9",
    r: "\xae",
    tm: "™"
};
function $a9197c1d74a3490c$var$replaceFn(match, name) {
    return $a9197c1d74a3490c$var$SCOPED_ABBR[name.toLowerCase()];
}
function $a9197c1d74a3490c$var$replace_scoped(inlineTokens) {
    var i, token, inside_autolink = 0;
    for(i = inlineTokens.length - 1; i >= 0; i--){
        token = inlineTokens[i];
        if (token.type === "text" && !inside_autolink) token.content = token.content.replace($a9197c1d74a3490c$var$SCOPED_ABBR_RE, $a9197c1d74a3490c$var$replaceFn);
        if (token.type === "link_open" && token.info === "auto") inside_autolink--;
        if (token.type === "link_close" && token.info === "auto") inside_autolink++;
    }
}
function $a9197c1d74a3490c$var$replace_rare(inlineTokens) {
    var i, token, inside_autolink = 0;
    for(i = inlineTokens.length - 1; i >= 0; i--){
        token = inlineTokens[i];
        if (token.type === "text" && !inside_autolink) {
            if ($a9197c1d74a3490c$var$RARE_RE.test(token.content)) token.content = token.content.replace(/\+-/g, "\xb1")// .., ..., ....... -> …
            // but ?..... & !..... -> ?.. & !..
            .replace(/\.{2,}/g, "…").replace(/([?!])…/g, "$1..").replace(/([?!]){4,}/g, "$1$1$1").replace(/,{2,}/g, ",")// em-dash
            .replace(/(^|[^-])---(?=[^-]|$)/mg, "$1—")// en-dash
            .replace(/(^|\s)--(?=\s|$)/mg, "$1–").replace(/(^|[^-\s])--(?=[^-\s]|$)/mg, "$1–");
        }
        if (token.type === "link_open" && token.info === "auto") inside_autolink--;
        if (token.type === "link_close" && token.info === "auto") inside_autolink++;
    }
}
module.exports = function replace(state) {
    var blkIdx;
    if (!state.md.options.typographer) return;
    for(blkIdx = state.tokens.length - 1; blkIdx >= 0; blkIdx--){
        if (state.tokens[blkIdx].type !== "inline") continue;
        if ($a9197c1d74a3490c$var$SCOPED_ABBR_TEST_RE.test(state.tokens[blkIdx].content)) $a9197c1d74a3490c$var$replace_scoped(state.tokens[blkIdx].children);
        if ($a9197c1d74a3490c$var$RARE_RE.test(state.tokens[blkIdx].content)) $a9197c1d74a3490c$var$replace_rare(state.tokens[blkIdx].children);
    }
};

});

parcelRequire.register("2quzb", function(module, exports) {
// Convert straight quotation marks to typographic ones
//
"use strict";

var $iE2q6 = parcelRequire("iE2q6");
var $1c45b85dc0a64a8c$require$isWhiteSpace = $iE2q6.isWhiteSpace;

var $iE2q6 = parcelRequire("iE2q6");
var $1c45b85dc0a64a8c$require$isPunctChar = $iE2q6.isPunctChar;

var $iE2q6 = parcelRequire("iE2q6");
var $1c45b85dc0a64a8c$require$isMdAsciiPunct = $iE2q6.isMdAsciiPunct;
var $1c45b85dc0a64a8c$var$QUOTE_TEST_RE = /['"]/;
var $1c45b85dc0a64a8c$var$QUOTE_RE = /['"]/g;
var $1c45b85dc0a64a8c$var$APOSTROPHE = "’"; /* ’ */ 
function $1c45b85dc0a64a8c$var$replaceAt(str, index, ch) {
    return str.slice(0, index) + ch + str.slice(index + 1);
}
function $1c45b85dc0a64a8c$var$process_inlines(tokens, state) {
    var i, token, text, t, pos, max, thisLevel, item, lastChar, nextChar, isLastPunctChar, isNextPunctChar, isLastWhiteSpace, isNextWhiteSpace, canOpen, canClose, j, isSingle, stack, openQuote, closeQuote;
    stack = [];
    for(i = 0; i < tokens.length; i++){
        token = tokens[i];
        thisLevel = tokens[i].level;
        for(j = stack.length - 1; j >= 0; j--){
            if (stack[j].level <= thisLevel) break;
        }
        stack.length = j + 1;
        if (token.type !== "text") continue;
        text = token.content;
        pos = 0;
        max = text.length;
        /*eslint no-labels:0,block-scoped-var:0*/ OUTER: while(pos < max){
            $1c45b85dc0a64a8c$var$QUOTE_RE.lastIndex = pos;
            t = $1c45b85dc0a64a8c$var$QUOTE_RE.exec(text);
            if (!t) break;
            canOpen = canClose = true;
            pos = t.index + 1;
            isSingle = t[0] === "'";
            // Find previous character,
            // default to space if it's the beginning of the line
            //
            lastChar = 0x20;
            if (t.index - 1 >= 0) lastChar = text.charCodeAt(t.index - 1);
            else for(j = i - 1; j >= 0; j--){
                if (tokens[j].type === "softbreak" || tokens[j].type === "hardbreak") break; // lastChar defaults to 0x20
                if (!tokens[j].content) continue; // should skip all tokens except 'text', 'html_inline' or 'code_inline'
                lastChar = tokens[j].content.charCodeAt(tokens[j].content.length - 1);
                break;
            }
            // Find next character,
            // default to space if it's the end of the line
            //
            nextChar = 0x20;
            if (pos < max) nextChar = text.charCodeAt(pos);
            else for(j = i + 1; j < tokens.length; j++){
                if (tokens[j].type === "softbreak" || tokens[j].type === "hardbreak") break; // nextChar defaults to 0x20
                if (!tokens[j].content) continue; // should skip all tokens except 'text', 'html_inline' or 'code_inline'
                nextChar = tokens[j].content.charCodeAt(0);
                break;
            }
            isLastPunctChar = $1c45b85dc0a64a8c$require$isMdAsciiPunct(lastChar) || $1c45b85dc0a64a8c$require$isPunctChar(String.fromCharCode(lastChar));
            isNextPunctChar = $1c45b85dc0a64a8c$require$isMdAsciiPunct(nextChar) || $1c45b85dc0a64a8c$require$isPunctChar(String.fromCharCode(nextChar));
            isLastWhiteSpace = $1c45b85dc0a64a8c$require$isWhiteSpace(lastChar);
            isNextWhiteSpace = $1c45b85dc0a64a8c$require$isWhiteSpace(nextChar);
            if (isNextWhiteSpace) canOpen = false;
            else if (isNextPunctChar) {
                if (!(isLastWhiteSpace || isLastPunctChar)) canOpen = false;
            }
            if (isLastWhiteSpace) canClose = false;
            else if (isLastPunctChar) {
                if (!(isNextWhiteSpace || isNextPunctChar)) canClose = false;
            }
            if (nextChar === 0x22 /* " */  && t[0] === '"') {
                if (lastChar >= 0x30 /* 0 */  && lastChar <= 0x39 /* 9 */ ) // special case: 1"" - count first quote as an inch
                canClose = canOpen = false;
            }
            if (canOpen && canClose) {
                // Replace quotes in the middle of punctuation sequence, but not
                // in the middle of the words, i.e.:
                //
                // 1. foo " bar " baz - not replaced
                // 2. foo-"-bar-"-baz - replaced
                // 3. foo"bar"baz     - not replaced
                //
                canOpen = isLastPunctChar;
                canClose = isNextPunctChar;
            }
            if (!canOpen && !canClose) {
                // middle of word
                if (isSingle) token.content = $1c45b85dc0a64a8c$var$replaceAt(token.content, t.index, $1c45b85dc0a64a8c$var$APOSTROPHE);
                continue;
            }
            if (canClose) // this could be a closing quote, rewind the stack to get a match
            for(j = stack.length - 1; j >= 0; j--){
                item = stack[j];
                if (stack[j].level < thisLevel) break;
                if (item.single === isSingle && stack[j].level === thisLevel) {
                    item = stack[j];
                    if (isSingle) {
                        openQuote = state.md.options.quotes[2];
                        closeQuote = state.md.options.quotes[3];
                    } else {
                        openQuote = state.md.options.quotes[0];
                        closeQuote = state.md.options.quotes[1];
                    }
                    // replace token.content *before* tokens[item.token].content,
                    // because, if they are pointing at the same token, replaceAt
                    // could mess up indices when quote length != 1
                    token.content = $1c45b85dc0a64a8c$var$replaceAt(token.content, t.index, closeQuote);
                    tokens[item.token].content = $1c45b85dc0a64a8c$var$replaceAt(tokens[item.token].content, item.pos, openQuote);
                    pos += closeQuote.length - 1;
                    if (item.token === i) pos += openQuote.length - 1;
                    text = token.content;
                    max = text.length;
                    stack.length = j;
                    continue OUTER;
                }
            }
            if (canOpen) stack.push({
                token: i,
                pos: t.index,
                single: isSingle,
                level: thisLevel
            });
            else if (canClose && isSingle) token.content = $1c45b85dc0a64a8c$var$replaceAt(token.content, t.index, $1c45b85dc0a64a8c$var$APOSTROPHE);
        }
    }
}
module.exports = function smartquotes(state) {
    /*eslint max-depth:0*/ var blkIdx;
    if (!state.md.options.typographer) return;
    for(blkIdx = state.tokens.length - 1; blkIdx >= 0; blkIdx--){
        if (state.tokens[blkIdx].type !== "inline" || !$1c45b85dc0a64a8c$var$QUOTE_TEST_RE.test(state.tokens[blkIdx].content)) continue;
        $1c45b85dc0a64a8c$var$process_inlines(state.tokens[blkIdx].children, state);
    }
};

});

parcelRequire.register("2UkVL", function(module, exports) {
// Join raw text tokens with the rest of the text
//
// This is set as a separate rule to provide an opportunity for plugins
// to run text replacements after text join, but before escape join.
//
// For example, `\:)` shouldn't be replaced with an emoji.
//
"use strict";
module.exports = function text_join(state) {
    var j, l, tokens, curr, max, last, blockTokens = state.tokens;
    for(j = 0, l = blockTokens.length; j < l; j++){
        if (blockTokens[j].type !== "inline") continue;
        tokens = blockTokens[j].children;
        max = tokens.length;
        for(curr = 0; curr < max; curr++)if (tokens[curr].type === "text_special") tokens[curr].type = "text";
        for(curr = last = 0; curr < max; curr++)if (tokens[curr].type === "text" && curr + 1 < max && tokens[curr + 1].type === "text") // collapse two adjacent text nodes
        tokens[curr + 1].content = tokens[curr].content + tokens[curr + 1].content;
        else {
            if (curr !== last) tokens[last] = tokens[curr];
            last++;
        }
        if (curr !== last) tokens.length = last;
    }
};

});

parcelRequire.register("1qh3b", function(module, exports) {
// Core state object
//
"use strict";

var $iLJ9G = parcelRequire("iLJ9G");
function $109571fb65930f53$var$StateCore(src, md, env) {
    this.src = src;
    this.env = env;
    this.tokens = [];
    this.inlineMode = false;
    this.md = md; // link to parser instance
}
// re-export Token class to use in core rules
$109571fb65930f53$var$StateCore.prototype.Token = $iLJ9G;
module.exports = $109571fb65930f53$var$StateCore;

});
parcelRequire.register("iLJ9G", function(module, exports) {
// Token class
"use strict";
/**
 * class Token
 **/ /**
 * new Token(type, tag, nesting)
 *
 * Create new token and fill passed properties.
 **/ function $da9fa4ac4b6c0b7a$var$Token(type, tag, nesting) {
    /**
   * Token#type -> String
   *
   * Type of the token (string, e.g. "paragraph_open")
   **/ this.type = type;
    /**
   * Token#tag -> String
   *
   * html tag name, e.g. "p"
   **/ this.tag = tag;
    /**
   * Token#attrs -> Array
   *
   * Html attributes. Format: `[ [ name1, value1 ], [ name2, value2 ] ]`
   **/ this.attrs = null;
    /**
   * Token#map -> Array
   *
   * Source map info. Format: `[ line_begin, line_end ]`
   **/ this.map = null;
    /**
   * Token#nesting -> Number
   *
   * Level change (number in {-1, 0, 1} set), where:
   *
   * -  `1` means the tag is opening
   * -  `0` means the tag is self-closing
   * - `-1` means the tag is closing
   **/ this.nesting = nesting;
    /**
   * Token#level -> Number
   *
   * nesting level, the same as `state.level`
   **/ this.level = 0;
    /**
   * Token#children -> Array
   *
   * An array of child nodes (inline and img tokens)
   **/ this.children = null;
    /**
   * Token#content -> String
   *
   * In a case of self-closing tag (code, html, fence, etc.),
   * it has contents of this tag.
   **/ this.content = "";
    /**
   * Token#markup -> String
   *
   * '*' or '_' for emphasis, fence string for fence, etc.
   **/ this.markup = "";
    /**
   * Token#info -> String
   *
   * Additional information:
   *
   * - Info string for "fence" tokens
   * - The value "auto" for autolink "link_open" and "link_close" tokens
   * - The string value of the item marker for ordered-list "list_item_open" tokens
   **/ this.info = "";
    /**
   * Token#meta -> Object
   *
   * A place for plugins to store an arbitrary data
   **/ this.meta = null;
    /**
   * Token#block -> Boolean
   *
   * True for block-level tokens, false for inline tokens.
   * Used in renderer to calculate line breaks
   **/ this.block = false;
    /**
   * Token#hidden -> Boolean
   *
   * If it's true, ignore this element when rendering. Used for tight lists
   * to hide paragraphs.
   **/ this.hidden = false;
}
/**
 * Token.attrIndex(name) -> Number
 *
 * Search attribute index by name.
 **/ $da9fa4ac4b6c0b7a$var$Token.prototype.attrIndex = function attrIndex(name) {
    var attrs, i, len;
    if (!this.attrs) return -1;
    attrs = this.attrs;
    for(i = 0, len = attrs.length; i < len; i++){
        if (attrs[i][0] === name) return i;
    }
    return -1;
};
/**
 * Token.attrPush(attrData)
 *
 * Add `[ name, value ]` attribute to list. Init attrs if necessary
 **/ $da9fa4ac4b6c0b7a$var$Token.prototype.attrPush = function attrPush(attrData) {
    if (this.attrs) this.attrs.push(attrData);
    else this.attrs = [
        attrData
    ];
};
/**
 * Token.attrSet(name, value)
 *
 * Set `name` attribute to `value`. Override old value if exists.
 **/ $da9fa4ac4b6c0b7a$var$Token.prototype.attrSet = function attrSet(name, value) {
    var idx = this.attrIndex(name), attrData = [
        name,
        value
    ];
    if (idx < 0) this.attrPush(attrData);
    else this.attrs[idx] = attrData;
};
/**
 * Token.attrGet(name)
 *
 * Get the value of attribute `name`, or null if it does not exist.
 **/ $da9fa4ac4b6c0b7a$var$Token.prototype.attrGet = function attrGet(name) {
    var idx = this.attrIndex(name), value = null;
    if (idx >= 0) value = this.attrs[idx][1];
    return value;
};
/**
 * Token.attrJoin(name, value)
 *
 * Join value to existing attribute via space. Or create new attribute if not
 * exists. Useful to operate with token classes.
 **/ $da9fa4ac4b6c0b7a$var$Token.prototype.attrJoin = function attrJoin(name, value) {
    var idx = this.attrIndex(name);
    if (idx < 0) this.attrPush([
        name,
        value
    ]);
    else this.attrs[idx][1] = this.attrs[idx][1] + " " + value;
};
module.exports = $da9fa4ac4b6c0b7a$var$Token;

});



parcelRequire.register("5XVT8", function(module, exports) {
/** internal
 * class ParserBlock
 *
 * Block-level tokenizer.
 **/ "use strict";

var $jRUoy = parcelRequire("jRUoy");











var $457f5dd5a6cca9af$var$_rules = [
    // First 2 params - rule name & source. Secondary array - list of rules,
    // which can be terminated by this one.
    [
        "table",
        (parcelRequire("l1bHc")),
        [
            "paragraph",
            "reference"
        ]
    ],
    [
        "code",
        (parcelRequire("22e9x"))
    ],
    [
        "fence",
        (parcelRequire("aezo9")),
        [
            "paragraph",
            "reference",
            "blockquote",
            "list"
        ]
    ],
    [
        "blockquote",
        (parcelRequire("8U83L")),
        [
            "paragraph",
            "reference",
            "blockquote",
            "list"
        ]
    ],
    [
        "hr",
        (parcelRequire("9I8zP")),
        [
            "paragraph",
            "reference",
            "blockquote",
            "list"
        ]
    ],
    [
        "list",
        (parcelRequire("3D3gr")),
        [
            "paragraph",
            "reference",
            "blockquote"
        ]
    ],
    [
        "reference",
        (parcelRequire("kVDAZ"))
    ],
    [
        "html_block",
        (parcelRequire("hI5Fz")),
        [
            "paragraph",
            "reference",
            "blockquote"
        ]
    ],
    [
        "heading",
        (parcelRequire("ba3fj")),
        [
            "paragraph",
            "reference",
            "blockquote"
        ]
    ],
    [
        "lheading",
        (parcelRequire("4m4vw"))
    ],
    [
        "paragraph",
        (parcelRequire("8nYFg"))
    ]
];
/**
 * new ParserBlock()
 **/ function $457f5dd5a6cca9af$var$ParserBlock() {
    /**
   * ParserBlock#ruler -> Ruler
   *
   * [[Ruler]] instance. Keep configuration of block rules.
   **/ this.ruler = new $jRUoy();
    for(var i = 0; i < $457f5dd5a6cca9af$var$_rules.length; i++)this.ruler.push($457f5dd5a6cca9af$var$_rules[i][0], $457f5dd5a6cca9af$var$_rules[i][1], {
        alt: ($457f5dd5a6cca9af$var$_rules[i][2] || []).slice()
    });
}
// Generate tokens for input range
//
$457f5dd5a6cca9af$var$ParserBlock.prototype.tokenize = function(state, startLine, endLine) {
    var ok, i, rules = this.ruler.getRules(""), len = rules.length, line = startLine, hasEmptyLines = false, maxNesting = state.md.options.maxNesting;
    while(line < endLine){
        state.line = line = state.skipEmptyLines(line);
        if (line >= endLine) break;
        // Termination condition for nested calls.
        // Nested calls currently used for blockquotes & lists
        if (state.sCount[line] < state.blkIndent) break;
        // If nesting level exceeded - skip tail to the end. That's not ordinary
        // situation and we should not care about content.
        if (state.level >= maxNesting) {
            state.line = endLine;
            break;
        }
        // Try all possible rules.
        // On success, rule should:
        //
        // - update `state.line`
        // - update `state.tokens`
        // - return true
        for(i = 0; i < len; i++){
            ok = rules[i](state, line, endLine, false);
            if (ok) break;
        }
        // set state.tight if we had an empty line before current tag
        // i.e. latest empty line should not count
        state.tight = !hasEmptyLines;
        // paragraph might "eat" one newline after it in nested lists
        if (state.isEmpty(state.line - 1)) hasEmptyLines = true;
        line = state.line;
        if (line < endLine && state.isEmpty(line)) {
            hasEmptyLines = true;
            line++;
            state.line = line;
        }
    }
};
/**
 * ParserBlock.parse(str, md, env, outTokens)
 *
 * Process input string and push block tokens into `outTokens`
 **/ $457f5dd5a6cca9af$var$ParserBlock.prototype.parse = function(src, md, env, outTokens) {
    var state;
    if (!src) return;
    state = new this.State(src, md, env, outTokens);
    this.tokenize(state, state.line, state.lineMax);
};

$457f5dd5a6cca9af$var$ParserBlock.prototype.State = (parcelRequire("aYK1o"));
module.exports = $457f5dd5a6cca9af$var$ParserBlock;

});
parcelRequire.register("l1bHc", function(module, exports) {
// GFM table, https://github.github.com/gfm/#tables-extension-
"use strict";

var $iE2q6 = parcelRequire("iE2q6");
var $f4d2c3806874aedd$require$isSpace = $iE2q6.isSpace;
function $f4d2c3806874aedd$var$getLine(state, line) {
    var pos = state.bMarks[line] + state.tShift[line], max = state.eMarks[line];
    return state.src.slice(pos, max);
}
function $f4d2c3806874aedd$var$escapedSplit(str) {
    var result = [], pos = 0, max = str.length, ch, isEscaped = false, lastPos = 0, current = "";
    ch = str.charCodeAt(pos);
    while(pos < max){
        if (ch === 0x7c /* | */ ) {
            if (!isEscaped) {
                // pipe separating cells, '|'
                result.push(current + str.substring(lastPos, pos));
                current = "";
                lastPos = pos + 1;
            } else {
                // escaped pipe, '\|'
                current += str.substring(lastPos, pos - 1);
                lastPos = pos;
            }
        }
        isEscaped = ch === 0x5c /* \ */ ;
        pos++;
        ch = str.charCodeAt(pos);
    }
    result.push(current + str.substring(lastPos));
    return result;
}
module.exports = function table(state, startLine, endLine, silent) {
    var ch, lineText, pos, i, l, nextLine, columns, columnCount, token, aligns, t, tableLines, tbodyLines, oldParentType, terminate, terminatorRules, firstCh, secondCh;
    // should have at least two lines
    if (startLine + 2 > endLine) return false;
    nextLine = startLine + 1;
    if (state.sCount[nextLine] < state.blkIndent) return false;
    // if it's indented more than 3 spaces, it should be a code block
    if (state.sCount[nextLine] - state.blkIndent >= 4) return false;
    // first character of the second line should be '|', '-', ':',
    // and no other characters are allowed but spaces;
    // basically, this is the equivalent of /^[-:|][-:|\s]*$/ regexp
    pos = state.bMarks[nextLine] + state.tShift[nextLine];
    if (pos >= state.eMarks[nextLine]) return false;
    firstCh = state.src.charCodeAt(pos++);
    if (firstCh !== 0x7C /* | */  && firstCh !== 0x2D /* - */  && firstCh !== 0x3A /* : */ ) return false;
    if (pos >= state.eMarks[nextLine]) return false;
    secondCh = state.src.charCodeAt(pos++);
    if (secondCh !== 0x7C /* | */  && secondCh !== 0x2D /* - */  && secondCh !== 0x3A /* : */  && !$f4d2c3806874aedd$require$isSpace(secondCh)) return false;
    // if first character is '-', then second character must not be a space
    // (due to parsing ambiguity with list)
    if (firstCh === 0x2D /* - */  && $f4d2c3806874aedd$require$isSpace(secondCh)) return false;
    while(pos < state.eMarks[nextLine]){
        ch = state.src.charCodeAt(pos);
        if (ch !== 0x7C /* | */  && ch !== 0x2D /* - */  && ch !== 0x3A /* : */  && !$f4d2c3806874aedd$require$isSpace(ch)) return false;
        pos++;
    }
    lineText = $f4d2c3806874aedd$var$getLine(state, startLine + 1);
    columns = lineText.split("|");
    aligns = [];
    for(i = 0; i < columns.length; i++){
        t = columns[i].trim();
        if (!t) {
            // allow empty columns before and after table, but not in between columns;
            // e.g. allow ` |---| `, disallow ` ---||--- `
            if (i === 0 || i === columns.length - 1) continue;
            else return false;
        }
        if (!/^:?-+:?$/.test(t)) return false;
        if (t.charCodeAt(t.length - 1) === 0x3A /* : */ ) aligns.push(t.charCodeAt(0) === 0x3A /* : */  ? "center" : "right");
        else if (t.charCodeAt(0) === 0x3A /* : */ ) aligns.push("left");
        else aligns.push("");
    }
    lineText = $f4d2c3806874aedd$var$getLine(state, startLine).trim();
    if (lineText.indexOf("|") === -1) return false;
    if (state.sCount[startLine] - state.blkIndent >= 4) return false;
    columns = $f4d2c3806874aedd$var$escapedSplit(lineText);
    if (columns.length && columns[0] === "") columns.shift();
    if (columns.length && columns[columns.length - 1] === "") columns.pop();
    // header row will define an amount of columns in the entire table,
    // and align row should be exactly the same (the rest of the rows can differ)
    columnCount = columns.length;
    if (columnCount === 0 || columnCount !== aligns.length) return false;
    if (silent) return true;
    oldParentType = state.parentType;
    state.parentType = "table";
    // use 'blockquote' lists for termination because it's
    // the most similar to tables
    terminatorRules = state.md.block.ruler.getRules("blockquote");
    token = state.push("table_open", "table", 1);
    token.map = tableLines = [
        startLine,
        0
    ];
    token = state.push("thead_open", "thead", 1);
    token.map = [
        startLine,
        startLine + 1
    ];
    token = state.push("tr_open", "tr", 1);
    token.map = [
        startLine,
        startLine + 1
    ];
    for(i = 0; i < columns.length; i++){
        token = state.push("th_open", "th", 1);
        if (aligns[i]) token.attrs = [
            [
                "style",
                "text-align:" + aligns[i]
            ]
        ];
        token = state.push("inline", "", 0);
        token.content = columns[i].trim();
        token.children = [];
        token = state.push("th_close", "th", -1);
    }
    token = state.push("tr_close", "tr", -1);
    token = state.push("thead_close", "thead", -1);
    for(nextLine = startLine + 2; nextLine < endLine; nextLine++){
        if (state.sCount[nextLine] < state.blkIndent) break;
        terminate = false;
        for(i = 0, l = terminatorRules.length; i < l; i++)if (terminatorRules[i](state, nextLine, endLine, true)) {
            terminate = true;
            break;
        }
        if (terminate) break;
        lineText = $f4d2c3806874aedd$var$getLine(state, nextLine).trim();
        if (!lineText) break;
        if (state.sCount[nextLine] - state.blkIndent >= 4) break;
        columns = $f4d2c3806874aedd$var$escapedSplit(lineText);
        if (columns.length && columns[0] === "") columns.shift();
        if (columns.length && columns[columns.length - 1] === "") columns.pop();
        if (nextLine === startLine + 2) {
            token = state.push("tbody_open", "tbody", 1);
            token.map = tbodyLines = [
                startLine + 2,
                0
            ];
        }
        token = state.push("tr_open", "tr", 1);
        token.map = [
            nextLine,
            nextLine + 1
        ];
        for(i = 0; i < columnCount; i++){
            token = state.push("td_open", "td", 1);
            if (aligns[i]) token.attrs = [
                [
                    "style",
                    "text-align:" + aligns[i]
                ]
            ];
            token = state.push("inline", "", 0);
            token.content = columns[i] ? columns[i].trim() : "";
            token.children = [];
            token = state.push("td_close", "td", -1);
        }
        token = state.push("tr_close", "tr", -1);
    }
    if (tbodyLines) {
        token = state.push("tbody_close", "tbody", -1);
        tbodyLines[1] = nextLine;
    }
    token = state.push("table_close", "table", -1);
    tableLines[1] = nextLine;
    state.parentType = oldParentType;
    state.line = nextLine;
    return true;
};

});

parcelRequire.register("22e9x", function(module, exports) {
// Code block (4 spaces padded)
"use strict";
module.exports = function code(state, startLine, endLine /*, silent*/ ) {
    var nextLine, last, token;
    if (state.sCount[startLine] - state.blkIndent < 4) return false;
    last = nextLine = startLine + 1;
    while(nextLine < endLine){
        if (state.isEmpty(nextLine)) {
            nextLine++;
            continue;
        }
        if (state.sCount[nextLine] - state.blkIndent >= 4) {
            nextLine++;
            last = nextLine;
            continue;
        }
        break;
    }
    state.line = last;
    token = state.push("code_block", "code", 0);
    token.content = state.getLines(startLine, last, 4 + state.blkIndent, false) + "\n";
    token.map = [
        startLine,
        state.line
    ];
    return true;
};

});

parcelRequire.register("aezo9", function(module, exports) {
// fences (``` lang, ~~~ lang)
"use strict";
module.exports = function fence(state, startLine, endLine, silent) {
    var marker, len, params, nextLine, mem, token, markup, haveEndMarker = false, pos = state.bMarks[startLine] + state.tShift[startLine], max = state.eMarks[startLine];
    // if it's indented more than 3 spaces, it should be a code block
    if (state.sCount[startLine] - state.blkIndent >= 4) return false;
    if (pos + 3 > max) return false;
    marker = state.src.charCodeAt(pos);
    if (marker !== 0x7E /* ~ */  && marker !== 0x60 /* ` */ ) return false;
    // scan marker length
    mem = pos;
    pos = state.skipChars(pos, marker);
    len = pos - mem;
    if (len < 3) return false;
    markup = state.src.slice(mem, pos);
    params = state.src.slice(pos, max);
    if (marker === 0x60 /* ` */ ) {
        if (params.indexOf(String.fromCharCode(marker)) >= 0) return false;
    }
    // Since start is found, we can report success here in validation mode
    if (silent) return true;
    // search end of block
    nextLine = startLine;
    for(;;){
        nextLine++;
        if (nextLine >= endLine) break;
        pos = mem = state.bMarks[nextLine] + state.tShift[nextLine];
        max = state.eMarks[nextLine];
        if (pos < max && state.sCount[nextLine] < state.blkIndent) break;
        if (state.src.charCodeAt(pos) !== marker) continue;
        if (state.sCount[nextLine] - state.blkIndent >= 4) continue;
        pos = state.skipChars(pos, marker);
        // closing code fence must be at least as long as the opening one
        if (pos - mem < len) continue;
        // make sure tail has spaces only
        pos = state.skipSpaces(pos);
        if (pos < max) continue;
        haveEndMarker = true;
        break;
    }
    // If a fence has heading spaces, they should be removed from its inner block
    len = state.sCount[startLine];
    state.line = nextLine + (haveEndMarker ? 1 : 0);
    token = state.push("fence", "code", 0);
    token.info = params;
    token.content = state.getLines(startLine + 1, nextLine, len, true);
    token.markup = markup;
    token.map = [
        startLine,
        state.line
    ];
    return true;
};

});

parcelRequire.register("8U83L", function(module, exports) {
// Block quotes
"use strict";

var $iE2q6 = parcelRequire("iE2q6");
var $67b9ce2d3452de67$require$isSpace = $iE2q6.isSpace;
module.exports = function blockquote(state, startLine, endLine, silent) {
    var adjustTab, ch, i, initial, l, lastLineEmpty, lines, nextLine, offset, oldBMarks, oldBSCount, oldIndent, oldParentType, oldSCount, oldTShift, spaceAfterMarker, terminate, terminatorRules, token, isOutdented, oldLineMax = state.lineMax, pos = state.bMarks[startLine] + state.tShift[startLine], max = state.eMarks[startLine];
    // if it's indented more than 3 spaces, it should be a code block
    if (state.sCount[startLine] - state.blkIndent >= 4) return false;
    // check the block quote marker
    if (state.src.charCodeAt(pos++) !== 0x3E /* > */ ) return false;
    // we know that it's going to be a valid blockquote,
    // so no point trying to find the end of it in silent mode
    if (silent) return true;
    // set offset past spaces and ">"
    initial = offset = state.sCount[startLine] + 1;
    // skip one optional space after '>'
    if (state.src.charCodeAt(pos) === 0x20 /* space */ ) {
        // ' >   test '
        //     ^ -- position start of line here:
        pos++;
        initial++;
        offset++;
        adjustTab = false;
        spaceAfterMarker = true;
    } else if (state.src.charCodeAt(pos) === 0x09 /* tab */ ) {
        spaceAfterMarker = true;
        if ((state.bsCount[startLine] + offset) % 4 === 3) {
            // '  >\t  test '
            //       ^ -- position start of line here (tab has width===1)
            pos++;
            initial++;
            offset++;
            adjustTab = false;
        } else // ' >\t  test '
        //    ^ -- position start of line here + shift bsCount slightly
        //         to make extra space appear
        adjustTab = true;
    } else spaceAfterMarker = false;
    oldBMarks = [
        state.bMarks[startLine]
    ];
    state.bMarks[startLine] = pos;
    while(pos < max){
        ch = state.src.charCodeAt(pos);
        if ($67b9ce2d3452de67$require$isSpace(ch)) {
            if (ch === 0x09) offset += 4 - (offset + state.bsCount[startLine] + (adjustTab ? 1 : 0)) % 4;
            else offset++;
        } else break;
        pos++;
    }
    oldBSCount = [
        state.bsCount[startLine]
    ];
    state.bsCount[startLine] = state.sCount[startLine] + 1 + (spaceAfterMarker ? 1 : 0);
    lastLineEmpty = pos >= max;
    oldSCount = [
        state.sCount[startLine]
    ];
    state.sCount[startLine] = offset - initial;
    oldTShift = [
        state.tShift[startLine]
    ];
    state.tShift[startLine] = pos - state.bMarks[startLine];
    terminatorRules = state.md.block.ruler.getRules("blockquote");
    oldParentType = state.parentType;
    state.parentType = "blockquote";
    // Search the end of the block
    //
    // Block ends with either:
    //  1. an empty line outside:
    //     ```
    //     > test
    //
    //     ```
    //  2. an empty line inside:
    //     ```
    //     >
    //     test
    //     ```
    //  3. another tag:
    //     ```
    //     > test
    //      - - -
    //     ```
    for(nextLine = startLine + 1; nextLine < endLine; nextLine++){
        // check if it's outdented, i.e. it's inside list item and indented
        // less than said list item:
        //
        // ```
        // 1. anything
        //    > current blockquote
        // 2. checking this line
        // ```
        isOutdented = state.sCount[nextLine] < state.blkIndent;
        pos = state.bMarks[nextLine] + state.tShift[nextLine];
        max = state.eMarks[nextLine];
        if (pos >= max) break;
        if (state.src.charCodeAt(pos++) === 0x3E /* > */  && !isOutdented) {
            // This line is inside the blockquote.
            // set offset past spaces and ">"
            initial = offset = state.sCount[nextLine] + 1;
            // skip one optional space after '>'
            if (state.src.charCodeAt(pos) === 0x20 /* space */ ) {
                // ' >   test '
                //     ^ -- position start of line here:
                pos++;
                initial++;
                offset++;
                adjustTab = false;
                spaceAfterMarker = true;
            } else if (state.src.charCodeAt(pos) === 0x09 /* tab */ ) {
                spaceAfterMarker = true;
                if ((state.bsCount[nextLine] + offset) % 4 === 3) {
                    // '  >\t  test '
                    //       ^ -- position start of line here (tab has width===1)
                    pos++;
                    initial++;
                    offset++;
                    adjustTab = false;
                } else // ' >\t  test '
                //    ^ -- position start of line here + shift bsCount slightly
                //         to make extra space appear
                adjustTab = true;
            } else spaceAfterMarker = false;
            oldBMarks.push(state.bMarks[nextLine]);
            state.bMarks[nextLine] = pos;
            while(pos < max){
                ch = state.src.charCodeAt(pos);
                if ($67b9ce2d3452de67$require$isSpace(ch)) {
                    if (ch === 0x09) offset += 4 - (offset + state.bsCount[nextLine] + (adjustTab ? 1 : 0)) % 4;
                    else offset++;
                } else break;
                pos++;
            }
            lastLineEmpty = pos >= max;
            oldBSCount.push(state.bsCount[nextLine]);
            state.bsCount[nextLine] = state.sCount[nextLine] + 1 + (spaceAfterMarker ? 1 : 0);
            oldSCount.push(state.sCount[nextLine]);
            state.sCount[nextLine] = offset - initial;
            oldTShift.push(state.tShift[nextLine]);
            state.tShift[nextLine] = pos - state.bMarks[nextLine];
            continue;
        }
        // Case 2: line is not inside the blockquote, and the last line was empty.
        if (lastLineEmpty) break;
        // Case 3: another tag found.
        terminate = false;
        for(i = 0, l = terminatorRules.length; i < l; i++)if (terminatorRules[i](state, nextLine, endLine, true)) {
            terminate = true;
            break;
        }
        if (terminate) {
            // Quirk to enforce "hard termination mode" for paragraphs;
            // normally if you call `tokenize(state, startLine, nextLine)`,
            // paragraphs will look below nextLine for paragraph continuation,
            // but if blockquote is terminated by another tag, they shouldn't
            state.lineMax = nextLine;
            if (state.blkIndent !== 0) {
                // state.blkIndent was non-zero, we now set it to zero,
                // so we need to re-calculate all offsets to appear as
                // if indent wasn't changed
                oldBMarks.push(state.bMarks[nextLine]);
                oldBSCount.push(state.bsCount[nextLine]);
                oldTShift.push(state.tShift[nextLine]);
                oldSCount.push(state.sCount[nextLine]);
                state.sCount[nextLine] -= state.blkIndent;
            }
            break;
        }
        oldBMarks.push(state.bMarks[nextLine]);
        oldBSCount.push(state.bsCount[nextLine]);
        oldTShift.push(state.tShift[nextLine]);
        oldSCount.push(state.sCount[nextLine]);
        // A negative indentation means that this is a paragraph continuation
        //
        state.sCount[nextLine] = -1;
    }
    oldIndent = state.blkIndent;
    state.blkIndent = 0;
    token = state.push("blockquote_open", "blockquote", 1);
    token.markup = ">";
    token.map = lines = [
        startLine,
        0
    ];
    state.md.block.tokenize(state, startLine, nextLine);
    token = state.push("blockquote_close", "blockquote", -1);
    token.markup = ">";
    state.lineMax = oldLineMax;
    state.parentType = oldParentType;
    lines[1] = state.line;
    // Restore original tShift; this might not be necessary since the parser
    // has already been here, but just to make sure we can do that.
    for(i = 0; i < oldTShift.length; i++){
        state.bMarks[i + startLine] = oldBMarks[i];
        state.tShift[i + startLine] = oldTShift[i];
        state.sCount[i + startLine] = oldSCount[i];
        state.bsCount[i + startLine] = oldBSCount[i];
    }
    state.blkIndent = oldIndent;
    return true;
};

});

parcelRequire.register("9I8zP", function(module, exports) {
// Horizontal rule
"use strict";

var $iE2q6 = parcelRequire("iE2q6");
var $711ee04b158f5c61$require$isSpace = $iE2q6.isSpace;
module.exports = function hr(state, startLine, endLine, silent) {
    var marker, cnt, ch, token, pos = state.bMarks[startLine] + state.tShift[startLine], max = state.eMarks[startLine];
    // if it's indented more than 3 spaces, it should be a code block
    if (state.sCount[startLine] - state.blkIndent >= 4) return false;
    marker = state.src.charCodeAt(pos++);
    // Check hr marker
    if (marker !== 0x2A /* * */  && marker !== 0x2D /* - */  && marker !== 0x5F /* _ */ ) return false;
    // markers can be mixed with spaces, but there should be at least 3 of them
    cnt = 1;
    while(pos < max){
        ch = state.src.charCodeAt(pos++);
        if (ch !== marker && !$711ee04b158f5c61$require$isSpace(ch)) return false;
        if (ch === marker) cnt++;
    }
    if (cnt < 3) return false;
    if (silent) return true;
    state.line = startLine + 1;
    token = state.push("hr", "hr", 0);
    token.map = [
        startLine,
        state.line
    ];
    token.markup = Array(cnt + 1).join(String.fromCharCode(marker));
    return true;
};

});

parcelRequire.register("3D3gr", function(module, exports) {
// Lists
"use strict";

var $iE2q6 = parcelRequire("iE2q6");
var $2a478bd5691278ce$require$isSpace = $iE2q6.isSpace;
// Search `[-+*][\n ]`, returns next pos after marker on success
// or -1 on fail.
function $2a478bd5691278ce$var$skipBulletListMarker(state, startLine) {
    var marker, pos, max, ch;
    pos = state.bMarks[startLine] + state.tShift[startLine];
    max = state.eMarks[startLine];
    marker = state.src.charCodeAt(pos++);
    // Check bullet
    if (marker !== 0x2A /* * */  && marker !== 0x2D /* - */  && marker !== 0x2B /* + */ ) return -1;
    if (pos < max) {
        ch = state.src.charCodeAt(pos);
        if (!$2a478bd5691278ce$require$isSpace(ch)) // " -test " - is not a list item
        return -1;
    }
    return pos;
}
// Search `\d+[.)][\n ]`, returns next pos after marker on success
// or -1 on fail.
function $2a478bd5691278ce$var$skipOrderedListMarker(state, startLine) {
    var ch, start = state.bMarks[startLine] + state.tShift[startLine], pos = start, max = state.eMarks[startLine];
    // List marker should have at least 2 chars (digit + dot)
    if (pos + 1 >= max) return -1;
    ch = state.src.charCodeAt(pos++);
    if (ch < 0x30 /* 0 */  || ch > 0x39 /* 9 */ ) return -1;
    for(;;){
        // EOL -> fail
        if (pos >= max) return -1;
        ch = state.src.charCodeAt(pos++);
        if (ch >= 0x30 /* 0 */  && ch <= 0x39 /* 9 */ ) {
            // List marker should have no more than 9 digits
            // (prevents integer overflow in browsers)
            if (pos - start >= 10) return -1;
            continue;
        }
        // found valid marker
        if (ch === 0x29 /* ) */  || ch === 0x2e /* . */ ) break;
        return -1;
    }
    if (pos < max) {
        ch = state.src.charCodeAt(pos);
        if (!$2a478bd5691278ce$require$isSpace(ch)) // " 1.test " - is not a list item
        return -1;
    }
    return pos;
}
function $2a478bd5691278ce$var$markTightParagraphs(state, idx) {
    var i, l, level = state.level + 2;
    for(i = idx + 2, l = state.tokens.length - 2; i < l; i++)if (state.tokens[i].level === level && state.tokens[i].type === "paragraph_open") {
        state.tokens[i + 2].hidden = true;
        state.tokens[i].hidden = true;
        i += 2;
    }
}
module.exports = function list(state, startLine, endLine, silent) {
    var ch, contentStart, i, indent, indentAfterMarker, initial, isOrdered, itemLines, l, listLines, listTokIdx, markerCharCode, markerValue, max, nextLine, offset, oldListIndent, oldParentType, oldSCount, oldTShift, oldTight, pos, posAfterMarker, prevEmptyEnd, start, terminate, terminatorRules, token, isTerminatingParagraph = false, tight = true;
    // if it's indented more than 3 spaces, it should be a code block
    if (state.sCount[startLine] - state.blkIndent >= 4) return false;
    // Special case:
    //  - item 1
    //   - item 2
    //    - item 3
    //     - item 4
    //      - this one is a paragraph continuation
    if (state.listIndent >= 0 && state.sCount[startLine] - state.listIndent >= 4 && state.sCount[startLine] < state.blkIndent) return false;
    // limit conditions when list can interrupt
    // a paragraph (validation mode only)
    if (silent && state.parentType === "paragraph") // Next list item should still terminate previous list item;
    //
    // This code can fail if plugins use blkIndent as well as lists,
    // but I hope the spec gets fixed long before that happens.
    //
    {
        if (state.sCount[startLine] >= state.blkIndent) isTerminatingParagraph = true;
    }
    // Detect list type and position after marker
    if ((posAfterMarker = $2a478bd5691278ce$var$skipOrderedListMarker(state, startLine)) >= 0) {
        isOrdered = true;
        start = state.bMarks[startLine] + state.tShift[startLine];
        markerValue = Number(state.src.slice(start, posAfterMarker - 1));
        // If we're starting a new ordered list right after
        // a paragraph, it should start with 1.
        if (isTerminatingParagraph && markerValue !== 1) return false;
    } else if ((posAfterMarker = $2a478bd5691278ce$var$skipBulletListMarker(state, startLine)) >= 0) isOrdered = false;
    else return false;
    // If we're starting a new unordered list right after
    // a paragraph, first line should not be empty.
    if (isTerminatingParagraph) {
        if (state.skipSpaces(posAfterMarker) >= state.eMarks[startLine]) return false;
    }
    // We should terminate list on style change. Remember first one to compare.
    markerCharCode = state.src.charCodeAt(posAfterMarker - 1);
    // For validation mode we can terminate immediately
    if (silent) return true;
    // Start list
    listTokIdx = state.tokens.length;
    if (isOrdered) {
        token = state.push("ordered_list_open", "ol", 1);
        if (markerValue !== 1) token.attrs = [
            [
                "start",
                markerValue
            ]
        ];
    } else token = state.push("bullet_list_open", "ul", 1);
    token.map = listLines = [
        startLine,
        0
    ];
    token.markup = String.fromCharCode(markerCharCode);
    //
    // Iterate list items
    //
    nextLine = startLine;
    prevEmptyEnd = false;
    terminatorRules = state.md.block.ruler.getRules("list");
    oldParentType = state.parentType;
    state.parentType = "list";
    while(nextLine < endLine){
        pos = posAfterMarker;
        max = state.eMarks[nextLine];
        initial = offset = state.sCount[nextLine] + posAfterMarker - (state.bMarks[startLine] + state.tShift[startLine]);
        while(pos < max){
            ch = state.src.charCodeAt(pos);
            if (ch === 0x09) offset += 4 - (offset + state.bsCount[nextLine]) % 4;
            else if (ch === 0x20) offset++;
            else break;
            pos++;
        }
        contentStart = pos;
        if (contentStart >= max) // trimming space in "-    \n  3" case, indent is 1 here
        indentAfterMarker = 1;
        else indentAfterMarker = offset - initial;
        // If we have more than 4 spaces, the indent is 1
        // (the rest is just indented code block)
        if (indentAfterMarker > 4) indentAfterMarker = 1;
        // "  -  test"
        //  ^^^^^ - calculating total length of this thing
        indent = initial + indentAfterMarker;
        // Run subparser & write tokens
        token = state.push("list_item_open", "li", 1);
        token.markup = String.fromCharCode(markerCharCode);
        token.map = itemLines = [
            startLine,
            0
        ];
        if (isOrdered) token.info = state.src.slice(start, posAfterMarker - 1);
        // change current state, then restore it after parser subcall
        oldTight = state.tight;
        oldTShift = state.tShift[startLine];
        oldSCount = state.sCount[startLine];
        //  - example list
        // ^ listIndent position will be here
        //   ^ blkIndent position will be here
        //
        oldListIndent = state.listIndent;
        state.listIndent = state.blkIndent;
        state.blkIndent = indent;
        state.tight = true;
        state.tShift[startLine] = contentStart - state.bMarks[startLine];
        state.sCount[startLine] = offset;
        if (contentStart >= max && state.isEmpty(startLine + 1)) // workaround for this case
        // (list item is empty, list terminates before "foo"):
        // ~~~~~~~~
        //   -
        //
        //     foo
        // ~~~~~~~~
        state.line = Math.min(state.line + 2, endLine);
        else state.md.block.tokenize(state, startLine, endLine, true);
        // If any of list item is tight, mark list as tight
        if (!state.tight || prevEmptyEnd) tight = false;
        // Item become loose if finish with empty line,
        // but we should filter last element, because it means list finish
        prevEmptyEnd = state.line - startLine > 1 && state.isEmpty(state.line - 1);
        state.blkIndent = state.listIndent;
        state.listIndent = oldListIndent;
        state.tShift[startLine] = oldTShift;
        state.sCount[startLine] = oldSCount;
        state.tight = oldTight;
        token = state.push("list_item_close", "li", -1);
        token.markup = String.fromCharCode(markerCharCode);
        nextLine = startLine = state.line;
        itemLines[1] = nextLine;
        contentStart = state.bMarks[startLine];
        if (nextLine >= endLine) break;
        //
        // Try to check if list is terminated or continued.
        //
        if (state.sCount[nextLine] < state.blkIndent) break;
        // if it's indented more than 3 spaces, it should be a code block
        if (state.sCount[startLine] - state.blkIndent >= 4) break;
        // fail if terminating block found
        terminate = false;
        for(i = 0, l = terminatorRules.length; i < l; i++)if (terminatorRules[i](state, nextLine, endLine, true)) {
            terminate = true;
            break;
        }
        if (terminate) break;
        // fail if list has another type
        if (isOrdered) {
            posAfterMarker = $2a478bd5691278ce$var$skipOrderedListMarker(state, nextLine);
            if (posAfterMarker < 0) break;
            start = state.bMarks[nextLine] + state.tShift[nextLine];
        } else {
            posAfterMarker = $2a478bd5691278ce$var$skipBulletListMarker(state, nextLine);
            if (posAfterMarker < 0) break;
        }
        if (markerCharCode !== state.src.charCodeAt(posAfterMarker - 1)) break;
    }
    // Finalize list
    if (isOrdered) token = state.push("ordered_list_close", "ol", -1);
    else token = state.push("bullet_list_close", "ul", -1);
    token.markup = String.fromCharCode(markerCharCode);
    listLines[1] = nextLine;
    state.line = nextLine;
    state.parentType = oldParentType;
    // mark paragraphs tight if needed
    if (tight) $2a478bd5691278ce$var$markTightParagraphs(state, listTokIdx);
    return true;
};

});

parcelRequire.register("kVDAZ", function(module, exports) {
"use strict";

var $iE2q6 = parcelRequire("iE2q6");
var $f3c7d85bde39f924$require$normalizeReference = $iE2q6.normalizeReference;

var $iE2q6 = parcelRequire("iE2q6");
var $f3c7d85bde39f924$require$isSpace = $iE2q6.isSpace;
module.exports = function reference(state, startLine, _endLine, silent) {
    var ch, destEndPos, destEndLineNo, endLine, href, i, l, label, labelEnd, oldParentType, res, start, str, terminate, terminatorRules, title, lines = 0, pos = state.bMarks[startLine] + state.tShift[startLine], max = state.eMarks[startLine], nextLine = startLine + 1;
    // if it's indented more than 3 spaces, it should be a code block
    if (state.sCount[startLine] - state.blkIndent >= 4) return false;
    if (state.src.charCodeAt(pos) !== 0x5B /* [ */ ) return false;
    // Simple check to quickly interrupt scan on [link](url) at the start of line.
    // Can be useful on practice: https://github.com/markdown-it/markdown-it/issues/54
    while(++pos < max)if (state.src.charCodeAt(pos) === 0x5D /* ] */  && state.src.charCodeAt(pos - 1) !== 0x5C /* \ */ ) {
        if (pos + 1 === max) return false;
        if (state.src.charCodeAt(pos + 1) !== 0x3A /* : */ ) return false;
        break;
    }
    endLine = state.lineMax;
    // jump line-by-line until empty one or EOF
    terminatorRules = state.md.block.ruler.getRules("reference");
    oldParentType = state.parentType;
    state.parentType = "reference";
    for(; nextLine < endLine && !state.isEmpty(nextLine); nextLine++){
        // this would be a code block normally, but after paragraph
        // it's considered a lazy continuation regardless of what's there
        if (state.sCount[nextLine] - state.blkIndent > 3) continue;
        // quirk for blockquotes, this line should already be checked by that rule
        if (state.sCount[nextLine] < 0) continue;
        // Some tags can terminate paragraph without empty line.
        terminate = false;
        for(i = 0, l = terminatorRules.length; i < l; i++)if (terminatorRules[i](state, nextLine, endLine, true)) {
            terminate = true;
            break;
        }
        if (terminate) break;
    }
    str = state.getLines(startLine, nextLine, state.blkIndent, false).trim();
    max = str.length;
    for(pos = 1; pos < max; pos++){
        ch = str.charCodeAt(pos);
        if (ch === 0x5B /* [ */ ) return false;
        else if (ch === 0x5D /* ] */ ) {
            labelEnd = pos;
            break;
        } else if (ch === 0x0A /* \n */ ) lines++;
        else if (ch === 0x5C /* \ */ ) {
            pos++;
            if (pos < max && str.charCodeAt(pos) === 0x0A) lines++;
        }
    }
    if (labelEnd < 0 || str.charCodeAt(labelEnd + 1) !== 0x3A /* : */ ) return false;
    // [label]:   destination   'title'
    //         ^^^ skip optional whitespace here
    for(pos = labelEnd + 2; pos < max; pos++){
        ch = str.charCodeAt(pos);
        if (ch === 0x0A) lines++;
        else if ($f3c7d85bde39f924$require$isSpace(ch)) ;
        else break;
    }
    // [label]:   destination   'title'
    //            ^^^^^^^^^^^ parse this
    res = state.md.helpers.parseLinkDestination(str, pos, max);
    if (!res.ok) return false;
    href = state.md.normalizeLink(res.str);
    if (!state.md.validateLink(href)) return false;
    pos = res.pos;
    lines += res.lines;
    // save cursor state, we could require to rollback later
    destEndPos = pos;
    destEndLineNo = lines;
    // [label]:   destination   'title'
    //                       ^^^ skipping those spaces
    start = pos;
    for(; pos < max; pos++){
        ch = str.charCodeAt(pos);
        if (ch === 0x0A) lines++;
        else if ($f3c7d85bde39f924$require$isSpace(ch)) ;
        else break;
    }
    // [label]:   destination   'title'
    //                          ^^^^^^^ parse this
    res = state.md.helpers.parseLinkTitle(str, pos, max);
    if (pos < max && start !== pos && res.ok) {
        title = res.str;
        pos = res.pos;
        lines += res.lines;
    } else {
        title = "";
        pos = destEndPos;
        lines = destEndLineNo;
    }
    // skip trailing spaces until the rest of the line
    while(pos < max){
        ch = str.charCodeAt(pos);
        if (!$f3c7d85bde39f924$require$isSpace(ch)) break;
        pos++;
    }
    if (pos < max && str.charCodeAt(pos) !== 0x0A) {
        if (title) {
            // garbage at the end of the line after title,
            // but it could still be a valid reference if we roll back
            title = "";
            pos = destEndPos;
            lines = destEndLineNo;
            while(pos < max){
                ch = str.charCodeAt(pos);
                if (!$f3c7d85bde39f924$require$isSpace(ch)) break;
                pos++;
            }
        }
    }
    if (pos < max && str.charCodeAt(pos) !== 0x0A) // garbage at the end of the line
    return false;
    label = $f3c7d85bde39f924$require$normalizeReference(str.slice(1, labelEnd));
    if (!label) // CommonMark 0.20 disallows empty labels
    return false;
    // Reference can not terminate anything. This check is for safety only.
    /*istanbul ignore if*/ if (silent) return true;
    if (typeof state.env.references === "undefined") state.env.references = {};
    if (typeof state.env.references[label] === "undefined") state.env.references[label] = {
        title: title,
        href: href
    };
    state.parentType = oldParentType;
    state.line = startLine + lines + 1;
    return true;
};

});

parcelRequire.register("hI5Fz", function(module, exports) {
// HTML block
"use strict";

var $tEmDd = parcelRequire("tEmDd");

var $6cXnH = parcelRequire("6cXnH");
var $ce4af1919d29bc53$require$HTML_OPEN_CLOSE_TAG_RE = $6cXnH.HTML_OPEN_CLOSE_TAG_RE;
// An array of opening and corresponding closing sequences for html tags,
// last argument defines whether it can terminate a paragraph or not
//
var $ce4af1919d29bc53$var$HTML_SEQUENCES = [
    [
        /^<(script|pre|style|textarea)(?=(\s|>|$))/i,
        /<\/(script|pre|style|textarea)>/i,
        true
    ],
    [
        /^<!--/,
        /-->/,
        true
    ],
    [
        /^<\?/,
        /\?>/,
        true
    ],
    [
        /^<![A-Z]/,
        />/,
        true
    ],
    [
        /^<!\[CDATA\[/,
        /\]\]>/,
        true
    ],
    [
        new RegExp("^</?(" + $tEmDd.join("|") + ")(?=(\\s|/?>|$))", "i"),
        /^$/,
        true
    ],
    [
        new RegExp($ce4af1919d29bc53$require$HTML_OPEN_CLOSE_TAG_RE.source + "\\s*$"),
        /^$/,
        false
    ]
];
module.exports = function html_block(state, startLine, endLine, silent) {
    var i, nextLine, token, lineText, pos = state.bMarks[startLine] + state.tShift[startLine], max = state.eMarks[startLine];
    // if it's indented more than 3 spaces, it should be a code block
    if (state.sCount[startLine] - state.blkIndent >= 4) return false;
    if (!state.md.options.html) return false;
    if (state.src.charCodeAt(pos) !== 0x3C /* < */ ) return false;
    lineText = state.src.slice(pos, max);
    for(i = 0; i < $ce4af1919d29bc53$var$HTML_SEQUENCES.length; i++){
        if ($ce4af1919d29bc53$var$HTML_SEQUENCES[i][0].test(lineText)) break;
    }
    if (i === $ce4af1919d29bc53$var$HTML_SEQUENCES.length) return false;
    if (silent) // true if this sequence can be a terminator, false otherwise
    return $ce4af1919d29bc53$var$HTML_SEQUENCES[i][2];
    nextLine = startLine + 1;
    // If we are here - we detected HTML block.
    // Let's roll down till block end.
    if (!$ce4af1919d29bc53$var$HTML_SEQUENCES[i][1].test(lineText)) for(; nextLine < endLine; nextLine++){
        if (state.sCount[nextLine] < state.blkIndent) break;
        pos = state.bMarks[nextLine] + state.tShift[nextLine];
        max = state.eMarks[nextLine];
        lineText = state.src.slice(pos, max);
        if ($ce4af1919d29bc53$var$HTML_SEQUENCES[i][1].test(lineText)) {
            if (lineText.length !== 0) nextLine++;
            break;
        }
    }
    state.line = nextLine;
    token = state.push("html_block", "", 0);
    token.map = [
        startLine,
        nextLine
    ];
    token.content = state.getLines(startLine, nextLine, state.blkIndent, true);
    return true;
};

});
parcelRequire.register("tEmDd", function(module, exports) {
// List of valid html blocks names, accorting to commonmark spec
// http://jgm.github.io/CommonMark/spec.html#html-blocks
"use strict";
module.exports = [
    "address",
    "article",
    "aside",
    "base",
    "basefont",
    "blockquote",
    "body",
    "caption",
    "center",
    "col",
    "colgroup",
    "dd",
    "details",
    "dialog",
    "dir",
    "div",
    "dl",
    "dt",
    "fieldset",
    "figcaption",
    "figure",
    "footer",
    "form",
    "frame",
    "frameset",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "head",
    "header",
    "hr",
    "html",
    "iframe",
    "legend",
    "li",
    "link",
    "main",
    "menu",
    "menuitem",
    "nav",
    "noframes",
    "ol",
    "optgroup",
    "option",
    "p",
    "param",
    "section",
    "source",
    "summary",
    "table",
    "tbody",
    "td",
    "tfoot",
    "th",
    "thead",
    "title",
    "tr",
    "track",
    "ul"
];

});

parcelRequire.register("6cXnH", function(module, exports) {

$parcel$export(module.exports, "HTML_TAG_RE", () => $4851ecf46747d641$export$6db61d2c3a16e419, (v) => $4851ecf46747d641$export$6db61d2c3a16e419 = v);
$parcel$export(module.exports, "HTML_OPEN_CLOSE_TAG_RE", () => $4851ecf46747d641$export$cd48660d06f74639, (v) => $4851ecf46747d641$export$cd48660d06f74639 = v);
// Regexps to match html elements
var $4851ecf46747d641$export$6db61d2c3a16e419;
var $4851ecf46747d641$export$cd48660d06f74639;
"use strict";
var $4851ecf46747d641$var$attr_name = "[a-zA-Z_:][a-zA-Z0-9:._-]*";
var $4851ecf46747d641$var$unquoted = "[^\"'=<>`\\x00-\\x20]+";
var $4851ecf46747d641$var$single_quoted = "'[^']*'";
var $4851ecf46747d641$var$double_quoted = '"[^"]*"';
var $4851ecf46747d641$var$attr_value = "(?:" + $4851ecf46747d641$var$unquoted + "|" + $4851ecf46747d641$var$single_quoted + "|" + $4851ecf46747d641$var$double_quoted + ")";
var $4851ecf46747d641$var$attribute = "(?:\\s+" + $4851ecf46747d641$var$attr_name + "(?:\\s*=\\s*" + $4851ecf46747d641$var$attr_value + ")?)";
var $4851ecf46747d641$var$open_tag = "<[A-Za-z][A-Za-z0-9\\-]*" + $4851ecf46747d641$var$attribute + "*\\s*\\/?>";
var $4851ecf46747d641$var$close_tag = "<\\/[A-Za-z][A-Za-z0-9\\-]*\\s*>";
var $4851ecf46747d641$var$comment = "<!---->|<!--(?:-?[^>-])(?:-?[^-])*-->";
var $4851ecf46747d641$var$processing = "<[?][\\s\\S]*?[?]>";
var $4851ecf46747d641$var$declaration = "<![A-Z]+\\s+[^>]*>";
var $4851ecf46747d641$var$cdata = "<!\\[CDATA\\[[\\s\\S]*?\\]\\]>";
var $4851ecf46747d641$var$HTML_TAG_RE = new RegExp("^(?:" + $4851ecf46747d641$var$open_tag + "|" + $4851ecf46747d641$var$close_tag + "|" + $4851ecf46747d641$var$comment + "|" + $4851ecf46747d641$var$processing + "|" + $4851ecf46747d641$var$declaration + "|" + $4851ecf46747d641$var$cdata + ")");
var $4851ecf46747d641$var$HTML_OPEN_CLOSE_TAG_RE = new RegExp("^(?:" + $4851ecf46747d641$var$open_tag + "|" + $4851ecf46747d641$var$close_tag + ")");
$4851ecf46747d641$export$6db61d2c3a16e419 = $4851ecf46747d641$var$HTML_TAG_RE;
$4851ecf46747d641$export$cd48660d06f74639 = $4851ecf46747d641$var$HTML_OPEN_CLOSE_TAG_RE;

});


parcelRequire.register("ba3fj", function(module, exports) {
// heading (#, ##, ...)
"use strict";

var $iE2q6 = parcelRequire("iE2q6");
var $8203257090ba2e18$require$isSpace = $iE2q6.isSpace;
module.exports = function heading(state, startLine, endLine, silent) {
    var ch, level, tmp, token, pos = state.bMarks[startLine] + state.tShift[startLine], max = state.eMarks[startLine];
    // if it's indented more than 3 spaces, it should be a code block
    if (state.sCount[startLine] - state.blkIndent >= 4) return false;
    ch = state.src.charCodeAt(pos);
    if (ch !== 0x23 /* # */  || pos >= max) return false;
    // count heading level
    level = 1;
    ch = state.src.charCodeAt(++pos);
    while(ch === 0x23 /* # */  && pos < max && level <= 6){
        level++;
        ch = state.src.charCodeAt(++pos);
    }
    if (level > 6 || pos < max && !$8203257090ba2e18$require$isSpace(ch)) return false;
    if (silent) return true;
    // Let's cut tails like '    ###  ' from the end of string
    max = state.skipSpacesBack(max, pos);
    tmp = state.skipCharsBack(max, 0x23, pos); // #
    if (tmp > pos && $8203257090ba2e18$require$isSpace(state.src.charCodeAt(tmp - 1))) max = tmp;
    state.line = startLine + 1;
    token = state.push("heading_open", "h" + String(level), 1);
    token.markup = "########".slice(0, level);
    token.map = [
        startLine,
        state.line
    ];
    token = state.push("inline", "", 0);
    token.content = state.src.slice(pos, max).trim();
    token.map = [
        startLine,
        state.line
    ];
    token.children = [];
    token = state.push("heading_close", "h" + String(level), -1);
    token.markup = "########".slice(0, level);
    return true;
};

});

parcelRequire.register("4m4vw", function(module, exports) {
// lheading (---, ===)
"use strict";
module.exports = function lheading(state, startLine, endLine /*, silent*/ ) {
    var content, terminate, i, l, token, pos, max, level, marker, nextLine = startLine + 1, oldParentType, terminatorRules = state.md.block.ruler.getRules("paragraph");
    // if it's indented more than 3 spaces, it should be a code block
    if (state.sCount[startLine] - state.blkIndent >= 4) return false;
    oldParentType = state.parentType;
    state.parentType = "paragraph"; // use paragraph to match terminatorRules
    // jump line-by-line until empty one or EOF
    for(; nextLine < endLine && !state.isEmpty(nextLine); nextLine++){
        // this would be a code block normally, but after paragraph
        // it's considered a lazy continuation regardless of what's there
        if (state.sCount[nextLine] - state.blkIndent > 3) continue;
        //
        // Check for underline in setext header
        //
        if (state.sCount[nextLine] >= state.blkIndent) {
            pos = state.bMarks[nextLine] + state.tShift[nextLine];
            max = state.eMarks[nextLine];
            if (pos < max) {
                marker = state.src.charCodeAt(pos);
                if (marker === 0x2D /* - */  || marker === 0x3D /* = */ ) {
                    pos = state.skipChars(pos, marker);
                    pos = state.skipSpaces(pos);
                    if (pos >= max) {
                        level = marker === 0x3D /* = */  ? 1 : 2;
                        break;
                    }
                }
            }
        }
        // quirk for blockquotes, this line should already be checked by that rule
        if (state.sCount[nextLine] < 0) continue;
        // Some tags can terminate paragraph without empty line.
        terminate = false;
        for(i = 0, l = terminatorRules.length; i < l; i++)if (terminatorRules[i](state, nextLine, endLine, true)) {
            terminate = true;
            break;
        }
        if (terminate) break;
    }
    if (!level) // Didn't find valid underline
    return false;
    content = state.getLines(startLine, nextLine, state.blkIndent, false).trim();
    state.line = nextLine + 1;
    token = state.push("heading_open", "h" + String(level), 1);
    token.markup = String.fromCharCode(marker);
    token.map = [
        startLine,
        state.line
    ];
    token = state.push("inline", "", 0);
    token.content = content;
    token.map = [
        startLine,
        state.line - 1
    ];
    token.children = [];
    token = state.push("heading_close", "h" + String(level), -1);
    token.markup = String.fromCharCode(marker);
    state.parentType = oldParentType;
    return true;
};

});

parcelRequire.register("8nYFg", function(module, exports) {
// Paragraph
"use strict";
module.exports = function paragraph(state, startLine /*, endLine*/ ) {
    var content, terminate, i, l, token, oldParentType, nextLine = startLine + 1, terminatorRules = state.md.block.ruler.getRules("paragraph"), endLine = state.lineMax;
    oldParentType = state.parentType;
    state.parentType = "paragraph";
    // jump line-by-line until empty one or EOF
    for(; nextLine < endLine && !state.isEmpty(nextLine); nextLine++){
        // this would be a code block normally, but after paragraph
        // it's considered a lazy continuation regardless of what's there
        if (state.sCount[nextLine] - state.blkIndent > 3) continue;
        // quirk for blockquotes, this line should already be checked by that rule
        if (state.sCount[nextLine] < 0) continue;
        // Some tags can terminate paragraph without empty line.
        terminate = false;
        for(i = 0, l = terminatorRules.length; i < l; i++)if (terminatorRules[i](state, nextLine, endLine, true)) {
            terminate = true;
            break;
        }
        if (terminate) break;
    }
    content = state.getLines(startLine, nextLine, state.blkIndent, false).trim();
    state.line = nextLine;
    token = state.push("paragraph_open", "p", 1);
    token.map = [
        startLine,
        state.line
    ];
    token = state.push("inline", "", 0);
    token.content = content;
    token.map = [
        startLine,
        state.line
    ];
    token.children = [];
    token = state.push("paragraph_close", "p", -1);
    state.parentType = oldParentType;
    return true;
};

});

parcelRequire.register("aYK1o", function(module, exports) {
// Parser state class
"use strict";

var $iLJ9G = parcelRequire("iLJ9G");

var $iE2q6 = parcelRequire("iE2q6");
var $7fe334e6f0f34d45$require$isSpace = $iE2q6.isSpace;
function $7fe334e6f0f34d45$var$StateBlock(src, md, env, tokens) {
    var ch, s, start, pos, len, indent, offset, indent_found;
    this.src = src;
    // link to parser instance
    this.md = md;
    this.env = env;
    //
    // Internal state vartiables
    //
    this.tokens = tokens;
    this.bMarks = []; // line begin offsets for fast jumps
    this.eMarks = []; // line end offsets for fast jumps
    this.tShift = []; // offsets of the first non-space characters (tabs not expanded)
    this.sCount = []; // indents for each line (tabs expanded)
    // An amount of virtual spaces (tabs expanded) between beginning
    // of each line (bMarks) and real beginning of that line.
    //
    // It exists only as a hack because blockquotes override bMarks
    // losing information in the process.
    //
    // It's used only when expanding tabs, you can think about it as
    // an initial tab length, e.g. bsCount=21 applied to string `\t123`
    // means first tab should be expanded to 4-21%4 === 3 spaces.
    //
    this.bsCount = [];
    // block parser variables
    this.blkIndent = 0; // required block content indent (for example, if we are
    // inside a list, it would be positioned after list marker)
    this.line = 0; // line index in src
    this.lineMax = 0; // lines count
    this.tight = false; // loose/tight mode for lists
    this.ddIndent = -1; // indent of the current dd block (-1 if there isn't any)
    this.listIndent = -1; // indent of the current list block (-1 if there isn't any)
    // can be 'blockquote', 'list', 'root', 'paragraph' or 'reference'
    // used in lists to determine if they interrupt a paragraph
    this.parentType = "root";
    this.level = 0;
    // renderer
    this.result = "";
    // Create caches
    // Generate markers.
    s = this.src;
    indent_found = false;
    for(start = pos = indent = offset = 0, len = s.length; pos < len; pos++){
        ch = s.charCodeAt(pos);
        if (!indent_found) {
            if ($7fe334e6f0f34d45$require$isSpace(ch)) {
                indent++;
                if (ch === 0x09) offset += 4 - offset % 4;
                else offset++;
                continue;
            } else indent_found = true;
        }
        if (ch === 0x0A || pos === len - 1) {
            if (ch !== 0x0A) pos++;
            this.bMarks.push(start);
            this.eMarks.push(pos);
            this.tShift.push(indent);
            this.sCount.push(offset);
            this.bsCount.push(0);
            indent_found = false;
            indent = 0;
            offset = 0;
            start = pos + 1;
        }
    }
    // Push fake entry to simplify cache bounds checks
    this.bMarks.push(s.length);
    this.eMarks.push(s.length);
    this.tShift.push(0);
    this.sCount.push(0);
    this.bsCount.push(0);
    this.lineMax = this.bMarks.length - 1; // don't count last fake line
}
// Push new token to "stream".
//
$7fe334e6f0f34d45$var$StateBlock.prototype.push = function(type, tag, nesting) {
    var token = new $iLJ9G(type, tag, nesting);
    token.block = true;
    if (nesting < 0) this.level--; // closing tag
    token.level = this.level;
    if (nesting > 0) this.level++; // opening tag
    this.tokens.push(token);
    return token;
};
$7fe334e6f0f34d45$var$StateBlock.prototype.isEmpty = function isEmpty(line) {
    return this.bMarks[line] + this.tShift[line] >= this.eMarks[line];
};
$7fe334e6f0f34d45$var$StateBlock.prototype.skipEmptyLines = function skipEmptyLines(from) {
    for(var max = this.lineMax; from < max; from++){
        if (this.bMarks[from] + this.tShift[from] < this.eMarks[from]) break;
    }
    return from;
};
// Skip spaces from given position.
$7fe334e6f0f34d45$var$StateBlock.prototype.skipSpaces = function skipSpaces(pos) {
    var ch;
    for(var max = this.src.length; pos < max; pos++){
        ch = this.src.charCodeAt(pos);
        if (!$7fe334e6f0f34d45$require$isSpace(ch)) break;
    }
    return pos;
};
// Skip spaces from given position in reverse.
$7fe334e6f0f34d45$var$StateBlock.prototype.skipSpacesBack = function skipSpacesBack(pos, min) {
    if (pos <= min) return pos;
    while(pos > min){
        if (!$7fe334e6f0f34d45$require$isSpace(this.src.charCodeAt(--pos))) return pos + 1;
    }
    return pos;
};
// Skip char codes from given position
$7fe334e6f0f34d45$var$StateBlock.prototype.skipChars = function skipChars(pos, code) {
    for(var max = this.src.length; pos < max; pos++){
        if (this.src.charCodeAt(pos) !== code) break;
    }
    return pos;
};
// Skip char codes reverse from given position - 1
$7fe334e6f0f34d45$var$StateBlock.prototype.skipCharsBack = function skipCharsBack(pos, code, min) {
    if (pos <= min) return pos;
    while(pos > min){
        if (code !== this.src.charCodeAt(--pos)) return pos + 1;
    }
    return pos;
};
// cut lines range from source.
$7fe334e6f0f34d45$var$StateBlock.prototype.getLines = function getLines(begin, end, indent, keepLastLF) {
    var i, lineIndent, ch, first, last, queue, lineStart, line = begin;
    if (begin >= end) return "";
    queue = new Array(end - begin);
    for(i = 0; line < end; line++, i++){
        lineIndent = 0;
        lineStart = first = this.bMarks[line];
        if (line + 1 < end || keepLastLF) // No need for bounds check because we have fake entry on tail.
        last = this.eMarks[line] + 1;
        else last = this.eMarks[line];
        while(first < last && lineIndent < indent){
            ch = this.src.charCodeAt(first);
            if ($7fe334e6f0f34d45$require$isSpace(ch)) {
                if (ch === 0x09) lineIndent += 4 - (lineIndent + this.bsCount[line]) % 4;
                else lineIndent++;
            } else if (first - lineStart < this.tShift[line]) // patched tShift masked characters to look like spaces (blockquotes, list markers)
            lineIndent++;
            else break;
            first++;
        }
        if (lineIndent > indent) // partially expanding tabs in code blocks, e.g '\t\tfoobar'
        // with indent=2 becomes '  \tfoobar'
        queue[i] = new Array(lineIndent - indent + 1).join(" ") + this.src.slice(first, last);
        else queue[i] = this.src.slice(first, last);
    }
    return queue.join("");
};
// re-export Token class to use in block rules
$7fe334e6f0f34d45$var$StateBlock.prototype.Token = $iLJ9G;
module.exports = $7fe334e6f0f34d45$var$StateBlock;

});


parcelRequire.register("6JKNt", function(module, exports) {
/** internal
 * class ParserInline
 *
 * Tokenizes paragraph content.
 **/ "use strict";

var $jRUoy = parcelRequire("jRUoy");












////////////////////////////////////////////////////////////////////////////////
// Parser rules
var $4e7b3ef7c8aca764$var$_rules = [
    [
        "text",
        (parcelRequire("6BAq5"))
    ],
    [
        "linkify",
        (parcelRequire("6HVk6"))
    ],
    [
        "newline",
        (parcelRequire("5nnxz"))
    ],
    [
        "escape",
        (parcelRequire("hEHax"))
    ],
    [
        "backticks",
        (parcelRequire("eByYc"))
    ],
    [
        "strikethrough",
        (parcelRequire("anne2")).tokenize
    ],
    [
        "emphasis",
        (parcelRequire("4yOPi")).tokenize
    ],
    [
        "link",
        (parcelRequire("YCZRu"))
    ],
    [
        "image",
        (parcelRequire("kxcMA"))
    ],
    [
        "autolink",
        (parcelRequire("j6xaM"))
    ],
    [
        "html_inline",
        (parcelRequire("9yjtD"))
    ],
    [
        "entity",
        (parcelRequire("3FUUx"))
    ]
];




// `rule2` ruleset was created specifically for emphasis/strikethrough
// post-processing and may be changed in the future.
//
// Don't use this for anything except pairs (plugins working with `balance_pairs`).
//
var $4e7b3ef7c8aca764$var$_rules2 = [
    [
        "balance_pairs",
        (parcelRequire("duYxm"))
    ],
    [
        "strikethrough",
        (parcelRequire("anne2")).postProcess
    ],
    [
        "emphasis",
        (parcelRequire("4yOPi")).postProcess
    ],
    // rules for pairs separate '**' into its own text tokens, which may be left unused,
    // rule below merges unused segments back with the rest of the text
    [
        "fragments_join",
        (parcelRequire("lemiq"))
    ]
];
/**
 * new ParserInline()
 **/ function $4e7b3ef7c8aca764$var$ParserInline() {
    var i;
    /**
   * ParserInline#ruler -> Ruler
   *
   * [[Ruler]] instance. Keep configuration of inline rules.
   **/ this.ruler = new $jRUoy();
    for(i = 0; i < $4e7b3ef7c8aca764$var$_rules.length; i++)this.ruler.push($4e7b3ef7c8aca764$var$_rules[i][0], $4e7b3ef7c8aca764$var$_rules[i][1]);
    /**
   * ParserInline#ruler2 -> Ruler
   *
   * [[Ruler]] instance. Second ruler used for post-processing
   * (e.g. in emphasis-like rules).
   **/ this.ruler2 = new $jRUoy();
    for(i = 0; i < $4e7b3ef7c8aca764$var$_rules2.length; i++)this.ruler2.push($4e7b3ef7c8aca764$var$_rules2[i][0], $4e7b3ef7c8aca764$var$_rules2[i][1]);
}
// Skip single token by running all rules in validation mode;
// returns `true` if any rule reported success
//
$4e7b3ef7c8aca764$var$ParserInline.prototype.skipToken = function(state) {
    var ok, i, pos = state.pos, rules = this.ruler.getRules(""), len = rules.length, maxNesting = state.md.options.maxNesting, cache = state.cache;
    if (typeof cache[pos] !== "undefined") {
        state.pos = cache[pos];
        return;
    }
    if (state.level < maxNesting) for(i = 0; i < len; i++){
        // Increment state.level and decrement it later to limit recursion.
        // It's harmless to do here, because no tokens are created. But ideally,
        // we'd need a separate private state variable for this purpose.
        //
        state.level++;
        ok = rules[i](state, true);
        state.level--;
        if (ok) break;
    }
    else // Too much nesting, just skip until the end of the paragraph.
    //
    // NOTE: this will cause links to behave incorrectly in the following case,
    //       when an amount of `[` is exactly equal to `maxNesting + 1`:
    //
    //       [[[[[[[[[[[[[[[[[[[[[foo]()
    //
    // TODO: remove this workaround when CM standard will allow nested links
    //       (we can replace it by preventing links from being parsed in
    //       validation mode)
    //
    state.pos = state.posMax;
    if (!ok) state.pos++;
    cache[pos] = state.pos;
};
// Generate tokens for input range
//
$4e7b3ef7c8aca764$var$ParserInline.prototype.tokenize = function(state) {
    var ok, i, rules = this.ruler.getRules(""), len = rules.length, end = state.posMax, maxNesting = state.md.options.maxNesting;
    while(state.pos < end){
        // Try all possible rules.
        // On success, rule should:
        //
        // - update `state.pos`
        // - update `state.tokens`
        // - return true
        if (state.level < maxNesting) for(i = 0; i < len; i++){
            ok = rules[i](state, false);
            if (ok) break;
        }
        if (ok) {
            if (state.pos >= end) break;
            continue;
        }
        state.pending += state.src[state.pos++];
    }
    if (state.pending) state.pushPending();
};
/**
 * ParserInline.parse(str, md, env, outTokens)
 *
 * Process input string and push inline tokens into `outTokens`
 **/ $4e7b3ef7c8aca764$var$ParserInline.prototype.parse = function(str, md, env, outTokens) {
    var i, rules, len;
    var state = new this.State(str, md, env, outTokens);
    this.tokenize(state);
    rules = this.ruler2.getRules("");
    len = rules.length;
    for(i = 0; i < len; i++)rules[i](state);
};

$4e7b3ef7c8aca764$var$ParserInline.prototype.State = (parcelRequire("3XVIV"));
module.exports = $4e7b3ef7c8aca764$var$ParserInline;

});
parcelRequire.register("6BAq5", function(module, exports) {
// Skip text characters for text token, place those to pending buffer
// and increment current pos
"use strict";
// Rule to skip pure text
// '{}$%@~+=:' reserved for extentions
// !, ", #, $, %, &, ', (, ), *, +, ,, -, ., /, :, ;, <, =, >, ?, @, [, \, ], ^, _, `, {, |, }, or ~
// !!!! Don't confuse with "Markdown ASCII Punctuation" chars
// http://spec.commonmark.org/0.15/#ascii-punctuation-character
function $4cf2730201177402$var$isTerminatorChar(ch) {
    switch(ch){
        case 0x0A /* \n */ :
        case 0x21 /* ! */ :
        case 0x23 /* # */ :
        case 0x24 /* $ */ :
        case 0x25 /* % */ :
        case 0x26 /* & */ :
        case 0x2A /* * */ :
        case 0x2B /* + */ :
        case 0x2D /* - */ :
        case 0x3A /* : */ :
        case 0x3C /* < */ :
        case 0x3D /* = */ :
        case 0x3E /* > */ :
        case 0x40 /* @ */ :
        case 0x5B /* [ */ :
        case 0x5C /* \ */ :
        case 0x5D /* ] */ :
        case 0x5E /* ^ */ :
        case 0x5F /* _ */ :
        case 0x60 /* ` */ :
        case 0x7B /* { */ :
        case 0x7D /* } */ :
        case 0x7E /* ~ */ :
            return true;
        default:
            return false;
    }
}
module.exports = function text(state, silent) {
    var pos = state.pos;
    while(pos < state.posMax && !$4cf2730201177402$var$isTerminatorChar(state.src.charCodeAt(pos)))pos++;
    if (pos === state.pos) return false;
    if (!silent) state.pending += state.src.slice(state.pos, pos);
    state.pos = pos;
    return true;
}; // Alternative implementation, for memory.
 //
 // It costs 10% of performance, but allows extend terminators list, if place it
 // to `ParcerInline` property. Probably, will switch to it sometime, such
 // flexibility required.
 /*
var TERMINATOR_RE = /[\n!#$%&*+\-:<=>@[\\\]^_`{}~]/;

module.exports = function text(state, silent) {
  var pos = state.pos,
      idx = state.src.slice(pos).search(TERMINATOR_RE);

  // first char is terminator -> empty text
  if (idx === 0) { return false; }

  // no terminator -> text till end of string
  if (idx < 0) {
    if (!silent) { state.pending += state.src.slice(pos); }
    state.pos = state.src.length;
    return true;
  }

  if (!silent) { state.pending += state.src.slice(pos, pos + idx); }

  state.pos += idx;

  return true;
};*/ 

});

parcelRequire.register("6HVk6", function(module, exports) {
// Process links like https://example.org/
"use strict";
// RFC3986: scheme = ALPHA *( ALPHA / DIGIT / "+" / "-" / "." )
var $4e2339730b306051$var$SCHEME_RE = /(?:^|[^a-z0-9.+-])([a-z][a-z0-9.+-]*)$/i;
module.exports = function linkify(state, silent) {
    var pos, max, match, proto, link, url, fullUrl, token;
    if (!state.md.options.linkify) return false;
    if (state.linkLevel > 0) return false;
    pos = state.pos;
    max = state.posMax;
    if (pos + 3 > max) return false;
    if (state.src.charCodeAt(pos) !== 0x3A /* : */ ) return false;
    if (state.src.charCodeAt(pos + 1) !== 0x2F /* / */ ) return false;
    if (state.src.charCodeAt(pos + 2) !== 0x2F /* / */ ) return false;
    match = state.pending.match($4e2339730b306051$var$SCHEME_RE);
    if (!match) return false;
    proto = match[1];
    link = state.md.linkify.matchAtStart(state.src.slice(pos - proto.length));
    if (!link) return false;
    url = link.url;
    // disallow '*' at the end of the link (conflicts with emphasis)
    url = url.replace(/\*+$/, "");
    fullUrl = state.md.normalizeLink(url);
    if (!state.md.validateLink(fullUrl)) return false;
    if (!silent) {
        state.pending = state.pending.slice(0, -proto.length);
        token = state.push("link_open", "a", 1);
        token.attrs = [
            [
                "href",
                fullUrl
            ]
        ];
        token.markup = "linkify";
        token.info = "auto";
        token = state.push("text", "", 0);
        token.content = state.md.normalizeLinkText(url);
        token = state.push("link_close", "a", -1);
        token.markup = "linkify";
        token.info = "auto";
    }
    state.pos += url.length - proto.length;
    return true;
};

});

parcelRequire.register("5nnxz", function(module, exports) {
// Proceess '\n'
"use strict";

var $iE2q6 = parcelRequire("iE2q6");
var $3ea15c62ee948ed0$require$isSpace = $iE2q6.isSpace;
module.exports = function newline(state, silent) {
    var pmax, max, ws, pos = state.pos;
    if (state.src.charCodeAt(pos) !== 0x0A /* \n */ ) return false;
    pmax = state.pending.length - 1;
    max = state.posMax;
    // '  \n' -> hardbreak
    // Lookup in pending chars is bad practice! Don't copy to other rules!
    // Pending string is stored in concat mode, indexed lookups will cause
    // convertion to flat mode.
    if (!silent) {
        if (pmax >= 0 && state.pending.charCodeAt(pmax) === 0x20) {
            if (pmax >= 1 && state.pending.charCodeAt(pmax - 1) === 0x20) {
                // Find whitespaces tail of pending chars.
                ws = pmax - 1;
                while(ws >= 1 && state.pending.charCodeAt(ws - 1) === 0x20)ws--;
                state.pending = state.pending.slice(0, ws);
                state.push("hardbreak", "br", 0);
            } else {
                state.pending = state.pending.slice(0, -1);
                state.push("softbreak", "br", 0);
            }
        } else state.push("softbreak", "br", 0);
    }
    pos++;
    // skip heading spaces for next line
    while(pos < max && $3ea15c62ee948ed0$require$isSpace(state.src.charCodeAt(pos)))pos++;
    state.pos = pos;
    return true;
};

});

parcelRequire.register("hEHax", function(module, exports) {
// Process escaped chars and hardbreaks
"use strict";

var $iE2q6 = parcelRequire("iE2q6");
var $cda7a8941268bd0b$require$isSpace = $iE2q6.isSpace;
var $cda7a8941268bd0b$var$ESCAPED = [];
for(var $cda7a8941268bd0b$var$i = 0; $cda7a8941268bd0b$var$i < 256; $cda7a8941268bd0b$var$i++)$cda7a8941268bd0b$var$ESCAPED.push(0);
"\\!\"#$%&'()*+,./:;<=>?@[]^_`{|}~-".split("").forEach(function(ch) {
    $cda7a8941268bd0b$var$ESCAPED[ch.charCodeAt(0)] = 1;
});
module.exports = function escape(state, silent) {
    var ch1, ch2, origStr, escapedStr, token, pos = state.pos, max = state.posMax;
    if (state.src.charCodeAt(pos) !== 0x5C /* \ */ ) return false;
    pos++;
    // '\' at the end of the inline block
    if (pos >= max) return false;
    ch1 = state.src.charCodeAt(pos);
    if (ch1 === 0x0A) {
        if (!silent) state.push("hardbreak", "br", 0);
        pos++;
        // skip leading whitespaces from next line
        while(pos < max){
            ch1 = state.src.charCodeAt(pos);
            if (!$cda7a8941268bd0b$require$isSpace(ch1)) break;
            pos++;
        }
        state.pos = pos;
        return true;
    }
    escapedStr = state.src[pos];
    if (ch1 >= 0xD800 && ch1 <= 0xDBFF && pos + 1 < max) {
        ch2 = state.src.charCodeAt(pos + 1);
        if (ch2 >= 0xDC00 && ch2 <= 0xDFFF) {
            escapedStr += state.src[pos + 1];
            pos++;
        }
    }
    origStr = "\\" + escapedStr;
    if (!silent) {
        token = state.push("text_special", "", 0);
        if (ch1 < 256 && $cda7a8941268bd0b$var$ESCAPED[ch1] !== 0) token.content = escapedStr;
        else token.content = origStr;
        token.markup = origStr;
        token.info = "escape";
    }
    state.pos = pos + 1;
    return true;
};

});

parcelRequire.register("eByYc", function(module, exports) {
// Parse backticks
"use strict";
module.exports = function backtick(state, silent) {
    var start, max, marker, token, matchStart, matchEnd, openerLength, closerLength, pos = state.pos, ch = state.src.charCodeAt(pos);
    if (ch !== 0x60 /* ` */ ) return false;
    start = pos;
    pos++;
    max = state.posMax;
    // scan marker length
    while(pos < max && state.src.charCodeAt(pos) === 0x60 /* ` */ )pos++;
    marker = state.src.slice(start, pos);
    openerLength = marker.length;
    if (state.backticksScanned && (state.backticks[openerLength] || 0) <= start) {
        if (!silent) state.pending += marker;
        state.pos += openerLength;
        return true;
    }
    matchStart = matchEnd = pos;
    // Nothing found in the cache, scan until the end of the line (or until marker is found)
    while((matchStart = state.src.indexOf("`", matchEnd)) !== -1){
        matchEnd = matchStart + 1;
        // scan marker length
        while(matchEnd < max && state.src.charCodeAt(matchEnd) === 0x60 /* ` */ )matchEnd++;
        closerLength = matchEnd - matchStart;
        if (closerLength === openerLength) {
            // Found matching closer length.
            if (!silent) {
                token = state.push("code_inline", "code", 0);
                token.markup = marker;
                token.content = state.src.slice(pos, matchStart).replace(/\n/g, " ").replace(/^ (.+) $/, "$1");
            }
            state.pos = matchEnd;
            return true;
        }
        // Some different length found, put it in cache as upper limit of where closer can be found
        state.backticks[closerLength] = matchStart;
    }
    // Scanned through the end, didn't find anything
    state.backticksScanned = true;
    if (!silent) state.pending += marker;
    state.pos += openerLength;
    return true;
};

});

parcelRequire.register("anne2", function(module, exports) {

$parcel$export(module.exports, "tokenize", () => $78de1177a63ab506$export$660b2ee2d4fb4eff, (v) => $78de1177a63ab506$export$660b2ee2d4fb4eff = v);
$parcel$export(module.exports, "postProcess", () => $78de1177a63ab506$export$7b804a0e0ce836d9, (v) => $78de1177a63ab506$export$7b804a0e0ce836d9 = v);
// ~~strike through~~
//
// Insert each marker as a separate text token, and add it to delimiter list
//
var $78de1177a63ab506$export$660b2ee2d4fb4eff;
// Walk through delimiter list and replace text tokens with tags
//
var $78de1177a63ab506$export$7b804a0e0ce836d9;
"use strict";
$78de1177a63ab506$export$660b2ee2d4fb4eff = function strikethrough(state, silent) {
    var i, scanned, token, len, ch, start = state.pos, marker = state.src.charCodeAt(start);
    if (silent) return false;
    if (marker !== 0x7E /* ~ */ ) return false;
    scanned = state.scanDelims(state.pos, true);
    len = scanned.length;
    ch = String.fromCharCode(marker);
    if (len < 2) return false;
    if (len % 2) {
        token = state.push("text", "", 0);
        token.content = ch;
        len--;
    }
    for(i = 0; i < len; i += 2){
        token = state.push("text", "", 0);
        token.content = ch + ch;
        state.delimiters.push({
            marker: marker,
            length: 0,
            token: state.tokens.length - 1,
            end: -1,
            open: scanned.can_open,
            close: scanned.can_close
        });
    }
    state.pos += scanned.length;
    return true;
};
function $78de1177a63ab506$var$postProcess(state, delimiters) {
    var i, j, startDelim, endDelim, token, loneMarkers = [], max = delimiters.length;
    for(i = 0; i < max; i++){
        startDelim = delimiters[i];
        if (startDelim.marker !== 0x7E /* ~ */ ) continue;
        if (startDelim.end === -1) continue;
        endDelim = delimiters[startDelim.end];
        token = state.tokens[startDelim.token];
        token.type = "s_open";
        token.tag = "s";
        token.nesting = 1;
        token.markup = "~~";
        token.content = "";
        token = state.tokens[endDelim.token];
        token.type = "s_close";
        token.tag = "s";
        token.nesting = -1;
        token.markup = "~~";
        token.content = "";
        if (state.tokens[endDelim.token - 1].type === "text" && state.tokens[endDelim.token - 1].content === "~") loneMarkers.push(endDelim.token - 1);
    }
    // If a marker sequence has an odd number of characters, it's splitted
    // like this: `~~~~~` -> `~` + `~~` + `~~`, leaving one marker at the
    // start of the sequence.
    //
    // So, we have to move all those markers after subsequent s_close tags.
    //
    while(loneMarkers.length){
        i = loneMarkers.pop();
        j = i + 1;
        while(j < state.tokens.length && state.tokens[j].type === "s_close")j++;
        j--;
        if (i !== j) {
            token = state.tokens[j];
            state.tokens[j] = state.tokens[i];
            state.tokens[i] = token;
        }
    }
}
$78de1177a63ab506$export$7b804a0e0ce836d9 = function strikethrough(state) {
    var curr, tokens_meta = state.tokens_meta, max = state.tokens_meta.length;
    $78de1177a63ab506$var$postProcess(state, state.delimiters);
    for(curr = 0; curr < max; curr++)if (tokens_meta[curr] && tokens_meta[curr].delimiters) $78de1177a63ab506$var$postProcess(state, tokens_meta[curr].delimiters);
};

});

parcelRequire.register("4yOPi", function(module, exports) {

$parcel$export(module.exports, "tokenize", () => $3521c37a6ce59b55$export$660b2ee2d4fb4eff, (v) => $3521c37a6ce59b55$export$660b2ee2d4fb4eff = v);
$parcel$export(module.exports, "postProcess", () => $3521c37a6ce59b55$export$7b804a0e0ce836d9, (v) => $3521c37a6ce59b55$export$7b804a0e0ce836d9 = v);
// Process *this* and _that_
//
// Insert each marker as a separate text token, and add it to delimiter list
//
var $3521c37a6ce59b55$export$660b2ee2d4fb4eff;
// Walk through delimiter list and replace text tokens with tags
//
var $3521c37a6ce59b55$export$7b804a0e0ce836d9;
"use strict";
$3521c37a6ce59b55$export$660b2ee2d4fb4eff = function emphasis(state, silent) {
    var i, scanned, token, start = state.pos, marker = state.src.charCodeAt(start);
    if (silent) return false;
    if (marker !== 0x5F /* _ */  && marker !== 0x2A /* * */ ) return false;
    scanned = state.scanDelims(state.pos, marker === 0x2A);
    for(i = 0; i < scanned.length; i++){
        token = state.push("text", "", 0);
        token.content = String.fromCharCode(marker);
        state.delimiters.push({
            // Char code of the starting marker (number).
            //
            marker: marker,
            // Total length of these series of delimiters.
            //
            length: scanned.length,
            // A position of the token this delimiter corresponds to.
            //
            token: state.tokens.length - 1,
            // If this delimiter is matched as a valid opener, `end` will be
            // equal to its position, otherwise it's `-1`.
            //
            end: -1,
            // Boolean flags that determine if this delimiter could open or close
            // an emphasis.
            //
            open: scanned.can_open,
            close: scanned.can_close
        });
    }
    state.pos += scanned.length;
    return true;
};
function $3521c37a6ce59b55$var$postProcess(state, delimiters) {
    var i, startDelim, endDelim, token, ch, isStrong, max = delimiters.length;
    for(i = max - 1; i >= 0; i--){
        startDelim = delimiters[i];
        if (startDelim.marker !== 0x5F /* _ */  && startDelim.marker !== 0x2A /* * */ ) continue;
        // Process only opening markers
        if (startDelim.end === -1) continue;
        endDelim = delimiters[startDelim.end];
        // If the previous delimiter has the same marker and is adjacent to this one,
        // merge those into one strong delimiter.
        //
        // `<em><em>whatever</em></em>` -> `<strong>whatever</strong>`
        //
        isStrong = i > 0 && delimiters[i - 1].end === startDelim.end + 1 && // check that first two markers match and adjacent
        delimiters[i - 1].marker === startDelim.marker && delimiters[i - 1].token === startDelim.token - 1 && // check that last two markers are adjacent (we can safely assume they match)
        delimiters[startDelim.end + 1].token === endDelim.token + 1;
        ch = String.fromCharCode(startDelim.marker);
        token = state.tokens[startDelim.token];
        token.type = isStrong ? "strong_open" : "em_open";
        token.tag = isStrong ? "strong" : "em";
        token.nesting = 1;
        token.markup = isStrong ? ch + ch : ch;
        token.content = "";
        token = state.tokens[endDelim.token];
        token.type = isStrong ? "strong_close" : "em_close";
        token.tag = isStrong ? "strong" : "em";
        token.nesting = -1;
        token.markup = isStrong ? ch + ch : ch;
        token.content = "";
        if (isStrong) {
            state.tokens[delimiters[i - 1].token].content = "";
            state.tokens[delimiters[startDelim.end + 1].token].content = "";
            i--;
        }
    }
}
$3521c37a6ce59b55$export$7b804a0e0ce836d9 = function emphasis(state) {
    var curr, tokens_meta = state.tokens_meta, max = state.tokens_meta.length;
    $3521c37a6ce59b55$var$postProcess(state, state.delimiters);
    for(curr = 0; curr < max; curr++)if (tokens_meta[curr] && tokens_meta[curr].delimiters) $3521c37a6ce59b55$var$postProcess(state, tokens_meta[curr].delimiters);
};

});

parcelRequire.register("YCZRu", function(module, exports) {
// Process [link](<to> "stuff")
"use strict";

var $iE2q6 = parcelRequire("iE2q6");
var $0b63daa84b47245f$require$normalizeReference = $iE2q6.normalizeReference;

var $iE2q6 = parcelRequire("iE2q6");
var $0b63daa84b47245f$require$isSpace = $iE2q6.isSpace;
module.exports = function link(state, silent) {
    var attrs, code, label, labelEnd, labelStart, pos, res, ref, token, href = "", title = "", oldPos = state.pos, max = state.posMax, start = state.pos, parseReference = true;
    if (state.src.charCodeAt(state.pos) !== 0x5B /* [ */ ) return false;
    labelStart = state.pos + 1;
    labelEnd = state.md.helpers.parseLinkLabel(state, state.pos, true);
    // parser failed to find ']', so it's not a valid link
    if (labelEnd < 0) return false;
    pos = labelEnd + 1;
    if (pos < max && state.src.charCodeAt(pos) === 0x28 /* ( */ ) {
        //
        // Inline link
        //
        // might have found a valid shortcut link, disable reference parsing
        parseReference = false;
        // [link](  <href>  "title"  )
        //        ^^ skipping these spaces
        pos++;
        for(; pos < max; pos++){
            code = state.src.charCodeAt(pos);
            if (!$0b63daa84b47245f$require$isSpace(code) && code !== 0x0A) break;
        }
        if (pos >= max) return false;
        // [link](  <href>  "title"  )
        //          ^^^^^^ parsing link destination
        start = pos;
        res = state.md.helpers.parseLinkDestination(state.src, pos, state.posMax);
        if (res.ok) {
            href = state.md.normalizeLink(res.str);
            if (state.md.validateLink(href)) pos = res.pos;
            else href = "";
            // [link](  <href>  "title"  )
            //                ^^ skipping these spaces
            start = pos;
            for(; pos < max; pos++){
                code = state.src.charCodeAt(pos);
                if (!$0b63daa84b47245f$require$isSpace(code) && code !== 0x0A) break;
            }
            // [link](  <href>  "title"  )
            //                  ^^^^^^^ parsing link title
            res = state.md.helpers.parseLinkTitle(state.src, pos, state.posMax);
            if (pos < max && start !== pos && res.ok) {
                title = res.str;
                pos = res.pos;
                // [link](  <href>  "title"  )
                //                         ^^ skipping these spaces
                for(; pos < max; pos++){
                    code = state.src.charCodeAt(pos);
                    if (!$0b63daa84b47245f$require$isSpace(code) && code !== 0x0A) break;
                }
            }
        }
        if (pos >= max || state.src.charCodeAt(pos) !== 0x29 /* ) */ ) // parsing a valid shortcut link failed, fallback to reference
        parseReference = true;
        pos++;
    }
    if (parseReference) {
        //
        // Link reference
        //
        if (typeof state.env.references === "undefined") return false;
        if (pos < max && state.src.charCodeAt(pos) === 0x5B /* [ */ ) {
            start = pos + 1;
            pos = state.md.helpers.parseLinkLabel(state, pos);
            if (pos >= 0) label = state.src.slice(start, pos++);
            else pos = labelEnd + 1;
        } else pos = labelEnd + 1;
        // covers label === '' and label === undefined
        // (collapsed reference link and shortcut reference link respectively)
        if (!label) label = state.src.slice(labelStart, labelEnd);
        ref = state.env.references[$0b63daa84b47245f$require$normalizeReference(label)];
        if (!ref) {
            state.pos = oldPos;
            return false;
        }
        href = ref.href;
        title = ref.title;
    }
    //
    // We found the end of the link, and know for a fact it's a valid link;
    // so all that's left to do is to call tokenizer.
    //
    if (!silent) {
        state.pos = labelStart;
        state.posMax = labelEnd;
        token = state.push("link_open", "a", 1);
        token.attrs = attrs = [
            [
                "href",
                href
            ]
        ];
        if (title) attrs.push([
            "title",
            title
        ]);
        state.linkLevel++;
        state.md.inline.tokenize(state);
        state.linkLevel--;
        token = state.push("link_close", "a", -1);
    }
    state.pos = pos;
    state.posMax = max;
    return true;
};

});

parcelRequire.register("kxcMA", function(module, exports) {
// Process ![image](<src> "title")
"use strict";

var $iE2q6 = parcelRequire("iE2q6");
var $ef30ce1bf90a0945$require$normalizeReference = $iE2q6.normalizeReference;

var $iE2q6 = parcelRequire("iE2q6");
var $ef30ce1bf90a0945$require$isSpace = $iE2q6.isSpace;
module.exports = function image(state, silent) {
    var attrs, code, content, label, labelEnd, labelStart, pos, ref, res, title, token, tokens, start, href = "", oldPos = state.pos, max = state.posMax;
    if (state.src.charCodeAt(state.pos) !== 0x21 /* ! */ ) return false;
    if (state.src.charCodeAt(state.pos + 1) !== 0x5B /* [ */ ) return false;
    labelStart = state.pos + 2;
    labelEnd = state.md.helpers.parseLinkLabel(state, state.pos + 1, false);
    // parser failed to find ']', so it's not a valid link
    if (labelEnd < 0) return false;
    pos = labelEnd + 1;
    if (pos < max && state.src.charCodeAt(pos) === 0x28 /* ( */ ) {
        //
        // Inline link
        //
        // [link](  <href>  "title"  )
        //        ^^ skipping these spaces
        pos++;
        for(; pos < max; pos++){
            code = state.src.charCodeAt(pos);
            if (!$ef30ce1bf90a0945$require$isSpace(code) && code !== 0x0A) break;
        }
        if (pos >= max) return false;
        // [link](  <href>  "title"  )
        //          ^^^^^^ parsing link destination
        start = pos;
        res = state.md.helpers.parseLinkDestination(state.src, pos, state.posMax);
        if (res.ok) {
            href = state.md.normalizeLink(res.str);
            if (state.md.validateLink(href)) pos = res.pos;
            else href = "";
        }
        // [link](  <href>  "title"  )
        //                ^^ skipping these spaces
        start = pos;
        for(; pos < max; pos++){
            code = state.src.charCodeAt(pos);
            if (!$ef30ce1bf90a0945$require$isSpace(code) && code !== 0x0A) break;
        }
        // [link](  <href>  "title"  )
        //                  ^^^^^^^ parsing link title
        res = state.md.helpers.parseLinkTitle(state.src, pos, state.posMax);
        if (pos < max && start !== pos && res.ok) {
            title = res.str;
            pos = res.pos;
            // [link](  <href>  "title"  )
            //                         ^^ skipping these spaces
            for(; pos < max; pos++){
                code = state.src.charCodeAt(pos);
                if (!$ef30ce1bf90a0945$require$isSpace(code) && code !== 0x0A) break;
            }
        } else title = "";
        if (pos >= max || state.src.charCodeAt(pos) !== 0x29 /* ) */ ) {
            state.pos = oldPos;
            return false;
        }
        pos++;
    } else {
        //
        // Link reference
        //
        if (typeof state.env.references === "undefined") return false;
        if (pos < max && state.src.charCodeAt(pos) === 0x5B /* [ */ ) {
            start = pos + 1;
            pos = state.md.helpers.parseLinkLabel(state, pos);
            if (pos >= 0) label = state.src.slice(start, pos++);
            else pos = labelEnd + 1;
        } else pos = labelEnd + 1;
        // covers label === '' and label === undefined
        // (collapsed reference link and shortcut reference link respectively)
        if (!label) label = state.src.slice(labelStart, labelEnd);
        ref = state.env.references[$ef30ce1bf90a0945$require$normalizeReference(label)];
        if (!ref) {
            state.pos = oldPos;
            return false;
        }
        href = ref.href;
        title = ref.title;
    }
    //
    // We found the end of the link, and know for a fact it's a valid link;
    // so all that's left to do is to call tokenizer.
    //
    if (!silent) {
        content = state.src.slice(labelStart, labelEnd);
        state.md.inline.parse(content, state.md, state.env, tokens = []);
        token = state.push("image", "img", 0);
        token.attrs = attrs = [
            [
                "src",
                href
            ],
            [
                "alt",
                ""
            ]
        ];
        token.children = tokens;
        token.content = content;
        if (title) attrs.push([
            "title",
            title
        ]);
    }
    state.pos = pos;
    state.posMax = max;
    return true;
};

});

parcelRequire.register("j6xaM", function(module, exports) {
// Process autolinks '<protocol:...>'
"use strict";
/*eslint max-len:0*/ var $de884f538a137544$var$EMAIL_RE = /^([a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*)$/;
var $de884f538a137544$var$AUTOLINK_RE = /^([a-zA-Z][a-zA-Z0-9+.\-]{1,31}):([^<>\x00-\x20]*)$/;
module.exports = function autolink(state, silent) {
    var url, fullUrl, token, ch, start, max, pos = state.pos;
    if (state.src.charCodeAt(pos) !== 0x3C /* < */ ) return false;
    start = state.pos;
    max = state.posMax;
    for(;;){
        if (++pos >= max) return false;
        ch = state.src.charCodeAt(pos);
        if (ch === 0x3C /* < */ ) return false;
        if (ch === 0x3E /* > */ ) break;
    }
    url = state.src.slice(start + 1, pos);
    if ($de884f538a137544$var$AUTOLINK_RE.test(url)) {
        fullUrl = state.md.normalizeLink(url);
        if (!state.md.validateLink(fullUrl)) return false;
        if (!silent) {
            token = state.push("link_open", "a", 1);
            token.attrs = [
                [
                    "href",
                    fullUrl
                ]
            ];
            token.markup = "autolink";
            token.info = "auto";
            token = state.push("text", "", 0);
            token.content = state.md.normalizeLinkText(url);
            token = state.push("link_close", "a", -1);
            token.markup = "autolink";
            token.info = "auto";
        }
        state.pos += url.length + 2;
        return true;
    }
    if ($de884f538a137544$var$EMAIL_RE.test(url)) {
        fullUrl = state.md.normalizeLink("mailto:" + url);
        if (!state.md.validateLink(fullUrl)) return false;
        if (!silent) {
            token = state.push("link_open", "a", 1);
            token.attrs = [
                [
                    "href",
                    fullUrl
                ]
            ];
            token.markup = "autolink";
            token.info = "auto";
            token = state.push("text", "", 0);
            token.content = state.md.normalizeLinkText(url);
            token = state.push("link_close", "a", -1);
            token.markup = "autolink";
            token.info = "auto";
        }
        state.pos += url.length + 2;
        return true;
    }
    return false;
};

});

parcelRequire.register("9yjtD", function(module, exports) {
// Process html tags
"use strict";

var $6cXnH = parcelRequire("6cXnH");
var $6f4665be1b75b223$require$HTML_TAG_RE = $6cXnH.HTML_TAG_RE;
function $6f4665be1b75b223$var$isLinkOpen(str) {
    return /^<a[>\s]/i.test(str);
}
function $6f4665be1b75b223$var$isLinkClose(str) {
    return /^<\/a\s*>/i.test(str);
}
function $6f4665be1b75b223$var$isLetter(ch) {
    /*eslint no-bitwise:0*/ var lc = ch | 0x20; // to lower case
    return lc >= 0x61 /* a */  && lc <= 0x7a /* z */ ;
}
module.exports = function html_inline(state, silent) {
    var ch, match, max, token, pos = state.pos;
    if (!state.md.options.html) return false;
    // Check start
    max = state.posMax;
    if (state.src.charCodeAt(pos) !== 0x3C /* < */  || pos + 2 >= max) return false;
    // Quick fail on second char
    ch = state.src.charCodeAt(pos + 1);
    if (ch !== 0x21 /* ! */  && ch !== 0x3F /* ? */  && ch !== 0x2F /* / */  && !$6f4665be1b75b223$var$isLetter(ch)) return false;
    match = state.src.slice(pos).match($6f4665be1b75b223$require$HTML_TAG_RE);
    if (!match) return false;
    if (!silent) {
        token = state.push("html_inline", "", 0);
        token.content = state.src.slice(pos, pos + match[0].length);
        if ($6f4665be1b75b223$var$isLinkOpen(token.content)) state.linkLevel++;
        if ($6f4665be1b75b223$var$isLinkClose(token.content)) state.linkLevel--;
    }
    state.pos += match[0].length;
    return true;
};

});

parcelRequire.register("3FUUx", function(module, exports) {
// Process html entity - &#123;, &#xAF;, &quot;, ...
"use strict";

var $1WpyR = parcelRequire("1WpyR");

var $iE2q6 = parcelRequire("iE2q6");
var $2ad158bd1e7ac904$require$has = $iE2q6.has;

var $iE2q6 = parcelRequire("iE2q6");
var $2ad158bd1e7ac904$require$isValidEntityCode = $iE2q6.isValidEntityCode;

var $iE2q6 = parcelRequire("iE2q6");
var $2ad158bd1e7ac904$require$fromCodePoint = $iE2q6.fromCodePoint;
var $2ad158bd1e7ac904$var$DIGITAL_RE = /^&#((?:x[a-f0-9]{1,6}|[0-9]{1,7}));/i;
var $2ad158bd1e7ac904$var$NAMED_RE = /^&([a-z][a-z0-9]{1,31});/i;
module.exports = function entity(state, silent) {
    var ch, code, match, token, pos = state.pos, max = state.posMax;
    if (state.src.charCodeAt(pos) !== 0x26 /* & */ ) return false;
    if (pos + 1 >= max) return false;
    ch = state.src.charCodeAt(pos + 1);
    if (ch === 0x23 /* # */ ) {
        match = state.src.slice(pos).match($2ad158bd1e7ac904$var$DIGITAL_RE);
        if (match) {
            if (!silent) {
                code = match[1][0].toLowerCase() === "x" ? parseInt(match[1].slice(1), 16) : parseInt(match[1], 10);
                token = state.push("text_special", "", 0);
                token.content = $2ad158bd1e7ac904$require$isValidEntityCode(code) ? $2ad158bd1e7ac904$require$fromCodePoint(code) : $2ad158bd1e7ac904$require$fromCodePoint(0xFFFD);
                token.markup = match[0];
                token.info = "entity";
            }
            state.pos += match[0].length;
            return true;
        }
    } else {
        match = state.src.slice(pos).match($2ad158bd1e7ac904$var$NAMED_RE);
        if (match) {
            if ($2ad158bd1e7ac904$require$has($1WpyR, match[1])) {
                if (!silent) {
                    token = state.push("text_special", "", 0);
                    token.content = $1WpyR[match[1]];
                    token.markup = match[0];
                    token.info = "entity";
                }
                state.pos += match[0].length;
                return true;
            }
        }
    }
    return false;
};

});

parcelRequire.register("duYxm", function(module, exports) {
// For each opening emphasis-like marker find a matching closing one
//
"use strict";
function $9d3d091a46d9d4b2$var$processDelimiters(state, delimiters) {
    var closerIdx, openerIdx, closer, opener, minOpenerIdx, newMinOpenerIdx, isOddMatch, lastJump, openersBottom = {}, max = delimiters.length;
    if (!max) return;
    // headerIdx is the first delimiter of the current (where closer is) delimiter run
    var headerIdx = 0;
    var lastTokenIdx = -2; // needs any value lower than -1
    var jumps = [];
    for(closerIdx = 0; closerIdx < max; closerIdx++){
        closer = delimiters[closerIdx];
        jumps.push(0);
        // markers belong to same delimiter run if:
        //  - they have adjacent tokens
        //  - AND markers are the same
        //
        if (delimiters[headerIdx].marker !== closer.marker || lastTokenIdx !== closer.token - 1) headerIdx = closerIdx;
        lastTokenIdx = closer.token;
        // Length is only used for emphasis-specific "rule of 3",
        // if it's not defined (in strikethrough or 3rd party plugins),
        // we can default it to 0 to disable those checks.
        //
        closer.length = closer.length || 0;
        if (!closer.close) continue;
        // Previously calculated lower bounds (previous fails)
        // for each marker, each delimiter length modulo 3,
        // and for whether this closer can be an opener;
        // https://github.com/commonmark/cmark/commit/34250e12ccebdc6372b8b49c44fab57c72443460
        if (!openersBottom.hasOwnProperty(closer.marker)) openersBottom[closer.marker] = [
            -1,
            -1,
            -1,
            -1,
            -1,
            -1
        ];
        minOpenerIdx = openersBottom[closer.marker][(closer.open ? 3 : 0) + closer.length % 3];
        openerIdx = headerIdx - jumps[headerIdx] - 1;
        newMinOpenerIdx = openerIdx;
        for(; openerIdx > minOpenerIdx; openerIdx -= jumps[openerIdx] + 1){
            opener = delimiters[openerIdx];
            if (opener.marker !== closer.marker) continue;
            if (opener.open && opener.end < 0) {
                isOddMatch = false;
                // from spec:
                //
                // If one of the delimiters can both open and close emphasis, then the
                // sum of the lengths of the delimiter runs containing the opening and
                // closing delimiters must not be a multiple of 3 unless both lengths
                // are multiples of 3.
                //
                if (opener.close || closer.open) {
                    if ((opener.length + closer.length) % 3 === 0) {
                        if (opener.length % 3 !== 0 || closer.length % 3 !== 0) isOddMatch = true;
                    }
                }
                if (!isOddMatch) {
                    // If previous delimiter cannot be an opener, we can safely skip
                    // the entire sequence in future checks. This is required to make
                    // sure algorithm has linear complexity (see *_*_*_*_*_... case).
                    //
                    lastJump = openerIdx > 0 && !delimiters[openerIdx - 1].open ? jumps[openerIdx - 1] + 1 : 0;
                    jumps[closerIdx] = closerIdx - openerIdx + lastJump;
                    jumps[openerIdx] = lastJump;
                    closer.open = false;
                    opener.end = closerIdx;
                    opener.close = false;
                    newMinOpenerIdx = -1;
                    // treat next token as start of run,
                    // it optimizes skips in **<...>**a**<...>** pathological case
                    lastTokenIdx = -2;
                    break;
                }
            }
        }
        if (newMinOpenerIdx !== -1) // If match for this delimiter run failed, we want to set lower bound for
        // future lookups. This is required to make sure algorithm has linear
        // complexity.
        //
        // See details here:
        // https://github.com/commonmark/cmark/issues/178#issuecomment-270417442
        //
        openersBottom[closer.marker][(closer.open ? 3 : 0) + (closer.length || 0) % 3] = newMinOpenerIdx;
    }
}
module.exports = function link_pairs(state) {
    var curr, tokens_meta = state.tokens_meta, max = state.tokens_meta.length;
    $9d3d091a46d9d4b2$var$processDelimiters(state, state.delimiters);
    for(curr = 0; curr < max; curr++)if (tokens_meta[curr] && tokens_meta[curr].delimiters) $9d3d091a46d9d4b2$var$processDelimiters(state, tokens_meta[curr].delimiters);
};

});

parcelRequire.register("lemiq", function(module, exports) {
// Clean up tokens after emphasis and strikethrough postprocessing:
// merge adjacent text nodes into one and re-calculate all token levels
//
// This is necessary because initially emphasis delimiter markers (*, _, ~)
// are treated as their own separate text tokens. Then emphasis rule either
// leaves them as text (needed to merge with adjacent text) or turns them
// into opening/closing tags (which messes up levels inside).
//
"use strict";
module.exports = function fragments_join(state) {
    var curr, last, level = 0, tokens = state.tokens, max = state.tokens.length;
    for(curr = last = 0; curr < max; curr++){
        // re-calculate levels after emphasis/strikethrough turns some text nodes
        // into opening/closing tags
        if (tokens[curr].nesting < 0) level--; // closing tag
        tokens[curr].level = level;
        if (tokens[curr].nesting > 0) level++; // opening tag
        if (tokens[curr].type === "text" && curr + 1 < max && tokens[curr + 1].type === "text") // collapse two adjacent text nodes
        tokens[curr + 1].content = tokens[curr].content + tokens[curr + 1].content;
        else {
            if (curr !== last) tokens[last] = tokens[curr];
            last++;
        }
    }
    if (curr !== last) tokens.length = last;
};

});

parcelRequire.register("3XVIV", function(module, exports) {
// Inline parser state
"use strict";

var $iLJ9G = parcelRequire("iLJ9G");

var $iE2q6 = parcelRequire("iE2q6");
var $2e33a87fb6f765b8$require$isWhiteSpace = $iE2q6.isWhiteSpace;

var $iE2q6 = parcelRequire("iE2q6");
var $2e33a87fb6f765b8$require$isPunctChar = $iE2q6.isPunctChar;

var $iE2q6 = parcelRequire("iE2q6");
var $2e33a87fb6f765b8$require$isMdAsciiPunct = $iE2q6.isMdAsciiPunct;
function $2e33a87fb6f765b8$var$StateInline(src, md, env, outTokens) {
    this.src = src;
    this.env = env;
    this.md = md;
    this.tokens = outTokens;
    this.tokens_meta = Array(outTokens.length);
    this.pos = 0;
    this.posMax = this.src.length;
    this.level = 0;
    this.pending = "";
    this.pendingLevel = 0;
    // Stores { start: end } pairs. Useful for backtrack
    // optimization of pairs parse (emphasis, strikes).
    this.cache = {};
    // List of emphasis-like delimiters for current tag
    this.delimiters = [];
    // Stack of delimiter lists for upper level tags
    this._prev_delimiters = [];
    // backtick length => last seen position
    this.backticks = {};
    this.backticksScanned = false;
    // Counter used to disable inline linkify-it execution
    // inside <a> and markdown links
    this.linkLevel = 0;
}
// Flush pending text
//
$2e33a87fb6f765b8$var$StateInline.prototype.pushPending = function() {
    var token = new $iLJ9G("text", "", 0);
    token.content = this.pending;
    token.level = this.pendingLevel;
    this.tokens.push(token);
    this.pending = "";
    return token;
};
// Push new token to "stream".
// If pending text exists - flush it as text token
//
$2e33a87fb6f765b8$var$StateInline.prototype.push = function(type, tag, nesting) {
    if (this.pending) this.pushPending();
    var token = new $iLJ9G(type, tag, nesting);
    var token_meta = null;
    if (nesting < 0) {
        // closing tag
        this.level--;
        this.delimiters = this._prev_delimiters.pop();
    }
    token.level = this.level;
    if (nesting > 0) {
        // opening tag
        this.level++;
        this._prev_delimiters.push(this.delimiters);
        this.delimiters = [];
        token_meta = {
            delimiters: this.delimiters
        };
    }
    this.pendingLevel = this.level;
    this.tokens.push(token);
    this.tokens_meta.push(token_meta);
    return token;
};
// Scan a sequence of emphasis-like markers, and determine whether
// it can start an emphasis sequence or end an emphasis sequence.
//
//  - start - position to scan from (it should point at a valid marker);
//  - canSplitWord - determine if these markers can be found inside a word
//
$2e33a87fb6f765b8$var$StateInline.prototype.scanDelims = function(start, canSplitWord) {
    var pos = start, lastChar, nextChar, count, can_open, can_close, isLastWhiteSpace, isLastPunctChar, isNextWhiteSpace, isNextPunctChar, left_flanking = true, right_flanking = true, max = this.posMax, marker = this.src.charCodeAt(start);
    // treat beginning of the line as a whitespace
    lastChar = start > 0 ? this.src.charCodeAt(start - 1) : 0x20;
    while(pos < max && this.src.charCodeAt(pos) === marker)pos++;
    count = pos - start;
    // treat end of the line as a whitespace
    nextChar = pos < max ? this.src.charCodeAt(pos) : 0x20;
    isLastPunctChar = $2e33a87fb6f765b8$require$isMdAsciiPunct(lastChar) || $2e33a87fb6f765b8$require$isPunctChar(String.fromCharCode(lastChar));
    isNextPunctChar = $2e33a87fb6f765b8$require$isMdAsciiPunct(nextChar) || $2e33a87fb6f765b8$require$isPunctChar(String.fromCharCode(nextChar));
    isLastWhiteSpace = $2e33a87fb6f765b8$require$isWhiteSpace(lastChar);
    isNextWhiteSpace = $2e33a87fb6f765b8$require$isWhiteSpace(nextChar);
    if (isNextWhiteSpace) left_flanking = false;
    else if (isNextPunctChar) {
        if (!(isLastWhiteSpace || isLastPunctChar)) left_flanking = false;
    }
    if (isLastWhiteSpace) right_flanking = false;
    else if (isLastPunctChar) {
        if (!(isNextWhiteSpace || isNextPunctChar)) right_flanking = false;
    }
    if (!canSplitWord) {
        can_open = left_flanking && (!right_flanking || isLastPunctChar);
        can_close = right_flanking && (!left_flanking || isNextPunctChar);
    } else {
        can_open = left_flanking;
        can_close = right_flanking;
    }
    return {
        can_open: can_open,
        can_close: can_close,
        length: count
    };
};
// re-export Token class to use in block rules
$2e33a87fb6f765b8$var$StateInline.prototype.Token = $iLJ9G;
module.exports = $2e33a87fb6f765b8$var$StateInline;

});


parcelRequire.register("8wtzx", function(module, exports) {
"use strict";
////////////////////////////////////////////////////////////////////////////////
// Helpers
// Merge objects
//
function $634840520ea3d55d$var$assign(obj /*from1, from2, from3, ...*/ ) {
    var sources = Array.prototype.slice.call(arguments, 1);
    sources.forEach(function(source) {
        if (!source) return;
        Object.keys(source).forEach(function(key) {
            obj[key] = source[key];
        });
    });
    return obj;
}
function $634840520ea3d55d$var$_class(obj) {
    return Object.prototype.toString.call(obj);
}
function $634840520ea3d55d$var$isString(obj) {
    return $634840520ea3d55d$var$_class(obj) === "[object String]";
}
function $634840520ea3d55d$var$isObject(obj) {
    return $634840520ea3d55d$var$_class(obj) === "[object Object]";
}
function $634840520ea3d55d$var$isRegExp(obj) {
    return $634840520ea3d55d$var$_class(obj) === "[object RegExp]";
}
function $634840520ea3d55d$var$isFunction(obj) {
    return $634840520ea3d55d$var$_class(obj) === "[object Function]";
}
function $634840520ea3d55d$var$escapeRE(str) {
    return str.replace(/[.?*+^$[\]\\(){}|-]/g, "\\$&");
}
////////////////////////////////////////////////////////////////////////////////
var $634840520ea3d55d$var$defaultOptions = {
    fuzzyLink: true,
    fuzzyEmail: true,
    fuzzyIP: false
};
function $634840520ea3d55d$var$isOptionsObj(obj) {
    return Object.keys(obj || {}).reduce(function(acc, k) {
        return acc || $634840520ea3d55d$var$defaultOptions.hasOwnProperty(k);
    }, false);
}
var $634840520ea3d55d$var$defaultSchemas = {
    "http:": {
        validate: function(text, pos, self) {
            var tail = text.slice(pos);
            if (!self.re.http) // compile lazily, because "host"-containing variables can change on tlds update.
            self.re.http = new RegExp("^\\/\\/" + self.re.src_auth + self.re.src_host_port_strict + self.re.src_path, "i");
            if (self.re.http.test(tail)) return tail.match(self.re.http)[0].length;
            return 0;
        }
    },
    "https:": "http:",
    "ftp:": "http:",
    "//": {
        validate: function(text, pos, self) {
            var tail = text.slice(pos);
            if (!self.re.no_http) // compile lazily, because "host"-containing variables can change on tlds update.
            self.re.no_http = new RegExp("^" + self.re.src_auth + // Don't allow single-level domains, because of false positives like '//test'
            // with code comments
            "(?:localhost|(?:(?:" + self.re.src_domain + ")\\.)+" + self.re.src_domain_root + ")" + self.re.src_port + self.re.src_host_terminator + self.re.src_path, "i");
            if (self.re.no_http.test(tail)) {
                // should not be `://` & `///`, that protects from errors in protocol name
                if (pos >= 3 && text[pos - 3] === ":") return 0;
                if (pos >= 3 && text[pos - 3] === "/") return 0;
                return tail.match(self.re.no_http)[0].length;
            }
            return 0;
        }
    },
    "mailto:": {
        validate: function(text, pos, self) {
            var tail = text.slice(pos);
            if (!self.re.mailto) self.re.mailto = new RegExp("^" + self.re.src_email_name + "@" + self.re.src_host_strict, "i");
            if (self.re.mailto.test(tail)) return tail.match(self.re.mailto)[0].length;
            return 0;
        }
    }
};
/*eslint-disable max-len*/ // RE pattern for 2-character tlds (autogenerated by ./support/tlds_2char_gen.js)
var $634840520ea3d55d$var$tlds_2ch_src_re = "a[cdefgilmnoqrstuwxz]|b[abdefghijmnorstvwyz]|c[acdfghiklmnoruvwxyz]|d[ejkmoz]|e[cegrstu]|f[ijkmor]|g[abdefghilmnpqrstuwy]|h[kmnrtu]|i[delmnoqrst]|j[emop]|k[eghimnprwyz]|l[abcikrstuvy]|m[acdeghklmnopqrstuvwxyz]|n[acefgilopruz]|om|p[aefghklmnrstwy]|qa|r[eosuw]|s[abcdeghijklmnortuvxyz]|t[cdfghjklmnortvwz]|u[agksyz]|v[aceginu]|w[fs]|y[et]|z[amw]";
// DON'T try to make PRs with changes. Extend TLDs with LinkifyIt.tlds() instead
var $634840520ea3d55d$var$tlds_default = "biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|рф".split("|");
/*eslint-enable max-len*/ ////////////////////////////////////////////////////////////////////////////////
function $634840520ea3d55d$var$resetScanCache(self) {
    self.__index__ = -1;
    self.__text_cache__ = "";
}
function $634840520ea3d55d$var$createValidator(re) {
    return function(text, pos) {
        var tail = text.slice(pos);
        if (re.test(tail)) return tail.match(re)[0].length;
        return 0;
    };
}
function $634840520ea3d55d$var$createNormalizer() {
    return function(match, self) {
        self.normalize(match);
    };
}

// Schemas compiler. Build regexps.
//
function $634840520ea3d55d$var$compile(self) {
    // Load & clone RE patterns.
    var re = self.re = (parcelRequire("lIrnr"))(self.__opts__);
    // Define dynamic patterns
    var tlds = self.__tlds__.slice();
    self.onCompile();
    if (!self.__tlds_replaced__) tlds.push($634840520ea3d55d$var$tlds_2ch_src_re);
    tlds.push(re.src_xn);
    re.src_tlds = tlds.join("|");
    function untpl(tpl) {
        return tpl.replace("%TLDS%", re.src_tlds);
    }
    re.email_fuzzy = RegExp(untpl(re.tpl_email_fuzzy), "i");
    re.link_fuzzy = RegExp(untpl(re.tpl_link_fuzzy), "i");
    re.link_no_ip_fuzzy = RegExp(untpl(re.tpl_link_no_ip_fuzzy), "i");
    re.host_fuzzy_test = RegExp(untpl(re.tpl_host_fuzzy_test), "i");
    //
    // Compile each schema
    //
    var aliases = [];
    self.__compiled__ = {}; // Reset compiled data
    function schemaError(name, val) {
        throw new Error('(LinkifyIt) Invalid schema "' + name + '": ' + val);
    }
    Object.keys(self.__schemas__).forEach(function(name) {
        var val = self.__schemas__[name];
        // skip disabled methods
        if (val === null) return;
        var compiled = {
            validate: null,
            link: null
        };
        self.__compiled__[name] = compiled;
        if ($634840520ea3d55d$var$isObject(val)) {
            if ($634840520ea3d55d$var$isRegExp(val.validate)) compiled.validate = $634840520ea3d55d$var$createValidator(val.validate);
            else if ($634840520ea3d55d$var$isFunction(val.validate)) compiled.validate = val.validate;
            else schemaError(name, val);
            if ($634840520ea3d55d$var$isFunction(val.normalize)) compiled.normalize = val.normalize;
            else if (!val.normalize) compiled.normalize = $634840520ea3d55d$var$createNormalizer();
            else schemaError(name, val);
            return;
        }
        if ($634840520ea3d55d$var$isString(val)) {
            aliases.push(name);
            return;
        }
        schemaError(name, val);
    });
    //
    // Compile postponed aliases
    //
    aliases.forEach(function(alias) {
        if (!self.__compiled__[self.__schemas__[alias]]) // Silently fail on missed schemas to avoid errons on disable.
        // schemaError(alias, self.__schemas__[alias]);
        return;
        self.__compiled__[alias].validate = self.__compiled__[self.__schemas__[alias]].validate;
        self.__compiled__[alias].normalize = self.__compiled__[self.__schemas__[alias]].normalize;
    });
    //
    // Fake record for guessed links
    //
    self.__compiled__[""] = {
        validate: null,
        normalize: $634840520ea3d55d$var$createNormalizer()
    };
    //
    // Build schema condition
    //
    var slist = Object.keys(self.__compiled__).filter(function(name) {
        // Filter disabled & fake schemas
        return name.length > 0 && self.__compiled__[name];
    }).map($634840520ea3d55d$var$escapeRE).join("|");
    // (?!_) cause 1.5x slowdown
    self.re.schema_test = RegExp("(^|(?!_)(?:[><｜]|" + re.src_ZPCc + "))(" + slist + ")", "i");
    self.re.schema_search = RegExp("(^|(?!_)(?:[><｜]|" + re.src_ZPCc + "))(" + slist + ")", "ig");
    self.re.schema_at_start = RegExp("^" + self.re.schema_search.source, "i");
    self.re.pretest = RegExp("(" + self.re.schema_test.source + ")|(" + self.re.host_fuzzy_test.source + ")|@", "i");
    //
    // Cleanup
    //
    $634840520ea3d55d$var$resetScanCache(self);
}
/**
 * class Match
 *
 * Match result. Single element of array, returned by [[LinkifyIt#match]]
 **/ function $634840520ea3d55d$var$Match(self, shift) {
    var start = self.__index__, end = self.__last_index__, text = self.__text_cache__.slice(start, end);
    /**
   * Match#schema -> String
   *
   * Prefix (protocol) for matched string.
   **/ this.schema = self.__schema__.toLowerCase();
    /**
   * Match#index -> Number
   *
   * First position of matched string.
   **/ this.index = start + shift;
    /**
   * Match#lastIndex -> Number
   *
   * Next position after matched string.
   **/ this.lastIndex = end + shift;
    /**
   * Match#raw -> String
   *
   * Matched string.
   **/ this.raw = text;
    /**
   * Match#text -> String
   *
   * Notmalized text of matched string.
   **/ this.text = text;
    /**
   * Match#url -> String
   *
   * Normalized url of matched string.
   **/ this.url = text;
}
function $634840520ea3d55d$var$createMatch(self, shift) {
    var match = new $634840520ea3d55d$var$Match(self, shift);
    self.__compiled__[match.schema].normalize(match, self);
    return match;
}
/**
 * class LinkifyIt
 **/ /**
 * new LinkifyIt(schemas, options)
 * - schemas (Object): Optional. Additional schemas to validate (prefix/validator)
 * - options (Object): { fuzzyLink|fuzzyEmail|fuzzyIP: true|false }
 *
 * Creates new linkifier instance with optional additional schemas.
 * Can be called without `new` keyword for convenience.
 *
 * By default understands:
 *
 * - `http(s)://...` , `ftp://...`, `mailto:...` & `//...` links
 * - "fuzzy" links and emails (example.com, foo@bar.com).
 *
 * `schemas` is an object, where each key/value describes protocol/rule:
 *
 * - __key__ - link prefix (usually, protocol name with `:` at the end, `skype:`
 *   for example). `linkify-it` makes shure that prefix is not preceeded with
 *   alphanumeric char and symbols. Only whitespaces and punctuation allowed.
 * - __value__ - rule to check tail after link prefix
 *   - _String_ - just alias to existing rule
 *   - _Object_
 *     - _validate_ - validator function (should return matched length on success),
 *       or `RegExp`.
 *     - _normalize_ - optional function to normalize text & url of matched result
 *       (for example, for @twitter mentions).
 *
 * `options`:
 *
 * - __fuzzyLink__ - recognige URL-s without `http(s):` prefix. Default `true`.
 * - __fuzzyIP__ - allow IPs in fuzzy links above. Can conflict with some texts
 *   like version numbers. Default `false`.
 * - __fuzzyEmail__ - recognize emails without `mailto:` prefix.
 *
 **/ function $634840520ea3d55d$var$LinkifyIt(schemas, options) {
    if (!(this instanceof $634840520ea3d55d$var$LinkifyIt)) return new $634840520ea3d55d$var$LinkifyIt(schemas, options);
    if (!options) {
        if ($634840520ea3d55d$var$isOptionsObj(schemas)) {
            options = schemas;
            schemas = {};
        }
    }
    this.__opts__ = $634840520ea3d55d$var$assign({}, $634840520ea3d55d$var$defaultOptions, options);
    // Cache last tested result. Used to skip repeating steps on next `match` call.
    this.__index__ = -1;
    this.__last_index__ = -1; // Next scan position
    this.__schema__ = "";
    this.__text_cache__ = "";
    this.__schemas__ = $634840520ea3d55d$var$assign({}, $634840520ea3d55d$var$defaultSchemas, schemas);
    this.__compiled__ = {};
    this.__tlds__ = $634840520ea3d55d$var$tlds_default;
    this.__tlds_replaced__ = false;
    this.re = {};
    $634840520ea3d55d$var$compile(this);
}
/** chainable
 * LinkifyIt#add(schema, definition)
 * - schema (String): rule name (fixed pattern prefix)
 * - definition (String|RegExp|Object): schema definition
 *
 * Add new rule definition. See constructor description for details.
 **/ $634840520ea3d55d$var$LinkifyIt.prototype.add = function add(schema, definition) {
    this.__schemas__[schema] = definition;
    $634840520ea3d55d$var$compile(this);
    return this;
};
/** chainable
 * LinkifyIt#set(options)
 * - options (Object): { fuzzyLink|fuzzyEmail|fuzzyIP: true|false }
 *
 * Set recognition options for links without schema.
 **/ $634840520ea3d55d$var$LinkifyIt.prototype.set = function set(options) {
    this.__opts__ = $634840520ea3d55d$var$assign(this.__opts__, options);
    return this;
};
/**
 * LinkifyIt#test(text) -> Boolean
 *
 * Searches linkifiable pattern and returns `true` on success or `false` on fail.
 **/ $634840520ea3d55d$var$LinkifyIt.prototype.test = function test(text) {
    // Reset scan cache
    this.__text_cache__ = text;
    this.__index__ = -1;
    if (!text.length) return false;
    var m, ml, me, len, shift, next, re, tld_pos, at_pos;
    // try to scan for link with schema - that's the most simple rule
    if (this.re.schema_test.test(text)) {
        re = this.re.schema_search;
        re.lastIndex = 0;
        while((m = re.exec(text)) !== null){
            len = this.testSchemaAt(text, m[2], re.lastIndex);
            if (len) {
                this.__schema__ = m[2];
                this.__index__ = m.index + m[1].length;
                this.__last_index__ = m.index + m[0].length + len;
                break;
            }
        }
    }
    if (this.__opts__.fuzzyLink && this.__compiled__["http:"]) {
        // guess schemaless links
        tld_pos = text.search(this.re.host_fuzzy_test);
        if (tld_pos >= 0) {
            // if tld is located after found link - no need to check fuzzy pattern
            if (this.__index__ < 0 || tld_pos < this.__index__) {
                if ((ml = text.match(this.__opts__.fuzzyIP ? this.re.link_fuzzy : this.re.link_no_ip_fuzzy)) !== null) {
                    shift = ml.index + ml[1].length;
                    if (this.__index__ < 0 || shift < this.__index__) {
                        this.__schema__ = "";
                        this.__index__ = shift;
                        this.__last_index__ = ml.index + ml[0].length;
                    }
                }
            }
        }
    }
    if (this.__opts__.fuzzyEmail && this.__compiled__["mailto:"]) {
        // guess schemaless emails
        at_pos = text.indexOf("@");
        if (at_pos >= 0) // We can't skip this check, because this cases are possible:
        // 192.168.1.1@gmail.com, my.in@example.com
        {
            if ((me = text.match(this.re.email_fuzzy)) !== null) {
                shift = me.index + me[1].length;
                next = me.index + me[0].length;
                if (this.__index__ < 0 || shift < this.__index__ || shift === this.__index__ && next > this.__last_index__) {
                    this.__schema__ = "mailto:";
                    this.__index__ = shift;
                    this.__last_index__ = next;
                }
            }
        }
    }
    return this.__index__ >= 0;
};
/**
 * LinkifyIt#pretest(text) -> Boolean
 *
 * Very quick check, that can give false positives. Returns true if link MAY BE
 * can exists. Can be used for speed optimization, when you need to check that
 * link NOT exists.
 **/ $634840520ea3d55d$var$LinkifyIt.prototype.pretest = function pretest(text) {
    return this.re.pretest.test(text);
};
/**
 * LinkifyIt#testSchemaAt(text, name, position) -> Number
 * - text (String): text to scan
 * - name (String): rule (schema) name
 * - position (Number): text offset to check from
 *
 * Similar to [[LinkifyIt#test]] but checks only specific protocol tail exactly
 * at given position. Returns length of found pattern (0 on fail).
 **/ $634840520ea3d55d$var$LinkifyIt.prototype.testSchemaAt = function testSchemaAt(text, schema, pos) {
    // If not supported schema check requested - terminate
    if (!this.__compiled__[schema.toLowerCase()]) return 0;
    return this.__compiled__[schema.toLowerCase()].validate(text, pos, this);
};
/**
 * LinkifyIt#match(text) -> Array|null
 *
 * Returns array of found link descriptions or `null` on fail. We strongly
 * recommend to use [[LinkifyIt#test]] first, for best speed.
 *
 * ##### Result match description
 *
 * - __schema__ - link schema, can be empty for fuzzy links, or `//` for
 *   protocol-neutral  links.
 * - __index__ - offset of matched text
 * - __lastIndex__ - index of next char after mathch end
 * - __raw__ - matched text
 * - __text__ - normalized text
 * - __url__ - link, generated from matched text
 **/ $634840520ea3d55d$var$LinkifyIt.prototype.match = function match(text) {
    var shift = 0, result = [];
    // Try to take previous element from cache, if .test() called before
    if (this.__index__ >= 0 && this.__text_cache__ === text) {
        result.push($634840520ea3d55d$var$createMatch(this, shift));
        shift = this.__last_index__;
    }
    // Cut head if cache was used
    var tail = shift ? text.slice(shift) : text;
    // Scan string until end reached
    while(this.test(tail)){
        result.push($634840520ea3d55d$var$createMatch(this, shift));
        tail = tail.slice(this.__last_index__);
        shift += this.__last_index__;
    }
    if (result.length) return result;
    return null;
};
/**
 * LinkifyIt#matchAtStart(text) -> Match|null
 *
 * Returns fully-formed (not fuzzy) link if it starts at the beginning
 * of the string, and null otherwise.
 **/ $634840520ea3d55d$var$LinkifyIt.prototype.matchAtStart = function matchAtStart(text) {
    // Reset scan cache
    this.__text_cache__ = text;
    this.__index__ = -1;
    if (!text.length) return null;
    var m = this.re.schema_at_start.exec(text);
    if (!m) return null;
    var len = this.testSchemaAt(text, m[2], m[0].length);
    if (!len) return null;
    this.__schema__ = m[2];
    this.__index__ = m.index + m[1].length;
    this.__last_index__ = m.index + m[0].length + len;
    return $634840520ea3d55d$var$createMatch(this, 0);
};
/** chainable
 * LinkifyIt#tlds(list [, keepOld]) -> this
 * - list (Array): list of tlds
 * - keepOld (Boolean): merge with current list if `true` (`false` by default)
 *
 * Load (or merge) new tlds list. Those are user for fuzzy links (without prefix)
 * to avoid false positives. By default this algorythm used:
 *
 * - hostname with any 2-letter root zones are ok.
 * - biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|рф
 *   are ok.
 * - encoded (`xn--...`) root zones are ok.
 *
 * If list is replaced, then exact match for 2-chars root zones will be checked.
 **/ $634840520ea3d55d$var$LinkifyIt.prototype.tlds = function tlds(list, keepOld) {
    list = Array.isArray(list) ? list : [
        list
    ];
    if (!keepOld) {
        this.__tlds__ = list.slice();
        this.__tlds_replaced__ = true;
        $634840520ea3d55d$var$compile(this);
        return this;
    }
    this.__tlds__ = this.__tlds__.concat(list).sort().filter(function(el, idx, arr) {
        return el !== arr[idx - 1];
    }).reverse();
    $634840520ea3d55d$var$compile(this);
    return this;
};
/**
 * LinkifyIt#normalize(match)
 *
 * Default normalizer (if schema does not define it's own).
 **/ $634840520ea3d55d$var$LinkifyIt.prototype.normalize = function normalize(match) {
    // Do minimal possible changes by default. Need to collect feedback prior
    // to move forward https://github.com/markdown-it/linkify-it/issues/1
    if (!match.schema) match.url = "http://" + match.url;
    if (match.schema === "mailto:" && !/^mailto:/i.test(match.url)) match.url = "mailto:" + match.url;
};
/**
 * LinkifyIt#onCompile()
 *
 * Override to modify basic RegExp-s.
 **/ $634840520ea3d55d$var$LinkifyIt.prototype.onCompile = function onCompile() {};
module.exports = $634840520ea3d55d$var$LinkifyIt;

});
parcelRequire.register("lIrnr", function(module, exports) {
"use strict";




module.exports = function(opts) {
    var re = {};
    opts = opts || {};
    // Use direct extract instead of `regenerate` to reduse browserified size
    re.src_Any = (parcelRequire("73OXq")).source;
    re.src_Cc = (parcelRequire("c7ys3")).source;
    re.src_Z = (parcelRequire("kWxtK")).source;
    re.src_P = (parcelRequire("7X6km")).source;
    // \p{\Z\P\Cc\CF} (white spaces + control + format + punctuation)
    re.src_ZPCc = [
        re.src_Z,
        re.src_P,
        re.src_Cc
    ].join("|");
    // \p{\Z\Cc} (white spaces + control)
    re.src_ZCc = [
        re.src_Z,
        re.src_Cc
    ].join("|");
    // Experimental. List of chars, completely prohibited in links
    // because can separate it from other part of text
    var text_separators = "[><｜]";
    // All possible word characters (everything without punctuation, spaces & controls)
    // Defined via punctuation & spaces to save space
    // Should be something like \p{\L\N\S\M} (\w but without `_`)
    re.src_pseudo_letter = "(?:(?!" + text_separators + "|" + re.src_ZPCc + ")" + re.src_Any + ")";
    // The same as abothe but without [0-9]
    // var src_pseudo_letter_non_d = '(?:(?![0-9]|' + src_ZPCc + ')' + src_Any + ')';
    ////////////////////////////////////////////////////////////////////////////////
    re.src_ip4 = "(?:(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.){3}(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)";
    // Prohibit any of "@/[]()" in user/pass to avoid wrong domain fetch.
    re.src_auth = "(?:(?:(?!" + re.src_ZCc + "|[@/\\[\\]()]).)+@)?";
    re.src_port = "(?::(?:6(?:[0-4]\\d{3}|5(?:[0-4]\\d{2}|5(?:[0-2]\\d|3[0-5])))|[1-5]?\\d{1,4}))?";
    re.src_host_terminator = "(?=$|" + text_separators + "|" + re.src_ZPCc + ")" + "(?!" + (opts["---"] ? "-(?!--)|" : "-|") + "_|:\\d|\\.-|\\.(?!$|" + re.src_ZPCc + "))";
    re.src_path = "(?:[/?#](?:(?!" + re.src_ZCc + "|" + text_separators + "|[()[\\]{}.,\"'?!\\-;]).|" + "\\[(?:(?!" + re.src_ZCc + "|\\]).)*\\]|" + "\\((?:(?!" + re.src_ZCc + "|[)]).)*\\)|" + "\\{(?:(?!" + re.src_ZCc + "|[}]).)*\\}|" + '\\"(?:(?!' + re.src_ZCc + '|["]).)+\\"|' + "\\'(?:(?!" + re.src_ZCc + "|[']).)+\\'|" + "\\'(?=" + re.src_pseudo_letter + "|[-])|" + // allow `I'm_king` if no pair found
    "\\.{2,}[a-zA-Z0-9%/&]|" + // google has many dots in "google search" links (#66, #81).
    // github has ... in commit range links,
    // Restrict to
    // - english
    // - percent-encoded
    // - parts of file path
    // - params separator
    // until more examples found.
    "\\.(?!" + re.src_ZCc + "|[.]|$)|" + (opts["---"] ? "\\-(?!--(?:[^-]|$))(?:-*)|" // `---` => long dash, terminate
     : "\\-+|") + ",(?!" + re.src_ZCc + "|$)|" + // allow `,,,` in paths
    ";(?!" + re.src_ZCc + "|$)|" + // allow `;` if not followed by space-like char
    "\\!+(?!" + re.src_ZCc + "|[!]|$)|" + // allow `!!!` in paths, but not at the end
    "\\?(?!" + re.src_ZCc + "|[?]|$)" + ")+" + "|\\/" + ")?";
    // Allow anything in markdown spec, forbid quote (") at the first position
    // because emails enclosed in quotes are far more common
    re.src_email_name = '[\\-;:&=\\+\\$,\\.a-zA-Z0-9_][\\-;:&=\\+\\$,\\"\\.a-zA-Z0-9_]*';
    re.src_xn = "xn--[a-z0-9\\-]{1,59}";
    // More to read about domain names
    // http://serverfault.com/questions/638260/
    re.src_domain_root = // Allow letters & digits (http://test1)
    "(?:" + re.src_xn + "|" + re.src_pseudo_letter + "{1,63}" + ")";
    re.src_domain = "(?:" + re.src_xn + "|" + "(?:" + re.src_pseudo_letter + ")" + "|" + "(?:" + re.src_pseudo_letter + "(?:-|" + re.src_pseudo_letter + "){0,61}" + re.src_pseudo_letter + ")" + ")";
    re.src_host = "(?:(?:(?:(?:" + re.src_domain + ")\\.)*" + re.src_domain /*_root*/  + ")" + ")";
    re.tpl_host_fuzzy = "(?:" + re.src_ip4 + "|" + "(?:(?:(?:" + re.src_domain + ")\\.)+(?:%TLDS%))" + ")";
    re.tpl_host_no_ip_fuzzy = "(?:(?:(?:" + re.src_domain + ")\\.)+(?:%TLDS%))";
    re.src_host_strict = re.src_host + re.src_host_terminator;
    re.tpl_host_fuzzy_strict = re.tpl_host_fuzzy + re.src_host_terminator;
    re.src_host_port_strict = re.src_host + re.src_port + re.src_host_terminator;
    re.tpl_host_port_fuzzy_strict = re.tpl_host_fuzzy + re.src_port + re.src_host_terminator;
    re.tpl_host_port_no_ip_fuzzy_strict = re.tpl_host_no_ip_fuzzy + re.src_port + re.src_host_terminator;
    ////////////////////////////////////////////////////////////////////////////////
    // Main rules
    // Rude test fuzzy links by host, for quick deny
    re.tpl_host_fuzzy_test = "localhost|www\\.|\\.\\d{1,3}\\.|(?:\\.(?:%TLDS%)(?:" + re.src_ZPCc + "|>|$))";
    re.tpl_email_fuzzy = "(^|" + text_separators + '|"|\\(|' + re.src_ZCc + ")" + "(" + re.src_email_name + "@" + re.tpl_host_fuzzy_strict + ")";
    re.tpl_link_fuzzy = // Fuzzy link can't be prepended with .:/\- and non punctuation.
    // but can start with > (markdown blockquote)
    "(^|(?![.:/\\-_@])(?:[$+<=>^`|｜]|" + re.src_ZPCc + "))" + "((?![$+<=>^`|｜])" + re.tpl_host_port_fuzzy_strict + re.src_path + ")";
    re.tpl_link_no_ip_fuzzy = // Fuzzy link can't be prepended with .:/\- and non punctuation.
    // but can start with > (markdown blockquote)
    "(^|(?![.:/\\-_@])(?:[$+<=>^`|｜]|" + re.src_ZPCc + "))" + "((?![$+<=>^`|｜])" + re.tpl_host_port_no_ip_fuzzy_strict + re.src_path + ")";
    return re;
};

});


parcelRequire.register("i3uit", function(module, exports) {
(function(root) {
    /** Detect free variables */ var freeExports = exports && !exports.nodeType && exports;
    var freeModule = module && !module.nodeType && module;
    var freeGlobal = typeof $parcel$global == "object" && $parcel$global;
    if (freeGlobal.global === freeGlobal || freeGlobal.window === freeGlobal || freeGlobal.self === freeGlobal) root = freeGlobal;
    /**
	 * The `punycode` object.
	 * @name punycode
	 * @type Object
	 */ var punycode, /** Highest positive signed 32-bit float value */ maxInt = 2147483647, /** Bootstring parameters */ base = 36, tMin = 1, tMax = 26, skew = 38, damp = 700, initialBias = 72, initialN = 128, delimiter = "-", /** Regular expressions */ regexPunycode = /^xn--/, regexNonASCII = /[^\x20-\x7E]/, regexSeparators = /[\x2E\u3002\uFF0E\uFF61]/g, /** Error messages */ errors = {
        "overflow": "Overflow: input needs wider integers to process",
        "not-basic": "Illegal input >= 0x80 (not a basic code point)",
        "invalid-input": "Invalid input"
    }, /** Convenience shortcuts */ baseMinusTMin = base - tMin, floor = Math.floor, stringFromCharCode = String.fromCharCode, /** Temporary variable */ key;
    /*--------------------------------------------------------------------------*/ /**
	 * A generic error utility function.
	 * @private
	 * @param {String} type The error type.
	 * @returns {Error} Throws a `RangeError` with the applicable error message.
	 */ function error(type) {
        throw new RangeError(errors[type]);
    }
    /**
	 * A generic `Array#map` utility function.
	 * @private
	 * @param {Array} array The array to iterate over.
	 * @param {Function} callback The function that gets called for every array
	 * item.
	 * @returns {Array} A new array of values returned by the callback function.
	 */ function map(array, fn) {
        var length = array.length;
        var result = [];
        while(length--)result[length] = fn(array[length]);
        return result;
    }
    /**
	 * A simple `Array#map`-like wrapper to work with domain name strings or email
	 * addresses.
	 * @private
	 * @param {String} domain The domain name or email address.
	 * @param {Function} callback The function that gets called for every
	 * character.
	 * @returns {Array} A new string of characters returned by the callback
	 * function.
	 */ function mapDomain(string, fn) {
        var parts = string.split("@");
        var result = "";
        if (parts.length > 1) {
            // In email addresses, only the domain name should be punycoded. Leave
            // the local part (i.e. everything up to `@`) intact.
            result = parts[0] + "@";
            string = parts[1];
        }
        // Avoid `split(regex)` for IE8 compatibility. See #17.
        string = string.replace(regexSeparators, ".");
        var labels = string.split(".");
        var encoded = map(labels, fn).join(".");
        return result + encoded;
    }
    /**
	 * Creates an array containing the numeric code points of each Unicode
	 * character in the string. While JavaScript uses UCS-2 internally,
	 * this function will convert a pair of surrogate halves (each of which
	 * UCS-2 exposes as separate characters) into a single code point,
	 * matching UTF-16.
	 * @see `punycode.ucs2.encode`
	 * @see <https://mathiasbynens.be/notes/javascript-encoding>
	 * @memberOf punycode.ucs2
	 * @name decode
	 * @param {String} string The Unicode input string (UCS-2).
	 * @returns {Array} The new array of code points.
	 */ function ucs2decode(string) {
        var output = [], counter = 0, length = string.length, value, extra;
        while(counter < length){
            value = string.charCodeAt(counter++);
            if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
                // high surrogate, and there is a next character
                extra = string.charCodeAt(counter++);
                if ((extra & 0xFC00) == 0xDC00) output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
                else {
                    // unmatched surrogate; only append this code unit, in case the next
                    // code unit is the high surrogate of a surrogate pair
                    output.push(value);
                    counter--;
                }
            } else output.push(value);
        }
        return output;
    }
    /**
	 * Creates a string based on an array of numeric code points.
	 * @see `punycode.ucs2.decode`
	 * @memberOf punycode.ucs2
	 * @name encode
	 * @param {Array} codePoints The array of numeric code points.
	 * @returns {String} The new Unicode string (UCS-2).
	 */ function ucs2encode(array) {
        return map(array, function(value) {
            var output = "";
            if (value > 0xFFFF) {
                value -= 0x10000;
                output += stringFromCharCode(value >>> 10 & 0x3FF | 0xD800);
                value = 0xDC00 | value & 0x3FF;
            }
            output += stringFromCharCode(value);
            return output;
        }).join("");
    }
    /**
	 * Converts a basic code point into a digit/integer.
	 * @see `digitToBasic()`
	 * @private
	 * @param {Number} codePoint The basic numeric code point value.
	 * @returns {Number} The numeric value of a basic code point (for use in
	 * representing integers) in the range `0` to `base - 1`, or `base` if
	 * the code point does not represent a value.
	 */ function basicToDigit(codePoint) {
        if (codePoint - 48 < 10) return codePoint - 22;
        if (codePoint - 65 < 26) return codePoint - 65;
        if (codePoint - 97 < 26) return codePoint - 97;
        return base;
    }
    /**
	 * Converts a digit/integer into a basic code point.
	 * @see `basicToDigit()`
	 * @private
	 * @param {Number} digit The numeric value of a basic code point.
	 * @returns {Number} The basic code point whose value (when used for
	 * representing integers) is `digit`, which needs to be in the range
	 * `0` to `base - 1`. If `flag` is non-zero, the uppercase form is
	 * used; else, the lowercase form is used. The behavior is undefined
	 * if `flag` is non-zero and `digit` has no uppercase form.
	 */ function digitToBasic(digit, flag) {
        //  0..25 map to ASCII a..z or A..Z
        // 26..35 map to ASCII 0..9
        return digit + 22 + 75 * (digit < 26) - ((flag != 0) << 5);
    }
    /**
	 * Bias adaptation function as per section 3.4 of RFC 3492.
	 * https://tools.ietf.org/html/rfc3492#section-3.4
	 * @private
	 */ function adapt(delta, numPoints, firstTime) {
        var k = 0;
        delta = firstTime ? floor(delta / damp) : delta >> 1;
        delta += floor(delta / numPoints);
        for(; delta > baseMinusTMin * tMax >> 1; k += base)delta = floor(delta / baseMinusTMin);
        return floor(k + (baseMinusTMin + 1) * delta / (delta + skew));
    }
    /**
	 * Converts a Punycode string of ASCII-only symbols to a string of Unicode
	 * symbols.
	 * @memberOf punycode
	 * @param {String} input The Punycode string of ASCII-only symbols.
	 * @returns {String} The resulting string of Unicode symbols.
	 */ function decode(input) {
        // Don't use UCS-2
        var output = [], inputLength = input.length, out, i = 0, n = initialN, bias = initialBias, basic, j, index, oldi, w, k, digit, t, /** Cached calculation results */ baseMinusT;
        // Handle the basic code points: let `basic` be the number of input code
        // points before the last delimiter, or `0` if there is none, then copy
        // the first basic code points to the output.
        basic = input.lastIndexOf(delimiter);
        if (basic < 0) basic = 0;
        for(j = 0; j < basic; ++j){
            // if it's not a basic code point
            if (input.charCodeAt(j) >= 0x80) error("not-basic");
            output.push(input.charCodeAt(j));
        }
        // Main decoding loop: start just after the last delimiter if any basic code
        // points were copied; start at the beginning otherwise.
        for(index = basic > 0 ? basic + 1 : 0; index < inputLength;){
            // `index` is the index of the next character to be consumed.
            // Decode a generalized variable-length integer into `delta`,
            // which gets added to `i`. The overflow checking is easier
            // if we increase `i` as we go, then subtract off its starting
            // value at the end to obtain `delta`.
            for(oldi = i, w = 1, k = base;; k += base){
                if (index >= inputLength) error("invalid-input");
                digit = basicToDigit(input.charCodeAt(index++));
                if (digit >= base || digit > floor((maxInt - i) / w)) error("overflow");
                i += digit * w;
                t = k <= bias ? tMin : k >= bias + tMax ? tMax : k - bias;
                if (digit < t) break;
                baseMinusT = base - t;
                if (w > floor(maxInt / baseMinusT)) error("overflow");
                w *= baseMinusT;
            }
            out = output.length + 1;
            bias = adapt(i - oldi, out, oldi == 0);
            // `i` was supposed to wrap around from `out` to `0`,
            // incrementing `n` each time, so we'll fix that now:
            if (floor(i / out) > maxInt - n) error("overflow");
            n += floor(i / out);
            i %= out;
            // Insert `n` at position `i` of the output
            output.splice(i++, 0, n);
        }
        return ucs2encode(output);
    }
    /**
	 * Converts a string of Unicode symbols (e.g. a domain name label) to a
	 * Punycode string of ASCII-only symbols.
	 * @memberOf punycode
	 * @param {String} input The string of Unicode symbols.
	 * @returns {String} The resulting Punycode string of ASCII-only symbols.
	 */ function encode(input) {
        var n, delta, handledCPCount, basicLength, bias, j, m, q, k, t, currentValue, output = [], /** `inputLength` will hold the number of code points in `input`. */ inputLength, /** Cached calculation results */ handledCPCountPlusOne, baseMinusT, qMinusT;
        // Convert the input in UCS-2 to Unicode
        input = ucs2decode(input);
        // Cache the length
        inputLength = input.length;
        // Initialize the state
        n = initialN;
        delta = 0;
        bias = initialBias;
        // Handle the basic code points
        for(j = 0; j < inputLength; ++j){
            currentValue = input[j];
            if (currentValue < 0x80) output.push(stringFromCharCode(currentValue));
        }
        handledCPCount = basicLength = output.length;
        // `handledCPCount` is the number of code points that have been handled;
        // `basicLength` is the number of basic code points.
        // Finish the basic string - if it is not empty - with a delimiter
        if (basicLength) output.push(delimiter);
        // Main encoding loop:
        while(handledCPCount < inputLength){
            // All non-basic code points < n have been handled already. Find the next
            // larger one:
            for(m = maxInt, j = 0; j < inputLength; ++j){
                currentValue = input[j];
                if (currentValue >= n && currentValue < m) m = currentValue;
            }
            // Increase `delta` enough to advance the decoder's <n,i> state to <m,0>,
            // but guard against overflow
            handledCPCountPlusOne = handledCPCount + 1;
            if (m - n > floor((maxInt - delta) / handledCPCountPlusOne)) error("overflow");
            delta += (m - n) * handledCPCountPlusOne;
            n = m;
            for(j = 0; j < inputLength; ++j){
                currentValue = input[j];
                if (currentValue < n && ++delta > maxInt) error("overflow");
                if (currentValue == n) {
                    // Represent delta as a generalized variable-length integer
                    for(q = delta, k = base;; k += base){
                        t = k <= bias ? tMin : k >= bias + tMax ? tMax : k - bias;
                        if (q < t) break;
                        qMinusT = q - t;
                        baseMinusT = base - t;
                        output.push(stringFromCharCode(digitToBasic(t + qMinusT % baseMinusT, 0)));
                        q = floor(qMinusT / baseMinusT);
                    }
                    output.push(stringFromCharCode(digitToBasic(q, 0)));
                    bias = adapt(delta, handledCPCountPlusOne, handledCPCount == basicLength);
                    delta = 0;
                    ++handledCPCount;
                }
            }
            ++delta;
            ++n;
        }
        return output.join("");
    }
    /**
	 * Converts a Punycode string representing a domain name or an email address
	 * to Unicode. Only the Punycoded parts of the input will be converted, i.e.
	 * it doesn't matter if you call it on a string that has already been
	 * converted to Unicode.
	 * @memberOf punycode
	 * @param {String} input The Punycoded domain name or email address to
	 * convert to Unicode.
	 * @returns {String} The Unicode representation of the given Punycode
	 * string.
	 */ function toUnicode(input) {
        return mapDomain(input, function(string) {
            return regexPunycode.test(string) ? decode(string.slice(4).toLowerCase()) : string;
        });
    }
    /**
	 * Converts a Unicode string representing a domain name or an email address to
	 * Punycode. Only the non-ASCII parts of the domain name will be converted,
	 * i.e. it doesn't matter if you call it with a domain that's already in
	 * ASCII.
	 * @memberOf punycode
	 * @param {String} input The domain name or email address to convert, as a
	 * Unicode string.
	 * @returns {String} The Punycode representation of the given domain name or
	 * email address.
	 */ function toASCII(input) {
        return mapDomain(input, function(string) {
            return regexNonASCII.test(string) ? "xn--" + encode(string) : string;
        });
    }
    /*--------------------------------------------------------------------------*/ /** Define the public API */ punycode = {
        /**
		 * A string representing the current Punycode.js version number.
		 * @memberOf punycode
		 * @type String
		 */ "version": "1.4.1",
        /**
		 * An object of methods to convert from JavaScript's internal character
		 * representation (UCS-2) to Unicode code points, and back.
		 * @see <https://mathiasbynens.be/notes/javascript-encoding>
		 * @memberOf punycode
		 * @type Object
		 */ "ucs2": {
            "decode": ucs2decode,
            "encode": ucs2encode
        },
        "decode": decode,
        "encode": encode,
        "toASCII": toASCII,
        "toUnicode": toUnicode
    };
    /** Expose `punycode` */ // Some AMD build optimizers, like r.js, check for specific condition patterns
    // like the following:
    if (typeof define == "function" && typeof define.amd == "object" && define.amd) define("punycode", function() {
        return punycode;
    });
    else if (freeExports && freeModule) {
        if (module.exports == freeExports) // in Node.js, io.js, or RingoJS v0.8.0+
        freeModule.exports = punycode;
        else // in Narwhal or RingoJS v0.7.0-
        for(key in punycode)punycode.hasOwnProperty(key) && (freeExports[key] = punycode[key]);
    } else // in Rhino or a web browser
    root.punycode = punycode;
})(this);

});

parcelRequire.register("ev7VO", function(module, exports) {
// markdown-it default options
"use strict";
module.exports = {
    options: {
        html: false,
        xhtmlOut: false,
        breaks: false,
        langPrefix: "language-",
        linkify: false,
        // Enable some language-neutral replacements + quotes beautification
        typographer: false,
        // Double + single quotes replacement pairs, when typographer enabled,
        // and smartquotes on. Could be either a String or an Array.
        //
        // For example, you can use '«»„“' for Russian, '„“‚‘' for German,
        // and ['«\xA0', '\xA0»', '‹\xA0', '\xA0›'] for French (including nbsp).
        quotes: "“”‘’",
        /* “”‘’ */ // Highlighter function. Should return escaped HTML,
        // or '' if the source string is not changed and should be escaped externaly.
        // If result starts with <pre... internal wrapper is skipped.
        //
        // function (/*str, lang*/) { return ''; }
        //
        highlight: null,
        maxNesting: 100 // Internal protection, recursion limit
    },
    components: {
        core: {},
        block: {},
        inline: {}
    }
};

});

parcelRequire.register("1GwiV", function(module, exports) {
// "Zero" preset, with nothing enabled. Useful for manual configuring of simple
// modes. For example, to parse bold/italic only.
"use strict";
module.exports = {
    options: {
        html: false,
        xhtmlOut: false,
        breaks: false,
        langPrefix: "language-",
        linkify: false,
        // Enable some language-neutral replacements + quotes beautification
        typographer: false,
        // Double + single quotes replacement pairs, when typographer enabled,
        // and smartquotes on. Could be either a String or an Array.
        //
        // For example, you can use '«»„“' for Russian, '„“‚‘' for German,
        // and ['«\xA0', '\xA0»', '‹\xA0', '\xA0›'] for French (including nbsp).
        quotes: "“”‘’",
        /* “”‘’ */ // Highlighter function. Should return escaped HTML,
        // or '' if the source string is not changed and should be escaped externaly.
        // If result starts with <pre... internal wrapper is skipped.
        //
        // function (/*str, lang*/) { return ''; }
        //
        highlight: null,
        maxNesting: 20 // Internal protection, recursion limit
    },
    components: {
        core: {
            rules: [
                "normalize",
                "block",
                "inline",
                "text_join"
            ]
        },
        block: {
            rules: [
                "paragraph"
            ]
        },
        inline: {
            rules: [
                "text"
            ],
            rules2: [
                "balance_pairs",
                "fragments_join"
            ]
        }
    }
};

});

parcelRequire.register("cANLb", function(module, exports) {
// Commonmark default options
"use strict";
module.exports = {
    options: {
        html: true,
        xhtmlOut: true,
        breaks: false,
        langPrefix: "language-",
        linkify: false,
        // Enable some language-neutral replacements + quotes beautification
        typographer: false,
        // Double + single quotes replacement pairs, when typographer enabled,
        // and smartquotes on. Could be either a String or an Array.
        //
        // For example, you can use '«»„“' for Russian, '„“‚‘' for German,
        // and ['«\xA0', '\xA0»', '‹\xA0', '\xA0›'] for French (including nbsp).
        quotes: "“”‘’",
        /* “”‘’ */ // Highlighter function. Should return escaped HTML,
        // or '' if the source string is not changed and should be escaped externaly.
        // If result starts with <pre... internal wrapper is skipped.
        //
        // function (/*str, lang*/) { return ''; }
        //
        highlight: null,
        maxNesting: 20 // Internal protection, recursion limit
    },
    components: {
        core: {
            rules: [
                "normalize",
                "block",
                "inline",
                "text_join"
            ]
        },
        block: {
            rules: [
                "blockquote",
                "code",
                "fence",
                "heading",
                "hr",
                "html_block",
                "lheading",
                "list",
                "reference",
                "paragraph"
            ]
        },
        inline: {
            rules: [
                "autolink",
                "backticks",
                "emphasis",
                "entity",
                "escape",
                "html_inline",
                "image",
                "link",
                "newline",
                "text"
            ],
            rules2: [
                "balance_pairs",
                "emphasis",
                "fragments_join"
            ]
        }
    }
};

});



parcelRequire.register("dCjk2", function(module, exports) {
"use strict";
function $9e9dcff382a34a4c$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $9e9dcff382a34a4c$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $9e9dcff382a34a4c$var$_typeof(obj);
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.speechSynthesis = module.exports.SpeechSynthesisVoice = module.exports.SpeechSynthesisUtterance = module.exports.SpeechSynthesisEvent = void 0;

var $9e9dcff382a34a4c$var$_es = $9e9dcff382a34a4c$var$_interopRequireWildcard((parcelRequire("bgEWP")));
function $9e9dcff382a34a4c$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($9e9dcff382a34a4c$var$_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $9e9dcff382a34a4c$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || $9e9dcff382a34a4c$var$_typeof(obj) !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $9e9dcff382a34a4c$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $9e9dcff382a34a4c$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $9e9dcff382a34a4c$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $9e9dcff382a34a4c$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $9e9dcff382a34a4c$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $9e9dcff382a34a4c$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $9e9dcff382a34a4c$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $9e9dcff382a34a4c$var$_setPrototypeOf(subClass, superClass);
}
function $9e9dcff382a34a4c$var$_setPrototypeOf(o, p) {
    $9e9dcff382a34a4c$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $9e9dcff382a34a4c$var$_setPrototypeOf(o, p);
}
function $9e9dcff382a34a4c$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $9e9dcff382a34a4c$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $9e9dcff382a34a4c$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $9e9dcff382a34a4c$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $9e9dcff382a34a4c$var$_possibleConstructorReturn(this, result);
    };
}
function $9e9dcff382a34a4c$var$_possibleConstructorReturn(self, call) {
    if (call && ($9e9dcff382a34a4c$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $9e9dcff382a34a4c$var$_assertThisInitialized(self);
}
function $9e9dcff382a34a4c$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $9e9dcff382a34a4c$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $9e9dcff382a34a4c$var$_getPrototypeOf(o) {
    $9e9dcff382a34a4c$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $9e9dcff382a34a4c$var$_getPrototypeOf(o);
}
var $9e9dcff382a34a4c$var$SpeechSynthesisEvent = /*#__PURE__*/ function(_Event) {
    $9e9dcff382a34a4c$var$_inherits(SpeechSynthesisEvent, _Event);
    var _super = $9e9dcff382a34a4c$var$_createSuper(SpeechSynthesisEvent);
    function SpeechSynthesisEvent(type, utterance) {
        var _this;
        $9e9dcff382a34a4c$var$_classCallCheck(this, SpeechSynthesisEvent);
        _this = _super.call(this, type);
        _this._utterance = utterance;
        return _this;
    }
    $9e9dcff382a34a4c$var$_createClass(SpeechSynthesisEvent, [
        {
            key: "charIndex",
            get: function get() {
                return 0;
            }
        },
        {
            key: "elapsedTime",
            get: function get() {
                return 0;
            }
        },
        {
            key: "name",
            get: function get() {}
        },
        {
            key: "utterance",
            get: function get() {
                return this._utterance;
            }
        }
    ]);
    return SpeechSynthesisEvent;
}($9e9dcff382a34a4c$var$_es.Event);
module.exports.SpeechSynthesisEvent = $9e9dcff382a34a4c$var$SpeechSynthesisEvent;
var $9e9dcff382a34a4c$var$SpeechSynthesisUtterance = /*#__PURE__*/ function(_EventTarget) {
    $9e9dcff382a34a4c$var$_inherits(SpeechSynthesisUtterance, _EventTarget);
    var _super2 = $9e9dcff382a34a4c$var$_createSuper(SpeechSynthesisUtterance);
    function SpeechSynthesisUtterance(text) {
        var _this2;
        $9e9dcff382a34a4c$var$_classCallCheck(this, SpeechSynthesisUtterance);
        _this2 = _super2.call(this);
        _this2._lang = "en-US";
        _this2._pitch = 1;
        _this2._rate = 1;
        _this2._text = text;
        _this2._voice = null;
        _this2._volume = 1;
        return _this2;
    }
    $9e9dcff382a34a4c$var$_createClass(SpeechSynthesisUtterance, [
        {
            key: "lang",
            get: function get() {
                return this._lang;
            },
            set: function set(value) {
                this._lang = value;
            }
        },
        {
            key: "pitch",
            get: function get() {
                return this._pitch;
            },
            set: function set(value) {
                this._pitch = value;
            }
        },
        {
            key: "rate",
            get: function get() {
                return this._rate;
            },
            set: function set(value) {
                this._rate = value;
            }
        },
        {
            key: "text",
            get: function get() {
                return this._text;
            },
            set: function set(value) {
                this._text = value;
            }
        },
        {
            key: "voice",
            get: function get() {
                return this._voice;
            },
            set: function set(value) {
                this._voice = value;
            }
        },
        {
            key: "volume",
            get: function get() {
                return this._volume;
            },
            set: function set(value) {
                this._volume = value;
            }
        },
        {
            key: "onboundary",
            get: function get() {
                return (0, $9e9dcff382a34a4c$var$_es.getEventAttributeValue)(this, "boundary");
            },
            set: function set(value) {
                (0, $9e9dcff382a34a4c$var$_es.setEventAttributeValue)(this, "boundary", value);
            }
        },
        {
            key: "onend",
            get: function get() {
                return (0, $9e9dcff382a34a4c$var$_es.getEventAttributeValue)(this, "end");
            },
            set: function set(value) {
                (0, $9e9dcff382a34a4c$var$_es.setEventAttributeValue)(this, "end", value);
            }
        },
        {
            key: "onerror",
            get: function get() {
                return (0, $9e9dcff382a34a4c$var$_es.getEventAttributeValue)(this, "error");
            },
            set: function set(value) {
                (0, $9e9dcff382a34a4c$var$_es.setEventAttributeValue)(this, "error", value);
            }
        },
        {
            key: "onmark",
            get: function get() {
                return (0, $9e9dcff382a34a4c$var$_es.getEventAttributeValue)(this, "mark");
            },
            set: function set(value) {
                (0, $9e9dcff382a34a4c$var$_es.setEventAttributeValue)(this, "mark", value);
            }
        },
        {
            key: "onpause",
            get: function get() {
                return (0, $9e9dcff382a34a4c$var$_es.getEventAttributeValue)(this, "pause");
            },
            set: function set(value) {
                (0, $9e9dcff382a34a4c$var$_es.setEventAttributeValue)(this, "pause", value);
            }
        },
        {
            key: "onresume",
            get: function get() {
                return (0, $9e9dcff382a34a4c$var$_es.getEventAttributeValue)(this, "resume");
            },
            set: function set(value) {
                (0, $9e9dcff382a34a4c$var$_es.setEventAttributeValue)(this, "resume", value);
            }
        },
        {
            key: "onstart",
            get: function get() {
                return (0, $9e9dcff382a34a4c$var$_es.getEventAttributeValue)(this, "start");
            },
            set: function set(value) {
                (0, $9e9dcff382a34a4c$var$_es.setEventAttributeValue)(this, "start", value);
            }
        }
    ]);
    return SpeechSynthesisUtterance;
}($9e9dcff382a34a4c$var$_es.default);
module.exports.SpeechSynthesisUtterance = $9e9dcff382a34a4c$var$SpeechSynthesisUtterance;
var $9e9dcff382a34a4c$var$SpeechSynthesisVoice = /*#__PURE__*/ function() {
    function SpeechSynthesisVoice() {
        $9e9dcff382a34a4c$var$_classCallCheck(this, SpeechSynthesisVoice);
    }
    $9e9dcff382a34a4c$var$_createClass(SpeechSynthesisVoice, [
        {
            key: "default",
            get: function get() {
                return true;
            }
        },
        {
            key: "lang",
            get: function get() {
                return "en-US";
            }
        },
        {
            key: "localService",
            get: function get() {
                return true;
            }
        },
        {
            key: "name",
            get: function get() {
                return "English (US)";
            }
        },
        {
            key: "voiceURI",
            get: function get() {
                return "English (US)";
            }
        }
    ]);
    return SpeechSynthesisVoice;
}();
module.exports.SpeechSynthesisVoice = $9e9dcff382a34a4c$var$SpeechSynthesisVoice;
var $9e9dcff382a34a4c$var$SpeechSynthesis = /*#__PURE__*/ function(_EventTarget2) {
    $9e9dcff382a34a4c$var$_inherits(SpeechSynthesis, _EventTarget2);
    var _super3 = $9e9dcff382a34a4c$var$_createSuper(SpeechSynthesis);
    function SpeechSynthesis() {
        $9e9dcff382a34a4c$var$_classCallCheck(this, SpeechSynthesis);
        return _super3.apply(this, arguments);
    }
    $9e9dcff382a34a4c$var$_createClass(SpeechSynthesis, [
        {
            key: "paused",
            get: function get() {
                return false;
            }
        },
        {
            key: "pending",
            get: function get() {
                return false;
            }
        },
        {
            key: "speaking",
            get: function get() {
                return false;
            }
        },
        {
            key: "cancel",
            value: function cancel() {}
        },
        {
            key: "getVoices",
            value: function getVoices() {
                return [
                    new $9e9dcff382a34a4c$var$SpeechSynthesisVoice()
                ];
            }
        },
        {
            key: "pause",
            value: function pause() {
                throw new Error("pause is not implemented.");
            }
        },
        {
            key: "resume",
            value: function resume() {
                throw new Error("resume is not implemented.");
            }
        },
        {
            key: "speak",
            value: function speak(utterance) {
                utterance.dispatchEvent(new $9e9dcff382a34a4c$var$SpeechSynthesisEvent("start", utterance));
                utterance.dispatchEvent(new $9e9dcff382a34a4c$var$SpeechSynthesisEvent("end", utterance));
            }
        },
        {
            key: "onvoiceschanged",
            get: function get() {
                return (0, $9e9dcff382a34a4c$var$_es.getEventAttributeValue)(this, "voiceschanged");
            },
            set: function set(value) {
                (0, $9e9dcff382a34a4c$var$_es.setEventAttributeValue)(this, "voiceschanged", value);
            }
        }
    ]);
    return SpeechSynthesis;
}($9e9dcff382a34a4c$var$_es.default);
var $9e9dcff382a34a4c$var$speechSynthesis = new $9e9dcff382a34a4c$var$SpeechSynthesis();
module.exports.speechSynthesis = $9e9dcff382a34a4c$var$speechSynthesis;

});
parcelRequire.register("bgEWP", function(module, exports) {

var $hIXGI = parcelRequire("hIXGI");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $ge3FC = parcelRequire("ge3FC");

var $fD23L = parcelRequire("fD23L");

var $fuQvR = parcelRequire("fuQvR");

var $7YH1B = parcelRequire("7YH1B");

var $dXPTy = parcelRequire("dXPTy");

var $lSSVg = parcelRequire("lSSVg");

var $e9coA = parcelRequire("e9coA");

var $04PW7 = parcelRequire("04PW7");

var $c4FN3 = parcelRequire("c4FN3");

var $4zObc = parcelRequire("4zObc");

var $d6QOm = parcelRequire("d6QOm");

var $iOJLr = parcelRequire("iOJLr");
function $8340f3b7957f8d3d$var$_interopDefaultLegacy(e) {
    return e && typeof e === "object" && "default" in e ? e : {
        "default": e
    };
}
var $8340f3b7957f8d3d$var$_toConsumableArray__default = /*#__PURE__*/ $8340f3b7957f8d3d$var$_interopDefaultLegacy($ge3FC);
var $8340f3b7957f8d3d$var$_set__default = /*#__PURE__*/ $8340f3b7957f8d3d$var$_interopDefaultLegacy($fD23L);
var $8340f3b7957f8d3d$var$_get__default = /*#__PURE__*/ $8340f3b7957f8d3d$var$_interopDefaultLegacy($fuQvR);
var $8340f3b7957f8d3d$var$_assertThisInitialized__default = /*#__PURE__*/ $8340f3b7957f8d3d$var$_interopDefaultLegacy($7YH1B);
var $8340f3b7957f8d3d$var$_inherits__default = /*#__PURE__*/ $8340f3b7957f8d3d$var$_interopDefaultLegacy($dXPTy);
var $8340f3b7957f8d3d$var$_possibleConstructorReturn__default = /*#__PURE__*/ $8340f3b7957f8d3d$var$_interopDefaultLegacy($lSSVg);
var $8340f3b7957f8d3d$var$_getPrototypeOf__default = /*#__PURE__*/ $8340f3b7957f8d3d$var$_interopDefaultLegacy($e9coA);
var $8340f3b7957f8d3d$var$_wrapNativeSuper__default = /*#__PURE__*/ $8340f3b7957f8d3d$var$_interopDefaultLegacy($04PW7);
var $8340f3b7957f8d3d$var$_defineProperty__default = /*#__PURE__*/ $8340f3b7957f8d3d$var$_interopDefaultLegacy($c4FN3);
var $8340f3b7957f8d3d$var$_classCallCheck__default = /*#__PURE__*/ $8340f3b7957f8d3d$var$_interopDefaultLegacy($4zObc);
var $8340f3b7957f8d3d$var$_createClass__default = /*#__PURE__*/ $8340f3b7957f8d3d$var$_interopDefaultLegacy($d6QOm);
var $8340f3b7957f8d3d$var$_typeof__default = /*#__PURE__*/ $8340f3b7957f8d3d$var$_interopDefaultLegacy($iOJLr);
function $8340f3b7957f8d3d$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $8340f3b7957f8d3d$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $8340f3b7957f8d3d$var$_getPrototypeOf__default["default"](Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $8340f3b7957f8d3d$var$_getPrototypeOf__default["default"](this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $8340f3b7957f8d3d$var$_possibleConstructorReturn__default["default"](this, result);
    };
}
function $8340f3b7957f8d3d$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $8340f3b7957f8d3d$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $8340f3b7957f8d3d$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $8340f3b7957f8d3d$var$ownKeys(Object(source), true).forEach(function(key) {
            $8340f3b7957f8d3d$var$_defineProperty__default["default"](target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $8340f3b7957f8d3d$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
/**
 * Assert a condition.
 * @param condition The condition that it should satisfy.
 * @param message The error message.
 * @param args The arguments for replacing placeholders in the message.
 */ function $8340f3b7957f8d3d$var$assertType(condition, message) {
    if (!condition) {
        for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)args[_key - 2] = arguments[_key];
        throw new TypeError($8340f3b7957f8d3d$var$format(message, args));
    }
}
/**
 * Convert a text and arguments to one string.
 * @param message The formating text
 * @param args The arguments.
 */ function $8340f3b7957f8d3d$var$format(message, args) {
    var i = 0;
    return message.replace(/%[os]/g, function() {
        return $8340f3b7957f8d3d$var$anyToString(args[i++]);
    });
}
/**
 * Convert a value to a string representation.
 * @param x The value to get the string representation.
 */ function $8340f3b7957f8d3d$var$anyToString(x) {
    if ($8340f3b7957f8d3d$var$_typeof__default["default"](x) !== "object" || x === null) return String(x);
    return Object.prototype.toString.call(x);
}
var $8340f3b7957f8d3d$var$currentErrorHandler;
/**
 * Set the error handler.
 * @param value The error handler to set.
 */ function $8340f3b7957f8d3d$var$setErrorHandler(value) {
    $8340f3b7957f8d3d$var$assertType(typeof value === "function" || value === undefined, "The error handler must be a function or undefined, but got %o.", value);
    $8340f3b7957f8d3d$var$currentErrorHandler = value;
}
/**
 * Print a error message.
 * @param maybeError The error object.
 */ function $8340f3b7957f8d3d$var$reportError(maybeError) {
    try {
        var error = maybeError instanceof Error ? maybeError : new Error($8340f3b7957f8d3d$var$anyToString(maybeError)); // Call the user-defined error handler if exists.
        if ($8340f3b7957f8d3d$var$currentErrorHandler) {
            $8340f3b7957f8d3d$var$currentErrorHandler(error);
            return;
        } // Dispatch an `error` event if this is on a browser.
        if (typeof dispatchEvent === "function" && typeof ErrorEvent === "function") dispatchEvent(new ErrorEvent("error", {
            error: error,
            message: error.message
        }));
        else if (typeof $hIXGI !== "undefined" && typeof $hIXGI.emit === "function") {
            $hIXGI.emit("uncaughtException", error);
            return;
        } // Otherwise, print the error.
        console.error(error);
    } catch (_a) {}
}
/**
 * The global object.
 */ //istanbul ignore next
var $8340f3b7957f8d3d$var$Global = typeof window !== "undefined" ? window : typeof self !== "undefined" ? self : typeof $parcel$global !== "undefined" ? $parcel$global : typeof globalThis !== "undefined" ? globalThis : undefined;
var $8340f3b7957f8d3d$var$currentWarnHandler;
/**
 * Set the warning handler.
 * @param value The warning handler to set.
 */ function $8340f3b7957f8d3d$var$setWarningHandler(value) {
    $8340f3b7957f8d3d$var$assertType(typeof value === "function" || value === undefined, "The warning handler must be a function or undefined, but got %o.", value);
    $8340f3b7957f8d3d$var$currentWarnHandler = value;
}
/**
 * The warning information.
 */ var $8340f3b7957f8d3d$var$Warning = /*#__PURE__*/ function() {
    function Warning(code, message) {
        $8340f3b7957f8d3d$var$_classCallCheck__default["default"](this, Warning);
        this.code = code;
        this.message = message;
    }
    /**
   * Report this warning.
   * @param args The arguments of the warning.
   */ $8340f3b7957f8d3d$var$_createClass__default["default"](Warning, [
        {
            key: "warn",
            value: function warn() {
                var _a;
                try {
                    var _console;
                    for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
                    // Call the user-defined warning handler if exists.
                    if ($8340f3b7957f8d3d$var$currentWarnHandler) {
                        $8340f3b7957f8d3d$var$currentWarnHandler($8340f3b7957f8d3d$var$_objectSpread($8340f3b7957f8d3d$var$_objectSpread({}, this), {}, {
                            args: args
                        }));
                        return;
                    } // Otherwise, print the warning.
                    var stack = ((_a = new Error().stack) !== null && _a !== void 0 ? _a : "").replace(/^(?:(?:[\0-\t\x0B\f\x0E-\u2027\u202A-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])+?\n){2}/g, "\n");
                    (_console = console).warn.apply(_console, [
                        this.message
                    ].concat(args, [
                        stack
                    ]));
                } catch (_b) {}
            }
        }
    ]);
    return Warning;
}();
var $8340f3b7957f8d3d$var$InitEventWasCalledWhileDispatching = new $8340f3b7957f8d3d$var$Warning("W01", "Unable to initialize event under dispatching.");
var $8340f3b7957f8d3d$var$FalsyWasAssignedToCancelBubble = new $8340f3b7957f8d3d$var$Warning("W02", "Assigning any falsy value to 'cancelBubble' property has no effect.");
var $8340f3b7957f8d3d$var$TruthyWasAssignedToReturnValue = new $8340f3b7957f8d3d$var$Warning("W03", "Assigning any truthy value to 'returnValue' property has no effect.");
var $8340f3b7957f8d3d$var$NonCancelableEventWasCanceled = new $8340f3b7957f8d3d$var$Warning("W04", "Unable to preventDefault on non-cancelable events.");
var $8340f3b7957f8d3d$var$CanceledInPassiveListener = new $8340f3b7957f8d3d$var$Warning("W05", "Unable to preventDefault inside passive event listener invocation.");
var $8340f3b7957f8d3d$var$EventListenerWasDuplicated = new $8340f3b7957f8d3d$var$Warning("W06", "An event listener wasn't added because it has been added already: %o, %o");
var $8340f3b7957f8d3d$var$OptionWasIgnored = new $8340f3b7957f8d3d$var$Warning("W07", "The %o option value was abandoned because the event listener wasn't added as duplicated.");
var $8340f3b7957f8d3d$var$InvalidEventListener = new $8340f3b7957f8d3d$var$Warning("W08", "The 'callback' argument must be a function or an object that has 'handleEvent' method: %o");
var $8340f3b7957f8d3d$var$InvalidAttributeHandler = new $8340f3b7957f8d3d$var$Warning("W09", "Event attribute handler must be a function: %o");
/*eslint-disable class-methods-use-this */ /**
 * An implementation of `Event` interface, that wraps a given event object.
 * `EventTarget` shim can control the internal state of this `Event` objects.
 * @see https://dom.spec.whatwg.org/#event
 */ var $8340f3b7957f8d3d$var$Event = /*#__PURE__*/ function() {
    $8340f3b7957f8d3d$var$_createClass__default["default"](Event, null, [
        {
            key: "NONE",
            /**
     * @see https://dom.spec.whatwg.org/#dom-event-none
     */ get: function get() {
                return $8340f3b7957f8d3d$var$NONE;
            }
        },
        {
            key: "CAPTURING_PHASE",
            get: function get() {
                return $8340f3b7957f8d3d$var$CAPTURING_PHASE;
            }
        },
        {
            key: "AT_TARGET",
            get: function get() {
                return $8340f3b7957f8d3d$var$AT_TARGET;
            }
        },
        {
            key: "BUBBLING_PHASE",
            get: function get() {
                return $8340f3b7957f8d3d$var$BUBBLING_PHASE;
            }
        }
    ]);
    function Event(type, eventInitDict) {
        $8340f3b7957f8d3d$var$_classCallCheck__default["default"](this, Event);
        Object.defineProperty(this, "isTrusted", {
            value: false,
            enumerable: true
        });
        var opts = eventInitDict !== null && eventInitDict !== void 0 ? eventInitDict : {};
        $8340f3b7957f8d3d$var$internalDataMap.set(this, {
            type: String(type),
            bubbles: Boolean(opts.bubbles),
            cancelable: Boolean(opts.cancelable),
            composed: Boolean(opts.composed),
            target: null,
            currentTarget: null,
            stopPropagationFlag: false,
            stopImmediatePropagationFlag: false,
            canceledFlag: false,
            inPassiveListenerFlag: false,
            dispatchFlag: false,
            timeStamp: Date.now()
        });
    }
    /**
   * The type of this event.
   * @see https://dom.spec.whatwg.org/#dom-event-type
   */ $8340f3b7957f8d3d$var$_createClass__default["default"](Event, [
        {
            key: "composedPath",
            /**
     * The event target of the current dispatching.
     * This doesn't support node tree.
     * @see https://dom.spec.whatwg.org/#dom-event-composedpath
     */ value: function composedPath() {
                var currentTarget = $8340f3b7957f8d3d$var$$(this).currentTarget;
                if (currentTarget) return [
                    currentTarget
                ];
                return [];
            }
        },
        {
            key: "stopPropagation",
            /**
     * Stop event bubbling.
     * Because this shim doesn't support node tree, this merely changes the `cancelBubble` property value.
     * @see https://dom.spec.whatwg.org/#dom-event-stoppropagation
     */ value: function stopPropagation() {
                $8340f3b7957f8d3d$var$$(this).stopPropagationFlag = true;
            }
        },
        {
            key: "stopImmediatePropagation",
            /**
     * Stop event bubbling and subsequent event listener callings.
     * @see https://dom.spec.whatwg.org/#dom-event-stopimmediatepropagation
     */ value: function stopImmediatePropagation() {
                var data = $8340f3b7957f8d3d$var$$(this);
                data.stopPropagationFlag = data.stopImmediatePropagationFlag = true;
            }
        },
        {
            key: "preventDefault",
            /**
     * Cancel the default behavior.
     * @see https://dom.spec.whatwg.org/#dom-event-preventdefault
     */ value: function preventDefault() {
                $8340f3b7957f8d3d$var$setCancelFlag($8340f3b7957f8d3d$var$$(this));
            }
        },
        {
            key: "initEvent",
            /**
     * @deprecated Don't use this method. The constructor did initialization.
     */ value: function initEvent(type) {
                var bubbles = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
                var cancelable = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
                var data = $8340f3b7957f8d3d$var$$(this);
                if (data.dispatchFlag) {
                    $8340f3b7957f8d3d$var$InitEventWasCalledWhileDispatching.warn();
                    return;
                }
                $8340f3b7957f8d3d$var$internalDataMap.set(this, $8340f3b7957f8d3d$var$_objectSpread($8340f3b7957f8d3d$var$_objectSpread({}, data), {}, {
                    type: String(type),
                    bubbles: Boolean(bubbles),
                    cancelable: Boolean(cancelable),
                    target: null,
                    currentTarget: null,
                    stopPropagationFlag: false,
                    stopImmediatePropagationFlag: false,
                    canceledFlag: false
                }));
            }
        },
        {
            key: "type",
            get: function get() {
                return $8340f3b7957f8d3d$var$$(this).type;
            }
        },
        {
            key: "target",
            get: function get() {
                return $8340f3b7957f8d3d$var$$(this).target;
            }
        },
        {
            key: "srcElement",
            get: function get() {
                return $8340f3b7957f8d3d$var$$(this).target;
            }
        },
        {
            key: "currentTarget",
            get: function get() {
                return $8340f3b7957f8d3d$var$$(this).currentTarget;
            }
        },
        {
            key: "NONE",
            get: function get() {
                return $8340f3b7957f8d3d$var$NONE;
            }
        },
        {
            key: "CAPTURING_PHASE",
            get: function get() {
                return $8340f3b7957f8d3d$var$CAPTURING_PHASE;
            }
        },
        {
            key: "AT_TARGET",
            get: function get() {
                return $8340f3b7957f8d3d$var$AT_TARGET;
            }
        },
        {
            key: "BUBBLING_PHASE",
            get: function get() {
                return $8340f3b7957f8d3d$var$BUBBLING_PHASE;
            }
        },
        {
            key: "eventPhase",
            get: function get() {
                return $8340f3b7957f8d3d$var$$(this).dispatchFlag ? 2 : 0;
            }
        },
        {
            key: "cancelBubble",
            get: function get() {
                return $8340f3b7957f8d3d$var$$(this).stopPropagationFlag;
            },
            set: function set(value) {
                if (value) $8340f3b7957f8d3d$var$$(this).stopPropagationFlag = true;
                else $8340f3b7957f8d3d$var$FalsyWasAssignedToCancelBubble.warn();
            }
        },
        {
            key: "bubbles",
            get: function get() {
                return $8340f3b7957f8d3d$var$$(this).bubbles;
            }
        },
        {
            key: "cancelable",
            get: function get() {
                return $8340f3b7957f8d3d$var$$(this).cancelable;
            }
        },
        {
            key: "returnValue",
            get: function get() {
                return !$8340f3b7957f8d3d$var$$(this).canceledFlag;
            },
            set: function set(value) {
                if (!value) $8340f3b7957f8d3d$var$setCancelFlag($8340f3b7957f8d3d$var$$(this));
                else $8340f3b7957f8d3d$var$TruthyWasAssignedToReturnValue.warn();
            }
        },
        {
            key: "defaultPrevented",
            get: function get() {
                return $8340f3b7957f8d3d$var$$(this).canceledFlag;
            }
        },
        {
            key: "composed",
            get: function get() {
                return $8340f3b7957f8d3d$var$$(this).composed;
            }
        },
        {
            key: "isTrusted",
            get: function get() {
                return false;
            }
        },
        {
            key: "timeStamp",
            get: function get() {
                return $8340f3b7957f8d3d$var$$(this).timeStamp;
            }
        }
    ]);
    return Event;
}(); //------------------------------------------------------------------------------
// Helpers
//------------------------------------------------------------------------------
var $8340f3b7957f8d3d$var$NONE = 0;
var $8340f3b7957f8d3d$var$CAPTURING_PHASE = 1;
var $8340f3b7957f8d3d$var$AT_TARGET = 2;
var $8340f3b7957f8d3d$var$BUBBLING_PHASE = 3;
/**
 * Private data for event wrappers.
 */ var $8340f3b7957f8d3d$var$internalDataMap = new WeakMap();
/**
 * Get private data.
 * @param event The event object to get private data.
 * @param name The variable name to report.
 * @returns The private data of the event.
 */ function $8340f3b7957f8d3d$var$$(event) {
    var name = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "this";
    var retv = $8340f3b7957f8d3d$var$internalDataMap.get(event);
    $8340f3b7957f8d3d$var$assertType(retv != null, "'%s' must be an object that Event constructor created, but got another one: %o", name, event);
    return retv;
}
/**
 * https://dom.spec.whatwg.org/#set-the-canceled-flag
 * @param data private data.
 */ function $8340f3b7957f8d3d$var$setCancelFlag(data) {
    if (data.inPassiveListenerFlag) {
        $8340f3b7957f8d3d$var$CanceledInPassiveListener.warn();
        return;
    }
    if (!data.cancelable) {
        $8340f3b7957f8d3d$var$NonCancelableEventWasCanceled.warn();
        return;
    }
    data.canceledFlag = true;
} // Set enumerable
Object.defineProperty($8340f3b7957f8d3d$var$Event, "NONE", {
    enumerable: true
});
Object.defineProperty($8340f3b7957f8d3d$var$Event, "CAPTURING_PHASE", {
    enumerable: true
});
Object.defineProperty($8340f3b7957f8d3d$var$Event, "AT_TARGET", {
    enumerable: true
});
Object.defineProperty($8340f3b7957f8d3d$var$Event, "BUBBLING_PHASE", {
    enumerable: true
});
var $8340f3b7957f8d3d$var$keys = Object.getOwnPropertyNames($8340f3b7957f8d3d$var$Event.prototype);
for(var $8340f3b7957f8d3d$var$i = 0; $8340f3b7957f8d3d$var$i < $8340f3b7957f8d3d$var$keys.length; ++$8340f3b7957f8d3d$var$i){
    if ($8340f3b7957f8d3d$var$keys[$8340f3b7957f8d3d$var$i] === "constructor") continue;
    Object.defineProperty($8340f3b7957f8d3d$var$Event.prototype, $8340f3b7957f8d3d$var$keys[$8340f3b7957f8d3d$var$i], {
        enumerable: true
    });
} // Ensure `event instanceof window.Event` is `true`.
if (typeof $8340f3b7957f8d3d$var$Global !== "undefined" && typeof $8340f3b7957f8d3d$var$Global.Event !== "undefined") Object.setPrototypeOf($8340f3b7957f8d3d$var$Event.prototype, $8340f3b7957f8d3d$var$Global.Event.prototype);
/**
 * Create a new InvalidStateError instance.
 * @param message The error message.
 */ function $8340f3b7957f8d3d$var$createInvalidStateError(message) {
    if ($8340f3b7957f8d3d$var$Global.DOMException) return new $8340f3b7957f8d3d$var$Global.DOMException(message, "InvalidStateError");
    if ($8340f3b7957f8d3d$var$DOMException == null) {
        $8340f3b7957f8d3d$var$DOMException = /*#__PURE__*/ function(_Error) {
            $8340f3b7957f8d3d$var$_inherits__default["default"](DOMException, _Error);
            var _super = $8340f3b7957f8d3d$var$_createSuper(DOMException);
            function DOMException(msg) {
                var _this;
                $8340f3b7957f8d3d$var$_classCallCheck__default["default"](this, DOMException);
                _this = _super.call(this, msg);
                if (Error.captureStackTrace) Error.captureStackTrace($8340f3b7957f8d3d$var$_assertThisInitialized__default["default"](_this), DOMException);
                return _this;
            } // eslint-disable-next-line class-methods-use-this
            $8340f3b7957f8d3d$var$_createClass__default["default"](DOMException, [
                {
                    key: "code",
                    get: function get() {
                        return 11;
                    } // eslint-disable-next-line class-methods-use-this
                },
                {
                    key: "name",
                    get: function get() {
                        return "InvalidStateError";
                    }
                }
            ]);
            return DOMException;
        }(/*#__PURE__*/ $8340f3b7957f8d3d$var$_wrapNativeSuper__default["default"](Error));
        Object.defineProperties($8340f3b7957f8d3d$var$DOMException.prototype, {
            code: {
                enumerable: true
            },
            name: {
                enumerable: true
            }
        });
        $8340f3b7957f8d3d$var$defineErrorCodeProperties($8340f3b7957f8d3d$var$DOMException);
        $8340f3b7957f8d3d$var$defineErrorCodeProperties($8340f3b7957f8d3d$var$DOMException.prototype);
    }
    return new $8340f3b7957f8d3d$var$DOMException(message);
} //------------------------------------------------------------------------------
// Helpers
//------------------------------------------------------------------------------
var $8340f3b7957f8d3d$var$DOMException;
var $8340f3b7957f8d3d$var$ErrorCodeMap = {
    INDEX_SIZE_ERR: 1,
    DOMSTRING_SIZE_ERR: 2,
    HIERARCHY_REQUEST_ERR: 3,
    WRONG_DOCUMENT_ERR: 4,
    INVALID_CHARACTER_ERR: 5,
    NO_DATA_ALLOWED_ERR: 6,
    NO_MODIFICATION_ALLOWED_ERR: 7,
    NOT_FOUND_ERR: 8,
    NOT_SUPPORTED_ERR: 9,
    INUSE_ATTRIBUTE_ERR: 10,
    INVALID_STATE_ERR: 11,
    SYNTAX_ERR: 12,
    INVALID_MODIFICATION_ERR: 13,
    NAMESPACE_ERR: 14,
    INVALID_ACCESS_ERR: 15,
    VALIDATION_ERR: 16,
    TYPE_MISMATCH_ERR: 17,
    SECURITY_ERR: 18,
    NETWORK_ERR: 19,
    ABORT_ERR: 20,
    URL_MISMATCH_ERR: 21,
    QUOTA_EXCEEDED_ERR: 22,
    TIMEOUT_ERR: 23,
    INVALID_NODE_TYPE_ERR: 24,
    DATA_CLONE_ERR: 25
};
function $8340f3b7957f8d3d$var$defineErrorCodeProperties(obj) {
    var keys = Object.keys($8340f3b7957f8d3d$var$ErrorCodeMap);
    var _loop = function _loop(_i) {
        var key = keys[_i];
        var value = $8340f3b7957f8d3d$var$ErrorCodeMap[key];
        Object.defineProperty(obj, key, {
            get: function get() {
                return value;
            },
            configurable: true,
            enumerable: true
        });
    };
    for(var _i = 0; _i < keys.length; ++_i)_loop(_i);
}
/**
 * An implementation of `Event` interface, that wraps a given event object.
 * This class controls the internal state of `Event`.
 * @see https://dom.spec.whatwg.org/#interface-event
 */ var $8340f3b7957f8d3d$var$EventWrapper = /*#__PURE__*/ function(_Event) {
    $8340f3b7957f8d3d$var$_inherits__default["default"](EventWrapper, _Event);
    var _super2 = $8340f3b7957f8d3d$var$_createSuper(EventWrapper);
    $8340f3b7957f8d3d$var$_createClass__default["default"](EventWrapper, null, [
        {
            key: "wrap",
            /**
     * Wrap a given event object to control states.
     * @param event The event-like object to wrap.
     */ value: function wrap(event) {
                return new ($8340f3b7957f8d3d$var$getWrapperClassOf(event))(event);
            }
        }
    ]);
    function EventWrapper(event) {
        var _thisSuper, _thisSuper2, _this2;
        $8340f3b7957f8d3d$var$_classCallCheck__default["default"](this, EventWrapper);
        _this2 = _super2.call(this, event.type, {
            bubbles: event.bubbles,
            cancelable: event.cancelable,
            composed: event.composed
        });
        if (event.cancelBubble) $8340f3b7957f8d3d$var$_get__default["default"]((_thisSuper = $8340f3b7957f8d3d$var$_assertThisInitialized__default["default"](_this2), $8340f3b7957f8d3d$var$_getPrototypeOf__default["default"](EventWrapper.prototype)), "stopPropagation", _thisSuper).call(_thisSuper);
        if (event.defaultPrevented) $8340f3b7957f8d3d$var$_get__default["default"]((_thisSuper2 = $8340f3b7957f8d3d$var$_assertThisInitialized__default["default"](_this2), $8340f3b7957f8d3d$var$_getPrototypeOf__default["default"](EventWrapper.prototype)), "preventDefault", _thisSuper2).call(_thisSuper2);
        $8340f3b7957f8d3d$var$internalDataMap$1.set($8340f3b7957f8d3d$var$_assertThisInitialized__default["default"](_this2), {
            original: event
        }); // Define accessors
        var keys = Object.keys(event);
        for(var _i2 = 0; _i2 < keys.length; ++_i2){
            var key = keys[_i2];
            if (!(key in $8340f3b7957f8d3d$var$_assertThisInitialized__default["default"](_this2))) Object.defineProperty($8340f3b7957f8d3d$var$_assertThisInitialized__default["default"](_this2), key, $8340f3b7957f8d3d$var$defineRedirectDescriptor(event, key));
        }
        return _this2;
    }
    $8340f3b7957f8d3d$var$_createClass__default["default"](EventWrapper, [
        {
            key: "stopPropagation",
            value: function stopPropagation() {
                $8340f3b7957f8d3d$var$_get__default["default"]($8340f3b7957f8d3d$var$_getPrototypeOf__default["default"](EventWrapper.prototype), "stopPropagation", this).call(this);
                var _$$ = $8340f3b7957f8d3d$var$$$1(this), original = _$$.original;
                if ("stopPropagation" in original) original.stopPropagation();
            }
        },
        {
            key: "stopImmediatePropagation",
            value: function stopImmediatePropagation() {
                $8340f3b7957f8d3d$var$_get__default["default"]($8340f3b7957f8d3d$var$_getPrototypeOf__default["default"](EventWrapper.prototype), "stopImmediatePropagation", this).call(this);
                var _$$2 = $8340f3b7957f8d3d$var$$$1(this), original = _$$2.original;
                if ("stopImmediatePropagation" in original) original.stopImmediatePropagation();
            }
        },
        {
            key: "preventDefault",
            value: function preventDefault() {
                $8340f3b7957f8d3d$var$_get__default["default"]($8340f3b7957f8d3d$var$_getPrototypeOf__default["default"](EventWrapper.prototype), "preventDefault", this).call(this);
                var _$$3 = $8340f3b7957f8d3d$var$$$1(this), original = _$$3.original;
                if ("preventDefault" in original) original.preventDefault();
            }
        },
        {
            key: "cancelBubble",
            get: function get() {
                return $8340f3b7957f8d3d$var$_get__default["default"]($8340f3b7957f8d3d$var$_getPrototypeOf__default["default"](EventWrapper.prototype), "cancelBubble", this);
            },
            set: function set(value) {
                $8340f3b7957f8d3d$var$_set__default["default"]($8340f3b7957f8d3d$var$_getPrototypeOf__default["default"](EventWrapper.prototype), "cancelBubble", value, this, true);
                var _$$4 = $8340f3b7957f8d3d$var$$$1(this), original = _$$4.original;
                if ("cancelBubble" in original) original.cancelBubble = value;
            }
        },
        {
            key: "returnValue",
            get: function get() {
                return $8340f3b7957f8d3d$var$_get__default["default"]($8340f3b7957f8d3d$var$_getPrototypeOf__default["default"](EventWrapper.prototype), "returnValue", this);
            },
            set: function set(value) {
                $8340f3b7957f8d3d$var$_set__default["default"]($8340f3b7957f8d3d$var$_getPrototypeOf__default["default"](EventWrapper.prototype), "returnValue", value, this, true);
                var _$$5 = $8340f3b7957f8d3d$var$$$1(this), original = _$$5.original;
                if ("returnValue" in original) original.returnValue = value;
            }
        },
        {
            key: "timeStamp",
            get: function get() {
                var _$$6 = $8340f3b7957f8d3d$var$$$1(this), original = _$$6.original;
                if ("timeStamp" in original) return original.timeStamp;
                return $8340f3b7957f8d3d$var$_get__default["default"]($8340f3b7957f8d3d$var$_getPrototypeOf__default["default"](EventWrapper.prototype), "timeStamp", this);
            }
        }
    ]);
    return EventWrapper;
}($8340f3b7957f8d3d$var$Event);
/**
 * Private data for event wrappers.
 */ var $8340f3b7957f8d3d$var$internalDataMap$1 = new WeakMap();
/**
 * Get private data.
 * @param event The event object to get private data.
 * @returns The private data of the event.
 */ function $8340f3b7957f8d3d$var$$$1(event) {
    var retv = $8340f3b7957f8d3d$var$internalDataMap$1.get(event);
    $8340f3b7957f8d3d$var$assertType(retv != null, "'this' is expected an Event object, but got", event);
    return retv;
}
/**
 * Cache for wrapper classes.
 * @type {WeakMap<Object, Function>}
 * @private
 */ var $8340f3b7957f8d3d$var$wrapperClassCache = new WeakMap(); // Make association for wrappers.
$8340f3b7957f8d3d$var$wrapperClassCache.set(Object.prototype, $8340f3b7957f8d3d$var$EventWrapper);
if (typeof $8340f3b7957f8d3d$var$Global !== "undefined" && typeof $8340f3b7957f8d3d$var$Global.Event !== "undefined") $8340f3b7957f8d3d$var$wrapperClassCache.set($8340f3b7957f8d3d$var$Global.Event.prototype, $8340f3b7957f8d3d$var$EventWrapper);
/**
 * Get the wrapper class of a given prototype.
 * @param originalEvent The event object to wrap.
 */ function $8340f3b7957f8d3d$var$getWrapperClassOf(originalEvent) {
    var prototype = Object.getPrototypeOf(originalEvent);
    if (prototype == null) return $8340f3b7957f8d3d$var$EventWrapper;
    var wrapper = $8340f3b7957f8d3d$var$wrapperClassCache.get(prototype);
    if (wrapper == null) {
        wrapper = $8340f3b7957f8d3d$var$defineWrapper($8340f3b7957f8d3d$var$getWrapperClassOf(prototype), prototype);
        $8340f3b7957f8d3d$var$wrapperClassCache.set(prototype, wrapper);
    }
    return wrapper;
}
/**
 * Define new wrapper class.
 * @param BaseEventWrapper The base wrapper class.
 * @param originalPrototype The prototype of the original event.
 */ function $8340f3b7957f8d3d$var$defineWrapper(BaseEventWrapper, originalPrototype) {
    var CustomEventWrapper = /*#__PURE__*/ function(_BaseEventWrapper) {
        $8340f3b7957f8d3d$var$_inherits__default["default"](CustomEventWrapper, _BaseEventWrapper);
        var _super3 = $8340f3b7957f8d3d$var$_createSuper(CustomEventWrapper);
        function CustomEventWrapper() {
            $8340f3b7957f8d3d$var$_classCallCheck__default["default"](this, CustomEventWrapper);
            return _super3.apply(this, arguments);
        }
        return CustomEventWrapper;
    }(BaseEventWrapper);
    var keys = Object.keys(originalPrototype);
    for(var _i3 = 0; _i3 < keys.length; ++_i3)Object.defineProperty(CustomEventWrapper.prototype, keys[_i3], $8340f3b7957f8d3d$var$defineRedirectDescriptor(originalPrototype, keys[_i3]));
    return CustomEventWrapper;
}
/**
 * Get the property descriptor to redirect a given property.
 */ function $8340f3b7957f8d3d$var$defineRedirectDescriptor(obj, key) {
    var d = Object.getOwnPropertyDescriptor(obj, key);
    return {
        get: function get() {
            var original = $8340f3b7957f8d3d$var$$$1(this).original;
            var value = original[key];
            if (typeof value === "function") return value.bind(original);
            return value;
        },
        set: function set(value) {
            var original = $8340f3b7957f8d3d$var$$$1(this).original;
            original[key] = value;
        },
        configurable: d.configurable,
        enumerable: d.enumerable
    };
}
/**
 * Create a new listener.
 * @param callback The callback function.
 * @param capture The capture flag.
 * @param passive The passive flag.
 * @param once The once flag.
 * @param signal The abort signal.
 * @param signalListener The abort event listener for the abort signal.
 */ function $8340f3b7957f8d3d$var$createListener(callback, capture, passive, once, signal, signalListener) {
    return {
        callback: callback,
        flags: (capture ? 1 : 0) | (passive ? 2 : 0) | (once ? 4 : 0),
        signal: signal,
        signalListener: signalListener
    };
}
/**
 * Set the `removed` flag to the given listener.
 * @param listener The listener to check.
 */ function $8340f3b7957f8d3d$var$setRemoved(listener) {
    listener.flags |= 8 /* Removed */ ;
}
/**
 * Check if the given listener has the `capture` flag or not.
 * @param listener The listener to check.
 */ function $8340f3b7957f8d3d$var$isCapture(listener) {
    return (listener.flags & 1) === 1 /* Capture */ ;
}
/**
 * Check if the given listener has the `passive` flag or not.
 * @param listener The listener to check.
 */ function $8340f3b7957f8d3d$var$isPassive(listener) {
    return (listener.flags & 2) === 2 /* Passive */ ;
}
/**
 * Check if the given listener has the `once` flag or not.
 * @param listener The listener to check.
 */ function $8340f3b7957f8d3d$var$isOnce(listener) {
    return (listener.flags & 4) === 4 /* Once */ ;
}
/**
 * Check if the given listener has the `removed` flag or not.
 * @param listener The listener to check.
 */ function $8340f3b7957f8d3d$var$isRemoved(listener) {
    return (listener.flags & 8) === 8 /* Removed */ ;
}
/**
 * Call an event listener.
 * @param listener The listener to call.
 * @param target The event target object for `thisArg`.
 * @param event The event object for the first argument.
 * @param attribute `true` if this callback is an event attribute handler.
 */ function $8340f3b7957f8d3d$var$invokeCallback(_ref, target, event) {
    var callback = _ref.callback;
    try {
        if (typeof callback === "function") callback.call(target, event);
        else if (typeof callback.handleEvent === "function") callback.handleEvent(event);
    } catch (thrownError) {
        $8340f3b7957f8d3d$var$reportError(thrownError);
    }
}
/**
 * Find the index of given listener.
 * This returns `-1` if not found.
 * @param list The listener list.
 * @param callback The callback function to find.
 * @param capture The capture flag to find.
 */ function $8340f3b7957f8d3d$var$findIndexOfListener(_ref2, callback, capture) {
    var listeners = _ref2.listeners;
    for(var _i4 = 0; _i4 < listeners.length; ++_i4){
        if (listeners[_i4].callback === callback && $8340f3b7957f8d3d$var$isCapture(listeners[_i4]) === capture) return _i4;
    }
    return -1;
}
/**
 * Add the given listener.
 * Does copy-on-write if needed.
 * @param list The listener list.
 * @param callback The callback function.
 * @param capture The capture flag.
 * @param passive The passive flag.
 * @param once The once flag.
 * @param signal The abort signal.
 */ function $8340f3b7957f8d3d$var$addListener(list, callback, capture, passive, once, signal) {
    var signalListener;
    if (signal) {
        signalListener = $8340f3b7957f8d3d$var$removeListener.bind(null, list, callback, capture);
        signal.addEventListener("abort", signalListener);
    }
    var listener = $8340f3b7957f8d3d$var$createListener(callback, capture, passive, once, signal, signalListener);
    if (list.cow) {
        list.cow = false;
        list.listeners = [].concat($8340f3b7957f8d3d$var$_toConsumableArray__default["default"](list.listeners), [
            listener
        ]);
    } else list.listeners.push(listener);
    return listener;
}
/**
 * Remove a listener.
 * @param list The listener list.
 * @param callback The callback function to find.
 * @param capture The capture flag to find.
 * @returns `true` if it mutated the list directly.
 */ function $8340f3b7957f8d3d$var$removeListener(list, callback, capture) {
    var index = $8340f3b7957f8d3d$var$findIndexOfListener(list, callback, capture);
    if (index !== -1) return $8340f3b7957f8d3d$var$removeListenerAt(list, index);
    return false;
}
/**
 * Remove a listener.
 * @param list The listener list.
 * @param index The index of the target listener.
 * @param disableCow Disable copy-on-write if true.
 * @returns `true` if it mutated the `listeners` array directly.
 */ function $8340f3b7957f8d3d$var$removeListenerAt(list, index) {
    var disableCow = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var listener = list.listeners[index]; // Set the removed flag.
    $8340f3b7957f8d3d$var$setRemoved(listener); // Dispose the abort signal listener if exists.
    if (listener.signal) listener.signal.removeEventListener("abort", listener.signalListener);
     // Remove it from the array.
    if (list.cow && !disableCow) {
        list.cow = false;
        list.listeners = list.listeners.filter(function(_, i) {
            return i !== index;
        });
        return false;
    }
    list.listeners.splice(index, 1);
    return true;
}
/**
 * Create a new `ListenerListMap` object.
 */ function $8340f3b7957f8d3d$var$createListenerListMap() {
    return Object.create(null);
}
/**
 * Get the listener list of the given type.
 * If the listener list has not been initialized, initialize and return it.
 * @param listenerMap The listener list map.
 * @param type The event type to get.
 */ function $8340f3b7957f8d3d$var$ensureListenerList(listenerMap, type) {
    var _a;
    return (_a = listenerMap[type]) !== null && _a !== void 0 ? _a : listenerMap[type] = {
        attrCallback: undefined,
        attrListener: undefined,
        cow: false,
        listeners: []
    };
}
/**
 * An implementation of the `EventTarget` interface.
 * @see https://dom.spec.whatwg.org/#eventtarget
 */ var $8340f3b7957f8d3d$var$EventTarget = /*#__PURE__*/ function() {
    /**
   * Initialize this instance.
   */ function EventTarget() {
        $8340f3b7957f8d3d$var$_classCallCheck__default["default"](this, EventTarget);
        $8340f3b7957f8d3d$var$internalDataMap$2.set(this, $8340f3b7957f8d3d$var$createListenerListMap());
    } // Implementation
    $8340f3b7957f8d3d$var$_createClass__default["default"](EventTarget, [
        {
            key: "addEventListener",
            value: function addEventListener(type0, callback0, options0) {
                var listenerMap = $8340f3b7957f8d3d$var$$$2(this);
                var _normalizeAddOptions = $8340f3b7957f8d3d$var$normalizeAddOptions(type0, callback0, options0), callback = _normalizeAddOptions.callback, capture = _normalizeAddOptions.capture, once = _normalizeAddOptions.once, passive = _normalizeAddOptions.passive, signal = _normalizeAddOptions.signal, type = _normalizeAddOptions.type;
                if (callback == null || (signal === null || signal === void 0 ? void 0 : signal.aborted)) return;
                var list = $8340f3b7957f8d3d$var$ensureListenerList(listenerMap, type); // Find existing listener.
                var i = $8340f3b7957f8d3d$var$findIndexOfListener(list, callback, capture);
                if (i !== -1) {
                    $8340f3b7957f8d3d$var$warnDuplicate(list.listeners[i], passive, once, signal);
                    return;
                } // Add the new listener.
                $8340f3b7957f8d3d$var$addListener(list, callback, capture, passive, once, signal);
            } // Implementation
        },
        {
            key: "removeEventListener",
            value: function removeEventListener(type0, callback0, options0) {
                var listenerMap = $8340f3b7957f8d3d$var$$$2(this);
                var _normalizeOptions = $8340f3b7957f8d3d$var$normalizeOptions(type0, callback0, options0), callback = _normalizeOptions.callback, capture = _normalizeOptions.capture, type = _normalizeOptions.type;
                var list = listenerMap[type];
                if (callback != null && list) $8340f3b7957f8d3d$var$removeListener(list, callback, capture);
            } // Implementation
        },
        {
            key: "dispatchEvent",
            value: function dispatchEvent1(e) {
                var list = $8340f3b7957f8d3d$var$$$2(this)[String(e.type)];
                if (list == null) return true;
                var event = e instanceof $8340f3b7957f8d3d$var$Event ? e : $8340f3b7957f8d3d$var$EventWrapper.wrap(e);
                var eventData = $8340f3b7957f8d3d$var$$(event, "event");
                if (eventData.dispatchFlag) throw $8340f3b7957f8d3d$var$createInvalidStateError("This event has been in dispatching.");
                eventData.dispatchFlag = true;
                eventData.target = eventData.currentTarget = this;
                if (!eventData.stopPropagationFlag) {
                    var cow = list.cow, listeners = list.listeners; // Set copy-on-write flag.
                    list.cow = true; // Call listeners.
                    for(var _i5 = 0; _i5 < listeners.length; ++_i5){
                        var listener = listeners[_i5]; // Skip if removed.
                        if ($8340f3b7957f8d3d$var$isRemoved(listener)) continue;
                         // Remove this listener if has the `once` flag.
                        if ($8340f3b7957f8d3d$var$isOnce(listener) && $8340f3b7957f8d3d$var$removeListenerAt(list, _i5, !cow)) // Because this listener was removed, the next index is the
                        // same as the current value.
                        _i5 -= 1;
                         // Call this listener with the `passive` flag.
                        eventData.inPassiveListenerFlag = $8340f3b7957f8d3d$var$isPassive(listener);
                        $8340f3b7957f8d3d$var$invokeCallback(listener, this, event);
                        eventData.inPassiveListenerFlag = false; // Stop if the `event.stopImmediatePropagation()` method was called.
                        if (eventData.stopImmediatePropagationFlag) break;
                    } // Restore copy-on-write flag.
                    if (!cow) list.cow = false;
                }
                eventData.target = null;
                eventData.currentTarget = null;
                eventData.stopImmediatePropagationFlag = false;
                eventData.stopPropagationFlag = false;
                eventData.dispatchFlag = false;
                return !eventData.canceledFlag;
            }
        }
    ]);
    return EventTarget;
}();
/**
 * Internal data.
 */ var $8340f3b7957f8d3d$var$internalDataMap$2 = new WeakMap();
/**
 * Get private data.
 * @param target The event target object to get private data.
 * @param name The variable name to report.
 * @returns The private data of the event.
 */ function $8340f3b7957f8d3d$var$$$2(target) {
    var name = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "this";
    var retv = $8340f3b7957f8d3d$var$internalDataMap$2.get(target);
    $8340f3b7957f8d3d$var$assertType(retv != null, "'%s' must be an object that EventTarget constructor created, but got another one: %o", name, target);
    return retv;
}
/**
 * Normalize options.
 * @param options The options to normalize.
 */ function $8340f3b7957f8d3d$var$normalizeAddOptions(type, callback, options) {
    var _a;
    $8340f3b7957f8d3d$var$assertCallback(callback);
    if ($8340f3b7957f8d3d$var$_typeof__default["default"](options) === "object" && options !== null) return {
        type: String(type),
        callback: callback !== null && callback !== void 0 ? callback : undefined,
        capture: Boolean(options.capture),
        passive: Boolean(options.passive),
        once: Boolean(options.once),
        signal: (_a = options.signal) !== null && _a !== void 0 ? _a : undefined
    };
    return {
        type: String(type),
        callback: callback !== null && callback !== void 0 ? callback : undefined,
        capture: Boolean(options),
        passive: false,
        once: false,
        signal: undefined
    };
}
/**
 * Normalize options.
 * @param options The options to normalize.
 */ function $8340f3b7957f8d3d$var$normalizeOptions(type, callback, options) {
    $8340f3b7957f8d3d$var$assertCallback(callback);
    if ($8340f3b7957f8d3d$var$_typeof__default["default"](options) === "object" && options !== null) return {
        type: String(type),
        callback: callback !== null && callback !== void 0 ? callback : undefined,
        capture: Boolean(options.capture)
    };
    return {
        type: String(type),
        callback: callback !== null && callback !== void 0 ? callback : undefined,
        capture: Boolean(options)
    };
}
/**
 * Assert the type of 'callback' argument.
 * @param callback The callback to check.
 */ function $8340f3b7957f8d3d$var$assertCallback(callback) {
    if (typeof callback === "function" || $8340f3b7957f8d3d$var$_typeof__default["default"](callback) === "object" && callback !== null && typeof callback.handleEvent === "function") return;
    if (callback == null || $8340f3b7957f8d3d$var$_typeof__default["default"](callback) === "object") {
        $8340f3b7957f8d3d$var$InvalidEventListener.warn(callback);
        return;
    }
    throw new TypeError($8340f3b7957f8d3d$var$format($8340f3b7957f8d3d$var$InvalidEventListener.message, [
        callback
    ]));
}
/**
 * Print warning for duplicated.
 * @param listener The current listener that is duplicated.
 * @param passive The passive flag of the new duplicated listener.
 * @param once The once flag of the new duplicated listener.
 * @param signal The signal object of the new duplicated listener.
 */ function $8340f3b7957f8d3d$var$warnDuplicate(listener, passive, once, signal) {
    $8340f3b7957f8d3d$var$EventListenerWasDuplicated.warn($8340f3b7957f8d3d$var$isCapture(listener) ? "capture" : "bubble", listener.callback);
    if ($8340f3b7957f8d3d$var$isPassive(listener) !== passive) $8340f3b7957f8d3d$var$OptionWasIgnored.warn("passive");
    if ($8340f3b7957f8d3d$var$isOnce(listener) !== once) $8340f3b7957f8d3d$var$OptionWasIgnored.warn("once");
    if (listener.signal !== signal) $8340f3b7957f8d3d$var$OptionWasIgnored.warn("signal");
} // Set enumerable
var $8340f3b7957f8d3d$var$keys$1 = Object.getOwnPropertyNames($8340f3b7957f8d3d$var$EventTarget.prototype);
for(var $8340f3b7957f8d3d$var$_i6 = 0; $8340f3b7957f8d3d$var$_i6 < $8340f3b7957f8d3d$var$keys$1.length; ++$8340f3b7957f8d3d$var$_i6){
    if ($8340f3b7957f8d3d$var$keys$1[$8340f3b7957f8d3d$var$_i6] === "constructor") continue;
    Object.defineProperty($8340f3b7957f8d3d$var$EventTarget.prototype, $8340f3b7957f8d3d$var$keys$1[$8340f3b7957f8d3d$var$_i6], {
        enumerable: true
    });
} // Ensure `eventTarget instanceof window.EventTarget` is `true`.
if (typeof $8340f3b7957f8d3d$var$Global !== "undefined" && typeof $8340f3b7957f8d3d$var$Global.EventTarget !== "undefined") Object.setPrototypeOf($8340f3b7957f8d3d$var$EventTarget.prototype, $8340f3b7957f8d3d$var$Global.EventTarget.prototype);
/**
 * Get the current value of a given event attribute.
 * @param target The `EventTarget` object to get.
 * @param type The event type.
 */ function $8340f3b7957f8d3d$var$getEventAttributeValue(target, type) {
    var _a, _b;
    var listMap = $8340f3b7957f8d3d$var$$$2(target, "target");
    return (_b = (_a = listMap[type]) === null || _a === void 0 ? void 0 : _a.attrCallback) !== null && _b !== void 0 ? _b : null;
}
/**
 * Set an event listener to a given event attribute.
 * @param target The `EventTarget` object to set.
 * @param type The event type.
 * @param callback The event listener.
 */ function $8340f3b7957f8d3d$var$setEventAttributeValue(target, type, callback) {
    if (callback != null && typeof callback !== "function") $8340f3b7957f8d3d$var$InvalidAttributeHandler.warn(callback);
    if (typeof callback === "function" || $8340f3b7957f8d3d$var$_typeof__default["default"](callback) === "object" && callback !== null) $8340f3b7957f8d3d$var$upsertEventAttributeListener(target, type, callback);
    else $8340f3b7957f8d3d$var$removeEventAttributeListener(target, type);
} //------------------------------------------------------------------------------
// Helpers
//------------------------------------------------------------------------------
/**
 * Update or insert the given event attribute handler.
 * @param target The `EventTarget` object to set.
 * @param type The event type.
 * @param callback The event listener.
 */ function $8340f3b7957f8d3d$var$upsertEventAttributeListener(target, type, callback) {
    var list = $8340f3b7957f8d3d$var$ensureListenerList($8340f3b7957f8d3d$var$$$2(target, "target"), String(type));
    list.attrCallback = callback;
    if (list.attrListener == null) list.attrListener = $8340f3b7957f8d3d$var$addListener(list, $8340f3b7957f8d3d$var$defineEventAttributeCallback(list), false, false, false, undefined);
}
/**
 * Remove the given event attribute handler.
 * @param target The `EventTarget` object to remove.
 * @param type The event type.
 * @param callback The event listener.
 */ function $8340f3b7957f8d3d$var$removeEventAttributeListener(target, type) {
    var listMap = $8340f3b7957f8d3d$var$$$2(target, "target");
    var list = listMap[String(type)];
    if (list && list.attrListener) {
        $8340f3b7957f8d3d$var$removeListener(list, list.attrListener.callback, false);
        list.attrCallback = list.attrListener = undefined;
    }
}
/**
 * Define the callback function for the given listener list object.
 * It calls `attrCallback` property if the property value is a function.
 * @param list The `ListenerList` object.
 */ function $8340f3b7957f8d3d$var$defineEventAttributeCallback(list) {
    return function(event) {
        var callback = list.attrCallback;
        if (typeof callback === "function") callback.call(this, event);
    };
}
/**
 * Define an `EventTarget` class that has event attibutes.
 * @param types The types to define event attributes.
 * @deprecated Use `getEventAttributeValue`/`setEventAttributeValue` pair on your derived class instead because of static analysis friendly.
 */ function $8340f3b7957f8d3d$var$defineCustomEventTarget() {
    var CustomEventTarget = /*#__PURE__*/ function(_EventTarget) {
        $8340f3b7957f8d3d$var$_inherits__default["default"](CustomEventTarget, _EventTarget);
        var _super4 = $8340f3b7957f8d3d$var$_createSuper(CustomEventTarget);
        function CustomEventTarget() {
            $8340f3b7957f8d3d$var$_classCallCheck__default["default"](this, CustomEventTarget);
            return _super4.apply(this, arguments);
        }
        return CustomEventTarget;
    }($8340f3b7957f8d3d$var$EventTarget);
    for(var _i7 = 0; _i7 < arguments.length; ++_i7)$8340f3b7957f8d3d$var$defineEventAttribute(CustomEventTarget.prototype, _i7 < 0 || arguments.length <= _i7 ? undefined : arguments[_i7]);
    return CustomEventTarget;
}
/**
 * Define an event attribute.
 * @param target The `EventTarget` object to define an event attribute.
 * @param type The event type to define.
 * @param _eventClass Unused, but to infer `Event` class type.
 * @deprecated Use `getEventAttributeValue`/`setEventAttributeValue` pair on your derived class instead because of static analysis friendly.
 */ function $8340f3b7957f8d3d$var$defineEventAttribute(target, type, _eventClass) {
    Object.defineProperty(target, "on".concat(type), {
        get: function get() {
            return $8340f3b7957f8d3d$var$getEventAttributeValue(this, type);
        },
        set: function set(value) {
            $8340f3b7957f8d3d$var$setEventAttributeValue(this, type, value);
        },
        configurable: true,
        enumerable: true
    });
}
module.exports.Event = $8340f3b7957f8d3d$var$Event;
module.exports.EventTarget = $8340f3b7957f8d3d$var$EventTarget;
module.exports.default = $8340f3b7957f8d3d$var$EventTarget;
module.exports.defineCustomEventTarget = $8340f3b7957f8d3d$var$defineCustomEventTarget;
module.exports.defineEventAttribute = $8340f3b7957f8d3d$var$defineEventAttribute;
module.exports.getEventAttributeValue = $8340f3b7957f8d3d$var$getEventAttributeValue;
module.exports.setErrorHandler = $8340f3b7957f8d3d$var$setErrorHandler;
module.exports.setEventAttributeValue = $8340f3b7957f8d3d$var$setEventAttributeValue;
module.exports.setWarningHandler = $8340f3b7957f8d3d$var$setWarningHandler;

});
parcelRequire.register("ge3FC", function(module, exports) {

var $fWd6y = parcelRequire("fWd6y");

var $58qVH = parcelRequire("58qVH");

var $fnhRl = parcelRequire("fnhRl");

var $1pZi9 = parcelRequire("1pZi9");
function $bd00ccf93827f52b$var$_toConsumableArray(arr) {
    return $fWd6y(arr) || $58qVH(arr) || $fnhRl(arr) || $1pZi9();
}
module.exports = $bd00ccf93827f52b$var$_toConsumableArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRequire.register("fWd6y", function(module, exports) {

var $3Tv2w = parcelRequire("3Tv2w");
function $b9a67018e7077d14$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $3Tv2w(arr);
}
module.exports = $b9a67018e7077d14$var$_arrayWithoutHoles, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRequire.register("3Tv2w", function(module, exports) {
function $2d5e9602528d135d$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
module.exports = $2d5e9602528d135d$var$_arrayLikeToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRequire.register("58qVH", function(module, exports) {
function $3bd296c062641f5e$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
module.exports = $3bd296c062641f5e$var$_iterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRequire.register("fnhRl", function(module, exports) {

var $3Tv2w = parcelRequire("3Tv2w");
function $b316db7b315c9488$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $3Tv2w(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $3Tv2w(o, minLen);
}
module.exports = $b316db7b315c9488$var$_unsupportedIterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRequire.register("1pZi9", function(module, exports) {
function $1087ab838ffbe640$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
module.exports = $1087ab838ffbe640$var$_nonIterableSpread, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRequire.register("fD23L", function(module, exports) {

var $jnkU6 = parcelRequire("jnkU6");

var $c4FN3 = parcelRequire("c4FN3");
function $b60c18877736b3f5$var$set(target, property, value, receiver) {
    if (typeof Reflect !== "undefined" && Reflect.set) $b60c18877736b3f5$var$set = Reflect.set;
    else $b60c18877736b3f5$var$set = function set(target, property, value, receiver) {
        var base = $jnkU6(target, property);
        var desc;
        if (base) {
            desc = Object.getOwnPropertyDescriptor(base, property);
            if (desc.set) {
                desc.set.call(receiver, value);
                return true;
            } else if (!desc.writable) return false;
        }
        desc = Object.getOwnPropertyDescriptor(receiver, property);
        if (desc) {
            if (!desc.writable) return false;
            desc.value = value;
            Object.defineProperty(receiver, property, desc);
        } else $c4FN3(receiver, property, value);
        return true;
    };
    return $b60c18877736b3f5$var$set(target, property, value, receiver);
}
function $b60c18877736b3f5$var$_set(target, property, value, receiver, isStrict) {
    var s = $b60c18877736b3f5$var$set(target, property, value, receiver || target);
    if (!s && isStrict) throw new TypeError("failed to set property");
    return value;
}
module.exports = $b60c18877736b3f5$var$_set, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRequire.register("jnkU6", function(module, exports) {

var $e9coA = parcelRequire("e9coA");
function $e1b0615dd750fcf6$var$_superPropBase(object, property) {
    while(!Object.prototype.hasOwnProperty.call(object, property)){
        object = $e9coA(object);
        if (object === null) break;
    }
    return object;
}
module.exports = $e1b0615dd750fcf6$var$_superPropBase, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRequire.register("e9coA", function(module, exports) {
function $a4cb8570a6b31eee$var$_getPrototypeOf(o) {
    module.exports = $a4cb8570a6b31eee$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    }, module.exports.__esModule = true, module.exports["default"] = module.exports;
    return $a4cb8570a6b31eee$var$_getPrototypeOf(o);
}
module.exports = $a4cb8570a6b31eee$var$_getPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRequire.register("c4FN3", function(module, exports) {

var $cCrsS = parcelRequire("cCrsS");
function $8ca6466ef6a35386$var$_defineProperty(obj, key, value) {
    key = $cCrsS(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
module.exports = $8ca6466ef6a35386$var$_defineProperty, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRequire.register("cCrsS", function(module, exports) {

var $iOJLr = parcelRequire("iOJLr");
var $92fe5698cd24cde0$var$_typeof = $iOJLr.default;

var $kYnmv = parcelRequire("kYnmv");
function $92fe5698cd24cde0$var$_toPropertyKey(arg) {
    var key = $kYnmv(arg, "string");
    return $92fe5698cd24cde0$var$_typeof(key) === "symbol" ? key : String(key);
}
module.exports = $92fe5698cd24cde0$var$_toPropertyKey, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRequire.register("iOJLr", function(module, exports) {
function $db306554233f8f05$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return module.exports = $db306554233f8f05$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $db306554233f8f05$var$_typeof(obj);
}
module.exports = $db306554233f8f05$var$_typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRequire.register("kYnmv", function(module, exports) {

var $iOJLr = parcelRequire("iOJLr");
var $f44b886e89e5ca5f$var$_typeof = $iOJLr.default;
function $f44b886e89e5ca5f$var$_toPrimitive(input, hint) {
    if ($f44b886e89e5ca5f$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($f44b886e89e5ca5f$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
module.exports = $f44b886e89e5ca5f$var$_toPrimitive, module.exports.__esModule = true, module.exports["default"] = module.exports;

});




parcelRequire.register("fuQvR", function(module, exports) {

var $jnkU6 = parcelRequire("jnkU6");
function $b482644c852b5a93$var$_get() {
    if (typeof Reflect !== "undefined" && Reflect.get) module.exports = $b482644c852b5a93$var$_get = Reflect.get.bind(), module.exports.__esModule = true, module.exports["default"] = module.exports;
    else module.exports = $b482644c852b5a93$var$_get = function _get(target, property, receiver) {
        var base = $jnkU6(target, property);
        if (!base) return;
        var desc = Object.getOwnPropertyDescriptor(base, property);
        if (desc.get) return desc.get.call(arguments.length < 3 ? target : receiver);
        return desc.value;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports;
    return $b482644c852b5a93$var$_get.apply(this, arguments);
}
module.exports = $b482644c852b5a93$var$_get, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRequire.register("7YH1B", function(module, exports) {
function $5cef82db6b76da96$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
module.exports = $5cef82db6b76da96$var$_assertThisInitialized, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRequire.register("dXPTy", function(module, exports) {

var $bAjyG = parcelRequire("bAjyG");
function $a2a90a4e03be88ff$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $bAjyG(subClass, superClass);
}
module.exports = $a2a90a4e03be88ff$var$_inherits, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRequire.register("bAjyG", function(module, exports) {
function $86f23a5ea914f802$var$_setPrototypeOf(o, p) {
    module.exports = $86f23a5ea914f802$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports;
    return $86f23a5ea914f802$var$_setPrototypeOf(o, p);
}
module.exports = $86f23a5ea914f802$var$_setPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRequire.register("lSSVg", function(module, exports) {

var $iOJLr = parcelRequire("iOJLr");
var $fee93e957dc4079d$var$_typeof = $iOJLr.default;

var $7YH1B = parcelRequire("7YH1B");
function $fee93e957dc4079d$var$_possibleConstructorReturn(self, call) {
    if (call && ($fee93e957dc4079d$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $7YH1B(self);
}
module.exports = $fee93e957dc4079d$var$_possibleConstructorReturn, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRequire.register("04PW7", function(module, exports) {

var $e9coA = parcelRequire("e9coA");

var $bAjyG = parcelRequire("bAjyG");

var $lDXsW = parcelRequire("lDXsW");

var $7DXSU = parcelRequire("7DXSU");
function $00e8a959e9460dca$var$_wrapNativeSuper(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    module.exports = $00e8a959e9460dca$var$_wrapNativeSuper = function _wrapNativeSuper(Class) {
        if (Class === null || !$lDXsW(Class)) return Class;
        if (typeof Class !== "function") throw new TypeError("Super expression must either be null or a function");
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return $7DXSU(Class, arguments, $e9coA(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return $bAjyG(Wrapper, Class);
    }, module.exports.__esModule = true, module.exports["default"] = module.exports;
    return $00e8a959e9460dca$var$_wrapNativeSuper(Class);
}
module.exports = $00e8a959e9460dca$var$_wrapNativeSuper, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRequire.register("lDXsW", function(module, exports) {
function $fc1b5e2aa45bbb84$var$_isNativeFunction(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}
module.exports = $fc1b5e2aa45bbb84$var$_isNativeFunction, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRequire.register("7DXSU", function(module, exports) {

var $bAjyG = parcelRequire("bAjyG");

var $6xXIA = parcelRequire("6xXIA");
function $590aa0c33188c60b$var$_construct(Parent, args, Class) {
    if ($6xXIA()) module.exports = $590aa0c33188c60b$var$_construct = Reflect.construct.bind(), module.exports.__esModule = true, module.exports["default"] = module.exports;
    else module.exports = $590aa0c33188c60b$var$_construct = function _construct(Parent, args, Class) {
        var a = [
            null
        ];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) $bAjyG(instance, Class.prototype);
        return instance;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports;
    return $590aa0c33188c60b$var$_construct.apply(null, arguments);
}
module.exports = $590aa0c33188c60b$var$_construct, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRequire.register("6xXIA", function(module, exports) {
function $4c4425ec5a810582$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
module.exports = $4c4425ec5a810582$var$_isNativeReflectConstruct, module.exports.__esModule = true, module.exports["default"] = module.exports;

});



parcelRequire.register("4zObc", function(module, exports) {
function $35515af34d6b15bb$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
module.exports = $35515af34d6b15bb$var$_classCallCheck, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRequire.register("d6QOm", function(module, exports) {

var $cCrsS = parcelRequire("cCrsS");
function $98b4cd1f6e710426$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $cCrsS(descriptor.key), descriptor);
    }
}
function $98b4cd1f6e710426$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $98b4cd1f6e710426$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $98b4cd1f6e710426$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
module.exports = $98b4cd1f6e710426$var$_createClass, module.exports.__esModule = true, module.exports["default"] = module.exports;

});



parcelRequire.register("8WVG5", function(module, exports) {
"use strict";
function $68407b1c4efb9d96$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $68407b1c4efb9d96$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $68407b1c4efb9d96$var$_typeof(obj);
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $hd4g0 = parcelRequire("hd4g0");

var $68407b1c4efb9d96$var$_react = $68407b1c4efb9d96$var$_interopRequireWildcard((parcelRequire("eO7Kz")));

var $68407b1c4efb9d96$var$_Context = $68407b1c4efb9d96$var$_interopRequireDefault((parcelRequire("cOp70")));

var $68407b1c4efb9d96$var$_useActivitiesWithRenderer = $68407b1c4efb9d96$var$_interopRequireDefault((parcelRequire("fqm10")));

var $68407b1c4efb9d96$var$_useContext = $68407b1c4efb9d96$var$_interopRequireDefault((parcelRequire("7QF4z")));

var $68407b1c4efb9d96$var$_useActivityTreeWithRenderer = $68407b1c4efb9d96$var$_interopRequireDefault((parcelRequire("d69DW")));

var $68407b1c4efb9d96$var$_useMemoWithPrevious = $68407b1c4efb9d96$var$_interopRequireDefault((parcelRequire("gNDPR")));
function $68407b1c4efb9d96$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $68407b1c4efb9d96$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($68407b1c4efb9d96$var$_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $68407b1c4efb9d96$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || $68407b1c4efb9d96$var$_typeof(obj) !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $68407b1c4efb9d96$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $68407b1c4efb9d96$var$_slicedToArray(arr, i) {
    return $68407b1c4efb9d96$var$_arrayWithHoles(arr) || $68407b1c4efb9d96$var$_iterableToArrayLimit(arr, i) || $68407b1c4efb9d96$var$_unsupportedIterableToArray(arr, i) || $68407b1c4efb9d96$var$_nonIterableRest();
}
function $68407b1c4efb9d96$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $68407b1c4efb9d96$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $68407b1c4efb9d96$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $68407b1c4efb9d96$var$_arrayLikeToArray(o, minLen);
}
function $68407b1c4efb9d96$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $68407b1c4efb9d96$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $68407b1c4efb9d96$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
var $68407b1c4efb9d96$var$useActivities = $hd4g0.hooks.useActivities, $68407b1c4efb9d96$var$useCreateActivityRenderer = $hd4g0.hooks.useCreateActivityRenderer;
var $68407b1c4efb9d96$var$ActivityTreeComposer = function ActivityTreeComposer(_ref) {
    var children = _ref.children;
    var existingContext = (0, $68407b1c4efb9d96$var$_useContext.default)(false);
    if (existingContext) throw new Error("botframework-webchat internal: <ActivityTreeComposer> should not be nested.");
    var _useActivities = $68407b1c4efb9d96$var$useActivities(), _useActivities2 = $68407b1c4efb9d96$var$_slicedToArray(_useActivities, 1), activities = _useActivities2[0];
    var createActivityRenderer = $68407b1c4efb9d96$var$useCreateActivityRenderer();
    var activitiesWithRenderer = (0, $68407b1c4efb9d96$var$_useActivitiesWithRenderer.default)(activities, createActivityRenderer);
    var activityTreeWithRenderer = (0, $68407b1c4efb9d96$var$_useActivityTreeWithRenderer.default)(activitiesWithRenderer);
    var flattenedActivityTreeWithRenderer = (0, $68407b1c4efb9d96$var$_useMemoWithPrevious.default)(function(prevFlattenedActivityTree) {
        var nextFlattenedActivityTree = Object.freeze(activityTreeWithRenderer.reduce(function(intermediate, entriesWithSameSender) {
            return entriesWithSameSender.reduce(function(intermediate, entriesWithSameSenderAndStatus) {
                return entriesWithSameSenderAndStatus.reduce(function(intermediate, entry) {
                    intermediate.push(entry);
                    return intermediate;
                }, intermediate);
            }, intermediate);
        }, []));
        return nextFlattenedActivityTree.length === (prevFlattenedActivityTree === null || prevFlattenedActivityTree === void 0 ? void 0 : prevFlattenedActivityTree.length) && nextFlattenedActivityTree.every(function(item, index) {
            return item === prevFlattenedActivityTree[+index];
        }) ? prevFlattenedActivityTree : nextFlattenedActivityTree;
    }, [
        activityTreeWithRenderer
    ]);
    var contextValue = (0, $68407b1c4efb9d96$var$_react.useMemo)(function() {
        return {
            activityTreeWithRendererState: Object.freeze([
                activityTreeWithRenderer
            ]),
            flattenedActivityTreeWithRendererState: Object.freeze([
                flattenedActivityTreeWithRenderer
            ])
        };
    }, [
        activityTreeWithRenderer,
        flattenedActivityTreeWithRenderer
    ]);
    return /*#__PURE__*/ $68407b1c4efb9d96$var$_react.default.createElement($68407b1c4efb9d96$var$_Context.default.Provider, {
        value: contextValue
    }, children);
};
var $68407b1c4efb9d96$var$_default = $68407b1c4efb9d96$var$ActivityTreeComposer;
module.exports.default = $68407b1c4efb9d96$var$_default;

});
parcelRequire.register("fqm10", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $b3aa5c81601e8048$var$useActivitiesWithRenderer;

var $eO7Kz = parcelRequire("eO7Kz");

var $b3aa5c81601e8048$var$_useMemoize = $b3aa5c81601e8048$var$_interopRequireDefault((parcelRequire("1uZp9")));
function $b3aa5c81601e8048$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $b3aa5c81601e8048$var$useActivitiesWithRenderer(activities, createActivityRenderer) {
    var createActivityRendererWithLiteralArgs = (0, $eO7Kz.useCallback)(function(activity, nextVisibleActivity) {
        return createActivityRenderer({
            activity: activity,
            nextVisibleActivity: nextVisibleActivity
        });
    }, [
        createActivityRenderer
    ]); // Create a memoized context of the createActivityRenderer function.
    // TODO: [P2] Rename useMemoize to useMemoAll
    var entries = (0, $b3aa5c81601e8048$var$_useMemoize.default)(createActivityRendererWithLiteralArgs, function(createActivityRendererWithLiteralArgsMemoized) {
        // All calls to createActivityRendererWithLiteralArgsMemoized() in this function will be memoized (LRU = 1).
        // In the next render cycle, calls to createActivityRendererWithLiteralArgsMemoized() might return the memoized result instead.
        // This is an improvement to React useMemo(), because it only allows 1 memoization.
        // useMemoize() allows any number of memoization.
        var activitiesWithRenderer = [];
        var nextVisibleActivity;
        for(var index = activities.length - 1; index >= 0; index--){
            var activity = activities[+index];
            var renderActivity = createActivityRendererWithLiteralArgsMemoized(activity, nextVisibleActivity);
            if (renderActivity) {
                activitiesWithRenderer.splice(0, 0, {
                    activity: activity,
                    renderActivity: renderActivity
                });
                nextVisibleActivity = activity;
            }
        }
        return Object.freeze(activitiesWithRenderer);
    }, [
        activities
    ]);
    var prevEntriesRef = (0, $eO7Kz.useRef)([]);
    var prevEntries = prevEntriesRef.current;
    if (prevEntries.length !== entries.length || prevEntries.some(function(prevEntry, index) {
        var entry = entries[+index];
        return entry.activity !== prevEntry.activity || entry.renderActivity !== prevEntry.renderActivity;
    })) prevEntriesRef.current = entries;
    return prevEntriesRef.current;
}

});
parcelRequire.register("1uZp9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $1178397f106ba370$var$useMemoize;

var $eO7Kz = parcelRequire("eO7Kz");
function $1178397f106ba370$var$_toConsumableArray(arr) {
    return $1178397f106ba370$var$_arrayWithoutHoles(arr) || $1178397f106ba370$var$_iterableToArray(arr) || $1178397f106ba370$var$_unsupportedIterableToArray(arr) || $1178397f106ba370$var$_nonIterableSpread();
}
function $1178397f106ba370$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $1178397f106ba370$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $1178397f106ba370$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $1178397f106ba370$var$_arrayLikeToArray(o, minLen);
}
function $1178397f106ba370$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $1178397f106ba370$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $1178397f106ba370$var$_arrayLikeToArray(arr);
}
function $1178397f106ba370$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
/**
 * `useMemoize` will memoize multiple calls to the same memoize function.
 *
 * This is similar to `useMemo`. But instead of calling it once, `useMemoize` enables multiple calls while the `callback` function is executed.
 *
 * @param {Fn<TArgs, TIntermediate>} fn - The function to be memoized.
 * @param {(fn: Fn<TArgs, TIntermediate>) => TFinal} callback - When called, this function should execute the memoizing function.
 * @param {DependencyList[]} deps - Dependencies to detect for chagnes.
 */ function $1178397f106ba370$var$useMemoize(fn, callback, deps) {
    if (typeof fn !== "function") throw new Error("The first argument must be a function.");
    else if (typeof callback !== "function") throw new Error("The second argument must be a function.");
    else if (!Array.isArray(deps)) throw new Error("The third argument must be an array.");
    var memoizedFn = (0, $eO7Kz.useMemo)(function() {
        var cache = [];
        return function(run) {
            var nextCache = [];
            var result = run(function() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                var _ref = [].concat($1178397f106ba370$var$_toConsumableArray(cache), nextCache).find(function(_ref2) {
                    var cachedArgs = _ref2.args;
                    return args.length === cachedArgs.length && args.every(function(arg, index) {
                        return Object.is(arg, cachedArgs[+index]);
                    });
                }) || {
                    result: fn.apply(void 0, args)
                }, result = _ref.result;
                nextCache.push({
                    args: args,
                    result: result
                });
                return result;
            });
            cache = nextCache;
            return result;
        }; // We are manually creating the deps here. The "callback" arg is also designed not to be impact deps, similar to useEffect(fn), where "fn" is not in deps.
    /* eslint-disable-next-line react-hooks/exhaustive-deps */ }, [
        fn
    ].concat($1178397f106ba370$var$_toConsumableArray(deps)));
    return memoizedFn(callback);
}

});


parcelRequire.register("d69DW", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $hd4g0 = parcelRequire("hd4g0");

var $eO7Kz = parcelRequire("eO7Kz");

var $989350d3eacb3f9a$var$_intersectionOf = $989350d3eacb3f9a$var$_interopRequireDefault((parcelRequire("2boUL")));

var $989350d3eacb3f9a$var$_removeInline = $989350d3eacb3f9a$var$_interopRequireDefault((parcelRequire("6gxgd")));
function $989350d3eacb3f9a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $989350d3eacb3f9a$var$_toConsumableArray(arr) {
    return $989350d3eacb3f9a$var$_arrayWithoutHoles(arr) || $989350d3eacb3f9a$var$_iterableToArray(arr) || $989350d3eacb3f9a$var$_unsupportedIterableToArray(arr) || $989350d3eacb3f9a$var$_nonIterableSpread();
}
function $989350d3eacb3f9a$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $989350d3eacb3f9a$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $989350d3eacb3f9a$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $989350d3eacb3f9a$var$_arrayLikeToArray(arr);
}
function $989350d3eacb3f9a$var$_slicedToArray(arr, i) {
    return $989350d3eacb3f9a$var$_arrayWithHoles(arr) || $989350d3eacb3f9a$var$_iterableToArrayLimit(arr, i) || $989350d3eacb3f9a$var$_unsupportedIterableToArray(arr, i) || $989350d3eacb3f9a$var$_nonIterableRest();
}
function $989350d3eacb3f9a$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $989350d3eacb3f9a$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $989350d3eacb3f9a$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $989350d3eacb3f9a$var$_arrayLikeToArray(o, minLen);
}
function $989350d3eacb3f9a$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $989350d3eacb3f9a$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $989350d3eacb3f9a$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
var $989350d3eacb3f9a$var$useGroupActivities = $hd4g0.hooks.useGroupActivities;
function $989350d3eacb3f9a$var$validateAllEntriesTagged(entries, bins) {
    return entries.every(function(entry) {
        return bins.some(function(bin) {
            return bin.includes(entry);
        });
    });
} // Activity tree is a multidimensional array, while activities is a 1D array.
// - The first dimension of the array contains activities with same sender;
// - The second dimension of the array contains activities with same status.
// [
//   [
//     // Both messages are from bot and is sent as a batch, we will group them as an array.
//     'Bot: Hello!'
//     'Bot: What can I help today?'
//   ],
//   [
//     'User: What is the weather?'
//   ],
//   [
//     'Bot: Let me look it up... hold on.'
//   ],
//   [
//     // This message is in a different group because it is more than a few seconds apart from the previous message.
//     'Bot: Here is the weather forecast.'
//   ]
// ]
function $989350d3eacb3f9a$var$useActivityTreeWithRenderer(entries) {
    var groupActivities = $989350d3eacb3f9a$var$useGroupActivities(); // We bin activities in 2 different ways:
    // - `activitiesBySender` is a 2D array containing activities with same sender
    // - `activitiesByStatus` is a 2D array containing activities with same status
    // Both arrays should contains all activities.
    var _useMemo = (0, $eO7Kz.useMemo)(function() {
        var visibleActivities = entries.map(function(_ref) {
            var activity = _ref.activity;
            return activity;
        });
        var groupActivitiesResult = groupActivities({
            activities: visibleActivities
        });
        var activitiesBySender = (groupActivitiesResult === null || groupActivitiesResult === void 0 ? void 0 : groupActivitiesResult.sender) || [];
        var activitiesByStatus = (groupActivitiesResult === null || groupActivitiesResult === void 0 ? void 0 : groupActivitiesResult.status) || [];
        var _map = [
            activitiesBySender,
            activitiesByStatus
        ].map(function(bins) {
            return bins.map(function(bin) {
                return bin.map(function(activity) {
                    return entries.find(function(entry) {
                        return entry.activity === activity;
                    });
                });
            });
        }), _map2 = $989350d3eacb3f9a$var$_slicedToArray(_map, 2), entriesBySender = _map2[0], entriesByStatus = _map2[1];
        if (!$989350d3eacb3f9a$var$validateAllEntriesTagged(visibleActivities, activitiesBySender)) console.warn('botframework-webchat: Not every activities are grouped in the "sender" property. Please fix "groupActivitiesMiddleware" and group every activities.');
        if (!$989350d3eacb3f9a$var$validateAllEntriesTagged(visibleActivities, activitiesByStatus)) console.warn('botframework-webchat: Not every activities are grouped in the "status" property. Please fix "groupActivitiesMiddleware" and group every activities.');
        return {
            entriesBySender: entriesBySender,
            entriesByStatus: entriesByStatus
        };
    }, [
        entries,
        groupActivities
    ]), entriesBySender = _useMemo.entriesBySender, entriesByStatus = _useMemo.entriesByStatus; // Create a tree of activities with 2 dimensions: sender, followed by status.
    var activityTree = (0, $eO7Kz.useMemo)(function() {
        var entriesPendingGrouping = $989350d3eacb3f9a$var$_toConsumableArray(entries);
        var activityTree = [];
        var _loop = function _loop() {
            var found = void 0;
            var entriesWithSameSender = entriesBySender.find(function(bin) {
                return bin.includes(entriesPendingGrouping[0]);
            });
            var senderTree = [];
            entriesWithSameSender === null || entriesWithSameSender === void 0 || entriesWithSameSender.forEach(function(entry) {
                var entriesWithSameStatus = entriesByStatus.find(function(bin) {
                    return bin.includes(entry);
                });
                var entriesWithSameSenderAndStatus = (0, $989350d3eacb3f9a$var$_intersectionOf.default)(entriesPendingGrouping, entriesWithSameSender, entriesWithSameStatus);
                if (entriesWithSameSenderAndStatus.length) {
                    senderTree.push(Object.freeze(entriesWithSameSenderAndStatus));
                    $989350d3eacb3f9a$var$_removeInline.default.apply(void 0, [
                        entriesPendingGrouping
                    ].concat($989350d3eacb3f9a$var$_toConsumableArray(entriesWithSameSenderAndStatus)));
                    found = true;
                }
            }); // If the entry is not grouped by the middleware, just put the entry in its own bin.
            found || senderTree.push(Object.freeze([
                entriesPendingGrouping.shift()
            ]));
            activityTree.push(Object.freeze(senderTree));
        };
        while(entriesPendingGrouping.length)_loop();
         // Assertion: All entries must be assigned to the activityTree.
        if (!entries.every(function(activity) {
            return activityTree.some(function(activitiesWithSameSender) {
                return activitiesWithSameSender.some(function(activitiesWithSameSenderAndStatus) {
                    return activitiesWithSameSenderAndStatus.includes(activity);
                });
            });
        })) console.warn("botframework-webchat internal: Not all visible activities are grouped in the activityTree.", {
            entries: entries,
            activityTree: activityTree
        });
        return Object.freeze(activityTree);
    }, [
        entriesBySender,
        entriesByStatus,
        entries
    ]);
    return activityTree;
}
var $989350d3eacb3f9a$var$_default = $989350d3eacb3f9a$var$useActivityTreeWithRenderer;
module.exports.default = $989350d3eacb3f9a$var$_default;

});
parcelRequire.register("2boUL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $196fef5e6abc1714$var$intersectionOf;
function $196fef5e6abc1714$var$_toConsumableArray(arr) {
    return $196fef5e6abc1714$var$_arrayWithoutHoles(arr) || $196fef5e6abc1714$var$_iterableToArray(arr) || $196fef5e6abc1714$var$_unsupportedIterableToArray(arr) || $196fef5e6abc1714$var$_nonIterableSpread();
}
function $196fef5e6abc1714$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $196fef5e6abc1714$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $196fef5e6abc1714$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $196fef5e6abc1714$var$_arrayLikeToArray(o, minLen);
}
function $196fef5e6abc1714$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $196fef5e6abc1714$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $196fef5e6abc1714$var$_arrayLikeToArray(arr);
}
function $196fef5e6abc1714$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
/**
 * Intersects 2 or more arrays and return an array of values which are common to all of them.
 */ function $196fef5e6abc1714$var$intersectionOf(arg0) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
    return args.reduce(function(interim, arg) {
        return interim.reduce(function(intersection, item) {
            arg.includes(item) && intersection.push(item);
            return intersection;
        }, []);
    }, $196fef5e6abc1714$var$_toConsumableArray(arg0));
}

});


parcelRequire.register("gNDPR", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $c3b01f6efd888660$var$useMemoWithPrevious;

var $eO7Kz = parcelRequire("eO7Kz");
function $c3b01f6efd888660$var$useMemoWithPrevious(factory, deps) {
    var prevValueRef = (0, $eO7Kz.useRef)(); // We are building a `useMemo`-like hook, `deps` is passed as-is and `factory` is not one fo the dependencies.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    var value = (0, $eO7Kz.useMemo)(function() {
        return factory(prevValueRef.current);
    }, deps);
    (0, $eO7Kz.useEffect)(function() {
        prevValueRef.current = value;
    });
    return value;
}

});


parcelRequire.register("aXJ2X", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $7fb25b6204dbb696$var$addTargetBlankToHyperlinksMarkdown;

var $7fb25b6204dbb696$var$_updateMarkdownAttrs = $7fb25b6204dbb696$var$_interopRequireDefault((parcelRequire("hcB39")));

var $7fb25b6204dbb696$var$_walkMarkdownTokens = $7fb25b6204dbb696$var$_interopRequireDefault((parcelRequire("ckeyu")));
function $7fb25b6204dbb696$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $7fb25b6204dbb696$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $7fb25b6204dbb696$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $7fb25b6204dbb696$var$ownKeys(Object(source), !0).forEach(function(key) {
            $7fb25b6204dbb696$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $7fb25b6204dbb696$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $7fb25b6204dbb696$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $7fb25b6204dbb696$var$addTargetBlankToHyperlinksMarkdown(tokens) {
    return (0, $7fb25b6204dbb696$var$_walkMarkdownTokens.default)(tokens, function(token) {
        switch(token.type){
            case "link_open":
                token = (0, $7fb25b6204dbb696$var$_updateMarkdownAttrs.default)(token, function(attrs) {
                    return(// Don't add for internal links, e.g. #ref-1, ?q=doc
                    /^[0-9A-Z_a-z]/.test(attrs.href) ? $7fb25b6204dbb696$var$_objectSpread($7fb25b6204dbb696$var$_objectSpread({}, attrs), {}, {
                        rel: "noopener noreferrer",
                        target: "_blank"
                    }) : attrs);
                });
                break;
            default:
                break;
        }
        return token;
    });
}

});
parcelRequire.register("hcB39", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $c8604bfeae5b73c3$var$updateMarkdownItAttrs;

var $c8604bfeae5b73c3$var$_simpleUpdateIn = $c8604bfeae5b73c3$var$_interopRequireDefault((parcelRequire("7qq3H")));
function $c8604bfeae5b73c3$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $c8604bfeae5b73c3$var$updateMarkdownItAttrs(token, updater) {
    return (0, $c8604bfeae5b73c3$var$_simpleUpdateIn.default)(token, [
        "attrs"
    ], function(attrs) {
        var map = Object.fromEntries(attrs);
        var nextMap = updater(map);
        return Object.entries(nextMap);
    });
}

});

parcelRequire.register("ckeyu", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $8f92a4ab48fd2ebe$var$walkMarkdownTokens;
function $8f92a4ab48fd2ebe$var$walkMarkdownTokens(tokens, walker) {
    return tokens.map(function(token) {
        if (token) {
            var nextToken = walker(token);
            if (nextToken.children) nextToken.children = $8f92a4ab48fd2ebe$var$walkMarkdownTokens(nextToken.children, walker);
            return nextToken;
        }
        return token;
    });
}

});


parcelRequire.register("gOLiq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $c3e600e3d187040e$var$useCSSKey;

var $c3e600e3d187040e$var$_mathRandom = $c3e600e3d187040e$var$_interopRequireDefault((parcelRequire("atZsr")));
function $c3e600e3d187040e$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/* eslint no-magic-numbers: ["error", { "ignore": [0, 2, 5, 26, 65] }] */ function $c3e600e3d187040e$var$useCSSKey() {
    return (0, $c3e600e3d187040e$var$_mathRandom.default)().toString(26).substr(2, 5).replace(/[0-9]/g, function(value) {
        return String.fromCharCode(value.charCodeAt(0) + 65);
    });
}

});

parcelRequire.register("9AQhK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $6fc0089819a702ac$var$createCoreMiddleware;

var $6fc0089819a702ac$var$_react = $6fc0089819a702ac$var$_interopRequireDefault((parcelRequire("eO7Kz")));

var $6fc0089819a702ac$var$_CarouselLayout = $6fc0089819a702ac$var$_interopRequireDefault((parcelRequire("3e5gZ")));

var $6fc0089819a702ac$var$_StackedLayout = $6fc0089819a702ac$var$_interopRequireDefault((parcelRequire("jcA5b")));
function $6fc0089819a702ac$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $6fc0089819a702ac$var$_extends() {
    $6fc0089819a702ac$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $6fc0089819a702ac$var$_extends.apply(this, arguments);
}
function $6fc0089819a702ac$var$createCoreMiddleware() {
    return [
        function() {
            return function(next) {
                return function() {
                    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                    var activity = args[0].activity; // TODO: [P4] Can we simplify these if-statement to something more readable?
                    var type = activity.type; // Filter out activities that should not be visible
                    if (type === "conversationUpdate" || type === "event" || type === "invoke" || type === "typing") return false;
                    else if (type === "message") {
                        var attachments = activity.attachments, channelData = activity.channelData, text = activity.text;
                        if (channelData !== null && channelData !== void 0 && channelData.postBack || // Do not show messageBack if displayText is undefined
                        channelData !== null && channelData !== void 0 && channelData.messageBack && !channelData.messageBack.displayText || // Do not show empty bubbles (no text and attachments, and not "typing")
                        !(text || attachments !== null && attachments !== void 0 && attachments.length)) return false;
                    }
                    if (type === "message" || type === "typing") {
                        var _activity$attachments;
                        if (type === "message" && (((_activity$attachments = activity.attachments) === null || _activity$attachments === void 0 ? void 0 : _activity$attachments.length) || 0) > 1 && activity.attachmentLayout === "carousel") // The following line is not a React functional component, it's a render function called by useCreateActivityRenderer() hook.
                        // The function signature need to be compatible with older version of activity middleware, which was:
                        //
                        // renderActivity(
                        //   renderAttachment: ({ activity, attachment }) => React.Element
                        // ) => React.Element
                        return function renderCarouselLayout(renderAttachment, props) {
                            typeof props === "undefined" && console.warn("botframework-webchat: One or more arguments were missing after passing through the activity middleware. Please check your custom activity middleware to make sure it passes all arguments.");
                            return /*#__PURE__*/ $6fc0089819a702ac$var$_react.default.createElement($6fc0089819a702ac$var$_CarouselLayout.default, $6fc0089819a702ac$var$_extends({
                                activity: activity,
                                renderAttachment: renderAttachment
                            }, props));
                        };
                         // The following line is not a React functional component, it's a render function called by useCreateActivityRenderer() hook.
                        return function renderStackedLayout(renderAttachment, props) {
                            typeof props === "undefined" && console.warn("botframework-webchat: One or more arguments were missing after passing through the activity middleware. Please check your custom activity middleware to make sure it passes all arguments.");
                            return /*#__PURE__*/ $6fc0089819a702ac$var$_react.default.createElement($6fc0089819a702ac$var$_StackedLayout.default, $6fc0089819a702ac$var$_extends({
                                activity: activity,
                                renderAttachment: renderAttachment
                            }, props));
                        };
                    }
                    return next.apply(void 0, args);
                };
            };
        }
    ];
}

});
parcelRequire.register("3e5gZ", function(module, exports) {
"use strict";
function $2596c4fea95c6899$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $2596c4fea95c6899$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $2596c4fea95c6899$var$_typeof(obj);
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $hd4g0 = parcelRequire("hd4g0");
parcelRequire("28Cd0");
var $jz9Ub = parcelRequire("jz9Ub");
var $29LnK = parcelRequire("29LnK");
var $kPoIH = parcelRequire("kPoIH");
var $1w92p = parcelRequire("1w92p");
var $2tzI6 = parcelRequire("2tzI6");
var $9rtoc = parcelRequire("9rtoc");

var $2596c4fea95c6899$var$_classnames = $2596c4fea95c6899$var$_interopRequireDefault((parcelRequire("5A4MD")));

var $2596c4fea95c6899$var$_propTypes = $2596c4fea95c6899$var$_interopRequireDefault((parcelRequire("f7UXb")));

var $2596c4fea95c6899$var$_react = $2596c4fea95c6899$var$_interopRequireWildcard((parcelRequire("eO7Kz")));

var $2596c4fea95c6899$var$_CarouselFilmStrip = $2596c4fea95c6899$var$_interopRequireDefault((parcelRequire("iKXe6")));

var $2596c4fea95c6899$var$_useNonce3 = $2596c4fea95c6899$var$_interopRequireDefault((parcelRequire("1PWhL")));

var $2596c4fea95c6899$var$_useStyleSet3 = $2596c4fea95c6899$var$_interopRequireDefault((parcelRequire("gC6jZ")));

var $2596c4fea95c6899$var$_useStyleToEmotionObject = $2596c4fea95c6899$var$_interopRequireDefault((parcelRequire("6l4uV")));
function $2596c4fea95c6899$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($2596c4fea95c6899$var$_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $2596c4fea95c6899$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || $2596c4fea95c6899$var$_typeof(obj) !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $2596c4fea95c6899$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $2596c4fea95c6899$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $2596c4fea95c6899$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $2596c4fea95c6899$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $2596c4fea95c6899$var$ownKeys(Object(source), !0).forEach(function(key) {
            $2596c4fea95c6899$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $2596c4fea95c6899$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $2596c4fea95c6899$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $2596c4fea95c6899$var$_slicedToArray(arr, i) {
    return $2596c4fea95c6899$var$_arrayWithHoles(arr) || $2596c4fea95c6899$var$_iterableToArrayLimit(arr, i) || $2596c4fea95c6899$var$_unsupportedIterableToArray(arr, i) || $2596c4fea95c6899$var$_nonIterableRest();
}
function $2596c4fea95c6899$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $2596c4fea95c6899$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $2596c4fea95c6899$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $2596c4fea95c6899$var$_arrayLikeToArray(o, minLen);
}
function $2596c4fea95c6899$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $2596c4fea95c6899$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $2596c4fea95c6899$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
var $2596c4fea95c6899$var$useDirection = $hd4g0.hooks.useDirection, $2596c4fea95c6899$var$useLocalizer = $hd4g0.hooks.useLocalizer;
var $2596c4fea95c6899$var$ROOT_STYLE = {
    "&.webchat__carousel-layout": {
        overflow: "hidden",
        position: "relative"
    }
};
var $2596c4fea95c6899$var$CarouselLayoutCore = function CarouselLayoutCore(_ref) {
    var activity = _ref.activity, hideTimestamp = _ref.hideTimestamp, renderActivityStatus = _ref.renderActivityStatus, renderAttachment = _ref.renderAttachment, renderAvatar = _ref.renderAvatar, showCallout = _ref.showCallout;
    var _useStyleSet = (0, $2596c4fea95c6899$var$_useStyleSet3.default)(), _useStyleSet2 = $2596c4fea95c6899$var$_slicedToArray(_useStyleSet, 1), carouselFlipperStyleSet = _useStyleSet2[0].carouselFlipper;
    var _useReactFilmStyleSet = (0, $jz9Ub.default)(), _useReactFilmStyleSet2 = $2596c4fea95c6899$var$_slicedToArray(_useReactFilmStyleSet, 1), filmRootClassName = _useReactFilmStyleSet2[0].root;
    var _useDirection = $2596c4fea95c6899$var$useDirection(), _useDirection2 = $2596c4fea95c6899$var$_slicedToArray(_useDirection, 1), direction = _useDirection2[0];
    var _useScrollBarWidth = (0, $29LnK.default)(), _useScrollBarWidth2 = $2596c4fea95c6899$var$_slicedToArray(_useScrollBarWidth, 1), scrollBarWidth = _useScrollBarWidth2[0];
    var _useScrolling = (0, $kPoIH.default)(), _useScrolling2 = $2596c4fea95c6899$var$_slicedToArray(_useScrolling, 1), scrolling = _useScrolling2[0];
    var leftSideFlipper = direction === "rtl" ? ">" : "<";
    var localize = $2596c4fea95c6899$var$useLocalizer();
    var rightSideFlipper = direction === "rtl" ? "<" : ">";
    var rootClassName = (0, $2596c4fea95c6899$var$_useStyleToEmotionObject.default)()($2596c4fea95c6899$var$ROOT_STYLE) + "";
    var nextAlt = localize("CAROUSEL_FLIPPER_NEXT_ALT");
    var previousAlt = localize("CAROUSEL_FLIPPER_PREVIOUS_ALT");
    var leftFlipperAriaLabel = direction === "rtl" ? nextAlt : previousAlt;
    var rightFlipperAriaLabel = direction === "rtl" ? previousAlt : nextAlt;
    return /*#__PURE__*/ $2596c4fea95c6899$var$_react.default.createElement("div", {
        className: (0, $2596c4fea95c6899$var$_classnames.default)("webchat__carousel-layout", rootClassName, carouselFlipperStyleSet + "", filmRootClassName)
    }, /*#__PURE__*/ $2596c4fea95c6899$var$_react.default.createElement("div", {
        className: (0, $2596c4fea95c6899$var$_classnames.default)("react-film__main", {
            "react-film__main--scrolling": scrolling
        })
    }, /*#__PURE__*/ $2596c4fea95c6899$var$_react.default.createElement($2596c4fea95c6899$var$_CarouselFilmStrip.default, {
        activity: activity,
        hideTimestamp: hideTimestamp,
        renderActivityStatus: renderActivityStatus,
        renderAttachment: renderAttachment,
        renderAvatar: renderAvatar,
        showCallout: showCallout
    }), scrollBarWidth !== "100%" && /*#__PURE__*/ $2596c4fea95c6899$var$_react.default.createElement($2596c4fea95c6899$var$_react.default.Fragment, null, /*#__PURE__*/ $2596c4fea95c6899$var$_react.default.createElement($1w92p.default, {
        "aria-label": leftFlipperAriaLabel,
        blurFocusOnClick: true,
        mode: "left"
    }, leftSideFlipper), /*#__PURE__*/ $2596c4fea95c6899$var$_react.default.createElement($1w92p.default, {
        "aria-label": rightFlipperAriaLabel,
        blurFocusOnClick: true,
        mode: "right"
    }, rightSideFlipper))));
};
$2596c4fea95c6899$var$CarouselLayoutCore.defaultProps = {
    hideTimestamp: false,
    renderActivityStatus: false,
    renderAvatar: false,
    showCallout: true
};
$2596c4fea95c6899$var$CarouselLayoutCore.propTypes = {
    activity: $2596c4fea95c6899$var$_propTypes.default.shape({
        attachments: $2596c4fea95c6899$var$_propTypes.default.array
    }).isRequired,
    hideTimestamp: $2596c4fea95c6899$var$_propTypes.default.bool,
    renderActivityStatus: $2596c4fea95c6899$var$_propTypes.default.oneOfType([
        $2596c4fea95c6899$var$_propTypes.default.oneOf([
            false
        ]),
        $2596c4fea95c6899$var$_propTypes.default.func
    ]),
    renderAttachment: $2596c4fea95c6899$var$_propTypes.default.func.isRequired,
    renderAvatar: $2596c4fea95c6899$var$_propTypes.default.oneOfType([
        $2596c4fea95c6899$var$_propTypes.default.oneOf([
            false
        ]),
        $2596c4fea95c6899$var$_propTypes.default.func
    ]),
    showCallout: $2596c4fea95c6899$var$_propTypes.default.bool
};
var $2596c4fea95c6899$var$CarouselLayout = function CarouselLayout(props) {
    var _props$activity = props.activity;
    _props$activity = _props$activity === void 0 ? {} : _props$activity;
    var _props$activity$attac = _props$activity.attachments, attachments = _props$activity$attac === void 0 ? [] : _props$activity$attac;
    var _useDirection3 = $2596c4fea95c6899$var$useDirection(), _useDirection4 = $2596c4fea95c6899$var$_slicedToArray(_useDirection3, 1), direction = _useDirection4[0];
    var _useNonce = (0, $2596c4fea95c6899$var$_useNonce3.default)(), _useNonce2 = $2596c4fea95c6899$var$_slicedToArray(_useNonce, 1), nonce = _useNonce2[0];
    var filmStyleSet = (0, $2596c4fea95c6899$var$_react.useMemo)(function() {
        return (0, $2tzI6.default)({
            cursor: null
        });
    }, []);
    return /*#__PURE__*/ $2596c4fea95c6899$var$_react.default.createElement($9rtoc.default, {
        dir: direction,
        nonce: nonce,
        numItems: attachments.length,
        styleSet: filmStyleSet
    }, /*#__PURE__*/ $2596c4fea95c6899$var$_react.default.createElement($2596c4fea95c6899$var$CarouselLayoutCore, props));
};
$2596c4fea95c6899$var$CarouselLayout.defaultProps = $2596c4fea95c6899$var$_objectSpread({}, $2596c4fea95c6899$var$CarouselLayoutCore.defaultProps);
$2596c4fea95c6899$var$CarouselLayout.propTypes = $2596c4fea95c6899$var$_objectSpread({}, $2596c4fea95c6899$var$CarouselLayoutCore.propTypes);
var $2596c4fea95c6899$var$_default = $2596c4fea95c6899$var$CarouselLayout;
module.exports.default = $2596c4fea95c6899$var$_default;

});
parcelRequire.register("iKXe6", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = module.exports.connectCarouselFilmStrip = void 0;

var $hd4g0 = parcelRequire("hd4g0");
parcelRequire("28Cd0");
var $8xjyx = parcelRequire("8xjyx");
var $4ibPa = parcelRequire("4ibPa");

var $da7a76ffd4ff6592$var$_classnames = $da7a76ffd4ff6592$var$_interopRequireDefault((parcelRequire("5A4MD")));

var $da7a76ffd4ff6592$var$_propTypes = $da7a76ffd4ff6592$var$_interopRequireDefault((parcelRequire("f7UXb")));

var $da7a76ffd4ff6592$var$_react = $da7a76ffd4ff6592$var$_interopRequireDefault((parcelRequire("eO7Kz")));

var $da7a76ffd4ff6592$var$_Bubble = $da7a76ffd4ff6592$var$_interopRequireDefault((parcelRequire("esGjx")));

var $da7a76ffd4ff6592$var$_CarouselFilmStripAttachment = $da7a76ffd4ff6592$var$_interopRequireDefault((parcelRequire("excCN")));

var $da7a76ffd4ff6592$var$_connectToWebChat = $da7a76ffd4ff6592$var$_interopRequireDefault((parcelRequire("86vmQ")));

var $da7a76ffd4ff6592$var$_isZeroOrPositive = $da7a76ffd4ff6592$var$_interopRequireDefault((parcelRequire("fFkLN")));

var $da7a76ffd4ff6592$var$_ScreenReaderText = $da7a76ffd4ff6592$var$_interopRequireDefault((parcelRequire("3NTZI")));

var $da7a76ffd4ff6592$var$_textFormatToContentType = $da7a76ffd4ff6592$var$_interopRequireDefault((parcelRequire("eNc4R")));

var $da7a76ffd4ff6592$var$_useStyleSet3 = $da7a76ffd4ff6592$var$_interopRequireDefault((parcelRequire("gC6jZ")));

var $da7a76ffd4ff6592$var$_useStyleToEmotionObject = $da7a76ffd4ff6592$var$_interopRequireDefault((parcelRequire("6l4uV")));
function $da7a76ffd4ff6592$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $da7a76ffd4ff6592$var$_slicedToArray(arr, i) {
    return $da7a76ffd4ff6592$var$_arrayWithHoles(arr) || $da7a76ffd4ff6592$var$_iterableToArrayLimit(arr, i) || $da7a76ffd4ff6592$var$_unsupportedIterableToArray(arr, i) || $da7a76ffd4ff6592$var$_nonIterableRest();
}
function $da7a76ffd4ff6592$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $da7a76ffd4ff6592$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $da7a76ffd4ff6592$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $da7a76ffd4ff6592$var$_arrayLikeToArray(o, minLen);
}
function $da7a76ffd4ff6592$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $da7a76ffd4ff6592$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $da7a76ffd4ff6592$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
var $da7a76ffd4ff6592$var$useAvatarForBot = $hd4g0.hooks.useAvatarForBot, $da7a76ffd4ff6592$var$useAvatarForUser = $hd4g0.hooks.useAvatarForUser, $da7a76ffd4ff6592$var$useDirection = $hd4g0.hooks.useDirection, $da7a76ffd4ff6592$var$useLocalizer = $hd4g0.hooks.useLocalizer, $da7a76ffd4ff6592$var$useStyleOptions = $hd4g0.hooks.useStyleOptions;
var $da7a76ffd4ff6592$var$ROOT_STYLE = {
    "&.webchat__carousel-filmstrip": {
        display: "flex",
        flexDirection: "column",
        MsOverflowStyle: "none",
        overflowX: "scroll",
        overflowY: "hidden",
        position: "relative",
        // This is to keep screen reader text in the destinated area.
        touchAction: "manipulation",
        WebkitOverflowScrolling: "touch",
        "&::-webkit-scrollbar": {
            display: "none"
        },
        "& .webchat__carousel-filmstrip__alignment-pad": {
            flexShrink: 0
        },
        "& .webchat__carousel-filmstrip-attachment": {
            flex: 1
        },
        "& .webchat__carousel-filmstrip__attachments": {
            display: "flex",
            listStyleType: "none",
            margin: 0,
            padding: 0
        },
        "& .webchat__carousel-filmstrip__avatar": {
            flexShrink: 0
        },
        "& .webchat__carousel-filmstrip__avatar-gutter": {
            display: "flex",
            flexDirection: "column",
            flexShrink: 0
        },
        "& .webchat__carousel-filmstrip__complimentary": {
            display: "flex"
        },
        "& .webchat__carousel-filmstrip__complimentary-content": {
            display: "flex",
            flexGrow: 1,
            flexDirection: "column"
        },
        "& .webchat__carousel-filmstrip__content": {
            display: "flex",
            flexGrow: 1,
            flexDirection: "column"
        },
        "& .webchat__carousel-filmstrip__filler": {
            flexGrow: 10000,
            flexShrink: 1
        },
        "& .webchat__carousel-filmstrip__main": {
            display: "flex"
        },
        "& .webchat__carousel-filmstrip__message": {
            display: "flex"
        },
        "& .webchat__carousel-filmstrip__nub-pad": {
            flexShrink: 0
        },
        "& .webchat__carousel-filmstrip__status": {
            display: "flex"
        }
    }
};
var $da7a76ffd4ff6592$var$connectCarouselFilmStrip = function connectCarouselFilmStrip() {
    for(var _len = arguments.length, selectors = new Array(_len), _key = 0; _key < _len; _key++)selectors[_key] = arguments[_key];
    return $da7a76ffd4ff6592$var$_connectToWebChat.default.apply(void 0, [
        function(_ref, _ref2) {
            var language = _ref.language, _ref$styleSet$options = _ref.styleSet.options, botAvatarInitials = _ref$styleSet$options.botAvatarInitials, userAvatarInitials = _ref$styleSet$options.userAvatarInitials;
            var _ref2$activity = _ref2.activity;
            _ref2$activity = _ref2$activity === void 0 ? {} : _ref2$activity;
            var _ref2$activity$from = _ref2$activity.from;
            _ref2$activity$from = _ref2$activity$from === void 0 ? {} : _ref2$activity$from;
            var role = _ref2$activity$from.role;
            return {
                avatarInitials: role === "user" ? userAvatarInitials : botAvatarInitials,
                language: language
            };
        }
    ].concat(selectors));
};
module.exports.connectCarouselFilmStrip = $da7a76ffd4ff6592$var$connectCarouselFilmStrip;
var $da7a76ffd4ff6592$var$CarouselFilmStrip = function CarouselFilmStrip(_ref3) {
    var activity = _ref3.activity, className = _ref3.className, hideTimestamp = _ref3.hideTimestamp, renderActivityStatus = _ref3.renderActivityStatus, renderAttachment = _ref3.renderAttachment, renderAvatar = _ref3.renderAvatar, showCallout = _ref3.showCallout;
    var _useStyleOptions = $da7a76ffd4ff6592$var$useStyleOptions(), _useStyleOptions2 = $da7a76ffd4ff6592$var$_slicedToArray(_useStyleOptions, 1), _useStyleOptions2$ = _useStyleOptions2[0], bubbleNubOffset = _useStyleOptions2$.bubbleNubOffset, bubbleNubSize = _useStyleOptions2$.bubbleNubSize, bubbleFromUserNubOffset = _useStyleOptions2$.bubbleFromUserNubOffset, bubbleFromUserNubSize = _useStyleOptions2$.bubbleFromUserNubSize;
    var _useStyleSet = (0, $da7a76ffd4ff6592$var$_useStyleSet3.default)(), _useStyleSet2 = $da7a76ffd4ff6592$var$_slicedToArray(_useStyleSet, 1), carouselFilmStripStyleSet = _useStyleSet2[0].carouselFilmStrip;
    var _useAvatarForBot = $da7a76ffd4ff6592$var$useAvatarForBot(), _useAvatarForBot2 = $da7a76ffd4ff6592$var$_slicedToArray(_useAvatarForBot, 1), botInitials = _useAvatarForBot2[0].initials;
    var _useAvatarForUser = $da7a76ffd4ff6592$var$useAvatarForUser(), _useAvatarForUser2 = $da7a76ffd4ff6592$var$_slicedToArray(_useAvatarForUser, 1), userInitials = _useAvatarForUser2[0].initials;
    var _useDirection = $da7a76ffd4ff6592$var$useDirection(), _useDirection2 = $da7a76ffd4ff6592$var$_slicedToArray(_useDirection, 1), direction = _useDirection2[0];
    var localize = $da7a76ffd4ff6592$var$useLocalizer();
    var rootClassName = (0, $da7a76ffd4ff6592$var$_useStyleToEmotionObject.default)()($da7a76ffd4ff6592$var$ROOT_STYLE) + "";
    var showActivityStatus = typeof renderActivityStatus === "function";
    var itemContainerCallbackRef = (0, $8xjyx.default)();
    var scrollableCallbackRef = (0, $4ibPa.default)();
    var _activity$attachments = activity.attachments, attachments = _activity$attachments === void 0 ? [] : _activity$attachments, _activity$channelData = activity.channelData;
    _activity$channelData = _activity$channelData === void 0 ? {} : _activity$channelData;
    var _activity$channelData2 = _activity$channelData.messageBack;
    _activity$channelData2 = _activity$channelData2 === void 0 ? {} : _activity$channelData2;
    var messageBackDisplayText = _activity$channelData2.displayText, _activity$from = activity.from;
    _activity$from = _activity$from === void 0 ? {} : _activity$from;
    var role = _activity$from.role, text = activity.text, textFormat = activity.textFormat;
    var activityDisplayText = messageBackDisplayText || text;
    var fromUser = role === "user";
    var greetingAlt = (fromUser ? localize("ACTIVITY_YOU_SAID_ALT") : localize("ACTIVITY_BOT_SAID_ALT", botInitials || "")).replace(/[\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]{2,}/g, " ");
    var initials = fromUser ? userInitials : botInitials;
    var nubOffset = fromUser ? bubbleFromUserNubOffset : bubbleNubOffset;
    var nubSize = fromUser ? bubbleFromUserNubSize : bubbleNubSize;
    var otherInitials = fromUser ? botInitials : userInitials;
    var otherNubSize = fromUser ? bubbleNubSize : bubbleFromUserNubSize;
    var hasAvatar = initials || typeof initials === "string";
    var hasOtherAvatar = otherInitials || typeof otherInitials === "string";
    var hasNub = typeof nubSize === "number";
    var hasOtherNub = typeof otherNubSize === "number";
    var topAlignedCallout = (0, $da7a76ffd4ff6592$var$_isZeroOrPositive.default)(nubOffset);
    var extraTrailing = !hasOtherAvatar && hasOtherNub; // This is for bot message with user nub and no user avatar. And vice versa.
    var showAvatar = showCallout && hasAvatar && !!renderAvatar;
    var showNub = showCallout && hasNub && (topAlignedCallout || !attachments.length);
    var hideNub = hasNub && !showNub;
    return /*#__PURE__*/ $da7a76ffd4ff6592$var$_react.default.createElement("div", {
        className: (0, $da7a76ffd4ff6592$var$_classnames.default)("webchat__carousel-filmstrip", {
            "webchat__carousel-filmstrip--extra-trailing": extraTrailing,
            "webchat__carousel-filmstrip--hide-avatar": hasAvatar && !showAvatar,
            "webchat__carousel-filmstrip--hide-nub": hideNub,
            "webchat__carousel-filmstrip--no-message": !activityDisplayText,
            "webchat__carousel-filmstrip--rtl": direction === "rtl",
            "webchat__carousel-filmstrip--show-avatar": showAvatar,
            "webchat__carousel-filmstrip--show-nub": showNub,
            "webchat__carousel-filmstrip--top-callout": topAlignedCallout
        }, "react-film__filmstrip", rootClassName, carouselFilmStripStyleSet + "", (className || "") + ""),
        ref: scrollableCallbackRef
    }, /*#__PURE__*/ $da7a76ffd4ff6592$var$_react.default.createElement("div", {
        className: "webchat__carousel-filmstrip__main"
    }, /*#__PURE__*/ $da7a76ffd4ff6592$var$_react.default.createElement("div", {
        className: "webchat__carousel-filmstrip__avatar-gutter"
    }, showAvatar && renderAvatar({
        activity: activity
    })), /*#__PURE__*/ $da7a76ffd4ff6592$var$_react.default.createElement("div", {
        className: "webchat__carousel-filmstrip__content"
    }, !!activityDisplayText && /*#__PURE__*/ $da7a76ffd4ff6592$var$_react.default.createElement("div", {
        "aria-roledescription": "message",
        className: "webchat__carousel-filmstrip__message",
        role: "group"
    }, /*#__PURE__*/ $da7a76ffd4ff6592$var$_react.default.createElement($da7a76ffd4ff6592$var$_ScreenReaderText.default, {
        text: greetingAlt
    }), /*#__PURE__*/ $da7a76ffd4ff6592$var$_react.default.createElement($da7a76ffd4ff6592$var$_Bubble.default, {
        className: "webchat__carousel-filmstrip__bubble",
        fromUser: fromUser,
        nub: showNub || (hasAvatar || hasNub) && "hidden"
    }, renderAttachment({
        activity: activity,
        attachment: {
            content: activityDisplayText,
            contentType: (0, $da7a76ffd4ff6592$var$_textFormatToContentType.default)(textFormat)
        }
    })), /*#__PURE__*/ $da7a76ffd4ff6592$var$_react.default.createElement("div", {
        className: "webchat__carousel-filmstrip__filler"
    })), /*#__PURE__*/ $da7a76ffd4ff6592$var$_react.default.createElement("div", {
        className: "webchat__carousel-filmstrip__complimentary"
    }, /*#__PURE__*/ $da7a76ffd4ff6592$var$_react.default.createElement("div", {
        className: "webchat__carousel-filmstrip__nub-pad"
    }), /*#__PURE__*/ $da7a76ffd4ff6592$var$_react.default.createElement("div", {
        className: "webchat__carousel-filmstrip__complimentary-content c"
    }, /*#__PURE__*/ $da7a76ffd4ff6592$var$_react.default.createElement("ul", {
        className: "webchat__carousel-filmstrip__attachments react-film__filmstrip__list",
        ref: itemContainerCallbackRef
    }, attachments.map(function(attachment, index) {
        return /*#__PURE__*/ $da7a76ffd4ff6592$var$_react.default.createElement($da7a76ffd4ff6592$var$_CarouselFilmStripAttachment.default, {
            activity: activity,
            attachment: attachment,
            fromUser: fromUser,
            hasAvatar: hasAvatar,
            hideNub: hideNub,
            index: index,
            key: index,
            renderAttachment: renderAttachment,
            showAvatar: showAvatar,
            showNub: showNub
        });
    }))))), /*#__PURE__*/ $da7a76ffd4ff6592$var$_react.default.createElement("div", {
        className: "webchat__carousel-filmstrip__alignment-pad"
    })), showActivityStatus && /*#__PURE__*/ $da7a76ffd4ff6592$var$_react.default.createElement("div", {
        className: "webchat__carousel-filmstrip__status"
    }, /*#__PURE__*/ $da7a76ffd4ff6592$var$_react.default.createElement("div", {
        className: "webchat__carousel-filmstrip__avatar-gutter"
    }), /*#__PURE__*/ $da7a76ffd4ff6592$var$_react.default.createElement("div", {
        className: "webchat__carousel-filmstrip__nub-pad"
    }), renderActivityStatus({
        hideTimestamp: hideTimestamp
    })));
};
$da7a76ffd4ff6592$var$CarouselFilmStrip.defaultProps = {
    className: "",
    hideTimestamp: false,
    renderActivityStatus: false,
    renderAvatar: false,
    showCallout: false
};
$da7a76ffd4ff6592$var$CarouselFilmStrip.propTypes = {
    activity: $da7a76ffd4ff6592$var$_propTypes.default.shape({
        attachments: $da7a76ffd4ff6592$var$_propTypes.default.array,
        channelData: $da7a76ffd4ff6592$var$_propTypes.default.shape({
            messageBack: $da7a76ffd4ff6592$var$_propTypes.default.shape({
                displayText: $da7a76ffd4ff6592$var$_propTypes.default.string
            })
        }),
        from: $da7a76ffd4ff6592$var$_propTypes.default.shape({
            role: $da7a76ffd4ff6592$var$_propTypes.default.string.isRequired
        }).isRequired,
        text: $da7a76ffd4ff6592$var$_propTypes.default.string,
        textFormat: $da7a76ffd4ff6592$var$_propTypes.default.string,
        timestamp: $da7a76ffd4ff6592$var$_propTypes.default.string
    }).isRequired,
    className: $da7a76ffd4ff6592$var$_propTypes.default.string,
    hideTimestamp: $da7a76ffd4ff6592$var$_propTypes.default.bool,
    renderActivityStatus: $da7a76ffd4ff6592$var$_propTypes.default.oneOfType([
        $da7a76ffd4ff6592$var$_propTypes.default.oneOf([
            false
        ]),
        $da7a76ffd4ff6592$var$_propTypes.default.func
    ]),
    renderAttachment: $da7a76ffd4ff6592$var$_propTypes.default.func.isRequired,
    renderAvatar: $da7a76ffd4ff6592$var$_propTypes.default.oneOfType([
        $da7a76ffd4ff6592$var$_propTypes.default.oneOf([
            false
        ]),
        $da7a76ffd4ff6592$var$_propTypes.default.func
    ]),
    showCallout: $da7a76ffd4ff6592$var$_propTypes.default.bool
};
var $da7a76ffd4ff6592$var$_default = $da7a76ffd4ff6592$var$CarouselFilmStrip;
module.exports.default = $da7a76ffd4ff6592$var$_default;

});
parcelRequire.register("esGjx", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $hd4g0 = parcelRequire("hd4g0");

var $a87480f147b9c042$var$_classnames = $a87480f147b9c042$var$_interopRequireDefault((parcelRequire("5A4MD")));

var $a87480f147b9c042$var$_propTypes = $a87480f147b9c042$var$_interopRequireDefault((parcelRequire("f7UXb")));

var $a87480f147b9c042$var$_react = $a87480f147b9c042$var$_interopRequireDefault((parcelRequire("eO7Kz")));

var $a87480f147b9c042$var$_isZeroOrPositive = $a87480f147b9c042$var$_interopRequireDefault((parcelRequire("fFkLN")));

var $a87480f147b9c042$var$_useStyleSet3 = $a87480f147b9c042$var$_interopRequireDefault((parcelRequire("gC6jZ")));

var $a87480f147b9c042$var$_useStyleToEmotionObject = $a87480f147b9c042$var$_interopRequireDefault((parcelRequire("6l4uV")));
function $a87480f147b9c042$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $a87480f147b9c042$var$_slicedToArray(arr, i) {
    return $a87480f147b9c042$var$_arrayWithHoles(arr) || $a87480f147b9c042$var$_iterableToArrayLimit(arr, i) || $a87480f147b9c042$var$_unsupportedIterableToArray(arr, i) || $a87480f147b9c042$var$_nonIterableRest();
}
function $a87480f147b9c042$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $a87480f147b9c042$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $a87480f147b9c042$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $a87480f147b9c042$var$_arrayLikeToArray(o, minLen);
}
function $a87480f147b9c042$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $a87480f147b9c042$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $a87480f147b9c042$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
var $a87480f147b9c042$var$useDirection = $hd4g0.hooks.useDirection, $a87480f147b9c042$var$useStyleOptions = $hd4g0.hooks.useStyleOptions;
var $a87480f147b9c042$var$ROOT_STYLE = {
    "&.webchat__bubble": {
        display: "flex",
        position: "relative",
        "& .webchat__bubble__nub-pad": {
            flexShrink: 0
        },
        "& .webchat__bubble__content": {
            flexGrow: 1,
            // This is for hiding content outside of the bubble, for example, content outside of border radius
            overflow: "hidden"
        }
    }
};
function $a87480f147b9c042$var$acuteNubSVG(nubSize, strokeWidth, side) {
    var upSideDown = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
    if (typeof nubSize !== "number") return false;
    var halfNubSize = nubSize / 2;
    var halfStrokeWidth = strokeWidth / 2; // Horizontally mirror the nub if it is from user
    var horizontalTransform = side === "bot" ? "" : "translate(".concat(halfNubSize, " 0) scale(-1 1) translate(").concat(-halfNubSize, " 0)"); // Vertically mirror the nub if it is up-side-down
    var verticalTransform = upSideDown ? "translate(0 ".concat(halfNubSize, ") scale(1 -1) translate(0 ").concat(-halfNubSize, ")") : "";
    var p1 = [
        nubSize,
        halfStrokeWidth
    ].join(" ");
    var p2 = [
        strokeWidth,
        halfStrokeWidth
    ].join(" ");
    var p3 = [
        nubSize + strokeWidth,
        nubSize + halfStrokeWidth
    ].join(" ");
    return /*#__PURE__*/ $a87480f147b9c042$var$_react.default.createElement("svg", {
        className: "webchat__bubble__nub",
        version: "1.1",
        viewBox: "0 0 ".concat(nubSize, " ").concat(nubSize),
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ $a87480f147b9c042$var$_react.default.createElement("g", {
        transform: "".concat(horizontalTransform, " ").concat(verticalTransform)
    }, /*#__PURE__*/ $a87480f147b9c042$var$_react.default.createElement("path", {
        className: "webchat__bubble__nub-outline",
        d: "M".concat(p1, " L").concat(p2, " L").concat(p3)
    })));
}
var $a87480f147b9c042$var$Bubble = function Bubble(_ref) {
    var ariaHidden = _ref["aria-hidden"], children = _ref.children, className = _ref.className, fromUser = _ref.fromUser, nub = _ref.nub;
    var _useStyleSet = (0, $a87480f147b9c042$var$_useStyleSet3.default)(), _useStyleSet2 = $a87480f147b9c042$var$_slicedToArray(_useStyleSet, 1), bubbleStyleSet = _useStyleSet2[0].bubble;
    var _useDirection = $a87480f147b9c042$var$useDirection(), _useDirection2 = $a87480f147b9c042$var$_slicedToArray(_useDirection, 1), direction = _useDirection2[0];
    var _useStyleOptions = $a87480f147b9c042$var$useStyleOptions(), _useStyleOptions2 = $a87480f147b9c042$var$_slicedToArray(_useStyleOptions, 1), _useStyleOptions2$ = _useStyleOptions2[0], bubbleBorderWidth = _useStyleOptions2$.bubbleBorderWidth, bubbleFromUserBorderWidth = _useStyleOptions2$.bubbleFromUserBorderWidth, bubbleFromUserNubSize = _useStyleOptions2$.bubbleFromUserNubSize, bubbleNubSize = _useStyleOptions2$.bubbleNubSize, bubbleNubOffset = _useStyleOptions2$.bubbleNubOffset, bubbleFromUserNubOffset = _useStyleOptions2$.bubbleFromUserNubOffset;
    var rootClassName = (0, $a87480f147b9c042$var$_useStyleToEmotionObject.default)()($a87480f147b9c042$var$ROOT_STYLE) + "";
    var _ref2 = fromUser ? {
        borderWidth: bubbleFromUserBorderWidth,
        nubOffset: bubbleFromUserNubOffset,
        nubSize: bubbleFromUserNubSize,
        side: "user"
    } : {
        borderWidth: bubbleBorderWidth,
        nubOffset: bubbleNubOffset,
        nubSize: bubbleNubSize,
        side: "bot"
    }, borderWidth = _ref2.borderWidth, nubOffset = _ref2.nubOffset, nubSize = _ref2.nubSize, side = _ref2.side;
    return /*#__PURE__*/ $a87480f147b9c042$var$_react.default.createElement("div", {
        "aria-hidden": ariaHidden,
        className: (0, $a87480f147b9c042$var$_classnames.default)("webchat__bubble", {
            "webchat__bubble--from-user": fromUser,
            "webchat__bubble--hide-nub": nub !== true && nub !== false,
            "webchat__bubble--nub-on-top": (0, $a87480f147b9c042$var$_isZeroOrPositive.default)(nubOffset),
            "webchat__bubble--rtl": direction === "rtl",
            "webchat__bubble--show-nub": nub === true
        }, rootClassName, bubbleStyleSet + "", (className || "") + "")
    }, /*#__PURE__*/ $a87480f147b9c042$var$_react.default.createElement("div", {
        className: "webchat__bubble__nub-pad"
    }), /*#__PURE__*/ $a87480f147b9c042$var$_react.default.createElement("div", {
        className: "webchat__bubble__content"
    }, children), nub === true && $a87480f147b9c042$var$acuteNubSVG(nubSize, borderWidth, side, !(0, $a87480f147b9c042$var$_isZeroOrPositive.default)(nubOffset)));
};
$a87480f147b9c042$var$Bubble.defaultProps = {
    "aria-hidden": undefined,
    children: undefined,
    className: "",
    fromUser: false,
    nub: false
};
$a87480f147b9c042$var$Bubble.propTypes = {
    "aria-hidden": $a87480f147b9c042$var$_propTypes.default.bool,
    children: $a87480f147b9c042$var$_propTypes.default.any,
    className: $a87480f147b9c042$var$_propTypes.default.string,
    fromUser: $a87480f147b9c042$var$_propTypes.default.bool,
    nub: $a87480f147b9c042$var$_propTypes.default.oneOf([
        true,
        false,
        "hidden"
    ])
};
var $a87480f147b9c042$var$_default = $a87480f147b9c042$var$Bubble;
module.exports.default = $a87480f147b9c042$var$_default;

});

parcelRequire.register("excCN", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $hd4g0 = parcelRequire("hd4g0");

var $a94df0bfdc59d4fe$var$_classnames = $a94df0bfdc59d4fe$var$_interopRequireDefault((parcelRequire("5A4MD")));

var $a94df0bfdc59d4fe$var$_propTypes = $a94df0bfdc59d4fe$var$_interopRequireDefault((parcelRequire("f7UXb")));

var $a94df0bfdc59d4fe$var$_react = $a94df0bfdc59d4fe$var$_interopRequireDefault((parcelRequire("eO7Kz")));

var $a94df0bfdc59d4fe$var$_Bubble = $a94df0bfdc59d4fe$var$_interopRequireDefault((parcelRequire("esGjx")));

var $a94df0bfdc59d4fe$var$_ScreenReaderText = $a94df0bfdc59d4fe$var$_interopRequireDefault((parcelRequire("3NTZI")));

var $a94df0bfdc59d4fe$var$_useStyleSet3 = $a94df0bfdc59d4fe$var$_interopRequireDefault((parcelRequire("gC6jZ")));
function $a94df0bfdc59d4fe$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $a94df0bfdc59d4fe$var$_slicedToArray(arr, i) {
    return $a94df0bfdc59d4fe$var$_arrayWithHoles(arr) || $a94df0bfdc59d4fe$var$_iterableToArrayLimit(arr, i) || $a94df0bfdc59d4fe$var$_unsupportedIterableToArray(arr, i) || $a94df0bfdc59d4fe$var$_nonIterableRest();
}
function $a94df0bfdc59d4fe$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $a94df0bfdc59d4fe$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $a94df0bfdc59d4fe$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $a94df0bfdc59d4fe$var$_arrayLikeToArray(o, minLen);
}
function $a94df0bfdc59d4fe$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $a94df0bfdc59d4fe$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $a94df0bfdc59d4fe$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
var $a94df0bfdc59d4fe$var$useDirection = $hd4g0.hooks.useDirection, $a94df0bfdc59d4fe$var$useLocalizer = $hd4g0.hooks.useLocalizer;
var $a94df0bfdc59d4fe$var$CarouselFilmStripAttachment = function CarouselFilmStripAttachment(_ref) {
    var activity = _ref.activity, attachment = _ref.attachment, className = _ref.className, fromUser = _ref.fromUser, hasAvatar = _ref.hasAvatar, hideNub = _ref.hideNub, index = _ref.index, renderAttachment = _ref.renderAttachment, showAvatar = _ref.showAvatar, showNub = _ref.showNub;
    var _useDirection = $a94df0bfdc59d4fe$var$useDirection(), _useDirection2 = $a94df0bfdc59d4fe$var$_slicedToArray(_useDirection, 1), direction = _useDirection2[0];
    var localize = $a94df0bfdc59d4fe$var$useLocalizer();
    var _useStyleSet = (0, $a94df0bfdc59d4fe$var$_useStyleSet3.default)(), _useStyleSet2 = $a94df0bfdc59d4fe$var$_slicedToArray(_useStyleSet, 1), carouselFilmStripAttachmentStyleSet = _useStyleSet2[0].carouselFilmStripAttachment;
    var attachedAlt = localize(fromUser ? "ACTIVITY_YOU_ATTACHED_ALT" : "ACTIVITY_BOT_ATTACHED_ALT");
    return /*#__PURE__*/ $a94df0bfdc59d4fe$var$_react.default.createElement("li", {
        "aria-roledescription": "attachment",
        className: (0, $a94df0bfdc59d4fe$var$_classnames.default)("webchat__carousel-filmstrip-attachment", {
            "webchat__carousel-filmstrip-attachment--hide-avatar": hasAvatar && !showAvatar,
            "webchat__carousel-filmstrip-attachment--hide-nub": hideNub,
            "webchat__carousel-filmstrip-attachment--rtl": direction === "rtl",
            "webchat__carousel-filmstrip-attachment--show-avatar": showAvatar,
            "webchat__carousel-filmstrip-attachment--show-nub": showNub
        }, "react-film__filmstrip__item", carouselFilmStripAttachmentStyleSet + "", (className || "") + ""),
        role: "listitem",
        tabIndex: 0
    }, /*#__PURE__*/ $a94df0bfdc59d4fe$var$_react.default.createElement($a94df0bfdc59d4fe$var$_ScreenReaderText.default, {
        text: attachedAlt
    }), /*#__PURE__*/ $a94df0bfdc59d4fe$var$_react.default.createElement($a94df0bfdc59d4fe$var$_Bubble.default, {
        fromUser: fromUser,
        key: index,
        nub: false
    }, renderAttachment({
        activity: activity,
        attachment: attachment
    }), /*#__PURE__*/ $a94df0bfdc59d4fe$var$_react.default.createElement("div", {
        className: "webchat__carousel-filmstrip-attachment--focus"
    })));
};
$a94df0bfdc59d4fe$var$CarouselFilmStripAttachment.defaultProps = {
    className: ""
};
$a94df0bfdc59d4fe$var$CarouselFilmStripAttachment.propTypes = {
    activity: $a94df0bfdc59d4fe$var$_propTypes.default.shape({
        attachments: $a94df0bfdc59d4fe$var$_propTypes.default.array,
        from: $a94df0bfdc59d4fe$var$_propTypes.default.shape({
            role: $a94df0bfdc59d4fe$var$_propTypes.default.string.isRequired
        }).isRequired,
        text: $a94df0bfdc59d4fe$var$_propTypes.default.string,
        textFormat: $a94df0bfdc59d4fe$var$_propTypes.default.string,
        timestamp: $a94df0bfdc59d4fe$var$_propTypes.default.string
    }).isRequired,
    attachment: $a94df0bfdc59d4fe$var$_propTypes.default.shape({
        content: $a94df0bfdc59d4fe$var$_propTypes.default.any
    }).isRequired,
    className: $a94df0bfdc59d4fe$var$_propTypes.default.string,
    fromUser: $a94df0bfdc59d4fe$var$_propTypes.default.any.isRequired,
    hasAvatar: $a94df0bfdc59d4fe$var$_propTypes.default.any.isRequired,
    hideNub: $a94df0bfdc59d4fe$var$_propTypes.default.bool.isRequired,
    index: $a94df0bfdc59d4fe$var$_propTypes.default.number.isRequired,
    renderAttachment: $a94df0bfdc59d4fe$var$_propTypes.default.func.isRequired,
    showAvatar: $a94df0bfdc59d4fe$var$_propTypes.default.bool.isRequired,
    showNub: $a94df0bfdc59d4fe$var$_propTypes.default.bool.isRequired
};
var $a94df0bfdc59d4fe$var$_default = $a94df0bfdc59d4fe$var$CarouselFilmStripAttachment;
module.exports.default = $a94df0bfdc59d4fe$var$_default;

});



parcelRequire.register("jcA5b", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = module.exports.connectStackedLayout = void 0;

var $hd4g0 = parcelRequire("hd4g0");

var $dfab20962f9d33d3$var$_classnames = $dfab20962f9d33d3$var$_interopRequireDefault((parcelRequire("5A4MD")));

var $dfab20962f9d33d3$var$_propTypes = $dfab20962f9d33d3$var$_interopRequireDefault((parcelRequire("f7UXb")));

var $dfab20962f9d33d3$var$_react = $dfab20962f9d33d3$var$_interopRequireDefault((parcelRequire("eO7Kz")));

var $dfab20962f9d33d3$var$_Bubble = $dfab20962f9d33d3$var$_interopRequireDefault((parcelRequire("esGjx")));

var $dfab20962f9d33d3$var$_connectToWebChat = $dfab20962f9d33d3$var$_interopRequireDefault((parcelRequire("86vmQ")));

var $dfab20962f9d33d3$var$_isZeroOrPositive = $dfab20962f9d33d3$var$_interopRequireDefault((parcelRequire("fFkLN")));

var $dfab20962f9d33d3$var$_ScreenReaderText = $dfab20962f9d33d3$var$_interopRequireDefault((parcelRequire("3NTZI")));

var $dfab20962f9d33d3$var$_textFormatToContentType = $dfab20962f9d33d3$var$_interopRequireDefault((parcelRequire("eNc4R")));

var $dfab20962f9d33d3$var$_useStyleSet3 = $dfab20962f9d33d3$var$_interopRequireDefault((parcelRequire("gC6jZ")));

var $dfab20962f9d33d3$var$_useStyleToEmotionObject = $dfab20962f9d33d3$var$_interopRequireDefault((parcelRequire("6l4uV")));

var $dfab20962f9d33d3$var$_useUniqueId = $dfab20962f9d33d3$var$_interopRequireDefault((parcelRequire("cdwtx")));
function $dfab20962f9d33d3$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $dfab20962f9d33d3$var$_slicedToArray(arr, i) {
    return $dfab20962f9d33d3$var$_arrayWithHoles(arr) || $dfab20962f9d33d3$var$_iterableToArrayLimit(arr, i) || $dfab20962f9d33d3$var$_unsupportedIterableToArray(arr, i) || $dfab20962f9d33d3$var$_nonIterableRest();
}
function $dfab20962f9d33d3$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $dfab20962f9d33d3$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $dfab20962f9d33d3$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $dfab20962f9d33d3$var$_arrayLikeToArray(o, minLen);
}
function $dfab20962f9d33d3$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $dfab20962f9d33d3$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $dfab20962f9d33d3$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
var $dfab20962f9d33d3$var$useAvatarForBot = $hd4g0.hooks.useAvatarForBot, $dfab20962f9d33d3$var$useAvatarForUser = $hd4g0.hooks.useAvatarForUser, $dfab20962f9d33d3$var$useLocalizer = $hd4g0.hooks.useLocalizer, $dfab20962f9d33d3$var$useStyleOptions = $hd4g0.hooks.useStyleOptions;
var $dfab20962f9d33d3$var$ROOT_STYLE = {
    "&.webchat__stacked-layout": {
        position: "relative",
        // This is to keep screen reader text in the destinated area.
        "& .webchat__stacked-layout__attachment-row, & .webchat__stacked-layout__main, & .webchat__stacked-layout__message-row, & .webchat__stacked-layout__status": {
            display: "flex"
        },
        "& .webchat__stacked-layout__alignment-pad": {
            flexShrink: 0
        },
        "& .webchat__stacked-layout__attachment": {
            width: "100%"
        },
        "& .webchat__stacked-layout__avatar-gutter": {
            display: "flex",
            flexDirection: "column",
            flexShrink: 0
        },
        "&.webchat__stacked-layout--from-user": {
            "& .webchat__stacked-layout__attachment-row, & .webchat__stacked-layout__main, & .webchat__stacked-layout__message-row, & .webchat__stacked-layout__status": {
                flexDirection: "row-reverse"
            }
        },
        "& .webchat__stacked-layout__content": {
            flex: 1,
            // This is for bottom aligning an avatar with a message bubble shorter than the avatar.
            // Related to the test at activityGrouping.avatarMiddleware.atBottom.js.
            display: "flex",
            flexDirection: "column",
            // This "overflow: hidden" is to make sure text overflow will get clipped correctly.
            // Related to the test at basic.js "long URLs with keep-all".
            overflow: "hidden"
        },
        "& .webchat__stacked-layout__nub-pad": {
            flexShrink: 0
        }
    }
};
var $dfab20962f9d33d3$var$connectStackedLayout = function connectStackedLayout() {
    for(var _len = arguments.length, selectors = new Array(_len), _key = 0; _key < _len; _key++)selectors[_key] = arguments[_key];
    return $dfab20962f9d33d3$var$_connectToWebChat.default.apply(void 0, [
        function(_ref, _ref2) {
            var language = _ref.language, _ref$styleSet$options = _ref.styleSet.options, botAvatarInitials = _ref$styleSet$options.botAvatarInitials, userAvatarInitials = _ref$styleSet$options.userAvatarInitials;
            var _ref2$activity = _ref2.activity;
            _ref2$activity = _ref2$activity === void 0 ? {} : _ref2$activity;
            var _ref2$activity$from = _ref2$activity.from;
            _ref2$activity$from = _ref2$activity$from === void 0 ? {} : _ref2$activity$from;
            var _ref2$activity$from$r = _ref2$activity$from.role, role = _ref2$activity$from$r === void 0 ? undefined : _ref2$activity$from$r;
            return {
                avatarInitials: role === "user" ? userAvatarInitials : botAvatarInitials,
                language: language,
                // TODO: [P4] We want to deprecate botAvatarInitials/userAvatarInitials because they are not as helpful as avatarInitials
                botAvatarInitials: botAvatarInitials,
                userAvatarInitials: userAvatarInitials
            };
        }
    ].concat(selectors));
};
module.exports.connectStackedLayout = $dfab20962f9d33d3$var$connectStackedLayout;
var $dfab20962f9d33d3$var$StackedLayout = function StackedLayout(_ref3) {
    var _activity$channelData, _activity$channelData2;
    var activity = _ref3.activity, hideTimestamp = _ref3.hideTimestamp, renderActivityStatus = _ref3.renderActivityStatus, renderAttachment = _ref3.renderAttachment, renderAvatar = _ref3.renderAvatar, showCallout = _ref3.showCallout;
    var _useStyleOptions = $dfab20962f9d33d3$var$useStyleOptions(), _useStyleOptions2 = $dfab20962f9d33d3$var$_slicedToArray(_useStyleOptions, 1), styleOptions = _useStyleOptions2[0];
    var _useAvatarForBot = $dfab20962f9d33d3$var$useAvatarForBot(), _useAvatarForBot2 = $dfab20962f9d33d3$var$_slicedToArray(_useAvatarForBot, 1), botInitials = _useAvatarForBot2[0].initials;
    var _useAvatarForUser = $dfab20962f9d33d3$var$useAvatarForUser(), _useAvatarForUser2 = $dfab20962f9d33d3$var$_slicedToArray(_useAvatarForUser, 1), userInitials = _useAvatarForUser2[0].initials;
    var _useStyleSet = (0, $dfab20962f9d33d3$var$_useStyleSet3.default)(), _useStyleSet2 = $dfab20962f9d33d3$var$_slicedToArray(_useStyleSet, 1), stackedLayoutStyleSet = _useStyleSet2[0].stackedLayout;
    var ariaLabelId = (0, $dfab20962f9d33d3$var$_useUniqueId.default)("webchat__stacked-layout__id");
    var localize = $dfab20962f9d33d3$var$useLocalizer();
    var rootClassName = (0, $dfab20962f9d33d3$var$_useStyleToEmotionObject.default)()($dfab20962f9d33d3$var$ROOT_STYLE) + "";
    var bubbleNubOffset = styleOptions.bubbleNubOffset, bubbleNubSize = styleOptions.bubbleNubSize, bubbleFromUserNubOffset = styleOptions.bubbleFromUserNubOffset, bubbleFromUserNubSize = styleOptions.bubbleFromUserNubSize;
    var isMessage = activity.type === "message";
    var attachments = isMessage && activity.attachments || [];
    var fromUser = activity.from.role === "user";
    var messageBackDisplayText = isMessage && ((_activity$channelData = activity.channelData) === null || _activity$channelData === void 0 ? void 0 : (_activity$channelData2 = _activity$channelData.messageBack) === null || _activity$channelData2 === void 0 ? void 0 : _activity$channelData2.displayText) || "";
    var activityDisplayText = isMessage ? messageBackDisplayText || activity.text : "";
    var attachedAlt = localize(fromUser ? "ACTIVITY_YOU_ATTACHED_ALT" : "ACTIVITY_BOT_ATTACHED_ALT");
    var greetingAlt = (fromUser ? localize("ACTIVITY_YOU_SAID_ALT") : localize("ACTIVITY_BOT_SAID_ALT", botInitials || "")).replace(/[\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]{2,}/g, " ");
    var initials = fromUser ? userInitials : botInitials;
    var nubOffset = fromUser ? bubbleFromUserNubOffset : bubbleNubOffset;
    var nubSize = fromUser ? bubbleFromUserNubSize : bubbleNubSize;
    var otherInitials = fromUser ? botInitials : userInitials;
    var otherNubSize = fromUser ? bubbleNubSize : bubbleFromUserNubSize;
    var hasAvatar = initials || typeof initials === "string";
    var hasOtherAvatar = otherInitials || typeof otherInitials === "string";
    var hasNub = typeof nubSize === "number";
    var hasOtherNub = typeof otherNubSize === "number";
    var topAlignedCallout = (0, $dfab20962f9d33d3$var$_isZeroOrPositive.default)(nubOffset);
    var extraTrailing = !hasOtherAvatar && hasOtherNub; // This is for bot message with user nub and no user avatar. And vice versa.
    var showAvatar = showCallout && hasAvatar && !!renderAvatar;
    var showNub = showCallout && hasNub && (topAlignedCallout || !(attachments !== null && attachments !== void 0 && attachments.length));
    return /*#__PURE__*/ $dfab20962f9d33d3$var$_react.default.createElement("div", {
        "aria-labelledby": activityDisplayText ? ariaLabelId : undefined,
        className: (0, $dfab20962f9d33d3$var$_classnames.default)("webchat__stacked-layout", rootClassName, stackedLayoutStyleSet + "", {
            "webchat__stacked-layout--extra-trailing": extraTrailing,
            "webchat__stacked-layout--from-user": fromUser,
            "webchat__stacked-layout--hide-avatar": hasAvatar && !showAvatar,
            "webchat__stacked-layout--hide-nub": hasNub && !showNub,
            "webchat__stacked-layout--no-message": !activityDisplayText,
            "webchat__stacked-layout--show-avatar": showAvatar,
            "webchat__stacked-layout--show-nub": showNub,
            "webchat__stacked-layout--top-callout": topAlignedCallout
        })
    }, /*#__PURE__*/ $dfab20962f9d33d3$var$_react.default.createElement("div", {
        className: "webchat__stacked-layout__main"
    }, /*#__PURE__*/ $dfab20962f9d33d3$var$_react.default.createElement("div", {
        className: "webchat__stacked-layout__avatar-gutter"
    }, showAvatar && renderAvatar()), /*#__PURE__*/ $dfab20962f9d33d3$var$_react.default.createElement("div", {
        className: "webchat__stacked-layout__content"
    }, !!activityDisplayText && /*#__PURE__*/ $dfab20962f9d33d3$var$_react.default.createElement("div", {
        "aria-roledescription": "message",
        className: "webchat__stacked-layout__message-row" // Disable "Prop `id` is forbidden on DOM Nodes" rule because we are using the ID prop for accessibility.
        ,
        id: ariaLabelId,
        role: "group"
    }, /*#__PURE__*/ $dfab20962f9d33d3$var$_react.default.createElement($dfab20962f9d33d3$var$_ScreenReaderText.default, {
        text: greetingAlt
    }), /*#__PURE__*/ $dfab20962f9d33d3$var$_react.default.createElement($dfab20962f9d33d3$var$_Bubble.default, {
        className: "webchat__stacked-layout__message",
        fromUser: fromUser,
        nub: showNub || (hasAvatar || hasNub ? "hidden" : false)
    }, renderAttachment({
        activity: activity,
        attachment: isMessage ? {
            content: activityDisplayText,
            contentType: (0, $dfab20962f9d33d3$var$_textFormatToContentType.default)(activity.textFormat)
        } : undefined
    }))), attachments.map(function(attachment, index) {
        return /*#__PURE__*/ $dfab20962f9d33d3$var$_react.default.createElement("div", {
            "aria-roledescription": "attachment",
            className: (0, $dfab20962f9d33d3$var$_classnames.default)("webchat__stacked-layout__attachment-row", {
                "webchat__stacked-layout__attachment-row--first": !index
            }),
            key: index,
            role: "group"
        }, /*#__PURE__*/ $dfab20962f9d33d3$var$_react.default.createElement($dfab20962f9d33d3$var$_ScreenReaderText.default, {
            text: attachedAlt
        }), /*#__PURE__*/ $dfab20962f9d33d3$var$_react.default.createElement($dfab20962f9d33d3$var$_Bubble.default, {
            className: "webchat__stacked-layout__attachment",
            fromUser: fromUser,
            key: index,
            nub: hasAvatar || hasNub ? "hidden" : false
        }, renderAttachment({
            activity: activity,
            attachment: attachment
        })));
    })), /*#__PURE__*/ $dfab20962f9d33d3$var$_react.default.createElement("div", {
        className: "webchat__stacked-layout__alignment-pad"
    })), typeof renderActivityStatus === "function" && /*#__PURE__*/ $dfab20962f9d33d3$var$_react.default.createElement("div", {
        className: "webchat__stacked-layout__status"
    }, /*#__PURE__*/ $dfab20962f9d33d3$var$_react.default.createElement("div", {
        className: "webchat__stacked-layout__avatar-gutter"
    }), /*#__PURE__*/ $dfab20962f9d33d3$var$_react.default.createElement("div", {
        className: "webchat__stacked-layout__nub-pad"
    }), renderActivityStatus({
        hideTimestamp: hideTimestamp
    }), /*#__PURE__*/ $dfab20962f9d33d3$var$_react.default.createElement("div", {
        className: "webchat__stacked-layout__alignment-pad"
    })));
};
$dfab20962f9d33d3$var$StackedLayout.defaultProps = {
    hideTimestamp: false,
    renderActivityStatus: function renderActivityStatus() {
        return false;
    },
    renderAvatar: undefined,
    showCallout: true
};
$dfab20962f9d33d3$var$StackedLayout.propTypes = {
    // PropTypes cannot fully capture TypeScript types.
    // @ts-ignore
    activity: $dfab20962f9d33d3$var$_propTypes.default.shape({
        attachments: $dfab20962f9d33d3$var$_propTypes.default.array,
        channelData: $dfab20962f9d33d3$var$_propTypes.default.shape({
            messageBack: $dfab20962f9d33d3$var$_propTypes.default.shape({
                displayText: $dfab20962f9d33d3$var$_propTypes.default.string
            })
        }),
        from: $dfab20962f9d33d3$var$_propTypes.default.shape({
            role: $dfab20962f9d33d3$var$_propTypes.default.string.isRequired
        }).isRequired,
        text: $dfab20962f9d33d3$var$_propTypes.default.string,
        textFormat: $dfab20962f9d33d3$var$_propTypes.default.oneOf([
            "markdown",
            "plain",
            "xml"
        ]),
        timestamp: $dfab20962f9d33d3$var$_propTypes.default.string,
        type: $dfab20962f9d33d3$var$_propTypes.default.string.isRequired
    }).isRequired,
    hideTimestamp: $dfab20962f9d33d3$var$_propTypes.default.bool,
    // PropTypes cannot validate precisely with its TypeScript counterpart.
    // @ts-ignore
    renderActivityStatus: $dfab20962f9d33d3$var$_propTypes.default.oneOfType([
        $dfab20962f9d33d3$var$_propTypes.default.oneOf([
            false
        ]),
        $dfab20962f9d33d3$var$_propTypes.default.func
    ]),
    renderAttachment: $dfab20962f9d33d3$var$_propTypes.default.func.isRequired,
    // PropTypes cannot validate precisely with its TypeScript counterpart.
    // @ts-ignore
    renderAvatar: $dfab20962f9d33d3$var$_propTypes.default.oneOfType([
        $dfab20962f9d33d3$var$_propTypes.default.oneOf([
            false
        ]),
        $dfab20962f9d33d3$var$_propTypes.default.func
    ]),
    showCallout: $dfab20962f9d33d3$var$_propTypes.default.bool
};
var $dfab20962f9d33d3$var$_default = $dfab20962f9d33d3$var$StackedLayout;
module.exports.default = $dfab20962f9d33d3$var$_default;

});


parcelRequire.register("elZtZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $a732b80698450448$var$createCoreMiddleware;

var $a732b80698450448$var$_createSendStatusMiddleware = $a732b80698450448$var$_interopRequireDefault((parcelRequire("6ASqN")));

var $a732b80698450448$var$_createTimestampMiddleware = $a732b80698450448$var$_interopRequireDefault((parcelRequire("6QGuD")));
function $a732b80698450448$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $a732b80698450448$var$createCoreMiddleware() {
    return [
        (0, $a732b80698450448$var$_createSendStatusMiddleware.default)(),
        (0, $a732b80698450448$var$_createTimestampMiddleware.default)()
    ];
}

});
parcelRequire.register("6ASqN", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $4cd053cb7565081a$var$createSendStatusMiddleware;

var $4cd053cb7565081a$var$_react = $4cd053cb7565081a$var$_interopRequireDefault((parcelRequire("eO7Kz")));

var $fjDvy = parcelRequire("fjDvy");

var $4cd053cb7565081a$var$_SendStatus2 = $4cd053cb7565081a$var$_interopRequireDefault((parcelRequire("cZ0iP")));
var $4cd053cb7565081a$var$_excluded = [
    "activity",
    "sendState"
];
function $4cd053cb7565081a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $4cd053cb7565081a$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $4cd053cb7565081a$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $4cd053cb7565081a$var$ownKeys(Object(source), !0).forEach(function(key) {
            $4cd053cb7565081a$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $4cd053cb7565081a$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $4cd053cb7565081a$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $4cd053cb7565081a$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $4cd053cb7565081a$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $4cd053cb7565081a$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $4cd053cb7565081a$var$createSendStatusMiddleware() {
    return function() {
        return function(next) {
            return(// eslint-disable-next-line react/prop-types
            function(_ref) {
                var activity = _ref.activity, sendState = _ref.sendState, args = $4cd053cb7565081a$var$_objectWithoutProperties(_ref, $4cd053cb7565081a$var$_excluded);
                switch(sendState){
                    case $fjDvy.SENDING:
                    case $fjDvy.SEND_FAILED:
                        return /*#__PURE__*/ $4cd053cb7565081a$var$_react.default.createElement($4cd053cb7565081a$var$_SendStatus2.default, {
                            activity: activity,
                            sendStatus: sendState
                        });
                    default:
                        return next($4cd053cb7565081a$var$_objectSpread({
                            activity: activity,
                            sendState: sendState
                        }, args));
                }
            });
        };
    };
}

});
parcelRequire.register("cZ0iP", function(module, exports) {
"use strict";
function $973b6aa806f94e6c$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $973b6aa806f94e6c$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $973b6aa806f94e6c$var$_typeof(obj);
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = module.exports.connectSendStatus = void 0;

var $hd4g0 = parcelRequire("hd4g0");

var $973b6aa806f94e6c$var$_propTypes = $973b6aa806f94e6c$var$_interopRequireDefault((parcelRequire("f7UXb")));

var $973b6aa806f94e6c$var$_react = $973b6aa806f94e6c$var$_interopRequireWildcard((parcelRequire("eO7Kz")));

var $fjDvy = parcelRequire("fjDvy");

var $973b6aa806f94e6c$var$_connectToWebChat = $973b6aa806f94e6c$var$_interopRequireDefault((parcelRequire("86vmQ")));

var $973b6aa806f94e6c$var$_SendFailedRetry = $973b6aa806f94e6c$var$_interopRequireDefault((parcelRequire("6u5Ao")));

var $973b6aa806f94e6c$var$_useFocus = $973b6aa806f94e6c$var$_interopRequireDefault((parcelRequire("kPV7d")));

var $973b6aa806f94e6c$var$_useStyleSet3 = $973b6aa806f94e6c$var$_interopRequireDefault((parcelRequire("gC6jZ")));
function $973b6aa806f94e6c$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($973b6aa806f94e6c$var$_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $973b6aa806f94e6c$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || $973b6aa806f94e6c$var$_typeof(obj) !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $973b6aa806f94e6c$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $973b6aa806f94e6c$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $973b6aa806f94e6c$var$_slicedToArray(arr, i) {
    return $973b6aa806f94e6c$var$_arrayWithHoles(arr) || $973b6aa806f94e6c$var$_iterableToArrayLimit(arr, i) || $973b6aa806f94e6c$var$_unsupportedIterableToArray(arr, i) || $973b6aa806f94e6c$var$_nonIterableRest();
}
function $973b6aa806f94e6c$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $973b6aa806f94e6c$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $973b6aa806f94e6c$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $973b6aa806f94e6c$var$_arrayLikeToArray(o, minLen);
}
function $973b6aa806f94e6c$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $973b6aa806f94e6c$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $973b6aa806f94e6c$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
var $973b6aa806f94e6c$var$useLocalizer = $hd4g0.hooks.useLocalizer, $973b6aa806f94e6c$var$usePostActivity = $hd4g0.hooks.usePostActivity;
var $973b6aa806f94e6c$var$connectSendStatus = function connectSendStatus() {
    for(var _len = arguments.length, selectors = new Array(_len), _key = 0; _key < _len; _key++)selectors[_key] = arguments[_key];
    return $973b6aa806f94e6c$var$_connectToWebChat.default.apply(void 0, [
        function(_ref, _ref2) {
            var focusSendBox = _ref.focusSendBox, language = _ref.language, postActivity = _ref.postActivity;
            var activity = _ref2.activity;
            return {
                language: language,
                retrySend: function retrySend(evt) {
                    evt.preventDefault();
                    postActivity(activity); // After clicking on "retry", the button will be removed from the DOM and focus will be lost (back to document.body)
                    // This ensures that focus will stay within Web Chat
                    focusSendBox();
                }
            };
        }
    ].concat(selectors));
};
module.exports.connectSendStatus = $973b6aa806f94e6c$var$connectSendStatus;
var $973b6aa806f94e6c$var$SendStatus = function SendStatus(_ref3) {
    var activity = _ref3.activity, sendStatus = _ref3.sendStatus;
    var _useStyleSet = (0, $973b6aa806f94e6c$var$_useStyleSet3.default)(), _useStyleSet2 = $973b6aa806f94e6c$var$_slicedToArray(_useStyleSet, 1), sendStatusStyleSet = _useStyleSet2[0].sendStatus;
    var focus = (0, $973b6aa806f94e6c$var$_useFocus.default)();
    var localize = $973b6aa806f94e6c$var$useLocalizer();
    var postActivity = $973b6aa806f94e6c$var$usePostActivity();
    var handleRetryClick = (0, $973b6aa806f94e6c$var$_react.useCallback)(function() {
        postActivity(activity); // After clicking on "retry", the button will be gone and focus will be lost (back to document.body)
        // We want to make sure the user stay inside Web Chat
        focus("sendBoxWithoutKeyboard");
    }, [
        activity,
        focus,
        postActivity
    ]);
    var sendingText = localize("ACTIVITY_STATUS_SEND_STATUS_ALT_SENDING");
    return /*#__PURE__*/ $973b6aa806f94e6c$var$_react.default.createElement($973b6aa806f94e6c$var$_react.default.Fragment, null, /*#__PURE__*/ $973b6aa806f94e6c$var$_react.default.createElement("span", {
        className: sendStatusStyleSet
    }, sendStatus === $fjDvy.SENDING ? sendingText : sendStatus === $fjDvy.SEND_FAILED ? /*#__PURE__*/ $973b6aa806f94e6c$var$_react.default.createElement($973b6aa806f94e6c$var$_SendFailedRetry.default, {
        onRetryClick: handleRetryClick
    }) : false));
};
$973b6aa806f94e6c$var$SendStatus.propTypes = {
    activity: $973b6aa806f94e6c$var$_propTypes.default.any.isRequired,
    // PropTypes cannot fully capture TypeScript types.
    // @ts-ignore
    sendStatus: $973b6aa806f94e6c$var$_propTypes.default.oneOf([
        $fjDvy.SENDING,
        $fjDvy.SEND_FAILED,
        $fjDvy.SENT
    ]).isRequired
};
var $973b6aa806f94e6c$var$_default = $973b6aa806f94e6c$var$SendStatus;
module.exports.default = $973b6aa806f94e6c$var$_default;

});
parcelRequire.register("6u5Ao", function(module, exports) {
"use strict";
function $4b89e0aa9bd0303a$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $4b89e0aa9bd0303a$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $4b89e0aa9bd0303a$var$_typeof(obj);
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $hd4g0 = parcelRequire("hd4g0");

var $4b89e0aa9bd0303a$var$_propTypes = $4b89e0aa9bd0303a$var$_interopRequireDefault((parcelRequire("f7UXb")));

var $4b89e0aa9bd0303a$var$_react = $4b89e0aa9bd0303a$var$_interopRequireWildcard((parcelRequire("eO7Kz")));

var $4b89e0aa9bd0303a$var$_InlineMarkdown = $4b89e0aa9bd0303a$var$_interopRequireDefault((parcelRequire("chSAr")));
function $4b89e0aa9bd0303a$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($4b89e0aa9bd0303a$var$_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $4b89e0aa9bd0303a$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || $4b89e0aa9bd0303a$var$_typeof(obj) !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $4b89e0aa9bd0303a$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $4b89e0aa9bd0303a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $4b89e0aa9bd0303a$var$useLocalizer = $hd4g0.hooks.useLocalizer;
var $4b89e0aa9bd0303a$var$MARKDOWN_REFERENCES = [
    "RETRY"
];
var $4b89e0aa9bd0303a$var$SendFailedRetry = function SendFailedRetry(_ref) {
    var onRetryClick = _ref.onRetryClick;
    var handleReference = (0, $4b89e0aa9bd0303a$var$_react.useCallback)(function(_ref2) {
        var data = _ref2.data;
        return data === "RETRY" && onRetryClick();
    }, [
        onRetryClick
    ]);
    var localize = $4b89e0aa9bd0303a$var$useLocalizer();
    var sendFailedText = localize("ACTIVITY_STATUS_SEND_FAILED_RETRY");
    return /*#__PURE__*/ $4b89e0aa9bd0303a$var$_react.default.createElement($4b89e0aa9bd0303a$var$_InlineMarkdown.default, {
        onReference: handleReference,
        references: $4b89e0aa9bd0303a$var$MARKDOWN_REFERENCES
    }, sendFailedText);
};
$4b89e0aa9bd0303a$var$SendFailedRetry.propTypes = {
    onRetryClick: $4b89e0aa9bd0303a$var$_propTypes.default.func.isRequired
};
var $4b89e0aa9bd0303a$var$_default = $4b89e0aa9bd0303a$var$SendFailedRetry;
module.exports.default = $4b89e0aa9bd0303a$var$_default;

});
parcelRequire.register("chSAr", function(module, exports) {
"use strict";
function $8f216a5d3bc40475$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $8f216a5d3bc40475$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $8f216a5d3bc40475$var$_typeof(obj);
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $hd4g0 = parcelRequire("hd4g0");

var $cG9B9 = parcelRequire("cG9B9");

var $8f216a5d3bc40475$var$_propTypes = $8f216a5d3bc40475$var$_interopRequireDefault((parcelRequire("f7UXb")));

var $8f216a5d3bc40475$var$_react = $8f216a5d3bc40475$var$_interopRequireWildcard((parcelRequire("eO7Kz")));

var $8f216a5d3bc40475$var$_simpleUpdateIn = $8f216a5d3bc40475$var$_interopRequireDefault((parcelRequire("7qq3H")));

var $8f216a5d3bc40475$var$_createCustomEvent = $8f216a5d3bc40475$var$_interopRequireDefault((parcelRequire("cVvwR")));

var $8f216a5d3bc40475$var$_randomId = $8f216a5d3bc40475$var$_interopRequireDefault((parcelRequire("gJ3hG")));

var $8f216a5d3bc40475$var$_useInternalMarkdownIt = $8f216a5d3bc40475$var$_interopRequireDefault((parcelRequire("j3iNS")));

var $8f216a5d3bc40475$var$_useStyleToEmotionObject = $8f216a5d3bc40475$var$_interopRequireDefault((parcelRequire("6l4uV")));

var $8f216a5d3bc40475$var$_walkMarkdownTokens = $8f216a5d3bc40475$var$_interopRequireDefault((parcelRequire("ckeyu")));
function $8f216a5d3bc40475$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($8f216a5d3bc40475$var$_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $8f216a5d3bc40475$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || $8f216a5d3bc40475$var$_typeof(obj) !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $8f216a5d3bc40475$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $8f216a5d3bc40475$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $8f216a5d3bc40475$var$_slicedToArray(arr, i) {
    return $8f216a5d3bc40475$var$_arrayWithHoles(arr) || $8f216a5d3bc40475$var$_iterableToArrayLimit(arr, i) || $8f216a5d3bc40475$var$_unsupportedIterableToArray(arr, i) || $8f216a5d3bc40475$var$_nonIterableRest();
}
function $8f216a5d3bc40475$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $8f216a5d3bc40475$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $8f216a5d3bc40475$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $8f216a5d3bc40475$var$_toConsumableArray(arr) {
    return $8f216a5d3bc40475$var$_arrayWithoutHoles(arr) || $8f216a5d3bc40475$var$_iterableToArray(arr) || $8f216a5d3bc40475$var$_unsupportedIterableToArray(arr) || $8f216a5d3bc40475$var$_nonIterableSpread();
}
function $8f216a5d3bc40475$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $8f216a5d3bc40475$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $8f216a5d3bc40475$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $8f216a5d3bc40475$var$_arrayLikeToArray(o, minLen);
}
function $8f216a5d3bc40475$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $8f216a5d3bc40475$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $8f216a5d3bc40475$var$_arrayLikeToArray(arr);
}
function $8f216a5d3bc40475$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $8f216a5d3bc40475$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $8f216a5d3bc40475$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $8f216a5d3bc40475$var$ownKeys(Object(source), !0).forEach(function(key) {
            $8f216a5d3bc40475$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $8f216a5d3bc40475$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $8f216a5d3bc40475$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $8f216a5d3bc40475$var$useStyleOptions = $hd4g0.hooks.useStyleOptions;
function $8f216a5d3bc40475$var$replaceAnchorWithButton(markdownTokens) {
    return (0, $8f216a5d3bc40475$var$_walkMarkdownTokens.default)(markdownTokens, function(markdownToken) {
        markdownToken = $8f216a5d3bc40475$var$_objectSpread({}, markdownToken);
        switch(markdownToken.type){
            case "link_open":
                markdownToken.tag = "button";
                markdownToken.attrs = [].concat($8f216a5d3bc40475$var$_toConsumableArray((0, $8f216a5d3bc40475$var$_simpleUpdateIn.default)(markdownToken.attrs, [
                    function(_ref) {
                        var _ref2 = $8f216a5d3bc40475$var$_slicedToArray(_ref, 2), name = _ref2[0], value = _ref2[1];
                        return name === "href" && value.startsWith("#");
                    }
                ], function(_ref3) {
                    var _ref4 = $8f216a5d3bc40475$var$_slicedToArray(_ref3, 2), value = _ref4[1];
                    return [
                        "data-markdown-href",
                        value.substr(1)
                    ];
                })), [
                    [
                        "type",
                        "button"
                    ]
                ]);
                break;
            case "link_close":
                markdownToken.tag = "button";
                break;
            default:
                break;
        }
        return markdownToken;
    });
}
var $8f216a5d3bc40475$var$InlineMarkdown = function InlineMarkdown(_ref5) {
    var children = _ref5.children, onReference = _ref5.onReference, references = _ref5.references;
    if (typeof children !== "string") {
        console.warn('botframework-webchat: "children" prop passed to <InlineMarkdown> must be of type string.');
        children = "";
    }
    var _useInternalMarkdownI = (0, $8f216a5d3bc40475$var$_useInternalMarkdownIt.default)(), _useInternalMarkdownI2 = $8f216a5d3bc40475$var$_slicedToArray(_useInternalMarkdownI, 1), markdownIt = _useInternalMarkdownI2[0];
    var _useStyleOptions = $8f216a5d3bc40475$var$useStyleOptions(), _useStyleOptions2 = $8f216a5d3bc40475$var$_slicedToArray(_useStyleOptions, 1), accent = _useStyleOptions2[0].accent;
    var styleToClassName = (0, $8f216a5d3bc40475$var$_useStyleToEmotionObject.default)(); // We inlined the style here because this style is:
    // 1. Internal to Web Chat
    // 2. Not customizable from developers (other than setting `styleOptions.accent`)
    var className = (0, $8f216a5d3bc40475$var$_react.useMemo)(function() {
        return styleToClassName({
            "& button[data-markdown-href]": {
                appearance: "none",
                backgroundColor: "transparent",
                border: 0,
                color: accent,
                cursor: "pointer",
                fontFamily: "inherit",
                fontSize: "inherit",
                padding: 0
            },
            "@media screen and (forced-colors: active)": {
                "& button[data-markdown-href]": {
                    color: "LinkText",
                    textDecoration: "underline"
                }
            }
        }) + "";
    }, [
        accent,
        styleToClassName
    ]); // Markdown-It only support references in uppercase.
    references = references.map(function(reference) {
        return reference.toUpperCase();
    });
    var _references$reduce = references.reduce(function(_ref6, ref) {
        var hrefToRef = _ref6.hrefToRef, refToHref = _ref6.refToHref;
        var href = (0, $8f216a5d3bc40475$var$_randomId.default)();
        return {
            hrefToRef: $8f216a5d3bc40475$var$_objectSpread($8f216a5d3bc40475$var$_objectSpread({}, hrefToRef), {}, $8f216a5d3bc40475$var$_defineProperty({}, href, ref)),
            refToHref: $8f216a5d3bc40475$var$_objectSpread($8f216a5d3bc40475$var$_objectSpread({}, refToHref), {}, $8f216a5d3bc40475$var$_defineProperty({}, ref, href))
        };
    }, {
        hrefToRef: {},
        refToHref: {}
    }), hrefToRef = _references$reduce.hrefToRef, refToHref = _references$reduce.refToHref;
    var html = (0, $8f216a5d3bc40475$var$_react.useMemo)(function() {
        var tree = markdownIt.parseInline(children, {
            references: references.reduce(function(references, key) {
                return(// eslint-disable-next-line security/detect-object-injection
                (0, $cG9B9.isForbiddenPropertyName)(key) ? references : $8f216a5d3bc40475$var$_objectSpread($8f216a5d3bc40475$var$_objectSpread({}, references), {}, $8f216a5d3bc40475$var$_defineProperty({}, key, {
                    href: "#".concat(refToHref[key])
                })));
            }, {})
        }); // Turn "<a href="#retry">Retry</a>" into "<button data-ref="retry" type="button">Retry</button>"
        var updatedTree = $8f216a5d3bc40475$var$replaceAnchorWithButton(tree);
        return {
            __html: markdownIt.renderer.render(updatedTree)
        };
    }, [
        children,
        refToHref,
        markdownIt,
        references
    ]);
    var handleClick = (0, $8f216a5d3bc40475$var$_react.useCallback)(function(event) {
        event.stopPropagation();
        var href = event.target.getAttribute("data-markdown-href");
        href && onReference && onReference((0, $8f216a5d3bc40475$var$_createCustomEvent.default)("reference", // eslint-disable-next-line security/detect-object-injection
        (0, $cG9B9.isForbiddenPropertyName)(href) ? {} : {
            data: hrefToRef[href]
        }));
    }, [
        hrefToRef,
        onReference
    ]);
    return /*#__PURE__*/ $8f216a5d3bc40475$var$_react.default.createElement("span", {
        className: className,
        dangerouslySetInnerHTML: html,
        onClick: handleClick
    });
};
$8f216a5d3bc40475$var$InlineMarkdown.defaultProps = {
    children: "",
    onReference: undefined,
    references: []
};
$8f216a5d3bc40475$var$InlineMarkdown.propTypes = {
    children: $8f216a5d3bc40475$var$_propTypes.default.string,
    onReference: $8f216a5d3bc40475$var$_propTypes.default.func,
    references: $8f216a5d3bc40475$var$_propTypes.default.arrayOf($8f216a5d3bc40475$var$_propTypes.default.string)
};
var $8f216a5d3bc40475$var$_default = $8f216a5d3bc40475$var$InlineMarkdown;
module.exports.default = $8f216a5d3bc40475$var$_default;

});
parcelRequire.register("cVvwR", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $969343e8b4196f06$var$createCustomEvent;

var $cG9B9 = parcelRequire("cG9B9");
function $969343e8b4196f06$var$_slicedToArray(arr, i) {
    return $969343e8b4196f06$var$_arrayWithHoles(arr) || $969343e8b4196f06$var$_iterableToArrayLimit(arr, i) || $969343e8b4196f06$var$_unsupportedIterableToArray(arr, i) || $969343e8b4196f06$var$_nonIterableRest();
}
function $969343e8b4196f06$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $969343e8b4196f06$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $969343e8b4196f06$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $969343e8b4196f06$var$_arrayLikeToArray(o, minLen);
}
function $969343e8b4196f06$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $969343e8b4196f06$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $969343e8b4196f06$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $969343e8b4196f06$var$createCustomEvent(name, eventInitDict) {
    var event;
    if (typeof CustomEvent === "function") event = new CustomEvent(name);
    else {
        event = document.createEvent("Event");
        event.initEvent(name, true, true);
    }
    Object.entries(eventInitDict).forEach(function(_ref) {
        var _ref2 = $969343e8b4196f06$var$_slicedToArray(_ref, 2), key = _ref2[0], value = _ref2[1];
        if (!(0, $cG9B9.isForbiddenPropertyName)(key)) // Mitigated through denylisting.
        // eslint-disable-next-line security/detect-object-injection
        event[key] = value;
    });
    return event;
}

});

parcelRequire.register("j3iNS", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ddece21852e23b75$var$_useWebChatUIContext = $ddece21852e23b75$var$_interopRequireDefault((parcelRequire("tHuBR")));
function $ddece21852e23b75$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $ddece21852e23b75$var$useInternalMarkdownIt() {
    return (0, $ddece21852e23b75$var$_useWebChatUIContext.default)().internalMarkdownItState;
}
var $ddece21852e23b75$var$_default = $ddece21852e23b75$var$useInternalMarkdownIt;
module.exports.default = $ddece21852e23b75$var$_default;

});





parcelRequire.register("6QGuD", function(module, exports) {
"use strict";
function $4fc88fa873077235$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $4fc88fa873077235$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $4fc88fa873077235$var$_typeof(obj);
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $4fc88fa873077235$var$createTimestampMiddleware;

var $4fc88fa873077235$var$_react = $4fc88fa873077235$var$_interopRequireWildcard((parcelRequire("eO7Kz")));

var $4fc88fa873077235$var$_AbsoluteTime = $4fc88fa873077235$var$_interopRequireDefault((parcelRequire("lMb2N")));

var $4fc88fa873077235$var$_Timestamp = $4fc88fa873077235$var$_interopRequireDefault((parcelRequire("6QRL7")));
function $4fc88fa873077235$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $4fc88fa873077235$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($4fc88fa873077235$var$_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $4fc88fa873077235$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || $4fc88fa873077235$var$_typeof(obj) !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $4fc88fa873077235$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $4fc88fa873077235$var$createTimestampMiddleware() {
    return function() {
        return function() {
            return function() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                var _args$ = args[0], activity = _args$.activity, hideTimestamp = _args$.hideTimestamp;
                if (typeof activity.timestamp === "undefined") // ActivityStatusMiddleware is using a legacy UI middleware pattern which does not supports returning `false`.
                // If the activity is sent and there is no timestamp, probably we will just not displaying the timestamp.
                // Or we somehow enforce all activities must have timestamp.
                return /*#__PURE__*/ $4fc88fa873077235$var$_react.default.createElement($4fc88fa873077235$var$_react.Fragment, null);
                else if (hideTimestamp) // If "hideTimestamp" is set, we will not render the visual timestamp. But continue to render the screen reader only version.
                return /*#__PURE__*/ $4fc88fa873077235$var$_react.default.createElement($4fc88fa873077235$var$_AbsoluteTime.default, {
                    hide: true,
                    value: activity.timestamp
                });
                return /*#__PURE__*/ $4fc88fa873077235$var$_react.default.createElement($4fc88fa873077235$var$_Timestamp.default, {
                    activity: activity
                });
            };
        };
    };
}

});
parcelRequire.register("lMb2N", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $hd4g0 = parcelRequire("hd4g0");

var $fda6a5cdfcaf6a82$var$_propTypes = $fda6a5cdfcaf6a82$var$_interopRequireDefault((parcelRequire("f7UXb")));

var $fda6a5cdfcaf6a82$var$_react = $fda6a5cdfcaf6a82$var$_interopRequireDefault((parcelRequire("eO7Kz")));

var $fda6a5cdfcaf6a82$var$_ScreenReaderText = $fda6a5cdfcaf6a82$var$_interopRequireDefault((parcelRequire("3NTZI")));
function $fda6a5cdfcaf6a82$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $fda6a5cdfcaf6a82$var$useDateFormatter = $hd4g0.hooks.useDateFormatter, $fda6a5cdfcaf6a82$var$useLocalizer = $hd4g0.hooks.useLocalizer;
var $fda6a5cdfcaf6a82$var$AbsoluteTime = function AbsoluteTime(_ref) {
    var hide = _ref.hide, value = _ref.value;
    var localize = $fda6a5cdfcaf6a82$var$useLocalizer();
    var formatDate = $fda6a5cdfcaf6a82$var$useDateFormatter();
    var absoluteTime = formatDate(value);
    return /*#__PURE__*/ $fda6a5cdfcaf6a82$var$_react.default.createElement($fda6a5cdfcaf6a82$var$_react.default.Fragment, null, /*#__PURE__*/ $fda6a5cdfcaf6a82$var$_react.default.createElement($fda6a5cdfcaf6a82$var$_ScreenReaderText.default, {
        text: localize("ACTIVITY_STATUS_SEND_STATUS_ALT_SENT_AT", absoluteTime)
    }), !hide && /*#__PURE__*/ $fda6a5cdfcaf6a82$var$_react.default.createElement("span", {
        "aria-hidden": true
    }, absoluteTime));
};
$fda6a5cdfcaf6a82$var$AbsoluteTime.defaultProps = {
    hide: false
};
$fda6a5cdfcaf6a82$var$AbsoluteTime.propTypes = {
    hide: $fda6a5cdfcaf6a82$var$_propTypes.default.bool,
    value: $fda6a5cdfcaf6a82$var$_propTypes.default.string.isRequired
};
var $fda6a5cdfcaf6a82$var$_default = $fda6a5cdfcaf6a82$var$AbsoluteTime;
module.exports.default = $fda6a5cdfcaf6a82$var$_default;

});

parcelRequire.register("6QRL7", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $hd4g0 = parcelRequire("hd4g0");

var $4fd14cd214565b58$var$_classnames = $4fd14cd214565b58$var$_interopRequireDefault((parcelRequire("5A4MD")));

var $4fd14cd214565b58$var$_propTypes = $4fd14cd214565b58$var$_interopRequireDefault((parcelRequire("f7UXb")));

var $4fd14cd214565b58$var$_react = $4fd14cd214565b58$var$_interopRequireDefault((parcelRequire("eO7Kz")));

var $4fd14cd214565b58$var$_AbsoluteTime = $4fd14cd214565b58$var$_interopRequireDefault((parcelRequire("lMb2N")));

var $4fd14cd214565b58$var$_RelativeTime = $4fd14cd214565b58$var$_interopRequireDefault((parcelRequire("lJ9g8")));

var $4fd14cd214565b58$var$_useStyleSet3 = $4fd14cd214565b58$var$_interopRequireDefault((parcelRequire("gC6jZ")));
function $4fd14cd214565b58$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $4fd14cd214565b58$var$_slicedToArray(arr, i) {
    return $4fd14cd214565b58$var$_arrayWithHoles(arr) || $4fd14cd214565b58$var$_iterableToArrayLimit(arr, i) || $4fd14cd214565b58$var$_unsupportedIterableToArray(arr, i) || $4fd14cd214565b58$var$_nonIterableRest();
}
function $4fd14cd214565b58$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $4fd14cd214565b58$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $4fd14cd214565b58$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $4fd14cd214565b58$var$_arrayLikeToArray(o, minLen);
}
function $4fd14cd214565b58$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $4fd14cd214565b58$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $4fd14cd214565b58$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
var $4fd14cd214565b58$var$useStyleOptions = $hd4g0.hooks.useStyleOptions;
var $4fd14cd214565b58$var$Timestamp = function Timestamp(_ref) {
    var timestamp = _ref.activity.timestamp, className = _ref.className;
    var _useStyleOptions = $4fd14cd214565b58$var$useStyleOptions(), _useStyleOptions2 = $4fd14cd214565b58$var$_slicedToArray(_useStyleOptions, 1), timestampFormat = _useStyleOptions2[0].timestampFormat;
    var _useStyleSet = (0, $4fd14cd214565b58$var$_useStyleSet3.default)(), _useStyleSet2 = $4fd14cd214565b58$var$_slicedToArray(_useStyleSet, 1), _useStyleSet2$ = _useStyleSet2[0], timestampStyleSet = _useStyleSet2$.timestamp, sendStatusStyleSet = _useStyleSet2$.sendStatus;
    timestampStyleSet && console.warn('botframework-webchat: "styleSet.timestamp" is deprecated. Please use "styleSet.sendStatus". This deprecation migration will be removed on or after December 31, 2021.');
    return !!timestamp && /*#__PURE__*/ $4fd14cd214565b58$var$_react.default.createElement("span", {
        className: (0, $4fd14cd214565b58$var$_classnames.default)((timestampStyleSet || "") + "", (sendStatusStyleSet || "") + "", (className || "") + "")
    }, timestampFormat === "relative" ? /*#__PURE__*/ $4fd14cd214565b58$var$_react.default.createElement($4fd14cd214565b58$var$_RelativeTime.default, {
        value: timestamp
    }) : /*#__PURE__*/ $4fd14cd214565b58$var$_react.default.createElement($4fd14cd214565b58$var$_AbsoluteTime.default, {
        value: timestamp
    }));
};
$4fd14cd214565b58$var$Timestamp.defaultProps = {
    className: ""
};
$4fd14cd214565b58$var$Timestamp.propTypes = {
    // PropTypes cannot fully capture TypeScript types.
    // @ts-ignore
    activity: $4fd14cd214565b58$var$_propTypes.default.shape({
        timestamp: $4fd14cd214565b58$var$_propTypes.default.string
    }).isRequired,
    className: $4fd14cd214565b58$var$_propTypes.default.string
};
var $4fd14cd214565b58$var$_default = $4fd14cd214565b58$var$Timestamp;
module.exports.default = $4fd14cd214565b58$var$_default;

});
parcelRequire.register("lJ9g8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $hd4g0 = parcelRequire("hd4g0");

var $fd14fb9cc39e7dae$var$_propTypes = $fd14fb9cc39e7dae$var$_interopRequireDefault((parcelRequire("f7UXb")));

var $fd14fb9cc39e7dae$var$_react = $fd14fb9cc39e7dae$var$_interopRequireDefault((parcelRequire("eO7Kz")));

var $fd14fb9cc39e7dae$var$_ScreenReaderText = $fd14fb9cc39e7dae$var$_interopRequireDefault((parcelRequire("3NTZI")));

var $fd14fb9cc39e7dae$var$_useForceRenderAtInterval = $fd14fb9cc39e7dae$var$_interopRequireDefault((parcelRequire("b23WQ")));
function $fd14fb9cc39e7dae$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $fd14fb9cc39e7dae$var$useDateFormatter = $hd4g0.hooks.useDateFormatter, $fd14fb9cc39e7dae$var$useLocalizer = $hd4g0.hooks.useLocalizer, $fd14fb9cc39e7dae$var$useRelativeTimeFormatter = $hd4g0.hooks.useRelativeTimeFormatter;
var $fd14fb9cc39e7dae$var$TIMER_INTERVAL = 60000;
var $fd14fb9cc39e7dae$var$RelativeTime = function RelativeTime(_ref) {
    var value = _ref.value;
    var formatDate = $fd14fb9cc39e7dae$var$useDateFormatter();
    var formatRelativeTime = $fd14fb9cc39e7dae$var$useRelativeTimeFormatter();
    var localize = $fd14fb9cc39e7dae$var$useLocalizer();
    (0, $fd14fb9cc39e7dae$var$_useForceRenderAtInterval.default)(value, $fd14fb9cc39e7dae$var$TIMER_INTERVAL);
    return /*#__PURE__*/ $fd14fb9cc39e7dae$var$_react.default.createElement($fd14fb9cc39e7dae$var$_react.default.Fragment, null, /*#__PURE__*/ $fd14fb9cc39e7dae$var$_react.default.createElement($fd14fb9cc39e7dae$var$_ScreenReaderText.default, {
        text: localize("ACTIVITY_STATUS_SEND_STATUS_ALT_SENT_AT", formatDate(value))
    }), /*#__PURE__*/ $fd14fb9cc39e7dae$var$_react.default.createElement("span", {
        "aria-hidden": true
    }, formatRelativeTime(value)));
};
$fd14fb9cc39e7dae$var$RelativeTime.propTypes = {
    value: $fd14fb9cc39e7dae$var$_propTypes.default.string.isRequired
};
var $fd14fb9cc39e7dae$var$_default = $fd14fb9cc39e7dae$var$RelativeTime;
module.exports.default = $fd14fb9cc39e7dae$var$_default;

});
parcelRequire.register("b23WQ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $8082f19ff86dc682$var$useForceRenderAtInterval;

var $hd4g0 = parcelRequire("hd4g0");

var $eO7Kz = parcelRequire("eO7Kz");

var $8082f19ff86dc682$var$_mathRandom = $8082f19ff86dc682$var$_interopRequireDefault((parcelRequire("atZsr")));

var $8082f19ff86dc682$var$_useTimer = $8082f19ff86dc682$var$_interopRequireDefault((parcelRequire("czn4j")));
function $8082f19ff86dc682$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $8082f19ff86dc682$var$_slicedToArray(arr, i) {
    return $8082f19ff86dc682$var$_arrayWithHoles(arr) || $8082f19ff86dc682$var$_iterableToArrayLimit(arr, i) || $8082f19ff86dc682$var$_unsupportedIterableToArray(arr, i) || $8082f19ff86dc682$var$_nonIterableRest();
}
function $8082f19ff86dc682$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $8082f19ff86dc682$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $8082f19ff86dc682$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $8082f19ff86dc682$var$_arrayLikeToArray(o, minLen);
}
function $8082f19ff86dc682$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $8082f19ff86dc682$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $8082f19ff86dc682$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
var $8082f19ff86dc682$var$usePonyfill = $hd4g0.hooks.usePonyfill; // The `nextTimer` function calculates the next absolute time that the timer should be fired based on the origin (original time received), interval, and current time.
// If the origin is t=260, and we are currently at t=1000, nextTimer must return t=60260.
// If the origin is t=260, and we are currently at t=60260 (exact landing), we must return t=120260, not t=60260.
// This is for fixing bug #2103: https://github.com/microsoft/BotFramework-WebChat/issues/2103.
// False positive: we are using `Date` as a type.
// eslint-disable-next-line no-restricted-globals
function $8082f19ff86dc682$var$nextTimer(origin, interval, _ref) {
    var Date = _ref.Date;
    var time = new Date(origin).getTime();
    var now = Date.now();
    return time > now ? time : now + interval - (now - time) % interval;
}
function $8082f19ff86dc682$var$useForceRenderAtInterval(// eslint-disable-next-line no-restricted-globals
origin, interval, fn) {
    var _usePonyfill = $8082f19ff86dc682$var$usePonyfill(), _usePonyfill2 = $8082f19ff86dc682$var$_slicedToArray(_usePonyfill, 1), ponyfill = _usePonyfill2[0];
    var _useState = (0, $eO7Kz.useState)($8082f19ff86dc682$var$nextTimer(origin, interval, ponyfill)), _useState2 = $8082f19ff86dc682$var$_slicedToArray(_useState, 2), timer = _useState2[0], setTimer = _useState2[1];
    var handler = (0, $eO7Kz.useCallback)(function() {
        fn && fn(); // Chrome may fire the setTimeout callback 1 ms before its original schedule.
        // Thus, when we calculate the "next" value, it will have the same value as before.
        // Sending the same value to useTimer(), it will not do another schedule because the value did not change.
        // So, we are adding a bit randomness, so useTimer() should pick up the newer scheduled time.
        setTimer($8082f19ff86dc682$var$nextTimer(origin, interval, ponyfill) + (0, $8082f19ff86dc682$var$_mathRandom.default)());
    }, [
        fn,
        origin,
        interval,
        ponyfill
    ]);
    (0, $8082f19ff86dc682$var$_useTimer.default)(timer, handler);
    return [
        timer,
        setTimer
    ];
}

});





parcelRequire.register("6XjCv", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $510778e465458180$var$createCoreMiddleware;

var $510778e465458180$var$_react = $510778e465458180$var$_interopRequireDefault((parcelRequire("eO7Kz")));

var $510778e465458180$var$_AudioAttachment = $510778e465458180$var$_interopRequireDefault((parcelRequire("3o1YU")));

var $510778e465458180$var$_FileAttachment = $510778e465458180$var$_interopRequireDefault((parcelRequire("jhvNo")));

var $510778e465458180$var$_ImageAttachment = $510778e465458180$var$_interopRequireDefault((parcelRequire("5oeg2")));

var $510778e465458180$var$_TextAttachment = $510778e465458180$var$_interopRequireDefault((parcelRequire("byy1t")));

var $510778e465458180$var$_VideoAttachment = $510778e465458180$var$_interopRequireDefault((parcelRequire("9pvFi")));
function $510778e465458180$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $510778e465458180$var$createCoreMiddleware() {
    return [
        function() {
            return function(next) {
                return function() {
                    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                    var _args$ = args[0], _args$$activity = _args$.activity;
                    _args$$activity = _args$$activity === void 0 ? {} : _args$$activity;
                    var _args$$activity$from = _args$$activity.from;
                    _args$$activity$from = _args$$activity$from === void 0 ? {} : _args$$activity$from;
                    var _args$$activity$from$ = _args$$activity$from.role, role = _args$$activity$from$ === void 0 ? undefined : _args$$activity$from$, attachment = _args$.attachment, _args$$attachment = _args$.attachment;
                    _args$$attachment = _args$$attachment === void 0 ? {} : _args$$attachment;
                    var _args$$attachment$con = _args$$attachment.contentType, contentType = _args$$attachment$con === void 0 ? undefined : _args$$attachment$con, _args$$attachment$con2 = _args$$attachment.contentUrl, contentUrl = _args$$attachment$con2 === void 0 ? undefined : _args$$attachment$con2, _args$$attachment$thu = _args$$attachment.thumbnailUrl, thumbnailUrl = _args$$attachment$thu === void 0 ? undefined : _args$$attachment$thu;
                    var isText = /^text\//.test(contentType);
                    return (isText ? !attachment.content : role === "user" && !thumbnailUrl) ? function() {
                        return /*#__PURE__*/ $510778e465458180$var$_react.default.createElement($510778e465458180$var$_FileAttachment.default, {
                            attachment: attachment
                        });
                    } : /^audio\//.test(contentType) ? function() {
                        return /*#__PURE__*/ $510778e465458180$var$_react.default.createElement($510778e465458180$var$_AudioAttachment.default, null);
                    } : /^image\//.test(contentType) ? function() {
                        return /*#__PURE__*/ $510778e465458180$var$_react.default.createElement($510778e465458180$var$_ImageAttachment.default, null);
                    } : /^video\//.test(contentType) ? function() {
                        return /*#__PURE__*/ $510778e465458180$var$_react.default.createElement($510778e465458180$var$_VideoAttachment.default, null);
                    } : contentUrl || contentType === "application/octet-stream" ? function() {
                        return /*#__PURE__*/ $510778e465458180$var$_react.default.createElement($510778e465458180$var$_FileAttachment.default, {
                            attachment: attachment
                        });
                    } : isText ? function() {
                        return /*#__PURE__*/ $510778e465458180$var$_react.default.createElement($510778e465458180$var$_TextAttachment.default, {
                            attachment: attachment
                        });
                    } : next.apply(void 0, args);
                };
            };
        }
    ];
}

});
parcelRequire.register("3o1YU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $hd4g0 = parcelRequire("hd4g0");

var $27752678c2abf196$var$_react = $27752678c2abf196$var$_interopRequireDefault((parcelRequire("eO7Kz")));
function $27752678c2abf196$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $27752678c2abf196$var$useLocalizer = $hd4g0.hooks.useLocalizer;
var $27752678c2abf196$var$AudioAttachment = function AudioAttachment() {
    var localize = $27752678c2abf196$var$useLocalizer();
    var label = localize("ATTACHMENT_AUDIO");
    return /*#__PURE__*/ $27752678c2abf196$var$_react.default.createElement("article", null, label);
};
var $27752678c2abf196$var$_default = $27752678c2abf196$var$AudioAttachment;
module.exports.default = $27752678c2abf196$var$_default;

});

parcelRequire.register("jhvNo", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $hd4g0 = parcelRequire("hd4g0");

var $e09844cdc355fe33$var$_propTypes = $e09844cdc355fe33$var$_interopRequireDefault((parcelRequire("f7UXb")));

var $e09844cdc355fe33$var$_react = $e09844cdc355fe33$var$_interopRequireDefault((parcelRequire("eO7Kz")));
function $e09844cdc355fe33$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $e09844cdc355fe33$var$useLocalizer = $hd4g0.hooks.useLocalizer;
var $e09844cdc355fe33$var$FileAttachment = function FileAttachment(_ref) {
    var _ref$attachment = _ref.attachment;
    _ref$attachment = _ref$attachment === void 0 ? {} : _ref$attachment;
    var _ref$attachment$name = _ref$attachment.name, name = _ref$attachment$name === void 0 ? "" : _ref$attachment$name;
    var localize = $e09844cdc355fe33$var$useLocalizer();
    var label = localize("ATTACHMENT_FILE", name);
    return /*#__PURE__*/ $e09844cdc355fe33$var$_react.default.createElement("article", null, label);
};
$e09844cdc355fe33$var$FileAttachment.propTypes = {
    attachment: $e09844cdc355fe33$var$_propTypes.default.shape({
        name: $e09844cdc355fe33$var$_propTypes.default.string.isRequired
    }).isRequired
};
var $e09844cdc355fe33$var$_default = $e09844cdc355fe33$var$FileAttachment;
module.exports.default = $e09844cdc355fe33$var$_default;

});

parcelRequire.register("5oeg2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $hd4g0 = parcelRequire("hd4g0");

var $3eca40e76e291449$var$_react = $3eca40e76e291449$var$_interopRequireDefault((parcelRequire("eO7Kz")));
function $3eca40e76e291449$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $3eca40e76e291449$var$useLocalizer = $hd4g0.hooks.useLocalizer;
var $3eca40e76e291449$var$ImageAttachment = function ImageAttachment() {
    var localize = $3eca40e76e291449$var$useLocalizer();
    var label = localize("ATTACHMENT_IMAGE");
    return /*#__PURE__*/ $3eca40e76e291449$var$_react.default.createElement("article", null, label);
};
var $3eca40e76e291449$var$_default = $3eca40e76e291449$var$ImageAttachment;
module.exports.default = $3eca40e76e291449$var$_default;

});

parcelRequire.register("byy1t", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $hd4g0 = parcelRequire("hd4g0");

var $869d42e540dcf99c$var$_propTypes = $869d42e540dcf99c$var$_interopRequireDefault((parcelRequire("f7UXb")));

var $869d42e540dcf99c$var$_react = $869d42e540dcf99c$var$_interopRequireDefault((parcelRequire("eO7Kz")));
function $869d42e540dcf99c$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $869d42e540dcf99c$var$useLocalizer = $hd4g0.hooks.useLocalizer;
var $869d42e540dcf99c$var$TextAttachment = function TextAttachment(_ref) {
    var _ref$attachment = _ref.attachment;
    _ref$attachment = _ref$attachment === void 0 ? {} : _ref$attachment;
    var _ref$attachment$conte = _ref$attachment.content, content = _ref$attachment$conte === void 0 ? "" : _ref$attachment$conte;
    var localize = $869d42e540dcf99c$var$useLocalizer();
    var label = localize("ATTACHMENT_TEXT", content);
    return /*#__PURE__*/ $869d42e540dcf99c$var$_react.default.createElement("article", null, label);
};
$869d42e540dcf99c$var$TextAttachment.propTypes = {
    attachment: $869d42e540dcf99c$var$_propTypes.default.shape({
        content: $869d42e540dcf99c$var$_propTypes.default.string.isRequired
    }).isRequired
};
var $869d42e540dcf99c$var$_default = $869d42e540dcf99c$var$TextAttachment;
module.exports.default = $869d42e540dcf99c$var$_default;

});

parcelRequire.register("9pvFi", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $hd4g0 = parcelRequire("hd4g0");

var $6d9f02e03b996b32$var$_react = $6d9f02e03b996b32$var$_interopRequireDefault((parcelRequire("eO7Kz")));
function $6d9f02e03b996b32$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $6d9f02e03b996b32$var$useLocalizer = $hd4g0.hooks.useLocalizer;
var $6d9f02e03b996b32$var$VideoAttachment = function VideoAttachment() {
    var localize = $6d9f02e03b996b32$var$useLocalizer();
    var label = localize("ATTACHMENT_VIDEO");
    return /*#__PURE__*/ $6d9f02e03b996b32$var$_react.default.createElement("article", null, label);
};
var $6d9f02e03b996b32$var$_default = $6d9f02e03b996b32$var$VideoAttachment;
module.exports.default = $6d9f02e03b996b32$var$_default;

});


parcelRequire.register("l1gyp", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $f4d68838b29b50be$var$createCoreMiddleware;

var $f4d68838b29b50be$var$_react = $f4d68838b29b50be$var$_interopRequireDefault((parcelRequire("eO7Kz")));

var $f4d68838b29b50be$var$_AudioAttachment = $f4d68838b29b50be$var$_interopRequireDefault((parcelRequire("3h3X9")));

var $f4d68838b29b50be$var$_FileAttachment = $f4d68838b29b50be$var$_interopRequireDefault((parcelRequire("i6Tko")));

var $f4d68838b29b50be$var$_ImageAttachment = $f4d68838b29b50be$var$_interopRequireDefault((parcelRequire("adyXK")));

var $f4d68838b29b50be$var$_TextAttachment = $f4d68838b29b50be$var$_interopRequireDefault((parcelRequire("c0ZXf")));

var $f4d68838b29b50be$var$_VideoAttachment = $f4d68838b29b50be$var$_interopRequireDefault((parcelRequire("icnJw")));
function $f4d68838b29b50be$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
// TODO: [P4] Rename this file or the whole middleware, it looks either too simple or too comprehensive now
function $f4d68838b29b50be$var$createCoreMiddleware() {
    return [
        function() {
            return function(next) {
                return function() {
                    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                    var _args$ = args[0], _args$$activity = _args$.activity, activity = _args$$activity === void 0 ? {} : _args$$activity, _args$$activity2 = _args$.activity;
                    _args$$activity2 = _args$$activity2 === void 0 ? {} : _args$$activity2;
                    var _args$$activity2$from = _args$$activity2.from;
                    _args$$activity2$from = _args$$activity2$from === void 0 ? {} : _args$$activity2$from;
                    var _args$$activity2$from2 = _args$$activity2$from.role, role = _args$$activity2$from2 === void 0 ? undefined : _args$$activity2$from2, attachment = _args$.attachment, _args$$attachment = _args$.attachment;
                    _args$$attachment = _args$$attachment === void 0 ? {} : _args$$attachment;
                    var _args$$attachment$con = _args$$attachment.contentType, contentType = _args$$attachment$con === void 0 ? undefined : _args$$attachment$con, _args$$attachment$con2 = _args$$attachment.contentUrl, contentUrl = _args$$attachment$con2 === void 0 ? undefined : _args$$attachment$con2, _args$$attachment$thu = _args$$attachment.thumbnailUrl, thumbnailUrl = _args$$attachment$thu === void 0 ? undefined : _args$$attachment$thu;
                    var isText = /^text\//.test(contentType);
                    return (isText ? !attachment.content : role === "user" && !thumbnailUrl) ? /*#__PURE__*/ $f4d68838b29b50be$var$_react.default.createElement($f4d68838b29b50be$var$_FileAttachment.default, {
                        activity: activity,
                        attachment: attachment
                    }) : /^audio\//.test(contentType) ? /*#__PURE__*/ $f4d68838b29b50be$var$_react.default.createElement($f4d68838b29b50be$var$_AudioAttachment.default, {
                        attachment: attachment
                    }) : /^image\//.test(contentType) ? /*#__PURE__*/ $f4d68838b29b50be$var$_react.default.createElement($f4d68838b29b50be$var$_ImageAttachment.default, {
                        attachment: attachment
                    }) : /^video\//.test(contentType) ? /*#__PURE__*/ $f4d68838b29b50be$var$_react.default.createElement($f4d68838b29b50be$var$_VideoAttachment.default, {
                        attachment: attachment
                    }) : contentUrl || contentType === "application/octet-stream" ? /*#__PURE__*/ $f4d68838b29b50be$var$_react.default.createElement($f4d68838b29b50be$var$_FileAttachment.default, {
                        activity: activity,
                        attachment: attachment
                    }) : isText ? /*#__PURE__*/ $f4d68838b29b50be$var$_react.default.createElement($f4d68838b29b50be$var$_TextAttachment.default, {
                        attachment: attachment
                    }) : next.apply(void 0, args);
                };
            };
        }
    ];
}

});
parcelRequire.register("3h3X9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2626069c5cb7abb8$var$_propTypes = $2626069c5cb7abb8$var$_interopRequireDefault((parcelRequire("f7UXb")));

var $2626069c5cb7abb8$var$_react = $2626069c5cb7abb8$var$_interopRequireDefault((parcelRequire("eO7Kz")));

var $2626069c5cb7abb8$var$_AudioContent = $2626069c5cb7abb8$var$_interopRequireDefault((parcelRequire("9p94T")));

var $2626069c5cb7abb8$var$_useStyleSet3 = $2626069c5cb7abb8$var$_interopRequireDefault((parcelRequire("gC6jZ")));
function $2626069c5cb7abb8$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $2626069c5cb7abb8$var$_slicedToArray(arr, i) {
    return $2626069c5cb7abb8$var$_arrayWithHoles(arr) || $2626069c5cb7abb8$var$_iterableToArrayLimit(arr, i) || $2626069c5cb7abb8$var$_unsupportedIterableToArray(arr, i) || $2626069c5cb7abb8$var$_nonIterableRest();
}
function $2626069c5cb7abb8$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $2626069c5cb7abb8$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $2626069c5cb7abb8$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $2626069c5cb7abb8$var$_arrayLikeToArray(o, minLen);
}
function $2626069c5cb7abb8$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $2626069c5cb7abb8$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $2626069c5cb7abb8$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
var $2626069c5cb7abb8$var$AudioAttachment = function AudioAttachment(_ref) {
    var attachment = _ref.attachment;
    var _useStyleSet = (0, $2626069c5cb7abb8$var$_useStyleSet3.default)(), _useStyleSet2 = $2626069c5cb7abb8$var$_slicedToArray(_useStyleSet, 1), audioAttachmentStyleSet = _useStyleSet2[0].audioAttachment;
    return /*#__PURE__*/ $2626069c5cb7abb8$var$_react.default.createElement("div", {
        className: audioAttachmentStyleSet
    }, /*#__PURE__*/ $2626069c5cb7abb8$var$_react.default.createElement($2626069c5cb7abb8$var$_AudioContent.default, {
        alt: attachment.name,
        src: attachment.contentUrl
    }));
};
$2626069c5cb7abb8$var$AudioAttachment.propTypes = {
    attachment: $2626069c5cb7abb8$var$_propTypes.default.shape({
        contentUrl: $2626069c5cb7abb8$var$_propTypes.default.string.isRequired,
        name: $2626069c5cb7abb8$var$_propTypes.default.string
    }).isRequired
};
var $2626069c5cb7abb8$var$_default = $2626069c5cb7abb8$var$AudioAttachment;
module.exports.default = $2626069c5cb7abb8$var$_default;

});
parcelRequire.register("9p94T", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6d8d7d88109f8ff6$var$_propTypes = $6d8d7d88109f8ff6$var$_interopRequireDefault((parcelRequire("f7UXb")));

var $6d8d7d88109f8ff6$var$_react = $6d8d7d88109f8ff6$var$_interopRequireDefault((parcelRequire("eO7Kz")));

var $6d8d7d88109f8ff6$var$_useStyleSet3 = $6d8d7d88109f8ff6$var$_interopRequireDefault((parcelRequire("gC6jZ")));
function $6d8d7d88109f8ff6$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $6d8d7d88109f8ff6$var$_slicedToArray(arr, i) {
    return $6d8d7d88109f8ff6$var$_arrayWithHoles(arr) || $6d8d7d88109f8ff6$var$_iterableToArrayLimit(arr, i) || $6d8d7d88109f8ff6$var$_unsupportedIterableToArray(arr, i) || $6d8d7d88109f8ff6$var$_nonIterableRest();
}
function $6d8d7d88109f8ff6$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $6d8d7d88109f8ff6$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $6d8d7d88109f8ff6$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $6d8d7d88109f8ff6$var$_arrayLikeToArray(o, minLen);
}
function $6d8d7d88109f8ff6$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $6d8d7d88109f8ff6$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $6d8d7d88109f8ff6$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
var $6d8d7d88109f8ff6$var$AudioContent = function AudioContent(_ref) {
    var alt = _ref.alt, autoPlay = _ref.autoPlay, loop = _ref.loop, src = _ref.src;
    var _useStyleSet = (0, $6d8d7d88109f8ff6$var$_useStyleSet3.default)(), _useStyleSet2 = $6d8d7d88109f8ff6$var$_slicedToArray(_useStyleSet, 1), audioContentStyleSet = _useStyleSet2[0].audioContent;
    return /*#__PURE__*/ $6d8d7d88109f8ff6$var$_react.default.createElement("audio", {
        "aria-label": alt,
        autoPlay: autoPlay,
        className: audioContentStyleSet,
        controls: true,
        loop: loop,
        src: src
    });
};
$6d8d7d88109f8ff6$var$AudioContent.defaultProps = {
    alt: "",
    autoPlay: false,
    loop: false,
    poster: ""
};
$6d8d7d88109f8ff6$var$AudioContent.propTypes = {
    alt: $6d8d7d88109f8ff6$var$_propTypes.default.string,
    autoPlay: $6d8d7d88109f8ff6$var$_propTypes.default.bool,
    loop: $6d8d7d88109f8ff6$var$_propTypes.default.bool,
    // We will keep the "poster" prop for #3315.
    // eslint-disable-next-line react/no-unused-prop-types
    poster: $6d8d7d88109f8ff6$var$_propTypes.default.string,
    src: $6d8d7d88109f8ff6$var$_propTypes.default.string.isRequired
};
var $6d8d7d88109f8ff6$var$_default = $6d8d7d88109f8ff6$var$AudioContent;
module.exports.default = $6d8d7d88109f8ff6$var$_default;

});


parcelRequire.register("i6Tko", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d2f3b480f327e3c5$var$_propTypes = $d2f3b480f327e3c5$var$_interopRequireDefault((parcelRequire("f7UXb")));

var $d2f3b480f327e3c5$var$_react = $d2f3b480f327e3c5$var$_interopRequireDefault((parcelRequire("eO7Kz")));

var $d2f3b480f327e3c5$var$_FileContent = $d2f3b480f327e3c5$var$_interopRequireDefault((parcelRequire("dShpd")));
function $d2f3b480f327e3c5$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $d2f3b480f327e3c5$var$FileAttachment = function FileAttachment(_ref) {
    var _ref$activity = _ref.activity;
    _ref$activity = _ref$activity === void 0 ? {} : _ref$activity;
    var _ref$activity$attachm = _ref$activity.attachments, attachments = _ref$activity$attachm === void 0 ? [] : _ref$activity$attachm, _ref$activity$channel = _ref$activity.channelData;
    _ref$activity$channel = _ref$activity$channel === void 0 ? {} : _ref$activity$channel;
    var _ref$activity$channel2 = _ref$activity$channel.attachmentSizes, attachmentSizes = _ref$activity$channel2 === void 0 ? [] : _ref$activity$channel2, attachment = _ref.attachment;
    var attachmentIndex = attachments.indexOf(attachment);
    var size = attachmentSizes[+attachmentIndex];
    return /*#__PURE__*/ $d2f3b480f327e3c5$var$_react.default.createElement($d2f3b480f327e3c5$var$_FileContent.default, {
        fileName: attachment.name,
        href: attachment.contentUrl,
        size: size
    });
};
$d2f3b480f327e3c5$var$FileAttachment.propTypes = {
    activity: $d2f3b480f327e3c5$var$_propTypes.default.shape({
        attachment: $d2f3b480f327e3c5$var$_propTypes.default.array,
        channelData: $d2f3b480f327e3c5$var$_propTypes.default.shape({
            attachmentSizes: $d2f3b480f327e3c5$var$_propTypes.default.arrayOf($d2f3b480f327e3c5$var$_propTypes.default.number)
        })
    }).isRequired,
    attachment: $d2f3b480f327e3c5$var$_propTypes.default.shape({
        contentUrl: $d2f3b480f327e3c5$var$_propTypes.default.string,
        name: $d2f3b480f327e3c5$var$_propTypes.default.string.isRequired
    }).isRequired
};
var $d2f3b480f327e3c5$var$_default = $d2f3b480f327e3c5$var$FileAttachment;
module.exports.default = $d2f3b480f327e3c5$var$_default;

});
parcelRequire.register("dShpd", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $hd4g0 = parcelRequire("hd4g0");

var $a19dd1eda7bcb484$var$_classnames = $a19dd1eda7bcb484$var$_interopRequireDefault((parcelRequire("5A4MD")));

var $a19dd1eda7bcb484$var$_propTypes = $a19dd1eda7bcb484$var$_interopRequireDefault((parcelRequire("f7UXb")));

var $a19dd1eda7bcb484$var$_react = $a19dd1eda7bcb484$var$_interopRequireDefault((parcelRequire("eO7Kz")));

var $a19dd1eda7bcb484$var$_DownloadIcon = $a19dd1eda7bcb484$var$_interopRequireDefault((parcelRequire("jtxi1")));

var $a19dd1eda7bcb484$var$_useStyleSet3 = $a19dd1eda7bcb484$var$_interopRequireDefault((parcelRequire("gC6jZ")));

var $a19dd1eda7bcb484$var$_useStyleToEmotionObject = $a19dd1eda7bcb484$var$_interopRequireDefault((parcelRequire("6l4uV")));
function $a19dd1eda7bcb484$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $a19dd1eda7bcb484$var$_slicedToArray(arr, i) {
    return $a19dd1eda7bcb484$var$_arrayWithHoles(arr) || $a19dd1eda7bcb484$var$_iterableToArrayLimit(arr, i) || $a19dd1eda7bcb484$var$_unsupportedIterableToArray(arr, i) || $a19dd1eda7bcb484$var$_nonIterableRest();
}
function $a19dd1eda7bcb484$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $a19dd1eda7bcb484$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $a19dd1eda7bcb484$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $a19dd1eda7bcb484$var$_arrayLikeToArray(o, minLen);
}
function $a19dd1eda7bcb484$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $a19dd1eda7bcb484$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $a19dd1eda7bcb484$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
var $a19dd1eda7bcb484$var$useByteFormatter = $hd4g0.hooks.useByteFormatter, $a19dd1eda7bcb484$var$useDirection = $hd4g0.hooks.useDirection, $a19dd1eda7bcb484$var$useLocalizer = $hd4g0.hooks.useLocalizer;
var $a19dd1eda7bcb484$var$ROOT_STYLE = {
    display: "flex",
    "& .webchat__fileContent__buttonLink": {
        display: "flex",
        flex: 1
    },
    "& .webchat__fileContent__badge": {
        display: "flex",
        flex: 1,
        flexDirection: "column"
    }
};
var $a19dd1eda7bcb484$var$ALLOWED_PROTOCOLS = [
    "blob:",
    "data:",
    "http:",
    "https:"
];
function $a19dd1eda7bcb484$var$isAllowedProtocol(url) {
    try {
        return $a19dd1eda7bcb484$var$ALLOWED_PROTOCOLS.includes(new URL(url).protocol);
    } catch (err) {
        return false;
    }
}
var $a19dd1eda7bcb484$var$FileContentBadge = function FileContentBadge(_ref) {
    var downloadIcon = _ref.downloadIcon, fileName = _ref.fileName, size = _ref.size;
    var _useDirection = $a19dd1eda7bcb484$var$useDirection(), _useDirection2 = $a19dd1eda7bcb484$var$_slicedToArray(_useDirection, 1), direction = _useDirection2[0];
    var formatByte = $a19dd1eda7bcb484$var$useByteFormatter();
    var localizedSize = typeof size === "number" && formatByte(size);
    return /*#__PURE__*/ $a19dd1eda7bcb484$var$_react.default.createElement($a19dd1eda7bcb484$var$_react.default.Fragment, null, /*#__PURE__*/ $a19dd1eda7bcb484$var$_react.default.createElement("div", {
        "aria-hidden": true,
        className: "webchat__fileContent__badge"
    }, /*#__PURE__*/ $a19dd1eda7bcb484$var$_react.default.createElement("div", {
        className: "webchat__fileContent__fileName"
    }, fileName), !!localizedSize && /*#__PURE__*/ $a19dd1eda7bcb484$var$_react.default.createElement("div", {
        className: "webchat__fileContent__size"
    }, localizedSize)), downloadIcon && /*#__PURE__*/ $a19dd1eda7bcb484$var$_react.default.createElement($a19dd1eda7bcb484$var$_DownloadIcon.default, {
        className: (0, $a19dd1eda7bcb484$var$_classnames.default)("webchat__fileContent__downloadIcon", direction === "rtl" && "webchat__fileContent__downloadIcon--rtl"),
        size: 1.5
    }));
};
$a19dd1eda7bcb484$var$FileContentBadge.defaultProps = {
    downloadIcon: false,
    size: undefined
};
$a19dd1eda7bcb484$var$FileContentBadge.propTypes = {
    downloadIcon: $a19dd1eda7bcb484$var$_propTypes.default.bool,
    fileName: $a19dd1eda7bcb484$var$_propTypes.default.string.isRequired,
    size: $a19dd1eda7bcb484$var$_propTypes.default.number
};
var $a19dd1eda7bcb484$var$FileContent = function FileContent(_ref2) {
    var className = _ref2.className, href = _ref2.href, fileName = _ref2.fileName, size = _ref2.size;
    var _useStyleSet = (0, $a19dd1eda7bcb484$var$_useStyleSet3.default)(), _useStyleSet2 = $a19dd1eda7bcb484$var$_slicedToArray(_useStyleSet, 1), fileContentStyleSet = _useStyleSet2[0].fileContent;
    var localize = $a19dd1eda7bcb484$var$useLocalizer();
    var localizeBytes = $a19dd1eda7bcb484$var$useByteFormatter();
    var rootClassName = (0, $a19dd1eda7bcb484$var$_useStyleToEmotionObject.default)()($a19dd1eda7bcb484$var$ROOT_STYLE) + "";
    var localizedSize = typeof size === "number" && localizeBytes(size);
    href = href && $a19dd1eda7bcb484$var$isAllowedProtocol(href) ? href : undefined;
    var alt = localize(href ? localizedSize ? "FILE_CONTENT_DOWNLOADABLE_WITH_SIZE_ALT" : "FILE_CONTENT_DOWNLOADABLE_ALT" : localizedSize ? "FILE_CONTENT_WITH_SIZE_ALT" : "FILE_CONTENT_ALT", fileName, localizedSize);
    return /*#__PURE__*/ $a19dd1eda7bcb484$var$_react.default.createElement("div", {
        className: (0, $a19dd1eda7bcb484$var$_classnames.default)("webchat__fileContent", rootClassName, fileContentStyleSet + "", (className || "") + "")
    }, href ? /*#__PURE__*/ $a19dd1eda7bcb484$var$_react.default.createElement("a", {
        "aria-label": alt,
        className: "webchat__fileContent__buttonLink",
        download: fileName,
        href: href,
        rel: "noopener noreferrer",
        target: "_blank"
    }, /*#__PURE__*/ $a19dd1eda7bcb484$var$_react.default.createElement($a19dd1eda7bcb484$var$FileContentBadge, {
        downloadIcon: true,
        fileName: fileName,
        size: size
    })) : /*#__PURE__*/ $a19dd1eda7bcb484$var$_react.default.createElement($a19dd1eda7bcb484$var$FileContentBadge, {
        downloadIcon: false,
        fileName: fileName,
        size: size
    }));
};
$a19dd1eda7bcb484$var$FileContent.defaultProps = {
    className: "",
    href: undefined,
    size: undefined
};
$a19dd1eda7bcb484$var$FileContent.propTypes = {
    className: $a19dd1eda7bcb484$var$_propTypes.default.string,
    fileName: $a19dd1eda7bcb484$var$_propTypes.default.string.isRequired,
    href: $a19dd1eda7bcb484$var$_propTypes.default.string,
    size: $a19dd1eda7bcb484$var$_propTypes.default.number
};
var $a19dd1eda7bcb484$var$_default = $a19dd1eda7bcb484$var$FileContent;
module.exports.default = $a19dd1eda7bcb484$var$_default;

});
parcelRequire.register("jtxi1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e2da8c5d8f7a2e96$var$_propTypes = $e2da8c5d8f7a2e96$var$_interopRequireDefault((parcelRequire("f7UXb")));

var $e2da8c5d8f7a2e96$var$_react = $e2da8c5d8f7a2e96$var$_interopRequireDefault((parcelRequire("eO7Kz")));
function $e2da8c5d8f7a2e96$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $e2da8c5d8f7a2e96$var$ICON_SIZE_FACTOR = 22;
var $e2da8c5d8f7a2e96$var$DownloadIcon = function DownloadIcon(_ref) {
    var className = _ref.className, size = _ref.size;
    return /*#__PURE__*/ $e2da8c5d8f7a2e96$var$_react.default.createElement("svg", {
        className: className,
        focusable: false,
        height: $e2da8c5d8f7a2e96$var$ICON_SIZE_FACTOR * size,
        role: "presentation",
        viewBox: "0 0 31.8 46",
        width: $e2da8c5d8f7a2e96$var$ICON_SIZE_FACTOR * size
    }, /*#__PURE__*/ $e2da8c5d8f7a2e96$var$_react.default.createElement("path", {
        d: "M26.8,23.8l-10.9,11L5,23.8l1.6-1.6l8.2,8.3V5H17v25.5l8.2-8.3L26.8,23.8z M5.8,41v-2.2H26V41H5.8z"
    }));
};
$e2da8c5d8f7a2e96$var$DownloadIcon.defaultProps = {
    className: "",
    size: 1
};
$e2da8c5d8f7a2e96$var$DownloadIcon.propTypes = {
    className: $e2da8c5d8f7a2e96$var$_propTypes.default.string,
    size: $e2da8c5d8f7a2e96$var$_propTypes.default.number
};
var $e2da8c5d8f7a2e96$var$_default = $e2da8c5d8f7a2e96$var$DownloadIcon;
module.exports.default = $e2da8c5d8f7a2e96$var$_default;

});



parcelRequire.register("adyXK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $77063d22e62a0634$var$_propTypes = $77063d22e62a0634$var$_interopRequireDefault((parcelRequire("f7UXb")));

var $77063d22e62a0634$var$_react = $77063d22e62a0634$var$_interopRequireDefault((parcelRequire("eO7Kz")));

var $77063d22e62a0634$var$_ImageContent = $77063d22e62a0634$var$_interopRequireDefault((parcelRequire("11gyx")));

var $77063d22e62a0634$var$_readDataURIToBlob = $77063d22e62a0634$var$_interopRequireDefault((parcelRequire("hl1DT")));
function $77063d22e62a0634$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $77063d22e62a0634$var$ImageAttachment = function ImageAttachment(_ref) {
    var attachment = _ref.attachment;
    var imageURL = attachment.thumbnailUrl || attachment.contentUrl; // To support Content Security Policy, data URI cannot be used.
    // We need to parse the data URI into a blob: URL.
    var blob = (0, $77063d22e62a0634$var$_readDataURIToBlob.default)(imageURL);
    if (blob) imageURL = URL.createObjectURL(blob);
    return /*#__PURE__*/ $77063d22e62a0634$var$_react.default.createElement($77063d22e62a0634$var$_ImageContent.default, {
        alt: attachment.name,
        src: imageURL
    });
};
$77063d22e62a0634$var$ImageAttachment.propTypes = {
    // Either attachment.contentUrl or attachment.thumbnailUrl must be specified.
    attachment: $77063d22e62a0634$var$_propTypes.default.oneOfType([
        $77063d22e62a0634$var$_propTypes.default.shape({
            contentUrl: $77063d22e62a0634$var$_propTypes.default.string.isRequired,
            name: $77063d22e62a0634$var$_propTypes.default.string,
            thumbnailUrl: $77063d22e62a0634$var$_propTypes.default.string
        }),
        $77063d22e62a0634$var$_propTypes.default.shape({
            contentUrl: $77063d22e62a0634$var$_propTypes.default.string,
            name: $77063d22e62a0634$var$_propTypes.default.string,
            thumbnailUrl: $77063d22e62a0634$var$_propTypes.default.string.isRequired
        })
    ]).isRequired
};
var $77063d22e62a0634$var$_default = $77063d22e62a0634$var$ImageAttachment;
module.exports.default = $77063d22e62a0634$var$_default;

});
parcelRequire.register("11gyx", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $hd4g0 = parcelRequire("hd4g0");

var $0be2ba1eae7fe81e$var$_propTypes = $0be2ba1eae7fe81e$var$_interopRequireDefault((parcelRequire("f7UXb")));

var $0be2ba1eae7fe81e$var$_react = $0be2ba1eae7fe81e$var$_interopRequireDefault((parcelRequire("eO7Kz")));

var $0be2ba1eae7fe81e$var$_CroppedImage = $0be2ba1eae7fe81e$var$_interopRequireDefault((parcelRequire("3gvcE")));
function $0be2ba1eae7fe81e$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $0be2ba1eae7fe81e$var$_slicedToArray(arr, i) {
    return $0be2ba1eae7fe81e$var$_arrayWithHoles(arr) || $0be2ba1eae7fe81e$var$_iterableToArrayLimit(arr, i) || $0be2ba1eae7fe81e$var$_unsupportedIterableToArray(arr, i) || $0be2ba1eae7fe81e$var$_nonIterableRest();
}
function $0be2ba1eae7fe81e$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $0be2ba1eae7fe81e$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $0be2ba1eae7fe81e$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $0be2ba1eae7fe81e$var$_arrayLikeToArray(o, minLen);
}
function $0be2ba1eae7fe81e$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $0be2ba1eae7fe81e$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $0be2ba1eae7fe81e$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
var $0be2ba1eae7fe81e$var$useStyleOptions = $hd4g0.hooks.useStyleOptions;
var $0be2ba1eae7fe81e$var$ImageContent = function ImageContent(_ref) {
    var alt = _ref.alt, src = _ref.src;
    var _useStyleOptions = $0be2ba1eae7fe81e$var$useStyleOptions(), _useStyleOptions2 = $0be2ba1eae7fe81e$var$_slicedToArray(_useStyleOptions, 1), bubbleImageHeight = _useStyleOptions2[0].bubbleImageHeight;
    return /*#__PURE__*/ $0be2ba1eae7fe81e$var$_react.default.createElement($0be2ba1eae7fe81e$var$_CroppedImage.default, {
        alt: alt,
        height: bubbleImageHeight,
        src: src,
        width: "100%"
    });
};
$0be2ba1eae7fe81e$var$ImageContent.defaultProps = {
    alt: ""
};
$0be2ba1eae7fe81e$var$ImageContent.propTypes = {
    alt: $0be2ba1eae7fe81e$var$_propTypes.default.string,
    src: $0be2ba1eae7fe81e$var$_propTypes.default.string.isRequired
};
var $0be2ba1eae7fe81e$var$_default = $0be2ba1eae7fe81e$var$ImageContent;
module.exports.default = $0be2ba1eae7fe81e$var$_default;

});
parcelRequire.register("3gvcE", function(module, exports) {
"use strict";
function $260b11fa504577f7$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $260b11fa504577f7$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $260b11fa504577f7$var$_typeof(obj);
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $260b11fa504577f7$var$_classnames = $260b11fa504577f7$var$_interopRequireDefault((parcelRequire("5A4MD")));

var $260b11fa504577f7$var$_propTypes = $260b11fa504577f7$var$_interopRequireDefault((parcelRequire("f7UXb")));

var $260b11fa504577f7$var$_react = $260b11fa504577f7$var$_interopRequireWildcard((parcelRequire("eO7Kz")));

var $260b11fa504577f7$var$_useStyleToEmotionObject = $260b11fa504577f7$var$_interopRequireDefault((parcelRequire("6l4uV")));
function $260b11fa504577f7$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($260b11fa504577f7$var$_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $260b11fa504577f7$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || $260b11fa504577f7$var$_typeof(obj) !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $260b11fa504577f7$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $260b11fa504577f7$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $260b11fa504577f7$var$ROOT_STYLE = {
    overflow: "hidden",
    position: "relative",
    "& > img": {
        height: "auto",
        left: "50%",
        position: "absolute",
        top: "50%",
        transform: "translate(-50%, -50%)",
        width: "100%"
    }
};
var $260b11fa504577f7$var$CroppedImage = function CroppedImage(_ref) {
    var alt = _ref.alt, className = _ref.className, height = _ref.height, src = _ref.src, width = _ref.width;
    var rootClassName = (0, $260b11fa504577f7$var$_useStyleToEmotionObject.default)()($260b11fa504577f7$var$ROOT_STYLE) + "";
    var sizeStyle = (0, $260b11fa504577f7$var$_react.useMemo)(function() {
        return {
            height: height,
            width: width
        };
    }, [
        height,
        width
    ]);
    return /*#__PURE__*/ $260b11fa504577f7$var$_react.default.createElement("div", {
        className: (0, $260b11fa504577f7$var$_classnames.default)(rootClassName, (className || "") + ""),
        style: sizeStyle
    }, /*#__PURE__*/ $260b11fa504577f7$var$_react.default.createElement("img", {
        alt: alt,
        src: src
    }));
};
$260b11fa504577f7$var$CroppedImage.defaultProps = {
    alt: "",
    className: ""
};
$260b11fa504577f7$var$CroppedImage.propTypes = {
    alt: $260b11fa504577f7$var$_propTypes.default.string,
    className: $260b11fa504577f7$var$_propTypes.default.string,
    height: $260b11fa504577f7$var$_propTypes.default.oneOfType([
        $260b11fa504577f7$var$_propTypes.default.number,
        $260b11fa504577f7$var$_propTypes.default.string
    ]).isRequired,
    src: $260b11fa504577f7$var$_propTypes.default.string.isRequired,
    width: $260b11fa504577f7$var$_propTypes.default.oneOfType([
        $260b11fa504577f7$var$_propTypes.default.number,
        $260b11fa504577f7$var$_propTypes.default.string
    ]).isRequired
};
var $260b11fa504577f7$var$_default = $260b11fa504577f7$var$CroppedImage;
module.exports.default = $260b11fa504577f7$var$_default;

});


parcelRequire.register("hl1DT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $c9f5abfac9e060b9$var$readDataURIToBlob;
module.exports.parse = $c9f5abfac9e060b9$var$parse;

var $l4PI2 = parcelRequire("l4PI2");
function $c9f5abfac9e060b9$var$_slicedToArray(arr, i) {
    return $c9f5abfac9e060b9$var$_arrayWithHoles(arr) || $c9f5abfac9e060b9$var$_iterableToArrayLimit(arr, i) || $c9f5abfac9e060b9$var$_unsupportedIterableToArray(arr, i) || $c9f5abfac9e060b9$var$_nonIterableRest();
}
function $c9f5abfac9e060b9$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $c9f5abfac9e060b9$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $c9f5abfac9e060b9$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $c9f5abfac9e060b9$var$_arrayLikeToArray(o, minLen);
}
function $c9f5abfac9e060b9$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $c9f5abfac9e060b9$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $c9f5abfac9e060b9$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
var $c9f5abfac9e060b9$var$PATTERN = /^data:((?:(?!,)[\s\S])*?)(;(base64))?,([\+\/-9=A-Za-z]+)/;
var $c9f5abfac9e060b9$var$DEFAULT_CONTENT_TYPE = "text/plain;charset=US-ASCII";
function $c9f5abfac9e060b9$var$parse(dataURI) {
    var match = $c9f5abfac9e060b9$var$PATTERN.exec(dataURI);
    if (!match) return;
    var _match = $c9f5abfac9e060b9$var$_slicedToArray(match, 5), contentType = _match[1], encoding = _match[3], base64 = _match[4];
    if (encoding !== "base64") return;
    return {
        base64: base64,
        contentType: contentType || $c9f5abfac9e060b9$var$DEFAULT_CONTENT_TYPE,
        encoding: encoding
    };
}
function $c9f5abfac9e060b9$var$readDataURIToBlob(dataURI) {
    var parsed = $c9f5abfac9e060b9$var$parse(dataURI);
    if (!parsed) return;
    return new Blob([
        (0, $l4PI2.toByteArray)(parsed.base64)
    ], {
        type: parsed.contentType
    });
}

});


parcelRequire.register("c0ZXf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8bf58b001b231b6d$var$_propTypes = $8bf58b001b231b6d$var$_interopRequireDefault((parcelRequire("f7UXb")));

var $8bf58b001b231b6d$var$_react = $8bf58b001b231b6d$var$_interopRequireDefault((parcelRequire("eO7Kz")));

var $8bf58b001b231b6d$var$_TextContent = $8bf58b001b231b6d$var$_interopRequireDefault((parcelRequire("cBkf0")));
function $8bf58b001b231b6d$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $8bf58b001b231b6d$var$TextAttachment = function TextAttachment(_ref) {
    var _ref$attachment = _ref.attachment;
    _ref$attachment = _ref$attachment === void 0 ? {} : _ref$attachment;
    var _ref$attachment$conte = _ref$attachment.content, content = _ref$attachment$conte === void 0 ? "" : _ref$attachment$conte, contentType = _ref$attachment.contentType;
    return /*#__PURE__*/ $8bf58b001b231b6d$var$_react.default.createElement($8bf58b001b231b6d$var$_TextContent.default, {
        contentType: contentType,
        text: content
    });
};
$8bf58b001b231b6d$var$TextAttachment.propTypes = {
    attachment: $8bf58b001b231b6d$var$_propTypes.default.shape({
        content: $8bf58b001b231b6d$var$_propTypes.default.string,
        contentType: $8bf58b001b231b6d$var$_propTypes.default.string.isRequired
    }).isRequired
};
var $8bf58b001b231b6d$var$_default = $8bf58b001b231b6d$var$TextAttachment;
module.exports.default = $8bf58b001b231b6d$var$_default;

});
parcelRequire.register("cBkf0", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $92c8a43576644929$var$_classnames = $92c8a43576644929$var$_interopRequireDefault((parcelRequire("5A4MD")));

var $92c8a43576644929$var$_propTypes = $92c8a43576644929$var$_interopRequireDefault((parcelRequire("f7UXb")));

var $92c8a43576644929$var$_react = $92c8a43576644929$var$_interopRequireDefault((parcelRequire("eO7Kz")));

var $92c8a43576644929$var$_useRenderMarkdownAsHTML = $92c8a43576644929$var$_interopRequireDefault((parcelRequire("5BkDS")));

var $92c8a43576644929$var$_useStyleSet3 = $92c8a43576644929$var$_interopRequireDefault((parcelRequire("gC6jZ")));
function $92c8a43576644929$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $92c8a43576644929$var$_slicedToArray(arr, i) {
    return $92c8a43576644929$var$_arrayWithHoles(arr) || $92c8a43576644929$var$_iterableToArrayLimit(arr, i) || $92c8a43576644929$var$_unsupportedIterableToArray(arr, i) || $92c8a43576644929$var$_nonIterableRest();
}
function $92c8a43576644929$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $92c8a43576644929$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $92c8a43576644929$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $92c8a43576644929$var$_arrayLikeToArray(o, minLen);
}
function $92c8a43576644929$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $92c8a43576644929$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $92c8a43576644929$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
var $92c8a43576644929$var$TextContent = function TextContent(_ref) {
    var contentType = _ref.contentType, text = _ref.text;
    var _useStyleSet = (0, $92c8a43576644929$var$_useStyleSet3.default)(), _useStyleSet2 = $92c8a43576644929$var$_slicedToArray(_useStyleSet, 1), textContentStyleSet = _useStyleSet2[0].textContent;
    var renderMarkdownAsHTML = (0, $92c8a43576644929$var$_useRenderMarkdownAsHTML.default)();
    var contentTypeMarkdown = contentType === "text/markdown";
    return contentTypeMarkdown && renderMarkdownAsHTML ? /*#__PURE__*/ $92c8a43576644929$var$_react.default.createElement("div", {
        className: (0, $92c8a43576644929$var$_classnames.default)("markdown", textContentStyleSet + ""),
        dangerouslySetInnerHTML: {
            __html: renderMarkdownAsHTML(text || "")
        }
    }) : /*#__PURE__*/ $92c8a43576644929$var$_react.default.createElement($92c8a43576644929$var$_react.default.Fragment, null, (text || "").split("\n").map(function(line, index) {
        return /*#__PURE__*/ $92c8a43576644929$var$_react.default.createElement("p", {
            className: (0, $92c8a43576644929$var$_classnames.default)("plain", textContentStyleSet + ""),
            key: index
        }, line.trim());
    }));
};
$92c8a43576644929$var$TextContent.defaultProps = {
    contentType: "text/markdown"
};
$92c8a43576644929$var$TextContent.propTypes = {
    contentType: $92c8a43576644929$var$_propTypes.default.string,
    text: $92c8a43576644929$var$_propTypes.default.string.isRequired
};
var $92c8a43576644929$var$_default = $92c8a43576644929$var$TextContent;
module.exports.default = $92c8a43576644929$var$_default;

});


parcelRequire.register("icnJw", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d3fbc1e58a436ddc$var$_classnames = $d3fbc1e58a436ddc$var$_interopRequireDefault((parcelRequire("5A4MD")));

var $d3fbc1e58a436ddc$var$_propTypes = $d3fbc1e58a436ddc$var$_interopRequireDefault((parcelRequire("f7UXb")));

var $d3fbc1e58a436ddc$var$_react = $d3fbc1e58a436ddc$var$_interopRequireDefault((parcelRequire("eO7Kz")));

var $d3fbc1e58a436ddc$var$_useStyleSet3 = $d3fbc1e58a436ddc$var$_interopRequireDefault((parcelRequire("gC6jZ")));

var $d3fbc1e58a436ddc$var$_useStyleToEmotionObject = $d3fbc1e58a436ddc$var$_interopRequireDefault((parcelRequire("6l4uV")));

var $d3fbc1e58a436ddc$var$_VideoContent = $d3fbc1e58a436ddc$var$_interopRequireDefault((parcelRequire("6QoBQ")));
function $d3fbc1e58a436ddc$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $d3fbc1e58a436ddc$var$_slicedToArray(arr, i) {
    return $d3fbc1e58a436ddc$var$_arrayWithHoles(arr) || $d3fbc1e58a436ddc$var$_iterableToArrayLimit(arr, i) || $d3fbc1e58a436ddc$var$_unsupportedIterableToArray(arr, i) || $d3fbc1e58a436ddc$var$_nonIterableRest();
}
function $d3fbc1e58a436ddc$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $d3fbc1e58a436ddc$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $d3fbc1e58a436ddc$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $d3fbc1e58a436ddc$var$_arrayLikeToArray(o, minLen);
}
function $d3fbc1e58a436ddc$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $d3fbc1e58a436ddc$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $d3fbc1e58a436ddc$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
var $d3fbc1e58a436ddc$var$ROOT_STYLE = {
    display: "flex",
    flexDirection: "column"
};
var $d3fbc1e58a436ddc$var$VideoAttachment = function VideoAttachment(_ref) {
    var attachment = _ref.attachment;
    var _useStyleSet = (0, $d3fbc1e58a436ddc$var$_useStyleSet3.default)(), _useStyleSet2 = $d3fbc1e58a436ddc$var$_slicedToArray(_useStyleSet, 1), videoAttachmentStyleSet = _useStyleSet2[0].videoAttachment;
    var rootClassName = (0, $d3fbc1e58a436ddc$var$_useStyleToEmotionObject.default)()($d3fbc1e58a436ddc$var$ROOT_STYLE) + "";
    return /*#__PURE__*/ $d3fbc1e58a436ddc$var$_react.default.createElement("div", {
        className: (0, $d3fbc1e58a436ddc$var$_classnames.default)(rootClassName, videoAttachmentStyleSet + "")
    }, /*#__PURE__*/ $d3fbc1e58a436ddc$var$_react.default.createElement($d3fbc1e58a436ddc$var$_VideoContent.default, {
        alt: attachment.name,
        src: attachment.contentUrl
    }));
};
$d3fbc1e58a436ddc$var$VideoAttachment.propTypes = {
    attachment: $d3fbc1e58a436ddc$var$_propTypes.default.shape({
        contentUrl: $d3fbc1e58a436ddc$var$_propTypes.default.string.isRequired,
        name: $d3fbc1e58a436ddc$var$_propTypes.default.string
    }).isRequired
};
var $d3fbc1e58a436ddc$var$_default = $d3fbc1e58a436ddc$var$VideoAttachment;
module.exports.default = $d3fbc1e58a436ddc$var$_default;

});
parcelRequire.register("6QoBQ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4fbab0545bf698c3$var$_propTypes = $4fbab0545bf698c3$var$_interopRequireDefault((parcelRequire("f7UXb")));

var $4fbab0545bf698c3$var$_react = $4fbab0545bf698c3$var$_interopRequireDefault((parcelRequire("eO7Kz")));

var $4fbab0545bf698c3$var$_HTMLVideoContent = $4fbab0545bf698c3$var$_interopRequireDefault((parcelRequire("3LRa6")));

var $4fbab0545bf698c3$var$_VimeoContent = $4fbab0545bf698c3$var$_interopRequireDefault((parcelRequire("60GsU")));

var $4fbab0545bf698c3$var$_YouTubeContent = $4fbab0545bf698c3$var$_interopRequireDefault((parcelRequire("gPSfP")));
function $4fbab0545bf698c3$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $4fbab0545bf698c3$var$YOUTUBE_DOMAIN = "youtube.com";
var $4fbab0545bf698c3$var$YOUTUBE_WWW_DOMAIN = "www.youtube.com";
var $4fbab0545bf698c3$var$YOUTUBE_SHORT_DOMAIN = "youtu.be";
var $4fbab0545bf698c3$var$YOUTUBE_WWW_SHORT_DOMAIN = "www.youtu.be";
var $4fbab0545bf698c3$var$VIMEO_DOMAIN = "vimeo.com";
var $4fbab0545bf698c3$var$VIMEO_WWW_DOMAIN = "www.vimeo.com"; // This is a workaround
// - Today, there is no good URL polyfill for older browser
// - Instead of writing a URL parser, for older browser, we will use this <a href> trick to parse the URL
function $4fbab0545bf698c3$var$parseURL(url) {
    var urlLike;
    if (typeof URL === "function") urlLike = new URL(url);
    else {
        urlLike = document.createElement("a");
        urlLike.setAttribute("href", url);
    }
    var _urlLike = urlLike, hostname = _urlLike.hostname, pathname = _urlLike.pathname, search = _urlLike.search;
    return {
        hostname: hostname,
        pathname: pathname,
        search: search
    };
}
var $4fbab0545bf698c3$var$VideoContent = function VideoContent(_ref) {
    var alt = _ref.alt, autoPlay = _ref.autoPlay, loop = _ref.loop, poster = _ref.poster, src = _ref.src;
    var _parseURL = $4fbab0545bf698c3$var$parseURL(src), hostname = _parseURL.hostname, pathname = _parseURL.pathname, search = _parseURL.search;
    var lastSegment = pathname.split("/").pop();
    var searchParams = new URLSearchParams(search);
    switch(hostname){
        case $4fbab0545bf698c3$var$VIMEO_DOMAIN:
        case $4fbab0545bf698c3$var$VIMEO_WWW_DOMAIN:
            return /*#__PURE__*/ $4fbab0545bf698c3$var$_react.default.createElement($4fbab0545bf698c3$var$_VimeoContent.default, {
                alt: alt,
                autoPlay: autoPlay,
                embedID: lastSegment,
                loop: loop
            });
        case $4fbab0545bf698c3$var$YOUTUBE_DOMAIN:
        case $4fbab0545bf698c3$var$YOUTUBE_WWW_DOMAIN:
            return /*#__PURE__*/ $4fbab0545bf698c3$var$_react.default.createElement($4fbab0545bf698c3$var$_YouTubeContent.default, {
                alt: alt,
                autoPlay: autoPlay,
                embedID: searchParams.get("v"),
                loop: loop
            });
        case $4fbab0545bf698c3$var$YOUTUBE_SHORT_DOMAIN:
        case $4fbab0545bf698c3$var$YOUTUBE_WWW_SHORT_DOMAIN:
            return /*#__PURE__*/ $4fbab0545bf698c3$var$_react.default.createElement($4fbab0545bf698c3$var$_YouTubeContent.default, {
                alt: alt,
                autoPlay: autoPlay,
                embedID: lastSegment,
                loop: loop
            });
        default:
            return /*#__PURE__*/ $4fbab0545bf698c3$var$_react.default.createElement($4fbab0545bf698c3$var$_HTMLVideoContent.default, {
                alt: alt,
                autoPlay: autoPlay,
                loop: loop,
                poster: poster,
                src: src
            });
    }
};
$4fbab0545bf698c3$var$VideoContent.defaultProps = {
    alt: "",
    autoPlay: false,
    loop: false,
    poster: ""
};
$4fbab0545bf698c3$var$VideoContent.propTypes = {
    alt: $4fbab0545bf698c3$var$_propTypes.default.string,
    autoPlay: $4fbab0545bf698c3$var$_propTypes.default.bool,
    loop: $4fbab0545bf698c3$var$_propTypes.default.bool,
    poster: $4fbab0545bf698c3$var$_propTypes.default.string,
    src: $4fbab0545bf698c3$var$_propTypes.default.string.isRequired
};
var $4fbab0545bf698c3$var$_default = $4fbab0545bf698c3$var$VideoContent;
module.exports.default = $4fbab0545bf698c3$var$_default;

});
parcelRequire.register("3LRa6", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2beeffc0a1cbbcc8$var$_propTypes = $2beeffc0a1cbbcc8$var$_interopRequireDefault((parcelRequire("f7UXb")));

var $2beeffc0a1cbbcc8$var$_react = $2beeffc0a1cbbcc8$var$_interopRequireDefault((parcelRequire("eO7Kz")));

var $2beeffc0a1cbbcc8$var$_useStyleSet3 = $2beeffc0a1cbbcc8$var$_interopRequireDefault((parcelRequire("gC6jZ")));
function $2beeffc0a1cbbcc8$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $2beeffc0a1cbbcc8$var$_slicedToArray(arr, i) {
    return $2beeffc0a1cbbcc8$var$_arrayWithHoles(arr) || $2beeffc0a1cbbcc8$var$_iterableToArrayLimit(arr, i) || $2beeffc0a1cbbcc8$var$_unsupportedIterableToArray(arr, i) || $2beeffc0a1cbbcc8$var$_nonIterableRest();
}
function $2beeffc0a1cbbcc8$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $2beeffc0a1cbbcc8$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $2beeffc0a1cbbcc8$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $2beeffc0a1cbbcc8$var$_arrayLikeToArray(o, minLen);
}
function $2beeffc0a1cbbcc8$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $2beeffc0a1cbbcc8$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $2beeffc0a1cbbcc8$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
var $2beeffc0a1cbbcc8$var$HTMLVideoContent = function HTMLVideoContent(_ref) {
    var alt = _ref.alt, autoPlay = _ref.autoPlay, loop = _ref.loop, poster = _ref.poster, src = _ref.src;
    var _useStyleSet = (0, $2beeffc0a1cbbcc8$var$_useStyleSet3.default)(), _useStyleSet2 = $2beeffc0a1cbbcc8$var$_slicedToArray(_useStyleSet, 1), videoContentStyleSet = _useStyleSet2[0].videoContent;
    return /*#__PURE__*/ $2beeffc0a1cbbcc8$var$_react.default.createElement("video", {
        "aria-label": alt,
        autoPlay: autoPlay,
        className: videoContentStyleSet,
        controls: true,
        loop: loop,
        poster: poster,
        src: src
    });
};
$2beeffc0a1cbbcc8$var$HTMLVideoContent.defaultProps = {
    alt: "",
    autoPlay: false,
    loop: false,
    poster: ""
};
$2beeffc0a1cbbcc8$var$HTMLVideoContent.propTypes = {
    alt: $2beeffc0a1cbbcc8$var$_propTypes.default.string,
    autoPlay: $2beeffc0a1cbbcc8$var$_propTypes.default.bool,
    loop: $2beeffc0a1cbbcc8$var$_propTypes.default.bool,
    poster: $2beeffc0a1cbbcc8$var$_propTypes.default.string,
    src: $2beeffc0a1cbbcc8$var$_propTypes.default.string.isRequired
};
var $2beeffc0a1cbbcc8$var$_default = $2beeffc0a1cbbcc8$var$HTMLVideoContent;
module.exports.default = $2beeffc0a1cbbcc8$var$_default;

});

parcelRequire.register("60GsU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $hd4g0 = parcelRequire("hd4g0");

var $4603aedd00fbd14f$var$_propTypes = $4603aedd00fbd14f$var$_interopRequireDefault((parcelRequire("f7UXb")));

var $4603aedd00fbd14f$var$_react = $4603aedd00fbd14f$var$_interopRequireDefault((parcelRequire("eO7Kz")));

var $4603aedd00fbd14f$var$_useStyleSet3 = $4603aedd00fbd14f$var$_interopRequireDefault((parcelRequire("gC6jZ")));
function $4603aedd00fbd14f$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $4603aedd00fbd14f$var$_slicedToArray(arr, i) {
    return $4603aedd00fbd14f$var$_arrayWithHoles(arr) || $4603aedd00fbd14f$var$_iterableToArrayLimit(arr, i) || $4603aedd00fbd14f$var$_unsupportedIterableToArray(arr, i) || $4603aedd00fbd14f$var$_nonIterableRest();
}
function $4603aedd00fbd14f$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $4603aedd00fbd14f$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $4603aedd00fbd14f$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $4603aedd00fbd14f$var$_arrayLikeToArray(o, minLen);
}
function $4603aedd00fbd14f$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $4603aedd00fbd14f$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $4603aedd00fbd14f$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
var $4603aedd00fbd14f$var$useLocalizer = $hd4g0.hooks.useLocalizer;
var $4603aedd00fbd14f$var$VimeoContent = function VimeoContent(_ref) {
    var alt = _ref.alt, autoPlay = _ref.autoPlay, embedID = _ref.embedID, loop = _ref.loop;
    var _useStyleSet = (0, $4603aedd00fbd14f$var$_useStyleSet3.default)(), _useStyleSet2 = $4603aedd00fbd14f$var$_slicedToArray(_useStyleSet, 1), vimeoContentStyleSet = _useStyleSet2[0].vimeoContent;
    var localize = $4603aedd00fbd14f$var$useLocalizer();
    var search = new URLSearchParams({
        autoplay: autoPlay ? "1" : "0",
        badge: "0",
        byline: "0",
        loop: loop ? "1" : "0",
        portrait: "0",
        title: "0"
    }).toString();
    var title = localize("ATTACHMENT_VIDEO");
    return /*#__PURE__*/ $4603aedd00fbd14f$var$_react.default.createElement("iframe", {
        allowFullScreen: true,
        "aria-label": alt,
        className: vimeoContentStyleSet,
        sandbox: "allow-same-origin allow-scripts",
        src: "https://player.vimeo.com/video/".concat(encodeURI(embedID), "?").concat(search),
        title: title
    });
};
$4603aedd00fbd14f$var$VimeoContent.defaultProps = {
    alt: "",
    autoPlay: false,
    loop: false
};
$4603aedd00fbd14f$var$VimeoContent.propTypes = {
    alt: $4603aedd00fbd14f$var$_propTypes.default.string,
    autoPlay: $4603aedd00fbd14f$var$_propTypes.default.bool,
    embedID: $4603aedd00fbd14f$var$_propTypes.default.string.isRequired,
    loop: $4603aedd00fbd14f$var$_propTypes.default.bool
};
var $4603aedd00fbd14f$var$_default = $4603aedd00fbd14f$var$VimeoContent;
module.exports.default = $4603aedd00fbd14f$var$_default;

});

parcelRequire.register("gPSfP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $hd4g0 = parcelRequire("hd4g0");

var $c41b7e8510a51519$var$_propTypes = $c41b7e8510a51519$var$_interopRequireDefault((parcelRequire("f7UXb")));

var $c41b7e8510a51519$var$_react = $c41b7e8510a51519$var$_interopRequireDefault((parcelRequire("eO7Kz")));

var $c41b7e8510a51519$var$_useStyleSet3 = $c41b7e8510a51519$var$_interopRequireDefault((parcelRequire("gC6jZ")));
function $c41b7e8510a51519$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $c41b7e8510a51519$var$_slicedToArray(arr, i) {
    return $c41b7e8510a51519$var$_arrayWithHoles(arr) || $c41b7e8510a51519$var$_iterableToArrayLimit(arr, i) || $c41b7e8510a51519$var$_unsupportedIterableToArray(arr, i) || $c41b7e8510a51519$var$_nonIterableRest();
}
function $c41b7e8510a51519$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $c41b7e8510a51519$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $c41b7e8510a51519$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $c41b7e8510a51519$var$_arrayLikeToArray(o, minLen);
}
function $c41b7e8510a51519$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $c41b7e8510a51519$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $c41b7e8510a51519$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
var $c41b7e8510a51519$var$useLocalizer = $hd4g0.hooks.useLocalizer;
var $c41b7e8510a51519$var$YouTubeContent = function YouTubeContent(_ref) {
    var alt = _ref.alt, autoPlay = _ref.autoPlay, embedID = _ref.embedID, loop = _ref.loop;
    var _useStyleSet = (0, $c41b7e8510a51519$var$_useStyleSet3.default)(), _useStyleSet2 = $c41b7e8510a51519$var$_slicedToArray(_useStyleSet, 1), youTubeContentStyleSet = _useStyleSet2[0].youTubeContent;
    var localize = $c41b7e8510a51519$var$useLocalizer();
    var search = new URLSearchParams({
        autoplay: autoPlay ? "1" : "0",
        loop: loop ? "1" : "0",
        modestbranding: "1"
    }).toString();
    var title = localize("ATTACHMENT_VIDEO");
    return(/*#__PURE__*/ // TODO: We should encodeURI the URL
    $c41b7e8510a51519$var$_react.default.createElement("iframe", {
        allowFullScreen: true,
        "aria-label": alt,
        className: youTubeContentStyleSet,
        sandbox: "allow-same-origin allow-scripts",
        src: "https://youtube.com/embed/".concat(embedID, "?").concat(search),
        title: title
    }));
};
$c41b7e8510a51519$var$YouTubeContent.defaultProps = {
    alt: "",
    autoPlay: false,
    loop: false
};
$c41b7e8510a51519$var$YouTubeContent.propTypes = {
    alt: $c41b7e8510a51519$var$_propTypes.default.string,
    autoPlay: $c41b7e8510a51519$var$_propTypes.default.bool,
    embedID: $c41b7e8510a51519$var$_propTypes.default.string.isRequired,
    loop: $c41b7e8510a51519$var$_propTypes.default.bool
};
var $c41b7e8510a51519$var$_default = $c41b7e8510a51519$var$YouTubeContent;
module.exports.default = $c41b7e8510a51519$var$_default;

});




parcelRequire.register("bIkyU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DefaultAvatar = void 0;
module.exports.default = $8873c0faabf55106$var$createCoreAvatarMiddleware;

var $8873c0faabf55106$var$_classnames = $8873c0faabf55106$var$_interopRequireDefault((parcelRequire("5A4MD")));

var $8873c0faabf55106$var$_propTypes = $8873c0faabf55106$var$_interopRequireDefault((parcelRequire("f7UXb")));

var $8873c0faabf55106$var$_react = $8873c0faabf55106$var$_interopRequireDefault((parcelRequire("eO7Kz")));

var $8873c0faabf55106$var$_ImageAvatar = $8873c0faabf55106$var$_interopRequireDefault((parcelRequire("fgSEd")));

var $8873c0faabf55106$var$_InitialsAvatar = $8873c0faabf55106$var$_interopRequireDefault((parcelRequire("jI0MR")));

var $8873c0faabf55106$var$_useStyleSet3 = $8873c0faabf55106$var$_interopRequireDefault((parcelRequire("gC6jZ")));

var $8873c0faabf55106$var$_useStyleToEmotionObject = $8873c0faabf55106$var$_interopRequireDefault((parcelRequire("6l4uV")));
function $8873c0faabf55106$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $8873c0faabf55106$var$_slicedToArray(arr, i) {
    return $8873c0faabf55106$var$_arrayWithHoles(arr) || $8873c0faabf55106$var$_iterableToArrayLimit(arr, i) || $8873c0faabf55106$var$_unsupportedIterableToArray(arr, i) || $8873c0faabf55106$var$_nonIterableRest();
}
function $8873c0faabf55106$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $8873c0faabf55106$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $8873c0faabf55106$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $8873c0faabf55106$var$_arrayLikeToArray(o, minLen);
}
function $8873c0faabf55106$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $8873c0faabf55106$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $8873c0faabf55106$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
var $8873c0faabf55106$var$ROOT_STYLE = {
    overflow: "hidden",
    position: "relative",
    "> *": {
        left: 0,
        position: "absolute",
        top: 0
    }
};
var $8873c0faabf55106$var$DefaultAvatar = function DefaultAvatar(_ref) {
    var ariaHidden = _ref["aria-hidden"], className = _ref.className, fromUser = _ref.fromUser;
    var _useStyleSet = (0, $8873c0faabf55106$var$_useStyleSet3.default)(), _useStyleSet2 = $8873c0faabf55106$var$_slicedToArray(_useStyleSet, 1), avatarStyleSet = _useStyleSet2[0].avatar;
    var rootClassName = (0, $8873c0faabf55106$var$_useStyleToEmotionObject.default)()($8873c0faabf55106$var$ROOT_STYLE) + "";
    return /*#__PURE__*/ $8873c0faabf55106$var$_react.default.createElement("div", {
        "aria-hidden": ariaHidden,
        className: (0, $8873c0faabf55106$var$_classnames.default)("webchat__defaultAvatar", {
            "webchat__defaultAvatar--fromUser": fromUser
        }, rootClassName, avatarStyleSet + "", (className || "") + "")
    }, /*#__PURE__*/ $8873c0faabf55106$var$_react.default.createElement($8873c0faabf55106$var$_InitialsAvatar.default, {
        fromUser: fromUser
    }), /*#__PURE__*/ $8873c0faabf55106$var$_react.default.createElement($8873c0faabf55106$var$_ImageAvatar.default, {
        fromUser: fromUser
    }));
};
module.exports.DefaultAvatar = $8873c0faabf55106$var$DefaultAvatar;
$8873c0faabf55106$var$DefaultAvatar.defaultProps = {
    "aria-hidden": true,
    className: ""
};
$8873c0faabf55106$var$DefaultAvatar.propTypes = {
    "aria-hidden": $8873c0faabf55106$var$_propTypes.default.bool,
    className: $8873c0faabf55106$var$_propTypes.default.string,
    fromUser: $8873c0faabf55106$var$_propTypes.default.bool.isRequired
};
function $8873c0faabf55106$var$createCoreAvatarMiddleware() {
    return [
        function() {
            return function() {
                return function(_ref2) {
                    var fromUser = _ref2.fromUser, styleOptions = _ref2.styleOptions;
                    var botAvatarImage = styleOptions.botAvatarImage, botAvatarInitials = styleOptions.botAvatarInitials, userAvatarImage = styleOptions.userAvatarImage, userAvatarInitials = styleOptions.userAvatarInitials;
                    if (fromUser ? userAvatarImage || userAvatarInitials : botAvatarImage || botAvatarInitials) return function() {
                        return /*#__PURE__*/ $8873c0faabf55106$var$_react.default.createElement($8873c0faabf55106$var$DefaultAvatar, {
                            fromUser: fromUser
                        });
                    };
                    return false;
                };
            };
        }
    ];
}

});
parcelRequire.register("fgSEd", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $hd4g0 = parcelRequire("hd4g0");

var $b1e2bd80ee6bd454$var$_classnames = $b1e2bd80ee6bd454$var$_interopRequireDefault((parcelRequire("5A4MD")));

var $b1e2bd80ee6bd454$var$_propTypes = $b1e2bd80ee6bd454$var$_interopRequireDefault((parcelRequire("f7UXb")));

var $b1e2bd80ee6bd454$var$_react = $b1e2bd80ee6bd454$var$_interopRequireDefault((parcelRequire("eO7Kz")));

var $b1e2bd80ee6bd454$var$_CroppedImage = $b1e2bd80ee6bd454$var$_interopRequireDefault((parcelRequire("3gvcE")));

var $b1e2bd80ee6bd454$var$_useStyleSet3 = $b1e2bd80ee6bd454$var$_interopRequireDefault((parcelRequire("gC6jZ")));

var $b1e2bd80ee6bd454$var$_useStyleToEmotionObject = $b1e2bd80ee6bd454$var$_interopRequireDefault((parcelRequire("6l4uV")));
function $b1e2bd80ee6bd454$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $b1e2bd80ee6bd454$var$_slicedToArray(arr, i) {
    return $b1e2bd80ee6bd454$var$_arrayWithHoles(arr) || $b1e2bd80ee6bd454$var$_iterableToArrayLimit(arr, i) || $b1e2bd80ee6bd454$var$_unsupportedIterableToArray(arr, i) || $b1e2bd80ee6bd454$var$_nonIterableRest();
}
function $b1e2bd80ee6bd454$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $b1e2bd80ee6bd454$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $b1e2bd80ee6bd454$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $b1e2bd80ee6bd454$var$_arrayLikeToArray(o, minLen);
}
function $b1e2bd80ee6bd454$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $b1e2bd80ee6bd454$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $b1e2bd80ee6bd454$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
var $b1e2bd80ee6bd454$var$useAvatarForBot = $hd4g0.hooks.useAvatarForBot, $b1e2bd80ee6bd454$var$useAvatarForUser = $hd4g0.hooks.useAvatarForUser;
var $b1e2bd80ee6bd454$var$ROOT_STYLE = {
    "& .webchat__imageAvatar__image": {
        width: "100%"
    }
};
var $b1e2bd80ee6bd454$var$ImageAvatar = function ImageAvatar(_ref) {
    var fromUser = _ref.fromUser;
    var _useAvatarForBot = $b1e2bd80ee6bd454$var$useAvatarForBot(), _useAvatarForBot2 = $b1e2bd80ee6bd454$var$_slicedToArray(_useAvatarForBot, 1), avatarImageForBot = _useAvatarForBot2[0].image;
    var _useAvatarForUser = $b1e2bd80ee6bd454$var$useAvatarForUser(), _useAvatarForUser2 = $b1e2bd80ee6bd454$var$_slicedToArray(_useAvatarForUser, 1), avatarImageForUser = _useAvatarForUser2[0].image;
    var _useStyleSet = (0, $b1e2bd80ee6bd454$var$_useStyleSet3.default)(), _useStyleSet2 = $b1e2bd80ee6bd454$var$_slicedToArray(_useStyleSet, 1), imageAvatarStyleSet = _useStyleSet2[0].imageAvatar;
    var rootClassName = (0, $b1e2bd80ee6bd454$var$_useStyleToEmotionObject.default)()($b1e2bd80ee6bd454$var$ROOT_STYLE) + "";
    var avatarImage = fromUser ? avatarImageForUser : avatarImageForBot;
    return !!avatarImage && /*#__PURE__*/ $b1e2bd80ee6bd454$var$_react.default.createElement("div", {
        className: (0, $b1e2bd80ee6bd454$var$_classnames.default)("webchat__imageAvatar", rootClassName, imageAvatarStyleSet + "")
    }, /*#__PURE__*/ $b1e2bd80ee6bd454$var$_react.default.createElement($b1e2bd80ee6bd454$var$_CroppedImage.default, {
        alt: "",
        className: "webchat__imageAvatar__image",
        height: "100%",
        src: fromUser ? avatarImageForUser : avatarImageForBot,
        width: "100%"
    }));
};
$b1e2bd80ee6bd454$var$ImageAvatar.defaultProps = {
    fromUser: false
};
$b1e2bd80ee6bd454$var$ImageAvatar.propTypes = {
    fromUser: $b1e2bd80ee6bd454$var$_propTypes.default.bool
};
var $b1e2bd80ee6bd454$var$_default = $b1e2bd80ee6bd454$var$ImageAvatar;
module.exports.default = $b1e2bd80ee6bd454$var$_default;

});

parcelRequire.register("jI0MR", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $hd4g0 = parcelRequire("hd4g0");

var $e592bca77a025700$var$_classnames = $e592bca77a025700$var$_interopRequireDefault((parcelRequire("5A4MD")));

var $e592bca77a025700$var$_propTypes = $e592bca77a025700$var$_interopRequireDefault((parcelRequire("f7UXb")));

var $e592bca77a025700$var$_react = $e592bca77a025700$var$_interopRequireDefault((parcelRequire("eO7Kz")));

var $e592bca77a025700$var$_useStyleSet3 = $e592bca77a025700$var$_interopRequireDefault((parcelRequire("gC6jZ")));

var $e592bca77a025700$var$_useStyleToEmotionObject = $e592bca77a025700$var$_interopRequireDefault((parcelRequire("6l4uV")));
function $e592bca77a025700$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $e592bca77a025700$var$_slicedToArray(arr, i) {
    return $e592bca77a025700$var$_arrayWithHoles(arr) || $e592bca77a025700$var$_iterableToArrayLimit(arr, i) || $e592bca77a025700$var$_unsupportedIterableToArray(arr, i) || $e592bca77a025700$var$_nonIterableRest();
}
function $e592bca77a025700$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $e592bca77a025700$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $e592bca77a025700$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $e592bca77a025700$var$_arrayLikeToArray(o, minLen);
}
function $e592bca77a025700$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $e592bca77a025700$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $e592bca77a025700$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
var $e592bca77a025700$var$useAvatarForBot = $hd4g0.hooks.useAvatarForBot, $e592bca77a025700$var$useAvatarForUser = $hd4g0.hooks.useAvatarForUser;
var $e592bca77a025700$var$ROOT_STYLE = {
    alignItems: "center",
    display: "flex",
    "& .webchat__initialsAvatar__initials": {
        justifyContent: "center"
    }
};
var $e592bca77a025700$var$InitialsAvatar = function InitialsAvatar(_ref) {
    var fromUser = _ref.fromUser;
    var _useAvatarForBot = $e592bca77a025700$var$useAvatarForBot(), _useAvatarForBot2 = $e592bca77a025700$var$_slicedToArray(_useAvatarForBot, 1), avatarInitialsForBot = _useAvatarForBot2[0].initials;
    var _useAvatarForUser = $e592bca77a025700$var$useAvatarForUser(), _useAvatarForUser2 = $e592bca77a025700$var$_slicedToArray(_useAvatarForUser, 1), avatarInitialsForUser = _useAvatarForUser2[0].initials;
    var _useStyleSet = (0, $e592bca77a025700$var$_useStyleSet3.default)(), _useStyleSet2 = $e592bca77a025700$var$_slicedToArray(_useStyleSet, 1), initialsAvatarStyleSet = _useStyleSet2[0].initialsAvatar;
    var rootClassName = (0, $e592bca77a025700$var$_useStyleToEmotionObject.default)()($e592bca77a025700$var$ROOT_STYLE) + "";
    return /*#__PURE__*/ $e592bca77a025700$var$_react.default.createElement("div", {
        className: (0, $e592bca77a025700$var$_classnames.default)("webchat__initialsAvatar", {
            "webchat__initialsAvatar--fromUser": fromUser
        }, rootClassName, initialsAvatarStyleSet + "")
    }, /*#__PURE__*/ $e592bca77a025700$var$_react.default.createElement("div", {
        className: "webchat__initialsAvatar__initials"
    }, fromUser ? avatarInitialsForUser : avatarInitialsForBot));
};
$e592bca77a025700$var$InitialsAvatar.defaultProps = {
    fromUser: false
};
$e592bca77a025700$var$InitialsAvatar.propTypes = {
    fromUser: $e592bca77a025700$var$_propTypes.default.bool
};
var $e592bca77a025700$var$_default = $e592bca77a025700$var$InitialsAvatar;
module.exports.default = $e592bca77a025700$var$_default;

});


parcelRequire.register("7tAMc", function(module, exports) {
"use strict";
function $5717c4da46066f16$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $5717c4da46066f16$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $5717c4da46066f16$var$_typeof(obj);
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $5717c4da46066f16$var$createDefaultCardActionMiddleware;

var $gLt36 = parcelRequire("gLt36");
function $5717c4da46066f16$var$_regeneratorRuntime() {
    "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ 
    $5717c4da46066f16$var$_regeneratorRuntime = function _regeneratorRuntime() {
        return exports;
    };
    var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
    function define(obj, key, value) {
        return Object.defineProperty(obj, key, {
            value: value,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }), obj[key];
    }
    try {
        define({}, "");
    } catch (err) {
        define = function define(obj, key, value) {
            return obj[key] = value;
        };
    }
    function wrap(innerFn, outerFn, self, tryLocsList) {
        var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []);
        return generator._invoke = function(innerFn, self, context) {
            var state = "suspendedStart";
            return function(method, arg) {
                if ("executing" === state) throw new Error("Generator is already running");
                if ("completed" === state) {
                    if ("throw" === method) throw arg;
                    return doneResult();
                }
                for(context.method = method, context.arg = arg;;){
                    var delegate = context.delegate;
                    if (delegate) {
                        var delegateResult = maybeInvokeDelegate(delegate, context);
                        if (delegateResult) {
                            if (delegateResult === ContinueSentinel) continue;
                            return delegateResult;
                        }
                    }
                    if ("next" === context.method) context.sent = context._sent = context.arg;
                    else if ("throw" === context.method) {
                        if ("suspendedStart" === state) throw state = "completed", context.arg;
                        context.dispatchException(context.arg);
                    } else "return" === context.method && context.abrupt("return", context.arg);
                    state = "executing";
                    var record = tryCatch(innerFn, self, context);
                    if ("normal" === record.type) {
                        if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue;
                        return {
                            value: record.arg,
                            done: context.done
                        };
                    }
                    "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg);
                }
            };
        }(innerFn, self, context), generator;
    }
    function tryCatch(fn, obj, arg) {
        try {
            return {
                type: "normal",
                arg: fn.call(obj, arg)
            };
        } catch (err) {
            return {
                type: "throw",
                arg: err
            };
        }
    }
    exports.wrap = wrap;
    var ContinueSentinel = {};
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    var IteratorPrototype = {};
    define(IteratorPrototype, iteratorSymbol, function() {
        return this;
    });
    var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([])));
    NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype);
    var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
    function defineIteratorMethods(prototype) {
        [
            "next",
            "throw",
            "return"
        ].forEach(function(method) {
            define(prototype, method, function(arg) {
                return this._invoke(method, arg);
            });
        });
    }
    function AsyncIterator(generator, PromiseImpl) {
        function invoke(method, arg, resolve, reject) {
            var record = tryCatch(generator[method], generator, arg);
            if ("throw" !== record.type) {
                var result = record.arg, value = result.value;
                return value && "object" == $5717c4da46066f16$var$_typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function(value) {
                    invoke("next", value, resolve, reject);
                }, function(err) {
                    invoke("throw", err, resolve, reject);
                }) : PromiseImpl.resolve(value).then(function(unwrapped) {
                    result.value = unwrapped, resolve(result);
                }, function(error) {
                    return invoke("throw", error, resolve, reject);
                });
            }
            reject(record.arg);
        }
        var previousPromise;
        this._invoke = function(method, arg) {
            function callInvokeWithMethodAndArg() {
                return new PromiseImpl(function(resolve, reject) {
                    invoke(method, arg, resolve, reject);
                });
            }
            return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
        };
    }
    function maybeInvokeDelegate(delegate, context) {
        var method = delegate.iterator[context.method];
        if (undefined === method) {
            if (context.delegate = null, "throw" === context.method) {
                if (delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel;
                context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method");
            }
            return ContinueSentinel;
        }
        var record = tryCatch(method, delegate.iterator, context.arg);
        if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel;
        var info = record.arg;
        return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel);
    }
    function pushTryEntry(locs) {
        var entry = {
            tryLoc: locs[0]
        };
        1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry);
    }
    function resetTryEntry(entry) {
        var record = entry.completion || {};
        record.type = "normal", delete record.arg, entry.completion = record;
    }
    function Context(tryLocsList) {
        this.tryEntries = [
            {
                tryLoc: "root"
            }
        ], tryLocsList.forEach(pushTryEntry, this), this.reset(!0);
    }
    function values(iterable) {
        if (iterable) {
            var iteratorMethod = iterable[iteratorSymbol];
            if (iteratorMethod) return iteratorMethod.call(iterable);
            if ("function" == typeof iterable.next) return iterable;
            if (!isNaN(iterable.length)) {
                var i = -1, next = function next() {
                    for(; ++i < iterable.length;){
                        if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next;
                    }
                    return next.value = undefined, next.done = !0, next;
                };
                return next.next = next;
            }
        }
        return {
            next: doneResult
        };
    }
    function doneResult() {
        return {
            value: undefined,
            done: !0
        };
    }
    return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function(genFun) {
        var ctor = "function" == typeof genFun && genFun.constructor;
        return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name));
    }, exports.mark = function(genFun) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun;
    }, exports.awrap = function(arg) {
        return {
            __await: arg
        };
    }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function() {
        return this;
    }), exports.AsyncIterator = AsyncIterator, exports.async = function(innerFn, outerFn, self, tryLocsList, PromiseImpl) {
        void 0 === PromiseImpl && (PromiseImpl = Promise);
        var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
        return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function(result) {
            return result.done ? result.value : iter.next();
        });
    }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function() {
        return this;
    }), define(Gp, "toString", function() {
        return "[object Generator]";
    }), exports.keys = function(object) {
        var keys = [];
        for(var key in object)keys.push(key);
        return keys.reverse(), function next() {
            for(; keys.length;){
                var key = keys.pop();
                if (key in object) return next.value = key, next.done = !1, next;
            }
            return next.done = !0, next;
        };
    }, exports.values = values, Context.prototype = {
        constructor: Context,
        reset: function reset(skipTempReset) {
            if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for(var name in this)"t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined);
        },
        stop: function stop() {
            this.done = !0;
            var rootRecord = this.tryEntries[0].completion;
            if ("throw" === rootRecord.type) throw rootRecord.arg;
            return this.rval;
        },
        dispatchException: function dispatchException(exception) {
            if (this.done) throw exception;
            var context = this;
            function handle(loc, caught) {
                return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught;
            }
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i], record = entry.completion;
                if ("root" === entry.tryLoc) return handle("end");
                if (entry.tryLoc <= this.prev) {
                    var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc");
                    if (hasCatch && hasFinally) {
                        if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
                        if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
                    } else if (hasCatch) {
                        if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
                    } else {
                        if (!hasFinally) throw new Error("try statement without catch or finally");
                        if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
                    }
                }
            }
        },
        abrupt: function abrupt(type, arg) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
                    var finallyEntry = entry;
                    break;
                }
            }
            finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null);
            var record = finallyEntry ? finallyEntry.completion : {};
            return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record);
        },
        complete: function complete(record, afterLoc) {
            if ("throw" === record.type) throw record.arg;
            return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel;
        },
        finish: function finish(finallyLoc) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel;
            }
        },
        catch: function _catch(tryLoc) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.tryLoc === tryLoc) {
                    var record = entry.completion;
                    if ("throw" === record.type) {
                        var thrown = record.arg;
                        resetTryEntry(entry);
                    }
                    return thrown;
                }
            }
            throw new Error("illegal catch attempt");
        },
        delegateYield: function delegateYield(iterable, resultName, nextLoc) {
            return this.delegate = {
                iterator: values(iterable),
                resultName: resultName,
                nextLoc: nextLoc
            }, "next" === this.method && (this.arg = undefined), ContinueSentinel;
        }
    }, exports;
}
function $5717c4da46066f16$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) resolve(value);
    else Promise.resolve(value).then(_next, _throw);
}
function $5717c4da46066f16$var$_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                $5717c4da46066f16$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                $5717c4da46066f16$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
// This code is adopted from sanitize-html/naughtyScheme.
// sanitize-html is a dependency of Web Chat but the naughtScheme function is neither exposed nor reusable.
// https://github.com/apostrophecms/sanitize-html/
function $5717c4da46066f16$var$getScheme(href) {
    // Browsers ignore character codes of 32 (space) and below in a surprising
    // number of situations. Start reading here:
    // https://www.owasp.org/index.php/XSS_Filter_Evasion_Cheat_Sheet#Embedded_tab
    /* eslint-disable-next-line no-control-regex */ href = href.replace(/[\0- ]+/g, ""); // Clobber any comments in URLs, which the browser might
    // interpret inside an XML data island, allowing
    // a javascript: URL to be snuck through
    href = href.replace(/<!\x2D\x2D(?:[\0-\t\x0B\f\x0E-\u2027\u202A-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])*?\x2D\x2D>/g, ""); // Case insensitive so we don't get faked out by JAVASCRIPT #1
    var matches = href.match(/^([A-Za-z]+):/);
    if (!matches) // Protocol-relative URL or no scheme
    return;
    return matches[1].toLowerCase();
}
var $5717c4da46066f16$var$ALLOWED_SCHEMES = [
    "data",
    "http",
    "https",
    "ftp",
    "mailto",
    "sip",
    "tel"
];
function $5717c4da46066f16$var$createDefaultCardActionMiddleware() {
    return [
        function() {
            return function(next) {
                return function() {
                    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                    var _args$ = args[0], _args$$cardAction = _args$.cardAction, type = _args$$cardAction.type, value = _args$$cardAction.value, getSignInUrl = _args$.getSignInUrl;
                    switch(type){
                        case "call":
                        case "downloadFile":
                        case "openUrl":
                        case "playAudio":
                        case "playVideo":
                        case "showImage":
                            if ($5717c4da46066f16$var$ALLOWED_SCHEMES.includes($5717c4da46066f16$var$getScheme(value))) {
                                if ($gLt36.ie11) {
                                    var newWindow = window.open();
                                    newWindow.opener = null;
                                    newWindow.location = value;
                                } else window.open(value, "_blank", "noopener noreferrer");
                            } else console.warn("botframework-webchat: Cannot open URL with disallowed schemes.", value);
                            break;
                        case "signin":
                            /**
               * @todo TODO: [P3] We should prime the URL into the OAuthCard directly, instead of calling getSessionId on-demand
               *       This is to eliminate the delay between window.open() and location.href call
               */ $5717c4da46066f16$var$_asyncToGenerator(/*#__PURE__*/ $5717c4da46066f16$var$_regeneratorRuntime().mark(function _callee() {
                                var popup, url;
                                return $5717c4da46066f16$var$_regeneratorRuntime().wrap(function _callee$(_context) {
                                    while(true)switch(_context.prev = _context.next){
                                        case 0:
                                            popup = window.open();
                                            _context.next = 3;
                                            return getSignInUrl();
                                        case 3:
                                            url = _context.sent;
                                            if ([
                                                "http",
                                                "https"
                                            ].includes($5717c4da46066f16$var$getScheme(url))) popup.location.href = url;
                                            else {
                                                console.warn("botframework-webchat: Cannot open URL with disallowed schemes.", url);
                                                popup.close();
                                            }
                                        case 5:
                                        case "end":
                                            return _context.stop();
                                    }
                                }, _callee);
                            }))();
                            break;
                        default:
                            return next.apply(void 0, args);
                    }
                };
            };
        }
    ];
}

});

parcelRequire.register("kVlGB", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $f3b9f3ee782599f3$var$createScrollToEndButtonMiddleware;

var $f3b9f3ee782599f3$var$_ScrollToEndButton = $f3b9f3ee782599f3$var$_interopRequireDefault((parcelRequire("dZpjb")));
function $f3b9f3ee782599f3$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $f3b9f3ee782599f3$var$createScrollToEndButtonMiddleware() {
    return [
        function() {
            return function() {
                return function(_ref) {
                    var atEnd = _ref.atEnd, scrollToEndButtonBehavior = _ref.styleOptions.scrollToEndButtonBehavior, unread = _ref.unread;
                    return !scrollToEndButtonBehavior ? false : scrollToEndButtonBehavior === "any" ? !atEnd && $f3b9f3ee782599f3$var$_ScrollToEndButton.default : !atEnd && unread && $f3b9f3ee782599f3$var$_ScrollToEndButton.default;
                };
            };
        }
    ];
}

});
parcelRequire.register("dZpjb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $hd4g0 = parcelRequire("hd4g0");

var $a2f49a9a32a8b2e8$var$_classnames = $a2f49a9a32a8b2e8$var$_interopRequireDefault((parcelRequire("5A4MD")));

var $a2f49a9a32a8b2e8$var$_propTypes = $a2f49a9a32a8b2e8$var$_interopRequireDefault((parcelRequire("f7UXb")));

var $a2f49a9a32a8b2e8$var$_react = $a2f49a9a32a8b2e8$var$_interopRequireDefault((parcelRequire("eO7Kz")));

var $a2f49a9a32a8b2e8$var$_useStyleSet3 = $a2f49a9a32a8b2e8$var$_interopRequireDefault((parcelRequire("gC6jZ")));
function $a2f49a9a32a8b2e8$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $a2f49a9a32a8b2e8$var$_slicedToArray(arr, i) {
    return $a2f49a9a32a8b2e8$var$_arrayWithHoles(arr) || $a2f49a9a32a8b2e8$var$_iterableToArrayLimit(arr, i) || $a2f49a9a32a8b2e8$var$_unsupportedIterableToArray(arr, i) || $a2f49a9a32a8b2e8$var$_nonIterableRest();
}
function $a2f49a9a32a8b2e8$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $a2f49a9a32a8b2e8$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $a2f49a9a32a8b2e8$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $a2f49a9a32a8b2e8$var$_arrayLikeToArray(o, minLen);
}
function $a2f49a9a32a8b2e8$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $a2f49a9a32a8b2e8$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $a2f49a9a32a8b2e8$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
var $a2f49a9a32a8b2e8$var$useDirection = $hd4g0.hooks.useDirection, $a2f49a9a32a8b2e8$var$useLocalizer = $hd4g0.hooks.useLocalizer, $a2f49a9a32a8b2e8$var$useStyleOptions = $hd4g0.hooks.useStyleOptions;
var $a2f49a9a32a8b2e8$var$ScrollToEndButton = function ScrollToEndButton(_ref) {
    var onClick = _ref.onClick;
    var _useStyleSet = (0, $a2f49a9a32a8b2e8$var$_useStyleSet3.default)(), _useStyleSet2 = $a2f49a9a32a8b2e8$var$_slicedToArray(_useStyleSet, 1), scrollToEndButtonStyleSet = _useStyleSet2[0].scrollToEndButton;
    var _useStyleOptions = $a2f49a9a32a8b2e8$var$useStyleOptions(), _useStyleOptions2 = $a2f49a9a32a8b2e8$var$_slicedToArray(_useStyleOptions, 1), scrollToEndButtonBehavior = _useStyleOptions2[0].scrollToEndButtonBehavior;
    var _useDirection = $a2f49a9a32a8b2e8$var$useDirection(), _useDirection2 = $a2f49a9a32a8b2e8$var$_slicedToArray(_useDirection, 1), direction = _useDirection2[0];
    var localize = $a2f49a9a32a8b2e8$var$useLocalizer();
    var text = localize(scrollToEndButtonBehavior === "any" ? "TRANSCRIPT_MORE_MESSAGES" : "TRANSCRIPT_NEW_MESSAGES");
    return /*#__PURE__*/ $a2f49a9a32a8b2e8$var$_react.default.createElement("button", {
        "aria-label": text,
        className: (0, $a2f49a9a32a8b2e8$var$_classnames.default)("webchat__scroll-to-end-button", scrollToEndButtonStyleSet + "", direction === "rtl" ? "webchat__scroll-to-end-button--rtl" : ""),
        onClick: onClick,
        tabIndex: 0,
        type: "button"
    }, text);
};
$a2f49a9a32a8b2e8$var$ScrollToEndButton.defaultProps = {
    onClick: undefined
};
$a2f49a9a32a8b2e8$var$ScrollToEndButton.displayName = "ScrollToEndButton";
$a2f49a9a32a8b2e8$var$ScrollToEndButton.propTypes = {
    onClick: $a2f49a9a32a8b2e8$var$_propTypes.default.func
};
var $a2f49a9a32a8b2e8$var$_default = $a2f49a9a32a8b2e8$var$ScrollToEndButton;
module.exports.default = $a2f49a9a32a8b2e8$var$_default;

});


parcelRequire.register("gRnWL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c4642bea97717bff$var$_createToastMiddleware = $c4642bea97717bff$var$_interopRequireDefault((parcelRequire("gyTYc")));
function $c4642bea97717bff$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $c4642bea97717bff$var$createCoreMiddleware() {
    return [
        function() {
            return function(next) {
                return function() {
                    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                    var id = args[0].notification.id; // We are ignoring "connectivitystatus" notifications, we will render it using <BasicConnectivityStatus> instead.
                    // If devs want to render it, they can add a middleware.
                    return id !== "connectivitystatus" && next.apply(void 0, args);
                };
            };
        },
        (0, $c4642bea97717bff$var$_createToastMiddleware.default)()
    ];
}
var $c4642bea97717bff$var$_default = $c4642bea97717bff$var$createCoreMiddleware;
module.exports.default = $c4642bea97717bff$var$_default;

});
parcelRequire.register("gyTYc", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c0eb3cc31679aaa1$var$_react = $c0eb3cc31679aaa1$var$_interopRequireDefault((parcelRequire("eO7Kz")));

var $c0eb3cc31679aaa1$var$_BasicToast = $c0eb3cc31679aaa1$var$_interopRequireDefault((parcelRequire("lPACj")));
function $c0eb3cc31679aaa1$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/* eslint react/prop-types: "off" */ function $c0eb3cc31679aaa1$var$createToastMiddleware() {
    return function() {
        return function() {
            return function(_ref) {
                var notification = _ref.notification;
                return /*#__PURE__*/ $c0eb3cc31679aaa1$var$_react.default.createElement($c0eb3cc31679aaa1$var$_BasicToast.default, {
                    notification: notification
                });
            };
        };
    };
}
var $c0eb3cc31679aaa1$var$_default = $c0eb3cc31679aaa1$var$createToastMiddleware;
module.exports.default = $c0eb3cc31679aaa1$var$_default;

});
parcelRequire.register("lPACj", function(module, exports) {
"use strict";
function $fe4ac3bbb38ac820$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $fe4ac3bbb38ac820$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $fe4ac3bbb38ac820$var$_typeof(obj);
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $hd4g0 = parcelRequire("hd4g0");

var $fe4ac3bbb38ac820$var$_classnames = $fe4ac3bbb38ac820$var$_interopRequireDefault((parcelRequire("5A4MD")));

var $fe4ac3bbb38ac820$var$_propTypes = $fe4ac3bbb38ac820$var$_interopRequireDefault((parcelRequire("f7UXb")));

var $fe4ac3bbb38ac820$var$_react = $fe4ac3bbb38ac820$var$_interopRequireWildcard((parcelRequire("eO7Kz")));

var $fe4ac3bbb38ac820$var$_DismissIcon = $fe4ac3bbb38ac820$var$_interopRequireDefault((parcelRequire("43vTW")));

var $fe4ac3bbb38ac820$var$_NotificationIcon = $fe4ac3bbb38ac820$var$_interopRequireDefault((parcelRequire("iOb1o")));

var $fe4ac3bbb38ac820$var$_randomId = $fe4ac3bbb38ac820$var$_interopRequireDefault((parcelRequire("gJ3hG")));

var $fe4ac3bbb38ac820$var$_ScreenReaderText = $fe4ac3bbb38ac820$var$_interopRequireDefault((parcelRequire("3NTZI")));

var $fe4ac3bbb38ac820$var$_useInternalRenderMarkdownInline = $fe4ac3bbb38ac820$var$_interopRequireDefault((parcelRequire("5XiAc")));

var $fe4ac3bbb38ac820$var$_useStyleSet3 = $fe4ac3bbb38ac820$var$_interopRequireDefault((parcelRequire("gC6jZ")));

var $fe4ac3bbb38ac820$var$_useStyleToEmotionObject = $fe4ac3bbb38ac820$var$_interopRequireDefault((parcelRequire("6l4uV")));
function $fe4ac3bbb38ac820$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($fe4ac3bbb38ac820$var$_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $fe4ac3bbb38ac820$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || $fe4ac3bbb38ac820$var$_typeof(obj) !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $fe4ac3bbb38ac820$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $fe4ac3bbb38ac820$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $fe4ac3bbb38ac820$var$_slicedToArray(arr, i) {
    return $fe4ac3bbb38ac820$var$_arrayWithHoles(arr) || $fe4ac3bbb38ac820$var$_iterableToArrayLimit(arr, i) || $fe4ac3bbb38ac820$var$_unsupportedIterableToArray(arr, i) || $fe4ac3bbb38ac820$var$_nonIterableRest();
}
function $fe4ac3bbb38ac820$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $fe4ac3bbb38ac820$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $fe4ac3bbb38ac820$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $fe4ac3bbb38ac820$var$_arrayLikeToArray(o, minLen);
}
function $fe4ac3bbb38ac820$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $fe4ac3bbb38ac820$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $fe4ac3bbb38ac820$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
var $fe4ac3bbb38ac820$var$useDismissNotification = $hd4g0.hooks.useDismissNotification, $fe4ac3bbb38ac820$var$useLocalizer = $hd4g0.hooks.useLocalizer;
var $fe4ac3bbb38ac820$var$ROOT_STYLE = {
    display: "flex",
    "& .webchat__toast__text": {
        flex: 1
    }
};
var $fe4ac3bbb38ac820$var$BasicToast = function BasicToast(_ref) {
    var _ref$notification = _ref.notification, alt = _ref$notification.alt, id = _ref$notification.id, level = _ref$notification.level, _ref$notification$mes = _ref$notification.message, message = _ref$notification$mes === void 0 ? "" : _ref$notification$mes;
    var _useStyleSet = (0, $fe4ac3bbb38ac820$var$_useStyleSet3.default)(), _useStyleSet2 = $fe4ac3bbb38ac820$var$_slicedToArray(_useStyleSet, 1), toastStyleSet = _useStyleSet2[0].toast;
    var contentId = (0, $fe4ac3bbb38ac820$var$_react.useMemo)(function() {
        return "webchat__toast__".concat((0, $fe4ac3bbb38ac820$var$_randomId.default)());
    }, []);
    var localize = $fe4ac3bbb38ac820$var$useLocalizer();
    var dismissNotification = $fe4ac3bbb38ac820$var$useDismissNotification();
    var renderMarkdownInline = (0, $fe4ac3bbb38ac820$var$_useInternalRenderMarkdownInline.default)();
    var rootClassName = (0, $fe4ac3bbb38ac820$var$_useStyleToEmotionObject.default)()($fe4ac3bbb38ac820$var$ROOT_STYLE) + "";
    var handleDismiss = (0, $fe4ac3bbb38ac820$var$_react.useCallback)(function() {
        return dismissNotification(id);
    }, [
        dismissNotification,
        id
    ]);
    var html = (0, $fe4ac3bbb38ac820$var$_react.useMemo)(function() {
        return {
            __html: renderMarkdownInline(message)
        };
    }, [
        message,
        renderMarkdownInline
    ]);
    return /*#__PURE__*/ $fe4ac3bbb38ac820$var$_react.default.createElement("div", {
        "aria-describedby": contentId,
        "aria-label": localize("TOAST_TITLE_ALT"),
        className: (0, $fe4ac3bbb38ac820$var$_classnames.default)("webchat__toast", {
            "webchat__toast--error": level === "error",
            "webchat__toast--info": level === "info",
            "webchat__toast--success": level === "success",
            "webchat__toast--warn": level === "warn"
        }, rootClassName, toastStyleSet + ""),
        role: "dialog"
    }, /*#__PURE__*/ $fe4ac3bbb38ac820$var$_react.default.createElement("div", {
        className: "webchat__toast__iconBox"
    }, /*#__PURE__*/ $fe4ac3bbb38ac820$var$_react.default.createElement($fe4ac3bbb38ac820$var$_NotificationIcon.default, {
        className: "webchat__toast__icon",
        level: level
    })), !!alt && /*#__PURE__*/ $fe4ac3bbb38ac820$var$_react.default.createElement($fe4ac3bbb38ac820$var$_ScreenReaderText.default, {
        text: alt
    }), /*#__PURE__*/ $fe4ac3bbb38ac820$var$_react.default.createElement("div", {
        "aria-hidden": !!alt,
        className: "webchat__toast__text",
        dangerouslySetInnerHTML: html,
        id: contentId
    }), /*#__PURE__*/ $fe4ac3bbb38ac820$var$_react.default.createElement("button", {
        "aria-label": localize("TOAST_DISMISS_BUTTON"),
        className: "webchat__toast__dismissButton",
        onClick: handleDismiss,
        type: "button"
    }, /*#__PURE__*/ $fe4ac3bbb38ac820$var$_react.default.createElement("div", {
        "aria-hidden": true,
        className: "webchat__toast__dismissButtonFocus"
    }, /*#__PURE__*/ $fe4ac3bbb38ac820$var$_react.default.createElement($fe4ac3bbb38ac820$var$_DismissIcon.default, null))));
};
$fe4ac3bbb38ac820$var$BasicToast.propTypes = {
    notification: $fe4ac3bbb38ac820$var$_propTypes.default.shape({
        alt: $fe4ac3bbb38ac820$var$_propTypes.default.string,
        id: $fe4ac3bbb38ac820$var$_propTypes.default.string.isRequired,
        level: $fe4ac3bbb38ac820$var$_propTypes.default.string.isRequired,
        message: $fe4ac3bbb38ac820$var$_propTypes.default.string.isRequired
    }).isRequired
};
var $fe4ac3bbb38ac820$var$_default = $fe4ac3bbb38ac820$var$BasicToast;
module.exports.default = $fe4ac3bbb38ac820$var$_default;

});
parcelRequire.register("43vTW", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2f40302c1e13e885$var$_propTypes = $2f40302c1e13e885$var$_interopRequireDefault((parcelRequire("f7UXb")));

var $2f40302c1e13e885$var$_react = $2f40302c1e13e885$var$_interopRequireDefault((parcelRequire("eO7Kz")));
function $2f40302c1e13e885$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $2f40302c1e13e885$var$DismissIcon = function DismissIcon(_ref) {
    var className = _ref.className;
    return /*#__PURE__*/ $2f40302c1e13e885$var$_react.default.createElement("svg", {
        className: (className || "") + "",
        focusable: false,
        height: "14",
        role: "presentation",
        viewBox: "0 0 14 14",
        width: "14",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ $2f40302c1e13e885$var$_react.default.createElement("path", {
        d: "M7.71094 7L13.1016 12.3984L12.3984 13.1016L7 7.71094L1.60156 13.1016L0.898438 12.3984L6.28906 7L0.898438 1.60156L1.60156 0.898438L7 6.28906L12.3984 0.898438L13.1016 1.60156L7.71094 7Z"
    }));
};
$2f40302c1e13e885$var$DismissIcon.defaultProps = {
    className: undefined
};
$2f40302c1e13e885$var$DismissIcon.propTypes = {
    className: $2f40302c1e13e885$var$_propTypes.default.string
};
var $2f40302c1e13e885$var$_default = $2f40302c1e13e885$var$DismissIcon;
module.exports.default = $2f40302c1e13e885$var$_default;

});

parcelRequire.register("5XiAc", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4560e099c3512e42$var$_useWebChatUIContext2 = $4560e099c3512e42$var$_interopRequireDefault((parcelRequire("tHuBR")));
function $4560e099c3512e42$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $4560e099c3512e42$var$useInternalRenderMarkdownInline() {
    var _useWebChatUIContext = (0, $4560e099c3512e42$var$_useWebChatUIContext2.default)(), internalRenderMarkdownInline = _useWebChatUIContext.internalRenderMarkdownInline;
    return internalRenderMarkdownInline;
}
var $4560e099c3512e42$var$_default = $4560e099c3512e42$var$useInternalRenderMarkdownInline;
module.exports.default = $4560e099c3512e42$var$_default;

});




parcelRequire.register("gc9Ic", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $bca54ce39533dc93$var$createCoreMiddleware;

var $hd4g0 = parcelRequire("hd4g0");

var $bca54ce39533dc93$var$_classnames = $bca54ce39533dc93$var$_interopRequireDefault((parcelRequire("5A4MD")));

var $bca54ce39533dc93$var$_react = $bca54ce39533dc93$var$_interopRequireDefault((parcelRequire("eO7Kz")));

var $bca54ce39533dc93$var$_TypingAnimation = $bca54ce39533dc93$var$_interopRequireDefault((parcelRequire("6ZfWA")));

var $bca54ce39533dc93$var$_useStyleSet3 = $bca54ce39533dc93$var$_interopRequireDefault((parcelRequire("gC6jZ")));
function $bca54ce39533dc93$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $bca54ce39533dc93$var$_slicedToArray(arr, i) {
    return $bca54ce39533dc93$var$_arrayWithHoles(arr) || $bca54ce39533dc93$var$_iterableToArrayLimit(arr, i) || $bca54ce39533dc93$var$_unsupportedIterableToArray(arr, i) || $bca54ce39533dc93$var$_nonIterableRest();
}
function $bca54ce39533dc93$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $bca54ce39533dc93$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $bca54ce39533dc93$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $bca54ce39533dc93$var$_arrayLikeToArray(o, minLen);
}
function $bca54ce39533dc93$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $bca54ce39533dc93$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $bca54ce39533dc93$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
var $bca54ce39533dc93$var$useDirection = $hd4g0.hooks.useDirection, $bca54ce39533dc93$var$useLocalizer = $hd4g0.hooks.useLocalizer;
var $bca54ce39533dc93$var$DotIndicator = function DotIndicator() {
    var _useStyleSet = (0, $bca54ce39533dc93$var$_useStyleSet3.default)(), _useStyleSet2 = $bca54ce39533dc93$var$_slicedToArray(_useStyleSet, 1), typingIndicatorStyleSet = _useStyleSet2[0].typingIndicator;
    var _useDirection = $bca54ce39533dc93$var$useDirection(), _useDirection2 = $bca54ce39533dc93$var$_slicedToArray(_useDirection, 1), direction = _useDirection2[0];
    var localize = $bca54ce39533dc93$var$useLocalizer();
    return /*#__PURE__*/ $bca54ce39533dc93$var$_react.default.createElement("div", {
        className: (0, $bca54ce39533dc93$var$_classnames.default)(typingIndicatorStyleSet + "", direction === "rtl" && "webchat__typingIndicator--rtl")
    }, /*#__PURE__*/ $bca54ce39533dc93$var$_react.default.createElement($bca54ce39533dc93$var$_TypingAnimation.default, {
        "aria-label": localize("TYPING_INDICATOR_ALT")
    }));
}; // TODO: [P4] Rename this file or the whole middleware, it looks either too simple or too comprehensive now
function $bca54ce39533dc93$var$createCoreMiddleware() {
    return [
        function() {
            return function() {
                return(// eslint-disable-next-line react/prop-types
                function(_ref) {
                    var visible = _ref.visible;
                    return visible && /*#__PURE__*/ $bca54ce39533dc93$var$_react.default.createElement($bca54ce39533dc93$var$DotIndicator, null);
                });
            };
        }
    ];
}

});
parcelRequire.register("6ZfWA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $hd4g0 = parcelRequire("hd4g0");

var $5164cebd24e5e4d8$var$_classnames = $5164cebd24e5e4d8$var$_interopRequireDefault((parcelRequire("5A4MD")));

var $5164cebd24e5e4d8$var$_react = $5164cebd24e5e4d8$var$_interopRequireDefault((parcelRequire("eO7Kz")));

var $5164cebd24e5e4d8$var$_ScreenReaderText = $5164cebd24e5e4d8$var$_interopRequireDefault((parcelRequire("3NTZI")));

var $5164cebd24e5e4d8$var$_useStyleSet3 = $5164cebd24e5e4d8$var$_interopRequireDefault((parcelRequire("gC6jZ")));

var $5164cebd24e5e4d8$var$_useStyleToEmotionObject = $5164cebd24e5e4d8$var$_interopRequireDefault((parcelRequire("6l4uV")));
function $5164cebd24e5e4d8$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $5164cebd24e5e4d8$var$_slicedToArray(arr, i) {
    return $5164cebd24e5e4d8$var$_arrayWithHoles(arr) || $5164cebd24e5e4d8$var$_iterableToArrayLimit(arr, i) || $5164cebd24e5e4d8$var$_unsupportedIterableToArray(arr, i) || $5164cebd24e5e4d8$var$_nonIterableRest();
}
function $5164cebd24e5e4d8$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $5164cebd24e5e4d8$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $5164cebd24e5e4d8$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $5164cebd24e5e4d8$var$_arrayLikeToArray(o, minLen);
}
function $5164cebd24e5e4d8$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $5164cebd24e5e4d8$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $5164cebd24e5e4d8$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
var $5164cebd24e5e4d8$var$useDirection = $hd4g0.hooks.useDirection, $5164cebd24e5e4d8$var$useLocalizer = $hd4g0.hooks.useLocalizer;
var $5164cebd24e5e4d8$var$ROOT_STYLE = {
    "&.webchat__typingIndicator.webchat__typingIndicator--rtl": {
        transform: "scale(-1, 1)"
    }
};
var $5164cebd24e5e4d8$var$TypingAnimation = function TypingAnimation() {
    var _useStyleSet = (0, $5164cebd24e5e4d8$var$_useStyleSet3.default)(), _useStyleSet2 = $5164cebd24e5e4d8$var$_slicedToArray(_useStyleSet, 1), typingAnimationStyleSet = _useStyleSet2[0].typingAnimation;
    var _useDirection = $5164cebd24e5e4d8$var$useDirection(), _useDirection2 = $5164cebd24e5e4d8$var$_slicedToArray(_useDirection, 1), direction = _useDirection2[0];
    var localize = $5164cebd24e5e4d8$var$useLocalizer();
    var rootClassName = (0, $5164cebd24e5e4d8$var$_useStyleToEmotionObject.default)()($5164cebd24e5e4d8$var$ROOT_STYLE) + "";
    return /*#__PURE__*/ $5164cebd24e5e4d8$var$_react.default.createElement($5164cebd24e5e4d8$var$_react.default.Fragment, null, /*#__PURE__*/ $5164cebd24e5e4d8$var$_react.default.createElement($5164cebd24e5e4d8$var$_ScreenReaderText.default, {
        text: localize("TYPING_INDICATOR_ALT")
    }), /*#__PURE__*/ $5164cebd24e5e4d8$var$_react.default.createElement("div", {
        "aria-hidden": true,
        className: (0, $5164cebd24e5e4d8$var$_classnames.default)("webchat__typingIndicator", {
            "webchat__typingIndicator--rtl": direction === "rtl"
        }, rootClassName, typingAnimationStyleSet + "")
    }));
};
var $5164cebd24e5e4d8$var$_default = $5164cebd24e5e4d8$var$TypingAnimation;
module.exports.default = $5164cebd24e5e4d8$var$_default;

});


parcelRequire.register("iRqQu", function(module, exports) {
"use strict";
function $dbb20037249fb1d0$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $dbb20037249fb1d0$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $dbb20037249fb1d0$var$_typeof(obj);
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
parcelRequire("likmj");
var $bE7qD = parcelRequire("bE7qD");

var $cG9B9 = parcelRequire("cG9B9");

var $hd4g0 = parcelRequire("hd4g0");

var $dbb20037249fb1d0$var$_propTypes = $dbb20037249fb1d0$var$_interopRequireDefault((parcelRequire("f7UXb")));

var $dbb20037249fb1d0$var$_react = $dbb20037249fb1d0$var$_interopRequireWildcard((parcelRequire("eO7Kz")));

var $dbb20037249fb1d0$var$_useResumeAudioContext = $dbb20037249fb1d0$var$_interopRequireDefault((parcelRequire("1Yrug")));

var $dbb20037249fb1d0$var$_useSettableDictateAbortable = $dbb20037249fb1d0$var$_interopRequireDefault((parcelRequire("7VcQr")));

var $dbb20037249fb1d0$var$_useWebSpeechPonyfill4 = $dbb20037249fb1d0$var$_interopRequireDefault((parcelRequire("dCR9j")));

var $dbb20037249fb1d0$var$_useSetDictateState = $dbb20037249fb1d0$var$_interopRequireDefault((parcelRequire("4t2Le")));
function $dbb20037249fb1d0$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($dbb20037249fb1d0$var$_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $dbb20037249fb1d0$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || $dbb20037249fb1d0$var$_typeof(obj) !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $dbb20037249fb1d0$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $dbb20037249fb1d0$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $dbb20037249fb1d0$var$_slicedToArray(arr, i) {
    return $dbb20037249fb1d0$var$_arrayWithHoles(arr) || $dbb20037249fb1d0$var$_iterableToArrayLimit(arr, i) || $dbb20037249fb1d0$var$_unsupportedIterableToArray(arr, i) || $dbb20037249fb1d0$var$_nonIterableRest();
}
function $dbb20037249fb1d0$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $dbb20037249fb1d0$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $dbb20037249fb1d0$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $dbb20037249fb1d0$var$_arrayLikeToArray(o, minLen);
}
function $dbb20037249fb1d0$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $dbb20037249fb1d0$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $dbb20037249fb1d0$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
var $dbb20037249fb1d0$var$useActivities = $hd4g0.hooks.useActivities, $dbb20037249fb1d0$var$useDictateInterims = $hd4g0.hooks.useDictateInterims, $dbb20037249fb1d0$var$useDictateState = $hd4g0.hooks.useDictateState, $dbb20037249fb1d0$var$useDisabled = $hd4g0.hooks.useDisabled, $dbb20037249fb1d0$var$useEmitTypingIndicator = $hd4g0.hooks.useEmitTypingIndicator, $dbb20037249fb1d0$var$useLanguage = $hd4g0.hooks.useLanguage, $dbb20037249fb1d0$var$useSendBoxValue = $hd4g0.hooks.useSendBoxValue, $dbb20037249fb1d0$var$useSendTypingIndicator = $hd4g0.hooks.useSendTypingIndicator, $dbb20037249fb1d0$var$useShouldSpeakIncomingActivity = $hd4g0.hooks.useShouldSpeakIncomingActivity, $dbb20037249fb1d0$var$useStopDictate = $hd4g0.hooks.useStopDictate, $dbb20037249fb1d0$var$useSubmitSendBox = $hd4g0.hooks.useSubmitSendBox;
var $dbb20037249fb1d0$var$_Constants$DictateSta = $cG9B9.Constants.DictateState, $dbb20037249fb1d0$var$DICTATING = $dbb20037249fb1d0$var$_Constants$DictateSta.DICTATING, $dbb20037249fb1d0$var$IDLE = $dbb20037249fb1d0$var$_Constants$DictateSta.IDLE, $dbb20037249fb1d0$var$STARTING = $dbb20037249fb1d0$var$_Constants$DictateSta.STARTING;
var $dbb20037249fb1d0$var$Dictation = function Dictation(_ref) {
    var onError = _ref.onError;
    var _useSettableDictateAb = (0, $dbb20037249fb1d0$var$_useSettableDictateAbortable.default)(), _useSettableDictateAb2 = $dbb20037249fb1d0$var$_slicedToArray(_useSettableDictateAb, 2), setDictateAbortable = _useSettableDictateAb2[1];
    var _useDictateInterims = $dbb20037249fb1d0$var$useDictateInterims(), _useDictateInterims2 = $dbb20037249fb1d0$var$_slicedToArray(_useDictateInterims, 2), setDictateInterims = _useDictateInterims2[1];
    var _useSendBoxValue = $dbb20037249fb1d0$var$useSendBoxValue(), _useSendBoxValue2 = $dbb20037249fb1d0$var$_slicedToArray(_useSendBoxValue, 2), setSendBox = _useSendBoxValue2[1];
    var _useShouldSpeakIncomi = $dbb20037249fb1d0$var$useShouldSpeakIncomingActivity(), _useShouldSpeakIncomi2 = $dbb20037249fb1d0$var$_slicedToArray(_useShouldSpeakIncomi, 2), setShouldSpeakIncomingActivity = _useShouldSpeakIncomi2[1];
    var _useWebSpeechPonyfill = (0, $dbb20037249fb1d0$var$_useWebSpeechPonyfill4.default)(), _useWebSpeechPonyfill2 = $dbb20037249fb1d0$var$_slicedToArray(_useWebSpeechPonyfill, 1), _useWebSpeechPonyfill3 = _useWebSpeechPonyfill2[0];
    _useWebSpeechPonyfill3 = _useWebSpeechPonyfill3 === void 0 ? {} : _useWebSpeechPonyfill3;
    var SpeechGrammarList = _useWebSpeechPonyfill3.SpeechGrammarList, SpeechRecognition = _useWebSpeechPonyfill3.SpeechRecognition;
    var _useActivities = $dbb20037249fb1d0$var$useActivities(), _useActivities2 = $dbb20037249fb1d0$var$_slicedToArray(_useActivities, 1), activities = _useActivities2[0];
    var _useDictateState = $dbb20037249fb1d0$var$useDictateState(), _useDictateState2 = $dbb20037249fb1d0$var$_slicedToArray(_useDictateState, 1), dictateState = _useDictateState2[0];
    var _useDisabled = $dbb20037249fb1d0$var$useDisabled(), _useDisabled2 = $dbb20037249fb1d0$var$_slicedToArray(_useDisabled, 1), disabled = _useDisabled2[0];
    var _useSendTypingIndicat = $dbb20037249fb1d0$var$useSendTypingIndicator(), _useSendTypingIndicat2 = $dbb20037249fb1d0$var$_slicedToArray(_useSendTypingIndicat, 1), sendTypingIndicator = _useSendTypingIndicat2[0];
    var _useLanguage = $dbb20037249fb1d0$var$useLanguage("speech"), _useLanguage2 = $dbb20037249fb1d0$var$_slicedToArray(_useLanguage, 1), speechLanguage = _useLanguage2[0];
    var emitTypingIndicator = $dbb20037249fb1d0$var$useEmitTypingIndicator();
    var resumeAudioContext = (0, $dbb20037249fb1d0$var$_useResumeAudioContext.default)();
    var setDictateState = (0, $dbb20037249fb1d0$var$_useSetDictateState.default)();
    var stopDictate = $dbb20037249fb1d0$var$useStopDictate();
    var submitSendBox = $dbb20037249fb1d0$var$useSubmitSendBox();
    var numSpeakingActivities = (0, $dbb20037249fb1d0$var$_react.useMemo)(function() {
        return activities.filter(function(_ref2) {
            var _ref2$channelData = _ref2.channelData;
            _ref2$channelData = _ref2$channelData === void 0 ? {} : _ref2$channelData;
            var speak = _ref2$channelData.speak;
            return speak;
        }).length;
    }, [
        activities
    ]);
    var handleDictate = (0, $dbb20037249fb1d0$var$_react.useCallback)(function(_ref3) {
        var _ref3$result = _ref3.result;
        _ref3$result = _ref3$result === void 0 ? {} : _ref3$result;
        var confidence = _ref3$result.confidence, transcript = _ref3$result.transcript;
        if (dictateState === $dbb20037249fb1d0$var$DICTATING || dictateState === $dbb20037249fb1d0$var$STARTING) {
            setDictateInterims([]);
            setDictateState($dbb20037249fb1d0$var$IDLE);
            stopDictate();
            if (transcript) {
                setSendBox(transcript);
                submitSendBox("speech", {
                    channelData: {
                        speech: {
                            alternatives: [
                                {
                                    confidence: confidence,
                                    transcript: transcript
                                }
                            ]
                        }
                    }
                });
                setShouldSpeakIncomingActivity(true);
            }
        }
    }, [
        dictateState,
        setDictateInterims,
        setDictateState,
        stopDictate,
        setSendBox,
        submitSendBox,
        setShouldSpeakIncomingActivity
    ]);
    var handleDictating = (0, $dbb20037249fb1d0$var$_react.useCallback)(function(_ref4) {
        var abortable = _ref4.abortable, _ref4$results = _ref4.results, results = _ref4$results === void 0 ? [] : _ref4$results;
        if (dictateState === $dbb20037249fb1d0$var$DICTATING || dictateState === $dbb20037249fb1d0$var$STARTING) {
            var interims = results.map(function(_ref5) {
                var transcript = _ref5.transcript;
                return transcript;
            });
            setDictateAbortable(abortable);
            setDictateInterims(interims);
            setDictateState($dbb20037249fb1d0$var$DICTATING);
            sendTypingIndicator && emitTypingIndicator();
        }
    }, [
        dictateState,
        emitTypingIndicator,
        sendTypingIndicator,
        setDictateAbortable,
        setDictateInterims,
        setDictateState
    ]);
    var handleError = (0, $dbb20037249fb1d0$var$_react.useCallback)(function(event) {
        dictateState !== $dbb20037249fb1d0$var$IDLE && setDictateState($dbb20037249fb1d0$var$IDLE);
        (dictateState === $dbb20037249fb1d0$var$DICTATING || dictateState === $dbb20037249fb1d0$var$STARTING) && stopDictate();
        onError && onError(event);
    }, [
        dictateState,
        onError,
        setDictateState,
        stopDictate
    ]);
    (0, $dbb20037249fb1d0$var$_react.useEffect)(function() {
        window.addEventListener("pointerdown", resumeAudioContext);
        return function() {
            return window.removeEventListener("pointerdown", resumeAudioContext);
        };
    }, [
        resumeAudioContext
    ]);
    return /*#__PURE__*/ $dbb20037249fb1d0$var$_react.default.createElement($bE7qD.default, {
        lang: speechLanguage,
        onDictate: handleDictate,
        onError: handleError,
        onProgress: handleDictating,
        speechGrammarList: SpeechGrammarList,
        speechRecognition: SpeechRecognition,
        started: !disabled && (dictateState === $dbb20037249fb1d0$var$STARTING || dictateState === $dbb20037249fb1d0$var$DICTATING) && !numSpeakingActivities
    });
};
$dbb20037249fb1d0$var$Dictation.defaultProps = {
    onError: undefined
};
$dbb20037249fb1d0$var$Dictation.propTypes = {
    onError: $dbb20037249fb1d0$var$_propTypes.default.func
};
var $dbb20037249fb1d0$var$_default = $dbb20037249fb1d0$var$Dictation;
module.exports.default = $dbb20037249fb1d0$var$_default;

});
parcelRequire.register("likmj", function(module, exports) {

$parcel$export(module.exports, "Composer", () => (parcelRequire("bE7qD")).default);

var $bE7qD = parcelRequire("bE7qD");

var $gxUqE = parcelRequire("gxUqE");

var $k6xtA = parcelRequire("k6xtA");

var $3lDbY = parcelRequire("3lDbY");

var $k27ak = parcelRequire("k27ak");

var $59WfU = parcelRequire("59WfU");

var $96Hy7 = parcelRequire("96Hy7");
var $f80b12422e90c6ac$export$2e2bcd8739ae039 = (0, $k6xtA.default);

});
parcelRequire.register("bE7qD", function(module, exports) {

$parcel$export(module.exports, "default", () => $87a9314d38ffabc8$export$2e2bcd8739ae039);

var $7SyKb = parcelRequire("7SyKb");

var $1Gk4M = parcelRequire("1Gk4M");

var $8JIAF = parcelRequire("8JIAF");

var $eAGiP = parcelRequire("eAGiP");

var $iYCfe = parcelRequire("iYCfe");

var $eO7Kz = parcelRequire("eO7Kz");

var $gxUqE = parcelRequire("gxUqE");

var $8dRCW = parcelRequire("8dRCW");

var $kzMsn = parcelRequire("kzMsn");

var $4XMXB = parcelRequire("4XMXB");
function $87a9314d38ffabc8$var$applyAll() {
    for(var _len = arguments.length, fns = new Array(_len), _key = 0; _key < _len; _key++)fns[_key] = arguments[_key];
    return function() {
        var _arguments = arguments, _this = this;
        // eslint-disable-next-line no-invalid-this, prefer-rest-params
        (0, (/*@__PURE__*/$parcel$interopDefault($1Gk4M)))(fns).call(fns, function(fn) {
            return fn.apply(_this, _arguments);
        });
    };
}
function $87a9314d38ffabc8$var$recognitionAbortable(recognition) {
    return !!(recognition && typeof recognition.abort === "function");
}
var $87a9314d38ffabc8$var$Composer = function Composer(_ref) {
    var children = _ref.children, extra = _ref.extra, grammar = _ref.grammar, lang = _ref.lang, onDictate = _ref.onDictate, onError = _ref.onError, onProgress = _ref.onProgress, onRawEvent = _ref.onRawEvent, speechGrammarList = _ref.speechGrammarList, speechRecognition = _ref.speechRecognition, started = _ref.started;
    var _useState = (0, $eO7Kz.useState)(0), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($7SyKb)))(_useState, 2), readyState = _useState2[0], setReadyState = _useState2[1];
    var emitDictateOnEndRef = (0, $eO7Kz.useRef)(false);
    var extraRef = (0, $kzMsn.default)(extra);
    var grammarRef = (0, $kzMsn.default)(grammar);
    var langRef = (0, $kzMsn.default)(lang);
    var notAllowedRef = (0, $eO7Kz.useRef)(false);
    var onDictateRef = (0, $kzMsn.default)(onDictate);
    var onErrorRef = (0, $kzMsn.default)(onError);
    var onProgressRef = (0, $kzMsn.default)(onProgress);
    var onRawEventRef = (0, $kzMsn.default)(onRawEvent);
    var prevSpeechRecognition = (0, $8dRCW.default)(speechRecognition);
    var recognitionRef = (0, $eO7Kz.useRef)();
    var speechGrammarListRef = (0, $kzMsn.default)(speechGrammarList);
    var speechRecognitionRef = (0, $kzMsn.default)(speechRecognition); // If "speechRecognition" ponyfill changed, reset the "notAllowed" flag.
    if (prevSpeechRecognition !== speechRecognition) notAllowedRef.current = false;
    var handleAudioEnd = (0, $eO7Kz.useCallback)(function(_ref2) {
        var target = _ref2.target;
        return target === recognitionRef.current && setReadyState(3);
    }, [
        recognitionRef,
        setReadyState
    ]);
    var handleAudioStart = (0, $eO7Kz.useCallback)(function(_ref3) {
        var target = _ref3.target;
        if (target !== recognitionRef.current) return;
        setReadyState(2); // Web Speech API does not emit "result" when nothing is heard, and Chrome does not emit "nomatch" event.
        // Because we emitted onProgress, we should emit "dictate" if not error, so they works in pair.
        emitDictateOnEndRef.current = true;
        onProgressRef.current && onProgressRef.current({
            abortable: $87a9314d38ffabc8$var$recognitionAbortable(target),
            type: "progress"
        });
    }, [
        emitDictateOnEndRef,
        onProgressRef,
        recognitionRef,
        setReadyState
    ]);
    var handleEnd = (0, $eO7Kz.useCallback)(function(_ref4) {
        var target = _ref4.target;
        if (target !== recognitionRef.current) return;
        recognitionRef.current = undefined;
        setReadyState(0);
        if (emitDictateOnEndRef.current) {
            onDictateRef.current && onDictateRef.current({
                type: "dictate"
            });
            emitDictateOnEndRef.current = false;
        }
    }, [
        emitDictateOnEndRef,
        onDictateRef,
        recognitionRef,
        setReadyState
    ]);
    var handleError = (0, $eO7Kz.useCallback)(function(event) {
        if (event.target !== recognitionRef.current) return;
         // Error out, no need to emit "dictate"
        emitDictateOnEndRef.current = false;
        recognitionRef.current = undefined;
        if (event.error === "not-allowed") notAllowedRef.current = true;
        setReadyState(0);
        onErrorRef.current && onErrorRef.current(event);
    }, [
        emitDictateOnEndRef,
        onErrorRef,
        notAllowedRef,
        recognitionRef,
        setReadyState
    ]);
    var handleRawEvent = (0, $eO7Kz.useCallback)(function(event) {
        if (event.target !== recognitionRef.current) return;
        onRawEventRef.current && onRawEventRef.current(event);
    }, [
        onRawEventRef,
        recognitionRef
    ]);
    var handleResult = (0, $eO7Kz.useCallback)(function(_ref5) {
        var rawResults = _ref5.results, target = _ref5.target;
        if (target !== recognitionRef.current) return;
        if (rawResults.length) {
            var results = (0, (/*@__PURE__*/$parcel$interopDefault($8JIAF)))([]).call(rawResults, function(alts) {
                // Destructuring breaks Angular due to a bug in Zone.js.
                // eslint-disable-next-line prefer-destructuring
                var firstAlt = alts[0];
                return {
                    confidence: firstAlt.confidence,
                    transcript: firstAlt.transcript
                };
            }); // Destructuring breaks Angular due to a bug in Zone.js.
            // eslint-disable-next-line prefer-destructuring
            var first = rawResults[0];
            if (first.isFinal) {
                // After "onDictate" callback, the caller should be able to set "started" to false on an unabortable recognition.
                // TODO: Add test for fortification.
                recognitionRef.current = undefined;
                setReadyState(0);
                onDictateRef.current && onDictateRef.current({
                    result: results[0],
                    type: "dictate"
                });
            } else onProgressRef.current && onProgressRef.current({
                abortable: $87a9314d38ffabc8$var$recognitionAbortable(target),
                results: results,
                type: "progress"
            });
        }
    }, [
        onDictateRef,
        onProgressRef,
        recognitionRef,
        setReadyState
    ]);
    var handleStart = (0, $eO7Kz.useCallback)(function(_ref6) {
        var target = _ref6.target;
        return target === recognitionRef.current && setReadyState(1);
    }, [
        recognitionRef,
        setReadyState
    ]);
    (0, $eO7Kz.useEffect)(function() {
        if (started) {
            var _context;
            if (!speechRecognitionRef.current || notAllowedRef.current) throw new Error("Speech recognition is not supported");
            var grammars = speechGrammarListRef.current && grammarRef.current && new speechGrammarListRef.current();
            var recognition = recognitionRef.current = new speechRecognitionRef.current();
            if (grammars) {
                grammars.addFromString(grammarRef.current, 1);
                recognition.grammars = grammars;
            }
            recognition.lang = langRef.current;
            recognition.interimResults = true;
            recognition.onaudioend = $87a9314d38ffabc8$var$applyAll(handleAudioEnd, handleRawEvent);
            recognition.onaudiostart = $87a9314d38ffabc8$var$applyAll(handleAudioStart, handleRawEvent);
            recognition.onend = $87a9314d38ffabc8$var$applyAll(handleEnd, handleRawEvent);
            recognition.onerror = $87a9314d38ffabc8$var$applyAll(handleError, handleRawEvent);
            recognition.onnomatch = handleRawEvent;
            recognition.onresult = $87a9314d38ffabc8$var$applyAll(handleResult, handleRawEvent);
            recognition.onsoundend = handleRawEvent;
            recognition.onsoundstart = handleRawEvent;
            recognition.onspeechend = handleRawEvent;
            recognition.onspeechstart = handleRawEvent;
            recognition.onstart = $87a9314d38ffabc8$var$applyAll(handleStart, handleRawEvent);
            var _extra = extraRef.current;
            _extra && (0, (/*@__PURE__*/$parcel$interopDefault($1Gk4M)))(_context = (0, (/*@__PURE__*/$parcel$interopDefault($eAGiP)))(_extra)).call(_context, function(_ref7) {
                var _ref8 = (0, (/*@__PURE__*/$parcel$interopDefault($7SyKb)))(_ref7, 2), key = _ref8[0], value = _ref8[1];
                if (key !== "constructor" && key !== "prototype" && key !== "__proto__") recognition[key] = value;
            });
            recognition.start();
        }
        return function() {
            var recognition = recognitionRef.current;
            if (recognition) {
                if ($87a9314d38ffabc8$var$recognitionAbortable(recognition)) recognition.abort();
                else throw new Error("Failed to stop recognition while the current one is ongoing and is not abortable.");
            }
        };
    }, [
        extraRef,
        grammarRef,
        handleAudioEnd,
        handleAudioStart,
        handleEnd,
        handleError,
        handleRawEvent,
        handleResult,
        handleStart,
        langRef,
        notAllowedRef,
        recognitionRef,
        speechGrammarListRef,
        speechRecognitionRef,
        started
    ]);
    var abortable = $87a9314d38ffabc8$var$recognitionAbortable(recognitionRef.current) && readyState === 2;
    var supported = !!speechRecognition && !notAllowedRef.current;
    var context = (0, $eO7Kz.useMemo)(function() {
        return {
            abortable: abortable,
            readyState: readyState,
            supported: supported
        };
    }, [
        abortable,
        readyState,
        supported
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eO7Kz))).createElement((0, $gxUqE.default).Provider, {
        value: context
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eO7Kz))).createElement((0, $gxUqE.default).Consumer, null, function(context) {
        return typeof children === "function" ? children(context) : children;
    }));
};
$87a9314d38ffabc8$var$Composer.defaultProps = {
    children: undefined,
    extra: undefined,
    grammar: undefined,
    lang: undefined,
    onDictate: undefined,
    onError: undefined,
    onProgress: undefined,
    onRawEvent: undefined,
    speechGrammarList: navigator.mediaDevices && navigator.mediaDevices.getUserMedia && (0, $4XMXB.default)("SpeechGrammarList"),
    speechRecognition: navigator.mediaDevices && navigator.mediaDevices.getUserMedia && (0, $4XMXB.default)("SpeechRecognition"),
    started: undefined
};
$87a9314d38ffabc8$var$Composer.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($iYCfe))).any,
    extra: (0, (/*@__PURE__*/$parcel$interopDefault($iYCfe))).any,
    grammar: (0, (/*@__PURE__*/$parcel$interopDefault($iYCfe))).string,
    lang: (0, (/*@__PURE__*/$parcel$interopDefault($iYCfe))).string,
    onDictate: (0, (/*@__PURE__*/$parcel$interopDefault($iYCfe))).func,
    onError: (0, (/*@__PURE__*/$parcel$interopDefault($iYCfe))).func,
    onProgress: (0, (/*@__PURE__*/$parcel$interopDefault($iYCfe))).func,
    onRawEvent: (0, (/*@__PURE__*/$parcel$interopDefault($iYCfe))).func,
    speechGrammarList: (0, (/*@__PURE__*/$parcel$interopDefault($iYCfe))).any,
    speechRecognition: (0, (/*@__PURE__*/$parcel$interopDefault($iYCfe))).any,
    started: (0, (/*@__PURE__*/$parcel$interopDefault($iYCfe))).any
};
var $87a9314d38ffabc8$export$2e2bcd8739ae039 = $87a9314d38ffabc8$var$Composer;

});
parcelRequire.register("8JIAF", function(module, exports) {

module.exports = (parcelRequire("bN2Yz"));

});

parcelRequire.register("eAGiP", function(module, exports) {

module.exports = (parcelRequire("9mJ0d"));

});

parcelRequire.register("iYCfe", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $dd0b7f305187b16a$var$ReactIs, $dd0b7f305187b16a$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
module.exports = (parcelRequire("9bVOY"))();

});
parcelRequire.register("9bVOY", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";

var $1AAen = parcelRequire("1AAen");
function $6b11fe3c8ee18501$var$emptyFunction() {}
function $6b11fe3c8ee18501$var$emptyFunctionWithReset() {}
$6b11fe3c8ee18501$var$emptyFunctionWithReset.resetWarningCache = $6b11fe3c8ee18501$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $1AAen) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = "Invariant Violation";
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $6b11fe3c8ee18501$var$emptyFunctionWithReset,
        resetWarningCache: $6b11fe3c8ee18501$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRequire.register("1AAen", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var $128541ef8f8f655a$var$ReactPropTypesSecret = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
module.exports = $128541ef8f8f655a$var$ReactPropTypesSecret;

});



parcelRequire.register("gxUqE", function(module, exports) {

$parcel$export(module.exports, "default", () => $c0bb7fff26fe2d23$export$2e2bcd8739ae039);

var $eO7Kz = parcelRequire("eO7Kz");
var $c0bb7fff26fe2d23$var$Context = /*#__PURE__*/ (0, $eO7Kz.createContext)({
    abortable: false,
    readyState: 0,
    supported: true
});
var $c0bb7fff26fe2d23$export$2e2bcd8739ae039 = $c0bb7fff26fe2d23$var$Context;

});

parcelRequire.register("8dRCW", function(module, exports) {

$parcel$export(module.exports, "default", () => $5fc922dd3cda2e59$export$2e2bcd8739ae039);

var $eO7Kz = parcelRequire("eO7Kz");
function $5fc922dd3cda2e59$export$2e2bcd8739ae039(value) {
    var ref = (0, $eO7Kz.useRef)();
    (0, $eO7Kz.useEffect)(function() {
        ref.current = value;
    });
    return ref.current;
}

});

parcelRequire.register("kzMsn", function(module, exports) {

$parcel$export(module.exports, "default", () => $efacaa03f6dce189$export$2e2bcd8739ae039);

var $eO7Kz = parcelRequire("eO7Kz");
function $efacaa03f6dce189$export$2e2bcd8739ae039(value) {
    var ref = (0, $eO7Kz.useRef)();
    ref.current = value;
    return ref;
}

});

parcelRequire.register("4XMXB", function(module, exports) {

$parcel$export(module.exports, "default", () => $39d2a69c9ea05aff$export$2e2bcd8739ae039);
function $39d2a69c9ea05aff$export$2e2bcd8739ae039(name) {
    if (typeof window !== "undefined") return typeof window[name] !== "undefined" ? window[name] : window["webkit".concat(name)];
}

});


parcelRequire.register("k6xtA", function(module, exports) {

$parcel$export(module.exports, "default", () => $ea2e55d964880097$export$2e2bcd8739ae039);

var $7SyKb = parcelRequire("7SyKb");

var $iYCfe = parcelRequire("iYCfe");

var $eO7Kz = parcelRequire("eO7Kz");

var $bE7qD = parcelRequire("bE7qD");

var $59WfU = parcelRequire("59WfU");

var $kzMsn = parcelRequire("kzMsn");

var $96Hy7 = parcelRequire("96Hy7");
var $ea2e55d964880097$var$DictateButtonCore = function DictateButtonCore(_ref) {
    var children = _ref.children, className = _ref.className, disabled = _ref.disabled, onClick = _ref.onClick;
    var _useReadyState = (0, $59WfU.default)(), _useReadyState2 = (0, (/*@__PURE__*/$parcel$interopDefault($7SyKb)))(_useReadyState, 1), readyState = _useReadyState2[0];
    var _useSupported = (0, $96Hy7.default)(), _useSupported2 = (0, (/*@__PURE__*/$parcel$interopDefault($7SyKb)))(_useSupported, 1), supported = _useSupported2[0];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eO7Kz))).createElement("button", {
        className: className,
        disabled: readyState === 1 || readyState === 3 || !supported || disabled,
        onClick: onClick,
        type: "button"
    }, typeof children === "function" ? children({
        readyState: readyState
    }) : children);
};
$ea2e55d964880097$var$DictateButtonCore.defaultProps = {
    children: undefined,
    className: undefined,
    disabled: undefined
};
$ea2e55d964880097$var$DictateButtonCore.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($iYCfe))).any,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($iYCfe))).string,
    disabled: (0, (/*@__PURE__*/$parcel$interopDefault($iYCfe))).bool,
    onClick: (0, (/*@__PURE__*/$parcel$interopDefault($iYCfe))).func.isRequired
};
var $ea2e55d964880097$var$DictateButton = function DictateButton(_ref2) {
    var children = _ref2.children, className = _ref2.className, disabled = _ref2.disabled, extra = _ref2.extra, grammar = _ref2.grammar, lang = _ref2.lang, onClick = _ref2.onClick, onDictate = _ref2.onDictate, onError = _ref2.onError, onProgress = _ref2.onProgress, onRawEvent = _ref2.onRawEvent, speechGrammarList = _ref2.speechGrammarList, speechRecognition = _ref2.speechRecognition;
    var _useState = (0, $eO7Kz.useState)(), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($7SyKb)))(_useState, 2), started = _useState2[0], setStarted = _useState2[1];
    var onClickRef = (0, $kzMsn.default)(onClick);
    var onDictateRef = (0, $kzMsn.default)(onDictate);
    var onErrorRef = (0, $kzMsn.default)(onError);
    var handleClick = (0, $eO7Kz.useCallback)(function(event) {
        onClickRef.current && onClickRef.current(event);
        !event.isDefaultPrevented() && setStarted(function(started) {
            return !started;
        });
    }, [
        onClickRef,
        setStarted
    ]);
    var handleDictate = (0, $eO7Kz.useCallback)(function(event) {
        setStarted(false);
        onDictateRef.current && onDictateRef.current(event);
    }, [
        onDictateRef,
        setStarted
    ]);
    var handleError = (0, $eO7Kz.useCallback)(function(event) {
        setStarted(false);
        onErrorRef.current && onErrorRef.current(event);
    }, [
        onErrorRef,
        setStarted
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eO7Kz))).createElement((0, $bE7qD.default), {
        extra: extra,
        grammar: grammar,
        lang: lang,
        onDictate: handleDictate,
        onError: handleError,
        onProgress: onProgress,
        onRawEvent: onRawEvent,
        speechGrammarList: speechGrammarList,
        speechRecognition: speechRecognition,
        started: started && !disabled
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eO7Kz))).createElement($ea2e55d964880097$var$DictateButtonCore, {
        className: className,
        disabled: disabled,
        onClick: handleClick
    }, children));
};
$ea2e55d964880097$var$DictateButton.defaultProps = {
    children: undefined,
    className: undefined,
    disabled: undefined,
    extra: undefined,
    grammar: undefined,
    lang: undefined,
    onClick: undefined,
    onDictate: undefined,
    onError: undefined,
    onProgress: undefined,
    onRawEvent: undefined,
    speechGrammarList: undefined,
    speechRecognition: undefined
};
$ea2e55d964880097$var$DictateButton.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($iYCfe))).any,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($iYCfe))).string,
    disabled: (0, (/*@__PURE__*/$parcel$interopDefault($iYCfe))).bool,
    extra: (0, (/*@__PURE__*/$parcel$interopDefault($iYCfe))).any,
    grammar: (0, (/*@__PURE__*/$parcel$interopDefault($iYCfe))).string,
    lang: (0, (/*@__PURE__*/$parcel$interopDefault($iYCfe))).string,
    onClick: (0, (/*@__PURE__*/$parcel$interopDefault($iYCfe))).func,
    onDictate: (0, (/*@__PURE__*/$parcel$interopDefault($iYCfe))).func,
    onError: (0, (/*@__PURE__*/$parcel$interopDefault($iYCfe))).func,
    onProgress: (0, (/*@__PURE__*/$parcel$interopDefault($iYCfe))).func,
    onRawEvent: (0, (/*@__PURE__*/$parcel$interopDefault($iYCfe))).func,
    speechGrammarList: (0, (/*@__PURE__*/$parcel$interopDefault($iYCfe))).any,
    speechRecognition: (0, (/*@__PURE__*/$parcel$interopDefault($iYCfe))).any
};
var $ea2e55d964880097$export$2e2bcd8739ae039 = $ea2e55d964880097$var$DictateButton;

});
parcelRequire.register("59WfU", function(module, exports) {

$parcel$export(module.exports, "default", () => $3c1afb619542efa9$export$2e2bcd8739ae039);

var $I8mWF = parcelRequire("I8mWF");
function $3c1afb619542efa9$export$2e2bcd8739ae039() {
    var _useDictateContext = (0, $I8mWF.default)(), readyState = _useDictateContext.readyState;
    return [
        readyState
    ];
}

});
parcelRequire.register("I8mWF", function(module, exports) {

$parcel$export(module.exports, "default", () => $084a9a19eab9e445$export$2e2bcd8739ae039);

var $eO7Kz = parcelRequire("eO7Kz");

var $gxUqE = parcelRequire("gxUqE");
function $084a9a19eab9e445$export$2e2bcd8739ae039() {
    return (0, $eO7Kz.useContext)((0, $gxUqE.default));
}

});


parcelRequire.register("96Hy7", function(module, exports) {

$parcel$export(module.exports, "default", () => $6a16749469f43762$export$2e2bcd8739ae039);

var $I8mWF = parcelRequire("I8mWF");
function $6a16749469f43762$export$2e2bcd8739ae039() {
    var _useDictateContext = (0, $I8mWF.default)(), supported = _useDictateContext.supported;
    return [
        supported
    ];
}

});


parcelRequire.register("3lDbY", function(module, exports) {

var $7SyKb = parcelRequire("7SyKb");

var $iYCfe = parcelRequire("iYCfe");

var $eO7Kz = parcelRequire("eO7Kz");

var $bE7qD = parcelRequire("bE7qD");

var $59WfU = parcelRequire("59WfU");

var $96Hy7 = parcelRequire("96Hy7");
var $2701bbfeee49a666$var$DictateCheckboxCore = function DictateCheckboxCore(_ref) {
    var children = _ref.children, className = _ref.className, disabled = _ref.disabled, onChange = _ref.onChange, started = _ref.started;
    var _useReadyState = (0, $59WfU.default)(), _useReadyState2 = (0, (/*@__PURE__*/$parcel$interopDefault($7SyKb)))(_useReadyState, 1), readyState = _useReadyState2[0];
    var _useSupported = (0, $96Hy7.default)(), _useSupported2 = (0, (/*@__PURE__*/$parcel$interopDefault($7SyKb)))(_useSupported, 1), supported = _useSupported2[0];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eO7Kz))).createElement("label", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eO7Kz))).createElement("input", {
        checked: started,
        className: className,
        disabled: readyState === 1 || readyState === 3 || !supported || disabled,
        onChange: onChange,
        type: "checkbox"
    }), typeof children === "function" ? children({
        readyState: readyState
    }) : children);
};
$2701bbfeee49a666$var$DictateCheckboxCore.defaultProps = {
    children: undefined,
    className: undefined,
    disabled: undefined
};
$2701bbfeee49a666$var$DictateCheckboxCore.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($iYCfe))).any,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($iYCfe))).string,
    disabled: (0, (/*@__PURE__*/$parcel$interopDefault($iYCfe))).bool,
    onChange: (0, (/*@__PURE__*/$parcel$interopDefault($iYCfe))).func.isRequired,
    started: (0, (/*@__PURE__*/$parcel$interopDefault($iYCfe))).bool.isRequired
};
var $2701bbfeee49a666$var$DictateCheckbox = function DictateCheckbox(_ref2) {
    var children = _ref2.children, className = _ref2.className, disabled = _ref2.disabled, extra = _ref2.extra, grammar = _ref2.grammar, lang = _ref2.lang, onDictate = _ref2.onDictate, onError = _ref2.onError, onProgress = _ref2.onProgress, onRawEvent = _ref2.onRawEvent, speechGrammarList = _ref2.speechGrammarList, speechRecognition = _ref2.speechRecognition;
    var _useState = (0, $eO7Kz.useState)(false), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($7SyKb)))(_useState, 2), started = _useState2[0], setStarted = _useState2[1];
    var handleChange = (0, $eO7Kz.useCallback)(function(_ref3) {
        var checked = _ref3.target.checked;
        setStarted(checked);
    }, [
        setStarted
    ]);
    var handleDictate = (0, $eO7Kz.useCallback)(function(event) {
        setStarted(false);
        onDictate && onDictate(event);
    }, [
        onDictate,
        setStarted
    ]);
    var handleError = (0, $eO7Kz.useCallback)(function(event) {
        setStarted(false);
        onError && onError(event);
    }, [
        onError,
        setStarted
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eO7Kz))).createElement((0, $bE7qD.default), {
        extra: extra,
        grammar: grammar,
        lang: lang,
        onDictate: handleDictate,
        onError: handleError,
        onProgress: onProgress,
        onRawEvent: onRawEvent,
        speechGrammarList: speechGrammarList,
        speechRecognition: speechRecognition,
        started: started && !disabled
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eO7Kz))).createElement($2701bbfeee49a666$var$DictateCheckboxCore, {
        className: className,
        disabled: disabled,
        onChange: handleChange,
        started: started
    }, children));
};
$2701bbfeee49a666$var$DictateCheckbox.defaultProps = {
    children: undefined,
    className: undefined,
    disabled: undefined,
    extra: undefined,
    grammar: undefined,
    lang: undefined,
    onDictate: undefined,
    onError: undefined,
    onProgress: undefined,
    onRawEvent: undefined,
    speechGrammarList: undefined,
    speechRecognition: undefined
};
$2701bbfeee49a666$var$DictateCheckbox.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($iYCfe))).any,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($iYCfe))).string,
    disabled: (0, (/*@__PURE__*/$parcel$interopDefault($iYCfe))).bool,
    extra: (0, (/*@__PURE__*/$parcel$interopDefault($iYCfe))).any,
    grammar: (0, (/*@__PURE__*/$parcel$interopDefault($iYCfe))).string,
    lang: (0, (/*@__PURE__*/$parcel$interopDefault($iYCfe))).string,
    onDictate: (0, (/*@__PURE__*/$parcel$interopDefault($iYCfe))).func,
    onError: (0, (/*@__PURE__*/$parcel$interopDefault($iYCfe))).func,
    onProgress: (0, (/*@__PURE__*/$parcel$interopDefault($iYCfe))).func,
    onRawEvent: (0, (/*@__PURE__*/$parcel$interopDefault($iYCfe))).func,
    speechGrammarList: (0, (/*@__PURE__*/$parcel$interopDefault($iYCfe))).any,
    speechRecognition: (0, (/*@__PURE__*/$parcel$interopDefault($iYCfe))).any
};
var $2701bbfeee49a666$export$2e2bcd8739ae039 = $2701bbfeee49a666$var$DictateCheckbox;

});

parcelRequire.register("k27ak", function(module, exports) {

var $I8mWF = parcelRequire("I8mWF");
function $e9598d78c2493c5a$export$2e2bcd8739ae039() {
    var _useDictateContext = (0, $I8mWF.default)(), abortable = _useDictateContext.abortable;
    return [
        abortable
    ];
}

});


parcelRequire.register("1Yrug", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $1700b769f921deaf$var$useResumeAudioContext;

var $1700b769f921deaf$var$_useWebSpeechPonyfill3 = $1700b769f921deaf$var$_interopRequireDefault((parcelRequire("dCR9j")));
function $1700b769f921deaf$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $1700b769f921deaf$var$_slicedToArray(arr, i) {
    return $1700b769f921deaf$var$_arrayWithHoles(arr) || $1700b769f921deaf$var$_iterableToArrayLimit(arr, i) || $1700b769f921deaf$var$_unsupportedIterableToArray(arr, i) || $1700b769f921deaf$var$_nonIterableRest();
}
function $1700b769f921deaf$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $1700b769f921deaf$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $1700b769f921deaf$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $1700b769f921deaf$var$_arrayLikeToArray(o, minLen);
}
function $1700b769f921deaf$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $1700b769f921deaf$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $1700b769f921deaf$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $1700b769f921deaf$var$useResumeAudioContext() {
    var _useWebSpeechPonyfill = (0, $1700b769f921deaf$var$_useWebSpeechPonyfill3.default)(), _useWebSpeechPonyfill2 = $1700b769f921deaf$var$_slicedToArray(_useWebSpeechPonyfill, 1), resumeAudioContext = _useWebSpeechPonyfill2[0].resumeAudioContext;
    return function() {
        return resumeAudioContext && resumeAudioContext();
    };
}

});

parcelRequire.register("4t2Le", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $340c0317d3aeecac$var$useSetDictateState;

var $340c0317d3aeecac$var$_useWebChatAPIContext = $340c0317d3aeecac$var$_interopRequireDefault((parcelRequire("iJOsw")));
function $340c0317d3aeecac$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $340c0317d3aeecac$var$useSetDictateState() {
    return (0, $340c0317d3aeecac$var$_useWebChatAPIContext.default)().setDictateState;
}

});


parcelRequire.register("foWLx", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $hd4g0 = parcelRequire("hd4g0");

var $b366ae93e622439e$var$_propTypes = $b366ae93e622439e$var$_interopRequireDefault((parcelRequire("f7UXb")));

var $b366ae93e622439e$var$_react = $b366ae93e622439e$var$_interopRequireDefault((parcelRequire("eO7Kz")));

var $b366ae93e622439e$var$_ScreenReaderText = $b366ae93e622439e$var$_interopRequireDefault((parcelRequire("3NTZI")));

var $b366ae93e622439e$var$_useStyleSet3 = $b366ae93e622439e$var$_interopRequireDefault((parcelRequire("gC6jZ")));
function $b366ae93e622439e$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $b366ae93e622439e$var$_slicedToArray(arr, i) {
    return $b366ae93e622439e$var$_arrayWithHoles(arr) || $b366ae93e622439e$var$_iterableToArrayLimit(arr, i) || $b366ae93e622439e$var$_unsupportedIterableToArray(arr, i) || $b366ae93e622439e$var$_nonIterableRest();
}
function $b366ae93e622439e$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $b366ae93e622439e$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $b366ae93e622439e$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $b366ae93e622439e$var$_arrayLikeToArray(o, minLen);
}
function $b366ae93e622439e$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $b366ae93e622439e$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $b366ae93e622439e$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
var $b366ae93e622439e$var$useLocalizer = $hd4g0.hooks.useLocalizer;
var $b366ae93e622439e$var$ErrorBox = function ErrorBox(_ref) {
    var error = _ref.error, type = _ref.type;
    var _useStyleSet = (0, $b366ae93e622439e$var$_useStyleSet3.default)(), _useStyleSet2 = $b366ae93e622439e$var$_slicedToArray(_useStyleSet, 1), errorBoxStyleSet = _useStyleSet2[0].errorBox;
    var localize = $b366ae93e622439e$var$useLocalizer();
    return /*#__PURE__*/ $b366ae93e622439e$var$_react.default.createElement($b366ae93e622439e$var$_react.default.Fragment, null, /*#__PURE__*/ $b366ae93e622439e$var$_react.default.createElement($b366ae93e622439e$var$_ScreenReaderText.default, {
        text: localize("ACTIVITY_ERROR_BOX_TITLE")
    }), /*#__PURE__*/ $b366ae93e622439e$var$_react.default.createElement("div", {
        className: errorBoxStyleSet
    }, /*#__PURE__*/ $b366ae93e622439e$var$_react.default.createElement("div", null, type), /*#__PURE__*/ $b366ae93e622439e$var$_react.default.createElement("details", null, /*#__PURE__*/ $b366ae93e622439e$var$_react.default.createElement("summary", null, error.message), /*#__PURE__*/ $b366ae93e622439e$var$_react.default.createElement("pre", null, error.stack))));
};
$b366ae93e622439e$var$ErrorBox.defaultProps = {
    type: ""
};
$b366ae93e622439e$var$ErrorBox.propTypes = {
    error: $b366ae93e622439e$var$_propTypes.default.instanceOf(Error).isRequired,
    type: $b366ae93e622439e$var$_propTypes.default.string
};
var $b366ae93e622439e$var$_default = $b366ae93e622439e$var$ErrorBox;
module.exports.default = $b366ae93e622439e$var$_default;

});

parcelRequire.register("jcXHG", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $dfbd732d25a741ca$var$mapMap;

var $cG9B9 = parcelRequire("cG9B9");
function $dfbd732d25a741ca$var$_slicedToArray(arr, i) {
    return $dfbd732d25a741ca$var$_arrayWithHoles(arr) || $dfbd732d25a741ca$var$_iterableToArrayLimit(arr, i) || $dfbd732d25a741ca$var$_unsupportedIterableToArray(arr, i) || $dfbd732d25a741ca$var$_nonIterableRest();
}
function $dfbd732d25a741ca$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $dfbd732d25a741ca$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $dfbd732d25a741ca$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $dfbd732d25a741ca$var$_arrayLikeToArray(o, minLen);
}
function $dfbd732d25a741ca$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $dfbd732d25a741ca$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $dfbd732d25a741ca$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $dfbd732d25a741ca$var$mapMap(map, mapper) {
    return Object.entries(map).reduce(function(result, _ref) {
        var _ref2 = $dfbd732d25a741ca$var$_slicedToArray(_ref, 2), key = _ref2[0], value = _ref2[1];
        if (!(0, $cG9B9.isForbiddenPropertyName)(key)) // Mitigated through denylisting.
        // eslint-disable-next-line security/detect-object-injection
        result[key] = mapper(value, key);
        return result;
    }, {});
}

});

parcelRequire.register("clXbV", function(module, exports) {
"use strict";
function $8fe55c632c67747e$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $8fe55c632c67747e$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $8fe55c632c67747e$var$_typeof(obj);
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $hd4g0 = parcelRequire("hd4g0");

var $gLfyc = parcelRequire("gLfyc");

var $8fe55c632c67747e$var$_classnames = $8fe55c632c67747e$var$_interopRequireDefault((parcelRequire("5A4MD")));

var $8fe55c632c67747e$var$_react = $8fe55c632c67747e$var$_interopRequireWildcard((parcelRequire("eO7Kz")));

var $8fe55c632c67747e$var$_Context = $8fe55c632c67747e$var$_interopRequireDefault((parcelRequire("gWEqo")));

var $8fe55c632c67747e$var$_useFocus = $8fe55c632c67747e$var$_interopRequireDefault((parcelRequire("kPV7d")));

var $8fe55c632c67747e$var$_useScrollToEnd = $8fe55c632c67747e$var$_interopRequireDefault((parcelRequire("gaC1T")));

var $8fe55c632c67747e$var$_useStyleToEmotionObject = $8fe55c632c67747e$var$_interopRequireDefault((parcelRequire("6l4uV")));

var $8fe55c632c67747e$var$_useUniqueId = $8fe55c632c67747e$var$_interopRequireDefault((parcelRequire("cdwtx")));
function $8fe55c632c67747e$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($8fe55c632c67747e$var$_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $8fe55c632c67747e$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || $8fe55c632c67747e$var$_typeof(obj) !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $8fe55c632c67747e$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $8fe55c632c67747e$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $8fe55c632c67747e$var$_slicedToArray(arr, i) {
    return $8fe55c632c67747e$var$_arrayWithHoles(arr) || $8fe55c632c67747e$var$_iterableToArrayLimit(arr, i) || $8fe55c632c67747e$var$_unsupportedIterableToArray(arr, i) || $8fe55c632c67747e$var$_nonIterableRest();
}
function $8fe55c632c67747e$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $8fe55c632c67747e$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $8fe55c632c67747e$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $8fe55c632c67747e$var$_arrayLikeToArray(o, minLen);
}
function $8fe55c632c67747e$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $8fe55c632c67747e$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $8fe55c632c67747e$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
var $8fe55c632c67747e$var$useConnectivityStatus = $hd4g0.hooks.useConnectivityStatus, $8fe55c632c67747e$var$useLocalizer = $hd4g0.hooks.useLocalizer, $8fe55c632c67747e$var$usePonyfill = $hd4g0.hooks.usePonyfill, $8fe55c632c67747e$var$useSendBoxValue = $hd4g0.hooks.useSendBoxValue, $8fe55c632c67747e$var$useSubmitSendBox = $hd4g0.hooks.useSubmitSendBox;
var $8fe55c632c67747e$var$SUBMIT_ERROR_MESSAGE_STYLE = {
    "&.webchat__submit-error-message": {
        // .sr-only - This component is intended to be invisible to the visual Web Chat user, but read by the AT when using a screen reader
        color: "transparent",
        height: 1,
        overflow: "hidden",
        position: "absolute",
        // We need to set top: 0, otherwise, it will repro:
        // - Run NVDA
        // - Make the transcript long enough to show the scrollbar
        // - Press SHIFT-TAB, focus on upload button
        // - Press up arrow multiple times
        top: 0,
        whiteSpace: "nowrap",
        width: 1
    }
}; // False positive: we are using `setTimeout` as a type.
// eslint-disable-next-line no-restricted-globals
var $8fe55c632c67747e$var$TIME_TO_QUEUE_ERROR_MESSAGE = 500;
var $8fe55c632c67747e$var$TIME_TO_RESET_ERROR_MESSAGE = 50; // This component is marked as internal because it is not fully implemented and is not ready to be consumed publicly.
// When it is done, it should provide and replace all the functionalities we did in Redux, including but not limited to:
// - Speech interims
// - Maintain text box value
// - Multiple <SendBoxComposer> in a single Web Chat instance
//    - Web devs should be able to put an individual send box instance into an activity
//    - The send box instance in the activity, should be separated from the bottommost send box
//    - The valued typed inside the activity, should be separated from the value typed into the bottommost send box
// In the old days, we use Redux to keep the send box state.
// However, when web devs put 2 send box on their page, it makes things complex because both send boxes will interact with each other.
// We would rather have them separate. If web devs want them to interact with each other, they will do the wiring themselves.
// TODO: [P2] Complete this component.
var $8fe55c632c67747e$var$SendBoxComposer = function SendBoxComposer(_ref) {
    var children = _ref.children;
    var _usePonyfill = $8fe55c632c67747e$var$usePonyfill(), _usePonyfill2 = $8fe55c632c67747e$var$_slicedToArray(_usePonyfill, 1), _usePonyfill2$ = _usePonyfill2[0], clearTimeout = _usePonyfill2$.clearTimeout, setTimeout = _usePonyfill2$.setTimeout;
    var _useConnectivityStatu = $8fe55c632c67747e$var$useConnectivityStatus(), _useConnectivityStatu2 = $8fe55c632c67747e$var$_slicedToArray(_useConnectivityStatu, 1), connectivityStatus = _useConnectivityStatu2[0];
    var _useState = (0, $8fe55c632c67747e$var$_react.useState)(false), _useState2 = $8fe55c632c67747e$var$_slicedToArray(_useState, 2), error = _useState2[0], setError = _useState2[1];
    var _useSendBoxValue = $8fe55c632c67747e$var$useSendBoxValue(), _useSendBoxValue2 = $8fe55c632c67747e$var$_slicedToArray(_useSendBoxValue, 1), sendBoxValue = _useSendBoxValue2[0];
    var apiSubmitSendBox = $8fe55c632c67747e$var$useSubmitSendBox();
    var focus = (0, $8fe55c632c67747e$var$_useFocus.default)();
    var localize = $8fe55c632c67747e$var$useLocalizer();
    var scrollToEnd = (0, $8fe55c632c67747e$var$_useScrollToEnd.default)();
    var styleToEmotionObject = (0, $8fe55c632c67747e$var$_useStyleToEmotionObject.default)();
    var submitErrorMessageId = (0, $8fe55c632c67747e$var$_useUniqueId.default)("webchat__send-box__error-message-id");
    var timeoutRef = (0, $8fe55c632c67747e$var$_react.useRef)(undefined);
    var errorMessageStringMap = (0, $8fe55c632c67747e$var$_react.useMemo)(function() {
        return Object.freeze(new Map().set("empty", localize("SEND_BOX_IS_EMPTY_TOOLTIP_ALT")) // TODO: [P0] We should add a new string for "Cannot send message while offline."
        .set("offline", localize("CONNECTIVITY_STATUS_ALT_FATAL")));
    }, [
        localize
    ]);
    var focusRef = (0, $gLfyc.useRefFrom)(focus);
    var scrollToEndRef = (0, $gLfyc.useRefFrom)(scrollToEnd);
    var setErrorRef = (0, $8fe55c632c67747e$var$_react.useRef)(setError);
    var submitErrorMessageClassName = styleToEmotionObject($8fe55c632c67747e$var$SUBMIT_ERROR_MESSAGE_STYLE) + "";
    var submitErrorMessageIdState = (0, $8fe55c632c67747e$var$_react.useMemo)(function() {
        return Object.freeze([
            error ? submitErrorMessageId : undefined
        ]);
    }, [
        error,
        submitErrorMessageId
    ]);
    setErrorRef.current = setError;
    var submitErrorRef = (0, $gLfyc.useRefFrom)(connectivityStatus !== "connected" && connectivityStatus !== "reconnected" ? "offline" : !sendBoxValue ? "empty" : undefined);
    var submit = (0, $8fe55c632c67747e$var$_react.useCallback)(function() {
        var _focusRef$current;
        var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, setFocus = _ref2.setFocus;
        (setFocus === "main" || setFocus === "sendBox" || setFocus === "sendBoxWithoutKeyboard") && ((_focusRef$current = focusRef.current) === null || _focusRef$current === void 0 || _focusRef$current.call(focusRef, setFocus === "main" || setFocus === "sendBox" ? setFocus : "sendBoxWithoutKeyboard"));
        var submitError = submitErrorRef.current;
        if (submitError) {
            var _setErrorRef$current;
            timeoutRef.current && timeoutRef.current.forEach(clearTimeout);
            (_setErrorRef$current = setErrorRef.current) === null || _setErrorRef$current === void 0 || _setErrorRef$current.call(setErrorRef, false);
            timeoutRef.current = Object.freeze([
                setTimeout(function() {
                    var _setErrorRef$current2;
                    return (_setErrorRef$current2 = setErrorRef.current) === null || _setErrorRef$current2 === void 0 ? void 0 : _setErrorRef$current2.call(setErrorRef, submitError);
                }, $8fe55c632c67747e$var$TIME_TO_RESET_ERROR_MESSAGE),
                setTimeout(function() {
                    var _setErrorRef$current3;
                    return (_setErrorRef$current3 = setErrorRef.current) === null || _setErrorRef$current3 === void 0 ? void 0 : _setErrorRef$current3.call(setErrorRef, false);
                }, $8fe55c632c67747e$var$TIME_TO_QUEUE_ERROR_MESSAGE)
            ]);
        } else {
            var _scrollToEndRef$curre;
            (_scrollToEndRef$curre = scrollToEndRef.current) === null || _scrollToEndRef$curre === void 0 || _scrollToEndRef$curre.call(scrollToEndRef);
            apiSubmitSendBox();
        }
    }, [
        apiSubmitSendBox,
        clearTimeout,
        focusRef,
        scrollToEndRef,
        setErrorRef,
        setTimeout,
        submitErrorRef,
        timeoutRef
    ]);
    (0, $8fe55c632c67747e$var$_react.useEffect)(function() {
        return function() {
            setErrorRef.current = undefined;
        };
    }, [
        setErrorRef
    ]);
    var context = (0, $8fe55c632c67747e$var$_react.useMemo)(function() {
        return {
            submit: submit,
            submitErrorMessageIdState: submitErrorMessageIdState
        };
    }, [
        submit,
        submitErrorMessageIdState
    ]);
    return /*#__PURE__*/ $8fe55c632c67747e$var$_react.default.createElement($8fe55c632c67747e$var$_Context.default.Provider, {
        value: context
    }, children, /*#__PURE__*/ $8fe55c632c67747e$var$_react.default.createElement("span", {
        className: (0, $8fe55c632c67747e$var$_classnames.default)("webchat__submit-error-message", submitErrorMessageClassName) // "id" is required for "aria-errormessage" as IDREF.
        ,
        id: submitErrorMessageId,
        role: "alert"
    }, error ? errorMessageStringMap.get(error) : ""));
};
var $8fe55c632c67747e$var$_default = $8fe55c632c67747e$var$SendBoxComposer;
module.exports.default = $8fe55c632c67747e$var$_default;

});
parcelRequire.register("gLfyc", function(module, exports) {
"use strict";

var $bzi9N = parcelRequire("bzi9N");

var $9BXGj = parcelRequire("9BXGj");
var $c33d19281b7501c1$require$_interopRequireDefault = $9BXGj.default;
$bzi9N(module.exports, "__esModule", {
    value: true
});
$bzi9N(module.exports, "useRefFrom", {
    enumerable: true,
    get: function get() {
        return $c33d19281b7501c1$var$_useRefFrom.default;
    }
});

var $c33d19281b7501c1$var$_useRefFrom = $c33d19281b7501c1$require$_interopRequireDefault((parcelRequire("35ZeP")));

});
parcelRequire.register("9BXGj", function(module, exports) {
function $6ff5dd435ded5bee$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
module.exports = $6ff5dd435ded5bee$var$_interopRequireDefault, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRequire.register("35ZeP", function(module, exports) {
"use strict";

var $bzi9N = parcelRequire("bzi9N");

var $9BXGj = parcelRequire("9BXGj");
var $24115759fedd7c81$require$_interopRequireDefault = $9BXGj.default;
$bzi9N(module.exports, "__esModule", {
    value: true
});
module.exports.default = $24115759fedd7c81$var$useRefFrom;

var $24115759fedd7c81$var$_create = $24115759fedd7c81$require$_interopRequireDefault((parcelRequire("7f1eV")));

var $eO7Kz = parcelRequire("eO7Kz");
function $24115759fedd7c81$var$useRefFrom(value) {
    var ref = (0, $eO7Kz.useRef)();
    var readOnlyRef = (0, $eO7Kz.useMemo)(function() {
        return (0, $24115759fedd7c81$var$_create.default)({}, {
            current: {
                get: function get() {
                    return ref.current;
                }
            }
        });
    }, [
        ref
    ]);
    ref.current = value;
    return readOnlyRef;
}

});
parcelRequire.register("7f1eV", function(module, exports) {

module.exports = (parcelRequire("6Z7dL"));

});




parcelRequire.register("fJh2e", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $hd4g0 = parcelRequire("hd4g0");

var $eO7Kz = parcelRequire("eO7Kz");

var $cKPu1 = parcelRequire("cKPu1");

var $dCjk2 = parcelRequire("dCjk2");

var $b73845c9625239ea$var$_useWebSpeechPonyfill3 = $b73845c9625239ea$var$_interopRequireDefault((parcelRequire("dCR9j")));
function $b73845c9625239ea$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $b73845c9625239ea$var$_slicedToArray(arr, i) {
    return $b73845c9625239ea$var$_arrayWithHoles(arr) || $b73845c9625239ea$var$_iterableToArrayLimit(arr, i) || $b73845c9625239ea$var$_unsupportedIterableToArray(arr, i) || $b73845c9625239ea$var$_nonIterableRest();
}
function $b73845c9625239ea$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $b73845c9625239ea$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $b73845c9625239ea$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $b73845c9625239ea$var$_arrayLikeToArray(o, minLen);
}
function $b73845c9625239ea$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $b73845c9625239ea$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $b73845c9625239ea$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
var $b73845c9625239ea$var$useTrackDimension = $hd4g0.hooks.useTrackDimension;
var $b73845c9625239ea$var$Tracker = function Tracker() {
    var _useWebSpeechPonyfill = (0, $b73845c9625239ea$var$_useWebSpeechPonyfill3.default)(), _useWebSpeechPonyfill2 = $b73845c9625239ea$var$_slicedToArray(_useWebSpeechPonyfill, 1), webSpeechPonyfill = _useWebSpeechPonyfill2[0];
    var trackDimension = $b73845c9625239ea$var$useTrackDimension();
    var speechRecognitionCapability = !!webSpeechPonyfill.SpeechRecognition;
    var speechSynthesisCapability = webSpeechPonyfill.speechSynthesis && webSpeechPonyfill.speechSynthesis !== $dCjk2.speechSynthesis;
    (0, $eO7Kz.useEffect)(function() {
        trackDimension("capability:downscaleImage:workerType", (0, $cKPu1.checkSupport)() ? "web worker" : "main");
        trackDimension("capability:renderer", "html"); // TODO: [P2] #2937 Differentiate between Cognitive Services and browser speech
        trackDimension("prop:speechRecognition", !!speechRecognitionCapability + "");
        trackDimension("prop:speechSynthesis", !!speechSynthesisCapability + "");
    }, [
        trackDimension,
        speechRecognitionCapability,
        speechSynthesisCapability
    ]);
    return false;
};
var $b73845c9625239ea$var$_default = $b73845c9625239ea$var$Tracker;
module.exports.default = $b73845c9625239ea$var$_default;

});



parcelRequire.register("8nM1g", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $61a5b861abb568dc$var$_propTypes = $61a5b861abb568dc$var$_interopRequireDefault((parcelRequire("f7UXb")));

var $61a5b861abb568dc$var$_react = $61a5b861abb568dc$var$_interopRequireDefault((parcelRequire("eO7Kz")));

var $bIkyU = parcelRequire("bIkyU");
function $61a5b861abb568dc$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/** @deprecated Please use `useRenderAvatar` hook instead. */ var $61a5b861abb568dc$var$Avatar = function Avatar(_ref) {
    var ariaHidden = _ref["aria-hidden"], className = _ref.className, fromUser = _ref.fromUser;
    console.warn("botframework-webchat: <Avatar> component is deprecated and will be removed on or after 2022-02-25. Please use `useRenderAvatar` hook instead.");
    return /*#__PURE__*/ $61a5b861abb568dc$var$_react.default.createElement($bIkyU.DefaultAvatar, {
        "aria-hidden": ariaHidden,
        className: className,
        fromUser: fromUser
    });
};
$61a5b861abb568dc$var$Avatar.defaultProps = {
    "aria-hidden": false,
    className: "",
    fromUser: false
};
$61a5b861abb568dc$var$Avatar.propTypes = {
    "aria-hidden": $61a5b861abb568dc$var$_propTypes.default.bool,
    className: $61a5b861abb568dc$var$_propTypes.default.string,
    fromUser: $61a5b861abb568dc$var$_propTypes.default.bool
};
var $61a5b861abb568dc$var$_default = $61a5b861abb568dc$var$Avatar;
module.exports.default = $61a5b861abb568dc$var$_default;

});

parcelRequire.register("kssQU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "useDictateAbortable", {
    enumerable: true,
    get: function get() {
        return $ee4ccdad5146eb9b$var$_useDictateAbortable.default;
    }
});
Object.defineProperty(module.exports, "useFocus", {
    enumerable: true,
    get: function get() {
        return $ee4ccdad5146eb9b$var$_useFocus.default;
    }
});
Object.defineProperty(module.exports, "useFocusSendBox", {
    enumerable: true,
    get: function get() {
        return $ee4ccdad5146eb9b$var$_useFocusSendBox.default;
    }
});
Object.defineProperty(module.exports, "useMicrophoneButtonClick", {
    enumerable: true,
    get: function get() {
        return $dtULG.useMicrophoneButtonClick;
    }
});
Object.defineProperty(module.exports, "useMicrophoneButtonDisabled", {
    enumerable: true,
    get: function get() {
        return $dtULG.useMicrophoneButtonDisabled;
    }
});
Object.defineProperty(module.exports, "useObserveScrollPosition", {
    enumerable: true,
    get: function get() {
        return $ee4ccdad5146eb9b$var$_useObserveScrollPosition.default;
    }
});
Object.defineProperty(module.exports, "useObserveTranscriptFocus", {
    enumerable: true,
    get: function get() {
        return $ee4ccdad5146eb9b$var$_useObserveTranscriptFocus.default;
    }
});
Object.defineProperty(module.exports, "useRenderMarkdownAsHTML", {
    enumerable: true,
    get: function get() {
        return $ee4ccdad5146eb9b$var$_useRenderMarkdownAsHTML.default;
    }
});
Object.defineProperty(module.exports, "useScrollDown", {
    enumerable: true,
    get: function get() {
        return $ee4ccdad5146eb9b$var$_useScrollDown.default;
    }
});
Object.defineProperty(module.exports, "useScrollTo", {
    enumerable: true,
    get: function get() {
        return $ee4ccdad5146eb9b$var$_useScrollTo.default;
    }
});
Object.defineProperty(module.exports, "useScrollToEnd", {
    enumerable: true,
    get: function get() {
        return $ee4ccdad5146eb9b$var$_useScrollToEnd.default;
    }
});
Object.defineProperty(module.exports, "useScrollUp", {
    enumerable: true,
    get: function get() {
        return $ee4ccdad5146eb9b$var$_useScrollUp.default;
    }
});
Object.defineProperty(module.exports, "useSendBoxSpeechInterimsVisible", {
    enumerable: true,
    get: function get() {
        return $ha8W8.useSendBoxSpeechInterimsVisible;
    }
});
Object.defineProperty(module.exports, "useSendFiles", {
    enumerable: true,
    get: function get() {
        return $ee4ccdad5146eb9b$var$_useSendFiles.default;
    }
});
Object.defineProperty(module.exports, "useStyleSet", {
    enumerable: true,
    get: function get() {
        return $ee4ccdad5146eb9b$var$_useStyleSet.default;
    }
});
Object.defineProperty(module.exports, "useTextBoxSubmit", {
    enumerable: true,
    get: function get() {
        return $6sNkp.useTextBoxSubmit;
    }
});
Object.defineProperty(module.exports, "useTextBoxValue", {
    enumerable: true,
    get: function get() {
        return $6sNkp.useTextBoxValue;
    }
});
Object.defineProperty(module.exports, "useTypingIndicatorVisible", {
    enumerable: true,
    get: function get() {
        return $56gdr.useTypingIndicatorVisible;
    }
});
Object.defineProperty(module.exports, "useWebSpeechPonyfill", {
    enumerable: true,
    get: function get() {
        return $ee4ccdad5146eb9b$var$_useWebSpeechPonyfill.default;
    }
});

var $ee4ccdad5146eb9b$var$_useDictateAbortable = $ee4ccdad5146eb9b$var$_interopRequireDefault((parcelRequire("erCqX")));

var $ee4ccdad5146eb9b$var$_useFocus = $ee4ccdad5146eb9b$var$_interopRequireDefault((parcelRequire("kPV7d")));

var $ee4ccdad5146eb9b$var$_useFocusSendBox = $ee4ccdad5146eb9b$var$_interopRequireDefault((parcelRequire("650jm")));

var $ee4ccdad5146eb9b$var$_useObserveScrollPosition = $ee4ccdad5146eb9b$var$_interopRequireDefault((parcelRequire("ba98k")));

var $ee4ccdad5146eb9b$var$_useObserveTranscriptFocus = $ee4ccdad5146eb9b$var$_interopRequireDefault((parcelRequire("jZOry")));

var $ee4ccdad5146eb9b$var$_useRenderMarkdownAsHTML = $ee4ccdad5146eb9b$var$_interopRequireDefault((parcelRequire("5BkDS")));

var $ee4ccdad5146eb9b$var$_useScrollDown = $ee4ccdad5146eb9b$var$_interopRequireDefault((parcelRequire("lgVAh")));

var $ee4ccdad5146eb9b$var$_useScrollTo = $ee4ccdad5146eb9b$var$_interopRequireDefault((parcelRequire("iyDrp")));

var $ee4ccdad5146eb9b$var$_useScrollToEnd = $ee4ccdad5146eb9b$var$_interopRequireDefault((parcelRequire("gaC1T")));

var $ee4ccdad5146eb9b$var$_useScrollUp = $ee4ccdad5146eb9b$var$_interopRequireDefault((parcelRequire("k6SGM")));

var $ee4ccdad5146eb9b$var$_useSendFiles = $ee4ccdad5146eb9b$var$_interopRequireDefault((parcelRequire("bo3v7")));

var $ee4ccdad5146eb9b$var$_useStyleSet = $ee4ccdad5146eb9b$var$_interopRequireDefault((parcelRequire("gC6jZ")));

var $ee4ccdad5146eb9b$var$_useWebSpeechPonyfill = $ee4ccdad5146eb9b$var$_interopRequireDefault((parcelRequire("dCR9j")));

var $dtULG = parcelRequire("dtULG");

var $ha8W8 = parcelRequire("ha8W8");

var $6sNkp = parcelRequire("6sNkp");

var $56gdr = parcelRequire("56gdr");
function $ee4ccdad5146eb9b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}

});
parcelRequire.register("650jm", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $46d37382485fc394$var$useFocusSendBox;

var $46d37382485fc394$var$_useFocus = $46d37382485fc394$var$_interopRequireDefault((parcelRequire("kPV7d")));
function $46d37382485fc394$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $46d37382485fc394$var$showDeprecationNotes = true;
/** @deprecated Please use `useFocus('sendBox')` instead. */ function $46d37382485fc394$var$useFocusSendBox() {
    if ($46d37382485fc394$var$showDeprecationNotes) {
        console.warn('botframework-webchat: "useFocusSendBox" is deprecated and will be removed on or after 2022-04-21. Please use "useFocus(\'sendBox\')" instead.');
        $46d37382485fc394$var$showDeprecationNotes = false;
    }
    return (0, $46d37382485fc394$var$_useFocus.default)().bind(null, "sendBox");
}

});

parcelRequire.register("ba98k", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $8207b69463ca93fd$var$useObserveScrollPosition;

var $eO7Kz = parcelRequire("eO7Kz");

var $8207b69463ca93fd$var$_useWebChatUIContext2 = $8207b69463ca93fd$var$_interopRequireDefault((parcelRequire("tHuBR")));
function $8207b69463ca93fd$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $8207b69463ca93fd$var$_toConsumableArray(arr) {
    return $8207b69463ca93fd$var$_arrayWithoutHoles(arr) || $8207b69463ca93fd$var$_iterableToArray(arr) || $8207b69463ca93fd$var$_unsupportedIterableToArray(arr) || $8207b69463ca93fd$var$_nonIterableSpread();
}
function $8207b69463ca93fd$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $8207b69463ca93fd$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $8207b69463ca93fd$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $8207b69463ca93fd$var$_arrayLikeToArray(o, minLen);
}
function $8207b69463ca93fd$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $8207b69463ca93fd$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $8207b69463ca93fd$var$_arrayLikeToArray(arr);
}
function $8207b69463ca93fd$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $8207b69463ca93fd$var$useObserveScrollPosition(observer, deps) {
    if (typeof observer !== "function") {
        observer = undefined;
        console.warn('botframework-webchat: First argument passed to "useObserveScrollPosition" must be a function.');
    } else if (typeof deps !== "undefined" && !Array.isArray(deps)) console.warn('botframework-webchat: Second argument passed to "useObserveScrollPosition" must be an array if specified.');
    var _useWebChatUIContext = (0, $8207b69463ca93fd$var$_useWebChatUIContext2.default)(), observeScrollPosition = _useWebChatUIContext.observeScrollPosition;
    /* eslint-disable-next-line react-hooks/exhaustive-deps */ (0, $eO7Kz.useEffect)(function() {
        return observer && observeScrollPosition(observer);
    }, [].concat($8207b69463ca93fd$var$_toConsumableArray(deps || []), [
        observer,
        observeScrollPosition
    ]));
}

});

parcelRequire.register("jZOry", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $e8ead7d6fb56353f$var$useObserveTranscriptFocus;

var $eO7Kz = parcelRequire("eO7Kz");

var $e8ead7d6fb56353f$var$_useWebChatUIContext2 = $e8ead7d6fb56353f$var$_interopRequireDefault((parcelRequire("tHuBR")));
function $e8ead7d6fb56353f$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $e8ead7d6fb56353f$var$_toConsumableArray(arr) {
    return $e8ead7d6fb56353f$var$_arrayWithoutHoles(arr) || $e8ead7d6fb56353f$var$_iterableToArray(arr) || $e8ead7d6fb56353f$var$_unsupportedIterableToArray(arr) || $e8ead7d6fb56353f$var$_nonIterableSpread();
}
function $e8ead7d6fb56353f$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $e8ead7d6fb56353f$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $e8ead7d6fb56353f$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $e8ead7d6fb56353f$var$_arrayLikeToArray(o, minLen);
}
function $e8ead7d6fb56353f$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $e8ead7d6fb56353f$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $e8ead7d6fb56353f$var$_arrayLikeToArray(arr);
}
function $e8ead7d6fb56353f$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $e8ead7d6fb56353f$var$useObserveTranscriptFocus(observer, deps) {
    if (typeof observer !== "function") {
        observer = undefined;
        console.warn('botframework-webchat: First argument passed to "useObserveTranscriptFocus" must be a function.');
    } else if (typeof deps !== "undefined" && !Array.isArray(deps)) console.warn('botframework-webchat: Second argument passed to "useObserveTranscriptFocus" must be an array if specified.');
    var _useWebChatUIContext = (0, $e8ead7d6fb56353f$var$_useWebChatUIContext2.default)(), observeTranscriptFocus = _useWebChatUIContext.observeTranscriptFocus;
    /* eslint-disable-next-line react-hooks/exhaustive-deps */ (0, $eO7Kz.useEffect)(function() {
        return observer && observeTranscriptFocus(observer);
    }, [].concat($e8ead7d6fb56353f$var$_toConsumableArray(deps || []), [
        observer,
        observeTranscriptFocus
    ]));
}

});

parcelRequire.register("iyDrp", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $d829ff20942796f6$var$useScrollTo;

var $eO7Kz = parcelRequire("eO7Kz");

var $d829ff20942796f6$var$_useWebChatUIContext2 = $d829ff20942796f6$var$_interopRequireDefault((parcelRequire("tHuBR")));
function $d829ff20942796f6$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $d829ff20942796f6$var$useScrollTo() {
    var _useWebChatUIContext = (0, $d829ff20942796f6$var$_useWebChatUIContext2.default)(), scrollToCallbacksRef = _useWebChatUIContext.scrollToCallbacksRef;
    return (0, $eO7Kz.useCallback)(function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return scrollToCallbacksRef.current.forEach(function(callback) {
            return callback.apply(void 0, args);
        });
    }, [
        scrollToCallbacksRef
    ]);
}

});



parcelRequire.register("2q5ze", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $1c3253fee3127592$var$addVersion;

var $fD7D4 = parcelRequire("fD7D4");

var $cG9B9 = parcelRequire("cG9B9");
/* global global:readonly, process:readonly */ /* eslint no-empty: ["error", { "allowEmptyCatch": true }] */ function $1c3253fee3127592$var$setMetaTag(name, content) {
    try {
        var _global = $parcel$global, document = _global.document;
        if (typeof document !== "undefined" && document.createElement && document.head && document.head.appendChild) {
            var meta = document.querySelector('html meta[name="'.concat(encodeURI(name), '"]')) || document.createElement("meta");
            meta.setAttribute("name", name);
            meta.setAttribute("content", content);
            document.head.appendChild(meta);
        }
    } catch (err) {}
}
function $1c3253fee3127592$var$addVersion(variant) {
    $1c3253fee3127592$var$setMetaTag("botframework-webchat:bundle:variant", variant);
    $1c3253fee3127592$var$setMetaTag("botframework-webchat:bundle:version", "4.15.8");
    $1c3253fee3127592$var$setMetaTag("botframework-webchat:core:version", $cG9B9.version);
    $1c3253fee3127592$var$setMetaTag("botframework-webchat:ui:version", $fD7D4.version);
}

});

parcelRequire.register("lBhHu", function(module, exports) {
"use strict";

var $luOtD = parcelRequire("luOtD");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $fb9ac8a2d262e2eb$var$renderWebChat;

var $fb9ac8a2d262e2eb$var$_react = $luOtD((parcelRequire("eO7Kz")));

var $fb9ac8a2d262e2eb$var$_reactDom = $luOtD((parcelRequire("kz03S")));
function $fb9ac8a2d262e2eb$var$renderWebChat(ReactWebChat, props, element) {
    $fb9ac8a2d262e2eb$var$_reactDom.default.render(/*#__PURE__*/ $fb9ac8a2d262e2eb$var$_react.default.createElement(ReactWebChat, props), element);
}

});
parcelRequire.register("luOtD", function(module, exports) {
function $fa638dfbb5fa2f1b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
module.exports = $fa638dfbb5fa2f1b$var$_interopRequireDefault, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRequire.register("3F9kf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $2aac6f470b0ca800$var$createBrowserWebSpeechPonyfillFactory;
function $2aac6f470b0ca800$var$createBrowserWebSpeechPonyfillFactory() {
    // eslint-disable-next-line dot-notation
    if (!window.SpeechRecognition && !window["webkitSpeechRecognition"]) console.warn("Web Chat: This browser does not support Web Speech API Speech Recognition.");
    if (!window.speechSynthesis) console.warn("Web Chat: This browser does not support Web Speech API Speech Synthesis.");
    return function() {
        return {
            // eslint-disable-next-line dot-notation
            SpeechGrammarList: window.SpeechGrammarList || window["webkitSpeechGrammarList"],
            // eslint-disable-next-line dot-notation
            SpeechRecognition: window.SpeechRecognition || window["webkitSpeechRecognition"],
            speechSynthesis: window.speechSynthesis,
            SpeechSynthesisUtterance: window.SpeechSynthesisUtterance
        };
    };
}

});

parcelRequire.register("bZDNv", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $8bb4432cb5ad0014$var$createDirectLine;

var $kT3Qz = parcelRequire("kT3Qz");
function $8bb4432cb5ad0014$var$createDirectLine(_ref) {
    var botAgent = _ref.botAgent, conversationId = _ref.conversationId, conversationStartProperties = _ref.conversationStartProperties, domain = _ref.domain, fetch = _ref.fetch, pollingInterval = _ref.pollingInterval, secret = _ref.secret, streamUrl = _ref.streamUrl, token = _ref.token, watermark = _ref.watermark, webSocket = _ref.webSocket;
    // TODO: [P3] Checks if DLJS supports ponyfilling fetch.
    return new $kT3Qz.DirectLine({
        botAgent: botAgent,
        conversationId: conversationId,
        conversationStartProperties: conversationStartProperties,
        domain: domain,
        fetch: fetch,
        pollingInterval: pollingInterval,
        secret: secret,
        streamUrl: streamUrl,
        token: token,
        watermark: watermark,
        webSocket: webSocket,
        createFormData: function createFormData(attachments) {
            var formData = new FormData();
            attachments.forEach(function(_ref2) {
                var contentType = _ref2.contentType, data = _ref2.data, filename = _ref2.filename, name = _ref2.name;
                formData.append(name, new Blob(data, {
                    type: contentType
                }), filename);
            });
            return formData;
        }
    });
}

});
parcelRequire.register("kT3Qz", function(module, exports) {
"use strict";

var $aJHrF = parcelRequire("aJHrF");

var $9FqFu = parcelRequire("9FqFu");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "DirectLineStreaming", {
    enumerable: true,
    get: function get() {
        return $7QzhE.DirectLineStreaming;
    }
});
module.exports.DirectLine = module.exports.ConnectionStatus = void 0;

var $f34bed9fe086c89c$var$_objectWithoutProperties2 = $aJHrF((parcelRequire("605Ce")));

var $f34bed9fe086c89c$var$_classCallCheck2 = $aJHrF((parcelRequire("hBL3H")));

var $f34bed9fe086c89c$var$_createClass2 = $aJHrF((parcelRequire("3As53")));

var $f34bed9fe086c89c$var$_defineProperty2 = $aJHrF((parcelRequire("eiPwg")));
parcelRequire("2qCUE");
parcelRequire("5lfHT");

var $5PS69 = parcelRequire("5PS69");

var $lyDVs = parcelRequire("lyDVs");

var $lvV06 = parcelRequire("lvV06");

var $f34bed9fe086c89c$var$_jwtDecode = $f34bed9fe086c89c$var$_interopRequireWildcard((parcelRequire("jWtCV")));
parcelRequire("cxO31");
parcelRequire("l3vao");
parcelRequire("8yQ9N");
parcelRequire("918ZT");
parcelRequire("kT8K1");
parcelRequire("bz5ZN");
parcelRequire("ii3mB");
parcelRequire("312NI");
parcelRequire("e6GkS");
parcelRequire("2p5xo");
parcelRequire("8B8mh");
parcelRequire("k9MKp");
parcelRequire("gMM0m");
parcelRequire("lcmTO");
parcelRequire("1G4dh");
parcelRequire("2Bgfi");
parcelRequire("gqkbp");
parcelRequire("919fR");

var $f34bed9fe086c89c$var$_dedupeFilenames = $aJHrF((parcelRequire("kGlFT")));

var $7QzhE = parcelRequire("7QzhE");
var $f34bed9fe086c89c$var$_excluded = [
    "contentUrl"
];
function $f34bed9fe086c89c$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($f34bed9fe086c89c$var$_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $f34bed9fe086c89c$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || $9FqFu(obj) !== "object" && typeof obj !== "function") return {
        "default": obj
    };
    var cache = $f34bed9fe086c89c$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj["default"] = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $f34bed9fe086c89c$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $f34bed9fe086c89c$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $f34bed9fe086c89c$var$ownKeys(Object(source), true).forEach(function(key) {
            (0, $f34bed9fe086c89c$var$_defineProperty2["default"])(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $f34bed9fe086c89c$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var $f34bed9fe086c89c$var$DIRECT_LINE_VERSION = "DirectLine/3.0";
// These types are specific to this client library, not to Direct Line 3.0
var $f34bed9fe086c89c$var$ConnectionStatus;
module.exports.ConnectionStatus = $f34bed9fe086c89c$var$ConnectionStatus;
(function(ConnectionStatus) {
    ConnectionStatus[ConnectionStatus["Uninitialized"] = 0] = "Uninitialized";
    ConnectionStatus[ConnectionStatus["Connecting"] = 1] = "Connecting";
    ConnectionStatus[ConnectionStatus["Online"] = 2] = "Online";
    ConnectionStatus[ConnectionStatus["ExpiredToken"] = 3] = "ExpiredToken";
    ConnectionStatus[ConnectionStatus["FailedToConnect"] = 4] = "FailedToConnect";
    ConnectionStatus[ConnectionStatus["Ended"] = 5] = "Ended";
})($f34bed9fe086c89c$var$ConnectionStatus || (module.exports.ConnectionStatus = $f34bed9fe086c89c$var$ConnectionStatus = {}));
var $f34bed9fe086c89c$var$wrapAjaxWithRetry = function wrapAjaxWithRetry(source, scheduler) {
    var notImplemented = function notImplemented() {
        throw new Error("not implemented");
    };
    var inner = function inner(response$) {
        return response$["catch"](function(err) {
            if (err.status === 429) {
                var retryAfterValue = err.xhr.getResponseHeader("Retry-After");
                var retryAfter = Number(retryAfterValue);
                if (!isNaN(retryAfter)) return $lyDVs.Observable.timer(retryAfter, scheduler).flatMap(function(_) {
                    return $lyDVs.Observable["throw"](err, scheduler);
                });
            }
            return $lyDVs.Observable["throw"](err, scheduler);
        });
    };
    var outer = function outer(urlOrRequest) {
        return inner(source(urlOrRequest));
    };
    return Object.assign(outer, {
        get: function get(url, headers) {
            return notImplemented();
        },
        post: function post(url, body, headers) {
            return notImplemented();
        },
        put: function put(url, body, headers) {
            return notImplemented();
        },
        patch: function patch(url, body, headers) {
            return notImplemented();
        },
        "delete": function _delete(url, headers) {
            return notImplemented();
        },
        getJSON: function getJSON(url, headers) {
            return notImplemented();
        }
    });
};
var $f34bed9fe086c89c$var$makeServices = function makeServices(services) {
    var scheduler = services.scheduler || $lvV06.async;
    return {
        scheduler: scheduler,
        ajax: $f34bed9fe086c89c$var$wrapAjaxWithRetry(services.ajax || $lyDVs.Observable.ajax, scheduler),
        WebSocket: services.WebSocket || WebSocket,
        random: services.random || Math.random
    };
};
var $f34bed9fe086c89c$var$lifetimeRefreshToken = 1800000;
var $f34bed9fe086c89c$var$intervalRefreshToken = $f34bed9fe086c89c$var$lifetimeRefreshToken / 2;
var $f34bed9fe086c89c$var$POLLING_INTERVAL_LOWER_BOUND = 200; //ms
var $f34bed9fe086c89c$var$errorExpiredToken = new Error("expired token");
var $f34bed9fe086c89c$var$errorConversationEnded = new Error("conversation ended");
var $f34bed9fe086c89c$var$errorFailedToConnect = new Error("failed to connect");
var $f34bed9fe086c89c$var$konsole = {
    log: function log(message) {
        var _console;
        for(var _len = arguments.length, optionalParams = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)optionalParams[_key - 1] = arguments[_key];
        if (typeof window !== "undefined" && window["botchatDebug"] && message) (_console = console).log.apply(_console, [
            message
        ].concat(optionalParams));
    }
};
var $f34bed9fe086c89c$var$DirectLine = /*#__PURE__*/ function() {
    function DirectLine(options) {
        (0, $f34bed9fe086c89c$var$_classCallCheck2["default"])(this, DirectLine);
        (0, $f34bed9fe086c89c$var$_defineProperty2["default"])(this, "connectionStatus$", new $5PS69.BehaviorSubject($f34bed9fe086c89c$var$ConnectionStatus.Uninitialized));
        (0, $f34bed9fe086c89c$var$_defineProperty2["default"])(this, "domain", "https://directline.botframework.com/v3/directline");
        (0, $f34bed9fe086c89c$var$_defineProperty2["default"])(this, "watermark", "");
        (0, $f34bed9fe086c89c$var$_defineProperty2["default"])(this, "_botAgent", "");
        (0, $f34bed9fe086c89c$var$_defineProperty2["default"])(this, "timeout", 20000);
        (0, $f34bed9fe086c89c$var$_defineProperty2["default"])(this, "pollingInterval", 1000);
        this.secret = options.secret;
        this.token = options.secret || options.token;
        this.webSocket = (options.webSocket === undefined ? true : options.webSocket) && typeof WebSocket !== "undefined" && WebSocket !== undefined;
        if (options.conversationStartProperties && options.conversationStartProperties.locale) {
            if (Object.prototype.toString.call(options.conversationStartProperties.locale) === "[object String]") this.localeOnStartConversation = options.conversationStartProperties.locale;
            else console.warn("DirectLineJS: conversationStartProperties.locale was ignored: the locale name may be a BCP 47 language tag");
        }
        if (options.domain) this.domain = options.domain;
        if (options.conversationId) this.conversationId = options.conversationId;
        if (options.watermark) this.watermark = options.watermark;
        if (options.streamUrl) {
            if (options.token && options.conversationId) this.streamUrl = options.streamUrl;
            else console.warn("DirectLineJS: streamUrl was ignored: you need to provide a token and a conversationid");
        }
        if (options.timeout !== undefined) this.timeout = options.timeout;
        this.retries = ($f34bed9fe086c89c$var$lifetimeRefreshToken - $f34bed9fe086c89c$var$intervalRefreshToken) / this.timeout;
        this._botAgent = this.getBotAgent(options.botAgent);
        this.services = $f34bed9fe086c89c$var$makeServices(options);
        var parsedPollingInterval = ~~options.pollingInterval;
        if (parsedPollingInterval < $f34bed9fe086c89c$var$POLLING_INTERVAL_LOWER_BOUND) {
            if (typeof options.pollingInterval !== "undefined") console.warn("DirectLineJS: provided pollingInterval (".concat(options.pollingInterval, ") is under lower bound (200ms), using default of 1000ms"));
        } else this.pollingInterval = parsedPollingInterval;
        this.expiredTokenExhaustion = this.setConnectionStatusFallback($f34bed9fe086c89c$var$ConnectionStatus.ExpiredToken, $f34bed9fe086c89c$var$ConnectionStatus.FailedToConnect, 5);
        this.activity$ = (this.webSocket ? this.webSocketActivity$() : this.pollingGetActivity$()).share();
    } // Every time we're about to make a Direct Line REST call, we call this first to see check the current connection status.
    // Either throws an error (indicating an error state) or emits a null, indicating a (presumably) healthy connection
    (0, $f34bed9fe086c89c$var$_createClass2["default"])(DirectLine, [
        {
            key: "checkConnection",
            value: function checkConnection() {
                var _this = this;
                var once = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
                var obs = this.connectionStatus$.flatMap(function(connectionStatus) {
                    if (connectionStatus === $f34bed9fe086c89c$var$ConnectionStatus.Uninitialized) {
                        _this.connectionStatus$.next($f34bed9fe086c89c$var$ConnectionStatus.Connecting); //if token and streamUrl are defined it means reconnect has already been done. Skipping it.
                        if (_this.token && _this.streamUrl) {
                            _this.connectionStatus$.next($f34bed9fe086c89c$var$ConnectionStatus.Online);
                            return $lyDVs.Observable.of(connectionStatus, _this.services.scheduler);
                        } else return _this.startConversation()["do"](function(conversation) {
                            _this.conversationId = conversation.conversationId;
                            _this.token = _this.secret || conversation.token;
                            _this.streamUrl = conversation.streamUrl;
                            _this.referenceGrammarId = conversation.referenceGrammarId;
                            if (!_this.secret) _this.refreshTokenLoop();
                            _this.connectionStatus$.next($f34bed9fe086c89c$var$ConnectionStatus.Online);
                        }, function(error) {
                            _this.connectionStatus$.next($f34bed9fe086c89c$var$ConnectionStatus.FailedToConnect);
                        }).map(function(_) {
                            return connectionStatus;
                        });
                    } else return $lyDVs.Observable.of(connectionStatus, _this.services.scheduler);
                }).filter(function(connectionStatus) {
                    return connectionStatus != $f34bed9fe086c89c$var$ConnectionStatus.Uninitialized && connectionStatus != $f34bed9fe086c89c$var$ConnectionStatus.Connecting;
                }).flatMap(function(connectionStatus) {
                    switch(connectionStatus){
                        case $f34bed9fe086c89c$var$ConnectionStatus.Ended:
                            return $lyDVs.Observable["throw"]($f34bed9fe086c89c$var$errorConversationEnded, _this.services.scheduler);
                        case $f34bed9fe086c89c$var$ConnectionStatus.FailedToConnect:
                            return $lyDVs.Observable["throw"]($f34bed9fe086c89c$var$errorFailedToConnect, _this.services.scheduler);
                        case $f34bed9fe086c89c$var$ConnectionStatus.ExpiredToken:
                            return $lyDVs.Observable.of(connectionStatus, _this.services.scheduler);
                        default:
                            return $lyDVs.Observable.of(connectionStatus, _this.services.scheduler);
                    }
                });
                return once ? obs.take(1) : obs;
            }
        },
        {
            key: "setConnectionStatusFallback",
            value: function setConnectionStatusFallback(connectionStatusFrom, connectionStatusTo) {
                var maxAttempts = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 5;
                maxAttempts--;
                var attempts = 0;
                var currStatus = null;
                return function(status) {
                    if (status === connectionStatusFrom && currStatus === status && attempts >= maxAttempts) {
                        attempts = 0;
                        return connectionStatusTo;
                    }
                    attempts++;
                    currStatus = status;
                    return status;
                };
            }
        },
        {
            key: "expiredToken",
            value: function expiredToken() {
                var connectionStatus = this.connectionStatus$.getValue();
                if (connectionStatus != $f34bed9fe086c89c$var$ConnectionStatus.Ended && connectionStatus != $f34bed9fe086c89c$var$ConnectionStatus.FailedToConnect) this.connectionStatus$.next($f34bed9fe086c89c$var$ConnectionStatus.ExpiredToken);
                var protectedConnectionStatus = this.expiredTokenExhaustion(this.connectionStatus$.getValue());
                this.connectionStatus$.next(protectedConnectionStatus);
            }
        },
        {
            key: "startConversation",
            value: function startConversation() {
                var _this2 = this;
                //if conversationid is set here, it means we need to call the reconnect api, else it is a new conversation
                var url = this.conversationId ? "".concat(this.domain, "/conversations/").concat(this.conversationId, "?watermark=").concat(this.watermark) : "".concat(this.domain, "/conversations");
                var method = this.conversationId ? "GET" : "POST";
                var body = this.conversationId ? undefined : {
                    user: {
                        id: this.userIdOnStartConversation
                    },
                    locale: this.localeOnStartConversation
                };
                return this.services.ajax({
                    method: method,
                    url: url,
                    body: body,
                    timeout: this.timeout,
                    headers: $f34bed9fe086c89c$var$_objectSpread({
                        "Accept": "application/json",
                        "Content-Type": "application/json"
                    }, this.commonHeaders())
                }) //      .do(ajaxResponse => konsole.log("conversation ajaxResponse", ajaxResponse.response))
                .map(function(ajaxResponse) {
                    return ajaxResponse.response;
                }).retryWhen(function(error$) {
                    return(// for everything else (timeouts), retry for a while
                    error$.mergeMap(function(error) {
                        return error.status >= 400 && error.status < 600 ? $lyDVs.Observable["throw"](error, _this2.services.scheduler) : $lyDVs.Observable.of(error, _this2.services.scheduler);
                    }).delay(_this2.timeout, _this2.services.scheduler).take(_this2.retries));
                });
            }
        },
        {
            key: "refreshTokenLoop",
            value: function refreshTokenLoop() {
                var _this3 = this;
                this.tokenRefreshSubscription = $lyDVs.Observable.interval($f34bed9fe086c89c$var$intervalRefreshToken, this.services.scheduler).flatMap(function(_) {
                    return _this3.refreshToken();
                }).subscribe(function(token) {
                    $f34bed9fe086c89c$var$konsole.log("refreshing token", token, "at", new Date());
                    _this3.token = token;
                });
            }
        },
        {
            key: "refreshToken",
            value: function refreshToken() {
                var _this4 = this;
                return this.checkConnection(true).flatMap(function(_) {
                    return _this4.services.ajax({
                        method: "POST",
                        url: "".concat(_this4.domain, "/tokens/refresh"),
                        timeout: _this4.timeout,
                        headers: $f34bed9fe086c89c$var$_objectSpread({}, _this4.commonHeaders())
                    }).map(function(ajaxResponse) {
                        return ajaxResponse.response.token;
                    }).retryWhen(function(error$) {
                        return error$.mergeMap(function(error) {
                            if (error.status === 403) {
                                // if the token is expired there's no reason to keep trying
                                _this4.expiredToken();
                                return $lyDVs.Observable["throw"](error, _this4.services.scheduler);
                            } else if (error.status === 404) // If the bot is gone, we should stop retrying
                            return $lyDVs.Observable["throw"](error, _this4.services.scheduler);
                            return $lyDVs.Observable.of(error, _this4.services.scheduler);
                        }).delay(_this4.timeout, _this4.services.scheduler).take(_this4.retries);
                    });
                });
            }
        },
        {
            key: "reconnect",
            value: function reconnect(conversation) {
                this.token = conversation.token;
                this.streamUrl = conversation.streamUrl;
                if (this.connectionStatus$.getValue() === $f34bed9fe086c89c$var$ConnectionStatus.ExpiredToken) this.connectionStatus$.next($f34bed9fe086c89c$var$ConnectionStatus.Online);
            }
        },
        {
            key: "end",
            value: function end() {
                if (this.tokenRefreshSubscription) this.tokenRefreshSubscription.unsubscribe();
                try {
                    this.connectionStatus$.next($f34bed9fe086c89c$var$ConnectionStatus.Ended);
                } catch (e) {
                    if (e === $f34bed9fe086c89c$var$errorConversationEnded) return;
                    throw e;
                }
            }
        },
        {
            key: "getSessionId",
            value: function getSessionId() {
                var _this5 = this;
                // If we're not connected to the bot, get connected
                // Will throw an error if we are not connected
                $f34bed9fe086c89c$var$konsole.log("getSessionId");
                return this.checkConnection(true).flatMap(function(_) {
                    return _this5.services.ajax({
                        method: "GET",
                        url: "".concat(_this5.domain, "/session/getsessionid"),
                        withCredentials: true,
                        timeout: _this5.timeout,
                        headers: $f34bed9fe086c89c$var$_objectSpread({
                            "Content-Type": "application/json"
                        }, _this5.commonHeaders())
                    }).map(function(ajaxResponse) {
                        if (ajaxResponse && ajaxResponse.response && ajaxResponse.response.sessionId) {
                            $f34bed9fe086c89c$var$konsole.log("getSessionId response: " + ajaxResponse.response.sessionId);
                            return ajaxResponse.response.sessionId;
                        }
                        return "";
                    })["catch"](function(error) {
                        $f34bed9fe086c89c$var$konsole.log("getSessionId error: " + error.status);
                        return $lyDVs.Observable.of("", _this5.services.scheduler);
                    });
                })["catch"](function(error) {
                    return _this5.catchExpiredToken(error);
                });
            }
        },
        {
            key: "postActivity",
            value: function postActivity(activity) {
                var _this6 = this;
                // If user id is set, check if it match activity.from.id and always override it in activity
                if (this.userIdOnStartConversation && activity.from && activity.from.id !== this.userIdOnStartConversation) {
                    console.warn("DirectLineJS: Activity.from.id does not match with user id, ignoring activity.from.id");
                    activity.from.id = this.userIdOnStartConversation;
                } // Use postMessageWithAttachments for messages with attachments that are local files (e.g. an image to upload)
                // Technically we could use it for *all* activities, but postActivity is much lighter weight
                // So, since WebChat is partially a reference implementation of Direct Line, we implement both.
                if (activity.type === "message" && activity.attachments && activity.attachments.length > 0) return this.postMessageWithAttachments(activity); // If we're not connected to the bot, get connected
                // Will throw an error if we are not connected
                $f34bed9fe086c89c$var$konsole.log("postActivity", activity);
                return this.checkConnection(true).flatMap(function(_) {
                    return _this6.services.ajax({
                        method: "POST",
                        url: "".concat(_this6.domain, "/conversations/").concat(_this6.conversationId, "/activities"),
                        body: activity,
                        timeout: _this6.timeout,
                        headers: $f34bed9fe086c89c$var$_objectSpread({
                            "Content-Type": "application/json"
                        }, _this6.commonHeaders())
                    }).map(function(ajaxResponse) {
                        return ajaxResponse.response.id;
                    })["catch"](function(error) {
                        return _this6.catchPostError(error);
                    });
                })["catch"](function(error) {
                    return _this6.catchExpiredToken(error);
                });
            }
        },
        {
            key: "postMessageWithAttachments",
            value: function postMessageWithAttachments(message) {
                var _this7 = this;
                var attachments = message.attachments; // We clean the attachments but making sure every attachment has unique name.
                // If the file do not have a name, Chrome will assign "blob" when it is appended to FormData.
                var attachmentNames = (0, $f34bed9fe086c89c$var$_dedupeFilenames["default"])(attachments.map(function(media) {
                    return media.name || "blob";
                }));
                var cleansedAttachments = attachments.map(function(attachment, index) {
                    return $f34bed9fe086c89c$var$_objectSpread($f34bed9fe086c89c$var$_objectSpread({}, attachment), {}, {
                        name: attachmentNames[index]
                    });
                });
                var formData; // If we're not connected to the bot, get connected
                // Will throw an error if we are not connected
                return this.checkConnection(true).flatMap(function(_) {
                    // To send this message to DirectLine we need to deconstruct it into a "template" activity
                    // and one blob for each attachment.
                    formData = new FormData();
                    formData.append("activity", new Blob([
                        JSON.stringify($f34bed9fe086c89c$var$_objectSpread($f34bed9fe086c89c$var$_objectSpread({}, message), {}, {
                            // Removing contentUrl from attachment, we will send it via multipart
                            attachments: cleansedAttachments.map(function(_ref) {
                                var string = _ref.contentUrl, others = (0, $f34bed9fe086c89c$var$_objectWithoutProperties2["default"])(_ref, $f34bed9fe086c89c$var$_excluded);
                                return $f34bed9fe086c89c$var$_objectSpread({}, others);
                            })
                        }))
                    ], {
                        type: "application/vnd.microsoft.activity"
                    }));
                    return $lyDVs.Observable.from(cleansedAttachments, _this7.services.scheduler).flatMap(function(media) {
                        return _this7.services.ajax({
                            method: "GET",
                            url: media.contentUrl,
                            responseType: "arraybuffer"
                        })["do"](function(ajaxResponse) {
                            return formData.append("file", new Blob([
                                ajaxResponse.response
                            ], {
                                type: media.contentType
                            }), media.name);
                        });
                    }).count();
                }).flatMap(function(_) {
                    return _this7.services.ajax({
                        method: "POST",
                        url: "".concat(_this7.domain, "/conversations/").concat(_this7.conversationId, "/upload?userId=").concat(message.from.id),
                        body: formData,
                        timeout: _this7.timeout,
                        headers: $f34bed9fe086c89c$var$_objectSpread({}, _this7.commonHeaders())
                    }).map(function(ajaxResponse) {
                        return ajaxResponse.response.id;
                    })["catch"](function(error) {
                        return _this7.catchPostError(error);
                    });
                })["catch"](function(error) {
                    return _this7.catchPostError(error);
                });
            }
        },
        {
            key: "catchPostError",
            value: function catchPostError(error) {
                if (error.status === 403) this.expiredToken();
                else if (error.status >= 400 && error.status < 500) return $lyDVs.Observable["throw"](error, this.services.scheduler);
                return $lyDVs.Observable.of("retry", this.services.scheduler);
            }
        },
        {
            key: "catchExpiredToken",
            value: function catchExpiredToken(error) {
                return error === $f34bed9fe086c89c$var$errorExpiredToken ? $lyDVs.Observable.of("retry", this.services.scheduler) : $lyDVs.Observable["throw"](error, this.services.scheduler);
            }
        },
        {
            key: "pollingGetActivity$",
            value: function pollingGetActivity$() {
                var _this8 = this;
                var poller$ = $lyDVs.Observable.create(function(subscriber) {
                    // A BehaviorSubject to trigger polling. Since it is a BehaviorSubject
                    // the first event is produced immediately.
                    var trigger$ = new $5PS69.BehaviorSubject({}); // TODO: remove Date.now, use reactive interval to space out every request
                    trigger$.subscribe(function() {
                        if (_this8.connectionStatus$.getValue() === $f34bed9fe086c89c$var$ConnectionStatus.Online) {
                            var startTimestamp = Date.now();
                            _this8.services.ajax({
                                headers: $f34bed9fe086c89c$var$_objectSpread({
                                    Accept: "application/json"
                                }, _this8.commonHeaders()),
                                method: "GET",
                                url: "".concat(_this8.domain, "/conversations/").concat(_this8.conversationId, "/activities?watermark=").concat(_this8.watermark),
                                timeout: _this8.timeout
                            }).subscribe(function(result) {
                                subscriber.next(result);
                                setTimeout(function() {
                                    return trigger$.next(null);
                                }, Math.max(0, _this8.pollingInterval - Date.now() + startTimestamp));
                            }, function(error) {
                                switch(error.status){
                                    case 403:
                                        _this8.connectionStatus$.next($f34bed9fe086c89c$var$ConnectionStatus.ExpiredToken);
                                        setTimeout(function() {
                                            return trigger$.next(null);
                                        }, _this8.pollingInterval);
                                        break;
                                    case 404:
                                        _this8.connectionStatus$.next($f34bed9fe086c89c$var$ConnectionStatus.Ended);
                                        break;
                                    default:
                                        // propagate the error
                                        subscriber.error(error);
                                        break;
                                }
                            });
                        }
                    });
                });
                return this.checkConnection().flatMap(function(_) {
                    return poller$["catch"](function() {
                        return $lyDVs.Observable.empty();
                    }).map(function(ajaxResponse) {
                        return ajaxResponse.response;
                    }).flatMap(function(activityGroup) {
                        return _this8.observableFromActivityGroup(activityGroup);
                    });
                });
            }
        },
        {
            key: "observableFromActivityGroup",
            value: function observableFromActivityGroup(activityGroup) {
                if (activityGroup.watermark) this.watermark = activityGroup.watermark;
                return $lyDVs.Observable.from(activityGroup.activities, this.services.scheduler);
            }
        },
        {
            key: "webSocketActivity$",
            value: function webSocketActivity$() {
                var _this9 = this;
                return this.checkConnection().flatMap(function(_) {
                    return _this9.observableWebSocket() // WebSockets can be closed by the server or the browser. In the former case we need to
                    // retrieve a new streamUrl. In the latter case we could first retry with the current streamUrl,
                    // but it's simpler just to always fetch a new one.
                    .retryWhen(function(error$) {
                        return error$.delay(_this9.getRetryDelay(), _this9.services.scheduler).mergeMap(function(error) {
                            return _this9.reconnectToConversation();
                        });
                    });
                }).flatMap(function(activityGroup) {
                    return _this9.observableFromActivityGroup(activityGroup);
                });
            } // Returns the delay duration in milliseconds
        },
        {
            key: "getRetryDelay",
            value: function getRetryDelay() {
                return Math.floor(3000 + this.services.random() * 12000);
            } // Originally we used Observable.webSocket, but it's fairly opinionated and I ended up writing
        },
        {
            key: "observableWebSocket",
            value: function observableWebSocket() {
                var _this10 = this;
                return $lyDVs.Observable.create(function(subscriber) {
                    $f34bed9fe086c89c$var$konsole.log("creating WebSocket", _this10.streamUrl);
                    var ws = new _this10.services.WebSocket(_this10.streamUrl);
                    var sub;
                    var closed;
                    ws.onopen = function(open) {
                        $f34bed9fe086c89c$var$konsole.log("WebSocket open", open); // Chrome is pretty bad at noticing when a WebSocket connection is broken.
                        // If we periodically ping the server with empty messages, it helps Chrome
                        // realize when connection breaks, and close the socket. We then throw an
                        // error, and that give us the opportunity to attempt to reconnect.
                        sub = $lyDVs.Observable.interval(_this10.timeout, _this10.services.scheduler).subscribe(function(_) {
                            try {
                                ws.send("");
                            } catch (e) {
                                $f34bed9fe086c89c$var$konsole.log("Ping error", e);
                            }
                        });
                    };
                    ws.onclose = function(close) {
                        $f34bed9fe086c89c$var$konsole.log("WebSocket close", close);
                        if (sub) sub.unsubscribe(); // RxJS.retryWhen has a bug that would cause "error" signal to be sent after the observable is completed/errored.
                        // We need to guard against extraneous "error" signal to workaround the bug.
                        closed || subscriber.error(close);
                        closed = true;
                    };
                    ws.onerror = function(error) {
                        $f34bed9fe086c89c$var$konsole.log("WebSocket error", error);
                        if (sub) sub.unsubscribe(); // RxJS.retryWhen has a bug that would cause "error" signal to be sent after the observable is completed/errored.
                        // We need to guard against extraneous "error" signal to workaround the bug.
                        closed || subscriber.error(error);
                        closed = true;
                    };
                    ws.onmessage = function(message) {
                        return message.data && subscriber.next(JSON.parse(message.data));
                    }; // This is the 'unsubscribe' method, which is called when this observable is disposed.
                    // When the WebSocket closes itself, we throw an error, and this function is eventually called.
                    // When the observable is closed first (e.g. when tearing down a WebChat instance) then
                    // we need to manually close the WebSocket.
                    return function() {
                        if (ws.readyState === 0 || ws.readyState === 1) ws.close();
                    };
                });
            }
        },
        {
            key: "reconnectToConversation",
            value: function reconnectToConversation() {
                var _this11 = this;
                return this.checkConnection(true).flatMap(function(_) {
                    return _this11.services.ajax({
                        method: "GET",
                        url: "".concat(_this11.domain, "/conversations/").concat(_this11.conversationId, "?watermark=").concat(_this11.watermark),
                        timeout: _this11.timeout,
                        headers: $f34bed9fe086c89c$var$_objectSpread({
                            "Accept": "application/json"
                        }, _this11.commonHeaders())
                    })["do"](function(result) {
                        if (!_this11.secret) _this11.token = result.response.token;
                        _this11.streamUrl = result.response.streamUrl;
                    }).map(function(_) {
                        return null;
                    }).retryWhen(function(error$) {
                        return error$.mergeMap(function(error) {
                            if (error.status === 403) // token has expired. We can't recover from this here, but the embedding
                            // website might eventually call reconnect() with a new token and streamUrl.
                            _this11.expiredToken();
                            else if (error.status === 404) return $lyDVs.Observable["throw"]($f34bed9fe086c89c$var$errorConversationEnded, _this11.services.scheduler);
                            return $lyDVs.Observable.of(error, _this11.services.scheduler);
                        }).delay(_this11.timeout, _this11.services.scheduler).take(_this11.retries);
                    });
                });
            }
        },
        {
            key: "commonHeaders",
            value: function commonHeaders() {
                return {
                    "Authorization": "Bearer ".concat(this.token),
                    "x-ms-bot-agent": this._botAgent
                };
            }
        },
        {
            key: "getBotAgent",
            value: function getBotAgent() {
                var customAgent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
                var clientAgent = "directlinejs";
                if (customAgent) clientAgent += "; ".concat(customAgent);
                return "".concat($f34bed9fe086c89c$var$DIRECT_LINE_VERSION, " (").concat(clientAgent, " ").concat("0.15.4", ")");
            }
        },
        {
            key: "setUserId",
            value: function setUserId(userId) {
                if (this.connectionStatus$.getValue() === $f34bed9fe086c89c$var$ConnectionStatus.Online) throw new Error("DirectLineJS: It is connected, we cannot set user id.");
                var userIdFromToken = this.parseToken(this.token);
                if (userIdFromToken) return console.warn("DirectLineJS: user id is already set in token, will ignore this user id.");
                if (/^dl_/.test(userId)) return console.warn('DirectLineJS: user id prefixed with "dl_" is reserved and must be embedded into the Direct Line token to prevent forgery.');
                this.userIdOnStartConversation = userId;
            }
        },
        {
            key: "parseToken",
            value: function parseToken(token) {
                try {
                    var _ref2 = (0, $f34bed9fe086c89c$var$_jwtDecode["default"])(token), user = _ref2.user;
                    return user;
                } catch (e) {
                    if (e instanceof $f34bed9fe086c89c$var$_jwtDecode.InvalidTokenError) return undefined;
                }
            }
        }
    ]);
    return DirectLine;
}();
module.exports.DirectLine = $f34bed9fe086c89c$var$DirectLine;

});
parcelRequire.register("aJHrF", function(module, exports) {
function $7d0fceb1508f32e0$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
module.exports = $7d0fceb1508f32e0$var$_interopRequireDefault;
module.exports["default"] = module.exports, module.exports.__esModule = true;

});

parcelRequire.register("9FqFu", function(module, exports) {
function $709ca127adce2d32$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
        module.exports = $709ca127adce2d32$var$_typeof = function _typeof(obj) {
            return typeof obj;
        };
        module.exports["default"] = module.exports, module.exports.__esModule = true;
    } else {
        module.exports = $709ca127adce2d32$var$_typeof = function _typeof(obj) {
            return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
        };
        module.exports["default"] = module.exports, module.exports.__esModule = true;
    }
    return $709ca127adce2d32$var$_typeof(obj);
}
module.exports = $709ca127adce2d32$var$_typeof;
module.exports["default"] = module.exports, module.exports.__esModule = true;

});

parcelRequire.register("605Ce", function(module, exports) {

var $6G1DZ = parcelRequire("6G1DZ");
function $45e7194b786a3aa1$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $6G1DZ(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
module.exports = $45e7194b786a3aa1$var$_objectWithoutProperties;
module.exports["default"] = module.exports, module.exports.__esModule = true;

});
parcelRequire.register("6G1DZ", function(module, exports) {
function $4dc7f0c3efb1675a$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
module.exports = $4dc7f0c3efb1675a$var$_objectWithoutPropertiesLoose;
module.exports["default"] = module.exports, module.exports.__esModule = true;

});


parcelRequire.register("hBL3H", function(module, exports) {
function $cd1a653d9fa694b2$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
module.exports = $cd1a653d9fa694b2$var$_classCallCheck;
module.exports["default"] = module.exports, module.exports.__esModule = true;

});

parcelRequire.register("3As53", function(module, exports) {
function $29ca84124a4249df$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $29ca84124a4249df$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $29ca84124a4249df$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $29ca84124a4249df$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
module.exports = $29ca84124a4249df$var$_createClass;
module.exports["default"] = module.exports, module.exports.__esModule = true;

});

parcelRequire.register("eiPwg", function(module, exports) {
function $a69ab5cca9a7b0f5$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
module.exports = $a69ab5cca9a7b0f5$var$_defineProperty;
module.exports["default"] = module.exports, module.exports.__esModule = true;

});

parcelRequire.register("2qCUE", function(module, exports) {

var $ejvTB = parcelRequire("ejvTB");
parcelRequire("lRBuN");
parcelRequire("3Rxse");
parcelRequire("e3Epf");
parcelRequire("cI6e3");
module.exports = $ejvTB;

});
parcelRequire.register("ejvTB", function(module, exports) {
parcelRequire("az5tL");
parcelRequire("fapX4");
parcelRequire("50acP");
parcelRequire("3xPki");
parcelRequire("fsAoq");
parcelRequire("gGk0c");
parcelRequire("mnyEo");
parcelRequire("aPfoN");

var $2urTK = parcelRequire("2urTK");
module.exports = $2urTK.Promise;

});
parcelRequire.register("az5tL", function(module, exports) {
"use strict";

var $gIY7k = parcelRequire("gIY7k");

var $hepN6 = parcelRequire("hepN6");

var $lx7Ao = parcelRequire("lx7Ao");

var $4VFy7 = parcelRequire("4VFy7");

var $36BU0 = parcelRequire("36BU0");

var $1kPdT = parcelRequire("1kPdT");

var $fIOwC = parcelRequire("fIOwC");
var $7b116c4f51fa8f05$var$$AggregateError = function AggregateError(errors, message) {
    var that = this;
    if (!(that instanceof $7b116c4f51fa8f05$var$$AggregateError)) return new $7b116c4f51fa8f05$var$$AggregateError(errors, message);
    if ($lx7Ao) // eslint-disable-next-line unicorn/error-message -- expected
    that = $lx7Ao(new Error(undefined), $hepN6(that));
    if (message !== undefined) $36BU0(that, "message", String(message));
    var errorsArray = [];
    $fIOwC(errors, errorsArray.push, {
        that: errorsArray
    });
    $36BU0(that, "errors", errorsArray);
    return that;
};
$7b116c4f51fa8f05$var$$AggregateError.prototype = $4VFy7(Error.prototype, {
    constructor: $1kPdT(5, $7b116c4f51fa8f05$var$$AggregateError),
    message: $1kPdT(5, ""),
    name: $1kPdT(5, "AggregateError")
});
// `AggregateError` constructor
// https://tc39.es/ecma262/#sec-aggregate-error-constructor
$gIY7k({
    global: true
}, {
    AggregateError: $7b116c4f51fa8f05$var$$AggregateError
});

});
parcelRequire.register("gIY7k", function(module, exports) {

var $aX2nu = parcelRequire("aX2nu");

var $bmwfk = parcelRequire("bmwfk");
var $c2cf63737dd2d4a7$require$getOwnPropertyDescriptor = $bmwfk.f;

var $36BU0 = parcelRequire("36BU0");

var $bRyc4 = parcelRequire("bRyc4");

var $2BSYF = parcelRequire("2BSYF");

var $aIrJb = parcelRequire("aIrJb");

var $isGE5 = parcelRequire("isGE5");
/*
  options.target      - name of the target object
  options.global      - target is the global object
  options.stat        - export as static methods of target
  options.proto       - export as prototype methods of target
  options.real        - real prototype method for the `pure` version
  options.forced      - export even if the native feature is available
  options.bind        - bind methods to the target, required for the `pure` version
  options.wrap        - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe      - use the simple assignment of property instead of delete + defineProperty
  options.sham        - add a flag to not completely full polyfills
  options.enumerable  - export as enumerable property
  options.noTargetGet - prevent calling a getter on target
*/ module.exports = function(options, source) {
    var TARGET = options.target;
    var GLOBAL = options.global;
    var STATIC = options.stat;
    var FORCED, target, key, targetProperty, sourceProperty, descriptor;
    if (GLOBAL) target = $aX2nu;
    else if (STATIC) target = $aX2nu[TARGET] || $2BSYF(TARGET, {});
    else target = ($aX2nu[TARGET] || {}).prototype;
    if (target) for(key in source){
        sourceProperty = source[key];
        if (options.noTargetGet) {
            descriptor = $c2cf63737dd2d4a7$require$getOwnPropertyDescriptor(target, key);
            targetProperty = descriptor && descriptor.value;
        } else targetProperty = target[key];
        FORCED = $isGE5(GLOBAL ? key : TARGET + (STATIC ? "." : "#") + key, options.forced);
        // contained in target
        if (!FORCED && targetProperty !== undefined) {
            if (typeof sourceProperty === typeof targetProperty) continue;
            $aIrJb(sourceProperty, targetProperty);
        }
        // add a flag to not completely full polyfills
        if (options.sham || targetProperty && targetProperty.sham) $36BU0(sourceProperty, "sham", true);
        // extend global
        $bRyc4(target, key, sourceProperty, options);
    }
};

});
parcelRequire.register("aX2nu", function(module, exports) {
var $7f91424a4d7dfd4c$var$check = function(it) {
    return it && it.Math == Math && it;
};
// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
module.exports = // eslint-disable-next-line es/no-global-this -- safe
$7f91424a4d7dfd4c$var$check(typeof globalThis == "object" && globalThis) || $7f91424a4d7dfd4c$var$check(typeof window == "object" && window) || // eslint-disable-next-line no-restricted-globals -- safe
$7f91424a4d7dfd4c$var$check(typeof self == "object" && self) || $7f91424a4d7dfd4c$var$check(typeof $parcel$global == "object" && $parcel$global) || // eslint-disable-next-line no-new-func -- fallback
function() {
    return this;
}() || Function("return this")();

});

parcelRequire.register("bmwfk", function(module, exports) {

$parcel$export(module.exports, "f", () => $845ac33c5daaa93f$export$2d1720544b23b823, (v) => $845ac33c5daaa93f$export$2d1720544b23b823 = v);
// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
var $845ac33c5daaa93f$export$2d1720544b23b823;

var $i87je = parcelRequire("i87je");

var $YGp3s = parcelRequire("YGp3s");

var $1kPdT = parcelRequire("1kPdT");

var $9t6kn = parcelRequire("9t6kn");

var $0pgSE = parcelRequire("0pgSE");

var $2bgoJ = parcelRequire("2bgoJ");

var $24A9J = parcelRequire("24A9J");
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $845ac33c5daaa93f$var$$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
$845ac33c5daaa93f$export$2d1720544b23b823 = $i87je ? $845ac33c5daaa93f$var$$getOwnPropertyDescriptor : function getOwnPropertyDescriptor(O, P) {
    O = $9t6kn(O);
    P = $0pgSE(P, true);
    if ($24A9J) try {
        return $845ac33c5daaa93f$var$$getOwnPropertyDescriptor(O, P);
    } catch (error) {}
    if ($2bgoJ(O, P)) return $1kPdT(!$YGp3s.f.call(O, P), O[P]);
};

});
parcelRequire.register("i87je", function(module, exports) {

var $5tvR9 = parcelRequire("5tvR9");
// Detect IE8's incomplete defineProperty implementation
module.exports = !$5tvR9(function() {
    // eslint-disable-next-line es/no-object-defineproperty -- required for testing
    return Object.defineProperty({}, 1, {
        get: function() {
            return 7;
        }
    })[1] != 7;
});

});
parcelRequire.register("5tvR9", function(module, exports) {
module.exports = function(exec) {
    try {
        return !!exec();
    } catch (error) {
        return true;
    }
};

});


parcelRequire.register("YGp3s", function(module, exports) {

$parcel$export(module.exports, "f", () => $0b667f15d68a6124$export$2d1720544b23b823, (v) => $0b667f15d68a6124$export$2d1720544b23b823 = v);
// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable
var $0b667f15d68a6124$export$2d1720544b23b823;
"use strict";
var $0b667f15d68a6124$var$$propertyIsEnumerable = {}.propertyIsEnumerable;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $0b667f15d68a6124$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
// Nashorn ~ JDK8 bug
var $0b667f15d68a6124$var$NASHORN_BUG = $0b667f15d68a6124$var$getOwnPropertyDescriptor && !$0b667f15d68a6124$var$$propertyIsEnumerable.call({
    1: 2
}, 1);
$0b667f15d68a6124$export$2d1720544b23b823 = $0b667f15d68a6124$var$NASHORN_BUG ? function propertyIsEnumerable(V) {
    var descriptor = $0b667f15d68a6124$var$getOwnPropertyDescriptor(this, V);
    return !!descriptor && descriptor.enumerable;
} : $0b667f15d68a6124$var$$propertyIsEnumerable;

});

parcelRequire.register("1kPdT", function(module, exports) {
module.exports = function(bitmap, value) {
    return {
        enumerable: !(bitmap & 1),
        configurable: !(bitmap & 2),
        writable: !(bitmap & 4),
        value: value
    };
};

});

parcelRequire.register("9t6kn", function(module, exports) {
// toObject with fallback for non-array-like ES3 strings

var $gtqi4 = parcelRequire("gtqi4");

var $9wYyI = parcelRequire("9wYyI");
module.exports = function(it) {
    return $gtqi4($9wYyI(it));
};

});
parcelRequire.register("gtqi4", function(module, exports) {

var $5tvR9 = parcelRequire("5tvR9");

var $7gs7P = parcelRequire("7gs7P");
var $bfe3bf88759aaa82$var$split = "".split;
// fallback for non-array-like ES3 and non-enumerable old V8 strings
module.exports = $5tvR9(function() {
    // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
    // eslint-disable-next-line no-prototype-builtins -- safe
    return !Object("z").propertyIsEnumerable(0);
}) ? function(it) {
    return $7gs7P(it) == "String" ? $bfe3bf88759aaa82$var$split.call(it, "") : Object(it);
} : Object;

});
parcelRequire.register("7gs7P", function(module, exports) {
var $549fd822ca98dce9$var$toString = {}.toString;
module.exports = function(it) {
    return $549fd822ca98dce9$var$toString.call(it).slice(8, -1);
};

});


parcelRequire.register("9wYyI", function(module, exports) {
// `RequireObjectCoercible` abstract operation
// https://tc39.es/ecma262/#sec-requireobjectcoercible
module.exports = function(it) {
    if (it == undefined) throw TypeError("Can't call method on " + it);
    return it;
};

});


parcelRequire.register("0pgSE", function(module, exports) {

var $4Wc10 = parcelRequire("4Wc10");
// `ToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-toprimitive
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function(input, PREFERRED_STRING) {
    if (!$4Wc10(input)) return input;
    var fn, val;
    if (PREFERRED_STRING && typeof (fn = input.toString) == "function" && !$4Wc10(val = fn.call(input))) return val;
    if (typeof (fn = input.valueOf) == "function" && !$4Wc10(val = fn.call(input))) return val;
    if (!PREFERRED_STRING && typeof (fn = input.toString) == "function" && !$4Wc10(val = fn.call(input))) return val;
    throw TypeError("Can't convert object to primitive value");
};

});
parcelRequire.register("4Wc10", function(module, exports) {
module.exports = function(it) {
    return typeof it === "object" ? it !== null : typeof it === "function";
};

});


parcelRequire.register("2bgoJ", function(module, exports) {

var $2gzlL = parcelRequire("2gzlL");
var $1969542117ad5e42$var$hasOwnProperty = {}.hasOwnProperty;
module.exports = Object.hasOwn || function hasOwn(it, key) {
    return $1969542117ad5e42$var$hasOwnProperty.call($2gzlL(it), key);
};

});
parcelRequire.register("2gzlL", function(module, exports) {

var $9wYyI = parcelRequire("9wYyI");
// `ToObject` abstract operation
// https://tc39.es/ecma262/#sec-toobject
module.exports = function(argument) {
    return Object($9wYyI(argument));
};

});


parcelRequire.register("24A9J", function(module, exports) {

var $i87je = parcelRequire("i87je");

var $5tvR9 = parcelRequire("5tvR9");

var $eKRPl = parcelRequire("eKRPl");
// Thank's IE8 for his funny defineProperty
module.exports = !$i87je && !$5tvR9(function() {
    // eslint-disable-next-line es/no-object-defineproperty -- requied for testing
    return Object.defineProperty($eKRPl("div"), "a", {
        get: function() {
            return 7;
        }
    }).a != 7;
});

});
parcelRequire.register("eKRPl", function(module, exports) {

var $aX2nu = parcelRequire("aX2nu");

var $4Wc10 = parcelRequire("4Wc10");
var $abdf1d88a923d180$var$document = $aX2nu.document;
// typeof document.createElement is 'object' in old IE
var $abdf1d88a923d180$var$EXISTS = $4Wc10($abdf1d88a923d180$var$document) && $4Wc10($abdf1d88a923d180$var$document.createElement);
module.exports = function(it) {
    return $abdf1d88a923d180$var$EXISTS ? $abdf1d88a923d180$var$document.createElement(it) : {};
};

});



parcelRequire.register("36BU0", function(module, exports) {

var $i87je = parcelRequire("i87je");

var $5PwwD = parcelRequire("5PwwD");

var $1kPdT = parcelRequire("1kPdT");
module.exports = $i87je ? function(object, key, value) {
    return $5PwwD.f(object, key, $1kPdT(1, value));
} : function(object, key, value) {
    object[key] = value;
    return object;
};

});
parcelRequire.register("5PwwD", function(module, exports) {

$parcel$export(module.exports, "f", () => $43eaf202e50940d7$export$2d1720544b23b823, (v) => $43eaf202e50940d7$export$2d1720544b23b823 = v);
// `Object.defineProperty` method
// https://tc39.es/ecma262/#sec-object.defineproperty
var $43eaf202e50940d7$export$2d1720544b23b823;

var $i87je = parcelRequire("i87je");

var $24A9J = parcelRequire("24A9J");

var $6GFWk = parcelRequire("6GFWk");

var $0pgSE = parcelRequire("0pgSE");
// eslint-disable-next-line es/no-object-defineproperty -- safe
var $43eaf202e50940d7$var$$defineProperty = Object.defineProperty;
$43eaf202e50940d7$export$2d1720544b23b823 = $i87je ? $43eaf202e50940d7$var$$defineProperty : function defineProperty(O, P, Attributes) {
    $6GFWk(O);
    P = $0pgSE(P, true);
    $6GFWk(Attributes);
    if ($24A9J) try {
        return $43eaf202e50940d7$var$$defineProperty(O, P, Attributes);
    } catch (error) {}
    if ("get" in Attributes || "set" in Attributes) throw TypeError("Accessors not supported");
    if ("value" in Attributes) O[P] = Attributes.value;
    return O;
};

});
parcelRequire.register("6GFWk", function(module, exports) {

var $4Wc10 = parcelRequire("4Wc10");
module.exports = function(it) {
    if (!$4Wc10(it)) throw TypeError(String(it) + " is not an object");
    return it;
};

});



parcelRequire.register("bRyc4", function(module, exports) {

var $aX2nu = parcelRequire("aX2nu");

var $36BU0 = parcelRequire("36BU0");

var $2bgoJ = parcelRequire("2bgoJ");

var $2BSYF = parcelRequire("2BSYF");

var $jLr6u = parcelRequire("jLr6u");

var $4rhVl = parcelRequire("4rhVl");
var $8a2f2b1ff582ef48$var$getInternalState = $4rhVl.get;
var $8a2f2b1ff582ef48$var$enforceInternalState = $4rhVl.enforce;
var $8a2f2b1ff582ef48$var$TEMPLATE = String(String).split("String");
(module.exports = function(O, key, value, options) {
    var unsafe = options ? !!options.unsafe : false;
    var simple = options ? !!options.enumerable : false;
    var noTargetGet = options ? !!options.noTargetGet : false;
    var state;
    if (typeof value == "function") {
        if (typeof key == "string" && !$2bgoJ(value, "name")) $36BU0(value, "name", key);
        state = $8a2f2b1ff582ef48$var$enforceInternalState(value);
        if (!state.source) state.source = $8a2f2b1ff582ef48$var$TEMPLATE.join(typeof key == "string" ? key : "");
    }
    if (O === $aX2nu) {
        if (simple) O[key] = value;
        else $2BSYF(key, value);
        return;
    } else if (!unsafe) delete O[key];
    else if (!noTargetGet && O[key]) simple = true;
    if (simple) O[key] = value;
    else $36BU0(O, key, value);
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
})(Function.prototype, "toString", function toString() {
    return typeof this == "function" && $8a2f2b1ff582ef48$var$getInternalState(this).source || $jLr6u(this);
});

});
parcelRequire.register("2BSYF", function(module, exports) {

var $aX2nu = parcelRequire("aX2nu");

var $36BU0 = parcelRequire("36BU0");
module.exports = function(key, value) {
    try {
        $36BU0($aX2nu, key, value);
    } catch (error) {
        $aX2nu[key] = value;
    }
    return value;
};

});

parcelRequire.register("jLr6u", function(module, exports) {

var $8eLLK = parcelRequire("8eLLK");
var $e6376e4f5442c8ee$var$functionToString = Function.toString;
// this helper broken in `core-js@3.4.1-3.4.4`, so we can't use `shared` helper
if (typeof $8eLLK.inspectSource != "function") $8eLLK.inspectSource = function(it) {
    return $e6376e4f5442c8ee$var$functionToString.call(it);
};
module.exports = $8eLLK.inspectSource;

});
parcelRequire.register("8eLLK", function(module, exports) {

var $aX2nu = parcelRequire("aX2nu");

var $2BSYF = parcelRequire("2BSYF");
var $5ff4af802a530b49$var$SHARED = "__core-js_shared__";
var $5ff4af802a530b49$var$store = $aX2nu[$5ff4af802a530b49$var$SHARED] || $2BSYF($5ff4af802a530b49$var$SHARED, {});
module.exports = $5ff4af802a530b49$var$store;

});


parcelRequire.register("4rhVl", function(module, exports) {

var $bMQQ9 = parcelRequire("bMQQ9");

var $aX2nu = parcelRequire("aX2nu");

var $4Wc10 = parcelRequire("4Wc10");

var $36BU0 = parcelRequire("36BU0");

var $2bgoJ = parcelRequire("2bgoJ");

var $8eLLK = parcelRequire("8eLLK");

var $7Iygj = parcelRequire("7Iygj");

var $lbF9W = parcelRequire("lbF9W");
var $33b7965c99fac593$var$OBJECT_ALREADY_INITIALIZED = "Object already initialized";
var $33b7965c99fac593$var$WeakMap = $aX2nu.WeakMap;
var $33b7965c99fac593$var$set, $33b7965c99fac593$var$get, $33b7965c99fac593$var$has;
var $33b7965c99fac593$var$enforce = function(it) {
    return $33b7965c99fac593$var$has(it) ? $33b7965c99fac593$var$get(it) : $33b7965c99fac593$var$set(it, {});
};
var $33b7965c99fac593$var$getterFor = function(TYPE) {
    return function(it) {
        var state;
        if (!$4Wc10(it) || (state = $33b7965c99fac593$var$get(it)).type !== TYPE) throw TypeError("Incompatible receiver, " + TYPE + " required");
        return state;
    };
};
if ($bMQQ9 || $8eLLK.state) {
    var $33b7965c99fac593$var$store = $8eLLK.state || ($8eLLK.state = new $33b7965c99fac593$var$WeakMap());
    var $33b7965c99fac593$var$wmget = $33b7965c99fac593$var$store.get;
    var $33b7965c99fac593$var$wmhas = $33b7965c99fac593$var$store.has;
    var $33b7965c99fac593$var$wmset = $33b7965c99fac593$var$store.set;
    $33b7965c99fac593$var$set = function(it, metadata) {
        if ($33b7965c99fac593$var$wmhas.call($33b7965c99fac593$var$store, it)) throw new TypeError($33b7965c99fac593$var$OBJECT_ALREADY_INITIALIZED);
        metadata.facade = it;
        $33b7965c99fac593$var$wmset.call($33b7965c99fac593$var$store, it, metadata);
        return metadata;
    };
    $33b7965c99fac593$var$get = function(it) {
        return $33b7965c99fac593$var$wmget.call($33b7965c99fac593$var$store, it) || {};
    };
    $33b7965c99fac593$var$has = function(it) {
        return $33b7965c99fac593$var$wmhas.call($33b7965c99fac593$var$store, it);
    };
} else {
    var $33b7965c99fac593$var$STATE = $7Iygj("state");
    $lbF9W[$33b7965c99fac593$var$STATE] = true;
    $33b7965c99fac593$var$set = function(it, metadata) {
        if ($2bgoJ(it, $33b7965c99fac593$var$STATE)) throw new TypeError($33b7965c99fac593$var$OBJECT_ALREADY_INITIALIZED);
        metadata.facade = it;
        $36BU0(it, $33b7965c99fac593$var$STATE, metadata);
        return metadata;
    };
    $33b7965c99fac593$var$get = function(it) {
        return $2bgoJ(it, $33b7965c99fac593$var$STATE) ? it[$33b7965c99fac593$var$STATE] : {};
    };
    $33b7965c99fac593$var$has = function(it) {
        return $2bgoJ(it, $33b7965c99fac593$var$STATE);
    };
}
module.exports = {
    set: $33b7965c99fac593$var$set,
    get: $33b7965c99fac593$var$get,
    has: $33b7965c99fac593$var$has,
    enforce: $33b7965c99fac593$var$enforce,
    getterFor: $33b7965c99fac593$var$getterFor
};

});
parcelRequire.register("bMQQ9", function(module, exports) {

var $aX2nu = parcelRequire("aX2nu");

var $jLr6u = parcelRequire("jLr6u");
var $894d2a565634613f$var$WeakMap = $aX2nu.WeakMap;
module.exports = typeof $894d2a565634613f$var$WeakMap === "function" && /native code/.test($jLr6u($894d2a565634613f$var$WeakMap));

});

parcelRequire.register("7Iygj", function(module, exports) {

var $jaOqH = parcelRequire("jaOqH");

var $fDKlG = parcelRequire("fDKlG");
var $59e73833deb3fa29$var$keys = $jaOqH("keys");
module.exports = function(key) {
    return $59e73833deb3fa29$var$keys[key] || ($59e73833deb3fa29$var$keys[key] = $fDKlG(key));
};

});
parcelRequire.register("jaOqH", function(module, exports) {

var $dc67Q = parcelRequire("dc67Q");

var $8eLLK = parcelRequire("8eLLK");
(module.exports = function(key, value) {
    return $8eLLK[key] || ($8eLLK[key] = value !== undefined ? value : {});
})("versions", []).push({
    version: "3.15.2",
    mode: $dc67Q ? "pure" : "global",
    copyright: "\xa9 2021 Denis Pushkarev (zloirock.ru)"
});

});
parcelRequire.register("dc67Q", function(module, exports) {
module.exports = false;

});


parcelRequire.register("fDKlG", function(module, exports) {
var $b62e73722d7b332b$var$id = 0;
var $b62e73722d7b332b$var$postfix = Math.random();
module.exports = function(key) {
    return "Symbol(" + String(key === undefined ? "" : key) + ")_" + (++$b62e73722d7b332b$var$id + $b62e73722d7b332b$var$postfix).toString(36);
};

});


parcelRequire.register("lbF9W", function(module, exports) {
module.exports = {};

});



parcelRequire.register("aIrJb", function(module, exports) {

var $2bgoJ = parcelRequire("2bgoJ");

var $5moak = parcelRequire("5moak");

var $bmwfk = parcelRequire("bmwfk");

var $5PwwD = parcelRequire("5PwwD");
module.exports = function(target, source) {
    var keys = $5moak(source);
    var defineProperty = $5PwwD.f;
    var getOwnPropertyDescriptor = $bmwfk.f;
    for(var i = 0; i < keys.length; i++){
        var key = keys[i];
        if (!$2bgoJ(target, key)) defineProperty(target, key, getOwnPropertyDescriptor(source, key));
    }
};

});
parcelRequire.register("5moak", function(module, exports) {

var $90wQL = parcelRequire("90wQL");

var $ibTDr = parcelRequire("ibTDr");

var $38hxU = parcelRequire("38hxU");

var $6GFWk = parcelRequire("6GFWk");
// all object keys, includes non-enumerable and symbols
module.exports = $90wQL("Reflect", "ownKeys") || function ownKeys(it) {
    var keys = $ibTDr.f($6GFWk(it));
    var getOwnPropertySymbols = $38hxU.f;
    return getOwnPropertySymbols ? keys.concat(getOwnPropertySymbols(it)) : keys;
};

});
parcelRequire.register("90wQL", function(module, exports) {

var $2urTK = parcelRequire("2urTK");

var $aX2nu = parcelRequire("aX2nu");
var $68ed9876b321a56b$var$aFunction = function(variable) {
    return typeof variable == "function" ? variable : undefined;
};
module.exports = function(namespace, method) {
    return arguments.length < 2 ? $68ed9876b321a56b$var$aFunction($2urTK[namespace]) || $68ed9876b321a56b$var$aFunction($aX2nu[namespace]) : $2urTK[namespace] && $2urTK[namespace][method] || $aX2nu[namespace] && $aX2nu[namespace][method];
};

});
parcelRequire.register("2urTK", function(module, exports) {

var $aX2nu = parcelRequire("aX2nu");
module.exports = $aX2nu;

});


parcelRequire.register("ibTDr", function(module, exports) {

$parcel$export(module.exports, "f", () => $d3e4690b56e410ce$export$2d1720544b23b823, (v) => $d3e4690b56e410ce$export$2d1720544b23b823 = v);
// `Object.getOwnPropertyNames` method
// https://tc39.es/ecma262/#sec-object.getownpropertynames
// eslint-disable-next-line es/no-object-getownpropertynames -- safe
var $d3e4690b56e410ce$export$2d1720544b23b823;

var $jhVya = parcelRequire("jhVya");

var $a7cEg = parcelRequire("a7cEg");
var $d3e4690b56e410ce$var$hiddenKeys = $a7cEg.concat("length", "prototype");
$d3e4690b56e410ce$export$2d1720544b23b823 = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
    return $jhVya(O, $d3e4690b56e410ce$var$hiddenKeys);
};

});
parcelRequire.register("jhVya", function(module, exports) {

var $2bgoJ = parcelRequire("2bgoJ");

var $9t6kn = parcelRequire("9t6kn");

var $i8yYF = parcelRequire("i8yYF");
var $e0ac3f19a0f5aa94$require$indexOf = $i8yYF.indexOf;

var $lbF9W = parcelRequire("lbF9W");
module.exports = function(object, names) {
    var O = $9t6kn(object);
    var i = 0;
    var result = [];
    var key;
    for(key in O)!$2bgoJ($lbF9W, key) && $2bgoJ(O, key) && result.push(key);
    // Don't enum bug & hidden keys
    while(names.length > i)if ($2bgoJ(O, key = names[i++])) ~$e0ac3f19a0f5aa94$require$indexOf(result, key) || result.push(key);
    return result;
};

});
parcelRequire.register("i8yYF", function(module, exports) {

var $9t6kn = parcelRequire("9t6kn");

var $ek0pp = parcelRequire("ek0pp");

var $cq14h = parcelRequire("cq14h");
// `Array.prototype.{ indexOf, includes }` methods implementation
var $d3441b2a40e63b91$var$createMethod = function(IS_INCLUDES) {
    return function($this, el, fromIndex) {
        var O = $9t6kn($this);
        var length = $ek0pp(O.length);
        var index = $cq14h(fromIndex, length);
        var value;
        // Array#includes uses SameValueZero equality algorithm
        // eslint-disable-next-line no-self-compare -- NaN check
        if (IS_INCLUDES && el != el) while(length > index){
            value = O[index++];
            // eslint-disable-next-line no-self-compare -- NaN check
            if (value != value) return true;
        // Array#indexOf ignores holes, Array#includes - not
        }
        else for(; length > index; index++){
            if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
        }
        return !IS_INCLUDES && -1;
    };
};
module.exports = {
    // `Array.prototype.includes` method
    // https://tc39.es/ecma262/#sec-array.prototype.includes
    includes: $d3441b2a40e63b91$var$createMethod(true),
    // `Array.prototype.indexOf` method
    // https://tc39.es/ecma262/#sec-array.prototype.indexof
    indexOf: $d3441b2a40e63b91$var$createMethod(false)
};

});
parcelRequire.register("ek0pp", function(module, exports) {

var $cLwdg = parcelRequire("cLwdg");
var $a6d34023d0410538$var$min = Math.min;
// `ToLength` abstract operation
// https://tc39.es/ecma262/#sec-tolength
module.exports = function(argument) {
    return argument > 0 ? $a6d34023d0410538$var$min($cLwdg(argument), 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};

});
parcelRequire.register("cLwdg", function(module, exports) {
var $94b2dca9cb56ec02$var$ceil = Math.ceil;
var $94b2dca9cb56ec02$var$floor = Math.floor;
// `ToInteger` abstract operation
// https://tc39.es/ecma262/#sec-tointeger
module.exports = function(argument) {
    return isNaN(argument = +argument) ? 0 : (argument > 0 ? $94b2dca9cb56ec02$var$floor : $94b2dca9cb56ec02$var$ceil)(argument);
};

});


parcelRequire.register("cq14h", function(module, exports) {

var $cLwdg = parcelRequire("cLwdg");
var $02554d626cd53570$var$max = Math.max;
var $02554d626cd53570$var$min = Math.min;
// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
module.exports = function(index, length) {
    var integer = $cLwdg(index);
    return integer < 0 ? $02554d626cd53570$var$max(integer + length, 0) : $02554d626cd53570$var$min(integer, length);
};

});



parcelRequire.register("a7cEg", function(module, exports) {
// IE8- don't enum bug keys
module.exports = [
    "constructor",
    "hasOwnProperty",
    "isPrototypeOf",
    "propertyIsEnumerable",
    "toLocaleString",
    "toString",
    "valueOf"
];

});


parcelRequire.register("38hxU", function(module, exports) {

$parcel$export(module.exports, "f", () => $247fbab1c15752f6$export$2d1720544b23b823, (v) => $247fbab1c15752f6$export$2d1720544b23b823 = v);
// eslint-disable-next-line es/no-object-getownpropertysymbols -- safe
var $247fbab1c15752f6$export$2d1720544b23b823;
$247fbab1c15752f6$export$2d1720544b23b823 = Object.getOwnPropertySymbols;

});



parcelRequire.register("isGE5", function(module, exports) {

var $5tvR9 = parcelRequire("5tvR9");
var $d70bec100bb6480b$var$replacement = /#|\.prototype\./;
var $d70bec100bb6480b$var$isForced = function(feature, detection) {
    var value = $d70bec100bb6480b$var$data[$d70bec100bb6480b$var$normalize(feature)];
    return value == $d70bec100bb6480b$var$POLYFILL ? true : value == $d70bec100bb6480b$var$NATIVE ? false : typeof detection == "function" ? $5tvR9(detection) : !!detection;
};
var $d70bec100bb6480b$var$normalize = $d70bec100bb6480b$var$isForced.normalize = function(string) {
    return String(string).replace($d70bec100bb6480b$var$replacement, ".").toLowerCase();
};
var $d70bec100bb6480b$var$data = $d70bec100bb6480b$var$isForced.data = {};
var $d70bec100bb6480b$var$NATIVE = $d70bec100bb6480b$var$isForced.NATIVE = "N";
var $d70bec100bb6480b$var$POLYFILL = $d70bec100bb6480b$var$isForced.POLYFILL = "P";
module.exports = $d70bec100bb6480b$var$isForced;

});


parcelRequire.register("hepN6", function(module, exports) {

var $2bgoJ = parcelRequire("2bgoJ");

var $2gzlL = parcelRequire("2gzlL");

var $7Iygj = parcelRequire("7Iygj");

var $a6wgH = parcelRequire("a6wgH");
var $c8b7c00cc7e18772$var$IE_PROTO = $7Iygj("IE_PROTO");
var $c8b7c00cc7e18772$var$ObjectPrototype = Object.prototype;
// `Object.getPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.getprototypeof
// eslint-disable-next-line es/no-object-getprototypeof -- safe
module.exports = $a6wgH ? Object.getPrototypeOf : function(O) {
    O = $2gzlL(O);
    if ($2bgoJ(O, $c8b7c00cc7e18772$var$IE_PROTO)) return O[$c8b7c00cc7e18772$var$IE_PROTO];
    if (typeof O.constructor == "function" && O instanceof O.constructor) return O.constructor.prototype;
    return O instanceof Object ? $c8b7c00cc7e18772$var$ObjectPrototype : null;
};

});
parcelRequire.register("a6wgH", function(module, exports) {

var $5tvR9 = parcelRequire("5tvR9");
module.exports = !$5tvR9(function() {
    function F() {}
    F.prototype.constructor = null;
    // eslint-disable-next-line es/no-object-getprototypeof -- required for testing
    return Object.getPrototypeOf(new F()) !== F.prototype;
});

});


parcelRequire.register("lx7Ao", function(module, exports) {
/* eslint-disable no-proto -- safe */ 
var $6GFWk = parcelRequire("6GFWk");

var $hsNsX = parcelRequire("hsNsX");
// `Object.setPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.setprototypeof
// Works with __proto__ only. Old v8 can't work with null proto objects.
// eslint-disable-next-line es/no-object-setprototypeof -- safe
module.exports = Object.setPrototypeOf || ("__proto__" in {} ? function() {
    var CORRECT_SETTER = false;
    var test = {};
    var setter;
    try {
        // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
        setter = Object.getOwnPropertyDescriptor(Object.prototype, "__proto__").set;
        setter.call(test, []);
        CORRECT_SETTER = test instanceof Array;
    } catch (error) {}
    return function setPrototypeOf(O, proto) {
        $6GFWk(O);
        $hsNsX(proto);
        if (CORRECT_SETTER) setter.call(O, proto);
        else O.__proto__ = proto;
        return O;
    };
}() : undefined);

});
parcelRequire.register("hsNsX", function(module, exports) {

var $4Wc10 = parcelRequire("4Wc10");
module.exports = function(it) {
    if (!$4Wc10(it) && it !== null) throw TypeError("Can't set " + String(it) + " as a prototype");
    return it;
};

});


parcelRequire.register("4VFy7", function(module, exports) {

var $6GFWk = parcelRequire("6GFWk");

var $24bQz = parcelRequire("24bQz");

var $a7cEg = parcelRequire("a7cEg");

var $lbF9W = parcelRequire("lbF9W");

var $9DpJO = parcelRequire("9DpJO");

var $eKRPl = parcelRequire("eKRPl");

var $7Iygj = parcelRequire("7Iygj");
var $396cb7215d8ad54d$var$GT = ">";
var $396cb7215d8ad54d$var$LT = "<";
var $396cb7215d8ad54d$var$PROTOTYPE = "prototype";
var $396cb7215d8ad54d$var$SCRIPT = "script";
var $396cb7215d8ad54d$var$IE_PROTO = $7Iygj("IE_PROTO");
var $396cb7215d8ad54d$var$EmptyConstructor = function() {};
var $396cb7215d8ad54d$var$scriptTag = function(content) {
    return $396cb7215d8ad54d$var$LT + $396cb7215d8ad54d$var$SCRIPT + $396cb7215d8ad54d$var$GT + content + $396cb7215d8ad54d$var$LT + "/" + $396cb7215d8ad54d$var$SCRIPT + $396cb7215d8ad54d$var$GT;
};
// Create object with fake `null` prototype: use ActiveX Object with cleared prototype
var $396cb7215d8ad54d$var$NullProtoObjectViaActiveX = function(activeXDocument) {
    activeXDocument.write($396cb7215d8ad54d$var$scriptTag(""));
    activeXDocument.close();
    var temp = activeXDocument.parentWindow.Object;
    activeXDocument = null; // avoid memory leak
    return temp;
};
// Create object with fake `null` prototype: use iframe Object with cleared prototype
var $396cb7215d8ad54d$var$NullProtoObjectViaIFrame = function() {
    // Thrash, waste and sodomy: IE GC bug
    var iframe = $eKRPl("iframe");
    var JS = "java" + $396cb7215d8ad54d$var$SCRIPT + ":";
    var iframeDocument;
    iframe.style.display = "none";
    $9DpJO.appendChild(iframe);
    // https://github.com/zloirock/core-js/issues/475
    iframe.src = String(JS);
    iframeDocument = iframe.contentWindow.document;
    iframeDocument.open();
    iframeDocument.write($396cb7215d8ad54d$var$scriptTag("document.F=Object"));
    iframeDocument.close();
    return iframeDocument.F;
};
// Check for document.domain and active x support
// No need to use active x approach when document.domain is not set
// see https://github.com/es-shims/es5-shim/issues/150
// variation of https://github.com/kitcambridge/es5-shim/commit/4f738ac066346
// avoid IE GC bug
var $396cb7215d8ad54d$var$activeXDocument;
var $396cb7215d8ad54d$var$NullProtoObject = function() {
    try {
        /* global ActiveXObject -- old IE */ $396cb7215d8ad54d$var$activeXDocument = document.domain && new ActiveXObject("htmlfile");
    } catch (error) {}
    $396cb7215d8ad54d$var$NullProtoObject = $396cb7215d8ad54d$var$activeXDocument ? $396cb7215d8ad54d$var$NullProtoObjectViaActiveX($396cb7215d8ad54d$var$activeXDocument) : $396cb7215d8ad54d$var$NullProtoObjectViaIFrame();
    var length = $a7cEg.length;
    while(length--)delete $396cb7215d8ad54d$var$NullProtoObject[$396cb7215d8ad54d$var$PROTOTYPE][$a7cEg[length]];
    return $396cb7215d8ad54d$var$NullProtoObject();
};
$lbF9W[$396cb7215d8ad54d$var$IE_PROTO] = true;
// `Object.create` method
// https://tc39.es/ecma262/#sec-object.create
module.exports = Object.create || function create(O, Properties) {
    var result;
    if (O !== null) {
        $396cb7215d8ad54d$var$EmptyConstructor[$396cb7215d8ad54d$var$PROTOTYPE] = $6GFWk(O);
        result = new $396cb7215d8ad54d$var$EmptyConstructor();
        $396cb7215d8ad54d$var$EmptyConstructor[$396cb7215d8ad54d$var$PROTOTYPE] = null;
        // add "__proto__" for Object.getPrototypeOf polyfill
        result[$396cb7215d8ad54d$var$IE_PROTO] = O;
    } else result = $396cb7215d8ad54d$var$NullProtoObject();
    return Properties === undefined ? result : $24bQz(result, Properties);
};

});
parcelRequire.register("24bQz", function(module, exports) {

var $i87je = parcelRequire("i87je");

var $5PwwD = parcelRequire("5PwwD");

var $6GFWk = parcelRequire("6GFWk");

var $i8aqr = parcelRequire("i8aqr");
// `Object.defineProperties` method
// https://tc39.es/ecma262/#sec-object.defineproperties
// eslint-disable-next-line es/no-object-defineproperties -- safe
module.exports = $i87je ? Object.defineProperties : function defineProperties(O, Properties) {
    $6GFWk(O);
    var keys = $i8aqr(Properties);
    var length = keys.length;
    var index = 0;
    var key;
    while(length > index)$5PwwD.f(O, key = keys[index++], Properties[key]);
    return O;
};

});
parcelRequire.register("i8aqr", function(module, exports) {

var $jhVya = parcelRequire("jhVya");

var $a7cEg = parcelRequire("a7cEg");
// `Object.keys` method
// https://tc39.es/ecma262/#sec-object.keys
// eslint-disable-next-line es/no-object-keys -- safe
module.exports = Object.keys || function keys(O) {
    return $jhVya(O, $a7cEg);
};

});


parcelRequire.register("9DpJO", function(module, exports) {

var $90wQL = parcelRequire("90wQL");
module.exports = $90wQL("document", "documentElement");

});


parcelRequire.register("fIOwC", function(module, exports) {

var $6GFWk = parcelRequire("6GFWk");

var $jFDVa = parcelRequire("jFDVa");

var $ek0pp = parcelRequire("ek0pp");

var $hhrzn = parcelRequire("hhrzn");

var $2cbHS = parcelRequire("2cbHS");

var $jgLaP = parcelRequire("jgLaP");
var $b72228516f4966b9$var$Result = function(stopped, result) {
    this.stopped = stopped;
    this.result = result;
};
module.exports = function(iterable, unboundFunction, options) {
    var that = options && options.that;
    var AS_ENTRIES = !!(options && options.AS_ENTRIES);
    var IS_ITERATOR = !!(options && options.IS_ITERATOR);
    var INTERRUPTED = !!(options && options.INTERRUPTED);
    var fn = $hhrzn(unboundFunction, that, 1 + AS_ENTRIES + INTERRUPTED);
    var iterator, iterFn, index, length, result, next, step;
    var stop = function(condition) {
        if (iterator) $jgLaP(iterator);
        return new $b72228516f4966b9$var$Result(true, condition);
    };
    var callFn = function(value) {
        if (AS_ENTRIES) {
            $6GFWk(value);
            return INTERRUPTED ? fn(value[0], value[1], stop) : fn(value[0], value[1]);
        }
        return INTERRUPTED ? fn(value, stop) : fn(value);
    };
    if (IS_ITERATOR) iterator = iterable;
    else {
        iterFn = $2cbHS(iterable);
        if (typeof iterFn != "function") throw TypeError("Target is not iterable");
        // optimisation for array iterators
        if ($jFDVa(iterFn)) {
            for(index = 0, length = $ek0pp(iterable.length); length > index; index++){
                result = callFn(iterable[index]);
                if (result && result instanceof $b72228516f4966b9$var$Result) return result;
            }
            return new $b72228516f4966b9$var$Result(false);
        }
        iterator = iterFn.call(iterable);
    }
    next = iterator.next;
    while(!(step = next.call(iterator)).done){
        try {
            result = callFn(step.value);
        } catch (error) {
            $jgLaP(iterator);
            throw error;
        }
        if (typeof result == "object" && result && result instanceof $b72228516f4966b9$var$Result) return result;
    }
    return new $b72228516f4966b9$var$Result(false);
};

});
parcelRequire.register("jFDVa", function(module, exports) {

var $5BzAB = parcelRequire("5BzAB");

var $jDDJq = parcelRequire("jDDJq");
var $e520d024f8a24027$var$ITERATOR = $5BzAB("iterator");
var $e520d024f8a24027$var$ArrayPrototype = Array.prototype;
// check on default Array iterator
module.exports = function(it) {
    return it !== undefined && ($jDDJq.Array === it || $e520d024f8a24027$var$ArrayPrototype[$e520d024f8a24027$var$ITERATOR] === it);
};

});
parcelRequire.register("5BzAB", function(module, exports) {

var $aX2nu = parcelRequire("aX2nu");

var $jaOqH = parcelRequire("jaOqH");

var $2bgoJ = parcelRequire("2bgoJ");

var $fDKlG = parcelRequire("fDKlG");

var $bLQ4x = parcelRequire("bLQ4x");

var $9L8NF = parcelRequire("9L8NF");
var $414c03be0139b304$var$WellKnownSymbolsStore = $jaOqH("wks");
var $414c03be0139b304$var$Symbol = $aX2nu.Symbol;
var $414c03be0139b304$var$createWellKnownSymbol = $9L8NF ? $414c03be0139b304$var$Symbol : $414c03be0139b304$var$Symbol && $414c03be0139b304$var$Symbol.withoutSetter || $fDKlG;
module.exports = function(name) {
    if (!$2bgoJ($414c03be0139b304$var$WellKnownSymbolsStore, name) || !($bLQ4x || typeof $414c03be0139b304$var$WellKnownSymbolsStore[name] == "string")) {
        if ($bLQ4x && $2bgoJ($414c03be0139b304$var$Symbol, name)) $414c03be0139b304$var$WellKnownSymbolsStore[name] = $414c03be0139b304$var$Symbol[name];
        else $414c03be0139b304$var$WellKnownSymbolsStore[name] = $414c03be0139b304$var$createWellKnownSymbol("Symbol." + name);
    }
    return $414c03be0139b304$var$WellKnownSymbolsStore[name];
};

});
parcelRequire.register("bLQ4x", function(module, exports) {
/* eslint-disable es/no-symbol -- required for testing */ 
var $4Ishw = parcelRequire("4Ishw");

var $5tvR9 = parcelRequire("5tvR9");
// eslint-disable-next-line es/no-object-getownpropertysymbols -- required for testing
module.exports = !!Object.getOwnPropertySymbols && !$5tvR9(function() {
    var symbol = Symbol();
    // Chrome 38 Symbol has incorrect toString conversion
    // `get-own-property-symbols` polyfill symbols converted to object are not Symbol instances
    return !String(symbol) || !(Object(symbol) instanceof Symbol) || // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
    !Symbol.sham && $4Ishw && $4Ishw < 41;
});

});
parcelRequire.register("4Ishw", function(module, exports) {

var $aX2nu = parcelRequire("aX2nu");

var $fM28n = parcelRequire("fM28n");
var $36f135a0c1137e9d$var$process = $aX2nu.process;
var $36f135a0c1137e9d$var$versions = $36f135a0c1137e9d$var$process && $36f135a0c1137e9d$var$process.versions;
var $36f135a0c1137e9d$var$v8 = $36f135a0c1137e9d$var$versions && $36f135a0c1137e9d$var$versions.v8;
var $36f135a0c1137e9d$var$match, $36f135a0c1137e9d$var$version;
if ($36f135a0c1137e9d$var$v8) {
    $36f135a0c1137e9d$var$match = $36f135a0c1137e9d$var$v8.split(".");
    $36f135a0c1137e9d$var$version = $36f135a0c1137e9d$var$match[0] < 4 ? 1 : $36f135a0c1137e9d$var$match[0] + $36f135a0c1137e9d$var$match[1];
} else if ($fM28n) {
    $36f135a0c1137e9d$var$match = $fM28n.match(/Edge\/(\d+)/);
    if (!$36f135a0c1137e9d$var$match || $36f135a0c1137e9d$var$match[1] >= 74) {
        $36f135a0c1137e9d$var$match = $fM28n.match(/Chrome\/(\d+)/);
        if ($36f135a0c1137e9d$var$match) $36f135a0c1137e9d$var$version = $36f135a0c1137e9d$var$match[1];
    }
}
module.exports = $36f135a0c1137e9d$var$version && +$36f135a0c1137e9d$var$version;

});
parcelRequire.register("fM28n", function(module, exports) {

var $90wQL = parcelRequire("90wQL");
module.exports = $90wQL("navigator", "userAgent") || "";

});



parcelRequire.register("9L8NF", function(module, exports) {
/* eslint-disable es/no-symbol -- required for testing */ 
var $bLQ4x = parcelRequire("bLQ4x");
module.exports = $bLQ4x && !Symbol.sham && typeof Symbol.iterator == "symbol";

});


parcelRequire.register("jDDJq", function(module, exports) {
module.exports = {};

});


parcelRequire.register("hhrzn", function(module, exports) {

var $belfi = parcelRequire("belfi");
// optional / simple context binding
module.exports = function(fn, that, length) {
    $belfi(fn);
    if (that === undefined) return fn;
    switch(length){
        case 0:
            return function() {
                return fn.call(that);
            };
        case 1:
            return function(a) {
                return fn.call(that, a);
            };
        case 2:
            return function(a, b) {
                return fn.call(that, a, b);
            };
        case 3:
            return function(a, b, c) {
                return fn.call(that, a, b, c);
            };
    }
    return function() {
        return fn.apply(that, arguments);
    };
};

});
parcelRequire.register("belfi", function(module, exports) {
module.exports = function(it) {
    if (typeof it != "function") throw TypeError(String(it) + " is not a function");
    return it;
};

});


parcelRequire.register("2cbHS", function(module, exports) {

var $6u9pX = parcelRequire("6u9pX");

var $jDDJq = parcelRequire("jDDJq");

var $5BzAB = parcelRequire("5BzAB");
var $1995c8799c5892e9$var$ITERATOR = $5BzAB("iterator");
module.exports = function(it) {
    if (it != undefined) return it[$1995c8799c5892e9$var$ITERATOR] || it["@@iterator"] || $jDDJq[$6u9pX(it)];
};

});
parcelRequire.register("6u9pX", function(module, exports) {

var $9rNN7 = parcelRequire("9rNN7");

var $7gs7P = parcelRequire("7gs7P");

var $5BzAB = parcelRequire("5BzAB");
var $4b8cd9914734823c$var$TO_STRING_TAG = $5BzAB("toStringTag");
// ES3 wrong here
var $4b8cd9914734823c$var$CORRECT_ARGUMENTS = $7gs7P(function() {
    return arguments;
}()) == "Arguments";
// fallback for IE11 Script Access Denied error
var $4b8cd9914734823c$var$tryGet = function(it, key) {
    try {
        return it[key];
    } catch (error) {}
};
// getting tag from ES6+ `Object.prototype.toString`
module.exports = $9rNN7 ? $7gs7P : function(it) {
    var O, tag, result;
    return it === undefined ? "Undefined" : it === null ? "Null" : typeof (tag = $4b8cd9914734823c$var$tryGet(O = Object(it), $4b8cd9914734823c$var$TO_STRING_TAG)) == "string" ? tag : $4b8cd9914734823c$var$CORRECT_ARGUMENTS ? $7gs7P(O) : (result = $7gs7P(O)) == "Object" && typeof O.callee == "function" ? "Arguments" : result;
};

});
parcelRequire.register("9rNN7", function(module, exports) {

var $5BzAB = parcelRequire("5BzAB");
var $6e0d422e5768e9dc$var$TO_STRING_TAG = $5BzAB("toStringTag");
var $6e0d422e5768e9dc$var$test = {};
$6e0d422e5768e9dc$var$test[$6e0d422e5768e9dc$var$TO_STRING_TAG] = "z";
module.exports = String($6e0d422e5768e9dc$var$test) === "[object z]";

});



parcelRequire.register("jgLaP", function(module, exports) {

var $6GFWk = parcelRequire("6GFWk");
module.exports = function(iterator) {
    var returnMethod = iterator["return"];
    if (returnMethod !== undefined) return $6GFWk(returnMethod.call(iterator)).value;
};

});



parcelRequire.register("fapX4", function(module, exports) {

var $9rNN7 = parcelRequire("9rNN7");

var $bRyc4 = parcelRequire("bRyc4");

var $8dV5y = parcelRequire("8dV5y");
// `Object.prototype.toString` method
// https://tc39.es/ecma262/#sec-object.prototype.tostring
if (!$9rNN7) $bRyc4(Object.prototype, "toString", $8dV5y, {
    unsafe: true
});

});
parcelRequire.register("8dV5y", function(module, exports) {
"use strict";

var $9rNN7 = parcelRequire("9rNN7");

var $6u9pX = parcelRequire("6u9pX");
// `Object.prototype.toString` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.tostring
module.exports = $9rNN7 ? ({}).toString : function toString() {
    return "[object " + $6u9pX(this) + "]";
};

});


parcelRequire.register("50acP", function(module, exports) {
"use strict";

var $gIY7k = parcelRequire("gIY7k");

var $dc67Q = parcelRequire("dc67Q");

var $aX2nu = parcelRequire("aX2nu");

var $90wQL = parcelRequire("90wQL");

var $0MEa7 = parcelRequire("0MEa7");

var $bRyc4 = parcelRequire("bRyc4");

var $8mgDd = parcelRequire("8mgDd");

var $lx7Ao = parcelRequire("lx7Ao");

var $eXgm1 = parcelRequire("eXgm1");

var $1kS4H = parcelRequire("1kS4H");

var $4Wc10 = parcelRequire("4Wc10");

var $belfi = parcelRequire("belfi");

var $89rhq = parcelRequire("89rhq");

var $jLr6u = parcelRequire("jLr6u");

var $fIOwC = parcelRequire("fIOwC");

var $lJScF = parcelRequire("lJScF");

var $lRtLz = parcelRequire("lRtLz");

var $jMbYs = parcelRequire("jMbYs");
var $3a44de88248276d6$require$task = $jMbYs.set;

var $95TiX = parcelRequire("95TiX");

var $cRnSQ = parcelRequire("cRnSQ");

var $hsS7J = parcelRequire("hsS7J");

var $bjg0H = parcelRequire("bjg0H");

var $87lZP = parcelRequire("87lZP");

var $4rhVl = parcelRequire("4rhVl");

var $isGE5 = parcelRequire("isGE5");

var $5BzAB = parcelRequire("5BzAB");

var $kkkKW = parcelRequire("kkkKW");

var $bKcXS = parcelRequire("bKcXS");

var $4Ishw = parcelRequire("4Ishw");
var $3a44de88248276d6$var$SPECIES = $5BzAB("species");
var $3a44de88248276d6$var$PROMISE = "Promise";
var $3a44de88248276d6$var$getInternalState = $4rhVl.get;
var $3a44de88248276d6$var$setInternalState = $4rhVl.set;
var $3a44de88248276d6$var$getInternalPromiseState = $4rhVl.getterFor($3a44de88248276d6$var$PROMISE);
var $3a44de88248276d6$var$NativePromisePrototype = $0MEa7 && $0MEa7.prototype;
var $3a44de88248276d6$var$PromiseConstructor = $0MEa7;
var $3a44de88248276d6$var$PromiseConstructorPrototype = $3a44de88248276d6$var$NativePromisePrototype;
var $3a44de88248276d6$var$TypeError = $aX2nu.TypeError;
var $3a44de88248276d6$var$document = $aX2nu.document;
var $3a44de88248276d6$var$process = $aX2nu.process;
var $3a44de88248276d6$var$newPromiseCapability = $bjg0H.f;
var $3a44de88248276d6$var$newGenericPromiseCapability = $3a44de88248276d6$var$newPromiseCapability;
var $3a44de88248276d6$var$DISPATCH_EVENT = !!($3a44de88248276d6$var$document && $3a44de88248276d6$var$document.createEvent && $aX2nu.dispatchEvent);
var $3a44de88248276d6$var$NATIVE_REJECTION_EVENT = typeof PromiseRejectionEvent == "function";
var $3a44de88248276d6$var$UNHANDLED_REJECTION = "unhandledrejection";
var $3a44de88248276d6$var$REJECTION_HANDLED = "rejectionhandled";
var $3a44de88248276d6$var$PENDING = 0;
var $3a44de88248276d6$var$FULFILLED = 1;
var $3a44de88248276d6$var$REJECTED = 2;
var $3a44de88248276d6$var$HANDLED = 1;
var $3a44de88248276d6$var$UNHANDLED = 2;
var $3a44de88248276d6$var$SUBCLASSING = false;
var $3a44de88248276d6$var$Internal, $3a44de88248276d6$var$OwnPromiseCapability, $3a44de88248276d6$var$PromiseWrapper, $3a44de88248276d6$var$nativeThen;
var $3a44de88248276d6$var$FORCED = $isGE5($3a44de88248276d6$var$PROMISE, function() {
    var PROMISE_CONSTRUCTOR_SOURCE = $jLr6u($3a44de88248276d6$var$PromiseConstructor);
    var GLOBAL_CORE_JS_PROMISE = PROMISE_CONSTRUCTOR_SOURCE !== String($3a44de88248276d6$var$PromiseConstructor);
    // V8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
    // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
    // We can't detect it synchronously, so just check versions
    if (!GLOBAL_CORE_JS_PROMISE && $4Ishw === 66) return true;
    // We need Promise#finally in the pure version for preventing prototype pollution
    if ($dc67Q && !$3a44de88248276d6$var$PromiseConstructorPrototype["finally"]) return true;
    // We can't use @@species feature detection in V8 since it causes
    // deoptimization and performance degradation
    // https://github.com/zloirock/core-js/issues/679
    if ($4Ishw >= 51 && /native code/.test(PROMISE_CONSTRUCTOR_SOURCE)) return false;
    // Detect correctness of subclassing with @@species support
    var promise = new $3a44de88248276d6$var$PromiseConstructor(function(resolve) {
        resolve(1);
    });
    var FakePromise = function(exec) {
        exec(function() {}, function() {});
    };
    var constructor = promise.constructor = {};
    constructor[$3a44de88248276d6$var$SPECIES] = FakePromise;
    $3a44de88248276d6$var$SUBCLASSING = promise.then(function() {}) instanceof FakePromise;
    if (!$3a44de88248276d6$var$SUBCLASSING) return true;
    // Unhandled rejections tracking support, NodeJS Promise without it fails @@species test
    return !GLOBAL_CORE_JS_PROMISE && $kkkKW && !$3a44de88248276d6$var$NATIVE_REJECTION_EVENT;
});
var $3a44de88248276d6$var$INCORRECT_ITERATION = $3a44de88248276d6$var$FORCED || !$lJScF(function(iterable) {
    $3a44de88248276d6$var$PromiseConstructor.all(iterable)["catch"](function() {});
});
// helpers
var $3a44de88248276d6$var$isThenable = function(it) {
    var then;
    return $4Wc10(it) && typeof (then = it.then) == "function" ? then : false;
};
var $3a44de88248276d6$var$notify = function(state, isReject) {
    if (state.notified) return;
    state.notified = true;
    var chain = state.reactions;
    $95TiX(function() {
        var value = state.value;
        var ok = state.state == $3a44de88248276d6$var$FULFILLED;
        var index = 0;
        // variable length - can't use forEach
        while(chain.length > index){
            var reaction = chain[index++];
            var handler = ok ? reaction.ok : reaction.fail;
            var resolve = reaction.resolve;
            var reject = reaction.reject;
            var domain = reaction.domain;
            var result, then, exited;
            try {
                if (handler) {
                    if (!ok) {
                        if (state.rejection === $3a44de88248276d6$var$UNHANDLED) $3a44de88248276d6$var$onHandleUnhandled(state);
                        state.rejection = $3a44de88248276d6$var$HANDLED;
                    }
                    if (handler === true) result = value;
                    else {
                        if (domain) domain.enter();
                        result = handler(value); // can throw
                        if (domain) {
                            domain.exit();
                            exited = true;
                        }
                    }
                    if (result === reaction.promise) reject($3a44de88248276d6$var$TypeError("Promise-chain cycle"));
                    else if (then = $3a44de88248276d6$var$isThenable(result)) then.call(result, resolve, reject);
                    else resolve(result);
                } else reject(value);
            } catch (error) {
                if (domain && !exited) domain.exit();
                reject(error);
            }
        }
        state.reactions = [];
        state.notified = false;
        if (isReject && !state.rejection) $3a44de88248276d6$var$onUnhandled(state);
    });
};
var $3a44de88248276d6$var$dispatchEvent = function(name, promise, reason) {
    var event, handler;
    if ($3a44de88248276d6$var$DISPATCH_EVENT) {
        event = $3a44de88248276d6$var$document.createEvent("Event");
        event.promise = promise;
        event.reason = reason;
        event.initEvent(name, false, true);
        $aX2nu.dispatchEvent(event);
    } else event = {
        promise: promise,
        reason: reason
    };
    if (!$3a44de88248276d6$var$NATIVE_REJECTION_EVENT && (handler = $aX2nu["on" + name])) handler(event);
    else if (name === $3a44de88248276d6$var$UNHANDLED_REJECTION) $hsS7J("Unhandled promise rejection", reason);
};
var $3a44de88248276d6$var$onUnhandled = function(state) {
    $3a44de88248276d6$require$task.call($aX2nu, function() {
        var promise = state.facade;
        var value = state.value;
        var IS_UNHANDLED = $3a44de88248276d6$var$isUnhandled(state);
        var result;
        if (IS_UNHANDLED) {
            result = $87lZP(function() {
                if ($bKcXS) $3a44de88248276d6$var$process.emit("unhandledRejection", value, promise);
                else $3a44de88248276d6$var$dispatchEvent($3a44de88248276d6$var$UNHANDLED_REJECTION, promise, value);
            });
            // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
            state.rejection = $bKcXS || $3a44de88248276d6$var$isUnhandled(state) ? $3a44de88248276d6$var$UNHANDLED : $3a44de88248276d6$var$HANDLED;
            if (result.error) throw result.value;
        }
    });
};
var $3a44de88248276d6$var$isUnhandled = function(state) {
    return state.rejection !== $3a44de88248276d6$var$HANDLED && !state.parent;
};
var $3a44de88248276d6$var$onHandleUnhandled = function(state) {
    $3a44de88248276d6$require$task.call($aX2nu, function() {
        var promise = state.facade;
        if ($bKcXS) $3a44de88248276d6$var$process.emit("rejectionHandled", promise);
        else $3a44de88248276d6$var$dispatchEvent($3a44de88248276d6$var$REJECTION_HANDLED, promise, state.value);
    });
};
var $3a44de88248276d6$var$bind = function(fn, state, unwrap) {
    return function(value) {
        fn(state, value, unwrap);
    };
};
var $3a44de88248276d6$var$internalReject = function(state, value, unwrap) {
    if (state.done) return;
    state.done = true;
    if (unwrap) state = unwrap;
    state.value = value;
    state.state = $3a44de88248276d6$var$REJECTED;
    $3a44de88248276d6$var$notify(state, true);
};
var $3a44de88248276d6$var$internalResolve = function(state, value, unwrap) {
    if (state.done) return;
    state.done = true;
    if (unwrap) state = unwrap;
    try {
        if (state.facade === value) throw $3a44de88248276d6$var$TypeError("Promise can't be resolved itself");
        var then = $3a44de88248276d6$var$isThenable(value);
        if (then) $95TiX(function() {
            var wrapper = {
                done: false
            };
            try {
                then.call(value, $3a44de88248276d6$var$bind($3a44de88248276d6$var$internalResolve, wrapper, state), $3a44de88248276d6$var$bind($3a44de88248276d6$var$internalReject, wrapper, state));
            } catch (error) {
                $3a44de88248276d6$var$internalReject(wrapper, error, state);
            }
        });
        else {
            state.value = value;
            state.state = $3a44de88248276d6$var$FULFILLED;
            $3a44de88248276d6$var$notify(state, false);
        }
    } catch (error) {
        $3a44de88248276d6$var$internalReject({
            done: false
        }, error, state);
    }
};
// constructor polyfill
if ($3a44de88248276d6$var$FORCED) {
    // 25.4.3.1 Promise(executor)
    $3a44de88248276d6$var$PromiseConstructor = function Promise(executor) {
        $89rhq(this, $3a44de88248276d6$var$PromiseConstructor, $3a44de88248276d6$var$PROMISE);
        $belfi(executor);
        $3a44de88248276d6$var$Internal.call(this);
        var state = $3a44de88248276d6$var$getInternalState(this);
        try {
            executor($3a44de88248276d6$var$bind($3a44de88248276d6$var$internalResolve, state), $3a44de88248276d6$var$bind($3a44de88248276d6$var$internalReject, state));
        } catch (error) {
            $3a44de88248276d6$var$internalReject(state, error);
        }
    };
    $3a44de88248276d6$var$PromiseConstructorPrototype = $3a44de88248276d6$var$PromiseConstructor.prototype;
    // eslint-disable-next-line no-unused-vars -- required for `.length`
    $3a44de88248276d6$var$Internal = function Promise(executor) {
        $3a44de88248276d6$var$setInternalState(this, {
            type: $3a44de88248276d6$var$PROMISE,
            done: false,
            notified: false,
            parent: false,
            reactions: [],
            rejection: false,
            state: $3a44de88248276d6$var$PENDING,
            value: undefined
        });
    };
    $3a44de88248276d6$var$Internal.prototype = $8mgDd($3a44de88248276d6$var$PromiseConstructorPrototype, {
        // `Promise.prototype.then` method
        // https://tc39.es/ecma262/#sec-promise.prototype.then
        then: function then(onFulfilled, onRejected) {
            var state = $3a44de88248276d6$var$getInternalPromiseState(this);
            var reaction = $3a44de88248276d6$var$newPromiseCapability($lRtLz(this, $3a44de88248276d6$var$PromiseConstructor));
            reaction.ok = typeof onFulfilled == "function" ? onFulfilled : true;
            reaction.fail = typeof onRejected == "function" && onRejected;
            reaction.domain = $bKcXS ? $3a44de88248276d6$var$process.domain : undefined;
            state.parent = true;
            state.reactions.push(reaction);
            if (state.state != $3a44de88248276d6$var$PENDING) $3a44de88248276d6$var$notify(state, false);
            return reaction.promise;
        },
        // `Promise.prototype.catch` method
        // https://tc39.es/ecma262/#sec-promise.prototype.catch
        "catch": function(onRejected) {
            return this.then(undefined, onRejected);
        }
    });
    $3a44de88248276d6$var$OwnPromiseCapability = function() {
        var promise = new $3a44de88248276d6$var$Internal();
        var state = $3a44de88248276d6$var$getInternalState(promise);
        this.promise = promise;
        this.resolve = $3a44de88248276d6$var$bind($3a44de88248276d6$var$internalResolve, state);
        this.reject = $3a44de88248276d6$var$bind($3a44de88248276d6$var$internalReject, state);
    };
    $bjg0H.f = $3a44de88248276d6$var$newPromiseCapability = function(C) {
        return C === $3a44de88248276d6$var$PromiseConstructor || C === $3a44de88248276d6$var$PromiseWrapper ? new $3a44de88248276d6$var$OwnPromiseCapability(C) : $3a44de88248276d6$var$newGenericPromiseCapability(C);
    };
    if (!$dc67Q && typeof $0MEa7 == "function" && $3a44de88248276d6$var$NativePromisePrototype !== Object.prototype) {
        $3a44de88248276d6$var$nativeThen = $3a44de88248276d6$var$NativePromisePrototype.then;
        if (!$3a44de88248276d6$var$SUBCLASSING) {
            // make `Promise#then` return a polyfilled `Promise` for native promise-based APIs
            $bRyc4($3a44de88248276d6$var$NativePromisePrototype, "then", function then(onFulfilled, onRejected) {
                var that = this;
                return new $3a44de88248276d6$var$PromiseConstructor(function(resolve, reject) {
                    $3a44de88248276d6$var$nativeThen.call(that, resolve, reject);
                }).then(onFulfilled, onRejected);
            // https://github.com/zloirock/core-js/issues/640
            }, {
                unsafe: true
            });
            // makes sure that native promise-based APIs `Promise#catch` properly works with patched `Promise#then`
            $bRyc4($3a44de88248276d6$var$NativePromisePrototype, "catch", $3a44de88248276d6$var$PromiseConstructorPrototype["catch"], {
                unsafe: true
            });
        }
        // make `.constructor === Promise` work for native promise-based APIs
        try {
            delete $3a44de88248276d6$var$NativePromisePrototype.constructor;
        } catch (error) {}
        // make `instanceof Promise` work for native promise-based APIs
        if ($lx7Ao) $lx7Ao($3a44de88248276d6$var$NativePromisePrototype, $3a44de88248276d6$var$PromiseConstructorPrototype);
    }
}
$gIY7k({
    global: true,
    wrap: true,
    forced: $3a44de88248276d6$var$FORCED
}, {
    Promise: $3a44de88248276d6$var$PromiseConstructor
});
$eXgm1($3a44de88248276d6$var$PromiseConstructor, $3a44de88248276d6$var$PROMISE, false, true);
$1kS4H($3a44de88248276d6$var$PROMISE);
$3a44de88248276d6$var$PromiseWrapper = $90wQL($3a44de88248276d6$var$PROMISE);
// statics
$gIY7k({
    target: $3a44de88248276d6$var$PROMISE,
    stat: true,
    forced: $3a44de88248276d6$var$FORCED
}, {
    // `Promise.reject` method
    // https://tc39.es/ecma262/#sec-promise.reject
    reject: function reject(r) {
        var capability = $3a44de88248276d6$var$newPromiseCapability(this);
        capability.reject.call(undefined, r);
        return capability.promise;
    }
});
$gIY7k({
    target: $3a44de88248276d6$var$PROMISE,
    stat: true,
    forced: $dc67Q || $3a44de88248276d6$var$FORCED
}, {
    // `Promise.resolve` method
    // https://tc39.es/ecma262/#sec-promise.resolve
    resolve: function resolve(x) {
        return $cRnSQ($dc67Q && this === $3a44de88248276d6$var$PromiseWrapper ? $3a44de88248276d6$var$PromiseConstructor : this, x);
    }
});
$gIY7k({
    target: $3a44de88248276d6$var$PROMISE,
    stat: true,
    forced: $3a44de88248276d6$var$INCORRECT_ITERATION
}, {
    // `Promise.all` method
    // https://tc39.es/ecma262/#sec-promise.all
    all: function all(iterable) {
        var C = this;
        var capability = $3a44de88248276d6$var$newPromiseCapability(C);
        var resolve = capability.resolve;
        var reject = capability.reject;
        var result = $87lZP(function() {
            var $promiseResolve = $belfi(C.resolve);
            var values = [];
            var counter = 0;
            var remaining = 1;
            $fIOwC(iterable, function(promise) {
                var index = counter++;
                var alreadyCalled = false;
                values.push(undefined);
                remaining++;
                $promiseResolve.call(C, promise).then(function(value) {
                    if (alreadyCalled) return;
                    alreadyCalled = true;
                    values[index] = value;
                    --remaining || resolve(values);
                }, reject);
            });
            --remaining || resolve(values);
        });
        if (result.error) reject(result.value);
        return capability.promise;
    },
    // `Promise.race` method
    // https://tc39.es/ecma262/#sec-promise.race
    race: function race(iterable) {
        var C = this;
        var capability = $3a44de88248276d6$var$newPromiseCapability(C);
        var reject = capability.reject;
        var result = $87lZP(function() {
            var $promiseResolve = $belfi(C.resolve);
            $fIOwC(iterable, function(promise) {
                $promiseResolve.call(C, promise).then(capability.resolve, reject);
            });
        });
        if (result.error) reject(result.value);
        return capability.promise;
    }
});

});
parcelRequire.register("0MEa7", function(module, exports) {

var $aX2nu = parcelRequire("aX2nu");
module.exports = $aX2nu.Promise;

});

parcelRequire.register("8mgDd", function(module, exports) {

var $bRyc4 = parcelRequire("bRyc4");
module.exports = function(target, src, options) {
    for(var key in src)$bRyc4(target, key, src[key], options);
    return target;
};

});

parcelRequire.register("eXgm1", function(module, exports) {

var $5PwwD = parcelRequire("5PwwD");
var $ae3342fc5ec736f7$require$defineProperty = $5PwwD.f;

var $2bgoJ = parcelRequire("2bgoJ");

var $5BzAB = parcelRequire("5BzAB");
var $ae3342fc5ec736f7$var$TO_STRING_TAG = $5BzAB("toStringTag");
module.exports = function(it, TAG, STATIC) {
    if (it && !$2bgoJ(it = STATIC ? it : it.prototype, $ae3342fc5ec736f7$var$TO_STRING_TAG)) $ae3342fc5ec736f7$require$defineProperty(it, $ae3342fc5ec736f7$var$TO_STRING_TAG, {
        configurable: true,
        value: TAG
    });
};

});

parcelRequire.register("1kS4H", function(module, exports) {
"use strict";

var $90wQL = parcelRequire("90wQL");

var $5PwwD = parcelRequire("5PwwD");

var $5BzAB = parcelRequire("5BzAB");

var $i87je = parcelRequire("i87je");
var $0f919adaa455e708$var$SPECIES = $5BzAB("species");
module.exports = function(CONSTRUCTOR_NAME) {
    var Constructor = $90wQL(CONSTRUCTOR_NAME);
    var defineProperty = $5PwwD.f;
    if ($i87je && Constructor && !Constructor[$0f919adaa455e708$var$SPECIES]) defineProperty(Constructor, $0f919adaa455e708$var$SPECIES, {
        configurable: true,
        get: function() {
            return this;
        }
    });
};

});

parcelRequire.register("89rhq", function(module, exports) {
module.exports = function(it, Constructor, name) {
    if (!(it instanceof Constructor)) throw TypeError("Incorrect " + (name ? name + " " : "") + "invocation");
    return it;
};

});

parcelRequire.register("lJScF", function(module, exports) {

var $5BzAB = parcelRequire("5BzAB");
var $fd37d89aa6b5074d$var$ITERATOR = $5BzAB("iterator");
var $fd37d89aa6b5074d$var$SAFE_CLOSING = false;
try {
    var $fd37d89aa6b5074d$var$called = 0;
    var $fd37d89aa6b5074d$var$iteratorWithReturn = {
        next: function() {
            return {
                done: !!$fd37d89aa6b5074d$var$called++
            };
        },
        "return": function() {
            $fd37d89aa6b5074d$var$SAFE_CLOSING = true;
        }
    };
    $fd37d89aa6b5074d$var$iteratorWithReturn[$fd37d89aa6b5074d$var$ITERATOR] = function() {
        return this;
    };
    // eslint-disable-next-line es/no-array-from, no-throw-literal -- required for testing
    Array.from($fd37d89aa6b5074d$var$iteratorWithReturn, function() {
        throw 2;
    });
} catch (error) {}
module.exports = function(exec, SKIP_CLOSING) {
    if (!SKIP_CLOSING && !$fd37d89aa6b5074d$var$SAFE_CLOSING) return false;
    var ITERATION_SUPPORT = false;
    try {
        var object = {};
        object[$fd37d89aa6b5074d$var$ITERATOR] = function() {
            return {
                next: function() {
                    return {
                        done: ITERATION_SUPPORT = true
                    };
                }
            };
        };
        exec(object);
    } catch (error) {}
    return ITERATION_SUPPORT;
};

});

parcelRequire.register("lRtLz", function(module, exports) {

var $6GFWk = parcelRequire("6GFWk");

var $belfi = parcelRequire("belfi");

var $5BzAB = parcelRequire("5BzAB");
var $fea5a32dae584eae$var$SPECIES = $5BzAB("species");
// `SpeciesConstructor` abstract operation
// https://tc39.es/ecma262/#sec-speciesconstructor
module.exports = function(O, defaultConstructor) {
    var C = $6GFWk(O).constructor;
    var S;
    return C === undefined || (S = $6GFWk(C)[$fea5a32dae584eae$var$SPECIES]) == undefined ? defaultConstructor : $belfi(S);
};

});

parcelRequire.register("jMbYs", function(module, exports) {

var $aX2nu = parcelRequire("aX2nu");

var $5tvR9 = parcelRequire("5tvR9");

var $hhrzn = parcelRequire("hhrzn");

var $9DpJO = parcelRequire("9DpJO");

var $eKRPl = parcelRequire("eKRPl");

var $1MjmK = parcelRequire("1MjmK");

var $bKcXS = parcelRequire("bKcXS");
var $e65bc9d3a8e1885f$var$location = $aX2nu.location;
var $e65bc9d3a8e1885f$var$set = $aX2nu.setImmediate;
var $e65bc9d3a8e1885f$var$clear = $aX2nu.clearImmediate;
var $e65bc9d3a8e1885f$var$process = $aX2nu.process;
var $e65bc9d3a8e1885f$var$MessageChannel = $aX2nu.MessageChannel;
var $e65bc9d3a8e1885f$var$Dispatch = $aX2nu.Dispatch;
var $e65bc9d3a8e1885f$var$counter = 0;
var $e65bc9d3a8e1885f$var$queue = {};
var $e65bc9d3a8e1885f$var$ONREADYSTATECHANGE = "onreadystatechange";
var $e65bc9d3a8e1885f$var$defer, $e65bc9d3a8e1885f$var$channel, $e65bc9d3a8e1885f$var$port;
var $e65bc9d3a8e1885f$var$run = function(id) {
    // eslint-disable-next-line no-prototype-builtins -- safe
    if ($e65bc9d3a8e1885f$var$queue.hasOwnProperty(id)) {
        var fn = $e65bc9d3a8e1885f$var$queue[id];
        delete $e65bc9d3a8e1885f$var$queue[id];
        fn();
    }
};
var $e65bc9d3a8e1885f$var$runner = function(id) {
    return function() {
        $e65bc9d3a8e1885f$var$run(id);
    };
};
var $e65bc9d3a8e1885f$var$listener = function(event) {
    $e65bc9d3a8e1885f$var$run(event.data);
};
var $e65bc9d3a8e1885f$var$post = function(id) {
    // old engines have not location.origin
    $aX2nu.postMessage(id + "", $e65bc9d3a8e1885f$var$location.protocol + "//" + $e65bc9d3a8e1885f$var$location.host);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!$e65bc9d3a8e1885f$var$set || !$e65bc9d3a8e1885f$var$clear) {
    $e65bc9d3a8e1885f$var$set = function setImmediate(fn) {
        var args = [];
        var i = 1;
        while(arguments.length > i)args.push(arguments[i++]);
        $e65bc9d3a8e1885f$var$queue[++$e65bc9d3a8e1885f$var$counter] = function() {
            // eslint-disable-next-line no-new-func -- spec requirement
            (typeof fn == "function" ? fn : Function(fn)).apply(undefined, args);
        };
        $e65bc9d3a8e1885f$var$defer($e65bc9d3a8e1885f$var$counter);
        return $e65bc9d3a8e1885f$var$counter;
    };
    $e65bc9d3a8e1885f$var$clear = function clearImmediate(id) {
        delete $e65bc9d3a8e1885f$var$queue[id];
    };
    // Node.js 0.8-
    if ($bKcXS) $e65bc9d3a8e1885f$var$defer = function(id) {
        $e65bc9d3a8e1885f$var$process.nextTick($e65bc9d3a8e1885f$var$runner(id));
    };
    else if ($e65bc9d3a8e1885f$var$Dispatch && $e65bc9d3a8e1885f$var$Dispatch.now) $e65bc9d3a8e1885f$var$defer = function(id) {
        $e65bc9d3a8e1885f$var$Dispatch.now($e65bc9d3a8e1885f$var$runner(id));
    };
    else if ($e65bc9d3a8e1885f$var$MessageChannel && !$1MjmK) {
        $e65bc9d3a8e1885f$var$channel = new $e65bc9d3a8e1885f$var$MessageChannel();
        $e65bc9d3a8e1885f$var$port = $e65bc9d3a8e1885f$var$channel.port2;
        $e65bc9d3a8e1885f$var$channel.port1.onmessage = $e65bc9d3a8e1885f$var$listener;
        $e65bc9d3a8e1885f$var$defer = $hhrzn($e65bc9d3a8e1885f$var$port.postMessage, $e65bc9d3a8e1885f$var$port, 1);
    // Browsers with postMessage, skip WebWorkers
    // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
    } else if ($aX2nu.addEventListener && typeof postMessage == "function" && !$aX2nu.importScripts && $e65bc9d3a8e1885f$var$location && $e65bc9d3a8e1885f$var$location.protocol !== "file:" && !$5tvR9($e65bc9d3a8e1885f$var$post)) {
        $e65bc9d3a8e1885f$var$defer = $e65bc9d3a8e1885f$var$post;
        $aX2nu.addEventListener("message", $e65bc9d3a8e1885f$var$listener, false);
    // IE8-
    } else if ($e65bc9d3a8e1885f$var$ONREADYSTATECHANGE in $eKRPl("script")) $e65bc9d3a8e1885f$var$defer = function(id) {
        $9DpJO.appendChild($eKRPl("script"))[$e65bc9d3a8e1885f$var$ONREADYSTATECHANGE] = function() {
            $9DpJO.removeChild(this);
            $e65bc9d3a8e1885f$var$run(id);
        };
    };
    else $e65bc9d3a8e1885f$var$defer = function(id) {
        setTimeout($e65bc9d3a8e1885f$var$runner(id), 0);
    };
}
module.exports = {
    set: $e65bc9d3a8e1885f$var$set,
    clear: $e65bc9d3a8e1885f$var$clear
};

});
parcelRequire.register("1MjmK", function(module, exports) {

var $fM28n = parcelRequire("fM28n");
module.exports = /(?:iphone|ipod|ipad).*applewebkit/i.test($fM28n);

});

parcelRequire.register("bKcXS", function(module, exports) {

var $7gs7P = parcelRequire("7gs7P");

var $aX2nu = parcelRequire("aX2nu");
module.exports = $7gs7P($aX2nu.process) == "process";

});


parcelRequire.register("95TiX", function(module, exports) {

var $aX2nu = parcelRequire("aX2nu");

var $bmwfk = parcelRequire("bmwfk");
var $69ef7b0d1a53eb73$require$getOwnPropertyDescriptor = $bmwfk.f;

var $jMbYs = parcelRequire("jMbYs");
var $69ef7b0d1a53eb73$require$macrotask = $jMbYs.set;

var $1MjmK = parcelRequire("1MjmK");

var $hB6NU = parcelRequire("hB6NU");

var $bKcXS = parcelRequire("bKcXS");
var $69ef7b0d1a53eb73$var$MutationObserver = $aX2nu.MutationObserver || $aX2nu.WebKitMutationObserver;
var $69ef7b0d1a53eb73$var$document = $aX2nu.document;
var $69ef7b0d1a53eb73$var$process = $aX2nu.process;
var $69ef7b0d1a53eb73$var$Promise = $aX2nu.Promise;
// Node.js 11 shows ExperimentalWarning on getting `queueMicrotask`
var $69ef7b0d1a53eb73$var$queueMicrotaskDescriptor = $69ef7b0d1a53eb73$require$getOwnPropertyDescriptor($aX2nu, "queueMicrotask");
var $69ef7b0d1a53eb73$var$queueMicrotask = $69ef7b0d1a53eb73$var$queueMicrotaskDescriptor && $69ef7b0d1a53eb73$var$queueMicrotaskDescriptor.value;
var $69ef7b0d1a53eb73$var$flush, $69ef7b0d1a53eb73$var$head, $69ef7b0d1a53eb73$var$last, $69ef7b0d1a53eb73$var$notify, $69ef7b0d1a53eb73$var$toggle, $69ef7b0d1a53eb73$var$node, $69ef7b0d1a53eb73$var$promise, $69ef7b0d1a53eb73$var$then;
// modern engines have queueMicrotask method
if (!$69ef7b0d1a53eb73$var$queueMicrotask) {
    $69ef7b0d1a53eb73$var$flush = function() {
        var parent, fn;
        if ($bKcXS && (parent = $69ef7b0d1a53eb73$var$process.domain)) parent.exit();
        while($69ef7b0d1a53eb73$var$head){
            fn = $69ef7b0d1a53eb73$var$head.fn;
            $69ef7b0d1a53eb73$var$head = $69ef7b0d1a53eb73$var$head.next;
            try {
                fn();
            } catch (error) {
                if ($69ef7b0d1a53eb73$var$head) $69ef7b0d1a53eb73$var$notify();
                else $69ef7b0d1a53eb73$var$last = undefined;
                throw error;
            }
        }
        $69ef7b0d1a53eb73$var$last = undefined;
        if (parent) parent.enter();
    };
    // browsers with MutationObserver, except iOS - https://github.com/zloirock/core-js/issues/339
    // also except WebOS Webkit https://github.com/zloirock/core-js/issues/898
    if (!$1MjmK && !$bKcXS && !$hB6NU && $69ef7b0d1a53eb73$var$MutationObserver && $69ef7b0d1a53eb73$var$document) {
        $69ef7b0d1a53eb73$var$toggle = true;
        $69ef7b0d1a53eb73$var$node = $69ef7b0d1a53eb73$var$document.createTextNode("");
        new $69ef7b0d1a53eb73$var$MutationObserver($69ef7b0d1a53eb73$var$flush).observe($69ef7b0d1a53eb73$var$node, {
            characterData: true
        });
        $69ef7b0d1a53eb73$var$notify = function() {
            $69ef7b0d1a53eb73$var$node.data = $69ef7b0d1a53eb73$var$toggle = !$69ef7b0d1a53eb73$var$toggle;
        };
    // environments with maybe non-completely correct, but existent Promise
    } else if ($69ef7b0d1a53eb73$var$Promise && $69ef7b0d1a53eb73$var$Promise.resolve) {
        // Promise.resolve without an argument throws an error in LG WebOS 2
        $69ef7b0d1a53eb73$var$promise = $69ef7b0d1a53eb73$var$Promise.resolve(undefined);
        // workaround of WebKit ~ iOS Safari 10.1 bug
        $69ef7b0d1a53eb73$var$promise.constructor = $69ef7b0d1a53eb73$var$Promise;
        $69ef7b0d1a53eb73$var$then = $69ef7b0d1a53eb73$var$promise.then;
        $69ef7b0d1a53eb73$var$notify = function() {
            $69ef7b0d1a53eb73$var$then.call($69ef7b0d1a53eb73$var$promise, $69ef7b0d1a53eb73$var$flush);
        };
    // Node.js without promises
    } else if ($bKcXS) $69ef7b0d1a53eb73$var$notify = function() {
        $69ef7b0d1a53eb73$var$process.nextTick($69ef7b0d1a53eb73$var$flush);
    };
    else $69ef7b0d1a53eb73$var$notify = function() {
        // strange IE + webpack dev server bug - use .call(global)
        $69ef7b0d1a53eb73$require$macrotask.call($aX2nu, $69ef7b0d1a53eb73$var$flush);
    };
}
module.exports = $69ef7b0d1a53eb73$var$queueMicrotask || function(fn) {
    var task = {
        fn: fn,
        next: undefined
    };
    if ($69ef7b0d1a53eb73$var$last) $69ef7b0d1a53eb73$var$last.next = task;
    if (!$69ef7b0d1a53eb73$var$head) {
        $69ef7b0d1a53eb73$var$head = task;
        $69ef7b0d1a53eb73$var$notify();
    }
    $69ef7b0d1a53eb73$var$last = task;
};

});
parcelRequire.register("hB6NU", function(module, exports) {

var $fM28n = parcelRequire("fM28n");
module.exports = /web0s(?!.*chrome)/i.test($fM28n);

});


parcelRequire.register("cRnSQ", function(module, exports) {

var $6GFWk = parcelRequire("6GFWk");

var $4Wc10 = parcelRequire("4Wc10");

var $bjg0H = parcelRequire("bjg0H");
module.exports = function(C, x) {
    $6GFWk(C);
    if ($4Wc10(x) && x.constructor === C) return x;
    var promiseCapability = $bjg0H.f(C);
    var resolve = promiseCapability.resolve;
    resolve(x);
    return promiseCapability.promise;
};

});
parcelRequire.register("bjg0H", function(module, exports) {

$parcel$export(module.exports, "f", () => $83bde35c8441bbab$export$2d1720544b23b823, (v) => $83bde35c8441bbab$export$2d1720544b23b823 = v);
// `NewPromiseCapability` abstract operation
// https://tc39.es/ecma262/#sec-newpromisecapability
var $83bde35c8441bbab$export$2d1720544b23b823;
"use strict";

var $belfi = parcelRequire("belfi");
var $83bde35c8441bbab$var$PromiseCapability = function(C) {
    var resolve, reject;
    this.promise = new C(function($$resolve, $$reject) {
        if (resolve !== undefined || reject !== undefined) throw TypeError("Bad Promise constructor");
        resolve = $$resolve;
        reject = $$reject;
    });
    this.resolve = $belfi(resolve);
    this.reject = $belfi(reject);
};
$83bde35c8441bbab$export$2d1720544b23b823 = function(C) {
    return new $83bde35c8441bbab$var$PromiseCapability(C);
};

});


parcelRequire.register("hsS7J", function(module, exports) {

var $aX2nu = parcelRequire("aX2nu");
module.exports = function(a, b) {
    var console = $aX2nu.console;
    if (console && console.error) arguments.length === 1 ? console.error(a) : console.error(a, b);
};

});

parcelRequire.register("87lZP", function(module, exports) {
module.exports = function(exec) {
    try {
        return {
            error: false,
            value: exec()
        };
    } catch (error) {
        return {
            error: true,
            value: error
        };
    }
};

});

parcelRequire.register("kkkKW", function(module, exports) {
module.exports = typeof window == "object";

});


parcelRequire.register("3xPki", function(module, exports) {
"use strict";

var $gIY7k = parcelRequire("gIY7k");

var $belfi = parcelRequire("belfi");

var $bjg0H = parcelRequire("bjg0H");

var $87lZP = parcelRequire("87lZP");

var $fIOwC = parcelRequire("fIOwC");
// `Promise.allSettled` method
// https://tc39.es/ecma262/#sec-promise.allsettled
$gIY7k({
    target: "Promise",
    stat: true
}, {
    allSettled: function allSettled(iterable) {
        var C = this;
        var capability = $bjg0H.f(C);
        var resolve = capability.resolve;
        var reject = capability.reject;
        var result = $87lZP(function() {
            var promiseResolve = $belfi(C.resolve);
            var values = [];
            var counter = 0;
            var remaining = 1;
            $fIOwC(iterable, function(promise) {
                var index = counter++;
                var alreadyCalled = false;
                values.push(undefined);
                remaining++;
                promiseResolve.call(C, promise).then(function(value) {
                    if (alreadyCalled) return;
                    alreadyCalled = true;
                    values[index] = {
                        status: "fulfilled",
                        value: value
                    };
                    --remaining || resolve(values);
                }, function(error) {
                    if (alreadyCalled) return;
                    alreadyCalled = true;
                    values[index] = {
                        status: "rejected",
                        reason: error
                    };
                    --remaining || resolve(values);
                });
            });
            --remaining || resolve(values);
        });
        if (result.error) reject(result.value);
        return capability.promise;
    }
});

});

parcelRequire.register("fsAoq", function(module, exports) {
"use strict";

var $gIY7k = parcelRequire("gIY7k");

var $belfi = parcelRequire("belfi");

var $90wQL = parcelRequire("90wQL");

var $bjg0H = parcelRequire("bjg0H");

var $87lZP = parcelRequire("87lZP");

var $fIOwC = parcelRequire("fIOwC");
var $b415b36e5ddaac76$var$PROMISE_ANY_ERROR = "No one promise resolved";
// `Promise.any` method
// https://tc39.es/ecma262/#sec-promise.any
$gIY7k({
    target: "Promise",
    stat: true
}, {
    any: function any(iterable) {
        var C = this;
        var capability = $bjg0H.f(C);
        var resolve = capability.resolve;
        var reject = capability.reject;
        var result = $87lZP(function() {
            var promiseResolve = $belfi(C.resolve);
            var errors = [];
            var counter = 0;
            var remaining = 1;
            var alreadyResolved = false;
            $fIOwC(iterable, function(promise) {
                var index = counter++;
                var alreadyRejected = false;
                errors.push(undefined);
                remaining++;
                promiseResolve.call(C, promise).then(function(value) {
                    if (alreadyRejected || alreadyResolved) return;
                    alreadyResolved = true;
                    resolve(value);
                }, function(error) {
                    if (alreadyRejected || alreadyResolved) return;
                    alreadyRejected = true;
                    errors[index] = error;
                    --remaining || reject(new ($90wQL("AggregateError"))(errors, $b415b36e5ddaac76$var$PROMISE_ANY_ERROR));
                });
            });
            --remaining || reject(new ($90wQL("AggregateError"))(errors, $b415b36e5ddaac76$var$PROMISE_ANY_ERROR));
        });
        if (result.error) reject(result.value);
        return capability.promise;
    }
});

});

parcelRequire.register("gGk0c", function(module, exports) {
"use strict";

var $gIY7k = parcelRequire("gIY7k");

var $dc67Q = parcelRequire("dc67Q");

var $0MEa7 = parcelRequire("0MEa7");

var $5tvR9 = parcelRequire("5tvR9");

var $90wQL = parcelRequire("90wQL");

var $lRtLz = parcelRequire("lRtLz");

var $cRnSQ = parcelRequire("cRnSQ");

var $bRyc4 = parcelRequire("bRyc4");
// Safari bug https://bugs.webkit.org/show_bug.cgi?id=200829
var $c2501595986df6b8$var$NON_GENERIC = !!$0MEa7 && $5tvR9(function() {
    $0MEa7.prototype["finally"].call({
        then: function() {}
    }, function() {});
});
// `Promise.prototype.finally` method
// https://tc39.es/ecma262/#sec-promise.prototype.finally
$gIY7k({
    target: "Promise",
    proto: true,
    real: true,
    forced: $c2501595986df6b8$var$NON_GENERIC
}, {
    "finally": function(onFinally) {
        var C = $lRtLz(this, $90wQL("Promise"));
        var isFunction = typeof onFinally == "function";
        return this.then(isFunction ? function(x) {
            return $cRnSQ(C, onFinally()).then(function() {
                return x;
            });
        } : onFinally, isFunction ? function(e) {
            return $cRnSQ(C, onFinally()).then(function() {
                throw e;
            });
        } : onFinally);
    }
});
// makes sure that native promise-based APIs `Promise#finally` properly works with patched `Promise#then`
if (!$dc67Q && typeof $0MEa7 == "function") {
    var $c2501595986df6b8$var$method = $90wQL("Promise").prototype["finally"];
    if ($0MEa7.prototype["finally"] !== $c2501595986df6b8$var$method) $bRyc4($0MEa7.prototype, "finally", $c2501595986df6b8$var$method, {
        unsafe: true
    });
}

});

parcelRequire.register("mnyEo", function(module, exports) {
"use strict";

var $byAX1 = parcelRequire("byAX1");
var $0434544b083c399b$require$charAt = $byAX1.charAt;

var $4rhVl = parcelRequire("4rhVl");

var $jSwO7 = parcelRequire("jSwO7");
var $0434544b083c399b$var$STRING_ITERATOR = "String Iterator";
var $0434544b083c399b$var$setInternalState = $4rhVl.set;
var $0434544b083c399b$var$getInternalState = $4rhVl.getterFor($0434544b083c399b$var$STRING_ITERATOR);
// `String.prototype[@@iterator]` method
// https://tc39.es/ecma262/#sec-string.prototype-@@iterator
$jSwO7(String, "String", function(iterated) {
    $0434544b083c399b$var$setInternalState(this, {
        type: $0434544b083c399b$var$STRING_ITERATOR,
        string: String(iterated),
        index: 0
    });
// `%StringIteratorPrototype%.next` method
// https://tc39.es/ecma262/#sec-%stringiteratorprototype%.next
}, function next() {
    var state = $0434544b083c399b$var$getInternalState(this);
    var string = state.string;
    var index = state.index;
    var point;
    if (index >= string.length) return {
        value: undefined,
        done: true
    };
    point = $0434544b083c399b$require$charAt(string, index);
    state.index += point.length;
    return {
        value: point,
        done: false
    };
});

});
parcelRequire.register("byAX1", function(module, exports) {

var $cLwdg = parcelRequire("cLwdg");

var $9wYyI = parcelRequire("9wYyI");
// `String.prototype.{ codePointAt, at }` methods implementation
var $869f885a8692fcca$var$createMethod = function(CONVERT_TO_STRING) {
    return function($this, pos) {
        var S = String($9wYyI($this));
        var position = $cLwdg(pos);
        var size = S.length;
        var first, second;
        if (position < 0 || position >= size) return CONVERT_TO_STRING ? "" : undefined;
        first = S.charCodeAt(position);
        return first < 0xD800 || first > 0xDBFF || position + 1 === size || (second = S.charCodeAt(position + 1)) < 0xDC00 || second > 0xDFFF ? CONVERT_TO_STRING ? S.charAt(position) : first : CONVERT_TO_STRING ? S.slice(position, position + 2) : (first - 0xD800 << 10) + (second - 0xDC00) + 0x10000;
    };
};
module.exports = {
    // `String.prototype.codePointAt` method
    // https://tc39.es/ecma262/#sec-string.prototype.codepointat
    codeAt: $869f885a8692fcca$var$createMethod(false),
    // `String.prototype.at` method
    // https://github.com/mathiasbynens/String.prototype.at
    charAt: $869f885a8692fcca$var$createMethod(true)
};

});

parcelRequire.register("jSwO7", function(module, exports) {
"use strict";

var $gIY7k = parcelRequire("gIY7k");

var $5tCtB = parcelRequire("5tCtB");

var $hepN6 = parcelRequire("hepN6");

var $lx7Ao = parcelRequire("lx7Ao");

var $eXgm1 = parcelRequire("eXgm1");

var $36BU0 = parcelRequire("36BU0");

var $bRyc4 = parcelRequire("bRyc4");

var $5BzAB = parcelRequire("5BzAB");

var $dc67Q = parcelRequire("dc67Q");

var $jDDJq = parcelRequire("jDDJq");

var $gkEk0 = parcelRequire("gkEk0");
var $e78c82595cb3b0d5$var$IteratorPrototype = $gkEk0.IteratorPrototype;
var $e78c82595cb3b0d5$var$BUGGY_SAFARI_ITERATORS = $gkEk0.BUGGY_SAFARI_ITERATORS;
var $e78c82595cb3b0d5$var$ITERATOR = $5BzAB("iterator");
var $e78c82595cb3b0d5$var$KEYS = "keys";
var $e78c82595cb3b0d5$var$VALUES = "values";
var $e78c82595cb3b0d5$var$ENTRIES = "entries";
var $e78c82595cb3b0d5$var$returnThis = function() {
    return this;
};
module.exports = function(Iterable, NAME, IteratorConstructor, next, DEFAULT, IS_SET, FORCED) {
    $5tCtB(IteratorConstructor, NAME, next);
    var getIterationMethod = function(KIND) {
        if (KIND === DEFAULT && defaultIterator) return defaultIterator;
        if (!$e78c82595cb3b0d5$var$BUGGY_SAFARI_ITERATORS && KIND in IterablePrototype) return IterablePrototype[KIND];
        switch(KIND){
            case $e78c82595cb3b0d5$var$KEYS:
                return function keys() {
                    return new IteratorConstructor(this, KIND);
                };
            case $e78c82595cb3b0d5$var$VALUES:
                return function values() {
                    return new IteratorConstructor(this, KIND);
                };
            case $e78c82595cb3b0d5$var$ENTRIES:
                return function entries() {
                    return new IteratorConstructor(this, KIND);
                };
        }
        return function() {
            return new IteratorConstructor(this);
        };
    };
    var TO_STRING_TAG = NAME + " Iterator";
    var INCORRECT_VALUES_NAME = false;
    var IterablePrototype = Iterable.prototype;
    var nativeIterator = IterablePrototype[$e78c82595cb3b0d5$var$ITERATOR] || IterablePrototype["@@iterator"] || DEFAULT && IterablePrototype[DEFAULT];
    var defaultIterator = !$e78c82595cb3b0d5$var$BUGGY_SAFARI_ITERATORS && nativeIterator || getIterationMethod(DEFAULT);
    var anyNativeIterator = NAME == "Array" ? IterablePrototype.entries || nativeIterator : nativeIterator;
    var CurrentIteratorPrototype, methods, KEY;
    // fix native
    if (anyNativeIterator) {
        CurrentIteratorPrototype = $hepN6(anyNativeIterator.call(new Iterable()));
        if ($e78c82595cb3b0d5$var$IteratorPrototype !== Object.prototype && CurrentIteratorPrototype.next) {
            if (!$dc67Q && $hepN6(CurrentIteratorPrototype) !== $e78c82595cb3b0d5$var$IteratorPrototype) {
                if ($lx7Ao) $lx7Ao(CurrentIteratorPrototype, $e78c82595cb3b0d5$var$IteratorPrototype);
                else if (typeof CurrentIteratorPrototype[$e78c82595cb3b0d5$var$ITERATOR] != "function") $36BU0(CurrentIteratorPrototype, $e78c82595cb3b0d5$var$ITERATOR, $e78c82595cb3b0d5$var$returnThis);
            }
            // Set @@toStringTag to native iterators
            $eXgm1(CurrentIteratorPrototype, TO_STRING_TAG, true, true);
            if ($dc67Q) $jDDJq[TO_STRING_TAG] = $e78c82595cb3b0d5$var$returnThis;
        }
    }
    // fix Array.prototype.{ values, @@iterator }.name in V8 / FF
    if (DEFAULT == $e78c82595cb3b0d5$var$VALUES && nativeIterator && nativeIterator.name !== $e78c82595cb3b0d5$var$VALUES) {
        INCORRECT_VALUES_NAME = true;
        defaultIterator = function values() {
            return nativeIterator.call(this);
        };
    }
    // define iterator
    if ((!$dc67Q || FORCED) && IterablePrototype[$e78c82595cb3b0d5$var$ITERATOR] !== defaultIterator) $36BU0(IterablePrototype, $e78c82595cb3b0d5$var$ITERATOR, defaultIterator);
    $jDDJq[NAME] = defaultIterator;
    // export additional methods
    if (DEFAULT) {
        methods = {
            values: getIterationMethod($e78c82595cb3b0d5$var$VALUES),
            keys: IS_SET ? defaultIterator : getIterationMethod($e78c82595cb3b0d5$var$KEYS),
            entries: getIterationMethod($e78c82595cb3b0d5$var$ENTRIES)
        };
        if (FORCED) {
            for(KEY in methods)if ($e78c82595cb3b0d5$var$BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME || !(KEY in IterablePrototype)) $bRyc4(IterablePrototype, KEY, methods[KEY]);
        } else $gIY7k({
            target: NAME,
            proto: true,
            forced: $e78c82595cb3b0d5$var$BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME
        }, methods);
    }
    return methods;
};

});
parcelRequire.register("5tCtB", function(module, exports) {
"use strict";

var $gkEk0 = parcelRequire("gkEk0");
var $3fcd81ca8da5161b$require$IteratorPrototype = $gkEk0.IteratorPrototype;

var $4VFy7 = parcelRequire("4VFy7");

var $1kPdT = parcelRequire("1kPdT");

var $eXgm1 = parcelRequire("eXgm1");

var $jDDJq = parcelRequire("jDDJq");
var $3fcd81ca8da5161b$var$returnThis = function() {
    return this;
};
module.exports = function(IteratorConstructor, NAME, next) {
    var TO_STRING_TAG = NAME + " Iterator";
    IteratorConstructor.prototype = $4VFy7($3fcd81ca8da5161b$require$IteratorPrototype, {
        next: $1kPdT(1, next)
    });
    $eXgm1(IteratorConstructor, TO_STRING_TAG, false, true);
    $jDDJq[TO_STRING_TAG] = $3fcd81ca8da5161b$var$returnThis;
    return IteratorConstructor;
};

});
parcelRequire.register("gkEk0", function(module, exports) {
"use strict";

var $5tvR9 = parcelRequire("5tvR9");

var $hepN6 = parcelRequire("hepN6");

var $36BU0 = parcelRequire("36BU0");

var $2bgoJ = parcelRequire("2bgoJ");

var $5BzAB = parcelRequire("5BzAB");

var $dc67Q = parcelRequire("dc67Q");
var $be3dcaa5c9cf3f13$var$ITERATOR = $5BzAB("iterator");
var $be3dcaa5c9cf3f13$var$BUGGY_SAFARI_ITERATORS = false;
var $be3dcaa5c9cf3f13$var$returnThis = function() {
    return this;
};
// `%IteratorPrototype%` object
// https://tc39.es/ecma262/#sec-%iteratorprototype%-object
var $be3dcaa5c9cf3f13$var$IteratorPrototype, $be3dcaa5c9cf3f13$var$PrototypeOfArrayIteratorPrototype, $be3dcaa5c9cf3f13$var$arrayIterator;
/* eslint-disable es/no-array-prototype-keys -- safe */ if ([].keys) {
    $be3dcaa5c9cf3f13$var$arrayIterator = [].keys();
    // Safari 8 has buggy iterators w/o `next`
    if (!("next" in $be3dcaa5c9cf3f13$var$arrayIterator)) $be3dcaa5c9cf3f13$var$BUGGY_SAFARI_ITERATORS = true;
    else {
        $be3dcaa5c9cf3f13$var$PrototypeOfArrayIteratorPrototype = $hepN6($hepN6($be3dcaa5c9cf3f13$var$arrayIterator));
        if ($be3dcaa5c9cf3f13$var$PrototypeOfArrayIteratorPrototype !== Object.prototype) $be3dcaa5c9cf3f13$var$IteratorPrototype = $be3dcaa5c9cf3f13$var$PrototypeOfArrayIteratorPrototype;
    }
}
var $be3dcaa5c9cf3f13$var$NEW_ITERATOR_PROTOTYPE = $be3dcaa5c9cf3f13$var$IteratorPrototype == undefined || $5tvR9(function() {
    var test = {};
    // FF44- legacy iterators case
    return $be3dcaa5c9cf3f13$var$IteratorPrototype[$be3dcaa5c9cf3f13$var$ITERATOR].call(test) !== test;
});
if ($be3dcaa5c9cf3f13$var$NEW_ITERATOR_PROTOTYPE) $be3dcaa5c9cf3f13$var$IteratorPrototype = {};
// `%IteratorPrototype%[@@iterator]()` method
// https://tc39.es/ecma262/#sec-%iteratorprototype%-@@iterator
if ((!$dc67Q || $be3dcaa5c9cf3f13$var$NEW_ITERATOR_PROTOTYPE) && !$2bgoJ($be3dcaa5c9cf3f13$var$IteratorPrototype, $be3dcaa5c9cf3f13$var$ITERATOR)) $36BU0($be3dcaa5c9cf3f13$var$IteratorPrototype, $be3dcaa5c9cf3f13$var$ITERATOR, $be3dcaa5c9cf3f13$var$returnThis);
module.exports = {
    IteratorPrototype: $be3dcaa5c9cf3f13$var$IteratorPrototype,
    BUGGY_SAFARI_ITERATORS: $be3dcaa5c9cf3f13$var$BUGGY_SAFARI_ITERATORS
};

});




parcelRequire.register("aPfoN", function(module, exports) {

var $aX2nu = parcelRequire("aX2nu");

var $lQ8SC = parcelRequire("lQ8SC");

var $e72nC = parcelRequire("e72nC");

var $36BU0 = parcelRequire("36BU0");

var $5BzAB = parcelRequire("5BzAB");
var $0208aff27cbda1af$var$ITERATOR = $5BzAB("iterator");
var $0208aff27cbda1af$var$TO_STRING_TAG = $5BzAB("toStringTag");
var $0208aff27cbda1af$var$ArrayValues = $e72nC.values;
for(var $0208aff27cbda1af$var$COLLECTION_NAME in $lQ8SC){
    var $0208aff27cbda1af$var$Collection = $aX2nu[$0208aff27cbda1af$var$COLLECTION_NAME];
    var $0208aff27cbda1af$var$CollectionPrototype = $0208aff27cbda1af$var$Collection && $0208aff27cbda1af$var$Collection.prototype;
    if ($0208aff27cbda1af$var$CollectionPrototype) {
        // some Chrome versions have non-configurable methods on DOMTokenList
        if ($0208aff27cbda1af$var$CollectionPrototype[$0208aff27cbda1af$var$ITERATOR] !== $0208aff27cbda1af$var$ArrayValues) try {
            $36BU0($0208aff27cbda1af$var$CollectionPrototype, $0208aff27cbda1af$var$ITERATOR, $0208aff27cbda1af$var$ArrayValues);
        } catch (error) {
            $0208aff27cbda1af$var$CollectionPrototype[$0208aff27cbda1af$var$ITERATOR] = $0208aff27cbda1af$var$ArrayValues;
        }
        if (!$0208aff27cbda1af$var$CollectionPrototype[$0208aff27cbda1af$var$TO_STRING_TAG]) $36BU0($0208aff27cbda1af$var$CollectionPrototype, $0208aff27cbda1af$var$TO_STRING_TAG, $0208aff27cbda1af$var$COLLECTION_NAME);
        if ($lQ8SC[$0208aff27cbda1af$var$COLLECTION_NAME]) for(var $0208aff27cbda1af$var$METHOD_NAME in $e72nC){
            // some Chrome versions have non-configurable methods on DOMTokenList
            if ($0208aff27cbda1af$var$CollectionPrototype[$0208aff27cbda1af$var$METHOD_NAME] !== $e72nC[$0208aff27cbda1af$var$METHOD_NAME]) try {
                $36BU0($0208aff27cbda1af$var$CollectionPrototype, $0208aff27cbda1af$var$METHOD_NAME, $e72nC[$0208aff27cbda1af$var$METHOD_NAME]);
            } catch (error) {
                $0208aff27cbda1af$var$CollectionPrototype[$0208aff27cbda1af$var$METHOD_NAME] = $e72nC[$0208aff27cbda1af$var$METHOD_NAME];
            }
        }
    }
}

});
parcelRequire.register("lQ8SC", function(module, exports) {
// iterable DOM collections
// flag - `iterable` interface - 'entries', 'keys', 'values', 'forEach' methods
module.exports = {
    CSSRuleList: 0,
    CSSStyleDeclaration: 0,
    CSSValueList: 0,
    ClientRectList: 0,
    DOMRectList: 0,
    DOMStringList: 0,
    DOMTokenList: 1,
    DataTransferItemList: 0,
    FileList: 0,
    HTMLAllCollection: 0,
    HTMLCollection: 0,
    HTMLFormElement: 0,
    HTMLSelectElement: 0,
    MediaList: 0,
    MimeTypeArray: 0,
    NamedNodeMap: 0,
    NodeList: 1,
    PaintRequestList: 0,
    Plugin: 0,
    PluginArray: 0,
    SVGLengthList: 0,
    SVGNumberList: 0,
    SVGPathSegList: 0,
    SVGPointList: 0,
    SVGStringList: 0,
    SVGTransformList: 0,
    SourceBufferList: 0,
    StyleSheetList: 0,
    TextTrackCueList: 0,
    TextTrackList: 0,
    TouchList: 0
};

});

parcelRequire.register("e72nC", function(module, exports) {
"use strict";

var $9t6kn = parcelRequire("9t6kn");

var $h972x = parcelRequire("h972x");

var $jDDJq = parcelRequire("jDDJq");

var $4rhVl = parcelRequire("4rhVl");

var $jSwO7 = parcelRequire("jSwO7");
var $a46390bd672ef286$var$ARRAY_ITERATOR = "Array Iterator";
var $a46390bd672ef286$var$setInternalState = $4rhVl.set;
var $a46390bd672ef286$var$getInternalState = $4rhVl.getterFor($a46390bd672ef286$var$ARRAY_ITERATOR);
// `Array.prototype.entries` method
// https://tc39.es/ecma262/#sec-array.prototype.entries
// `Array.prototype.keys` method
// https://tc39.es/ecma262/#sec-array.prototype.keys
// `Array.prototype.values` method
// https://tc39.es/ecma262/#sec-array.prototype.values
// `Array.prototype[@@iterator]` method
// https://tc39.es/ecma262/#sec-array.prototype-@@iterator
// `CreateArrayIterator` internal method
// https://tc39.es/ecma262/#sec-createarrayiterator
module.exports = $jSwO7(Array, "Array", function(iterated, kind) {
    $a46390bd672ef286$var$setInternalState(this, {
        type: $a46390bd672ef286$var$ARRAY_ITERATOR,
        target: $9t6kn(iterated),
        index: 0,
        kind: kind // kind
    });
// `%ArrayIteratorPrototype%.next` method
// https://tc39.es/ecma262/#sec-%arrayiteratorprototype%.next
}, function() {
    var state = $a46390bd672ef286$var$getInternalState(this);
    var target = state.target;
    var kind = state.kind;
    var index = state.index++;
    if (!target || index >= target.length) {
        state.target = undefined;
        return {
            value: undefined,
            done: true
        };
    }
    if (kind == "keys") return {
        value: index,
        done: false
    };
    if (kind == "values") return {
        value: target[index],
        done: false
    };
    return {
        value: [
            index,
            target[index]
        ],
        done: false
    };
}, "values");
// argumentsList[@@iterator] is %ArrayProto_values%
// https://tc39.es/ecma262/#sec-createunmappedargumentsobject
// https://tc39.es/ecma262/#sec-createmappedargumentsobject
$jDDJq.Arguments = $jDDJq.Array;
// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
$h972x("keys");
$h972x("values");
$h972x("entries");

});
parcelRequire.register("h972x", function(module, exports) {

var $5BzAB = parcelRequire("5BzAB");

var $4VFy7 = parcelRequire("4VFy7");

var $5PwwD = parcelRequire("5PwwD");
var $c7b8bcf1464d02f4$var$UNSCOPABLES = $5BzAB("unscopables");
var $c7b8bcf1464d02f4$var$ArrayPrototype = Array.prototype;
// Array.prototype[@@unscopables]
// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
if ($c7b8bcf1464d02f4$var$ArrayPrototype[$c7b8bcf1464d02f4$var$UNSCOPABLES] == undefined) $5PwwD.f($c7b8bcf1464d02f4$var$ArrayPrototype, $c7b8bcf1464d02f4$var$UNSCOPABLES, {
    configurable: true,
    value: $4VFy7(null)
});
// add a key to Array.prototype[@@unscopables]
module.exports = function(key) {
    $c7b8bcf1464d02f4$var$ArrayPrototype[$c7b8bcf1464d02f4$var$UNSCOPABLES][key] = true;
};

});




parcelRequire.register("lRBuN", function(module, exports) {
// TODO: Remove from `core-js@4`
parcelRequire("az5tL");

});

parcelRequire.register("3Rxse", function(module, exports) {
// TODO: Remove from `core-js@4`
parcelRequire("3xPki");

});

parcelRequire.register("e3Epf", function(module, exports) {
"use strict";

var $gIY7k = parcelRequire("gIY7k");

var $bjg0H = parcelRequire("bjg0H");

var $87lZP = parcelRequire("87lZP");
// `Promise.try` method
// https://github.com/tc39/proposal-promise-try
$gIY7k({
    target: "Promise",
    stat: true
}, {
    "try": function(callbackfn) {
        var promiseCapability = $bjg0H.f(this);
        var result = $87lZP(callbackfn);
        (result.error ? promiseCapability.reject : promiseCapability.resolve)(result.value);
        return promiseCapability.promise;
    }
});

});

parcelRequire.register("cI6e3", function(module, exports) {
// TODO: Remove from `core-js@4`
parcelRequire("fsAoq");

});


parcelRequire.register("5lfHT", function(module, exports) {
/**
 *
 *
 * @author Jerry Bendy <jerry@icewingcc.com>
 * @licence MIT
 *
 */ (function(self) {
    "use strict";
    var nativeURLSearchParams = function() {
        // #41 Fix issue in RN
        try {
            if (self.URLSearchParams && new self.URLSearchParams("foo=bar").get("foo") === "bar") return self.URLSearchParams;
        } catch (e) {}
        return null;
    }(), isSupportObjectConstructor = nativeURLSearchParams && new nativeURLSearchParams({
        a: 1
    }).toString() === "a=1", // There is a bug in safari 10.1 (and earlier) that incorrectly decodes `%2B` as an empty space and not a plus.
    decodesPlusesCorrectly = nativeURLSearchParams && new nativeURLSearchParams("s=%2B").get("s") === "+", __URLSearchParams__ = "__URLSearchParams__", // Fix bug in Edge which cannot encode ' &' correctly
    encodesAmpersandsCorrectly = nativeURLSearchParams ? function() {
        var ampersandTest = new nativeURLSearchParams();
        ampersandTest.append("s", " &");
        return ampersandTest.toString() === "s=+%26";
    }() : true, prototype = URLSearchParamsPolyfill.prototype, iterable = !!(self.Symbol && self.Symbol.iterator);
    if (nativeURLSearchParams && isSupportObjectConstructor && decodesPlusesCorrectly && encodesAmpersandsCorrectly) return;
    /**
     * Make a URLSearchParams instance
     *
     * @param {object|string|URLSearchParams} search
     * @constructor
     */ function URLSearchParamsPolyfill(search) {
        search = search || "";
        // support construct object with another URLSearchParams instance
        if (search instanceof URLSearchParams || search instanceof URLSearchParamsPolyfill) search = search.toString();
        this[__URLSearchParams__] = parseToDict(search);
    }
    /**
     * Appends a specified key/value pair as a new search parameter.
     *
     * @param {string} name
     * @param {string} value
     */ prototype.append = function(name, value) {
        appendTo(this[__URLSearchParams__], name, value);
    };
    /**
     * Deletes the given search parameter, and its associated value,
     * from the list of all search parameters.
     *
     * @param {string} name
     */ prototype["delete"] = function(name) {
        delete this[__URLSearchParams__][name];
    };
    /**
     * Returns the first value associated to the given search parameter.
     *
     * @param {string} name
     * @returns {string|null}
     */ prototype.get = function(name) {
        var dict = this[__URLSearchParams__];
        return this.has(name) ? dict[name][0] : null;
    };
    /**
     * Returns all the values association with a given search parameter.
     *
     * @param {string} name
     * @returns {Array}
     */ prototype.getAll = function(name) {
        var dict = this[__URLSearchParams__];
        return this.has(name) ? dict[name].slice(0) : [];
    };
    /**
     * Returns a Boolean indicating if such a search parameter exists.
     *
     * @param {string} name
     * @returns {boolean}
     */ prototype.has = function(name) {
        return hasOwnProperty(this[__URLSearchParams__], name);
    };
    /**
     * Sets the value associated to a given search parameter to
     * the given value. If there were several values, delete the
     * others.
     *
     * @param {string} name
     * @param {string} value
     */ prototype.set = function set(name, value) {
        this[__URLSearchParams__][name] = [
            "" + value
        ];
    };
    /**
     * Returns a string containg a query string suitable for use in a URL.
     *
     * @returns {string}
     */ prototype.toString = function() {
        var dict = this[__URLSearchParams__], query = [], i, key, name, value;
        for(key in dict){
            name = encode(key);
            for(i = 0, value = dict[key]; i < value.length; i++)query.push(name + "=" + encode(value[i]));
        }
        return query.join("&");
    };
    // There is a bug in Safari 10.1 and `Proxy`ing it is not enough.
    var forSureUsePolyfill = !decodesPlusesCorrectly;
    var useProxy = !forSureUsePolyfill && nativeURLSearchParams && !isSupportObjectConstructor && self.Proxy;
    var propValue;
    if (useProxy) {
        // Safari 10.0 doesn't support Proxy, so it won't extend URLSearchParams on safari 10.0
        propValue = new Proxy(nativeURLSearchParams, {
            construct: function(target, args) {
                return new target(new URLSearchParamsPolyfill(args[0]).toString());
            }
        });
        // Chrome <=60 .toString() on a function proxy got error "Function.prototype.toString is not generic"
        propValue.toString = Function.prototype.toString.bind(URLSearchParamsPolyfill);
    } else propValue = URLSearchParamsPolyfill;
    /*
     * Apply polifill to global object and append other prototype into it
     */ Object.defineProperty(self, "URLSearchParams", {
        value: propValue
    });
    var USPProto = self.URLSearchParams.prototype;
    USPProto.polyfill = true;
    /**
     *
     * @param {function} callback
     * @param {object} thisArg
     */ USPProto.forEach = USPProto.forEach || function(callback, thisArg) {
        var dict = parseToDict(this.toString());
        Object.getOwnPropertyNames(dict).forEach(function(name) {
            dict[name].forEach(function(value) {
                callback.call(thisArg, value, name, this);
            }, this);
        }, this);
    };
    /**
     * Sort all name-value pairs
     */ USPProto.sort = USPProto.sort || function() {
        var dict = parseToDict(this.toString()), keys = [], k, i, j;
        for(k in dict)keys.push(k);
        keys.sort();
        for(i = 0; i < keys.length; i++)this["delete"](keys[i]);
        for(i = 0; i < keys.length; i++){
            var key = keys[i], values = dict[key];
            for(j = 0; j < values.length; j++)this.append(key, values[j]);
        }
    };
    /**
     * Returns an iterator allowing to go through all keys of
     * the key/value pairs contained in this object.
     *
     * @returns {function}
     */ USPProto.keys = USPProto.keys || function() {
        var items = [];
        this.forEach(function(item, name) {
            items.push(name);
        });
        return makeIterator(items);
    };
    /**
     * Returns an iterator allowing to go through all values of
     * the key/value pairs contained in this object.
     *
     * @returns {function}
     */ USPProto.values = USPProto.values || function() {
        var items = [];
        this.forEach(function(item) {
            items.push(item);
        });
        return makeIterator(items);
    };
    /**
     * Returns an iterator allowing to go through all key/value
     * pairs contained in this object.
     *
     * @returns {function}
     */ USPProto.entries = USPProto.entries || function() {
        var items = [];
        this.forEach(function(item, name) {
            items.push([
                name,
                item
            ]);
        });
        return makeIterator(items);
    };
    if (iterable) USPProto[self.Symbol.iterator] = USPProto[self.Symbol.iterator] || USPProto.entries;
    function encode(str) {
        var replace = {
            "!": "%21",
            "'": "%27",
            "(": "%28",
            ")": "%29",
            "~": "%7E",
            "%20": "+",
            "%00": "\x00"
        };
        return encodeURIComponent(str).replace(/[!'\(\)~]|%20|%00/g, function(match) {
            return replace[match];
        });
    }
    function decode(str) {
        return str.replace(/[ +]/g, "%20").replace(/(%[a-f0-9]{2})+/ig, function(match) {
            return decodeURIComponent(match);
        });
    }
    function makeIterator(arr) {
        var iterator = {
            next: function() {
                var value = arr.shift();
                return {
                    done: value === undefined,
                    value: value
                };
            }
        };
        if (iterable) iterator[self.Symbol.iterator] = function() {
            return iterator;
        };
        return iterator;
    }
    function parseToDict(search) {
        var dict = {};
        if (typeof search === "object") {
            // if `search` is an array, treat it as a sequence
            if (isArray(search)) for(var i = 0; i < search.length; i++){
                var item = search[i];
                if (isArray(item) && item.length === 2) appendTo(dict, item[0], item[1]);
                else throw new TypeError("Failed to construct 'URLSearchParams': Sequence initializer must only contain pair elements");
            }
            else {
                for(var key in search)if (search.hasOwnProperty(key)) appendTo(dict, key, search[key]);
            }
        } else {
            // remove first '?'
            if (search.indexOf("?") === 0) search = search.slice(1);
            var pairs = search.split("&");
            for(var j = 0; j < pairs.length; j++){
                var value = pairs[j], index = value.indexOf("=");
                if (-1 < index) appendTo(dict, decode(value.slice(0, index)), decode(value.slice(index + 1)));
                else if (value) appendTo(dict, decode(value), "");
            }
        }
        return dict;
    }
    function appendTo(dict, name, value) {
        var val = typeof value === "string" ? value : value !== null && value !== undefined && typeof value.toString === "function" ? value.toString() : JSON.stringify(value);
        // #47 Prevent using `hasOwnProperty` as a property name
        if (hasOwnProperty(dict, name)) dict[name].push(val);
        else dict[name] = [
            val
        ];
    }
    function isArray(val) {
        return !!val && "[object Array]" === Object.prototype.toString.call(val);
    }
    function hasOwnProperty(obj, prop) {
        return Object.prototype.hasOwnProperty.call(obj, prop);
    }
})(typeof $parcel$global !== "undefined" ? $parcel$global : typeof window !== "undefined" ? window : module.exports);

});

parcelRequire.register("5PS69", function(module, exports) {
"use strict";
var $43fbadf50a028cca$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $gfSg8 = parcelRequire("gfSg8");

var $cKPYe = parcelRequire("cKPYe");
/**
 * @class BehaviorSubject<T>
 */ var $43fbadf50a028cca$var$BehaviorSubject = function(_super) {
    $43fbadf50a028cca$var$__extends(BehaviorSubject, _super);
    function BehaviorSubject(_value) {
        _super.call(this);
        this._value = _value;
    }
    Object.defineProperty(BehaviorSubject.prototype, "value", {
        get: function() {
            return this.getValue();
        },
        enumerable: true,
        configurable: true
    });
    /** @deprecated internal use only */ BehaviorSubject.prototype._subscribe = function(subscriber) {
        var subscription = _super.prototype._subscribe.call(this, subscriber);
        if (subscription && !subscription.closed) subscriber.next(this._value);
        return subscription;
    };
    BehaviorSubject.prototype.getValue = function() {
        if (this.hasError) throw this.thrownError;
        else if (this.closed) throw new $cKPYe.ObjectUnsubscribedError();
        else return this._value;
    };
    BehaviorSubject.prototype.next = function(value) {
        _super.prototype.next.call(this, this._value = value);
    };
    return BehaviorSubject;
}($gfSg8.Subject);
module.exports.BehaviorSubject = $43fbadf50a028cca$var$BehaviorSubject;

});
parcelRequire.register("gfSg8", function(module, exports) {
"use strict";
var $bd5822d51c50abc5$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $lyDVs = parcelRequire("lyDVs");

var $gYcab = parcelRequire("gYcab");

var $lSRxI = parcelRequire("lSRxI");

var $cKPYe = parcelRequire("cKPYe");

var $7IBvb = parcelRequire("7IBvb");

var $i9WMZ = parcelRequire("i9WMZ");
/**
 * @class SubjectSubscriber<T>
 */ var $bd5822d51c50abc5$var$SubjectSubscriber = function(_super) {
    $bd5822d51c50abc5$var$__extends(SubjectSubscriber, _super);
    function SubjectSubscriber(destination) {
        _super.call(this, destination);
        this.destination = destination;
    }
    return SubjectSubscriber;
}($gYcab.Subscriber);
module.exports.SubjectSubscriber = $bd5822d51c50abc5$var$SubjectSubscriber;
/**
 * @class Subject<T>
 */ var $bd5822d51c50abc5$var$Subject = function(_super) {
    $bd5822d51c50abc5$var$__extends(Subject, _super);
    function Subject() {
        _super.call(this);
        this.observers = [];
        this.closed = false;
        this.isStopped = false;
        this.hasError = false;
        this.thrownError = null;
    }
    Subject.prototype[$i9WMZ.rxSubscriber] = function() {
        return new $bd5822d51c50abc5$var$SubjectSubscriber(this);
    };
    Subject.prototype.lift = function(operator) {
        var subject = new $bd5822d51c50abc5$var$AnonymousSubject(this, this);
        subject.operator = operator;
        return subject;
    };
    Subject.prototype.next = function(value) {
        if (this.closed) throw new $cKPYe.ObjectUnsubscribedError();
        if (!this.isStopped) {
            var observers = this.observers;
            var len = observers.length;
            var copy = observers.slice();
            for(var i = 0; i < len; i++)copy[i].next(value);
        }
    };
    Subject.prototype.error = function(err) {
        if (this.closed) throw new $cKPYe.ObjectUnsubscribedError();
        this.hasError = true;
        this.thrownError = err;
        this.isStopped = true;
        var observers = this.observers;
        var len = observers.length;
        var copy = observers.slice();
        for(var i = 0; i < len; i++)copy[i].error(err);
        this.observers.length = 0;
    };
    Subject.prototype.complete = function() {
        if (this.closed) throw new $cKPYe.ObjectUnsubscribedError();
        this.isStopped = true;
        var observers = this.observers;
        var len = observers.length;
        var copy = observers.slice();
        for(var i = 0; i < len; i++)copy[i].complete();
        this.observers.length = 0;
    };
    Subject.prototype.unsubscribe = function() {
        this.isStopped = true;
        this.closed = true;
        this.observers = null;
    };
    Subject.prototype._trySubscribe = function(subscriber) {
        if (this.closed) throw new $cKPYe.ObjectUnsubscribedError();
        else return _super.prototype._trySubscribe.call(this, subscriber);
    };
    /** @deprecated internal use only */ Subject.prototype._subscribe = function(subscriber) {
        if (this.closed) throw new $cKPYe.ObjectUnsubscribedError();
        else if (this.hasError) {
            subscriber.error(this.thrownError);
            return $lSRxI.Subscription.EMPTY;
        } else if (this.isStopped) {
            subscriber.complete();
            return $lSRxI.Subscription.EMPTY;
        } else {
            this.observers.push(subscriber);
            return new $7IBvb.SubjectSubscription(this, subscriber);
        }
    };
    Subject.prototype.asObservable = function() {
        var observable = new $lyDVs.Observable();
        observable.source = this;
        return observable;
    };
    Subject.create = function(destination, source) {
        return new $bd5822d51c50abc5$var$AnonymousSubject(destination, source);
    };
    return Subject;
}($lyDVs.Observable);
module.exports.Subject = $bd5822d51c50abc5$var$Subject;
/**
 * @class AnonymousSubject<T>
 */ var $bd5822d51c50abc5$var$AnonymousSubject = function(_super) {
    $bd5822d51c50abc5$var$__extends(AnonymousSubject, _super);
    function AnonymousSubject(destination, source) {
        _super.call(this);
        this.destination = destination;
        this.source = source;
    }
    AnonymousSubject.prototype.next = function(value) {
        var destination = this.destination;
        if (destination && destination.next) destination.next(value);
    };
    AnonymousSubject.prototype.error = function(err) {
        var destination = this.destination;
        if (destination && destination.error) this.destination.error(err);
    };
    AnonymousSubject.prototype.complete = function() {
        var destination = this.destination;
        if (destination && destination.complete) this.destination.complete();
    };
    /** @deprecated internal use only */ AnonymousSubject.prototype._subscribe = function(subscriber) {
        var source = this.source;
        if (source) return this.source.subscribe(subscriber);
        else return $lSRxI.Subscription.EMPTY;
    };
    return AnonymousSubject;
}($bd5822d51c50abc5$var$Subject);
module.exports.AnonymousSubject = $bd5822d51c50abc5$var$AnonymousSubject;

});
parcelRequire.register("lyDVs", function(module, exports) {

$parcel$export(module.exports, "Observable", () => $fb1bbe57d97ea7cb$export$77cea355fa80b5f4, (v) => $fb1bbe57d97ea7cb$export$77cea355fa80b5f4 = v);
var $fb1bbe57d97ea7cb$export$77cea355fa80b5f4;
"use strict";

var $hGUNf = parcelRequire("hGUNf");

var $s3mw1 = parcelRequire("s3mw1");

var $bhQVP = parcelRequire("bhQVP");

var $dXgYL = parcelRequire("dXgYL");
/**
 * A representation of any set of values over any amount of time. This is the most basic building block
 * of RxJS.
 *
 * @class Observable<T>
 */ var $fb1bbe57d97ea7cb$var$Observable = function() {
    /**
     * @constructor
     * @param {Function} subscribe the function that is called when the Observable is
     * initially subscribed to. This function is given a Subscriber, to which new values
     * can be `next`ed, or an `error` method can be called to raise an error, or
     * `complete` can be called to notify of a successful completion.
     */ function Observable(subscribe) {
        this._isScalar = false;
        if (subscribe) this._subscribe = subscribe;
    }
    /**
     * Creates a new Observable, with this Observable as the source, and the passed
     * operator defined as the new observable's operator.
     * @method lift
     * @param {Operator} operator the operator defining the operation to take on the observable
     * @return {Observable} a new observable with the Operator applied
     */ Observable.prototype.lift = function(operator) {
        var observable = new Observable();
        observable.source = this;
        observable.operator = operator;
        return observable;
    };
    /**
     * Invokes an execution of an Observable and registers Observer handlers for notifications it will emit.
     *
     * <span class="informal">Use it when you have all these Observables, but still nothing is happening.</span>
     *
     * `subscribe` is not a regular operator, but a method that calls Observable's internal `subscribe` function. It
     * might be for example a function that you passed to a {@link create} static factory, but most of the time it is
     * a library implementation, which defines what and when will be emitted by an Observable. This means that calling
     * `subscribe` is actually the moment when Observable starts its work, not when it is created, as it is often
     * thought.
     *
     * Apart from starting the execution of an Observable, this method allows you to listen for values
     * that an Observable emits, as well as for when it completes or errors. You can achieve this in two
     * following ways.
     *
     * The first way is creating an object that implements {@link Observer} interface. It should have methods
     * defined by that interface, but note that it should be just a regular JavaScript object, which you can create
     * yourself in any way you want (ES6 class, classic function constructor, object literal etc.). In particular do
     * not attempt to use any RxJS implementation details to create Observers - you don't need them. Remember also
     * that your object does not have to implement all methods. If you find yourself creating a method that doesn't
     * do anything, you can simply omit it. Note however, that if `error` method is not provided, all errors will
     * be left uncaught.
     *
     * The second way is to give up on Observer object altogether and simply provide callback functions in place of its methods.
     * This means you can provide three functions as arguments to `subscribe`, where first function is equivalent
     * of a `next` method, second of an `error` method and third of a `complete` method. Just as in case of Observer,
     * if you do not need to listen for something, you can omit a function, preferably by passing `undefined` or `null`,
     * since `subscribe` recognizes these functions by where they were placed in function call. When it comes
     * to `error` function, just as before, if not provided, errors emitted by an Observable will be thrown.
     *
     * Whatever style of calling `subscribe` you use, in both cases it returns a Subscription object.
     * This object allows you to call `unsubscribe` on it, which in turn will stop work that an Observable does and will clean
     * up all resources that an Observable used. Note that cancelling a subscription will not call `complete` callback
     * provided to `subscribe` function, which is reserved for a regular completion signal that comes from an Observable.
     *
     * Remember that callbacks provided to `subscribe` are not guaranteed to be called asynchronously.
     * It is an Observable itself that decides when these functions will be called. For example {@link of}
     * by default emits all its values synchronously. Always check documentation for how given Observable
     * will behave when subscribed and if its default behavior can be modified with a {@link Scheduler}.
     *
     * @example <caption>Subscribe with an Observer</caption>
     * const sumObserver = {
     *   sum: 0,
     *   next(value) {
     *     console.log('Adding: ' + value);
     *     this.sum = this.sum + value;
     *   },
     *   error() { // We actually could just remove this method,
     *   },        // since we do not really care about errors right now.
     *   complete() {
     *     console.log('Sum equals: ' + this.sum);
     *   }
     * };
     *
     * Rx.Observable.of(1, 2, 3) // Synchronously emits 1, 2, 3 and then completes.
     * .subscribe(sumObserver);
     *
     * // Logs:
     * // "Adding: 1"
     * // "Adding: 2"
     * // "Adding: 3"
     * // "Sum equals: 6"
     *
     *
     * @example <caption>Subscribe with functions</caption>
     * let sum = 0;
     *
     * Rx.Observable.of(1, 2, 3)
     * .subscribe(
     *   function(value) {
     *     console.log('Adding: ' + value);
     *     sum = sum + value;
     *   },
     *   undefined,
     *   function() {
     *     console.log('Sum equals: ' + sum);
     *   }
     * );
     *
     * // Logs:
     * // "Adding: 1"
     * // "Adding: 2"
     * // "Adding: 3"
     * // "Sum equals: 6"
     *
     *
     * @example <caption>Cancel a subscription</caption>
     * const subscription = Rx.Observable.interval(1000).subscribe(
     *   num => console.log(num),
     *   undefined,
     *   () => console.log('completed!') // Will not be called, even
     * );                                // when cancelling subscription
     *
     *
     * setTimeout(() => {
     *   subscription.unsubscribe();
     *   console.log('unsubscribed!');
     * }, 2500);
     *
     * // Logs:
     * // 0 after 1s
     * // 1 after 2s
     * // "unsubscribed!" after 2.5s
     *
     *
     * @param {Observer|Function} observerOrNext (optional) Either an observer with methods to be called,
     *  or the first of three possible handlers, which is the handler for each value emitted from the subscribed
     *  Observable.
     * @param {Function} error (optional) A handler for a terminal event resulting from an error. If no error handler is provided,
     *  the error will be thrown as unhandled.
     * @param {Function} complete (optional) A handler for a terminal event resulting from successful completion.
     * @return {ISubscription} a subscription reference to the registered handlers
     * @method subscribe
     */ Observable.prototype.subscribe = function(observerOrNext, error, complete) {
        var operator = this.operator;
        var sink = $s3mw1.toSubscriber(observerOrNext, error, complete);
        if (operator) operator.call(sink, this.source);
        else sink.add(this.source || !sink.syncErrorThrowable ? this._subscribe(sink) : this._trySubscribe(sink));
        if (sink.syncErrorThrowable) {
            sink.syncErrorThrowable = false;
            if (sink.syncErrorThrown) throw sink.syncErrorValue;
        }
        return sink;
    };
    Observable.prototype._trySubscribe = function(sink) {
        try {
            return this._subscribe(sink);
        } catch (err) {
            sink.syncErrorThrown = true;
            sink.syncErrorValue = err;
            sink.error(err);
        }
    };
    /**
     * @method forEach
     * @param {Function} next a handler for each value emitted by the observable
     * @param {PromiseConstructor} [PromiseCtor] a constructor function used to instantiate the Promise
     * @return {Promise} a promise that either resolves on observable completion or
     *  rejects with the handled error
     */ Observable.prototype.forEach = function(next, PromiseCtor) {
        var _this = this;
        if (!PromiseCtor) {
            if ($hGUNf.root.Rx && $hGUNf.root.Rx.config && $hGUNf.root.Rx.config.Promise) PromiseCtor = $hGUNf.root.Rx.config.Promise;
            else if ($hGUNf.root.Promise) PromiseCtor = $hGUNf.root.Promise;
        }
        if (!PromiseCtor) throw new Error("no Promise impl found");
        return new PromiseCtor(function(resolve, reject) {
            // Must be declared in a separate statement to avoid a RefernceError when
            // accessing subscription below in the closure due to Temporal Dead Zone.
            var subscription;
            subscription = _this.subscribe(function(value) {
                if (subscription) // if there is a subscription, then we can surmise
                // the next handling is asynchronous. Any errors thrown
                // need to be rejected explicitly and unsubscribe must be
                // called manually
                try {
                    next(value);
                } catch (err) {
                    reject(err);
                    subscription.unsubscribe();
                }
                else // if there is NO subscription, then we're getting a nexted
                // value synchronously during subscription. We can just call it.
                // If it errors, Observable's `subscribe` will ensure the
                // unsubscription logic is called, then synchronously rethrow the error.
                // After that, Promise will trap the error and send it
                // down the rejection path.
                next(value);
            }, reject, resolve);
        });
    };
    /** @deprecated internal use only */ Observable.prototype._subscribe = function(subscriber) {
        return this.source.subscribe(subscriber);
    };
    /**
     * An interop point defined by the es7-observable spec https://github.com/zenparsing/es-observable
     * @method Symbol.observable
     * @return {Observable} this instance of the observable
     */ Observable.prototype[$bhQVP.observable] = function() {
        return this;
    };
    /* tslint:enable:max-line-length */ /**
     * Used to stitch together functional operators into a chain.
     * @method pipe
     * @return {Observable} the Observable result of all of the operators having
     * been called in the order they were passed in.
     *
     * @example
     *
     * import { map, filter, scan } from 'rxjs/operators';
     *
     * Rx.Observable.interval(1000)
     *   .pipe(
     *     filter(x => x % 2 === 0),
     *     map(x => x + x),
     *     scan((acc, x) => acc + x)
     *   )
     *   .subscribe(x => console.log(x))
     */ Observable.prototype.pipe = function() {
        var operations = [];
        for(var _i = 0; _i < arguments.length; _i++)operations[_i - 0] = arguments[_i];
        if (operations.length === 0) return this;
        return $dXgYL.pipeFromArray(operations)(this);
    };
    /* tslint:enable:max-line-length */ Observable.prototype.toPromise = function(PromiseCtor) {
        var _this = this;
        if (!PromiseCtor) {
            if ($hGUNf.root.Rx && $hGUNf.root.Rx.config && $hGUNf.root.Rx.config.Promise) PromiseCtor = $hGUNf.root.Rx.config.Promise;
            else if ($hGUNf.root.Promise) PromiseCtor = $hGUNf.root.Promise;
        }
        if (!PromiseCtor) throw new Error("no Promise impl found");
        return new PromiseCtor(function(resolve, reject) {
            var value;
            _this.subscribe(function(x) {
                return value = x;
            }, function(err) {
                return reject(err);
            }, function() {
                return resolve(value);
            });
        });
    };
    // HACK: Since TypeScript inherits static properties too, we have to
    // fight against TypeScript here so Subject can have a different static create signature
    /**
     * Creates a new cold Observable by calling the Observable constructor
     * @static true
     * @owner Observable
     * @method create
     * @param {Function} subscribe? the subscriber function to be passed to the Observable constructor
     * @return {Observable} a new cold observable
     */ Observable.create = function(subscribe) {
        return new Observable(subscribe);
    };
    return Observable;
}();
$fb1bbe57d97ea7cb$export$77cea355fa80b5f4 = $fb1bbe57d97ea7cb$var$Observable;

});
parcelRequire.register("hGUNf", function(module, exports) {

$parcel$export(module.exports, "root", () => $ce1269dfe1766f7d$export$e8e78c978b129247, (v) => $ce1269dfe1766f7d$export$e8e78c978b129247 = v);
var $ce1269dfe1766f7d$export$e8e78c978b129247;
"use strict";
// CommonJS / Node have global context exposed as "global" variable.
// We don't want to include the whole node.d.ts this this compilation unit so we'll just fake
// the global "global" var for now.
var $ce1269dfe1766f7d$var$__window = typeof window !== "undefined" && window;
var $ce1269dfe1766f7d$var$__self = typeof self !== "undefined" && typeof WorkerGlobalScope !== "undefined" && self instanceof WorkerGlobalScope && self;
var $ce1269dfe1766f7d$var$__global = typeof $parcel$global !== "undefined" && $parcel$global;
var $ce1269dfe1766f7d$var$_root = $ce1269dfe1766f7d$var$__window || $ce1269dfe1766f7d$var$__global || $ce1269dfe1766f7d$var$__self;
$ce1269dfe1766f7d$export$e8e78c978b129247 = $ce1269dfe1766f7d$var$_root;
// Workaround Closure Compiler restriction: The body of a goog.module cannot use throw.
// This is needed when used with angular/tsickle which inserts a goog.module statement.
// Wrap in IIFE
(function() {
    if (!$ce1269dfe1766f7d$var$_root) throw new Error("RxJS could not find any global context (window, self, global)");
})();

});

parcelRequire.register("s3mw1", function(module, exports) {

$parcel$export(module.exports, "toSubscriber", () => $0545394b06537d28$export$2a12c2cebbfd1087, (v) => $0545394b06537d28$export$2a12c2cebbfd1087 = v);
var $0545394b06537d28$export$2a12c2cebbfd1087;
"use strict";

var $gYcab = parcelRequire("gYcab");

var $i9WMZ = parcelRequire("i9WMZ");

var $jMM09 = parcelRequire("jMM09");
function $0545394b06537d28$var$toSubscriber(nextOrObserver, error, complete) {
    if (nextOrObserver) {
        if (nextOrObserver instanceof $gYcab.Subscriber) return nextOrObserver;
        if (nextOrObserver[$i9WMZ.rxSubscriber]) return nextOrObserver[$i9WMZ.rxSubscriber]();
    }
    if (!nextOrObserver && !error && !complete) return new $gYcab.Subscriber($jMM09.empty);
    return new $gYcab.Subscriber(nextOrObserver, error, complete);
}
$0545394b06537d28$export$2a12c2cebbfd1087 = $0545394b06537d28$var$toSubscriber;

});
parcelRequire.register("gYcab", function(module, exports) {
"use strict";
var $c5abaf4e7561c1be$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $6MSkv = parcelRequire("6MSkv");

var $lSRxI = parcelRequire("lSRxI");

var $jMM09 = parcelRequire("jMM09");

var $i9WMZ = parcelRequire("i9WMZ");
/**
 * Implements the {@link Observer} interface and extends the
 * {@link Subscription} class. While the {@link Observer} is the public API for
 * consuming the values of an {@link Observable}, all Observers get converted to
 * a Subscriber, in order to provide Subscription-like capabilities such as
 * `unsubscribe`. Subscriber is a common type in RxJS, and crucial for
 * implementing operators, but it is rarely used as a public API.
 *
 * @class Subscriber<T>
 */ var $c5abaf4e7561c1be$var$Subscriber = function(_super) {
    $c5abaf4e7561c1be$var$__extends(Subscriber, _super);
    /**
     * @param {Observer|function(value: T): void} [destinationOrNext] A partially
     * defined Observer or a `next` callback function.
     * @param {function(e: ?any): void} [error] The `error` callback of an
     * Observer.
     * @param {function(): void} [complete] The `complete` callback of an
     * Observer.
     */ function Subscriber(destinationOrNext, error, complete) {
        _super.call(this);
        this.syncErrorValue = null;
        this.syncErrorThrown = false;
        this.syncErrorThrowable = false;
        this.isStopped = false;
        switch(arguments.length){
            case 0:
                this.destination = $jMM09.empty;
                break;
            case 1:
                if (!destinationOrNext) {
                    this.destination = $jMM09.empty;
                    break;
                }
                if (typeof destinationOrNext === "object") {
                    // HACK(benlesh): To resolve an issue where Node users may have multiple
                    // copies of rxjs in their node_modules directory.
                    if ($c5abaf4e7561c1be$var$isTrustedSubscriber(destinationOrNext)) {
                        var trustedSubscriber = destinationOrNext[$i9WMZ.rxSubscriber]();
                        this.syncErrorThrowable = trustedSubscriber.syncErrorThrowable;
                        this.destination = trustedSubscriber;
                        trustedSubscriber.add(this);
                    } else {
                        this.syncErrorThrowable = true;
                        this.destination = new $c5abaf4e7561c1be$var$SafeSubscriber(this, destinationOrNext);
                    }
                    break;
                }
            default:
                this.syncErrorThrowable = true;
                this.destination = new $c5abaf4e7561c1be$var$SafeSubscriber(this, destinationOrNext, error, complete);
                break;
        }
    }
    Subscriber.prototype[$i9WMZ.rxSubscriber] = function() {
        return this;
    };
    /**
     * A static factory for a Subscriber, given a (potentially partial) definition
     * of an Observer.
     * @param {function(x: ?T): void} [next] The `next` callback of an Observer.
     * @param {function(e: ?any): void} [error] The `error` callback of an
     * Observer.
     * @param {function(): void} [complete] The `complete` callback of an
     * Observer.
     * @return {Subscriber<T>} A Subscriber wrapping the (partially defined)
     * Observer represented by the given arguments.
     */ Subscriber.create = function(next, error, complete) {
        var subscriber = new Subscriber(next, error, complete);
        subscriber.syncErrorThrowable = false;
        return subscriber;
    };
    /**
     * The {@link Observer} callback to receive notifications of type `next` from
     * the Observable, with a value. The Observable may call this method 0 or more
     * times.
     * @param {T} [value] The `next` value.
     * @return {void}
     */ Subscriber.prototype.next = function(value) {
        if (!this.isStopped) this._next(value);
    };
    /**
     * The {@link Observer} callback to receive notifications of type `error` from
     * the Observable, with an attached {@link Error}. Notifies the Observer that
     * the Observable has experienced an error condition.
     * @param {any} [err] The `error` exception.
     * @return {void}
     */ Subscriber.prototype.error = function(err) {
        if (!this.isStopped) {
            this.isStopped = true;
            this._error(err);
        }
    };
    /**
     * The {@link Observer} callback to receive a valueless notification of type
     * `complete` from the Observable. Notifies the Observer that the Observable
     * has finished sending push-based notifications.
     * @return {void}
     */ Subscriber.prototype.complete = function() {
        if (!this.isStopped) {
            this.isStopped = true;
            this._complete();
        }
    };
    Subscriber.prototype.unsubscribe = function() {
        if (this.closed) return;
        this.isStopped = true;
        _super.prototype.unsubscribe.call(this);
    };
    Subscriber.prototype._next = function(value) {
        this.destination.next(value);
    };
    Subscriber.prototype._error = function(err) {
        this.destination.error(err);
        this.unsubscribe();
    };
    Subscriber.prototype._complete = function() {
        this.destination.complete();
        this.unsubscribe();
    };
    /** @deprecated internal use only */ Subscriber.prototype._unsubscribeAndRecycle = function() {
        var _a = this, _parent = _a._parent, _parents = _a._parents;
        this._parent = null;
        this._parents = null;
        this.unsubscribe();
        this.closed = false;
        this.isStopped = false;
        this._parent = _parent;
        this._parents = _parents;
        return this;
    };
    return Subscriber;
}($lSRxI.Subscription);
module.exports.Subscriber = $c5abaf4e7561c1be$var$Subscriber;
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $c5abaf4e7561c1be$var$SafeSubscriber = function(_super) {
    $c5abaf4e7561c1be$var$__extends(SafeSubscriber, _super);
    function SafeSubscriber(_parentSubscriber, observerOrNext, error, complete) {
        _super.call(this);
        this._parentSubscriber = _parentSubscriber;
        var next;
        var context = this;
        if ($6MSkv.isFunction(observerOrNext)) next = observerOrNext;
        else if (observerOrNext) {
            next = observerOrNext.next;
            error = observerOrNext.error;
            complete = observerOrNext.complete;
            if (observerOrNext !== $jMM09.empty) {
                context = Object.create(observerOrNext);
                if ($6MSkv.isFunction(context.unsubscribe)) this.add(context.unsubscribe.bind(context));
                context.unsubscribe = this.unsubscribe.bind(this);
            }
        }
        this._context = context;
        this._next = next;
        this._error = error;
        this._complete = complete;
    }
    SafeSubscriber.prototype.next = function(value) {
        if (!this.isStopped && this._next) {
            var _parentSubscriber = this._parentSubscriber;
            if (!_parentSubscriber.syncErrorThrowable) this.__tryOrUnsub(this._next, value);
            else if (this.__tryOrSetError(_parentSubscriber, this._next, value)) this.unsubscribe();
        }
    };
    SafeSubscriber.prototype.error = function(err) {
        if (!this.isStopped) {
            var _parentSubscriber = this._parentSubscriber;
            if (this._error) {
                if (!_parentSubscriber.syncErrorThrowable) {
                    this.__tryOrUnsub(this._error, err);
                    this.unsubscribe();
                } else {
                    this.__tryOrSetError(_parentSubscriber, this._error, err);
                    this.unsubscribe();
                }
            } else if (!_parentSubscriber.syncErrorThrowable) {
                this.unsubscribe();
                throw err;
            } else {
                _parentSubscriber.syncErrorValue = err;
                _parentSubscriber.syncErrorThrown = true;
                this.unsubscribe();
            }
        }
    };
    SafeSubscriber.prototype.complete = function() {
        var _this = this;
        if (!this.isStopped) {
            var _parentSubscriber = this._parentSubscriber;
            if (this._complete) {
                var wrappedComplete = function() {
                    return _this._complete.call(_this._context);
                };
                if (!_parentSubscriber.syncErrorThrowable) {
                    this.__tryOrUnsub(wrappedComplete);
                    this.unsubscribe();
                } else {
                    this.__tryOrSetError(_parentSubscriber, wrappedComplete);
                    this.unsubscribe();
                }
            } else this.unsubscribe();
        }
    };
    SafeSubscriber.prototype.__tryOrUnsub = function(fn, value) {
        try {
            fn.call(this._context, value);
        } catch (err) {
            this.unsubscribe();
            throw err;
        }
    };
    SafeSubscriber.prototype.__tryOrSetError = function(parent, fn, value) {
        try {
            fn.call(this._context, value);
        } catch (err) {
            parent.syncErrorValue = err;
            parent.syncErrorThrown = true;
            return true;
        }
        return false;
    };
    /** @deprecated internal use only */ SafeSubscriber.prototype._unsubscribe = function() {
        var _parentSubscriber = this._parentSubscriber;
        this._context = null;
        this._parentSubscriber = null;
        _parentSubscriber.unsubscribe();
    };
    return SafeSubscriber;
}($c5abaf4e7561c1be$var$Subscriber);
function $c5abaf4e7561c1be$var$isTrustedSubscriber(obj) {
    return obj instanceof $c5abaf4e7561c1be$var$Subscriber || "syncErrorThrowable" in obj && obj[$i9WMZ.rxSubscriber];
}

});
parcelRequire.register("6MSkv", function(module, exports) {

$parcel$export(module.exports, "isFunction", () => $4f115e8caabb6d4b$export$f6e2535fb5126e54, (v) => $4f115e8caabb6d4b$export$f6e2535fb5126e54 = v);
var $4f115e8caabb6d4b$export$f6e2535fb5126e54;
"use strict";
function $4f115e8caabb6d4b$var$isFunction(x) {
    return typeof x === "function";
}
$4f115e8caabb6d4b$export$f6e2535fb5126e54 = $4f115e8caabb6d4b$var$isFunction;

});

parcelRequire.register("lSRxI", function(module, exports) {

$parcel$export(module.exports, "Subscription", () => $fee82c9714bdbc24$export$f55210826850c514, (v) => $fee82c9714bdbc24$export$f55210826850c514 = v);
var $fee82c9714bdbc24$export$f55210826850c514;
"use strict";

var $6V6Ta = parcelRequire("6V6Ta");

var $dfcyJ = parcelRequire("dfcyJ");

var $6MSkv = parcelRequire("6MSkv");

var $hQGdZ = parcelRequire("hQGdZ");

var $9hvEt = parcelRequire("9hvEt");

var $kxnok = parcelRequire("kxnok");
/**
 * Represents a disposable resource, such as the execution of an Observable. A
 * Subscription has one important method, `unsubscribe`, that takes no argument
 * and just disposes the resource held by the subscription.
 *
 * Additionally, subscriptions may be grouped together through the `add()`
 * method, which will attach a child Subscription to the current Subscription.
 * When a Subscription is unsubscribed, all its children (and its grandchildren)
 * will be unsubscribed as well.
 *
 * @class Subscription
 */ var $fee82c9714bdbc24$var$Subscription = function() {
    /**
     * @param {function(): void} [unsubscribe] A function describing how to
     * perform the disposal of resources when the `unsubscribe` method is called.
     */ function Subscription(unsubscribe) {
        /**
         * A flag to indicate whether this Subscription has already been unsubscribed.
         * @type {boolean}
         */ this.closed = false;
        this._parent = null;
        this._parents = null;
        this._subscriptions = null;
        if (unsubscribe) this._unsubscribe = unsubscribe;
    }
    /**
     * Disposes the resources held by the subscription. May, for instance, cancel
     * an ongoing Observable execution or cancel any other type of work that
     * started when the Subscription was created.
     * @return {void}
     */ Subscription.prototype.unsubscribe = function() {
        var hasErrors = false;
        var errors;
        if (this.closed) return;
        var _a = this, _parent = _a._parent, _parents = _a._parents, _unsubscribe = _a._unsubscribe, _subscriptions = _a._subscriptions;
        this.closed = true;
        this._parent = null;
        this._parents = null;
        // null out _subscriptions first so any child subscriptions that attempt
        // to remove themselves from this subscription will noop
        this._subscriptions = null;
        var index = -1;
        var len = _parents ? _parents.length : 0;
        // if this._parent is null, then so is this._parents, and we
        // don't have to remove ourselves from any parent subscriptions.
        while(_parent){
            _parent.remove(this);
            // if this._parents is null or index >= len,
            // then _parent is set to null, and the loop exits
            _parent = ++index < len && _parents[index] || null;
        }
        if ($6MSkv.isFunction(_unsubscribe)) {
            var trial = $hQGdZ.tryCatch(_unsubscribe).call(this);
            if (trial === $9hvEt.errorObject) {
                hasErrors = true;
                errors = errors || ($9hvEt.errorObject.e instanceof $kxnok.UnsubscriptionError ? $fee82c9714bdbc24$var$flattenUnsubscriptionErrors($9hvEt.errorObject.e.errors) : [
                    $9hvEt.errorObject.e
                ]);
            }
        }
        if ($6V6Ta.isArray(_subscriptions)) {
            index = -1;
            len = _subscriptions.length;
            while(++index < len){
                var sub = _subscriptions[index];
                if ($dfcyJ.isObject(sub)) {
                    var trial = $hQGdZ.tryCatch(sub.unsubscribe).call(sub);
                    if (trial === $9hvEt.errorObject) {
                        hasErrors = true;
                        errors = errors || [];
                        var err = $9hvEt.errorObject.e;
                        if (err instanceof $kxnok.UnsubscriptionError) errors = errors.concat($fee82c9714bdbc24$var$flattenUnsubscriptionErrors(err.errors));
                        else errors.push(err);
                    }
                }
            }
        }
        if (hasErrors) throw new $kxnok.UnsubscriptionError(errors);
    };
    /**
     * Adds a tear down to be called during the unsubscribe() of this
     * Subscription.
     *
     * If the tear down being added is a subscription that is already
     * unsubscribed, is the same reference `add` is being called on, or is
     * `Subscription.EMPTY`, it will not be added.
     *
     * If this subscription is already in an `closed` state, the passed
     * tear down logic will be executed immediately.
     *
     * @param {TeardownLogic} teardown The additional logic to execute on
     * teardown.
     * @return {Subscription} Returns the Subscription used or created to be
     * added to the inner subscriptions list. This Subscription can be used with
     * `remove()` to remove the passed teardown logic from the inner subscriptions
     * list.
     */ Subscription.prototype.add = function(teardown) {
        if (!teardown || teardown === Subscription.EMPTY) return Subscription.EMPTY;
        if (teardown === this) return this;
        var subscription = teardown;
        switch(typeof teardown){
            case "function":
                subscription = new Subscription(teardown);
            case "object":
                if (subscription.closed || typeof subscription.unsubscribe !== "function") return subscription;
                else if (this.closed) {
                    subscription.unsubscribe();
                    return subscription;
                } else if (typeof subscription._addParent !== "function" /* quack quack */ ) {
                    var tmp = subscription;
                    subscription = new Subscription();
                    subscription._subscriptions = [
                        tmp
                    ];
                }
                break;
            default:
                throw new Error("unrecognized teardown " + teardown + " added to Subscription.");
        }
        var subscriptions = this._subscriptions || (this._subscriptions = []);
        subscriptions.push(subscription);
        subscription._addParent(this);
        return subscription;
    };
    /**
     * Removes a Subscription from the internal list of subscriptions that will
     * unsubscribe during the unsubscribe process of this Subscription.
     * @param {Subscription} subscription The subscription to remove.
     * @return {void}
     */ Subscription.prototype.remove = function(subscription) {
        var subscriptions = this._subscriptions;
        if (subscriptions) {
            var subscriptionIndex = subscriptions.indexOf(subscription);
            if (subscriptionIndex !== -1) subscriptions.splice(subscriptionIndex, 1);
        }
    };
    Subscription.prototype._addParent = function(parent) {
        var _a = this, _parent = _a._parent, _parents = _a._parents;
        if (!_parent || _parent === parent) // If we don't have a parent, or the new parent is the same as the
        // current parent, then set this._parent to the new parent.
        this._parent = parent;
        else if (!_parents) // If there's already one parent, but not multiple, allocate an Array to
        // store the rest of the parent Subscriptions.
        this._parents = [
            parent
        ];
        else if (_parents.indexOf(parent) === -1) // Only add the new parent to the _parents list if it's not already there.
        _parents.push(parent);
    };
    Subscription.EMPTY = function(empty) {
        empty.closed = true;
        return empty;
    }(new Subscription());
    return Subscription;
}();
$fee82c9714bdbc24$export$f55210826850c514 = $fee82c9714bdbc24$var$Subscription;
function $fee82c9714bdbc24$var$flattenUnsubscriptionErrors(errors) {
    return errors.reduce(function(errs, err) {
        return errs.concat(err instanceof $kxnok.UnsubscriptionError ? err.errors : err);
    }, []);
}

});
parcelRequire.register("6V6Ta", function(module, exports) {

$parcel$export(module.exports, "isArray", () => $509d68e97ad56399$export$43bee75e5e14138e, (v) => $509d68e97ad56399$export$43bee75e5e14138e = v);
var $509d68e97ad56399$export$43bee75e5e14138e;
"use strict";
$509d68e97ad56399$export$43bee75e5e14138e = Array.isArray || function(x) {
    return x && typeof x.length === "number";
};

});

parcelRequire.register("dfcyJ", function(module, exports) {

$parcel$export(module.exports, "isObject", () => $9a466b13ca89d181$export$a6cdc56e425d0d0a, (v) => $9a466b13ca89d181$export$a6cdc56e425d0d0a = v);
var $9a466b13ca89d181$export$a6cdc56e425d0d0a;
"use strict";
function $9a466b13ca89d181$var$isObject(x) {
    return x != null && typeof x === "object";
}
$9a466b13ca89d181$export$a6cdc56e425d0d0a = $9a466b13ca89d181$var$isObject;

});

parcelRequire.register("hQGdZ", function(module, exports) {

$parcel$export(module.exports, "tryCatch", () => $cfe80bf0e63bc961$export$d234c058d1d4e435, (v) => $cfe80bf0e63bc961$export$d234c058d1d4e435 = v);
var $cfe80bf0e63bc961$export$d234c058d1d4e435;
"use strict";

var $9hvEt = parcelRequire("9hvEt");
var $cfe80bf0e63bc961$var$tryCatchTarget;
function $cfe80bf0e63bc961$var$tryCatcher() {
    try {
        return $cfe80bf0e63bc961$var$tryCatchTarget.apply(this, arguments);
    } catch (e) {
        $9hvEt.errorObject.e = e;
        return $9hvEt.errorObject;
    }
}
function $cfe80bf0e63bc961$var$tryCatch(fn) {
    $cfe80bf0e63bc961$var$tryCatchTarget = fn;
    return $cfe80bf0e63bc961$var$tryCatcher;
}
$cfe80bf0e63bc961$export$d234c058d1d4e435 = $cfe80bf0e63bc961$var$tryCatch;

});
parcelRequire.register("9hvEt", function(module, exports) {

$parcel$export(module.exports, "errorObject", () => $6c1e40f6756626c5$export$fc504b39d7c1176, (v) => $6c1e40f6756626c5$export$fc504b39d7c1176 = v);
// typeof any so that it we don't have to cast when comparing a result to the error object
var $6c1e40f6756626c5$export$fc504b39d7c1176;
"use strict";
$6c1e40f6756626c5$export$fc504b39d7c1176 = {
    e: {}
};

});


parcelRequire.register("kxnok", function(module, exports) {
"use strict";
var $ef3908c86011fa5a$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
/**
 * An error thrown when one or more errors have occurred during the
 * `unsubscribe` of a {@link Subscription}.
 */ var $ef3908c86011fa5a$var$UnsubscriptionError = function(_super) {
    $ef3908c86011fa5a$var$__extends(UnsubscriptionError, _super);
    function UnsubscriptionError(errors) {
        _super.call(this);
        this.errors = errors;
        var err = Error.call(this, errors ? errors.length + " errors occurred during unsubscription:\n  " + errors.map(function(err, i) {
            return i + 1 + ") " + err.toString();
        }).join("\n  ") : "");
        this.name = err.name = "UnsubscriptionError";
        this.stack = err.stack;
        this.message = err.message;
    }
    return UnsubscriptionError;
}(Error);
module.exports.UnsubscriptionError = $ef3908c86011fa5a$var$UnsubscriptionError;

});


parcelRequire.register("jMM09", function(module, exports) {

$parcel$export(module.exports, "empty", () => $e677bc158184ce63$export$6e22c362a0406a2c, (v) => $e677bc158184ce63$export$6e22c362a0406a2c = v);
var $e677bc158184ce63$export$6e22c362a0406a2c;
"use strict";
$e677bc158184ce63$export$6e22c362a0406a2c = {
    closed: true,
    next: function(value) {},
    error: function(err) {
        throw err;
    },
    complete: function() {}
};

});

parcelRequire.register("i9WMZ", function(module, exports) {

$parcel$export(module.exports, "rxSubscriber", () => $d386ab8e60881464$export$77f77496d7cade10, (v) => $d386ab8e60881464$export$77f77496d7cade10 = v);
var $d386ab8e60881464$export$77f77496d7cade10;
/**
 * @deprecated use rxSubscriber instead
 */ var $d386ab8e60881464$export$4a2e07ff24d010f0;
"use strict";

var $hGUNf = parcelRequire("hGUNf");
var $d386ab8e60881464$var$Symbol = $hGUNf.root.Symbol;
$d386ab8e60881464$export$77f77496d7cade10 = typeof $d386ab8e60881464$var$Symbol === "function" && typeof $d386ab8e60881464$var$Symbol.for === "function" ? $d386ab8e60881464$var$Symbol.for("rxSubscriber") : "@@rxSubscriber";
$d386ab8e60881464$export$4a2e07ff24d010f0 = $d386ab8e60881464$export$77f77496d7cade10;

});



parcelRequire.register("bhQVP", function(module, exports) {

$parcel$export(module.exports, "observable", () => $837a5762fc0277d3$export$5ab46cbf6120b33a, (v) => $837a5762fc0277d3$export$5ab46cbf6120b33a = v);
var $837a5762fc0277d3$export$7e68bb2e8ecea8fe;
var $837a5762fc0277d3$export$5ab46cbf6120b33a;
/**
 * @deprecated use observable instead
 */ var $837a5762fc0277d3$export$a7c40509ff863847;
"use strict";

var $hGUNf = parcelRequire("hGUNf");
function $837a5762fc0277d3$var$getSymbolObservable(context) {
    var $$observable;
    var Symbol = context.Symbol;
    if (typeof Symbol === "function") {
        if (Symbol.observable) $$observable = Symbol.observable;
        else {
            $$observable = Symbol("observable");
            Symbol.observable = $$observable;
        }
    } else $$observable = "@@observable";
    return $$observable;
}
$837a5762fc0277d3$export$7e68bb2e8ecea8fe = $837a5762fc0277d3$var$getSymbolObservable;
$837a5762fc0277d3$export$5ab46cbf6120b33a = $837a5762fc0277d3$var$getSymbolObservable($hGUNf.root);
$837a5762fc0277d3$export$a7c40509ff863847 = $837a5762fc0277d3$export$5ab46cbf6120b33a;

});

parcelRequire.register("dXgYL", function(module, exports) {

$parcel$export(module.exports, "pipeFromArray", () => $a28df4bf3ee4ad7a$export$71f88a61afaa14d7, (v) => $a28df4bf3ee4ad7a$export$71f88a61afaa14d7 = v);
var $a28df4bf3ee4ad7a$export$a4627e546088548d;
var $a28df4bf3ee4ad7a$export$71f88a61afaa14d7;
"use strict";

var $lMnZx = parcelRequire("lMnZx");
/* tslint:enable:max-line-length */ function $a28df4bf3ee4ad7a$var$pipe() {
    var fns = [];
    for(var _i = 0; _i < arguments.length; _i++)fns[_i - 0] = arguments[_i];
    return $a28df4bf3ee4ad7a$var$pipeFromArray(fns);
}
$a28df4bf3ee4ad7a$export$a4627e546088548d = $a28df4bf3ee4ad7a$var$pipe;
/* @internal */ function $a28df4bf3ee4ad7a$var$pipeFromArray(fns) {
    if (!fns) return $lMnZx.noop;
    if (fns.length === 1) return fns[0];
    return function piped(input) {
        return fns.reduce(function(prev, fn) {
            return fn(prev);
        }, input);
    };
}
$a28df4bf3ee4ad7a$export$71f88a61afaa14d7 = $a28df4bf3ee4ad7a$var$pipeFromArray;

});
parcelRequire.register("lMnZx", function(module, exports) {

$parcel$export(module.exports, "noop", () => $fdb0b0e5f8e6448e$export$8793edee2d425525, (v) => $fdb0b0e5f8e6448e$export$8793edee2d425525 = v);
var $fdb0b0e5f8e6448e$export$8793edee2d425525;
"use strict";
/* tslint:disable:no-empty */ function $fdb0b0e5f8e6448e$var$noop() {}
$fdb0b0e5f8e6448e$export$8793edee2d425525 = $fdb0b0e5f8e6448e$var$noop;

});



parcelRequire.register("cKPYe", function(module, exports) {
"use strict";
var $9492182a688007ff$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
/**
 * An error thrown when an action is invalid because the object has been
 * unsubscribed.
 *
 * @see {@link Subject}
 * @see {@link BehaviorSubject}
 *
 * @class ObjectUnsubscribedError
 */ var $9492182a688007ff$var$ObjectUnsubscribedError = function(_super) {
    $9492182a688007ff$var$__extends(ObjectUnsubscribedError, _super);
    function ObjectUnsubscribedError() {
        var err = _super.call(this, "object unsubscribed");
        this.name = err.name = "ObjectUnsubscribedError";
        this.stack = err.stack;
        this.message = err.message;
    }
    return ObjectUnsubscribedError;
}(Error);
module.exports.ObjectUnsubscribedError = $9492182a688007ff$var$ObjectUnsubscribedError;

});

parcelRequire.register("7IBvb", function(module, exports) {
"use strict";
var $59e9bb96a5251fb0$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $lSRxI = parcelRequire("lSRxI");
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $59e9bb96a5251fb0$var$SubjectSubscription = function(_super) {
    $59e9bb96a5251fb0$var$__extends(SubjectSubscription, _super);
    function SubjectSubscription(subject, subscriber) {
        _super.call(this);
        this.subject = subject;
        this.subscriber = subscriber;
        this.closed = false;
    }
    SubjectSubscription.prototype.unsubscribe = function() {
        if (this.closed) return;
        this.closed = true;
        var subject = this.subject;
        var observers = subject.observers;
        this.subject = null;
        if (!observers || observers.length === 0 || subject.isStopped || subject.closed) return;
        var subscriberIndex = observers.indexOf(this.subscriber);
        if (subscriberIndex !== -1) observers.splice(subscriberIndex, 1);
    };
    return SubjectSubscription;
}($lSRxI.Subscription);
module.exports.SubjectSubscription = $59e9bb96a5251fb0$var$SubjectSubscription;

});



parcelRequire.register("lvV06", function(module, exports) {

$parcel$export(module.exports, "async", () => $fa98b55e86bc420c$export$12af436354f1a4f7, (v) => $fa98b55e86bc420c$export$12af436354f1a4f7 = v);
/**
 *
 * Async Scheduler
 *
 * <span class="informal">Schedule task as if you used setTimeout(task, duration)</span>
 *
 * `async` scheduler schedules tasks asynchronously, by putting them on the JavaScript
 * event loop queue. It is best used to delay tasks in time or to schedule tasks repeating
 * in intervals.
 *
 * If you just want to "defer" task, that is to perform it right after currently
 * executing synchronous code ends (commonly achieved by `setTimeout(deferredTask, 0)`),
 * better choice will be the {@link asap} scheduler.
 *
 * @example <caption>Use async scheduler to delay task</caption>
 * const task = () => console.log('it works!');
 *
 * Rx.Scheduler.async.schedule(task, 2000);
 *
 * // After 2 seconds logs:
 * // "it works!"
 *
 *
 * @example <caption>Use async scheduler to repeat task in intervals</caption>
 * function task(state) {
 *   console.log(state);
 *   this.schedule(state + 1, 1000); // `this` references currently executing Action,
 *                                   // which we reschedule with new state and delay
 * }
 *
 * Rx.Scheduler.async.schedule(task, 3000, 0);
 *
 * // Logs:
 * // 0 after 3s
 * // 1 after 4s
 * // 2 after 5s
 * // 3 after 6s
 *
 * @static true
 * @name async
 * @owner Scheduler
 */ var $fa98b55e86bc420c$export$12af436354f1a4f7;
"use strict";

var $aE1p0 = parcelRequire("aE1p0");

var $4lZyi = parcelRequire("4lZyi");
$fa98b55e86bc420c$export$12af436354f1a4f7 = new $4lZyi.AsyncScheduler($aE1p0.AsyncAction);

});
parcelRequire.register("aE1p0", function(module, exports) {
"use strict";
var $7bfeba4a0724c57a$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $hGUNf = parcelRequire("hGUNf");

var $kaWeq = parcelRequire("kaWeq");
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $7bfeba4a0724c57a$var$AsyncAction = function(_super) {
    $7bfeba4a0724c57a$var$__extends(AsyncAction, _super);
    function AsyncAction(scheduler, work) {
        _super.call(this, scheduler, work);
        this.scheduler = scheduler;
        this.pending = false;
        this.work = work;
    }
    AsyncAction.prototype.schedule = function(state, delay) {
        if (delay === void 0) delay = 0;
        if (this.closed) return this;
        // Always replace the current state with the new state.
        this.state = state;
        // Set the pending flag indicating that this action has been scheduled, or
        // has recursively rescheduled itself.
        this.pending = true;
        var id = this.id;
        var scheduler = this.scheduler;
        //
        // Important implementation note:
        //
        // Actions only execute once by default, unless rescheduled from within the
        // scheduled callback. This allows us to implement single and repeat
        // actions via the same code path, without adding API surface area, as well
        // as mimic traditional recursion but across asynchronous boundaries.
        //
        // However, JS runtimes and timers distinguish between intervals achieved by
        // serial `setTimeout` calls vs. a single `setInterval` call. An interval of
        // serial `setTimeout` calls can be individually delayed, which delays
        // scheduling the next `setTimeout`, and so on. `setInterval` attempts to
        // guarantee the interval callback will be invoked more precisely to the
        // interval period, regardless of load.
        //
        // Therefore, we use `setInterval` to schedule single and repeat actions.
        // If the action reschedules itself with the same delay, the interval is not
        // canceled. If the action doesn't reschedule, or reschedules with a
        // different delay, the interval will be canceled after scheduled callback
        // execution.
        //
        if (id != null) this.id = this.recycleAsyncId(scheduler, id, delay);
        this.delay = delay;
        // If this action has already an async Id, don't request a new one.
        this.id = this.id || this.requestAsyncId(scheduler, this.id, delay);
        return this;
    };
    AsyncAction.prototype.requestAsyncId = function(scheduler, id, delay) {
        if (delay === void 0) delay = 0;
        return $hGUNf.root.setInterval(scheduler.flush.bind(scheduler, this), delay);
    };
    AsyncAction.prototype.recycleAsyncId = function(scheduler, id, delay) {
        if (delay === void 0) delay = 0;
        // If this action is rescheduled with the same delay time, don't clear the interval id.
        if (delay !== null && this.delay === delay && this.pending === false) return id;
        // Otherwise, if the action's delay time is different from the current delay,
        // or the action has been rescheduled before it's executed, clear the interval id
        return $hGUNf.root.clearInterval(id) && undefined, undefined;
    };
    /**
     * Immediately executes this action and the `work` it contains.
     * @return {any}
     */ AsyncAction.prototype.execute = function(state, delay) {
        if (this.closed) return new Error("executing a cancelled action");
        this.pending = false;
        var error = this._execute(state, delay);
        if (error) return error;
        else if (this.pending === false && this.id != null) // Dequeue if the action didn't reschedule itself. Don't call
        // unsubscribe(), because the action could reschedule later.
        // For example:
        // ```
        // scheduler.schedule(function doWork(counter) {
        //   /* ... I'm a busy worker bee ... */
        //   var originalAction = this;
        //   /* wait 100ms before rescheduling the action */
        //   setTimeout(function () {
        //     originalAction.schedule(counter + 1);
        //   }, 100);
        // }, 1000);
        // ```
        this.id = this.recycleAsyncId(this.scheduler, this.id, null);
    };
    AsyncAction.prototype._execute = function(state, delay) {
        var errored = false;
        var errorValue = undefined;
        try {
            this.work(state);
        } catch (e) {
            errored = true;
            errorValue = !!e && e || new Error(e);
        }
        if (errored) {
            this.unsubscribe();
            return errorValue;
        }
    };
    /** @deprecated internal use only */ AsyncAction.prototype._unsubscribe = function() {
        var id = this.id;
        var scheduler = this.scheduler;
        var actions = scheduler.actions;
        var index = actions.indexOf(this);
        this.work = null;
        this.state = null;
        this.pending = false;
        this.scheduler = null;
        if (index !== -1) actions.splice(index, 1);
        if (id != null) this.id = this.recycleAsyncId(scheduler, id, null);
        this.delay = null;
    };
    return AsyncAction;
}($kaWeq.Action);
module.exports.AsyncAction = $7bfeba4a0724c57a$var$AsyncAction;

});
parcelRequire.register("kaWeq", function(module, exports) {
"use strict";
var $eb01e963c0d1ee62$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $lSRxI = parcelRequire("lSRxI");
/**
 * A unit of work to be executed in a {@link Scheduler}. An action is typically
 * created from within a Scheduler and an RxJS user does not need to concern
 * themselves about creating and manipulating an Action.
 *
 * ```ts
 * class Action<T> extends Subscription {
 *   new (scheduler: Scheduler, work: (state?: T) => void);
 *   schedule(state?: T, delay: number = 0): Subscription;
 * }
 * ```
 *
 * @class Action<T>
 */ var $eb01e963c0d1ee62$var$Action = function(_super) {
    $eb01e963c0d1ee62$var$__extends(Action, _super);
    function Action(scheduler, work) {
        _super.call(this);
    }
    /**
     * Schedules this action on its parent Scheduler for execution. May be passed
     * some context object, `state`. May happen at some point in the future,
     * according to the `delay` parameter, if specified.
     * @param {T} [state] Some contextual data that the `work` function uses when
     * called by the Scheduler.
     * @param {number} [delay] Time to wait before executing the work, where the
     * time unit is implicit and defined by the Scheduler.
     * @return {void}
     */ Action.prototype.schedule = function(state, delay) {
        if (delay === void 0) delay = 0;
        return this;
    };
    return Action;
}($lSRxI.Subscription);
module.exports.Action = $eb01e963c0d1ee62$var$Action;

});


parcelRequire.register("4lZyi", function(module, exports) {
"use strict";
var $32b8de96a4171c60$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $jGtIp = parcelRequire("jGtIp");
var $32b8de96a4171c60$var$AsyncScheduler = function(_super) {
    $32b8de96a4171c60$var$__extends(AsyncScheduler, _super);
    function AsyncScheduler() {
        _super.apply(this, arguments);
        this.actions = [];
        /**
         * A flag to indicate whether the Scheduler is currently executing a batch of
         * queued actions.
         * @type {boolean}
         */ this.active = false;
        /**
         * An internal ID used to track the latest asynchronous task such as those
         * coming from `setTimeout`, `setInterval`, `requestAnimationFrame`, and
         * others.
         * @type {any}
         */ this.scheduled = undefined;
    }
    AsyncScheduler.prototype.flush = function(action) {
        var actions = this.actions;
        if (this.active) {
            actions.push(action);
            return;
        }
        var error;
        this.active = true;
        do {
            if (error = action.execute(action.state, action.delay)) break;
        }while (action = actions.shift()); // exhaust the scheduler queue
        this.active = false;
        if (error) {
            while(action = actions.shift())action.unsubscribe();
            throw error;
        }
    };
    return AsyncScheduler;
}($jGtIp.Scheduler);
module.exports.AsyncScheduler = $32b8de96a4171c60$var$AsyncScheduler;

});
parcelRequire.register("jGtIp", function(module, exports) {

$parcel$export(module.exports, "Scheduler", () => $e548fd6554372374$export$d3e54bb8584cda7c, (v) => $e548fd6554372374$export$d3e54bb8584cda7c = v);
var $e548fd6554372374$export$d3e54bb8584cda7c;
"use strict";
/**
 * An execution context and a data structure to order tasks and schedule their
 * execution. Provides a notion of (potentially virtual) time, through the
 * `now()` getter method.
 *
 * Each unit of work in a Scheduler is called an {@link Action}.
 *
 * ```ts
 * class Scheduler {
 *   now(): number;
 *   schedule(work, delay?, state?): Subscription;
 * }
 * ```
 *
 * @class Scheduler
 */ var $e548fd6554372374$var$Scheduler = function() {
    function Scheduler(SchedulerAction, now) {
        if (now === void 0) now = Scheduler.now;
        this.SchedulerAction = SchedulerAction;
        this.now = now;
    }
    /**
     * Schedules a function, `work`, for execution. May happen at some point in
     * the future, according to the `delay` parameter, if specified. May be passed
     * some context object, `state`, which will be passed to the `work` function.
     *
     * The given arguments will be processed an stored as an Action object in a
     * queue of actions.
     *
     * @param {function(state: ?T): ?Subscription} work A function representing a
     * task, or some unit of work to be executed by the Scheduler.
     * @param {number} [delay] Time to wait before executing the work, where the
     * time unit is implicit and defined by the Scheduler itself.
     * @param {T} [state] Some contextual data that the `work` function uses when
     * called by the Scheduler.
     * @return {Subscription} A subscription in order to be able to unsubscribe
     * the scheduled work.
     */ Scheduler.prototype.schedule = function(work, delay, state) {
        if (delay === void 0) delay = 0;
        return new this.SchedulerAction(this, work).schedule(state, delay);
    };
    Scheduler.now = Date.now ? Date.now : function() {
        return +new Date();
    };
    return Scheduler;
}();
$e548fd6554372374$export$d3e54bb8584cda7c = $e548fd6554372374$var$Scheduler;

});



parcelRequire.register("cxO31", function(module, exports) {
"use strict";

var $lyDVs = parcelRequire("lyDVs");

var $h5IeP = parcelRequire("h5IeP");
$lyDVs.Observable.prototype.catch = $h5IeP._catch;
$lyDVs.Observable.prototype._catch = $h5IeP._catch;

});
parcelRequire.register("h5IeP", function(module, exports) {

$parcel$export(module.exports, "_catch", () => $c715380d7169f85c$export$7f43fa37c3d8a0b3, (v) => $c715380d7169f85c$export$7f43fa37c3d8a0b3 = v);
var $c715380d7169f85c$export$7f43fa37c3d8a0b3;
"use strict";

var $4S9XW = parcelRequire("4S9XW");
/**
 * Catches errors on the observable to be handled by returning a new observable or throwing an error.
 *
 * <img src="./img/catch.png" width="100%">
 *
 * @example <caption>Continues with a different Observable when there's an error</caption>
 *
 * Observable.of(1, 2, 3, 4, 5)
 *   .map(n => {
 * 	   if (n == 4) {
 * 	     throw 'four!';
 *     }
 *	   return n;
 *   })
 *   .catch(err => Observable.of('I', 'II', 'III', 'IV', 'V'))
 *   .subscribe(x => console.log(x));
 *   // 1, 2, 3, I, II, III, IV, V
 *
 * @example <caption>Retries the caught source Observable again in case of error, similar to retry() operator</caption>
 *
 * Observable.of(1, 2, 3, 4, 5)
 *   .map(n => {
 * 	   if (n === 4) {
 * 	     throw 'four!';
 *     }
 * 	   return n;
 *   })
 *   .catch((err, caught) => caught)
 *   .take(30)
 *   .subscribe(x => console.log(x));
 *   // 1, 2, 3, 1, 2, 3, ...
 *
 * @example <caption>Throws a new error when the source Observable throws an error</caption>
 *
 * Observable.of(1, 2, 3, 4, 5)
 *   .map(n => {
 *     if (n == 4) {
 *       throw 'four!';
 *     }
 *     return n;
 *   })
 *   .catch(err => {
 *     throw 'error in source. Details: ' + err;
 *   })
 *   .subscribe(
 *     x => console.log(x),
 *     err => console.log(err)
 *   );
 *   // 1, 2, 3, error in source. Details: four!
 *
 * @param {function} selector a function that takes as arguments `err`, which is the error, and `caught`, which
 *  is the source observable, in case you'd like to "retry" that observable by returning it again. Whatever observable
 *  is returned by the `selector` will be used to continue the observable chain.
 * @return {Observable} An observable that originates from either the source or the observable returned by the
 *  catch `selector` function.
 * @method catch
 * @name catch
 * @owner Observable
 */ function $c715380d7169f85c$var$_catch(selector) {
    return $4S9XW.catchError(selector)(this);
}
$c715380d7169f85c$export$7f43fa37c3d8a0b3 = $c715380d7169f85c$var$_catch;

});
parcelRequire.register("4S9XW", function(module, exports) {
"use strict";
var $38c3ef8ce7c1da07$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $2HYhY = parcelRequire("2HYhY");

var $dkOaF = parcelRequire("dkOaF");
/**
 * Catches errors on the observable to be handled by returning a new observable or throwing an error.
 *
 * <img src="./img/catch.png" width="100%">
 *
 * @example <caption>Continues with a different Observable when there's an error</caption>
 *
 * Observable.of(1, 2, 3, 4, 5)
 *   .map(n => {
 * 	   if (n == 4) {
 * 	     throw 'four!';
 *     }
 *	   return n;
 *   })
 *   .catch(err => Observable.of('I', 'II', 'III', 'IV', 'V'))
 *   .subscribe(x => console.log(x));
 *   // 1, 2, 3, I, II, III, IV, V
 *
 * @example <caption>Retries the caught source Observable again in case of error, similar to retry() operator</caption>
 *
 * Observable.of(1, 2, 3, 4, 5)
 *   .map(n => {
 * 	   if (n === 4) {
 * 	     throw 'four!';
 *     }
 * 	   return n;
 *   })
 *   .catch((err, caught) => caught)
 *   .take(30)
 *   .subscribe(x => console.log(x));
 *   // 1, 2, 3, 1, 2, 3, ...
 *
 * @example <caption>Throws a new error when the source Observable throws an error</caption>
 *
 * Observable.of(1, 2, 3, 4, 5)
 *   .map(n => {
 *     if (n == 4) {
 *       throw 'four!';
 *     }
 *     return n;
 *   })
 *   .catch(err => {
 *     throw 'error in source. Details: ' + err;
 *   })
 *   .subscribe(
 *     x => console.log(x),
 *     err => console.log(err)
 *   );
 *   // 1, 2, 3, error in source. Details: four!
 *
 * @param {function} selector a function that takes as arguments `err`, which is the error, and `caught`, which
 *  is the source observable, in case you'd like to "retry" that observable by returning it again. Whatever observable
 *  is returned by the `selector` will be used to continue the observable chain.
 * @return {Observable} An observable that originates from either the source or the observable returned by the
 *  catch `selector` function.
 * @name catchError
 */ function $38c3ef8ce7c1da07$var$catchError(selector) {
    return function catchErrorOperatorFunction(source) {
        var operator = new $38c3ef8ce7c1da07$var$CatchOperator(selector);
        var caught = source.lift(operator);
        return operator.caught = caught;
    };
}
module.exports.catchError = $38c3ef8ce7c1da07$var$catchError;
var $38c3ef8ce7c1da07$var$CatchOperator = function() {
    function CatchOperator(selector) {
        this.selector = selector;
    }
    CatchOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $38c3ef8ce7c1da07$var$CatchSubscriber(subscriber, this.selector, this.caught));
    };
    return CatchOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $38c3ef8ce7c1da07$var$CatchSubscriber = function(_super) {
    $38c3ef8ce7c1da07$var$__extends(CatchSubscriber, _super);
    function CatchSubscriber(destination, selector, caught) {
        _super.call(this, destination);
        this.selector = selector;
        this.caught = caught;
    }
    // NOTE: overriding `error` instead of `_error` because we don't want
    // to have this flag this subscriber as `isStopped`. We can mimic the
    // behavior of the RetrySubscriber (from the `retry` operator), where
    // we unsubscribe from our source chain, reset our Subscriber flags,
    // then subscribe to the selector result.
    CatchSubscriber.prototype.error = function(err) {
        if (!this.isStopped) {
            var result = void 0;
            try {
                result = this.selector(err, this.caught);
            } catch (err2) {
                _super.prototype.error.call(this, err2);
                return;
            }
            this._unsubscribeAndRecycle();
            this.add($dkOaF.subscribeToResult(this, result));
        }
    };
    return CatchSubscriber;
}($2HYhY.OuterSubscriber);

});
parcelRequire.register("2HYhY", function(module, exports) {
"use strict";
var $1f8e5d0f9c69435e$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $gYcab = parcelRequire("gYcab");
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $1f8e5d0f9c69435e$var$OuterSubscriber = function(_super) {
    $1f8e5d0f9c69435e$var$__extends(OuterSubscriber, _super);
    function OuterSubscriber() {
        _super.apply(this, arguments);
    }
    OuterSubscriber.prototype.notifyNext = function(outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        this.destination.next(innerValue);
    };
    OuterSubscriber.prototype.notifyError = function(error, innerSub) {
        this.destination.error(error);
    };
    OuterSubscriber.prototype.notifyComplete = function(innerSub) {
        this.destination.complete();
    };
    return OuterSubscriber;
}($gYcab.Subscriber);
module.exports.OuterSubscriber = $1f8e5d0f9c69435e$var$OuterSubscriber;

});

parcelRequire.register("dkOaF", function(module, exports) {

$parcel$export(module.exports, "subscribeToResult", () => $9b540f852ad64725$export$d0604af3321cfb1b, (v) => $9b540f852ad64725$export$d0604af3321cfb1b = v);
var $9b540f852ad64725$export$d0604af3321cfb1b;
"use strict";

var $hGUNf = parcelRequire("hGUNf");

var $lwvLm = parcelRequire("lwvLm");

var $lHMn8 = parcelRequire("lHMn8");

var $dfcyJ = parcelRequire("dfcyJ");

var $lyDVs = parcelRequire("lyDVs");

var $iRyhk = parcelRequire("iRyhk");

var $bnq9t = parcelRequire("bnq9t");

var $bhQVP = parcelRequire("bhQVP");
function $9b540f852ad64725$var$subscribeToResult(outerSubscriber, result, outerValue, outerIndex) {
    var destination = new $bnq9t.InnerSubscriber(outerSubscriber, outerValue, outerIndex);
    if (destination.closed) return null;
    if (result instanceof $lyDVs.Observable) {
        if (result._isScalar) {
            destination.next(result.value);
            destination.complete();
            return null;
        } else {
            destination.syncErrorThrowable = true;
            return result.subscribe(destination);
        }
    } else if ($lwvLm.isArrayLike(result)) {
        for(var i = 0, len = result.length; i < len && !destination.closed; i++)destination.next(result[i]);
        if (!destination.closed) destination.complete();
    } else if ($lHMn8.isPromise(result)) {
        result.then(function(value) {
            if (!destination.closed) {
                destination.next(value);
                destination.complete();
            }
        }, function(err) {
            return destination.error(err);
        }).then(null, function(err) {
            // Escaping the Promise trap: globally throw unhandled errors
            $hGUNf.root.setTimeout(function() {
                throw err;
            });
        });
        return destination;
    } else if (result && typeof result[$iRyhk.iterator] === "function") {
        var iterator = result[$iRyhk.iterator]();
        do {
            var item = iterator.next();
            if (item.done) {
                destination.complete();
                break;
            }
            destination.next(item.value);
            if (destination.closed) break;
        }while (true);
    } else if (result && typeof result[$bhQVP.observable] === "function") {
        var obs = result[$bhQVP.observable]();
        if (typeof obs.subscribe !== "function") destination.error(new TypeError("Provided object does not correctly implement Symbol.observable"));
        else return obs.subscribe(new $bnq9t.InnerSubscriber(outerSubscriber, outerValue, outerIndex));
    } else {
        var value = $dfcyJ.isObject(result) ? "an invalid object" : "'" + result + "'";
        var msg = "You provided " + value + " where a stream was expected." + " You can provide an Observable, Promise, Array, or Iterable.";
        destination.error(new TypeError(msg));
    }
    return null;
}
$9b540f852ad64725$export$d0604af3321cfb1b = $9b540f852ad64725$var$subscribeToResult;

});
parcelRequire.register("lwvLm", function(module, exports) {

$parcel$export(module.exports, "isArrayLike", () => $fab5399418e4c621$export$1e2f57719e155213, (v) => $fab5399418e4c621$export$1e2f57719e155213 = v);
var $fab5399418e4c621$export$1e2f57719e155213;
"use strict";
$fab5399418e4c621$export$1e2f57719e155213 = function(x) {
    return x && typeof x.length === "number";
};

});

parcelRequire.register("lHMn8", function(module, exports) {

$parcel$export(module.exports, "isPromise", () => $fcd322cd302e0aa6$export$4369c812aac99591, (v) => $fcd322cd302e0aa6$export$4369c812aac99591 = v);
var $fcd322cd302e0aa6$export$4369c812aac99591;
"use strict";
function $fcd322cd302e0aa6$var$isPromise(value) {
    return value && typeof value.subscribe !== "function" && typeof value.then === "function";
}
$fcd322cd302e0aa6$export$4369c812aac99591 = $fcd322cd302e0aa6$var$isPromise;

});

parcelRequire.register("iRyhk", function(module, exports) {

$parcel$export(module.exports, "iterator", () => $dbb7c43517697216$export$6f58e2338da23f4d, (v) => $dbb7c43517697216$export$6f58e2338da23f4d = v);
var $dbb7c43517697216$export$77b88d321d1c84c6;
var $dbb7c43517697216$export$6f58e2338da23f4d;
/**
 * @deprecated use iterator instead
 */ var $dbb7c43517697216$export$9785f547d3164dac;
"use strict";

var $hGUNf = parcelRequire("hGUNf");
function $dbb7c43517697216$var$symbolIteratorPonyfill(root) {
    var Symbol = root.Symbol;
    if (typeof Symbol === "function") {
        if (!Symbol.iterator) Symbol.iterator = Symbol("iterator polyfill");
        return Symbol.iterator;
    } else {
        // [for Mozilla Gecko 27-35:](https://mzl.la/2ewE1zC)
        var Set_1 = root.Set;
        if (Set_1 && typeof new Set_1()["@@iterator"] === "function") return "@@iterator";
        var Map_1 = root.Map;
        // required for compatability with es6-shim
        if (Map_1) {
            var keys = Object.getOwnPropertyNames(Map_1.prototype);
            for(var i = 0; i < keys.length; ++i){
                var key = keys[i];
                // according to spec, Map.prototype[@@iterator] and Map.orototype.entries must be equal.
                if (key !== "entries" && key !== "size" && Map_1.prototype[key] === Map_1.prototype["entries"]) return key;
            }
        }
        return "@@iterator";
    }
}
$dbb7c43517697216$export$77b88d321d1c84c6 = $dbb7c43517697216$var$symbolIteratorPonyfill;
$dbb7c43517697216$export$6f58e2338da23f4d = $dbb7c43517697216$var$symbolIteratorPonyfill($hGUNf.root);
$dbb7c43517697216$export$9785f547d3164dac = $dbb7c43517697216$export$6f58e2338da23f4d;

});

parcelRequire.register("bnq9t", function(module, exports) {
"use strict";
var $848620e3c8f44781$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $gYcab = parcelRequire("gYcab");
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $848620e3c8f44781$var$InnerSubscriber = function(_super) {
    $848620e3c8f44781$var$__extends(InnerSubscriber, _super);
    function InnerSubscriber(parent, outerValue, outerIndex) {
        _super.call(this);
        this.parent = parent;
        this.outerValue = outerValue;
        this.outerIndex = outerIndex;
        this.index = 0;
    }
    InnerSubscriber.prototype._next = function(value) {
        this.parent.notifyNext(this.outerValue, value, this.outerIndex, this.index++, this);
    };
    InnerSubscriber.prototype._error = function(error) {
        this.parent.notifyError(error, this);
        this.unsubscribe();
    };
    InnerSubscriber.prototype._complete = function() {
        this.parent.notifyComplete(this);
        this.unsubscribe();
    };
    return InnerSubscriber;
}($gYcab.Subscriber);
module.exports.InnerSubscriber = $848620e3c8f44781$var$InnerSubscriber;

});





parcelRequire.register("l3vao", function(module, exports) {
"use strict";

var $lyDVs = parcelRequire("lyDVs");

var $gZCZI = parcelRequire("gZCZI");
$lyDVs.Observable.prototype.combineLatest = $gZCZI.combineLatest;

});
parcelRequire.register("gZCZI", function(module, exports) {

$parcel$export(module.exports, "combineLatest", () => $c5f097542fdb32eb$export$77fa7d86f5204e8a, (v) => $c5f097542fdb32eb$export$77fa7d86f5204e8a = v);
var $c5f097542fdb32eb$export$77fa7d86f5204e8a;
"use strict";

var $hM9Dc = parcelRequire("hM9Dc");
/* tslint:enable:max-line-length */ /**
 * Combines multiple Observables to create an Observable whose values are
 * calculated from the latest values of each of its input Observables.
 *
 * <span class="informal">Whenever any input Observable emits a value, it
 * computes a formula using the latest values from all the inputs, then emits
 * the output of that formula.</span>
 *
 * <img src="./img/combineLatest.png" width="100%">
 *
 * `combineLatest` combines the values from this Observable with values from
 * Observables passed as arguments. This is done by subscribing to each
 * Observable, in order, and collecting an array of each of the most recent
 * values any time any of the input Observables emits, then either taking that
 * array and passing it as arguments to an optional `project` function and
 * emitting the return value of that, or just emitting the array of recent
 * values directly if there is no `project` function.
 *
 * @example <caption>Dynamically calculate the Body-Mass Index from an Observable of weight and one for height</caption>
 * var weight = Rx.Observable.of(70, 72, 76, 79, 75);
 * var height = Rx.Observable.of(1.76, 1.77, 1.78);
 * var bmi = weight.combineLatest(height, (w, h) => w / (h * h));
 * bmi.subscribe(x => console.log('BMI is ' + x));
 *
 * // With output to console:
 * // BMI is 24.212293388429753
 * // BMI is 23.93948099205209
 * // BMI is 23.671253629592222
 *
 * @see {@link combineAll}
 * @see {@link merge}
 * @see {@link withLatestFrom}
 *
 * @param {ObservableInput} other An input Observable to combine with the source
 * Observable. More than one input Observables may be given as argument.
 * @param {function} [project] An optional function to project the values from
 * the combined latest values into a new value on the output Observable.
 * @return {Observable} An Observable of projected values from the most recent
 * values from each input Observable, or an array of the most recent values from
 * each input Observable.
 * @method combineLatest
 * @owner Observable
 */ function $c5f097542fdb32eb$var$combineLatest() {
    var observables = [];
    for(var _i = 0; _i < arguments.length; _i++)observables[_i - 0] = arguments[_i];
    return $hM9Dc.combineLatest.apply(void 0, observables)(this);
}
$c5f097542fdb32eb$export$77fa7d86f5204e8a = $c5f097542fdb32eb$var$combineLatest;

});
parcelRequire.register("hM9Dc", function(module, exports) {
"use strict";
var $cf0e63ea54fafb1f$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $8y8sl = parcelRequire("8y8sl");

var $6V6Ta = parcelRequire("6V6Ta");

var $2HYhY = parcelRequire("2HYhY");

var $dkOaF = parcelRequire("dkOaF");
var $cf0e63ea54fafb1f$var$none = {};
/* tslint:enable:max-line-length */ /**
 * Combines multiple Observables to create an Observable whose values are
 * calculated from the latest values of each of its input Observables.
 *
 * <span class="informal">Whenever any input Observable emits a value, it
 * computes a formula using the latest values from all the inputs, then emits
 * the output of that formula.</span>
 *
 * <img src="./img/combineLatest.png" width="100%">
 *
 * `combineLatest` combines the values from this Observable with values from
 * Observables passed as arguments. This is done by subscribing to each
 * Observable, in order, and collecting an array of each of the most recent
 * values any time any of the input Observables emits, then either taking that
 * array and passing it as arguments to an optional `project` function and
 * emitting the return value of that, or just emitting the array of recent
 * values directly if there is no `project` function.
 *
 * @example <caption>Dynamically calculate the Body-Mass Index from an Observable of weight and one for height</caption>
 * var weight = Rx.Observable.of(70, 72, 76, 79, 75);
 * var height = Rx.Observable.of(1.76, 1.77, 1.78);
 * var bmi = weight.combineLatest(height, (w, h) => w / (h * h));
 * bmi.subscribe(x => console.log('BMI is ' + x));
 *
 * // With output to console:
 * // BMI is 24.212293388429753
 * // BMI is 23.93948099205209
 * // BMI is 23.671253629592222
 *
 * @see {@link combineAll}
 * @see {@link merge}
 * @see {@link withLatestFrom}
 *
 * @param {ObservableInput} other An input Observable to combine with the source
 * Observable. More than one input Observables may be given as argument.
 * @param {function} [project] An optional function to project the values from
 * the combined latest values into a new value on the output Observable.
 * @return {Observable} An Observable of projected values from the most recent
 * values from each input Observable, or an array of the most recent values from
 * each input Observable.
 * @method combineLatest
 * @owner Observable
 */ function $cf0e63ea54fafb1f$var$combineLatest() {
    var observables = [];
    for(var _i = 0; _i < arguments.length; _i++)observables[_i - 0] = arguments[_i];
    var project = null;
    if (typeof observables[observables.length - 1] === "function") project = observables.pop();
    // if the first and only other argument besides the resultSelector is an array
    // assume it's been called with `combineLatest([obs1, obs2, obs3], project)`
    if (observables.length === 1 && $6V6Ta.isArray(observables[0])) observables = observables[0].slice();
    return function(source) {
        return source.lift.call(new $8y8sl.ArrayObservable([
            source
        ].concat(observables)), new $cf0e63ea54fafb1f$var$CombineLatestOperator(project));
    };
}
module.exports.combineLatest = $cf0e63ea54fafb1f$var$combineLatest;
var $cf0e63ea54fafb1f$var$CombineLatestOperator = function() {
    function CombineLatestOperator(project) {
        this.project = project;
    }
    CombineLatestOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $cf0e63ea54fafb1f$var$CombineLatestSubscriber(subscriber, this.project));
    };
    return CombineLatestOperator;
}();
module.exports.CombineLatestOperator = $cf0e63ea54fafb1f$var$CombineLatestOperator;
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $cf0e63ea54fafb1f$var$CombineLatestSubscriber = function(_super) {
    $cf0e63ea54fafb1f$var$__extends(CombineLatestSubscriber, _super);
    function CombineLatestSubscriber(destination, project) {
        _super.call(this, destination);
        this.project = project;
        this.active = 0;
        this.values = [];
        this.observables = [];
    }
    CombineLatestSubscriber.prototype._next = function(observable) {
        this.values.push($cf0e63ea54fafb1f$var$none);
        this.observables.push(observable);
    };
    CombineLatestSubscriber.prototype._complete = function() {
        var observables = this.observables;
        var len = observables.length;
        if (len === 0) this.destination.complete();
        else {
            this.active = len;
            this.toRespond = len;
            for(var i = 0; i < len; i++){
                var observable = observables[i];
                this.add($dkOaF.subscribeToResult(this, observable, observable, i));
            }
        }
    };
    CombineLatestSubscriber.prototype.notifyComplete = function(unused) {
        if ((this.active -= 1) === 0) this.destination.complete();
    };
    CombineLatestSubscriber.prototype.notifyNext = function(outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        var values = this.values;
        var oldVal = values[outerIndex];
        var toRespond = !this.toRespond ? 0 : oldVal === $cf0e63ea54fafb1f$var$none ? --this.toRespond : this.toRespond;
        values[outerIndex] = innerValue;
        if (toRespond === 0) {
            if (this.project) this._tryProject(values);
            else this.destination.next(values.slice());
        }
    };
    CombineLatestSubscriber.prototype._tryProject = function(values) {
        var result;
        try {
            result = this.project.apply(this, values);
        } catch (err) {
            this.destination.error(err);
            return;
        }
        this.destination.next(result);
    };
    return CombineLatestSubscriber;
}($2HYhY.OuterSubscriber);
module.exports.CombineLatestSubscriber = $cf0e63ea54fafb1f$var$CombineLatestSubscriber;

});
parcelRequire.register("8y8sl", function(module, exports) {
"use strict";
var $63980eee503321c0$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $lyDVs = parcelRequire("lyDVs");

var $5elaO = parcelRequire("5elaO");

var $3pasW = parcelRequire("3pasW");

var $1P4hl = parcelRequire("1P4hl");
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */ var $63980eee503321c0$var$ArrayObservable = function(_super) {
    $63980eee503321c0$var$__extends(ArrayObservable, _super);
    function ArrayObservable(array, scheduler) {
        _super.call(this);
        this.array = array;
        this.scheduler = scheduler;
        if (!scheduler && array.length === 1) {
            this._isScalar = true;
            this.value = array[0];
        }
    }
    ArrayObservable.create = function(array, scheduler) {
        return new ArrayObservable(array, scheduler);
    };
    /**
     * Creates an Observable that emits some values you specify as arguments,
     * immediately one after the other, and then emits a complete notification.
     *
     * <span class="informal">Emits the arguments you provide, then completes.
     * </span>
     *
     * <img src="./img/of.png" width="100%">
     *
     * This static operator is useful for creating a simple Observable that only
     * emits the arguments given, and the complete notification thereafter. It can
     * be used for composing with other Observables, such as with {@link concat}.
     * By default, it uses a `null` IScheduler, which means the `next`
     * notifications are sent synchronously, although with a different IScheduler
     * it is possible to determine when those notifications will be delivered.
     *
     * @example <caption>Emit 10, 20, 30, then 'a', 'b', 'c', then start ticking every second.</caption>
     * var numbers = Rx.Observable.of(10, 20, 30);
     * var letters = Rx.Observable.of('a', 'b', 'c');
     * var interval = Rx.Observable.interval(1000);
     * var result = numbers.concat(letters).concat(interval);
     * result.subscribe(x => console.log(x));
     *
     * @see {@link create}
     * @see {@link empty}
     * @see {@link never}
     * @see {@link throw}
     *
     * @param {...T} values Arguments that represent `next` values to be emitted.
     * @param {Scheduler} [scheduler] A {@link IScheduler} to use for scheduling
     * the emissions of the `next` notifications.
     * @return {Observable<T>} An Observable that emits each given input value.
     * @static true
     * @name of
     * @owner Observable
     */ ArrayObservable.of = function() {
        var array = [];
        for(var _i = 0; _i < arguments.length; _i++)array[_i - 0] = arguments[_i];
        var scheduler = array[array.length - 1];
        if ($1P4hl.isScheduler(scheduler)) array.pop();
        else scheduler = null;
        var len = array.length;
        if (len > 1) return new ArrayObservable(array, scheduler);
        else if (len === 1) return new $5elaO.ScalarObservable(array[0], scheduler);
        else return new $3pasW.EmptyObservable(scheduler);
    };
    ArrayObservable.dispatch = function(state) {
        var array = state.array, index = state.index, count = state.count, subscriber = state.subscriber;
        if (index >= count) {
            subscriber.complete();
            return;
        }
        subscriber.next(array[index]);
        if (subscriber.closed) return;
        state.index = index + 1;
        this.schedule(state);
    };
    /** @deprecated internal use only */ ArrayObservable.prototype._subscribe = function(subscriber) {
        var index = 0;
        var array = this.array;
        var count = array.length;
        var scheduler = this.scheduler;
        if (scheduler) return scheduler.schedule(ArrayObservable.dispatch, 0, {
            array: array,
            index: index,
            count: count,
            subscriber: subscriber
        });
        else {
            for(var i = 0; i < count && !subscriber.closed; i++)subscriber.next(array[i]);
            subscriber.complete();
        }
    };
    return ArrayObservable;
}($lyDVs.Observable);
module.exports.ArrayObservable = $63980eee503321c0$var$ArrayObservable;

});
parcelRequire.register("5elaO", function(module, exports) {
"use strict";
var $3ceeaf2a7eb2d78f$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $lyDVs = parcelRequire("lyDVs");
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */ var $3ceeaf2a7eb2d78f$var$ScalarObservable = function(_super) {
    $3ceeaf2a7eb2d78f$var$__extends(ScalarObservable, _super);
    function ScalarObservable(value, scheduler) {
        _super.call(this);
        this.value = value;
        this.scheduler = scheduler;
        this._isScalar = true;
        if (scheduler) this._isScalar = false;
    }
    ScalarObservable.create = function(value, scheduler) {
        return new ScalarObservable(value, scheduler);
    };
    ScalarObservable.dispatch = function(state) {
        var done = state.done, value = state.value, subscriber = state.subscriber;
        if (done) {
            subscriber.complete();
            return;
        }
        subscriber.next(value);
        if (subscriber.closed) return;
        state.done = true;
        this.schedule(state);
    };
    /** @deprecated internal use only */ ScalarObservable.prototype._subscribe = function(subscriber) {
        var value = this.value;
        var scheduler = this.scheduler;
        if (scheduler) return scheduler.schedule(ScalarObservable.dispatch, 0, {
            done: false,
            value: value,
            subscriber: subscriber
        });
        else {
            subscriber.next(value);
            if (!subscriber.closed) subscriber.complete();
        }
    };
    return ScalarObservable;
}($lyDVs.Observable);
module.exports.ScalarObservable = $3ceeaf2a7eb2d78f$var$ScalarObservable;

});

parcelRequire.register("3pasW", function(module, exports) {
"use strict";
var $27abd32c74d48e4e$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $lyDVs = parcelRequire("lyDVs");
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */ var $27abd32c74d48e4e$var$EmptyObservable = function(_super) {
    $27abd32c74d48e4e$var$__extends(EmptyObservable, _super);
    function EmptyObservable(scheduler) {
        _super.call(this);
        this.scheduler = scheduler;
    }
    /**
     * Creates an Observable that emits no items to the Observer and immediately
     * emits a complete notification.
     *
     * <span class="informal">Just emits 'complete', and nothing else.
     * </span>
     *
     * <img src="./img/empty.png" width="100%">
     *
     * This static operator is useful for creating a simple Observable that only
     * emits the complete notification. It can be used for composing with other
     * Observables, such as in a {@link mergeMap}.
     *
     * @example <caption>Emit the number 7, then complete.</caption>
     * var result = Rx.Observable.empty().startWith(7);
     * result.subscribe(x => console.log(x));
     *
     * @example <caption>Map and flatten only odd numbers to the sequence 'a', 'b', 'c'</caption>
     * var interval = Rx.Observable.interval(1000);
     * var result = interval.mergeMap(x =>
     *   x % 2 === 1 ? Rx.Observable.of('a', 'b', 'c') : Rx.Observable.empty()
     * );
     * result.subscribe(x => console.log(x));
     *
     * // Results in the following to the console:
     * // x is equal to the count on the interval eg(0,1,2,3,...)
     * // x will occur every 1000ms
     * // if x % 2 is equal to 1 print abc
     * // if x % 2 is not equal to 1 nothing will be output
     *
     * @see {@link create}
     * @see {@link never}
     * @see {@link of}
     * @see {@link throw}
     *
     * @param {Scheduler} [scheduler] A {@link IScheduler} to use for scheduling
     * the emission of the complete notification.
     * @return {Observable} An "empty" Observable: emits only the complete
     * notification.
     * @static true
     * @name empty
     * @owner Observable
     */ EmptyObservable.create = function(scheduler) {
        return new EmptyObservable(scheduler);
    };
    EmptyObservable.dispatch = function(arg) {
        var subscriber = arg.subscriber;
        subscriber.complete();
    };
    /** @deprecated internal use only */ EmptyObservable.prototype._subscribe = function(subscriber) {
        var scheduler = this.scheduler;
        if (scheduler) return scheduler.schedule(EmptyObservable.dispatch, 0, {
            subscriber: subscriber
        });
        else subscriber.complete();
    };
    return EmptyObservable;
}($lyDVs.Observable);
module.exports.EmptyObservable = $27abd32c74d48e4e$var$EmptyObservable;

});

parcelRequire.register("1P4hl", function(module, exports) {

$parcel$export(module.exports, "isScheduler", () => $153ddf8852817109$export$187e35932e88c15c, (v) => $153ddf8852817109$export$187e35932e88c15c = v);
var $153ddf8852817109$export$187e35932e88c15c;
"use strict";
function $153ddf8852817109$var$isScheduler(value) {
    return value && typeof value.schedule === "function";
}
$153ddf8852817109$export$187e35932e88c15c = $153ddf8852817109$var$isScheduler;

});





parcelRequire.register("8yQ9N", function(module, exports) {
"use strict";

var $lyDVs = parcelRequire("lyDVs");

var $jgmpn = parcelRequire("jgmpn");
$lyDVs.Observable.prototype.count = $jgmpn.count;

});
parcelRequire.register("jgmpn", function(module, exports) {

$parcel$export(module.exports, "count", () => $e060e4c00d9e4b58$export$85b9a36db797e02b, (v) => $e060e4c00d9e4b58$export$85b9a36db797e02b = v);
var $e060e4c00d9e4b58$export$85b9a36db797e02b;
"use strict";

var $g6EJl = parcelRequire("g6EJl");
/**
 * Counts the number of emissions on the source and emits that number when the
 * source completes.
 *
 * <span class="informal">Tells how many values were emitted, when the source
 * completes.</span>
 *
 * <img src="./img/count.png" width="100%">
 *
 * `count` transforms an Observable that emits values into an Observable that
 * emits a single value that represents the number of values emitted by the
 * source Observable. If the source Observable terminates with an error, `count`
 * will pass this error notification along without emitting a value first. If
 * the source Observable does not terminate at all, `count` will neither emit
 * a value nor terminate. This operator takes an optional `predicate` function
 * as argument, in which case the output emission will represent the number of
 * source values that matched `true` with the `predicate`.
 *
 * @example <caption>Counts how many seconds have passed before the first click happened</caption>
 * var seconds = Rx.Observable.interval(1000);
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var secondsBeforeClick = seconds.takeUntil(clicks);
 * var result = secondsBeforeClick.count();
 * result.subscribe(x => console.log(x));
 *
 * @example <caption>Counts how many odd numbers are there between 1 and 7</caption>
 * var numbers = Rx.Observable.range(1, 7);
 * var result = numbers.count(i => i % 2 === 1);
 * result.subscribe(x => console.log(x));
 *
 * // Results in:
 * // 4
 *
 * @see {@link max}
 * @see {@link min}
 * @see {@link reduce}
 *
 * @param {function(value: T, i: number, source: Observable<T>): boolean} [predicate] A
 * boolean function to select what values are to be counted. It is provided with
 * arguments of:
 * - `value`: the value from the source Observable.
 * - `index`: the (zero-based) "index" of the value from the source Observable.
 * - `source`: the source Observable instance itself.
 * @return {Observable} An Observable of one number that represents the count as
 * described above.
 * @method count
 * @owner Observable
 */ function $e060e4c00d9e4b58$var$count(predicate) {
    return $g6EJl.count(predicate)(this);
}
$e060e4c00d9e4b58$export$85b9a36db797e02b = $e060e4c00d9e4b58$var$count;

});
parcelRequire.register("g6EJl", function(module, exports) {
"use strict";
var $bb9ccd199276dc58$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $gYcab = parcelRequire("gYcab");
/**
 * Counts the number of emissions on the source and emits that number when the
 * source completes.
 *
 * <span class="informal">Tells how many values were emitted, when the source
 * completes.</span>
 *
 * <img src="./img/count.png" width="100%">
 *
 * `count` transforms an Observable that emits values into an Observable that
 * emits a single value that represents the number of values emitted by the
 * source Observable. If the source Observable terminates with an error, `count`
 * will pass this error notification along without emitting a value first. If
 * the source Observable does not terminate at all, `count` will neither emit
 * a value nor terminate. This operator takes an optional `predicate` function
 * as argument, in which case the output emission will represent the number of
 * source values that matched `true` with the `predicate`.
 *
 * @example <caption>Counts how many seconds have passed before the first click happened</caption>
 * var seconds = Rx.Observable.interval(1000);
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var secondsBeforeClick = seconds.takeUntil(clicks);
 * var result = secondsBeforeClick.count();
 * result.subscribe(x => console.log(x));
 *
 * @example <caption>Counts how many odd numbers are there between 1 and 7</caption>
 * var numbers = Rx.Observable.range(1, 7);
 * var result = numbers.count(i => i % 2 === 1);
 * result.subscribe(x => console.log(x));
 *
 * // Results in:
 * // 4
 *
 * @see {@link max}
 * @see {@link min}
 * @see {@link reduce}
 *
 * @param {function(value: T, i: number, source: Observable<T>): boolean} [predicate] A
 * boolean function to select what values are to be counted. It is provided with
 * arguments of:
 * - `value`: the value from the source Observable.
 * - `index`: the (zero-based) "index" of the value from the source Observable.
 * - `source`: the source Observable instance itself.
 * @return {Observable} An Observable of one number that represents the count as
 * described above.
 * @method count
 * @owner Observable
 */ function $bb9ccd199276dc58$var$count(predicate) {
    return function(source) {
        return source.lift(new $bb9ccd199276dc58$var$CountOperator(predicate, source));
    };
}
module.exports.count = $bb9ccd199276dc58$var$count;
var $bb9ccd199276dc58$var$CountOperator = function() {
    function CountOperator(predicate, source) {
        this.predicate = predicate;
        this.source = source;
    }
    CountOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $bb9ccd199276dc58$var$CountSubscriber(subscriber, this.predicate, this.source));
    };
    return CountOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $bb9ccd199276dc58$var$CountSubscriber = function(_super) {
    $bb9ccd199276dc58$var$__extends(CountSubscriber, _super);
    function CountSubscriber(destination, predicate, source) {
        _super.call(this, destination);
        this.predicate = predicate;
        this.source = source;
        this.count = 0;
        this.index = 0;
    }
    CountSubscriber.prototype._next = function(value) {
        if (this.predicate) this._tryPredicate(value);
        else this.count++;
    };
    CountSubscriber.prototype._tryPredicate = function(value) {
        var result;
        try {
            result = this.predicate(value, this.index++, this.source);
        } catch (err) {
            this.destination.error(err);
            return;
        }
        if (result) this.count++;
    };
    CountSubscriber.prototype._complete = function() {
        this.destination.next(this.count);
        this.destination.complete();
    };
    return CountSubscriber;
}($gYcab.Subscriber);

});



parcelRequire.register("918ZT", function(module, exports) {
"use strict";

var $lyDVs = parcelRequire("lyDVs");

var $fzk31 = parcelRequire("fzk31");
$lyDVs.Observable.prototype.delay = $fzk31.delay;

});
parcelRequire.register("fzk31", function(module, exports) {

$parcel$export(module.exports, "delay", () => $b559acf91faf726d$export$1391212d75b2ee65, (v) => $b559acf91faf726d$export$1391212d75b2ee65 = v);
var $b559acf91faf726d$export$1391212d75b2ee65;
"use strict";

var $lvV06 = parcelRequire("lvV06");

var $ePWqf = parcelRequire("ePWqf");
/**
 * Delays the emission of items from the source Observable by a given timeout or
 * until a given Date.
 *
 * <span class="informal">Time shifts each item by some specified amount of
 * milliseconds.</span>
 *
 * <img src="./img/delay.png" width="100%">
 *
 * If the delay argument is a Number, this operator time shifts the source
 * Observable by that amount of time expressed in milliseconds. The relative
 * time intervals between the values are preserved.
 *
 * If the delay argument is a Date, this operator time shifts the start of the
 * Observable execution until the given date occurs.
 *
 * @example <caption>Delay each click by one second</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var delayedClicks = clicks.delay(1000); // each click emitted after 1 second
 * delayedClicks.subscribe(x => console.log(x));
 *
 * @example <caption>Delay all clicks until a future date happens</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var date = new Date('March 15, 2050 12:00:00'); // in the future
 * var delayedClicks = clicks.delay(date); // click emitted only after that date
 * delayedClicks.subscribe(x => console.log(x));
 *
 * @see {@link debounceTime}
 * @see {@link delayWhen}
 *
 * @param {number|Date} delay The delay duration in milliseconds (a `number`) or
 * a `Date` until which the emission of the source items is delayed.
 * @param {Scheduler} [scheduler=async] The IScheduler to use for
 * managing the timers that handle the time-shift for each item.
 * @return {Observable} An Observable that delays the emissions of the source
 * Observable by the specified timeout or Date.
 * @method delay
 * @owner Observable
 */ function $b559acf91faf726d$var$delay(delay, scheduler) {
    if (scheduler === void 0) scheduler = $lvV06.async;
    return $ePWqf.delay(delay, scheduler)(this);
}
$b559acf91faf726d$export$1391212d75b2ee65 = $b559acf91faf726d$var$delay;

});
parcelRequire.register("ePWqf", function(module, exports) {
"use strict";
var $acd325931a0e586b$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $lvV06 = parcelRequire("lvV06");

var $7MY6P = parcelRequire("7MY6P");

var $gYcab = parcelRequire("gYcab");

var $fKTkY = parcelRequire("fKTkY");
/**
 * Delays the emission of items from the source Observable by a given timeout or
 * until a given Date.
 *
 * <span class="informal">Time shifts each item by some specified amount of
 * milliseconds.</span>
 *
 * <img src="./img/delay.png" width="100%">
 *
 * If the delay argument is a Number, this operator time shifts the source
 * Observable by that amount of time expressed in milliseconds. The relative
 * time intervals between the values are preserved.
 *
 * If the delay argument is a Date, this operator time shifts the start of the
 * Observable execution until the given date occurs.
 *
 * @example <caption>Delay each click by one second</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var delayedClicks = clicks.delay(1000); // each click emitted after 1 second
 * delayedClicks.subscribe(x => console.log(x));
 *
 * @example <caption>Delay all clicks until a future date happens</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var date = new Date('March 15, 2050 12:00:00'); // in the future
 * var delayedClicks = clicks.delay(date); // click emitted only after that date
 * delayedClicks.subscribe(x => console.log(x));
 *
 * @see {@link debounceTime}
 * @see {@link delayWhen}
 *
 * @param {number|Date} delay The delay duration in milliseconds (a `number`) or
 * a `Date` until which the emission of the source items is delayed.
 * @param {Scheduler} [scheduler=async] The IScheduler to use for
 * managing the timers that handle the time-shift for each item.
 * @return {Observable} An Observable that delays the emissions of the source
 * Observable by the specified timeout or Date.
 * @method delay
 * @owner Observable
 */ function $acd325931a0e586b$var$delay(delay, scheduler) {
    if (scheduler === void 0) scheduler = $lvV06.async;
    var absoluteDelay = $7MY6P.isDate(delay);
    var delayFor = absoluteDelay ? +delay - scheduler.now() : Math.abs(delay);
    return function(source) {
        return source.lift(new $acd325931a0e586b$var$DelayOperator(delayFor, scheduler));
    };
}
module.exports.delay = $acd325931a0e586b$var$delay;
var $acd325931a0e586b$var$DelayOperator = function() {
    function DelayOperator(delay, scheduler) {
        this.delay = delay;
        this.scheduler = scheduler;
    }
    DelayOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $acd325931a0e586b$var$DelaySubscriber(subscriber, this.delay, this.scheduler));
    };
    return DelayOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $acd325931a0e586b$var$DelaySubscriber = function(_super) {
    $acd325931a0e586b$var$__extends(DelaySubscriber, _super);
    function DelaySubscriber(destination, delay, scheduler) {
        _super.call(this, destination);
        this.delay = delay;
        this.scheduler = scheduler;
        this.queue = [];
        this.active = false;
        this.errored = false;
    }
    DelaySubscriber.dispatch = function(state) {
        var source = state.source;
        var queue = source.queue;
        var scheduler = state.scheduler;
        var destination = state.destination;
        while(queue.length > 0 && queue[0].time - scheduler.now() <= 0)queue.shift().notification.observe(destination);
        if (queue.length > 0) {
            var delay_1 = Math.max(0, queue[0].time - scheduler.now());
            this.schedule(state, delay_1);
        } else {
            this.unsubscribe();
            source.active = false;
        }
    };
    DelaySubscriber.prototype._schedule = function(scheduler) {
        this.active = true;
        this.add(scheduler.schedule(DelaySubscriber.dispatch, this.delay, {
            source: this,
            destination: this.destination,
            scheduler: scheduler
        }));
    };
    DelaySubscriber.prototype.scheduleNotification = function(notification) {
        if (this.errored === true) return;
        var scheduler = this.scheduler;
        var message = new $acd325931a0e586b$var$DelayMessage(scheduler.now() + this.delay, notification);
        this.queue.push(message);
        if (this.active === false) this._schedule(scheduler);
    };
    DelaySubscriber.prototype._next = function(value) {
        this.scheduleNotification($fKTkY.Notification.createNext(value));
    };
    DelaySubscriber.prototype._error = function(err) {
        this.errored = true;
        this.queue = [];
        this.destination.error(err);
    };
    DelaySubscriber.prototype._complete = function() {
        this.scheduleNotification($fKTkY.Notification.createComplete());
    };
    return DelaySubscriber;
}($gYcab.Subscriber);
var $acd325931a0e586b$var$DelayMessage = function() {
    function DelayMessage(time, notification) {
        this.time = time;
        this.notification = notification;
    }
    return DelayMessage;
}();

});
parcelRequire.register("7MY6P", function(module, exports) {

$parcel$export(module.exports, "isDate", () => $5abba4895ecf9324$export$871608497c498473, (v) => $5abba4895ecf9324$export$871608497c498473 = v);
var $5abba4895ecf9324$export$871608497c498473;
"use strict";
function $5abba4895ecf9324$var$isDate(value) {
    return value instanceof Date && !isNaN(+value);
}
$5abba4895ecf9324$export$871608497c498473 = $5abba4895ecf9324$var$isDate;

});

parcelRequire.register("fKTkY", function(module, exports) {

$parcel$export(module.exports, "Notification", () => $b78613bc78c80761$export$14834abbfce3b8cd, (v) => $b78613bc78c80761$export$14834abbfce3b8cd = v);
var $b78613bc78c80761$export$14834abbfce3b8cd;
"use strict";

var $lyDVs = parcelRequire("lyDVs");
/**
 * Represents a push-based event or value that an {@link Observable} can emit.
 * This class is particularly useful for operators that manage notifications,
 * like {@link materialize}, {@link dematerialize}, {@link observeOn}, and
 * others. Besides wrapping the actual delivered value, it also annotates it
 * with metadata of, for instance, what type of push message it is (`next`,
 * `error`, or `complete`).
 *
 * @see {@link materialize}
 * @see {@link dematerialize}
 * @see {@link observeOn}
 *
 * @class Notification<T>
 */ var $b78613bc78c80761$var$Notification = function() {
    function Notification(kind, value, error) {
        this.kind = kind;
        this.value = value;
        this.error = error;
        this.hasValue = kind === "N";
    }
    /**
     * Delivers to the given `observer` the value wrapped by this Notification.
     * @param {Observer} observer
     * @return
     */ Notification.prototype.observe = function(observer) {
        switch(this.kind){
            case "N":
                return observer.next && observer.next(this.value);
            case "E":
                return observer.error && observer.error(this.error);
            case "C":
                return observer.complete && observer.complete();
        }
    };
    /**
     * Given some {@link Observer} callbacks, deliver the value represented by the
     * current Notification to the correctly corresponding callback.
     * @param {function(value: T): void} next An Observer `next` callback.
     * @param {function(err: any): void} [error] An Observer `error` callback.
     * @param {function(): void} [complete] An Observer `complete` callback.
     * @return {any}
     */ Notification.prototype.do = function(next, error, complete) {
        var kind = this.kind;
        switch(kind){
            case "N":
                return next && next(this.value);
            case "E":
                return error && error(this.error);
            case "C":
                return complete && complete();
        }
    };
    /**
     * Takes an Observer or its individual callback functions, and calls `observe`
     * or `do` methods accordingly.
     * @param {Observer|function(value: T): void} nextOrObserver An Observer or
     * the `next` callback.
     * @param {function(err: any): void} [error] An Observer `error` callback.
     * @param {function(): void} [complete] An Observer `complete` callback.
     * @return {any}
     */ Notification.prototype.accept = function(nextOrObserver, error, complete) {
        if (nextOrObserver && typeof nextOrObserver.next === "function") return this.observe(nextOrObserver);
        else return this.do(nextOrObserver, error, complete);
    };
    /**
     * Returns a simple Observable that just delivers the notification represented
     * by this Notification instance.
     * @return {any}
     */ Notification.prototype.toObservable = function() {
        var kind = this.kind;
        switch(kind){
            case "N":
                return $lyDVs.Observable.of(this.value);
            case "E":
                return $lyDVs.Observable.throw(this.error);
            case "C":
                return $lyDVs.Observable.empty();
        }
        throw new Error("unexpected notification kind value");
    };
    /**
     * A shortcut to create a Notification instance of the type `next` from a
     * given value.
     * @param {T} value The `next` value.
     * @return {Notification<T>} The "next" Notification representing the
     * argument.
     */ Notification.createNext = function(value) {
        if (typeof value !== "undefined") return new Notification("N", value);
        return Notification.undefinedValueNotification;
    };
    /**
     * A shortcut to create a Notification instance of the type `error` from a
     * given error.
     * @param {any} [err] The `error` error.
     * @return {Notification<T>} The "error" Notification representing the
     * argument.
     */ Notification.createError = function(err) {
        return new Notification("E", undefined, err);
    };
    /**
     * A shortcut to create a Notification instance of the type `complete`.
     * @return {Notification<any>} The valueless "complete" Notification.
     */ Notification.createComplete = function() {
        return Notification.completeNotification;
    };
    Notification.completeNotification = new Notification("C");
    Notification.undefinedValueNotification = new Notification("N", undefined);
    return Notification;
}();
$b78613bc78c80761$export$14834abbfce3b8cd = $b78613bc78c80761$var$Notification;

});




parcelRequire.register("kT8K1", function(module, exports) {
"use strict";

var $lyDVs = parcelRequire("lyDVs");

var $2hpb9 = parcelRequire("2hpb9");
$lyDVs.Observable.prototype.do = $2hpb9._do;
$lyDVs.Observable.prototype._do = $2hpb9._do;

});
parcelRequire.register("2hpb9", function(module, exports) {

$parcel$export(module.exports, "_do", () => $1a90b34eb9a7cf05$export$6e1c2ce23f3c9991, (v) => $1a90b34eb9a7cf05$export$6e1c2ce23f3c9991 = v);
var $1a90b34eb9a7cf05$export$6e1c2ce23f3c9991;
"use strict";

var $eyOOh = parcelRequire("eyOOh");
/* tslint:enable:max-line-length */ /**
 * Perform a side effect for every emission on the source Observable, but return
 * an Observable that is identical to the source.
 *
 * <span class="informal">Intercepts each emission on the source and runs a
 * function, but returns an output which is identical to the source as long as errors don't occur.</span>
 *
 * <img src="./img/do.png" width="100%">
 *
 * Returns a mirrored Observable of the source Observable, but modified so that
 * the provided Observer is called to perform a side effect for every value,
 * error, and completion emitted by the source. Any errors that are thrown in
 * the aforementioned Observer or handlers are safely sent down the error path
 * of the output Observable.
 *
 * This operator is useful for debugging your Observables for the correct values
 * or performing other side effects.
 *
 * Note: this is different to a `subscribe` on the Observable. If the Observable
 * returned by `do` is not subscribed, the side effects specified by the
 * Observer will never happen. `do` therefore simply spies on existing
 * execution, it does not trigger an execution to happen like `subscribe` does.
 *
 * @example <caption>Map every click to the clientX position of that click, while also logging the click event</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var positions = clicks
 *   .do(ev => console.log(ev))
 *   .map(ev => ev.clientX);
 * positions.subscribe(x => console.log(x));
 *
 * @see {@link map}
 * @see {@link subscribe}
 *
 * @param {Observer|function} [nextOrObserver] A normal Observer object or a
 * callback for `next`.
 * @param {function} [error] Callback for errors in the source.
 * @param {function} [complete] Callback for the completion of the source.
 * @return {Observable} An Observable identical to the source, but runs the
 * specified Observer or callback(s) for each item.
 * @method do
 * @name do
 * @owner Observable
 */ function $1a90b34eb9a7cf05$var$_do(nextOrObserver, error, complete) {
    return $eyOOh.tap(nextOrObserver, error, complete)(this);
}
$1a90b34eb9a7cf05$export$6e1c2ce23f3c9991 = $1a90b34eb9a7cf05$var$_do;

});
parcelRequire.register("eyOOh", function(module, exports) {
"use strict";
var $a99ba77abb4eee7a$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $gYcab = parcelRequire("gYcab");
/* tslint:enable:max-line-length */ /**
 * Perform a side effect for every emission on the source Observable, but return
 * an Observable that is identical to the source.
 *
 * <span class="informal">Intercepts each emission on the source and runs a
 * function, but returns an output which is identical to the source as long as errors don't occur.</span>
 *
 * <img src="./img/do.png" width="100%">
 *
 * Returns a mirrored Observable of the source Observable, but modified so that
 * the provided Observer is called to perform a side effect for every value,
 * error, and completion emitted by the source. Any errors that are thrown in
 * the aforementioned Observer or handlers are safely sent down the error path
 * of the output Observable.
 *
 * This operator is useful for debugging your Observables for the correct values
 * or performing other side effects.
 *
 * Note: this is different to a `subscribe` on the Observable. If the Observable
 * returned by `do` is not subscribed, the side effects specified by the
 * Observer will never happen. `do` therefore simply spies on existing
 * execution, it does not trigger an execution to happen like `subscribe` does.
 *
 * @example <caption>Map every click to the clientX position of that click, while also logging the click event</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var positions = clicks
 *   .do(ev => console.log(ev))
 *   .map(ev => ev.clientX);
 * positions.subscribe(x => console.log(x));
 *
 * @see {@link map}
 * @see {@link subscribe}
 *
 * @param {Observer|function} [nextOrObserver] A normal Observer object or a
 * callback for `next`.
 * @param {function} [error] Callback for errors in the source.
 * @param {function} [complete] Callback for the completion of the source.
 * @return {Observable} An Observable identical to the source, but runs the
 * specified Observer or callback(s) for each item.
 * @name tap
 */ function $a99ba77abb4eee7a$var$tap(nextOrObserver, error, complete) {
    return function tapOperatorFunction(source) {
        return source.lift(new $a99ba77abb4eee7a$var$DoOperator(nextOrObserver, error, complete));
    };
}
module.exports.tap = $a99ba77abb4eee7a$var$tap;
var $a99ba77abb4eee7a$var$DoOperator = function() {
    function DoOperator(nextOrObserver, error, complete) {
        this.nextOrObserver = nextOrObserver;
        this.error = error;
        this.complete = complete;
    }
    DoOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $a99ba77abb4eee7a$var$DoSubscriber(subscriber, this.nextOrObserver, this.error, this.complete));
    };
    return DoOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $a99ba77abb4eee7a$var$DoSubscriber = function(_super) {
    $a99ba77abb4eee7a$var$__extends(DoSubscriber, _super);
    function DoSubscriber(destination, nextOrObserver, error, complete) {
        _super.call(this, destination);
        var safeSubscriber = new $gYcab.Subscriber(nextOrObserver, error, complete);
        safeSubscriber.syncErrorThrowable = true;
        this.add(safeSubscriber);
        this.safeSubscriber = safeSubscriber;
    }
    DoSubscriber.prototype._next = function(value) {
        var safeSubscriber = this.safeSubscriber;
        safeSubscriber.next(value);
        if (safeSubscriber.syncErrorThrown) this.destination.error(safeSubscriber.syncErrorValue);
        else this.destination.next(value);
    };
    DoSubscriber.prototype._error = function(err) {
        var safeSubscriber = this.safeSubscriber;
        safeSubscriber.error(err);
        if (safeSubscriber.syncErrorThrown) this.destination.error(safeSubscriber.syncErrorValue);
        else this.destination.error(err);
    };
    DoSubscriber.prototype._complete = function() {
        var safeSubscriber = this.safeSubscriber;
        safeSubscriber.complete();
        if (safeSubscriber.syncErrorThrown) this.destination.error(safeSubscriber.syncErrorValue);
        else this.destination.complete();
    };
    return DoSubscriber;
}($gYcab.Subscriber);

});



parcelRequire.register("bz5ZN", function(module, exports) {
"use strict";

var $lyDVs = parcelRequire("lyDVs");

var $cer4W = parcelRequire("cer4W");
$lyDVs.Observable.prototype.filter = $cer4W.filter;

});
parcelRequire.register("cer4W", function(module, exports) {

$parcel$export(module.exports, "filter", () => $8e7bcc210cd67651$export$3dea766d36a8935f, (v) => $8e7bcc210cd67651$export$3dea766d36a8935f = v);
var $8e7bcc210cd67651$export$3dea766d36a8935f;
"use strict";

var $ZXlRm = parcelRequire("ZXlRm");
/* tslint:enable:max-line-length */ /**
 * Filter items emitted by the source Observable by only emitting those that
 * satisfy a specified predicate.
 *
 * <span class="informal">Like
 * [Array.prototype.filter()](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/filter),
 * it only emits a value from the source if it passes a criterion function.</span>
 *
 * <img src="./img/filter.png" width="100%">
 *
 * Similar to the well-known `Array.prototype.filter` method, this operator
 * takes values from the source Observable, passes them through a `predicate`
 * function and only emits those values that yielded `true`.
 *
 * @example <caption>Emit only click events whose target was a DIV element</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var clicksOnDivs = clicks.filter(ev => ev.target.tagName === 'DIV');
 * clicksOnDivs.subscribe(x => console.log(x));
 *
 * @see {@link distinct}
 * @see {@link distinctUntilChanged}
 * @see {@link distinctUntilKeyChanged}
 * @see {@link ignoreElements}
 * @see {@link partition}
 * @see {@link skip}
 *
 * @param {function(value: T, index: number): boolean} predicate A function that
 * evaluates each value emitted by the source Observable. If it returns `true`,
 * the value is emitted, if `false` the value is not passed to the output
 * Observable. The `index` parameter is the number `i` for the i-th source
 * emission that has happened since the subscription, starting from the number
 * `0`.
 * @param {any} [thisArg] An optional argument to determine the value of `this`
 * in the `predicate` function.
 * @return {Observable} An Observable of values from the source that were
 * allowed by the `predicate` function.
 * @method filter
 * @owner Observable
 */ function $8e7bcc210cd67651$var$filter(predicate, thisArg) {
    return $ZXlRm.filter(predicate, thisArg)(this);
}
$8e7bcc210cd67651$export$3dea766d36a8935f = $8e7bcc210cd67651$var$filter;

});
parcelRequire.register("ZXlRm", function(module, exports) {
"use strict";
var $0ba3bc9b3db8a28d$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $gYcab = parcelRequire("gYcab");
/* tslint:enable:max-line-length */ /**
 * Filter items emitted by the source Observable by only emitting those that
 * satisfy a specified predicate.
 *
 * <span class="informal">Like
 * [Array.prototype.filter()](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/filter),
 * it only emits a value from the source if it passes a criterion function.</span>
 *
 * <img src="./img/filter.png" width="100%">
 *
 * Similar to the well-known `Array.prototype.filter` method, this operator
 * takes values from the source Observable, passes them through a `predicate`
 * function and only emits those values that yielded `true`.
 *
 * @example <caption>Emit only click events whose target was a DIV element</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var clicksOnDivs = clicks.filter(ev => ev.target.tagName === 'DIV');
 * clicksOnDivs.subscribe(x => console.log(x));
 *
 * @see {@link distinct}
 * @see {@link distinctUntilChanged}
 * @see {@link distinctUntilKeyChanged}
 * @see {@link ignoreElements}
 * @see {@link partition}
 * @see {@link skip}
 *
 * @param {function(value: T, index: number): boolean} predicate A function that
 * evaluates each value emitted by the source Observable. If it returns `true`,
 * the value is emitted, if `false` the value is not passed to the output
 * Observable. The `index` parameter is the number `i` for the i-th source
 * emission that has happened since the subscription, starting from the number
 * `0`.
 * @param {any} [thisArg] An optional argument to determine the value of `this`
 * in the `predicate` function.
 * @return {Observable} An Observable of values from the source that were
 * allowed by the `predicate` function.
 * @method filter
 * @owner Observable
 */ function $0ba3bc9b3db8a28d$var$filter(predicate, thisArg) {
    return function filterOperatorFunction(source) {
        return source.lift(new $0ba3bc9b3db8a28d$var$FilterOperator(predicate, thisArg));
    };
}
module.exports.filter = $0ba3bc9b3db8a28d$var$filter;
var $0ba3bc9b3db8a28d$var$FilterOperator = function() {
    function FilterOperator(predicate, thisArg) {
        this.predicate = predicate;
        this.thisArg = thisArg;
    }
    FilterOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $0ba3bc9b3db8a28d$var$FilterSubscriber(subscriber, this.predicate, this.thisArg));
    };
    return FilterOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $0ba3bc9b3db8a28d$var$FilterSubscriber = function(_super) {
    $0ba3bc9b3db8a28d$var$__extends(FilterSubscriber, _super);
    function FilterSubscriber(destination, predicate, thisArg) {
        _super.call(this, destination);
        this.predicate = predicate;
        this.thisArg = thisArg;
        this.count = 0;
    }
    // the try catch block below is left specifically for
    // optimization and perf reasons. a tryCatcher is not necessary here.
    FilterSubscriber.prototype._next = function(value) {
        var result;
        try {
            result = this.predicate.call(this.thisArg, value, this.count++);
        } catch (err) {
            this.destination.error(err);
            return;
        }
        if (result) this.destination.next(value);
    };
    return FilterSubscriber;
}($gYcab.Subscriber);

});



parcelRequire.register("ii3mB", function(module, exports) {
"use strict";

var $lyDVs = parcelRequire("lyDVs");

var $lnFrc = parcelRequire("lnFrc");
$lyDVs.Observable.prototype.map = $lnFrc.map;

});
parcelRequire.register("lnFrc", function(module, exports) {

$parcel$export(module.exports, "map", () => $f90be39cf5cbe63a$export$871de8747c9eaa88, (v) => $f90be39cf5cbe63a$export$871de8747c9eaa88 = v);
var $f90be39cf5cbe63a$export$871de8747c9eaa88;
"use strict";

var $7SucU = parcelRequire("7SucU");
/**
 * Applies a given `project` function to each value emitted by the source
 * Observable, and emits the resulting values as an Observable.
 *
 * <span class="informal">Like [Array.prototype.map()](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/map),
 * it passes each source value through a transformation function to get
 * corresponding output values.</span>
 *
 * <img src="./img/map.png" width="100%">
 *
 * Similar to the well known `Array.prototype.map` function, this operator
 * applies a projection to each value and emits that projection in the output
 * Observable.
 *
 * @example <caption>Map every click to the clientX position of that click</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var positions = clicks.map(ev => ev.clientX);
 * positions.subscribe(x => console.log(x));
 *
 * @see {@link mapTo}
 * @see {@link pluck}
 *
 * @param {function(value: T, index: number): R} project The function to apply
 * to each `value` emitted by the source Observable. The `index` parameter is
 * the number `i` for the i-th emission that has happened since the
 * subscription, starting from the number `0`.
 * @param {any} [thisArg] An optional argument to define what `this` is in the
 * `project` function.
 * @return {Observable<R>} An Observable that emits the values from the source
 * Observable transformed by the given `project` function.
 * @method map
 * @owner Observable
 */ function $f90be39cf5cbe63a$var$map(project, thisArg) {
    return $7SucU.map(project, thisArg)(this);
}
$f90be39cf5cbe63a$export$871de8747c9eaa88 = $f90be39cf5cbe63a$var$map;

});
parcelRequire.register("7SucU", function(module, exports) {
"use strict";
var $5bc502129b80158d$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $gYcab = parcelRequire("gYcab");
/**
 * Applies a given `project` function to each value emitted by the source
 * Observable, and emits the resulting values as an Observable.
 *
 * <span class="informal">Like [Array.prototype.map()](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/map),
 * it passes each source value through a transformation function to get
 * corresponding output values.</span>
 *
 * <img src="./img/map.png" width="100%">
 *
 * Similar to the well known `Array.prototype.map` function, this operator
 * applies a projection to each value and emits that projection in the output
 * Observable.
 *
 * @example <caption>Map every click to the clientX position of that click</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var positions = clicks.map(ev => ev.clientX);
 * positions.subscribe(x => console.log(x));
 *
 * @see {@link mapTo}
 * @see {@link pluck}
 *
 * @param {function(value: T, index: number): R} project The function to apply
 * to each `value` emitted by the source Observable. The `index` parameter is
 * the number `i` for the i-th emission that has happened since the
 * subscription, starting from the number `0`.
 * @param {any} [thisArg] An optional argument to define what `this` is in the
 * `project` function.
 * @return {Observable<R>} An Observable that emits the values from the source
 * Observable transformed by the given `project` function.
 * @method map
 * @owner Observable
 */ function $5bc502129b80158d$var$map(project, thisArg) {
    return function mapOperation(source) {
        if (typeof project !== "function") throw new TypeError("argument is not a function. Are you looking for `mapTo()`?");
        return source.lift(new $5bc502129b80158d$var$MapOperator(project, thisArg));
    };
}
module.exports.map = $5bc502129b80158d$var$map;
var $5bc502129b80158d$var$MapOperator = function() {
    function MapOperator(project, thisArg) {
        this.project = project;
        this.thisArg = thisArg;
    }
    MapOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $5bc502129b80158d$var$MapSubscriber(subscriber, this.project, this.thisArg));
    };
    return MapOperator;
}();
module.exports.MapOperator = $5bc502129b80158d$var$MapOperator;
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $5bc502129b80158d$var$MapSubscriber = function(_super) {
    $5bc502129b80158d$var$__extends(MapSubscriber, _super);
    function MapSubscriber(destination, project, thisArg) {
        _super.call(this, destination);
        this.project = project;
        this.count = 0;
        this.thisArg = thisArg || this;
    }
    // NOTE: This looks unoptimized, but it's actually purposefully NOT
    // using try/catch optimizations.
    MapSubscriber.prototype._next = function(value) {
        var result;
        try {
            result = this.project.call(this.thisArg, value, this.count++);
        } catch (err) {
            this.destination.error(err);
            return;
        }
        this.destination.next(result);
    };
    return MapSubscriber;
}($gYcab.Subscriber);

});



parcelRequire.register("312NI", function(module, exports) {
"use strict";

var $lyDVs = parcelRequire("lyDVs");

var $8Rw4T = parcelRequire("8Rw4T");
$lyDVs.Observable.prototype.mergeMap = $8Rw4T.mergeMap;
$lyDVs.Observable.prototype.flatMap = $8Rw4T.mergeMap;

});
parcelRequire.register("8Rw4T", function(module, exports) {

$parcel$export(module.exports, "mergeMap", () => $673c27f9e6ff779b$export$6b9f6c0d32c093f9, (v) => $673c27f9e6ff779b$export$6b9f6c0d32c093f9 = v);
var $673c27f9e6ff779b$export$6b9f6c0d32c093f9;
"use strict";

var $iRnO1 = parcelRequire("iRnO1");
/* tslint:enable:max-line-length */ /**
 * Projects each source value to an Observable which is merged in the output
 * Observable.
 *
 * <span class="informal">Maps each value to an Observable, then flattens all of
 * these inner Observables using {@link mergeAll}.</span>
 *
 * <img src="./img/mergeMap.png" width="100%">
 *
 * Returns an Observable that emits items based on applying a function that you
 * supply to each item emitted by the source Observable, where that function
 * returns an Observable, and then merging those resulting Observables and
 * emitting the results of this merger.
 *
 * @example <caption>Map and flatten each letter to an Observable ticking every 1 second</caption>
 * var letters = Rx.Observable.of('a', 'b', 'c');
 * var result = letters.mergeMap(x =>
 *   Rx.Observable.interval(1000).map(i => x+i)
 * );
 * result.subscribe(x => console.log(x));
 *
 * // Results in the following:
 * // a0
 * // b0
 * // c0
 * // a1
 * // b1
 * // c1
 * // continues to list a,b,c with respective ascending integers
 *
 * @see {@link concatMap}
 * @see {@link exhaustMap}
 * @see {@link merge}
 * @see {@link mergeAll}
 * @see {@link mergeMapTo}
 * @see {@link mergeScan}
 * @see {@link switchMap}
 *
 * @param {function(value: T, ?index: number): ObservableInput} project A function
 * that, when applied to an item emitted by the source Observable, returns an
 * Observable.
 * @param {function(outerValue: T, innerValue: I, outerIndex: number, innerIndex: number): any} [resultSelector]
 * A function to produce the value on the output Observable based on the values
 * and the indices of the source (outer) emission and the inner Observable
 * emission. The arguments passed to this function are:
 * - `outerValue`: the value that came from the source
 * - `innerValue`: the value that came from the projected Observable
 * - `outerIndex`: the "index" of the value that came from the source
 * - `innerIndex`: the "index" of the value from the projected Observable
 * @param {number} [concurrent=Number.POSITIVE_INFINITY] Maximum number of input
 * Observables being subscribed to concurrently.
 * @return {Observable} An Observable that emits the result of applying the
 * projection function (and the optional `resultSelector`) to each item emitted
 * by the source Observable and merging the results of the Observables obtained
 * from this transformation.
 * @method mergeMap
 * @owner Observable
 */ function $673c27f9e6ff779b$var$mergeMap(project, resultSelector, concurrent) {
    if (concurrent === void 0) concurrent = Number.POSITIVE_INFINITY;
    return $iRnO1.mergeMap(project, resultSelector, concurrent)(this);
}
$673c27f9e6ff779b$export$6b9f6c0d32c093f9 = $673c27f9e6ff779b$var$mergeMap;

});
parcelRequire.register("iRnO1", function(module, exports) {
"use strict";
var $dbafa490594e036a$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $dkOaF = parcelRequire("dkOaF");

var $2HYhY = parcelRequire("2HYhY");
/* tslint:enable:max-line-length */ /**
 * Projects each source value to an Observable which is merged in the output
 * Observable.
 *
 * <span class="informal">Maps each value to an Observable, then flattens all of
 * these inner Observables using {@link mergeAll}.</span>
 *
 * <img src="./img/mergeMap.png" width="100%">
 *
 * Returns an Observable that emits items based on applying a function that you
 * supply to each item emitted by the source Observable, where that function
 * returns an Observable, and then merging those resulting Observables and
 * emitting the results of this merger.
 *
 * @example <caption>Map and flatten each letter to an Observable ticking every 1 second</caption>
 * var letters = Rx.Observable.of('a', 'b', 'c');
 * var result = letters.mergeMap(x =>
 *   Rx.Observable.interval(1000).map(i => x+i)
 * );
 * result.subscribe(x => console.log(x));
 *
 * // Results in the following:
 * // a0
 * // b0
 * // c0
 * // a1
 * // b1
 * // c1
 * // continues to list a,b,c with respective ascending integers
 *
 * @see {@link concatMap}
 * @see {@link exhaustMap}
 * @see {@link merge}
 * @see {@link mergeAll}
 * @see {@link mergeMapTo}
 * @see {@link mergeScan}
 * @see {@link switchMap}
 *
 * @param {function(value: T, ?index: number): ObservableInput} project A function
 * that, when applied to an item emitted by the source Observable, returns an
 * Observable.
 * @param {function(outerValue: T, innerValue: I, outerIndex: number, innerIndex: number): any} [resultSelector]
 * A function to produce the value on the output Observable based on the values
 * and the indices of the source (outer) emission and the inner Observable
 * emission. The arguments passed to this function are:
 * - `outerValue`: the value that came from the source
 * - `innerValue`: the value that came from the projected Observable
 * - `outerIndex`: the "index" of the value that came from the source
 * - `innerIndex`: the "index" of the value from the projected Observable
 * @param {number} [concurrent=Number.POSITIVE_INFINITY] Maximum number of input
 * Observables being subscribed to concurrently.
 * @return {Observable} An Observable that emits the result of applying the
 * projection function (and the optional `resultSelector`) to each item emitted
 * by the source Observable and merging the results of the Observables obtained
 * from this transformation.
 * @method mergeMap
 * @owner Observable
 */ function $dbafa490594e036a$var$mergeMap(project, resultSelector, concurrent) {
    if (concurrent === void 0) concurrent = Number.POSITIVE_INFINITY;
    return function mergeMapOperatorFunction(source) {
        if (typeof resultSelector === "number") {
            concurrent = resultSelector;
            resultSelector = null;
        }
        return source.lift(new $dbafa490594e036a$var$MergeMapOperator(project, resultSelector, concurrent));
    };
}
module.exports.mergeMap = $dbafa490594e036a$var$mergeMap;
var $dbafa490594e036a$var$MergeMapOperator = function() {
    function MergeMapOperator(project, resultSelector, concurrent) {
        if (concurrent === void 0) concurrent = Number.POSITIVE_INFINITY;
        this.project = project;
        this.resultSelector = resultSelector;
        this.concurrent = concurrent;
    }
    MergeMapOperator.prototype.call = function(observer, source) {
        return source.subscribe(new $dbafa490594e036a$var$MergeMapSubscriber(observer, this.project, this.resultSelector, this.concurrent));
    };
    return MergeMapOperator;
}();
module.exports.MergeMapOperator = $dbafa490594e036a$var$MergeMapOperator;
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $dbafa490594e036a$var$MergeMapSubscriber = function(_super) {
    $dbafa490594e036a$var$__extends(MergeMapSubscriber, _super);
    function MergeMapSubscriber(destination, project, resultSelector, concurrent) {
        if (concurrent === void 0) concurrent = Number.POSITIVE_INFINITY;
        _super.call(this, destination);
        this.project = project;
        this.resultSelector = resultSelector;
        this.concurrent = concurrent;
        this.hasCompleted = false;
        this.buffer = [];
        this.active = 0;
        this.index = 0;
    }
    MergeMapSubscriber.prototype._next = function(value) {
        if (this.active < this.concurrent) this._tryNext(value);
        else this.buffer.push(value);
    };
    MergeMapSubscriber.prototype._tryNext = function(value) {
        var result;
        var index = this.index++;
        try {
            result = this.project(value, index);
        } catch (err) {
            this.destination.error(err);
            return;
        }
        this.active++;
        this._innerSub(result, value, index);
    };
    MergeMapSubscriber.prototype._innerSub = function(ish, value, index) {
        this.add($dkOaF.subscribeToResult(this, ish, value, index));
    };
    MergeMapSubscriber.prototype._complete = function() {
        this.hasCompleted = true;
        if (this.active === 0 && this.buffer.length === 0) this.destination.complete();
    };
    MergeMapSubscriber.prototype.notifyNext = function(outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        if (this.resultSelector) this._notifyResultSelector(outerValue, innerValue, outerIndex, innerIndex);
        else this.destination.next(innerValue);
    };
    MergeMapSubscriber.prototype._notifyResultSelector = function(outerValue, innerValue, outerIndex, innerIndex) {
        var result;
        try {
            result = this.resultSelector(outerValue, innerValue, outerIndex, innerIndex);
        } catch (err) {
            this.destination.error(err);
            return;
        }
        this.destination.next(result);
    };
    MergeMapSubscriber.prototype.notifyComplete = function(innerSub) {
        var buffer = this.buffer;
        this.remove(innerSub);
        this.active--;
        if (buffer.length > 0) this._next(buffer.shift());
        else if (this.active === 0 && this.hasCompleted) this.destination.complete();
    };
    return MergeMapSubscriber;
}($2HYhY.OuterSubscriber);
module.exports.MergeMapSubscriber = $dbafa490594e036a$var$MergeMapSubscriber;

});



parcelRequire.register("e6GkS", function(module, exports) {
"use strict";

var $lyDVs = parcelRequire("lyDVs");

var $e6ZvB = parcelRequire("e6ZvB");
$lyDVs.Observable.prototype.concatMap = $e6ZvB.concatMap;

});
parcelRequire.register("e6ZvB", function(module, exports) {

$parcel$export(module.exports, "concatMap", () => $a4615691b724c307$export$c28c8388be0ab31a, (v) => $a4615691b724c307$export$c28c8388be0ab31a = v);
var $a4615691b724c307$export$c28c8388be0ab31a;
"use strict";

var $44jXw = parcelRequire("44jXw");
/* tslint:enable:max-line-length */ /**
 * Projects each source value to an Observable which is merged in the output
 * Observable, in a serialized fashion waiting for each one to complete before
 * merging the next.
 *
 * <span class="informal">Maps each value to an Observable, then flattens all of
 * these inner Observables using {@link concatAll}.</span>
 *
 * <img src="./img/concatMap.png" width="100%">
 *
 * Returns an Observable that emits items based on applying a function that you
 * supply to each item emitted by the source Observable, where that function
 * returns an (so-called "inner") Observable. Each new inner Observable is
 * concatenated with the previous inner Observable.
 *
 * __Warning:__ if source values arrive endlessly and faster than their
 * corresponding inner Observables can complete, it will result in memory issues
 * as inner Observables amass in an unbounded buffer waiting for their turn to
 * be subscribed to.
 *
 * Note: `concatMap` is equivalent to `mergeMap` with concurrency parameter set
 * to `1`.
 *
 * @example <caption>For each click event, tick every second from 0 to 3, with no concurrency</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.concatMap(ev => Rx.Observable.interval(1000).take(4));
 * result.subscribe(x => console.log(x));
 *
 * // Results in the following:
 * // (results are not concurrent)
 * // For every click on the "document" it will emit values 0 to 3 spaced
 * // on a 1000ms interval
 * // one click = 1000ms-> 0 -1000ms-> 1 -1000ms-> 2 -1000ms-> 3
 *
 * @see {@link concat}
 * @see {@link concatAll}
 * @see {@link concatMapTo}
 * @see {@link exhaustMap}
 * @see {@link mergeMap}
 * @see {@link switchMap}
 *
 * @param {function(value: T, ?index: number): ObservableInput} project A function
 * that, when applied to an item emitted by the source Observable, returns an
 * Observable.
 * @param {function(outerValue: T, innerValue: I, outerIndex: number, innerIndex: number): any} [resultSelector]
 * A function to produce the value on the output Observable based on the values
 * and the indices of the source (outer) emission and the inner Observable
 * emission. The arguments passed to this function are:
 * - `outerValue`: the value that came from the source
 * - `innerValue`: the value that came from the projected Observable
 * - `outerIndex`: the "index" of the value that came from the source
 * - `innerIndex`: the "index" of the value from the projected Observable
 * @return {Observable} An Observable that emits the result of applying the
 * projection function (and the optional `resultSelector`) to each item emitted
 * by the source Observable and taking values from each projected inner
 * Observable sequentially.
 * @method concatMap
 * @owner Observable
 */ function $a4615691b724c307$var$concatMap(project, resultSelector) {
    return $44jXw.concatMap(project, resultSelector)(this);
}
$a4615691b724c307$export$c28c8388be0ab31a = $a4615691b724c307$var$concatMap;

});
parcelRequire.register("44jXw", function(module, exports) {

$parcel$export(module.exports, "concatMap", () => $2f67049c82b31894$export$c28c8388be0ab31a, (v) => $2f67049c82b31894$export$c28c8388be0ab31a = v);
var $2f67049c82b31894$export$c28c8388be0ab31a;
"use strict";

var $iRnO1 = parcelRequire("iRnO1");
/* tslint:enable:max-line-length */ /**
 * Projects each source value to an Observable which is merged in the output
 * Observable, in a serialized fashion waiting for each one to complete before
 * merging the next.
 *
 * <span class="informal">Maps each value to an Observable, then flattens all of
 * these inner Observables using {@link concatAll}.</span>
 *
 * <img src="./img/concatMap.png" width="100%">
 *
 * Returns an Observable that emits items based on applying a function that you
 * supply to each item emitted by the source Observable, where that function
 * returns an (so-called "inner") Observable. Each new inner Observable is
 * concatenated with the previous inner Observable.
 *
 * __Warning:__ if source values arrive endlessly and faster than their
 * corresponding inner Observables can complete, it will result in memory issues
 * as inner Observables amass in an unbounded buffer waiting for their turn to
 * be subscribed to.
 *
 * Note: `concatMap` is equivalent to `mergeMap` with concurrency parameter set
 * to `1`.
 *
 * @example <caption>For each click event, tick every second from 0 to 3, with no concurrency</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.concatMap(ev => Rx.Observable.interval(1000).take(4));
 * result.subscribe(x => console.log(x));
 *
 * // Results in the following:
 * // (results are not concurrent)
 * // For every click on the "document" it will emit values 0 to 3 spaced
 * // on a 1000ms interval
 * // one click = 1000ms-> 0 -1000ms-> 1 -1000ms-> 2 -1000ms-> 3
 *
 * @see {@link concat}
 * @see {@link concatAll}
 * @see {@link concatMapTo}
 * @see {@link exhaustMap}
 * @see {@link mergeMap}
 * @see {@link switchMap}
 *
 * @param {function(value: T, ?index: number): ObservableInput} project A function
 * that, when applied to an item emitted by the source Observable, returns an
 * Observable.
 * @param {function(outerValue: T, innerValue: I, outerIndex: number, innerIndex: number): any} [resultSelector]
 * A function to produce the value on the output Observable based on the values
 * and the indices of the source (outer) emission and the inner Observable
 * emission. The arguments passed to this function are:
 * - `outerValue`: the value that came from the source
 * - `innerValue`: the value that came from the projected Observable
 * - `outerIndex`: the "index" of the value that came from the source
 * - `innerIndex`: the "index" of the value from the projected Observable
 * @return {Observable} An Observable that emits the result of applying the
 * projection function (and the optional `resultSelector`) to each item emitted
 * by the source Observable and taking values from each projected inner
 * Observable sequentially.
 * @method concatMap
 * @owner Observable
 */ function $2f67049c82b31894$var$concatMap(project, resultSelector) {
    return $iRnO1.mergeMap(project, resultSelector, 1);
}
$2f67049c82b31894$export$c28c8388be0ab31a = $2f67049c82b31894$var$concatMap;

});



parcelRequire.register("2p5xo", function(module, exports) {
"use strict";

var $lyDVs = parcelRequire("lyDVs");

var $gfQux = parcelRequire("gfQux");
$lyDVs.Observable.prototype.retryWhen = $gfQux.retryWhen;

});
parcelRequire.register("gfQux", function(module, exports) {

$parcel$export(module.exports, "retryWhen", () => $bd56c3c78bacbd3d$export$1281551253cfee02, (v) => $bd56c3c78bacbd3d$export$1281551253cfee02 = v);
var $bd56c3c78bacbd3d$export$1281551253cfee02;
"use strict";

var $4ub2Y = parcelRequire("4ub2Y");
/**
 * Returns an Observable that mirrors the source Observable with the exception of an `error`. If the source Observable
 * calls `error`, this method will emit the Throwable that caused the error to the Observable returned from `notifier`.
 * If that Observable calls `complete` or `error` then this method will call `complete` or `error` on the child
 * subscription. Otherwise this method will resubscribe to the source Observable.
 *
 * <img src="./img/retryWhen.png" width="100%">
 *
 * @param {function(errors: Observable): Observable} notifier - Receives an Observable of notifications with which a
 * user can `complete` or `error`, aborting the retry.
 * @return {Observable} The source Observable modified with retry logic.
 * @method retryWhen
 * @owner Observable
 */ function $bd56c3c78bacbd3d$var$retryWhen(notifier) {
    return $4ub2Y.retryWhen(notifier)(this);
}
$bd56c3c78bacbd3d$export$1281551253cfee02 = $bd56c3c78bacbd3d$var$retryWhen;

});
parcelRequire.register("4ub2Y", function(module, exports) {
"use strict";
var $34428876fa190177$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $gfSg8 = parcelRequire("gfSg8");

var $hQGdZ = parcelRequire("hQGdZ");

var $9hvEt = parcelRequire("9hvEt");

var $2HYhY = parcelRequire("2HYhY");

var $dkOaF = parcelRequire("dkOaF");
/**
 * Returns an Observable that mirrors the source Observable with the exception of an `error`. If the source Observable
 * calls `error`, this method will emit the Throwable that caused the error to the Observable returned from `notifier`.
 * If that Observable calls `complete` or `error` then this method will call `complete` or `error` on the child
 * subscription. Otherwise this method will resubscribe to the source Observable.
 *
 * <img src="./img/retryWhen.png" width="100%">
 *
 * @param {function(errors: Observable): Observable} notifier - Receives an Observable of notifications with which a
 * user can `complete` or `error`, aborting the retry.
 * @return {Observable} The source Observable modified with retry logic.
 * @method retryWhen
 * @owner Observable
 */ function $34428876fa190177$var$retryWhen(notifier) {
    return function(source) {
        return source.lift(new $34428876fa190177$var$RetryWhenOperator(notifier, source));
    };
}
module.exports.retryWhen = $34428876fa190177$var$retryWhen;
var $34428876fa190177$var$RetryWhenOperator = function() {
    function RetryWhenOperator(notifier, source) {
        this.notifier = notifier;
        this.source = source;
    }
    RetryWhenOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $34428876fa190177$var$RetryWhenSubscriber(subscriber, this.notifier, this.source));
    };
    return RetryWhenOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $34428876fa190177$var$RetryWhenSubscriber = function(_super) {
    $34428876fa190177$var$__extends(RetryWhenSubscriber, _super);
    function RetryWhenSubscriber(destination, notifier, source) {
        _super.call(this, destination);
        this.notifier = notifier;
        this.source = source;
    }
    RetryWhenSubscriber.prototype.error = function(err) {
        if (!this.isStopped) {
            var errors = this.errors;
            var retries = this.retries;
            var retriesSubscription = this.retriesSubscription;
            if (!retries) {
                errors = new $gfSg8.Subject();
                retries = $hQGdZ.tryCatch(this.notifier)(errors);
                if (retries === $9hvEt.errorObject) return _super.prototype.error.call(this, $9hvEt.errorObject.e);
                retriesSubscription = $dkOaF.subscribeToResult(this, retries);
            } else {
                this.errors = null;
                this.retriesSubscription = null;
            }
            this._unsubscribeAndRecycle();
            this.errors = errors;
            this.retries = retries;
            this.retriesSubscription = retriesSubscription;
            errors.next(err);
        }
    };
    /** @deprecated internal use only */ RetryWhenSubscriber.prototype._unsubscribe = function() {
        var _a = this, errors = _a.errors, retriesSubscription = _a.retriesSubscription;
        if (errors) {
            errors.unsubscribe();
            this.errors = null;
        }
        if (retriesSubscription) {
            retriesSubscription.unsubscribe();
            this.retriesSubscription = null;
        }
        this.retries = null;
    };
    RetryWhenSubscriber.prototype.notifyNext = function(outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        var _a = this, errors = _a.errors, retries = _a.retries, retriesSubscription = _a.retriesSubscription;
        this.errors = null;
        this.retries = null;
        this.retriesSubscription = null;
        this._unsubscribeAndRecycle();
        this.errors = errors;
        this.retries = retries;
        this.retriesSubscription = retriesSubscription;
        this.source.subscribe(this);
    };
    return RetryWhenSubscriber;
}($2HYhY.OuterSubscriber);

});



parcelRequire.register("8B8mh", function(module, exports) {
"use strict";

var $lyDVs = parcelRequire("lyDVs");

var $7b9kp = parcelRequire("7b9kp");
$lyDVs.Observable.prototype.share = $7b9kp.share;

});
parcelRequire.register("7b9kp", function(module, exports) {

$parcel$export(module.exports, "share", () => $53a0cbdfe5b4192f$export$ed80d9de1d9df928, (v) => $53a0cbdfe5b4192f$export$ed80d9de1d9df928 = v);
var $53a0cbdfe5b4192f$export$ed80d9de1d9df928;
"use strict";

var $ftqHQ = parcelRequire("ftqHQ");
/**
 * Returns a new Observable that multicasts (shares) the original Observable. As long as there is at least one
 * Subscriber this Observable will be subscribed and emitting data. When all subscribers have unsubscribed it will
 * unsubscribe from the source Observable. Because the Observable is multicasting it makes the stream `hot`.
 *
 * This behaves similarly to .publish().refCount(), with a behavior difference when the source observable emits complete.
 * .publish().refCount() will not resubscribe to the original source, however .share() will resubscribe to the original source.
 * Observable.of("test").publish().refCount() will not re-emit "test" on new subscriptions, Observable.of("test").share() will
 * re-emit "test" to new subscriptions.
 *
 * <img src="./img/share.png" width="100%">
 *
 * @return {Observable<T>} An Observable that upon connection causes the source Observable to emit items to its Observers.
 * @method share
 * @owner Observable
 */ function $53a0cbdfe5b4192f$var$share() {
    return $ftqHQ.share()(this);
}
$53a0cbdfe5b4192f$export$ed80d9de1d9df928 = $53a0cbdfe5b4192f$var$share;

});
parcelRequire.register("ftqHQ", function(module, exports) {

$parcel$export(module.exports, "share", () => $b43e47c1bd32ea90$export$ed80d9de1d9df928, (v) => $b43e47c1bd32ea90$export$ed80d9de1d9df928 = v);
var $b43e47c1bd32ea90$export$ed80d9de1d9df928;
"use strict";

var $925Ra = parcelRequire("925Ra");

var $9MA8K = parcelRequire("9MA8K");

var $gfSg8 = parcelRequire("gfSg8");
function $b43e47c1bd32ea90$var$shareSubjectFactory() {
    return new $gfSg8.Subject();
}
/**
 * Returns a new Observable that multicasts (shares) the original Observable. As long as there is at least one
 * Subscriber this Observable will be subscribed and emitting data. When all subscribers have unsubscribed it will
 * unsubscribe from the source Observable. Because the Observable is multicasting it makes the stream `hot`.
 * This is an alias for .multicast(() => new Subject()).refCount().
 *
 * <img src="./img/share.png" width="100%">
 *
 * @return {Observable<T>} An Observable that upon connection causes the source Observable to emit items to its Observers.
 * @method share
 * @owner Observable
 */ function $b43e47c1bd32ea90$var$share() {
    return function(source) {
        return $9MA8K.refCount()($925Ra.multicast($b43e47c1bd32ea90$var$shareSubjectFactory)(source));
    };
}
$b43e47c1bd32ea90$export$ed80d9de1d9df928 = $b43e47c1bd32ea90$var$share;

});
parcelRequire.register("925Ra", function(module, exports) {

$parcel$export(module.exports, "multicast", () => $6938d7ebda3f8c5d$export$1364843af8d5a963, (v) => $6938d7ebda3f8c5d$export$1364843af8d5a963 = v);
var $6938d7ebda3f8c5d$export$1364843af8d5a963;
var $6938d7ebda3f8c5d$export$150d52413393bf2c;
"use strict";

var $gGKqA = parcelRequire("gGKqA");
/* tslint:enable:max-line-length */ /**
 * Returns an Observable that emits the results of invoking a specified selector on items
 * emitted by a ConnectableObservable that shares a single subscription to the underlying stream.
 *
 * <img src="./img/multicast.png" width="100%">
 *
 * @param {Function|Subject} subjectOrSubjectFactory - Factory function to create an intermediate subject through
 * which the source sequence's elements will be multicast to the selector function
 * or Subject to push source elements into.
 * @param {Function} [selector] - Optional selector function that can use the multicasted source stream
 * as many times as needed, without causing multiple subscriptions to the source stream.
 * Subscribers to the given source will receive all notifications of the source from the
 * time of the subscription forward.
 * @return {Observable} An Observable that emits the results of invoking the selector
 * on the items emitted by a `ConnectableObservable` that shares a single subscription to
 * the underlying stream.
 * @method multicast
 * @owner Observable
 */ function $6938d7ebda3f8c5d$var$multicast(subjectOrSubjectFactory, selector) {
    return function multicastOperatorFunction(source) {
        var subjectFactory;
        if (typeof subjectOrSubjectFactory === "function") subjectFactory = subjectOrSubjectFactory;
        else subjectFactory = function subjectFactory() {
            return subjectOrSubjectFactory;
        };
        if (typeof selector === "function") return source.lift(new $6938d7ebda3f8c5d$var$MulticastOperator(subjectFactory, selector));
        var connectable = Object.create(source, $gGKqA.connectableObservableDescriptor);
        connectable.source = source;
        connectable.subjectFactory = subjectFactory;
        return connectable;
    };
}
$6938d7ebda3f8c5d$export$1364843af8d5a963 = $6938d7ebda3f8c5d$var$multicast;
var $6938d7ebda3f8c5d$var$MulticastOperator = function() {
    function MulticastOperator(subjectFactory, selector) {
        this.subjectFactory = subjectFactory;
        this.selector = selector;
    }
    MulticastOperator.prototype.call = function(subscriber, source) {
        var selector = this.selector;
        var subject = this.subjectFactory();
        var subscription = selector(subject).subscribe(subscriber);
        subscription.add(source.subscribe(subject));
        return subscription;
    };
    return MulticastOperator;
}();
$6938d7ebda3f8c5d$export$150d52413393bf2c = $6938d7ebda3f8c5d$var$MulticastOperator;

});
parcelRequire.register("gGKqA", function(module, exports) {
"use strict";
var $0322a7912f2e2d69$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $gfSg8 = parcelRequire("gfSg8");

var $lyDVs = parcelRequire("lyDVs");

var $gYcab = parcelRequire("gYcab");

var $lSRxI = parcelRequire("lSRxI");

var $9MA8K = parcelRequire("9MA8K");
/**
 * @class ConnectableObservable<T>
 */ var $0322a7912f2e2d69$var$ConnectableObservable = function(_super) {
    $0322a7912f2e2d69$var$__extends(ConnectableObservable, _super);
    function ConnectableObservable(/** @deprecated internal use only */ source, /** @deprecated internal use only */ subjectFactory) {
        _super.call(this);
        this.source = source;
        this.subjectFactory = subjectFactory;
        /** @deprecated internal use only */ this._refCount = 0;
        this._isComplete = false;
    }
    /** @deprecated internal use only */ ConnectableObservable.prototype._subscribe = function(subscriber) {
        return this.getSubject().subscribe(subscriber);
    };
    /** @deprecated internal use only */ ConnectableObservable.prototype.getSubject = function() {
        var subject = this._subject;
        if (!subject || subject.isStopped) this._subject = this.subjectFactory();
        return this._subject;
    };
    ConnectableObservable.prototype.connect = function() {
        var connection = this._connection;
        if (!connection) {
            this._isComplete = false;
            connection = this._connection = new $lSRxI.Subscription();
            connection.add(this.source.subscribe(new $0322a7912f2e2d69$var$ConnectableSubscriber(this.getSubject(), this)));
            if (connection.closed) {
                this._connection = null;
                connection = $lSRxI.Subscription.EMPTY;
            } else this._connection = connection;
        }
        return connection;
    };
    ConnectableObservable.prototype.refCount = function() {
        return $9MA8K.refCount()(this);
    };
    return ConnectableObservable;
}($lyDVs.Observable);
module.exports.ConnectableObservable = $0322a7912f2e2d69$var$ConnectableObservable;
var $0322a7912f2e2d69$var$connectableProto = $0322a7912f2e2d69$var$ConnectableObservable.prototype;
module.exports.connectableObservableDescriptor = {
    operator: {
        value: null
    },
    _refCount: {
        value: 0,
        writable: true
    },
    _subject: {
        value: null,
        writable: true
    },
    _connection: {
        value: null,
        writable: true
    },
    _subscribe: {
        value: $0322a7912f2e2d69$var$connectableProto._subscribe
    },
    _isComplete: {
        value: $0322a7912f2e2d69$var$connectableProto._isComplete,
        writable: true
    },
    getSubject: {
        value: $0322a7912f2e2d69$var$connectableProto.getSubject
    },
    connect: {
        value: $0322a7912f2e2d69$var$connectableProto.connect
    },
    refCount: {
        value: $0322a7912f2e2d69$var$connectableProto.refCount
    }
};
var $0322a7912f2e2d69$var$ConnectableSubscriber = function(_super) {
    $0322a7912f2e2d69$var$__extends(ConnectableSubscriber, _super);
    function ConnectableSubscriber(destination, connectable) {
        _super.call(this, destination);
        this.connectable = connectable;
    }
    ConnectableSubscriber.prototype._error = function(err) {
        this._unsubscribe();
        _super.prototype._error.call(this, err);
    };
    ConnectableSubscriber.prototype._complete = function() {
        this.connectable._isComplete = true;
        this._unsubscribe();
        _super.prototype._complete.call(this);
    };
    /** @deprecated internal use only */ ConnectableSubscriber.prototype._unsubscribe = function() {
        var connectable = this.connectable;
        if (connectable) {
            this.connectable = null;
            var connection = connectable._connection;
            connectable._refCount = 0;
            connectable._subject = null;
            connectable._connection = null;
            if (connection) connection.unsubscribe();
        }
    };
    return ConnectableSubscriber;
}($gfSg8.SubjectSubscriber);
var $0322a7912f2e2d69$var$RefCountOperator = function() {
    function RefCountOperator(connectable) {
        this.connectable = connectable;
    }
    RefCountOperator.prototype.call = function(subscriber, source) {
        var connectable = this.connectable;
        connectable._refCount++;
        var refCounter = new $0322a7912f2e2d69$var$RefCountSubscriber(subscriber, connectable);
        var subscription = source.subscribe(refCounter);
        if (!refCounter.closed) refCounter.connection = connectable.connect();
        return subscription;
    };
    return RefCountOperator;
}();
var $0322a7912f2e2d69$var$RefCountSubscriber = function(_super) {
    $0322a7912f2e2d69$var$__extends(RefCountSubscriber, _super);
    function RefCountSubscriber(destination, connectable) {
        _super.call(this, destination);
        this.connectable = connectable;
    }
    /** @deprecated internal use only */ RefCountSubscriber.prototype._unsubscribe = function() {
        var connectable = this.connectable;
        if (!connectable) {
            this.connection = null;
            return;
        }
        this.connectable = null;
        var refCount = connectable._refCount;
        if (refCount <= 0) {
            this.connection = null;
            return;
        }
        connectable._refCount = refCount - 1;
        if (refCount > 1) {
            this.connection = null;
            return;
        }
        ///
        // Compare the local RefCountSubscriber's connection Subscription to the
        // connection Subscription on the shared ConnectableObservable. In cases
        // where the ConnectableObservable source synchronously emits values, and
        // the RefCountSubscriber's downstream Observers synchronously unsubscribe,
        // execution continues to here before the RefCountOperator has a chance to
        // supply the RefCountSubscriber with the shared connection Subscription.
        // For example:
        // ```
        // Observable.range(0, 10)
        //   .publish()
        //   .refCount()
        //   .take(5)
        //   .subscribe();
        // ```
        // In order to account for this case, RefCountSubscriber should only dispose
        // the ConnectableObservable's shared connection Subscription if the
        // connection Subscription exists, *and* either:
        //   a. RefCountSubscriber doesn't have a reference to the shared connection
        //      Subscription yet, or,
        //   b. RefCountSubscriber's connection Subscription reference is identical
        //      to the shared connection Subscription
        ///
        var connection = this.connection;
        var sharedConnection = connectable._connection;
        this.connection = null;
        if (sharedConnection && (!connection || sharedConnection === connection)) sharedConnection.unsubscribe();
    };
    return RefCountSubscriber;
}($gYcab.Subscriber);

});
parcelRequire.register("9MA8K", function(module, exports) {
"use strict";
var $71f4a167825d81e8$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $gYcab = parcelRequire("gYcab");
function $71f4a167825d81e8$var$refCount() {
    return function refCountOperatorFunction(source) {
        return source.lift(new $71f4a167825d81e8$var$RefCountOperator(source));
    };
}
module.exports.refCount = $71f4a167825d81e8$var$refCount;
var $71f4a167825d81e8$var$RefCountOperator = function() {
    function RefCountOperator(connectable) {
        this.connectable = connectable;
    }
    RefCountOperator.prototype.call = function(subscriber, source) {
        var connectable = this.connectable;
        connectable._refCount++;
        var refCounter = new $71f4a167825d81e8$var$RefCountSubscriber(subscriber, connectable);
        var subscription = source.subscribe(refCounter);
        if (!refCounter.closed) refCounter.connection = connectable.connect();
        return subscription;
    };
    return RefCountOperator;
}();
var $71f4a167825d81e8$var$RefCountSubscriber = function(_super) {
    $71f4a167825d81e8$var$__extends(RefCountSubscriber, _super);
    function RefCountSubscriber(destination, connectable) {
        _super.call(this, destination);
        this.connectable = connectable;
    }
    /** @deprecated internal use only */ RefCountSubscriber.prototype._unsubscribe = function() {
        var connectable = this.connectable;
        if (!connectable) {
            this.connection = null;
            return;
        }
        this.connectable = null;
        var refCount = connectable._refCount;
        if (refCount <= 0) {
            this.connection = null;
            return;
        }
        connectable._refCount = refCount - 1;
        if (refCount > 1) {
            this.connection = null;
            return;
        }
        ///
        // Compare the local RefCountSubscriber's connection Subscription to the
        // connection Subscription on the shared ConnectableObservable. In cases
        // where the ConnectableObservable source synchronously emits values, and
        // the RefCountSubscriber's downstream Observers synchronously unsubscribe,
        // execution continues to here before the RefCountOperator has a chance to
        // supply the RefCountSubscriber with the shared connection Subscription.
        // For example:
        // ```
        // Observable.range(0, 10)
        //   .publish()
        //   .refCount()
        //   .take(5)
        //   .subscribe();
        // ```
        // In order to account for this case, RefCountSubscriber should only dispose
        // the ConnectableObservable's shared connection Subscription if the
        // connection Subscription exists, *and* either:
        //   a. RefCountSubscriber doesn't have a reference to the shared connection
        //      Subscription yet, or,
        //   b. RefCountSubscriber's connection Subscription reference is identical
        //      to the shared connection Subscription
        ///
        var connection = this.connection;
        var sharedConnection = connectable._connection;
        this.connection = null;
        if (sharedConnection && (!connection || sharedConnection === connection)) sharedConnection.unsubscribe();
    };
    return RefCountSubscriber;
}($gYcab.Subscriber);

});






parcelRequire.register("k9MKp", function(module, exports) {
"use strict";

var $lyDVs = parcelRequire("lyDVs");

var $3JJ9p = parcelRequire("3JJ9p");
$lyDVs.Observable.prototype.take = $3JJ9p.take;

});
parcelRequire.register("3JJ9p", function(module, exports) {

$parcel$export(module.exports, "take", () => $2b88991271567266$export$b7df5d561049483a, (v) => $2b88991271567266$export$b7df5d561049483a = v);
var $2b88991271567266$export$b7df5d561049483a;
"use strict";

var $cx7ty = parcelRequire("cx7ty");
/**
 * Emits only the first `count` values emitted by the source Observable.
 *
 * <span class="informal">Takes the first `count` values from the source, then
 * completes.</span>
 *
 * <img src="./img/take.png" width="100%">
 *
 * `take` returns an Observable that emits only the first `count` values emitted
 * by the source Observable. If the source emits fewer than `count` values then
 * all of its values are emitted. After that, it completes, regardless if the
 * source completes.
 *
 * @example <caption>Take the first 5 seconds of an infinite 1-second interval Observable</caption>
 * var interval = Rx.Observable.interval(1000);
 * var five = interval.take(5);
 * five.subscribe(x => console.log(x));
 *
 * @see {@link takeLast}
 * @see {@link takeUntil}
 * @see {@link takeWhile}
 * @see {@link skip}
 *
 * @throws {ArgumentOutOfRangeError} When using `take(i)`, it delivers an
 * ArgumentOutOrRangeError to the Observer's `error` callback if `i < 0`.
 *
 * @param {number} count The maximum number of `next` values to emit.
 * @return {Observable<T>} An Observable that emits only the first `count`
 * values emitted by the source Observable, or all of the values from the source
 * if the source emits fewer than `count` values.
 * @method take
 * @owner Observable
 */ function $2b88991271567266$var$take(count) {
    return $cx7ty.take(count)(this);
}
$2b88991271567266$export$b7df5d561049483a = $2b88991271567266$var$take;

});
parcelRequire.register("cx7ty", function(module, exports) {
"use strict";
var $91fe5d9b52822c55$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $gYcab = parcelRequire("gYcab");

var $3G7xN = parcelRequire("3G7xN");

var $3pasW = parcelRequire("3pasW");
/**
 * Emits only the first `count` values emitted by the source Observable.
 *
 * <span class="informal">Takes the first `count` values from the source, then
 * completes.</span>
 *
 * <img src="./img/take.png" width="100%">
 *
 * `take` returns an Observable that emits only the first `count` values emitted
 * by the source Observable. If the source emits fewer than `count` values then
 * all of its values are emitted. After that, it completes, regardless if the
 * source completes.
 *
 * @example <caption>Take the first 5 seconds of an infinite 1-second interval Observable</caption>
 * var interval = Rx.Observable.interval(1000);
 * var five = interval.take(5);
 * five.subscribe(x => console.log(x));
 *
 * @see {@link takeLast}
 * @see {@link takeUntil}
 * @see {@link takeWhile}
 * @see {@link skip}
 *
 * @throws {ArgumentOutOfRangeError} When using `take(i)`, it delivers an
 * ArgumentOutOrRangeError to the Observer's `error` callback if `i < 0`.
 *
 * @param {number} count The maximum number of `next` values to emit.
 * @return {Observable<T>} An Observable that emits only the first `count`
 * values emitted by the source Observable, or all of the values from the source
 * if the source emits fewer than `count` values.
 * @method take
 * @owner Observable
 */ function $91fe5d9b52822c55$var$take(count) {
    return function(source) {
        if (count === 0) return new $3pasW.EmptyObservable();
        else return source.lift(new $91fe5d9b52822c55$var$TakeOperator(count));
    };
}
module.exports.take = $91fe5d9b52822c55$var$take;
var $91fe5d9b52822c55$var$TakeOperator = function() {
    function TakeOperator(total) {
        this.total = total;
        if (this.total < 0) throw new $3G7xN.ArgumentOutOfRangeError;
    }
    TakeOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $91fe5d9b52822c55$var$TakeSubscriber(subscriber, this.total));
    };
    return TakeOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $91fe5d9b52822c55$var$TakeSubscriber = function(_super) {
    $91fe5d9b52822c55$var$__extends(TakeSubscriber, _super);
    function TakeSubscriber(destination, total) {
        _super.call(this, destination);
        this.total = total;
        this.count = 0;
    }
    TakeSubscriber.prototype._next = function(value) {
        var total = this.total;
        var count = ++this.count;
        if (count <= total) {
            this.destination.next(value);
            if (count === total) {
                this.destination.complete();
                this.unsubscribe();
            }
        }
    };
    return TakeSubscriber;
}($gYcab.Subscriber);

});
parcelRequire.register("3G7xN", function(module, exports) {
"use strict";
var $2adb256e49e262cb$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
/**
 * An error thrown when an element was queried at a certain index of an
 * Observable, but no such index or position exists in that sequence.
 *
 * @see {@link elementAt}
 * @see {@link take}
 * @see {@link takeLast}
 *
 * @class ArgumentOutOfRangeError
 */ var $2adb256e49e262cb$var$ArgumentOutOfRangeError = function(_super) {
    $2adb256e49e262cb$var$__extends(ArgumentOutOfRangeError, _super);
    function ArgumentOutOfRangeError() {
        var err = _super.call(this, "argument out of range");
        this.name = err.name = "ArgumentOutOfRangeError";
        this.stack = err.stack;
        this.message = err.message;
    }
    return ArgumentOutOfRangeError;
}(Error);
module.exports.ArgumentOutOfRangeError = $2adb256e49e262cb$var$ArgumentOutOfRangeError;

});




parcelRequire.register("gMM0m", function(module, exports) {
"use strict";

var $lyDVs = parcelRequire("lyDVs");

var $gGVJE = parcelRequire("gGVJE");
$lyDVs.Observable.ajax = $gGVJE.ajax;

});
parcelRequire.register("gGVJE", function(module, exports) {

$parcel$export(module.exports, "ajax", () => $c26d5a9f1b0ded63$export$e68fce4c5f453854, (v) => $c26d5a9f1b0ded63$export$e68fce4c5f453854 = v);
var $c26d5a9f1b0ded63$export$e68fce4c5f453854;
"use strict";

var $8eUt9 = parcelRequire("8eUt9");
$c26d5a9f1b0ded63$export$e68fce4c5f453854 = $8eUt9.AjaxObservable.create;

});
parcelRequire.register("8eUt9", function(module, exports) {
"use strict";
var $5ffb6f29843817c0$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $hGUNf = parcelRequire("hGUNf");

var $hQGdZ = parcelRequire("hQGdZ");

var $9hvEt = parcelRequire("9hvEt");

var $lyDVs = parcelRequire("lyDVs");

var $gYcab = parcelRequire("gYcab");

var $7SucU = parcelRequire("7SucU");
function $5ffb6f29843817c0$var$getCORSRequest() {
    if ($hGUNf.root.XMLHttpRequest) return new $hGUNf.root.XMLHttpRequest();
    else if (!!$hGUNf.root.XDomainRequest) return new $hGUNf.root.XDomainRequest();
    else throw new Error("CORS is not supported by your browser");
}
function $5ffb6f29843817c0$var$getXMLHttpRequest() {
    if ($hGUNf.root.XMLHttpRequest) return new $hGUNf.root.XMLHttpRequest();
    else {
        var progId = void 0;
        try {
            var progIds = [
                "Msxml2.XMLHTTP",
                "Microsoft.XMLHTTP",
                "Msxml2.XMLHTTP.4.0"
            ];
            for(var i = 0; i < 3; i++)try {
                progId = progIds[i];
                new $hGUNf.root.ActiveXObject(progId);
                break;
            } catch (e) {}
            return new $hGUNf.root.ActiveXObject(progId);
        } catch (e) {
            throw new Error("XMLHttpRequest is not supported by your browser");
        }
    }
}
function $5ffb6f29843817c0$var$ajaxGet(url, headers) {
    if (headers === void 0) headers = null;
    return new $5ffb6f29843817c0$var$AjaxObservable({
        method: "GET",
        url: url,
        headers: headers
    });
}
module.exports.ajaxGet = $5ffb6f29843817c0$var$ajaxGet;
function $5ffb6f29843817c0$var$ajaxPost(url, body, headers) {
    return new $5ffb6f29843817c0$var$AjaxObservable({
        method: "POST",
        url: url,
        body: body,
        headers: headers
    });
}
module.exports.ajaxPost = $5ffb6f29843817c0$var$ajaxPost;
function $5ffb6f29843817c0$var$ajaxDelete(url, headers) {
    return new $5ffb6f29843817c0$var$AjaxObservable({
        method: "DELETE",
        url: url,
        headers: headers
    });
}
module.exports.ajaxDelete = $5ffb6f29843817c0$var$ajaxDelete;
function $5ffb6f29843817c0$var$ajaxPut(url, body, headers) {
    return new $5ffb6f29843817c0$var$AjaxObservable({
        method: "PUT",
        url: url,
        body: body,
        headers: headers
    });
}
module.exports.ajaxPut = $5ffb6f29843817c0$var$ajaxPut;
function $5ffb6f29843817c0$var$ajaxPatch(url, body, headers) {
    return new $5ffb6f29843817c0$var$AjaxObservable({
        method: "PATCH",
        url: url,
        body: body,
        headers: headers
    });
}
module.exports.ajaxPatch = $5ffb6f29843817c0$var$ajaxPatch;
var $5ffb6f29843817c0$var$mapResponse = $7SucU.map(function(x, index) {
    return x.response;
});
function $5ffb6f29843817c0$var$ajaxGetJSON(url, headers) {
    return $5ffb6f29843817c0$var$mapResponse(new $5ffb6f29843817c0$var$AjaxObservable({
        method: "GET",
        url: url,
        responseType: "json",
        headers: headers
    }));
}
module.exports.ajaxGetJSON = $5ffb6f29843817c0$var$ajaxGetJSON;
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */ var $5ffb6f29843817c0$var$AjaxObservable = function(_super) {
    $5ffb6f29843817c0$var$__extends(AjaxObservable, _super);
    function AjaxObservable(urlOrRequest) {
        _super.call(this);
        var request = {
            async: true,
            createXHR: function() {
                return this.crossDomain ? $5ffb6f29843817c0$var$getCORSRequest.call(this) : $5ffb6f29843817c0$var$getXMLHttpRequest();
            },
            crossDomain: false,
            withCredentials: false,
            headers: {},
            method: "GET",
            responseType: "json",
            timeout: 0
        };
        if (typeof urlOrRequest === "string") request.url = urlOrRequest;
        else {
            for(var prop in urlOrRequest)if (urlOrRequest.hasOwnProperty(prop)) request[prop] = urlOrRequest[prop];
        }
        this.request = request;
    }
    /** @deprecated internal use only */ AjaxObservable.prototype._subscribe = function(subscriber) {
        return new $5ffb6f29843817c0$var$AjaxSubscriber(subscriber, this.request);
    };
    /**
     * Creates an observable for an Ajax request with either a request object with
     * url, headers, etc or a string for a URL.
     *
     * @example
     * source = Rx.Observable.ajax('/products');
     * source = Rx.Observable.ajax({ url: 'products', method: 'GET' });
     *
     * @param {string|Object} request Can be one of the following:
     *   A string of the URL to make the Ajax call.
     *   An object with the following properties
     *   - url: URL of the request
     *   - body: The body of the request
     *   - method: Method of the request, such as GET, POST, PUT, PATCH, DELETE
     *   - async: Whether the request is async
     *   - headers: Optional headers
     *   - crossDomain: true if a cross domain request, else false
     *   - createXHR: a function to override if you need to use an alternate
     *   XMLHttpRequest implementation.
     *   - resultSelector: a function to use to alter the output value type of
     *   the Observable. Gets {@link AjaxResponse} as an argument.
     * @return {Observable} An observable sequence containing the XMLHttpRequest.
     * @static true
     * @name ajax
     * @owner Observable
    */ AjaxObservable.create = function() {
        var create = function(urlOrRequest) {
            return new AjaxObservable(urlOrRequest);
        };
        create.get = $5ffb6f29843817c0$var$ajaxGet;
        create.post = $5ffb6f29843817c0$var$ajaxPost;
        create.delete = $5ffb6f29843817c0$var$ajaxDelete;
        create.put = $5ffb6f29843817c0$var$ajaxPut;
        create.patch = $5ffb6f29843817c0$var$ajaxPatch;
        create.getJSON = $5ffb6f29843817c0$var$ajaxGetJSON;
        return create;
    }();
    return AjaxObservable;
}($lyDVs.Observable);
module.exports.AjaxObservable = $5ffb6f29843817c0$var$AjaxObservable;
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $5ffb6f29843817c0$var$AjaxSubscriber = function(_super) {
    $5ffb6f29843817c0$var$__extends(AjaxSubscriber, _super);
    function AjaxSubscriber(destination, request) {
        _super.call(this, destination);
        this.request = request;
        this.done = false;
        var headers = request.headers = request.headers || {};
        // force CORS if requested
        if (!request.crossDomain && !headers["X-Requested-With"]) headers["X-Requested-With"] = "XMLHttpRequest";
        // ensure content type is set
        if (!("Content-Type" in headers) && !($hGUNf.root.FormData && request.body instanceof $hGUNf.root.FormData) && typeof request.body !== "undefined") headers["Content-Type"] = "application/x-www-form-urlencoded; charset=UTF-8";
        // properly serialize body
        request.body = this.serializeBody(request.body, request.headers["Content-Type"]);
        this.send();
    }
    AjaxSubscriber.prototype.next = function(e) {
        this.done = true;
        var _a = this, xhr = _a.xhr, request = _a.request, destination = _a.destination;
        var response = new $5ffb6f29843817c0$var$AjaxResponse(e, xhr, request);
        destination.next(response);
    };
    AjaxSubscriber.prototype.send = function() {
        var _a = this, request = _a.request, _b = _a.request, user = _b.user, method = _b.method, url = _b.url, async = _b.async, password = _b.password, headers = _b.headers, body = _b.body;
        var createXHR = request.createXHR;
        var xhr = $hQGdZ.tryCatch(createXHR).call(request);
        if (xhr === $9hvEt.errorObject) this.error($9hvEt.errorObject.e);
        else {
            this.xhr = xhr;
            // set up the events before open XHR
            // https://developer.mozilla.org/en/docs/Web/API/XMLHttpRequest/Using_XMLHttpRequest
            // You need to add the event listeners before calling open() on the request.
            // Otherwise the progress events will not fire.
            this.setupEvents(xhr, request);
            // open XHR
            var result = void 0;
            if (user) result = $hQGdZ.tryCatch(xhr.open).call(xhr, method, url, async, user, password);
            else result = $hQGdZ.tryCatch(xhr.open).call(xhr, method, url, async);
            if (result === $9hvEt.errorObject) {
                this.error($9hvEt.errorObject.e);
                return null;
            }
            // timeout, responseType and withCredentials can be set once the XHR is open
            if (async) {
                xhr.timeout = request.timeout;
                xhr.responseType = request.responseType;
            }
            if ("withCredentials" in xhr) xhr.withCredentials = !!request.withCredentials;
            // set headers
            this.setHeaders(xhr, headers);
            // finally send the request
            result = body ? $hQGdZ.tryCatch(xhr.send).call(xhr, body) : $hQGdZ.tryCatch(xhr.send).call(xhr);
            if (result === $9hvEt.errorObject) {
                this.error($9hvEt.errorObject.e);
                return null;
            }
        }
        return xhr;
    };
    AjaxSubscriber.prototype.serializeBody = function(body, contentType) {
        if (!body || typeof body === "string") return body;
        else if ($hGUNf.root.FormData && body instanceof $hGUNf.root.FormData) return body;
        if (contentType) {
            var splitIndex = contentType.indexOf(";");
            if (splitIndex !== -1) contentType = contentType.substring(0, splitIndex);
        }
        switch(contentType){
            case "application/x-www-form-urlencoded":
                return Object.keys(body).map(function(key) {
                    return encodeURIComponent(key) + "=" + encodeURIComponent(body[key]);
                }).join("&");
            case "application/json":
                return JSON.stringify(body);
            default:
                return body;
        }
    };
    AjaxSubscriber.prototype.setHeaders = function(xhr, headers) {
        for(var key in headers)if (headers.hasOwnProperty(key)) xhr.setRequestHeader(key, headers[key]);
    };
    AjaxSubscriber.prototype.setupEvents = function(xhr, request) {
        var progressSubscriber = request.progressSubscriber;
        function xhrTimeout(e) {
            var _a = xhrTimeout, subscriber = _a.subscriber, progressSubscriber = _a.progressSubscriber, request = _a.request;
            if (progressSubscriber) progressSubscriber.error(e);
            subscriber.error(new $5ffb6f29843817c0$var$AjaxTimeoutError(this, request)); //TODO: Make betterer.
        }
        xhr.ontimeout = xhrTimeout;
        xhrTimeout.request = request;
        xhrTimeout.subscriber = this;
        xhrTimeout.progressSubscriber = progressSubscriber;
        if (xhr.upload && "withCredentials" in xhr) {
            if (progressSubscriber) {
                var xhrProgress_1;
                xhrProgress_1 = function(e) {
                    var progressSubscriber = xhrProgress_1.progressSubscriber;
                    progressSubscriber.next(e);
                };
                if ($hGUNf.root.XDomainRequest) xhr.onprogress = xhrProgress_1;
                else xhr.upload.onprogress = xhrProgress_1;
                xhrProgress_1.progressSubscriber = progressSubscriber;
            }
            var xhrError_1;
            xhrError_1 = function(e) {
                var _a = xhrError_1, progressSubscriber = _a.progressSubscriber, subscriber = _a.subscriber, request = _a.request;
                if (progressSubscriber) progressSubscriber.error(e);
                subscriber.error(new $5ffb6f29843817c0$var$AjaxError("ajax error", this, request));
            };
            xhr.onerror = xhrError_1;
            xhrError_1.request = request;
            xhrError_1.subscriber = this;
            xhrError_1.progressSubscriber = progressSubscriber;
        }
        function xhrReadyStateChange(e) {
            var _a = xhrReadyStateChange, subscriber = _a.subscriber, progressSubscriber = _a.progressSubscriber, request = _a.request;
            if (this.readyState === 4) {
                // normalize IE9 bug (http://bugs.jquery.com/ticket/1450)
                var status_1 = this.status === 1223 ? 204 : this.status;
                var response = this.responseType === "text" ? this.response || this.responseText : this.response;
                // fix status code when it is 0 (0 status is undocumented).
                // Occurs when accessing file resources or on Android 4.1 stock browser
                // while retrieving files from application cache.
                if (status_1 === 0) status_1 = response ? 200 : 0;
                if (200 <= status_1 && status_1 < 300) {
                    if (progressSubscriber) progressSubscriber.complete();
                    subscriber.next(e);
                    subscriber.complete();
                } else {
                    if (progressSubscriber) progressSubscriber.error(e);
                    subscriber.error(new $5ffb6f29843817c0$var$AjaxError("ajax error " + status_1, this, request));
                }
            }
        }
        xhr.onreadystatechange = xhrReadyStateChange;
        xhrReadyStateChange.subscriber = this;
        xhrReadyStateChange.progressSubscriber = progressSubscriber;
        xhrReadyStateChange.request = request;
    };
    AjaxSubscriber.prototype.unsubscribe = function() {
        var _a = this, done = _a.done, xhr = _a.xhr;
        if (!done && xhr && xhr.readyState !== 4 && typeof xhr.abort === "function") xhr.abort();
        _super.prototype.unsubscribe.call(this);
    };
    return AjaxSubscriber;
}($gYcab.Subscriber);
module.exports.AjaxSubscriber = $5ffb6f29843817c0$var$AjaxSubscriber;
/**
 * A normalized AJAX response.
 *
 * @see {@link ajax}
 *
 * @class AjaxResponse
 */ var $5ffb6f29843817c0$var$AjaxResponse = function() {
    function AjaxResponse(originalEvent, xhr, request) {
        this.originalEvent = originalEvent;
        this.xhr = xhr;
        this.request = request;
        this.status = xhr.status;
        this.responseType = xhr.responseType || request.responseType;
        this.response = $5ffb6f29843817c0$var$parseXhrResponse(this.responseType, xhr);
    }
    return AjaxResponse;
}();
module.exports.AjaxResponse = $5ffb6f29843817c0$var$AjaxResponse;
/**
 * A normalized AJAX error.
 *
 * @see {@link ajax}
 *
 * @class AjaxError
 */ var $5ffb6f29843817c0$var$AjaxError = function(_super) {
    $5ffb6f29843817c0$var$__extends(AjaxError, _super);
    function AjaxError(message, xhr, request) {
        _super.call(this, message);
        this.message = message;
        this.xhr = xhr;
        this.request = request;
        this.status = xhr.status;
        this.responseType = xhr.responseType || request.responseType;
        this.response = $5ffb6f29843817c0$var$parseXhrResponse(this.responseType, xhr);
    }
    return AjaxError;
}(Error);
module.exports.AjaxError = $5ffb6f29843817c0$var$AjaxError;
function $5ffb6f29843817c0$var$parseXhrResponse(responseType, xhr) {
    switch(responseType){
        case "json":
            if ("response" in xhr) //IE does not support json as responseType, parse it internally
            return xhr.responseType ? xhr.response : JSON.parse(xhr.response || xhr.responseText || "null");
            else // HACK(benlesh): TypeScript shennanigans
            // tslint:disable-next-line:no-any latest TS seems to think xhr is "never" here.
            return JSON.parse(xhr.responseText || "null");
        case "xml":
            return xhr.responseXML;
        case "text":
        default:
            // HACK(benlesh): TypeScript shennanigans
            // tslint:disable-next-line:no-any latest TS seems to think xhr is "never" here.
            return "response" in xhr ? xhr.response : xhr.responseText;
    }
}
/**
 * @see {@link ajax}
 *
 * @class AjaxTimeoutError
 */ var $5ffb6f29843817c0$var$AjaxTimeoutError = function(_super) {
    $5ffb6f29843817c0$var$__extends(AjaxTimeoutError, _super);
    function AjaxTimeoutError(xhr, request) {
        _super.call(this, "ajax timeout", xhr, request);
    }
    return AjaxTimeoutError;
}($5ffb6f29843817c0$var$AjaxError);
module.exports.AjaxTimeoutError = $5ffb6f29843817c0$var$AjaxTimeoutError;

});



parcelRequire.register("lcmTO", function(module, exports) {
"use strict";

var $lyDVs = parcelRequire("lyDVs");

var $32bhV = parcelRequire("32bhV");
$lyDVs.Observable.empty = $32bhV.empty;

});
parcelRequire.register("32bhV", function(module, exports) {

$parcel$export(module.exports, "empty", () => $235a509992450dce$export$6e22c362a0406a2c, (v) => $235a509992450dce$export$6e22c362a0406a2c = v);
var $235a509992450dce$export$6e22c362a0406a2c;
"use strict";

var $3pasW = parcelRequire("3pasW");
$235a509992450dce$export$6e22c362a0406a2c = $3pasW.EmptyObservable.create;

});


parcelRequire.register("1G4dh", function(module, exports) {
"use strict";

var $lyDVs = parcelRequire("lyDVs");

var $lOtTh = parcelRequire("lOtTh");
$lyDVs.Observable.from = $lOtTh.from;

});
parcelRequire.register("lOtTh", function(module, exports) {

$parcel$export(module.exports, "from", () => $fe1574213d7194dd$export$6788812c4e6611e6, (v) => $fe1574213d7194dd$export$6788812c4e6611e6 = v);
var $fe1574213d7194dd$export$6788812c4e6611e6;
"use strict";

var $aUIHq = parcelRequire("aUIHq");
$fe1574213d7194dd$export$6788812c4e6611e6 = $aUIHq.FromObservable.create;

});
parcelRequire.register("aUIHq", function(module, exports) {
"use strict";
var $7f21ceb47bb363ec$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $6V6Ta = parcelRequire("6V6Ta");

var $lwvLm = parcelRequire("lwvLm");

var $lHMn8 = parcelRequire("lHMn8");

var $2ppRb = parcelRequire("2ppRb");

var $fCe3k = parcelRequire("fCe3k");

var $8y8sl = parcelRequire("8y8sl");

var $74pD5 = parcelRequire("74pD5");

var $iRyhk = parcelRequire("iRyhk");

var $lyDVs = parcelRequire("lyDVs");

var $5NCUI = parcelRequire("5NCUI");

var $bhQVP = parcelRequire("bhQVP");
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */ var $7f21ceb47bb363ec$var$FromObservable = function(_super) {
    $7f21ceb47bb363ec$var$__extends(FromObservable, _super);
    function FromObservable(ish, scheduler) {
        _super.call(this, null);
        this.ish = ish;
        this.scheduler = scheduler;
    }
    /**
     * Creates an Observable from an Array, an array-like object, a Promise, an
     * iterable object, or an Observable-like object.
     *
     * <span class="informal">Converts almost anything to an Observable.</span>
     *
     * <img src="./img/from.png" width="100%">
     *
     * Convert various other objects and data types into Observables. `from`
     * converts a Promise or an array-like or an
     * [iterable](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Iteration_protocols#iterable)
     * object into an Observable that emits the items in that promise or array or
     * iterable. A String, in this context, is treated as an array of characters.
     * Observable-like objects (contains a function named with the ES2015 Symbol
     * for Observable) can also be converted through this operator.
     *
     * @example <caption>Converts an array to an Observable</caption>
     * var array = [10, 20, 30];
     * var result = Rx.Observable.from(array);
     * result.subscribe(x => console.log(x));
     *
     * // Results in the following:
     * // 10 20 30
     *
     * @example <caption>Convert an infinite iterable (from a generator) to an Observable</caption>
     * function* generateDoubles(seed) {
     *   var i = seed;
     *   while (true) {
     *     yield i;
     *     i = 2 * i; // double it
     *   }
     * }
     *
     * var iterator = generateDoubles(3);
     * var result = Rx.Observable.from(iterator).take(10);
     * result.subscribe(x => console.log(x));
     *
     * // Results in the following:
     * // 3 6 12 24 48 96 192 384 768 1536
     *
     * @see {@link create}
     * @see {@link fromEvent}
     * @see {@link fromEventPattern}
     * @see {@link fromPromise}
     *
     * @param {ObservableInput<T>} ish A subscribable object, a Promise, an
     * Observable-like, an Array, an iterable or an array-like object to be
     * converted.
     * @param {Scheduler} [scheduler] The scheduler on which to schedule the
     * emissions of values.
     * @return {Observable<T>} The Observable whose values are originally from the
     * input object that was converted.
     * @static true
     * @name from
     * @owner Observable
     */ FromObservable.create = function(ish, scheduler) {
        if (ish != null) {
            if (typeof ish[$bhQVP.observable] === "function") {
                if (ish instanceof $lyDVs.Observable && !scheduler) return ish;
                return new FromObservable(ish, scheduler);
            } else if ($6V6Ta.isArray(ish)) return new $8y8sl.ArrayObservable(ish, scheduler);
            else if ($lHMn8.isPromise(ish)) return new $2ppRb.PromiseObservable(ish, scheduler);
            else if (typeof ish[$iRyhk.iterator] === "function" || typeof ish === "string") return new $fCe3k.IteratorObservable(ish, scheduler);
            else if ($lwvLm.isArrayLike(ish)) return new $74pD5.ArrayLikeObservable(ish, scheduler);
        }
        throw new TypeError((ish !== null && typeof ish || ish) + " is not observable");
    };
    /** @deprecated internal use only */ FromObservable.prototype._subscribe = function(subscriber) {
        var ish = this.ish;
        var scheduler = this.scheduler;
        if (scheduler == null) return ish[$bhQVP.observable]().subscribe(subscriber);
        else return ish[$bhQVP.observable]().subscribe(new $5NCUI.ObserveOnSubscriber(subscriber, scheduler, 0));
    };
    return FromObservable;
}($lyDVs.Observable);
module.exports.FromObservable = $7f21ceb47bb363ec$var$FromObservable;

});
parcelRequire.register("2ppRb", function(module, exports) {
"use strict";
var $1c11f92db0c6ce45$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $hGUNf = parcelRequire("hGUNf");

var $lyDVs = parcelRequire("lyDVs");
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */ var $1c11f92db0c6ce45$var$PromiseObservable = function(_super) {
    $1c11f92db0c6ce45$var$__extends(PromiseObservable, _super);
    function PromiseObservable(promise, scheduler) {
        _super.call(this);
        this.promise = promise;
        this.scheduler = scheduler;
    }
    /**
     * Converts a Promise to an Observable.
     *
     * <span class="informal">Returns an Observable that just emits the Promise's
     * resolved value, then completes.</span>
     *
     * Converts an ES2015 Promise or a Promises/A+ spec compliant Promise to an
     * Observable. If the Promise resolves with a value, the output Observable
     * emits that resolved value as a `next`, and then completes. If the Promise
     * is rejected, then the output Observable emits the corresponding Error.
     *
     * @example <caption>Convert the Promise returned by Fetch to an Observable</caption>
     * var result = Rx.Observable.fromPromise(fetch('http://myserver.com/'));
     * result.subscribe(x => console.log(x), e => console.error(e));
     *
     * @see {@link bindCallback}
     * @see {@link from}
     *
     * @param {PromiseLike<T>} promise The promise to be converted.
     * @param {Scheduler} [scheduler] An optional IScheduler to use for scheduling
     * the delivery of the resolved value (or the rejection).
     * @return {Observable<T>} An Observable which wraps the Promise.
     * @static true
     * @name fromPromise
     * @owner Observable
     */ PromiseObservable.create = function(promise, scheduler) {
        return new PromiseObservable(promise, scheduler);
    };
    /** @deprecated internal use only */ PromiseObservable.prototype._subscribe = function(subscriber) {
        var _this = this;
        var promise = this.promise;
        var scheduler = this.scheduler;
        if (scheduler == null) {
            if (this._isScalar) {
                if (!subscriber.closed) {
                    subscriber.next(this.value);
                    subscriber.complete();
                }
            } else promise.then(function(value) {
                _this.value = value;
                _this._isScalar = true;
                if (!subscriber.closed) {
                    subscriber.next(value);
                    subscriber.complete();
                }
            }, function(err) {
                if (!subscriber.closed) subscriber.error(err);
            }).then(null, function(err) {
                // escape the promise trap, throw unhandled errors
                $hGUNf.root.setTimeout(function() {
                    throw err;
                });
            });
        } else if (this._isScalar) {
            if (!subscriber.closed) return scheduler.schedule($1c11f92db0c6ce45$var$dispatchNext, 0, {
                value: this.value,
                subscriber: subscriber
            });
        } else promise.then(function(value) {
            _this.value = value;
            _this._isScalar = true;
            if (!subscriber.closed) subscriber.add(scheduler.schedule($1c11f92db0c6ce45$var$dispatchNext, 0, {
                value: value,
                subscriber: subscriber
            }));
        }, function(err) {
            if (!subscriber.closed) subscriber.add(scheduler.schedule($1c11f92db0c6ce45$var$dispatchError, 0, {
                err: err,
                subscriber: subscriber
            }));
        }).then(null, function(err) {
            // escape the promise trap, throw unhandled errors
            $hGUNf.root.setTimeout(function() {
                throw err;
            });
        });
    };
    return PromiseObservable;
}($lyDVs.Observable);
module.exports.PromiseObservable = $1c11f92db0c6ce45$var$PromiseObservable;
function $1c11f92db0c6ce45$var$dispatchNext(arg) {
    var value = arg.value, subscriber = arg.subscriber;
    if (!subscriber.closed) {
        subscriber.next(value);
        subscriber.complete();
    }
}
function $1c11f92db0c6ce45$var$dispatchError(arg) {
    var err = arg.err, subscriber = arg.subscriber;
    if (!subscriber.closed) subscriber.error(err);
}

});

parcelRequire.register("fCe3k", function(module, exports) {
"use strict";
var $b5e54e357c5b6d60$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $hGUNf = parcelRequire("hGUNf");

var $lyDVs = parcelRequire("lyDVs");

var $iRyhk = parcelRequire("iRyhk");
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */ var $b5e54e357c5b6d60$var$IteratorObservable = function(_super) {
    $b5e54e357c5b6d60$var$__extends(IteratorObservable, _super);
    function IteratorObservable(iterator, scheduler) {
        _super.call(this);
        this.scheduler = scheduler;
        if (iterator == null) throw new Error("iterator cannot be null.");
        this.iterator = $b5e54e357c5b6d60$var$getIterator(iterator);
    }
    IteratorObservable.create = function(iterator, scheduler) {
        return new IteratorObservable(iterator, scheduler);
    };
    IteratorObservable.dispatch = function(state) {
        var index = state.index, hasError = state.hasError, iterator = state.iterator, subscriber = state.subscriber;
        if (hasError) {
            subscriber.error(state.error);
            return;
        }
        var result = iterator.next();
        if (result.done) {
            subscriber.complete();
            return;
        }
        subscriber.next(result.value);
        state.index = index + 1;
        if (subscriber.closed) {
            if (typeof iterator.return === "function") iterator.return();
            return;
        }
        this.schedule(state);
    };
    /** @deprecated internal use only */ IteratorObservable.prototype._subscribe = function(subscriber) {
        var index = 0;
        var _a = this, iterator = _a.iterator, scheduler = _a.scheduler;
        if (scheduler) return scheduler.schedule(IteratorObservable.dispatch, 0, {
            index: index,
            iterator: iterator,
            subscriber: subscriber
        });
        else do {
            var result = iterator.next();
            if (result.done) {
                subscriber.complete();
                break;
            } else subscriber.next(result.value);
            if (subscriber.closed) {
                if (typeof iterator.return === "function") iterator.return();
                break;
            }
        }while (true);
    };
    return IteratorObservable;
}($lyDVs.Observable);
module.exports.IteratorObservable = $b5e54e357c5b6d60$var$IteratorObservable;
var $b5e54e357c5b6d60$var$StringIterator = function() {
    function StringIterator(str, idx, len) {
        if (idx === void 0) idx = 0;
        if (len === void 0) len = str.length;
        this.str = str;
        this.idx = idx;
        this.len = len;
    }
    StringIterator.prototype[$iRyhk.iterator] = function() {
        return this;
    };
    StringIterator.prototype.next = function() {
        return this.idx < this.len ? {
            done: false,
            value: this.str.charAt(this.idx++)
        } : {
            done: true,
            value: undefined
        };
    };
    return StringIterator;
}();
var $b5e54e357c5b6d60$var$ArrayIterator = function() {
    function ArrayIterator(arr, idx, len) {
        if (idx === void 0) idx = 0;
        if (len === void 0) len = $b5e54e357c5b6d60$var$toLength(arr);
        this.arr = arr;
        this.idx = idx;
        this.len = len;
    }
    ArrayIterator.prototype[$iRyhk.iterator] = function() {
        return this;
    };
    ArrayIterator.prototype.next = function() {
        return this.idx < this.len ? {
            done: false,
            value: this.arr[this.idx++]
        } : {
            done: true,
            value: undefined
        };
    };
    return ArrayIterator;
}();
function $b5e54e357c5b6d60$var$getIterator(obj) {
    var i = obj[$iRyhk.iterator];
    if (!i && typeof obj === "string") return new $b5e54e357c5b6d60$var$StringIterator(obj);
    if (!i && obj.length !== undefined) return new $b5e54e357c5b6d60$var$ArrayIterator(obj);
    if (!i) throw new TypeError("object is not iterable");
    return obj[$iRyhk.iterator]();
}
var $b5e54e357c5b6d60$var$maxSafeInteger = Math.pow(2, 53) - 1;
function $b5e54e357c5b6d60$var$toLength(o) {
    var len = +o.length;
    if (isNaN(len)) return 0;
    if (len === 0 || !$b5e54e357c5b6d60$var$numberIsFinite(len)) return len;
    len = $b5e54e357c5b6d60$var$sign(len) * Math.floor(Math.abs(len));
    if (len <= 0) return 0;
    if (len > $b5e54e357c5b6d60$var$maxSafeInteger) return $b5e54e357c5b6d60$var$maxSafeInteger;
    return len;
}
function $b5e54e357c5b6d60$var$numberIsFinite(value) {
    return typeof value === "number" && $hGUNf.root.isFinite(value);
}
function $b5e54e357c5b6d60$var$sign(value) {
    var valueAsNumber = +value;
    if (valueAsNumber === 0) return valueAsNumber;
    if (isNaN(valueAsNumber)) return valueAsNumber;
    return valueAsNumber < 0 ? -1 : 1;
}

});

parcelRequire.register("74pD5", function(module, exports) {
"use strict";
var $525cc999142bf197$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $lyDVs = parcelRequire("lyDVs");

var $5elaO = parcelRequire("5elaO");

var $3pasW = parcelRequire("3pasW");
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */ var $525cc999142bf197$var$ArrayLikeObservable = function(_super) {
    $525cc999142bf197$var$__extends(ArrayLikeObservable, _super);
    function ArrayLikeObservable(arrayLike, scheduler) {
        _super.call(this);
        this.arrayLike = arrayLike;
        this.scheduler = scheduler;
        if (!scheduler && arrayLike.length === 1) {
            this._isScalar = true;
            this.value = arrayLike[0];
        }
    }
    ArrayLikeObservable.create = function(arrayLike, scheduler) {
        var length = arrayLike.length;
        if (length === 0) return new $3pasW.EmptyObservable();
        else if (length === 1) return new $5elaO.ScalarObservable(arrayLike[0], scheduler);
        else return new ArrayLikeObservable(arrayLike, scheduler);
    };
    ArrayLikeObservable.dispatch = function(state) {
        var arrayLike = state.arrayLike, index = state.index, length = state.length, subscriber = state.subscriber;
        if (subscriber.closed) return;
        if (index >= length) {
            subscriber.complete();
            return;
        }
        subscriber.next(arrayLike[index]);
        state.index = index + 1;
        this.schedule(state);
    };
    /** @deprecated internal use only */ ArrayLikeObservable.prototype._subscribe = function(subscriber) {
        var index = 0;
        var _a = this, arrayLike = _a.arrayLike, scheduler = _a.scheduler;
        var length = arrayLike.length;
        if (scheduler) return scheduler.schedule(ArrayLikeObservable.dispatch, 0, {
            arrayLike: arrayLike,
            index: index,
            length: length,
            subscriber: subscriber
        });
        else {
            for(var i = 0; i < length && !subscriber.closed; i++)subscriber.next(arrayLike[i]);
            subscriber.complete();
        }
    };
    return ArrayLikeObservable;
}($lyDVs.Observable);
module.exports.ArrayLikeObservable = $525cc999142bf197$var$ArrayLikeObservable;

});

parcelRequire.register("5NCUI", function(module, exports) {
"use strict";
var $438fb6ce1a78b7fd$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $gYcab = parcelRequire("gYcab");

var $fKTkY = parcelRequire("fKTkY");
/**
 *
 * Re-emits all notifications from source Observable with specified scheduler.
 *
 * <span class="informal">Ensure a specific scheduler is used, from outside of an Observable.</span>
 *
 * `observeOn` is an operator that accepts a scheduler as a first parameter, which will be used to reschedule
 * notifications emitted by the source Observable. It might be useful, if you do not have control over
 * internal scheduler of a given Observable, but want to control when its values are emitted nevertheless.
 *
 * Returned Observable emits the same notifications (nexted values, complete and error events) as the source Observable,
 * but rescheduled with provided scheduler. Note that this doesn't mean that source Observables internal
 * scheduler will be replaced in any way. Original scheduler still will be used, but when the source Observable emits
 * notification, it will be immediately scheduled again - this time with scheduler passed to `observeOn`.
 * An anti-pattern would be calling `observeOn` on Observable that emits lots of values synchronously, to split
 * that emissions into asynchronous chunks. For this to happen, scheduler would have to be passed into the source
 * Observable directly (usually into the operator that creates it). `observeOn` simply delays notifications a
 * little bit more, to ensure that they are emitted at expected moments.
 *
 * As a matter of fact, `observeOn` accepts second parameter, which specifies in milliseconds with what delay notifications
 * will be emitted. The main difference between {@link delay} operator and `observeOn` is that `observeOn`
 * will delay all notifications - including error notifications - while `delay` will pass through error
 * from source Observable immediately when it is emitted. In general it is highly recommended to use `delay` operator
 * for any kind of delaying of values in the stream, while using `observeOn` to specify which scheduler should be used
 * for notification emissions in general.
 *
 * @example <caption>Ensure values in subscribe are called just before browser repaint.</caption>
 * const intervals = Rx.Observable.interval(10); // Intervals are scheduled
 *                                               // with async scheduler by default...
 *
 * intervals
 * .observeOn(Rx.Scheduler.animationFrame)       // ...but we will observe on animationFrame
 * .subscribe(val => {                           // scheduler to ensure smooth animation.
 *   someDiv.style.height = val + 'px';
 * });
 *
 * @see {@link delay}
 *
 * @param {IScheduler} scheduler Scheduler that will be used to reschedule notifications from source Observable.
 * @param {number} [delay] Number of milliseconds that states with what delay every notification should be rescheduled.
 * @return {Observable<T>} Observable that emits the same notifications as the source Observable,
 * but with provided scheduler.
 *
 * @method observeOn
 * @owner Observable
 */ function $438fb6ce1a78b7fd$var$observeOn(scheduler, delay) {
    if (delay === void 0) delay = 0;
    return function observeOnOperatorFunction(source) {
        return source.lift(new $438fb6ce1a78b7fd$var$ObserveOnOperator(scheduler, delay));
    };
}
module.exports.observeOn = $438fb6ce1a78b7fd$var$observeOn;
var $438fb6ce1a78b7fd$var$ObserveOnOperator = function() {
    function ObserveOnOperator(scheduler, delay) {
        if (delay === void 0) delay = 0;
        this.scheduler = scheduler;
        this.delay = delay;
    }
    ObserveOnOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $438fb6ce1a78b7fd$var$ObserveOnSubscriber(subscriber, this.scheduler, this.delay));
    };
    return ObserveOnOperator;
}();
module.exports.ObserveOnOperator = $438fb6ce1a78b7fd$var$ObserveOnOperator;
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $438fb6ce1a78b7fd$var$ObserveOnSubscriber = function(_super) {
    $438fb6ce1a78b7fd$var$__extends(ObserveOnSubscriber, _super);
    function ObserveOnSubscriber(destination, scheduler, delay) {
        if (delay === void 0) delay = 0;
        _super.call(this, destination);
        this.scheduler = scheduler;
        this.delay = delay;
    }
    ObserveOnSubscriber.dispatch = function(arg) {
        var notification = arg.notification, destination = arg.destination;
        notification.observe(destination);
        this.unsubscribe();
    };
    ObserveOnSubscriber.prototype.scheduleMessage = function(notification) {
        this.add(this.scheduler.schedule(ObserveOnSubscriber.dispatch, this.delay, new $438fb6ce1a78b7fd$var$ObserveOnMessage(notification, this.destination)));
    };
    ObserveOnSubscriber.prototype._next = function(value) {
        this.scheduleMessage($fKTkY.Notification.createNext(value));
    };
    ObserveOnSubscriber.prototype._error = function(err) {
        this.scheduleMessage($fKTkY.Notification.createError(err));
    };
    ObserveOnSubscriber.prototype._complete = function() {
        this.scheduleMessage($fKTkY.Notification.createComplete());
    };
    return ObserveOnSubscriber;
}($gYcab.Subscriber);
module.exports.ObserveOnSubscriber = $438fb6ce1a78b7fd$var$ObserveOnSubscriber;
var $438fb6ce1a78b7fd$var$ObserveOnMessage = function() {
    function ObserveOnMessage(notification, destination) {
        this.notification = notification;
        this.destination = destination;
    }
    return ObserveOnMessage;
}();
module.exports.ObserveOnMessage = $438fb6ce1a78b7fd$var$ObserveOnMessage;

});




parcelRequire.register("2Bgfi", function(module, exports) {
"use strict";

var $lyDVs = parcelRequire("lyDVs");

var $kTOhx = parcelRequire("kTOhx");
$lyDVs.Observable.interval = $kTOhx.interval;

});
parcelRequire.register("kTOhx", function(module, exports) {

$parcel$export(module.exports, "interval", () => $f36ff29f19414e38$export$3174cdbf0a0cbc84, (v) => $f36ff29f19414e38$export$3174cdbf0a0cbc84 = v);
var $f36ff29f19414e38$export$3174cdbf0a0cbc84;
"use strict";

var $aVlav = parcelRequire("aVlav");
$f36ff29f19414e38$export$3174cdbf0a0cbc84 = $aVlav.IntervalObservable.create;

});
parcelRequire.register("aVlav", function(module, exports) {
"use strict";
var $7f3fa5e497410c3b$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $3afTg = parcelRequire("3afTg");

var $lyDVs = parcelRequire("lyDVs");

var $lvV06 = parcelRequire("lvV06");
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */ var $7f3fa5e497410c3b$var$IntervalObservable = function(_super) {
    $7f3fa5e497410c3b$var$__extends(IntervalObservable, _super);
    function IntervalObservable(period, scheduler) {
        if (period === void 0) period = 0;
        if (scheduler === void 0) scheduler = $lvV06.async;
        _super.call(this);
        this.period = period;
        this.scheduler = scheduler;
        if (!$3afTg.isNumeric(period) || period < 0) this.period = 0;
        if (!scheduler || typeof scheduler.schedule !== "function") this.scheduler = $lvV06.async;
    }
    /**
     * Creates an Observable that emits sequential numbers every specified
     * interval of time, on a specified IScheduler.
     *
     * <span class="informal">Emits incremental numbers periodically in time.
     * </span>
     *
     * <img src="./img/interval.png" width="100%">
     *
     * `interval` returns an Observable that emits an infinite sequence of
     * ascending integers, with a constant interval of time of your choosing
     * between those emissions. The first emission is not sent immediately, but
     * only after the first period has passed. By default, this operator uses the
     * `async` IScheduler to provide a notion of time, but you may pass any
     * IScheduler to it.
     *
     * @example <caption>Emits ascending numbers, one every second (1000ms)</caption>
     * var numbers = Rx.Observable.interval(1000);
     * numbers.subscribe(x => console.log(x));
     *
     * @see {@link timer}
     * @see {@link delay}
     *
     * @param {number} [period=0] The interval size in milliseconds (by default)
     * or the time unit determined by the scheduler's clock.
     * @param {Scheduler} [scheduler=async] The IScheduler to use for scheduling
     * the emission of values, and providing a notion of "time".
     * @return {Observable} An Observable that emits a sequential number each time
     * interval.
     * @static true
     * @name interval
     * @owner Observable
     */ IntervalObservable.create = function(period, scheduler) {
        if (period === void 0) period = 0;
        if (scheduler === void 0) scheduler = $lvV06.async;
        return new IntervalObservable(period, scheduler);
    };
    IntervalObservable.dispatch = function(state) {
        var index = state.index, subscriber = state.subscriber, period = state.period;
        subscriber.next(index);
        if (subscriber.closed) return;
        state.index += 1;
        this.schedule(state, period);
    };
    /** @deprecated internal use only */ IntervalObservable.prototype._subscribe = function(subscriber) {
        var index = 0;
        var period = this.period;
        var scheduler = this.scheduler;
        subscriber.add(scheduler.schedule(IntervalObservable.dispatch, period, {
            index: index,
            subscriber: subscriber,
            period: period
        }));
    };
    return IntervalObservable;
}($lyDVs.Observable);
module.exports.IntervalObservable = $7f3fa5e497410c3b$var$IntervalObservable;

});
parcelRequire.register("3afTg", function(module, exports) {

$parcel$export(module.exports, "isNumeric", () => $24dea1c4cd7686a8$export$e90fb89750dba83f, (v) => $24dea1c4cd7686a8$export$e90fb89750dba83f = v);
var $24dea1c4cd7686a8$export$e90fb89750dba83f;
"use strict";

var $6V6Ta = parcelRequire("6V6Ta");
function $24dea1c4cd7686a8$var$isNumeric(val) {
    // parseFloat NaNs numeric-cast false positives (null|true|false|"")
    // ...but misinterprets leading-number strings, particularly hex literals ("0x...")
    // subtraction forces infinities to NaN
    // adding 1 corrects loss of precision from parseFloat (#15100)
    return !$6V6Ta.isArray(val) && val - parseFloat(val) + 1 >= 0;
}
$24dea1c4cd7686a8$export$e90fb89750dba83f = $24dea1c4cd7686a8$var$isNumeric;

});




parcelRequire.register("gqkbp", function(module, exports) {
"use strict";

var $lyDVs = parcelRequire("lyDVs");

var $9xbuJ = parcelRequire("9xbuJ");
$lyDVs.Observable.of = $9xbuJ.of;

});
parcelRequire.register("9xbuJ", function(module, exports) {

$parcel$export(module.exports, "of", () => $6f101cbb22810523$export$ba255e9e49e00608, (v) => $6f101cbb22810523$export$ba255e9e49e00608 = v);
var $6f101cbb22810523$export$ba255e9e49e00608;
"use strict";

var $8y8sl = parcelRequire("8y8sl");
$6f101cbb22810523$export$ba255e9e49e00608 = $8y8sl.ArrayObservable.of;

});


parcelRequire.register("919fR", function(module, exports) {
"use strict";

var $lyDVs = parcelRequire("lyDVs");

var $5UbTi = parcelRequire("5UbTi");
$lyDVs.Observable.throw = $5UbTi._throw;

});
parcelRequire.register("5UbTi", function(module, exports) {

$parcel$export(module.exports, "_throw", () => $44cb67fe1e6a9070$export$82a8af9b11518516, (v) => $44cb67fe1e6a9070$export$82a8af9b11518516 = v);
var $44cb67fe1e6a9070$export$82a8af9b11518516;
"use strict";

var $gHbKW = parcelRequire("gHbKW");
$44cb67fe1e6a9070$export$82a8af9b11518516 = $gHbKW.ErrorObservable.create;

});
parcelRequire.register("gHbKW", function(module, exports) {
"use strict";
var $c279c80009275acc$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $lyDVs = parcelRequire("lyDVs");
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */ var $c279c80009275acc$var$ErrorObservable = function(_super) {
    $c279c80009275acc$var$__extends(ErrorObservable, _super);
    function ErrorObservable(error, scheduler) {
        _super.call(this);
        this.error = error;
        this.scheduler = scheduler;
    }
    /**
     * Creates an Observable that emits no items to the Observer and immediately
     * emits an error notification.
     *
     * <span class="informal">Just emits 'error', and nothing else.
     * </span>
     *
     * <img src="./img/throw.png" width="100%">
     *
     * This static operator is useful for creating a simple Observable that only
     * emits the error notification. It can be used for composing with other
     * Observables, such as in a {@link mergeMap}.
     *
     * @example <caption>Emit the number 7, then emit an error.</caption>
     * var result = Rx.Observable.throw(new Error('oops!')).startWith(7);
     * result.subscribe(x => console.log(x), e => console.error(e));
     *
     * @example <caption>Map and flatten numbers to the sequence 'a', 'b', 'c', but throw an error for 13</caption>
     * var interval = Rx.Observable.interval(1000);
     * var result = interval.mergeMap(x =>
     *   x === 13 ?
     *     Rx.Observable.throw('Thirteens are bad') :
     *     Rx.Observable.of('a', 'b', 'c')
     * );
     * result.subscribe(x => console.log(x), e => console.error(e));
     *
     * @see {@link create}
     * @see {@link empty}
     * @see {@link never}
     * @see {@link of}
     *
     * @param {any} error The particular Error to pass to the error notification.
     * @param {Scheduler} [scheduler] A {@link IScheduler} to use for scheduling
     * the emission of the error notification.
     * @return {Observable} An error Observable: emits only the error notification
     * using the given error argument.
     * @static true
     * @name throw
     * @owner Observable
     */ ErrorObservable.create = function(error, scheduler) {
        return new ErrorObservable(error, scheduler);
    };
    ErrorObservable.dispatch = function(arg) {
        var error = arg.error, subscriber = arg.subscriber;
        subscriber.error(error);
    };
    /** @deprecated internal use only */ ErrorObservable.prototype._subscribe = function(subscriber) {
        var error = this.error;
        var scheduler = this.scheduler;
        subscriber.syncErrorThrowable = true;
        if (scheduler) return scheduler.schedule(ErrorObservable.dispatch, 0, {
            error: error,
            subscriber: subscriber
        });
        else subscriber.error(error);
    };
    return ErrorObservable;
}($lyDVs.Observable);
module.exports.ErrorObservable = $c279c80009275acc$var$ErrorObservable;

});



parcelRequire.register("kGlFT", function(module, exports) {
"use strict";

var $aJHrF = parcelRequire("aJHrF");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = $f0e88b0c027ca14f$var$dedupeFilenames;

var $f0e88b0c027ca14f$var$_parseFilename2 = $aJHrF((parcelRequire("gNTDJ")));
function $f0e88b0c027ca14f$var$dedupeFilenames(array) {
    var nextArray = [];
    array.forEach(function(value) {
        var _parseFilename = (0, $f0e88b0c027ca14f$var$_parseFilename2["default"])(value), extname = _parseFilename.extname, name = _parseFilename.name;
        var count = 0;
        var nextValue = value;
        while(nextArray.includes(nextValue))nextValue = [
            name,
            "(".concat(++count, ")")
        ].filter(function(segment) {
            return segment;
        }).join(" ") + extname;
        nextArray.push(nextValue);
    });
    return nextArray;
}

});
parcelRequire.register("gNTDJ", function(module, exports) {
"use strict";

var $aJHrF = parcelRequire("aJHrF");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = $c3bc61dbaa908bf8$var$parseFilename;

var $c3bc61dbaa908bf8$var$_toArray2 = $aJHrF((parcelRequire("l4zrn")));
function $c3bc61dbaa908bf8$var$parseFilename(filename) {
    if (!filename) return {
        extname: "",
        name: ""
    };
    else if (~filename.indexOf(".")) {
        var _filename$split$rever = filename.split(".").reverse(), _filename$split$rever2 = (0, $c3bc61dbaa908bf8$var$_toArray2["default"])(_filename$split$rever), extensionWithoutDot = _filename$split$rever2[0], nameSegments = _filename$split$rever2.slice(1);
        return {
            extname: "." + extensionWithoutDot,
            name: nameSegments.reverse().join(".")
        };
    } else return {
        extname: "",
        name: filename
    };
}

});
parcelRequire.register("l4zrn", function(module, exports) {

var $5TnyL = parcelRequire("5TnyL");

var $glEHk = parcelRequire("glEHk");

var $039bf = parcelRequire("039bf");

var $f5qwy = parcelRequire("f5qwy");
function $f57576706660eeb9$var$_toArray(arr) {
    return $5TnyL(arr) || $glEHk(arr) || $039bf(arr) || $f5qwy();
}
module.exports = $f57576706660eeb9$var$_toArray;
module.exports["default"] = module.exports, module.exports.__esModule = true;

});
parcelRequire.register("5TnyL", function(module, exports) {
function $44a45d3f37a285f2$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
module.exports = $44a45d3f37a285f2$var$_arrayWithHoles;
module.exports["default"] = module.exports, module.exports.__esModule = true;

});

parcelRequire.register("glEHk", function(module, exports) {
function $be6e2d3cd9077138$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
module.exports = $be6e2d3cd9077138$var$_iterableToArray;
module.exports["default"] = module.exports, module.exports.__esModule = true;

});

parcelRequire.register("039bf", function(module, exports) {

var $9NpzT = parcelRequire("9NpzT");
function $009766f4d564795b$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $9NpzT(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $9NpzT(o, minLen);
}
module.exports = $009766f4d564795b$var$_unsupportedIterableToArray;
module.exports["default"] = module.exports, module.exports.__esModule = true;

});
parcelRequire.register("9NpzT", function(module, exports) {
function $721c87e919f1ed1d$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
module.exports = $721c87e919f1ed1d$var$_arrayLikeToArray;
module.exports["default"] = module.exports, module.exports.__esModule = true;

});


parcelRequire.register("f5qwy", function(module, exports) {
function $afbbe5c731de618b$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
module.exports = $afbbe5c731de618b$var$_nonIterableRest;
module.exports["default"] = module.exports, module.exports.__esModule = true;

});




parcelRequire.register("7QzhE", function(module, exports) {
"use strict";

var $aJHrF = parcelRequire("aJHrF");

var $9FqFu = parcelRequire("9FqFu");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DirectLineStreaming = void 0;

var $5b68c2555dfc6fc0$var$_objectWithoutProperties2 = $aJHrF((parcelRequire("605Ce")));

var $5b68c2555dfc6fc0$var$_regenerator = $aJHrF((parcelRequire("ifEAF")));

var $5b68c2555dfc6fc0$var$_toConsumableArray2 = $aJHrF((parcelRequire("gE7KV")));

var $5b68c2555dfc6fc0$var$_asyncToGenerator2 = $aJHrF((parcelRequire("gpGGk")));

var $5b68c2555dfc6fc0$var$_classCallCheck2 = $aJHrF((parcelRequire("hBL3H")));

var $5b68c2555dfc6fc0$var$_createClass2 = $aJHrF((parcelRequire("3As53")));

var $5b68c2555dfc6fc0$var$_defineProperty2 = $aJHrF((parcelRequire("eiPwg")));

var $5PS69 = parcelRequire("5PS69");

var $89iLh = parcelRequire("89iLh");

var $lyDVs = parcelRequire("lyDVs");

var $5b68c2555dfc6fc0$var$BFSE = $5b68c2555dfc6fc0$var$_interopRequireWildcard((parcelRequire("ip1K7")));

var $5b68c2555dfc6fc0$var$_createDeferred = $aJHrF((parcelRequire("hKphp")));

var $5b68c2555dfc6fc0$var$_crossFetch = $aJHrF((parcelRequire("9WGwn")));

var $kT3Qz = parcelRequire("kT3Qz");
var $5b68c2555dfc6fc0$var$_excluded = [
    "attachments"
];
function $5b68c2555dfc6fc0$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($5b68c2555dfc6fc0$var$_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $5b68c2555dfc6fc0$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || $9FqFu(obj) !== "object" && typeof obj !== "function") return {
        "default": obj
    };
    var cache = $5b68c2555dfc6fc0$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj["default"] = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
var $5b68c2555dfc6fc0$var$DIRECT_LINE_VERSION = "DirectLine/3.0";
var $5b68c2555dfc6fc0$var$MAX_RETRY_COUNT = 3;
var $5b68c2555dfc6fc0$var$refreshTokenLifetime = 1800000; //const refreshTokenLifetime = 5000;
var $5b68c2555dfc6fc0$var$timeout = 20000;
var $5b68c2555dfc6fc0$var$refreshTokenInterval = $5b68c2555dfc6fc0$var$refreshTokenLifetime / 2;
var $5b68c2555dfc6fc0$var$StreamHandler = /*#__PURE__*/ function() {
    function StreamHandler(s, c$, sq) {
        (0, $5b68c2555dfc6fc0$var$_classCallCheck2["default"])(this, StreamHandler);
        (0, $5b68c2555dfc6fc0$var$_defineProperty2["default"])(this, "activityQueue", []);
        this.subscriber = s;
        this.connectionStatus$ = c$;
        this.shouldQueue = sq;
    }
    (0, $5b68c2555dfc6fc0$var$_createClass2["default"])(StreamHandler, [
        {
            key: "setSubscriber",
            value: function setSubscriber(s) {
                this.subscriber = s;
            }
        },
        {
            key: "processRequest",
            value: function() {
                var _processRequest = (0, $5b68c2555dfc6fc0$var$_asyncToGenerator2["default"])(/*#__PURE__*/ $5b68c2555dfc6fc0$var$_regenerator["default"].mark(function _callee(request, logger) {
                    var streams, stream0, activitySetJson, activitySet, activity, attachments, stream, attachment, dataUri;
                    return $5b68c2555dfc6fc0$var$_regenerator["default"].wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                streams = (0, $5b68c2555dfc6fc0$var$_toConsumableArray2["default"])(request.streams);
                                stream0 = streams.shift();
                                _context.next = 4;
                                return stream0.readAsString();
                            case 4:
                                activitySetJson = _context.sent;
                                activitySet = JSON.parse(activitySetJson);
                                if (!(activitySet.activities.length !== 1)) {
                                    _context.next = 9;
                                    break;
                                }
                                // Only one activity is expected in a set in streaming
                                this.subscriber.error(new Error("there should be exactly one activity"));
                                return _context.abrupt("return", $5b68c2555dfc6fc0$var$BFSE.StreamingResponse.create(500));
                            case 9:
                                activity = activitySet.activities[0];
                                if (!(streams.length > 0)) {
                                    _context.next = 21;
                                    break;
                                }
                                attachments = (0, $5b68c2555dfc6fc0$var$_toConsumableArray2["default"])(activity.attachments);
                            case 12:
                                if (!(stream = streams.shift())) {
                                    _context.next = 20;
                                    break;
                                }
                                _context.next = 15;
                                return stream.readAsString();
                            case 15:
                                attachment = _context.sent;
                                dataUri = "data:text/plain;base64," + attachment;
                                attachments.push({
                                    contentType: stream.contentType,
                                    contentUrl: dataUri
                                });
                                _context.next = 12;
                                break;
                            case 20:
                                activity.attachments = attachments;
                            case 21:
                                if (this.shouldQueue()) this.activityQueue.push(activity);
                                else this.subscriber.next(activity);
                                return _context.abrupt("return", $5b68c2555dfc6fc0$var$BFSE.StreamingResponse.create(200));
                            case 23:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this);
                }));
                function processRequest(_x, _x2) {
                    return _processRequest.apply(this, arguments);
                }
                return processRequest;
            }()
        },
        {
            key: "flush",
            value: function flush() {
                var _this = this;
                this.connectionStatus$.subscribe(function(cs) {});
                this.activityQueue.forEach(function(a) {
                    return _this.subscriber.next(a);
                });
                this.activityQueue = [];
            }
        },
        {
            key: "end",
            value: function end() {
                this.subscriber.complete();
            }
        }
    ]);
    return StreamHandler;
}();
var $5b68c2555dfc6fc0$var$DirectLineStreaming = /*#__PURE__*/ function() {
    function DirectLineStreaming(options) {
        var _this2 = this;
        (0, $5b68c2555dfc6fc0$var$_classCallCheck2["default"])(this, DirectLineStreaming);
        (0, $5b68c2555dfc6fc0$var$_defineProperty2["default"])(this, "connectionStatus$", new $5PS69.BehaviorSubject($kT3Qz.ConnectionStatus.Uninitialized));
        (0, $5b68c2555dfc6fc0$var$_defineProperty2["default"])(this, "_botAgent", "");
        this.token = options.token;
        this.refreshToken()["catch"](function() {
            _this2.connectionStatus$.next($kT3Qz.ConnectionStatus.ExpiredToken);
        });
        this.domain = options.domain;
        if (options.conversationId) this.conversationId = options.conversationId;
        this._botAgent = this.getBotAgent(options.botAgent);
        this.queueActivities = true;
        this.activity$ = $lyDVs.Observable.create(/*#__PURE__*/ function() {
            var _ref = (0, $5b68c2555dfc6fc0$var$_asyncToGenerator2["default"])(/*#__PURE__*/ $5b68c2555dfc6fc0$var$_regenerator["default"].mark(function _callee2(subscriber) {
                return $5b68c2555dfc6fc0$var$_regenerator["default"].wrap(function _callee2$(_context2) {
                    while(true)switch(_context2.prev = _context2.next){
                        case 0:
                            _this2.activitySubscriber = subscriber;
                            _this2.theStreamHandler = new $5b68c2555dfc6fc0$var$StreamHandler(subscriber, _this2.connectionStatus$, function() {
                                return _this2.queueActivities;
                            }); // Resolving connectDeferred will kick-off the connection.
                            _this2.connectDeferred.resolve();
                        case 3:
                        case "end":
                            return _context2.stop();
                    }
                }, _callee2);
            }));
            return function(_x3) {
                return _ref.apply(this, arguments);
            };
        }()).share(); // connectWithRetryAsync() will create the connectDeferred object required in activity$.
        this.connectWithRetryAsync();
    }
    (0, $5b68c2555dfc6fc0$var$_createClass2["default"])(DirectLineStreaming, [
        {
            key: "reconnect",
            value: function reconnect(_ref2) {
                var conversationId = _ref2.conversationId, token = _ref2.token;
                if (this.connectionStatus$.getValue() === $kT3Qz.ConnectionStatus.Ended) throw new Error("Connection has ended.");
                this.conversationId = conversationId;
                this.token = token;
                this.connectDeferred.resolve();
            }
        },
        {
            key: "end",
            value: function end() {
                // Once end() is called, no reconnection can be made.
                this.activitySubscriber.complete();
                this.connectionStatus$.next($kT3Qz.ConnectionStatus.Ended);
                this.connectionStatus$.complete();
                this.streamConnection.disconnect();
            }
        },
        {
            key: "commonHeaders",
            value: function commonHeaders() {
                return {
                    "Authorization": "Bearer ".concat(this.token),
                    "x-ms-bot-agent": this._botAgent
                };
            }
        },
        {
            key: "getBotAgent",
            value: function getBotAgent() {
                var customAgent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
                var clientAgent = "directlineStreaming";
                if (customAgent) clientAgent += "; ".concat(customAgent);
                return "".concat($5b68c2555dfc6fc0$var$DIRECT_LINE_VERSION, " (").concat(clientAgent, ")");
            }
        },
        {
            key: "refreshToken",
            value: function() {
                var _refreshToken = (0, $5b68c2555dfc6fc0$var$_asyncToGenerator2["default"])(/*#__PURE__*/ $5b68c2555dfc6fc0$var$_regenerator["default"].mark(function _callee3() {
                    var firstCall, retryCount, numberOfAttempts, res, _yield$res$json, token, _args3 = arguments;
                    return $5b68c2555dfc6fc0$var$_regenerator["default"].wrap(function _callee3$(_context3) {
                        while(true)switch(_context3.prev = _context3.next){
                            case 0:
                                firstCall = _args3.length > 0 && _args3[0] !== undefined ? _args3[0] : true;
                                retryCount = _args3.length > 1 && _args3[1] !== undefined ? _args3[1] : 0;
                                _context3.next = 4;
                                return this.waitUntilOnline();
                            case 4:
                                numberOfAttempts = 0;
                            case 5:
                                if (!(numberOfAttempts < $5b68c2555dfc6fc0$var$MAX_RETRY_COUNT)) {
                                    _context3.next = 30;
                                    break;
                                }
                                numberOfAttempts++;
                                _context3.next = 9;
                                return new Promise(function(r) {
                                    return setTimeout(r, $5b68c2555dfc6fc0$var$refreshTokenInterval);
                                });
                            case 9:
                                _context3.prev = 9;
                                _context3.next = 12;
                                return (0, $5b68c2555dfc6fc0$var$_crossFetch["default"])("".concat(this.domain, "/tokens/refresh"), {
                                    method: "POST",
                                    headers: this.commonHeaders()
                                });
                            case 12:
                                res = _context3.sent;
                                if (!res.ok) {
                                    _context3.next = 22;
                                    break;
                                }
                                numberOfAttempts = 0;
                                _context3.next = 17;
                                return res.json();
                            case 17:
                                _yield$res$json = _context3.sent;
                                token = _yield$res$json.token;
                                this.token = token;
                                _context3.next = 23;
                                break;
                            case 22:
                                if (res.status === 403 || res.status === 403) {
                                    console.error("Fatal error while refreshing the token: ".concat(res.status, " ").concat(res.statusText));
                                    this.streamConnection.disconnect();
                                } else console.warn("Refresh attempt #".concat(numberOfAttempts, " failed: ").concat(res.status, " ").concat(res.statusText));
                            case 23:
                                _context3.next = 28;
                                break;
                            case 25:
                                _context3.prev = 25;
                                _context3.t0 = _context3["catch"](9);
                                console.warn("Refresh attempt #".concat(numberOfAttempts, " threw an exception: ").concat(_context3.t0));
                            case 28:
                                _context3.next = 5;
                                break;
                            case 30:
                                console.error("Retries exhausted");
                                this.streamConnection.disconnect();
                            case 32:
                            case "end":
                                return _context3.stop();
                        }
                    }, _callee3, this, [
                        [
                            9,
                            25
                        ]
                    ]);
                }));
                function refreshToken() {
                    return _refreshToken.apply(this, arguments);
                }
                return refreshToken;
            }()
        },
        {
            key: "postActivity",
            value: function postActivity(activity) {
                var _this3 = this;
                if (this.connectionStatus$.value === $kT3Qz.ConnectionStatus.Ended || this.connectionStatus$.value === $kT3Qz.ConnectionStatus.FailedToConnect) return $lyDVs.Observable["throw"](new Error("Connection is closed"));
                if (activity.type === "message" && activity.attachments && activity.attachments.length > 0) return this.postMessageWithAttachments(activity);
                var resp$ = $lyDVs.Observable.create(/*#__PURE__*/ function() {
                    var _ref3 = (0, $5b68c2555dfc6fc0$var$_asyncToGenerator2["default"])(/*#__PURE__*/ $5b68c2555dfc6fc0$var$_regenerator["default"].mark(function _callee4(subscriber) {
                        var request, resp, numberOfStreams, idString, _JSON$parse, id;
                        return $5b68c2555dfc6fc0$var$_regenerator["default"].wrap(function _callee4$(_context4) {
                            while(true)switch(_context4.prev = _context4.next){
                                case 0:
                                    request = $5b68c2555dfc6fc0$var$BFSE.StreamingRequest.create("POST", "/v3/directline/conversations/" + _this3.conversationId + "/activities");
                                    request.setBody(JSON.stringify(activity));
                                    _context4.prev = 2;
                                    _context4.next = 5;
                                    return _this3.streamConnection.send(request);
                                case 5:
                                    resp = _context4.sent;
                                    if (!(resp.statusCode !== 200)) {
                                        _context4.next = 8;
                                        break;
                                    }
                                    throw new Error("PostActivity returned " + resp.statusCode);
                                case 8:
                                    numberOfStreams = resp.streams.length;
                                    if (!(numberOfStreams !== 1)) {
                                        _context4.next = 11;
                                        break;
                                    }
                                    throw new Error("Expected one stream but got " + numberOfStreams);
                                case 11:
                                    _context4.next = 13;
                                    return resp.streams[0].readAsString();
                                case 13:
                                    idString = _context4.sent;
                                    _JSON$parse = JSON.parse(idString), id = _JSON$parse.Id;
                                    subscriber.next(id);
                                    return _context4.abrupt("return", subscriber.complete());
                                case 19:
                                    _context4.prev = 19;
                                    _context4.t0 = _context4["catch"](2);
                                    // If there is a network issue then its handled by
                                    // the disconnectionHandler. Everything else can
                                    // be retried
                                    console.warn(_context4.t0);
                                    _this3.streamConnection.disconnect();
                                    return _context4.abrupt("return", subscriber.error(_context4.t0));
                                case 24:
                                case "end":
                                    return _context4.stop();
                            }
                        }, _callee4, null, [
                            [
                                2,
                                19
                            ]
                        ]);
                    }));
                    return function(_x4) {
                        return _ref3.apply(this, arguments);
                    };
                }());
                return resp$;
            }
        },
        {
            key: "postMessageWithAttachments",
            value: function postMessageWithAttachments(message) {
                var _this4 = this;
                var attachments = message.attachments, messageWithoutAttachments = (0, $5b68c2555dfc6fc0$var$_objectWithoutProperties2["default"])(message, $5b68c2555dfc6fc0$var$_excluded);
                return $lyDVs.Observable.create(function(subscriber) {
                    var httpContentList = [];
                    (0, $5b68c2555dfc6fc0$var$_asyncToGenerator2["default"])(/*#__PURE__*/ $5b68c2555dfc6fc0$var$_regenerator["default"].mark(function _callee6() {
                        var arrayBuffers, url, request, activityStream, resp, _yield$resp$streams$, id;
                        return $5b68c2555dfc6fc0$var$_regenerator["default"].wrap(function _callee6$(_context6) {
                            while(true)switch(_context6.prev = _context6.next){
                                case 0:
                                    _context6.prev = 0;
                                    _context6.next = 3;
                                    return Promise.all(attachments.map(/*#__PURE__*/ function() {
                                        var _ref5 = (0, $5b68c2555dfc6fc0$var$_asyncToGenerator2["default"])(/*#__PURE__*/ $5b68c2555dfc6fc0$var$_regenerator["default"].mark(function _callee5(attachment) {
                                            var media, res;
                                            return $5b68c2555dfc6fc0$var$_regenerator["default"].wrap(function _callee5$(_context5) {
                                                while(true)switch(_context5.prev = _context5.next){
                                                    case 0:
                                                        media = attachment;
                                                        _context5.next = 3;
                                                        return (0, $5b68c2555dfc6fc0$var$_crossFetch["default"])(media.contentUrl);
                                                    case 3:
                                                        res = _context5.sent;
                                                        if (!res.ok) {
                                                            _context5.next = 12;
                                                            break;
                                                        }
                                                        _context5.next = 7;
                                                        return res.arrayBuffer();
                                                    case 7:
                                                        _context5.t0 = _context5.sent;
                                                        _context5.t1 = media;
                                                        return _context5.abrupt("return", {
                                                            arrayBuffer: _context5.t0,
                                                            media: _context5.t1
                                                        });
                                                    case 12:
                                                        throw new Error("...");
                                                    case 13:
                                                    case "end":
                                                        return _context5.stop();
                                                }
                                            }, _callee5);
                                        }));
                                        return function(_x5) {
                                            return _ref5.apply(this, arguments);
                                        };
                                    }()));
                                case 3:
                                    arrayBuffers = _context6.sent;
                                    arrayBuffers.forEach(function(_ref6) {
                                        var arrayBuffer = _ref6.arrayBuffer, media = _ref6.media;
                                        var buffer = $89iLh.Buffer.from(arrayBuffer);
                                        var stream = new $5b68c2555dfc6fc0$var$BFSE.SubscribableStream();
                                        stream.write(buffer);
                                        var httpContent = new $5b68c2555dfc6fc0$var$BFSE.HttpContent({
                                            type: media.contentType,
                                            contentLength: buffer.length
                                        }, stream);
                                        httpContentList.push(httpContent);
                                    });
                                    url = "/v3/directline/conversations/".concat(_this4.conversationId, "/users/").concat(messageWithoutAttachments.from.id, "/upload");
                                    request = $5b68c2555dfc6fc0$var$BFSE.StreamingRequest.create("PUT", url);
                                    activityStream = new $5b68c2555dfc6fc0$var$BFSE.SubscribableStream();
                                    activityStream.write(JSON.stringify(messageWithoutAttachments), "utf-8");
                                    request.addStream(new $5b68c2555dfc6fc0$var$BFSE.HttpContent({
                                        type: "application/vnd.microsoft.activity",
                                        contentLength: activityStream.length
                                    }, activityStream));
                                    httpContentList.forEach(function(e) {
                                        return request.addStream(e);
                                    });
                                    _context6.next = 13;
                                    return _this4.streamConnection.send(request);
                                case 13:
                                    resp = _context6.sent;
                                    if (!(resp.streams && resp.streams.length !== 1)) {
                                        _context6.next = 18;
                                        break;
                                    }
                                    subscriber.error(new Error("Invalid stream count ".concat(resp.streams.length)));
                                    _context6.next = 24;
                                    break;
                                case 18:
                                    _context6.next = 20;
                                    return resp.streams[0].readAsJson();
                                case 20:
                                    _yield$resp$streams$ = _context6.sent;
                                    id = _yield$resp$streams$.Id;
                                    subscriber.next(id);
                                    subscriber.complete();
                                case 24:
                                    _context6.next = 29;
                                    break;
                                case 26:
                                    _context6.prev = 26;
                                    _context6.t0 = _context6["catch"](0);
                                    subscriber.error(_context6.t0);
                                case 29:
                                case "end":
                                    return _context6.stop();
                            }
                        }, _callee6, null, [
                            [
                                0,
                                26
                            ]
                        ]);
                    }))();
                });
            }
        },
        {
            key: "waitUntilOnline",
            value: function() {
                var _waitUntilOnline = (0, $5b68c2555dfc6fc0$var$_asyncToGenerator2["default"])(/*#__PURE__*/ $5b68c2555dfc6fc0$var$_regenerator["default"].mark(function _callee7() {
                    var _this5 = this;
                    return $5b68c2555dfc6fc0$var$_regenerator["default"].wrap(function _callee7$(_context7) {
                        while(true)switch(_context7.prev = _context7.next){
                            case 0:
                                return _context7.abrupt("return", new Promise(function(resolve, reject) {
                                    _this5.connectionStatus$.subscribe(function(cs) {
                                        if (cs === $kT3Qz.ConnectionStatus.Online) return resolve();
                                    }, function(e) {
                                        return reject(e);
                                    });
                                }));
                            case 1:
                            case "end":
                                return _context7.stop();
                        }
                    }, _callee7);
                }));
                function waitUntilOnline() {
                    return _waitUntilOnline.apply(this, arguments);
                }
                return waitUntilOnline;
            }()
        },
        {
            key: "connectAsync",
            value: function() {
                var _connectAsync = (0, $5b68c2555dfc6fc0$var$_asyncToGenerator2["default"])(/*#__PURE__*/ $5b68c2555dfc6fc0$var$_regenerator["default"].mark(function _callee9() {
                    var _this6 = this;
                    var re, params, urlSearchParams, wsUrl;
                    return $5b68c2555dfc6fc0$var$_regenerator["default"].wrap(function _callee9$(_context9) {
                        while(true)switch(_context9.prev = _context9.next){
                            case 0:
                                re = new RegExp("^http(s?)");
                                if (re.test(this.domain)) {
                                    _context9.next = 3;
                                    break;
                                }
                                throw "Domain must begin with http or https";
                            case 3:
                                params = {
                                    token: this.token
                                };
                                if (this.conversationId) params["conversationId"] = this.conversationId;
                                urlSearchParams = new URLSearchParams(params).toString();
                                wsUrl = "".concat(this.domain.replace(re, "ws$1"), "/conversations/connect?").concat(urlSearchParams); // This promise will resolve when it is disconnected.
                                return _context9.abrupt("return", new Promise(/*#__PURE__*/ function() {
                                    var _ref7 = (0, $5b68c2555dfc6fc0$var$_asyncToGenerator2["default"])(/*#__PURE__*/ $5b68c2555dfc6fc0$var$_regenerator["default"].mark(function _callee8(resolve, reject) {
                                        var request, response, responseString, conversation;
                                        return $5b68c2555dfc6fc0$var$_regenerator["default"].wrap(function _callee8$(_context8) {
                                            while(true)switch(_context8.prev = _context8.next){
                                                case 0:
                                                    _context8.prev = 0;
                                                    _this6.streamConnection = new $5b68c2555dfc6fc0$var$BFSE.WebSocketClient({
                                                        url: wsUrl,
                                                        requestHandler: _this6.theStreamHandler,
                                                        disconnectionHandler: function disconnectionHandler(e) {
                                                            return resolve(e);
                                                        }
                                                    });
                                                    _this6.queueActivities = true;
                                                    _context8.next = 5;
                                                    return _this6.streamConnection.connect();
                                                case 5:
                                                    request = $5b68c2555dfc6fc0$var$BFSE.StreamingRequest.create("POST", "/v3/directline/conversations");
                                                    _context8.next = 8;
                                                    return _this6.streamConnection.send(request);
                                                case 8:
                                                    response = _context8.sent;
                                                    if (!(response.statusCode !== 200)) {
                                                        _context8.next = 11;
                                                        break;
                                                    }
                                                    throw new Error("Connection response code " + response.statusCode);
                                                case 11:
                                                    if (!(response.streams.length !== 1)) {
                                                        _context8.next = 13;
                                                        break;
                                                    }
                                                    throw new Error("Expected 1 stream but got " + response.streams.length);
                                                case 13:
                                                    _context8.next = 15;
                                                    return response.streams[0].readAsString();
                                                case 15:
                                                    responseString = _context8.sent;
                                                    conversation = JSON.parse(responseString);
                                                    _this6.conversationId = conversation.conversationId;
                                                    _this6.connectionStatus$.next($kT3Qz.ConnectionStatus.Online); // Wait until DL consumers have had a chance to be notified
                                                    // of the connection status change.
                                                    _context8.next = 21;
                                                    return _this6.waitUntilOnline();
                                                case 21:
                                                    _this6.theStreamHandler.flush();
                                                    _this6.queueActivities = false;
                                                    _context8.next = 28;
                                                    break;
                                                case 25:
                                                    _context8.prev = 25;
                                                    _context8.t0 = _context8["catch"](0);
                                                    reject(_context8.t0);
                                                case 28:
                                                case "end":
                                                    return _context8.stop();
                                            }
                                        }, _callee8, null, [
                                            [
                                                0,
                                                25
                                            ]
                                        ]);
                                    }));
                                    return function(_x6, _x7) {
                                        return _ref7.apply(this, arguments);
                                    };
                                }()));
                            case 8:
                            case "end":
                                return _context9.stop();
                        }
                    }, _callee9, this);
                }));
                function connectAsync() {
                    return _connectAsync.apply(this, arguments);
                }
                return connectAsync;
            }()
        },
        {
            key: "connectWithRetryAsync",
            value: function() {
                var _connectWithRetryAsync = (0, $5b68c2555dfc6fc0$var$_asyncToGenerator2["default"])(/*#__PURE__*/ $5b68c2555dfc6fc0$var$_regenerator["default"].mark(function _callee10() {
                    var _this7 = this;
                    var numRetries, start;
                    return $5b68c2555dfc6fc0$var$_regenerator["default"].wrap(function _callee10$(_context10) {
                        while(true)switch(_context10.prev = _context10.next){
                            case 0:
                                _context10.next = 2;
                                return (this.connectDeferred = (0, $5b68c2555dfc6fc0$var$_createDeferred["default"])()).promise;
                            case 2:
                                numRetries = $5b68c2555dfc6fc0$var$MAX_RETRY_COUNT;
                                this.connectionStatus$.next($kT3Qz.ConnectionStatus.Connecting);
                            case 4:
                                if (!(numRetries > 0)) {
                                    _context10.next = 26;
                                    break;
                                }
                                numRetries--;
                                start = Date.now();
                                _context10.prev = 7;
                                _context10.next = 10;
                                return this.connectAsync();
                            case 10:
                                _context10.next = 14;
                                break;
                            case 12:
                                _context10.prev = 12;
                                _context10.t0 = _context10["catch"](7);
                            case 14:
                                if (!(this.connectionStatus$.getValue() === $kT3Qz.ConnectionStatus.Ended)) {
                                    _context10.next = 16;
                                    break;
                                }
                                return _context10.abrupt("return");
                            case 16:
                                // Make sure we don't signal ConnectionStatus.Connecting twice or more without an actual connection.
                                // Subsequent retries should be transparent.
                                if (this.connectionStatus$.getValue() !== $kT3Qz.ConnectionStatus.Connecting) this.connectionStatus$.next($kT3Qz.ConnectionStatus.Connecting);
                                 // If the current connection lasted for more than a minute, the previous connection is good, which means:
                                // - we should reset the retry counter, and;
                                // - we should reconnect immediately.
                                if (!(60000 < Date.now() - start)) {
                                    _context10.next = 21;
                                    break;
                                }
                                numRetries = $5b68c2555dfc6fc0$var$MAX_RETRY_COUNT;
                                _context10.next = 24;
                                break;
                            case 21:
                                if (!(numRetries > 0)) {
                                    _context10.next = 24;
                                    break;
                                }
                                _context10.next = 24;
                                return new Promise(function(r) {
                                    return setTimeout(r, _this7.getRetryDelay());
                                });
                            case 24:
                                _context10.next = 4;
                                break;
                            case 26:
                                // TODO: [TEST] Make sure FailedToConnect is reported immediately after last disconnection, should be no getRetryDelay().
                                // Failed to reconnect after multiple retries.
                                this.connectionStatus$.next($kT3Qz.ConnectionStatus.FailedToConnect);
                            case 27:
                                _context10.next = 0;
                                break;
                            case 29:
                                throw new Error("Failed to connect after ".concat($5b68c2555dfc6fc0$var$MAX_RETRY_COUNT, " attempts"));
                            case 30:
                            case "end":
                                return _context10.stop();
                        }
                    }, _callee10, this, [
                        [
                            7,
                            12
                        ]
                    ]);
                }));
                function connectWithRetryAsync() {
                    return _connectWithRetryAsync.apply(this, arguments);
                }
                return connectWithRetryAsync;
            }() // Returns the delay duration in milliseconds
        },
        {
            key: "getRetryDelay",
            value: function getRetryDelay() {
                return Math.floor(3000 + Math.random() * 12000);
            }
        }
    ]);
    return DirectLineStreaming;
}();
module.exports.DirectLineStreaming = $5b68c2555dfc6fc0$var$DirectLineStreaming;

});
parcelRequire.register("ifEAF", function(module, exports) {

module.exports = (parcelRequire("6D4qh"));

});

parcelRequire.register("gE7KV", function(module, exports) {

var $3qQfH = parcelRequire("3qQfH");

var $glEHk = parcelRequire("glEHk");

var $039bf = parcelRequire("039bf");

var $iLlNv = parcelRequire("iLlNv");
function $c1e665ee85fa94ca$var$_toConsumableArray(arr) {
    return $3qQfH(arr) || $glEHk(arr) || $039bf(arr) || $iLlNv();
}
module.exports = $c1e665ee85fa94ca$var$_toConsumableArray;
module.exports["default"] = module.exports, module.exports.__esModule = true;

});
parcelRequire.register("3qQfH", function(module, exports) {

var $9NpzT = parcelRequire("9NpzT");
function $27fc55029311bab9$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $9NpzT(arr);
}
module.exports = $27fc55029311bab9$var$_arrayWithoutHoles;
module.exports["default"] = module.exports, module.exports.__esModule = true;

});

parcelRequire.register("iLlNv", function(module, exports) {
function $da8d86549b0639ca$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
module.exports = $da8d86549b0639ca$var$_nonIterableSpread;
module.exports["default"] = module.exports, module.exports.__esModule = true;

});


parcelRequire.register("gpGGk", function(module, exports) {
function $bf3016d3b5f3a734$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) resolve(value);
    else Promise.resolve(value).then(_next, _throw);
}
function $bf3016d3b5f3a734$var$_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                $bf3016d3b5f3a734$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                $bf3016d3b5f3a734$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
module.exports = $bf3016d3b5f3a734$var$_asyncToGenerator;
module.exports["default"] = module.exports, module.exports.__esModule = true;

});

parcelRequire.register("89iLh", function(module, exports) {

$parcel$export(module.exports, "Buffer", () => $5eedb7a58163e1bd$export$a143d493d941bafc, (v) => $5eedb7a58163e1bd$export$a143d493d941bafc = v);
$parcel$export(module.exports, "INSPECT_MAX_BYTES", () => $5eedb7a58163e1bd$export$f99ded8fe4b79145, (v) => $5eedb7a58163e1bd$export$f99ded8fe4b79145 = v);
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $5eedb7a58163e1bd$export$a143d493d941bafc;
var $5eedb7a58163e1bd$export$e4cf37d7f6fb9e0a;
var $5eedb7a58163e1bd$export$f99ded8fe4b79145;
var $5eedb7a58163e1bd$export$599f31c3813fae4d;
"use strict";

var $l4PI2 = parcelRequire("l4PI2");

var $9BUzF = parcelRequire("9BUzF");
const $5eedb7a58163e1bd$var$customInspectSymbol = typeof Symbol === "function" && typeof Symbol["for"] === "function" // eslint-disable-line dot-notation
 ? Symbol["for"]("nodejs.util.inspect.custom") // eslint-disable-line dot-notation
 : null;
$5eedb7a58163e1bd$export$a143d493d941bafc = $5eedb7a58163e1bd$var$Buffer;
$5eedb7a58163e1bd$export$e4cf37d7f6fb9e0a = $5eedb7a58163e1bd$var$SlowBuffer;
$5eedb7a58163e1bd$export$f99ded8fe4b79145 = 50;
const $5eedb7a58163e1bd$var$K_MAX_LENGTH = 0x7fffffff;
$5eedb7a58163e1bd$export$599f31c3813fae4d = $5eedb7a58163e1bd$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $5eedb7a58163e1bd$var$Buffer.TYPED_ARRAY_SUPPORT = $5eedb7a58163e1bd$var$typedArraySupport();
if (!$5eedb7a58163e1bd$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== "undefined" && typeof console.error === "function") console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $5eedb7a58163e1bd$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($5eedb7a58163e1bd$var$Buffer.prototype, "parent", {
    enumerable: true,
    get: function() {
        if (!$5eedb7a58163e1bd$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($5eedb7a58163e1bd$var$Buffer.prototype, "offset", {
    enumerable: true,
    get: function() {
        if (!$5eedb7a58163e1bd$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $5eedb7a58163e1bd$var$createBuffer(length) {
    if (length > $5eedb7a58163e1bd$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $5eedb7a58163e1bd$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $5eedb7a58163e1bd$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === "number") {
        if (typeof encodingOrOffset === "string") throw new TypeError('The "string" argument must be of type string. Received type number');
        return $5eedb7a58163e1bd$var$allocUnsafe(arg);
    }
    return $5eedb7a58163e1bd$var$from(arg, encodingOrOffset, length);
}
$5eedb7a58163e1bd$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $5eedb7a58163e1bd$var$from(value, encodingOrOffset, length) {
    if (typeof value === "string") return $5eedb7a58163e1bd$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $5eedb7a58163e1bd$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($5eedb7a58163e1bd$var$isInstance(value, ArrayBuffer) || value && $5eedb7a58163e1bd$var$isInstance(value.buffer, ArrayBuffer)) return $5eedb7a58163e1bd$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== "undefined" && ($5eedb7a58163e1bd$var$isInstance(value, SharedArrayBuffer) || value && $5eedb7a58163e1bd$var$isInstance(value.buffer, SharedArrayBuffer))) return $5eedb7a58163e1bd$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === "number") throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $5eedb7a58163e1bd$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $5eedb7a58163e1bd$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== "undefined" && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === "function") return $5eedb7a58163e1bd$var$Buffer.from(value[Symbol.toPrimitive]("string"), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $5eedb7a58163e1bd$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $5eedb7a58163e1bd$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($5eedb7a58163e1bd$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($5eedb7a58163e1bd$var$Buffer, Uint8Array);
function $5eedb7a58163e1bd$var$assertSize(size) {
    if (typeof size !== "number") throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $5eedb7a58163e1bd$var$alloc(size, fill, encoding) {
    $5eedb7a58163e1bd$var$assertSize(size);
    if (size <= 0) return $5eedb7a58163e1bd$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === "string" ? $5eedb7a58163e1bd$var$createBuffer(size).fill(fill, encoding) : $5eedb7a58163e1bd$var$createBuffer(size).fill(fill);
    return $5eedb7a58163e1bd$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $5eedb7a58163e1bd$var$Buffer.alloc = function(size, fill, encoding) {
    return $5eedb7a58163e1bd$var$alloc(size, fill, encoding);
};
function $5eedb7a58163e1bd$var$allocUnsafe(size) {
    $5eedb7a58163e1bd$var$assertSize(size);
    return $5eedb7a58163e1bd$var$createBuffer(size < 0 ? 0 : $5eedb7a58163e1bd$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $5eedb7a58163e1bd$var$Buffer.allocUnsafe = function(size) {
    return $5eedb7a58163e1bd$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $5eedb7a58163e1bd$var$Buffer.allocUnsafeSlow = function(size) {
    return $5eedb7a58163e1bd$var$allocUnsafe(size);
};
function $5eedb7a58163e1bd$var$fromString(string, encoding) {
    if (typeof encoding !== "string" || encoding === "") encoding = "utf8";
    if (!$5eedb7a58163e1bd$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
    const length = $5eedb7a58163e1bd$var$byteLength(string, encoding) | 0;
    let buf = $5eedb7a58163e1bd$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $5eedb7a58163e1bd$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $5eedb7a58163e1bd$var$checked(array.length) | 0;
    const buf = $5eedb7a58163e1bd$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $5eedb7a58163e1bd$var$fromArrayView(arrayView) {
    if ($5eedb7a58163e1bd$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $5eedb7a58163e1bd$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $5eedb7a58163e1bd$var$fromArrayLike(arrayView);
}
function $5eedb7a58163e1bd$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $5eedb7a58163e1bd$var$Buffer.prototype);
    return buf;
}
function $5eedb7a58163e1bd$var$fromObject(obj) {
    if ($5eedb7a58163e1bd$var$Buffer.isBuffer(obj)) {
        const len = $5eedb7a58163e1bd$var$checked(obj.length) | 0;
        const buf = $5eedb7a58163e1bd$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== "number" || $5eedb7a58163e1bd$var$numberIsNaN(obj.length)) return $5eedb7a58163e1bd$var$createBuffer(0);
        return $5eedb7a58163e1bd$var$fromArrayLike(obj);
    }
    if (obj.type === "Buffer" && Array.isArray(obj.data)) return $5eedb7a58163e1bd$var$fromArrayLike(obj.data);
}
function $5eedb7a58163e1bd$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $5eedb7a58163e1bd$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $5eedb7a58163e1bd$var$K_MAX_LENGTH.toString(16) + " bytes");
    return length | 0;
}
function $5eedb7a58163e1bd$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $5eedb7a58163e1bd$var$Buffer.alloc(+length);
}
$5eedb7a58163e1bd$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $5eedb7a58163e1bd$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$5eedb7a58163e1bd$var$Buffer.compare = function compare(a, b) {
    if ($5eedb7a58163e1bd$var$isInstance(a, Uint8Array)) a = $5eedb7a58163e1bd$var$Buffer.from(a, a.offset, a.byteLength);
    if ($5eedb7a58163e1bd$var$isInstance(b, Uint8Array)) b = $5eedb7a58163e1bd$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$5eedb7a58163e1bd$var$Buffer.isBuffer(a) || !$5eedb7a58163e1bd$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$5eedb7a58163e1bd$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "latin1":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return true;
        default:
            return false;
    }
};
$5eedb7a58163e1bd$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $5eedb7a58163e1bd$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $5eedb7a58163e1bd$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($5eedb7a58163e1bd$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$5eedb7a58163e1bd$var$Buffer.isBuffer(buf)) buf = $5eedb7a58163e1bd$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$5eedb7a58163e1bd$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $5eedb7a58163e1bd$var$byteLength(string, encoding) {
    if ($5eedb7a58163e1bd$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $5eedb7a58163e1bd$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== "string") throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case "ascii":
        case "latin1":
        case "binary":
            return len;
        case "utf8":
        case "utf-8":
            return $5eedb7a58163e1bd$var$utf8ToBytes(string).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return len * 2;
        case "hex":
            return len >>> 1;
        case "base64":
            return $5eedb7a58163e1bd$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $5eedb7a58163e1bd$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
}
$5eedb7a58163e1bd$var$Buffer.byteLength = $5eedb7a58163e1bd$var$byteLength;
function $5eedb7a58163e1bd$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return "";
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return "";
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return "";
    if (!encoding) encoding = "utf8";
    while(true)switch(encoding){
        case "hex":
            return $5eedb7a58163e1bd$var$hexSlice(this, start, end);
        case "utf8":
        case "utf-8":
            return $5eedb7a58163e1bd$var$utf8Slice(this, start, end);
        case "ascii":
            return $5eedb7a58163e1bd$var$asciiSlice(this, start, end);
        case "latin1":
        case "binary":
            return $5eedb7a58163e1bd$var$latin1Slice(this, start, end);
        case "base64":
            return $5eedb7a58163e1bd$var$base64Slice(this, start, end);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $5eedb7a58163e1bd$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = (encoding + "").toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$5eedb7a58163e1bd$var$Buffer.prototype._isBuffer = true;
function $5eedb7a58163e1bd$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$5eedb7a58163e1bd$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
    for(let i = 0; i < len; i += 2)$5eedb7a58163e1bd$var$swap(this, i, i + 1);
    return this;
};
$5eedb7a58163e1bd$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
    for(let i = 0; i < len; i += 4){
        $5eedb7a58163e1bd$var$swap(this, i, i + 3);
        $5eedb7a58163e1bd$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$5eedb7a58163e1bd$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
    for(let i = 0; i < len; i += 8){
        $5eedb7a58163e1bd$var$swap(this, i, i + 7);
        $5eedb7a58163e1bd$var$swap(this, i + 1, i + 6);
        $5eedb7a58163e1bd$var$swap(this, i + 2, i + 5);
        $5eedb7a58163e1bd$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$5eedb7a58163e1bd$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return "";
    if (arguments.length === 0) return $5eedb7a58163e1bd$var$utf8Slice(this, 0, length);
    return $5eedb7a58163e1bd$var$slowToString.apply(this, arguments);
};
$5eedb7a58163e1bd$var$Buffer.prototype.toLocaleString = $5eedb7a58163e1bd$var$Buffer.prototype.toString;
$5eedb7a58163e1bd$var$Buffer.prototype.equals = function equals(b) {
    if (!$5eedb7a58163e1bd$var$Buffer.isBuffer(b)) throw new TypeError("Argument must be a Buffer");
    if (this === b) return true;
    return $5eedb7a58163e1bd$var$Buffer.compare(this, b) === 0;
};
$5eedb7a58163e1bd$var$Buffer.prototype.inspect = function inspect() {
    let str = "";
    const max = $5eedb7a58163e1bd$export$f99ded8fe4b79145;
    str = this.toString("hex", 0, max).replace(/(.{2})/g, "$1 ").trim();
    if (this.length > max) str += " ... ";
    return "<Buffer " + str + ">";
};
if ($5eedb7a58163e1bd$var$customInspectSymbol) $5eedb7a58163e1bd$var$Buffer.prototype[$5eedb7a58163e1bd$var$customInspectSymbol] = $5eedb7a58163e1bd$var$Buffer.prototype.inspect;
$5eedb7a58163e1bd$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($5eedb7a58163e1bd$var$isInstance(target, Uint8Array)) target = $5eedb7a58163e1bd$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$5eedb7a58163e1bd$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError("out of range index");
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $5eedb7a58163e1bd$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === "string") {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($5eedb7a58163e1bd$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === "string") val = $5eedb7a58163e1bd$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($5eedb7a58163e1bd$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $5eedb7a58163e1bd$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === "number") {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === "function") {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $5eedb7a58163e1bd$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError("val must be string, number or Buffer");
}
function $5eedb7a58163e1bd$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === "ucs2" || encoding === "ucs-2" || encoding === "utf16le" || encoding === "utf-16le") {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$5eedb7a58163e1bd$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$5eedb7a58163e1bd$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $5eedb7a58163e1bd$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$5eedb7a58163e1bd$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $5eedb7a58163e1bd$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $5eedb7a58163e1bd$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($5eedb7a58163e1bd$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $5eedb7a58163e1bd$var$utf8Write(buf, string, offset, length) {
    return $5eedb7a58163e1bd$var$blitBuffer($5eedb7a58163e1bd$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $5eedb7a58163e1bd$var$asciiWrite(buf, string, offset, length) {
    return $5eedb7a58163e1bd$var$blitBuffer($5eedb7a58163e1bd$var$asciiToBytes(string), buf, offset, length);
}
function $5eedb7a58163e1bd$var$base64Write(buf, string, offset, length) {
    return $5eedb7a58163e1bd$var$blitBuffer($5eedb7a58163e1bd$var$base64ToBytes(string), buf, offset, length);
}
function $5eedb7a58163e1bd$var$ucs2Write(buf, string, offset, length) {
    return $5eedb7a58163e1bd$var$blitBuffer($5eedb7a58163e1bd$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$5eedb7a58163e1bd$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = "utf8";
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === "string") {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = "utf8";
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError("Attempt to write outside buffer bounds");
    if (!encoding) encoding = "utf8";
    let loweredCase = false;
    for(;;)switch(encoding){
        case "hex":
            return $5eedb7a58163e1bd$var$hexWrite(this, string, offset, length);
        case "utf8":
        case "utf-8":
            return $5eedb7a58163e1bd$var$utf8Write(this, string, offset, length);
        case "ascii":
        case "latin1":
        case "binary":
            return $5eedb7a58163e1bd$var$asciiWrite(this, string, offset, length);
        case "base64":
            // Warning: maxLength not taken into account in base64Write
            return $5eedb7a58163e1bd$var$base64Write(this, string, offset, length);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $5eedb7a58163e1bd$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
};
$5eedb7a58163e1bd$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: "Buffer",
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $5eedb7a58163e1bd$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $l4PI2.fromByteArray(buf);
    else return $l4PI2.fromByteArray(buf.slice(start, end));
}
function $5eedb7a58163e1bd$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $5eedb7a58163e1bd$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $5eedb7a58163e1bd$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $5eedb7a58163e1bd$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $5eedb7a58163e1bd$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = "";
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $5eedb7a58163e1bd$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $5eedb7a58163e1bd$var$asciiSlice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $5eedb7a58163e1bd$var$latin1Slice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $5eedb7a58163e1bd$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = "";
    for(let i = start; i < end; ++i)out += $5eedb7a58163e1bd$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $5eedb7a58163e1bd$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = "";
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$5eedb7a58163e1bd$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $5eedb7a58163e1bd$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $5eedb7a58163e1bd$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError("offset is not uint");
    if (offset + ext > length) throw new RangeError("Trying to access beyond buffer length");
}
$5eedb7a58163e1bd$var$Buffer.prototype.readUintLE = $5eedb7a58163e1bd$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $5eedb7a58163e1bd$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$5eedb7a58163e1bd$var$Buffer.prototype.readUintBE = $5eedb7a58163e1bd$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $5eedb7a58163e1bd$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$5eedb7a58163e1bd$var$Buffer.prototype.readUint8 = $5eedb7a58163e1bd$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $5eedb7a58163e1bd$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$5eedb7a58163e1bd$var$Buffer.prototype.readUint16LE = $5eedb7a58163e1bd$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $5eedb7a58163e1bd$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$5eedb7a58163e1bd$var$Buffer.prototype.readUint16BE = $5eedb7a58163e1bd$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $5eedb7a58163e1bd$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$5eedb7a58163e1bd$var$Buffer.prototype.readUint32LE = $5eedb7a58163e1bd$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $5eedb7a58163e1bd$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$5eedb7a58163e1bd$var$Buffer.prototype.readUint32BE = $5eedb7a58163e1bd$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $5eedb7a58163e1bd$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$5eedb7a58163e1bd$var$Buffer.prototype.readBigUInt64LE = $5eedb7a58163e1bd$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $5eedb7a58163e1bd$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $5eedb7a58163e1bd$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$5eedb7a58163e1bd$var$Buffer.prototype.readBigUInt64BE = $5eedb7a58163e1bd$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $5eedb7a58163e1bd$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $5eedb7a58163e1bd$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$5eedb7a58163e1bd$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $5eedb7a58163e1bd$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$5eedb7a58163e1bd$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $5eedb7a58163e1bd$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$5eedb7a58163e1bd$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $5eedb7a58163e1bd$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$5eedb7a58163e1bd$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $5eedb7a58163e1bd$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$5eedb7a58163e1bd$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $5eedb7a58163e1bd$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$5eedb7a58163e1bd$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $5eedb7a58163e1bd$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$5eedb7a58163e1bd$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $5eedb7a58163e1bd$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$5eedb7a58163e1bd$var$Buffer.prototype.readBigInt64LE = $5eedb7a58163e1bd$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $5eedb7a58163e1bd$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $5eedb7a58163e1bd$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$5eedb7a58163e1bd$var$Buffer.prototype.readBigInt64BE = $5eedb7a58163e1bd$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $5eedb7a58163e1bd$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $5eedb7a58163e1bd$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$5eedb7a58163e1bd$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $5eedb7a58163e1bd$var$checkOffset(offset, 4, this.length);
    return $9BUzF.read(this, offset, true, 23, 4);
};
$5eedb7a58163e1bd$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $5eedb7a58163e1bd$var$checkOffset(offset, 4, this.length);
    return $9BUzF.read(this, offset, false, 23, 4);
};
$5eedb7a58163e1bd$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $5eedb7a58163e1bd$var$checkOffset(offset, 8, this.length);
    return $9BUzF.read(this, offset, true, 52, 8);
};
$5eedb7a58163e1bd$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $5eedb7a58163e1bd$var$checkOffset(offset, 8, this.length);
    return $9BUzF.read(this, offset, false, 52, 8);
};
function $5eedb7a58163e1bd$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$5eedb7a58163e1bd$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
}
$5eedb7a58163e1bd$var$Buffer.prototype.writeUintLE = $5eedb7a58163e1bd$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $5eedb7a58163e1bd$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$5eedb7a58163e1bd$var$Buffer.prototype.writeUintBE = $5eedb7a58163e1bd$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $5eedb7a58163e1bd$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$5eedb7a58163e1bd$var$Buffer.prototype.writeUint8 = $5eedb7a58163e1bd$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $5eedb7a58163e1bd$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$5eedb7a58163e1bd$var$Buffer.prototype.writeUint16LE = $5eedb7a58163e1bd$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $5eedb7a58163e1bd$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$5eedb7a58163e1bd$var$Buffer.prototype.writeUint16BE = $5eedb7a58163e1bd$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $5eedb7a58163e1bd$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$5eedb7a58163e1bd$var$Buffer.prototype.writeUint32LE = $5eedb7a58163e1bd$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $5eedb7a58163e1bd$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$5eedb7a58163e1bd$var$Buffer.prototype.writeUint32BE = $5eedb7a58163e1bd$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $5eedb7a58163e1bd$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $5eedb7a58163e1bd$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $5eedb7a58163e1bd$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $5eedb7a58163e1bd$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $5eedb7a58163e1bd$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$5eedb7a58163e1bd$var$Buffer.prototype.writeBigUInt64LE = $5eedb7a58163e1bd$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $5eedb7a58163e1bd$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
$5eedb7a58163e1bd$var$Buffer.prototype.writeBigUInt64BE = $5eedb7a58163e1bd$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $5eedb7a58163e1bd$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
$5eedb7a58163e1bd$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $5eedb7a58163e1bd$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$5eedb7a58163e1bd$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $5eedb7a58163e1bd$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$5eedb7a58163e1bd$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $5eedb7a58163e1bd$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$5eedb7a58163e1bd$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $5eedb7a58163e1bd$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$5eedb7a58163e1bd$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $5eedb7a58163e1bd$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$5eedb7a58163e1bd$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $5eedb7a58163e1bd$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$5eedb7a58163e1bd$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $5eedb7a58163e1bd$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$5eedb7a58163e1bd$var$Buffer.prototype.writeBigInt64LE = $5eedb7a58163e1bd$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $5eedb7a58163e1bd$var$wrtBigUInt64LE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
$5eedb7a58163e1bd$var$Buffer.prototype.writeBigInt64BE = $5eedb7a58163e1bd$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $5eedb7a58163e1bd$var$wrtBigUInt64BE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
function $5eedb7a58163e1bd$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
    if (offset < 0) throw new RangeError("Index out of range");
}
function $5eedb7a58163e1bd$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $5eedb7a58163e1bd$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $9BUzF.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$5eedb7a58163e1bd$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $5eedb7a58163e1bd$var$writeFloat(this, value, offset, true, noAssert);
};
$5eedb7a58163e1bd$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $5eedb7a58163e1bd$var$writeFloat(this, value, offset, false, noAssert);
};
function $5eedb7a58163e1bd$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $5eedb7a58163e1bd$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $9BUzF.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$5eedb7a58163e1bd$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $5eedb7a58163e1bd$var$writeDouble(this, value, offset, true, noAssert);
};
$5eedb7a58163e1bd$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $5eedb7a58163e1bd$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$5eedb7a58163e1bd$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$5eedb7a58163e1bd$var$Buffer.isBuffer(target)) throw new TypeError("argument should be a Buffer");
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError("targetStart out of bounds");
    if (start < 0 || start >= this.length) throw new RangeError("Index out of range");
    if (end < 0) throw new RangeError("sourceEnd out of bounds");
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === "function") // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$5eedb7a58163e1bd$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === "string") {
        if (typeof start === "string") {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === "string") {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== "string") throw new TypeError("encoding must be a string");
        if (typeof encoding === "string" && !$5eedb7a58163e1bd$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === "utf8" && code < 128 || encoding === "latin1") // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === "number") val = val & 255;
    else if (typeof val === "boolean") val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError("Out of range index");
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === "number") for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $5eedb7a58163e1bd$var$Buffer.isBuffer(val) ? val : $5eedb7a58163e1bd$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $5eedb7a58163e1bd$var$errors = {};
function $5eedb7a58163e1bd$var$E(sym, getMessage, Base) {
    $5eedb7a58163e1bd$var$errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, "message", {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, "code", {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
$5eedb7a58163e1bd$var$E("ERR_BUFFER_OUT_OF_BOUNDS", function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return "Attempt to access memory outside buffer bounds";
}, RangeError);
$5eedb7a58163e1bd$var$E("ERR_INVALID_ARG_TYPE", function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$5eedb7a58163e1bd$var$E("ERR_OUT_OF_RANGE", function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $5eedb7a58163e1bd$var$addNumericalSeparator(String(input));
    else if (typeof input === "bigint") {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $5eedb7a58163e1bd$var$addNumericalSeparator(received);
        received += "n";
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $5eedb7a58163e1bd$var$addNumericalSeparator(val) {
    let res = "";
    let i = val.length;
    const start = val[0] === "-" ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $5eedb7a58163e1bd$var$checkBounds(buf, offset, byteLength) {
    $5eedb7a58163e1bd$var$validateNumber(offset, "offset");
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $5eedb7a58163e1bd$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $5eedb7a58163e1bd$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === "bigint" ? "n" : "";
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $5eedb7a58163e1bd$var$errors.ERR_OUT_OF_RANGE("value", range, value);
    }
    $5eedb7a58163e1bd$var$checkBounds(buf, offset, byteLength);
}
function $5eedb7a58163e1bd$var$validateNumber(value, name) {
    if (typeof value !== "number") throw new $5eedb7a58163e1bd$var$errors.ERR_INVALID_ARG_TYPE(name, "number", value);
}
function $5eedb7a58163e1bd$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $5eedb7a58163e1bd$var$validateNumber(value, type);
        throw new $5eedb7a58163e1bd$var$errors.ERR_OUT_OF_RANGE(type || "offset", "an integer", value);
    }
    if (length < 0) throw new $5eedb7a58163e1bd$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $5eedb7a58163e1bd$var$errors.ERR_OUT_OF_RANGE(type || "offset", `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $5eedb7a58163e1bd$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $5eedb7a58163e1bd$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split("=")[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($5eedb7a58163e1bd$var$INVALID_BASE64_RE, "");
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return "";
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + "=";
    return str;
}
function $5eedb7a58163e1bd$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error("Invalid code point");
    }
    return bytes;
}
function $5eedb7a58163e1bd$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $5eedb7a58163e1bd$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $5eedb7a58163e1bd$var$base64ToBytes(str) {
    return $l4PI2.toByteArray($5eedb7a58163e1bd$var$base64clean(str));
}
function $5eedb7a58163e1bd$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $5eedb7a58163e1bd$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $5eedb7a58163e1bd$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $5eedb7a58163e1bd$var$hexSliceLookupTable = function() {
    const alphabet = "0123456789abcdef";
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $5eedb7a58163e1bd$var$defineBigIntMethod(fn) {
    return typeof BigInt === "undefined" ? $5eedb7a58163e1bd$var$BufferBigIntNotDefined : fn;
}
function $5eedb7a58163e1bd$var$BufferBigIntNotDefined() {
    throw new Error("BigInt not supported");
}

});
parcelRequire.register("9BUzF", function(module, exports) {

$parcel$export(module.exports, "read", () => $6ff3743d49b5b65d$export$aafa59e2e03f2942, (v) => $6ff3743d49b5b65d$export$aafa59e2e03f2942 = v);
$parcel$export(module.exports, "write", () => $6ff3743d49b5b65d$export$68d8715fc104d294, (v) => $6ff3743d49b5b65d$export$68d8715fc104d294 = v);
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $6ff3743d49b5b65d$export$aafa59e2e03f2942;
var $6ff3743d49b5b65d$export$68d8715fc104d294;
$6ff3743d49b5b65d$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$6ff3743d49b5b65d$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

});


parcelRequire.register("ip1K7", function(module, exports) {
(function(f) {
    var g;
    module.exports = f();
})(function() {
    var define, module, exports;
    return (function() {
        function r(e, n, t) {
            function o(i, f) {
                if (!n[i]) {
                    if (!e[i]) {
                        var c = undefined;
                        if (!f && c) return c(i, !0);
                        if (u) return u(i, !0);
                        var a = new Error("Cannot find module '" + i + "'");
                        throw a.code = "MODULE_NOT_FOUND", a;
                    }
                    var p = n[i] = {
                        exports: {}
                    };
                    e[i][0].call(p.exports, function(r) {
                        var n = e[i][1][r];
                        return o(n || r);
                    }, p, p.exports, r, e, n, t);
                }
                return n[i].exports;
            }
            for(var u = undefined, i = 0; i < t.length; i++)o(t[i]);
            return o;
        }
        return r;
    })()({
        1: [
            function(require, module, exports) {
                "use strict";
                /**
 * @module botframework-streaming
 */ /**
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ var __awaiter = this && this.__awaiter || function(thisArg, _arguments, P, generator) {
                    function adopt(value) {
                        return value instanceof P ? value : new P(function(resolve) {
                            resolve(value);
                        });
                    }
                    return new (P || (P = Promise))(function(resolve, reject) {
                        function fulfilled(value) {
                            try {
                                step(generator.next(value));
                            } catch (e) {
                                reject(e);
                            }
                        }
                        function rejected(value) {
                            try {
                                step(generator["throw"](value));
                            } catch (e) {
                                reject(e);
                            }
                        }
                        function step(result) {
                            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
                        }
                        step((generator = generator.apply(thisArg, _arguments || [])).next());
                    });
                };
                var __generator = this && this.__generator || function(thisArg, body) {
                    var _ = {
                        label: 0,
                        sent: function() {
                            if (t[0] & 1) throw t[1];
                            return t[1];
                        },
                        trys: [],
                        ops: []
                    }, f, y, t, g;
                    return g = {
                        next: verb(0),
                        "throw": verb(1),
                        "return": verb(2)
                    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
                        return this;
                    }), g;
                    function verb(n) {
                        return function(v) {
                            return step([
                                n,
                                v
                            ]);
                        };
                    }
                    function step(op) {
                        if (f) throw new TypeError("Generator is already executing.");
                        while(g && (g = 0, op[0] && (_ = 0)), _)try {
                            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
                            if (y = 0, t) op = [
                                op[0] & 2,
                                t.value
                            ];
                            switch(op[0]){
                                case 0:
                                case 1:
                                    t = op;
                                    break;
                                case 4:
                                    _.label++;
                                    return {
                                        value: op[1],
                                        done: false
                                    };
                                case 5:
                                    _.label++;
                                    y = op[1];
                                    op = [
                                        0
                                    ];
                                    continue;
                                case 7:
                                    op = _.ops.pop();
                                    _.trys.pop();
                                    continue;
                                default:
                                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                                        _ = 0;
                                        continue;
                                    }
                                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                                        _.label = op[1];
                                        break;
                                    }
                                    if (op[0] === 6 && _.label < t[1]) {
                                        _.label = t[1];
                                        t = op;
                                        break;
                                    }
                                    if (t && _.label < t[2]) {
                                        _.label = t[2];
                                        _.ops.push(op);
                                        break;
                                    }
                                    if (t[2]) _.ops.pop();
                                    _.trys.pop();
                                    continue;
                            }
                            op = body.call(thisArg, _);
                        } catch (e) {
                            op = [
                                6,
                                e
                            ];
                            y = 0;
                        } finally{
                            f = t = 0;
                        }
                        if (op[0] & 5) throw op[1];
                        return {
                            value: op[0] ? op[1] : void 0,
                            done: true
                        };
                    }
                };
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.PayloadAssembler = void 0;
                var subscribableStream_1 = require("../subscribableStream");
                var payloads_1 = require("../payloads");
                var contentStream_1 = require("../contentStream");
                /**
 * Assembles payloads for streaming library.
 *
 * @internal
 */ var PayloadAssembler = /** @class */ function() {
                    /**
     * Initializes a new instance of the [PayloadAssembler](xref:botframework-streaming.PayloadAssembler) class.
     *
     * @param streamManager The [StreamManager](xref:botframework-streaming.StreamManager) managing the stream being assembled.
     * @param params Parameters for a streaming assembler.
     */ function PayloadAssembler(streamManager, params) {
                        this.streamManager = streamManager;
                        this._byteOrderMark = 0xfeff;
                        this._utf = "utf8";
                        if (params.header) {
                            this.id = params.header.id;
                            this.payloadType = params.header.payloadType;
                            this.contentLength = params.header.payloadLength;
                            this.end = params.header.end;
                        } else this.id = params.id;
                        if (!this.id) throw Error("An ID must be supplied when creating an assembler.");
                        this._onCompleted = params.onCompleted;
                    }
                    /**
     * Retrieves the assembler's payload as a stream.
     *
     * @returns A [SubscribableStream](xref:botframework-streaming.SubscribableStream) of the assembler's payload.
     */ PayloadAssembler.prototype.getPayloadStream = function() {
                        if (!this.stream) this.stream = this.createPayloadStream();
                        return this.stream;
                    };
                    /**
     * The action the assembler executes when new bytes are received on the incoming stream.
     *
     * @param header The stream's Header.
     * @param stream The incoming stream being assembled.
     * @param _contentLength The length of the stream, if finite.
     */ PayloadAssembler.prototype.onReceive = function(header, stream, _contentLength) {
                        this.end = header.end;
                        if (header.payloadType === payloads_1.PayloadTypes.response || header.payloadType === payloads_1.PayloadTypes.request) this.process(stream).then().catch();
                        else if (header.end) stream.end();
                    };
                    /**
     * Closes the assembler.
     */ PayloadAssembler.prototype.close = function() {
                        this.streamManager.closeStream(this.id);
                    };
                    /**
     * Creates a new [SubscribableStream](xref:botframework-streaming.SubscribableStream) instance.
     *
     * @returns The new stream ready for consumption.
     */ PayloadAssembler.prototype.createPayloadStream = function() {
                        return new subscribableStream_1.SubscribableStream();
                    };
                    PayloadAssembler.prototype.payloadFromJson = function(json) {
                        return JSON.parse(json.charCodeAt(0) === this._byteOrderMark ? json.slice(1) : json);
                    };
                    PayloadAssembler.prototype.stripBOM = function(input) {
                        return input.charCodeAt(0) === this._byteOrderMark ? input.slice(1) : input;
                    };
                    PayloadAssembler.prototype.process = function(stream) {
                        return __awaiter(this, void 0, void 0, function() {
                            var streamData, streamDataAsString;
                            return __generator(this, function(_a) {
                                switch(_a.label){
                                    case 0:
                                        streamData = stream.read(stream.length);
                                        if (!streamData) return [
                                            2 /*return*/ 
                                        ];
                                        streamDataAsString = streamData.toString(this._utf);
                                        if (!(this.payloadType === payloads_1.PayloadTypes.request)) return [
                                            3 /*break*/ ,
                                            2
                                        ];
                                        return [
                                            4 /*yield*/ ,
                                            this.processRequest(streamDataAsString)
                                        ];
                                    case 1:
                                        _a.sent();
                                        return [
                                            3 /*break*/ ,
                                            4
                                        ];
                                    case 2:
                                        if (!(this.payloadType === payloads_1.PayloadTypes.response)) return [
                                            3 /*break*/ ,
                                            4
                                        ];
                                        return [
                                            4 /*yield*/ ,
                                            this.processResponse(streamDataAsString)
                                        ];
                                    case 3:
                                        _a.sent();
                                        _a.label = 4;
                                    case 4:
                                        return [
                                            2 /*return*/ 
                                        ];
                                }
                            });
                        });
                    };
                    PayloadAssembler.prototype.processResponse = function(streamDataAsString) {
                        return __awaiter(this, void 0, void 0, function() {
                            var responsePayload, receiveResponse;
                            return __generator(this, function(_a) {
                                switch(_a.label){
                                    case 0:
                                        responsePayload = this.payloadFromJson(this.stripBOM(streamDataAsString));
                                        receiveResponse = {
                                            streams: [],
                                            statusCode: responsePayload.statusCode
                                        };
                                        return [
                                            4 /*yield*/ ,
                                            this.processStreams(responsePayload, receiveResponse)
                                        ];
                                    case 1:
                                        _a.sent();
                                        return [
                                            2 /*return*/ 
                                        ];
                                }
                            });
                        });
                    };
                    PayloadAssembler.prototype.processRequest = function(streamDataAsString) {
                        return __awaiter(this, void 0, void 0, function() {
                            var requestPayload, receiveRequest;
                            return __generator(this, function(_a) {
                                switch(_a.label){
                                    case 0:
                                        requestPayload = this.payloadFromJson(streamDataAsString);
                                        receiveRequest = {
                                            streams: [],
                                            path: requestPayload.path,
                                            verb: requestPayload.verb
                                        };
                                        return [
                                            4 /*yield*/ ,
                                            this.processStreams(requestPayload, receiveRequest)
                                        ];
                                    case 1:
                                        _a.sent();
                                        return [
                                            2 /*return*/ 
                                        ];
                                }
                            });
                        });
                    };
                    PayloadAssembler.prototype.processStreams = function(responsePayload, receiveResponse) {
                        var _a;
                        return __awaiter(this, void 0, void 0, function() {
                            var _this = this;
                            return __generator(this, function(_b) {
                                switch(_b.label){
                                    case 0:
                                        (_a = responsePayload.streams) === null || _a === void 0 || _a.forEach(function(responseStream) {
                                            var _a;
                                            // There was a bug in how streams were handled. In .NET, the StreamDescription definiton mapped the
                                            // "type" JSON property to `contentType`, but in Typescript there was no mapping. This is a workaround
                                            // to resolve this inconsistency.
                                            //
                                            // .NET code:
                                            // https://github.com/microsoft/botbuilder-dotnet/blob/a79036ddf6625ec3fd68a6f7295886eb7831bc1c/libraries/Microsoft.Bot.Streaming/Payloads/Models/StreamDescription.cs#L28-L29
                                            var contentType = (_a = responseStream.type) !== null && _a !== void 0 ? _a : responseStream.contentType;
                                            var contentAssembler = _this.streamManager.getPayloadAssembler(responseStream.id);
                                            contentAssembler.payloadType = contentType;
                                            contentAssembler.contentLength = responseStream.length;
                                            receiveResponse.streams.push(new contentStream_1.ContentStream(responseStream.id, contentAssembler));
                                        });
                                        return [
                                            4 /*yield*/ ,
                                            this._onCompleted(this.id, receiveResponse)
                                        ];
                                    case 1:
                                        _b.sent();
                                        return [
                                            2 /*return*/ 
                                        ];
                                }
                            });
                        });
                    };
                    return PayloadAssembler;
                }();
                exports.PayloadAssembler = PayloadAssembler;
            },
            {
                "../contentStream": 2,
                "../payloads": 16,
                "../subscribableStream": 27
            }
        ],
        2: [
            function(require, module, exports) {
                "use strict";
                /**
 * @module botframework-streaming
 */ /**
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ var __awaiter = this && this.__awaiter || function(thisArg, _arguments, P, generator) {
                    function adopt(value) {
                        return value instanceof P ? value : new P(function(resolve) {
                            resolve(value);
                        });
                    }
                    return new (P || (P = Promise))(function(resolve, reject) {
                        function fulfilled(value) {
                            try {
                                step(generator.next(value));
                            } catch (e) {
                                reject(e);
                            }
                        }
                        function rejected(value) {
                            try {
                                step(generator["throw"](value));
                            } catch (e) {
                                reject(e);
                            }
                        }
                        function step(result) {
                            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
                        }
                        step((generator = generator.apply(thisArg, _arguments || [])).next());
                    });
                };
                var __generator = this && this.__generator || function(thisArg, body) {
                    var _ = {
                        label: 0,
                        sent: function() {
                            if (t[0] & 1) throw t[1];
                            return t[1];
                        },
                        trys: [],
                        ops: []
                    }, f, y, t, g;
                    return g = {
                        next: verb(0),
                        "throw": verb(1),
                        "return": verb(2)
                    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
                        return this;
                    }), g;
                    function verb(n) {
                        return function(v) {
                            return step([
                                n,
                                v
                            ]);
                        };
                    }
                    function step(op) {
                        if (f) throw new TypeError("Generator is already executing.");
                        while(g && (g = 0, op[0] && (_ = 0)), _)try {
                            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
                            if (y = 0, t) op = [
                                op[0] & 2,
                                t.value
                            ];
                            switch(op[0]){
                                case 0:
                                case 1:
                                    t = op;
                                    break;
                                case 4:
                                    _.label++;
                                    return {
                                        value: op[1],
                                        done: false
                                    };
                                case 5:
                                    _.label++;
                                    y = op[1];
                                    op = [
                                        0
                                    ];
                                    continue;
                                case 7:
                                    op = _.ops.pop();
                                    _.trys.pop();
                                    continue;
                                default:
                                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                                        _ = 0;
                                        continue;
                                    }
                                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                                        _.label = op[1];
                                        break;
                                    }
                                    if (op[0] === 6 && _.label < t[1]) {
                                        _.label = t[1];
                                        t = op;
                                        break;
                                    }
                                    if (t && _.label < t[2]) {
                                        _.label = t[2];
                                        _.ops.push(op);
                                        break;
                                    }
                                    if (t[2]) _.ops.pop();
                                    _.trys.pop();
                                    continue;
                            }
                            op = body.call(thisArg, _);
                        } catch (e) {
                            op = [
                                6,
                                e
                            ];
                            y = 0;
                        } finally{
                            f = t = 0;
                        }
                        if (op[0] & 5) throw op[1];
                        return {
                            value: op[0] ? op[1] : void 0,
                            done: true
                        };
                    }
                };
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.ContentStream = void 0;
                /**
 * A stream of fixed or infinite length containing content to be decoded.
 */ var ContentStream = /** @class */ function() {
                    /**
     * Initializes a new instance of the [ContentStream](xref:botframework-streaming.ContentStream) class.
     *
     * @param id The ID assigned to this instance.
     * @param assembler The [PayloadAssembler](xref:botframework-streaming.PayloadAssembler) assigned to this instance.
     */ function ContentStream(id, assembler) {
                        if (!assembler) throw Error("Null Argument Exception");
                        this.id = id;
                        this.assembler = assembler;
                    }
                    Object.defineProperty(ContentStream.prototype, "contentType", {
                        /**
         * Gets the name of the type of the object contained within this [ContentStream](xref:botframework-streaming.ContentStream).
         *
         * @returns The [PayloadType](xref:botframework-streaming.PayloadType) of this [ContentStream](xref:botframework-streaming.ContentStream).
         */ get: function() {
                            return this.assembler.payloadType;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(ContentStream.prototype, "length", {
                        /**
         * Gets the length of this [ContentStream](xref:botframework-streaming.ContentStream).
         *
         * @returns A number representing the length of this [ContentStream](xref:botframework-streaming.ContentStream).
         */ get: function() {
                            return this.assembler.contentLength;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    /**
     * Gets the data contained within this [ContentStream](xref:botframework-streaming.ContentStream).
     *
     * @returns This [ContentStream's](xref:botframework-streaming.ContentStream) [SubscribableStream](xref:botframework-streaming.SubscribableStream).
     */ ContentStream.prototype.getStream = function() {
                        if (!this.stream) this.stream = this.assembler.getPayloadStream();
                        return this.stream;
                    };
                    /**
     * Closes the assembler.
     */ ContentStream.prototype.cancel = function() {
                        this.assembler.close();
                    };
                    /**
     * Gets the [SubscribableStream](xref:botframework-streaming.SubscribableStream) content as a string.
     *
     * @returns A string Promise with [SubscribableStream](xref:botframework-streaming.SubscribableStream) content.
     */ ContentStream.prototype.readAsString = function() {
                        return __awaiter(this, void 0, void 0, function() {
                            var bufferArray;
                            return __generator(this, function(_a) {
                                switch(_a.label){
                                    case 0:
                                        return [
                                            4 /*yield*/ ,
                                            this.readAll()
                                        ];
                                    case 1:
                                        bufferArray = _a.sent().bufferArray;
                                        return [
                                            2 /*return*/ ,
                                            (bufferArray || []).map(function(result) {
                                                return result.toString("utf8");
                                            }).join("")
                                        ];
                                }
                            });
                        });
                    };
                    /**
     * Gets the [SubscribableStream](xref:botframework-streaming.SubscribableStream) content as a typed JSON object.
     *
     * @returns A typed object Promise with `SubscribableStream` content.
     */ ContentStream.prototype.readAsJson = function() {
                        return __awaiter(this, void 0, void 0, function() {
                            var stringToParse;
                            return __generator(this, function(_a) {
                                switch(_a.label){
                                    case 0:
                                        return [
                                            4 /*yield*/ ,
                                            this.readAsString()
                                        ];
                                    case 1:
                                        stringToParse = _a.sent();
                                        return [
                                            2 /*return*/ ,
                                            JSON.parse(stringToParse)
                                        ];
                                }
                            });
                        });
                    };
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    ContentStream.prototype.readAll = function() {
                        return __awaiter(this, void 0, void 0, function() {
                            var allData, count, stream, chunk, readToEnd;
                            var _this = this;
                            return __generator(this, function(_a) {
                                switch(_a.label){
                                    case 0:
                                        allData = [];
                                        count = 0;
                                        stream = this.getStream();
                                        // populate the array with any existing buffers
                                        while(count < stream.length){
                                            chunk = stream.read(stream.length);
                                            allData.push(chunk);
                                            count += chunk.length;
                                        }
                                        if (!(count < this.length)) return [
                                            3 /*break*/ ,
                                            2
                                        ];
                                        readToEnd = new Promise(function(resolve) {
                                            // eslint-disable-next-line @typescript-eslint/no-explicit-any
                                            var callback = function(cs) {
                                                return function(chunk) {
                                                    allData.push(chunk);
                                                    count += chunk.length;
                                                    if (count === cs.length) resolve(true);
                                                };
                                            };
                                            stream.subscribe(callback(_this));
                                        });
                                        return [
                                            4 /*yield*/ ,
                                            readToEnd
                                        ];
                                    case 1:
                                        _a.sent();
                                        _a.label = 2;
                                    case 2:
                                        return [
                                            2 /*return*/ ,
                                            {
                                                bufferArray: allData,
                                                size: count
                                            }
                                        ];
                                }
                            });
                        });
                    };
                    return ContentStream;
                }();
                exports.ContentStream = ContentStream;
            },
            {}
        ],
        3: [
            function(require, module, exports) {
                "use strict";
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.CancelDisassembler = void 0;
                /**
 * Streaming cancel disassembler.
 */ var CancelDisassembler = /** @class */ function() {
                    /**
     * Initializes a new instance of the [CancelDisassembler](xref:botframework-streaming.CancelDisassembler) class.
     *
     * @param sender The [PayloadSender](xref:botframework-streaming.PayloadSender) that this Cancel request will be sent by.
     * @param id The ID of the Stream to cancel.
     * @param payloadType The type of the Stream that is being cancelled.
     */ function CancelDisassembler(sender, id, payloadType) {
                        this.sender = sender;
                        this.id = id;
                        this.payloadType = payloadType;
                    }
                    /**
     * Initiates the process of disassembling the request and signals the [PayloadSender](xref:botframework-streaming.PayloadSender) to begin sending.
     */ CancelDisassembler.prototype.disassemble = function() {
                        var header = {
                            payloadType: this.payloadType,
                            payloadLength: 0,
                            id: this.id,
                            end: true
                        };
                        this.sender.sendPayload(header);
                    };
                    return CancelDisassembler;
                }();
                exports.CancelDisassembler = CancelDisassembler;
            },
            {}
        ],
        4: [
            function(require, module, exports) {
                "use strict";
                var __extends = this && this.__extends || function() {
                    var extendStatics = function(d, b) {
                        extendStatics = Object.setPrototypeOf || ({
                            __proto__: []
                        }) instanceof Array && function(d, b) {
                            d.__proto__ = b;
                        } || function(d, b) {
                            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                        };
                        return extendStatics(d, b);
                    };
                    return function(d, b) {
                        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                        extendStatics(d, b);
                        function __() {
                            this.constructor = d;
                        }
                        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                    };
                }();
                var __awaiter = this && this.__awaiter || function(thisArg, _arguments, P, generator) {
                    function adopt(value) {
                        return value instanceof P ? value : new P(function(resolve) {
                            resolve(value);
                        });
                    }
                    return new (P || (P = Promise))(function(resolve, reject) {
                        function fulfilled(value) {
                            try {
                                step(generator.next(value));
                            } catch (e) {
                                reject(e);
                            }
                        }
                        function rejected(value) {
                            try {
                                step(generator["throw"](value));
                            } catch (e) {
                                reject(e);
                            }
                        }
                        function step(result) {
                            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
                        }
                        step((generator = generator.apply(thisArg, _arguments || [])).next());
                    });
                };
                var __generator = this && this.__generator || function(thisArg, body) {
                    var _ = {
                        label: 0,
                        sent: function() {
                            if (t[0] & 1) throw t[1];
                            return t[1];
                        },
                        trys: [],
                        ops: []
                    }, f, y, t, g;
                    return g = {
                        next: verb(0),
                        "throw": verb(1),
                        "return": verb(2)
                    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
                        return this;
                    }), g;
                    function verb(n) {
                        return function(v) {
                            return step([
                                n,
                                v
                            ]);
                        };
                    }
                    function step(op) {
                        if (f) throw new TypeError("Generator is already executing.");
                        while(g && (g = 0, op[0] && (_ = 0)), _)try {
                            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
                            if (y = 0, t) op = [
                                op[0] & 2,
                                t.value
                            ];
                            switch(op[0]){
                                case 0:
                                case 1:
                                    t = op;
                                    break;
                                case 4:
                                    _.label++;
                                    return {
                                        value: op[1],
                                        done: false
                                    };
                                case 5:
                                    _.label++;
                                    y = op[1];
                                    op = [
                                        0
                                    ];
                                    continue;
                                case 7:
                                    op = _.ops.pop();
                                    _.trys.pop();
                                    continue;
                                default:
                                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                                        _ = 0;
                                        continue;
                                    }
                                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                                        _.label = op[1];
                                        break;
                                    }
                                    if (op[0] === 6 && _.label < t[1]) {
                                        _.label = t[1];
                                        t = op;
                                        break;
                                    }
                                    if (t && _.label < t[2]) {
                                        _.label = t[2];
                                        _.ops.push(op);
                                        break;
                                    }
                                    if (t[2]) _.ops.pop();
                                    _.trys.pop();
                                    continue;
                            }
                            op = body.call(thisArg, _);
                        } catch (e) {
                            op = [
                                6,
                                e
                            ];
                            y = 0;
                        } finally{
                            f = t = 0;
                        }
                        if (op[0] & 5) throw op[1];
                        return {
                            value: op[0] ? op[1] : void 0,
                            done: true
                        };
                    }
                };
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.HttpContentStreamDisassembler = void 0;
                var payloadDisassembler_1 = require("./payloadDisassembler");
                var payloads_1 = require("../payloads");
                /**
 * Disassembler for Http content stream
 */ var HttpContentStreamDisassembler = /** @class */ function(_super) {
                    __extends(HttpContentStreamDisassembler, _super);
                    /**
     * Initializes a new instance of the [HttpContentStreamDisassembler](xref:botframework-streaming.HttpContentStreamDisassembler) class.
     *
     * @param sender The [PayloadSender](xref:botframework-streaming.PayloadSender) to send the disassembled data to.
     * @param contentStream The [HttpContentStream](xref:botframework-streaming.HttpContentStream) to be disassembled.
     */ function HttpContentStreamDisassembler(sender, contentStream) {
                        var _this = _super.call(this, sender, contentStream.id) || this;
                        _this.payloadType = payloads_1.PayloadTypes.stream;
                        _this.contentStream = contentStream;
                        return _this;
                    }
                    /**
     * Gets the stream this disassembler is operating on.
     *
     * @returns An [IStreamWrapper](xref:botframework-streaming.IStreamWrapper) with a Subscribable Strea.
     */ HttpContentStreamDisassembler.prototype.getStream = function() {
                        return __awaiter(this, void 0, void 0, function() {
                            var stream;
                            return __generator(this, function(_a) {
                                stream = this.contentStream.content.getStream();
                                return [
                                    2 /*return*/ ,
                                    {
                                        stream: stream,
                                        streamLength: stream.length
                                    }
                                ];
                            });
                        });
                    };
                    return HttpContentStreamDisassembler;
                }(payloadDisassembler_1.PayloadDisassembler);
                exports.HttpContentStreamDisassembler = HttpContentStreamDisassembler;
            },
            {
                "../payloads": 16,
                "./payloadDisassembler": 5
            }
        ],
        5: [
            function(require, module, exports) {
                "use strict";
                var __awaiter = this && this.__awaiter || function(thisArg, _arguments, P, generator) {
                    function adopt(value) {
                        return value instanceof P ? value : new P(function(resolve) {
                            resolve(value);
                        });
                    }
                    return new (P || (P = Promise))(function(resolve, reject) {
                        function fulfilled(value) {
                            try {
                                step(generator.next(value));
                            } catch (e) {
                                reject(e);
                            }
                        }
                        function rejected(value) {
                            try {
                                step(generator["throw"](value));
                            } catch (e) {
                                reject(e);
                            }
                        }
                        function step(result) {
                            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
                        }
                        step((generator = generator.apply(thisArg, _arguments || [])).next());
                    });
                };
                var __generator = this && this.__generator || function(thisArg, body) {
                    var _ = {
                        label: 0,
                        sent: function() {
                            if (t[0] & 1) throw t[1];
                            return t[1];
                        },
                        trys: [],
                        ops: []
                    }, f, y, t, g;
                    return g = {
                        next: verb(0),
                        "throw": verb(1),
                        "return": verb(2)
                    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
                        return this;
                    }), g;
                    function verb(n) {
                        return function(v) {
                            return step([
                                n,
                                v
                            ]);
                        };
                    }
                    function step(op) {
                        if (f) throw new TypeError("Generator is already executing.");
                        while(g && (g = 0, op[0] && (_ = 0)), _)try {
                            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
                            if (y = 0, t) op = [
                                op[0] & 2,
                                t.value
                            ];
                            switch(op[0]){
                                case 0:
                                case 1:
                                    t = op;
                                    break;
                                case 4:
                                    _.label++;
                                    return {
                                        value: op[1],
                                        done: false
                                    };
                                case 5:
                                    _.label++;
                                    y = op[1];
                                    op = [
                                        0
                                    ];
                                    continue;
                                case 7:
                                    op = _.ops.pop();
                                    _.trys.pop();
                                    continue;
                                default:
                                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                                        _ = 0;
                                        continue;
                                    }
                                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                                        _.label = op[1];
                                        break;
                                    }
                                    if (op[0] === 6 && _.label < t[1]) {
                                        _.label = t[1];
                                        t = op;
                                        break;
                                    }
                                    if (t && _.label < t[2]) {
                                        _.label = t[2];
                                        _.ops.push(op);
                                        break;
                                    }
                                    if (t[2]) _.ops.pop();
                                    _.trys.pop();
                                    continue;
                            }
                            op = body.call(thisArg, _);
                        } catch (e) {
                            op = [
                                6,
                                e
                            ];
                            y = 0;
                        } finally{
                            f = t = 0;
                        }
                        if (op[0] & 5) throw op[1];
                        return {
                            value: op[0] ? op[1] : void 0,
                            done: true
                        };
                    }
                };
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.PayloadDisassembler = void 0;
                var subscribableStream_1 = require("../subscribableStream");
                /**
 * Base class streaming payload disassembling.
 */ var PayloadDisassembler = /** @class */ function() {
                    /**
     * Initializes a new instance of the [PayloadDisassembler](xref:botframework-streaming.PayloadDisassembler) class.
     *
     * @param sender The [PayloadSender](xref:botframework-streaming.PayloadSender) used to send the disassembled payload chunks.
     * @param id The ID of this disassembler.
     */ function PayloadDisassembler(sender, id) {
                        this.sender = sender;
                        this.id = id;
                    }
                    /**
     * Serializes the item into the [IStreamWrapper](xref:botframework-streaming.IStreamWrapper) that exposes the stream and length of the result.
     *
     * @param item The item to be serialized.
     * @returns The stream containing the serialized item and the length of the stream.
     */ PayloadDisassembler.serialize = function(item) {
                        var stream = new subscribableStream_1.SubscribableStream();
                        stream.write(JSON.stringify(item));
                        stream.end();
                        return {
                            stream: stream,
                            streamLength: stream.length
                        };
                    };
                    /**
     * Begins the process of disassembling a payload and sending the resulting chunks to the [PayloadSender](xref:botframework-streaming.PayloadSender) to dispatch over the transport.
     *
     * @returns A completed Promise after the disassembled payload has been sent.
     */ PayloadDisassembler.prototype.disassemble = function() {
                        return __awaiter(this, void 0, void 0, function() {
                            var _a, stream, streamLength;
                            return __generator(this, function(_b) {
                                switch(_b.label){
                                    case 0:
                                        return [
                                            4 /*yield*/ ,
                                            this.getStream()
                                        ];
                                    case 1:
                                        _a = _b.sent(), stream = _a.stream, streamLength = _a.streamLength;
                                        this.stream = stream;
                                        this.streamLength = streamLength;
                                        return [
                                            2 /*return*/ ,
                                            this.send()
                                        ];
                                }
                            });
                        });
                    };
                    /**
     * Begins the process of disassembling a payload and signals the [PayloadSender](xref:botframework-streaming.PayloadSender).
     */ PayloadDisassembler.prototype.send = function() {
                        return __awaiter(this, void 0, void 0, function() {
                            var header;
                            return __generator(this, function(_a) {
                                header = {
                                    payloadType: this.payloadType,
                                    payloadLength: this.streamLength,
                                    id: this.id,
                                    end: true
                                };
                                this.sender.sendPayload(header, this.stream);
                                return [
                                    2 /*return*/ 
                                ];
                            });
                        });
                    };
                    return PayloadDisassembler;
                }();
                exports.PayloadDisassembler = PayloadDisassembler;
            },
            {
                "../subscribableStream": 27
            }
        ],
        6: [
            function(require, module, exports) {
                "use strict";
                /**
 * @module botframework-streaming
 */ /**
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ var __extends = this && this.__extends || function() {
                    var extendStatics = function(d, b) {
                        extendStatics = Object.setPrototypeOf || ({
                            __proto__: []
                        }) instanceof Array && function(d, b) {
                            d.__proto__ = b;
                        } || function(d, b) {
                            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                        };
                        return extendStatics(d, b);
                    };
                    return function(d, b) {
                        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                        extendStatics(d, b);
                        function __() {
                            this.constructor = d;
                        }
                        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                    };
                }();
                var __awaiter = this && this.__awaiter || function(thisArg, _arguments, P, generator) {
                    function adopt(value) {
                        return value instanceof P ? value : new P(function(resolve) {
                            resolve(value);
                        });
                    }
                    return new (P || (P = Promise))(function(resolve, reject) {
                        function fulfilled(value) {
                            try {
                                step(generator.next(value));
                            } catch (e) {
                                reject(e);
                            }
                        }
                        function rejected(value) {
                            try {
                                step(generator["throw"](value));
                            } catch (e) {
                                reject(e);
                            }
                        }
                        function step(result) {
                            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
                        }
                        step((generator = generator.apply(thisArg, _arguments || [])).next());
                    });
                };
                var __generator = this && this.__generator || function(thisArg, body) {
                    var _ = {
                        label: 0,
                        sent: function() {
                            if (t[0] & 1) throw t[1];
                            return t[1];
                        },
                        trys: [],
                        ops: []
                    }, f, y, t, g;
                    return g = {
                        next: verb(0),
                        "throw": verb(1),
                        "return": verb(2)
                    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
                        return this;
                    }), g;
                    function verb(n) {
                        return function(v) {
                            return step([
                                n,
                                v
                            ]);
                        };
                    }
                    function step(op) {
                        if (f) throw new TypeError("Generator is already executing.");
                        while(g && (g = 0, op[0] && (_ = 0)), _)try {
                            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
                            if (y = 0, t) op = [
                                op[0] & 2,
                                t.value
                            ];
                            switch(op[0]){
                                case 0:
                                case 1:
                                    t = op;
                                    break;
                                case 4:
                                    _.label++;
                                    return {
                                        value: op[1],
                                        done: false
                                    };
                                case 5:
                                    _.label++;
                                    y = op[1];
                                    op = [
                                        0
                                    ];
                                    continue;
                                case 7:
                                    op = _.ops.pop();
                                    _.trys.pop();
                                    continue;
                                default:
                                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                                        _ = 0;
                                        continue;
                                    }
                                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                                        _.label = op[1];
                                        break;
                                    }
                                    if (op[0] === 6 && _.label < t[1]) {
                                        _.label = t[1];
                                        t = op;
                                        break;
                                    }
                                    if (t && _.label < t[2]) {
                                        _.label = t[2];
                                        _.ops.push(op);
                                        break;
                                    }
                                    if (t[2]) _.ops.pop();
                                    _.trys.pop();
                                    continue;
                            }
                            op = body.call(thisArg, _);
                        } catch (e) {
                            op = [
                                6,
                                e
                            ];
                            y = 0;
                        } finally{
                            f = t = 0;
                        }
                        if (op[0] & 5) throw op[1];
                        return {
                            value: op[0] ? op[1] : void 0,
                            done: true
                        };
                    }
                };
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.RequestDisassembler = void 0;
                var payloadTypes_1 = require("../payloads/payloadTypes");
                var payloadDisassembler_1 = require("./payloadDisassembler");
                /**
 * Streaming request disassembler.
 */ var RequestDisassembler = /** @class */ function(_super) {
                    __extends(RequestDisassembler, _super);
                    /**
     * Initializes a new instance of the [RequestDisassembler](xref:botframework-streaming.RequestDisassembler) class.
     *
     * @param sender The [PayloadSender](xref:botframework-streaming.PayloadSender) to send the disassembled data to.
     * @param id The ID of this disassembler.
     * @param request The request to be disassembled.
     */ function RequestDisassembler(sender, id, request) {
                        var _this = _super.call(this, sender, id) || this;
                        _this.request = request;
                        _this.payloadType = payloadTypes_1.PayloadTypes.request;
                        return _this;
                    }
                    /**
     * Gets the stream this disassembler is operating on.
     *
     * @returns An [IStreamWrapper](xref:botframework-streaming.IStreamWrapper) with a Subscribable Stream.
     */ RequestDisassembler.prototype.getStream = function() {
                        var _a, _b, _c, _d;
                        return __awaiter(this, void 0, void 0, function() {
                            var payload;
                            return __generator(this, function(_e) {
                                payload = {
                                    verb: (_a = this.request) === null || _a === void 0 ? void 0 : _a.verb,
                                    path: (_b = this.request) === null || _b === void 0 ? void 0 : _b.path,
                                    streams: []
                                };
                                (_d = (_c = this.request) === null || _c === void 0 ? void 0 : _c.streams) === null || _d === void 0 || _d.forEach(function(stream) {
                                    payload.streams.push(stream.description);
                                });
                                return [
                                    2 /*return*/ ,
                                    payloadDisassembler_1.PayloadDisassembler.serialize(payload)
                                ];
                            });
                        });
                    };
                    return RequestDisassembler;
                }(payloadDisassembler_1.PayloadDisassembler);
                exports.RequestDisassembler = RequestDisassembler;
            },
            {
                "../payloads/payloadTypes": 19,
                "./payloadDisassembler": 5
            }
        ],
        7: [
            function(require, module, exports) {
                "use strict";
                var __extends = this && this.__extends || function() {
                    var extendStatics = function(d, b) {
                        extendStatics = Object.setPrototypeOf || ({
                            __proto__: []
                        }) instanceof Array && function(d, b) {
                            d.__proto__ = b;
                        } || function(d, b) {
                            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                        };
                        return extendStatics(d, b);
                    };
                    return function(d, b) {
                        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                        extendStatics(d, b);
                        function __() {
                            this.constructor = d;
                        }
                        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                    };
                }();
                var __awaiter = this && this.__awaiter || function(thisArg, _arguments, P, generator) {
                    function adopt(value) {
                        return value instanceof P ? value : new P(function(resolve) {
                            resolve(value);
                        });
                    }
                    return new (P || (P = Promise))(function(resolve, reject) {
                        function fulfilled(value) {
                            try {
                                step(generator.next(value));
                            } catch (e) {
                                reject(e);
                            }
                        }
                        function rejected(value) {
                            try {
                                step(generator["throw"](value));
                            } catch (e) {
                                reject(e);
                            }
                        }
                        function step(result) {
                            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
                        }
                        step((generator = generator.apply(thisArg, _arguments || [])).next());
                    });
                };
                var __generator = this && this.__generator || function(thisArg, body) {
                    var _ = {
                        label: 0,
                        sent: function() {
                            if (t[0] & 1) throw t[1];
                            return t[1];
                        },
                        trys: [],
                        ops: []
                    }, f, y, t, g;
                    return g = {
                        next: verb(0),
                        "throw": verb(1),
                        "return": verb(2)
                    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
                        return this;
                    }), g;
                    function verb(n) {
                        return function(v) {
                            return step([
                                n,
                                v
                            ]);
                        };
                    }
                    function step(op) {
                        if (f) throw new TypeError("Generator is already executing.");
                        while(g && (g = 0, op[0] && (_ = 0)), _)try {
                            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
                            if (y = 0, t) op = [
                                op[0] & 2,
                                t.value
                            ];
                            switch(op[0]){
                                case 0:
                                case 1:
                                    t = op;
                                    break;
                                case 4:
                                    _.label++;
                                    return {
                                        value: op[1],
                                        done: false
                                    };
                                case 5:
                                    _.label++;
                                    y = op[1];
                                    op = [
                                        0
                                    ];
                                    continue;
                                case 7:
                                    op = _.ops.pop();
                                    _.trys.pop();
                                    continue;
                                default:
                                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                                        _ = 0;
                                        continue;
                                    }
                                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                                        _.label = op[1];
                                        break;
                                    }
                                    if (op[0] === 6 && _.label < t[1]) {
                                        _.label = t[1];
                                        t = op;
                                        break;
                                    }
                                    if (t && _.label < t[2]) {
                                        _.label = t[2];
                                        _.ops.push(op);
                                        break;
                                    }
                                    if (t[2]) _.ops.pop();
                                    _.trys.pop();
                                    continue;
                            }
                            op = body.call(thisArg, _);
                        } catch (e) {
                            op = [
                                6,
                                e
                            ];
                            y = 0;
                        } finally{
                            f = t = 0;
                        }
                        if (op[0] & 5) throw op[1];
                        return {
                            value: op[0] ? op[1] : void 0,
                            done: true
                        };
                    }
                };
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.ResponseDisassembler = void 0;
                /**
 * @module botframework-streaming
 */ /**
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ var payloadTypes_1 = require("../payloads/payloadTypes");
                var payloadDisassembler_1 = require("./payloadDisassembler");
                /**
 * Streaming response disassembler.
 */ var ResponseDisassembler = /** @class */ function(_super) {
                    __extends(ResponseDisassembler, _super);
                    /**
     * Initializes a new instance of the [ResponseDisassembler](xref:botframework-streaming.ResponseDisassembler) class.
     *
     * @param sender The [PayloadSender](xref:botframework-streaming.PayloadSender) to send the disassembled data to.
     * @param id The ID of this disassembler.
     * @param response The response to be disassembled.
     */ function ResponseDisassembler(sender, id, response) {
                        var _this = _super.call(this, sender, id) || this;
                        _this.payloadType = payloadTypes_1.PayloadTypes.response;
                        _this.response = response;
                        return _this;
                    }
                    /**
     * Gets the stream this disassembler is operating on.
     *
     * @returns An [IStreamWrapper](xref:botframework-streaming.IStreamWrapper) with a Subscribable Stream.
     */ ResponseDisassembler.prototype.getStream = function() {
                        var _a;
                        return __awaiter(this, void 0, void 0, function() {
                            var payload;
                            return __generator(this, function(_b) {
                                payload = {
                                    statusCode: this.response.statusCode,
                                    streams: []
                                };
                                (_a = this.response.streams) === null || _a === void 0 || _a.forEach(function(_a) {
                                    var description = _a.description;
                                    payload.streams.push({
                                        id: description.id,
                                        contentType: description.type,
                                        length: description.length
                                    });
                                });
                                return [
                                    2 /*return*/ ,
                                    payloadDisassembler_1.PayloadDisassembler.serialize(payload)
                                ];
                            });
                        });
                    };
                    return ResponseDisassembler;
                }(payloadDisassembler_1.PayloadDisassembler);
                exports.ResponseDisassembler = ResponseDisassembler;
            },
            {
                "../payloads/payloadTypes": 19,
                "./payloadDisassembler": 5
            }
        ],
        8: [
            function(require, module, exports) {
                "use strict";
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.HttpContent = exports.HttpContentStream = void 0;
                /**
 * @module botframework-streaming
 */ /**
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ var protocol_base_1 = require("./utilities/protocol-base");
                /**
 * An attachment contained within a StreamingRequest's stream collection, which itself contains any form of media item.
 */ var HttpContentStream = /** @class */ function() {
                    /**
     * Initializes a new instance of the [HttpContentStream](xref:botframework-streaming.HttpContentStream) class.
     *
     * @param content The [HttpContent](xref:botframework-streaming.HttpContent) to assign to the [HttpContentStream](xref:botframework-streaming.HttpContentStream).
     */ function HttpContentStream(content) {
                        var _a, _b, _c, _d, _e, _f;
                        this.content = content;
                        this.id = (0, protocol_base_1.generateGuid)();
                        this.description = {
                            id: this.id,
                            type: (_c = (_b = (_a = this.content) === null || _a === void 0 ? void 0 : _a.headers) === null || _b === void 0 ? void 0 : _b.type) !== null && _c !== void 0 ? _c : "unknown",
                            length: (_f = (_e = (_d = this.content) === null || _d === void 0 ? void 0 : _d.headers) === null || _e === void 0 ? void 0 : _e.contentLength) !== null && _f !== void 0 ? _f : 0
                        };
                    }
                    return HttpContentStream;
                }();
                exports.HttpContentStream = HttpContentStream;
                /**
 * The HttpContent class that contains a [SubscribableStream](xref:botframework-streaming.SubscribableStream).
 */ var HttpContent = /** @class */ function() {
                    /**
     * Initializes a new instance of the [HttpContent](xref:botframework-streaming.HttpContent) class.
     *
     * @param headers The Streaming Http content header definition.
     * @param stream The stream of buffered data.
     */ function HttpContent(headers, stream) {
                        this.headers = headers;
                        this.stream = stream;
                    }
                    /**
     * Gets the data contained within this [HttpContent](xref:botframework-streaming.HttpContent).
     *
     * @returns This [HttpContent's](xref:botframework-streaming.HttpContent) [SubscribableStream](xref:botframework-streaming.SubscribableStream) member.
     */ HttpContent.prototype.getStream = function() {
                        return this.stream;
                    };
                    return HttpContent;
                }();
                exports.HttpContent = HttpContent;
            },
            {
                "./utilities/protocol-base": 28
            }
        ],
        9: [
            function(require, module, exports) {
                "use strict";
                /**
 * @module botframework-streaming
 */ /**
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.WebSocketClient = exports.BrowserWebSocket = exports.SubscribableStream = exports.StreamingResponse = exports.StreamingRequest = exports.RequestHandler = exports.HttpContent = exports.ContentStream = void 0;
                var contentStream_1 = require("./contentStream");
                Object.defineProperty(exports, "ContentStream", {
                    enumerable: true,
                    get: function() {
                        return contentStream_1.ContentStream;
                    }
                });
                var httpContentStream_1 = require("./httpContentStream");
                Object.defineProperty(exports, "HttpContent", {
                    enumerable: true,
                    get: function() {
                        return httpContentStream_1.HttpContent;
                    }
                });
                var requestHandler_1 = require("./requestHandler");
                Object.defineProperty(exports, "RequestHandler", {
                    enumerable: true,
                    get: function() {
                        return requestHandler_1.RequestHandler;
                    }
                });
                var streamingRequest_1 = require("./streamingRequest");
                Object.defineProperty(exports, "StreamingRequest", {
                    enumerable: true,
                    get: function() {
                        return streamingRequest_1.StreamingRequest;
                    }
                });
                var streamingResponse_1 = require("./streamingResponse");
                Object.defineProperty(exports, "StreamingResponse", {
                    enumerable: true,
                    get: function() {
                        return streamingResponse_1.StreamingResponse;
                    }
                });
                var subscribableStream_1 = require("./subscribableStream");
                Object.defineProperty(exports, "SubscribableStream", {
                    enumerable: true,
                    get: function() {
                        return subscribableStream_1.SubscribableStream;
                    }
                });
                var index_browser_1 = require("./webSocket/index-browser");
                Object.defineProperty(exports, "BrowserWebSocket", {
                    enumerable: true,
                    get: function() {
                        return index_browser_1.BrowserWebSocket;
                    }
                });
                Object.defineProperty(exports, "WebSocketClient", {
                    enumerable: true,
                    get: function() {
                        return index_browser_1.WebSocketClient;
                    }
                });
            },
            {
                "./contentStream": 2,
                "./httpContentStream": 8,
                "./requestHandler": 24,
                "./streamingRequest": 25,
                "./streamingResponse": 26,
                "./subscribableStream": 27,
                "./webSocket/index-browser": 31
            }
        ],
        10: [
            function(require, module, exports) {
                "use strict";
                /**
 * @module botframework-streaming
 */ /**
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ var __createBinding = this && this.__createBinding || (Object.create ? function(o, m, k, k2) {
                    if (k2 === undefined) k2 = k;
                    var desc = Object.getOwnPropertyDescriptor(m, k);
                    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
                        enumerable: true,
                        get: function() {
                            return m[k];
                        }
                    };
                    Object.defineProperty(o, k2, desc);
                } : function(o, m, k, k2) {
                    if (k2 === undefined) k2 = k;
                    o[k2] = m[k];
                });
                var __exportStar = this && this.__exportStar || function(m, exports) {
                    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
                };
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                __exportStar(require("./payloadReceiver"), exports);
                __exportStar(require("./payloadSender"), exports);
                __exportStar(require("./transportDisconnectedEvent"), exports);
                __exportStar(require("./transportDisconnectedEventHandler"), exports);
            },
            {
                "./payloadReceiver": 11,
                "./payloadSender": 12,
                "./transportDisconnectedEvent": 13,
                "./transportDisconnectedEventHandler": 14
            }
        ],
        11: [
            function(require, module, exports) {
                "use strict";
                var __awaiter = this && this.__awaiter || function(thisArg, _arguments, P, generator) {
                    function adopt(value) {
                        return value instanceof P ? value : new P(function(resolve) {
                            resolve(value);
                        });
                    }
                    return new (P || (P = Promise))(function(resolve, reject) {
                        function fulfilled(value) {
                            try {
                                step(generator.next(value));
                            } catch (e) {
                                reject(e);
                            }
                        }
                        function rejected(value) {
                            try {
                                step(generator["throw"](value));
                            } catch (e) {
                                reject(e);
                            }
                        }
                        function step(result) {
                            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
                        }
                        step((generator = generator.apply(thisArg, _arguments || [])).next());
                    });
                };
                var __generator = this && this.__generator || function(thisArg, body) {
                    var _ = {
                        label: 0,
                        sent: function() {
                            if (t[0] & 1) throw t[1];
                            return t[1];
                        },
                        trys: [],
                        ops: []
                    }, f, y, t, g;
                    return g = {
                        next: verb(0),
                        "throw": verb(1),
                        "return": verb(2)
                    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
                        return this;
                    }), g;
                    function verb(n) {
                        return function(v) {
                            return step([
                                n,
                                v
                            ]);
                        };
                    }
                    function step(op) {
                        if (f) throw new TypeError("Generator is already executing.");
                        while(g && (g = 0, op[0] && (_ = 0)), _)try {
                            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
                            if (y = 0, t) op = [
                                op[0] & 2,
                                t.value
                            ];
                            switch(op[0]){
                                case 0:
                                case 1:
                                    t = op;
                                    break;
                                case 4:
                                    _.label++;
                                    return {
                                        value: op[1],
                                        done: false
                                    };
                                case 5:
                                    _.label++;
                                    y = op[1];
                                    op = [
                                        0
                                    ];
                                    continue;
                                case 7:
                                    op = _.ops.pop();
                                    _.trys.pop();
                                    continue;
                                default:
                                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                                        _ = 0;
                                        continue;
                                    }
                                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                                        _.label = op[1];
                                        break;
                                    }
                                    if (op[0] === 6 && _.label < t[1]) {
                                        _.label = t[1];
                                        t = op;
                                        break;
                                    }
                                    if (t && _.label < t[2]) {
                                        _.label = t[2];
                                        _.ops.push(op);
                                        break;
                                    }
                                    if (t[2]) _.ops.pop();
                                    _.trys.pop();
                                    continue;
                            }
                            op = body.call(thisArg, _);
                        } catch (e) {
                            op = [
                                6,
                                e
                            ];
                            y = 0;
                        } finally{
                            f = t = 0;
                        }
                        if (op[0] & 5) throw op[1];
                        return {
                            value: op[0] ? op[1] : void 0,
                            done: true
                        };
                    }
                };
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.PayloadReceiver = void 0;
                var payloadTypes_1 = require("../payloads/payloadTypes");
                var headerSerializer_1 = require("../payloads/headerSerializer");
                var payloadConstants_1 = require("../payloads/payloadConstants");
                var transportDisconnectedEvent_1 = require("./transportDisconnectedEvent");
                /**
 * Payload receiver for streaming.
 */ var PayloadReceiver = /** @class */ function() {
                    function PayloadReceiver() {}
                    Object.defineProperty(PayloadReceiver.prototype, "isConnected", {
                        /**
         * Get current connected state
         *
         * @returns true if connected to a transport sender.
         */ get: function() {
                            return this._receiver != null;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    /**
     * Connects to a transport receiver
     *
     * @param receiver The [ITransportReceiver](xref:botframework-streaming.ITransportReceiver) object to pull incoming data from.
     * @returns a promise that resolves when the receiver is complete
     */ PayloadReceiver.prototype.connect = function(receiver) {
                        this._receiver = receiver;
                        return this.receivePackets();
                    };
                    /**
     * Allows subscribing to this receiver in order to be notified when new data comes in.
     *
     * @param getStream Callback when a new stream has been received.
     * @param receiveAction Callback when a new message has been received.
     */ PayloadReceiver.prototype.subscribe = function(getStream, receiveAction) {
                        this._getStream = getStream;
                        this._receiveAction = receiveAction;
                    };
                    /**
     * Force this receiver to disconnect.
     *
     * @param event Event arguments to include when broadcasting disconnection event.
     */ PayloadReceiver.prototype.disconnect = function(event) {
                        var _a, _b;
                        if (event === void 0) event = transportDisconnectedEvent_1.TransportDisconnectedEvent.Empty;
                        if (!this.isConnected) return;
                        try {
                            this._receiver.close();
                            (_a = this.disconnected) === null || _a === void 0 || _a.call(this, this, event);
                        } catch (err) {
                            (_b = this.disconnected) === null || _b === void 0 || _b.call(this, this, new transportDisconnectedEvent_1.TransportDisconnectedEvent(err.message));
                        } finally{
                            this._receiver = null;
                        }
                    };
                    PayloadReceiver.prototype.receivePackets = function() {
                        return __awaiter(this, void 0, void 0, function() {
                            var readSoFar, _a, header, isStream, bytesActuallyRead, contentStream, count, _b, err_1;
                            return __generator(this, function(_c) {
                                switch(_c.label){
                                    case 0:
                                        if (!this.isConnected) return [
                                            3 /*break*/ ,
                                            11
                                        ];
                                        _c.label = 1;
                                    case 1:
                                        _c.trys.push([
                                            1,
                                            9,
                                            ,
                                            10
                                        ]);
                                        readSoFar = 0;
                                        _c.label = 2;
                                    case 2:
                                        if (!(readSoFar < payloadConstants_1.PayloadConstants.MaxHeaderLength)) return [
                                            3 /*break*/ ,
                                            4
                                        ];
                                        _a = this;
                                        return [
                                            4 /*yield*/ ,
                                            this._receiver.receive(payloadConstants_1.PayloadConstants.MaxHeaderLength - readSoFar)
                                        ];
                                    case 3:
                                        _a._receiveHeaderBuffer = _c.sent();
                                        if (this._receiveHeaderBuffer) readSoFar += this._receiveHeaderBuffer.length;
                                        return [
                                            3 /*break*/ ,
                                            2
                                        ];
                                    case 4:
                                        header = headerSerializer_1.HeaderSerializer.deserialize(this._receiveHeaderBuffer);
                                        isStream = header.payloadType === payloadTypes_1.PayloadTypes.stream;
                                        if (!(header.payloadLength > 0)) return [
                                            3 /*break*/ ,
                                            8
                                        ];
                                        bytesActuallyRead = 0;
                                        contentStream = this._getStream(header);
                                        _c.label = 5;
                                    case 5:
                                        if (!(bytesActuallyRead < header.payloadLength && bytesActuallyRead < payloadConstants_1.PayloadConstants.MaxPayloadLength)) return [
                                            3 /*break*/ ,
                                            7
                                        ];
                                        count = Math.min(header.payloadLength - bytesActuallyRead, payloadConstants_1.PayloadConstants.MaxPayloadLength);
                                        _b = this;
                                        return [
                                            4 /*yield*/ ,
                                            this._receiver.receive(count)
                                        ];
                                    case 6:
                                        _b._receivePayloadBuffer = _c.sent();
                                        bytesActuallyRead += this._receivePayloadBuffer.byteLength;
                                        contentStream.write(this._receivePayloadBuffer);
                                        // If this is a stream we want to keep handing it up as it comes in
                                        if (isStream) this._receiveAction(header, contentStream, bytesActuallyRead);
                                        return [
                                            3 /*break*/ ,
                                            5
                                        ];
                                    case 7:
                                        if (!isStream) this._receiveAction(header, contentStream, bytesActuallyRead);
                                        _c.label = 8;
                                    case 8:
                                        return [
                                            3 /*break*/ ,
                                            10
                                        ];
                                    case 9:
                                        err_1 = _c.sent();
                                        this.disconnect(new transportDisconnectedEvent_1.TransportDisconnectedEvent(err_1.message));
                                        return [
                                            3 /*break*/ ,
                                            10
                                        ];
                                    case 10:
                                        return [
                                            3 /*break*/ ,
                                            0
                                        ];
                                    case 11:
                                        return [
                                            2 /*return*/ 
                                        ];
                                }
                            });
                        });
                    };
                    return PayloadReceiver;
                }();
                exports.PayloadReceiver = PayloadReceiver;
            },
            {
                "../payloads/headerSerializer": 15,
                "../payloads/payloadConstants": 18,
                "../payloads/payloadTypes": 19,
                "./transportDisconnectedEvent": 13
            }
        ],
        12: [
            function(require, module, exports) {
                (function(Buffer) {
                    (function() {
                        "use strict";
                        /**
 * @module botframework-streaming
 */ /**
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ Object.defineProperty(exports, "__esModule", {
                            value: true
                        });
                        exports.PayloadSender = void 0;
                        var headerSerializer_1 = require("../payloads/headerSerializer");
                        var payloadConstants_1 = require("../payloads/payloadConstants");
                        var transportDisconnectedEvent_1 = require("./transportDisconnectedEvent");
                        /**
 * Streaming payload sender.
 */ var PayloadSender = /** @class */ function() {
                            function PayloadSender() {}
                            Object.defineProperty(PayloadSender.prototype, "isConnected", {
                                /**
         * Get current connected state
         *
         * @returns true if connected to a transport sender.
         */ get: function() {
                                    return this._sender != null;
                                },
                                enumerable: false,
                                configurable: true
                            });
                            /**
     * Connects to the given transport sender.
     *
     * @param sender The transport sender to connect this payload sender to.
     */ PayloadSender.prototype.connect = function(sender) {
                                this._sender = sender;
                            };
                            /**
     * Sends a payload out over the connected transport sender.
     *
     * @param header The header to attach to the outgoing payload.
     * @param payload The stream of buffered data to send.
     * @param sentCallback The function to execute when the send has completed.
     */ PayloadSender.prototype.sendPayload = function(header, payload, sentCallback) {
                                var packet = {
                                    header: header,
                                    payload: payload,
                                    sentCallback: sentCallback
                                };
                                this.writePacket(packet);
                            };
                            /**
     * Disconnects this payload sender.
     *
     * @param event The disconnected event arguments to include in the disconnected event broadcast.
     */ PayloadSender.prototype.disconnect = function(event) {
                                var _a, _b;
                                if (event === void 0) event = transportDisconnectedEvent_1.TransportDisconnectedEvent.Empty;
                                if (!this.isConnected) return;
                                try {
                                    this._sender.close();
                                    (_a = this.disconnected) === null || _a === void 0 || _a.call(this, this, event);
                                } catch (err) {
                                    (_b = this.disconnected) === null || _b === void 0 || _b.call(this, this, new transportDisconnectedEvent_1.TransportDisconnectedEvent(err.message));
                                } finally{
                                    this._sender = null;
                                }
                            };
                            PayloadSender.prototype.writePacket = function(packet) {
                                try {
                                    if (packet.header.payloadLength > 0 && packet.payload) {
                                        var leftOver = packet.header.payloadLength;
                                        while(leftOver > 0){
                                            var count = leftOver <= payloadConstants_1.PayloadConstants.MaxPayloadLength ? leftOver : payloadConstants_1.PayloadConstants.MaxPayloadLength;
                                            var chunk = packet.payload.read(count);
                                            var header = packet.header;
                                            header.payloadLength = count;
                                            header.end = leftOver <= payloadConstants_1.PayloadConstants.MaxPayloadLength;
                                            var sendHeaderBuffer = Buffer.alloc(payloadConstants_1.PayloadConstants.MaxHeaderLength);
                                            headerSerializer_1.HeaderSerializer.serialize(header, sendHeaderBuffer);
                                            this._sender.send(sendHeaderBuffer);
                                            this._sender.send(chunk);
                                            leftOver -= chunk.length;
                                        }
                                        if (packet.sentCallback) packet.sentCallback();
                                    }
                                } catch (err) {
                                    this.disconnect(new transportDisconnectedEvent_1.TransportDisconnectedEvent(err.message));
                                }
                            };
                            return PayloadSender;
                        }();
                        exports.PayloadSender = PayloadSender;
                    }).call(this);
                }).call(this, require("buffer").Buffer);
            },
            {
                "../payloads/headerSerializer": 15,
                "../payloads/payloadConstants": 18,
                "./transportDisconnectedEvent": 13,
                "buffer": 35
            }
        ],
        13: [
            function(require, module, exports) {
                "use strict";
                /**
 * @module botframework-streaming
 */ /**
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.TransportDisconnectedEvent = void 0;
                /**
 * Event to be included when disconnection events are fired.
 */ var TransportDisconnectedEvent = /** @class */ function() {
                    /**
     * Indicates a transport disconnected with the reason provided via the constructor.
     *
     * @remarks
     * This class is used for communicating disconnection events between the
     * PayloadReceiver and PayloadSender.
     * @param reason The reason the disconnection event fired, in plain text.
     */ function TransportDisconnectedEvent(reason) {
                        this.reason = reason;
                    }
                    /**
     * A new and empty TransportDisconnectedEvent.
     */ TransportDisconnectedEvent.Empty = new TransportDisconnectedEvent();
                    return TransportDisconnectedEvent;
                }();
                exports.TransportDisconnectedEvent = TransportDisconnectedEvent;
            },
            {}
        ],
        14: [
            function(require, module, exports) {
                "use strict";
                /**
 * @module botframework-streaming
 */ /**
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ Object.defineProperty(exports, "__esModule", {
                    value: true
                });
            },
            {}
        ],
        15: [
            function(require, module, exports) {
                "use strict";
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.HeaderSerializer = void 0;
                var payloadConstants_1 = require("./payloadConstants");
                /**
 * Streaming header serializer
 */ var HeaderSerializer = /** @class */ function() {
                    function HeaderSerializer() {}
                    /**
     * Serializes the header into a buffer
     *
     * @param header The header to serialize.
     * @param buffer The buffer into which to serialize the header.
     */ HeaderSerializer.serialize = function(header, buffer) {
                        buffer.write(header.payloadType, this.TypeOffset, 1, this.Encoding);
                        buffer.write(this.Delimiter, this.TypeDelimiterOffset, 1, this.Encoding);
                        buffer.write(this.headerLengthPadder(header.payloadLength, this.LengthLength, "0"), this.LengthOffset, this.LengthLength, this.Encoding);
                        buffer.write(this.Delimiter, this.LengthDelimeterOffset, 1, this.Encoding);
                        buffer.write(header.id, this.IdOffset);
                        buffer.write(this.Delimiter, this.IdDelimeterOffset, 1, this.Encoding);
                        buffer.write(header.end ? this.End : this.NotEnd, this.EndOffset);
                        buffer.write(this.Terminator, this.TerminatorOffset);
                    };
                    /**
     * Deserializes a buffer containing header information.
     *
     * @param buffer The buffer from which to obtain the data to deserialize.
     * @returns The deserialized header from the buffer.
     */ HeaderSerializer.deserialize = function(buffer) {
                        var jsonBuffer = buffer.toString(this.Encoding);
                        var headerArray = jsonBuffer.split(this.Delimiter);
                        if (headerArray.length !== 4) throw Error("Cannot parse header, header is malformed. Header: ".concat(jsonBuffer));
                        var payloadType = headerArray[0], length = headerArray[1], id = headerArray[2], headerEnd = headerArray[3];
                        var end = headerEnd === "1\n";
                        var payloadLength = Number(length);
                        var header = {
                            end: end,
                            payloadLength: payloadLength,
                            payloadType: payloadType,
                            id: id
                        };
                        if (!(header.payloadLength <= payloadConstants_1.PayloadConstants.MaxPayloadLength && header.payloadLength >= payloadConstants_1.PayloadConstants.MinLength)) throw Error("Header length of ".concat(header.payloadLength, " is missing or malformed"));
                        if (header.payloadType.length !== this.TypeDelimiterOffset) throw Error("Header type '".concat(header.payloadType.length, "' is missing or malformed."));
                        if (!header.id || !header.id.match(/^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i) || header.id.length !== this.IdLength) throw Error("Header ID '".concat(header.id, "' is missing or malformed."));
                        if (!(headerEnd === "0\n" || headerEnd === "1\n")) throw Error("Header End is missing or not a valid value. Header end: '".concat(headerEnd, "'"));
                        return header;
                    };
                    /**
     * Creates a padded string based on a length and character to be padded to.
     *
     * @param lengthValue The value to be assingned on the result.
     * @param totalLength The length of the padded string result.
     * @param padChar The character value to use as filling.
     * @returns The padded string.
     */ HeaderSerializer.headerLengthPadder = function(lengthValue, totalLength, padChar) {
                        var result = Array(totalLength + 1).join(padChar);
                        var lengthString = lengthValue.toString();
                        return (result + lengthString).slice(lengthString.length);
                    };
                    HeaderSerializer.Delimiter = ".";
                    HeaderSerializer.Terminator = "\n";
                    HeaderSerializer.End = "1";
                    HeaderSerializer.NotEnd = "0";
                    HeaderSerializer.TypeOffset = 0;
                    HeaderSerializer.TypeDelimiterOffset = 1;
                    HeaderSerializer.LengthOffset = 2;
                    HeaderSerializer.LengthLength = 6;
                    HeaderSerializer.LengthDelimeterOffset = 8;
                    HeaderSerializer.IdOffset = 9;
                    HeaderSerializer.IdLength = 36;
                    HeaderSerializer.IdDelimeterOffset = 45;
                    HeaderSerializer.EndOffset = 46;
                    HeaderSerializer.TerminatorOffset = 47;
                    HeaderSerializer.Encoding = "utf8";
                    return HeaderSerializer;
                }();
                exports.HeaderSerializer = HeaderSerializer;
            },
            {
                "./payloadConstants": 18
            }
        ],
        16: [
            function(require, module, exports) {
                "use strict";
                /**
 * @module botframework-streaming
 */ /**
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ var __createBinding = this && this.__createBinding || (Object.create ? function(o, m, k, k2) {
                    if (k2 === undefined) k2 = k;
                    var desc = Object.getOwnPropertyDescriptor(m, k);
                    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
                        enumerable: true,
                        get: function() {
                            return m[k];
                        }
                    };
                    Object.defineProperty(o, k2, desc);
                } : function(o, m, k, k2) {
                    if (k2 === undefined) k2 = k;
                    o[k2] = m[k];
                });
                var __exportStar = this && this.__exportStar || function(m, exports) {
                    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
                };
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                __exportStar(require("./headerSerializer"), exports);
                __exportStar(require("./streamManager"), exports);
                __exportStar(require("./payloadAssemblerManager"), exports);
                __exportStar(require("./payloadTypes"), exports);
                __exportStar(require("./requestManager"), exports);
                __exportStar(require("./sendOperations"), exports);
                __exportStar(require("./streamManager"), exports);
            },
            {
                "./headerSerializer": 15,
                "./payloadAssemblerManager": 17,
                "./payloadTypes": 19,
                "./requestManager": 20,
                "./sendOperations": 21,
                "./streamManager": 22
            }
        ],
        17: [
            function(require, module, exports) {
                "use strict";
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.PayloadAssemblerManager = void 0;
                var payloadAssembler_1 = require("../assemblers/payloadAssembler");
                var payloadTypes_1 = require("./payloadTypes");
                /**
 * Orchestrates assembly of payloads.
 */ var PayloadAssemblerManager = /** @class */ function() {
                    /**
     * Initializes a new instance of the [PayloadAssemblerManager](xref:botframework-streaming.PayloadAssemblerManager) class.
     *
     * @param streamManager The [StreamManager](xref:botframework-streaming.StreamManager) managing the stream being assembled.
     * @param onReceiveResponse Function that executes when new bytes are received on a `response` stream.
     * @param onReceiveRequest Function that executes when new bytes are received on a `request` stream.
     */ function PayloadAssemblerManager(streamManager, onReceiveResponse, onReceiveRequest) {
                        this.streamManager = streamManager;
                        this.onReceiveResponse = onReceiveResponse;
                        this.onReceiveRequest = onReceiveRequest;
                        this.activeAssemblers = {};
                    }
                    /**
     * Retrieves the assembler's payload as a stream.
     *
     * @param header The Header of the Stream to retrieve.
     * @returns A [SubscribableStream](xref:botframework-streaming.SubscribableStream) of the assembler's payload.
     */ PayloadAssemblerManager.prototype.getPayloadStream = function(header) {
                        if (header.payloadType === payloadTypes_1.PayloadTypes.stream) return this.streamManager.getPayloadStream(header);
                        else if (!this.activeAssemblers[header.id]) {
                            var assembler = this.createPayloadAssembler(header);
                            if (assembler) {
                                this.activeAssemblers[header.id] = assembler;
                                return assembler.getPayloadStream();
                            }
                        }
                    };
                    /**
     * The action the assembler executes when new bytes are received on the incoming stream.
     *
     * @param header The stream's Header.
     * @param contentStream The incoming stream being assembled.
     * @param contentLength The length of the stream, if finite.
     */ PayloadAssemblerManager.prototype.onReceive = function(header, contentStream, contentLength) {
                        if (header.payloadType === payloadTypes_1.PayloadTypes.stream) this.streamManager.onReceive(header, contentStream, contentLength);
                        else {
                            if (this.activeAssemblers && this.activeAssemblers[header.id]) {
                                var assembler = this.activeAssemblers[header.id];
                                assembler.onReceive(header, contentStream, contentLength);
                            }
                            if (header.end) delete this.activeAssemblers[header.id];
                        }
                    };
                    PayloadAssemblerManager.prototype.createPayloadAssembler = function(header) {
                        if (header.payloadType === payloadTypes_1.PayloadTypes.request) return new payloadAssembler_1.PayloadAssembler(this.streamManager, {
                            header: header,
                            onCompleted: this.onReceiveRequest
                        });
                        else if (header.payloadType === payloadTypes_1.PayloadTypes.response) return new payloadAssembler_1.PayloadAssembler(this.streamManager, {
                            header: header,
                            onCompleted: this.onReceiveResponse
                        });
                    };
                    return PayloadAssemblerManager;
                }();
                exports.PayloadAssemblerManager = PayloadAssemblerManager;
            },
            {
                "../assemblers/payloadAssembler": 1,
                "./payloadTypes": 19
            }
        ],
        18: [
            function(require, module, exports) {
                "use strict";
                /**
 * @module botframework-streaming
 */ /**
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.PayloadConstants = void 0;
                /**
 * Constants for streaming payloads.
 */ var PayloadConstants;
                (function(PayloadConstants) {
                    PayloadConstants[PayloadConstants["MaxPayloadLength"] = 4096] = "MaxPayloadLength";
                    PayloadConstants[PayloadConstants["MaxHeaderLength"] = 48] = "MaxHeaderLength";
                    PayloadConstants[PayloadConstants["MaxLength"] = 999999] = "MaxLength";
                    PayloadConstants[PayloadConstants["MinLength"] = 0] = "MinLength";
                })(PayloadConstants = exports.PayloadConstants || (exports.PayloadConstants = {}));
            },
            {}
        ],
        19: [
            function(require, module, exports) {
                "use strict";
                /**
 * @module botframework-streaming
 */ /**
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.PayloadTypes = void 0;
                /**
 * Typess of payloads supported in the streaming library.
 */ var PayloadTypes;
                (function(PayloadTypes) {
                    PayloadTypes["request"] = "A";
                    PayloadTypes["response"] = "B";
                    PayloadTypes["stream"] = "S";
                    PayloadTypes["cancelAll"] = "X";
                    PayloadTypes["cancelStream"] = "C";
                })(PayloadTypes = exports.PayloadTypes || (exports.PayloadTypes = {}));
            },
            {}
        ],
        20: [
            function(require, module, exports) {
                "use strict";
                var __awaiter = this && this.__awaiter || function(thisArg, _arguments, P, generator) {
                    function adopt(value) {
                        return value instanceof P ? value : new P(function(resolve) {
                            resolve(value);
                        });
                    }
                    return new (P || (P = Promise))(function(resolve, reject) {
                        function fulfilled(value) {
                            try {
                                step(generator.next(value));
                            } catch (e) {
                                reject(e);
                            }
                        }
                        function rejected(value) {
                            try {
                                step(generator["throw"](value));
                            } catch (e) {
                                reject(e);
                            }
                        }
                        function step(result) {
                            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
                        }
                        step((generator = generator.apply(thisArg, _arguments || [])).next());
                    });
                };
                var __generator = this && this.__generator || function(thisArg, body) {
                    var _ = {
                        label: 0,
                        sent: function() {
                            if (t[0] & 1) throw t[1];
                            return t[1];
                        },
                        trys: [],
                        ops: []
                    }, f, y, t, g;
                    return g = {
                        next: verb(0),
                        "throw": verb(1),
                        "return": verb(2)
                    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
                        return this;
                    }), g;
                    function verb(n) {
                        return function(v) {
                            return step([
                                n,
                                v
                            ]);
                        };
                    }
                    function step(op) {
                        if (f) throw new TypeError("Generator is already executing.");
                        while(g && (g = 0, op[0] && (_ = 0)), _)try {
                            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
                            if (y = 0, t) op = [
                                op[0] & 2,
                                t.value
                            ];
                            switch(op[0]){
                                case 0:
                                case 1:
                                    t = op;
                                    break;
                                case 4:
                                    _.label++;
                                    return {
                                        value: op[1],
                                        done: false
                                    };
                                case 5:
                                    _.label++;
                                    y = op[1];
                                    op = [
                                        0
                                    ];
                                    continue;
                                case 7:
                                    op = _.ops.pop();
                                    _.trys.pop();
                                    continue;
                                default:
                                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                                        _ = 0;
                                        continue;
                                    }
                                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                                        _.label = op[1];
                                        break;
                                    }
                                    if (op[0] === 6 && _.label < t[1]) {
                                        _.label = t[1];
                                        t = op;
                                        break;
                                    }
                                    if (t && _.label < t[2]) {
                                        _.label = t[2];
                                        _.ops.push(op);
                                        break;
                                    }
                                    if (t[2]) _.ops.pop();
                                    _.trys.pop();
                                    continue;
                            }
                            op = body.call(thisArg, _);
                        } catch (e) {
                            op = [
                                6,
                                e
                            ];
                            y = 0;
                        } finally{
                            f = t = 0;
                        }
                        if (op[0] & 5) throw op[1];
                        return {
                            value: op[0] ? op[1] : void 0,
                            done: true
                        };
                    }
                };
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.RequestManager = void 0;
                /**
 * A streaming pending request.
 */ var PendingRequest = /** @class */ function() {
                    function PendingRequest() {}
                    return PendingRequest;
                }();
                /**
 * Orchestrates and manages pending streaming requests.
 */ var RequestManager = /** @class */ function() {
                    function RequestManager() {
                        this._pendingRequests = {};
                    }
                    /**
     * Gets the count of the pending requests.
     *
     * @returns Number with the pending requests count.
     */ RequestManager.prototype.pendingRequestCount = function() {
                        return Object.keys(this._pendingRequests).length;
                    };
                    /**
     * Signal fired when all response tasks have completed.
     *
     * @param requestId The ID of the StreamingRequest.
     * @param response The [IReceiveResponse](xref:botframework-streaming.IReceiveResponse) in response to the request.
     * @returns A Promise that when completed returns `true` if the `requestId`'s pending response task was completed, otherwise `false`.
     */ RequestManager.prototype.signalResponse = function(requestId, response) {
                        return __awaiter(this, void 0, void 0, function() {
                            var pendingRequest;
                            return __generator(this, function(_a) {
                                pendingRequest = this._pendingRequests[requestId];
                                if (pendingRequest) {
                                    pendingRequest.resolve(response);
                                    delete this._pendingRequests[requestId];
                                    return [
                                        2 /*return*/ ,
                                        true
                                    ];
                                }
                                return [
                                    2 /*return*/ ,
                                    false
                                ];
                            });
                        });
                    };
                    /**
     * Constructs and returns a response for this request.
     *
     * @param requestId The ID of the StreamingRequest being responded to.
     * @returns The response to the specified request.
     */ RequestManager.prototype.getResponse = function(requestId) {
                        var pendingRequest = this._pendingRequests[requestId];
                        if (pendingRequest) return Promise.reject("requestId '".concat(requestId, "' already exists in RequestManager"));
                        pendingRequest = new PendingRequest();
                        pendingRequest.requestId = requestId;
                        var promise = new Promise(function(resolve, reject) {
                            pendingRequest.resolve = resolve;
                            pendingRequest.reject = reject;
                        });
                        this._pendingRequests[requestId] = pendingRequest;
                        return promise;
                    };
                    /**
     * Rejects all requests pending a response.
     *
     * @param reason The reason for rejection.
     */ RequestManager.prototype.rejectAllResponses = function(reason) {
                        var _this = this;
                        Object.entries(this._pendingRequests).forEach(function(_a) {
                            var requestId = _a[0], reject = _a[1].reject;
                            reject(reason);
                            delete _this._pendingRequests[requestId];
                        });
                    };
                    return RequestManager;
                }();
                exports.RequestManager = RequestManager;
            },
            {}
        ],
        21: [
            function(require, module, exports) {
                "use strict";
                var __awaiter = this && this.__awaiter || function(thisArg, _arguments, P, generator) {
                    function adopt(value) {
                        return value instanceof P ? value : new P(function(resolve) {
                            resolve(value);
                        });
                    }
                    return new (P || (P = Promise))(function(resolve, reject) {
                        function fulfilled(value) {
                            try {
                                step(generator.next(value));
                            } catch (e) {
                                reject(e);
                            }
                        }
                        function rejected(value) {
                            try {
                                step(generator["throw"](value));
                            } catch (e) {
                                reject(e);
                            }
                        }
                        function step(result) {
                            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
                        }
                        step((generator = generator.apply(thisArg, _arguments || [])).next());
                    });
                };
                var __generator = this && this.__generator || function(thisArg, body) {
                    var _ = {
                        label: 0,
                        sent: function() {
                            if (t[0] & 1) throw t[1];
                            return t[1];
                        },
                        trys: [],
                        ops: []
                    }, f, y, t, g;
                    return g = {
                        next: verb(0),
                        "throw": verb(1),
                        "return": verb(2)
                    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
                        return this;
                    }), g;
                    function verb(n) {
                        return function(v) {
                            return step([
                                n,
                                v
                            ]);
                        };
                    }
                    function step(op) {
                        if (f) throw new TypeError("Generator is already executing.");
                        while(g && (g = 0, op[0] && (_ = 0)), _)try {
                            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
                            if (y = 0, t) op = [
                                op[0] & 2,
                                t.value
                            ];
                            switch(op[0]){
                                case 0:
                                case 1:
                                    t = op;
                                    break;
                                case 4:
                                    _.label++;
                                    return {
                                        value: op[1],
                                        done: false
                                    };
                                case 5:
                                    _.label++;
                                    y = op[1];
                                    op = [
                                        0
                                    ];
                                    continue;
                                case 7:
                                    op = _.ops.pop();
                                    _.trys.pop();
                                    continue;
                                default:
                                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                                        _ = 0;
                                        continue;
                                    }
                                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                                        _.label = op[1];
                                        break;
                                    }
                                    if (op[0] === 6 && _.label < t[1]) {
                                        _.label = t[1];
                                        t = op;
                                        break;
                                    }
                                    if (t && _.label < t[2]) {
                                        _.label = t[2];
                                        _.ops.push(op);
                                        break;
                                    }
                                    if (t[2]) _.ops.pop();
                                    _.trys.pop();
                                    continue;
                            }
                            op = body.call(thisArg, _);
                        } catch (e) {
                            op = [
                                6,
                                e
                            ];
                            y = 0;
                        } finally{
                            f = t = 0;
                        }
                        if (op[0] & 5) throw op[1];
                        return {
                            value: op[0] ? op[1] : void 0,
                            done: true
                        };
                    }
                };
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.SendOperations = void 0;
                var cancelDisassembler_1 = require("../disassemblers/cancelDisassembler");
                var httpContentStreamDisassembler_1 = require("../disassemblers/httpContentStreamDisassembler");
                var requestDisassembler_1 = require("../disassemblers/requestDisassembler");
                var responseDisassembler_1 = require("../disassemblers/responseDisassembler");
                var payloadTypes_1 = require("./payloadTypes");
                /**
 * Send operations for streaming payloads.
 */ var SendOperations = /** @class */ function() {
                    /**
     * Initializes a new instance of the [SendOperations](xref:botframework-streaming.SendOperations) class.
     *
     * @param payloadSender The [PayloadSender](xref:botframework-streaming.PayloadSender) that will send the disassembled data from all of this instance's send operations.
     */ function SendOperations(payloadSender) {
                        this.payloadSender = payloadSender;
                    }
                    /**
     * The send operation used to send a [StreamingRequest](xref:botframework-streaming.StreamingRequest).
     *
     * @param id The ID to assign to the [RequestDisassembler](xref:botframework-streaming.RequestDisassembler) used by this operation.
     * @param request The request to send.
     */ SendOperations.prototype.sendRequest = function(id, request) {
                        return __awaiter(this, void 0, void 0, function() {
                            var disassembler;
                            var _this = this;
                            return __generator(this, function(_a) {
                                switch(_a.label){
                                    case 0:
                                        disassembler = new requestDisassembler_1.RequestDisassembler(this.payloadSender, id, request);
                                        return [
                                            4 /*yield*/ ,
                                            disassembler.disassemble()
                                        ];
                                    case 1:
                                        _a.sent();
                                        if (request.streams) request.streams.forEach(function(contentStream) {
                                            return __awaiter(_this, void 0, void 0, function() {
                                                return __generator(this, function(_a) {
                                                    switch(_a.label){
                                                        case 0:
                                                            return [
                                                                4 /*yield*/ ,
                                                                new httpContentStreamDisassembler_1.HttpContentStreamDisassembler(this.payloadSender, contentStream).disassemble()
                                                            ];
                                                        case 1:
                                                            _a.sent();
                                                            return [
                                                                2 /*return*/ 
                                                            ];
                                                    }
                                                });
                                            });
                                        });
                                        return [
                                            2 /*return*/ 
                                        ];
                                }
                            });
                        });
                    };
                    /**
     * The send operation used to send a [PayloadTypes.response](xref:botframework-streaming.PayloadTypes.response).
     *
     * @param id The ID to assign to the [ResponseDisassembler](xref:botframework-streaming.ResponseDisassembler) used by this operation.
     * @param response The response to send.
     */ SendOperations.prototype.sendResponse = function(id, response) {
                        return __awaiter(this, void 0, void 0, function() {
                            var disassembler;
                            var _this = this;
                            return __generator(this, function(_a) {
                                switch(_a.label){
                                    case 0:
                                        disassembler = new responseDisassembler_1.ResponseDisassembler(this.payloadSender, id, response);
                                        return [
                                            4 /*yield*/ ,
                                            disassembler.disassemble()
                                        ];
                                    case 1:
                                        _a.sent();
                                        if (response.streams) response.streams.forEach(function(contentStream) {
                                            return __awaiter(_this, void 0, void 0, function() {
                                                return __generator(this, function(_a) {
                                                    switch(_a.label){
                                                        case 0:
                                                            return [
                                                                4 /*yield*/ ,
                                                                new httpContentStreamDisassembler_1.HttpContentStreamDisassembler(this.payloadSender, contentStream).disassemble()
                                                            ];
                                                        case 1:
                                                            _a.sent();
                                                            return [
                                                                2 /*return*/ 
                                                            ];
                                                    }
                                                });
                                            });
                                        });
                                        return [
                                            2 /*return*/ 
                                        ];
                                }
                            });
                        });
                    };
                    /**
     * The send operation used to send a [PayloadTypes.cancelStream](xref:botframework-streaming.PayloadTypes.cancelStream).
     *
     * @param id The ID to assign to the [CancelDisassembler](xref:botframework-streaming.CancelDisassembler) used by this operation.
     */ SendOperations.prototype.sendCancelStream = function(id) {
                        return __awaiter(this, void 0, void 0, function() {
                            var disassembler;
                            return __generator(this, function(_a) {
                                disassembler = new cancelDisassembler_1.CancelDisassembler(this.payloadSender, id, payloadTypes_1.PayloadTypes.cancelStream);
                                disassembler.disassemble();
                                return [
                                    2 /*return*/ 
                                ];
                            });
                        });
                    };
                    return SendOperations;
                }();
                exports.SendOperations = SendOperations;
            },
            {
                "../disassemblers/cancelDisassembler": 3,
                "../disassemblers/httpContentStreamDisassembler": 4,
                "../disassemblers/requestDisassembler": 6,
                "../disassemblers/responseDisassembler": 7,
                "./payloadTypes": 19
            }
        ],
        22: [
            function(require, module, exports) {
                "use strict";
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.StreamManager = void 0;
                var payloadAssembler_1 = require("../assemblers/payloadAssembler");
                /**
 * Orchestrates and manages streams.
 */ var StreamManager = /** @class */ function() {
                    /**
     * Initializes a new instance of the [StreamManager](xref:botframework-streaming.StreamManager) class.
     *
     * @param onCancelStream Function to trigger if the managed stream is cancelled.
     */ function StreamManager(onCancelStream) {
                        this.onCancelStream = onCancelStream;
                        this.activeAssemblers = [];
                    }
                    /**
     * Retrieves a [PayloadAssembler](xref:botframework-streaming.PayloadAssembler) with the given ID if one exists, otherwise a new instance is created and assigned the given ID.
     *
     * @param id The ID of the [PayloadAssembler](xref:botframework-streaming.PayloadAssembler) to retrieve or create.
     * @returns The [PayloadAssembler](xref:botframework-streaming.PayloadAssembler) with the given ID.
     */ StreamManager.prototype.getPayloadAssembler = function(id) {
                        if (!this.activeAssemblers[id]) {
                            // A new id has come in, kick off the process of tracking it.
                            var assembler = new payloadAssembler_1.PayloadAssembler(this, {
                                id: id
                            });
                            this.activeAssemblers[id] = assembler;
                            return assembler;
                        } else return this.activeAssemblers[id];
                    };
                    /**
     * Retrieves the [SubscribableStream](xref:botframework-streaming.SubscribableStream) from the [PayloadAssembler](xref:botframework-streaming.PayloadAssembler) this manager manages.
     *
     * @param header The Header of the [SubscribableStream](xref:botframework-streaming.SubscribableStream) to retrieve.
     * @returns The [SubscribableStream](xref:botframework-streaming.SubscribableStream) with the given header.
     */ StreamManager.prototype.getPayloadStream = function(header) {
                        var assembler = this.getPayloadAssembler(header.id);
                        return assembler.getPayloadStream();
                    };
                    /**
     * Used to set the behavior of the managed [PayloadAssembler](xref:botframework-streaming.PayloadAssembler) when data is received.
     *
     * @param header The Header of the stream.
     * @param contentStream The [SubscribableStream](xref:botframework-streaming.SubscribableStream) to write incoming data to.
     * @param contentLength The amount of data to write to the contentStream.
     */ StreamManager.prototype.onReceive = function(header, contentStream, contentLength) {
                        if (!this.activeAssemblers[header.id]) return;
                        this.activeAssemblers[header.id].onReceive(header, contentStream, contentLength);
                    };
                    /**
     * Closes the [PayloadAssembler](xref:botframework-streaming.PayloadAssembler) assigned to the [SubscribableStream](xref:botframework-streaming.SubscribableStream) with the given ID.
     *
     * @param id The ID of the [SubscribableStream](xref:botframework-streaming.SubscribableStream) to close.
     */ StreamManager.prototype.closeStream = function(id) {
                        if (!this.activeAssemblers[id]) return;
                        else {
                            var assembler = this.activeAssemblers[id];
                            this.activeAssemblers.splice(this.activeAssemblers.indexOf(id), 1);
                            var targetStream = assembler.getPayloadStream();
                            if (assembler.contentLength && targetStream.length < assembler.contentLength || !assembler.end) this.onCancelStream(assembler);
                        }
                    };
                    return StreamManager;
                }();
                exports.StreamManager = StreamManager;
            },
            {
                "../assemblers/payloadAssembler": 1
            }
        ],
        23: [
            function(require, module, exports) {
                "use strict";
                var __awaiter = this && this.__awaiter || function(thisArg, _arguments, P, generator) {
                    function adopt(value) {
                        return value instanceof P ? value : new P(function(resolve) {
                            resolve(value);
                        });
                    }
                    return new (P || (P = Promise))(function(resolve, reject) {
                        function fulfilled(value) {
                            try {
                                step(generator.next(value));
                            } catch (e) {
                                reject(e);
                            }
                        }
                        function rejected(value) {
                            try {
                                step(generator["throw"](value));
                            } catch (e) {
                                reject(e);
                            }
                        }
                        function step(result) {
                            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
                        }
                        step((generator = generator.apply(thisArg, _arguments || [])).next());
                    });
                };
                var __generator = this && this.__generator || function(thisArg, body) {
                    var _ = {
                        label: 0,
                        sent: function() {
                            if (t[0] & 1) throw t[1];
                            return t[1];
                        },
                        trys: [],
                        ops: []
                    }, f, y, t, g;
                    return g = {
                        next: verb(0),
                        "throw": verb(1),
                        "return": verb(2)
                    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
                        return this;
                    }), g;
                    function verb(n) {
                        return function(v) {
                            return step([
                                n,
                                v
                            ]);
                        };
                    }
                    function step(op) {
                        if (f) throw new TypeError("Generator is already executing.");
                        while(g && (g = 0, op[0] && (_ = 0)), _)try {
                            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
                            if (y = 0, t) op = [
                                op[0] & 2,
                                t.value
                            ];
                            switch(op[0]){
                                case 0:
                                case 1:
                                    t = op;
                                    break;
                                case 4:
                                    _.label++;
                                    return {
                                        value: op[1],
                                        done: false
                                    };
                                case 5:
                                    _.label++;
                                    y = op[1];
                                    op = [
                                        0
                                    ];
                                    continue;
                                case 7:
                                    op = _.ops.pop();
                                    _.trys.pop();
                                    continue;
                                default:
                                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                                        _ = 0;
                                        continue;
                                    }
                                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                                        _.label = op[1];
                                        break;
                                    }
                                    if (op[0] === 6 && _.label < t[1]) {
                                        _.label = t[1];
                                        t = op;
                                        break;
                                    }
                                    if (t && _.label < t[2]) {
                                        _.label = t[2];
                                        _.ops.push(op);
                                        break;
                                    }
                                    if (t[2]) _.ops.pop();
                                    _.trys.pop();
                                    continue;
                            }
                            op = body.call(thisArg, _);
                        } catch (e) {
                            op = [
                                6,
                                e
                            ];
                            y = 0;
                        } finally{
                            f = t = 0;
                        }
                        if (op[0] & 5) throw op[1];
                        return {
                            value: op[0] ? op[1] : void 0,
                            done: true
                        };
                    }
                };
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.ProtocolAdapter = void 0;
                var payloadAssemblerManager_1 = require("./payloads/payloadAssemblerManager");
                var sendOperations_1 = require("./payloads/sendOperations");
                var streamManager_1 = require("./payloads/streamManager");
                var protocol_base_1 = require("./utilities/protocol-base");
                /**
 * Creates a protocol adapter for Streaming.
 */ var ProtocolAdapter = /** @class */ function() {
                    /**
     * Creates a new instance of the protocol adapter class.
     *
     * @param requestHandler The [RequestHandler](xref:botframework-streaming.RequestHandler) that will process incoming requests.
     * @param requestManager The [RequestManager](xref:botframework-streaming.RequestManager) that will process outgoing requests.
     * @param sender The [PayloadSender](xref:botframework-streaming.PayloadSender) for use with outgoing requests.
     * @param receiver The [PayloadReceiver](xref:botframework-streaming.PayloadReceiver) for use with incoming requests.
     */ function ProtocolAdapter(requestHandler, requestManager, sender, receiver) {
                        var _this = this;
                        this.requestHandler = requestHandler;
                        this.requestManager = requestManager;
                        this.payloadSender = sender;
                        this.payloadReceiver = receiver;
                        this.sendOperations = new sendOperations_1.SendOperations(this.payloadSender);
                        this.streamManager = new streamManager_1.StreamManager(this.onCancelStream);
                        this.assemblerManager = new payloadAssemblerManager_1.PayloadAssemblerManager(this.streamManager, function(id, response) {
                            return _this.onReceiveResponse(id, response);
                        }, function(id, request) {
                            return _this.onReceiveRequest(id, request);
                        });
                        this.payloadReceiver.subscribe(function(header) {
                            return _this.assemblerManager.getPayloadStream(header);
                        }, function(header, contentStream, contentLength) {
                            return _this.assemblerManager.onReceive(header, contentStream, contentLength);
                        });
                    }
                    /**
     * Sends a request over the attached request manager.
     *
     * @param request The outgoing request to send.
     * @returns The response to the specified request.
     */ ProtocolAdapter.prototype.sendRequest = function(request) {
                        return __awaiter(this, void 0, void 0, function() {
                            var requestId, getResponsePromise;
                            return __generator(this, function(_a) {
                                switch(_a.label){
                                    case 0:
                                        requestId = (0, protocol_base_1.generateGuid)();
                                        getResponsePromise = this.requestManager.getResponse(requestId);
                                        return [
                                            4 /*yield*/ ,
                                            this.sendOperations.sendRequest(requestId, request)
                                        ];
                                    case 1:
                                        _a.sent();
                                        return [
                                            2 /*return*/ ,
                                            getResponsePromise
                                        ];
                                }
                            });
                        });
                    };
                    /**
     * Executes the receive pipeline when a request comes in.
     *
     * @param id The id the resources created for the response will be assigned.
     * @param request The incoming request to process.
     */ ProtocolAdapter.prototype.onReceiveRequest = function(id, request) {
                        return __awaiter(this, void 0, void 0, function() {
                            var response;
                            return __generator(this, function(_a) {
                                switch(_a.label){
                                    case 0:
                                        if (!this.requestHandler) return [
                                            3 /*break*/ ,
                                            3
                                        ];
                                        return [
                                            4 /*yield*/ ,
                                            this.requestHandler.processRequest(request)
                                        ];
                                    case 1:
                                        response = _a.sent();
                                        if (!response) return [
                                            3 /*break*/ ,
                                            3
                                        ];
                                        return [
                                            4 /*yield*/ ,
                                            this.sendOperations.sendResponse(id, response)
                                        ];
                                    case 2:
                                        _a.sent();
                                        _a.label = 3;
                                    case 3:
                                        return [
                                            2 /*return*/ 
                                        ];
                                }
                            });
                        });
                    };
                    /**
     * Executes the receive pipeline when a response comes in.
     *
     * @param id The id the resources created for the response will be assigned.
     * @param response The incoming response to process.
     */ ProtocolAdapter.prototype.onReceiveResponse = function(id, response) {
                        return __awaiter(this, void 0, void 0, function() {
                            return __generator(this, function(_a) {
                                switch(_a.label){
                                    case 0:
                                        return [
                                            4 /*yield*/ ,
                                            this.requestManager.signalResponse(id, response)
                                        ];
                                    case 1:
                                        _a.sent();
                                        return [
                                            2 /*return*/ 
                                        ];
                                }
                            });
                        });
                    };
                    /**
     * Executes the receive pipeline when a cancellation comes in.
     *
     * @param contentStreamAssembler The payload assembler processing the incoming data that this cancellation request targets.
     */ ProtocolAdapter.prototype.onCancelStream = function(contentStreamAssembler) {
                        this.sendOperations.sendCancelStream(contentStreamAssembler.id).catch();
                    };
                    return ProtocolAdapter;
                }();
                exports.ProtocolAdapter = ProtocolAdapter;
            },
            {
                "./payloads/payloadAssemblerManager": 17,
                "./payloads/sendOperations": 21,
                "./payloads/streamManager": 22,
                "./utilities/protocol-base": 28
            }
        ],
        24: [
            function(require, module, exports) {
                "use strict";
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.RequestHandler = void 0;
                /**
 * Implemented by classes used to process incoming streaming requests sent over an [IStreamingTransport](xref:botframework-streaming.IStreamingTransport).
 */ var RequestHandler = /** @class */ function() {
                    function RequestHandler() {}
                    return RequestHandler;
                }();
                exports.RequestHandler = RequestHandler;
            },
            {}
        ],
        25: [
            function(require, module, exports) {
                "use strict";
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.StreamingRequest = void 0;
                /**
 * @module botframework-streaming
 */ /**
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ var httpContentStream_1 = require("./httpContentStream");
                var subscribableStream_1 = require("./subscribableStream");
                /**
 * The basic request type sent over Bot Framework Protocol 3 with Streaming Extensions transports, equivalent to HTTP request messages.
 */ var StreamingRequest = /** @class */ function() {
                    function StreamingRequest() {
                        /**
         * List of associated streams.
         */ this.streams = [];
                    }
                    /**
     * Creates a streaming request with the passed in method, path, and body.
     *
     * @param method The HTTP verb to use for this request.
     * @param path Optional path where the resource can be found on the remote server.
     * @param body Optional body to send to the remote server.
     * @returns On success returns a streaming request with appropriate status code and body.
     */ StreamingRequest.create = function(method, path, body) {
                        var request = new StreamingRequest();
                        request.verb = method;
                        request.path = path;
                        if (body) request.setBody(body);
                        return request;
                    };
                    /**
     * Adds a new stream attachment to this streaming request.
     *
     * @param content The Http content to include in the new stream attachment.
     */ StreamingRequest.prototype.addStream = function(content) {
                        if (!content) throw new Error("Argument Undefined Exception: content undefined.");
                        this.streams.push(new httpContentStream_1.HttpContentStream(content));
                    };
                    /**
     * Sets the contents of the body of this streamingRequest.
     *
     * @param body The JSON text to write to the body of the streamingRequest.
     */ // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/no-explicit-any
                    StreamingRequest.prototype.setBody = function(body) {
                        if (typeof body === "string") {
                            var stream = new subscribableStream_1.SubscribableStream();
                            stream.write(body, "utf8");
                            this.addStream(new httpContentStream_1.HttpContent({
                                type: "application/json; charset=utf-8",
                                contentLength: stream.length
                            }, stream));
                        } else if (typeof body === "object") this.addStream(body);
                    };
                    return StreamingRequest;
                }();
                exports.StreamingRequest = StreamingRequest;
            },
            {
                "./httpContentStream": 8,
                "./subscribableStream": 27
            }
        ],
        26: [
            function(require, module, exports) {
                "use strict";
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.StreamingResponse = void 0;
                /**
 * @module botframework-streaming
 */ /**
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ var httpContentStream_1 = require("./httpContentStream");
                var subscribableStream_1 = require("./subscribableStream");
                /**
 * The basic response type sent over Bot Framework Protocol 3 with Streaming Extensions transports, equivalent to HTTP response messages.
 */ var StreamingResponse = /** @class */ function() {
                    function StreamingResponse() {
                        this.streams = [];
                    }
                    /**
     * Creates a streaming response with the passed in method, path, and body.
     *
     * @param statusCode The HTTP verb to use for this request.
     * @param body Optional body containing additional information.
     * @returns A streaming response with the appropriate statuscode and passed in body.
     */ StreamingResponse.create = function(statusCode, body) {
                        var response = new StreamingResponse();
                        response.statusCode = statusCode;
                        if (body) response.addStream(body);
                        return response;
                    };
                    /**
     * Adds a new stream attachment to this streaming request.
     *
     * @param content The Http content to include in the new stream attachment.
     */ StreamingResponse.prototype.addStream = function(content) {
                        this.streams.push(new httpContentStream_1.HttpContentStream(content));
                    };
                    /**
     * Sets the contents of the body of this streaming response.
     *
     * @param body The JSON text to write to the body of the streaming response.
     */ // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/no-explicit-any
                    StreamingResponse.prototype.setBody = function(body) {
                        var stream = new subscribableStream_1.SubscribableStream();
                        stream.write(JSON.stringify(body), "utf8");
                        this.addStream(new httpContentStream_1.HttpContent({
                            type: "application/json; charset=utf-8",
                            contentLength: stream.length
                        }, stream));
                    };
                    return StreamingResponse;
                }();
                exports.StreamingResponse = StreamingResponse;
            },
            {
                "./httpContentStream": 8,
                "./subscribableStream": 27
            }
        ],
        27: [
            function(require, module, exports) {
                (function(Buffer) {
                    (function() {
                        "use strict";
                        var __extends = this && this.__extends || function() {
                            var extendStatics = function(d, b) {
                                extendStatics = Object.setPrototypeOf || ({
                                    __proto__: []
                                }) instanceof Array && function(d, b) {
                                    d.__proto__ = b;
                                } || function(d, b) {
                                    for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                                };
                                return extendStatics(d, b);
                            };
                            return function(d, b) {
                                if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                                extendStatics(d, b);
                                function __() {
                                    this.constructor = d;
                                }
                                d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                            };
                        }();
                        Object.defineProperty(exports, "__esModule", {
                            value: true
                        });
                        exports.SubscribableStream = void 0;
                        /**
 * @module botframework-streaming
 */ /**
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ var stream_1 = require("stream");
                        /**
 * An extension of `Duplex` that operates in conjunction with a `PayloadAssembler` to convert raw bytes into a consumable form.
 */ var SubscribableStream = /** @class */ function(_super) {
                            __extends(SubscribableStream, _super);
                            /**
     * Initializes a new instance of the [SubscribableStream](xref:botframework-streaming.SubscribableStream) class.
     *
     * @param options The `DuplexOptions` to use when constructing this stream.
     */ function SubscribableStream(options) {
                                var _this = _super.call(this, options) || this;
                                _this.length = 0;
                                _this.bufferList = [];
                                return _this;
                            }
                            /**
     * Writes data to the buffered list.
     * All calls to writable.write() that occur between the time writable._write() is called and the callback is called will cause the written data to be buffered.
     *
     * @param chunk The Buffer to be written.
     * @param _encoding The encoding. Unused in the implementation of Duplex.
     * @param callback Callback for when this chunk of data is flushed.
     */ // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/no-explicit-any
                            SubscribableStream.prototype._write = function(chunk, _encoding, callback) {
                                var buffer = Buffer.from(chunk);
                                this.bufferList.push(buffer);
                                this.length += chunk.length;
                                if (this._onData) this._onData(buffer);
                                callback();
                            };
                            /**
     * Reads the buffered list.
     * Once the readable._read() method has been called, it will not be called again until more data is pushed through the readable.push() method.
     * Empty data such as empty buffers and strings will not cause readable._read() to be called.
     *
     * @param size Number of bytes to read.
     */ SubscribableStream.prototype._read = function(size) {
                                if (this.bufferList.length === 0) // null signals end of stream
                                this.push(null);
                                else {
                                    var total = 0;
                                    while(total < size && this.bufferList.length > 0){
                                        var buffer = this.bufferList[0];
                                        this.push(buffer);
                                        this.bufferList.splice(0, 1);
                                        total += buffer.length;
                                    }
                                }
                            };
                            /**
     * Subscribes to the stream when receives data.
     *
     * @param onData Callback to be called when onData is executed.
     */ // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/no-explicit-any
                            SubscribableStream.prototype.subscribe = function(onData) {
                                this._onData = onData;
                            };
                            return SubscribableStream;
                        }(stream_1.Duplex);
                        exports.SubscribableStream = SubscribableStream;
                    }).call(this);
                }).call(this, require("buffer").Buffer);
            },
            {
                "buffer": 35,
                "stream": 41
            }
        ],
        28: [
            function(require, module, exports) {
                "use strict";
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.generateGuid = void 0;
                /**
 * @module botframework-streaming
 */ /**
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ var uuid_1 = require("uuid");
                /**
 * Generates an uuid v4 string.
 *
 * @returns An uuidv4 string.
 */ function generateGuid() {
                    return (0, uuid_1.v4)();
                }
                exports.generateGuid = generateGuid;
            },
            {
                "uuid": 58
            }
        ],
        29: [
            function(require, module, exports) {
                "use strict";
                var __awaiter = this && this.__awaiter || function(thisArg, _arguments, P, generator) {
                    function adopt(value) {
                        return value instanceof P ? value : new P(function(resolve) {
                            resolve(value);
                        });
                    }
                    return new (P || (P = Promise))(function(resolve, reject) {
                        function fulfilled(value) {
                            try {
                                step(generator.next(value));
                            } catch (e) {
                                reject(e);
                            }
                        }
                        function rejected(value) {
                            try {
                                step(generator["throw"](value));
                            } catch (e) {
                                reject(e);
                            }
                        }
                        function step(result) {
                            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
                        }
                        step((generator = generator.apply(thisArg, _arguments || [])).next());
                    });
                };
                var __generator = this && this.__generator || function(thisArg, body) {
                    var _ = {
                        label: 0,
                        sent: function() {
                            if (t[0] & 1) throw t[1];
                            return t[1];
                        },
                        trys: [],
                        ops: []
                    }, f, y, t, g;
                    return g = {
                        next: verb(0),
                        "throw": verb(1),
                        "return": verb(2)
                    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
                        return this;
                    }), g;
                    function verb(n) {
                        return function(v) {
                            return step([
                                n,
                                v
                            ]);
                        };
                    }
                    function step(op) {
                        if (f) throw new TypeError("Generator is already executing.");
                        while(g && (g = 0, op[0] && (_ = 0)), _)try {
                            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
                            if (y = 0, t) op = [
                                op[0] & 2,
                                t.value
                            ];
                            switch(op[0]){
                                case 0:
                                case 1:
                                    t = op;
                                    break;
                                case 4:
                                    _.label++;
                                    return {
                                        value: op[1],
                                        done: false
                                    };
                                case 5:
                                    _.label++;
                                    y = op[1];
                                    op = [
                                        0
                                    ];
                                    continue;
                                case 7:
                                    op = _.ops.pop();
                                    _.trys.pop();
                                    continue;
                                default:
                                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                                        _ = 0;
                                        continue;
                                    }
                                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                                        _.label = op[1];
                                        break;
                                    }
                                    if (op[0] === 6 && _.label < t[1]) {
                                        _.label = t[1];
                                        t = op;
                                        break;
                                    }
                                    if (t && _.label < t[2]) {
                                        _.label = t[2];
                                        _.ops.push(op);
                                        break;
                                    }
                                    if (t[2]) _.ops.pop();
                                    _.trys.pop();
                                    continue;
                            }
                            op = body.call(thisArg, _);
                        } catch (e) {
                            op = [
                                6,
                                e
                            ];
                            y = 0;
                        } finally{
                            f = t = 0;
                        }
                        if (op[0] & 5) throw op[1];
                        return {
                            value: op[0] ? op[1] : void 0,
                            done: true
                        };
                    }
                };
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.BrowserWebSocket = void 0;
                /**
 * Represents a WebSocket that implements [ISocket](xref:botframework-streaming.ISocket).
 */ var BrowserWebSocket = /** @class */ function() {
                    /**
     * Creates a new instance of the [BrowserWebSocket](xref:botframework-streaming.BrowserWebSocket) class.
     *
     * @param socket The socket object to build this connection on.
     */ function BrowserWebSocket(socket) {
                        if (socket) this.webSocket = socket;
                    }
                    /**
     * Connects to the supporting socket using WebSocket protocol.
     *
     * @param serverAddress The address the server is listening on.
     * @returns A Promise that resolves the websocket is open and rejects if an error is encountered.
     */ BrowserWebSocket.prototype.connect = function(serverAddress) {
                        return __awaiter(this, void 0, void 0, function() {
                            var resolver, rejector;
                            return __generator(this, function(_a) {
                                if (!this.webSocket) this.webSocket = new WebSocket(serverAddress);
                                this.webSocket.onerror = function(e) {
                                    rejector(e);
                                };
                                this.webSocket.onopen = function(e) {
                                    resolver(e);
                                };
                                return [
                                    2 /*return*/ ,
                                    new Promise(function(resolve, reject) {
                                        resolver = resolve;
                                        rejector = reject;
                                    })
                                ];
                            });
                        });
                    };
                    Object.defineProperty(BrowserWebSocket.prototype, "isConnected", {
                        /**
         * Indicates if the [BrowserWebSocket's](xref:botframework-streaming.BrowserWebSocket) underlying websocket is currently connected.
         *
         * @returns `true` if the underlying websocket is ready and availble to send messages, otherwise `false`.
         */ get: function() {
                            return this.webSocket.readyState === 1;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    /**
     * Writes a buffer to the socket and sends it.
     *
     * @param buffer The buffer of data to send across the connection.
     */ BrowserWebSocket.prototype.write = function(buffer) {
                        this.webSocket.send(buffer);
                    };
                    /**
     * Close the socket.
     */ BrowserWebSocket.prototype.close = function() {
                        this.webSocket.close();
                    };
                    /**
     * Set the handler for text and binary messages received on the socket.
     *
     * @param handler The callback to handle the "message" event.
     */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    BrowserWebSocket.prototype.setOnMessageHandler = function(handler) {
                        var bufferKey = "buffer";
                        var packets = [];
                        this.webSocket.onmessage = function(evt) {
                            var fileReader = new FileReader();
                            var queueEntry = {
                                buffer: null
                            };
                            packets.push(queueEntry);
                            fileReader.onload = function(e) {
                                var t = e.target;
                                queueEntry[bufferKey] = t.result;
                                if (packets[0] === queueEntry) while(0 < packets.length && packets[0][bufferKey]){
                                    handler(packets[0][bufferKey]);
                                    packets.splice(0, 1);
                                }
                            };
                            fileReader.readAsArrayBuffer(evt.data);
                        };
                    };
                    /**
     * Set the callback to call when encountering errors.
     *
     * @param handler The callback to handle the "error" event.
     */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    BrowserWebSocket.prototype.setOnErrorHandler = function(handler) {
                        this.webSocket.onerror = function(error) {
                            if (error) handler(error);
                        };
                    };
                    /**
     * Set the callback to call when encountering socket closures.
     *
     * @param handler The callback to handle the "close" event.
     */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    BrowserWebSocket.prototype.setOnCloseHandler = function(handler) {
                        this.webSocket.onclose = handler;
                    };
                    return BrowserWebSocket;
                }();
                exports.BrowserWebSocket = BrowserWebSocket;
            },
            {}
        ],
        30: [
            function(require, module, exports) {
                "use strict";
                /**
 * @module botframework-streaming
 */ /**
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ var __awaiter = this && this.__awaiter || function(thisArg, _arguments, P, generator) {
                    function adopt(value) {
                        return value instanceof P ? value : new P(function(resolve) {
                            resolve(value);
                        });
                    }
                    return new (P || (P = Promise))(function(resolve, reject) {
                        function fulfilled(value) {
                            try {
                                step(generator.next(value));
                            } catch (e) {
                                reject(e);
                            }
                        }
                        function rejected(value) {
                            try {
                                step(generator["throw"](value));
                            } catch (e) {
                                reject(e);
                            }
                        }
                        function step(result) {
                            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
                        }
                        step((generator = generator.apply(thisArg, _arguments || [])).next());
                    });
                };
                var __generator = this && this.__generator || function(thisArg, body) {
                    var _ = {
                        label: 0,
                        sent: function() {
                            if (t[0] & 1) throw t[1];
                            return t[1];
                        },
                        trys: [],
                        ops: []
                    }, f, y, t, g;
                    return g = {
                        next: verb(0),
                        "throw": verb(1),
                        "return": verb(2)
                    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
                        return this;
                    }), g;
                    function verb(n) {
                        return function(v) {
                            return step([
                                n,
                                v
                            ]);
                        };
                    }
                    function step(op) {
                        if (f) throw new TypeError("Generator is already executing.");
                        while(g && (g = 0, op[0] && (_ = 0)), _)try {
                            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
                            if (y = 0, t) op = [
                                op[0] & 2,
                                t.value
                            ];
                            switch(op[0]){
                                case 0:
                                case 1:
                                    t = op;
                                    break;
                                case 4:
                                    _.label++;
                                    return {
                                        value: op[1],
                                        done: false
                                    };
                                case 5:
                                    _.label++;
                                    y = op[1];
                                    op = [
                                        0
                                    ];
                                    continue;
                                case 7:
                                    op = _.ops.pop();
                                    _.trys.pop();
                                    continue;
                                default:
                                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                                        _ = 0;
                                        continue;
                                    }
                                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                                        _.label = op[1];
                                        break;
                                    }
                                    if (op[0] === 6 && _.label < t[1]) {
                                        _.label = t[1];
                                        t = op;
                                        break;
                                    }
                                    if (t && _.label < t[2]) {
                                        _.label = t[2];
                                        _.ops.push(op);
                                        break;
                                    }
                                    if (t[2]) _.ops.pop();
                                    _.trys.pop();
                                    continue;
                            }
                            op = body.call(thisArg, _);
                        } catch (e) {
                            op = [
                                6,
                                e
                            ];
                            y = 0;
                        } finally{
                            f = t = 0;
                        }
                        if (op[0] & 5) throw op[1];
                        return {
                            value: op[0] ? op[1] : void 0,
                            done: true
                        };
                    }
                };
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.WebSocketClient = void 0;
                var browserWebSocket_1 = require("./browserWebSocket");
                var payloadTransport_1 = require("../payloadTransport");
                var protocolAdapter_1 = require("../protocolAdapter");
                var payloads_1 = require("../payloads");
                var webSocketTransport_1 = require("./webSocketTransport");
                /**
 * Web socket based client to be used as streaming transport.
 */ var WebSocketClient = /** @class */ function() {
                    /**
     * Creates a new instance of the [WebSocketClient](xref:botframework-streaming.WebSocketClient) class.
     *
     * @param config For configuring a [WebSocketClient](xref:botframework-streaming.WebSocketClient) instance to communicate with a WebSocket server.
     * @param config.url The URL of the remote server to connect to.
     * @param config.requestHandler The [RequestHandler](xref:botframework-streaming.RequestHandler) used to process incoming messages received by this client.
     * @param config.disconnectionHandler Optional function to handle the disconnection message.
     */ function WebSocketClient(_a) {
                        var url = _a.url, requestHandler = _a.requestHandler, _b = _a.disconnectionHandler, disconnectionHandler = _b === void 0 ? null : _b;
                        this._url = url;
                        this._requestHandler = requestHandler;
                        this._disconnectionHandler = disconnectionHandler;
                        this._requestManager = new payloads_1.RequestManager();
                        this._sender = new payloadTransport_1.PayloadSender();
                        this._sender.disconnected = this.onConnectionDisconnected.bind(this);
                        this._receiver = new payloadTransport_1.PayloadReceiver();
                        this._receiver.disconnected = this.onConnectionDisconnected.bind(this);
                        this._protocolAdapter = new protocolAdapter_1.ProtocolAdapter(this._requestHandler, this._requestManager, this._sender, this._receiver);
                    }
                    /**
     * Establish a connection with no custom headers.
     *
     * @returns A promise that will not resolve until the client stops listening for incoming messages.
     */ WebSocketClient.prototype.connect = function() {
                        return __awaiter(this, void 0, void 0, function() {
                            var ws, transport;
                            return __generator(this, function(_a) {
                                switch(_a.label){
                                    case 0:
                                        ws = new browserWebSocket_1.BrowserWebSocket();
                                        return [
                                            4 /*yield*/ ,
                                            ws.connect(this._url)
                                        ];
                                    case 1:
                                        _a.sent();
                                        transport = new webSocketTransport_1.WebSocketTransport(ws);
                                        this._sender.connect(transport);
                                        this._receiver.connect(transport);
                                        return [
                                            2 /*return*/ 
                                        ];
                                }
                            });
                        });
                    };
                    /**
     * Stop this client from listening.
     */ WebSocketClient.prototype.disconnect = function() {
                        this._sender.disconnect(new payloadTransport_1.TransportDisconnectedEvent("Disconnect was called."));
                        this._receiver.disconnect(new payloadTransport_1.TransportDisconnectedEvent("Disconnect was called."));
                    };
                    /**
     * Task used to send data over this client connection.
     *
     * @param request The streaming request to send.
     * @returns A promise that will produce an instance of receive response on completion of the send operation.
     */ WebSocketClient.prototype.send = function(request) {
                        return __awaiter(this, void 0, void 0, function() {
                            return __generator(this, function(_a) {
                                return [
                                    2 /*return*/ ,
                                    this._protocolAdapter.sendRequest(request)
                                ];
                            });
                        });
                    };
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    WebSocketClient.prototype.onConnectionDisconnected = function(sender, args) {
                        // Rejects all pending requests on disconnect.
                        this._requestManager.rejectAllResponses(new Error("Disconnect was called."));
                        if (this._disconnectionHandler != null) {
                            this._disconnectionHandler("Disconnected");
                            return;
                        }
                        throw new Error("Unable to re-connect client to transport for url ".concat(this._url, ". Sender: '").concat(JSON.stringify(sender), "'. Args:' ").concat(JSON.stringify(args)));
                    };
                    return WebSocketClient;
                }();
                exports.WebSocketClient = WebSocketClient;
            },
            {
                "../payloadTransport": 10,
                "../payloads": 16,
                "../protocolAdapter": 23,
                "./browserWebSocket": 29,
                "./webSocketTransport": 32
            }
        ],
        31: [
            function(require, module, exports) {
                "use strict";
                /**
 * @module botframework-streaming
 */ /**
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.WebSocketTransport = exports.WebSocketClient = exports.BrowserWebSocket = void 0;
                var browserWebSocket_1 = require("./browserWebSocket");
                Object.defineProperty(exports, "BrowserWebSocket", {
                    enumerable: true,
                    get: function() {
                        return browserWebSocket_1.BrowserWebSocket;
                    }
                });
                var browserWebSocketClient_1 = require("./browserWebSocketClient");
                Object.defineProperty(exports, "WebSocketClient", {
                    enumerable: true,
                    get: function() {
                        return browserWebSocketClient_1.WebSocketClient;
                    }
                });
                /** @internal */ var webSocketTransport_1 = require("./webSocketTransport");
                Object.defineProperty(exports, "WebSocketTransport", {
                    enumerable: true,
                    get: function() {
                        return webSocketTransport_1.WebSocketTransport;
                    }
                });
            },
            {
                "./browserWebSocket": 29,
                "./browserWebSocketClient": 30,
                "./webSocketTransport": 32
            }
        ],
        32: [
            function(require, module, exports) {
                (function(Buffer) {
                    (function() {
                        "use strict";
                        /**
 * @module botframework-streaming
 */ /**
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ var __awaiter = this && this.__awaiter || function(thisArg, _arguments, P, generator) {
                            function adopt(value) {
                                return value instanceof P ? value : new P(function(resolve) {
                                    resolve(value);
                                });
                            }
                            return new (P || (P = Promise))(function(resolve, reject) {
                                function fulfilled(value) {
                                    try {
                                        step(generator.next(value));
                                    } catch (e) {
                                        reject(e);
                                    }
                                }
                                function rejected(value) {
                                    try {
                                        step(generator["throw"](value));
                                    } catch (e) {
                                        reject(e);
                                    }
                                }
                                function step(result) {
                                    result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
                                }
                                step((generator = generator.apply(thisArg, _arguments || [])).next());
                            });
                        };
                        var __generator = this && this.__generator || function(thisArg, body) {
                            var _ = {
                                label: 0,
                                sent: function() {
                                    if (t[0] & 1) throw t[1];
                                    return t[1];
                                },
                                trys: [],
                                ops: []
                            }, f, y, t, g;
                            return g = {
                                next: verb(0),
                                "throw": verb(1),
                                "return": verb(2)
                            }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
                                return this;
                            }), g;
                            function verb(n) {
                                return function(v) {
                                    return step([
                                        n,
                                        v
                                    ]);
                                };
                            }
                            function step(op) {
                                if (f) throw new TypeError("Generator is already executing.");
                                while(g && (g = 0, op[0] && (_ = 0)), _)try {
                                    if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
                                    if (y = 0, t) op = [
                                        op[0] & 2,
                                        t.value
                                    ];
                                    switch(op[0]){
                                        case 0:
                                        case 1:
                                            t = op;
                                            break;
                                        case 4:
                                            _.label++;
                                            return {
                                                value: op[1],
                                                done: false
                                            };
                                        case 5:
                                            _.label++;
                                            y = op[1];
                                            op = [
                                                0
                                            ];
                                            continue;
                                        case 7:
                                            op = _.ops.pop();
                                            _.trys.pop();
                                            continue;
                                        default:
                                            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                                                _ = 0;
                                                continue;
                                            }
                                            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                                                _.label = op[1];
                                                break;
                                            }
                                            if (op[0] === 6 && _.label < t[1]) {
                                                _.label = t[1];
                                                t = op;
                                                break;
                                            }
                                            if (t && _.label < t[2]) {
                                                _.label = t[2];
                                                _.ops.push(op);
                                                break;
                                            }
                                            if (t[2]) _.ops.pop();
                                            _.trys.pop();
                                            continue;
                                    }
                                    op = body.call(thisArg, _);
                                } catch (e) {
                                    op = [
                                        6,
                                        e
                                    ];
                                    y = 0;
                                } finally{
                                    f = t = 0;
                                }
                                if (op[0] & 5) throw op[1];
                                return {
                                    value: op[0] ? op[1] : void 0,
                                    done: true
                                };
                            }
                        };
                        Object.defineProperty(exports, "__esModule", {
                            value: true
                        });
                        exports.WebSocketTransport = void 0;
                        /**
 * Web socket based transport.
 */ var WebSocketTransport = /** @class */ function() {
                            /**
     * Creates a new instance of the [WebSocketTransport](xref:botframework-streaming.WebSocketTransport) class.
     *
     * @param ws The ISocket to build this transport on top of.
     */ function WebSocketTransport(ws) {
                                var _this = this;
                                this.ws = ws;
                                this._queue = [];
                                this._activeOffset = 0;
                                this._activeReceiveCount = 0;
                                this.ws.setOnMessageHandler(function(data) {
                                    _this.onReceive(data);
                                });
                                this.ws.setOnErrorHandler(function(err) {
                                    _this.onError(err);
                                });
                                this.ws.setOnCloseHandler(function() {
                                    _this.onClose();
                                });
                            }
                            /**
     * Sends the given buffer out over the socket's connection.
     *
     * @param buffer The buffered data to send out over the connection.
     * @returns A number indicating the length of the sent data if the data was successfully sent, otherwise 0.
     */ WebSocketTransport.prototype.send = function(buffer) {
                                var _a;
                                if ((_a = this.ws) === null || _a === void 0 ? void 0 : _a.isConnected) {
                                    this.ws.write(buffer);
                                    return buffer.length;
                                }
                                return 0;
                            };
                            Object.defineProperty(WebSocketTransport.prototype, "isConnected", {
                                /**
         * Returns true if the transport is connected to a socket.
         *
         * @returns `true` if the the transport is connected and ready to send data, `false` otherwise.
         */ get: function() {
                                    var _a;
                                    return !!((_a = this.ws) === null || _a === void 0 ? void 0 : _a.isConnected);
                                },
                                enumerable: false,
                                configurable: true
                            });
                            /**
     * Close the socket this transport is connected to.
     */ WebSocketTransport.prototype.close = function() {
                                var _a;
                                if ((_a = this.ws) === null || _a === void 0 ? void 0 : _a.isConnected) this.ws.close();
                            };
                            /**
     * Attempt to receive incoming data from the connected socket.
     *
     * @param count The number of bytes to attempt to receive.
     * @returns A buffer populated with the received data.
     */ WebSocketTransport.prototype.receive = function(count) {
                                return __awaiter(this, void 0, void 0, function() {
                                    var promise;
                                    var _this = this;
                                    return __generator(this, function(_a) {
                                        if (this._activeReceiveResolve) throw new Error("Cannot call receive more than once before it has returned.");
                                        this._activeReceiveCount = count;
                                        promise = new Promise(function(resolve, reject) {
                                            _this._activeReceiveResolve = resolve;
                                            _this._activeReceiveReject = reject;
                                        });
                                        this.trySignalData();
                                        return [
                                            2 /*return*/ ,
                                            promise
                                        ];
                                    });
                                });
                            };
                            /**
     * Sets the transport to attempt to receive incoming data that has not yet arrived.
     *
     * @param data A buffer to store incoming data in.
     */ WebSocketTransport.prototype.onReceive = function(data) {
                                if (this._queue && data && data.byteLength > 0) {
                                    this._queue.push(Buffer.from(data));
                                    this.trySignalData();
                                }
                            };
                            WebSocketTransport.prototype.onClose = function() {
                                if (this._activeReceiveReject) this._activeReceiveReject(new Error("Socket was closed."));
                                this._active = null;
                                this._activeOffset = 0;
                                this._activeReceiveResolve = null;
                                this._activeReceiveReject = null;
                                this._activeReceiveCount = 0;
                                this.ws = null;
                            };
                            WebSocketTransport.prototype.onError = function(err) {
                                if (this._activeReceiveReject) this._activeReceiveReject(err);
                                this.onClose();
                            };
                            WebSocketTransport.prototype.trySignalData = function() {
                                if (this._activeReceiveResolve) {
                                    if (!this._active && this._queue.length > 0) {
                                        this._active = this._queue.shift();
                                        this._activeOffset = 0;
                                    }
                                    if (this._active) {
                                        if (this._activeOffset === 0 && this._active.length === this._activeReceiveCount) {
                                            // can send the entire _active buffer
                                            var buffer = this._active;
                                            this._active = null;
                                            this._activeReceiveResolve(buffer);
                                        } else {
                                            // create a Buffer.from and copy some of the contents into it
                                            var available = Math.min(this._activeReceiveCount, this._active.length - this._activeOffset);
                                            var buffer = Buffer.alloc(available);
                                            this._active.copy(buffer, 0, this._activeOffset, this._activeOffset + available);
                                            this._activeOffset += available;
                                            // if we used all of active, set it to undefined
                                            if (this._activeOffset >= this._active.length) {
                                                this._active = null;
                                                this._activeOffset = 0;
                                            }
                                            this._activeReceiveResolve(buffer);
                                        }
                                        this._activeReceiveCount = 0;
                                        this._activeReceiveReject = null;
                                        this._activeReceiveResolve = null;
                                    }
                                }
                            };
                            return WebSocketTransport;
                        }();
                        exports.WebSocketTransport = WebSocketTransport;
                    }).call(this);
                }).call(this, require("buffer").Buffer);
            },
            {
                "buffer": 35
            }
        ],
        33: [
            function(require, module, exports) {
                "use strict";
                exports.byteLength = byteLength;
                exports.toByteArray = toByteArray;
                exports.fromByteArray = fromByteArray;
                var lookup = [];
                var revLookup = [];
                var Arr = typeof Uint8Array !== "undefined" ? Uint8Array : Array;
                var code = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
                for(var i = 0, len = code.length; i < len; ++i){
                    lookup[i] = code[i];
                    revLookup[code.charCodeAt(i)] = i;
                }
                // Support decoding URL-safe base64 strings, as Node.js does.
                // See: https://en.wikipedia.org/wiki/Base64#URL_applications
                revLookup["-".charCodeAt(0)] = 62;
                revLookup["_".charCodeAt(0)] = 63;
                function getLens(b64) {
                    var len = b64.length;
                    if (len % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
                    // Trim off extra bytes after placeholder bytes are found
                    // See: https://github.com/beatgammit/base64-js/issues/42
                    var validLen = b64.indexOf("=");
                    if (validLen === -1) validLen = len;
                    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
                    return [
                        validLen,
                        placeHoldersLen
                    ];
                }
                // base64 is 4/3 + up to two characters of the original data
                function byteLength(b64) {
                    var lens = getLens(b64);
                    var validLen = lens[0];
                    var placeHoldersLen = lens[1];
                    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
                }
                function _byteLength(b64, validLen, placeHoldersLen) {
                    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
                }
                function toByteArray(b64) {
                    var tmp;
                    var lens = getLens(b64);
                    var validLen = lens[0];
                    var placeHoldersLen = lens[1];
                    var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen));
                    var curByte = 0;
                    // if there are placeholders, only get up to the last complete 4 chars
                    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
                    var i;
                    for(i = 0; i < len; i += 4){
                        tmp = revLookup[b64.charCodeAt(i)] << 18 | revLookup[b64.charCodeAt(i + 1)] << 12 | revLookup[b64.charCodeAt(i + 2)] << 6 | revLookup[b64.charCodeAt(i + 3)];
                        arr[curByte++] = tmp >> 16 & 0xFF;
                        arr[curByte++] = tmp >> 8 & 0xFF;
                        arr[curByte++] = tmp & 0xFF;
                    }
                    if (placeHoldersLen === 2) {
                        tmp = revLookup[b64.charCodeAt(i)] << 2 | revLookup[b64.charCodeAt(i + 1)] >> 4;
                        arr[curByte++] = tmp & 0xFF;
                    }
                    if (placeHoldersLen === 1) {
                        tmp = revLookup[b64.charCodeAt(i)] << 10 | revLookup[b64.charCodeAt(i + 1)] << 4 | revLookup[b64.charCodeAt(i + 2)] >> 2;
                        arr[curByte++] = tmp >> 8 & 0xFF;
                        arr[curByte++] = tmp & 0xFF;
                    }
                    return arr;
                }
                function tripletToBase64(num) {
                    return lookup[num >> 18 & 0x3F] + lookup[num >> 12 & 0x3F] + lookup[num >> 6 & 0x3F] + lookup[num & 0x3F];
                }
                function encodeChunk(uint8, start, end) {
                    var tmp;
                    var output = [];
                    for(var i = start; i < end; i += 3){
                        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
                        output.push(tripletToBase64(tmp));
                    }
                    return output.join("");
                }
                function fromByteArray(uint8) {
                    var tmp;
                    var len = uint8.length;
                    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
                    ;
                    var parts = [];
                    var maxChunkLength = 16383 // must be multiple of 3
                    ;
                    // go through the array every three bytes, we'll deal with trailing stuff later
                    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push(encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
                    // pad the end with zeros, but make sure to not forget the extra bytes
                    if (extraBytes === 1) {
                        tmp = uint8[len - 1];
                        parts.push(lookup[tmp >> 2] + lookup[tmp << 4 & 0x3F] + "==");
                    } else if (extraBytes === 2) {
                        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
                        parts.push(lookup[tmp >> 10] + lookup[tmp >> 4 & 0x3F] + lookup[tmp << 2 & 0x3F] + "=");
                    }
                    return parts.join("");
                }
            },
            {}
        ],
        34: [
            function(require, module, exports) {},
            {}
        ],
        35: [
            function(require, module, exports) {
                (function(Buffer) {
                    (function() {
                        /*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ "use strict";
                        var base64 = require("base64-js");
                        var ieee754 = require("ieee754");
                        exports.Buffer = Buffer;
                        exports.SlowBuffer = SlowBuffer;
                        exports.INSPECT_MAX_BYTES = 50;
                        var K_MAX_LENGTH = 0x7fffffff;
                        exports.kMaxLength = K_MAX_LENGTH;
                        /**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ Buffer.TYPED_ARRAY_SUPPORT = typedArraySupport();
                        if (!Buffer.TYPED_ARRAY_SUPPORT && typeof console !== "undefined" && typeof console.error === "function") console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
                        function typedArraySupport() {
                            // Can typed array instances can be augmented?
                            try {
                                var arr = new Uint8Array(1);
                                arr.__proto__ = {
                                    __proto__: Uint8Array.prototype,
                                    foo: function() {
                                        return 42;
                                    }
                                };
                                return arr.foo() === 42;
                            } catch (e) {
                                return false;
                            }
                        }
                        Object.defineProperty(Buffer.prototype, "parent", {
                            enumerable: true,
                            get: function() {
                                if (!Buffer.isBuffer(this)) return undefined;
                                return this.buffer;
                            }
                        });
                        Object.defineProperty(Buffer.prototype, "offset", {
                            enumerable: true,
                            get: function() {
                                if (!Buffer.isBuffer(this)) return undefined;
                                return this.byteOffset;
                            }
                        });
                        function createBuffer(length) {
                            if (length > K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
                            // Return an augmented `Uint8Array` instance
                            var buf = new Uint8Array(length);
                            buf.__proto__ = Buffer.prototype;
                            return buf;
                        }
                        /**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function Buffer(arg, encodingOrOffset, length) {
                            // Common case.
                            if (typeof arg === "number") {
                                if (typeof encodingOrOffset === "string") throw new TypeError('The "string" argument must be of type string. Received type number');
                                return allocUnsafe(arg);
                            }
                            return from(arg, encodingOrOffset, length);
                        }
                        // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
                        if (typeof Symbol !== "undefined" && Symbol.species != null && Buffer[Symbol.species] === Buffer) Object.defineProperty(Buffer, Symbol.species, {
                            value: null,
                            configurable: true,
                            enumerable: false,
                            writable: false
                        });
                        Buffer.poolSize = 8192 // not used by this implementation
                        ;
                        function from(value, encodingOrOffset, length) {
                            if (typeof value === "string") return fromString(value, encodingOrOffset);
                            if (ArrayBuffer.isView(value)) return fromArrayLike(value);
                            if (value == null) throw TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
                            if (isInstance(value, ArrayBuffer) || value && isInstance(value.buffer, ArrayBuffer)) return fromArrayBuffer(value, encodingOrOffset, length);
                            if (typeof value === "number") throw new TypeError('The "value" argument must not be of type number. Received type number');
                            var valueOf = value.valueOf && value.valueOf();
                            if (valueOf != null && valueOf !== value) return Buffer.from(valueOf, encodingOrOffset, length);
                            var b = fromObject(value);
                            if (b) return b;
                            if (typeof Symbol !== "undefined" && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === "function") return Buffer.from(value[Symbol.toPrimitive]("string"), encodingOrOffset, length);
                            throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
                        }
                        /**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ Buffer.from = function(value, encodingOrOffset, length) {
                            return from(value, encodingOrOffset, length);
                        };
                        // Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
                        // https://github.com/feross/buffer/pull/148
                        Buffer.prototype.__proto__ = Uint8Array.prototype;
                        Buffer.__proto__ = Uint8Array;
                        function assertSize(size) {
                            if (typeof size !== "number") throw new TypeError('"size" argument must be of type number');
                            else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
                        }
                        function alloc(size, fill, encoding) {
                            assertSize(size);
                            if (size <= 0) return createBuffer(size);
                            if (fill !== undefined) // Only pay attention to encoding if it's a string. This
                            // prevents accidentally sending in a number that would
                            // be interpretted as a start offset.
                            return typeof encoding === "string" ? createBuffer(size).fill(fill, encoding) : createBuffer(size).fill(fill);
                            return createBuffer(size);
                        }
                        /**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ Buffer.alloc = function(size, fill, encoding) {
                            return alloc(size, fill, encoding);
                        };
                        function allocUnsafe(size) {
                            assertSize(size);
                            return createBuffer(size < 0 ? 0 : checked(size) | 0);
                        }
                        /**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ Buffer.allocUnsafe = function(size) {
                            return allocUnsafe(size);
                        };
                        /**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ Buffer.allocUnsafeSlow = function(size) {
                            return allocUnsafe(size);
                        };
                        function fromString(string, encoding) {
                            if (typeof encoding !== "string" || encoding === "") encoding = "utf8";
                            if (!Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
                            var length = byteLength(string, encoding) | 0;
                            var buf = createBuffer(length);
                            var actual = buf.write(string, encoding);
                            if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
                            // cause everything after the first invalid character to be ignored. (e.g.
                            // 'abxxcd' will be treated as 'ab')
                            buf = buf.slice(0, actual);
                            return buf;
                        }
                        function fromArrayLike(array) {
                            var length = array.length < 0 ? 0 : checked(array.length) | 0;
                            var buf = createBuffer(length);
                            for(var i = 0; i < length; i += 1)buf[i] = array[i] & 255;
                            return buf;
                        }
                        function fromArrayBuffer(array, byteOffset, length) {
                            if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
                            if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
                            var buf;
                            if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
                            else if (length === undefined) buf = new Uint8Array(array, byteOffset);
                            else buf = new Uint8Array(array, byteOffset, length);
                            // Return an augmented `Uint8Array` instance
                            buf.__proto__ = Buffer.prototype;
                            return buf;
                        }
                        function fromObject(obj) {
                            if (Buffer.isBuffer(obj)) {
                                var len = checked(obj.length) | 0;
                                var buf = createBuffer(len);
                                if (buf.length === 0) return buf;
                                obj.copy(buf, 0, 0, len);
                                return buf;
                            }
                            if (obj.length !== undefined) {
                                if (typeof obj.length !== "number" || numberIsNaN(obj.length)) return createBuffer(0);
                                return fromArrayLike(obj);
                            }
                            if (obj.type === "Buffer" && Array.isArray(obj.data)) return fromArrayLike(obj.data);
                        }
                        function checked(length) {
                            // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
                            // length is NaN (which is otherwise coerced to zero.)
                            if (length >= K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + K_MAX_LENGTH.toString(16) + " bytes");
                            return length | 0;
                        }
                        function SlowBuffer(length) {
                            if (+length != length) length = 0;
                            return Buffer.alloc(+length);
                        }
                        Buffer.isBuffer = function isBuffer(b) {
                            return b != null && b._isBuffer === true && b !== Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
                            ;
                        };
                        Buffer.compare = function compare(a, b) {
                            if (isInstance(a, Uint8Array)) a = Buffer.from(a, a.offset, a.byteLength);
                            if (isInstance(b, Uint8Array)) b = Buffer.from(b, b.offset, b.byteLength);
                            if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
                            if (a === b) return 0;
                            var x = a.length;
                            var y = b.length;
                            for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
                                x = a[i];
                                y = b[i];
                                break;
                            }
                            if (x < y) return -1;
                            if (y < x) return 1;
                            return 0;
                        };
                        Buffer.isEncoding = function isEncoding(encoding) {
                            switch(String(encoding).toLowerCase()){
                                case "hex":
                                case "utf8":
                                case "utf-8":
                                case "ascii":
                                case "latin1":
                                case "binary":
                                case "base64":
                                case "ucs2":
                                case "ucs-2":
                                case "utf16le":
                                case "utf-16le":
                                    return true;
                                default:
                                    return false;
                            }
                        };
                        Buffer.concat = function concat(list, length) {
                            if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
                            if (list.length === 0) return Buffer.alloc(0);
                            var i;
                            if (length === undefined) {
                                length = 0;
                                for(i = 0; i < list.length; ++i)length += list[i].length;
                            }
                            var buffer = Buffer.allocUnsafe(length);
                            var pos = 0;
                            for(i = 0; i < list.length; ++i){
                                var buf = list[i];
                                if (isInstance(buf, Uint8Array)) buf = Buffer.from(buf);
                                if (!Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
                                buf.copy(buffer, pos);
                                pos += buf.length;
                            }
                            return buffer;
                        };
                        function byteLength(string, encoding) {
                            if (Buffer.isBuffer(string)) return string.length;
                            if (ArrayBuffer.isView(string) || isInstance(string, ArrayBuffer)) return string.byteLength;
                            if (typeof string !== "string") throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
                            var len = string.length;
                            var mustMatch = arguments.length > 2 && arguments[2] === true;
                            if (!mustMatch && len === 0) return 0;
                            // Use a for loop to avoid recursion
                            var loweredCase = false;
                            for(;;)switch(encoding){
                                case "ascii":
                                case "latin1":
                                case "binary":
                                    return len;
                                case "utf8":
                                case "utf-8":
                                    return utf8ToBytes(string).length;
                                case "ucs2":
                                case "ucs-2":
                                case "utf16le":
                                case "utf-16le":
                                    return len * 2;
                                case "hex":
                                    return len >>> 1;
                                case "base64":
                                    return base64ToBytes(string).length;
                                default:
                                    if (loweredCase) return mustMatch ? -1 : utf8ToBytes(string).length // assume utf8
                                    ;
                                    encoding = ("" + encoding).toLowerCase();
                                    loweredCase = true;
                            }
                        }
                        Buffer.byteLength = byteLength;
                        function slowToString(encoding, start, end) {
                            var loweredCase = false;
                            // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
                            // property of a typed array.
                            // This behaves neither like String nor Uint8Array in that we set start/end
                            // to their upper/lower bounds if the value passed is out of range.
                            // undefined is handled specially as per ECMA-262 6th Edition,
                            // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
                            if (start === undefined || start < 0) start = 0;
                            // Return early if start > this.length. Done here to prevent potential uint32
                            // coercion fail below.
                            if (start > this.length) return "";
                            if (end === undefined || end > this.length) end = this.length;
                            if (end <= 0) return "";
                            // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
                            end >>>= 0;
                            start >>>= 0;
                            if (end <= start) return "";
                            if (!encoding) encoding = "utf8";
                            while(true)switch(encoding){
                                case "hex":
                                    return hexSlice(this, start, end);
                                case "utf8":
                                case "utf-8":
                                    return utf8Slice(this, start, end);
                                case "ascii":
                                    return asciiSlice(this, start, end);
                                case "latin1":
                                case "binary":
                                    return latin1Slice(this, start, end);
                                case "base64":
                                    return base64Slice(this, start, end);
                                case "ucs2":
                                case "ucs-2":
                                case "utf16le":
                                case "utf-16le":
                                    return utf16leSlice(this, start, end);
                                default:
                                    if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
                                    encoding = (encoding + "").toLowerCase();
                                    loweredCase = true;
                            }
                        }
                        // This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
                        // to detect a Buffer instance. It's not possible to use `instanceof Buffer`
                        // reliably in a browserify context because there could be multiple different
                        // copies of the 'buffer' package in use. This method works even for Buffer
                        // instances that were created from another copy of the `buffer` package.
                        // See: https://github.com/feross/buffer/issues/154
                        Buffer.prototype._isBuffer = true;
                        function swap(b, n, m) {
                            var i = b[n];
                            b[n] = b[m];
                            b[m] = i;
                        }
                        Buffer.prototype.swap16 = function swap16() {
                            var len = this.length;
                            if (len % 2 !== 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
                            for(var i = 0; i < len; i += 2)swap(this, i, i + 1);
                            return this;
                        };
                        Buffer.prototype.swap32 = function swap32() {
                            var len = this.length;
                            if (len % 4 !== 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
                            for(var i = 0; i < len; i += 4){
                                swap(this, i, i + 3);
                                swap(this, i + 1, i + 2);
                            }
                            return this;
                        };
                        Buffer.prototype.swap64 = function swap64() {
                            var len = this.length;
                            if (len % 8 !== 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
                            for(var i = 0; i < len; i += 8){
                                swap(this, i, i + 7);
                                swap(this, i + 1, i + 6);
                                swap(this, i + 2, i + 5);
                                swap(this, i + 3, i + 4);
                            }
                            return this;
                        };
                        Buffer.prototype.toString = function toString() {
                            var length = this.length;
                            if (length === 0) return "";
                            if (arguments.length === 0) return utf8Slice(this, 0, length);
                            return slowToString.apply(this, arguments);
                        };
                        Buffer.prototype.toLocaleString = Buffer.prototype.toString;
                        Buffer.prototype.equals = function equals(b) {
                            if (!Buffer.isBuffer(b)) throw new TypeError("Argument must be a Buffer");
                            if (this === b) return true;
                            return Buffer.compare(this, b) === 0;
                        };
                        Buffer.prototype.inspect = function inspect() {
                            var str = "";
                            var max = exports.INSPECT_MAX_BYTES;
                            str = this.toString("hex", 0, max).replace(/(.{2})/g, "$1 ").trim();
                            if (this.length > max) str += " ... ";
                            return "<Buffer " + str + ">";
                        };
                        Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
                            if (isInstance(target, Uint8Array)) target = Buffer.from(target, target.offset, target.byteLength);
                            if (!Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
                            if (start === undefined) start = 0;
                            if (end === undefined) end = target ? target.length : 0;
                            if (thisStart === undefined) thisStart = 0;
                            if (thisEnd === undefined) thisEnd = this.length;
                            if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError("out of range index");
                            if (thisStart >= thisEnd && start >= end) return 0;
                            if (thisStart >= thisEnd) return -1;
                            if (start >= end) return 1;
                            start >>>= 0;
                            end >>>= 0;
                            thisStart >>>= 0;
                            thisEnd >>>= 0;
                            if (this === target) return 0;
                            var x = thisEnd - thisStart;
                            var y = end - start;
                            var len = Math.min(x, y);
                            var thisCopy = this.slice(thisStart, thisEnd);
                            var targetCopy = target.slice(start, end);
                            for(var i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
                                x = thisCopy[i];
                                y = targetCopy[i];
                                break;
                            }
                            if (x < y) return -1;
                            if (y < x) return 1;
                            return 0;
                        };
                        // Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
                        // OR the last index of `val` in `buffer` at offset <= `byteOffset`.
                        //
                        // Arguments:
                        // - buffer - a Buffer to search
                        // - val - a string, Buffer, or number
                        // - byteOffset - an index into `buffer`; will be clamped to an int32
                        // - encoding - an optional encoding, relevant is val is a string
                        // - dir - true for indexOf, false for lastIndexOf
                        function bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
                            // Empty buffer means no match
                            if (buffer.length === 0) return -1;
                            // Normalize byteOffset
                            if (typeof byteOffset === "string") {
                                encoding = byteOffset;
                                byteOffset = 0;
                            } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
                            else if (byteOffset < -2147483648) byteOffset = -2147483648;
                            byteOffset = +byteOffset // Coerce to Number.
                            ;
                            if (numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
                            byteOffset = dir ? 0 : buffer.length - 1;
                            // Normalize byteOffset: negative offsets start from the end of the buffer
                            if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
                            if (byteOffset >= buffer.length) {
                                if (dir) return -1;
                                else byteOffset = buffer.length - 1;
                            } else if (byteOffset < 0) {
                                if (dir) byteOffset = 0;
                                else return -1;
                            }
                            // Normalize val
                            if (typeof val === "string") val = Buffer.from(val, encoding);
                            // Finally, search either indexOf (if dir is true) or lastIndexOf
                            if (Buffer.isBuffer(val)) {
                                // Special case: looking for empty string/buffer always fails
                                if (val.length === 0) return -1;
                                return arrayIndexOf(buffer, val, byteOffset, encoding, dir);
                            } else if (typeof val === "number") {
                                val = val & 0xFF // Search for a byte value [0-255]
                                ;
                                if (typeof Uint8Array.prototype.indexOf === "function") {
                                    if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
                                    else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
                                }
                                return arrayIndexOf(buffer, [
                                    val
                                ], byteOffset, encoding, dir);
                            }
                            throw new TypeError("val must be string, number or Buffer");
                        }
                        function arrayIndexOf(arr, val, byteOffset, encoding, dir) {
                            var indexSize = 1;
                            var arrLength = arr.length;
                            var valLength = val.length;
                            if (encoding !== undefined) {
                                encoding = String(encoding).toLowerCase();
                                if (encoding === "ucs2" || encoding === "ucs-2" || encoding === "utf16le" || encoding === "utf-16le") {
                                    if (arr.length < 2 || val.length < 2) return -1;
                                    indexSize = 2;
                                    arrLength /= 2;
                                    valLength /= 2;
                                    byteOffset /= 2;
                                }
                            }
                            function read(buf, i) {
                                if (indexSize === 1) return buf[i];
                                else return buf.readUInt16BE(i * indexSize);
                            }
                            var i;
                            if (dir) {
                                var foundIndex = -1;
                                for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
                                    if (foundIndex === -1) foundIndex = i;
                                    if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
                                } else {
                                    if (foundIndex !== -1) i -= i - foundIndex;
                                    foundIndex = -1;
                                }
                            } else {
                                if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
                                for(i = byteOffset; i >= 0; i--){
                                    var found = true;
                                    for(var j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                                        found = false;
                                        break;
                                    }
                                    if (found) return i;
                                }
                            }
                            return -1;
                        }
                        Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
                            return this.indexOf(val, byteOffset, encoding) !== -1;
                        };
                        Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
                            return bidirectionalIndexOf(this, val, byteOffset, encoding, true);
                        };
                        Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
                            return bidirectionalIndexOf(this, val, byteOffset, encoding, false);
                        };
                        function hexWrite(buf, string, offset, length) {
                            offset = Number(offset) || 0;
                            var remaining = buf.length - offset;
                            if (!length) length = remaining;
                            else {
                                length = Number(length);
                                if (length > remaining) length = remaining;
                            }
                            var strLen = string.length;
                            if (length > strLen / 2) length = strLen / 2;
                            for(var i = 0; i < length; ++i){
                                var parsed = parseInt(string.substr(i * 2, 2), 16);
                                if (numberIsNaN(parsed)) return i;
                                buf[offset + i] = parsed;
                            }
                            return i;
                        }
                        function utf8Write(buf, string, offset, length) {
                            return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length);
                        }
                        function asciiWrite(buf, string, offset, length) {
                            return blitBuffer(asciiToBytes(string), buf, offset, length);
                        }
                        function latin1Write(buf, string, offset, length) {
                            return asciiWrite(buf, string, offset, length);
                        }
                        function base64Write(buf, string, offset, length) {
                            return blitBuffer(base64ToBytes(string), buf, offset, length);
                        }
                        function ucs2Write(buf, string, offset, length) {
                            return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length);
                        }
                        Buffer.prototype.write = function write(string, offset, length, encoding) {
                            // Buffer#write(string)
                            if (offset === undefined) {
                                encoding = "utf8";
                                length = this.length;
                                offset = 0;
                            // Buffer#write(string, encoding)
                            } else if (length === undefined && typeof offset === "string") {
                                encoding = offset;
                                length = this.length;
                                offset = 0;
                            // Buffer#write(string, offset[, length][, encoding])
                            } else if (isFinite(offset)) {
                                offset = offset >>> 0;
                                if (isFinite(length)) {
                                    length = length >>> 0;
                                    if (encoding === undefined) encoding = "utf8";
                                } else {
                                    encoding = length;
                                    length = undefined;
                                }
                            } else throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
                            var remaining = this.length - offset;
                            if (length === undefined || length > remaining) length = remaining;
                            if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError("Attempt to write outside buffer bounds");
                            if (!encoding) encoding = "utf8";
                            var loweredCase = false;
                            for(;;)switch(encoding){
                                case "hex":
                                    return hexWrite(this, string, offset, length);
                                case "utf8":
                                case "utf-8":
                                    return utf8Write(this, string, offset, length);
                                case "ascii":
                                    return asciiWrite(this, string, offset, length);
                                case "latin1":
                                case "binary":
                                    return latin1Write(this, string, offset, length);
                                case "base64":
                                    // Warning: maxLength not taken into account in base64Write
                                    return base64Write(this, string, offset, length);
                                case "ucs2":
                                case "ucs-2":
                                case "utf16le":
                                case "utf-16le":
                                    return ucs2Write(this, string, offset, length);
                                default:
                                    if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
                                    encoding = ("" + encoding).toLowerCase();
                                    loweredCase = true;
                            }
                        };
                        Buffer.prototype.toJSON = function toJSON() {
                            return {
                                type: "Buffer",
                                data: Array.prototype.slice.call(this._arr || this, 0)
                            };
                        };
                        function base64Slice(buf, start, end) {
                            if (start === 0 && end === buf.length) return base64.fromByteArray(buf);
                            else return base64.fromByteArray(buf.slice(start, end));
                        }
                        function utf8Slice(buf, start, end) {
                            end = Math.min(buf.length, end);
                            var res = [];
                            var i = start;
                            while(i < end){
                                var firstByte = buf[i];
                                var codePoint = null;
                                var bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
                                if (i + bytesPerSequence <= end) {
                                    var secondByte, thirdByte, fourthByte, tempCodePoint;
                                    switch(bytesPerSequence){
                                        case 1:
                                            if (firstByte < 0x80) codePoint = firstByte;
                                            break;
                                        case 2:
                                            secondByte = buf[i + 1];
                                            if ((secondByte & 0xC0) === 0x80) {
                                                tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                                                if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                                            }
                                            break;
                                        case 3:
                                            secondByte = buf[i + 1];
                                            thirdByte = buf[i + 2];
                                            if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                                                tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                                                if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                                            }
                                            break;
                                        case 4:
                                            secondByte = buf[i + 1];
                                            thirdByte = buf[i + 2];
                                            fourthByte = buf[i + 3];
                                            if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                                                tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                                                if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                                            }
                                    }
                                }
                                if (codePoint === null) {
                                    // we did not generate a valid codePoint so insert a
                                    // replacement char (U+FFFD) and advance only 1 byte
                                    codePoint = 0xFFFD;
                                    bytesPerSequence = 1;
                                } else if (codePoint > 0xFFFF) {
                                    // encode to utf16 (surrogate pair dance)
                                    codePoint -= 0x10000;
                                    res.push(codePoint >>> 10 & 0x3FF | 0xD800);
                                    codePoint = 0xDC00 | codePoint & 0x3FF;
                                }
                                res.push(codePoint);
                                i += bytesPerSequence;
                            }
                            return decodeCodePointsArray(res);
                        }
                        // Based on http://stackoverflow.com/a/22747272/680742, the browser with
                        // the lowest limit is Chrome, with 0x10000 args.
                        // We go 1 magnitude less, for safety
                        var MAX_ARGUMENTS_LENGTH = 0x1000;
                        function decodeCodePointsArray(codePoints) {
                            var len = codePoints.length;
                            if (len <= MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
                            ;
                            // Decode in chunks to avoid "call stack size exceeded".
                            var res = "";
                            var i = 0;
                            while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH));
                            return res;
                        }
                        function asciiSlice(buf, start, end) {
                            var ret = "";
                            end = Math.min(buf.length, end);
                            for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
                            return ret;
                        }
                        function latin1Slice(buf, start, end) {
                            var ret = "";
                            end = Math.min(buf.length, end);
                            for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
                            return ret;
                        }
                        function hexSlice(buf, start, end) {
                            var len = buf.length;
                            if (!start || start < 0) start = 0;
                            if (!end || end < 0 || end > len) end = len;
                            var out = "";
                            for(var i = start; i < end; ++i)out += toHex(buf[i]);
                            return out;
                        }
                        function utf16leSlice(buf, start, end) {
                            var bytes = buf.slice(start, end);
                            var res = "";
                            for(var i = 0; i < bytes.length; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
                            return res;
                        }
                        Buffer.prototype.slice = function slice(start, end) {
                            var len = this.length;
                            start = ~~start;
                            end = end === undefined ? len : ~~end;
                            if (start < 0) {
                                start += len;
                                if (start < 0) start = 0;
                            } else if (start > len) start = len;
                            if (end < 0) {
                                end += len;
                                if (end < 0) end = 0;
                            } else if (end > len) end = len;
                            if (end < start) end = start;
                            var newBuf = this.subarray(start, end);
                            // Return an augmented `Uint8Array` instance
                            newBuf.__proto__ = Buffer.prototype;
                            return newBuf;
                        };
                        /*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function checkOffset(offset, ext, length) {
                            if (offset % 1 !== 0 || offset < 0) throw new RangeError("offset is not uint");
                            if (offset + ext > length) throw new RangeError("Trying to access beyond buffer length");
                        }
                        Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
                            offset = offset >>> 0;
                            byteLength = byteLength >>> 0;
                            if (!noAssert) checkOffset(offset, byteLength, this.length);
                            var val = this[offset];
                            var mul = 1;
                            var i = 0;
                            while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
                            return val;
                        };
                        Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
                            offset = offset >>> 0;
                            byteLength = byteLength >>> 0;
                            if (!noAssert) checkOffset(offset, byteLength, this.length);
                            var val = this[offset + --byteLength];
                            var mul = 1;
                            while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
                            return val;
                        };
                        Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
                            offset = offset >>> 0;
                            if (!noAssert) checkOffset(offset, 1, this.length);
                            return this[offset];
                        };
                        Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
                            offset = offset >>> 0;
                            if (!noAssert) checkOffset(offset, 2, this.length);
                            return this[offset] | this[offset + 1] << 8;
                        };
                        Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
                            offset = offset >>> 0;
                            if (!noAssert) checkOffset(offset, 2, this.length);
                            return this[offset] << 8 | this[offset + 1];
                        };
                        Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
                            offset = offset >>> 0;
                            if (!noAssert) checkOffset(offset, 4, this.length);
                            return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
                        };
                        Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
                            offset = offset >>> 0;
                            if (!noAssert) checkOffset(offset, 4, this.length);
                            return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
                        };
                        Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
                            offset = offset >>> 0;
                            byteLength = byteLength >>> 0;
                            if (!noAssert) checkOffset(offset, byteLength, this.length);
                            var val = this[offset];
                            var mul = 1;
                            var i = 0;
                            while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
                            mul *= 0x80;
                            if (val >= mul) val -= Math.pow(2, 8 * byteLength);
                            return val;
                        };
                        Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
                            offset = offset >>> 0;
                            byteLength = byteLength >>> 0;
                            if (!noAssert) checkOffset(offset, byteLength, this.length);
                            var i = byteLength;
                            var mul = 1;
                            var val = this[offset + --i];
                            while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
                            mul *= 0x80;
                            if (val >= mul) val -= Math.pow(2, 8 * byteLength);
                            return val;
                        };
                        Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
                            offset = offset >>> 0;
                            if (!noAssert) checkOffset(offset, 1, this.length);
                            if (!(this[offset] & 0x80)) return this[offset];
                            return (0xff - this[offset] + 1) * -1;
                        };
                        Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
                            offset = offset >>> 0;
                            if (!noAssert) checkOffset(offset, 2, this.length);
                            var val = this[offset] | this[offset + 1] << 8;
                            return val & 0x8000 ? val | 0xFFFF0000 : val;
                        };
                        Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
                            offset = offset >>> 0;
                            if (!noAssert) checkOffset(offset, 2, this.length);
                            var val = this[offset + 1] | this[offset] << 8;
                            return val & 0x8000 ? val | 0xFFFF0000 : val;
                        };
                        Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
                            offset = offset >>> 0;
                            if (!noAssert) checkOffset(offset, 4, this.length);
                            return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
                        };
                        Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
                            offset = offset >>> 0;
                            if (!noAssert) checkOffset(offset, 4, this.length);
                            return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
                        };
                        Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
                            offset = offset >>> 0;
                            if (!noAssert) checkOffset(offset, 4, this.length);
                            return ieee754.read(this, offset, true, 23, 4);
                        };
                        Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
                            offset = offset >>> 0;
                            if (!noAssert) checkOffset(offset, 4, this.length);
                            return ieee754.read(this, offset, false, 23, 4);
                        };
                        Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
                            offset = offset >>> 0;
                            if (!noAssert) checkOffset(offset, 8, this.length);
                            return ieee754.read(this, offset, true, 52, 8);
                        };
                        Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
                            offset = offset >>> 0;
                            if (!noAssert) checkOffset(offset, 8, this.length);
                            return ieee754.read(this, offset, false, 52, 8);
                        };
                        function checkInt(buf, value, offset, ext, max, min) {
                            if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
                            if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
                            if (offset + ext > buf.length) throw new RangeError("Index out of range");
                        }
                        Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
                            value = +value;
                            offset = offset >>> 0;
                            byteLength = byteLength >>> 0;
                            if (!noAssert) {
                                var maxBytes = Math.pow(2, 8 * byteLength) - 1;
                                checkInt(this, value, offset, byteLength, maxBytes, 0);
                            }
                            var mul = 1;
                            var i = 0;
                            this[offset] = value & 0xFF;
                            while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
                            return offset + byteLength;
                        };
                        Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
                            value = +value;
                            offset = offset >>> 0;
                            byteLength = byteLength >>> 0;
                            if (!noAssert) {
                                var maxBytes = Math.pow(2, 8 * byteLength) - 1;
                                checkInt(this, value, offset, byteLength, maxBytes, 0);
                            }
                            var i = byteLength - 1;
                            var mul = 1;
                            this[offset + i] = value & 0xFF;
                            while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
                            return offset + byteLength;
                        };
                        Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
                            value = +value;
                            offset = offset >>> 0;
                            if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0);
                            this[offset] = value & 0xff;
                            return offset + 1;
                        };
                        Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
                            value = +value;
                            offset = offset >>> 0;
                            if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0);
                            this[offset] = value & 0xff;
                            this[offset + 1] = value >>> 8;
                            return offset + 2;
                        };
                        Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
                            value = +value;
                            offset = offset >>> 0;
                            if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0);
                            this[offset] = value >>> 8;
                            this[offset + 1] = value & 0xff;
                            return offset + 2;
                        };
                        Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
                            value = +value;
                            offset = offset >>> 0;
                            if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0);
                            this[offset + 3] = value >>> 24;
                            this[offset + 2] = value >>> 16;
                            this[offset + 1] = value >>> 8;
                            this[offset] = value & 0xff;
                            return offset + 4;
                        };
                        Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
                            value = +value;
                            offset = offset >>> 0;
                            if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0);
                            this[offset] = value >>> 24;
                            this[offset + 1] = value >>> 16;
                            this[offset + 2] = value >>> 8;
                            this[offset + 3] = value & 0xff;
                            return offset + 4;
                        };
                        Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
                            value = +value;
                            offset = offset >>> 0;
                            if (!noAssert) {
                                var limit = Math.pow(2, 8 * byteLength - 1);
                                checkInt(this, value, offset, byteLength, limit - 1, -limit);
                            }
                            var i = 0;
                            var mul = 1;
                            var sub = 0;
                            this[offset] = value & 0xFF;
                            while(++i < byteLength && (mul *= 0x100)){
                                if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
                                this[offset + i] = (value / mul >> 0) - sub & 0xFF;
                            }
                            return offset + byteLength;
                        };
                        Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
                            value = +value;
                            offset = offset >>> 0;
                            if (!noAssert) {
                                var limit = Math.pow(2, 8 * byteLength - 1);
                                checkInt(this, value, offset, byteLength, limit - 1, -limit);
                            }
                            var i = byteLength - 1;
                            var mul = 1;
                            var sub = 0;
                            this[offset + i] = value & 0xFF;
                            while(--i >= 0 && (mul *= 0x100)){
                                if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
                                this[offset + i] = (value / mul >> 0) - sub & 0xFF;
                            }
                            return offset + byteLength;
                        };
                        Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
                            value = +value;
                            offset = offset >>> 0;
                            if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -128);
                            if (value < 0) value = 0xff + value + 1;
                            this[offset] = value & 0xff;
                            return offset + 1;
                        };
                        Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
                            value = +value;
                            offset = offset >>> 0;
                            if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -32768);
                            this[offset] = value & 0xff;
                            this[offset + 1] = value >>> 8;
                            return offset + 2;
                        };
                        Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
                            value = +value;
                            offset = offset >>> 0;
                            if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -32768);
                            this[offset] = value >>> 8;
                            this[offset + 1] = value & 0xff;
                            return offset + 2;
                        };
                        Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
                            value = +value;
                            offset = offset >>> 0;
                            if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
                            this[offset] = value & 0xff;
                            this[offset + 1] = value >>> 8;
                            this[offset + 2] = value >>> 16;
                            this[offset + 3] = value >>> 24;
                            return offset + 4;
                        };
                        Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
                            value = +value;
                            offset = offset >>> 0;
                            if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
                            if (value < 0) value = 0xffffffff + value + 1;
                            this[offset] = value >>> 24;
                            this[offset + 1] = value >>> 16;
                            this[offset + 2] = value >>> 8;
                            this[offset + 3] = value & 0xff;
                            return offset + 4;
                        };
                        function checkIEEE754(buf, value, offset, ext, max, min) {
                            if (offset + ext > buf.length) throw new RangeError("Index out of range");
                            if (offset < 0) throw new RangeError("Index out of range");
                        }
                        function writeFloat(buf, value, offset, littleEndian, noAssert) {
                            value = +value;
                            offset = offset >>> 0;
                            if (!noAssert) checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
                            ieee754.write(buf, value, offset, littleEndian, 23, 4);
                            return offset + 4;
                        }
                        Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
                            return writeFloat(this, value, offset, true, noAssert);
                        };
                        Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
                            return writeFloat(this, value, offset, false, noAssert);
                        };
                        function writeDouble(buf, value, offset, littleEndian, noAssert) {
                            value = +value;
                            offset = offset >>> 0;
                            if (!noAssert) checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
                            ieee754.write(buf, value, offset, littleEndian, 52, 8);
                            return offset + 8;
                        }
                        Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
                            return writeDouble(this, value, offset, true, noAssert);
                        };
                        Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
                            return writeDouble(this, value, offset, false, noAssert);
                        };
                        // copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
                        Buffer.prototype.copy = function copy(target, targetStart, start, end) {
                            if (!Buffer.isBuffer(target)) throw new TypeError("argument should be a Buffer");
                            if (!start) start = 0;
                            if (!end && end !== 0) end = this.length;
                            if (targetStart >= target.length) targetStart = target.length;
                            if (!targetStart) targetStart = 0;
                            if (end > 0 && end < start) end = start;
                            // Copy 0 bytes; we're done
                            if (end === start) return 0;
                            if (target.length === 0 || this.length === 0) return 0;
                            // Fatal error conditions
                            if (targetStart < 0) throw new RangeError("targetStart out of bounds");
                            if (start < 0 || start >= this.length) throw new RangeError("Index out of range");
                            if (end < 0) throw new RangeError("sourceEnd out of bounds");
                            // Are we oob?
                            if (end > this.length) end = this.length;
                            if (target.length - targetStart < end - start) end = target.length - targetStart + start;
                            var len = end - start;
                            if (this === target && typeof Uint8Array.prototype.copyWithin === "function") // Use built-in when available, missing from IE11
                            this.copyWithin(targetStart, start, end);
                            else if (this === target && start < targetStart && targetStart < end) // descending copy from end
                            for(var i = len - 1; i >= 0; --i)target[i + targetStart] = this[i + start];
                            else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
                            return len;
                        };
                        // Usage:
                        //    buffer.fill(number[, offset[, end]])
                        //    buffer.fill(buffer[, offset[, end]])
                        //    buffer.fill(string[, offset[, end]][, encoding])
                        Buffer.prototype.fill = function fill(val, start, end, encoding) {
                            // Handle string cases:
                            if (typeof val === "string") {
                                if (typeof start === "string") {
                                    encoding = start;
                                    start = 0;
                                    end = this.length;
                                } else if (typeof end === "string") {
                                    encoding = end;
                                    end = this.length;
                                }
                                if (encoding !== undefined && typeof encoding !== "string") throw new TypeError("encoding must be a string");
                                if (typeof encoding === "string" && !Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
                                if (val.length === 1) {
                                    var code = val.charCodeAt(0);
                                    if (encoding === "utf8" && code < 128 || encoding === "latin1") // Fast path: If `val` fits into a single byte, use that numeric value.
                                    val = code;
                                }
                            } else if (typeof val === "number") val = val & 255;
                            // Invalid ranges are not set to a default, so can range check early.
                            if (start < 0 || this.length < start || this.length < end) throw new RangeError("Out of range index");
                            if (end <= start) return this;
                            start = start >>> 0;
                            end = end === undefined ? this.length : end >>> 0;
                            if (!val) val = 0;
                            var i;
                            if (typeof val === "number") for(i = start; i < end; ++i)this[i] = val;
                            else {
                                var bytes = Buffer.isBuffer(val) ? val : Buffer.from(val, encoding);
                                var len = bytes.length;
                                if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
                                for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
                            }
                            return this;
                        };
                        // HELPER FUNCTIONS
                        // ================
                        var INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
                        function base64clean(str) {
                            // Node takes equal signs as end of the Base64 encoding
                            str = str.split("=")[0];
                            // Node strips out invalid characters like \n and \t from the string, base64-js does not
                            str = str.trim().replace(INVALID_BASE64_RE, "");
                            // Node converts strings with length < 2 to ''
                            if (str.length < 2) return "";
                            // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
                            while(str.length % 4 !== 0)str = str + "=";
                            return str;
                        }
                        function toHex(n) {
                            if (n < 16) return "0" + n.toString(16);
                            return n.toString(16);
                        }
                        function utf8ToBytes(string, units) {
                            units = units || Infinity;
                            var codePoint;
                            var length = string.length;
                            var leadSurrogate = null;
                            var bytes = [];
                            for(var i = 0; i < length; ++i){
                                codePoint = string.charCodeAt(i);
                                // is surrogate component
                                if (codePoint > 0xD7FF && codePoint < 0xE000) {
                                    // last char was a lead
                                    if (!leadSurrogate) {
                                        // no lead yet
                                        if (codePoint > 0xDBFF) {
                                            // unexpected trail
                                            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                                            continue;
                                        } else if (i + 1 === length) {
                                            // unpaired lead
                                            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                                            continue;
                                        }
                                        // valid lead
                                        leadSurrogate = codePoint;
                                        continue;
                                    }
                                    // 2 leads in a row
                                    if (codePoint < 0xDC00) {
                                        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                                        leadSurrogate = codePoint;
                                        continue;
                                    }
                                    // valid surrogate pair
                                    codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
                                } else if (leadSurrogate) // valid bmp char, but last char was a lead
                                {
                                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                                }
                                leadSurrogate = null;
                                // encode utf8
                                if (codePoint < 0x80) {
                                    if ((units -= 1) < 0) break;
                                    bytes.push(codePoint);
                                } else if (codePoint < 0x800) {
                                    if ((units -= 2) < 0) break;
                                    bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
                                } else if (codePoint < 0x10000) {
                                    if ((units -= 3) < 0) break;
                                    bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
                                } else if (codePoint < 0x110000) {
                                    if ((units -= 4) < 0) break;
                                    bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
                                } else throw new Error("Invalid code point");
                            }
                            return bytes;
                        }
                        function asciiToBytes(str) {
                            var byteArray = [];
                            for(var i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
                            byteArray.push(str.charCodeAt(i) & 0xFF);
                            return byteArray;
                        }
                        function utf16leToBytes(str, units) {
                            var c, hi, lo;
                            var byteArray = [];
                            for(var i = 0; i < str.length; ++i){
                                if ((units -= 2) < 0) break;
                                c = str.charCodeAt(i);
                                hi = c >> 8;
                                lo = c % 256;
                                byteArray.push(lo);
                                byteArray.push(hi);
                            }
                            return byteArray;
                        }
                        function base64ToBytes(str) {
                            return base64.toByteArray(base64clean(str));
                        }
                        function blitBuffer(src, dst, offset, length) {
                            for(var i = 0; i < length; ++i){
                                if (i + offset >= dst.length || i >= src.length) break;
                                dst[i + offset] = src[i];
                            }
                            return i;
                        }
                        // ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
                        // the `instanceof` check but they should be treated as of that type.
                        // See: https://github.com/feross/buffer/issues/166
                        function isInstance(obj, type) {
                            return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
                        }
                        function numberIsNaN(obj) {
                            // For IE11 support
                            return obj !== obj // eslint-disable-line no-self-compare
                            ;
                        }
                    }).call(this);
                }).call(this, require("buffer").Buffer);
            },
            {
                "base64-js": 33,
                "buffer": 35,
                "ieee754": 37
            }
        ],
        36: [
            function(require, module, exports) {
                // Copyright Joyent, Inc. and other Node contributors.
                //
                // Permission is hereby granted, free of charge, to any person obtaining a
                // copy of this software and associated documentation files (the
                // "Software"), to deal in the Software without restriction, including
                // without limitation the rights to use, copy, modify, merge, publish,
                // distribute, sublicense, and/or sell copies of the Software, and to permit
                // persons to whom the Software is furnished to do so, subject to the
                // following conditions:
                //
                // The above copyright notice and this permission notice shall be included
                // in all copies or substantial portions of the Software.
                //
                // THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
                // OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
                // MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
                // NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
                // DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
                // OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
                // USE OR OTHER DEALINGS IN THE SOFTWARE.
                "use strict";
                var R = typeof Reflect === "object" ? Reflect : null;
                var ReflectApply = R && typeof R.apply === "function" ? R.apply : function ReflectApply(target, receiver, args) {
                    return Function.prototype.apply.call(target, receiver, args);
                };
                var ReflectOwnKeys;
                if (R && typeof R.ownKeys === "function") ReflectOwnKeys = R.ownKeys;
                else if (Object.getOwnPropertySymbols) ReflectOwnKeys = function ReflectOwnKeys(target) {
                    return Object.getOwnPropertyNames(target).concat(Object.getOwnPropertySymbols(target));
                };
                else ReflectOwnKeys = function ReflectOwnKeys(target) {
                    return Object.getOwnPropertyNames(target);
                };
                function ProcessEmitWarning(warning) {
                    if (console && console.warn) console.warn(warning);
                }
                var NumberIsNaN = Number.isNaN || function NumberIsNaN(value) {
                    return value !== value;
                };
                function EventEmitter() {
                    EventEmitter.init.call(this);
                }
                module.exports = EventEmitter;
                module.exports.once = once;
                // Backwards-compat with node 0.10.x
                EventEmitter.EventEmitter = EventEmitter;
                EventEmitter.prototype._events = undefined;
                EventEmitter.prototype._eventsCount = 0;
                EventEmitter.prototype._maxListeners = undefined;
                // By default EventEmitters will print a warning if more than 10 listeners are
                // added to it. This is a useful default which helps finding memory leaks.
                var defaultMaxListeners = 10;
                function checkListener(listener) {
                    if (typeof listener !== "function") throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
                }
                Object.defineProperty(EventEmitter, "defaultMaxListeners", {
                    enumerable: true,
                    get: function() {
                        return defaultMaxListeners;
                    },
                    set: function(arg) {
                        if (typeof arg !== "number" || arg < 0 || NumberIsNaN(arg)) throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + arg + ".");
                        defaultMaxListeners = arg;
                    }
                });
                EventEmitter.init = function() {
                    if (this._events === undefined || this._events === Object.getPrototypeOf(this)._events) {
                        this._events = Object.create(null);
                        this._eventsCount = 0;
                    }
                    this._maxListeners = this._maxListeners || undefined;
                };
                // Obviously not all Emitters should be limited to 10. This function allows
                // that to be increased. Set to zero for unlimited.
                EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
                    if (typeof n !== "number" || n < 0 || NumberIsNaN(n)) throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + n + ".");
                    this._maxListeners = n;
                    return this;
                };
                function _getMaxListeners(that) {
                    if (that._maxListeners === undefined) return EventEmitter.defaultMaxListeners;
                    return that._maxListeners;
                }
                EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
                    return _getMaxListeners(this);
                };
                EventEmitter.prototype.emit = function emit(type) {
                    var args = [];
                    for(var i = 1; i < arguments.length; i++)args.push(arguments[i]);
                    var doError = type === "error";
                    var events = this._events;
                    if (events !== undefined) doError = doError && events.error === undefined;
                    else if (!doError) return false;
                    // If there is no 'error' event listener then throw.
                    if (doError) {
                        var er;
                        if (args.length > 0) er = args[0];
                        if (er instanceof Error) // Note: The comments on the `throw` lines are intentional, they show
                        // up in Node's output if this results in an unhandled exception.
                        throw er; // Unhandled 'error' event
                        // At least give some kind of context to the user
                        var err = new Error("Unhandled error." + (er ? " (" + er.message + ")" : ""));
                        err.context = er;
                        throw err; // Unhandled 'error' event
                    }
                    var handler = events[type];
                    if (handler === undefined) return false;
                    if (typeof handler === "function") ReflectApply(handler, this, args);
                    else {
                        var len = handler.length;
                        var listeners = arrayClone(handler, len);
                        for(var i = 0; i < len; ++i)ReflectApply(listeners[i], this, args);
                    }
                    return true;
                };
                function _addListener(target, type, listener, prepend) {
                    var m;
                    var events;
                    var existing;
                    checkListener(listener);
                    events = target._events;
                    if (events === undefined) {
                        events = target._events = Object.create(null);
                        target._eventsCount = 0;
                    } else {
                        // To avoid recursion in the case that type === "newListener"! Before
                        // adding it to the listeners, first emit "newListener".
                        if (events.newListener !== undefined) {
                            target.emit("newListener", type, listener.listener ? listener.listener : listener);
                            // Re-assign `events` because a newListener handler could have caused the
                            // this._events to be assigned to a new object
                            events = target._events;
                        }
                        existing = events[type];
                    }
                    if (existing === undefined) {
                        // Optimize the case of one listener. Don't need the extra array object.
                        existing = events[type] = listener;
                        ++target._eventsCount;
                    } else {
                        if (typeof existing === "function") // Adding the second element, need to change to array.
                        existing = events[type] = prepend ? [
                            listener,
                            existing
                        ] : [
                            existing,
                            listener
                        ];
                        else if (prepend) existing.unshift(listener);
                        else existing.push(listener);
                        // Check for listener leak
                        m = _getMaxListeners(target);
                        if (m > 0 && existing.length > m && !existing.warned) {
                            existing.warned = true;
                            // No error code for this since it is a Warning
                            // eslint-disable-next-line no-restricted-syntax
                            var w = new Error("Possible EventEmitter memory leak detected. " + existing.length + " " + String(type) + " listeners " + "added. Use emitter.setMaxListeners() to " + "increase limit");
                            w.name = "MaxListenersExceededWarning";
                            w.emitter = target;
                            w.type = type;
                            w.count = existing.length;
                            ProcessEmitWarning(w);
                        }
                    }
                    return target;
                }
                EventEmitter.prototype.addListener = function addListener(type, listener) {
                    return _addListener(this, type, listener, false);
                };
                EventEmitter.prototype.on = EventEmitter.prototype.addListener;
                EventEmitter.prototype.prependListener = function prependListener(type, listener) {
                    return _addListener(this, type, listener, true);
                };
                function onceWrapper() {
                    if (!this.fired) {
                        this.target.removeListener(this.type, this.wrapFn);
                        this.fired = true;
                        if (arguments.length === 0) return this.listener.call(this.target);
                        return this.listener.apply(this.target, arguments);
                    }
                }
                function _onceWrap(target, type, listener) {
                    var state = {
                        fired: false,
                        wrapFn: undefined,
                        target: target,
                        type: type,
                        listener: listener
                    };
                    var wrapped = onceWrapper.bind(state);
                    wrapped.listener = listener;
                    state.wrapFn = wrapped;
                    return wrapped;
                }
                EventEmitter.prototype.once = function once(type, listener) {
                    checkListener(listener);
                    this.on(type, _onceWrap(this, type, listener));
                    return this;
                };
                EventEmitter.prototype.prependOnceListener = function prependOnceListener(type, listener) {
                    checkListener(listener);
                    this.prependListener(type, _onceWrap(this, type, listener));
                    return this;
                };
                // Emits a 'removeListener' event if and only if the listener was removed.
                EventEmitter.prototype.removeListener = function removeListener(type, listener) {
                    var list, events, position, i, originalListener;
                    checkListener(listener);
                    events = this._events;
                    if (events === undefined) return this;
                    list = events[type];
                    if (list === undefined) return this;
                    if (list === listener || list.listener === listener) {
                        if (--this._eventsCount === 0) this._events = Object.create(null);
                        else {
                            delete events[type];
                            if (events.removeListener) this.emit("removeListener", type, list.listener || listener);
                        }
                    } else if (typeof list !== "function") {
                        position = -1;
                        for(i = list.length - 1; i >= 0; i--)if (list[i] === listener || list[i].listener === listener) {
                            originalListener = list[i].listener;
                            position = i;
                            break;
                        }
                        if (position < 0) return this;
                        if (position === 0) list.shift();
                        else spliceOne(list, position);
                        if (list.length === 1) events[type] = list[0];
                        if (events.removeListener !== undefined) this.emit("removeListener", type, originalListener || listener);
                    }
                    return this;
                };
                EventEmitter.prototype.off = EventEmitter.prototype.removeListener;
                EventEmitter.prototype.removeAllListeners = function removeAllListeners(type) {
                    var listeners, events, i;
                    events = this._events;
                    if (events === undefined) return this;
                    // not listening for removeListener, no need to emit
                    if (events.removeListener === undefined) {
                        if (arguments.length === 0) {
                            this._events = Object.create(null);
                            this._eventsCount = 0;
                        } else if (events[type] !== undefined) {
                            if (--this._eventsCount === 0) this._events = Object.create(null);
                            else delete events[type];
                        }
                        return this;
                    }
                    // emit removeListener for all listeners on all events
                    if (arguments.length === 0) {
                        var keys = Object.keys(events);
                        var key;
                        for(i = 0; i < keys.length; ++i){
                            key = keys[i];
                            if (key === "removeListener") continue;
                            this.removeAllListeners(key);
                        }
                        this.removeAllListeners("removeListener");
                        this._events = Object.create(null);
                        this._eventsCount = 0;
                        return this;
                    }
                    listeners = events[type];
                    if (typeof listeners === "function") this.removeListener(type, listeners);
                    else if (listeners !== undefined) // LIFO order
                    for(i = listeners.length - 1; i >= 0; i--)this.removeListener(type, listeners[i]);
                    return this;
                };
                function _listeners(target, type, unwrap) {
                    var events = target._events;
                    if (events === undefined) return [];
                    var evlistener = events[type];
                    if (evlistener === undefined) return [];
                    if (typeof evlistener === "function") return unwrap ? [
                        evlistener.listener || evlistener
                    ] : [
                        evlistener
                    ];
                    return unwrap ? unwrapListeners(evlistener) : arrayClone(evlistener, evlistener.length);
                }
                EventEmitter.prototype.listeners = function listeners(type) {
                    return _listeners(this, type, true);
                };
                EventEmitter.prototype.rawListeners = function rawListeners(type) {
                    return _listeners(this, type, false);
                };
                EventEmitter.listenerCount = function(emitter, type) {
                    if (typeof emitter.listenerCount === "function") return emitter.listenerCount(type);
                    else return listenerCount.call(emitter, type);
                };
                EventEmitter.prototype.listenerCount = listenerCount;
                function listenerCount(type) {
                    var events = this._events;
                    if (events !== undefined) {
                        var evlistener = events[type];
                        if (typeof evlistener === "function") return 1;
                        else if (evlistener !== undefined) return evlistener.length;
                    }
                    return 0;
                }
                EventEmitter.prototype.eventNames = function eventNames() {
                    return this._eventsCount > 0 ? ReflectOwnKeys(this._events) : [];
                };
                function arrayClone(arr, n) {
                    var copy = new Array(n);
                    for(var i = 0; i < n; ++i)copy[i] = arr[i];
                    return copy;
                }
                function spliceOne(list, index) {
                    for(; index + 1 < list.length; index++)list[index] = list[index + 1];
                    list.pop();
                }
                function unwrapListeners(arr) {
                    var ret = new Array(arr.length);
                    for(var i = 0; i < ret.length; ++i)ret[i] = arr[i].listener || arr[i];
                    return ret;
                }
                function once(emitter, name) {
                    return new Promise(function(resolve, reject) {
                        function eventListener() {
                            if (errorListener !== undefined) emitter.removeListener("error", errorListener);
                            resolve([].slice.call(arguments));
                        }
                        var errorListener;
                        // Adding an error listener is not optional because
                        // if an error is thrown on an event emitter we cannot
                        // guarantee that the actual event we are waiting will
                        // be fired. The result could be a silent way to create
                        // memory or file descriptor leaks, which is something
                        // we should avoid.
                        if (name !== "error") {
                            errorListener = function errorListener(err) {
                                emitter.removeListener(name, eventListener);
                                reject(err);
                            };
                            emitter.once("error", errorListener);
                        }
                        emitter.once(name, eventListener);
                    });
                }
            },
            {}
        ],
        37: [
            function(require, module, exports) {
                /*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ exports.read = function(buffer, offset, isLE, mLen, nBytes) {
                    var e, m;
                    var eLen = nBytes * 8 - mLen - 1;
                    var eMax = (1 << eLen) - 1;
                    var eBias = eMax >> 1;
                    var nBits = -7;
                    var i = isLE ? nBytes - 1 : 0;
                    var d = isLE ? -1 : 1;
                    var s = buffer[offset + i];
                    i += d;
                    e = s & (1 << -nBits) - 1;
                    s >>= -nBits;
                    nBits += eLen;
                    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
                    m = e & (1 << -nBits) - 1;
                    e >>= -nBits;
                    nBits += mLen;
                    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
                    if (e === 0) e = 1 - eBias;
                    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
                    else {
                        m = m + Math.pow(2, mLen);
                        e = e - eBias;
                    }
                    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
                };
                exports.write = function(buffer, value, offset, isLE, mLen, nBytes) {
                    var e, m, c;
                    var eLen = nBytes * 8 - mLen - 1;
                    var eMax = (1 << eLen) - 1;
                    var eBias = eMax >> 1;
                    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
                    var i = isLE ? 0 : nBytes - 1;
                    var d = isLE ? 1 : -1;
                    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
                    value = Math.abs(value);
                    if (isNaN(value) || value === Infinity) {
                        m = isNaN(value) ? 1 : 0;
                        e = eMax;
                    } else {
                        e = Math.floor(Math.log(value) / Math.LN2);
                        if (value * (c = Math.pow(2, -e)) < 1) {
                            e--;
                            c *= 2;
                        }
                        if (e + eBias >= 1) value += rt / c;
                        else value += rt * Math.pow(2, 1 - eBias);
                        if (value * c >= 2) {
                            e++;
                            c /= 2;
                        }
                        if (e + eBias >= eMax) {
                            m = 0;
                            e = eMax;
                        } else if (e + eBias >= 1) {
                            m = (value * c - 1) * Math.pow(2, mLen);
                            e = e + eBias;
                        } else {
                            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
                            e = 0;
                        }
                    }
                    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
                    e = e << mLen | m;
                    eLen += mLen;
                    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
                    buffer[offset + i - d] |= s * 128;
                };
            },
            {}
        ],
        38: [
            function(require, module, exports) {
                if (typeof Object.create === "function") // implementation from standard node.js 'util' module
                module.exports = function inherits(ctor, superCtor) {
                    if (superCtor) {
                        ctor.super_ = superCtor;
                        ctor.prototype = Object.create(superCtor.prototype, {
                            constructor: {
                                value: ctor,
                                enumerable: false,
                                writable: true,
                                configurable: true
                            }
                        });
                    }
                };
                else // old school shim for old browsers
                module.exports = function inherits(ctor, superCtor) {
                    if (superCtor) {
                        ctor.super_ = superCtor;
                        var TempCtor = function() {};
                        TempCtor.prototype = superCtor.prototype;
                        ctor.prototype = new TempCtor();
                        ctor.prototype.constructor = ctor;
                    }
                };
            },
            {}
        ],
        39: [
            function(require, module, exports) {
                // shim for using process in browser
                var process = module.exports = {};
                // cached from whatever global is present so that test runners that stub it
                // don't break things.  But we need to wrap it in a try catch in case it is
                // wrapped in strict mode code which doesn't define any globals.  It's inside a
                // function because try/catches deoptimize in certain engines.
                var cachedSetTimeout;
                var cachedClearTimeout;
                function defaultSetTimout() {
                    throw new Error("setTimeout has not been defined");
                }
                function defaultClearTimeout() {
                    throw new Error("clearTimeout has not been defined");
                }
                (function() {
                    try {
                        if (typeof setTimeout === "function") cachedSetTimeout = setTimeout;
                        else cachedSetTimeout = defaultSetTimout;
                    } catch (e) {
                        cachedSetTimeout = defaultSetTimout;
                    }
                    try {
                        if (typeof clearTimeout === "function") cachedClearTimeout = clearTimeout;
                        else cachedClearTimeout = defaultClearTimeout;
                    } catch (e) {
                        cachedClearTimeout = defaultClearTimeout;
                    }
                })();
                function runTimeout(fun) {
                    if (cachedSetTimeout === setTimeout) //normal enviroments in sane situations
                    return setTimeout(fun, 0);
                    // if setTimeout wasn't available but was latter defined
                    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
                        cachedSetTimeout = setTimeout;
                        return setTimeout(fun, 0);
                    }
                    try {
                        // when when somebody has screwed with setTimeout but no I.E. maddness
                        return cachedSetTimeout(fun, 0);
                    } catch (e) {
                        try {
                            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
                            return cachedSetTimeout.call(null, fun, 0);
                        } catch (e) {
                            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
                            return cachedSetTimeout.call(this, fun, 0);
                        }
                    }
                }
                function runClearTimeout(marker) {
                    if (cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
                    return clearTimeout(marker);
                    // if clearTimeout wasn't available but was latter defined
                    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
                        cachedClearTimeout = clearTimeout;
                        return clearTimeout(marker);
                    }
                    try {
                        // when when somebody has screwed with setTimeout but no I.E. maddness
                        return cachedClearTimeout(marker);
                    } catch (e) {
                        try {
                            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
                            return cachedClearTimeout.call(null, marker);
                        } catch (e) {
                            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
                            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
                            return cachedClearTimeout.call(this, marker);
                        }
                    }
                }
                var queue = [];
                var draining = false;
                var currentQueue;
                var queueIndex = -1;
                function cleanUpNextTick() {
                    if (!draining || !currentQueue) return;
                    draining = false;
                    if (currentQueue.length) queue = currentQueue.concat(queue);
                    else queueIndex = -1;
                    if (queue.length) drainQueue();
                }
                function drainQueue() {
                    if (draining) return;
                    var timeout = runTimeout(cleanUpNextTick);
                    draining = true;
                    var len = queue.length;
                    while(len){
                        currentQueue = queue;
                        queue = [];
                        while(++queueIndex < len)if (currentQueue) currentQueue[queueIndex].run();
                        queueIndex = -1;
                        len = queue.length;
                    }
                    currentQueue = null;
                    draining = false;
                    runClearTimeout(timeout);
                }
                process.nextTick = function(fun) {
                    var args = new Array(arguments.length - 1);
                    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
                    queue.push(new Item(fun, args));
                    if (queue.length === 1 && !draining) runTimeout(drainQueue);
                };
                // v8 likes predictible objects
                function Item(fun, array) {
                    this.fun = fun;
                    this.array = array;
                }
                Item.prototype.run = function() {
                    this.fun.apply(null, this.array);
                };
                process.title = "browser";
                process.browser = true;
                process.env = {};
                process.argv = [];
                process.version = ""; // empty string to avoid regexp issues
                process.versions = {};
                function noop() {}
                process.on = noop;
                process.addListener = noop;
                process.once = noop;
                process.off = noop;
                process.removeListener = noop;
                process.removeAllListeners = noop;
                process.emit = noop;
                process.prependListener = noop;
                process.prependOnceListener = noop;
                process.listeners = function(name) {
                    return [];
                };
                process.binding = function(name) {
                    throw new Error("process.binding is not supported");
                };
                process.cwd = function() {
                    return "/";
                };
                process.chdir = function(dir) {
                    throw new Error("process.chdir is not supported");
                };
                process.umask = function() {
                    return 0;
                };
            },
            {}
        ],
        40: [
            function(require, module, exports) {
                /*! safe-buffer. MIT License. Feross Aboukhadijeh <https://feross.org/opensource> */ /* eslint-disable node/no-deprecated-api */ var buffer = require("buffer");
                var Buffer = buffer.Buffer;
                // alternative to using Object.keys for old browsers
                function copyProps(src, dst) {
                    for(var key in src)dst[key] = src[key];
                }
                if (Buffer.from && Buffer.alloc && Buffer.allocUnsafe && Buffer.allocUnsafeSlow) module.exports = buffer;
                else {
                    // Copy properties from require('buffer')
                    copyProps(buffer, exports);
                    exports.Buffer = SafeBuffer;
                }
                function SafeBuffer(arg, encodingOrOffset, length) {
                    return Buffer(arg, encodingOrOffset, length);
                }
                SafeBuffer.prototype = Object.create(Buffer.prototype);
                // Copy static methods from Buffer
                copyProps(Buffer, SafeBuffer);
                SafeBuffer.from = function(arg, encodingOrOffset, length) {
                    if (typeof arg === "number") throw new TypeError("Argument must not be a number");
                    return Buffer(arg, encodingOrOffset, length);
                };
                SafeBuffer.alloc = function(size, fill, encoding) {
                    if (typeof size !== "number") throw new TypeError("Argument must be a number");
                    var buf = Buffer(size);
                    if (fill !== undefined) {
                        if (typeof encoding === "string") buf.fill(fill, encoding);
                        else buf.fill(fill);
                    } else buf.fill(0);
                    return buf;
                };
                SafeBuffer.allocUnsafe = function(size) {
                    if (typeof size !== "number") throw new TypeError("Argument must be a number");
                    return Buffer(size);
                };
                SafeBuffer.allocUnsafeSlow = function(size) {
                    if (typeof size !== "number") throw new TypeError("Argument must be a number");
                    return buffer.SlowBuffer(size);
                };
            },
            {
                "buffer": 35
            }
        ],
        41: [
            function(require, module, exports) {
                // Copyright Joyent, Inc. and other Node contributors.
                //
                // Permission is hereby granted, free of charge, to any person obtaining a
                // copy of this software and associated documentation files (the
                // "Software"), to deal in the Software without restriction, including
                // without limitation the rights to use, copy, modify, merge, publish,
                // distribute, sublicense, and/or sell copies of the Software, and to permit
                // persons to whom the Software is furnished to do so, subject to the
                // following conditions:
                //
                // The above copyright notice and this permission notice shall be included
                // in all copies or substantial portions of the Software.
                //
                // THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
                // OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
                // MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
                // NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
                // DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
                // OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
                // USE OR OTHER DEALINGS IN THE SOFTWARE.
                module.exports = Stream;
                var EE = require("events").EventEmitter;
                var inherits = require("inherits");
                inherits(Stream, EE);
                Stream.Readable = require("readable-stream/lib/_stream_readable.js");
                Stream.Writable = require("readable-stream/lib/_stream_writable.js");
                Stream.Duplex = require("readable-stream/lib/_stream_duplex.js");
                Stream.Transform = require("readable-stream/lib/_stream_transform.js");
                Stream.PassThrough = require("readable-stream/lib/_stream_passthrough.js");
                Stream.finished = require("readable-stream/lib/internal/streams/end-of-stream.js");
                Stream.pipeline = require("readable-stream/lib/internal/streams/pipeline.js");
                // Backwards-compat with node 0.4.x
                Stream.Stream = Stream;
                // old-style streams.  Note that the pipe method (the only relevant
                // part of this class) is overridden in the Readable class.
                function Stream() {
                    EE.call(this);
                }
                Stream.prototype.pipe = function(dest, options) {
                    var source = this;
                    function ondata(chunk) {
                        if (dest.writable) {
                            if (false === dest.write(chunk) && source.pause) source.pause();
                        }
                    }
                    source.on("data", ondata);
                    function ondrain() {
                        if (source.readable && source.resume) source.resume();
                    }
                    dest.on("drain", ondrain);
                    // If the 'end' option is not supplied, dest.end() will be called when
                    // source gets the 'end' or 'close' events.  Only dest.end() once.
                    if (!dest._isStdio && (!options || options.end !== false)) {
                        source.on("end", onend);
                        source.on("close", onclose);
                    }
                    var didOnEnd = false;
                    function onend() {
                        if (didOnEnd) return;
                        didOnEnd = true;
                        dest.end();
                    }
                    function onclose() {
                        if (didOnEnd) return;
                        didOnEnd = true;
                        if (typeof dest.destroy === "function") dest.destroy();
                    }
                    // don't leave dangling pipes when there are errors.
                    function onerror(er) {
                        cleanup();
                        if (EE.listenerCount(this, "error") === 0) throw er; // Unhandled stream error in pipe.
                    }
                    source.on("error", onerror);
                    dest.on("error", onerror);
                    // remove all the event listeners that were added.
                    function cleanup() {
                        source.removeListener("data", ondata);
                        dest.removeListener("drain", ondrain);
                        source.removeListener("end", onend);
                        source.removeListener("close", onclose);
                        source.removeListener("error", onerror);
                        dest.removeListener("error", onerror);
                        source.removeListener("end", cleanup);
                        source.removeListener("close", cleanup);
                        dest.removeListener("close", cleanup);
                    }
                    source.on("end", cleanup);
                    source.on("close", cleanup);
                    dest.on("close", cleanup);
                    dest.emit("pipe", source);
                    // Allow for unix-like usage: A.pipe(B).pipe(C)
                    return dest;
                };
            },
            {
                "events": 36,
                "inherits": 38,
                "readable-stream/lib/_stream_duplex.js": 43,
                "readable-stream/lib/_stream_passthrough.js": 44,
                "readable-stream/lib/_stream_readable.js": 45,
                "readable-stream/lib/_stream_transform.js": 46,
                "readable-stream/lib/_stream_writable.js": 47,
                "readable-stream/lib/internal/streams/end-of-stream.js": 51,
                "readable-stream/lib/internal/streams/pipeline.js": 53
            }
        ],
        42: [
            function(require, module, exports) {
                "use strict";
                function _inheritsLoose(subClass, superClass) {
                    subClass.prototype = Object.create(superClass.prototype);
                    subClass.prototype.constructor = subClass;
                    subClass.__proto__ = superClass;
                }
                var codes = {};
                function createErrorType(code, message, Base) {
                    if (!Base) Base = Error;
                    function getMessage(arg1, arg2, arg3) {
                        if (typeof message === "string") return message;
                        else return message(arg1, arg2, arg3);
                    }
                    var NodeError = /*#__PURE__*/ function(_Base) {
                        _inheritsLoose(NodeError, _Base);
                        function NodeError(arg1, arg2, arg3) {
                            return _Base.call(this, getMessage(arg1, arg2, arg3)) || this;
                        }
                        return NodeError;
                    }(Base);
                    NodeError.prototype.name = Base.name;
                    NodeError.prototype.code = code;
                    codes[code] = NodeError;
                } // https://github.com/nodejs/node/blob/v10.8.0/lib/internal/errors.js
                function oneOf(expected, thing) {
                    if (Array.isArray(expected)) {
                        var len = expected.length;
                        expected = expected.map(function(i) {
                            return String(i);
                        });
                        if (len > 2) return "one of ".concat(thing, " ").concat(expected.slice(0, len - 1).join(", "), ", or ") + expected[len - 1];
                        else if (len === 2) return "one of ".concat(thing, " ").concat(expected[0], " or ").concat(expected[1]);
                        else return "of ".concat(thing, " ").concat(expected[0]);
                    } else return "of ".concat(thing, " ").concat(String(expected));
                } // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/startsWith
                function startsWith(str, search, pos) {
                    return str.substr(!pos || pos < 0 ? 0 : +pos, search.length) === search;
                } // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/endsWith
                function endsWith(str, search, this_len) {
                    if (this_len === undefined || this_len > str.length) this_len = str.length;
                    return str.substring(this_len - search.length, this_len) === search;
                } // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/includes
                function includes(str, search, start) {
                    if (typeof start !== "number") start = 0;
                    if (start + search.length > str.length) return false;
                    else return str.indexOf(search, start) !== -1;
                }
                createErrorType("ERR_INVALID_OPT_VALUE", function(name, value) {
                    return 'The value "' + value + '" is invalid for option "' + name + '"';
                }, TypeError);
                createErrorType("ERR_INVALID_ARG_TYPE", function(name, expected, actual) {
                    // determiner: 'must be' or 'must not be'
                    var determiner;
                    if (typeof expected === "string" && startsWith(expected, "not ")) {
                        determiner = "must not be";
                        expected = expected.replace(/^not /, "");
                    } else determiner = "must be";
                    var msg;
                    if (endsWith(name, " argument")) // For cases like 'first argument'
                    msg = "The ".concat(name, " ").concat(determiner, " ").concat(oneOf(expected, "type"));
                    else {
                        var type = includes(name, ".") ? "property" : "argument";
                        msg = 'The "'.concat(name, '" ').concat(type, " ").concat(determiner, " ").concat(oneOf(expected, "type"));
                    }
                    msg += ". Received type ".concat(typeof actual);
                    return msg;
                }, TypeError);
                createErrorType("ERR_STREAM_PUSH_AFTER_EOF", "stream.push() after EOF");
                createErrorType("ERR_METHOD_NOT_IMPLEMENTED", function(name) {
                    return "The " + name + " method is not implemented";
                });
                createErrorType("ERR_STREAM_PREMATURE_CLOSE", "Premature close");
                createErrorType("ERR_STREAM_DESTROYED", function(name) {
                    return "Cannot call " + name + " after a stream was destroyed";
                });
                createErrorType("ERR_MULTIPLE_CALLBACK", "Callback called multiple times");
                createErrorType("ERR_STREAM_CANNOT_PIPE", "Cannot pipe, not readable");
                createErrorType("ERR_STREAM_WRITE_AFTER_END", "write after end");
                createErrorType("ERR_STREAM_NULL_VALUES", "May not write null values to stream", TypeError);
                createErrorType("ERR_UNKNOWN_ENCODING", function(arg) {
                    return "Unknown encoding: " + arg;
                }, TypeError);
                createErrorType("ERR_STREAM_UNSHIFT_AFTER_END_EVENT", "stream.unshift() after end event");
                module.exports.codes = codes;
            },
            {}
        ],
        43: [
            function(require, module, exports) {
                (function(process) {
                    (function() {
                        // Copyright Joyent, Inc. and other Node contributors.
                        //
                        // Permission is hereby granted, free of charge, to any person obtaining a
                        // copy of this software and associated documentation files (the
                        // "Software"), to deal in the Software without restriction, including
                        // without limitation the rights to use, copy, modify, merge, publish,
                        // distribute, sublicense, and/or sell copies of the Software, and to permit
                        // persons to whom the Software is furnished to do so, subject to the
                        // following conditions:
                        //
                        // The above copyright notice and this permission notice shall be included
                        // in all copies or substantial portions of the Software.
                        //
                        // THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
                        // OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
                        // MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
                        // NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
                        // DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
                        // OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
                        // USE OR OTHER DEALINGS IN THE SOFTWARE.
                        // a duplex stream is just a stream that is both readable and writable.
                        // Since JS doesn't have multiple prototypal inheritance, this class
                        // prototypally inherits from Readable, and then parasitically from
                        // Writable.
                        "use strict";
                        /*<replacement>*/ var objectKeys = Object.keys || function(obj) {
                            var keys = [];
                            for(var key in obj)keys.push(key);
                            return keys;
                        };
                        /*</replacement>*/ module.exports = Duplex;
                        var Readable = require("./_stream_readable");
                        var Writable = require("./_stream_writable");
                        require("inherits")(Duplex, Readable);
                        // Allow the keys array to be GC'ed.
                        var keys = objectKeys(Writable.prototype);
                        for(var v = 0; v < keys.length; v++){
                            var method = keys[v];
                            if (!Duplex.prototype[method]) Duplex.prototype[method] = Writable.prototype[method];
                        }
                        function Duplex(options) {
                            if (!(this instanceof Duplex)) return new Duplex(options);
                            Readable.call(this, options);
                            Writable.call(this, options);
                            this.allowHalfOpen = true;
                            if (options) {
                                if (options.readable === false) this.readable = false;
                                if (options.writable === false) this.writable = false;
                                if (options.allowHalfOpen === false) {
                                    this.allowHalfOpen = false;
                                    this.once("end", onend);
                                }
                            }
                        }
                        Object.defineProperty(Duplex.prototype, "writableHighWaterMark", {
                            // making it explicit this property is not enumerable
                            // because otherwise some prototype manipulation in
                            // userland will fail
                            enumerable: false,
                            get: function get() {
                                return this._writableState.highWaterMark;
                            }
                        });
                        Object.defineProperty(Duplex.prototype, "writableBuffer", {
                            // making it explicit this property is not enumerable
                            // because otherwise some prototype manipulation in
                            // userland will fail
                            enumerable: false,
                            get: function get() {
                                return this._writableState && this._writableState.getBuffer();
                            }
                        });
                        Object.defineProperty(Duplex.prototype, "writableLength", {
                            // making it explicit this property is not enumerable
                            // because otherwise some prototype manipulation in
                            // userland will fail
                            enumerable: false,
                            get: function get() {
                                return this._writableState.length;
                            }
                        }); // the no-half-open enforcer
                        function onend() {
                            // If the writable side ended, then we're ok.
                            if (this._writableState.ended) return; // no more data can be written.
                            // But allow more writes to happen in this tick.
                            process.nextTick(onEndNT, this);
                        }
                        function onEndNT(self1) {
                            self1.end();
                        }
                        Object.defineProperty(Duplex.prototype, "destroyed", {
                            // making it explicit this property is not enumerable
                            // because otherwise some prototype manipulation in
                            // userland will fail
                            enumerable: false,
                            get: function get() {
                                if (this._readableState === undefined || this._writableState === undefined) return false;
                                return this._readableState.destroyed && this._writableState.destroyed;
                            },
                            set: function set(value) {
                                // we ignore the value if the stream
                                // has not been initialized yet
                                if (this._readableState === undefined || this._writableState === undefined) return;
                                 // backward compatibility, the user is explicitly
                                // managing destroyed
                                this._readableState.destroyed = value;
                                this._writableState.destroyed = value;
                            }
                        });
                    }).call(this);
                }).call(this, require("_process"));
            },
            {
                "./_stream_readable": 45,
                "./_stream_writable": 47,
                "_process": 39,
                "inherits": 38
            }
        ],
        44: [
            function(require, module, exports) {
                // Copyright Joyent, Inc. and other Node contributors.
                //
                // Permission is hereby granted, free of charge, to any person obtaining a
                // copy of this software and associated documentation files (the
                // "Software"), to deal in the Software without restriction, including
                // without limitation the rights to use, copy, modify, merge, publish,
                // distribute, sublicense, and/or sell copies of the Software, and to permit
                // persons to whom the Software is furnished to do so, subject to the
                // following conditions:
                //
                // The above copyright notice and this permission notice shall be included
                // in all copies or substantial portions of the Software.
                //
                // THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
                // OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
                // MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
                // NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
                // DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
                // OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
                // USE OR OTHER DEALINGS IN THE SOFTWARE.
                // a passthrough stream.
                // basically just the most minimal sort of Transform stream.
                // Every written chunk gets output as-is.
                "use strict";
                module.exports = PassThrough;
                var Transform = require("./_stream_transform");
                require("inherits")(PassThrough, Transform);
                function PassThrough(options) {
                    if (!(this instanceof PassThrough)) return new PassThrough(options);
                    Transform.call(this, options);
                }
                PassThrough.prototype._transform = function(chunk, encoding, cb) {
                    cb(null, chunk);
                };
            },
            {
                "./_stream_transform": 46,
                "inherits": 38
            }
        ],
        45: [
            function(require, module, exports) {
                (function(process, global) {
                    (function() {
                        // Copyright Joyent, Inc. and other Node contributors.
                        //
                        // Permission is hereby granted, free of charge, to any person obtaining a
                        // copy of this software and associated documentation files (the
                        // "Software"), to deal in the Software without restriction, including
                        // without limitation the rights to use, copy, modify, merge, publish,
                        // distribute, sublicense, and/or sell copies of the Software, and to permit
                        // persons to whom the Software is furnished to do so, subject to the
                        // following conditions:
                        //
                        // The above copyright notice and this permission notice shall be included
                        // in all copies or substantial portions of the Software.
                        //
                        // THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
                        // OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
                        // MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
                        // NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
                        // DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
                        // OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
                        // USE OR OTHER DEALINGS IN THE SOFTWARE.
                        "use strict";
                        module.exports = Readable;
                        /*<replacement>*/ var Duplex;
                        /*</replacement>*/ Readable.ReadableState = ReadableState;
                        /*<replacement>*/ var EE = require("events").EventEmitter;
                        var EElistenerCount = function EElistenerCount(emitter, type) {
                            return emitter.listeners(type).length;
                        };
                        /*</replacement>*/ /*<replacement>*/ var Stream = require("./internal/streams/stream");
                        /*</replacement>*/ var Buffer = require("buffer").Buffer;
                        var OurUint8Array = global.Uint8Array || function() {};
                        function _uint8ArrayToBuffer(chunk) {
                            return Buffer.from(chunk);
                        }
                        function _isUint8Array(obj) {
                            return Buffer.isBuffer(obj) || obj instanceof OurUint8Array;
                        }
                        /*<replacement>*/ var debugUtil = require("util");
                        var debug;
                        if (debugUtil && debugUtil.debuglog) debug = debugUtil.debuglog("stream");
                        else debug = function debug() {};
                        /*</replacement>*/ var BufferList = require("./internal/streams/buffer_list");
                        var destroyImpl = require("./internal/streams/destroy");
                        var _require = require("./internal/streams/state"), getHighWaterMark = _require.getHighWaterMark;
                        var _require$codes = require("../errors").codes, ERR_INVALID_ARG_TYPE = _require$codes.ERR_INVALID_ARG_TYPE, ERR_STREAM_PUSH_AFTER_EOF = _require$codes.ERR_STREAM_PUSH_AFTER_EOF, ERR_METHOD_NOT_IMPLEMENTED = _require$codes.ERR_METHOD_NOT_IMPLEMENTED, ERR_STREAM_UNSHIFT_AFTER_END_EVENT = _require$codes.ERR_STREAM_UNSHIFT_AFTER_END_EVENT; // Lazy loaded to improve the startup performance.
                        var StringDecoder;
                        var createReadableStreamAsyncIterator;
                        var from;
                        require("inherits")(Readable, Stream);
                        var errorOrDestroy = destroyImpl.errorOrDestroy;
                        var kProxyEvents = [
                            "error",
                            "close",
                            "destroy",
                            "pause",
                            "resume"
                        ];
                        function prependListener(emitter, event, fn) {
                            // Sadly this is not cacheable as some libraries bundle their own
                            // event emitter implementation with them.
                            if (typeof emitter.prependListener === "function") return emitter.prependListener(event, fn); // This is a hack to make sure that our error handler is attached before any
                            // userland ones.  NEVER DO THIS. This is here only because this code needs
                            // to continue to work with older versions of Node.js that do not include
                            // the prependListener() method. The goal is to eventually remove this hack.
                            if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);
                            else if (Array.isArray(emitter._events[event])) emitter._events[event].unshift(fn);
                            else emitter._events[event] = [
                                fn,
                                emitter._events[event]
                            ];
                        }
                        function ReadableState(options, stream, isDuplex) {
                            Duplex = Duplex || require("./_stream_duplex");
                            options = options || {}; // Duplex streams are both readable and writable, but share
                            // the same options object.
                            // However, some cases require setting options to different
                            // values for the readable and the writable sides of the duplex stream.
                            // These options can be provided separately as readableXXX and writableXXX.
                            if (typeof isDuplex !== "boolean") isDuplex = stream instanceof Duplex; // object stream flag. Used to make read(n) ignore n and to
                            // make all the buffer merging and length checks go away
                            this.objectMode = !!options.objectMode;
                            if (isDuplex) this.objectMode = this.objectMode || !!options.readableObjectMode; // the point at which it stops calling _read() to fill the buffer
                            // Note: 0 is a valid value, means "don't call _read preemptively ever"
                            this.highWaterMark = getHighWaterMark(this, options, "readableHighWaterMark", isDuplex); // A linked list is used to store data chunks instead of an array because the
                            // linked list can remove elements from the beginning faster than
                            // array.shift()
                            this.buffer = new BufferList();
                            this.length = 0;
                            this.pipes = null;
                            this.pipesCount = 0;
                            this.flowing = null;
                            this.ended = false;
                            this.endEmitted = false;
                            this.reading = false; // a flag to be able to tell if the event 'readable'/'data' is emitted
                            // immediately, or on a later tick.  We set this to true at first, because
                            // any actions that shouldn't happen until "later" should generally also
                            // not happen before the first read call.
                            this.sync = true; // whenever we return null, then we set a flag to say
                            // that we're awaiting a 'readable' event emission.
                            this.needReadable = false;
                            this.emittedReadable = false;
                            this.readableListening = false;
                            this.resumeScheduled = false;
                            this.paused = true; // Should close be emitted on destroy. Defaults to true.
                            this.emitClose = options.emitClose !== false; // Should .destroy() be called after 'end' (and potentially 'finish')
                            this.autoDestroy = !!options.autoDestroy; // has it been destroyed
                            this.destroyed = false; // Crypto is kind of old and crusty.  Historically, its default string
                            // encoding is 'binary' so we have to make this configurable.
                            // Everything else in the universe uses 'utf8', though.
                            this.defaultEncoding = options.defaultEncoding || "utf8"; // the number of writers that are awaiting a drain event in .pipe()s
                            this.awaitDrain = 0; // if true, a maybeReadMore has been scheduled
                            this.readingMore = false;
                            this.decoder = null;
                            this.encoding = null;
                            if (options.encoding) {
                                if (!StringDecoder) StringDecoder = require("string_decoder/").StringDecoder;
                                this.decoder = new StringDecoder(options.encoding);
                                this.encoding = options.encoding;
                            }
                        }
                        function Readable(options) {
                            Duplex = Duplex || require("./_stream_duplex");
                            if (!(this instanceof Readable)) return new Readable(options); // Checking for a Stream.Duplex instance is faster here instead of inside
                            // the ReadableState constructor, at least with V8 6.5
                            var isDuplex = this instanceof Duplex;
                            this._readableState = new ReadableState(options, this, isDuplex); // legacy
                            this.readable = true;
                            if (options) {
                                if (typeof options.read === "function") this._read = options.read;
                                if (typeof options.destroy === "function") this._destroy = options.destroy;
                            }
                            Stream.call(this);
                        }
                        Object.defineProperty(Readable.prototype, "destroyed", {
                            // making it explicit this property is not enumerable
                            // because otherwise some prototype manipulation in
                            // userland will fail
                            enumerable: false,
                            get: function get() {
                                if (this._readableState === undefined) return false;
                                return this._readableState.destroyed;
                            },
                            set: function set(value) {
                                // we ignore the value if the stream
                                // has not been initialized yet
                                if (!this._readableState) return;
                                 // backward compatibility, the user is explicitly
                                // managing destroyed
                                this._readableState.destroyed = value;
                            }
                        });
                        Readable.prototype.destroy = destroyImpl.destroy;
                        Readable.prototype._undestroy = destroyImpl.undestroy;
                        Readable.prototype._destroy = function(err, cb) {
                            cb(err);
                        }; // Manually shove something into the read() buffer.
                        // This returns true if the highWaterMark has not been hit yet,
                        // similar to how Writable.write() returns true if you should
                        // write() some more.
                        Readable.prototype.push = function(chunk, encoding) {
                            var state = this._readableState;
                            var skipChunkCheck;
                            if (!state.objectMode) {
                                if (typeof chunk === "string") {
                                    encoding = encoding || state.defaultEncoding;
                                    if (encoding !== state.encoding) {
                                        chunk = Buffer.from(chunk, encoding);
                                        encoding = "";
                                    }
                                    skipChunkCheck = true;
                                }
                            } else skipChunkCheck = true;
                            return readableAddChunk(this, chunk, encoding, false, skipChunkCheck);
                        }; // Unshift should *always* be something directly out of read()
                        Readable.prototype.unshift = function(chunk) {
                            return readableAddChunk(this, chunk, null, true, false);
                        };
                        function readableAddChunk(stream, chunk, encoding, addToFront, skipChunkCheck) {
                            debug("readableAddChunk", chunk);
                            var state = stream._readableState;
                            if (chunk === null) {
                                state.reading = false;
                                onEofChunk(stream, state);
                            } else {
                                var er;
                                if (!skipChunkCheck) er = chunkInvalid(state, chunk);
                                if (er) errorOrDestroy(stream, er);
                                else if (state.objectMode || chunk && chunk.length > 0) {
                                    if (typeof chunk !== "string" && !state.objectMode && Object.getPrototypeOf(chunk) !== Buffer.prototype) chunk = _uint8ArrayToBuffer(chunk);
                                    if (addToFront) {
                                        if (state.endEmitted) errorOrDestroy(stream, new ERR_STREAM_UNSHIFT_AFTER_END_EVENT());
                                        else addChunk(stream, state, chunk, true);
                                    } else if (state.ended) errorOrDestroy(stream, new ERR_STREAM_PUSH_AFTER_EOF());
                                    else if (state.destroyed) return false;
                                    else {
                                        state.reading = false;
                                        if (state.decoder && !encoding) {
                                            chunk = state.decoder.write(chunk);
                                            if (state.objectMode || chunk.length !== 0) addChunk(stream, state, chunk, false);
                                            else maybeReadMore(stream, state);
                                        } else addChunk(stream, state, chunk, false);
                                    }
                                } else if (!addToFront) {
                                    state.reading = false;
                                    maybeReadMore(stream, state);
                                }
                            } // We can push more data if we are below the highWaterMark.
                            // Also, if we have no data yet, we can stand some more bytes.
                            // This is to work around cases where hwm=0, such as the repl.
                            return !state.ended && (state.length < state.highWaterMark || state.length === 0);
                        }
                        function addChunk(stream, state, chunk, addToFront) {
                            if (state.flowing && state.length === 0 && !state.sync) {
                                state.awaitDrain = 0;
                                stream.emit("data", chunk);
                            } else {
                                // update the buffer info.
                                state.length += state.objectMode ? 1 : chunk.length;
                                if (addToFront) state.buffer.unshift(chunk);
                                else state.buffer.push(chunk);
                                if (state.needReadable) emitReadable(stream);
                            }
                            maybeReadMore(stream, state);
                        }
                        function chunkInvalid(state, chunk) {
                            var er;
                            if (!_isUint8Array(chunk) && typeof chunk !== "string" && chunk !== undefined && !state.objectMode) er = new ERR_INVALID_ARG_TYPE("chunk", [
                                "string",
                                "Buffer",
                                "Uint8Array"
                            ], chunk);
                            return er;
                        }
                        Readable.prototype.isPaused = function() {
                            return this._readableState.flowing === false;
                        }; // backwards compatibility.
                        Readable.prototype.setEncoding = function(enc) {
                            if (!StringDecoder) StringDecoder = require("string_decoder/").StringDecoder;
                            var decoder = new StringDecoder(enc);
                            this._readableState.decoder = decoder; // If setEncoding(null), decoder.encoding equals utf8
                            this._readableState.encoding = this._readableState.decoder.encoding; // Iterate over current buffer to convert already stored Buffers:
                            var p = this._readableState.buffer.head;
                            var content = "";
                            while(p !== null){
                                content += decoder.write(p.data);
                                p = p.next;
                            }
                            this._readableState.buffer.clear();
                            if (content !== "") this._readableState.buffer.push(content);
                            this._readableState.length = content.length;
                            return this;
                        }; // Don't raise the hwm > 1GB
                        var MAX_HWM = 0x40000000;
                        function computeNewHighWaterMark(n) {
                            if (n >= MAX_HWM) // TODO(ronag): Throw ERR_VALUE_OUT_OF_RANGE.
                            n = MAX_HWM;
                            else {
                                // Get the next highest power of 2 to prevent increasing hwm excessively in
                                // tiny amounts
                                n--;
                                n |= n >>> 1;
                                n |= n >>> 2;
                                n |= n >>> 4;
                                n |= n >>> 8;
                                n |= n >>> 16;
                                n++;
                            }
                            return n;
                        } // This function is designed to be inlinable, so please take care when making
                        // changes to the function body.
                        function howMuchToRead(n, state) {
                            if (n <= 0 || state.length === 0 && state.ended) return 0;
                            if (state.objectMode) return 1;
                            if (n !== n) {
                                // Only flow one buffer at a time
                                if (state.flowing && state.length) return state.buffer.head.data.length;
                                else return state.length;
                            } // If we're asking for more than the current hwm, then raise the hwm.
                            if (n > state.highWaterMark) state.highWaterMark = computeNewHighWaterMark(n);
                            if (n <= state.length) return n; // Don't have enough
                            if (!state.ended) {
                                state.needReadable = true;
                                return 0;
                            }
                            return state.length;
                        } // you can override either this method, or the async _read(n) below.
                        Readable.prototype.read = function(n) {
                            debug("read", n);
                            n = parseInt(n, 10);
                            var state = this._readableState;
                            var nOrig = n;
                            if (n !== 0) state.emittedReadable = false; // if we're doing read(0) to trigger a readable event, but we
                            // already have a bunch of data in the buffer, then just trigger
                            // the 'readable' event and move on.
                            if (n === 0 && state.needReadable && ((state.highWaterMark !== 0 ? state.length >= state.highWaterMark : state.length > 0) || state.ended)) {
                                debug("read: emitReadable", state.length, state.ended);
                                if (state.length === 0 && state.ended) endReadable(this);
                                else emitReadable(this);
                                return null;
                            }
                            n = howMuchToRead(n, state); // if we've ended, and we're now clear, then finish it up.
                            if (n === 0 && state.ended) {
                                if (state.length === 0) endReadable(this);
                                return null;
                            } // All the actual chunk generation logic needs to be
                            // *below* the call to _read.  The reason is that in certain
                            // synthetic stream cases, such as passthrough streams, _read
                            // may be a completely synchronous operation which may change
                            // the state of the read buffer, providing enough data when
                            // before there was *not* enough.
                            //
                            // So, the steps are:
                            // 1. Figure out what the state of things will be after we do
                            // a read from the buffer.
                            //
                            // 2. If that resulting state will trigger a _read, then call _read.
                            // Note that this may be asynchronous, or synchronous.  Yes, it is
                            // deeply ugly to write APIs this way, but that still doesn't mean
                            // that the Readable class should behave improperly, as streams are
                            // designed to be sync/async agnostic.
                            // Take note if the _read call is sync or async (ie, if the read call
                            // has returned yet), so that we know whether or not it's safe to emit
                            // 'readable' etc.
                            //
                            // 3. Actually pull the requested chunks out of the buffer and return.
                            // if we need a readable event, then we need to do some reading.
                            var doRead = state.needReadable;
                            debug("need readable", doRead); // if we currently have less than the highWaterMark, then also read some
                            if (state.length === 0 || state.length - n < state.highWaterMark) {
                                doRead = true;
                                debug("length less than watermark", doRead);
                            } // however, if we've ended, then there's no point, and if we're already
                            // reading, then it's unnecessary.
                            if (state.ended || state.reading) {
                                doRead = false;
                                debug("reading or ended", doRead);
                            } else if (doRead) {
                                debug("do read");
                                state.reading = true;
                                state.sync = true; // if the length is currently zero, then we *need* a readable event.
                                if (state.length === 0) state.needReadable = true; // call internal read method
                                this._read(state.highWaterMark);
                                state.sync = false; // If _read pushed data synchronously, then `reading` will be false,
                                // and we need to re-evaluate how much data we can return to the user.
                                if (!state.reading) n = howMuchToRead(nOrig, state);
                            }
                            var ret;
                            if (n > 0) ret = fromList(n, state);
                            else ret = null;
                            if (ret === null) {
                                state.needReadable = state.length <= state.highWaterMark;
                                n = 0;
                            } else {
                                state.length -= n;
                                state.awaitDrain = 0;
                            }
                            if (state.length === 0) {
                                // If we have nothing in the buffer, then we want to know
                                // as soon as we *do* get something into the buffer.
                                if (!state.ended) state.needReadable = true; // If we tried to read() past the EOF, then emit end on the next tick.
                                if (nOrig !== n && state.ended) endReadable(this);
                            }
                            if (ret !== null) this.emit("data", ret);
                            return ret;
                        };
                        function onEofChunk(stream, state) {
                            debug("onEofChunk");
                            if (state.ended) return;
                            if (state.decoder) {
                                var chunk = state.decoder.end();
                                if (chunk && chunk.length) {
                                    state.buffer.push(chunk);
                                    state.length += state.objectMode ? 1 : chunk.length;
                                }
                            }
                            state.ended = true;
                            if (state.sync) // if we are sync, wait until next tick to emit the data.
                            // Otherwise we risk emitting data in the flow()
                            // the readable code triggers during a read() call
                            emitReadable(stream);
                            else {
                                // emit 'readable' now to make sure it gets picked up.
                                state.needReadable = false;
                                if (!state.emittedReadable) {
                                    state.emittedReadable = true;
                                    emitReadable_(stream);
                                }
                            }
                        } // Don't emit readable right away in sync mode, because this can trigger
                        // another read() call => stack overflow.  This way, it might trigger
                        // a nextTick recursion warning, but that's not so bad.
                        function emitReadable(stream) {
                            var state = stream._readableState;
                            debug("emitReadable", state.needReadable, state.emittedReadable);
                            state.needReadable = false;
                            if (!state.emittedReadable) {
                                debug("emitReadable", state.flowing);
                                state.emittedReadable = true;
                                process.nextTick(emitReadable_, stream);
                            }
                        }
                        function emitReadable_(stream) {
                            var state = stream._readableState;
                            debug("emitReadable_", state.destroyed, state.length, state.ended);
                            if (!state.destroyed && (state.length || state.ended)) {
                                stream.emit("readable");
                                state.emittedReadable = false;
                            } // The stream needs another readable event if
                            // 1. It is not flowing, as the flow mechanism will take
                            //    care of it.
                            // 2. It is not ended.
                            // 3. It is below the highWaterMark, so we can schedule
                            //    another readable later.
                            state.needReadable = !state.flowing && !state.ended && state.length <= state.highWaterMark;
                            flow(stream);
                        } // at this point, the user has presumably seen the 'readable' event,
                        // and called read() to consume some data.  that may have triggered
                        // in turn another _read(n) call, in which case reading = true if
                        // it's in progress.
                        // However, if we're not ended, or reading, and the length < hwm,
                        // then go ahead and try to read some more preemptively.
                        function maybeReadMore(stream, state) {
                            if (!state.readingMore) {
                                state.readingMore = true;
                                process.nextTick(maybeReadMore_, stream, state);
                            }
                        }
                        function maybeReadMore_(stream, state) {
                            // Attempt to read more data if we should.
                            //
                            // The conditions for reading more data are (one of):
                            // - Not enough data buffered (state.length < state.highWaterMark). The loop
                            //   is responsible for filling the buffer with enough data if such data
                            //   is available. If highWaterMark is 0 and we are not in the flowing mode
                            //   we should _not_ attempt to buffer any extra data. We'll get more data
                            //   when the stream consumer calls read() instead.
                            // - No data in the buffer, and the stream is in flowing mode. In this mode
                            //   the loop below is responsible for ensuring read() is called. Failing to
                            //   call read here would abort the flow and there's no other mechanism for
                            //   continuing the flow if the stream consumer has just subscribed to the
                            //   'data' event.
                            //
                            // In addition to the above conditions to keep reading data, the following
                            // conditions prevent the data from being read:
                            // - The stream has ended (state.ended).
                            // - There is already a pending 'read' operation (state.reading). This is a
                            //   case where the the stream has called the implementation defined _read()
                            //   method, but they are processing the call asynchronously and have _not_
                            //   called push() with new data. In this case we skip performing more
                            //   read()s. The execution ends in this method again after the _read() ends
                            //   up calling push() with more data.
                            while(!state.reading && !state.ended && (state.length < state.highWaterMark || state.flowing && state.length === 0)){
                                var len = state.length;
                                debug("maybeReadMore read 0");
                                stream.read(0);
                                if (len === state.length) break;
                            }
                            state.readingMore = false;
                        } // abstract method.  to be overridden in specific implementation classes.
                        // call cb(er, data) where data is <= n in length.
                        // for virtual (non-string, non-buffer) streams, "length" is somewhat
                        // arbitrary, and perhaps not very meaningful.
                        Readable.prototype._read = function(n) {
                            errorOrDestroy(this, new ERR_METHOD_NOT_IMPLEMENTED("_read()"));
                        };
                        Readable.prototype.pipe = function(dest, pipeOpts) {
                            var src = this;
                            var state = this._readableState;
                            switch(state.pipesCount){
                                case 0:
                                    state.pipes = dest;
                                    break;
                                case 1:
                                    state.pipes = [
                                        state.pipes,
                                        dest
                                    ];
                                    break;
                                default:
                                    state.pipes.push(dest);
                                    break;
                            }
                            state.pipesCount += 1;
                            debug("pipe count=%d opts=%j", state.pipesCount, pipeOpts);
                            var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== process.stdout && dest !== process.stderr;
                            var endFn = doEnd ? onend : unpipe;
                            if (state.endEmitted) process.nextTick(endFn);
                            else src.once("end", endFn);
                            dest.on("unpipe", onunpipe);
                            function onunpipe(readable, unpipeInfo) {
                                debug("onunpipe");
                                if (readable === src) {
                                    if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
                                        unpipeInfo.hasUnpiped = true;
                                        cleanup();
                                    }
                                }
                            }
                            function onend() {
                                debug("onend");
                                dest.end();
                            } // when the dest drains, it reduces the awaitDrain counter
                            // on the source.  This would be more elegant with a .once()
                            // handler in flow(), but adding and removing repeatedly is
                            // too slow.
                            var ondrain = pipeOnDrain(src);
                            dest.on("drain", ondrain);
                            var cleanedUp = false;
                            function cleanup() {
                                debug("cleanup"); // cleanup event handlers once the pipe is broken
                                dest.removeListener("close", onclose);
                                dest.removeListener("finish", onfinish);
                                dest.removeListener("drain", ondrain);
                                dest.removeListener("error", onerror);
                                dest.removeListener("unpipe", onunpipe);
                                src.removeListener("end", onend);
                                src.removeListener("end", unpipe);
                                src.removeListener("data", ondata);
                                cleanedUp = true; // if the reader is waiting for a drain event from this
                                // specific writer, then it would cause it to never start
                                // flowing again.
                                // So, if this is awaiting a drain, then we just call it now.
                                // If we don't know, then assume that we are waiting for one.
                                if (state.awaitDrain && (!dest._writableState || dest._writableState.needDrain)) ondrain();
                            }
                            src.on("data", ondata);
                            function ondata(chunk) {
                                debug("ondata");
                                var ret = dest.write(chunk);
                                debug("dest.write", ret);
                                if (ret === false) {
                                    // If the user unpiped during `dest.write()`, it is possible
                                    // to get stuck in a permanently paused state if that write
                                    // also returned false.
                                    // => Check whether `dest` is still a piping destination.
                                    if ((state.pipesCount === 1 && state.pipes === dest || state.pipesCount > 1 && indexOf(state.pipes, dest) !== -1) && !cleanedUp) {
                                        debug("false write response, pause", state.awaitDrain);
                                        state.awaitDrain++;
                                    }
                                    src.pause();
                                }
                            } // if the dest has an error, then stop piping into it.
                            // however, don't suppress the throwing behavior for this.
                            function onerror(er) {
                                debug("onerror", er);
                                unpipe();
                                dest.removeListener("error", onerror);
                                if (EElistenerCount(dest, "error") === 0) errorOrDestroy(dest, er);
                            } // Make sure our error handler is attached before userland ones.
                            prependListener(dest, "error", onerror); // Both close and finish should trigger unpipe, but only once.
                            function onclose() {
                                dest.removeListener("finish", onfinish);
                                unpipe();
                            }
                            dest.once("close", onclose);
                            function onfinish() {
                                debug("onfinish");
                                dest.removeListener("close", onclose);
                                unpipe();
                            }
                            dest.once("finish", onfinish);
                            function unpipe() {
                                debug("unpipe");
                                src.unpipe(dest);
                            } // tell the dest that it's being piped to
                            dest.emit("pipe", src); // start the flow if it hasn't been started already.
                            if (!state.flowing) {
                                debug("pipe resume");
                                src.resume();
                            }
                            return dest;
                        };
                        function pipeOnDrain(src) {
                            return function pipeOnDrainFunctionResult() {
                                var state = src._readableState;
                                debug("pipeOnDrain", state.awaitDrain);
                                if (state.awaitDrain) state.awaitDrain--;
                                if (state.awaitDrain === 0 && EElistenerCount(src, "data")) {
                                    state.flowing = true;
                                    flow(src);
                                }
                            };
                        }
                        Readable.prototype.unpipe = function(dest) {
                            var state = this._readableState;
                            var unpipeInfo = {
                                hasUnpiped: false
                            }; // if we're not piping anywhere, then do nothing.
                            if (state.pipesCount === 0) return this; // just one destination.  most common case.
                            if (state.pipesCount === 1) {
                                // passed in one, but it's not the right one.
                                if (dest && dest !== state.pipes) return this;
                                if (!dest) dest = state.pipes; // got a match.
                                state.pipes = null;
                                state.pipesCount = 0;
                                state.flowing = false;
                                if (dest) dest.emit("unpipe", this, unpipeInfo);
                                return this;
                            } // slow case. multiple pipe destinations.
                            if (!dest) {
                                // remove all.
                                var dests = state.pipes;
                                var len = state.pipesCount;
                                state.pipes = null;
                                state.pipesCount = 0;
                                state.flowing = false;
                                for(var i = 0; i < len; i++)dests[i].emit("unpipe", this, {
                                    hasUnpiped: false
                                });
                                return this;
                            } // try to find the right one.
                            var index = indexOf(state.pipes, dest);
                            if (index === -1) return this;
                            state.pipes.splice(index, 1);
                            state.pipesCount -= 1;
                            if (state.pipesCount === 1) state.pipes = state.pipes[0];
                            dest.emit("unpipe", this, unpipeInfo);
                            return this;
                        }; // set up data events if they are asked for
                        // Ensure readable listeners eventually get something
                        Readable.prototype.on = function(ev, fn) {
                            var res = Stream.prototype.on.call(this, ev, fn);
                            var state = this._readableState;
                            if (ev === "data") {
                                // update readableListening so that resume() may be a no-op
                                // a few lines down. This is needed to support once('readable').
                                state.readableListening = this.listenerCount("readable") > 0; // Try start flowing on next tick if stream isn't explicitly paused
                                if (state.flowing !== false) this.resume();
                            } else if (ev === "readable") {
                                if (!state.endEmitted && !state.readableListening) {
                                    state.readableListening = state.needReadable = true;
                                    state.flowing = false;
                                    state.emittedReadable = false;
                                    debug("on readable", state.length, state.reading);
                                    if (state.length) emitReadable(this);
                                    else if (!state.reading) process.nextTick(nReadingNextTick, this);
                                }
                            }
                            return res;
                        };
                        Readable.prototype.addListener = Readable.prototype.on;
                        Readable.prototype.removeListener = function(ev, fn) {
                            var res = Stream.prototype.removeListener.call(this, ev, fn);
                            if (ev === "readable") // We need to check if there is someone still listening to
                            // readable and reset the state. However this needs to happen
                            // after readable has been emitted but before I/O (nextTick) to
                            // support once('readable', fn) cycles. This means that calling
                            // resume within the same tick will have no
                            // effect.
                            process.nextTick(updateReadableListening, this);
                            return res;
                        };
                        Readable.prototype.removeAllListeners = function(ev) {
                            var res = Stream.prototype.removeAllListeners.apply(this, arguments);
                            if (ev === "readable" || ev === undefined) // We need to check if there is someone still listening to
                            // readable and reset the state. However this needs to happen
                            // after readable has been emitted but before I/O (nextTick) to
                            // support once('readable', fn) cycles. This means that calling
                            // resume within the same tick will have no
                            // effect.
                            process.nextTick(updateReadableListening, this);
                            return res;
                        };
                        function updateReadableListening(self1) {
                            var state = self1._readableState;
                            state.readableListening = self1.listenerCount("readable") > 0;
                            if (state.resumeScheduled && !state.paused) // flowing needs to be set to true now, otherwise
                            // the upcoming resume will not flow.
                            state.flowing = true; // crude way to check if we should resume
                            else if (self1.listenerCount("data") > 0) self1.resume();
                        }
                        function nReadingNextTick(self1) {
                            debug("readable nexttick read 0");
                            self1.read(0);
                        } // pause() and resume() are remnants of the legacy readable stream API
                        // If the user uses them, then switch into old mode.
                        Readable.prototype.resume = function() {
                            var state = this._readableState;
                            if (!state.flowing) {
                                debug("resume"); // we flow only if there is no one listening
                                // for readable, but we still have to call
                                // resume()
                                state.flowing = !state.readableListening;
                                resume(this, state);
                            }
                            state.paused = false;
                            return this;
                        };
                        function resume(stream, state) {
                            if (!state.resumeScheduled) {
                                state.resumeScheduled = true;
                                process.nextTick(resume_, stream, state);
                            }
                        }
                        function resume_(stream, state) {
                            debug("resume", state.reading);
                            if (!state.reading) stream.read(0);
                            state.resumeScheduled = false;
                            stream.emit("resume");
                            flow(stream);
                            if (state.flowing && !state.reading) stream.read(0);
                        }
                        Readable.prototype.pause = function() {
                            debug("call pause flowing=%j", this._readableState.flowing);
                            if (this._readableState.flowing !== false) {
                                debug("pause");
                                this._readableState.flowing = false;
                                this.emit("pause");
                            }
                            this._readableState.paused = true;
                            return this;
                        };
                        function flow(stream) {
                            var state = stream._readableState;
                            debug("flow", state.flowing);
                            while(state.flowing && stream.read() !== null);
                        } // wrap an old-style stream as the async data source.
                        // This is *not* part of the readable stream interface.
                        // It is an ugly unfortunate mess of history.
                        Readable.prototype.wrap = function(stream) {
                            var _this = this;
                            var state = this._readableState;
                            var paused = false;
                            stream.on("end", function() {
                                debug("wrapped end");
                                if (state.decoder && !state.ended) {
                                    var chunk = state.decoder.end();
                                    if (chunk && chunk.length) _this.push(chunk);
                                }
                                _this.push(null);
                            });
                            stream.on("data", function(chunk) {
                                debug("wrapped data");
                                if (state.decoder) chunk = state.decoder.write(chunk); // don't skip over falsy values in objectMode
                                if (state.objectMode && (chunk === null || chunk === undefined)) return;
                                else if (!state.objectMode && (!chunk || !chunk.length)) return;
                                var ret = _this.push(chunk);
                                if (!ret) {
                                    paused = true;
                                    stream.pause();
                                }
                            }); // proxy all the other methods.
                            // important when wrapping filters and duplexes.
                            for(var i in stream)if (this[i] === undefined && typeof stream[i] === "function") this[i] = function methodWrap(method) {
                                return function methodWrapReturnFunction() {
                                    return stream[method].apply(stream, arguments);
                                };
                            }(i);
                             // proxy certain important events.
                            for(var n = 0; n < kProxyEvents.length; n++)stream.on(kProxyEvents[n], this.emit.bind(this, kProxyEvents[n]));
                             // when we try to consume some more bytes, simply unpause the
                            // underlying stream.
                            this._read = function(n) {
                                debug("wrapped _read", n);
                                if (paused) {
                                    paused = false;
                                    stream.resume();
                                }
                            };
                            return this;
                        };
                        if (typeof Symbol === "function") Readable.prototype[Symbol.asyncIterator] = function() {
                            if (createReadableStreamAsyncIterator === undefined) createReadableStreamAsyncIterator = require("./internal/streams/async_iterator");
                            return createReadableStreamAsyncIterator(this);
                        };
                        Object.defineProperty(Readable.prototype, "readableHighWaterMark", {
                            // making it explicit this property is not enumerable
                            // because otherwise some prototype manipulation in
                            // userland will fail
                            enumerable: false,
                            get: function get() {
                                return this._readableState.highWaterMark;
                            }
                        });
                        Object.defineProperty(Readable.prototype, "readableBuffer", {
                            // making it explicit this property is not enumerable
                            // because otherwise some prototype manipulation in
                            // userland will fail
                            enumerable: false,
                            get: function get() {
                                return this._readableState && this._readableState.buffer;
                            }
                        });
                        Object.defineProperty(Readable.prototype, "readableFlowing", {
                            // making it explicit this property is not enumerable
                            // because otherwise some prototype manipulation in
                            // userland will fail
                            enumerable: false,
                            get: function get() {
                                return this._readableState.flowing;
                            },
                            set: function set(state) {
                                if (this._readableState) this._readableState.flowing = state;
                            }
                        }); // exposed for testing purposes only.
                        Readable._fromList = fromList;
                        Object.defineProperty(Readable.prototype, "readableLength", {
                            // making it explicit this property is not enumerable
                            // because otherwise some prototype manipulation in
                            // userland will fail
                            enumerable: false,
                            get: function get() {
                                return this._readableState.length;
                            }
                        }); // Pluck off n bytes from an array of buffers.
                        // Length is the combined lengths of all the buffers in the list.
                        // This function is designed to be inlinable, so please take care when making
                        // changes to the function body.
                        function fromList(n, state) {
                            // nothing buffered
                            if (state.length === 0) return null;
                            var ret;
                            if (state.objectMode) ret = state.buffer.shift();
                            else if (!n || n >= state.length) {
                                // read it all, truncate the list
                                if (state.decoder) ret = state.buffer.join("");
                                else if (state.buffer.length === 1) ret = state.buffer.first();
                                else ret = state.buffer.concat(state.length);
                                state.buffer.clear();
                            } else // read part of list
                            ret = state.buffer.consume(n, state.decoder);
                            return ret;
                        }
                        function endReadable(stream) {
                            var state = stream._readableState;
                            debug("endReadable", state.endEmitted);
                            if (!state.endEmitted) {
                                state.ended = true;
                                process.nextTick(endReadableNT, state, stream);
                            }
                        }
                        function endReadableNT(state, stream) {
                            debug("endReadableNT", state.endEmitted, state.length); // Check that we didn't get one last unshift.
                            if (!state.endEmitted && state.length === 0) {
                                state.endEmitted = true;
                                stream.readable = false;
                                stream.emit("end");
                                if (state.autoDestroy) {
                                    // In case of duplex streams we need a way to detect
                                    // if the writable side is ready for autoDestroy as well
                                    var wState = stream._writableState;
                                    if (!wState || wState.autoDestroy && wState.finished) stream.destroy();
                                }
                            }
                        }
                        if (typeof Symbol === "function") Readable.from = function(iterable, opts) {
                            if (from === undefined) from = require("./internal/streams/from");
                            return from(Readable, iterable, opts);
                        };
                        function indexOf(xs, x) {
                            for(var i = 0, l = xs.length; i < l; i++){
                                if (xs[i] === x) return i;
                            }
                            return -1;
                        }
                    }).call(this);
                }).call(this, require("_process"), typeof $parcel$global !== "undefined" ? $parcel$global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {});
            },
            {
                "../errors": 42,
                "./_stream_duplex": 43,
                "./internal/streams/async_iterator": 48,
                "./internal/streams/buffer_list": 49,
                "./internal/streams/destroy": 50,
                "./internal/streams/from": 52,
                "./internal/streams/state": 54,
                "./internal/streams/stream": 55,
                "_process": 39,
                "buffer": 35,
                "events": 36,
                "inherits": 38,
                "string_decoder/": 56,
                "util": 34
            }
        ],
        46: [
            function(require, module, exports) {
                // Copyright Joyent, Inc. and other Node contributors.
                //
                // Permission is hereby granted, free of charge, to any person obtaining a
                // copy of this software and associated documentation files (the
                // "Software"), to deal in the Software without restriction, including
                // without limitation the rights to use, copy, modify, merge, publish,
                // distribute, sublicense, and/or sell copies of the Software, and to permit
                // persons to whom the Software is furnished to do so, subject to the
                // following conditions:
                //
                // The above copyright notice and this permission notice shall be included
                // in all copies or substantial portions of the Software.
                //
                // THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
                // OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
                // MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
                // NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
                // DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
                // OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
                // USE OR OTHER DEALINGS IN THE SOFTWARE.
                // a transform stream is a readable/writable stream where you do
                // something with the data.  Sometimes it's called a "filter",
                // but that's not a great name for it, since that implies a thing where
                // some bits pass through, and others are simply ignored.  (That would
                // be a valid example of a transform, of course.)
                //
                // While the output is causally related to the input, it's not a
                // necessarily symmetric or synchronous transformation.  For example,
                // a zlib stream might take multiple plain-text writes(), and then
                // emit a single compressed chunk some time in the future.
                //
                // Here's how this works:
                //
                // The Transform stream has all the aspects of the readable and writable
                // stream classes.  When you write(chunk), that calls _write(chunk,cb)
                // internally, and returns false if there's a lot of pending writes
                // buffered up.  When you call read(), that calls _read(n) until
                // there's enough pending readable data buffered up.
                //
                // In a transform stream, the written data is placed in a buffer.  When
                // _read(n) is called, it transforms the queued up data, calling the
                // buffered _write cb's as it consumes chunks.  If consuming a single
                // written chunk would result in multiple output chunks, then the first
                // outputted bit calls the readcb, and subsequent chunks just go into
                // the read buffer, and will cause it to emit 'readable' if necessary.
                //
                // This way, back-pressure is actually determined by the reading side,
                // since _read has to be called to start processing a new chunk.  However,
                // a pathological inflate type of transform can cause excessive buffering
                // here.  For example, imagine a stream where every byte of input is
                // interpreted as an integer from 0-255, and then results in that many
                // bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
                // 1kb of data being output.  In this case, you could write a very small
                // amount of input, and end up with a very large amount of output.  In
                // such a pathological inflating mechanism, there'd be no way to tell
                // the system to stop doing the transform.  A single 4MB write could
                // cause the system to run out of memory.
                //
                // However, even in such a pathological case, only a single written chunk
                // would be consumed, and then the rest would wait (un-transformed) until
                // the results of the previous transformed chunk were consumed.
                "use strict";
                module.exports = Transform;
                var _require$codes = require("../errors").codes, ERR_METHOD_NOT_IMPLEMENTED = _require$codes.ERR_METHOD_NOT_IMPLEMENTED, ERR_MULTIPLE_CALLBACK = _require$codes.ERR_MULTIPLE_CALLBACK, ERR_TRANSFORM_ALREADY_TRANSFORMING = _require$codes.ERR_TRANSFORM_ALREADY_TRANSFORMING, ERR_TRANSFORM_WITH_LENGTH_0 = _require$codes.ERR_TRANSFORM_WITH_LENGTH_0;
                var Duplex = require("./_stream_duplex");
                require("inherits")(Transform, Duplex);
                function afterTransform(er, data) {
                    var ts = this._transformState;
                    ts.transforming = false;
                    var cb = ts.writecb;
                    if (cb === null) return this.emit("error", new ERR_MULTIPLE_CALLBACK());
                    ts.writechunk = null;
                    ts.writecb = null;
                    if (data != null) this.push(data);
                    cb(er);
                    var rs = this._readableState;
                    rs.reading = false;
                    if (rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
                }
                function Transform(options) {
                    if (!(this instanceof Transform)) return new Transform(options);
                    Duplex.call(this, options);
                    this._transformState = {
                        afterTransform: afterTransform.bind(this),
                        needTransform: false,
                        transforming: false,
                        writecb: null,
                        writechunk: null,
                        writeencoding: null
                    }; // start out asking for a readable event once data is transformed.
                    this._readableState.needReadable = true; // we have implemented the _read method, and done the other things
                    // that Readable wants before the first _read call, so unset the
                    // sync guard flag.
                    this._readableState.sync = false;
                    if (options) {
                        if (typeof options.transform === "function") this._transform = options.transform;
                        if (typeof options.flush === "function") this._flush = options.flush;
                    } // When the writable side finishes, then flush out anything remaining.
                    this.on("prefinish", prefinish);
                }
                function prefinish() {
                    var _this = this;
                    if (typeof this._flush === "function" && !this._readableState.destroyed) this._flush(function(er, data) {
                        done(_this, er, data);
                    });
                    else done(this, null, null);
                }
                Transform.prototype.push = function(chunk, encoding) {
                    this._transformState.needTransform = false;
                    return Duplex.prototype.push.call(this, chunk, encoding);
                }; // This is the part where you do stuff!
                // override this function in implementation classes.
                // 'chunk' is an input chunk.
                //
                // Call `push(newChunk)` to pass along transformed output
                // to the readable side.  You may call 'push' zero or more times.
                //
                // Call `cb(err)` when you are done with this chunk.  If you pass
                // an error, then that'll put the hurt on the whole operation.  If you
                // never call cb(), then you'll never get another chunk.
                Transform.prototype._transform = function(chunk, encoding, cb) {
                    cb(new ERR_METHOD_NOT_IMPLEMENTED("_transform()"));
                };
                Transform.prototype._write = function(chunk, encoding, cb) {
                    var ts = this._transformState;
                    ts.writecb = cb;
                    ts.writechunk = chunk;
                    ts.writeencoding = encoding;
                    if (!ts.transforming) {
                        var rs = this._readableState;
                        if (ts.needTransform || rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
                    }
                }; // Doesn't matter what the args are here.
                // _transform does all the work.
                // That we got here means that the readable side wants more data.
                Transform.prototype._read = function(n) {
                    var ts = this._transformState;
                    if (ts.writechunk !== null && !ts.transforming) {
                        ts.transforming = true;
                        this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
                    } else // mark that we need a transform, so that any data that comes in
                    // will get processed, now that we've asked for it.
                    ts.needTransform = true;
                };
                Transform.prototype._destroy = function(err, cb) {
                    Duplex.prototype._destroy.call(this, err, function(err2) {
                        cb(err2);
                    });
                };
                function done(stream, er, data) {
                    if (er) return stream.emit("error", er);
                    if (data != null) stream.push(data); // TODO(BridgeAR): Write a test for these two error cases
                    // if there's nothing in the write buffer, then that means
                    // that nothing more will ever be provided
                    if (stream._writableState.length) throw new ERR_TRANSFORM_WITH_LENGTH_0();
                    if (stream._transformState.transforming) throw new ERR_TRANSFORM_ALREADY_TRANSFORMING();
                    return stream.push(null);
                }
            },
            {
                "../errors": 42,
                "./_stream_duplex": 43,
                "inherits": 38
            }
        ],
        47: [
            function(require, module, exports) {
                (function(process, global) {
                    (function() {
                        // Copyright Joyent, Inc. and other Node contributors.
                        //
                        // Permission is hereby granted, free of charge, to any person obtaining a
                        // copy of this software and associated documentation files (the
                        // "Software"), to deal in the Software without restriction, including
                        // without limitation the rights to use, copy, modify, merge, publish,
                        // distribute, sublicense, and/or sell copies of the Software, and to permit
                        // persons to whom the Software is furnished to do so, subject to the
                        // following conditions:
                        //
                        // The above copyright notice and this permission notice shall be included
                        // in all copies or substantial portions of the Software.
                        //
                        // THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
                        // OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
                        // MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
                        // NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
                        // DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
                        // OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
                        // USE OR OTHER DEALINGS IN THE SOFTWARE.
                        // A bit simpler than readable streams.
                        // Implement an async ._write(chunk, encoding, cb), and it'll handle all
                        // the drain event emission and buffering.
                        "use strict";
                        module.exports = Writable;
                        /* <replacement> */ function WriteReq(chunk, encoding, cb) {
                            this.chunk = chunk;
                            this.encoding = encoding;
                            this.callback = cb;
                            this.next = null;
                        } // It seems a linked list but it is not
                        // there will be only 2 of these for each stream
                        function CorkedRequest(state) {
                            var _this = this;
                            this.next = null;
                            this.entry = null;
                            this.finish = function() {
                                onCorkedFinish(_this, state);
                            };
                        }
                        /* </replacement> */ /*<replacement>*/ var Duplex;
                        /*</replacement>*/ Writable.WritableState = WritableState;
                        /*<replacement>*/ var internalUtil = {
                            deprecate: require("util-deprecate")
                        };
                        /*</replacement>*/ /*<replacement>*/ var Stream = require("./internal/streams/stream");
                        /*</replacement>*/ var Buffer = require("buffer").Buffer;
                        var OurUint8Array = global.Uint8Array || function() {};
                        function _uint8ArrayToBuffer(chunk) {
                            return Buffer.from(chunk);
                        }
                        function _isUint8Array(obj) {
                            return Buffer.isBuffer(obj) || obj instanceof OurUint8Array;
                        }
                        var destroyImpl = require("./internal/streams/destroy");
                        var _require = require("./internal/streams/state"), getHighWaterMark = _require.getHighWaterMark;
                        var _require$codes = require("../errors").codes, ERR_INVALID_ARG_TYPE = _require$codes.ERR_INVALID_ARG_TYPE, ERR_METHOD_NOT_IMPLEMENTED = _require$codes.ERR_METHOD_NOT_IMPLEMENTED, ERR_MULTIPLE_CALLBACK = _require$codes.ERR_MULTIPLE_CALLBACK, ERR_STREAM_CANNOT_PIPE = _require$codes.ERR_STREAM_CANNOT_PIPE, ERR_STREAM_DESTROYED = _require$codes.ERR_STREAM_DESTROYED, ERR_STREAM_NULL_VALUES = _require$codes.ERR_STREAM_NULL_VALUES, ERR_STREAM_WRITE_AFTER_END = _require$codes.ERR_STREAM_WRITE_AFTER_END, ERR_UNKNOWN_ENCODING = _require$codes.ERR_UNKNOWN_ENCODING;
                        var errorOrDestroy = destroyImpl.errorOrDestroy;
                        require("inherits")(Writable, Stream);
                        function nop() {}
                        function WritableState(options, stream, isDuplex) {
                            Duplex = Duplex || require("./_stream_duplex");
                            options = options || {}; // Duplex streams are both readable and writable, but share
                            // the same options object.
                            // However, some cases require setting options to different
                            // values for the readable and the writable sides of the duplex stream,
                            // e.g. options.readableObjectMode vs. options.writableObjectMode, etc.
                            if (typeof isDuplex !== "boolean") isDuplex = stream instanceof Duplex; // object stream flag to indicate whether or not this stream
                            // contains buffers or objects.
                            this.objectMode = !!options.objectMode;
                            if (isDuplex) this.objectMode = this.objectMode || !!options.writableObjectMode; // the point at which write() starts returning false
                            // Note: 0 is a valid value, means that we always return false if
                            // the entire buffer is not flushed immediately on write()
                            this.highWaterMark = getHighWaterMark(this, options, "writableHighWaterMark", isDuplex); // if _final has been called
                            this.finalCalled = false; // drain event flag.
                            this.needDrain = false; // at the start of calling end()
                            this.ending = false; // when end() has been called, and returned
                            this.ended = false; // when 'finish' is emitted
                            this.finished = false; // has it been destroyed
                            this.destroyed = false; // should we decode strings into buffers before passing to _write?
                            // this is here so that some node-core streams can optimize string
                            // handling at a lower level.
                            var noDecode = options.decodeStrings === false;
                            this.decodeStrings = !noDecode; // Crypto is kind of old and crusty.  Historically, its default string
                            // encoding is 'binary' so we have to make this configurable.
                            // Everything else in the universe uses 'utf8', though.
                            this.defaultEncoding = options.defaultEncoding || "utf8"; // not an actual buffer we keep track of, but a measurement
                            // of how much we're waiting to get pushed to some underlying
                            // socket or file.
                            this.length = 0; // a flag to see when we're in the middle of a write.
                            this.writing = false; // when true all writes will be buffered until .uncork() call
                            this.corked = 0; // a flag to be able to tell if the onwrite cb is called immediately,
                            // or on a later tick.  We set this to true at first, because any
                            // actions that shouldn't happen until "later" should generally also
                            // not happen before the first write call.
                            this.sync = true; // a flag to know if we're processing previously buffered items, which
                            // may call the _write() callback in the same tick, so that we don't
                            // end up in an overlapped onwrite situation.
                            this.bufferProcessing = false; // the callback that's passed to _write(chunk,cb)
                            this.onwrite = function(er) {
                                onwrite(stream, er);
                            }; // the callback that the user supplies to write(chunk,encoding,cb)
                            this.writecb = null; // the amount that is being written when _write is called.
                            this.writelen = 0;
                            this.bufferedRequest = null;
                            this.lastBufferedRequest = null; // number of pending user-supplied write callbacks
                            // this must be 0 before 'finish' can be emitted
                            this.pendingcb = 0; // emit prefinish if the only thing we're waiting for is _write cbs
                            // This is relevant for synchronous Transform streams
                            this.prefinished = false; // True if the error was already emitted and should not be thrown again
                            this.errorEmitted = false; // Should close be emitted on destroy. Defaults to true.
                            this.emitClose = options.emitClose !== false; // Should .destroy() be called after 'finish' (and potentially 'end')
                            this.autoDestroy = !!options.autoDestroy; // count buffered requests
                            this.bufferedRequestCount = 0; // allocate the first CorkedRequest, there is always
                            // one allocated and free to use, and we maintain at most two
                            this.corkedRequestsFree = new CorkedRequest(this);
                        }
                        WritableState.prototype.getBuffer = function getBuffer() {
                            var current = this.bufferedRequest;
                            var out = [];
                            while(current){
                                out.push(current);
                                current = current.next;
                            }
                            return out;
                        };
                        (function() {
                            try {
                                Object.defineProperty(WritableState.prototype, "buffer", {
                                    get: internalUtil.deprecate(function writableStateBufferGetter() {
                                        return this.getBuffer();
                                    }, "_writableState.buffer is deprecated. Use _writableState.getBuffer instead.", "DEP0003")
                                });
                            } catch (_) {}
                        })(); // Test _writableState for inheritance to account for Duplex streams,
                        // whose prototype chain only points to Readable.
                        var realHasInstance;
                        if (typeof Symbol === "function" && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] === "function") {
                            realHasInstance = Function.prototype[Symbol.hasInstance];
                            Object.defineProperty(Writable, Symbol.hasInstance, {
                                value: function value(object) {
                                    if (realHasInstance.call(this, object)) return true;
                                    if (this !== Writable) return false;
                                    return object && object._writableState instanceof WritableState;
                                }
                            });
                        } else realHasInstance = function realHasInstance(object) {
                            return object instanceof this;
                        };
                        function Writable(options) {
                            Duplex = Duplex || require("./_stream_duplex"); // Writable ctor is applied to Duplexes, too.
                            // `realHasInstance` is necessary because using plain `instanceof`
                            // would return false, as no `_writableState` property is attached.
                            // Trying to use the custom `instanceof` for Writable here will also break the
                            // Node.js LazyTransform implementation, which has a non-trivial getter for
                            // `_writableState` that would lead to infinite recursion.
                            // Checking for a Stream.Duplex instance is faster here instead of inside
                            // the WritableState constructor, at least with V8 6.5
                            var isDuplex = this instanceof Duplex;
                            if (!isDuplex && !realHasInstance.call(Writable, this)) return new Writable(options);
                            this._writableState = new WritableState(options, this, isDuplex); // legacy.
                            this.writable = true;
                            if (options) {
                                if (typeof options.write === "function") this._write = options.write;
                                if (typeof options.writev === "function") this._writev = options.writev;
                                if (typeof options.destroy === "function") this._destroy = options.destroy;
                                if (typeof options.final === "function") this._final = options.final;
                            }
                            Stream.call(this);
                        } // Otherwise people can pipe Writable streams, which is just wrong.
                        Writable.prototype.pipe = function() {
                            errorOrDestroy(this, new ERR_STREAM_CANNOT_PIPE());
                        };
                        function writeAfterEnd(stream, cb) {
                            var er = new ERR_STREAM_WRITE_AFTER_END(); // TODO: defer error events consistently everywhere, not just the cb
                            errorOrDestroy(stream, er);
                            process.nextTick(cb, er);
                        } // Checks that a user-supplied chunk is valid, especially for the particular
                        // mode the stream is in. Currently this means that `null` is never accepted
                        // and undefined/non-string values are only allowed in object mode.
                        function validChunk(stream, state, chunk, cb) {
                            var er;
                            if (chunk === null) er = new ERR_STREAM_NULL_VALUES();
                            else if (typeof chunk !== "string" && !state.objectMode) er = new ERR_INVALID_ARG_TYPE("chunk", [
                                "string",
                                "Buffer"
                            ], chunk);
                            if (er) {
                                errorOrDestroy(stream, er);
                                process.nextTick(cb, er);
                                return false;
                            }
                            return true;
                        }
                        Writable.prototype.write = function(chunk, encoding, cb) {
                            var state = this._writableState;
                            var ret = false;
                            var isBuf = !state.objectMode && _isUint8Array(chunk);
                            if (isBuf && !Buffer.isBuffer(chunk)) chunk = _uint8ArrayToBuffer(chunk);
                            if (typeof encoding === "function") {
                                cb = encoding;
                                encoding = null;
                            }
                            if (isBuf) encoding = "buffer";
                            else if (!encoding) encoding = state.defaultEncoding;
                            if (typeof cb !== "function") cb = nop;
                            if (state.ending) writeAfterEnd(this, cb);
                            else if (isBuf || validChunk(this, state, chunk, cb)) {
                                state.pendingcb++;
                                ret = writeOrBuffer(this, state, isBuf, chunk, encoding, cb);
                            }
                            return ret;
                        };
                        Writable.prototype.cork = function() {
                            this._writableState.corked++;
                        };
                        Writable.prototype.uncork = function() {
                            var state = this._writableState;
                            if (state.corked) {
                                state.corked--;
                                if (!state.writing && !state.corked && !state.bufferProcessing && state.bufferedRequest) clearBuffer(this, state);
                            }
                        };
                        Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
                            // node::ParseEncoding() requires lower case.
                            if (typeof encoding === "string") encoding = encoding.toLowerCase();
                            if (!([
                                "hex",
                                "utf8",
                                "utf-8",
                                "ascii",
                                "binary",
                                "base64",
                                "ucs2",
                                "ucs-2",
                                "utf16le",
                                "utf-16le",
                                "raw"
                            ].indexOf((encoding + "").toLowerCase()) > -1)) throw new ERR_UNKNOWN_ENCODING(encoding);
                            this._writableState.defaultEncoding = encoding;
                            return this;
                        };
                        Object.defineProperty(Writable.prototype, "writableBuffer", {
                            // making it explicit this property is not enumerable
                            // because otherwise some prototype manipulation in
                            // userland will fail
                            enumerable: false,
                            get: function get() {
                                return this._writableState && this._writableState.getBuffer();
                            }
                        });
                        function decodeChunk(state, chunk, encoding) {
                            if (!state.objectMode && state.decodeStrings !== false && typeof chunk === "string") chunk = Buffer.from(chunk, encoding);
                            return chunk;
                        }
                        Object.defineProperty(Writable.prototype, "writableHighWaterMark", {
                            // making it explicit this property is not enumerable
                            // because otherwise some prototype manipulation in
                            // userland will fail
                            enumerable: false,
                            get: function get() {
                                return this._writableState.highWaterMark;
                            }
                        }); // if we're already writing something, then just put this
                        // in the queue, and wait our turn.  Otherwise, call _write
                        // If we return false, then we need a drain event, so set that flag.
                        function writeOrBuffer(stream, state, isBuf, chunk, encoding, cb) {
                            if (!isBuf) {
                                var newChunk = decodeChunk(state, chunk, encoding);
                                if (chunk !== newChunk) {
                                    isBuf = true;
                                    encoding = "buffer";
                                    chunk = newChunk;
                                }
                            }
                            var len = state.objectMode ? 1 : chunk.length;
                            state.length += len;
                            var ret = state.length < state.highWaterMark; // we must ensure that previous needDrain will not be reset to false.
                            if (!ret) state.needDrain = true;
                            if (state.writing || state.corked) {
                                var last = state.lastBufferedRequest;
                                state.lastBufferedRequest = {
                                    chunk: chunk,
                                    encoding: encoding,
                                    isBuf: isBuf,
                                    callback: cb,
                                    next: null
                                };
                                if (last) last.next = state.lastBufferedRequest;
                                else state.bufferedRequest = state.lastBufferedRequest;
                                state.bufferedRequestCount += 1;
                            } else doWrite(stream, state, false, len, chunk, encoding, cb);
                            return ret;
                        }
                        function doWrite(stream, state, writev, len, chunk, encoding, cb) {
                            state.writelen = len;
                            state.writecb = cb;
                            state.writing = true;
                            state.sync = true;
                            if (state.destroyed) state.onwrite(new ERR_STREAM_DESTROYED("write"));
                            else if (writev) stream._writev(chunk, state.onwrite);
                            else stream._write(chunk, encoding, state.onwrite);
                            state.sync = false;
                        }
                        function onwriteError(stream, state, sync, er, cb) {
                            --state.pendingcb;
                            if (sync) {
                                // defer the callback if we are being called synchronously
                                // to avoid piling up things on the stack
                                process.nextTick(cb, er); // this can emit finish, and it will always happen
                                // after error
                                process.nextTick(finishMaybe, stream, state);
                                stream._writableState.errorEmitted = true;
                                errorOrDestroy(stream, er);
                            } else {
                                // the caller expect this to happen before if
                                // it is async
                                cb(er);
                                stream._writableState.errorEmitted = true;
                                errorOrDestroy(stream, er); // this can emit finish, but finish must
                                // always follow error
                                finishMaybe(stream, state);
                            }
                        }
                        function onwriteStateUpdate(state) {
                            state.writing = false;
                            state.writecb = null;
                            state.length -= state.writelen;
                            state.writelen = 0;
                        }
                        function onwrite(stream, er) {
                            var state = stream._writableState;
                            var sync = state.sync;
                            var cb = state.writecb;
                            if (typeof cb !== "function") throw new ERR_MULTIPLE_CALLBACK();
                            onwriteStateUpdate(state);
                            if (er) onwriteError(stream, state, sync, er, cb);
                            else {
                                // Check if we're actually ready to finish, but don't emit yet
                                var finished = needFinish(state) || stream.destroyed;
                                if (!finished && !state.corked && !state.bufferProcessing && state.bufferedRequest) clearBuffer(stream, state);
                                if (sync) process.nextTick(afterWrite, stream, state, finished, cb);
                                else afterWrite(stream, state, finished, cb);
                            }
                        }
                        function afterWrite(stream, state, finished, cb) {
                            if (!finished) onwriteDrain(stream, state);
                            state.pendingcb--;
                            cb();
                            finishMaybe(stream, state);
                        } // Must force callback to be called on nextTick, so that we don't
                        // emit 'drain' before the write() consumer gets the 'false' return
                        // value, and has a chance to attach a 'drain' listener.
                        function onwriteDrain(stream, state) {
                            if (state.length === 0 && state.needDrain) {
                                state.needDrain = false;
                                stream.emit("drain");
                            }
                        } // if there's something in the buffer waiting, then process it
                        function clearBuffer(stream, state) {
                            state.bufferProcessing = true;
                            var entry = state.bufferedRequest;
                            if (stream._writev && entry && entry.next) {
                                // Fast case, write everything using _writev()
                                var l = state.bufferedRequestCount;
                                var buffer = new Array(l);
                                var holder = state.corkedRequestsFree;
                                holder.entry = entry;
                                var count = 0;
                                var allBuffers = true;
                                while(entry){
                                    buffer[count] = entry;
                                    if (!entry.isBuf) allBuffers = false;
                                    entry = entry.next;
                                    count += 1;
                                }
                                buffer.allBuffers = allBuffers;
                                doWrite(stream, state, true, state.length, buffer, "", holder.finish); // doWrite is almost always async, defer these to save a bit of time
                                // as the hot path ends with doWrite
                                state.pendingcb++;
                                state.lastBufferedRequest = null;
                                if (holder.next) {
                                    state.corkedRequestsFree = holder.next;
                                    holder.next = null;
                                } else state.corkedRequestsFree = new CorkedRequest(state);
                                state.bufferedRequestCount = 0;
                            } else {
                                // Slow case, write chunks one-by-one
                                while(entry){
                                    var chunk = entry.chunk;
                                    var encoding = entry.encoding;
                                    var cb = entry.callback;
                                    var len = state.objectMode ? 1 : chunk.length;
                                    doWrite(stream, state, false, len, chunk, encoding, cb);
                                    entry = entry.next;
                                    state.bufferedRequestCount--; // if we didn't call the onwrite immediately, then
                                    // it means that we need to wait until it does.
                                    // also, that means that the chunk and cb are currently
                                    // being processed, so move the buffer counter past them.
                                    if (state.writing) break;
                                }
                                if (entry === null) state.lastBufferedRequest = null;
                            }
                            state.bufferedRequest = entry;
                            state.bufferProcessing = false;
                        }
                        Writable.prototype._write = function(chunk, encoding, cb) {
                            cb(new ERR_METHOD_NOT_IMPLEMENTED("_write()"));
                        };
                        Writable.prototype._writev = null;
                        Writable.prototype.end = function(chunk, encoding, cb) {
                            var state = this._writableState;
                            if (typeof chunk === "function") {
                                cb = chunk;
                                chunk = null;
                                encoding = null;
                            } else if (typeof encoding === "function") {
                                cb = encoding;
                                encoding = null;
                            }
                            if (chunk !== null && chunk !== undefined) this.write(chunk, encoding); // .end() fully uncorks
                            if (state.corked) {
                                state.corked = 1;
                                this.uncork();
                            } // ignore unnecessary end() calls.
                            if (!state.ending) endWritable(this, state, cb);
                            return this;
                        };
                        Object.defineProperty(Writable.prototype, "writableLength", {
                            // making it explicit this property is not enumerable
                            // because otherwise some prototype manipulation in
                            // userland will fail
                            enumerable: false,
                            get: function get() {
                                return this._writableState.length;
                            }
                        });
                        function needFinish(state) {
                            return state.ending && state.length === 0 && state.bufferedRequest === null && !state.finished && !state.writing;
                        }
                        function callFinal(stream, state) {
                            stream._final(function(err) {
                                state.pendingcb--;
                                if (err) errorOrDestroy(stream, err);
                                state.prefinished = true;
                                stream.emit("prefinish");
                                finishMaybe(stream, state);
                            });
                        }
                        function prefinish(stream, state) {
                            if (!state.prefinished && !state.finalCalled) {
                                if (typeof stream._final === "function" && !state.destroyed) {
                                    state.pendingcb++;
                                    state.finalCalled = true;
                                    process.nextTick(callFinal, stream, state);
                                } else {
                                    state.prefinished = true;
                                    stream.emit("prefinish");
                                }
                            }
                        }
                        function finishMaybe(stream, state) {
                            var need = needFinish(state);
                            if (need) {
                                prefinish(stream, state);
                                if (state.pendingcb === 0) {
                                    state.finished = true;
                                    stream.emit("finish");
                                    if (state.autoDestroy) {
                                        // In case of duplex streams we need a way to detect
                                        // if the readable side is ready for autoDestroy as well
                                        var rState = stream._readableState;
                                        if (!rState || rState.autoDestroy && rState.endEmitted) stream.destroy();
                                    }
                                }
                            }
                            return need;
                        }
                        function endWritable(stream, state, cb) {
                            state.ending = true;
                            finishMaybe(stream, state);
                            if (cb) {
                                if (state.finished) process.nextTick(cb);
                                else stream.once("finish", cb);
                            }
                            state.ended = true;
                            stream.writable = false;
                        }
                        function onCorkedFinish(corkReq, state, err) {
                            var entry = corkReq.entry;
                            corkReq.entry = null;
                            while(entry){
                                var cb = entry.callback;
                                state.pendingcb--;
                                cb(err);
                                entry = entry.next;
                            } // reuse the free corkReq.
                            state.corkedRequestsFree.next = corkReq;
                        }
                        Object.defineProperty(Writable.prototype, "destroyed", {
                            // making it explicit this property is not enumerable
                            // because otherwise some prototype manipulation in
                            // userland will fail
                            enumerable: false,
                            get: function get() {
                                if (this._writableState === undefined) return false;
                                return this._writableState.destroyed;
                            },
                            set: function set(value) {
                                // we ignore the value if the stream
                                // has not been initialized yet
                                if (!this._writableState) return;
                                 // backward compatibility, the user is explicitly
                                // managing destroyed
                                this._writableState.destroyed = value;
                            }
                        });
                        Writable.prototype.destroy = destroyImpl.destroy;
                        Writable.prototype._undestroy = destroyImpl.undestroy;
                        Writable.prototype._destroy = function(err, cb) {
                            cb(err);
                        };
                    }).call(this);
                }).call(this, require("_process"), typeof $parcel$global !== "undefined" ? $parcel$global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {});
            },
            {
                "../errors": 42,
                "./_stream_duplex": 43,
                "./internal/streams/destroy": 50,
                "./internal/streams/state": 54,
                "./internal/streams/stream": 55,
                "_process": 39,
                "buffer": 35,
                "inherits": 38,
                "util-deprecate": 57
            }
        ],
        48: [
            function(require, module, exports) {
                (function(process) {
                    (function() {
                        "use strict";
                        var _Object$setPrototypeO;
                        function _defineProperty(obj, key, value) {
                            if (key in obj) Object.defineProperty(obj, key, {
                                value: value,
                                enumerable: true,
                                configurable: true,
                                writable: true
                            });
                            else obj[key] = value;
                            return obj;
                        }
                        var finished = require("./end-of-stream");
                        var kLastResolve = Symbol("lastResolve");
                        var kLastReject = Symbol("lastReject");
                        var kError = Symbol("error");
                        var kEnded = Symbol("ended");
                        var kLastPromise = Symbol("lastPromise");
                        var kHandlePromise = Symbol("handlePromise");
                        var kStream = Symbol("stream");
                        function createIterResult(value, done) {
                            return {
                                value: value,
                                done: done
                            };
                        }
                        function readAndResolve(iter) {
                            var resolve = iter[kLastResolve];
                            if (resolve !== null) {
                                var data = iter[kStream].read(); // we defer if data is null
                                // we can be expecting either 'end' or
                                // 'error'
                                if (data !== null) {
                                    iter[kLastPromise] = null;
                                    iter[kLastResolve] = null;
                                    iter[kLastReject] = null;
                                    resolve(createIterResult(data, false));
                                }
                            }
                        }
                        function onReadable(iter) {
                            // we wait for the next tick, because it might
                            // emit an error with process.nextTick
                            process.nextTick(readAndResolve, iter);
                        }
                        function wrapForNext(lastPromise, iter) {
                            return function(resolve, reject) {
                                lastPromise.then(function() {
                                    if (iter[kEnded]) {
                                        resolve(createIterResult(undefined, true));
                                        return;
                                    }
                                    iter[kHandlePromise](resolve, reject);
                                }, reject);
                            };
                        }
                        var AsyncIteratorPrototype = Object.getPrototypeOf(function() {});
                        var ReadableStreamAsyncIteratorPrototype = Object.setPrototypeOf((_Object$setPrototypeO = {
                            get stream () {
                                return this[kStream];
                            },
                            next: function next() {
                                var _this = this;
                                // if we have detected an error in the meanwhile
                                // reject straight away
                                var error = this[kError];
                                if (error !== null) return Promise.reject(error);
                                if (this[kEnded]) return Promise.resolve(createIterResult(undefined, true));
                                if (this[kStream].destroyed) // We need to defer via nextTick because if .destroy(err) is
                                // called, the error will be emitted via nextTick, and
                                // we cannot guarantee that there is no error lingering around
                                // waiting to be emitted.
                                return new Promise(function(resolve, reject) {
                                    process.nextTick(function() {
                                        if (_this[kError]) reject(_this[kError]);
                                        else resolve(createIterResult(undefined, true));
                                    });
                                });
                                 // if we have multiple next() calls
                                // we will wait for the previous Promise to finish
                                // this logic is optimized to support for await loops,
                                // where next() is only called once at a time
                                var lastPromise = this[kLastPromise];
                                var promise;
                                if (lastPromise) promise = new Promise(wrapForNext(lastPromise, this));
                                else {
                                    // fast path needed to support multiple this.push()
                                    // without triggering the next() queue
                                    var data = this[kStream].read();
                                    if (data !== null) return Promise.resolve(createIterResult(data, false));
                                    promise = new Promise(this[kHandlePromise]);
                                }
                                this[kLastPromise] = promise;
                                return promise;
                            }
                        }, _defineProperty(_Object$setPrototypeO, Symbol.asyncIterator, function() {
                            return this;
                        }), _defineProperty(_Object$setPrototypeO, "return", function _return() {
                            var _this2 = this;
                            // destroy(err, cb) is a private API
                            // we can guarantee we have that here, because we control the
                            // Readable class this is attached to
                            return new Promise(function(resolve, reject) {
                                _this2[kStream].destroy(null, function(err) {
                                    if (err) {
                                        reject(err);
                                        return;
                                    }
                                    resolve(createIterResult(undefined, true));
                                });
                            });
                        }), _Object$setPrototypeO), AsyncIteratorPrototype);
                        var createReadableStreamAsyncIterator = function createReadableStreamAsyncIterator(stream) {
                            var _Object$create;
                            var iterator = Object.create(ReadableStreamAsyncIteratorPrototype, (_Object$create = {}, _defineProperty(_Object$create, kStream, {
                                value: stream,
                                writable: true
                            }), _defineProperty(_Object$create, kLastResolve, {
                                value: null,
                                writable: true
                            }), _defineProperty(_Object$create, kLastReject, {
                                value: null,
                                writable: true
                            }), _defineProperty(_Object$create, kError, {
                                value: null,
                                writable: true
                            }), _defineProperty(_Object$create, kEnded, {
                                value: stream._readableState.endEmitted,
                                writable: true
                            }), _defineProperty(_Object$create, kHandlePromise, {
                                value: function value(resolve, reject) {
                                    var data = iterator[kStream].read();
                                    if (data) {
                                        iterator[kLastPromise] = null;
                                        iterator[kLastResolve] = null;
                                        iterator[kLastReject] = null;
                                        resolve(createIterResult(data, false));
                                    } else {
                                        iterator[kLastResolve] = resolve;
                                        iterator[kLastReject] = reject;
                                    }
                                },
                                writable: true
                            }), _Object$create));
                            iterator[kLastPromise] = null;
                            finished(stream, function(err) {
                                if (err && err.code !== "ERR_STREAM_PREMATURE_CLOSE") {
                                    var reject = iterator[kLastReject]; // reject if we are waiting for data in the Promise
                                    // returned by next() and store the error
                                    if (reject !== null) {
                                        iterator[kLastPromise] = null;
                                        iterator[kLastResolve] = null;
                                        iterator[kLastReject] = null;
                                        reject(err);
                                    }
                                    iterator[kError] = err;
                                    return;
                                }
                                var resolve = iterator[kLastResolve];
                                if (resolve !== null) {
                                    iterator[kLastPromise] = null;
                                    iterator[kLastResolve] = null;
                                    iterator[kLastReject] = null;
                                    resolve(createIterResult(undefined, true));
                                }
                                iterator[kEnded] = true;
                            });
                            stream.on("readable", onReadable.bind(null, iterator));
                            return iterator;
                        };
                        module.exports = createReadableStreamAsyncIterator;
                    }).call(this);
                }).call(this, require("_process"));
            },
            {
                "./end-of-stream": 51,
                "_process": 39
            }
        ],
        49: [
            function(require, module, exports) {
                "use strict";
                function ownKeys(object, enumerableOnly) {
                    var keys = Object.keys(object);
                    if (Object.getOwnPropertySymbols) {
                        var symbols = Object.getOwnPropertySymbols(object);
                        if (enumerableOnly) symbols = symbols.filter(function(sym) {
                            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
                        });
                        keys.push.apply(keys, symbols);
                    }
                    return keys;
                }
                function _objectSpread(target) {
                    for(var i = 1; i < arguments.length; i++){
                        var source = arguments[i] != null ? arguments[i] : {};
                        if (i % 2) ownKeys(Object(source), true).forEach(function(key) {
                            _defineProperty(target, key, source[key]);
                        });
                        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
                        else ownKeys(Object(source)).forEach(function(key) {
                            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
                        });
                    }
                    return target;
                }
                function _defineProperty(obj, key, value) {
                    if (key in obj) Object.defineProperty(obj, key, {
                        value: value,
                        enumerable: true,
                        configurable: true,
                        writable: true
                    });
                    else obj[key] = value;
                    return obj;
                }
                function _classCallCheck(instance, Constructor) {
                    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
                }
                function _defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                function _createClass(Constructor, protoProps, staticProps) {
                    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) _defineProperties(Constructor, staticProps);
                    return Constructor;
                }
                var _require = require("buffer"), Buffer = _require.Buffer;
                var _require2 = require("util"), inspect = _require2.inspect;
                var custom = inspect && inspect.custom || "inspect";
                function copyBuffer(src, target, offset) {
                    Buffer.prototype.copy.call(src, target, offset);
                }
                module.exports = /*#__PURE__*/ function() {
                    function BufferList() {
                        _classCallCheck(this, BufferList);
                        this.head = null;
                        this.tail = null;
                        this.length = 0;
                    }
                    _createClass(BufferList, [
                        {
                            key: "push",
                            value: function push(v) {
                                var entry = {
                                    data: v,
                                    next: null
                                };
                                if (this.length > 0) this.tail.next = entry;
                                else this.head = entry;
                                this.tail = entry;
                                ++this.length;
                            }
                        },
                        {
                            key: "unshift",
                            value: function unshift(v) {
                                var entry = {
                                    data: v,
                                    next: this.head
                                };
                                if (this.length === 0) this.tail = entry;
                                this.head = entry;
                                ++this.length;
                            }
                        },
                        {
                            key: "shift",
                            value: function shift() {
                                if (this.length === 0) return;
                                var ret = this.head.data;
                                if (this.length === 1) this.head = this.tail = null;
                                else this.head = this.head.next;
                                --this.length;
                                return ret;
                            }
                        },
                        {
                            key: "clear",
                            value: function clear() {
                                this.head = this.tail = null;
                                this.length = 0;
                            }
                        },
                        {
                            key: "join",
                            value: function join(s) {
                                if (this.length === 0) return "";
                                var p = this.head;
                                var ret = "" + p.data;
                                while(p = p.next)ret += s + p.data;
                                return ret;
                            }
                        },
                        {
                            key: "concat",
                            value: function concat(n) {
                                if (this.length === 0) return Buffer.alloc(0);
                                var ret = Buffer.allocUnsafe(n >>> 0);
                                var p = this.head;
                                var i = 0;
                                while(p){
                                    copyBuffer(p.data, ret, i);
                                    i += p.data.length;
                                    p = p.next;
                                }
                                return ret;
                            } // Consumes a specified amount of bytes or characters from the buffered data.
                        },
                        {
                            key: "consume",
                            value: function consume(n, hasStrings) {
                                var ret;
                                if (n < this.head.data.length) {
                                    // `slice` is the same for buffers and strings.
                                    ret = this.head.data.slice(0, n);
                                    this.head.data = this.head.data.slice(n);
                                } else if (n === this.head.data.length) // First chunk is a perfect match.
                                ret = this.shift();
                                else // Result spans more than one buffer.
                                ret = hasStrings ? this._getString(n) : this._getBuffer(n);
                                return ret;
                            }
                        },
                        {
                            key: "first",
                            value: function first() {
                                return this.head.data;
                            } // Consumes a specified amount of characters from the buffered data.
                        },
                        {
                            key: "_getString",
                            value: function _getString(n) {
                                var p = this.head;
                                var c = 1;
                                var ret = p.data;
                                n -= ret.length;
                                while(p = p.next){
                                    var str = p.data;
                                    var nb = n > str.length ? str.length : n;
                                    if (nb === str.length) ret += str;
                                    else ret += str.slice(0, n);
                                    n -= nb;
                                    if (n === 0) {
                                        if (nb === str.length) {
                                            ++c;
                                            if (p.next) this.head = p.next;
                                            else this.head = this.tail = null;
                                        } else {
                                            this.head = p;
                                            p.data = str.slice(nb);
                                        }
                                        break;
                                    }
                                    ++c;
                                }
                                this.length -= c;
                                return ret;
                            } // Consumes a specified amount of bytes from the buffered data.
                        },
                        {
                            key: "_getBuffer",
                            value: function _getBuffer(n) {
                                var ret = Buffer.allocUnsafe(n);
                                var p = this.head;
                                var c = 1;
                                p.data.copy(ret);
                                n -= p.data.length;
                                while(p = p.next){
                                    var buf = p.data;
                                    var nb = n > buf.length ? buf.length : n;
                                    buf.copy(ret, ret.length - n, 0, nb);
                                    n -= nb;
                                    if (n === 0) {
                                        if (nb === buf.length) {
                                            ++c;
                                            if (p.next) this.head = p.next;
                                            else this.head = this.tail = null;
                                        } else {
                                            this.head = p;
                                            p.data = buf.slice(nb);
                                        }
                                        break;
                                    }
                                    ++c;
                                }
                                this.length -= c;
                                return ret;
                            } // Make sure the linked list only shows the minimal necessary information.
                        },
                        {
                            key: custom,
                            value: function value(_, options) {
                                return inspect(this, _objectSpread({}, options, {
                                    // Only inspect one level.
                                    depth: 0,
                                    // It should not recurse.
                                    customInspect: false
                                }));
                            }
                        }
                    ]);
                    return BufferList;
                }();
            },
            {
                "buffer": 35,
                "util": 34
            }
        ],
        50: [
            function(require, module, exports) {
                (function(process) {
                    (function() {
                        "use strict"; // undocumented cb() API, needed for core, not for public API
                        function destroy(err, cb) {
                            var _this = this;
                            var readableDestroyed = this._readableState && this._readableState.destroyed;
                            var writableDestroyed = this._writableState && this._writableState.destroyed;
                            if (readableDestroyed || writableDestroyed) {
                                if (cb) cb(err);
                                else if (err) {
                                    if (!this._writableState) process.nextTick(emitErrorNT, this, err);
                                    else if (!this._writableState.errorEmitted) {
                                        this._writableState.errorEmitted = true;
                                        process.nextTick(emitErrorNT, this, err);
                                    }
                                }
                                return this;
                            } // we set destroyed to true before firing error callbacks in order
                            // to make it re-entrance safe in case destroy() is called within callbacks
                            if (this._readableState) this._readableState.destroyed = true;
                             // if this is a duplex stream mark the writable part as destroyed as well
                            if (this._writableState) this._writableState.destroyed = true;
                            this._destroy(err || null, function(err) {
                                if (!cb && err) {
                                    if (!_this._writableState) process.nextTick(emitErrorAndCloseNT, _this, err);
                                    else if (!_this._writableState.errorEmitted) {
                                        _this._writableState.errorEmitted = true;
                                        process.nextTick(emitErrorAndCloseNT, _this, err);
                                    } else process.nextTick(emitCloseNT, _this);
                                } else if (cb) {
                                    process.nextTick(emitCloseNT, _this);
                                    cb(err);
                                } else process.nextTick(emitCloseNT, _this);
                            });
                            return this;
                        }
                        function emitErrorAndCloseNT(self1, err) {
                            emitErrorNT(self1, err);
                            emitCloseNT(self1);
                        }
                        function emitCloseNT(self1) {
                            if (self1._writableState && !self1._writableState.emitClose) return;
                            if (self1._readableState && !self1._readableState.emitClose) return;
                            self1.emit("close");
                        }
                        function undestroy() {
                            if (this._readableState) {
                                this._readableState.destroyed = false;
                                this._readableState.reading = false;
                                this._readableState.ended = false;
                                this._readableState.endEmitted = false;
                            }
                            if (this._writableState) {
                                this._writableState.destroyed = false;
                                this._writableState.ended = false;
                                this._writableState.ending = false;
                                this._writableState.finalCalled = false;
                                this._writableState.prefinished = false;
                                this._writableState.finished = false;
                                this._writableState.errorEmitted = false;
                            }
                        }
                        function emitErrorNT(self1, err) {
                            self1.emit("error", err);
                        }
                        function errorOrDestroy(stream, err) {
                            // We have tests that rely on errors being emitted
                            // in the same tick, so changing this is semver major.
                            // For now when you opt-in to autoDestroy we allow
                            // the error to be emitted nextTick. In a future
                            // semver major update we should change the default to this.
                            var rState = stream._readableState;
                            var wState = stream._writableState;
                            if (rState && rState.autoDestroy || wState && wState.autoDestroy) stream.destroy(err);
                            else stream.emit("error", err);
                        }
                        module.exports = {
                            destroy: destroy,
                            undestroy: undestroy,
                            errorOrDestroy: errorOrDestroy
                        };
                    }).call(this);
                }).call(this, require("_process"));
            },
            {
                "_process": 39
            }
        ],
        51: [
            function(require, module, exports) {
                // Ported from https://github.com/mafintosh/end-of-stream with
                // permission from the author, Mathias Buus (@mafintosh).
                "use strict";
                var ERR_STREAM_PREMATURE_CLOSE = require("../../../errors").codes.ERR_STREAM_PREMATURE_CLOSE;
                function once(callback) {
                    var called = false;
                    return function() {
                        if (called) return;
                        called = true;
                        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                        callback.apply(this, args);
                    };
                }
                function noop() {}
                function isRequest(stream) {
                    return stream.setHeader && typeof stream.abort === "function";
                }
                function eos(stream, opts, callback) {
                    if (typeof opts === "function") return eos(stream, null, opts);
                    if (!opts) opts = {};
                    callback = once(callback || noop);
                    var readable = opts.readable || opts.readable !== false && stream.readable;
                    var writable = opts.writable || opts.writable !== false && stream.writable;
                    var onlegacyfinish = function onlegacyfinish() {
                        if (!stream.writable) onfinish();
                    };
                    var writableEnded = stream._writableState && stream._writableState.finished;
                    var onfinish = function onfinish() {
                        writable = false;
                        writableEnded = true;
                        if (!readable) callback.call(stream);
                    };
                    var readableEnded = stream._readableState && stream._readableState.endEmitted;
                    var onend = function onend() {
                        readable = false;
                        readableEnded = true;
                        if (!writable) callback.call(stream);
                    };
                    var onerror = function onerror(err) {
                        callback.call(stream, err);
                    };
                    var onclose = function onclose() {
                        var err;
                        if (readable && !readableEnded) {
                            if (!stream._readableState || !stream._readableState.ended) err = new ERR_STREAM_PREMATURE_CLOSE();
                            return callback.call(stream, err);
                        }
                        if (writable && !writableEnded) {
                            if (!stream._writableState || !stream._writableState.ended) err = new ERR_STREAM_PREMATURE_CLOSE();
                            return callback.call(stream, err);
                        }
                    };
                    var onrequest = function onrequest() {
                        stream.req.on("finish", onfinish);
                    };
                    if (isRequest(stream)) {
                        stream.on("complete", onfinish);
                        stream.on("abort", onclose);
                        if (stream.req) onrequest();
                        else stream.on("request", onrequest);
                    } else if (writable && !stream._writableState) {
                        // legacy streams
                        stream.on("end", onlegacyfinish);
                        stream.on("close", onlegacyfinish);
                    }
                    stream.on("end", onend);
                    stream.on("finish", onfinish);
                    if (opts.error !== false) stream.on("error", onerror);
                    stream.on("close", onclose);
                    return function() {
                        stream.removeListener("complete", onfinish);
                        stream.removeListener("abort", onclose);
                        stream.removeListener("request", onrequest);
                        if (stream.req) stream.req.removeListener("finish", onfinish);
                        stream.removeListener("end", onlegacyfinish);
                        stream.removeListener("close", onlegacyfinish);
                        stream.removeListener("finish", onfinish);
                        stream.removeListener("end", onend);
                        stream.removeListener("error", onerror);
                        stream.removeListener("close", onclose);
                    };
                }
                module.exports = eos;
            },
            {
                "../../../errors": 42
            }
        ],
        52: [
            function(require, module, exports) {
                module.exports = function() {
                    throw new Error("Readable.from is not available in the browser");
                };
            },
            {}
        ],
        53: [
            function(require, module, exports) {
                // Ported from https://github.com/mafintosh/pump with
                // permission from the author, Mathias Buus (@mafintosh).
                "use strict";
                var eos;
                function once(callback) {
                    var called = false;
                    return function() {
                        if (called) return;
                        called = true;
                        callback.apply(void 0, arguments);
                    };
                }
                var _require$codes = require("../../../errors").codes, ERR_MISSING_ARGS = _require$codes.ERR_MISSING_ARGS, ERR_STREAM_DESTROYED = _require$codes.ERR_STREAM_DESTROYED;
                function noop(err) {
                    // Rethrow the error if it exists to avoid swallowing it
                    if (err) throw err;
                }
                function isRequest(stream) {
                    return stream.setHeader && typeof stream.abort === "function";
                }
                function destroyer(stream, reading, writing, callback) {
                    callback = once(callback);
                    var closed = false;
                    stream.on("close", function() {
                        closed = true;
                    });
                    if (eos === undefined) eos = require("./end-of-stream");
                    eos(stream, {
                        readable: reading,
                        writable: writing
                    }, function(err) {
                        if (err) return callback(err);
                        closed = true;
                        callback();
                    });
                    var destroyed = false;
                    return function(err) {
                        if (closed) return;
                        if (destroyed) return;
                        destroyed = true; // request.destroy just do .end - .abort is what we want
                        if (isRequest(stream)) return stream.abort();
                        if (typeof stream.destroy === "function") return stream.destroy();
                        callback(err || new ERR_STREAM_DESTROYED("pipe"));
                    };
                }
                function call(fn) {
                    fn();
                }
                function pipe(from, to) {
                    return from.pipe(to);
                }
                function popCallback(streams) {
                    if (!streams.length) return noop;
                    if (typeof streams[streams.length - 1] !== "function") return noop;
                    return streams.pop();
                }
                function pipeline() {
                    for(var _len = arguments.length, streams = new Array(_len), _key = 0; _key < _len; _key++)streams[_key] = arguments[_key];
                    var callback = popCallback(streams);
                    if (Array.isArray(streams[0])) streams = streams[0];
                    if (streams.length < 2) throw new ERR_MISSING_ARGS("streams");
                    var error;
                    var destroys = streams.map(function(stream, i) {
                        var reading = i < streams.length - 1;
                        var writing = i > 0;
                        return destroyer(stream, reading, writing, function(err) {
                            if (!error) error = err;
                            if (err) destroys.forEach(call);
                            if (reading) return;
                            destroys.forEach(call);
                            callback(error);
                        });
                    });
                    return streams.reduce(pipe);
                }
                module.exports = pipeline;
            },
            {
                "../../../errors": 42,
                "./end-of-stream": 51
            }
        ],
        54: [
            function(require, module, exports) {
                "use strict";
                var ERR_INVALID_OPT_VALUE = require("../../../errors").codes.ERR_INVALID_OPT_VALUE;
                function highWaterMarkFrom(options, isDuplex, duplexKey) {
                    return options.highWaterMark != null ? options.highWaterMark : isDuplex ? options[duplexKey] : null;
                }
                function getHighWaterMark(state, options, duplexKey, isDuplex) {
                    var hwm = highWaterMarkFrom(options, isDuplex, duplexKey);
                    if (hwm != null) {
                        if (!(isFinite(hwm) && Math.floor(hwm) === hwm) || hwm < 0) {
                            var name = isDuplex ? duplexKey : "highWaterMark";
                            throw new ERR_INVALID_OPT_VALUE(name, hwm);
                        }
                        return Math.floor(hwm);
                    } // Default value
                    return state.objectMode ? 16 : 16384;
                }
                module.exports = {
                    getHighWaterMark: getHighWaterMark
                };
            },
            {
                "../../../errors": 42
            }
        ],
        55: [
            function(require, module, exports) {
                module.exports = require("events").EventEmitter;
            },
            {
                "events": 36
            }
        ],
        56: [
            function(require, module, exports) {
                // Copyright Joyent, Inc. and other Node contributors.
                //
                // Permission is hereby granted, free of charge, to any person obtaining a
                // copy of this software and associated documentation files (the
                // "Software"), to deal in the Software without restriction, including
                // without limitation the rights to use, copy, modify, merge, publish,
                // distribute, sublicense, and/or sell copies of the Software, and to permit
                // persons to whom the Software is furnished to do so, subject to the
                // following conditions:
                //
                // The above copyright notice and this permission notice shall be included
                // in all copies or substantial portions of the Software.
                //
                // THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
                // OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
                // MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
                // NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
                // DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
                // OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
                // USE OR OTHER DEALINGS IN THE SOFTWARE.
                "use strict";
                /*<replacement>*/ var Buffer = require("safe-buffer").Buffer;
                /*</replacement>*/ var isEncoding = Buffer.isEncoding || function(encoding) {
                    encoding = "" + encoding;
                    switch(encoding && encoding.toLowerCase()){
                        case "hex":
                        case "utf8":
                        case "utf-8":
                        case "ascii":
                        case "binary":
                        case "base64":
                        case "ucs2":
                        case "ucs-2":
                        case "utf16le":
                        case "utf-16le":
                        case "raw":
                            return true;
                        default:
                            return false;
                    }
                };
                function _normalizeEncoding(enc) {
                    if (!enc) return "utf8";
                    var retried;
                    while(true)switch(enc){
                        case "utf8":
                        case "utf-8":
                            return "utf8";
                        case "ucs2":
                        case "ucs-2":
                        case "utf16le":
                        case "utf-16le":
                            return "utf16le";
                        case "latin1":
                        case "binary":
                            return "latin1";
                        case "base64":
                        case "ascii":
                        case "hex":
                            return enc;
                        default:
                            if (retried) return; // undefined
                            enc = ("" + enc).toLowerCase();
                            retried = true;
                    }
                }
                // Do not cache `Buffer.isEncoding` when checking encoding names as some
                // modules monkey-patch it to support additional encodings
                function normalizeEncoding(enc) {
                    var nenc = _normalizeEncoding(enc);
                    if (typeof nenc !== "string" && (Buffer.isEncoding === isEncoding || !isEncoding(enc))) throw new Error("Unknown encoding: " + enc);
                    return nenc || enc;
                }
                // StringDecoder provides an interface for efficiently splitting a series of
                // buffers into a series of JS strings without breaking apart multi-byte
                // characters.
                exports.StringDecoder = StringDecoder;
                function StringDecoder(encoding) {
                    this.encoding = normalizeEncoding(encoding);
                    var nb;
                    switch(this.encoding){
                        case "utf16le":
                            this.text = utf16Text;
                            this.end = utf16End;
                            nb = 4;
                            break;
                        case "utf8":
                            this.fillLast = utf8FillLast;
                            nb = 4;
                            break;
                        case "base64":
                            this.text = base64Text;
                            this.end = base64End;
                            nb = 3;
                            break;
                        default:
                            this.write = simpleWrite;
                            this.end = simpleEnd;
                            return;
                    }
                    this.lastNeed = 0;
                    this.lastTotal = 0;
                    this.lastChar = Buffer.allocUnsafe(nb);
                }
                StringDecoder.prototype.write = function(buf) {
                    if (buf.length === 0) return "";
                    var r;
                    var i;
                    if (this.lastNeed) {
                        r = this.fillLast(buf);
                        if (r === undefined) return "";
                        i = this.lastNeed;
                        this.lastNeed = 0;
                    } else i = 0;
                    if (i < buf.length) return r ? r + this.text(buf, i) : this.text(buf, i);
                    return r || "";
                };
                StringDecoder.prototype.end = utf8End;
                // Returns only complete characters in a Buffer
                StringDecoder.prototype.text = utf8Text;
                // Attempts to complete a partial non-UTF-8 character using bytes from a Buffer
                StringDecoder.prototype.fillLast = function(buf) {
                    if (this.lastNeed <= buf.length) {
                        buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed);
                        return this.lastChar.toString(this.encoding, 0, this.lastTotal);
                    }
                    buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, buf.length);
                    this.lastNeed -= buf.length;
                };
                // Checks the type of a UTF-8 byte, whether it's ASCII, a leading byte, or a
                // continuation byte. If an invalid byte is detected, -2 is returned.
                function utf8CheckByte(byte) {
                    if (byte <= 0x7F) return 0;
                    else if (byte >> 5 === 0x06) return 2;
                    else if (byte >> 4 === 0x0E) return 3;
                    else if (byte >> 3 === 0x1E) return 4;
                    return byte >> 6 === 0x02 ? -1 : -2;
                }
                // Checks at most 3 bytes at the end of a Buffer in order to detect an
                // incomplete multi-byte UTF-8 character. The total number of bytes (2, 3, or 4)
                // needed to complete the UTF-8 character (if applicable) are returned.
                function utf8CheckIncomplete(self1, buf, i) {
                    var j = buf.length - 1;
                    if (j < i) return 0;
                    var nb = utf8CheckByte(buf[j]);
                    if (nb >= 0) {
                        if (nb > 0) self1.lastNeed = nb - 1;
                        return nb;
                    }
                    if (--j < i || nb === -2) return 0;
                    nb = utf8CheckByte(buf[j]);
                    if (nb >= 0) {
                        if (nb > 0) self1.lastNeed = nb - 2;
                        return nb;
                    }
                    if (--j < i || nb === -2) return 0;
                    nb = utf8CheckByte(buf[j]);
                    if (nb >= 0) {
                        if (nb > 0) {
                            if (nb === 2) nb = 0;
                            else self1.lastNeed = nb - 3;
                        }
                        return nb;
                    }
                    return 0;
                }
                // Validates as many continuation bytes for a multi-byte UTF-8 character as
                // needed or are available. If we see a non-continuation byte where we expect
                // one, we "replace" the validated continuation bytes we've seen so far with
                // a single UTF-8 replacement character ('\ufffd'), to match v8's UTF-8 decoding
                // behavior. The continuation byte check is included three times in the case
                // where all of the continuation bytes for a character exist in the same buffer.
                // It is also done this way as a slight performance increase instead of using a
                // loop.
                function utf8CheckExtraBytes(self1, buf, p) {
                    if ((buf[0] & 0xC0) !== 0x80) {
                        self1.lastNeed = 0;
                        return "�";
                    }
                    if (self1.lastNeed > 1 && buf.length > 1) {
                        if ((buf[1] & 0xC0) !== 0x80) {
                            self1.lastNeed = 1;
                            return "�";
                        }
                        if (self1.lastNeed > 2 && buf.length > 2) {
                            if ((buf[2] & 0xC0) !== 0x80) {
                                self1.lastNeed = 2;
                                return "�";
                            }
                        }
                    }
                }
                // Attempts to complete a multi-byte UTF-8 character using bytes from a Buffer.
                function utf8FillLast(buf) {
                    var p = this.lastTotal - this.lastNeed;
                    var r = utf8CheckExtraBytes(this, buf, p);
                    if (r !== undefined) return r;
                    if (this.lastNeed <= buf.length) {
                        buf.copy(this.lastChar, p, 0, this.lastNeed);
                        return this.lastChar.toString(this.encoding, 0, this.lastTotal);
                    }
                    buf.copy(this.lastChar, p, 0, buf.length);
                    this.lastNeed -= buf.length;
                }
                // Returns all complete UTF-8 characters in a Buffer. If the Buffer ended on a
                // partial character, the character's bytes are buffered until the required
                // number of bytes are available.
                function utf8Text(buf, i) {
                    var total = utf8CheckIncomplete(this, buf, i);
                    if (!this.lastNeed) return buf.toString("utf8", i);
                    this.lastTotal = total;
                    var end = buf.length - (total - this.lastNeed);
                    buf.copy(this.lastChar, 0, end);
                    return buf.toString("utf8", i, end);
                }
                // For UTF-8, a replacement character is added when ending on a partial
                // character.
                function utf8End(buf) {
                    var r = buf && buf.length ? this.write(buf) : "";
                    if (this.lastNeed) return r + "�";
                    return r;
                }
                // UTF-16LE typically needs two bytes per character, but even if we have an even
                // number of bytes available, we need to check if we end on a leading/high
                // surrogate. In that case, we need to wait for the next two bytes in order to
                // decode the last character properly.
                function utf16Text(buf, i) {
                    if ((buf.length - i) % 2 === 0) {
                        var r = buf.toString("utf16le", i);
                        if (r) {
                            var c = r.charCodeAt(r.length - 1);
                            if (c >= 0xD800 && c <= 0xDBFF) {
                                this.lastNeed = 2;
                                this.lastTotal = 4;
                                this.lastChar[0] = buf[buf.length - 2];
                                this.lastChar[1] = buf[buf.length - 1];
                                return r.slice(0, -1);
                            }
                        }
                        return r;
                    }
                    this.lastNeed = 1;
                    this.lastTotal = 2;
                    this.lastChar[0] = buf[buf.length - 1];
                    return buf.toString("utf16le", i, buf.length - 1);
                }
                // For UTF-16LE we do not explicitly append special replacement characters if we
                // end on a partial character, we simply let v8 handle that.
                function utf16End(buf) {
                    var r = buf && buf.length ? this.write(buf) : "";
                    if (this.lastNeed) {
                        var end = this.lastTotal - this.lastNeed;
                        return r + this.lastChar.toString("utf16le", 0, end);
                    }
                    return r;
                }
                function base64Text(buf, i) {
                    var n = (buf.length - i) % 3;
                    if (n === 0) return buf.toString("base64", i);
                    this.lastNeed = 3 - n;
                    this.lastTotal = 3;
                    if (n === 1) this.lastChar[0] = buf[buf.length - 1];
                    else {
                        this.lastChar[0] = buf[buf.length - 2];
                        this.lastChar[1] = buf[buf.length - 1];
                    }
                    return buf.toString("base64", i, buf.length - n);
                }
                function base64End(buf) {
                    var r = buf && buf.length ? this.write(buf) : "";
                    if (this.lastNeed) return r + this.lastChar.toString("base64", 0, 3 - this.lastNeed);
                    return r;
                }
                // Pass bytes on through for single-byte encodings (e.g. ascii, latin1, hex)
                function simpleWrite(buf) {
                    return buf.toString(this.encoding);
                }
                function simpleEnd(buf) {
                    return buf && buf.length ? this.write(buf) : "";
                }
            },
            {
                "safe-buffer": 40
            }
        ],
        57: [
            function(require, module, exports) {
                (function(global) {
                    (function() {
                        /**
 * Module exports.
 */ module.exports = deprecate;
                        /**
 * Mark that a method should not be used.
 * Returns a modified function which warns once by default.
 *
 * If `localStorage.noDeprecation = true` is set, then it is a no-op.
 *
 * If `localStorage.throwDeprecation = true` is set, then deprecated functions
 * will throw an Error when invoked.
 *
 * If `localStorage.traceDeprecation = true` is set, then deprecated functions
 * will invoke `console.trace()` instead of `console.error()`.
 *
 * @param {Function} fn - the function to deprecate
 * @param {String} msg - the string to print to the console when `fn` is invoked
 * @returns {Function} a new "deprecated" version of `fn`
 * @api public
 */ function deprecate(fn, msg) {
                            if (config("noDeprecation")) return fn;
                            var warned = false;
                            function deprecated() {
                                if (!warned) {
                                    if (config("throwDeprecation")) throw new Error(msg);
                                    else if (config("traceDeprecation")) console.trace(msg);
                                    else console.warn(msg);
                                    warned = true;
                                }
                                return fn.apply(this, arguments);
                            }
                            return deprecated;
                        }
                        /**
 * Checks `localStorage` for boolean values for the given `name`.
 *
 * @param {String} name
 * @returns {Boolean}
 * @api private
 */ function config(name) {
                            // accessing global.localStorage can trigger a DOMException in sandboxed iframes
                            try {
                                if (!global.localStorage) return false;
                            } catch (_) {
                                return false;
                            }
                            var val = global.localStorage[name];
                            if (null == val) return false;
                            return String(val).toLowerCase() === "true";
                        }
                    }).call(this);
                }).call(this, typeof $parcel$global !== "undefined" ? $parcel$global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {});
            },
            {}
        ],
        58: [
            function(require, module, exports) {
                "use strict";
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                Object.defineProperty(exports, "v1", {
                    enumerable: true,
                    get: function() {
                        return _v.default;
                    }
                });
                Object.defineProperty(exports, "v3", {
                    enumerable: true,
                    get: function() {
                        return _v2.default;
                    }
                });
                Object.defineProperty(exports, "v4", {
                    enumerable: true,
                    get: function() {
                        return _v3.default;
                    }
                });
                Object.defineProperty(exports, "v5", {
                    enumerable: true,
                    get: function() {
                        return _v4.default;
                    }
                });
                Object.defineProperty(exports, "NIL", {
                    enumerable: true,
                    get: function() {
                        return _nil.default;
                    }
                });
                Object.defineProperty(exports, "version", {
                    enumerable: true,
                    get: function() {
                        return _version.default;
                    }
                });
                Object.defineProperty(exports, "validate", {
                    enumerable: true,
                    get: function() {
                        return _validate.default;
                    }
                });
                Object.defineProperty(exports, "stringify", {
                    enumerable: true,
                    get: function() {
                        return _stringify.default;
                    }
                });
                Object.defineProperty(exports, "parse", {
                    enumerable: true,
                    get: function() {
                        return _parse.default;
                    }
                });
                var _v = _interopRequireDefault(require("./v1.js"));
                var _v2 = _interopRequireDefault(require("./v3.js"));
                var _v3 = _interopRequireDefault(require("./v4.js"));
                var _v4 = _interopRequireDefault(require("./v5.js"));
                var _nil = _interopRequireDefault(require("./nil.js"));
                var _version = _interopRequireDefault(require("./version.js"));
                var _validate = _interopRequireDefault(require("./validate.js"));
                var _stringify = _interopRequireDefault(require("./stringify.js"));
                var _parse = _interopRequireDefault(require("./parse.js"));
                function _interopRequireDefault(obj) {
                    return obj && obj.__esModule ? obj : {
                        default: obj
                    };
                }
            },
            {
                "./nil.js": 60,
                "./parse.js": 61,
                "./stringify.js": 65,
                "./v1.js": 66,
                "./v3.js": 67,
                "./v4.js": 69,
                "./v5.js": 70,
                "./validate.js": 71,
                "./version.js": 72
            }
        ],
        59: [
            function(require, module, exports) {
                "use strict";
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.default = void 0;
                /*
 * Browser-compatible JavaScript MD5
 *
 * Modification of JavaScript MD5
 * https://github.com/blueimp/JavaScript-MD5
 *
 * Copyright 2011, Sebastian Tschan
 * https://blueimp.net
 *
 * Licensed under the MIT license:
 * https://opensource.org/licenses/MIT
 *
 * Based on
 * A JavaScript implementation of the RSA Data Security, Inc. MD5 Message
 * Digest Algorithm, as defined in RFC 1321.
 * Version 2.2 Copyright (C) Paul Johnston 1999 - 2009
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 * Distributed under the BSD License
 * See http://pajhome.org.uk/crypt/md5 for more info.
 */ function md5(bytes) {
                    if (typeof bytes === "string") {
                        const msg = unescape(encodeURIComponent(bytes)); // UTF8 escape
                        bytes = new Uint8Array(msg.length);
                        for(let i = 0; i < msg.length; ++i)bytes[i] = msg.charCodeAt(i);
                    }
                    return md5ToHexEncodedArray(wordsToMd5(bytesToWords(bytes), bytes.length * 8));
                }
                /*
 * Convert an array of little-endian words to an array of bytes
 */ function md5ToHexEncodedArray(input) {
                    const output = [];
                    const length32 = input.length * 32;
                    const hexTab = "0123456789abcdef";
                    for(let i = 0; i < length32; i += 8){
                        const x = input[i >> 5] >>> i % 32 & 0xff;
                        const hex = parseInt(hexTab.charAt(x >>> 4 & 0x0f) + hexTab.charAt(x & 0x0f), 16);
                        output.push(hex);
                    }
                    return output;
                }
                /**
 * Calculate output length with padding and bit length
 */ function getOutputLength(inputLength8) {
                    return (inputLength8 + 64 >>> 9 << 4) + 14 + 1;
                }
                /*
 * Calculate the MD5 of an array of little-endian words, and a bit length.
 */ function wordsToMd5(x, len) {
                    /* append padding */ x[len >> 5] |= 0x80 << len % 32;
                    x[getOutputLength(len) - 1] = len;
                    let a = 1732584193;
                    let b = -271733879;
                    let c = -1732584194;
                    let d = 271733878;
                    for(let i = 0; i < x.length; i += 16){
                        const olda = a;
                        const oldb = b;
                        const oldc = c;
                        const oldd = d;
                        a = md5ff(a, b, c, d, x[i], 7, -680876936);
                        d = md5ff(d, a, b, c, x[i + 1], 12, -389564586);
                        c = md5ff(c, d, a, b, x[i + 2], 17, 606105819);
                        b = md5ff(b, c, d, a, x[i + 3], 22, -1044525330);
                        a = md5ff(a, b, c, d, x[i + 4], 7, -176418897);
                        d = md5ff(d, a, b, c, x[i + 5], 12, 1200080426);
                        c = md5ff(c, d, a, b, x[i + 6], 17, -1473231341);
                        b = md5ff(b, c, d, a, x[i + 7], 22, -45705983);
                        a = md5ff(a, b, c, d, x[i + 8], 7, 1770035416);
                        d = md5ff(d, a, b, c, x[i + 9], 12, -1958414417);
                        c = md5ff(c, d, a, b, x[i + 10], 17, -42063);
                        b = md5ff(b, c, d, a, x[i + 11], 22, -1990404162);
                        a = md5ff(a, b, c, d, x[i + 12], 7, 1804603682);
                        d = md5ff(d, a, b, c, x[i + 13], 12, -40341101);
                        c = md5ff(c, d, a, b, x[i + 14], 17, -1502002290);
                        b = md5ff(b, c, d, a, x[i + 15], 22, 1236535329);
                        a = md5gg(a, b, c, d, x[i + 1], 5, -165796510);
                        d = md5gg(d, a, b, c, x[i + 6], 9, -1069501632);
                        c = md5gg(c, d, a, b, x[i + 11], 14, 643717713);
                        b = md5gg(b, c, d, a, x[i], 20, -373897302);
                        a = md5gg(a, b, c, d, x[i + 5], 5, -701558691);
                        d = md5gg(d, a, b, c, x[i + 10], 9, 38016083);
                        c = md5gg(c, d, a, b, x[i + 15], 14, -660478335);
                        b = md5gg(b, c, d, a, x[i + 4], 20, -405537848);
                        a = md5gg(a, b, c, d, x[i + 9], 5, 568446438);
                        d = md5gg(d, a, b, c, x[i + 14], 9, -1019803690);
                        c = md5gg(c, d, a, b, x[i + 3], 14, -187363961);
                        b = md5gg(b, c, d, a, x[i + 8], 20, 1163531501);
                        a = md5gg(a, b, c, d, x[i + 13], 5, -1444681467);
                        d = md5gg(d, a, b, c, x[i + 2], 9, -51403784);
                        c = md5gg(c, d, a, b, x[i + 7], 14, 1735328473);
                        b = md5gg(b, c, d, a, x[i + 12], 20, -1926607734);
                        a = md5hh(a, b, c, d, x[i + 5], 4, -378558);
                        d = md5hh(d, a, b, c, x[i + 8], 11, -2022574463);
                        c = md5hh(c, d, a, b, x[i + 11], 16, 1839030562);
                        b = md5hh(b, c, d, a, x[i + 14], 23, -35309556);
                        a = md5hh(a, b, c, d, x[i + 1], 4, -1530992060);
                        d = md5hh(d, a, b, c, x[i + 4], 11, 1272893353);
                        c = md5hh(c, d, a, b, x[i + 7], 16, -155497632);
                        b = md5hh(b, c, d, a, x[i + 10], 23, -1094730640);
                        a = md5hh(a, b, c, d, x[i + 13], 4, 681279174);
                        d = md5hh(d, a, b, c, x[i], 11, -358537222);
                        c = md5hh(c, d, a, b, x[i + 3], 16, -722521979);
                        b = md5hh(b, c, d, a, x[i + 6], 23, 76029189);
                        a = md5hh(a, b, c, d, x[i + 9], 4, -640364487);
                        d = md5hh(d, a, b, c, x[i + 12], 11, -421815835);
                        c = md5hh(c, d, a, b, x[i + 15], 16, 530742520);
                        b = md5hh(b, c, d, a, x[i + 2], 23, -995338651);
                        a = md5ii(a, b, c, d, x[i], 6, -198630844);
                        d = md5ii(d, a, b, c, x[i + 7], 10, 1126891415);
                        c = md5ii(c, d, a, b, x[i + 14], 15, -1416354905);
                        b = md5ii(b, c, d, a, x[i + 5], 21, -57434055);
                        a = md5ii(a, b, c, d, x[i + 12], 6, 1700485571);
                        d = md5ii(d, a, b, c, x[i + 3], 10, -1894986606);
                        c = md5ii(c, d, a, b, x[i + 10], 15, -1051523);
                        b = md5ii(b, c, d, a, x[i + 1], 21, -2054922799);
                        a = md5ii(a, b, c, d, x[i + 8], 6, 1873313359);
                        d = md5ii(d, a, b, c, x[i + 15], 10, -30611744);
                        c = md5ii(c, d, a, b, x[i + 6], 15, -1560198380);
                        b = md5ii(b, c, d, a, x[i + 13], 21, 1309151649);
                        a = md5ii(a, b, c, d, x[i + 4], 6, -145523070);
                        d = md5ii(d, a, b, c, x[i + 11], 10, -1120210379);
                        c = md5ii(c, d, a, b, x[i + 2], 15, 718787259);
                        b = md5ii(b, c, d, a, x[i + 9], 21, -343485551);
                        a = safeAdd(a, olda);
                        b = safeAdd(b, oldb);
                        c = safeAdd(c, oldc);
                        d = safeAdd(d, oldd);
                    }
                    return [
                        a,
                        b,
                        c,
                        d
                    ];
                }
                /*
 * Convert an array bytes to an array of little-endian words
 * Characters >255 have their high-byte silently ignored.
 */ function bytesToWords(input) {
                    if (input.length === 0) return [];
                    const length8 = input.length * 8;
                    const output = new Uint32Array(getOutputLength(length8));
                    for(let i = 0; i < length8; i += 8)output[i >> 5] |= (input[i / 8] & 0xff) << i % 32;
                    return output;
                }
                /*
 * Add integers, wrapping at 2^32. This uses 16-bit operations internally
 * to work around bugs in some JS interpreters.
 */ function safeAdd(x, y) {
                    const lsw = (x & 0xffff) + (y & 0xffff);
                    const msw = (x >> 16) + (y >> 16) + (lsw >> 16);
                    return msw << 16 | lsw & 0xffff;
                }
                /*
 * Bitwise rotate a 32-bit number to the left.
 */ function bitRotateLeft(num, cnt) {
                    return num << cnt | num >>> 32 - cnt;
                }
                /*
 * These functions implement the four basic operations the algorithm uses.
 */ function md5cmn(q, a, b, x, s, t) {
                    return safeAdd(bitRotateLeft(safeAdd(safeAdd(a, q), safeAdd(x, t)), s), b);
                }
                function md5ff(a, b, c, d, x, s, t) {
                    return md5cmn(b & c | ~b & d, a, b, x, s, t);
                }
                function md5gg(a, b, c, d, x, s, t) {
                    return md5cmn(b & d | c & ~d, a, b, x, s, t);
                }
                function md5hh(a, b, c, d, x, s, t) {
                    return md5cmn(b ^ c ^ d, a, b, x, s, t);
                }
                function md5ii(a, b, c, d, x, s, t) {
                    return md5cmn(c ^ (b | ~d), a, b, x, s, t);
                }
                var _default = md5;
                exports.default = _default;
            },
            {}
        ],
        60: [
            function(require, module, exports) {
                "use strict";
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.default = void 0;
                var _default = "00000000-0000-0000-0000-000000000000";
                exports.default = _default;
            },
            {}
        ],
        61: [
            function(require, module, exports) {
                "use strict";
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.default = void 0;
                var _validate = _interopRequireDefault(require("./validate.js"));
                function _interopRequireDefault(obj) {
                    return obj && obj.__esModule ? obj : {
                        default: obj
                    };
                }
                function parse(uuid) {
                    if (!(0, _validate.default)(uuid)) throw TypeError("Invalid UUID");
                    let v;
                    const arr = new Uint8Array(16); // Parse ########-....-....-....-............
                    arr[0] = (v = parseInt(uuid.slice(0, 8), 16)) >>> 24;
                    arr[1] = v >>> 16 & 0xff;
                    arr[2] = v >>> 8 & 0xff;
                    arr[3] = v & 0xff; // Parse ........-####-....-....-............
                    arr[4] = (v = parseInt(uuid.slice(9, 13), 16)) >>> 8;
                    arr[5] = v & 0xff; // Parse ........-....-####-....-............
                    arr[6] = (v = parseInt(uuid.slice(14, 18), 16)) >>> 8;
                    arr[7] = v & 0xff; // Parse ........-....-....-####-............
                    arr[8] = (v = parseInt(uuid.slice(19, 23), 16)) >>> 8;
                    arr[9] = v & 0xff; // Parse ........-....-....-....-############
                    // (Use "/" to avoid 32-bit truncation when bit-shifting high-order bytes)
                    arr[10] = (v = parseInt(uuid.slice(24, 36), 16)) / 0x10000000000 & 0xff;
                    arr[11] = v / 0x100000000 & 0xff;
                    arr[12] = v >>> 24 & 0xff;
                    arr[13] = v >>> 16 & 0xff;
                    arr[14] = v >>> 8 & 0xff;
                    arr[15] = v & 0xff;
                    return arr;
                }
                var _default = parse;
                exports.default = _default;
            },
            {
                "./validate.js": 71
            }
        ],
        62: [
            function(require, module, exports) {
                "use strict";
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.default = void 0;
                var _default = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;
                exports.default = _default;
            },
            {}
        ],
        63: [
            function(require, module, exports) {
                "use strict";
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.default = rng;
                // Unique ID creation requires a high quality random # generator. In the browser we therefore
                // require the crypto API and do not support built-in fallback to lower quality random number
                // generators (like Math.random()).
                let getRandomValues;
                const rnds8 = new Uint8Array(16);
                function rng() {
                    // lazy load so that environments that need to polyfill have a chance to do so
                    if (!getRandomValues) {
                        // getRandomValues needs to be invoked in a context where "this" is a Crypto implementation. Also,
                        // find the complete implementation of crypto (msCrypto) on IE11.
                        getRandomValues = typeof crypto !== "undefined" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto !== "undefined" && typeof msCrypto.getRandomValues === "function" && msCrypto.getRandomValues.bind(msCrypto);
                        if (!getRandomValues) throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
                    }
                    return getRandomValues(rnds8);
                }
            },
            {}
        ],
        64: [
            function(require, module, exports) {
                "use strict";
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.default = void 0;
                // Adapted from Chris Veness' SHA1 code at
                // http://www.movable-type.co.uk/scripts/sha1.html
                function f(s, x, y, z) {
                    switch(s){
                        case 0:
                            return x & y ^ ~x & z;
                        case 1:
                            return x ^ y ^ z;
                        case 2:
                            return x & y ^ x & z ^ y & z;
                        case 3:
                            return x ^ y ^ z;
                    }
                }
                function ROTL(x, n) {
                    return x << n | x >>> 32 - n;
                }
                function sha1(bytes) {
                    const K = [
                        0x5a827999,
                        0x6ed9eba1,
                        0x8f1bbcdc,
                        0xca62c1d6
                    ];
                    const H = [
                        0x67452301,
                        0xefcdab89,
                        0x98badcfe,
                        0x10325476,
                        0xc3d2e1f0
                    ];
                    if (typeof bytes === "string") {
                        const msg = unescape(encodeURIComponent(bytes)); // UTF8 escape
                        bytes = [];
                        for(let i = 0; i < msg.length; ++i)bytes.push(msg.charCodeAt(i));
                    } else if (!Array.isArray(bytes)) // Convert Array-like to Array
                    bytes = Array.prototype.slice.call(bytes);
                    bytes.push(0x80);
                    const l = bytes.length / 4 + 2;
                    const N = Math.ceil(l / 16);
                    const M = new Array(N);
                    for(let i = 0; i < N; ++i){
                        const arr = new Uint32Array(16);
                        for(let j = 0; j < 16; ++j)arr[j] = bytes[i * 64 + j * 4] << 24 | bytes[i * 64 + j * 4 + 1] << 16 | bytes[i * 64 + j * 4 + 2] << 8 | bytes[i * 64 + j * 4 + 3];
                        M[i] = arr;
                    }
                    M[N - 1][14] = (bytes.length - 1) * 8 / Math.pow(2, 32);
                    M[N - 1][14] = Math.floor(M[N - 1][14]);
                    M[N - 1][15] = (bytes.length - 1) * 8 & 0xffffffff;
                    for(let i = 0; i < N; ++i){
                        const W = new Uint32Array(80);
                        for(let t = 0; t < 16; ++t)W[t] = M[i][t];
                        for(let t = 16; t < 80; ++t)W[t] = ROTL(W[t - 3] ^ W[t - 8] ^ W[t - 14] ^ W[t - 16], 1);
                        let a = H[0];
                        let b = H[1];
                        let c = H[2];
                        let d = H[3];
                        let e = H[4];
                        for(let t = 0; t < 80; ++t){
                            const s = Math.floor(t / 20);
                            const T = ROTL(a, 5) + f(s, b, c, d) + e + K[s] + W[t] >>> 0;
                            e = d;
                            d = c;
                            c = ROTL(b, 30) >>> 0;
                            b = a;
                            a = T;
                        }
                        H[0] = H[0] + a >>> 0;
                        H[1] = H[1] + b >>> 0;
                        H[2] = H[2] + c >>> 0;
                        H[3] = H[3] + d >>> 0;
                        H[4] = H[4] + e >>> 0;
                    }
                    return [
                        H[0] >> 24 & 0xff,
                        H[0] >> 16 & 0xff,
                        H[0] >> 8 & 0xff,
                        H[0] & 0xff,
                        H[1] >> 24 & 0xff,
                        H[1] >> 16 & 0xff,
                        H[1] >> 8 & 0xff,
                        H[1] & 0xff,
                        H[2] >> 24 & 0xff,
                        H[2] >> 16 & 0xff,
                        H[2] >> 8 & 0xff,
                        H[2] & 0xff,
                        H[3] >> 24 & 0xff,
                        H[3] >> 16 & 0xff,
                        H[3] >> 8 & 0xff,
                        H[3] & 0xff,
                        H[4] >> 24 & 0xff,
                        H[4] >> 16 & 0xff,
                        H[4] >> 8 & 0xff,
                        H[4] & 0xff
                    ];
                }
                var _default = sha1;
                exports.default = _default;
            },
            {}
        ],
        65: [
            function(require, module, exports) {
                "use strict";
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.default = void 0;
                var _validate = _interopRequireDefault(require("./validate.js"));
                function _interopRequireDefault(obj) {
                    return obj && obj.__esModule ? obj : {
                        default: obj
                    };
                }
                /**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */ const byteToHex = [];
                for(let i = 0; i < 256; ++i)byteToHex.push((i + 0x100).toString(16).substr(1));
                function stringify(arr, offset = 0) {
                    // Note: Be careful editing this code!  It's been tuned for performance
                    // and works in ways you may not expect. See https://github.com/uuidjs/uuid/pull/434
                    const uuid = (byteToHex[arr[offset + 0]] + byteToHex[arr[offset + 1]] + byteToHex[arr[offset + 2]] + byteToHex[arr[offset + 3]] + "-" + byteToHex[arr[offset + 4]] + byteToHex[arr[offset + 5]] + "-" + byteToHex[arr[offset + 6]] + byteToHex[arr[offset + 7]] + "-" + byteToHex[arr[offset + 8]] + byteToHex[arr[offset + 9]] + "-" + byteToHex[arr[offset + 10]] + byteToHex[arr[offset + 11]] + byteToHex[arr[offset + 12]] + byteToHex[arr[offset + 13]] + byteToHex[arr[offset + 14]] + byteToHex[arr[offset + 15]]).toLowerCase(); // Consistency check for valid UUID.  If this throws, it's likely due to one
                    // of the following:
                    // - One or more input array values don't map to a hex octet (leading to
                    // "undefined" in the uuid)
                    // - Invalid input values for the RFC `version` or `variant` fields
                    if (!(0, _validate.default)(uuid)) throw TypeError("Stringified UUID is invalid");
                    return uuid;
                }
                var _default = stringify;
                exports.default = _default;
            },
            {
                "./validate.js": 71
            }
        ],
        66: [
            function(require, module, exports) {
                "use strict";
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.default = void 0;
                var _rng = _interopRequireDefault(require("./rng.js"));
                var _stringify = _interopRequireDefault(require("./stringify.js"));
                function _interopRequireDefault(obj) {
                    return obj && obj.__esModule ? obj : {
                        default: obj
                    };
                }
                // **`v1()` - Generate time-based UUID**
                //
                // Inspired by https://github.com/LiosK/UUID.js
                // and http://docs.python.org/library/uuid.html
                let _nodeId;
                let _clockseq; // Previous uuid creation time
                let _lastMSecs = 0;
                let _lastNSecs = 0; // See https://github.com/uuidjs/uuid for API details
                function v1(options, buf, offset) {
                    let i = buf && offset || 0;
                    const b = buf || new Array(16);
                    options = options || {};
                    let node = options.node || _nodeId;
                    let clockseq = options.clockseq !== undefined ? options.clockseq : _clockseq; // node and clockseq need to be initialized to random values if they're not
                    // specified.  We do this lazily to minimize issues related to insufficient
                    // system entropy.  See #189
                    if (node == null || clockseq == null) {
                        const seedBytes = options.random || (options.rng || _rng.default)();
                        if (node == null) // Per 4.5, create and 48-bit node id, (47 random bits + multicast bit = 1)
                        node = _nodeId = [
                            seedBytes[0] | 0x01,
                            seedBytes[1],
                            seedBytes[2],
                            seedBytes[3],
                            seedBytes[4],
                            seedBytes[5]
                        ];
                        if (clockseq == null) // Per 4.2.2, randomize (14 bit) clockseq
                        clockseq = _clockseq = (seedBytes[6] << 8 | seedBytes[7]) & 0x3fff;
                    } // UUID timestamps are 100 nano-second units since the Gregorian epoch,
                    // (1582-10-15 00:00).  JSNumbers aren't precise enough for this, so
                    // time is handled internally as 'msecs' (integer milliseconds) and 'nsecs'
                    // (100-nanoseconds offset from msecs) since unix epoch, 1970-01-01 00:00.
                    let msecs = options.msecs !== undefined ? options.msecs : Date.now(); // Per 4.2.1.2, use count of uuid's generated during the current clock
                    // cycle to simulate higher resolution clock
                    let nsecs = options.nsecs !== undefined ? options.nsecs : _lastNSecs + 1; // Time since last uuid creation (in msecs)
                    const dt = msecs - _lastMSecs + (nsecs - _lastNSecs) / 10000; // Per 4.2.1.2, Bump clockseq on clock regression
                    if (dt < 0 && options.clockseq === undefined) clockseq = clockseq + 1 & 0x3fff;
                     // Reset nsecs if clock regresses (new clockseq) or we've moved onto a new
                    // time interval
                    if ((dt < 0 || msecs > _lastMSecs) && options.nsecs === undefined) nsecs = 0;
                     // Per 4.2.1.2 Throw error if too many uuids are requested
                    if (nsecs >= 10000) throw new Error("uuid.v1(): Can't create more than 10M uuids/sec");
                    _lastMSecs = msecs;
                    _lastNSecs = nsecs;
                    _clockseq = clockseq; // Per 4.1.4 - Convert from unix epoch to Gregorian epoch
                    msecs += 12219292800000; // `time_low`
                    const tl = ((msecs & 0xfffffff) * 10000 + nsecs) % 0x100000000;
                    b[i++] = tl >>> 24 & 0xff;
                    b[i++] = tl >>> 16 & 0xff;
                    b[i++] = tl >>> 8 & 0xff;
                    b[i++] = tl & 0xff; // `time_mid`
                    const tmh = msecs / 0x100000000 * 10000 & 0xfffffff;
                    b[i++] = tmh >>> 8 & 0xff;
                    b[i++] = tmh & 0xff; // `time_high_and_version`
                    b[i++] = tmh >>> 24 & 0xf | 0x10; // include version
                    b[i++] = tmh >>> 16 & 0xff; // `clock_seq_hi_and_reserved` (Per 4.2.2 - include variant)
                    b[i++] = clockseq >>> 8 | 0x80; // `clock_seq_low`
                    b[i++] = clockseq & 0xff; // `node`
                    for(let n = 0; n < 6; ++n)b[i + n] = node[n];
                    return buf || (0, _stringify.default)(b);
                }
                var _default = v1;
                exports.default = _default;
            },
            {
                "./rng.js": 63,
                "./stringify.js": 65
            }
        ],
        67: [
            function(require, module, exports) {
                "use strict";
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.default = void 0;
                var _v = _interopRequireDefault(require("./v35.js"));
                var _md = _interopRequireDefault(require("./md5.js"));
                function _interopRequireDefault(obj) {
                    return obj && obj.__esModule ? obj : {
                        default: obj
                    };
                }
                const v3 = (0, _v.default)("v3", 0x30, _md.default);
                var _default = v3;
                exports.default = _default;
            },
            {
                "./md5.js": 59,
                "./v35.js": 68
            }
        ],
        68: [
            function(require, module, exports) {
                "use strict";
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.default = _default;
                exports.URL = exports.DNS = void 0;
                var _stringify = _interopRequireDefault(require("./stringify.js"));
                var _parse = _interopRequireDefault(require("./parse.js"));
                function _interopRequireDefault(obj) {
                    return obj && obj.__esModule ? obj : {
                        default: obj
                    };
                }
                function stringToBytes(str) {
                    str = unescape(encodeURIComponent(str)); // UTF8 escape
                    const bytes = [];
                    for(let i = 0; i < str.length; ++i)bytes.push(str.charCodeAt(i));
                    return bytes;
                }
                const DNS = "6ba7b810-9dad-11d1-80b4-00c04fd430c8";
                exports.DNS = DNS;
                const URL = "6ba7b811-9dad-11d1-80b4-00c04fd430c8";
                exports.URL = URL;
                function _default(name, version, hashfunc) {
                    function generateUUID(value, namespace, buf, offset) {
                        if (typeof value === "string") value = stringToBytes(value);
                        if (typeof namespace === "string") namespace = (0, _parse.default)(namespace);
                        if (namespace.length !== 16) throw TypeError("Namespace must be array-like (16 iterable integer values, 0-255)");
                         // Compute hash of namespace and value, Per 4.3
                        // Future: Use spread syntax when supported on all platforms, e.g. `bytes =
                        // hashfunc([...namespace, ... value])`
                        let bytes = new Uint8Array(16 + value.length);
                        bytes.set(namespace);
                        bytes.set(value, namespace.length);
                        bytes = hashfunc(bytes);
                        bytes[6] = bytes[6] & 0x0f | version;
                        bytes[8] = bytes[8] & 0x3f | 0x80;
                        if (buf) {
                            offset = offset || 0;
                            for(let i = 0; i < 16; ++i)buf[offset + i] = bytes[i];
                            return buf;
                        }
                        return (0, _stringify.default)(bytes);
                    } // Function#name is not settable on some platforms (#270)
                    try {
                        generateUUID.name = name; // eslint-disable-next-line no-empty
                    } catch (err) {} // For CommonJS default export support
                    generateUUID.DNS = DNS;
                    generateUUID.URL = URL;
                    return generateUUID;
                }
            },
            {
                "./parse.js": 61,
                "./stringify.js": 65
            }
        ],
        69: [
            function(require, module, exports) {
                "use strict";
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.default = void 0;
                var _rng = _interopRequireDefault(require("./rng.js"));
                var _stringify = _interopRequireDefault(require("./stringify.js"));
                function _interopRequireDefault(obj) {
                    return obj && obj.__esModule ? obj : {
                        default: obj
                    };
                }
                function v4(options, buf, offset) {
                    options = options || {};
                    const rnds = options.random || (options.rng || _rng.default)(); // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
                    rnds[6] = rnds[6] & 0x0f | 0x40;
                    rnds[8] = rnds[8] & 0x3f | 0x80; // Copy bytes to buffer, if provided
                    if (buf) {
                        offset = offset || 0;
                        for(let i = 0; i < 16; ++i)buf[offset + i] = rnds[i];
                        return buf;
                    }
                    return (0, _stringify.default)(rnds);
                }
                var _default = v4;
                exports.default = _default;
            },
            {
                "./rng.js": 63,
                "./stringify.js": 65
            }
        ],
        70: [
            function(require, module, exports) {
                "use strict";
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.default = void 0;
                var _v = _interopRequireDefault(require("./v35.js"));
                var _sha = _interopRequireDefault(require("./sha1.js"));
                function _interopRequireDefault(obj) {
                    return obj && obj.__esModule ? obj : {
                        default: obj
                    };
                }
                const v5 = (0, _v.default)("v5", 0x50, _sha.default);
                var _default = v5;
                exports.default = _default;
            },
            {
                "./sha1.js": 64,
                "./v35.js": 68
            }
        ],
        71: [
            function(require, module, exports) {
                "use strict";
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.default = void 0;
                var _regex = _interopRequireDefault(require("./regex.js"));
                function _interopRequireDefault(obj) {
                    return obj && obj.__esModule ? obj : {
                        default: obj
                    };
                }
                function validate(uuid) {
                    return typeof uuid === "string" && _regex.default.test(uuid);
                }
                var _default = validate;
                exports.default = _default;
            },
            {
                "./regex.js": 62
            }
        ],
        72: [
            function(require, module, exports) {
                "use strict";
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.default = void 0;
                var _validate = _interopRequireDefault(require("./validate.js"));
                function _interopRequireDefault(obj) {
                    return obj && obj.__esModule ? obj : {
                        default: obj
                    };
                }
                function version(uuid) {
                    if (!(0, _validate.default)(uuid)) throw TypeError("Invalid UUID");
                    return parseInt(uuid.substr(14, 1), 16);
                }
                var _default = version;
                exports.default = _default;
            },
            {
                "./validate.js": 71
            }
        ]
    }, {}, [
        9
    ])(9);
});

});

parcelRequire.register("hKphp", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;
function $ceba5796479b385e$var$createDeferred() {
    var deferred = {};
    deferred.promise = new Promise(function(resolve, reject) {
        deferred.reject = reject;
        deferred.resolve = resolve;
    });
    return deferred;
}
var $ceba5796479b385e$var$_default = $ceba5796479b385e$var$createDeferred;
module.exports["default"] = $ceba5796479b385e$var$_default;

});

parcelRequire.register("9WGwn", function(module, exports) {
var global = typeof self !== "undefined" ? self : this;
var __self__ = function() {
    function F() {
        this.fetch = false;
        this.DOMException = global.DOMException;
    }
    F.prototype = global;
    return new F();
}();
(function(self1) {
    var irrelevant = function(exports1) {
        var support = {
            searchParams: "URLSearchParams" in self1,
            iterable: "Symbol" in self1 && "iterator" in Symbol,
            blob: "FileReader" in self1 && "Blob" in self1 && function() {
                try {
                    new Blob();
                    return true;
                } catch (e) {
                    return false;
                }
            }(),
            formData: "FormData" in self1,
            arrayBuffer: "ArrayBuffer" in self1
        };
        function isDataView(obj) {
            return obj && DataView.prototype.isPrototypeOf(obj);
        }
        if (support.arrayBuffer) {
            var viewClasses = [
                "[object Int8Array]",
                "[object Uint8Array]",
                "[object Uint8ClampedArray]",
                "[object Int16Array]",
                "[object Uint16Array]",
                "[object Int32Array]",
                "[object Uint32Array]",
                "[object Float32Array]",
                "[object Float64Array]"
            ];
            var isArrayBufferView = ArrayBuffer.isView || function(obj) {
                return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1;
            };
        }
        function normalizeName(name) {
            if (typeof name !== "string") name = String(name);
            if (/[^a-z0-9\-#$%&'*+.^_`|~]/i.test(name)) throw new TypeError("Invalid character in header field name");
            return name.toLowerCase();
        }
        function normalizeValue(value) {
            if (typeof value !== "string") value = String(value);
            return value;
        }
        // Build a destructive iterator for the value list
        function iteratorFor(items) {
            var iterator = {
                next: function() {
                    var value = items.shift();
                    return {
                        done: value === undefined,
                        value: value
                    };
                }
            };
            if (support.iterable) iterator[Symbol.iterator] = function() {
                return iterator;
            };
            return iterator;
        }
        function Headers(headers) {
            this.map = {};
            if (headers instanceof Headers) headers.forEach(function(value, name) {
                this.append(name, value);
            }, this);
            else if (Array.isArray(headers)) headers.forEach(function(header) {
                this.append(header[0], header[1]);
            }, this);
            else if (headers) Object.getOwnPropertyNames(headers).forEach(function(name) {
                this.append(name, headers[name]);
            }, this);
        }
        Headers.prototype.append = function(name, value) {
            name = normalizeName(name);
            value = normalizeValue(value);
            var oldValue = this.map[name];
            this.map[name] = oldValue ? oldValue + ", " + value : value;
        };
        Headers.prototype["delete"] = function(name) {
            delete this.map[normalizeName(name)];
        };
        Headers.prototype.get = function(name) {
            name = normalizeName(name);
            return this.has(name) ? this.map[name] : null;
        };
        Headers.prototype.has = function(name) {
            return this.map.hasOwnProperty(normalizeName(name));
        };
        Headers.prototype.set = function(name, value) {
            this.map[normalizeName(name)] = normalizeValue(value);
        };
        Headers.prototype.forEach = function(callback, thisArg) {
            for(var name in this.map)if (this.map.hasOwnProperty(name)) callback.call(thisArg, this.map[name], name, this);
        };
        Headers.prototype.keys = function() {
            var items = [];
            this.forEach(function(value, name) {
                items.push(name);
            });
            return iteratorFor(items);
        };
        Headers.prototype.values = function() {
            var items = [];
            this.forEach(function(value) {
                items.push(value);
            });
            return iteratorFor(items);
        };
        Headers.prototype.entries = function() {
            var items = [];
            this.forEach(function(value, name) {
                items.push([
                    name,
                    value
                ]);
            });
            return iteratorFor(items);
        };
        if (support.iterable) Headers.prototype[Symbol.iterator] = Headers.prototype.entries;
        function consumed(body) {
            if (body.bodyUsed) return Promise.reject(new TypeError("Already read"));
            body.bodyUsed = true;
        }
        function fileReaderReady(reader) {
            return new Promise(function(resolve, reject) {
                reader.onload = function() {
                    resolve(reader.result);
                };
                reader.onerror = function() {
                    reject(reader.error);
                };
            });
        }
        function readBlobAsArrayBuffer(blob) {
            var reader = new FileReader();
            var promise = fileReaderReady(reader);
            reader.readAsArrayBuffer(blob);
            return promise;
        }
        function readBlobAsText(blob) {
            var reader = new FileReader();
            var promise = fileReaderReady(reader);
            reader.readAsText(blob);
            return promise;
        }
        function readArrayBufferAsText(buf) {
            var view = new Uint8Array(buf);
            var chars = new Array(view.length);
            for(var i = 0; i < view.length; i++)chars[i] = String.fromCharCode(view[i]);
            return chars.join("");
        }
        function bufferClone(buf) {
            if (buf.slice) return buf.slice(0);
            else {
                var view = new Uint8Array(buf.byteLength);
                view.set(new Uint8Array(buf));
                return view.buffer;
            }
        }
        function Body() {
            this.bodyUsed = false;
            this._initBody = function(body) {
                this._bodyInit = body;
                if (!body) this._bodyText = "";
                else if (typeof body === "string") this._bodyText = body;
                else if (support.blob && Blob.prototype.isPrototypeOf(body)) this._bodyBlob = body;
                else if (support.formData && FormData.prototype.isPrototypeOf(body)) this._bodyFormData = body;
                else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) this._bodyText = body.toString();
                else if (support.arrayBuffer && support.blob && isDataView(body)) {
                    this._bodyArrayBuffer = bufferClone(body.buffer);
                    // IE 10-11 can't handle a DataView body.
                    this._bodyInit = new Blob([
                        this._bodyArrayBuffer
                    ]);
                } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) this._bodyArrayBuffer = bufferClone(body);
                else this._bodyText = body = Object.prototype.toString.call(body);
                if (!this.headers.get("content-type")) {
                    if (typeof body === "string") this.headers.set("content-type", "text/plain;charset=UTF-8");
                    else if (this._bodyBlob && this._bodyBlob.type) this.headers.set("content-type", this._bodyBlob.type);
                    else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) this.headers.set("content-type", "application/x-www-form-urlencoded;charset=UTF-8");
                }
            };
            if (support.blob) {
                this.blob = function() {
                    var rejected = consumed(this);
                    if (rejected) return rejected;
                    if (this._bodyBlob) return Promise.resolve(this._bodyBlob);
                    else if (this._bodyArrayBuffer) return Promise.resolve(new Blob([
                        this._bodyArrayBuffer
                    ]));
                    else if (this._bodyFormData) throw new Error("could not read FormData body as blob");
                    else return Promise.resolve(new Blob([
                        this._bodyText
                    ]));
                };
                this.arrayBuffer = function() {
                    if (this._bodyArrayBuffer) return consumed(this) || Promise.resolve(this._bodyArrayBuffer);
                    else return this.blob().then(readBlobAsArrayBuffer);
                };
            }
            this.text = function() {
                var rejected = consumed(this);
                if (rejected) return rejected;
                if (this._bodyBlob) return readBlobAsText(this._bodyBlob);
                else if (this._bodyArrayBuffer) return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer));
                else if (this._bodyFormData) throw new Error("could not read FormData body as text");
                else return Promise.resolve(this._bodyText);
            };
            if (support.formData) this.formData = function() {
                return this.text().then(decode);
            };
            this.json = function() {
                return this.text().then(JSON.parse);
            };
            return this;
        }
        // HTTP methods whose capitalization should be normalized
        var methods = [
            "DELETE",
            "GET",
            "HEAD",
            "OPTIONS",
            "POST",
            "PUT"
        ];
        function normalizeMethod(method) {
            var upcased = method.toUpperCase();
            return methods.indexOf(upcased) > -1 ? upcased : method;
        }
        function Request(input, options) {
            options = options || {};
            var body = options.body;
            if (input instanceof Request) {
                if (input.bodyUsed) throw new TypeError("Already read");
                this.url = input.url;
                this.credentials = input.credentials;
                if (!options.headers) this.headers = new Headers(input.headers);
                this.method = input.method;
                this.mode = input.mode;
                this.signal = input.signal;
                if (!body && input._bodyInit != null) {
                    body = input._bodyInit;
                    input.bodyUsed = true;
                }
            } else this.url = String(input);
            this.credentials = options.credentials || this.credentials || "same-origin";
            if (options.headers || !this.headers) this.headers = new Headers(options.headers);
            this.method = normalizeMethod(options.method || this.method || "GET");
            this.mode = options.mode || this.mode || null;
            this.signal = options.signal || this.signal;
            this.referrer = null;
            if ((this.method === "GET" || this.method === "HEAD") && body) throw new TypeError("Body not allowed for GET or HEAD requests");
            this._initBody(body);
        }
        Request.prototype.clone = function() {
            return new Request(this, {
                body: this._bodyInit
            });
        };
        function decode(body) {
            var form = new FormData();
            body.trim().split("&").forEach(function(bytes) {
                if (bytes) {
                    var split = bytes.split("=");
                    var name = split.shift().replace(/\+/g, " ");
                    var value = split.join("=").replace(/\+/g, " ");
                    form.append(decodeURIComponent(name), decodeURIComponent(value));
                }
            });
            return form;
        }
        function parseHeaders(rawHeaders) {
            var headers = new Headers();
            // Replace instances of \r\n and \n followed by at least one space or horizontal tab with a space
            // https://tools.ietf.org/html/rfc7230#section-3.2
            var preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, " ");
            preProcessedHeaders.split(/\r?\n/).forEach(function(line) {
                var parts = line.split(":");
                var key = parts.shift().trim();
                if (key) {
                    var value = parts.join(":").trim();
                    headers.append(key, value);
                }
            });
            return headers;
        }
        Body.call(Request.prototype);
        function Response(bodyInit, options) {
            if (!options) options = {};
            this.type = "default";
            this.status = options.status === undefined ? 200 : options.status;
            this.ok = this.status >= 200 && this.status < 300;
            this.statusText = "statusText" in options ? options.statusText : "OK";
            this.headers = new Headers(options.headers);
            this.url = options.url || "";
            this._initBody(bodyInit);
        }
        Body.call(Response.prototype);
        Response.prototype.clone = function() {
            return new Response(this._bodyInit, {
                status: this.status,
                statusText: this.statusText,
                headers: new Headers(this.headers),
                url: this.url
            });
        };
        Response.error = function() {
            var response = new Response(null, {
                status: 0,
                statusText: ""
            });
            response.type = "error";
            return response;
        };
        var redirectStatuses = [
            301,
            302,
            303,
            307,
            308
        ];
        Response.redirect = function(url, status) {
            if (redirectStatuses.indexOf(status) === -1) throw new RangeError("Invalid status code");
            return new Response(null, {
                status: status,
                headers: {
                    location: url
                }
            });
        };
        exports1.DOMException = self1.DOMException;
        try {
            new exports1.DOMException();
        } catch (err) {
            exports1.DOMException = function(message, name) {
                this.message = message;
                this.name = name;
                var error = Error(message);
                this.stack = error.stack;
            };
            exports1.DOMException.prototype = Object.create(Error.prototype);
            exports1.DOMException.prototype.constructor = exports1.DOMException;
        }
        function fetch(input, init) {
            return new Promise(function(resolve, reject) {
                var request = new Request(input, init);
                if (request.signal && request.signal.aborted) return reject(new exports1.DOMException("Aborted", "AbortError"));
                var xhr = new XMLHttpRequest();
                function abortXhr() {
                    xhr.abort();
                }
                xhr.onload = function() {
                    var options = {
                        status: xhr.status,
                        statusText: xhr.statusText,
                        headers: parseHeaders(xhr.getAllResponseHeaders() || "")
                    };
                    options.url = "responseURL" in xhr ? xhr.responseURL : options.headers.get("X-Request-URL");
                    var body = "response" in xhr ? xhr.response : xhr.responseText;
                    resolve(new Response(body, options));
                };
                xhr.onerror = function() {
                    reject(new TypeError("Network request failed"));
                };
                xhr.ontimeout = function() {
                    reject(new TypeError("Network request failed"));
                };
                xhr.onabort = function() {
                    reject(new exports1.DOMException("Aborted", "AbortError"));
                };
                xhr.open(request.method, request.url, true);
                if (request.credentials === "include") xhr.withCredentials = true;
                else if (request.credentials === "omit") xhr.withCredentials = false;
                if ("responseType" in xhr && support.blob) xhr.responseType = "blob";
                request.headers.forEach(function(value, name) {
                    xhr.setRequestHeader(name, value);
                });
                if (request.signal) {
                    request.signal.addEventListener("abort", abortXhr);
                    xhr.onreadystatechange = function() {
                        // DONE (success or failure)
                        if (xhr.readyState === 4) request.signal.removeEventListener("abort", abortXhr);
                    };
                }
                xhr.send(typeof request._bodyInit === "undefined" ? null : request._bodyInit);
            });
        }
        fetch.polyfill = true;
        if (!self1.fetch) {
            self1.fetch = fetch;
            self1.Headers = Headers;
            self1.Request = Request;
            self1.Response = Response;
        }
        exports1.Headers = Headers;
        exports1.Request = Request;
        exports1.Response = Response;
        exports1.fetch = fetch;
        Object.defineProperty(exports1, "__esModule", {
            value: true
        });
        return exports1;
    }({});
})(__self__);
__self__.fetch.ponyfill = true;
// Remove "polyfill" property added by whatwg-fetch
delete __self__.fetch.polyfill;
// Choose between native implementation (global) or custom implementation (__self__)
// var ctx = global.fetch ? global : __self__;
var ctx = __self__; // this line disable service worker support temporarily
exports = ctx.fetch // To enable: import fetch from 'cross-fetch'
;
exports.default = ctx.fetch // For TypeScript consumers without esModuleInterop.
;
exports.fetch = ctx.fetch // To enable: import {fetch} from 'cross-fetch'
;
exports.Headers = ctx.Headers;
exports.Request = ctx.Request;
exports.Response = ctx.Response;
module.exports = exports;

});




parcelRequire.register("eZI1G", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $aea8e9d9ebe16dc9$var$createDirectLineAppServiceExtension;

var $kT3Qz = parcelRequire("kT3Qz");
function $aea8e9d9ebe16dc9$var$createDirectLineAppServiceExtension(_ref) {
    var botAgent = _ref.botAgent, conversationId = _ref.conversationId, domain = _ref.domain, token = _ref.token;
    return Promise.resolve(new $kT3Qz.DirectLineStreaming({
        botAgent: botAgent,
        conversationId: conversationId,
        domain: domain,
        token: token
    }));
}

});

parcelRequire.register("f0Leo", function(module, exports) {
"use strict";

var $luOtD = parcelRequire("luOtD");

Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $aedb7e34dfaa2207$var$_typeof2 = $luOtD((parcelRequire("2PxO1")));

var $aedb7e34dfaa2207$var$_defineProperty2 = $luOtD((parcelRequire("3w8Sv")));

var $aedb7e34dfaa2207$var$_propTypes = $luOtD((parcelRequire("f7UXb")));

var $aedb7e34dfaa2207$var$_react = $aedb7e34dfaa2207$var$_interopRequireWildcard((parcelRequire("eO7Kz")));

var $aedb7e34dfaa2207$var$_AdaptiveCardRenderer = $luOtD((parcelRequire("7qmwG")));

var $aedb7e34dfaa2207$var$_useParseAdaptiveCardJSON = $luOtD((parcelRequire("bwbgg")));
function $aedb7e34dfaa2207$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($aedb7e34dfaa2207$var$_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $aedb7e34dfaa2207$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || (parcelRequire("2PxO1"))(obj) !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $aedb7e34dfaa2207$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $aedb7e34dfaa2207$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $aedb7e34dfaa2207$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $aedb7e34dfaa2207$var$ownKeys(Object(source), !0).forEach(function(key) {
            (0, $aedb7e34dfaa2207$var$_defineProperty2.default)(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $aedb7e34dfaa2207$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $aedb7e34dfaa2207$var$stripSubmitAction(card) {
    if (!card.actions) return card;
     // Filter out HTTP action buttons
    var nextActions = card.actions.filter(function(action) {
        return action.type !== "Action.Submit";
    }).map(function(action) {
        return action.type === "Action.ShowCard" ? $aedb7e34dfaa2207$var$_objectSpread($aedb7e34dfaa2207$var$_objectSpread({}, action), {}, {
            card: $aedb7e34dfaa2207$var$stripSubmitAction(action.card)
        }) : action;
    });
    return $aedb7e34dfaa2207$var$_objectSpread($aedb7e34dfaa2207$var$_objectSpread({}, card), {}, {
        nextActions: nextActions
    });
}
var $aedb7e34dfaa2207$var$AdaptiveCardContent = function AdaptiveCardContent(_ref) {
    var actionPerformedClassName = _ref.actionPerformedClassName, content = _ref.content, disabled = _ref.disabled;
    var parseAdaptiveCardJSON = (0, $aedb7e34dfaa2207$var$_useParseAdaptiveCardJSON.default)();
    var card = (0, $aedb7e34dfaa2207$var$_react.useMemo)(function() {
        return parseAdaptiveCardJSON($aedb7e34dfaa2207$var$stripSubmitAction($aedb7e34dfaa2207$var$_objectSpread({
            version: "1.0"
        }, (0, $aedb7e34dfaa2207$var$_typeof2.default)(content) === "object" ? content : {})), {
            ignoreErrors: true
        });
    }, [
        content,
        parseAdaptiveCardJSON
    ]);
    return !!card && /*#__PURE__*/ $aedb7e34dfaa2207$var$_react.default.createElement($aedb7e34dfaa2207$var$_AdaptiveCardRenderer.default, {
        actionPerformedClassName: actionPerformedClassName,
        adaptiveCard: card,
        disabled: disabled
    });
};
$aedb7e34dfaa2207$var$AdaptiveCardContent.defaultProps = {
    actionPerformedClassName: "",
    disabled: undefined
};
$aedb7e34dfaa2207$var$AdaptiveCardContent.propTypes = {
    actionPerformedClassName: $aedb7e34dfaa2207$var$_propTypes.default.string,
    content: $aedb7e34dfaa2207$var$_propTypes.default.any.isRequired,
    disabled: $aedb7e34dfaa2207$var$_propTypes.default.bool
};
var $aedb7e34dfaa2207$var$_default = $aedb7e34dfaa2207$var$AdaptiveCardContent;
module.exports.default = $aedb7e34dfaa2207$var$_default;

});
parcelRequire.register("7qmwG", function(module, exports) {
"use strict";

var $luOtD = parcelRequire("luOtD");

var $2PxO1 = parcelRequire("2PxO1");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $567c6f5b6dc76f7f$var$_slicedToArray2 = $luOtD((parcelRequire("fhBCP")));

var $fD7D4 = parcelRequire("fD7D4");

var $567c6f5b6dc76f7f$var$_classnames = $luOtD((parcelRequire("5A4MD")));

var $567c6f5b6dc76f7f$var$_propTypes = $luOtD((parcelRequire("f7UXb")));

var $567c6f5b6dc76f7f$var$_react = $567c6f5b6dc76f7f$var$_interopRequireWildcard((parcelRequire("eO7Kz")));

var $567c6f5b6dc76f7f$var$_renderAdaptiveCard = $luOtD((parcelRequire("fWUqx")));

var $567c6f5b6dc76f7f$var$_useActionSetShouldNotBeMenuBarModEffect = $luOtD((parcelRequire("dUUUB")));

var $567c6f5b6dc76f7f$var$_useActionShouldBePushButtonModEffect = $luOtD((parcelRequire("gpNMB")));

var $567c6f5b6dc76f7f$var$_useActiveElementModEffect = $luOtD((parcelRequire("6LCaP")));

var $567c6f5b6dc76f7f$var$_useAdaptiveCardsHostConfig = $luOtD((parcelRequire("8JJxt")));

var $567c6f5b6dc76f7f$var$_useAdaptiveCardsPackage = $luOtD((parcelRequire("fdwbc")));

var $567c6f5b6dc76f7f$var$_useDisabledModEffect3 = $luOtD((parcelRequire("RZJe6")));

var $567c6f5b6dc76f7f$var$_usePersistValuesModEffect = $luOtD((parcelRequire("gAqf1")));

var $567c6f5b6dc76f7f$var$_useRoleModEffect3 = $luOtD((parcelRequire("fTrR3")));

var $567c6f5b6dc76f7f$var$_useValueRef = $luOtD((parcelRequire("3guG7")));
function $567c6f5b6dc76f7f$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($567c6f5b6dc76f7f$var$_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $567c6f5b6dc76f7f$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || $2PxO1(obj) !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $567c6f5b6dc76f7f$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
/* eslint no-magic-numbers: ["error", { "ignore": [-1, 0, 2] }] */ var $567c6f5b6dc76f7f$var$ErrorBox = $fD7D4.Components.ErrorBox;
var $567c6f5b6dc76f7f$var$useDisabled = $fD7D4.hooks.useDisabled, $567c6f5b6dc76f7f$var$useLocalizer = $fD7D4.hooks.useLocalizer, $567c6f5b6dc76f7f$var$usePerformCardAction = $fD7D4.hooks.usePerformCardAction, $567c6f5b6dc76f7f$var$useRenderMarkdownAsHTML = $fD7D4.hooks.useRenderMarkdownAsHTML, $567c6f5b6dc76f7f$var$useScrollToEnd = $fD7D4.hooks.useScrollToEnd, $567c6f5b6dc76f7f$var$useStyleSet = $fD7D4.hooks.useStyleSet;
var $567c6f5b6dc76f7f$var$node_env = "production";
var $567c6f5b6dc76f7f$var$AdaptiveCardRenderer = function AdaptiveCardRenderer(_ref) {
    var actionPerformedClassName = _ref.actionPerformedClassName, adaptiveCard = _ref.adaptiveCard, disabledFromProps = _ref.disabled, tapAction = _ref.tapAction;
    var _useStyleSet = $567c6f5b6dc76f7f$var$useStyleSet(), _useStyleSet2 = (0, $567c6f5b6dc76f7f$var$_slicedToArray2.default)(_useStyleSet, 1), adaptiveCardRendererStyleSet = _useStyleSet2[0].adaptiveCardRenderer;
    var _useAdaptiveCardsPack = (0, $567c6f5b6dc76f7f$var$_useAdaptiveCardsPackage.default)(), _useAdaptiveCardsPack2 = (0, $567c6f5b6dc76f7f$var$_slicedToArray2.default)(_useAdaptiveCardsPack, 1), _useAdaptiveCardsPack3 = _useAdaptiveCardsPack2[0], GlobalSettings = _useAdaptiveCardsPack3.GlobalSettings, HostConfig = _useAdaptiveCardsPack3.HostConfig;
    var _useAdaptiveCardsHost = (0, $567c6f5b6dc76f7f$var$_useAdaptiveCardsHostConfig.default)(), _useAdaptiveCardsHost2 = (0, $567c6f5b6dc76f7f$var$_slicedToArray2.default)(_useAdaptiveCardsHost, 1), adaptiveCardsHostConfig = _useAdaptiveCardsHost2[0];
    var _useDisabled = $567c6f5b6dc76f7f$var$useDisabled(), _useDisabled2 = (0, $567c6f5b6dc76f7f$var$_slicedToArray2.default)(_useDisabled, 1), disabledFromComposer = _useDisabled2[0];
    var contentRef = (0, $567c6f5b6dc76f7f$var$_react.useRef)();
    var localize = $567c6f5b6dc76f7f$var$useLocalizer();
    var performCardAction = $567c6f5b6dc76f7f$var$usePerformCardAction();
    var renderMarkdownAsHTML = $567c6f5b6dc76f7f$var$useRenderMarkdownAsHTML();
    var scrollToEnd = $567c6f5b6dc76f7f$var$useScrollToEnd();
    var disabled = disabledFromComposer || disabledFromProps;
    var tapActionRef = (0, $567c6f5b6dc76f7f$var$_useValueRef.default)(tapAction);
    var disabledRef = (0, $567c6f5b6dc76f7f$var$_useValueRef.default)(disabled); // TODO: [P2] #3199 We should consider using `adaptiveCard.selectAction` instead.
    // The null check for "tapAction" is in "handleClickAndKeyPressForTapAction".
    var handleClickAndKeyPress = (0, $567c6f5b6dc76f7f$var$_react.useCallback)(function(event) {
        var _ref2 = event, key = _ref2.key, type = _ref2.type;
        var target = event.target; // Some items, e.g. tappable text, cannot be disabled thru DOM attributes
        var current = contentRef.current;
        var adaptiveCardRoot = current.querySelector('.ac-adaptiveCard[tabindex="0"]');
        if (!adaptiveCardRoot) return console.warn("botframework-webchat: No Adaptive Card root container can be found; the card is probably on an unsupported Adaptive Card version.");
         // For "keypress" event, we only listen to ENTER and SPACEBAR key.
        if (type === "keypress") {
            if (key !== "Enter" && key !== " ") return;
            event.preventDefault();
        } // We will call performCardAction if either:
        // 1. We are on the target, or
        // 2. The event-dispatching element is not interactive
        if (target !== adaptiveCardRoot) {
            var tabIndex = (0, $fD7D4.getTabIndex)(target); // If the user is clicking on something that is already clickable, do not allow them to click the card.
            // E.g. a hero card can be tappable, and image and buttons inside the hero card can also be tappable.
            if (typeof tabIndex === "number" && tabIndex >= 0) return;
        }
        performCardAction(tapActionRef.current);
        scrollToEnd();
    }, [
        contentRef,
        performCardAction,
        scrollToEnd,
        tapActionRef
    ]); // Only listen to event if it is not disabled and have "tapAction" prop.
    var handleClickAndKeyPressForTapAction = !disabled && tapAction ? handleClickAndKeyPress : undefined;
    var handleExecuteAction = (0, $567c6f5b6dc76f7f$var$_react.useCallback)(function(action) {
        // Some items, e.g. tappable image, cannot be disabled thru DOM attributes
        if (disabledRef.current) return;
        var actionTypeName = action.getJsonTypeName();
        var image = action.iconUrl, title = action.title; // We cannot use "instanceof" check here, because web devs may bring their own version of Adaptive Cards package.
        // We need to check using "getJsonTypeName()" instead.
        if (actionTypeName === "Action.OpenUrl") {
            var _ref3 = action, value = _ref3.url;
            performCardAction({
                image: image,
                title: title,
                type: "openUrl",
                value: value
            });
        } else if (actionTypeName === "Action.Submit") {
            var _ref4 = action, data = _ref4.data;
            if (typeof data !== "undefined") {
                if (typeof data === "string") performCardAction({
                    image: image,
                    title: title,
                    type: "imBack",
                    value: data
                });
                else if (data.__isBotFrameworkCardAction) performCardAction(data.cardAction);
                else performCardAction({
                    image: image,
                    title: title,
                    type: "postBack",
                    value: data
                });
            }
            scrollToEnd();
        } else {
            console.error("Web Chat: received unknown action from Adaptive Cards");
            console.error(action);
        }
    }, [
        disabledRef,
        performCardAction,
        scrollToEnd
    ]); // For accessibility issue #1340, `tabindex="0"` must not be set for the root container if it is not interactive.
    var setTabIndexAtCardRoot = !!tapAction;
    var _useActionShouldBePus = (0, $567c6f5b6dc76f7f$var$_useActionShouldBePushButtonModEffect.default)(adaptiveCard), _useActionShouldBePus2 = (0, $567c6f5b6dc76f7f$var$_slicedToArray2.default)(_useActionShouldBePus, 2), applyActionShouldBePushButtonMod = _useActionShouldBePus2[0], undoActionShouldBePushButtonMod = _useActionShouldBePus2[1];
    var _useActionSetShouldNo = (0, $567c6f5b6dc76f7f$var$_useActionSetShouldNotBeMenuBarModEffect.default)(adaptiveCard), _useActionSetShouldNo2 = (0, $567c6f5b6dc76f7f$var$_slicedToArray2.default)(_useActionSetShouldNo, 2), applyActionSetShouldNotBeMenuBarMod = _useActionSetShouldNo2[0], undoActionSetShouldNotBeMenuBarMod = _useActionSetShouldNo2[1];
    var _useActiveElementModE = (0, $567c6f5b6dc76f7f$var$_useActiveElementModEffect.default)(adaptiveCard), _useActiveElementModE2 = (0, $567c6f5b6dc76f7f$var$_slicedToArray2.default)(_useActiveElementModE, 2), applyActiveElementMod = _useActiveElementModE2[0], undoActiveElementMod = _useActiveElementModE2[1];
    var _useDisabledModEffect = (0, $567c6f5b6dc76f7f$var$_useDisabledModEffect3.default)(adaptiveCard), _useDisabledModEffect2 = (0, $567c6f5b6dc76f7f$var$_slicedToArray2.default)(_useDisabledModEffect, 2), applyDisabledMod = _useDisabledModEffect2[0], undoDisabledMod = _useDisabledModEffect2[1];
    var _usePersistValuesModE = (0, $567c6f5b6dc76f7f$var$_usePersistValuesModEffect.default)(adaptiveCard), _usePersistValuesModE2 = (0, $567c6f5b6dc76f7f$var$_slicedToArray2.default)(_usePersistValuesModE, 2), applyPersistValuesMod = _usePersistValuesModE2[0], undoPersistValuesMod = _usePersistValuesModE2[1];
    var _useRoleModEffect = (0, $567c6f5b6dc76f7f$var$_useRoleModEffect3.default)(adaptiveCard), _useRoleModEffect2 = (0, $567c6f5b6dc76f7f$var$_slicedToArray2.default)(_useRoleModEffect, 2), applyRoleMod = _useRoleModEffect2[0], undoRoleMod = _useRoleModEffect2[1];
    var _useMemo = (0, $567c6f5b6dc76f7f$var$_react.useMemo)(function() {
        undoActionShouldBePushButtonMod();
        undoActionSetShouldNotBeMenuBarMod();
        undoActiveElementMod();
        undoDisabledMod();
        undoPersistValuesMod();
        undoRoleMod();
        return (0, $567c6f5b6dc76f7f$var$_renderAdaptiveCard.default)(adaptiveCard, {
            adaptiveCardsHostConfig: adaptiveCardsHostConfig,
            adaptiveCardsPackage: {
                GlobalSettings: GlobalSettings,
                HostConfig: HostConfig
            },
            renderMarkdownAsHTML: renderMarkdownAsHTML,
            setTabIndexAtCardRoot: setTabIndexAtCardRoot
        });
    }, [
        adaptiveCard,
        adaptiveCardsHostConfig,
        GlobalSettings,
        HostConfig,
        renderMarkdownAsHTML,
        setTabIndexAtCardRoot,
        undoActionShouldBePushButtonMod,
        undoActionSetShouldNotBeMenuBarMod,
        undoActiveElementMod,
        undoDisabledMod,
        undoPersistValuesMod,
        undoRoleMod
    ]), element = _useMemo.element, errors = _useMemo.errors;
    (0, $567c6f5b6dc76f7f$var$_react.useMemo)(function() {
        adaptiveCard.onExecuteAction = handleExecuteAction;
    }, [
        adaptiveCard,
        handleExecuteAction
    ]);
    (0, $567c6f5b6dc76f7f$var$_react.useLayoutEffect)(function() {
        var current = contentRef.current;
        current === null || current === void 0 || current.appendChild(element);
        return function() {
            current === null || current === void 0 || current.removeChild(element);
        };
    }, [
        contentRef,
        element
    ]); // Apply all mods regardless whether the element changed or not.
    // This is because we have undoed mods when we call the `useXXXModEffect` hook.
    (0, $567c6f5b6dc76f7f$var$_react.useLayoutEffect)(function() {
        applyActionShouldBePushButtonMod(element, actionPerformedClassName);
        applyActionSetShouldNotBeMenuBarMod(element);
        applyActiveElementMod(element);
        applyDisabledMod(element, disabled);
        applyPersistValuesMod(element);
        applyRoleMod(element);
    }, [
        actionPerformedClassName,
        applyActionShouldBePushButtonMod,
        applyActionSetShouldNotBeMenuBarMod,
        applyActiveElementMod,
        applyDisabledMod,
        applyPersistValuesMod,
        applyRoleMod,
        disabled,
        element
    ]);
    return errors !== null && errors !== void 0 && errors.length ? $567c6f5b6dc76f7f$var$node_env === "development" && /*#__PURE__*/ $567c6f5b6dc76f7f$var$_react.default.createElement($567c6f5b6dc76f7f$var$ErrorBox, {
        error: errors[0],
        type: localize("ADAPTIVE_CARD_ERROR_BOX_TITLE_RENDER")
    }) : /*#__PURE__*/ $567c6f5b6dc76f7f$var$_react.default.createElement("div", {
        className: (0, $567c6f5b6dc76f7f$var$_classnames.default)(adaptiveCardRendererStyleSet + "", "webchat__adaptive-card-renderer"),
        onClick: handleClickAndKeyPressForTapAction,
        onKeyPress: handleClickAndKeyPressForTapAction,
        ref: contentRef
    });
};
$567c6f5b6dc76f7f$var$AdaptiveCardRenderer.defaultProps = {
    actionPerformedClassName: "",
    disabled: undefined,
    tapAction: undefined
};
$567c6f5b6dc76f7f$var$AdaptiveCardRenderer.propTypes = {
    actionPerformedClassName: $567c6f5b6dc76f7f$var$_propTypes.default.string,
    adaptiveCard: $567c6f5b6dc76f7f$var$_propTypes.default.any.isRequired,
    disabled: $567c6f5b6dc76f7f$var$_propTypes.default.bool,
    // TypeScript class is not mappable to PropTypes.func
    // @ts-ignore
    tapAction: $567c6f5b6dc76f7f$var$_propTypes.default.shape({
        image: $567c6f5b6dc76f7f$var$_propTypes.default.string,
        title: $567c6f5b6dc76f7f$var$_propTypes.default.string,
        type: $567c6f5b6dc76f7f$var$_propTypes.default.string.isRequired,
        value: $567c6f5b6dc76f7f$var$_propTypes.default.string
    })
};
var $567c6f5b6dc76f7f$var$_default = $567c6f5b6dc76f7f$var$AdaptiveCardRenderer;
module.exports.default = $567c6f5b6dc76f7f$var$_default;

});
parcelRequire.register("fhBCP", function(module, exports) {

var $h9WXo = parcelRequire("h9WXo");

var $3WLzp = parcelRequire("3WLzp");

var $ieyTF = parcelRequire("ieyTF");

var $cNv2e = parcelRequire("cNv2e");
function $b205a11f0a2352cb$var$_slicedToArray(arr, i) {
    return $h9WXo(arr) || $3WLzp(arr, i) || $ieyTF(arr, i) || $cNv2e();
}
module.exports = $b205a11f0a2352cb$var$_slicedToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRequire.register("h9WXo", function(module, exports) {
function $c7e10293880f85c2$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
module.exports = $c7e10293880f85c2$var$_arrayWithHoles, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRequire.register("3WLzp", function(module, exports) {
function $2dfbb054211fb570$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
module.exports = $2dfbb054211fb570$var$_iterableToArrayLimit, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRequire.register("ieyTF", function(module, exports) {

var $eoPLA = parcelRequire("eoPLA");
function $d4649a90d1ff9017$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $eoPLA(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $eoPLA(o, minLen);
}
module.exports = $d4649a90d1ff9017$var$_unsupportedIterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRequire.register("eoPLA", function(module, exports) {
function $a7bb765baf254885$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
module.exports = $a7bb765baf254885$var$_arrayLikeToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRequire.register("cNv2e", function(module, exports) {
function $95122286827455f0$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
module.exports = $95122286827455f0$var$_nonIterableRest, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRequire.register("fWUqx", function(module, exports) {
"use strict";

var $luOtD = parcelRequire("luOtD");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $b9c80b0cb1fee49f$var$renderAdaptiveCard;

var $b9c80b0cb1fee49f$var$_toConsumableArray2 = $luOtD((parcelRequire("9ErOw")));
/**
 * Returns `true`, if the object is a plain object and not a class, otherwise, `false`.
 */ function $b9c80b0cb1fee49f$var$isPlainObject(obj) {
    return Object.getPrototypeOf(obj) === Object.prototype;
}
function $b9c80b0cb1fee49f$var$renderAdaptiveCard(adaptiveCard, _ref) {
    var adaptiveCardsHostConfig = _ref.adaptiveCardsHostConfig, _ref$adaptiveCardsPac = _ref.adaptiveCardsPackage, GlobalSettings = _ref$adaptiveCardsPac.GlobalSettings, HostConfig = _ref$adaptiveCardsPac.HostConfig, renderMarkdownAsHTML = _ref.renderMarkdownAsHTML, setTabIndexAtCardRoot = _ref.setTabIndexAtCardRoot;
    // Currently, the only way to set the Markdown engine is to set it thru static member of AdaptiveCard class
    // TODO: [P3] Checks if we could make the "renderMarkdownAsHTML" per card
    //       This could be limitations from Adaptive Cards package (not supported as of 1.2.5)
    //       Because there could be timing difference between .parse and .render, we could be using wrong Markdown engine
    // "onProcessMarkdown" is a static function but we are trying to scope it to the current object instead.
    // eslint-disable-next-line dot-notation
    adaptiveCard.constructor["onProcessMarkdown"] = function(text, result) {
        if (renderMarkdownAsHTML) {
            result.outputHtml = renderMarkdownAsHTML(text);
            result.didProcess = true;
        }
    };
    if (adaptiveCardsHostConfig) adaptiveCard.hostConfig = $b9c80b0cb1fee49f$var$isPlainObject(adaptiveCardsHostConfig) ? new HostConfig(adaptiveCardsHostConfig) : adaptiveCardsHostConfig;
     // For accessibility issue #1340, `tabindex="0"` must not be set for the root container if it is not interactive.
    GlobalSettings.setTabIndexAtCardRoot = setTabIndexAtCardRoot;
    var _adaptiveCard$validat = adaptiveCard.validateProperties(), validationEvents = _adaptiveCard$validat.validationEvents;
    if (validationEvents.length) return {
        errors: validationEvents.reduce(function(items, _ref2) {
            var message = _ref2.message;
            return [].concat((0, $b9c80b0cb1fee49f$var$_toConsumableArray2.default)(items), [
                new Error(message)
            ]);
        }, [])
    };
    var element;
    try {
        element = adaptiveCard.render();
    } catch (error) {
        return {
            errors: [
                error
            ]
        };
    }
    if (!element) return {
        errors: [
            new Error("Adaptive Card rendered as empty element")
        ]
    };
    return {
        element: element
    };
}

});
parcelRequire.register("9ErOw", function(module, exports) {

var $lBWtz = parcelRequire("lBWtz");

var $16F5a = parcelRequire("16F5a");

var $ieyTF = parcelRequire("ieyTF");

var $h0nfQ = parcelRequire("h0nfQ");
function $706d6cc3a590e00d$var$_toConsumableArray(arr) {
    return $lBWtz(arr) || $16F5a(arr) || $ieyTF(arr) || $h0nfQ();
}
module.exports = $706d6cc3a590e00d$var$_toConsumableArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRequire.register("lBWtz", function(module, exports) {

var $eoPLA = parcelRequire("eoPLA");
function $fbba69c510950cde$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $eoPLA(arr);
}
module.exports = $fbba69c510950cde$var$_arrayWithoutHoles, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRequire.register("16F5a", function(module, exports) {
function $0ce6380e9778fdb0$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
module.exports = $0ce6380e9778fdb0$var$_iterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRequire.register("h0nfQ", function(module, exports) {
function $0331e0edd6a405b9$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
module.exports = $0331e0edd6a405b9$var$_nonIterableSpread, module.exports.__esModule = true, module.exports["default"] = module.exports;

});



parcelRequire.register("dUUUB", function(module, exports) {
"use strict";

var $luOtD = parcelRequire("luOtD");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $a21ca6dc5cd4b218$var$useActionShouldBePushButtonModEffect;

var $eO7Kz = parcelRequire("eO7Kz");

var $a21ca6dc5cd4b218$var$_bunchUndos = $luOtD((parcelRequire("j5Eef")));

var $a21ca6dc5cd4b218$var$_setOrRemoveAttributeIfFalseWithUndo = $luOtD((parcelRequire("2Sdlj")));

var $a21ca6dc5cd4b218$var$_useAdaptiveCardModEffect = $luOtD((parcelRequire("4vYkA")));
/**
 * Accessibility: ActionSet should not be menu bar.
 *
 * Menu bar is not accessible through screen reader keyboard shortcut keys:
 *
 * - <kbd>B</kbd> will jump to next button, which the end-user can quickly the chosen action;
 * - <kbd>F</kbd> will jump to next form field, which is very similar but also jump to text fields;
 * - There are no keyboard shortcut keys for menu.
 *
 * Marking action button as menu item in a menu bar hurts accessibility. End-user will not be able to jump to buttons quickly.
 *
 * Thus, ActionSet should not be menu bar.
 */ function $a21ca6dc5cd4b218$var$useActionShouldBePushButtonModEffect(adaptiveCard) {
    var modder = (0, $eO7Kz.useMemo)(function() {
        return function(_, cardElement) {
            var actionSetElements = Array.from(cardElement.querySelectorAll('.ac-actionSet[role="menubar"]'));
            var undoStack = actionSetElements.map(function(actionSetElement) {
                return (0, $a21ca6dc5cd4b218$var$_setOrRemoveAttributeIfFalseWithUndo.default)(actionSetElement, "role", false);
            });
            return function() {
                return (0, $a21ca6dc5cd4b218$var$_bunchUndos.default)(undoStack)();
            };
        };
    }, []);
    return (0, $a21ca6dc5cd4b218$var$_useAdaptiveCardModEffect.default)(modder, adaptiveCard);
}

});
parcelRequire.register("j5Eef", function(module, exports) {
"use strict";

var $luOtD = parcelRequire("luOtD");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $de5db091f802c85b$var$bunchUndos;

var $de5db091f802c85b$var$_toConsumableArray2 = $luOtD((parcelRequire("9ErOw")));
function $de5db091f802c85b$var$bunchUndos(fns) {
    var called;
    return function() {
        if (!called) {
            called = true;
            (0, $de5db091f802c85b$var$_toConsumableArray2.default)(fns).reverse().forEach(function(fn) {
                return fn === null || fn === void 0 ? void 0 : fn();
            });
        }
    };
}

});

parcelRequire.register("2Sdlj", function(module, exports) {
"use strict";

var $luOtD = parcelRequire("luOtD");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $217af97ca9b4a692$var$setOrRemoveAttributeIfFalseWithUndo;

var $217af97ca9b4a692$var$_getAttributeOrFalse = $luOtD((parcelRequire("41SMr")));

var $217af97ca9b4a692$var$_noOp = $luOtD((parcelRequire("8pE4V")));

var $217af97ca9b4a692$var$_setOrRemoveAttributeIfFalse = $luOtD((parcelRequire("lIauo")));
/**
 * Sets or removes an attribute from an element with an undo function.
 *
 * @param {HTMLElement} element - The element to set or remove attribute from.
 * @param {string} qualifiedName - The name of the attribute.
 * @param {false | string} value - The value of the attribute. When passing `false`, remove the attribute.
 *
 * @returns {() => void} An undo function, when called, will undo all manipulations by restoring values recorded at the time of the function call.
 */ function $217af97ca9b4a692$var$setOrRemoveAttributeIfFalseWithUndo(element, qualifiedName, value) {
    if (!element) return $217af97ca9b4a692$var$_noOp.default;
    var prevValue = (0, $217af97ca9b4a692$var$_getAttributeOrFalse.default)(element, qualifiedName);
    if (prevValue === value) return $217af97ca9b4a692$var$_noOp.default;
    (0, $217af97ca9b4a692$var$_setOrRemoveAttributeIfFalse.default)(element, qualifiedName, value);
    return function() {
        return (0, $217af97ca9b4a692$var$_setOrRemoveAttributeIfFalse.default)(element, qualifiedName, prevValue);
    };
}

});
parcelRequire.register("41SMr", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $2ef1bfa3edc1dbd0$var$getAttributeOrFalse;
/**
 * Gets the value of an attribute from an element.
 *
 * @returns {false | string} The value of the attribute. `false` if the attribute was not set.
 */ function $2ef1bfa3edc1dbd0$var$getAttributeOrFalse(element, qualifiedName) {
    return !!element && element.hasAttribute(qualifiedName) && (element.getAttribute(qualifiedName) || "");
}

});

parcelRequire.register("8pE4V", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
// This is intended. This is a no-op function and intended to do nothing.
// eslint-disable-next-line @typescript-eslint/no-empty-function
var $0194a41e05cafece$var$noOp = function noOp() {};
var $0194a41e05cafece$var$_default = $0194a41e05cafece$var$noOp;
module.exports.default = $0194a41e05cafece$var$_default;

});

parcelRequire.register("lIauo", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $fce5d7fa37d1cf0b$var$setOrRemoveAttributeIfFalse;
/**
 * Sets or removes an attribute from an element.
 *
 * @param {HTMLElement} element - The element to set or remove attribute from.
 * @param {string} qualifiedName - The name of the attribute.
 * @param {false | string} value - The value of the attribute. When passing `false`, remove the attribute.
 */ function $fce5d7fa37d1cf0b$var$setOrRemoveAttributeIfFalse(element, qualifiedName, value) {
    if (value === false) element === null || element === void 0 || element.removeAttribute(qualifiedName);
    else element === null || element === void 0 || element.setAttribute(qualifiedName, value);
}

});


parcelRequire.register("4vYkA", function(module, exports) {
"use strict";

var $luOtD = parcelRequire("luOtD");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $3498db281986f972$var$useAdaptiveCardModEffect;

var $3498db281986f972$var$_classCallCheck2 = $luOtD((parcelRequire("hYNAh")));

var $3498db281986f972$var$_createClass2 = $luOtD((parcelRequire("8Eu5W")));

var $3498db281986f972$var$_classPrivateFieldGet5 = $luOtD((parcelRequire("4YxKL")));

var $3498db281986f972$var$_classPrivateFieldSet2 = $luOtD((parcelRequire("3BpRL")));

var $eO7Kz = parcelRequire("eO7Kz");

var $3498db281986f972$var$_useLazyRef = $luOtD((parcelRequire("kZ2hr")));

var $3498db281986f972$var$_useValueRef = $luOtD((parcelRequire("3guG7")));
function $3498db281986f972$var$_classPrivateFieldInitSpec(obj, privateMap, value) {
    $3498db281986f972$var$_checkPrivateRedeclaration(obj, privateMap);
    privateMap.set(obj, value);
}
function $3498db281986f972$var$_checkPrivateRedeclaration(obj, privateCollection) {
    if (privateCollection.has(obj)) throw new TypeError("Cannot initialize the same private elements twice on an object");
}
var $3498db281986f972$var$_mod = /*#__PURE__*/ new WeakMap();
var $3498db281986f972$var$_undo = /*#__PURE__*/ new WeakMap();
var $3498db281986f972$var$Mod = /*#__PURE__*/ function() {
    function Mod(mod) {
        (0, $3498db281986f972$var$_classCallCheck2.default)(this, Mod);
        $3498db281986f972$var$_classPrivateFieldInitSpec(this, $3498db281986f972$var$_mod, {
            writable: true,
            value: void 0
        });
        $3498db281986f972$var$_classPrivateFieldInitSpec(this, $3498db281986f972$var$_undo, {
            writable: true,
            value: void 0
        });
        (0, $3498db281986f972$var$_classPrivateFieldSet2.default)(this, $3498db281986f972$var$_mod, mod);
    } // @ts-ignore We are using Babel to transpile and it will transpile private modifier.
    (0, $3498db281986f972$var$_createClass2.default)(Mod, [
        {
            key: "apply",
            value: function apply(adaptiveCard, cardElement) {
                var _classPrivateFieldGet2, _classPrivateFieldGet3;
                (_classPrivateFieldGet2 = (0, $3498db281986f972$var$_classPrivateFieldGet5.default)(this, $3498db281986f972$var$_undo)) === null || _classPrivateFieldGet2 === void 0 || _classPrivateFieldGet2.call(this);
                for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)args[_key - 2] = arguments[_key];
                (0, $3498db281986f972$var$_classPrivateFieldSet2.default)(this, $3498db281986f972$var$_undo, adaptiveCard && cardElement && (_classPrivateFieldGet3 = (0, $3498db281986f972$var$_classPrivateFieldGet5.default)(this, $3498db281986f972$var$_mod)).call.apply(_classPrivateFieldGet3, [
                    this,
                    adaptiveCard,
                    cardElement
                ].concat(args)));
            }
        },
        {
            key: "undo",
            value: function undo() {
                var _classPrivateFieldGet4;
                (_classPrivateFieldGet4 = (0, $3498db281986f972$var$_classPrivateFieldGet5.default)(this, $3498db281986f972$var$_undo)) === null || _classPrivateFieldGet4 === void 0 || _classPrivateFieldGet4.call(this);
                (0, $3498db281986f972$var$_classPrivateFieldSet2.default)(this, $3498db281986f972$var$_undo, undefined);
            }
        }
    ]);
    return Mod;
}();
/**
 * Creates a mod effect for Adaptive Card.
 *
 * When this hook is executed, it will return two functions for applying and undo the mod.
 * It will also monitor the DOM tree and undo-then-reapply if mutation occurred.
 *
 * The first function must be called right after DOM is mounted. The second function must be called right before re-render.
 *
 * @return {[function, function]} Two functions, the first one to apply the mod, the second one to undo the mod.
 */ function $3498db281986f972$var$useAdaptiveCardModEffect(modder, adaptiveCard) {
    var adaptiveCardRef = (0, $3498db281986f972$var$_useValueRef.default)(adaptiveCard);
    var mod = (0, $eO7Kz.useMemo)(function() {
        return new $3498db281986f972$var$Mod(modder);
    }, [
        modder
    ]);
    var reapplyRef = (0, $eO7Kz.useRef)();
    var observerRef = (0, $3498db281986f972$var$_useLazyRef.default)(function() {
        return new MutationObserver(function() {
            var _reapplyRef$current;
            (_reapplyRef$current = reapplyRef.current) === null || _reapplyRef$current === void 0 || _reapplyRef$current.call(reapplyRef);
        });
    });
    (0, $eO7Kz.useEffect)(function() {
        return function() {
            observerRef.current.disconnect();
        };
    }, [
        observerRef
    ]);
    var handleApply = (0, $eO7Kz.useCallback)(function(cardElement) {
        for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
        if (adaptiveCardRef.current && cardElement) // Apply the mod immediately, then assign the function to reapply() so we can call later when mutation happens.
        (reapplyRef.current = function() {
            return mod.apply.apply(mod, [
                adaptiveCardRef.current,
                cardElement
            ].concat(args));
        })();
        var observer = observerRef.current;
        observer.disconnect();
        observer.observe(cardElement, {
            childList: true,
            subtree: true
        });
    }, [
        adaptiveCardRef,
        observerRef,
        mod
    ]);
    var handleUndo = (0, $eO7Kz.useCallback)(function() {
        mod.undo(); // If we have undo-ed the mod, calling reapply() through MutationObserver should be no-op.
        reapplyRef.current = undefined;
    }, [
        mod,
        reapplyRef
    ]);
    return (0, $eO7Kz.useMemo)(function() {
        return Object.freeze([
            handleApply,
            handleUndo
        ]);
    }, [
        handleApply,
        handleUndo
    ]);
}

});
parcelRequire.register("hYNAh", function(module, exports) {
function $d16e80a91c55cdbe$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
module.exports = $d16e80a91c55cdbe$var$_classCallCheck, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRequire.register("8Eu5W", function(module, exports) {
function $64c9676183b021a0$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $64c9676183b021a0$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $64c9676183b021a0$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $64c9676183b021a0$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
module.exports = $64c9676183b021a0$var$_createClass, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRequire.register("4YxKL", function(module, exports) {

var $jDNnW = parcelRequire("jDNnW");

var $k3wdj = parcelRequire("k3wdj");
function $39f6f2b77c22f72b$var$_classPrivateFieldGet(receiver, privateMap) {
    var descriptor = $k3wdj(receiver, privateMap, "get");
    return $jDNnW(receiver, descriptor);
}
module.exports = $39f6f2b77c22f72b$var$_classPrivateFieldGet, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRequire.register("jDNnW", function(module, exports) {
function $e4c7f7b3128c49b8$var$_classApplyDescriptorGet(receiver, descriptor) {
    if (descriptor.get) return descriptor.get.call(receiver);
    return descriptor.value;
}
module.exports = $e4c7f7b3128c49b8$var$_classApplyDescriptorGet, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRequire.register("k3wdj", function(module, exports) {
function $e99d13744d0a5175$var$_classExtractFieldDescriptor(receiver, privateMap, action) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to " + action + " private field on non-instance");
    return privateMap.get(receiver);
}
module.exports = $e99d13744d0a5175$var$_classExtractFieldDescriptor, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRequire.register("3BpRL", function(module, exports) {

var $hOLgv = parcelRequire("hOLgv");

var $k3wdj = parcelRequire("k3wdj");
function $29f8e4443f2bebad$var$_classPrivateFieldSet(receiver, privateMap, value) {
    var descriptor = $k3wdj(receiver, privateMap, "set");
    $hOLgv(receiver, descriptor, value);
    return value;
}
module.exports = $29f8e4443f2bebad$var$_classPrivateFieldSet, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRequire.register("hOLgv", function(module, exports) {
function $cf8bc510e174f762$var$_classApplyDescriptorSet(receiver, descriptor, value) {
    if (descriptor.set) descriptor.set.call(receiver, value);
    else {
        if (!descriptor.writable) throw new TypeError("attempted to set read only private field");
        descriptor.value = value;
    }
}
module.exports = $cf8bc510e174f762$var$_classApplyDescriptorSet, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRequire.register("kZ2hr", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $f46b45f5f9f29735$var$useLazyRef;

var $eO7Kz = parcelRequire("eO7Kz");
var $f46b45f5f9f29735$var$UNINITIALIZED = Symbol();
function $f46b45f5f9f29735$var$useLazyRef(refInit) {
    var ref = (0, $eO7Kz.useRef)($f46b45f5f9f29735$var$UNINITIALIZED);
    if (ref.current === $f46b45f5f9f29735$var$UNINITIALIZED) ref.current = refInit();
    return ref;
}

});

parcelRequire.register("3guG7", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $260aa9cf6754a59e$var$useValueRef;

var $eO7Kz = parcelRequire("eO7Kz");
function $260aa9cf6754a59e$var$useValueRef(value) {
    var ref = (0, $eO7Kz.useRef)(value);
    ref.current = value;
    return ref;
}

});



parcelRequire.register("gpNMB", function(module, exports) {
"use strict";

var $luOtD = parcelRequire("luOtD");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $bf3598fa6253a4bd$var$useActionShouldBePushButtonModEffect;

var $eO7Kz = parcelRequire("eO7Kz");

var $bf3598fa6253a4bd$var$_addEventListenerWithUndo = $luOtD((parcelRequire("eZoDe")));

var $bf3598fa6253a4bd$var$_bunchUndos = $luOtD((parcelRequire("j5Eef")));

var $bf3598fa6253a4bd$var$_closest = $luOtD((parcelRequire("kAyA8")));

var $bf3598fa6253a4bd$var$_durableAddClassWithUndo = $luOtD((parcelRequire("38a2Y")));

var $bf3598fa6253a4bd$var$_findDOMNodeOwner = $luOtD((parcelRequire("14GqI")));

var $bf3598fa6253a4bd$var$_setOrRemoveAttributeIfFalseWithUndo = $luOtD((parcelRequire("2Sdlj")));

var $bf3598fa6253a4bd$var$_useAdaptiveCardModEffect = $luOtD((parcelRequire("4vYkA")));

var $bf3598fa6253a4bd$var$_usePrevious = $luOtD((parcelRequire("1mgFg")));
/**
 * Accessibility: Action in ActionSet/CardElement should be push button.
 *
 * Pressing the action button is a decision-making process. The decision made by the end-user need to be read by the screen reader.
 * Thus, we need to indicate what decision the end-user made.
 *
 * Since action buttons are button, the intuitive way to indicate selection of a button is marking it as pressed.
 *
 * One exception is the `Action.ShowUrl` action. This button represents expand/collapse header of an accordion.
 * Thus, their state is indicated by `aria-expanded`, instead of `aria-pressed`.
 * However, we still need to remove other unnecessary ARIA fields.
 */ function $bf3598fa6253a4bd$var$useActionShouldBePushButtonModEffect(adaptiveCard) {
    var prevAdaptiveCard = (0, $bf3598fa6253a4bd$var$_usePrevious.default)(adaptiveCard);
    var pushedCardObjectsRef = (0, $eO7Kz.useRef)(new Set());
    prevAdaptiveCard === adaptiveCard || pushedCardObjectsRef.current.clear();
    var modder = (0, $eO7Kz.useMemo)(function() {
        return function(adaptiveCard, cardElement, actionPerformedClassName) {
            var undoStack = [];
            Array.from(cardElement.querySelectorAll("button.ac-pushButton")).forEach(function(actionElement) {
                var cardObject = (0, $bf3598fa6253a4bd$var$_findDOMNodeOwner.default)(adaptiveCard, actionElement);
                if (!actionElement.hasAttribute("aria-expanded")) {
                    if (pushedCardObjectsRef.current.has(cardObject)) {
                        actionPerformedClassName && undoStack.push((0, $bf3598fa6253a4bd$var$_durableAddClassWithUndo.default)(actionElement, actionPerformedClassName));
                        undoStack.push((0, $bf3598fa6253a4bd$var$_setOrRemoveAttributeIfFalseWithUndo.default)(actionElement, "aria-pressed", "true"));
                    } else undoStack.push((0, $bf3598fa6253a4bd$var$_setOrRemoveAttributeIfFalseWithUndo.default)(actionElement, "aria-pressed", "false"));
                }
                undoStack.push((0, $bf3598fa6253a4bd$var$_setOrRemoveAttributeIfFalseWithUndo.default)(actionElement, "aria-posinset", false), (0, $bf3598fa6253a4bd$var$_setOrRemoveAttributeIfFalseWithUndo.default)(actionElement, "aria-setsize", false), (0, $bf3598fa6253a4bd$var$_setOrRemoveAttributeIfFalseWithUndo.default)(actionElement, "role", false));
            });
            undoStack.push((0, $bf3598fa6253a4bd$var$_addEventListenerWithUndo.default)(cardElement, "click", function(_ref) {
                var target = _ref.target;
                // Depends on click location, `target` could be the <div> inside the <button class="ac-pushButton">.
                // Thus, we need to check if we the `target` is inside `button.ac-pushButton` or not.
                var actionElement = (0, $bf3598fa6253a4bd$var$_closest.default)(target, "button.ac-pushButton");
                if (!actionElement) return;
                var cardObject = (0, $bf3598fa6253a4bd$var$_findDOMNodeOwner.default)(adaptiveCard, actionElement);
                if (!cardObject || // Ignores buttons which are supposed to be disabled.
                actionElement.getAttribute("aria-disabled") === "true" || // Mods all AC action buttons except those for `Action.ShowCard`, which has `aria-expanded` attribute.
                actionElement.hasAttribute("aria-expanded")) return;
                actionPerformedClassName && undoStack.push((0, $bf3598fa6253a4bd$var$_durableAddClassWithUndo.default)(actionElement, actionPerformedClassName));
                undoStack.push((0, $bf3598fa6253a4bd$var$_setOrRemoveAttributeIfFalseWithUndo.default)(actionElement, "aria-pressed", "true"));
                cardObject && pushedCardObjectsRef.current.add(cardObject);
            }, {
                capture: true
            }));
            return function() {
                return (0, $bf3598fa6253a4bd$var$_bunchUndos.default)(undoStack)();
            };
        };
    }, [
        pushedCardObjectsRef
    ]);
    return (0, $bf3598fa6253a4bd$var$_useAdaptiveCardModEffect.default)(modder, adaptiveCard);
}

});
parcelRequire.register("eZoDe", function(module, exports) {
"use strict";

var $luOtD = parcelRequire("luOtD");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $ae99de8d8a8ffddb$var$addEventListenerWithUndo;

var $ae99de8d8a8ffddb$var$_noOp = $luOtD((parcelRequire("8pE4V")));
/**
 * Listens to event. Returns a function, when called, will stop listening.
 */ function $ae99de8d8a8ffddb$var$addEventListenerWithUndo(element, name, handler, options) {
    if (!element) return $ae99de8d8a8ffddb$var$_noOp.default;
    element.addEventListener(name, handler, options);
    return function() {
        return element.removeEventListener(name, handler, options);
    };
}

});

parcelRequire.register("kAyA8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $efd1feab83e0f3f1$var$closest;
// Ponyfill `HTMLElement.closest`.
// https://developer.mozilla.org/en-US/docs/Web/API/Element/closest
function $efd1feab83e0f3f1$var$closest(element, selector) {
    if (typeof element.closest === "function") return element.closest(selector);
    var current = element;
    while(current){
        // "msMatchesSelector" is vendor-prefixed version of "matches".
        // eslint-disable-next-line dot-notation
        if ((current.matches || current["msMatchesSelector"]).call(current, selector)) return current;
        current = current.parentElement;
    }
}

});

parcelRequire.register("38a2Y", function(module, exports) {
"use strict";

var $luOtD = parcelRequire("luOtD");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $2479e99349db7ea0$var$durableAddClassWithUndo;

var $8SDZt = parcelRequire("8SDZt");

var $2479e99349db7ea0$var$_noOp = $luOtD((parcelRequire("8pE4V")));
/**
 * Adds a class to the `HTMLElement` and re-add on mutations.
 *
 * @returns {function} A function, when called, will restore to previous state.
 */ function $2479e99349db7ea0$var$durableAddClassWithUndo(element, className) {
    if (element) {
        (0, $8SDZt.addClass)(element, className); // After we add the class, keep observing the element to make sure the class is not removed.
        var observer = new MutationObserver(function() {
            return (0, $8SDZt.addClass)(element, className);
        });
        observer.observe(element, {
            attributes: true,
            attributeFilter: [
                "class"
            ]
        });
        return function() {
            element.classList.remove(className);
            observer.disconnect();
        };
    }
    return $2479e99349db7ea0$var$_noOp.default;
}

});
parcelRequire.register("8SDZt", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.addClass = $6772632d39cfb273$var$addClass;
/**
 * Adds a class to the `HTMLElement`. Returns `true` if the class is added, otherwise, `undefined`.
 */ function $6772632d39cfb273$var$addClass(element, className) {
    var classList = element.classList;
    if (!classList.contains(className)) {
        classList.add(className);
        return true;
    }
}

});


parcelRequire.register("14GqI", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $0c8713ddd85a8925$var$findDOMNodeOwner;
// TODO: [P2] Remove this when Adaptive Card fixed their bug #7606.
//            https://github.com/microsoft/AdaptiveCards/issues/7606
//            Currently, their findDOMNodeOwner() returns bad result when passing an Action attached to the card.
function $0c8713ddd85a8925$var$findDOMNodeOwner(adaptiveCard, element) {
    for(var count = adaptiveCard.getActionCount(), index = 0; index < count; index++){
        var action = adaptiveCard.getActionAt(index);
        if (action.renderedElement === element) return action;
        if (action.getJsonTypeName() === "Action.ShowCard") {
            var _ref = action, card = _ref.card;
            var cardObject = card && $0c8713ddd85a8925$var$findDOMNodeOwner(card, element);
            if (cardObject) return cardObject;
        }
    }
    return adaptiveCard.findDOMNodeOwner(element);
}

});

parcelRequire.register("1mgFg", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $0fd4c5c41c81f928$var$usePrevious;

var $eO7Kz = parcelRequire("eO7Kz");
// TODO: [P0] #4133 Don't copy.
function $0fd4c5c41c81f928$var$usePrevious(value) {
    var ref = (0, $eO7Kz.useRef)();
    (0, $eO7Kz.useEffect)(function() {
        ref.current = value;
    });
    return ref.current;
}

});


parcelRequire.register("6LCaP", function(module, exports) {
"use strict";

var $luOtD = parcelRequire("luOtD");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $4ed4be5e3c377eba$var$useActiveElementModEffect;

var $eO7Kz = parcelRequire("eO7Kz");

var $4ed4be5e3c377eba$var$_findDOMNodeOwner = $luOtD((parcelRequire("14GqI")));

var $4ed4be5e3c377eba$var$_useAdaptiveCardModEffect = $luOtD((parcelRequire("4vYkA")));

var $4ed4be5e3c377eba$var$_usePrevious = $luOtD((parcelRequire("1mgFg")));
/**
 * Re-rendering: Last focused element must be persisted during render cycle.
 */ function $4ed4be5e3c377eba$var$useActiveElementModEffect(adaptiveCard) {
    var activeCardObjectRef = (0, $eO7Kz.useRef)();
    var prevAdaptiveCard = (0, $4ed4be5e3c377eba$var$_usePrevious.default)(adaptiveCard);
    if (prevAdaptiveCard !== adaptiveCard) activeCardObjectRef.current = undefined;
    var modder = (0, $eO7Kz.useMemo)(function() {
        return function(adaptiveCard) {
            var _activeCardObjectRef$, _activeCardObjectRef$2, _activeCardObjectRef$3;
            // When apply, if we have saved the `CardObject` that was focused, restore its focused to the newly rendered element.
            (_activeCardObjectRef$ = activeCardObjectRef.current) === null || _activeCardObjectRef$ === void 0 || (_activeCardObjectRef$2 = _activeCardObjectRef$.renderedElement) === null || _activeCardObjectRef$2 === void 0 || (_activeCardObjectRef$3 = _activeCardObjectRef$2.focus) === null || _activeCardObjectRef$3 === void 0 || _activeCardObjectRef$3.call(_activeCardObjectRef$2); // When undo, we are preparing for the next rendering.
            // So, find and save the `CardObject` that is currently focused.
            return function() {
                activeCardObjectRef.current = (0, $4ed4be5e3c377eba$var$_findDOMNodeOwner.default)(adaptiveCard, document.activeElement);
            };
        };
    }, [
        activeCardObjectRef
    ]);
    return (0, $4ed4be5e3c377eba$var$_useAdaptiveCardModEffect.default)(modder, adaptiveCard);
}

});

parcelRequire.register("8JJxt", function(module, exports) {
"use strict";

var $luOtD = parcelRequire("luOtD");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $65c5d9c9c04e66a6$var$useAdaptiveCardsHostConfig;

var $65c5d9c9c04e66a6$var$_slicedToArray2 = $luOtD((parcelRequire("fhBCP")));

var $eO7Kz = parcelRequire("eO7Kz");

var $65c5d9c9c04e66a6$var$_adaptiveCardHostConfig = $luOtD((parcelRequire("kwPz8")));

var $65c5d9c9c04e66a6$var$_useAdaptiveCardsContext = $luOtD((parcelRequire("5ZW5c")));

var $65c5d9c9c04e66a6$var$_useStyleOptions3 = $luOtD((parcelRequire("gwtqY")));
function $65c5d9c9c04e66a6$var$useAdaptiveCardsHostConfig() {
    var _useAdaptiveCardsCont = (0, $65c5d9c9c04e66a6$var$_useAdaptiveCardsContext.default)(), hostConfigFromProps = _useAdaptiveCardsCont.hostConfigFromProps;
    var _useStyleOptions = (0, $65c5d9c9c04e66a6$var$_useStyleOptions3.default)(), _useStyleOptions2 = (0, $65c5d9c9c04e66a6$var$_slicedToArray2.default)(_useStyleOptions, 1), styleOptions = _useStyleOptions2[0];
    var patchedHostConfig = (0, $eO7Kz.useMemo)(function() {
        return hostConfigFromProps || (0, $65c5d9c9c04e66a6$var$_adaptiveCardHostConfig.default)(styleOptions);
    }, [
        hostConfigFromProps,
        styleOptions
    ]);
    return [
        patchedHostConfig
    ];
}

});
parcelRequire.register("kwPz8", function(module, exports) {
"use strict";

var $luOtD = parcelRequire("luOtD");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $ef1ecbac700ddc38$var$createAdaptiveCardsHostConfig;

var $ef1ecbac700ddc38$var$_defineProperty2 = $luOtD((parcelRequire("3w8Sv")));

var $hd4g0 = parcelRequire("hd4g0");

var $ef1ecbac700ddc38$var$_normalizeStyleOptions = $luOtD((parcelRequire("gSEu1")));
function $ef1ecbac700ddc38$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $ef1ecbac700ddc38$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $ef1ecbac700ddc38$var$ownKeys(Object(source), !0).forEach(function(key) {
            (0, $ef1ecbac700ddc38$var$_defineProperty2.default)(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $ef1ecbac700ddc38$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
// https://docs.microsoft.com/en-us/adaptive-cards/rendering-cards/host-config
function $ef1ecbac700ddc38$var$createAdaptiveCardsHostConfig(styleOptions) {
    var _normalizeStyleOption = $ef1ecbac700ddc38$var$_objectSpread($ef1ecbac700ddc38$var$_objectSpread({}, (0, $hd4g0.normalizeStyleOptions)(styleOptions)), (0, $ef1ecbac700ddc38$var$_normalizeStyleOptions.default)(styleOptions)), accent = _normalizeStyleOption.accent, bubbleTextColor = _normalizeStyleOption.bubbleTextColor, cardEmphasisBackgroundColor = _normalizeStyleOption.cardEmphasisBackgroundColor, primaryFont = _normalizeStyleOption.primaryFont, subtle = _normalizeStyleOption.subtle;
    return {
        containerStyles: {
            default: {
                foregroundColors: {
                    default: {
                        default: bubbleTextColor,
                        subtle: subtle
                    },
                    accent: {
                        default: accent,
                        subtle: "#0078D4"
                    },
                    attention: {
                        default: "#D13438",
                        subtle: "#A4262C"
                    },
                    dark: {
                        default: "#000000",
                        subtle: "#646464"
                    },
                    good: {
                        default: "#0B6A0B",
                        subtle: "#028A02"
                    },
                    light: {
                        default: "#FFFFFF",
                        subtle: subtle
                    },
                    warning: {
                        default: "#B75C00",
                        subtle: "#986F0B"
                    }
                }
            },
            emphasis: {
                backgroundColor: cardEmphasisBackgroundColor,
                foregroundColors: {
                    default: {
                        default: "#000000",
                        subtle: "#484644"
                    }
                }
            },
            accent: {
                backgroundColor: "#C7DEF9",
                foregroundColors: {
                    default: {
                        default: "#333333",
                        subtle: "#484644"
                    }
                }
            },
            good: {
                backgroundColor: "#CCFFCC",
                foregroundColors: {
                    default: {
                        default: "#333333",
                        subtle: "#484644"
                    }
                }
            },
            attention: {
                backgroundColor: "#FFC5B2",
                foregroundColors: {
                    default: {
                        default: "#333333",
                        subtle: "#484644"
                    }
                }
            },
            warning: {
                backgroundColor: "#FFE2B2",
                foregroundColors: {
                    default: {
                        default: "#333333",
                        subtle: "#484644"
                    }
                }
            }
        },
        supportsInteractivity: true,
        fontFamily: primaryFont,
        imageSizes: {
            small: 40,
            medium: 80,
            large: 160
        },
        actions: {
            actionAlignment: "stretch",
            actionsOrientation: "vertical",
            buttonSpacing: 8,
            maxActions: 100,
            showCard: {
                actionMode: "inline",
                inlineTopMargin: 8
            },
            spacing: "default"
        },
        adaptiveCard: {
            allowCustomStyle: false
        },
        imageSet: {
            imageSize: "medium",
            maxImageHeight: 100
        },
        factSet: {
            title: {
                color: "default",
                size: "default",
                isSubtle: false,
                weight: "bolder",
                wrap: true,
                maxWidth: 150
            },
            value: {
                color: "default",
                size: "default",
                isSubtle: false,
                weight: "default",
                wrap: true
            },
            spacing: 8
        },
        textBlock: {
            headingLevel: 1
        }
    };
}

});
parcelRequire.register("gSEu1", function(module, exports) {
"use strict";

var $luOtD = parcelRequire("luOtD");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $c4a1179cebab4e66$var$normalizeStyleOptions;

var $c4a1179cebab4e66$var$_defineProperty2 = $luOtD((parcelRequire("3w8Sv")));

var $c4a1179cebab4e66$var$_defaultStyleOptions = $luOtD((parcelRequire("4E9mo")));
function $c4a1179cebab4e66$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $c4a1179cebab4e66$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $c4a1179cebab4e66$var$ownKeys(Object(source), !0).forEach(function(key) {
            (0, $c4a1179cebab4e66$var$_defineProperty2.default)(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $c4a1179cebab4e66$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $c4a1179cebab4e66$var$normalizeStyleOptions(styleOptions) {
    return $c4a1179cebab4e66$var$_objectSpread($c4a1179cebab4e66$var$_objectSpread({}, $c4a1179cebab4e66$var$_defaultStyleOptions.default), styleOptions);
}

});
parcelRequire.register("4E9mo", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
var $3622289571ea00c6$var$ADAPTIVE_CARDS_DEFAULT_STYLE_OPTIONS = {
    adaptiveCardsParserMaxVersion: undefined,
    cardEmphasisBackgroundColor: "#F9F9F9",
    cardPushButtonBackgroundColor: "#0063B1",
    cardPushButtonTextColor: "White",
    richCardWrapTitle: false
};
var $3622289571ea00c6$var$_default = $3622289571ea00c6$var$ADAPTIVE_CARDS_DEFAULT_STYLE_OPTIONS;
module.exports.default = $3622289571ea00c6$var$_default;

});



parcelRequire.register("5ZW5c", function(module, exports) {
"use strict";

var $luOtD = parcelRequire("luOtD");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $45dfb44706cabfac$var$useAdaptiveCardsContext;

var $eO7Kz = parcelRequire("eO7Kz");

var $45dfb44706cabfac$var$_AdaptiveCardsContext = $luOtD((parcelRequire("16V6h")));
function $45dfb44706cabfac$var$useAdaptiveCardsContext() {
    var context = (0, $eO7Kz.useContext)($45dfb44706cabfac$var$_AdaptiveCardsContext.default);
    if (!context) throw new Error("This hook can only be used on component that is decendants of <ComposerWithAdaptiveCards>");
    return context;
}

});
parcelRequire.register("16V6h", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $eO7Kz = parcelRequire("eO7Kz");
var $0cf2a4eaec4bfb19$var$AdaptiveCardsContext = /*#__PURE__*/ (0, $eO7Kz.createContext)(undefined);
var $0cf2a4eaec4bfb19$var$_default = $0cf2a4eaec4bfb19$var$AdaptiveCardsContext;
module.exports.default = $0cf2a4eaec4bfb19$var$_default;

});


parcelRequire.register("gwtqY", function(module, exports) {
"use strict";

var $luOtD = parcelRequire("luOtD");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $c0767782ea5642fa$var$useStyleOptions;

var $c0767782ea5642fa$var$_slicedToArray2 = $luOtD((parcelRequire("fhBCP")));

var $fD7D4 = parcelRequire("fD7D4");
function $c0767782ea5642fa$var$useStyleOptions() {
    var _hooks$useStyleOption = $fD7D4.hooks.useStyleOptions(), _hooks$useStyleOption2 = (0, $c0767782ea5642fa$var$_slicedToArray2.default)(_hooks$useStyleOption, 1), styleOptions = _hooks$useStyleOption2[0];
    return [
        styleOptions
    ];
}

});


parcelRequire.register("fdwbc", function(module, exports) {
"use strict";

var $luOtD = parcelRequire("luOtD");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $b14108229278c46d$var$useAdaptiveCardsPackage;

var $b14108229278c46d$var$_useAdaptiveCardsContext = $luOtD((parcelRequire("5ZW5c")));
function $b14108229278c46d$var$useAdaptiveCardsPackage() {
    var _useAdaptiveCardsCont = (0, $b14108229278c46d$var$_useAdaptiveCardsContext.default)(), adaptiveCardsPackage = _useAdaptiveCardsCont.adaptiveCardsPackage;
    return [
        adaptiveCardsPackage
    ];
}

});

parcelRequire.register("RZJe6", function(module, exports) {
"use strict";

var $luOtD = parcelRequire("luOtD");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $0a24d556a4ed4975$var$useDisabledModEffect;

var $eO7Kz = parcelRequire("eO7Kz");

var $0a24d556a4ed4975$var$_bunchUndos = $luOtD((parcelRequire("j5Eef")));

var $0a24d556a4ed4975$var$_durableDisableInputElementAccessiblyWithUndo = $luOtD((parcelRequire("eUB7Q")));

var $0a24d556a4ed4975$var$_useAdaptiveCardModEffect = $luOtD((parcelRequire("4vYkA")));
// This is intended. This is a no-op function and intended to do nothing.
// eslint-disable-next-line @typescript-eslint/no-empty-function
var $0a24d556a4ed4975$var$NO_OP = function NO_OP() {}; // In Adaptive Cards, <button> with "aria-expanded" attribute means it is makeshift of <details> and it is Action.ShowCard.
// In HTML, <details> should not be disabled unless the accordion does not permit the panel to be collapsed.
// So when we look for input elements, should skip <button> that mimick <details>.
var $0a24d556a4ed4975$var$INPUT_ELEMENT_SELECTOR = "button:not([aria-expanded]), input, select, textarea";
/**
 * Accessibility: Form fields in Adaptive Cards need to be disabled to reduce confusion for screen reader users.
 *
 * One exception is the `Action.ShowUrl`, this is because this action is expand/collapse of an accordion control.
 * Similar to `<details>`/`<summary>`, accordion must not allowed to be disabled.
 */ function $0a24d556a4ed4975$var$useDisabledModEffect(adaptiveCard) {
    var modder = (0, $eO7Kz.useMemo)(function() {
        return function(_, cardElement, disabled) {
            if (!disabled) return $0a24d556a4ed4975$var$NO_OP;
            var undoStack = Array.from(cardElement.querySelectorAll($0a24d556a4ed4975$var$INPUT_ELEMENT_SELECTOR)).map(function(element) {
                return (0, $0a24d556a4ed4975$var$_durableDisableInputElementAccessiblyWithUndo.default)(element);
            });
            return function() {
                return (0, $0a24d556a4ed4975$var$_bunchUndos.default)(undoStack)();
            };
        };
    }, []);
    return (0, $0a24d556a4ed4975$var$_useAdaptiveCardModEffect.default)(modder, adaptiveCard);
}

});
parcelRequire.register("eUB7Q", function(module, exports) {
"use strict";

var $luOtD = parcelRequire("luOtD");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $adb3180298a20382$var$durableDisableInputElementAccessiblyWithUndo;

var $adb3180298a20382$var$_toConsumableArray2 = $luOtD((parcelRequire("9ErOw")));

var $adb3180298a20382$var$_addEventListenerWithUndo = $luOtD((parcelRequire("eZoDe")));

var $adb3180298a20382$var$_bunchUndos = $luOtD((parcelRequire("j5Eef")));

var $adb3180298a20382$var$_noOp = $luOtD((parcelRequire("8pE4V")));

var $adb3180298a20382$var$_setOrRemoveAttributeIfFalseWithUndo = $luOtD((parcelRequire("2Sdlj")));
/**
 * An event handler for disabling event bubbling and propagation.
 */ function $adb3180298a20382$var$disabledHandler(event) {
    event.preventDefault();
    event.stopImmediatePropagation();
    event.stopPropagation();
}
function $adb3180298a20382$var$disable(element, undoStack) {
    var tag = element.nodeName.toLowerCase();
    /* eslint-disable-next-line default-case */ switch(tag){
        case "button":
        case "input":
        case "select":
        case "textarea":
            undoStack.push((0, $adb3180298a20382$var$_addEventListenerWithUndo.default)(element, "click", $adb3180298a20382$var$disabledHandler, {
                capture: true
            }), (0, $adb3180298a20382$var$_setOrRemoveAttributeIfFalseWithUndo.default)(element, "aria-disabled", "true"), (0, $adb3180298a20382$var$_setOrRemoveAttributeIfFalseWithUndo.default)(element, "tabindex", "-1"));
            if (tag === "input" || tag === "textarea") undoStack.push((0, $adb3180298a20382$var$_setOrRemoveAttributeIfFalseWithUndo.default)(element, "readonly", "readonly"));
            else if (tag === "select") undoStack.push.apply(undoStack, (0, $adb3180298a20382$var$_toConsumableArray2.default)(Array.from(element.querySelectorAll("option")).map(function(option) {
                return (0, $adb3180298a20382$var$_setOrRemoveAttributeIfFalseWithUndo.default)(option, "disabled", "disabled");
            })));
            break;
    }
}
/**
 * Disables an input element in accessible fashion with undo function.
 *
 * This is designed for accessibility and mimick the behavior of `disabled` attribute in accessible form:
 *
 * - Take away from focus ring;
 *   - If currently focused, do not move focus;
 * - Mark content as readonly.
 *
 * Thus, it should not impact hyperlinks or other contents which are not affected by `disabled` attribute.
 *
 * For simplicity, currently, we did not disable element with `contenteditable` attribute.
 *
 * We only disable these elements: `<button>`, `<input>`, `<select>`, `<textarea>`.
 *
 * We need durability as Adaptive Cards occasionally reset `tabindex="0"`.
 *
 * @returns {function} A function, when called, will restore to previous state.
 */ function $adb3180298a20382$var$durableDisableInputElementAccessiblyWithUndo(element) {
    if (!element) return $adb3180298a20382$var$_noOp.default;
    var undoStack = [];
    var apply = function apply() {
        return $adb3180298a20382$var$disable(element, undoStack);
    };
    apply();
    var observer = new MutationObserver(apply);
    observer.observe(element, {
        attributeFilter: [
            "tabindex"
        ]
    });
    undoStack.push(function() {
        return observer.disconnect();
    });
    return (0, $adb3180298a20382$var$_bunchUndos.default)(undoStack);
}

});


parcelRequire.register("gAqf1", function(module, exports) {
"use strict";

var $luOtD = parcelRequire("luOtD");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $c1345d1cbbe62afc$var$usePersistValuesModEffect;

var $eO7Kz = parcelRequire("eO7Kz");

var $c1345d1cbbe62afc$var$_useAdaptiveCardModEffect = $luOtD((parcelRequire("4vYkA")));

var $c1345d1cbbe62afc$var$_usePrevious = $luOtD((parcelRequire("1mgFg")));
/**
 * Gets all user-inputted values under a DOM node.
 *
 * We assume values are ID-ed. If not ID-ed (such as `<textarea>`), there will be only a single instance (no two `<textarea>`).
 */ function $c1345d1cbbe62afc$var$getUserValues(element) {
    if (!element) return new Set();
    return Array.from(element.querySelectorAll("input, option, textarea")).reduce(function(values, element) {
        if (element instanceof HTMLInputElement) {
            var type = element.type;
            if (type === "checkbox" || type === "radio") element.checked && values.add(element.value);
            else {
                // ASSUMPTION: We expect CardObject will NOT mix <input type="text"> with <input type="checkbox">.
                values.clear();
                values.add(element.value);
            }
        } else if (element instanceof HTMLOptionElement) element.selected && values.add(element.value);
        else {
            // ASSUMPTION: We expect CardObject will NOT mix <textarea> with <input type="checkbox">.
            values.clear();
            values.add(element.value);
        }
        return values;
    }, new Set());
}
/**
 * Set multiple user-inputted values under a DOM node.
 *
 * This function must be paired with `getUserValues`.
 */ function $c1345d1cbbe62afc$var$setUserValues(element, values) {
    if (!element) return;
     // If the element does not support multiple choices, say <input type="text"> or <textarea>, then, use the first value.
    var defaultValue = Array.from(values)[0] || "";
    element.querySelectorAll("input, option, textarea").forEach(function(element) {
        if (element instanceof HTMLInputElement) {
            var type = element.type;
            if (type === "checkbox" || type === "radio") element.checked = values.has(element.value);
            else element.value = defaultValue;
        } else if (element instanceof HTMLOptionElement) element.selected = values.has(element.value);
        else element.value = defaultValue;
    });
}
/**
 * Re-rendering: Current user-inputted values must be saved and restored on re-render.
 */ function $c1345d1cbbe62afc$var$usePersistValuesModEffect(adaptiveCard) {
    var prevAdaptiveCard = (0, $c1345d1cbbe62afc$var$_usePrevious.default)(adaptiveCard);
    var valuesMapRef = (0, $eO7Kz.useRef)(new Map());
    prevAdaptiveCard === adaptiveCard || valuesMapRef.current.clear();
    var modder = (0, $eO7Kz.useMemo)(function() {
        return function(adaptiveCard) {
            var valuesMap = valuesMapRef.current;
            adaptiveCard.getAllInputs().forEach(function(cardObject) {
                valuesMap.has(cardObject) && $c1345d1cbbe62afc$var$setUserValues(cardObject.renderedElement, valuesMap.get(cardObject));
            });
            return function() {
                valuesMapRef.current = adaptiveCard.getAllInputs().reduce(function(valuesMap, cardObject) {
                    var value = $c1345d1cbbe62afc$var$getUserValues(cardObject.renderedElement);
                    return typeof value !== "undefined" ? valuesMap.set(cardObject, value) : valuesMap;
                }, new Map());
            };
        };
    }, [
        valuesMapRef
    ]);
    return (0, $c1345d1cbbe62afc$var$_useAdaptiveCardModEffect.default)(modder, adaptiveCard);
}

});

parcelRequire.register("fTrR3", function(module, exports) {
"use strict";

var $luOtD = parcelRequire("luOtD");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $b92199753d2c1eff$var$useRoleModEffect;

var $eO7Kz = parcelRequire("eO7Kz");

var $b92199753d2c1eff$var$_setOrRemoveAttributeIfFalseWithUndo = $luOtD((parcelRequire("2Sdlj")));

var $b92199753d2c1eff$var$_useAdaptiveCardModEffect = $luOtD((parcelRequire("4vYkA")));
/**
 * Accessibility: "role" attribute must be set if "aria-label" is set.
 *
 * It is possible to render an Adaptive Card with empty content but "aria-label" attribute. The Adaptive Cards JSON looks like:
 *
 * ```json
 * {
 *   "type": "AdaptiveCard",
 *   "speak": "Hello, World!",
 *   "body": [],
 *   "$schema": "http://adaptivecards.io/schemas/adaptive-card.json",
 *   "version": "1.5"
 * }
 * ```
 *
 * The HTML output will be:
 *
 * ```html
 * <div class="ac-adaptiveCard" aria-label="Hello, World!"></div>
 * ```
 *
 * This violates WAI-ARIA because "aria-label" must not be set on an element without a "role".
 *
 * We need to set "role" attribute to "form" if the card has any input fields and is valid as a "form" role, otherwise, "figure".
 */ function $b92199753d2c1eff$var$useRoleModEffect(adaptiveCard) {
    var modder = (0, $eO7Kz.useMemo)(function() {
        return function(_, cardElement) {
            return (0, $b92199753d2c1eff$var$_setOrRemoveAttributeIfFalseWithUndo.default)(cardElement, "role", cardElement.querySelector("button, input, select, textarea") && cardElement.getAttribute("aria-label") || cardElement.getAttribute("aria-labelledby") || cardElement.getAttribute("title") ? "form" : "figure");
        };
    }, []);
    return (0, $b92199753d2c1eff$var$_useAdaptiveCardModEffect.default)(modder, adaptiveCard);
}

});


parcelRequire.register("bwbgg", function(module, exports) {
"use strict";

var $luOtD = parcelRequire("luOtD");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $862b6b250f04872c$var$useParseAdaptiveCardJSON;

var $862b6b250f04872c$var$_slicedToArray2 = $luOtD((parcelRequire("fhBCP")));

var $fD7D4 = parcelRequire("fD7D4");

var $eO7Kz = parcelRequire("eO7Kz");

var $862b6b250f04872c$var$_useAdaptiveCardsPackage = $luOtD((parcelRequire("fdwbc")));

var $862b6b250f04872c$var$_useStyleOptions3 = $luOtD((parcelRequire("gwtqY")));
var $862b6b250f04872c$var$useDirection = $fD7D4.hooks.useDirection;
function $862b6b250f04872c$var$updateRTLInline(element, rtl, adaptiveCardsPackage) {
    if (element instanceof adaptiveCardsPackage.Container) element.rtl = rtl;
     // Tree traversal to add rtl boolean to child elements
    if (element.getItemAt && element.getItemCount) {
        var count = element.getItemCount();
        for(var index = 0; index < count; index++){
            var child = element.getItemAt(index);
            $862b6b250f04872c$var$updateRTLInline(child, rtl, adaptiveCardsPackage);
        }
    }
}
function $862b6b250f04872c$var$useParseAdaptiveCardJSON() {
    var _useAdaptiveCardsPack = (0, $862b6b250f04872c$var$_useAdaptiveCardsPackage.default)(), _useAdaptiveCardsPack2 = (0, $862b6b250f04872c$var$_slicedToArray2.default)(_useAdaptiveCardsPack, 1), adaptiveCardsPackage = _useAdaptiveCardsPack2[0];
    var _useDirection = $862b6b250f04872c$var$useDirection(), _useDirection2 = (0, $862b6b250f04872c$var$_slicedToArray2.default)(_useDirection, 1), direction = _useDirection2[0];
    var _useStyleOptions = (0, $862b6b250f04872c$var$_useStyleOptions3.default)(), _useStyleOptions2 = (0, $862b6b250f04872c$var$_slicedToArray2.default)(_useStyleOptions, 1), adaptiveCardsParserMaxVersion = _useStyleOptions2[0].adaptiveCardsParserMaxVersion;
    var AdaptiveCard = adaptiveCardsPackage.AdaptiveCard, SerializationContext = adaptiveCardsPackage.SerializationContext, Version = adaptiveCardsPackage.Version;
    var maxVersion = (0, $eO7Kz.useMemo)(function() {
        var maxVersion = Version.parse(adaptiveCardsParserMaxVersion, new SerializationContext());
        if (maxVersion && !maxVersion.isValid) {
            console.warn('botframework-webchat: "adaptiveCardsParserMaxVersion" specified is not a valid version.');
            return;
        }
        return maxVersion;
    }, [
        adaptiveCardsParserMaxVersion,
        SerializationContext,
        Version
    ]);
    return (0, $eO7Kz.useCallback)(function(content) {
        var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {}, _ref$ignoreErrors = _ref.ignoreErrors, ignoreErrors = _ref$ignoreErrors === void 0 ? false : _ref$ignoreErrors;
        if (!content) return;
        var card = new AdaptiveCard();
        var errors = [];
        var serializationContext = new SerializationContext(maxVersion);
        card.parse(content, serializationContext);
        var eventCount = serializationContext.eventCount;
        for(var i = 0; i < eventCount; i++)errors.push(serializationContext.getEventAt(i));
        if (!ignoreErrors && errors.length) {
            console.error("botframework-webchat: Failed to parse Adaptive Card", {
                errors: errors
            });
            throw new Error("botframework-webchat: Failed to parse Adaptive Card");
        }
        $862b6b250f04872c$var$updateRTLInline(card, direction === "rtl", adaptiveCardsPackage);
        return card;
    }, [
        AdaptiveCard,
        adaptiveCardsPackage,
        direction,
        maxVersion,
        SerializationContext
    ]);
}

});


parcelRequire.register("6PqZf", function(module, exports) {
"use strict";

var $luOtD = parcelRequire("luOtD");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4f8c708883ccc073$var$_slicedToArray2 = $luOtD((parcelRequire("fhBCP")));

var $fD7D4 = parcelRequire("fD7D4");

var $4f8c708883ccc073$var$_propTypes = $luOtD((parcelRequire("f7UXb")));

var $4f8c708883ccc073$var$_react = $luOtD((parcelRequire("eO7Kz")));

var $4f8c708883ccc073$var$_CommonCard = $luOtD((parcelRequire("6vkD7")));
/* eslint react/no-array-index-key: "off" */ var $4f8c708883ccc073$var$ImageContent = $fD7D4.Components.ImageContent, $4f8c708883ccc073$var$VideoContent = $fD7D4.Components.VideoContent;
var $4f8c708883ccc073$var$useStyleSet = $fD7D4.hooks.useStyleSet;
var $4f8c708883ccc073$var$AnimationCardContent = function AnimationCardContent(_ref) {
    var actionPerformedClassName = _ref.actionPerformedClassName, content = _ref.content, disabled = _ref.disabled;
    var _content$media = content.media, media = _content$media === void 0 ? [] : _content$media;
    var _useStyleSet = $4f8c708883ccc073$var$useStyleSet(), _useStyleSet2 = (0, $4f8c708883ccc073$var$_slicedToArray2.default)(_useStyleSet, 1), animationCardAttachmentStyleSet = _useStyleSet2[0].animationCardAttachment;
    return /*#__PURE__*/ $4f8c708883ccc073$var$_react.default.createElement("div", {
        className: animationCardAttachmentStyleSet
    }, /*#__PURE__*/ $4f8c708883ccc073$var$_react.default.createElement("ul", {
        className: "media-list"
    }, media.map(function(_ref2, index) {
        var _ref2$profile = _ref2.profile, profile = _ref2$profile === void 0 ? "" : _ref2$profile, url = _ref2.url;
        return /*#__PURE__*/ $4f8c708883ccc073$var$_react.default.createElement("li", {
            key: index
        }, /\.gif$/i.test(url) ? /*#__PURE__*/ $4f8c708883ccc073$var$_react.default.createElement($4f8c708883ccc073$var$ImageContent, {
            alt: profile,
            src: url
        }) : /*#__PURE__*/ $4f8c708883ccc073$var$_react.default.createElement($4f8c708883ccc073$var$VideoContent, {
            alt: profile,
            src: url
        }));
    })), /*#__PURE__*/ $4f8c708883ccc073$var$_react.default.createElement($4f8c708883ccc073$var$_CommonCard.default, {
        actionPerformedClassName: actionPerformedClassName,
        content: content,
        disabled: disabled
    }));
};
$4f8c708883ccc073$var$AnimationCardContent.defaultProps = {
    actionPerformedClassName: "",
    disabled: undefined
};
$4f8c708883ccc073$var$AnimationCardContent.propTypes = {
    actionPerformedClassName: $4f8c708883ccc073$var$_propTypes.default.string,
    // PropTypes cannot fully capture TypeScript types.
    // @ts-ignore
    content: $4f8c708883ccc073$var$_propTypes.default.shape({
        media: $4f8c708883ccc073$var$_propTypes.default.arrayOf($4f8c708883ccc073$var$_propTypes.default.shape({
            profile: $4f8c708883ccc073$var$_propTypes.default.string,
            url: $4f8c708883ccc073$var$_propTypes.default.string.isRequired
        })).isRequired
    }).isRequired,
    disabled: $4f8c708883ccc073$var$_propTypes.default.bool
};
var $4f8c708883ccc073$var$_default = $4f8c708883ccc073$var$AnimationCardContent;
module.exports.default = $4f8c708883ccc073$var$_default;

});
parcelRequire.register("6vkD7", function(module, exports) {
"use strict";

var $luOtD = parcelRequire("luOtD");

var $2PxO1 = parcelRequire("2PxO1");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4bc5a3fbdd40b762$var$_slicedToArray2 = $luOtD((parcelRequire("fhBCP")));

var $4bc5a3fbdd40b762$var$_propTypes = $luOtD((parcelRequire("f7UXb")));

var $4bc5a3fbdd40b762$var$_react = $4bc5a3fbdd40b762$var$_interopRequireWildcard((parcelRequire("eO7Kz")));

var $fD7D4 = parcelRequire("fD7D4");

var $4bc5a3fbdd40b762$var$_AdaptiveCardBuilder = $luOtD((parcelRequire("dUIqS")));

var $4bc5a3fbdd40b762$var$_AdaptiveCardRenderer = $luOtD((parcelRequire("7qmwG")));

var $4bc5a3fbdd40b762$var$_useAdaptiveCardsPackage = $luOtD((parcelRequire("fdwbc")));

var $4bc5a3fbdd40b762$var$_useStyleOptions3 = $luOtD((parcelRequire("gwtqY")));
function $4bc5a3fbdd40b762$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($4bc5a3fbdd40b762$var$_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $4bc5a3fbdd40b762$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || $2PxO1(obj) !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $4bc5a3fbdd40b762$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
var $4bc5a3fbdd40b762$var$useDirection = $fD7D4.hooks.useDirection;
var $4bc5a3fbdd40b762$var$CommonCard = function CommonCard(_ref) {
    var actionPerformedClassName = _ref.actionPerformedClassName, content = _ref.content, disabled = _ref.disabled;
    var _useAdaptiveCardsPack = (0, $4bc5a3fbdd40b762$var$_useAdaptiveCardsPackage.default)(), _useAdaptiveCardsPack2 = (0, $4bc5a3fbdd40b762$var$_slicedToArray2.default)(_useAdaptiveCardsPack, 1), adaptiveCardsPackage = _useAdaptiveCardsPack2[0];
    var _useDirection = $4bc5a3fbdd40b762$var$useDirection(), _useDirection2 = (0, $4bc5a3fbdd40b762$var$_slicedToArray2.default)(_useDirection, 1), direction = _useDirection2[0];
    var _useStyleOptions = (0, $4bc5a3fbdd40b762$var$_useStyleOptions3.default)(), _useStyleOptions2 = (0, $4bc5a3fbdd40b762$var$_slicedToArray2.default)(_useStyleOptions, 1), styleOptions = _useStyleOptions2[0];
    var builtCard = (0, $4bc5a3fbdd40b762$var$_react.useMemo)(function() {
        if (content) {
            var builder = new $4bc5a3fbdd40b762$var$_AdaptiveCardBuilder.default(adaptiveCardsPackage, styleOptions, direction);
            builder.addCommon(content);
            return builder.card;
        }
    }, [
        adaptiveCardsPackage,
        content,
        direction,
        styleOptions
    ]);
    return /*#__PURE__*/ $4bc5a3fbdd40b762$var$_react.default.createElement($4bc5a3fbdd40b762$var$_AdaptiveCardRenderer.default, {
        actionPerformedClassName: actionPerformedClassName,
        adaptiveCard: builtCard,
        disabled: disabled,
        tapAction: content && content.tap
    });
};
$4bc5a3fbdd40b762$var$CommonCard.defaultProps = {
    actionPerformedClassName: "",
    disabled: undefined
};
$4bc5a3fbdd40b762$var$CommonCard.propTypes = {
    actionPerformedClassName: $4bc5a3fbdd40b762$var$_propTypes.default.string,
    content: $4bc5a3fbdd40b762$var$_propTypes.default.shape({
        tap: $4bc5a3fbdd40b762$var$_propTypes.default.any
    }).isRequired,
    disabled: $4bc5a3fbdd40b762$var$_propTypes.default.bool
};
var $4bc5a3fbdd40b762$var$_default = $4bc5a3fbdd40b762$var$CommonCard;
module.exports.default = $4bc5a3fbdd40b762$var$_default;

});
parcelRequire.register("dUIqS", function(module, exports) {
"use strict";

var $luOtD = parcelRequire("luOtD");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a212f8b2e5ae806c$var$_classCallCheck2 = $luOtD((parcelRequire("hYNAh")));

var $a212f8b2e5ae806c$var$_createClass2 = $luOtD((parcelRequire("8Eu5W")));

var $a212f8b2e5ae806c$var$_defineProperty2 = $luOtD((parcelRequire("3w8Sv")));

var $gqJaI = parcelRequire("gqJaI");

var $cG9B9 = parcelRequire("cG9B9");
function $a212f8b2e5ae806c$var$addCardAction(cardAction, includesOAuthButtons) {
    var type = cardAction.type;
    var action;
    if (type === "imBack" || type === "messageBack" || type === "postBack" || type === "signin" && includesOAuthButtons) {
        action = new $gqJaI.SubmitAction();
        action.data = {
            __isBotFrameworkCardAction: true,
            cardAction: cardAction
        };
        action.title = cardAction.title;
    } else {
        action = new $gqJaI.OpenUrlAction();
        action.title = cardAction.title;
        action.url = cardAction.type === "call" ? "tel:".concat(cardAction.value) : cardAction.value;
    }
    return action;
}
var $a212f8b2e5ae806c$var$AdaptiveCardBuilder = /*#__PURE__*/ function() {
    function AdaptiveCardBuilder(adaptiveCards, styleOptions) {
        var direction = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "ltr";
        (0, $a212f8b2e5ae806c$var$_classCallCheck2.default)(this, AdaptiveCardBuilder);
        (0, $a212f8b2e5ae806c$var$_defineProperty2.default)(this, "card", void 0);
        (0, $a212f8b2e5ae806c$var$_defineProperty2.default)(this, "container", void 0);
        (0, $a212f8b2e5ae806c$var$_defineProperty2.default)(this, "styleOptions", void 0);
        this.card = new adaptiveCards.AdaptiveCard();
        this.container = new $gqJaI.Container();
        this.container.rtl = direction === "rtl";
        this.styleOptions = styleOptions;
        this.card.addItem(this.container);
    }
    (0, $a212f8b2e5ae806c$var$_createClass2.default)(AdaptiveCardBuilder, [
        {
            key: "addColumnSet",
            value: function addColumnSet(sizes) {
                var container = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.container;
                var selectAction = arguments.length > 2 ? arguments[2] : undefined;
                var columnSet = new $gqJaI.ColumnSet();
                columnSet.selectAction = selectAction && $a212f8b2e5ae806c$var$addCardAction(selectAction);
                container.addItem(columnSet);
                return sizes.map(function(size) {
                    var column = new $gqJaI.Column();
                    column.width = new $gqJaI.SizeAndUnit(size, $gqJaI.SizeUnit.Weight);
                    columnSet.addColumn(column);
                    return column;
                });
            }
        },
        {
            key: "addItems",
            value: function addItems(cardElements) {
                var container = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.container;
                cardElements.forEach(function(cardElement) {
                    return container.addItem(cardElement);
                });
            }
        },
        {
            key: "addTextBlock",
            value: function addTextBlock(text, template) {
                var container = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : this.container;
                if (typeof text !== "undefined") {
                    var textblock = new $gqJaI.TextBlock();
                    for(var prop in template)if (!(0, $cG9B9.isForbiddenPropertyName)(prop)) // Mitigated through denylisting.
                    // eslint-disable-next-line security/detect-object-injection
                    textblock[prop] = template[prop];
                    textblock.text = text;
                    container.addItem(textblock);
                }
            }
        },
        {
            key: "addButtons",
            value: function addButtons(cardActions, includesOAuthButtons) {
                var _this = this;
                cardActions && cardActions.forEach(function(cardAction) {
                    _this.card.addAction($a212f8b2e5ae806c$var$addCardAction(cardAction, includesOAuthButtons));
                });
            }
        },
        {
            key: "addCommonHeaders",
            value: function addCommonHeaders(content) {
                var richCardWrapTitle = this.styleOptions.richCardWrapTitle;
                this.addTextBlock(content.title, {
                    color: $gqJaI.TextColor.Default,
                    size: $gqJaI.TextSize.Medium,
                    style: "heading",
                    weight: $gqJaI.TextWeight.Bolder,
                    wrap: richCardWrapTitle
                });
                this.addTextBlock(content.subtitle, {
                    color: $gqJaI.TextColor.Default,
                    isSubtle: true,
                    wrap: richCardWrapTitle
                });
                this.addTextBlock(content.text, {
                    color: $gqJaI.TextColor.Default,
                    wrap: true
                });
            }
        },
        {
            key: "addCommon",
            value: function addCommon(content) {
                this.addCommonHeaders(content);
                this.addButtons(content.buttons);
            }
        },
        {
            key: "addImage",
            value: function addImage(url, container, selectAction, altText) {
                container = container || this.container;
                var image = new $gqJaI.Image();
                image.altText = altText;
                image.url = url;
                image.selectAction = selectAction && $a212f8b2e5ae806c$var$addCardAction(selectAction);
                image.size = $gqJaI.Size.Stretch;
                container.addItem(image);
            }
        }
    ]);
    return AdaptiveCardBuilder;
}();
module.exports.default = $a212f8b2e5ae806c$var$AdaptiveCardBuilder;

});
parcelRequire.register("gqJaI", function(module, exports) {
"use strict";
var $bf621d3b5a91bc39$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $bf621d3b5a91bc39$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) $bf621d3b5a91bc39$var$__createBinding(exports, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.
$bf621d3b5a91bc39$var$__exportStar((parcelRequire("brsVB")), module.exports);

$bf621d3b5a91bc39$var$__exportStar((parcelRequire("iw5eI")), module.exports);

$bf621d3b5a91bc39$var$__exportStar((parcelRequire("eUh3g")), module.exports);

$bf621d3b5a91bc39$var$__exportStar((parcelRequire("ioYal")), module.exports);

$bf621d3b5a91bc39$var$__exportStar((parcelRequire("ldzOp")), module.exports);

$bf621d3b5a91bc39$var$__exportStar((parcelRequire("35a5S")), module.exports);

$bf621d3b5a91bc39$var$__exportStar((parcelRequire("4IoSX")), module.exports);

$bf621d3b5a91bc39$var$__exportStar((parcelRequire("J4wUi")), module.exports);

$bf621d3b5a91bc39$var$__exportStar((parcelRequire("j1Jxg")), module.exports);

$bf621d3b5a91bc39$var$__exportStar((parcelRequire("3K4s0")), module.exports);

$bf621d3b5a91bc39$var$__exportStar((parcelRequire("8Cbbq")), module.exports);

$bf621d3b5a91bc39$var$__exportStar((parcelRequire("eL6J6")), module.exports);

$bf621d3b5a91bc39$var$__exportStar((parcelRequire("g3v9p")), module.exports);

$bf621d3b5a91bc39$var$__exportStar((parcelRequire("1PnIQ")), module.exports);

});
parcelRequire.register("brsVB", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Strings = void 0;
// eslint-disable-next-line @typescript-eslint/no-extraneous-class
var $8548a7d791cc48a3$var$Strings = /** @class */ function() {
    function Strings() {}
    Strings.errors = {
        unknownElementType: function(typeName) {
            return 'Unknown element type "'.concat(typeName, '". Fallback will be used if present.');
        },
        unknownActionType: function(typeName) {
            return 'Unknown action type "'.concat(typeName, '". Fallback will be used if present.');
        },
        elementTypeNotAllowed: function(typeName) {
            return 'Element type "'.concat(typeName, '" is not allowed in this context.');
        },
        actionTypeNotAllowed: function(typeName) {
            return 'Action type "'.concat(typeName, '" is not allowed in this context.');
        },
        invalidPropertyValue: function(value, propertyName) {
            return 'Invalid value "'.concat(value, '" for property "').concat(propertyName, '".');
        },
        showCardMustHaveCard: function() {
            return '"An Action.ShowCard must have its "card" property set to a valid AdaptiveCard object.';
        },
        invalidColumnWidth: function(invalidWidth) {
            return 'Invalid column width "'.concat(invalidWidth, '" - defaulting to "auto".');
        },
        invalidCardVersion: function(defaultingToVersion) {
            return 'Invalid card version. Defaulting to "'.concat(defaultingToVersion, '".');
        },
        invalidVersionString: function(versionString) {
            return 'Invalid version string "'.concat(versionString, '".');
        },
        propertyValueNotSupported: function(value, propertyName, supportedInVersion, versionUsed) {
            return 'Value "'.concat(value, '" for property "').concat(propertyName, '" is supported in version ').concat(supportedInVersion, ", but you are using version ").concat(versionUsed, ".");
        },
        propertyNotSupported: function(propertyName, supportedInVersion, versionUsed) {
            return 'Property "'.concat(propertyName, '" is supported in version ').concat(supportedInVersion, ", but you are using version ").concat(versionUsed, ".");
        },
        indexOutOfRange: function(index) {
            return "Index out of range (".concat(index, ").");
        },
        elementCannotBeUsedAsInline: function() {
            return "RichTextBlock.addInline: the specified card element cannot be used as a RichTextBlock inline.";
        },
        inlineAlreadyParented: function() {
            return "RichTextBlock.addInline: the specified inline already belongs to another RichTextBlock.";
        },
        interactivityNotAllowed: function() {
            return "Interactivity is not allowed.";
        },
        inputsMustHaveUniqueId: function() {
            return "All inputs must have a unique Id.";
        },
        choiceSetMustHaveAtLeastOneChoice: function() {
            return "An Input.ChoiceSet must have at least one choice defined.";
        },
        choiceSetChoicesMustHaveTitleAndValue: function() {
            return "All choices in an Input.ChoiceSet must have their title and value properties set.";
        },
        propertyMustBeSet: function(propertyName) {
            return 'Property "'.concat(propertyName, '" must be set.');
        },
        actionHttpHeadersMustHaveNameAndValue: function() {
            return "All headers of an Action.Http must have their name and value properties set.";
        },
        tooManyActions: function(maximumActions) {
            return "Maximum number of actions exceeded (".concat(maximumActions, ").");
        },
        tooLittleTimeDelay: function(minAutoplayDelay) {
            return "Autoplay Delay is too short (".concat(minAutoplayDelay, ").");
        },
        columnAlreadyBelongsToAnotherSet: function() {
            return "This column already belongs to another ColumnSet.";
        },
        invalidCardType: function() {
            return 'Invalid or missing card type. Make sure the card\'s type property is set to "AdaptiveCard".';
        },
        unsupportedCardVersion: function(version, maxSupportedVersion) {
            return "The specified card version (".concat(version, ") is not supported or still in preview. The latest released card version is ").concat(maxSupportedVersion, ".");
        },
        duplicateId: function(id) {
            return 'Duplicate Id "'.concat(id, '".');
        },
        markdownProcessingNotEnabled: function() {
            return "Markdown processing isn't enabled. Please see https://www.npmjs.com/package/adaptivecards#supporting-markdown";
        },
        processMarkdownEventRemoved: function() {
            return "The processMarkdown event has been removed. Please update your code and set onProcessMarkdown instead.";
        },
        elementAlreadyParented: function() {
            return "The element already belongs to another container.";
        },
        actionAlreadyParented: function() {
            return "The action already belongs to another element.";
        },
        elementTypeNotStandalone: function(typeName) {
            return "Elements of type ".concat(typeName, " cannot be used as standalone elements.");
        }
    };
    Strings.magicCodeInputCard = {
        tryAgain: function() {
            return "That didn't work... let's try again.";
        },
        pleaseLogin: function() {
            return 'Please login in the popup. You will obtain a magic code. Paste that code below and select "Submit"';
        },
        enterMagicCode: function() {
            return "Enter magic code";
        },
        pleaseEnterMagicCodeYouReceived: function() {
            return "Please enter the magic code you received.";
        },
        submit: function() {
            return "Submit";
        },
        cancel: function() {
            return "Cancel";
        },
        somethingWentWrong: function() {
            return "Something went wrong. This action can't be handled.";
        },
        authenticationFailed: function() {
            return "Authentication failed.";
        }
    };
    Strings.runtime = {
        automaticRefreshPaused: function() {
            return "Automatic refresh paused.";
        },
        clckToRestartAutomaticRefresh: function() {
            return "Click to restart.";
        },
        refreshThisCard: function() {
            return "Refresh this card";
        }
    };
    Strings.hints = {
        dontUseWeightedAndStrecthedColumnsInSameSet: function() {
            return "It is not recommended to use weighted and stretched columns in the same ColumnSet, because in such a situation stretched columns will always get the minimum amount of space.";
        }
    };
    Strings.defaults = {
        inlineActionTitle: function() {
            return "Inline Action";
        },
        overflowButtonText: function() {
            return "...";
        },
        mediaPlayerAriaLabel: function() {
            return "Media content";
        },
        mediaPlayerPlayMedia: function() {
            return "Play media";
        },
        youTubeVideoPlayer: function() {
            return "YouTube video player";
        },
        vimeoVideoPlayer: function() {
            return "Vimeo video player";
        },
        dailymotionVideoPlayer: function() {
            return "Dailymotion video player";
        }
    };
    return Strings;
}();
module.exports.Strings = $8548a7d791cc48a3$var$Strings;

});

parcelRequire.register("iw5eI", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LogLevel = module.exports.RefreshMode = module.exports.TypeErrorType = module.exports.ContainerFitStatus = module.exports.ValidationEvent = module.exports.ValidationPhase = module.exports.InputTextStyle = module.exports.ActionIconPlacement = module.exports.FillMode = module.exports.Orientation = module.exports.ShowCardActionMode = module.exports.ImageStyle = module.exports.ActionAlignment = module.exports.VerticalAlignment = module.exports.HorizontalAlignment = module.exports.TextColor = module.exports.Spacing = module.exports.FontType = module.exports.TextWeight = module.exports.TextSize = module.exports.SizeUnit = module.exports.ImageSize = module.exports.Size = module.exports.ActionMode = module.exports.ActionStyle = module.exports.ContainerStyle = void 0;
/*
    This should really be a string enum, e.g.

        export enum ContainerStyle {
            Default = "default",
            Emphasis = "emphasis"
        }

    However, some hosts do not use a version of TypeScript
    recent enough to understand string enums. This is
    a compatible construct that does not require using
    a more recent version of TypeScript.

    Also note the "weird" way these readonly fields are declared is to work around
    a breaking change introduced in TS 3.1 wrt d.ts generation. DO NOT CHANGE
    and adopt this syntax for all other static readonly fields.
*/ /* eslint-disable @typescript-eslint/no-extraneous-class, @typescript-eslint/naming-convention */ var $d7af46f8dcb7006b$var$ContainerStyle = /** @class */ function() {
    function ContainerStyle() {}
    ContainerStyle.Default = "default";
    ContainerStyle.Emphasis = "emphasis";
    ContainerStyle.Accent = "accent";
    ContainerStyle.Good = "good";
    ContainerStyle.Attention = "attention";
    ContainerStyle.Warning = "warning";
    return ContainerStyle;
}();
module.exports.ContainerStyle = $d7af46f8dcb7006b$var$ContainerStyle;
var $d7af46f8dcb7006b$var$ActionStyle = /** @class */ function() {
    function ActionStyle() {}
    ActionStyle.Default = "default";
    ActionStyle.Positive = "positive";
    ActionStyle.Destructive = "destructive";
    return ActionStyle;
}();
module.exports.ActionStyle = $d7af46f8dcb7006b$var$ActionStyle;
var $d7af46f8dcb7006b$var$ActionMode = /** @class */ function() {
    function ActionMode() {}
    ActionMode.Primary = "primary";
    ActionMode.Secondary = "secondary";
    return ActionMode;
}();
module.exports.ActionMode = $d7af46f8dcb7006b$var$ActionMode;
/* eslint-enable @typescript-eslint/no-extraneous-class, @typescript-eslint/naming-convention */ var $d7af46f8dcb7006b$var$Size;
(function(Size) {
    Size[Size["Auto"] = 0] = "Auto";
    Size[Size["Stretch"] = 1] = "Stretch";
    Size[Size["Small"] = 2] = "Small";
    Size[Size["Medium"] = 3] = "Medium";
    Size[Size["Large"] = 4] = "Large";
})($d7af46f8dcb7006b$var$Size = module.exports.Size || (module.exports.Size = {}));
var $d7af46f8dcb7006b$var$ImageSize;
(function(ImageSize) {
    ImageSize[ImageSize["Small"] = 0] = "Small";
    ImageSize[ImageSize["Medium"] = 1] = "Medium";
    ImageSize[ImageSize["Large"] = 2] = "Large";
})($d7af46f8dcb7006b$var$ImageSize = module.exports.ImageSize || (module.exports.ImageSize = {}));
var $d7af46f8dcb7006b$var$SizeUnit;
(function(SizeUnit) {
    SizeUnit[SizeUnit["Weight"] = 0] = "Weight";
    SizeUnit[SizeUnit["Pixel"] = 1] = "Pixel";
})($d7af46f8dcb7006b$var$SizeUnit = module.exports.SizeUnit || (module.exports.SizeUnit = {}));
var $d7af46f8dcb7006b$var$TextSize;
(function(TextSize) {
    TextSize[TextSize["Small"] = 0] = "Small";
    TextSize[TextSize["Default"] = 1] = "Default";
    TextSize[TextSize["Medium"] = 2] = "Medium";
    TextSize[TextSize["Large"] = 3] = "Large";
    TextSize[TextSize["ExtraLarge"] = 4] = "ExtraLarge";
})($d7af46f8dcb7006b$var$TextSize = module.exports.TextSize || (module.exports.TextSize = {}));
var $d7af46f8dcb7006b$var$TextWeight;
(function(TextWeight) {
    TextWeight[TextWeight["Lighter"] = 0] = "Lighter";
    TextWeight[TextWeight["Default"] = 1] = "Default";
    TextWeight[TextWeight["Bolder"] = 2] = "Bolder";
})($d7af46f8dcb7006b$var$TextWeight = module.exports.TextWeight || (module.exports.TextWeight = {}));
var $d7af46f8dcb7006b$var$FontType;
(function(FontType) {
    FontType[FontType["Default"] = 0] = "Default";
    FontType[FontType["Monospace"] = 1] = "Monospace";
})($d7af46f8dcb7006b$var$FontType = module.exports.FontType || (module.exports.FontType = {}));
var $d7af46f8dcb7006b$var$Spacing;
(function(Spacing) {
    Spacing[Spacing["None"] = 0] = "None";
    Spacing[Spacing["Small"] = 1] = "Small";
    Spacing[Spacing["Default"] = 2] = "Default";
    Spacing[Spacing["Medium"] = 3] = "Medium";
    Spacing[Spacing["Large"] = 4] = "Large";
    Spacing[Spacing["ExtraLarge"] = 5] = "ExtraLarge";
    Spacing[Spacing["Padding"] = 6] = "Padding";
})($d7af46f8dcb7006b$var$Spacing = module.exports.Spacing || (module.exports.Spacing = {}));
var $d7af46f8dcb7006b$var$TextColor;
(function(TextColor) {
    TextColor[TextColor["Default"] = 0] = "Default";
    TextColor[TextColor["Dark"] = 1] = "Dark";
    TextColor[TextColor["Light"] = 2] = "Light";
    TextColor[TextColor["Accent"] = 3] = "Accent";
    TextColor[TextColor["Good"] = 4] = "Good";
    TextColor[TextColor["Warning"] = 5] = "Warning";
    TextColor[TextColor["Attention"] = 6] = "Attention";
})($d7af46f8dcb7006b$var$TextColor = module.exports.TextColor || (module.exports.TextColor = {}));
var $d7af46f8dcb7006b$var$HorizontalAlignment;
(function(HorizontalAlignment) {
    HorizontalAlignment[HorizontalAlignment["Left"] = 0] = "Left";
    HorizontalAlignment[HorizontalAlignment["Center"] = 1] = "Center";
    HorizontalAlignment[HorizontalAlignment["Right"] = 2] = "Right";
})($d7af46f8dcb7006b$var$HorizontalAlignment = module.exports.HorizontalAlignment || (module.exports.HorizontalAlignment = {}));
var $d7af46f8dcb7006b$var$VerticalAlignment;
(function(VerticalAlignment) {
    VerticalAlignment[VerticalAlignment["Top"] = 0] = "Top";
    VerticalAlignment[VerticalAlignment["Center"] = 1] = "Center";
    VerticalAlignment[VerticalAlignment["Bottom"] = 2] = "Bottom";
})($d7af46f8dcb7006b$var$VerticalAlignment = module.exports.VerticalAlignment || (module.exports.VerticalAlignment = {}));
var $d7af46f8dcb7006b$var$ActionAlignment;
(function(ActionAlignment) {
    ActionAlignment[ActionAlignment["Left"] = 0] = "Left";
    ActionAlignment[ActionAlignment["Center"] = 1] = "Center";
    ActionAlignment[ActionAlignment["Right"] = 2] = "Right";
    ActionAlignment[ActionAlignment["Stretch"] = 3] = "Stretch";
})($d7af46f8dcb7006b$var$ActionAlignment = module.exports.ActionAlignment || (module.exports.ActionAlignment = {}));
var $d7af46f8dcb7006b$var$ImageStyle;
(function(ImageStyle) {
    ImageStyle[ImageStyle["Default"] = 0] = "Default";
    ImageStyle[ImageStyle["Person"] = 1] = "Person";
})($d7af46f8dcb7006b$var$ImageStyle = module.exports.ImageStyle || (module.exports.ImageStyle = {}));
var $d7af46f8dcb7006b$var$ShowCardActionMode;
(function(ShowCardActionMode) {
    ShowCardActionMode[ShowCardActionMode["Inline"] = 0] = "Inline";
    ShowCardActionMode[ShowCardActionMode["Popup"] = 1] = "Popup";
})($d7af46f8dcb7006b$var$ShowCardActionMode = module.exports.ShowCardActionMode || (module.exports.ShowCardActionMode = {}));
var $d7af46f8dcb7006b$var$Orientation;
(function(Orientation) {
    Orientation[Orientation["Horizontal"] = 0] = "Horizontal";
    Orientation[Orientation["Vertical"] = 1] = "Vertical";
})($d7af46f8dcb7006b$var$Orientation = module.exports.Orientation || (module.exports.Orientation = {}));
var $d7af46f8dcb7006b$var$FillMode;
(function(FillMode) {
    FillMode[FillMode["Cover"] = 0] = "Cover";
    FillMode[FillMode["RepeatHorizontally"] = 1] = "RepeatHorizontally";
    FillMode[FillMode["RepeatVertically"] = 2] = "RepeatVertically";
    FillMode[FillMode["Repeat"] = 3] = "Repeat";
})($d7af46f8dcb7006b$var$FillMode = module.exports.FillMode || (module.exports.FillMode = {}));
var $d7af46f8dcb7006b$var$ActionIconPlacement;
(function(ActionIconPlacement) {
    ActionIconPlacement[ActionIconPlacement["LeftOfTitle"] = 0] = "LeftOfTitle";
    ActionIconPlacement[ActionIconPlacement["AboveTitle"] = 1] = "AboveTitle";
})($d7af46f8dcb7006b$var$ActionIconPlacement = module.exports.ActionIconPlacement || (module.exports.ActionIconPlacement = {}));
var $d7af46f8dcb7006b$var$InputTextStyle;
(function(InputTextStyle) {
    InputTextStyle[InputTextStyle["Text"] = 0] = "Text";
    InputTextStyle[InputTextStyle["Tel"] = 1] = "Tel";
    InputTextStyle[InputTextStyle["Url"] = 2] = "Url";
    InputTextStyle[InputTextStyle["Email"] = 3] = "Email";
    InputTextStyle[InputTextStyle["Password"] = 4] = "Password";
})($d7af46f8dcb7006b$var$InputTextStyle = module.exports.InputTextStyle || (module.exports.InputTextStyle = {}));
var $d7af46f8dcb7006b$var$ValidationPhase;
(function(ValidationPhase) {
    ValidationPhase[ValidationPhase["Parse"] = 0] = "Parse";
    ValidationPhase[ValidationPhase["ToJSON"] = 1] = "ToJSON";
    ValidationPhase[ValidationPhase["Validation"] = 2] = "Validation";
})($d7af46f8dcb7006b$var$ValidationPhase = module.exports.ValidationPhase || (module.exports.ValidationPhase = {}));
var $d7af46f8dcb7006b$var$ValidationEvent;
(function(ValidationEvent) {
    ValidationEvent[ValidationEvent["Hint"] = 0] = "Hint";
    ValidationEvent[ValidationEvent["ActionTypeNotAllowed"] = 1] = "ActionTypeNotAllowed";
    ValidationEvent[ValidationEvent["CollectionCantBeEmpty"] = 2] = "CollectionCantBeEmpty";
    ValidationEvent[ValidationEvent["Deprecated"] = 3] = "Deprecated";
    ValidationEvent[ValidationEvent["ElementTypeNotAllowed"] = 4] = "ElementTypeNotAllowed";
    ValidationEvent[ValidationEvent["InteractivityNotAllowed"] = 5] = "InteractivityNotAllowed";
    ValidationEvent[ValidationEvent["InvalidPropertyValue"] = 6] = "InvalidPropertyValue";
    ValidationEvent[ValidationEvent["MissingCardType"] = 7] = "MissingCardType";
    ValidationEvent[ValidationEvent["PropertyCantBeNull"] = 8] = "PropertyCantBeNull";
    ValidationEvent[ValidationEvent["TooManyActions"] = 9] = "TooManyActions";
    ValidationEvent[ValidationEvent["UnknownActionType"] = 10] = "UnknownActionType";
    ValidationEvent[ValidationEvent["UnknownElementType"] = 11] = "UnknownElementType";
    ValidationEvent[ValidationEvent["UnsupportedCardVersion"] = 12] = "UnsupportedCardVersion";
    ValidationEvent[ValidationEvent["DuplicateId"] = 13] = "DuplicateId";
    ValidationEvent[ValidationEvent["UnsupportedProperty"] = 14] = "UnsupportedProperty";
    ValidationEvent[ValidationEvent["RequiredInputsShouldHaveLabel"] = 15] = "RequiredInputsShouldHaveLabel";
    ValidationEvent[ValidationEvent["RequiredInputsShouldHaveErrorMessage"] = 16] = "RequiredInputsShouldHaveErrorMessage";
    ValidationEvent[ValidationEvent["Other"] = 17] = "Other";
})($d7af46f8dcb7006b$var$ValidationEvent = module.exports.ValidationEvent || (module.exports.ValidationEvent = {}));
var $d7af46f8dcb7006b$var$ContainerFitStatus;
(function(ContainerFitStatus) {
    ContainerFitStatus[ContainerFitStatus["FullyInContainer"] = 0] = "FullyInContainer";
    ContainerFitStatus[ContainerFitStatus["Overflowing"] = 1] = "Overflowing";
    ContainerFitStatus[ContainerFitStatus["FullyOutOfContainer"] = 2] = "FullyOutOfContainer";
})($d7af46f8dcb7006b$var$ContainerFitStatus = module.exports.ContainerFitStatus || (module.exports.ContainerFitStatus = {}));
var $d7af46f8dcb7006b$var$TypeErrorType;
(function(TypeErrorType) {
    TypeErrorType[TypeErrorType["UnknownType"] = 0] = "UnknownType";
    TypeErrorType[TypeErrorType["ForbiddenType"] = 1] = "ForbiddenType";
})($d7af46f8dcb7006b$var$TypeErrorType = module.exports.TypeErrorType || (module.exports.TypeErrorType = {}));
var $d7af46f8dcb7006b$var$RefreshMode;
(function(RefreshMode) {
    RefreshMode[RefreshMode["Disabled"] = 0] = "Disabled";
    RefreshMode[RefreshMode["Manual"] = 1] = "Manual";
    RefreshMode[RefreshMode["Automatic"] = 2] = "Automatic";
})($d7af46f8dcb7006b$var$RefreshMode = module.exports.RefreshMode || (module.exports.RefreshMode = {}));
var $d7af46f8dcb7006b$var$LogLevel;
(function(LogLevel) {
    LogLevel[LogLevel["Info"] = 0] = "Info";
    LogLevel[LogLevel["Warning"] = 1] = "Warning";
    LogLevel[LogLevel["Error"] = 2] = "Error";
})($d7af46f8dcb7006b$var$LogLevel = module.exports.LogLevel || (module.exports.LogLevel = {}));

});

parcelRequire.register("eUh3g", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.UUID = module.exports.SizeAndUnit = module.exports.PaddingDefinition = module.exports.SpacingDefinition = module.exports.StringWithSubstitutions = module.exports.ContentTypes = module.exports.GlobalSettings = void 0;

var $iw5eI = parcelRequire("iw5eI");
// eslint-disable-next-line @typescript-eslint/no-extraneous-class
var $ada385c31f4f9af6$var$GlobalSettings = /** @class */ function() {
    function GlobalSettings() {}
    GlobalSettings.useAdvancedTextBlockTruncation = true;
    GlobalSettings.useAdvancedCardBottomTruncation = false;
    GlobalSettings.useMarkdownInRadioButtonAndCheckbox = true;
    GlobalSettings.allowMarkForTextHighlighting = false;
    GlobalSettings.alwaysBleedSeparators = false;
    GlobalSettings.enableFullJsonRoundTrip = false;
    GlobalSettings.displayInputValidationErrors = true;
    GlobalSettings.allowPreProcessingPropertyValues = false;
    GlobalSettings.setTabIndexAtCardRoot = true;
    GlobalSettings.enableFallback = true;
    GlobalSettings.useWebkitLineClamp = true;
    GlobalSettings.allowMoreThanMaxActionsInOverflowMenu = false;
    GlobalSettings.removePaddingFromContainersWithBackgroundImage = false;
    GlobalSettings.resetInputsDirtyStateAfterActionExecution = true;
    GlobalSettings.applets = {
        logEnabled: true,
        logLevel: $iw5eI.LogLevel.Error,
        maximumRetryAttempts: 3,
        defaultTimeBetweenRetryAttempts: 3000,
        authPromptWidth: 400,
        authPromptHeight: 600,
        refresh: {
            mode: $iw5eI.RefreshMode.Manual,
            timeBetweenAutomaticRefreshes: 3000,
            maximumConsecutiveAutomaticRefreshes: 3,
            allowManualRefreshesAfterAutomaticRefreshes: true
        }
    };
    return GlobalSettings;
}();
module.exports.GlobalSettings = $ada385c31f4f9af6$var$GlobalSettings;
module.exports.ContentTypes = {
    applicationJson: "application/json",
    applicationXWwwFormUrlencoded: "application/x-www-form-urlencoded"
};
var $ada385c31f4f9af6$var$StringWithSubstitutions = /** @class */ function() {
    function StringWithSubstitutions() {
        this._isProcessed = false;
    }
    StringWithSubstitutions.prototype.getReferencedInputs = function(inputs, referencedInputs) {
        if (!referencedInputs) throw new Error("The referencedInputs parameter cannot be null.");
        if (this._original) for(var _i = 0, inputs_1 = inputs; _i < inputs_1.length; _i++){
            var input = inputs_1[_i];
            var matches = new RegExp("\\{{2}(" + input.id + ").value\\}{2}", "gi").exec(this._original);
            if (matches != null && input.id) referencedInputs[input.id] = input;
        }
    };
    StringWithSubstitutions.prototype.substituteInputValues = function(inputs, contentType) {
        this._processed = this._original;
        if (this._original) {
            var regEx = /\{{2}([a-z0-9_$@]+).value\}{2}/gi;
            var matches = void 0;
            while((matches = regEx.exec(this._original)) !== null && this._processed)for(var _i = 0, _a = Object.keys(inputs); _i < _a.length; _i++){
                var key = _a[_i];
                if (key.toLowerCase() === matches[1].toLowerCase()) {
                    var matchedInput = inputs[key];
                    var valueForReplace = "";
                    if (matchedInput.value) valueForReplace = matchedInput.value;
                    if (contentType === module.exports.ContentTypes.applicationJson) {
                        valueForReplace = JSON.stringify(valueForReplace);
                        valueForReplace = valueForReplace.slice(1, -1);
                    } else if (contentType === module.exports.ContentTypes.applicationXWwwFormUrlencoded) valueForReplace = encodeURIComponent(valueForReplace);
                    this._processed = this._processed.replace(matches[0], valueForReplace);
                    break;
                }
            }
        }
        this._isProcessed = true;
    };
    StringWithSubstitutions.prototype.getOriginal = function() {
        return this._original;
    };
    StringWithSubstitutions.prototype.get = function() {
        if (!this._isProcessed) return this._original;
        else return this._processed;
    };
    StringWithSubstitutions.prototype.set = function(value) {
        this._original = value;
        this._isProcessed = false;
    };
    return StringWithSubstitutions;
}();
module.exports.StringWithSubstitutions = $ada385c31f4f9af6$var$StringWithSubstitutions;
var $ada385c31f4f9af6$var$SpacingDefinition = /** @class */ function() {
    function SpacingDefinition(top, right, bottom, left) {
        if (top === void 0) top = 0;
        if (right === void 0) right = 0;
        if (bottom === void 0) bottom = 0;
        if (left === void 0) left = 0;
        this.left = 0;
        this.top = 0;
        this.right = 0;
        this.bottom = 0;
        this.top = top;
        this.right = right;
        this.bottom = bottom;
        this.left = left;
    }
    return SpacingDefinition;
}();
module.exports.SpacingDefinition = $ada385c31f4f9af6$var$SpacingDefinition;
var $ada385c31f4f9af6$var$PaddingDefinition = /** @class */ function() {
    function PaddingDefinition(top, right, bottom, left) {
        if (top === void 0) top = $iw5eI.Spacing.None;
        if (right === void 0) right = $iw5eI.Spacing.None;
        if (bottom === void 0) bottom = $iw5eI.Spacing.None;
        if (left === void 0) left = $iw5eI.Spacing.None;
        this.top = $iw5eI.Spacing.None;
        this.right = $iw5eI.Spacing.None;
        this.bottom = $iw5eI.Spacing.None;
        this.left = $iw5eI.Spacing.None;
        this.top = top;
        this.right = right;
        this.bottom = bottom;
        this.left = left;
    }
    return PaddingDefinition;
}();
module.exports.PaddingDefinition = $ada385c31f4f9af6$var$PaddingDefinition;
var $ada385c31f4f9af6$var$SizeAndUnit = /** @class */ function() {
    function SizeAndUnit(physicalSize, unit) {
        this.physicalSize = physicalSize;
        this.unit = unit;
    }
    SizeAndUnit.parse = function(input, requireUnitSpecifier) {
        if (requireUnitSpecifier === void 0) requireUnitSpecifier = false;
        var result = new SizeAndUnit(0, $iw5eI.SizeUnit.Weight);
        if (typeof input === "number") {
            result.physicalSize = input;
            return result;
        } else if (typeof input === "string") {
            var regExp = /^([0-9]+)(px|\*)?$/g;
            var matches = regExp.exec(input);
            var expectedMatchCount = requireUnitSpecifier ? 3 : 2;
            if (matches && matches.length >= expectedMatchCount) {
                result.physicalSize = parseInt(matches[1]);
                if (matches.length === 3) {
                    if (matches[2] === "px") result.unit = $iw5eI.SizeUnit.Pixel;
                }
                return result;
            }
        }
        throw new Error("Invalid size: " + input);
    };
    return SizeAndUnit;
}();
module.exports.SizeAndUnit = $ada385c31f4f9af6$var$SizeAndUnit;
/**
 * Fast UUID generator, RFC4122 version 4 compliant.
 * @author Jeff Ward (jcward.com).
 * @license MIT license
 * @link http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/21963136#21963136
 **/ /* eslint-disable @typescript-eslint/no-extraneous-class, @typescript-eslint/naming-convention, no-bitwise */ var $ada385c31f4f9af6$var$UUID = /** @class */ function() {
    function UUID() {}
    UUID.generate = function() {
        var d0 = Math.random() * 0xffffffff | 0;
        var d1 = Math.random() * 0xffffffff | 0;
        var d2 = Math.random() * 0xffffffff | 0;
        var d3 = Math.random() * 0xffffffff | 0;
        return UUID.lut[d0 & 0xff] + UUID.lut[d0 >> 8 & 0xff] + UUID.lut[d0 >> 16 & 0xff] + UUID.lut[d0 >> 24 & 0xff] + "-" + UUID.lut[d1 & 0xff] + UUID.lut[d1 >> 8 & 0xff] + "-" + UUID.lut[d1 >> 16 & 0x0f | 0x40] + UUID.lut[d1 >> 24 & 0xff] + "-" + UUID.lut[d2 & 0x3f | 0x80] + UUID.lut[d2 >> 8 & 0xff] + "-" + UUID.lut[d2 >> 16 & 0xff] + UUID.lut[d2 >> 24 & 0xff] + UUID.lut[d3 & 0xff] + UUID.lut[d3 >> 8 & 0xff] + UUID.lut[d3 >> 16 & 0xff] + UUID.lut[d3 >> 24 & 0xff];
    };
    UUID.initialize = function() {
        for(var i = 0; i < 256; i++)UUID.lut[i] = (i < 16 ? "0" : "") + i.toString(16);
    };
    UUID.lut = [];
    return UUID;
}();
module.exports.UUID = $ada385c31f4f9af6$var$UUID;
$ada385c31f4f9af6$var$UUID.initialize(); /* eslint-enable @typescript-eslint/no-extraneous-class, @typescript-eslint/naming-convention, no-bitwise */ 

});

parcelRequire.register("ioYal", function(module, exports) {
"use strict";
var $d6592393752e53dc$var$_a;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.clearElementChildren = module.exports.getScrollY = module.exports.getScrollX = module.exports.getFitStatus = module.exports.truncate = module.exports.truncateText = module.exports.stringToCssColor = module.exports.parseEnum = module.exports.getEnumValueByName = module.exports.parseBool = module.exports.parseNumber = module.exports.parseString = module.exports.appendChild = module.exports.generateUniqueId = module.exports.isMobileOS = module.exports.isInternetExplorer = void 0;

var $iw5eI = parcelRequire("iw5eI");

var $eUh3g = parcelRequire("eUh3g");
function $d6592393752e53dc$var$isInternetExplorer() {
    // The documentMode property only exists in IE
    return window.document.documentMode !== undefined;
}
module.exports.isInternetExplorer = $d6592393752e53dc$var$isInternetExplorer;
function $d6592393752e53dc$var$isMobileOS() {
    var userAgent = window.navigator.userAgent;
    return !!userAgent.match(/Android/i) || !!userAgent.match(/iPad/i) || !!userAgent.match(/iPhone/i);
}
module.exports.isMobileOS = $d6592393752e53dc$var$isMobileOS;
/**
 * Generate a UUID prepended with "__ac-"
 */ function $d6592393752e53dc$var$generateUniqueId() {
    return "__ac-" + $eUh3g.UUID.generate();
}
module.exports.generateUniqueId = $d6592393752e53dc$var$generateUniqueId;
function $d6592393752e53dc$var$appendChild(node, child) {
    if (child) node.appendChild(child);
}
module.exports.appendChild = $d6592393752e53dc$var$appendChild;
function $d6592393752e53dc$var$parseString(obj, defaultValue) {
    return typeof obj === "string" ? obj : defaultValue;
}
module.exports.parseString = $d6592393752e53dc$var$parseString;
function $d6592393752e53dc$var$parseNumber(obj, defaultValue) {
    return typeof obj === "number" ? obj : defaultValue;
}
module.exports.parseNumber = $d6592393752e53dc$var$parseNumber;
function $d6592393752e53dc$var$parseBool(value, defaultValue) {
    if (typeof value === "boolean") return value;
    else if (typeof value === "string") switch(value.toLowerCase()){
        case "true":
            return true;
        case "false":
            return false;
        default:
            return defaultValue;
    }
    return defaultValue;
}
module.exports.parseBool = $d6592393752e53dc$var$parseBool;
function $d6592393752e53dc$var$getEnumValueByName(enumType, name) {
    // eslint-disable-next-line guard-for-in
    for(var key in enumType){
        var keyAsNumber = parseInt(key, 10);
        if (keyAsNumber >= 0) {
            var value = enumType[key];
            if (value && typeof value === "string" && value.toLowerCase() === name.toLowerCase()) return keyAsNumber;
        }
    }
    return undefined;
}
module.exports.getEnumValueByName = $d6592393752e53dc$var$getEnumValueByName;
function $d6592393752e53dc$var$parseEnum(enumType, name, defaultValue) {
    if (!name) return defaultValue;
    var enumValue = $d6592393752e53dc$var$getEnumValueByName(enumType, name);
    return enumValue !== undefined ? enumValue : defaultValue;
}
module.exports.parseEnum = $d6592393752e53dc$var$parseEnum;
function $d6592393752e53dc$var$stringToCssColor(color) {
    if (color) {
        var regEx = /#([0-9A-F]{2})([0-9A-F]{2})([0-9A-F]{2})([0-9A-F]{2})?/gi;
        var matches = regEx.exec(color);
        if (matches && matches[4]) {
            var a = parseInt(matches[1], 16) / 255;
            var r = parseInt(matches[2], 16);
            var g = parseInt(matches[3], 16);
            var b = parseInt(matches[4], 16);
            return "rgba(" + r + "," + g + "," + b + "," + a + ")";
        }
    }
    return color;
}
module.exports.stringToCssColor = $d6592393752e53dc$var$stringToCssColor;
function $d6592393752e53dc$var$truncateWorker(element, maxHeight, fullText, truncateAt, lineHeight) {
    var fits = function() {
        // Allow a one pixel overflow to account for rounding differences
        // between browsers
        return maxHeight - element.scrollHeight >= -1;
    };
    if (fits()) return;
    var breakableIndices = $d6592393752e53dc$var$findBreakableIndices(fullText);
    var lo = 0;
    var hi = breakableIndices.length;
    var bestBreakIdx = 0;
    // Do a binary search for the longest string that fits
    while(lo < hi){
        var mid = Math.floor((lo + hi) / 2);
        truncateAt(fullText, breakableIndices[mid]);
        if (fits()) {
            bestBreakIdx = breakableIndices[mid];
            lo = mid + 1;
        } else hi = mid;
    }
    truncateAt(fullText, bestBreakIdx);
    // If we have extra room, try to expand the string letter by letter
    // (covers the case where we have to break in the middle of a long word)
    if (lineHeight && maxHeight - element.scrollHeight >= lineHeight - 1.0) {
        var idx = $d6592393752e53dc$var$findNextCharacter(fullText, bestBreakIdx);
        while(idx < fullText.length){
            truncateAt(fullText, idx);
            if (fits()) {
                bestBreakIdx = idx;
                idx = $d6592393752e53dc$var$findNextCharacter(fullText, idx);
            } else break;
        }
        truncateAt(fullText, bestBreakIdx);
    }
}
function $d6592393752e53dc$var$truncateText(element, maxHeight, lineHeight) {
    $d6592393752e53dc$var$truncateWorker(element, maxHeight, element.innerText, function(text, idx) {
        element.innerText = text.substring(0, idx) + "...";
    }, lineHeight);
}
module.exports.truncateText = $d6592393752e53dc$var$truncateText;
/**
 * {@link truncate} has been deprecated and is no longer in use internally. This policy passes
 * content through as it always has, which is _supposed_ to be dealing with text only (see {@link
 * TextBlock.truncateIfSupported}), but had a bug where it might actually pass through an element
 * for which innerHTML yielded actual HTML (since fixed).
 */ var $d6592393752e53dc$var$ttDeprecatedPolicy = typeof window === "undefined" ? undefined : ($d6592393752e53dc$var$_a = window.trustedTypes) === null || $d6592393752e53dc$var$_a === void 0 ? void 0 : $d6592393752e53dc$var$_a.createPolicy("adaptivecards#deprecatedExportedFunctionPolicy", {
    createHTML: function(value) {
        return value;
    }
});
/** @deprecated Use {@link truncateText} instead. */ function $d6592393752e53dc$var$truncate(element, maxHeight, lineHeight) {
    $d6592393752e53dc$var$truncateWorker(element, maxHeight, element.innerHTML, function(text, idx) {
        var _a;
        var truncatedString = text.substring(0, idx) + "...";
        var truncatedHTML = (_a = $d6592393752e53dc$var$ttDeprecatedPolicy === null || $d6592393752e53dc$var$ttDeprecatedPolicy === void 0 ? void 0 : $d6592393752e53dc$var$ttDeprecatedPolicy.createHTML(truncatedString)) !== null && _a !== void 0 ? _a : truncatedString;
        element.innerHTML = truncatedHTML;
    }, lineHeight);
}
module.exports.truncate = $d6592393752e53dc$var$truncate;
function $d6592393752e53dc$var$findBreakableIndices(html) {
    var results = [];
    var idx = $d6592393752e53dc$var$findNextCharacter(html, -1);
    while(idx < html.length){
        if (html[idx] === " ") results.push(idx);
        idx = $d6592393752e53dc$var$findNextCharacter(html, idx);
    }
    return results;
}
function $d6592393752e53dc$var$findNextCharacter(html, currIdx) {
    currIdx += 1;
    // If we found the start of an HTML tag, keep advancing until we get
    // past it, so we don't end up truncating in the middle of the tag
    while(currIdx < html.length && html[currIdx] === "<"){
        while(currIdx < html.length && html[currIdx++] !== ">")continue;
    }
    return currIdx;
}
function $d6592393752e53dc$var$getFitStatus(element, containerEnd) {
    var start = element.offsetTop;
    var end = start + element.clientHeight;
    if (end <= containerEnd) return $iw5eI.ContainerFitStatus.FullyInContainer;
    else if (start < containerEnd) return $iw5eI.ContainerFitStatus.Overflowing;
    else return $iw5eI.ContainerFitStatus.FullyOutOfContainer;
}
module.exports.getFitStatus = $d6592393752e53dc$var$getFitStatus;
function $d6592393752e53dc$var$getScrollX() {
    return window.pageXOffset;
}
module.exports.getScrollX = $d6592393752e53dc$var$getScrollX;
function $d6592393752e53dc$var$getScrollY() {
    return window.pageYOffset;
}
module.exports.getScrollY = $d6592393752e53dc$var$getScrollY;
function $d6592393752e53dc$var$clearElementChildren(element) {
    while(element.firstChild)element.removeChild(element.firstChild);
}
module.exports.clearElementChildren = $d6592393752e53dc$var$clearElementChildren;

});

parcelRequire.register("ldzOp", function(module, exports) {
"use strict";
var $f72697650d056fd5$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SerializableObject = module.exports.property = module.exports.SerializableObjectSchema = module.exports.CustomProperty = module.exports.SerializableObjectCollectionProperty = module.exports.SerializableObjectProperty = module.exports.EnumProperty = module.exports.ValueSetProperty = module.exports.StringArrayProperty = module.exports.PixelSizeProperty = module.exports.NumProperty = module.exports.BoolProperty = module.exports.StringProperty = module.exports.PropertyDefinition = module.exports.BaseSerializationContext = module.exports.isVersionLessOrEqual = module.exports.Versions = module.exports.Version = void 0;

var $eUh3g = parcelRequire("eUh3g");

var $ioYal = parcelRequire("ioYal");

var $iw5eI = parcelRequire("iw5eI");

var $brsVB = parcelRequire("brsVB");
var $f72697650d056fd5$var$Version = /** @class */ function() {
    function Version(major, minor, label) {
        if (major === void 0) major = 1;
        if (minor === void 0) minor = 1;
        this._isValid = true;
        this._major = major;
        this._minor = minor;
        this._label = label;
    }
    Version.parse = function(versionString, context) {
        if (!versionString) return undefined;
        var result = new Version();
        result._versionString = versionString;
        var regEx = /(\d+).(\d+)/gi;
        var matches = regEx.exec(versionString);
        if (matches != null && matches.length === 3) {
            result._major = parseInt(matches[1]);
            result._minor = parseInt(matches[2]);
        } else result._isValid = false;
        if (!result._isValid) context.logParseEvent(undefined, $iw5eI.ValidationEvent.InvalidPropertyValue, $brsVB.Strings.errors.invalidVersionString(result._versionString));
        return result;
    };
    Version.prototype.toString = function() {
        return !this._isValid ? this._versionString : this._major + "." + this._minor;
    };
    Version.prototype.toJSON = function() {
        return this.toString();
    };
    Version.prototype.compareTo = function(otherVersion) {
        if (!this.isValid || !otherVersion.isValid) throw new Error("Cannot compare invalid version.");
        if (this.major > otherVersion.major) return 1;
        else if (this.major < otherVersion.major) return -1;
        else if (this.minor > otherVersion.minor) return 1;
        else if (this.minor < otherVersion.minor) return -1;
        return 0;
    };
    Object.defineProperty(Version.prototype, "label", {
        get: function() {
            return this._label ? this._label : this.toString();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Version.prototype, "major", {
        get: function() {
            return this._major;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Version.prototype, "minor", {
        get: function() {
            return this._minor;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Version.prototype, "isValid", {
        get: function() {
            return this._isValid;
        },
        enumerable: false,
        configurable: true
    });
    return Version;
}();
module.exports.Version = $f72697650d056fd5$var$Version;
// eslint-disable-next-line @typescript-eslint/no-extraneous-class
var $f72697650d056fd5$var$Versions = /** @class */ function() {
    function Versions() {}
    /* eslint-enable @typescript-eslint/naming-convention */ Versions.getAllDeclaredVersions = function() {
        var ctor = Versions;
        var properties = [];
        for(var propertyName in ctor){
            if (propertyName.match(/^v[0-9_]*$/)) // filter latest
            try {
                var propertyValue = ctor[propertyName];
                if (propertyValue instanceof $f72697650d056fd5$var$Version) properties.push(propertyValue);
            } catch (_a) {
            // If a property happens to have a getter function and
            // it throws an exception, we need to catch it here
            }
        }
        return properties.sort(function(v1, v2) {
            return v1.compareTo(v2);
        });
    };
    /* eslint-disable @typescript-eslint/naming-convention */ Versions.v1_0 = new $f72697650d056fd5$var$Version(1, 0);
    Versions.v1_1 = new $f72697650d056fd5$var$Version(1, 1);
    Versions.v1_2 = new $f72697650d056fd5$var$Version(1, 2);
    Versions.v1_3 = new $f72697650d056fd5$var$Version(1, 3);
    Versions.v1_4 = new $f72697650d056fd5$var$Version(1, 4);
    Versions.v1_5 = new $f72697650d056fd5$var$Version(1, 5);
    // If preview tag is added/removed from any version,
    // don't forget to update .ac-schema-version-1-?::after too in adaptivecards-site\themes\adaptivecards\source\css\style.css
    Versions.v1_6 = new $f72697650d056fd5$var$Version(1, 6, "1.6 Preview");
    Versions.latest = Versions.v1_5;
    return Versions;
}();
module.exports.Versions = $f72697650d056fd5$var$Versions;
function $f72697650d056fd5$var$isVersionLessOrEqual(version, targetVersion) {
    if (version instanceof $f72697650d056fd5$var$Version) {
        if (targetVersion instanceof $f72697650d056fd5$var$Version) return targetVersion.compareTo(version) >= 0;
        else // Target version is *
        return true;
    } else // Version is *
    return true;
}
module.exports.isVersionLessOrEqual = $f72697650d056fd5$var$isVersionLessOrEqual;
var $f72697650d056fd5$var$BaseSerializationContext = /** @class */ function() {
    function BaseSerializationContext(targetVersion) {
        if (targetVersion === void 0) targetVersion = $f72697650d056fd5$var$Versions.latest;
        this._validationEvents = [];
        this.targetVersion = targetVersion;
    }
    BaseSerializationContext.prototype.serializeValue = function(target, propertyName, propertyValue, defaultValue, forceDeleteIfNullOrDefault) {
        if (defaultValue === void 0) defaultValue = undefined;
        if (forceDeleteIfNullOrDefault === void 0) forceDeleteIfNullOrDefault = false;
        if (propertyValue === null || propertyValue === undefined || propertyValue === defaultValue) {
            if (!$eUh3g.GlobalSettings.enableFullJsonRoundTrip || forceDeleteIfNullOrDefault) delete target[propertyName];
        } else if (propertyValue === defaultValue) delete target[propertyName];
        else target[propertyName] = propertyValue;
    };
    BaseSerializationContext.prototype.serializeString = function(target, propertyName, propertyValue, defaultValue) {
        if (propertyValue === null || propertyValue === undefined || propertyValue === defaultValue) {
            if (!$eUh3g.GlobalSettings.enableFullJsonRoundTrip) delete target[propertyName];
        } else target[propertyName] = propertyValue;
    };
    BaseSerializationContext.prototype.serializeBool = function(target, propertyName, propertyValue, defaultValue) {
        if (propertyValue === null || propertyValue === undefined || propertyValue === defaultValue) {
            if (!$eUh3g.GlobalSettings.enableFullJsonRoundTrip) delete target[propertyName];
        } else target[propertyName] = propertyValue;
    };
    BaseSerializationContext.prototype.serializeNumber = function(target, propertyName, propertyValue, defaultValue) {
        if (propertyValue === null || propertyValue === undefined || propertyValue === defaultValue || isNaN(propertyValue)) {
            if (!$eUh3g.GlobalSettings.enableFullJsonRoundTrip) delete target[propertyName];
        } else target[propertyName] = propertyValue;
    };
    BaseSerializationContext.prototype.serializeEnum = function(enumType, target, propertyName, propertyValue, defaultValue) {
        if (defaultValue === void 0) defaultValue = undefined;
        if (propertyValue === null || propertyValue === undefined || propertyValue === defaultValue) {
            if (!$eUh3g.GlobalSettings.enableFullJsonRoundTrip) delete target[propertyName];
        } else target[propertyName] = enumType[propertyValue];
    };
    BaseSerializationContext.prototype.serializeArray = function(target, propertyName, propertyValue) {
        var items = [];
        if (propertyValue) for(var _i = 0, propertyValue_1 = propertyValue; _i < propertyValue_1.length; _i++){
            var item = propertyValue_1[_i];
            var serializedItem = undefined;
            if (item instanceof $f72697650d056fd5$var$SerializableObject) serializedItem = item.toJSON(this);
            else if (item.toJSON) serializedItem = item.toJSON();
            else serializedItem = item;
            if (serializedItem !== undefined) items.push(serializedItem);
        }
        if (items.length === 0) {
            if (target.hasOwnProperty(propertyName) && Array.isArray(target[propertyName])) delete target[propertyName];
        } else this.serializeValue(target, propertyName, items);
    };
    BaseSerializationContext.prototype.clearEvents = function() {
        this._validationEvents = [];
    };
    BaseSerializationContext.prototype.logEvent = function(source, phase, event, message) {
        this._validationEvents.push({
            source: source,
            phase: phase,
            event: event,
            message: message
        });
    };
    BaseSerializationContext.prototype.logParseEvent = function(source, event, message) {
        this.logEvent(source, $iw5eI.ValidationPhase.Parse, event, message);
    };
    BaseSerializationContext.prototype.getEventAt = function(index) {
        return this._validationEvents[index];
    };
    Object.defineProperty(BaseSerializationContext.prototype, "eventCount", {
        get: function() {
            return this._validationEvents.length;
        },
        enumerable: false,
        configurable: true
    });
    return BaseSerializationContext;
}();
module.exports.BaseSerializationContext = $f72697650d056fd5$var$BaseSerializationContext;
var $f72697650d056fd5$var$SimpleSerializationContext = /** @class */ function(_super) {
    $f72697650d056fd5$var$__extends(SimpleSerializationContext, _super);
    function SimpleSerializationContext() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return SimpleSerializationContext;
}($f72697650d056fd5$var$BaseSerializationContext);
var $f72697650d056fd5$var$PropertyDefinition = /** @class */ function() {
    function PropertyDefinition(targetVersion, name, defaultValue, onGetInitialValue) {
        this.targetVersion = targetVersion;
        this.name = name;
        this.defaultValue = defaultValue;
        this.onGetInitialValue = onGetInitialValue;
        this.isSerializationEnabled = true;
        this.sequentialNumber = PropertyDefinition._sequentialNumber;
        PropertyDefinition._sequentialNumber++;
    }
    PropertyDefinition.prototype.getInternalName = function() {
        return this.name;
    };
    PropertyDefinition.prototype.parse = function(sender, source, context) {
        return source[this.name];
    };
    PropertyDefinition.prototype.toJSON = function(sender, target, value, context) {
        context.serializeValue(target, this.name, value, this.defaultValue);
    };
    PropertyDefinition._sequentialNumber = 0;
    return PropertyDefinition;
}();
module.exports.PropertyDefinition = $f72697650d056fd5$var$PropertyDefinition;
var $f72697650d056fd5$var$StringProperty = /** @class */ function(_super) {
    $f72697650d056fd5$var$__extends(StringProperty, _super);
    function StringProperty(targetVersion, name, treatEmptyAsUndefined, regEx, defaultValue, onGetInitialValue) {
        if (treatEmptyAsUndefined === void 0) treatEmptyAsUndefined = true;
        var _this = _super.call(this, targetVersion, name, defaultValue, onGetInitialValue) || this;
        _this.targetVersion = targetVersion;
        _this.name = name;
        _this.treatEmptyAsUndefined = treatEmptyAsUndefined;
        _this.regEx = regEx;
        _this.defaultValue = defaultValue;
        _this.onGetInitialValue = onGetInitialValue;
        return _this;
    }
    StringProperty.prototype.parse = function(sender, source, context) {
        var parsedValue = $ioYal.parseString(source[this.name], this.defaultValue);
        var isUndefined = parsedValue === undefined || parsedValue === "" && this.treatEmptyAsUndefined;
        if (!isUndefined && this.regEx !== undefined) {
            var matches = this.regEx.exec(parsedValue);
            if (!matches) {
                context.logParseEvent(sender, $iw5eI.ValidationEvent.InvalidPropertyValue, $brsVB.Strings.errors.invalidPropertyValue(parsedValue, this.name));
                return undefined;
            }
        }
        return parsedValue;
    };
    StringProperty.prototype.toJSON = function(sender, target, value, context) {
        context.serializeString(target, this.name, value === "" && this.treatEmptyAsUndefined ? undefined : value, this.defaultValue);
    };
    return StringProperty;
}($f72697650d056fd5$var$PropertyDefinition);
module.exports.StringProperty = $f72697650d056fd5$var$StringProperty;
var $f72697650d056fd5$var$BoolProperty = /** @class */ function(_super) {
    $f72697650d056fd5$var$__extends(BoolProperty, _super);
    function BoolProperty(targetVersion, name, defaultValue, onGetInitialValue) {
        var _this = _super.call(this, targetVersion, name, defaultValue, onGetInitialValue) || this;
        _this.targetVersion = targetVersion;
        _this.name = name;
        _this.defaultValue = defaultValue;
        _this.onGetInitialValue = onGetInitialValue;
        return _this;
    }
    BoolProperty.prototype.parse = function(sender, source, context) {
        return $ioYal.parseBool(source[this.name], this.defaultValue);
    };
    BoolProperty.prototype.toJSON = function(sender, target, value, context) {
        context.serializeBool(target, this.name, value, this.defaultValue);
    };
    return BoolProperty;
}($f72697650d056fd5$var$PropertyDefinition);
module.exports.BoolProperty = $f72697650d056fd5$var$BoolProperty;
var $f72697650d056fd5$var$NumProperty = /** @class */ function(_super) {
    $f72697650d056fd5$var$__extends(NumProperty, _super);
    function NumProperty(targetVersion, name, defaultValue, onGetInitialValue) {
        var _this = _super.call(this, targetVersion, name, defaultValue, onGetInitialValue) || this;
        _this.targetVersion = targetVersion;
        _this.name = name;
        _this.defaultValue = defaultValue;
        _this.onGetInitialValue = onGetInitialValue;
        return _this;
    }
    NumProperty.prototype.parse = function(sender, source, context) {
        return $ioYal.parseNumber(source[this.name], this.defaultValue);
    };
    NumProperty.prototype.toJSON = function(sender, target, value, context) {
        context.serializeNumber(target, this.name, value, this.defaultValue);
    };
    return NumProperty;
}($f72697650d056fd5$var$PropertyDefinition);
module.exports.NumProperty = $f72697650d056fd5$var$NumProperty;
var $f72697650d056fd5$var$PixelSizeProperty = /** @class */ function(_super) {
    $f72697650d056fd5$var$__extends(PixelSizeProperty, _super);
    function PixelSizeProperty() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PixelSizeProperty.prototype.parse = function(sender, source, context) {
        var result = undefined;
        var value = source[this.name];
        if (typeof value === "string") {
            var isValid = false;
            try {
                var size = $eUh3g.SizeAndUnit.parse(value, true);
                if (size.unit === $iw5eI.SizeUnit.Pixel) {
                    result = size.physicalSize;
                    isValid = true;
                }
            } catch (_a) {
            // Do nothing. A parse error is emitted below
            }
            if (!isValid) context.logParseEvent(sender, $iw5eI.ValidationEvent.InvalidPropertyValue, $brsVB.Strings.errors.invalidPropertyValue(source[this.name], "minHeight"));
        }
        return result;
    };
    PixelSizeProperty.prototype.toJSON = function(sender, target, value, context) {
        context.serializeValue(target, this.name, typeof value === "number" && !isNaN(value) ? value + "px" : undefined);
    };
    return PixelSizeProperty;
}($f72697650d056fd5$var$PropertyDefinition);
module.exports.PixelSizeProperty = $f72697650d056fd5$var$PixelSizeProperty;
var $f72697650d056fd5$var$StringArrayProperty = /** @class */ function(_super) {
    $f72697650d056fd5$var$__extends(StringArrayProperty, _super);
    function StringArrayProperty(targetVersion, name, defaultValue, onGetInitialValue) {
        var _this = _super.call(this, targetVersion, name, defaultValue, onGetInitialValue) || this;
        _this.targetVersion = targetVersion;
        _this.name = name;
        _this.defaultValue = defaultValue;
        _this.onGetInitialValue = onGetInitialValue;
        return _this;
    }
    StringArrayProperty.prototype.parse = function(sender, source, context) {
        var sourceValue = source[this.name];
        if (sourceValue === undefined || !Array.isArray(sourceValue)) return this.defaultValue;
        var result = [];
        for(var _i = 0, sourceValue_1 = sourceValue; _i < sourceValue_1.length; _i++){
            var value = sourceValue_1[_i];
            if (typeof value === "string") result.push(value);
            else context.logParseEvent(sender, $iw5eI.ValidationEvent.InvalidPropertyValue, 'Invalid array value "'.concat(JSON.stringify(value), '" of type "').concat(typeof value, '" ignored for "').concat(this.name, '".'));
        }
        return result;
    };
    StringArrayProperty.prototype.toJSON = function(sender, target, value, context) {
        context.serializeArray(target, this.name, value);
    };
    return StringArrayProperty;
}($f72697650d056fd5$var$PropertyDefinition);
module.exports.StringArrayProperty = $f72697650d056fd5$var$StringArrayProperty;
var $f72697650d056fd5$var$ValueSetProperty = /** @class */ function(_super) {
    $f72697650d056fd5$var$__extends(ValueSetProperty, _super);
    function ValueSetProperty(targetVersion, name, values, defaultValue, onGetInitialValue) {
        var _this = _super.call(this, targetVersion, name, defaultValue, onGetInitialValue) || this;
        _this.targetVersion = targetVersion;
        _this.name = name;
        _this.values = values;
        _this.defaultValue = defaultValue;
        _this.onGetInitialValue = onGetInitialValue;
        return _this;
    }
    ValueSetProperty.prototype.isValidValue = function(value, context) {
        for(var _i = 0, _a = this.values; _i < _a.length; _i++){
            var versionedValue = _a[_i];
            if (value.toLowerCase() === versionedValue.value.toLowerCase()) {
                var targetVersion = versionedValue.targetVersion ? versionedValue.targetVersion : this.targetVersion;
                return targetVersion.compareTo(context.targetVersion) <= 0;
            }
        }
        return false;
    };
    ValueSetProperty.prototype.parse = function(sender, source, context) {
        var sourceValue = source[this.name];
        if (sourceValue === undefined) return this.defaultValue;
        if (typeof sourceValue === "string") for(var _i = 0, _a = this.values; _i < _a.length; _i++){
            var versionedValue = _a[_i];
            if (sourceValue.toLowerCase() === versionedValue.value.toLowerCase()) {
                var targetVersion = versionedValue.targetVersion ? versionedValue.targetVersion : this.targetVersion;
                if (targetVersion.compareTo(context.targetVersion) <= 0) return versionedValue.value;
                else {
                    context.logParseEvent(sender, $iw5eI.ValidationEvent.InvalidPropertyValue, $brsVB.Strings.errors.propertyValueNotSupported(sourceValue, this.name, targetVersion.toString(), context.targetVersion.toString()));
                    return this.defaultValue;
                }
            }
        }
        context.logParseEvent(sender, $iw5eI.ValidationEvent.InvalidPropertyValue, $brsVB.Strings.errors.invalidPropertyValue(sourceValue, this.name));
        return this.defaultValue;
    };
    ValueSetProperty.prototype.toJSON = function(sender, target, value, context) {
        var invalidValue = false;
        if (value !== undefined) {
            invalidValue = true;
            for(var _i = 0, _a = this.values; _i < _a.length; _i++){
                var versionedValue = _a[_i];
                if (versionedValue.value === value) {
                    var targetVersion = versionedValue.targetVersion ? versionedValue.targetVersion : this.targetVersion;
                    if (targetVersion.compareTo(context.targetVersion) <= 0) {
                        invalidValue = false;
                        break;
                    } else context.logEvent(sender, $iw5eI.ValidationPhase.ToJSON, $iw5eI.ValidationEvent.InvalidPropertyValue, $brsVB.Strings.errors.propertyValueNotSupported(value, this.name, targetVersion.toString(), context.targetVersion.toString()));
                }
            }
        }
        if (!invalidValue) context.serializeValue(target, this.name, value, this.defaultValue, true);
    };
    return ValueSetProperty;
}($f72697650d056fd5$var$PropertyDefinition);
module.exports.ValueSetProperty = $f72697650d056fd5$var$ValueSetProperty;
var $f72697650d056fd5$var$EnumProperty = /** @class */ function(_super) {
    $f72697650d056fd5$var$__extends(EnumProperty, _super);
    function EnumProperty(targetVersion, name, enumType, defaultValue, values, onGetInitialValue) {
        var _this = _super.call(this, targetVersion, name, defaultValue, onGetInitialValue) || this;
        _this.targetVersion = targetVersion;
        _this.name = name;
        _this.enumType = enumType;
        _this.defaultValue = defaultValue;
        _this.onGetInitialValue = onGetInitialValue;
        _this._values = [];
        if (!values) // eslint-disable-next-line guard-for-in
        for(var key in enumType){
            var keyAsNumber = parseInt(key, 10);
            if (keyAsNumber >= 0) _this._values.push({
                value: keyAsNumber
            });
        }
        else _this._values = values;
        return _this;
    }
    EnumProperty.prototype.parse = function(sender, source, context) {
        var sourceValue = source[this.name];
        if (typeof sourceValue !== "string") return this.defaultValue;
        var enumValue = $ioYal.getEnumValueByName(this.enumType, sourceValue);
        if (enumValue !== undefined) for(var _i = 0, _a = this.values; _i < _a.length; _i++){
            var versionedValue = _a[_i];
            if (versionedValue.value === enumValue) {
                var targetVersion = versionedValue.targetVersion ? versionedValue.targetVersion : this.targetVersion;
                if (targetVersion.compareTo(context.targetVersion) <= 0) return enumValue;
                else {
                    context.logParseEvent(sender, $iw5eI.ValidationEvent.InvalidPropertyValue, $brsVB.Strings.errors.propertyValueNotSupported(sourceValue, this.name, targetVersion.toString(), context.targetVersion.toString()));
                    return this.defaultValue;
                }
            }
        }
        context.logParseEvent(sender, $iw5eI.ValidationEvent.InvalidPropertyValue, $brsVB.Strings.errors.invalidPropertyValue(sourceValue, this.name));
        return this.defaultValue;
    };
    EnumProperty.prototype.toJSON = function(sender, target, value, context) {
        var invalidValue = false;
        if (value !== undefined) {
            invalidValue = true;
            for(var _i = 0, _a = this.values; _i < _a.length; _i++){
                var versionedValue = _a[_i];
                if (versionedValue.value === value) {
                    var targetVersion = versionedValue.targetVersion ? versionedValue.targetVersion : this.targetVersion;
                    if (targetVersion.compareTo(context.targetVersion) <= 0) {
                        invalidValue = false;
                        break;
                    } else context.logEvent(sender, $iw5eI.ValidationPhase.ToJSON, $iw5eI.ValidationEvent.InvalidPropertyValue, $brsVB.Strings.errors.invalidPropertyValue(value, this.name));
                }
            }
        }
        if (!invalidValue) context.serializeEnum(this.enumType, target, this.name, value, this.defaultValue);
    };
    Object.defineProperty(EnumProperty.prototype, "values", {
        get: function() {
            return this._values;
        },
        enumerable: false,
        configurable: true
    });
    return EnumProperty;
}($f72697650d056fd5$var$PropertyDefinition);
module.exports.EnumProperty = $f72697650d056fd5$var$EnumProperty;
var $f72697650d056fd5$var$SerializableObjectProperty = /** @class */ function(_super) {
    $f72697650d056fd5$var$__extends(SerializableObjectProperty, _super);
    function SerializableObjectProperty(targetVersion, name, objectType, nullable, defaultValue) {
        if (nullable === void 0) nullable = false;
        var _this = _super.call(this, targetVersion, name, defaultValue, function(sender) {
            return _this.nullable ? undefined : new _this.objectType();
        }) || this;
        _this.targetVersion = targetVersion;
        _this.name = name;
        _this.objectType = objectType;
        _this.nullable = nullable;
        return _this;
    }
    SerializableObjectProperty.prototype.parse = function(sender, source, context) {
        var sourceValue = source[this.name];
        if (sourceValue === undefined) return this.onGetInitialValue ? this.onGetInitialValue(sender) : this.defaultValue;
        var result = new this.objectType();
        result.parse(sourceValue, context);
        return result;
    };
    SerializableObjectProperty.prototype.toJSON = function(sender, target, value, context) {
        var serializedValue = undefined;
        if (value !== undefined && !value.hasAllDefaultValues()) serializedValue = value.toJSON(context);
        if (typeof serializedValue === "object" && Object.keys(serializedValue).length === 0) serializedValue = undefined;
        context.serializeValue(target, this.name, serializedValue, this.defaultValue, true);
    };
    return SerializableObjectProperty;
}($f72697650d056fd5$var$PropertyDefinition);
module.exports.SerializableObjectProperty = $f72697650d056fd5$var$SerializableObjectProperty;
var $f72697650d056fd5$var$SerializableObjectCollectionProperty = /** @class */ function(_super) {
    $f72697650d056fd5$var$__extends(SerializableObjectCollectionProperty, _super);
    function SerializableObjectCollectionProperty(targetVersion, name, objectType, onItemAdded) {
        var _this = _super.call(this, targetVersion, name, undefined, function(sender) {
            return [];
        }) || this;
        _this.targetVersion = targetVersion;
        _this.name = name;
        _this.objectType = objectType;
        _this.onItemAdded = onItemAdded;
        return _this;
    }
    SerializableObjectCollectionProperty.prototype.parse = function(sender, source, context) {
        var result = [];
        var sourceCollection = source[this.name];
        if (Array.isArray(sourceCollection)) for(var _i = 0, sourceCollection_1 = sourceCollection; _i < sourceCollection_1.length; _i++){
            var sourceItem = sourceCollection_1[_i];
            var item = new this.objectType();
            item.parse(sourceItem, context);
            result.push(item);
            if (this.onItemAdded) this.onItemAdded(sender, item);
        }
        return result.length > 0 ? result : this.onGetInitialValue ? this.onGetInitialValue(sender) : undefined;
    };
    SerializableObjectCollectionProperty.prototype.toJSON = function(sender, target, value, context) {
        context.serializeArray(target, this.name, value);
    };
    return SerializableObjectCollectionProperty;
}($f72697650d056fd5$var$PropertyDefinition);
module.exports.SerializableObjectCollectionProperty = $f72697650d056fd5$var$SerializableObjectCollectionProperty;
var $f72697650d056fd5$var$CustomProperty = /** @class */ function(_super) {
    $f72697650d056fd5$var$__extends(CustomProperty, _super);
    function CustomProperty(targetVersion, name, onParse, onToJSON, defaultValue, onGetInitialValue) {
        var _this = _super.call(this, targetVersion, name, defaultValue, onGetInitialValue) || this;
        _this.targetVersion = targetVersion;
        _this.name = name;
        _this.onParse = onParse;
        _this.onToJSON = onToJSON;
        _this.defaultValue = defaultValue;
        _this.onGetInitialValue = onGetInitialValue;
        if (!_this.onParse) throw new Error("CustomPropertyDefinition instances must have an onParse handler.");
        if (!_this.onToJSON) throw new Error("CustomPropertyDefinition instances must have an onToJSON handler.");
        return _this;
    }
    CustomProperty.prototype.parse = function(sender, source, context) {
        return this.onParse(sender, this, source, context);
    };
    CustomProperty.prototype.toJSON = function(sender, target, value, context) {
        this.onToJSON(sender, this, target, value, context);
    };
    return CustomProperty;
}($f72697650d056fd5$var$PropertyDefinition);
module.exports.CustomProperty = $f72697650d056fd5$var$CustomProperty;
var $f72697650d056fd5$var$SerializableObjectSchema = /** @class */ function() {
    function SerializableObjectSchema() {
        this._properties = [];
    }
    SerializableObjectSchema.prototype.indexOf = function(prop) {
        for(var i = 0; i < this._properties.length; i++){
            if (this._properties[i] === prop) return i;
        }
        return -1;
    };
    SerializableObjectSchema.prototype.add = function() {
        var properties = [];
        for(var _i = 0; _i < arguments.length; _i++)properties[_i] = arguments[_i];
        for(var _a = 0, properties_1 = properties; _a < properties_1.length; _a++){
            var prop = properties_1[_a];
            if (this.indexOf(prop) === -1) this._properties.push(prop);
        }
    };
    SerializableObjectSchema.prototype.remove = function() {
        var properties = [];
        for(var _i = 0; _i < arguments.length; _i++)properties[_i] = arguments[_i];
        for(var _a = 0, properties_2 = properties; _a < properties_2.length; _a++){
            var prop = properties_2[_a];
            while(true){
                var index = this.indexOf(prop);
                if (index >= 0) this._properties.splice(index, 1);
                else break;
            }
        }
    };
    SerializableObjectSchema.prototype.getItemAt = function(index) {
        return this._properties[index];
    };
    SerializableObjectSchema.prototype.getCount = function() {
        return this._properties.length;
    };
    return SerializableObjectSchema;
}();
module.exports.SerializableObjectSchema = $f72697650d056fd5$var$SerializableObjectSchema;
// This is a decorator function, used to map SerializableObject descendant class members to
// schema properties
function $f72697650d056fd5$var$property(prop) {
    return function(target, propertyKey) {
        var descriptor = Object.getOwnPropertyDescriptor(target, propertyKey) || {};
        if (!descriptor.get && !descriptor.set) {
            descriptor.get = function() {
                return this.getValue(prop);
            };
            descriptor.set = function(value) {
                this.setValue(prop, value);
            };
            Object.defineProperty(target, propertyKey, descriptor);
        }
    };
}
module.exports.property = $f72697650d056fd5$var$property;
var $f72697650d056fd5$var$SerializableObject = /** @class */ function() {
    function SerializableObject() {
        this._propertyBag = {};
        this._rawProperties = {};
        this.maxVersion = SerializableObject.defaultMaxVersion;
        var s = this.getSchema();
        for(var i = 0; i < s.getCount(); i++){
            var prop = s.getItemAt(i);
            if (prop.onGetInitialValue) this.setValue(prop, prop.onGetInitialValue(this));
        }
    }
    SerializableObject.prototype.getDefaultSerializationContext = function() {
        return new $f72697650d056fd5$var$SimpleSerializationContext();
    };
    SerializableObject.prototype.populateSchema = function(schema) {
        var ctor = this.constructor;
        var properties = [];
        // eslint-disable-next-line guard-for-in
        for(var propertyName in ctor)try {
            var propertyValue = ctor[propertyName];
            if (propertyValue instanceof $f72697650d056fd5$var$PropertyDefinition) properties.push(propertyValue);
        } catch (_a) {
        // If a property happens to have a getter function and
        // it throws an exception, we need to catch it here
        }
        if (properties.length > 0) {
            var sortedProperties = properties.sort(function(p1, p2) {
                if (p1.sequentialNumber > p2.sequentialNumber) return 1;
                else if (p1.sequentialNumber < p2.sequentialNumber) return -1;
                return 0;
            });
            schema.add.apply(schema, sortedProperties);
        }
        if (SerializableObject.onRegisterCustomProperties) SerializableObject.onRegisterCustomProperties(this, schema);
    };
    SerializableObject.prototype.getValue = function(prop) {
        return this._propertyBag.hasOwnProperty(prop.getInternalName()) ? this._propertyBag[prop.getInternalName()] : prop.defaultValue;
    };
    SerializableObject.prototype.setValue = function(prop, value) {
        if (value === undefined || value === null) delete this._propertyBag[prop.getInternalName()];
        else this._propertyBag[prop.getInternalName()] = value;
    };
    SerializableObject.prototype.internalParse = function(source, context) {
        this._propertyBag = {};
        this._rawProperties = $eUh3g.GlobalSettings.enableFullJsonRoundTrip ? source ? source : {} : {};
        if (source) {
            var s = this.getSchema();
            for(var i = 0; i < s.getCount(); i++){
                var prop = s.getItemAt(i);
                if (prop.isSerializationEnabled) {
                    var propertyValue = prop.onGetInitialValue ? prop.onGetInitialValue(this) : undefined;
                    if (source.hasOwnProperty(prop.name)) {
                        if (prop.targetVersion.compareTo(context.targetVersion) <= 0) propertyValue = prop.parse(this, source, context);
                        else context.logParseEvent(this, $iw5eI.ValidationEvent.UnsupportedProperty, $brsVB.Strings.errors.propertyNotSupported(prop.name, prop.targetVersion.toString(), context.targetVersion.toString()));
                    }
                    this.setValue(prop, propertyValue);
                }
            }
        } else this.resetDefaultValues();
    };
    SerializableObject.prototype.internalToJSON = function(target, context) {
        var s = this.getSchema();
        var serializedProperties = [];
        for(var i = 0; i < s.getCount(); i++){
            var prop = s.getItemAt(i);
            // Avoid serializing the same property multiple times. This is necessary
            // because some property definitions map to the same underlying schema
            // property
            if (prop.isSerializationEnabled && prop.targetVersion.compareTo(context.targetVersion) <= 0 && serializedProperties.indexOf(prop.name) === -1) {
                prop.toJSON(this, target, this.getValue(prop), context);
                serializedProperties.push(prop.name);
            }
        }
    };
    SerializableObject.prototype.shouldSerialize = function(_context) {
        return true;
    };
    SerializableObject.prototype.parse = function(source, context) {
        this.internalParse(source, context ? context : new $f72697650d056fd5$var$SimpleSerializationContext());
    };
    SerializableObject.prototype.toJSON = function(context) {
        var effectiveContext;
        if (context && context instanceof $f72697650d056fd5$var$BaseSerializationContext) effectiveContext = context;
        else {
            effectiveContext = this.getDefaultSerializationContext();
            effectiveContext.toJSONOriginalParam = context;
        }
        if (this.shouldSerialize(effectiveContext)) {
            var result = void 0;
            if ($eUh3g.GlobalSettings.enableFullJsonRoundTrip && this._rawProperties && typeof this._rawProperties === "object") result = this._rawProperties;
            else result = {};
            this.internalToJSON(result, effectiveContext);
            return result;
        } else return undefined;
    };
    SerializableObject.prototype.hasDefaultValue = function(prop) {
        return this.getValue(prop) === prop.defaultValue;
    };
    SerializableObject.prototype.hasAllDefaultValues = function() {
        var s = this.getSchema();
        for(var i = 0; i < s.getCount(); i++){
            var prop = s.getItemAt(i);
            if (!this.hasDefaultValue(prop)) return false;
        }
        return true;
    };
    SerializableObject.prototype.resetDefaultValues = function() {
        var s = this.getSchema();
        for(var i = 0; i < s.getCount(); i++){
            var prop = s.getItemAt(i);
            this.setValue(prop, prop.defaultValue);
        }
    };
    SerializableObject.prototype.setCustomProperty = function(name, value) {
        var shouldDeleteProperty = typeof value === "string" && !value || value === undefined || value === null;
        if (shouldDeleteProperty) delete this._rawProperties[name];
        else this._rawProperties[name] = value;
    };
    SerializableObject.prototype.getCustomProperty = function(name) {
        return this._rawProperties[name];
    };
    SerializableObject.prototype.getSchema = function() {
        var schema = SerializableObject._schemaCache[this.getSchemaKey()];
        if (!schema) {
            schema = new $f72697650d056fd5$var$SerializableObjectSchema();
            this.populateSchema(schema);
            SerializableObject._schemaCache[this.getSchemaKey()] = schema;
        }
        return schema;
    };
    SerializableObject.defaultMaxVersion = $f72697650d056fd5$var$Versions.latest;
    SerializableObject._schemaCache = {};
    return SerializableObject;
}();
module.exports.SerializableObject = $f72697650d056fd5$var$SerializableObject;

});

parcelRequire.register("35a5S", function(module, exports) {
"use strict";
var $23e9ab21d358c8aa$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.HostCapabilities = void 0;

var $ldzOp = parcelRequire("ldzOp");
var $23e9ab21d358c8aa$var$HostCapabilities = /** @class */ function(_super) {
    $23e9ab21d358c8aa$var$__extends(HostCapabilities, _super);
    function HostCapabilities() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._capabilities = {};
        return _this;
    }
    HostCapabilities.prototype.getSchemaKey = function() {
        return "HostCapabilities";
    };
    HostCapabilities.prototype.internalParse = function(source, context) {
        _super.prototype.internalParse.call(this, source, context);
        if (source) // eslint-disable-next-line guard-for-in
        for(var name_1 in source){
            var jsonVersion = source[name_1];
            if (typeof jsonVersion === "string") {
                if (jsonVersion === "*") this.addCapability(name_1, "*");
                else {
                    var version = $ldzOp.Version.parse(jsonVersion, context);
                    if (version === null || version === void 0 ? void 0 : version.isValid) this.addCapability(name_1, version);
                }
            }
        }
    };
    HostCapabilities.prototype.internalToJSON = function(target, context) {
        _super.prototype.internalToJSON.call(this, target, context);
        // eslint-disable-next-line guard-for-in
        for(var key in this._capabilities)target[key] = this._capabilities[key];
    };
    HostCapabilities.prototype.addCapability = function(name, version) {
        this._capabilities[name] = version;
    };
    HostCapabilities.prototype.removeCapability = function(name) {
        delete this._capabilities[name];
    };
    HostCapabilities.prototype.clear = function() {
        this._capabilities = {};
    };
    HostCapabilities.prototype.hasCapability = function(name, version) {
        if (this._capabilities.hasOwnProperty(name)) {
            if (version === "*" || this._capabilities[name] === "*") return true;
            return version.compareTo(this._capabilities[name]) <= 0;
        }
        return false;
    };
    HostCapabilities.prototype.areAllMet = function(hostCapabilities) {
        for(var capabilityName in this._capabilities){
            if (!hostCapabilities.hasCapability(capabilityName, this._capabilities[capabilityName])) return false;
        }
        return true;
    };
    return HostCapabilities;
}($ldzOp.SerializableObject);
module.exports.HostCapabilities = $23e9ab21d358c8aa$var$HostCapabilities;

});

parcelRequire.register("4IoSX", function(module, exports) {
"use strict";
var $36ee93347ac8a9ee$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.defaultHostConfig = module.exports.HostConfig = module.exports.FontTypeSet = module.exports.FontTypeDefinition = module.exports.ContainerStyleSet = module.exports.ContainerStyleDefinition = module.exports.ColorSetDefinition = module.exports.ActionsConfig = module.exports.ShowCardActionConfig = module.exports.FactSetConfig = module.exports.FactTitleDefinition = module.exports.FactTextDefinition = module.exports.InputConfig = module.exports.InputLabelConfig = module.exports.RequiredInputLabelTextDefinition = module.exports.TextBlockConfig = module.exports.TextStyleSet = module.exports.TextStyleDefinition = module.exports.BaseTextDefinition = module.exports.TableConfig = module.exports.MediaConfig = module.exports.ImageSetConfig = module.exports.AdaptiveCardConfig = module.exports.TextColorDefinition = module.exports.ColorDefinition = void 0;

var $iw5eI = parcelRequire("iw5eI");

var $ioYal = parcelRequire("ioYal");

var $eUh3g = parcelRequire("eUh3g");

var $35a5S = parcelRequire("35a5S");
function $36ee93347ac8a9ee$var$parseHostConfigEnum(targetEnum, value, defaultValue) {
    if (typeof value === "string") {
        var parsedValue = $ioYal.parseEnum(targetEnum, value, defaultValue);
        return parsedValue !== undefined ? parsedValue : defaultValue;
    } else if (typeof value === "number") return value;
    else return defaultValue;
}
var $36ee93347ac8a9ee$var$ColorDefinition = /** @class */ function() {
    function ColorDefinition(defaultColor, subtleColor) {
        this.default = "#000000";
        this.subtle = "#666666";
        if (defaultColor) this.default = defaultColor;
        if (subtleColor) this.subtle = subtleColor;
    }
    ColorDefinition.prototype.parse = function(obj) {
        if (obj) {
            this.default = obj["default"] || this.default;
            this.subtle = obj["subtle"] || this.subtle;
        }
    };
    return ColorDefinition;
}();
module.exports.ColorDefinition = $36ee93347ac8a9ee$var$ColorDefinition;
var $36ee93347ac8a9ee$var$TextColorDefinition = /** @class */ function(_super) {
    $36ee93347ac8a9ee$var$__extends(TextColorDefinition, _super);
    function TextColorDefinition() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.highlightColors = new $36ee93347ac8a9ee$var$ColorDefinition("#22000000", "#11000000");
        return _this;
    }
    TextColorDefinition.prototype.parse = function(obj) {
        _super.prototype.parse.call(this, obj);
        if (obj) this.highlightColors.parse(obj["highlightColors"]);
    };
    return TextColorDefinition;
}($36ee93347ac8a9ee$var$ColorDefinition);
module.exports.TextColorDefinition = $36ee93347ac8a9ee$var$TextColorDefinition;
var $36ee93347ac8a9ee$var$AdaptiveCardConfig = /** @class */ function() {
    function AdaptiveCardConfig(obj) {
        this.allowCustomStyle = false;
        if (obj) this.allowCustomStyle = obj["allowCustomStyle"] || this.allowCustomStyle;
    }
    return AdaptiveCardConfig;
}();
module.exports.AdaptiveCardConfig = $36ee93347ac8a9ee$var$AdaptiveCardConfig;
var $36ee93347ac8a9ee$var$ImageSetConfig = /** @class */ function() {
    function ImageSetConfig(obj) {
        this.imageSize = $iw5eI.Size.Medium;
        this.maxImageHeight = 100;
        if (obj) {
            this.imageSize = obj["imageSize"] != null ? obj["imageSize"] : this.imageSize;
            this.maxImageHeight = $ioYal.parseNumber(obj["maxImageHeight"], 100);
        }
    }
    ImageSetConfig.prototype.toJSON = function() {
        return {
            imageSize: $iw5eI.Size[this.imageSize],
            maxImageHeight: this.maxImageHeight
        };
    };
    return ImageSetConfig;
}();
module.exports.ImageSetConfig = $36ee93347ac8a9ee$var$ImageSetConfig;
var $36ee93347ac8a9ee$var$MediaConfig = /** @class */ function() {
    function MediaConfig(obj) {
        this.allowInlinePlayback = true;
        if (obj) {
            this.defaultPoster = obj["defaultPoster"];
            this.allowInlinePlayback = obj["allowInlinePlayback"] || this.allowInlinePlayback;
        }
    }
    MediaConfig.prototype.toJSON = function() {
        return {
            defaultPoster: this.defaultPoster,
            allowInlinePlayback: this.allowInlinePlayback
        };
    };
    return MediaConfig;
}();
module.exports.MediaConfig = $36ee93347ac8a9ee$var$MediaConfig;
var $36ee93347ac8a9ee$var$TableConfig = /** @class */ function() {
    function TableConfig(obj) {
        this.cellSpacing = 8;
        if (obj) this.cellSpacing = obj.cellSpacing && typeof obj.cellSpacing === "number" ? obj.cellSpacing : this.cellSpacing;
    }
    TableConfig.prototype.toJSON = function() {
        return {
            cellSpacing: this.cellSpacing
        };
    };
    return TableConfig;
}();
module.exports.TableConfig = $36ee93347ac8a9ee$var$TableConfig;
var $36ee93347ac8a9ee$var$BaseTextDefinition = /** @class */ function() {
    function BaseTextDefinition(obj) {
        this.size = $iw5eI.TextSize.Default;
        this.color = $iw5eI.TextColor.Default;
        this.isSubtle = false;
        this.weight = $iw5eI.TextWeight.Default;
        this.parse(obj);
    }
    BaseTextDefinition.prototype.parse = function(obj) {
        if (obj) {
            this.size = $36ee93347ac8a9ee$var$parseHostConfigEnum($iw5eI.TextSize, obj["size"], this.size);
            this.color = $36ee93347ac8a9ee$var$parseHostConfigEnum($iw5eI.TextColor, obj["color"], this.color);
            this.isSubtle = obj.isSubtle !== undefined && typeof obj.isSubtle === "boolean" ? obj.isSubtle : this.isSubtle;
            this.weight = $36ee93347ac8a9ee$var$parseHostConfigEnum($iw5eI.TextWeight, obj["weight"], this.getDefaultWeight());
        }
    };
    BaseTextDefinition.prototype.getDefaultWeight = function() {
        return $iw5eI.TextWeight.Default;
    };
    BaseTextDefinition.prototype.toJSON = function() {
        return {
            size: $iw5eI.TextSize[this.size],
            color: $iw5eI.TextColor[this.color],
            isSubtle: this.isSubtle,
            weight: $iw5eI.TextWeight[this.weight]
        };
    };
    return BaseTextDefinition;
}();
module.exports.BaseTextDefinition = $36ee93347ac8a9ee$var$BaseTextDefinition;
var $36ee93347ac8a9ee$var$TextStyleDefinition = /** @class */ function(_super) {
    $36ee93347ac8a9ee$var$__extends(TextStyleDefinition, _super);
    function TextStyleDefinition() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.fontType = $iw5eI.FontType.Default;
        return _this;
    }
    TextStyleDefinition.prototype.parse = function(obj) {
        _super.prototype.parse.call(this, obj);
        if (obj) this.fontType = $36ee93347ac8a9ee$var$parseHostConfigEnum($iw5eI.FontType, obj.fontType, this.fontType);
    };
    return TextStyleDefinition;
}($36ee93347ac8a9ee$var$BaseTextDefinition);
module.exports.TextStyleDefinition = $36ee93347ac8a9ee$var$TextStyleDefinition;
var $36ee93347ac8a9ee$var$TextStyleSet = /** @class */ function() {
    function TextStyleSet(obj) {
        this.default = new $36ee93347ac8a9ee$var$TextStyleDefinition();
        this.heading = new $36ee93347ac8a9ee$var$TextStyleDefinition({
            size: "Large",
            weight: "Bolder"
        });
        this.columnHeader = new $36ee93347ac8a9ee$var$TextStyleDefinition({
            weight: "Bolder"
        });
        if (obj) {
            this.heading.parse(obj.heading);
            this.columnHeader.parse(obj.columnHeader);
        }
    }
    TextStyleSet.prototype.getStyleByName = function(name) {
        switch(name.toLowerCase()){
            case "heading":
                return this.heading;
            case "columnHeader":
                return this.columnHeader;
            default:
                return this.default;
        }
    };
    return TextStyleSet;
}();
module.exports.TextStyleSet = $36ee93347ac8a9ee$var$TextStyleSet;
var $36ee93347ac8a9ee$var$TextBlockConfig = /** @class */ function() {
    function TextBlockConfig(obj) {
        if (obj) this.headingLevel = $ioYal.parseNumber(obj.headingLevel);
    }
    return TextBlockConfig;
}();
module.exports.TextBlockConfig = $36ee93347ac8a9ee$var$TextBlockConfig;
var $36ee93347ac8a9ee$var$RequiredInputLabelTextDefinition = /** @class */ function(_super) {
    $36ee93347ac8a9ee$var$__extends(RequiredInputLabelTextDefinition, _super);
    function RequiredInputLabelTextDefinition() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.suffix = " *";
        _this.suffixColor = $iw5eI.TextColor.Attention;
        return _this;
    }
    RequiredInputLabelTextDefinition.prototype.parse = function(obj) {
        _super.prototype.parse.call(this, obj);
        if (obj) {
            this.suffix = obj["suffix"] || this.suffix;
            this.suffixColor = $36ee93347ac8a9ee$var$parseHostConfigEnum($iw5eI.TextColor, obj["suffixColor"], this.suffixColor);
        }
    };
    RequiredInputLabelTextDefinition.prototype.toJSON = function() {
        var result = _super.prototype.toJSON.call(this);
        result["suffix"] = this.suffix;
        result["suffixColor"] = $iw5eI.TextColor[this.suffixColor];
        return result;
    };
    return RequiredInputLabelTextDefinition;
}($36ee93347ac8a9ee$var$BaseTextDefinition);
module.exports.RequiredInputLabelTextDefinition = $36ee93347ac8a9ee$var$RequiredInputLabelTextDefinition;
var $36ee93347ac8a9ee$var$InputLabelConfig = /** @class */ function() {
    function InputLabelConfig(obj) {
        this.inputSpacing = $iw5eI.Spacing.Small;
        this.requiredInputs = new $36ee93347ac8a9ee$var$RequiredInputLabelTextDefinition();
        this.optionalInputs = new $36ee93347ac8a9ee$var$BaseTextDefinition();
        if (obj) {
            this.inputSpacing = $36ee93347ac8a9ee$var$parseHostConfigEnum($iw5eI.Spacing, obj["inputSpacing"], this.inputSpacing);
            this.requiredInputs = new $36ee93347ac8a9ee$var$RequiredInputLabelTextDefinition(obj["requiredInputs"]);
            this.optionalInputs = new $36ee93347ac8a9ee$var$BaseTextDefinition(obj["optionalInputs"]);
        }
    }
    return InputLabelConfig;
}();
module.exports.InputLabelConfig = $36ee93347ac8a9ee$var$InputLabelConfig;
var $36ee93347ac8a9ee$var$InputConfig = /** @class */ function() {
    function InputConfig(obj) {
        this.label = new $36ee93347ac8a9ee$var$InputLabelConfig();
        this.errorMessage = new $36ee93347ac8a9ee$var$BaseTextDefinition({
            color: $iw5eI.TextColor.Attention
        });
        if (obj) {
            this.label = new $36ee93347ac8a9ee$var$InputLabelConfig(obj["label"]);
            this.errorMessage = new $36ee93347ac8a9ee$var$BaseTextDefinition(obj["errorMessage"]);
        }
    }
    return InputConfig;
}();
module.exports.InputConfig = $36ee93347ac8a9ee$var$InputConfig;
var $36ee93347ac8a9ee$var$FactTextDefinition = /** @class */ function(_super) {
    $36ee93347ac8a9ee$var$__extends(FactTextDefinition, _super);
    function FactTextDefinition() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.wrap = true;
        return _this;
    }
    FactTextDefinition.prototype.parse = function(obj) {
        _super.prototype.parse.call(this, obj);
        if (obj) this.wrap = obj["wrap"] != null ? obj["wrap"] : this.wrap;
    };
    FactTextDefinition.prototype.toJSON = function() {
        var result = _super.prototype.toJSON.call(this);
        result["wrap"] = this.wrap;
        return result;
    };
    return FactTextDefinition;
}($36ee93347ac8a9ee$var$BaseTextDefinition);
module.exports.FactTextDefinition = $36ee93347ac8a9ee$var$FactTextDefinition;
var $36ee93347ac8a9ee$var$FactTitleDefinition = /** @class */ function(_super) {
    $36ee93347ac8a9ee$var$__extends(FactTitleDefinition, _super);
    function FactTitleDefinition(obj) {
        var _this = _super.call(this, obj) || this;
        _this.maxWidth = 150;
        _this.weight = $iw5eI.TextWeight.Bolder;
        if (obj) {
            _this.maxWidth = obj["maxWidth"] != null ? obj["maxWidth"] : _this.maxWidth;
            _this.weight = $36ee93347ac8a9ee$var$parseHostConfigEnum($iw5eI.TextWeight, obj["weight"], $iw5eI.TextWeight.Bolder);
        }
        return _this;
    }
    FactTitleDefinition.prototype.getDefaultWeight = function() {
        return $iw5eI.TextWeight.Bolder;
    };
    return FactTitleDefinition;
}($36ee93347ac8a9ee$var$FactTextDefinition);
module.exports.FactTitleDefinition = $36ee93347ac8a9ee$var$FactTitleDefinition;
var $36ee93347ac8a9ee$var$FactSetConfig = /** @class */ function() {
    function FactSetConfig(obj) {
        this.title = new $36ee93347ac8a9ee$var$FactTitleDefinition();
        this.value = new $36ee93347ac8a9ee$var$FactTextDefinition();
        this.spacing = 10;
        if (obj) {
            this.title = new $36ee93347ac8a9ee$var$FactTitleDefinition(obj["title"]);
            this.value = new $36ee93347ac8a9ee$var$FactTextDefinition(obj["value"]);
            this.spacing = obj.spacing && obj.spacing != null ? obj.spacing && obj.spacing : this.spacing;
        }
    }
    return FactSetConfig;
}();
module.exports.FactSetConfig = $36ee93347ac8a9ee$var$FactSetConfig;
var $36ee93347ac8a9ee$var$ShowCardActionConfig = /** @class */ function() {
    function ShowCardActionConfig(obj) {
        this.actionMode = $iw5eI.ShowCardActionMode.Inline;
        this.inlineTopMargin = 16;
        this.style = $iw5eI.ContainerStyle.Emphasis;
        if (obj) {
            this.actionMode = $36ee93347ac8a9ee$var$parseHostConfigEnum($iw5eI.ShowCardActionMode, obj["actionMode"], $iw5eI.ShowCardActionMode.Inline);
            this.inlineTopMargin = obj["inlineTopMargin"] != null ? obj["inlineTopMargin"] : this.inlineTopMargin;
            this.style = obj["style"] && typeof obj["style"] === "string" ? obj["style"] : $iw5eI.ContainerStyle.Emphasis;
        }
    }
    ShowCardActionConfig.prototype.toJSON = function() {
        return {
            actionMode: $iw5eI.ShowCardActionMode[this.actionMode],
            inlineTopMargin: this.inlineTopMargin,
            style: this.style
        };
    };
    return ShowCardActionConfig;
}();
module.exports.ShowCardActionConfig = $36ee93347ac8a9ee$var$ShowCardActionConfig;
var $36ee93347ac8a9ee$var$ActionsConfig = /** @class */ function() {
    function ActionsConfig(obj) {
        this.maxActions = 5;
        this.spacing = $iw5eI.Spacing.Default;
        this.buttonSpacing = 20;
        this.showCard = new $36ee93347ac8a9ee$var$ShowCardActionConfig();
        this.preExpandSingleShowCardAction = false;
        this.actionsOrientation = $iw5eI.Orientation.Horizontal;
        this.actionAlignment = $iw5eI.ActionAlignment.Left;
        this.iconPlacement = $iw5eI.ActionIconPlacement.LeftOfTitle;
        this.allowTitleToWrap = false;
        this.iconSize = 16;
        if (obj) {
            this.maxActions = obj["maxActions"] != null ? obj["maxActions"] : this.maxActions;
            this.spacing = $36ee93347ac8a9ee$var$parseHostConfigEnum($iw5eI.Spacing, obj.spacing && obj.spacing, $iw5eI.Spacing.Default);
            this.buttonSpacing = obj["buttonSpacing"] != null ? obj["buttonSpacing"] : this.buttonSpacing;
            this.showCard = new $36ee93347ac8a9ee$var$ShowCardActionConfig(obj["showCard"]);
            this.preExpandSingleShowCardAction = $ioYal.parseBool(obj["preExpandSingleShowCardAction"], false);
            this.actionsOrientation = $36ee93347ac8a9ee$var$parseHostConfigEnum($iw5eI.Orientation, obj["actionsOrientation"], $iw5eI.Orientation.Horizontal);
            this.actionAlignment = $36ee93347ac8a9ee$var$parseHostConfigEnum($iw5eI.ActionAlignment, obj["actionAlignment"], $iw5eI.ActionAlignment.Left);
            this.iconPlacement = $36ee93347ac8a9ee$var$parseHostConfigEnum($iw5eI.ActionIconPlacement, obj["iconPlacement"], $iw5eI.ActionIconPlacement.LeftOfTitle);
            this.allowTitleToWrap = obj["allowTitleToWrap"] != null ? obj["allowTitleToWrap"] : this.allowTitleToWrap;
            try {
                var sizeAndUnit = $eUh3g.SizeAndUnit.parse(obj["iconSize"]);
                if (sizeAndUnit.unit === $iw5eI.SizeUnit.Pixel) this.iconSize = sizeAndUnit.physicalSize;
            } catch (e) {
            // Swallow this, keep default icon size
            }
        }
    }
    ActionsConfig.prototype.toJSON = function() {
        return {
            maxActions: this.maxActions,
            spacing: $iw5eI.Spacing[this.spacing],
            buttonSpacing: this.buttonSpacing,
            showCard: this.showCard,
            preExpandSingleShowCardAction: this.preExpandSingleShowCardAction,
            actionsOrientation: $iw5eI.Orientation[this.actionsOrientation],
            actionAlignment: $iw5eI.ActionAlignment[this.actionAlignment]
        };
    };
    return ActionsConfig;
}();
module.exports.ActionsConfig = $36ee93347ac8a9ee$var$ActionsConfig;
var $36ee93347ac8a9ee$var$ColorSetDefinition = /** @class */ function() {
    function ColorSetDefinition(obj) {
        this.default = new $36ee93347ac8a9ee$var$TextColorDefinition();
        this.dark = new $36ee93347ac8a9ee$var$TextColorDefinition();
        this.light = new $36ee93347ac8a9ee$var$TextColorDefinition();
        this.accent = new $36ee93347ac8a9ee$var$TextColorDefinition();
        this.good = new $36ee93347ac8a9ee$var$TextColorDefinition();
        this.warning = new $36ee93347ac8a9ee$var$TextColorDefinition();
        this.attention = new $36ee93347ac8a9ee$var$TextColorDefinition();
        this.parse(obj);
    }
    ColorSetDefinition.prototype.parseSingleColor = function(obj, propertyName) {
        if (obj) this[propertyName].parse(obj[propertyName]);
    };
    ColorSetDefinition.prototype.parse = function(obj) {
        if (obj) {
            this.parseSingleColor(obj, "default");
            this.parseSingleColor(obj, "dark");
            this.parseSingleColor(obj, "light");
            this.parseSingleColor(obj, "accent");
            this.parseSingleColor(obj, "good");
            this.parseSingleColor(obj, "warning");
            this.parseSingleColor(obj, "attention");
        }
    };
    return ColorSetDefinition;
}();
module.exports.ColorSetDefinition = $36ee93347ac8a9ee$var$ColorSetDefinition;
var $36ee93347ac8a9ee$var$ContainerStyleDefinition = /** @class */ function() {
    function ContainerStyleDefinition(obj) {
        this.foregroundColors = new $36ee93347ac8a9ee$var$ColorSetDefinition({
            "default": {
                default: "#333333",
                subtle: "#EE333333"
            },
            "dark": {
                default: "#000000",
                subtle: "#66000000"
            },
            "light": {
                default: "#FFFFFF",
                subtle: "#33000000"
            },
            "accent": {
                default: "#2E89FC",
                subtle: "#882E89FC"
            },
            "good": {
                default: "#028A02",
                subtle: "#DD027502"
            },
            "warning": {
                default: "#E69500",
                subtle: "#DDE69500"
            },
            "attention": {
                default: "#CC3300",
                subtle: "#DDCC3300"
            }
        });
        this.parse(obj);
    }
    ContainerStyleDefinition.prototype.parse = function(obj) {
        if (obj) {
            this.backgroundColor = obj["backgroundColor"];
            this.foregroundColors.parse(obj["foregroundColors"]);
            this.highlightBackgroundColor = obj["highlightBackgroundColor"];
            this.highlightForegroundColor = obj["highlightForegroundColor"];
            this.borderColor = obj["borderColor"];
        }
    };
    Object.defineProperty(ContainerStyleDefinition.prototype, "isBuiltIn", {
        get: function() {
            return false;
        },
        enumerable: false,
        configurable: true
    });
    return ContainerStyleDefinition;
}();
module.exports.ContainerStyleDefinition = $36ee93347ac8a9ee$var$ContainerStyleDefinition;
var $36ee93347ac8a9ee$var$BuiltInContainerStyleDefinition = /** @class */ function(_super) {
    $36ee93347ac8a9ee$var$__extends(BuiltInContainerStyleDefinition, _super);
    function BuiltInContainerStyleDefinition() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(BuiltInContainerStyleDefinition.prototype, "isBuiltIn", {
        get: function() {
            return true;
        },
        enumerable: false,
        configurable: true
    });
    return BuiltInContainerStyleDefinition;
}($36ee93347ac8a9ee$var$ContainerStyleDefinition);
var $36ee93347ac8a9ee$var$ContainerStyleSet = /** @class */ function() {
    function ContainerStyleSet(obj) {
        this._allStyles = {};
        this._allStyles[$iw5eI.ContainerStyle.Default] = new $36ee93347ac8a9ee$var$BuiltInContainerStyleDefinition();
        this._allStyles[$iw5eI.ContainerStyle.Emphasis] = new $36ee93347ac8a9ee$var$BuiltInContainerStyleDefinition();
        this._allStyles[$iw5eI.ContainerStyle.Accent] = new $36ee93347ac8a9ee$var$BuiltInContainerStyleDefinition();
        this._allStyles[$iw5eI.ContainerStyle.Good] = new $36ee93347ac8a9ee$var$BuiltInContainerStyleDefinition();
        this._allStyles[$iw5eI.ContainerStyle.Attention] = new $36ee93347ac8a9ee$var$BuiltInContainerStyleDefinition();
        this._allStyles[$iw5eI.ContainerStyle.Warning] = new $36ee93347ac8a9ee$var$BuiltInContainerStyleDefinition();
        if (obj) {
            this._allStyles[$iw5eI.ContainerStyle.Default].parse(obj[$iw5eI.ContainerStyle.Default]);
            this._allStyles[$iw5eI.ContainerStyle.Emphasis].parse(obj[$iw5eI.ContainerStyle.Emphasis]);
            this._allStyles[$iw5eI.ContainerStyle.Accent].parse(obj[$iw5eI.ContainerStyle.Accent]);
            this._allStyles[$iw5eI.ContainerStyle.Good].parse(obj[$iw5eI.ContainerStyle.Good]);
            this._allStyles[$iw5eI.ContainerStyle.Attention].parse(obj[$iw5eI.ContainerStyle.Attention]);
            this._allStyles[$iw5eI.ContainerStyle.Warning].parse(obj[$iw5eI.ContainerStyle.Warning]);
            var customStyleArray = obj["customStyles"];
            if (customStyleArray && Array.isArray(customStyleArray)) for(var _i = 0, customStyleArray_1 = customStyleArray; _i < customStyleArray_1.length; _i++){
                var customStyle = customStyleArray_1[_i];
                if (customStyle) {
                    var styleName = customStyle["name"];
                    if (styleName && typeof styleName === "string") {
                        if (this._allStyles.hasOwnProperty(styleName)) this._allStyles[styleName].parse(customStyle["style"]);
                        else this._allStyles[styleName] = new $36ee93347ac8a9ee$var$ContainerStyleDefinition(customStyle["style"]);
                    }
                }
            }
        }
    }
    ContainerStyleSet.prototype.toJSON = function() {
        var _this = this;
        var customStyleArray = [];
        Object.keys(this._allStyles).forEach(function(key) {
            if (!_this._allStyles[key].isBuiltIn) customStyleArray.push({
                name: key,
                style: _this._allStyles[key]
            });
        });
        var result = {
            default: this.default,
            emphasis: this.emphasis
        };
        if (customStyleArray.length > 0) result.customStyles = customStyleArray;
        return result;
    };
    ContainerStyleSet.prototype.getStyleByName = function(name, defaultValue) {
        if (name && this._allStyles.hasOwnProperty(name)) return this._allStyles[name];
        else return defaultValue ? defaultValue : this._allStyles[$iw5eI.ContainerStyle.Default];
    };
    Object.defineProperty(ContainerStyleSet.prototype, "default", {
        get: function() {
            return this._allStyles[$iw5eI.ContainerStyle.Default];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ContainerStyleSet.prototype, "emphasis", {
        get: function() {
            return this._allStyles[$iw5eI.ContainerStyle.Emphasis];
        },
        enumerable: false,
        configurable: true
    });
    return ContainerStyleSet;
}();
module.exports.ContainerStyleSet = $36ee93347ac8a9ee$var$ContainerStyleSet;
var $36ee93347ac8a9ee$var$FontTypeDefinition = /** @class */ function() {
    function FontTypeDefinition(fontFamily) {
        this.fontFamily = "Segoe UI,Segoe,Segoe WP,Helvetica Neue,Helvetica,sans-serif";
        this.fontSizes = {
            small: 12,
            default: 14,
            medium: 17,
            large: 21,
            extraLarge: 26
        };
        this.fontWeights = {
            lighter: 200,
            default: 400,
            bolder: 600
        };
        if (fontFamily) this.fontFamily = fontFamily;
    }
    FontTypeDefinition.prototype.parse = function(obj) {
        this.fontFamily = obj["fontFamily"] || this.fontFamily;
        this.fontSizes = {
            small: obj.fontSizes && obj.fontSizes["small"] || this.fontSizes.small,
            default: obj.fontSizes && obj.fontSizes["default"] || this.fontSizes.default,
            medium: obj.fontSizes && obj.fontSizes["medium"] || this.fontSizes.medium,
            large: obj.fontSizes && obj.fontSizes["large"] || this.fontSizes.large,
            extraLarge: obj.fontSizes && obj.fontSizes["extraLarge"] || this.fontSizes.extraLarge
        };
        this.fontWeights = {
            lighter: obj.fontWeights && obj.fontWeights["lighter"] || this.fontWeights.lighter,
            default: obj.fontWeights && obj.fontWeights["default"] || this.fontWeights.default,
            bolder: obj.fontWeights && obj.fontWeights["bolder"] || this.fontWeights.bolder
        };
    };
    FontTypeDefinition.monospace = new FontTypeDefinition("'Courier New', Courier, monospace");
    return FontTypeDefinition;
}();
module.exports.FontTypeDefinition = $36ee93347ac8a9ee$var$FontTypeDefinition;
var $36ee93347ac8a9ee$var$FontTypeSet = /** @class */ function() {
    function FontTypeSet(obj) {
        this.default = new $36ee93347ac8a9ee$var$FontTypeDefinition();
        this.monospace = new $36ee93347ac8a9ee$var$FontTypeDefinition("'Courier New', Courier, monospace");
        if (obj) {
            this.default.parse(obj["default"]);
            this.monospace.parse(obj["monospace"]);
        }
    }
    FontTypeSet.prototype.getStyleDefinition = function(style) {
        switch(style){
            case $iw5eI.FontType.Monospace:
                return this.monospace;
            case $iw5eI.FontType.Default:
            default:
                return this.default;
        }
    };
    return FontTypeSet;
}();
module.exports.FontTypeSet = $36ee93347ac8a9ee$var$FontTypeSet;
var $36ee93347ac8a9ee$var$HostConfig = /** @class */ function() {
    function HostConfig(obj) {
        this.hostCapabilities = new $35a5S.HostCapabilities();
        this.choiceSetInputValueSeparator = ",";
        this.supportsInteractivity = true;
        this.spacing = {
            small: 3,
            default: 8,
            medium: 20,
            large: 30,
            extraLarge: 40,
            padding: 15
        };
        this.separator = {
            lineThickness: 1,
            lineColor: "#EEEEEE"
        };
        this.imageSizes = {
            small: 40,
            medium: 80,
            large: 160
        };
        this.containerStyles = new $36ee93347ac8a9ee$var$ContainerStyleSet();
        this.inputs = new $36ee93347ac8a9ee$var$InputConfig();
        this.actions = new $36ee93347ac8a9ee$var$ActionsConfig();
        this.adaptiveCard = new $36ee93347ac8a9ee$var$AdaptiveCardConfig();
        this.imageSet = new $36ee93347ac8a9ee$var$ImageSetConfig();
        this.media = new $36ee93347ac8a9ee$var$MediaConfig();
        this.factSet = new $36ee93347ac8a9ee$var$FactSetConfig();
        this.table = new $36ee93347ac8a9ee$var$TableConfig();
        this.textStyles = new $36ee93347ac8a9ee$var$TextStyleSet();
        this.textBlock = new $36ee93347ac8a9ee$var$TextBlockConfig();
        this.alwaysAllowBleed = false;
        if (obj) {
            if (typeof obj === "string" || obj instanceof String) obj = JSON.parse(obj);
            this.choiceSetInputValueSeparator = obj && typeof obj["choiceSetInputValueSeparator"] === "string" ? obj["choiceSetInputValueSeparator"] : this.choiceSetInputValueSeparator;
            this.supportsInteractivity = obj && typeof obj["supportsInteractivity"] === "boolean" ? obj["supportsInteractivity"] : this.supportsInteractivity;
            this._legacyFontType = new $36ee93347ac8a9ee$var$FontTypeDefinition();
            this._legacyFontType.parse(obj);
            if (obj.fontTypes) this.fontTypes = new $36ee93347ac8a9ee$var$FontTypeSet(obj.fontTypes);
            if (obj.lineHeights) this.lineHeights = {
                small: obj.lineHeights["small"],
                default: obj.lineHeights["default"],
                medium: obj.lineHeights["medium"],
                large: obj.lineHeights["large"],
                extraLarge: obj.lineHeights["extraLarge"]
            };
            this.imageSizes = {
                small: obj.imageSizes && obj.imageSizes["small"] || this.imageSizes.small,
                medium: obj.imageSizes && obj.imageSizes["medium"] || this.imageSizes.medium,
                large: obj.imageSizes && obj.imageSizes["large"] || this.imageSizes.large
            };
            this.containerStyles = new $36ee93347ac8a9ee$var$ContainerStyleSet(obj["containerStyles"]);
            this.spacing = {
                small: obj.spacing && obj.spacing["small"] || this.spacing.small,
                default: obj.spacing && obj.spacing["default"] || this.spacing.default,
                medium: obj.spacing && obj.spacing["medium"] || this.spacing.medium,
                large: obj.spacing && obj.spacing["large"] || this.spacing.large,
                extraLarge: obj.spacing && obj.spacing["extraLarge"] || this.spacing.extraLarge,
                padding: obj.spacing && obj.spacing["padding"] || this.spacing.padding
            };
            this.separator = {
                lineThickness: obj.separator && obj.separator["lineThickness"] || this.separator.lineThickness,
                lineColor: obj.separator && obj.separator["lineColor"] || this.separator.lineColor
            };
            this.inputs = new $36ee93347ac8a9ee$var$InputConfig(obj.inputs || this.inputs);
            this.actions = new $36ee93347ac8a9ee$var$ActionsConfig(obj.actions || this.actions);
            this.adaptiveCard = new $36ee93347ac8a9ee$var$AdaptiveCardConfig(obj.adaptiveCard || this.adaptiveCard);
            this.imageSet = new $36ee93347ac8a9ee$var$ImageSetConfig(obj["imageSet"]);
            this.factSet = new $36ee93347ac8a9ee$var$FactSetConfig(obj["factSet"]);
            this.textStyles = new $36ee93347ac8a9ee$var$TextStyleSet(obj["textStyles"]);
            this.textBlock = new $36ee93347ac8a9ee$var$TextBlockConfig(obj["textBlock"]);
        }
    }
    HostConfig.prototype.getFontTypeDefinition = function(style) {
        if (this.fontTypes) return this.fontTypes.getStyleDefinition(style);
        else return style === $iw5eI.FontType.Monospace ? $36ee93347ac8a9ee$var$FontTypeDefinition.monospace : this._legacyFontType;
    };
    HostConfig.prototype.getEffectiveSpacing = function(spacing) {
        switch(spacing){
            case $iw5eI.Spacing.Small:
                return this.spacing.small;
            case $iw5eI.Spacing.Default:
                return this.spacing.default;
            case $iw5eI.Spacing.Medium:
                return this.spacing.medium;
            case $iw5eI.Spacing.Large:
                return this.spacing.large;
            case $iw5eI.Spacing.ExtraLarge:
                return this.spacing.extraLarge;
            case $iw5eI.Spacing.Padding:
                return this.spacing.padding;
            default:
                return 0;
        }
    };
    HostConfig.prototype.paddingDefinitionToSpacingDefinition = function(paddingDefinition) {
        return new $eUh3g.SpacingDefinition(this.getEffectiveSpacing(paddingDefinition.top), this.getEffectiveSpacing(paddingDefinition.right), this.getEffectiveSpacing(paddingDefinition.bottom), this.getEffectiveSpacing(paddingDefinition.left));
    };
    HostConfig.prototype.makeCssClassNames = function() {
        var classNames = [];
        for(var _i = 0; _i < arguments.length; _i++)classNames[_i] = arguments[_i];
        var result = [];
        for(var _a = 0, classNames_1 = classNames; _a < classNames_1.length; _a++){
            var className = classNames_1[_a];
            result.push((this.cssClassNamePrefix ? this.cssClassNamePrefix + "-" : "") + className);
        }
        return result;
    };
    HostConfig.prototype.makeCssClassName = function() {
        var classNames = [];
        for(var _i = 0; _i < arguments.length; _i++)classNames[_i] = arguments[_i];
        var result = this.makeCssClassNames.apply(this, classNames).join(" ");
        return result ? result : "";
    };
    Object.defineProperty(HostConfig.prototype, "fontFamily", {
        get: function() {
            return this._legacyFontType.fontFamily;
        },
        set: function(value) {
            this._legacyFontType.fontFamily = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(HostConfig.prototype, "fontSizes", {
        get: function() {
            return this._legacyFontType.fontSizes;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(HostConfig.prototype, "fontWeights", {
        get: function() {
            return this._legacyFontType.fontWeights;
        },
        enumerable: false,
        configurable: true
    });
    return HostConfig;
}();
module.exports.HostConfig = $36ee93347ac8a9ee$var$HostConfig;
// eslint-disable-next-line @typescript-eslint/naming-convention
module.exports.defaultHostConfig = new $36ee93347ac8a9ee$var$HostConfig({
    supportsInteractivity: true,
    spacing: {
        small: 10,
        default: 20,
        medium: 30,
        large: 40,
        extraLarge: 50,
        padding: 20
    },
    separator: {
        lineThickness: 1,
        lineColor: "#EEEEEE"
    },
    fontTypes: {
        default: {
            fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
            fontSizes: {
                small: 12,
                default: 14,
                medium: 17,
                large: 21,
                extraLarge: 26
            },
            fontWeights: {
                lighter: 200,
                default: 400,
                bolder: 600
            }
        },
        monospace: {
            fontFamily: "'Courier New', Courier, monospace",
            fontSizes: {
                small: 12,
                default: 14,
                medium: 17,
                large: 21,
                extraLarge: 26
            },
            fontWeights: {
                lighter: 200,
                default: 400,
                bolder: 600
            }
        }
    },
    imageSizes: {
        small: 40,
        medium: 80,
        large: 160
    },
    containerStyles: {
        default: {
            backgroundColor: "#FFFFFF",
            foregroundColors: {
                default: {
                    default: "#333333",
                    subtle: "#EE333333"
                },
                dark: {
                    default: "#000000",
                    subtle: "#66000000"
                },
                light: {
                    default: "#FFFFFF",
                    subtle: "#33000000"
                },
                accent: {
                    default: "#2E89FC",
                    subtle: "#882E89FC"
                },
                attention: {
                    default: "#cc3300",
                    subtle: "#DDcc3300"
                },
                good: {
                    default: "#028A02",
                    subtle: "#DD027502"
                },
                warning: {
                    default: "#e69500",
                    subtle: "#DDe69500"
                }
            }
        },
        emphasis: {
            backgroundColor: "#08000000",
            foregroundColors: {
                default: {
                    default: "#333333",
                    subtle: "#EE333333"
                },
                dark: {
                    default: "#000000",
                    subtle: "#66000000"
                },
                light: {
                    default: "#FFFFFF",
                    subtle: "#33000000"
                },
                accent: {
                    default: "#2E89FC",
                    subtle: "#882E89FC"
                },
                attention: {
                    default: "#cc3300",
                    subtle: "#DDcc3300"
                },
                good: {
                    default: "#028A02",
                    subtle: "#DD027502"
                },
                warning: {
                    default: "#e69500",
                    subtle: "#DDe69500"
                }
            }
        },
        accent: {
            backgroundColor: "#C7DEF9",
            foregroundColors: {
                default: {
                    default: "#333333",
                    subtle: "#EE333333"
                },
                dark: {
                    default: "#000000",
                    subtle: "#66000000"
                },
                light: {
                    default: "#FFFFFF",
                    subtle: "#33000000"
                },
                accent: {
                    default: "#2E89FC",
                    subtle: "#882E89FC"
                },
                attention: {
                    default: "#cc3300",
                    subtle: "#DDcc3300"
                },
                good: {
                    default: "#028A02",
                    subtle: "#DD027502"
                },
                warning: {
                    default: "#e69500",
                    subtle: "#DDe69500"
                }
            }
        },
        good: {
            backgroundColor: "#CCFFCC",
            foregroundColors: {
                default: {
                    default: "#333333",
                    subtle: "#EE333333"
                },
                dark: {
                    default: "#000000",
                    subtle: "#66000000"
                },
                light: {
                    default: "#FFFFFF",
                    subtle: "#33000000"
                },
                accent: {
                    default: "#2E89FC",
                    subtle: "#882E89FC"
                },
                attention: {
                    default: "#cc3300",
                    subtle: "#DDcc3300"
                },
                good: {
                    default: "#028A02",
                    subtle: "#DD027502"
                },
                warning: {
                    default: "#e69500",
                    subtle: "#DDe69500"
                }
            }
        },
        attention: {
            backgroundColor: "#FFC5B2",
            foregroundColors: {
                default: {
                    default: "#333333",
                    subtle: "#EE333333"
                },
                dark: {
                    default: "#000000",
                    subtle: "#66000000"
                },
                light: {
                    default: "#FFFFFF",
                    subtle: "#33000000"
                },
                accent: {
                    default: "#2E89FC",
                    subtle: "#882E89FC"
                },
                attention: {
                    default: "#cc3300",
                    subtle: "#DDcc3300"
                },
                good: {
                    default: "#028A02",
                    subtle: "#DD027502"
                },
                warning: {
                    default: "#e69500",
                    subtle: "#DDe69500"
                }
            }
        },
        warning: {
            backgroundColor: "#FFE2B2",
            foregroundColors: {
                default: {
                    default: "#333333",
                    subtle: "#EE333333"
                },
                dark: {
                    default: "#000000",
                    subtle: "#66000000"
                },
                light: {
                    default: "#FFFFFF",
                    subtle: "#33000000"
                },
                accent: {
                    default: "#2E89FC",
                    subtle: "#882E89FC"
                },
                attention: {
                    default: "#cc3300",
                    subtle: "#DDcc3300"
                },
                good: {
                    default: "#028A02",
                    subtle: "#DD027502"
                },
                warning: {
                    default: "#e69500",
                    subtle: "#DDe69500"
                }
            }
        }
    },
    inputs: {
        label: {
            requiredInputs: {
                weight: $iw5eI.TextWeight.Bolder,
                suffix: " *",
                suffixColor: $iw5eI.TextColor.Attention
            },
            optionalInputs: {
                weight: $iw5eI.TextWeight.Bolder
            }
        },
        errorMessage: {
            color: $iw5eI.TextColor.Attention,
            weight: $iw5eI.TextWeight.Bolder
        }
    },
    actions: {
        maxActions: 5,
        spacing: $iw5eI.Spacing.Default,
        buttonSpacing: 10,
        showCard: {
            actionMode: $iw5eI.ShowCardActionMode.Inline,
            inlineTopMargin: 16
        },
        actionsOrientation: $iw5eI.Orientation.Horizontal,
        actionAlignment: $iw5eI.ActionAlignment.Left
    },
    adaptiveCard: {
        allowCustomStyle: false
    },
    imageSet: {
        imageSize: $iw5eI.Size.Medium,
        maxImageHeight: 100
    },
    factSet: {
        title: {
            color: $iw5eI.TextColor.Default,
            size: $iw5eI.TextSize.Default,
            isSubtle: false,
            weight: $iw5eI.TextWeight.Bolder,
            wrap: true,
            maxWidth: 150
        },
        value: {
            color: $iw5eI.TextColor.Default,
            size: $iw5eI.TextSize.Default,
            isSubtle: false,
            weight: $iw5eI.TextWeight.Default,
            wrap: true
        },
        spacing: 10
    }
});

});

parcelRequire.register("J4wUi", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.GlobalRegistry = module.exports.CardObjectRegistry = module.exports.ElementSingletonBehavior = void 0;

var $ldzOp = parcelRequire("ldzOp");
/**
 * Describes whether a certain element can be parsed in a "singleton" context.
 * Specifically, is the element allowed to exist as an object in a context where the
 * parent expects an Array of elements (e.g. `AdaptiveCard.body`)
 *
 * @example - Singleton element in a container (note `items` contains an `object` rather than an `Array<object>`)
 * ```json
 * {
 *     "type": "Container",
 *     "items": {
 *         "type": "AllowedSingletonElement"
 *     }
 * }
 * ```
 */ var $0877b79995ad7350$var$ElementSingletonBehavior;
(function(ElementSingletonBehavior) {
    /** Element only valid in a singleton context. */ ElementSingletonBehavior[ElementSingletonBehavior["Only"] = 0] = "Only";
    /** Element is allowed in a singleton context, but not required to be a singleton. */ ElementSingletonBehavior[ElementSingletonBehavior["Allowed"] = 1] = "Allowed";
    /** Element is not allowed to exist in a singleton context. */ ElementSingletonBehavior[ElementSingletonBehavior["NotAllowed"] = 2] = "NotAllowed";
})($0877b79995ad7350$var$ElementSingletonBehavior = module.exports.ElementSingletonBehavior || (module.exports.ElementSingletonBehavior = {}));
var $0877b79995ad7350$var$CardObjectRegistry = /** @class */ function() {
    function CardObjectRegistry() {
        this._items = {};
    }
    CardObjectRegistry.prototype.findByName = function(typeName) {
        return this._items.hasOwnProperty(typeName) ? this._items[typeName] : undefined;
    };
    CardObjectRegistry.prototype.clear = function() {
        this._items = {};
    };
    CardObjectRegistry.prototype.copyTo = function(target) {
        var keys = Object.keys(this._items);
        for(var _i = 0, keys_1 = keys; _i < keys_1.length; _i++){
            var key = keys_1[_i];
            var typeRegistration = this._items[key];
            target.register(typeRegistration.typeName, typeRegistration.objectType, typeRegistration.schemaVersion, typeRegistration.singletonBehavior);
        }
    };
    CardObjectRegistry.prototype.register = function(typeName, objectType, schemaVersion, singletonBehavior) {
        if (schemaVersion === void 0) schemaVersion = $ldzOp.Versions.v1_0;
        if (singletonBehavior === void 0) singletonBehavior = $0877b79995ad7350$var$ElementSingletonBehavior.NotAllowed;
        var registrationInfo = this.findByName(typeName);
        if (registrationInfo !== undefined) registrationInfo.objectType = objectType;
        else registrationInfo = {
            typeName: typeName,
            objectType: objectType,
            schemaVersion: schemaVersion,
            singletonBehavior: singletonBehavior
        };
        this._items[typeName] = registrationInfo;
    };
    CardObjectRegistry.prototype.unregister = function(typeName) {
        delete this._items[typeName];
    };
    CardObjectRegistry.prototype.createInstance = function(typeName, targetVersion) {
        var registrationInfo = this.findByName(typeName);
        return registrationInfo && registrationInfo.schemaVersion.compareTo(targetVersion) <= 0 ? new registrationInfo.objectType() : undefined;
    };
    CardObjectRegistry.prototype.getItemCount = function() {
        return Object.keys(this._items).length;
    };
    CardObjectRegistry.prototype.getItemAt = function(index) {
        var _this = this;
        return Object.keys(this._items).map(function(e) {
            return _this._items[e];
        })[index];
    };
    return CardObjectRegistry;
}();
module.exports.CardObjectRegistry = $0877b79995ad7350$var$CardObjectRegistry;
// eslint-disable-next-line @typescript-eslint/no-extraneous-class
var $0877b79995ad7350$var$GlobalRegistry = /** @class */ function() {
    function GlobalRegistry() {}
    GlobalRegistry.populateWithDefaultElements = function(registry) {
        registry.clear();
        GlobalRegistry.defaultElements.copyTo(registry);
    };
    GlobalRegistry.populateWithDefaultActions = function(registry) {
        registry.clear();
        GlobalRegistry.defaultActions.copyTo(registry);
    };
    Object.defineProperty(GlobalRegistry, "elements", {
        get: function() {
            if (!GlobalRegistry._elements) {
                GlobalRegistry._elements = new $0877b79995ad7350$var$CardObjectRegistry();
                GlobalRegistry.populateWithDefaultElements(GlobalRegistry._elements);
            }
            return GlobalRegistry._elements;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(GlobalRegistry, "actions", {
        get: function() {
            if (!GlobalRegistry._actions) {
                GlobalRegistry._actions = new $0877b79995ad7350$var$CardObjectRegistry();
                GlobalRegistry.populateWithDefaultActions(GlobalRegistry._actions);
            }
            return GlobalRegistry._actions;
        },
        enumerable: false,
        configurable: true
    });
    GlobalRegistry.reset = function() {
        GlobalRegistry._elements = undefined;
        GlobalRegistry._actions = undefined;
    };
    GlobalRegistry.defaultElements = new $0877b79995ad7350$var$CardObjectRegistry();
    GlobalRegistry.defaultActions = new $0877b79995ad7350$var$CardObjectRegistry();
    return GlobalRegistry;
}();
module.exports.GlobalRegistry = $0877b79995ad7350$var$GlobalRegistry;

});

parcelRequire.register("j1Jxg", function(module, exports) {
"use strict";
var $dda16eb6bb6f7e74$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $dda16eb6bb6f7e74$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CardObject = module.exports.ValidationResults = void 0;

var $iw5eI = parcelRequire("iw5eI");

var $brsVB = parcelRequire("brsVB");

var $eUh3g = parcelRequire("eUh3g");

var $35a5S = parcelRequire("35a5S");

var $ldzOp = parcelRequire("ldzOp");
var $dda16eb6bb6f7e74$var$ValidationResults = /** @class */ function() {
    function ValidationResults() {
        this.allIds = {};
        this.validationEvents = [];
    }
    ValidationResults.prototype.addFailure = function(cardObject, event, message) {
        this.validationEvents.push({
            phase: $iw5eI.ValidationPhase.Validation,
            source: cardObject,
            event: event,
            message: message
        });
    };
    return ValidationResults;
}();
module.exports.ValidationResults = $dda16eb6bb6f7e74$var$ValidationResults;
var $dda16eb6bb6f7e74$var$CardObject = /** @class */ function(_super) {
    $dda16eb6bb6f7e74$var$__extends(CardObject, _super);
    function CardObject() {
        //#region Schema
        var _this = _super !== null && _super.apply(this, arguments) || this;
        //#endregion
        _this._shouldFallback = false;
        return _this;
    }
    CardObject.prototype.getSchemaKey = function() {
        return this.getJsonTypeName();
    };
    Object.defineProperty(CardObject.prototype, "requires", {
        get: function() {
            return this.getValue(CardObject.requiresProperty);
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Checks if this CardObject contains the given DOM Node.
     * @param node The DOM Node to look for.
     * @returns `true` if the DOM Node was found, `false` otherwise.
     */ CardObject.prototype.contains = function(node) {
        if (this._renderedElement) return this._renderedElement.contains(node);
        return false;
    };
    CardObject.prototype.preProcessPropertyValue = function(prop, propertyValue) {
        var value = propertyValue === undefined ? this.getValue(prop) : propertyValue;
        if ($eUh3g.GlobalSettings.allowPreProcessingPropertyValues) {
            // eslint-disable-next-line @typescript-eslint/no-this-alias
            var currentObject = this;
            while(currentObject && !currentObject.onPreProcessPropertyValue)currentObject = currentObject.parent;
            if (currentObject && currentObject.onPreProcessPropertyValue) return currentObject.onPreProcessPropertyValue(this, prop, value);
        }
        return value;
    };
    CardObject.prototype.setParent = function(value) {
        this._parent = value;
    };
    CardObject.prototype.setShouldFallback = function(value) {
        this._shouldFallback = value;
    };
    CardObject.prototype.shouldFallback = function() {
        return this._shouldFallback || !this.requires.areAllMet(this.hostConfig.hostCapabilities);
    };
    CardObject.prototype.getRootObject = function() {
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        var currentObject = this;
        while(currentObject.parent)currentObject = currentObject.parent;
        return currentObject;
    };
    CardObject.prototype.internalValidateProperties = function(context) {
        if (this.id) {
            if (context.allIds.hasOwnProperty(this.id)) {
                if (context.allIds[this.id] === 1) context.addFailure(this, $iw5eI.ValidationEvent.DuplicateId, $brsVB.Strings.errors.duplicateId(this.id));
                context.allIds[this.id] += 1;
            } else context.allIds[this.id] = 1;
        }
    };
    CardObject.prototype.validateProperties = function() {
        var result = new $dda16eb6bb6f7e74$var$ValidationResults();
        this.internalValidateProperties(result);
        return result;
    };
    /**
     * Recursively searches this CardObject and any children to find the
     * innermost CardObject that owns the given DOM Node.
     *
     * @param node The DOM Node to look for.
     *
     * @returns The owner of the given DOM Node, or `undefined` if no owner was found.
     */ CardObject.prototype.findDOMNodeOwner = function(node) {
        // default implementation for CardObjects with no associated children
        return this.contains(node) ? this : undefined;
    };
    CardObject.prototype.releaseDOMResources = function() {
    // Do nothing in base implementation
    };
    Object.defineProperty(CardObject.prototype, "parent", {
        get: function() {
            return this._parent;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CardObject.prototype, "renderedElement", {
        get: function() {
            return this._renderedElement;
        },
        enumerable: false,
        configurable: true
    });
    CardObject.typeNameProperty = new $ldzOp.StringProperty($ldzOp.Versions.v1_0, "type", undefined, undefined, undefined, function(sender) {
        return sender.getJsonTypeName();
    });
    CardObject.idProperty = new $ldzOp.StringProperty($ldzOp.Versions.v1_0, "id");
    CardObject.requiresProperty = new $ldzOp.SerializableObjectProperty($ldzOp.Versions.v1_2, "requires", $35a5S.HostCapabilities, false, new $35a5S.HostCapabilities());
    $dda16eb6bb6f7e74$var$__decorate([
        (0, $ldzOp.property)(CardObject.idProperty)
    ], CardObject.prototype, "id", void 0);
    $dda16eb6bb6f7e74$var$__decorate([
        (0, $ldzOp.property)(CardObject.requiresProperty)
    ], CardObject.prototype, "requires", null);
    return CardObject;
}($ldzOp.SerializableObject);
module.exports.CardObject = $dda16eb6bb6f7e74$var$CardObject;

});

parcelRequire.register("3K4s0", function(module, exports) {
"use strict";
var $2b991ecb5ab02fee$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $2b991ecb5ab02fee$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $2b991ecb5ab02fee$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $2b991ecb5ab02fee$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ContainerWithActions = module.exports.ColumnSet = module.exports.Column = module.exports.Container = module.exports.BackgroundImage = module.exports.ContainerBase = module.exports.StylableCardElementContainer = module.exports.ContainerStyleProperty = module.exports.ActionSet = module.exports.ShowCardAction = module.exports.HttpAction = module.exports.HttpHeader = module.exports.ToggleVisibilityAction = module.exports.OpenUrlAction = module.exports.ExecuteAction = module.exports.SubmitAction = module.exports.SubmitActionBase = module.exports.Action = module.exports.TimeInput = module.exports.TimeProperty = module.exports.DateInput = module.exports.NumberInput = module.exports.ChoiceSetInput = module.exports.Choice = module.exports.ToggleInput = module.exports.TextInput = module.exports.Input = module.exports.Media = module.exports.YouTubePlayer = module.exports.DailymotionPlayer = module.exports.VimeoPlayer = module.exports.IFrameMediaMediaPlayer = module.exports.CustomMediaPlayer = module.exports.HTML5MediaPlayer = module.exports.MediaPlayer = module.exports.MediaSource = module.exports.CaptionSource = module.exports.ContentSource = module.exports.ImageSet = module.exports.CardElementContainer = module.exports.Image = module.exports.FactSet = module.exports.Fact = module.exports.RichTextBlock = module.exports.TextRun = module.exports.TextBlock = module.exports.BaseTextBlock = module.exports.ActionProperty = module.exports.CardElement = module.exports.renderSeparation = void 0;
module.exports.SerializationContext = module.exports.AdaptiveCard = module.exports.Authentication = module.exports.TokenExchangeResource = module.exports.AuthCardButton = module.exports.RefreshDefinition = module.exports.RefreshActionProperty = void 0;

var $iw5eI = parcelRequire("iw5eI");

var $eUh3g = parcelRequire("eUh3g");

var $ioYal = parcelRequire("ioYal");

var $4IoSX = parcelRequire("4IoSX");

var $fQwaQ = parcelRequire("fQwaQ");

var $j1Jxg = parcelRequire("j1Jxg");

var $ldzOp = parcelRequire("ldzOp");

var $J4wUi = parcelRequire("J4wUi");

var $brsVB = parcelRequire("brsVB");

var $eIrtg = parcelRequire("eIrtg");
function $2b991ecb5ab02fee$var$clearElement(element) {
    var _a, _b;
    var trustedHtml = typeof window === "undefined" ? "" : (_b = (_a = window.trustedTypes) === null || _a === void 0 ? void 0 : _a.emptyHTML) !== null && _b !== void 0 ? _b : "";
    element.innerHTML = trustedHtml;
}
function $2b991ecb5ab02fee$var$renderSeparation(hostConfig, separationDefinition, orientation) {
    if (separationDefinition.spacing > 0 || separationDefinition.lineThickness && separationDefinition.lineThickness > 0) {
        var separator = document.createElement("div");
        separator.className = hostConfig.makeCssClassName("ac-" + (orientation === $iw5eI.Orientation.Horizontal ? "horizontal" : "vertical") + "-separator");
        separator.setAttribute("aria-hidden", "true");
        var color = separationDefinition.lineColor ? $ioYal.stringToCssColor(separationDefinition.lineColor) : "";
        if (orientation === $iw5eI.Orientation.Horizontal) {
            if (separationDefinition.lineThickness) {
                separator.style.paddingTop = separationDefinition.spacing / 2 + "px";
                separator.style.marginBottom = separationDefinition.spacing / 2 + "px";
                separator.style.borderBottom = separationDefinition.lineThickness + "px solid " + color;
            } else separator.style.height = separationDefinition.spacing + "px";
        } else if (separationDefinition.lineThickness) {
            separator.style.paddingLeft = separationDefinition.spacing / 2 + "px";
            separator.style.marginRight = separationDefinition.spacing / 2 + "px";
            separator.style.borderRight = separationDefinition.lineThickness + "px solid " + color;
        } else separator.style.width = separationDefinition.spacing + "px";
        separator.style.overflow = "hidden";
        separator.style.flex = "0 0 auto";
        return separator;
    } else return undefined;
}
module.exports.renderSeparation = $2b991ecb5ab02fee$var$renderSeparation;
var $2b991ecb5ab02fee$var$CardElement = /** @class */ function(_super) {
    $2b991ecb5ab02fee$var$__extends(CardElement, _super);
    function CardElement() {
        //#region Schema
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._truncatedDueToOverflow = false;
        return _this;
    }
    Object.defineProperty(CardElement.prototype, "lang", {
        get: function() {
            var lang = this.getValue(CardElement.langProperty);
            if (lang) return lang;
            else {
                if (this.parent) return this.parent.lang;
                else return undefined;
            }
        },
        set: function(value) {
            this.setValue(CardElement.langProperty, value);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CardElement.prototype, "isVisible", {
        get: function() {
            return this.getValue(CardElement.isVisibleProperty);
        },
        set: function(value) {
            // If the element is going to be hidden, reset any changes that were due
            // to overflow truncation (this ensures that if the element is later
            // un-hidden it has the right content)
            if ($eUh3g.GlobalSettings.useAdvancedCardBottomTruncation && !value) this.undoOverflowTruncation();
            if (this.isVisible !== value) {
                this.setValue(CardElement.isVisibleProperty, value);
                this.updateRenderedElementVisibility();
                if (this._renderedElement) $2b991ecb5ab02fee$var$raiseElementVisibilityChangedEvent(this);
            }
            if (this._renderedElement) this._renderedElement.setAttribute("aria-expanded", value.toString());
        },
        enumerable: false,
        configurable: true
    });
    CardElement.prototype.internalRenderSeparator = function() {
        var renderedSeparator = $2b991ecb5ab02fee$var$renderSeparation(this.hostConfig, {
            spacing: this.hostConfig.getEffectiveSpacing(this.spacing),
            lineThickness: this.separator ? this.hostConfig.separator.lineThickness : undefined,
            lineColor: this.separator ? this.hostConfig.separator.lineColor : undefined
        }, this.separatorOrientation);
        if ($eUh3g.GlobalSettings.alwaysBleedSeparators && renderedSeparator && this.separatorOrientation === $iw5eI.Orientation.Horizontal) {
            // Adjust separator's margins if the option to always bleed separators is turned on
            var parentContainer = this.getParentContainer();
            if (parentContainer && parentContainer.getEffectivePadding()) {
                var parentPhysicalPadding = this.hostConfig.paddingDefinitionToSpacingDefinition(parentContainer.getEffectivePadding());
                renderedSeparator.style.marginLeft = "-" + parentPhysicalPadding.left + "px";
                renderedSeparator.style.marginRight = "-" + parentPhysicalPadding.right + "px";
            }
        }
        return renderedSeparator;
    };
    CardElement.prototype.updateRenderedElementVisibility = function() {
        var displayMode = this.isDesignMode() || this.isVisible ? this._defaultRenderedElementDisplayMode : "none";
        if (this._renderedElement) {
            if (displayMode) this._renderedElement.style.display = displayMode;
            else this._renderedElement.style.removeProperty("display");
        }
        if (this._separatorElement) {
            if (this.parent && this.parent.isFirstElement(this)) this._separatorElement.style.display = "none";
            else if (displayMode) this._separatorElement.style.display = displayMode;
            else this._separatorElement.style.removeProperty("display");
        }
    };
    CardElement.prototype.hideElementDueToOverflow = function() {
        if (this._renderedElement && this.isVisible) {
            this._renderedElement.style.visibility = "hidden";
            this.isVisible = false;
            $2b991ecb5ab02fee$var$raiseElementVisibilityChangedEvent(this, false);
        }
    };
    CardElement.prototype.showElementHiddenDueToOverflow = function() {
        if (this._renderedElement && !this.isVisible) {
            this._renderedElement.style.removeProperty("visibility");
            this.isVisible = true;
            $2b991ecb5ab02fee$var$raiseElementVisibilityChangedEvent(this, false);
        }
    };
    // Marked private to emulate internal access
    CardElement.prototype.handleOverflow = function(maxHeight) {
        if (this.isVisible || this.isHiddenDueToOverflow()) {
            var handled = this.truncateOverflow(maxHeight);
            // Even if we were unable to truncate the element to fit this time,
            // it still could have been previously truncated
            this._truncatedDueToOverflow = handled || this._truncatedDueToOverflow;
            if (!handled) this.hideElementDueToOverflow();
            else if (handled && !this.isVisible) this.showElementHiddenDueToOverflow();
        }
    };
    // Marked private to emulate internal access
    CardElement.prototype.resetOverflow = function() {
        var sizeChanged = false;
        if (this._truncatedDueToOverflow) {
            this.undoOverflowTruncation();
            this._truncatedDueToOverflow = false;
            sizeChanged = true;
        }
        if (this.isHiddenDueToOverflow()) this.showElementHiddenDueToOverflow();
        return sizeChanged;
    };
    CardElement.prototype.getDefaultSerializationContext = function() {
        return new $2b991ecb5ab02fee$var$SerializationContext();
    };
    CardElement.prototype.createPlaceholderElement = function() {
        var styleDefinition = this.getEffectiveStyleDefinition();
        var foregroundCssColor = $ioYal.stringToCssColor(styleDefinition.foregroundColors.default.subtle);
        var element = document.createElement("div");
        element.style.border = "1px dashed " + foregroundCssColor;
        element.style.padding = "4px";
        element.style.minHeight = "32px";
        element.style.fontSize = "10px";
        if (foregroundCssColor) element.style.color = foregroundCssColor;
        element.innerText = "Empty " + this.getJsonTypeName();
        return element;
    };
    CardElement.prototype.adjustRenderedElementSize = function(renderedElement) {
        if (this.height === "auto") renderedElement.style.flex = "0 0 auto";
        else renderedElement.style.flex = "1 1 auto";
    };
    CardElement.prototype.isDisplayed = function() {
        return this._renderedElement !== undefined && this.isVisible && this._renderedElement.offsetHeight > 0;
    };
    CardElement.prototype.overrideInternalRender = function() {
        return this.internalRender();
    };
    CardElement.prototype.applyPadding = function() {
        if (this.separatorElement && this.separatorOrientation === $iw5eI.Orientation.Horizontal) {
            if ($eUh3g.GlobalSettings.alwaysBleedSeparators && !this.isBleeding()) {
                var padding = new $eUh3g.PaddingDefinition();
                this.getImmediateSurroundingPadding(padding);
                var physicalPadding = this.hostConfig.paddingDefinitionToSpacingDefinition(padding);
                this.separatorElement.style.marginLeft = "-" + physicalPadding.left + "px";
                this.separatorElement.style.marginRight = "-" + physicalPadding.right + "px";
            } else {
                this.separatorElement.style.marginRight = "0";
                this.separatorElement.style.marginLeft = "0";
            }
        }
    };
    /*
     * Called when this element overflows the bottom of the card.
     * maxHeight will be the amount of space still available on the card (0 if
     * the element is fully off the card).
     */ CardElement.prototype.truncateOverflow = function(_maxHeight) {
        // Child implementations should return true if the element handled
        // the truncation request such that its content fits within maxHeight,
        // false if the element should fall back to being hidden
        return false;
    };
    /*
     * This should reverse any changes performed in truncateOverflow().
     */ CardElement.prototype.undoOverflowTruncation = function() {
        return;
    };
    CardElement.prototype.getDefaultPadding = function() {
        return new $eUh3g.PaddingDefinition();
    };
    CardElement.prototype.getHasBackground = function(ignoreBackgroundImages) {
        if (ignoreBackgroundImages === void 0) ignoreBackgroundImages = false;
        return false;
    };
    CardElement.prototype.getHasBorder = function() {
        return false;
    };
    CardElement.prototype.getPadding = function() {
        return this._padding;
    };
    CardElement.prototype.setPadding = function(value) {
        this._padding = value;
    };
    CardElement.prototype.shouldSerialize = function(context) {
        return context.elementRegistry.findByName(this.getJsonTypeName()) !== undefined;
    };
    Object.defineProperty(CardElement.prototype, "useDefaultSizing", {
        get: function() {
            return true;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CardElement.prototype, "separatorOrientation", {
        get: function() {
            return $iw5eI.Orientation.Horizontal;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CardElement.prototype, "defaultStyle", {
        get: function() {
            return $iw5eI.ContainerStyle.Default;
        },
        enumerable: false,
        configurable: true
    });
    CardElement.prototype.parse = function(source, context) {
        _super.prototype.parse.call(this, source, context ? context : new $2b991ecb5ab02fee$var$SerializationContext());
    };
    CardElement.prototype.asString = function() {
        return "";
    };
    CardElement.prototype.isBleeding = function() {
        return false;
    };
    CardElement.prototype.getEffectiveStyle = function() {
        if (this.parent) return this.parent.getEffectiveStyle();
        return this.defaultStyle;
    };
    CardElement.prototype.getEffectiveStyleDefinition = function() {
        return this.hostConfig.containerStyles.getStyleByName(this.getEffectiveStyle());
    };
    CardElement.prototype.getEffectiveTextStyleDefinition = function() {
        if (this.parent) return this.parent.getEffectiveTextStyleDefinition();
        return this.hostConfig.textStyles.default;
    };
    CardElement.prototype.getForbiddenActionTypes = function() {
        return [];
    };
    CardElement.prototype.getImmediateSurroundingPadding = function(result, processTop, processRight, processBottom, processLeft) {
        if (processTop === void 0) processTop = true;
        if (processRight === void 0) processRight = true;
        if (processBottom === void 0) processBottom = true;
        if (processLeft === void 0) processLeft = true;
        if (this.parent) {
            var doProcessTop = processTop && this.parent.isTopElement(this);
            var doProcessRight = processRight && this.parent.isRightMostElement(this);
            var doProcessBottom = processBottom && this.parent.isBottomElement(this);
            var doProcessLeft = processLeft && this.parent.isLeftMostElement(this);
            var effectivePadding = this.parent.getEffectivePadding();
            if (effectivePadding) {
                if (doProcessTop && effectivePadding.top !== $iw5eI.Spacing.None) {
                    result.top = effectivePadding.top;
                    doProcessTop = false;
                }
                if (doProcessRight && effectivePadding.right !== $iw5eI.Spacing.None) {
                    result.right = effectivePadding.right;
                    doProcessRight = false;
                }
                if (doProcessBottom && effectivePadding.bottom !== $iw5eI.Spacing.None) {
                    result.bottom = effectivePadding.bottom;
                    doProcessBottom = false;
                }
                if (doProcessLeft && effectivePadding.left !== $iw5eI.Spacing.None) {
                    result.left = effectivePadding.left;
                    doProcessLeft = false;
                }
            }
            if (doProcessTop || doProcessRight || doProcessBottom || doProcessLeft) this.parent.getImmediateSurroundingPadding(result, doProcessTop, doProcessRight, doProcessBottom, doProcessLeft);
        }
    };
    CardElement.prototype.getActionCount = function() {
        return 0;
    };
    CardElement.prototype.getActionAt = function(index) {
        throw new Error($brsVB.Strings.errors.indexOutOfRange(index));
    };
    CardElement.prototype.indexOfAction = function(action) {
        for(var i = 0; i < this.getActionCount(); i++){
            if (this.getActionAt(i) === action) return i;
        }
        return -1;
    };
    CardElement.prototype.remove = function() {
        if (this.parent && this.parent instanceof $2b991ecb5ab02fee$var$CardElementContainer) return this.parent.removeItem(this);
        return false;
    };
    CardElement.prototype.render = function() {
        this._renderedElement = this.overrideInternalRender();
        this._separatorElement = this.internalRenderSeparator();
        if (this._renderedElement) {
            if (this.id) this._renderedElement.id = this.id;
            if (this.customCssSelector) this._renderedElement.classList.add(this.customCssSelector);
            this._renderedElement.style.boxSizing = "border-box";
            this._defaultRenderedElementDisplayMode = this._renderedElement.style.display ? this._renderedElement.style.display : undefined;
            this.adjustRenderedElementSize(this._renderedElement);
            this.updateLayout(false);
        } else if (this.isDesignMode()) this._renderedElement = this.createPlaceholderElement();
        this.getRootElement().updateActionsEnabledState();
        return this._renderedElement;
    };
    CardElement.prototype.updateLayout = function(_processChildren) {
        if (_processChildren === void 0) _processChildren = true;
        this.updateRenderedElementVisibility();
        this.applyPadding();
    };
    CardElement.prototype.updateActionsEnabledState = function() {
        var allActions = this.getRootElement().getAllActions();
        for(var _i = 0, allActions_1 = allActions; _i < allActions_1.length; _i++){
            var action = allActions_1[_i];
            action.updateEnabledState();
        }
    };
    CardElement.prototype.indexOf = function(_cardElement) {
        return -1;
    };
    CardElement.prototype.isDesignMode = function() {
        var rootElement = this.getRootElement();
        return rootElement instanceof $2b991ecb5ab02fee$var$AdaptiveCard && rootElement.designMode;
    };
    CardElement.prototype.isFirstElement = function(_element) {
        return true;
    };
    CardElement.prototype.isLastElement = function(_element) {
        return true;
    };
    CardElement.prototype.isAtTheVeryLeft = function() {
        return this.parent ? this.parent.isLeftMostElement(this) && this.parent.isAtTheVeryLeft() : true;
    };
    CardElement.prototype.isAtTheVeryRight = function() {
        return this.parent ? this.parent.isRightMostElement(this) && this.parent.isAtTheVeryRight() : true;
    };
    CardElement.prototype.isAtTheVeryTop = function() {
        return this.parent ? this.parent.isFirstElement(this) && this.parent.isAtTheVeryTop() : true;
    };
    CardElement.prototype.isAtTheVeryBottom = function() {
        return this.parent ? this.parent.isLastElement(this) && this.parent.isAtTheVeryBottom() : true;
    };
    CardElement.prototype.isBleedingAtTop = function() {
        return false;
    };
    CardElement.prototype.isBleedingAtBottom = function() {
        return false;
    };
    CardElement.prototype.isLeftMostElement = function(_element) {
        return true;
    };
    CardElement.prototype.isRightMostElement = function(_element) {
        return true;
    };
    CardElement.prototype.isTopElement = function(element) {
        return this.isFirstElement(element);
    };
    CardElement.prototype.isBottomElement = function(element) {
        return this.isLastElement(element);
    };
    CardElement.prototype.isHiddenDueToOverflow = function() {
        return this._renderedElement !== undefined && this._renderedElement.style.visibility === "hidden";
    };
    CardElement.prototype.getRootElement = function() {
        return this.getRootObject();
    };
    CardElement.prototype.getParentContainer = function() {
        var currentElement = this.parent;
        while(currentElement){
            if (currentElement instanceof $2b991ecb5ab02fee$var$Container) return currentElement;
            currentElement = currentElement.parent;
        }
        return undefined;
    };
    CardElement.prototype.getAllInputs = function(processActions) {
        if (processActions === void 0) processActions = true;
        return [];
    };
    CardElement.prototype.getAllActions = function() {
        var result = [];
        for(var i = 0; i < this.getActionCount(); i++){
            var action = this.getActionAt(i);
            if (action) result.push(action);
        }
        return result;
    };
    CardElement.prototype.getResourceInformation = function() {
        return [];
    };
    CardElement.prototype.getElementById = function(id) {
        return this.id === id ? this : undefined;
    };
    CardElement.prototype.getActionById = function(_id) {
        return undefined;
    };
    CardElement.prototype.getEffectivePadding = function() {
        var padding = this.getPadding();
        return padding ? padding : this.getDefaultPadding();
    };
    CardElement.prototype.getEffectiveHorizontalAlignment = function() {
        if (this.horizontalAlignment !== undefined) return this.horizontalAlignment;
        if (this.parent) return this.parent.getEffectiveHorizontalAlignment();
        return $iw5eI.HorizontalAlignment.Left;
    };
    Object.defineProperty(CardElement.prototype, "hostConfig", {
        get: function() {
            if (this._hostConfig) return this._hostConfig;
            else {
                if (this.parent) return this.parent.hostConfig;
                else return $4IoSX.defaultHostConfig;
            }
        },
        set: function(value) {
            this._hostConfig = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CardElement.prototype, "index", {
        get: function() {
            if (this.parent) return this.parent.indexOf(this);
            else return 0;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CardElement.prototype, "isInteractive", {
        get: function() {
            return false;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CardElement.prototype, "isStandalone", {
        get: function() {
            return true;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CardElement.prototype, "isInline", {
        get: function() {
            return false;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CardElement.prototype, "hasVisibleSeparator", {
        get: function() {
            if (this.parent && this.separatorElement) return !this.parent.isFirstElement(this) && (this.isVisible || this.isDesignMode());
            else return false;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CardElement.prototype, "separatorElement", {
        get: function() {
            return this._separatorElement;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CardElement.prototype, "parent", {
        get: function() {
            return this._parent;
        },
        enumerable: false,
        configurable: true
    });
    CardElement.prototype.getElementSingletonBehavior = function() {
        return $J4wUi.ElementSingletonBehavior.NotAllowed;
    };
    CardElement.langProperty = new $ldzOp.StringProperty($ldzOp.Versions.v1_1, "lang", true, /^[a-z]{2,3}$/gi);
    CardElement.isVisibleProperty = new $ldzOp.BoolProperty($ldzOp.Versions.v1_2, "isVisible", true);
    CardElement.separatorProperty = new $ldzOp.BoolProperty($ldzOp.Versions.v1_0, "separator", false);
    CardElement.heightProperty = new $ldzOp.ValueSetProperty($ldzOp.Versions.v1_1, "height", [
        {
            value: "auto"
        },
        {
            value: "stretch"
        }
    ], "auto");
    CardElement.horizontalAlignmentProperty = new $ldzOp.EnumProperty($ldzOp.Versions.v1_0, "horizontalAlignment", $iw5eI.HorizontalAlignment);
    CardElement.spacingProperty = new $ldzOp.EnumProperty($ldzOp.Versions.v1_0, "spacing", $iw5eI.Spacing, $iw5eI.Spacing.Default);
    $2b991ecb5ab02fee$var$__decorate([
        (0, $ldzOp.property)(CardElement.horizontalAlignmentProperty)
    ], CardElement.prototype, "horizontalAlignment", void 0);
    $2b991ecb5ab02fee$var$__decorate([
        (0, $ldzOp.property)(CardElement.spacingProperty)
    ], CardElement.prototype, "spacing", void 0);
    $2b991ecb5ab02fee$var$__decorate([
        (0, $ldzOp.property)(CardElement.separatorProperty)
    ], CardElement.prototype, "separator", void 0);
    $2b991ecb5ab02fee$var$__decorate([
        (0, $ldzOp.property)(CardElement.heightProperty)
    ], CardElement.prototype, "height", void 0);
    $2b991ecb5ab02fee$var$__decorate([
        (0, $ldzOp.property)(CardElement.langProperty)
    ], CardElement.prototype, "lang", null);
    $2b991ecb5ab02fee$var$__decorate([
        (0, $ldzOp.property)(CardElement.isVisibleProperty)
    ], CardElement.prototype, "isVisible", null);
    return CardElement;
}($j1Jxg.CardObject);
module.exports.CardElement = $2b991ecb5ab02fee$var$CardElement;
var $2b991ecb5ab02fee$var$ActionProperty = /** @class */ function(_super) {
    $2b991ecb5ab02fee$var$__extends(ActionProperty, _super);
    function ActionProperty(targetVersion, name, forbiddenActionTypes) {
        if (forbiddenActionTypes === void 0) forbiddenActionTypes = [];
        var _this = _super.call(this, targetVersion, name, undefined) || this;
        _this.targetVersion = targetVersion;
        _this.name = name;
        _this.forbiddenActionTypes = forbiddenActionTypes;
        return _this;
    }
    ActionProperty.prototype.parse = function(sender, source, context) {
        var parent = sender;
        return context.parseAction(parent, source[this.name], this.forbiddenActionTypes, parent.isDesignMode());
    };
    ActionProperty.prototype.toJSON = function(sender, target, value, context) {
        context.serializeValue(target, this.name, value ? value.toJSON(context) : undefined, undefined, true);
    };
    return ActionProperty;
}($ldzOp.PropertyDefinition);
module.exports.ActionProperty = $2b991ecb5ab02fee$var$ActionProperty;
var $2b991ecb5ab02fee$var$BaseTextBlock = /** @class */ function(_super) {
    $2b991ecb5ab02fee$var$__extends(BaseTextBlock, _super);
    function BaseTextBlock(text) {
        var _this = _super.call(this) || this;
        _this.ariaHidden = false;
        if (text) _this.text = text;
        return _this;
    }
    BaseTextBlock.prototype.populateSchema = function(schema) {
        _super.prototype.populateSchema.call(this, schema);
        // selectAction is declared on BaseTextBlock but is only exposed on TextRun,
        // so the property is removed from the BaseTextBlock schema.
        schema.remove(BaseTextBlock.selectActionProperty);
    };
    Object.defineProperty(BaseTextBlock.prototype, "text", {
        get: function() {
            return this.getValue(BaseTextBlock.textProperty);
        },
        set: function(value) {
            this.setText(value);
        },
        enumerable: false,
        configurable: true
    });
    //#endregion
    BaseTextBlock.prototype.getFontSize = function(fontType) {
        switch(this.effectiveSize){
            case $iw5eI.TextSize.Small:
                return fontType.fontSizes.small;
            case $iw5eI.TextSize.Medium:
                return fontType.fontSizes.medium;
            case $iw5eI.TextSize.Large:
                return fontType.fontSizes.large;
            case $iw5eI.TextSize.ExtraLarge:
                return fontType.fontSizes.extraLarge;
            default:
                return fontType.fontSizes.default;
        }
    };
    BaseTextBlock.prototype.getColorDefinition = function(colorSet, color) {
        switch(color){
            case $iw5eI.TextColor.Accent:
                return colorSet.accent;
            case $iw5eI.TextColor.Dark:
                return colorSet.dark;
            case $iw5eI.TextColor.Light:
                return colorSet.light;
            case $iw5eI.TextColor.Good:
                return colorSet.good;
            case $iw5eI.TextColor.Warning:
                return colorSet.warning;
            case $iw5eI.TextColor.Attention:
                return colorSet.attention;
            default:
                return colorSet.default;
        }
    };
    BaseTextBlock.prototype.setText = function(value) {
        this.setValue(BaseTextBlock.textProperty, value);
    };
    BaseTextBlock.prototype.init = function(textDefinition) {
        this.size = textDefinition.size;
        this.weight = textDefinition.weight;
        this.color = textDefinition.color;
        this.isSubtle = textDefinition.isSubtle;
    };
    BaseTextBlock.prototype.asString = function() {
        return this.text;
    };
    BaseTextBlock.prototype.applyStylesTo = function(targetElement) {
        var fontType = this.hostConfig.getFontTypeDefinition(this.effectiveFontType);
        if (fontType.fontFamily) targetElement.style.fontFamily = fontType.fontFamily;
        var fontSize;
        switch(this.effectiveSize){
            case $iw5eI.TextSize.Small:
                fontSize = fontType.fontSizes.small;
                break;
            case $iw5eI.TextSize.Medium:
                fontSize = fontType.fontSizes.medium;
                break;
            case $iw5eI.TextSize.Large:
                fontSize = fontType.fontSizes.large;
                break;
            case $iw5eI.TextSize.ExtraLarge:
                fontSize = fontType.fontSizes.extraLarge;
                break;
            default:
                fontSize = fontType.fontSizes.default;
                break;
        }
        targetElement.style.fontSize = fontSize + "px";
        var colorDefinition = this.getColorDefinition(this.getEffectiveStyleDefinition().foregroundColors, this.effectiveColor);
        var targetColor = $ioYal.stringToCssColor(this.effectiveIsSubtle ? colorDefinition.subtle : colorDefinition.default);
        if (targetColor) targetElement.style.color = targetColor;
        var fontWeight;
        switch(this.effectiveWeight){
            case $iw5eI.TextWeight.Lighter:
                fontWeight = fontType.fontWeights.lighter;
                break;
            case $iw5eI.TextWeight.Bolder:
                fontWeight = fontType.fontWeights.bolder;
                break;
            default:
                fontWeight = fontType.fontWeights.default;
                break;
        }
        targetElement.style.fontWeight = fontWeight.toString();
        if (this.ariaHidden) targetElement.setAttribute("aria-hidden", "true");
    };
    BaseTextBlock.prototype.getAllActions = function() {
        var result = _super.prototype.getAllActions.call(this);
        if (this.selectAction) result.push(this.selectAction);
        return result;
    };
    Object.defineProperty(BaseTextBlock.prototype, "effectiveColor", {
        get: function() {
            return this.color !== undefined ? this.color : this.getEffectiveTextStyleDefinition().color;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BaseTextBlock.prototype, "effectiveFontType", {
        get: function() {
            return this.fontType !== undefined ? this.fontType : this.getEffectiveTextStyleDefinition().fontType;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BaseTextBlock.prototype, "effectiveIsSubtle", {
        get: function() {
            return this.isSubtle !== undefined ? this.isSubtle : this.getEffectiveTextStyleDefinition().isSubtle;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BaseTextBlock.prototype, "effectiveSize", {
        get: function() {
            return this.size !== undefined ? this.size : this.getEffectiveTextStyleDefinition().size;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BaseTextBlock.prototype, "effectiveWeight", {
        get: function() {
            return this.weight !== undefined ? this.weight : this.getEffectiveTextStyleDefinition().weight;
        },
        enumerable: false,
        configurable: true
    });
    //#region Schema
    BaseTextBlock.textProperty = new $ldzOp.StringProperty($ldzOp.Versions.v1_0, "text", true);
    BaseTextBlock.sizeProperty = new $ldzOp.EnumProperty($ldzOp.Versions.v1_0, "size", $iw5eI.TextSize);
    BaseTextBlock.weightProperty = new $ldzOp.EnumProperty($ldzOp.Versions.v1_0, "weight", $iw5eI.TextWeight);
    BaseTextBlock.colorProperty = new $ldzOp.EnumProperty($ldzOp.Versions.v1_0, "color", $iw5eI.TextColor);
    BaseTextBlock.isSubtleProperty = new $ldzOp.BoolProperty($ldzOp.Versions.v1_0, "isSubtle");
    BaseTextBlock.fontTypeProperty = new $ldzOp.EnumProperty($ldzOp.Versions.v1_2, "fontType", $iw5eI.FontType);
    BaseTextBlock.selectActionProperty = new $2b991ecb5ab02fee$var$ActionProperty($ldzOp.Versions.v1_1, "selectAction", [
        "Action.ShowCard"
    ]);
    $2b991ecb5ab02fee$var$__decorate([
        (0, $ldzOp.property)(BaseTextBlock.sizeProperty)
    ], BaseTextBlock.prototype, "size", void 0);
    $2b991ecb5ab02fee$var$__decorate([
        (0, $ldzOp.property)(BaseTextBlock.weightProperty)
    ], BaseTextBlock.prototype, "weight", void 0);
    $2b991ecb5ab02fee$var$__decorate([
        (0, $ldzOp.property)(BaseTextBlock.colorProperty)
    ], BaseTextBlock.prototype, "color", void 0);
    $2b991ecb5ab02fee$var$__decorate([
        (0, $ldzOp.property)(BaseTextBlock.fontTypeProperty)
    ], BaseTextBlock.prototype, "fontType", void 0);
    $2b991ecb5ab02fee$var$__decorate([
        (0, $ldzOp.property)(BaseTextBlock.isSubtleProperty)
    ], BaseTextBlock.prototype, "isSubtle", void 0);
    $2b991ecb5ab02fee$var$__decorate([
        (0, $ldzOp.property)(BaseTextBlock.textProperty)
    ], BaseTextBlock.prototype, "text", null);
    $2b991ecb5ab02fee$var$__decorate([
        (0, $ldzOp.property)(BaseTextBlock.selectActionProperty)
    ], BaseTextBlock.prototype, "selectAction", void 0);
    return BaseTextBlock;
}($2b991ecb5ab02fee$var$CardElement);
module.exports.BaseTextBlock = $2b991ecb5ab02fee$var$BaseTextBlock;
var $2b991ecb5ab02fee$var$TextBlock = /** @class */ function(_super) {
    $2b991ecb5ab02fee$var$__extends(TextBlock, _super);
    function TextBlock() {
        //#region Schema
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.wrap = false;
        _this._treatAsPlainText = true;
        _this.useMarkdown = true;
        return _this;
    }
    TextBlock.prototype.restoreOriginalContent = function() {
        var _a, _b;
        if (this.renderedElement !== undefined) {
            if (this.maxLines && this.maxLines > 0) this.renderedElement.style.maxHeight = this._computedLineHeight * this.maxLines + "px";
            var originalHtml = (_b = (_a = TextBlock._ttRoundtripPolicy) === null || _a === void 0 ? void 0 : _a.createHTML(this._originalInnerHtml)) !== null && _b !== void 0 ? _b : this._originalInnerHtml;
            this.renderedElement.innerHTML = originalHtml;
        }
    };
    TextBlock.prototype.truncateIfSupported = function(maxHeight) {
        if (this.renderedElement !== undefined) {
            // For now, only truncate TextBlocks that contain just a single
            // paragraph -- since the maxLines calculation doesn't take into
            // account Markdown lists
            var children = this.renderedElement.children;
            var isTextOnly = !children.length;
            var truncationSupported = isTextOnly || children.length === 1 && children[0].tagName.toLowerCase() === "p" && !children[0].children.length;
            if (truncationSupported) {
                var element = isTextOnly ? this.renderedElement : children[0];
                $ioYal.truncateText(element, maxHeight, this._computedLineHeight);
                return true;
            }
        }
        return false;
    };
    TextBlock.prototype.setText = function(value) {
        _super.prototype.setText.call(this, value);
        this._processedText = undefined;
    };
    TextBlock.prototype.internalRender = function() {
        var _this = this;
        var _a, _b;
        this._processedText = undefined;
        if (this.text) {
            var preProcessedText = this.preProcessPropertyValue($2b991ecb5ab02fee$var$BaseTextBlock.textProperty);
            var hostConfig = this.hostConfig;
            var element = void 0;
            if (this.forElementId) {
                var labelElement = document.createElement("label");
                labelElement.htmlFor = this.forElementId;
                element = labelElement;
            } else element = document.createElement("div");
            element.classList.add(hostConfig.makeCssClassName("ac-textBlock"));
            element.style.overflow = "hidden";
            this.applyStylesTo(element);
            if (this.style === "heading") {
                element.setAttribute("role", "heading");
                var headingLevel = this.hostConfig.textBlock.headingLevel;
                if (headingLevel !== undefined && headingLevel > 0) element.setAttribute("aria-level", headingLevel.toString());
            }
            if (this.selectAction && hostConfig.supportsInteractivity) {
                element.onclick = function(e) {
                    if (_this.selectAction && _this.selectAction.isEffectivelyEnabled()) {
                        e.preventDefault();
                        e.cancelBubble = true;
                        _this.selectAction.execute();
                    }
                };
                this.selectAction.setupElementForAccessibility(element);
                if (this.selectAction.isEffectivelyEnabled()) element.classList.add(hostConfig.makeCssClassName("ac-selectable"));
            }
            if (!this._processedText) {
                this._treatAsPlainText = true;
                var formattedText = $fQwaQ.formatText(this.lang, preProcessedText);
                if (this.useMarkdown && formattedText) {
                    if ($eUh3g.GlobalSettings.allowMarkForTextHighlighting) formattedText = formattedText.replace(/<mark>/g, "===").replace(/<\/mark>/g, "/==/");
                    var markdownProcessingResult = $2b991ecb5ab02fee$var$AdaptiveCard.applyMarkdown(formattedText);
                    if (markdownProcessingResult.didProcess && markdownProcessingResult.outputHtml) {
                        this._processedText = markdownProcessingResult.outputHtml;
                        this._treatAsPlainText = false;
                        // Only process <mark> tag if markdown processing was applied because
                        // markdown processing is also responsible for sanitizing the input string
                        if ($eUh3g.GlobalSettings.allowMarkForTextHighlighting && this._processedText) {
                            var markStyle = "";
                            var effectiveStyle = this.getEffectiveStyleDefinition();
                            if (effectiveStyle.highlightBackgroundColor) markStyle += "background-color: " + effectiveStyle.highlightBackgroundColor + ";";
                            if (effectiveStyle.highlightForegroundColor) markStyle += "color: " + effectiveStyle.highlightForegroundColor + ";";
                            if (markStyle) markStyle = 'style="' + markStyle + '"';
                            this._processedText = this._processedText.replace(/===/g, "<mark " + markStyle + ">").replace(/\/==\//g, "</mark>");
                        }
                    } else {
                        this._processedText = formattedText;
                        this._treatAsPlainText = true;
                    }
                } else {
                    this._processedText = formattedText;
                    this._treatAsPlainText = true;
                }
            }
            if (!this._processedText) this._processedText = "";
            if (this._treatAsPlainText) element.innerText = this._processedText;
            else {
                var processedHtml = (_b = (_a = TextBlock._ttMarkdownPolicy) === null || _a === void 0 ? void 0 : _a.createHTML(this._processedText)) !== null && _b !== void 0 ? _b : this._processedText;
                element.innerHTML = processedHtml;
            }
            if (element.firstElementChild instanceof HTMLElement) {
                var firstElementChild = element.firstElementChild;
                firstElementChild.style.marginTop = "0px";
                firstElementChild.style.width = "100%";
                if (!this.wrap) {
                    firstElementChild.style.overflow = "hidden";
                    firstElementChild.style.textOverflow = "ellipsis";
                }
            }
            if (element.lastElementChild instanceof HTMLElement) element.lastElementChild.style.marginBottom = "0px";
            var anchors = element.getElementsByTagName("a");
            var _loop_1 = function(anchor) {
                anchor.classList.add(hostConfig.makeCssClassName("ac-anchor"));
                anchor.target = "_blank";
                anchor.onclick = function(e) {
                    if ($2b991ecb5ab02fee$var$raiseAnchorClickedEvent(_this, anchor, e)) {
                        e.preventDefault();
                        e.cancelBubble = true;
                    }
                };
                anchor.oncontextmenu = function(e) {
                    if ($2b991ecb5ab02fee$var$raiseAnchorClickedEvent(_this, anchor, e)) {
                        e.preventDefault();
                        e.cancelBubble = true;
                        return false;
                    }
                    return true;
                };
            };
            for(var _i = 0, _c = Array.from(anchors); _i < _c.length; _i++){
                var anchor = _c[_i];
                _loop_1(anchor);
            }
            if (this.wrap) {
                element.style.wordWrap = "break-word";
                if (this.maxLines && this.maxLines > 0) {
                    element.style.overflow = "hidden";
                    if ($ioYal.isInternetExplorer() || !$eUh3g.GlobalSettings.useWebkitLineClamp) element.style.maxHeight = this._computedLineHeight * this.maxLines + "px";
                    else {
                        // While non standard, --webkit-line-clamp works in every browser (except IE)
                        // and is a great solution to support the maxLines feature with ellipsis
                        // truncation. With --webkit-line-clamp there is need to use explicit line heights
                        element.style.removeProperty("line-height");
                        element.style.display = "-webkit-box";
                        element.style.webkitBoxOrient = "vertical";
                        element.style.webkitLineClamp = this.maxLines.toString();
                    }
                }
            } else {
                element.style.whiteSpace = "nowrap";
                element.style.textOverflow = "ellipsis";
            }
            if ($eUh3g.GlobalSettings.useAdvancedTextBlockTruncation || $eUh3g.GlobalSettings.useAdvancedCardBottomTruncation) this._originalInnerHtml = element.innerHTML;
            return element;
        } else return undefined;
    };
    TextBlock.prototype.truncateOverflow = function(maxHeight) {
        if (maxHeight >= this._computedLineHeight) return this.truncateIfSupported(maxHeight);
        return false;
    };
    TextBlock.prototype.undoOverflowTruncation = function() {
        this.restoreOriginalContent();
        if ($eUh3g.GlobalSettings.useAdvancedTextBlockTruncation && this.maxLines) {
            var maxHeight = this._computedLineHeight * this.maxLines;
            this.truncateIfSupported(maxHeight);
        }
    };
    TextBlock.prototype.applyStylesTo = function(targetElement) {
        _super.prototype.applyStylesTo.call(this, targetElement);
        switch(this.getEffectiveHorizontalAlignment()){
            case $iw5eI.HorizontalAlignment.Center:
                targetElement.style.textAlign = "center";
                break;
            case $iw5eI.HorizontalAlignment.Right:
                targetElement.style.textAlign = "end";
                break;
            default:
                targetElement.style.textAlign = "start";
                break;
        }
        var lineHeights = this.hostConfig.lineHeights;
        if (lineHeights) switch(this.effectiveSize){
            case $iw5eI.TextSize.Small:
                this._computedLineHeight = lineHeights.small;
                break;
            case $iw5eI.TextSize.Medium:
                this._computedLineHeight = lineHeights.medium;
                break;
            case $iw5eI.TextSize.Large:
                this._computedLineHeight = lineHeights.large;
                break;
            case $iw5eI.TextSize.ExtraLarge:
                this._computedLineHeight = lineHeights.extraLarge;
                break;
            default:
                this._computedLineHeight = lineHeights.default;
                break;
        }
        else // Looks like 1.33 is the magic number to compute line-height
        // from font size.
        this._computedLineHeight = this.getFontSize(this.hostConfig.getFontTypeDefinition(this.effectiveFontType)) * 1.33;
        targetElement.style.lineHeight = this._computedLineHeight + "px";
    };
    TextBlock.prototype.getJsonTypeName = function() {
        return "TextBlock";
    };
    TextBlock.prototype.getEffectiveTextStyleDefinition = function() {
        if (this.style) return this.hostConfig.textStyles.getStyleByName(this.style);
        return _super.prototype.getEffectiveTextStyleDefinition.call(this);
    };
    TextBlock.prototype.updateLayout = function(processChildren) {
        if (processChildren === void 0) processChildren = false;
        _super.prototype.updateLayout.call(this, processChildren);
        if ($eUh3g.GlobalSettings.useAdvancedTextBlockTruncation && this.maxLines && this.isDisplayed()) {
            // Reset the element's innerHTML in case the available room for
            // content has increased
            this.restoreOriginalContent();
            this.truncateIfSupported(this._computedLineHeight * this.maxLines);
        }
    };
    var _a, _b;
    TextBlock.wrapProperty = new $ldzOp.BoolProperty($ldzOp.Versions.v1_0, "wrap", false);
    TextBlock.maxLinesProperty = new $ldzOp.NumProperty($ldzOp.Versions.v1_0, "maxLines");
    TextBlock.styleProperty = new $ldzOp.ValueSetProperty($ldzOp.Versions.v1_5, "style", [
        {
            value: "default"
        },
        {
            value: "columnHeader"
        },
        {
            value: "heading"
        }
    ]);
    // Markdown processing is handled outside of Adaptive Cards. It's up to the host to ensure that markdown is safely
    // processed.
    TextBlock._ttMarkdownPolicy = typeof window === "undefined" ? undefined : (_a = window.trustedTypes) === null || _a === void 0 ? void 0 : _a.createPolicy("adaptivecards#markdownPassthroughPolicy", {
        createHTML: function(value) {
            return value;
        }
    });
    // When "advanced" truncation is enabled (see GlobalSettings.useAdvancedCardBottomTruncation and
    // GlobalSettings.useAdvancedTextBlockTruncation), we store the original pre-truncation content in
    // _originalInnerHtml so that we can restore/recalculate truncation later if space availability has changed (see
    // TextBlock.restoreOriginalContent())
    TextBlock._ttRoundtripPolicy = typeof window === "undefined" ? undefined : (_b = window.trustedTypes) === null || _b === void 0 ? void 0 : _b.createPolicy("adaptivecards#restoreContentsPolicy", {
        createHTML: function(value) {
            return value;
        }
    });
    $2b991ecb5ab02fee$var$__decorate([
        (0, $ldzOp.property)(TextBlock.wrapProperty)
    ], TextBlock.prototype, "wrap", void 0);
    $2b991ecb5ab02fee$var$__decorate([
        (0, $ldzOp.property)(TextBlock.maxLinesProperty)
    ], TextBlock.prototype, "maxLines", void 0);
    $2b991ecb5ab02fee$var$__decorate([
        (0, $ldzOp.property)(TextBlock.styleProperty)
    ], TextBlock.prototype, "style", void 0);
    return TextBlock;
}($2b991ecb5ab02fee$var$BaseTextBlock);
module.exports.TextBlock = $2b991ecb5ab02fee$var$TextBlock;
var $2b991ecb5ab02fee$var$TextRun = /** @class */ function(_super) {
    $2b991ecb5ab02fee$var$__extends(TextRun, _super);
    function TextRun() {
        //#region Schema
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.italic = false;
        _this.strikethrough = false;
        _this.highlight = false;
        _this.underline = false;
        return _this;
    }
    TextRun.prototype.populateSchema = function(schema) {
        _super.prototype.populateSchema.call(this, schema);
        schema.add($2b991ecb5ab02fee$var$BaseTextBlock.selectActionProperty);
    };
    //#endregion
    TextRun.prototype.internalRender = function() {
        var _this = this;
        if (this.text) {
            var preProcessedText = this.preProcessPropertyValue($2b991ecb5ab02fee$var$BaseTextBlock.textProperty);
            var hostConfig = this.hostConfig;
            var formattedText = $fQwaQ.formatText(this.lang, preProcessedText);
            if (!formattedText) formattedText = "";
            var element = document.createElement("span");
            element.classList.add(hostConfig.makeCssClassName("ac-textRun"));
            this.applyStylesTo(element);
            if (this.selectAction && hostConfig.supportsInteractivity) {
                var anchor = document.createElement("a");
                anchor.classList.add(hostConfig.makeCssClassName("ac-anchor"));
                var href = this.selectAction.getHref();
                anchor.href = href ? href : "";
                anchor.target = "_blank";
                anchor.onclick = function(e) {
                    if (_this.selectAction && _this.selectAction.isEffectivelyEnabled()) {
                        e.preventDefault();
                        e.cancelBubble = true;
                        _this.selectAction.execute();
                    }
                };
                this.selectAction.setupElementForAccessibility(anchor);
                anchor.innerText = formattedText;
                element.appendChild(anchor);
            } else element.innerText = formattedText;
            return element;
        } else return undefined;
    };
    TextRun.prototype.applyStylesTo = function(targetElement) {
        _super.prototype.applyStylesTo.call(this, targetElement);
        if (this.italic) targetElement.style.fontStyle = "italic";
        if (this.strikethrough) targetElement.style.textDecoration = "line-through";
        if (this.highlight) {
            var colorDefinition = this.getColorDefinition(this.getEffectiveStyleDefinition().foregroundColors, this.effectiveColor);
            var backgroundColor = $ioYal.stringToCssColor(this.effectiveIsSubtle ? colorDefinition.highlightColors.subtle : colorDefinition.highlightColors.default);
            if (backgroundColor) targetElement.style.backgroundColor = backgroundColor;
        }
        if (this.underline) targetElement.style.textDecoration = "underline";
    };
    TextRun.prototype.getJsonTypeName = function() {
        return "TextRun";
    };
    Object.defineProperty(TextRun.prototype, "isStandalone", {
        get: function() {
            return false;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TextRun.prototype, "isInline", {
        get: function() {
            return true;
        },
        enumerable: false,
        configurable: true
    });
    TextRun.italicProperty = new $ldzOp.BoolProperty($ldzOp.Versions.v1_2, "italic", false);
    TextRun.strikethroughProperty = new $ldzOp.BoolProperty($ldzOp.Versions.v1_2, "strikethrough", false);
    TextRun.highlightProperty = new $ldzOp.BoolProperty($ldzOp.Versions.v1_2, "highlight", false);
    TextRun.underlineProperty = new $ldzOp.BoolProperty($ldzOp.Versions.v1_3, "underline", false);
    $2b991ecb5ab02fee$var$__decorate([
        (0, $ldzOp.property)(TextRun.italicProperty)
    ], TextRun.prototype, "italic", void 0);
    $2b991ecb5ab02fee$var$__decorate([
        (0, $ldzOp.property)(TextRun.strikethroughProperty)
    ], TextRun.prototype, "strikethrough", void 0);
    $2b991ecb5ab02fee$var$__decorate([
        (0, $ldzOp.property)(TextRun.highlightProperty)
    ], TextRun.prototype, "highlight", void 0);
    $2b991ecb5ab02fee$var$__decorate([
        (0, $ldzOp.property)(TextRun.underlineProperty)
    ], TextRun.prototype, "underline", void 0);
    return TextRun;
}($2b991ecb5ab02fee$var$BaseTextBlock);
module.exports.TextRun = $2b991ecb5ab02fee$var$TextRun;
var $2b991ecb5ab02fee$var$RichTextBlock = /** @class */ function(_super) {
    $2b991ecb5ab02fee$var$__extends(RichTextBlock, _super);
    function RichTextBlock() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._inlines = [];
        return _this;
    }
    RichTextBlock.prototype.internalAddInline = function(inline, forceAdd) {
        if (forceAdd === void 0) forceAdd = false;
        if (!inline.isInline) throw new Error($brsVB.Strings.errors.elementCannotBeUsedAsInline());
        var doAdd = inline.parent === undefined || forceAdd;
        if (!doAdd && inline.parent !== this) throw new Error($brsVB.Strings.errors.inlineAlreadyParented());
        else {
            inline.setParent(this);
            this._inlines.push(inline);
        }
    };
    RichTextBlock.prototype.internalParse = function(source, context) {
        _super.prototype.internalParse.call(this, source, context);
        this._inlines = [];
        if (Array.isArray(source["inlines"])) for(var _i = 0, _a = source["inlines"]; _i < _a.length; _i++){
            var jsonInline = _a[_i];
            var inline = void 0;
            if (typeof jsonInline === "string") {
                var textRun = new $2b991ecb5ab02fee$var$TextRun();
                textRun.text = jsonInline;
                inline = textRun;
            } else // No fallback for inlines in 1.2
            inline = context.parseElement(this, jsonInline, [], false);
            if (inline) this.internalAddInline(inline, true);
        }
    };
    RichTextBlock.prototype.internalToJSON = function(target, context) {
        _super.prototype.internalToJSON.call(this, target, context);
        if (this._inlines.length > 0) {
            var jsonInlines = [];
            for(var _i = 0, _a = this._inlines; _i < _a.length; _i++){
                var inline = _a[_i];
                jsonInlines.push(inline.toJSON(context));
            }
            context.serializeValue(target, "inlines", jsonInlines);
        }
    };
    RichTextBlock.prototype.internalRender = function() {
        if (this._inlines.length > 0) {
            var element = void 0;
            if (this.forElementId) {
                var labelElement = document.createElement("label");
                labelElement.htmlFor = this.forElementId;
                element = labelElement;
            } else element = document.createElement("div");
            element.className = this.hostConfig.makeCssClassName("ac-richTextBlock");
            switch(this.getEffectiveHorizontalAlignment()){
                case $iw5eI.HorizontalAlignment.Center:
                    element.style.textAlign = "center";
                    break;
                case $iw5eI.HorizontalAlignment.Right:
                    element.style.textAlign = "end";
                    break;
                default:
                    element.style.textAlign = "start";
                    break;
            }
            var renderedInlines = 0;
            for(var _i = 0, _a = this._inlines; _i < _a.length; _i++){
                var inline = _a[_i];
                var renderedInline = inline.render();
                if (renderedInline) {
                    element.appendChild(renderedInline);
                    renderedInlines++;
                }
            }
            if (renderedInlines > 0) return element;
        }
        return undefined;
    };
    RichTextBlock.prototype.asString = function() {
        var result = "";
        for(var _i = 0, _a = this._inlines; _i < _a.length; _i++){
            var inline = _a[_i];
            result += inline.asString();
        }
        return result;
    };
    RichTextBlock.prototype.getJsonTypeName = function() {
        return "RichTextBlock";
    };
    RichTextBlock.prototype.getInlineCount = function() {
        return this._inlines.length;
    };
    RichTextBlock.prototype.getInlineAt = function(index) {
        if (index >= 0 && index < this._inlines.length) return this._inlines[index];
        else throw new Error($brsVB.Strings.errors.indexOutOfRange(index));
    };
    RichTextBlock.prototype.addInline = function(inline) {
        if (typeof inline === "string") this.internalAddInline(new $2b991ecb5ab02fee$var$TextRun(inline));
        else this.internalAddInline(inline);
    };
    RichTextBlock.prototype.removeInline = function(inline) {
        var index = this._inlines.indexOf(inline);
        if (index >= 0) {
            this._inlines[index].setParent(undefined);
            this._inlines.splice(index, 1);
            return true;
        }
        return false;
    };
    return RichTextBlock;
}($2b991ecb5ab02fee$var$CardElement);
module.exports.RichTextBlock = $2b991ecb5ab02fee$var$RichTextBlock;
var $2b991ecb5ab02fee$var$Fact = /** @class */ function(_super) {
    $2b991ecb5ab02fee$var$__extends(Fact, _super);
    function Fact(name, value) {
        var _this = _super.call(this) || this;
        _this.name = name;
        _this.value = value;
        return _this;
    }
    //#endregion
    Fact.prototype.getSchemaKey = function() {
        return "Fact";
    };
    //#region Schema
    Fact.titleProperty = new $ldzOp.StringProperty($ldzOp.Versions.v1_0, "title");
    Fact.valueProperty = new $ldzOp.StringProperty($ldzOp.Versions.v1_0, "value");
    $2b991ecb5ab02fee$var$__decorate([
        (0, $ldzOp.property)(Fact.titleProperty)
    ], Fact.prototype, "name", void 0);
    $2b991ecb5ab02fee$var$__decorate([
        (0, $ldzOp.property)(Fact.valueProperty)
    ], Fact.prototype, "value", void 0);
    return Fact;
}($ldzOp.SerializableObject);
module.exports.Fact = $2b991ecb5ab02fee$var$Fact;
var $2b991ecb5ab02fee$var$FactSet = /** @class */ function(_super) {
    $2b991ecb5ab02fee$var$__extends(FactSet, _super);
    function FactSet() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(FactSet.prototype, "useDefaultSizing", {
        //#endregion
        get: function() {
            return false;
        },
        enumerable: false,
        configurable: true
    });
    FactSet.prototype.internalRender = function() {
        var element = undefined;
        var hostConfig = this.hostConfig;
        if (this.facts.length > 0) {
            element = document.createElement("table");
            element.style.borderWidth = "0px";
            element.style.borderSpacing = "0px";
            element.style.borderStyle = "none";
            element.style.borderCollapse = "collapse";
            element.style.display = "block";
            element.style.overflow = "hidden";
            element.classList.add(hostConfig.makeCssClassName("ac-factset"));
            element.setAttribute("role", "presentation");
            for(var i = 0; i < this.facts.length; i++){
                var trElement = document.createElement("tr");
                if (i > 0) trElement.style.marginTop = hostConfig.factSet.spacing + "px";
                // Title column
                var tdElement = document.createElement("td");
                tdElement.style.padding = "0";
                tdElement.classList.add(hostConfig.makeCssClassName("ac-fact-title"));
                if (hostConfig.factSet.title.maxWidth) tdElement.style.maxWidth = hostConfig.factSet.title.maxWidth + "px";
                tdElement.style.verticalAlign = "top";
                var textBlock = new $2b991ecb5ab02fee$var$TextBlock();
                textBlock.setParent(this);
                textBlock.text = !this.facts[i].name && this.isDesignMode() ? "Title" : this.facts[i].name;
                textBlock.size = hostConfig.factSet.title.size;
                textBlock.color = hostConfig.factSet.title.color;
                textBlock.isSubtle = hostConfig.factSet.title.isSubtle;
                textBlock.weight = hostConfig.factSet.title.weight;
                textBlock.wrap = hostConfig.factSet.title.wrap;
                textBlock.spacing = $iw5eI.Spacing.None;
                $ioYal.appendChild(tdElement, textBlock.render());
                $ioYal.appendChild(trElement, tdElement);
                // Spacer column
                tdElement = document.createElement("td");
                tdElement.style.width = "10px";
                $ioYal.appendChild(trElement, tdElement);
                // Value column
                tdElement = document.createElement("td");
                tdElement.style.padding = "0";
                tdElement.style.verticalAlign = "top";
                tdElement.classList.add(hostConfig.makeCssClassName("ac-fact-value"));
                textBlock = new $2b991ecb5ab02fee$var$TextBlock();
                textBlock.setParent(this);
                textBlock.text = this.facts[i].value;
                textBlock.size = hostConfig.factSet.value.size;
                textBlock.color = hostConfig.factSet.value.color;
                textBlock.isSubtle = hostConfig.factSet.value.isSubtle;
                textBlock.weight = hostConfig.factSet.value.weight;
                textBlock.wrap = hostConfig.factSet.value.wrap;
                textBlock.spacing = $iw5eI.Spacing.None;
                $ioYal.appendChild(tdElement, textBlock.render());
                $ioYal.appendChild(trElement, tdElement);
                $ioYal.appendChild(element, trElement);
            }
        }
        return element;
    };
    FactSet.prototype.getJsonTypeName = function() {
        return "FactSet";
    };
    //#region Schema
    FactSet.factsProperty = new $ldzOp.SerializableObjectCollectionProperty($ldzOp.Versions.v1_0, "facts", $2b991ecb5ab02fee$var$Fact);
    $2b991ecb5ab02fee$var$__decorate([
        (0, $ldzOp.property)(FactSet.factsProperty)
    ], FactSet.prototype, "facts", void 0);
    return FactSet;
}($2b991ecb5ab02fee$var$CardElement);
module.exports.FactSet = $2b991ecb5ab02fee$var$FactSet;
var $2b991ecb5ab02fee$var$ImageDimensionProperty = /** @class */ function(_super) {
    $2b991ecb5ab02fee$var$__extends(ImageDimensionProperty, _super);
    function ImageDimensionProperty(targetVersion, name, internalName, fallbackProperty) {
        var _this = _super.call(this, targetVersion, name) || this;
        _this.targetVersion = targetVersion;
        _this.name = name;
        _this.internalName = internalName;
        _this.fallbackProperty = fallbackProperty;
        return _this;
    }
    ImageDimensionProperty.prototype.getInternalName = function() {
        return this.internalName;
    };
    ImageDimensionProperty.prototype.parse = function(sender, source, context) {
        var result = undefined;
        var sourceValue = source[this.name];
        if (sourceValue === undefined) return this.defaultValue;
        var isValid = false;
        if (typeof sourceValue === "string") {
            try {
                var size = $eUh3g.SizeAndUnit.parse(sourceValue, true);
                if (size.unit === $iw5eI.SizeUnit.Pixel) {
                    result = size.physicalSize;
                    isValid = true;
                }
            } catch (_a) {
            // Swallow the exception
            }
            // If the source value isn't valid per this property definition,
            // check its validity per the fallback property, if specified
            if (!isValid && this.fallbackProperty) isValid = this.fallbackProperty.isValidValue(sourceValue, context);
        }
        if (!isValid) context.logParseEvent(sender, $iw5eI.ValidationEvent.InvalidPropertyValue, $brsVB.Strings.errors.invalidPropertyValue(sourceValue, this.name));
        return result;
    };
    ImageDimensionProperty.prototype.toJSON = function(sender, target, value, context) {
        context.serializeValue(target, this.name, typeof value === "number" && !isNaN(value) ? value + "px" : undefined);
    };
    return ImageDimensionProperty;
}($ldzOp.PropertyDefinition);
var $2b991ecb5ab02fee$var$Image = /** @class */ function(_super) {
    $2b991ecb5ab02fee$var$__extends(Image, _super);
    function Image() {
        //#region Schema
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.size = $iw5eI.Size.Auto;
        _this.style = $iw5eI.ImageStyle.Default;
        return _this;
    }
    Image.prototype.populateSchema = function(schema) {
        _super.prototype.populateSchema.call(this, schema);
        schema.remove($2b991ecb5ab02fee$var$CardElement.heightProperty);
    };
    //#endregion
    Image.prototype.applySize = function(element) {
        if (this.pixelWidth || this.pixelHeight) {
            if (this.pixelWidth) element.style.width = this.pixelWidth + "px";
            if (this.pixelHeight) element.style.height = this.pixelHeight + "px";
        } else if (this.maxHeight) {
            // If the image is constrained in height, we set its height property and
            // auto and stretch are ignored (default to medium). THis is necessary for
            // ImageSet which uses a maximum image height as opposed to the cards width
            // as a constraining dimension
            switch(this.size){
                case $iw5eI.Size.Small:
                    element.style.height = this.hostConfig.imageSizes.small + "px";
                    break;
                case $iw5eI.Size.Large:
                    element.style.height = this.hostConfig.imageSizes.large + "px";
                    break;
                default:
                    element.style.height = this.hostConfig.imageSizes.medium + "px";
                    break;
            }
            element.style.maxHeight = this.maxHeight + "px";
        } else {
            switch(this.size){
                case $iw5eI.Size.Stretch:
                    element.style.width = "100%";
                    break;
                case $iw5eI.Size.Auto:
                    element.style.maxWidth = "100%";
                    break;
                case $iw5eI.Size.Small:
                    element.style.width = this.hostConfig.imageSizes.small + "px";
                    break;
                case $iw5eI.Size.Large:
                    element.style.width = this.hostConfig.imageSizes.large + "px";
                    break;
                case $iw5eI.Size.Medium:
                    element.style.width = this.hostConfig.imageSizes.medium + "px";
                    break;
            }
            element.style.maxHeight = "100%";
        }
    };
    Object.defineProperty(Image.prototype, "useDefaultSizing", {
        get: function() {
            return false;
        },
        enumerable: false,
        configurable: true
    });
    Image.prototype.internalRender = function() {
        var _this = this;
        var element = undefined;
        if (this.url) {
            element = document.createElement("div");
            element.style.display = "flex";
            element.style.alignItems = "flex-start";
            // Cache hostConfig to avoid walking the parent hierarchy multiple times
            var hostConfig = this.hostConfig;
            switch(this.getEffectiveHorizontalAlignment()){
                case $iw5eI.HorizontalAlignment.Center:
                    element.style.justifyContent = "center";
                    break;
                case $iw5eI.HorizontalAlignment.Right:
                    element.style.justifyContent = "flex-end";
                    break;
                default:
                    element.style.justifyContent = "flex-start";
                    break;
            }
            var imageElement = document.createElement("img");
            imageElement.onload = function(_e) {
                $2b991ecb5ab02fee$var$raiseImageLoadedEvent(_this);
            };
            imageElement.onerror = function(_e) {
                if (_this.renderedElement) {
                    var card = _this.getRootElement();
                    _this.renderedElement;
                    if (card && card.designMode) {
                        var errorElement = document.createElement("div");
                        errorElement.style.display = "flex";
                        errorElement.style.alignItems = "center";
                        errorElement.style.justifyContent = "center";
                        errorElement.style.backgroundColor = "#EEEEEE";
                        errorElement.style.color = "black";
                        errorElement.innerText = ":-(";
                        errorElement.style.padding = "10px";
                        _this.applySize(errorElement);
                        _this.renderedElement.appendChild(errorElement);
                    }
                }
                $2b991ecb5ab02fee$var$raiseImageLoadedEvent(_this);
            };
            imageElement.style.minWidth = "0";
            imageElement.classList.add(hostConfig.makeCssClassName("ac-image"));
            if (this.selectAction && hostConfig.supportsInteractivity) {
                imageElement.onkeypress = function(e) {
                    if (_this.selectAction && _this.selectAction.isEffectivelyEnabled() && (e.code === "Enter" || e.code === "Space")) {
                        // enter or space pressed
                        e.preventDefault();
                        e.cancelBubble = true;
                        _this.selectAction.execute();
                    }
                };
                imageElement.onclick = function(e) {
                    if (_this.selectAction && _this.selectAction.isEffectivelyEnabled()) {
                        e.preventDefault();
                        e.cancelBubble = true;
                        _this.selectAction.execute();
                    }
                };
                this.selectAction.setupElementForAccessibility(imageElement);
                if (this.selectAction.isEffectivelyEnabled()) imageElement.classList.add(hostConfig.makeCssClassName("ac-selectable"));
            }
            this.applySize(imageElement);
            if (this.style === $iw5eI.ImageStyle.Person) {
                imageElement.style.borderRadius = "50%";
                imageElement.style.backgroundPosition = "50% 50%";
                imageElement.style.backgroundRepeat = "no-repeat";
            }
            var backgroundColor = $ioYal.stringToCssColor(this.backgroundColor);
            if (backgroundColor) imageElement.style.backgroundColor = backgroundColor;
            imageElement.src = this.preProcessPropertyValue(Image.urlProperty);
            var altTextProperty = this.preProcessPropertyValue(Image.altTextProperty);
            if (altTextProperty) imageElement.alt = altTextProperty;
            element.appendChild(imageElement);
        }
        return element;
    };
    Image.prototype.getJsonTypeName = function() {
        return "Image";
    };
    Image.prototype.getAllActions = function() {
        var result = _super.prototype.getAllActions.call(this);
        if (this.selectAction) result.push(this.selectAction);
        return result;
    };
    Image.prototype.getActionById = function(id) {
        var result = _super.prototype.getActionById.call(this, id);
        if (!result && this.selectAction) result = this.selectAction.getActionById(id);
        return result;
    };
    Image.prototype.getResourceInformation = function() {
        return this.url ? [
            {
                url: this.url,
                mimeType: "image"
            }
        ] : [];
    };
    Image.urlProperty = new $ldzOp.StringProperty($ldzOp.Versions.v1_0, "url");
    Image.altTextProperty = new $ldzOp.StringProperty($ldzOp.Versions.v1_0, "altText");
    Image.backgroundColorProperty = new $ldzOp.StringProperty($ldzOp.Versions.v1_1, "backgroundColor");
    Image.styleProperty = new $ldzOp.EnumProperty($ldzOp.Versions.v1_0, "style", $iw5eI.ImageStyle, $iw5eI.ImageStyle.Default);
    Image.sizeProperty = new $ldzOp.EnumProperty($ldzOp.Versions.v1_0, "size", $iw5eI.Size, $iw5eI.Size.Auto);
    Image.pixelWidthProperty = new $2b991ecb5ab02fee$var$ImageDimensionProperty($ldzOp.Versions.v1_1, "width", "pixelWidth");
    Image.pixelHeightProperty = new $2b991ecb5ab02fee$var$ImageDimensionProperty($ldzOp.Versions.v1_1, "height", "pixelHeight", $2b991ecb5ab02fee$var$CardElement.heightProperty);
    Image.selectActionProperty = new $2b991ecb5ab02fee$var$ActionProperty($ldzOp.Versions.v1_1, "selectAction", [
        "Action.ShowCard"
    ]);
    $2b991ecb5ab02fee$var$__decorate([
        (0, $ldzOp.property)(Image.urlProperty)
    ], Image.prototype, "url", void 0);
    $2b991ecb5ab02fee$var$__decorate([
        (0, $ldzOp.property)(Image.altTextProperty)
    ], Image.prototype, "altText", void 0);
    $2b991ecb5ab02fee$var$__decorate([
        (0, $ldzOp.property)(Image.backgroundColorProperty)
    ], Image.prototype, "backgroundColor", void 0);
    $2b991ecb5ab02fee$var$__decorate([
        (0, $ldzOp.property)(Image.sizeProperty)
    ], Image.prototype, "size", void 0);
    $2b991ecb5ab02fee$var$__decorate([
        (0, $ldzOp.property)(Image.styleProperty)
    ], Image.prototype, "style", void 0);
    $2b991ecb5ab02fee$var$__decorate([
        (0, $ldzOp.property)(Image.pixelWidthProperty)
    ], Image.prototype, "pixelWidth", void 0);
    $2b991ecb5ab02fee$var$__decorate([
        (0, $ldzOp.property)(Image.pixelHeightProperty)
    ], Image.prototype, "pixelHeight", void 0);
    $2b991ecb5ab02fee$var$__decorate([
        (0, $ldzOp.property)(Image.selectActionProperty)
    ], Image.prototype, "selectAction", void 0);
    return Image;
}($2b991ecb5ab02fee$var$CardElement);
module.exports.Image = $2b991ecb5ab02fee$var$Image;
var $2b991ecb5ab02fee$var$CardElementContainer = /** @class */ function(_super) {
    $2b991ecb5ab02fee$var$__extends(CardElementContainer, _super);
    function CardElementContainer() {
        //#region Schema
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.allowVerticalOverflow = false;
        return _this;
    }
    CardElementContainer.prototype.populateSchema = function(schema) {
        _super.prototype.populateSchema.call(this, schema);
        if (!this.isSelectable) schema.remove(CardElementContainer.selectActionProperty);
    };
    //#endregion
    CardElementContainer.prototype.isElementAllowed = function(element) {
        return this.hostConfig.supportsInteractivity || !element.isInteractive;
    };
    CardElementContainer.prototype.applyPadding = function() {
        _super.prototype.applyPadding.call(this);
        if (!this.renderedElement) return;
        var physicalPadding = new $eUh3g.SpacingDefinition();
        if (this.getEffectivePadding()) physicalPadding = this.hostConfig.paddingDefinitionToSpacingDefinition(this.getEffectivePadding());
        this.renderedElement.style.paddingTop = physicalPadding.top + "px";
        this.renderedElement.style.paddingRight = physicalPadding.right + "px";
        this.renderedElement.style.paddingBottom = physicalPadding.bottom + "px";
        this.renderedElement.style.paddingLeft = physicalPadding.left + "px";
        this.renderedElement.style.marginRight = "0";
        this.renderedElement.style.marginLeft = "0";
    };
    Object.defineProperty(CardElementContainer.prototype, "isSelectable", {
        get: function() {
            return false;
        },
        enumerable: false,
        configurable: true
    });
    // This function is kept but return [] when removing Carousel from code
    CardElementContainer.prototype.forbiddenChildElements = function() {
        return [];
    };
    CardElementContainer.prototype.releaseDOMResources = function() {
        _super.prototype.releaseDOMResources.call(this);
        for(var i = 0; i < this.getItemCount(); i++)this.getItemAt(i).releaseDOMResources();
    };
    CardElementContainer.prototype.internalValidateProperties = function(context) {
        _super.prototype.internalValidateProperties.call(this, context);
        for(var i = 0; i < this.getItemCount(); i++){
            var item = this.getItemAt(i);
            if (!this.hostConfig.supportsInteractivity && item.isInteractive) context.addFailure(this, $iw5eI.ValidationEvent.InteractivityNotAllowed, $brsVB.Strings.errors.interactivityNotAllowed());
            if (!this.isElementAllowed(item)) context.addFailure(this, $iw5eI.ValidationEvent.InteractivityNotAllowed, $brsVB.Strings.errors.elementTypeNotAllowed(item.getJsonTypeName()));
            item.internalValidateProperties(context);
        }
        if (this._selectAction) this._selectAction.internalValidateProperties(context);
    };
    CardElementContainer.prototype.render = function() {
        var _this = this;
        var element = _super.prototype.render.call(this);
        if (element) {
            var hostConfig = this.hostConfig;
            if (this.allowVerticalOverflow) {
                element.style.overflowX = "hidden";
                element.style.overflowY = "auto";
            }
            if (element && this.isSelectable && this._selectAction && hostConfig.supportsInteractivity) {
                element.onclick = function(e) {
                    if (_this._selectAction && _this._selectAction.isEffectivelyEnabled()) {
                        e.preventDefault();
                        e.cancelBubble = true;
                        _this._selectAction.execute();
                    }
                };
                element.onkeypress = function(e) {
                    if (_this._selectAction && _this._selectAction.isEffectivelyEnabled() && (e.code === "Enter" || e.code === "Space")) {
                        // Enter or space pressed
                        e.preventDefault();
                        e.cancelBubble = true;
                        _this._selectAction.execute();
                    }
                };
                this._selectAction.setupElementForAccessibility(element);
                if (this._selectAction.isEffectivelyEnabled()) element.classList.add(hostConfig.makeCssClassName("ac-selectable"));
            }
        }
        return element;
    };
    CardElementContainer.prototype.updateLayout = function(processChildren) {
        if (processChildren === void 0) processChildren = true;
        _super.prototype.updateLayout.call(this, processChildren);
        if (processChildren) for(var i = 0; i < this.getItemCount(); i++)this.getItemAt(i).updateLayout();
    };
    CardElementContainer.prototype.getAllInputs = function(processActions) {
        if (processActions === void 0) processActions = true;
        var result = [];
        for(var i = 0; i < this.getItemCount(); i++)result.push.apply(result, this.getItemAt(i).getAllInputs(processActions));
        return result;
    };
    CardElementContainer.prototype.getAllActions = function() {
        var result = _super.prototype.getAllActions.call(this);
        for(var i = 0; i < this.getItemCount(); i++)result.push.apply(result, this.getItemAt(i).getAllActions());
        if (this._selectAction) result.push(this._selectAction);
        return result;
    };
    CardElementContainer.prototype.getResourceInformation = function() {
        var result = [];
        for(var i = 0; i < this.getItemCount(); i++)result.push.apply(result, this.getItemAt(i).getResourceInformation());
        return result;
    };
    CardElementContainer.prototype.getElementById = function(id) {
        var result = _super.prototype.getElementById.call(this, id);
        if (!result) for(var i = 0; i < this.getItemCount(); i++){
            result = this.getItemAt(i).getElementById(id);
            if (result) break;
        }
        return result;
    };
    /**
     * @inheritdoc
     */ CardElementContainer.prototype.findDOMNodeOwner = function(node) {
        var _a;
        var target = undefined;
        for(var i = 0; i < this.getItemCount(); i++){
            // recur through child elements
            target = this.getItemAt(i).findDOMNodeOwner(node);
            if (target) return target;
        }
        // If not found in children, check the actions
        for(var i = 0; i < this.getActionCount(); i++){
            target = (_a = this.getActionAt(i)) === null || _a === void 0 ? void 0 : _a.findDOMNodeOwner(node);
            if (target) return target;
        }
        // if not found in children or actions, defer to parent implementation
        return _super.prototype.findDOMNodeOwner.call(this, node);
    };
    CardElementContainer.selectActionProperty = new $2b991ecb5ab02fee$var$ActionProperty($ldzOp.Versions.v1_1, "selectAction", [
        "Action.ShowCard"
    ]);
    $2b991ecb5ab02fee$var$__decorate([
        (0, $ldzOp.property)(CardElementContainer.selectActionProperty)
    ], CardElementContainer.prototype, "_selectAction", void 0);
    return CardElementContainer;
}($2b991ecb5ab02fee$var$CardElement);
module.exports.CardElementContainer = $2b991ecb5ab02fee$var$CardElementContainer;
var $2b991ecb5ab02fee$var$ImageSet = /** @class */ function(_super) {
    $2b991ecb5ab02fee$var$__extends(ImageSet, _super);
    function ImageSet() {
        //#region Schema
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._images = [];
        _this.imageSize = $iw5eI.ImageSize.Medium;
        return _this;
    }
    //#endregion
    ImageSet.prototype.internalRender = function() {
        var element = undefined;
        if (this._images.length > 0) {
            element = document.createElement("div");
            element.style.display = "flex";
            element.style.flexWrap = "wrap";
            for(var _i = 0, _a = this._images; _i < _a.length; _i++){
                var image = _a[_i];
                switch(this.imageSize){
                    case $iw5eI.ImageSize.Small:
                        image.size = $iw5eI.Size.Small;
                        break;
                    case $iw5eI.ImageSize.Large:
                        image.size = $iw5eI.Size.Large;
                        break;
                    default:
                        image.size = $iw5eI.Size.Medium;
                        break;
                }
                image.maxHeight = this.hostConfig.imageSet.maxImageHeight;
                var renderedImage = image.render();
                if (renderedImage) {
                    renderedImage.style.display = "inline-flex";
                    renderedImage.style.margin = "0px";
                    renderedImage.style.marginRight = "10px";
                    $ioYal.appendChild(element, renderedImage);
                }
            }
        }
        return element;
    };
    ImageSet.prototype.getItemCount = function() {
        return this._images.length;
    };
    ImageSet.prototype.getItemAt = function(index) {
        return this._images[index];
    };
    ImageSet.prototype.getFirstVisibleRenderedItem = function() {
        return this._images && this._images.length > 0 ? this._images[0] : undefined;
    };
    ImageSet.prototype.getLastVisibleRenderedItem = function() {
        return this._images && this._images.length > 0 ? this._images[this._images.length - 1] : undefined;
    };
    ImageSet.prototype.removeItem = function(item) {
        if (item instanceof $2b991ecb5ab02fee$var$Image) {
            var itemIndex = this._images.indexOf(item);
            if (itemIndex >= 0) {
                this._images.splice(itemIndex, 1);
                item.setParent(undefined);
                this.updateLayout();
                return true;
            }
        }
        return false;
    };
    ImageSet.prototype.getJsonTypeName = function() {
        return "ImageSet";
    };
    ImageSet.prototype.addImage = function(image) {
        if (!image.parent) {
            this._images.push(image);
            image.setParent(this);
        } else throw new Error("This image already belongs to another ImageSet");
    };
    ImageSet.prototype.indexOf = function(cardElement) {
        return cardElement instanceof $2b991ecb5ab02fee$var$Image ? this._images.indexOf(cardElement) : -1;
    };
    ImageSet.imagesProperty = new $ldzOp.SerializableObjectCollectionProperty($ldzOp.Versions.v1_0, "images", $2b991ecb5ab02fee$var$Image, function(sender, item) {
        item.setParent(sender);
    });
    ImageSet.imageSizeProperty = new $ldzOp.EnumProperty($ldzOp.Versions.v1_0, "imageSize", $iw5eI.ImageSize, $iw5eI.ImageSize.Medium);
    $2b991ecb5ab02fee$var$__decorate([
        (0, $ldzOp.property)(ImageSet.imagesProperty)
    ], ImageSet.prototype, "_images", void 0);
    $2b991ecb5ab02fee$var$__decorate([
        (0, $ldzOp.property)(ImageSet.imageSizeProperty)
    ], ImageSet.prototype, "imageSize", void 0);
    return ImageSet;
}($2b991ecb5ab02fee$var$CardElementContainer);
module.exports.ImageSet = $2b991ecb5ab02fee$var$ImageSet;
var $2b991ecb5ab02fee$var$ContentSource = /** @class */ function(_super) {
    $2b991ecb5ab02fee$var$__extends(ContentSource, _super);
    //#endregion
    function ContentSource(url, mimeType) {
        var _this = _super.call(this) || this;
        _this.url = url;
        _this.mimeType = mimeType;
        return _this;
    }
    ContentSource.prototype.isValid = function() {
        return this.mimeType && this.url ? true : false;
    };
    //#region Schema
    ContentSource.mimeTypeProperty = new $ldzOp.StringProperty($ldzOp.Versions.v1_1, "mimeType");
    ContentSource.urlProperty = new $ldzOp.StringProperty($ldzOp.Versions.v1_1, "url");
    $2b991ecb5ab02fee$var$__decorate([
        (0, $ldzOp.property)(ContentSource.mimeTypeProperty)
    ], ContentSource.prototype, "mimeType", void 0);
    $2b991ecb5ab02fee$var$__decorate([
        (0, $ldzOp.property)(ContentSource.urlProperty)
    ], ContentSource.prototype, "url", void 0);
    return ContentSource;
}($ldzOp.SerializableObject);
module.exports.ContentSource = $2b991ecb5ab02fee$var$ContentSource;
var $2b991ecb5ab02fee$var$CaptionSource = /** @class */ function(_super) {
    $2b991ecb5ab02fee$var$__extends(CaptionSource, _super);
    //#endregion
    function CaptionSource(url, mimeType, label) {
        var _this = _super.call(this, url, mimeType) || this;
        _this.label = label;
        return _this;
    }
    CaptionSource.prototype.getSchemaKey = function() {
        return "CaptionSource";
    };
    CaptionSource.prototype.render = function() {
        var result = undefined;
        if (this.isValid()) {
            result = document.createElement("track");
            result.src = this.url;
            result.kind = "captions";
            result.label = this.label;
        }
        return result;
    };
    //#region Schema
    CaptionSource.labelProperty = new $ldzOp.StringProperty($ldzOp.Versions.v1_6, "label");
    $2b991ecb5ab02fee$var$__decorate([
        (0, $ldzOp.property)(CaptionSource.labelProperty)
    ], CaptionSource.prototype, "label", void 0);
    return CaptionSource;
}($2b991ecb5ab02fee$var$ContentSource);
module.exports.CaptionSource = $2b991ecb5ab02fee$var$CaptionSource;
var $2b991ecb5ab02fee$var$MediaSource = /** @class */ function(_super) {
    $2b991ecb5ab02fee$var$__extends(MediaSource, _super);
    function MediaSource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MediaSource.prototype.getSchemaKey = function() {
        return "MediaSource";
    };
    MediaSource.prototype.render = function() {
        var result = undefined;
        if (this.isValid()) {
            result = document.createElement("source");
            result.src = this.url;
            result.type = this.mimeType;
        }
        return result;
    };
    return MediaSource;
}($2b991ecb5ab02fee$var$ContentSource);
module.exports.MediaSource = $2b991ecb5ab02fee$var$MediaSource;
var $2b991ecb5ab02fee$var$MediaPlayer = /** @class */ function() {
    function MediaPlayer() {}
    MediaPlayer.prototype.play = function() {
    // Do nothing in base implementation
    };
    Object.defineProperty(MediaPlayer.prototype, "posterUrl", {
        get: function() {
            return this._posterUrl;
        },
        set: function(value) {
            this._posterUrl = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MediaPlayer.prototype, "selectedMediaType", {
        get: function() {
            return undefined;
        },
        enumerable: false,
        configurable: true
    });
    return MediaPlayer;
}();
module.exports.MediaPlayer = $2b991ecb5ab02fee$var$MediaPlayer;
var $2b991ecb5ab02fee$var$HTML5MediaPlayer = /** @class */ function(_super) {
    $2b991ecb5ab02fee$var$__extends(HTML5MediaPlayer, _super);
    function HTML5MediaPlayer(owner) {
        var _this = _super.call(this) || this;
        _this.owner = owner;
        _this._selectedSources = [];
        _this._captionSources = [];
        _this.processSources();
        return _this;
    }
    HTML5MediaPlayer.prototype.processSources = function() {
        var _a;
        this._selectedSources = [];
        this._captionSources = [];
        this._selectedMediaType = undefined;
        for(var _i = 0, _b = this.owner.sources; _i < _b.length; _i++){
            var source = _b[_i];
            var mimeComponents = source.mimeType ? source.mimeType.split("/") : [];
            if (mimeComponents.length === 2) {
                if (!this._selectedMediaType) {
                    var index = HTML5MediaPlayer.supportedMediaTypes.indexOf(mimeComponents[0]);
                    if (index >= 0) this._selectedMediaType = HTML5MediaPlayer.supportedMediaTypes[index];
                }
                if (mimeComponents[0] === this._selectedMediaType) this._selectedSources.push(source);
            }
        }
        (_a = this._captionSources).push.apply(_a, this.owner.captionSources);
    };
    HTML5MediaPlayer.prototype.canPlay = function() {
        return this._selectedSources.length > 0;
    };
    HTML5MediaPlayer.prototype.fetchVideoDetails = function() {
        return $2b991ecb5ab02fee$var$__awaiter(this, void 0, void 0, function() {
            return $2b991ecb5ab02fee$var$__generator(this, function(_a) {
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    HTML5MediaPlayer.prototype.render = function() {
        if (this._selectedMediaType === "video") this._mediaElement = document.createElement("video");
        else this._mediaElement = document.createElement("audio");
        this._mediaElement.setAttribute("aria-label", this.owner.altText ? this.owner.altText : $brsVB.Strings.defaults.mediaPlayerAriaLabel());
        this._mediaElement.setAttribute("webkit-playsinline", "");
        this._mediaElement.setAttribute("playsinline", "");
        // We enable crossorigin for cases where the caption file has a different domain than
        // the video file. If the caption file lives in a different domain than the video file
        // and crossorigin is not set, then the caption file will fail to load.
        this._mediaElement.setAttribute("crossorigin", "");
        this._mediaElement.autoplay = true;
        this._mediaElement.controls = true;
        if ($ioYal.isMobileOS()) this._mediaElement.muted = true;
        this._mediaElement.preload = "none";
        this._mediaElement.style.width = "100%";
        for(var _i = 0, _a = this.owner.sources; _i < _a.length; _i++){
            var source = _a[_i];
            var renderedSource = source.render();
            $ioYal.appendChild(this._mediaElement, renderedSource);
        }
        for(var _b = 0, _c = this.owner.captionSources; _b < _c.length; _b++){
            var captionSource = _c[_b];
            if (captionSource.mimeType == "vtt") {
                var renderedCaptionSource = captionSource.render();
                $ioYal.appendChild(this._mediaElement, renderedCaptionSource);
            }
        }
        return this._mediaElement;
    };
    HTML5MediaPlayer.prototype.play = function() {
        if (this._mediaElement) this._mediaElement.play();
    };
    Object.defineProperty(HTML5MediaPlayer.prototype, "selectedMediaType", {
        get: function() {
            return this._selectedMediaType;
        },
        enumerable: false,
        configurable: true
    });
    HTML5MediaPlayer.supportedMediaTypes = [
        "audio",
        "video"
    ];
    return HTML5MediaPlayer;
}($2b991ecb5ab02fee$var$MediaPlayer);
module.exports.HTML5MediaPlayer = $2b991ecb5ab02fee$var$HTML5MediaPlayer;
var $2b991ecb5ab02fee$var$CustomMediaPlayer = /** @class */ function(_super) {
    $2b991ecb5ab02fee$var$__extends(CustomMediaPlayer, _super);
    function CustomMediaPlayer(matches) {
        return _super.call(this) || this;
    }
    return CustomMediaPlayer;
}($2b991ecb5ab02fee$var$MediaPlayer);
module.exports.CustomMediaPlayer = $2b991ecb5ab02fee$var$CustomMediaPlayer;
var $2b991ecb5ab02fee$var$IFrameMediaMediaPlayer = /** @class */ function(_super) {
    $2b991ecb5ab02fee$var$__extends(IFrameMediaMediaPlayer, _super);
    function IFrameMediaMediaPlayer(matches, iFrameTitle) {
        var _this = _super.call(this, matches) || this;
        _this.iFrameTitle = iFrameTitle;
        if (matches.length >= 2) _this._videoId = matches[1];
        return _this;
    }
    IFrameMediaMediaPlayer.prototype.canPlay = function() {
        return this._videoId !== undefined;
    };
    IFrameMediaMediaPlayer.prototype.render = function() {
        var container = document.createElement("div");
        container.style.position = "relative";
        container.style.width = "100%";
        container.style.height = "0";
        container.style.paddingBottom = "56.25%";
        var iFrame = document.createElement("iframe");
        iFrame.style.position = "absolute";
        iFrame.style.top = "0";
        iFrame.style.left = "0";
        iFrame.style.width = "100%";
        iFrame.style.height = "100%";
        iFrame.src = this.getEmbedVideoUrl();
        iFrame.frameBorder = "0";
        if (this.iFrameTitle) iFrame.title = this.iFrameTitle;
        iFrame.allow = "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture";
        iFrame.allowFullscreen = true;
        container.appendChild(iFrame);
        return container;
    };
    Object.defineProperty(IFrameMediaMediaPlayer.prototype, "videoId", {
        get: function() {
            return this._videoId;
        },
        enumerable: false,
        configurable: true
    });
    return IFrameMediaMediaPlayer;
}($2b991ecb5ab02fee$var$CustomMediaPlayer);
module.exports.IFrameMediaMediaPlayer = $2b991ecb5ab02fee$var$IFrameMediaMediaPlayer;
var $2b991ecb5ab02fee$var$VimeoPlayer = /** @class */ function(_super) {
    $2b991ecb5ab02fee$var$__extends(VimeoPlayer, _super);
    function VimeoPlayer() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    VimeoPlayer.prototype.fetchVideoDetails = function() {
        return $2b991ecb5ab02fee$var$__awaiter(this, void 0, void 0, function() {
            var oEmbedUrl, response, json;
            return $2b991ecb5ab02fee$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        oEmbedUrl = "https://vimeo.com/api/oembed.json?url=".concat(this.getEmbedVideoUrl());
                        return [
                            4 /*yield*/ ,
                            fetch(oEmbedUrl)
                        ];
                    case 1:
                        response = _a.sent();
                        if (!response.ok) return [
                            3 /*break*/ ,
                            3
                        ];
                        return [
                            4 /*yield*/ ,
                            response.json()
                        ];
                    case 2:
                        json = _a.sent();
                        this.posterUrl = json["thumbnail_url"];
                        _a.label = 3;
                    case 3:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    VimeoPlayer.prototype.getEmbedVideoUrl = function() {
        return "https://player.vimeo.com/video/".concat(this.videoId, "?autoplay=1");
    };
    return VimeoPlayer;
}($2b991ecb5ab02fee$var$IFrameMediaMediaPlayer);
module.exports.VimeoPlayer = $2b991ecb5ab02fee$var$VimeoPlayer;
var $2b991ecb5ab02fee$var$DailymotionPlayer = /** @class */ function(_super) {
    $2b991ecb5ab02fee$var$__extends(DailymotionPlayer, _super);
    function DailymotionPlayer() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DailymotionPlayer.prototype.fetchVideoDetails = function() {
        return $2b991ecb5ab02fee$var$__awaiter(this, void 0, void 0, function() {
            var apiUrl, response, json;
            return $2b991ecb5ab02fee$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        apiUrl = "https://api.dailymotion.com/video/".concat(this.videoId, "?fields=thumbnail_720_url");
                        return [
                            4 /*yield*/ ,
                            fetch(apiUrl)
                        ];
                    case 1:
                        response = _a.sent();
                        if (!response.ok) return [
                            3 /*break*/ ,
                            3
                        ];
                        return [
                            4 /*yield*/ ,
                            response.json()
                        ];
                    case 2:
                        json = _a.sent();
                        this.posterUrl = json["thumbnail_720_url"];
                        _a.label = 3;
                    case 3:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    DailymotionPlayer.prototype.getEmbedVideoUrl = function() {
        return "https://www.dailymotion.com/embed/video/".concat(this.videoId, "?autoplay=1");
    };
    return DailymotionPlayer;
}($2b991ecb5ab02fee$var$IFrameMediaMediaPlayer);
module.exports.DailymotionPlayer = $2b991ecb5ab02fee$var$DailymotionPlayer;
var $2b991ecb5ab02fee$var$YouTubePlayer = /** @class */ function(_super) {
    $2b991ecb5ab02fee$var$__extends(YouTubePlayer, _super);
    function YouTubePlayer(matches, iFrameTitle) {
        var _this = _super.call(this, matches, iFrameTitle) || this;
        _this.iFrameTitle = iFrameTitle;
        if (matches.length >= 3 && matches[2] !== undefined) _this._startTimeIndex = parseInt(matches[2]);
        return _this;
    }
    YouTubePlayer.prototype.fetchVideoDetails = function() {
        return $2b991ecb5ab02fee$var$__awaiter(this, void 0, void 0, function() {
            return $2b991ecb5ab02fee$var$__generator(this, function(_a) {
                this.posterUrl = this.videoId ? "https://img.youtube.com/vi/".concat(this.videoId, "/maxresdefault.jpg") : undefined;
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    YouTubePlayer.prototype.getEmbedVideoUrl = function() {
        var url = "https://www.youtube.com/embed/".concat(this.videoId, "?autoplay=1");
        if (this._startTimeIndex !== undefined) url += "&start=".concat(this._startTimeIndex);
        return url;
    };
    return YouTubePlayer;
}($2b991ecb5ab02fee$var$IFrameMediaMediaPlayer);
module.exports.YouTubePlayer = $2b991ecb5ab02fee$var$YouTubePlayer;
var $2b991ecb5ab02fee$var$Media = /** @class */ function(_super) {
    $2b991ecb5ab02fee$var$__extends(Media, _super);
    function Media() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.sources = [];
        _this.captionSources = [];
        return _this;
    }
    Media.prototype.createMediaPlayer = function() {
        for(var _i = 0, _a = Media.customMediaPlayers; _i < _a.length; _i++){
            var provider = _a[_i];
            for(var _b = 0, _c = this.sources; _b < _c.length; _b++){
                var source = _c[_b];
                if (source.url) for(var _d = 0, _f = provider.urlPatterns; _d < _f.length; _d++){
                    var pattern = _f[_d];
                    var matches = pattern.exec(source.url);
                    if (matches !== null) return provider.createMediaPlayer(matches);
                }
            }
        }
        return new $2b991ecb5ab02fee$var$HTML5MediaPlayer(this);
    };
    Media.prototype.handlePlayButtonInvoke = function(event) {
        if (this.hostConfig.media.allowInlinePlayback) {
            event.preventDefault();
            event.cancelBubble = true;
            if (this.renderedElement) {
                var mediaPlayerElement = this._mediaPlayer.render();
                $2b991ecb5ab02fee$var$clearElement(this.renderedElement);
                this.renderedElement.appendChild(mediaPlayerElement);
                this._mediaPlayer.play();
                mediaPlayerElement.focus();
            }
        } else if (Media.onPlay) {
            event.preventDefault();
            event.cancelBubble = true;
            Media.onPlay(this);
        }
    };
    Media.prototype.displayPoster = function() {
        return $2b991ecb5ab02fee$var$__awaiter(this, void 0, void 0, function() {
            var playButtonArrowWidth, playButtonArrowHeight, posterRootElement_1, posterUrl, posterImageElement_1, playButtonOuterElement, playButtonInnerElement, playButtonContainer;
            var _this = this;
            return $2b991ecb5ab02fee$var$__generator(this, function(_a) {
                if (this.renderedElement) {
                    playButtonArrowWidth = 12;
                    playButtonArrowHeight = 15;
                    posterRootElement_1 = document.createElement("div");
                    posterRootElement_1.className = this.hostConfig.makeCssClassName("ac-media-poster");
                    posterRootElement_1.setAttribute("role", "contentinfo");
                    posterRootElement_1.setAttribute("aria-label", this.altText ? this.altText : $brsVB.Strings.defaults.mediaPlayerAriaLabel());
                    posterRootElement_1.style.position = "relative";
                    posterRootElement_1.style.display = "flex";
                    posterUrl = this.poster ? this.poster : this._mediaPlayer.posterUrl;
                    if (!posterUrl) posterUrl = this.hostConfig.media.defaultPoster;
                    if (posterUrl) {
                        posterImageElement_1 = document.createElement("img");
                        posterImageElement_1.style.width = "100%";
                        posterImageElement_1.style.height = "100%";
                        posterImageElement_1.setAttribute("role", "presentation");
                        posterImageElement_1.onerror = function(_e) {
                            if (posterImageElement_1.parentNode) posterImageElement_1.parentNode.removeChild(posterImageElement_1);
                            posterRootElement_1.classList.add("empty");
                            posterRootElement_1.style.minHeight = "150px";
                        };
                        posterImageElement_1.src = posterUrl;
                        posterRootElement_1.appendChild(posterImageElement_1);
                    } else {
                        posterRootElement_1.classList.add("empty");
                        posterRootElement_1.style.minHeight = "150px";
                    }
                    if (this.hostConfig.supportsInteractivity && this._mediaPlayer.canPlay()) {
                        playButtonOuterElement = document.createElement("div");
                        playButtonOuterElement.tabIndex = 0;
                        playButtonOuterElement.setAttribute("role", "button");
                        playButtonOuterElement.setAttribute("aria-label", $brsVB.Strings.defaults.mediaPlayerPlayMedia());
                        playButtonOuterElement.className = this.hostConfig.makeCssClassName("ac-media-playButton");
                        playButtonOuterElement.style.display = "flex";
                        playButtonOuterElement.style.alignItems = "center";
                        playButtonOuterElement.style.justifyContent = "center";
                        playButtonOuterElement.onclick = function(e) {
                            _this.handlePlayButtonInvoke(e);
                        };
                        playButtonOuterElement.onkeypress = function(e) {
                            if (e.code === "Enter" || e.code === "Space") // space or enter
                            _this.handlePlayButtonInvoke(e);
                        };
                        playButtonInnerElement = document.createElement("div");
                        playButtonInnerElement.className = this.hostConfig.makeCssClassName("ac-media-playButton-arrow");
                        playButtonInnerElement.style.width = playButtonArrowWidth + "px";
                        playButtonInnerElement.style.height = playButtonArrowHeight + "px";
                        playButtonInnerElement.style.borderTopWidth = playButtonArrowHeight / 2 + "px";
                        playButtonInnerElement.style.borderBottomWidth = playButtonArrowHeight / 2 + "px";
                        playButtonInnerElement.style.borderLeftWidth = playButtonArrowWidth + "px";
                        playButtonInnerElement.style.borderRightWidth = "0";
                        playButtonInnerElement.style.borderStyle = "solid";
                        playButtonInnerElement.style.borderTopColor = "transparent";
                        playButtonInnerElement.style.borderRightColor = "transparent";
                        playButtonInnerElement.style.borderBottomColor = "transparent";
                        playButtonInnerElement.style.transform = "translate(" + playButtonArrowWidth / 10 + "px,0px)";
                        playButtonOuterElement.appendChild(playButtonInnerElement);
                        playButtonContainer = document.createElement("div");
                        playButtonContainer.style.position = "absolute";
                        playButtonContainer.style.left = "0";
                        playButtonContainer.style.top = "0";
                        playButtonContainer.style.width = "100%";
                        playButtonContainer.style.height = "100%";
                        playButtonContainer.style.display = "flex";
                        playButtonContainer.style.justifyContent = "center";
                        playButtonContainer.style.alignItems = "center";
                        playButtonContainer.appendChild(playButtonOuterElement);
                        posterRootElement_1.appendChild(playButtonContainer);
                    }
                    $2b991ecb5ab02fee$var$clearElement(this.renderedElement);
                    this.renderedElement.appendChild(posterRootElement_1);
                }
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    Media.prototype.internalRender = function() {
        var element = document.createElement("div");
        element.className = this.hostConfig.makeCssClassName("ac-media");
        return element;
    };
    Media.prototype.render = function() {
        var _this = this;
        var result = _super.prototype.render.call(this);
        if (result) {
            this._mediaPlayer = this.createMediaPlayer();
            this._mediaPlayer.fetchVideoDetails().then(function() {
                return _this.displayPoster();
            });
        }
        return result;
    };
    Media.prototype.releaseDOMResources = function() {
        _super.prototype.releaseDOMResources.call(this);
        this.displayPoster();
    };
    Media.prototype.getJsonTypeName = function() {
        return "Media";
    };
    Media.prototype.getResourceInformation = function() {
        var result = [];
        if (this._mediaPlayer) {
            var posterUrl = this.poster ? this.poster : this.hostConfig.media.defaultPoster;
            if (posterUrl) result.push({
                url: posterUrl,
                mimeType: "image"
            });
        }
        for(var _i = 0, _a = this.sources; _i < _a.length; _i++){
            var mediaSource = _a[_i];
            if (mediaSource.isValid()) result.push({
                /* eslint-disable @typescript-eslint/no-unnecessary-type-assertion -- `mediaSource.url` is of type `string | undefined`, but is validated by `isValid()` call */ url: mediaSource.url,
                mimeType: mediaSource.mimeType
            });
        }
        for(var _b = 0, _c = this.captionSources; _b < _c.length; _b++){
            var captionSource = _c[_b];
            if (captionSource.isValid()) result.push({
                /* eslint-disable @typescript-eslint/no-unnecessary-type-assertion -- `captionSource.url` is of type `string | undefined`, but is validated by `isValid()` call */ url: captionSource.url,
                mimeType: captionSource.mimeType
            });
        }
        return result;
    };
    Object.defineProperty(Media.prototype, "selectedMediaType", {
        get: function() {
            return this._mediaPlayer.selectedMediaType;
        },
        enumerable: false,
        configurable: true
    });
    Media.customMediaPlayers = [
        {
            urlPatterns: [
                /^(?:https?:\/\/)?(?:www.)?youtube.com\/watch\?(?=.*v=([\w\d-_]+))(?=(?:.*t=(\d+))?).*/gi,
                /^(?:https?:\/\/)?youtu.be\/([\w\d-_]+)(?:\?t=(\d+))?/gi
            ],
            createMediaPlayer: function(matches) {
                return new $2b991ecb5ab02fee$var$YouTubePlayer(matches, $brsVB.Strings.defaults.youTubeVideoPlayer());
            }
        },
        {
            urlPatterns: [
                /^(?:https?:\/\/)?vimeo.com\/([\w\d-_]+).*/gi
            ],
            createMediaPlayer: function(matches) {
                return new $2b991ecb5ab02fee$var$VimeoPlayer(matches, $brsVB.Strings.defaults.vimeoVideoPlayer());
            }
        },
        {
            urlPatterns: [
                /^(?:https?:\/\/)?(?:www.)?dailymotion.com\/video\/([\w\d-_]+).*/gi
            ],
            createMediaPlayer: function(matches) {
                return new $2b991ecb5ab02fee$var$DailymotionPlayer(matches, $brsVB.Strings.defaults.dailymotionVideoPlayer());
            }
        }
    ];
    //#region Schema
    Media.sourcesProperty = new $ldzOp.SerializableObjectCollectionProperty($ldzOp.Versions.v1_1, "sources", $2b991ecb5ab02fee$var$MediaSource);
    Media.captionSourcesProperty = new $ldzOp.SerializableObjectCollectionProperty($ldzOp.Versions.v1_6, "captionSources", $2b991ecb5ab02fee$var$CaptionSource);
    Media.posterProperty = new $ldzOp.StringProperty($ldzOp.Versions.v1_1, "poster");
    Media.altTextProperty = new $ldzOp.StringProperty($ldzOp.Versions.v1_1, "altText");
    $2b991ecb5ab02fee$var$__decorate([
        (0, $ldzOp.property)(Media.sourcesProperty)
    ], Media.prototype, "sources", void 0);
    $2b991ecb5ab02fee$var$__decorate([
        (0, $ldzOp.property)(Media.captionSourcesProperty)
    ], Media.prototype, "captionSources", void 0);
    $2b991ecb5ab02fee$var$__decorate([
        (0, $ldzOp.property)(Media.posterProperty)
    ], Media.prototype, "poster", void 0);
    $2b991ecb5ab02fee$var$__decorate([
        (0, $ldzOp.property)(Media.altTextProperty)
    ], Media.prototype, "altText", void 0);
    return Media;
}($2b991ecb5ab02fee$var$CardElement);
module.exports.Media = $2b991ecb5ab02fee$var$Media;
var $2b991ecb5ab02fee$var$Input = /** @class */ function(_super) {
    $2b991ecb5ab02fee$var$__extends(Input, _super);
    function Input() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Input.prototype.getAllLabelIds = function() {
        var labelIds = [];
        if (this.labelledBy) labelIds.push(this.labelledBy);
        if (this._renderedLabelElement) labelIds.push(this._renderedLabelElement.id);
        if (this._renderedErrorMessageElement) labelIds.push(this._renderedErrorMessageElement.id);
        return labelIds;
    };
    Input.prototype.updateInputControlAriaLabelledBy = function() {
        if (this._renderedInputControlElement) {
            var labelIds = this.getAllLabelIds();
            if (labelIds.length > 0) this._renderedInputControlElement.setAttribute("aria-labelledby", labelIds.join(" "));
            else this._renderedInputControlElement.removeAttribute("aria-labelledby");
        }
    };
    Object.defineProperty(Input.prototype, "isNullable", {
        get: function() {
            return true;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Input.prototype, "renderedInputControlElement", {
        get: function() {
            return this._renderedInputControlElement;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Input.prototype, "inputControlContainerElement", {
        get: function() {
            return this._inputControlContainerElement;
        },
        enumerable: false,
        configurable: true
    });
    Input.prototype.overrideInternalRender = function() {
        var hostConfig = this.hostConfig;
        this._outerContainerElement = document.createElement("div");
        this._outerContainerElement.style.display = "flex";
        this._outerContainerElement.style.flexDirection = "column";
        var renderedInputControlId = $ioYal.generateUniqueId();
        if (this.label) {
            var labelRichTextBlock = new $2b991ecb5ab02fee$var$RichTextBlock();
            labelRichTextBlock.setParent(this);
            labelRichTextBlock.forElementId = renderedInputControlId;
            var labelInline = new $2b991ecb5ab02fee$var$TextRun(this.label);
            labelRichTextBlock.addInline(labelInline);
            if (this.isRequired) {
                labelInline.init(hostConfig.inputs.label.requiredInputs);
                var isRequiredCueInline = new $2b991ecb5ab02fee$var$TextRun(hostConfig.inputs.label.requiredInputs.suffix);
                isRequiredCueInline.color = hostConfig.inputs.label.requiredInputs.suffixColor;
                isRequiredCueInline.ariaHidden = true;
                labelRichTextBlock.addInline(isRequiredCueInline);
            } else labelInline.init(hostConfig.inputs.label.optionalInputs);
            this._renderedLabelElement = labelRichTextBlock.render();
            if (this._renderedLabelElement) {
                this._renderedLabelElement.id = $ioYal.generateUniqueId();
                this._renderedLabelElement.style.marginBottom = hostConfig.getEffectiveSpacing(hostConfig.inputs.label.inputSpacing) + "px";
                this._outerContainerElement.appendChild(this._renderedLabelElement);
            }
        }
        this._inputControlContainerElement = document.createElement("div");
        this._inputControlContainerElement.className = hostConfig.makeCssClassName("ac-input-container");
        this._inputControlContainerElement.style.display = "flex";
        if (this.height === "stretch") {
            this._inputControlContainerElement.style.alignItems = "stretch";
            this._inputControlContainerElement.style.flex = "1 1 auto";
        }
        this._renderedInputControlElement = this.internalRender();
        if (this._renderedInputControlElement) {
            this._renderedInputControlElement.id = renderedInputControlId;
            this._renderedInputControlElement.style.minWidth = "0px";
            if (this.isNullable && this.isRequired) {
                this._renderedInputControlElement.setAttribute("aria-required", "true");
                this._renderedInputControlElement.classList.add(hostConfig.makeCssClassName("ac-input-required"));
            }
            this._inputControlContainerElement.appendChild(this._renderedInputControlElement);
            this._outerContainerElement.appendChild(this._inputControlContainerElement);
            this.updateInputControlAriaLabelledBy();
            return this._outerContainerElement;
        }
        this.resetDirtyState();
        return undefined;
    };
    Input.prototype.valueChanged = function() {
        this.getRootElement().updateActionsEnabledState();
        if (this.isValid()) this.resetValidationFailureCue();
        if (this.onValueChanged) this.onValueChanged(this);
        $2b991ecb5ab02fee$var$raiseInputValueChangedEvent(this);
    };
    Input.prototype.resetValidationFailureCue = function() {
        if (this.renderedInputControlElement) {
            this.renderedInputControlElement.classList.remove(this.hostConfig.makeCssClassName("ac-input-validation-failed"));
            this.updateInputControlAriaLabelledBy();
            if (this._renderedErrorMessageElement) {
                this._outerContainerElement.removeChild(this._renderedErrorMessageElement);
                this._renderedErrorMessageElement = undefined;
            }
        }
    };
    Input.prototype.showValidationErrorMessage = function() {
        if (this.renderedElement && this.errorMessage && $eUh3g.GlobalSettings.displayInputValidationErrors) {
            var errorMessageTextBlock = new $2b991ecb5ab02fee$var$TextBlock();
            errorMessageTextBlock.setParent(this);
            errorMessageTextBlock.text = this.errorMessage;
            errorMessageTextBlock.wrap = true;
            errorMessageTextBlock.init(this.hostConfig.inputs.errorMessage);
            this._renderedErrorMessageElement = errorMessageTextBlock.render();
            if (this._renderedErrorMessageElement) {
                this._renderedErrorMessageElement.id = $ioYal.generateUniqueId();
                this._outerContainerElement.appendChild(this._renderedErrorMessageElement);
                this.updateInputControlAriaLabelledBy();
            }
        }
    };
    Input.prototype.focus = function() {
        if (this._renderedInputControlElement) this._renderedInputControlElement.focus();
    };
    Input.prototype.isValid = function() {
        return true;
    };
    Input.prototype.isDirty = function() {
        return this.value !== this._oldValue;
    };
    Input.prototype.resetDirtyState = function() {
        this._oldValue = this.value;
    };
    Input.prototype.internalValidateProperties = function(context) {
        _super.prototype.internalValidateProperties.call(this, context);
        if (!this.id) context.addFailure(this, $iw5eI.ValidationEvent.PropertyCantBeNull, $brsVB.Strings.errors.inputsMustHaveUniqueId());
        if (this.isRequired) {
            if (!this.label) context.addFailure(this, $iw5eI.ValidationEvent.RequiredInputsShouldHaveLabel, "Required inputs should have a label");
            if (!this.errorMessage) context.addFailure(this, $iw5eI.ValidationEvent.RequiredInputsShouldHaveErrorMessage, "Required inputs should have an error message");
        }
    };
    Input.prototype.validateValue = function() {
        this.resetValidationFailureCue();
        var result = this.isRequired ? this.isSet() && this.isValid() : this.isValid();
        if (!result && this.renderedInputControlElement) {
            this.renderedInputControlElement.classList.add(this.hostConfig.makeCssClassName("ac-input-validation-failed"));
            this.showValidationErrorMessage();
        }
        return result;
    };
    Input.prototype.getAllInputs = function(processActions) {
        if (processActions === void 0) processActions = true;
        return [
            this
        ];
    };
    Input.prototype.render = function() {
        var result = _super.prototype.render.call(this);
        this.resetDirtyState();
        return result;
    };
    Object.defineProperty(Input.prototype, "isInteractive", {
        get: function() {
            return true;
        },
        enumerable: false,
        configurable: true
    });
    //#region Schema
    Input.labelProperty = new $ldzOp.StringProperty($ldzOp.Versions.v1_3, "label", true);
    Input.isRequiredProperty = new $ldzOp.BoolProperty($ldzOp.Versions.v1_3, "isRequired", false);
    Input.errorMessageProperty = new $ldzOp.StringProperty($ldzOp.Versions.v1_3, "errorMessage", true);
    $2b991ecb5ab02fee$var$__decorate([
        (0, $ldzOp.property)(Input.labelProperty)
    ], Input.prototype, "label", void 0);
    $2b991ecb5ab02fee$var$__decorate([
        (0, $ldzOp.property)(Input.isRequiredProperty)
    ], Input.prototype, "isRequired", void 0);
    $2b991ecb5ab02fee$var$__decorate([
        (0, $ldzOp.property)(Input.errorMessageProperty)
    ], Input.prototype, "errorMessage", void 0);
    return Input;
}($2b991ecb5ab02fee$var$CardElement);
module.exports.Input = $2b991ecb5ab02fee$var$Input;
var $2b991ecb5ab02fee$var$TextInput = /** @class */ function(_super) {
    $2b991ecb5ab02fee$var$__extends(TextInput, _super);
    function TextInput() {
        //#region Schema
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.isMultiline = false;
        _this.style = $iw5eI.InputTextStyle.Text;
        return _this;
    }
    //#endregion
    TextInput.prototype.setupInput = function(input) {
        var _this = this;
        input.style.flex = "1 1 auto";
        input.tabIndex = this.isDesignMode() ? -1 : 0;
        if (this.placeholder) {
            input.placeholder = this.placeholder;
            input.setAttribute("aria-label", this.placeholder);
        }
        if (this.defaultValue) input.value = this.defaultValue;
        if (this.maxLength && this.maxLength > 0) input.maxLength = this.maxLength;
        input.oninput = function() {
            _this.valueChanged();
        };
        input.onkeypress = function(e) {
            // Ctrl+Enter pressed
            if (e.ctrlKey && e.code === "Enter" && _this.inlineAction && _this.inlineAction.isEffectivelyEnabled()) _this.inlineAction.execute();
        };
    };
    TextInput.prototype.internalRender = function() {
        var result;
        if (this.isMultiline && this.style !== $iw5eI.InputTextStyle.Password) {
            result = document.createElement("textarea");
            result.className = this.hostConfig.makeCssClassName("ac-input", "ac-textInput", "ac-multiline");
            if (this.height === "stretch") result.style.height = "initial";
        } else {
            result = document.createElement("input");
            result.className = this.hostConfig.makeCssClassName("ac-input", "ac-textInput");
            result.type = $iw5eI.InputTextStyle[this.style].toLowerCase();
        }
        this.setupInput(result);
        return result;
    };
    TextInput.prototype.overrideInternalRender = function() {
        var _this = this;
        var renderedInputControl = _super.prototype.overrideInternalRender.call(this);
        if (this.inlineAction) {
            var button_1 = document.createElement("button");
            button_1.className = this.hostConfig.makeCssClassName(this.inlineAction.isEffectivelyEnabled() ? "ac-inlineActionButton" : "ac-inlineActionButton-disabled");
            button_1.onclick = function(e) {
                if (_this.inlineAction && _this.inlineAction.isEffectivelyEnabled()) {
                    e.preventDefault();
                    e.cancelBubble = true;
                    _this.inlineAction.execute();
                }
            };
            if (this.inlineAction.iconUrl) {
                button_1.classList.add("iconOnly");
                var icon_1 = document.createElement("img");
                icon_1.style.height = "100%";
                icon_1.setAttribute("role", "presentation");
                // The below trick is necessary as a workaround in Chrome where the icon is initially displayed
                // at its native size then resized to 100% of the button's height. This cfreates an unpleasant
                // flicker. On top of that, Chrome's flex implementation fails to prperly re-layout the button
                // after the image has loaded and been gicven its final size. The below trick also fixes that.
                icon_1.style.display = "none";
                icon_1.onload = function() {
                    icon_1.style.removeProperty("display");
                };
                icon_1.onerror = function() {
                    button_1.removeChild(icon_1);
                    button_1.classList.remove("iconOnly");
                    button_1.classList.add("textOnly");
                    button_1.textContent = _this.inlineAction && _this.inlineAction.title ? _this.inlineAction.title : $brsVB.Strings.defaults.inlineActionTitle();
                };
                icon_1.src = this.inlineAction.iconUrl;
                button_1.appendChild(icon_1);
                button_1.title = this.inlineAction.title ? this.inlineAction.title : $brsVB.Strings.defaults.inlineActionTitle();
            } else {
                button_1.classList.add("textOnly");
                button_1.textContent = this.inlineAction.title ? this.inlineAction.title : $brsVB.Strings.defaults.inlineActionTitle();
            }
            this.inlineAction.setupElementForAccessibility(button_1, true);
            button_1.style.marginLeft = "8px";
            this.inputControlContainerElement.appendChild(button_1);
        }
        return renderedInputControl;
    };
    TextInput.prototype.getJsonTypeName = function() {
        return "Input.Text";
    };
    TextInput.prototype.getAllActions = function() {
        var result = _super.prototype.getAllActions.call(this);
        if (this.inlineAction) result.push(this.inlineAction);
        return result;
    };
    TextInput.prototype.getActionById = function(id) {
        var result = _super.prototype.getActionById.call(this, id);
        if (!result && this.inlineAction) result = this.inlineAction.getActionById(id);
        return result;
    };
    TextInput.prototype.isSet = function() {
        return this.value ? true : false;
    };
    TextInput.prototype.isValid = function() {
        if (!this.value) return true;
        if (this.regex) return new RegExp(this.regex, "g").test(this.value);
        return true;
    };
    Object.defineProperty(TextInput.prototype, "value", {
        get: function() {
            if (this.renderedInputControlElement) {
                if (this.isMultiline) return this.renderedInputControlElement.value;
                else return this.renderedInputControlElement.value;
            } else return undefined;
        },
        enumerable: false,
        configurable: true
    });
    TextInput.valueProperty = new $ldzOp.StringProperty($ldzOp.Versions.v1_0, "value");
    TextInput.maxLengthProperty = new $ldzOp.NumProperty($ldzOp.Versions.v1_0, "maxLength");
    TextInput.isMultilineProperty = new $ldzOp.BoolProperty($ldzOp.Versions.v1_0, "isMultiline", false);
    TextInput.placeholderProperty = new $ldzOp.StringProperty($ldzOp.Versions.v1_0, "placeholder");
    TextInput.styleProperty = new $ldzOp.EnumProperty($ldzOp.Versions.v1_0, "style", $iw5eI.InputTextStyle, $iw5eI.InputTextStyle.Text, [
        {
            value: $iw5eI.InputTextStyle.Text
        },
        {
            value: $iw5eI.InputTextStyle.Tel
        },
        {
            value: $iw5eI.InputTextStyle.Url
        },
        {
            value: $iw5eI.InputTextStyle.Email
        },
        {
            value: $iw5eI.InputTextStyle.Password,
            targetVersion: $ldzOp.Versions.v1_5
        }
    ]);
    TextInput.inlineActionProperty = new $2b991ecb5ab02fee$var$ActionProperty($ldzOp.Versions.v1_0, "inlineAction", [
        "Action.ShowCard"
    ]);
    TextInput.regexProperty = new $ldzOp.StringProperty($ldzOp.Versions.v1_3, "regex", true);
    $2b991ecb5ab02fee$var$__decorate([
        (0, $ldzOp.property)(TextInput.valueProperty)
    ], TextInput.prototype, "defaultValue", void 0);
    $2b991ecb5ab02fee$var$__decorate([
        (0, $ldzOp.property)(TextInput.maxLengthProperty)
    ], TextInput.prototype, "maxLength", void 0);
    $2b991ecb5ab02fee$var$__decorate([
        (0, $ldzOp.property)(TextInput.isMultilineProperty)
    ], TextInput.prototype, "isMultiline", void 0);
    $2b991ecb5ab02fee$var$__decorate([
        (0, $ldzOp.property)(TextInput.placeholderProperty)
    ], TextInput.prototype, "placeholder", void 0);
    $2b991ecb5ab02fee$var$__decorate([
        (0, $ldzOp.property)(TextInput.styleProperty)
    ], TextInput.prototype, "style", void 0);
    $2b991ecb5ab02fee$var$__decorate([
        (0, $ldzOp.property)(TextInput.inlineActionProperty)
    ], TextInput.prototype, "inlineAction", void 0);
    $2b991ecb5ab02fee$var$__decorate([
        (0, $ldzOp.property)(TextInput.regexProperty)
    ], TextInput.prototype, "regex", void 0);
    return TextInput;
}($2b991ecb5ab02fee$var$Input);
module.exports.TextInput = $2b991ecb5ab02fee$var$TextInput;
var $2b991ecb5ab02fee$var$ToggleInput = /** @class */ function(_super) {
    $2b991ecb5ab02fee$var$__extends(ToggleInput, _super);
    function ToggleInput() {
        //#region Schema
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.valueOn = "true";
        _this.valueOff = "false";
        _this.wrap = false;
        return _this;
    }
    ToggleInput.prototype.updateInputControlAriaLabelledBy = function() {
        if (this._checkboxInputElement) {
            var joinedLabelIds = this.getAllLabelIds().join(" ");
            if (this._checkboxInputLabelElement && this._checkboxInputLabelElement.id) joinedLabelIds += " " + this._checkboxInputLabelElement.id;
            if (joinedLabelIds) this._checkboxInputElement.setAttribute("aria-labelledby", joinedLabelIds);
            else this._checkboxInputElement.removeAttribute("aria-labelledby");
        }
    };
    ToggleInput.prototype.internalRender = function() {
        var _this = this;
        var element = document.createElement("div");
        element.className = this.hostConfig.makeCssClassName("ac-input", "ac-toggleInput");
        element.style.width = "100%";
        element.style.display = "flex";
        element.style.alignItems = "center";
        this._checkboxInputElement = document.createElement("input");
        this._checkboxInputElement.id = $ioYal.generateUniqueId();
        this._checkboxInputElement.type = "checkbox";
        this._checkboxInputElement.style.display = "inline-block";
        this._checkboxInputElement.style.verticalAlign = "middle";
        this._checkboxInputElement.style.margin = "0";
        this._checkboxInputElement.style.flex = "0 0 auto";
        if (this.title) this._checkboxInputElement.setAttribute("aria-label", this.title);
        if (this.isRequired) this._checkboxInputElement.setAttribute("aria-required", "true");
        this._checkboxInputElement.tabIndex = this.isDesignMode() ? -1 : 0;
        if (this.defaultValue === this.valueOn) this._checkboxInputElement.checked = true;
        this._oldCheckboxValue = this._checkboxInputElement.checked;
        this._checkboxInputElement.onchange = function() {
            _this.valueChanged();
        };
        $ioYal.appendChild(element, this._checkboxInputElement);
        if (this.title || this.isDesignMode()) {
            var label = new $2b991ecb5ab02fee$var$TextBlock();
            label.setParent(this);
            label.forElementId = this._checkboxInputElement.id;
            label.hostConfig = this.hostConfig;
            label.text = !this.title ? this.getJsonTypeName() : this.title;
            label.useMarkdown = $eUh3g.GlobalSettings.useMarkdownInRadioButtonAndCheckbox;
            label.wrap = this.wrap;
            this._checkboxInputLabelElement = label.render();
            if (this._checkboxInputLabelElement) {
                this._checkboxInputLabelElement.id = $ioYal.generateUniqueId();
                this._checkboxInputLabelElement.style.display = "inline-block";
                this._checkboxInputLabelElement.style.flex = "1 1 auto";
                this._checkboxInputLabelElement.style.marginLeft = "6px";
                this._checkboxInputLabelElement.style.verticalAlign = "middle";
                var spacerElement = document.createElement("div");
                spacerElement.style.width = "6px";
                $ioYal.appendChild(element, spacerElement);
                $ioYal.appendChild(element, this._checkboxInputLabelElement);
            }
        }
        return element;
    };
    Object.defineProperty(ToggleInput.prototype, "isNullable", {
        get: function() {
            return false;
        },
        enumerable: false,
        configurable: true
    });
    ToggleInput.prototype.getJsonTypeName = function() {
        return "Input.Toggle";
    };
    ToggleInput.prototype.focus = function() {
        if (this._checkboxInputElement) this._checkboxInputElement.focus();
    };
    ToggleInput.prototype.isSet = function() {
        if (this.isRequired) return this.value === this.valueOn;
        return this.value ? true : false;
    };
    ToggleInput.prototype.isDirty = function() {
        return this._checkboxInputElement ? this._checkboxInputElement.checked !== this._oldCheckboxValue : false;
    };
    Object.defineProperty(ToggleInput.prototype, "value", {
        get: function() {
            if (this._checkboxInputElement) return this._checkboxInputElement.checked ? this.valueOn : this.valueOff;
            else return undefined;
        },
        enumerable: false,
        configurable: true
    });
    ToggleInput.valueProperty = new $ldzOp.StringProperty($ldzOp.Versions.v1_0, "value");
    ToggleInput.titleProperty = new $ldzOp.StringProperty($ldzOp.Versions.v1_0, "title");
    ToggleInput.valueOnProperty = new $ldzOp.StringProperty($ldzOp.Versions.v1_0, "valueOn", true, undefined, "true", function(sender) {
        return "true";
    });
    ToggleInput.valueOffProperty = new $ldzOp.StringProperty($ldzOp.Versions.v1_0, "valueOff", true, undefined, "false", function(sender) {
        return "false";
    });
    ToggleInput.wrapProperty = new $ldzOp.BoolProperty($ldzOp.Versions.v1_2, "wrap", false);
    $2b991ecb5ab02fee$var$__decorate([
        (0, $ldzOp.property)(ToggleInput.valueProperty)
    ], ToggleInput.prototype, "defaultValue", void 0);
    $2b991ecb5ab02fee$var$__decorate([
        (0, $ldzOp.property)(ToggleInput.titleProperty)
    ], ToggleInput.prototype, "title", void 0);
    $2b991ecb5ab02fee$var$__decorate([
        (0, $ldzOp.property)(ToggleInput.valueOnProperty)
    ], ToggleInput.prototype, "valueOn", void 0);
    $2b991ecb5ab02fee$var$__decorate([
        (0, $ldzOp.property)(ToggleInput.valueOffProperty)
    ], ToggleInput.prototype, "valueOff", void 0);
    $2b991ecb5ab02fee$var$__decorate([
        (0, $ldzOp.property)(ToggleInput.wrapProperty)
    ], ToggleInput.prototype, "wrap", void 0);
    return ToggleInput;
}($2b991ecb5ab02fee$var$Input);
module.exports.ToggleInput = $2b991ecb5ab02fee$var$ToggleInput;
var $2b991ecb5ab02fee$var$Choice = /** @class */ function(_super) {
    $2b991ecb5ab02fee$var$__extends(Choice, _super);
    function Choice(title, value) {
        var _this = _super.call(this) || this;
        _this.title = title;
        _this.value = value;
        return _this;
    }
    //#endregion
    Choice.prototype.getSchemaKey = function() {
        return "Choice";
    };
    //#region Schema
    Choice.titleProperty = new $ldzOp.StringProperty($ldzOp.Versions.v1_0, "title");
    Choice.valueProperty = new $ldzOp.StringProperty($ldzOp.Versions.v1_0, "value");
    $2b991ecb5ab02fee$var$__decorate([
        (0, $ldzOp.property)(Choice.titleProperty)
    ], Choice.prototype, "title", void 0);
    $2b991ecb5ab02fee$var$__decorate([
        (0, $ldzOp.property)(Choice.valueProperty)
    ], Choice.prototype, "value", void 0);
    return Choice;
}($ldzOp.SerializableObject);
module.exports.Choice = $2b991ecb5ab02fee$var$Choice;
var $2b991ecb5ab02fee$var$ChoiceSetInput = /** @class */ function(_super) {
    $2b991ecb5ab02fee$var$__extends(ChoiceSetInput, _super);
    function ChoiceSetInput() {
        //#region Schema
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.isMultiSelect = false;
        _this.wrap = false;
        _this.choices = [];
        return _this;
    }
    Object.defineProperty(ChoiceSetInput.prototype, "isCompact", {
        get: function() {
            return !this.style || this.style === "compact";
        },
        set: function(value) {
            this.style = value ? undefined : "expanded";
        },
        enumerable: false,
        configurable: true
    });
    ChoiceSetInput.getUniqueCategoryName = function() {
        var uniqueCategoryName = "__ac-category" + ChoiceSetInput._uniqueCategoryCounter;
        ChoiceSetInput._uniqueCategoryCounter++;
        return uniqueCategoryName;
    };
    // Make sure `aria-current` is applied to the currently-selected item
    ChoiceSetInput.prototype.internalApplyAriaCurrent = function() {
        if (this._selectElement) {
            var options = this._selectElement.options;
            if (options) for(var _i = 0, _a = Array.from(options); _i < _a.length; _i++){
                var option = _a[_i];
                if (option.selected) option.setAttribute("aria-current", "true");
                else option.removeAttribute("aria-current");
            }
        }
    };
    ChoiceSetInput.prototype.renderCompoundInput = function(cssClassName, type, defaultValues) {
        var _this = this;
        var element = document.createElement("div");
        element.className = this.hostConfig.makeCssClassName("ac-input", cssClassName);
        element.style.width = "100%";
        element.tabIndex = this.isDesignMode() ? -1 : 0;
        this._toggleInputs = [];
        this._labels = [];
        for(var _i = 0, _a = this.choices; _i < _a.length; _i++){
            var choice = _a[_i];
            var input = document.createElement("input");
            input.id = $ioYal.generateUniqueId();
            input.type = type;
            input.style.margin = "0";
            input.style.display = "inline-block";
            input.style.verticalAlign = "middle";
            input.style.flex = "0 0 auto";
            input.name = this.id ? this.id : this._uniqueCategoryName;
            if (this.isRequired) input.setAttribute("aria-required", "true");
            input.tabIndex = this.isDesignMode() ? -1 : 0;
            if (choice.value) input.value = choice.value;
            if (choice.title) input.setAttribute("aria-label", choice.title);
            if (defaultValues && choice.value) {
                if (defaultValues.indexOf(choice.value) >= 0) input.checked = true;
            }
            input.onchange = function() {
                _this.valueChanged();
            };
            this._toggleInputs.push(input);
            var compoundInput = document.createElement("div");
            compoundInput.style.display = "flex";
            compoundInput.style.alignItems = "center";
            $ioYal.appendChild(compoundInput, input);
            var label = new $2b991ecb5ab02fee$var$TextBlock();
            label.setParent(this);
            label.forElementId = input.id;
            label.hostConfig = this.hostConfig;
            label.text = choice.title ? choice.title : "Choice " + this._toggleInputs.length;
            label.useMarkdown = $eUh3g.GlobalSettings.useMarkdownInRadioButtonAndCheckbox;
            label.wrap = this.wrap;
            var labelElement = label.render();
            this._labels.push(labelElement);
            if (labelElement) {
                labelElement.id = $ioYal.generateUniqueId();
                labelElement.style.display = "inline-block";
                labelElement.style.flex = "1 1 auto";
                labelElement.style.marginLeft = "6px";
                labelElement.style.verticalAlign = "middle";
                var spacerElement = document.createElement("div");
                spacerElement.style.width = "6px";
                $ioYal.appendChild(compoundInput, spacerElement);
                $ioYal.appendChild(compoundInput, labelElement);
            }
            $ioYal.appendChild(element, compoundInput);
        }
        return element;
    };
    ChoiceSetInput.prototype.updateInputControlAriaLabelledBy = function() {
        if ((this.isMultiSelect || this.style === "expanded") && this._toggleInputs && this._labels) {
            var labelIds = this.getAllLabelIds();
            for(var i = 0; i < this._toggleInputs.length; i++){
                var joinedLabelIds = labelIds.join(" ");
                var label = this._labels[i];
                if (label && label.id) joinedLabelIds += " " + label.id;
                if (joinedLabelIds) this._toggleInputs[i].setAttribute("aria-labelledby", joinedLabelIds);
                else this._toggleInputs[i].removeAttribute("aria-labelledby");
            }
        } else _super.prototype.updateInputControlAriaLabelledBy.call(this);
    };
    ChoiceSetInput.prototype.internalRender = function() {
        var _this = this;
        this._uniqueCategoryName = ChoiceSetInput.getUniqueCategoryName();
        if (this.isMultiSelect) // Render as a list of toggle inputs
        return this.renderCompoundInput("ac-choiceSetInput-multiSelect", "checkbox", this.defaultValue ? this.defaultValue.split(this.hostConfig.choiceSetInputValueSeparator) : undefined);
        else {
            if (this.style === "expanded") // Render as a series of radio buttons
            return this.renderCompoundInput("ac-choiceSetInput-expanded", "radio", this.defaultValue ? [
                this.defaultValue
            ] : undefined);
            else if (this.style === "filtered") {
                // Render as a text input coupled with a datalist
                var inputContainer = document.createElement("div");
                inputContainer.style.width = "100%";
                this._textInput = document.createElement("input");
                this._textInput.className = this.hostConfig.makeCssClassName("ac-input", "ac-multichoiceInput", "ac-choiceSetInput-filtered");
                this._textInput.type = "text";
                this._textInput.style.width = "100%";
                this._textInput.oninput = function() {
                    _this.valueChanged();
                    if (_this._textInput) {
                        // Remove aria-label when value is not empty so narration software doesn't
                        // read the placeholder
                        if (_this.value) {
                            _this._textInput.removeAttribute("placeholder");
                            _this._textInput.removeAttribute("aria-label");
                        } else if (_this.placeholder) {
                            _this._textInput.placeholder = _this.placeholder;
                            _this._textInput.setAttribute("aria-label", _this.placeholder);
                        }
                    }
                };
                if (this.defaultValue) this._textInput.value = this.defaultValue;
                if (this.placeholder && !this._textInput.value) {
                    this._textInput.placeholder = this.placeholder;
                    this._textInput.setAttribute("aria-label", this.placeholder);
                }
                this._textInput.tabIndex = this.isDesignMode() ? -1 : 0;
                var dataList = document.createElement("datalist");
                dataList.id = $ioYal.generateUniqueId();
                for(var _i = 0, _a = this.choices; _i < _a.length; _i++){
                    var choice = _a[_i];
                    var option = document.createElement("option");
                    // To fix https://stackoverflow.com/questions/29882361/show-datalist-labels-but-submit-the-actual-value
                    // value is mapped to choice.title other than choice.value
                    if (choice.title) {
                        option.value = choice.title;
                        option.setAttribute("aria-label", choice.title);
                    }
                    option.tabIndex = this.isDesignMode() ? -1 : 0;
                    dataList.appendChild(option);
                }
                this._textInput.setAttribute("list", dataList.id);
                inputContainer.append(this._textInput, dataList);
                return inputContainer;
            } else {
                // Render as a combo box
                this._selectElement = document.createElement("select");
                this._selectElement.className = this.hostConfig.makeCssClassName("ac-input", "ac-multichoiceInput", "ac-choiceSetInput-compact");
                this._selectElement.style.width = "100%";
                this._selectElement.tabIndex = this.isDesignMode() ? -1 : 0;
                var placeholderOption = document.createElement("option");
                placeholderOption.selected = true;
                placeholderOption.disabled = true;
                placeholderOption.hidden = true;
                placeholderOption.value = "";
                if (this.placeholder) placeholderOption.text = this.placeholder;
                $ioYal.appendChild(this._selectElement, placeholderOption);
                for(var _b = 0, _c = this.choices; _b < _c.length; _b++){
                    var choice = _c[_b];
                    var option = document.createElement("option");
                    option.value = choice.value;
                    if (choice.title) {
                        option.text = choice.title;
                        option.setAttribute("aria-label", choice.title);
                    }
                    option.tabIndex = this.isDesignMode() ? -1 : 0;
                    if (choice.value === this.defaultValue) option.selected = true;
                    $ioYal.appendChild(this._selectElement, option);
                }
                this._selectElement.onchange = function() {
                    _this.internalApplyAriaCurrent();
                    _this.valueChanged();
                };
                this.internalApplyAriaCurrent();
                return this._selectElement;
            }
        }
    };
    ChoiceSetInput.prototype.getJsonTypeName = function() {
        return "Input.ChoiceSet";
    };
    ChoiceSetInput.prototype.focus = function() {
        if (this._toggleInputs && (this.isMultiSelect || this.style === "expanded")) {
            if (this._toggleInputs.length > 0) this._toggleInputs[0].focus();
        } else if (this._textInput) this._textInput.focus();
        else _super.prototype.focus.call(this);
    };
    ChoiceSetInput.prototype.internalValidateProperties = function(context) {
        _super.prototype.internalValidateProperties.call(this, context);
        if (this.choices.length === 0) context.addFailure(this, $iw5eI.ValidationEvent.CollectionCantBeEmpty, $brsVB.Strings.errors.choiceSetMustHaveAtLeastOneChoice());
        for(var _i = 0, _a = this.choices; _i < _a.length; _i++){
            var choice = _a[_i];
            if (!choice.title || !choice.value) context.addFailure(this, $iw5eI.ValidationEvent.PropertyCantBeNull, $brsVB.Strings.errors.choiceSetChoicesMustHaveTitleAndValue());
        }
    };
    ChoiceSetInput.prototype.isSet = function() {
        return this.value ? true : false;
    };
    ChoiceSetInput.prototype.isValid = function() {
        if (this._textInput) {
            if (this.value === "" || this.value === this.placeholder) return true;
            for(var _i = 0, _a = this.choices; _i < _a.length; _i++){
                var choice = _a[_i];
                if (this.value === choice.value) return true;
            }
            return false;
        }
        return _super.prototype.isValid.call(this);
    };
    Object.defineProperty(ChoiceSetInput.prototype, "value", {
        get: function() {
            if (!this.isMultiSelect) {
                if (this._selectElement) return this._selectElement.selectedIndex > 0 ? this._selectElement.value : undefined;
                else if (this._textInput) {
                    for(var _i = 0, _a = this.choices; _i < _a.length; _i++){
                        var choice = _a[_i];
                        if (choice.title && this._textInput.value === choice.title) return choice.value;
                    }
                    return this._textInput.value;
                } else if (this._toggleInputs && this._toggleInputs.length > 0) for(var _b = 0, _c = this._toggleInputs; _b < _c.length; _b++){
                    var toggleInput = _c[_b];
                    if (toggleInput.checked) return toggleInput.value;
                }
                return undefined;
            } else {
                if (!this._toggleInputs || this._toggleInputs.length === 0) return undefined;
                var result = "";
                for(var _d = 0, _f = this._toggleInputs; _d < _f.length; _d++){
                    var toggleInput = _f[_d];
                    if (toggleInput.checked) {
                        if (result !== "") result += this.hostConfig.choiceSetInputValueSeparator;
                        result += toggleInput.value;
                    }
                }
                return result ? result : undefined;
            }
        },
        enumerable: false,
        configurable: true
    });
    ChoiceSetInput.valueProperty = new $ldzOp.StringProperty($ldzOp.Versions.v1_0, "value");
    ChoiceSetInput.choicesProperty = new $ldzOp.SerializableObjectCollectionProperty($ldzOp.Versions.v1_0, "choices", $2b991ecb5ab02fee$var$Choice);
    ChoiceSetInput.styleProperty = new $ldzOp.ValueSetProperty($ldzOp.Versions.v1_0, "style", [
        {
            value: "compact"
        },
        {
            value: "expanded"
        },
        {
            value: "filtered",
            targetVersion: $ldzOp.Versions.v1_5
        }
    ], "compact");
    ChoiceSetInput.isMultiSelectProperty = new $ldzOp.BoolProperty($ldzOp.Versions.v1_0, "isMultiSelect", false);
    ChoiceSetInput.placeholderProperty = new $ldzOp.StringProperty($ldzOp.Versions.v1_0, "placeholder");
    ChoiceSetInput.wrapProperty = new $ldzOp.BoolProperty($ldzOp.Versions.v1_2, "wrap", false);
    //#endregion
    ChoiceSetInput._uniqueCategoryCounter = 0;
    $2b991ecb5ab02fee$var$__decorate([
        (0, $ldzOp.property)(ChoiceSetInput.valueProperty)
    ], ChoiceSetInput.prototype, "defaultValue", void 0);
    $2b991ecb5ab02fee$var$__decorate([
        (0, $ldzOp.property)(ChoiceSetInput.styleProperty)
    ], ChoiceSetInput.prototype, "style", void 0);
    $2b991ecb5ab02fee$var$__decorate([
        (0, $ldzOp.property)(ChoiceSetInput.isMultiSelectProperty)
    ], ChoiceSetInput.prototype, "isMultiSelect", void 0);
    $2b991ecb5ab02fee$var$__decorate([
        (0, $ldzOp.property)(ChoiceSetInput.placeholderProperty)
    ], ChoiceSetInput.prototype, "placeholder", void 0);
    $2b991ecb5ab02fee$var$__decorate([
        (0, $ldzOp.property)(ChoiceSetInput.wrapProperty)
    ], ChoiceSetInput.prototype, "wrap", void 0);
    $2b991ecb5ab02fee$var$__decorate([
        (0, $ldzOp.property)(ChoiceSetInput.choicesProperty)
    ], ChoiceSetInput.prototype, "choices", void 0);
    return ChoiceSetInput;
}($2b991ecb5ab02fee$var$Input);
module.exports.ChoiceSetInput = $2b991ecb5ab02fee$var$ChoiceSetInput;
var $2b991ecb5ab02fee$var$NumberInput = /** @class */ function(_super) {
    $2b991ecb5ab02fee$var$__extends(NumberInput, _super);
    function NumberInput() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    NumberInput.prototype.internalRender = function() {
        var _this = this;
        this._numberInputElement = document.createElement("input");
        this._numberInputElement.setAttribute("type", "number");
        if (this.min !== undefined) this._numberInputElement.setAttribute("min", this.min.toString());
        if (this.max !== undefined) this._numberInputElement.setAttribute("max", this.max.toString());
        this._numberInputElement.className = this.hostConfig.makeCssClassName("ac-input", "ac-numberInput");
        this._numberInputElement.style.width = "100%";
        this._numberInputElement.tabIndex = this.isDesignMode() ? -1 : 0;
        if (this.defaultValue !== undefined) this._numberInputElement.valueAsNumber = this.defaultValue;
        if (this.placeholder) {
            this._numberInputElement.placeholder = this.placeholder;
            this._numberInputElement.setAttribute("aria-label", this.placeholder);
        }
        this._numberInputElement.oninput = function() {
            _this.valueChanged();
        };
        return this._numberInputElement;
    };
    NumberInput.prototype.getJsonTypeName = function() {
        return "Input.Number";
    };
    NumberInput.prototype.isSet = function() {
        return this.value !== undefined && !isNaN(this.value);
    };
    NumberInput.prototype.isValid = function() {
        if (this.value === undefined) return !this.isRequired;
        var result = true;
        if (this.min !== undefined) result = result && this.value >= this.min;
        if (this.max !== undefined) result = result && this.value <= this.max;
        return result;
    };
    Object.defineProperty(NumberInput.prototype, "value", {
        get: function() {
            return this._numberInputElement ? this._numberInputElement.valueAsNumber : undefined;
        },
        set: function(value) {
            if (value && this._numberInputElement) this._numberInputElement.value = value.toString();
        },
        enumerable: false,
        configurable: true
    });
    //#region Schema
    NumberInput.valueProperty = new $ldzOp.NumProperty($ldzOp.Versions.v1_0, "value");
    NumberInput.placeholderProperty = new $ldzOp.StringProperty($ldzOp.Versions.v1_0, "placeholder");
    NumberInput.minProperty = new $ldzOp.NumProperty($ldzOp.Versions.v1_0, "min");
    NumberInput.maxProperty = new $ldzOp.NumProperty($ldzOp.Versions.v1_0, "max");
    $2b991ecb5ab02fee$var$__decorate([
        (0, $ldzOp.property)(NumberInput.valueProperty)
    ], NumberInput.prototype, "defaultValue", void 0);
    $2b991ecb5ab02fee$var$__decorate([
        (0, $ldzOp.property)(NumberInput.minProperty)
    ], NumberInput.prototype, "min", void 0);
    $2b991ecb5ab02fee$var$__decorate([
        (0, $ldzOp.property)(NumberInput.maxProperty)
    ], NumberInput.prototype, "max", void 0);
    $2b991ecb5ab02fee$var$__decorate([
        (0, $ldzOp.property)(NumberInput.placeholderProperty)
    ], NumberInput.prototype, "placeholder", void 0);
    return NumberInput;
}($2b991ecb5ab02fee$var$Input);
module.exports.NumberInput = $2b991ecb5ab02fee$var$NumberInput;
var $2b991ecb5ab02fee$var$DateInput = /** @class */ function(_super) {
    $2b991ecb5ab02fee$var$__extends(DateInput, _super);
    function DateInput() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DateInput.prototype.internalRender = function() {
        var _this = this;
        this._dateInputElement = document.createElement("input");
        this._dateInputElement.setAttribute("type", "date");
        if (this.min) this._dateInputElement.setAttribute("min", this.min);
        if (this.max) this._dateInputElement.setAttribute("max", this.max);
        if (this.placeholder) {
            this._dateInputElement.placeholder = this.placeholder;
            this._dateInputElement.setAttribute("aria-label", this.placeholder);
        }
        this._dateInputElement.tabIndex = this.isDesignMode() ? -1 : 0;
        this._dateInputElement.className = this.hostConfig.makeCssClassName("ac-input", "ac-dateInput");
        this._dateInputElement.style.width = "100%";
        this._dateInputElement.oninput = function() {
            _this.valueChanged();
        };
        if (this.defaultValue) this._dateInputElement.value = this.defaultValue;
        return this._dateInputElement;
    };
    DateInput.prototype.getJsonTypeName = function() {
        return "Input.Date";
    };
    DateInput.prototype.isSet = function() {
        return this.value ? true : false;
    };
    DateInput.prototype.isValid = function() {
        if (!this.value) return !this.isRequired;
        var valueAsDate = new Date(this.value);
        var result = true;
        if (this.min) {
            var minDate = new Date(this.min);
            result = result && valueAsDate >= minDate;
        }
        if (this.max) {
            var maxDate = new Date(this.max);
            result = result && valueAsDate <= maxDate;
        }
        return result;
    };
    Object.defineProperty(DateInput.prototype, "value", {
        get: function() {
            return this._dateInputElement ? this._dateInputElement.value : undefined;
        },
        enumerable: false,
        configurable: true
    });
    //#region Schema
    DateInput.valueProperty = new $ldzOp.StringProperty($ldzOp.Versions.v1_0, "value");
    DateInput.placeholderProperty = new $ldzOp.StringProperty($ldzOp.Versions.v1_0, "placeholder");
    DateInput.minProperty = new $ldzOp.StringProperty($ldzOp.Versions.v1_0, "min");
    DateInput.maxProperty = new $ldzOp.StringProperty($ldzOp.Versions.v1_0, "max");
    $2b991ecb5ab02fee$var$__decorate([
        (0, $ldzOp.property)(DateInput.valueProperty)
    ], DateInput.prototype, "defaultValue", void 0);
    $2b991ecb5ab02fee$var$__decorate([
        (0, $ldzOp.property)(DateInput.minProperty)
    ], DateInput.prototype, "min", void 0);
    $2b991ecb5ab02fee$var$__decorate([
        (0, $ldzOp.property)(DateInput.maxProperty)
    ], DateInput.prototype, "max", void 0);
    $2b991ecb5ab02fee$var$__decorate([
        (0, $ldzOp.property)(DateInput.placeholderProperty)
    ], DateInput.prototype, "placeholder", void 0);
    return DateInput;
}($2b991ecb5ab02fee$var$Input);
module.exports.DateInput = $2b991ecb5ab02fee$var$DateInput;
var $2b991ecb5ab02fee$var$TimeProperty = /** @class */ function(_super) {
    $2b991ecb5ab02fee$var$__extends(TimeProperty, _super);
    function TimeProperty(targetVersion, name) {
        var _this = _super.call(this, targetVersion, name, function(sender, prop, source, context) {
            var value = source[prop.name];
            if (typeof value === "string" && value && /^[0-9]{2}:[0-9]{2}$/.test(value)) return value;
            return undefined;
        }, function(sender, prop, target, value, context) {
            context.serializeValue(target, prop.name, value);
        }) || this;
        _this.targetVersion = targetVersion;
        _this.name = name;
        return _this;
    }
    return TimeProperty;
}($ldzOp.CustomProperty);
module.exports.TimeProperty = $2b991ecb5ab02fee$var$TimeProperty;
var $2b991ecb5ab02fee$var$TimeInput = /** @class */ function(_super) {
    $2b991ecb5ab02fee$var$__extends(TimeInput, _super);
    function TimeInput() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TimeInput.convertTimeStringToDate = function(timeString) {
        return new Date("1973-09-04T" + timeString + ":00Z");
    };
    TimeInput.prototype.internalRender = function() {
        var _this = this;
        this._timeInputElement = document.createElement("input");
        this._timeInputElement.setAttribute("type", "time");
        if (this.min) this._timeInputElement.setAttribute("min", this.min);
        if (this.max) this._timeInputElement.setAttribute("max", this.max);
        this._timeInputElement.className = this.hostConfig.makeCssClassName("ac-input", "ac-timeInput");
        this._timeInputElement.style.width = "100%";
        this._timeInputElement.oninput = function() {
            _this.valueChanged();
        };
        if (this.placeholder) {
            this._timeInputElement.placeholder = this.placeholder;
            this._timeInputElement.setAttribute("aria-label", this.placeholder);
        }
        this._timeInputElement.tabIndex = this.isDesignMode() ? -1 : 0;
        if (this.defaultValue) this._timeInputElement.value = this.defaultValue;
        return this._timeInputElement;
    };
    TimeInput.prototype.getJsonTypeName = function() {
        return "Input.Time";
    };
    TimeInput.prototype.isSet = function() {
        return this.value ? true : false;
    };
    TimeInput.prototype.isValid = function() {
        if (!this.value) return !this.isRequired;
        var valueAsDate = TimeInput.convertTimeStringToDate(this.value);
        var result = true;
        if (this.min) {
            var minDate = TimeInput.convertTimeStringToDate(this.min);
            result = result && valueAsDate >= minDate;
        }
        if (this.max) {
            var maxDate = TimeInput.convertTimeStringToDate(this.max);
            result = result && valueAsDate <= maxDate;
        }
        return result;
    };
    Object.defineProperty(TimeInput.prototype, "value", {
        get: function() {
            return this._timeInputElement ? this._timeInputElement.value : undefined;
        },
        enumerable: false,
        configurable: true
    });
    //#region Schema
    TimeInput.valueProperty = new $2b991ecb5ab02fee$var$TimeProperty($ldzOp.Versions.v1_0, "value");
    TimeInput.placeholderProperty = new $ldzOp.StringProperty($ldzOp.Versions.v1_0, "placeholder");
    TimeInput.minProperty = new $2b991ecb5ab02fee$var$TimeProperty($ldzOp.Versions.v1_0, "min");
    TimeInput.maxProperty = new $2b991ecb5ab02fee$var$TimeProperty($ldzOp.Versions.v1_0, "max");
    $2b991ecb5ab02fee$var$__decorate([
        (0, $ldzOp.property)(TimeInput.valueProperty)
    ], TimeInput.prototype, "defaultValue", void 0);
    $2b991ecb5ab02fee$var$__decorate([
        (0, $ldzOp.property)(TimeInput.minProperty)
    ], TimeInput.prototype, "min", void 0);
    $2b991ecb5ab02fee$var$__decorate([
        (0, $ldzOp.property)(TimeInput.maxProperty)
    ], TimeInput.prototype, "max", void 0);
    $2b991ecb5ab02fee$var$__decorate([
        (0, $ldzOp.property)(TimeInput.placeholderProperty)
    ], TimeInput.prototype, "placeholder", void 0);
    return TimeInput;
}($2b991ecb5ab02fee$var$Input);
module.exports.TimeInput = $2b991ecb5ab02fee$var$TimeInput;
var $2b991ecb5ab02fee$var$Action = /** @class */ function(_super) {
    $2b991ecb5ab02fee$var$__extends(Action, _super);
    function Action() {
        //#region Schema
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.style = $iw5eI.ActionStyle.Default;
        _this.mode = $iw5eI.ActionMode.Primary;
        _this._state = 0 /* Normal */ ;
        _this._isFocusable = true;
        return _this;
    }
    //#endregion
    Action.prototype.renderButtonContent = function() {
        if (this.renderedElement) {
            // Cache hostConfig for perf
            var hostConfig = this.hostConfig;
            var titleElement = document.createElement("div");
            titleElement.style.overflow = "hidden";
            titleElement.style.textOverflow = "ellipsis";
            if (!(hostConfig.actions.iconPlacement === $iw5eI.ActionIconPlacement.AboveTitle || hostConfig.actions.allowTitleToWrap)) titleElement.style.whiteSpace = "nowrap";
            if (this.title) titleElement.innerText = this.title;
            if (!this.iconUrl) {
                this.renderedElement.classList.add("noIcon");
                this.renderedElement.appendChild(titleElement);
            } else {
                var iconElement = document.createElement("img");
                iconElement.src = this.iconUrl;
                iconElement.style.width = hostConfig.actions.iconSize + "px";
                iconElement.style.height = hostConfig.actions.iconSize + "px";
                iconElement.style.flex = "0 0 auto";
                if (hostConfig.actions.iconPlacement === $iw5eI.ActionIconPlacement.AboveTitle) {
                    this.renderedElement.classList.add("iconAbove");
                    this.renderedElement.style.flexDirection = "column";
                    if (this.title) iconElement.style.marginBottom = "6px";
                } else {
                    this.renderedElement.classList.add("iconLeft");
                    iconElement.style.maxHeight = "100%";
                    if (this.title) iconElement.style.marginRight = "6px";
                }
                this.renderedElement.appendChild(iconElement);
                this.renderedElement.appendChild(titleElement);
            }
        }
    };
    Action.prototype.getParentContainer = function() {
        if (this.parent instanceof $2b991ecb5ab02fee$var$Container) return this.parent;
        return this.parent ? this.parent.getParentContainer() : undefined;
    };
    Action.prototype.isDesignMode = function() {
        var rootElement = this.getRootObject();
        return rootElement instanceof $2b991ecb5ab02fee$var$CardElement && rootElement.isDesignMode();
    };
    Action.prototype.updateCssClasses = function() {
        var _a, _b;
        if (this.parent && this.renderedElement) {
            var hostConfig = this.parent.hostConfig;
            this.renderedElement.className = hostConfig.makeCssClassName(this.isEffectivelyEnabled() ? "ac-pushButton" : "ac-pushButton-disabled");
            var parentContainer = this.getParentContainer();
            if (parentContainer) {
                var parentContainerStyle = parentContainer.getEffectiveStyle();
                if (parentContainerStyle) this.renderedElement.classList.add("style-" + parentContainerStyle);
            }
            this.renderedElement.tabIndex = !this.isDesignMode() && this.isFocusable ? 0 : -1;
            switch(this._state){
                case 0 /* Normal */ :
                    break;
                case 1 /* Expanded */ :
                    this.renderedElement.classList.add(hostConfig.makeCssClassName("expanded"));
                    break;
                case 2 /* Subdued */ :
                    this.renderedElement.classList.add(hostConfig.makeCssClassName("subdued"));
                    break;
            }
            if (this.style && this.isEffectivelyEnabled()) {
                if (this.style === $iw5eI.ActionStyle.Positive) (_a = this.renderedElement.classList).add.apply(_a, hostConfig.makeCssClassNames("primary", "style-positive"));
                else (_b = this.renderedElement.classList).add.apply(_b, hostConfig.makeCssClassNames("style-" + this.style.toLowerCase()));
            }
        }
    };
    Action.prototype.getDefaultSerializationContext = function() {
        return new $2b991ecb5ab02fee$var$SerializationContext();
    };
    Action.prototype.internalGetReferencedInputs = function() {
        return {};
    };
    Action.prototype.internalPrepareForExecution = function(_inputs) {
    // Do nothing in base implementation
    };
    Action.prototype.internalValidateInputs = function(referencedInputs) {
        var result = [];
        if (referencedInputs) for(var _i = 0, _a = Object.keys(referencedInputs); _i < _a.length; _i++){
            var key = _a[_i];
            var input = referencedInputs[key];
            if (!input.validateValue()) result.push(input);
        }
        return result;
    };
    Action.prototype.shouldSerialize = function(context) {
        return context.actionRegistry.findByName(this.getJsonTypeName()) !== undefined;
    };
    Action.prototype.raiseExecuteActionEvent = function() {
        if (this.onExecute) this.onExecute(this);
        $2b991ecb5ab02fee$var$raiseExecuteActionEvent(this);
    };
    Action.prototype.internalAfterExecute = function() {
        var rootObject = this.getRootObject();
        if (rootObject instanceof $2b991ecb5ab02fee$var$CardElement) rootObject.updateActionsEnabledState();
    };
    Action.prototype.getHref = function() {
        return "";
    };
    Action.prototype.getAriaRole = function() {
        return "button";
    };
    Action.prototype.setupElementForAccessibility = function(element, promoteTooltipToLabel) {
        if (promoteTooltipToLabel === void 0) promoteTooltipToLabel = false;
        element.tabIndex = this.isEffectivelyEnabled() && !this.isDesignMode() ? 0 : -1;
        element.setAttribute("role", this.getAriaRole());
        if (element instanceof HTMLButtonElement) element.disabled = !this.isEffectivelyEnabled();
        if (!this.isEffectivelyEnabled()) element.setAttribute("aria-disabled", "true");
        else {
            element.removeAttribute("aria-disabled");
            element.classList.add(this.hostConfig.makeCssClassName("ac-selectable"));
        }
        if (this.title) {
            element.setAttribute("aria-label", this.title);
            element.title = this.title;
        } else {
            element.removeAttribute("aria-label");
            element.removeAttribute("title");
        }
        if (this.tooltip) {
            var targetAriaAttribute = promoteTooltipToLabel ? this.title ? "aria-description" : "aria-label" : "aria-description";
            element.setAttribute(targetAriaAttribute, this.tooltip);
            element.title = this.tooltip;
        }
    };
    Action.prototype.parse = function(source, context) {
        return _super.prototype.parse.call(this, source, context ? context : new $2b991ecb5ab02fee$var$SerializationContext());
    };
    Action.prototype.render = function() {
        var _this = this;
        var buttonElement = document.createElement("button");
        buttonElement.type = "button";
        buttonElement.style.display = "flex";
        buttonElement.style.alignItems = "center";
        buttonElement.style.justifyContent = "center";
        buttonElement.onclick = function(e) {
            if (_this.isEffectivelyEnabled()) {
                e.preventDefault();
                e.cancelBubble = true;
                _this.execute();
            }
        };
        this._renderedElement = buttonElement;
        this.renderButtonContent();
        this.updateCssClasses();
        this.setupElementForAccessibility(buttonElement);
    };
    Action.prototype.execute = function() {
        if (this._actionCollection) this._actionCollection.actionExecuted(this);
        this.raiseExecuteActionEvent();
        this.internalAfterExecute();
    };
    Action.prototype.prepareForExecution = function() {
        var referencedInputs = this.getReferencedInputs();
        var invalidInputs = this.internalValidateInputs(referencedInputs);
        if (invalidInputs.length > 0) {
            invalidInputs[0].focus();
            return false;
        }
        this.internalPrepareForExecution(referencedInputs);
        return true;
    };
    Action.prototype.remove = function() {
        if (this._actionCollection) return this._actionCollection.removeAction(this);
        return false;
    };
    Action.prototype.getAllInputs = function(processActions) {
        if (processActions === void 0) processActions = true;
        return [];
    };
    Action.prototype.getAllActions = function() {
        return [
            this
        ];
    };
    Action.prototype.getResourceInformation = function() {
        return this.iconUrl ? [
            {
                url: this.iconUrl,
                mimeType: "image"
            }
        ] : [];
    };
    Action.prototype.getActionById = function(id) {
        return this.id === id ? this : undefined;
    };
    Action.prototype.getReferencedInputs = function() {
        return this.internalGetReferencedInputs();
    };
    /**
     * Validates the inputs associated with this action.
     *
     * @returns A list of inputs that failed validation, or an empty array if no input failed validation.
     */ Action.prototype.validateInputs = function() {
        return this.internalValidateInputs(this.getReferencedInputs());
    };
    Action.prototype.updateEnabledState = function() {
    // Do nothing in base implementation
    };
    Action.prototype.isEffectivelyEnabled = function() {
        return this.isEnabled;
    };
    Object.defineProperty(Action.prototype, "isPrimary", {
        get: function() {
            return this.style === $iw5eI.ActionStyle.Positive;
        },
        set: function(value) {
            if (value) this.style = $iw5eI.ActionStyle.Positive;
            else if (this.style === $iw5eI.ActionStyle.Positive) this.style = $iw5eI.ActionStyle.Default;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Action.prototype, "hostConfig", {
        get: function() {
            return this.parent ? this.parent.hostConfig : $4IoSX.defaultHostConfig;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Action.prototype, "parent", {
        get: function() {
            return this._parent;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Action.prototype, "state", {
        get: function() {
            return this._state;
        },
        set: function(value) {
            if (this._state !== value) {
                this._state = value;
                this.updateCssClasses();
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Action.prototype, "isFocusable", {
        get: function() {
            return this._isFocusable;
        },
        set: function(value) {
            if (this._isFocusable !== value) {
                this._isFocusable = value;
                this.updateCssClasses();
            }
        },
        enumerable: false,
        configurable: true
    });
    Action.titleProperty = new $ldzOp.StringProperty($ldzOp.Versions.v1_0, "title");
    Action.iconUrlProperty = new $ldzOp.StringProperty($ldzOp.Versions.v1_1, "iconUrl");
    Action.styleProperty = new $ldzOp.ValueSetProperty($ldzOp.Versions.v1_2, "style", [
        {
            value: $iw5eI.ActionStyle.Default
        },
        {
            value: $iw5eI.ActionStyle.Positive
        },
        {
            value: $iw5eI.ActionStyle.Destructive
        }
    ], $iw5eI.ActionStyle.Default);
    Action.modeProperty = new $ldzOp.ValueSetProperty($ldzOp.Versions.v1_5, "mode", [
        {
            value: $iw5eI.ActionMode.Primary
        },
        {
            value: $iw5eI.ActionMode.Secondary
        }
    ], $iw5eI.ActionMode.Primary);
    Action.tooltipProperty = new $ldzOp.StringProperty($ldzOp.Versions.v1_5, "tooltip");
    Action.isEnabledProperty = new $ldzOp.BoolProperty($ldzOp.Versions.v1_5, "isEnabled", true);
    $2b991ecb5ab02fee$var$__decorate([
        (0, $ldzOp.property)(Action.titleProperty)
    ], Action.prototype, "title", void 0);
    $2b991ecb5ab02fee$var$__decorate([
        (0, $ldzOp.property)(Action.iconUrlProperty)
    ], Action.prototype, "iconUrl", void 0);
    $2b991ecb5ab02fee$var$__decorate([
        (0, $ldzOp.property)(Action.styleProperty)
    ], Action.prototype, "style", void 0);
    $2b991ecb5ab02fee$var$__decorate([
        (0, $ldzOp.property)(Action.modeProperty)
    ], Action.prototype, "mode", void 0);
    $2b991ecb5ab02fee$var$__decorate([
        (0, $ldzOp.property)(Action.tooltipProperty)
    ], Action.prototype, "tooltip", void 0);
    $2b991ecb5ab02fee$var$__decorate([
        (0, $ldzOp.property)(Action.isEnabledProperty)
    ], Action.prototype, "isEnabled", void 0);
    return Action;
}($j1Jxg.CardObject);
module.exports.Action = $2b991ecb5ab02fee$var$Action;
var $2b991ecb5ab02fee$var$SubmitActionBase = /** @class */ function(_super) {
    $2b991ecb5ab02fee$var$__extends(SubmitActionBase, _super);
    function SubmitActionBase() {
        //#region Schema
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.disabledUnlessAssociatedInputsChange = false;
        //#endregion
        _this._isPrepared = false;
        _this._areReferencedInputsDirty = false;
        return _this;
    }
    SubmitActionBase.prototype.internalGetReferencedInputs = function() {
        var result = {};
        if (this.associatedInputs !== "none") {
            var current = this.parent;
            var inputs = [];
            while(current){
                inputs.push.apply(inputs, current.getAllInputs(false));
                current = current.parent;
            }
            for(var _i = 0, inputs_1 = inputs; _i < inputs_1.length; _i++){
                var input = inputs_1[_i];
                if (input.id) result[input.id] = input;
            }
        }
        return result;
    };
    SubmitActionBase.prototype.internalPrepareForExecution = function(inputs) {
        if (this._originalData) this._processedData = JSON.parse(JSON.stringify(this._originalData));
        else this._processedData = {};
        if (this._processedData && inputs) for(var _i = 0, _a = Object.keys(inputs); _i < _a.length; _i++){
            var key = _a[_i];
            var input = inputs[key];
            if (input.id && input.isSet()) this._processedData[input.id] = typeof input.value === "string" ? input.value : input.value.toString();
        }
        this._isPrepared = true;
    };
    SubmitActionBase.prototype.internalAfterExecute = function() {
        if ($eUh3g.GlobalSettings.resetInputsDirtyStateAfterActionExecution) this.resetReferencedInputsDirtyState();
    };
    SubmitActionBase.prototype.resetReferencedInputsDirtyState = function() {
        var referencedInputs = this.getReferencedInputs();
        this._areReferencedInputsDirty = false;
        if (referencedInputs) for(var _i = 0, _a = Object.keys(referencedInputs); _i < _a.length; _i++){
            var key = _a[_i];
            var input = referencedInputs[key];
            input.resetDirtyState();
        }
    };
    SubmitActionBase.prototype.updateEnabledState = function() {
        this._areReferencedInputsDirty = false;
        var referencedInputs = this.getReferencedInputs();
        if (referencedInputs) for(var _i = 0, _a = Object.keys(referencedInputs); _i < _a.length; _i++){
            var key = _a[_i];
            var input = referencedInputs[key];
            if (input.isDirty()) {
                this._areReferencedInputsDirty = true;
                break;
            }
        }
        this.updateCssClasses();
        if (this._renderedElement) this.setupElementForAccessibility(this._renderedElement);
    };
    SubmitActionBase.prototype.isEffectivelyEnabled = function() {
        var result = _super.prototype.isEffectivelyEnabled.call(this);
        return this.disabledUnlessAssociatedInputsChange ? result && this._areReferencedInputsDirty : result;
    };
    Object.defineProperty(SubmitActionBase.prototype, "data", {
        get: function() {
            return this._isPrepared ? this._processedData : this._originalData;
        },
        set: function(value) {
            this._originalData = value;
            this._isPrepared = false;
        },
        enumerable: false,
        configurable: true
    });
    SubmitActionBase.dataProperty = new $ldzOp.PropertyDefinition($ldzOp.Versions.v1_0, "data");
    SubmitActionBase.associatedInputsProperty = new $ldzOp.CustomProperty($ldzOp.Versions.v1_3, "associatedInputs", function(sender, prop, source, context) {
        var value = source[prop.name];
        if (value !== undefined && typeof value === "string") return value.toLowerCase() === "none" ? "none" : "auto";
        return undefined;
    }, function(sender, prop, target, value, context) {
        context.serializeValue(target, prop.name, value);
    });
    SubmitActionBase.disabledUnlessAssociatedInputsChangeProperty = new $ldzOp.BoolProperty($ldzOp.Versions.v1_6, "disabledUnlessAssociatedInputsChange", false);
    $2b991ecb5ab02fee$var$__decorate([
        (0, $ldzOp.property)(SubmitActionBase.dataProperty)
    ], SubmitActionBase.prototype, "_originalData", void 0);
    $2b991ecb5ab02fee$var$__decorate([
        (0, $ldzOp.property)(SubmitActionBase.associatedInputsProperty)
    ], SubmitActionBase.prototype, "associatedInputs", void 0);
    $2b991ecb5ab02fee$var$__decorate([
        (0, $ldzOp.property)(SubmitActionBase.disabledUnlessAssociatedInputsChangeProperty)
    ], SubmitActionBase.prototype, "disabledUnlessAssociatedInputsChange", void 0);
    return SubmitActionBase;
}($2b991ecb5ab02fee$var$Action);
module.exports.SubmitActionBase = $2b991ecb5ab02fee$var$SubmitActionBase;
var $2b991ecb5ab02fee$var$SubmitAction = /** @class */ function(_super) {
    $2b991ecb5ab02fee$var$__extends(SubmitAction, _super);
    function SubmitAction() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SubmitAction.prototype.getJsonTypeName = function() {
        return SubmitAction.JsonTypeName;
    };
    // Note the "weird" way this field is declared is to work around a breaking
    // change introduced in TS 3.1 wrt d.ts generation. DO NOT CHANGE
    SubmitAction.JsonTypeName = "Action.Submit";
    return SubmitAction;
}($2b991ecb5ab02fee$var$SubmitActionBase);
module.exports.SubmitAction = $2b991ecb5ab02fee$var$SubmitAction;
var $2b991ecb5ab02fee$var$ExecuteAction = /** @class */ function(_super) {
    $2b991ecb5ab02fee$var$__extends(ExecuteAction, _super);
    function ExecuteAction() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    //#endregion
    ExecuteAction.prototype.getJsonTypeName = function() {
        return ExecuteAction.JsonTypeName;
    };
    // Note the "weird" way this field is declared is to work around a breaking
    // change introduced in TS 3.1 wrt d.ts generation. DO NOT CHANGE
    ExecuteAction.JsonTypeName = "Action.Execute";
    //#region Schema
    ExecuteAction.verbProperty = new $ldzOp.StringProperty($ldzOp.Versions.v1_4, "verb");
    $2b991ecb5ab02fee$var$__decorate([
        (0, $ldzOp.property)(ExecuteAction.verbProperty)
    ], ExecuteAction.prototype, "verb", void 0);
    return ExecuteAction;
}($2b991ecb5ab02fee$var$SubmitActionBase);
module.exports.ExecuteAction = $2b991ecb5ab02fee$var$ExecuteAction;
var $2b991ecb5ab02fee$var$OpenUrlAction = /** @class */ function(_super) {
    $2b991ecb5ab02fee$var$__extends(OpenUrlAction, _super);
    function OpenUrlAction() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    OpenUrlAction.prototype.getJsonTypeName = function() {
        return OpenUrlAction.JsonTypeName;
    };
    OpenUrlAction.prototype.getAriaRole = function() {
        return "link";
    };
    OpenUrlAction.prototype.internalValidateProperties = function(context) {
        _super.prototype.internalValidateProperties.call(this, context);
        if (!this.url) context.addFailure(this, $iw5eI.ValidationEvent.PropertyCantBeNull, $brsVB.Strings.errors.propertyMustBeSet("url"));
    };
    OpenUrlAction.prototype.getHref = function() {
        return this.url;
    };
    //#region Schema
    OpenUrlAction.urlProperty = new $ldzOp.StringProperty($ldzOp.Versions.v1_0, "url");
    //#endregion
    // Note the "weird" way this field is declared is to work around a breaking
    // change introduced in TS 3.1 wrt d.ts generation. DO NOT CHANGE
    OpenUrlAction.JsonTypeName = "Action.OpenUrl";
    $2b991ecb5ab02fee$var$__decorate([
        (0, $ldzOp.property)(OpenUrlAction.urlProperty)
    ], OpenUrlAction.prototype, "url", void 0);
    return OpenUrlAction;
}($2b991ecb5ab02fee$var$Action);
module.exports.OpenUrlAction = $2b991ecb5ab02fee$var$OpenUrlAction;
var $2b991ecb5ab02fee$var$ToggleVisibilityAction = /** @class */ function(_super) {
    $2b991ecb5ab02fee$var$__extends(ToggleVisibilityAction, _super);
    function ToggleVisibilityAction() {
        //#region Schema
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.targetElements = {};
        return _this;
    }
    ToggleVisibilityAction.prototype.updateAriaControlsAttribute = function() {
        // apply aria labels to make it clear which elements this action will toggle
        if (this.targetElements) {
            var elementIds = Object.keys(this.targetElements);
            if (this._renderedElement) {
                if (elementIds.length > 0) this._renderedElement.setAttribute("aria-controls", elementIds.join(" "));
                else this._renderedElement.removeAttribute("aria-controls");
            }
        }
    };
    ToggleVisibilityAction.prototype.internalValidateProperties = function(context) {
        _super.prototype.internalValidateProperties.call(this, context);
        if (!this.targetElements) context.addFailure(this, $iw5eI.ValidationEvent.PropertyCantBeNull, $brsVB.Strings.errors.propertyMustBeSet("targetElements"));
    };
    ToggleVisibilityAction.prototype.getJsonTypeName = function() {
        return ToggleVisibilityAction.JsonTypeName;
    };
    ToggleVisibilityAction.prototype.render = function() {
        _super.prototype.render.call(this);
        this.updateAriaControlsAttribute();
    };
    ToggleVisibilityAction.prototype.execute = function() {
        _super.prototype.execute.call(this);
        if (this.parent) for(var _i = 0, _a = Object.keys(this.targetElements); _i < _a.length; _i++){
            var elementId = _a[_i];
            var targetElement = this.parent.getRootElement().getElementById(elementId);
            if (targetElement) {
                if (typeof this.targetElements[elementId] === "boolean") targetElement.isVisible = this.targetElements[elementId];
                else targetElement.isVisible = !targetElement.isVisible;
            }
        }
    };
    ToggleVisibilityAction.prototype.addTargetElement = function(elementId, isVisible) {
        if (isVisible === void 0) isVisible = undefined;
        this.targetElements[elementId] = isVisible;
        this.updateAriaControlsAttribute();
    };
    ToggleVisibilityAction.prototype.removeTargetElement = function(elementId) {
        delete this.targetElements[elementId];
        this.updateAriaControlsAttribute();
    };
    ToggleVisibilityAction.targetElementsProperty = new $ldzOp.CustomProperty($ldzOp.Versions.v1_2, "targetElements", function(sender, prop, source, context) {
        var result = {};
        if (Array.isArray(source[prop.name])) for(var _i = 0, _a = source[prop.name]; _i < _a.length; _i++){
            var item = _a[_i];
            if (typeof item === "string") result[item] = undefined;
            else if (typeof item === "object") {
                var elementId = item["elementId"];
                if (typeof elementId === "string") result[elementId] = $ioYal.parseBool(item["isVisible"]);
            }
        }
        return result;
    }, function(sender, prop, target, value, context) {
        var targetElements = [];
        for(var _i = 0, _a = Object.keys(value); _i < _a.length; _i++){
            var id = _a[_i];
            if (typeof value[id] === "boolean") targetElements.push({
                elementId: id,
                isVisible: value[id]
            });
            else targetElements.push(id);
        }
        context.serializeArray(target, prop.name, targetElements);
    }, {}, function(sender) {
        return {};
    });
    //#endregion
    // Note the "weird" way this field is declared is to work around a breaking
    // change introduced in TS 3.1 wrt d.ts generation. DO NOT CHANGE
    ToggleVisibilityAction.JsonTypeName = "Action.ToggleVisibility";
    $2b991ecb5ab02fee$var$__decorate([
        (0, $ldzOp.property)(ToggleVisibilityAction.targetElementsProperty)
    ], ToggleVisibilityAction.prototype, "targetElements", void 0);
    return ToggleVisibilityAction;
}($2b991ecb5ab02fee$var$Action);
module.exports.ToggleVisibilityAction = $2b991ecb5ab02fee$var$ToggleVisibilityAction;
var $2b991ecb5ab02fee$var$StringWithSubstitutionProperty = /** @class */ function(_super) {
    $2b991ecb5ab02fee$var$__extends(StringWithSubstitutionProperty, _super);
    function StringWithSubstitutionProperty(targetVersion, name) {
        var _this = _super.call(this, targetVersion, name, undefined, function() {
            return new $eUh3g.StringWithSubstitutions();
        }) || this;
        _this.targetVersion = targetVersion;
        _this.name = name;
        return _this;
    }
    StringWithSubstitutionProperty.prototype.parse = function(sender, source, context) {
        var result = new $eUh3g.StringWithSubstitutions();
        result.set($ioYal.parseString(source[this.name]));
        return result;
    };
    StringWithSubstitutionProperty.prototype.toJSON = function(sender, target, value, context) {
        context.serializeValue(target, this.name, value.getOriginal());
    };
    return StringWithSubstitutionProperty;
}($ldzOp.PropertyDefinition);
var $2b991ecb5ab02fee$var$HttpHeader = /** @class */ function(_super) {
    $2b991ecb5ab02fee$var$__extends(HttpHeader, _super);
    //#endregion
    function HttpHeader(name, value) {
        if (name === void 0) name = "";
        if (value === void 0) value = "";
        var _this = _super.call(this) || this;
        _this.name = name;
        _this.value = value;
        return _this;
    }
    HttpHeader.prototype.getSchemaKey = function() {
        return "HttpHeader";
    };
    HttpHeader.prototype.getReferencedInputs = function(inputs, referencedInputs) {
        this._value.getReferencedInputs(inputs, referencedInputs);
    };
    HttpHeader.prototype.prepareForExecution = function(inputs) {
        this._value.substituteInputValues(inputs, $eUh3g.ContentTypes.applicationXWwwFormUrlencoded);
    };
    Object.defineProperty(HttpHeader.prototype, "value", {
        get: function() {
            return this._value.get();
        },
        set: function(newValue) {
            this._value.set(newValue);
        },
        enumerable: false,
        configurable: true
    });
    //#region Schema
    HttpHeader.nameProperty = new $ldzOp.StringProperty($ldzOp.Versions.v1_0, "name");
    HttpHeader.valueProperty = new $2b991ecb5ab02fee$var$StringWithSubstitutionProperty($ldzOp.Versions.v1_0, "value");
    $2b991ecb5ab02fee$var$__decorate([
        (0, $ldzOp.property)(HttpHeader.nameProperty)
    ], HttpHeader.prototype, "name", void 0);
    $2b991ecb5ab02fee$var$__decorate([
        (0, $ldzOp.property)(HttpHeader.valueProperty)
    ], HttpHeader.prototype, "_value", void 0);
    return HttpHeader;
}($ldzOp.SerializableObject);
module.exports.HttpHeader = $2b991ecb5ab02fee$var$HttpHeader;
var $2b991ecb5ab02fee$var$HttpAction = /** @class */ function(_super) {
    $2b991ecb5ab02fee$var$__extends(HttpAction, _super);
    function HttpAction() {
        //#region Schema
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._ignoreInputValidation = false;
        return _this;
    }
    HttpAction.prototype.internalGetReferencedInputs = function() {
        var allInputs = this.parent ? this.parent.getRootElement().getAllInputs() : [];
        var result = {};
        this._url.getReferencedInputs(allInputs, result);
        for(var _i = 0, _a = this.headers; _i < _a.length; _i++){
            var header = _a[_i];
            header.getReferencedInputs(allInputs, result);
        }
        this._body.getReferencedInputs(allInputs, result);
        return result;
    };
    HttpAction.prototype.internalPrepareForExecution = function(inputs) {
        if (inputs) {
            this._url.substituteInputValues(inputs, $eUh3g.ContentTypes.applicationXWwwFormUrlencoded);
            var contentType = $eUh3g.ContentTypes.applicationJson;
            for(var _i = 0, _a = this.headers; _i < _a.length; _i++){
                var header = _a[_i];
                header.prepareForExecution(inputs);
                if (header.name && header.name.toLowerCase() === "content-type") contentType = header.value;
            }
            this._body.substituteInputValues(inputs, contentType);
        }
    };
    HttpAction.prototype.getJsonTypeName = function() {
        return HttpAction.JsonTypeName;
    };
    HttpAction.prototype.internalValidateProperties = function(context) {
        _super.prototype.internalValidateProperties.call(this, context);
        if (!this.url) context.addFailure(this, $iw5eI.ValidationEvent.PropertyCantBeNull, $brsVB.Strings.errors.propertyMustBeSet("url"));
        if (this.headers.length > 0) for(var _i = 0, _a = this.headers; _i < _a.length; _i++){
            var header = _a[_i];
            if (!header.name) context.addFailure(this, $iw5eI.ValidationEvent.PropertyCantBeNull, $brsVB.Strings.errors.actionHttpHeadersMustHaveNameAndValue());
        }
    };
    Object.defineProperty(HttpAction.prototype, "ignoreInputValidation", {
        get: function() {
            return this._ignoreInputValidation;
        },
        set: function(value) {
            this._ignoreInputValidation = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(HttpAction.prototype, "url", {
        get: function() {
            return this._url.get();
        },
        set: function(value) {
            this._url.set(value);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(HttpAction.prototype, "body", {
        get: function() {
            return this._body.get();
        },
        set: function(value) {
            this._body.set(value);
        },
        enumerable: false,
        configurable: true
    });
    HttpAction.urlProperty = new $2b991ecb5ab02fee$var$StringWithSubstitutionProperty($ldzOp.Versions.v1_0, "url");
    HttpAction.bodyProperty = new $2b991ecb5ab02fee$var$StringWithSubstitutionProperty($ldzOp.Versions.v1_0, "body");
    HttpAction.methodProperty = new $ldzOp.StringProperty($ldzOp.Versions.v1_0, "method");
    HttpAction.headersProperty = new $ldzOp.SerializableObjectCollectionProperty($ldzOp.Versions.v1_0, "headers", $2b991ecb5ab02fee$var$HttpHeader);
    HttpAction.ignoreInputValidationProperty = new $ldzOp.BoolProperty($ldzOp.Versions.v1_3, "ignoreInputValidation", false);
    //#endregion
    // Note the "weird" way this field is declared is to work around a breaking
    // change introduced in TS 3.1 wrt d.ts generation. DO NOT CHANGE
    HttpAction.JsonTypeName = "Action.Http";
    $2b991ecb5ab02fee$var$__decorate([
        (0, $ldzOp.property)(HttpAction.urlProperty)
    ], HttpAction.prototype, "_url", void 0);
    $2b991ecb5ab02fee$var$__decorate([
        (0, $ldzOp.property)(HttpAction.bodyProperty)
    ], HttpAction.prototype, "_body", void 0);
    $2b991ecb5ab02fee$var$__decorate([
        (0, $ldzOp.property)(HttpAction.methodProperty)
    ], HttpAction.prototype, "method", void 0);
    $2b991ecb5ab02fee$var$__decorate([
        (0, $ldzOp.property)(HttpAction.headersProperty)
    ], HttpAction.prototype, "headers", void 0);
    $2b991ecb5ab02fee$var$__decorate([
        (0, $ldzOp.property)(HttpAction.ignoreInputValidationProperty)
    ], HttpAction.prototype, "_ignoreInputValidation", void 0);
    return HttpAction;
}($2b991ecb5ab02fee$var$Action);
module.exports.HttpAction = $2b991ecb5ab02fee$var$HttpAction;
var $2b991ecb5ab02fee$var$ShowCardAction = /** @class */ function(_super) {
    $2b991ecb5ab02fee$var$__extends(ShowCardAction, _super);
    function ShowCardAction() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.card = new $2b991ecb5ab02fee$var$InlineAdaptiveCard();
        return _this;
    }
    ShowCardAction.prototype.updateCssClasses = function() {
        _super.prototype.updateCssClasses.call(this);
        if (this.renderedElement) {
            var effectiveHostConfig = this.parent ? this.parent.hostConfig : $4IoSX.defaultHostConfig;
            this.renderedElement.classList.add(effectiveHostConfig.makeCssClassName("expandable"));
            this.renderedElement.setAttribute("aria-expanded", (this.state === 1 /* Expanded */ ).toString());
        }
    };
    ShowCardAction.prototype.internalParse = function(source, context) {
        _super.prototype.internalParse.call(this, source, context);
        var jsonCard = source["card"];
        if (jsonCard) this.card.parse(jsonCard, context);
        else context.logParseEvent(this, $iw5eI.ValidationEvent.PropertyCantBeNull, $brsVB.Strings.errors.showCardMustHaveCard());
    };
    ShowCardAction.prototype.internalToJSON = function(target, context) {
        _super.prototype.internalToJSON.call(this, target, context);
        if (this.card) context.serializeValue(target, "card", this.card.toJSON(context));
    };
    ShowCardAction.prototype.raiseExecuteActionEvent = function() {
        if (this.hostConfig.actions.showCard.actionMode === $iw5eI.ShowCardActionMode.Popup) // Only raise the event in Popup mode.
        _super.prototype.raiseExecuteActionEvent.call(this);
    };
    ShowCardAction.prototype.releaseDOMResources = function() {
        _super.prototype.releaseDOMResources.call(this);
        this.card.releaseDOMResources();
    };
    ShowCardAction.prototype.getJsonTypeName = function() {
        return ShowCardAction.JsonTypeName;
    };
    ShowCardAction.prototype.internalValidateProperties = function(context) {
        _super.prototype.internalValidateProperties.call(this, context);
        this.card.internalValidateProperties(context);
    };
    ShowCardAction.prototype.setParent = function(value) {
        _super.prototype.setParent.call(this, value);
        this.card.setParent(value);
    };
    ShowCardAction.prototype.getAllInputs = function(processActions) {
        if (processActions === void 0) processActions = true;
        return this.card.getAllInputs(processActions);
    };
    ShowCardAction.prototype.getAllActions = function() {
        var result = _super.prototype.getAllActions.call(this);
        result.push.apply(result, this.card.getAllActions());
        return result;
    };
    ShowCardAction.prototype.getResourceInformation = function() {
        var result = _super.prototype.getResourceInformation.call(this);
        result.push.apply(result, this.card.getResourceInformation());
        return result;
    };
    ShowCardAction.prototype.getActionById = function(id) {
        var result = _super.prototype.getActionById.call(this, id);
        if (!result) result = this.card.getActionById(id);
        return result;
    };
    // Note the "weird" way this field is declared is to work around a breaking
    // change introduced in TS 3.1 wrt d.ts generation. DO NOT CHANGE
    ShowCardAction.JsonTypeName = "Action.ShowCard";
    return ShowCardAction;
}($2b991ecb5ab02fee$var$Action);
module.exports.ShowCardAction = $2b991ecb5ab02fee$var$ShowCardAction;
var $2b991ecb5ab02fee$var$OverflowAction = /** @class */ function(_super) {
    $2b991ecb5ab02fee$var$__extends(OverflowAction, _super);
    function OverflowAction(actions) {
        var _this = _super.call(this) || this;
        _this._actions = actions;
        _this.title = $brsVB.Strings.defaults.overflowButtonText();
        return _this;
    }
    OverflowAction.prototype.getActions = function() {
        return this._actions;
    };
    OverflowAction.prototype.getAllActions = function() {
        var result = _super.prototype.getAllActions.call(this);
        result.push.apply(result, this._actions);
        return result;
    };
    OverflowAction.prototype.getJsonTypeName = function() {
        return $2b991ecb5ab02fee$var$ShowCardAction.JsonTypeName;
    };
    OverflowAction.prototype.execute = function() {
        var _this = this;
        var _a;
        var shouldDisplayPopupMenu = !$2b991ecb5ab02fee$var$raiseDisplayOverflowActionMenuEvent(this, this.renderedElement);
        if (shouldDisplayPopupMenu && this.renderedElement) {
            var contextMenu_1 = new $eIrtg.PopupMenu();
            contextMenu_1.hostConfig = this.hostConfig;
            var _loop_2 = function(i) {
                var menuItem = new $eIrtg.MenuItem(i.toString(), (_a = this_1._actions[i].title) !== null && _a !== void 0 ? _a : "");
                menuItem.isEnabled = this_1._actions[i].isEnabled;
                menuItem.onClick = function() {
                    var actionToExecute = _this._actions[i];
                    contextMenu_1.closePopup(false);
                    if (actionToExecute.isEnabled) actionToExecute.execute();
                };
                contextMenu_1.items.add(menuItem);
            };
            var this_1 = this;
            for(var i = 0; i < this._actions.length; i++)_loop_2(i);
            contextMenu_1.popup(this.renderedElement);
        }
    };
    OverflowAction.JsonTypeName = "Action.Overflow";
    return OverflowAction;
}($2b991ecb5ab02fee$var$Action);
var $2b991ecb5ab02fee$var$ActionCollection = /** @class */ function() {
    function ActionCollection(owner) {
        this._items = [];
        this._renderedActions = [];
        this._owner = owner;
    }
    ActionCollection.prototype.isActionAllowed = function(action) {
        var forbiddenTypes = this._owner.getForbiddenActionTypes();
        if (forbiddenTypes) for(var _i = 0, forbiddenTypes_1 = forbiddenTypes; _i < forbiddenTypes_1.length; _i++){
            var forbiddenType = forbiddenTypes_1[_i];
            if (action.constructor === forbiddenType) return false;
        }
        return true;
    };
    ActionCollection.prototype.refreshContainer = function() {
        $2b991ecb5ab02fee$var$clearElement(this._actionCardContainer);
        if (!this._actionCard) {
            this._actionCardContainer.style.marginTop = "0px";
            return;
        }
        this._actionCardContainer.style.marginTop = this.renderedActionCount > 0 ? this._owner.hostConfig.actions.showCard.inlineTopMargin + "px" : "0px";
        var padding = this._owner.getEffectivePadding();
        this._owner.getImmediateSurroundingPadding(padding);
        var physicalPadding = this._owner.hostConfig.paddingDefinitionToSpacingDefinition(padding);
        if (this._actionCard) {
            this._actionCard.style.paddingLeft = physicalPadding.left + "px";
            this._actionCard.style.paddingRight = physicalPadding.right + "px";
            this._actionCard.style.marginLeft = "-" + physicalPadding.left + "px";
            this._actionCard.style.marginRight = "-" + physicalPadding.right + "px";
            if (physicalPadding.bottom !== 0 && !this._owner.isDesignMode()) {
                this._actionCard.style.paddingBottom = physicalPadding.bottom + "px";
                this._actionCard.style.marginBottom = "-" + physicalPadding.bottom + "px";
            }
            $ioYal.appendChild(this._actionCardContainer, this._actionCard);
        }
    };
    ActionCollection.prototype.layoutChanged = function() {
        this._owner.getRootElement().updateLayout();
    };
    ActionCollection.prototype.showActionCard = function(action, suppressStyle, raiseEvent) {
        if (suppressStyle === void 0) suppressStyle = false;
        if (raiseEvent === void 0) raiseEvent = true;
        action.card.suppressStyle = suppressStyle;
        // Always re-render a ShowCard action in design mode; reuse already rendered ShowCard (if available) otherwise
        var renderedCard = action.card.renderedElement && !this._owner.isDesignMode() ? action.card.renderedElement : action.card.render();
        this._actionCard = renderedCard;
        this._expandedAction = action;
        this.refreshContainer();
        if (raiseEvent) {
            this.layoutChanged();
            $2b991ecb5ab02fee$var$raiseInlineCardExpandedEvent(action, true);
        }
    };
    ActionCollection.prototype.collapseExpandedAction = function() {
        for(var _i = 0, _a = this._renderedActions; _i < _a.length; _i++){
            var action = _a[_i];
            action.state = 0 /* Normal */ ;
        }
        var previouslyExpandedAction = this._expandedAction;
        this._expandedAction = undefined;
        this._actionCard = undefined;
        this.refreshContainer();
        if (previouslyExpandedAction) {
            this.layoutChanged();
            $2b991ecb5ab02fee$var$raiseInlineCardExpandedEvent(previouslyExpandedAction, false);
        }
    };
    ActionCollection.prototype.expandShowCardAction = function(action, raiseEvent) {
        var _this = this;
        var afterSelectedAction = false;
        for(var _i = 0, _a = this._renderedActions; _i < _a.length; _i++){
            var renderedAction = _a[_i];
            // Remove actions after selected action from tabOrder if the actions are oriented horizontally, to skip focus directly to expanded card
            if (this._owner.hostConfig.actions.actionsOrientation == $iw5eI.Orientation.Horizontal && afterSelectedAction) renderedAction.isFocusable = false;
            if (renderedAction !== action) renderedAction.state = 2 /* Subdued */ ;
            else {
                renderedAction.state = 1 /* Expanded */ ;
                afterSelectedAction = true;
                if (renderedAction.renderedElement) renderedAction.renderedElement.onblur = function(_e) {
                    for(var _i = 0, _a = _this._renderedActions; _i < _a.length; _i++){
                        var ra = _a[_i];
                        ra.isFocusable = true;
                    }
                };
            }
        }
        this.showActionCard(action, !(this._owner.isAtTheVeryLeft() && this._owner.isAtTheVeryRight()), raiseEvent);
    };
    ActionCollection.prototype.releaseDOMResources = function() {
        for(var _i = 0, _a = this._renderedActions; _i < _a.length; _i++){
            var action = _a[_i];
            action.releaseDOMResources();
        }
    };
    ActionCollection.prototype.actionExecuted = function(action) {
        if (!(action instanceof $2b991ecb5ab02fee$var$ShowCardAction)) this.collapseExpandedAction();
        else {
            if (action === this._expandedAction) this.collapseExpandedAction();
            else if (this._owner.hostConfig.actions.showCard.actionMode === $iw5eI.ShowCardActionMode.Inline) this.expandShowCardAction(action, true);
        }
    };
    ActionCollection.prototype.parse = function(source, context) {
        this.clear();
        if (Array.isArray(source)) for(var _i = 0, source_1 = source; _i < source_1.length; _i++){
            var jsonAction = source_1[_i];
            var forbiddenActions = [];
            // If the action owner is a ContainerWithActions, we should check for forbidden actions
            if (this._owner instanceof $2b991ecb5ab02fee$var$ContainerWithActions) forbiddenActions = this._owner.getForbiddenActionNames();
            var action = context.parseAction(this._owner, jsonAction, forbiddenActions, !this._owner.isDesignMode());
            if (action) this.addAction(action);
        }
    };
    ActionCollection.prototype.toJSON = function(target, propertyName, context) {
        context.serializeArray(target, propertyName, this._items);
    };
    ActionCollection.prototype.getActionAt = function(id) {
        return this._items[id];
    };
    ActionCollection.prototype.getActionCount = function() {
        return this._items.length;
    };
    ActionCollection.prototype.getActionById = function(id) {
        var result = undefined;
        for(var _i = 0, _a = this._items; _i < _a.length; _i++){
            var item = _a[_i];
            result = item.getActionById(id);
            if (result) break;
        }
        return result;
    };
    ActionCollection.prototype.validateProperties = function(context) {
        if (this._owner.hostConfig.actions.maxActions && this._items.length > this._owner.hostConfig.actions.maxActions) context.addFailure(this._owner, $iw5eI.ValidationEvent.TooManyActions, $brsVB.Strings.errors.tooManyActions(this._owner.hostConfig.actions.maxActions));
        if (this._items.length > 0 && !this._owner.hostConfig.supportsInteractivity) context.addFailure(this._owner, $iw5eI.ValidationEvent.InteractivityNotAllowed, $brsVB.Strings.errors.interactivityNotAllowed());
        for(var _i = 0, _a = this._items; _i < _a.length; _i++){
            var item = _a[_i];
            if (!this.isActionAllowed(item)) context.addFailure(this._owner, $iw5eI.ValidationEvent.ActionTypeNotAllowed, $brsVB.Strings.errors.actionTypeNotAllowed(item.getJsonTypeName()));
            item.internalValidateProperties(context);
        }
    };
    ActionCollection.prototype.render = function(orientation) {
        // Cache hostConfig for better perf
        var hostConfig = this._owner.hostConfig;
        if (!hostConfig.supportsInteractivity) return undefined;
        var element = document.createElement("div");
        var maxActions = hostConfig.actions.maxActions ? Math.min(hostConfig.actions.maxActions, this._items.length) : this._items.length;
        this._actionCardContainer = document.createElement("div");
        this._renderedActions = [];
        if (hostConfig.actions.preExpandSingleShowCardAction && maxActions === 1 && this._items[0] instanceof $2b991ecb5ab02fee$var$ShowCardAction && this.isActionAllowed(this._items[0])) {
            this.showActionCard(this._items[0], true);
            this._renderedActions.push(this._items[0]);
        } else {
            var buttonStrip = document.createElement("div");
            buttonStrip.className = hostConfig.makeCssClassName("ac-actionSet");
            buttonStrip.style.display = "flex";
            if (orientation === $iw5eI.Orientation.Horizontal) {
                buttonStrip.style.flexDirection = "row";
                if (this._owner.horizontalAlignment && hostConfig.actions.actionAlignment !== $iw5eI.ActionAlignment.Stretch) switch(this._owner.horizontalAlignment){
                    case $iw5eI.HorizontalAlignment.Center:
                        buttonStrip.style.justifyContent = "center";
                        break;
                    case $iw5eI.HorizontalAlignment.Right:
                        buttonStrip.style.justifyContent = "flex-end";
                        break;
                    default:
                        buttonStrip.style.justifyContent = "flex-start";
                        break;
                }
                else switch(hostConfig.actions.actionAlignment){
                    case $iw5eI.ActionAlignment.Center:
                        buttonStrip.style.justifyContent = "center";
                        break;
                    case $iw5eI.ActionAlignment.Right:
                        buttonStrip.style.justifyContent = "flex-end";
                        break;
                    default:
                        buttonStrip.style.justifyContent = "flex-start";
                        break;
                }
            } else {
                buttonStrip.style.flexDirection = "column";
                if (this._owner.horizontalAlignment && hostConfig.actions.actionAlignment !== $iw5eI.ActionAlignment.Stretch) switch(this._owner.horizontalAlignment){
                    case $iw5eI.HorizontalAlignment.Center:
                        buttonStrip.style.alignItems = "center";
                        break;
                    case $iw5eI.HorizontalAlignment.Right:
                        buttonStrip.style.alignItems = "flex-end";
                        break;
                    default:
                        buttonStrip.style.alignItems = "flex-start";
                        break;
                }
                else switch(hostConfig.actions.actionAlignment){
                    case $iw5eI.ActionAlignment.Center:
                        buttonStrip.style.alignItems = "center";
                        break;
                    case $iw5eI.ActionAlignment.Right:
                        buttonStrip.style.alignItems = "flex-end";
                        break;
                    case $iw5eI.ActionAlignment.Stretch:
                        buttonStrip.style.alignItems = "stretch";
                        break;
                    default:
                        buttonStrip.style.alignItems = "flex-start";
                        break;
                }
            }
            var allowedActions = this._items.filter(this.isActionAllowed.bind(this));
            var primaryActions_1 = [];
            var secondaryActions_1 = [];
            if (!this._owner.isDesignMode()) {
                allowedActions.forEach(function(action) {
                    return action.mode === $iw5eI.ActionMode.Secondary ? secondaryActions_1.push(action) : primaryActions_1.push(action);
                });
                // If primaryActions.length > maxActions, extra actions are moved to overflow
                var overflowPrimaryActions = primaryActions_1.splice(hostConfig.actions.maxActions);
                if ($eUh3g.GlobalSettings.allowMoreThanMaxActionsInOverflowMenu) secondaryActions_1.push.apply(secondaryActions_1, overflowPrimaryActions);
                var shouldRenderOverflowActionButton = true;
                if (secondaryActions_1.length > 0) {
                    if (!this._overflowAction) {
                        this._overflowAction = new $2b991ecb5ab02fee$var$OverflowAction(secondaryActions_1);
                        this._overflowAction.setParent(this._owner);
                        this._overflowAction["_actionCollection"] = this;
                    }
                    var isRootAction = this._owner instanceof $2b991ecb5ab02fee$var$AdaptiveCard && !this._owner.parent;
                    shouldRenderOverflowActionButton = !$2b991ecb5ab02fee$var$raiseRenderOverflowActionsEvent(this._overflowAction, isRootAction);
                }
                if (this._overflowAction && shouldRenderOverflowActionButton) primaryActions_1.push(this._overflowAction);
            } else primaryActions_1 = allowedActions;
            for(var i = 0; i < primaryActions_1.length; i++){
                var action = primaryActions_1[i];
                action.render();
                if (action.renderedElement) {
                    if (hostConfig.actions.actionsOrientation === $iw5eI.Orientation.Horizontal && hostConfig.actions.actionAlignment === $iw5eI.ActionAlignment.Stretch) action.renderedElement.style.flex = "0 1 100%";
                    else action.renderedElement.style.flex = "0 1 auto";
                    buttonStrip.appendChild(action.renderedElement);
                    this._renderedActions.push(action);
                    if (i < primaryActions_1.length - 1 && hostConfig.actions.buttonSpacing > 0) {
                        var spacer = document.createElement("div");
                        if (orientation === $iw5eI.Orientation.Horizontal) {
                            spacer.style.flex = "0 0 auto";
                            spacer.style.width = hostConfig.actions.buttonSpacing + "px";
                        } else spacer.style.height = hostConfig.actions.buttonSpacing + "px";
                        $ioYal.appendChild(buttonStrip, spacer);
                    }
                }
            }
            var buttonStripContainer = document.createElement("div");
            buttonStripContainer.style.overflow = "hidden";
            buttonStripContainer.appendChild(buttonStrip);
            $ioYal.appendChild(element, buttonStripContainer);
        }
        $ioYal.appendChild(element, this._actionCardContainer);
        for(var _i = 0, _a = this._renderedActions; _i < _a.length; _i++){
            var renderedAction = _a[_i];
            if (renderedAction.state === 1 /* Expanded */ ) {
                this.expandShowCardAction(renderedAction, false);
                break;
            }
        }
        return this._renderedActions.length > 0 ? element : undefined;
    };
    ActionCollection.prototype.addAction = function(action) {
        if (!action) throw new Error("The action parameter cannot be null.");
        if ((!action.parent || action.parent === this._owner) && this._items.indexOf(action) < 0) {
            this._items.push(action);
            if (!action.parent) action.setParent(this._owner);
            action["_actionCollection"] = this;
        } else throw new Error($brsVB.Strings.errors.actionAlreadyParented());
    };
    ActionCollection.prototype.removeAction = function(action) {
        if (this.expandedAction && this._expandedAction === action) this.collapseExpandedAction();
        var actionIndex = this._items.indexOf(action);
        if (actionIndex >= 0) {
            this._items.splice(actionIndex, 1);
            action.setParent(undefined);
            action["_actionCollection"] = undefined;
            for(var i = 0; i < this._renderedActions.length; i++)if (this._renderedActions[i] === action) {
                this._renderedActions.splice(i, 1);
                break;
            }
            return true;
        }
        return false;
    };
    ActionCollection.prototype.clear = function() {
        this._items = [];
        this._renderedActions = [];
        this._expandedAction = undefined;
    };
    ActionCollection.prototype.getAllInputs = function(processActions) {
        if (processActions === void 0) processActions = true;
        var result = [];
        if (processActions) for(var _i = 0, _a = this._items; _i < _a.length; _i++){
            var action = _a[_i];
            result.push.apply(result, action.getAllInputs());
        }
        return result;
    };
    ActionCollection.prototype.getResourceInformation = function() {
        var result = [];
        for(var _i = 0, _a = this._items; _i < _a.length; _i++){
            var action = _a[_i];
            result.push.apply(result, action.getResourceInformation());
        }
        return result;
    };
    Object.defineProperty(ActionCollection.prototype, "renderedActionCount", {
        get: function() {
            return this._renderedActions.length;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ActionCollection.prototype, "expandedAction", {
        get: function() {
            return this._expandedAction;
        },
        enumerable: false,
        configurable: true
    });
    return ActionCollection;
}();
var $2b991ecb5ab02fee$var$ActionSet = /** @class */ function(_super) {
    $2b991ecb5ab02fee$var$__extends(ActionSet, _super);
    function ActionSet() {
        var _this = _super.call(this) || this;
        _this._actionCollection = new $2b991ecb5ab02fee$var$ActionCollection(_this);
        return _this;
    }
    ActionSet.prototype.internalParse = function(source, context) {
        _super.prototype.internalParse.call(this, source, context);
        this._actionCollection.parse(source["actions"], context);
    };
    ActionSet.prototype.internalToJSON = function(target, context) {
        _super.prototype.internalToJSON.call(this, target, context);
        this._actionCollection.toJSON(target, "actions", context);
    };
    ActionSet.prototype.internalRender = function() {
        return this._actionCollection.render(this.orientation !== undefined ? this.orientation : this.hostConfig.actions.actionsOrientation);
    };
    ActionSet.prototype.releaseDOMResources = function() {
        _super.prototype.releaseDOMResources.call(this);
        this._actionCollection.releaseDOMResources();
    };
    ActionSet.prototype.isBleedingAtBottom = function() {
        if (this._actionCollection.renderedActionCount === 0) return _super.prototype.isBleedingAtBottom.call(this);
        else {
            if (this._actionCollection.getActionCount() === 1) return this._actionCollection.expandedAction !== undefined && !this.hostConfig.actions.preExpandSingleShowCardAction;
            else return this._actionCollection.expandedAction !== undefined;
        }
    };
    ActionSet.prototype.getJsonTypeName = function() {
        return "ActionSet";
    };
    ActionSet.prototype.getActionCount = function() {
        return this._actionCollection.getActionCount();
    };
    ActionSet.prototype.getActionAt = function(index) {
        if (index >= 0 && index < this.getActionCount()) return this._actionCollection.getActionAt(index);
        else return _super.prototype.getActionAt.call(this, index);
    };
    ActionSet.prototype.getActionById = function(id) {
        var result = this._actionCollection.getActionById(id);
        return result ? result : _super.prototype.getActionById.call(this, id);
    };
    ActionSet.prototype.getAllActions = function() {
        var result = _super.prototype.getAllActions.call(this);
        for(var i = 0; i < this.getActionCount(); i++){
            var action = this.getActionAt(i);
            if (action) result.push(action);
        }
        return result;
    };
    ActionSet.prototype.internalValidateProperties = function(context) {
        _super.prototype.internalValidateProperties.call(this, context);
        this._actionCollection.validateProperties(context);
    };
    ActionSet.prototype.addAction = function(action) {
        this._actionCollection.addAction(action);
    };
    ActionSet.prototype.getAllInputs = function(processActions) {
        if (processActions === void 0) processActions = true;
        return processActions ? this._actionCollection.getAllInputs() : [];
    };
    ActionSet.prototype.getResourceInformation = function() {
        return this._actionCollection.getResourceInformation();
    };
    /**
     * @inheritdoc
     */ ActionSet.prototype.findDOMNodeOwner = function(node) {
        var target = undefined;
        for(var i = 0; i < this.getActionCount(); i++){
            var action = this.getActionAt(i);
            if (action) {
                // recur through each Action
                target = action.findDOMNodeOwner(node);
                if (target) return target;
            }
        }
        // if not found in any Action, defer to parent implementation
        return _super.prototype.findDOMNodeOwner.call(this, node);
    };
    Object.defineProperty(ActionSet.prototype, "isInteractive", {
        get: function() {
            return true;
        },
        enumerable: false,
        configurable: true
    });
    //#region Schema
    ActionSet.orientationProperty = new $ldzOp.EnumProperty($ldzOp.Versions.v1_1, "orientation", $iw5eI.Orientation);
    $2b991ecb5ab02fee$var$__decorate([
        (0, $ldzOp.property)(ActionSet.orientationProperty)
    ], ActionSet.prototype, "orientation", void 0);
    return ActionSet;
}($2b991ecb5ab02fee$var$CardElement);
module.exports.ActionSet = $2b991ecb5ab02fee$var$ActionSet;
var $2b991ecb5ab02fee$var$ContainerStyleProperty = /** @class */ function(_super) {
    $2b991ecb5ab02fee$var$__extends(ContainerStyleProperty, _super);
    function ContainerStyleProperty(targetVersion, name, defaultValue, onGetInitialValue) {
        var _this = _super.call(this, targetVersion, name, [
            {
                value: $iw5eI.ContainerStyle.Default
            },
            {
                value: $iw5eI.ContainerStyle.Emphasis
            },
            {
                targetVersion: $ldzOp.Versions.v1_2,
                value: $iw5eI.ContainerStyle.Accent
            },
            {
                targetVersion: $ldzOp.Versions.v1_2,
                value: $iw5eI.ContainerStyle.Good
            },
            {
                targetVersion: $ldzOp.Versions.v1_2,
                value: $iw5eI.ContainerStyle.Attention
            },
            {
                targetVersion: $ldzOp.Versions.v1_2,
                value: $iw5eI.ContainerStyle.Warning
            }
        ], defaultValue, onGetInitialValue) || this;
        _this.targetVersion = targetVersion;
        _this.name = name;
        _this.defaultValue = defaultValue;
        _this.onGetInitialValue = onGetInitialValue;
        return _this;
    }
    return ContainerStyleProperty;
}($ldzOp.ValueSetProperty);
module.exports.ContainerStyleProperty = $2b991ecb5ab02fee$var$ContainerStyleProperty;
var $2b991ecb5ab02fee$var$StylableCardElementContainer = /** @class */ function(_super) {
    $2b991ecb5ab02fee$var$__extends(StylableCardElementContainer, _super);
    function StylableCardElementContainer() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(StylableCardElementContainer.prototype, "style", {
        get: function() {
            if (this.allowCustomStyle) {
                var style = this.getValue(StylableCardElementContainer.styleProperty);
                if (style && this.hostConfig.containerStyles.getStyleByName(style)) return style;
            }
            return undefined;
        },
        set: function(value) {
            this.setValue(StylableCardElementContainer.styleProperty, value);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StylableCardElementContainer.prototype, "allowCustomStyle", {
        //#endregion
        get: function() {
            return true;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StylableCardElementContainer.prototype, "hasExplicitStyle", {
        get: function() {
            return this.getValue(StylableCardElementContainer.styleProperty) !== undefined;
        },
        enumerable: false,
        configurable: true
    });
    StylableCardElementContainer.prototype.applyBorder = function() {
    // No border in base implementation
    };
    StylableCardElementContainer.prototype.applyBackground = function() {
        if (this.renderedElement) {
            var styleDefinition = this.hostConfig.containerStyles.getStyleByName(this.style, this.hostConfig.containerStyles.getStyleByName(this.defaultStyle));
            if (styleDefinition.backgroundColor) {
                var bgColor = $ioYal.stringToCssColor(styleDefinition.backgroundColor);
                if (bgColor) this.renderedElement.style.backgroundColor = bgColor;
            }
        }
    };
    StylableCardElementContainer.prototype.applyPadding = function() {
        _super.prototype.applyPadding.call(this);
        if (!this.renderedElement) return;
        var physicalPadding = new $eUh3g.SpacingDefinition();
        if (this.getEffectivePadding()) physicalPadding = this.hostConfig.paddingDefinitionToSpacingDefinition(this.getEffectivePadding());
        this.renderedElement.style.paddingTop = physicalPadding.top + "px";
        this.renderedElement.style.paddingRight = physicalPadding.right + "px";
        this.renderedElement.style.paddingBottom = physicalPadding.bottom + "px";
        this.renderedElement.style.paddingLeft = physicalPadding.left + "px";
        if (this.isBleeding()) {
            // Bleed into the first parent that does have padding
            var padding = new $eUh3g.PaddingDefinition();
            this.getImmediateSurroundingPadding(padding);
            var surroundingPadding = this.hostConfig.paddingDefinitionToSpacingDefinition(padding);
            this.renderedElement.style.marginRight = "-" + surroundingPadding.right + "px";
            this.renderedElement.style.marginLeft = "-" + surroundingPadding.left + "px";
            if (!this.isDesignMode()) {
                this.renderedElement.style.marginTop = "-" + surroundingPadding.top + "px";
                this.renderedElement.style.marginBottom = "-" + surroundingPadding.bottom + "px";
            }
            if (this.separatorElement && this.separatorOrientation === $iw5eI.Orientation.Horizontal) {
                this.separatorElement.style.marginLeft = "-" + surroundingPadding.left + "px";
                this.separatorElement.style.marginRight = "-" + surroundingPadding.right + "px";
            }
        } else {
            this.renderedElement.style.marginRight = "0";
            this.renderedElement.style.marginLeft = "0";
            this.renderedElement.style.marginTop = "0";
            this.renderedElement.style.marginBottom = "0";
            if (this.separatorElement && this.separatorOrientation === $iw5eI.Orientation.Horizontal) {
                this.separatorElement.style.marginRight = "0";
                this.separatorElement.style.marginLeft = "0";
            }
        }
    };
    StylableCardElementContainer.prototype.getHasBackground = function(ignoreBackgroundImages) {
        if (ignoreBackgroundImages === void 0) ignoreBackgroundImages = false;
        var currentElement = this.parent;
        while(currentElement){
            var currentElementHasBackgroundImage = false;
            if (ignoreBackgroundImages) currentElementHasBackgroundImage = false;
            else currentElementHasBackgroundImage = currentElement instanceof $2b991ecb5ab02fee$var$Container ? currentElement.backgroundImage.isValid() : false;
            if (currentElement instanceof StylableCardElementContainer) {
                if (this.hasExplicitStyle && (currentElement.getEffectiveStyle() !== this.getEffectiveStyle() || currentElementHasBackgroundImage)) return true;
            }
            currentElement = currentElement.parent;
        }
        return false;
    };
    StylableCardElementContainer.prototype.getDefaultPadding = function() {
        return this.getHasBackground() || this.getHasBorder() ? new $eUh3g.PaddingDefinition($iw5eI.Spacing.Padding, $iw5eI.Spacing.Padding, $iw5eI.Spacing.Padding, $iw5eI.Spacing.Padding) : _super.prototype.getDefaultPadding.call(this);
    };
    StylableCardElementContainer.prototype.internalValidateProperties = function(context) {
        _super.prototype.internalValidateProperties.call(this, context);
        var explicitStyle = this.getValue(StylableCardElementContainer.styleProperty);
        if (explicitStyle !== undefined) {
            var styleDefinition = this.hostConfig.containerStyles.getStyleByName(explicitStyle);
            if (!styleDefinition) context.addFailure(this, $iw5eI.ValidationEvent.InvalidPropertyValue, $brsVB.Strings.errors.invalidPropertyValue(explicitStyle, "style"));
        }
    };
    StylableCardElementContainer.prototype.render = function() {
        var renderedElement = _super.prototype.render.call(this);
        if (renderedElement && this.getHasBackground()) this.applyBackground();
        this.applyBorder();
        return renderedElement;
    };
    StylableCardElementContainer.prototype.getEffectiveStyle = function() {
        var effectiveStyle = this.style;
        return effectiveStyle ? effectiveStyle : _super.prototype.getEffectiveStyle.call(this);
    };
    //#region Schema
    StylableCardElementContainer.styleProperty = new $2b991ecb5ab02fee$var$ContainerStyleProperty($ldzOp.Versions.v1_0, "style");
    $2b991ecb5ab02fee$var$__decorate([
        (0, $ldzOp.property)(StylableCardElementContainer.styleProperty)
    ], StylableCardElementContainer.prototype, "style", null);
    return StylableCardElementContainer;
}($2b991ecb5ab02fee$var$CardElementContainer);
module.exports.StylableCardElementContainer = $2b991ecb5ab02fee$var$StylableCardElementContainer;
var $2b991ecb5ab02fee$var$ContainerBase = /** @class */ function(_super) {
    $2b991ecb5ab02fee$var$__extends(ContainerBase, _super);
    function ContainerBase() {
        //#region Schema
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._bleed = false;
        return _this;
    }
    //#endregion
    ContainerBase.prototype.adjustRenderedElementSize = function(renderedElement) {
        _super.prototype.adjustRenderedElementSize.call(this, renderedElement);
        if (this.minPixelHeight) renderedElement.style.minHeight = this.minPixelHeight + "px";
    };
    ContainerBase.prototype.getHasExpandedAction = function() {
        return false;
    };
    ContainerBase.prototype.getBleed = function() {
        return this._bleed;
    };
    ContainerBase.prototype.setBleed = function(value) {
        this._bleed = value;
    };
    Object.defineProperty(ContainerBase.prototype, "renderedActionCount", {
        get: function() {
            return 0;
        },
        enumerable: false,
        configurable: true
    });
    ContainerBase.prototype.isBleeding = function() {
        return (this.getHasBackground() || this.hostConfig.alwaysAllowBleed) && this.getBleed();
    };
    ContainerBase.bleedProperty = new $ldzOp.BoolProperty($ldzOp.Versions.v1_2, "bleed", false);
    ContainerBase.minHeightProperty = new $ldzOp.PixelSizeProperty($ldzOp.Versions.v1_2, "minHeight");
    $2b991ecb5ab02fee$var$__decorate([
        (0, $ldzOp.property)(ContainerBase.bleedProperty)
    ], ContainerBase.prototype, "_bleed", void 0);
    $2b991ecb5ab02fee$var$__decorate([
        (0, $ldzOp.property)(ContainerBase.minHeightProperty)
    ], ContainerBase.prototype, "minPixelHeight", void 0);
    return ContainerBase;
}($2b991ecb5ab02fee$var$StylableCardElementContainer);
module.exports.ContainerBase = $2b991ecb5ab02fee$var$ContainerBase;
var $2b991ecb5ab02fee$var$BackgroundImage = /** @class */ function(_super) {
    $2b991ecb5ab02fee$var$__extends(BackgroundImage, _super);
    function BackgroundImage() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    //#endregion
    BackgroundImage.prototype.getSchemaKey = function() {
        return "BackgroundImage";
    };
    BackgroundImage.prototype.internalParse = function(source, context) {
        if (typeof source === "string") {
            this.resetDefaultValues();
            this.url = source;
        } else return _super.prototype.internalParse.call(this, source, context);
    };
    BackgroundImage.prototype.apply = function(element) {
        if (this.url && element.renderedElement) {
            element.renderedElement.style.backgroundImage = "url('" + element.preProcessPropertyValue(BackgroundImage.urlProperty, this.url) + "')";
            switch(this.fillMode){
                case $iw5eI.FillMode.Repeat:
                    element.renderedElement.style.backgroundRepeat = "repeat";
                    break;
                case $iw5eI.FillMode.RepeatHorizontally:
                    element.renderedElement.style.backgroundRepeat = "repeat-x";
                    break;
                case $iw5eI.FillMode.RepeatVertically:
                    element.renderedElement.style.backgroundRepeat = "repeat-y";
                    break;
                case $iw5eI.FillMode.Cover:
                default:
                    element.renderedElement.style.backgroundRepeat = "no-repeat";
                    element.renderedElement.style.backgroundSize = "cover";
                    break;
            }
            switch(this.horizontalAlignment){
                case $iw5eI.HorizontalAlignment.Left:
                    break;
                case $iw5eI.HorizontalAlignment.Center:
                    element.renderedElement.style.backgroundPositionX = "center";
                    break;
                case $iw5eI.HorizontalAlignment.Right:
                    element.renderedElement.style.backgroundPositionX = "right";
                    break;
            }
            switch(this.verticalAlignment){
                case $iw5eI.VerticalAlignment.Top:
                    break;
                case $iw5eI.VerticalAlignment.Center:
                    element.renderedElement.style.backgroundPositionY = "center";
                    break;
                case $iw5eI.VerticalAlignment.Bottom:
                    element.renderedElement.style.backgroundPositionY = "bottom";
                    break;
            }
        }
    };
    BackgroundImage.prototype.isValid = function() {
        return this.url ? true : false;
    };
    //#region Schema
    BackgroundImage.urlProperty = new $ldzOp.StringProperty($ldzOp.Versions.v1_0, "url");
    BackgroundImage.fillModeProperty = new $ldzOp.EnumProperty($ldzOp.Versions.v1_2, "fillMode", $iw5eI.FillMode, $iw5eI.FillMode.Cover);
    BackgroundImage.horizontalAlignmentProperty = new $ldzOp.EnumProperty($ldzOp.Versions.v1_2, "horizontalAlignment", $iw5eI.HorizontalAlignment, $iw5eI.HorizontalAlignment.Left);
    BackgroundImage.verticalAlignmentProperty = new $ldzOp.EnumProperty($ldzOp.Versions.v1_2, "verticalAlignment", $iw5eI.VerticalAlignment, $iw5eI.VerticalAlignment.Top);
    $2b991ecb5ab02fee$var$__decorate([
        (0, $ldzOp.property)(BackgroundImage.urlProperty)
    ], BackgroundImage.prototype, "url", void 0);
    $2b991ecb5ab02fee$var$__decorate([
        (0, $ldzOp.property)(BackgroundImage.fillModeProperty)
    ], BackgroundImage.prototype, "fillMode", void 0);
    $2b991ecb5ab02fee$var$__decorate([
        (0, $ldzOp.property)(BackgroundImage.horizontalAlignmentProperty)
    ], BackgroundImage.prototype, "horizontalAlignment", void 0);
    $2b991ecb5ab02fee$var$__decorate([
        (0, $ldzOp.property)(BackgroundImage.verticalAlignmentProperty)
    ], BackgroundImage.prototype, "verticalAlignment", void 0);
    return BackgroundImage;
}($ldzOp.SerializableObject);
module.exports.BackgroundImage = $2b991ecb5ab02fee$var$BackgroundImage;
var $2b991ecb5ab02fee$var$Container = /** @class */ function(_super) {
    $2b991ecb5ab02fee$var$__extends(Container, _super);
    function Container() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        //#endregion
        _this._items = [];
        _this._renderedItems = [];
        return _this;
    }
    Object.defineProperty(Container.prototype, "backgroundImage", {
        get: function() {
            return this.getValue(Container.backgroundImageProperty);
        },
        enumerable: false,
        configurable: true
    });
    Container.prototype.insertItemAt = function(item, index, forceInsert) {
        if (!item.parent || forceInsert) {
            if (item.isStandalone) {
                if (index < 0 || index >= this._items.length) this._items.push(item);
                else this._items.splice(index, 0, item);
                item.setParent(this);
            } else throw new Error($brsVB.Strings.errors.elementTypeNotStandalone(item.getJsonTypeName()));
        } else throw new Error($brsVB.Strings.errors.elementAlreadyParented());
    };
    Container.prototype.getItemsCollectionPropertyName = function() {
        return "items";
    };
    Container.prototype.applyBackground = function() {
        if (this.backgroundImage.isValid() && this.renderedElement) this.backgroundImage.apply(this);
        _super.prototype.applyBackground.call(this);
    };
    Container.prototype.applyRTL = function(element) {
        if (this.rtl !== undefined) element.dir = this.rtl ? "rtl" : "ltr";
    };
    Container.prototype.internalRender = function() {
        this._renderedItems = [];
        // Cache hostConfig to avoid walking the parent hierarchy several times
        var hostConfig = this.hostConfig;
        var element = document.createElement("div");
        this.applyRTL(element);
        element.classList.add(hostConfig.makeCssClassName("ac-container"));
        element.style.display = "flex";
        element.style.flexDirection = "column";
        if ($eUh3g.GlobalSettings.useAdvancedCardBottomTruncation) // Forces the container to be at least as tall as its content.
        //
        // Fixes a quirk in Chrome where, for nested flex elements, the
        // inner element's height would never exceed the outer element's
        // height. This caused overflow truncation to break -- containers
        // would always be measured as not overflowing, since their heights
        // were constrained by their parents as opposed to truly reflecting
        // the height of their content.
        //
        // See the "Browser Rendering Notes" section of this answer:
        // https://stackoverflow.com/questions/36247140/why-doesnt-flex-item-shrink-past-content-size
        element.style.minHeight = "-webkit-min-content";
        switch(this.getEffectiveVerticalContentAlignment()){
            case $iw5eI.VerticalAlignment.Center:
                element.style.justifyContent = "center";
                break;
            case $iw5eI.VerticalAlignment.Bottom:
                element.style.justifyContent = "flex-end";
                break;
            default:
                element.style.justifyContent = "flex-start";
                break;
        }
        if (this._items.length > 0) for(var _i = 0, _a = this._items; _i < _a.length; _i++){
            var item = _a[_i];
            var renderedItem = this.isElementAllowed(item) ? item.render() : undefined;
            if (renderedItem) {
                if (this._renderedItems.length > 0 && item.separatorElement) {
                    item.separatorElement.style.flex = "0 0 auto";
                    $ioYal.appendChild(element, item.separatorElement);
                }
                $ioYal.appendChild(element, renderedItem);
                this._renderedItems.push(item);
            }
        }
        else if (this.isDesignMode()) {
            var placeholderElement = this.createPlaceholderElement();
            placeholderElement.style.width = "100%";
            placeholderElement.style.height = "100%";
            element.appendChild(placeholderElement);
        }
        return element;
    };
    Container.prototype.truncateOverflow = function(maxHeight) {
        if (this.renderedElement) {
            // Add 1 to account for rounding differences between browsers
            var boundary_1 = this.renderedElement.offsetTop + maxHeight + 1;
            var handleElement_1 = function(cardElement) {
                var elt = cardElement.renderedElement;
                if (elt) switch($ioYal.getFitStatus(elt, boundary_1)){
                    case $iw5eI.ContainerFitStatus.FullyInContainer:
                        var sizeChanged = cardElement["resetOverflow"]();
                        // If the element's size changed after resetting content,
                        // we have to check if it still fits fully in the card
                        if (sizeChanged) handleElement_1(cardElement);
                        break;
                    case $iw5eI.ContainerFitStatus.Overflowing:
                        var containerMaxHeight = boundary_1 - elt.offsetTop;
                        cardElement["handleOverflow"](containerMaxHeight);
                        break;
                    case $iw5eI.ContainerFitStatus.FullyOutOfContainer:
                        cardElement["handleOverflow"](0);
                        break;
                }
            };
            for(var _i = 0, _a = this._items; _i < _a.length; _i++){
                var item = _a[_i];
                handleElement_1(item);
            }
            return true;
        }
        return false;
    };
    Container.prototype.undoOverflowTruncation = function() {
        for(var _i = 0, _a = this._items; _i < _a.length; _i++){
            var item = _a[_i];
            item["resetOverflow"]();
        }
    };
    Container.prototype.getHasBackground = function(ignoreBackgroundImages) {
        if (ignoreBackgroundImages === void 0) ignoreBackgroundImages = false;
        var result = ignoreBackgroundImages ? false : this.backgroundImage.isValid();
        return result || _super.prototype.getHasBackground.call(this, ignoreBackgroundImages);
    };
    Container.prototype.canHostSingletons = function() {
        return false;
    };
    Container.prototype.internalParse = function(source, context) {
        _super.prototype.internalParse.call(this, source, context);
        this.clear();
        this.setShouldFallback(false);
        var jsonItems = source[this.getItemsCollectionPropertyName()];
        if (!Array.isArray(jsonItems) && typeof jsonItems === "object" && this.canHostSingletons()) {
            var typeName = $ioYal.parseString(jsonItems["type"]);
            if (typeName) {
                var registration = context.elementRegistry.findByName(typeName);
                if ((registration === null || registration === void 0 ? void 0 : registration.singletonBehavior) !== $J4wUi.ElementSingletonBehavior.NotAllowed) {
                    var element = context.parseElement(this, jsonItems, [], !this.isDesignMode(), true);
                    if (element) this.insertItemAt(element, -1, true);
                }
            }
        } else if (Array.isArray(jsonItems)) for(var _i = 0, jsonItems_1 = jsonItems; _i < jsonItems_1.length; _i++){
            var item = jsonItems_1[_i];
            var element = context.parseElement(this, item, this.forbiddenChildElements(), !this.isDesignMode());
            if (element) this.insertItemAt(element, -1, true);
        }
    };
    Container.prototype.internalToJSON = function(target, context) {
        _super.prototype.internalToJSON.call(this, target, context);
        var collectionPropertyName = this.getItemsCollectionPropertyName();
        if (this._items.length === 1 && this._items[0].getElementSingletonBehavior() === $J4wUi.ElementSingletonBehavior.Only) // If the element is only allowed in a singleton context, parse it to an object instead of an array
        context.serializeValue(target, collectionPropertyName, this._items[0].toJSON(context));
        else context.serializeArray(target, collectionPropertyName, this._items);
    };
    Object.defineProperty(Container.prototype, "isSelectable", {
        get: function() {
            return true;
        },
        enumerable: false,
        configurable: true
    });
    Container.prototype.getEffectivePadding = function() {
        if ($eUh3g.GlobalSettings.removePaddingFromContainersWithBackgroundImage && !this.getHasBackground(true)) return new $eUh3g.PaddingDefinition();
        return _super.prototype.getEffectivePadding.call(this);
    };
    Container.prototype.getEffectiveVerticalContentAlignment = function() {
        if (this.verticalContentAlignment !== undefined) return this.verticalContentAlignment;
        var parentContainer = this.getParentContainer();
        return parentContainer ? parentContainer.getEffectiveVerticalContentAlignment() : $iw5eI.VerticalAlignment.Top;
    };
    Container.prototype.getItemCount = function() {
        return this._items.length;
    };
    Container.prototype.getItemAt = function(index) {
        return this._items[index];
    };
    Container.prototype.getFirstVisibleRenderedItem = function() {
        if (this.renderedElement && this._renderedItems && this._renderedItems.length > 0) for(var _i = 0, _a = this._renderedItems; _i < _a.length; _i++){
            var item = _a[_i];
            if (item.isVisible) return item;
        }
        return undefined;
    };
    Container.prototype.getLastVisibleRenderedItem = function() {
        if (this.renderedElement && this._renderedItems && this._renderedItems.length > 0) for(var i = this._renderedItems.length - 1; i >= 0; i--){
            if (this._renderedItems[i].isVisible) return this._renderedItems[i];
        }
        return undefined;
    };
    Container.prototype.getJsonTypeName = function() {
        return "Container";
    };
    Container.prototype.isFirstElement = function(element) {
        var designMode = this.isDesignMode();
        for(var _i = 0, _a = this._items; _i < _a.length; _i++){
            var item = _a[_i];
            if (item.isVisible || designMode) return item === element;
        }
        return false;
    };
    Container.prototype.isLastElement = function(element) {
        var designMode = this.isDesignMode();
        for(var i = this._items.length - 1; i >= 0; i--){
            if (this._items[i].isVisible || designMode) return this._items[i] === element;
        }
        return false;
    };
    Container.prototype.isRtl = function() {
        if (this.rtl !== undefined) return this.rtl;
        else {
            var parentContainer = this.getParentContainer();
            return parentContainer ? parentContainer.isRtl() : false;
        }
    };
    Container.prototype.isBleedingAtTop = function() {
        var firstRenderedItem = this.getFirstVisibleRenderedItem();
        return this.isBleeding() || (firstRenderedItem ? firstRenderedItem.isBleedingAtTop() : false);
    };
    Container.prototype.isBleedingAtBottom = function() {
        var lastRenderedItem = this.getLastVisibleRenderedItem();
        return this.isBleeding() || (lastRenderedItem ? lastRenderedItem.isBleedingAtBottom() && lastRenderedItem.getEffectiveStyle() === this.getEffectiveStyle() : false);
    };
    Container.prototype.indexOf = function(cardElement) {
        return this._items.indexOf(cardElement);
    };
    Container.prototype.addItem = function(item) {
        this.insertItemAt(item, -1, false);
    };
    Container.prototype.insertItemBefore = function(item, insertBefore) {
        this.insertItemAt(item, this._items.indexOf(insertBefore), false);
    };
    Container.prototype.insertItemAfter = function(item, insertAfter) {
        this.insertItemAt(item, this._items.indexOf(insertAfter) + 1, false);
    };
    Container.prototype.removeItem = function(item) {
        var itemIndex = this._items.indexOf(item);
        if (itemIndex >= 0) {
            this._items.splice(itemIndex, 1);
            item.setParent(undefined);
            this.updateLayout();
            return true;
        }
        return false;
    };
    Container.prototype.clear = function() {
        this._items = [];
        this._renderedItems = [];
    };
    Container.prototype.getResourceInformation = function() {
        var result = _super.prototype.getResourceInformation.call(this);
        if (this.backgroundImage.isValid()) result.push({
            // eslint-disable-next-line @typescript-eslint/no-unnecessary-type-assertion -- validated by `isValid()`
            url: this.backgroundImage.url,
            mimeType: "image"
        });
        return result;
    };
    Container.prototype.getActionById = function(id) {
        var result = _super.prototype.getActionById.call(this, id);
        if (!result) {
            if (this.selectAction) result = this.selectAction.getActionById(id);
            if (!result) for(var _i = 0, _a = this._items; _i < _a.length; _i++){
                var item = _a[_i];
                result = item.getActionById(id);
                if (result) break;
            }
        }
        return result;
    };
    Object.defineProperty(Container.prototype, "padding", {
        get: function() {
            return this.getPadding();
        },
        set: function(value) {
            this.setPadding(value);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Container.prototype, "selectAction", {
        get: function() {
            return this._selectAction;
        },
        set: function(value) {
            this._selectAction = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Container.prototype, "bleed", {
        get: function() {
            return this.getBleed();
        },
        set: function(value) {
            this.setBleed(value);
        },
        enumerable: false,
        configurable: true
    });
    //#region Schema
    Container.backgroundImageProperty = new $ldzOp.SerializableObjectProperty($ldzOp.Versions.v1_0, "backgroundImage", $2b991ecb5ab02fee$var$BackgroundImage);
    Container.verticalContentAlignmentProperty = new $ldzOp.EnumProperty($ldzOp.Versions.v1_1, "verticalContentAlignment", $iw5eI.VerticalAlignment);
    Container.rtlProperty = new $ldzOp.BoolProperty($ldzOp.Versions.v1_0, "rtl");
    $2b991ecb5ab02fee$var$__decorate([
        (0, $ldzOp.property)(Container.backgroundImageProperty)
    ], Container.prototype, "backgroundImage", null);
    $2b991ecb5ab02fee$var$__decorate([
        (0, $ldzOp.property)(Container.verticalContentAlignmentProperty)
    ], Container.prototype, "verticalContentAlignment", void 0);
    $2b991ecb5ab02fee$var$__decorate([
        (0, $ldzOp.property)(Container.rtlProperty)
    ], Container.prototype, "rtl", void 0);
    return Container;
}($2b991ecb5ab02fee$var$ContainerBase);
module.exports.Container = $2b991ecb5ab02fee$var$Container;
var $2b991ecb5ab02fee$var$Column = /** @class */ function(_super) {
    $2b991ecb5ab02fee$var$__extends(Column, _super);
    function Column(width) {
        if (width === void 0) width = "stretch";
        var _this = _super.call(this) || this;
        _this.width = "stretch";
        //#endregion
        _this._computedWeight = 0;
        _this.width = width;
        return _this;
    }
    Column.prototype.adjustRenderedElementSize = function(renderedElement) {
        var minDesignTimeColumnHeight = 20;
        if (this.isDesignMode()) {
            renderedElement.style.minWidth = "20px";
            renderedElement.style.minHeight = (!this.minPixelHeight ? minDesignTimeColumnHeight : Math.max(this.minPixelHeight, minDesignTimeColumnHeight)) + "px";
        } else {
            renderedElement.style.minWidth = "0";
            if (this.minPixelHeight) renderedElement.style.minHeight = this.minPixelHeight + "px";
        }
        if (this.width === "auto") renderedElement.style.flex = "0 1 auto";
        else if (this.width === "stretch") renderedElement.style.flex = "1 1 50px";
        else if (this.width instanceof $eUh3g.SizeAndUnit) {
            if (this.width.unit === $iw5eI.SizeUnit.Pixel) {
                renderedElement.style.flex = "0 0 auto";
                renderedElement.style.width = this.width.physicalSize + "px";
            } else renderedElement.style.flex = "1 1 " + (this._computedWeight > 0 ? this._computedWeight : this.width.physicalSize) + "%";
        }
    };
    Column.prototype.shouldSerialize = function(_context) {
        return true;
    };
    Object.defineProperty(Column.prototype, "separatorOrientation", {
        get: function() {
            return $iw5eI.Orientation.Vertical;
        },
        enumerable: false,
        configurable: true
    });
    Column.prototype.getJsonTypeName = function() {
        return "Column";
    };
    Object.defineProperty(Column.prototype, "hasVisibleSeparator", {
        get: function() {
            if (this.parent && this.parent instanceof $2b991ecb5ab02fee$var$ColumnSet) return this.separatorElement !== undefined && !this.parent.isLeftMostElement(this);
            else return false;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Column.prototype, "isStandalone", {
        get: function() {
            return false;
        },
        enumerable: false,
        configurable: true
    });
    //#region Schema
    Column.widthProperty = new $ldzOp.CustomProperty($ldzOp.Versions.v1_0, "width", function(sender, prop, source, context) {
        var result = prop.defaultValue;
        var value = source[prop.name];
        var invalidWidth = false;
        if (typeof value === "number" && !isNaN(value)) result = new $eUh3g.SizeAndUnit(value, $iw5eI.SizeUnit.Weight);
        else if (value === "auto" || value === "stretch") result = value;
        else if (typeof value === "string") try {
            result = $eUh3g.SizeAndUnit.parse(value);
            if (result.unit === $iw5eI.SizeUnit.Pixel && prop.targetVersion.compareTo(context.targetVersion) > 0) invalidWidth = true;
        } catch (e) {
            invalidWidth = true;
        }
        else invalidWidth = true;
        if (invalidWidth) {
            context.logParseEvent(sender, $iw5eI.ValidationEvent.InvalidPropertyValue, $brsVB.Strings.errors.invalidColumnWidth(value));
            result = "auto";
        }
        return result;
    }, function(sender, property, target, value, context) {
        if (value instanceof $eUh3g.SizeAndUnit) {
            if (value.unit === $iw5eI.SizeUnit.Pixel) context.serializeValue(target, "width", value.physicalSize + "px");
            else context.serializeNumber(target, "width", value.physicalSize);
        } else context.serializeValue(target, "width", value);
    }, "stretch");
    $2b991ecb5ab02fee$var$__decorate([
        (0, $ldzOp.property)(Column.widthProperty)
    ], Column.prototype, "width", void 0);
    return Column;
}($2b991ecb5ab02fee$var$Container);
module.exports.Column = $2b991ecb5ab02fee$var$Column;
var $2b991ecb5ab02fee$var$ColumnSet = /** @class */ function(_super) {
    $2b991ecb5ab02fee$var$__extends(ColumnSet, _super);
    function ColumnSet() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._columns = [];
        return _this;
    }
    ColumnSet.prototype.createColumnInstance = function(source, context) {
        return context.parseCardObject(this, source, [], !this.isDesignMode(), function(typeName) {
            return !typeName || typeName === "Column" ? new $2b991ecb5ab02fee$var$Column() : undefined;
        }, function(typeName, _errorType) {
            context.logParseEvent(undefined, $iw5eI.ValidationEvent.ElementTypeNotAllowed, $brsVB.Strings.errors.elementTypeNotAllowed(typeName));
        });
    };
    ColumnSet.prototype.internalRender = function() {
        this._renderedColumns = [];
        if (this._columns.length > 0) {
            // Cache hostConfig to avoid walking the parent hierarchy several times
            var hostConfig = this.hostConfig;
            var element = document.createElement("div");
            element.className = hostConfig.makeCssClassName("ac-columnSet");
            element.style.display = "flex";
            if ($eUh3g.GlobalSettings.useAdvancedCardBottomTruncation) // See comment in Container.internalRender()
            element.style.minHeight = "-webkit-min-content";
            switch(this.getEffectiveHorizontalAlignment()){
                case $iw5eI.HorizontalAlignment.Center:
                    element.style.justifyContent = "center";
                    break;
                case $iw5eI.HorizontalAlignment.Right:
                    element.style.justifyContent = "flex-end";
                    break;
                default:
                    element.style.justifyContent = "flex-start";
                    break;
            }
            var totalWeight = 0;
            for(var _i = 0, _a = this._columns; _i < _a.length; _i++){
                var column = _a[_i];
                if (column.width instanceof $eUh3g.SizeAndUnit && column.width.unit === $iw5eI.SizeUnit.Weight) totalWeight += column.width.physicalSize;
            }
            for(var _b = 0, _c = this._columns; _b < _c.length; _b++){
                var column = _c[_b];
                if (column.width instanceof $eUh3g.SizeAndUnit && column.width.unit === $iw5eI.SizeUnit.Weight && totalWeight > 0) {
                    var computedWeight = 100 / totalWeight * column.width.physicalSize;
                    // Best way to emulate "internal" access I know of
                    column["_computedWeight"] = computedWeight;
                }
                var renderedColumn = column.render();
                if (renderedColumn) {
                    if (this._renderedColumns.length > 0 && column.separatorElement) {
                        column.separatorElement.style.flex = "0 0 auto";
                        $ioYal.appendChild(element, column.separatorElement);
                    }
                    $ioYal.appendChild(element, renderedColumn);
                    this._renderedColumns.push(column);
                }
            }
            return this._renderedColumns.length > 0 ? element : undefined;
        } else return undefined;
    };
    ColumnSet.prototype.truncateOverflow = function(maxHeight) {
        for(var _i = 0, _a = this._columns; _i < _a.length; _i++){
            var column = _a[_i];
            column["handleOverflow"](maxHeight);
        }
        return true;
    };
    ColumnSet.prototype.undoOverflowTruncation = function() {
        for(var _i = 0, _a = this._columns; _i < _a.length; _i++){
            var column = _a[_i];
            column["resetOverflow"]();
        }
    };
    Object.defineProperty(ColumnSet.prototype, "isSelectable", {
        get: function() {
            return true;
        },
        enumerable: false,
        configurable: true
    });
    ColumnSet.prototype.internalParse = function(source, context) {
        _super.prototype.internalParse.call(this, source, context);
        this._columns = [];
        this._renderedColumns = [];
        var jsonColumns = source["columns"];
        if (Array.isArray(jsonColumns)) for(var _i = 0, jsonColumns_1 = jsonColumns; _i < jsonColumns_1.length; _i++){
            var item = jsonColumns_1[_i];
            var column = this.createColumnInstance(item, context);
            if (column) this._columns.push(column);
        }
    };
    ColumnSet.prototype.internalToJSON = function(target, context) {
        _super.prototype.internalToJSON.call(this, target, context);
        context.serializeArray(target, "columns", this._columns);
    };
    ColumnSet.prototype.isFirstElement = function(element) {
        for(var _i = 0, _a = this._columns; _i < _a.length; _i++){
            var column = _a[_i];
            if (column.isVisible) return column === element;
        }
        return false;
    };
    ColumnSet.prototype.isBleedingAtTop = function() {
        if (this.isBleeding()) return true;
        if (this._renderedColumns && this._renderedColumns.length > 0) for(var _i = 0, _a = this._columns; _i < _a.length; _i++){
            var column = _a[_i];
            if (column.isBleedingAtTop()) return true;
        }
        return false;
    };
    ColumnSet.prototype.isBleedingAtBottom = function() {
        if (this.isBleeding()) return true;
        if (this._renderedColumns && this._renderedColumns.length > 0) for(var _i = 0, _a = this._columns; _i < _a.length; _i++){
            var column = _a[_i];
            if (column.isBleedingAtBottom()) return true;
        }
        return false;
    };
    ColumnSet.prototype.getItemCount = function() {
        return this._columns.length;
    };
    ColumnSet.prototype.getFirstVisibleRenderedItem = function() {
        if (this.renderedElement && this._renderedColumns && this._renderedColumns.length > 0) return this._renderedColumns[0];
        else return undefined;
    };
    ColumnSet.prototype.getLastVisibleRenderedItem = function() {
        if (this.renderedElement && this._renderedColumns && this._renderedColumns.length > 0) return this._renderedColumns[this._renderedColumns.length - 1];
        else return undefined;
    };
    ColumnSet.prototype.getColumnAt = function(index) {
        return this._columns[index];
    };
    ColumnSet.prototype.getItemAt = function(index) {
        return this.getColumnAt(index);
    };
    ColumnSet.prototype.getJsonTypeName = function() {
        return "ColumnSet";
    };
    ColumnSet.prototype.internalValidateProperties = function(context) {
        _super.prototype.internalValidateProperties.call(this, context);
        var weightedColumns = 0;
        var stretchedColumns = 0;
        for(var _i = 0, _a = this._columns; _i < _a.length; _i++){
            var column = _a[_i];
            if (typeof column.width === "number") weightedColumns++;
            else if (column.width === "stretch") stretchedColumns++;
        }
        if (weightedColumns > 0 && stretchedColumns > 0) context.addFailure(this, $iw5eI.ValidationEvent.Hint, $brsVB.Strings.hints.dontUseWeightedAndStrecthedColumnsInSameSet());
    };
    ColumnSet.prototype.addColumn = function(column) {
        if (!column.parent) {
            this._columns.push(column);
            column.setParent(this);
        } else throw new Error($brsVB.Strings.errors.columnAlreadyBelongsToAnotherSet());
    };
    ColumnSet.prototype.removeItem = function(item) {
        if (item instanceof $2b991ecb5ab02fee$var$Column) {
            var itemIndex = this._columns.indexOf(item);
            if (itemIndex >= 0) {
                this._columns.splice(itemIndex, 1);
                item.setParent(undefined);
                this.updateLayout();
                return true;
            }
        }
        return false;
    };
    ColumnSet.prototype.indexOf = function(cardElement) {
        return cardElement instanceof $2b991ecb5ab02fee$var$Column ? this._columns.indexOf(cardElement) : -1;
    };
    ColumnSet.prototype.isLeftMostElement = function(element) {
        return this._columns.indexOf(element) === 0;
    };
    ColumnSet.prototype.isRightMostElement = function(element) {
        return this._columns.indexOf(element) === this._columns.length - 1;
    };
    ColumnSet.prototype.isTopElement = function(element) {
        return this._columns.indexOf(element) >= 0;
    };
    ColumnSet.prototype.isBottomElement = function(element) {
        return this._columns.indexOf(element) >= 0;
    };
    ColumnSet.prototype.getActionById = function(id) {
        var result = undefined;
        for(var _i = 0, _a = this._columns; _i < _a.length; _i++){
            var column = _a[_i];
            result = column.getActionById(id);
            if (result) break;
        }
        return result;
    };
    Object.defineProperty(ColumnSet.prototype, "bleed", {
        get: function() {
            return this.getBleed();
        },
        set: function(value) {
            this.setBleed(value);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ColumnSet.prototype, "padding", {
        get: function() {
            return this.getPadding();
        },
        set: function(value) {
            this.setPadding(value);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ColumnSet.prototype, "selectAction", {
        get: function() {
            return this._selectAction;
        },
        set: function(value) {
            this._selectAction = value;
        },
        enumerable: false,
        configurable: true
    });
    return ColumnSet;
}($2b991ecb5ab02fee$var$ContainerBase);
module.exports.ColumnSet = $2b991ecb5ab02fee$var$ColumnSet;
function $2b991ecb5ab02fee$var$raiseImageLoadedEvent(image) {
    var card = image.getRootElement();
    var onImageLoadedHandler = card && card.onImageLoaded ? card.onImageLoaded : $2b991ecb5ab02fee$var$AdaptiveCard.onImageLoaded;
    if (onImageLoadedHandler) onImageLoadedHandler(image);
}
function $2b991ecb5ab02fee$var$raiseAnchorClickedEvent(element, anchor, ev) {
    var card = element.getRootElement();
    var onAnchorClickedHandler = card && card.onAnchorClicked ? card.onAnchorClicked : $2b991ecb5ab02fee$var$AdaptiveCard.onAnchorClicked;
    return onAnchorClickedHandler !== undefined ? onAnchorClickedHandler(element, anchor, ev) : false;
}
function $2b991ecb5ab02fee$var$raiseExecuteActionEvent(action) {
    var card = action.parent ? action.parent.getRootElement() : undefined;
    var onExecuteActionHandler = card && card.onExecuteAction ? card.onExecuteAction : $2b991ecb5ab02fee$var$AdaptiveCard.onExecuteAction;
    if (action.prepareForExecution() && onExecuteActionHandler) onExecuteActionHandler(action);
}
function $2b991ecb5ab02fee$var$raiseInlineCardExpandedEvent(action, isExpanded) {
    var card = action.parent ? action.parent.getRootElement() : undefined;
    var onInlineCardExpandedHandler = card && card.onInlineCardExpanded ? card.onInlineCardExpanded : $2b991ecb5ab02fee$var$AdaptiveCard.onInlineCardExpanded;
    if (onInlineCardExpandedHandler) onInlineCardExpandedHandler(action, isExpanded);
}
function $2b991ecb5ab02fee$var$raiseInputValueChangedEvent(input) {
    var card = input.getRootElement();
    var onInputValueChangedHandler = card && card.onInputValueChanged ? card.onInputValueChanged : $2b991ecb5ab02fee$var$AdaptiveCard.onInputValueChanged;
    if (onInputValueChangedHandler) onInputValueChangedHandler(input);
}
function $2b991ecb5ab02fee$var$raiseElementVisibilityChangedEvent(element, shouldUpdateLayout) {
    if (shouldUpdateLayout === void 0) shouldUpdateLayout = true;
    var rootElement = element.getRootElement();
    if (shouldUpdateLayout) rootElement.updateLayout();
    var card = rootElement;
    var onElementVisibilityChangedHandler = card && card.onElementVisibilityChanged ? card.onElementVisibilityChanged : $2b991ecb5ab02fee$var$AdaptiveCard.onElementVisibilityChanged;
    if (onElementVisibilityChangedHandler !== undefined) onElementVisibilityChangedHandler(element);
}
/**
 * @returns return false to continue with default context menu; return true to skip SDK default context menu
 */ function $2b991ecb5ab02fee$var$raiseDisplayOverflowActionMenuEvent(action, target) {
    var card = action.parent ? action.parent.getRootElement() : undefined;
    var onDisplayOverflowActionMenuHandler = card && card.onDisplayOverflowActionMenu ? card.onDisplayOverflowActionMenu : $2b991ecb5ab02fee$var$AdaptiveCard.onDisplayOverflowActionMenu;
    return onDisplayOverflowActionMenuHandler !== undefined ? onDisplayOverflowActionMenuHandler(action.getActions(), target) : false;
}
/**
 * @returns return false to continue with default action button; return true to skip SDK default action button
 */ function $2b991ecb5ab02fee$var$raiseRenderOverflowActionsEvent(action, isAtRootLevelActions) {
    var card = action.parent ? action.parent.getRootElement() : undefined;
    var onRenderOverflowActionsHandler = card && card.onRenderOverflowActions ? card.onRenderOverflowActions : $2b991ecb5ab02fee$var$AdaptiveCard.onRenderOverflowActions;
    return onRenderOverflowActionsHandler !== undefined ? onRenderOverflowActionsHandler(action.getActions(), isAtRootLevelActions) : false;
}
var $2b991ecb5ab02fee$var$ContainerWithActions = /** @class */ function(_super) {
    $2b991ecb5ab02fee$var$__extends(ContainerWithActions, _super);
    function ContainerWithActions() {
        var _this = _super.call(this) || this;
        _this._actionCollection = new $2b991ecb5ab02fee$var$ActionCollection(_this);
        return _this;
    }
    ContainerWithActions.prototype.internalParse = function(source, context) {
        _super.prototype.internalParse.call(this, source, context);
        this.parseActions(source, context);
    };
    ContainerWithActions.prototype.parseActions = function(source, context) {
        this._actionCollection.parse(source["actions"], context);
    };
    ContainerWithActions.prototype.internalToJSON = function(target, context) {
        _super.prototype.internalToJSON.call(this, target, context);
        this._actionCollection.toJSON(target, "actions", context);
    };
    ContainerWithActions.prototype.internalRender = function() {
        var element = _super.prototype.internalRender.call(this);
        if (element) {
            var renderedActions = this._actionCollection.render(this.hostConfig.actions.actionsOrientation);
            if (renderedActions) {
                $ioYal.appendChild(element, $2b991ecb5ab02fee$var$renderSeparation(this.hostConfig, {
                    spacing: this.hostConfig.getEffectiveSpacing(this.hostConfig.actions.spacing)
                }, $iw5eI.Orientation.Horizontal));
                $ioYal.appendChild(element, renderedActions);
            }
            if (this.renderIfEmpty) return element;
            else return element.children.length > 0 ? element : undefined;
        } else return undefined;
    };
    ContainerWithActions.prototype.getHasExpandedAction = function() {
        if (this.renderedActionCount === 0) return false;
        else if (this.renderedActionCount === 1) return this._actionCollection.expandedAction !== undefined && !this.hostConfig.actions.preExpandSingleShowCardAction;
        else return this._actionCollection.expandedAction !== undefined;
    };
    Object.defineProperty(ContainerWithActions.prototype, "renderedActionCount", {
        get: function() {
            return this._actionCollection.renderedActionCount;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ContainerWithActions.prototype, "renderIfEmpty", {
        get: function() {
            return false;
        },
        enumerable: false,
        configurable: true
    });
    ContainerWithActions.prototype.releaseDOMResources = function() {
        _super.prototype.releaseDOMResources.call(this);
        this._actionCollection.releaseDOMResources();
    };
    ContainerWithActions.prototype.getActionCount = function() {
        return this._actionCollection.getActionCount();
    };
    ContainerWithActions.prototype.getActionAt = function(index) {
        if (index >= 0 && index < this.getActionCount()) return this._actionCollection.getActionAt(index);
        else return _super.prototype.getActionAt.call(this, index);
    };
    ContainerWithActions.prototype.getActionById = function(id) {
        var result = this._actionCollection.getActionById(id);
        return result ? result : _super.prototype.getActionById.call(this, id);
    };
    ContainerWithActions.prototype.internalValidateProperties = function(context) {
        _super.prototype.internalValidateProperties.call(this, context);
        if (this._actionCollection) this._actionCollection.validateProperties(context);
    };
    ContainerWithActions.prototype.isLastElement = function(element) {
        return _super.prototype.isLastElement.call(this, element) && this._actionCollection.getActionCount() === 0;
    };
    ContainerWithActions.prototype.addAction = function(action) {
        this._actionCollection.addAction(action);
    };
    ContainerWithActions.prototype.clear = function() {
        _super.prototype.clear.call(this);
        this._actionCollection.clear();
    };
    ContainerWithActions.prototype.getAllInputs = function(processActions) {
        if (processActions === void 0) processActions = true;
        var result = _super.prototype.getAllInputs.call(this, processActions);
        if (processActions) result.push.apply(result, this._actionCollection.getAllInputs(processActions));
        return result;
    };
    ContainerWithActions.prototype.getResourceInformation = function() {
        var result = _super.prototype.getResourceInformation.call(this);
        result.push.apply(result, this._actionCollection.getResourceInformation());
        return result;
    };
    ContainerWithActions.prototype.isBleedingAtBottom = function() {
        if (this._actionCollection.renderedActionCount === 0) return _super.prototype.isBleedingAtBottom.call(this);
        else {
            if (this._actionCollection.getActionCount() === 1) return this._actionCollection.expandedAction !== undefined && !this.hostConfig.actions.preExpandSingleShowCardAction;
            else return this._actionCollection.expandedAction !== undefined;
        }
    };
    ContainerWithActions.prototype.getForbiddenActionNames = function() {
        return [];
    };
    Object.defineProperty(ContainerWithActions.prototype, "isStandalone", {
        get: function() {
            return false;
        },
        enumerable: false,
        configurable: true
    });
    return ContainerWithActions;
}($2b991ecb5ab02fee$var$Container);
module.exports.ContainerWithActions = $2b991ecb5ab02fee$var$ContainerWithActions;
var $2b991ecb5ab02fee$var$RefreshActionProperty = /** @class */ function(_super) {
    $2b991ecb5ab02fee$var$__extends(RefreshActionProperty, _super);
    function RefreshActionProperty(targetVersion, name) {
        var _this = _super.call(this, targetVersion, name, undefined) || this;
        _this.targetVersion = targetVersion;
        _this.name = name;
        return _this;
    }
    RefreshActionProperty.prototype.parse = function(sender, source, context) {
        var action = context.parseAction(sender.parent, source[this.name], [], false);
        if (action !== undefined) {
            if (action instanceof $2b991ecb5ab02fee$var$ExecuteAction) return action;
            context.logParseEvent(sender, $iw5eI.ValidationEvent.ActionTypeNotAllowed, $brsVB.Strings.errors.actionTypeNotAllowed(action.getJsonTypeName()));
        }
        context.logParseEvent(sender, $iw5eI.ValidationEvent.PropertyCantBeNull, $brsVB.Strings.errors.propertyMustBeSet("action"));
        return undefined;
    };
    RefreshActionProperty.prototype.toJSON = function(sender, target, value, context) {
        context.serializeValue(target, this.name, value ? value.toJSON(context) : undefined, undefined, true);
    };
    return RefreshActionProperty;
}($ldzOp.PropertyDefinition);
module.exports.RefreshActionProperty = $2b991ecb5ab02fee$var$RefreshActionProperty;
var $2b991ecb5ab02fee$var$RefreshDefinition = /** @class */ function(_super) {
    $2b991ecb5ab02fee$var$__extends(RefreshDefinition, _super);
    function RefreshDefinition() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(RefreshDefinition.prototype, "action", {
        get: function() {
            return this.getValue(RefreshDefinition.actionProperty);
        },
        set: function(value) {
            this.setValue(RefreshDefinition.actionProperty, value);
            if (value) value.setParent(this.parent);
        },
        enumerable: false,
        configurable: true
    });
    RefreshDefinition.prototype.getSchemaKey = function() {
        return "RefreshDefinition";
    };
    //#region Schema
    RefreshDefinition.actionProperty = new $2b991ecb5ab02fee$var$RefreshActionProperty($ldzOp.Versions.v1_4, "action");
    RefreshDefinition.userIdsProperty = new $ldzOp.StringArrayProperty($ldzOp.Versions.v1_4, "userIds");
    $2b991ecb5ab02fee$var$__decorate([
        (0, $ldzOp.property)(RefreshDefinition.actionProperty)
    ], RefreshDefinition.prototype, "action", null);
    $2b991ecb5ab02fee$var$__decorate([
        (0, $ldzOp.property)(RefreshDefinition.userIdsProperty)
    ], RefreshDefinition.prototype, "userIds", void 0);
    return RefreshDefinition;
}($ldzOp.SerializableObject);
module.exports.RefreshDefinition = $2b991ecb5ab02fee$var$RefreshDefinition;
var $2b991ecb5ab02fee$var$AuthCardButton = /** @class */ function(_super) {
    $2b991ecb5ab02fee$var$__extends(AuthCardButton, _super);
    function AuthCardButton() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AuthCardButton.prototype.getSchemaKey = function() {
        return "AuthCardButton";
    };
    //#region Schema
    AuthCardButton.typeProperty = new $ldzOp.StringProperty($ldzOp.Versions.v1_4, "type");
    AuthCardButton.titleProperty = new $ldzOp.StringProperty($ldzOp.Versions.v1_4, "title");
    AuthCardButton.imageProperty = new $ldzOp.StringProperty($ldzOp.Versions.v1_4, "image");
    AuthCardButton.valueProperty = new $ldzOp.StringProperty($ldzOp.Versions.v1_4, "value");
    $2b991ecb5ab02fee$var$__decorate([
        (0, $ldzOp.property)(AuthCardButton.typeProperty)
    ], AuthCardButton.prototype, "type", void 0);
    $2b991ecb5ab02fee$var$__decorate([
        (0, $ldzOp.property)(AuthCardButton.titleProperty)
    ], AuthCardButton.prototype, "title", void 0);
    $2b991ecb5ab02fee$var$__decorate([
        (0, $ldzOp.property)(AuthCardButton.imageProperty)
    ], AuthCardButton.prototype, "image", void 0);
    $2b991ecb5ab02fee$var$__decorate([
        (0, $ldzOp.property)(AuthCardButton.valueProperty)
    ], AuthCardButton.prototype, "value", void 0);
    return AuthCardButton;
}($ldzOp.SerializableObject);
module.exports.AuthCardButton = $2b991ecb5ab02fee$var$AuthCardButton;
var $2b991ecb5ab02fee$var$TokenExchangeResource = /** @class */ function(_super) {
    $2b991ecb5ab02fee$var$__extends(TokenExchangeResource, _super);
    function TokenExchangeResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TokenExchangeResource.prototype.getSchemaKey = function() {
        return "TokenExchangeResource";
    };
    //#region Schema
    TokenExchangeResource.idProperty = new $ldzOp.StringProperty($ldzOp.Versions.v1_4, "id");
    TokenExchangeResource.uriProperty = new $ldzOp.StringProperty($ldzOp.Versions.v1_4, "uri");
    TokenExchangeResource.providerIdProperty = new $ldzOp.StringProperty($ldzOp.Versions.v1_4, "providerId");
    $2b991ecb5ab02fee$var$__decorate([
        (0, $ldzOp.property)(TokenExchangeResource.idProperty)
    ], TokenExchangeResource.prototype, "id", void 0);
    $2b991ecb5ab02fee$var$__decorate([
        (0, $ldzOp.property)(TokenExchangeResource.uriProperty)
    ], TokenExchangeResource.prototype, "uri", void 0);
    $2b991ecb5ab02fee$var$__decorate([
        (0, $ldzOp.property)(TokenExchangeResource.providerIdProperty)
    ], TokenExchangeResource.prototype, "providerId", void 0);
    return TokenExchangeResource;
}($ldzOp.SerializableObject);
module.exports.TokenExchangeResource = $2b991ecb5ab02fee$var$TokenExchangeResource;
var $2b991ecb5ab02fee$var$Authentication = /** @class */ function(_super) {
    $2b991ecb5ab02fee$var$__extends(Authentication, _super);
    function Authentication() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Authentication.prototype.getSchemaKey = function() {
        return "Authentication";
    };
    //#region Schema
    Authentication.textProperty = new $ldzOp.StringProperty($ldzOp.Versions.v1_4, "text");
    Authentication.connectionNameProperty = new $ldzOp.StringProperty($ldzOp.Versions.v1_4, "connectionName");
    Authentication.buttonsProperty = new $ldzOp.SerializableObjectCollectionProperty($ldzOp.Versions.v1_4, "buttons", $2b991ecb5ab02fee$var$AuthCardButton);
    Authentication.tokenExchangeResourceProperty = new $ldzOp.SerializableObjectProperty($ldzOp.Versions.v1_4, "tokenExchangeResource", $2b991ecb5ab02fee$var$TokenExchangeResource, true);
    $2b991ecb5ab02fee$var$__decorate([
        (0, $ldzOp.property)(Authentication.textProperty)
    ], Authentication.prototype, "text", void 0);
    $2b991ecb5ab02fee$var$__decorate([
        (0, $ldzOp.property)(Authentication.connectionNameProperty)
    ], Authentication.prototype, "connectionName", void 0);
    $2b991ecb5ab02fee$var$__decorate([
        (0, $ldzOp.property)(Authentication.buttonsProperty)
    ], Authentication.prototype, "buttons", void 0);
    $2b991ecb5ab02fee$var$__decorate([
        (0, $ldzOp.property)(Authentication.tokenExchangeResourceProperty)
    ], Authentication.prototype, "tokenExchangeResource", void 0);
    return Authentication;
}($ldzOp.SerializableObject);
module.exports.Authentication = $2b991ecb5ab02fee$var$Authentication;
// @dynamic
var $2b991ecb5ab02fee$var$AdaptiveCard = /** @class */ function(_super) {
    $2b991ecb5ab02fee$var$__extends(AdaptiveCard, _super);
    function AdaptiveCard() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.designMode = false;
        return _this;
    }
    Object.defineProperty(AdaptiveCard.prototype, "refresh", {
        get: function() {
            return this.getValue(AdaptiveCard.refreshProperty);
        },
        set: function(value) {
            this.setValue(AdaptiveCard.refreshProperty, value);
            if (value) value.parent = this;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AdaptiveCard, "processMarkdown", {
        get: function() {
            throw new Error($brsVB.Strings.errors.processMarkdownEventRemoved());
        },
        // eslint-disable-next-line @typescript-eslint/naming-convention
        set: function(_value) {
            throw new Error($brsVB.Strings.errors.processMarkdownEventRemoved());
        },
        enumerable: false,
        configurable: true
    });
    AdaptiveCard.applyMarkdown = function(text) {
        var result = {
            didProcess: false
        };
        if (AdaptiveCard.onProcessMarkdown) AdaptiveCard.onProcessMarkdown(text, result);
        else if (window.markdownit) {
            // Check for markdownit
            var markdownIt = window.markdownit;
            result.outputHtml = markdownIt().render(text);
            result.didProcess = true;
        } else if (!AdaptiveCard._haveWarnedAboutNoMarkdownProcessing) {
            // eslint-disable-next-line no-console
            console.warn($brsVB.Strings.errors.markdownProcessingNotEnabled);
            AdaptiveCard._haveWarnedAboutNoMarkdownProcessing = true;
        }
        return result;
    };
    AdaptiveCard.prototype.isVersionSupported = function() {
        if (this.bypassVersionCheck) return true;
        else {
            var unsupportedVersion = !this.version || !this.version.isValid || this.maxVersion.major < this.version.major || this.maxVersion.major === this.version.major && this.maxVersion.minor < this.version.minor;
            return !unsupportedVersion;
        }
    };
    AdaptiveCard.prototype.getDefaultSerializationContext = function() {
        return new $2b991ecb5ab02fee$var$SerializationContext(this.version);
    };
    AdaptiveCard.prototype.getItemsCollectionPropertyName = function() {
        return "body";
    };
    AdaptiveCard.prototype.canHostSingletons = function() {
        return true;
    };
    AdaptiveCard.prototype.internalParse = function(source, context) {
        this._fallbackCard = undefined;
        var fallbackElement = context.parseElement(undefined, source["fallback"], this.forbiddenChildElements(), !this.isDesignMode());
        if (fallbackElement) {
            this._fallbackCard = new AdaptiveCard();
            this._fallbackCard.addItem(fallbackElement);
        }
        _super.prototype.internalParse.call(this, source, context);
    };
    AdaptiveCard.prototype.internalToJSON = function(target, context) {
        this.setValue(AdaptiveCard.versionProperty, context.targetVersion);
        _super.prototype.internalToJSON.call(this, target, context);
    };
    AdaptiveCard.prototype.internalRender = function() {
        var renderedElement = _super.prototype.internalRender.call(this);
        if ($eUh3g.GlobalSettings.useAdvancedCardBottomTruncation && renderedElement) // Unlike containers, the root card element should be allowed to
        // be shorter than its content (otherwise the overflow truncation
        // logic would never get triggered)
        renderedElement.style.removeProperty("minHeight");
        return renderedElement;
    };
    AdaptiveCard.prototype.getHasBackground = function(ignoreBackgroundImages) {
        if (ignoreBackgroundImages === void 0) ignoreBackgroundImages = false;
        return true;
    };
    AdaptiveCard.prototype.getDefaultPadding = function() {
        return new $eUh3g.PaddingDefinition($iw5eI.Spacing.Padding, $iw5eI.Spacing.Padding, $iw5eI.Spacing.Padding, $iw5eI.Spacing.Padding);
    };
    AdaptiveCard.prototype.shouldSerialize = function(_context) {
        return true;
    };
    Object.defineProperty(AdaptiveCard.prototype, "renderIfEmpty", {
        get: function() {
            return true;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AdaptiveCard.prototype, "bypassVersionCheck", {
        get: function() {
            return false;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AdaptiveCard.prototype, "allowCustomStyle", {
        get: function() {
            return this.hostConfig.adaptiveCard && this.hostConfig.adaptiveCard.allowCustomStyle;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AdaptiveCard.prototype, "hasBackground", {
        get: function() {
            return true;
        },
        enumerable: false,
        configurable: true
    });
    AdaptiveCard.prototype.getJsonTypeName = function() {
        return "AdaptiveCard";
    };
    AdaptiveCard.prototype.internalValidateProperties = function(context) {
        _super.prototype.internalValidateProperties.call(this, context);
        if (this.getValue($2b991ecb5ab02fee$var$CardElement.typeNameProperty) !== "AdaptiveCard") context.addFailure(this, $iw5eI.ValidationEvent.MissingCardType, $brsVB.Strings.errors.invalidCardType());
        if (!this.bypassVersionCheck && !this.version) context.addFailure(this, $iw5eI.ValidationEvent.PropertyCantBeNull, $brsVB.Strings.errors.propertyMustBeSet("version"));
        else if (!this.isVersionSupported()) context.addFailure(this, $iw5eI.ValidationEvent.UnsupportedCardVersion, $brsVB.Strings.errors.unsupportedCardVersion(this.version.toString(), this.maxVersion.toString()));
    };
    AdaptiveCard.prototype.render = function(target) {
        var renderedCard;
        if (this.shouldFallback() && this._fallbackCard) {
            this._fallbackCard.hostConfig = this.hostConfig;
            renderedCard = this._fallbackCard.render();
        } else {
            renderedCard = _super.prototype.render.call(this);
            if (renderedCard) {
                renderedCard.classList.add(this.hostConfig.makeCssClassName("ac-adaptiveCard"));
                // Having a tabIndex on the root container for a card can mess up accessibility in some scenarios.
                // However, we've shipped this behavior before, and so can't just turn it off in a point release. For
                // now, to unblock accessibility scenarios for our customers, we've got an option to turn it off. In a
                // future release, we should strongly consider flipping the default such that we *don't* emit a tabIndex
                // by default.
                if ($eUh3g.GlobalSettings.setTabIndexAtCardRoot) renderedCard.tabIndex = 0;
                if (this.speak) renderedCard.setAttribute("aria-label", this.speak);
            }
        }
        if (target) {
            $ioYal.appendChild(target, renderedCard);
            this.updateLayout();
        }
        return renderedCard;
    };
    AdaptiveCard.prototype.updateLayout = function(processChildren) {
        if (processChildren === void 0) processChildren = true;
        _super.prototype.updateLayout.call(this, processChildren);
        if ($eUh3g.GlobalSettings.useAdvancedCardBottomTruncation && this.isDisplayed()) {
            var padding = this.hostConfig.getEffectiveSpacing($iw5eI.Spacing.Default);
            // eslint-disable-next-line @typescript-eslint/no-unnecessary-type-assertion
            this["handleOverflow"](this.renderedElement.offsetHeight - padding);
        }
    };
    AdaptiveCard.prototype.shouldFallback = function() {
        return _super.prototype.shouldFallback.call(this) || !this.isVersionSupported();
    };
    Object.defineProperty(AdaptiveCard.prototype, "hasVisibleSeparator", {
        get: function() {
            return false;
        },
        enumerable: false,
        configurable: true
    });
    AdaptiveCard.schemaUrl = "http://adaptivecards.io/schemas/adaptive-card.json";
    //#region Schema
    // eslint-disable-next-line @typescript-eslint/naming-convention
    AdaptiveCard.$schemaProperty = new $ldzOp.CustomProperty($ldzOp.Versions.v1_0, "$schema", function(sender, property, source, context) {
        return AdaptiveCard.schemaUrl;
    }, function(sender, prop, target, value, context) {
        context.serializeValue(target, prop.name, AdaptiveCard.schemaUrl);
    });
    AdaptiveCard.versionProperty = new $ldzOp.CustomProperty($ldzOp.Versions.v1_0, "version", function(sender, prop, source, context) {
        var version = $ldzOp.Version.parse(source[prop.name], context);
        if (version === undefined) {
            version = $ldzOp.Versions.latest;
            context.logParseEvent(sender, $iw5eI.ValidationEvent.InvalidPropertyValue, $brsVB.Strings.errors.invalidCardVersion(version.toString()));
        }
        return version;
    }, function(sender, prop, target, value, context) {
        if (value !== undefined) context.serializeValue(target, prop.name, value.toString());
    }, $ldzOp.Versions.v1_0);
    AdaptiveCard.fallbackTextProperty = new $ldzOp.StringProperty($ldzOp.Versions.v1_0, "fallbackText");
    AdaptiveCard.speakProperty = new $ldzOp.StringProperty($ldzOp.Versions.v1_0, "speak");
    AdaptiveCard.refreshProperty = new $ldzOp.SerializableObjectProperty($ldzOp.Versions.v1_4, "refresh", $2b991ecb5ab02fee$var$RefreshDefinition, true);
    AdaptiveCard.authenticationProperty = new $ldzOp.SerializableObjectProperty($ldzOp.Versions.v1_4, "authentication", $2b991ecb5ab02fee$var$Authentication, true);
    //#endregion
    AdaptiveCard._haveWarnedAboutNoMarkdownProcessing = false;
    $2b991ecb5ab02fee$var$__decorate([
        (0, $ldzOp.property)(AdaptiveCard.versionProperty)
    ], AdaptiveCard.prototype, "version", void 0);
    $2b991ecb5ab02fee$var$__decorate([
        (0, $ldzOp.property)(AdaptiveCard.fallbackTextProperty)
    ], AdaptiveCard.prototype, "fallbackText", void 0);
    $2b991ecb5ab02fee$var$__decorate([
        (0, $ldzOp.property)(AdaptiveCard.speakProperty)
    ], AdaptiveCard.prototype, "speak", void 0);
    $2b991ecb5ab02fee$var$__decorate([
        (0, $ldzOp.property)(AdaptiveCard.refreshProperty)
    ], AdaptiveCard.prototype, "refresh", null);
    $2b991ecb5ab02fee$var$__decorate([
        (0, $ldzOp.property)(AdaptiveCard.authenticationProperty)
    ], AdaptiveCard.prototype, "authentication", void 0);
    return AdaptiveCard;
}($2b991ecb5ab02fee$var$ContainerWithActions);
module.exports.AdaptiveCard = $2b991ecb5ab02fee$var$AdaptiveCard;
var $2b991ecb5ab02fee$var$InlineAdaptiveCard = /** @class */ function(_super) {
    $2b991ecb5ab02fee$var$__extends(InlineAdaptiveCard, _super);
    function InlineAdaptiveCard() {
        //#region Schema
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.suppressStyle = false;
        return _this;
    }
    InlineAdaptiveCard.prototype.getSchemaKey = function() {
        return "InlineAdaptiveCard";
    };
    InlineAdaptiveCard.prototype.populateSchema = function(schema) {
        _super.prototype.populateSchema.call(this, schema);
        schema.remove($2b991ecb5ab02fee$var$AdaptiveCard.$schemaProperty, $2b991ecb5ab02fee$var$AdaptiveCard.versionProperty);
    };
    //#endregion
    InlineAdaptiveCard.prototype.getDefaultPadding = function() {
        return new $eUh3g.PaddingDefinition(this.suppressStyle ? $iw5eI.Spacing.None : $iw5eI.Spacing.Padding, $iw5eI.Spacing.Padding, this.suppressStyle ? $iw5eI.Spacing.None : $iw5eI.Spacing.Padding, $iw5eI.Spacing.Padding);
    };
    Object.defineProperty(InlineAdaptiveCard.prototype, "bypassVersionCheck", {
        get: function() {
            return true;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InlineAdaptiveCard.prototype, "defaultStyle", {
        get: function() {
            if (this.suppressStyle) return $iw5eI.ContainerStyle.Default;
            else return this.hostConfig.actions.showCard.style ? this.hostConfig.actions.showCard.style : $iw5eI.ContainerStyle.Emphasis;
        },
        enumerable: false,
        configurable: true
    });
    InlineAdaptiveCard.prototype.render = function(target) {
        var renderedCard = _super.prototype.render.call(this, target);
        if (renderedCard) {
            renderedCard.setAttribute("aria-live", "polite");
            renderedCard.removeAttribute("tabindex");
        }
        return renderedCard;
    };
    return InlineAdaptiveCard;
}($2b991ecb5ab02fee$var$AdaptiveCard);
var $2b991ecb5ab02fee$var$SerializationContext = /** @class */ function(_super) {
    $2b991ecb5ab02fee$var$__extends(SerializationContext, _super);
    function SerializationContext() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._forbiddenTypes = new Set();
        return _this;
    }
    SerializationContext.prototype.internalParseCardObject = function(parent, source, forbiddenTypes, allowFallback, createInstanceCallback, logParseEvent, parsingSingletonObject) {
        var _this = this;
        if (parsingSingletonObject === void 0) parsingSingletonObject = false;
        var result = undefined;
        if (source && typeof source === "object") {
            var oldForbiddenTypes_1 = new Set();
            this._forbiddenTypes.forEach(function(type) {
                oldForbiddenTypes_1.add(type);
            });
            forbiddenTypes.forEach(function(type) {
                _this._forbiddenTypes.add(type);
            });
            var typeName = $ioYal.parseString(source["type"]);
            var ignoreForbiddenType = parsingSingletonObject && typeName === "Carousel";
            if (typeName && this._forbiddenTypes.has(typeName) && !ignoreForbiddenType) logParseEvent(typeName, $iw5eI.TypeErrorType.ForbiddenType);
            else {
                var tryToFallback = false;
                result = createInstanceCallback(typeName);
                if (!result) {
                    tryToFallback = $eUh3g.GlobalSettings.enableFallback && allowFallback;
                    logParseEvent(typeName, $iw5eI.TypeErrorType.UnknownType);
                } else {
                    result.setParent(parent);
                    result.parse(source, this);
                    tryToFallback = $eUh3g.GlobalSettings.enableFallback && allowFallback && result.shouldFallback();
                }
                if (tryToFallback) {
                    var fallback = source["fallback"];
                    if (!fallback && parent) parent.setShouldFallback(true);
                    if (typeof fallback === "string" && fallback.toLowerCase() === "drop") result = undefined;
                    else if (typeof fallback === "object") result = this.internalParseCardObject(parent, fallback, forbiddenTypes, true, createInstanceCallback, logParseEvent);
                }
            }
            this._forbiddenTypes = oldForbiddenTypes_1;
        }
        return result;
    };
    SerializationContext.prototype.cardObjectParsed = function(o, source) {
        if (o instanceof $2b991ecb5ab02fee$var$Action && this.onParseAction) this.onParseAction(o, source, this);
        else if (o instanceof $2b991ecb5ab02fee$var$CardElement && this.onParseElement) this.onParseElement(o, source, this);
    };
    SerializationContext.prototype.shouldSerialize = function(o) {
        if (o instanceof $2b991ecb5ab02fee$var$Action) return this.actionRegistry.findByName(o.getJsonTypeName()) !== undefined;
        else if (o instanceof $2b991ecb5ab02fee$var$CardElement) return this.elementRegistry.findByName(o.getJsonTypeName()) !== undefined;
        else return true;
    };
    SerializationContext.prototype.parseCardObject = function(parent, source, forbiddenTypeNames, allowFallback, createInstanceCallback, logParseEvent, parsingSingletonObject) {
        if (parsingSingletonObject === void 0) parsingSingletonObject = false;
        var forbiddenTypes = new Set(forbiddenTypeNames);
        var result = this.internalParseCardObject(parent, source, forbiddenTypes, allowFallback, createInstanceCallback, logParseEvent, parsingSingletonObject);
        if (result !== undefined) this.cardObjectParsed(result, source);
        return result;
    };
    SerializationContext.prototype.parseElement = function(parent, source, forbiddenTypes, allowFallback, _parsingSingletonObject) {
        var _this = this;
        if (_parsingSingletonObject === void 0) _parsingSingletonObject = false;
        return this.parseCardObject(parent, source, forbiddenTypes, allowFallback, function(typeName) {
            return _this.elementRegistry.createInstance(typeName, _this.targetVersion);
        }, function(typeName, errorType) {
            if (errorType === $iw5eI.TypeErrorType.UnknownType) _this.logParseEvent(undefined, $iw5eI.ValidationEvent.UnknownElementType, $brsVB.Strings.errors.unknownElementType(typeName));
            else _this.logParseEvent(undefined, $iw5eI.ValidationEvent.ElementTypeNotAllowed, $brsVB.Strings.errors.elementTypeNotAllowed(typeName));
        }, _parsingSingletonObject);
    };
    SerializationContext.prototype.parseAction = function(parent, source, forbiddenActionTypes, allowFallback) {
        var _this = this;
        return this.parseCardObject(parent, source, forbiddenActionTypes, allowFallback, function(typeName) {
            return _this.actionRegistry.createInstance(typeName, _this.targetVersion);
        }, function(typeName, errorType) {
            if (errorType === $iw5eI.TypeErrorType.UnknownType) _this.logParseEvent(undefined, $iw5eI.ValidationEvent.UnknownActionType, $brsVB.Strings.errors.unknownActionType(typeName));
            else _this.logParseEvent(undefined, $iw5eI.ValidationEvent.ActionTypeNotAllowed, $brsVB.Strings.errors.actionTypeNotAllowed(typeName));
        });
    };
    Object.defineProperty(SerializationContext.prototype, "elementRegistry", {
        get: function() {
            var _a;
            return (_a = this._elementRegistry) !== null && _a !== void 0 ? _a : $J4wUi.GlobalRegistry.elements;
        },
        enumerable: false,
        configurable: true
    });
    // Not using a property setter here because the setter should accept "undefined"
    // whereas the getter should never return undefined.
    SerializationContext.prototype.setElementRegistry = function(value) {
        this._elementRegistry = value;
    };
    Object.defineProperty(SerializationContext.prototype, "actionRegistry", {
        get: function() {
            var _a;
            return (_a = this._actionRegistry) !== null && _a !== void 0 ? _a : $J4wUi.GlobalRegistry.actions;
        },
        enumerable: false,
        configurable: true
    });
    // Not using a property setter here because the setter should accept "undefined"
    // whereas the getter should never return undefined.
    SerializationContext.prototype.setActionRegistry = function(value) {
        this._actionRegistry = value;
    };
    return SerializationContext;
}($ldzOp.BaseSerializationContext);
module.exports.SerializationContext = $2b991ecb5ab02fee$var$SerializationContext;
$J4wUi.GlobalRegistry.defaultElements.register("Container", $2b991ecb5ab02fee$var$Container);
$J4wUi.GlobalRegistry.defaultElements.register("TextBlock", $2b991ecb5ab02fee$var$TextBlock);
$J4wUi.GlobalRegistry.defaultElements.register("RichTextBlock", $2b991ecb5ab02fee$var$RichTextBlock, $ldzOp.Versions.v1_2);
$J4wUi.GlobalRegistry.defaultElements.register("TextRun", $2b991ecb5ab02fee$var$TextRun, $ldzOp.Versions.v1_2);
$J4wUi.GlobalRegistry.defaultElements.register("Image", $2b991ecb5ab02fee$var$Image);
$J4wUi.GlobalRegistry.defaultElements.register("ImageSet", $2b991ecb5ab02fee$var$ImageSet);
$J4wUi.GlobalRegistry.defaultElements.register("Media", $2b991ecb5ab02fee$var$Media, $ldzOp.Versions.v1_1);
$J4wUi.GlobalRegistry.defaultElements.register("FactSet", $2b991ecb5ab02fee$var$FactSet);
$J4wUi.GlobalRegistry.defaultElements.register("ColumnSet", $2b991ecb5ab02fee$var$ColumnSet);
$J4wUi.GlobalRegistry.defaultElements.register("ActionSet", $2b991ecb5ab02fee$var$ActionSet, $ldzOp.Versions.v1_2);
$J4wUi.GlobalRegistry.defaultElements.register("Input.Text", $2b991ecb5ab02fee$var$TextInput);
$J4wUi.GlobalRegistry.defaultElements.register("Input.Date", $2b991ecb5ab02fee$var$DateInput);
$J4wUi.GlobalRegistry.defaultElements.register("Input.Time", $2b991ecb5ab02fee$var$TimeInput);
$J4wUi.GlobalRegistry.defaultElements.register("Input.Number", $2b991ecb5ab02fee$var$NumberInput);
$J4wUi.GlobalRegistry.defaultElements.register("Input.ChoiceSet", $2b991ecb5ab02fee$var$ChoiceSetInput);
$J4wUi.GlobalRegistry.defaultElements.register("Input.Toggle", $2b991ecb5ab02fee$var$ToggleInput);
$J4wUi.GlobalRegistry.defaultActions.register($2b991ecb5ab02fee$var$OpenUrlAction.JsonTypeName, $2b991ecb5ab02fee$var$OpenUrlAction);
$J4wUi.GlobalRegistry.defaultActions.register($2b991ecb5ab02fee$var$SubmitAction.JsonTypeName, $2b991ecb5ab02fee$var$SubmitAction);
$J4wUi.GlobalRegistry.defaultActions.register($2b991ecb5ab02fee$var$ShowCardAction.JsonTypeName, $2b991ecb5ab02fee$var$ShowCardAction);
$J4wUi.GlobalRegistry.defaultActions.register($2b991ecb5ab02fee$var$ToggleVisibilityAction.JsonTypeName, $2b991ecb5ab02fee$var$ToggleVisibilityAction, $ldzOp.Versions.v1_2);
$J4wUi.GlobalRegistry.defaultActions.register($2b991ecb5ab02fee$var$ExecuteAction.JsonTypeName, $2b991ecb5ab02fee$var$ExecuteAction, $ldzOp.Versions.v1_4);

});
parcelRequire.register("fQwaQ", function(module, exports) {
"use strict";
var $b894ab6dfaccdb93$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.formatText = void 0;
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.
var $b894ab6dfaccdb93$var$AbstractTextFormatter = /** @class */ function() {
    function AbstractTextFormatter(regularExpression) {
        this._regularExpression = regularExpression;
    }
    AbstractTextFormatter.prototype.format = function(lang, input) {
        var matches;
        if (input) {
            var result = input;
            while((matches = this._regularExpression.exec(input)) != null)result = result.replace(matches[0], this.internalFormat(lang, matches));
            return result;
        } else return input;
    };
    return AbstractTextFormatter;
}();
var $b894ab6dfaccdb93$var$DateFormatter = /** @class */ function(_super) {
    $b894ab6dfaccdb93$var$__extends(DateFormatter, _super);
    function DateFormatter() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DateFormatter.prototype.internalFormat = function(lang, matches) {
        var date = new Date(Date.parse(matches[1]));
        var format = matches[2] !== undefined ? matches[2].toLowerCase() : "compact";
        if (format !== "compact") return date.toLocaleDateString(lang, {
            day: "numeric",
            weekday: format,
            month: format,
            year: "numeric"
        });
        else return date.toLocaleDateString();
    };
    return DateFormatter;
}($b894ab6dfaccdb93$var$AbstractTextFormatter);
var $b894ab6dfaccdb93$var$TimeFormatter = /** @class */ function(_super) {
    $b894ab6dfaccdb93$var$__extends(TimeFormatter, _super);
    function TimeFormatter() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TimeFormatter.prototype.internalFormat = function(lang, matches) {
        var date = new Date(Date.parse(matches[1]));
        return date.toLocaleTimeString(lang, {
            hour: "numeric",
            minute: "2-digit"
        });
    };
    return TimeFormatter;
}($b894ab6dfaccdb93$var$AbstractTextFormatter);
function $b894ab6dfaccdb93$var$formatText(lang, text) {
    var formatters = [
        new $b894ab6dfaccdb93$var$DateFormatter(/\{{2}DATE\((\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:Z|(?:(?:-|\+)\d{2}:\d{2})))(?:, ?(COMPACT|LONG|SHORT))?\)\}{2}/g),
        new $b894ab6dfaccdb93$var$TimeFormatter(/\{{2}TIME\((\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:Z|(?:(?:-|\+)\d{2}:\d{2})))\)\}{2}/g)
    ];
    var result = text;
    for(var _i = 0, formatters_1 = formatters; _i < formatters_1.length; _i++){
        var formatter = formatters_1[_i];
        result = formatter.format(lang, result);
    }
    return result;
}
module.exports.formatText = $b894ab6dfaccdb93$var$formatText;

});

parcelRequire.register("eIrtg", function(module, exports) {
"use strict";
var $02c3c8313180389f$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $02c3c8313180389f$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) $02c3c8313180389f$var$__createBinding(exports, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

// Copyright (C) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.
$02c3c8313180389f$var$__exportStar((parcelRequire("1Khtv")), module.exports);

$02c3c8313180389f$var$__exportStar((parcelRequire("9ivDb")), module.exports);

});
parcelRequire.register("1Khtv", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MenuItem = void 0;

var $4IoSX = parcelRequire("4IoSX");

var $4uzah = parcelRequire("4uzah");
var $1457a47aa783cb21$var$MenuItem = /** @class */ function() {
    function MenuItem(key, value) {
        this._isEnabled = true;
        this.key = key;
        this._value = value;
    }
    MenuItem.prototype.click = function() {
        if (this.isEnabled && this.onClick) this.onClick(this);
    };
    MenuItem.prototype.updateCssClasses = function() {
        if (this._element) {
            var effectiveHostConfig = this._hostConfig ? this._hostConfig : $4IoSX.defaultHostConfig;
            this._element.className = effectiveHostConfig.makeCssClassName("ac-ctrl");
            this._element.classList.add(effectiveHostConfig.makeCssClassName(this.isEnabled ? "ac-ctrl-dropdown-item" : "ac-ctrl-dropdown-item-disabled"));
            if (!this.isEnabled) this._element.classList.add(effectiveHostConfig.makeCssClassName("ac-disabled"));
        }
    };
    MenuItem.prototype.toString = function() {
        return this.value;
    };
    MenuItem.prototype.render = function(hostConfig) {
        var _this = this;
        this._hostConfig = hostConfig;
        if (!this._element) {
            this._element = document.createElement("span");
            this._element.innerText = this.value;
            this._element.setAttribute("role", "menuitem");
            if (!this.isEnabled) this._element.setAttribute("aria-disabled", "true");
            this._element.setAttribute("aria-current", "false");
            this._element.onmouseup = function(_e) {
                _this.click();
            };
            this._element.onkeydown = function(e) {
                if (e.key === $4uzah.Constants.keys.enter) {
                    e.cancelBubble = true;
                    _this.click();
                }
            };
            this.updateCssClasses();
        }
        return this._element;
    };
    Object.defineProperty(MenuItem.prototype, "value", {
        get: function() {
            return this._value;
        },
        set: function(newValue) {
            this._value = newValue;
            if (this._element) this._element.innerText = newValue;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MenuItem.prototype, "isEnabled", {
        get: function() {
            return this._isEnabled;
        },
        set: function(value) {
            if (this._isEnabled !== value) {
                this._isEnabled = value;
                this.updateCssClasses();
            }
        },
        enumerable: false,
        configurable: true
    });
    return MenuItem;
}();
module.exports.MenuItem = $1457a47aa783cb21$var$MenuItem;

});
parcelRequire.register("4uzah", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Constants = void 0;
// eslint-disable-next-line @typescript-eslint/no-extraneous-class
var $34553dc681c50858$var$Constants = /** @class */ function() {
    function Constants() {}
    Constants.keys = {
        tab: "Tab",
        enter: "Enter",
        escape: "Escape",
        space: " ",
        up: "ArrowUp",
        down: "ArrowDown",
        delete: "Delete"
    };
    return Constants;
}();
module.exports.Constants = $34553dc681c50858$var$Constants;

});


parcelRequire.register("9ivDb", function(module, exports) {
"use strict";
var $6c4e54bed45298a5$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PopupMenu = void 0;

var $4uzah = parcelRequire("4uzah");

var $giY6T = parcelRequire("giY6T");

var $1jIIU = parcelRequire("1jIIU");
var $6c4e54bed45298a5$var$PopupMenu = /** @class */ function(_super) {
    $6c4e54bed45298a5$var$__extends(PopupMenu, _super);
    function PopupMenu() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._items = new $giY6T.Collection();
        _this._renderedItems = [];
        _this._selectedIndex = -1;
        return _this;
    }
    PopupMenu.prototype.renderContent = function() {
        var element = document.createElement("div");
        element.className = this.hostConfig.makeCssClassName("ac-ctrl ac-popup");
        element.setAttribute("role", "listbox");
        for(var i = 0; i < this._items.length; i++){
            var renderedItem = this._items.get(i).render(this.hostConfig);
            renderedItem.tabIndex = 0;
            element.appendChild(renderedItem);
            if (i === this.selectedIndex) renderedItem.focus();
            this._renderedItems.push(renderedItem);
        }
        return element;
    };
    PopupMenu.prototype.keyDown = function(e) {
        _super.prototype.keyDown.call(this, e);
        var selectedItemIndex = this._selectedIndex;
        switch(e.key){
            case $4uzah.Constants.keys.tab:
                this.closePopup(true);
                break;
            /*
            case Constants.keys.enter:
                if (this.selectedIndex >= 0) {
                    this.selectedIndex = this.selectedIndex;

                    this.close();
                }

                break;
            */ case $4uzah.Constants.keys.up:
                if (selectedItemIndex <= 0) selectedItemIndex = this._renderedItems.length - 1;
                else {
                    selectedItemIndex--;
                    if (selectedItemIndex < 0) selectedItemIndex = this._renderedItems.length - 1;
                }
                this.selectedIndex = selectedItemIndex;
                e.cancelBubble = true;
                break;
            case $4uzah.Constants.keys.down:
                if (selectedItemIndex < 0) selectedItemIndex = 0;
                else {
                    selectedItemIndex++;
                    if (selectedItemIndex >= this._renderedItems.length) selectedItemIndex = 0;
                }
                this.selectedIndex = selectedItemIndex;
                e.cancelBubble = true;
                break;
        }
    };
    Object.defineProperty(PopupMenu.prototype, "items", {
        get: function() {
            return this._items;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PopupMenu.prototype, "selectedIndex", {
        get: function() {
            return this._selectedIndex;
        },
        set: function(index) {
            if (index >= 0 && index < this._renderedItems.length) {
                this._renderedItems[index].focus();
                this._selectedIndex = index;
            }
        },
        enumerable: false,
        configurable: true
    });
    return PopupMenu;
}($1jIIU.PopupControl);
module.exports.PopupMenu = $6c4e54bed45298a5$var$PopupMenu;

});
parcelRequire.register("giY6T", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Collection = void 0;
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.
var $bdecf46f18237fc2$var$Collection = /** @class */ function() {
    function Collection() {
        this._items = [];
    }
    Collection.prototype.get = function(index) {
        return this._items[index];
    };
    Collection.prototype.add = function(item) {
        this._items.push(item);
        if (this.onItemAdded) this.onItemAdded(item);
    };
    Collection.prototype.remove = function(item) {
        var i = this._items.indexOf(item);
        if (i >= 0) {
            this._items = this._items.splice(i, 1);
            if (this.onItemRemoved) this.onItemRemoved(item);
        }
    };
    Collection.prototype.indexOf = function(item) {
        return this._items.indexOf(item);
    };
    Object.defineProperty(Collection.prototype, "length", {
        get: function() {
            return this._items.length;
        },
        enumerable: false,
        configurable: true
    });
    return Collection;
}();
module.exports.Collection = $bdecf46f18237fc2$var$Collection;

});

parcelRequire.register("1jIIU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PopupControl = void 0;

var $4uzah = parcelRequire("4uzah");

var $ioYal = parcelRequire("ioYal");

var $4IoSX = parcelRequire("4IoSX");
var $0f5a41ec5fa3c3fc$var$PopupControl = /** @class */ function() {
    function PopupControl() {
        this._isOpen = false;
    }
    PopupControl.prototype.keyDown = function(e) {
        switch(e.key){
            case $4uzah.Constants.keys.escape:
                this.closePopup(true);
                break;
        }
    };
    PopupControl.prototype.render = function(_rootElementBounds) {
        var _this = this;
        var element = document.createElement("div");
        element.tabIndex = 0;
        element.className = this.hostConfig.makeCssClassName("ac-ctrl", "ac-ctrl-popup-container");
        element.setAttribute("role", "dialog");
        element.setAttribute("aria-modal", "true");
        element.onkeydown = function(e) {
            _this.keyDown(e);
            return !e.cancelBubble;
        };
        element.appendChild(this.renderContent());
        return element;
    };
    PopupControl.prototype.focus = function() {
        if (this._popupElement) this._popupElement.firstElementChild.focus();
    };
    PopupControl.prototype.popup = function(rootElement) {
        var _a, _b, _c, _d, _f;
        var _this = this;
        if (!this._isOpen) {
            this._overlayElement = document.createElement("div");
            this._overlayElement.className = this.hostConfig.makeCssClassName("ac-ctrl-overlay");
            this._overlayElement.tabIndex = 0;
            this._overlayElement.style.width = document.documentElement.scrollWidth + "px";
            this._overlayElement.style.height = document.documentElement.scrollHeight + "px";
            this._overlayElement.onfocus = function(_e) {
                _this.closePopup(true);
            };
            document.body.appendChild(this._overlayElement);
            var rootElementBounds = rootElement.getBoundingClientRect();
            this._popupElement = this.render(rootElementBounds);
            (_a = this._popupElement.classList).remove.apply(_a, this.hostConfig.makeCssClassNames("ac-ctrl-slide", "ac-ctrl-slideLeftToRight", "ac-ctrl-slideRightToLeft", "ac-ctrl-slideTopToBottom", "ac-ctrl-slideRightToLeft"));
            window.addEventListener("resize", function(_e) {
                _this.closePopup(true);
            });
            var rootElementLabel = rootElement.getAttribute("aria-label");
            if (rootElementLabel) this._popupElement.setAttribute("aria-label", rootElementLabel);
            this._overlayElement.appendChild(this._popupElement);
            var popupElementBounds = this._popupElement.getBoundingClientRect();
            var availableSpaceBelow = window.innerHeight - rootElementBounds.bottom;
            var availableSpaceAbove = rootElementBounds.top;
            var availableSpaceRight = window.innerWidth - rootElementBounds.right;
            var availableSpaceLeft = rootElementBounds.left;
            var left = rootElementBounds.left + $ioYal.getScrollX();
            var top_1;
            if (availableSpaceAbove < popupElementBounds.height && availableSpaceBelow < popupElementBounds.height) {
                // Not enough space above or below root element
                var actualPopupHeight = Math.min(popupElementBounds.height, window.innerHeight);
                this._popupElement.style.maxHeight = actualPopupHeight + "px";
                if (actualPopupHeight < popupElementBounds.height) top_1 = $ioYal.getScrollY();
                else top_1 = $ioYal.getScrollY() + rootElementBounds.top + (rootElementBounds.height - actualPopupHeight) / 2;
                if (availableSpaceLeft < popupElementBounds.width && availableSpaceRight < popupElementBounds.width) {
                    // Not enough space left or right of root element
                    var actualPopupWidth = Math.min(popupElementBounds.width, window.innerWidth);
                    this._popupElement.style.maxWidth = actualPopupWidth + "px";
                    if (actualPopupWidth < popupElementBounds.width) left = $ioYal.getScrollX();
                    else left = $ioYal.getScrollX() + rootElementBounds.left + (rootElementBounds.width - actualPopupWidth) / 2;
                } else // Enough space on the left or right of the root element
                if (availableSpaceRight >= popupElementBounds.width) {
                    left = $ioYal.getScrollX() + rootElementBounds.right;
                    (_b = this._popupElement.classList).add.apply(_b, this.hostConfig.makeCssClassNames("ac-ctrl-slide", "ac-ctrl-slideLeftToRight"));
                } else {
                    left = $ioYal.getScrollX() + rootElementBounds.left - popupElementBounds.width;
                    (_c = this._popupElement.classList).add.apply(_c, this.hostConfig.makeCssClassNames("ac-ctrl-slide", "ac-ctrl-slideRightToLeft"));
                }
            } else {
                // Enough space above or below root element
                if (availableSpaceBelow >= popupElementBounds.height) {
                    top_1 = $ioYal.getScrollY() + rootElementBounds.bottom;
                    (_d = this._popupElement.classList).add.apply(_d, this.hostConfig.makeCssClassNames("ac-ctrl-slide", "ac-ctrl-slideTopToBottom"));
                } else {
                    top_1 = $ioYal.getScrollY() + rootElementBounds.top - popupElementBounds.height;
                    (_f = this._popupElement.classList).add.apply(_f, this.hostConfig.makeCssClassNames("ac-ctrl-slide", "ac-ctrl-slideBottomToTop"));
                }
                if (availableSpaceRight < popupElementBounds.width) left = $ioYal.getScrollX() + rootElementBounds.right - popupElementBounds.width;
            }
            this._popupElement.style.left = left + "px";
            this._popupElement.style.top = top_1 + "px";
            this._popupElement.focus();
            this._isOpen = true;
        }
    };
    PopupControl.prototype.closePopup = function(wasCancelled) {
        if (this._isOpen) {
            document.body.removeChild(this._overlayElement);
            this._isOpen = false;
            if (this.onClose) this.onClose(this, wasCancelled);
        }
    };
    Object.defineProperty(PopupControl.prototype, "hostConfig", {
        get: function() {
            return this._hostConfig ? this._hostConfig : $4IoSX.defaultHostConfig;
        },
        set: function(value) {
            this._hostConfig = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PopupControl.prototype, "isOpen", {
        get: function() {
            return this._isOpen;
        },
        enumerable: false,
        configurable: true
    });
    return PopupControl;
}();
module.exports.PopupControl = $0f5a41ec5fa3c3fc$var$PopupControl;

});




parcelRequire.register("8Cbbq", function(module, exports) {
"use strict";
var $645a8c1a60fc2209$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $645a8c1a60fc2209$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Table = module.exports.TableRow = module.exports.TableCell = module.exports.StylableContainer = module.exports.TableColumnDefinition = void 0;

var $3K4s0 = parcelRequire("3K4s0");

var $iw5eI = parcelRequire("iw5eI");

var $J4wUi = parcelRequire("J4wUi");

var $ldzOp = parcelRequire("ldzOp");

var $eUh3g = parcelRequire("eUh3g");

var $brsVB = parcelRequire("brsVB");

var $ioYal = parcelRequire("ioYal");
var $645a8c1a60fc2209$var$TableColumnDefinition = /** @class */ function(_super) {
    $645a8c1a60fc2209$var$__extends(TableColumnDefinition, _super);
    function TableColumnDefinition() {
        //#region Schema
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.width = new $eUh3g.SizeAndUnit(1, $iw5eI.SizeUnit.Weight);
        return _this;
    }
    TableColumnDefinition.prototype.getSchemaKey = function() {
        return "ColumnDefinition";
    };
    TableColumnDefinition.horizontalCellContentAlignmentProperty = new $ldzOp.EnumProperty($ldzOp.Versions.v1_5, "horizontalCellContentAlignment", $iw5eI.HorizontalAlignment);
    TableColumnDefinition.verticalCellContentAlignmentProperty = new $ldzOp.EnumProperty($ldzOp.Versions.v1_5, "verticalCellContentAlignment", $iw5eI.VerticalAlignment);
    TableColumnDefinition.widthProperty = new $ldzOp.CustomProperty($ldzOp.Versions.v1_5, "width", function(sender, prop, source, context) {
        var result = prop.defaultValue;
        var value = source[prop.name];
        var invalidWidth = false;
        if (typeof value === "number" && !isNaN(value)) result = new $eUh3g.SizeAndUnit(value, $iw5eI.SizeUnit.Weight);
        else if (typeof value === "string") try {
            result = $eUh3g.SizeAndUnit.parse(value);
        } catch (e) {
            invalidWidth = true;
        }
        else invalidWidth = true;
        if (invalidWidth) context.logParseEvent(sender, $iw5eI.ValidationEvent.InvalidPropertyValue, $brsVB.Strings.errors.invalidColumnWidth(value));
        return result;
    }, function(sender, property, target, value, context) {
        if (value.unit === $iw5eI.SizeUnit.Pixel) context.serializeValue(target, "width", value.physicalSize + "px");
        else context.serializeNumber(target, "width", value.physicalSize);
    }, new $eUh3g.SizeAndUnit(1, $iw5eI.SizeUnit.Weight));
    $645a8c1a60fc2209$var$__decorate([
        (0, $ldzOp.property)(TableColumnDefinition.horizontalCellContentAlignmentProperty)
    ], TableColumnDefinition.prototype, "horizontalCellContentAlignment", void 0);
    $645a8c1a60fc2209$var$__decorate([
        (0, $ldzOp.property)(TableColumnDefinition.verticalCellContentAlignmentProperty)
    ], TableColumnDefinition.prototype, "verticalCellContentAlignment", void 0);
    $645a8c1a60fc2209$var$__decorate([
        (0, $ldzOp.property)(TableColumnDefinition.widthProperty)
    ], TableColumnDefinition.prototype, "width", void 0);
    return TableColumnDefinition;
}($ldzOp.SerializableObject);
module.exports.TableColumnDefinition = $645a8c1a60fc2209$var$TableColumnDefinition;
var $645a8c1a60fc2209$var$StylableContainer = /** @class */ function(_super) {
    $645a8c1a60fc2209$var$__extends(StylableContainer, _super);
    function StylableContainer() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._items = [];
        return _this;
    }
    StylableContainer.prototype.parseItem = function(source, context) {
        var _this = this;
        return context.parseCardObject(this, source, [], !this.isDesignMode(), function(typeName) {
            return _this.createItemInstance(typeName);
        }, function(typeName, _errorType) {
            context.logParseEvent(undefined, $iw5eI.ValidationEvent.ElementTypeNotAllowed, $brsVB.Strings.errors.elementTypeNotAllowed(typeName));
        });
    };
    StylableContainer.prototype.internalAddItem = function(item) {
        if (!item.parent) {
            this._items.push(item);
            item.setParent(this);
        } else throw new Error($brsVB.Strings.errors.elementAlreadyParented());
    };
    StylableContainer.prototype.internalRemoveItem = function(item) {
        var itemIndex = this._items.indexOf(item);
        if (itemIndex >= 0) {
            this._items.splice(itemIndex, 1);
            item.setParent(undefined);
            this.updateLayout();
            return true;
        }
        return false;
    };
    StylableContainer.prototype.internalIndexOf = function(item) {
        return this._items.indexOf(item);
    };
    StylableContainer.prototype.internalParse = function(source, context) {
        _super.prototype.internalParse.call(this, source, context);
        this._items = [];
        var items = source[this.getCollectionPropertyName()];
        if (Array.isArray(items)) for(var _i = 0, items_1 = items; _i < items_1.length; _i++){
            var item = items_1[_i];
            var instance = this.parseItem(item, context);
            if (instance) this._items.push(instance);
        }
    };
    StylableContainer.prototype.internalToJSON = function(target, context) {
        _super.prototype.internalToJSON.call(this, target, context);
        context.serializeArray(target, this.getCollectionPropertyName(), this._items);
    };
    StylableContainer.prototype.removeItem = function(item) {
        return this.internalRemoveItem(item);
    };
    StylableContainer.prototype.getItemCount = function() {
        return this._items.length;
    };
    StylableContainer.prototype.getItemAt = function(index) {
        return this._items[index];
    };
    StylableContainer.prototype.getFirstVisibleRenderedItem = function() {
        return this.getItemCount() > 0 ? this.getItemAt(0) : undefined;
    };
    StylableContainer.prototype.getLastVisibleRenderedItem = function() {
        return this.getItemCount() > 0 ? this.getItemAt(this.getItemCount() - 1) : undefined;
    };
    return StylableContainer;
}($3K4s0.StylableCardElementContainer);
module.exports.StylableContainer = $645a8c1a60fc2209$var$StylableContainer;
var $645a8c1a60fc2209$var$TableCell = /** @class */ function(_super) {
    $645a8c1a60fc2209$var$__extends(TableCell, _super);
    function TableCell() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._columnIndex = -1;
        _this._cellType = "data";
        return _this;
    }
    TableCell.prototype.getHasBorder = function() {
        return this.parentRow.parentTable.showGridLines;
    };
    TableCell.prototype.applyBorder = function() {
        if (this.renderedElement && this.getHasBorder()) {
            var styleDefinition = this.hostConfig.containerStyles.getStyleByName(this.parentRow.parentTable.gridStyle);
            if (styleDefinition.borderColor) {
                var borderColor = (0, $ioYal.stringToCssColor)(styleDefinition.borderColor);
                if (borderColor) {
                    this.renderedElement.style.borderRight = "1px solid " + borderColor;
                    this.renderedElement.style.borderBottom = "1px solid " + borderColor;
                }
            }
        }
    };
    TableCell.prototype.getDefaultPadding = function() {
        return this.getHasBackground() || this.getHasBorder() ? new $eUh3g.PaddingDefinition($iw5eI.Spacing.Small, $iw5eI.Spacing.Small, $iw5eI.Spacing.Small, $iw5eI.Spacing.Small) : _super.prototype.getDefaultPadding.call(this);
    };
    TableCell.prototype.internalRender = function() {
        var cellElement = _super.prototype.internalRender.call(this);
        if (cellElement) {
            cellElement.setAttribute("role", this.cellType === "data" ? "cell" : "columnheader");
            cellElement.style.minWidth = "0";
            if (this.cellType === "header") cellElement.setAttribute("scope", "col");
        }
        return cellElement;
    };
    TableCell.prototype.shouldSerialize = function(_context) {
        return true;
    };
    TableCell.prototype.getJsonTypeName = function() {
        return "TableCell";
    };
    TableCell.prototype.getEffectiveTextStyleDefinition = function() {
        if (this.cellType === "header") return this.hostConfig.textStyles.columnHeader;
        return _super.prototype.getEffectiveTextStyleDefinition.call(this);
    };
    TableCell.prototype.getEffectiveHorizontalAlignment = function() {
        if (this.horizontalAlignment !== undefined) return this.horizontalAlignment;
        if (this.parentRow.horizontalCellContentAlignment !== undefined) return this.parentRow.horizontalCellContentAlignment;
        if (this.columnIndex >= 0) {
            var horizontalAlignment = this.parentRow.parentTable.getColumnAt(this.columnIndex).horizontalCellContentAlignment;
            if (horizontalAlignment !== undefined) return horizontalAlignment;
        }
        if (this.parentRow.parentTable.horizontalCellContentAlignment !== undefined) return this.parentRow.parentTable.horizontalCellContentAlignment;
        return _super.prototype.getEffectiveHorizontalAlignment.call(this);
    };
    TableCell.prototype.getEffectiveVerticalContentAlignment = function() {
        if (this.verticalContentAlignment !== undefined) return this.verticalContentAlignment;
        if (this.parentRow.verticalCellContentAlignment !== undefined) return this.parentRow.verticalCellContentAlignment;
        if (this.columnIndex >= 0) {
            var verticalAlignment = this.parentRow.parentTable.getColumnAt(this.columnIndex).verticalCellContentAlignment;
            if (verticalAlignment !== undefined) return verticalAlignment;
        }
        if (this.parentRow.parentTable.verticalCellContentAlignment !== undefined) return this.parentRow.parentTable.verticalCellContentAlignment;
        return _super.prototype.getEffectiveVerticalContentAlignment.call(this);
    };
    Object.defineProperty(TableCell.prototype, "columnIndex", {
        get: function() {
            return this._columnIndex;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TableCell.prototype, "cellType", {
        get: function() {
            return this._cellType;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TableCell.prototype, "parentRow", {
        get: function() {
            return this.parent;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TableCell.prototype, "isStandalone", {
        get: function() {
            return false;
        },
        enumerable: false,
        configurable: true
    });
    return TableCell;
}($3K4s0.Container);
module.exports.TableCell = $645a8c1a60fc2209$var$TableCell;
var $645a8c1a60fc2209$var$TableRow = /** @class */ function(_super) {
    $645a8c1a60fc2209$var$__extends(TableRow, _super);
    function TableRow() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    //#endregion
    TableRow.prototype.getDefaultPadding = function() {
        return new $eUh3g.PaddingDefinition($iw5eI.Spacing.None, $iw5eI.Spacing.None, $iw5eI.Spacing.None, $iw5eI.Spacing.None);
    };
    TableRow.prototype.applyBackground = function() {
        if (this.renderedElement) {
            var styleDefinition = this.hostConfig.containerStyles.getStyleByName(this.style, this.hostConfig.containerStyles.getStyleByName(this.defaultStyle));
            if (styleDefinition.backgroundColor) {
                var bgColor = (0, $ioYal.stringToCssColor)(styleDefinition.backgroundColor);
                if (bgColor) this.renderedElement.style.backgroundColor = bgColor;
            }
        }
    };
    TableRow.prototype.getCollectionPropertyName = function() {
        return "cells";
    };
    TableRow.prototype.createItemInstance = function(typeName) {
        return !typeName || typeName === "TableCell" ? new $645a8c1a60fc2209$var$TableCell() : undefined;
    };
    TableRow.prototype.internalRender = function() {
        var isFirstRow = this.getIsFirstRow();
        var cellSpacing = this.hostConfig.table.cellSpacing;
        var rowElement = document.createElement("div");
        rowElement.setAttribute("role", "row");
        rowElement.style.display = "flex";
        rowElement.style.flexDirection = "row";
        for(var i = 0; i < Math.min(this.getItemCount(), this.parentTable.getColumnCount()); i++){
            var cell = this.getItemAt(i);
            // Cheating a bit in order to keep cellType read-only
            cell["_columnIndex"] = i;
            cell["_cellType"] = this.parentTable.firstRowAsHeaders && isFirstRow ? "header" : "data";
            var renderedCell = cell.render();
            if (renderedCell) {
                var column = this.parentTable.getColumnAt(i);
                if (column.computedWidth.unit === $iw5eI.SizeUnit.Pixel) renderedCell.style.flex = "0 0 " + column.computedWidth.physicalSize + "px";
                else renderedCell.style.flex = "1 1 " + column.computedWidth.physicalSize + "%";
                if (i > 0 && !this.parentTable.showGridLines && cellSpacing > 0) renderedCell.style.marginLeft = cellSpacing + "px";
                rowElement.appendChild(renderedCell);
            }
        }
        return rowElement.children.length > 0 ? rowElement : undefined;
    };
    TableRow.prototype.shouldSerialize = function(_context) {
        return true;
    };
    TableRow.prototype.addCell = function(cell) {
        this.internalAddItem(cell);
    };
    TableRow.prototype.removeCellAt = function(columnIndex) {
        if (columnIndex >= 0 && columnIndex < this.getItemCount()) return this.removeItem(this.getItemAt(columnIndex));
        return false;
    };
    TableRow.prototype.indexOf = function(cardElement) {
        return cardElement instanceof $645a8c1a60fc2209$var$TableCell ? this.internalIndexOf(cardElement) : -1;
    };
    TableRow.prototype.ensureHasEnoughCells = function(cellCount) {
        while(this.getItemCount() < cellCount)this.addCell(new $645a8c1a60fc2209$var$TableCell());
    };
    TableRow.prototype.getJsonTypeName = function() {
        return "TableRow";
    };
    TableRow.prototype.getIsFirstRow = function() {
        return this.parentTable.getItemAt(0) === this;
    };
    Object.defineProperty(TableRow.prototype, "parentTable", {
        get: function() {
            return this.parent;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TableRow.prototype, "isStandalone", {
        get: function() {
            return false;
        },
        enumerable: false,
        configurable: true
    });
    //#region Schema
    TableRow.styleProperty = new $3K4s0.ContainerStyleProperty($ldzOp.Versions.v1_5, "style");
    TableRow.horizontalCellContentAlignmentProperty = new $ldzOp.EnumProperty($ldzOp.Versions.v1_5, "horizontalCellContentAlignment", $iw5eI.HorizontalAlignment);
    TableRow.verticalCellContentAlignmentProperty = new $ldzOp.EnumProperty($ldzOp.Versions.v1_5, "verticalCellContentAlignment", $iw5eI.VerticalAlignment);
    $645a8c1a60fc2209$var$__decorate([
        (0, $ldzOp.property)(TableRow.horizontalCellContentAlignmentProperty)
    ], TableRow.prototype, "horizontalCellContentAlignment", void 0);
    $645a8c1a60fc2209$var$__decorate([
        (0, $ldzOp.property)(TableRow.verticalCellContentAlignmentProperty)
    ], TableRow.prototype, "verticalCellContentAlignment", void 0);
    return TableRow;
}($645a8c1a60fc2209$var$StylableContainer);
module.exports.TableRow = $645a8c1a60fc2209$var$TableRow;
var $645a8c1a60fc2209$var$Table = /** @class */ function(_super) {
    $645a8c1a60fc2209$var$__extends(Table, _super);
    function Table() {
        //#region Schema
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._columns = [];
        _this.firstRowAsHeaders = true;
        _this.showGridLines = true;
        return _this;
    }
    Object.defineProperty(Table.prototype, "gridStyle", {
        get: function() {
            var style = this.getValue(Table.gridStyleProperty);
            if (style && this.hostConfig.containerStyles.getStyleByName(style)) return style;
            return undefined;
        },
        set: function(value) {
            this.setValue(Table.gridStyleProperty, value);
        },
        enumerable: false,
        configurable: true
    });
    //#endregion
    Table.prototype.ensureRowsHaveEnoughCells = function() {
        for(var i = 0; i < this.getItemCount(); i++)this.getItemAt(i).ensureHasEnoughCells(this.getColumnCount());
    };
    Table.prototype.removeCellsFromColumn = function(columnIndex) {
        for(var i = 0; i < this.getItemCount(); i++)this.getItemAt(i).removeCellAt(columnIndex);
    };
    Table.prototype.getCollectionPropertyName = function() {
        return "rows";
    };
    Table.prototype.createItemInstance = function(typeName) {
        return !typeName || typeName === "TableRow" ? new $645a8c1a60fc2209$var$TableRow() : undefined;
    };
    Table.prototype.internalParse = function(source, context) {
        _super.prototype.internalParse.call(this, source, context);
        this.ensureRowsHaveEnoughCells();
    };
    Table.prototype.internalRender = function() {
        if (this.getItemCount() > 0) {
            var totalWeights = 0;
            for(var _i = 0, _a = this._columns; _i < _a.length; _i++){
                var column = _a[_i];
                if (column.width.unit === $iw5eI.SizeUnit.Weight) totalWeights += column.width.physicalSize;
            }
            for(var _b = 0, _c = this._columns; _b < _c.length; _b++){
                var column = _c[_b];
                if (column.width.unit === $iw5eI.SizeUnit.Pixel) column.computedWidth = new $eUh3g.SizeAndUnit(column.width.physicalSize, $iw5eI.SizeUnit.Pixel);
                else column.computedWidth = new $eUh3g.SizeAndUnit(100 / totalWeights * column.width.physicalSize, $iw5eI.SizeUnit.Weight);
            }
            var tableElement = document.createElement("div");
            tableElement.setAttribute("role", "table");
            tableElement.style.display = "flex";
            tableElement.style.flexDirection = "column";
            if (this.showGridLines) {
                var styleDefinition = this.hostConfig.containerStyles.getStyleByName(this.gridStyle);
                if (styleDefinition.borderColor) {
                    var borderColor = (0, $ioYal.stringToCssColor)(styleDefinition.borderColor);
                    if (borderColor) {
                        tableElement.style.borderTop = "1px solid " + borderColor;
                        tableElement.style.borderLeft = "1px solid " + borderColor;
                    }
                }
            }
            var cellSpacing = this.hostConfig.table.cellSpacing;
            for(var i = 0; i < this.getItemCount(); i++){
                var renderedRow = this.getItemAt(i).render();
                if (renderedRow) {
                    if (i > 0 && !this.showGridLines && cellSpacing > 0) {
                        var separatorRow = document.createElement("div");
                        separatorRow.setAttribute("aria-hidden", "true");
                        separatorRow.style.height = cellSpacing + "px";
                        tableElement.appendChild(separatorRow);
                    }
                    tableElement.appendChild(renderedRow);
                }
            }
            return tableElement;
        }
        return undefined;
    };
    Table.prototype.addColumn = function(column) {
        this._columns.push(column);
        this.ensureRowsHaveEnoughCells();
    };
    Table.prototype.removeColumn = function(column) {
        var index = this._columns.indexOf(column);
        if (index >= 0) {
            this.removeCellsFromColumn(index);
            this._columns.splice(index, 1);
        }
    };
    Table.prototype.getColumnCount = function() {
        return this._columns.length;
    };
    Table.prototype.getColumnAt = function(index) {
        return this._columns[index];
    };
    Table.prototype.addRow = function(row) {
        this.internalAddItem(row);
        row.ensureHasEnoughCells(this.getColumnCount());
    };
    Table.prototype.indexOf = function(cardElement) {
        return cardElement instanceof $645a8c1a60fc2209$var$TableRow ? this.internalIndexOf(cardElement) : -1;
    };
    Table.prototype.getJsonTypeName = function() {
        return "Table";
    };
    Table._columnsProperty = new $ldzOp.SerializableObjectCollectionProperty($ldzOp.Versions.v1_5, "columns", $645a8c1a60fc2209$var$TableColumnDefinition);
    Table.firstRowAsHeadersProperty = new $ldzOp.BoolProperty($ldzOp.Versions.v1_5, "firstRowAsHeaders", true);
    Table.showGridLinesProperty = new $ldzOp.BoolProperty($ldzOp.Versions.v1_5, "showGridLines", true);
    Table.gridStyleProperty = new $3K4s0.ContainerStyleProperty($ldzOp.Versions.v1_5, "gridStyle");
    Table.horizontalCellContentAlignmentProperty = new $ldzOp.EnumProperty($ldzOp.Versions.v1_5, "horizontalCellContentAlignment", $iw5eI.HorizontalAlignment);
    Table.verticalCellContentAlignmentProperty = new $ldzOp.EnumProperty($ldzOp.Versions.v1_5, "verticalCellContentAlignment", $iw5eI.VerticalAlignment);
    $645a8c1a60fc2209$var$__decorate([
        (0, $ldzOp.property)(Table._columnsProperty)
    ], Table.prototype, "_columns", void 0);
    $645a8c1a60fc2209$var$__decorate([
        (0, $ldzOp.property)(Table.firstRowAsHeadersProperty)
    ], Table.prototype, "firstRowAsHeaders", void 0);
    $645a8c1a60fc2209$var$__decorate([
        (0, $ldzOp.property)(Table.showGridLinesProperty)
    ], Table.prototype, "showGridLines", void 0);
    $645a8c1a60fc2209$var$__decorate([
        (0, $ldzOp.property)(Table.gridStyleProperty)
    ], Table.prototype, "gridStyle", null);
    $645a8c1a60fc2209$var$__decorate([
        (0, $ldzOp.property)(Table.horizontalCellContentAlignmentProperty)
    ], Table.prototype, "horizontalCellContentAlignment", void 0);
    $645a8c1a60fc2209$var$__decorate([
        (0, $ldzOp.property)(Table.verticalCellContentAlignmentProperty)
    ], Table.prototype, "verticalCellContentAlignment", void 0);
    return Table;
}($645a8c1a60fc2209$var$StylableContainer);
module.exports.Table = $645a8c1a60fc2209$var$Table;
$J4wUi.GlobalRegistry.defaultElements.register("Table", $645a8c1a60fc2209$var$Table, $ldzOp.Versions.v1_5);

});

parcelRequire.register("eL6J6", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ChannelAdapter = void 0;
var $abeaac3af632dbd7$var$ChannelAdapter = /** @class */ function() {
    function ChannelAdapter() {}
    return ChannelAdapter;
}();
module.exports.ChannelAdapter = $abeaac3af632dbd7$var$ChannelAdapter;

});

parcelRequire.register("g3v9p", function(module, exports) {
"use strict";
var $bb051707e8ae5f83$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LoginRequestResponse = module.exports.ErrorResponse = module.exports.SuccessResponse = module.exports.ActivityResponse = module.exports.ActivityRequestError = module.exports.ActivityRequestTrigger = void 0;
var $bb051707e8ae5f83$var$ActivityRequestTrigger;
(function(ActivityRequestTrigger) {
    ActivityRequestTrigger["Automatic"] = "automatic";
    ActivityRequestTrigger["Manual"] = "manual";
})($bb051707e8ae5f83$var$ActivityRequestTrigger = module.exports.ActivityRequestTrigger || (module.exports.ActivityRequestTrigger = {}));
var $bb051707e8ae5f83$var$ActivityRequestError = /** @class */ function() {
    function ActivityRequestError(code, message) {
        this.code = code;
        this.message = message;
    }
    return ActivityRequestError;
}();
module.exports.ActivityRequestError = $bb051707e8ae5f83$var$ActivityRequestError;
var $bb051707e8ae5f83$var$ActivityResponse = /** @class */ function() {
    function ActivityResponse(request) {
        this.request = request;
    }
    return ActivityResponse;
}();
module.exports.ActivityResponse = $bb051707e8ae5f83$var$ActivityResponse;
var $bb051707e8ae5f83$var$SuccessResponse = /** @class */ function(_super) {
    $bb051707e8ae5f83$var$__extends(SuccessResponse, _super);
    function SuccessResponse(request, rawContent) {
        var _this = _super.call(this, request) || this;
        _this.request = request;
        _this.rawContent = rawContent;
        return _this;
    }
    return SuccessResponse;
}($bb051707e8ae5f83$var$ActivityResponse);
module.exports.SuccessResponse = $bb051707e8ae5f83$var$SuccessResponse;
var $bb051707e8ae5f83$var$ErrorResponse = /** @class */ function(_super) {
    $bb051707e8ae5f83$var$__extends(ErrorResponse, _super);
    function ErrorResponse(request, error) {
        var _this = _super.call(this, request) || this;
        _this.request = request;
        _this.error = error;
        return _this;
    }
    return ErrorResponse;
}($bb051707e8ae5f83$var$ActivityResponse);
module.exports.ErrorResponse = $bb051707e8ae5f83$var$ErrorResponse;
var $bb051707e8ae5f83$var$LoginRequestResponse = /** @class */ function(_super) {
    $bb051707e8ae5f83$var$__extends(LoginRequestResponse, _super);
    function LoginRequestResponse(request, auth) {
        var _this = _super.call(this, request) || this;
        _this.request = request;
        _this._auth = auth;
        for(var _i = 0, _a = _this._auth.buttons; _i < _a.length; _i++){
            var button = _a[_i];
            if (button.type === "signin" && button.value !== undefined) try {
                new URL(button.value);
                _this.signinButton = button;
                break;
            } catch (e) {
            // Ignore parsing error
            }
        }
        return _this;
    }
    Object.defineProperty(LoginRequestResponse.prototype, "tokenExchangeResource", {
        get: function() {
            return this._auth.tokenExchangeResource;
        },
        enumerable: false,
        configurable: true
    });
    return LoginRequestResponse;
}($bb051707e8ae5f83$var$ActivityResponse);
module.exports.LoginRequestResponse = $bb051707e8ae5f83$var$LoginRequestResponse;

});

parcelRequire.register("1PnIQ", function(module, exports) {
"use strict";
var $154cf4a17a3968eb$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $154cf4a17a3968eb$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.AdaptiveApplet = void 0;

var $iw5eI = parcelRequire("iw5eI");

var $ioYal = parcelRequire("ioYal");

var $eUh3g = parcelRequire("eUh3g");

var $g3v9p = parcelRequire("g3v9p");

var $brsVB = parcelRequire("brsVB");

var $3K4s0 = parcelRequire("3K4s0");

var $ldzOp = parcelRequire("ldzOp");
function $154cf4a17a3968eb$var$logEvent(level, message) {
    var optionalParams = [];
    for(var _i = 2; _i < arguments.length; _i++)optionalParams[_i - 2] = arguments[_i];
    if ($eUh3g.GlobalSettings.applets.logEnabled) {
        if ($eUh3g.GlobalSettings.applets.onLogEvent) $eUh3g.GlobalSettings.applets.onLogEvent(level, message, optionalParams);
        else /* eslint-disable no-console */ switch(level){
            case $iw5eI.LogLevel.Warning:
                console.warn(message, optionalParams);
                break;
            case $iw5eI.LogLevel.Error:
                console.error(message, optionalParams);
                break;
            default:
                console.log(message, optionalParams);
                break;
        }
    }
}
var $154cf4a17a3968eb$var$ActivityRequest = /** @class */ function() {
    function ActivityRequest(action, trigger, consecutiveRefreshes) {
        this.action = action;
        this.trigger = trigger;
        this.consecutiveRefreshes = consecutiveRefreshes;
        this.attemptNumber = 0;
    }
    // eslint-disable-next-line @typescript-eslint/require-await
    ActivityRequest.prototype.retryAsync = function() {
        return $154cf4a17a3968eb$var$__awaiter(this, void 0, void 0, function() {
            return $154cf4a17a3968eb$var$__generator(this, function(_a) {
                if (this.onSend) this.onSend(this);
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    return ActivityRequest;
}();
var $154cf4a17a3968eb$var$AdaptiveApplet = /** @class */ function() {
    function AdaptiveApplet() {
        this._allowAutomaticCardUpdate = false;
        this.renderedElement = document.createElement("div");
        this.renderedElement.className = "aaf-cardHost";
        this.renderedElement.style.position = "relative";
        this.renderedElement.style.display = "flex";
        this.renderedElement.style.flexDirection = "column";
        this._cardHostElement = document.createElement("div");
        this._refreshButtonHostElement = document.createElement("div");
        this._refreshButtonHostElement.className = "aaf-refreshButtonHost";
        this._refreshButtonHostElement.style.display = "none";
        this.renderedElement.appendChild(this._cardHostElement);
        this.renderedElement.appendChild(this._refreshButtonHostElement);
    }
    AdaptiveApplet.prototype.displayCard = function(card) {
        if (card.renderedElement) {
            $ioYal.clearElementChildren(this._cardHostElement);
            this._refreshButtonHostElement.style.display = "none";
            this._cardHostElement.appendChild(card.renderedElement);
        } else throw new Error("displayCard: undefined card.");
    };
    AdaptiveApplet.prototype.showManualRefreshButton = function(refreshAction) {
        var _this = this;
        var displayBuiltInManualRefreshButton = this.onShowManualRefreshButton ? this.onShowManualRefreshButton(this) : true;
        if (displayBuiltInManualRefreshButton) {
            this._refreshButtonHostElement.style.display = "none";
            var renderedRefreshButton = undefined;
            if (this.onRenderManualRefreshButton) renderedRefreshButton = this.onRenderManualRefreshButton(this);
            else {
                var message = $brsVB.Strings.runtime.refreshThisCard();
                if ($eUh3g.GlobalSettings.applets.refresh.mode === $iw5eI.RefreshMode.Automatic) {
                    var autoRefreshPausedMessage = $brsVB.Strings.runtime.automaticRefreshPaused();
                    if (autoRefreshPausedMessage[autoRefreshPausedMessage.length - 1] !== " ") autoRefreshPausedMessage += " ";
                    message = $brsVB.Strings.runtime.clckToRestartAutomaticRefresh();
                }
                var cardPayload = {
                    type: "AdaptiveCard",
                    version: "1.2",
                    body: [
                        {
                            type: "RichTextBlock",
                            horizontalAlignment: "right",
                            inlines: [
                                {
                                    type: "TextRun",
                                    text: message,
                                    selectAction: {
                                        type: "Action.Submit",
                                        id: "refreshCard"
                                    }
                                }
                            ]
                        }
                    ]
                };
                var card = new $3K4s0.AdaptiveCard();
                card.parse(cardPayload, new $3K4s0.SerializationContext($ldzOp.Versions.v1_2));
                card.onExecuteAction = function(action) {
                    if (action.id === "refreshCard") {
                        $ioYal.clearElementChildren(_this._refreshButtonHostElement);
                        _this.internalExecuteAction(refreshAction, $g3v9p.ActivityRequestTrigger.Automatic, 0);
                    }
                };
                renderedRefreshButton = card.render();
            }
            if (renderedRefreshButton) {
                $ioYal.clearElementChildren(this._refreshButtonHostElement);
                this._refreshButtonHostElement.appendChild(renderedRefreshButton);
                this._refreshButtonHostElement.style.removeProperty("display");
            }
        }
    };
    AdaptiveApplet.prototype.createActivityRequest = function(action, trigger, consecutiveRefreshes) {
        var _this = this;
        if (this.card) {
            var request_1 = new $154cf4a17a3968eb$var$ActivityRequest(action, trigger, consecutiveRefreshes);
            request_1.onSend = function(sender) {
                sender.attemptNumber++;
                _this.internalSendActivityRequestAsync(request_1);
            };
            var cancel = this.onPrepareActivityRequest ? !this.onPrepareActivityRequest(this, request_1, action) : false;
            return cancel ? undefined : request_1;
        } else throw new Error("createActivityRequest: no card has been set.");
    };
    AdaptiveApplet.prototype.createMagicCodeInputCard = function(attemptNumber) {
        var payload = {
            type: "AdaptiveCard",
            version: "1.0",
            body: [
                {
                    type: "TextBlock",
                    color: "attention",
                    text: attemptNumber === 1 ? undefined : "That didn't work... let's try again.",
                    wrap: true,
                    horizontalAlignment: "center"
                },
                {
                    type: "TextBlock",
                    text: 'Please login in the popup. You will obtain a magic code. Paste that code below and select "Submit"',
                    wrap: true,
                    horizontalAlignment: "center"
                },
                {
                    type: "Input.Text",
                    id: "magicCode",
                    placeholder: "Enter magic code"
                },
                {
                    type: "ActionSet",
                    horizontalAlignment: "center",
                    actions: [
                        {
                            type: "Action.Submit",
                            id: AdaptiveApplet._submitMagicCodeActionId,
                            title: "Submit"
                        },
                        {
                            type: "Action.Submit",
                            id: AdaptiveApplet._cancelMagicCodeAuthActionId,
                            title: "Cancel"
                        }
                    ]
                }
            ]
        };
        var card = new $3K4s0.AdaptiveCard();
        card.parse(payload);
        return card;
    };
    AdaptiveApplet.prototype.cancelAutomaticRefresh = function() {
        if (this._allowAutomaticCardUpdate) $154cf4a17a3968eb$var$logEvent($iw5eI.LogLevel.Warning, "Automatic card refresh has been cancelled as a result of the user interacting with the card.");
        this._allowAutomaticCardUpdate = false;
    };
    AdaptiveApplet.prototype.createSerializationContext = function() {
        return this.onCreateSerializationContext ? this.onCreateSerializationContext(this) : new $3K4s0.SerializationContext();
    };
    AdaptiveApplet.prototype.internalSetCard = function(payload, consecutiveRefreshes) {
        var _this = this;
        if (typeof payload === "object" && payload["type"] === "AdaptiveCard") this._cardPayload = payload;
        if (this._cardPayload) try {
            var card = new $3K4s0.AdaptiveCard();
            if (this.hostConfig) card.hostConfig = this.hostConfig;
            var serializationContext = this.createSerializationContext();
            card.parse(this._cardPayload, serializationContext);
            var doChangeCard = this.onCardChanging ? this.onCardChanging(this, this._cardPayload) : true;
            if (doChangeCard) {
                this._card = card;
                if (this._card.authentication && this._card.authentication.tokenExchangeResource && this.onPrefetchSSOToken) this.onPrefetchSSOToken(this, this._card.authentication.tokenExchangeResource);
                this._card.onExecuteAction = function(action) {
                    // If the user takes an action, cancel any pending automatic refresh
                    _this.cancelAutomaticRefresh();
                    _this.internalExecuteAction(action, $g3v9p.ActivityRequestTrigger.Manual, 0);
                };
                this._card.onInputValueChanged = function(_input) {
                    // If the user modifies an input, cancel any pending automatic refresh
                    _this.cancelAutomaticRefresh();
                };
                this._card.render();
                if (this._card.renderedElement) {
                    this.displayCard(this._card);
                    if (this.onCardChanged) this.onCardChanged(this);
                    if (this._card.refresh) {
                        if ($eUh3g.GlobalSettings.applets.refresh.mode === $iw5eI.RefreshMode.Automatic && consecutiveRefreshes < $eUh3g.GlobalSettings.applets.refresh.maximumConsecutiveAutomaticRefreshes) {
                            if ($eUh3g.GlobalSettings.applets.refresh.timeBetweenAutomaticRefreshes <= 0) {
                                $154cf4a17a3968eb$var$logEvent($iw5eI.LogLevel.Info, "Triggering automatic card refresh number " + (consecutiveRefreshes + 1));
                                this.internalExecuteAction(this._card.refresh.action, $g3v9p.ActivityRequestTrigger.Automatic, consecutiveRefreshes + 1);
                            } else {
                                $154cf4a17a3968eb$var$logEvent($iw5eI.LogLevel.Info, "Scheduling automatic card refresh number " + (consecutiveRefreshes + 1) + " in " + $eUh3g.GlobalSettings.applets.refresh.timeBetweenAutomaticRefreshes + "ms");
                                var action_1 = this._card.refresh.action;
                                this._allowAutomaticCardUpdate = true;
                                window.setTimeout(function() {
                                    if (_this._allowAutomaticCardUpdate) _this.internalExecuteAction(action_1, $g3v9p.ActivityRequestTrigger.Automatic, consecutiveRefreshes + 1);
                                }, $eUh3g.GlobalSettings.applets.refresh.timeBetweenAutomaticRefreshes);
                            }
                        } else if ($eUh3g.GlobalSettings.applets.refresh.mode !== $iw5eI.RefreshMode.Disabled) {
                            if (consecutiveRefreshes > 0) $154cf4a17a3968eb$var$logEvent($iw5eI.LogLevel.Warning, "Stopping automatic refreshes after " + consecutiveRefreshes + " consecutive refreshes.");
                            else $154cf4a17a3968eb$var$logEvent($iw5eI.LogLevel.Warning, "The card has a refresh section, but automatic refreshes are disabled.");
                            if ($eUh3g.GlobalSettings.applets.refresh.allowManualRefreshesAfterAutomaticRefreshes || $eUh3g.GlobalSettings.applets.refresh.mode === $iw5eI.RefreshMode.Manual) {
                                $154cf4a17a3968eb$var$logEvent($iw5eI.LogLevel.Info, "Showing manual refresh button.");
                                this.showManualRefreshButton(this._card.refresh.action);
                            }
                        }
                    }
                }
            }
        } catch (error) {
            // Ignore all errors
            $154cf4a17a3968eb$var$logEvent($iw5eI.LogLevel.Error, "setCard: " + error);
        }
    };
    AdaptiveApplet.prototype.internalExecuteAction = function(action, trigger, consecutiveRefreshes) {
        if (action instanceof $3K4s0.ExecuteAction) {
            if (this.channelAdapter) {
                var request = this.createActivityRequest(action, trigger, consecutiveRefreshes);
                if (request) request.retryAsync();
            } else throw new Error("internalExecuteAction: No channel adapter set.");
        }
        if (this.onAction) this.onAction(this, action);
    };
    AdaptiveApplet.prototype.createProgressOverlay = function(request) {
        if (!this._progressOverlay) {
            if (this.onCreateProgressOverlay) this._progressOverlay = this.onCreateProgressOverlay(this, request);
            else {
                this._progressOverlay = document.createElement("div");
                this._progressOverlay.className = "aaf-progress-overlay";
                var spinner = document.createElement("div");
                spinner.className = "aaf-spinner";
                spinner.style.width = "28px";
                spinner.style.height = "28px";
                this._progressOverlay.appendChild(spinner);
            }
        }
        return this._progressOverlay;
    };
    AdaptiveApplet.prototype.removeProgressOverlay = function(request) {
        if (this.onRemoveProgressOverlay) this.onRemoveProgressOverlay(this, request);
        if (this._progressOverlay !== undefined) {
            this.renderedElement.removeChild(this._progressOverlay);
            this._progressOverlay = undefined;
        }
    };
    AdaptiveApplet.prototype.activityRequestSucceeded = function(response, parsedContent) {
        if (this.onActivityRequestSucceeded) this.onActivityRequestSucceeded(this, response, parsedContent);
    };
    AdaptiveApplet.prototype.activityRequestFailed = function(response) {
        return this.onActivityRequestFailed ? this.onActivityRequestFailed(this, response) : $eUh3g.GlobalSettings.applets.defaultTimeBetweenRetryAttempts;
    };
    AdaptiveApplet.prototype.showAuthCodeInputDialog = function(request) {
        var _this = this;
        var showBuiltInAuthCodeInputCard = this.onShowAuthCodeInputDialog ? this.onShowAuthCodeInputDialog(this, request) : true;
        if (showBuiltInAuthCodeInputCard) {
            var authCodeInputCard = this.createMagicCodeInputCard(request.attemptNumber);
            authCodeInputCard.render();
            authCodeInputCard.onExecuteAction = function(submitMagicCodeAction) {
                if (_this.card && submitMagicCodeAction instanceof $3K4s0.SubmitAction) switch(submitMagicCodeAction.id){
                    case AdaptiveApplet._submitMagicCodeActionId:
                        var authCode = undefined;
                        if (submitMagicCodeAction.data && typeof submitMagicCodeAction.data["magicCode"] === "string") authCode = submitMagicCodeAction.data["magicCode"];
                        if (authCode) {
                            _this.displayCard(_this.card);
                            request.authCode = authCode;
                            request.retryAsync();
                        } else alert("Please enter the magic code you received.");
                        break;
                    case AdaptiveApplet._cancelMagicCodeAuthActionId:
                        $154cf4a17a3968eb$var$logEvent($iw5eI.LogLevel.Warning, "Authentication cancelled by user.");
                        _this.displayCard(_this.card);
                        break;
                    default:
                        $154cf4a17a3968eb$var$logEvent($iw5eI.LogLevel.Error, "Unexpected action taken from magic code input card (id = " + submitMagicCodeAction.id + ")");
                        alert($brsVB.Strings.magicCodeInputCard.somethingWentWrong());
                        break;
                }
            };
            this.displayCard(authCodeInputCard);
        }
    };
    AdaptiveApplet.prototype.internalSendActivityRequestAsync = function(request) {
        return $154cf4a17a3968eb$var$__awaiter(this, void 0, void 0, function() {
            var overlay, done, _loop_1, this_1, state_1;
            return $154cf4a17a3968eb$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!this.channelAdapter) throw new Error("internalSendActivityRequestAsync: channelAdapter is not set.");
                        overlay = this.createProgressOverlay(request);
                        if (overlay !== undefined) this.renderedElement.appendChild(overlay);
                        done = false;
                        _loop_1 = function() {
                            var response, error_1, parsedContent, retryIn_1, attemptOAuth, left, top_1;
                            return $154cf4a17a3968eb$var$__generator(this, function(_b) {
                                switch(_b.label){
                                    case 0:
                                        response = undefined;
                                        if (request.attemptNumber === 1) $154cf4a17a3968eb$var$logEvent($iw5eI.LogLevel.Info, "Sending activity request to channel (attempt " + request.attemptNumber + ")");
                                        else $154cf4a17a3968eb$var$logEvent($iw5eI.LogLevel.Info, "Re-sending activity request to channel (attempt " + request.attemptNumber + ")");
                                        _b.label = 1;
                                    case 1:
                                        _b.trys.push([
                                            1,
                                            3,
                                            ,
                                            4
                                        ]);
                                        return [
                                            4 /*yield*/ ,
                                            this_1.channelAdapter.sendRequestAsync(request)
                                        ];
                                    case 2:
                                        response = _b.sent();
                                        return [
                                            3 /*break*/ ,
                                            4
                                        ];
                                    case 3:
                                        error_1 = _b.sent();
                                        $154cf4a17a3968eb$var$logEvent($iw5eI.LogLevel.Error, "Activity request failed: " + error_1);
                                        this_1.removeProgressOverlay(request);
                                        done = true;
                                        return [
                                            3 /*break*/ ,
                                            4
                                        ];
                                    case 4:
                                        if (!response) return [
                                            3 /*break*/ ,
                                            10
                                        ];
                                        if (!(response instanceof $g3v9p.SuccessResponse)) return [
                                            3 /*break*/ ,
                                            5
                                        ];
                                        this_1.removeProgressOverlay(request);
                                        if (response.rawContent === undefined) throw new Error("internalSendActivityRequestAsync: Action.Execute result is undefined");
                                        parsedContent = response.rawContent;
                                        try {
                                            parsedContent = JSON.parse(response.rawContent);
                                        } catch (_c) {
                                        // Leave parseContent as is
                                        }
                                        if (typeof parsedContent === "string") {
                                            $154cf4a17a3968eb$var$logEvent($iw5eI.LogLevel.Info, "The activity request returned a string after " + request.attemptNumber + " attempt(s).");
                                            this_1.activityRequestSucceeded(response, parsedContent);
                                        } else if (typeof parsedContent === "object" && parsedContent["type"] === "AdaptiveCard") {
                                            $154cf4a17a3968eb$var$logEvent($iw5eI.LogLevel.Info, "The activity request returned an Adaptive Card after " + request.attemptNumber + " attempt(s).");
                                            this_1.internalSetCard(parsedContent, request.consecutiveRefreshes);
                                            this_1.activityRequestSucceeded(response, this_1.card);
                                        } else throw new Error("internalSendActivityRequestAsync: Action.Execute result is of unsupported type (" + typeof response.rawContent + ")");
                                        done = true;
                                        return [
                                            3 /*break*/ ,
                                            10
                                        ];
                                    case 5:
                                        if (!(response instanceof $g3v9p.ErrorResponse)) return [
                                            3 /*break*/ ,
                                            9
                                        ];
                                        retryIn_1 = this_1.activityRequestFailed(response);
                                        if (!(retryIn_1 >= 0 && request.attemptNumber < $eUh3g.GlobalSettings.applets.maximumRetryAttempts)) return [
                                            3 /*break*/ ,
                                            7
                                        ];
                                        $154cf4a17a3968eb$var$logEvent($iw5eI.LogLevel.Warning, "Activity request failed: ".concat(response.error.message, ". Retrying in ").concat(retryIn_1, "ms"));
                                        request.attemptNumber++;
                                        return [
                                            4 /*yield*/ ,
                                            new Promise(function(resolve, _reject) {
                                                window.setTimeout(function() {
                                                    resolve();
                                                }, retryIn_1);
                                            })
                                        ];
                                    case 6:
                                        _b.sent();
                                        return [
                                            3 /*break*/ ,
                                            8
                                        ];
                                    case 7:
                                        $154cf4a17a3968eb$var$logEvent($iw5eI.LogLevel.Error, "Activity request failed: ".concat(response.error.message, ". Giving up after ").concat(request.attemptNumber, " attempt(s)"));
                                        this_1.removeProgressOverlay(request);
                                        done = true;
                                        _b.label = 8;
                                    case 8:
                                        return [
                                            3 /*break*/ ,
                                            10
                                        ];
                                    case 9:
                                        if (response instanceof $g3v9p.LoginRequestResponse) {
                                            $154cf4a17a3968eb$var$logEvent($iw5eI.LogLevel.Info, "The activity request returned a LoginRequestResponse after " + request.attemptNumber + " attempt(s).");
                                            if (request.attemptNumber <= $eUh3g.GlobalSettings.applets.maximumRetryAttempts) {
                                                attemptOAuth = true;
                                                if (response.tokenExchangeResource && this_1.onSSOTokenNeeded) // Attempt to use SSO. The host will return true if it can handle SSO, in which case
                                                // we bypass OAuth
                                                attemptOAuth = !this_1.onSSOTokenNeeded(this_1, request, response.tokenExchangeResource);
                                                if (attemptOAuth) {
                                                    // Attempt to use OAuth
                                                    this_1.removeProgressOverlay(request);
                                                    if (response.signinButton === undefined) throw new Error("internalSendActivityRequestAsync: the login request doesn't contain a valid signin URL.");
                                                    $154cf4a17a3968eb$var$logEvent($iw5eI.LogLevel.Info, "Login required at " + response.signinButton.value);
                                                    if (this_1.onShowSigninPrompt) // Bypass the built-in auth prompt if the host app handles it
                                                    this_1.onShowSigninPrompt(this_1, request, response.signinButton);
                                                    else {
                                                        this_1.showAuthCodeInputDialog(request);
                                                        left = window.screenX + (window.outerWidth - $eUh3g.GlobalSettings.applets.authPromptWidth) / 2;
                                                        top_1 = window.screenY + (window.outerHeight - $eUh3g.GlobalSettings.applets.authPromptHeight) / 2;
                                                        window.open(response.signinButton.value, response.signinButton.title ? response.signinButton.title : "Sign in", "width=".concat($eUh3g.GlobalSettings.applets.authPromptWidth, ",height=").concat($eUh3g.GlobalSettings.applets.authPromptHeight, ",left=").concat(left, ",top=").concat(top_1));
                                                    }
                                                }
                                            } else {
                                                $154cf4a17a3968eb$var$logEvent($iw5eI.LogLevel.Error, "Authentication failed. Giving up after " + request.attemptNumber + " attempt(s)");
                                                alert($brsVB.Strings.magicCodeInputCard.authenticationFailed());
                                            }
                                            return [
                                                2 /*return*/ ,
                                                "break"
                                            ];
                                        } else throw new Error("Unhandled response type: " + JSON.stringify(response));
                                        _b.label = 10;
                                    case 10:
                                        return [
                                            2 /*return*/ 
                                        ];
                                }
                            });
                        };
                        this_1 = this;
                        _a.label = 1;
                    case 1:
                        if (!!done) return [
                            3 /*break*/ ,
                            3
                        ];
                        return [
                            5 /*yield**/ ,
                            _loop_1()
                        ];
                    case 2:
                        state_1 = _a.sent();
                        if (state_1 === "break") return [
                            3 /*break*/ ,
                            3
                        ];
                        return [
                            3 /*break*/ ,
                            1
                        ];
                    case 3:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    AdaptiveApplet.prototype.refreshCard = function() {
        if (this._card && this._card.refresh) this.internalExecuteAction(this._card.refresh.action, $g3v9p.ActivityRequestTrigger.Manual, 0);
    };
    AdaptiveApplet.prototype.setCard = function(payload) {
        this.internalSetCard(payload, 0);
    };
    Object.defineProperty(AdaptiveApplet.prototype, "card", {
        get: function() {
            return this._card;
        },
        enumerable: false,
        configurable: true
    });
    AdaptiveApplet._submitMagicCodeActionId = "submitMagicCode";
    AdaptiveApplet._cancelMagicCodeAuthActionId = "cancelMagicCodeAuth";
    return AdaptiveApplet;
}();
module.exports.AdaptiveApplet = $154cf4a17a3968eb$var$AdaptiveApplet;

});





parcelRequire.register("7BYwH", function(module, exports) {
"use strict";

var $luOtD = parcelRequire("luOtD");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $58aaf062fe88c76c$var$_slicedToArray2 = $luOtD((parcelRequire("fhBCP")));

var $fD7D4 = parcelRequire("fD7D4");

var $58aaf062fe88c76c$var$_propTypes = $luOtD((parcelRequire("f7UXb")));

var $58aaf062fe88c76c$var$_react = $luOtD((parcelRequire("eO7Kz")));

var $58aaf062fe88c76c$var$_CommonCard = $luOtD((parcelRequire("6vkD7")));
/* eslint react/no-array-index-key: "off" */ var $58aaf062fe88c76c$var$AudioContent = $fD7D4.Components.AudioContent;
var $58aaf062fe88c76c$var$useStyleSet = $fD7D4.hooks.useStyleSet;
var $58aaf062fe88c76c$var$AudioCardContent = function AudioCardContent(_ref) {
    var actionPerformedClassName = _ref.actionPerformedClassName, content = _ref.content, disabled = _ref.disabled;
    var _useStyleSet = $58aaf062fe88c76c$var$useStyleSet(), _useStyleSet2 = (0, $58aaf062fe88c76c$var$_slicedToArray2.default)(_useStyleSet, 1), audioCardAttachmentStyleSet = _useStyleSet2[0].audioCardAttachment;
    var _content$autostart = content.autostart, autostart = _content$autostart === void 0 ? false : _content$autostart, _content$autoloop = content.autoloop, autoloop = _content$autoloop === void 0 ? false : _content$autoloop, _content$image = content.image;
    _content$image = _content$image === void 0 ? {} : _content$image;
    var _content$image$url = _content$image.url, imageURL = _content$image$url === void 0 ? "" : _content$image$url, _content$media = content.media, media = _content$media === void 0 ? [] : _content$media;
    return /*#__PURE__*/ $58aaf062fe88c76c$var$_react.default.createElement("div", {
        className: audioCardAttachmentStyleSet
    }, /*#__PURE__*/ $58aaf062fe88c76c$var$_react.default.createElement("ul", {
        className: "media-list"
    }, media.map(function(_ref2, index) {
        var url = _ref2.url;
        return /*#__PURE__*/ $58aaf062fe88c76c$var$_react.default.createElement("li", {
            key: index
        }, /*#__PURE__*/ $58aaf062fe88c76c$var$_react.default.createElement($58aaf062fe88c76c$var$AudioContent, {
            autoPlay: autostart,
            loop: autoloop,
            poster: imageURL,
            src: url
        }));
    })), /*#__PURE__*/ $58aaf062fe88c76c$var$_react.default.createElement($58aaf062fe88c76c$var$_CommonCard.default, {
        actionPerformedClassName: actionPerformedClassName,
        content: content,
        disabled: disabled
    }));
};
$58aaf062fe88c76c$var$AudioCardContent.defaultProps = {
    actionPerformedClassName: "",
    disabled: undefined
};
$58aaf062fe88c76c$var$AudioCardContent.propTypes = {
    actionPerformedClassName: $58aaf062fe88c76c$var$_propTypes.default.string,
    // PropTypes cannot fully capture TypeScript types.
    // @ts-ignore
    content: $58aaf062fe88c76c$var$_propTypes.default.shape({
        autostart: $58aaf062fe88c76c$var$_propTypes.default.bool,
        autoloop: $58aaf062fe88c76c$var$_propTypes.default.bool,
        image: $58aaf062fe88c76c$var$_propTypes.default.shape({
            url: $58aaf062fe88c76c$var$_propTypes.default.string.isRequired
        }),
        media: $58aaf062fe88c76c$var$_propTypes.default.arrayOf($58aaf062fe88c76c$var$_propTypes.default.shape({
            url: $58aaf062fe88c76c$var$_propTypes.default.string.isRequired
        }).isRequired).isRequired
    }).isRequired,
    disabled: $58aaf062fe88c76c$var$_propTypes.default.bool
};
var $58aaf062fe88c76c$var$_default = $58aaf062fe88c76c$var$AudioCardContent;
module.exports.default = $58aaf062fe88c76c$var$_default;

});

parcelRequire.register("kgxJb", function(module, exports) {
"use strict";

var $luOtD = parcelRequire("luOtD");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $ec0f76e132e94e26$var$createAdaptiveCardsAttachmentMiddleware;

var $ec0f76e132e94e26$var$_react = $luOtD((parcelRequire("eO7Kz")));

var $ec0f76e132e94e26$var$_AdaptiveCardAttachment = $luOtD((parcelRequire("4942Y")));

var $ec0f76e132e94e26$var$_AnimationCardAttachment = $luOtD((parcelRequire("8Jagv")));

var $ec0f76e132e94e26$var$_AudioCardAttachment = $luOtD((parcelRequire("3Zi14")));

var $ec0f76e132e94e26$var$_HeroCardAttachment = $luOtD((parcelRequire("7GJHI")));

var $ec0f76e132e94e26$var$_OAuthCardAttachment = $luOtD((parcelRequire("2rwLE")));

var $ec0f76e132e94e26$var$_ReceiptCardAttachment = $luOtD((parcelRequire("9aMFh")));

var $ec0f76e132e94e26$var$_SignInCardAttachment = $luOtD((parcelRequire("EyQ1v")));

var $ec0f76e132e94e26$var$_ThumbnailCardAttachment = $luOtD((parcelRequire("71QUT")));

var $ec0f76e132e94e26$var$_VideoCardAttachment = $luOtD((parcelRequire("a4P51")));
function $ec0f76e132e94e26$var$createAdaptiveCardsAttachmentMiddleware() {
    // This is not returning a React component, but a render function.
    return function() {
        return function(next) {
            return function() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                var attachment = args[0].attachment;
                return attachment.contentType === "application/vnd.microsoft.card.hero" ? /*#__PURE__*/ $ec0f76e132e94e26$var$_react.default.createElement($ec0f76e132e94e26$var$_HeroCardAttachment.default, {
                    attachment: attachment
                }) : attachment.contentType === "application/vnd.microsoft.card.adaptive" ? /*#__PURE__*/ $ec0f76e132e94e26$var$_react.default.createElement($ec0f76e132e94e26$var$_AdaptiveCardAttachment.default, {
                    attachment: attachment
                }) : attachment.contentType === "application/vnd.microsoft.card.animation" ? /*#__PURE__*/ $ec0f76e132e94e26$var$_react.default.createElement($ec0f76e132e94e26$var$_AnimationCardAttachment.default, {
                    attachment: attachment
                }) : attachment.contentType === "application/vnd.microsoft.card.audio" ? /*#__PURE__*/ $ec0f76e132e94e26$var$_react.default.createElement($ec0f76e132e94e26$var$_AudioCardAttachment.default, {
                    attachment: attachment
                }) : attachment.contentType === "application/vnd.microsoft.card.oauth" ? /*#__PURE__*/ $ec0f76e132e94e26$var$_react.default.createElement($ec0f76e132e94e26$var$_OAuthCardAttachment.default, {
                    attachment: attachment
                }) : attachment.contentType === "application/vnd.microsoft.card.receipt" ? /*#__PURE__*/ $ec0f76e132e94e26$var$_react.default.createElement($ec0f76e132e94e26$var$_ReceiptCardAttachment.default, {
                    attachment: attachment
                }) : attachment.contentType === "application/vnd.microsoft.card.signin" ? /*#__PURE__*/ $ec0f76e132e94e26$var$_react.default.createElement($ec0f76e132e94e26$var$_SignInCardAttachment.default, {
                    attachment: attachment
                }) : attachment.contentType === "application/vnd.microsoft.card.thumbnail" ? /*#__PURE__*/ $ec0f76e132e94e26$var$_react.default.createElement($ec0f76e132e94e26$var$_ThumbnailCardAttachment.default, {
                    attachment: attachment
                }) : attachment.contentType === "application/vnd.microsoft.card.video" ? /*#__PURE__*/ $ec0f76e132e94e26$var$_react.default.createElement($ec0f76e132e94e26$var$_VideoCardAttachment.default, {
                    attachment: attachment
                }) : next.apply(void 0, args);
            };
        };
    };
}

});
parcelRequire.register("4942Y", function(module, exports) {
"use strict";

var $luOtD = parcelRequire("luOtD");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $304b24585ac607c5$var$_propTypes = $luOtD((parcelRequire("f7UXb")));

var $304b24585ac607c5$var$_react = $luOtD((parcelRequire("eO7Kz")));

var $304b24585ac607c5$var$_AdaptiveCardContent = $luOtD((parcelRequire("f0Leo")));
var $304b24585ac607c5$var$AdaptiveCardAttachment = function AdaptiveCardAttachment(_ref) {
    var content = _ref.attachment.content, disabled = _ref.disabled;
    return /*#__PURE__*/ $304b24585ac607c5$var$_react.default.createElement($304b24585ac607c5$var$_AdaptiveCardContent.default, {
        content: content,
        disabled: disabled
    });
};
var $304b24585ac607c5$var$_default = $304b24585ac607c5$var$AdaptiveCardAttachment;
module.exports.default = $304b24585ac607c5$var$_default;
$304b24585ac607c5$var$AdaptiveCardAttachment.defaultProps = {
    disabled: undefined
};
$304b24585ac607c5$var$AdaptiveCardAttachment.propTypes = {
    // PropTypes cannot fully capture TypeScript types.
    // @ts-ignore
    attachment: $304b24585ac607c5$var$_propTypes.default.shape({
        content: $304b24585ac607c5$var$_propTypes.default.any.isRequired
    }).isRequired,
    disabled: $304b24585ac607c5$var$_propTypes.default.bool
};

});

parcelRequire.register("8Jagv", function(module, exports) {
"use strict";

var $luOtD = parcelRequire("luOtD");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $65aa7d2c1e22c592$var$_propTypes = $luOtD((parcelRequire("f7UXb")));

var $65aa7d2c1e22c592$var$_react = $luOtD((parcelRequire("eO7Kz")));

var $65aa7d2c1e22c592$var$_AnimationCardContent = $luOtD((parcelRequire("6PqZf")));
var $65aa7d2c1e22c592$var$AnimationCardAttachment = function AnimationCardAttachment(_ref) {
    var content = _ref.attachment.content, disabled = _ref.disabled;
    return /*#__PURE__*/ $65aa7d2c1e22c592$var$_react.default.createElement($65aa7d2c1e22c592$var$_AnimationCardContent.default, {
        content: content,
        disabled: disabled
    });
};
$65aa7d2c1e22c592$var$AnimationCardAttachment.defaultProps = {
    disabled: undefined
};
$65aa7d2c1e22c592$var$AnimationCardAttachment.propTypes = {
    attachment: $65aa7d2c1e22c592$var$_propTypes.default.shape({
        content: $65aa7d2c1e22c592$var$_propTypes.default.shape({
            media: $65aa7d2c1e22c592$var$_propTypes.default.arrayOf($65aa7d2c1e22c592$var$_propTypes.default.shape({
                profile: $65aa7d2c1e22c592$var$_propTypes.default.string,
                url: $65aa7d2c1e22c592$var$_propTypes.default.string.isRequired
            })).isRequired
        }).isRequired
    }).isRequired,
    disabled: $65aa7d2c1e22c592$var$_propTypes.default.bool
};
var $65aa7d2c1e22c592$var$_default = $65aa7d2c1e22c592$var$AnimationCardAttachment;
module.exports.default = $65aa7d2c1e22c592$var$_default;

});

parcelRequire.register("3Zi14", function(module, exports) {
"use strict";

var $luOtD = parcelRequire("luOtD");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2e750b433962a879$var$_propTypes = $luOtD((parcelRequire("f7UXb")));

var $2e750b433962a879$var$_react = $luOtD((parcelRequire("eO7Kz")));

var $2e750b433962a879$var$_AudioCardContent = $luOtD((parcelRequire("7BYwH")));
/* eslint react/no-array-index-key: "off" */ var $2e750b433962a879$var$AudioCardAttachment = function AudioCardAttachment(_ref) {
    var content = _ref.attachment.content, disabled = _ref.disabled;
    return /*#__PURE__*/ $2e750b433962a879$var$_react.default.createElement($2e750b433962a879$var$_AudioCardContent.default, {
        content: content,
        disabled: disabled
    });
};
$2e750b433962a879$var$AudioCardAttachment.defaultProps = {
    disabled: undefined
};
$2e750b433962a879$var$AudioCardAttachment.propTypes = {
    attachment: $2e750b433962a879$var$_propTypes.default.shape({
        content: $2e750b433962a879$var$_propTypes.default.shape({
            autostart: $2e750b433962a879$var$_propTypes.default.bool,
            autoloop: $2e750b433962a879$var$_propTypes.default.bool,
            image: $2e750b433962a879$var$_propTypes.default.shape({
                url: $2e750b433962a879$var$_propTypes.default.string.isRequired
            }),
            media: $2e750b433962a879$var$_propTypes.default.arrayOf($2e750b433962a879$var$_propTypes.default.shape({
                url: $2e750b433962a879$var$_propTypes.default.string.isRequired
            }).isRequired).isRequired
        })
    }).isRequired,
    disabled: $2e750b433962a879$var$_propTypes.default.bool
};
var $2e750b433962a879$var$_default = $2e750b433962a879$var$AudioCardAttachment;
module.exports.default = $2e750b433962a879$var$_default;

});

parcelRequire.register("7GJHI", function(module, exports) {
"use strict";

var $luOtD = parcelRequire("luOtD");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $598fe887da3b2571$var$_propTypes = $luOtD((parcelRequire("f7UXb")));

var $598fe887da3b2571$var$_react = $luOtD((parcelRequire("eO7Kz")));

var $598fe887da3b2571$var$_HeroCardContent = $luOtD((parcelRequire("qVAKz")));
var $598fe887da3b2571$var$HeroCardAttachment = function HeroCardAttachment(_ref) {
    var _ref$attachment = _ref.attachment;
    _ref$attachment = _ref$attachment === void 0 ? {} : _ref$attachment;
    var content = _ref$attachment.content, disabled = _ref.disabled;
    return !!content && /*#__PURE__*/ $598fe887da3b2571$var$_react.default.createElement($598fe887da3b2571$var$_HeroCardContent.default, {
        content: content,
        disabled: disabled
    });
};
$598fe887da3b2571$var$HeroCardAttachment.defaultProps = {
    disabled: undefined
};
$598fe887da3b2571$var$HeroCardAttachment.propTypes = {
    attachment: $598fe887da3b2571$var$_propTypes.default.shape({
        content: $598fe887da3b2571$var$_propTypes.default.shape({
            buttons: $598fe887da3b2571$var$_propTypes.default.any,
            images: $598fe887da3b2571$var$_propTypes.default.arrayOf($598fe887da3b2571$var$_propTypes.default.shape({
                alt: $598fe887da3b2571$var$_propTypes.default.string,
                tap: $598fe887da3b2571$var$_propTypes.default.any,
                url: $598fe887da3b2571$var$_propTypes.default.string.isRequired
            })),
            subtitle: $598fe887da3b2571$var$_propTypes.default.string,
            tap: $598fe887da3b2571$var$_propTypes.default.any,
            text: $598fe887da3b2571$var$_propTypes.default.string,
            title: $598fe887da3b2571$var$_propTypes.default.string
        }).isRequired
    }).isRequired,
    disabled: $598fe887da3b2571$var$_propTypes.default.bool
};
var $598fe887da3b2571$var$_default = $598fe887da3b2571$var$HeroCardAttachment;
module.exports.default = $598fe887da3b2571$var$_default;

});
parcelRequire.register("qVAKz", function(module, exports) {
"use strict";

var $luOtD = parcelRequire("luOtD");

var $2PxO1 = parcelRequire("2PxO1");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $050f1a57f35c1511$var$_slicedToArray2 = $luOtD((parcelRequire("fhBCP")));

var $fD7D4 = parcelRequire("fD7D4");

var $050f1a57f35c1511$var$_propTypes = $luOtD((parcelRequire("f7UXb")));

var $050f1a57f35c1511$var$_react = $050f1a57f35c1511$var$_interopRequireWildcard((parcelRequire("eO7Kz")));

var $050f1a57f35c1511$var$_AdaptiveCardBuilder = $luOtD((parcelRequire("dUIqS")));

var $050f1a57f35c1511$var$_AdaptiveCardRenderer = $luOtD((parcelRequire("7qmwG")));

var $050f1a57f35c1511$var$_useAdaptiveCardsPackage = $luOtD((parcelRequire("fdwbc")));

var $050f1a57f35c1511$var$_useStyleOptions3 = $luOtD((parcelRequire("gwtqY")));
function $050f1a57f35c1511$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($050f1a57f35c1511$var$_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $050f1a57f35c1511$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || $2PxO1(obj) !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $050f1a57f35c1511$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
var $050f1a57f35c1511$var$useDirection = $fD7D4.hooks.useDirection;
var $050f1a57f35c1511$var$HeroCardContent = function HeroCardContent(_ref) {
    var actionPerformedClassName = _ref.actionPerformedClassName, content = _ref.content, disabled = _ref.disabled;
    var _useAdaptiveCardsPack = (0, $050f1a57f35c1511$var$_useAdaptiveCardsPackage.default)(), _useAdaptiveCardsPack2 = (0, $050f1a57f35c1511$var$_slicedToArray2.default)(_useAdaptiveCardsPack, 1), adaptiveCardsPackage = _useAdaptiveCardsPack2[0];
    var _useStyleOptions = (0, $050f1a57f35c1511$var$_useStyleOptions3.default)(), _useStyleOptions2 = (0, $050f1a57f35c1511$var$_slicedToArray2.default)(_useStyleOptions, 1), styleOptions = _useStyleOptions2[0];
    var _useDirection = $050f1a57f35c1511$var$useDirection(), _useDirection2 = (0, $050f1a57f35c1511$var$_slicedToArray2.default)(_useDirection, 1), direction = _useDirection2[0];
    var builtCard = (0, $050f1a57f35c1511$var$_react.useMemo)(function() {
        var builder = new $050f1a57f35c1511$var$_AdaptiveCardBuilder.default(adaptiveCardsPackage, styleOptions, direction);
        if (content) {
            (content.images || []).forEach(function(image) {
                return builder.addImage(image.url, null, image.tap, image.alt);
            });
            builder.addCommon(content);
            return builder.card;
        }
    }, [
        adaptiveCardsPackage,
        content,
        direction,
        styleOptions
    ]);
    return /*#__PURE__*/ $050f1a57f35c1511$var$_react.default.createElement($050f1a57f35c1511$var$_AdaptiveCardRenderer.default, {
        actionPerformedClassName: actionPerformedClassName,
        adaptiveCard: builtCard,
        disabled: disabled,
        tapAction: content && content.tap
    });
};
$050f1a57f35c1511$var$HeroCardContent.defaultProps = {
    actionPerformedClassName: "",
    disabled: undefined
};
$050f1a57f35c1511$var$HeroCardContent.propTypes = {
    actionPerformedClassName: $050f1a57f35c1511$var$_propTypes.default.string,
    // PropTypes cannot fully capture TypeScript types.
    // @ts-ignore
    content: $050f1a57f35c1511$var$_propTypes.default.shape({
        images: $050f1a57f35c1511$var$_propTypes.default.arrayOf($050f1a57f35c1511$var$_propTypes.default.shape({
            alt: $050f1a57f35c1511$var$_propTypes.default.string.isRequired,
            tap: $050f1a57f35c1511$var$_propTypes.default.any,
            url: $050f1a57f35c1511$var$_propTypes.default.string.isRequired
        })),
        tap: $050f1a57f35c1511$var$_propTypes.default.any
    }).isRequired,
    disabled: $050f1a57f35c1511$var$_propTypes.default.bool
};
var $050f1a57f35c1511$var$_default = $050f1a57f35c1511$var$HeroCardContent;
module.exports.default = $050f1a57f35c1511$var$_default;

});


parcelRequire.register("2rwLE", function(module, exports) {
"use strict";

var $luOtD = parcelRequire("luOtD");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1c778552be1bb7b1$var$_propTypes = $luOtD((parcelRequire("f7UXb")));

var $1c778552be1bb7b1$var$_react = $luOtD((parcelRequire("eO7Kz")));

var $1c778552be1bb7b1$var$_OAuthCardContent = $luOtD((parcelRequire("eEDa4")));
var $1c778552be1bb7b1$var$OAuthCardAttachment = function OAuthCardAttachment(_ref) {
    var _ref$attachment = _ref.attachment;
    _ref$attachment = _ref$attachment === void 0 ? {} : _ref$attachment;
    var content = _ref$attachment.content, disabled = _ref.disabled;
    return /*#__PURE__*/ $1c778552be1bb7b1$var$_react.default.createElement($1c778552be1bb7b1$var$_OAuthCardContent.default, {
        content: content,
        disabled: disabled
    });
};
$1c778552be1bb7b1$var$OAuthCardAttachment.defaultProps = {
    disabled: undefined
};
$1c778552be1bb7b1$var$OAuthCardAttachment.propTypes = {
    attachment: $1c778552be1bb7b1$var$_propTypes.default.shape({
        content: $1c778552be1bb7b1$var$_propTypes.default.shape({
            buttons: $1c778552be1bb7b1$var$_propTypes.default.array
        }).isRequired
    }).isRequired,
    disabled: $1c778552be1bb7b1$var$_propTypes.default.bool
};
var $1c778552be1bb7b1$var$_default = $1c778552be1bb7b1$var$OAuthCardAttachment;
module.exports.default = $1c778552be1bb7b1$var$_default;

});
parcelRequire.register("eEDa4", function(module, exports) {
"use strict";

var $luOtD = parcelRequire("luOtD");

var $2PxO1 = parcelRequire("2PxO1");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $aab32dc1db515039$var$_slicedToArray2 = $luOtD((parcelRequire("fhBCP")));

var $fD7D4 = parcelRequire("fD7D4");

var $aab32dc1db515039$var$_propTypes = $luOtD((parcelRequire("f7UXb")));

var $aab32dc1db515039$var$_react = $aab32dc1db515039$var$_interopRequireWildcard((parcelRequire("eO7Kz")));

var $aab32dc1db515039$var$_AdaptiveCardBuilder = $luOtD((parcelRequire("dUIqS")));

var $aab32dc1db515039$var$_AdaptiveCardRenderer = $luOtD((parcelRequire("7qmwG")));

var $aab32dc1db515039$var$_useAdaptiveCardsPackage = $luOtD((parcelRequire("fdwbc")));

var $aab32dc1db515039$var$_useStyleOptions3 = $luOtD((parcelRequire("gwtqY")));
function $aab32dc1db515039$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($aab32dc1db515039$var$_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $aab32dc1db515039$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || $2PxO1(obj) !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $aab32dc1db515039$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
var $aab32dc1db515039$var$useDirection = $fD7D4.hooks.useDirection;
var $aab32dc1db515039$var$OAuthCardContent = function OAuthCardContent(_ref) {
    var actionPerformedClassName = _ref.actionPerformedClassName, content = _ref.content, disabled = _ref.disabled;
    var _useAdaptiveCardsPack = (0, $aab32dc1db515039$var$_useAdaptiveCardsPackage.default)(), _useAdaptiveCardsPack2 = (0, $aab32dc1db515039$var$_slicedToArray2.default)(_useAdaptiveCardsPack, 1), adaptiveCardsPackage = _useAdaptiveCardsPack2[0];
    var _useDirection = $aab32dc1db515039$var$useDirection(), _useDirection2 = (0, $aab32dc1db515039$var$_slicedToArray2.default)(_useDirection, 1), direction = _useDirection2[0];
    var _useStyleOptions = (0, $aab32dc1db515039$var$_useStyleOptions3.default)(), _useStyleOptions2 = (0, $aab32dc1db515039$var$_slicedToArray2.default)(_useStyleOptions, 1), styleOptions = _useStyleOptions2[0];
    var builtCard = (0, $aab32dc1db515039$var$_react.useMemo)(function() {
        if (content) {
            var builder = new $aab32dc1db515039$var$_AdaptiveCardBuilder.default(adaptiveCardsPackage, styleOptions, direction);
            builder.addCommonHeaders(content);
            builder.addButtons(content.buttons, true);
            return builder.card;
        }
    }, [
        adaptiveCardsPackage,
        content,
        direction,
        styleOptions
    ]);
    return /*#__PURE__*/ $aab32dc1db515039$var$_react.default.createElement($aab32dc1db515039$var$_AdaptiveCardRenderer.default, {
        actionPerformedClassName: actionPerformedClassName,
        adaptiveCard: builtCard,
        disabled: disabled
    });
};
$aab32dc1db515039$var$OAuthCardContent.defaultProps = {
    actionPerformedClassName: "",
    disabled: undefined
};
$aab32dc1db515039$var$OAuthCardContent.propTypes = {
    actionPerformedClassName: $aab32dc1db515039$var$_propTypes.default.string,
    // PropTypes cannot fully capture TypeScript types.
    // @ts-ignore
    content: $aab32dc1db515039$var$_propTypes.default.shape({
        buttons: $aab32dc1db515039$var$_propTypes.default.array
    }).isRequired,
    disabled: $aab32dc1db515039$var$_propTypes.default.bool
};
var $aab32dc1db515039$var$_default = $aab32dc1db515039$var$OAuthCardContent;
module.exports.default = $aab32dc1db515039$var$_default;

});


parcelRequire.register("9aMFh", function(module, exports) {
"use strict";

var $luOtD = parcelRequire("luOtD");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6adacc08f939e74d$var$_propTypes = $luOtD((parcelRequire("f7UXb")));

var $6adacc08f939e74d$var$_react = $luOtD((parcelRequire("eO7Kz")));

var $6adacc08f939e74d$var$_ReceiptCardContent = $luOtD((parcelRequire("lUOAR")));
var $6adacc08f939e74d$var$ReceiptCardAttachment = function ReceiptCardAttachment(_ref) {
    var content = _ref.attachment.content, disabled = _ref.disabled;
    return /*#__PURE__*/ $6adacc08f939e74d$var$_react.default.createElement($6adacc08f939e74d$var$_ReceiptCardContent.default, {
        content: content,
        disabled: disabled
    });
};
$6adacc08f939e74d$var$ReceiptCardAttachment.defaultProps = {
    disabled: undefined
};
$6adacc08f939e74d$var$ReceiptCardAttachment.propTypes = {
    attachment: $6adacc08f939e74d$var$_propTypes.default.shape({
        content: $6adacc08f939e74d$var$_propTypes.default.shape({
            buttons: $6adacc08f939e74d$var$_propTypes.default.array,
            facts: $6adacc08f939e74d$var$_propTypes.default.arrayOf($6adacc08f939e74d$var$_propTypes.default.shape({
                key: $6adacc08f939e74d$var$_propTypes.default.string,
                value: $6adacc08f939e74d$var$_propTypes.default.string
            })),
            items: $6adacc08f939e74d$var$_propTypes.default.arrayOf($6adacc08f939e74d$var$_propTypes.default.shape({
                image: $6adacc08f939e74d$var$_propTypes.default.shape({
                    alt: $6adacc08f939e74d$var$_propTypes.default.string.isRequired,
                    tap: $6adacc08f939e74d$var$_propTypes.default.any,
                    url: $6adacc08f939e74d$var$_propTypes.default.string.isRequired
                }),
                price: $6adacc08f939e74d$var$_propTypes.default.string.isRequired,
                quantity: $6adacc08f939e74d$var$_propTypes.default.string,
                subtitle: $6adacc08f939e74d$var$_propTypes.default.string,
                tap: $6adacc08f939e74d$var$_propTypes.default.any,
                text: $6adacc08f939e74d$var$_propTypes.default.string,
                title: $6adacc08f939e74d$var$_propTypes.default.string.isRequired
            })),
            tap: $6adacc08f939e74d$var$_propTypes.default.any,
            tax: $6adacc08f939e74d$var$_propTypes.default.string,
            title: $6adacc08f939e74d$var$_propTypes.default.string,
            total: $6adacc08f939e74d$var$_propTypes.default.string,
            vat: $6adacc08f939e74d$var$_propTypes.default.string
        }).isRequired
    }).isRequired,
    disabled: $6adacc08f939e74d$var$_propTypes.default.bool
};
var $6adacc08f939e74d$var$_default = $6adacc08f939e74d$var$ReceiptCardAttachment;
module.exports.default = $6adacc08f939e74d$var$_default;

});
parcelRequire.register("lUOAR", function(module, exports) {
"use strict";

var $luOtD = parcelRequire("luOtD");

var $2PxO1 = parcelRequire("2PxO1");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ff4612bd51ffa099$var$_toArray2 = $luOtD((parcelRequire("1qudV")));

var $ff4612bd51ffa099$var$_slicedToArray2 = $luOtD((parcelRequire("fhBCP")));

var $fD7D4 = parcelRequire("fD7D4");

var $ff4612bd51ffa099$var$_propTypes = $luOtD((parcelRequire("f7UXb")));

var $ff4612bd51ffa099$var$_react = $ff4612bd51ffa099$var$_interopRequireWildcard((parcelRequire("eO7Kz")));

var $ff4612bd51ffa099$var$_AdaptiveCardBuilder = $luOtD((parcelRequire("dUIqS")));

var $ff4612bd51ffa099$var$_AdaptiveCardRenderer = $luOtD((parcelRequire("7qmwG")));

var $ff4612bd51ffa099$var$_useAdaptiveCardsPackage = $luOtD((parcelRequire("fdwbc")));

var $ff4612bd51ffa099$var$_useStyleOptions3 = $luOtD((parcelRequire("gwtqY")));
function $ff4612bd51ffa099$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($ff4612bd51ffa099$var$_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $ff4612bd51ffa099$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || $2PxO1(obj) !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $ff4612bd51ffa099$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
/* eslint no-magic-numbers: ["error", { "ignore": [0, 1, 10, 15, 25, 50, 75] }] */ var $ff4612bd51ffa099$var$useDirection = $fD7D4.hooks.useDirection, $ff4612bd51ffa099$var$useLocalizer = $fD7D4.hooks.useLocalizer;
function $ff4612bd51ffa099$var$nullOrUndefined(obj) {
    return obj === null || typeof obj === "undefined";
}
var $ff4612bd51ffa099$var$ReceiptCardContent = function ReceiptCardContent(_ref) {
    var actionPerformedClassName = _ref.actionPerformedClassName, content = _ref.content, disabled = _ref.disabled;
    var _useAdaptiveCardsPack = (0, $ff4612bd51ffa099$var$_useAdaptiveCardsPackage.default)(), _useAdaptiveCardsPack2 = (0, $ff4612bd51ffa099$var$_slicedToArray2.default)(_useAdaptiveCardsPack, 1), adaptiveCardsPackage = _useAdaptiveCardsPack2[0];
    var _useDirection = $ff4612bd51ffa099$var$useDirection(), _useDirection2 = (0, $ff4612bd51ffa099$var$_slicedToArray2.default)(_useDirection, 1), direction = _useDirection2[0];
    var _useStyleOptions = (0, $ff4612bd51ffa099$var$_useStyleOptions3.default)(), _useStyleOptions2 = (0, $ff4612bd51ffa099$var$_slicedToArray2.default)(_useStyleOptions, 1), styleOptions = _useStyleOptions2[0];
    var localize = $ff4612bd51ffa099$var$useLocalizer();
    var taxText = localize("RECEIPT_CARD_TAX");
    var totalText = localize("RECEIPT_CARD_TOTAL");
    var vatText = localize("RECEIPT_CARD_VAT");
    var builtCard = (0, $ff4612bd51ffa099$var$_react.useMemo)(function() {
        var builder = new $ff4612bd51ffa099$var$_AdaptiveCardBuilder.default(adaptiveCardsPackage, styleOptions, direction);
        var HorizontalAlignment = adaptiveCardsPackage.HorizontalAlignment, TextSize = adaptiveCardsPackage.TextSize, TextWeight = adaptiveCardsPackage.TextWeight;
        var buttons = content.buttons, facts = content.facts, items = content.items, tax = content.tax, title = content.title, total = content.total, vat = content.vat;
        var richCardWrapTitle = styleOptions.richCardWrapTitle;
        if (content) {
            builder.addTextBlock(title, {
                size: TextSize.Medium,
                weight: TextWeight.Bolder,
                wrap: richCardWrapTitle
            });
            if (facts) {
                var _builder$addColumnSet = builder.addColumnSet([
                    75,
                    25
                ]), _builder$addColumnSet2 = (0, $ff4612bd51ffa099$var$_slicedToArray2.default)(_builder$addColumnSet, 2), firstFactColumn = _builder$addColumnSet2[0], lastFactColumn = _builder$addColumnSet2[1];
                facts.map(function(_ref2) {
                    var key = _ref2.key, value = _ref2.value;
                    builder.addTextBlock(key, {
                        size: TextSize.Medium
                    }, firstFactColumn);
                    builder.addTextBlock(value, {
                        size: TextSize.Medium,
                        horizontalAlignment: HorizontalAlignment.Right
                    }, lastFactColumn);
                });
            }
            items && items.map(function(_ref3) {
                var _ref3$image = _ref3.image;
                _ref3$image = _ref3$image === void 0 ? {} : _ref3$image;
                var alt = _ref3$image.alt, imageTap = _ref3$image.tap, url = _ref3$image.url, price = _ref3.price, quantity = _ref3.quantity, subtitle = _ref3.subtitle, tap = _ref3.tap, text = _ref3.text, title = _ref3.title;
                var itemColumns;
                if (url) {
                    var _builder$addColumnSet3 = builder.addColumnSet([
                        15,
                        75,
                        10
                    ]), _builder$addColumnSet4 = (0, $ff4612bd51ffa099$var$_toArray2.default)(_builder$addColumnSet3), itemImageColumn = _builder$addColumnSet4[0], columns = _builder$addColumnSet4.slice(1);
                    itemColumns = columns;
                    builder.addImage(url, itemImageColumn, imageTap, alt);
                } else itemColumns = builder.addColumnSet([
                    75,
                    25
                ], undefined, tap && tap);
                var _itemColumns = itemColumns, _itemColumns2 = (0, $ff4612bd51ffa099$var$_slicedToArray2.default)(_itemColumns, 2), itemTitleColumn = _itemColumns2[0], itemPriceColumn = _itemColumns2[1];
                builder.addTextBlock(quantity ? "".concat(title, " &times; ").concat(quantity) : title, {
                    size: TextSize.Medium,
                    weight: TextWeight.Bolder,
                    wrap: richCardWrapTitle
                }, itemTitleColumn);
                builder.addTextBlock(subtitle, {
                    size: TextSize.Medium,
                    wrap: richCardWrapTitle
                }, itemTitleColumn);
                builder.addTextBlock(price, {
                    horizontalAlignment: HorizontalAlignment.Right
                }, itemPriceColumn);
                if (text) builder.addTextBlock(text, {
                    size: TextSize.Medium,
                    wrap: richCardWrapTitle
                }, itemTitleColumn);
            });
            if (!$ff4612bd51ffa099$var$nullOrUndefined(vat)) {
                var vatCol = builder.addColumnSet([
                    75,
                    25
                ]);
                builder.addTextBlock(vatText, {
                    size: TextSize.Medium,
                    weight: TextWeight.Bolder
                }, vatCol[0]);
                builder.addTextBlock(vat, {
                    horizontalAlignment: HorizontalAlignment.Right
                }, vatCol[1]);
            }
            if (!$ff4612bd51ffa099$var$nullOrUndefined(tax)) {
                var taxCol = builder.addColumnSet([
                    75,
                    25
                ]);
                builder.addTextBlock(taxText, {
                    size: TextSize.Medium,
                    weight: TextWeight.Bolder
                }, taxCol[0]);
                builder.addTextBlock(tax, {
                    horizontalAlignment: HorizontalAlignment.Right
                }, taxCol[1]);
            }
            if (!$ff4612bd51ffa099$var$nullOrUndefined(total)) {
                var totalCol = builder.addColumnSet([
                    75,
                    25
                ]);
                builder.addTextBlock(totalText, {
                    size: TextSize.Medium,
                    weight: TextWeight.Bolder
                }, totalCol[0]);
                builder.addTextBlock(total, {
                    horizontalAlignment: HorizontalAlignment.Right,
                    size: TextSize.Medium,
                    weight: TextWeight.Bolder
                }, totalCol[1]);
            }
            builder.addButtons(buttons);
            return builder.card;
        }
    }, [
        adaptiveCardsPackage,
        content,
        direction,
        styleOptions,
        taxText,
        totalText,
        vatText
    ]);
    return /*#__PURE__*/ $ff4612bd51ffa099$var$_react.default.createElement($ff4612bd51ffa099$var$_AdaptiveCardRenderer.default, {
        actionPerformedClassName: actionPerformedClassName,
        adaptiveCard: builtCard,
        disabled: disabled,
        tapAction: content && content.tap
    });
};
$ff4612bd51ffa099$var$ReceiptCardContent.defaultProps = {
    actionPerformedClassName: "",
    disabled: undefined
};
$ff4612bd51ffa099$var$ReceiptCardContent.propTypes = {
    actionPerformedClassName: $ff4612bd51ffa099$var$_propTypes.default.string,
    // PropTypes cannot fully capture TypeScript types.
    // @ts-ignore
    content: $ff4612bd51ffa099$var$_propTypes.default.shape({
        buttons: $ff4612bd51ffa099$var$_propTypes.default.array,
        facts: $ff4612bd51ffa099$var$_propTypes.default.arrayOf($ff4612bd51ffa099$var$_propTypes.default.shape({
            key: $ff4612bd51ffa099$var$_propTypes.default.string,
            value: $ff4612bd51ffa099$var$_propTypes.default.string
        })),
        items: $ff4612bd51ffa099$var$_propTypes.default.arrayOf($ff4612bd51ffa099$var$_propTypes.default.shape({
            image: $ff4612bd51ffa099$var$_propTypes.default.shape({
                alt: $ff4612bd51ffa099$var$_propTypes.default.string.isRequired,
                tap: $ff4612bd51ffa099$var$_propTypes.default.any,
                url: $ff4612bd51ffa099$var$_propTypes.default.string.isRequired
            }),
            price: $ff4612bd51ffa099$var$_propTypes.default.string.isRequired,
            quantity: $ff4612bd51ffa099$var$_propTypes.default.string,
            subtitle: $ff4612bd51ffa099$var$_propTypes.default.string,
            tap: $ff4612bd51ffa099$var$_propTypes.default.any,
            text: $ff4612bd51ffa099$var$_propTypes.default.string,
            title: $ff4612bd51ffa099$var$_propTypes.default.string.isRequired
        })),
        tap: $ff4612bd51ffa099$var$_propTypes.default.any,
        tax: $ff4612bd51ffa099$var$_propTypes.default.string,
        title: $ff4612bd51ffa099$var$_propTypes.default.string,
        total: $ff4612bd51ffa099$var$_propTypes.default.string,
        vat: $ff4612bd51ffa099$var$_propTypes.default.string
    }).isRequired,
    disabled: $ff4612bd51ffa099$var$_propTypes.default.bool
};
var $ff4612bd51ffa099$var$_default = $ff4612bd51ffa099$var$ReceiptCardContent;
module.exports.default = $ff4612bd51ffa099$var$_default;

});
parcelRequire.register("1qudV", function(module, exports) {

var $h9WXo = parcelRequire("h9WXo");

var $16F5a = parcelRequire("16F5a");

var $ieyTF = parcelRequire("ieyTF");

var $cNv2e = parcelRequire("cNv2e");
function $109fa9ea1b869750$var$_toArray(arr) {
    return $h9WXo(arr) || $16F5a(arr) || $ieyTF(arr) || $cNv2e();
}
module.exports = $109fa9ea1b869750$var$_toArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});



parcelRequire.register("EyQ1v", function(module, exports) {
"use strict";

var $luOtD = parcelRequire("luOtD");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $079ec2a8d1ffe1e2$var$_propTypes = $luOtD((parcelRequire("f7UXb")));

var $079ec2a8d1ffe1e2$var$_react = $luOtD((parcelRequire("eO7Kz")));

var $079ec2a8d1ffe1e2$var$_SignInCardContent = $luOtD((parcelRequire("idxQs")));
var $079ec2a8d1ffe1e2$var$SignInCardAttachment = function SignInCardAttachment(_ref) {
    var content = _ref.attachment.content, disabled = _ref.disabled;
    return /*#__PURE__*/ $079ec2a8d1ffe1e2$var$_react.default.createElement($079ec2a8d1ffe1e2$var$_SignInCardContent.default, {
        content: content,
        disabled: disabled
    });
};
$079ec2a8d1ffe1e2$var$SignInCardAttachment.defaultProps = {
    disabled: undefined
};
$079ec2a8d1ffe1e2$var$SignInCardAttachment.propTypes = {
    attachment: $079ec2a8d1ffe1e2$var$_propTypes.default.shape({
        content: $079ec2a8d1ffe1e2$var$_propTypes.default.any.isRequired
    }).isRequired,
    disabled: $079ec2a8d1ffe1e2$var$_propTypes.default.bool
};
var $079ec2a8d1ffe1e2$var$_default = $079ec2a8d1ffe1e2$var$SignInCardAttachment;
module.exports.default = $079ec2a8d1ffe1e2$var$_default;

});
parcelRequire.register("idxQs", function(module, exports) {
"use strict";

var $luOtD = parcelRequire("luOtD");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d433b1cd412d09c3$var$_slicedToArray2 = $luOtD((parcelRequire("fhBCP")));

var $fD7D4 = parcelRequire("fD7D4");

var $d433b1cd412d09c3$var$_propTypes = $luOtD((parcelRequire("f7UXb")));

var $d433b1cd412d09c3$var$_react = $luOtD((parcelRequire("eO7Kz")));

var $d433b1cd412d09c3$var$_CommonCard = $luOtD((parcelRequire("6vkD7")));
var $d433b1cd412d09c3$var$useStyleSet = $fD7D4.hooks.useStyleSet;
var $d433b1cd412d09c3$var$SignInCardContent = function SignInCardContent(_ref) {
    var actionPerformedClassName = _ref.actionPerformedClassName, content = _ref.content, disabled = _ref.disabled;
    var _useStyleSet = $d433b1cd412d09c3$var$useStyleSet(), _useStyleSet2 = (0, $d433b1cd412d09c3$var$_slicedToArray2.default)(_useStyleSet, 1), animationCardAttachmentStyleSet = _useStyleSet2[0].animationCardAttachment;
    return /*#__PURE__*/ $d433b1cd412d09c3$var$_react.default.createElement("div", {
        className: animationCardAttachmentStyleSet
    }, /*#__PURE__*/ $d433b1cd412d09c3$var$_react.default.createElement($d433b1cd412d09c3$var$_CommonCard.default, {
        actionPerformedClassName: actionPerformedClassName,
        content: content,
        disabled: disabled
    }));
};
$d433b1cd412d09c3$var$SignInCardContent.defaultProps = {
    actionPerformedClassName: "",
    disabled: undefined
};
$d433b1cd412d09c3$var$SignInCardContent.propTypes = {
    actionPerformedClassName: $d433b1cd412d09c3$var$_propTypes.default.string,
    content: $d433b1cd412d09c3$var$_propTypes.default.any.isRequired,
    disabled: $d433b1cd412d09c3$var$_propTypes.default.bool
};
var $d433b1cd412d09c3$var$_default = $d433b1cd412d09c3$var$SignInCardContent;
module.exports.default = $d433b1cd412d09c3$var$_default;

});


parcelRequire.register("71QUT", function(module, exports) {
"use strict";

var $luOtD = parcelRequire("luOtD");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $51e1ac87472a4b9c$var$_propTypes = $luOtD((parcelRequire("f7UXb")));

var $51e1ac87472a4b9c$var$_react = $luOtD((parcelRequire("eO7Kz")));

var $51e1ac87472a4b9c$var$_ThumbnailCardContent = $luOtD((parcelRequire("gBtw4")));
var $51e1ac87472a4b9c$var$ThumbnailCardAttachment = function ThumbnailCardAttachment(_ref) {
    var content = _ref.attachment.content, disabled = _ref.disabled;
    return /*#__PURE__*/ $51e1ac87472a4b9c$var$_react.default.createElement($51e1ac87472a4b9c$var$_ThumbnailCardContent.default, {
        content: content,
        disabled: disabled
    });
};
$51e1ac87472a4b9c$var$ThumbnailCardAttachment.defaultProps = {
    disabled: undefined
};
$51e1ac87472a4b9c$var$ThumbnailCardAttachment.propTypes = {
    attachment: $51e1ac87472a4b9c$var$_propTypes.default.shape({
        content: $51e1ac87472a4b9c$var$_propTypes.default.shape({
            buttons: $51e1ac87472a4b9c$var$_propTypes.default.array,
            images: $51e1ac87472a4b9c$var$_propTypes.default.arrayOf($51e1ac87472a4b9c$var$_propTypes.default.shape({
                alt: $51e1ac87472a4b9c$var$_propTypes.default.string.isRequired,
                tap: $51e1ac87472a4b9c$var$_propTypes.default.any,
                url: $51e1ac87472a4b9c$var$_propTypes.default.string.isRequired
            })),
            subtitle: $51e1ac87472a4b9c$var$_propTypes.default.string,
            tap: $51e1ac87472a4b9c$var$_propTypes.default.any,
            text: $51e1ac87472a4b9c$var$_propTypes.default.string,
            title: $51e1ac87472a4b9c$var$_propTypes.default.string
        }).isRequired
    }).isRequired,
    disabled: $51e1ac87472a4b9c$var$_propTypes.default.bool
};
var $51e1ac87472a4b9c$var$_default = $51e1ac87472a4b9c$var$ThumbnailCardAttachment;
module.exports.default = $51e1ac87472a4b9c$var$_default;

});
parcelRequire.register("gBtw4", function(module, exports) {
"use strict";

var $luOtD = parcelRequire("luOtD");

var $2PxO1 = parcelRequire("2PxO1");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c166ff616c0b6344$var$_slicedToArray2 = $luOtD((parcelRequire("fhBCP")));

var $fD7D4 = parcelRequire("fD7D4");

var $c166ff616c0b6344$var$_propTypes = $luOtD((parcelRequire("f7UXb")));

var $c166ff616c0b6344$var$_react = $c166ff616c0b6344$var$_interopRequireWildcard((parcelRequire("eO7Kz")));

var $c166ff616c0b6344$var$_AdaptiveCardBuilder = $luOtD((parcelRequire("dUIqS")));

var $c166ff616c0b6344$var$_AdaptiveCardRenderer = $luOtD((parcelRequire("7qmwG")));

var $c166ff616c0b6344$var$_useAdaptiveCardsPackage = $luOtD((parcelRequire("fdwbc")));

var $c166ff616c0b6344$var$_useStyleOptions3 = $luOtD((parcelRequire("gwtqY")));
function $c166ff616c0b6344$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($c166ff616c0b6344$var$_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $c166ff616c0b6344$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || $2PxO1(obj) !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $c166ff616c0b6344$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
/* eslint no-magic-numbers: ["error", { "ignore": [25, 75] }] */ var $c166ff616c0b6344$var$useDirection = $fD7D4.hooks.useDirection;
var $c166ff616c0b6344$var$ThumbnailCardContent = function ThumbnailCardContent(_ref) {
    var actionPerformedClassName = _ref.actionPerformedClassName, content = _ref.content, disabled = _ref.disabled;
    var _useAdaptiveCardsPack = (0, $c166ff616c0b6344$var$_useAdaptiveCardsPackage.default)(), _useAdaptiveCardsPack2 = (0, $c166ff616c0b6344$var$_slicedToArray2.default)(_useAdaptiveCardsPack, 1), adaptiveCardsPackage = _useAdaptiveCardsPack2[0];
    var _useDirection = $c166ff616c0b6344$var$useDirection(), _useDirection2 = (0, $c166ff616c0b6344$var$_slicedToArray2.default)(_useDirection, 1), direction = _useDirection2[0];
    var _useStyleOptions = (0, $c166ff616c0b6344$var$_useStyleOptions3.default)(), _useStyleOptions2 = (0, $c166ff616c0b6344$var$_slicedToArray2.default)(_useStyleOptions, 1), styleOptions = _useStyleOptions2[0];
    var builtCard = (0, $c166ff616c0b6344$var$_react.useMemo)(function() {
        if (content) {
            var builder = new $c166ff616c0b6344$var$_AdaptiveCardBuilder.default(adaptiveCardsPackage, styleOptions, direction);
            var TextSize = adaptiveCardsPackage.TextSize, TextWeight = adaptiveCardsPackage.TextWeight;
            var buttons = content.buttons, images = content.images, subtitle = content.subtitle, text = content.text, title = content.title;
            var richCardWrapTitle = styleOptions.richCardWrapTitle;
            if (images && images.length) {
                var _builder$addColumnSet = builder.addColumnSet([
                    75,
                    25
                ]), _builder$addColumnSet2 = (0, $c166ff616c0b6344$var$_slicedToArray2.default)(_builder$addColumnSet, 2), firstColumn = _builder$addColumnSet2[0], lastColumn = _builder$addColumnSet2[1];
                var _images = (0, $c166ff616c0b6344$var$_slicedToArray2.default)(images, 1), _images$ = _images[0], alt = _images$.alt, tap = _images$.tap, url = _images$.url;
                builder.addTextBlock(title, {
                    size: TextSize.Medium,
                    weight: TextWeight.Bolder,
                    wrap: richCardWrapTitle
                }, firstColumn);
                builder.addTextBlock(subtitle, {
                    isSubtle: true,
                    wrap: richCardWrapTitle
                }, firstColumn);
                builder.addImage(url, lastColumn, tap, alt);
                builder.addTextBlock(text, {
                    wrap: true
                });
                builder.addButtons(buttons);
            } else builder.addCommon(content);
            return builder.card;
        }
    }, [
        adaptiveCardsPackage,
        direction,
        content,
        styleOptions
    ]);
    return /*#__PURE__*/ $c166ff616c0b6344$var$_react.default.createElement($c166ff616c0b6344$var$_AdaptiveCardRenderer.default, {
        actionPerformedClassName: actionPerformedClassName,
        adaptiveCard: builtCard,
        disabled: disabled,
        tapAction: content && content.tap
    });
};
$c166ff616c0b6344$var$ThumbnailCardContent.defaultProps = {
    actionPerformedClassName: "",
    disabled: undefined
};
$c166ff616c0b6344$var$ThumbnailCardContent.propTypes = {
    actionPerformedClassName: $c166ff616c0b6344$var$_propTypes.default.string,
    // PropTypes cannot fully capture TypeScript types.
    // @ts-ignore
    content: $c166ff616c0b6344$var$_propTypes.default.shape({
        buttons: $c166ff616c0b6344$var$_propTypes.default.array,
        images: $c166ff616c0b6344$var$_propTypes.default.arrayOf($c166ff616c0b6344$var$_propTypes.default.shape({
            alt: $c166ff616c0b6344$var$_propTypes.default.string.isRequired,
            tap: $c166ff616c0b6344$var$_propTypes.default.any,
            url: $c166ff616c0b6344$var$_propTypes.default.string.isRequired
        })),
        subtitle: $c166ff616c0b6344$var$_propTypes.default.string,
        tap: $c166ff616c0b6344$var$_propTypes.default.any,
        text: $c166ff616c0b6344$var$_propTypes.default.string,
        title: $c166ff616c0b6344$var$_propTypes.default.string
    }).isRequired,
    disabled: $c166ff616c0b6344$var$_propTypes.default.bool
};
var $c166ff616c0b6344$var$_default = $c166ff616c0b6344$var$ThumbnailCardContent;
module.exports.default = $c166ff616c0b6344$var$_default;

});


parcelRequire.register("a4P51", function(module, exports) {
"use strict";

var $luOtD = parcelRequire("luOtD");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7561e68d62a51c7e$var$_propTypes = $luOtD((parcelRequire("f7UXb")));

var $7561e68d62a51c7e$var$_react = $luOtD((parcelRequire("eO7Kz")));

var $7561e68d62a51c7e$var$_VideoCardContent = $luOtD((parcelRequire("lfUgi")));
/* eslint react/no-array-index-key: "off" */ var $7561e68d62a51c7e$var$VideoCardAttachment = function VideoCardAttachment(_ref) {
    var content = _ref.attachment.content, disabled = _ref.disabled;
    return /*#__PURE__*/ $7561e68d62a51c7e$var$_react.default.createElement($7561e68d62a51c7e$var$_VideoCardContent.default, {
        content: content,
        disabled: disabled
    });
};
$7561e68d62a51c7e$var$VideoCardAttachment.defaultProps = {
    disabled: undefined
};
$7561e68d62a51c7e$var$VideoCardAttachment.propTypes = {
    attachment: $7561e68d62a51c7e$var$_propTypes.default.shape({
        content: $7561e68d62a51c7e$var$_propTypes.default.shape({
            autoloop: $7561e68d62a51c7e$var$_propTypes.default.bool,
            autostart: $7561e68d62a51c7e$var$_propTypes.default.bool,
            image: $7561e68d62a51c7e$var$_propTypes.default.shape({
                url: $7561e68d62a51c7e$var$_propTypes.default.string.isRequired
            }),
            media: $7561e68d62a51c7e$var$_propTypes.default.arrayOf($7561e68d62a51c7e$var$_propTypes.default.shape({
                profile: $7561e68d62a51c7e$var$_propTypes.default.string.isRequired,
                url: $7561e68d62a51c7e$var$_propTypes.default.string
            }))
        })
    }).isRequired,
    disabled: $7561e68d62a51c7e$var$_propTypes.default.bool
};
var $7561e68d62a51c7e$var$_default = $7561e68d62a51c7e$var$VideoCardAttachment;
module.exports.default = $7561e68d62a51c7e$var$_default;

});
parcelRequire.register("lfUgi", function(module, exports) {
"use strict";

var $luOtD = parcelRequire("luOtD");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f796a41cf49c4425$var$_slicedToArray2 = $luOtD((parcelRequire("fhBCP")));

var $fD7D4 = parcelRequire("fD7D4");

var $f796a41cf49c4425$var$_propTypes = $luOtD((parcelRequire("f7UXb")));

var $f796a41cf49c4425$var$_react = $luOtD((parcelRequire("eO7Kz")));

var $f796a41cf49c4425$var$_CommonCard = $luOtD((parcelRequire("6vkD7")));
/* eslint react/no-array-index-key: "off" */ var $f796a41cf49c4425$var$useStyleSet = $fD7D4.hooks.useStyleSet;
var $f796a41cf49c4425$var$VideoContent = $fD7D4.Components.VideoContent;
var $f796a41cf49c4425$var$VideoCardContent = function VideoCardContent(_ref) {
    var actionPerformedClassName = _ref.actionPerformedClassName, content = _ref.content, disabled = _ref.disabled;
    var autoloop = content.autoloop, autostart = content.autostart, _content$image = content.image;
    _content$image = _content$image === void 0 ? {
        url: undefined
    } : _content$image;
    var imageURL = _content$image.url, media = content.media;
    var _useStyleSet = $f796a41cf49c4425$var$useStyleSet(), _useStyleSet2 = (0, $f796a41cf49c4425$var$_slicedToArray2.default)(_useStyleSet, 1), audioCardAttachmentStyleSet = _useStyleSet2[0].audioCardAttachment;
    return /*#__PURE__*/ $f796a41cf49c4425$var$_react.default.createElement("div", {
        className: audioCardAttachmentStyleSet
    }, /*#__PURE__*/ $f796a41cf49c4425$var$_react.default.createElement("ul", {
        className: "media-list"
    }, media.map(function(_ref2, index) {
        var url = _ref2.url;
        return /*#__PURE__*/ $f796a41cf49c4425$var$_react.default.createElement("li", {
            key: index
        }, /*#__PURE__*/ $f796a41cf49c4425$var$_react.default.createElement($f796a41cf49c4425$var$VideoContent, {
            autoPlay: autostart,
            loop: autoloop,
            poster: imageURL,
            src: url
        }));
    })), /*#__PURE__*/ $f796a41cf49c4425$var$_react.default.createElement($f796a41cf49c4425$var$_CommonCard.default, {
        actionPerformedClassName: actionPerformedClassName,
        content: content,
        disabled: disabled
    }));
};
$f796a41cf49c4425$var$VideoCardContent.defaultProps = {
    actionPerformedClassName: "",
    disabled: undefined
};
$f796a41cf49c4425$var$VideoCardContent.propTypes = {
    actionPerformedClassName: $f796a41cf49c4425$var$_propTypes.default.string,
    // PropTypes cannot fully capture TypeScript types.
    // @ts-ignore
    content: $f796a41cf49c4425$var$_propTypes.default.shape({
        autoloop: $f796a41cf49c4425$var$_propTypes.default.bool,
        autostart: $f796a41cf49c4425$var$_propTypes.default.bool,
        image: $f796a41cf49c4425$var$_propTypes.default.shape({
            url: $f796a41cf49c4425$var$_propTypes.default.string.isRequired
        }),
        media: $f796a41cf49c4425$var$_propTypes.default.arrayOf($f796a41cf49c4425$var$_propTypes.default.shape({
            profile: $f796a41cf49c4425$var$_propTypes.default.string,
            url: $f796a41cf49c4425$var$_propTypes.default.string.isRequired
        })).isRequired
    }).isRequired,
    disabled: $f796a41cf49c4425$var$_propTypes.default.bool
};
var $f796a41cf49c4425$var$_default = $f796a41cf49c4425$var$VideoCardContent;
module.exports.default = $f796a41cf49c4425$var$_default;

});



parcelRequire.register("gixiP", function(module, exports) {
"use strict";

var $luOtD = parcelRequire("luOtD");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $bdd8290690306bd9$var$createAdaptiveCardsAttachmentMiddleware;

var $bdd8290690306bd9$var$_react = $luOtD((parcelRequire("eO7Kz")));

var $bdd8290690306bd9$var$_AdaptiveCardAttachment = $luOtD((parcelRequire("MWJex")));

var $bdd8290690306bd9$var$_RichCardAttachment = $luOtD((parcelRequire("dk4P3")));
var $bdd8290690306bd9$var$RICH_CARD_CONTENT_TYPES = [
    "application/vnd.microsoft.card.animation",
    "application/vnd.microsoft.card.audio",
    "application/vnd.microsoft.card.hero",
    "application/vnd.microsoft.card.oauth",
    "application/vnd.microsoft.card.receipt",
    "application/vnd.microsoft.card.signin",
    "application/vnd.microsoft.card.thumbnail",
    "application/vnd.microsoft.card.video"
];
function $bdd8290690306bd9$var$createAdaptiveCardsAttachmentMiddleware() {
    return function() {
        return function(next) {
            return function() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                var _args$0$attachment = args[0].attachment, content = _args$0$attachment.content, contentType = _args$0$attachment.contentType;
                return content && $bdd8290690306bd9$var$RICH_CARD_CONTENT_TYPES.includes(contentType) ? function() {
                    return /*#__PURE__*/ $bdd8290690306bd9$var$_react.default.createElement($bdd8290690306bd9$var$_RichCardAttachment.default, {
                        content: content
                    });
                } : content && contentType === "application/vnd.microsoft.card.adaptive" ? function() {
                    return /*#__PURE__*/ $bdd8290690306bd9$var$_react.default.createElement($bdd8290690306bd9$var$_AdaptiveCardAttachment.default, {
                        content: content
                    });
                } : next.apply(void 0, args);
            };
        };
    };
}

});
parcelRequire.register("MWJex", function(module, exports) {
"use strict";

var $luOtD = parcelRequire("luOtD");

var $2PxO1 = parcelRequire("2PxO1");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $09320a1493dd2687$var$_slicedToArray2 = $luOtD((parcelRequire("fhBCP")));

var $fD7D4 = parcelRequire("fD7D4");

var $09320a1493dd2687$var$_propTypes = $luOtD((parcelRequire("f7UXb")));

var $09320a1493dd2687$var$_react = $09320a1493dd2687$var$_interopRequireWildcard((parcelRequire("eO7Kz")));

var $09320a1493dd2687$var$_useAdaptiveCardsPackage = $luOtD((parcelRequire("fdwbc")));

var $09320a1493dd2687$var$_useParseAdaptiveCardJSON = $luOtD((parcelRequire("bwbgg")));

var $09320a1493dd2687$var$_useUniqueId = $luOtD((parcelRequire("3Nm5t")));
function $09320a1493dd2687$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($09320a1493dd2687$var$_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $09320a1493dd2687$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || $2PxO1(obj) !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $09320a1493dd2687$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
/* eslint-disable react/no-array-index-key */ /* eslint-disable react/forbid-dom-props */ var $09320a1493dd2687$var$useLocalizer = $fD7D4.hooks.useLocalizer; // Perform a depth-first search of the Adaptive Card tree.
function $09320a1493dd2687$var$walkAllItems(node, fn) {
    fn(node);
    if (node.getItemAt && node.getItemCount) for(var count = node.getItemCount(), index = 0; index < count; index++)$09320a1493dd2687$var$walkAllItems(node.getItemAt(index), fn);
    if (node.getActionAt && node.getActionCount) for(var _count = node.getActionCount(), _index = 0; _index < _count; _index++)fn(node.getActionAt(_index));
}
var $09320a1493dd2687$var$AdaptiveCardChoiceSetInput = function AdaptiveCardChoiceSetInput(_ref) {
    var _ref$input = _ref.input, choices = _ref$input.choices, defaultValue = _ref$input.defaultValue, label = _ref$input.label;
    var labelId = (0, $09320a1493dd2687$var$_useUniqueId.default)("webchat__id");
    var defaultChoice = choices.find(function(_ref2) {
        var value = _ref2.value;
        return defaultValue === value || !defaultValue && !value;
    });
    return /*#__PURE__*/ $09320a1493dd2687$var$_react.default.createElement("div", null, /*#__PURE__*/ $09320a1493dd2687$var$_react.default.createElement("select", {
        "aria-label": label,
        "aria-labelledby": !label && defaultChoice ? labelId : undefined,
        defaultValue: defaultValue,
        tabIndex: -1
    }, choices.map(function(choice) {
        return /*#__PURE__*/ $09320a1493dd2687$var$_react.default.createElement("option", {
            id: !label && choice === defaultChoice ? labelId : undefined,
            key: choice.value,
            value: choice.value
        }, choice.title);
    })));
};
$09320a1493dd2687$var$AdaptiveCardChoiceSetInput.propTypes = {
    input: $09320a1493dd2687$var$_propTypes.default.shape({
        choices: $09320a1493dd2687$var$_propTypes.default.arrayOf($09320a1493dd2687$var$_propTypes.default.shape({
            title: $09320a1493dd2687$var$_propTypes.default.string,
            value: $09320a1493dd2687$var$_propTypes.default.any
        })),
        defaultValue: $09320a1493dd2687$var$_propTypes.default.any,
        label: $09320a1493dd2687$var$_propTypes.default.string,
        value: $09320a1493dd2687$var$_propTypes.default.any
    }).isRequired
};
var $09320a1493dd2687$var$AdaptiveCardAttachment = function AdaptiveCardAttachment(_ref3) {
    var content = _ref3.content;
    var localize = $09320a1493dd2687$var$useLocalizer();
    var parseAdaptiveCardJSON = (0, $09320a1493dd2687$var$_useParseAdaptiveCardJSON.default)();
    var _useAdaptiveCardsPack = (0, $09320a1493dd2687$var$_useAdaptiveCardsPackage.default)(), _useAdaptiveCardsPack2 = (0, $09320a1493dd2687$var$_slicedToArray2.default)(_useAdaptiveCardsPack, 1), _useAdaptiveCardsPack3 = _useAdaptiveCardsPack2[0], ChoiceSetInput = _useAdaptiveCardsPack3.ChoiceSetInput, DateInput = _useAdaptiveCardsPack3.DateInput, NumberInput = _useAdaptiveCardsPack3.NumberInput, OpenUrlAction = _useAdaptiveCardsPack3.OpenUrlAction, ShowCardAction = _useAdaptiveCardsPack3.ShowCardAction, SubmitAction = _useAdaptiveCardsPack3.SubmitAction, TextInput = _useAdaptiveCardsPack3.TextInput, TimeInput = _useAdaptiveCardsPack3.TimeInput, ToggleInput = _useAdaptiveCardsPack3.ToggleInput;
    var card = (0, $09320a1493dd2687$var$_react.useMemo)(function() {
        return parseAdaptiveCardJSON(content, {
            ignoreErrors: true
        });
    }, [
        content,
        parseAdaptiveCardJSON
    ]);
    var inputs = (0, $09320a1493dd2687$var$_react.useMemo)(function() {
        var inputs = [];
        $09320a1493dd2687$var$walkAllItems(card, function(node) {
            if (node instanceof ChoiceSetInput || node instanceof DateInput || node instanceof NumberInput || node instanceof OpenUrlAction || node instanceof ShowCardAction || node instanceof SubmitAction || node instanceof TextInput || node instanceof TimeInput || node instanceof ToggleInput) inputs.push(node);
        });
        return inputs;
    }, [
        card,
        ChoiceSetInput,
        DateInput,
        NumberInput,
        OpenUrlAction,
        ShowCardAction,
        SubmitAction,
        TextInput,
        TimeInput,
        ToggleInput
    ]);
    var cardLabel = localize("ATTACHMENT_CARD", card.speak || "", "", "");
    return /*#__PURE__*/ $09320a1493dd2687$var$_react.default.createElement("article", null, /*#__PURE__*/ $09320a1493dd2687$var$_react.default.createElement("div", null, cardLabel), inputs.map(function(input, index) {
        return input instanceof ChoiceSetInput ? /*#__PURE__*/ $09320a1493dd2687$var$_react.default.createElement($09320a1493dd2687$var$AdaptiveCardChoiceSetInput, {
            input: input,
            key: index
        }) : input instanceof DateInput ? /*#__PURE__*/ $09320a1493dd2687$var$_react.default.createElement("label", {
            key: index
        }, input.title, /*#__PURE__*/ $09320a1493dd2687$var$_react.default.createElement("input", {
            placeholder: input.placeholder,
            tabIndex: -1,
            type: "date"
        })) : input instanceof NumberInput ? /*#__PURE__*/ $09320a1493dd2687$var$_react.default.createElement("label", {
            key: index
        }, input.title, /*#__PURE__*/ $09320a1493dd2687$var$_react.default.createElement("input", {
            placeholder: input.placeholder,
            tabIndex: -1,
            type: "number"
        })) : input instanceof OpenUrlAction || input instanceof ShowCardAction || input instanceof SubmitAction ? /*#__PURE__*/ $09320a1493dd2687$var$_react.default.createElement("div", {
            key: index
        }, /*#__PURE__*/ $09320a1493dd2687$var$_react.default.createElement("button", {
            tabIndex: -1,
            type: "button"
        }, input.title)) : input instanceof TextInput ? /*#__PURE__*/ $09320a1493dd2687$var$_react.default.createElement("label", {
            key: index
        }, input.title, /*#__PURE__*/ $09320a1493dd2687$var$_react.default.createElement("input", {
            placeholder: input.placeholder,
            tabIndex: -1,
            type: "text"
        })) : input instanceof TimeInput ? /*#__PURE__*/ $09320a1493dd2687$var$_react.default.createElement("label", {
            key: index
        }, input.title, /*#__PURE__*/ $09320a1493dd2687$var$_react.default.createElement("input", {
            placeholder: input.placeholder,
            tabIndex: -1,
            type: "time"
        })) : input instanceof ToggleInput ? /*#__PURE__*/ $09320a1493dd2687$var$_react.default.createElement("label", {
            key: index
        }, input.title, /*#__PURE__*/ $09320a1493dd2687$var$_react.default.createElement("input", {
            defaultChecked: input.value === input.valueOn,
            tabIndex: -1,
            type: "checkbox"
        })) : false;
    }));
};
$09320a1493dd2687$var$AdaptiveCardAttachment.propTypes = {
    content: $09320a1493dd2687$var$_propTypes.default.any.isRequired
};
var $09320a1493dd2687$var$_default = $09320a1493dd2687$var$AdaptiveCardAttachment;
module.exports.default = $09320a1493dd2687$var$_default;

});
parcelRequire.register("3Nm5t", function(module, exports) {
"use strict";

var $luOtD = parcelRequire("luOtD");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $2c3714c62f6c22dd$var$useUniqueId;

var $eO7Kz = parcelRequire("eO7Kz");

var $2c3714c62f6c22dd$var$_mathRandom = $luOtD((parcelRequire("atZsr")));
/* eslint no-magic-numbers: ["error", { "ignore": [2, 5, 36] }] */ function $2c3714c62f6c22dd$var$useUniqueId(prefix) {
    var id = (0, $eO7Kz.useMemo)(function() {
        return (0, $2c3714c62f6c22dd$var$_mathRandom.default)().toString(36).substr(2, 5);
    }, []);
    prefix = prefix ? "".concat(prefix, "--") : "";
    return "".concat(prefix).concat(id);
}

});


parcelRequire.register("dk4P3", function(module, exports) {
"use strict";

var $luOtD = parcelRequire("luOtD");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9b30e243df3cf83b$var$_propTypes = $luOtD((parcelRequire("f7UXb")));

var $9b30e243df3cf83b$var$_react = $luOtD((parcelRequire("eO7Kz")));

var $fD7D4 = parcelRequire("fD7D4");
/* eslint-disable react/no-array-index-key */ var $9b30e243df3cf83b$var$useLocalizer = $fD7D4.hooks.useLocalizer;
var $9b30e243df3cf83b$var$RichCardAttachment = function RichCardAttachment(_ref) {
    var _ref$content = _ref.content, content = _ref$content === void 0 ? {} : _ref$content;
    var localize = $9b30e243df3cf83b$var$useLocalizer();
    var buttons = content.buttons, facts = content.facts, image = content.image, images = content.images, items = content.items, subtitle = content.subtitle, tax = content.tax, text = content.text, title = content.title, total = content.total, vat = content.vat;
    var taxLabel = localize("RECEIPT_CARD_TAX");
    var totalLabel = localize("RECEIPT_CARD_TOTAL");
    var vatLabel = localize("RECEIPT_CARD_VAT");
    var cardLabel = localize("ATTACHMENT_CARD", title || "", subtitle || "", text || "");
    return /*#__PURE__*/ $9b30e243df3cf83b$var$_react.default.createElement("article", null, /*#__PURE__*/ $9b30e243df3cf83b$var$_react.default.createElement("div", null, cardLabel), !!image && !!image.alt && /*#__PURE__*/ $9b30e243df3cf83b$var$_react.default.createElement("img", {
        alt: image.alt
    }), !!images && !!images.length && images.map(function(_ref2, index) {
        var alt = _ref2.alt;
        return /*#__PURE__*/ $9b30e243df3cf83b$var$_react.default.createElement("img", {
            alt: alt,
            key: index
        });
    }), !!facts && !!facts.length && /*#__PURE__*/ $9b30e243df3cf83b$var$_react.default.createElement("dl", null, facts.map(function(_ref3, index) {
        var key = _ref3.key, value = _ref3.value;
        return /*#__PURE__*/ $9b30e243df3cf83b$var$_react.default.createElement($9b30e243df3cf83b$var$_react.default.Fragment, {
            key: index
        }, /*#__PURE__*/ $9b30e243df3cf83b$var$_react.default.createElement("dt", null, key), /*#__PURE__*/ $9b30e243df3cf83b$var$_react.default.createElement("dd", null, value));
    })), !!items && !!items.length && /*#__PURE__*/ $9b30e243df3cf83b$var$_react.default.createElement("ul", null, items.map(function(_ref4, index) {
        var image = _ref4.image, price = _ref4.price, quantity = _ref4.quantity, subtitle = _ref4.subtitle, text = _ref4.text, title = _ref4.title;
        return /*#__PURE__*/ $9b30e243df3cf83b$var$_react.default.createElement("li", {
            key: index
        }, !!image && !!image.alt && /*#__PURE__*/ $9b30e243df3cf83b$var$_react.default.createElement("img", {
            alt: image.alt
        }), !!title && /*#__PURE__*/ $9b30e243df3cf83b$var$_react.default.createElement("p", null, title), !!subtitle && /*#__PURE__*/ $9b30e243df3cf83b$var$_react.default.createElement("p", null, subtitle), !!text && /*#__PURE__*/ $9b30e243df3cf83b$var$_react.default.createElement("p", null, text), !!quantity && /*#__PURE__*/ $9b30e243df3cf83b$var$_react.default.createElement("p", null, quantity), !!price && /*#__PURE__*/ $9b30e243df3cf83b$var$_react.default.createElement("p", null, price));
    })), !!vat && /*#__PURE__*/ $9b30e243df3cf83b$var$_react.default.createElement("p", null, vatLabel, " ", vat), !!tax && /*#__PURE__*/ $9b30e243df3cf83b$var$_react.default.createElement("p", null, taxLabel, " ", tax), !!total && /*#__PURE__*/ $9b30e243df3cf83b$var$_react.default.createElement("p", null, totalLabel, " ", total), !!buttons && !!buttons.length && /*#__PURE__*/ $9b30e243df3cf83b$var$_react.default.createElement("div", null, buttons.map(function(_ref5, index) {
        var title = _ref5.title;
        return /*#__PURE__*/ $9b30e243df3cf83b$var$_react.default.createElement("button", {
            key: index,
            tabIndex: -1,
            type: "button"
        }, title);
    })));
};
$9b30e243df3cf83b$var$RichCardAttachment.propTypes = {
    content: $9b30e243df3cf83b$var$_propTypes.default.any.isRequired
};
var $9b30e243df3cf83b$var$_default = $9b30e243df3cf83b$var$RichCardAttachment;
module.exports.default = $9b30e243df3cf83b$var$_default;

});


parcelRequire.register("ccGPK", function(module, exports) {
"use strict";

var $luOtD = parcelRequire("luOtD");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $8e27d4e183294bd9$var$createCognitiveServicesSpeechServicesPonyfillFactory;

var $8e27d4e183294bd9$var$_SpeechServices = $luOtD((parcelRequire("26T2L")));

var $8e27d4e183294bd9$var$_createMicrophoneAudioConfigAndAudioContext = $luOtD((parcelRequire("iKa9Q")));
function $8e27d4e183294bd9$var$createCognitiveServicesSpeechServicesPonyfillFactory(_ref) {
    var audioConfig = _ref.audioConfig, audioContext = _ref.audioContext, audioInputDeviceId = _ref.audioInputDeviceId, credentials = _ref.credentials, enableTelemetry = _ref.enableTelemetry, speechRecognitionEndpointId = _ref.speechRecognitionEndpointId, speechSynthesisDeploymentId = _ref.speechSynthesisDeploymentId, speechSynthesisOutputFormat = _ref.speechSynthesisOutputFormat, textNormalization = _ref.textNormalization;
    if (!window.navigator.mediaDevices && !audioConfig) {
        console.warn("botframework-webchat: Your browser does not support Web Audio or the page is not loaded via HTTPS or localhost. Cognitive Services Speech Services is disabled. However, you may pass a custom AudioConfig to enable speech in this environment.");
        return function() {
            return {};
        };
    }
    if (audioConfig) {
        audioInputDeviceId && console.warn('botframework-webchat: "audioConfig" and "audioInputDeviceId" cannot be set at the same time; ignoring "audioInputDeviceId".');
        audioContext && console.warn('botframework-webchat: "audioConfig" and "audioContext" cannot be set at the same time; ignoring "audioContext" for speech recognition.');
    } else {
        var _createMicrophoneAudi = (0, $8e27d4e183294bd9$var$_createMicrophoneAudioConfigAndAudioContext.default)({
            audioContext: audioContext,
            audioInputDeviceId: audioInputDeviceId,
            enableTelemetry: enableTelemetry
        });
        audioConfig = _createMicrophoneAudi.audioConfig;
        audioContext = _createMicrophoneAudi.audioContext;
    }
    return function() {
        var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, referenceGrammarID = _ref2.referenceGrammarID;
        var _createPonyfill = (0, $8e27d4e183294bd9$var$_SpeechServices.default)({
            audioConfig: audioConfig,
            audioContext: audioContext,
            credentials: credentials,
            enableTelemetry: enableTelemetry,
            referenceGrammars: referenceGrammarID ? [
                "luis/".concat(referenceGrammarID, "-PRODUCTION")
            ] : [],
            speechRecognitionEndpointId: speechRecognitionEndpointId,
            speechSynthesisDeploymentId: speechSynthesisDeploymentId,
            speechSynthesisOutputFormat: speechSynthesisOutputFormat,
            textNormalization: textNormalization
        }), SpeechGrammarList = _createPonyfill.SpeechGrammarList, SpeechRecognition = _createPonyfill.SpeechRecognition, speechSynthesis = _createPonyfill.speechSynthesis, SpeechSynthesisUtterance = _createPonyfill.SpeechSynthesisUtterance;
        return {
            resumeAudioContext: function resumeAudioContext() {
                return audioContext && audioContext.state === "suspended" && audioContext.resume();
            },
            SpeechGrammarList: SpeechGrammarList,
            SpeechRecognition: SpeechRecognition,
            speechSynthesis: speechSynthesis,
            SpeechSynthesisUtterance: SpeechSynthesisUtterance
        };
    };
}

});
parcelRequire.register("26T2L", function(module, exports) {
"use strict";

var $lsqXV = parcelRequire("lsqXV");

var $4AWWc = parcelRequire("4AWWc");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "createSpeechRecognitionPonyfill", {
    enumerable: true,
    get: function get() {
        return $1896d6d184ebb1a4$var$_SpeechToText.default;
    }
});
Object.defineProperty(module.exports, "createSpeechRecognitionPonyfillFromRecognizer", {
    enumerable: true,
    get: function get() {
        return $1896d6d184ebb1a4$var$_SpeechToText.createSpeechRecognitionPonyfillFromRecognizer;
    }
});
Object.defineProperty(module.exports, "createSpeechSynthesisPonyfill", {
    enumerable: true,
    get: function get() {
        return $1896d6d184ebb1a4$var$_TextToSpeech.default;
    }
});
module.exports.default = $1896d6d184ebb1a4$var$createSpeechServicesPonyfill;
Object.defineProperty(module.exports, "fetchAuthorizationToken", {
    enumerable: true,
    get: function get() {
        return $1896d6d184ebb1a4$var$_fetchAuthorizationToken.default;
    }
});

var $1896d6d184ebb1a4$var$_defineProperty2 = $lsqXV((parcelRequire("7jg8p")));

var $1896d6d184ebb1a4$var$_SpeechToText = $1896d6d184ebb1a4$var$_interopRequireWildcard((parcelRequire("g7sYb")));

var $1896d6d184ebb1a4$var$_TextToSpeech = $lsqXV((parcelRequire("hpbgl")));

var $1896d6d184ebb1a4$var$_fetchAuthorizationToken = $lsqXV((parcelRequire("g3aCs")));
function $1896d6d184ebb1a4$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($1896d6d184ebb1a4$var$_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $1896d6d184ebb1a4$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || $4AWWc(obj) !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $1896d6d184ebb1a4$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $1896d6d184ebb1a4$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $1896d6d184ebb1a4$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $1896d6d184ebb1a4$var$ownKeys(Object(source), !0).forEach(function(key) {
            (0, $1896d6d184ebb1a4$var$_defineProperty2.default)(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $1896d6d184ebb1a4$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $1896d6d184ebb1a4$var$createSpeechServicesPonyfill() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
    var ponyfill = $1896d6d184ebb1a4$var$_objectSpread($1896d6d184ebb1a4$var$_objectSpread({}, $1896d6d184ebb1a4$var$_SpeechToText.default.apply(void 0, [
        options
    ].concat(args))), $1896d6d184ebb1a4$var$_TextToSpeech.default.apply(void 0, [
        options
    ].concat(args)));
    return $1896d6d184ebb1a4$var$_objectSpread($1896d6d184ebb1a4$var$_objectSpread({}, ponyfill), {}, {
        then: function then(resolve) {
            console.warn("web-speech-cognitive-services: This function no longer need to be called in an asynchronous fashion. Please update your code. We will remove this Promise.then function on or after 2020-08-10.");
            resolve(ponyfill);
        }
    });
}
var $1896d6d184ebb1a4$var$meta = document.createElement("meta");
$1896d6d184ebb1a4$var$meta.setAttribute("name", "web-speech-cognitive-services");
$1896d6d184ebb1a4$var$meta.setAttribute("content", "version=".concat("7.1.3"));
document.head.appendChild($1896d6d184ebb1a4$var$meta);

});
parcelRequire.register("lsqXV", function(module, exports) {
function $f9f1214952101558$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
module.exports = $f9f1214952101558$var$_interopRequireDefault, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRequire.register("4AWWc", function(module, exports) {
function $35883e0a23f8e9c7$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return module.exports = $35883e0a23f8e9c7$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $35883e0a23f8e9c7$var$_typeof(obj);
}
module.exports = $35883e0a23f8e9c7$var$_typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRequire.register("7jg8p", function(module, exports) {
function $5526d2c218cf1494$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
module.exports = $5526d2c218cf1494$var$_defineProperty, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRequire.register("g7sYb", function(module, exports) {
"use strict";

var $4AWWc = parcelRequire("4AWWc");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "createSpeechRecognitionPonyfillFromRecognizer", {
    enumerable: true,
    get: function get() {
        return $bbc3c58c7f6bc117$var$_createSpeechRecognitionPonyfill.createSpeechRecognitionPonyfillFromRecognizer;
    }
});
module.exports.default = void 0;

var $bbc3c58c7f6bc117$var$_createSpeechRecognitionPonyfill = $bbc3c58c7f6bc117$var$_interopRequireWildcard((parcelRequire("bF51L")));
function $bbc3c58c7f6bc117$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($bbc3c58c7f6bc117$var$_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $bbc3c58c7f6bc117$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || $4AWWc(obj) !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $bbc3c58c7f6bc117$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
var $bbc3c58c7f6bc117$var$_default = $bbc3c58c7f6bc117$var$_createSpeechRecognitionPonyfill.default;
module.exports.default = $bbc3c58c7f6bc117$var$_default;

});
parcelRequire.register("bF51L", function(module, exports) {
"use strict";

var $lsqXV = parcelRequire("lsqXV");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.createSpeechRecognitionPonyfillFromRecognizer = $87d76c69fba10416$var$createSpeechRecognitionPonyfillFromRecognizer;
module.exports.default = void 0;

var $87d76c69fba10416$var$_regenerator = $lsqXV((parcelRequire("jfaTe")));

var $87d76c69fba10416$var$_toConsumableArray2 = $lsqXV((parcelRequire("29hOE")));

var $87d76c69fba10416$var$_defineProperty2 = $lsqXV((parcelRequire("7jg8p")));

var $87d76c69fba10416$var$_asyncToGenerator2 = $lsqXV((parcelRequire("jT3Iz")));

var $87d76c69fba10416$var$_createClass2 = $lsqXV((parcelRequire("fQlXT")));

var $87d76c69fba10416$var$_classCallCheck2 = $lsqXV((parcelRequire("2wF0s")));

var $87d76c69fba10416$var$_inherits2 = $lsqXV((parcelRequire("i2Ce6")));

var $87d76c69fba10416$var$_possibleConstructorReturn2 = $lsqXV((parcelRequire("2cKO9")));

var $87d76c69fba10416$var$_getPrototypeOf2 = $lsqXV((parcelRequire("1AdHm")));

var $bgEWP = parcelRequire("bgEWP");

var $87d76c69fba10416$var$_cognitiveServiceEventResultToWebSpeechRecognitionResultList = $lsqXV((parcelRequire("1My6l")));

var $87d76c69fba10416$var$_createPromiseQueue = $lsqXV((parcelRequire("9QKOF")));

var $87d76c69fba10416$var$_patchOptions2 = $lsqXV((parcelRequire("crqHc")));

var $87d76c69fba10416$var$_SpeechGrammarList = $lsqXV((parcelRequire("f9mFT")));

var $87d76c69fba10416$var$_SpeechSDK = $lsqXV((parcelRequire("4PbZI")));
function $87d76c69fba10416$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $87d76c69fba10416$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $87d76c69fba10416$var$ownKeys(Object(source), !0).forEach(function(key) {
            (0, $87d76c69fba10416$var$_defineProperty2.default)(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $87d76c69fba10416$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $87d76c69fba10416$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $87d76c69fba10416$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, $87d76c69fba10416$var$_getPrototypeOf2.default)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $87d76c69fba10416$var$_getPrototypeOf2.default)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $87d76c69fba10416$var$_possibleConstructorReturn2.default)(this, result);
    };
}
function $87d76c69fba10416$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
// https://docs.microsoft.com/en-us/javascript/api/microsoft-cognitiveservices-speech-sdk/speechconfig?view=azure-node-latest#outputformat
// {
//   "RecognitionStatus": "Success",
//   "Offset": 900000,
//   "Duration": 49000000,
//   "NBest": [
//     {
//       "Confidence": 0.738919,
//       "Lexical": "second",
//       "ITN": "second",
//       "MaskedITN": "second",
//       "Display": "Second."
//     }
//   ]
// }
// {
//   "RecognitionStatus": "InitialSilenceTimeout",
//   "Offset": 50000000,
//   "Duration": 0
// }
var $87d76c69fba10416$var$AudioConfig = $87d76c69fba10416$var$_SpeechSDK.default.AudioConfig, $87d76c69fba10416$var$OutputFormat = $87d76c69fba10416$var$_SpeechSDK.default.OutputFormat, $87d76c69fba10416$var$ResultReason = $87d76c69fba10416$var$_SpeechSDK.default.ResultReason, $87d76c69fba10416$var$SpeechConfig = $87d76c69fba10416$var$_SpeechSDK.default.SpeechConfig, $87d76c69fba10416$var$SpeechRecognizer = $87d76c69fba10416$var$_SpeechSDK.default.SpeechRecognizer;
function $87d76c69fba10416$var$serializeRecognitionResult(_ref) {
    var duration = _ref.duration, errorDetails = _ref.errorDetails, json = _ref.json, offset = _ref.offset, properties = _ref.properties, reason = _ref.reason, resultId = _ref.resultId, text = _ref.text;
    return {
        duration: duration,
        errorDetails: errorDetails,
        json: JSON.parse(json),
        offset: offset,
        properties: properties,
        reason: reason,
        resultId: resultId,
        text: text
    };
}
function $87d76c69fba10416$var$averageAmplitude(arrayBuffer) {
    var array = new Int16Array(arrayBuffer);
    return [].reduce.call(array, function(averageAmplitude, amplitude) {
        return averageAmplitude + Math.abs(amplitude);
    }, 0) / array.length;
}
function $87d76c69fba10416$var$cognitiveServicesAsyncToPromise(fn) {
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return new Promise(function(resolve, reject) {
            return fn.apply(void 0, args.concat([
                resolve,
                reject
            ]));
        });
    };
}
var $87d76c69fba10416$var$SpeechRecognitionEvent = /*#__PURE__*/ function(_Event) {
    (0, $87d76c69fba10416$var$_inherits2.default)(SpeechRecognitionEvent, _Event);
    var _super = $87d76c69fba10416$var$_createSuper(SpeechRecognitionEvent);
    function SpeechRecognitionEvent(type) {
        var _this;
        var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {}, data = _ref2.data, emma = _ref2.emma, interpretation = _ref2.interpretation, resultIndex = _ref2.resultIndex, results = _ref2.results;
        (0, $87d76c69fba10416$var$_classCallCheck2.default)(this, SpeechRecognitionEvent);
        _this = _super.call(this, type);
        _this.data = data;
        _this.emma = emma;
        _this.interpretation = interpretation;
        _this.resultIndex = resultIndex;
        _this.results = results;
        return _this;
    }
    return (0, $87d76c69fba10416$var$_createClass2.default)(SpeechRecognitionEvent);
}($bgEWP.Event);
function $87d76c69fba10416$var$prepareAudioConfig(audioConfig) {
    var originalAttach = audioConfig.attach;
    var boundOriginalAttach = audioConfig.attach.bind(audioConfig);
    var firstChunk;
    var muted; // We modify "attach" function and detect when audible chunk is read.
    // We will only modify "attach" function once.
    audioConfig.attach = /*#__PURE__*/ (0, $87d76c69fba10416$var$_asyncToGenerator2.default)(/*#__PURE__*/ $87d76c69fba10416$var$_regenerator.default.mark(function _callee2() {
        var reader;
        return $87d76c69fba10416$var$_regenerator.default.wrap(function _callee2$(_context2) {
            while(true)switch(_context2.prev = _context2.next){
                case 0:
                    _context2.next = 2;
                    return boundOriginalAttach();
                case 2:
                    reader = _context2.sent;
                    return _context2.abrupt("return", $87d76c69fba10416$var$_objectSpread($87d76c69fba10416$var$_objectSpread({}, reader), {}, {
                        read: function() {
                            var _read = (0, $87d76c69fba10416$var$_asyncToGenerator2.default)(/*#__PURE__*/ $87d76c69fba10416$var$_regenerator.default.mark(function _callee() {
                                var chunk;
                                return $87d76c69fba10416$var$_regenerator.default.wrap(function _callee$(_context) {
                                    while(true)switch(_context.prev = _context.next){
                                        case 0:
                                            _context.next = 2;
                                            return reader.read();
                                        case 2:
                                            chunk = _context.sent;
                                            // The magic number 150 is measured by:
                                            // 1. Set microphone volume to 0
                                            // 2. Observe the amplitude (100-110) for the first few chunks
                                            //    (There is a short static caught when turning on the microphone)
                                            // 3. Set the number a bit higher than the observation
                                            if (!firstChunk && $87d76c69fba10416$var$averageAmplitude(chunk.buffer) > 150) {
                                                audioConfig.events.onEvent({
                                                    name: "FirstAudibleChunk"
                                                });
                                                firstChunk = true;
                                            }
                                            if (!muted) {
                                                _context.next = 6;
                                                break;
                                            }
                                            return _context.abrupt("return", {
                                                buffer: new ArrayBuffer(0),
                                                isEnd: true,
                                                timeReceived: Date.now()
                                            });
                                        case 6:
                                            return _context.abrupt("return", chunk);
                                        case 7:
                                        case "end":
                                            return _context.stop();
                                    }
                                }, _callee);
                            }));
                            function read() {
                                return _read.apply(this, arguments);
                            }
                            return read;
                        }()
                    }));
                case 4:
                case "end":
                    return _context2.stop();
            }
        }, _callee2);
    }));
    return {
        audioConfig: audioConfig,
        pause: function pause() {
            muted = true;
        },
        unprepare: function unprepare() {
            audioConfig.attach = originalAttach;
        }
    };
}
function $87d76c69fba10416$var$createSpeechRecognitionPonyfillFromRecognizer(_ref4) {
    var createRecognizer = _ref4.createRecognizer, enableTelemetry = _ref4.enableTelemetry, looseEvents = _ref4.looseEvents, referenceGrammars = _ref4.referenceGrammars, textNormalization = _ref4.textNormalization;
    // If enableTelemetry is set to null or non-boolean, we will default to true.
    $87d76c69fba10416$var$SpeechRecognizer.enableTelemetry(enableTelemetry !== false);
    var SpeechRecognition = /*#__PURE__*/ function(_EventTarget) {
        (0, $87d76c69fba10416$var$_inherits2.default)(SpeechRecognition, _EventTarget);
        var _super2 = $87d76c69fba10416$var$_createSuper(SpeechRecognition);
        function SpeechRecognition() {
            var _this2;
            (0, $87d76c69fba10416$var$_classCallCheck2.default)(this, SpeechRecognition);
            _this2 = _super2.call(this);
            _this2._continuous = false;
            _this2._interimResults = false;
            _this2._lang = typeof window !== "undefined" ? window.document.documentElement.getAttribute("lang") || window.navigator.language : "en-US";
            _this2._grammars = new $87d76c69fba10416$var$_SpeechGrammarList.default();
            _this2._maxAlternatives = 1;
            return _this2;
        }
        (0, $87d76c69fba10416$var$_createClass2.default)(SpeechRecognition, [
            {
                key: "emitCognitiveServices",
                value: function emitCognitiveServices(type, event) {
                    this.dispatchEvent(new $87d76c69fba10416$var$SpeechRecognitionEvent("cognitiveservices", {
                        data: $87d76c69fba10416$var$_objectSpread($87d76c69fba10416$var$_objectSpread({}, event), {}, {
                            type: type
                        })
                    }));
                }
            },
            {
                key: "continuous",
                get: function get() {
                    return this._continuous;
                },
                set: function set(value) {
                    this._continuous = value;
                }
            },
            {
                key: "grammars",
                get: function get() {
                    return this._grammars;
                },
                set: function set(value) {
                    if (value instanceof $87d76c69fba10416$var$_SpeechGrammarList.default) this._grammars = value;
                    else throw new Error("The provided value is not of type 'SpeechGrammarList'");
                }
            },
            {
                key: "interimResults",
                get: function get() {
                    return this._interimResults;
                },
                set: function set(value) {
                    this._interimResults = value;
                }
            },
            {
                key: "maxAlternatives",
                get: function get() {
                    return this._maxAlternatives;
                },
                set: function set(value) {
                    this._maxAlternatives = value;
                }
            },
            {
                key: "lang",
                get: function get() {
                    return this._lang;
                },
                set: function set(value) {
                    this._lang = value;
                }
            },
            {
                key: "onaudioend",
                get: function get() {
                    return (0, $bgEWP.getEventAttributeValue)(this, "audioend");
                },
                set: function set(value) {
                    (0, $bgEWP.setEventAttributeValue)(this, "audioend", value);
                }
            },
            {
                key: "onaudiostart",
                get: function get() {
                    return (0, $bgEWP.getEventAttributeValue)(this, "audiostart");
                },
                set: function set(value) {
                    (0, $bgEWP.setEventAttributeValue)(this, "audiostart", value);
                }
            },
            {
                key: "oncognitiveservices",
                get: function get() {
                    return (0, $bgEWP.getEventAttributeValue)(this, "cognitiveservices");
                },
                set: function set(value) {
                    (0, $bgEWP.setEventAttributeValue)(this, "cognitiveservices", value);
                }
            },
            {
                key: "onend",
                get: function get() {
                    return (0, $bgEWP.getEventAttributeValue)(this, "end");
                },
                set: function set(value) {
                    (0, $bgEWP.setEventAttributeValue)(this, "end", value);
                }
            },
            {
                key: "onerror",
                get: function get() {
                    return (0, $bgEWP.getEventAttributeValue)(this, "error");
                },
                set: function set(value) {
                    (0, $bgEWP.setEventAttributeValue)(this, "error", value);
                }
            },
            {
                key: "onresult",
                get: function get() {
                    return (0, $bgEWP.getEventAttributeValue)(this, "result");
                },
                set: function set(value) {
                    (0, $bgEWP.setEventAttributeValue)(this, "result", value);
                }
            },
            {
                key: "onsoundend",
                get: function get() {
                    return (0, $bgEWP.getEventAttributeValue)(this, "soundend");
                },
                set: function set(value) {
                    (0, $bgEWP.setEventAttributeValue)(this, "soundend", value);
                }
            },
            {
                key: "onsoundstart",
                get: function get() {
                    return (0, $bgEWP.getEventAttributeValue)(this, "soundstart");
                },
                set: function set(value) {
                    (0, $bgEWP.setEventAttributeValue)(this, "soundstart", value);
                }
            },
            {
                key: "onspeechend",
                get: function get() {
                    return (0, $bgEWP.getEventAttributeValue)(this, "speechend");
                },
                set: function set(value) {
                    (0, $bgEWP.setEventAttributeValue)(this, "speechend", value);
                }
            },
            {
                key: "onspeechstart",
                get: function get() {
                    return (0, $bgEWP.getEventAttributeValue)(this, "speechstart");
                },
                set: function set(value) {
                    (0, $bgEWP.setEventAttributeValue)(this, "speechstart", value);
                }
            },
            {
                key: "onstart",
                get: function get() {
                    return (0, $bgEWP.getEventAttributeValue)(this, "start");
                },
                set: function set(value) {
                    (0, $bgEWP.setEventAttributeValue)(this, "start", value);
                }
            },
            {
                key: "start",
                value: function start() {
                    var _this3 = this;
                    this._startOnce().catch(function(err) {
                        _this3.dispatchEvent(new ErrorEvent("error", {
                            error: err,
                            message: err && (err.stack || err.message)
                        }));
                    });
                }
            },
            {
                key: "_startOnce",
                value: function() {
                    var _startOnce2 = (0, $87d76c69fba10416$var$_asyncToGenerator2.default)(/*#__PURE__*/ $87d76c69fba10416$var$_regenerator.default.mark(function _callee3() {
                        var _this4 = this;
                        var recognizer, _prepareAudioConfig, pause, unprepare, queue, soundStarted, speechStarted, stopping, _recognizer$audioConf, detachAudioConfigEvent, phrases, dynamicGrammar, audioStarted, finalEvent, finalizedResults, _loop, loop, _ret;
                        return $87d76c69fba10416$var$_regenerator.default.wrap(function _callee3$(_context4) {
                            while(true)switch(_context4.prev = _context4.next){
                                case 0:
                                    _context4.next = 2;
                                    return createRecognizer(this.lang);
                                case 2:
                                    recognizer = _context4.sent;
                                    _prepareAudioConfig = $87d76c69fba10416$var$prepareAudioConfig(recognizer.audioConfig), pause = _prepareAudioConfig.pause, unprepare = _prepareAudioConfig.unprepare;
                                    _context4.prev = 4;
                                    queue = (0, $87d76c69fba10416$var$_createPromiseQueue.default)();
                                    _recognizer$audioConf = recognizer.audioConfig.events.attach(function(event) {
                                        var name = event.name;
                                        if (name === "AudioSourceReadyEvent") queue.push({
                                            audioSourceReady: {}
                                        });
                                        else if (name === "AudioSourceOffEvent") queue.push({
                                            audioSourceOff: {}
                                        });
                                        else if (name === "FirstAudibleChunk") queue.push({
                                            firstAudibleChunk: {}
                                        });
                                    }), detachAudioConfigEvent = _recognizer$audioConf.detach;
                                    recognizer.canceled = function(_, _ref5) {
                                        var errorDetails = _ref5.errorDetails, offset = _ref5.offset, reason = _ref5.reason, sessionId = _ref5.sessionId;
                                        queue.push({
                                            canceled: {
                                                errorDetails: errorDetails,
                                                offset: offset,
                                                reason: reason,
                                                sessionId: sessionId
                                            }
                                        });
                                    };
                                    recognizer.recognized = function(_, _ref6) {
                                        var offset = _ref6.offset, result = _ref6.result, sessionId = _ref6.sessionId;
                                        queue.push({
                                            recognized: {
                                                offset: offset,
                                                result: $87d76c69fba10416$var$serializeRecognitionResult(result),
                                                sessionId: sessionId
                                            }
                                        });
                                    };
                                    recognizer.recognizing = function(_, _ref7) {
                                        var offset = _ref7.offset, result = _ref7.result, sessionId = _ref7.sessionId;
                                        queue.push({
                                            recognizing: {
                                                offset: offset,
                                                result: $87d76c69fba10416$var$serializeRecognitionResult(result),
                                                sessionId: sessionId
                                            }
                                        });
                                    };
                                    recognizer.sessionStarted = function(_, _ref8) {
                                        var sessionId = _ref8.sessionId;
                                        queue.push({
                                            sessionStarted: {
                                                sessionId: sessionId
                                            }
                                        });
                                    };
                                    recognizer.sessionStopped = function(_, _ref9) {
                                        var sessionId = _ref9.sessionId;
                                        // "sessionStopped" is never fired, probably because we are using startContinuousRecognitionAsync instead of recognizeOnceAsync.
                                        queue.push({
                                            sessionStopped: {
                                                sessionId: sessionId
                                            }
                                        });
                                    };
                                    recognizer.speechStartDetected = function(_, _ref10) {
                                        var offset = _ref10.offset, sessionId = _ref10.sessionId;
                                        queue.push({
                                            speechStartDetected: {
                                                offset: offset,
                                                sessionId: sessionId
                                            }
                                        });
                                    };
                                    recognizer.speechEndDetected = function(_, _ref11) {
                                        var sessionId = _ref11.sessionId;
                                        // "speechEndDetected" is never fired, probably because we are using startContinuousRecognitionAsync instead of recognizeOnceAsync.
                                        // Update: "speechEndDetected" is fired for DLSpeech.listenOnceAsync()
                                        queue.push({
                                            speechEndDetected: {
                                                sessionId: sessionId
                                            }
                                        });
                                    };
                                    phrases = this.grammars.phrases; // HACK: We are using the internal of SpeechRecognizer because they did not expose it
                                    dynamicGrammar = recognizer.privReco.dynamicGrammar;
                                    referenceGrammars && referenceGrammars.length && dynamicGrammar.addReferenceGrammar(referenceGrammars);
                                    phrases && phrases.length && dynamicGrammar.addPhrase(phrases);
                                    _context4.next = 20;
                                    return $87d76c69fba10416$var$cognitiveServicesAsyncToPromise(recognizer.startContinuousRecognitionAsync.bind(recognizer))();
                                case 20:
                                    if (recognizer.stopContinuousRecognitionAsync) {
                                        this.abort = function() {
                                            return queue.push({
                                                abort: {}
                                            });
                                        };
                                        this.stop = function() {
                                            return queue.push({
                                                stop: {}
                                            });
                                        };
                                    } else this.abort = this.stop = undefined;
                                    finalizedResults = [];
                                    _loop = /*#__PURE__*/ $87d76c69fba10416$var$_regenerator.default.mark(function _loop(loop) {
                                        var event, abort, audioSourceOff, audioSourceReady, canceled, firstAudibleChunk, recognized, recognizing, stop, errorMessage, result, recognizable;
                                        return $87d76c69fba10416$var$_regenerator.default.wrap(function _loop$(_context3) {
                                            while(true)switch(_context3.prev = _context3.next){
                                                case 0:
                                                    _context3.next = 2;
                                                    return queue.shift();
                                                case 2:
                                                    event = _context3.sent;
                                                    abort = event.abort, audioSourceOff = event.audioSourceOff, audioSourceReady = event.audioSourceReady, canceled = event.canceled, firstAudibleChunk = event.firstAudibleChunk, recognized = event.recognized, recognizing = event.recognizing, stop = event.stop; // We are emitting event "cognitiveservices" for debugging purpose.
                                                    Object.keys(event).forEach(function(name) {
                                                        return _this4.emitCognitiveServices(name, event[name]);
                                                    });
                                                    errorMessage = canceled && canceled.errorDetails;
                                                    if (!/Permission[\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]denied/.test(errorMessage || "")) {
                                                        _context3.next = 9;
                                                        break;
                                                    }
                                                    // If microphone is not allowed, we should not emit "start" event.
                                                    finalEvent = {
                                                        error: "not-allowed",
                                                        type: "error"
                                                    };
                                                    return _context3.abrupt("return", "break");
                                                case 9:
                                                    if (!loop) _this4.dispatchEvent(new $87d76c69fba10416$var$SpeechRecognitionEvent("start"));
                                                    if (!errorMessage) {
                                                        _context3.next = 15;
                                                        break;
                                                    }
                                                    if (/1006/.test(errorMessage)) {
                                                        if (!audioStarted) {
                                                            _this4.dispatchEvent(new $87d76c69fba10416$var$SpeechRecognitionEvent("audiostart"));
                                                            _this4.dispatchEvent(new $87d76c69fba10416$var$SpeechRecognitionEvent("audioend"));
                                                        }
                                                        finalEvent = {
                                                            error: "network",
                                                            type: "error"
                                                        };
                                                    } else finalEvent = {
                                                        error: "unknown",
                                                        type: "error"
                                                    };
                                                    return _context3.abrupt("return", "break");
                                                case 15:
                                                    if (!(abort || stop)) {
                                                        _context3.next = 22;
                                                        break;
                                                    }
                                                    if (abort) {
                                                        finalEvent = {
                                                            error: "aborted",
                                                            type: "error"
                                                        }; // If we are aborting, we will ignore lingering recognizing/recognized events. But if we are stopping, we need them.
                                                        stopping = "abort";
                                                    } else {
                                                        // When we pause, we will send { isEnd: true }, Speech Services will send us "recognized" event.
                                                        pause();
                                                        stopping = "stop";
                                                    } // Abort should not be dispatched without support of "stopContinuousRecognitionAsync".
                                                    // But for defensive purpose, we make sure "stopContinuousRecognitionAsync" is available before we can call.
                                                    if (!(abort && recognizer.stopContinuousRecognitionAsync)) {
                                                        _context3.next = 20;
                                                        break;
                                                    }
                                                    _context3.next = 20;
                                                    return $87d76c69fba10416$var$cognitiveServicesAsyncToPromise(recognizer.stopContinuousRecognitionAsync.bind(recognizer))();
                                                case 20:
                                                    _context3.next = 61;
                                                    break;
                                                case 22:
                                                    if (!audioSourceReady) {
                                                        _context3.next = 27;
                                                        break;
                                                    }
                                                    _this4.dispatchEvent(new $87d76c69fba10416$var$SpeechRecognitionEvent("audiostart"));
                                                    audioStarted = true;
                                                    _context3.next = 61;
                                                    break;
                                                case 27:
                                                    if (!firstAudibleChunk) {
                                                        _context3.next = 32;
                                                        break;
                                                    }
                                                    _this4.dispatchEvent(new $87d76c69fba10416$var$SpeechRecognitionEvent("soundstart"));
                                                    soundStarted = true;
                                                    _context3.next = 61;
                                                    break;
                                                case 32:
                                                    if (!audioSourceOff) {
                                                        _context3.next = 40;
                                                        break;
                                                    }
                                                    // Looks like we don't need this line and all the tests are still working.
                                                    // Guessing probably stopping is already truthy.
                                                    // stopping = true;
                                                    speechStarted && _this4.dispatchEvent(new $87d76c69fba10416$var$SpeechRecognitionEvent("speechend"));
                                                    soundStarted && _this4.dispatchEvent(new $87d76c69fba10416$var$SpeechRecognitionEvent("soundend"));
                                                    audioStarted && _this4.dispatchEvent(new $87d76c69fba10416$var$SpeechRecognitionEvent("audioend"));
                                                    audioStarted = soundStarted = speechStarted = false;
                                                    return _context3.abrupt("return", "break");
                                                case 40:
                                                    if (!(stopping !== "abort")) {
                                                        _context3.next = 61;
                                                        break;
                                                    }
                                                    if (!(recognized && recognized.result && recognized.result.reason === $87d76c69fba10416$var$ResultReason.NoMatch)) {
                                                        _context3.next = 45;
                                                        break;
                                                    }
                                                    finalEvent = {
                                                        error: "no-speech",
                                                        type: "error"
                                                    };
                                                    _context3.next = 61;
                                                    break;
                                                case 45:
                                                    if (!(recognized || recognizing)) {
                                                        _context3.next = 61;
                                                        break;
                                                    }
                                                    if (!audioStarted) {
                                                        // Unconfirmed prevention of quirks
                                                        _this4.dispatchEvent(new $87d76c69fba10416$var$SpeechRecognitionEvent("audiostart"));
                                                        audioStarted = true;
                                                    }
                                                    if (!soundStarted) {
                                                        _this4.dispatchEvent(new $87d76c69fba10416$var$SpeechRecognitionEvent("soundstart"));
                                                        soundStarted = true;
                                                    }
                                                    if (!speechStarted) {
                                                        _this4.dispatchEvent(new $87d76c69fba10416$var$SpeechRecognitionEvent("speechstart"));
                                                        speechStarted = true;
                                                    }
                                                    if (!recognized) {
                                                        _context3.next = 60;
                                                        break;
                                                    }
                                                    result = (0, $87d76c69fba10416$var$_cognitiveServiceEventResultToWebSpeechRecognitionResultList.default)(recognized.result, {
                                                        maxAlternatives: _this4.maxAlternatives,
                                                        textNormalization: textNormalization
                                                    });
                                                    recognizable = !!result[0].transcript;
                                                    if (recognizable) {
                                                        finalizedResults = [].concat((0, $87d76c69fba10416$var$_toConsumableArray2.default)(finalizedResults), [
                                                            result
                                                        ]);
                                                        _this4.continuous && _this4.dispatchEvent(new $87d76c69fba10416$var$SpeechRecognitionEvent("result", {
                                                            results: finalizedResults
                                                        }));
                                                    } // If it is continuous, we just sent the finalized results. So we don't need to send it again after "audioend" event.
                                                    if (_this4.continuous && recognizable) finalEvent = null;
                                                    else finalEvent = {
                                                        results: finalizedResults,
                                                        type: "result"
                                                    };
                                                    if (!(!_this4.continuous && recognizer.stopContinuousRecognitionAsync)) {
                                                        _context3.next = 57;
                                                        break;
                                                    }
                                                    _context3.next = 57;
                                                    return $87d76c69fba10416$var$cognitiveServicesAsyncToPromise(recognizer.stopContinuousRecognitionAsync.bind(recognizer))();
                                                case 57:
                                                    // If event order can be loosened, we can send the recognized event as soon as we receive it.
                                                    // 1. If it is not recognizable (no-speech), we should send an "error" event just before "end" event. We will not loosen "error" events.
                                                    if (looseEvents && finalEvent && recognizable) {
                                                        _this4.dispatchEvent(new $87d76c69fba10416$var$SpeechRecognitionEvent(finalEvent.type, finalEvent));
                                                        finalEvent = null;
                                                    }
                                                    _context3.next = 61;
                                                    break;
                                                case 60:
                                                    if (recognizing) _this4.interimResults && _this4.dispatchEvent(new $87d76c69fba10416$var$SpeechRecognitionEvent("result", {
                                                        results: [].concat((0, $87d76c69fba10416$var$_toConsumableArray2.default)(finalizedResults), [
                                                            (0, $87d76c69fba10416$var$_cognitiveServiceEventResultToWebSpeechRecognitionResultList.default)(recognizing.result, {
                                                                maxAlternatives: _this4.maxAlternatives,
                                                                textNormalization: textNormalization
                                                            })
                                                        ])
                                                    }));
                                                case 61:
                                                case "end":
                                                    return _context3.stop();
                                            }
                                        }, _loop);
                                    });
                                    loop = 0;
                                case 24:
                                    if (!(!stopping || audioStarted)) {
                                        _context4.next = 32;
                                        break;
                                    }
                                    return _context4.delegateYield(_loop(loop), "t0", 26);
                                case 26:
                                    _ret = _context4.t0;
                                    if (!(_ret === "break")) {
                                        _context4.next = 29;
                                        break;
                                    }
                                    return _context4.abrupt("break", 32);
                                case 29:
                                    loop++;
                                    _context4.next = 24;
                                    break;
                                case 32:
                                    if (speechStarted) this.dispatchEvent(new $87d76c69fba10416$var$SpeechRecognitionEvent("speechend"));
                                    if (soundStarted) this.dispatchEvent(new $87d76c69fba10416$var$SpeechRecognitionEvent("soundend"));
                                    if (audioStarted) this.dispatchEvent(new $87d76c69fba10416$var$SpeechRecognitionEvent("audioend"));
                                    if (finalEvent) {
                                        if (finalEvent.type === "result" && !finalEvent.results.length) finalEvent = {
                                            error: "no-speech",
                                            type: "error"
                                        };
                                        if (finalEvent.type === "error") this.dispatchEvent(new ErrorEvent("error", finalEvent));
                                        else this.dispatchEvent(new $87d76c69fba10416$var$SpeechRecognitionEvent(finalEvent.type, finalEvent));
                                    } // Even though there is no "start" event emitted, we will still emit "end" event
                                    // This is mainly for "microphone blocked" story.
                                    this.dispatchEvent(new $87d76c69fba10416$var$SpeechRecognitionEvent("end"));
                                    detachAudioConfigEvent();
                                    _context4.next = 44;
                                    break;
                                case 40:
                                    _context4.prev = 40;
                                    _context4.t1 = _context4["catch"](4);
                                    // Logging out the erorr because Speech SDK would fail silently.
                                    console.error(_context4.t1);
                                    throw _context4.t1;
                                case 44:
                                    _context4.prev = 44;
                                    unprepare();
                                    recognizer.dispose();
                                    return _context4.finish(44);
                                case 48:
                                case "end":
                                    return _context4.stop();
                            }
                        }, _callee3, this, [
                            [
                                4,
                                40,
                                44,
                                48
                            ]
                        ]);
                    }));
                    function _startOnce() {
                        return _startOnce2.apply(this, arguments);
                    }
                    return _startOnce;
                }()
            }
        ]);
        return SpeechRecognition;
    }($bgEWP.EventTarget);
    return {
        SpeechGrammarList: $87d76c69fba10416$var$_SpeechGrammarList.default,
        SpeechRecognition: SpeechRecognition,
        SpeechRecognitionEvent: $87d76c69fba10416$var$SpeechRecognitionEvent
    };
}
var $87d76c69fba10416$var$_default = function _default(options) {
    var _patchOptions = (0, $87d76c69fba10416$var$_patchOptions2.default)(options), _patchOptions$audioCo = _patchOptions.audioConfig, audioConfig = _patchOptions$audioCo === void 0 ? $87d76c69fba10416$var$AudioConfig.fromDefaultMicrophoneInput() : _patchOptions$audioCo, _patchOptions$enableT = _patchOptions.enableTelemetry, enableTelemetry = _patchOptions$enableT === void 0 ? true : _patchOptions$enableT, fetchCredentials = _patchOptions.fetchCredentials, looseEvents = _patchOptions.looseEvents, referenceGrammars = _patchOptions.referenceGrammars, speechRecognitionEndpointId = _patchOptions.speechRecognitionEndpointId, _patchOptions$textNor = _patchOptions.textNormalization, textNormalization = _patchOptions$textNor === void 0 ? "display" : _patchOptions$textNor;
    if (!audioConfig && (!window.navigator.mediaDevices || !window.navigator.mediaDevices.getUserMedia)) {
        console.warn("web-speech-cognitive-services: This browser does not support WebRTC and it will not work with Cognitive Services Speech Services.");
        return {};
    }
    var createRecognizer = /*#__PURE__*/ function() {
        var _ref12 = (0, $87d76c69fba10416$var$_asyncToGenerator2.default)(/*#__PURE__*/ $87d76c69fba10416$var$_regenerator.default.mark(function _callee4(lang) {
            var _yield$fetchCredentia, authorizationToken, region, speechRecognitionHostname, subscriptionKey, speechConfig, host;
            return $87d76c69fba10416$var$_regenerator.default.wrap(function _callee4$(_context5) {
                while(true)switch(_context5.prev = _context5.next){
                    case 0:
                        _context5.next = 2;
                        return fetchCredentials();
                    case 2:
                        _yield$fetchCredentia = _context5.sent;
                        authorizationToken = _yield$fetchCredentia.authorizationToken;
                        region = _yield$fetchCredentia.region;
                        speechRecognitionHostname = _yield$fetchCredentia.speechRecognitionHostname;
                        subscriptionKey = _yield$fetchCredentia.subscriptionKey;
                        if (speechRecognitionHostname) {
                            host = {
                                hostname: speechRecognitionHostname,
                                port: 443,
                                protocol: "wss:"
                            };
                            if (authorizationToken) {
                                speechConfig = $87d76c69fba10416$var$SpeechConfig.fromHost(host);
                                speechConfig.authorizationToken = authorizationToken;
                            } else speechConfig = $87d76c69fba10416$var$SpeechConfig.fromHost(host, subscriptionKey);
                        } else speechConfig = authorizationToken ? $87d76c69fba10416$var$SpeechConfig.fromAuthorizationToken(authorizationToken, region) : $87d76c69fba10416$var$SpeechConfig.fromSubscription(subscriptionKey, region);
                        if (speechRecognitionEndpointId) speechConfig.endpointId = speechRecognitionEndpointId;
                        speechConfig.outputFormat = $87d76c69fba10416$var$OutputFormat.Detailed;
                        speechConfig.speechRecognitionLanguage = lang || "en-US";
                        return _context5.abrupt("return", new $87d76c69fba10416$var$SpeechRecognizer(speechConfig, audioConfig));
                    case 12:
                    case "end":
                        return _context5.stop();
                }
            }, _callee4);
        }));
        return function createRecognizer(_x) {
            return _ref12.apply(this, arguments);
        };
    }();
    return $87d76c69fba10416$var$createSpeechRecognitionPonyfillFromRecognizer({
        audioConfig: audioConfig,
        createRecognizer: createRecognizer,
        enableTelemetry: enableTelemetry,
        looseEvents: looseEvents,
        referenceGrammars: referenceGrammars,
        textNormalization: textNormalization
    });
};
module.exports.default = $87d76c69fba10416$var$_default;

});
parcelRequire.register("jfaTe", function(module, exports) {
// TODO(Babel 8): Remove this file.

var $e027dd8a19de3659$var$runtime = (parcelRequire("eCbTy"))();
module.exports = $e027dd8a19de3659$var$runtime;
// Copied from https://github.com/facebook/regenerator/blob/main/packages/runtime/runtime.js#L736=
try {
    regeneratorRuntime = $e027dd8a19de3659$var$runtime;
} catch (accidentalStrictMode) {
    if (typeof globalThis === "object") globalThis.regeneratorRuntime = $e027dd8a19de3659$var$runtime;
    else Function("r", "regeneratorRuntime = r")($e027dd8a19de3659$var$runtime);
}

});
parcelRequire.register("eCbTy", function(module, exports) {

var $4AWWc = parcelRequire("4AWWc");
var $aa3dd76cbb1816c8$var$_typeof = $4AWWc.default;
function $aa3dd76cbb1816c8$var$_regeneratorRuntime() {
    "use strict";
    /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ module.exports = $aa3dd76cbb1816c8$var$_regeneratorRuntime = function _regeneratorRuntime() {
        return exports;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports;
    var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
    function define(obj, key, value) {
        return Object.defineProperty(obj, key, {
            value: value,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }), obj[key];
    }
    try {
        define({}, "");
    } catch (err) {
        define = function define(obj, key, value) {
            return obj[key] = value;
        };
    }
    function wrap(innerFn, outerFn, self, tryLocsList) {
        var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []);
        return generator._invoke = function(innerFn, self, context) {
            var state = "suspendedStart";
            return function(method, arg) {
                if ("executing" === state) throw new Error("Generator is already running");
                if ("completed" === state) {
                    if ("throw" === method) throw arg;
                    return doneResult();
                }
                for(context.method = method, context.arg = arg;;){
                    var delegate = context.delegate;
                    if (delegate) {
                        var delegateResult = maybeInvokeDelegate(delegate, context);
                        if (delegateResult) {
                            if (delegateResult === ContinueSentinel) continue;
                            return delegateResult;
                        }
                    }
                    if ("next" === context.method) context.sent = context._sent = context.arg;
                    else if ("throw" === context.method) {
                        if ("suspendedStart" === state) throw state = "completed", context.arg;
                        context.dispatchException(context.arg);
                    } else "return" === context.method && context.abrupt("return", context.arg);
                    state = "executing";
                    var record = tryCatch(innerFn, self, context);
                    if ("normal" === record.type) {
                        if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue;
                        return {
                            value: record.arg,
                            done: context.done
                        };
                    }
                    "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg);
                }
            };
        }(innerFn, self, context), generator;
    }
    function tryCatch(fn, obj, arg) {
        try {
            return {
                type: "normal",
                arg: fn.call(obj, arg)
            };
        } catch (err) {
            return {
                type: "throw",
                arg: err
            };
        }
    }
    exports.wrap = wrap;
    var ContinueSentinel = {};
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    var IteratorPrototype = {};
    define(IteratorPrototype, iteratorSymbol, function() {
        return this;
    });
    var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([])));
    NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype);
    var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
    function defineIteratorMethods(prototype) {
        [
            "next",
            "throw",
            "return"
        ].forEach(function(method) {
            define(prototype, method, function(arg) {
                return this._invoke(method, arg);
            });
        });
    }
    function AsyncIterator(generator, PromiseImpl) {
        function invoke(method, arg, resolve, reject) {
            var record = tryCatch(generator[method], generator, arg);
            if ("throw" !== record.type) {
                var result = record.arg, value = result.value;
                return value && "object" == $aa3dd76cbb1816c8$var$_typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function(value) {
                    invoke("next", value, resolve, reject);
                }, function(err) {
                    invoke("throw", err, resolve, reject);
                }) : PromiseImpl.resolve(value).then(function(unwrapped) {
                    result.value = unwrapped, resolve(result);
                }, function(error) {
                    return invoke("throw", error, resolve, reject);
                });
            }
            reject(record.arg);
        }
        var previousPromise;
        this._invoke = function(method, arg) {
            function callInvokeWithMethodAndArg() {
                return new PromiseImpl(function(resolve, reject) {
                    invoke(method, arg, resolve, reject);
                });
            }
            return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
        };
    }
    function maybeInvokeDelegate(delegate, context) {
        var method = delegate.iterator[context.method];
        if (undefined === method) {
            if (context.delegate = null, "throw" === context.method) {
                if (delegate.iterator["return"] && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel;
                context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method");
            }
            return ContinueSentinel;
        }
        var record = tryCatch(method, delegate.iterator, context.arg);
        if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel;
        var info = record.arg;
        return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel);
    }
    function pushTryEntry(locs) {
        var entry = {
            tryLoc: locs[0]
        };
        1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry);
    }
    function resetTryEntry(entry) {
        var record = entry.completion || {};
        record.type = "normal", delete record.arg, entry.completion = record;
    }
    function Context(tryLocsList) {
        this.tryEntries = [
            {
                tryLoc: "root"
            }
        ], tryLocsList.forEach(pushTryEntry, this), this.reset(!0);
    }
    function values(iterable) {
        if (iterable) {
            var iteratorMethod = iterable[iteratorSymbol];
            if (iteratorMethod) return iteratorMethod.call(iterable);
            if ("function" == typeof iterable.next) return iterable;
            if (!isNaN(iterable.length)) {
                var i = -1, next = function next() {
                    for(; ++i < iterable.length;){
                        if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next;
                    }
                    return next.value = undefined, next.done = !0, next;
                };
                return next.next = next;
            }
        }
        return {
            next: doneResult
        };
    }
    function doneResult() {
        return {
            value: undefined,
            done: !0
        };
    }
    return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function(genFun) {
        var ctor = "function" == typeof genFun && genFun.constructor;
        return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name));
    }, exports.mark = function(genFun) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun;
    }, exports.awrap = function(arg) {
        return {
            __await: arg
        };
    }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function() {
        return this;
    }), exports.AsyncIterator = AsyncIterator, exports.async = function(innerFn, outerFn, self, tryLocsList, PromiseImpl) {
        void 0 === PromiseImpl && (PromiseImpl = Promise);
        var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
        return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function(result) {
            return result.done ? result.value : iter.next();
        });
    }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function() {
        return this;
    }), define(Gp, "toString", function() {
        return "[object Generator]";
    }), exports.keys = function(object) {
        var keys = [];
        for(var key in object)keys.push(key);
        return keys.reverse(), function next() {
            for(; keys.length;){
                var key = keys.pop();
                if (key in object) return next.value = key, next.done = !1, next;
            }
            return next.done = !0, next;
        };
    }, exports.values = values, Context.prototype = {
        constructor: Context,
        reset: function reset(skipTempReset) {
            if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for(var name in this)"t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined);
        },
        stop: function stop() {
            this.done = !0;
            var rootRecord = this.tryEntries[0].completion;
            if ("throw" === rootRecord.type) throw rootRecord.arg;
            return this.rval;
        },
        dispatchException: function dispatchException(exception) {
            if (this.done) throw exception;
            var context = this;
            function handle(loc, caught) {
                return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught;
            }
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i], record = entry.completion;
                if ("root" === entry.tryLoc) return handle("end");
                if (entry.tryLoc <= this.prev) {
                    var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc");
                    if (hasCatch && hasFinally) {
                        if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
                        if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
                    } else if (hasCatch) {
                        if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
                    } else {
                        if (!hasFinally) throw new Error("try statement without catch or finally");
                        if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
                    }
                }
            }
        },
        abrupt: function abrupt(type, arg) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
                    var finallyEntry = entry;
                    break;
                }
            }
            finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null);
            var record = finallyEntry ? finallyEntry.completion : {};
            return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record);
        },
        complete: function complete(record, afterLoc) {
            if ("throw" === record.type) throw record.arg;
            return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel;
        },
        finish: function finish(finallyLoc) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel;
            }
        },
        "catch": function _catch(tryLoc) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.tryLoc === tryLoc) {
                    var record = entry.completion;
                    if ("throw" === record.type) {
                        var thrown = record.arg;
                        resetTryEntry(entry);
                    }
                    return thrown;
                }
            }
            throw new Error("illegal catch attempt");
        },
        delegateYield: function delegateYield(iterable, resultName, nextLoc) {
            return this.delegate = {
                iterator: values(iterable),
                resultName: resultName,
                nextLoc: nextLoc
            }, "next" === this.method && (this.arg = undefined), ContinueSentinel;
        }
    }, exports;
}
module.exports = $aa3dd76cbb1816c8$var$_regeneratorRuntime, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRequire.register("29hOE", function(module, exports) {

var $hQQTy = parcelRequire("hQQTy");

var $6CBqM = parcelRequire("6CBqM");

var $7UT1l = parcelRequire("7UT1l");

var $fvh8i = parcelRequire("fvh8i");
function $190a3decd35f64b1$var$_toConsumableArray(arr) {
    return $hQQTy(arr) || $6CBqM(arr) || $7UT1l(arr) || $fvh8i();
}
module.exports = $190a3decd35f64b1$var$_toConsumableArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRequire.register("hQQTy", function(module, exports) {

var $eKbfw = parcelRequire("eKbfw");
function $cff052dacbbf2405$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $eKbfw(arr);
}
module.exports = $cff052dacbbf2405$var$_arrayWithoutHoles, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRequire.register("eKbfw", function(module, exports) {
function $abbe1676c285a8db$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
module.exports = $abbe1676c285a8db$var$_arrayLikeToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRequire.register("6CBqM", function(module, exports) {
function $4d2353ade1bbbace$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
module.exports = $4d2353ade1bbbace$var$_iterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRequire.register("7UT1l", function(module, exports) {

var $eKbfw = parcelRequire("eKbfw");
function $5c38715623daea7e$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $eKbfw(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $eKbfw(o, minLen);
}
module.exports = $5c38715623daea7e$var$_unsupportedIterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRequire.register("fvh8i", function(module, exports) {
function $b4970a75aff3a30f$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
module.exports = $b4970a75aff3a30f$var$_nonIterableSpread, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRequire.register("jT3Iz", function(module, exports) {
function $e7a609b0f00e544b$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) resolve(value);
    else Promise.resolve(value).then(_next, _throw);
}
function $e7a609b0f00e544b$var$_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                $e7a609b0f00e544b$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                $e7a609b0f00e544b$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
module.exports = $e7a609b0f00e544b$var$_asyncToGenerator, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRequire.register("fQlXT", function(module, exports) {
function $b88cc02391971936$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $b88cc02391971936$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $b88cc02391971936$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $b88cc02391971936$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
module.exports = $b88cc02391971936$var$_createClass, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRequire.register("2wF0s", function(module, exports) {
function $1d6e60ef33234f2c$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
module.exports = $1d6e60ef33234f2c$var$_classCallCheck, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRequire.register("i2Ce6", function(module, exports) {

var $dvXGw = parcelRequire("dvXGw");
function $d22610e3a85443f0$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $dvXGw(subClass, superClass);
}
module.exports = $d22610e3a85443f0$var$_inherits, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRequire.register("dvXGw", function(module, exports) {
function $9d6c77cb9b27a1ce$var$_setPrototypeOf(o, p) {
    module.exports = $9d6c77cb9b27a1ce$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports;
    return $9d6c77cb9b27a1ce$var$_setPrototypeOf(o, p);
}
module.exports = $9d6c77cb9b27a1ce$var$_setPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRequire.register("2cKO9", function(module, exports) {

var $4AWWc = parcelRequire("4AWWc");
var $19b102d13c66c479$var$_typeof = $4AWWc.default;

var $f6IEs = parcelRequire("f6IEs");
function $19b102d13c66c479$var$_possibleConstructorReturn(self, call) {
    if (call && ($19b102d13c66c479$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $f6IEs(self);
}
module.exports = $19b102d13c66c479$var$_possibleConstructorReturn, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRequire.register("f6IEs", function(module, exports) {
function $affa0d6c6e7f9f9f$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
module.exports = $affa0d6c6e7f9f9f$var$_assertThisInitialized, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRequire.register("1AdHm", function(module, exports) {
function $1273c76c94727a9b$var$_getPrototypeOf(o) {
    module.exports = $1273c76c94727a9b$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    }, module.exports.__esModule = true, module.exports["default"] = module.exports;
    return $1273c76c94727a9b$var$_getPrototypeOf(o);
}
module.exports = $1273c76c94727a9b$var$_getPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRequire.register("1My6l", function(module, exports) {
"use strict";

var $lsqXV = parcelRequire("lsqXV");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $14c4b9f7a7c0747b$var$_default;

var $14c4b9f7a7c0747b$var$_arrayToMap = $lsqXV((parcelRequire("hleeF")));

var $14c4b9f7a7c0747b$var$_SpeechSDK = $lsqXV((parcelRequire("4PbZI")));
var $14c4b9f7a7c0747b$var$_SpeechSDK$ResultReas = $14c4b9f7a7c0747b$var$_SpeechSDK.default.ResultReason, $14c4b9f7a7c0747b$var$RecognizingSpeech = $14c4b9f7a7c0747b$var$_SpeechSDK$ResultReas.RecognizingSpeech, $14c4b9f7a7c0747b$var$RecognizedSpeech = $14c4b9f7a7c0747b$var$_SpeechSDK$ResultReas.RecognizedSpeech;
function $14c4b9f7a7c0747b$var$_default(result) {
    var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {}, _ref$maxAlternatives = _ref.maxAlternatives, maxAlternatives = _ref$maxAlternatives === void 0 ? Infinity : _ref$maxAlternatives, _ref$textNormalizatio = _ref.textNormalization, textNormalization = _ref$textNormalizatio === void 0 ? "display" : _ref$textNormalizatio;
    if (result.reason === $14c4b9f7a7c0747b$var$RecognizingSpeech || result.reason === $14c4b9f7a7c0747b$var$RecognizedSpeech && !result.json.NBest) {
        var resultList = [
            {
                confidence: 0.5,
                transcript: result.text
            }
        ];
        if (result.reason === $14c4b9f7a7c0747b$var$RecognizedSpeech) resultList.isFinal = true;
        return resultList;
    } else if (result.reason === $14c4b9f7a7c0747b$var$RecognizedSpeech) {
        var _resultList = (0, $14c4b9f7a7c0747b$var$_arrayToMap.default)((result.json.NBest || []).slice(0, maxAlternatives).map(function(_ref2) {
            var confidence = _ref2.Confidence, display = _ref2.Display, itn = _ref2.ITN, lexical = _ref2.Lexical, maskedITN = _ref2.MaskedITN;
            return {
                confidence: confidence,
                transcript: textNormalization === "itn" ? itn : textNormalization === "lexical" ? lexical : textNormalization === "maskeditn" ? maskedITN : display
            };
        }), {
            isFinal: true
        });
        return _resultList;
    }
    return [];
}

});
parcelRequire.register("hleeF", function(module, exports) {
"use strict";

var $lsqXV = parcelRequire("lsqXV");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $c9ff70b482b1e68a$var$_default;

var $c9ff70b482b1e68a$var$_defineProperty2 = $lsqXV((parcelRequire("7jg8p")));
function $c9ff70b482b1e68a$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $c9ff70b482b1e68a$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $c9ff70b482b1e68a$var$ownKeys(Object(source), !0).forEach(function(key) {
            (0, $c9ff70b482b1e68a$var$_defineProperty2.default)(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $c9ff70b482b1e68a$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $c9ff70b482b1e68a$var$_default(array, extras) {
    var map = $c9ff70b482b1e68a$var$_objectSpread($c9ff70b482b1e68a$var$_objectSpread($c9ff70b482b1e68a$var$_objectSpread({}, [].reduce.call(array, function(map, value, index) {
        map[index] = value;
        return map;
    }, {})), extras), {}, (0, $c9ff70b482b1e68a$var$_defineProperty2.default)({
        length: array.length
    }, Symbol.iterator, function() {
        return [].slice.call(map)[Symbol.iterator]();
    }));
    return map;
}

});

parcelRequire.register("4PbZI", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $icWGt = parcelRequire("icWGt");
// We are only importing what we need.
var $38353ab2e01148df$var$_default = {
    AudioConfig: $icWGt.AudioConfig,
    OutputFormat: $icWGt.OutputFormat,
    ResultReason: $icWGt.ResultReason,
    SpeechConfig: $icWGt.SpeechConfig,
    SpeechRecognizer: $icWGt.SpeechRecognizer
};
module.exports.default = $38353ab2e01148df$var$_default;

});
parcelRequire.register("icWGt", function(module, exports) {
"use strict";
var $d416de70326f465d$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $d416de70326f465d$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) $d416de70326f465d$var$__createBinding(exports, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $9h4kO = parcelRequire("9h4kO");

var $7srwU = parcelRequire("7srwU");
// Common.Storage.SetLocalStorage(new Common.Browser.LocalStorage());
// Common.Storage.SetSessionStorage(new Common.Browser.SessionStorage());
$7srwU.Events.instance.attachListener(new $9h4kO.ConsoleLoggingListener());

// Speech SDK API
$d416de70326f465d$var$__exportStar((parcelRequire("iQDnw")), module.exports);

});
parcelRequire.register("9h4kO", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
var $6c0910625fd26577$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $6c0910625fd26577$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) $6c0910625fd26577$var$__createBinding(exports, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$6c0910625fd26577$var$__exportStar((parcelRequire("aBjJN")), module.exports);

$6c0910625fd26577$var$__exportStar((parcelRequire("lRtbx")), module.exports);

$6c0910625fd26577$var$__exportStar((parcelRequire("fAkys")), module.exports);

$6c0910625fd26577$var$__exportStar((parcelRequire("if33N")), module.exports);

$6c0910625fd26577$var$__exportStar((parcelRequire("kEtWl")), module.exports);

$6c0910625fd26577$var$__exportStar((parcelRequire("yaYst")), module.exports);

$6c0910625fd26577$var$__exportStar((parcelRequire("hmlgZ")), module.exports);

$6c0910625fd26577$var$__exportStar((parcelRequire("1U5qe")), module.exports);

$6c0910625fd26577$var$__exportStar((parcelRequire("4DhJM")), module.exports);

$6c0910625fd26577$var$__exportStar((parcelRequire("c3lLr")), module.exports);

$6c0910625fd26577$var$__exportStar((parcelRequire("4MIZo")), module.exports);

});
parcelRequire.register("aBjJN", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ConsoleLoggingListener = void 0;

var $7srwU = parcelRequire("7srwU");
var $7b7cab8e485c699d$var$ConsoleLoggingListener = /** @class */ function() {
    function ConsoleLoggingListener(logLevelFilter) {
        var _this = this;
        if (logLevelFilter === void 0) logLevelFilter = $7srwU.EventType.Warning;
        this.onEvent = function(event) {
            if (event.eventType >= _this.privLogLevelFilter) {
                var log = _this.toString(event);
                switch(event.eventType){
                    case $7srwU.EventType.Debug:
                        // tslint:disable-next-line:no-console
                        console.debug(log);
                        break;
                    case $7srwU.EventType.Info:
                        // tslint:disable-next-line:no-console
                        console.info(log);
                        break;
                    case $7srwU.EventType.Warning:
                        // tslint:disable-next-line:no-console
                        console.warn(log);
                        break;
                    case $7srwU.EventType.Error:
                        // tslint:disable-next-line:no-console
                        console.error(log);
                        break;
                    default:
                        // tslint:disable-next-line:no-console
                        console.log(log);
                        break;
                }
            }
        };
        this.toString = function(event) {
            var logFragments = [
                "" + event.EventTime,
                "" + event.Name
            ];
            for(var prop in event)if (prop && event.hasOwnProperty(prop) && prop !== "eventTime" && prop !== "eventType" && prop !== "eventId" && prop !== "name" && prop !== "constructor") {
                var value = event[prop];
                var valueToLog = "<NULL>";
                if (value !== undefined && value !== null) {
                    if (typeof value === "number" || typeof value === "string") valueToLog = value.toString();
                    else valueToLog = JSON.stringify(value);
                }
                logFragments.push(prop + ": " + valueToLog);
            }
            return logFragments.join(" | ");
        };
        this.privLogLevelFilter = logLevelFilter;
    }
    return ConsoleLoggingListener;
}();
module.exports.ConsoleLoggingListener = $7b7cab8e485c699d$var$ConsoleLoggingListener;

});
parcelRequire.register("7srwU", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
var $56e080bf35d38109$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $56e080bf35d38109$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) $56e080bf35d38109$var$__createBinding(exports, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$56e080bf35d38109$var$__exportStar((parcelRequire("9SplQ")), module.exports);

$56e080bf35d38109$var$__exportStar((parcelRequire("g9VXc")), module.exports);

$56e080bf35d38109$var$__exportStar((parcelRequire("6jh4n")), module.exports);

$56e080bf35d38109$var$__exportStar((parcelRequire("7uTv5")), module.exports);

$56e080bf35d38109$var$__exportStar((parcelRequire("cf3Wp")), module.exports);

$56e080bf35d38109$var$__exportStar((parcelRequire("7YICj")), module.exports);

$56e080bf35d38109$var$__exportStar((parcelRequire("9EZm0")), module.exports);

$56e080bf35d38109$var$__exportStar((parcelRequire("fdZP5")), module.exports);

$56e080bf35d38109$var$__exportStar((parcelRequire("6B7tN")), module.exports);

$56e080bf35d38109$var$__exportStar((parcelRequire("1mX7i")), module.exports);

$56e080bf35d38109$var$__exportStar((parcelRequire("gjgOA")), module.exports);

$56e080bf35d38109$var$__exportStar((parcelRequire("8GXh4")), module.exports);

$56e080bf35d38109$var$__exportStar((parcelRequire("94ECO")), module.exports);

$56e080bf35d38109$var$__exportStar((parcelRequire("eeTYk")), module.exports);

$56e080bf35d38109$var$__exportStar((parcelRequire("8jh0O")), module.exports);

$56e080bf35d38109$var$__exportStar((parcelRequire("ks7hR")), module.exports);

$56e080bf35d38109$var$__exportStar((parcelRequire("2L3lu")), module.exports);

$56e080bf35d38109$var$__exportStar((parcelRequire("5N33k")), module.exports);

$56e080bf35d38109$var$__exportStar((parcelRequire("48xKX")), module.exports);

$56e080bf35d38109$var$__exportStar((parcelRequire("1HDz4")), module.exports);

$56e080bf35d38109$var$__exportStar((parcelRequire("5uWXA")), module.exports);

$56e080bf35d38109$var$__exportStar((parcelRequire("7khmB")), module.exports);

$56e080bf35d38109$var$__exportStar((parcelRequire("dLqx3")), module.exports);

$56e080bf35d38109$var$__exportStar((parcelRequire("fheVe")), module.exports);

$56e080bf35d38109$var$__exportStar((parcelRequire("jjaOf")), module.exports);

var $hlsVP = parcelRequire("hlsVP");
Object.defineProperty(module.exports, "TranslationStatus", {
    enumerable: true,
    get: function() {
        return $hlsVP.TranslationStatus;
    }
});

$56e080bf35d38109$var$__exportStar((parcelRequire("lkPVc")), module.exports);

$56e080bf35d38109$var$__exportStar((parcelRequire("gOfY7")), module.exports);

$56e080bf35d38109$var$__exportStar((parcelRequire("5qmAd")), module.exports);

$56e080bf35d38109$var$__exportStar((parcelRequire("5AaWw")), module.exports);

$56e080bf35d38109$var$__exportStar((parcelRequire("arl3z")), module.exports);

});
parcelRequire.register("9SplQ", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
var $730cd26fa4b83c68$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.AudioStreamNodeErrorEvent = module.exports.AudioStreamNodeDetachedEvent = module.exports.AudioStreamNodeAttachedEvent = module.exports.AudioStreamNodeAttachingEvent = module.exports.AudioStreamNodeEvent = module.exports.AudioSourceErrorEvent = module.exports.AudioSourceOffEvent = module.exports.AudioSourceReadyEvent = module.exports.AudioSourceInitializingEvent = module.exports.AudioSourceEvent = void 0;

var $1HDz4 = parcelRequire("1HDz4");
var $730cd26fa4b83c68$var$AudioSourceEvent = /** @class */ function(_super) {
    $730cd26fa4b83c68$var$__extends(AudioSourceEvent, _super);
    function AudioSourceEvent(eventName, audioSourceId, eventType) {
        if (eventType === void 0) eventType = $1HDz4.EventType.Info;
        var _this = _super.call(this, eventName, eventType) || this;
        _this.privAudioSourceId = audioSourceId;
        return _this;
    }
    Object.defineProperty(AudioSourceEvent.prototype, "audioSourceId", {
        get: function() {
            return this.privAudioSourceId;
        },
        enumerable: false,
        configurable: true
    });
    return AudioSourceEvent;
}($1HDz4.PlatformEvent);
module.exports.AudioSourceEvent = $730cd26fa4b83c68$var$AudioSourceEvent;
var $730cd26fa4b83c68$var$AudioSourceInitializingEvent = /** @class */ function(_super) {
    $730cd26fa4b83c68$var$__extends(AudioSourceInitializingEvent, _super);
    function AudioSourceInitializingEvent(audioSourceId) {
        return _super.call(this, "AudioSourceInitializingEvent", audioSourceId) || this;
    }
    return AudioSourceInitializingEvent;
}($730cd26fa4b83c68$var$AudioSourceEvent);
module.exports.AudioSourceInitializingEvent = $730cd26fa4b83c68$var$AudioSourceInitializingEvent;
var $730cd26fa4b83c68$var$AudioSourceReadyEvent = /** @class */ function(_super) {
    $730cd26fa4b83c68$var$__extends(AudioSourceReadyEvent, _super);
    function AudioSourceReadyEvent(audioSourceId) {
        return _super.call(this, "AudioSourceReadyEvent", audioSourceId) || this;
    }
    return AudioSourceReadyEvent;
}($730cd26fa4b83c68$var$AudioSourceEvent);
module.exports.AudioSourceReadyEvent = $730cd26fa4b83c68$var$AudioSourceReadyEvent;
var $730cd26fa4b83c68$var$AudioSourceOffEvent = /** @class */ function(_super) {
    $730cd26fa4b83c68$var$__extends(AudioSourceOffEvent, _super);
    function AudioSourceOffEvent(audioSourceId) {
        return _super.call(this, "AudioSourceOffEvent", audioSourceId) || this;
    }
    return AudioSourceOffEvent;
}($730cd26fa4b83c68$var$AudioSourceEvent);
module.exports.AudioSourceOffEvent = $730cd26fa4b83c68$var$AudioSourceOffEvent;
var $730cd26fa4b83c68$var$AudioSourceErrorEvent = /** @class */ function(_super) {
    $730cd26fa4b83c68$var$__extends(AudioSourceErrorEvent, _super);
    function AudioSourceErrorEvent(audioSourceId, error) {
        var _this = _super.call(this, "AudioSourceErrorEvent", audioSourceId, $1HDz4.EventType.Error) || this;
        _this.privError = error;
        return _this;
    }
    Object.defineProperty(AudioSourceErrorEvent.prototype, "error", {
        get: function() {
            return this.privError;
        },
        enumerable: false,
        configurable: true
    });
    return AudioSourceErrorEvent;
}($730cd26fa4b83c68$var$AudioSourceEvent);
module.exports.AudioSourceErrorEvent = $730cd26fa4b83c68$var$AudioSourceErrorEvent;
var $730cd26fa4b83c68$var$AudioStreamNodeEvent = /** @class */ function(_super) {
    $730cd26fa4b83c68$var$__extends(AudioStreamNodeEvent, _super);
    function AudioStreamNodeEvent(eventName, audioSourceId, audioNodeId) {
        var _this = _super.call(this, eventName, audioSourceId) || this;
        _this.privAudioNodeId = audioNodeId;
        return _this;
    }
    Object.defineProperty(AudioStreamNodeEvent.prototype, "audioNodeId", {
        get: function() {
            return this.privAudioNodeId;
        },
        enumerable: false,
        configurable: true
    });
    return AudioStreamNodeEvent;
}($730cd26fa4b83c68$var$AudioSourceEvent);
module.exports.AudioStreamNodeEvent = $730cd26fa4b83c68$var$AudioStreamNodeEvent;
var $730cd26fa4b83c68$var$AudioStreamNodeAttachingEvent = /** @class */ function(_super) {
    $730cd26fa4b83c68$var$__extends(AudioStreamNodeAttachingEvent, _super);
    function AudioStreamNodeAttachingEvent(audioSourceId, audioNodeId) {
        return _super.call(this, "AudioStreamNodeAttachingEvent", audioSourceId, audioNodeId) || this;
    }
    return AudioStreamNodeAttachingEvent;
}($730cd26fa4b83c68$var$AudioStreamNodeEvent);
module.exports.AudioStreamNodeAttachingEvent = $730cd26fa4b83c68$var$AudioStreamNodeAttachingEvent;
var $730cd26fa4b83c68$var$AudioStreamNodeAttachedEvent = /** @class */ function(_super) {
    $730cd26fa4b83c68$var$__extends(AudioStreamNodeAttachedEvent, _super);
    function AudioStreamNodeAttachedEvent(audioSourceId, audioNodeId) {
        return _super.call(this, "AudioStreamNodeAttachedEvent", audioSourceId, audioNodeId) || this;
    }
    return AudioStreamNodeAttachedEvent;
}($730cd26fa4b83c68$var$AudioStreamNodeEvent);
module.exports.AudioStreamNodeAttachedEvent = $730cd26fa4b83c68$var$AudioStreamNodeAttachedEvent;
var $730cd26fa4b83c68$var$AudioStreamNodeDetachedEvent = /** @class */ function(_super) {
    $730cd26fa4b83c68$var$__extends(AudioStreamNodeDetachedEvent, _super);
    function AudioStreamNodeDetachedEvent(audioSourceId, audioNodeId) {
        return _super.call(this, "AudioStreamNodeDetachedEvent", audioSourceId, audioNodeId) || this;
    }
    return AudioStreamNodeDetachedEvent;
}($730cd26fa4b83c68$var$AudioStreamNodeEvent);
module.exports.AudioStreamNodeDetachedEvent = $730cd26fa4b83c68$var$AudioStreamNodeDetachedEvent;
var $730cd26fa4b83c68$var$AudioStreamNodeErrorEvent = /** @class */ function(_super) {
    $730cd26fa4b83c68$var$__extends(AudioStreamNodeErrorEvent, _super);
    function AudioStreamNodeErrorEvent(audioSourceId, audioNodeId, error) {
        var _this = _super.call(this, "AudioStreamNodeErrorEvent", audioSourceId, audioNodeId) || this;
        _this.privError = error;
        return _this;
    }
    Object.defineProperty(AudioStreamNodeErrorEvent.prototype, "error", {
        get: function() {
            return this.privError;
        },
        enumerable: false,
        configurable: true
    });
    return AudioStreamNodeErrorEvent;
}($730cd26fa4b83c68$var$AudioStreamNodeEvent);
module.exports.AudioStreamNodeErrorEvent = $730cd26fa4b83c68$var$AudioStreamNodeErrorEvent;

});
parcelRequire.register("1HDz4", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PlatformEvent = module.exports.EventType = void 0;

var $6B7tN = parcelRequire("6B7tN");
var $13d87f54359d7c11$var$EventType;
(function(EventType) {
    EventType[EventType["Debug"] = 0] = "Debug";
    EventType[EventType["Info"] = 1] = "Info";
    EventType[EventType["Warning"] = 2] = "Warning";
    EventType[EventType["Error"] = 3] = "Error";
})($13d87f54359d7c11$var$EventType = module.exports.EventType || (module.exports.EventType = {}));
var $13d87f54359d7c11$var$PlatformEvent = /** @class */ function() {
    function PlatformEvent(eventName, eventType) {
        this.privName = eventName;
        this.privEventId = $6B7tN.createNoDashGuid();
        this.privEventTime = new Date().toISOString();
        this.privEventType = eventType;
        this.privMetadata = {};
    }
    Object.defineProperty(PlatformEvent.prototype, "name", {
        get: function() {
            return this.privName;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PlatformEvent.prototype, "eventId", {
        get: function() {
            return this.privEventId;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PlatformEvent.prototype, "eventTime", {
        get: function() {
            return this.privEventTime;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PlatformEvent.prototype, "eventType", {
        get: function() {
            return this.privEventType;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PlatformEvent.prototype, "metadata", {
        get: function() {
            return this.privMetadata;
        },
        enumerable: false,
        configurable: true
    });
    return PlatformEvent;
}();
module.exports.PlatformEvent = $13d87f54359d7c11$var$PlatformEvent;

});
parcelRequire.register("6B7tN", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.createNoDashGuid = module.exports.createGuid = void 0;

var $hG6NY = parcelRequire("hG6NY");
var $4cdc000d22450c18$var$createGuid = function() {
    return $hG6NY.v4();
};
module.exports.createGuid = $4cdc000d22450c18$var$createGuid;
var $4cdc000d22450c18$var$createNoDashGuid = function() {
    return $4cdc000d22450c18$var$createGuid().replace(new RegExp("-", "g"), "").toUpperCase();
};
module.exports.createNoDashGuid = $4cdc000d22450c18$var$createNoDashGuid;

});
parcelRequire.register("hG6NY", function(module, exports) {

var $8c4kl = parcelRequire("8c4kl");

var $d8krE = parcelRequire("d8krE");
var $cdeba33e2d1b5e24$var$uuid = $d8krE;
$cdeba33e2d1b5e24$var$uuid.v1 = $8c4kl;
$cdeba33e2d1b5e24$var$uuid.v4 = $d8krE;
module.exports = $cdeba33e2d1b5e24$var$uuid;

});
parcelRequire.register("8c4kl", function(module, exports) {

var $9XSGv = parcelRequire("9XSGv");

var $a5fe6 = parcelRequire("a5fe6");
// **`v1()` - Generate time-based UUID**
//
// Inspired by https://github.com/LiosK/UUID.js
// and http://docs.python.org/library/uuid.html
var $5f72ccfe77858eb1$var$_nodeId;
var $5f72ccfe77858eb1$var$_clockseq;
// Previous uuid creation time
var $5f72ccfe77858eb1$var$_lastMSecs = 0;
var $5f72ccfe77858eb1$var$_lastNSecs = 0;
// See https://github.com/uuidjs/uuid for API details
function $5f72ccfe77858eb1$var$v1(options, buf, offset) {
    var i = buf && offset || 0;
    var b = buf || [];
    options = options || {};
    var node = options.node || $5f72ccfe77858eb1$var$_nodeId;
    var clockseq = options.clockseq !== undefined ? options.clockseq : $5f72ccfe77858eb1$var$_clockseq;
    // node and clockseq need to be initialized to random values if they're not
    // specified.  We do this lazily to minimize issues related to insufficient
    // system entropy.  See #189
    if (node == null || clockseq == null) {
        var seedBytes = $9XSGv();
        if (node == null) // Per 4.5, create and 48-bit node id, (47 random bits + multicast bit = 1)
        node = $5f72ccfe77858eb1$var$_nodeId = [
            seedBytes[0] | 0x01,
            seedBytes[1],
            seedBytes[2],
            seedBytes[3],
            seedBytes[4],
            seedBytes[5]
        ];
        if (clockseq == null) // Per 4.2.2, randomize (14 bit) clockseq
        clockseq = $5f72ccfe77858eb1$var$_clockseq = (seedBytes[6] << 8 | seedBytes[7]) & 0x3fff;
    }
    // UUID timestamps are 100 nano-second units since the Gregorian epoch,
    // (1582-10-15 00:00).  JSNumbers aren't precise enough for this, so
    // time is handled internally as 'msecs' (integer milliseconds) and 'nsecs'
    // (100-nanoseconds offset from msecs) since unix epoch, 1970-01-01 00:00.
    var msecs = options.msecs !== undefined ? options.msecs : new Date().getTime();
    // Per 4.2.1.2, use count of uuid's generated during the current clock
    // cycle to simulate higher resolution clock
    var nsecs = options.nsecs !== undefined ? options.nsecs : $5f72ccfe77858eb1$var$_lastNSecs + 1;
    // Time since last uuid creation (in msecs)
    var dt = msecs - $5f72ccfe77858eb1$var$_lastMSecs + (nsecs - $5f72ccfe77858eb1$var$_lastNSecs) / 10000;
    // Per 4.2.1.2, Bump clockseq on clock regression
    if (dt < 0 && options.clockseq === undefined) clockseq = clockseq + 1 & 0x3fff;
    // Reset nsecs if clock regresses (new clockseq) or we've moved onto a new
    // time interval
    if ((dt < 0 || msecs > $5f72ccfe77858eb1$var$_lastMSecs) && options.nsecs === undefined) nsecs = 0;
    // Per 4.2.1.2 Throw error if too many uuids are requested
    if (nsecs >= 10000) throw new Error("uuid.v1(): Can't create more than 10M uuids/sec");
    $5f72ccfe77858eb1$var$_lastMSecs = msecs;
    $5f72ccfe77858eb1$var$_lastNSecs = nsecs;
    $5f72ccfe77858eb1$var$_clockseq = clockseq;
    // Per 4.1.4 - Convert from unix epoch to Gregorian epoch
    msecs += 12219292800000;
    // `time_low`
    var tl = ((msecs & 0xfffffff) * 10000 + nsecs) % 0x100000000;
    b[i++] = tl >>> 24 & 0xff;
    b[i++] = tl >>> 16 & 0xff;
    b[i++] = tl >>> 8 & 0xff;
    b[i++] = tl & 0xff;
    // `time_mid`
    var tmh = msecs / 0x100000000 * 10000 & 0xfffffff;
    b[i++] = tmh >>> 8 & 0xff;
    b[i++] = tmh & 0xff;
    // `time_high_and_version`
    b[i++] = tmh >>> 24 & 0xf | 0x10; // include version
    b[i++] = tmh >>> 16 & 0xff;
    // `clock_seq_hi_and_reserved` (Per 4.2.2 - include variant)
    b[i++] = clockseq >>> 8 | 0x80;
    // `clock_seq_low`
    b[i++] = clockseq & 0xff;
    // `node`
    for(var n = 0; n < 6; ++n)b[i + n] = node[n];
    return buf ? buf : $a5fe6(b);
}
module.exports = $5f72ccfe77858eb1$var$v1;

});
parcelRequire.register("9XSGv", function(module, exports) {
// Unique ID creation requires a high quality random # generator.  In the
// browser this is a little complicated due to unknown quality of Math.random()
// and inconsistent support for the `crypto` API.  We do the best we can via
// feature-detection
// getRandomValues needs to be invoked in a context where "this" is a Crypto
// implementation. Also, find the complete implementation of crypto on IE11.
var $74140af7c2e326a2$var$getRandomValues = typeof crypto != "undefined" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto != "undefined" && typeof window.msCrypto.getRandomValues == "function" && msCrypto.getRandomValues.bind(msCrypto);
if ($74140af7c2e326a2$var$getRandomValues) {
    // WHATWG crypto RNG - http://wiki.whatwg.org/wiki/Crypto
    var $74140af7c2e326a2$var$rnds8 = new Uint8Array(16); // eslint-disable-line no-undef
    module.exports = function whatwgRNG() {
        $74140af7c2e326a2$var$getRandomValues($74140af7c2e326a2$var$rnds8);
        return $74140af7c2e326a2$var$rnds8;
    };
} else {
    // Math.random()-based (RNG)
    //
    // If all else fails, use Math.random().  It's fast, but is of unspecified
    // quality.
    var $74140af7c2e326a2$var$rnds = new Array(16);
    module.exports = function mathRNG() {
        for(var i = 0, r; i < 16; i++){
            if ((i & 0x03) === 0) r = Math.random() * 0x100000000;
            $74140af7c2e326a2$var$rnds[i] = r >>> ((i & 0x03) << 3) & 0xff;
        }
        return $74140af7c2e326a2$var$rnds;
    };
}

});

parcelRequire.register("a5fe6", function(module, exports) {
/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */ var $75762eb08260999b$var$byteToHex = [];
for(var $75762eb08260999b$var$i = 0; $75762eb08260999b$var$i < 256; ++$75762eb08260999b$var$i)$75762eb08260999b$var$byteToHex[$75762eb08260999b$var$i] = ($75762eb08260999b$var$i + 0x100).toString(16).substr(1);
function $75762eb08260999b$var$bytesToUuid(buf, offset) {
    var i = offset || 0;
    var bth = $75762eb08260999b$var$byteToHex;
    // join used to fix memory issue caused by concatenation: https://bugs.chromium.org/p/v8/issues/detail?id=3175#c4
    return [
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        "-",
        bth[buf[i++]],
        bth[buf[i++]],
        "-",
        bth[buf[i++]],
        bth[buf[i++]],
        "-",
        bth[buf[i++]],
        bth[buf[i++]],
        "-",
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]]
    ].join("");
}
module.exports = $75762eb08260999b$var$bytesToUuid;

});


parcelRequire.register("d8krE", function(module, exports) {

var $9XSGv = parcelRequire("9XSGv");

var $a5fe6 = parcelRequire("a5fe6");
function $98fbe1ab98af5cb3$var$v4(options, buf, offset) {
    var i = buf && offset || 0;
    if (typeof options == "string") {
        buf = options === "binary" ? new Array(16) : null;
        options = null;
    }
    options = options || {};
    var rnds = options.random || (options.rng || $9XSGv)();
    // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80;
    // Copy bytes to buffer, if provided
    if (buf) for(var ii = 0; ii < 16; ++ii)buf[i + ii] = rnds[ii];
    return buf || $a5fe6(rnds);
}
module.exports = $98fbe1ab98af5cb3$var$v4;

});





parcelRequire.register("g9VXc", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
var $bc3a710646afef4d$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ConnectionMessageSentEvent = module.exports.ConnectionMessageReceivedEvent = module.exports.ConnectionEstablishErrorEvent = module.exports.ConnectionErrorEvent = module.exports.ConnectionClosedEvent = module.exports.ConnectionEstablishedEvent = module.exports.ConnectionStartEvent = module.exports.ConnectionEvent = module.exports.ServiceEvent = void 0;

var $1HDz4 = parcelRequire("1HDz4");
var $bc3a710646afef4d$var$ServiceEvent = /** @class */ function(_super) {
    $bc3a710646afef4d$var$__extends(ServiceEvent, _super);
    function ServiceEvent(eventName, jsonstring, eventType) {
        if (eventType === void 0) eventType = $1HDz4.EventType.Info;
        var _this = _super.call(this, eventName, eventType) || this;
        _this.privJsonResult = jsonstring;
        return _this;
    }
    Object.defineProperty(ServiceEvent.prototype, "jsonString", {
        get: function() {
            return this.privJsonResult;
        },
        enumerable: false,
        configurable: true
    });
    return ServiceEvent;
}($1HDz4.PlatformEvent);
module.exports.ServiceEvent = $bc3a710646afef4d$var$ServiceEvent;
var $bc3a710646afef4d$var$ConnectionEvent = /** @class */ function(_super) {
    $bc3a710646afef4d$var$__extends(ConnectionEvent, _super);
    function ConnectionEvent(eventName, connectionId, eventType) {
        if (eventType === void 0) eventType = $1HDz4.EventType.Info;
        var _this = _super.call(this, eventName, eventType) || this;
        _this.privConnectionId = connectionId;
        return _this;
    }
    Object.defineProperty(ConnectionEvent.prototype, "connectionId", {
        get: function() {
            return this.privConnectionId;
        },
        enumerable: false,
        configurable: true
    });
    return ConnectionEvent;
}($1HDz4.PlatformEvent);
module.exports.ConnectionEvent = $bc3a710646afef4d$var$ConnectionEvent;
var $bc3a710646afef4d$var$ConnectionStartEvent = /** @class */ function(_super) {
    $bc3a710646afef4d$var$__extends(ConnectionStartEvent, _super);
    function ConnectionStartEvent(connectionId, uri, headers) {
        var _this = _super.call(this, "ConnectionStartEvent", connectionId) || this;
        _this.privUri = uri;
        _this.privHeaders = headers;
        return _this;
    }
    Object.defineProperty(ConnectionStartEvent.prototype, "uri", {
        get: function() {
            return this.privUri;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ConnectionStartEvent.prototype, "headers", {
        get: function() {
            return this.privHeaders;
        },
        enumerable: false,
        configurable: true
    });
    return ConnectionStartEvent;
}($bc3a710646afef4d$var$ConnectionEvent);
module.exports.ConnectionStartEvent = $bc3a710646afef4d$var$ConnectionStartEvent;
var $bc3a710646afef4d$var$ConnectionEstablishedEvent = /** @class */ function(_super) {
    $bc3a710646afef4d$var$__extends(ConnectionEstablishedEvent, _super);
    function ConnectionEstablishedEvent(connectionId, metadata) {
        return _super.call(this, "ConnectionEstablishedEvent", connectionId) || this;
    }
    return ConnectionEstablishedEvent;
}($bc3a710646afef4d$var$ConnectionEvent);
module.exports.ConnectionEstablishedEvent = $bc3a710646afef4d$var$ConnectionEstablishedEvent;
var $bc3a710646afef4d$var$ConnectionClosedEvent = /** @class */ function(_super) {
    $bc3a710646afef4d$var$__extends(ConnectionClosedEvent, _super);
    function ConnectionClosedEvent(connectionId, statusCode, reason) {
        var _this = _super.call(this, "ConnectionClosedEvent", connectionId, $1HDz4.EventType.Debug) || this;
        _this.privReason = reason;
        _this.privStatusCode = statusCode;
        return _this;
    }
    Object.defineProperty(ConnectionClosedEvent.prototype, "reason", {
        get: function() {
            return this.privReason;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ConnectionClosedEvent.prototype, "statusCode", {
        get: function() {
            return this.privStatusCode;
        },
        enumerable: false,
        configurable: true
    });
    return ConnectionClosedEvent;
}($bc3a710646afef4d$var$ConnectionEvent);
module.exports.ConnectionClosedEvent = $bc3a710646afef4d$var$ConnectionClosedEvent;
var $bc3a710646afef4d$var$ConnectionErrorEvent = /** @class */ function(_super) {
    $bc3a710646afef4d$var$__extends(ConnectionErrorEvent, _super);
    function ConnectionErrorEvent(connectionId, message, type) {
        var _this = _super.call(this, "ConnectionErrorEvent", connectionId, $1HDz4.EventType.Debug) || this;
        _this.privMessage = message;
        _this.privType = type;
        return _this;
    }
    Object.defineProperty(ConnectionErrorEvent.prototype, "message", {
        get: function() {
            return this.privMessage;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ConnectionErrorEvent.prototype, "type", {
        get: function() {
            return this.privType;
        },
        enumerable: false,
        configurable: true
    });
    return ConnectionErrorEvent;
}($bc3a710646afef4d$var$ConnectionEvent);
module.exports.ConnectionErrorEvent = $bc3a710646afef4d$var$ConnectionErrorEvent;
var $bc3a710646afef4d$var$ConnectionEstablishErrorEvent = /** @class */ function(_super) {
    $bc3a710646afef4d$var$__extends(ConnectionEstablishErrorEvent, _super);
    function ConnectionEstablishErrorEvent(connectionId, statuscode, reason) {
        var _this = _super.call(this, "ConnectionEstablishErrorEvent", connectionId, $1HDz4.EventType.Error) || this;
        _this.privStatusCode = statuscode;
        _this.privReason = reason;
        return _this;
    }
    Object.defineProperty(ConnectionEstablishErrorEvent.prototype, "reason", {
        get: function() {
            return this.privReason;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ConnectionEstablishErrorEvent.prototype, "statusCode", {
        get: function() {
            return this.privStatusCode;
        },
        enumerable: false,
        configurable: true
    });
    return ConnectionEstablishErrorEvent;
}($bc3a710646afef4d$var$ConnectionEvent);
module.exports.ConnectionEstablishErrorEvent = $bc3a710646afef4d$var$ConnectionEstablishErrorEvent;
var $bc3a710646afef4d$var$ConnectionMessageReceivedEvent = /** @class */ function(_super) {
    $bc3a710646afef4d$var$__extends(ConnectionMessageReceivedEvent, _super);
    function ConnectionMessageReceivedEvent(connectionId, networkReceivedTimeISO, message) {
        var _this = _super.call(this, "ConnectionMessageReceivedEvent", connectionId) || this;
        _this.privNetworkReceivedTime = networkReceivedTimeISO;
        _this.privMessage = message;
        return _this;
    }
    Object.defineProperty(ConnectionMessageReceivedEvent.prototype, "networkReceivedTime", {
        get: function() {
            return this.privNetworkReceivedTime;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ConnectionMessageReceivedEvent.prototype, "message", {
        get: function() {
            return this.privMessage;
        },
        enumerable: false,
        configurable: true
    });
    return ConnectionMessageReceivedEvent;
}($bc3a710646afef4d$var$ConnectionEvent);
module.exports.ConnectionMessageReceivedEvent = $bc3a710646afef4d$var$ConnectionMessageReceivedEvent;
var $bc3a710646afef4d$var$ConnectionMessageSentEvent = /** @class */ function(_super) {
    $bc3a710646afef4d$var$__extends(ConnectionMessageSentEvent, _super);
    function ConnectionMessageSentEvent(connectionId, networkSentTimeISO, message) {
        var _this = _super.call(this, "ConnectionMessageSentEvent", connectionId) || this;
        _this.privNetworkSentTime = networkSentTimeISO;
        _this.privMessage = message;
        return _this;
    }
    Object.defineProperty(ConnectionMessageSentEvent.prototype, "networkSentTime", {
        get: function() {
            return this.privNetworkSentTime;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ConnectionMessageSentEvent.prototype, "message", {
        get: function() {
            return this.privMessage;
        },
        enumerable: false,
        configurable: true
    });
    return ConnectionMessageSentEvent;
}($bc3a710646afef4d$var$ConnectionEvent);
module.exports.ConnectionMessageSentEvent = $bc3a710646afef4d$var$ConnectionMessageSentEvent;

});

parcelRequire.register("6jh4n", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ConnectionMessage = module.exports.MessageType = void 0;

var $7YICj = parcelRequire("7YICj");

var $6B7tN = parcelRequire("6B7tN");
var $4981c21d2ee338bd$var$MessageType;
(function(MessageType) {
    MessageType[MessageType["Text"] = 0] = "Text";
    MessageType[MessageType["Binary"] = 1] = "Binary";
})($4981c21d2ee338bd$var$MessageType = module.exports.MessageType || (module.exports.MessageType = {}));
var $4981c21d2ee338bd$var$ConnectionMessage = /** @class */ function() {
    function ConnectionMessage(messageType, body, headers, id) {
        this.privBody = null;
        if (messageType === $4981c21d2ee338bd$var$MessageType.Text && body && !(typeof body === "string")) throw new $7YICj.InvalidOperationError("Payload must be a string");
        if (messageType === $4981c21d2ee338bd$var$MessageType.Binary && body && !(body instanceof ArrayBuffer)) throw new $7YICj.InvalidOperationError("Payload must be ArrayBuffer");
        this.privMessageType = messageType;
        this.privBody = body;
        this.privHeaders = headers ? headers : {};
        this.privId = id ? id : $6B7tN.createNoDashGuid();
        switch(this.messageType){
            case $4981c21d2ee338bd$var$MessageType.Binary:
                this.privSize = this.binaryBody !== null ? this.binaryBody.byteLength : 0;
                break;
            case $4981c21d2ee338bd$var$MessageType.Text:
                this.privSize = this.textBody.length;
        }
    }
    Object.defineProperty(ConnectionMessage.prototype, "messageType", {
        get: function() {
            return this.privMessageType;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ConnectionMessage.prototype, "headers", {
        get: function() {
            return this.privHeaders;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ConnectionMessage.prototype, "body", {
        get: function() {
            return this.privBody;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ConnectionMessage.prototype, "textBody", {
        get: function() {
            if (this.privMessageType === $4981c21d2ee338bd$var$MessageType.Binary) throw new $7YICj.InvalidOperationError("Not supported for binary message");
            return this.privBody;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ConnectionMessage.prototype, "binaryBody", {
        get: function() {
            if (this.privMessageType === $4981c21d2ee338bd$var$MessageType.Text) throw new $7YICj.InvalidOperationError("Not supported for text message");
            return this.privBody;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ConnectionMessage.prototype, "id", {
        get: function() {
            return this.privId;
        },
        enumerable: false,
        configurable: true
    });
    return ConnectionMessage;
}();
module.exports.ConnectionMessage = $4981c21d2ee338bd$var$ConnectionMessage;

});
parcelRequire.register("7YICj", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
var $5cf0beff2979dc1a$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ObjectDisposedError = module.exports.InvalidOperationError = module.exports.ArgumentNullError = void 0;
// tslint:disable:max-classes-per-file
/**
 * The error that is thrown when an argument passed in is null.
 *
 * @export
 * @class ArgumentNullError
 * @extends {Error}
 */ var $5cf0beff2979dc1a$var$ArgumentNullError = /** @class */ function(_super) {
    $5cf0beff2979dc1a$var$__extends(ArgumentNullError, _super);
    /**
     * Creates an instance of ArgumentNullError.
     *
     * @param {string} argumentName - Name of the argument that is null
     *
     * @memberOf ArgumentNullError
     */ function ArgumentNullError(argumentName) {
        var _this = _super.call(this, argumentName) || this;
        _this.name = "ArgumentNull";
        _this.message = argumentName;
        return _this;
    }
    return ArgumentNullError;
}(Error);
module.exports.ArgumentNullError = $5cf0beff2979dc1a$var$ArgumentNullError;
/**
 * The error that is thrown when an invalid operation is performed in the code.
 *
 * @export
 * @class InvalidOperationError
 * @extends {Error}
 */ var $5cf0beff2979dc1a$var$InvalidOperationError = /** @class */ function(_super) {
    $5cf0beff2979dc1a$var$__extends(InvalidOperationError, _super);
    /**
     * Creates an instance of InvalidOperationError.
     *
     * @param {string} error - The error
     *
     * @memberOf InvalidOperationError
     */ function InvalidOperationError(error) {
        var _this = _super.call(this, error) || this;
        _this.name = "InvalidOperation";
        _this.message = error;
        return _this;
    }
    return InvalidOperationError;
}(Error);
module.exports.InvalidOperationError = $5cf0beff2979dc1a$var$InvalidOperationError;
/**
 * The error that is thrown when an object is disposed.
 *
 * @export
 * @class ObjectDisposedError
 * @extends {Error}
 */ // tslint:disable-next-line:max-classes-per-file
var $5cf0beff2979dc1a$var$ObjectDisposedError = /** @class */ function(_super) {
    $5cf0beff2979dc1a$var$__extends(ObjectDisposedError, _super);
    /**
     * Creates an instance of ObjectDisposedError.
     *
     * @param {string} objectName - The object that is disposed
     * @param {string} error - The error
     *
     * @memberOf ObjectDisposedError
     */ function ObjectDisposedError(objectName, error) {
        var _this = _super.call(this, error) || this;
        _this.name = objectName + "ObjectDisposed";
        _this.message = error;
        return _this;
    }
    return ObjectDisposedError;
}(Error);
module.exports.ObjectDisposedError = $5cf0beff2979dc1a$var$ObjectDisposedError;

});


parcelRequire.register("7uTv5", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ConnectionOpenResponse = void 0;
var $575662f900291320$var$ConnectionOpenResponse = /** @class */ function() {
    function ConnectionOpenResponse(statusCode, reason) {
        this.privStatusCode = statusCode;
        this.privReason = reason;
    }
    Object.defineProperty(ConnectionOpenResponse.prototype, "statusCode", {
        get: function() {
            return this.privStatusCode;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ConnectionOpenResponse.prototype, "reason", {
        get: function() {
            return this.privReason;
        },
        enumerable: false,
        configurable: true
    });
    return ConnectionOpenResponse;
}();
module.exports.ConnectionOpenResponse = $575662f900291320$var$ConnectionOpenResponse;

});

parcelRequire.register("cf3Wp", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
var $8e99f15a04911b7d$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SendingAgentContextMessageEvent = module.exports.DialogEvent = void 0;

var $1HDz4 = parcelRequire("1HDz4");
var $8e99f15a04911b7d$var$DialogEvent = /** @class */ function(_super) {
    $8e99f15a04911b7d$var$__extends(DialogEvent, _super);
    function DialogEvent(eventName, eventType) {
        if (eventType === void 0) eventType = $1HDz4.EventType.Info;
        return _super.call(this, eventName, eventType) || this;
    }
    return DialogEvent;
}($1HDz4.PlatformEvent);
module.exports.DialogEvent = $8e99f15a04911b7d$var$DialogEvent;
var $8e99f15a04911b7d$var$SendingAgentContextMessageEvent = /** @class */ function(_super) {
    $8e99f15a04911b7d$var$__extends(SendingAgentContextMessageEvent, _super);
    function SendingAgentContextMessageEvent(agentConfig) {
        var _this = _super.call(this, "SendingAgentContextMessageEvent") || this;
        _this.privAgentConfig = agentConfig;
        return _this;
    }
    Object.defineProperty(SendingAgentContextMessageEvent.prototype, "agentConfig", {
        get: function() {
            return this.privAgentConfig;
        },
        enumerable: false,
        configurable: true
    });
    return SendingAgentContextMessageEvent;
}($8e99f15a04911b7d$var$DialogEvent);
module.exports.SendingAgentContextMessageEvent = $8e99f15a04911b7d$var$SendingAgentContextMessageEvent;

});

parcelRequire.register("9EZm0", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Events = void 0;

var $7YICj = parcelRequire("7YICj");

var $fdZP5 = parcelRequire("fdZP5");
var $7087711a0cf738b8$var$Events = /** @class */ function() {
    function Events() {}
    Object.defineProperty(Events, "instance", {
        get: function() {
            return Events.privInstance;
        },
        enumerable: false,
        configurable: true
    });
    Events.privInstance = new $fdZP5.EventSource();
    Events.setEventSource = function(eventSource) {
        if (!eventSource) throw new $7YICj.ArgumentNullError("eventSource");
        Events.privInstance = eventSource;
    };
    return Events;
}();
module.exports.Events = $7087711a0cf738b8$var$Events;

});
parcelRequire.register("fdZP5", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.EventSource = void 0;

var $7YICj = parcelRequire("7YICj");

var $6B7tN = parcelRequire("6B7tN");
var $b15806afa4e1095a$var$EventSource = /** @class */ function() {
    function EventSource(metadata) {
        var _this = this;
        this.privEventListeners = {};
        this.privIsDisposed = false;
        this.onEvent = function(event) {
            if (_this.isDisposed()) throw new $7YICj.ObjectDisposedError("EventSource");
            if (_this.metadata) {
                for(var paramName in _this.metadata)if (paramName) {
                    if (event.metadata) {
                        if (!event.metadata[paramName]) event.metadata[paramName] = _this.metadata[paramName];
                    }
                }
            }
            for(var eventId in _this.privEventListeners)if (eventId && _this.privEventListeners[eventId]) _this.privEventListeners[eventId](event);
        };
        this.attach = function(onEventCallback) {
            var id = $6B7tN.createNoDashGuid();
            _this.privEventListeners[id] = onEventCallback;
            return {
                detach: function() {
                    delete _this.privEventListeners[id];
                    return Promise.resolve();
                }
            };
        };
        this.attachListener = function(listener) {
            return _this.attach(listener.onEvent);
        };
        this.isDisposed = function() {
            return _this.privIsDisposed;
        };
        this.dispose = function() {
            _this.privEventListeners = null;
            _this.privIsDisposed = true;
        };
        this.privMetadata = metadata;
    }
    Object.defineProperty(EventSource.prototype, "metadata", {
        get: function() {
            return this.privMetadata;
        },
        enumerable: false,
        configurable: true
    });
    return EventSource;
}();
module.exports.EventSource = $b15806afa4e1095a$var$EventSource;

});


parcelRequire.register("1mX7i", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRequire.register("gjgOA", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ConnectionState = void 0;
var $bdfb76c75635e7a0$var$ConnectionState;
(function(ConnectionState) {
    ConnectionState[ConnectionState["None"] = 0] = "None";
    ConnectionState[ConnectionState["Connected"] = 1] = "Connected";
    ConnectionState[ConnectionState["Connecting"] = 2] = "Connecting";
    ConnectionState[ConnectionState["Disconnected"] = 3] = "Disconnected";
})($bdfb76c75635e7a0$var$ConnectionState = module.exports.ConnectionState || (module.exports.ConnectionState = {}));

});

parcelRequire.register("8GXh4", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRequire.register("94ECO", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRequire.register("eeTYk", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRequire.register("8jh0O", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRequire.register("ks7hR", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRequire.register("2L3lu", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRequire.register("5N33k", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRequire.register("48xKX", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.List = void 0;

var $7YICj = parcelRequire("7YICj");
var $30321814c18a51f1$var$List = /** @class */ function() {
    function List(list) {
        var _this = this;
        this.privSubscriptionIdCounter = 0;
        this.privAddSubscriptions = {};
        this.privRemoveSubscriptions = {};
        this.privDisposedSubscriptions = {};
        this.privDisposeReason = null;
        this.get = function(itemIndex) {
            _this.throwIfDisposed();
            return _this.privList[itemIndex];
        };
        this.first = function() {
            return _this.get(0);
        };
        this.last = function() {
            return _this.get(_this.length() - 1);
        };
        this.add = function(item) {
            _this.throwIfDisposed();
            _this.insertAt(_this.privList.length, item);
        };
        this.insertAt = function(index, item) {
            _this.throwIfDisposed();
            if (index === 0) _this.privList.unshift(item);
            else if (index === _this.privList.length) _this.privList.push(item);
            else _this.privList.splice(index, 0, item);
            _this.triggerSubscriptions(_this.privAddSubscriptions);
        };
        this.removeFirst = function() {
            _this.throwIfDisposed();
            return _this.removeAt(0);
        };
        this.removeLast = function() {
            _this.throwIfDisposed();
            return _this.removeAt(_this.length() - 1);
        };
        this.removeAt = function(index) {
            _this.throwIfDisposed();
            return _this.remove(index, 1)[0];
        };
        this.remove = function(index, count) {
            _this.throwIfDisposed();
            var removedElements = _this.privList.splice(index, count);
            _this.triggerSubscriptions(_this.privRemoveSubscriptions);
            return removedElements;
        };
        this.clear = function() {
            _this.throwIfDisposed();
            _this.remove(0, _this.length());
        };
        this.length = function() {
            _this.throwIfDisposed();
            return _this.privList.length;
        };
        this.onAdded = function(addedCallback) {
            _this.throwIfDisposed();
            var subscriptionId = _this.privSubscriptionIdCounter++;
            _this.privAddSubscriptions[subscriptionId] = addedCallback;
            return {
                detach: function() {
                    delete _this.privAddSubscriptions[subscriptionId];
                    return Promise.resolve();
                }
            };
        };
        this.onRemoved = function(removedCallback) {
            _this.throwIfDisposed();
            var subscriptionId = _this.privSubscriptionIdCounter++;
            _this.privRemoveSubscriptions[subscriptionId] = removedCallback;
            return {
                detach: function() {
                    delete _this.privRemoveSubscriptions[subscriptionId];
                    return Promise.resolve();
                }
            };
        };
        this.onDisposed = function(disposedCallback) {
            _this.throwIfDisposed();
            var subscriptionId = _this.privSubscriptionIdCounter++;
            _this.privDisposedSubscriptions[subscriptionId] = disposedCallback;
            return {
                detach: function() {
                    delete _this.privDisposedSubscriptions[subscriptionId];
                    return Promise.resolve();
                }
            };
        };
        this.join = function(seperator) {
            _this.throwIfDisposed();
            return _this.privList.join(seperator);
        };
        this.toArray = function() {
            var cloneCopy = Array();
            _this.privList.forEach(function(val) {
                cloneCopy.push(val);
            });
            return cloneCopy;
        };
        this.any = function(callback) {
            _this.throwIfDisposed();
            if (callback) return _this.where(callback).length() > 0;
            else return _this.length() > 0;
        };
        this.all = function(callback) {
            _this.throwIfDisposed();
            return _this.where(callback).length() === _this.length();
        };
        this.forEach = function(callback) {
            _this.throwIfDisposed();
            for(var i = 0; i < _this.length(); i++)callback(_this.privList[i], i);
        };
        this.select = function(callback) {
            _this.throwIfDisposed();
            var selectList = [];
            for(var i = 0; i < _this.privList.length; i++)selectList.push(callback(_this.privList[i], i));
            return new List(selectList);
        };
        this.where = function(callback) {
            _this.throwIfDisposed();
            var filteredList = new List();
            for(var i = 0; i < _this.privList.length; i++)if (callback(_this.privList[i], i)) filteredList.add(_this.privList[i]);
            return filteredList;
        };
        this.orderBy = function(compareFn) {
            _this.throwIfDisposed();
            var clonedArray = _this.toArray();
            var orderedArray = clonedArray.sort(compareFn);
            return new List(orderedArray);
        };
        this.orderByDesc = function(compareFn) {
            _this.throwIfDisposed();
            return _this.orderBy(function(a, b) {
                return compareFn(b, a);
            });
        };
        this.clone = function() {
            _this.throwIfDisposed();
            return new List(_this.toArray());
        };
        this.concat = function(list) {
            _this.throwIfDisposed();
            return new List(_this.privList.concat(list.toArray()));
        };
        this.concatArray = function(array) {
            _this.throwIfDisposed();
            return new List(_this.privList.concat(array));
        };
        this.isDisposed = function() {
            return _this.privList == null;
        };
        this.dispose = function(reason) {
            if (!_this.isDisposed()) {
                _this.privDisposeReason = reason;
                _this.privList = null;
                _this.privAddSubscriptions = null;
                _this.privRemoveSubscriptions = null;
                _this.triggerSubscriptions(_this.privDisposedSubscriptions);
            }
        };
        this.throwIfDisposed = function() {
            if (_this.isDisposed()) throw new $7YICj.ObjectDisposedError("List", _this.privDisposeReason);
        };
        this.triggerSubscriptions = function(subscriptions) {
            if (subscriptions) {
                for(var subscriptionId in subscriptions)if (subscriptionId) subscriptions[subscriptionId]();
            }
        };
        this.privList = [];
        // copy the list rather than taking as is.
        if (list) for(var _i = 0, list_1 = list; _i < list_1.length; _i++){
            var item = list_1[_i];
            this.privList.push(item);
        }
    }
    return List;
}();
module.exports.List = $30321814c18a51f1$var$List;

});

parcelRequire.register("5uWXA", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.marshalPromiseToCallbacks = module.exports.Sink = module.exports.Deferred = module.exports.PromiseResultEventSource = module.exports.PromiseResult = module.exports.PromiseState = void 0;
var $400d7d5a515c2d8b$var$PromiseState;
(function(PromiseState) {
    PromiseState[PromiseState["None"] = 0] = "None";
    PromiseState[PromiseState["Resolved"] = 1] = "Resolved";
    PromiseState[PromiseState["Rejected"] = 2] = "Rejected";
})($400d7d5a515c2d8b$var$PromiseState = module.exports.PromiseState || (module.exports.PromiseState = {}));
var $400d7d5a515c2d8b$var$PromiseResult = /** @class */ function() {
    function PromiseResult(promiseResultEventSource) {
        var _this = this;
        this.throwIfError = function() {
            if (_this.isError) throw _this.error;
        };
        promiseResultEventSource.on(function(result) {
            if (!_this.privIsCompleted) {
                _this.privIsCompleted = true;
                _this.privIsError = false;
                _this.privResult = result;
            }
        }, function(error) {
            if (!_this.privIsCompleted) {
                _this.privIsCompleted = true;
                _this.privIsError = true;
                _this.privError = error;
            }
        });
    }
    Object.defineProperty(PromiseResult.prototype, "isCompleted", {
        get: function() {
            return this.privIsCompleted;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PromiseResult.prototype, "isError", {
        get: function() {
            return this.privIsError;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PromiseResult.prototype, "error", {
        get: function() {
            return this.privError;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PromiseResult.prototype, "result", {
        get: function() {
            return this.privResult;
        },
        enumerable: false,
        configurable: true
    });
    return PromiseResult;
}();
module.exports.PromiseResult = $400d7d5a515c2d8b$var$PromiseResult;
var $400d7d5a515c2d8b$var$PromiseResultEventSource = /** @class */ function() {
    function PromiseResultEventSource() {
        var _this = this;
        this.setResult = function(result) {
            _this.privOnSetResult(result);
        };
        this.setError = function(error) {
            _this.privOnSetError(error);
        };
        this.on = function(onSetResult, onSetError) {
            _this.privOnSetResult = onSetResult;
            _this.privOnSetError = onSetError;
        };
    }
    return PromiseResultEventSource;
}();
module.exports.PromiseResultEventSource = $400d7d5a515c2d8b$var$PromiseResultEventSource;
var $400d7d5a515c2d8b$var$Deferred = /** @class */ function() {
    function Deferred() {
        var _this = this;
        this.resolve = function(result) {
            _this.privResolve(result);
            return _this;
        };
        this.reject = function(error) {
            _this.privReject(error);
            return _this;
        };
        this.privPromise = new Promise(function(resolve, reject) {
            _this.privResolve = resolve;
            _this.privReject = reject;
        });
    }
    Object.defineProperty(Deferred.prototype, "promise", {
        get: function() {
            return this.privPromise;
        },
        enumerable: false,
        configurable: true
    });
    return Deferred;
}();
module.exports.Deferred = $400d7d5a515c2d8b$var$Deferred;
var $400d7d5a515c2d8b$var$Sink = /** @class */ function() {
    function Sink() {
        var _this = this;
        this.privState = $400d7d5a515c2d8b$var$PromiseState.None;
        this.privPromiseResult = null;
        this.privPromiseResultEvents = null;
        this.privSuccessHandlers = [];
        this.privErrorHandlers = [];
        this.resolve = function(result) {
            if (_this.privState !== $400d7d5a515c2d8b$var$PromiseState.None) throw new Error("'Cannot resolve a completed promise'");
            _this.privState = $400d7d5a515c2d8b$var$PromiseState.Resolved;
            _this.privPromiseResultEvents.setResult(result);
            for(var i = 0; i < _this.privSuccessHandlers.length; i++)_this.executeSuccessCallback(result, _this.privSuccessHandlers[i], _this.privErrorHandlers[i]);
            _this.detachHandlers();
        };
        this.reject = function(error) {
            if (_this.privState !== $400d7d5a515c2d8b$var$PromiseState.None) throw new Error("'Cannot reject a completed promise'");
            _this.privState = $400d7d5a515c2d8b$var$PromiseState.Rejected;
            _this.privPromiseResultEvents.setError(error);
            for(var _i = 0, _a = _this.privErrorHandlers; _i < _a.length; _i++){
                var errorHandler = _a[_i];
                _this.executeErrorCallback(error, errorHandler);
            }
            _this.detachHandlers();
        };
        this.on = function(successCallback, errorCallback) {
            if (successCallback == null) successCallback = function(r) {
                return;
            };
            if (_this.privState === $400d7d5a515c2d8b$var$PromiseState.None) {
                _this.privSuccessHandlers.push(successCallback);
                _this.privErrorHandlers.push(errorCallback);
            } else {
                if (_this.privState === $400d7d5a515c2d8b$var$PromiseState.Resolved) _this.executeSuccessCallback(_this.privPromiseResult.result, successCallback, errorCallback);
                else if (_this.privState === $400d7d5a515c2d8b$var$PromiseState.Rejected) _this.executeErrorCallback(_this.privPromiseResult.error, errorCallback);
                _this.detachHandlers();
            }
        };
        this.executeSuccessCallback = function(result, successCallback, errorCallback) {
            try {
                successCallback(result);
            } catch (e) {
                _this.executeErrorCallback("'Unhandled callback error: " + e + "'", errorCallback);
            }
        };
        this.executeErrorCallback = function(error, errorCallback) {
            if (errorCallback) try {
                errorCallback(error);
            } catch (e) {
                throw new Error("'Unhandled callback error: " + e + ". InnerError: " + error + "'");
            }
            else throw new Error("'Unhandled error: " + error + "'");
        };
        this.detachHandlers = function() {
            _this.privErrorHandlers = [];
            _this.privSuccessHandlers = [];
        };
        this.privPromiseResultEvents = new $400d7d5a515c2d8b$var$PromiseResultEventSource();
        this.privPromiseResult = new $400d7d5a515c2d8b$var$PromiseResult(this.privPromiseResultEvents);
    }
    Object.defineProperty(Sink.prototype, "state", {
        get: function() {
            return this.privState;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Sink.prototype, "result", {
        get: function() {
            return this.privPromiseResult;
        },
        enumerable: false,
        configurable: true
    });
    return Sink;
}();
module.exports.Sink = $400d7d5a515c2d8b$var$Sink;
function $400d7d5a515c2d8b$var$marshalPromiseToCallbacks(promise, cb, err) {
    promise.then(function(val) {
        try {
            if (!!cb) cb(val);
        } catch (error) {
            if (!!err) try {
                if (error instanceof Error) {
                    var typedError = error;
                    err(typedError.name + ": " + typedError.message);
                } else err(error);
            /* tslint:disable:no-empty */ } catch (error) {}
        }
    }, function(error) {
        if (!!err) try {
            if (error instanceof Error) {
                var typedError = error;
                err(typedError.name + ": " + typedError.message);
            } else err(error);
        /* tslint:disable:no-empty */ } catch (error) {}
    });
}
module.exports.marshalPromiseToCallbacks = $400d7d5a515c2d8b$var$marshalPromiseToCallbacks;

});

parcelRequire.register("7khmB", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
var $5557deb7f40c521f$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $5557deb7f40c521f$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Queue = void 0;

var $7YICj = parcelRequire("7YICj");

var $48xKX = parcelRequire("48xKX");

var $5uWXA = parcelRequire("5uWXA");
var $5557deb7f40c521f$var$SubscriberType;
(function(SubscriberType) {
    SubscriberType[SubscriberType["Dequeue"] = 0] = "Dequeue";
    SubscriberType[SubscriberType["Peek"] = 1] = "Peek";
})($5557deb7f40c521f$var$SubscriberType || ($5557deb7f40c521f$var$SubscriberType = {}));
var $5557deb7f40c521f$var$Queue = /** @class */ function() {
    function Queue(list) {
        var _this = this;
        this.privPromiseStore = new $48xKX.List();
        this.privIsDrainInProgress = false;
        this.privIsDisposing = false;
        this.privDisposeReason = null;
        this.enqueue = function(item) {
            _this.throwIfDispose();
            _this.enqueueFromPromise(new Promise(function(resolve, reject) {
                resolve(item);
            }));
        };
        this.enqueueFromPromise = function(promise) {
            _this.throwIfDispose();
            promise.then(function(val) {
                _this.privList.add(val);
            /* tslint:disable:no-empty */ }, function(error) {});
        };
        this.dequeue = function() {
            _this.throwIfDispose();
            var deferredSubscriber = new $5uWXA.Deferred();
            if (_this.privSubscribers) {
                _this.privSubscribers.add({
                    deferral: deferredSubscriber,
                    type: $5557deb7f40c521f$var$SubscriberType.Dequeue
                });
                _this.drain();
            }
            return deferredSubscriber.promise;
        };
        this.peek = function() {
            _this.throwIfDispose();
            var deferredSubscriber = new $5uWXA.Deferred();
            var subs = _this.privSubscribers;
            if (subs) {
                _this.privSubscribers.add({
                    deferral: deferredSubscriber,
                    type: $5557deb7f40c521f$var$SubscriberType.Peek
                });
                _this.drain();
            }
            return deferredSubscriber.promise;
        };
        this.length = function() {
            _this.throwIfDispose();
            return _this.privList.length();
        };
        this.isDisposed = function() {
            return _this.privSubscribers == null;
        };
        this.drain = function() {
            if (!_this.privIsDrainInProgress && !_this.privIsDisposing) {
                _this.privIsDrainInProgress = true;
                var subs = _this.privSubscribers;
                var lists = _this.privList;
                if (subs && lists) {
                    while(lists.length() > 0 && subs.length() > 0 && !_this.privIsDisposing){
                        var subscriber = subs.removeFirst();
                        if (subscriber.type === $5557deb7f40c521f$var$SubscriberType.Peek) subscriber.deferral.resolve(lists.first());
                        else {
                            var dequeuedItem = lists.removeFirst();
                            subscriber.deferral.resolve(dequeuedItem);
                        }
                    }
                    // note: this block assumes cooperative multitasking, i.e.,
                    // between the if-statement and the assignment there are no
                    // thread switches.
                    // Reason is that between the initial const = this.; and this
                    // point there is the derral.resolve() operation that might have
                    // caused recursive calls to the Queue, especially, calling
                    // Dispose() on the queue alredy (which would reset the var
                    // here to null!).
                    // That should generally hold true for javascript...
                    if (_this.privSubscribers === subs) _this.privSubscribers = subs;
                    // note: this block assumes cooperative multitasking, i.e.,
                    // between the if-statement and the assignment there are no
                    // thread switches.
                    // Reason is that between the initial const = this.; and this
                    // point there is the derral.resolve() operation that might have
                    // caused recursive calls to the Queue, especially, calling
                    // Dispose() on the queue alredy (which would reset the var
                    // here to null!).
                    // That should generally hold true for javascript...
                    if (_this.privList === lists) _this.privList = lists;
                }
                _this.privIsDrainInProgress = false;
            }
        };
        this.throwIfDispose = function() {
            if (_this.isDisposed()) {
                if (_this.privDisposeReason) throw new $7YICj.InvalidOperationError(_this.privDisposeReason);
                throw new $7YICj.ObjectDisposedError("Queue");
            } else if (_this.privIsDisposing) throw new $7YICj.InvalidOperationError("Queue disposing");
        };
        this.privList = list ? list : new $48xKX.List();
        this.privDetachables = [];
        this.privSubscribers = new $48xKX.List();
        this.privDetachables.push(this.privList.onAdded(this.drain));
    }
    Queue.prototype.drainAndDispose = function(pendingItemProcessor, reason) {
        return $5557deb7f40c521f$var$__awaiter(this, void 0, void 0, function() {
            var subs, subscriber, _i, _a, detachable, promiseArray_1;
            var _this = this;
            return $5557deb7f40c521f$var$__generator(this, function(_b) {
                switch(_b.label){
                    case 0:
                        if (!(!this.isDisposed() && !this.privIsDisposing)) return [
                            3 /*break*/ ,
                            5
                        ];
                        this.privDisposeReason = reason;
                        this.privIsDisposing = true;
                        subs = this.privSubscribers;
                        if (subs) {
                            while(subs.length() > 0){
                                subscriber = subs.removeFirst();
                                // TODO: this needs work (Resolve(null) instead?).
                                subscriber.deferral.resolve(undefined);
                            // subscriber.deferral.reject("Disposed");
                            }
                            // note: this block assumes cooperative multitasking, i.e.,
                            // between the if-statement and the assignment there are no
                            // thread switches.
                            // Reason is that between the initial const = this.; and this
                            // point there is the derral.resolve() operation that might have
                            // caused recursive calls to the Queue, especially, calling
                            // Dispose() on the queue alredy (which would reset the var
                            // here to null!).
                            // That should generally hold true for javascript...
                            if (this.privSubscribers === subs) this.privSubscribers = subs;
                        }
                        _i = 0, _a = this.privDetachables;
                        _b.label = 1;
                    case 1:
                        if (!(_i < _a.length)) return [
                            3 /*break*/ ,
                            4
                        ];
                        detachable = _a[_i];
                        return [
                            4 /*yield*/ ,
                            detachable.detach()
                        ];
                    case 2:
                        _b.sent();
                        _b.label = 3;
                    case 3:
                        _i++;
                        return [
                            3 /*break*/ ,
                            1
                        ];
                    case 4:
                        if (this.privPromiseStore.length() > 0 && pendingItemProcessor) {
                            promiseArray_1 = [];
                            this.privPromiseStore.toArray().forEach(function(wrapper) {
                                promiseArray_1.push(wrapper);
                            });
                            return [
                                2 /*return*/ ,
                                Promise.all(promiseArray_1).finally(function() {
                                    _this.privSubscribers = null;
                                    _this.privList.forEach(function(item, index) {
                                        pendingItemProcessor(item);
                                    });
                                    _this.privList = null;
                                    return;
                                }).then()
                            ];
                        } else {
                            this.privSubscribers = null;
                            this.privList = null;
                        }
                        _b.label = 5;
                    case 5:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    Queue.prototype.dispose = function(reason) {
        return $5557deb7f40c521f$var$__awaiter(this, void 0, void 0, function() {
            return $5557deb7f40c521f$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.drainAndDispose(null, reason)
                        ];
                    case 1:
                        _a.sent();
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    return Queue;
}();
module.exports.Queue = $5557deb7f40c521f$var$Queue;

});

parcelRequire.register("dLqx3", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RawWebsocketMessage = void 0;

var $6jh4n = parcelRequire("6jh4n");

var $7YICj = parcelRequire("7YICj");

var $6B7tN = parcelRequire("6B7tN");
var $a0543edbb92b9852$var$RawWebsocketMessage = /** @class */ function() {
    function RawWebsocketMessage(messageType, payload, id) {
        this.privPayload = null;
        if (!payload) throw new $7YICj.ArgumentNullError("payload");
        if (messageType === $6jh4n.MessageType.Binary && payload.__proto__.constructor.name !== "ArrayBuffer") throw new $7YICj.InvalidOperationError("Payload must be ArrayBuffer");
        if (messageType === $6jh4n.MessageType.Text && !(typeof payload === "string")) throw new $7YICj.InvalidOperationError("Payload must be a string");
        this.privMessageType = messageType;
        this.privPayload = payload;
        this.privId = id ? id : $6B7tN.createNoDashGuid();
    }
    Object.defineProperty(RawWebsocketMessage.prototype, "messageType", {
        get: function() {
            return this.privMessageType;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(RawWebsocketMessage.prototype, "payload", {
        get: function() {
            return this.privPayload;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(RawWebsocketMessage.prototype, "textContent", {
        get: function() {
            if (this.privMessageType === $6jh4n.MessageType.Binary) throw new $7YICj.InvalidOperationError("Not supported for binary message");
            return this.privPayload;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(RawWebsocketMessage.prototype, "binaryContent", {
        get: function() {
            if (this.privMessageType === $6jh4n.MessageType.Text) throw new $7YICj.InvalidOperationError("Not supported for text message");
            return this.privPayload;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(RawWebsocketMessage.prototype, "id", {
        get: function() {
            return this.privId;
        },
        enumerable: false,
        configurable: true
    });
    return RawWebsocketMessage;
}();
module.exports.RawWebsocketMessage = $a0543edbb92b9852$var$RawWebsocketMessage;

});

parcelRequire.register("fheVe", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RiffPcmEncoder = void 0;
var $b1f404be534b72f1$var$RiffPcmEncoder = /** @class */ function() {
    function RiffPcmEncoder(actualSampleRate, desiredSampleRate) {
        var _this = this;
        this.encode = function(actualAudioFrame) {
            var audioFrame = _this.downSampleAudioFrame(actualAudioFrame, _this.privActualSampleRate, _this.privDesiredSampleRate);
            if (!audioFrame) return null;
            var audioLength = audioFrame.length * 2;
            var buffer = new ArrayBuffer(audioLength);
            var view = new DataView(buffer);
            _this.floatTo16BitPCM(view, 0, audioFrame);
            return buffer;
        };
        this.setString = function(view, offset, str) {
            for(var i = 0; i < str.length; i++)view.setUint8(offset + i, str.charCodeAt(i));
        };
        this.floatTo16BitPCM = function(view, offset, input) {
            for(var i = 0; i < input.length; i++, offset += 2){
                var s = Math.max(-1, Math.min(1, input[i]));
                view.setInt16(offset, s < 0 ? s * 0x8000 : s * 0x7FFF, true);
            }
        };
        this.downSampleAudioFrame = function(srcFrame, srcRate, dstRate) {
            if (dstRate === srcRate || dstRate > srcRate) return srcFrame;
            var ratio = srcRate / dstRate;
            var dstLength = Math.round(srcFrame.length / ratio);
            var dstFrame = new Float32Array(dstLength);
            var srcOffset = 0;
            var dstOffset = 0;
            while(dstOffset < dstLength){
                var nextSrcOffset = Math.round((dstOffset + 1) * ratio);
                var accum = 0;
                var count = 0;
                while(srcOffset < nextSrcOffset && srcOffset < srcFrame.length){
                    accum += srcFrame[srcOffset++];
                    count++;
                }
                dstFrame[dstOffset++] = accum / count;
            }
            return dstFrame;
        };
        this.privActualSampleRate = actualSampleRate;
        this.privDesiredSampleRate = desiredSampleRate;
    }
    return RiffPcmEncoder;
}();
module.exports.RiffPcmEncoder = $b1f404be534b72f1$var$RiffPcmEncoder;

});

parcelRequire.register("jjaOf", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
var $e0e82d2d52de756f$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $e0e82d2d52de756f$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Stream = void 0;

var $7YICj = parcelRequire("7YICj");

var $6B7tN = parcelRequire("6B7tN");

var $7khmB = parcelRequire("7khmB");
var $e0e82d2d52de756f$var$Stream = /** @class */ function() {
    function Stream(streamId) {
        var _this = this;
        this.privIsWriteEnded = false;
        this.privIsReadEnded = false;
        this.read = function() {
            if (_this.privIsReadEnded) throw new $7YICj.InvalidOperationError("Stream read has already finished");
            return _this.privReaderQueue.dequeue().then(function(streamChunk) {
                return $e0e82d2d52de756f$var$__awaiter(_this, void 0, void 0, function() {
                    return $e0e82d2d52de756f$var$__generator(this, function(_a) {
                        switch(_a.label){
                            case 0:
                                if (!(streamChunk === undefined || streamChunk.isEnd)) return [
                                    3 /*break*/ ,
                                    2
                                ];
                                return [
                                    4 /*yield*/ ,
                                    this.privReaderQueue.dispose("End of stream reached")
                                ];
                            case 1:
                                _a.sent();
                                _a.label = 2;
                            case 2:
                                return [
                                    2 /*return*/ ,
                                    streamChunk
                                ];
                        }
                    });
                });
            });
        };
        this.readEnded = function() {
            if (!_this.privIsReadEnded) {
                _this.privIsReadEnded = true;
                _this.privReaderQueue = new $7khmB.Queue();
            }
        };
        this.throwIfClosed = function() {
            if (_this.privIsWriteEnded) throw new $7YICj.InvalidOperationError("Stream closed");
        };
        this.privId = streamId ? streamId : $6B7tN.createNoDashGuid();
        this.privReaderQueue = new $7khmB.Queue();
    }
    Object.defineProperty(Stream.prototype, "isClosed", {
        get: function() {
            return this.privIsWriteEnded;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Stream.prototype, "isReadEnded", {
        get: function() {
            return this.privIsReadEnded;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Stream.prototype, "id", {
        get: function() {
            return this.privId;
        },
        enumerable: false,
        configurable: true
    });
    Stream.prototype.close = function() {
        if (!this.privIsWriteEnded) {
            this.writeStreamChunk({
                buffer: null,
                isEnd: true,
                timeReceived: Date.now()
            });
            this.privIsWriteEnded = true;
        }
    };
    Stream.prototype.writeStreamChunk = function(streamChunk) {
        this.throwIfClosed();
        if (!this.privReaderQueue.isDisposed()) try {
            this.privReaderQueue.enqueue(streamChunk);
        } catch (e) {
        // Do nothing
        }
    };
    return Stream;
}();
module.exports.Stream = $e0e82d2d52de756f$var$Stream;

});

parcelRequire.register("hlsVP", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TranslationStatus = void 0;
/**
 * Defines translation status.
 * @class TranslationStatus
 */ var $ca0ad7121eb1d54b$var$TranslationStatus;
(function(TranslationStatus) {
    /**
     * @member TranslationStatus.Success
     */ TranslationStatus[TranslationStatus["Success"] = 0] = "Success";
    /**
     * @member TranslationStatus.Error
     */ TranslationStatus[TranslationStatus["Error"] = 1] = "Error";
})($ca0ad7121eb1d54b$var$TranslationStatus = module.exports.TranslationStatus || (module.exports.TranslationStatus = {}));

});

parcelRequire.register("lkPVc", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
var $f883bdc3321b3de7$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ChunkedArrayBufferStream = void 0;

var $7srwU = parcelRequire("7srwU");
var $f883bdc3321b3de7$var$ChunkedArrayBufferStream = /** @class */ function(_super) {
    $f883bdc3321b3de7$var$__extends(ChunkedArrayBufferStream, _super);
    function ChunkedArrayBufferStream(targetChunkSize, streamId) {
        var _this = _super.call(this, streamId) || this;
        _this.privTargetChunkSize = targetChunkSize;
        _this.privNextBufferReadyBytes = 0;
        return _this;
    }
    ChunkedArrayBufferStream.prototype.writeStreamChunk = function(chunk) {
        // No pending write, and the buffer is the right size so write it.
        if (chunk.isEnd || 0 === this.privNextBufferReadyBytes && chunk.buffer.byteLength === this.privTargetChunkSize) {
            _super.prototype.writeStreamChunk.call(this, chunk);
            return;
        }
        var bytesCopiedFromBuffer = 0;
        while(bytesCopiedFromBuffer < chunk.buffer.byteLength){
            // Fill the next buffer.
            if (undefined === this.privNextBufferToWrite) {
                this.privNextBufferToWrite = new ArrayBuffer(this.privTargetChunkSize);
                this.privNextBufferStartTime = chunk.timeReceived;
            }
            // Find out how many bytes we can copy into the read buffer.
            var bytesToCopy = Math.min(chunk.buffer.byteLength - bytesCopiedFromBuffer, this.privTargetChunkSize - this.privNextBufferReadyBytes);
            var targetView = new Uint8Array(this.privNextBufferToWrite);
            var sourceView = new Uint8Array(chunk.buffer.slice(bytesCopiedFromBuffer, bytesToCopy + bytesCopiedFromBuffer));
            targetView.set(sourceView, this.privNextBufferReadyBytes);
            this.privNextBufferReadyBytes += bytesToCopy;
            bytesCopiedFromBuffer += bytesToCopy;
            // Are we ready to write?
            if (this.privNextBufferReadyBytes === this.privTargetChunkSize) {
                _super.prototype.writeStreamChunk.call(this, {
                    buffer: this.privNextBufferToWrite,
                    isEnd: false,
                    timeReceived: this.privNextBufferStartTime
                });
                this.privNextBufferReadyBytes = 0;
                this.privNextBufferToWrite = undefined;
            }
        }
    };
    ChunkedArrayBufferStream.prototype.close = function() {
        // Send whatever is pending, then close the base class.
        if (0 !== this.privNextBufferReadyBytes && !this.isClosed) _super.prototype.writeStreamChunk.call(this, {
            buffer: this.privNextBufferToWrite.slice(0, this.privNextBufferReadyBytes),
            isEnd: false,
            timeReceived: this.privNextBufferStartTime
        });
        _super.prototype.close.call(this);
    };
    return ChunkedArrayBufferStream;
}($7srwU.Stream);
module.exports.ChunkedArrayBufferStream = $f883bdc3321b3de7$var$ChunkedArrayBufferStream;

});

parcelRequire.register("gOfY7", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRequire.register("5qmAd", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Timeout = void 0;
var $3f30e60564674905$var$Timeout = /** @class */ function() {
    function Timeout() {}
    Timeout.workerTimers = null;
    Timeout.clearTimeout = function(timerId) {
        return Timeout.timers().clearTimeout(timerId);
    };
    Timeout.setTimeout = function(func, delay) {
        return Timeout.timers().setTimeout(func, delay);
    };
    Timeout.load = function(url) {
        // Prefilling the Maps with a function indexed by zero is necessary to be compliant with the specification.
        var scheduledTimeoutFunctions = new Map([
            [
                0,
                function() {}
            ]
        ]); // tslint:disable-line no-empty
        var unhandledRequests = new Map();
        var worker = new Worker(url);
        worker.addEventListener("message", function(_a) {
            var data = _a.data;
            if (Timeout.isCallNotification(data)) {
                var timerId = data.params.timerId;
                var idOrFunc = scheduledTimeoutFunctions.get(timerId);
                if (typeof idOrFunc === "number") {
                    var unhandledTimerId = unhandledRequests.get(idOrFunc);
                    if (unhandledTimerId === undefined || unhandledTimerId !== timerId) throw new Error("The timer is in an undefined state.");
                } else if (typeof idOrFunc !== "undefined") {
                    idOrFunc();
                    // A timeout can be safely deleted because it is only called once.
                    scheduledTimeoutFunctions.delete(timerId);
                } else throw new Error("The timer is in an undefined state.");
            } else if (Timeout.isClearResponse(data)) {
                var id = data.id;
                var unhandledTimerId = unhandledRequests.get(id);
                if (unhandledTimerId === undefined) throw new Error("The timer is in an undefined state.");
                unhandledRequests.delete(id);
                scheduledTimeoutFunctions.delete(unhandledTimerId);
            } else {
                var message = data.error.message;
                throw new Error(message);
            }
        });
        var clearTimeout = function(timerId) {
            var id = Math.random();
            unhandledRequests.set(id, timerId);
            scheduledTimeoutFunctions.set(timerId, id);
            worker.postMessage({
                id: id,
                method: "clear",
                params: {
                    timerId: timerId
                }
            });
        };
        var setTimeout = function(func, delay) {
            var timerId = Math.random();
            scheduledTimeoutFunctions.set(timerId, func);
            worker.postMessage({
                id: null,
                method: "set",
                params: {
                    delay: delay,
                    now: performance.now(),
                    timerId: timerId
                }
            });
            return timerId;
        };
        return {
            clearTimeout: clearTimeout,
            setTimeout: setTimeout
        };
    };
    Timeout.loadWorkerTimers = function() {
        var worker = '!function(e){var t={};function n(r){if(t[r])return t[r].exports;var o=t[r]={i:r,l:!1,exports:{}};return e[r].call(o.exports,o,o.exports,n),o.l=!0,o.exports}n.m=e,n.c=t,n.d=function(e,t,r){n.o(e,t)||Object.defineProperty(e,t,{enumerable:!0,get:r})},n.r=function(e){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(e,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(e,"__esModule",{value:!0})},n.t=function(e,t){if(1&t&&(e=n(e)),8&t)return e;if(4&t&&"object"==typeof e&&e&&e.__esModule)return e;var r=Object.create(null);if(n.r(r),Object.defineProperty(r,"default",{enumerable:!0,value:e}),2&t&&"string"!=typeof e)for(var o in e)n.d(r,o,function(t){return e[t]}.bind(null,o));return r},n.n=function(e){var t=e&&e.__esModule?function(){return e.default}:function(){return e};return n.d(t,"a",t),t},n.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},n.p="",n(n.s=14)}([function(e,t,n){"use strict";n.d(t,"a",(function(){return i})),n.d(t,"b",(function(){return u})),n.d(t,"c",(function(){return a})),n.d(t,"d",(function(){return d}));const r=new Map,o=new Map,i=e=>{const t=r.get(e);if(void 0===t)throw new Error(\'There is no interval scheduled with the given id "\'.concat(e,\'".\'));clearTimeout(t),r.delete(e)},u=e=>{const t=o.get(e);if(void 0===t)throw new Error(\'There is no timeout scheduled with the given id "\'.concat(e,\'".\'));clearTimeout(t),o.delete(e)},f=(e,t)=>{let n,r;if("performance"in self){const o=performance.now();n=o,r=e-Math.max(0,o-t)}else n=Date.now(),r=e;return{expected:n+r,remainingDelay:r}},c=(e,t,n,r)=>{const o="performance"in self?performance.now():Date.now();o>n?postMessage({id:null,method:"call",params:{timerId:t}}):e.set(t,setTimeout(c,n-o,e,t,n))},a=(e,t,n)=>{const{expected:o,remainingDelay:i}=f(e,n);r.set(t,setTimeout(c,i,r,t,o))},d=(e,t,n)=>{const{expected:r,remainingDelay:i}=f(e,n);o.set(t,setTimeout(c,i,o,t,r))}},function(e,t,n){"use strict";n.r(t);var r=n(2);for(var o in r)"default"!==o&&function(e){n.d(t,e,(function(){return r[e]}))}(o);var i=n(3);for(var o in i)"default"!==o&&function(e){n.d(t,e,(function(){return i[e]}))}(o);var u=n(4);for(var o in u)"default"!==o&&function(e){n.d(t,e,(function(){return u[e]}))}(o);var f=n(5);for(var o in f)"default"!==o&&function(e){n.d(t,e,(function(){return f[e]}))}(o);var c=n(6);for(var o in c)"default"!==o&&function(e){n.d(t,e,(function(){return c[e]}))}(o);var a=n(7);for(var o in a)"default"!==o&&function(e){n.d(t,e,(function(){return a[e]}))}(o);var d=n(8);for(var o in d)"default"!==o&&function(e){n.d(t,e,(function(){return d[e]}))}(o);var s=n(9);for(var o in s)"default"!==o&&function(e){n.d(t,e,(function(){return s[e]}))}(o)},function(e,t){},function(e,t){},function(e,t){},function(e,t){},function(e,t){},function(e,t){},function(e,t){},function(e,t){},function(e,t,n){"use strict";n.r(t);var r=n(11);for(var o in r)"default"!==o&&function(e){n.d(t,e,(function(){return r[e]}))}(o);var i=n(12);for(var o in i)"default"!==o&&function(e){n.d(t,e,(function(){return i[e]}))}(o);var u=n(13);for(var o in u)"default"!==o&&function(e){n.d(t,e,(function(){return u[e]}))}(o)},function(e,t){},function(e,t){},function(e,t){},function(e,t,n){"use strict";n.r(t);var r=n(0),o=n(1);for(var i in o)"default"!==i&&function(e){n.d(t,e,(function(){return o[e]}))}(i);var u=n(10);for(var i in u)"default"!==i&&function(e){n.d(t,e,(function(){return u[e]}))}(i);addEventListener("message",({data:e})=>{try{if("clear"===e.method){const{id:t,params:{timerId:n}}=e;Object(r.b)(n),postMessage({error:null,id:t})}else{if("set"!==e.method)throw new Error(\'The given method "\'.concat(e.method,\'" is not supported\'));{const{params:{delay:t,now:n,timerId:o}}=e;Object(r.d)(t,o,n)}}}catch(t){postMessage({error:{message:t.message},id:e.id,result:null})}})}]);'; // tslint:disable-line:max-line-length
        return function() {
            if (Timeout.workerTimers !== null) return Timeout.workerTimers;
            var blob = new Blob([
                worker
            ], {
                type: "application/javascript; charset=utf-8"
            });
            var url = URL.createObjectURL(blob);
            Timeout.workerTimers = Timeout.load(url);
            // Edge doesn't like the URL to be revoked directly.
            Timeout.workerTimers.setTimeout(function() {
                return URL.revokeObjectURL(url);
            }, 0);
            return Timeout.workerTimers;
        };
    };
    Timeout.timers = Timeout.loadWorkerTimers();
    Timeout.isCallNotification = function(message) {
        return message.method !== undefined && message.method === "call";
    };
    Timeout.isClearResponse = function(message) {
        return message.error === null && typeof message.id === "number";
    };
    return Timeout;
}();
module.exports.Timeout = $3f30e60564674905$var$Timeout;

});

parcelRequire.register("5AaWw", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
var $4108cd94b4a01e91$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.OCSPCacheUpdateErrorEvent = module.exports.OCSPResponseRetrievedEvent = module.exports.OCSPCacheFetchErrorEvent = module.exports.OCSPVerificationFailedEvent = module.exports.OCSPCacheHitEvent = module.exports.OCSPCacheEntryNeedsRefreshEvent = module.exports.OCSPCacheEntryExpiredEvent = module.exports.OCSPWSUpgradeStartedEvent = module.exports.OCSPStapleReceivedEvent = module.exports.OCSPCacheUpdatehCompleteEvent = module.exports.OCSPDiskCacheStoreEvent = module.exports.OCSPMemoryCacheStoreEvent = module.exports.OCSPCacheUpdateNeededEvent = module.exports.OCSPDiskCacheHitEvent = module.exports.OCSPCacheMissEvent = module.exports.OCSPMemoryCacheHitEvent = module.exports.OCSPEvent = void 0;

var $1HDz4 = parcelRequire("1HDz4");
var $4108cd94b4a01e91$var$OCSPEvent = /** @class */ function(_super) {
    $4108cd94b4a01e91$var$__extends(OCSPEvent, _super);
    function OCSPEvent(eventName, eventType, signature) {
        var _this = _super.call(this, eventName, eventType) || this;
        _this.privSignature = signature;
        return _this;
    }
    return OCSPEvent;
}($1HDz4.PlatformEvent);
module.exports.OCSPEvent = $4108cd94b4a01e91$var$OCSPEvent;
var $4108cd94b4a01e91$var$OCSPMemoryCacheHitEvent = /** @class */ function(_super) {
    $4108cd94b4a01e91$var$__extends(OCSPMemoryCacheHitEvent, _super);
    function OCSPMemoryCacheHitEvent(signature) {
        return _super.call(this, "OCSPMemoryCacheHitEvent", $1HDz4.EventType.Debug, signature) || this;
    }
    return OCSPMemoryCacheHitEvent;
}($4108cd94b4a01e91$var$OCSPEvent);
module.exports.OCSPMemoryCacheHitEvent = $4108cd94b4a01e91$var$OCSPMemoryCacheHitEvent;
var $4108cd94b4a01e91$var$OCSPCacheMissEvent = /** @class */ function(_super) {
    $4108cd94b4a01e91$var$__extends(OCSPCacheMissEvent, _super);
    function OCSPCacheMissEvent(signature) {
        return _super.call(this, "OCSPCacheMissEvent", $1HDz4.EventType.Debug, signature) || this;
    }
    return OCSPCacheMissEvent;
}($4108cd94b4a01e91$var$OCSPEvent);
module.exports.OCSPCacheMissEvent = $4108cd94b4a01e91$var$OCSPCacheMissEvent;
var $4108cd94b4a01e91$var$OCSPDiskCacheHitEvent = /** @class */ function(_super) {
    $4108cd94b4a01e91$var$__extends(OCSPDiskCacheHitEvent, _super);
    function OCSPDiskCacheHitEvent(signature) {
        return _super.call(this, "OCSPDiskCacheHitEvent", $1HDz4.EventType.Debug, signature) || this;
    }
    return OCSPDiskCacheHitEvent;
}($4108cd94b4a01e91$var$OCSPEvent);
module.exports.OCSPDiskCacheHitEvent = $4108cd94b4a01e91$var$OCSPDiskCacheHitEvent;
var $4108cd94b4a01e91$var$OCSPCacheUpdateNeededEvent = /** @class */ function(_super) {
    $4108cd94b4a01e91$var$__extends(OCSPCacheUpdateNeededEvent, _super);
    function OCSPCacheUpdateNeededEvent(signature) {
        return _super.call(this, "OCSPCacheUpdateNeededEvent", $1HDz4.EventType.Debug, signature) || this;
    }
    return OCSPCacheUpdateNeededEvent;
}($4108cd94b4a01e91$var$OCSPEvent);
module.exports.OCSPCacheUpdateNeededEvent = $4108cd94b4a01e91$var$OCSPCacheUpdateNeededEvent;
var $4108cd94b4a01e91$var$OCSPMemoryCacheStoreEvent = /** @class */ function(_super) {
    $4108cd94b4a01e91$var$__extends(OCSPMemoryCacheStoreEvent, _super);
    function OCSPMemoryCacheStoreEvent(signature) {
        return _super.call(this, "OCSPMemoryCacheStoreEvent", $1HDz4.EventType.Debug, signature) || this;
    }
    return OCSPMemoryCacheStoreEvent;
}($4108cd94b4a01e91$var$OCSPEvent);
module.exports.OCSPMemoryCacheStoreEvent = $4108cd94b4a01e91$var$OCSPMemoryCacheStoreEvent;
var $4108cd94b4a01e91$var$OCSPDiskCacheStoreEvent = /** @class */ function(_super) {
    $4108cd94b4a01e91$var$__extends(OCSPDiskCacheStoreEvent, _super);
    function OCSPDiskCacheStoreEvent(signature) {
        return _super.call(this, "OCSPDiskCacheStoreEvent", $1HDz4.EventType.Debug, signature) || this;
    }
    return OCSPDiskCacheStoreEvent;
}($4108cd94b4a01e91$var$OCSPEvent);
module.exports.OCSPDiskCacheStoreEvent = $4108cd94b4a01e91$var$OCSPDiskCacheStoreEvent;
var $4108cd94b4a01e91$var$OCSPCacheUpdatehCompleteEvent = /** @class */ function(_super) {
    $4108cd94b4a01e91$var$__extends(OCSPCacheUpdatehCompleteEvent, _super);
    function OCSPCacheUpdatehCompleteEvent(signature) {
        return _super.call(this, "OCSPCacheUpdatehCompleteEvent", $1HDz4.EventType.Debug, signature) || this;
    }
    return OCSPCacheUpdatehCompleteEvent;
}($4108cd94b4a01e91$var$OCSPEvent);
module.exports.OCSPCacheUpdatehCompleteEvent = $4108cd94b4a01e91$var$OCSPCacheUpdatehCompleteEvent;
var $4108cd94b4a01e91$var$OCSPStapleReceivedEvent = /** @class */ function(_super) {
    $4108cd94b4a01e91$var$__extends(OCSPStapleReceivedEvent, _super);
    function OCSPStapleReceivedEvent() {
        return _super.call(this, "OCSPStapleReceivedEvent", $1HDz4.EventType.Debug, "") || this;
    }
    return OCSPStapleReceivedEvent;
}($4108cd94b4a01e91$var$OCSPEvent);
module.exports.OCSPStapleReceivedEvent = $4108cd94b4a01e91$var$OCSPStapleReceivedEvent;
var $4108cd94b4a01e91$var$OCSPWSUpgradeStartedEvent = /** @class */ function(_super) {
    $4108cd94b4a01e91$var$__extends(OCSPWSUpgradeStartedEvent, _super);
    function OCSPWSUpgradeStartedEvent(serialNumber) {
        return _super.call(this, "OCSPWSUpgradeStartedEvent", $1HDz4.EventType.Debug, serialNumber) || this;
    }
    return OCSPWSUpgradeStartedEvent;
}($4108cd94b4a01e91$var$OCSPEvent);
module.exports.OCSPWSUpgradeStartedEvent = $4108cd94b4a01e91$var$OCSPWSUpgradeStartedEvent;
var $4108cd94b4a01e91$var$OCSPCacheEntryExpiredEvent = /** @class */ function(_super) {
    $4108cd94b4a01e91$var$__extends(OCSPCacheEntryExpiredEvent, _super);
    function OCSPCacheEntryExpiredEvent(serialNumber, expireTime) {
        var _this = _super.call(this, "OCSPCacheEntryExpiredEvent", $1HDz4.EventType.Debug, serialNumber) || this;
        _this.privExpireTime = expireTime;
        return _this;
    }
    return OCSPCacheEntryExpiredEvent;
}($4108cd94b4a01e91$var$OCSPEvent);
module.exports.OCSPCacheEntryExpiredEvent = $4108cd94b4a01e91$var$OCSPCacheEntryExpiredEvent;
var $4108cd94b4a01e91$var$OCSPCacheEntryNeedsRefreshEvent = /** @class */ function(_super) {
    $4108cd94b4a01e91$var$__extends(OCSPCacheEntryNeedsRefreshEvent, _super);
    function OCSPCacheEntryNeedsRefreshEvent(serialNumber, startTime, expireTime) {
        var _this = _super.call(this, "OCSPCacheEntryNeedsRefreshEvent", $1HDz4.EventType.Debug, serialNumber) || this;
        _this.privExpireTime = expireTime;
        _this.privStartTime = startTime;
        return _this;
    }
    return OCSPCacheEntryNeedsRefreshEvent;
}($4108cd94b4a01e91$var$OCSPEvent);
module.exports.OCSPCacheEntryNeedsRefreshEvent = $4108cd94b4a01e91$var$OCSPCacheEntryNeedsRefreshEvent;
var $4108cd94b4a01e91$var$OCSPCacheHitEvent = /** @class */ function(_super) {
    $4108cd94b4a01e91$var$__extends(OCSPCacheHitEvent, _super);
    function OCSPCacheHitEvent(serialNumber, startTime, expireTime) {
        var _this = _super.call(this, "OCSPCacheHitEvent", $1HDz4.EventType.Debug, serialNumber) || this;
        _this.privExpireTime = expireTime;
        _this.privExpireTimeString = new Date(expireTime).toLocaleDateString();
        _this.privStartTime = startTime;
        _this.privStartTimeString = new Date(startTime).toLocaleTimeString();
        return _this;
    }
    return OCSPCacheHitEvent;
}($4108cd94b4a01e91$var$OCSPEvent);
module.exports.OCSPCacheHitEvent = $4108cd94b4a01e91$var$OCSPCacheHitEvent;
var $4108cd94b4a01e91$var$OCSPVerificationFailedEvent = /** @class */ function(_super) {
    $4108cd94b4a01e91$var$__extends(OCSPVerificationFailedEvent, _super);
    function OCSPVerificationFailedEvent(serialNumber, error) {
        var _this = _super.call(this, "OCSPVerificationFailedEvent", $1HDz4.EventType.Debug, serialNumber) || this;
        _this.privError = error;
        return _this;
    }
    return OCSPVerificationFailedEvent;
}($4108cd94b4a01e91$var$OCSPEvent);
module.exports.OCSPVerificationFailedEvent = $4108cd94b4a01e91$var$OCSPVerificationFailedEvent;
var $4108cd94b4a01e91$var$OCSPCacheFetchErrorEvent = /** @class */ function(_super) {
    $4108cd94b4a01e91$var$__extends(OCSPCacheFetchErrorEvent, _super);
    function OCSPCacheFetchErrorEvent(serialNumber, error) {
        var _this = _super.call(this, "OCSPCacheFetchErrorEvent", $1HDz4.EventType.Debug, serialNumber) || this;
        _this.privError = error;
        return _this;
    }
    return OCSPCacheFetchErrorEvent;
}($4108cd94b4a01e91$var$OCSPEvent);
module.exports.OCSPCacheFetchErrorEvent = $4108cd94b4a01e91$var$OCSPCacheFetchErrorEvent;
var $4108cd94b4a01e91$var$OCSPResponseRetrievedEvent = /** @class */ function(_super) {
    $4108cd94b4a01e91$var$__extends(OCSPResponseRetrievedEvent, _super);
    function OCSPResponseRetrievedEvent(serialNumber) {
        return _super.call(this, "OCSPResponseRetrievedEvent", $1HDz4.EventType.Debug, serialNumber) || this;
    }
    return OCSPResponseRetrievedEvent;
}($4108cd94b4a01e91$var$OCSPEvent);
module.exports.OCSPResponseRetrievedEvent = $4108cd94b4a01e91$var$OCSPResponseRetrievedEvent;
var $4108cd94b4a01e91$var$OCSPCacheUpdateErrorEvent = /** @class */ function(_super) {
    $4108cd94b4a01e91$var$__extends(OCSPCacheUpdateErrorEvent, _super);
    function OCSPCacheUpdateErrorEvent(serialNumber, error) {
        var _this = _super.call(this, "OCSPCacheUpdateErrorEvent", $1HDz4.EventType.Debug, serialNumber) || this;
        _this.privError = error;
        return _this;
    }
    return OCSPCacheUpdateErrorEvent;
}($4108cd94b4a01e91$var$OCSPEvent);
module.exports.OCSPCacheUpdateErrorEvent = $4108cd94b4a01e91$var$OCSPCacheUpdateErrorEvent;

});

parcelRequire.register("arl3z", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
var $799cc26081269e68$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.BackgroundEvent = void 0;

var $7srwU = parcelRequire("7srwU");
var $799cc26081269e68$var$BackgroundEvent = /** @class */ function(_super) {
    $799cc26081269e68$var$__extends(BackgroundEvent, _super);
    function BackgroundEvent(error) {
        var _this = _super.call(this, "BackgroundEvent", $7srwU.EventType.Error) || this;
        _this.privError = error;
        return _this;
    }
    Object.defineProperty(BackgroundEvent.prototype, "error", {
        get: function() {
            return this.privError;
        },
        enumerable: false,
        configurable: true
    });
    return BackgroundEvent;
}($7srwU.PlatformEvent);
module.exports.BackgroundEvent = $799cc26081269e68$var$BackgroundEvent;

});



parcelRequire.register("lRtbx", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRequire.register("fAkys", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
var $b58a29942b89f95e$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $b58a29942b89f95e$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MicAudioSource = module.exports.AudioWorkletSourceURLPropertyName = void 0;

var $9MAMI = parcelRequire("9MAMI");

var $7srwU = parcelRequire("7srwU");

var $7PHxc = parcelRequire("7PHxc");
module.exports.AudioWorkletSourceURLPropertyName = "MICROPHONE-WorkletSourceUrl";
var $b58a29942b89f95e$var$MicAudioSource = /** @class */ function() {
    function MicAudioSource(privRecorder, deviceId, audioSourceId, mediaStream) {
        var _this = this;
        this.privRecorder = privRecorder;
        this.deviceId = deviceId;
        this.privStreams = {};
        this.turnOn = function() {
            if (_this.privInitializeDeferral) return _this.privInitializeDeferral.promise;
            _this.privInitializeDeferral = new $7srwU.Deferred();
            try {
                _this.createAudioContext();
            } catch (error) {
                if (error instanceof Error) {
                    var typedError = error;
                    _this.privInitializeDeferral.reject(typedError.name + ": " + typedError.message);
                } else _this.privInitializeDeferral.reject(error);
                return _this.privInitializeDeferral.promise;
            }
            var nav = window.navigator;
            var getUserMedia = nav.getUserMedia || nav.webkitGetUserMedia || nav.mozGetUserMedia || nav.msGetUserMedia;
            if (!!nav.mediaDevices) getUserMedia = function(constraints, successCallback, errorCallback) {
                nav.mediaDevices.getUserMedia(constraints).then(successCallback).catch(errorCallback);
            };
            if (!getUserMedia) {
                var errorMsg = "Browser does not support getUserMedia.";
                _this.privInitializeDeferral.reject(errorMsg);
                _this.onEvent(new $7srwU.AudioSourceErrorEvent(errorMsg, "")); // mic initialized error - no streamid at this point
            } else {
                var next = function() {
                    _this.onEvent(new $7srwU.AudioSourceInitializingEvent(_this.privId)); // no stream id
                    if (_this.privMediaStream && _this.privMediaStream.active) {
                        _this.onEvent(new $7srwU.AudioSourceReadyEvent(_this.privId));
                        _this.privInitializeDeferral.resolve();
                    } else getUserMedia({
                        audio: _this.deviceId ? {
                            deviceId: _this.deviceId
                        } : true,
                        video: false
                    }, function(mediaStream) {
                        _this.privMediaStream = mediaStream;
                        _this.onEvent(new $7srwU.AudioSourceReadyEvent(_this.privId));
                        _this.privInitializeDeferral.resolve();
                    }, function(error) {
                        var errorMsg = "Error occurred during microphone initialization: " + error;
                        _this.privInitializeDeferral.reject(errorMsg);
                        _this.onEvent(new $7srwU.AudioSourceErrorEvent(_this.privId, errorMsg));
                    });
                };
                if (_this.privContext.state === "suspended") // NOTE: On iOS, the Web Audio API requires sounds to be triggered from an explicit user action.
                // https://github.com/WebAudio/web-audio-api/issues/790
                _this.privContext.resume().then(next).catch(function(reason) {
                    _this.privInitializeDeferral.reject("Failed to initialize audio context: " + reason);
                });
                else next();
            }
            return _this.privInitializeDeferral.promise;
        };
        this.id = function() {
            return _this.privId;
        };
        this.attach = function(audioNodeId) {
            _this.onEvent(new $7srwU.AudioStreamNodeAttachingEvent(_this.privId, audioNodeId));
            return _this.listen(audioNodeId).then(function(stream) {
                _this.onEvent(new $7srwU.AudioStreamNodeAttachedEvent(_this.privId, audioNodeId));
                return {
                    detach: function() {
                        return $b58a29942b89f95e$var$__awaiter(_this, void 0, void 0, function() {
                            return $b58a29942b89f95e$var$__generator(this, function(_a) {
                                stream.readEnded();
                                delete this.privStreams[audioNodeId];
                                this.onEvent(new $7srwU.AudioStreamNodeDetachedEvent(this.privId, audioNodeId));
                                return [
                                    2 /*return*/ ,
                                    this.turnOff()
                                ];
                            });
                        });
                    },
                    id: function() {
                        return audioNodeId;
                    },
                    read: function() {
                        return stream.read();
                    }
                };
            });
        };
        this.detach = function(audioNodeId) {
            if (audioNodeId && _this.privStreams[audioNodeId]) {
                _this.privStreams[audioNodeId].close();
                delete _this.privStreams[audioNodeId];
                _this.onEvent(new $7srwU.AudioStreamNodeDetachedEvent(_this.privId, audioNodeId));
            }
        };
        this.listen = function(audioNodeId) {
            return $b58a29942b89f95e$var$__awaiter(_this, void 0, void 0, function() {
                var stream, result;
                return $b58a29942b89f95e$var$__generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            return [
                                4 /*yield*/ ,
                                this.turnOn()
                            ];
                        case 1:
                            _a.sent();
                            stream = new $7srwU.ChunkedArrayBufferStream(this.privOutputChunkSize, audioNodeId);
                            this.privStreams[audioNodeId] = stream;
                            try {
                                this.privRecorder.record(this.privContext, this.privMediaStream, stream);
                            } catch (error) {
                                this.onEvent(new $7srwU.AudioStreamNodeErrorEvent(this.privId, audioNodeId, error));
                                throw error;
                            }
                            result = stream;
                            return [
                                2 /*return*/ ,
                                result
                            ];
                    }
                });
            });
        };
        this.onEvent = function(event) {
            _this.privEvents.onEvent(event);
            $7srwU.Events.instance.onEvent(event);
        };
        this.createAudioContext = function() {
            if (!!_this.privContext) return;
            _this.privContext = $7PHxc.AudioStreamFormatImpl.getAudioContext(MicAudioSource.AUDIOFORMAT.samplesPerSec);
        };
        this.privOutputChunkSize = MicAudioSource.AUDIOFORMAT.avgBytesPerSec / 10;
        this.privId = audioSourceId ? audioSourceId : $7srwU.createNoDashGuid();
        this.privEvents = new $7srwU.EventSource();
        this.privMediaStream = mediaStream || null;
    }
    Object.defineProperty(MicAudioSource.prototype, "format", {
        get: function() {
            return Promise.resolve(MicAudioSource.AUDIOFORMAT);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MicAudioSource.prototype, "blob", {
        get: function() {
            return Promise.reject("Not implemented for Mic input");
        },
        enumerable: false,
        configurable: true
    });
    MicAudioSource.prototype.turnOff = function() {
        return $b58a29942b89f95e$var$__awaiter(this, void 0, void 0, function() {
            var streamId, stream;
            return $b58a29942b89f95e$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        for(streamId in this.privStreams)if (streamId) {
                            stream = this.privStreams[streamId];
                            if (stream) stream.close();
                        }
                        this.onEvent(new $7srwU.AudioSourceOffEvent(this.privId)); // no stream now
                        if (!this.privInitializeDeferral) return [
                            3 /*break*/ ,
                            2
                        ];
                        // Correctly handle when browser forces mic off before turnOn() completes
                        return [
                            4 /*yield*/ ,
                            this.privInitializeDeferral
                        ];
                    case 1:
                        // Correctly handle when browser forces mic off before turnOn() completes
                        _a.sent();
                        this.privInitializeDeferral = null;
                        _a.label = 2;
                    case 2:
                        return [
                            4 /*yield*/ ,
                            this.destroyAudioContext()
                        ];
                    case 3:
                        _a.sent();
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    Object.defineProperty(MicAudioSource.prototype, "events", {
        get: function() {
            return this.privEvents;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MicAudioSource.prototype, "deviceInfo", {
        get: function() {
            return this.getMicrophoneLabel().then(function(label) {
                return {
                    bitspersample: MicAudioSource.AUDIOFORMAT.bitsPerSample,
                    channelcount: MicAudioSource.AUDIOFORMAT.channels,
                    connectivity: $9MAMI.connectivity.Unknown,
                    manufacturer: "Speech SDK",
                    model: label,
                    samplerate: MicAudioSource.AUDIOFORMAT.samplesPerSec,
                    type: $9MAMI.type.Microphones
                };
            });
        },
        enumerable: false,
        configurable: true
    });
    MicAudioSource.prototype.setProperty = function(name, value) {
        if (name === module.exports.AudioWorkletSourceURLPropertyName) this.privRecorder.setWorkletUrl(value);
        else throw new Error("Property '" + name + "' is not supported on Microphone.");
    };
    MicAudioSource.prototype.getMicrophoneLabel = function() {
        var _this = this;
        var defaultMicrophoneName = "microphone";
        // If we did this already, return the value.
        if (this.privMicrophoneLabel !== undefined) return Promise.resolve(this.privMicrophoneLabel);
        // If the stream isn't currently running, we can't query devices because security.
        if (this.privMediaStream === undefined || !this.privMediaStream.active) return Promise.resolve(defaultMicrophoneName);
        // Setup a default
        this.privMicrophoneLabel = defaultMicrophoneName;
        // Get the id of the device running the audio track.
        var microphoneDeviceId = this.privMediaStream.getTracks()[0].getSettings().deviceId;
        // If the browser doesn't support getting the device ID, set a default and return.
        if (undefined === microphoneDeviceId) return Promise.resolve(this.privMicrophoneLabel);
        var deferred = new $7srwU.Deferred();
        // Enumerate the media devices.
        navigator.mediaDevices.enumerateDevices().then(function(devices) {
            for(var _i = 0, devices_1 = devices; _i < devices_1.length; _i++){
                var device = devices_1[_i];
                if (device.deviceId === microphoneDeviceId) {
                    // Found the device
                    _this.privMicrophoneLabel = device.label;
                    break;
                }
            }
            deferred.resolve(_this.privMicrophoneLabel);
        }, function() {
            return deferred.resolve(_this.privMicrophoneLabel);
        });
        return deferred.promise;
    };
    MicAudioSource.prototype.destroyAudioContext = function() {
        return $b58a29942b89f95e$var$__awaiter(this, void 0, void 0, function() {
            var hasClose;
            return $b58a29942b89f95e$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!this.privContext) return [
                            2 /*return*/ 
                        ];
                        this.privRecorder.releaseMediaResources(this.privContext);
                        hasClose = false;
                        if ("close" in this.privContext) hasClose = true;
                        if (!hasClose) return [
                            3 /*break*/ ,
                            2
                        ];
                        return [
                            4 /*yield*/ ,
                            this.privContext.close()
                        ];
                    case 1:
                        _a.sent();
                        this.privContext = null;
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 2:
                        if (!(null !== this.privContext && this.privContext.state === "running")) return [
                            3 /*break*/ ,
                            4
                        ];
                        // Suspend actually takes a callback, but analogous to the
                        // resume method, it'll be only fired if suspend is called
                        // in a direct response to a user action. The later is not always
                        // the case, as TurnOff is also called, when we receive an
                        // end-of-speech message from the service. So, doing a best effort
                        // fire-and-forget here.
                        return [
                            4 /*yield*/ ,
                            this.privContext.suspend()
                        ];
                    case 3:
                        // Suspend actually takes a callback, but analogous to the
                        // resume method, it'll be only fired if suspend is called
                        // in a direct response to a user action. The later is not always
                        // the case, as TurnOff is also called, when we receive an
                        // end-of-speech message from the service. So, doing a best effort
                        // fire-and-forget here.
                        _a.sent();
                        _a.label = 4;
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    MicAudioSource.AUDIOFORMAT = $7PHxc.AudioStreamFormat.getDefaultInputFormat();
    return MicAudioSource;
}();
module.exports.MicAudioSource = $b58a29942b89f95e$var$MicAudioSource;

});
parcelRequire.register("9MAMI", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
var $71f5216e5821e7ac$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $71f5216e5821e7ac$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) $71f5216e5821e7ac$var$__createBinding(exports, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.AutoDetectSourceLanguagesOpenRangeOptionName = module.exports.ForceDictationPropertyName = module.exports.ServicePropertiesPropertyName = module.exports.CancellationErrorCodePropertyName = module.exports.OutputFormatPropertyName = void 0;

// Make sure not to export internal modules.
//
$71f5216e5821e7ac$var$__exportStar((parcelRequire("lq754")), module.exports);

$71f5216e5821e7ac$var$__exportStar((parcelRequire("7x7gL")), module.exports);

$71f5216e5821e7ac$var$__exportStar((parcelRequire("kw5Y1")), module.exports);

$71f5216e5821e7ac$var$__exportStar((parcelRequire("hFNe0")), module.exports);

$71f5216e5821e7ac$var$__exportStar((parcelRequire("ib4YL")), module.exports);

$71f5216e5821e7ac$var$__exportStar((parcelRequire("ltnza")), module.exports);

$71f5216e5821e7ac$var$__exportStar((parcelRequire("kzoIC")), module.exports);

$71f5216e5821e7ac$var$__exportStar((parcelRequire("dYRUq")), module.exports);

$71f5216e5821e7ac$var$__exportStar((parcelRequire("fQK0E")), module.exports);

$71f5216e5821e7ac$var$__exportStar((parcelRequire("MD7s3")), module.exports);

$71f5216e5821e7ac$var$__exportStar((parcelRequire("dY3QQ")), module.exports);

$71f5216e5821e7ac$var$__exportStar((parcelRequire("7EXdq")), module.exports);

$71f5216e5821e7ac$var$__exportStar((parcelRequire("jWD2C")), module.exports);

$71f5216e5821e7ac$var$__exportStar((parcelRequire("eQiZ3")), module.exports);

$71f5216e5821e7ac$var$__exportStar((parcelRequire("ksvGQ")), module.exports);

$71f5216e5821e7ac$var$__exportStar((parcelRequire("dSDdv")), module.exports);

$71f5216e5821e7ac$var$__exportStar((parcelRequire("ghmgJ")), module.exports);

$71f5216e5821e7ac$var$__exportStar((parcelRequire("3ipaP")), module.exports);

$71f5216e5821e7ac$var$__exportStar((parcelRequire("1R7uH")), module.exports);

$71f5216e5821e7ac$var$__exportStar((parcelRequire("baRzV")), module.exports);

$71f5216e5821e7ac$var$__exportStar((parcelRequire("2sLVM")), module.exports);

$71f5216e5821e7ac$var$__exportStar((parcelRequire("i9UcG")), module.exports);

$71f5216e5821e7ac$var$__exportStar((parcelRequire("ewiBS")), module.exports);

$71f5216e5821e7ac$var$__exportStar((parcelRequire("4VwSP")), module.exports);

$71f5216e5821e7ac$var$__exportStar((parcelRequire("JeRGY")), module.exports);

$71f5216e5821e7ac$var$__exportStar((parcelRequire("9yqU6")), module.exports);

$71f5216e5821e7ac$var$__exportStar((parcelRequire("8F8am")), module.exports);

$71f5216e5821e7ac$var$__exportStar((parcelRequire("6UY4Q")), module.exports);

$71f5216e5821e7ac$var$__exportStar((parcelRequire("6C40j")), module.exports);

$71f5216e5821e7ac$var$__exportStar((parcelRequire("hZJYk")), module.exports);

$71f5216e5821e7ac$var$__exportStar((parcelRequire("hbzRA")), module.exports);

$71f5216e5821e7ac$var$__exportStar((parcelRequire("kC0Si")), module.exports);

$71f5216e5821e7ac$var$__exportStar((parcelRequire("9VrPQ")), module.exports);

$71f5216e5821e7ac$var$__exportStar((parcelRequire("6u0OP")), module.exports);

$71f5216e5821e7ac$var$__exportStar((parcelRequire("d7WUt")), module.exports);

$71f5216e5821e7ac$var$__exportStar((parcelRequire("kW11K")), module.exports);

$71f5216e5821e7ac$var$__exportStar((parcelRequire("eJjYN")), module.exports);

$71f5216e5821e7ac$var$__exportStar((parcelRequire("7lj1o")), module.exports);

$71f5216e5821e7ac$var$__exportStar((parcelRequire("2u1qE")), module.exports);

$71f5216e5821e7ac$var$__exportStar((parcelRequire("dbuqV")), module.exports);

$71f5216e5821e7ac$var$__exportStar((parcelRequire("lzout")), module.exports);

$71f5216e5821e7ac$var$__exportStar((parcelRequire("gYgJV")), module.exports);

$71f5216e5821e7ac$var$__exportStar((parcelRequire("kJuuX")), module.exports);

$71f5216e5821e7ac$var$__exportStar((parcelRequire("jXSj0")), module.exports);

$71f5216e5821e7ac$var$__exportStar((parcelRequire("8x4f9")), module.exports);
module.exports.OutputFormatPropertyName = "OutputFormat";
module.exports.CancellationErrorCodePropertyName = "CancellationErrorCode";
module.exports.ServicePropertiesPropertyName = "ServiceProperties";
module.exports.ForceDictationPropertyName = "ForceDictation";
module.exports.AutoDetectSourceLanguagesOpenRangeOptionName = "OpenRange";

});
parcelRequire.register("lq754", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CognitiveSubscriptionKeyAuthentication = void 0;

var $7srwU = parcelRequire("7srwU");

var $hiJX4 = parcelRequire("hiJX4");

var $kw5Y1 = parcelRequire("kw5Y1");
/**
 * @class
 */ var $f98184c4a5fd4afd$var$CognitiveSubscriptionKeyAuthentication = /** @class */ function() {
    /**
     * Creates and initializes an instance of the CognitiveSubscriptionKeyAuthentication class.
     * @constructor
     * @param {string} subscriptionKey - The subscription key
     */ function CognitiveSubscriptionKeyAuthentication(subscriptionKey) {
        var _this = this;
        /**
         * Fetches the subscription key.
         * @member
         * @function
         * @public
         * @param {string} authFetchEventId - The id to fetch.
         */ this.fetch = function(authFetchEventId) {
            return Promise.resolve(_this.privAuthInfo);
        };
        /**
         * Fetches the subscription key.
         * @member
         * @function
         * @public
         * @param {string} authFetchEventId - The id to fetch.
         */ this.fetchOnExpiry = function(authFetchEventId) {
            return Promise.resolve(_this.privAuthInfo);
        };
        if (!subscriptionKey) throw new $7srwU.ArgumentNullError("subscriptionKey");
        this.privAuthInfo = new $kw5Y1.AuthInfo($hiJX4.HeaderNames.AuthKey, subscriptionKey);
    }
    return CognitiveSubscriptionKeyAuthentication;
}();
module.exports.CognitiveSubscriptionKeyAuthentication = $f98184c4a5fd4afd$var$CognitiveSubscriptionKeyAuthentication;

});
parcelRequire.register("hiJX4", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.HeaderNames = void 0;
var $c987c32b6b212391$var$HeaderNames = /** @class */ function() {
    function HeaderNames() {}
    HeaderNames.AuthKey = "Ocp-Apim-Subscription-Key";
    HeaderNames.ConnectionId = "X-ConnectionId";
    HeaderNames.ContentType = "Content-Type";
    HeaderNames.CustomCommandsAppId = "X-CommandsAppId";
    HeaderNames.Path = "Path";
    HeaderNames.RequestId = "X-RequestId";
    HeaderNames.RequestStreamId = "X-StreamId";
    HeaderNames.RequestTimestamp = "X-Timestamp";
    return HeaderNames;
}();
module.exports.HeaderNames = $c987c32b6b212391$var$HeaderNames;

});

parcelRequire.register("kw5Y1", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.AuthInfo = void 0;
var $eefb6cc422532995$var$AuthInfo = /** @class */ function() {
    function AuthInfo(headerName, token) {
        this.privHeaderName = headerName;
        this.privToken = token;
    }
    Object.defineProperty(AuthInfo.prototype, "headerName", {
        get: function() {
            return this.privHeaderName;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AuthInfo.prototype, "token", {
        get: function() {
            return this.privToken;
        },
        enumerable: false,
        configurable: true
    });
    return AuthInfo;
}();
module.exports.AuthInfo = $eefb6cc422532995$var$AuthInfo;

});


parcelRequire.register("7x7gL", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CognitiveTokenAuthentication = void 0;

var $7srwU = parcelRequire("7srwU");

var $kw5Y1 = parcelRequire("kw5Y1");
var $57c14102cd58f842$var$AuthHeader = "Authorization";
var $57c14102cd58f842$var$CognitiveTokenAuthentication = /** @class */ function() {
    function CognitiveTokenAuthentication(fetchCallback, fetchOnExpiryCallback) {
        var _this = this;
        this.fetch = function(authFetchEventId) {
            return _this.privFetchCallback(authFetchEventId).then(function(token) {
                return new $kw5Y1.AuthInfo($57c14102cd58f842$var$AuthHeader, token);
            });
        };
        this.fetchOnExpiry = function(authFetchEventId) {
            return _this.privFetchOnExpiryCallback(authFetchEventId).then(function(token) {
                return new $kw5Y1.AuthInfo($57c14102cd58f842$var$AuthHeader, token);
            });
        };
        if (!fetchCallback) throw new $7srwU.ArgumentNullError("fetchCallback");
        if (!fetchOnExpiryCallback) throw new $7srwU.ArgumentNullError("fetchOnExpiryCallback");
        this.privFetchCallback = fetchCallback;
        this.privFetchOnExpiryCallback = fetchOnExpiryCallback;
    }
    return CognitiveTokenAuthentication;
}();
module.exports.CognitiveTokenAuthentication = $57c14102cd58f842$var$CognitiveTokenAuthentication;

});

parcelRequire.register("hFNe0", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRequire.register("ib4YL", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRequire.register("ltnza", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
var $fa1e962f25eeb0b0$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.IntentConnectionFactory = void 0;

var $9h4kO = parcelRequire("9h4kO");

var $iQDnw = parcelRequire("iQDnw");

var $8EAiJ = parcelRequire("8EAiJ");

var $9MAMI = parcelRequire("9MAMI");

var $hiJX4 = parcelRequire("hiJX4");
var $fa1e962f25eeb0b0$var$IntentConnectionFactory = /** @class */ function(_super) {
    $fa1e962f25eeb0b0$var$__extends(IntentConnectionFactory, _super);
    function IntentConnectionFactory() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.create = function(config, authInfo, connectionId) {
            var endpoint = config.parameters.getProperty($iQDnw.PropertyId.SpeechServiceConnection_Endpoint);
            if (!endpoint) {
                var region = config.parameters.getProperty($iQDnw.PropertyId.SpeechServiceConnection_IntentRegion);
                var hostSuffix = region && region.toLowerCase().startsWith("china") ? ".azure.cn" : ".microsoft.com";
                var host = config.parameters.getProperty($iQDnw.PropertyId.SpeechServiceConnection_Host, "wss://" + region + ".sr.speech" + hostSuffix);
                endpoint = host + "/speech/recognition/interactive/cognitiveservices/v1";
            }
            var queryParams = {
                format: "simple",
                language: config.parameters.getProperty($iQDnw.PropertyId.SpeechServiceConnection_RecoLanguage)
            };
            _this.setCommonUrlParams(config, queryParams, endpoint);
            var headers = {};
            if (authInfo.token !== undefined && authInfo.token !== "") headers[authInfo.headerName] = authInfo.token;
            headers[$hiJX4.HeaderNames.ConnectionId] = connectionId;
            config.parameters.setProperty($iQDnw.PropertyId.SpeechServiceConnection_Url, endpoint);
            var enableCompression = config.parameters.getProperty("SPEECH-EnableWebsocketCompression", "false") === "true";
            return new $9h4kO.WebsocketConnection(endpoint, queryParams, headers, new $9MAMI.WebsocketMessageFormatter(), $9h4kO.ProxyInfo.fromRecognizerConfig(config), enableCompression, connectionId);
        };
        return _this;
    }
    IntentConnectionFactory.prototype.getSpeechRegionFromIntentRegion = function(intentRegion) {
        switch(intentRegion){
            case "West US":
            case "US West":
            case "westus":
                return "uswest";
            case "West US 2":
            case "US West 2":
            case "westus2":
                return "uswest2";
            case "South Central US":
            case "US South Central":
            case "southcentralus":
                return "ussouthcentral";
            case "West Central US":
            case "US West Central":
            case "westcentralus":
                return "uswestcentral";
            case "East US":
            case "US East":
            case "eastus":
                return "useast";
            case "East US 2":
            case "US East 2":
            case "eastus2":
                return "useast2";
            case "West Europe":
            case "Europe West":
            case "westeurope":
                return "europewest";
            case "North Europe":
            case "Europe North":
            case "northeurope":
                return "europenorth";
            case "Brazil South":
            case "South Brazil":
            case "southbrazil":
                return "brazilsouth";
            case "Australia East":
            case "East Australia":
            case "eastaustralia":
                return "australiaeast";
            case "Southeast Asia":
            case "Asia Southeast":
            case "southeastasia":
                return "asiasoutheast";
            case "East Asia":
            case "Asia East":
            case "eastasia":
                return "asiaeast";
            default:
                return intentRegion;
        }
    };
    return IntentConnectionFactory;
}($8EAiJ.ConnectionFactoryBase);
module.exports.IntentConnectionFactory = $fa1e962f25eeb0b0$var$IntentConnectionFactory;

});
parcelRequire.register("iQDnw", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $4J3Mu = parcelRequire("4J3Mu");
Object.defineProperty(module.exports, "AudioConfig", {
    enumerable: true,
    get: function() {
        return $4J3Mu.AudioConfig;
    }
});

var $7PHxc = parcelRequire("7PHxc");
Object.defineProperty(module.exports, "AudioStreamFormat", {
    enumerable: true,
    get: function() {
        return $7PHxc.AudioStreamFormat;
    }
});

var $lNEKs = parcelRequire("lNEKs");
Object.defineProperty(module.exports, "AudioInputStream", {
    enumerable: true,
    get: function() {
        return $lNEKs.AudioInputStream;
    }
});
Object.defineProperty(module.exports, "PullAudioInputStream", {
    enumerable: true,
    get: function() {
        return $lNEKs.PullAudioInputStream;
    }
});
Object.defineProperty(module.exports, "PushAudioInputStream", {
    enumerable: true,
    get: function() {
        return $lNEKs.PushAudioInputStream;
    }
});

var $epVjg = parcelRequire("epVjg");
Object.defineProperty(module.exports, "AudioOutputStream", {
    enumerable: true,
    get: function() {
        return $epVjg.AudioOutputStream;
    }
});
Object.defineProperty(module.exports, "PullAudioOutputStream", {
    enumerable: true,
    get: function() {
        return $epVjg.PullAudioOutputStream;
    }
});
Object.defineProperty(module.exports, "PushAudioOutputStream", {
    enumerable: true,
    get: function() {
        return $epVjg.PushAudioOutputStream;
    }
});

var $hVeWA = parcelRequire("hVeWA");
Object.defineProperty(module.exports, "CancellationReason", {
    enumerable: true,
    get: function() {
        return $hVeWA.CancellationReason;
    }
});

var $5RVXf = parcelRequire("5RVXf");
Object.defineProperty(module.exports, "PullAudioInputStreamCallback", {
    enumerable: true,
    get: function() {
        return $5RVXf.PullAudioInputStreamCallback;
    }
});

var $7qKBh = parcelRequire("7qKBh");
Object.defineProperty(module.exports, "PushAudioOutputStreamCallback", {
    enumerable: true,
    get: function() {
        return $7qKBh.PushAudioOutputStreamCallback;
    }
});

var $78X2i = parcelRequire("78X2i");
Object.defineProperty(module.exports, "KeywordRecognitionModel", {
    enumerable: true,
    get: function() {
        return $78X2i.KeywordRecognitionModel;
    }
});

var $4iaAu = parcelRequire("4iaAu");
Object.defineProperty(module.exports, "SessionEventArgs", {
    enumerable: true,
    get: function() {
        return $4iaAu.SessionEventArgs;
    }
});

var $k5cHF = parcelRequire("k5cHF");
Object.defineProperty(module.exports, "RecognitionEventArgs", {
    enumerable: true,
    get: function() {
        return $k5cHF.RecognitionEventArgs;
    }
});

var $ekTR9 = parcelRequire("ekTR9");
Object.defineProperty(module.exports, "OutputFormat", {
    enumerable: true,
    get: function() {
        return $ekTR9.OutputFormat;
    }
});

var $jJ0y0 = parcelRequire("jJ0y0");
Object.defineProperty(module.exports, "IntentRecognitionEventArgs", {
    enumerable: true,
    get: function() {
        return $jJ0y0.IntentRecognitionEventArgs;
    }
});

var $gvAKQ = parcelRequire("gvAKQ");
Object.defineProperty(module.exports, "RecognitionResult", {
    enumerable: true,
    get: function() {
        return $gvAKQ.RecognitionResult;
    }
});

var $a5IuE = parcelRequire("a5IuE");
Object.defineProperty(module.exports, "SpeechRecognitionResult", {
    enumerable: true,
    get: function() {
        return $a5IuE.SpeechRecognitionResult;
    }
});

var $gQhL4 = parcelRequire("gQhL4");
Object.defineProperty(module.exports, "IntentRecognitionResult", {
    enumerable: true,
    get: function() {
        return $gQhL4.IntentRecognitionResult;
    }
});

var $bJDXy = parcelRequire("bJDXy");
Object.defineProperty(module.exports, "LanguageUnderstandingModel", {
    enumerable: true,
    get: function() {
        return $bJDXy.LanguageUnderstandingModel;
    }
});

var $g2jVZ = parcelRequire("g2jVZ");
Object.defineProperty(module.exports, "SpeechRecognitionEventArgs", {
    enumerable: true,
    get: function() {
        return $g2jVZ.SpeechRecognitionEventArgs;
    }
});
Object.defineProperty(module.exports, "ConversationTranscriptionEventArgs", {
    enumerable: true,
    get: function() {
        return $g2jVZ.ConversationTranscriptionEventArgs;
    }
});

var $4svLY = parcelRequire("4svLY");
Object.defineProperty(module.exports, "SpeechRecognitionCanceledEventArgs", {
    enumerable: true,
    get: function() {
        return $4svLY.SpeechRecognitionCanceledEventArgs;
    }
});

var $2FEh7 = parcelRequire("2FEh7");
Object.defineProperty(module.exports, "TranslationRecognitionEventArgs", {
    enumerable: true,
    get: function() {
        return $2FEh7.TranslationRecognitionEventArgs;
    }
});

var $cQcqq = parcelRequire("cQcqq");
Object.defineProperty(module.exports, "TranslationSynthesisEventArgs", {
    enumerable: true,
    get: function() {
        return $cQcqq.TranslationSynthesisEventArgs;
    }
});

var $k62Rg = parcelRequire("k62Rg");
Object.defineProperty(module.exports, "TranslationRecognitionResult", {
    enumerable: true,
    get: function() {
        return $k62Rg.TranslationRecognitionResult;
    }
});

var $f3RAc = parcelRequire("f3RAc");
Object.defineProperty(module.exports, "TranslationSynthesisResult", {
    enumerable: true,
    get: function() {
        return $f3RAc.TranslationSynthesisResult;
    }
});

var $dTEoe = parcelRequire("dTEoe");
Object.defineProperty(module.exports, "ResultReason", {
    enumerable: true,
    get: function() {
        return $dTEoe.ResultReason;
    }
});

var $lbsDi = parcelRequire("lbsDi");
Object.defineProperty(module.exports, "SpeechConfig", {
    enumerable: true,
    get: function() {
        return $lbsDi.SpeechConfig;
    }
});
Object.defineProperty(module.exports, "SpeechConfigImpl", {
    enumerable: true,
    get: function() {
        return $lbsDi.SpeechConfigImpl;
    }
});

var $8m0VQ = parcelRequire("8m0VQ");
Object.defineProperty(module.exports, "SpeechTranslationConfig", {
    enumerable: true,
    get: function() {
        return $8m0VQ.SpeechTranslationConfig;
    }
});
Object.defineProperty(module.exports, "SpeechTranslationConfigImpl", {
    enumerable: true,
    get: function() {
        return $8m0VQ.SpeechTranslationConfigImpl;
    }
});

var $jnfnZ = parcelRequire("jnfnZ");
Object.defineProperty(module.exports, "PropertyCollection", {
    enumerable: true,
    get: function() {
        return $jnfnZ.PropertyCollection;
    }
});

var $ChSMK = parcelRequire("ChSMK");
Object.defineProperty(module.exports, "PropertyId", {
    enumerable: true,
    get: function() {
        return $ChSMK.PropertyId;
    }
});

var $cSAoc = parcelRequire("cSAoc");
Object.defineProperty(module.exports, "Recognizer", {
    enumerable: true,
    get: function() {
        return $cSAoc.Recognizer;
    }
});

var $9jqYC = parcelRequire("9jqYC");
Object.defineProperty(module.exports, "SpeechRecognizer", {
    enumerable: true,
    get: function() {
        return $9jqYC.SpeechRecognizer;
    }
});

var $dSRBv = parcelRequire("dSRBv");
Object.defineProperty(module.exports, "IntentRecognizer", {
    enumerable: true,
    get: function() {
        return $dSRBv.IntentRecognizer;
    }
});

var $ft2Zs = parcelRequire("ft2Zs");
Object.defineProperty(module.exports, "VoiceProfileType", {
    enumerable: true,
    get: function() {
        return $ft2Zs.VoiceProfileType;
    }
});

var $dAXAT = parcelRequire("dAXAT");
Object.defineProperty(module.exports, "TranslationRecognizer", {
    enumerable: true,
    get: function() {
        return $dAXAT.TranslationRecognizer;
    }
});

var $7QOKD = parcelRequire("7QOKD");
Object.defineProperty(module.exports, "Translations", {
    enumerable: true,
    get: function() {
        return $7QOKD.Translations;
    }
});

var $d8dph = parcelRequire("d8dph");
Object.defineProperty(module.exports, "NoMatchReason", {
    enumerable: true,
    get: function() {
        return $d8dph.NoMatchReason;
    }
});

var $hXuim = parcelRequire("hXuim");
Object.defineProperty(module.exports, "NoMatchDetails", {
    enumerable: true,
    get: function() {
        return $hXuim.NoMatchDetails;
    }
});

var $eZWf4 = parcelRequire("eZWf4");
Object.defineProperty(module.exports, "TranslationRecognitionCanceledEventArgs", {
    enumerable: true,
    get: function() {
        return $eZWf4.TranslationRecognitionCanceledEventArgs;
    }
});

var $gGKie = parcelRequire("gGKie");
Object.defineProperty(module.exports, "IntentRecognitionCanceledEventArgs", {
    enumerable: true,
    get: function() {
        return $gGKie.IntentRecognitionCanceledEventArgs;
    }
});

var $cFx58 = parcelRequire("cFx58");
Object.defineProperty(module.exports, "CancellationDetailsBase", {
    enumerable: true,
    get: function() {
        return $cFx58.CancellationDetailsBase;
    }
});

var $fsGED = parcelRequire("fsGED");
Object.defineProperty(module.exports, "CancellationDetails", {
    enumerable: true,
    get: function() {
        return $fsGED.CancellationDetails;
    }
});

var $225vB = parcelRequire("225vB");
Object.defineProperty(module.exports, "CancellationErrorCode", {
    enumerable: true,
    get: function() {
        return $225vB.CancellationErrorCode;
    }
});

var $14ZAb = parcelRequire("14ZAb");
Object.defineProperty(module.exports, "ConnectionEventArgs", {
    enumerable: true,
    get: function() {
        return $14ZAb.ConnectionEventArgs;
    }
});

var $ibe0U = parcelRequire("ibe0U");
Object.defineProperty(module.exports, "ServiceEventArgs", {
    enumerable: true,
    get: function() {
        return $ibe0U.ServiceEventArgs;
    }
});

var $lz0AZ = parcelRequire("lz0AZ");
Object.defineProperty(module.exports, "Connection", {
    enumerable: true,
    get: function() {
        return $lz0AZ.Connection;
    }
});

var $1ccNQ = parcelRequire("1ccNQ");
Object.defineProperty(module.exports, "PhraseListGrammar", {
    enumerable: true,
    get: function() {
        return $1ccNQ.PhraseListGrammar;
    }
});

var $aID4k = parcelRequire("aID4k");
Object.defineProperty(module.exports, "DialogServiceConfig", {
    enumerable: true,
    get: function() {
        return $aID4k.DialogServiceConfig;
    }
});

var $5Cqjy = parcelRequire("5Cqjy");
Object.defineProperty(module.exports, "BotFrameworkConfig", {
    enumerable: true,
    get: function() {
        return $5Cqjy.BotFrameworkConfig;
    }
});

var $7XLtC = parcelRequire("7XLtC");
Object.defineProperty(module.exports, "CustomCommandsConfig", {
    enumerable: true,
    get: function() {
        return $7XLtC.CustomCommandsConfig;
    }
});

var $g7L87 = parcelRequire("g7L87");
Object.defineProperty(module.exports, "DialogServiceConnector", {
    enumerable: true,
    get: function() {
        return $g7L87.DialogServiceConnector;
    }
});

var $ev1KH = parcelRequire("ev1KH");
Object.defineProperty(module.exports, "ActivityReceivedEventArgs", {
    enumerable: true,
    get: function() {
        return $ev1KH.ActivityReceivedEventArgs;
    }
});

var $cTX1T = parcelRequire("cTX1T");
Object.defineProperty(module.exports, "TurnStatusReceivedEventArgs", {
    enumerable: true,
    get: function() {
        return $cTX1T.TurnStatusReceivedEventArgs;
    }
});

var $7yzTn = parcelRequire("7yzTn");
Object.defineProperty(module.exports, "ServicePropertyChannel", {
    enumerable: true,
    get: function() {
        return $7yzTn.ServicePropertyChannel;
    }
});

var $VYwrl = parcelRequire("VYwrl");
Object.defineProperty(module.exports, "ProfanityOption", {
    enumerable: true,
    get: function() {
        return $VYwrl.ProfanityOption;
    }
});

var $d4W5o = parcelRequire("d4W5o");
Object.defineProperty(module.exports, "BaseAudioPlayer", {
    enumerable: true,
    get: function() {
        return $d4W5o.BaseAudioPlayer;
    }
});

var $luex6 = parcelRequire("luex6");
Object.defineProperty(module.exports, "ConnectionMessageEventArgs", {
    enumerable: true,
    get: function() {
        return $luex6.ConnectionMessageEventArgs;
    }
});

var $ldtlJ = parcelRequire("ldtlJ");
Object.defineProperty(module.exports, "ConnectionMessage", {
    enumerable: true,
    get: function() {
        return $ldtlJ.ConnectionMessage;
    }
});

var $9Culy = parcelRequire("9Culy");
Object.defineProperty(module.exports, "VoiceProfile", {
    enumerable: true,
    get: function() {
        return $9Culy.VoiceProfile;
    }
});

var $bKnbO = parcelRequire("bKnbO");
Object.defineProperty(module.exports, "VoiceProfileEnrollmentResult", {
    enumerable: true,
    get: function() {
        return $bKnbO.VoiceProfileEnrollmentResult;
    }
});
Object.defineProperty(module.exports, "VoiceProfileEnrollmentCancellationDetails", {
    enumerable: true,
    get: function() {
        return $bKnbO.VoiceProfileEnrollmentCancellationDetails;
    }
});

var $bnJgP = parcelRequire("bnJgP");
Object.defineProperty(module.exports, "VoiceProfileResult", {
    enumerable: true,
    get: function() {
        return $bnJgP.VoiceProfileResult;
    }
});
Object.defineProperty(module.exports, "VoiceProfileCancellationDetails", {
    enumerable: true,
    get: function() {
        return $bnJgP.VoiceProfileCancellationDetails;
    }
});

var $bUVPH = parcelRequire("bUVPH");
Object.defineProperty(module.exports, "VoiceProfileAuthorizationPhraseResult", {
    enumerable: true,
    get: function() {
        return $bUVPH.VoiceProfileAuthorizationPhraseResult;
    }
});

var $hxIBD = parcelRequire("hxIBD");
Object.defineProperty(module.exports, "VoiceProfileClient", {
    enumerable: true,
    get: function() {
        return $hxIBD.VoiceProfileClient;
    }
});

var $2kSvM = parcelRequire("2kSvM");
Object.defineProperty(module.exports, "SpeakerRecognizer", {
    enumerable: true,
    get: function() {
        return $2kSvM.SpeakerRecognizer;
    }
});

var $3oTtJ = parcelRequire("3oTtJ");
Object.defineProperty(module.exports, "SpeakerIdentificationModel", {
    enumerable: true,
    get: function() {
        return $3oTtJ.SpeakerIdentificationModel;
    }
});

var $iukep = parcelRequire("iukep");
Object.defineProperty(module.exports, "SpeakerVerificationModel", {
    enumerable: true,
    get: function() {
        return $iukep.SpeakerVerificationModel;
    }
});

var $fgpUG = parcelRequire("fgpUG");
Object.defineProperty(module.exports, "AutoDetectSourceLanguageConfig", {
    enumerable: true,
    get: function() {
        return $fgpUG.AutoDetectSourceLanguageConfig;
    }
});

var $lJIjW = parcelRequire("lJIjW");
Object.defineProperty(module.exports, "AutoDetectSourceLanguageResult", {
    enumerable: true,
    get: function() {
        return $lJIjW.AutoDetectSourceLanguageResult;
    }
});

var $j25ra = parcelRequire("j25ra");
Object.defineProperty(module.exports, "SourceLanguageConfig", {
    enumerable: true,
    get: function() {
        return $j25ra.SourceLanguageConfig;
    }
});

var $4bKzl = parcelRequire("4bKzl");
Object.defineProperty(module.exports, "SpeakerRecognitionResult", {
    enumerable: true,
    get: function() {
        return $4bKzl.SpeakerRecognitionResult;
    }
});
Object.defineProperty(module.exports, "SpeakerRecognitionResultType", {
    enumerable: true,
    get: function() {
        return $4bKzl.SpeakerRecognitionResultType;
    }
});
Object.defineProperty(module.exports, "SpeakerRecognitionCancellationDetails", {
    enumerable: true,
    get: function() {
        return $4bKzl.SpeakerRecognitionCancellationDetails;
    }
});

var $by2ku = parcelRequire("by2ku");
Object.defineProperty(module.exports, "Conversation", {
    enumerable: true,
    get: function() {
        return $by2ku.Conversation;
    }
});
Object.defineProperty(module.exports, "ConversationExpirationEventArgs", {
    enumerable: true,
    get: function() {
        return $by2ku.ConversationExpirationEventArgs;
    }
});
Object.defineProperty(module.exports, "ConversationParticipantsChangedEventArgs", {
    enumerable: true,
    get: function() {
        return $by2ku.ConversationParticipantsChangedEventArgs;
    }
});
Object.defineProperty(module.exports, "ConversationTranslationCanceledEventArgs", {
    enumerable: true,
    get: function() {
        return $by2ku.ConversationTranslationCanceledEventArgs;
    }
});
Object.defineProperty(module.exports, "ConversationTranslationEventArgs", {
    enumerable: true,
    get: function() {
        return $by2ku.ConversationTranslationEventArgs;
    }
});
Object.defineProperty(module.exports, "ConversationTranslationResult", {
    enumerable: true,
    get: function() {
        return $by2ku.ConversationTranslationResult;
    }
});
Object.defineProperty(module.exports, "ConversationTranslator", {
    enumerable: true,
    get: function() {
        return $by2ku.ConversationTranslator;
    }
});
Object.defineProperty(module.exports, "ConversationTranscriber", {
    enumerable: true,
    get: function() {
        return $by2ku.ConversationTranscriber;
    }
});
Object.defineProperty(module.exports, "Participant", {
    enumerable: true,
    get: function() {
        return $by2ku.Participant;
    }
});
Object.defineProperty(module.exports, "ParticipantChangedReason", {
    enumerable: true,
    get: function() {
        return $by2ku.ParticipantChangedReason;
    }
});
Object.defineProperty(module.exports, "User", {
    enumerable: true,
    get: function() {
        return $by2ku.User;
    }
});

var $eYlAB = parcelRequire("eYlAB");
Object.defineProperty(module.exports, "SpeechSynthesisOutputFormat", {
    enumerable: true,
    get: function() {
        return $eYlAB.SpeechSynthesisOutputFormat;
    }
});

var $n4jmR = parcelRequire("n4jmR");
Object.defineProperty(module.exports, "SpeechSynthesizer", {
    enumerable: true,
    get: function() {
        return $n4jmR.SpeechSynthesizer;
    }
});

var $8tQIl = parcelRequire("8tQIl");
Object.defineProperty(module.exports, "SpeechSynthesisResult", {
    enumerable: true,
    get: function() {
        return $8tQIl.SpeechSynthesisResult;
    }
});

var $3mo9G = parcelRequire("3mo9G");
Object.defineProperty(module.exports, "SpeechSynthesisEventArgs", {
    enumerable: true,
    get: function() {
        return $3mo9G.SpeechSynthesisEventArgs;
    }
});

var $9Rbw1 = parcelRequire("9Rbw1");
Object.defineProperty(module.exports, "SpeechSynthesisWordBoundaryEventArgs", {
    enumerable: true,
    get: function() {
        return $9Rbw1.SpeechSynthesisWordBoundaryEventArgs;
    }
});

var $2dwxT = parcelRequire("2dwxT");
Object.defineProperty(module.exports, "SpeechSynthesisBookmarkEventArgs", {
    enumerable: true,
    get: function() {
        return $2dwxT.SpeechSynthesisBookmarkEventArgs;
    }
});

var $jlPPH = parcelRequire("jlPPH");
Object.defineProperty(module.exports, "SpeechSynthesisVisemeEventArgs", {
    enumerable: true,
    get: function() {
        return $jlPPH.SpeechSynthesisVisemeEventArgs;
    }
});

var $kNmMK = parcelRequire("kNmMK");
Object.defineProperty(module.exports, "SpeakerAudioDestination", {
    enumerable: true,
    get: function() {
        return $kNmMK.SpeakerAudioDestination;
    }
});

var $6bF60 = parcelRequire("6bF60");
Object.defineProperty(module.exports, "ConversationTranscriptionCanceledEventArgs", {
    enumerable: true,
    get: function() {
        return $6bF60.ConversationTranscriptionCanceledEventArgs;
    }
});

var $akQdQ = parcelRequire("akQdQ");
Object.defineProperty(module.exports, "PronunciationAssessmentGradingSystem", {
    enumerable: true,
    get: function() {
        return $akQdQ.PronunciationAssessmentGradingSystem;
    }
});

var $2ZPnp = parcelRequire("2ZPnp");
Object.defineProperty(module.exports, "PronunciationAssessmentGranularity", {
    enumerable: true,
    get: function() {
        return $2ZPnp.PronunciationAssessmentGranularity;
    }
});

var $8zUca = parcelRequire("8zUca");
Object.defineProperty(module.exports, "PronunciationAssessmentConfig", {
    enumerable: true,
    get: function() {
        return $8zUca.PronunciationAssessmentConfig;
    }
});

var $gxTum = parcelRequire("gxTum");
Object.defineProperty(module.exports, "PronunciationAssessmentResult", {
    enumerable: true,
    get: function() {
        return $gxTum.PronunciationAssessmentResult;
    }
});

});
parcelRequire.register("4J3Mu", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
var $370e4c413c9a40e2$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.AudioOutputConfigImpl = module.exports.AudioConfigImpl = module.exports.AudioConfig = void 0;

var $9h4kO = parcelRequire("9h4kO");

var $evvAW = parcelRequire("evvAW");

var $iQDnw = parcelRequire("iQDnw");

var $dydmC = parcelRequire("dydmC");

var $lNEKs = parcelRequire("lNEKs");

var $epVjg = parcelRequire("epVjg");
/**
 * Represents audio input configuration used for specifying what type of input to use (microphone, file, stream).
 * @class AudioConfig
 * Updated in version 1.11.0
 */ var $370e4c413c9a40e2$var$AudioConfig = /** @class */ function() {
    function AudioConfig() {}
    /**
     * Creates an AudioConfig object representing the default microphone on the system.
     * @member AudioConfig.fromDefaultMicrophoneInput
     * @function
     * @public
     * @returns {AudioConfig} The audio input configuration being created.
     */ AudioConfig.fromDefaultMicrophoneInput = function() {
        var pcmRecorder = new $9h4kO.PcmRecorder();
        return new $370e4c413c9a40e2$var$AudioConfigImpl(new $9h4kO.MicAudioSource(pcmRecorder));
    };
    /**
     * Creates an AudioConfig object representing a microphone with the specified device ID.
     * @member AudioConfig.fromMicrophoneInput
     * @function
     * @public
     * @param {string | undefined} deviceId - Specifies the device ID of the microphone to be used.
     *        Default microphone is used the value is omitted.
     * @returns {AudioConfig} The audio input configuration being created.
     */ AudioConfig.fromMicrophoneInput = function(deviceId) {
        var pcmRecorder = new $9h4kO.PcmRecorder();
        return new $370e4c413c9a40e2$var$AudioConfigImpl(new $9h4kO.MicAudioSource(pcmRecorder, deviceId));
    };
    /**
     * Creates an AudioConfig object representing the specified file.
     * @member AudioConfig.fromWavFileInput
     * @function
     * @public
     * @param {File} fileName - Specifies the audio input file. Currently, only WAV / PCM is supported.
     * @returns {AudioConfig} The audio input configuration being created.
     */ AudioConfig.fromWavFileInput = function(file, name) {
        if (name === void 0) name = "unnamedBuffer.wav";
        return new $370e4c413c9a40e2$var$AudioConfigImpl(new $9h4kO.FileAudioSource(file, name));
    };
    /**
     * Creates an AudioConfig object representing the specified stream.
     * @member AudioConfig.fromStreamInput
     * @function
     * @public
     * @param {AudioInputStream | PullAudioInputStreamCallback | MediaStream} audioStream - Specifies the custom audio input
     *        stream. Currently, only WAV / PCM is supported.
     * @returns {AudioConfig} The audio input configuration being created.
     */ AudioConfig.fromStreamInput = function(audioStream) {
        if (audioStream instanceof $iQDnw.PullAudioInputStreamCallback) return new $370e4c413c9a40e2$var$AudioConfigImpl(new $lNEKs.PullAudioInputStreamImpl(audioStream));
        if (audioStream instanceof $iQDnw.AudioInputStream) return new $370e4c413c9a40e2$var$AudioConfigImpl(audioStream);
        if (typeof MediaStream !== "undefined" && audioStream instanceof MediaStream) {
            var pcmRecorder = new $9h4kO.PcmRecorder();
            return new $370e4c413c9a40e2$var$AudioConfigImpl(new $9h4kO.MicAudioSource(pcmRecorder, null, null, audioStream));
        }
        throw new Error("Not Supported Type");
    };
    /**
     * Creates an AudioConfig object representing the default speaker.
     * @member AudioConfig.fromDefaultSpeakerOutput
     * @function
     * @public
     * @returns {AudioConfig} The audio output configuration being created.
     * Added in version 1.11.0
     */ AudioConfig.fromDefaultSpeakerOutput = function() {
        return new $370e4c413c9a40e2$var$AudioOutputConfigImpl(new $iQDnw.SpeakerAudioDestination());
    };
    /**
     * Creates an AudioConfig object representing the custom IPlayer object.
     * You can use the IPlayer object to control pause, resume, etc.
     * @member AudioConfig.fromSpeakerOutput
     * @function
     * @public
     * @param {IPlayer} player - the IPlayer object for playback.
     * @returns {AudioConfig} The audio output configuration being created.
     * Added in version 1.12.0
     */ AudioConfig.fromSpeakerOutput = function(player) {
        if (player === undefined) return AudioConfig.fromDefaultSpeakerOutput();
        if (player instanceof $iQDnw.SpeakerAudioDestination) return new $370e4c413c9a40e2$var$AudioOutputConfigImpl(player);
        throw new Error("Not Supported Type");
    };
    /**
     * Creates an AudioConfig object representing a specified output audio file
     * @member AudioConfig.fromAudioFileOutput
     * @function
     * @public
     * @param {PathLike} filename - the filename of the output audio file
     * @returns {AudioConfig} The audio output configuration being created.
     * Added in version 1.11.0
     */ AudioConfig.fromAudioFileOutput = function(filename) {
        return new $370e4c413c9a40e2$var$AudioOutputConfigImpl(new $dydmC.AudioFileWriter(filename));
    };
    /**
     * Creates an AudioConfig object representing a specified audio output stream
     * @member AudioConfig.fromStreamOutput
     * @function
     * @public
     * @param {AudioOutputStream | PushAudioOutputStreamCallback} audioStream - Specifies the custom audio output
     *        stream.
     * @returns {AudioConfig} The audio output configuration being created.
     * Added in version 1.11.0
     */ AudioConfig.fromStreamOutput = function(audioStream) {
        if (audioStream instanceof $iQDnw.PushAudioOutputStreamCallback) return new $370e4c413c9a40e2$var$AudioOutputConfigImpl(new $epVjg.PushAudioOutputStreamImpl(audioStream));
        if (audioStream instanceof $iQDnw.PushAudioOutputStream) return new $370e4c413c9a40e2$var$AudioOutputConfigImpl(audioStream);
        if (audioStream instanceof $iQDnw.PullAudioOutputStream) return new $370e4c413c9a40e2$var$AudioOutputConfigImpl(audioStream);
        throw new Error("Not Supported Type");
    };
    return AudioConfig;
}();
module.exports.AudioConfig = $370e4c413c9a40e2$var$AudioConfig;
/**
 * Represents audio input stream used for custom audio input configurations.
 * @private
 * @class AudioConfigImpl
 */ var $370e4c413c9a40e2$var$AudioConfigImpl = /** @class */ function(_super) {
    $370e4c413c9a40e2$var$__extends(AudioConfigImpl, _super);
    /**
     * Creates and initializes an instance of this class.
     * @constructor
     * @param {IAudioSource} source - An audio source.
     */ function AudioConfigImpl(source) {
        var _this = _super.call(this) || this;
        _this.privSource = source;
        return _this;
    }
    Object.defineProperty(AudioConfigImpl.prototype, "format", {
        /**
         * Format information for the audio
         */ get: function() {
            return this.privSource.format;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * @member AudioConfigImpl.prototype.close
     * @function
     * @public
     */ AudioConfigImpl.prototype.close = function(cb, err) {
        this.privSource.turnOff().then(function() {
            if (!!cb) cb();
        }, function(error) {
            if (!!err) err(error);
        });
    };
    /**
     * @member AudioConfigImpl.prototype.id
     * @function
     * @public
     */ AudioConfigImpl.prototype.id = function() {
        return this.privSource.id();
    };
    Object.defineProperty(AudioConfigImpl.prototype, "blob", {
        /**
         * @member AudioConfigImpl.prototype.blob
         * @function
         * @public
         */ get: function() {
            return this.privSource.blob;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * @member AudioConfigImpl.prototype.turnOn
     * @function
     * @public
     * @returns {Promise<void>} A promise.
     */ AudioConfigImpl.prototype.turnOn = function() {
        return this.privSource.turnOn();
    };
    /**
     * @member AudioConfigImpl.prototype.attach
     * @function
     * @public
     * @param {string} audioNodeId - The audio node id.
     * @returns {Promise<IAudioStreamNode>} A promise.
     */ AudioConfigImpl.prototype.attach = function(audioNodeId) {
        return this.privSource.attach(audioNodeId);
    };
    /**
     * @member AudioConfigImpl.prototype.detach
     * @function
     * @public
     * @param {string} audioNodeId - The audio node id.
     */ AudioConfigImpl.prototype.detach = function(audioNodeId) {
        return this.privSource.detach(audioNodeId);
    };
    /**
     * @member AudioConfigImpl.prototype.turnOff
     * @function
     * @public
     * @returns {Promise<void>} A promise.
     */ AudioConfigImpl.prototype.turnOff = function() {
        return this.privSource.turnOff();
    };
    Object.defineProperty(AudioConfigImpl.prototype, "events", {
        /**
         * @member AudioConfigImpl.prototype.events
         * @function
         * @public
         * @returns {EventSource<AudioSourceEvent>} An event source for audio events.
         */ get: function() {
            return this.privSource.events;
        },
        enumerable: false,
        configurable: true
    });
    AudioConfigImpl.prototype.setProperty = function(name, value) {
        $evvAW.Contracts.throwIfNull(value, "value");
        if (undefined !== this.privSource.setProperty) this.privSource.setProperty(name, value);
        else throw new Error("This AudioConfig instance does not support setting properties.");
    };
    AudioConfigImpl.prototype.getProperty = function(name, def) {
        if (undefined !== this.privSource.getProperty) return this.privSource.getProperty(name, def);
        else throw new Error("This AudioConfig instance does not support getting properties.");
        return def;
    };
    Object.defineProperty(AudioConfigImpl.prototype, "deviceInfo", {
        get: function() {
            return this.privSource.deviceInfo;
        },
        enumerable: false,
        configurable: true
    });
    return AudioConfigImpl;
}($370e4c413c9a40e2$var$AudioConfig);
module.exports.AudioConfigImpl = $370e4c413c9a40e2$var$AudioConfigImpl;
var $370e4c413c9a40e2$var$AudioOutputConfigImpl = /** @class */ function(_super) {
    $370e4c413c9a40e2$var$__extends(AudioOutputConfigImpl, _super);
    /**
     * Creates and initializes an instance of this class.
     * @constructor
     * @param {IAudioDestination} destination - An audio destination.
     */ function AudioOutputConfigImpl(destination) {
        var _this = _super.call(this) || this;
        _this.privDestination = destination;
        return _this;
    }
    Object.defineProperty(AudioOutputConfigImpl.prototype, "format", {
        set: function(format) {
            this.privDestination.format = format;
        },
        enumerable: false,
        configurable: true
    });
    AudioOutputConfigImpl.prototype.write = function(buffer) {
        this.privDestination.write(buffer);
    };
    AudioOutputConfigImpl.prototype.close = function() {
        this.privDestination.close();
    };
    AudioOutputConfigImpl.prototype.id = function() {
        return this.privDestination.id();
    };
    AudioOutputConfigImpl.prototype.setProperty = function(name, value) {
        throw new Error("This AudioConfig instance does not support setting properties.");
    };
    AudioOutputConfigImpl.prototype.getProperty = function(name, def) {
        throw new Error("This AudioConfig instance does not support getting properties.");
    };
    return AudioOutputConfigImpl;
}($370e4c413c9a40e2$var$AudioConfig);
module.exports.AudioOutputConfigImpl = $370e4c413c9a40e2$var$AudioOutputConfigImpl;

});
parcelRequire.register("evvAW", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Contracts = void 0;
/**
 * @class Contracts
 * @private
 */ var $a8fc7804c17c5c56$var$Contracts = /** @class */ function() {
    function Contracts() {}
    Contracts.throwIfNullOrUndefined = function(param, name) {
        if (param === undefined || param === null) throw new Error("throwIfNullOrUndefined:" + name);
    };
    Contracts.throwIfNull = function(param, name) {
        if (param === null) throw new Error("throwIfNull:" + name);
    };
    Contracts.throwIfNullOrWhitespace = function(param, name) {
        Contracts.throwIfNullOrUndefined(param, name);
        if (("" + param).trim().length < 1) throw new Error("throwIfNullOrWhitespace:" + name);
    };
    Contracts.throwIfDisposed = function(isDisposed) {
        if (isDisposed) throw new Error("the object is already disposed");
    };
    Contracts.throwIfArrayEmptyOrWhitespace = function(array, name) {
        Contracts.throwIfNullOrUndefined(array, name);
        if (array.length === 0) throw new Error("throwIfArrayEmptyOrWhitespace:" + name);
        for(var _i = 0, array_1 = array; _i < array_1.length; _i++){
            var item = array_1[_i];
            Contracts.throwIfNullOrWhitespace(item, name);
        }
    };
    Contracts.throwIfFileDoesNotExist = function(param, name) {
        Contracts.throwIfNullOrWhitespace(param, name);
    // TODO check for file existence.
    };
    Contracts.throwIfNotUndefined = function(param, name) {
        if (param !== undefined) throw new Error("throwIfNotUndefined:" + name);
    };
    return Contracts;
}();
module.exports.Contracts = $a8fc7804c17c5c56$var$Contracts;

});

parcelRequire.register("dydmC", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
var $9dd8d11d659eb396$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $9dd8d11d659eb396$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $9dd8d11d659eb396$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.hasOwnProperty.call(mod, k)) $9dd8d11d659eb396$var$__createBinding(result, mod, k);
    }
    $9dd8d11d659eb396$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.AudioFileWriter = void 0;

var $9dd8d11d659eb396$var$fs = $9dd8d11d659eb396$var$__importStar((parcelRequire("gR5sk")));

var $evvAW = parcelRequire("evvAW");
var $9dd8d11d659eb396$var$AudioFileWriter = /** @class */ function() {
    function AudioFileWriter(filename) {
        var _this = this;
        this.id = function() {
            return _this.privId;
        };
        $evvAW.Contracts.throwIfNullOrUndefined($9dd8d11d659eb396$var$fs.openSync, "\nFile System access not available, please use Push or PullAudioOutputStream");
        this.privFd = $9dd8d11d659eb396$var$fs.openSync(filename, "w");
    }
    Object.defineProperty(AudioFileWriter.prototype, "format", {
        set: function(format) {
            $evvAW.Contracts.throwIfNotUndefined(this.privAudioFormat, "format is already set");
            this.privAudioFormat = format;
            var headerOffset = 0;
            if (this.privAudioFormat.hasHeader) headerOffset = this.privAudioFormat.header.byteLength;
            if (this.privFd !== undefined) this.privWriteStream = $9dd8d11d659eb396$var$fs.createWriteStream("", {
                fd: this.privFd,
                start: headerOffset,
                autoClose: false
            });
        },
        enumerable: false,
        configurable: true
    });
    AudioFileWriter.prototype.write = function(buffer) {
        $evvAW.Contracts.throwIfNullOrUndefined(this.privAudioFormat, "must set format before writing.");
        if (this.privWriteStream !== undefined) this.privWriteStream.write(new Uint8Array(buffer.slice(0)));
    };
    AudioFileWriter.prototype.close = function() {
        var _this = this;
        if (this.privFd !== undefined) {
            this.privWriteStream.on("finish", function() {
                if (_this.privAudioFormat.hasHeader) {
                    _this.privAudioFormat.updateHeader(_this.privWriteStream.bytesWritten);
                    $9dd8d11d659eb396$var$fs.writeSync(_this.privFd, new Int8Array(_this.privAudioFormat.header), 0, _this.privAudioFormat.header.byteLength, 0);
                }
                $9dd8d11d659eb396$var$fs.closeSync(_this.privFd);
                _this.privFd = undefined;
            });
            this.privWriteStream.end();
        }
    };
    return AudioFileWriter;
}();
module.exports.AudioFileWriter = $9dd8d11d659eb396$var$AudioFileWriter;

});
parcelRequire.register("gR5sk", function(module, exports) {
"use strict";

});


parcelRequire.register("lNEKs", function(module, exports) {

var $cBXue = parcelRequire("cBXue");
var $fdedc854765160fd$require$Buffer = $cBXue.Buffer;
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
var $fdedc854765160fd$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $fdedc854765160fd$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $fdedc854765160fd$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PullAudioInputStreamImpl = module.exports.PullAudioInputStream = module.exports.PushAudioInputStreamImpl = module.exports.PushAudioInputStream = module.exports.AudioInputStream = void 0;

var $9MAMI = parcelRequire("9MAMI");

var $7srwU = parcelRequire("7srwU");

var $6B7tN = parcelRequire("6B7tN");

var $iQDnw = parcelRequire("iQDnw");

var $7PHxc = parcelRequire("7PHxc");
/**
 * Represents audio input stream used for custom audio input configurations.
 * @class AudioInputStream
 */ var $fdedc854765160fd$var$AudioInputStream = /** @class */ function() {
    /**
     * Creates and initializes an instance.
     * @constructor
     */ function AudioInputStream() {}
    /**
     * Creates a memory backed PushAudioInputStream with the specified audio format.
     * @member AudioInputStream.createPushStream
     * @function
     * @public
     * @param {AudioStreamFormat} format - The audio data format in which audio will be
     *        written to the push audio stream's write() method (Required if format is not 16 kHz 16bit mono PCM).
     * @returns {PushAudioInputStream} The audio input stream being created.
     */ AudioInputStream.createPushStream = function(format) {
        return $fdedc854765160fd$var$PushAudioInputStream.create(format);
    };
    /**
     * Creates a PullAudioInputStream that delegates to the specified callback interface for read()
     * and close() methods.
     * @member AudioInputStream.createPullStream
     * @function
     * @public
     * @param {PullAudioInputStreamCallback} callback - The custom audio input object, derived from
     *        PullAudioInputStreamCallback
     * @param {AudioStreamFormat} format - The audio data format in which audio will be returned from
     *        the callback's read() method (Required if format is not 16 kHz 16bit mono PCM).
     * @returns {PullAudioInputStream} The audio input stream being created.
     */ AudioInputStream.createPullStream = function(callback, format) {
        return $fdedc854765160fd$var$PullAudioInputStream.create(callback, format);
    // throw new Error("Oops");
    };
    return AudioInputStream;
}();
module.exports.AudioInputStream = $fdedc854765160fd$var$AudioInputStream;
/**
 * Represents memory backed push audio input stream used for custom audio input configurations.
 * @class PushAudioInputStream
 */ var $fdedc854765160fd$var$PushAudioInputStream = /** @class */ function(_super) {
    $fdedc854765160fd$var$__extends(PushAudioInputStream, _super);
    function PushAudioInputStream() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Creates a memory backed PushAudioInputStream with the specified audio format.
     * @member PushAudioInputStream.create
     * @function
     * @public
     * @param {AudioStreamFormat} format - The audio data format in which audio will be written to the
     *        push audio stream's write() method (Required if format is not 16 kHz 16bit mono PCM).
     * @returns {PushAudioInputStream} The push audio input stream being created.
     */ PushAudioInputStream.create = function(format) {
        return new $fdedc854765160fd$var$PushAudioInputStreamImpl(format);
    };
    return PushAudioInputStream;
}($fdedc854765160fd$var$AudioInputStream);
module.exports.PushAudioInputStream = $fdedc854765160fd$var$PushAudioInputStream;
/**
 * Represents memory backed push audio input stream used for custom audio input configurations.
 * @private
 * @class PushAudioInputStreamImpl
 */ var $fdedc854765160fd$var$PushAudioInputStreamImpl = /** @class */ function(_super) {
    $fdedc854765160fd$var$__extends(PushAudioInputStreamImpl, _super);
    /**
     * Creates and initalizes an instance with the given values.
     * @constructor
     * @param {AudioStreamFormat} format - The audio stream format.
     */ function PushAudioInputStreamImpl(format) {
        var _this = _super.call(this) || this;
        _this.onEvent = function(event) {
            _this.privEvents.onEvent(event);
            $7srwU.Events.instance.onEvent(event);
        };
        if (format === undefined) _this.privFormat = $7PHxc.AudioStreamFormatImpl.getDefaultInputFormat();
        else _this.privFormat = format;
        _this.privEvents = new $7srwU.EventSource();
        _this.privId = $6B7tN.createNoDashGuid();
        _this.privStream = new $7srwU.ChunkedArrayBufferStream(_this.privFormat.avgBytesPerSec / 10);
        return _this;
    }
    Object.defineProperty(PushAudioInputStreamImpl.prototype, "format", {
        /**
         * Format information for the audio
         */ get: function() {
            return Promise.resolve(this.privFormat);
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Writes the audio data specified by making an internal copy of the data.
     * @member PushAudioInputStreamImpl.prototype.write
     * @function
     * @public
     * @param {ArrayBuffer} dataBuffer - The audio buffer of which this function will make a copy.
     */ PushAudioInputStreamImpl.prototype.write = function(dataBuffer) {
        this.privStream.writeStreamChunk({
            buffer: dataBuffer,
            isEnd: false,
            timeReceived: Date.now()
        });
    };
    /**
     * Closes the stream.
     * @member PushAudioInputStreamImpl.prototype.close
     * @function
     * @public
     */ PushAudioInputStreamImpl.prototype.close = function() {
        this.privStream.close();
    };
    PushAudioInputStreamImpl.prototype.id = function() {
        return this.privId;
    };
    Object.defineProperty(PushAudioInputStreamImpl.prototype, "blob", {
        get: function() {
            var _this = this;
            return this.attach("id").then(function(audioNode) {
                var data = [];
                var bufferData = $fdedc854765160fd$require$Buffer.from("");
                var readCycle = function() {
                    return audioNode.read().then(function(audioStreamChunk) {
                        if (!audioStreamChunk || audioStreamChunk.isEnd) {
                            if (typeof XMLHttpRequest !== "undefined" && typeof Blob !== "undefined") return Promise.resolve(new Blob(data));
                            else return Promise.resolve($fdedc854765160fd$require$Buffer.from(bufferData));
                        } else {
                            if (typeof Blob !== "undefined") data.push(audioStreamChunk.buffer);
                            else bufferData = $fdedc854765160fd$require$Buffer.concat([
                                bufferData,
                                _this.toBuffer(audioStreamChunk.buffer)
                            ]);
                            return readCycle();
                        }
                    });
                };
                return readCycle();
            });
        },
        enumerable: false,
        configurable: true
    });
    PushAudioInputStreamImpl.prototype.turnOn = function() {
        this.onEvent(new $7srwU.AudioSourceInitializingEvent(this.privId)); // no stream id
        this.onEvent(new $7srwU.AudioSourceReadyEvent(this.privId));
        return;
    };
    PushAudioInputStreamImpl.prototype.attach = function(audioNodeId) {
        return $fdedc854765160fd$var$__awaiter(this, void 0, void 0, function() {
            var stream;
            var _this = this;
            return $fdedc854765160fd$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        this.onEvent(new $7srwU.AudioStreamNodeAttachingEvent(this.privId, audioNodeId));
                        return [
                            4 /*yield*/ ,
                            this.turnOn()
                        ];
                    case 1:
                        _a.sent();
                        stream = this.privStream;
                        this.onEvent(new $7srwU.AudioStreamNodeAttachedEvent(this.privId, audioNodeId));
                        return [
                            2 /*return*/ ,
                            {
                                detach: function() {
                                    return $fdedc854765160fd$var$__awaiter(_this, void 0, void 0, function() {
                                        return $fdedc854765160fd$var$__generator(this, function(_a) {
                                            stream.readEnded();
                                            this.onEvent(new $7srwU.AudioStreamNodeDetachedEvent(this.privId, audioNodeId));
                                            return [
                                                2 /*return*/ ,
                                                this.turnOff()
                                            ];
                                        });
                                    });
                                },
                                id: function() {
                                    return audioNodeId;
                                },
                                read: function() {
                                    return stream.read();
                                }
                            }
                        ];
                }
            });
        });
    };
    PushAudioInputStreamImpl.prototype.detach = function(audioNodeId) {
        this.onEvent(new $7srwU.AudioStreamNodeDetachedEvent(this.privId, audioNodeId));
    };
    PushAudioInputStreamImpl.prototype.turnOff = function() {
        return;
    };
    Object.defineProperty(PushAudioInputStreamImpl.prototype, "events", {
        get: function() {
            return this.privEvents;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PushAudioInputStreamImpl.prototype, "deviceInfo", {
        get: function() {
            return Promise.resolve({
                bitspersample: this.privFormat.bitsPerSample,
                channelcount: this.privFormat.channels,
                connectivity: $9MAMI.connectivity.Unknown,
                manufacturer: "Speech SDK",
                model: "PushStream",
                samplerate: this.privFormat.samplesPerSec,
                type: $9MAMI.type.Stream
            });
        },
        enumerable: false,
        configurable: true
    });
    PushAudioInputStreamImpl.prototype.toBuffer = function(arrayBuffer) {
        var buf = $fdedc854765160fd$require$Buffer.alloc(arrayBuffer.byteLength);
        var view = new Uint8Array(arrayBuffer);
        for(var i = 0; i < buf.length; ++i)buf[i] = view[i];
        return buf;
    };
    return PushAudioInputStreamImpl;
}($fdedc854765160fd$var$PushAudioInputStream);
module.exports.PushAudioInputStreamImpl = $fdedc854765160fd$var$PushAudioInputStreamImpl;
/*
 * Represents audio input stream used for custom audio input configurations.
 * @class PullAudioInputStream
 */ var $fdedc854765160fd$var$PullAudioInputStream = /** @class */ function(_super) {
    $fdedc854765160fd$var$__extends(PullAudioInputStream, _super);
    /**
     * Creates and initializes and instance.
     * @constructor
     */ function PullAudioInputStream() {
        return _super.call(this) || this;
    }
    /**
     * Creates a PullAudioInputStream that delegates to the specified callback interface for
     * read() and close() methods, using the default format (16 kHz 16bit mono PCM).
     * @member PullAudioInputStream.create
     * @function
     * @public
     * @param {PullAudioInputStreamCallback} callback - The custom audio input object,
     *        derived from PullAudioInputStreamCustomCallback
     * @param {AudioStreamFormat} format - The audio data format in which audio will be
     *        returned from the callback's read() method (Required if format is not 16 kHz 16bit mono PCM).
     * @returns {PullAudioInputStream} The push audio input stream being created.
     */ PullAudioInputStream.create = function(callback, format) {
        return new $fdedc854765160fd$var$PullAudioInputStreamImpl(callback, format);
    };
    return PullAudioInputStream;
}($fdedc854765160fd$var$AudioInputStream);
module.exports.PullAudioInputStream = $fdedc854765160fd$var$PullAudioInputStream;
/**
 * Represents audio input stream used for custom audio input configurations.
 * @private
 * @class PullAudioInputStreamImpl
 */ var $fdedc854765160fd$var$PullAudioInputStreamImpl = /** @class */ function(_super) {
    $fdedc854765160fd$var$__extends(PullAudioInputStreamImpl, _super);
    /**
     * Creates a PullAudioInputStream that delegates to the specified callback interface for
     * read() and close() methods, using the default format (16 kHz 16bit mono PCM).
     * @constructor
     * @param {PullAudioInputStreamCallback} callback - The custom audio input object,
     *        derived from PullAudioInputStreamCustomCallback
     * @param {AudioStreamFormat} format - The audio data format in which audio will be
     *        returned from the callback's read() method (Required if format is not 16 kHz 16bit mono PCM).
     */ function PullAudioInputStreamImpl(callback, format) {
        var _this = _super.call(this) || this;
        _this.onEvent = function(event) {
            _this.privEvents.onEvent(event);
            $7srwU.Events.instance.onEvent(event);
        };
        if (undefined === format) _this.privFormat = $iQDnw.AudioStreamFormat.getDefaultInputFormat();
        else _this.privFormat = format;
        _this.privEvents = new $7srwU.EventSource();
        _this.privId = $6B7tN.createNoDashGuid();
        _this.privCallback = callback;
        _this.privIsClosed = false;
        _this.privBufferSize = _this.privFormat.avgBytesPerSec / 10;
        return _this;
    }
    Object.defineProperty(PullAudioInputStreamImpl.prototype, "format", {
        /**
         * Format information for the audio
         */ get: function() {
            return Promise.resolve(this.privFormat);
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Closes the stream.
     * @member PullAudioInputStreamImpl.prototype.close
     * @function
     * @public
     */ PullAudioInputStreamImpl.prototype.close = function() {
        this.privIsClosed = true;
        this.privCallback.close();
    };
    PullAudioInputStreamImpl.prototype.id = function() {
        return this.privId;
    };
    Object.defineProperty(PullAudioInputStreamImpl.prototype, "blob", {
        get: function() {
            return Promise.reject("Not implemented");
        },
        enumerable: false,
        configurable: true
    });
    PullAudioInputStreamImpl.prototype.turnOn = function() {
        this.onEvent(new $7srwU.AudioSourceInitializingEvent(this.privId)); // no stream id
        this.onEvent(new $7srwU.AudioSourceReadyEvent(this.privId));
        return;
    };
    PullAudioInputStreamImpl.prototype.attach = function(audioNodeId) {
        return $fdedc854765160fd$var$__awaiter(this, void 0, void 0, function() {
            var _this = this;
            return $fdedc854765160fd$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        this.onEvent(new $7srwU.AudioStreamNodeAttachingEvent(this.privId, audioNodeId));
                        return [
                            4 /*yield*/ ,
                            this.turnOn()
                        ];
                    case 1:
                        _a.sent();
                        this.onEvent(new $7srwU.AudioStreamNodeAttachedEvent(this.privId, audioNodeId));
                        return [
                            2 /*return*/ ,
                            {
                                detach: function() {
                                    _this.privCallback.close();
                                    _this.onEvent(new $7srwU.AudioStreamNodeDetachedEvent(_this.privId, audioNodeId));
                                    return _this.turnOff();
                                },
                                id: function() {
                                    return audioNodeId;
                                },
                                read: function() {
                                    var totalBytes = 0;
                                    var transmitBuff;
                                    // Until we have the minimum number of bytes to send in a transmission, keep asking for more.
                                    while(totalBytes < _this.privBufferSize){
                                        // Sizing the read buffer to the delta between the perfect size and what's left means we won't ever get too much
                                        // data back.
                                        var readBuff = new ArrayBuffer(_this.privBufferSize - totalBytes);
                                        var pulledBytes = _this.privCallback.read(readBuff);
                                        // If there is no return buffer yet defined, set the return buffer to the that was just populated.
                                        // This was, if we have enough data there's no copy penalty, but if we don't we have a buffer that's the
                                        // preferred size allocated.
                                        if (undefined === transmitBuff) transmitBuff = readBuff;
                                        else {
                                            // Not the first bite at the apple, so fill the return buffer with the data we got back.
                                            var intView = new Int8Array(transmitBuff);
                                            intView.set(new Int8Array(readBuff), totalBytes);
                                        }
                                        // If there are no bytes to read, just break out and be done.
                                        if (0 === pulledBytes) break;
                                        totalBytes += pulledBytes;
                                    }
                                    return Promise.resolve({
                                        buffer: transmitBuff.slice(0, totalBytes),
                                        isEnd: _this.privIsClosed || totalBytes === 0,
                                        timeReceived: Date.now()
                                    });
                                }
                            }
                        ];
                }
            });
        });
    };
    PullAudioInputStreamImpl.prototype.detach = function(audioNodeId) {
        this.onEvent(new $7srwU.AudioStreamNodeDetachedEvent(this.privId, audioNodeId));
    };
    PullAudioInputStreamImpl.prototype.turnOff = function() {
        return;
    };
    Object.defineProperty(PullAudioInputStreamImpl.prototype, "events", {
        get: function() {
            return this.privEvents;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PullAudioInputStreamImpl.prototype, "deviceInfo", {
        get: function() {
            return Promise.resolve({
                bitspersample: this.privFormat.bitsPerSample,
                channelcount: this.privFormat.channels,
                connectivity: $9MAMI.connectivity.Unknown,
                manufacturer: "Speech SDK",
                model: "PullStream",
                samplerate: this.privFormat.samplesPerSec,
                type: $9MAMI.type.Stream
            });
        },
        enumerable: false,
        configurable: true
    });
    return PullAudioInputStreamImpl;
}($fdedc854765160fd$var$PullAudioInputStream);
module.exports.PullAudioInputStreamImpl = $fdedc854765160fd$var$PullAudioInputStreamImpl;

});
parcelRequire.register("cBXue", function(module, exports) {

$parcel$export(module.exports, "Buffer", () => $92e7158efb4d49dd$export$a143d493d941bafc, (v) => $92e7158efb4d49dd$export$a143d493d941bafc = v);
$parcel$export(module.exports, "INSPECT_MAX_BYTES", () => $92e7158efb4d49dd$export$f99ded8fe4b79145, (v) => $92e7158efb4d49dd$export$f99ded8fe4b79145 = v);
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $92e7158efb4d49dd$export$a143d493d941bafc;
var $92e7158efb4d49dd$export$e4cf37d7f6fb9e0a;
var $92e7158efb4d49dd$export$f99ded8fe4b79145;
var $92e7158efb4d49dd$export$599f31c3813fae4d;
"use strict";

var $4nf3l = parcelRequire("4nf3l");

var $iL6rd = parcelRequire("iL6rd");
var $92e7158efb4d49dd$var$customInspectSymbol = typeof Symbol === "function" && typeof Symbol["for"] === "function" // eslint-disable-line dot-notation
 ? Symbol["for"]("nodejs.util.inspect.custom") // eslint-disable-line dot-notation
 : null;
$92e7158efb4d49dd$export$a143d493d941bafc = $92e7158efb4d49dd$var$Buffer;
$92e7158efb4d49dd$export$e4cf37d7f6fb9e0a = $92e7158efb4d49dd$var$SlowBuffer;
$92e7158efb4d49dd$export$f99ded8fe4b79145 = 50;
var $92e7158efb4d49dd$var$K_MAX_LENGTH = 0x7fffffff;
$92e7158efb4d49dd$export$599f31c3813fae4d = $92e7158efb4d49dd$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $92e7158efb4d49dd$var$Buffer.TYPED_ARRAY_SUPPORT = $92e7158efb4d49dd$var$typedArraySupport();
if (!$92e7158efb4d49dd$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== "undefined" && typeof console.error === "function") console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $92e7158efb4d49dd$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        var arr = new Uint8Array(1);
        var proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($92e7158efb4d49dd$var$Buffer.prototype, "parent", {
    enumerable: true,
    get: function() {
        if (!$92e7158efb4d49dd$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($92e7158efb4d49dd$var$Buffer.prototype, "offset", {
    enumerable: true,
    get: function() {
        if (!$92e7158efb4d49dd$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $92e7158efb4d49dd$var$createBuffer(length) {
    if (length > $92e7158efb4d49dd$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    var buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $92e7158efb4d49dd$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $92e7158efb4d49dd$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === "number") {
        if (typeof encodingOrOffset === "string") throw new TypeError('The "string" argument must be of type string. Received type number');
        return $92e7158efb4d49dd$var$allocUnsafe(arg);
    }
    return $92e7158efb4d49dd$var$from(arg, encodingOrOffset, length);
}
$92e7158efb4d49dd$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $92e7158efb4d49dd$var$from(value, encodingOrOffset, length) {
    if (typeof value === "string") return $92e7158efb4d49dd$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $92e7158efb4d49dd$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($92e7158efb4d49dd$var$isInstance(value, ArrayBuffer) || value && $92e7158efb4d49dd$var$isInstance(value.buffer, ArrayBuffer)) return $92e7158efb4d49dd$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== "undefined" && ($92e7158efb4d49dd$var$isInstance(value, SharedArrayBuffer) || value && $92e7158efb4d49dd$var$isInstance(value.buffer, SharedArrayBuffer))) return $92e7158efb4d49dd$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === "number") throw new TypeError('The "value" argument must not be of type number. Received type number');
    var valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $92e7158efb4d49dd$var$Buffer.from(valueOf, encodingOrOffset, length);
    var b = $92e7158efb4d49dd$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== "undefined" && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === "function") return $92e7158efb4d49dd$var$Buffer.from(value[Symbol.toPrimitive]("string"), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $92e7158efb4d49dd$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $92e7158efb4d49dd$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($92e7158efb4d49dd$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($92e7158efb4d49dd$var$Buffer, Uint8Array);
function $92e7158efb4d49dd$var$assertSize(size) {
    if (typeof size !== "number") throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $92e7158efb4d49dd$var$alloc(size, fill, encoding) {
    $92e7158efb4d49dd$var$assertSize(size);
    if (size <= 0) return $92e7158efb4d49dd$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === "string" ? $92e7158efb4d49dd$var$createBuffer(size).fill(fill, encoding) : $92e7158efb4d49dd$var$createBuffer(size).fill(fill);
    return $92e7158efb4d49dd$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $92e7158efb4d49dd$var$Buffer.alloc = function(size, fill, encoding) {
    return $92e7158efb4d49dd$var$alloc(size, fill, encoding);
};
function $92e7158efb4d49dd$var$allocUnsafe(size) {
    $92e7158efb4d49dd$var$assertSize(size);
    return $92e7158efb4d49dd$var$createBuffer(size < 0 ? 0 : $92e7158efb4d49dd$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $92e7158efb4d49dd$var$Buffer.allocUnsafe = function(size) {
    return $92e7158efb4d49dd$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $92e7158efb4d49dd$var$Buffer.allocUnsafeSlow = function(size) {
    return $92e7158efb4d49dd$var$allocUnsafe(size);
};
function $92e7158efb4d49dd$var$fromString(string, encoding) {
    if (typeof encoding !== "string" || encoding === "") encoding = "utf8";
    if (!$92e7158efb4d49dd$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
    var length = $92e7158efb4d49dd$var$byteLength(string, encoding) | 0;
    var buf = $92e7158efb4d49dd$var$createBuffer(length);
    var actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $92e7158efb4d49dd$var$fromArrayLike(array) {
    var length = array.length < 0 ? 0 : $92e7158efb4d49dd$var$checked(array.length) | 0;
    var buf = $92e7158efb4d49dd$var$createBuffer(length);
    for(var i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $92e7158efb4d49dd$var$fromArrayView(arrayView) {
    if ($92e7158efb4d49dd$var$isInstance(arrayView, Uint8Array)) {
        var copy = new Uint8Array(arrayView);
        return $92e7158efb4d49dd$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $92e7158efb4d49dd$var$fromArrayLike(arrayView);
}
function $92e7158efb4d49dd$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    var buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $92e7158efb4d49dd$var$Buffer.prototype);
    return buf;
}
function $92e7158efb4d49dd$var$fromObject(obj) {
    if ($92e7158efb4d49dd$var$Buffer.isBuffer(obj)) {
        var len = $92e7158efb4d49dd$var$checked(obj.length) | 0;
        var buf = $92e7158efb4d49dd$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== "number" || $92e7158efb4d49dd$var$numberIsNaN(obj.length)) return $92e7158efb4d49dd$var$createBuffer(0);
        return $92e7158efb4d49dd$var$fromArrayLike(obj);
    }
    if (obj.type === "Buffer" && Array.isArray(obj.data)) return $92e7158efb4d49dd$var$fromArrayLike(obj.data);
}
function $92e7158efb4d49dd$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $92e7158efb4d49dd$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $92e7158efb4d49dd$var$K_MAX_LENGTH.toString(16) + " bytes");
    return length | 0;
}
function $92e7158efb4d49dd$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $92e7158efb4d49dd$var$Buffer.alloc(+length);
}
$92e7158efb4d49dd$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $92e7158efb4d49dd$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$92e7158efb4d49dd$var$Buffer.compare = function compare(a, b) {
    if ($92e7158efb4d49dd$var$isInstance(a, Uint8Array)) a = $92e7158efb4d49dd$var$Buffer.from(a, a.offset, a.byteLength);
    if ($92e7158efb4d49dd$var$isInstance(b, Uint8Array)) b = $92e7158efb4d49dd$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$92e7158efb4d49dd$var$Buffer.isBuffer(a) || !$92e7158efb4d49dd$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    var x = a.length;
    var y = b.length;
    for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$92e7158efb4d49dd$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "latin1":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return true;
        default:
            return false;
    }
};
$92e7158efb4d49dd$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $92e7158efb4d49dd$var$Buffer.alloc(0);
    var i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    var buffer = $92e7158efb4d49dd$var$Buffer.allocUnsafe(length);
    var pos = 0;
    for(i = 0; i < list.length; ++i){
        var buf = list[i];
        if ($92e7158efb4d49dd$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) $92e7158efb4d49dd$var$Buffer.from(buf).copy(buffer, pos);
            else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$92e7158efb4d49dd$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $92e7158efb4d49dd$var$byteLength(string, encoding) {
    if ($92e7158efb4d49dd$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $92e7158efb4d49dd$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== "string") throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    var len = string.length;
    var mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    var loweredCase = false;
    for(;;)switch(encoding){
        case "ascii":
        case "latin1":
        case "binary":
            return len;
        case "utf8":
        case "utf-8":
            return $92e7158efb4d49dd$var$utf8ToBytes(string).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return len * 2;
        case "hex":
            return len >>> 1;
        case "base64":
            return $92e7158efb4d49dd$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $92e7158efb4d49dd$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
}
$92e7158efb4d49dd$var$Buffer.byteLength = $92e7158efb4d49dd$var$byteLength;
function $92e7158efb4d49dd$var$slowToString(encoding, start, end) {
    var loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return "";
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return "";
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return "";
    if (!encoding) encoding = "utf8";
    while(true)switch(encoding){
        case "hex":
            return $92e7158efb4d49dd$var$hexSlice(this, start, end);
        case "utf8":
        case "utf-8":
            return $92e7158efb4d49dd$var$utf8Slice(this, start, end);
        case "ascii":
            return $92e7158efb4d49dd$var$asciiSlice(this, start, end);
        case "latin1":
        case "binary":
            return $92e7158efb4d49dd$var$latin1Slice(this, start, end);
        case "base64":
            return $92e7158efb4d49dd$var$base64Slice(this, start, end);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $92e7158efb4d49dd$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = (encoding + "").toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$92e7158efb4d49dd$var$Buffer.prototype._isBuffer = true;
function $92e7158efb4d49dd$var$swap(b, n, m) {
    var i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$92e7158efb4d49dd$var$Buffer.prototype.swap16 = function swap16() {
    var len = this.length;
    if (len % 2 !== 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
    for(var i = 0; i < len; i += 2)$92e7158efb4d49dd$var$swap(this, i, i + 1);
    return this;
};
$92e7158efb4d49dd$var$Buffer.prototype.swap32 = function swap32() {
    var len = this.length;
    if (len % 4 !== 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
    for(var i = 0; i < len; i += 4){
        $92e7158efb4d49dd$var$swap(this, i, i + 3);
        $92e7158efb4d49dd$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$92e7158efb4d49dd$var$Buffer.prototype.swap64 = function swap64() {
    var len = this.length;
    if (len % 8 !== 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
    for(var i = 0; i < len; i += 8){
        $92e7158efb4d49dd$var$swap(this, i, i + 7);
        $92e7158efb4d49dd$var$swap(this, i + 1, i + 6);
        $92e7158efb4d49dd$var$swap(this, i + 2, i + 5);
        $92e7158efb4d49dd$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$92e7158efb4d49dd$var$Buffer.prototype.toString = function toString() {
    var length = this.length;
    if (length === 0) return "";
    if (arguments.length === 0) return $92e7158efb4d49dd$var$utf8Slice(this, 0, length);
    return $92e7158efb4d49dd$var$slowToString.apply(this, arguments);
};
$92e7158efb4d49dd$var$Buffer.prototype.toLocaleString = $92e7158efb4d49dd$var$Buffer.prototype.toString;
$92e7158efb4d49dd$var$Buffer.prototype.equals = function equals(b) {
    if (!$92e7158efb4d49dd$var$Buffer.isBuffer(b)) throw new TypeError("Argument must be a Buffer");
    if (this === b) return true;
    return $92e7158efb4d49dd$var$Buffer.compare(this, b) === 0;
};
$92e7158efb4d49dd$var$Buffer.prototype.inspect = function inspect() {
    var str = "";
    var max = $92e7158efb4d49dd$export$f99ded8fe4b79145;
    str = this.toString("hex", 0, max).replace(/(.{2})/g, "$1 ").trim();
    if (this.length > max) str += " ... ";
    return "<Buffer " + str + ">";
};
if ($92e7158efb4d49dd$var$customInspectSymbol) $92e7158efb4d49dd$var$Buffer.prototype[$92e7158efb4d49dd$var$customInspectSymbol] = $92e7158efb4d49dd$var$Buffer.prototype.inspect;
$92e7158efb4d49dd$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($92e7158efb4d49dd$var$isInstance(target, Uint8Array)) target = $92e7158efb4d49dd$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$92e7158efb4d49dd$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError("out of range index");
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    var x = thisEnd - thisStart;
    var y = end - start;
    var len = Math.min(x, y);
    var thisCopy = this.slice(thisStart, thisEnd);
    var targetCopy = target.slice(start, end);
    for(var i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $92e7158efb4d49dd$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === "string") {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($92e7158efb4d49dd$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === "string") val = $92e7158efb4d49dd$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($92e7158efb4d49dd$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $92e7158efb4d49dd$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === "number") {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === "function") {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $92e7158efb4d49dd$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError("val must be string, number or Buffer");
}
function $92e7158efb4d49dd$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    var indexSize = 1;
    var arrLength = arr.length;
    var valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === "ucs2" || encoding === "ucs-2" || encoding === "utf16le" || encoding === "utf-16le") {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    var i;
    if (dir) {
        var foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            var found = true;
            for(var j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$92e7158efb4d49dd$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$92e7158efb4d49dd$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $92e7158efb4d49dd$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$92e7158efb4d49dd$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $92e7158efb4d49dd$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $92e7158efb4d49dd$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    var remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    var strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    for(var i = 0; i < length; ++i){
        var parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($92e7158efb4d49dd$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $92e7158efb4d49dd$var$utf8Write(buf, string, offset, length) {
    return $92e7158efb4d49dd$var$blitBuffer($92e7158efb4d49dd$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $92e7158efb4d49dd$var$asciiWrite(buf, string, offset, length) {
    return $92e7158efb4d49dd$var$blitBuffer($92e7158efb4d49dd$var$asciiToBytes(string), buf, offset, length);
}
function $92e7158efb4d49dd$var$base64Write(buf, string, offset, length) {
    return $92e7158efb4d49dd$var$blitBuffer($92e7158efb4d49dd$var$base64ToBytes(string), buf, offset, length);
}
function $92e7158efb4d49dd$var$ucs2Write(buf, string, offset, length) {
    return $92e7158efb4d49dd$var$blitBuffer($92e7158efb4d49dd$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$92e7158efb4d49dd$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = "utf8";
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === "string") {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = "utf8";
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
    var remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError("Attempt to write outside buffer bounds");
    if (!encoding) encoding = "utf8";
    var loweredCase = false;
    for(;;)switch(encoding){
        case "hex":
            return $92e7158efb4d49dd$var$hexWrite(this, string, offset, length);
        case "utf8":
        case "utf-8":
            return $92e7158efb4d49dd$var$utf8Write(this, string, offset, length);
        case "ascii":
        case "latin1":
        case "binary":
            return $92e7158efb4d49dd$var$asciiWrite(this, string, offset, length);
        case "base64":
            // Warning: maxLength not taken into account in base64Write
            return $92e7158efb4d49dd$var$base64Write(this, string, offset, length);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $92e7158efb4d49dd$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
};
$92e7158efb4d49dd$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: "Buffer",
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $92e7158efb4d49dd$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $4nf3l.fromByteArray(buf);
    else return $4nf3l.fromByteArray(buf.slice(start, end));
}
function $92e7158efb4d49dd$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    var res = [];
    var i = start;
    while(i < end){
        var firstByte = buf[i];
        var codePoint = null;
        var bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            var secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $92e7158efb4d49dd$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var $92e7158efb4d49dd$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $92e7158efb4d49dd$var$decodeCodePointsArray(codePoints) {
    var len = codePoints.length;
    if (len <= $92e7158efb4d49dd$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    var res = "";
    var i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $92e7158efb4d49dd$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $92e7158efb4d49dd$var$asciiSlice(buf, start, end) {
    var ret = "";
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $92e7158efb4d49dd$var$latin1Slice(buf, start, end) {
    var ret = "";
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $92e7158efb4d49dd$var$hexSlice(buf, start, end) {
    var len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    var out = "";
    for(var i = start; i < end; ++i)out += $92e7158efb4d49dd$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $92e7158efb4d49dd$var$utf16leSlice(buf, start, end) {
    var bytes = buf.slice(start, end);
    var res = "";
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(var i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$92e7158efb4d49dd$var$Buffer.prototype.slice = function slice(start, end) {
    var len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    var newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $92e7158efb4d49dd$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $92e7158efb4d49dd$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError("offset is not uint");
    if (offset + ext > length) throw new RangeError("Trying to access beyond buffer length");
}
$92e7158efb4d49dd$var$Buffer.prototype.readUintLE = $92e7158efb4d49dd$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $92e7158efb4d49dd$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$92e7158efb4d49dd$var$Buffer.prototype.readUintBE = $92e7158efb4d49dd$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $92e7158efb4d49dd$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset + --byteLength];
    var mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$92e7158efb4d49dd$var$Buffer.prototype.readUint8 = $92e7158efb4d49dd$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $92e7158efb4d49dd$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$92e7158efb4d49dd$var$Buffer.prototype.readUint16LE = $92e7158efb4d49dd$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $92e7158efb4d49dd$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$92e7158efb4d49dd$var$Buffer.prototype.readUint16BE = $92e7158efb4d49dd$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $92e7158efb4d49dd$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$92e7158efb4d49dd$var$Buffer.prototype.readUint32LE = $92e7158efb4d49dd$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $92e7158efb4d49dd$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$92e7158efb4d49dd$var$Buffer.prototype.readUint32BE = $92e7158efb4d49dd$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $92e7158efb4d49dd$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$92e7158efb4d49dd$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $92e7158efb4d49dd$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$92e7158efb4d49dd$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $92e7158efb4d49dd$var$checkOffset(offset, byteLength, this.length);
    var i = byteLength;
    var mul = 1;
    var val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$92e7158efb4d49dd$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $92e7158efb4d49dd$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$92e7158efb4d49dd$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $92e7158efb4d49dd$var$checkOffset(offset, 2, this.length);
    var val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$92e7158efb4d49dd$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $92e7158efb4d49dd$var$checkOffset(offset, 2, this.length);
    var val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$92e7158efb4d49dd$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $92e7158efb4d49dd$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$92e7158efb4d49dd$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $92e7158efb4d49dd$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$92e7158efb4d49dd$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $92e7158efb4d49dd$var$checkOffset(offset, 4, this.length);
    return $iL6rd.read(this, offset, true, 23, 4);
};
$92e7158efb4d49dd$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $92e7158efb4d49dd$var$checkOffset(offset, 4, this.length);
    return $iL6rd.read(this, offset, false, 23, 4);
};
$92e7158efb4d49dd$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $92e7158efb4d49dd$var$checkOffset(offset, 8, this.length);
    return $iL6rd.read(this, offset, true, 52, 8);
};
$92e7158efb4d49dd$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $92e7158efb4d49dd$var$checkOffset(offset, 8, this.length);
    return $iL6rd.read(this, offset, false, 52, 8);
};
function $92e7158efb4d49dd$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$92e7158efb4d49dd$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
}
$92e7158efb4d49dd$var$Buffer.prototype.writeUintLE = $92e7158efb4d49dd$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $92e7158efb4d49dd$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var mul = 1;
    var i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$92e7158efb4d49dd$var$Buffer.prototype.writeUintBE = $92e7158efb4d49dd$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $92e7158efb4d49dd$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var i = byteLength - 1;
    var mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$92e7158efb4d49dd$var$Buffer.prototype.writeUint8 = $92e7158efb4d49dd$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $92e7158efb4d49dd$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$92e7158efb4d49dd$var$Buffer.prototype.writeUint16LE = $92e7158efb4d49dd$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $92e7158efb4d49dd$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$92e7158efb4d49dd$var$Buffer.prototype.writeUint16BE = $92e7158efb4d49dd$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $92e7158efb4d49dd$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$92e7158efb4d49dd$var$Buffer.prototype.writeUint32LE = $92e7158efb4d49dd$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $92e7158efb4d49dd$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$92e7158efb4d49dd$var$Buffer.prototype.writeUint32BE = $92e7158efb4d49dd$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $92e7158efb4d49dd$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$92e7158efb4d49dd$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $92e7158efb4d49dd$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = 0;
    var mul = 1;
    var sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$92e7158efb4d49dd$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $92e7158efb4d49dd$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = byteLength - 1;
    var mul = 1;
    var sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$92e7158efb4d49dd$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $92e7158efb4d49dd$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$92e7158efb4d49dd$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $92e7158efb4d49dd$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$92e7158efb4d49dd$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $92e7158efb4d49dd$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$92e7158efb4d49dd$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $92e7158efb4d49dd$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$92e7158efb4d49dd$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $92e7158efb4d49dd$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $92e7158efb4d49dd$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
    if (offset < 0) throw new RangeError("Index out of range");
}
function $92e7158efb4d49dd$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $92e7158efb4d49dd$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $iL6rd.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$92e7158efb4d49dd$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $92e7158efb4d49dd$var$writeFloat(this, value, offset, true, noAssert);
};
$92e7158efb4d49dd$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $92e7158efb4d49dd$var$writeFloat(this, value, offset, false, noAssert);
};
function $92e7158efb4d49dd$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $92e7158efb4d49dd$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $iL6rd.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$92e7158efb4d49dd$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $92e7158efb4d49dd$var$writeDouble(this, value, offset, true, noAssert);
};
$92e7158efb4d49dd$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $92e7158efb4d49dd$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$92e7158efb4d49dd$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$92e7158efb4d49dd$var$Buffer.isBuffer(target)) throw new TypeError("argument should be a Buffer");
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError("targetStart out of bounds");
    if (start < 0 || start >= this.length) throw new RangeError("Index out of range");
    if (end < 0) throw new RangeError("sourceEnd out of bounds");
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    var len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === "function") // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$92e7158efb4d49dd$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === "string") {
        if (typeof start === "string") {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === "string") {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== "string") throw new TypeError("encoding must be a string");
        if (typeof encoding === "string" && !$92e7158efb4d49dd$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
        if (val.length === 1) {
            var code = val.charCodeAt(0);
            if (encoding === "utf8" && code < 128 || encoding === "latin1") // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === "number") val = val & 255;
    else if (typeof val === "boolean") val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError("Out of range index");
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    var i;
    if (typeof val === "number") for(i = start; i < end; ++i)this[i] = val;
    else {
        var bytes = $92e7158efb4d49dd$var$Buffer.isBuffer(val) ? val : $92e7158efb4d49dd$var$Buffer.from(val, encoding);
        var len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// HELPER FUNCTIONS
// ================
var $92e7158efb4d49dd$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $92e7158efb4d49dd$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split("=")[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($92e7158efb4d49dd$var$INVALID_BASE64_RE, "");
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return "";
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + "=";
    return str;
}
function $92e7158efb4d49dd$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    var codePoint;
    var length = string.length;
    var leadSurrogate = null;
    var bytes = [];
    for(var i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error("Invalid code point");
    }
    return bytes;
}
function $92e7158efb4d49dd$var$asciiToBytes(str) {
    var byteArray = [];
    for(var i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $92e7158efb4d49dd$var$utf16leToBytes(str, units) {
    var c, hi, lo;
    var byteArray = [];
    for(var i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $92e7158efb4d49dd$var$base64ToBytes(str) {
    return $4nf3l.toByteArray($92e7158efb4d49dd$var$base64clean(str));
}
function $92e7158efb4d49dd$var$blitBuffer(src, dst, offset, length) {
    for(var i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $92e7158efb4d49dd$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $92e7158efb4d49dd$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
var $92e7158efb4d49dd$var$hexSliceLookupTable = function() {
    var alphabet = "0123456789abcdef";
    var table = new Array(256);
    for(var i = 0; i < 16; ++i){
        var i16 = i * 16;
        for(var j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();

});
parcelRequire.register("4nf3l", function(module, exports) {

$parcel$export(module.exports, "toByteArray", () => $32f4fca1571d79cf$export$d622b2ad8d90c771, (v) => $32f4fca1571d79cf$export$d622b2ad8d90c771 = v);
$parcel$export(module.exports, "fromByteArray", () => $32f4fca1571d79cf$export$6100ba28696e12de, (v) => $32f4fca1571d79cf$export$6100ba28696e12de = v);
var $32f4fca1571d79cf$export$a48f0734ac7c2329;
var $32f4fca1571d79cf$export$d622b2ad8d90c771;
var $32f4fca1571d79cf$export$6100ba28696e12de;
"use strict";
$32f4fca1571d79cf$export$a48f0734ac7c2329 = $32f4fca1571d79cf$var$byteLength;
$32f4fca1571d79cf$export$d622b2ad8d90c771 = $32f4fca1571d79cf$var$toByteArray;
$32f4fca1571d79cf$export$6100ba28696e12de = $32f4fca1571d79cf$var$fromByteArray;
var $32f4fca1571d79cf$var$lookup = [];
var $32f4fca1571d79cf$var$revLookup = [];
var $32f4fca1571d79cf$var$Arr = typeof Uint8Array !== "undefined" ? Uint8Array : Array;
var $32f4fca1571d79cf$var$code = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
for(var $32f4fca1571d79cf$var$i = 0, $32f4fca1571d79cf$var$len = $32f4fca1571d79cf$var$code.length; $32f4fca1571d79cf$var$i < $32f4fca1571d79cf$var$len; ++$32f4fca1571d79cf$var$i){
    $32f4fca1571d79cf$var$lookup[$32f4fca1571d79cf$var$i] = $32f4fca1571d79cf$var$code[$32f4fca1571d79cf$var$i];
    $32f4fca1571d79cf$var$revLookup[$32f4fca1571d79cf$var$code.charCodeAt($32f4fca1571d79cf$var$i)] = $32f4fca1571d79cf$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$32f4fca1571d79cf$var$revLookup["-".charCodeAt(0)] = 62;
$32f4fca1571d79cf$var$revLookup["_".charCodeAt(0)] = 63;
function $32f4fca1571d79cf$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf("=");
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $32f4fca1571d79cf$var$byteLength(b64) {
    var lens = $32f4fca1571d79cf$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $32f4fca1571d79cf$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $32f4fca1571d79cf$var$toByteArray(b64) {
    var tmp;
    var lens = $32f4fca1571d79cf$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $32f4fca1571d79cf$var$Arr($32f4fca1571d79cf$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $32f4fca1571d79cf$var$revLookup[b64.charCodeAt(i)] << 18 | $32f4fca1571d79cf$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $32f4fca1571d79cf$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $32f4fca1571d79cf$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $32f4fca1571d79cf$var$revLookup[b64.charCodeAt(i)] << 2 | $32f4fca1571d79cf$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $32f4fca1571d79cf$var$revLookup[b64.charCodeAt(i)] << 10 | $32f4fca1571d79cf$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $32f4fca1571d79cf$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $32f4fca1571d79cf$var$tripletToBase64(num) {
    return $32f4fca1571d79cf$var$lookup[num >> 18 & 0x3F] + $32f4fca1571d79cf$var$lookup[num >> 12 & 0x3F] + $32f4fca1571d79cf$var$lookup[num >> 6 & 0x3F] + $32f4fca1571d79cf$var$lookup[num & 0x3F];
}
function $32f4fca1571d79cf$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($32f4fca1571d79cf$var$tripletToBase64(tmp));
    }
    return output.join("");
}
function $32f4fca1571d79cf$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($32f4fca1571d79cf$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($32f4fca1571d79cf$var$lookup[tmp >> 2] + $32f4fca1571d79cf$var$lookup[tmp << 4 & 0x3F] + "==");
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($32f4fca1571d79cf$var$lookup[tmp >> 10] + $32f4fca1571d79cf$var$lookup[tmp >> 4 & 0x3F] + $32f4fca1571d79cf$var$lookup[tmp << 2 & 0x3F] + "=");
    }
    return parts.join("");
}

});

parcelRequire.register("iL6rd", function(module, exports) {

$parcel$export(module.exports, "read", () => $da819c3c1253403e$export$aafa59e2e03f2942, (v) => $da819c3c1253403e$export$aafa59e2e03f2942 = v);
$parcel$export(module.exports, "write", () => $da819c3c1253403e$export$68d8715fc104d294, (v) => $da819c3c1253403e$export$68d8715fc104d294 = v);
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $da819c3c1253403e$export$aafa59e2e03f2942;
var $da819c3c1253403e$export$68d8715fc104d294;
$da819c3c1253403e$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$da819c3c1253403e$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

});


parcelRequire.register("7PHxc", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
var $5b3f10d8eaf8ba70$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.AudioStreamFormatImpl = module.exports.AudioStreamFormat = module.exports.AudioFormatTag = void 0;
var $5b3f10d8eaf8ba70$var$AudioFormatTag;
(function(AudioFormatTag) {
    AudioFormatTag[AudioFormatTag["PCM"] = 1] = "PCM";
    AudioFormatTag[AudioFormatTag["MuLaw"] = 2] = "MuLaw";
    AudioFormatTag[AudioFormatTag["Siren"] = 3] = "Siren";
    AudioFormatTag[AudioFormatTag["MP3"] = 4] = "MP3";
    AudioFormatTag[AudioFormatTag["SILKSkype"] = 5] = "SILKSkype";
    AudioFormatTag[AudioFormatTag["OGG_OPUS"] = 6] = "OGG_OPUS";
    AudioFormatTag[AudioFormatTag["WEBM_OPUS"] = 7] = "WEBM_OPUS";
    AudioFormatTag[AudioFormatTag["ALaw"] = 8] = "ALaw";
})($5b3f10d8eaf8ba70$var$AudioFormatTag = module.exports.AudioFormatTag || (module.exports.AudioFormatTag = {}));
/**
 * Represents audio stream format used for custom audio input configurations.
 * @class AudioStreamFormat
 */ var $5b3f10d8eaf8ba70$var$AudioStreamFormat = /** @class */ function() {
    function AudioStreamFormat() {}
    /**
     * Creates an audio stream format object representing the default audio stream
     * format (16KHz 16bit mono PCM).
     * @member AudioStreamFormat.getDefaultInputFormat
     * @function
     * @public
     * @returns {AudioStreamFormat} The audio stream format being created.
     */ AudioStreamFormat.getDefaultInputFormat = function() {
        return $5b3f10d8eaf8ba70$var$AudioStreamFormatImpl.getDefaultInputFormat();
    };
    /**
     * Creates an audio stream format object with the specified pcm waveformat characteristics.
     * @member AudioStreamFormat.getWaveFormatPCM
     * @function
     * @public
     * @param {number} samplesPerSecond - Sample rate, in samples per second (Hertz).
     * @param {number} bitsPerSample - Bits per sample, typically 16.
     * @param {number} channels - Number of channels in the waveform-audio data. Monaural data
     *        uses one channel and stereo data uses two channels.
     * @returns {AudioStreamFormat} The audio stream format being created.
     */ AudioStreamFormat.getWaveFormatPCM = function(samplesPerSecond, bitsPerSample, channels) {
        return new $5b3f10d8eaf8ba70$var$AudioStreamFormatImpl(samplesPerSecond, bitsPerSample, channels);
    };
    return AudioStreamFormat;
}();
module.exports.AudioStreamFormat = $5b3f10d8eaf8ba70$var$AudioStreamFormat;
/**
 * @private
 * @class AudioStreamFormatImpl
 */ // tslint:disable-next-line:max-classes-per-file
var $5b3f10d8eaf8ba70$var$AudioStreamFormatImpl = /** @class */ function(_super) {
    $5b3f10d8eaf8ba70$var$__extends(AudioStreamFormatImpl, _super);
    /**
     * Creates an instance with the given values.
     * @constructor
     * @param {number} samplesPerSec - Samples per second.
     * @param {number} bitsPerSample - Bits per sample.
     * @param {number} channels - Number of channels.
     * @param {AudioFormatTag} format - Audio format (PCM, alaw or mulaw).
     */ function AudioStreamFormatImpl(samplesPerSec, bitsPerSample, channels, format) {
        if (samplesPerSec === void 0) samplesPerSec = 16000;
        if (bitsPerSample === void 0) bitsPerSample = 16;
        if (channels === void 0) channels = 1;
        if (format === void 0) format = $5b3f10d8eaf8ba70$var$AudioFormatTag.PCM;
        var _this = _super.call(this) || this;
        _this.setString = function(view, offset, str) {
            for(var i = 0; i < str.length; i++)view.setUint8(offset + i, str.charCodeAt(i));
        };
        /* 1 for PCM; 6 for alaw; 7 for mulaw */ switch(format){
            case $5b3f10d8eaf8ba70$var$AudioFormatTag.PCM:
                _this.formatTag = 1;
                break;
            case $5b3f10d8eaf8ba70$var$AudioFormatTag.ALaw:
                _this.formatTag = 6;
                break;
            case $5b3f10d8eaf8ba70$var$AudioFormatTag.MuLaw:
                _this.formatTag = 7;
                break;
            default:
        }
        _this.bitsPerSample = bitsPerSample;
        _this.samplesPerSec = samplesPerSec;
        _this.channels = channels;
        _this.avgBytesPerSec = _this.samplesPerSec * _this.channels * (_this.bitsPerSample / 8);
        _this.blockAlign = _this.channels * Math.max(_this.bitsPerSample, 8);
        _this.privHeader = new ArrayBuffer(44);
        // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DataView
        var view = new DataView(_this.privHeader);
        /* RIFF identifier */ _this.setString(view, 0, "RIFF");
        /* file length */ view.setUint32(4, 0, true);
        /* RIFF type & Format */ _this.setString(view, 8, "WAVEfmt ");
        /* format chunk length */ view.setUint32(16, 16, true);
        /* audio format */ view.setUint16(20, _this.formatTag, true);
        /* channel count */ view.setUint16(22, _this.channels, true);
        /* sample rate */ view.setUint32(24, _this.samplesPerSec, true);
        /* byte rate (sample rate * block align) */ view.setUint32(28, _this.avgBytesPerSec, true);
        /* block align (channel count * bytes per sample) */ view.setUint16(32, _this.channels * (_this.bitsPerSample / 8), true);
        /* bits per sample */ view.setUint16(34, _this.bitsPerSample, true);
        /* data chunk identifier */ _this.setString(view, 36, "data");
        /* data chunk length */ view.setUint32(40, 0, true);
        return _this;
    }
    /**
     * Retrieves the default input format.
     * @member AudioStreamFormatImpl.getDefaultInputFormat
     * @function
     * @public
     * @returns {AudioStreamFormatImpl} The default input format.
     */ AudioStreamFormatImpl.getDefaultInputFormat = function() {
        return new AudioStreamFormatImpl();
    };
    /**
     * Creates an audio context appropriate to current browser
     * @member AudioStreamFormatImpl.getAudioContext
     * @function
     * @public
     * @returns {AudioContext} An audio context instance
     */ AudioStreamFormatImpl.getAudioContext = function(sampleRate) {
        // Workaround for Speech SDK bug in Safari.
        var AudioContext = window.AudioContext // our preferred impl
         || window.webkitAudioContext // fallback, mostly when on Safari
         || false; // could not find.
        // https://developer.mozilla.org/en-US/docs/Web/API/AudioContext
        if (!!AudioContext) {
            if (sampleRate !== undefined && navigator.mediaDevices.getSupportedConstraints().sampleRate) return new AudioContext({
                sampleRate: sampleRate
            });
            else return new AudioContext();
        } else throw new Error("Browser does not support Web Audio API (AudioContext is not available).");
    };
    /**
     * Closes the configuration object.
     * @member AudioStreamFormatImpl.prototype.close
     * @function
     * @public
     */ AudioStreamFormatImpl.prototype.close = function() {
        return;
    };
    Object.defineProperty(AudioStreamFormatImpl.prototype, "header", {
        get: function() {
            return this.privHeader;
        },
        enumerable: false,
        configurable: true
    });
    return AudioStreamFormatImpl;
}($5b3f10d8eaf8ba70$var$AudioStreamFormat);
module.exports.AudioStreamFormatImpl = $5b3f10d8eaf8ba70$var$AudioStreamFormatImpl;

});


parcelRequire.register("epVjg", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
var $a7efdb06bda2702e$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $a7efdb06bda2702e$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $a7efdb06bda2702e$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PushAudioOutputStreamImpl = module.exports.PushAudioOutputStream = module.exports.PullAudioOutputStreamImpl = module.exports.PullAudioOutputStream = module.exports.AudioOutputStream = void 0;

var $7srwU = parcelRequire("7srwU");

var $evvAW = parcelRequire("evvAW");

var $gU3rQ = parcelRequire("gU3rQ");
/**
 * Represents audio output stream used for custom audio output configurations.
 * @class AudioOutputStream
 */ var $a7efdb06bda2702e$var$AudioOutputStream = /** @class */ function() {
    /**
     * Creates and initializes an instance.
     * @constructor
     */ function AudioOutputStream() {}
    /**
     * Creates a memory backed PullAudioOutputStream with the specified audio format.
     * @member AudioOutputStream.createPullStream
     * @function
     * @public
     * @returns {PullAudioOutputStream} The audio output stream being created.
     */ AudioOutputStream.createPullStream = function() {
        return $a7efdb06bda2702e$var$PullAudioOutputStream.create();
    };
    return AudioOutputStream;
}();
module.exports.AudioOutputStream = $a7efdb06bda2702e$var$AudioOutputStream;
/**
 * Represents memory backed push audio output stream used for custom audio output configurations.
 * @class PullAudioOutputStream
 */ var $a7efdb06bda2702e$var$PullAudioOutputStream = /** @class */ function(_super) {
    $a7efdb06bda2702e$var$__extends(PullAudioOutputStream, _super);
    function PullAudioOutputStream() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Creates a memory backed PullAudioOutputStream with the specified audio format.
     * @member PullAudioOutputStream.create
     * @function
     * @public
     * @returns {PullAudioOutputStream} The push audio output stream being created.
     */ PullAudioOutputStream.create = function() {
        return new $a7efdb06bda2702e$var$PullAudioOutputStreamImpl();
    };
    return PullAudioOutputStream;
}($a7efdb06bda2702e$var$AudioOutputStream);
module.exports.PullAudioOutputStream = $a7efdb06bda2702e$var$PullAudioOutputStream;
/**
 * Represents memory backed push audio output stream used for custom audio output configurations.
 * @private
 * @class PullAudioOutputStreamImpl
 */ var $a7efdb06bda2702e$var$PullAudioOutputStreamImpl = /** @class */ function(_super) {
    $a7efdb06bda2702e$var$__extends(PullAudioOutputStreamImpl, _super);
    /**
     * Creates and initializes an instance with the given values.
     * @constructor
     */ function PullAudioOutputStreamImpl() {
        var _this = _super.call(this) || this;
        _this.privId = $7srwU.createNoDashGuid();
        _this.privStream = new $7srwU.Stream();
        return _this;
    }
    Object.defineProperty(PullAudioOutputStreamImpl.prototype, "format", {
        /**
         * Format information for the audio
         */ get: function() {
            return this.privFormat;
        },
        /**
         * Sets the format information to the stream. For internal use only.
         * @param {AudioStreamFormat} format - the format to be set.
         */ set: function(format) {
            if (format === undefined || format === null) this.privFormat = $gU3rQ.AudioOutputFormatImpl.getDefaultOutputFormat();
            this.privFormat = format;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PullAudioOutputStreamImpl.prototype, "isClosed", {
        /**
         * Checks if the stream is closed
         * @member PullAudioOutputStreamImpl.prototype.isClosed
         * @property
         * @public
         */ get: function() {
            return this.privStream.isClosed;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Gets the id of the stream
     * @member PullAudioOutputStreamImpl.prototype.id
     * @property
     * @public
     */ PullAudioOutputStreamImpl.prototype.id = function() {
        return this.privId;
    };
    /**
     * Reads audio data from the internal buffer.
     * @member PullAudioOutputStreamImpl.prototype.read
     * @function
     * @public
     * @param {ArrayBuffer} dataBuffer - An ArrayBuffer to store the read data.
     * @returns {Promise<number>} - Audio buffer length has been read.
     */ PullAudioOutputStreamImpl.prototype.read = function(dataBuffer) {
        return $a7efdb06bda2702e$var$__awaiter(this, void 0, void 0, function() {
            var intView, totalBytes, chunk, tmpBuffer;
            return $a7efdb06bda2702e$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        intView = new Int8Array(dataBuffer);
                        totalBytes = 0;
                        if (this.privLastChunkView !== undefined) {
                            if (this.privLastChunkView.length > dataBuffer.byteLength) {
                                intView.set(this.privLastChunkView.slice(0, dataBuffer.byteLength));
                                this.privLastChunkView = this.privLastChunkView.slice(dataBuffer.byteLength);
                                return [
                                    2 /*return*/ ,
                                    Promise.resolve(dataBuffer.byteLength)
                                ];
                            }
                            intView.set(this.privLastChunkView);
                            totalBytes = this.privLastChunkView.length;
                            this.privLastChunkView = undefined;
                        }
                        _a.label = 1;
                    case 1:
                        if (!(totalBytes < dataBuffer.byteLength && !this.privStream.isReadEnded)) return [
                            3 /*break*/ ,
                            6
                        ];
                        return [
                            4 /*yield*/ ,
                            this.privStream.read()
                        ];
                    case 2:
                        chunk = _a.sent();
                        if (!(chunk !== undefined && !chunk.isEnd)) return [
                            3 /*break*/ ,
                            3
                        ];
                        tmpBuffer = void 0;
                        if (chunk.buffer.byteLength > dataBuffer.byteLength - totalBytes) {
                            tmpBuffer = chunk.buffer.slice(0, dataBuffer.byteLength - totalBytes);
                            this.privLastChunkView = new Int8Array(chunk.buffer.slice(dataBuffer.byteLength - totalBytes));
                        } else tmpBuffer = chunk.buffer;
                        intView.set(new Int8Array(tmpBuffer), totalBytes);
                        totalBytes += tmpBuffer.byteLength;
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 3:
                        return [
                            4 /*yield*/ ,
                            this.privStream.readEnded()
                        ];
                    case 4:
                        _a.sent();
                        _a.label = 5;
                    case 5:
                        return [
                            3 /*break*/ ,
                            1
                        ];
                    case 6:
                        return [
                            2 /*return*/ ,
                            totalBytes
                        ];
                }
            });
        });
    };
    /**
     * Writes the audio data specified by making an internal copy of the data.
     * @member PullAudioOutputStreamImpl.prototype.write
     * @function
     * @public
     * @param {ArrayBuffer} dataBuffer - The audio buffer of which this function will make a copy.
     */ PullAudioOutputStreamImpl.prototype.write = function(dataBuffer) {
        $evvAW.Contracts.throwIfNullOrUndefined(this.privStream, "must set format before writing");
        this.privStream.writeStreamChunk({
            buffer: dataBuffer,
            isEnd: false,
            timeReceived: Date.now()
        });
    };
    /**
     * Closes the stream.
     * @member PullAudioOutputStreamImpl.prototype.close
     * @function
     * @public
     */ PullAudioOutputStreamImpl.prototype.close = function() {
        this.privStream.close();
    };
    return PullAudioOutputStreamImpl;
}($a7efdb06bda2702e$var$PullAudioOutputStream);
module.exports.PullAudioOutputStreamImpl = $a7efdb06bda2702e$var$PullAudioOutputStreamImpl;
/*
 * Represents audio output stream used for custom audio output configurations.
 * @class PushAudioOutputStream
 */ var $a7efdb06bda2702e$var$PushAudioOutputStream = /** @class */ function(_super) {
    $a7efdb06bda2702e$var$__extends(PushAudioOutputStream, _super);
    /**
     * Creates and initializes and instance.
     * @constructor
     */ function PushAudioOutputStream() {
        return _super.call(this) || this;
    }
    /**
     * Creates a PushAudioOutputStream that delegates to the specified callback interface for
     * write() and close() methods.
     * @member PushAudioOutputStream.create
     * @function
     * @public
     * @param {PushAudioOutputStreamCallback} callback - The custom audio output object,
     *        derived from PushAudioOutputStreamCallback
     * @returns {PushAudioOutputStream} The push audio output stream being created.
     */ PushAudioOutputStream.create = function(callback) {
        return new $a7efdb06bda2702e$var$PushAudioOutputStreamImpl(callback);
    };
    return PushAudioOutputStream;
}($a7efdb06bda2702e$var$AudioOutputStream);
module.exports.PushAudioOutputStream = $a7efdb06bda2702e$var$PushAudioOutputStream;
/**
 * Represents audio output stream used for custom audio output configurations.
 * @private
 * @class PushAudioOutputStreamImpl
 */ var $a7efdb06bda2702e$var$PushAudioOutputStreamImpl = /** @class */ function(_super) {
    $a7efdb06bda2702e$var$__extends(PushAudioOutputStreamImpl, _super);
    /**
     * Creates a PushAudioOutputStream that delegates to the specified callback interface for
     * read() and close() methods.
     * @constructor
     * @param {PushAudioOutputStreamCallback} callback - The custom audio output object,
     *        derived from PushAudioOutputStreamCallback
     */ function PushAudioOutputStreamImpl(callback) {
        var _this = _super.call(this) || this;
        _this.privId = $7srwU.createNoDashGuid();
        _this.privCallback = callback;
        return _this;
    }
    Object.defineProperty(PushAudioOutputStreamImpl.prototype, "format", {
        // tslint:disable-next-line:no-empty
        set: function(format) {},
        enumerable: false,
        configurable: true
    });
    PushAudioOutputStreamImpl.prototype.write = function(buffer) {
        if (!!this.privCallback.write) this.privCallback.write(buffer);
    };
    PushAudioOutputStreamImpl.prototype.close = function() {
        if (!!this.privCallback.close) this.privCallback.close();
    };
    PushAudioOutputStreamImpl.prototype.id = function() {
        return this.privId;
    };
    return PushAudioOutputStreamImpl;
}($a7efdb06bda2702e$var$PushAudioOutputStream);
module.exports.PushAudioOutputStreamImpl = $a7efdb06bda2702e$var$PushAudioOutputStreamImpl;

});
parcelRequire.register("gU3rQ", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
var $c4e48d012f7925a2$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $c4e48d012f7925a2$var$_a;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.AudioOutputFormatImpl = void 0;

var $eYlAB = parcelRequire("eYlAB");

var $7PHxc = parcelRequire("7PHxc");
/**
 * @private
 * @class AudioOutputFormatImpl
 * Updated in version 1.17.0
 */ // tslint:disable-next-line:max-classes-per-file
var $c4e48d012f7925a2$var$AudioOutputFormatImpl = /** @class */ function(_super) {
    $c4e48d012f7925a2$var$__extends(AudioOutputFormatImpl, _super);
    /**
     * Creates an instance with the given values.
     * @constructor
     * @param formatTag
     * @param {number} channels - Number of channels.
     * @param {number} samplesPerSec - Samples per second.
     * @param {number} avgBytesPerSec - Average bytes per second.
     * @param {number} blockAlign - Block alignment.
     * @param {number} bitsPerSample - Bits per sample.
     * @param {string} audioFormatString - Audio format string
     * @param {string} requestAudioFormatString - Audio format string sent to service.
     * @param {boolean} hasHeader - If the format has header or not.
     */ function AudioOutputFormatImpl(formatTag, channels, samplesPerSec, avgBytesPerSec, blockAlign, bitsPerSample, audioFormatString, requestAudioFormatString, hasHeader) {
        var _this = _super.call(this, samplesPerSec, bitsPerSample, channels, formatTag) || this;
        _this.formatTag = formatTag;
        _this.avgBytesPerSec = avgBytesPerSec;
        _this.blockAlign = blockAlign;
        _this.priAudioFormatString = audioFormatString;
        _this.priRequestAudioFormatString = requestAudioFormatString;
        _this.priHasHeader = hasHeader;
        return _this;
    }
    AudioOutputFormatImpl.fromSpeechSynthesisOutputFormat = function(speechSynthesisOutputFormat) {
        if (speechSynthesisOutputFormat === undefined) return AudioOutputFormatImpl.getDefaultOutputFormat();
        return AudioOutputFormatImpl.fromSpeechSynthesisOutputFormatString(AudioOutputFormatImpl.SpeechSynthesisOutputFormatToString[speechSynthesisOutputFormat]);
    };
    AudioOutputFormatImpl.fromSpeechSynthesisOutputFormatString = function(speechSynthesisOutputFormatString) {
        switch(speechSynthesisOutputFormatString){
            case "raw-8khz-8bit-mono-mulaw":
                return new AudioOutputFormatImpl($7PHxc.AudioFormatTag.MuLaw, 1, 8000, 8000, 1, 8, speechSynthesisOutputFormatString, speechSynthesisOutputFormatString, false);
            case "riff-16khz-16kbps-mono-siren":
                return new AudioOutputFormatImpl($7PHxc.AudioFormatTag.Siren, 1, 16000, 2000, 40, 0, speechSynthesisOutputFormatString, "audio-16khz-16kbps-mono-siren", true);
            case "audio-16khz-16kbps-mono-siren":
                return new AudioOutputFormatImpl($7PHxc.AudioFormatTag.Siren, 1, 16000, 2000, 40, 0, speechSynthesisOutputFormatString, speechSynthesisOutputFormatString, false);
            case "audio-16khz-32kbitrate-mono-mp3":
                return new AudioOutputFormatImpl($7PHxc.AudioFormatTag.MP3, 1, 16000, 4096, 2, 16, speechSynthesisOutputFormatString, speechSynthesisOutputFormatString, false);
            case "audio-16khz-128kbitrate-mono-mp3":
                return new AudioOutputFormatImpl($7PHxc.AudioFormatTag.MP3, 1, 16000, 16384, 2, 16, speechSynthesisOutputFormatString, speechSynthesisOutputFormatString, false);
            case "audio-16khz-64kbitrate-mono-mp3":
                return new AudioOutputFormatImpl($7PHxc.AudioFormatTag.MP3, 1, 16000, 8192, 2, 16, speechSynthesisOutputFormatString, speechSynthesisOutputFormatString, false);
            case "audio-24khz-48kbitrate-mono-mp3":
                return new AudioOutputFormatImpl($7PHxc.AudioFormatTag.MP3, 1, 24000, 6144, 2, 16, speechSynthesisOutputFormatString, speechSynthesisOutputFormatString, false);
            case "audio-24khz-96kbitrate-mono-mp3":
                return new AudioOutputFormatImpl($7PHxc.AudioFormatTag.MP3, 1, 24000, 12288, 2, 16, speechSynthesisOutputFormatString, speechSynthesisOutputFormatString, false);
            case "audio-24khz-160kbitrate-mono-mp3":
                return new AudioOutputFormatImpl($7PHxc.AudioFormatTag.MP3, 1, 24000, 20480, 2, 16, speechSynthesisOutputFormatString, speechSynthesisOutputFormatString, false);
            case "raw-16khz-16bit-mono-truesilk":
                return new AudioOutputFormatImpl($7PHxc.AudioFormatTag.SILKSkype, 1, 16000, 32000, 2, 16, speechSynthesisOutputFormatString, speechSynthesisOutputFormatString, false);
            case "riff-8khz-16bit-mono-pcm":
                return new AudioOutputFormatImpl($7PHxc.AudioFormatTag.PCM, 1, 8000, 16000, 2, 16, speechSynthesisOutputFormatString, "raw-8khz-16bit-mono-pcm", true);
            case "riff-24khz-16bit-mono-pcm":
                return new AudioOutputFormatImpl($7PHxc.AudioFormatTag.PCM, 1, 24000, 48000, 2, 16, speechSynthesisOutputFormatString, "raw-24khz-16bit-mono-pcm", true);
            case "riff-8khz-8bit-mono-mulaw":
                return new AudioOutputFormatImpl($7PHxc.AudioFormatTag.MuLaw, 1, 8000, 8000, 1, 8, speechSynthesisOutputFormatString, "raw-8khz-8bit-mono-mulaw", true);
            case "raw-16khz-16bit-mono-pcm":
                return new AudioOutputFormatImpl($7PHxc.AudioFormatTag.PCM, 1, 16000, 32000, 2, 16, speechSynthesisOutputFormatString, "raw-16khz-16bit-mono-pcm", false);
            case "raw-24khz-16bit-mono-pcm":
                return new AudioOutputFormatImpl($7PHxc.AudioFormatTag.PCM, 1, 24000, 48000, 2, 16, speechSynthesisOutputFormatString, "raw-24khz-16bit-mono-pcm", false);
            case "raw-8khz-16bit-mono-pcm":
                return new AudioOutputFormatImpl($7PHxc.AudioFormatTag.PCM, 1, 8000, 16000, 2, 16, speechSynthesisOutputFormatString, "raw-8khz-16bit-mono-pcm", false);
            case "ogg-16khz-16bit-mono-opus":
                return new AudioOutputFormatImpl($7PHxc.AudioFormatTag.OGG_OPUS, 1, 16000, 8192, 2, 16, speechSynthesisOutputFormatString, speechSynthesisOutputFormatString, false);
            case "ogg-24khz-16bit-mono-opus":
                return new AudioOutputFormatImpl($7PHxc.AudioFormatTag.OGG_OPUS, 1, 24000, 8192, 2, 16, speechSynthesisOutputFormatString, speechSynthesisOutputFormatString, false);
            case "raw-48khz-16bit-mono-pcm":
                return new AudioOutputFormatImpl($7PHxc.AudioFormatTag.PCM, 1, 48000, 96000, 2, 16, speechSynthesisOutputFormatString, "raw-48khz-16bit-mono-pcm", false);
            case "riff-48khz-16bit-mono-pcm":
                return new AudioOutputFormatImpl($7PHxc.AudioFormatTag.PCM, 1, 48000, 96000, 2, 16, speechSynthesisOutputFormatString, "raw-48khz-16bit-mono-pcm", true);
            case "audio-48khz-96kbitrate-mono-mp3":
                return new AudioOutputFormatImpl($7PHxc.AudioFormatTag.MP3, 1, 48000, 12288, 2, 16, speechSynthesisOutputFormatString, speechSynthesisOutputFormatString, false);
            case "audio-48khz-192kbitrate-mono-mp3":
                return new AudioOutputFormatImpl($7PHxc.AudioFormatTag.MP3, 1, 48000, 24576, 2, 16, speechSynthesisOutputFormatString, speechSynthesisOutputFormatString, false);
            case "ogg-48khz-16bit-mono-opus":
                return new AudioOutputFormatImpl($7PHxc.AudioFormatTag.OGG_OPUS, 1, 48000, 12000, 2, 16, speechSynthesisOutputFormatString, speechSynthesisOutputFormatString, false);
            case "webm-16khz-16bit-mono-opus":
                return new AudioOutputFormatImpl($7PHxc.AudioFormatTag.WEBM_OPUS, 1, 16000, 8000, 2, 16, speechSynthesisOutputFormatString, speechSynthesisOutputFormatString, false);
            case "webm-24khz-16bit-mono-opus":
                return new AudioOutputFormatImpl($7PHxc.AudioFormatTag.WEBM_OPUS, 1, 24000, 8000, 2, 16, speechSynthesisOutputFormatString, speechSynthesisOutputFormatString, false);
            case "raw-24khz-16bit-mono-truesilk":
                return new AudioOutputFormatImpl($7PHxc.AudioFormatTag.SILKSkype, 1, 24000, 48000, 2, 16, speechSynthesisOutputFormatString, speechSynthesisOutputFormatString, false);
            case "raw-8khz-8bit-mono-alaw":
                return new AudioOutputFormatImpl($7PHxc.AudioFormatTag.ALaw, 1, 8000, 8000, 1, 8, speechSynthesisOutputFormatString, speechSynthesisOutputFormatString, false);
            case "riff-8khz-8bit-mono-alaw":
                return new AudioOutputFormatImpl($7PHxc.AudioFormatTag.ALaw, 1, 8000, 8000, 1, 8, speechSynthesisOutputFormatString, "raw-8khz-8bit-mono-alaw", true);
            case "riff-16khz-16bit-mono-pcm":
            default:
                return new AudioOutputFormatImpl($7PHxc.AudioFormatTag.PCM, 1, 16000, 32000, 2, 16, "riff-16khz-16bit-mono-pcm", "raw-16khz-16bit-mono-pcm", true);
        }
    };
    AudioOutputFormatImpl.getDefaultOutputFormat = function() {
        return AudioOutputFormatImpl.fromSpeechSynthesisOutputFormatString(typeof window !== "undefined" ? "audio-24khz-48kbitrate-mono-mp3" : "riff-16khz-16bit-mono-pcm");
    };
    Object.defineProperty(AudioOutputFormatImpl.prototype, "hasHeader", {
        /**
         * Specifies if this audio output format has a header
         * @boolean AudioOutputFormatImpl.prototype.hasHeader
         * @function
         * @public
         */ get: function() {
            return this.priHasHeader;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AudioOutputFormatImpl.prototype, "header", {
        /**
         * Specifies the header of this format
         * @ArrayBuffer AudioOutputFormatImpl.prototype.header
         * @function
         * @public
         */ get: function() {
            if (this.hasHeader) return this.privHeader;
            return undefined;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Updates the header based on the audio length
     * @member AudioOutputFormatImpl.updateHeader
     * @function
     * @public
     * @param {number} audioLength - the audio length
     */ AudioOutputFormatImpl.prototype.updateHeader = function(audioLength) {
        if (this.priHasHeader) {
            var view = new DataView(this.privHeader);
            view.setUint32(40, audioLength, true);
        }
    };
    Object.defineProperty(AudioOutputFormatImpl.prototype, "requestAudioFormatString", {
        /**
         * Specifies the audio format string to be sent to the service
         * @string AudioOutputFormatImpl.prototype.requestAudioFormatString
         * @function
         * @public
         */ get: function() {
            return this.priRequestAudioFormatString;
        },
        enumerable: false,
        configurable: true
    });
    AudioOutputFormatImpl.SpeechSynthesisOutputFormatToString = ($c4e48d012f7925a2$var$_a = {}, $c4e48d012f7925a2$var$_a[$eYlAB.SpeechSynthesisOutputFormat.Raw8Khz8BitMonoMULaw] = "raw-8khz-8bit-mono-mulaw", $c4e48d012f7925a2$var$_a[$eYlAB.SpeechSynthesisOutputFormat.Riff16Khz16KbpsMonoSiren] = "riff-16khz-16kbps-mono-siren", $c4e48d012f7925a2$var$_a[$eYlAB.SpeechSynthesisOutputFormat.Audio16Khz16KbpsMonoSiren] = "audio-16khz-16kbps-mono-siren", $c4e48d012f7925a2$var$_a[$eYlAB.SpeechSynthesisOutputFormat.Audio16Khz32KBitRateMonoMp3] = "audio-16khz-32kbitrate-mono-mp3", $c4e48d012f7925a2$var$_a[$eYlAB.SpeechSynthesisOutputFormat.Audio16Khz128KBitRateMonoMp3] = "audio-16khz-128kbitrate-mono-mp3", $c4e48d012f7925a2$var$_a[$eYlAB.SpeechSynthesisOutputFormat.Audio16Khz64KBitRateMonoMp3] = "audio-16khz-64kbitrate-mono-mp3", $c4e48d012f7925a2$var$_a[$eYlAB.SpeechSynthesisOutputFormat.Audio24Khz48KBitRateMonoMp3] = "audio-24khz-48kbitrate-mono-mp3", $c4e48d012f7925a2$var$_a[$eYlAB.SpeechSynthesisOutputFormat.Audio24Khz96KBitRateMonoMp3] = "audio-24khz-96kbitrate-mono-mp3", $c4e48d012f7925a2$var$_a[$eYlAB.SpeechSynthesisOutputFormat.Audio24Khz160KBitRateMonoMp3] = "audio-24khz-160kbitrate-mono-mp3", $c4e48d012f7925a2$var$_a[$eYlAB.SpeechSynthesisOutputFormat.Raw16Khz16BitMonoTrueSilk] = "raw-16khz-16bit-mono-truesilk", $c4e48d012f7925a2$var$_a[$eYlAB.SpeechSynthesisOutputFormat.Riff16Khz16BitMonoPcm] = "riff-16khz-16bit-mono-pcm", $c4e48d012f7925a2$var$_a[$eYlAB.SpeechSynthesisOutputFormat.Riff8Khz16BitMonoPcm] = "riff-8khz-16bit-mono-pcm", $c4e48d012f7925a2$var$_a[$eYlAB.SpeechSynthesisOutputFormat.Riff24Khz16BitMonoPcm] = "riff-24khz-16bit-mono-pcm", $c4e48d012f7925a2$var$_a[$eYlAB.SpeechSynthesisOutputFormat.Riff8Khz8BitMonoMULaw] = "riff-8khz-8bit-mono-mulaw", $c4e48d012f7925a2$var$_a[$eYlAB.SpeechSynthesisOutputFormat.Raw16Khz16BitMonoPcm] = "raw-16khz-16bit-mono-pcm", $c4e48d012f7925a2$var$_a[$eYlAB.SpeechSynthesisOutputFormat.Raw24Khz16BitMonoPcm] = "raw-24khz-16bit-mono-pcm", $c4e48d012f7925a2$var$_a[$eYlAB.SpeechSynthesisOutputFormat.Raw8Khz16BitMonoPcm] = "raw-8khz-16bit-mono-pcm", $c4e48d012f7925a2$var$_a[$eYlAB.SpeechSynthesisOutputFormat.Ogg16Khz16BitMonoOpus] = "ogg-16khz-16bit-mono-opus", $c4e48d012f7925a2$var$_a[$eYlAB.SpeechSynthesisOutputFormat.Ogg24Khz16BitMonoOpus] = "ogg-24khz-16bit-mono-opus", $c4e48d012f7925a2$var$_a[$eYlAB.SpeechSynthesisOutputFormat.Raw48Khz16BitMonoPcm] = "raw-48khz-16bit-mono-pcm", $c4e48d012f7925a2$var$_a[$eYlAB.SpeechSynthesisOutputFormat.Riff48Khz16BitMonoPcm] = "riff-48khz-16bit-mono-pcm", $c4e48d012f7925a2$var$_a[$eYlAB.SpeechSynthesisOutputFormat.Audio48Khz96KBitRateMonoMp3] = "audio-48khz-96kbitrate-mono-mp3", $c4e48d012f7925a2$var$_a[$eYlAB.SpeechSynthesisOutputFormat.Audio48Khz192KBitRateMonoMp3] = "audio-48khz-192kbitrate-mono-mp3", $c4e48d012f7925a2$var$_a[$eYlAB.SpeechSynthesisOutputFormat.Ogg48Khz16BitMonoOpus] = "ogg-48khz-16bit-mono-opus", $c4e48d012f7925a2$var$_a[$eYlAB.SpeechSynthesisOutputFormat.Webm16Khz16BitMonoOpus] = "webm-16khz-16bit-mono-opus", $c4e48d012f7925a2$var$_a[$eYlAB.SpeechSynthesisOutputFormat.Webm24Khz16BitMonoOpus] = "webm-24khz-16bit-mono-opus", $c4e48d012f7925a2$var$_a[$eYlAB.SpeechSynthesisOutputFormat.Raw24Khz16BitMonoTrueSilk] = "raw-24khz-16bit-mono-truesilk", $c4e48d012f7925a2$var$_a[$eYlAB.SpeechSynthesisOutputFormat.Raw8Khz8BitMonoALaw] = "raw-8khz-8bit-mono-alaw", $c4e48d012f7925a2$var$_a[$eYlAB.SpeechSynthesisOutputFormat.Riff8Khz8BitMonoALaw] = "riff-8khz-8bit-mono-alaw", $c4e48d012f7925a2$var$_a);
    return AudioOutputFormatImpl;
}($7PHxc.AudioStreamFormatImpl);
module.exports.AudioOutputFormatImpl = $c4e48d012f7925a2$var$AudioOutputFormatImpl;

});
parcelRequire.register("eYlAB", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SpeechSynthesisOutputFormat = void 0;
/**
 * Define speech synthesis audio output formats.
 * @enum SpeechSynthesisOutputFormat
 * Updated in version 1.17.0
 */ var $ae676a7566fbdf2a$var$SpeechSynthesisOutputFormat;
(function(SpeechSynthesisOutputFormat) {
    /**
     * raw-8khz-8bit-mono-mulaw
     * @member SpeechSynthesisOutputFormat.Raw8Khz8BitMonoMULaw,
     */ SpeechSynthesisOutputFormat[SpeechSynthesisOutputFormat["Raw8Khz8BitMonoMULaw"] = 0] = "Raw8Khz8BitMonoMULaw";
    /**
     * riff-16khz-16kbps-mono-siren
     * @note Unsupported by the service. Do not use this value.
     * @member SpeechSynthesisOutputFormat.Riff16Khz16KbpsMonoSiren
     */ SpeechSynthesisOutputFormat[SpeechSynthesisOutputFormat["Riff16Khz16KbpsMonoSiren"] = 1] = "Riff16Khz16KbpsMonoSiren";
    /**
     * audio-16khz-16kbps-mono-siren
     * @note Unsupported by the service. Do not use this value.
     * @member SpeechSynthesisOutputFormat.Audio16Khz16KbpsMonoSiren
     */ SpeechSynthesisOutputFormat[SpeechSynthesisOutputFormat["Audio16Khz16KbpsMonoSiren"] = 2] = "Audio16Khz16KbpsMonoSiren";
    /**
     * audio-16khz-32kbitrate-mono-mp3
     * @member SpeechSynthesisOutputFormat.Audio16Khz32KBitRateMonoMp3
     */ SpeechSynthesisOutputFormat[SpeechSynthesisOutputFormat["Audio16Khz32KBitRateMonoMp3"] = 3] = "Audio16Khz32KBitRateMonoMp3";
    /**
     * audio-16khz-128kbitrate-mono-mp3
     * @member SpeechSynthesisOutputFormat.Audio16Khz128KBitRateMonoMp3
     */ SpeechSynthesisOutputFormat[SpeechSynthesisOutputFormat["Audio16Khz128KBitRateMonoMp3"] = 4] = "Audio16Khz128KBitRateMonoMp3";
    /**
     * audio-16khz-64kbitrate-mono-mp3
     * @member SpeechSynthesisOutputFormat.Audio16Khz64KBitRateMonoMp3
     */ SpeechSynthesisOutputFormat[SpeechSynthesisOutputFormat["Audio16Khz64KBitRateMonoMp3"] = 5] = "Audio16Khz64KBitRateMonoMp3";
    /**
     * audio-24khz-48kbitrate-mono-mp3
     * @member SpeechSynthesisOutputFormat.Audio24Khz48KBitRateMonoMp3
     */ SpeechSynthesisOutputFormat[SpeechSynthesisOutputFormat["Audio24Khz48KBitRateMonoMp3"] = 6] = "Audio24Khz48KBitRateMonoMp3";
    /**
     * audio-24khz-96kbitrate-mono-mp3
     * @member SpeechSynthesisOutputFormat.Audio24Khz96KBitRateMonoMp3
     */ SpeechSynthesisOutputFormat[SpeechSynthesisOutputFormat["Audio24Khz96KBitRateMonoMp3"] = 7] = "Audio24Khz96KBitRateMonoMp3";
    /**
     * audio-24khz-160kbitrate-mono-mp3
     * @member SpeechSynthesisOutputFormat.Audio24Khz160KBitRateMonoMp3
     */ SpeechSynthesisOutputFormat[SpeechSynthesisOutputFormat["Audio24Khz160KBitRateMonoMp3"] = 8] = "Audio24Khz160KBitRateMonoMp3";
    /**
     * raw-16khz-16bit-mono-truesilk
     * @member SpeechSynthesisOutputFormat.Raw16Khz16BitMonoTrueSilk
     */ SpeechSynthesisOutputFormat[SpeechSynthesisOutputFormat["Raw16Khz16BitMonoTrueSilk"] = 9] = "Raw16Khz16BitMonoTrueSilk";
    /**
     * riff-16khz-16bit-mono-pcm
     * @member SpeechSynthesisOutputFormat.Riff16Khz16BitMonoPcm
     */ SpeechSynthesisOutputFormat[SpeechSynthesisOutputFormat["Riff16Khz16BitMonoPcm"] = 10] = "Riff16Khz16BitMonoPcm";
    /**
     * riff-8khz-16bit-mono-pcm
     * @member SpeechSynthesisOutputFormat.Riff8Khz16BitMonoPcm
     */ SpeechSynthesisOutputFormat[SpeechSynthesisOutputFormat["Riff8Khz16BitMonoPcm"] = 11] = "Riff8Khz16BitMonoPcm";
    /**
     * riff-24khz-16bit-mono-pcm
     * @member SpeechSynthesisOutputFormat.Riff24Khz16BitMonoPcm
     */ SpeechSynthesisOutputFormat[SpeechSynthesisOutputFormat["Riff24Khz16BitMonoPcm"] = 12] = "Riff24Khz16BitMonoPcm";
    /**
     * riff-8khz-8bit-mono-mulaw
     * @member SpeechSynthesisOutputFormat.Riff8Khz8BitMonoMULaw
     */ SpeechSynthesisOutputFormat[SpeechSynthesisOutputFormat["Riff8Khz8BitMonoMULaw"] = 13] = "Riff8Khz8BitMonoMULaw";
    /**
     * raw-16khz-16bit-mono-pcm
     * @member SpeechSynthesisOutputFormat.Raw16Khz16BitMonoPcm
     */ SpeechSynthesisOutputFormat[SpeechSynthesisOutputFormat["Raw16Khz16BitMonoPcm"] = 14] = "Raw16Khz16BitMonoPcm";
    /**
     * raw-24khz-16bit-mono-pcm
     * @member SpeechSynthesisOutputFormat.Raw24Khz16BitMonoPcm
     */ SpeechSynthesisOutputFormat[SpeechSynthesisOutputFormat["Raw24Khz16BitMonoPcm"] = 15] = "Raw24Khz16BitMonoPcm";
    /**
     * raw-8khz-16bit-mono-pcm
     * @member SpeechSynthesisOutputFormat.Raw8Khz16BitMonoPcm
     */ SpeechSynthesisOutputFormat[SpeechSynthesisOutputFormat["Raw8Khz16BitMonoPcm"] = 16] = "Raw8Khz16BitMonoPcm";
    /**
     * ogg-16khz-16bit-mono-opus
     * @member SpeechSynthesisOutputFormat.Ogg16Khz16BitMonoOpus
     */ SpeechSynthesisOutputFormat[SpeechSynthesisOutputFormat["Ogg16Khz16BitMonoOpus"] = 17] = "Ogg16Khz16BitMonoOpus";
    /**
     * ogg-24khz-16bit-mono-opus
     * @member SpeechSynthesisOutputFormat.Ogg24Khz16BitMonoOpus
     */ SpeechSynthesisOutputFormat[SpeechSynthesisOutputFormat["Ogg24Khz16BitMonoOpus"] = 18] = "Ogg24Khz16BitMonoOpus";
    /**
     * raw-48khz-16bit-mono-pcm
     * @member SpeechSynthesisOutputFormat.Raw48Khz16BitMonoPcm
     */ SpeechSynthesisOutputFormat[SpeechSynthesisOutputFormat["Raw48Khz16BitMonoPcm"] = 19] = "Raw48Khz16BitMonoPcm";
    /**
     * riff-48khz-16bit-mono-pcm
     * @member SpeechSynthesisOutputFormat.Riff48Khz16BitMonoPcm
     */ SpeechSynthesisOutputFormat[SpeechSynthesisOutputFormat["Riff48Khz16BitMonoPcm"] = 20] = "Riff48Khz16BitMonoPcm";
    /**
     * audio-48khz-96kbitrate-mono-mp3
     * @member SpeechSynthesisOutputFormat.Audio48Khz96KBitRateMonoMp3
     */ SpeechSynthesisOutputFormat[SpeechSynthesisOutputFormat["Audio48Khz96KBitRateMonoMp3"] = 21] = "Audio48Khz96KBitRateMonoMp3";
    /**
     * audio-48khz-192kbitrate-mono-mp3
     * @member SpeechSynthesisOutputFormat.Audio48Khz192KBitRateMonoMp3
     */ SpeechSynthesisOutputFormat[SpeechSynthesisOutputFormat["Audio48Khz192KBitRateMonoMp3"] = 22] = "Audio48Khz192KBitRateMonoMp3";
    /**
     * ogg-48khz-16bit-mono-opus
     * Added in version 1.16.0
     * @member SpeechSynthesisOutputFormat.Ogg48Khz16BitMonoOpus
     */ SpeechSynthesisOutputFormat[SpeechSynthesisOutputFormat["Ogg48Khz16BitMonoOpus"] = 23] = "Ogg48Khz16BitMonoOpus";
    /**
     * webm-16khz-16bit-mono-opus
     * Added in version 1.16.0
     * @member SpeechSynthesisOutputFormat.Webm16Khz16BitMonoOpus
     */ SpeechSynthesisOutputFormat[SpeechSynthesisOutputFormat["Webm16Khz16BitMonoOpus"] = 24] = "Webm16Khz16BitMonoOpus";
    /**
     * webm-24khz-16bit-mono-opus
     * Added in version 1.16.0
     * @member SpeechSynthesisOutputFormat.Webm24Khz16BitMonoOpus
     */ SpeechSynthesisOutputFormat[SpeechSynthesisOutputFormat["Webm24Khz16BitMonoOpus"] = 25] = "Webm24Khz16BitMonoOpus";
    /**
     * raw-24khz-16bit-mono-truesilk
     * Added in version 1.17.0
     * @member SpeechSynthesisOutputFormat.Raw24Khz16BitMonoTrueSilk
     */ SpeechSynthesisOutputFormat[SpeechSynthesisOutputFormat["Raw24Khz16BitMonoTrueSilk"] = 26] = "Raw24Khz16BitMonoTrueSilk";
    /**
     * raw-8khz-8bit-mono-alaw
     * Added in version 1.17.0
     * @member SpeechSynthesisOutputFormat.Raw8Khz8BitMonoALaw
     */ SpeechSynthesisOutputFormat[SpeechSynthesisOutputFormat["Raw8Khz8BitMonoALaw"] = 27] = "Raw8Khz8BitMonoALaw";
    /**
     * riff-8khz-8bit-mono-alaw
     * Added in version 1.17.0
     * @member SpeechSynthesisOutputFormat.Riff8Khz8BitMonoALaw
     */ SpeechSynthesisOutputFormat[SpeechSynthesisOutputFormat["Riff8Khz8BitMonoALaw"] = 28] = "Riff8Khz8BitMonoALaw";
})($ae676a7566fbdf2a$var$SpeechSynthesisOutputFormat = module.exports.SpeechSynthesisOutputFormat || (module.exports.SpeechSynthesisOutputFormat = {}));

});




parcelRequire.register("hVeWA", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CancellationReason = void 0;
/**
 * Defines the possible reasons a recognition result might be canceled.
 * @class CancellationReason
 */ var $d0c35a1919576062$var$CancellationReason;
(function(CancellationReason) {
    /**
     * Indicates that an error occurred during speech recognition.
     * @member CancellationReason.Error
     */ CancellationReason[CancellationReason["Error"] = 0] = "Error";
    /**
     * Indicates that the end of the audio stream was reached.
     * @member CancellationReason.EndOfStream
     */ CancellationReason[CancellationReason["EndOfStream"] = 1] = "EndOfStream";
})($d0c35a1919576062$var$CancellationReason = module.exports.CancellationReason || (module.exports.CancellationReason = {}));

});

parcelRequire.register("5RVXf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PullAudioInputStreamCallback = void 0;
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
/**
 * An abstract base class that defines callback methods (read() and close()) for
 * custom audio input streams).
 * @class PullAudioInputStreamCallback
 */ var $445edb8fa888fdc7$var$PullAudioInputStreamCallback = /** @class */ function() {
    function PullAudioInputStreamCallback() {}
    return PullAudioInputStreamCallback;
}();
module.exports.PullAudioInputStreamCallback = $445edb8fa888fdc7$var$PullAudioInputStreamCallback;

});

parcelRequire.register("7qKBh", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PushAudioOutputStreamCallback = void 0;
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
/**
 * An abstract base class that defines callback methods (write() and close()) for
 * custom audio output streams).
 * @class PushAudioOutputStreamCallback
 */ var $568f1bf197f268fe$var$PushAudioOutputStreamCallback = /** @class */ function() {
    function PushAudioOutputStreamCallback() {}
    return PushAudioOutputStreamCallback;
}();
module.exports.PushAudioOutputStreamCallback = $568f1bf197f268fe$var$PushAudioOutputStreamCallback;

});

parcelRequire.register("78X2i", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.KeywordRecognitionModel = void 0;

var $evvAW = parcelRequire("evvAW");
/**
 * Represents a keyword recognition model for recognizing when
 * the user says a keyword to initiate further speech recognition.
 * @class KeywordRecognitionModel
 */ var $53371315c591df1a$var$KeywordRecognitionModel = /** @class */ function() {
    /**
     * Create and initializes a new instance.
     * @constructor
     */ function KeywordRecognitionModel() {
        this.privDisposed = false;
    }
    /**
     * Creates a keyword recognition model using the specified filename.
     * @member KeywordRecognitionModel.fromFile
     * @function
     * @public
     * @param {string} fileName - A string that represents file name for the keyword recognition model.
     *        Note, the file can point to a zip file in which case the model
     *        will be extracted from the zip.
     * @returns {KeywordRecognitionModel} The keyword recognition model being created.
     */ KeywordRecognitionModel.fromFile = function(fileName) {
        $evvAW.Contracts.throwIfFileDoesNotExist(fileName, "fileName");
        throw new Error("Not yet implemented.");
    };
    /**
     * Creates a keyword recognition model using the specified filename.
     * @member KeywordRecognitionModel.fromStream
     * @function
     * @public
     * @param {string} file - A File that represents file for the keyword recognition model.
     *        Note, the file can point to a zip file in which case the model will be extracted from the zip.
     * @returns {KeywordRecognitionModel} The keyword recognition model being created.
     */ KeywordRecognitionModel.fromStream = function(file) {
        $evvAW.Contracts.throwIfNull(file, "file");
        throw new Error("Not yet implemented.");
    };
    /**
     * Dispose of associated resources.
     * @member KeywordRecognitionModel.prototype.close
     * @function
     * @public
     */ KeywordRecognitionModel.prototype.close = function() {
        if (this.privDisposed) return;
        this.privDisposed = true;
    };
    return KeywordRecognitionModel;
}();
module.exports.KeywordRecognitionModel = $53371315c591df1a$var$KeywordRecognitionModel;

});

parcelRequire.register("4iaAu", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SessionEventArgs = void 0;
/**
 * Defines content for session events like SessionStarted/Stopped, SoundStarted/Stopped.
 * @class SessionEventArgs
 */ var $32010e4f581dce0d$var$SessionEventArgs = /** @class */ function() {
    /**
     * Creates and initializes an instance of this class.
     * @constructor
     * @param {string} sessionId - The session id.
     */ function SessionEventArgs(sessionId) {
        this.privSessionId = sessionId;
    }
    Object.defineProperty(SessionEventArgs.prototype, "sessionId", {
        /**
         * Represents the session identifier.
         * @member SessionEventArgs.prototype.sessionId
         * @function
         * @public
         * @returns {string} Represents the session identifier.
         */ get: function() {
            return this.privSessionId;
        },
        enumerable: false,
        configurable: true
    });
    return SessionEventArgs;
}();
module.exports.SessionEventArgs = $32010e4f581dce0d$var$SessionEventArgs;

});

parcelRequire.register("k5cHF", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
var $e9ee20e136e698dc$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RecognitionEventArgs = void 0;

var $iQDnw = parcelRequire("iQDnw");
/**
 * Defines payload for session events like Speech Start/End Detected
 * @class
 */ var $e9ee20e136e698dc$var$RecognitionEventArgs = /** @class */ function(_super) {
    $e9ee20e136e698dc$var$__extends(RecognitionEventArgs, _super);
    /**
     * Creates and initializes an instance of this class.
     * @constructor
     * @param {number} offset - The offset.
     * @param {string} sessionId - The session id.
     */ function RecognitionEventArgs(offset, sessionId) {
        var _this = _super.call(this, sessionId) || this;
        _this.privOffset = offset;
        return _this;
    }
    Object.defineProperty(RecognitionEventArgs.prototype, "offset", {
        /**
         * Represents the message offset
         * @member RecognitionEventArgs.prototype.offset
         * @function
         * @public
         */ get: function() {
            return this.privOffset;
        },
        enumerable: false,
        configurable: true
    });
    return RecognitionEventArgs;
}($iQDnw.SessionEventArgs);
module.exports.RecognitionEventArgs = $e9ee20e136e698dc$var$RecognitionEventArgs;

});

parcelRequire.register("ekTR9", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.OutputFormat = void 0;
/**
 * Define Speech Recognizer output formats.
 * @class OutputFormat
 */ var $02b18534f3897f27$var$OutputFormat;
(function(OutputFormat) {
    /**
     * @member OutputFormat.Simple
     */ OutputFormat[OutputFormat["Simple"] = 0] = "Simple";
    /**
     * @member OutputFormat.Detailed
     */ OutputFormat[OutputFormat["Detailed"] = 1] = "Detailed";
})($02b18534f3897f27$var$OutputFormat = module.exports.OutputFormat || (module.exports.OutputFormat = {}));

});

parcelRequire.register("jJ0y0", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
var $e5c2a4fea9e75339$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.IntentRecognitionEventArgs = void 0;

var $iQDnw = parcelRequire("iQDnw");
/**
 * Intent recognition result event arguments.
 * @class
 */ var $e5c2a4fea9e75339$var$IntentRecognitionEventArgs = /** @class */ function(_super) {
    $e5c2a4fea9e75339$var$__extends(IntentRecognitionEventArgs, _super);
    /**
     * Creates and initializes an instance of this class.
     * @constructor
     * @param result - The result of the intent recognition.
     * @param offset - The offset.
     * @param sessionId - The session id.
     */ function IntentRecognitionEventArgs(result, offset, sessionId) {
        var _this = _super.call(this, offset, sessionId) || this;
        _this.privResult = result;
        return _this;
    }
    Object.defineProperty(IntentRecognitionEventArgs.prototype, "result", {
        /**
         * Represents the intent recognition result.
         * @member IntentRecognitionEventArgs.prototype.result
         * @function
         * @public
         * @returns {IntentRecognitionResult} Represents the intent recognition result.
         */ get: function() {
            return this.privResult;
        },
        enumerable: false,
        configurable: true
    });
    return IntentRecognitionEventArgs;
}($iQDnw.RecognitionEventArgs);
module.exports.IntentRecognitionEventArgs = $e5c2a4fea9e75339$var$IntentRecognitionEventArgs;

});

parcelRequire.register("gvAKQ", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RecognitionResult = void 0;
/**
 * Defines result of speech recognition.
 * @class RecognitionResult
 */ var $c04c0d448bfaa1ab$var$RecognitionResult = /** @class */ function() {
    /**
     * Creates and initializes an instance of this class.
     * @constructor
     * @param {string} resultId - The result id.
     * @param {ResultReason} reason - The reason.
     * @param {string} text - The recognized text.
     * @param {number} duration - The duration.
     * @param {number} offset - The offset into the stream.
     * @param {string} language - Primary Language detected, if provided.
     * @param {string} languageDetectionConfidence - Primary Language confidence ("Unknown," "Low," "Medium," "High"...), if provided.
     * @param {string} errorDetails - Error details, if provided.
     * @param {string} json - Additional Json, if provided.
     * @param {PropertyCollection} properties - Additional properties, if provided.
     */ function RecognitionResult(resultId, reason, text, duration, offset, language, languageDetectionConfidence, errorDetails, json, properties) {
        this.privResultId = resultId;
        this.privReason = reason;
        this.privText = text;
        this.privDuration = duration;
        this.privOffset = offset;
        this.privLanguage = language;
        this.privLanguageDetectionConfidence = languageDetectionConfidence;
        this.privErrorDetails = errorDetails;
        this.privJson = json;
        this.privProperties = properties;
    }
    Object.defineProperty(RecognitionResult.prototype, "resultId", {
        /**
         * Specifies the result identifier.
         * @member RecognitionResult.prototype.resultId
         * @function
         * @public
         * @returns {string} Specifies the result identifier.
         */ get: function() {
            return this.privResultId;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(RecognitionResult.prototype, "reason", {
        /**
         * Specifies status of the result.
         * @member RecognitionResult.prototype.reason
         * @function
         * @public
         * @returns {ResultReason} Specifies status of the result.
         */ get: function() {
            return this.privReason;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(RecognitionResult.prototype, "text", {
        /**
         * Presents the recognized text in the result.
         * @member RecognitionResult.prototype.text
         * @function
         * @public
         * @returns {string} Presents the recognized text in the result.
         */ get: function() {
            return this.privText;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(RecognitionResult.prototype, "duration", {
        /**
         * Duration of recognized speech in 100 nano second incements.
         * @member RecognitionResult.prototype.duration
         * @function
         * @public
         * @returns {number} Duration of recognized speech in 100 nano second incements.
         */ get: function() {
            return this.privDuration;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(RecognitionResult.prototype, "offset", {
        /**
         * Offset of recognized speech in 100 nano second incements.
         * @member RecognitionResult.prototype.offset
         * @function
         * @public
         * @returns {number} Offset of recognized speech in 100 nano second incements.
         */ get: function() {
            return this.privOffset;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(RecognitionResult.prototype, "language", {
        /**
         * Primary Language detected.
         * @member RecognitionResult.prototype.language
         * @function
         * @public
         * @returns {string} language detected.
         */ get: function() {
            return this.privLanguage;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(RecognitionResult.prototype, "languageDetectionConfidence", {
        /**
         * Primary Language detection confidence (Unknown, Low, Medium, High).
         * @member RecognitionResult.prototype.languageDetectionConfidence
         * @function
         * @public
         * @returns {string} detection confidence strength.
         */ get: function() {
            return this.privLanguageDetectionConfidence;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(RecognitionResult.prototype, "errorDetails", {
        /**
         * In case of an unsuccessful recognition, provides details of the occurred error.
         * @member RecognitionResult.prototype.errorDetails
         * @function
         * @public
         * @returns {string} a brief description of an error.
         */ get: function() {
            return this.privErrorDetails;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(RecognitionResult.prototype, "json", {
        /**
         * A string containing Json serialized recognition result as it was received from the service.
         * @member RecognitionResult.prototype.json
         * @function
         * @private
         * @returns {string} Json serialized representation of the result.
         */ get: function() {
            return this.privJson;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(RecognitionResult.prototype, "properties", {
        /**
         *  The set of properties exposed in the result.
         * @member RecognitionResult.prototype.properties
         * @function
         * @public
         * @returns {PropertyCollection} The set of properties exposed in the result.
         */ get: function() {
            return this.privProperties;
        },
        enumerable: false,
        configurable: true
    });
    return RecognitionResult;
}();
module.exports.RecognitionResult = $c04c0d448bfaa1ab$var$RecognitionResult;

});

parcelRequire.register("a5IuE", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
var $758ce279b0bdec9c$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SpeechRecognitionResult = void 0;

var $iQDnw = parcelRequire("iQDnw");
/**
 * Defines result of speech recognition.
 * @class SpeechRecognitionResult
 */ var $758ce279b0bdec9c$var$SpeechRecognitionResult = /** @class */ function(_super) {
    $758ce279b0bdec9c$var$__extends(SpeechRecognitionResult, _super);
    /**
     * Creates and initializes an instance of this class.
     * @constructor
     * @public
     * @param {string} resultId - The result id.
     * @param {ResultReason} reason - The reason.
     * @param {string} text - The recognized text.
     * @param {number} duration - The duration.
     * @param {number} offset - The offset into the stream.
     * @param {string} language - Primary Language detected, if provided.
     * @param {string} languageDetectionConfidence - Primary Language confidence ("Unknown," "Low," "Medium," "High"...), if provided.
     * @param {string} speakerId - speaker id for conversation transcription, if provided.
     * @param {string} errorDetails - Error details, if provided.
     * @param {string} json - Additional Json, if provided.
     * @param {PropertyCollection} properties - Additional properties, if provided.
     */ function SpeechRecognitionResult(resultId, reason, text, duration, offset, language, languageDetectionConfidence, speakerId, errorDetails, json, properties) {
        var _this = _super.call(this, resultId, reason, text, duration, offset, language, languageDetectionConfidence, errorDetails, json, properties) || this;
        _this.privSpeakerId = speakerId;
        return _this;
    }
    Object.defineProperty(SpeechRecognitionResult.prototype, "speakerId", {
        /**
         * speaker id from conversation transcription/id scenarios
         * @member SpeechRecognitionResult.prototype.speakerId
         * @function
         * @public
         * @returns {string} id of speaker in given result
         */ get: function() {
            return this.privSpeakerId;
        },
        enumerable: false,
        configurable: true
    });
    return SpeechRecognitionResult;
}($iQDnw.RecognitionResult);
module.exports.SpeechRecognitionResult = $758ce279b0bdec9c$var$SpeechRecognitionResult;

});

parcelRequire.register("gQhL4", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
var $c42f471489b67deb$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.IntentRecognitionResult = void 0;

var $iQDnw = parcelRequire("iQDnw");
/**
 * Intent recognition result.
 * @class
 */ var $c42f471489b67deb$var$IntentRecognitionResult = /** @class */ function(_super) {
    $c42f471489b67deb$var$__extends(IntentRecognitionResult, _super);
    /**
     * Creates and initializes an instance of this class.
     * @constructor
     * @param intentId - The intent id.
     * @param resultId - The result id.
     * @param reason - The reason.
     * @param text - The recognized text.
     * @param duration - The duration.
     * @param offset - The offset into the stream.
     * @param language - Primary Language detected, if provided.
     * @param languageDetectionConfidence - Primary Language confidence ("Unknown," "Low," "Medium," "High"...), if provided.
     * @param errorDetails - Error details, if provided.
     * @param json - Additional Json, if provided.
     * @param properties - Additional properties, if provided.
     */ function IntentRecognitionResult(intentId, resultId, reason, text, duration, offset, language, languageDetectionConfidence, errorDetails, json, properties) {
        var _this = _super.call(this, resultId, reason, text, duration, offset, language, languageDetectionConfidence, undefined, errorDetails, json, properties) || this;
        _this.privIntentId = intentId;
        return _this;
    }
    Object.defineProperty(IntentRecognitionResult.prototype, "intentId", {
        /**
         * A String that represents the intent identifier being recognized.
         * @member IntentRecognitionResult.prototype.intentId
         * @function
         * @public
         * @returns {string} A String that represents the intent identifier being recognized.
         */ get: function() {
            return this.privIntentId;
        },
        enumerable: false,
        configurable: true
    });
    return IntentRecognitionResult;
}($iQDnw.SpeechRecognitionResult);
module.exports.IntentRecognitionResult = $c42f471489b67deb$var$IntentRecognitionResult;

});

parcelRequire.register("bJDXy", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
var $88b2e4cdde256e2c$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LanguageUnderstandingModelImpl = module.exports.LanguageUnderstandingModel = void 0;

var $evvAW = parcelRequire("evvAW");
/**
 * Language understanding model
 * @class LanguageUnderstandingModel
 */ var $88b2e4cdde256e2c$var$LanguageUnderstandingModel = /** @class */ function() {
    /**
     * Creates and initializes a new instance
     * @constructor
     */ function LanguageUnderstandingModel() {}
    /**
     * Creates an language understanding model using the specified endpoint.
     * @member LanguageUnderstandingModel.fromEndpoint
     * @function
     * @public
     * @param {URL} uri - A String that represents the endpoint of the language understanding model.
     * @returns {LanguageUnderstandingModel} The language understanding model being created.
     */ LanguageUnderstandingModel.fromEndpoint = function(uri) {
        $evvAW.Contracts.throwIfNull(uri, "uri");
        $evvAW.Contracts.throwIfNullOrWhitespace(uri.hostname, "uri");
        var langModelImp = new $88b2e4cdde256e2c$var$LanguageUnderstandingModelImpl();
        // Need to extract the app ID from the URL.
        // URL is in the format: https://<region>.api.cognitive.microsoft.com/luis/v2.0/apps/<Guid>?subscription-key=<key>&timezoneOffset=-360
        // Start tearing the string apart.
        // region can be extracted from the host name.
        var firstDot = uri.host.indexOf(".");
        if (-1 === firstDot) throw new Error("Could not determine region from endpoint");
        langModelImp.region = uri.host.substr(0, firstDot);
        // Now the app ID.
        var lastSegment = uri.pathname.lastIndexOf("/") + 1;
        if (-1 === lastSegment) throw new Error("Could not determine appId from endpoint");
        langModelImp.appId = uri.pathname.substr(lastSegment);
        // And finally the key.
        langModelImp.subscriptionKey = uri.searchParams.get("subscription-key");
        if (undefined === langModelImp.subscriptionKey) throw new Error("Could not determine subscription key from endpoint");
        return langModelImp;
    };
    /**
     * Creates an language understanding model using the application id of Language Understanding service.
     * @member LanguageUnderstandingModel.fromAppId
     * @function
     * @public
     * @param {string} appId - A String that represents the application id of Language Understanding service.
     * @returns {LanguageUnderstandingModel} The language understanding model being created.
     */ LanguageUnderstandingModel.fromAppId = function(appId) {
        $evvAW.Contracts.throwIfNullOrWhitespace(appId, "appId");
        var langModelImp = new $88b2e4cdde256e2c$var$LanguageUnderstandingModelImpl();
        langModelImp.appId = appId;
        return langModelImp;
    };
    /**
     * Creates a language understanding model using hostname, subscription key and application
     * id of Language Understanding service.
     * @member LanguageUnderstandingModel.fromSubscription
     * @function
     * @public
     * @param {string} subscriptionKey - A String that represents the subscription key of
     *        Language Understanding service.
     * @param {string} appId - A String that represents the application id of Language
     *        Understanding service.
     * @param {LanguageUnderstandingModel} region - A String that represents the region
     *        of the Language Understanding service (see the <a href="https://aka.ms/csspeech/region">region page</a>).
     * @returns {LanguageUnderstandingModel} The language understanding model being created.
     */ LanguageUnderstandingModel.fromSubscription = function(subscriptionKey, appId, region) {
        $evvAW.Contracts.throwIfNullOrWhitespace(subscriptionKey, "subscriptionKey");
        $evvAW.Contracts.throwIfNullOrWhitespace(appId, "appId");
        $evvAW.Contracts.throwIfNullOrWhitespace(region, "region");
        var langModelImp = new $88b2e4cdde256e2c$var$LanguageUnderstandingModelImpl();
        langModelImp.appId = appId;
        langModelImp.region = region;
        langModelImp.subscriptionKey = subscriptionKey;
        return langModelImp;
    };
    return LanguageUnderstandingModel;
}();
module.exports.LanguageUnderstandingModel = $88b2e4cdde256e2c$var$LanguageUnderstandingModel;
/**
 * @private
 * @class LanguageUnderstandingModelImpl
 */ // tslint:disable-next-line:max-classes-per-file
var $88b2e4cdde256e2c$var$LanguageUnderstandingModelImpl = /** @class */ function(_super) {
    $88b2e4cdde256e2c$var$__extends(LanguageUnderstandingModelImpl, _super);
    function LanguageUnderstandingModelImpl() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return LanguageUnderstandingModelImpl;
}($88b2e4cdde256e2c$var$LanguageUnderstandingModel);
module.exports.LanguageUnderstandingModelImpl = $88b2e4cdde256e2c$var$LanguageUnderstandingModelImpl;

});

parcelRequire.register("g2jVZ", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
var $bacc4bcd2c8d20e7$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ConversationTranscriptionEventArgs = module.exports.SpeechRecognitionEventArgs = void 0;

var $iQDnw = parcelRequire("iQDnw");
/**
 * Defines contents of speech recognizing/recognized event.
 * @class SpeechRecognitionEventArgs
 */ var $bacc4bcd2c8d20e7$var$SpeechRecognitionEventArgs = /** @class */ function(_super) {
    $bacc4bcd2c8d20e7$var$__extends(SpeechRecognitionEventArgs, _super);
    /**
     * Creates and initializes an instance of this class.
     * @constructor
     * @param {SpeechRecognitionResult} result - The speech recognition result.
     * @param {number} offset - The offset.
     * @param {string} sessionId - The session id.
     */ function SpeechRecognitionEventArgs(result, offset, sessionId) {
        var _this = _super.call(this, offset, sessionId) || this;
        _this.privResult = result;
        return _this;
    }
    Object.defineProperty(SpeechRecognitionEventArgs.prototype, "result", {
        /**
         * Specifies the recognition result.
         * @member SpeechRecognitionEventArgs.prototype.result
         * @function
         * @public
         * @returns {SpeechRecognitionResult} the recognition result.
         */ get: function() {
            return this.privResult;
        },
        enumerable: false,
        configurable: true
    });
    return SpeechRecognitionEventArgs;
}($iQDnw.RecognitionEventArgs);
module.exports.SpeechRecognitionEventArgs = $bacc4bcd2c8d20e7$var$SpeechRecognitionEventArgs;
/**
 * Defines contents of conversation transcribed/transcribing event.
 * @class ConversationTranscriptionEventArgs
 */ // tslint:disable-next-line:max-classes-per-file
var $bacc4bcd2c8d20e7$var$ConversationTranscriptionEventArgs = /** @class */ function(_super) {
    $bacc4bcd2c8d20e7$var$__extends(ConversationTranscriptionEventArgs, _super);
    function ConversationTranscriptionEventArgs() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return ConversationTranscriptionEventArgs;
}($bacc4bcd2c8d20e7$var$SpeechRecognitionEventArgs);
module.exports.ConversationTranscriptionEventArgs = $bacc4bcd2c8d20e7$var$ConversationTranscriptionEventArgs;

});

parcelRequire.register("4svLY", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
var $33f26c61aa50a2ff$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SpeechRecognitionCanceledEventArgs = void 0;

var $dFtwT = parcelRequire("dFtwT");
var $33f26c61aa50a2ff$var$SpeechRecognitionCanceledEventArgs = /** @class */ function(_super) {
    $33f26c61aa50a2ff$var$__extends(SpeechRecognitionCanceledEventArgs, _super);
    function SpeechRecognitionCanceledEventArgs() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return SpeechRecognitionCanceledEventArgs;
}($dFtwT.CancellationEventArgsBase);
module.exports.SpeechRecognitionCanceledEventArgs = $33f26c61aa50a2ff$var$SpeechRecognitionCanceledEventArgs;

});
parcelRequire.register("dFtwT", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
var $9f3602a85b9277b4$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CancellationEventArgsBase = void 0;

var $iQDnw = parcelRequire("iQDnw");
/**
 * Defines content of a CancellationEvent.
 * @class CancellationEventArgsBase
 */ var $9f3602a85b9277b4$var$CancellationEventArgsBase = /** @class */ function(_super) {
    $9f3602a85b9277b4$var$__extends(CancellationEventArgsBase, _super);
    /**
     * Creates and initializes an instance of this class.
     * @constructor
     * @param {CancellationReason} reason - The cancellation reason.
     * @param {string} errorDetails - Error details, if provided.
     * @param {number} offset - The offset.
     * @param {string} sessionId - The session id.
     */ function CancellationEventArgsBase(reason, errorDetails, errorCode, offset, sessionId) {
        var _this = _super.call(this, offset, sessionId) || this;
        _this.privReason = reason;
        _this.privErrorDetails = errorDetails;
        _this.privErrorCode = errorCode;
        return _this;
    }
    Object.defineProperty(CancellationEventArgsBase.prototype, "reason", {
        /**
         * The reason the recognition was canceled.
         * @member CancellationEventArgsBase.prototype.reason
         * @function
         * @public
         * @returns {CancellationReason} Specifies the reason canceled.
         */ get: function() {
            return this.privReason;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CancellationEventArgsBase.prototype, "errorCode", {
        /**
         * The error code in case of an unsuccessful operation.
         * @return An error code that represents the error reason.
         */ get: function() {
            return this.privErrorCode;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CancellationEventArgsBase.prototype, "errorDetails", {
        /**
         * In case of an unsuccessful operation, provides details of the occurred error.
         * @member CancellationEventArgsBase.prototype.errorDetails
         * @function
         * @public
         * @returns {string} A String that represents the error details.
         */ get: function() {
            return this.privErrorDetails;
        },
        enumerable: false,
        configurable: true
    });
    return CancellationEventArgsBase;
}($iQDnw.RecognitionEventArgs);
module.exports.CancellationEventArgsBase = $9f3602a85b9277b4$var$CancellationEventArgsBase;

});


parcelRequire.register("2FEh7", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
var $1f1ea6e4c6744f57$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TranslationRecognitionEventArgs = void 0;

var $iQDnw = parcelRequire("iQDnw");
/**
 * Translation text result event arguments.
 * @class TranslationRecognitionEventArgs
 */ var $1f1ea6e4c6744f57$var$TranslationRecognitionEventArgs = /** @class */ function(_super) {
    $1f1ea6e4c6744f57$var$__extends(TranslationRecognitionEventArgs, _super);
    /**
     * Creates and initializes an instance of this class.
     * @constructor
     * @param {TranslationRecognitionResult} result - The translation recognition result.
     * @param {number} offset - The offset.
     * @param {string} sessionId - The session id.
     */ function TranslationRecognitionEventArgs(result, offset, sessionId) {
        var _this = _super.call(this, offset, sessionId) || this;
        _this.privResult = result;
        return _this;
    }
    Object.defineProperty(TranslationRecognitionEventArgs.prototype, "result", {
        /**
         * Specifies the recognition result.
         * @member TranslationRecognitionEventArgs.prototype.result
         * @function
         * @public
         * @returns {TranslationRecognitionResult} the recognition result.
         */ get: function() {
            return this.privResult;
        },
        enumerable: false,
        configurable: true
    });
    return TranslationRecognitionEventArgs;
}($iQDnw.RecognitionEventArgs);
module.exports.TranslationRecognitionEventArgs = $1f1ea6e4c6744f57$var$TranslationRecognitionEventArgs;

});

parcelRequire.register("cQcqq", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
var $9593faba5d5b358d$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TranslationSynthesisEventArgs = void 0;

var $iQDnw = parcelRequire("iQDnw");
/**
 * Translation Synthesis event arguments
 * @class TranslationSynthesisEventArgs
 */ var $9593faba5d5b358d$var$TranslationSynthesisEventArgs = /** @class */ function(_super) {
    $9593faba5d5b358d$var$__extends(TranslationSynthesisEventArgs, _super);
    /**
     * Creates and initializes an instance of this class.
     * @constructor
     * @param {TranslationSynthesisResult} result - The translation synthesis result.
     * @param {string} sessionId - The session id.
     */ function TranslationSynthesisEventArgs(result, sessionId) {
        var _this = _super.call(this, sessionId) || this;
        _this.privResult = result;
        return _this;
    }
    Object.defineProperty(TranslationSynthesisEventArgs.prototype, "result", {
        /**
         * Specifies the translation synthesis result.
         * @member TranslationSynthesisEventArgs.prototype.result
         * @function
         * @public
         * @returns {TranslationSynthesisResult} Specifies the translation synthesis result.
         */ get: function() {
            return this.privResult;
        },
        enumerable: false,
        configurable: true
    });
    return TranslationSynthesisEventArgs;
}($iQDnw.SessionEventArgs);
module.exports.TranslationSynthesisEventArgs = $9593faba5d5b358d$var$TranslationSynthesisEventArgs;

});

parcelRequire.register("k62Rg", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
var $ea1695bad31283ce$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TranslationRecognitionResult = void 0;

var $iQDnw = parcelRequire("iQDnw");
/**
 * Translation text result.
 * @class TranslationRecognitionResult
 */ var $ea1695bad31283ce$var$TranslationRecognitionResult = /** @class */ function(_super) {
    $ea1695bad31283ce$var$__extends(TranslationRecognitionResult, _super);
    /**
     * Creates and initializes an instance of this class.
     * @constructor
     * @param {Translations} translations - The translations.
     * @param {string} resultId - The result id.
     * @param {ResultReason} reason - The reason.
     * @param {string} text - The recognized text.
     * @param {number} duration - The duration.
     * @param {number} offset - The offset into the stream.
     * @param {string} errorDetails - Error details, if provided.
     * @param {string} json - Additional Json, if provided.
     * @param {PropertyCollection} properties - Additional properties, if provided.
     */ function TranslationRecognitionResult(translations, resultId, reason, text, duration, offset, errorDetails, json, properties) {
        var _this = _super.call(this, resultId, reason, text, duration, offset, undefined, undefined, undefined, errorDetails, json, properties) || this;
        _this.privTranslations = translations;
        return _this;
    }
    Object.defineProperty(TranslationRecognitionResult.prototype, "translations", {
        /**
         * Presents the translation results. Each item in the dictionary represents
         * a translation result in one of target languages, where the key is the name
         * of the target language, in BCP-47 format, and the value is the translation
         * text in the specified language.
         * @member TranslationRecognitionResult.prototype.translations
         * @function
         * @public
         * @returns {Translations} the current translation map that holds all translations requested.
         */ get: function() {
            return this.privTranslations;
        },
        enumerable: false,
        configurable: true
    });
    return TranslationRecognitionResult;
}($iQDnw.SpeechRecognitionResult);
module.exports.TranslationRecognitionResult = $ea1695bad31283ce$var$TranslationRecognitionResult;

});

parcelRequire.register("f3RAc", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TranslationSynthesisResult = void 0;
/**
 * Defines translation synthesis result, i.e. the voice output of the translated
 * text in the target language.
 * @class TranslationSynthesisResult
 */ var $af70b34a11b95f88$var$TranslationSynthesisResult = /** @class */ function() {
    /**
     * Creates and initializes an instance of this class.
     * @constructor
     * @param {ResultReason} reason - The synthesis reason.
     * @param {ArrayBuffer} audio - The audio data.
     */ function TranslationSynthesisResult(reason, audio) {
        this.privReason = reason;
        this.privAudio = audio;
    }
    Object.defineProperty(TranslationSynthesisResult.prototype, "audio", {
        /**
         * Translated text in the target language.
         * @member TranslationSynthesisResult.prototype.audio
         * @function
         * @public
         * @returns {ArrayBuffer} Translated audio in the target language.
         */ get: function() {
            return this.privAudio;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TranslationSynthesisResult.prototype, "reason", {
        /**
         * The synthesis status.
         * @member TranslationSynthesisResult.prototype.reason
         * @function
         * @public
         * @returns {ResultReason} The synthesis status.
         */ get: function() {
            return this.privReason;
        },
        enumerable: false,
        configurable: true
    });
    return TranslationSynthesisResult;
}();
module.exports.TranslationSynthesisResult = $af70b34a11b95f88$var$TranslationSynthesisResult;

});

parcelRequire.register("dTEoe", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ResultReason = void 0;
/**
 * Defines the possible reasons a recognition result might be generated.
 * @class ResultReason
 */ var $a1dfbe03bda02568$var$ResultReason;
(function(ResultReason) {
    /**
     * Indicates speech could not be recognized. More details
     * can be found in the NoMatchDetails object.
     * @member ResultReason.NoMatch
     */ ResultReason[ResultReason["NoMatch"] = 0] = "NoMatch";
    /**
     * Indicates that the recognition was canceled. More details
     * can be found using the CancellationDetails object.
     * @member ResultReason.Canceled
     */ ResultReason[ResultReason["Canceled"] = 1] = "Canceled";
    /**
     * Indicates the speech result contains hypothesis text.
     * @member ResultReason.RecognizedSpeech
     */ ResultReason[ResultReason["RecognizingSpeech"] = 2] = "RecognizingSpeech";
    /**
     * Indicates the speech result contains final text that has been recognized.
     * Speech Recognition is now complete for this phrase.
     * @member ResultReason.RecognizedSpeech
     */ ResultReason[ResultReason["RecognizedSpeech"] = 3] = "RecognizedSpeech";
    /**
     * Indicates the speech result contains a finalized acceptance of a provided keyword.
     * Speech recognition will continue unless otherwise configured.
     * @member ResultReason.RecognizedKeyword
     */ ResultReason[ResultReason["RecognizedKeyword"] = 4] = "RecognizedKeyword";
    /**
     * Indicates the intent result contains hypothesis text and intent.
     * @member ResultReason.RecognizingIntent
     */ ResultReason[ResultReason["RecognizingIntent"] = 5] = "RecognizingIntent";
    /**
     * Indicates the intent result contains final text and intent.
     * Speech Recognition and Intent determination are now complete for this phrase.
     * @member ResultReason.RecognizedIntent
     */ ResultReason[ResultReason["RecognizedIntent"] = 6] = "RecognizedIntent";
    /**
     * Indicates the translation result contains hypothesis text and its translation(s).
     * @member ResultReason.TranslatingSpeech
     */ ResultReason[ResultReason["TranslatingSpeech"] = 7] = "TranslatingSpeech";
    /**
     * Indicates the translation result contains final text and corresponding translation(s).
     * Speech Recognition and Translation are now complete for this phrase.
     * @member ResultReason.TranslatedSpeech
     */ ResultReason[ResultReason["TranslatedSpeech"] = 8] = "TranslatedSpeech";
    /**
     * Indicates the synthesized audio result contains a non-zero amount of audio data
     * @member ResultReason.SynthesizingAudio
     */ ResultReason[ResultReason["SynthesizingAudio"] = 9] = "SynthesizingAudio";
    /**
     * Indicates the synthesized audio is now complete for this phrase.
     * @member ResultReason.SynthesizingAudioCompleted
     */ ResultReason[ResultReason["SynthesizingAudioCompleted"] = 10] = "SynthesizingAudioCompleted";
    /**
     * Indicates the speech synthesis is now started
     * @member ResultReason.SynthesizingAudioStarted
     */ ResultReason[ResultReason["SynthesizingAudioStarted"] = 11] = "SynthesizingAudioStarted";
    /**
     * Indicates the voice profile is being enrolled and customers need to send more audio to create a voice profile.
     * @member ResultReason.EnrollingVoiceProfile
     */ ResultReason[ResultReason["EnrollingVoiceProfile"] = 12] = "EnrollingVoiceProfile";
    /**
     * Indicates the voice profile has been enrolled.
     * @member ResultReason.EnrolledVoiceProfile
     */ ResultReason[ResultReason["EnrolledVoiceProfile"] = 13] = "EnrolledVoiceProfile";
    /**
     * Indicates successful identification of some speakers.
     * @member ResultReason.RecognizedSpeakers
     */ ResultReason[ResultReason["RecognizedSpeakers"] = 14] = "RecognizedSpeakers";
    /**
     * Indicates successfully verified one speaker.
     * @member ResultReason.RecognizedSpeaker
     */ ResultReason[ResultReason["RecognizedSpeaker"] = 15] = "RecognizedSpeaker";
    /**
     * Indicates a voice profile has been reset successfully.
     * @member ResultReason.ResetVoiceProfile
     */ ResultReason[ResultReason["ResetVoiceProfile"] = 16] = "ResetVoiceProfile";
    /**
     * Indicates a voice profile has been deleted successfully.
     * @member ResultReason.DeletedVoiceProfile
     */ ResultReason[ResultReason["DeletedVoiceProfile"] = 17] = "DeletedVoiceProfile";
})($a1dfbe03bda02568$var$ResultReason = module.exports.ResultReason || (module.exports.ResultReason = {}));

});

parcelRequire.register("lbsDi", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
var $f6c0d5eef84aefd9$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SpeechConfigImpl = module.exports.SpeechConfig = void 0;

var $9MAMI = parcelRequire("9MAMI");

var $evvAW = parcelRequire("evvAW");

var $iQDnw = parcelRequire("iQDnw");
/**
 * Speech configuration.
 * @class SpeechConfig
 */ var $f6c0d5eef84aefd9$var$SpeechConfig = /** @class */ function() {
    /**
     * Creates and initializes an instance.
     * @constructor
     */ function SpeechConfig() {}
    /**
     * Static instance of SpeechConfig returned by passing subscriptionKey and service region.
     * Note: Please use your LanguageUnderstanding subscription key in case you want to use the Intent recognizer.
     * @member SpeechConfig.fromSubscription
     * @function
     * @public
     * @param {string} subscriptionKey - The subscription key.
     * @param {string} region - The region name (see the <a href="https://aka.ms/csspeech/region">region page</a>).
     * @returns {SpeechConfig} The speech factory
     */ SpeechConfig.fromSubscription = function(subscriptionKey, region) {
        $evvAW.Contracts.throwIfNullOrWhitespace(subscriptionKey, "subscriptionKey");
        $evvAW.Contracts.throwIfNullOrWhitespace(region, "region");
        var speechImpl = new $f6c0d5eef84aefd9$var$SpeechConfigImpl();
        speechImpl.setProperty($iQDnw.PropertyId.SpeechServiceConnection_Region, region);
        speechImpl.setProperty($iQDnw.PropertyId.SpeechServiceConnection_IntentRegion, region);
        speechImpl.setProperty($iQDnw.PropertyId.SpeechServiceConnection_Key, subscriptionKey);
        return speechImpl;
    };
    /**
     * Creates an instance of the speech config with specified endpoint and subscription key.
     * This method is intended only for users who use a non-standard service endpoint or parameters.
     * Note: Please use your LanguageUnderstanding subscription key in case you want to use the Intent recognizer.
     * Note: The query parameters specified in the endpoint URL are not changed, even if they are set by any other APIs.
     * For example, if language is defined in the uri as query parameter "language=de-DE", and also set by
     *              SpeechConfig.speechRecognitionLanguage = "en-US", the language setting in uri takes precedence,
     *              and the effective language is "de-DE". Only the parameters that are not specified in the
     *              endpoint URL can be set by other APIs.
     * Note: To use authorization token with fromEndpoint, pass an empty string to the subscriptionKey in the
     *       fromEndpoint method, and then set authorizationToken="token" on the created SpeechConfig instance to
     *       use the authorization token.
     * @member SpeechConfig.fromEndpoint
     * @function
     * @public
     * @param {URL} endpoint - The service endpoint to connect to.
     * @param {string} subscriptionKey - The subscription key. If a subscription key is not specified, an authorization token must be set.
     * @returns {SpeechConfig} A speech factory instance.
     */ SpeechConfig.fromEndpoint = function(endpoint, subscriptionKey) {
        $evvAW.Contracts.throwIfNull(endpoint, "endpoint");
        var speechImpl = new $f6c0d5eef84aefd9$var$SpeechConfigImpl();
        speechImpl.setProperty($iQDnw.PropertyId.SpeechServiceConnection_Endpoint, endpoint.href);
        if (undefined !== subscriptionKey) speechImpl.setProperty($iQDnw.PropertyId.SpeechServiceConnection_Key, subscriptionKey);
        return speechImpl;
    };
    /**
     * Creates an instance of the speech config with specified host and subscription key.
     * This method is intended only for users who use a non-default service host. Standard resource path will be assumed.
     * For services with a non-standard resource path or no path at all, use fromEndpoint instead.
     * Note: Query parameters are not allowed in the host URI and must be set by other APIs.
     * Note: To use an authorization token with fromHost, use fromHost(URL),
     * and then set the AuthorizationToken property on the created SpeechConfig instance.
     * Note: Added in version 1.9.0.
     * @member SpeechConfig.fromHost
     * @function
     * @public
     * @param {URL} host - The service endpoint to connect to. Format is "protocol://host:port" where ":port" is optional.
     * @param {string} subscriptionKey - The subscription key. If a subscription key is not specified, an authorization token must be set.
     * @returns {SpeechConfig} A speech factory instance.
     */ SpeechConfig.fromHost = function(hostName, subscriptionKey) {
        $evvAW.Contracts.throwIfNull(hostName, "hostName");
        var speechImpl = new $f6c0d5eef84aefd9$var$SpeechConfigImpl();
        speechImpl.setProperty($iQDnw.PropertyId.SpeechServiceConnection_Host, hostName.protocol + "//" + hostName.hostname + (hostName.port === "" ? "" : ":" + hostName.port));
        if (undefined !== subscriptionKey) speechImpl.setProperty($iQDnw.PropertyId.SpeechServiceConnection_Key, subscriptionKey);
        return speechImpl;
    };
    /**
     * Creates an instance of the speech factory with specified initial authorization token and region.
     * Note: The caller needs to ensure that the authorization token is valid. Before the authorization token
     *       expires, the caller needs to refresh it by calling this setter with a new valid token.
     * Note: Please use a token derived from your LanguageUnderstanding subscription key in case you want
     *       to use the Intent recognizer. As configuration values are copied when creating a new recognizer,
     *       the new token value will not apply to recognizers that have already been created. For recognizers
     *       that have been created before, you need to set authorization token of the corresponding recognizer
     *       to refresh the token. Otherwise, the recognizers will encounter errors during recognition.
     * @member SpeechConfig.fromAuthorizationToken
     * @function
     * @public
     * @param {string} authorizationToken - The initial authorization token.
     * @param {string} region - The region name (see the <a href="https://aka.ms/csspeech/region">region page</a>).
     * @returns {SpeechConfig} A speech factory instance.
     */ SpeechConfig.fromAuthorizationToken = function(authorizationToken, region) {
        $evvAW.Contracts.throwIfNull(authorizationToken, "authorizationToken");
        $evvAW.Contracts.throwIfNullOrWhitespace(region, "region");
        var speechImpl = new $f6c0d5eef84aefd9$var$SpeechConfigImpl();
        speechImpl.setProperty($iQDnw.PropertyId.SpeechServiceConnection_Region, region);
        speechImpl.setProperty($iQDnw.PropertyId.SpeechServiceConnection_IntentRegion, region);
        speechImpl.authorizationToken = authorizationToken;
        return speechImpl;
    };
    /**
     * Closes the configuration.
     * @member SpeechConfig.prototype.close
     * @function
     * @public
     */ /* tslint:disable:no-empty */ SpeechConfig.prototype.close = function() {};
    return SpeechConfig;
}();
module.exports.SpeechConfig = $f6c0d5eef84aefd9$var$SpeechConfig;
/**
 * @public
 * @class SpeechConfigImpl
 */ // tslint:disable-next-line:max-classes-per-file
var $f6c0d5eef84aefd9$var$SpeechConfigImpl = /** @class */ function(_super) {
    $f6c0d5eef84aefd9$var$__extends(SpeechConfigImpl, _super);
    function SpeechConfigImpl() {
        var _this = _super.call(this) || this;
        _this.privProperties = new $iQDnw.PropertyCollection();
        _this.speechRecognitionLanguage = "en-US"; // Should we have a default?
        _this.outputFormat = $iQDnw.OutputFormat.Simple;
        return _this;
    }
    Object.defineProperty(SpeechConfigImpl.prototype, "properties", {
        get: function() {
            return this.privProperties;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SpeechConfigImpl.prototype, "endPoint", {
        get: function() {
            return new URL(this.privProperties.getProperty($iQDnw.PropertyId.SpeechServiceConnection_Endpoint));
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SpeechConfigImpl.prototype, "subscriptionKey", {
        get: function() {
            return this.privProperties.getProperty($iQDnw.PropertyId.SpeechServiceConnection_Key);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SpeechConfigImpl.prototype, "region", {
        get: function() {
            return this.privProperties.getProperty($iQDnw.PropertyId.SpeechServiceConnection_Region);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SpeechConfigImpl.prototype, "authorizationToken", {
        get: function() {
            return this.privProperties.getProperty($iQDnw.PropertyId.SpeechServiceAuthorization_Token);
        },
        set: function(value) {
            this.privProperties.setProperty($iQDnw.PropertyId.SpeechServiceAuthorization_Token, value);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SpeechConfigImpl.prototype, "speechRecognitionLanguage", {
        get: function() {
            return this.privProperties.getProperty($iQDnw.PropertyId.SpeechServiceConnection_RecoLanguage);
        },
        set: function(value) {
            this.privProperties.setProperty($iQDnw.PropertyId.SpeechServiceConnection_RecoLanguage, value);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SpeechConfigImpl.prototype, "autoDetectSourceLanguages", {
        get: function() {
            return this.privProperties.getProperty($iQDnw.PropertyId.SpeechServiceConnection_AutoDetectSourceLanguages);
        },
        set: function(value) {
            this.privProperties.setProperty($iQDnw.PropertyId.SpeechServiceConnection_AutoDetectSourceLanguages, value);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SpeechConfigImpl.prototype, "outputFormat", {
        get: function() {
            return $iQDnw.OutputFormat[this.privProperties.getProperty($9MAMI.OutputFormatPropertyName, undefined)];
        },
        set: function(value) {
            this.privProperties.setProperty($9MAMI.OutputFormatPropertyName, $iQDnw.OutputFormat[value]);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SpeechConfigImpl.prototype, "endpointId", {
        get: function() {
            return this.privProperties.getProperty($iQDnw.PropertyId.SpeechServiceConnection_EndpointId);
        },
        set: function(value) {
            this.privProperties.setProperty($iQDnw.PropertyId.SpeechServiceConnection_EndpointId, value);
        },
        enumerable: false,
        configurable: true
    });
    SpeechConfigImpl.prototype.setProperty = function(name, value) {
        $evvAW.Contracts.throwIfNull(value, "value");
        this.privProperties.setProperty(name, value);
    };
    SpeechConfigImpl.prototype.getProperty = function(name, def) {
        return this.privProperties.getProperty(name, def);
    };
    SpeechConfigImpl.prototype.setProxy = function(proxyHostName, proxyPort, proxyUserName, proxyPassword) {
        this.setProperty($iQDnw.PropertyId[$iQDnw.PropertyId.SpeechServiceConnection_ProxyHostName], proxyHostName);
        this.setProperty($iQDnw.PropertyId[$iQDnw.PropertyId.SpeechServiceConnection_ProxyPort], proxyPort);
        this.setProperty($iQDnw.PropertyId[$iQDnw.PropertyId.SpeechServiceConnection_ProxyUserName], proxyUserName);
        this.setProperty($iQDnw.PropertyId[$iQDnw.PropertyId.SpeechServiceConnection_ProxyPassword], proxyPassword);
    };
    SpeechConfigImpl.prototype.setServiceProperty = function(name, value, channel) {
        var currentProperties = JSON.parse(this.privProperties.getProperty($9MAMI.ServicePropertiesPropertyName, "{}"));
        currentProperties[name] = value;
        this.privProperties.setProperty($9MAMI.ServicePropertiesPropertyName, JSON.stringify(currentProperties));
    };
    SpeechConfigImpl.prototype.setProfanity = function(profanity) {
        this.privProperties.setProperty($iQDnw.PropertyId.SpeechServiceResponse_ProfanityOption, $iQDnw.ProfanityOption[profanity]);
    };
    SpeechConfigImpl.prototype.enableAudioLogging = function() {
        this.privProperties.setProperty($iQDnw.PropertyId.SpeechServiceConnection_EnableAudioLogging, "true");
    };
    SpeechConfigImpl.prototype.requestWordLevelTimestamps = function() {
        this.privProperties.setProperty($iQDnw.PropertyId.SpeechServiceResponse_RequestWordLevelTimestamps, "true");
    };
    SpeechConfigImpl.prototype.enableDictation = function() {
        this.privProperties.setProperty($9MAMI.ForceDictationPropertyName, "true");
    };
    SpeechConfigImpl.prototype.clone = function() {
        var ret = new SpeechConfigImpl();
        ret.privProperties = this.privProperties.clone();
        return ret;
    };
    Object.defineProperty(SpeechConfigImpl.prototype, "speechSynthesisLanguage", {
        get: function() {
            return this.privProperties.getProperty($iQDnw.PropertyId.SpeechServiceConnection_SynthLanguage);
        },
        set: function(language) {
            this.privProperties.setProperty($iQDnw.PropertyId.SpeechServiceConnection_SynthLanguage, language);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SpeechConfigImpl.prototype, "speechSynthesisVoiceName", {
        get: function() {
            return this.privProperties.getProperty($iQDnw.PropertyId.SpeechServiceConnection_SynthVoice);
        },
        set: function(voice) {
            this.privProperties.setProperty($iQDnw.PropertyId.SpeechServiceConnection_SynthVoice, voice);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SpeechConfigImpl.prototype, "speechSynthesisOutputFormat", {
        get: function() {
            return $iQDnw.SpeechSynthesisOutputFormat[this.privProperties.getProperty($iQDnw.PropertyId.SpeechServiceConnection_SynthOutputFormat, undefined)];
        },
        set: function(format) {
            this.privProperties.setProperty($iQDnw.PropertyId.SpeechServiceConnection_SynthOutputFormat, $iQDnw.SpeechSynthesisOutputFormat[format]);
        },
        enumerable: false,
        configurable: true
    });
    return SpeechConfigImpl;
}($f6c0d5eef84aefd9$var$SpeechConfig);
module.exports.SpeechConfigImpl = $f6c0d5eef84aefd9$var$SpeechConfigImpl;

});

parcelRequire.register("8m0VQ", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
var $615119e1f4953f0f$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SpeechTranslationConfigImpl = module.exports.SpeechTranslationConfig = void 0;

var $9MAMI = parcelRequire("9MAMI");

var $evvAW = parcelRequire("evvAW");

var $iQDnw = parcelRequire("iQDnw");
/**
 * Speech translation configuration.
 * @class SpeechTranslationConfig
 */ var $615119e1f4953f0f$var$SpeechTranslationConfig = /** @class */ function(_super) {
    $615119e1f4953f0f$var$__extends(SpeechTranslationConfig, _super);
    /**
     * Creates an instance of recognizer config.
     */ function SpeechTranslationConfig() {
        return _super.call(this) || this;
    }
    /**
     * Static instance of SpeechTranslationConfig returned by passing a subscription key and service region.
     * @member SpeechTranslationConfig.fromSubscription
     * @function
     * @public
     * @param {string} subscriptionKey - The subscription key.
     * @param {string} region - The region name (see the <a href="https://aka.ms/csspeech/region">region page</a>).
     * @returns {SpeechTranslationConfig} The speech translation config.
     */ SpeechTranslationConfig.fromSubscription = function(subscriptionKey, region) {
        $evvAW.Contracts.throwIfNullOrWhitespace(subscriptionKey, "subscriptionKey");
        $evvAW.Contracts.throwIfNullOrWhitespace(region, "region");
        var ret = new $615119e1f4953f0f$var$SpeechTranslationConfigImpl();
        ret.properties.setProperty($iQDnw.PropertyId.SpeechServiceConnection_Key, subscriptionKey);
        ret.properties.setProperty($iQDnw.PropertyId.SpeechServiceConnection_Region, region);
        return ret;
    };
    /**
     * Static instance of SpeechTranslationConfig returned by passing authorization token and service region.
     * Note: The caller needs to ensure that the authorization token is valid. Before the authorization token
     *       expires, the caller needs to refresh it by setting the property authorizationToken with a new
     *       valid token. Otherwise, all the recognizers created by this SpeechTranslationConfig instance
     *       will encounter errors during recognition.
     * As configuration values are copied when creating a new recognizer, the new token value will not apply
     * to recognizers that have already been created.
     * For recognizers that have been created before, you need to set authorization token of the corresponding recognizer
     * to refresh the token. Otherwise, the recognizers will encounter errors during recognition.
     * @member SpeechTranslationConfig.fromAuthorizationToken
     * @function
     * @public
     * @param {string} authorizationToken - The authorization token.
     * @param {string} region - The region name (see the <a href="https://aka.ms/csspeech/region">region page</a>).
     * @returns {SpeechTranslationConfig} The speech translation config.
     */ SpeechTranslationConfig.fromAuthorizationToken = function(authorizationToken, region) {
        $evvAW.Contracts.throwIfNullOrWhitespace(authorizationToken, "authorizationToken");
        $evvAW.Contracts.throwIfNullOrWhitespace(region, "region");
        var ret = new $615119e1f4953f0f$var$SpeechTranslationConfigImpl();
        ret.properties.setProperty($iQDnw.PropertyId.SpeechServiceAuthorization_Token, authorizationToken);
        ret.properties.setProperty($iQDnw.PropertyId.SpeechServiceConnection_Region, region);
        return ret;
    };
    /**
     * Creates an instance of the speech config with specified host and subscription key.
     * This method is intended only for users who use a non-default service host. Standard resource path will be assumed.
     * For services with a non-standard resource path or no path at all, use fromEndpoint instead.
     * Note: Query parameters are not allowed in the host URI and must be set by other APIs.
     * Note: To use an authorization token with fromHost, use fromHost(URL),
     * and then set the AuthorizationToken property on the created SpeechConfig instance.
     * Note: Added in version 1.9.0.
     * @member SpeechConfig.fromHost
     * @function
     * @public
     * @param {URL} host - The service endpoint to connect to. Format is "protocol://host:port" where ":port" is optional.
     * @param {string} subscriptionKey - The subscription key. If a subscription key is not specified, an authorization token must be set.
     * @returns {SpeechConfig} A speech factory instance.
     */ SpeechTranslationConfig.fromHost = function(hostName, subscriptionKey) {
        $evvAW.Contracts.throwIfNull(hostName, "hostName");
        var speechImpl = new $615119e1f4953f0f$var$SpeechTranslationConfigImpl();
        speechImpl.setProperty($iQDnw.PropertyId.SpeechServiceConnection_Host, hostName.protocol + "//" + hostName.hostname + (hostName.port === "" ? "" : ":" + hostName.port));
        if (undefined !== subscriptionKey) speechImpl.setProperty($iQDnw.PropertyId.SpeechServiceConnection_Key, subscriptionKey);
        return speechImpl;
    };
    /**
     * Creates an instance of the speech translation config with specified endpoint and subscription key.
     * This method is intended only for users who use a non-standard service endpoint or paramters.
     * Note: The query properties specified in the endpoint URL are not changed, even if they are
     *       set by any other APIs. For example, if language is defined in the uri as query parameter
     *       "language=de-DE", and also set by the speechRecognitionLanguage property, the language
     *       setting in uri takes precedence, and the effective language is "de-DE".
     * Only the properties that are not specified in the endpoint URL can be set by other APIs.
     * Note: To use authorization token with fromEndpoint, pass an empty string to the subscriptionKey in the
     *       fromEndpoint method, and then set authorizationToken="token" on the created SpeechConfig instance to
     *       use the authorization token.
     * @member SpeechTranslationConfig.fromEndpoint
     * @function
     * @public
     * @param {URL} endpoint - The service endpoint to connect to.
     * @param {string} subscriptionKey - The subscription key.
     * @returns {SpeechTranslationConfig} A speech config instance.
     */ SpeechTranslationConfig.fromEndpoint = function(endpoint, subscriptionKey) {
        $evvAW.Contracts.throwIfNull(endpoint, "endpoint");
        $evvAW.Contracts.throwIfNull(subscriptionKey, "subscriptionKey");
        var ret = new $615119e1f4953f0f$var$SpeechTranslationConfigImpl();
        ret.properties.setProperty($iQDnw.PropertyId.SpeechServiceConnection_Endpoint, endpoint.href);
        ret.properties.setProperty($iQDnw.PropertyId.SpeechServiceConnection_Key, subscriptionKey);
        return ret;
    };
    return SpeechTranslationConfig;
}($iQDnw.SpeechConfig);
module.exports.SpeechTranslationConfig = $615119e1f4953f0f$var$SpeechTranslationConfig;
/**
 * @private
 * @class SpeechTranslationConfigImpl
 */ // tslint:disable-next-line:max-classes-per-file
var $615119e1f4953f0f$var$SpeechTranslationConfigImpl = /** @class */ function(_super) {
    $615119e1f4953f0f$var$__extends(SpeechTranslationConfigImpl, _super);
    function SpeechTranslationConfigImpl() {
        var _this = _super.call(this) || this;
        _this.privSpeechProperties = new $iQDnw.PropertyCollection();
        _this.outputFormat = $iQDnw.OutputFormat.Simple;
        return _this;
    }
    Object.defineProperty(SpeechTranslationConfigImpl.prototype, "authorizationToken", {
        /**
         * Gets/Sets the authorization token.
         * If this is set, subscription key is ignored.
         * User needs to make sure the provided authorization token is valid and not expired.
         * @member SpeechTranslationConfigImpl.prototype.authorizationToken
         * @function
         * @public
         * @param {string} value - The authorization token.
         */ set: function(value) {
            $evvAW.Contracts.throwIfNullOrWhitespace(value, "value");
            this.privSpeechProperties.setProperty($iQDnw.PropertyId.SpeechServiceAuthorization_Token, value);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SpeechTranslationConfigImpl.prototype, "speechRecognitionLanguage", {
        /**
         * Gets the speech recognition language.
         * @member SpeechTranslationConfigImpl.prototype.speechRecognitionLanguage
         * @function
         * @public
         * @return {string} The speechRecognitionLanguage.
         */ get: function() {
            return this.privSpeechProperties.getProperty($iQDnw.PropertyId[$iQDnw.PropertyId.SpeechServiceConnection_RecoLanguage]);
        },
        /**
         * Sets the speech recognition language.
         * @member SpeechTranslationConfigImpl.prototype.speechRecognitionLanguage
         * @function
         * @public
         * @param {string} value - The authorization token.
         */ set: function(value) {
            $evvAW.Contracts.throwIfNullOrWhitespace(value, "value");
            this.privSpeechProperties.setProperty($iQDnw.PropertyId.SpeechServiceConnection_RecoLanguage, value);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SpeechTranslationConfigImpl.prototype, "subscriptionKey", {
        /**
         * @member SpeechTranslationConfigImpl.prototype.subscriptionKey
         * @function
         * @public
         */ get: function() {
            return this.privSpeechProperties.getProperty($iQDnw.PropertyId[$iQDnw.PropertyId.SpeechServiceConnection_Key]);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SpeechTranslationConfigImpl.prototype, "outputFormat", {
        /**
         * Gets the output format
         * @member SpeechTranslationConfigImpl.prototype.outputFormat
         * @function
         * @public
         */ get: function() {
            return $iQDnw.OutputFormat[this.privSpeechProperties.getProperty($9MAMI.OutputFormatPropertyName, undefined)];
        },
        /**
         * Gets/Sets the output format
         * @member SpeechTranslationConfigImpl.prototype.outputFormat
         * @function
         * @public
         */ set: function(value) {
            this.privSpeechProperties.setProperty($9MAMI.OutputFormatPropertyName, $iQDnw.OutputFormat[value]);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SpeechTranslationConfigImpl.prototype, "endpointId", {
        /**
         * Gets the endpoint id.
         * @member SpeechTranslationConfigImpl.prototype.endpointId
         * @function
         * @public
         */ get: function() {
            return this.privSpeechProperties.getProperty($iQDnw.PropertyId.SpeechServiceConnection_EndpointId);
        },
        /**
         * Gets/Sets the endpoint id.
         * @member SpeechTranslationConfigImpl.prototype.endpointId
         * @function
         * @public
         */ set: function(value) {
            this.privSpeechProperties.setProperty($iQDnw.PropertyId.SpeechServiceConnection_EndpointId, value);
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Add a (text) target language to translate into.
     * @member SpeechTranslationConfigImpl.prototype.addTargetLanguage
     * @function
     * @public
     * @param {string} value - The language such as de-DE
     */ SpeechTranslationConfigImpl.prototype.addTargetLanguage = function(value) {
        $evvAW.Contracts.throwIfNullOrWhitespace(value, "value");
        var languages = this.targetLanguages;
        languages.push(value);
        this.privSpeechProperties.setProperty($iQDnw.PropertyId.SpeechServiceConnection_TranslationToLanguages, languages.join(","));
    };
    Object.defineProperty(SpeechTranslationConfigImpl.prototype, "targetLanguages", {
        /**
         * Gets the (text) target language to translate into.
         * @member SpeechTranslationConfigImpl.prototype.targetLanguages
         * @function
         * @public
         * @param {string} value - The language such as de-DE
         */ get: function() {
            if (this.privSpeechProperties.getProperty($iQDnw.PropertyId.SpeechServiceConnection_TranslationToLanguages, undefined) !== undefined) return this.privSpeechProperties.getProperty($iQDnw.PropertyId.SpeechServiceConnection_TranslationToLanguages).split(",");
            else return [];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SpeechTranslationConfigImpl.prototype, "voiceName", {
        /**
         * Gets the voice name.
         * @member SpeechTranslationConfigImpl.prototype.voiceName
         * @function
         * @public
         */ get: function() {
            return this.getProperty($iQDnw.PropertyId[$iQDnw.PropertyId.SpeechServiceConnection_TranslationVoice]);
        },
        /**
         * Gets/Sets the voice of the translated language, enable voice synthesis output.
         * @member SpeechTranslationConfigImpl.prototype.voiceName
         * @function
         * @public
         * @param {string} value - The name of the voice.
         */ set: function(value) {
            $evvAW.Contracts.throwIfNullOrWhitespace(value, "value");
            this.privSpeechProperties.setProperty($iQDnw.PropertyId.SpeechServiceConnection_TranslationVoice, value);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SpeechTranslationConfigImpl.prototype, "region", {
        /**
         * Provides the region.
         * @member SpeechTranslationConfigImpl.prototype.region
         * @function
         * @public
         * @returns {string} The region.
         */ get: function() {
            return this.privSpeechProperties.getProperty($iQDnw.PropertyId.SpeechServiceConnection_Region);
        },
        enumerable: false,
        configurable: true
    });
    SpeechTranslationConfigImpl.prototype.setProxy = function(proxyHostName, proxyPort, proxyUserName, proxyPassword) {
        this.setProperty($iQDnw.PropertyId[$iQDnw.PropertyId.SpeechServiceConnection_ProxyHostName], proxyHostName);
        this.setProperty($iQDnw.PropertyId[$iQDnw.PropertyId.SpeechServiceConnection_ProxyPort], proxyPort);
        this.setProperty($iQDnw.PropertyId[$iQDnw.PropertyId.SpeechServiceConnection_ProxyUserName], proxyUserName);
        this.setProperty($iQDnw.PropertyId[$iQDnw.PropertyId.SpeechServiceConnection_ProxyPassword], proxyPassword);
    };
    /**
     * Gets an arbitrary property value.
     * @member SpeechTranslationConfigImpl.prototype.getProperty
     * @function
     * @public
     * @param {string} name - The name of the property.
     * @param {string} def - The default value of the property in case it is not set.
     * @returns {string} The value of the property.
     */ SpeechTranslationConfigImpl.prototype.getProperty = function(name, def) {
        return this.privSpeechProperties.getProperty(name, def);
    };
    /**
     * Gets/Sets an arbitrary property value.
     * @member SpeechTranslationConfigImpl.prototype.setProperty
     * @function
     * @public
     * @param {string} name - The name of the property.
     * @param {string} value - The value of the property.
     */ SpeechTranslationConfigImpl.prototype.setProperty = function(name, value) {
        this.privSpeechProperties.setProperty(name, value);
    };
    Object.defineProperty(SpeechTranslationConfigImpl.prototype, "properties", {
        /**
         * Provides access to custom properties.
         * @member SpeechTranslationConfigImpl.prototype.properties
         * @function
         * @public
         * @returns {PropertyCollection} The properties.
         */ get: function() {
            return this.privSpeechProperties;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Dispose of associated resources.
     * @member SpeechTranslationConfigImpl.prototype.close
     * @function
     * @public
     */ SpeechTranslationConfigImpl.prototype.close = function() {
        return;
    };
    SpeechTranslationConfigImpl.prototype.setServiceProperty = function(name, value, channel) {
        var currentProperties = JSON.parse(this.privSpeechProperties.getProperty($9MAMI.ServicePropertiesPropertyName, "{}"));
        currentProperties[name] = value;
        this.privSpeechProperties.setProperty($9MAMI.ServicePropertiesPropertyName, JSON.stringify(currentProperties));
    };
    SpeechTranslationConfigImpl.prototype.setProfanity = function(profanity) {
        this.privSpeechProperties.setProperty($iQDnw.PropertyId.SpeechServiceResponse_ProfanityOption, $iQDnw.ProfanityOption[profanity]);
    };
    SpeechTranslationConfigImpl.prototype.enableAudioLogging = function() {
        this.privSpeechProperties.setProperty($iQDnw.PropertyId.SpeechServiceConnection_EnableAudioLogging, "true");
    };
    SpeechTranslationConfigImpl.prototype.requestWordLevelTimestamps = function() {
        this.privSpeechProperties.setProperty($iQDnw.PropertyId.SpeechServiceResponse_RequestWordLevelTimestamps, "true");
    };
    SpeechTranslationConfigImpl.prototype.enableDictation = function() {
        this.privSpeechProperties.setProperty($9MAMI.ForceDictationPropertyName, "true");
    };
    Object.defineProperty(SpeechTranslationConfigImpl.prototype, "speechSynthesisLanguage", {
        get: function() {
            return this.privSpeechProperties.getProperty($iQDnw.PropertyId.SpeechServiceConnection_SynthLanguage);
        },
        set: function(language) {
            this.privSpeechProperties.setProperty($iQDnw.PropertyId.SpeechServiceConnection_SynthLanguage, language);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SpeechTranslationConfigImpl.prototype, "speechSynthesisVoiceName", {
        get: function() {
            return this.privSpeechProperties.getProperty($iQDnw.PropertyId.SpeechServiceConnection_SynthVoice);
        },
        set: function(voice) {
            this.privSpeechProperties.setProperty($iQDnw.PropertyId.SpeechServiceConnection_SynthVoice, voice);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SpeechTranslationConfigImpl.prototype, "speechSynthesisOutputFormat", {
        get: function() {
            return $iQDnw.SpeechSynthesisOutputFormat[this.privSpeechProperties.getProperty($iQDnw.PropertyId.SpeechServiceConnection_SynthOutputFormat, undefined)];
        },
        set: function(format) {
            this.privSpeechProperties.setProperty($iQDnw.PropertyId.SpeechServiceConnection_SynthOutputFormat, $iQDnw.SpeechSynthesisOutputFormat[format]);
        },
        enumerable: false,
        configurable: true
    });
    return SpeechTranslationConfigImpl;
}($615119e1f4953f0f$var$SpeechTranslationConfig);
module.exports.SpeechTranslationConfigImpl = $615119e1f4953f0f$var$SpeechTranslationConfigImpl;

});

parcelRequire.register("jnfnZ", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PropertyCollection = void 0;

var $iQDnw = parcelRequire("iQDnw");
/**
 * Represents collection of properties and their values.
 * @class PropertyCollection
 */ var $e1ac19a01e000a82$var$PropertyCollection = /** @class */ function() {
    function PropertyCollection() {
        this.privKeys = [];
        this.privValues = [];
    }
    /**
     * Returns the property value in type String. The parameter must have the same type as String.
     * Currently only String, int and bool are allowed.
     * If the name is not available, the specified defaultValue is returned.
     * @member PropertyCollection.prototype.getProperty
     * @function
     * @public
     * @param {string} key - The parameter name.
     * @param {string} def - The default value which is returned if the parameter
     *        is not available in the collection.
     * @returns {string} value of the parameter.
     */ PropertyCollection.prototype.getProperty = function(key, def) {
        var keyToUse;
        if (typeof key === "string") keyToUse = key;
        else keyToUse = $iQDnw.PropertyId[key];
        for(var n = 0; n < this.privKeys.length; n++){
            if (this.privKeys[n] === keyToUse) return this.privValues[n];
        }
        return def;
    };
    /**
     * Sets the String value of the parameter specified by name.
     * @member PropertyCollection.prototype.setProperty
     * @function
     * @public
     * @param {string} key - The parameter name.
     * @param {string} value - The value of the parameter.
     */ PropertyCollection.prototype.setProperty = function(key, value) {
        var keyToUse;
        if (typeof key === "string") keyToUse = key;
        else keyToUse = $iQDnw.PropertyId[key];
        for(var n = 0; n < this.privKeys.length; n++)if (this.privKeys[n] === keyToUse) {
            this.privValues[n] = value;
            return;
        }
        this.privKeys.push(keyToUse);
        this.privValues.push(value);
    };
    /**
     * Clones the collection.
     * @member PropertyCollection.prototype.clone
     * @function
     * @public
     * @returns {PropertyCollection} A copy of the collection.
     */ PropertyCollection.prototype.clone = function() {
        var clonedMap = new PropertyCollection();
        for(var n = 0; n < this.privKeys.length; n++){
            clonedMap.privKeys.push(this.privKeys[n]);
            clonedMap.privValues.push(this.privValues[n]);
        }
        return clonedMap;
    };
    /**
     * Merges this set of properties into another, no overwrites.
     * @member PropertyCollection.prototype.mergeTo
     * @function
     * @public
     * @param {PropertyCollection} The collection to merge into.
     */ PropertyCollection.prototype.mergeTo = function(destinationCollection) {
        var _this = this;
        this.privKeys.forEach(function(key) {
            if (destinationCollection.getProperty(key, undefined) === undefined) {
                var value = _this.getProperty(key);
                destinationCollection.setProperty(key, value);
            }
        });
    };
    return PropertyCollection;
}();
module.exports.PropertyCollection = $e1ac19a01e000a82$var$PropertyCollection;

});

parcelRequire.register("ChSMK", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PropertyId = void 0;
/**
 * Defines speech property ids.
 * @class PropertyId
 */ var $07316bd7c00b1607$var$PropertyId;
(function(PropertyId) {
    /**
     * The Cognitive Services Speech Service subscription Key. If you are using an intent recognizer, you need to specify
     * to specify the LUIS endpoint key for your particular LUIS app. Under normal circumstances, you shouldn't
     * have to use this property directly.
     * Instead, use [[SpeechConfig.fromSubscription]].
     * @member PropertyId.SpeechServiceConnection_Key
     */ PropertyId[PropertyId["SpeechServiceConnection_Key"] = 0] = "SpeechServiceConnection_Key";
    /**
     * The Cognitive Services Speech Service endpoint (url). Under normal circumstances, you shouldn't
     * have to use this property directly.
     * Instead, use [[SpeechConfig.fromEndpoint]].
     * NOTE: This endpoint is not the same as the endpoint used to obtain an access token.
     * @member PropertyId.SpeechServiceConnection_Endpoint
     */ PropertyId[PropertyId["SpeechServiceConnection_Endpoint"] = 1] = "SpeechServiceConnection_Endpoint";
    /**
     * The Cognitive Services Speech Service region. Under normal circumstances, you shouldn't have to
     * use this property directly.
     * Instead, use [[SpeechConfig.fromSubscription]], [[SpeechConfig.fromEndpoint]], [[SpeechConfig.fromAuthorizationToken]].
     * @member PropertyId.SpeechServiceConnection_Region
     */ PropertyId[PropertyId["SpeechServiceConnection_Region"] = 2] = "SpeechServiceConnection_Region";
    /**
     * The Cognitive Services Speech Service authorization token (aka access token). Under normal circumstances,
     * you shouldn't have to use this property directly.
     * Instead, use [[SpeechConfig.fromAuthorizationToken]], [[SpeechRecognizer.authorizationToken]],
     * [[IntentRecognizer.authorizationToken]], [[TranslationRecognizer.authorizationToken]], [[SpeakerRecognizer.authorizationToken]].
     * @member PropertyId.SpeechServiceAuthorization_Token
     */ PropertyId[PropertyId["SpeechServiceAuthorization_Token"] = 3] = "SpeechServiceAuthorization_Token";
    /**
     * The Cognitive Services Speech Service authorization type. Currently unused.
     * @member PropertyId.SpeechServiceAuthorization_Type
     */ PropertyId[PropertyId["SpeechServiceAuthorization_Type"] = 4] = "SpeechServiceAuthorization_Type";
    /**
     * The Cognitive Services Speech Service endpoint id. Under normal circumstances, you shouldn't
     * have to use this property directly.
     * Instead, use [[SpeechConfig.endpointId]].
     * NOTE: The endpoint id is available in the Speech Portal, listed under Endpoint Details.
     * @member PropertyId.SpeechServiceConnection_EndpointId
     */ PropertyId[PropertyId["SpeechServiceConnection_EndpointId"] = 5] = "SpeechServiceConnection_EndpointId";
    /**
     * The list of comma separated languages (BCP-47 format) used as target translation languages. Under normal circumstances,
     * you shouldn't have to use this property directly.
     * Instead use [[SpeechTranslationConfig.addTargetLanguage]],
     * [[SpeechTranslationConfig.targetLanguages]], [[TranslationRecognizer.targetLanguages]].
     * @member PropertyId.SpeechServiceConnection_TranslationToLanguages
     */ PropertyId[PropertyId["SpeechServiceConnection_TranslationToLanguages"] = 6] = "SpeechServiceConnection_TranslationToLanguages";
    /**
     * The name of the Cognitive Service Text to Speech Service Voice. Under normal circumstances, you shouldn't have to use this
     * property directly.
     * Instead, use [[SpeechTranslationConfig.voiceName]].
     * NOTE: Valid voice names can be found <a href="https://aka.ms/csspeech/voicenames">here</a>.
     * @member PropertyId.SpeechServiceConnection_TranslationVoice
     */ PropertyId[PropertyId["SpeechServiceConnection_TranslationVoice"] = 7] = "SpeechServiceConnection_TranslationVoice";
    /**
     * Translation features.
     * @member PropertyId.SpeechServiceConnection_TranslationFeatures
     */ PropertyId[PropertyId["SpeechServiceConnection_TranslationFeatures"] = 8] = "SpeechServiceConnection_TranslationFeatures";
    /**
     * The Language Understanding Service Region. Under normal circumstances, you shouldn't have to use this property directly.
     * Instead, use [[LanguageUnderstandingModel]].
     * @member PropertyId.SpeechServiceConnection_IntentRegion
     */ PropertyId[PropertyId["SpeechServiceConnection_IntentRegion"] = 9] = "SpeechServiceConnection_IntentRegion";
    /**
     * The host name of the proxy server used to connect to the Cognitive Services Speech Service. Only relevant in Node.js environments.
     * You shouldn't have to use this property directly.
     * Instead use <see cref="SpeechConfig.SetProxy(string,int,string,string)"/>.
     * Added in version 1.4.0.
     */ PropertyId[PropertyId["SpeechServiceConnection_ProxyHostName"] = 10] = "SpeechServiceConnection_ProxyHostName";
    /**
     * The port of the proxy server used to connect to the Cognitive Services Speech Service. Only relevant in Node.js environments.
     * You shouldn't have to use this property directly.
     * Instead use <see cref="SpeechConfig.SetProxy(string,int,string,string)"/>.
     * Added in version 1.4.0.
     */ PropertyId[PropertyId["SpeechServiceConnection_ProxyPort"] = 11] = "SpeechServiceConnection_ProxyPort";
    /**
     * The user name of the proxy server used to connect to the Cognitive Services Speech Service. Only relevant in Node.js environments.
     * You shouldn't have to use this property directly.
     * Instead use <see cref="SpeechConfig.SetProxy(string,int,string,string)"/>.
     * Added in version 1.4.0.
     */ PropertyId[PropertyId["SpeechServiceConnection_ProxyUserName"] = 12] = "SpeechServiceConnection_ProxyUserName";
    /**
     * The password of the proxy server used to connect to the Cognitive Services Speech Service. Only relevant in Node.js environments.
     * You shouldn't have to use this property directly.
     * Instead use <see cref="SpeechConfig.SetProxy(string,int,string,string)"/>.
     * Added in version 1.4.0.
     */ PropertyId[PropertyId["SpeechServiceConnection_ProxyPassword"] = 13] = "SpeechServiceConnection_ProxyPassword";
    /**
     * The Cognitive Services Speech Service recognition Mode. Can be "INTERACTIVE", "CONVERSATION", "DICTATION".
     * This property is intended to be read-only. The SDK is using it internally.
     * @member PropertyId.SpeechServiceConnection_RecoMode
     */ PropertyId[PropertyId["SpeechServiceConnection_RecoMode"] = 14] = "SpeechServiceConnection_RecoMode";
    /**
     * The spoken language to be recognized (in BCP-47 format). Under normal circumstances, you shouldn't have to use this property
     * directly.
     * Instead, use [[SpeechConfig.speechRecognitionLanguage]].
     * @member PropertyId.SpeechServiceConnection_RecoLanguage
     */ PropertyId[PropertyId["SpeechServiceConnection_RecoLanguage"] = 15] = "SpeechServiceConnection_RecoLanguage";
    /**
     * The session id. This id is a universally unique identifier (aka UUID) representing a specific binding of an audio input stream
     * and the underlying speech recognition instance to which it is bound. Under normal circumstances, you shouldn't have to use this
     * property directly.
     * Instead use [[SessionEventArgs.sessionId]].
     * @member PropertyId.Speech_SessionId
     */ PropertyId[PropertyId["Speech_SessionId"] = 16] = "Speech_SessionId";
    /**
     * The spoken language to be synthesized (e.g. en-US)
     * @member PropertyId.SpeechServiceConnection_SynthLanguage
     */ PropertyId[PropertyId["SpeechServiceConnection_SynthLanguage"] = 17] = "SpeechServiceConnection_SynthLanguage";
    /**
     * The name of the TTS voice to be used for speech synthesis
     * @member PropertyId.SpeechServiceConnection_SynthVoice
     */ PropertyId[PropertyId["SpeechServiceConnection_SynthVoice"] = 18] = "SpeechServiceConnection_SynthVoice";
    /**
     * The string to specify TTS output audio format
     * @member PropertyId.SpeechServiceConnection_SynthOutputFormat
     */ PropertyId[PropertyId["SpeechServiceConnection_SynthOutputFormat"] = 19] = "SpeechServiceConnection_SynthOutputFormat";
    /**
     * The list of comma separated languages used as possible source languages
     * Added in version 1.13.0
     * @member PropertyId.SpeechServiceConnection_AutoDetectSourceLanguages
     */ PropertyId[PropertyId["SpeechServiceConnection_AutoDetectSourceLanguages"] = 20] = "SpeechServiceConnection_AutoDetectSourceLanguages";
    /**
     * The requested Cognitive Services Speech Service response output format (simple or detailed). Under normal circumstances, you shouldn't have
     * to use this property directly.
     * Instead use [[SpeechConfig.outputFormat]].
     * @member PropertyId.SpeechServiceResponse_RequestDetailedResultTrueFalse
     */ PropertyId[PropertyId["SpeechServiceResponse_RequestDetailedResultTrueFalse"] = 21] = "SpeechServiceResponse_RequestDetailedResultTrueFalse";
    /**
     * The requested Cognitive Services Speech Service response output profanity level. Currently unused.
     * @member PropertyId.SpeechServiceResponse_RequestProfanityFilterTrueFalse
     */ PropertyId[PropertyId["SpeechServiceResponse_RequestProfanityFilterTrueFalse"] = 22] = "SpeechServiceResponse_RequestProfanityFilterTrueFalse";
    /**
     * The Cognitive Services Speech Service response output (in JSON format). This property is available on recognition result objects only.
     * @member PropertyId.SpeechServiceResponse_JsonResult
     */ PropertyId[PropertyId["SpeechServiceResponse_JsonResult"] = 23] = "SpeechServiceResponse_JsonResult";
    /**
     * The Cognitive Services Speech Service error details (in JSON format). Under normal circumstances, you shouldn't have to
     * use this property directly. Instead use [[CancellationDetails.errorDetails]].
     * @member PropertyId.SpeechServiceResponse_JsonErrorDetails
     */ PropertyId[PropertyId["SpeechServiceResponse_JsonErrorDetails"] = 24] = "SpeechServiceResponse_JsonErrorDetails";
    /**
     * The cancellation reason. Currently unused.
     * @member PropertyId.CancellationDetails_Reason
     */ PropertyId[PropertyId["CancellationDetails_Reason"] = 25] = "CancellationDetails_Reason";
    /**
     * The cancellation text. Currently unused.
     * @member PropertyId.CancellationDetails_ReasonText
     */ PropertyId[PropertyId["CancellationDetails_ReasonText"] = 26] = "CancellationDetails_ReasonText";
    /**
     * The Cancellation detailed text. Currently unused.
     * @member PropertyId.CancellationDetails_ReasonDetailedText
     */ PropertyId[PropertyId["CancellationDetails_ReasonDetailedText"] = 27] = "CancellationDetails_ReasonDetailedText";
    /**
     * The Language Understanding Service response output (in JSON format). Available via [[IntentRecognitionResult]]
     * @member PropertyId.LanguageUnderstandingServiceResponse_JsonResult
     */ PropertyId[PropertyId["LanguageUnderstandingServiceResponse_JsonResult"] = 28] = "LanguageUnderstandingServiceResponse_JsonResult";
    /**
     * The URL string built from speech configuration.
     * This property is intended to be read-only. The SDK is using it internally.
     * NOTE: Added in version 1.7.0.
     */ PropertyId[PropertyId["SpeechServiceConnection_Url"] = 29] = "SpeechServiceConnection_Url";
    /**
     * The initial silence timeout value (in milliseconds) used by the service.
     * Added in version 1.7.0
     */ PropertyId[PropertyId["SpeechServiceConnection_InitialSilenceTimeoutMs"] = 30] = "SpeechServiceConnection_InitialSilenceTimeoutMs";
    /**
     * The end silence timeout value (in milliseconds) used by the service.
     * Added in version 1.7.0
     */ PropertyId[PropertyId["SpeechServiceConnection_EndSilenceTimeoutMs"] = 31] = "SpeechServiceConnection_EndSilenceTimeoutMs";
    /**
     * A boolean value specifying whether audio logging is enabled in the service or not.
     * Added in version 1.7.0
     */ PropertyId[PropertyId["SpeechServiceConnection_EnableAudioLogging"] = 32] = "SpeechServiceConnection_EnableAudioLogging";
    /**
     * The requested Cognitive Services Speech Service response output profanity setting.
     * Allowed values are "masked", "removed", and "raw".
     * Added in version 1.7.0.
     */ PropertyId[PropertyId["SpeechServiceResponse_ProfanityOption"] = 33] = "SpeechServiceResponse_ProfanityOption";
    /**
     * A string value specifying which post processing option should be used by service.
     * Allowed values are "TrueText".
     * Added in version 1.7.0
     */ PropertyId[PropertyId["SpeechServiceResponse_PostProcessingOption"] = 34] = "SpeechServiceResponse_PostProcessingOption";
    /**
     *  A boolean value specifying whether to include word-level timestamps in the response result.
     * Added in version 1.7.0
     */ PropertyId[PropertyId["SpeechServiceResponse_RequestWordLevelTimestamps"] = 35] = "SpeechServiceResponse_RequestWordLevelTimestamps";
    /**
     * The number of times a word has to be in partial results to be returned.
     * Added in version 1.7.0
     */ PropertyId[PropertyId["SpeechServiceResponse_StablePartialResultThreshold"] = 36] = "SpeechServiceResponse_StablePartialResultThreshold";
    /**
     * A string value specifying the output format option in the response result. Internal use only.
     * Added in version 1.7.0.
     */ PropertyId[PropertyId["SpeechServiceResponse_OutputFormatOption"] = 37] = "SpeechServiceResponse_OutputFormatOption";
    /**
     * A boolean value to request for stabilizing translation partial results by omitting words in the end.
     * Added in version 1.7.0.
     */ PropertyId[PropertyId["SpeechServiceResponse_TranslationRequestStablePartialResult"] = 38] = "SpeechServiceResponse_TranslationRequestStablePartialResult";
    /**
     * Identifier used to connect to the backend service.
     * @member PropertyId.Conversation_ApplicationId
     */ PropertyId[PropertyId["Conversation_ApplicationId"] = 39] = "Conversation_ApplicationId";
    /**
     * Type of dialog backend to connect to.
     * @member PropertyId.Conversation_DialogType
     */ PropertyId[PropertyId["Conversation_DialogType"] = 40] = "Conversation_DialogType";
    /**
     * Silence timeout for listening
     * @member PropertyId.Conversation_Initial_Silence_Timeout
     */ PropertyId[PropertyId["Conversation_Initial_Silence_Timeout"] = 41] = "Conversation_Initial_Silence_Timeout";
    /**
     * From Id to add to speech recognition activities.
     * @member PropertyId.Conversation_From_Id
     */ PropertyId[PropertyId["Conversation_From_Id"] = 42] = "Conversation_From_Id";
    /**
     * ConversationId for the session.
     * @member PropertyId.Conversation_Conversation_Id
     */ PropertyId[PropertyId["Conversation_Conversation_Id"] = 43] = "Conversation_Conversation_Id";
    /**
     * Comma separated list of custom voice deployment ids.
     * @member PropertyId.Conversation_Custom_Voice_Deployment_Ids
     */ PropertyId[PropertyId["Conversation_Custom_Voice_Deployment_Ids"] = 44] = "Conversation_Custom_Voice_Deployment_Ids";
    /**
     * Speech activity template, stamp properties from the template on the activity generated by the service for speech.
     * @member PropertyId.Conversation_Speech_Activity_Template
     * Added in version 1.10.0.
     */ PropertyId[PropertyId["Conversation_Speech_Activity_Template"] = 45] = "Conversation_Speech_Activity_Template";
    /**
     * Enables or disables the receipt of turn status messages as obtained on the turnStatusReceived event.
     * @member PropertyId.Conversation_Request_Bot_Status_Messages
     * Added in version 1.15.0.
     */ PropertyId[PropertyId["Conversation_Request_Bot_Status_Messages"] = 46] = "Conversation_Request_Bot_Status_Messages";
    /**
     * Specifies the connection ID to be provided in the Agent configuration message, e.g. a Direct Line token for
     * channel authentication.
     * Added in version 1.15.1.
     */ PropertyId[PropertyId["Conversation_Agent_Connection_Id"] = 47] = "Conversation_Agent_Connection_Id";
    /**
     * The Cognitive Services Speech Service host (url). Under normal circumstances, you shouldn't have to use this property directly.
     * Instead, use [[SpeechConfig.fromHost]].
     */ PropertyId[PropertyId["SpeechServiceConnection_Host"] = 48] = "SpeechServiceConnection_Host";
    /**
     * Set the host for service calls to the Conversation Translator REST management and websocket calls.
     */ PropertyId[PropertyId["ConversationTranslator_Host"] = 49] = "ConversationTranslator_Host";
    /**
     * Optionally set the the host's display name.
     * Used when joining a conversation.
     */ PropertyId[PropertyId["ConversationTranslator_Name"] = 50] = "ConversationTranslator_Name";
    /**
     * Optionally set a value for the X-CorrelationId request header.
     * Used for troubleshooting errors in the server logs. It should be a valid guid.
     */ PropertyId[PropertyId["ConversationTranslator_CorrelationId"] = 51] = "ConversationTranslator_CorrelationId";
    /**
     * Set the conversation token to be sent to the speech service. This enables the
     * service to service call from the speech service to the Conversation Translator service for relaying
     * recognitions. For internal use.
     */ PropertyId[PropertyId["ConversationTranslator_Token"] = 52] = "ConversationTranslator_Token";
    /**
     * The reference text of the audio for pronunciation evaluation.
     * For this and the following pronunciation assessment parameters, see
     * https://docs.microsoft.com/azure/cognitive-services/speech-service/rest-speech-to-text#pronunciation-assessment-parameters for details.
     * Under normal circumstances, you shouldn't have to use this property directly.
     * Added in version 1.15.0
     */ PropertyId[PropertyId["PronunciationAssessment_ReferenceText"] = 53] = "PronunciationAssessment_ReferenceText";
    /**
     * The point system for pronunciation score calibration (FivePoint or HundredMark).
     * Under normal circumstances, you shouldn't have to use this property directly.
     * Added in version 1.15.0
     */ PropertyId[PropertyId["PronunciationAssessment_GradingSystem"] = 54] = "PronunciationAssessment_GradingSystem";
    /**
     * The pronunciation evaluation granularity (Phoneme, Word, or FullText).
     * Under normal circumstances, you shouldn't have to use this property directly.
     * Added in version 1.15.0
     */ PropertyId[PropertyId["PronunciationAssessment_Granularity"] = 55] = "PronunciationAssessment_Granularity";
    /**
     * Defines if enable miscue calculation.
     * With this enabled, the pronounced words will be compared to the reference text,
     * and will be marked with omission/insertion based on the comparison. The default setting is False.
     * Under normal circumstances, you shouldn't have to use this property directly.
     * Added in version 1.15.0
     */ PropertyId[PropertyId["PronunciationAssessment_EnableMiscue"] = 56] = "PronunciationAssessment_EnableMiscue";
    /**
     * The json string of pronunciation assessment parameters
     * Under normal circumstances, you shouldn't have to use this property directly.
     * Added in version 1.15.0
     */ PropertyId[PropertyId["PronunciationAssessment_Json"] = 57] = "PronunciationAssessment_Json";
    /**
     * Pronunciation assessment parameters.
     * This property is intended to be read-only. The SDK is using it internally.
     * Added in version 1.15.0
     */ PropertyId[PropertyId["PronunciationAssessment_Params"] = 58] = "PronunciationAssessment_Params";
})($07316bd7c00b1607$var$PropertyId = module.exports.PropertyId || (module.exports.PropertyId = {}));

});

parcelRequire.register("cSAoc", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
var $9606c15392f176e4$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $9606c15392f176e4$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Recognizer = void 0;

var $9MAMI = parcelRequire("9MAMI");

var $7srwU = parcelRequire("7srwU");

var $evvAW = parcelRequire("evvAW");

var $iQDnw = parcelRequire("iQDnw");
/**
 * Defines the base class Recognizer which mainly contains common event handlers.
 * @class Recognizer
 */ var $9606c15392f176e4$var$Recognizer = /** @class */ function() {
    /**
     * Creates and initializes an instance of a Recognizer
     * @constructor
     * @param {AudioConfig} audioInput - An optional audio input stream associated with the recognizer
     */ function Recognizer(audioConfig, properties, connectionFactory) {
        this.audioConfig = audioConfig !== undefined ? audioConfig : $iQDnw.AudioConfig.fromDefaultMicrophoneInput();
        this.privDisposed = false;
        this.privProperties = properties.clone();
        this.privConnectionFactory = connectionFactory;
        this.implCommonRecognizerSetup();
    }
    /**
     * Dispose of associated resources.
     * @member Recognizer.prototype.close
     * @function
     * @public
     */ Recognizer.prototype.close = function(cb, errorCb) {
        $evvAW.Contracts.throwIfDisposed(this.privDisposed);
        $7srwU.marshalPromiseToCallbacks(this.dispose(true), cb, errorCb);
    };
    Object.defineProperty(Recognizer.prototype, "internalData", {
        /**
         * @Internal
         * Internal data member to support fromRecognizer* pattern methods on other classes.
         * Do not use externally, object returned will change without warning or notice.
         */ get: function() {
            return this.privReco;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * This method performs cleanup of resources.
     * The Boolean parameter disposing indicates whether the method is called
     * from Dispose (if disposing is true) or from the finalizer (if disposing is false).
     * Derived classes should override this method to dispose resource if needed.
     * @member Recognizer.prototype.dispose
     * @function
     * @public
     * @param {boolean} disposing - Flag to request disposal.
     */ Recognizer.prototype.dispose = function(disposing) {
        return $9606c15392f176e4$var$__awaiter(this, void 0, void 0, function() {
            return $9606c15392f176e4$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (this.privDisposed) return [
                            2 /*return*/ 
                        ];
                        this.privDisposed = true;
                        if (!disposing) return [
                            3 /*break*/ ,
                            3
                        ];
                        if (!this.privReco) return [
                            3 /*break*/ ,
                            3
                        ];
                        return [
                            4 /*yield*/ ,
                            this.privReco.audioSource.turnOff()
                        ];
                    case 1:
                        _a.sent();
                        return [
                            4 /*yield*/ ,
                            this.privReco.dispose()
                        ];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    Object.defineProperty(Recognizer, "telemetryEnabled", {
        /**
         * This method returns the current state of the telemetry setting.
         * @member Recognizer.prototype.telemetryEnabled
         * @function
         * @public
         * @returns true if the telemetry is enabled, false otherwise.
         */ get: function() {
            return $9MAMI.ServiceRecognizerBase.telemetryDataEnabled;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * This method globally enables or disables telemetry.
     * @member Recognizer.prototype.enableTelemetry
     * @function
     * @public
     * @param enabled - Global setting for telemetry collection.
     * If set to true, telemetry information like microphone errors,
     * recognition errors are collected and sent to Microsoft.
     * If set to false, no telemetry is sent to Microsoft.
     */ /* tslint:disable:member-ordering */ Recognizer.enableTelemetry = function(enabled) {
        $9MAMI.ServiceRecognizerBase.telemetryDataEnabled = enabled;
    };
    // Does the generic recognizer setup that is common across all recognizer types.
    Recognizer.prototype.implCommonRecognizerSetup = function() {
        var osPlatform = typeof window !== "undefined" ? "Browser" : "Node";
        var osName = "unknown";
        var osVersion = "unknown";
        if (typeof navigator !== "undefined") {
            osPlatform = osPlatform + "/" + navigator.platform;
            osName = navigator.userAgent;
            osVersion = navigator.appVersion;
        }
        var recognizerConfig = this.createRecognizerConfig(new $9MAMI.SpeechServiceConfig(new $9MAMI.Context(new $9MAMI.OS(osPlatform, osName, osVersion))));
        this.privReco = this.createServiceRecognizer(Recognizer.getAuthFromProperties(this.privProperties), this.privConnectionFactory, this.audioConfig, recognizerConfig);
    };
    Recognizer.prototype.recognizeOnceAsyncImpl = function(recognitionMode) {
        return $9606c15392f176e4$var$__awaiter(this, void 0, void 0, function() {
            var ret, result;
            return $9606c15392f176e4$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        $evvAW.Contracts.throwIfDisposed(this.privDisposed);
                        ret = new $7srwU.Deferred();
                        return [
                            4 /*yield*/ ,
                            this.implRecognizerStop()
                        ];
                    case 1:
                        _a.sent();
                        return [
                            4 /*yield*/ ,
                            this.privReco.recognize(recognitionMode, ret.resolve, ret.reject)
                        ];
                    case 2:
                        _a.sent();
                        return [
                            4 /*yield*/ ,
                            ret.promise
                        ];
                    case 3:
                        result = _a.sent();
                        return [
                            4 /*yield*/ ,
                            this.implRecognizerStop()
                        ];
                    case 4:
                        _a.sent();
                        return [
                            2 /*return*/ ,
                            result
                        ];
                }
            });
        });
    };
    Recognizer.prototype.startContinuousRecognitionAsyncImpl = function(recognitionMode) {
        return $9606c15392f176e4$var$__awaiter(this, void 0, void 0, function() {
            return $9606c15392f176e4$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        $evvAW.Contracts.throwIfDisposed(this.privDisposed);
                        return [
                            4 /*yield*/ ,
                            this.implRecognizerStop()
                        ];
                    case 1:
                        _a.sent();
                        return [
                            4 /*yield*/ ,
                            this.privReco.recognize(recognitionMode, undefined, undefined)
                        ];
                    case 2:
                        _a.sent();
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    Recognizer.prototype.stopContinuousRecognitionAsyncImpl = function() {
        return $9606c15392f176e4$var$__awaiter(this, void 0, void 0, function() {
            return $9606c15392f176e4$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        $evvAW.Contracts.throwIfDisposed(this.privDisposed);
                        return [
                            4 /*yield*/ ,
                            this.implRecognizerStop()
                        ];
                    case 1:
                        _a.sent();
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    Recognizer.prototype.implRecognizerStop = function() {
        return $9606c15392f176e4$var$__awaiter(this, void 0, void 0, function() {
            return $9606c15392f176e4$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!this.privReco) return [
                            3 /*break*/ ,
                            2
                        ];
                        return [
                            4 /*yield*/ ,
                            this.privReco.stopRecognizing()
                        ];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    Recognizer.getAuthFromProperties = function(properties) {
        var subscriptionKey = properties.getProperty($iQDnw.PropertyId.SpeechServiceConnection_Key, undefined);
        var authentication = subscriptionKey && subscriptionKey !== "" ? new $9MAMI.CognitiveSubscriptionKeyAuthentication(subscriptionKey) : new $9MAMI.CognitiveTokenAuthentication(function(authFetchEventId) {
            var authorizationToken = properties.getProperty($iQDnw.PropertyId.SpeechServiceAuthorization_Token, undefined);
            return Promise.resolve(authorizationToken);
        }, function(authFetchEventId) {
            var authorizationToken = properties.getProperty($iQDnw.PropertyId.SpeechServiceAuthorization_Token, undefined);
            return Promise.resolve(authorizationToken);
        });
        return authentication;
    };
    return Recognizer;
}();
module.exports.Recognizer = $9606c15392f176e4$var$Recognizer;

});

parcelRequire.register("9jqYC", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
var $6c7ad068f21a9c9e$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $6c7ad068f21a9c9e$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $6c7ad068f21a9c9e$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SpeechRecognizer = void 0;

var $9MAMI = parcelRequire("9MAMI");

var $7srwU = parcelRequire("7srwU");

var $evvAW = parcelRequire("evvAW");

var $iQDnw = parcelRequire("iQDnw");
/**
 * Performs speech recognition from microphone, file, or other audio input streams, and gets transcribed text as result.
 * @class SpeechRecognizer
 */ var $6c7ad068f21a9c9e$var$SpeechRecognizer = /** @class */ function(_super) {
    $6c7ad068f21a9c9e$var$__extends(SpeechRecognizer, _super);
    /**
     * SpeechRecognizer constructor.
     * @constructor
     * @param {SpeechConfig} speechConfig - an set of initial properties for this recognizer
     * @param {AudioConfig} audioConfig - An optional audio configuration associated with the recognizer
     */ function SpeechRecognizer(speechConfig, audioConfig) {
        var _this = this;
        var speechConfigImpl = speechConfig;
        $evvAW.Contracts.throwIfNull(speechConfigImpl, "speechConfig");
        $evvAW.Contracts.throwIfNullOrWhitespace(speechConfigImpl.properties.getProperty($iQDnw.PropertyId.SpeechServiceConnection_RecoLanguage), $iQDnw.PropertyId[$iQDnw.PropertyId.SpeechServiceConnection_RecoLanguage]);
        _this = _super.call(this, audioConfig, speechConfigImpl.properties, new $9MAMI.SpeechConnectionFactory()) || this;
        _this.privDisposedRecognizer = false;
        return _this;
    }
    /**
     * SpeechRecognizer constructor.
     * @constructor
     * @param {SpeechConfig} speechConfig - an set of initial properties for this recognizer
     * @param {AutoDetectSourceLanguageConfig} autoDetectSourceLanguageConfig - An source language detection configuration associated with the recognizer
     * @param {AudioConfig} audioConfig - An optional audio configuration associated with the recognizer
     */ SpeechRecognizer.FromConfig = function(speechConfig, autoDetectSourceLanguageConfig, audioConfig) {
        var speechConfigImpl = speechConfig;
        autoDetectSourceLanguageConfig.properties.mergeTo(speechConfigImpl.properties);
        var recognizer = new SpeechRecognizer(speechConfig, audioConfig);
        return recognizer;
    };
    Object.defineProperty(SpeechRecognizer.prototype, "endpointId", {
        /**
         * Gets the endpoint id of a customized speech model that is used for speech recognition.
         * @member SpeechRecognizer.prototype.endpointId
         * @function
         * @public
         * @returns {string} the endpoint id of a customized speech model that is used for speech recognition.
         */ get: function() {
            $evvAW.Contracts.throwIfDisposed(this.privDisposedRecognizer);
            return this.properties.getProperty($iQDnw.PropertyId.SpeechServiceConnection_EndpointId, "00000000-0000-0000-0000-000000000000");
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SpeechRecognizer.prototype, "authorizationToken", {
        /**
         * Gets the authorization token used to communicate with the service.
         * @member SpeechRecognizer.prototype.authorizationToken
         * @function
         * @public
         * @returns {string} Authorization token.
         */ get: function() {
            return this.properties.getProperty($iQDnw.PropertyId.SpeechServiceAuthorization_Token);
        },
        /**
         * Gets/Sets the authorization token used to communicate with the service.
         * @member SpeechRecognizer.prototype.authorizationToken
         * @function
         * @public
         * @param {string} token - Authorization token.
         */ set: function(token) {
            $evvAW.Contracts.throwIfNullOrWhitespace(token, "token");
            this.properties.setProperty($iQDnw.PropertyId.SpeechServiceAuthorization_Token, token);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SpeechRecognizer.prototype, "speechRecognitionLanguage", {
        /**
         * Gets the spoken language of recognition.
         * @member SpeechRecognizer.prototype.speechRecognitionLanguage
         * @function
         * @public
         * @returns {string} The spoken language of recognition.
         */ get: function() {
            $evvAW.Contracts.throwIfDisposed(this.privDisposedRecognizer);
            return this.properties.getProperty($iQDnw.PropertyId.SpeechServiceConnection_RecoLanguage);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SpeechRecognizer.prototype, "outputFormat", {
        /**
         * Gets the output format of recognition.
         * @member SpeechRecognizer.prototype.outputFormat
         * @function
         * @public
         * @returns {OutputFormat} The output format of recognition.
         */ get: function() {
            $evvAW.Contracts.throwIfDisposed(this.privDisposedRecognizer);
            if (this.properties.getProperty($9MAMI.OutputFormatPropertyName, $iQDnw.OutputFormat[$iQDnw.OutputFormat.Simple]) === $iQDnw.OutputFormat[$iQDnw.OutputFormat.Simple]) return $iQDnw.OutputFormat.Simple;
            else return $iQDnw.OutputFormat.Detailed;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SpeechRecognizer.prototype, "properties", {
        /**
         * The collection of properties and their values defined for this SpeechRecognizer.
         * @member SpeechRecognizer.prototype.properties
         * @function
         * @public
         * @returns {PropertyCollection} The collection of properties and their values defined for this SpeechRecognizer.
         */ get: function() {
            return this.privProperties;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Starts speech recognition, and stops after the first utterance is recognized.
     * The task returns the recognition text as result.
     * Note: RecognizeOnceAsync() returns when the first utterance has been recognized,
     *       so it is suitable only for single shot recognition
     *       like command or query. For long-running recognition, use StartContinuousRecognitionAsync() instead.
     * @member SpeechRecognizer.prototype.recognizeOnceAsync
     * @function
     * @public
     * @param cb - Callback that received the SpeechRecognitionResult.
     * @param err - Callback invoked in case of an error.
     */ SpeechRecognizer.prototype.recognizeOnceAsync = function(cb, err) {
        $7srwU.marshalPromiseToCallbacks(this.recognizeOnceAsyncImpl($9MAMI.RecognitionMode.Interactive), cb, err);
    };
    /**
     * Starts speech recognition, until stopContinuousRecognitionAsync() is called.
     * User must subscribe to events to receive recognition results.
     * @member SpeechRecognizer.prototype.startContinuousRecognitionAsync
     * @function
     * @public
     * @param cb - Callback invoked once the recognition has started.
     * @param err - Callback invoked in case of an error.
     */ SpeechRecognizer.prototype.startContinuousRecognitionAsync = function(cb, err) {
        $7srwU.marshalPromiseToCallbacks(this.startContinuousRecognitionAsyncImpl($9MAMI.RecognitionMode.Conversation), cb, err);
    };
    /**
     * Stops continuous speech recognition.
     * @member SpeechRecognizer.prototype.stopContinuousRecognitionAsync
     * @function
     * @public
     * @param cb - Callback invoked once the recognition has stopped.
     * @param err - Callback invoked in case of an error.
     */ SpeechRecognizer.prototype.stopContinuousRecognitionAsync = function(cb, err) {
        $7srwU.marshalPromiseToCallbacks(this.stopContinuousRecognitionAsyncImpl(), cb, err);
    };
    /**
     * Starts speech recognition with keyword spotting, until
     * stopKeywordRecognitionAsync() is called.
     * User must subscribe to events to receive recognition results.
     * Note: Key word spotting functionality is only available on the
     *      Speech Devices SDK. This functionality is currently not included in the SDK itself.
     * @member SpeechRecognizer.prototype.startKeywordRecognitionAsync
     * @function
     * @public
     * @param {KeywordRecognitionModel} model The keyword recognition model that
     *        specifies the keyword to be recognized.
     * @param cb - Callback invoked once the recognition has started.
     * @param err - Callback invoked in case of an error.
     */ SpeechRecognizer.prototype.startKeywordRecognitionAsync = function(model, cb, err) {
        $evvAW.Contracts.throwIfNull(model, "model");
        if (!!err) err("Not yet implemented.");
    };
    /**
     * Stops continuous speech recognition.
     * Note: Key word spotting functionality is only available on the
     *       Speech Devices SDK. This functionality is currently not included in the SDK itself.
     * @member SpeechRecognizer.prototype.stopKeywordRecognitionAsync
     * @function
     * @public
     * @param cb - Callback invoked once the recognition has stopped.
     * @param err - Callback invoked in case of an error.
     */ SpeechRecognizer.prototype.stopKeywordRecognitionAsync = function(cb, err) {
        if (!!cb) cb();
    };
    /**
     * closes all external resources held by an instance of this class.
     * @member SpeechRecognizer.prototype.close
     * @function
     * @public
     */ SpeechRecognizer.prototype.close = function(cb, errorCb) {
        $evvAW.Contracts.throwIfDisposed(this.privDisposedRecognizer);
        $7srwU.marshalPromiseToCallbacks(this.dispose(true), cb, errorCb);
    };
    /**
     * Disposes any resources held by the object.
     * @member SpeechRecognizer.prototype.dispose
     * @function
     * @public
     * @param {boolean} disposing - true if disposing the object.
     */ SpeechRecognizer.prototype.dispose = function(disposing) {
        return $6c7ad068f21a9c9e$var$__awaiter(this, void 0, void 0, function() {
            return $6c7ad068f21a9c9e$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (this.privDisposedRecognizer) return [
                            2 /*return*/ 
                        ];
                        if (!disposing) return [
                            3 /*break*/ ,
                            2
                        ];
                        this.privDisposedRecognizer = true;
                        return [
                            4 /*yield*/ ,
                            this.implRecognizerStop()
                        ];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        return [
                            4 /*yield*/ ,
                            _super.prototype.dispose.call(this, disposing)
                        ];
                    case 3:
                        _a.sent();
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    SpeechRecognizer.prototype.createRecognizerConfig = function(speechConfig) {
        return new $9MAMI.RecognizerConfig(speechConfig, this.properties);
    };
    SpeechRecognizer.prototype.createServiceRecognizer = function(authentication, connectionFactory, audioConfig, recognizerConfig) {
        var configImpl = audioConfig;
        return new $9MAMI.SpeechServiceRecognizer(authentication, connectionFactory, configImpl, recognizerConfig, this);
    };
    return SpeechRecognizer;
}($iQDnw.Recognizer);
module.exports.SpeechRecognizer = $6c7ad068f21a9c9e$var$SpeechRecognizer;

});

parcelRequire.register("dSRBv", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
var $a1b9e625f35ac870$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $a1b9e625f35ac870$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $a1b9e625f35ac870$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.IntentRecognizer = void 0;

var $9MAMI = parcelRequire("9MAMI");

var $7srwU = parcelRequire("7srwU");

var $evvAW = parcelRequire("evvAW");

var $iQDnw = parcelRequire("iQDnw");
/**
 * Intent recognizer.
 * @class
 */ var $a1b9e625f35ac870$var$IntentRecognizer = /** @class */ function(_super) {
    $a1b9e625f35ac870$var$__extends(IntentRecognizer, _super);
    /**
     * Initializes an instance of the IntentRecognizer.
     * @constructor
     * @param {SpeechConfig} speechConfig - The set of configuration properties.
     * @param {AudioConfig} audioConfig - An optional audio input config associated with the recognizer
     */ function IntentRecognizer(speechConfig, audioConfig) {
        var _this = this;
        $evvAW.Contracts.throwIfNullOrUndefined(speechConfig, "speechConfig");
        var configImpl = speechConfig;
        $evvAW.Contracts.throwIfNullOrUndefined(configImpl, "speechConfig");
        _this = _super.call(this, audioConfig, configImpl.properties, new $9MAMI.IntentConnectionFactory()) || this;
        _this.privAddedIntents = [];
        _this.privAddedLmIntents = {};
        _this.privDisposedIntentRecognizer = false;
        _this.privProperties = configImpl.properties;
        $evvAW.Contracts.throwIfNullOrWhitespace(_this.properties.getProperty($iQDnw.PropertyId.SpeechServiceConnection_RecoLanguage), $iQDnw.PropertyId[$iQDnw.PropertyId.SpeechServiceConnection_RecoLanguage]);
        return _this;
    }
    Object.defineProperty(IntentRecognizer.prototype, "speechRecognitionLanguage", {
        /**
         * Gets the spoken language of recognition.
         * @member IntentRecognizer.prototype.speechRecognitionLanguage
         * @function
         * @public
         * @returns {string} the spoken language of recognition.
         */ get: function() {
            $evvAW.Contracts.throwIfDisposed(this.privDisposedIntentRecognizer);
            return this.properties.getProperty($iQDnw.PropertyId.SpeechServiceConnection_RecoLanguage);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IntentRecognizer.prototype, "authorizationToken", {
        /**
         * Gets the authorization token used to communicate with the service.
         * @member IntentRecognizer.prototype.authorizationToken
         * @function
         * @public
         * @returns {string} Authorization token.
         */ get: function() {
            return this.properties.getProperty($iQDnw.PropertyId.SpeechServiceAuthorization_Token);
        },
        /**
         * Gets/Sets the authorization token used to communicate with the service.
         * Note: Please use a token derived from your LanguageUnderstanding subscription key for the Intent recognizer.
         * @member IntentRecognizer.prototype.authorizationToken
         * @function
         * @public
         * @param {string} value - Authorization token.
         */ set: function(value) {
            this.properties.setProperty($iQDnw.PropertyId.SpeechServiceAuthorization_Token, value);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IntentRecognizer.prototype, "properties", {
        /**
         * The collection of properties and their values defined for this IntentRecognizer.
         * @member IntentRecognizer.prototype.properties
         * @function
         * @public
         * @returns {PropertyCollection} The collection of properties and their
         *          values defined for this IntentRecognizer.
         */ get: function() {
            return this.privProperties;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Starts intent recognition, and stops after the first utterance is recognized.
     * The task returns the recognition text and intent as result.
     * Note: RecognizeOnceAsync() returns when the first utterance has been recognized,
     *       so it is suitable only for single shot recognition like command or query.
     *       For long-running recognition, use StartContinuousRecognitionAsync() instead.
     * @member IntentRecognizer.prototype.recognizeOnceAsync
     * @function
     * @public
     * @param cb - Callback that received the recognition has finished with an IntentRecognitionResult.
     * @param err - Callback invoked in case of an error.
     */ IntentRecognizer.prototype.recognizeOnceAsync = function(cb, err) {
        $evvAW.Contracts.throwIfDisposed(this.privDisposedIntentRecognizer);
        if (Object.keys(this.privAddedLmIntents).length !== 0 || undefined !== this.privUmbrellaIntent) {
            var context = this.buildSpeechContext();
            this.privReco.speechContext.setSection("intent", context.Intent);
            this.privReco.dynamicGrammar.addReferenceGrammar(context.ReferenceGrammars);
            var intentReco = this.privReco;
            intentReco.setIntents(this.privAddedLmIntents, this.privUmbrellaIntent);
        }
        $7srwU.marshalPromiseToCallbacks(this.recognizeOnceAsyncImpl($9MAMI.RecognitionMode.Interactive), cb, err);
    };
    /**
     * Starts speech recognition, until stopContinuousRecognitionAsync() is called.
     * User must subscribe to events to receive recognition results.
     * @member IntentRecognizer.prototype.startContinuousRecognitionAsync
     * @function
     * @public
     * @param cb - Callback invoked once the recognition has started.
     * @param err - Callback invoked in case of an error.
     */ IntentRecognizer.prototype.startContinuousRecognitionAsync = function(cb, err) {
        if (Object.keys(this.privAddedLmIntents).length !== 0 || undefined !== this.privUmbrellaIntent) {
            var context = this.buildSpeechContext();
            this.privReco.speechContext.setSection("intent", context.Intent);
            this.privReco.dynamicGrammar.addReferenceGrammar(context.ReferenceGrammars);
            var intentReco = this.privReco;
            intentReco.setIntents(this.privAddedLmIntents, this.privUmbrellaIntent);
        }
        $7srwU.marshalPromiseToCallbacks(this.startContinuousRecognitionAsyncImpl($9MAMI.RecognitionMode.Conversation), cb, err);
    };
    /**
     * Stops continuous intent recognition.
     * @member IntentRecognizer.prototype.stopContinuousRecognitionAsync
     * @function
     * @public
     * @param cb - Callback invoked once the recognition has stopped.
     * @param err - Callback invoked in case of an error.
     */ IntentRecognizer.prototype.stopContinuousRecognitionAsync = function(cb, err) {
        $7srwU.marshalPromiseToCallbacks(this.stopContinuousRecognitionAsyncImpl(), cb, err);
    };
    /**
     * Starts speech recognition with keyword spotting, until stopKeywordRecognitionAsync() is called.
     * User must subscribe to events to receive recognition results.
     * Note: Key word spotting functionality is only available on the Speech Devices SDK.
     *       This functionality is currently not included in the SDK itself.
     * @member IntentRecognizer.prototype.startKeywordRecognitionAsync
     * @function
     * @public
     * @param {KeywordRecognitionModel} model - The keyword recognition model that specifies the keyword to be recognized.
     * @param cb - Callback invoked once the recognition has started.
     * @param err - Callback invoked in case of an error.
     */ IntentRecognizer.prototype.startKeywordRecognitionAsync = function(model, cb, err) {
        $evvAW.Contracts.throwIfNull(model, "model");
        if (!!err) err("Not yet implemented.");
    };
    /**
     * Stops continuous speech recognition.
     * Note: Key word spotting functionality is only available on the Speech Devices SDK.
     *       This functionality is currently not included in the SDK itself.
     * @member IntentRecognizer.prototype.stopKeywordRecognitionAsync
     * @function
     * @public
     * @param cb - Callback invoked once the recognition has stopped.
     * @param err - Callback invoked in case of an error.
     */ IntentRecognizer.prototype.stopKeywordRecognitionAsync = function(cb, err) {
        if (!!cb) cb();
    };
    /**
     * Adds a phrase that should be recognized as intent.
     * @member IntentRecognizer.prototype.addIntent
     * @function
     * @public
     * @param {string} intentId - A String that represents the identifier of the intent to be recognized.
     * @param {string} phrase - A String that specifies the phrase representing the intent.
     */ IntentRecognizer.prototype.addIntent = function(simplePhrase, intentId) {
        $evvAW.Contracts.throwIfDisposed(this.privDisposedIntentRecognizer);
        $evvAW.Contracts.throwIfNullOrWhitespace(intentId, "intentId");
        $evvAW.Contracts.throwIfNullOrWhitespace(simplePhrase, "simplePhrase");
        this.privAddedIntents.push([
            intentId,
            simplePhrase
        ]);
    };
    /**
     * Adds an intent from Language Understanding service for recognition.
     * @member IntentRecognizer.prototype.addIntentWithLanguageModel
     * @function
     * @public
     * @param {string} intentId - A String that represents the identifier of the intent
     *        to be recognized. Ignored if intentName is empty.
     * @param {string} model - The intent model from Language Understanding service.
     * @param {string} intentName - The intent name defined in the intent model. If it
     *        is empty, all intent names defined in the model will be added.
     */ IntentRecognizer.prototype.addIntentWithLanguageModel = function(intentId, model, intentName) {
        $evvAW.Contracts.throwIfDisposed(this.privDisposedIntentRecognizer);
        $evvAW.Contracts.throwIfNullOrWhitespace(intentId, "intentId");
        $evvAW.Contracts.throwIfNull(model, "model");
        var modelImpl = model;
        $evvAW.Contracts.throwIfNullOrWhitespace(modelImpl.appId, "model.appId");
        this.privAddedLmIntents[intentId] = new $9MAMI.AddedLmIntent(modelImpl, intentName);
    };
    /**
     * @summary Adds all intents from the specified Language Understanding Model.
     * @member IntentRecognizer.prototype.addAllIntents
     * @function
     * @public
     * @function
     * @public
     * @param {LanguageUnderstandingModel} model - The language understanding model containing the intents.
     * @param {string} intentId - A custom id String to be returned in the IntentRecognitionResult's getIntentId() method.
     */ IntentRecognizer.prototype.addAllIntents = function(model, intentId) {
        $evvAW.Contracts.throwIfNull(model, "model");
        var modelImpl = model;
        $evvAW.Contracts.throwIfNullOrWhitespace(modelImpl.appId, "model.appId");
        this.privUmbrellaIntent = new $9MAMI.AddedLmIntent(modelImpl, intentId);
    };
    /**
     * closes all external resources held by an instance of this class.
     * @member IntentRecognizer.prototype.close
     * @function
     * @public
     */ IntentRecognizer.prototype.close = function(cb, errorCb) {
        $evvAW.Contracts.throwIfDisposed(this.privDisposedIntentRecognizer);
        $7srwU.marshalPromiseToCallbacks(this.dispose(true), cb, errorCb);
    };
    IntentRecognizer.prototype.createRecognizerConfig = function(speechConfig) {
        return new $9MAMI.RecognizerConfig(speechConfig, this.properties);
    };
    IntentRecognizer.prototype.createServiceRecognizer = function(authentication, connectionFactory, audioConfig, recognizerConfig) {
        var audioImpl = audioConfig;
        return new $9MAMI.IntentServiceRecognizer(authentication, connectionFactory, audioImpl, recognizerConfig, this);
    };
    IntentRecognizer.prototype.dispose = function(disposing) {
        return $a1b9e625f35ac870$var$__awaiter(this, void 0, void 0, function() {
            return $a1b9e625f35ac870$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (this.privDisposedIntentRecognizer) return [
                            2 /*return*/ 
                        ];
                        if (!disposing) return [
                            3 /*break*/ ,
                            2
                        ];
                        this.privDisposedIntentRecognizer = true;
                        return [
                            4 /*yield*/ ,
                            _super.prototype.dispose.call(this, disposing)
                        ];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    IntentRecognizer.prototype.buildSpeechContext = function() {
        var appId;
        var region;
        var subscriptionKey;
        var refGrammers = [];
        if (undefined !== this.privUmbrellaIntent) {
            appId = this.privUmbrellaIntent.modelImpl.appId;
            region = this.privUmbrellaIntent.modelImpl.region;
            subscriptionKey = this.privUmbrellaIntent.modelImpl.subscriptionKey;
        }
        // Build the reference grammer array.
        for(var _i = 0, _a = Object.keys(this.privAddedLmIntents); _i < _a.length; _i++){
            var intentId = _a[_i];
            var addedLmIntent = this.privAddedLmIntents[intentId];
            // validate all the same model, region, and key...
            if (appId === undefined) appId = addedLmIntent.modelImpl.appId;
            else {
                if (appId !== addedLmIntent.modelImpl.appId) throw new Error("Intents must all be from the same LUIS model");
            }
            if (region === undefined) region = addedLmIntent.modelImpl.region;
            else {
                if (region !== addedLmIntent.modelImpl.region) throw new Error("Intents must all be from the same LUIS model in a single region");
            }
            if (subscriptionKey === undefined) subscriptionKey = addedLmIntent.modelImpl.subscriptionKey;
            else {
                if (subscriptionKey !== addedLmIntent.modelImpl.subscriptionKey) throw new Error("Intents must all use the same subscription key");
            }
            var grammer = "luis/" + appId + "-PRODUCTION#" + intentId;
            refGrammers.push(grammer);
        }
        return {
            Intent: {
                id: appId,
                key: subscriptionKey === undefined ? this.privProperties.getProperty($iQDnw.PropertyId[$iQDnw.PropertyId.SpeechServiceConnection_Key]) : subscriptionKey,
                provider: "LUIS"
            },
            ReferenceGrammars: undefined === this.privUmbrellaIntent ? refGrammers : [
                "luis/" + appId + "-PRODUCTION"
            ]
        };
    };
    return IntentRecognizer;
}($iQDnw.Recognizer);
module.exports.IntentRecognizer = $a1b9e625f35ac870$var$IntentRecognizer;

});

parcelRequire.register("ft2Zs", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.VoiceProfileType = void 0;
/**
 * Output format
 * @class VoiceProfileType
 */ var $b42be23fdce286cc$var$VoiceProfileType;
(function(VoiceProfileType) {
    /**
     * Text independent speaker identification
     * @member VoiceProfileType.TextIndependentIdentification
     */ VoiceProfileType[VoiceProfileType["TextIndependentIdentification"] = 0] = "TextIndependentIdentification";
    /**
     * Text dependent speaker verification
     * @member VoiceProfileType.TextDependentVerification
     */ VoiceProfileType[VoiceProfileType["TextDependentVerification"] = 1] = "TextDependentVerification";
    /**
     * Text independent speaker verification
     * @member VoiceProfileType.TextIndependentVerification
     */ VoiceProfileType[VoiceProfileType["TextIndependentVerification"] = 2] = "TextIndependentVerification";
})($b42be23fdce286cc$var$VoiceProfileType = module.exports.VoiceProfileType || (module.exports.VoiceProfileType = {}));

});

parcelRequire.register("dAXAT", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
var $9e5cdd4bcf0b5cfb$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $9e5cdd4bcf0b5cfb$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $9e5cdd4bcf0b5cfb$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TranslationRecognizer = void 0;

var $9MAMI = parcelRequire("9MAMI");

var $7srwU = parcelRequire("7srwU");

var $evvAW = parcelRequire("evvAW");

var $iQDnw = parcelRequire("iQDnw");
/**
 * Translation recognizer
 * @class TranslationRecognizer
 */ var $9e5cdd4bcf0b5cfb$var$TranslationRecognizer = /** @class */ function(_super) {
    $9e5cdd4bcf0b5cfb$var$__extends(TranslationRecognizer, _super);
    /**
     * Initializes an instance of the TranslationRecognizer.
     * @constructor
     * @param {SpeechTranslationConfig} speechConfig - Set of properties to configure this recognizer.
     * @param {AudioConfig} audioConfig - An optional audio config associated with the recognizer
     */ function TranslationRecognizer(speechConfig, audioConfig) {
        var _this = this;
        var configImpl = speechConfig;
        $evvAW.Contracts.throwIfNull(configImpl, "speechConfig");
        _this = _super.call(this, audioConfig, configImpl.properties, new $9MAMI.TranslationConnectionFactory()) || this;
        _this.privDisposedTranslationRecognizer = false;
        _this.privProperties = configImpl.properties.clone();
        if (_this.properties.getProperty($iQDnw.PropertyId.SpeechServiceConnection_TranslationVoice, undefined) !== undefined) $evvAW.Contracts.throwIfNullOrWhitespace(_this.properties.getProperty($iQDnw.PropertyId.SpeechServiceConnection_TranslationVoice), $iQDnw.PropertyId[$iQDnw.PropertyId.SpeechServiceConnection_TranslationVoice]);
        $evvAW.Contracts.throwIfNullOrWhitespace(_this.properties.getProperty($iQDnw.PropertyId.SpeechServiceConnection_TranslationToLanguages), $iQDnw.PropertyId[$iQDnw.PropertyId.SpeechServiceConnection_TranslationToLanguages]);
        $evvAW.Contracts.throwIfNullOrWhitespace(_this.properties.getProperty($iQDnw.PropertyId.SpeechServiceConnection_RecoLanguage), $iQDnw.PropertyId[$iQDnw.PropertyId.SpeechServiceConnection_RecoLanguage]);
        return _this;
    }
    Object.defineProperty(TranslationRecognizer.prototype, "speechRecognitionLanguage", {
        /**
         * Gets the language name that was set when the recognizer was created.
         * @member TranslationRecognizer.prototype.speechRecognitionLanguage
         * @function
         * @public
         * @returns {string} Gets the language name that was set when the recognizer was created.
         */ get: function() {
            $evvAW.Contracts.throwIfDisposed(this.privDisposedTranslationRecognizer);
            return this.properties.getProperty($iQDnw.PropertyId.SpeechServiceConnection_RecoLanguage);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TranslationRecognizer.prototype, "targetLanguages", {
        /**
         * Gets target languages for translation that were set when the recognizer was created.
         * The language is specified in BCP-47 format. The translation will provide translated text for each of language.
         * @member TranslationRecognizer.prototype.targetLanguages
         * @function
         * @public
         * @returns {string[]} Gets target languages for translation that were set when the recognizer was created.
         */ get: function() {
            $evvAW.Contracts.throwIfDisposed(this.privDisposedTranslationRecognizer);
            return this.properties.getProperty($iQDnw.PropertyId.SpeechServiceConnection_TranslationToLanguages).split(",");
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TranslationRecognizer.prototype, "voiceName", {
        /**
         * Gets the name of output voice.
         * @member TranslationRecognizer.prototype.voiceName
         * @function
         * @public
         * @returns {string} the name of output voice.
         */ get: function() {
            $evvAW.Contracts.throwIfDisposed(this.privDisposedTranslationRecognizer);
            return this.properties.getProperty($iQDnw.PropertyId.SpeechServiceConnection_TranslationVoice, undefined);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TranslationRecognizer.prototype, "authorizationToken", {
        /**
         * Gets the authorization token used to communicate with the service.
         * @member TranslationRecognizer.prototype.authorizationToken
         * @function
         * @public
         * @returns {string} Authorization token.
         */ get: function() {
            return this.properties.getProperty($iQDnw.PropertyId.SpeechServiceAuthorization_Token);
        },
        /**
         * Gets/Sets the authorization token used to communicate with the service.
         * @member TranslationRecognizer.prototype.authorizationToken
         * @function
         * @public
         * @param {string} value - Authorization token.
         */ set: function(value) {
            this.properties.setProperty($iQDnw.PropertyId.SpeechServiceAuthorization_Token, value);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TranslationRecognizer.prototype, "properties", {
        /**
         * The collection of properties and their values defined for this TranslationRecognizer.
         * @member TranslationRecognizer.prototype.properties
         * @function
         * @public
         * @returns {PropertyCollection} The collection of properties and their values defined for this TranslationRecognizer.
         */ get: function() {
            return this.privProperties;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Starts recognition and translation, and stops after the first utterance is recognized.
     * The task returns the translation text as result.
     * Note: recognizeOnceAsync returns when the first utterance has been recognized, so it is suitableonly
     *       for single shot recognition like command or query. For long-running recognition,
     *       use startContinuousRecognitionAsync() instead.
     * @member TranslationRecognizer.prototype.recognizeOnceAsync
     * @function
     * @public
     * @param cb - Callback that received the result when the translation has completed.
     * @param err - Callback invoked in case of an error.
     */ TranslationRecognizer.prototype.recognizeOnceAsync = function(cb, err) {
        $evvAW.Contracts.throwIfDisposed(this.privDisposedTranslationRecognizer);
        $7srwU.marshalPromiseToCallbacks(this.recognizeOnceAsyncImpl($9MAMI.RecognitionMode.Conversation), cb, err);
    };
    /**
     * Starts recognition and translation, until stopContinuousRecognitionAsync() is called.
     * User must subscribe to events to receive translation results.
     * @member TranslationRecognizer.prototype.startContinuousRecognitionAsync
     * @function
     * @public
     * @param cb - Callback that received the translation has started.
     * @param err - Callback invoked in case of an error.
     */ TranslationRecognizer.prototype.startContinuousRecognitionAsync = function(cb, err) {
        $7srwU.marshalPromiseToCallbacks(this.startContinuousRecognitionAsyncImpl($9MAMI.RecognitionMode.Conversation), cb, err);
    };
    /**
     * Stops continuous recognition and translation.
     * @member TranslationRecognizer.prototype.stopContinuousRecognitionAsync
     * @function
     * @public
     * @param cb - Callback that received the translation has stopped.
     * @param err - Callback invoked in case of an error.
     */ TranslationRecognizer.prototype.stopContinuousRecognitionAsync = function(cb, err) {
        $7srwU.marshalPromiseToCallbacks(this.stopContinuousRecognitionAsyncImpl(), cb, err);
    };
    /**
     * closes all external resources held by an instance of this class.
     * @member TranslationRecognizer.prototype.close
     * @function
     * @public
     */ TranslationRecognizer.prototype.close = function(cb, errorCb) {
        $evvAW.Contracts.throwIfDisposed(this.privDisposedTranslationRecognizer);
        $7srwU.marshalPromiseToCallbacks(this.dispose(true), cb, errorCb);
    };
    /**
     * handles ConnectionEstablishedEvent for conversation translation scenarios.
     * @member TranslationRecognizer.prototype.onConnection
     * @function
     * @public
     */ /* tslint:disable:no-empty */ TranslationRecognizer.prototype.onConnection = function() {};
    /**
     * handles disconnection events for conversation translation scenarios.
     * @member TranslationRecognizer.prototype.onDisconnection
     * @function
     * @public
     */ /* tslint:disable:no-empty */ TranslationRecognizer.prototype.onDisconnection = function() {
        return $9e5cdd4bcf0b5cfb$var$__awaiter(this, void 0, void 0, function() {
            return $9e5cdd4bcf0b5cfb$var$__generator(this, function(_a) {
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    TranslationRecognizer.prototype.dispose = function(disposing) {
        return $9e5cdd4bcf0b5cfb$var$__awaiter(this, void 0, void 0, function() {
            return $9e5cdd4bcf0b5cfb$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (this.privDisposedTranslationRecognizer) return [
                            2 /*return*/ 
                        ];
                        this.privDisposedTranslationRecognizer = true;
                        if (!disposing) return [
                            3 /*break*/ ,
                            3
                        ];
                        return [
                            4 /*yield*/ ,
                            this.implRecognizerStop()
                        ];
                    case 1:
                        _a.sent();
                        return [
                            4 /*yield*/ ,
                            _super.prototype.dispose.call(this, disposing)
                        ];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    TranslationRecognizer.prototype.createRecognizerConfig = function(speechConfig) {
        return new $9MAMI.RecognizerConfig(speechConfig, this.properties);
    };
    TranslationRecognizer.prototype.createServiceRecognizer = function(authentication, connectionFactory, audioConfig, recognizerConfig) {
        var configImpl = audioConfig;
        return new $9MAMI.TranslationServiceRecognizer(authentication, connectionFactory, configImpl, recognizerConfig, this);
    };
    return TranslationRecognizer;
}($iQDnw.Recognizer);
module.exports.TranslationRecognizer = $9e5cdd4bcf0b5cfb$var$TranslationRecognizer;

});

parcelRequire.register("7QOKD", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Translations = void 0;

var $iQDnw = parcelRequire("iQDnw");
/**
 * Represents collection of parameters and their values.
 * @class Translation
 */ var $5b74c1d92c71b2de$var$Translations = /** @class */ function() {
    function Translations() {
        // Use an PropertyCollection internally, just wrapping it to hide the | enum syntax it has.
        this.privMap = new $iQDnw.PropertyCollection();
    }
    /**
     * Returns the parameter value in type String. The parameter must have the same type as String.
     * Currently only String, int and bool are allowed.
     * If the name is not available, the specified defaultValue is returned.
     * @member Translation.prototype.get
     * @function
     * @public
     * @param {string} key - The parameter name.
     * @param {string} def - The default value which is returned if the parameter is not available in the collection.
     * @returns {string} value of the parameter.
     */ Translations.prototype.get = function(key, def) {
        return this.privMap.getProperty(key, def);
    };
    /**
     * Sets the String value of the parameter specified by name.
     * @member Translation.prototype.set
     * @function
     * @public
     * @param {string} key - The parameter name.
     * @param {string} value - The value of the parameter.
     */ Translations.prototype.set = function(key, value) {
        this.privMap.setProperty(key, value);
    };
    return Translations;
}();
module.exports.Translations = $5b74c1d92c71b2de$var$Translations;

});

parcelRequire.register("d8dph", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.NoMatchReason = void 0;
/**
 * Defines the possible reasons a recognition result might not be recognized.
 * @class NoMatchReason
 */ var $98f66c06f93b7784$var$NoMatchReason;
(function(NoMatchReason) {
    /**
     * Indicates that speech was detected, but not recognized.
     * @member NoMatchReason.NotRecognized
     */ NoMatchReason[NoMatchReason["NotRecognized"] = 0] = "NotRecognized";
    /**
     * Indicates that the start of the audio stream contained only silence,
     * and the service timed out waiting for speech.
     * @member NoMatchReason.InitialSilenceTimeout
     */ NoMatchReason[NoMatchReason["InitialSilenceTimeout"] = 1] = "InitialSilenceTimeout";
    /**
     * Indicates that the start of the audio stream contained only noise,
     * and the service timed out waiting for speech.
     * @member NoMatchReason.InitialBabbleTimeout
     */ NoMatchReason[NoMatchReason["InitialBabbleTimeout"] = 2] = "InitialBabbleTimeout";
})($98f66c06f93b7784$var$NoMatchReason = module.exports.NoMatchReason || (module.exports.NoMatchReason = {}));

});

parcelRequire.register("hXuim", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.NoMatchDetails = void 0;

var $9MAMI = parcelRequire("9MAMI");

var $iQDnw = parcelRequire("iQDnw");
/**
 * Contains detailed information for NoMatch recognition results.
 * @class NoMatchDetails
 */ var $d12f725104395251$var$NoMatchDetails = /** @class */ function() {
    /**
     * Creates and initializes an instance of this class.
     * @constructor
     * @param {NoMatchReason} reason - The no-match reason.
     */ function NoMatchDetails(reason) {
        this.privReason = reason;
    }
    /**
     * Creates an instance of NoMatchDetails object for the NoMatch SpeechRecognitionResults.
     * @member NoMatchDetails.fromResult
     * @function
     * @public
     * @param {SpeechRecognitionResult | IntentRecognitionResult | TranslationRecognitionResult}
     *        result - The recognition result that was not recognized.
     * @returns {NoMatchDetails} The no match details object being created.
     */ NoMatchDetails.fromResult = function(result) {
        var simpleSpeech = $9MAMI.SimpleSpeechPhrase.fromJSON(result.json);
        var reason = $iQDnw.NoMatchReason.NotRecognized;
        switch(simpleSpeech.RecognitionStatus){
            case $9MAMI.RecognitionStatus.BabbleTimeout:
                reason = $iQDnw.NoMatchReason.InitialBabbleTimeout;
                break;
            case $9MAMI.RecognitionStatus.InitialSilenceTimeout:
                reason = $iQDnw.NoMatchReason.InitialSilenceTimeout;
                break;
            default:
                reason = $iQDnw.NoMatchReason.NotRecognized;
                break;
        }
        return new NoMatchDetails(reason);
    };
    Object.defineProperty(NoMatchDetails.prototype, "reason", {
        /**
         * The reason the recognition was canceled.
         * @member NoMatchDetails.prototype.reason
         * @function
         * @public
         * @returns {NoMatchReason} Specifies the reason canceled.
         */ get: function() {
            return this.privReason;
        },
        enumerable: false,
        configurable: true
    });
    return NoMatchDetails;
}();
module.exports.NoMatchDetails = $d12f725104395251$var$NoMatchDetails;

});

parcelRequire.register("eZWf4", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TranslationRecognitionCanceledEventArgs = void 0;
/**
 * Define payload of speech recognition canceled result events.
 * @class TranslationRecognitionCanceledEventArgs
 */ var $aeb3f0e0d7d63fd4$var$TranslationRecognitionCanceledEventArgs = /** @class */ function() {
    /**
     * Creates and initializes an instance of this class.
     * @constructor
     * @param {string} sessionid - The session id.
     * @param {CancellationReason} cancellationReason - The cancellation reason.
     * @param {string} errorDetails - Error details, if provided.
     * @param {TranslationRecognitionResult} result - The result.
     */ function TranslationRecognitionCanceledEventArgs(sessionid, cancellationReason, errorDetails, errorCode, result) {
        this.privCancelReason = cancellationReason;
        this.privErrorDetails = errorDetails;
        this.privResult = result;
        this.privSessionId = sessionid;
        this.privErrorCode = errorCode;
    }
    Object.defineProperty(TranslationRecognitionCanceledEventArgs.prototype, "result", {
        /**
         * Specifies the recognition result.
         * @member TranslationRecognitionCanceledEventArgs.prototype.result
         * @function
         * @public
         * @returns {TranslationRecognitionResult} the recognition result.
         */ get: function() {
            return this.privResult;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TranslationRecognitionCanceledEventArgs.prototype, "sessionId", {
        /**
         * Specifies the session identifier.
         * @member TranslationRecognitionCanceledEventArgs.prototype.sessionId
         * @function
         * @public
         * @returns {string} the session identifier.
         */ get: function() {
            return this.privSessionId;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TranslationRecognitionCanceledEventArgs.prototype, "reason", {
        /**
         * The reason the recognition was canceled.
         * @member TranslationRecognitionCanceledEventArgs.prototype.reason
         * @function
         * @public
         * @returns {CancellationReason} Specifies the reason canceled.
         */ get: function() {
            return this.privCancelReason;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TranslationRecognitionCanceledEventArgs.prototype, "errorCode", {
        /**
         * The error code in case of an unsuccessful recognition.
         * Added in version 1.1.0.
         * @return An error code that represents the error reason.
         */ get: function() {
            return this.privErrorCode;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TranslationRecognitionCanceledEventArgs.prototype, "errorDetails", {
        /**
         * In case of an unsuccessful recognition, provides details of the occurred error.
         * @member TranslationRecognitionCanceledEventArgs.prototype.errorDetails
         * @function
         * @public
         * @returns {string} A String that represents the error details.
         */ get: function() {
            return this.privErrorDetails;
        },
        enumerable: false,
        configurable: true
    });
    return TranslationRecognitionCanceledEventArgs;
}();
module.exports.TranslationRecognitionCanceledEventArgs = $aeb3f0e0d7d63fd4$var$TranslationRecognitionCanceledEventArgs;

});

parcelRequire.register("gGKie", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
var $c2647a6be09302bd$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.IntentRecognitionCanceledEventArgs = void 0;

var $iQDnw = parcelRequire("iQDnw");
/**
 * Define payload of intent recognition canceled result events.
 * @class IntentRecognitionCanceledEventArgs
 */ var $c2647a6be09302bd$var$IntentRecognitionCanceledEventArgs = /** @class */ function(_super) {
    $c2647a6be09302bd$var$__extends(IntentRecognitionCanceledEventArgs, _super);
    /**
     * Creates and initializes an instance of this class.
     * @constructor
     * @param {CancellationReason} result - The result of the intent recognition.
     * @param {string} offset - The offset.
     * @param {IntentRecognitionResult} sessionId - The session id.
     */ function IntentRecognitionCanceledEventArgs(reason, errorDetails, errorCode, result, offset, sessionId) {
        var _this = _super.call(this, result, offset, sessionId) || this;
        _this.privReason = reason;
        _this.privErrorDetails = errorDetails;
        _this.privErrorCode = errorCode;
        return _this;
    }
    Object.defineProperty(IntentRecognitionCanceledEventArgs.prototype, "reason", {
        /**
         * The reason the recognition was canceled.
         * @member IntentRecognitionCanceledEventArgs.prototype.reason
         * @function
         * @public
         * @returns {CancellationReason} Specifies the reason canceled.
         */ get: function() {
            return this.privReason;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IntentRecognitionCanceledEventArgs.prototype, "errorCode", {
        /**
         * The error code in case of an unsuccessful recognition.
         * Added in version 1.1.0.
         * @return An error code that represents the error reason.
         */ get: function() {
            return this.privErrorCode;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IntentRecognitionCanceledEventArgs.prototype, "errorDetails", {
        /**
         * In case of an unsuccessful recognition, provides details of the occurred error.
         * @member IntentRecognitionCanceledEventArgs.prototype.errorDetails
         * @function
         * @public
         * @returns {string} A String that represents the error details.
         */ get: function() {
            return this.privErrorDetails;
        },
        enumerable: false,
        configurable: true
    });
    return IntentRecognitionCanceledEventArgs;
}($iQDnw.IntentRecognitionEventArgs);
module.exports.IntentRecognitionCanceledEventArgs = $c2647a6be09302bd$var$IntentRecognitionCanceledEventArgs;

});

parcelRequire.register("cFx58", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CancellationDetailsBase = void 0;
/**
 * Contains detailed information about why a result was canceled.
 * @class CancellationDetailsBase
 */ var $9392f9be919f97f0$var$CancellationDetailsBase = /** @class */ function() {
    /**
     * Creates and initializes an instance of this class.
     * @constructor
     * @param {CancellationReason} reason - The cancellation reason.
     * @param {string} errorDetails - The error details, if provided.
     */ function CancellationDetailsBase(reason, errorDetails, errorCode) {
        this.privReason = reason;
        this.privErrorDetails = errorDetails;
        this.privErrorCode = errorCode;
    }
    Object.defineProperty(CancellationDetailsBase.prototype, "reason", {
        /**
         * The reason the recognition was canceled.
         * @member CancellationDetailsBase.prototype.reason
         * @function
         * @public
         * @returns {CancellationReason} Specifies the reason canceled.
         */ get: function() {
            return this.privReason;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CancellationDetailsBase.prototype, "errorDetails", {
        /**
         * In case of an unsuccessful recognition, provides details of the occurred error.
         * @member CancellationDetailsBase.prototype.errorDetails
         * @function
         * @public
         * @returns {string} A String that represents the error details.
         */ get: function() {
            return this.privErrorDetails;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CancellationDetailsBase.prototype, "ErrorCode", {
        /**
         * The error code in case of an unsuccessful recognition.
         * Added in version 1.1.0.
         * @return An error code that represents the error reason.
         */ get: function() {
            return this.privErrorCode;
        },
        enumerable: false,
        configurable: true
    });
    return CancellationDetailsBase;
}();
module.exports.CancellationDetailsBase = $9392f9be919f97f0$var$CancellationDetailsBase;

});

parcelRequire.register("fsGED", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
var $b41a8ed6f3e912d4$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CancellationDetails = void 0;

var $9MAMI = parcelRequire("9MAMI");

var $cFx58 = parcelRequire("cFx58");

var $iQDnw = parcelRequire("iQDnw");
/**
 * Contains detailed information about why a result was canceled.
 * @class CancellationDetails
 */ var $b41a8ed6f3e912d4$var$CancellationDetails = /** @class */ function(_super) {
    $b41a8ed6f3e912d4$var$__extends(CancellationDetails, _super);
    function CancellationDetails(reason, errorDetails, errorCode) {
        return _super.call(this, reason, errorDetails, errorCode) || this;
    }
    /**
     * Creates an instance of CancellationDetails object for the canceled RecognitionResult.
     * @member CancellationDetails.fromResult
     * @function
     * @public
     * @param {RecognitionResult | SpeechSynthesisResult} result - The result that was canceled.
     * @returns {CancellationDetails} The cancellation details object being created.
     */ CancellationDetails.fromResult = function(result) {
        var reason = $iQDnw.CancellationReason.Error;
        var errorCode = $iQDnw.CancellationErrorCode.NoError;
        if (result instanceof $iQDnw.RecognitionResult && !!result.json) {
            var simpleSpeech = $9MAMI.SimpleSpeechPhrase.fromJSON(result.json);
            reason = $9MAMI.EnumTranslation.implTranslateCancelResult(simpleSpeech.RecognitionStatus);
        }
        if (!!result.properties) errorCode = $iQDnw.CancellationErrorCode[result.properties.getProperty($9MAMI.CancellationErrorCodePropertyName, $iQDnw.CancellationErrorCode[$iQDnw.CancellationErrorCode.NoError])];
        return new CancellationDetails(reason, result.errorDetails, errorCode);
    };
    return CancellationDetails;
}($cFx58.CancellationDetailsBase);
module.exports.CancellationDetails = $b41a8ed6f3e912d4$var$CancellationDetails;

});

parcelRequire.register("225vB", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CancellationErrorCode = void 0;
/**
 *  Defines error code in case that CancellationReason is Error.
 *  Added in version 1.1.0.
 */ var $17b00a96f5b57e92$var$CancellationErrorCode;
(function(CancellationErrorCode) {
    /**
     * Indicates that no error occurred during speech recognition.
     */ CancellationErrorCode[CancellationErrorCode["NoError"] = 0] = "NoError";
    /**
     * Indicates an authentication error.
     */ CancellationErrorCode[CancellationErrorCode["AuthenticationFailure"] = 1] = "AuthenticationFailure";
    /**
     * Indicates that one or more recognition parameters are invalid.
     */ CancellationErrorCode[CancellationErrorCode["BadRequestParameters"] = 2] = "BadRequestParameters";
    /**
     * Indicates that the number of parallel requests exceeded the number of allowed
     * concurrent transcriptions for the subscription.
     */ CancellationErrorCode[CancellationErrorCode["TooManyRequests"] = 3] = "TooManyRequests";
    /**
     * Indicates a connection error.
     */ CancellationErrorCode[CancellationErrorCode["ConnectionFailure"] = 4] = "ConnectionFailure";
    /**
     * Indicates a time-out error when waiting for response from service.
     */ CancellationErrorCode[CancellationErrorCode["ServiceTimeout"] = 5] = "ServiceTimeout";
    /**
     * Indicates that an error is returned by the service.
     */ CancellationErrorCode[CancellationErrorCode["ServiceError"] = 6] = "ServiceError";
    /**
     * Indicates an unexpected runtime error.
     */ CancellationErrorCode[CancellationErrorCode["RuntimeError"] = 7] = "RuntimeError";
})($17b00a96f5b57e92$var$CancellationErrorCode = module.exports.CancellationErrorCode || (module.exports.CancellationErrorCode = {}));

});

parcelRequire.register("14ZAb", function(module, exports) {
"use strict";
//
// Copyright (c) Microsoft. All rights reserved.
// Licensed under the MIT license. See LICENSE.md file in the project root for full license information.
//
var $0c95ef2b755f2d9f$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ConnectionEventArgs = void 0;

var $iQDnw = parcelRequire("iQDnw");
/**
 * Defines payload for connection events like Connected/Disconnected.
 * Added in version 1.2.0
 */ var $0c95ef2b755f2d9f$var$ConnectionEventArgs = /** @class */ function(_super) {
    $0c95ef2b755f2d9f$var$__extends(ConnectionEventArgs, _super);
    function ConnectionEventArgs() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return ConnectionEventArgs;
}($iQDnw.SessionEventArgs);
module.exports.ConnectionEventArgs = $0c95ef2b755f2d9f$var$ConnectionEventArgs;

});

parcelRequire.register("ibe0U", function(module, exports) {
"use strict";
//
// Copyright (c) Microsoft. All rights reserved.
// Licensed under the MIT license. See LICENSE.md file in the project root for full license information.
//
var $d3c41fe07fcbc925$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ServiceEventArgs = void 0;

var $iQDnw = parcelRequire("iQDnw");
/**
 * Defines payload for any Service message event
 * Added in version 1.9.0
 */ var $d3c41fe07fcbc925$var$ServiceEventArgs = /** @class */ function(_super) {
    $d3c41fe07fcbc925$var$__extends(ServiceEventArgs, _super);
    /**
     * Creates and initializes an instance of this class.
     * @constructor
     * @param {string} json - json payload of the USP message.
     */ function ServiceEventArgs(json, name, sessionId) {
        var _this = _super.call(this, sessionId) || this;
        _this.privJsonResult = json;
        _this.privEventName = name;
        return _this;
    }
    Object.defineProperty(ServiceEventArgs.prototype, "jsonString", {
        get: function() {
            return this.privJsonResult;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ServiceEventArgs.prototype, "eventName", {
        get: function() {
            return this.privEventName;
        },
        enumerable: false,
        configurable: true
    });
    return ServiceEventArgs;
}($iQDnw.SessionEventArgs);
module.exports.ServiceEventArgs = $d3c41fe07fcbc925$var$ServiceEventArgs;

});

parcelRequire.register("lz0AZ", function(module, exports) {
"use strict";
//
// Copyright (c) Microsoft. All rights reserved.
// Licensed under the MIT license. See LICENSE.md file in the project root for full license information.
//
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Connection = void 0;

var $9MAMI = parcelRequire("9MAMI");

var $7srwU = parcelRequire("7srwU");

var $ldtlJ = parcelRequire("ldtlJ");

var $evvAW = parcelRequire("evvAW");

var $iQDnw = parcelRequire("iQDnw");
/**
 * Connection is a proxy class for managing connection to the speech service of the specified Recognizer.
 * By default, a Recognizer autonomously manages connection to service when needed.
 * The Connection class provides additional methods for users to explicitly open or close a connection and
 * to subscribe to connection status changes.
 * The use of Connection is optional, and mainly for scenarios where fine tuning of application
 * behavior based on connection status is needed. Users can optionally call Open() to manually set up a connection
 * in advance before starting recognition on the Recognizer associated with this Connection.
 * If the Recognizer needs to connect or disconnect to service, it will
 * setup or shutdown the connection independently. In this case the Connection will be notified by change of connection
 * status via Connected/Disconnected events.
 * Added in version 1.2.1.
 */ var $fb2d54234821f5ef$var$Connection = /** @class */ function() {
    function Connection() {}
    /**
     * Gets the Connection instance from the specified recognizer.
     * @param recognizer The recognizer associated with the connection.
     * @return The Connection instance of the recognizer.
     */ Connection.fromRecognizer = function(recognizer) {
        var recoBase = recognizer.internalData;
        var ret = new Connection();
        ret.privInternalData = recoBase;
        ret.setupEvents();
        return ret;
    };
    /**
     * Gets the Connection instance from the specified synthesizer.
     * @param synthesizer The synthesizer associated with the connection.
     * @return The Connection instance of the synthesizer.
     */ Connection.fromSynthesizer = function(synthesizer) {
        var synthBase = synthesizer.internalData;
        var ret = new Connection();
        ret.privInternalData = synthBase;
        ret.setupEvents();
        return ret;
    };
    /**
     * Starts to set up connection to the service.
     * Users can optionally call openConnection() to manually set up a connection in advance before starting recognition on the
     * Recognizer associated with this Connection. After starting recognition, calling Open() will have no effect
     *
     * Note: On return, the connection might not be ready yet. Please subscribe to the Connected event to
     * be notified when the connection is established.
     */ Connection.prototype.openConnection = function(cb, err) {
        $7srwU.marshalPromiseToCallbacks(this.privInternalData.connect(), cb, err);
    };
    /**
     * Closes the connection the service.
     * Users can optionally call closeConnection() to manually shutdown the connection of the associated Recognizer.
     *
     * If closeConnection() is called during recognition, recognition will fail and cancel with an error.
     */ Connection.prototype.closeConnection = function(cb, err) {
        if (this.privInternalData instanceof $9MAMI.SynthesisAdapterBase) throw new Error("Disconnecting a synthesizer's connection is currently not supported");
        else $7srwU.marshalPromiseToCallbacks(this.privInternalData.disconnect(), cb, err);
    };
    /**
     * Appends a parameter in a message to service.
     * Added in version 1.12.1.
     * @param path The path of the network message.
     * @param propertyName Name of the property
     * @param propertyValue Value of the property. This is a json string.
     */ Connection.prototype.setMessageProperty = function(path, propertyName, propertyValue) {
        $evvAW.Contracts.throwIfNullOrWhitespace(propertyName, "propertyName");
        if (this.privInternalData instanceof $9MAMI.ServiceRecognizerBase) {
            if (path.toLowerCase() !== "speech.context") throw new Error("Only speech.context message property sets are currently supported for recognizer");
            else this.privInternalData.speechContext.setSection(propertyName, propertyValue);
        } else if (this.privInternalData instanceof $9MAMI.SynthesisAdapterBase) {
            if (path.toLowerCase() !== "synthesis.context") throw new Error("Only synthesis.context message property sets are currently supported for synthesizer");
            else this.privInternalData.synthesisContext.setSection(propertyName, propertyValue);
        }
    };
    /**
     * Sends a message to the speech service.
     * Added in version 1.13.0.
     * @param path The WebSocket path of the message
     * @param payload The payload of the message. This is a json string or a ArrayBuffer.
     * @param success A callback to indicate success.
     * @param error A callback to indicate an error.
     */ Connection.prototype.sendMessageAsync = function(path, payload, success, error) {
        $7srwU.marshalPromiseToCallbacks(this.privInternalData.sendNetworkMessage(path, payload), success, error);
    };
    /**
     * Dispose of associated resources.
     */ Connection.prototype.close = function() {
    /* tslint:disable:no-empty */ };
    Connection.prototype.setupEvents = function() {
        var _this = this;
        this.privEventListener = this.privInternalData.connectionEvents.attach(function(connectionEvent) {
            if (connectionEvent.name === "ConnectionEstablishedEvent") {
                if (!!_this.connected) _this.connected(new $iQDnw.ConnectionEventArgs(connectionEvent.connectionId));
            } else if (connectionEvent.name === "ConnectionClosedEvent") {
                if (!!_this.disconnected) _this.disconnected(new $iQDnw.ConnectionEventArgs(connectionEvent.connectionId));
            } else if (connectionEvent.name === "ConnectionMessageSentEvent") {
                if (!!_this.messageSent) _this.messageSent(new $iQDnw.ConnectionMessageEventArgs(new $ldtlJ.ConnectionMessageImpl(connectionEvent.message)));
            } else if (connectionEvent.name === "ConnectionMessageReceivedEvent") {
                if (!!_this.messageReceived) _this.messageReceived(new $iQDnw.ConnectionMessageEventArgs(new $ldtlJ.ConnectionMessageImpl(connectionEvent.message)));
            }
        });
        this.privServiceEventListener = this.privInternalData.serviceEvents.attach(function(e) {
            if (!!_this.receivedServiceMessage) _this.receivedServiceMessage(new $iQDnw.ServiceEventArgs(e.jsonString, e.name));
        });
    };
    return Connection;
}();
module.exports.Connection = $fb2d54234821f5ef$var$Connection;

});
parcelRequire.register("ldtlJ", function(module, exports) {
"use strict";
//
// Copyright (c) Microsoft. All rights reserved.
// Licensed under the MIT license. See LICENSE.md file in the project root for full license information.
//
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ConnectionMessageImpl = module.exports.ConnectionMessage = void 0;

var $hiJX4 = parcelRequire("hiJX4");

var $7srwU = parcelRequire("7srwU");

var $jnfnZ = parcelRequire("jnfnZ");

var $ChSMK = parcelRequire("ChSMK");
/**
 * ConnectionMessage represents implementation specific messages sent to and received from
 * the speech service. These messages are provided for debugging purposes and should not
 * be used for production use cases with the Azure Cognitive Services Speech Service.
 * Messages sent to and received from the Speech Service are subject to change without
 * notice. This includes message contents, headers, payloads, ordering, etc.
 * Added in version 1.11.0.
 */ var $f7219417f6c5e688$var$ConnectionMessage = /** @class */ function() {
    function ConnectionMessage() {}
    return ConnectionMessage;
}();
module.exports.ConnectionMessage = $f7219417f6c5e688$var$ConnectionMessage;
// tslint:disable-next-line:max-classes-per-file
var $f7219417f6c5e688$var$ConnectionMessageImpl = /** @class */ function() {
    function ConnectionMessageImpl(message) {
        var _this = this;
        this.privConnectionMessage = message;
        this.privProperties = new $jnfnZ.PropertyCollection();
        if (!!this.privConnectionMessage.headers[$hiJX4.HeaderNames.ConnectionId]) this.privProperties.setProperty($ChSMK.PropertyId.Speech_SessionId, this.privConnectionMessage.headers[$hiJX4.HeaderNames.ConnectionId]);
        Object.keys(this.privConnectionMessage.headers).forEach(function(header, index, array) {
            _this.privProperties.setProperty(header, _this.privConnectionMessage.headers[header]);
        });
    }
    Object.defineProperty(ConnectionMessageImpl.prototype, "path", {
        /**
         * The message path.
         */ get: function() {
            return this.privConnectionMessage.headers[Object.keys(this.privConnectionMessage.headers).find(function(key) {
                return key.toLowerCase() === "path".toLowerCase();
            })];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ConnectionMessageImpl.prototype, "isTextMessage", {
        /**
         * Checks to see if the ConnectionMessage is a text message.
         * See also IsBinaryMessage().
         */ get: function() {
            return this.privConnectionMessage.messageType === $7srwU.MessageType.Text;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ConnectionMessageImpl.prototype, "isBinaryMessage", {
        /**
         * Checks to see if the ConnectionMessage is a binary message.
         * See also GetBinaryMessage().
         */ get: function() {
            return this.privConnectionMessage.messageType === $7srwU.MessageType.Binary;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ConnectionMessageImpl.prototype, "TextMessage", {
        /**
         * Gets the text message payload. Typically the text message content-type is
         * application/json. To determine other content-types use
         * Properties.GetProperty("Content-Type").
         */ get: function() {
            return this.privConnectionMessage.textBody;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ConnectionMessageImpl.prototype, "binaryMessage", {
        /**
         * Gets the binary message payload.
         */ get: function() {
            return this.privConnectionMessage.binaryBody;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ConnectionMessageImpl.prototype, "properties", {
        /**
         * A collection of properties and their values defined for this <see cref="ConnectionMessage"/>.
         * Message headers can be accessed via this collection (e.g. "Content-Type").
         */ get: function() {
            return this.privProperties;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Returns a string that represents the connection message.
     */ ConnectionMessageImpl.prototype.toString = function() {
        return "";
    };
    return ConnectionMessageImpl;
}();
module.exports.ConnectionMessageImpl = $f7219417f6c5e688$var$ConnectionMessageImpl;

});


parcelRequire.register("1ccNQ", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PhraseListGrammar = void 0;
/**
 * Allows additions of new phrases to improve speech recognition.
 *
 * Phrases added to the recognizer are effective at the start of the next recognition, or the next time the SpeechSDK must reconnect
 * to the speech service.
 */ var $0df0d7d591944666$var$PhraseListGrammar = /** @class */ function() {
    function PhraseListGrammar(recogBase) {
        this.privGrammerBuilder = recogBase.dynamicGrammar;
    }
    /**
     * Creates a PhraseListGrammar from a given speech recognizer. Will accept any recognizer that derives from @class Recognizer.
     * @param recognizer The recognizer to add phrase lists to.
     */ PhraseListGrammar.fromRecognizer = function(recognizer) {
        var recoBase = recognizer.internalData;
        return new PhraseListGrammar(recoBase);
    };
    /**
     * Adds a single phrase to the current recognizer.
     * @param phrase Phrase to add.
     */ PhraseListGrammar.prototype.addPhrase = function(phrase) {
        this.privGrammerBuilder.addPhrase(phrase);
    };
    /**
     * Adds multiple phrases to the current recognizer.
     * @param phrases Array of phrases to add.
     */ PhraseListGrammar.prototype.addPhrases = function(phrases) {
        this.privGrammerBuilder.addPhrase(phrases);
    };
    /**
     * Clears all phrases added to the current recognizer.
     */ PhraseListGrammar.prototype.clear = function() {
        this.privGrammerBuilder.clearPhrases();
    };
    return PhraseListGrammar;
}();
module.exports.PhraseListGrammar = $0df0d7d591944666$var$PhraseListGrammar;

});

parcelRequire.register("aID4k", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
var $7cdc51b7140cab4c$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DialogServiceConfigImpl = module.exports.DialogServiceConfig = void 0;

var $evvAW = parcelRequire("evvAW");

var $iQDnw = parcelRequire("iQDnw");
/**
 * Class that defines base configurations for dialog service connector
 * @class DialogServiceConfig
 */ var $7cdc51b7140cab4c$var$DialogServiceConfig = /** @class */ function() {
    /**
     * Creates an instance of DialogService config.
     * @constructor
     */ function DialogServiceConfig() {}
    Object.defineProperty(DialogServiceConfig.prototype, "applicationId", {
        /**
         * Sets the corresponding backend application identifier.
         * @member DialogServiceConfig.prototype.Conversation_ApplicationId
         * @function
         * @public
         * @param {string} value - The application identifier to set.
         */ // tslint:disable-next-line: no-empty
        set: function(value) {},
        enumerable: false,
        configurable: true
    });
    var _a;
    DialogServiceConfig.DialogTypes = (_a = /** @class */ function() {
        function class_1() {}
        return class_1;
    }(), _a.BotFramework = "bot_framework", _a.CustomCommands = "custom_commands", _a);
    return DialogServiceConfig;
}();
module.exports.DialogServiceConfig = $7cdc51b7140cab4c$var$DialogServiceConfig;
/**
 * Dialog Service configuration.
 * @class DialogServiceConfigImpl
 */ // tslint:disable-next-line:max-classes-per-file
var $7cdc51b7140cab4c$var$DialogServiceConfigImpl = /** @class */ function(_super) {
    $7cdc51b7140cab4c$var$__extends(DialogServiceConfigImpl, _super);
    /**
     * Creates an instance of dialogService config.
     */ function DialogServiceConfigImpl() {
        var _this = _super.call(this) || this;
        _this.privSpeechConfig = new $iQDnw.SpeechConfigImpl();
        return _this;
    }
    Object.defineProperty(DialogServiceConfigImpl.prototype, "properties", {
        /**
         * Provides access to custom properties.
         * @member DialogServiceConfigImpl.prototype.properties
         * @function
         * @public
         * @returns {PropertyCollection} The properties.
         */ get: function() {
            return this.privSpeechConfig.properties;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DialogServiceConfigImpl.prototype, "speechRecognitionLanguage", {
        /**
         * Gets the speech recognition language.
         * @member DialogServiceConfigImpl.prototype.speechRecognitionLanguage
         * @function
         * @public
         */ get: function() {
            return this.privSpeechConfig.speechRecognitionLanguage;
        },
        /**
         * Sets the speech recognition language.
         * @member DialogServiceConfigImpl.prototype.speechRecognitionLanguage
         * @function
         * @public
         * @param {string} value - The language to set.
         */ set: function(value) {
            $evvAW.Contracts.throwIfNullOrWhitespace(value, "value");
            this.privSpeechConfig.speechRecognitionLanguage = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DialogServiceConfigImpl.prototype, "outputFormat", {
        get: function() {
            return this.privSpeechConfig.outputFormat;
        },
        set: function(value) {
            this.privSpeechConfig.outputFormat = value;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Sets a named property as value
     * @member DialogServiceConfigImpl.prototype.setProperty
     * @function
     * @public
     * @param {PropertyId | string} name - The property to set.
     * @param {string} value - The value.
     */ DialogServiceConfigImpl.prototype.setProperty = function(name, value) {
        this.privSpeechConfig.setProperty(name, value);
    };
    /**
     * Sets a named property as value
     * @member DialogServiceConfigImpl.prototype.getProperty
     * @function
     * @public
     * @param {PropertyId | string} name - The property to get.
     * @param {string} def - The default value to return in case the property is not known.
     * @returns {string} The current value, or provided default, of the given property.
     */ DialogServiceConfigImpl.prototype.getProperty = function(name, def) {
        return this.privSpeechConfig.getProperty(name);
    };
    /**
     * Sets the proxy configuration.
     * Only relevant in Node.js environments.
     * Added in version 1.4.0.
     * @param proxyHostName The host name of the proxy server, without the protocol scheme (http://)
     * @param proxyPort The port number of the proxy server.
     * @param proxyUserName The user name of the proxy server.
     * @param proxyPassword The password of the proxy server.
     */ DialogServiceConfigImpl.prototype.setProxy = function(proxyHostName, proxyPort, proxyUserName, proxyPassword) {
        this.setProperty($iQDnw.PropertyId.SpeechServiceConnection_ProxyHostName, proxyHostName);
        this.setProperty($iQDnw.PropertyId.SpeechServiceConnection_ProxyPort, "" + proxyPort);
        if (proxyUserName) this.setProperty($iQDnw.PropertyId.SpeechServiceConnection_ProxyUserName, proxyUserName);
        if (proxyPassword) this.setProperty($iQDnw.PropertyId.SpeechServiceConnection_ProxyPassword, proxyPassword);
    };
    DialogServiceConfigImpl.prototype.setServiceProperty = function(name, value, channel) {
        this.privSpeechConfig.setServiceProperty(name, value, channel);
    };
    /**
     * Dispose of associated resources.
     * @member DialogServiceConfigImpl.prototype.close
     * @function
     * @public
     */ DialogServiceConfigImpl.prototype.close = function() {
        return;
    };
    return DialogServiceConfigImpl;
}($7cdc51b7140cab4c$var$DialogServiceConfig);
module.exports.DialogServiceConfigImpl = $7cdc51b7140cab4c$var$DialogServiceConfigImpl;

});

parcelRequire.register("5Cqjy", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
var $4174e9df61fbcc1c$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.BotFrameworkConfig = void 0;

var $evvAW = parcelRequire("evvAW");

var $aID4k = parcelRequire("aID4k");

var $iQDnw = parcelRequire("iQDnw");
/**
 * Class that defines configurations for the dialog service connector object for using a Bot Framework backend.
 * @class BotFrameworkConfig
 */ var $4174e9df61fbcc1c$var$BotFrameworkConfig = /** @class */ function(_super) {
    $4174e9df61fbcc1c$var$__extends(BotFrameworkConfig, _super);
    /**
     * Creates an instance of BotFrameworkConfig.
     */ function BotFrameworkConfig() {
        return _super.call(this) || this;
    }
    /**
     * Creates a bot framework configuration instance with the provided subscription information.
     * @member BotFrameworkConfig.fromSubscription
     * @function
     * @public
     * @param subscription Subscription key associated with the bot
     * @param region The region name (see the <a href="https://aka.ms/csspeech/region">region page</a>).
     * @param botId Optional. Identifier for using a specific bot within an Azure resource group. Equivalent to the
     *        resource name.
     * @returns {BotFrameworkConfig} A new bot framework configuration instance.
     */ BotFrameworkConfig.fromSubscription = function(subscription, region, botId) {
        $evvAW.Contracts.throwIfNullOrWhitespace(subscription, "subscription");
        $evvAW.Contracts.throwIfNullOrWhitespace(region, "region");
        var botFrameworkConfig = new $aID4k.DialogServiceConfigImpl();
        botFrameworkConfig.setProperty($iQDnw.PropertyId.Conversation_DialogType, $aID4k.DialogServiceConfig.DialogTypes.BotFramework);
        botFrameworkConfig.setProperty($iQDnw.PropertyId.SpeechServiceConnection_Key, subscription);
        botFrameworkConfig.setProperty($iQDnw.PropertyId.SpeechServiceConnection_Region, region);
        if (botId) botFrameworkConfig.setProperty($iQDnw.PropertyId.Conversation_ApplicationId, botId);
        return botFrameworkConfig;
    };
    /**
     * Creates a bot framework configuration instance for the specified authorization token and region.
     * Note: The caller must ensure that an authorization token is valid. Before an authorization token expires, the
     *       caller must refresh it by setting the authorizationToken property on the corresponding
     *       DialogServiceConnector instance created with this config. The contents of configuration objects are copied
     *       when connectors are created, so setting authorizationToken on a DialogServiceConnector will not update the
     *       original configuration's authorization token. Create a new configuration instance or set the
     *       SpeechServiceAuthorization_Token property to update an existing instance if it will be used to create
     *       further DialogServiceConnectors.
     * @member BotFrameworkConfig.fromAuthorizationToken
     * @function
     * @public
     * @param authorizationToken The authorization token associated with the bot
     * @param region The region name (see the <a href="https://aka.ms/csspeech/region">region page</a>).
     * @param botId Optional. Identifier for using a specific bot within an Azure resource group. Equivalent to the
     *        resource name.
     * @returns {BotFrameworkConfig} A new bot framework configuration instance.
     */ BotFrameworkConfig.fromAuthorizationToken = function(authorizationToken, region, botId) {
        $evvAW.Contracts.throwIfNullOrWhitespace(authorizationToken, "authorizationToken");
        $evvAW.Contracts.throwIfNullOrWhitespace(region, "region");
        var botFrameworkConfig = new $aID4k.DialogServiceConfigImpl();
        botFrameworkConfig.setProperty($iQDnw.PropertyId.Conversation_DialogType, $aID4k.DialogServiceConfig.DialogTypes.BotFramework);
        botFrameworkConfig.setProperty($iQDnw.PropertyId.SpeechServiceAuthorization_Token, authorizationToken);
        botFrameworkConfig.setProperty($iQDnw.PropertyId.SpeechServiceConnection_Region, region);
        if (botId) botFrameworkConfig.setProperty($iQDnw.PropertyId.Conversation_ApplicationId, botId);
        return botFrameworkConfig;
    };
    /**
     * Creates an instance of a BotFrameworkConfig.
     * This method is intended only for users who use a non-default service host. The standard resource path will be
     * assumed. For services with a non-standard resource path or no path at all, use fromEndpoint instead.
     * Note: Query parameters are not allowed in the host URI and must be set by other APIs.
     * Note: To use an authorization token with fromHost, use fromHost(URL) and then set the AuthorizationToken
     *       property on the created BotFrameworkConfig instance.
     * Note: Added in version 1.15.0.
     * @member BotFrameworkConfig.fromHost
     * @function
     * @public
     * @param {URL | string} host - If a URL is provided, the fully-qualified host with protocol (e.g.
     *        wss://your.host.com:1234) will be used. If a string is provided, it will be embedded in
     *        wss://{host}.convai.speech.azure.us.
     * @param {string} subscriptionKey - The subscription key. If a subscription key is not specified, an authorization
     *        token must be set.
     * @param botId Optional. Identifier for using a specific bot within an Azure resource group. Equivalent to the
     *        resource name.
     * @returns {BotFrameworkConfig} A new bot framework configuration instance.
     */ BotFrameworkConfig.fromHost = function(host, subscriptionKey, botId) {
        $evvAW.Contracts.throwIfNullOrUndefined(host, "host");
        var resolvedHost = host instanceof URL ? host : new URL("wss://" + host + ".convai.speech.azure.us");
        $evvAW.Contracts.throwIfNullOrUndefined(resolvedHost, "resolvedHost");
        var botFrameworkConfig = new $aID4k.DialogServiceConfigImpl();
        botFrameworkConfig.setProperty($iQDnw.PropertyId.Conversation_DialogType, $aID4k.DialogServiceConfig.DialogTypes.BotFramework);
        botFrameworkConfig.setProperty($iQDnw.PropertyId.SpeechServiceConnection_Host, resolvedHost.toString());
        if (undefined !== subscriptionKey) botFrameworkConfig.setProperty($iQDnw.PropertyId.SpeechServiceConnection_Key, subscriptionKey);
        return botFrameworkConfig;
    };
    /**
     * Creates an instance of a BotFrameworkConfig.
     * This method is intended only for users who use a non-standard service endpoint or parameters.
     * Note: The query parameters specified in the endpoint URL are not changed, even if they are set by any other APIs.
     * Note: To use authorization token with fromEndpoint, pass an empty string to the subscriptionKey in the
     *       fromEndpoint method, and then set authorizationToken="token" on the created BotFrameworkConfig instance to
     *       use the authorization token.
     * Note: Added in version 1.15.0.
     * @member BotFrameworkConfig.fromEndpoint
     * @function
     * @public
     * @param {URL} endpoint - The service endpoint to connect to.
     * @param {string} subscriptionKey - The subscription key. If a subscription key is not specified, an authorization
     *        token must be set.
     * @returns {BotFrameworkConfig} - A new bot framework configuration instance using the provided endpoint.
     */ BotFrameworkConfig.fromEndpoint = function(endpoint, subscriptionKey) {
        $evvAW.Contracts.throwIfNull(endpoint, "endpoint");
        var botFrameworkConfig = new $aID4k.DialogServiceConfigImpl();
        botFrameworkConfig.setProperty($iQDnw.PropertyId.Conversation_DialogType, $aID4k.DialogServiceConfig.DialogTypes.BotFramework);
        botFrameworkConfig.setProperty($iQDnw.PropertyId.SpeechServiceConnection_Endpoint, endpoint.toString());
        if (undefined !== subscriptionKey) botFrameworkConfig.setProperty($iQDnw.PropertyId.SpeechServiceConnection_Key, subscriptionKey);
        return botFrameworkConfig;
    };
    return BotFrameworkConfig;
}($aID4k.DialogServiceConfigImpl);
module.exports.BotFrameworkConfig = $4174e9df61fbcc1c$var$BotFrameworkConfig;

});

parcelRequire.register("7XLtC", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
var $5cc2def8f2fe762f$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CustomCommandsConfig = void 0;

var $evvAW = parcelRequire("evvAW");

var $aID4k = parcelRequire("aID4k");

var $iQDnw = parcelRequire("iQDnw");
/**
 * Class that defines configurations for the dialog service connector object for using a CustomCommands backend.
 * @class CustomCommandsConfig
 */ var $5cc2def8f2fe762f$var$CustomCommandsConfig = /** @class */ function(_super) {
    $5cc2def8f2fe762f$var$__extends(CustomCommandsConfig, _super);
    /**
     * Creates an instance of CustomCommandsConfig.
     */ function CustomCommandsConfig() {
        return _super.call(this) || this;
    }
    /**
     * Creates an instance of the bot framework config with the specified subscription and region.
     * @member CustomCommandsConfig.fromSubscription
     * @function
     * @public
     * @param applicationId Speech Commands application id.
     * @param subscription Subscription key associated with the bot
     * @param region The region name (see the <a href="https://aka.ms/csspeech/region">region page</a>).
     * @returns {CustomCommandsConfig} A new bot framework config.
     */ CustomCommandsConfig.fromSubscription = function(applicationId, subscription, region) {
        $evvAW.Contracts.throwIfNullOrWhitespace(applicationId, "applicationId");
        $evvAW.Contracts.throwIfNullOrWhitespace(subscription, "subscription");
        $evvAW.Contracts.throwIfNullOrWhitespace(region, "region");
        var customCommandsConfig = new $aID4k.DialogServiceConfigImpl();
        customCommandsConfig.setProperty($iQDnw.PropertyId.Conversation_DialogType, $aID4k.DialogServiceConfig.DialogTypes.CustomCommands);
        customCommandsConfig.setProperty($iQDnw.PropertyId.Conversation_ApplicationId, applicationId);
        customCommandsConfig.setProperty($iQDnw.PropertyId.SpeechServiceConnection_Key, subscription);
        customCommandsConfig.setProperty($iQDnw.PropertyId.SpeechServiceConnection_Region, region);
        return customCommandsConfig;
    };
    /**
     * Creates an instance of the bot framework config with the specified Speech Commands application id, authorization token and region.
     * Note: The caller needs to ensure that the authorization token is valid. Before the authorization token
     * expires, the caller needs to refresh it by calling this setter with a new valid token.
     * As configuration values are copied when creating a new recognizer, the new token value will not apply to recognizers that have already been created.
     * For recognizers that have been created before, you need to set authorization token of the corresponding recognizer
     * to refresh the token. Otherwise, the recognizers will encounter errors during recognition.
     * @member CustomCommandsConfig.fromAuthorizationToken
     * @function
     * @public
     * @param applicationId Speech Commands application id.
     * @param authorizationToken The authorization token associated with the application.
     * @param region The region name (see the <a href="https://aka.ms/csspeech/region">region page</a>).
     * @returns {CustomCommandsConfig} A new speech commands config.
     */ CustomCommandsConfig.fromAuthorizationToken = function(applicationId, authorizationToken, region) {
        $evvAW.Contracts.throwIfNullOrWhitespace(applicationId, "applicationId");
        $evvAW.Contracts.throwIfNullOrWhitespace(authorizationToken, "authorizationToken");
        $evvAW.Contracts.throwIfNullOrWhitespace(region, "region");
        var customCommandsConfig = new $aID4k.DialogServiceConfigImpl();
        customCommandsConfig.setProperty($iQDnw.PropertyId.Conversation_DialogType, $aID4k.DialogServiceConfig.DialogTypes.CustomCommands);
        customCommandsConfig.setProperty($iQDnw.PropertyId.Conversation_ApplicationId, applicationId);
        customCommandsConfig.setProperty($iQDnw.PropertyId.SpeechServiceAuthorization_Token, authorizationToken);
        customCommandsConfig.setProperty($iQDnw.PropertyId.SpeechServiceConnection_Region, region);
        return customCommandsConfig;
    };
    Object.defineProperty(CustomCommandsConfig.prototype, "applicationId", {
        /**
         * Gets the corresponding backend application identifier.
         * @member CustomCommandsConfig.prototype.Conversation_ApplicationId
         * @function
         * @public
         * @param {string} value - The application identifier to get.
         */ get: function() {
            return this.getProperty($iQDnw.PropertyId.Conversation_ApplicationId);
        },
        /**
         * Sets the corresponding backend application identifier.
         * @member CustomCommandsConfig.prototype.Conversation_ApplicationId
         * @function
         * @public
         * @param {string} value - The application identifier to set.
         */ set: function(value) {
            $evvAW.Contracts.throwIfNullOrWhitespace(value, "value");
            this.setProperty($iQDnw.PropertyId.Conversation_ApplicationId, value);
        },
        enumerable: false,
        configurable: true
    });
    return CustomCommandsConfig;
}($aID4k.DialogServiceConfigImpl);
module.exports.CustomCommandsConfig = $5cc2def8f2fe762f$var$CustomCommandsConfig;

});

parcelRequire.register("g7L87", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
var $bbd1dbd5ded6685d$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $bbd1dbd5ded6685d$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $bbd1dbd5ded6685d$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DialogServiceConnector = void 0;

var $hMLdw = parcelRequire("hMLdw");

var $9MAMI = parcelRequire("9MAMI");

var $7srwU = parcelRequire("7srwU");

var $evvAW = parcelRequire("evvAW");

var $iQDnw = parcelRequire("iQDnw");

var $ChSMK = parcelRequire("ChSMK");
/**
 * Dialog Service Connector
 * @class DialogServiceConnector
 */ var $bbd1dbd5ded6685d$var$DialogServiceConnector = /** @class */ function(_super) {
    $bbd1dbd5ded6685d$var$__extends(DialogServiceConnector, _super);
    /**
     * Initializes an instance of the DialogServiceConnector.
     * @constructor
     * @param {DialogServiceConfig} dialogConfig - Set of properties to configure this recognizer.
     * @param {AudioConfig} audioConfig - An optional audio config associated with the recognizer
     */ function DialogServiceConnector(dialogConfig, audioConfig) {
        var _this = this;
        var dialogServiceConfigImpl = dialogConfig;
        $evvAW.Contracts.throwIfNull(dialogConfig, "dialogConfig");
        _this = _super.call(this, audioConfig, dialogServiceConfigImpl.properties, new $hMLdw.DialogConnectionFactory()) || this;
        _this.isTurnComplete = true;
        _this.privIsDisposed = false;
        _this.privProperties = dialogServiceConfigImpl.properties.clone();
        var agentConfig = _this.buildAgentConfig();
        _this.privReco.agentConfig.set(agentConfig);
        return _this;
    }
    /**
     * Starts a connection to the service.
     * Users can optionally call connect() to manually set up a connection in advance, before starting interactions.
     *
     * Note: On return, the connection might not be ready yet. Please subscribe to the Connected event to
     * be notified when the connection is established.
     * @member DialogServiceConnector.prototype.connect
     * @function
     * @public
     */ DialogServiceConnector.prototype.connect = function(cb, err) {
        $7srwU.marshalPromiseToCallbacks(this.privReco.connect(), cb, err);
    };
    /**
     * Closes the connection the service.
     * Users can optionally call disconnect() to manually shutdown the connection of the associated DialogServiceConnector.
     *
     * If disconnect() is called during a recognition, recognition will fail and cancel with an error.
     */ DialogServiceConnector.prototype.disconnect = function(cb, err) {
        $7srwU.marshalPromiseToCallbacks(this.privReco.disconnect(), cb, err);
    };
    Object.defineProperty(DialogServiceConnector.prototype, "authorizationToken", {
        /**
         * Gets the authorization token used to communicate with the service.
         * @member DialogServiceConnector.prototype.authorizationToken
         * @function
         * @public
         * @returns {string} Authorization token.
         */ get: function() {
            return this.properties.getProperty($ChSMK.PropertyId.SpeechServiceAuthorization_Token);
        },
        /**
         * Sets the authorization token used to communicate with the service.
         * @member DialogServiceConnector.prototype.authorizationToken
         * @function
         * @public
         * @param {string} token - Authorization token.
         */ set: function(token) {
            $evvAW.Contracts.throwIfNullOrWhitespace(token, "token");
            this.properties.setProperty($ChSMK.PropertyId.SpeechServiceAuthorization_Token, token);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DialogServiceConnector.prototype, "properties", {
        /**
         * The collection of properties and their values defined for this DialogServiceConnector.
         * @member DialogServiceConnector.prototype.properties
         * @function
         * @public
         * @returns {PropertyCollection} The collection of properties and their values defined for this DialogServiceConnector.
         */ get: function() {
            return this.privProperties;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DialogServiceConnector.prototype, "speechActivityTemplate", {
        /** Gets the template for the activity generated by service from speech.
         * Properties from the template will be stamped on the generated activity.
         * It can be empty
         */ get: function() {
            return this.properties.getProperty($ChSMK.PropertyId.Conversation_Speech_Activity_Template);
        },
        /** Sets the template for the activity generated by service from speech.
         * Properties from the template will be stamped on the generated activity.
         * It can be null or empty.
         * Note: it has to be a valid Json object.
         */ set: function(speechActivityTemplate) {
            this.properties.setProperty($ChSMK.PropertyId.Conversation_Speech_Activity_Template, speechActivityTemplate);
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Starts recognition and stops after the first utterance is recognized.
     * @member DialogServiceConnector.prototype.listenOnceAsync
     * @function
     * @public
     * @param cb - Callback that received the result when the reco has completed.
     * @param err - Callback invoked in case of an error.
     */ DialogServiceConnector.prototype.listenOnceAsync = function(cb, err) {
        var _this = this;
        if (this.isTurnComplete) {
            $evvAW.Contracts.throwIfDisposed(this.privIsDisposed);
            var callbackHolder = function() {
                return $bbd1dbd5ded6685d$var$__awaiter(_this, void 0, void 0, function() {
                    var ret, e;
                    return $bbd1dbd5ded6685d$var$__generator(this, function(_a) {
                        switch(_a.label){
                            case 0:
                                return [
                                    4 /*yield*/ ,
                                    this.privReco.connect()
                                ];
                            case 1:
                                _a.sent();
                                return [
                                    4 /*yield*/ ,
                                    this.implRecognizerStop()
                                ];
                            case 2:
                                _a.sent();
                                this.isTurnComplete = false;
                                ret = new $7srwU.Deferred();
                                return [
                                    4 /*yield*/ ,
                                    this.privReco.recognize($9MAMI.RecognitionMode.Conversation, ret.resolve, ret.reject)
                                ];
                            case 3:
                                _a.sent();
                                return [
                                    4 /*yield*/ ,
                                    ret.promise
                                ];
                            case 4:
                                e = _a.sent();
                                return [
                                    4 /*yield*/ ,
                                    this.implRecognizerStop()
                                ];
                            case 5:
                                _a.sent();
                                return [
                                    2 /*return*/ ,
                                    e
                                ];
                        }
                    });
                });
            };
            var retPromise = callbackHolder();
            retPromise.catch(function() {
                // Destroy the recognizer.
                /* tslint:disable:no-empty */ // We've done all we can here.
                _this.dispose(true).catch(function() {});
            });
            $7srwU.marshalPromiseToCallbacks(retPromise.finally(function() {
                _this.isTurnComplete = true;
            }), cb, err);
        }
    };
    DialogServiceConnector.prototype.sendActivityAsync = function(activity, cb, errCb) {
        $7srwU.marshalPromiseToCallbacks(this.privReco.sendMessage(activity), cb, errCb);
    };
    /**
     * closes all external resources held by an instance of this class.
     * @member DialogServiceConnector.prototype.close
     * @function
     * @public
     */ DialogServiceConnector.prototype.close = function(cb, err) {
        $evvAW.Contracts.throwIfDisposed(this.privIsDisposed);
        $7srwU.marshalPromiseToCallbacks(this.dispose(true), cb, err);
    };
    DialogServiceConnector.prototype.dispose = function(disposing) {
        return $bbd1dbd5ded6685d$var$__awaiter(this, void 0, void 0, function() {
            return $bbd1dbd5ded6685d$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (this.privIsDisposed) return [
                            2 /*return*/ 
                        ];
                        if (!disposing) return [
                            3 /*break*/ ,
                            3
                        ];
                        this.privIsDisposed = true;
                        return [
                            4 /*yield*/ ,
                            this.implRecognizerStop()
                        ];
                    case 1:
                        _a.sent();
                        return [
                            4 /*yield*/ ,
                            _super.prototype.dispose.call(this, disposing)
                        ];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    DialogServiceConnector.prototype.createRecognizerConfig = function(speechConfig) {
        return new $9MAMI.RecognizerConfig(speechConfig, this.privProperties);
    };
    DialogServiceConnector.prototype.createServiceRecognizer = function(authentication, connectionFactory, audioConfig, recognizerConfig) {
        var audioSource = audioConfig;
        return new $9MAMI.DialogServiceAdapter(authentication, connectionFactory, audioSource, recognizerConfig, this);
    };
    DialogServiceConnector.prototype.buildAgentConfig = function() {
        var communicationType = this.properties.getProperty("Conversation_Communication_Type", "Default");
        return {
            botInfo: {
                commType: communicationType,
                commandsCulture: undefined,
                connectionId: this.properties.getProperty($ChSMK.PropertyId.Conversation_Agent_Connection_Id),
                conversationId: this.properties.getProperty($ChSMK.PropertyId.Conversation_Conversation_Id, undefined),
                fromId: this.properties.getProperty($ChSMK.PropertyId.Conversation_From_Id, undefined),
                ttsAudioFormat: this.properties.getProperty($ChSMK.PropertyId.SpeechServiceConnection_SynthOutputFormat, undefined)
            },
            version: 0.2
        };
    };
    return DialogServiceConnector;
}($iQDnw.Recognizer);
module.exports.DialogServiceConnector = $bbd1dbd5ded6685d$var$DialogServiceConnector;

});
parcelRequire.register("hMLdw", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
var $cf2b8baf88546c73$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DialogConnectionFactory = void 0;

var $9h4kO = parcelRequire("9h4kO");

var $9MAMI = parcelRequire("9MAMI");

var $iQDnw = parcelRequire("iQDnw");

var $8EAiJ = parcelRequire("8EAiJ");

var $9MAMI = parcelRequire("9MAMI");

var $hiJX4 = parcelRequire("hiJX4");

var $gYscZ = parcelRequire("gYscZ");
var $cf2b8baf88546c73$var$DialogConnectionFactory = /** @class */ function(_super) {
    $cf2b8baf88546c73$var$__extends(DialogConnectionFactory, _super);
    function DialogConnectionFactory() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.create = function(config, authInfo, connectionId) {
            var applicationId = config.parameters.getProperty($iQDnw.PropertyId.Conversation_ApplicationId, "");
            var dialogType = config.parameters.getProperty($iQDnw.PropertyId.Conversation_DialogType);
            var region = config.parameters.getProperty($iQDnw.PropertyId.SpeechServiceConnection_Region);
            var language = config.parameters.getProperty($iQDnw.PropertyId.SpeechServiceConnection_RecoLanguage, "en-US");
            var requestTurnStatus = config.parameters.getProperty($iQDnw.PropertyId.Conversation_Request_Bot_Status_Messages, "true");
            var queryParams = {};
            queryParams[$hiJX4.HeaderNames.ConnectionId] = connectionId;
            queryParams[$gYscZ.QueryParameterNames.Format] = config.parameters.getProperty($9MAMI.OutputFormatPropertyName, $iQDnw.OutputFormat[$iQDnw.OutputFormat.Simple]).toLowerCase();
            queryParams[$gYscZ.QueryParameterNames.Language] = language;
            queryParams[$gYscZ.QueryParameterNames.RequestBotStatusMessages] = requestTurnStatus;
            if (applicationId) {
                queryParams[$gYscZ.QueryParameterNames.BotId] = applicationId;
                if (dialogType === $iQDnw.DialogServiceConfig.DialogTypes.CustomCommands) queryParams[$hiJX4.HeaderNames.CustomCommandsAppId] = applicationId;
            }
            var resourceInfix = dialogType === $iQDnw.DialogServiceConfig.DialogTypes.CustomCommands ? "commands/" : "";
            var version = dialogType === $iQDnw.DialogServiceConfig.DialogTypes.CustomCommands ? "v1" : dialogType === $iQDnw.DialogServiceConfig.DialogTypes.BotFramework ? "v3" : "v0";
            var headers = {};
            if (authInfo.token != null && authInfo.token !== "") headers[authInfo.headerName] = authInfo.token;
            // The URL used for connection is chosen in a priority order of specification:
            //  1. If a custom endpoint is provided, that URL is used verbatim.
            //  2. If a custom host is provided (e.g. "wss://my.custom.endpoint.com:1123"), a URL is constructed from it.
            //  3. If no custom connection details are provided, a URL is constructed from default values.
            var endpoint = config.parameters.getProperty($iQDnw.PropertyId.SpeechServiceConnection_Endpoint, "");
            if (!endpoint) {
                var hostSuffix = region && region.toLowerCase().startsWith("china") ? ".azure.cn" : ".microsoft.com";
                var host = config.parameters.getProperty($iQDnw.PropertyId.SpeechServiceConnection_Host, "wss://" + region + "." + DialogConnectionFactory.Constants.BaseUrl + hostSuffix);
                var standardizedHost = host.endsWith("/") ? host : host + "/";
                endpoint = "" + standardizedHost + resourceInfix + DialogConnectionFactory.Constants.ApiKey + "/" + version;
            }
            _this.setCommonUrlParams(config, queryParams, endpoint);
            var enableCompression = config.parameters.getProperty("SPEECH-EnableWebsocketCompression", "false") === "true";
            return new $9h4kO.WebsocketConnection(endpoint, queryParams, headers, new $9MAMI.WebsocketMessageFormatter(), $9h4kO.ProxyInfo.fromRecognizerConfig(config), enableCompression, connectionId);
        };
        return _this;
    }
    var _a;
    DialogConnectionFactory.Constants = (_a = /** @class */ function() {
        function class_1() {}
        return class_1;
    }(), _a.ApiKey = "api", _a.BaseUrl = "convai.speech", _a);
    return DialogConnectionFactory;
}($8EAiJ.ConnectionFactoryBase);
module.exports.DialogConnectionFactory = $cf2b8baf88546c73$var$DialogConnectionFactory;

});
parcelRequire.register("8EAiJ", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ConnectionFactoryBase = void 0;

var $9MAMI = parcelRequire("9MAMI");

var $iQDnw = parcelRequire("iQDnw");

var $gYscZ = parcelRequire("gYscZ");
var $64ce37ca295acf7c$var$ConnectionFactoryBase = /** @class */ function() {
    function ConnectionFactoryBase() {}
    ConnectionFactoryBase.prototype.setCommonUrlParams = function(config, queryParams, endpoint) {
        this.setUrlParameter($iQDnw.PropertyId.SpeechServiceConnection_EnableAudioLogging, $gYscZ.QueryParameterNames.EnableAudioLogging, config, queryParams, endpoint);
        this.setUrlParameter($iQDnw.PropertyId.SpeechServiceResponse_RequestWordLevelTimestamps, $gYscZ.QueryParameterNames.EnableWordLevelTimestamps, config, queryParams, endpoint);
        this.setUrlParameter($iQDnw.PropertyId.SpeechServiceResponse_ProfanityOption, $gYscZ.QueryParameterNames.Profanity, config, queryParams, endpoint);
        this.setUrlParameter($iQDnw.PropertyId.SpeechServiceConnection_InitialSilenceTimeoutMs, $gYscZ.QueryParameterNames.InitialSilenceTimeoutMs, config, queryParams, endpoint);
        this.setUrlParameter($iQDnw.PropertyId.SpeechServiceConnection_EndSilenceTimeoutMs, $gYscZ.QueryParameterNames.EndSilenceTimeoutMs, config, queryParams, endpoint);
        this.setUrlParameter($iQDnw.PropertyId.SpeechServiceResponse_StablePartialResultThreshold, $gYscZ.QueryParameterNames.StableIntermediateThreshold, config, queryParams, endpoint);
        var serviceProperties = JSON.parse(config.parameters.getProperty($9MAMI.ServicePropertiesPropertyName, "{}"));
        Object.keys(serviceProperties).forEach(function(value, num, array) {
            queryParams[value] = serviceProperties[value];
        });
    };
    ConnectionFactoryBase.prototype.setUrlParameter = function(propId, parameterName, config, queryParams, endpoint) {
        var value = config.parameters.getProperty(propId, undefined);
        if (value && (!endpoint || endpoint.search(parameterName) === -1)) queryParams[parameterName] = value.toLocaleLowerCase();
    };
    return ConnectionFactoryBase;
}();
module.exports.ConnectionFactoryBase = $64ce37ca295acf7c$var$ConnectionFactoryBase;

});
parcelRequire.register("gYscZ", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.QueryParameterNames = void 0;
var $c5b8218a391dc0ad$var$QueryParameterNames = /** @class */ function() {
    function QueryParameterNames() {}
    QueryParameterNames.BotId = "botid";
    QueryParameterNames.CustomSpeechDeploymentId = "cid";
    QueryParameterNames.CustomVoiceDeploymentId = "deploymentId";
    QueryParameterNames.EnableAudioLogging = "storeAudio";
    QueryParameterNames.EnableLanguageId = "lidEnabled";
    QueryParameterNames.EnableWordLevelTimestamps = "wordLevelTimestamps";
    QueryParameterNames.EndSilenceTimeoutMs = "endSilenceTimeoutMs";
    QueryParameterNames.Format = "format";
    QueryParameterNames.InitialSilenceTimeoutMs = "initialSilenceTimeoutMs";
    QueryParameterNames.Language = "language";
    QueryParameterNames.Profanity = "profanity";
    QueryParameterNames.RequestBotStatusMessages = "enableBotMessageStatus";
    QueryParameterNames.StableIntermediateThreshold = "stableIntermediateThreshold";
    QueryParameterNames.StableTranslation = "stableTranslation";
    QueryParameterNames.TestHooks = "testhooks";
    return QueryParameterNames;
}();
module.exports.QueryParameterNames = $c5b8218a391dc0ad$var$QueryParameterNames;

});




parcelRequire.register("ev1KH", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActivityReceivedEventArgs = void 0;
/**
 * Defines contents of received message/events.
 * @class ActivityReceivedEventArgs
 */ var $a8e551de5e8762d9$var$ActivityReceivedEventArgs = /** @class */ function() {
    /**
     * Creates and initializes an instance of this class.
     * @constructor
     * @param {any} activity - The activity..
     */ function ActivityReceivedEventArgs(activity, audioStream) {
        this.privActivity = activity;
        this.privAudioStream = audioStream;
    }
    Object.defineProperty(ActivityReceivedEventArgs.prototype, "activity", {
        /**
         * Gets the received activity
         * @member ActivityReceivedEventArgs.prototype.activity
         * @function
         * @public
         * @returns {any} the received activity.
         */ get: function() {
            return this.privActivity;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ActivityReceivedEventArgs.prototype, "audioStream", {
        get: function() {
            return this.privAudioStream;
        },
        enumerable: false,
        configurable: true
    });
    return ActivityReceivedEventArgs;
}();
module.exports.ActivityReceivedEventArgs = $a8e551de5e8762d9$var$ActivityReceivedEventArgs;

});

parcelRequire.register("cTX1T", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TurnStatusReceivedEventArgs = void 0;

var $8wz1X = parcelRequire("8wz1X");
/**
 * Defines contents of received message/events.
 * @class TurnStatusReceivedEventArgs
 */ var $9648691c3a0d3aa1$var$TurnStatusReceivedEventArgs = /** @class */ function() {
    /**
     * Creates and initializes an instance of this class.
     * @constructor
     * @param {string} turnStatus - The JSON-encoded turn status message.
     */ function TurnStatusReceivedEventArgs(turnStatus) {
        this.privTurnStatus = $8wz1X.TurnStatusResponsePayload.fromJSON(turnStatus);
    }
    Object.defineProperty(TurnStatusReceivedEventArgs.prototype, "interactionId", {
        /**
         * Gets the interaction identifier associated with this turn status event.
         * @member TurnStatusReceivedEventArgs.prototype.interactionId
         * @function
         * @public
         * @returns {any} the received interaction id.
         */ get: function() {
            return this.privTurnStatus.interactionId;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TurnStatusReceivedEventArgs.prototype, "conversationId", {
        /**
         * Gets the conversation identifier associated with this turn status event.
         * @member TurnStatusReceivedEventArgs.prototype.conversationId
         * @function
         * @public
         * @returns {any} the received conversation id.
         */ get: function() {
            return this.privTurnStatus.conversationId;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TurnStatusReceivedEventArgs.prototype, "statusCode", {
        /**
         * Gets the received turn status code.
         * @member TurnStatusReceivedEventArgs.prototype.statusCode
         * @function
         * @public
         * @returns {number} the received turn status.
         */ get: function() {
            return this.privTurnStatus.statusCode;
        },
        enumerable: false,
        configurable: true
    });
    return TurnStatusReceivedEventArgs;
}();
module.exports.TurnStatusReceivedEventArgs = $9648691c3a0d3aa1$var$TurnStatusReceivedEventArgs;

});
parcelRequire.register("8wz1X", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TurnStatusResponsePayload = void 0;
var $634c7c3dac880ff6$var$TurnStatusResponsePayload = /** @class */ function() {
    function TurnStatusResponsePayload(json) {
        this.privMessageStatusResponse = JSON.parse(json);
    }
    TurnStatusResponsePayload.fromJSON = function(json) {
        return new TurnStatusResponsePayload(json);
    };
    Object.defineProperty(TurnStatusResponsePayload.prototype, "interactionId", {
        get: function() {
            return this.privMessageStatusResponse.interactionId;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TurnStatusResponsePayload.prototype, "conversationId", {
        get: function() {
            return this.privMessageStatusResponse.conversationId;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TurnStatusResponsePayload.prototype, "statusCode", {
        get: function() {
            // Payloads may contain a limited set of textual representations or a numeric status
            // code. The textual values are here converted into numeric ones.
            switch(this.privMessageStatusResponse.statusCode){
                case "Success":
                    return 200;
                case "Failed":
                    return 400;
                case "TimedOut":
                    return 429;
                default:
                    return this.privMessageStatusResponse.statusCode;
            }
        },
        enumerable: false,
        configurable: true
    });
    return TurnStatusResponsePayload;
}();
module.exports.TurnStatusResponsePayload = $634c7c3dac880ff6$var$TurnStatusResponsePayload;

});


parcelRequire.register("7yzTn", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ServicePropertyChannel = void 0;
/**
 * Defines channels used to pass property settings to service.
 * Added in version 1.7.0.
 */ var $58078ccd79e0124b$var$ServicePropertyChannel;
(function(ServicePropertyChannel) {
    /**
     * Uses URI query parameter to pass property settings to service.
     */ ServicePropertyChannel[ServicePropertyChannel["UriQueryParameter"] = 0] = "UriQueryParameter";
})($58078ccd79e0124b$var$ServicePropertyChannel = module.exports.ServicePropertyChannel || (module.exports.ServicePropertyChannel = {}));

});

parcelRequire.register("VYwrl", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ProfanityOption = void 0;
/**
 * Profanity option.
 * Added in version 1.7.0.
 */ var $0ae445707ad8e0e4$var$ProfanityOption;
(function(ProfanityOption) {
    ProfanityOption[ProfanityOption["Masked"] = 0] = "Masked";
    ProfanityOption[ProfanityOption["Removed"] = 1] = "Removed";
    ProfanityOption[ProfanityOption["Raw"] = 2] = "Raw";
})($0ae445707ad8e0e4$var$ProfanityOption = module.exports.ProfanityOption || (module.exports.ProfanityOption = {}));

});

parcelRequire.register("d4W5o", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
var $9858b4ba899dc570$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $9858b4ba899dc570$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.BaseAudioPlayer = void 0;

var $7YICj = parcelRequire("7YICj");

var $5uWXA = parcelRequire("5uWXA");

var $iQDnw = parcelRequire("iQDnw");

var $7PHxc = parcelRequire("7PHxc");
/**
 * Base audio player class
 * TODO: Plays only PCM for now.
 * @class
 */ var $9858b4ba899dc570$var$BaseAudioPlayer = /** @class */ function() {
    /**
     * Creates and initializes an instance of this class.
     * @constructor
     * @param {AudioStreamFormat} audioFormat audio stream format recognized by the player.
     */ function BaseAudioPlayer(audioFormat) {
        this.audioContext = null;
        this.gainNode = null;
        this.autoUpdateBufferTimer = 0;
        if (audioFormat === undefined) audioFormat = $iQDnw.AudioStreamFormat.getDefaultInputFormat();
        this.init(audioFormat);
    }
    /**
     * play Audio sample
     * @param newAudioData audio data to be played.
     */ BaseAudioPlayer.prototype.playAudioSample = function(newAudioData, cb, err) {
        var _this = this;
        $5uWXA.marshalPromiseToCallbacks(function() {
            return $9858b4ba899dc570$var$__awaiter(_this, void 0, void 0, function() {
                var audioData, newSamplesData;
                return $9858b4ba899dc570$var$__generator(this, function(_a) {
                    this.ensureInitializedContext();
                    audioData = this.formatAudioData(newAudioData);
                    newSamplesData = new Float32Array(this.samples.length + audioData.length);
                    newSamplesData.set(this.samples, 0);
                    newSamplesData.set(audioData, this.samples.length);
                    this.samples = newSamplesData;
                    return [
                        2 /*return*/ 
                    ];
                });
            });
        }(), cb, err);
    };
    /**
     * stops audio and clears the buffers
     */ BaseAudioPlayer.prototype.stopAudio = function(cb, err) {
        if (this.audioContext !== null) {
            this.samples = new Float32Array();
            clearInterval(this.autoUpdateBufferTimer);
            this.audioContext.close().then(function() {
                if (!!cb) cb();
            }, function(error) {
                if (!!err) err(error);
            });
            this.audioContext = null;
        }
    };
    BaseAudioPlayer.prototype.init = function(audioFormat) {
        this.audioFormat = audioFormat;
        this.samples = new Float32Array();
    };
    BaseAudioPlayer.prototype.ensureInitializedContext = function() {
        var _this = this;
        if (this.audioContext === null) {
            this.createAudioContext();
            var timerPeriod = 200;
            this.autoUpdateBufferTimer = setInterval(function() {
                _this.updateAudioBuffer();
            }, timerPeriod);
        }
    };
    BaseAudioPlayer.prototype.createAudioContext = function() {
        // new ((window as any).AudioContext || (window as any).webkitAudioContext)();
        this.audioContext = $7PHxc.AudioStreamFormatImpl.getAudioContext();
        // TODO: Various examples shows this gain node, it does not seem to be needed unless we plan
        // to control the volume, not likely
        this.gainNode = this.audioContext.createGain();
        this.gainNode.gain.value = 1;
        this.gainNode.connect(this.audioContext.destination);
        this.startTime = this.audioContext.currentTime;
    };
    BaseAudioPlayer.prototype.formatAudioData = function(audioData) {
        switch(this.audioFormat.bitsPerSample){
            case 8:
                return this.formatArrayBuffer(new Int8Array(audioData), 128);
            case 16:
                return this.formatArrayBuffer(new Int16Array(audioData), 32768);
            case 32:
                return this.formatArrayBuffer(new Int32Array(audioData), 2147483648);
            default:
                throw new $7YICj.InvalidOperationError("Only WAVE_FORMAT_PCM (8/16/32 bps) format supported at this time");
        }
    };
    BaseAudioPlayer.prototype.formatArrayBuffer = function(audioData, maxValue) {
        var float32Data = new Float32Array(audioData.length);
        for(var i = 0; i < audioData.length; i++)float32Data[i] = audioData[i] / maxValue;
        return float32Data;
    };
    BaseAudioPlayer.prototype.updateAudioBuffer = function() {
        if (this.samples.length === 0) return;
        var channelCount = this.audioFormat.channels;
        var bufferSource = this.audioContext.createBufferSource();
        var frameCount = this.samples.length / channelCount;
        var audioBuffer = this.audioContext.createBuffer(channelCount, frameCount, this.audioFormat.samplesPerSec);
        // TODO: Should we do the conversion in the pushAudioSample instead?
        for(var channel = 0; channel < channelCount; channel++){
            // Fill in individual channel data
            var channelOffset = channel;
            var audioData = audioBuffer.getChannelData(channel);
            for(var i = 0; i < this.samples.length; i++, channelOffset += channelCount)audioData[i] = this.samples[channelOffset];
        }
        if (this.startTime < this.audioContext.currentTime) this.startTime = this.audioContext.currentTime;
        bufferSource.buffer = audioBuffer;
        bufferSource.connect(this.gainNode);
        bufferSource.start(this.startTime);
        // Make sure we play the next sample after the current one.
        this.startTime += audioBuffer.duration;
        // Clear the samples for the next pushed data.
        this.samples = new Float32Array();
    };
    BaseAudioPlayer.prototype.playAudio = function(audioData) {
        return $9858b4ba899dc570$var$__awaiter(this, void 0, void 0, function() {
            var source, destination;
            return $9858b4ba899dc570$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (this.audioContext === null) this.createAudioContext();
                        source = this.audioContext.createBufferSource();
                        destination = this.audioContext.destination;
                        return [
                            4 /*yield*/ ,
                            this.audioContext.decodeAudioData(audioData, function(newBuffer) {
                                source.buffer = newBuffer;
                                source.connect(destination);
                                source.start(0);
                            })
                        ];
                    case 1:
                        _a.sent();
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    return BaseAudioPlayer;
}();
module.exports.BaseAudioPlayer = $9858b4ba899dc570$var$BaseAudioPlayer;

});

parcelRequire.register("luex6", function(module, exports) {
"use strict";
//
// Copyright (c) Microsoft. All rights reserved.
// Licensed under the MIT license. See LICENSE.md file in the project root for full license information.
//
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ConnectionMessageEventArgs = void 0;
var $fa47ac46582cadae$var$ConnectionMessageEventArgs = /** @class */ function() {
    function ConnectionMessageEventArgs(message) {
        this.privConnectionMessage = message;
    }
    Object.defineProperty(ConnectionMessageEventArgs.prototype, "message", {
        /**
         * Gets the <see cref="ConnectionMessage"/> associated with this <see cref="ConnectionMessageEventArgs"/>.
         */ get: function() {
            return this.privConnectionMessage;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Returns a string that represents the connection message event.
     */ ConnectionMessageEventArgs.prototype.toString = function() {
        return "Message: " + this.privConnectionMessage.toString();
    };
    return ConnectionMessageEventArgs;
}();
module.exports.ConnectionMessageEventArgs = $fa47ac46582cadae$var$ConnectionMessageEventArgs;

});

parcelRequire.register("9Culy", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.VoiceProfile = void 0;
/**
 * Defines Voice Profile class for Speaker Recognition
 * @class VoiceProfile
 */ var $700f33e0deec5758$var$VoiceProfile = /** @class */ function() {
    /**
     * Creates and initializes an instance of this class.
     * @constructor
     * @param {string} profileId - profileId of this Voice Profile.
     * @param {VoiceProfileType} profileType - profileType of this Voice Profile.
     */ function VoiceProfile(profileId, profileType) {
        this.privId = profileId;
        this.privProfileType = profileType;
    }
    Object.defineProperty(VoiceProfile.prototype, "profileId", {
        /**
         * profileId of this Voice Profile instance
         * @member VoiceProfile.prototype.profileId
         * @function
         * @public
         * @returns {string} profileId of this Voice Profile instance.
         */ get: function() {
            return this.privId;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(VoiceProfile.prototype, "profileType", {
        /**
         * profileType of this Voice Profile instance
         * @member VoiceProfile.prototype.profileType
         * @function
         * @public
         * @returns {VoiceProfileType} profile type of this Voice Profile instance.
         */ get: function() {
            return this.privProfileType;
        },
        enumerable: false,
        configurable: true
    });
    return VoiceProfile;
}();
module.exports.VoiceProfile = $700f33e0deec5758$var$VoiceProfile;

});

parcelRequire.register("bKnbO", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
var $88d5fa8e8699407e$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.VoiceProfileEnrollmentCancellationDetails = module.exports.VoiceProfileEnrollmentResult = void 0;

var $9MAMI = parcelRequire("9MAMI");

var $iQDnw = parcelRequire("iQDnw");
/**
 * Output format
 * @class VoiceProfileEnrollmentResult
 */ var $88d5fa8e8699407e$var$VoiceProfileEnrollmentResult = /** @class */ function() {
    function VoiceProfileEnrollmentResult(reason, json, statusText) {
        this.privReason = reason;
        this.privProperties = new $iQDnw.PropertyCollection();
        if (this.privReason !== $iQDnw.ResultReason.Canceled) {
            if (!!json) {
                this.privDetails = JSON.parse(json);
                if (this.privDetails.enrollmentStatus.toLowerCase() === "enrolling") this.privReason = $iQDnw.ResultReason.EnrollingVoiceProfile;
            }
        } else {
            this.privErrorDetails = statusText;
            this.privProperties.setProperty($9MAMI.CancellationErrorCodePropertyName, $iQDnw.CancellationErrorCode[$iQDnw.CancellationErrorCode.ServiceError]);
        }
    }
    VoiceProfileEnrollmentResult.FromIdentificationProfileList = function(json) {
        var results = [];
        for(var _i = 0, _a = json.profiles; _i < _a.length; _i++){
            var item = _a[_i];
            var reason = item.enrollmentStatus.toLowerCase() === "enrolling" ? $iQDnw.ResultReason.EnrollingVoiceProfile : item.enrollmentStatus.toLowerCase() === "enrolled" ? $iQDnw.ResultReason.EnrolledVoiceProfile : $iQDnw.ResultReason.Canceled;
            var result = new VoiceProfileEnrollmentResult(reason, null, null);
            result.privDetails = this.getIdentificationDetails(item);
            results.push(result);
        }
        return results;
    };
    VoiceProfileEnrollmentResult.FromVerificationProfileList = function(json) {
        var results = [];
        for(var _i = 0, _a = json.profiles; _i < _a.length; _i++){
            var item = _a[_i];
            var reason = item.enrollmentStatus.toLowerCase() === "enrolling" ? $iQDnw.ResultReason.EnrollingVoiceProfile : item.enrollmentStatus.toLowerCase() === "enrolled" ? $iQDnw.ResultReason.EnrolledVoiceProfile : $iQDnw.ResultReason.Canceled;
            var result = new VoiceProfileEnrollmentResult(reason, null, null);
            result.privDetails = this.getVerificationDetails(item);
            results.push(result);
        }
        return results;
    };
    Object.defineProperty(VoiceProfileEnrollmentResult.prototype, "reason", {
        get: function() {
            return this.privReason;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(VoiceProfileEnrollmentResult.prototype, "enrollmentsCount", {
        get: function() {
            return this.privDetails.enrollmentsCount;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(VoiceProfileEnrollmentResult.prototype, "enrollmentsLength", {
        get: function() {
            return this.privDetails.enrollmentsLength;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(VoiceProfileEnrollmentResult.prototype, "properties", {
        get: function() {
            return this.privProperties;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(VoiceProfileEnrollmentResult.prototype, "enrollmentResultDetails", {
        get: function() {
            return this.privDetails;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(VoiceProfileEnrollmentResult.prototype, "errorDetails", {
        get: function() {
            return this.privErrorDetails;
        },
        enumerable: false,
        configurable: true
    });
    VoiceProfileEnrollmentResult.getIdentificationDetails = function(json) {
        return {
            audioSpeechLength: json.speechTime ? parseFloat(json.speechTime) : 0,
            enrollmentStatus: json.enrollmentStatus,
            enrollmentsLength: json.enrollmentSpeechTime ? parseFloat(json.enrollmentSpeechTime) : 0,
            profileId: json.profileId || json.identificationProfileId,
            remainingEnrollmentSpeechLength: json.remainingEnrollmentSpeechTime ? parseFloat(json.remainingEnrollmentSpeechTime) : 0
        };
    };
    VoiceProfileEnrollmentResult.getVerificationDetails = function(json) {
        return {
            enrollmentStatus: json.enrollmentStatus,
            enrollmentsCount: json.enrollmentsCount,
            profileId: json.profileId || json.verificationProfileId,
            remainingEnrollmentSpeechLength: json.remainingEnrollmentSpeechLength ? parseFloat(json.remainingEnrollmentSpeechLength) : 0,
            remainingEnrollmentsCount: json.remainingEnrollments || json.remainingEnrollmentsCount
        };
    };
    return VoiceProfileEnrollmentResult;
}();
module.exports.VoiceProfileEnrollmentResult = $88d5fa8e8699407e$var$VoiceProfileEnrollmentResult;
/**
 * @class VoiceProfileEnrollmentCancellationDetails
 */ // tslint:disable-next-line:max-classes-per-file
var $88d5fa8e8699407e$var$VoiceProfileEnrollmentCancellationDetails = /** @class */ function(_super) {
    $88d5fa8e8699407e$var$__extends(VoiceProfileEnrollmentCancellationDetails, _super);
    function VoiceProfileEnrollmentCancellationDetails(reason, errorDetails, errorCode) {
        return _super.call(this, reason, errorDetails, errorCode) || this;
    }
    /**
     * Creates an instance of VoiceProfileEnrollmentCancellationDetails object for the canceled VoiceProfileEnrollmentResult.
     * @member VoiceProfileEnrollmentCancellationDetails.fromResult
     * @function
     * @public
     * @param {VoiceProfileEnrollmentResult} result - The result that was canceled.
     * @returns {VoiceProfileEnrollmentCancellationDetails} The cancellation details object being created.
     */ VoiceProfileEnrollmentCancellationDetails.fromResult = function(result) {
        var reason = $iQDnw.CancellationReason.Error;
        var errorCode = $iQDnw.CancellationErrorCode.NoError;
        if (!!result.properties) errorCode = $iQDnw.CancellationErrorCode[result.properties.getProperty($9MAMI.CancellationErrorCodePropertyName, $iQDnw.CancellationErrorCode[$iQDnw.CancellationErrorCode.NoError])];
        return new VoiceProfileEnrollmentCancellationDetails(reason, result.errorDetails, errorCode);
    };
    return VoiceProfileEnrollmentCancellationDetails;
}($iQDnw.CancellationDetailsBase);
module.exports.VoiceProfileEnrollmentCancellationDetails = $88d5fa8e8699407e$var$VoiceProfileEnrollmentCancellationDetails;

});

parcelRequire.register("bnJgP", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
var $8494f573df12ad1d$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.VoiceProfileCancellationDetails = module.exports.VoiceProfileResult = void 0;

var $9MAMI = parcelRequire("9MAMI");

var $evvAW = parcelRequire("evvAW");

var $iQDnw = parcelRequire("iQDnw");
/**
 * Output format
 * @class VoiceProfileResult
 */ var $8494f573df12ad1d$var$VoiceProfileResult = /** @class */ function() {
    function VoiceProfileResult(reason, statusText) {
        this.privReason = reason;
        this.privProperties = new $iQDnw.PropertyCollection();
        if (reason === $iQDnw.ResultReason.Canceled) {
            $evvAW.Contracts.throwIfNullOrUndefined(statusText, "statusText");
            this.privErrorDetails = statusText;
            this.privProperties.setProperty($9MAMI.CancellationErrorCodePropertyName, $iQDnw.CancellationErrorCode[$iQDnw.CancellationErrorCode.ServiceError]);
        }
    }
    Object.defineProperty(VoiceProfileResult.prototype, "reason", {
        get: function() {
            return this.privReason;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(VoiceProfileResult.prototype, "properties", {
        get: function() {
            return this.privProperties;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(VoiceProfileResult.prototype, "errorDetails", {
        get: function() {
            return this.privErrorDetails;
        },
        enumerable: false,
        configurable: true
    });
    return VoiceProfileResult;
}();
module.exports.VoiceProfileResult = $8494f573df12ad1d$var$VoiceProfileResult;
/**
 * @class VoiceProfileCancellationDetails
 */ // tslint:disable-next-line:max-classes-per-file
var $8494f573df12ad1d$var$VoiceProfileCancellationDetails = /** @class */ function(_super) {
    $8494f573df12ad1d$var$__extends(VoiceProfileCancellationDetails, _super);
    function VoiceProfileCancellationDetails(reason, errorDetails, errorCode) {
        return _super.call(this, reason, errorDetails, errorCode) || this;
    }
    /**
     * Creates an instance of VoiceProfileCancellationDetails object for the canceled VoiceProfileResult.
     * @member VoiceProfileCancellationDetails.fromResult
     * @function
     * @public
     * @param {VoiceProfileResult} result - The result that was canceled.
     * @returns {VoiceProfileCancellationDetails} The cancellation details object being created.
     */ VoiceProfileCancellationDetails.fromResult = function(result) {
        var reason = $iQDnw.CancellationReason.Error;
        var errorCode = $iQDnw.CancellationErrorCode.NoError;
        if (!!result.properties) errorCode = $iQDnw.CancellationErrorCode[result.properties.getProperty($9MAMI.CancellationErrorCodePropertyName, $iQDnw.CancellationErrorCode[$iQDnw.CancellationErrorCode.NoError])];
        return new VoiceProfileCancellationDetails(reason, result.errorDetails, errorCode);
    };
    return VoiceProfileCancellationDetails;
}($iQDnw.CancellationDetailsBase);
module.exports.VoiceProfileCancellationDetails = $8494f573df12ad1d$var$VoiceProfileCancellationDetails;

});

parcelRequire.register("bUVPH", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
var $8ad1c9141db114a0$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.VoiceProfileAuthorizationPhraseResult = void 0;

var $evvAW = parcelRequire("evvAW");

var $iQDnw = parcelRequire("iQDnw");
/**
 * Output format
 * @class VoiceProfileAuthorizationPhraseResult
 */ var $8ad1c9141db114a0$var$VoiceProfileAuthorizationPhraseResult = /** @class */ function(_super) {
    $8ad1c9141db114a0$var$__extends(VoiceProfileAuthorizationPhraseResult, _super);
    function VoiceProfileAuthorizationPhraseResult(reason, statusText, json) {
        var _this = _super.call(this, reason, statusText) || this;
        _this.privPhrases = [];
        $evvAW.Contracts.throwIfNullOrUndefined(json, "phrases array");
        for(var _i = 0, json_1 = json; _i < json_1.length; _i++){
            var item = json_1[_i];
            _this.privPhrases.push(item.passPhrase);
        }
        return _this;
    }
    Object.defineProperty(VoiceProfileAuthorizationPhraseResult.prototype, "phrases", {
        get: function() {
            return this.privPhrases;
        },
        enumerable: false,
        configurable: true
    });
    return VoiceProfileAuthorizationPhraseResult;
}($iQDnw.VoiceProfileResult);
module.exports.VoiceProfileAuthorizationPhraseResult = $8ad1c9141db114a0$var$VoiceProfileAuthorizationPhraseResult;

});

parcelRequire.register("hxIBD", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
var $cc581e8c587b634d$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $cc581e8c587b634d$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.VoiceProfileClient = void 0;

var $9MAMI = parcelRequire("9MAMI");

var $7srwU = parcelRequire("7srwU");

var $evvAW = parcelRequire("evvAW");

var $iQDnw = parcelRequire("iQDnw");
/**
 * Defines VoiceProfileClient class for Speaker Recognition
 * Handles operations from user for Voice Profile operations (e.g. createProfile, deleteProfile)
 * @class VoiceProfileClient
 */ var $cc581e8c587b634d$var$VoiceProfileClient = /** @class */ function() {
    /**
     * VoiceProfileClient constructor.
     * @constructor
     * @param {SpeechConfig} speechConfig - An set of initial properties for this synthesizer (authentication key, region, &c)
     */ function VoiceProfileClient(speechConfig) {
        var speechConfigImpl = speechConfig;
        $evvAW.Contracts.throwIfNull(speechConfigImpl, "speechConfig");
        this.privProperties = speechConfigImpl.properties.clone();
        this.implClientSetup();
    }
    Object.defineProperty(VoiceProfileClient.prototype, "authorizationToken", {
        /**
         * Gets the authorization token used to communicate with the service.
         * @member VoiceProfileClient.prototype.authorizationToken
         * @function
         * @public
         * @returns {string} Authorization token.
         */ get: function() {
            return this.properties.getProperty($iQDnw.PropertyId.SpeechServiceAuthorization_Token);
        },
        /**
         * Gets/Sets the authorization token used to communicate with the service.
         * @member VoiceProfileClient.prototype.authorizationToken
         * @function
         * @public
         * @param {string} token - Authorization token.
         */ set: function(token) {
            $evvAW.Contracts.throwIfNullOrWhitespace(token, "token");
            this.properties.setProperty($iQDnw.PropertyId.SpeechServiceAuthorization_Token, token);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(VoiceProfileClient.prototype, "properties", {
        /**
         * The collection of properties and their values defined for this VoiceProfileClient.
         * @member VoiceProfileClient.prototype.properties
         * @function
         * @public
         * @returns {PropertyCollection} The collection of properties and their values defined for this VoiceProfileClient.
         */ get: function() {
            return this.privProperties;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Create a speaker recognition voice profile
     * @member VoiceProfileClient.prototype.createProfileAsync
     * @function
     * @public
     * @param {VoiceProfileType} profileType Type of Voice Profile to be created
     *        specifies the keyword to be recognized.
     * @param {string} lang Language string (locale) for Voice Profile
     * @param cb - Callback invoked once Voice Profile has been created.
     * @param err - Callback invoked in case of an error.
     */ VoiceProfileClient.prototype.createProfileAsync = function(profileType, lang, cb, err) {
        var _this = this;
        $7srwU.marshalPromiseToCallbacks(function() {
            return $cc581e8c587b634d$var$__awaiter(_this, void 0, void 0, function() {
                var result, response, profile;
                return $cc581e8c587b634d$var$__generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            return [
                                4 /*yield*/ ,
                                this.privAdapter.createProfile(profileType, lang)
                            ];
                        case 1:
                            result = _a.sent();
                            response = result.json();
                            profile = new $iQDnw.VoiceProfile(response.profileId, profileType);
                            return [
                                2 /*return*/ ,
                                profile
                            ];
                    }
                });
            });
        }(), cb, err);
    };
    /**
     * Get current information of a voice profile
     * @member VoiceProfileClient.prototype.retrieveEnrollmentResultAsync
     * @function
     * @public
     * @param {VoiceProfile} profile Voice Profile to retrieve info for
     * @param cb - Callback invoked once Voice Profile has been created.
     * @param err - Callback invoked in case of an error.
     */ VoiceProfileClient.prototype.retrieveEnrollmentResultAsync = function(profile, cb, err) {
        var _this = this;
        $7srwU.marshalPromiseToCallbacks(function() {
            return $cc581e8c587b634d$var$__awaiter(_this, void 0, void 0, function() {
                var result;
                return $cc581e8c587b634d$var$__generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            return [
                                4 /*yield*/ ,
                                this.privAdapter.getProfileStatus(profile)
                            ];
                        case 1:
                            result = _a.sent();
                            return [
                                2 /*return*/ ,
                                new $iQDnw.VoiceProfileEnrollmentResult(result.ok ? $iQDnw.ResultReason.EnrolledVoiceProfile : $iQDnw.ResultReason.Canceled, result.data, result.statusText)
                            ];
                    }
                });
            });
        }(), cb, err);
    };
    /**
     * Get all voice profiles on account with given voice profile type
     * @member VoiceProfileClient.prototype.getAllProfilesAsync
     * @function
     * @public
     * @param {VoiceProfileType} profileType profile type (identification/verification) for which to list profiles
     * @param cb - Callback invoked once Profile list has been returned.
     * @param err - Callback invoked in case of an error.
     */ VoiceProfileClient.prototype.getAllProfilesAsync = function(profileType, cb, err) {
        var _this = this;
        $7srwU.marshalPromiseToCallbacks(function() {
            return $cc581e8c587b634d$var$__awaiter(_this, void 0, void 0, function() {
                var result;
                return $cc581e8c587b634d$var$__generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            return [
                                4 /*yield*/ ,
                                this.privAdapter.getProfiles(profileType)
                            ];
                        case 1:
                            result = _a.sent();
                            if (profileType === $iQDnw.VoiceProfileType.TextIndependentIdentification) return [
                                2 /*return*/ ,
                                $iQDnw.VoiceProfileEnrollmentResult.FromIdentificationProfileList(result.json())
                            ];
                            return [
                                2 /*return*/ ,
                                $iQDnw.VoiceProfileEnrollmentResult.FromVerificationProfileList(result.json())
                            ];
                    }
                });
            });
        }(), cb, err);
    };
    /**
     * Get valid authorization phrases for voice profile enrollment
     * @member VoiceProfileClient.prototype.getAuthorizationPhrasesAsync
     * @function
     * @public
     * @param {string} lang Language string (locale) for Voice Profile
     * @param cb - Callback invoked once phrases have been returned.
     * @param err - Callback invoked in case of an error.
     */ VoiceProfileClient.prototype.getAuthorizationPhrasesAsync = function(lang, cb, err) {
        var _this = this;
        $7srwU.marshalPromiseToCallbacks(function() {
            return $cc581e8c587b634d$var$__awaiter(_this, void 0, void 0, function() {
                var result;
                return $cc581e8c587b634d$var$__generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            return [
                                4 /*yield*/ ,
                                this.privAdapter.getAuthorizationPhrases(lang)
                            ];
                        case 1:
                            result = _a.sent();
                            return [
                                2 /*return*/ ,
                                new $iQDnw.VoiceProfileAuthorizationPhraseResult(result.ok ? $iQDnw.ResultReason.EnrollingVoiceProfile : $iQDnw.ResultReason.Canceled, result.statusText, result.json())
                            ];
                    }
                });
            });
        }(), cb, err);
    };
    /**
     * Create a speaker recognition voice profile
     * @member VoiceProfileClient.prototype.enrollProfileAsync
     * @function
     * @public
     * @param {VoiceProfile} profile Voice Profile to create enrollment for
     * @param {AudioConfig} audioConfig source info from which to create enrollment
     * @param cb - Callback invoked once Enrollment request has been submitted.
     * @param err - Callback invoked in case of an error.
     */ VoiceProfileClient.prototype.enrollProfileAsync = function(profile, audioConfig, cb, err) {
        var _this = this;
        var configImpl = audioConfig;
        $evvAW.Contracts.throwIfNullOrUndefined(configImpl, "audioConfig");
        $7srwU.marshalPromiseToCallbacks(function() {
            return $cc581e8c587b634d$var$__awaiter(_this, void 0, void 0, function() {
                var result;
                return $cc581e8c587b634d$var$__generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            return [
                                4 /*yield*/ ,
                                this.privAdapter.createEnrollment(profile, configImpl)
                            ];
                        case 1:
                            result = _a.sent();
                            return [
                                2 /*return*/ ,
                                new $iQDnw.VoiceProfileEnrollmentResult(result.ok ? $iQDnw.ResultReason.EnrolledVoiceProfile : $iQDnw.ResultReason.Canceled, result.data, result.statusText)
                            ];
                    }
                });
            });
        }(), cb, err);
    };
    /**
     * Delete a speaker recognition voice profile
     * @member VoiceProfileClient.prototype.deleteProfileAsync
     * @function
     * @public
     * @param {VoiceProfile} profile Voice Profile to be deleted
     * @param cb - Callback invoked once Voice Profile has been deleted.
     * @param err - Callback invoked in case of an error.
     */ VoiceProfileClient.prototype.deleteProfileAsync = function(profile, cb, err) {
        var _this = this;
        $7srwU.marshalPromiseToCallbacks(function() {
            return $cc581e8c587b634d$var$__awaiter(_this, void 0, void 0, function() {
                var result;
                return $cc581e8c587b634d$var$__generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            return [
                                4 /*yield*/ ,
                                this.privAdapter.deleteProfile(profile)
                            ];
                        case 1:
                            result = _a.sent();
                            return [
                                2 /*return*/ ,
                                this.getResult(result, $iQDnw.ResultReason.DeletedVoiceProfile)
                            ];
                    }
                });
            });
        }(), cb, err);
    };
    /**
     * Remove all enrollments for a speaker recognition voice profile
     * @member VoiceProfileClient.prototype.resetProfileAsync
     * @function
     * @public
     * @param {VoiceProfile} profile Voice Profile to be reset
     * @param cb - Callback invoked once Voice Profile has been reset.
     * @param err - Callback invoked in case of an error.
     */ VoiceProfileClient.prototype.resetProfileAsync = function(profile, cb, err) {
        var _this = this;
        $7srwU.marshalPromiseToCallbacks(function() {
            return $cc581e8c587b634d$var$__awaiter(_this, void 0, void 0, function() {
                var result;
                return $cc581e8c587b634d$var$__generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            return [
                                4 /*yield*/ ,
                                this.privAdapter.resetProfile(profile)
                            ];
                        case 1:
                            result = _a.sent();
                            return [
                                2 /*return*/ ,
                                this.getResult(result, $iQDnw.ResultReason.ResetVoiceProfile)
                            ];
                    }
                });
            });
        }(), cb, err);
    };
    /**
     * Included for compatibility
     * @member VoiceProfileClient.prototype.close
     * @function
     * @public
     */ VoiceProfileClient.prototype.close = function() {
        return;
    };
    // Does class setup, swiped from Recognizer.
    VoiceProfileClient.prototype.implClientSetup = function() {
        var osPlatform = typeof window !== "undefined" ? "Browser" : "Node";
        var osName = "unknown";
        var osVersion = "unknown";
        if (typeof navigator !== "undefined") {
            osPlatform = osPlatform + "/" + navigator.platform;
            osName = navigator.userAgent;
            osVersion = navigator.appVersion;
        }
        var recognizerConfig = new $9MAMI.SpeakerRecognitionConfig(new $9MAMI.Context(new $9MAMI.OS(osPlatform, osName, osVersion)), this.privProperties);
        this.privAdapter = new $9MAMI.SpeakerIdMessageAdapter(recognizerConfig);
    };
    VoiceProfileClient.prototype.getResult = function(result, successReason, cb) {
        var response = new $iQDnw.VoiceProfileResult(result.ok ? successReason : $iQDnw.ResultReason.Canceled, result.statusText);
        return response;
    };
    return VoiceProfileClient;
}();
module.exports.VoiceProfileClient = $cc581e8c587b634d$var$VoiceProfileClient;

});

parcelRequire.register("2kSvM", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
var $1b37bbdfef45eb55$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $1b37bbdfef45eb55$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SpeakerRecognizer = void 0;

var $9MAMI = parcelRequire("9MAMI");

var $7srwU = parcelRequire("7srwU");

var $evvAW = parcelRequire("evvAW");

var $iQDnw = parcelRequire("iQDnw");
/**
 * Defines SpeakerRecognizer class for Speaker Recognition
 * Handles operations from user for Voice Profile operations (e.g. createProfile, deleteProfile)
 * @class SpeakerRecognizer
 */ var $1b37bbdfef45eb55$var$SpeakerRecognizer = /** @class */ function() {
    /**
     * SpeakerRecognizer constructor.
     * @constructor
     * @param {SpeechConfig} speechConfig - An set of initial properties for this recognizer (authentication key, region, &c)
     */ function SpeakerRecognizer(speechConfig, audioConfig) {
        var speechConfigImpl = speechConfig;
        $evvAW.Contracts.throwIfNull(speechConfigImpl, "speechConfig");
        this.privAudioConfigImpl = audioConfig;
        $evvAW.Contracts.throwIfNull(this.privAudioConfigImpl, "audioConfig");
        this.privProperties = speechConfigImpl.properties.clone();
        this.implSRSetup();
    }
    Object.defineProperty(SpeakerRecognizer.prototype, "authorizationToken", {
        /**
         * Gets the authorization token used to communicate with the service.
         * @member SpeakerRecognizer.prototype.authorizationToken
         * @function
         * @public
         * @returns {string} Authorization token.
         */ get: function() {
            return this.properties.getProperty($iQDnw.PropertyId.SpeechServiceAuthorization_Token);
        },
        /**
         * Gets/Sets the authorization token used to communicate with the service.
         * @member SpeakerRecognizer.prototype.authorizationToken
         * @function
         * @public
         * @param {string} token - Authorization token.
         */ set: function(token) {
            $evvAW.Contracts.throwIfNullOrWhitespace(token, "token");
            this.properties.setProperty($iQDnw.PropertyId.SpeechServiceAuthorization_Token, token);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SpeakerRecognizer.prototype, "properties", {
        /**
         * The collection of properties and their values defined for this SpeakerRecognizer.
         * @member SpeakerRecognizer.prototype.properties
         * @function
         * @public
         * @returns {PropertyCollection} The collection of properties and their values defined for this SpeakerRecognizer.
         */ get: function() {
            return this.privProperties;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Get recognition result for model using given audio
     * @member SpeakerRecognizer.prototype.recognizeOnceAsync
     * @function
     * @public
     * @param {SpeakerIdentificationModel} model Model containing Voice Profiles to be identified
     * @param cb - Callback invoked once result is returned.
     * @param err - Callback invoked in case of an error.
     */ SpeakerRecognizer.prototype.recognizeOnceAsync = function(model, cb, err) {
        if (model instanceof $iQDnw.SpeakerIdentificationModel) {
            var responsePromise = this.privAdapter.identifySpeaker(model, this.privAudioConfigImpl);
            $7srwU.marshalPromiseToCallbacks(this.getResult(responsePromise, $iQDnw.SpeakerRecognitionResultType.Identify, undefined), cb, err);
        } else if (model instanceof $iQDnw.SpeakerVerificationModel) {
            var responsePromise = this.privAdapter.verifySpeaker(model, this.privAudioConfigImpl);
            $7srwU.marshalPromiseToCallbacks(this.getResult(responsePromise, $iQDnw.SpeakerRecognitionResultType.Verify, model.voiceProfile.profileId), cb, err);
        } else throw new Error("SpeakerRecognizer.recognizeOnce: Unexpected model type");
    };
    /**
     * Included for compatibility
     * @member SpeakerRecognizer.prototype.close
     * @function
     * @public
     */ SpeakerRecognizer.prototype.close = function() {
        return;
    };
    // Does class setup, swiped from Recognizer.
    SpeakerRecognizer.prototype.implSRSetup = function() {
        var osPlatform = typeof window !== "undefined" ? "Browser" : "Node";
        var osName = "unknown";
        var osVersion = "unknown";
        if (typeof navigator !== "undefined") {
            osPlatform = osPlatform + "/" + navigator.platform;
            osName = navigator.userAgent;
            osVersion = navigator.appVersion;
        }
        var recognizerConfig = new $9MAMI.SpeakerRecognitionConfig(new $9MAMI.Context(new $9MAMI.OS(osPlatform, osName, osVersion)), this.privProperties);
        this.privAdapter = new $9MAMI.SpeakerIdMessageAdapter(recognizerConfig);
    };
    SpeakerRecognizer.prototype.getResult = function(responsePromise, resultType, profileId) {
        return $1b37bbdfef45eb55$var$__awaiter(this, void 0, void 0, function() {
            var response;
            return $1b37bbdfef45eb55$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            responsePromise
                        ];
                    case 1:
                        response = _a.sent();
                        return [
                            2 /*return*/ ,
                            new $iQDnw.SpeakerRecognitionResult(resultType, response.data, profileId, response.ok ? $iQDnw.ResultReason.RecognizedSpeaker : $iQDnw.ResultReason.Canceled)
                        ];
                }
            });
        });
    };
    return SpeakerRecognizer;
}();
module.exports.SpeakerRecognizer = $1b37bbdfef45eb55$var$SpeakerRecognizer;

});

parcelRequire.register("3oTtJ", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SpeakerIdentificationModel = void 0;

var $evvAW = parcelRequire("evvAW");

var $iQDnw = parcelRequire("iQDnw");
/**
 * Defines SpeakerIdentificationModel class for Speaker Recognition
 * Model contains a set of profiles against which to identify speaker(s)
 * @class SpeakerIdentificationModel
 */ var $279ea5e12dc040dd$var$SpeakerIdentificationModel = /** @class */ function() {
    function SpeakerIdentificationModel(profiles) {
        var _this = this;
        this.privVoiceProfiles = [];
        $evvAW.Contracts.throwIfNullOrUndefined(profiles, "VoiceProfiles");
        if (profiles.length === 0) throw new Error("Empty Voice Profiles array");
        profiles.forEach(function(profile) {
            if (profile.profileType !== $iQDnw.VoiceProfileType.TextIndependentIdentification) throw new Error("Identification model can only be created from Identification profile: " + profile.profileId);
            _this.privVoiceProfiles.push(profile);
        });
    }
    SpeakerIdentificationModel.fromProfiles = function(profiles) {
        return new SpeakerIdentificationModel(profiles);
    };
    Object.defineProperty(SpeakerIdentificationModel.prototype, "voiceProfileIds", {
        get: function() {
            return this.privVoiceProfiles.map(function(profile) {
                return profile.profileId;
            }).join(",");
        },
        enumerable: false,
        configurable: true
    });
    return SpeakerIdentificationModel;
}();
module.exports.SpeakerIdentificationModel = $279ea5e12dc040dd$var$SpeakerIdentificationModel;

});

parcelRequire.register("iukep", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SpeakerVerificationModel = void 0;

var $evvAW = parcelRequire("evvAW");

var $iQDnw = parcelRequire("iQDnw");
/**
 * Defines SpeakerVerificationModel class for Speaker Recognition
 * Model contains a profile against which to verify a speaker
 * @class SpeakerVerificationModel
 */ var $d75ab8e22ffa1321$var$SpeakerVerificationModel = /** @class */ function() {
    function SpeakerVerificationModel(profile) {
        $evvAW.Contracts.throwIfNullOrUndefined(profile, "VoiceProfile");
        if (profile.profileType === $iQDnw.VoiceProfileType.TextIndependentIdentification) throw new Error("Verification model cannot be created from Identification profile");
        this.privVoiceProfile = profile;
    }
    SpeakerVerificationModel.fromProfile = function(profile) {
        return new SpeakerVerificationModel(profile);
    };
    Object.defineProperty(SpeakerVerificationModel.prototype, "voiceProfile", {
        get: function() {
            return this.privVoiceProfile;
        },
        enumerable: false,
        configurable: true
    });
    return SpeakerVerificationModel;
}();
module.exports.SpeakerVerificationModel = $d75ab8e22ffa1321$var$SpeakerVerificationModel;

});

parcelRequire.register("fgpUG", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.AutoDetectSourceLanguageConfig = void 0;

var $9MAMI = parcelRequire("9MAMI");

var $evvAW = parcelRequire("evvAW");

var $iQDnw = parcelRequire("iQDnw");
/**
 * Language auto detect configuration.
 * @class AutoDetectSourceLanguageConfig
 * Added in version 1.13.0.
 */ var $b1cc7372349f0531$var$AutoDetectSourceLanguageConfig = /** @class */ function() {
    function AutoDetectSourceLanguageConfig() {
        this.privProperties = new $iQDnw.PropertyCollection();
    }
    /**
     * @member AutoDetectSourceLanguageConfig.fromOpenRange
     * @function
     * @public
     * Only [[SpeechSynthesizer]] supports source language auto detection from open range,
     * for [[Recognizer]], please use AutoDetectSourceLanguageConfig with specific source languages.
     * @return {AutoDetectSourceLanguageConfig} Instance of AutoDetectSourceLanguageConfig
     * @summary Creates an instance of the AutoDetectSourceLanguageConfig with open range.
     */ AutoDetectSourceLanguageConfig.fromOpenRange = function() {
        var config = new AutoDetectSourceLanguageConfig();
        config.properties.setProperty($iQDnw.PropertyId.SpeechServiceConnection_AutoDetectSourceLanguages, $9MAMI.AutoDetectSourceLanguagesOpenRangeOptionName);
        return config;
    };
    /**
     * @member AutoDetectSourceLanguageConfig.fromLanguages
     * @function
     * @public
     * @param {string[]} languages Comma-separated string of languages (eg. "en-US,fr-FR") to populate properties of config.
     * @return {AutoDetectSourceLanguageConfig} Instance of AutoDetectSourceLanguageConfig
     * @summary Creates an instance of the AutoDetectSourceLanguageConfig with given languages.
     */ AutoDetectSourceLanguageConfig.fromLanguages = function(languages) {
        $evvAW.Contracts.throwIfArrayEmptyOrWhitespace(languages, "languages");
        var config = new AutoDetectSourceLanguageConfig();
        config.properties.setProperty($iQDnw.PropertyId.SpeechServiceConnection_AutoDetectSourceLanguages, languages.join());
        return config;
    };
    /**
     * @member AutoDetectSourceLanguageConfig.fromSourceLanguageConfigs
     * @function
     * @public
     * @param {SourceLanguageConfig[]} configs SourceLanguageConfigs to populate properties of config.
     * @return {AutoDetectSourceLanguageConfig} Instance of AutoDetectSourceLanguageConfig
     * @summary Creates an instance of the AutoDetectSourceLanguageConfig with given SourceLanguageConfigs.
     */ AutoDetectSourceLanguageConfig.fromSourceLanguageConfigs = function(configs) {
        if (configs.length < 1) throw new Error("Expected non-empty SourceLanguageConfig array.");
        var autoConfig = new AutoDetectSourceLanguageConfig();
        var langs = [];
        configs.forEach(function(config) {
            langs.push(config.language);
            if (config.endpointId !== undefined && config.endpointId !== "") {
                var customProperty = config.language + $iQDnw.PropertyId.SpeechServiceConnection_EndpointId.toString();
                autoConfig.properties.setProperty(customProperty, config.endpointId);
            }
        });
        autoConfig.properties.setProperty($iQDnw.PropertyId.SpeechServiceConnection_AutoDetectSourceLanguages, langs.join());
        return autoConfig;
    };
    Object.defineProperty(AutoDetectSourceLanguageConfig.prototype, "properties", {
        /**
         * @member AutoDetectSourceLanguageConfig.prototype.properties
         * @function
         * @public
         * @return {PropertyCollection} Properties of the config.
         * @summary Gets an auto detected language config properties
         */ get: function() {
            return this.privProperties;
        },
        enumerable: false,
        configurable: true
    });
    return AutoDetectSourceLanguageConfig;
}();
module.exports.AutoDetectSourceLanguageConfig = $b1cc7372349f0531$var$AutoDetectSourceLanguageConfig;

});

parcelRequire.register("lJIjW", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.AutoDetectSourceLanguageResult = void 0;

var $evvAW = parcelRequire("evvAW");
/**
 * Output format
 * @class AutoDetectSourceLanguageResult
 */ var $fd302e177f858a88$var$AutoDetectSourceLanguageResult = /** @class */ function() {
    function AutoDetectSourceLanguageResult(language, languageDetectionConfidence) {
        $evvAW.Contracts.throwIfNullOrUndefined(language, "language");
        $evvAW.Contracts.throwIfNullOrUndefined(languageDetectionConfidence, "languageDetectionConfidence");
        this.privLanguage = language;
        this.privLanguageDetectionConfidence = languageDetectionConfidence;
    }
    /**
     * Creates an instance of AutoDetectSourceLanguageResult object from a SpeechRecognitionResult instance.
     * @member AutoDetectSourceLanguageResult.fromResult
     * @function
     * @public
     * @param {SpeechRecognitionResult} result - The recognition result.
     * @returns {AutoDetectSourceLanguageResult} AutoDetectSourceLanguageResult object being created.
     */ AutoDetectSourceLanguageResult.fromResult = function(result) {
        return new AutoDetectSourceLanguageResult(result.language, result.languageDetectionConfidence);
    };
    Object.defineProperty(AutoDetectSourceLanguageResult.prototype, "language", {
        get: function() {
            return this.privLanguage;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AutoDetectSourceLanguageResult.prototype, "languageDetectionConfidence", {
        get: function() {
            return this.privLanguageDetectionConfidence;
        },
        enumerable: false,
        configurable: true
    });
    return AutoDetectSourceLanguageResult;
}();
module.exports.AutoDetectSourceLanguageResult = $fd302e177f858a88$var$AutoDetectSourceLanguageResult;

});

parcelRequire.register("j25ra", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SourceLanguageConfig = void 0;

var $evvAW = parcelRequire("evvAW");
/**
 * Source Language configuration.
 * @class SourceLanguageConfig
 */ var $ddb26bed681d8f60$var$SourceLanguageConfig = /** @class */ function() {
    function SourceLanguageConfig(language, endpointId) {
        $evvAW.Contracts.throwIfNullOrUndefined(language, "language");
        this.privLanguage = language;
        this.privEndpointId = endpointId;
    }
    /**
     * @member SourceLanguageConfig.fromLanguage
     * @function
     * @public
     * @param {string} language language (eg. "en-US") value of config.
     * @param {string?} endpointId endpointId of model bound to given language of config.
     * @return {SourceLanguageConfig} Instance of SourceLanguageConfig
     * @summary Creates an instance of the SourceLanguageConfig with the given language and optional endpointId.
     * Added in version 1.13.0.
     */ SourceLanguageConfig.fromLanguage = function(language, endpointId) {
        return new SourceLanguageConfig(language, endpointId);
    };
    Object.defineProperty(SourceLanguageConfig.prototype, "language", {
        get: function() {
            return this.privLanguage;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SourceLanguageConfig.prototype, "endpointId", {
        get: function() {
            return this.privEndpointId;
        },
        enumerable: false,
        configurable: true
    });
    return SourceLanguageConfig;
}();
module.exports.SourceLanguageConfig = $ddb26bed681d8f60$var$SourceLanguageConfig;

});

parcelRequire.register("4bKzl", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
var $30cc5024e019f74b$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SpeakerRecognitionCancellationDetails = module.exports.SpeakerRecognitionResult = module.exports.SpeakerRecognitionResultType = void 0;

var $9MAMI = parcelRequire("9MAMI");

var $evvAW = parcelRequire("evvAW");

var $iQDnw = parcelRequire("iQDnw");
var $30cc5024e019f74b$var$SpeakerRecognitionResultType;
(function(SpeakerRecognitionResultType) {
    SpeakerRecognitionResultType[SpeakerRecognitionResultType["Verify"] = 0] = "Verify";
    SpeakerRecognitionResultType[SpeakerRecognitionResultType["Identify"] = 1] = "Identify";
})($30cc5024e019f74b$var$SpeakerRecognitionResultType = module.exports.SpeakerRecognitionResultType || (module.exports.SpeakerRecognitionResultType = {}));
/**
 * Output format
 * @class SpeakerRecognitionResult
 */ var $30cc5024e019f74b$var$SpeakerRecognitionResult = /** @class */ function() {
    function SpeakerRecognitionResult(resultType, data, profileId, resultReason) {
        if (resultReason === void 0) resultReason = $iQDnw.ResultReason.RecognizedSpeaker;
        this.privProperties = new $iQDnw.PropertyCollection();
        this.privReason = resultReason;
        if (this.privReason !== $iQDnw.ResultReason.Canceled) {
            if (resultType === $30cc5024e019f74b$var$SpeakerRecognitionResultType.Identify) {
                var json = JSON.parse(data);
                $evvAW.Contracts.throwIfNullOrUndefined(json, "JSON");
                this.privProfileId = json.identifiedProfile.profileId;
                this.privScore = json.identifiedProfile.score;
            } else {
                var json = JSON.parse(data);
                $evvAW.Contracts.throwIfNullOrUndefined(json, "JSON");
                this.privScore = json.score;
                if (json.recognitionResult.toLowerCase() !== "accept") this.privReason = $iQDnw.ResultReason.NoMatch;
                if (profileId !== undefined && profileId !== "") this.privProfileId = profileId;
            }
        } else {
            var json = JSON.parse(data);
            $evvAW.Contracts.throwIfNullOrUndefined(json, "JSON");
            this.privErrorDetails = json.statusText;
            this.privProperties.setProperty($9MAMI.CancellationErrorCodePropertyName, $iQDnw.CancellationErrorCode[$iQDnw.CancellationErrorCode.ServiceError]);
        }
        this.privProperties.setProperty($iQDnw.PropertyId.SpeechServiceResponse_JsonResult, data);
    }
    Object.defineProperty(SpeakerRecognitionResult.prototype, "properties", {
        get: function() {
            return this.privProperties;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SpeakerRecognitionResult.prototype, "reason", {
        get: function() {
            return this.privReason;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SpeakerRecognitionResult.prototype, "profileId", {
        get: function() {
            return this.privProfileId;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SpeakerRecognitionResult.prototype, "errorDetails", {
        get: function() {
            return this.privErrorDetails;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SpeakerRecognitionResult.prototype, "score", {
        get: function() {
            return this.privScore;
        },
        enumerable: false,
        configurable: true
    });
    return SpeakerRecognitionResult;
}();
module.exports.SpeakerRecognitionResult = $30cc5024e019f74b$var$SpeakerRecognitionResult;
/**
 * @class SpeakerRecognitionCancellationDetails
 */ // tslint:disable-next-line:max-classes-per-file
var $30cc5024e019f74b$var$SpeakerRecognitionCancellationDetails = /** @class */ function(_super) {
    $30cc5024e019f74b$var$__extends(SpeakerRecognitionCancellationDetails, _super);
    function SpeakerRecognitionCancellationDetails(reason, errorDetails, errorCode) {
        return _super.call(this, reason, errorDetails, errorCode) || this;
    }
    /**
     * Creates an instance of SpeakerRecognitionCancellationDetails object for the canceled SpeakerRecognitionResult
     * @member SpeakerRecognitionCancellationDetails.fromResult
     * @function
     * @public
     * @param {SpeakerRecognitionResult} result - The result that was canceled.
     * @returns {SpeakerRecognitionCancellationDetails} The cancellation details object being created.
     */ SpeakerRecognitionCancellationDetails.fromResult = function(result) {
        var reason = $iQDnw.CancellationReason.Error;
        var errorCode = $iQDnw.CancellationErrorCode.NoError;
        if (!!result.properties) errorCode = $iQDnw.CancellationErrorCode[result.properties.getProperty($9MAMI.CancellationErrorCodePropertyName, $iQDnw.CancellationErrorCode[$iQDnw.CancellationErrorCode.NoError])];
        return new SpeakerRecognitionCancellationDetails(reason, result.errorDetails, errorCode);
    };
    return SpeakerRecognitionCancellationDetails;
}($iQDnw.CancellationDetailsBase);
module.exports.SpeakerRecognitionCancellationDetails = $30cc5024e019f74b$var$SpeakerRecognitionCancellationDetails;

});

parcelRequire.register("by2ku", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
// Multi-device Conversation is a Preview feature.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $9UkLh = parcelRequire("9UkLh");
Object.defineProperty(module.exports, "Conversation", {
    enumerable: true,
    get: function() {
        return $9UkLh.Conversation;
    }
});
Object.defineProperty(module.exports, "ConversationImpl", {
    enumerable: true,
    get: function() {
        return $9UkLh.ConversationImpl;
    }
});

var $1ql0W = parcelRequire("1ql0W");
Object.defineProperty(module.exports, "ConversationCommon", {
    enumerable: true,
    get: function() {
        return $1ql0W.ConversationCommon;
    }
});

var $gXf2c = parcelRequire("gXf2c");
Object.defineProperty(module.exports, "ConversationExpirationEventArgs", {
    enumerable: true,
    get: function() {
        return $gXf2c.ConversationExpirationEventArgs;
    }
});

var $hoSof = parcelRequire("hoSof");
Object.defineProperty(module.exports, "ConversationParticipantsChangedEventArgs", {
    enumerable: true,
    get: function() {
        return $hoSof.ConversationParticipantsChangedEventArgs;
    }
});

var $blM8U = parcelRequire("blM8U");
Object.defineProperty(module.exports, "ConversationTranslationCanceledEventArgs", {
    enumerable: true,
    get: function() {
        return $blM8U.ConversationTranslationCanceledEventArgs;
    }
});

var $2C5FD = parcelRequire("2C5FD");
Object.defineProperty(module.exports, "ConversationTranslationEventArgs", {
    enumerable: true,
    get: function() {
        return $2C5FD.ConversationTranslationEventArgs;
    }
});

var $113kD = parcelRequire("113kD");
Object.defineProperty(module.exports, "ConversationTranslationResult", {
    enumerable: true,
    get: function() {
        return $113kD.ConversationTranslationResult;
    }
});

var $kt5Mj = parcelRequire("kt5Mj");
Object.defineProperty(module.exports, "ConversationTranslator", {
    enumerable: true,
    get: function() {
        return $kt5Mj.ConversationTranslator;
    }
});

var $2gral = parcelRequire("2gral");
Object.defineProperty(module.exports, "ConversationTranscriber", {
    enumerable: true,
    get: function() {
        return $2gral.ConversationTranscriber;
    }
});

var $bVIyY = parcelRequire("bVIyY");
Object.defineProperty(module.exports, "Participant", {
    enumerable: true,
    get: function() {
        return $bVIyY.Participant;
    }
});
Object.defineProperty(module.exports, "User", {
    enumerable: true,
    get: function() {
        return $bVIyY.User;
    }
});

var $aYx5P = parcelRequire("aYx5P");
Object.defineProperty(module.exports, "ParticipantChangedReason", {
    enumerable: true,
    get: function() {
        return $aYx5P.ParticipantChangedReason;
    }
});

});
parcelRequire.register("9UkLh", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
// Multi-device Conversation is a Preview feature.
var $736972d54f5e676e$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $736972d54f5e676e$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $736972d54f5e676e$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $736972d54f5e676e$var$__spreadArrays = module.exports && module.exports.__spreadArrays || function() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ConversationImpl = module.exports.Conversation = void 0;

var $9MAMI = parcelRequire("9MAMI");

var $7srwU = parcelRequire("7srwU");

var $evvAW = parcelRequire("evvAW");

var $iQDnw = parcelRequire("iQDnw");
var $736972d54f5e676e$var$Conversation = /** @class */ function() {
    function Conversation() {}
    /**
     * Create a conversation
     * @param speechConfig
     * @param cb
     * @param err
     */ Conversation.createConversationAsync = function(speechConfig, arg2, arg3, arg4) {
        var _this = this;
        $evvAW.Contracts.throwIfNullOrUndefined(speechConfig, $9MAMI.ConversationConnectionConfig.restErrors.invalidArgs.replace("{arg}", "config"));
        $evvAW.Contracts.throwIfNullOrUndefined(speechConfig.region, $9MAMI.ConversationConnectionConfig.restErrors.invalidArgs.replace("{arg}", "SpeechServiceConnection_Region"));
        if (!speechConfig.subscriptionKey && !speechConfig.getProperty($iQDnw.PropertyId[$iQDnw.PropertyId.SpeechServiceAuthorization_Token])) $evvAW.Contracts.throwIfNullOrUndefined(speechConfig.subscriptionKey, $9MAMI.ConversationConnectionConfig.restErrors.invalidArgs.replace("{arg}", "SpeechServiceConnection_Key"));
        if (typeof arg2 === "string") {
            var conversationImpl = new $736972d54f5e676e$var$ConversationImpl(speechConfig, arg2);
            $7srwU.marshalPromiseToCallbacks(function() {
                return $736972d54f5e676e$var$__awaiter(_this, void 0, void 0, function() {
                    return $736972d54f5e676e$var$__generator(this, function(_a) {
                        return [
                            2 /*return*/ 
                        ];
                    });
                });
            }(), arg3, arg4);
            return conversationImpl;
        } else {
            var conversationImpl = new $736972d54f5e676e$var$ConversationImpl(speechConfig);
            var cb_1 = arg2;
            var err_1 = arg3;
            conversationImpl.createConversationAsync(function() {
                if (!!cb_1) cb_1();
            }, function(error) {
                if (!!err_1) err_1(error);
            });
            return conversationImpl;
        }
    };
    return Conversation;
}();
module.exports.Conversation = $736972d54f5e676e$var$Conversation;
// tslint:disable-next-line:max-classes-per-file
var $736972d54f5e676e$var$ConversationImpl = /** @class */ function(_super) {
    $736972d54f5e676e$var$__extends(ConversationImpl, _super);
    /**
     * Create a conversation impl
     * @param speechConfig
     * @param {string} id - optional conversationId
     */ function ConversationImpl(speechConfig, id) {
        var _this = _super.call(this) || this;
        _this.privIsDisposed = false;
        _this.privIsConnected = false;
        _this.privErrors = $9MAMI.ConversationConnectionConfig.restErrors;
        _this.privConversationId = "";
        /** websocket callbacks */ _this.onConnected = function(e) {
            _this.privIsConnected = true;
            try {
                if (!!_this.privConversationTranslator.sessionStarted) _this.privConversationTranslator.sessionStarted(_this.privConversationTranslator, e);
            } catch (e) {
            //
            }
        };
        _this.onDisconnected = function(e) {
            return $736972d54f5e676e$var$__awaiter(_this, void 0, void 0, function() {
                return $736972d54f5e676e$var$__generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            return [
                                4 /*yield*/ ,
                                this.close(false)
                            ];
                        case 1:
                            _a.sent();
                            try {
                                if (!!this.privConversationTranslator.sessionStopped) this.privConversationTranslator.sessionStopped(this.privConversationTranslator, e);
                            } catch (e) {
                            //
                            }
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        _this.onCanceled = function(r, e) {
            return $736972d54f5e676e$var$__awaiter(_this, void 0, void 0, function() {
                return $736972d54f5e676e$var$__generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            return [
                                4 /*yield*/ ,
                                this.close(false)
                            ];
                        case 1:
                            _a.sent(); // ?
                            try {
                                if (!!this.privConversationTranslator.canceled) this.privConversationTranslator.canceled(this.privConversationTranslator, e);
                            } catch (e) {
                            //
                            }
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        _this.onParticipantUpdateCommandReceived = function(r, e) {
            var _a, _b;
            try {
                var updatedParticipant = _this.privParticipants.getParticipant(e.id);
                if (updatedParticipant !== undefined) {
                    switch(e.key){
                        case $9MAMI.ConversationTranslatorCommandTypes.changeNickname:
                            updatedParticipant.displayName = e.value;
                            break;
                        case $9MAMI.ConversationTranslatorCommandTypes.setUseTTS:
                            updatedParticipant.useTts = e.value;
                            break;
                        case $9MAMI.ConversationTranslatorCommandTypes.setProfanityFiltering:
                            updatedParticipant.profanity = e.value;
                            break;
                        case $9MAMI.ConversationTranslatorCommandTypes.setMute:
                            updatedParticipant.isMuted = e.value;
                            break;
                        case $9MAMI.ConversationTranslatorCommandTypes.setTranslateToLanguages:
                            updatedParticipant.translateToLanguages = e.value;
                            break;
                    }
                    _this.privParticipants.addOrUpdateParticipant(updatedParticipant);
                    if (!!((_a = _this.privConversationTranslator) === null || _a === void 0 ? void 0 : _a.participantsChanged)) (_b = _this.privConversationTranslator) === null || _b === void 0 || _b.participantsChanged(_this.privConversationTranslator, new $iQDnw.ConversationParticipantsChangedEventArgs($iQDnw.ParticipantChangedReason.Updated, [
                        _this.toParticipant(updatedParticipant)
                    ], e.sessionId));
                }
            } catch (e) {
            //
            }
        };
        _this.onLockRoomCommandReceived = function(r, e) {
        // TODO
        };
        _this.onMuteAllCommandReceived = function(r, e) {
            var _a, _b;
            try {
                _this.privParticipants.participants.forEach(function(p) {
                    return p.isMuted = p.isHost ? false : e.isMuted;
                });
                if (!!((_a = _this.privConversationTranslator) === null || _a === void 0 ? void 0 : _a.participantsChanged)) (_b = _this.privConversationTranslator) === null || _b === void 0 || _b.participantsChanged(_this.privConversationTranslator, new $iQDnw.ConversationParticipantsChangedEventArgs($iQDnw.ParticipantChangedReason.Updated, _this.toParticipants(false), e.sessionId));
            } catch (e) {
            //
            }
        };
        _this.onParticipantJoinCommandReceived = function(r, e) {
            var _a, _b;
            try {
                var newParticipant = _this.privParticipants.addOrUpdateParticipant(e.participant);
                if (newParticipant !== undefined) {
                    if (!!((_a = _this.privConversationTranslator) === null || _a === void 0 ? void 0 : _a.participantsChanged)) (_b = _this.privConversationTranslator) === null || _b === void 0 || _b.participantsChanged(_this.privConversationTranslator, new $iQDnw.ConversationParticipantsChangedEventArgs($iQDnw.ParticipantChangedReason.JoinedConversation, [
                        _this.toParticipant(newParticipant)
                    ], e.sessionId));
                }
            } catch (e) {
            //
            }
        };
        _this.onParticipantLeaveCommandReceived = function(r, e) {
            var _a, _b;
            try {
                var ejectedParticipant = _this.privParticipants.getParticipant(e.participant.id);
                if (ejectedParticipant !== undefined) {
                    // remove the participant from the internal participants list
                    _this.privParticipants.deleteParticipant(e.participant.id);
                    if (!!((_a = _this.privConversationTranslator) === null || _a === void 0 ? void 0 : _a.participantsChanged)) // notify subscribers that the participant has left the conversation
                    (_b = _this.privConversationTranslator) === null || _b === void 0 || _b.participantsChanged(_this.privConversationTranslator, new $iQDnw.ConversationParticipantsChangedEventArgs($iQDnw.ParticipantChangedReason.LeftConversation, [
                        _this.toParticipant(ejectedParticipant)
                    ], e.sessionId));
                }
            } catch (e) {
            //
            }
        };
        _this.onTranslationReceived = function(r, e) {
            var _a, _b, _c, _d, _e, _f;
            try {
                switch(e.command){
                    case $9MAMI.ConversationTranslatorMessageTypes.final:
                        if (!!((_a = _this.privConversationTranslator) === null || _a === void 0 ? void 0 : _a.transcribed)) (_b = _this.privConversationTranslator) === null || _b === void 0 || _b.transcribed(_this.privConversationTranslator, new $iQDnw.ConversationTranslationEventArgs(e.payload, undefined, e.sessionId));
                        break;
                    case $9MAMI.ConversationTranslatorMessageTypes.partial:
                        if (!!((_c = _this.privConversationTranslator) === null || _c === void 0 ? void 0 : _c.transcribing)) (_d = _this.privConversationTranslator) === null || _d === void 0 || _d.transcribing(_this.privConversationTranslator, new $iQDnw.ConversationTranslationEventArgs(e.payload, undefined, e.sessionId));
                        break;
                    case $9MAMI.ConversationTranslatorMessageTypes.instantMessage:
                        if (!!((_e = _this.privConversationTranslator) === null || _e === void 0 ? void 0 : _e.textMessageReceived)) (_f = _this.privConversationTranslator) === null || _f === void 0 || _f.textMessageReceived(_this.privConversationTranslator, new $iQDnw.ConversationTranslationEventArgs(e.payload, undefined, e.sessionId));
                        break;
                }
            } catch (e) {
            //
            }
        };
        _this.onParticipantsListReceived = function(r, e) {
            var _a, _b, _c;
            try {
                // check if the session token needs to be updated
                if (e.sessionToken !== undefined && e.sessionToken !== null) _this.privRoom.token = e.sessionToken;
                // save the participants
                _this.privParticipants.participants = $736972d54f5e676e$var$__spreadArrays(e.participants);
                // enable the conversation
                if (_this.privParticipants.me !== undefined) _this.privIsReady = true;
                if (!!((_a = _this.privConversationTranslator) === null || _a === void 0 ? void 0 : _a.participantsChanged)) (_b = _this.privConversationTranslator) === null || _b === void 0 || _b.participantsChanged(_this.privConversationTranslator, new $iQDnw.ConversationParticipantsChangedEventArgs($iQDnw.ParticipantChangedReason.JoinedConversation, _this.toParticipants(true), e.sessionId));
                // if this is the host, update the nickname if needed
                if (_this.me.isHost) {
                    var nickname = (_c = _this.privConversationTranslator) === null || _c === void 0 ? void 0 : _c.properties.getProperty($iQDnw.PropertyId.ConversationTranslator_Name);
                    if (nickname !== undefined && nickname.length > 0 && nickname !== _this.me.displayName) // issue a change nickname request
                    _this.changeNicknameAsync(nickname);
                }
            } catch (e) {
            //
            }
        };
        _this.onConversationExpiration = function(r, e) {
            var _a, _b;
            try {
                if (!!((_a = _this.privConversationTranslator) === null || _a === void 0 ? void 0 : _a.conversationExpiration)) (_b = _this.privConversationTranslator) === null || _b === void 0 || _b.conversationExpiration(_this.privConversationTranslator, e);
            } catch (e) {
            //
            }
        };
        _this.privProperties = new $iQDnw.PropertyCollection();
        _this.privManager = new $9MAMI.ConversationManager();
        // check the speech language
        var language = speechConfig.getProperty($iQDnw.PropertyId[$iQDnw.PropertyId.SpeechServiceConnection_RecoLanguage]);
        if (!language) speechConfig.setProperty($iQDnw.PropertyId[$iQDnw.PropertyId.SpeechServiceConnection_RecoLanguage], $9MAMI.ConversationConnectionConfig.defaultLanguageCode);
        _this.privLanguage = speechConfig.getProperty($iQDnw.PropertyId[$iQDnw.PropertyId.SpeechServiceConnection_RecoLanguage]);
        if (!id) {
            // check the target language(s)
            if (speechConfig.targetLanguages.length === 0) speechConfig.addTargetLanguage(_this.privLanguage);
            // check the profanity setting: speech and conversationTranslator should be in sync
            var profanity = speechConfig.getProperty($iQDnw.PropertyId[$iQDnw.PropertyId.SpeechServiceResponse_ProfanityOption]);
            if (!profanity) speechConfig.setProfanity($iQDnw.ProfanityOption.Masked);
            // check the nickname: it should pass this regex: ^\w+([\s-][\w\(\)]+)*$"
            // TODO: specify the regex required. Nicknames must be unique or get the duplicate nickname error
            // TODO: check what the max length is and if a truncation is required or if the service handles it without an error
            var hostNickname = speechConfig.getProperty($iQDnw.PropertyId[$iQDnw.PropertyId.ConversationTranslator_Name]);
            if (hostNickname === undefined || hostNickname === null || hostNickname.length <= 1 || hostNickname.length > 50) hostNickname = "Host";
            speechConfig.setProperty($iQDnw.PropertyId[$iQDnw.PropertyId.ConversationTranslator_Name], hostNickname);
        } else _this.privConversationId = id;
        // save the speech config for future usage
        _this.privConfig = speechConfig;
        // save the config properties
        var configImpl = speechConfig;
        $evvAW.Contracts.throwIfNull(configImpl, "speechConfig");
        _this.privProperties = configImpl.properties.clone();
        _this.privIsConnected = false;
        _this.privParticipants = new $9MAMI.InternalParticipants();
        _this.privIsReady = false;
        _this.privTextMessageMaxLength = 1000;
        return _this;
    }
    Object.defineProperty(ConversationImpl.prototype, "conversationTranslator", {
        set: function(value) {
            this.privConversationTranslator = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ConversationImpl.prototype, "room", {
        // get the internal data about a conversation
        get: function() {
            return this.privRoom;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ConversationImpl.prototype, "connection", {
        // get the wrapper for connecting to the websockets
        get: function() {
            return this.privConversationRecognizer; // this.privConnection;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ConversationImpl.prototype, "authorizationToken", {
        // get / set the speech auth token
        get: function() {
            return this.privToken;
        },
        set: function(value) {
            $evvAW.Contracts.throwIfNullOrWhitespace(value, "authorizationToken");
            this.privToken = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ConversationImpl.prototype, "config", {
        // get the config
        get: function() {
            return this.privConfig;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ConversationImpl.prototype, "conversationId", {
        // get the conversation Id
        get: function() {
            return this.privRoom ? this.privRoom.roomId : this.privConversationId;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ConversationImpl.prototype, "properties", {
        // get the properties
        get: function() {
            return this.privProperties;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ConversationImpl.prototype, "speechRecognitionLanguage", {
        // get the speech language
        get: function() {
            return this.privLanguage;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ConversationImpl.prototype, "isMutedByHost", {
        get: function() {
            var _a, _b;
            return ((_a = this.privParticipants.me) === null || _a === void 0 ? void 0 : _a.isHost) ? false : (_b = this.privParticipants.me) === null || _b === void 0 ? void 0 : _b.isMuted;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ConversationImpl.prototype, "isConnected", {
        get: function() {
            return this.privIsConnected && this.privIsReady;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ConversationImpl.prototype, "participants", {
        get: function() {
            return this.toParticipants(true);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ConversationImpl.prototype, "me", {
        get: function() {
            return this.toParticipant(this.privParticipants.me);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ConversationImpl.prototype, "host", {
        get: function() {
            return this.toParticipant(this.privParticipants.host);
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Create a new conversation as Host
     * @param cb
     * @param err
     */ ConversationImpl.prototype.createConversationAsync = function(cb, err) {
        var _this = this;
        try {
            if (!!this.privConversationRecognizer) this.handleError(new Error(this.privErrors.permissionDeniedStart), err);
            this.privManager.createOrJoin(this.privProperties, undefined, function(room) {
                if (!room) _this.handleError(new Error(_this.privErrors.permissionDeniedConnect), err);
                _this.privRoom = room;
                _this.handleCallback(cb, err);
            }, function(error) {
                _this.handleError(error, err);
            });
        } catch (error) {
            this.handleError(error, err);
        }
    };
    /**
     * Starts a new conversation as host.
     * @param cb
     * @param err
     */ ConversationImpl.prototype.startConversationAsync = function(cb, err) {
        var _this = this;
        try {
            // check if there is already a recognizer
            if (!!this.privConversationRecognizer) this.handleError(new Error(this.privErrors.permissionDeniedStart), err);
            // check if there is conversation data available
            $evvAW.Contracts.throwIfNullOrUndefined(this.privRoom, this.privErrors.permissionDeniedConnect);
            // connect to the conversation websocket
            this.privParticipants.meId = this.privRoom.participantId;
            this.privConversationRecognizer = $9MAMI.ConversationRecognizerFactory.fromConfig(this.privConfig);
            // Because ConversationTranslator manually sets up and manages the connection, Conversation
            // has to forward serviceRecognizer connection events that usually get passed automatically
            this.privConversationRecognizer.connected = this.onConnected;
            this.privConversationRecognizer.disconnected = this.onDisconnected;
            this.privConversationRecognizer.canceled = this.onCanceled;
            this.privConversationRecognizer.participantUpdateCommandReceived = this.onParticipantUpdateCommandReceived;
            this.privConversationRecognizer.lockRoomCommandReceived = this.onLockRoomCommandReceived;
            this.privConversationRecognizer.muteAllCommandReceived = this.onMuteAllCommandReceived;
            this.privConversationRecognizer.participantJoinCommandReceived = this.onParticipantJoinCommandReceived;
            this.privConversationRecognizer.participantLeaveCommandReceived = this.onParticipantLeaveCommandReceived;
            this.privConversationRecognizer.translationReceived = this.onTranslationReceived;
            this.privConversationRecognizer.participantsListReceived = this.onParticipantsListReceived;
            this.privConversationRecognizer.conversationExpiration = this.onConversationExpiration;
            this.privConversationRecognizer.connect(this.privRoom.token, function() {
                _this.handleCallback(cb, err);
            }, function(error) {
                _this.handleError(error, err);
            });
        } catch (error) {
            this.handleError(error, err);
        }
    };
    /**
     * Join a conversation as a participant.
     * @param { IParticipant } participant - participant to add
     * @param cb
     * @param err
     */ ConversationImpl.prototype.addParticipantAsync = function(participant, cb, err) {
        $evvAW.Contracts.throwIfNullOrUndefined(participant, "Participant");
        $7srwU.marshalPromiseToCallbacks(this.addParticipantImplAsync(participant), cb, err);
    };
    /**
     * Join a conversation as a participant.
     * @param conversation
     * @param nickname
     * @param lang
     * @param cb
     * @param err
     */ ConversationImpl.prototype.joinConversationAsync = function(conversationId, nickname, lang, cb, err) {
        var _this = this;
        try {
            // TODO
            // if (!!this.privConversationRecognizer) {
            //     throw new Error(this.privErrors.permissionDeniedStart);
            // }
            $evvAW.Contracts.throwIfNullOrWhitespace(conversationId, this.privErrors.invalidArgs.replace("{arg}", "conversationId"));
            $evvAW.Contracts.throwIfNullOrWhitespace(nickname, this.privErrors.invalidArgs.replace("{arg}", "nickname"));
            $evvAW.Contracts.throwIfNullOrWhitespace(lang, this.privErrors.invalidArgs.replace("{arg}", "language"));
            // join the conversation
            this.privManager.createOrJoin(this.privProperties, conversationId, function(room) {
                $evvAW.Contracts.throwIfNullOrUndefined(room, _this.privErrors.permissionDeniedConnect);
                _this.privRoom = room;
                _this.privConfig.authorizationToken = room.cognitiveSpeechAuthToken;
                // join callback
                if (!!cb) cb(room.cognitiveSpeechAuthToken);
            }, function(error) {
                _this.handleError(error, err);
            });
        } catch (error) {
            this.handleError(error, err);
        }
    };
    /**
     * Deletes a conversation
     * @param cb
     * @param err
     */ ConversationImpl.prototype.deleteConversationAsync = function(cb, err) {
        $7srwU.marshalPromiseToCallbacks(this.deleteConversationImplAsync(), cb, err);
    };
    ConversationImpl.prototype.deleteConversationImplAsync = function() {
        return $736972d54f5e676e$var$__awaiter(this, void 0, void 0, function() {
            return $736972d54f5e676e$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        $evvAW.Contracts.throwIfNullOrUndefined(this.privProperties, this.privErrors.permissionDeniedConnect);
                        $evvAW.Contracts.throwIfNullOrWhitespace(this.privRoom.token, this.privErrors.permissionDeniedConnect);
                        return [
                            4 /*yield*/ ,
                            this.privManager.leave(this.privProperties, this.privRoom.token)
                        ];
                    case 1:
                        _a.sent();
                        this.dispose();
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * Issues a request to close the client websockets
     * @param cb
     * @param err
     */ ConversationImpl.prototype.endConversationAsync = function(cb, err) {
        $7srwU.marshalPromiseToCallbacks(this.endConversationImplAsync(), cb, err);
    };
    ConversationImpl.prototype.endConversationImplAsync = function() {
        return this.close(true);
    };
    /**
     * Issues a request to lock the conversation
     * @param cb
     * @param err
     */ ConversationImpl.prototype.lockConversationAsync = function(cb, err) {
        var _this = this;
        var _a;
        try {
            $evvAW.Contracts.throwIfDisposed(this.privIsDisposed);
            $evvAW.Contracts.throwIfDisposed(this.privConversationRecognizer.isDisposed());
            $evvAW.Contracts.throwIfNullOrUndefined(this.privRoom, this.privErrors.permissionDeniedSend);
            if (!this.canSendAsHost) this.handleError(new Error(this.privErrors.permissionDeniedConversation.replace("{command}", "lock")), err);
            (_a = this.privConversationRecognizer) === null || _a === void 0 || _a.sendRequest(this.getLockCommand(true), function() {
                _this.handleCallback(cb, err);
            }, function(error) {
                _this.handleError(error, err);
            });
        } catch (error) {
            this.handleError(error, err);
        }
    };
    /**
     * Issues a request to mute the conversation
     * @param cb
     * @param err
     */ ConversationImpl.prototype.muteAllParticipantsAsync = function(cb, err) {
        var _this = this;
        var _a;
        try {
            $evvAW.Contracts.throwIfDisposed(this.privIsDisposed);
            $evvAW.Contracts.throwIfDisposed(this.privConversationRecognizer.isDisposed());
            $evvAW.Contracts.throwIfNullOrUndefined(this.privConversationRecognizer, this.privErrors.permissionDeniedSend);
            $evvAW.Contracts.throwIfNullOrUndefined(this.privRoom, this.privErrors.permissionDeniedSend);
            // check the user's permissions
            if (!this.canSendAsHost) this.handleError(new Error(this.privErrors.permissionDeniedConversation.replace("{command}", "mute")), err);
            (_a = this.privConversationRecognizer) === null || _a === void 0 || _a.sendRequest(this.getMuteAllCommand(true), function() {
                _this.handleCallback(cb, err);
            }, function(error) {
                _this.handleError(error, err);
            });
        } catch (error) {
            this.handleError(error, err);
        }
    };
    /**
     * Issues a request to mute a participant in the conversation
     * @param userId
     * @param cb
     * @param err
     */ ConversationImpl.prototype.muteParticipantAsync = function(userId, cb, err) {
        var _this = this;
        var _a;
        try {
            $evvAW.Contracts.throwIfDisposed(this.privIsDisposed);
            $evvAW.Contracts.throwIfDisposed(this.privConversationRecognizer.isDisposed());
            $evvAW.Contracts.throwIfNullOrWhitespace(userId, this.privErrors.invalidArgs.replace("{arg}", "userId"));
            $evvAW.Contracts.throwIfNullOrUndefined(this.privRoom, this.privErrors.permissionDeniedSend);
            // check the connection is open (host + participant can perform the mute command)
            if (!this.canSend) this.handleError(new Error(this.privErrors.permissionDeniedSend), err);
            // if not host, check the participant is not muting another participant
            if (!this.me.isHost && this.me.id !== userId) this.handleError(new Error(this.privErrors.permissionDeniedParticipant.replace("{command}", "mute")), err);
            // check the user exists
            var exists = this.privParticipants.getParticipantIndex(userId);
            if (exists === -1) this.handleError(new Error(this.privErrors.invalidParticipantRequest), err);
            (_a = this.privConversationRecognizer) === null || _a === void 0 || _a.sendRequest(this.getMuteCommand(userId, true), function() {
                _this.handleCallback(cb, err);
            }, function(error) {
                _this.handleError(error, err);
            });
        } catch (error) {
            this.handleError(error, err);
        }
    };
    /**
     * Issues a request to remove a participant from the conversation
     * @param userId
     * @param cb
     * @param err
     */ ConversationImpl.prototype.removeParticipantAsync = function(userId, cb, err) {
        var _this = this;
        var _a;
        try {
            $evvAW.Contracts.throwIfDisposed(this.privIsDisposed);
            if (!!this.privTranscriberRecognizer && userId.hasOwnProperty("id")) // Assume this is a transcription participant
            $7srwU.marshalPromiseToCallbacks(this.removeParticipantImplAsync(userId), cb, err);
            else {
                $evvAW.Contracts.throwIfDisposed(this.privConversationRecognizer.isDisposed());
                $evvAW.Contracts.throwIfNullOrUndefined(this.privRoom, this.privErrors.permissionDeniedSend);
                if (!this.canSendAsHost) this.handleError(new Error(this.privErrors.permissionDeniedParticipant.replace("{command}", "remove")), err);
                var participantId_1 = "";
                if (typeof userId === "string") participantId_1 = userId;
                else if (userId.hasOwnProperty("id")) {
                    var participant = userId;
                    participantId_1 = participant.id;
                } else if (userId.hasOwnProperty("userId")) {
                    var user = userId;
                    participantId_1 = user.userId;
                }
                $evvAW.Contracts.throwIfNullOrWhitespace(participantId_1, this.privErrors.invalidArgs.replace("{arg}", "userId"));
                // check the participant exists
                var index = this.participants.findIndex(function(p) {
                    return p.id === participantId_1;
                });
                if (index === -1) this.handleError(new Error(this.privErrors.invalidParticipantRequest), err);
                (_a = this.privConversationRecognizer) === null || _a === void 0 || _a.sendRequest(this.getEjectCommand(participantId_1), function() {
                    _this.handleCallback(cb, err);
                }, function(error) {
                    _this.handleError(error, err);
                });
            }
        } catch (error) {
            this.handleError(error, err);
        }
    };
    /**
     * Issues a request to unlock the conversation
     * @param cb
     * @param err
     */ ConversationImpl.prototype.unlockConversationAsync = function(cb, err) {
        var _this = this;
        var _a;
        try {
            $evvAW.Contracts.throwIfDisposed(this.privIsDisposed);
            $evvAW.Contracts.throwIfDisposed(this.privConversationRecognizer.isDisposed());
            $evvAW.Contracts.throwIfNullOrUndefined(this.privRoom, this.privErrors.permissionDeniedSend);
            if (!this.canSendAsHost) this.handleError(new Error(this.privErrors.permissionDeniedConversation.replace("{command}", "unlock")), err);
            (_a = this.privConversationRecognizer) === null || _a === void 0 || _a.sendRequest(this.getLockCommand(false), function() {
                _this.handleCallback(cb, err);
            }, function(error) {
                _this.handleError(error, err);
            });
        } catch (error) {
            this.handleError(error, err);
        }
    };
    /**
     * Issues a request to unmute all participants in the conversation
     * @param cb
     * @param err
     */ ConversationImpl.prototype.unmuteAllParticipantsAsync = function(cb, err) {
        var _this = this;
        var _a;
        try {
            $evvAW.Contracts.throwIfDisposed(this.privIsDisposed);
            $evvAW.Contracts.throwIfDisposed(this.privConversationRecognizer.isDisposed());
            $evvAW.Contracts.throwIfNullOrUndefined(this.privRoom, this.privErrors.permissionDeniedSend);
            if (!this.canSendAsHost) this.handleError(new Error(this.privErrors.permissionDeniedConversation.replace("{command}", "unmute all")), err);
            (_a = this.privConversationRecognizer) === null || _a === void 0 || _a.sendRequest(this.getMuteAllCommand(false), function() {
                _this.handleCallback(cb, err);
            }, function(error) {
                _this.handleError(error, err);
            });
        } catch (error) {
            this.handleError(error, err);
        }
    };
    /**
     * Issues a request to unmute a participant in the conversation
     * @param userId
     * @param cb
     * @param err
     */ ConversationImpl.prototype.unmuteParticipantAsync = function(userId, cb, err) {
        var _this = this;
        var _a;
        try {
            $evvAW.Contracts.throwIfDisposed(this.privIsDisposed);
            $evvAW.Contracts.throwIfDisposed(this.privConversationRecognizer.isDisposed());
            $evvAW.Contracts.throwIfNullOrWhitespace(userId, this.privErrors.invalidArgs.replace("{arg}", "userId"));
            $evvAW.Contracts.throwIfNullOrUndefined(this.privRoom, this.privErrors.permissionDeniedSend);
            // check the connection is open (host + participant can perform the mute command)
            if (!this.canSend) this.handleError(new Error(this.privErrors.permissionDeniedSend), err);
            // if not host, check the participant is not muting another participant
            if (!this.me.isHost && this.me.id !== userId) this.handleError(new Error(this.privErrors.permissionDeniedParticipant.replace("{command}", "mute")), err);
            // check the user exists
            var exists = this.privParticipants.getParticipantIndex(userId);
            if (exists === -1) this.handleError(new Error(this.privErrors.invalidParticipantRequest), err);
            (_a = this.privConversationRecognizer) === null || _a === void 0 || _a.sendRequest(this.getMuteCommand(userId, false), function() {
                _this.handleCallback(cb, err);
            }, function(error) {
                _this.handleError(error, err);
            });
        } catch (error) {
            this.handleError(error, err);
        }
    };
    /**
     * Send a text message
     * @param message
     * @param cb
     * @param err
     */ ConversationImpl.prototype.sendTextMessageAsync = function(message, cb, err) {
        var _this = this;
        var _a;
        try {
            $evvAW.Contracts.throwIfDisposed(this.privIsDisposed);
            $evvAW.Contracts.throwIfDisposed(this.privConversationRecognizer.isDisposed());
            $evvAW.Contracts.throwIfNullOrWhitespace(message, this.privErrors.invalidArgs.replace("{arg}", "message"));
            $evvAW.Contracts.throwIfNullOrUndefined(this.privRoom, this.privErrors.permissionDeniedSend);
            if (!this.canSend) this.handleError(new Error(this.privErrors.permissionDeniedSend), err);
            // TODO: is a max length check required?
            if (message.length > this.privTextMessageMaxLength) this.handleError(new Error(this.privErrors.invalidArgs.replace("{arg}", "message length")), err);
            (_a = this.privConversationRecognizer) === null || _a === void 0 || _a.sendRequest(this.getMessageCommand(message), function() {
                _this.handleCallback(cb, err);
            }, function(error) {
                _this.handleError(error, err);
            });
        } catch (error) {
            this.handleError(error, err);
        }
    };
    /**
     * Change nickname
     * @param message
     * @param cb
     * @param err
     */ ConversationImpl.prototype.changeNicknameAsync = function(nickname, cb, err) {
        var _this = this;
        var _a;
        try {
            $evvAW.Contracts.throwIfDisposed(this.privIsDisposed);
            $evvAW.Contracts.throwIfDisposed(this.privConversationRecognizer.isDisposed());
            $evvAW.Contracts.throwIfNullOrWhitespace(nickname, this.privErrors.invalidArgs.replace("{arg}", "nickname"));
            $evvAW.Contracts.throwIfNullOrUndefined(this.privRoom, this.privErrors.permissionDeniedSend);
            if (!this.canSend) this.handleError(new Error(this.privErrors.permissionDeniedSend), err);
            (_a = this.privConversationRecognizer) === null || _a === void 0 || _a.sendRequest(this.getChangeNicknameCommand(nickname), function() {
                _this.handleCallback(cb, err);
            }, function(error) {
                _this.handleError(error, err);
            });
        } catch (error) {
            this.handleError(error, err);
        }
    };
    ConversationImpl.prototype.isDisposed = function() {
        return this.privIsDisposed;
    };
    ConversationImpl.prototype.dispose = function(reason) {
        var _a;
        if (this.isDisposed) return;
        this.privIsDisposed = true;
        (_a = this.config) === null || _a === void 0 || _a.close();
        this.privConfig = undefined;
        this.privLanguage = undefined;
        this.privProperties = undefined;
        this.privRoom = undefined;
        this.privToken = undefined;
        this.privManager = undefined;
        this.privConversationRecognizer = undefined;
        this.privIsConnected = false;
        this.privIsReady = false;
        this.privParticipants = undefined;
    };
    Object.defineProperty(ConversationImpl.prototype, "transcriberRecognizer", {
        get: function() {
            return this.privTranscriberRecognizer;
        },
        enumerable: false,
        configurable: true
    });
    ConversationImpl.prototype.connectTranscriberRecognizer = function(recognizer) {
        return $736972d54f5e676e$var$__awaiter(this, void 0, void 0, function() {
            return $736972d54f5e676e$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!!!this.privTranscriberRecognizer) return [
                            3 /*break*/ ,
                            2
                        ];
                        return [
                            4 /*yield*/ ,
                            this.privTranscriberRecognizer.close()
                        ];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        this.privTranscriberRecognizer = recognizer;
                        this.privTranscriberRecognizer.conversation = this;
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    Object.defineProperty(ConversationImpl.prototype, "conversationInfo", {
        get: function() {
            var convId = this.conversationId;
            var p = this.participants.map(function(part) {
                return {
                    id: part.id,
                    preferredLanguage: part.preferredLanguage,
                    voice: part.voice
                };
            });
            var props = {};
            for(var _i = 0, _a = $9MAMI.ConversationConnectionConfig.transcriptionEventKeys; _i < _a.length; _i++){
                var key = _a[_i];
                var val = this.properties.getProperty(key, "");
                if (val !== "") props[key] = val;
            }
            var info = {
                id: convId,
                participants: p,
                conversationProperties: props
            };
            return info;
        },
        enumerable: false,
        configurable: true
    });
    ConversationImpl.prototype.addParticipantImplAsync = function(participant) {
        var newParticipant = this.privParticipants.addOrUpdateParticipant(participant);
        if (newParticipant !== undefined) {
            if (!!this.privTranscriberRecognizer) {
                var conversationInfo = this.conversationInfo;
                conversationInfo.participants = [
                    participant
                ];
                return this.privTranscriberRecognizer.pushConversationEvent(conversationInfo, "join");
            }
        }
    };
    ConversationImpl.prototype.removeParticipantImplAsync = function(participant) {
        this.privParticipants.deleteParticipant(participant.id);
        var conversationInfo = this.conversationInfo;
        conversationInfo.participants = [
            participant
        ];
        return this.privTranscriberRecognizer.pushConversationEvent(conversationInfo, "leave");
    };
    ConversationImpl.prototype.close = function(dispose) {
        var _a, _b;
        return $736972d54f5e676e$var$__awaiter(this, void 0, void 0, function() {
            var e_1;
            return $736972d54f5e676e$var$__generator(this, function(_c) {
                switch(_c.label){
                    case 0:
                        _c.trys.push([
                            0,
                            3,
                            ,
                            4
                        ]);
                        this.privIsConnected = false;
                        return [
                            4 /*yield*/ ,
                            this.privConversationRecognizer.close()
                        ];
                    case 1:
                        _c.sent();
                        return [
                            4 /*yield*/ ,
                            (_a = this.privTranscriberRecognizer) === null || _a === void 0 ? void 0 : _a.close()
                        ];
                    case 2:
                        _c.sent();
                        this.privConversationRecognizer = undefined;
                        (_b = this.privConversationTranslator) === null || _b === void 0 || _b.dispose();
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 3:
                        e_1 = _c.sent();
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 4:
                        if (dispose) this.dispose();
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    Object.defineProperty(ConversationImpl.prototype, "canSend", {
        /** Helpers */ get: function() {
            var _a;
            return this.privIsConnected && !((_a = this.privParticipants.me) === null || _a === void 0 ? void 0 : _a.isMuted);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ConversationImpl.prototype, "canSendAsHost", {
        get: function() {
            var _a;
            return this.privIsConnected && ((_a = this.privParticipants.me) === null || _a === void 0 ? void 0 : _a.isHost);
        },
        enumerable: false,
        configurable: true
    });
    ConversationImpl.prototype.handleCallback = function(cb, err) {
        if (!!cb) {
            try {
                cb();
            } catch (e) {
                if (!!err) err(e);
            }
            cb = undefined;
        }
    };
    ConversationImpl.prototype.handleError = function(error, err) {
        if (!!err) {
            if (error instanceof Error) {
                var typedError = error;
                err(typedError.name + ": " + typedError.message);
            } else err(error);
        }
    };
    /** Participant Helpers */ ConversationImpl.prototype.toParticipants = function(includeHost) {
        var _this = this;
        var participants = this.privParticipants.participants.map(function(p) {
            return _this.toParticipant(p);
        });
        if (!includeHost) return participants.filter(function(p) {
            return p.isHost === false;
        });
        else return participants;
    };
    ConversationImpl.prototype.toParticipant = function(p) {
        return new $iQDnw.Participant(p.id, p.avatar, p.displayName, p.isHost, p.isMuted, p.isUsingTts, p.preferredLanguage, p.voice);
    };
    ConversationImpl.prototype.getMuteAllCommand = function(isMuted) {
        $evvAW.Contracts.throwIfNullOrWhitespace(this.privRoom.roomId, "conversationId");
        $evvAW.Contracts.throwIfNullOrWhitespace(this.privRoom.participantId, "participantId");
        return JSON.stringify({
            command: $9MAMI.ConversationTranslatorCommandTypes.setMuteAll,
            // tslint:disable-next-line: object-literal-shorthand
            participantId: this.privRoom.participantId,
            roomid: this.privRoom.roomId,
            type: $9MAMI.ConversationTranslatorMessageTypes.participantCommand,
            value: isMuted
        });
    };
    ConversationImpl.prototype.getMuteCommand = function(participantId, isMuted) {
        $evvAW.Contracts.throwIfNullOrWhitespace(this.privRoom.roomId, "conversationId");
        $evvAW.Contracts.throwIfNullOrWhitespace(participantId, "participantId");
        return JSON.stringify({
            command: $9MAMI.ConversationTranslatorCommandTypes.setMute,
            // tslint:disable-next-line: object-literal-shorthand
            participantId: participantId,
            roomid: this.privRoom.roomId,
            type: $9MAMI.ConversationTranslatorMessageTypes.participantCommand,
            value: isMuted
        });
    };
    ConversationImpl.prototype.getLockCommand = function(isLocked) {
        $evvAW.Contracts.throwIfNullOrWhitespace(this.privRoom.roomId, "conversationId");
        $evvAW.Contracts.throwIfNullOrWhitespace(this.privRoom.participantId, "participantId");
        return JSON.stringify({
            command: $9MAMI.ConversationTranslatorCommandTypes.setLockState,
            // tslint:disable-next-line: object-literal-shorthand
            participantId: this.privRoom.participantId,
            roomid: this.privRoom.roomId,
            type: $9MAMI.ConversationTranslatorMessageTypes.participantCommand,
            value: isLocked
        });
    };
    ConversationImpl.prototype.getEjectCommand = function(participantId) {
        $evvAW.Contracts.throwIfNullOrWhitespace(this.privRoom.roomId, "conversationId");
        $evvAW.Contracts.throwIfNullOrWhitespace(participantId, "participantId");
        return JSON.stringify({
            command: $9MAMI.ConversationTranslatorCommandTypes.ejectParticipant,
            // tslint:disable-next-line: object-literal-shorthand
            participantId: participantId,
            roomid: this.privRoom.roomId,
            type: $9MAMI.ConversationTranslatorMessageTypes.participantCommand
        });
    };
    ConversationImpl.prototype.getChangeNicknameCommand = function(nickname) {
        $evvAW.Contracts.throwIfNullOrWhitespace(this.privRoom.roomId, "conversationId");
        $evvAW.Contracts.throwIfNullOrWhitespace(nickname, "nickname");
        $evvAW.Contracts.throwIfNullOrWhitespace(this.privRoom.participantId, "participantId");
        return JSON.stringify({
            command: $9MAMI.ConversationTranslatorCommandTypes.changeNickname,
            nickname: nickname,
            // tslint:disable-next-line: object-literal-shorthand
            participantId: this.privRoom.participantId,
            roomid: this.privRoom.roomId,
            type: $9MAMI.ConversationTranslatorMessageTypes.participantCommand,
            value: nickname
        });
    };
    ConversationImpl.prototype.getMessageCommand = function(message) {
        $evvAW.Contracts.throwIfNullOrWhitespace(this.privRoom.roomId, "conversationId");
        $evvAW.Contracts.throwIfNullOrWhitespace(this.privRoom.participantId, "participantId");
        $evvAW.Contracts.throwIfNullOrWhitespace(message, "message");
        return JSON.stringify({
            // tslint:disable-next-line: object-literal-shorthand
            participantId: this.privRoom.participantId,
            roomId: this.privRoom.roomId,
            text: message,
            type: $9MAMI.ConversationTranslatorMessageTypes.instantMessage
        });
    };
    return ConversationImpl;
}($736972d54f5e676e$var$Conversation);
module.exports.ConversationImpl = $736972d54f5e676e$var$ConversationImpl;

});

parcelRequire.register("1ql0W", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ConversationCommon = void 0;
var $109885228f9711fc$var$ConversationCommon = /** @class */ function() {
    function ConversationCommon(audioConfig) {
        this.privAudioConfig = audioConfig;
    }
    ConversationCommon.prototype.handleCallback = function(cb, err) {
        if (!!cb) {
            try {
                cb();
            } catch (e) {
                if (!!err) err(e);
            }
            cb = undefined;
        }
    };
    ConversationCommon.prototype.handleError = function(error, err) {
        if (!!err) {
            if (error instanceof Error) {
                var typedError = error;
                err(typedError.name + ": " + typedError.message);
            } else err(error);
        }
    };
    return ConversationCommon;
}();
module.exports.ConversationCommon = $109885228f9711fc$var$ConversationCommon;

});

parcelRequire.register("gXf2c", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
// Multi-device Conversation is a Preview feature.
var $c57dd18d4f8ef242$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ConversationExpirationEventArgs = void 0;

var $iQDnw = parcelRequire("iQDnw");
var $c57dd18d4f8ef242$var$ConversationExpirationEventArgs = /** @class */ function(_super) {
    $c57dd18d4f8ef242$var$__extends(ConversationExpirationEventArgs, _super);
    function ConversationExpirationEventArgs(expirationTime, sessionId) {
        var _this = _super.call(this, sessionId) || this;
        _this.privExpirationTime = expirationTime;
        return _this;
    }
    Object.defineProperty(ConversationExpirationEventArgs.prototype, "expirationTime", {
        /** How much longer until the conversation expires (in minutes). */ get: function() {
            return this.privExpirationTime;
        },
        enumerable: false,
        configurable: true
    });
    return ConversationExpirationEventArgs;
}($iQDnw.SessionEventArgs);
module.exports.ConversationExpirationEventArgs = $c57dd18d4f8ef242$var$ConversationExpirationEventArgs;

});

parcelRequire.register("hoSof", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
// Multi-device Conversation is a Preview feature.
var $caaede4a9035e907$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ConversationParticipantsChangedEventArgs = void 0;

var $iQDnw = parcelRequire("iQDnw");
var $caaede4a9035e907$var$ConversationParticipantsChangedEventArgs = /** @class */ function(_super) {
    $caaede4a9035e907$var$__extends(ConversationParticipantsChangedEventArgs, _super);
    function ConversationParticipantsChangedEventArgs(reason, participants, sessionId) {
        var _this = _super.call(this, sessionId) || this;
        _this.privReason = reason;
        _this.privParticipant = participants;
        return _this;
    }
    Object.defineProperty(ConversationParticipantsChangedEventArgs.prototype, "reason", {
        get: function() {
            return this.privReason;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ConversationParticipantsChangedEventArgs.prototype, "participants", {
        get: function() {
            return this.privParticipant;
        },
        enumerable: false,
        configurable: true
    });
    return ConversationParticipantsChangedEventArgs;
}($iQDnw.SessionEventArgs);
module.exports.ConversationParticipantsChangedEventArgs = $caaede4a9035e907$var$ConversationParticipantsChangedEventArgs;

});

parcelRequire.register("blM8U", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
// Multi-device Conversation is a Preview feature.
var $843700052586c793$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ConversationTranslationCanceledEventArgs = void 0;

var $dFtwT = parcelRequire("dFtwT");
var $843700052586c793$var$ConversationTranslationCanceledEventArgs = /** @class */ function(_super) {
    $843700052586c793$var$__extends(ConversationTranslationCanceledEventArgs, _super);
    function ConversationTranslationCanceledEventArgs() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return ConversationTranslationCanceledEventArgs;
}($dFtwT.CancellationEventArgsBase);
module.exports.ConversationTranslationCanceledEventArgs = $843700052586c793$var$ConversationTranslationCanceledEventArgs;

});

parcelRequire.register("2C5FD", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
// Multi-device Conversation is a Preview feature.
var $1e7387698e68bcab$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ConversationTranslationEventArgs = void 0;

var $iQDnw = parcelRequire("iQDnw");
var $1e7387698e68bcab$var$ConversationTranslationEventArgs = /** @class */ function(_super) {
    $1e7387698e68bcab$var$__extends(ConversationTranslationEventArgs, _super);
    /**
     * Creates and initializes an instance of this class.
     * @constructor
     * @param {ConversationTranslationResult} result - The translation recognition result.
     * @param {number} offset - The offset.
     * @param {string} sessionId - The session id.
     */ function ConversationTranslationEventArgs(result, offset, sessionId) {
        var _this = _super.call(this, offset, sessionId) || this;
        _this.privResult = result;
        return _this;
    }
    Object.defineProperty(ConversationTranslationEventArgs.prototype, "result", {
        /**
         * Specifies the recognition result.
         * @returns {ConversationTranslationResult} the recognition result.
         */ get: function() {
            return this.privResult;
        },
        enumerable: false,
        configurable: true
    });
    return ConversationTranslationEventArgs;
}($iQDnw.RecognitionEventArgs);
module.exports.ConversationTranslationEventArgs = $1e7387698e68bcab$var$ConversationTranslationEventArgs;

});

parcelRequire.register("113kD", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
// Multi-device Conversation is a Preview feature.
var $0bd8780f378ca635$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ConversationTranslationResult = void 0;

var $k62Rg = parcelRequire("k62Rg");
var $0bd8780f378ca635$var$ConversationTranslationResult = /** @class */ function(_super) {
    $0bd8780f378ca635$var$__extends(ConversationTranslationResult, _super);
    function ConversationTranslationResult(participantId, translations, originalLanguage, resultId, reason, text, duration, offset, errorDetails, json, properties) {
        var _this = _super.call(this, translations, resultId, reason, text, duration, offset, errorDetails, json, properties) || this;
        _this.privId = participantId;
        _this.privOrigLang = originalLanguage;
        return _this;
    }
    Object.defineProperty(ConversationTranslationResult.prototype, "participantId", {
        /**
         * The unique identifier for the participant this result is for.
         */ get: function() {
            return this.privId;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ConversationTranslationResult.prototype, "originalLang", {
        /**
         * The original language this result was in.
         */ get: function() {
            return this.privOrigLang;
        },
        enumerable: false,
        configurable: true
    });
    return ConversationTranslationResult;
}($k62Rg.TranslationRecognitionResult);
module.exports.ConversationTranslationResult = $0bd8780f378ca635$var$ConversationTranslationResult;

});

parcelRequire.register("kt5Mj", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
// Multi-device Conversation is a Preview feature.
var $ee6aff87c9a3b5ba$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $ee6aff87c9a3b5ba$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $ee6aff87c9a3b5ba$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ConversationTranslator = module.exports.SpeechState = void 0;

var $9MAMI = parcelRequire("9MAMI");

var $7srwU = parcelRequire("7srwU");

var $evvAW = parcelRequire("evvAW");

var $iQDnw = parcelRequire("iQDnw");

var $9UkLh = parcelRequire("9UkLh");

var $by2ku = parcelRequire("by2ku");
var $ee6aff87c9a3b5ba$var$SpeechState;
(function(SpeechState) {
    SpeechState[SpeechState["Inactive"] = 0] = "Inactive";
    SpeechState[SpeechState["Connecting"] = 1] = "Connecting";
    SpeechState[SpeechState["Connected"] = 2] = "Connected";
})($ee6aff87c9a3b5ba$var$SpeechState = module.exports.SpeechState || (module.exports.SpeechState = {}));
// tslint:disable:max-classes-per-file
// child class of TranslationRecognizer meant only for use with ConversationTranslator
var $ee6aff87c9a3b5ba$var$ConversationTranslationRecognizer = /** @class */ function(_super) {
    $ee6aff87c9a3b5ba$var$__extends(ConversationTranslationRecognizer, _super);
    function ConversationTranslationRecognizer(speechConfig, audioConfig, translator) {
        var _this = _super.call(this, speechConfig, audioConfig) || this;
        _this.privSpeechState = $ee6aff87c9a3b5ba$var$SpeechState.Inactive;
        if (!!translator) {
            _this.privTranslator = translator;
            _this.sessionStarted = function() {
                _this.privSpeechState = $ee6aff87c9a3b5ba$var$SpeechState.Connected;
            };
            _this.sessionStopped = function() {
                _this.privSpeechState = $ee6aff87c9a3b5ba$var$SpeechState.Inactive;
            };
            _this.recognized = function(tr, e) {
                return $ee6aff87c9a3b5ba$var$__awaiter(_this, void 0, void 0, function() {
                    var _a;
                    return $ee6aff87c9a3b5ba$var$__generator(this, function(_b) {
                        switch(_b.label){
                            case 0:
                                if (!((_a = e.result) === null || _a === void 0 ? void 0 : _a.errorDetails)) return [
                                    3 /*break*/ ,
                                    2
                                ];
                                return [
                                    4 /*yield*/ ,
                                    this.cancelSpeech()
                                ];
                            case 1:
                                _b.sent();
                                // TODO: format the error message contained in 'errorDetails'
                                this.fireCancelEvent(e.result.errorDetails);
                                _b.label = 2;
                            case 2:
                                return [
                                    2 /*return*/ 
                                ];
                        }
                    });
                });
            };
            _this.canceled = function(r, e) {
                return $ee6aff87c9a3b5ba$var$__awaiter(_this, void 0, void 0, function() {
                    var error_1;
                    return $ee6aff87c9a3b5ba$var$__generator(this, function(_a) {
                        switch(_a.label){
                            case 0:
                                if (!(this.privSpeechState !== $ee6aff87c9a3b5ba$var$SpeechState.Inactive)) return [
                                    3 /*break*/ ,
                                    4
                                ];
                                _a.label = 1;
                            case 1:
                                _a.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                return [
                                    4 /*yield*/ ,
                                    this.cancelSpeech()
                                ];
                            case 2:
                                _a.sent();
                                return [
                                    3 /*break*/ ,
                                    4
                                ];
                            case 3:
                                error_1 = _a.sent();
                                this.privSpeechState = $ee6aff87c9a3b5ba$var$SpeechState.Inactive;
                                return [
                                    3 /*break*/ ,
                                    4
                                ];
                            case 4:
                                return [
                                    2 /*return*/ 
                                ];
                        }
                    });
                });
            };
        }
        return _this;
    }
    Object.defineProperty(ConversationTranslationRecognizer.prototype, "state", {
        get: function() {
            return this.privSpeechState;
        },
        set: function(newState) {
            this.privSpeechState = newState;
        },
        enumerable: false,
        configurable: true
    });
    ConversationTranslationRecognizer.prototype.onConnection = function() {
        this.privSpeechState = $ee6aff87c9a3b5ba$var$SpeechState.Connected;
    };
    ConversationTranslationRecognizer.prototype.onDisconnection = function() {
        return $ee6aff87c9a3b5ba$var$__awaiter(this, void 0, void 0, function() {
            return $ee6aff87c9a3b5ba$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        this.privSpeechState = $ee6aff87c9a3b5ba$var$SpeechState.Inactive;
                        return [
                            4 /*yield*/ ,
                            this.cancelSpeech()
                        ];
                    case 1:
                        _a.sent();
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * Fire a cancel event
     * @param error
     */ ConversationTranslationRecognizer.prototype.fireCancelEvent = function(error) {
        var _a, _b, _c;
        try {
            if (!!this.privTranslator.canceled) {
                var cancelEvent = new $by2ku.ConversationTranslationCanceledEventArgs((_a = error === null || error === void 0 ? void 0 : error.reason) !== null && _a !== void 0 ? _a : $iQDnw.CancellationReason.Error, (_b = error === null || error === void 0 ? void 0 : error.errorDetails) !== null && _b !== void 0 ? _b : error, (_c = error === null || error === void 0 ? void 0 : error.errorCode) !== null && _c !== void 0 ? _c : $iQDnw.CancellationErrorCode.RuntimeError, undefined, error === null || error === void 0 ? void 0 : error.sessionId);
                this.privTranslator.canceled(this.privTranslator, cancelEvent);
            }
        } catch (e) {
        //
        }
    };
    ConversationTranslationRecognizer.prototype.cancelSpeech = function() {
        var _a;
        return $ee6aff87c9a3b5ba$var$__awaiter(this, void 0, void 0, function() {
            var e_1;
            return $ee6aff87c9a3b5ba$var$__generator(this, function(_b) {
                switch(_b.label){
                    case 0:
                        _b.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        this.stopContinuousRecognitionAsync();
                        return [
                            4 /*yield*/ ,
                            (_a = this.privReco) === null || _a === void 0 ? void 0 : _a.disconnect()
                        ];
                    case 1:
                        _b.sent();
                        this.privSpeechState = $ee6aff87c9a3b5ba$var$SpeechState.Inactive;
                        return [
                            3 /*break*/ ,
                            3
                        ];
                    case 2:
                        e_1 = _b.sent();
                        return [
                            3 /*break*/ ,
                            3
                        ];
                    case 3:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    return ConversationTranslationRecognizer;
}($iQDnw.TranslationRecognizer);
/***
 * Join, leave or connect to a conversation.
 */ var $ee6aff87c9a3b5ba$var$ConversationTranslator = /** @class */ function(_super) {
    $ee6aff87c9a3b5ba$var$__extends(ConversationTranslator, _super);
    function ConversationTranslator(audioConfig) {
        var _this = _super.call(this, audioConfig) || this;
        _this.privIsDisposed = false;
        _this.privIsSpeaking = false;
        _this.privErrors = $9MAMI.ConversationConnectionConfig.restErrors;
        _this.privPlaceholderKey = "abcdefghijklmnopqrstuvwxyz012345";
        _this.privPlaceholderRegion = "westus";
        _this.privProperties = new $iQDnw.PropertyCollection();
        return _this;
    }
    Object.defineProperty(ConversationTranslator.prototype, "properties", {
        get: function() {
            return this.privProperties;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ConversationTranslator.prototype, "speechRecognitionLanguage", {
        get: function() {
            return this.privSpeechRecognitionLanguage;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ConversationTranslator.prototype, "participants", {
        get: function() {
            var _a;
            return (_a = this.privConversation) === null || _a === void 0 ? void 0 : _a.participants;
        },
        enumerable: false,
        configurable: true
    });
    ConversationTranslator.prototype.joinConversationAsync = function(conversation, nickname, param1, param2, param3) {
        var _this = this;
        try {
            if (typeof conversation === "string") {
                $evvAW.Contracts.throwIfNullOrUndefined(conversation, this.privErrors.invalidArgs.replace("{arg}", "conversation id"));
                $evvAW.Contracts.throwIfNullOrWhitespace(nickname, this.privErrors.invalidArgs.replace("{arg}", "nickname"));
                if (!!this.privConversation) this.handleError(new Error(this.privErrors.permissionDeniedStart), param3);
                var lang = param1;
                if (lang === undefined || lang === null || lang === "") lang = $9MAMI.ConversationConnectionConfig.defaultLanguageCode;
                // create a placeholder config
                this.privSpeechTranslationConfig = $iQDnw.SpeechTranslationConfig.fromSubscription(this.privPlaceholderKey, this.privPlaceholderRegion);
                this.privSpeechTranslationConfig.setProfanity($iQDnw.ProfanityOption.Masked);
                this.privSpeechTranslationConfig.addTargetLanguage(lang);
                this.privSpeechTranslationConfig.setProperty($iQDnw.PropertyId[$iQDnw.PropertyId.SpeechServiceConnection_RecoLanguage], lang);
                this.privSpeechTranslationConfig.setProperty($iQDnw.PropertyId[$iQDnw.PropertyId.ConversationTranslator_Name], nickname);
                var endpoint = this.privProperties.getProperty($iQDnw.PropertyId.ConversationTranslator_Host);
                if (endpoint) this.privSpeechTranslationConfig.setProperty($iQDnw.PropertyId[$iQDnw.PropertyId.ConversationTranslator_Host], endpoint);
                var speechEndpointHost = this.privProperties.getProperty($iQDnw.PropertyId.SpeechServiceConnection_Host);
                if (speechEndpointHost) this.privSpeechTranslationConfig.setProperty($iQDnw.PropertyId[$iQDnw.PropertyId.SpeechServiceConnection_Host], speechEndpointHost);
                // join the conversation
                this.privConversation = new $9UkLh.ConversationImpl(this.privSpeechTranslationConfig);
                this.privConversation.conversationTranslator = this;
                this.privConversation.joinConversationAsync(conversation, nickname, lang, function(result) {
                    if (!result) _this.handleError(new Error(_this.privErrors.permissionDeniedConnect), param3);
                    _this.privSpeechTranslationConfig.authorizationToken = result;
                    // connect to the ws
                    _this.privConversation.startConversationAsync(function() {
                        _this.handleCallback(param2, param3);
                    }, function(error) {
                        _this.handleError(error, param3);
                    });
                }, function(error) {
                    _this.handleError(error, param3);
                });
            } else if (typeof conversation === "object") {
                $evvAW.Contracts.throwIfNullOrUndefined(conversation, this.privErrors.invalidArgs.replace("{arg}", "conversation id"));
                $evvAW.Contracts.throwIfNullOrWhitespace(nickname, this.privErrors.invalidArgs.replace("{arg}", "nickname"));
                // save the nickname
                this.privProperties.setProperty($iQDnw.PropertyId.ConversationTranslator_Name, nickname);
                // ref the conversation object
                this.privConversation = conversation;
                // ref the conversation translator object
                this.privConversation.conversationTranslator = this;
                $evvAW.Contracts.throwIfNullOrUndefined(this.privConversation, this.privErrors.permissionDeniedConnect);
                $evvAW.Contracts.throwIfNullOrUndefined(this.privConversation.room.token, this.privErrors.permissionDeniedConnect);
                this.privSpeechTranslationConfig = conversation.config;
                this.handleCallback(param1, param2);
            } else this.handleError(new Error(this.privErrors.invalidArgs.replace("{arg}", "invalid conversation type")), param2);
        } catch (error) {
            this.handleError(error, typeof param1 === "string" ? param3 : param2);
        }
    };
    /**
     * Leave the conversation
     * @param cb
     * @param err
     */ ConversationTranslator.prototype.leaveConversationAsync = function(cb, err) {
        var _this = this;
        $7srwU.marshalPromiseToCallbacks(function() {
            return $ee6aff87c9a3b5ba$var$__awaiter(_this, void 0, void 0, function() {
                return $ee6aff87c9a3b5ba$var$__generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            // stop the speech websocket
                            return [
                                4 /*yield*/ ,
                                this.cancelSpeech()
                            ];
                        case 1:
                            // stop the speech websocket
                            _a.sent();
                            // stop the websocket
                            return [
                                4 /*yield*/ ,
                                this.privConversation.endConversationImplAsync()
                            ];
                        case 2:
                            // stop the websocket
                            _a.sent();
                            // https delete request
                            return [
                                4 /*yield*/ ,
                                this.privConversation.deleteConversationImplAsync()
                            ];
                        case 3:
                            // https delete request
                            _a.sent();
                            this.dispose();
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        }(), cb, err);
    };
    /**
     * Send a text message
     * @param message
     * @param cb
     * @param err
     */ ConversationTranslator.prototype.sendTextMessageAsync = function(message, cb, err) {
        var _a;
        try {
            $evvAW.Contracts.throwIfNullOrUndefined(this.privConversation, this.privErrors.permissionDeniedSend);
            $evvAW.Contracts.throwIfNullOrWhitespace(message, this.privErrors.invalidArgs.replace("{arg}", message));
            (_a = this.privConversation) === null || _a === void 0 || _a.sendTextMessageAsync(message, cb, err);
        } catch (error) {
            this.handleError(error, err);
        }
    };
    /**
     * Start speaking
     * @param cb
     * @param err
     */ ConversationTranslator.prototype.startTranscribingAsync = function(cb, err) {
        var _this = this;
        $7srwU.marshalPromiseToCallbacks(function() {
            return $ee6aff87c9a3b5ba$var$__awaiter(_this, void 0, void 0, function() {
                var error_2;
                return $ee6aff87c9a3b5ba$var$__generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            _a.trys.push([
                                0,
                                4,
                                ,
                                6
                            ]);
                            $evvAW.Contracts.throwIfNullOrUndefined(this.privConversation, this.privErrors.permissionDeniedSend);
                            $evvAW.Contracts.throwIfNullOrUndefined(this.privConversation.room.token, this.privErrors.permissionDeniedConnect);
                            if (!(this.privCTRecognizer === undefined)) return [
                                3 /*break*/ ,
                                2
                            ];
                            return [
                                4 /*yield*/ ,
                                this.connectTranslatorRecognizer()
                            ];
                        case 1:
                            _a.sent();
                            _a.label = 2;
                        case 2:
                            $evvAW.Contracts.throwIfNullOrUndefined(this.privCTRecognizer, this.privErrors.permissionDeniedSend);
                            if (!this.canSpeak) this.handleError(new Error(this.privErrors.permissionDeniedSend), err);
                            return [
                                4 /*yield*/ ,
                                this.startContinuousRecognition()
                            ];
                        case 3:
                            _a.sent();
                            this.privIsSpeaking = true;
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case 4:
                            error_2 = _a.sent();
                            this.privIsSpeaking = false;
                            return [
                                4 /*yield*/ ,
                                this.cancelSpeech()
                            ];
                        case 5:
                            _a.sent();
                            throw error_2;
                        case 6:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        }(), cb, err);
    };
    /**
     * Stop speaking
     * @param cb
     * @param err
     */ ConversationTranslator.prototype.stopTranscribingAsync = function(cb, err) {
        var _this = this;
        $7srwU.marshalPromiseToCallbacks(function() {
            return $ee6aff87c9a3b5ba$var$__awaiter(_this, void 0, void 0, function() {
                var error_3;
                var _this = this;
                return $ee6aff87c9a3b5ba$var$__generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            _a.trys.push([
                                0,
                                4,
                                ,
                                6
                            ]);
                            if (!!this.privIsSpeaking) return [
                                3 /*break*/ ,
                                2
                            ];
                            // stop speech
                            return [
                                4 /*yield*/ ,
                                this.cancelSpeech()
                            ];
                        case 1:
                            // stop speech
                            _a.sent();
                            return [
                                2 /*return*/ 
                            ];
                        case 2:
                            // stop the recognition but leave the websocket open
                            this.privIsSpeaking = false;
                            return [
                                4 /*yield*/ ,
                                new Promise(function(resolve, reject) {
                                    var _a;
                                    (_a = _this.privCTRecognizer) === null || _a === void 0 || _a.stopContinuousRecognitionAsync(resolve, reject);
                                })
                            ];
                        case 3:
                            _a.sent();
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case 4:
                            error_3 = _a.sent();
                            return [
                                4 /*yield*/ ,
                                this.cancelSpeech()
                            ];
                        case 5:
                            _a.sent();
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case 6:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        }(), cb, err);
    };
    ConversationTranslator.prototype.isDisposed = function() {
        return this.privIsDisposed;
    };
    ConversationTranslator.prototype.dispose = function(reason, success, err) {
        var _this = this;
        $7srwU.marshalPromiseToCallbacks(function() {
            return $ee6aff87c9a3b5ba$var$__awaiter(_this, void 0, void 0, function() {
                var _a, _b;
                return $ee6aff87c9a3b5ba$var$__generator(this, function(_c) {
                    switch(_c.label){
                        case 0:
                            if (this.isDisposed && !this.privIsSpeaking) return [
                                2 /*return*/ 
                            ];
                            return [
                                4 /*yield*/ ,
                                this.cancelSpeech()
                            ];
                        case 1:
                            _c.sent();
                            this.privIsDisposed = true;
                            (_a = this.privSpeechTranslationConfig) === null || _a === void 0 || _a.close();
                            this.privSpeechRecognitionLanguage = undefined;
                            this.privProperties = undefined;
                            this.privAudioConfig = undefined;
                            this.privSpeechTranslationConfig = undefined;
                            (_b = this.privConversation) === null || _b === void 0 || _b.dispose();
                            this.privConversation = undefined;
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        }(), success, err);
    };
    /**
     * Cancel the speech websocket
     */ ConversationTranslator.prototype.cancelSpeech = function() {
        var _a;
        return $ee6aff87c9a3b5ba$var$__awaiter(this, void 0, void 0, function() {
            var e_2;
            return $ee6aff87c9a3b5ba$var$__generator(this, function(_b) {
                switch(_b.label){
                    case 0:
                        _b.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        this.privIsSpeaking = false;
                        return [
                            4 /*yield*/ ,
                            (_a = this.privCTRecognizer) === null || _a === void 0 ? void 0 : _a.onDisconnection()
                        ];
                    case 1:
                        _b.sent();
                        this.privCTRecognizer = undefined;
                        return [
                            3 /*break*/ ,
                            3
                        ];
                    case 2:
                        e_2 = _b.sent();
                        return [
                            3 /*break*/ ,
                            3
                        ];
                    case 3:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * Connect to the speech translation recognizer.
     * Currently there is no language validation performed before sending the SpeechLanguage code to the service.
     * If it's an invalid language the raw error will be: 'Error during WebSocket handshake: Unexpected response code: 400'
     * e.g. pass in 'fr' instead of 'fr-FR', or a text-only language 'cy'
     * @param cb
     * @param err
     */ ConversationTranslator.prototype.connectTranslatorRecognizer = function() {
        return $ee6aff87c9a3b5ba$var$__awaiter(this, void 0, void 0, function() {
            var token, endpointHost, url, error_4;
            return $ee6aff87c9a3b5ba$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        _a.trys.push([
                            0,
                            1,
                            ,
                            3
                        ]);
                        if (this.privAudioConfig === undefined) this.privAudioConfig = $iQDnw.AudioConfig.fromDefaultMicrophoneInput();
                        // clear the temp subscription key if it's a participant joining
                        if (this.privSpeechTranslationConfig.getProperty($iQDnw.PropertyId[$iQDnw.PropertyId.SpeechServiceConnection_Key]) === this.privPlaceholderKey) this.privSpeechTranslationConfig.setProperty($iQDnw.PropertyId[$iQDnw.PropertyId.SpeechServiceConnection_Key], "");
                        token = encodeURIComponent(this.privConversation.room.token);
                        endpointHost = this.privSpeechTranslationConfig.getProperty($iQDnw.PropertyId[$iQDnw.PropertyId.SpeechServiceConnection_Host], $9MAMI.ConversationConnectionConfig.speechHost);
                        endpointHost = endpointHost.replace("{region}", this.privConversation.room.cognitiveSpeechRegion);
                        url = "wss://" + endpointHost + $9MAMI.ConversationConnectionConfig.speechPath + "?" + $9MAMI.ConversationConnectionConfig.configParams.token + "=" + token;
                        this.privSpeechTranslationConfig.setProperty($iQDnw.PropertyId[$iQDnw.PropertyId.SpeechServiceConnection_Endpoint], url);
                        this.privCTRecognizer = new $ee6aff87c9a3b5ba$var$ConversationTranslationRecognizer(this.privSpeechTranslationConfig, this.privAudioConfig, this);
                        return [
                            3 /*break*/ ,
                            3
                        ];
                    case 1:
                        error_4 = _a.sent();
                        return [
                            4 /*yield*/ ,
                            this.cancelSpeech()
                        ];
                    case 2:
                        _a.sent();
                        throw error_4;
                    case 3:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * Handle the start speaking request
     * @param cb
     * @param err
     */ ConversationTranslator.prototype.startContinuousRecognition = function() {
        var _this = this;
        return new Promise(function(resolve, reject) {
            _this.privCTRecognizer.startContinuousRecognitionAsync(resolve, reject);
        });
    };
    Object.defineProperty(ConversationTranslator.prototype, "canSpeak", {
        get: function() {
            // is there a Conversation websocket available and has the Recognizer been set up
            if (!this.privConversation.isConnected || !this.privCTRecognizer) return false;
            // is the user already speaking
            if (this.privIsSpeaking || this.privCTRecognizer.state === $ee6aff87c9a3b5ba$var$SpeechState.Connected || this.privCTRecognizer.state === $ee6aff87c9a3b5ba$var$SpeechState.Connecting) return false;
            // is the user muted
            if (this.privConversation.isMutedByHost) return false;
            return true;
        },
        enumerable: false,
        configurable: true
    });
    return ConversationTranslator;
}($by2ku.ConversationCommon);
module.exports.ConversationTranslator = $ee6aff87c9a3b5ba$var$ConversationTranslator;

});

parcelRequire.register("2gral", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
var $1a6225f84f371423$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $1a6225f84f371423$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ConversationTranscriber = void 0;

var $9MAMI = parcelRequire("9MAMI");

var $7srwU = parcelRequire("7srwU");

var $evvAW = parcelRequire("evvAW");

var $iQDnw = parcelRequire("iQDnw");
var $1a6225f84f371423$var$ConversationTranscriber = /** @class */ function() {
    /**
     * ConversationTranscriber constructor.
     * @constructor
     * @param {AudioConfig} audioConfig - An optional audio configuration associated with the recognizer
     */ function ConversationTranscriber(audioConfig) {
        this.privAudioConfig = audioConfig;
        this.privProperties = new $iQDnw.PropertyCollection();
        this.privRecognizer = undefined;
        this.privDisposedRecognizer = false;
    }
    /**
     * @param {Conversation} converation - conversation to be recognized
     */ ConversationTranscriber.prototype.joinConversationAsync = function(conversation, cb, err) {
        var conversationImpl = conversation;
        $evvAW.Contracts.throwIfNullOrUndefined(conversationImpl, "Conversation");
        // ref the conversation object
        // create recognizer and subscribe to recognizer events
        this.privRecognizer = new $9MAMI.TranscriberRecognizer(conversation.config, this.privAudioConfig);
        $evvAW.Contracts.throwIfNullOrUndefined(this.privRecognizer, "Recognizer");
        this.privRecognizer.connectCallbacks(this);
        $7srwU.marshalPromiseToCallbacks(conversationImpl.connectTranscriberRecognizer(this.privRecognizer), cb, err);
    };
    Object.defineProperty(ConversationTranscriber.prototype, "authorizationToken", {
        /**
         * Gets the authorization token used to communicate with the service.
         * @member ConversationTranscriber.prototype.authorizationToken
         * @function
         * @public
         * @returns {string} Authorization token.
         */ get: function() {
            return this.properties.getProperty($iQDnw.PropertyId.SpeechServiceAuthorization_Token);
        },
        /**
         * Gets/Sets the authorization token used to communicate with the service.
         * @member ConversationTranscriber.prototype.authorizationToken
         * @function
         * @public
         * @param {string} token - Authorization token.
         */ set: function(token) {
            $evvAW.Contracts.throwIfNullOrWhitespace(token, "token");
            this.properties.setProperty($iQDnw.PropertyId.SpeechServiceAuthorization_Token, token);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ConversationTranscriber.prototype, "speechRecognitionLanguage", {
        /**
         * Gets the spoken language of recognition.
         * @member ConversationTranscriber.prototype.speechRecognitionLanguage
         * @function
         * @public
         * @returns {string} The spoken language of recognition.
         */ get: function() {
            $evvAW.Contracts.throwIfDisposed(this.privDisposedRecognizer);
            return this.properties.getProperty($iQDnw.PropertyId.SpeechServiceConnection_RecoLanguage);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ConversationTranscriber.prototype, "properties", {
        /**
         * The collection of properties and their values defined for this ConversationTranscriber.
         * @member ConversationTranscriber.prototype.properties
         * @function
         * @public
         * @returns {PropertyCollection} The collection of properties and their values defined for this ConversationTranscriber.
         */ get: function() {
            return this.privProperties;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Starts conversation transcription, until stopTranscribingAsync() is called.
     * User must subscribe to events to receive transcription results.
     * @member ConversationTranscriber.prototype.startTranscribingAsync
     * @function
     * @public
     * @param cb - Callback invoked once the transcription has started.
     * @param err - Callback invoked in case of an error.
     */ ConversationTranscriber.prototype.startTranscribingAsync = function(cb, err) {
        this.privRecognizer.startContinuousRecognitionAsync(cb, err);
    };
    /**
     * Starts conversation transcription, until stopTranscribingAsync() is called.
     * User must subscribe to events to receive transcription results.
     * @member ConversationTranscriber.prototype.stopTranscribingAsync
     * @function
     * @public
     * @param cb - Callback invoked once the transcription has started.
     * @param err - Callback invoked in case of an error.
     */ ConversationTranscriber.prototype.stopTranscribingAsync = function(cb, err) {
        this.privRecognizer.stopContinuousRecognitionAsync(cb, err);
    };
    /**
     * Leave the current conversation. After this is called, you will no longer receive any events.
     */ ConversationTranscriber.prototype.leaveConversationAsync = function(cb, err) {
        var _this = this;
        this.privRecognizer.disconnectCallbacks();
        $7srwU.marshalPromiseToCallbacks(function() {
            return $1a6225f84f371423$var$__awaiter(_this, void 0, void 0, function() {
                return $1a6225f84f371423$var$__generator(this, function(_a) {
                    return [
                        2 /*return*/ 
                    ];
                });
            });
        }(), cb, err);
    };
    /**
     * closes all external resources held by an instance of this class.
     * @member ConversationTranscriber.prototype.close
     * @function
     * @public
     */ ConversationTranscriber.prototype.close = function(cb, errorCb) {
        $evvAW.Contracts.throwIfDisposed(this.privDisposedRecognizer);
        $7srwU.marshalPromiseToCallbacks(this.dispose(true), cb, errorCb);
    };
    /**
     * Disposes any resources held by the object.
     * @member ConversationTranscriber.prototype.dispose
     * @function
     * @public
     * @param {boolean} disposing - true if disposing the object.
     */ ConversationTranscriber.prototype.dispose = function(disposing) {
        return $1a6225f84f371423$var$__awaiter(this, void 0, void 0, function() {
            return $1a6225f84f371423$var$__generator(this, function(_a) {
                if (this.privDisposedRecognizer) return [
                    2 /*return*/ 
                ];
                if (disposing) this.privDisposedRecognizer = true;
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    return ConversationTranscriber;
}();
module.exports.ConversationTranscriber = $1a6225f84f371423$var$ConversationTranscriber;

});

parcelRequire.register("bVIyY", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
// Multi-device Conversation is a Preview feature.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Participant = module.exports.User = void 0;

var $iQDnw = parcelRequire("iQDnw");
var $8af795e4460d85c4$var$User = /** @class */ function() {
    function User(userId) {
        this.privUserId = userId;
    }
    Object.defineProperty(User.prototype, "userId", {
        get: function() {
            return this.privUserId;
        },
        enumerable: false,
        configurable: true
    });
    return User;
}();
module.exports.User = $8af795e4460d85c4$var$User;
// tslint:disable-next-line: max-classes-per-file
var $8af795e4460d85c4$var$Participant = /** @class */ function() {
    function Participant(id, avatar, displayName, isHost, isMuted, isUsingTts, preferredLanguage, voice) {
        this.privId = id;
        this.privAvatar = avatar;
        this.privDisplayName = displayName;
        this.privIsHost = isHost;
        this.privIsMuted = isMuted;
        this.privIsUsingTts = isUsingTts;
        this.privPreferredLanguage = preferredLanguage;
        this.privVoice = voice;
        this.privProperties = new $iQDnw.PropertyCollection();
    }
    Participant.From = function(id, language, voice) {
        return new Participant(id, "", id, false, false, false, language, voice);
    };
    Object.defineProperty(Participant.prototype, "avatar", {
        get: function() {
            return this.privAvatar;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Participant.prototype, "displayName", {
        get: function() {
            return this.privDisplayName;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Participant.prototype, "id", {
        get: function() {
            return this.privId;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Participant.prototype, "preferredLanguage", {
        get: function() {
            return this.privPreferredLanguage;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Participant.prototype, "isHost", {
        get: function() {
            return this.privIsHost;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Participant.prototype, "isMuted", {
        get: function() {
            return this.privIsMuted;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Participant.prototype, "isUsingTts", {
        get: function() {
            return this.privIsUsingTts;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Participant.prototype, "voice", {
        get: function() {
            return this.privVoice;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Participant.prototype, "properties", {
        get: function() {
            return this.privProperties;
        },
        enumerable: false,
        configurable: true
    });
    return Participant;
}();
module.exports.Participant = $8af795e4460d85c4$var$Participant;

});

parcelRequire.register("aYx5P", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
// Multi-device Conversation is a Preview feature.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ParticipantChangedReason = void 0;
var $7fd92d89cdb7ed28$var$ParticipantChangedReason;
(function(ParticipantChangedReason) {
    /** Participant has joined the conversation. */ ParticipantChangedReason[ParticipantChangedReason["JoinedConversation"] = 0] = "JoinedConversation";
    /** Participant has left the conversation. This could be voluntary, or involuntary
     *  (e.g. they are experiencing networking issues).
     */ ParticipantChangedReason[ParticipantChangedReason["LeftConversation"] = 1] = "LeftConversation";
    /** The participants' state has changed (e.g. they became muted, changed their nickname). */ ParticipantChangedReason[ParticipantChangedReason["Updated"] = 2] = "Updated";
})($7fd92d89cdb7ed28$var$ParticipantChangedReason = module.exports.ParticipantChangedReason || (module.exports.ParticipantChangedReason = {}));

});


parcelRequire.register("n4jmR", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
var $04557e3f6d5e2a92$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $04557e3f6d5e2a92$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SynthesisRequest = module.exports.SpeechSynthesizer = void 0;

var $9MAMI = parcelRequire("9MAMI");

var $7srwU = parcelRequire("7srwU");

var $dydmC = parcelRequire("dydmC");

var $gU3rQ = parcelRequire("gU3rQ");

var $epVjg = parcelRequire("epVjg");

var $evvAW = parcelRequire("evvAW");

var $iQDnw = parcelRequire("iQDnw");
/**
 * Defines the class SpeechSynthesizer for text to speech.
 * Updated in version 1.16.0
 * @class SpeechSynthesizer
 */ var $04557e3f6d5e2a92$var$SpeechSynthesizer = /** @class */ function() {
    /**
     * SpeechSynthesizer constructor.
     * @constructor
     * @param {SpeechConfig} speechConfig - An set of initial properties for this synthesizer.
     * @param {AudioConfig} audioConfig - An optional audio configuration associated with the synthesizer.
     */ function SpeechSynthesizer(speechConfig, audioConfig) {
        var speechConfigImpl = speechConfig;
        $evvAW.Contracts.throwIfNull(speechConfigImpl, "speechConfig");
        if (audioConfig !== null) {
            if (audioConfig === undefined) this.audioConfig = typeof window === "undefined" ? undefined : $iQDnw.AudioConfig.fromDefaultSpeakerOutput();
            else this.audioConfig = audioConfig;
        }
        this.privProperties = speechConfigImpl.properties.clone();
        this.privDisposed = false;
        this.privSynthesizing = false;
        this.privConnectionFactory = new $9MAMI.SpeechSynthesisConnectionFactory();
        this.synthesisRequestQueue = new $7srwU.Queue();
        this.implCommonSynthesizeSetup();
    }
    Object.defineProperty(SpeechSynthesizer.prototype, "authorizationToken", {
        /**
         * Gets the authorization token used to communicate with the service.
         * @member SpeechSynthesizer.prototype.authorizationToken
         * @function
         * @public
         * @returns {string} Authorization token.
         */ get: function() {
            return this.properties.getProperty($iQDnw.PropertyId.SpeechServiceAuthorization_Token);
        },
        /**
         * Gets/Sets the authorization token used to communicate with the service.
         * @member SpeechSynthesizer.prototype.authorizationToken
         * @function
         * @public
         * @param {string} token - Authorization token.
         */ set: function(token) {
            $evvAW.Contracts.throwIfNullOrWhitespace(token, "token");
            this.properties.setProperty($iQDnw.PropertyId.SpeechServiceAuthorization_Token, token);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SpeechSynthesizer.prototype, "properties", {
        /**
         * The collection of properties and their values defined for this SpeechSynthesizer.
         * @member SpeechSynthesizer.prototype.properties
         * @function
         * @public
         * @returns {PropertyCollection} The collection of properties and their values defined for this SpeechSynthesizer.
         */ get: function() {
            return this.privProperties;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SpeechSynthesizer.prototype, "autoDetectSourceLanguage", {
        /**
         * Indicates if auto detect source language is enabled
         * @member SpeechSynthesizer.prototype.properties
         * @function
         * @public
         * @returns {boolean} if auto detect source language is enabled
         */ get: function() {
            return this.properties.getProperty($iQDnw.PropertyId.SpeechServiceConnection_AutoDetectSourceLanguages) === $9MAMI.AutoDetectSourceLanguagesOpenRangeOptionName;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * SpeechSynthesizer constructor.
     * @constructor
     * @param {SpeechConfig} speechConfig - an set of initial properties for this synthesizer
     * @param {AutoDetectSourceLanguageConfig} autoDetectSourceLanguageConfig - An source language detection configuration associated with the synthesizer
     * @param {AudioConfig} audioConfig - An optional audio configuration associated with the synthesizer
     */ SpeechSynthesizer.FromConfig = function(speechConfig, autoDetectSourceLanguageConfig, audioConfig) {
        var speechConfigImpl = speechConfig;
        autoDetectSourceLanguageConfig.properties.mergeTo(speechConfigImpl.properties);
        return new SpeechSynthesizer(speechConfig, audioConfig);
    };
    SpeechSynthesizer.prototype.buildSsml = function(text) {
        var _a;
        var languageToDefaultVoice = (_a = {}, _a["ar-EG"] = "Microsoft Server Speech Text to Speech Voice (ar-EG, Hoda)", _a["ar-SA"] = "Microsoft Server Speech Text to Speech Voice (ar-SA, Naayf)", _a["bg-BG"] = "Microsoft Server Speech Text to Speech Voice (bg-BG, Ivan)", _a["ca-ES"] = "Microsoft Server Speech Text to Speech Voice (ca-ES, HerenaRUS)", _a["cs-CZ"] = "Microsoft Server Speech Text to Speech Voice (cs-CZ, Jakub)", _a["da-DK"] = "Microsoft Server Speech Text to Speech Voice (da-DK, HelleRUS)", _a["de-AT"] = "Microsoft Server Speech Text to Speech Voice (de-AT, Michael)", _a["de-CH"] = "Microsoft Server Speech Text to Speech Voice (de-CH, Karsten)", _a["de-DE"] = "Microsoft Server Speech Text to Speech Voice (de-DE, HeddaRUS)", _a["el-GR"] = "Microsoft Server Speech Text to Speech Voice (el-GR, Stefanos)", _a["en-AU"] = "Microsoft Server Speech Text to Speech Voice (en-AU, HayleyRUS)", _a["en-CA"] = "Microsoft Server Speech Text to Speech Voice (en-CA, HeatherRUS)", _a["en-GB"] = "Microsoft Server Speech Text to Speech Voice (en-GB, HazelRUS)", _a["en-IE"] = "Microsoft Server Speech Text to Speech Voice (en-IE, Sean)", _a["en-IN"] = "Microsoft Server Speech Text to Speech Voice (en-IN, PriyaRUS)", _a["en-US"] = "Microsoft Server Speech Text to Speech Voice (en-US, AriaRUS)", _a["es-ES"] = "Microsoft Server Speech Text to Speech Voice (es-ES, HelenaRUS)", _a["es-MX"] = "Microsoft Server Speech Text to Speech Voice (es-MX, HildaRUS)", _a["fi-FI"] = "Microsoft Server Speech Text to Speech Voice (fi-FI, HeidiRUS)", _a["fr-CA"] = "Microsoft Server Speech Text to Speech Voice (fr-CA, HarmonieRUS)", _a["fr-CH"] = "Microsoft Server Speech Text to Speech Voice (fr-CH, Guillaume)", _a["fr-FR"] = "Microsoft Server Speech Text to Speech Voice (fr-FR, HortenseRUS)", _a["he-IL"] = "Microsoft Server Speech Text to Speech Voice (he-IL, Asaf)", _a["hi-IN"] = "Microsoft Server Speech Text to Speech Voice (hi-IN, Kalpana)", _a["hr-HR"] = "Microsoft Server Speech Text to Speech Voice (hr-HR, Matej)", _a["hu-HU"] = "Microsoft Server Speech Text to Speech Voice (hu-HU, Szabolcs)", _a["id-ID"] = "Microsoft Server Speech Text to Speech Voice (id-ID, Andika)", _a["it-IT"] = "Microsoft Server Speech Text to Speech Voice (it-IT, LuciaRUS)", _a["ja-JP"] = "Microsoft Server Speech Text to Speech Voice (ja-JP, HarukaRUS)", _a["ko-KR"] = "Microsoft Server Speech Text to Speech Voice (ko-KR, HeamiRUS)", _a["ms-MY"] = "Microsoft Server Speech Text to Speech Voice (ms-MY, Rizwan)", _a["nb-NO"] = "Microsoft Server Speech Text to Speech Voice (nb-NO, HuldaRUS)", _a["nl-NL"] = "Microsoft Server Speech Text to Speech Voice (nl-NL, HannaRUS)", _a["pl-PL"] = "Microsoft Server Speech Text to Speech Voice (pl-PL, PaulinaRUS)", _a["pt-BR"] = "Microsoft Server Speech Text to Speech Voice (pt-BR, HeloisaRUS)", _a["pt-PT"] = "Microsoft Server Speech Text to Speech Voice (pt-PT, HeliaRUS)", _a["ro-RO"] = "Microsoft Server Speech Text to Speech Voice (ro-RO, Andrei)", _a["ru-RU"] = "Microsoft Server Speech Text to Speech Voice (ru-RU, EkaterinaRUS)", _a["sk-SK"] = "Microsoft Server Speech Text to Speech Voice (sk-SK, Filip)", _a["sl-SI"] = "Microsoft Server Speech Text to Speech Voice (sl-SI, Lado)", _a["sv-SE"] = "Microsoft Server Speech Text to Speech Voice (sv-SE, HedvigRUS)", _a["ta-IN"] = "Microsoft Server Speech Text to Speech Voice (ta-IN, Valluvar)", _a["te-IN"] = "Microsoft Server Speech Text to Speech Voice (te-IN, Chitra)", _a["th-TH"] = "Microsoft Server Speech Text to Speech Voice (th-TH, Pattara)", _a["tr-TR"] = "Microsoft Server Speech Text to Speech Voice (tr-TR, SedaRUS)", _a["vi-VN"] = "Microsoft Server Speech Text to Speech Voice (vi-VN, An)", _a["zh-CN"] = "Microsoft Server Speech Text to Speech Voice (zh-CN, HuihuiRUS)", _a["zh-HK"] = "Microsoft Server Speech Text to Speech Voice (zh-HK, TracyRUS)", _a["zh-TW"] = "Microsoft Server Speech Text to Speech Voice (zh-TW, HanHanRUS)", _a);
        var language = this.properties.getProperty($iQDnw.PropertyId.SpeechServiceConnection_SynthLanguage, "en-US");
        var voice = this.properties.getProperty($iQDnw.PropertyId.SpeechServiceConnection_SynthVoice, "");
        var ssml = SpeechSynthesizer.XMLEncode(text);
        if (this.autoDetectSourceLanguage) language = "en-US";
        else voice = voice || languageToDefaultVoice[language];
        if (voice) ssml = "<voice name='" + voice + "'>" + ssml + "</voice>";
        ssml = "<speak version='1.0' xmlns='http://www.w3.org/2001/10/synthesis' xmlns:mstts='http://www.w3.org/2001/mstts' xmlns:emo='http://www.w3.org/2009/10/emotionml' xml:lang='" + language + "'>" + ssml + "</speak>";
        return ssml;
    };
    /**
     * Executes speech synthesis on plain text.
     * The task returns the synthesis result.
     * @member SpeechSynthesizer.prototype.speakTextAsync
     * @function
     * @public
     * @param text - Text to be synthesized.
     * @param cb - Callback that received the SpeechSynthesisResult.
     * @param err - Callback invoked in case of an error.
     * @param stream - AudioOutputStream to receive the synthesized audio.
     */ SpeechSynthesizer.prototype.speakTextAsync = function(text, cb, err, stream) {
        this.speakImpl(text, false, cb, err, stream);
    };
    /**
     * Executes speech synthesis on SSML.
     * The task returns the synthesis result.
     * @member SpeechSynthesizer.prototype.speakSsmlAsync
     * @function
     * @public
     * @param ssml - SSML to be synthesized.
     * @param cb - Callback that received the SpeechSynthesisResult.
     * @param err - Callback invoked in case of an error.
     * @param stream - AudioOutputStream to receive the synthesized audio.
     */ SpeechSynthesizer.prototype.speakSsmlAsync = function(ssml, cb, err, stream) {
        this.speakImpl(ssml, true, cb, err, stream);
    };
    /**
     * Dispose of associated resources.
     * @member SpeechSynthesizer.prototype.close
     * @function
     * @public
     */ SpeechSynthesizer.prototype.close = function(cb, err) {
        $evvAW.Contracts.throwIfDisposed(this.privDisposed);
        $7srwU.marshalPromiseToCallbacks(this.dispose(true), cb, err);
    };
    Object.defineProperty(SpeechSynthesizer.prototype, "internalData", {
        /**
         * @Internal
         * Do not use externally, object returned will change without warning or notice.
         */ get: function() {
            return this.privAdapter;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * This method performs cleanup of resources.
     * The Boolean parameter disposing indicates whether the method is called
     * from Dispose (if disposing is true) or from the finalizer (if disposing is false).
     * Derived classes should override this method to dispose resource if needed.
     * @member SpeechSynthesizer.prototype.dispose
     * @function
     * @public
     * @param {boolean} disposing - Flag to request disposal.
     */ SpeechSynthesizer.prototype.dispose = function(disposing) {
        return $04557e3f6d5e2a92$var$__awaiter(this, void 0, void 0, function() {
            return $04557e3f6d5e2a92$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (this.privDisposed) return [
                            2 /*return*/ 
                        ];
                        if (!disposing) return [
                            3 /*break*/ ,
                            2
                        ];
                        if (!this.privAdapter) return [
                            3 /*break*/ ,
                            2
                        ];
                        return [
                            4 /*yield*/ ,
                            this.privAdapter.dispose()
                        ];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        this.privDisposed = true;
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    //
    // ################################################################################################################
    // IMPLEMENTATION.
    // Move to independent class
    // ################################################################################################################
    //
    SpeechSynthesizer.prototype.createSynthesizerConfig = function(speechConfig) {
        return new $9MAMI.SynthesizerConfig(speechConfig, this.privProperties);
    };
    // Creates the synthesis adapter
    SpeechSynthesizer.prototype.createSynthesisAdapter = function(authentication, connectionFactory, audioConfig, synthesizerConfig) {
        return new $9MAMI.SynthesisAdapterBase(authentication, connectionFactory, synthesizerConfig, this, this.audioConfig);
    };
    SpeechSynthesizer.prototype.implCommonSynthesizeSetup = function() {
        var _this = this;
        var osPlatform = typeof window !== "undefined" ? "Browser" : "Node";
        var osName = "unknown";
        var osVersion = "unknown";
        if (typeof navigator !== "undefined") {
            osPlatform = osPlatform + "/" + navigator.platform;
            osName = navigator.userAgent;
            osVersion = navigator.appVersion;
        }
        var synthesizerConfig = this.createSynthesizerConfig(new $9MAMI.SpeechServiceConfig(new $9MAMI.Context(new $9MAMI.OS(osPlatform, osName, osVersion))));
        var subscriptionKey = this.privProperties.getProperty($iQDnw.PropertyId.SpeechServiceConnection_Key, undefined);
        var authentication = subscriptionKey && subscriptionKey !== "" ? new $9MAMI.CognitiveSubscriptionKeyAuthentication(subscriptionKey) : new $9MAMI.CognitiveTokenAuthentication(function(authFetchEventId) {
            var authorizationToken = _this.privProperties.getProperty($iQDnw.PropertyId.SpeechServiceAuthorization_Token, undefined);
            return Promise.resolve(authorizationToken);
        }, function(authFetchEventId) {
            var authorizationToken = _this.privProperties.getProperty($iQDnw.PropertyId.SpeechServiceAuthorization_Token, undefined);
            return Promise.resolve(authorizationToken);
        });
        this.privAdapter = this.createSynthesisAdapter(authentication, this.privConnectionFactory, this.audioConfig, synthesizerConfig);
        this.privAdapter.audioOutputFormat = $gU3rQ.AudioOutputFormatImpl.fromSpeechSynthesisOutputFormat($iQDnw.SpeechSynthesisOutputFormat[this.properties.getProperty($iQDnw.PropertyId.SpeechServiceConnection_SynthOutputFormat, undefined)]);
    };
    SpeechSynthesizer.prototype.speakImpl = function(text, IsSsml, cb, err, dataStream) {
        var _this = this;
        try {
            $evvAW.Contracts.throwIfDisposed(this.privDisposed);
            var requestId = $7srwU.createNoDashGuid();
            var audioDestination = void 0;
            if (dataStream instanceof $iQDnw.PushAudioOutputStreamCallback) audioDestination = new $epVjg.PushAudioOutputStreamImpl(dataStream);
            else if (dataStream instanceof $iQDnw.PullAudioOutputStream) audioDestination = dataStream;
            else if (dataStream !== undefined) audioDestination = new $dydmC.AudioFileWriter(dataStream);
            else audioDestination = undefined;
            this.synthesisRequestQueue.enqueue(new $04557e3f6d5e2a92$var$SynthesisRequest(requestId, text, IsSsml, function(e) {
                _this.privSynthesizing = false;
                if (!!cb) try {
                    cb(e);
                } catch (e) {
                    if (!!err) err(e);
                }
                cb = undefined;
                /* tslint:disable:no-empty */ _this.adapterSpeak().catch(function() {});
            }, function(e) {
                if (!!err) err(e);
            }, audioDestination));
            /* tslint:disable:no-empty */ this.adapterSpeak().catch(function() {});
        } catch (error) {
            if (!!err) {
                if (error instanceof Error) {
                    var typedError = error;
                    err(typedError.name + ": " + typedError.message);
                } else err(error);
            }
            // Destroy the synthesizer.
            /* tslint:disable:no-empty */ this.dispose(true).catch(function() {});
        }
    };
    SpeechSynthesizer.prototype.adapterSpeak = function() {
        return $04557e3f6d5e2a92$var$__awaiter(this, void 0, void 0, function() {
            var request;
            return $04557e3f6d5e2a92$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!(!this.privDisposed && !this.privSynthesizing)) return [
                            3 /*break*/ ,
                            2
                        ];
                        this.privSynthesizing = true;
                        return [
                            4 /*yield*/ ,
                            this.synthesisRequestQueue.dequeue()
                        ];
                    case 1:
                        request = _a.sent();
                        return [
                            2 /*return*/ ,
                            this.privAdapter.Speak(request.text, request.isSSML, request.requestId, request.cb, request.err, request.dataStream)
                        ];
                    case 2:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    SpeechSynthesizer.XMLEncode = function(text) {
        return text.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&apos;");
    };
    return SpeechSynthesizer;
}();
module.exports.SpeechSynthesizer = $04557e3f6d5e2a92$var$SpeechSynthesizer;
// tslint:disable-next-line:max-classes-per-file
var $04557e3f6d5e2a92$var$SynthesisRequest = /** @class */ function() {
    function SynthesisRequest(requestId, text, isSSML, cb, err, dataStream) {
        this.requestId = requestId;
        this.text = text;
        this.isSSML = isSSML;
        this.cb = cb;
        this.err = err;
        this.dataStream = dataStream;
    }
    return SynthesisRequest;
}();
module.exports.SynthesisRequest = $04557e3f6d5e2a92$var$SynthesisRequest;

});

parcelRequire.register("8tQIl", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SpeechSynthesisResult = void 0;
/**
 * Defines result of speech synthesis.
 * @class SpeechSynthesisResult
 * Added in version 1.11.0
 */ var $62c9ec19da4f6293$var$SpeechSynthesisResult = /** @class */ function() {
    /**
     * Creates and initializes an instance of this class.
     * @constructor
     * @param {string} resultId - The result id.
     * @param {ResultReason} reason - The reason.
     * @param {number} audioData - The offset into the stream.
     * @param {string} errorDetails - Error details, if provided.
     * @param {PropertyCollection} properties - Additional properties, if provided.
     */ function SpeechSynthesisResult(resultId, reason, audioData, errorDetails, properties) {
        this.privResultId = resultId;
        this.privReason = reason;
        this.privAudioData = audioData;
        this.privErrorDetails = errorDetails;
        this.privProperties = properties;
    }
    Object.defineProperty(SpeechSynthesisResult.prototype, "resultId", {
        /**
         * Specifies the result identifier.
         * @member SpeechSynthesisResult.prototype.resultId
         * @function
         * @public
         * @returns {string} Specifies the result identifier.
         */ get: function() {
            return this.privResultId;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SpeechSynthesisResult.prototype, "reason", {
        /**
         * Specifies status of the result.
         * @member SpeechSynthesisResult.prototype.reason
         * @function
         * @public
         * @returns {ResultReason} Specifies status of the result.
         */ get: function() {
            return this.privReason;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SpeechSynthesisResult.prototype, "audioData", {
        /**
         * The synthesized audio data
         * @member SpeechSynthesisResult.prototype.audioData
         * @function
         * @public
         * @returns {ArrayBuffer} The synthesized audio data.
         */ get: function() {
            return this.privAudioData;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SpeechSynthesisResult.prototype, "errorDetails", {
        /**
         * In case of an unsuccessful synthesis, provides details of the occurred error.
         * @member SpeechSynthesisResult.prototype.errorDetails
         * @function
         * @public
         * @returns {string} a brief description of an error.
         */ get: function() {
            return this.privErrorDetails;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SpeechSynthesisResult.prototype, "properties", {
        /**
         *  The set of properties exposed in the result.
         * @member SpeechSynthesisResult.prototype.properties
         * @function
         * @public
         * @returns {PropertyCollection} The set of properties exposed in the result.
         */ get: function() {
            return this.privProperties;
        },
        enumerable: false,
        configurable: true
    });
    return SpeechSynthesisResult;
}();
module.exports.SpeechSynthesisResult = $62c9ec19da4f6293$var$SpeechSynthesisResult;

});

parcelRequire.register("3mo9G", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SpeechSynthesisEventArgs = void 0;
/**
 * Defines contents of speech synthesis events.
 * @class SpeechSynthesisEventArgs
 * Added in version 1.11.0
 */ var $272629e5e8c0f7b6$var$SpeechSynthesisEventArgs = /** @class */ function() {
    /**
     * Creates and initializes an instance of this class.
     * @constructor
     * @param {SpeechSynthesisResult} result - The speech synthesis result.
     */ function SpeechSynthesisEventArgs(result) {
        this.privResult = result;
    }
    Object.defineProperty(SpeechSynthesisEventArgs.prototype, "result", {
        /**
         * Specifies the synthesis result.
         * @member SpeechSynthesisEventArgs.prototype.result
         * @function
         * @public
         * @returns {SpeechSynthesisResult} the synthesis result.
         */ get: function() {
            return this.privResult;
        },
        enumerable: false,
        configurable: true
    });
    return SpeechSynthesisEventArgs;
}();
module.exports.SpeechSynthesisEventArgs = $272629e5e8c0f7b6$var$SpeechSynthesisEventArgs;

});

parcelRequire.register("9Rbw1", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SpeechSynthesisWordBoundaryEventArgs = void 0;
/**
 * Defines contents of speech synthesis word boundary event.
 * @class SpeechSynthesisWordBoundaryEventArgs
 * Added in version 1.11.0
 */ var $72d1ff0921276bbb$var$SpeechSynthesisWordBoundaryEventArgs = /** @class */ function() {
    /**
     * Creates and initializes an instance of this class.
     * @constructor
     * @param {number} audioOffset - The audio offset.
     * @param {string} text - The text.
     * @param {number} wordLength - The length of the word.
     * @param {number} textOffset - The text offset.
     */ function SpeechSynthesisWordBoundaryEventArgs(audioOffset, text, wordLength, textOffset) {
        this.privAudioOffset = audioOffset;
        this.privText = text;
        this.privWordLength = wordLength;
        this.privTextOffset = textOffset;
    }
    Object.defineProperty(SpeechSynthesisWordBoundaryEventArgs.prototype, "audioOffset", {
        /**
         * Specifies the audio offset.
         * @member SpeechSynthesisWordBoundaryEventArgs.prototype.audioOffset
         * @function
         * @public
         * @returns {number} the audio offset.
         */ get: function() {
            return this.privAudioOffset;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SpeechSynthesisWordBoundaryEventArgs.prototype, "text", {
        /**
         * Specifies the text of the word boundary event.
         * @member SpeechSynthesisWordBoundaryEventArgs.prototype.text
         * @function
         * @public
         * @returns {string} the text.
         */ get: function() {
            return this.privText;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SpeechSynthesisWordBoundaryEventArgs.prototype, "wordLength", {
        /**
         * Specifies the word length
         * @member SpeechSynthesisWordBoundaryEventArgs.prototype.wordLength
         * @function
         * @public
         * @returns {number} the word length
         */ get: function() {
            return this.privWordLength;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SpeechSynthesisWordBoundaryEventArgs.prototype, "textOffset", {
        /**
         * Specifies the text offset.
         * @member SpeechSynthesisWordBoundaryEventArgs.prototype.textOffset
         * @function
         * @public
         * @returns {number} the text offset.
         */ get: function() {
            return this.privTextOffset;
        },
        enumerable: false,
        configurable: true
    });
    return SpeechSynthesisWordBoundaryEventArgs;
}();
module.exports.SpeechSynthesisWordBoundaryEventArgs = $72d1ff0921276bbb$var$SpeechSynthesisWordBoundaryEventArgs;

});

parcelRequire.register("2dwxT", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SpeechSynthesisBookmarkEventArgs = void 0;
/**
 * Defines contents of speech synthesis bookmark event.
 * @class SpeechSynthesisBookmarkEventArgs
 * Added in version 1.16.0
 */ var $19d60a9396334ed8$var$SpeechSynthesisBookmarkEventArgs = /** @class */ function() {
    /**
     * Creates and initializes an instance of this class.
     * @constructor
     * @param {number} audioOffset - The audio offset.
     * @param {string} text - The bookmark text.
     */ function SpeechSynthesisBookmarkEventArgs(audioOffset, text) {
        this.privAudioOffset = audioOffset;
        this.privText = text;
    }
    Object.defineProperty(SpeechSynthesisBookmarkEventArgs.prototype, "audioOffset", {
        /**
         * Specifies the audio offset.
         * @member SpeechSynthesisBookmarkEventArgs.prototype.audioOffset
         * @function
         * @public
         * @returns {number} the audio offset.
         */ get: function() {
            return this.privAudioOffset;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SpeechSynthesisBookmarkEventArgs.prototype, "text", {
        /**
         * Specifies the bookmark.
         * @member SpeechSynthesisBookmarkEventArgs.prototype.text
         * @function
         * @public
         * @returns {string} the bookmark text.
         */ get: function() {
            return this.privText;
        },
        enumerable: false,
        configurable: true
    });
    return SpeechSynthesisBookmarkEventArgs;
}();
module.exports.SpeechSynthesisBookmarkEventArgs = $19d60a9396334ed8$var$SpeechSynthesisBookmarkEventArgs;

});

parcelRequire.register("jlPPH", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SpeechSynthesisVisemeEventArgs = void 0;
/**
 * Defines contents of speech synthesis viseme event.
 * @class SpeechSynthesisVisemeEventArgs
 * Added in version 1.16.0
 */ var $e1682f66c33501ee$var$SpeechSynthesisVisemeEventArgs = /** @class */ function() {
    /**
     * Creates and initializes an instance of this class.
     * @constructor
     * @param {number} audioOffset - The audio offset.
     * @param {number} visemeId - The viseme ID.
     * @param {string} animation - The animation, could be in svg or other format.
     */ function SpeechSynthesisVisemeEventArgs(audioOffset, visemeId, animation) {
        this.privAudioOffset = audioOffset;
        this.privVisemeId = visemeId;
        this.privAnimation = animation;
    }
    Object.defineProperty(SpeechSynthesisVisemeEventArgs.prototype, "audioOffset", {
        /**
         * Specifies the audio offset.
         * @member SpeechSynthesisVisemeEventArgs.prototype.audioOffset
         * @function
         * @public
         * @returns {number} the audio offset.
         */ get: function() {
            return this.privAudioOffset;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SpeechSynthesisVisemeEventArgs.prototype, "visemeId", {
        /**
         * Specifies the viseme ID.
         * @member SpeechSynthesisVisemeEventArgs.prototype.visemeId
         * @function
         * @public
         * @returns {number} the viseme ID.
         */ get: function() {
            return this.privVisemeId;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SpeechSynthesisVisemeEventArgs.prototype, "animation", {
        /**
         * Specifies the animation.
         * @member SpeechSynthesisVisemeEventArgs.prototype.animation
         * @function
         * @public
         * @returns {string} the animation, could be in svg or other format.
         */ get: function() {
            return this.privAnimation;
        },
        enumerable: false,
        configurable: true
    });
    return SpeechSynthesisVisemeEventArgs;
}();
module.exports.SpeechSynthesisVisemeEventArgs = $e1682f66c33501ee$var$SpeechSynthesisVisemeEventArgs;

});

parcelRequire.register("kNmMK", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
var $f23a0ee7ac9bcd68$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $f23a0ee7ac9bcd68$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $f23a0ee7ac9bcd68$var$_a;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SpeakerAudioDestination = void 0;

var $9MAMI = parcelRequire("9MAMI");

var $7srwU = parcelRequire("7srwU");

var $epVjg = parcelRequire("epVjg");

var $7PHxc = parcelRequire("7PHxc");
var $f23a0ee7ac9bcd68$var$MediaDurationPlaceholderSeconds = 1800;
var $f23a0ee7ac9bcd68$var$AudioFormatToMimeType = ($f23a0ee7ac9bcd68$var$_a = {}, $f23a0ee7ac9bcd68$var$_a[$7PHxc.AudioFormatTag.PCM] = "audio/wav", $f23a0ee7ac9bcd68$var$_a[$7PHxc.AudioFormatTag.MuLaw] = "audio/x-wav", $f23a0ee7ac9bcd68$var$_a[$7PHxc.AudioFormatTag.MP3] = "audio/mpeg", $f23a0ee7ac9bcd68$var$_a[$7PHxc.AudioFormatTag.OGG_OPUS] = "audio/ogg", $f23a0ee7ac9bcd68$var$_a[$7PHxc.AudioFormatTag.WEBM_OPUS] = "audio/webm; codecs=opus", $f23a0ee7ac9bcd68$var$_a[$7PHxc.AudioFormatTag.ALaw] = "audio/x-wav", $f23a0ee7ac9bcd68$var$_a);
/**
 * Represents the speaker playback audio destination, which only works in browser.
 * Note: the SDK will try to use <a href="https://www.w3.org/TR/media-source/">Media Source Extensions</a> to play audio.
 * Mp3 format has better supports on Microsoft Edge, Chrome and Safari (desktop), so, it's better to specify mp3 format for playback.
 * @class SpeakerAudioDestination
 * Updated in version 1.17.0
 */ var $f23a0ee7ac9bcd68$var$SpeakerAudioDestination = /** @class */ function() {
    function SpeakerAudioDestination(audioDestinationId) {
        this.privPlaybackStarted = false;
        this.privAppendingToBuffer = false;
        this.privMediaSourceOpened = false;
        this.privBytesReceived = 0;
        this.privId = audioDestinationId ? audioDestinationId : $7srwU.createNoDashGuid();
        this.privIsPaused = false;
        this.privIsClosed = false;
    }
    SpeakerAudioDestination.prototype.id = function() {
        return this.privId;
    };
    SpeakerAudioDestination.prototype.write = function(buffer, cb, err) {
        if (this.privAudioBuffer !== undefined) {
            this.privAudioBuffer.push(buffer);
            this.updateSourceBuffer().then(function() {
                if (!!cb) cb();
            }, function(error) {
                if (!!err) err(error);
            });
        } else if (this.privAudioOutputStream !== undefined) {
            this.privAudioOutputStream.write(buffer);
            this.privBytesReceived += buffer.byteLength;
        }
    };
    SpeakerAudioDestination.prototype.close = function(cb, err) {
        var _this = this;
        this.privIsClosed = true;
        if (this.privSourceBuffer !== undefined) this.handleSourceBufferUpdateEnd().then(function() {
            if (!!cb) cb();
        }, function(error) {
            if (!!err) err(error);
        });
        else if (this.privAudioOutputStream !== undefined) {
            if ((this.privFormat.formatTag === $7PHxc.AudioFormatTag.PCM || this.privFormat.formatTag === $7PHxc.AudioFormatTag.MuLaw || this.privFormat.formatTag === $7PHxc.AudioFormatTag.ALaw) && this.privFormat.hasHeader === false) {
                // tslint:disable-next-line:no-console
                console.warn("Play back is not supported for raw PCM, mulaw or alaw format without header.");
                if (!!this.onAudioEnd) this.onAudioEnd(this);
            } else {
                var receivedAudio_1 = new ArrayBuffer(this.privBytesReceived);
                this.privAudioOutputStream.read(receivedAudio_1).then(function(_) {
                    receivedAudio_1 = $9MAMI.SynthesisAdapterBase.addHeader(receivedAudio_1, _this.privFormat);
                    var audioBlob = new Blob([
                        receivedAudio_1
                    ], {
                        type: $f23a0ee7ac9bcd68$var$AudioFormatToMimeType[_this.privFormat.formatTag]
                    });
                    _this.privAudio.src = window.URL.createObjectURL(audioBlob);
                    _this.notifyPlayback().then(function() {
                        if (!!cb) cb();
                    }, function(error) {
                        if (!!err) err(error);
                    });
                }, function(error) {
                    if (!!err) err(error);
                });
            }
        } else // unsupported format, call onAudioEnd directly.
        if (!!this.onAudioEnd) this.onAudioEnd(this);
    };
    Object.defineProperty(SpeakerAudioDestination.prototype, "format", {
        set: function(format) {
            var _this = this;
            if (typeof AudioContext !== "undefined" || typeof window.webkitAudioContext !== "undefined") {
                this.privFormat = format;
                var mimeType_1 = $f23a0ee7ac9bcd68$var$AudioFormatToMimeType[this.privFormat.formatTag];
                if (mimeType_1 === undefined) // tslint:disable-next-line:no-console
                console.warn("Unknown mimeType for format " + $7PHxc.AudioFormatTag[this.privFormat.formatTag] + "; playback is not supported.");
                else if (typeof MediaSource !== "undefined" && MediaSource.isTypeSupported(mimeType_1)) {
                    this.privAudio = new Audio();
                    this.privAudioBuffer = [];
                    this.privMediaSource = new MediaSource();
                    this.privAudio.src = URL.createObjectURL(this.privMediaSource);
                    this.privAudio.load();
                    this.privMediaSource.onsourceopen = function(event) {
                        _this.privMediaSourceOpened = true;
                        _this.privMediaSource.duration = $f23a0ee7ac9bcd68$var$MediaDurationPlaceholderSeconds;
                        _this.privSourceBuffer = _this.privMediaSource.addSourceBuffer(mimeType_1);
                        _this.privSourceBuffer.onupdate = function(_) {
                            _this.updateSourceBuffer().catch(function(reason) {
                                $7srwU.Events.instance.onEvent(new $7srwU.BackgroundEvent(reason));
                            });
                        };
                        _this.privSourceBuffer.onupdateend = function(_) {
                            _this.handleSourceBufferUpdateEnd().catch(function(reason) {
                                $7srwU.Events.instance.onEvent(new $7srwU.BackgroundEvent(reason));
                            });
                        };
                        _this.privSourceBuffer.onupdatestart = function(_) {
                            _this.privAppendingToBuffer = false;
                        };
                    };
                    this.updateSourceBuffer().catch(function(reason) {
                        $7srwU.Events.instance.onEvent(new $7srwU.BackgroundEvent(reason));
                    });
                } else {
                    // tslint:disable-next-line:no-console
                    console.warn("Format " + $7PHxc.AudioFormatTag[this.privFormat.formatTag] + " could not be played by MSE, streaming playback is not enabled.");
                    this.privAudioOutputStream = new $epVjg.PullAudioOutputStreamImpl();
                    this.privAudioOutputStream.format = this.privFormat;
                    this.privAudio = new Audio();
                }
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SpeakerAudioDestination.prototype, "isClosed", {
        get: function() {
            return this.privIsClosed;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SpeakerAudioDestination.prototype, "currentTime", {
        get: function() {
            if (this.privAudio !== undefined) return this.privAudio.currentTime;
            return -1;
        },
        enumerable: false,
        configurable: true
    });
    SpeakerAudioDestination.prototype.pause = function() {
        if (!this.privIsPaused && this.privAudio !== undefined) {
            this.privAudio.pause();
            this.privIsPaused = true;
        }
    };
    SpeakerAudioDestination.prototype.resume = function(cb, err) {
        if (this.privIsPaused && this.privAudio !== undefined) {
            this.privAudio.play().then(function() {
                if (!!cb) cb();
            }, function(error) {
                if (!!err) err(error);
            });
            this.privIsPaused = false;
        }
    };
    Object.defineProperty(SpeakerAudioDestination.prototype, "internalAudio", {
        get: function() {
            return this.privAudio;
        },
        enumerable: false,
        configurable: true
    });
    SpeakerAudioDestination.prototype.updateSourceBuffer = function() {
        return $f23a0ee7ac9bcd68$var$__awaiter(this, void 0, void 0, function() {
            var binary;
            return $f23a0ee7ac9bcd68$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!(this.privAudioBuffer !== undefined && this.privAudioBuffer.length > 0 && this.sourceBufferAvailable())) return [
                            3 /*break*/ ,
                            2
                        ];
                        this.privAppendingToBuffer = true;
                        binary = this.privAudioBuffer.shift();
                        try {
                            this.privSourceBuffer.appendBuffer(binary);
                        } catch (error) {
                            this.privAudioBuffer.unshift(binary);
                            // tslint:disable-next-line:no-console
                            console.log("buffer filled, pausing addition of binaries until space is made");
                            return [
                                2 /*return*/ 
                            ];
                        }
                        return [
                            4 /*yield*/ ,
                            this.notifyPlayback()
                        ];
                    case 1:
                        _a.sent();
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 2:
                        if (!this.canEndStream()) return [
                            3 /*break*/ ,
                            4
                        ];
                        return [
                            4 /*yield*/ ,
                            this.handleSourceBufferUpdateEnd()
                        ];
                    case 3:
                        _a.sent();
                        _a.label = 4;
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    SpeakerAudioDestination.prototype.handleSourceBufferUpdateEnd = function() {
        return $f23a0ee7ac9bcd68$var$__awaiter(this, void 0, void 0, function() {
            return $f23a0ee7ac9bcd68$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!(this.canEndStream() && this.sourceBufferAvailable())) return [
                            3 /*break*/ ,
                            2
                        ];
                        this.privMediaSource.endOfStream();
                        return [
                            4 /*yield*/ ,
                            this.notifyPlayback()
                        ];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    SpeakerAudioDestination.prototype.notifyPlayback = function() {
        return $f23a0ee7ac9bcd68$var$__awaiter(this, void 0, void 0, function() {
            var _this = this;
            return $f23a0ee7ac9bcd68$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!(!this.privPlaybackStarted && this.privAudio !== undefined)) return [
                            3 /*break*/ ,
                            2
                        ];
                        this.privPlaybackStarted = true;
                        if (!!this.onAudioStart) this.onAudioStart(this);
                        this.privAudio.onended = function() {
                            if (!!_this.onAudioEnd) _this.onAudioEnd(_this);
                        };
                        if (!!this.privIsPaused) return [
                            3 /*break*/ ,
                            2
                        ];
                        return [
                            4 /*yield*/ ,
                            this.privAudio.play()
                        ];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    SpeakerAudioDestination.prototype.canEndStream = function() {
        return this.isClosed && this.privSourceBuffer !== undefined && this.privAudioBuffer.length === 0 && this.privMediaSourceOpened && !this.privAppendingToBuffer && this.privMediaSource.readyState === "open";
    };
    SpeakerAudioDestination.prototype.sourceBufferAvailable = function() {
        return this.privSourceBuffer !== undefined && !this.privSourceBuffer.updating;
    };
    return SpeakerAudioDestination;
}();
module.exports.SpeakerAudioDestination = $f23a0ee7ac9bcd68$var$SpeakerAudioDestination;

});

parcelRequire.register("6bF60", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
var $4813a5eaf15985ab$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ConversationTranscriptionCanceledEventArgs = void 0;

var $dFtwT = parcelRequire("dFtwT");
/**
 * Defines content of a RecognitionErrorEvent.
 * @class ConversationTranscriptionCanceledEventArgs
 */ var $4813a5eaf15985ab$var$ConversationTranscriptionCanceledEventArgs = /** @class */ function(_super) {
    $4813a5eaf15985ab$var$__extends(ConversationTranscriptionCanceledEventArgs, _super);
    function ConversationTranscriptionCanceledEventArgs() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return ConversationTranscriptionCanceledEventArgs;
}($dFtwT.CancellationEventArgsBase);
module.exports.ConversationTranscriptionCanceledEventArgs = $4813a5eaf15985ab$var$ConversationTranscriptionCanceledEventArgs;

});

parcelRequire.register("akQdQ", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PronunciationAssessmentGradingSystem = void 0;
/**
 * Defines the point system for pronunciation score calibration; default value is FivePoint.
 * Added in version 1.15.0
 * @class PronunciationAssessmentGradingSystem
 */ var $786447e68ff0a87e$var$PronunciationAssessmentGradingSystem;
(function(PronunciationAssessmentGradingSystem) {
    /**
     * Five point calibration
     * @member PronunciationAssessmentGradingSystem.FivePoint
     */ PronunciationAssessmentGradingSystem[PronunciationAssessmentGradingSystem["FivePoint"] = 1] = "FivePoint";
    /**
     * Hundred mark
     * @member PronunciationAssessmentGradingSystem.HundredMark
     */ PronunciationAssessmentGradingSystem[PronunciationAssessmentGradingSystem["HundredMark"] = 2] = "HundredMark";
})($786447e68ff0a87e$var$PronunciationAssessmentGradingSystem = module.exports.PronunciationAssessmentGradingSystem || (module.exports.PronunciationAssessmentGradingSystem = {}));

});

parcelRequire.register("2ZPnp", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PronunciationAssessmentGranularity = void 0;
/**
 * Defines the pronunciation evaluation granularity; default value is Phoneme.
 * Added in version 1.15.0
 * @class PronunciationAssessmentGranularity
 */ var $22e921913d46748e$var$PronunciationAssessmentGranularity;
(function(PronunciationAssessmentGranularity) {
    /**
     * Shows the score on the full text, word and phoneme level
     * @member PronunciationAssessmentGranularity.Phoneme
     */ PronunciationAssessmentGranularity[PronunciationAssessmentGranularity["Phoneme"] = 1] = "Phoneme";
    /**
     * Shows the score on the full text and word level
     * @member PronunciationAssessmentGranularity.Word
     */ PronunciationAssessmentGranularity[PronunciationAssessmentGranularity["Word"] = 2] = "Word";
    /**
     * Shows the score on the full text level only
     * @member PronunciationAssessmentGranularity.FullText
     */ PronunciationAssessmentGranularity[PronunciationAssessmentGranularity["FullText"] = 3] = "FullText";
})($22e921913d46748e$var$PronunciationAssessmentGranularity = module.exports.PronunciationAssessmentGranularity || (module.exports.PronunciationAssessmentGranularity = {}));

});

parcelRequire.register("8zUca", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PronunciationAssessmentConfig = void 0;

var $evvAW = parcelRequire("evvAW");

var $iQDnw = parcelRequire("iQDnw");
/**
 * Pronunciation assessment configuration.
 * @class PronunciationAssessmentConfig
 * Added in version 1.15.0.
 */ var $63ed2ed3027ff4a5$var$PronunciationAssessmentConfig = /** @class */ function() {
    /**
     * PronunciationAssessmentConfig constructor.
     * @constructor
     * @param {string} referenceText
     * @param gradingSystem
     * @param granularity
     * @param enableMiscue
     */ function PronunciationAssessmentConfig(referenceText, gradingSystem, granularity, enableMiscue) {
        if (gradingSystem === void 0) gradingSystem = $iQDnw.PronunciationAssessmentGradingSystem.FivePoint;
        if (granularity === void 0) granularity = $iQDnw.PronunciationAssessmentGranularity.Phoneme;
        if (enableMiscue === void 0) enableMiscue = false;
        $evvAW.Contracts.throwIfNullOrUndefined(referenceText, "referenceText");
        this.privProperties = new $iQDnw.PropertyCollection();
        this.privProperties.setProperty($iQDnw.PropertyId.PronunciationAssessment_ReferenceText, referenceText);
        this.privProperties.setProperty($iQDnw.PropertyId.PronunciationAssessment_GradingSystem, $iQDnw.PronunciationAssessmentGradingSystem[gradingSystem]);
        this.privProperties.setProperty($iQDnw.PropertyId.PronunciationAssessment_Granularity, $iQDnw.PronunciationAssessmentGranularity[granularity]);
        this.privProperties.setProperty($iQDnw.PropertyId.PronunciationAssessment_EnableMiscue, String(enableMiscue));
    }
    /**
     * @member PronunciationAssessmentConfig.fromJSON
     * @function
     * @public
     * @param {string} json The json string containing the pronunciation assessment parameters.
     * @return {PronunciationAssessmentConfig} Instance of PronunciationAssessmentConfig
     * @summary Creates an instance of the PronunciationAssessmentConfig from json.
     */ PronunciationAssessmentConfig.fromJSON = function(json) {
        $evvAW.Contracts.throwIfNullOrUndefined(json, "json");
        var config = new PronunciationAssessmentConfig("");
        config.privProperties = new $iQDnw.PropertyCollection();
        config.properties.setProperty($iQDnw.PropertyId.PronunciationAssessment_Json, json);
        return config;
    };
    PronunciationAssessmentConfig.prototype.toJSON = function() {
        this.updateJson();
        return this.privProperties.getProperty($iQDnw.PropertyId.PronunciationAssessment_Params);
    };
    PronunciationAssessmentConfig.prototype.applyTo = function(recognizer) {
        this.updateJson();
        var recoBase = recognizer.internalData;
        recoBase.speechContext.setPronunciationAssessmentParams(this.properties.getProperty($iQDnw.PropertyId.PronunciationAssessment_Params));
    };
    Object.defineProperty(PronunciationAssessmentConfig.prototype, "referenceText", {
        /**
         * Gets the reference text.
         * @member PronunciationAssessmentConfig.prototype.referenceText
         * @function
         * @public
         * @returns {string} Reference text.
         */ get: function() {
            return this.properties.getProperty($iQDnw.PropertyId.PronunciationAssessment_ReferenceText);
        },
        /**
         * Gets/Sets the reference text.
         * @member PronunciationAssessmentConfig.prototype.referenceText
         * @function
         * @public
         * @param {string} referenceText - Reference text.
         */ set: function(referenceText) {
            $evvAW.Contracts.throwIfNullOrWhitespace(referenceText, "referenceText");
            this.properties.setProperty($iQDnw.PropertyId.PronunciationAssessment_ReferenceText, referenceText);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PronunciationAssessmentConfig.prototype, "properties", {
        /**
         * @member PronunciationAssessmentConfig.prototype.properties
         * @function
         * @public
         * @return {PropertyCollection} Properties of the config.
         * @summary Gets a pronunciation assessment config properties
         */ get: function() {
            return this.privProperties;
        },
        enumerable: false,
        configurable: true
    });
    PronunciationAssessmentConfig.prototype.updateJson = function() {
        var jsonString = this.privProperties.getProperty($iQDnw.PropertyId.PronunciationAssessment_Json, "{}");
        var paramsJson = JSON.parse(jsonString);
        var referenceText = this.privProperties.getProperty($iQDnw.PropertyId.PronunciationAssessment_ReferenceText);
        if (referenceText) paramsJson.referenceText = referenceText;
        var gradingSystem = this.privProperties.getProperty($iQDnw.PropertyId.PronunciationAssessment_GradingSystem);
        if (gradingSystem) paramsJson.gradingSystem = gradingSystem;
        var granularity = this.privProperties.getProperty($iQDnw.PropertyId.PronunciationAssessment_Granularity);
        if (granularity) paramsJson.granularity = granularity;
        // always set dimension to Comprehensive
        paramsJson.dimension = "Comprehensive";
        var enableMiscueString = this.privProperties.getProperty($iQDnw.PropertyId.PronunciationAssessment_EnableMiscue);
        if (enableMiscueString === "true") paramsJson.enableMiscue = true;
        else if (enableMiscueString === "false") paramsJson.enableMiscue = false;
        this.privProperties.setProperty($iQDnw.PropertyId.PronunciationAssessment_Params, JSON.stringify(paramsJson));
    };
    return PronunciationAssessmentConfig;
}();
module.exports.PronunciationAssessmentConfig = $63ed2ed3027ff4a5$var$PronunciationAssessmentConfig;

});

parcelRequire.register("gxTum", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PronunciationAssessmentResult = void 0;

var $evvAW = parcelRequire("evvAW");

var $iQDnw = parcelRequire("iQDnw");
/**
 * Pronunciation assessment results.
 * @class PronunciationAssessmentResult
 * Added in version 1.15.0.
 */ var $c0bac54d8cc1464a$var$PronunciationAssessmentResult = /** @class */ function() {
    function PronunciationAssessmentResult(jsonString) {
        var j = JSON.parse(jsonString);
        $evvAW.Contracts.throwIfNullOrUndefined(j.NBest[0], "NBest");
        this.privPronJson = j.NBest[0];
    }
    /**
     * @member PronunciationAssessmentResult.fromResult
     * @function
     * @public
     * @param {RecognitionResult} result The recognition result.
     * @return {PronunciationAssessmentConfig} Instance of PronunciationAssessmentConfig
     * @summary Creates an instance of the PronunciationAssessmentResult from recognition result.
     */ PronunciationAssessmentResult.fromResult = function(result) {
        $evvAW.Contracts.throwIfNullOrUndefined(result, "result");
        var json = result.properties.getProperty($iQDnw.PropertyId.SpeechServiceResponse_JsonResult);
        $evvAW.Contracts.throwIfNullOrUndefined(json, "json");
        return new PronunciationAssessmentResult(json);
    };
    Object.defineProperty(PronunciationAssessmentResult.prototype, "detailResult", {
        /**
         * Gets the detail result of pronunciation assessment.
         * @member PronunciationAssessmentConfig.prototype.detailResult
         * @function
         * @public
         * @returns {any} detail result.
         */ get: function() {
            return this.privPronJson;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PronunciationAssessmentResult.prototype, "accuracyScore", {
        /**
         * The score indicating the pronunciation accuracy of the given speech, which indicates
         * how closely the phonemes match a native speaker's pronunciation.
         * @member PronunciationAssessmentResult.prototype.accuracyScore
         * @function
         * @public
         * @returns {number} Accuracy score.
         */ get: function() {
            return this.detailResult.PronunciationAssessment.AccuracyScore;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PronunciationAssessmentResult.prototype, "pronunciationScore", {
        /**
         * The overall score indicating the pronunciation quality of the given speech.
         * This is calculated from AccuracyScore, FluencyScore and CompletenessScore with weight.
         * @member PronunciationAssessmentResult.prototype.pronunciationScore
         * @function
         * @public
         * @returns {number} Pronunciation score.
         */ get: function() {
            return this.detailResult.PronunciationAssessment.PronScore;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PronunciationAssessmentResult.prototype, "completenessScore", {
        /**
         * The score indicating the completeness of the given speech by calculating the ratio of pronounced words towards entire input.
         * @member PronunciationAssessmentResult.prototype.completenessScore
         * @function
         * @public
         * @returns {number} Completeness score.
         */ get: function() {
            return this.detailResult.PronunciationAssessment.CompletenessScore;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PronunciationAssessmentResult.prototype, "fluencyScore", {
        /**
         * The score indicating the fluency of the given speech.
         * @member PronunciationAssessmentResult.prototype.fluencyScore
         * @function
         * @public
         * @returns {number} Fluency score.
         */ get: function() {
            return this.detailResult.PronunciationAssessment.FluencyScore;
        },
        enumerable: false,
        configurable: true
    });
    return PronunciationAssessmentResult;
}();
module.exports.PronunciationAssessmentResult = $c0bac54d8cc1464a$var$PronunciationAssessmentResult;

});



parcelRequire.register("kzoIC", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
var $ef9a40206ac25a64$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RecognitionEndedEvent = module.exports.RecognitionCompletionStatus = module.exports.RecognitionStartedEvent = module.exports.ConnectingToServiceEvent = module.exports.ListeningStartedEvent = module.exports.RecognitionTriggeredEvent = module.exports.SpeechRecognitionEvent = void 0;

var $7srwU = parcelRequire("7srwU");
var $ef9a40206ac25a64$var$SpeechRecognitionEvent = /** @class */ function(_super) {
    $ef9a40206ac25a64$var$__extends(SpeechRecognitionEvent, _super);
    function SpeechRecognitionEvent(eventName, requestId, sessionId, eventType) {
        if (eventType === void 0) eventType = $7srwU.EventType.Info;
        var _this = _super.call(this, eventName, eventType) || this;
        _this.privRequestId = requestId;
        _this.privSessionId = sessionId;
        return _this;
    }
    Object.defineProperty(SpeechRecognitionEvent.prototype, "requestId", {
        get: function() {
            return this.privRequestId;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SpeechRecognitionEvent.prototype, "sessionId", {
        get: function() {
            return this.privSessionId;
        },
        enumerable: false,
        configurable: true
    });
    return SpeechRecognitionEvent;
}($7srwU.PlatformEvent);
module.exports.SpeechRecognitionEvent = $ef9a40206ac25a64$var$SpeechRecognitionEvent;
var $ef9a40206ac25a64$var$RecognitionTriggeredEvent = /** @class */ function(_super) {
    $ef9a40206ac25a64$var$__extends(RecognitionTriggeredEvent, _super);
    function RecognitionTriggeredEvent(requestId, sessionId, audioSourceId, audioNodeId) {
        var _this = _super.call(this, "RecognitionTriggeredEvent", requestId, sessionId) || this;
        _this.privAudioSourceId = audioSourceId;
        _this.privAudioNodeId = audioNodeId;
        return _this;
    }
    Object.defineProperty(RecognitionTriggeredEvent.prototype, "audioSourceId", {
        get: function() {
            return this.privAudioSourceId;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(RecognitionTriggeredEvent.prototype, "audioNodeId", {
        get: function() {
            return this.privAudioNodeId;
        },
        enumerable: false,
        configurable: true
    });
    return RecognitionTriggeredEvent;
}($ef9a40206ac25a64$var$SpeechRecognitionEvent);
module.exports.RecognitionTriggeredEvent = $ef9a40206ac25a64$var$RecognitionTriggeredEvent;
var $ef9a40206ac25a64$var$ListeningStartedEvent = /** @class */ function(_super) {
    $ef9a40206ac25a64$var$__extends(ListeningStartedEvent, _super);
    function ListeningStartedEvent(requestId, sessionId, audioSourceId, audioNodeId) {
        var _this = _super.call(this, "ListeningStartedEvent", requestId, sessionId) || this;
        _this.privAudioSourceId = audioSourceId;
        _this.privAudioNodeId = audioNodeId;
        return _this;
    }
    Object.defineProperty(ListeningStartedEvent.prototype, "audioSourceId", {
        get: function() {
            return this.privAudioSourceId;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ListeningStartedEvent.prototype, "audioNodeId", {
        get: function() {
            return this.privAudioNodeId;
        },
        enumerable: false,
        configurable: true
    });
    return ListeningStartedEvent;
}($ef9a40206ac25a64$var$SpeechRecognitionEvent);
module.exports.ListeningStartedEvent = $ef9a40206ac25a64$var$ListeningStartedEvent;
var $ef9a40206ac25a64$var$ConnectingToServiceEvent = /** @class */ function(_super) {
    $ef9a40206ac25a64$var$__extends(ConnectingToServiceEvent, _super);
    function ConnectingToServiceEvent(requestId, authFetchEventid, sessionId) {
        var _this = _super.call(this, "ConnectingToServiceEvent", requestId, sessionId) || this;
        _this.privAuthFetchEventid = authFetchEventid;
        return _this;
    }
    Object.defineProperty(ConnectingToServiceEvent.prototype, "authFetchEventid", {
        get: function() {
            return this.privAuthFetchEventid;
        },
        enumerable: false,
        configurable: true
    });
    return ConnectingToServiceEvent;
}($ef9a40206ac25a64$var$SpeechRecognitionEvent);
module.exports.ConnectingToServiceEvent = $ef9a40206ac25a64$var$ConnectingToServiceEvent;
var $ef9a40206ac25a64$var$RecognitionStartedEvent = /** @class */ function(_super) {
    $ef9a40206ac25a64$var$__extends(RecognitionStartedEvent, _super);
    function RecognitionStartedEvent(requestId, audioSourceId, audioNodeId, authFetchEventId, sessionId) {
        var _this = _super.call(this, "RecognitionStartedEvent", requestId, sessionId) || this;
        _this.privAudioSourceId = audioSourceId;
        _this.privAudioNodeId = audioNodeId;
        _this.privAuthFetchEventId = authFetchEventId;
        return _this;
    }
    Object.defineProperty(RecognitionStartedEvent.prototype, "audioSourceId", {
        get: function() {
            return this.privAudioSourceId;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(RecognitionStartedEvent.prototype, "audioNodeId", {
        get: function() {
            return this.privAudioNodeId;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(RecognitionStartedEvent.prototype, "authFetchEventId", {
        get: function() {
            return this.privAuthFetchEventId;
        },
        enumerable: false,
        configurable: true
    });
    return RecognitionStartedEvent;
}($ef9a40206ac25a64$var$SpeechRecognitionEvent);
module.exports.RecognitionStartedEvent = $ef9a40206ac25a64$var$RecognitionStartedEvent;
var $ef9a40206ac25a64$var$RecognitionCompletionStatus;
(function(RecognitionCompletionStatus) {
    RecognitionCompletionStatus[RecognitionCompletionStatus["Success"] = 0] = "Success";
    RecognitionCompletionStatus[RecognitionCompletionStatus["AudioSourceError"] = 1] = "AudioSourceError";
    RecognitionCompletionStatus[RecognitionCompletionStatus["AudioSourceTimeout"] = 2] = "AudioSourceTimeout";
    RecognitionCompletionStatus[RecognitionCompletionStatus["AuthTokenFetchError"] = 3] = "AuthTokenFetchError";
    RecognitionCompletionStatus[RecognitionCompletionStatus["AuthTokenFetchTimeout"] = 4] = "AuthTokenFetchTimeout";
    RecognitionCompletionStatus[RecognitionCompletionStatus["UnAuthorized"] = 5] = "UnAuthorized";
    RecognitionCompletionStatus[RecognitionCompletionStatus["ConnectTimeout"] = 6] = "ConnectTimeout";
    RecognitionCompletionStatus[RecognitionCompletionStatus["ConnectError"] = 7] = "ConnectError";
    RecognitionCompletionStatus[RecognitionCompletionStatus["ClientRecognitionActivityTimeout"] = 8] = "ClientRecognitionActivityTimeout";
    RecognitionCompletionStatus[RecognitionCompletionStatus["UnknownError"] = 9] = "UnknownError";
})($ef9a40206ac25a64$var$RecognitionCompletionStatus = module.exports.RecognitionCompletionStatus || (module.exports.RecognitionCompletionStatus = {}));
var $ef9a40206ac25a64$var$RecognitionEndedEvent = /** @class */ function(_super) {
    $ef9a40206ac25a64$var$__extends(RecognitionEndedEvent, _super);
    function RecognitionEndedEvent(requestId, audioSourceId, audioNodeId, authFetchEventId, sessionId, serviceTag, status, error) {
        var _this = _super.call(this, "RecognitionEndedEvent", requestId, sessionId, status === $ef9a40206ac25a64$var$RecognitionCompletionStatus.Success ? $7srwU.EventType.Info : $7srwU.EventType.Error) || this;
        _this.privAudioSourceId = audioSourceId;
        _this.privAudioNodeId = audioNodeId;
        _this.privAuthFetchEventId = authFetchEventId;
        _this.privStatus = status;
        _this.privError = error;
        _this.privServiceTag = serviceTag;
        return _this;
    }
    Object.defineProperty(RecognitionEndedEvent.prototype, "audioSourceId", {
        get: function() {
            return this.privAudioSourceId;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(RecognitionEndedEvent.prototype, "audioNodeId", {
        get: function() {
            return this.privAudioNodeId;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(RecognitionEndedEvent.prototype, "authFetchEventId", {
        get: function() {
            return this.privAuthFetchEventId;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(RecognitionEndedEvent.prototype, "serviceTag", {
        get: function() {
            return this.privServiceTag;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(RecognitionEndedEvent.prototype, "status", {
        get: function() {
            return this.privStatus;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(RecognitionEndedEvent.prototype, "error", {
        get: function() {
            return this.privError;
        },
        enumerable: false,
        configurable: true
    });
    return RecognitionEndedEvent;
}($ef9a40206ac25a64$var$SpeechRecognitionEvent);
module.exports.RecognitionEndedEvent = $ef9a40206ac25a64$var$RecognitionEndedEvent;

});

parcelRequire.register("dYRUq", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
var $a2dab232aaee975b$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $a2dab232aaee975b$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ServiceRecognizerBase = void 0;

var $9h4kO = parcelRequire("9h4kO");

var $7srwU = parcelRequire("7srwU");

var $iQDnw = parcelRequire("iQDnw");

var $9MAMI = parcelRequire("9MAMI");

var $eqPE4 = parcelRequire("eqPE4");
var $a2dab232aaee975b$var$ServiceRecognizerBase = /** @class */ function() {
    function ServiceRecognizerBase(authentication, connectionFactory, audioSource, recognizerConfig, recognizer) {
        var _this = this;
        this.privSetTimeout = setTimeout;
        this.privIsLiveAudio = false;
        this.recognizeOverride = undefined;
        this.disconnectOverride = undefined;
        this.receiveMessageOverride = undefined;
        this.sendSpeechContext = function(connection) {
            var speechContextJson = _this.speechContext.toJSON();
            if (speechContextJson) return connection.send(new $eqPE4.SpeechConnectionMessage($7srwU.MessageType.Text, "speech.context", _this.privRequestSession.requestId, "application/json", speechContextJson));
            return;
        };
        this.sendPrePayloadJSONOverride = undefined;
        this.postConnectImplOverride = undefined;
        this.configConnectionOverride = undefined;
        this.sendSpeechServiceConfig = function(connection, requestSession, SpeechServiceConfigJson) {
            // filter out anything that is not required for the service to work.
            if (ServiceRecognizerBase.telemetryDataEnabled !== true) {
                var withTelemetry = JSON.parse(SpeechServiceConfigJson);
                var replacement = {
                    context: {
                        system: withTelemetry.context.system
                    }
                };
                SpeechServiceConfigJson = JSON.stringify(replacement);
            }
            if (_this.privRecognizerConfig.parameters.getProperty("TranscriptionService_SingleChannel", "false").toLowerCase() === "true") {
                var json = JSON.parse(SpeechServiceConfigJson);
                json.context.DisableReferenceChannel = "True";
                json.context.MicSpec = "1_0_0";
                SpeechServiceConfigJson = JSON.stringify(json);
            }
            if (SpeechServiceConfigJson) return connection.send(new $eqPE4.SpeechConnectionMessage($7srwU.MessageType.Text, "speech.config", requestSession.requestId, "application/json", SpeechServiceConfigJson));
            return;
        };
        if (!authentication) throw new $7srwU.ArgumentNullError("authentication");
        if (!connectionFactory) throw new $7srwU.ArgumentNullError("connectionFactory");
        if (!audioSource) throw new $7srwU.ArgumentNullError("audioSource");
        if (!recognizerConfig) throw new $7srwU.ArgumentNullError("recognizerConfig");
        this.privMustReportEndOfStream = false;
        this.privAuthentication = authentication;
        this.privConnectionFactory = connectionFactory;
        this.privAudioSource = audioSource;
        this.privRecognizerConfig = recognizerConfig;
        this.privIsDisposed = false;
        this.privRecognizer = recognizer;
        this.privRequestSession = new $9MAMI.RequestSession(this.privAudioSource.id());
        this.privConnectionEvents = new $7srwU.EventSource();
        this.privServiceEvents = new $7srwU.EventSource();
        this.privDynamicGrammar = new $9MAMI.DynamicGrammarBuilder();
        this.privSpeechContext = new $9MAMI.SpeechContext(this.privDynamicGrammar);
        this.privAgentConfig = new $9MAMI.AgentConfig();
        if (typeof Blob !== "undefined" && typeof Worker !== "undefined") this.privSetTimeout = $7srwU.Timeout.setTimeout;
        this.connectionEvents.attach(function(connectionEvent) {
            return $a2dab232aaee975b$var$__awaiter(_this, void 0, void 0, function() {
                var connectionClosedEvent;
                return $a2dab232aaee975b$var$__generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            if (!(connectionEvent.name === "ConnectionClosedEvent")) return [
                                3 /*break*/ ,
                                2
                            ];
                            connectionClosedEvent = connectionEvent;
                            if (!(connectionClosedEvent.statusCode === 1003 || connectionClosedEvent.statusCode === 1007 || connectionClosedEvent.statusCode === 1002 || connectionClosedEvent.statusCode === 4000 || this.privRequestSession.numConnectionAttempts > this.privRecognizerConfig.maxRetryCount)) return [
                                3 /*break*/ ,
                                2
                            ];
                            return [
                                4 /*yield*/ ,
                                this.cancelRecognitionLocal($iQDnw.CancellationReason.Error, connectionClosedEvent.statusCode === 1007 ? $iQDnw.CancellationErrorCode.BadRequestParameters : $iQDnw.CancellationErrorCode.ConnectionFailure, connectionClosedEvent.reason + " websocket error code: " + connectionClosedEvent.statusCode)
                            ];
                        case 1:
                            _a.sent();
                            _a.label = 2;
                        case 2:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        });
    }
    Object.defineProperty(ServiceRecognizerBase.prototype, "audioSource", {
        get: function() {
            return this.privAudioSource;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ServiceRecognizerBase.prototype, "speechContext", {
        get: function() {
            return this.privSpeechContext;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ServiceRecognizerBase.prototype, "dynamicGrammar", {
        get: function() {
            return this.privDynamicGrammar;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ServiceRecognizerBase.prototype, "agentConfig", {
        get: function() {
            return this.privAgentConfig;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ServiceRecognizerBase.prototype, "conversationTranslatorToken", {
        set: function(token) {
            this.privRecognizerConfig.parameters.setProperty($iQDnw.PropertyId.ConversationTranslator_Token, token);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ServiceRecognizerBase.prototype, "authentication", {
        set: function(auth) {
            this.privAuthentication = this.authentication;
        },
        enumerable: false,
        configurable: true
    });
    ServiceRecognizerBase.prototype.isDisposed = function() {
        return this.privIsDisposed;
    };
    ServiceRecognizerBase.prototype.dispose = function(reason) {
        return $a2dab232aaee975b$var$__awaiter(this, void 0, void 0, function() {
            var connection, error_1;
            return $a2dab232aaee975b$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        this.privIsDisposed = true;
                        if (!this.privConnectionConfigurationPromise) return [
                            3 /*break*/ ,
                            5
                        ];
                        _a.label = 1;
                    case 1:
                        _a.trys.push([
                            1,
                            4,
                            ,
                            5
                        ]);
                        return [
                            4 /*yield*/ ,
                            this.privConnectionConfigurationPromise
                        ];
                    case 2:
                        connection = _a.sent();
                        return [
                            4 /*yield*/ ,
                            connection.dispose(reason)
                        ];
                    case 3:
                        _a.sent();
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 4:
                        error_1 = _a.sent();
                        // The connection is in a bad state. But we're trying to kill it, so...
                        return [
                            2 /*return*/ 
                        ];
                    case 5:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    Object.defineProperty(ServiceRecognizerBase.prototype, "connectionEvents", {
        get: function() {
            return this.privConnectionEvents;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ServiceRecognizerBase.prototype, "serviceEvents", {
        get: function() {
            return this.privServiceEvents;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ServiceRecognizerBase.prototype, "recognitionMode", {
        get: function() {
            return this.privRecognizerConfig.recognitionMode;
        },
        enumerable: false,
        configurable: true
    });
    ServiceRecognizerBase.prototype.recognize = function(recoMode, successCallback, errorCallBack) {
        return $a2dab232aaee975b$var$__awaiter(this, void 0, void 0, function() {
            var conPromise, audioNode, audioStreamNode, format, deviceInfo, error_2, error_3, sessionStartEventArgs, messageRetrievalPromise, audioSendPromise;
            var _this = this;
            return $a2dab232aaee975b$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (this.recognizeOverride !== undefined) return [
                            2 /*return*/ ,
                            this.recognizeOverride(recoMode, successCallback, errorCallBack)
                        ];
                        // Clear the existing configuration promise to force a re-transmission of config and context.
                        this.privConnectionConfigurationPromise = null;
                        this.privRecognizerConfig.recognitionMode = recoMode;
                        this.privSuccessCallback = successCallback;
                        this.privErrorCallback = errorCallBack;
                        this.privRequestSession.startNewRecognition();
                        this.privRequestSession.listenForServiceTelemetry(this.privAudioSource.events);
                        conPromise = this.connectImpl();
                        _a.label = 1;
                    case 1:
                        _a.trys.push([
                            1,
                            6,
                            ,
                            8
                        ]);
                        return [
                            4 /*yield*/ ,
                            this.audioSource.attach(this.privRequestSession.audioNodeId)
                        ];
                    case 2:
                        audioStreamNode = _a.sent();
                        return [
                            4 /*yield*/ ,
                            this.audioSource.format
                        ];
                    case 3:
                        format = _a.sent();
                        return [
                            4 /*yield*/ ,
                            this.audioSource.deviceInfo
                        ];
                    case 4:
                        deviceInfo = _a.sent();
                        this.privIsLiveAudio = deviceInfo.type && deviceInfo.type === $9MAMI.type.Microphones;
                        audioNode = new $9h4kO.ReplayableAudioNode(audioStreamNode, format.avgBytesPerSec);
                        return [
                            4 /*yield*/ ,
                            this.privRequestSession.onAudioSourceAttachCompleted(audioNode, false)
                        ];
                    case 5:
                        _a.sent();
                        this.privRecognizerConfig.SpeechServiceConfig.Context.audio = {
                            source: deviceInfo
                        };
                        return [
                            3 /*break*/ ,
                            8
                        ];
                    case 6:
                        error_2 = _a.sent();
                        return [
                            4 /*yield*/ ,
                            this.privRequestSession.onStopRecognizing()
                        ];
                    case 7:
                        _a.sent();
                        throw error_2;
                    case 8:
                        _a.trys.push([
                            8,
                            10,
                            ,
                            12
                        ]);
                        return [
                            4 /*yield*/ ,
                            conPromise
                        ];
                    case 9:
                        _a.sent();
                        return [
                            3 /*break*/ ,
                            12
                        ];
                    case 10:
                        error_3 = _a.sent();
                        return [
                            4 /*yield*/ ,
                            this.cancelRecognitionLocal($iQDnw.CancellationReason.Error, $iQDnw.CancellationErrorCode.ConnectionFailure, error_3)
                        ];
                    case 11:
                        _a.sent();
                        return [
                            2 /*return*/ 
                        ];
                    case 12:
                        sessionStartEventArgs = new $iQDnw.SessionEventArgs(this.privRequestSession.sessionId);
                        if (!!this.privRecognizer.sessionStarted) this.privRecognizer.sessionStarted(this.privRecognizer, sessionStartEventArgs);
                        messageRetrievalPromise = this.receiveMessage();
                        audioSendPromise = this.sendAudio(audioNode);
                        audioSendPromise.catch(function(error) {
                            return $a2dab232aaee975b$var$__awaiter(_this, void 0, void 0, function() {
                                return $a2dab232aaee975b$var$__generator(this, function(_a) {
                                    switch(_a.label){
                                        case 0:
                                            return [
                                                4 /*yield*/ ,
                                                this.cancelRecognitionLocal($iQDnw.CancellationReason.Error, $iQDnw.CancellationErrorCode.RuntimeError, error)
                                            ];
                                        case 1:
                                            _a.sent();
                                            return [
                                                2 /*return*/ 
                                            ];
                                    }
                                });
                            });
                        });
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    ServiceRecognizerBase.prototype.stopRecognizing = function() {
        return $a2dab232aaee975b$var$__awaiter(this, void 0, void 0, function() {
            return $a2dab232aaee975b$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!this.privRequestSession.isRecognizing) return [
                            3 /*break*/ ,
                            8
                        ];
                        _a.label = 1;
                    case 1:
                        _a.trys.push([
                            1,
                            ,
                            6,
                            8
                        ]);
                        return [
                            4 /*yield*/ ,
                            this.audioSource.turnOff()
                        ];
                    case 2:
                        _a.sent();
                        return [
                            4 /*yield*/ ,
                            this.sendFinalAudio()
                        ];
                    case 3:
                        _a.sent();
                        return [
                            4 /*yield*/ ,
                            this.privRequestSession.onStopRecognizing()
                        ];
                    case 4:
                        _a.sent();
                        return [
                            4 /*yield*/ ,
                            this.privRequestSession.turnCompletionPromise
                        ];
                    case 5:
                        _a.sent();
                        return [
                            3 /*break*/ ,
                            8
                        ];
                    case 6:
                        return [
                            4 /*yield*/ ,
                            this.privRequestSession.dispose()
                        ];
                    case 7:
                        _a.sent();
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 8:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    ServiceRecognizerBase.prototype.connect = function() {
        return $a2dab232aaee975b$var$__awaiter(this, void 0, void 0, function() {
            return $a2dab232aaee975b$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.connectImpl()
                        ];
                    case 1:
                        _a.sent();
                        return [
                            2 /*return*/ ,
                            Promise.resolve()
                        ];
                }
            });
        });
    };
    ServiceRecognizerBase.prototype.connectAsync = function(cb, err) {
        this.connectImpl().then(function(connection) {
            try {
                if (!!cb) cb();
            } catch (e) {
                if (!!err) err(e);
            }
        }, function(reason) {
            try {
                if (!!err) err(reason);
            /* tslint:disable:no-empty */ } catch (error) {}
        });
    };
    ServiceRecognizerBase.prototype.disconnect = function() {
        return $a2dab232aaee975b$var$__awaiter(this, void 0, void 0, function() {
            var error_4;
            return $a2dab232aaee975b$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.cancelRecognitionLocal($iQDnw.CancellationReason.Error, $iQDnw.CancellationErrorCode.NoError, "Disconnecting")
                        ];
                    case 1:
                        _a.sent();
                        if (!(this.disconnectOverride !== undefined)) return [
                            3 /*break*/ ,
                            3
                        ];
                        return [
                            4 /*yield*/ ,
                            this.disconnectOverride()
                        ];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3:
                        _a.trys.push([
                            3,
                            6,
                            ,
                            7
                        ]);
                        return [
                            4 /*yield*/ ,
                            this.privConnectionPromise
                        ];
                    case 4:
                        return [
                            4 /*yield*/ ,
                            _a.sent().dispose()
                        ];
                    case 5:
                        _a.sent();
                        return [
                            3 /*break*/ ,
                            7
                        ];
                    case 6:
                        error_4 = _a.sent();
                        return [
                            3 /*break*/ ,
                            7
                        ];
                    case 7:
                        this.privConnectionPromise = null;
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    ServiceRecognizerBase.prototype.sendMessage = function(message) {};
    ServiceRecognizerBase.prototype.sendNetworkMessage = function(path, payload) {
        return $a2dab232aaee975b$var$__awaiter(this, void 0, void 0, function() {
            var type, contentType, connection;
            return $a2dab232aaee975b$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        type = typeof payload === "string" ? $7srwU.MessageType.Text : $7srwU.MessageType.Binary;
                        contentType = typeof payload === "string" ? "application/json" : "";
                        return [
                            4 /*yield*/ ,
                            this.fetchConnection()
                        ];
                    case 1:
                        connection = _a.sent();
                        return [
                            2 /*return*/ ,
                            connection.send(new $eqPE4.SpeechConnectionMessage(type, path, this.privRequestSession.requestId, contentType, payload))
                        ];
                }
            });
        });
    };
    Object.defineProperty(ServiceRecognizerBase.prototype, "activityTemplate", {
        get: function() {
            return this.privActivityTemplate;
        },
        set: function(messagePayload) {
            this.privActivityTemplate = messagePayload;
        },
        enumerable: false,
        configurable: true
    });
    ServiceRecognizerBase.prototype.sendTelemetryData = function() {
        return $a2dab232aaee975b$var$__awaiter(this, void 0, void 0, function() {
            var telemetryData, connection;
            return $a2dab232aaee975b$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        telemetryData = this.privRequestSession.getTelemetry();
                        if (ServiceRecognizerBase.telemetryDataEnabled !== true || this.privIsDisposed || null === telemetryData) return [
                            2 /*return*/ 
                        ];
                        if (!!ServiceRecognizerBase.telemetryData) try {
                            ServiceRecognizerBase.telemetryData(telemetryData);
                        /* tslint:disable:no-empty */ } catch (_b) {}
                        return [
                            4 /*yield*/ ,
                            this.fetchConnection()
                        ];
                    case 1:
                        connection = _a.sent();
                        return [
                            4 /*yield*/ ,
                            connection.send(new $eqPE4.SpeechConnectionMessage($7srwU.MessageType.Text, "telemetry", this.privRequestSession.requestId, "application/json", telemetryData))
                        ];
                    case 2:
                        _a.sent();
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    // Cancels recognition.
    ServiceRecognizerBase.prototype.cancelRecognitionLocal = function(cancellationReason, errorCode, error) {
        return $a2dab232aaee975b$var$__awaiter(this, void 0, void 0, function() {
            return $a2dab232aaee975b$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!!!this.privRequestSession.isRecognizing) return [
                            3 /*break*/ ,
                            2
                        ];
                        return [
                            4 /*yield*/ ,
                            this.privRequestSession.onStopRecognizing()
                        ];
                    case 1:
                        _a.sent();
                        this.cancelRecognition(this.privRequestSession.sessionId, this.privRequestSession.requestId, cancellationReason, errorCode, error);
                        _a.label = 2;
                    case 2:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    ServiceRecognizerBase.prototype.receiveMessage = function() {
        return $a2dab232aaee975b$var$__awaiter(this, void 0, void 0, function() {
            var connection, message, connectionMessage, _a, speechStartDetected, speechStartEventArgs, json, speechStopDetected, speechStopEventArgs, sessionStopEventArgs, error_5;
            return $a2dab232aaee975b$var$__generator(this, function(_b) {
                switch(_b.label){
                    case 0:
                        _b.trys.push([
                            0,
                            18,
                            ,
                            19
                        ]);
                        if (this.privIsDisposed) // We're done.
                        return [
                            2 /*return*/ 
                        ];
                        return [
                            4 /*yield*/ ,
                            this.fetchConnection()
                        ];
                    case 1:
                        connection = _b.sent();
                        return [
                            4 /*yield*/ ,
                            connection.read()
                        ];
                    case 2:
                        message = _b.sent();
                        if (this.receiveMessageOverride !== undefined) return [
                            2 /*return*/ ,
                            this.receiveMessageOverride()
                        ];
                        // indicates we are draining the queue and it came with no message;
                        if (!message) {
                            if (!this.privRequestSession.isRecognizing) return [
                                2 /*return*/ 
                            ];
                            else return [
                                2 /*return*/ ,
                                this.receiveMessage()
                            ];
                        }
                        this.privServiceHasSentMessage = true;
                        connectionMessage = $eqPE4.SpeechConnectionMessage.fromConnectionMessage(message);
                        if (!(connectionMessage.requestId.toLowerCase() === this.privRequestSession.requestId.toLowerCase())) return [
                            3 /*break*/ ,
                            17
                        ];
                        _a = connectionMessage.path.toLowerCase();
                        switch(_a){
                            case "turn.start":
                                return [
                                    3 /*break*/ ,
                                    3
                                ];
                            case "speech.startdetected":
                                return [
                                    3 /*break*/ ,
                                    4
                                ];
                            case "speech.enddetected":
                                return [
                                    3 /*break*/ ,
                                    5
                                ];
                            case "turn.end":
                                return [
                                    3 /*break*/ ,
                                    6
                                ];
                        }
                        return [
                            3 /*break*/ ,
                            15
                        ];
                    case 3:
                        this.privMustReportEndOfStream = true;
                        this.privRequestSession.onServiceTurnStartResponse();
                        return [
                            3 /*break*/ ,
                            17
                        ];
                    case 4:
                        speechStartDetected = $9MAMI.SpeechDetected.fromJSON(connectionMessage.textBody);
                        speechStartEventArgs = new $iQDnw.RecognitionEventArgs(speechStartDetected.Offset, this.privRequestSession.sessionId);
                        if (!!this.privRecognizer.speechStartDetected) this.privRecognizer.speechStartDetected(this.privRecognizer, speechStartEventArgs);
                        return [
                            3 /*break*/ ,
                            17
                        ];
                    case 5:
                        json = void 0;
                        if (connectionMessage.textBody.length > 0) json = connectionMessage.textBody;
                        else // If the request was empty, the JSON returned is empty.
                        json = "{ Offset: 0 }";
                        speechStopDetected = $9MAMI.SpeechDetected.fromJSON(json);
                        // Only shrink the buffers for continuous recognition.
                        // For single shot, the speech.phrase message will come after the speech.end and it should own buffer shrink.
                        if (this.privRecognizerConfig.isContinuousRecognition) this.privRequestSession.onServiceRecognized(speechStopDetected.Offset + this.privRequestSession.currentTurnAudioOffset);
                        speechStopEventArgs = new $iQDnw.RecognitionEventArgs(speechStopDetected.Offset + this.privRequestSession.currentTurnAudioOffset, this.privRequestSession.sessionId);
                        if (!!this.privRecognizer.speechEndDetected) this.privRecognizer.speechEndDetected(this.privRecognizer, speechStopEventArgs);
                        return [
                            3 /*break*/ ,
                            17
                        ];
                    case 6:
                        return [
                            4 /*yield*/ ,
                            this.sendTelemetryData()
                        ];
                    case 7:
                        _b.sent();
                        if (!(this.privRequestSession.isSpeechEnded && this.privMustReportEndOfStream)) return [
                            3 /*break*/ ,
                            9
                        ];
                        this.privMustReportEndOfStream = false;
                        return [
                            4 /*yield*/ ,
                            this.cancelRecognitionLocal($iQDnw.CancellationReason.EndOfStream, $iQDnw.CancellationErrorCode.NoError, undefined)
                        ];
                    case 8:
                        _b.sent();
                        _b.label = 9;
                    case 9:
                        sessionStopEventArgs = new $iQDnw.SessionEventArgs(this.privRequestSession.sessionId);
                        return [
                            4 /*yield*/ ,
                            this.privRequestSession.onServiceTurnEndResponse(this.privRecognizerConfig.isContinuousRecognition)
                        ];
                    case 10:
                        _b.sent();
                        if (!(!this.privRecognizerConfig.isContinuousRecognition || this.privRequestSession.isSpeechEnded || !this.privRequestSession.isRecognizing)) return [
                            3 /*break*/ ,
                            11
                        ];
                        if (!!this.privRecognizer.sessionStopped) this.privRecognizer.sessionStopped(this.privRecognizer, sessionStopEventArgs);
                        return [
                            2 /*return*/ 
                        ];
                    case 11:
                        return [
                            4 /*yield*/ ,
                            this.fetchConnection()
                        ];
                    case 12:
                        connection = _b.sent();
                        return [
                            4 /*yield*/ ,
                            this.sendPrePayloadJSON(connection)
                        ];
                    case 13:
                        _b.sent();
                        _b.label = 14;
                    case 14:
                        return [
                            3 /*break*/ ,
                            17
                        ];
                    case 15:
                        return [
                            4 /*yield*/ ,
                            this.processTypeSpecificMessages(connectionMessage)
                        ];
                    case 16:
                        if (!_b.sent()) // here are some messages that the derived class has not processed, dispatch them to connect class
                        {
                            if (!!this.privServiceEvents) this.serviceEvents.onEvent(new $7srwU.ServiceEvent(connectionMessage.path.toLowerCase(), connectionMessage.textBody));
                        }
                        _b.label = 17;
                    case 17:
                        return [
                            2 /*return*/ ,
                            this.receiveMessage()
                        ];
                    case 18:
                        error_5 = _b.sent();
                        return [
                            2 /*return*/ ,
                            null
                        ];
                    case 19:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    // Encapsulated for derived service recognizers that need to send additional JSON
    ServiceRecognizerBase.prototype.sendPrePayloadJSON = function(connection) {
        return $a2dab232aaee975b$var$__awaiter(this, void 0, void 0, function() {
            return $a2dab232aaee975b$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (this.sendPrePayloadJSONOverride !== undefined) return [
                            2 /*return*/ ,
                            this.sendPrePayloadJSONOverride(connection)
                        ];
                        return [
                            4 /*yield*/ ,
                            this.sendSpeechContext(connection)
                        ];
                    case 1:
                        _a.sent();
                        return [
                            4 /*yield*/ ,
                            this.sendWaveHeader(connection)
                        ];
                    case 2:
                        _a.sent();
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    ServiceRecognizerBase.prototype.sendWaveHeader = function(connection) {
        return $a2dab232aaee975b$var$__awaiter(this, void 0, void 0, function() {
            var format;
            return $a2dab232aaee975b$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.audioSource.format
                        ];
                    case 1:
                        format = _a.sent();
                        // this.writeBufferToConsole(format.header);
                        return [
                            2 /*return*/ ,
                            connection.send(new $eqPE4.SpeechConnectionMessage($7srwU.MessageType.Binary, "audio", this.privRequestSession.requestId, "audio/x-wav", format.header))
                        ];
                }
            });
        });
    };
    // Establishes a websocket connection to the end point.
    ServiceRecognizerBase.prototype.connectImpl = function() {
        var _this = this;
        if (this.privConnectionPromise) return this.privConnectionPromise.then(function(connection) {
            if (connection.state() === $7srwU.ConnectionState.Disconnected) {
                _this.privConnectionId = null;
                _this.privConnectionPromise = null;
                _this.privServiceHasSentMessage = false;
                return _this.connectImpl();
            }
            return _this.privConnectionPromise;
        }, function(error) {
            _this.privConnectionId = null;
            _this.privConnectionPromise = null;
            _this.privServiceHasSentMessage = false;
            return _this.connectImpl();
        });
        this.privConnectionPromise = this.retryableConnect();
        // Attach an empty handler to allow the promise to run in the background while
        // other startup events happen. It'll eventually be awaited on.
        this.privConnectionPromise.catch(function() {});
        if (this.postConnectImplOverride !== undefined) return this.postConnectImplOverride(this.privConnectionPromise);
        return this.privConnectionPromise;
    };
    ServiceRecognizerBase.prototype.fetchConnection = function() {
        return $a2dab232aaee975b$var$__awaiter(this, void 0, void 0, function() {
            var _this = this;
            return $a2dab232aaee975b$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (this.privConnectionConfigurationPromise) return [
                            2 /*return*/ ,
                            this.privConnectionConfigurationPromise.then(function(connection) {
                                if (connection.state() === $7srwU.ConnectionState.Disconnected) {
                                    _this.privConnectionId = null;
                                    _this.privConnectionConfigurationPromise = null;
                                    _this.privServiceHasSentMessage = false;
                                    return _this.fetchConnection();
                                }
                                return _this.privConnectionConfigurationPromise;
                            }, function(error) {
                                _this.privConnectionId = null;
                                _this.privConnectionConfigurationPromise = null;
                                _this.privServiceHasSentMessage = false;
                                return _this.fetchConnection();
                            })
                        ];
                        this.privConnectionConfigurationPromise = this.configureConnection();
                        return [
                            4 /*yield*/ ,
                            this.privConnectionConfigurationPromise
                        ];
                    case 1:
                        return [
                            2 /*return*/ ,
                            _a.sent()
                        ];
                }
            });
        });
    };
    ServiceRecognizerBase.prototype.sendAudio = function(audioStreamNode) {
        return $a2dab232aaee975b$var$__awaiter(this, void 0, void 0, function() {
            var audioFormat, nextSendTime, fastLaneSizeMs, maxSendUnthrottledBytes, startRecogNumber, readAndUploadCycle;
            var _this = this;
            return $a2dab232aaee975b$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.audioSource.format
                        ];
                    case 1:
                        audioFormat = _a.sent();
                        nextSendTime = Date.now();
                        fastLaneSizeMs = this.privRecognizerConfig.parameters.getProperty("SPEECH-TransmitLengthBeforThrottleMs", "5000");
                        maxSendUnthrottledBytes = audioFormat.avgBytesPerSec / 1000 * parseInt(fastLaneSizeMs, 10);
                        startRecogNumber = this.privRequestSession.recogNumber;
                        readAndUploadCycle = function() {
                            return $a2dab232aaee975b$var$__awaiter(_this, void 0, void 0, function() {
                                var connection, audioStreamChunk, payload, sendDelay;
                                var _this = this;
                                return $a2dab232aaee975b$var$__generator(this, function(_a) {
                                    switch(_a.label){
                                        case 0:
                                            if (!(!this.privIsDisposed && !this.privRequestSession.isSpeechEnded && this.privRequestSession.isRecognizing && this.privRequestSession.recogNumber === startRecogNumber)) return [
                                                3 /*break*/ ,
                                                5
                                            ];
                                            return [
                                                4 /*yield*/ ,
                                                this.fetchConnection()
                                            ];
                                        case 1:
                                            connection = _a.sent();
                                            return [
                                                4 /*yield*/ ,
                                                audioStreamNode.read()
                                            ];
                                        case 2:
                                            audioStreamChunk = _a.sent();
                                            // we have a new audio chunk to upload.
                                            if (this.privRequestSession.isSpeechEnded) // If service already recognized audio end then don't send any more audio
                                            return [
                                                2 /*return*/ 
                                            ];
                                            payload = void 0;
                                            sendDelay = void 0;
                                            if (!audioStreamChunk || audioStreamChunk.isEnd) {
                                                payload = null;
                                                sendDelay = 0;
                                            } else {
                                                payload = audioStreamChunk.buffer;
                                                this.privRequestSession.onAudioSent(payload.byteLength);
                                                if (maxSendUnthrottledBytes >= this.privRequestSession.bytesSent) sendDelay = 0;
                                                else sendDelay = Math.max(0, nextSendTime - Date.now());
                                            }
                                            if (!(0 !== sendDelay)) return [
                                                3 /*break*/ ,
                                                4
                                            ];
                                            return [
                                                4 /*yield*/ ,
                                                this.delay(sendDelay)
                                            ];
                                        case 3:
                                            _a.sent();
                                            _a.label = 4;
                                        case 4:
                                            if (payload !== null) nextSendTime = Date.now() + payload.byteLength * 1000 / (audioFormat.avgBytesPerSec * 2);
                                            // Are we still alive?
                                            if (!this.privIsDisposed && !this.privRequestSession.isSpeechEnded && this.privRequestSession.isRecognizing && this.privRequestSession.recogNumber === startRecogNumber) {
                                                connection.send(new $eqPE4.SpeechConnectionMessage($7srwU.MessageType.Binary, "audio", this.privRequestSession.requestId, null, payload)).catch(function() {
                                                    _this.privRequestSession.onServiceTurnEndResponse(_this.privRecognizerConfig.isContinuousRecognition).catch(function() {});
                                                });
                                                if (!(audioStreamChunk === null || audioStreamChunk === void 0 ? void 0 : audioStreamChunk.isEnd)) // this.writeBufferToConsole(payload);
                                                // Regardless of success or failure, schedule the next upload.
                                                // If the underlying connection was broken, the next cycle will
                                                // get a new connection and re-transmit missing audio automatically.
                                                return [
                                                    2 /*return*/ ,
                                                    readAndUploadCycle()
                                                ];
                                                else // the audio stream has been closed, no need to schedule next
                                                // read-upload cycle.
                                                if (!this.privIsLiveAudio) this.privRequestSession.onSpeechEnded();
                                            }
                                            _a.label = 5;
                                        case 5:
                                            return [
                                                2 /*return*/ 
                                            ];
                                    }
                                });
                            });
                        };
                        return [
                            2 /*return*/ ,
                            readAndUploadCycle()
                        ];
                }
            });
        });
    };
    ServiceRecognizerBase.prototype.retryableConnect = function() {
        return $a2dab232aaee975b$var$__awaiter(this, void 0, void 0, function() {
            var isUnAuthorized, sessionId, lastStatusCode, lastReason, authPromise, auth, connection, response;
            var _this = this;
            return $a2dab232aaee975b$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        isUnAuthorized = false;
                        this.privAuthFetchEventId = $7srwU.createNoDashGuid();
                        sessionId = this.privRequestSession.sessionId;
                        this.privConnectionId = sessionId !== undefined ? sessionId : $7srwU.createNoDashGuid();
                        this.privRequestSession.onPreConnectionStart(this.privAuthFetchEventId, this.privConnectionId);
                        lastStatusCode = 0;
                        lastReason = "";
                        _a.label = 1;
                    case 1:
                        if (!(this.privRequestSession.numConnectionAttempts <= this.privRecognizerConfig.maxRetryCount)) return [
                            3 /*break*/ ,
                            8
                        ];
                        authPromise = isUnAuthorized ? this.privAuthentication.fetchOnExpiry(this.privAuthFetchEventId) : this.privAuthentication.fetch(this.privAuthFetchEventId);
                        return [
                            4 /*yield*/ ,
                            authPromise
                        ];
                    case 2:
                        auth = _a.sent();
                        return [
                            4 /*yield*/ ,
                            this.privRequestSession.onAuthCompleted(false)
                        ];
                    case 3:
                        _a.sent();
                        connection = this.privConnectionFactory.create(this.privRecognizerConfig, auth, this.privConnectionId);
                        // Attach the telemetry handlers.
                        this.privRequestSession.listenForServiceTelemetry(connection.events);
                        // Attach to the underlying event. No need to hold onto the detach pointers as in the event the connection goes away,
                        // it'll stop sending events.
                        connection.events.attach(function(event) {
                            _this.connectionEvents.onEvent(event);
                        });
                        return [
                            4 /*yield*/ ,
                            connection.open()
                        ];
                    case 4:
                        response = _a.sent();
                        if (!(response.statusCode === 200)) return [
                            3 /*break*/ ,
                            6
                        ];
                        return [
                            4 /*yield*/ ,
                            this.privRequestSession.onConnectionEstablishCompleted(response.statusCode)
                        ];
                    case 5:
                        _a.sent();
                        return [
                            2 /*return*/ ,
                            Promise.resolve(connection)
                        ];
                    case 6:
                        if (response.statusCode === 1006) isUnAuthorized = true;
                        _a.label = 7;
                    case 7:
                        lastStatusCode = response.statusCode;
                        lastReason = response.reason;
                        this.privRequestSession.onRetryConnection();
                        return [
                            3 /*break*/ ,
                            1
                        ];
                    case 8:
                        return [
                            4 /*yield*/ ,
                            this.privRequestSession.onConnectionEstablishCompleted(lastStatusCode, lastReason)
                        ];
                    case 9:
                        _a.sent();
                        return [
                            2 /*return*/ ,
                            Promise.reject("Unable to contact server. StatusCode: " + lastStatusCode + ", " + this.privRecognizerConfig.parameters.getProperty($iQDnw.PropertyId.SpeechServiceConnection_Endpoint) + " Reason: " + lastReason)
                        ];
                }
            });
        });
    };
    ServiceRecognizerBase.prototype.delay = function(delayMs) {
        var _this = this;
        return new Promise(function(resolve, reject) {
            _this.privSetTimeout(resolve, delayMs);
        });
    };
    ServiceRecognizerBase.prototype.writeBufferToConsole = function(buffer) {
        var out = "Buffer Size: ";
        if (null === buffer) out += "null";
        else {
            var readView = new Uint8Array(buffer);
            out += buffer.byteLength + "\r\n";
            for(var i = 0; i < buffer.byteLength; i++)out += readView[i].toString(16).padStart(2, "0") + " ";
        }
        // tslint:disable-next-line:no-console
        console.info(out);
    };
    ServiceRecognizerBase.prototype.sendFinalAudio = function() {
        return $a2dab232aaee975b$var$__awaiter(this, void 0, void 0, function() {
            var connection;
            return $a2dab232aaee975b$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.fetchConnection()
                        ];
                    case 1:
                        connection = _a.sent();
                        return [
                            4 /*yield*/ ,
                            connection.send(new $eqPE4.SpeechConnectionMessage($7srwU.MessageType.Binary, "audio", this.privRequestSession.requestId, null, null))
                        ];
                    case 2:
                        _a.sent();
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    // Takes an established websocket connection to the endpoint and sends speech configuration information.
    ServiceRecognizerBase.prototype.configureConnection = function() {
        return $a2dab232aaee975b$var$__awaiter(this, void 0, void 0, function() {
            var connection;
            return $a2dab232aaee975b$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.connectImpl()
                        ];
                    case 1:
                        connection = _a.sent();
                        if (this.configConnectionOverride !== undefined) return [
                            2 /*return*/ ,
                            this.configConnectionOverride(connection)
                        ];
                        return [
                            4 /*yield*/ ,
                            this.sendSpeechServiceConfig(connection, this.privRequestSession, this.privRecognizerConfig.SpeechServiceConfig.serialize())
                        ];
                    case 2:
                        _a.sent();
                        return [
                            4 /*yield*/ ,
                            this.sendPrePayloadJSON(connection)
                        ];
                    case 3:
                        _a.sent();
                        return [
                            2 /*return*/ ,
                            connection
                        ];
                }
            });
        });
    };
    ServiceRecognizerBase.telemetryDataEnabled = true;
    return ServiceRecognizerBase;
}();
module.exports.ServiceRecognizerBase = $a2dab232aaee975b$var$ServiceRecognizerBase;

});
parcelRequire.register("eqPE4", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
var $a81b8e108a7f5c22$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SpeechConnectionMessage = void 0;

var $7srwU = parcelRequire("7srwU");

var $hiJX4 = parcelRequire("hiJX4");
var $a81b8e108a7f5c22$var$SpeechConnectionMessage = /** @class */ function(_super) {
    $a81b8e108a7f5c22$var$__extends(SpeechConnectionMessage, _super);
    function SpeechConnectionMessage(messageType, path, requestId, contentType, body, streamId, additionalHeaders, id) {
        var _this = this;
        if (!path) throw new $7srwU.ArgumentNullError("path");
        if (!requestId) throw new $7srwU.ArgumentNullError("requestId");
        var headers = {};
        headers[$hiJX4.HeaderNames.Path] = path;
        headers[$hiJX4.HeaderNames.RequestId] = requestId;
        headers[$hiJX4.HeaderNames.RequestTimestamp] = new Date().toISOString();
        if (contentType) headers[$hiJX4.HeaderNames.ContentType] = contentType;
        if (streamId) headers[$hiJX4.HeaderNames.RequestStreamId] = streamId;
        if (additionalHeaders) {
            for(var headerName in additionalHeaders)if (headerName) headers[headerName] = additionalHeaders[headerName];
        }
        if (id) _this = _super.call(this, messageType, body, headers, id) || this;
        else _this = _super.call(this, messageType, body, headers) || this;
        _this.privPath = path;
        _this.privRequestId = requestId;
        _this.privContentType = contentType;
        _this.privStreamId = streamId;
        _this.privAdditionalHeaders = additionalHeaders;
        return _this;
    }
    Object.defineProperty(SpeechConnectionMessage.prototype, "path", {
        get: function() {
            return this.privPath;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SpeechConnectionMessage.prototype, "requestId", {
        get: function() {
            return this.privRequestId;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SpeechConnectionMessage.prototype, "contentType", {
        get: function() {
            return this.privContentType;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SpeechConnectionMessage.prototype, "streamId", {
        get: function() {
            return this.privStreamId;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SpeechConnectionMessage.prototype, "additionalHeaders", {
        get: function() {
            return this.privAdditionalHeaders;
        },
        enumerable: false,
        configurable: true
    });
    SpeechConnectionMessage.fromConnectionMessage = function(message) {
        var path = null;
        var requestId = null;
        var contentType = null;
        var requestTimestamp = null;
        var streamId = null;
        var additionalHeaders = {};
        if (message.headers) {
            for(var headerName in message.headers)if (headerName) {
                if (headerName.toLowerCase() === $hiJX4.HeaderNames.Path.toLowerCase()) path = message.headers[headerName];
                else if (headerName.toLowerCase() === $hiJX4.HeaderNames.RequestId.toLowerCase()) requestId = message.headers[headerName];
                else if (headerName.toLowerCase() === $hiJX4.HeaderNames.RequestTimestamp.toLowerCase()) requestTimestamp = message.headers[headerName];
                else if (headerName.toLowerCase() === $hiJX4.HeaderNames.ContentType.toLowerCase()) contentType = message.headers[headerName];
                else if (headerName.toLowerCase() === $hiJX4.HeaderNames.RequestStreamId.toLowerCase()) streamId = message.headers[headerName];
                else additionalHeaders[headerName] = message.headers[headerName];
            }
        }
        return new SpeechConnectionMessage(message.messageType, path, requestId, contentType, message.body, streamId, additionalHeaders, message.id);
    };
    return SpeechConnectionMessage;
}($7srwU.ConnectionMessage);
module.exports.SpeechConnectionMessage = $a81b8e108a7f5c22$var$SpeechConnectionMessage;

});


parcelRequire.register("fQK0E", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.type = module.exports.connectivity = module.exports.Device = module.exports.OS = module.exports.System = module.exports.Context = module.exports.SpeechServiceConfig = module.exports.RecognizerConfig = module.exports.SpeechResultFormat = module.exports.RecognitionMode = void 0;

var $iQDnw = parcelRequire("iQDnw");
var $b89f66e4aa6e6c9c$var$RecognitionMode;
(function(RecognitionMode) {
    RecognitionMode[RecognitionMode["Interactive"] = 0] = "Interactive";
    RecognitionMode[RecognitionMode["Conversation"] = 1] = "Conversation";
    RecognitionMode[RecognitionMode["Dictation"] = 2] = "Dictation";
})($b89f66e4aa6e6c9c$var$RecognitionMode = module.exports.RecognitionMode || (module.exports.RecognitionMode = {}));
var $b89f66e4aa6e6c9c$var$SpeechResultFormat;
(function(SpeechResultFormat) {
    SpeechResultFormat[SpeechResultFormat["Simple"] = 0] = "Simple";
    SpeechResultFormat[SpeechResultFormat["Detailed"] = 1] = "Detailed";
})($b89f66e4aa6e6c9c$var$SpeechResultFormat = module.exports.SpeechResultFormat || (module.exports.SpeechResultFormat = {}));
var $b89f66e4aa6e6c9c$var$RecognizerConfig = /** @class */ function() {
    function RecognizerConfig(speechServiceConfig, parameters) {
        this.privRecognitionMode = $b89f66e4aa6e6c9c$var$RecognitionMode.Interactive;
        this.privSpeechServiceConfig = speechServiceConfig ? speechServiceConfig : new $b89f66e4aa6e6c9c$var$SpeechServiceConfig(new $b89f66e4aa6e6c9c$var$Context(null));
        this.privParameters = parameters;
        this.privMaxRetryCount = parseInt(parameters.getProperty("SPEECH-Error-MaxRetryCount", "4"), 10);
    }
    Object.defineProperty(RecognizerConfig.prototype, "parameters", {
        get: function() {
            return this.privParameters;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(RecognizerConfig.prototype, "recognitionMode", {
        get: function() {
            return this.privRecognitionMode;
        },
        set: function(value) {
            this.privRecognitionMode = value;
            this.privRecognitionActivityTimeout = value === $b89f66e4aa6e6c9c$var$RecognitionMode.Interactive ? 8000 : 25000;
            this.privSpeechServiceConfig.Recognition = $b89f66e4aa6e6c9c$var$RecognitionMode[value];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(RecognizerConfig.prototype, "SpeechServiceConfig", {
        get: function() {
            return this.privSpeechServiceConfig;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(RecognizerConfig.prototype, "recognitionActivityTimeout", {
        get: function() {
            return this.privRecognitionActivityTimeout;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(RecognizerConfig.prototype, "isContinuousRecognition", {
        get: function() {
            return this.privRecognitionMode !== $b89f66e4aa6e6c9c$var$RecognitionMode.Interactive;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(RecognizerConfig.prototype, "autoDetectSourceLanguages", {
        get: function() {
            return this.parameters.getProperty($iQDnw.PropertyId.SpeechServiceConnection_AutoDetectSourceLanguages, undefined);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(RecognizerConfig.prototype, "maxRetryCount", {
        get: function() {
            return this.privMaxRetryCount;
        },
        enumerable: false,
        configurable: true
    });
    return RecognizerConfig;
}();
module.exports.RecognizerConfig = $b89f66e4aa6e6c9c$var$RecognizerConfig;
// The config is serialized and sent as the Speech.Config
var $b89f66e4aa6e6c9c$var$SpeechServiceConfig = /** @class */ function() {
    function SpeechServiceConfig(context) {
        var _this = this;
        this.serialize = function() {
            return JSON.stringify(_this, function(key, value) {
                if (value && typeof value === "object") {
                    var replacement = {};
                    for(var k in value)if (Object.hasOwnProperty.call(value, k)) replacement[k && k.charAt(0).toLowerCase() + k.substring(1)] = value[k];
                    return replacement;
                }
                return value;
            });
        };
        this.context = context;
    }
    Object.defineProperty(SpeechServiceConfig.prototype, "Context", {
        get: function() {
            return this.context;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SpeechServiceConfig.prototype, "Recognition", {
        get: function() {
            return this.recognition;
        },
        set: function(value) {
            this.recognition = value.toLowerCase();
        },
        enumerable: false,
        configurable: true
    });
    return SpeechServiceConfig;
}();
module.exports.SpeechServiceConfig = $b89f66e4aa6e6c9c$var$SpeechServiceConfig;
var $b89f66e4aa6e6c9c$var$Context = /** @class */ function() {
    function Context(os) {
        this.system = new $b89f66e4aa6e6c9c$var$System();
        this.os = os;
    }
    return Context;
}();
module.exports.Context = $b89f66e4aa6e6c9c$var$Context;
var $b89f66e4aa6e6c9c$var$System = /** @class */ function() {
    function System() {
        // Note: below will be patched for official builds.
        var SPEECHSDK_CLIENTSDK_VERSION = "1.17.0";
        this.name = "SpeechSDK";
        this.version = SPEECHSDK_CLIENTSDK_VERSION;
        this.build = "JavaScript";
        this.lang = "JavaScript";
    }
    return System;
}();
module.exports.System = $b89f66e4aa6e6c9c$var$System;
var $b89f66e4aa6e6c9c$var$OS = /** @class */ function() {
    function OS(platform, name, version) {
        this.platform = platform;
        this.name = name;
        this.version = version;
    }
    return OS;
}();
module.exports.OS = $b89f66e4aa6e6c9c$var$OS;
var $b89f66e4aa6e6c9c$var$Device = /** @class */ function() {
    function Device(manufacturer, model, version) {
        this.manufacturer = manufacturer;
        this.model = model;
        this.version = version;
    }
    return Device;
}();
module.exports.Device = $b89f66e4aa6e6c9c$var$Device;
var $b89f66e4aa6e6c9c$var$connectivity;
(function(connectivity) {
    connectivity["Bluetooth"] = "Bluetooth";
    connectivity["Wired"] = "Wired";
    connectivity["WiFi"] = "WiFi";
    connectivity["Cellular"] = "Cellular";
    connectivity["InBuilt"] = "InBuilt";
    connectivity["Unknown"] = "Unknown";
})($b89f66e4aa6e6c9c$var$connectivity = module.exports.connectivity || (module.exports.connectivity = {}));
var $b89f66e4aa6e6c9c$var$type;
(function(type) {
    type["Phone"] = "Phone";
    type["Speaker"] = "Speaker";
    type["Car"] = "Car";
    type["Headset"] = "Headset";
    type["Thermostat"] = "Thermostat";
    type["Microphones"] = "Microphones";
    type["Deskphone"] = "Deskphone";
    type["RemoteControl"] = "RemoteControl";
    type["Unknown"] = "Unknown";
    type["File"] = "File";
    type["Stream"] = "Stream";
})($b89f66e4aa6e6c9c$var$type = module.exports.type || (module.exports.type = {}));

});

parcelRequire.register("MD7s3", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRequire.register("dY3QQ", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.WebsocketMessageFormatter = void 0;

var $7srwU = parcelRequire("7srwU");
var $a2b3ddc550433653$var$CRLF = "\r\n";
var $a2b3ddc550433653$var$WebsocketMessageFormatter = /** @class */ function() {
    function WebsocketMessageFormatter() {
        var _this = this;
        this.toConnectionMessage = function(message) {
            var deferral = new $7srwU.Deferred();
            try {
                if (message.messageType === $7srwU.MessageType.Text) {
                    var textMessage = message.textContent;
                    var headers = {};
                    var body = null;
                    if (textMessage) {
                        var headerBodySplit = textMessage.split("\r\n\r\n");
                        if (headerBodySplit && headerBodySplit.length > 0) {
                            headers = _this.parseHeaders(headerBodySplit[0]);
                            if (headerBodySplit.length > 1) body = headerBodySplit[1];
                        }
                    }
                    deferral.resolve(new $7srwU.ConnectionMessage(message.messageType, body, headers, message.id));
                } else if (message.messageType === $7srwU.MessageType.Binary) {
                    var binaryMessage = message.binaryContent;
                    var headers = {};
                    var body = null;
                    if (!binaryMessage || binaryMessage.byteLength < 2) throw new Error("Invalid binary message format. Header length missing.");
                    var dataView = new DataView(binaryMessage);
                    var headerLength = dataView.getInt16(0);
                    if (binaryMessage.byteLength < headerLength + 2) throw new Error("Invalid binary message format. Header content missing.");
                    var headersString = "";
                    for(var i = 0; i < headerLength; i++)headersString += String.fromCharCode(dataView.getInt8(i + 2));
                    headers = _this.parseHeaders(headersString);
                    if (binaryMessage.byteLength > headerLength + 2) body = binaryMessage.slice(2 + headerLength);
                    deferral.resolve(new $7srwU.ConnectionMessage(message.messageType, body, headers, message.id));
                }
            } catch (e) {
                deferral.reject("Error formatting the message. Error: " + e);
            }
            return deferral.promise;
        };
        this.fromConnectionMessage = function(message) {
            var deferral = new $7srwU.Deferred();
            try {
                if (message.messageType === $7srwU.MessageType.Text) {
                    var payload = "" + _this.makeHeaders(message) + $a2b3ddc550433653$var$CRLF + (message.textBody ? message.textBody : "");
                    deferral.resolve(new $7srwU.RawWebsocketMessage($7srwU.MessageType.Text, payload, message.id));
                } else if (message.messageType === $7srwU.MessageType.Binary) {
                    var headersString = _this.makeHeaders(message);
                    var content = message.binaryBody;
                    var headerBuffer = _this.stringToArrayBuffer(headersString);
                    var headerInt8Array = new Int8Array(headerBuffer);
                    var headerLength = headerInt8Array.byteLength;
                    var payloadInt8Array = new Int8Array(2 + headerLength + (content ? content.byteLength : 0));
                    payloadInt8Array[0] = headerLength >> 8 & 0xff;
                    payloadInt8Array[1] = headerLength & 0xff;
                    payloadInt8Array.set(headerInt8Array, 2);
                    if (content) {
                        var bodyInt8Array = new Int8Array(content);
                        payloadInt8Array.set(bodyInt8Array, 2 + headerLength);
                    }
                    var payload = payloadInt8Array.buffer;
                    deferral.resolve(new $7srwU.RawWebsocketMessage($7srwU.MessageType.Binary, payload, message.id));
                }
            } catch (e) {
                deferral.reject("Error formatting the message. " + e);
            }
            return deferral.promise;
        };
        this.makeHeaders = function(message) {
            var headersString = "";
            if (message.headers) {
                for(var header in message.headers)if (header) headersString += header + ": " + message.headers[header] + $a2b3ddc550433653$var$CRLF;
            }
            return headersString;
        };
        this.parseHeaders = function(headersString) {
            var headers = {};
            if (headersString) {
                var headerMatches = headersString.match(/[^\r\n]+/g);
                if (headers) for(var _i = 0, headerMatches_1 = headerMatches; _i < headerMatches_1.length; _i++){
                    var header = headerMatches_1[_i];
                    if (header) {
                        var separatorIndex = header.indexOf(":");
                        var headerName = separatorIndex > 0 ? header.substr(0, separatorIndex).trim().toLowerCase() : header;
                        var headerValue = separatorIndex > 0 && header.length > separatorIndex + 1 ? header.substr(separatorIndex + 1).trim() : "";
                        headers[headerName] = headerValue;
                    }
                }
            }
            return headers;
        };
        this.stringToArrayBuffer = function(str) {
            var buffer = new ArrayBuffer(str.length);
            var view = new DataView(buffer);
            for(var i = 0; i < str.length; i++)view.setUint8(i, str.charCodeAt(i));
            return buffer;
        };
    }
    return WebsocketMessageFormatter;
}();
module.exports.WebsocketMessageFormatter = $a2b3ddc550433653$var$WebsocketMessageFormatter;

});

parcelRequire.register("7EXdq", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
var $593a33ce6ecd75b0$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SpeechConnectionFactory = void 0;

var $9h4kO = parcelRequire("9h4kO");

var $9MAMI = parcelRequire("9MAMI");

var $iQDnw = parcelRequire("iQDnw");

var $8EAiJ = parcelRequire("8EAiJ");

var $9MAMI = parcelRequire("9MAMI");

var $hiJX4 = parcelRequire("hiJX4");

var $gYscZ = parcelRequire("gYscZ");
var $593a33ce6ecd75b0$var$SpeechConnectionFactory = /** @class */ function(_super) {
    $593a33ce6ecd75b0$var$__extends(SpeechConnectionFactory, _super);
    function SpeechConnectionFactory() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.interactiveRelativeUri = "/speech/recognition/interactive/cognitiveservices/v1";
        _this.conversationRelativeUri = "/speech/recognition/conversation/cognitiveservices/v1";
        _this.dictationRelativeUri = "/speech/recognition/dictation/cognitiveservices/v1";
        _this.create = function(config, authInfo, connectionId) {
            var endpoint = config.parameters.getProperty($iQDnw.PropertyId.SpeechServiceConnection_Endpoint, undefined);
            var region = config.parameters.getProperty($iQDnw.PropertyId.SpeechServiceConnection_Region, undefined);
            var hostSuffix = region && region.toLowerCase().startsWith("china") ? ".azure.cn" : ".microsoft.com";
            var host = config.parameters.getProperty($iQDnw.PropertyId.SpeechServiceConnection_Host, "wss://" + region + ".stt.speech" + hostSuffix);
            var queryParams = {};
            var endpointId = config.parameters.getProperty($iQDnw.PropertyId.SpeechServiceConnection_EndpointId, undefined);
            var language = config.parameters.getProperty($iQDnw.PropertyId.SpeechServiceConnection_RecoLanguage, undefined);
            if (endpointId) {
                if (!endpoint || endpoint.search($gYscZ.QueryParameterNames.CustomSpeechDeploymentId) === -1) queryParams[$gYscZ.QueryParameterNames.CustomSpeechDeploymentId] = endpointId;
            } else if (language) {
                if (!endpoint || endpoint.search($gYscZ.QueryParameterNames.Language) === -1) queryParams[$gYscZ.QueryParameterNames.Language] = language;
            }
            if (!endpoint || endpoint.search($gYscZ.QueryParameterNames.Format) === -1) queryParams[$gYscZ.QueryParameterNames.Format] = config.parameters.getProperty($9MAMI.OutputFormatPropertyName, $iQDnw.OutputFormat[$iQDnw.OutputFormat.Simple]).toLowerCase();
            if (config.autoDetectSourceLanguages !== undefined) queryParams[$gYscZ.QueryParameterNames.EnableLanguageId] = "true";
            _this.setCommonUrlParams(config, queryParams, endpoint);
            if (!endpoint) switch(config.recognitionMode){
                case $9MAMI.RecognitionMode.Conversation:
                    if (config.parameters.getProperty($9MAMI.ForceDictationPropertyName, "false") === "true") endpoint = host + _this.dictationRelativeUri;
                    else endpoint = host + _this.conversationRelativeUri;
                    break;
                case $9MAMI.RecognitionMode.Dictation:
                    endpoint = host + _this.dictationRelativeUri;
                    break;
                default:
                    endpoint = host + _this.interactiveRelativeUri; // default is interactive
                    break;
            }
            var headers = {};
            if (authInfo.token !== undefined && authInfo.token !== "") headers[authInfo.headerName] = authInfo.token;
            headers[$hiJX4.HeaderNames.ConnectionId] = connectionId;
            config.parameters.setProperty($iQDnw.PropertyId.SpeechServiceConnection_Url, endpoint);
            var enableCompression = config.parameters.getProperty("SPEECH-EnableWebsocketCompression", "false") === "true";
            return new $9h4kO.WebsocketConnection(endpoint, queryParams, headers, new $9MAMI.WebsocketMessageFormatter(), $9h4kO.ProxyInfo.fromRecognizerConfig(config), enableCompression, connectionId);
        };
        return _this;
    }
    return SpeechConnectionFactory;
}($8EAiJ.ConnectionFactoryBase);
module.exports.SpeechConnectionFactory = $593a33ce6ecd75b0$var$SpeechConnectionFactory;

});

parcelRequire.register("jWD2C", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
var $e851b7e63c3423b4$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TranscriberConnectionFactory = void 0;

var $9h4kO = parcelRequire("9h4kO");

var $iQDnw = parcelRequire("iQDnw");

var $8EAiJ = parcelRequire("8EAiJ");

var $9MAMI = parcelRequire("9MAMI");

var $hiJX4 = parcelRequire("hiJX4");

var $gYscZ = parcelRequire("gYscZ");
var $e851b7e63c3423b4$var$TranscriberConnectionFactory = /** @class */ function(_super) {
    $e851b7e63c3423b4$var$__extends(TranscriberConnectionFactory, _super);
    function TranscriberConnectionFactory() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.multiaudioRelativeUri = "/speech/recognition/multiaudio";
        _this.create = function(config, authInfo, connectionId) {
            var endpoint = config.parameters.getProperty($iQDnw.PropertyId.SpeechServiceConnection_Endpoint, undefined);
            var region = config.parameters.getProperty($iQDnw.PropertyId.SpeechServiceConnection_Region, "centralus");
            var hostSuffix = region && region.toLowerCase().startsWith("china") ? ".azure.cn" : ".microsoft.com";
            var hostDefault = "wss://transcribe." + region + ".cts.speech" + hostSuffix + _this.multiaudioRelativeUri;
            var host = config.parameters.getProperty($iQDnw.PropertyId.SpeechServiceConnection_Host, hostDefault);
            var queryParams = {};
            var endpointId = config.parameters.getProperty($iQDnw.PropertyId.SpeechServiceConnection_EndpointId, undefined);
            var language = config.parameters.getProperty($iQDnw.PropertyId.SpeechServiceConnection_RecoLanguage, undefined);
            if (endpointId) {
                if (!endpoint || endpoint.search($gYscZ.QueryParameterNames.CustomSpeechDeploymentId) === -1) queryParams[$gYscZ.QueryParameterNames.CustomSpeechDeploymentId] = endpointId;
            } else if (language) {
                if (!endpoint || endpoint.search($gYscZ.QueryParameterNames.Language) === -1) queryParams[$gYscZ.QueryParameterNames.Language] = language;
            }
            _this.setCommonUrlParams(config, queryParams, endpoint);
            if (!endpoint) endpoint = host;
            var headers = {};
            if (authInfo.token !== undefined && authInfo.token !== "") headers[authInfo.headerName] = authInfo.token;
            headers[$hiJX4.HeaderNames.ConnectionId] = connectionId;
            config.parameters.setProperty($iQDnw.PropertyId.SpeechServiceConnection_Url, endpoint);
            var enableCompression = config.parameters.getProperty("SPEECH-EnableWebsocketCompression", "false") === "true";
            return new $9h4kO.WebsocketConnection(endpoint, queryParams, headers, new $9MAMI.WebsocketMessageFormatter(), $9h4kO.ProxyInfo.fromRecognizerConfig(config), enableCompression, connectionId);
        };
        return _this;
    }
    return TranscriberConnectionFactory;
}($8EAiJ.ConnectionFactoryBase);
module.exports.TranscriberConnectionFactory = $e851b7e63c3423b4$var$TranscriberConnectionFactory;

});

parcelRequire.register("eQiZ3", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
var $ace4a5cd2f504c8a$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TranslationConnectionFactory = void 0;

var $9h4kO = parcelRequire("9h4kO");

var $iQDnw = parcelRequire("iQDnw");

var $8EAiJ = parcelRequire("8EAiJ");

var $9MAMI = parcelRequire("9MAMI");

var $hiJX4 = parcelRequire("hiJX4");

var $gYscZ = parcelRequire("gYscZ");
var $ace4a5cd2f504c8a$var$TranslationConnectionFactory = /** @class */ function(_super) {
    $ace4a5cd2f504c8a$var$__extends(TranslationConnectionFactory, _super);
    function TranslationConnectionFactory() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.create = function(config, authInfo, connectionId) {
            var endpoint = config.parameters.getProperty($iQDnw.PropertyId.SpeechServiceConnection_Endpoint, undefined);
            if (!endpoint) {
                var region = config.parameters.getProperty($iQDnw.PropertyId.SpeechServiceConnection_Region, undefined);
                var hostSuffix = region && region.toLowerCase().startsWith("china") ? ".azure.cn" : ".microsoft.com";
                var host = config.parameters.getProperty($iQDnw.PropertyId.SpeechServiceConnection_Host, "wss://" + region + ".s2s.speech" + hostSuffix);
                endpoint = host + "/speech/translation/cognitiveservices/v1";
            }
            var queryParams = {
                from: config.parameters.getProperty($iQDnw.PropertyId.SpeechServiceConnection_RecoLanguage),
                to: config.parameters.getProperty($iQDnw.PropertyId.SpeechServiceConnection_TranslationToLanguages)
            };
            _this.setCommonUrlParams(config, queryParams, endpoint);
            _this.setUrlParameter($iQDnw.PropertyId.SpeechServiceResponse_TranslationRequestStablePartialResult, $gYscZ.QueryParameterNames.StableTranslation, config, queryParams, endpoint);
            var voiceName = "voice";
            var featureName = "features";
            if (config.parameters.getProperty($iQDnw.PropertyId.SpeechServiceConnection_TranslationVoice, undefined) !== undefined) {
                queryParams[voiceName] = config.parameters.getProperty($iQDnw.PropertyId.SpeechServiceConnection_TranslationVoice);
                queryParams[featureName] = "texttospeech";
            }
            var headers = {};
            if (authInfo.token !== undefined && authInfo.token !== "") headers[authInfo.headerName] = authInfo.token;
            headers[$hiJX4.HeaderNames.ConnectionId] = connectionId;
            config.parameters.setProperty($iQDnw.PropertyId.SpeechServiceConnection_Url, endpoint);
            var enableCompression = config.parameters.getProperty("SPEECH-EnableWebsocketCompression", "false") === "true";
            return new $9h4kO.WebsocketConnection(endpoint, queryParams, headers, new $9MAMI.WebsocketMessageFormatter(), $9h4kO.ProxyInfo.fromRecognizerConfig(config), enableCompression, connectionId);
        };
        return _this;
    }
    return TranslationConnectionFactory;
}($8EAiJ.ConnectionFactoryBase);
module.exports.TranslationConnectionFactory = $ace4a5cd2f504c8a$var$TranslationConnectionFactory;

});

parcelRequire.register("ksvGQ", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SpeechSynthesisConnectionFactory = void 0;

var $9h4kO = parcelRequire("9h4kO");

var $iQDnw = parcelRequire("iQDnw");

var $9MAMI = parcelRequire("9MAMI");

var $hiJX4 = parcelRequire("hiJX4");

var $gYscZ = parcelRequire("gYscZ");
var $ee4f012b68397604$var$SpeechSynthesisConnectionFactory = /** @class */ function() {
    function SpeechSynthesisConnectionFactory() {
        var _this = this;
        this.synthesisUri = "/cognitiveservices/websocket/v1";
        this.create = function(config, authInfo, connectionId) {
            var endpoint = config.parameters.getProperty($iQDnw.PropertyId.SpeechServiceConnection_Endpoint, undefined);
            var region = config.parameters.getProperty($iQDnw.PropertyId.SpeechServiceConnection_Region, undefined);
            var hostSuffix = region && region.toLowerCase().startsWith("china") ? ".azure.cn" : ".microsoft.com";
            var endpointId = config.parameters.getProperty($iQDnw.PropertyId.SpeechServiceConnection_EndpointId, undefined);
            var hostPrefix = endpointId === undefined ? "tts" : "voice";
            var host = config.parameters.getProperty($iQDnw.PropertyId.SpeechServiceConnection_Host, "wss://" + region + "." + hostPrefix + ".speech" + hostSuffix);
            var queryParams = {};
            if (!endpoint) endpoint = host + _this.synthesisUri;
            var headers = {};
            if (authInfo.token !== undefined && authInfo.token !== "") headers[authInfo.headerName] = authInfo.token;
            headers[$hiJX4.HeaderNames.ConnectionId] = connectionId;
            if (endpointId !== undefined) headers[$gYscZ.QueryParameterNames.CustomVoiceDeploymentId] = endpointId;
            config.parameters.setProperty($iQDnw.PropertyId.SpeechServiceConnection_Url, endpoint);
            var enableCompression = config.parameters.getProperty("SPEECH-EnableWebsocketCompression", "false") === "true";
            return new $9h4kO.WebsocketConnection(endpoint, queryParams, headers, new $9MAMI.WebsocketMessageFormatter(), $9h4kO.ProxyInfo.fromParameters(config.parameters), enableCompression, connectionId);
        };
    }
    return SpeechSynthesisConnectionFactory;
}();
module.exports.SpeechSynthesisConnectionFactory = $ee4f012b68397604$var$SpeechSynthesisConnectionFactory;

});

parcelRequire.register("dSDdv", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.EnumTranslation = void 0;

var $iQDnw = parcelRequire("iQDnw");

var $9MAMI = parcelRequire("9MAMI");
var $a1aebd288900b135$var$EnumTranslation = /** @class */ function() {
    function EnumTranslation() {}
    EnumTranslation.implTranslateRecognitionResult = function(recognitionStatus) {
        var reason = $iQDnw.ResultReason.Canceled;
        switch(recognitionStatus){
            case $9MAMI.RecognitionStatus.Success:
                reason = $iQDnw.ResultReason.RecognizedSpeech;
                break;
            case $9MAMI.RecognitionStatus.NoMatch:
            case $9MAMI.RecognitionStatus.InitialSilenceTimeout:
            case $9MAMI.RecognitionStatus.BabbleTimeout:
            case $9MAMI.RecognitionStatus.EndOfDictation:
                reason = $iQDnw.ResultReason.NoMatch;
                break;
            case $9MAMI.RecognitionStatus.Error:
            default:
                reason = $iQDnw.ResultReason.Canceled;
                break;
        }
        return reason;
    };
    EnumTranslation.implTranslateCancelResult = function(recognitionStatus) {
        var reason = $iQDnw.CancellationReason.EndOfStream;
        switch(recognitionStatus){
            case $9MAMI.RecognitionStatus.Success:
            case $9MAMI.RecognitionStatus.EndOfDictation:
            case $9MAMI.RecognitionStatus.NoMatch:
                reason = $iQDnw.CancellationReason.EndOfStream;
                break;
            case $9MAMI.RecognitionStatus.InitialSilenceTimeout:
            case $9MAMI.RecognitionStatus.BabbleTimeout:
            case $9MAMI.RecognitionStatus.Error:
            default:
                reason = $iQDnw.CancellationReason.Error;
                break;
        }
        return reason;
    };
    EnumTranslation.implTranslateCancelErrorCode = function(recognitionStatus) {
        var reason = $iQDnw.CancellationErrorCode.NoError;
        switch(recognitionStatus){
            case $9MAMI.RecognitionStatus.Error:
                reason = $iQDnw.CancellationErrorCode.ServiceError;
                break;
            case $9MAMI.RecognitionStatus.TooManyRequests:
                reason = $iQDnw.CancellationErrorCode.TooManyRequests;
                break;
            default:
                reason = $iQDnw.CancellationErrorCode.NoError;
                break;
        }
        return reason;
    };
    return EnumTranslation;
}();
module.exports.EnumTranslation = $a1aebd288900b135$var$EnumTranslation;

});

parcelRequire.register("ghmgJ", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RecognitionStatus = module.exports.SynthesisStatus = void 0;
/**
 * @class SynthesisStatus
 * @private
 */ var $bd9f8204ddb81a28$var$SynthesisStatus;
(function(SynthesisStatus) {
    /**
     * The response contains valid audio data.
     * @member SynthesisStatus.Success
     */ SynthesisStatus[SynthesisStatus["Success"] = 0] = "Success";
    /**
     * Indicates the end of audio data. No valid audio data is included in the message.
     * @member SynthesisStatus.SynthesisEnd
     */ SynthesisStatus[SynthesisStatus["SynthesisEnd"] = 1] = "SynthesisEnd";
    /**
     * Indicates an error occurred during synthesis data processing.
     * @member SynthesisStatus.Error
     */ SynthesisStatus[SynthesisStatus["Error"] = 2] = "Error";
})($bd9f8204ddb81a28$var$SynthesisStatus = module.exports.SynthesisStatus || (module.exports.SynthesisStatus = {}));
var $bd9f8204ddb81a28$var$RecognitionStatus;
(function(RecognitionStatus) {
    RecognitionStatus[RecognitionStatus["Success"] = 0] = "Success";
    RecognitionStatus[RecognitionStatus["NoMatch"] = 1] = "NoMatch";
    RecognitionStatus[RecognitionStatus["InitialSilenceTimeout"] = 2] = "InitialSilenceTimeout";
    RecognitionStatus[RecognitionStatus["BabbleTimeout"] = 3] = "BabbleTimeout";
    RecognitionStatus[RecognitionStatus["Error"] = 4] = "Error";
    RecognitionStatus[RecognitionStatus["EndOfDictation"] = 5] = "EndOfDictation";
    RecognitionStatus[RecognitionStatus["TooManyRequests"] = 6] = "TooManyRequests";
})($bd9f8204ddb81a28$var$RecognitionStatus = module.exports.RecognitionStatus || (module.exports.RecognitionStatus = {}));

});

parcelRequire.register("3ipaP", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TranslationSynthesisEnd = void 0;

var $9MAMI = parcelRequire("9MAMI");
var $2666948669cf14a7$var$TranslationSynthesisEnd = /** @class */ function() {
    function TranslationSynthesisEnd(json) {
        this.privSynthesisEnd = JSON.parse(json);
        this.privSynthesisEnd.SynthesisStatus = $9MAMI.SynthesisStatus[this.privSynthesisEnd.SynthesisStatus];
    }
    TranslationSynthesisEnd.fromJSON = function(json) {
        return new TranslationSynthesisEnd(json);
    };
    Object.defineProperty(TranslationSynthesisEnd.prototype, "SynthesisStatus", {
        get: function() {
            return this.privSynthesisEnd.SynthesisStatus;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TranslationSynthesisEnd.prototype, "FailureReason", {
        get: function() {
            return this.privSynthesisEnd.FailureReason;
        },
        enumerable: false,
        configurable: true
    });
    return TranslationSynthesisEnd;
}();
module.exports.TranslationSynthesisEnd = $2666948669cf14a7$var$TranslationSynthesisEnd;

});

parcelRequire.register("1R7uH", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TranslationHypothesis = void 0;

var $hlsVP = parcelRequire("hlsVP");
var $15a08de080ceeae7$var$TranslationHypothesis = /** @class */ function() {
    function TranslationHypothesis(json) {
        this.privTranslationHypothesis = JSON.parse(json);
        this.privTranslationHypothesis.Translation.TranslationStatus = $hlsVP.TranslationStatus[this.privTranslationHypothesis.Translation.TranslationStatus];
    }
    TranslationHypothesis.fromJSON = function(json) {
        return new TranslationHypothesis(json);
    };
    Object.defineProperty(TranslationHypothesis.prototype, "Duration", {
        get: function() {
            return this.privTranslationHypothesis.Duration;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TranslationHypothesis.prototype, "Offset", {
        get: function() {
            return this.privTranslationHypothesis.Offset;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TranslationHypothesis.prototype, "Text", {
        get: function() {
            return this.privTranslationHypothesis.Text;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TranslationHypothesis.prototype, "Translation", {
        get: function() {
            return this.privTranslationHypothesis.Translation;
        },
        enumerable: false,
        configurable: true
    });
    return TranslationHypothesis;
}();
module.exports.TranslationHypothesis = $15a08de080ceeae7$var$TranslationHypothesis;

});

parcelRequire.register("baRzV", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TranslationPhrase = void 0;

var $9MAMI = parcelRequire("9MAMI");

var $hlsVP = parcelRequire("hlsVP");
var $822a306f1754cf36$var$TranslationPhrase = /** @class */ function() {
    function TranslationPhrase(json) {
        this.privTranslationPhrase = JSON.parse(json);
        this.privTranslationPhrase.RecognitionStatus = $9MAMI.RecognitionStatus[this.privTranslationPhrase.RecognitionStatus];
        if (this.privTranslationPhrase.Translation !== undefined) this.privTranslationPhrase.Translation.TranslationStatus = $hlsVP.TranslationStatus[this.privTranslationPhrase.Translation.TranslationStatus];
    }
    TranslationPhrase.fromJSON = function(json) {
        return new TranslationPhrase(json);
    };
    Object.defineProperty(TranslationPhrase.prototype, "RecognitionStatus", {
        get: function() {
            return this.privTranslationPhrase.RecognitionStatus;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TranslationPhrase.prototype, "Offset", {
        get: function() {
            return this.privTranslationPhrase.Offset;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TranslationPhrase.prototype, "Duration", {
        get: function() {
            return this.privTranslationPhrase.Duration;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TranslationPhrase.prototype, "Text", {
        get: function() {
            return this.privTranslationPhrase.Text;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TranslationPhrase.prototype, "Translation", {
        get: function() {
            return this.privTranslationPhrase.Translation;
        },
        enumerable: false,
        configurable: true
    });
    return TranslationPhrase;
}();
module.exports.TranslationPhrase = $822a306f1754cf36$var$TranslationPhrase;

});

parcelRequire.register("2sLVM", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
var $1cb36065d34ef663$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $1cb36065d34ef663$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $1cb36065d34ef663$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TranslationServiceRecognizer = void 0;

var $7srwU = parcelRequire("7srwU");

var $iQDnw = parcelRequire("iQDnw");

var $9MAMI = parcelRequire("9MAMI");
// tslint:disable-next-line:max-classes-per-file
var $1cb36065d34ef663$var$TranslationServiceRecognizer = /** @class */ function(_super) {
    $1cb36065d34ef663$var$__extends(TranslationServiceRecognizer, _super);
    function TranslationServiceRecognizer(authentication, connectionFactory, audioSource, recognizerConfig, translationRecognizer) {
        var _this = _super.call(this, authentication, connectionFactory, audioSource, recognizerConfig, translationRecognizer) || this;
        _this.privTranslationRecognizer = translationRecognizer;
        _this.connectionEvents.attach(function(connectionEvent) {
            return $1cb36065d34ef663$var$__awaiter(_this, void 0, void 0, function() {
                return $1cb36065d34ef663$var$__generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            if (!(connectionEvent.name === "ConnectionEstablishedEvent")) return [
                                3 /*break*/ ,
                                1
                            ];
                            this.privTranslationRecognizer.onConnection();
                            return [
                                3 /*break*/ ,
                                3
                            ];
                        case 1:
                            if (!(connectionEvent.name === "ConnectionClosedEvent")) return [
                                3 /*break*/ ,
                                3
                            ];
                            return [
                                4 /*yield*/ ,
                                this.privTranslationRecognizer.onDisconnection()
                            ];
                        case 2:
                            _a.sent();
                            _a.label = 3;
                        case 3:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        });
        return _this;
    }
    TranslationServiceRecognizer.prototype.processTypeSpecificMessages = function(connectionMessage) {
        return $1cb36065d34ef663$var$__awaiter(this, void 0, void 0, function() {
            var resultProps, processed, _a, result, translatedPhrase, result_1, reason, result_2, cancelReason, ev, synthEnd, result_3, retEvent, canceledResult;
            return $1cb36065d34ef663$var$__generator(this, function(_b) {
                switch(_b.label){
                    case 0:
                        resultProps = new $iQDnw.PropertyCollection();
                        processed = false;
                        if (connectionMessage.messageType === $7srwU.MessageType.Text) resultProps.setProperty($iQDnw.PropertyId.SpeechServiceResponse_JsonResult, connectionMessage.textBody);
                        _a = connectionMessage.path.toLowerCase();
                        switch(_a){
                            case "translation.hypothesis":
                                return [
                                    3 /*break*/ ,
                                    1
                                ];
                            case "translation.phrase":
                                return [
                                    3 /*break*/ ,
                                    2
                                ];
                            case "translation.synthesis":
                                return [
                                    3 /*break*/ ,
                                    7
                                ];
                            case "translation.synthesis.end":
                                return [
                                    3 /*break*/ ,
                                    8
                                ];
                        }
                        return [
                            3 /*break*/ ,
                            9
                        ];
                    case 1:
                        result = this.fireEventForResult($9MAMI.TranslationHypothesis.fromJSON(connectionMessage.textBody), resultProps);
                        this.privRequestSession.onHypothesis(this.privRequestSession.currentTurnAudioOffset + result.offset);
                        if (!!this.privTranslationRecognizer.recognizing) try {
                            this.privTranslationRecognizer.recognizing(this.privTranslationRecognizer, result);
                        /* tslint:disable:no-empty */ } catch (error) {
                        // Not going to let errors in the event handler
                        // trip things up.
                        }
                        processed = true;
                        return [
                            3 /*break*/ ,
                            10
                        ];
                    case 2:
                        translatedPhrase = $9MAMI.TranslationPhrase.fromJSON(connectionMessage.textBody);
                        this.privRequestSession.onPhraseRecognized(this.privRequestSession.currentTurnAudioOffset + translatedPhrase.Offset + translatedPhrase.Duration);
                        if (!(translatedPhrase.RecognitionStatus === $9MAMI.RecognitionStatus.Success)) return [
                            3 /*break*/ ,
                            3
                        ];
                        result_1 = this.fireEventForResult(translatedPhrase, resultProps);
                        if (!!this.privTranslationRecognizer.recognized) try {
                            this.privTranslationRecognizer.recognized(this.privTranslationRecognizer, result_1);
                        /* tslint:disable:no-empty */ } catch (error) {
                        // Not going to let errors in the event handler
                        // trip things up.
                        }
                        // report result to promise.
                        if (!!this.privSuccessCallback) {
                            try {
                                this.privSuccessCallback(result_1.result);
                            } catch (e) {
                                if (!!this.privErrorCallback) this.privErrorCallback(e);
                            }
                            // Only invoke the call back once.
                            // and if it's successful don't invoke the
                            // error after that.
                            this.privSuccessCallback = undefined;
                            this.privErrorCallback = undefined;
                        }
                        return [
                            3 /*break*/ ,
                            10
                        ];
                    case 3:
                        reason = $9MAMI.EnumTranslation.implTranslateRecognitionResult(translatedPhrase.RecognitionStatus);
                        result_2 = new $iQDnw.TranslationRecognitionResult(undefined, this.privRequestSession.requestId, reason, translatedPhrase.Text, translatedPhrase.Duration, this.privRequestSession.currentTurnAudioOffset + translatedPhrase.Offset, undefined, connectionMessage.textBody, resultProps);
                        if (!(reason === $iQDnw.ResultReason.Canceled)) return [
                            3 /*break*/ ,
                            5
                        ];
                        cancelReason = $9MAMI.EnumTranslation.implTranslateCancelResult(translatedPhrase.RecognitionStatus);
                        return [
                            4 /*yield*/ ,
                            this.cancelRecognitionLocal(cancelReason, $9MAMI.EnumTranslation.implTranslateCancelErrorCode(translatedPhrase.RecognitionStatus), undefined)
                        ];
                    case 4:
                        _b.sent();
                        return [
                            3 /*break*/ ,
                            6
                        ];
                    case 5:
                        if (!(this.privRequestSession.isSpeechEnded && reason === $iQDnw.ResultReason.NoMatch && translatedPhrase.RecognitionStatus !== $9MAMI.RecognitionStatus.InitialSilenceTimeout)) {
                            ev = new $iQDnw.TranslationRecognitionEventArgs(result_2, result_2.offset, this.privRequestSession.sessionId);
                            if (!!this.privTranslationRecognizer.recognized) try {
                                this.privTranslationRecognizer.recognized(this.privTranslationRecognizer, ev);
                            /* tslint:disable:no-empty */ } catch (error) {
                            // Not going to let errors in the event handler
                            // trip things up.
                            }
                        }
                        // report result to promise.
                        if (!!this.privSuccessCallback) {
                            try {
                                this.privSuccessCallback(result_2);
                            } catch (e) {
                                if (!!this.privErrorCallback) this.privErrorCallback(e);
                            }
                            // Only invoke the call back once.
                            // and if it's successful don't invoke the
                            // error after that.
                            this.privSuccessCallback = undefined;
                            this.privErrorCallback = undefined;
                        }
                        _b.label = 6;
                    case 6:
                        processed = true;
                        return [
                            3 /*break*/ ,
                            10
                        ];
                    case 7:
                        this.sendSynthesisAudio(connectionMessage.binaryBody, this.privRequestSession.sessionId);
                        processed = true;
                        return [
                            3 /*break*/ ,
                            10
                        ];
                    case 8:
                        synthEnd = $9MAMI.TranslationSynthesisEnd.fromJSON(connectionMessage.textBody);
                        switch(synthEnd.SynthesisStatus){
                            case $9MAMI.SynthesisStatus.Error:
                                if (!!this.privTranslationRecognizer.synthesizing) {
                                    result_3 = new $iQDnw.TranslationSynthesisResult($iQDnw.ResultReason.Canceled, undefined);
                                    retEvent = new $iQDnw.TranslationSynthesisEventArgs(result_3, this.privRequestSession.sessionId);
                                    try {
                                        this.privTranslationRecognizer.synthesizing(this.privTranslationRecognizer, retEvent);
                                    /* tslint:disable:no-empty */ } catch (error) {
                                    // Not going to let errors in the event handler
                                    // trip things up.
                                    }
                                }
                                if (!!this.privTranslationRecognizer.canceled) {
                                    canceledResult = new $iQDnw.TranslationRecognitionCanceledEventArgs(this.privRequestSession.sessionId, $iQDnw.CancellationReason.Error, synthEnd.FailureReason, $iQDnw.CancellationErrorCode.ServiceError, null);
                                    try {
                                        this.privTranslationRecognizer.canceled(this.privTranslationRecognizer, canceledResult);
                                    /* tslint:disable:no-empty */ } catch (error) {
                                    // Not going to let errors in the event handler
                                    // trip things up.
                                    }
                                }
                                break;
                            case $9MAMI.SynthesisStatus.Success:
                                this.sendSynthesisAudio(undefined, this.privRequestSession.sessionId);
                                break;
                            default:
                                break;
                        }
                        processed = true;
                        return [
                            3 /*break*/ ,
                            10
                        ];
                    case 9:
                        return [
                            3 /*break*/ ,
                            10
                        ];
                    case 10:
                        return [
                            2 /*return*/ ,
                            processed
                        ];
                }
            });
        });
    };
    // Cancels recognition.
    TranslationServiceRecognizer.prototype.cancelRecognition = function(sessionId, requestId, cancellationReason, errorCode, error) {
        var properties = new $iQDnw.PropertyCollection();
        properties.setProperty($9MAMI.CancellationErrorCodePropertyName, $iQDnw.CancellationErrorCode[errorCode]);
        if (!!this.privTranslationRecognizer.canceled) {
            var cancelEvent = new $iQDnw.TranslationRecognitionCanceledEventArgs(sessionId, cancellationReason, error, errorCode, undefined);
            try {
                this.privTranslationRecognizer.canceled(this.privTranslationRecognizer, cancelEvent);
            /* tslint:disable:no-empty */ } catch (_a) {}
        }
        if (!!this.privSuccessCallback) {
            var result = new $iQDnw.TranslationRecognitionResult(undefined, requestId, $iQDnw.ResultReason.Canceled, undefined, undefined, undefined, error, undefined, properties);
            try {
                this.privSuccessCallback(result);
                /* tslint:disable:no-empty */ this.privSuccessCallback = undefined;
            } catch (_b) {}
        }
    };
    TranslationServiceRecognizer.prototype.fireEventForResult = function(serviceResult, properties) {
        var translations;
        if (undefined !== serviceResult.Translation.Translations) {
            translations = new $iQDnw.Translations();
            for(var _i = 0, _a = serviceResult.Translation.Translations; _i < _a.length; _i++){
                var translation = _a[_i];
                translations.set(translation.Language, translation.Text);
            }
        }
        var resultReason;
        if (serviceResult instanceof $9MAMI.TranslationPhrase) {
            if (serviceResult.Translation.TranslationStatus === $7srwU.TranslationStatus.Success) resultReason = $iQDnw.ResultReason.TranslatedSpeech;
            else resultReason = $iQDnw.ResultReason.RecognizedSpeech;
        } else resultReason = $iQDnw.ResultReason.TranslatingSpeech;
        var offset = serviceResult.Offset + this.privRequestSession.currentTurnAudioOffset;
        var result = new $iQDnw.TranslationRecognitionResult(translations, this.privRequestSession.requestId, resultReason, serviceResult.Text, serviceResult.Duration, offset, serviceResult.Translation.FailureReason, JSON.stringify(serviceResult), properties);
        var ev = new $iQDnw.TranslationRecognitionEventArgs(result, offset, this.privRequestSession.sessionId);
        return ev;
    };
    TranslationServiceRecognizer.prototype.sendSynthesisAudio = function(audio, sessionId) {
        var reason = undefined === audio ? $iQDnw.ResultReason.SynthesizingAudioCompleted : $iQDnw.ResultReason.SynthesizingAudio;
        var result = new $iQDnw.TranslationSynthesisResult(reason, audio);
        var retEvent = new $iQDnw.TranslationSynthesisEventArgs(result, sessionId);
        if (!!this.privTranslationRecognizer.synthesizing) try {
            this.privTranslationRecognizer.synthesizing(this.privTranslationRecognizer, retEvent);
        /* tslint:disable:no-empty */ } catch (error) {
        // Not going to let errors in the event handler
        // trip things up.
        }
    };
    return TranslationServiceRecognizer;
}($9MAMI.ServiceRecognizerBase);
module.exports.TranslationServiceRecognizer = $1cb36065d34ef663$var$TranslationServiceRecognizer;

});

parcelRequire.register("i9UcG", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SpeechDetected = void 0;
var $d384aa17c99ba626$var$SpeechDetected = /** @class */ function() {
    function SpeechDetected(json) {
        this.privSpeechStartDetected = JSON.parse(json);
    }
    SpeechDetected.fromJSON = function(json) {
        return new SpeechDetected(json);
    };
    Object.defineProperty(SpeechDetected.prototype, "Offset", {
        get: function() {
            return this.privSpeechStartDetected.Offset;
        },
        enumerable: false,
        configurable: true
    });
    return SpeechDetected;
}();
module.exports.SpeechDetected = $d384aa17c99ba626$var$SpeechDetected;

});

parcelRequire.register("ewiBS", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SpeechHypothesis = void 0;
var $a9227d6117006903$var$SpeechHypothesis = /** @class */ function() {
    function SpeechHypothesis(json) {
        this.privSpeechHypothesis = JSON.parse(json);
    }
    SpeechHypothesis.fromJSON = function(json) {
        return new SpeechHypothesis(json);
    };
    Object.defineProperty(SpeechHypothesis.prototype, "Text", {
        get: function() {
            return this.privSpeechHypothesis.Text;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SpeechHypothesis.prototype, "Offset", {
        get: function() {
            return this.privSpeechHypothesis.Offset;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SpeechHypothesis.prototype, "Duration", {
        get: function() {
            return this.privSpeechHypothesis.Duration;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SpeechHypothesis.prototype, "Language", {
        get: function() {
            return this.privSpeechHypothesis.PrimaryLanguage === undefined ? undefined : this.privSpeechHypothesis.PrimaryLanguage.Language;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SpeechHypothesis.prototype, "LanguageDetectionConfidence", {
        get: function() {
            return this.privSpeechHypothesis.PrimaryLanguage === undefined ? undefined : this.privSpeechHypothesis.PrimaryLanguage.Confidence;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SpeechHypothesis.prototype, "SpeakerId", {
        get: function() {
            return this.privSpeechHypothesis.SpeakerId;
        },
        enumerable: false,
        configurable: true
    });
    return SpeechHypothesis;
}();
module.exports.SpeechHypothesis = $a9227d6117006903$var$SpeechHypothesis;

});

parcelRequire.register("4VwSP", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SpeechKeyword = void 0;
var $3965fe4099a92721$var$SpeechKeyword = /** @class */ function() {
    function SpeechKeyword(json) {
        this.privSpeechKeyword = JSON.parse(json);
    }
    SpeechKeyword.fromJSON = function(json) {
        return new SpeechKeyword(json);
    };
    Object.defineProperty(SpeechKeyword.prototype, "Status", {
        get: function() {
            return this.privSpeechKeyword.Status;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SpeechKeyword.prototype, "Text", {
        get: function() {
            return this.privSpeechKeyword.Text;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SpeechKeyword.prototype, "Offset", {
        get: function() {
            return this.privSpeechKeyword.Offset;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SpeechKeyword.prototype, "Duration", {
        get: function() {
            return this.privSpeechKeyword.Duration;
        },
        enumerable: false,
        configurable: true
    });
    return SpeechKeyword;
}();
module.exports.SpeechKeyword = $3965fe4099a92721$var$SpeechKeyword;

});

parcelRequire.register("JeRGY", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
var $087fbbf6be4bf407$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $087fbbf6be4bf407$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $087fbbf6be4bf407$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SpeechServiceRecognizer = void 0;

var $iQDnw = parcelRequire("iQDnw");

var $9MAMI = parcelRequire("9MAMI");
// tslint:disable-next-line:max-classes-per-file
var $087fbbf6be4bf407$var$SpeechServiceRecognizer = /** @class */ function(_super) {
    $087fbbf6be4bf407$var$__extends(SpeechServiceRecognizer, _super);
    function SpeechServiceRecognizer(authentication, connectionFactory, audioSource, recognizerConfig, speechRecognizer) {
        var _this = _super.call(this, authentication, connectionFactory, audioSource, recognizerConfig, speechRecognizer) || this;
        _this.privSpeechRecognizer = speechRecognizer;
        if (recognizerConfig.autoDetectSourceLanguages !== undefined) {
            var sourceLanguages = recognizerConfig.autoDetectSourceLanguages.split(",");
            _this.privSpeechContext.setSection("languageId", {
                languages: sourceLanguages,
                onSuccess: {
                    action: "Recognize"
                },
                onUnknown: {
                    action: "None"
                }
            });
            _this.privSpeechContext.setSection("phraseOutput", {
                interimResults: {
                    resultType: "Auto"
                },
                phraseResults: {
                    resultType: "Always"
                }
            });
        }
        return _this;
    }
    SpeechServiceRecognizer.prototype.processTypeSpecificMessages = function(connectionMessage) {
        return $087fbbf6be4bf407$var$__awaiter(this, void 0, void 0, function() {
            var result, resultProps, processed, _a, hypothesis, offset, ev, simple, resultReason, cancelReason, detailed, event_1;
            return $087fbbf6be4bf407$var$__generator(this, function(_b) {
                switch(_b.label){
                    case 0:
                        resultProps = new $iQDnw.PropertyCollection();
                        resultProps.setProperty($iQDnw.PropertyId.SpeechServiceResponse_JsonResult, connectionMessage.textBody);
                        processed = false;
                        _a = connectionMessage.path.toLowerCase();
                        switch(_a){
                            case "speech.hypothesis":
                                return [
                                    3 /*break*/ ,
                                    1
                                ];
                            case "speech.fragment":
                                return [
                                    3 /*break*/ ,
                                    1
                                ];
                            case "speech.phrase":
                                return [
                                    3 /*break*/ ,
                                    2
                                ];
                        }
                        return [
                            3 /*break*/ ,
                            6
                        ];
                    case 1:
                        hypothesis = $9MAMI.SpeechHypothesis.fromJSON(connectionMessage.textBody);
                        offset = hypothesis.Offset + this.privRequestSession.currentTurnAudioOffset;
                        result = new $iQDnw.SpeechRecognitionResult(this.privRequestSession.requestId, $iQDnw.ResultReason.RecognizingSpeech, hypothesis.Text, hypothesis.Duration, offset, hypothesis.Language, hypothesis.LanguageDetectionConfidence, undefined, undefined, connectionMessage.textBody, resultProps);
                        this.privRequestSession.onHypothesis(offset);
                        ev = new $iQDnw.SpeechRecognitionEventArgs(result, hypothesis.Duration, this.privRequestSession.sessionId);
                        if (!!this.privSpeechRecognizer.recognizing) try {
                            this.privSpeechRecognizer.recognizing(this.privSpeechRecognizer, ev);
                        /* tslint:disable:no-empty */ } catch (error) {
                        // Not going to let errors in the event handler
                        // trip things up.
                        }
                        processed = true;
                        return [
                            3 /*break*/ ,
                            7
                        ];
                    case 2:
                        simple = $9MAMI.SimpleSpeechPhrase.fromJSON(connectionMessage.textBody);
                        resultReason = $9MAMI.EnumTranslation.implTranslateRecognitionResult(simple.RecognitionStatus);
                        this.privRequestSession.onPhraseRecognized(this.privRequestSession.currentTurnAudioOffset + simple.Offset + simple.Duration);
                        if (!($iQDnw.ResultReason.Canceled === resultReason)) return [
                            3 /*break*/ ,
                            4
                        ];
                        cancelReason = $9MAMI.EnumTranslation.implTranslateCancelResult(simple.RecognitionStatus);
                        return [
                            4 /*yield*/ ,
                            this.cancelRecognitionLocal(cancelReason, $9MAMI.EnumTranslation.implTranslateCancelErrorCode(simple.RecognitionStatus), undefined)
                        ];
                    case 3:
                        _b.sent();
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 4:
                        if (!(this.privRequestSession.isSpeechEnded && resultReason === $iQDnw.ResultReason.NoMatch && simple.RecognitionStatus !== $9MAMI.RecognitionStatus.InitialSilenceTimeout)) {
                            if (this.privRecognizerConfig.parameters.getProperty($9MAMI.OutputFormatPropertyName) === $iQDnw.OutputFormat[$iQDnw.OutputFormat.Simple]) result = new $iQDnw.SpeechRecognitionResult(this.privRequestSession.requestId, resultReason, simple.DisplayText, simple.Duration, simple.Offset + this.privRequestSession.currentTurnAudioOffset, simple.Language, simple.LanguageDetectionConfidence, undefined, undefined, connectionMessage.textBody, resultProps);
                            else {
                                detailed = $9MAMI.DetailedSpeechPhrase.fromJSON(connectionMessage.textBody);
                                result = new $iQDnw.SpeechRecognitionResult(this.privRequestSession.requestId, resultReason, detailed.RecognitionStatus === $9MAMI.RecognitionStatus.Success ? detailed.NBest[0].Display : undefined, detailed.Duration, detailed.Offset + this.privRequestSession.currentTurnAudioOffset, detailed.Language, detailed.LanguageDetectionConfidence, undefined, undefined, connectionMessage.textBody, resultProps);
                            }
                            event_1 = new $iQDnw.SpeechRecognitionEventArgs(result, result.offset, this.privRequestSession.sessionId);
                            if (!!this.privSpeechRecognizer.recognized) try {
                                this.privSpeechRecognizer.recognized(this.privSpeechRecognizer, event_1);
                            /* tslint:disable:no-empty */ } catch (error) {
                            // Not going to let errors in the event handler
                            // trip things up.
                            }
                        }
                        if (!!this.privSuccessCallback) {
                            try {
                                this.privSuccessCallback(result);
                            } catch (e) {
                                if (!!this.privErrorCallback) this.privErrorCallback(e);
                            }
                            // Only invoke the call back once.
                            // and if it's successful don't invoke the
                            // error after that.
                            this.privSuccessCallback = undefined;
                            this.privErrorCallback = undefined;
                        }
                        _b.label = 5;
                    case 5:
                        processed = true;
                        return [
                            3 /*break*/ ,
                            7
                        ];
                    case 6:
                        return [
                            3 /*break*/ ,
                            7
                        ];
                    case 7:
                        return [
                            2 /*return*/ ,
                            processed
                        ];
                }
            });
        });
    };
    // Cancels recognition.
    SpeechServiceRecognizer.prototype.cancelRecognition = function(sessionId, requestId, cancellationReason, errorCode, error) {
        var properties = new $iQDnw.PropertyCollection();
        properties.setProperty($9MAMI.CancellationErrorCodePropertyName, $iQDnw.CancellationErrorCode[errorCode]);
        if (!!this.privSpeechRecognizer.canceled) {
            var cancelEvent = new $iQDnw.SpeechRecognitionCanceledEventArgs(cancellationReason, error, errorCode, undefined, sessionId);
            try {
                this.privSpeechRecognizer.canceled(this.privSpeechRecognizer, cancelEvent);
            /* tslint:disable:no-empty */ } catch (_a) {}
        }
        if (!!this.privSuccessCallback) {
            var result = new $iQDnw.SpeechRecognitionResult(requestId, $iQDnw.ResultReason.Canceled, undefined, undefined, undefined, undefined, undefined, undefined, error, undefined, properties);
            try {
                this.privSuccessCallback(result);
                this.privSuccessCallback = undefined;
            /* tslint:disable:no-empty */ } catch (_b) {}
        }
    };
    return SpeechServiceRecognizer;
}($9MAMI.ServiceRecognizerBase);
module.exports.SpeechServiceRecognizer = $087fbbf6be4bf407$var$SpeechServiceRecognizer;

});

parcelRequire.register("9yqU6", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
var $6f4c28947709ace9$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $6f4c28947709ace9$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $6f4c28947709ace9$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TranscriptionServiceRecognizer = void 0;

var $7srwU = parcelRequire("7srwU");

var $iQDnw = parcelRequire("iQDnw");

var $9MAMI = parcelRequire("9MAMI");

var $eqPE4 = parcelRequire("eqPE4");
// tslint:disable-next-line:max-classes-per-file
var $6f4c28947709ace9$var$TranscriptionServiceRecognizer = /** @class */ function(_super) {
    $6f4c28947709ace9$var$__extends(TranscriptionServiceRecognizer, _super);
    function TranscriptionServiceRecognizer(authentication, connectionFactory, audioSource, recognizerConfig, transcriber) {
        var _this = _super.call(this, authentication, connectionFactory, audioSource, recognizerConfig, transcriber) || this;
        _this.sendSpeechEvent = function(connection, payload) {
            var speechEventJson = JSON.stringify(payload);
            if (speechEventJson) return connection.send(new $eqPE4.SpeechConnectionMessage($7srwU.MessageType.Text, "speech.event", _this.privRequestSession.requestId, "application/json", speechEventJson));
            return;
        };
        _this.privTranscriberRecognizer = transcriber;
        _this.sendPrePayloadJSONOverride = _this.sendTranscriptionStartJSON;
        return _this;
    }
    TranscriptionServiceRecognizer.prototype.sendSpeechEventAsync = function(info, command) {
        return $6f4c28947709ace9$var$__awaiter(this, void 0, void 0, function() {
            var connection;
            return $6f4c28947709ace9$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!!!this.privRequestSession.isRecognizing) return [
                            3 /*break*/ ,
                            3
                        ];
                        return [
                            4 /*yield*/ ,
                            this.fetchConnection()
                        ];
                    case 1:
                        connection = _a.sent();
                        return [
                            4 /*yield*/ ,
                            this.sendSpeechEvent(connection, this.createSpeechEventPayload(info, command))
                        ];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    TranscriptionServiceRecognizer.prototype.processTypeSpecificMessages = function(connectionMessage) {
        return $6f4c28947709ace9$var$__awaiter(this, void 0, void 0, function() {
            var result, resultProps, processed, _a, hypothesis, offset, ev, simple, resultReason, cancelReason, detailed, event_1;
            return $6f4c28947709ace9$var$__generator(this, function(_b) {
                switch(_b.label){
                    case 0:
                        resultProps = new $iQDnw.PropertyCollection();
                        resultProps.setProperty($iQDnw.PropertyId.SpeechServiceResponse_JsonResult, connectionMessage.textBody);
                        processed = false;
                        _a = connectionMessage.path.toLowerCase();
                        switch(_a){
                            case "speech.hypothesis":
                                return [
                                    3 /*break*/ ,
                                    1
                                ];
                            case "speech.fragment":
                                return [
                                    3 /*break*/ ,
                                    1
                                ];
                            case "speech.phrase":
                                return [
                                    3 /*break*/ ,
                                    2
                                ];
                        }
                        return [
                            3 /*break*/ ,
                            6
                        ];
                    case 1:
                        hypothesis = $9MAMI.SpeechHypothesis.fromJSON(connectionMessage.textBody);
                        offset = hypothesis.Offset + this.privRequestSession.currentTurnAudioOffset;
                        result = new $iQDnw.SpeechRecognitionResult(this.privRequestSession.requestId, $iQDnw.ResultReason.RecognizingSpeech, hypothesis.Text, hypothesis.Duration, offset, hypothesis.Language, hypothesis.LanguageDetectionConfidence, hypothesis.SpeakerId, undefined, connectionMessage.textBody, resultProps);
                        this.privRequestSession.onHypothesis(offset);
                        ev = new $iQDnw.SpeechRecognitionEventArgs(result, hypothesis.Duration, this.privRequestSession.sessionId);
                        if (!!this.privTranscriberRecognizer.recognizing) try {
                            this.privTranscriberRecognizer.recognizing(this.privTranscriberRecognizer, ev);
                        /* tslint:disable:no-empty */ } catch (error) {
                        // Not going to let errors in the event handler
                        // trip things up.
                        }
                        processed = true;
                        return [
                            3 /*break*/ ,
                            7
                        ];
                    case 2:
                        simple = $9MAMI.SimpleSpeechPhrase.fromJSON(connectionMessage.textBody);
                        resultReason = $9MAMI.EnumTranslation.implTranslateRecognitionResult(simple.RecognitionStatus);
                        this.privRequestSession.onPhraseRecognized(this.privRequestSession.currentTurnAudioOffset + simple.Offset + simple.Duration);
                        if (!($iQDnw.ResultReason.Canceled === resultReason)) return [
                            3 /*break*/ ,
                            4
                        ];
                        cancelReason = $9MAMI.EnumTranslation.implTranslateCancelResult(simple.RecognitionStatus);
                        return [
                            4 /*yield*/ ,
                            this.cancelRecognitionLocal(cancelReason, $9MAMI.EnumTranslation.implTranslateCancelErrorCode(simple.RecognitionStatus), undefined)
                        ];
                    case 3:
                        _b.sent();
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 4:
                        if (!(this.privRequestSession.isSpeechEnded && resultReason === $iQDnw.ResultReason.NoMatch && simple.RecognitionStatus !== $9MAMI.RecognitionStatus.InitialSilenceTimeout)) {
                            if (this.privRecognizerConfig.parameters.getProperty($9MAMI.OutputFormatPropertyName) === $iQDnw.OutputFormat[$iQDnw.OutputFormat.Simple]) result = new $iQDnw.SpeechRecognitionResult(this.privRequestSession.requestId, resultReason, simple.DisplayText, simple.Duration, simple.Offset + this.privRequestSession.currentTurnAudioOffset, simple.Language, simple.LanguageDetectionConfidence, simple.SpeakerId, undefined, connectionMessage.textBody, resultProps);
                            else {
                                detailed = $9MAMI.DetailedSpeechPhrase.fromJSON(connectionMessage.textBody);
                                result = new $iQDnw.SpeechRecognitionResult(this.privRequestSession.requestId, resultReason, detailed.RecognitionStatus === $9MAMI.RecognitionStatus.Success ? detailed.NBest[0].Display : undefined, detailed.Duration, detailed.Offset + this.privRequestSession.currentTurnAudioOffset, detailed.Language, detailed.LanguageDetectionConfidence, undefined, undefined, connectionMessage.textBody, resultProps);
                            }
                            event_1 = new $iQDnw.SpeechRecognitionEventArgs(result, result.offset, this.privRequestSession.sessionId);
                            if (!!this.privTranscriberRecognizer.recognized) try {
                                this.privTranscriberRecognizer.recognized(this.privTranscriberRecognizer, event_1);
                            /* tslint:disable:no-empty */ } catch (error) {
                            // Not going to let errors in the event handler
                            // trip things up.
                            }
                        }
                        if (!!this.privSuccessCallback) {
                            try {
                                this.privSuccessCallback(result);
                            } catch (e) {
                                if (!!this.privErrorCallback) this.privErrorCallback(e);
                            }
                            // Only invoke the call back once.
                            // and if it's successful don't invoke the
                            // error after that.
                            this.privSuccessCallback = undefined;
                            this.privErrorCallback = undefined;
                        }
                        _b.label = 5;
                    case 5:
                        processed = true;
                        return [
                            3 /*break*/ ,
                            7
                        ];
                    case 6:
                        return [
                            3 /*break*/ ,
                            7
                        ];
                    case 7:
                        return [
                            2 /*return*/ ,
                            processed
                        ];
                }
            });
        });
    };
    // Cancels recognition.
    TranscriptionServiceRecognizer.prototype.cancelRecognition = function(sessionId, requestId, cancellationReason, errorCode, error) {
        var properties = new $iQDnw.PropertyCollection();
        properties.setProperty($9MAMI.CancellationErrorCodePropertyName, $iQDnw.CancellationErrorCode[errorCode]);
        if (!!this.privTranscriberRecognizer.canceled) {
            var cancelEvent = new $iQDnw.ConversationTranscriptionCanceledEventArgs(cancellationReason, error, errorCode, undefined, sessionId);
            try {
                this.privTranscriberRecognizer.canceled(this.privTranscriberRecognizer, cancelEvent);
            /* tslint:disable:no-empty */ } catch (_a) {}
        }
        if (!!this.privSuccessCallback) {
            var result = new $iQDnw.SpeechRecognitionResult(requestId, $iQDnw.ResultReason.Canceled, undefined, undefined, undefined, undefined, undefined, undefined, error, undefined, properties);
            try {
                this.privSuccessCallback(result);
                this.privSuccessCallback = undefined;
            /* tslint:disable:no-empty */ } catch (_b) {}
        }
    };
    // Encapsulated for derived service recognizers that need to send additional JSON
    TranscriptionServiceRecognizer.prototype.sendTranscriptionStartJSON = function(connection) {
        return $6f4c28947709ace9$var$__awaiter(this, void 0, void 0, function() {
            var info, payload;
            return $6f4c28947709ace9$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.sendSpeechContext(connection)
                        ];
                    case 1:
                        _a.sent();
                        info = this.privTranscriberRecognizer.getConversationInfo();
                        payload = this.createSpeechEventPayload(info, "start");
                        return [
                            4 /*yield*/ ,
                            this.sendSpeechEvent(connection, payload)
                        ];
                    case 2:
                        _a.sent();
                        return [
                            4 /*yield*/ ,
                            this.sendWaveHeader(connection)
                        ];
                    case 3:
                        _a.sent();
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    TranscriptionServiceRecognizer.prototype.createSpeechEventPayload = function(info, command) {
        var meeting = "meeting";
        var eventDict = {
            id: meeting,
            name: command,
            meeting: info.conversationProperties
        };
        var idString = "id";
        var attendees = "attendees";
        var record = "record";
        eventDict[meeting][idString] = info.id;
        eventDict[meeting][attendees] = info.participants;
        eventDict[meeting][record] = info.conversationProperties.audiorecording === "on" ? "true" : "false";
        return eventDict;
    };
    return TranscriptionServiceRecognizer;
}($9MAMI.ServiceRecognizerBase);
module.exports.TranscriptionServiceRecognizer = $6f4c28947709ace9$var$TranscriptionServiceRecognizer;

});

parcelRequire.register("8F8am", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DetailedSpeechPhrase = void 0;

var $9MAMI = parcelRequire("9MAMI");
var $64e87cb331dda5a9$var$DetailedSpeechPhrase = /** @class */ function() {
    function DetailedSpeechPhrase(json) {
        this.privDetailedSpeechPhrase = JSON.parse(json);
        this.privDetailedSpeechPhrase.RecognitionStatus = $9MAMI.RecognitionStatus[this.privDetailedSpeechPhrase.RecognitionStatus];
    }
    DetailedSpeechPhrase.fromJSON = function(json) {
        return new DetailedSpeechPhrase(json);
    };
    Object.defineProperty(DetailedSpeechPhrase.prototype, "RecognitionStatus", {
        get: function() {
            return this.privDetailedSpeechPhrase.RecognitionStatus;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DetailedSpeechPhrase.prototype, "NBest", {
        get: function() {
            return this.privDetailedSpeechPhrase.NBest;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DetailedSpeechPhrase.prototype, "Duration", {
        get: function() {
            return this.privDetailedSpeechPhrase.Duration;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DetailedSpeechPhrase.prototype, "Offset", {
        get: function() {
            return this.privDetailedSpeechPhrase.Offset;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DetailedSpeechPhrase.prototype, "Language", {
        get: function() {
            return this.privDetailedSpeechPhrase.PrimaryLanguage === undefined ? undefined : this.privDetailedSpeechPhrase.PrimaryLanguage.Language;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DetailedSpeechPhrase.prototype, "LanguageDetectionConfidence", {
        get: function() {
            return this.privDetailedSpeechPhrase.PrimaryLanguage === undefined ? undefined : this.privDetailedSpeechPhrase.PrimaryLanguage.Confidence;
        },
        enumerable: false,
        configurable: true
    });
    return DetailedSpeechPhrase;
}();
module.exports.DetailedSpeechPhrase = $64e87cb331dda5a9$var$DetailedSpeechPhrase;

});

parcelRequire.register("6UY4Q", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SimpleSpeechPhrase = void 0;

var $9MAMI = parcelRequire("9MAMI");
var $50969317472a169a$var$SimpleSpeechPhrase = /** @class */ function() {
    function SimpleSpeechPhrase(json) {
        this.privSimpleSpeechPhrase = JSON.parse(json);
        this.privSimpleSpeechPhrase.RecognitionStatus = $9MAMI.RecognitionStatus[this.privSimpleSpeechPhrase.RecognitionStatus];
    }
    SimpleSpeechPhrase.fromJSON = function(json) {
        return new SimpleSpeechPhrase(json);
    };
    Object.defineProperty(SimpleSpeechPhrase.prototype, "RecognitionStatus", {
        get: function() {
            return this.privSimpleSpeechPhrase.RecognitionStatus;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SimpleSpeechPhrase.prototype, "DisplayText", {
        get: function() {
            return this.privSimpleSpeechPhrase.DisplayText;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SimpleSpeechPhrase.prototype, "Offset", {
        get: function() {
            return this.privSimpleSpeechPhrase.Offset;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SimpleSpeechPhrase.prototype, "Duration", {
        get: function() {
            return this.privSimpleSpeechPhrase.Duration;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SimpleSpeechPhrase.prototype, "Language", {
        get: function() {
            return this.privSimpleSpeechPhrase.PrimaryLanguage === undefined ? undefined : this.privSimpleSpeechPhrase.PrimaryLanguage.Language;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SimpleSpeechPhrase.prototype, "LanguageDetectionConfidence", {
        get: function() {
            return this.privSimpleSpeechPhrase.PrimaryLanguage === undefined ? undefined : this.privSimpleSpeechPhrase.PrimaryLanguage.Confidence;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SimpleSpeechPhrase.prototype, "SpeakerId", {
        get: function() {
            return this.privSimpleSpeechPhrase.SpeakerId;
        },
        enumerable: false,
        configurable: true
    });
    return SimpleSpeechPhrase;
}();
module.exports.SimpleSpeechPhrase = $50969317472a169a$var$SimpleSpeechPhrase;

});

parcelRequire.register("6C40j", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.AddedLmIntent = void 0;
/**
 * @class AddedLmIntent
 */ // tslint:disable-next-line:max-classes-per-file
var $4d0965ce9e05a809$var$AddedLmIntent = /** @class */ function() {
    /**
     * Creates and initializes an instance of this class.
     * @constructor
     * @param modelImpl - The model.
     * @param intentName - The intent name.
     */ function AddedLmIntent(modelImpl, intentName) {
        this.modelImpl = modelImpl;
        this.intentName = intentName;
    }
    return AddedLmIntent;
}();
module.exports.AddedLmIntent = $4d0965ce9e05a809$var$AddedLmIntent;

});

parcelRequire.register("hZJYk", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
var $d19bcb4786070d3f$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $d19bcb4786070d3f$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $d19bcb4786070d3f$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.IntentServiceRecognizer = void 0;

var $7srwU = parcelRequire("7srwU");

var $iQDnw = parcelRequire("iQDnw");

var $9MAMI = parcelRequire("9MAMI");
// tslint:disable-next-line:max-classes-per-file
var $d19bcb4786070d3f$var$IntentServiceRecognizer = /** @class */ function(_super) {
    $d19bcb4786070d3f$var$__extends(IntentServiceRecognizer, _super);
    function IntentServiceRecognizer(authentication, connectionFactory, audioSource, recognizerConfig, recognizer) {
        var _this = _super.call(this, authentication, connectionFactory, audioSource, recognizerConfig, recognizer) || this;
        _this.privIntentRecognizer = recognizer;
        _this.privIntentDataSent = false;
        return _this;
    }
    IntentServiceRecognizer.prototype.setIntents = function(addedIntents, umbrellaIntent) {
        this.privAddedLmIntents = addedIntents;
        this.privUmbrellaIntent = umbrellaIntent;
        this.privIntentDataSent = true;
    };
    IntentServiceRecognizer.prototype.processTypeSpecificMessages = function(connectionMessage) {
        return $d19bcb4786070d3f$var$__awaiter(this, void 0, void 0, function() {
            var result, ev, processed, resultProps, speechHypothesis, simple, sendEvent, intentResponse, addedIntent, intentId, reason, properties;
            var _this = this;
            return $d19bcb4786070d3f$var$__generator(this, function(_a) {
                processed = false;
                resultProps = new $iQDnw.PropertyCollection();
                if (connectionMessage.messageType === $7srwU.MessageType.Text) resultProps.setProperty($iQDnw.PropertyId.SpeechServiceResponse_JsonResult, connectionMessage.textBody);
                switch(connectionMessage.path.toLowerCase()){
                    case "speech.hypothesis":
                        speechHypothesis = $9MAMI.SpeechHypothesis.fromJSON(connectionMessage.textBody);
                        result = new $iQDnw.IntentRecognitionResult(undefined, this.privRequestSession.requestId, $iQDnw.ResultReason.RecognizingIntent, speechHypothesis.Text, speechHypothesis.Duration, speechHypothesis.Offset + this.privRequestSession.currentTurnAudioOffset, speechHypothesis.Language, speechHypothesis.LanguageDetectionConfidence, undefined, connectionMessage.textBody, resultProps);
                        this.privRequestSession.onHypothesis(result.offset);
                        ev = new $iQDnw.IntentRecognitionEventArgs(result, speechHypothesis.Offset + this.privRequestSession.currentTurnAudioOffset, this.privRequestSession.sessionId);
                        if (!!this.privIntentRecognizer.recognizing) try {
                            this.privIntentRecognizer.recognizing(this.privIntentRecognizer, ev);
                        /* tslint:disable:no-empty */ } catch (error) {
                        // Not going to let errors in the event handler
                        // trip things up.
                        }
                        processed = true;
                        break;
                    case "speech.phrase":
                        simple = $9MAMI.SimpleSpeechPhrase.fromJSON(connectionMessage.textBody);
                        result = new $iQDnw.IntentRecognitionResult(undefined, this.privRequestSession.requestId, $9MAMI.EnumTranslation.implTranslateRecognitionResult(simple.RecognitionStatus), simple.DisplayText, simple.Duration, simple.Offset + this.privRequestSession.currentTurnAudioOffset, simple.Language, simple.LanguageDetectionConfidence, undefined, connectionMessage.textBody, resultProps);
                        ev = new $iQDnw.IntentRecognitionEventArgs(result, result.offset, this.privRequestSession.sessionId);
                        sendEvent = function() {
                            if (!!_this.privIntentRecognizer.recognized) try {
                                _this.privIntentRecognizer.recognized(_this.privIntentRecognizer, ev);
                            /* tslint:disable:no-empty */ } catch (error) {
                            // Not going to let errors in the event handler
                            // trip things up.
                            }
                            // report result to promise.
                            if (!!_this.privSuccessCallback) {
                                try {
                                    _this.privSuccessCallback(result);
                                } catch (e) {
                                    if (!!_this.privErrorCallback) _this.privErrorCallback(e);
                                }
                                // Only invoke the call back once.
                                // and if it's successful don't invoke the
                                // error after that.
                                _this.privSuccessCallback = undefined;
                                _this.privErrorCallback = undefined;
                            }
                        };
                        // If intent data was sent, the terminal result for this recognizer is an intent being found.
                        // If no intent data was sent, the terminal event is speech recognition being successful.
                        if (false === this.privIntentDataSent || $iQDnw.ResultReason.NoMatch === ev.result.reason) {
                            // Advance the buffers.
                            this.privRequestSession.onPhraseRecognized(ev.offset + ev.result.duration);
                            sendEvent();
                        } else // Squirrel away the args, when the response event arrives it will build upon them
                        // and then return
                        this.privPendingIntentArgs = ev;
                        processed = true;
                        break;
                    case "response":
                        // Response from LUIS
                        ev = this.privPendingIntentArgs;
                        this.privPendingIntentArgs = undefined;
                        if (undefined === ev) {
                            if ("" === connectionMessage.textBody) // This condition happens if there is nothing but silence in the
                            // audio sent to the service.
                            return [
                                2 /*return*/ 
                            ];
                            // Odd... Not sure this can happen
                            ev = new $iQDnw.IntentRecognitionEventArgs(new $iQDnw.IntentRecognitionResult(), 0 /*TODO*/ , this.privRequestSession.sessionId);
                        }
                        intentResponse = $9MAMI.IntentResponse.fromJSON(connectionMessage.textBody);
                        addedIntent = this.privAddedLmIntents[intentResponse.topScoringIntent.intent];
                        if (this.privUmbrellaIntent !== undefined) addedIntent = this.privUmbrellaIntent;
                        if (null !== intentResponse && addedIntent !== undefined) {
                            intentId = addedIntent.intentName === undefined ? intentResponse.topScoringIntent.intent : addedIntent.intentName;
                            reason = ev.result.reason;
                            if (undefined !== intentId) reason = $iQDnw.ResultReason.RecognizedIntent;
                            properties = undefined !== ev.result.properties ? ev.result.properties : new $iQDnw.PropertyCollection();
                            properties.setProperty($iQDnw.PropertyId.LanguageUnderstandingServiceResponse_JsonResult, connectionMessage.textBody);
                            ev = new $iQDnw.IntentRecognitionEventArgs(new $iQDnw.IntentRecognitionResult(intentId, ev.result.resultId, reason, ev.result.text, ev.result.duration, ev.result.offset, undefined, undefined, ev.result.errorDetails, ev.result.json, properties), ev.offset, ev.sessionId);
                        }
                        this.privRequestSession.onPhraseRecognized(ev.offset + ev.result.duration);
                        if (!!this.privIntentRecognizer.recognized) try {
                            this.privIntentRecognizer.recognized(this.privIntentRecognizer, ev);
                        /* tslint:disable:no-empty */ } catch (error) {
                        // Not going to let errors in the event handler
                        // trip things up.
                        }
                        // report result to promise.
                        if (!!this.privSuccessCallback) {
                            try {
                                this.privSuccessCallback(ev.result);
                            } catch (e) {
                                if (!!this.privErrorCallback) this.privErrorCallback(e);
                            }
                            // Only invoke the call back once.
                            // and if it's successful don't invoke the
                            // error after that.
                            this.privSuccessCallback = undefined;
                            this.privErrorCallback = undefined;
                        }
                        processed = true;
                        break;
                    default:
                        break;
                }
                return [
                    2 /*return*/ ,
                    processed
                ];
            });
        });
    };
    // Cancels recognition.
    IntentServiceRecognizer.prototype.cancelRecognition = function(sessionId, requestId, cancellationReason, errorCode, error) {
        var properties = new $iQDnw.PropertyCollection();
        properties.setProperty($9MAMI.CancellationErrorCodePropertyName, $iQDnw.CancellationErrorCode[errorCode]);
        if (!!this.privIntentRecognizer.canceled) {
            var cancelEvent = new $iQDnw.IntentRecognitionCanceledEventArgs(cancellationReason, error, errorCode, undefined, undefined, sessionId);
            try {
                this.privIntentRecognizer.canceled(this.privIntentRecognizer, cancelEvent);
            /* tslint:disable:no-empty */ } catch (_a) {}
        }
        if (!!this.privSuccessCallback) {
            var result = new $iQDnw.IntentRecognitionResult(undefined, requestId, $iQDnw.ResultReason.Canceled, undefined, undefined, undefined, undefined, undefined, error, undefined, properties);
            try {
                this.privSuccessCallback(result);
                this.privSuccessCallback = undefined;
            /* tslint:disable:no-empty */ } catch (_b) {}
        }
    };
    return IntentServiceRecognizer;
}($9MAMI.ServiceRecognizerBase);
module.exports.IntentServiceRecognizer = $d19bcb4786070d3f$var$IntentServiceRecognizer;

});

parcelRequire.register("hbzRA", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
// response
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.IntentResponse = void 0;
var $c82f486f6958c332$var$IntentResponse = /** @class */ function() {
    function IntentResponse(json) {
        this.privIntentResponse = JSON.parse(json);
    }
    IntentResponse.fromJSON = function(json) {
        return new IntentResponse(json);
    };
    Object.defineProperty(IntentResponse.prototype, "query", {
        get: function() {
            return this.privIntentResponse.query;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IntentResponse.prototype, "topScoringIntent", {
        get: function() {
            return this.privIntentResponse.topScoringIntent;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IntentResponse.prototype, "entities", {
        get: function() {
            return this.privIntentResponse.entities;
        },
        enumerable: false,
        configurable: true
    });
    return IntentResponse;
}();
module.exports.IntentResponse = $c82f486f6958c332$var$IntentResponse;

});

parcelRequire.register("kC0Si", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
var $03df5afbca8a688b$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $03df5afbca8a688b$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RequestSession = void 0;

var $7srwU = parcelRequire("7srwU");

var $kzoIC = parcelRequire("kzoIC");

var $3aP3e = parcelRequire("3aP3e");
var $03df5afbca8a688b$var$RequestSession = /** @class */ function() {
    function RequestSession(audioSourceId) {
        var _this = this;
        this.privIsDisposed = false;
        this.privDetachables = new Array();
        this.privIsAudioNodeDetached = false;
        this.privIsRecognizing = false;
        this.privIsSpeechEnded = false;
        this.privTurnStartAudioOffset = 0;
        this.privLastRecoOffset = 0;
        this.privHypothesisReceived = false;
        this.privBytesSent = 0;
        this.privRecogNumber = 0;
        this.privInTurn = false;
        this.privConnectionAttempts = 0;
        this.onPreConnectionStart = function(authFetchEventId, connectionId) {
            _this.privAuthFetchEventId = authFetchEventId;
            _this.privSessionId = connectionId;
            _this.onEvent(new $kzoIC.ConnectingToServiceEvent(_this.privRequestId, _this.privAuthFetchEventId, _this.privSessionId));
        };
        this.onServiceTurnStartResponse = function() {
            if (!!_this.privTurnDeferral && !!_this.privInTurn) {
                // What? How are we starting a turn with another not done?
                _this.privTurnDeferral.reject("Another turn started before current completed.");
                // Avoid UnhandledPromiseRejection if privTurnDeferral is not being awaited
                /* tslint:disable:no-empty */ _this.privTurnDeferral.promise.then().catch(function() {});
            }
            _this.privInTurn = true;
            _this.privTurnDeferral = new $7srwU.Deferred();
        };
        this.getTelemetry = function() {
            if (_this.privServiceTelemetryListener.hasTelemetry) return _this.privServiceTelemetryListener.getTelemetry();
            else return null;
        };
        this.onEvent = function(event) {
            if (!!_this.privServiceTelemetryListener) _this.privServiceTelemetryListener.onEvent(event);
            $7srwU.Events.instance.onEvent(event);
        };
        this.privAudioSourceId = audioSourceId;
        this.privRequestId = $7srwU.createNoDashGuid();
        this.privAudioNodeId = $7srwU.createNoDashGuid();
        this.privTurnDeferral = new $7srwU.Deferred();
        // We're not in a turn, so resolve.
        this.privTurnDeferral.resolve();
    }
    Object.defineProperty(RequestSession.prototype, "sessionId", {
        get: function() {
            return this.privSessionId;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(RequestSession.prototype, "requestId", {
        get: function() {
            return this.privRequestId;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(RequestSession.prototype, "audioNodeId", {
        get: function() {
            return this.privAudioNodeId;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(RequestSession.prototype, "turnCompletionPromise", {
        get: function() {
            return this.privTurnDeferral.promise;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(RequestSession.prototype, "isSpeechEnded", {
        get: function() {
            return this.privIsSpeechEnded;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(RequestSession.prototype, "isRecognizing", {
        get: function() {
            return this.privIsRecognizing;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(RequestSession.prototype, "currentTurnAudioOffset", {
        get: function() {
            return this.privTurnStartAudioOffset;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(RequestSession.prototype, "recogNumber", {
        get: function() {
            return this.privRecogNumber;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(RequestSession.prototype, "numConnectionAttempts", {
        get: function() {
            return this.privConnectionAttempts;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(RequestSession.prototype, "bytesSent", {
        // The number of bytes sent for the current connection.
        // Counter is reset to 0 each time a connection is established.
        get: function() {
            return this.privBytesSent;
        },
        enumerable: false,
        configurable: true
    });
    RequestSession.prototype.listenForServiceTelemetry = function(eventSource) {
        if (!!this.privServiceTelemetryListener) this.privDetachables.push(eventSource.attachListener(this.privServiceTelemetryListener));
    };
    RequestSession.prototype.startNewRecognition = function() {
        this.privIsSpeechEnded = false;
        this.privIsRecognizing = true;
        this.privTurnStartAudioOffset = 0;
        this.privLastRecoOffset = 0;
        this.privRequestId = $7srwU.createNoDashGuid();
        this.privRecogNumber++;
        this.privServiceTelemetryListener = new $3aP3e.ServiceTelemetryListener(this.privRequestId, this.privAudioSourceId, this.privAudioNodeId);
        this.onEvent(new $kzoIC.RecognitionTriggeredEvent(this.requestId, this.privSessionId, this.privAudioSourceId, this.privAudioNodeId));
    };
    RequestSession.prototype.onAudioSourceAttachCompleted = function(audioNode, isError, error) {
        return $03df5afbca8a688b$var$__awaiter(this, void 0, void 0, function() {
            return $03df5afbca8a688b$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        this.privAudioNode = audioNode;
                        this.privIsAudioNodeDetached = false;
                        if (!isError) return [
                            3 /*break*/ ,
                            2
                        ];
                        return [
                            4 /*yield*/ ,
                            this.onComplete()
                        ];
                    case 1:
                        _a.sent();
                        return [
                            3 /*break*/ ,
                            3
                        ];
                    case 2:
                        this.onEvent(new $kzoIC.ListeningStartedEvent(this.privRequestId, this.privSessionId, this.privAudioSourceId, this.privAudioNodeId));
                        _a.label = 3;
                    case 3:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    RequestSession.prototype.onAuthCompleted = function(isError, error) {
        return $03df5afbca8a688b$var$__awaiter(this, void 0, void 0, function() {
            return $03df5afbca8a688b$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!isError) return [
                            3 /*break*/ ,
                            2
                        ];
                        return [
                            4 /*yield*/ ,
                            this.onComplete()
                        ];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    RequestSession.prototype.onConnectionEstablishCompleted = function(statusCode, reason) {
        return $03df5afbca8a688b$var$__awaiter(this, void 0, void 0, function() {
            return $03df5afbca8a688b$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!(statusCode === 200)) return [
                            3 /*break*/ ,
                            1
                        ];
                        this.onEvent(new $kzoIC.RecognitionStartedEvent(this.requestId, this.privAudioSourceId, this.privAudioNodeId, this.privAuthFetchEventId, this.privSessionId));
                        if (!!this.privAudioNode) this.privAudioNode.replay();
                        this.privTurnStartAudioOffset = this.privLastRecoOffset;
                        this.privBytesSent = 0;
                        return [
                            2 /*return*/ 
                        ];
                    case 1:
                        if (!(statusCode === 403)) return [
                            3 /*break*/ ,
                            3
                        ];
                        return [
                            4 /*yield*/ ,
                            this.onComplete()
                        ];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    RequestSession.prototype.onServiceTurnEndResponse = function(continuousRecognition) {
        return $03df5afbca8a688b$var$__awaiter(this, void 0, void 0, function() {
            return $03df5afbca8a688b$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        this.privTurnDeferral.resolve();
                        if (!(!continuousRecognition || this.isSpeechEnded)) return [
                            3 /*break*/ ,
                            2
                        ];
                        return [
                            4 /*yield*/ ,
                            this.onComplete()
                        ];
                    case 1:
                        _a.sent();
                        this.privInTurn = false;
                        return [
                            3 /*break*/ ,
                            3
                        ];
                    case 2:
                        // Start a new request set.
                        this.privTurnStartAudioOffset = this.privLastRecoOffset;
                        this.privRequestId = $7srwU.createNoDashGuid();
                        this.privAudioNode.replay();
                        _a.label = 3;
                    case 3:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    RequestSession.prototype.onHypothesis = function(offset) {
        if (!this.privHypothesisReceived) {
            this.privHypothesisReceived = true;
            this.privServiceTelemetryListener.hypothesisReceived(this.privAudioNode.findTimeAtOffset(offset));
        }
    };
    RequestSession.prototype.onPhraseRecognized = function(offset) {
        this.privServiceTelemetryListener.phraseReceived(this.privAudioNode.findTimeAtOffset(offset));
        this.onServiceRecognized(offset);
    };
    RequestSession.prototype.onServiceRecognized = function(offset) {
        this.privLastRecoOffset = offset;
        this.privHypothesisReceived = false;
        this.privAudioNode.shrinkBuffers(offset);
        this.privConnectionAttempts = 0;
    };
    RequestSession.prototype.onAudioSent = function(bytesSent) {
        this.privBytesSent += bytesSent;
    };
    RequestSession.prototype.onRetryConnection = function() {
        this.privConnectionAttempts++;
    };
    RequestSession.prototype.dispose = function(error) {
        return $03df5afbca8a688b$var$__awaiter(this, void 0, void 0, function() {
            var _i, _a, detachable;
            return $03df5afbca8a688b$var$__generator(this, function(_b) {
                switch(_b.label){
                    case 0:
                        if (!!this.privIsDisposed) return [
                            3 /*break*/ ,
                            5
                        ];
                        // we should have completed by now. If we did not its an unknown error.
                        this.privIsDisposed = true;
                        _i = 0, _a = this.privDetachables;
                        _b.label = 1;
                    case 1:
                        if (!(_i < _a.length)) return [
                            3 /*break*/ ,
                            4
                        ];
                        detachable = _a[_i];
                        return [
                            4 /*yield*/ ,
                            detachable.detach()
                        ];
                    case 2:
                        _b.sent();
                        _b.label = 3;
                    case 3:
                        _i++;
                        return [
                            3 /*break*/ ,
                            1
                        ];
                    case 4:
                        this.privServiceTelemetryListener.dispose();
                        this.privIsRecognizing = false;
                        _b.label = 5;
                    case 5:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    RequestSession.prototype.onStopRecognizing = function() {
        return $03df5afbca8a688b$var$__awaiter(this, void 0, void 0, function() {
            return $03df5afbca8a688b$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.onComplete()
                        ];
                    case 1:
                        _a.sent();
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    // Should be called with the audioNode for this session has indicated that it is out of speech.
    RequestSession.prototype.onSpeechEnded = function() {
        this.privIsSpeechEnded = true;
    };
    RequestSession.prototype.onComplete = function() {
        return $03df5afbca8a688b$var$__awaiter(this, void 0, void 0, function() {
            return $03df5afbca8a688b$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!!!this.privIsRecognizing) return [
                            3 /*break*/ ,
                            2
                        ];
                        this.privIsRecognizing = false;
                        return [
                            4 /*yield*/ ,
                            this.detachAudioNode()
                        ];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    RequestSession.prototype.detachAudioNode = function() {
        return $03df5afbca8a688b$var$__awaiter(this, void 0, void 0, function() {
            return $03df5afbca8a688b$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!!this.privIsAudioNodeDetached) return [
                            3 /*break*/ ,
                            2
                        ];
                        this.privIsAudioNodeDetached = true;
                        if (!this.privAudioNode) return [
                            3 /*break*/ ,
                            2
                        ];
                        return [
                            4 /*yield*/ ,
                            this.privAudioNode.detach()
                        ];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    return RequestSession;
}();
module.exports.RequestSession = $03df5afbca8a688b$var$RequestSession;

});
parcelRequire.register("3aP3e", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ServiceTelemetryListener = void 0;

var $7srwU = parcelRequire("7srwU");

var $kzoIC = parcelRequire("kzoIC");
var $24f9e7f861361d59$var$ServiceTelemetryListener = /** @class */ function() {
    function ServiceTelemetryListener(requestId, audioSourceId, audioNodeId) {
        var _this = this;
        this.privIsDisposed = false;
        this.privListeningTriggerMetric = null;
        this.privMicMetric = null;
        this.privConnectionEstablishMetric = null;
        this.onEvent = function(e) {
            if (_this.privIsDisposed) return;
            if (e instanceof $kzoIC.RecognitionTriggeredEvent && e.requestId === _this.privRequestId) _this.privListeningTriggerMetric = {
                End: e.eventTime,
                Name: "ListeningTrigger",
                Start: e.eventTime
            };
            if (e instanceof $7srwU.AudioStreamNodeAttachingEvent && e.audioSourceId === _this.privAudioSourceId && e.audioNodeId === _this.privAudioNodeId) _this.privMicStartTime = e.eventTime;
            if (e instanceof $7srwU.AudioStreamNodeAttachedEvent && e.audioSourceId === _this.privAudioSourceId && e.audioNodeId === _this.privAudioNodeId) _this.privMicStartTime = e.eventTime;
            if (e instanceof $7srwU.AudioSourceErrorEvent && e.audioSourceId === _this.privAudioSourceId) {
                if (!_this.privMicMetric) _this.privMicMetric = {
                    End: e.eventTime,
                    Error: e.error,
                    Name: "Microphone",
                    Start: _this.privMicStartTime
                };
            }
            if (e instanceof $7srwU.AudioStreamNodeErrorEvent && e.audioSourceId === _this.privAudioSourceId && e.audioNodeId === _this.privAudioNodeId) {
                if (!_this.privMicMetric) _this.privMicMetric = {
                    End: e.eventTime,
                    Error: e.error,
                    Name: "Microphone",
                    Start: _this.privMicStartTime
                };
            }
            if (e instanceof $7srwU.AudioStreamNodeDetachedEvent && e.audioSourceId === _this.privAudioSourceId && e.audioNodeId === _this.privAudioNodeId) {
                if (!_this.privMicMetric) _this.privMicMetric = {
                    End: e.eventTime,
                    Name: "Microphone",
                    Start: _this.privMicStartTime
                };
            }
            if (e instanceof $kzoIC.ConnectingToServiceEvent && e.requestId === _this.privRequestId) _this.privConnectionId = e.sessionId;
            if (e instanceof $7srwU.ConnectionStartEvent && e.connectionId === _this.privConnectionId) _this.privConnectionStartTime = e.eventTime;
            if (e instanceof $7srwU.ConnectionEstablishedEvent && e.connectionId === _this.privConnectionId) {
                if (!_this.privConnectionEstablishMetric) _this.privConnectionEstablishMetric = {
                    End: e.eventTime,
                    Id: _this.privConnectionId,
                    Name: "Connection",
                    Start: _this.privConnectionStartTime
                };
            }
            if (e instanceof $7srwU.ConnectionEstablishErrorEvent && e.connectionId === _this.privConnectionId) {
                if (!_this.privConnectionEstablishMetric) _this.privConnectionEstablishMetric = {
                    End: e.eventTime,
                    Error: _this.getConnectionError(e.statusCode),
                    Id: _this.privConnectionId,
                    Name: "Connection",
                    Start: _this.privConnectionStartTime
                };
            }
            if (e instanceof $7srwU.ConnectionMessageReceivedEvent && e.connectionId === _this.privConnectionId) {
                if (e.message && e.message.headers && e.message.headers.path) {
                    if (!_this.privReceivedMessages[e.message.headers.path]) _this.privReceivedMessages[e.message.headers.path] = new Array();
                    _this.privReceivedMessages[e.message.headers.path].push(e.networkReceivedTime);
                }
            }
        };
        this.getTelemetry = function() {
            var metrics = new Array();
            if (_this.privListeningTriggerMetric) metrics.push(_this.privListeningTriggerMetric);
            if (_this.privMicMetric) metrics.push(_this.privMicMetric);
            if (_this.privConnectionEstablishMetric) metrics.push(_this.privConnectionEstablishMetric);
            if (_this.privPhraseLatencies.length > 0) metrics.push({
                PhraseLatencyMs: _this.privPhraseLatencies
            });
            if (_this.privHypothesisLatencies.length > 0) metrics.push({
                FirstHypothesisLatencyMs: _this.privHypothesisLatencies
            });
            var telemetry = {
                Metrics: metrics,
                ReceivedMessages: _this.privReceivedMessages
            };
            var json = JSON.stringify(telemetry);
            // We dont want to send the same telemetry again. So clean those out.
            _this.privReceivedMessages = {};
            _this.privListeningTriggerMetric = null;
            _this.privMicMetric = null;
            _this.privConnectionEstablishMetric = null;
            _this.privPhraseLatencies = [];
            _this.privHypothesisLatencies = [];
            return json;
        };
        this.dispose = function() {
            _this.privIsDisposed = true;
        };
        this.getConnectionError = function(statusCode) {
            /*
            -- Websocket status codes --
            NormalClosure = 1000,
            EndpointUnavailable = 1001,
            ProtocolError = 1002,
            InvalidMessageType = 1003,
            Empty = 1005,
            InvalidPayloadData = 1007,
            PolicyViolation = 1008,
            MessageTooBig = 1009,
            MandatoryExtension = 1010,
            InternalServerError = 1011
            */ switch(statusCode){
                case 400:
                case 1002:
                case 1003:
                case 1005:
                case 1007:
                case 1008:
                case 1009:
                    return "BadRequest";
                case 401:
                    return "Unauthorized";
                case 403:
                    return "Forbidden";
                case 503:
                case 1001:
                    return "ServerUnavailable";
                case 500:
                case 1011:
                    return "ServerError";
                case 408:
                case 504:
                    return "Timeout";
                default:
                    return "statuscode:" + statusCode.toString();
            }
        };
        this.privRequestId = requestId;
        this.privAudioSourceId = audioSourceId;
        this.privAudioNodeId = audioNodeId;
        this.privReceivedMessages = {};
        this.privPhraseLatencies = [];
        this.privHypothesisLatencies = [];
    }
    ServiceTelemetryListener.prototype.phraseReceived = function(audioReceivedTime) {
        if (audioReceivedTime > 0) this.privPhraseLatencies.push(Date.now() - audioReceivedTime);
    };
    ServiceTelemetryListener.prototype.hypothesisReceived = function(audioReceivedTime) {
        if (audioReceivedTime > 0) this.privHypothesisLatencies.push(Date.now() - audioReceivedTime);
    };
    Object.defineProperty(ServiceTelemetryListener.prototype, "hasTelemetry", {
        // Determines if there are any telemetry events to send to the service.
        get: function() {
            return Object.keys(this.privReceivedMessages).length !== 0 || this.privListeningTriggerMetric !== null || this.privMicMetric !== null || this.privConnectionEstablishMetric !== null || this.privPhraseLatencies.length !== 0 || this.privHypothesisLatencies.length !== 0;
        },
        enumerable: false,
        configurable: true
    });
    return ServiceTelemetryListener;
}();
module.exports.ServiceTelemetryListener = $24f9e7f861361d59$var$ServiceTelemetryListener;

});


parcelRequire.register("9VrPQ", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SpeechContext = void 0;
/**
 * Represents the JSON used in the speech.context message sent to the speech service.
 * The dynamic grammar is always refreshed from the encapsulated dynamic grammar object.
 */ var $739f076660823523$var$SpeechContext = /** @class */ function() {
    function SpeechContext(dynamicGrammar) {
        this.privContext = {};
        this.privDynamicGrammar = dynamicGrammar;
    }
    /**
     * Adds a section to the speech.context object.
     * @param sectionName Name of the section to add.
     * @param value JSON serializable object that represents the value.
     */ SpeechContext.prototype.setSection = function(sectionName, value) {
        this.privContext[sectionName] = value;
    };
    /**
     * @Internal
     * This is only used by pronunciation assessment config.
     * Do not use externally, object returned will change without warning or notice.
     */ SpeechContext.prototype.setPronunciationAssessmentParams = function(params) {
        if (this.privContext.phraseDetection === undefined) this.privContext.phraseDetection = {
            enrichment: {
                pronunciationAssessment: {}
            }
        };
        this.privContext.phraseDetection.enrichment.pronunciationAssessment = JSON.parse(params);
        if (this.privContext.phraseOutput === undefined) this.privContext.phraseOutput = {
            detailed: {
                options: []
            },
            format: {}
        };
        this.privContext.phraseOutput.format = "Detailed";
        this.privContext.phraseOutput.detailed.options.push("PronunciationAssessment");
        if (this.privContext.phraseOutput.detailed.options.indexOf("WordTimings") === -1) this.privContext.phraseOutput.detailed.options.push("WordTimings");
    };
    SpeechContext.prototype.toJSON = function() {
        var dgi = this.privDynamicGrammar.generateGrammarObject();
        this.setSection("dgi", dgi);
        var ret = JSON.stringify(this.privContext);
        return ret;
    };
    return SpeechContext;
}();
module.exports.SpeechContext = $739f076660823523$var$SpeechContext;

});

parcelRequire.register("6u0OP", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DynamicGrammarBuilder = void 0;
/**
 * Responsible for building the object to be sent to the speech service to support dynamic grammars.
 * @class DynamicGrammarBuilder
 */ var $4b862dffe48cbbf0$var$DynamicGrammarBuilder = /** @class */ function() {
    function DynamicGrammarBuilder() {}
    // Adds one more reference phrases to the dynamic grammar to send.
    // All added phrases are generic phrases.
    DynamicGrammarBuilder.prototype.addPhrase = function(phrase) {
        if (!this.privPhrases) this.privPhrases = [];
        if (phrase instanceof Array) this.privPhrases = this.privPhrases.concat(phrase);
        else this.privPhrases.push(phrase);
    };
    // Clears all phrases stored in the current object.
    DynamicGrammarBuilder.prototype.clearPhrases = function() {
        this.privPhrases = undefined;
    };
    // Adds one or more reference grammars to the current grammar.
    DynamicGrammarBuilder.prototype.addReferenceGrammar = function(grammar) {
        if (!this.privGrammars) this.privGrammars = [];
        if (grammar instanceof Array) this.privGrammars = this.privGrammars.concat(grammar);
        else this.privGrammars.push(grammar);
    };
    // clears all grammars stored on the recognizer.
    DynamicGrammarBuilder.prototype.clearGrammars = function() {
        this.privGrammars = undefined;
    };
    // Generates an object that represents the dynamic grammar used by the Speech Service.
    // This is done by building an object with the correct layout based on the phrases and reference grammars added to this instance
    // of a DynamicGrammarBuilder
    DynamicGrammarBuilder.prototype.generateGrammarObject = function() {
        if (this.privGrammars === undefined && this.privPhrases === undefined) return undefined;
        var retObj = {};
        retObj.ReferenceGrammars = this.privGrammars;
        if (undefined !== this.privPhrases && 0 !== this.privPhrases.length) {
            var retPhrases_1 = [];
            this.privPhrases.forEach(function(value, index, array) {
                retPhrases_1.push({
                    Text: value
                });
            });
            retObj.Groups = [
                {
                    Type: "Generic",
                    Items: retPhrases_1
                }
            ];
        }
        return retObj;
    };
    return DynamicGrammarBuilder;
}();
module.exports.DynamicGrammarBuilder = $4b862dffe48cbbf0$var$DynamicGrammarBuilder;

});

parcelRequire.register("d7WUt", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRequire.register("kW11K", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
var $f3da0566e1737ae2$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $f3da0566e1737ae2$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $f3da0566e1737ae2$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DialogServiceAdapter = void 0;

var $9h4kO = parcelRequire("9h4kO");

var $cf3Wp = parcelRequire("cf3Wp");

var $7srwU = parcelRequire("7srwU");

var $gU3rQ = parcelRequire("gU3rQ");

var $iQDnw = parcelRequire("iQDnw");

var $3IGXt = parcelRequire("3IGXt");

var $9MAMI = parcelRequire("9MAMI");

var $dizhq = parcelRequire("dizhq");

var $eqPE4 = parcelRequire("eqPE4");
var $f3da0566e1737ae2$var$DialogServiceAdapter = /** @class */ function(_super) {
    $f3da0566e1737ae2$var$__extends(DialogServiceAdapter, _super);
    function DialogServiceAdapter(authentication, connectionFactory, audioSource, recognizerConfig, dialogServiceConnector) {
        var _this = _super.call(this, authentication, connectionFactory, audioSource, recognizerConfig, dialogServiceConnector) || this;
        _this.sendAgentConfig = function(connection) {
            if (_this.agentConfig && !_this.agentConfigSent) {
                if (_this.privRecognizerConfig.parameters.getProperty($iQDnw.PropertyId.Conversation_DialogType) === $iQDnw.DialogServiceConfig.DialogTypes.CustomCommands) {
                    var config = _this.agentConfig.get();
                    config.botInfo.commandsCulture = _this.privRecognizerConfig.parameters.getProperty($iQDnw.PropertyId.SpeechServiceConnection_RecoLanguage, "en-us");
                    _this.agentConfig.set(config);
                }
                _this.onEvent(new $cf3Wp.SendingAgentContextMessageEvent(_this.agentConfig));
                var agentConfigJson = _this.agentConfig.toJsonString();
                // guard against sending this multiple times on one connection
                _this.agentConfigSent = true;
                return connection.send(new $eqPE4.SpeechConnectionMessage($7srwU.MessageType.Text, "agent.config", _this.privRequestSession.requestId, "application/json", agentConfigJson));
            }
            return;
        };
        _this.sendAgentContext = function(connection) {
            var guid = $7srwU.createGuid();
            var speechActivityTemplate = _this.privDialogServiceConnector.properties.getProperty($iQDnw.PropertyId.Conversation_Speech_Activity_Template);
            var agentContext = {
                channelData: "",
                context: {
                    interactionId: guid
                },
                messagePayload: speechActivityTemplate,
                version: 0.5
            };
            var agentContextJson = JSON.stringify(agentContext);
            return connection.send(new $eqPE4.SpeechConnectionMessage($7srwU.MessageType.Text, "speech.agent.context", _this.privRequestSession.requestId, "application/json", agentContextJson));
        };
        _this.handleResponseMessage = function(responseMessage) {
            // "response" messages can contain either "message" (activity) or "MessageStatus" data. Fire the appropriate
            // event according to the message type that's specified.
            var responsePayload = JSON.parse(responseMessage.textBody);
            switch(responsePayload.messageType.toLowerCase()){
                case "message":
                    var responseRequestId = responseMessage.requestId.toUpperCase();
                    var activityPayload = $dizhq.ActivityPayloadResponse.fromJSON(responseMessage.textBody);
                    var turn = _this.privTurnStateManager.GetTurn(responseRequestId);
                    // update the conversation Id
                    if (activityPayload.conversationId) {
                        var updateAgentConfig = _this.agentConfig.get();
                        updateAgentConfig.botInfo.conversationId = activityPayload.conversationId;
                        _this.agentConfig.set(updateAgentConfig);
                    }
                    var pullAudioOutputStream = turn.processActivityPayload(activityPayload, $gU3rQ.AudioOutputFormatImpl.fromSpeechSynthesisOutputFormatString(_this.privDialogServiceConnector.properties.getProperty($iQDnw.PropertyId.SpeechServiceConnection_SynthOutputFormat, undefined)));
                    var activity = new $iQDnw.ActivityReceivedEventArgs(activityPayload.messagePayload, pullAudioOutputStream);
                    if (!!_this.privDialogServiceConnector.activityReceived) try {
                        _this.privDialogServiceConnector.activityReceived(_this.privDialogServiceConnector, activity);
                    /* tslint:disable:no-empty */ } catch (error) {
                    // Not going to let errors in the event handler
                    // trip things up.
                    }
                    break;
                case "messagestatus":
                    if (!!_this.privDialogServiceConnector.turnStatusReceived) try {
                        _this.privDialogServiceConnector.turnStatusReceived(_this.privDialogServiceConnector, new $iQDnw.TurnStatusReceivedEventArgs(responseMessage.textBody));
                    /* tslint:disable:no-empty */ } catch (error) {
                    // Not going to let errors in the event handler
                    // trip things up.
                    }
                    break;
                default:
                    $7srwU.Events.instance.onEvent(new $7srwU.BackgroundEvent("Unexpected response of type " + responsePayload.messageType + ". Ignoring."));
                    break;
            }
        };
        _this.privEvents = new $7srwU.EventSource();
        _this.privDialogServiceConnector = dialogServiceConnector;
        _this.receiveMessageOverride = _this.receiveDialogMessageOverride;
        _this.privTurnStateManager = new $3IGXt.DialogServiceTurnStateManager();
        _this.recognizeOverride = _this.listenOnce;
        _this.postConnectImplOverride = _this.dialogConnectImpl;
        _this.configConnectionOverride = _this.configConnection;
        _this.disconnectOverride = _this.privDisconnect;
        _this.privDialogAudioSource = audioSource;
        _this.agentConfigSent = false;
        _this.privLastResult = null;
        _this.connectionEvents.attach(function(connectionEvent) {
            return $f3da0566e1737ae2$var$__awaiter(_this, void 0, void 0, function() {
                return $f3da0566e1737ae2$var$__generator(this, function(_a) {
                    if (connectionEvent.name === "ConnectionClosedEvent") this.terminateMessageLoop = true;
                    return [
                        2 /*return*/ 
                    ];
                });
            });
        });
        return _this;
    }
    DialogServiceAdapter.prototype.sendMessage = function(message) {
        return $f3da0566e1737ae2$var$__awaiter(this, void 0, void 0, function() {
            var interactionGuid, requestId, agentMessage, agentMessageJson, connection;
            return $f3da0566e1737ae2$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        interactionGuid = $7srwU.createGuid();
                        requestId = $7srwU.createNoDashGuid();
                        agentMessage = {
                            context: {
                                interactionId: interactionGuid
                            },
                            messagePayload: JSON.parse(message),
                            version: 0.5
                        };
                        agentMessageJson = JSON.stringify(agentMessage);
                        return [
                            4 /*yield*/ ,
                            this.fetchConnection()
                        ];
                    case 1:
                        connection = _a.sent();
                        return [
                            4 /*yield*/ ,
                            connection.send(new $eqPE4.SpeechConnectionMessage($7srwU.MessageType.Text, "agent", requestId, "application/json", agentMessageJson))
                        ];
                    case 2:
                        _a.sent();
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    DialogServiceAdapter.prototype.privDisconnect = function() {
        return $f3da0566e1737ae2$var$__awaiter(this, void 0, void 0, function() {
            return $f3da0566e1737ae2$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.cancelRecognition(this.privRequestSession.sessionId, this.privRequestSession.requestId, $iQDnw.CancellationReason.Error, $iQDnw.CancellationErrorCode.NoError, "Disconnecting")
                        ];
                    case 1:
                        _a.sent();
                        this.terminateMessageLoop = true;
                        this.agentConfigSent = false;
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    DialogServiceAdapter.prototype.processTypeSpecificMessages = function(connectionMessage) {
        return $f3da0566e1737ae2$var$__awaiter(this, void 0, void 0, function() {
            var resultProps, result, processed, speechPhrase, args, hypothesis, offset, ev, keyword, event_1, audioRequestId, turn;
            return $f3da0566e1737ae2$var$__generator(this, function(_a) {
                resultProps = new $iQDnw.PropertyCollection();
                if (connectionMessage.messageType === $7srwU.MessageType.Text) resultProps.setProperty($iQDnw.PropertyId.SpeechServiceResponse_JsonResult, connectionMessage.textBody);
                switch(connectionMessage.path.toLowerCase()){
                    case "speech.phrase":
                        speechPhrase = $9MAMI.SimpleSpeechPhrase.fromJSON(connectionMessage.textBody);
                        this.privRequestSession.onPhraseRecognized(this.privRequestSession.currentTurnAudioOffset + speechPhrase.Offset + speechPhrase.Duration);
                        if (speechPhrase.RecognitionStatus !== $9MAMI.RecognitionStatus.TooManyRequests && speechPhrase.RecognitionStatus !== $9MAMI.RecognitionStatus.Error) {
                            args = this.fireEventForResult(speechPhrase, resultProps);
                            this.privLastResult = args.result;
                            if (!!this.privDialogServiceConnector.recognized) try {
                                this.privDialogServiceConnector.recognized(this.privDialogServiceConnector, args);
                            /* tslint:disable:no-empty */ } catch (error) {
                            // Not going to let errors in the event handler
                            // trip things up.
                            }
                        }
                        processed = true;
                        break;
                    case "speech.hypothesis":
                        hypothesis = $9MAMI.SpeechHypothesis.fromJSON(connectionMessage.textBody);
                        offset = hypothesis.Offset + this.privRequestSession.currentTurnAudioOffset;
                        result = new $iQDnw.SpeechRecognitionResult(this.privRequestSession.requestId, $iQDnw.ResultReason.RecognizingSpeech, hypothesis.Text, hypothesis.Duration, offset, hypothesis.Language, hypothesis.LanguageDetectionConfidence, undefined, undefined, connectionMessage.textBody, resultProps);
                        this.privRequestSession.onHypothesis(offset);
                        ev = new $iQDnw.SpeechRecognitionEventArgs(result, hypothesis.Duration, this.privRequestSession.sessionId);
                        if (!!this.privDialogServiceConnector.recognizing) try {
                            this.privDialogServiceConnector.recognizing(this.privDialogServiceConnector, ev);
                        /* tslint:disable:no-empty */ } catch (error) {
                        // Not going to let errors in the event handler
                        // trip things up.
                        }
                        processed = true;
                        break;
                    case "speech.keyword":
                        keyword = $9MAMI.SpeechKeyword.fromJSON(connectionMessage.textBody);
                        result = new $iQDnw.SpeechRecognitionResult(this.privRequestSession.requestId, keyword.Status === "Accepted" ? $iQDnw.ResultReason.RecognizedKeyword : $iQDnw.ResultReason.NoMatch, keyword.Text, keyword.Duration, keyword.Offset, undefined, undefined, undefined, undefined, connectionMessage.textBody, resultProps);
                        if (keyword.Status !== "Accepted") this.privLastResult = result;
                        event_1 = new $iQDnw.SpeechRecognitionEventArgs(result, result.duration, result.resultId);
                        if (!!this.privDialogServiceConnector.recognized) try {
                            this.privDialogServiceConnector.recognized(this.privDialogServiceConnector, event_1);
                        /* tslint:disable:no-empty */ } catch (error) {
                        // Not going to let errors in the event handler
                        // trip things up.
                        }
                        processed = true;
                        break;
                    case "audio":
                        audioRequestId = connectionMessage.requestId.toUpperCase();
                        turn = this.privTurnStateManager.GetTurn(audioRequestId);
                        try {
                            // Empty binary message signals end of stream.
                            if (!connectionMessage.binaryBody) turn.endAudioStream();
                            else turn.audioStream.write(connectionMessage.binaryBody);
                        } catch (error) {
                        // Not going to let errors in the event handler
                        // trip things up.
                        }
                        processed = true;
                        break;
                    case "response":
                        this.handleResponseMessage(connectionMessage);
                        processed = true;
                        break;
                    default:
                        break;
                }
                return [
                    2 /*return*/ ,
                    processed
                ];
            });
        });
    };
    // Cancels recognition.
    DialogServiceAdapter.prototype.cancelRecognition = function(sessionId, requestId, cancellationReason, errorCode, error) {
        return $f3da0566e1737ae2$var$__awaiter(this, void 0, void 0, function() {
            var properties, cancelEvent, result;
            return $f3da0566e1737ae2$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        this.terminateMessageLoop = true;
                        if (!!!this.privRequestSession.isRecognizing) return [
                            3 /*break*/ ,
                            2
                        ];
                        return [
                            4 /*yield*/ ,
                            this.privRequestSession.onStopRecognizing()
                        ];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        if (!!this.privDialogServiceConnector.canceled) {
                            properties = new $iQDnw.PropertyCollection();
                            properties.setProperty($9MAMI.CancellationErrorCodePropertyName, $iQDnw.CancellationErrorCode[errorCode]);
                            cancelEvent = new $iQDnw.SpeechRecognitionCanceledEventArgs(cancellationReason, error, errorCode, undefined, sessionId);
                            try {
                                this.privDialogServiceConnector.canceled(this.privDialogServiceConnector, cancelEvent);
                            /* tslint:disable:no-empty */ } catch (_b) {}
                            if (!!this.privSuccessCallback) {
                                result = new $iQDnw.SpeechRecognitionResult(undefined, $iQDnw.ResultReason.Canceled, undefined, undefined, undefined, undefined, undefined, undefined, error, undefined, properties);
                                try {
                                    this.privSuccessCallback(result);
                                    this.privSuccessCallback = undefined;
                                /* tslint:disable:no-empty */ } catch (_c) {}
                            }
                        }
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    DialogServiceAdapter.prototype.listenOnce = function(recoMode, successCallback, errorCallback) {
        return $f3da0566e1737ae2$var$__awaiter(this, void 0, void 0, function() {
            var conPromise, preAudioPromise, node, format, deviceInfo, audioNode, error_1, sessionStartEventArgs, audioSendPromise;
            var _this = this;
            return $f3da0566e1737ae2$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        this.privRecognizerConfig.recognitionMode = recoMode;
                        this.privSuccessCallback = successCallback;
                        this.privErrorCallback = errorCallback;
                        this.privRequestSession.startNewRecognition();
                        this.privRequestSession.listenForServiceTelemetry(this.privDialogAudioSource.events);
                        this.privRecognizerConfig.parameters.setProperty($iQDnw.PropertyId.Speech_SessionId, this.privRequestSession.sessionId);
                        conPromise = this.connectImpl();
                        preAudioPromise = this.sendPreAudioMessages();
                        return [
                            4 /*yield*/ ,
                            this.privDialogAudioSource.attach(this.privRequestSession.audioNodeId)
                        ];
                    case 1:
                        node = _a.sent();
                        return [
                            4 /*yield*/ ,
                            this.privDialogAudioSource.format
                        ];
                    case 2:
                        format = _a.sent();
                        return [
                            4 /*yield*/ ,
                            this.privDialogAudioSource.deviceInfo
                        ];
                    case 3:
                        deviceInfo = _a.sent();
                        audioNode = new $9h4kO.ReplayableAudioNode(node, format.avgBytesPerSec);
                        return [
                            4 /*yield*/ ,
                            this.privRequestSession.onAudioSourceAttachCompleted(audioNode, false)
                        ];
                    case 4:
                        _a.sent();
                        this.privRecognizerConfig.SpeechServiceConfig.Context.audio = {
                            source: deviceInfo
                        };
                        _a.label = 5;
                    case 5:
                        _a.trys.push([
                            5,
                            8,
                            ,
                            10
                        ]);
                        return [
                            4 /*yield*/ ,
                            conPromise
                        ];
                    case 6:
                        _a.sent();
                        return [
                            4 /*yield*/ ,
                            preAudioPromise
                        ];
                    case 7:
                        _a.sent();
                        return [
                            3 /*break*/ ,
                            10
                        ];
                    case 8:
                        error_1 = _a.sent();
                        return [
                            4 /*yield*/ ,
                            this.cancelRecognition(this.privRequestSession.sessionId, this.privRequestSession.requestId, $iQDnw.CancellationReason.Error, $iQDnw.CancellationErrorCode.ConnectionFailure, error_1)
                        ];
                    case 9:
                        _a.sent();
                        return [
                            2 /*return*/ ,
                            Promise.resolve()
                        ];
                    case 10:
                        sessionStartEventArgs = new $iQDnw.SessionEventArgs(this.privRequestSession.sessionId);
                        if (!!this.privRecognizer.sessionStarted) this.privRecognizer.sessionStarted(this.privRecognizer, sessionStartEventArgs);
                        audioSendPromise = this.sendAudio(audioNode);
                        // /* tslint:disable:no-empty */
                        audioSendPromise.then(function() {}, function(error) {
                            return $f3da0566e1737ae2$var$__awaiter(_this, void 0, void 0, function() {
                                return $f3da0566e1737ae2$var$__generator(this, function(_a) {
                                    switch(_a.label){
                                        case 0:
                                            return [
                                                4 /*yield*/ ,
                                                this.cancelRecognition(this.privRequestSession.sessionId, this.privRequestSession.requestId, $iQDnw.CancellationReason.Error, $iQDnw.CancellationErrorCode.RuntimeError, error)
                                            ];
                                        case 1:
                                            _a.sent();
                                            return [
                                                2 /*return*/ 
                                            ];
                                    }
                                });
                            });
                        });
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    // Establishes a websocket connection to the end point.
    DialogServiceAdapter.prototype.dialogConnectImpl = function(connection) {
        this.privConnectionLoop = this.startMessageLoop();
        return connection;
    };
    DialogServiceAdapter.prototype.receiveDialogMessageOverride = function() {
        var _this = this;
        // we won't rely on the cascading promises of the connection since we want to continually be available to receive messages
        var communicationCustodian = new $7srwU.Deferred();
        var loop = function() {
            return $f3da0566e1737ae2$var$__awaiter(_this, void 0, void 0, function() {
                var isDisposed, terminateMessageLoop, connection, message, connectionMessage, _a, turnRequestId, audioSessionReqId, speechStartDetected, speechStartEventArgs, json, speechStopDetected, speechStopEventArgs, turnEndRequestId, audioSessionReqId, sessionStopEventArgs, ret, error_2;
                return $f3da0566e1737ae2$var$__generator(this, function(_b) {
                    switch(_b.label){
                        case 0:
                            _b.trys.push([
                                0,
                                12,
                                ,
                                13
                            ]);
                            isDisposed = this.isDisposed();
                            terminateMessageLoop = !this.isDisposed() && this.terminateMessageLoop;
                            if (isDisposed || terminateMessageLoop) {
                                // We're done.
                                communicationCustodian.resolve(undefined);
                                return [
                                    2 /*return*/ 
                                ];
                            }
                            return [
                                4 /*yield*/ ,
                                this.fetchConnection()
                            ];
                        case 1:
                            connection = _b.sent();
                            return [
                                4 /*yield*/ ,
                                connection.read()
                            ];
                        case 2:
                            message = _b.sent();
                            if (!message) return [
                                2 /*return*/ ,
                                loop()
                            ];
                            connectionMessage = $eqPE4.SpeechConnectionMessage.fromConnectionMessage(message);
                            _a = connectionMessage.path.toLowerCase();
                            switch(_a){
                                case "turn.start":
                                    return [
                                        3 /*break*/ ,
                                        3
                                    ];
                                case "speech.startdetected":
                                    return [
                                        3 /*break*/ ,
                                        4
                                    ];
                                case "speech.enddetected":
                                    return [
                                        3 /*break*/ ,
                                        5
                                    ];
                                case "turn.end":
                                    return [
                                        3 /*break*/ ,
                                        6
                                    ];
                            }
                            return [
                                3 /*break*/ ,
                                10
                            ];
                        case 3:
                            turnRequestId = connectionMessage.requestId.toUpperCase();
                            audioSessionReqId = this.privRequestSession.requestId.toUpperCase();
                            // turn started by the service
                            if (turnRequestId !== audioSessionReqId) this.privTurnStateManager.StartTurn(turnRequestId);
                            else this.privRequestSession.onServiceTurnStartResponse();
                            return [
                                3 /*break*/ ,
                                11
                            ];
                        case 4:
                            speechStartDetected = $9MAMI.SpeechDetected.fromJSON(connectionMessage.textBody);
                            speechStartEventArgs = new $iQDnw.RecognitionEventArgs(speechStartDetected.Offset, this.privRequestSession.sessionId);
                            if (!!this.privRecognizer.speechStartDetected) this.privRecognizer.speechStartDetected(this.privRecognizer, speechStartEventArgs);
                            return [
                                3 /*break*/ ,
                                11
                            ];
                        case 5:
                            json = void 0;
                            if (connectionMessage.textBody.length > 0) json = connectionMessage.textBody;
                            else // If the request was empty, the JSON returned is empty.
                            json = "{ Offset: 0 }";
                            speechStopDetected = $9MAMI.SpeechDetected.fromJSON(json);
                            this.privRequestSession.onServiceRecognized(speechStopDetected.Offset + this.privRequestSession.currentTurnAudioOffset);
                            speechStopEventArgs = new $iQDnw.RecognitionEventArgs(speechStopDetected.Offset + this.privRequestSession.currentTurnAudioOffset, this.privRequestSession.sessionId);
                            if (!!this.privRecognizer.speechEndDetected) this.privRecognizer.speechEndDetected(this.privRecognizer, speechStopEventArgs);
                            return [
                                3 /*break*/ ,
                                11
                            ];
                        case 6:
                            turnEndRequestId = connectionMessage.requestId.toUpperCase();
                            audioSessionReqId = this.privRequestSession.requestId.toUpperCase();
                            if (!(turnEndRequestId !== audioSessionReqId)) return [
                                3 /*break*/ ,
                                7
                            ];
                            this.privTurnStateManager.CompleteTurn(turnEndRequestId);
                            return [
                                3 /*break*/ ,
                                9
                            ];
                        case 7:
                            sessionStopEventArgs = new $iQDnw.SessionEventArgs(this.privRequestSession.sessionId);
                            return [
                                4 /*yield*/ ,
                                this.privRequestSession.onServiceTurnEndResponse(false)
                            ];
                        case 8:
                            _b.sent();
                            if (!this.privRecognizerConfig.isContinuousRecognition || this.privRequestSession.isSpeechEnded || !this.privRequestSession.isRecognizing) {
                                if (!!this.privRecognizer.sessionStopped) this.privRecognizer.sessionStopped(this.privRecognizer, sessionStopEventArgs);
                            }
                            // report result to promise.
                            if (!!this.privSuccessCallback && this.privLastResult) {
                                try {
                                    this.privSuccessCallback(this.privLastResult);
                                    this.privLastResult = null;
                                } catch (e) {
                                    if (!!this.privErrorCallback) this.privErrorCallback(e);
                                }
                                // Only invoke the call back once.
                                // and if it's successful don't invoke the
                                // error after that.
                                this.privSuccessCallback = undefined;
                                this.privErrorCallback = undefined;
                            }
                            _b.label = 9;
                        case 9:
                            return [
                                3 /*break*/ ,
                                11
                            ];
                        case 10:
                            if (!this.processTypeSpecificMessages(connectionMessage)) {
                                if (!!this.serviceEvents) this.serviceEvents.onEvent(new $7srwU.ServiceEvent(connectionMessage.path.toLowerCase(), connectionMessage.textBody));
                            }
                            _b.label = 11;
                        case 11:
                            ret = loop();
                            return [
                                2 /*return*/ ,
                                ret
                            ];
                        case 12:
                            error_2 = _b.sent();
                            this.terminateMessageLoop = true;
                            communicationCustodian.resolve();
                            return [
                                3 /*break*/ ,
                                13
                            ];
                        case 13:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        loop().catch(function(reason) {
            $7srwU.Events.instance.onEvent(new $7srwU.BackgroundEvent(reason));
        });
        return communicationCustodian.promise;
    };
    DialogServiceAdapter.prototype.startMessageLoop = function() {
        return $f3da0566e1737ae2$var$__awaiter(this, void 0, void 0, function() {
            var error_3;
            return $f3da0566e1737ae2$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        this.terminateMessageLoop = false;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([
                            1,
                            3,
                            ,
                            5
                        ]);
                        return [
                            4 /*yield*/ ,
                            this.receiveDialogMessageOverride()
                        ];
                    case 2:
                        _a.sent();
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 3:
                        error_3 = _a.sent();
                        return [
                            4 /*yield*/ ,
                            this.cancelRecognition(this.privRequestSession.sessionId, this.privRequestSession.requestId, $iQDnw.CancellationReason.Error, $iQDnw.CancellationErrorCode.RuntimeError, error_3)
                        ];
                    case 4:
                        _a.sent();
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 5:
                        return [
                            2 /*return*/ ,
                            Promise.resolve()
                        ];
                }
            });
        });
    };
    // Takes an established websocket connection to the endpoint and sends speech configuration information.
    DialogServiceAdapter.prototype.configConnection = function(connection) {
        return $f3da0566e1737ae2$var$__awaiter(this, void 0, void 0, function() {
            return $f3da0566e1737ae2$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (this.terminateMessageLoop) {
                            this.terminateMessageLoop = false;
                            return [
                                2 /*return*/ ,
                                Promise.reject("Connection to service terminated.")
                            ];
                        }
                        return [
                            4 /*yield*/ ,
                            this.sendSpeechServiceConfig(connection, this.privRequestSession, this.privRecognizerConfig.SpeechServiceConfig.serialize())
                        ];
                    case 1:
                        _a.sent();
                        return [
                            4 /*yield*/ ,
                            this.sendAgentConfig(connection)
                        ];
                    case 2:
                        _a.sent();
                        return [
                            2 /*return*/ ,
                            connection
                        ];
                }
            });
        });
    };
    DialogServiceAdapter.prototype.sendPreAudioMessages = function() {
        return $f3da0566e1737ae2$var$__awaiter(this, void 0, void 0, function() {
            var connection;
            return $f3da0566e1737ae2$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.fetchConnection()
                        ];
                    case 1:
                        connection = _a.sent();
                        this.addKeywordContextData();
                        return [
                            4 /*yield*/ ,
                            this.sendSpeechContext(connection)
                        ];
                    case 2:
                        _a.sent();
                        return [
                            4 /*yield*/ ,
                            this.sendAgentContext(connection)
                        ];
                    case 3:
                        _a.sent();
                        return [
                            4 /*yield*/ ,
                            this.sendWaveHeader(connection)
                        ];
                    case 4:
                        _a.sent();
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    DialogServiceAdapter.prototype.fireEventForResult = function(serviceResult, properties) {
        var resultReason = $9MAMI.EnumTranslation.implTranslateRecognitionResult(serviceResult.RecognitionStatus);
        var offset = serviceResult.Offset + this.privRequestSession.currentTurnAudioOffset;
        var result = new $iQDnw.SpeechRecognitionResult(this.privRequestSession.requestId, resultReason, serviceResult.DisplayText, serviceResult.Duration, offset, serviceResult.Language, serviceResult.LanguageDetectionConfidence, undefined, undefined, JSON.stringify(serviceResult), properties);
        var ev = new $iQDnw.SpeechRecognitionEventArgs(result, offset, this.privRequestSession.sessionId);
        return ev;
    };
    DialogServiceAdapter.prototype.onEvent = function(event) {
        this.privEvents.onEvent(event);
        $7srwU.Events.instance.onEvent(event);
    };
    DialogServiceAdapter.prototype.addKeywordContextData = function() {
        var keywordPropertyValue = this.privRecognizerConfig.parameters.getProperty("SPEECH-KeywordsToDetect");
        if (keywordPropertyValue === undefined) return;
        var keywordOffsetPropertyValue = this.privRecognizerConfig.parameters.getProperty("SPEECH-KeywordsToDetect-Offsets");
        var keywordDurationPropertyValue = this.privRecognizerConfig.parameters.getProperty("SPEECH-KeywordsToDetect-Durations");
        var keywords = keywordPropertyValue.split(";");
        var keywordOffsets = keywordOffsetPropertyValue === undefined ? [] : keywordOffsetPropertyValue.split(";");
        var keywordDurations = keywordDurationPropertyValue === undefined ? [] : keywordDurationPropertyValue.split(";");
        var keywordDefinitionArray = [];
        for(var i = 0; i < keywords.length; i++){
            var definition = {};
            definition.text = keywords[i];
            if (i < keywordOffsets.length) definition.offset = Number(keywordOffsets[i]);
            if (i < keywordDurations.length) definition.duration = Number(keywordDurations[i]);
            keywordDefinitionArray.push(definition);
        }
        this.speechContext.setSection("invocationSource", "VoiceActivationWithKeyword");
        this.speechContext.setSection("keywordDetection", [
            {
                clientDetectedKeywords: keywordDefinitionArray,
                onReject: {
                    action: "EndOfTurn"
                },
                type: "startTrigger"
            }
        ]);
    };
    return DialogServiceAdapter;
}($9MAMI.ServiceRecognizerBase);
module.exports.DialogServiceAdapter = $f3da0566e1737ae2$var$DialogServiceAdapter;

});
parcelRequire.register("3IGXt", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DialogServiceTurnStateManager = void 0;

var $7YICj = parcelRequire("7YICj");

var $1yK15 = parcelRequire("1yK15");
var $2b56cdc7986cbc57$var$DialogServiceTurnStateManager = /** @class */ function() {
    function DialogServiceTurnStateManager() {
        this.privTurnMap = new Map();
        return;
    }
    DialogServiceTurnStateManager.prototype.StartTurn = function(id) {
        if (this.privTurnMap.has(id)) throw new $7YICj.InvalidOperationError("Service error: There is already a turn with id:" + id);
        var turnState = new $1yK15.DialogServiceTurnState(this, id);
        this.privTurnMap.set(id, turnState);
        return this.privTurnMap.get(id);
    };
    DialogServiceTurnStateManager.prototype.GetTurn = function(id) {
        return this.privTurnMap.get(id);
    };
    DialogServiceTurnStateManager.prototype.CompleteTurn = function(id) {
        if (!this.privTurnMap.has(id)) throw new $7YICj.InvalidOperationError("Service error: Received turn end for an unknown turn id:" + id);
        var turnState = this.privTurnMap.get(id);
        turnState.complete();
        this.privTurnMap.delete(id);
        return turnState;
    };
    return DialogServiceTurnStateManager;
}();
module.exports.DialogServiceTurnStateManager = $2b56cdc7986cbc57$var$DialogServiceTurnStateManager;

});
parcelRequire.register("1yK15", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DialogServiceTurnState = void 0;

var $gU3rQ = parcelRequire("gU3rQ");

var $epVjg = parcelRequire("epVjg");

var $dizhq = parcelRequire("dizhq");
var $122ca95b55c396ed$var$DialogServiceTurnState = /** @class */ function() {
    function DialogServiceTurnState(manager, requestId) {
        this.privRequestId = requestId;
        this.privIsCompleted = false;
        this.privAudioStream = null;
        this.privTurnManager = manager;
        this.resetTurnEndTimeout();
    // tslint:disable-next-line:no-console
    // console.info("DialogServiceTurnState debugturn start:" + this.privRequestId);
    }
    Object.defineProperty(DialogServiceTurnState.prototype, "audioStream", {
        get: function() {
            // Called when is needed to stream.
            this.resetTurnEndTimeout();
            return this.privAudioStream;
        },
        enumerable: false,
        configurable: true
    });
    DialogServiceTurnState.prototype.processActivityPayload = function(payload, audioFormat) {
        if (payload.messageDataStreamType === $dizhq.MessageDataStreamType.TextToSpeechAudio) {
            this.privAudioStream = $epVjg.AudioOutputStream.createPullStream();
            this.privAudioStream.format = audioFormat !== undefined ? audioFormat : $gU3rQ.AudioOutputFormatImpl.getDefaultOutputFormat();
        // tslint:disable-next-line:no-console
        // console.info("Audio start debugturn:" + this.privRequestId);
        }
        return this.privAudioStream;
    };
    DialogServiceTurnState.prototype.endAudioStream = function() {
        if (this.privAudioStream !== null && !this.privAudioStream.isClosed) this.privAudioStream.close();
    };
    DialogServiceTurnState.prototype.complete = function() {
        if (this.privTimeoutToken !== undefined) clearTimeout(this.privTimeoutToken);
        this.endAudioStream();
    };
    DialogServiceTurnState.prototype.resetTurnEndTimeout = function() {
        var _this = this;
        if (this.privTimeoutToken !== undefined) clearTimeout(this.privTimeoutToken);
        // tslint:disable-next-line:no-console
        // console.info("Timeout reset debugturn:" + this.privRequestId);
        this.privTimeoutToken = setTimeout(function() {
            // tslint:disable-next-line:no-console
            // console.info("Timeout complete debugturn:" + this.privRequestId);
            _this.privTurnManager.CompleteTurn(_this.privRequestId);
            return;
        }, 2000);
    };
    return DialogServiceTurnState;
}();
module.exports.DialogServiceTurnState = $122ca95b55c396ed$var$DialogServiceTurnState;

});
parcelRequire.register("dizhq", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
// response
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MessageDataStreamType = module.exports.ActivityPayloadResponse = void 0;
var $9ae852b204dd1f03$var$ActivityPayloadResponse = /** @class */ function() {
    function ActivityPayloadResponse(json) {
        this.privActivityResponse = JSON.parse(json);
    }
    ActivityPayloadResponse.fromJSON = function(json) {
        return new ActivityPayloadResponse(json);
    };
    Object.defineProperty(ActivityPayloadResponse.prototype, "conversationId", {
        get: function() {
            return this.privActivityResponse.conversationId;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ActivityPayloadResponse.prototype, "messageDataStreamType", {
        get: function() {
            return this.privActivityResponse.messageDataStreamType;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ActivityPayloadResponse.prototype, "messagePayload", {
        get: function() {
            return this.privActivityResponse.messagePayload;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ActivityPayloadResponse.prototype, "version", {
        get: function() {
            return this.privActivityResponse.version;
        },
        enumerable: false,
        configurable: true
    });
    return ActivityPayloadResponse;
}();
module.exports.ActivityPayloadResponse = $9ae852b204dd1f03$var$ActivityPayloadResponse;
var $9ae852b204dd1f03$var$MessageDataStreamType;
(function(MessageDataStreamType) {
    MessageDataStreamType[MessageDataStreamType["None"] = 0] = "None";
    MessageDataStreamType[MessageDataStreamType["TextToSpeechAudio"] = 1] = "TextToSpeechAudio";
})($9ae852b204dd1f03$var$MessageDataStreamType = module.exports.MessageDataStreamType || (module.exports.MessageDataStreamType = {}));

});




parcelRequire.register("eJjYN", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.AgentConfig = void 0;
/**
 * Represents the JSON used in the agent.config message sent to the speech service.
 */ var $ab94c4310c084b57$var$AgentConfig = /** @class */ function() {
    function AgentConfig() {}
    AgentConfig.prototype.toJsonString = function() {
        return JSON.stringify(this.iPrivConfig);
    };
    AgentConfig.prototype.get = function() {
        return this.iPrivConfig;
    };
    /**
     * Setter for the agent.config object.
     * @param value a JSON serializable object.
     */ AgentConfig.prototype.set = function(value) {
        this.iPrivConfig = value;
    };
    return AgentConfig;
}();
module.exports.AgentConfig = $ab94c4310c084b57$var$AgentConfig;

});

parcelRequire.register("7lj1o", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $8oa2d = parcelRequire("8oa2d");
Object.defineProperty(module.exports, "ConversationManager", {
    enumerable: true,
    get: function() {
        return $8oa2d.ConversationManager;
    }
});

var $cy6mO = parcelRequire("cy6mO");
Object.defineProperty(module.exports, "ConversationConnectionConfig", {
    enumerable: true,
    get: function() {
        return $cy6mO.ConversationConnectionConfig;
    }
});

var $6VCpw = parcelRequire("6VCpw");
Object.defineProperty(module.exports, "ConversationRecognizerFactory", {
    enumerable: true,
    get: function() {
        return $6VCpw.ConversationRecognizerFactory;
    }
});

var $bTT88 = parcelRequire("bTT88");
Object.defineProperty(module.exports, "TranscriberRecognizer", {
    enumerable: true,
    get: function() {
        return $bTT88.TranscriberRecognizer;
    }
});

var $j6vE5 = parcelRequire("j6vE5");
Object.defineProperty(module.exports, "ConversationReceivedTranslationEventArgs", {
    enumerable: true,
    get: function() {
        return $j6vE5.ConversationReceivedTranslationEventArgs;
    }
});
Object.defineProperty(module.exports, "LockRoomEventArgs", {
    enumerable: true,
    get: function() {
        return $j6vE5.LockRoomEventArgs;
    }
});
Object.defineProperty(module.exports, "MuteAllEventArgs", {
    enumerable: true,
    get: function() {
        return $j6vE5.MuteAllEventArgs;
    }
});
Object.defineProperty(module.exports, "ParticipantAttributeEventArgs", {
    enumerable: true,
    get: function() {
        return $j6vE5.ParticipantAttributeEventArgs;
    }
});
Object.defineProperty(module.exports, "ParticipantEventArgs", {
    enumerable: true,
    get: function() {
        return $j6vE5.ParticipantEventArgs;
    }
});
Object.defineProperty(module.exports, "ParticipantsListEventArgs", {
    enumerable: true,
    get: function() {
        return $j6vE5.ParticipantsListEventArgs;
    }
});

var $3c9ZA = parcelRequire("3c9ZA");
Object.defineProperty(module.exports, "ConversationTranslatorCommandTypes", {
    enumerable: true,
    get: function() {
        return $3c9ZA.ConversationTranslatorCommandTypes;
    }
});
Object.defineProperty(module.exports, "ConversationTranslatorMessageTypes", {
    enumerable: true,
    get: function() {
        return $3c9ZA.ConversationTranslatorMessageTypes;
    }
});
Object.defineProperty(module.exports, "InternalParticipants", {
    enumerable: true,
    get: function() {
        return $3c9ZA.InternalParticipants;
    }
});

});
parcelRequire.register("8oa2d", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ConversationManager = void 0;

var $evvAW = parcelRequire("evvAW");

var $iQDnw = parcelRequire("iQDnw");

var $cy6mO = parcelRequire("cy6mO");

var $jgZrW = parcelRequire("jgZrW");
var $61b8594c71dbcdbd$var$ConversationManager = /** @class */ function() {
    function ConversationManager() {
        //
        this.privRequestParams = $cy6mO.ConversationConnectionConfig.configParams;
        this.privErrors = $cy6mO.ConversationConnectionConfig.restErrors;
        this.privHost = $cy6mO.ConversationConnectionConfig.host;
        this.privApiVersion = $cy6mO.ConversationConnectionConfig.apiVersion;
        this.privRestPath = $cy6mO.ConversationConnectionConfig.restPath;
    }
    /**
     * Make a POST request to the Conversation Manager service endpoint to create or join a conversation.
     * @param args
     * @param conversationCode
     * @param callback
     * @param errorCallback
     */ ConversationManager.prototype.createOrJoin = function(args, conversationCode, cb, err) {
        var _this = this;
        try {
            $evvAW.Contracts.throwIfNullOrUndefined(args, "args");
            var languageCode = args.getProperty($iQDnw.PropertyId.SpeechServiceConnection_RecoLanguage, $cy6mO.ConversationConnectionConfig.defaultLanguageCode);
            var nickname = args.getProperty($iQDnw.PropertyId.ConversationTranslator_Name);
            var endpointHost = args.getProperty($iQDnw.PropertyId.ConversationTranslator_Host, this.privHost);
            var correlationId = args.getProperty($iQDnw.PropertyId.ConversationTranslator_CorrelationId);
            var subscriptionKey = args.getProperty($iQDnw.PropertyId.SpeechServiceConnection_Key);
            var subscriptionRegion = args.getProperty($iQDnw.PropertyId.SpeechServiceConnection_Region);
            var authToken = args.getProperty($iQDnw.PropertyId.SpeechServiceAuthorization_Token);
            $evvAW.Contracts.throwIfNullOrWhitespace(languageCode, "languageCode");
            $evvAW.Contracts.throwIfNullOrWhitespace(nickname, "nickname");
            $evvAW.Contracts.throwIfNullOrWhitespace(endpointHost, "endpointHost");
            var queryParams = {};
            queryParams[this.privRequestParams.apiVersion] = this.privApiVersion;
            queryParams[this.privRequestParams.languageCode] = languageCode;
            queryParams[this.privRequestParams.nickname] = nickname;
            var headers = {};
            if (correlationId) headers[this.privRequestParams.correlationId] = correlationId;
            headers[this.privRequestParams.clientAppId] = $cy6mO.ConversationConnectionConfig.clientAppId;
            if (conversationCode !== undefined) queryParams[this.privRequestParams.roomId] = conversationCode;
            else {
                $evvAW.Contracts.throwIfNullOrUndefined(subscriptionRegion, this.privErrors.authInvalidSubscriptionRegion);
                headers[this.privRequestParams.subscriptionRegion] = subscriptionRegion;
                if (subscriptionKey) headers[this.privRequestParams.subscriptionKey] = subscriptionKey;
                else if (authToken) headers[this.privRequestParams.authorization] = "Bearer " + authToken;
                else $evvAW.Contracts.throwIfNullOrUndefined(subscriptionKey, this.privErrors.authInvalidSubscriptionKey);
            }
            var config = {};
            config.headers = headers;
            var endpoint = "https://" + endpointHost + this.privRestPath;
            // TODO: support a proxy and certificate validation
            $jgZrW.request("post", endpoint, queryParams, null, config, function(response) {
                var requestId = $jgZrW.extractHeaderValue(_this.privRequestParams.requestId, response.headers);
                if (!response.ok) {
                    if (!!err) {
                        // get the error
                        var errorMessage = _this.privErrors.invalidCreateJoinConversationResponse.replace("{status}", response.status.toString());
                        var errMessageRaw = void 0;
                        try {
                            errMessageRaw = JSON.parse(response.data);
                            errorMessage += " [" + errMessageRaw.error.code + ": " + errMessageRaw.error.message + "]";
                        } catch (e) {
                            errorMessage += " [" + response.data + "]";
                        }
                        if (requestId) errorMessage += " " + requestId;
                        err(errorMessage);
                    }
                    return;
                }
                var conversation = JSON.parse(response.data);
                if (conversation) conversation.requestId = requestId;
                if (!!cb) {
                    try {
                        cb(conversation);
                    } catch (e) {
                        if (!!err) err(e);
                    }
                    cb = undefined;
                }
            });
        } catch (error) {
            if (!!err) {
                if (error instanceof Error) {
                    var typedError = error;
                    err(typedError.name + ": " + typedError.message);
                } else err(error);
            }
        }
    };
    /**
     * Make a DELETE request to the Conversation Manager service endpoint to leave the conversation.
     * @param args
     * @param sessionToken
     * @param callback
     */ ConversationManager.prototype.leave = function(args, sessionToken) {
        var _this = this;
        return new Promise(function(resolve, reject) {
            try {
                $evvAW.Contracts.throwIfNullOrUndefined(args, _this.privErrors.invalidArgs.replace("{arg}", "config"));
                $evvAW.Contracts.throwIfNullOrWhitespace(sessionToken, _this.privErrors.invalidArgs.replace("{arg}", "token"));
                var endpointHost = args.getProperty($iQDnw.PropertyId.ConversationTranslator_Host, _this.privHost);
                var correlationId = args.getProperty($iQDnw.PropertyId.ConversationTranslator_CorrelationId);
                var queryParams = {};
                queryParams[_this.privRequestParams.apiVersion] = _this.privApiVersion;
                queryParams[_this.privRequestParams.sessionToken] = sessionToken;
                var headers = {};
                if (correlationId) headers[_this.privRequestParams.correlationId] = correlationId;
                var config = {};
                config.headers = headers;
                var endpoint = "https://" + endpointHost + _this.privRestPath;
                // TODO: support a proxy and certificate validation
                $jgZrW.request("delete", endpoint, queryParams, null, config, function(response) {
                    response.ok;
                    resolve();
                });
            } catch (error) {
                if (error instanceof Error) {
                    var typedError = error;
                    reject(typedError.name + ": " + typedError.message);
                } else reject(error);
            }
        });
    };
    return ConversationManager;
}();
module.exports.ConversationManager = $61b8594c71dbcdbd$var$ConversationManager;

});
parcelRequire.register("cy6mO", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
var $922d99597e489e15$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ConversationConnectionConfig = void 0;

var $4MIZo = parcelRequire("4MIZo");
var $922d99597e489e15$var$ConversationConnectionConfig = /** @class */ function(_super) {
    $922d99597e489e15$var$__extends(ConversationConnectionConfig, _super);
    function ConversationConnectionConfig() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(ConversationConnectionConfig, "host", {
        get: function() {
            return ConversationConnectionConfig.privHost;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ConversationConnectionConfig, "apiVersion", {
        get: function() {
            return ConversationConnectionConfig.privApiVersion;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ConversationConnectionConfig, "clientAppId", {
        get: function() {
            return ConversationConnectionConfig.privClientAppId;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ConversationConnectionConfig, "defaultLanguageCode", {
        get: function() {
            return ConversationConnectionConfig.privDefaultLanguageCode;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ConversationConnectionConfig, "restPath", {
        get: function() {
            return ConversationConnectionConfig.privRestPath;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ConversationConnectionConfig, "webSocketPath", {
        get: function() {
            return ConversationConnectionConfig.privWebSocketPath;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ConversationConnectionConfig, "speechHost", {
        get: function() {
            return ConversationConnectionConfig.privSpeechHost;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ConversationConnectionConfig, "speechPath", {
        get: function() {
            return ConversationConnectionConfig.privSpeechPath;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ConversationConnectionConfig, "transcriptionEventKeys", {
        get: function() {
            return ConversationConnectionConfig.privTranscriptionEventKeys;
        },
        enumerable: false,
        configurable: true
    });
    ConversationConnectionConfig.privHost = "dev.microsofttranslator.com";
    ConversationConnectionConfig.privRestPath = "/capito/room";
    ConversationConnectionConfig.privApiVersion = "2.0";
    ConversationConnectionConfig.privDefaultLanguageCode = "en-US";
    ConversationConnectionConfig.privClientAppId = "FC539C22-1767-4F1F-84BC-B4D811114F15";
    ConversationConnectionConfig.privWebSocketPath = "/capito/translate";
    ConversationConnectionConfig.privSpeechHost = "{region}.s2s.speech.microsoft.com";
    ConversationConnectionConfig.privSpeechPath = "/speech/translation/cognitiveservices/v1";
    ConversationConnectionConfig.privTranscriptionEventKeys = [
        "iCalUid",
        "callId",
        "organizer",
        "FLAC",
        "MTUri",
        "DifferenciateGuestSpeakers",
        "audiorecording",
        "Threadid",
        "OrganizerMri",
        "OrganizerTenantId",
        "UserToken"
    ];
    return ConversationConnectionConfig;
}($4MIZo.RestConfigBase);
module.exports.ConversationConnectionConfig = $922d99597e489e15$var$ConversationConnectionConfig;

});
parcelRequire.register("4MIZo", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RestConfigBase = void 0;
var $37be8b0b53d7d8dd$var$RestConfigBase = /** @class */ function() {
    function RestConfigBase() {}
    Object.defineProperty(RestConfigBase, "requestOptions", {
        get: function() {
            return RestConfigBase.privDefaultRequestOptions;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(RestConfigBase, "configParams", {
        get: function() {
            return RestConfigBase.privDefaultParams;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(RestConfigBase, "restErrors", {
        get: function() {
            return RestConfigBase.privRestErrors;
        },
        enumerable: false,
        configurable: true
    });
    RestConfigBase.privDefaultRequestOptions = {
        headers: {
            Accept: "application/json"
        },
        ignoreCache: false,
        timeout: 10000
    };
    RestConfigBase.privRestErrors = {
        authInvalidSubscriptionKey: "You must specify either an authentication token to use, or a Cognitive Speech subscription key.",
        authInvalidSubscriptionRegion: "You must specify the Cognitive Speech region to use.",
        invalidArgs: "Required input not found: {arg}.",
        invalidCreateJoinConversationResponse: "Creating/Joining conversation failed with HTTP {status}.",
        invalidParticipantRequest: "The requested participant was not found.",
        permissionDeniedConnect: "Required credentials not found.",
        permissionDeniedConversation: "Invalid operation: only the host can {command} the conversation.",
        permissionDeniedParticipant: "Invalid operation: only the host can {command} a participant.",
        permissionDeniedSend: "Invalid operation: the conversation is not in a connected state.",
        permissionDeniedStart: "Invalid operation: there is already an active conversation."
    };
    RestConfigBase.privDefaultParams = {
        apiVersion: "api-version",
        authorization: "Authorization",
        clientAppId: "X-ClientAppId",
        contentTypeKey: "Content-Type",
        correlationId: "X-CorrelationId",
        languageCode: "language",
        nickname: "nickname",
        profanity: "profanity",
        requestId: "X-RequestId",
        roomId: "roomid",
        sessionToken: "token",
        subscriptionKey: "Ocp-Apim-Subscription-Key",
        subscriptionRegion: "Ocp-Apim-Subscription-Region",
        token: "X-CapitoToken"
    };
    return RestConfigBase;
}();
module.exports.RestConfigBase = $37be8b0b53d7d8dd$var$RestConfigBase;

});


parcelRequire.register("jgZrW", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
var $e07f2d8dc69e41de$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $e07f2d8dc69e41de$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $e07f2d8dc69e41de$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.hasOwnProperty.call(mod, k)) $e07f2d8dc69e41de$var$__createBinding(result, mod, k);
    }
    $e07f2d8dc69e41de$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PromiseToEmptyCallback = module.exports.request = module.exports.extractHeaderValue = void 0;

var $4MIZo = parcelRequire("4MIZo");

// Node.JS specific xmlhttprequest / browser support.
var $e07f2d8dc69e41de$var$XHR = $e07f2d8dc69e41de$var$__importStar((parcelRequire("gR5sk")));
/**
 * Config settings for Conversation Translator
 */ /**
 * Helpers for sending / receiving HTTPS requests / responses.
 * @param params
 */ function $e07f2d8dc69e41de$var$queryParams(params) {
    if (params === void 0) params = {};
    return Object.keys(params).map(function(k) {
        return encodeURIComponent(k) + "=" + encodeURIComponent(params[k]);
    }).join("&");
}
function $e07f2d8dc69e41de$var$withQuery(url, params) {
    if (params === void 0) params = {};
    var queryString = $e07f2d8dc69e41de$var$queryParams(params);
    return queryString ? url + (url.indexOf("?") === -1 ? "?" : "&") + queryString : url;
}
function $e07f2d8dc69e41de$var$parseXHRResult(xhr) {
    return {
        data: xhr.responseText,
        headers: xhr.getAllResponseHeaders(),
        json: function() {
            return JSON.parse(xhr.responseText);
        },
        ok: xhr.status >= 200 && xhr.status < 300,
        status: xhr.status,
        statusText: xhr.statusText
    };
}
function $e07f2d8dc69e41de$var$errorResponse(xhr, message) {
    if (message === void 0) message = null;
    return {
        data: message || xhr.statusText,
        headers: xhr.getAllResponseHeaders(),
        json: function() {
            return JSON.parse(message || '"' + xhr.statusText + '"');
        },
        ok: false,
        status: xhr.status,
        statusText: xhr.statusText
    };
}
function $e07f2d8dc69e41de$var$extractHeaderValue(headerKey, headers) {
    var headerValue = "";
    try {
        var arr = headers.trim().split(/[\r\n]+/);
        var headerMap_1 = {};
        arr.forEach(function(line) {
            var parts = line.split(": ");
            var header = parts.shift().toLowerCase();
            var value = parts.join(": ");
            headerMap_1[header] = value;
        });
        headerValue = headerMap_1[headerKey.toLowerCase()];
    } catch (e) {
    // ignore the error
    }
    return headerValue;
}
module.exports.extractHeaderValue = $e07f2d8dc69e41de$var$extractHeaderValue;
function $e07f2d8dc69e41de$var$request(method, url, queryParams, body, options, callback) {
    if (queryParams === void 0) queryParams = {};
    if (body === void 0) body = null;
    if (options === void 0) options = {};
    var defaultRequestOptions = $4MIZo.RestConfigBase.requestOptions;
    var ignoreCache = options.ignoreCache || defaultRequestOptions.ignoreCache;
    var headers = options.headers || defaultRequestOptions.headers;
    var timeout = options.timeout || defaultRequestOptions.timeout;
    var xhr;
    if (typeof window === "undefined") xhr = new $e07f2d8dc69e41de$var$XHR.XMLHttpRequest();
    else xhr = new XMLHttpRequest();
    xhr.open(method, $e07f2d8dc69e41de$var$withQuery(url, queryParams), true);
    if (headers) Object.keys(headers).forEach(function(key) {
        return xhr.setRequestHeader(key, headers[key]);
    });
    if (ignoreCache) xhr.setRequestHeader("Cache-Control", "no-cache");
    xhr.timeout = timeout;
    xhr.onload = function(evt) {
        callback($e07f2d8dc69e41de$var$parseXHRResult(xhr));
    };
    xhr.onerror = function(evt) {
        callback($e07f2d8dc69e41de$var$errorResponse(xhr, "Failed to make request."));
    };
    xhr.ontimeout = function(evt) {
        callback($e07f2d8dc69e41de$var$errorResponse(xhr, "Request took longer than expected."));
    };
    if (method === "post" && body) {
        xhr.setRequestHeader("Content-Type", "application/json");
        xhr.send(JSON.stringify(body));
    } else xhr.send();
}
module.exports.request = $e07f2d8dc69e41de$var$request;
function $e07f2d8dc69e41de$var$PromiseToEmptyCallback(promise, cb, err) {
    if (!!promise) promise.then(function(result) {
        try {
            if (!!cb) cb();
        } catch (e) {
            if (!!err) err("'Unhandled error on promise callback: " + e + "'");
        }
    }, function(reason) {
        try {
            if (!!err) err(reason);
        /* tslint:disable:no-empty */ } catch (error) {}
    });
    else if (!!err) err("Null promise");
}
module.exports.PromiseToEmptyCallback = $e07f2d8dc69e41de$var$PromiseToEmptyCallback;

});


parcelRequire.register("6VCpw", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
var $50b5dc7a3ccb2d8d$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $50b5dc7a3ccb2d8d$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $50b5dc7a3ccb2d8d$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ConversationTranslatorRecognizer = module.exports.ConversationRecognizerFactory = void 0;

var $9MAMI = parcelRequire("9MAMI");

var $7srwU = parcelRequire("7srwU");

var $evvAW = parcelRequire("evvAW");

var $iQDnw = parcelRequire("iQDnw");

var $aIr1H = parcelRequire("aIr1H");

var $asmm2 = parcelRequire("asmm2");

var $jgZrW = parcelRequire("jgZrW");
var $50b5dc7a3ccb2d8d$var$ConversationRecognizerFactory = /** @class */ function() {
    function ConversationRecognizerFactory() {}
    ConversationRecognizerFactory.fromConfig = function(speechConfig, audioConfig) {
        return new $50b5dc7a3ccb2d8d$var$ConversationTranslatorRecognizer(speechConfig, audioConfig);
    };
    return ConversationRecognizerFactory;
}();
module.exports.ConversationRecognizerFactory = $50b5dc7a3ccb2d8d$var$ConversationRecognizerFactory;
/**
 * Sends messages to the Conversation Translator websocket and listens for incoming events containing websocket messages.
 * Based off the recognizers in the SDK folder.
 */ // tslint:disable-next-line:max-classes-per-file
var $50b5dc7a3ccb2d8d$var$ConversationTranslatorRecognizer = /** @class */ function(_super) {
    $50b5dc7a3ccb2d8d$var$__extends(ConversationTranslatorRecognizer, _super);
    function ConversationTranslatorRecognizer(speechConfig, audioConfig) {
        var _this = this;
        var serviceConfigImpl = speechConfig;
        $evvAW.Contracts.throwIfNull(serviceConfigImpl, "speechConfig");
        _this = _super.call(this, audioConfig, serviceConfigImpl.properties, new $aIr1H.ConversationConnectionFactory()) || this;
        _this.privIsDisposed = false;
        _this.privProperties = serviceConfigImpl.properties.clone();
        _this.privConnection = $iQDnw.Connection.fromRecognizer(_this);
        return _this;
    }
    Object.defineProperty(ConversationTranslatorRecognizer.prototype, "connected", {
        set: function(cb) {
            this.privConnection.connected = cb;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ConversationTranslatorRecognizer.prototype, "disconnected", {
        set: function(cb) {
            this.privConnection.disconnected = cb;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ConversationTranslatorRecognizer.prototype, "speechRecognitionLanguage", {
        /**
         * Return the speech language used by the recognizer
         */ get: function() {
            return this.privSpeechRecognitionLanguage;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ConversationTranslatorRecognizer.prototype, "properties", {
        /**
         * Return the properties for the recognizer
         */ get: function() {
            return this.privProperties;
        },
        enumerable: false,
        configurable: true
    });
    ConversationTranslatorRecognizer.prototype.isDisposed = function() {
        return this.privIsDisposed;
    };
    /**
     * Connect to the recognizer
     * @param token
     */ ConversationTranslatorRecognizer.prototype.connect = function(token, cb, err) {
        try {
            $evvAW.Contracts.throwIfDisposed(this.privIsDisposed);
            $evvAW.Contracts.throwIfNullOrWhitespace(token, "token");
            this.privReco.conversationTranslatorToken = token;
            this.privReco.connectAsync(cb, err);
        } catch (error) {
            if (!!err) {
                if (error instanceof Error) {
                    var typedError = error;
                    err(typedError.name + ": " + typedError.message);
                } else err(error);
            }
        }
    };
    /**
     * Disconnect from the recognizer
     */ ConversationTranslatorRecognizer.prototype.disconnect = function(cb, err) {
        try {
            $evvAW.Contracts.throwIfDisposed(this.privIsDisposed);
            this.privReco.disconnect().then(function() {
                if (!!cb) cb();
            }, function(error) {
                if (!!err) err(error);
            });
        } catch (error) {
            if (!!err) {
                if (error instanceof Error) {
                    var typedError = error;
                    err(typedError.name + ": " + typedError.message);
                } else err(error);
            }
            // Destroy the recognizer.
            this.dispose(true).catch(function(reason) {
                $7srwU.Events.instance.onEvent(new $7srwU.BackgroundEvent(reason));
            });
        }
    };
    /**
     * Send the mute all participants command to the websocket
     * @param conversationId
     * @param participantId
     * @param isMuted
     */ ConversationTranslatorRecognizer.prototype.sendRequest = function(command, cb, err) {
        try {
            $evvAW.Contracts.throwIfDisposed(this.privIsDisposed);
            this.sendMessage(command, cb, err);
        } catch (error) {
            if (!!err) {
                if (error instanceof Error) {
                    var typedError = error;
                    err(typedError.name + ": " + typedError.message);
                } else err(error);
            }
            // Destroy the recognizer.
            this.dispose(true).catch(function(reason) {
                $7srwU.Events.instance.onEvent(new $7srwU.BackgroundEvent(reason));
            });
        }
    };
    /**
     * Close and dispose the recognizer
     */ ConversationTranslatorRecognizer.prototype.close = function() {
        var _a, _b;
        return $50b5dc7a3ccb2d8d$var$__awaiter(this, void 0, void 0, function() {
            return $50b5dc7a3ccb2d8d$var$__generator(this, function(_c) {
                switch(_c.label){
                    case 0:
                        $evvAW.Contracts.throwIfDisposed(this.privIsDisposed);
                        (_a = this.privConnection) === null || _a === void 0 || _a.closeConnection();
                        (_b = this.privConnection) === null || _b === void 0 || _b.close();
                        this.privConnection = undefined;
                        return [
                            4 /*yield*/ ,
                            this.dispose(true)
                        ];
                    case 1:
                        _c.sent();
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * Dispose the recognizer
     * @param disposing
     */ ConversationTranslatorRecognizer.prototype.dispose = function(disposing) {
        return $50b5dc7a3ccb2d8d$var$__awaiter(this, void 0, void 0, function() {
            return $50b5dc7a3ccb2d8d$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (this.privIsDisposed) return [
                            2 /*return*/ 
                        ];
                        if (!disposing) return [
                            3 /*break*/ ,
                            2
                        ];
                        this.privIsDisposed = true;
                        if (!!this.privConnection) {
                            this.privConnection.closeConnection();
                            this.privConnection.close();
                            this.privConnection = undefined;
                        }
                        return [
                            4 /*yield*/ ,
                            _super.prototype.dispose.call(this, disposing)
                        ];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * Create the config for the recognizer
     * @param speechConfig
     */ ConversationTranslatorRecognizer.prototype.createRecognizerConfig = function(speechConfig) {
        return new $9MAMI.RecognizerConfig(speechConfig, this.privProperties);
    };
    /**
     * Create the service recognizer.
     * The audio source is redundnant here but is required by the implementation.
     * @param authentication
     * @param connectionFactory
     * @param audioConfig
     * @param recognizerConfig
     */ ConversationTranslatorRecognizer.prototype.createServiceRecognizer = function(authentication, connectionFactory, audioConfig, recognizerConfig) {
        var audioSource = audioConfig;
        return new $asmm2.ConversationServiceAdapter(authentication, connectionFactory, audioSource, recognizerConfig, this);
    };
    ConversationTranslatorRecognizer.prototype.sendMessage = function(msg, cb, err) {
        var withAsync = this.privReco;
        $jgZrW.PromiseToEmptyCallback(withAsync.sendMessageAsync(msg), cb, err);
    };
    return ConversationTranslatorRecognizer;
}($iQDnw.Recognizer);
module.exports.ConversationTranslatorRecognizer = $50b5dc7a3ccb2d8d$var$ConversationTranslatorRecognizer;

});
parcelRequire.register("aIr1H", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
var $7cd2fa54b3e1961c$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ConversationConnectionFactory = void 0;

var $9h4kO = parcelRequire("9h4kO");

var $7srwU = parcelRequire("7srwU");

var $evvAW = parcelRequire("evvAW");

var $iQDnw = parcelRequire("iQDnw");

var $8EAiJ = parcelRequire("8EAiJ");

var $cy6mO = parcelRequire("cy6mO");

var $eX7Md = parcelRequire("eX7Md");
/**
 * Create a connection to the Conversation Translator websocket for sending instant messages and commands, and for receiving translated messages.
 * The conversation must already have been started or joined.
 */ var $7cd2fa54b3e1961c$var$ConversationConnectionFactory = /** @class */ function(_super) {
    $7cd2fa54b3e1961c$var$__extends(ConversationConnectionFactory, _super);
    function ConversationConnectionFactory() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ConversationConnectionFactory.prototype.create = function(config, authInfo, connectionId) {
        var endpointHost = config.parameters.getProperty($iQDnw.PropertyId.ConversationTranslator_Host, $cy6mO.ConversationConnectionConfig.host);
        var correlationId = config.parameters.getProperty($iQDnw.PropertyId.ConversationTranslator_CorrelationId, $7srwU.createGuid());
        var endpoint = "wss://" + endpointHost + $cy6mO.ConversationConnectionConfig.webSocketPath;
        var token = config.parameters.getProperty($iQDnw.PropertyId.ConversationTranslator_Token, undefined);
        $evvAW.Contracts.throwIfNullOrUndefined(token, "token");
        var queryParams = {};
        queryParams[$cy6mO.ConversationConnectionConfig.configParams.apiVersion] = $cy6mO.ConversationConnectionConfig.apiVersion;
        queryParams[$cy6mO.ConversationConnectionConfig.configParams.token] = token;
        queryParams[$cy6mO.ConversationConnectionConfig.configParams.correlationId] = correlationId;
        var enableCompression = config.parameters.getProperty("SPEECH-EnableWebsocketCompression", "false") === "true";
        return new $9h4kO.WebsocketConnection(endpoint, queryParams, {}, new $eX7Md.ConversationWebsocketMessageFormatter(), $9h4kO.ProxyInfo.fromRecognizerConfig(config), enableCompression, connectionId);
    };
    return ConversationConnectionFactory;
}($8EAiJ.ConnectionFactoryBase);
module.exports.ConversationConnectionFactory = $7cd2fa54b3e1961c$var$ConversationConnectionFactory;

});
parcelRequire.register("eX7Md", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ConversationWebsocketMessageFormatter = void 0;

var $7srwU = parcelRequire("7srwU");

var $giFWJ = parcelRequire("giFWJ");
/**
 * Based off WebsocketMessageFormatter. The messages for Conversation Translator have some variations from the Speech messages.
 */ var $ae2c9ba90800f984$var$ConversationWebsocketMessageFormatter = /** @class */ function() {
    function ConversationWebsocketMessageFormatter() {
        /**
         * Format incoming messages: text (speech partial/final, IM) or binary (tts)
         */ this.toConnectionMessage = function(message) {
            var deferral = new $7srwU.Deferred();
            try {
                if (message.messageType === $7srwU.MessageType.Text) {
                    var incomingMessage = new $giFWJ.ConversationConnectionMessage(message.messageType, message.textContent, {}, message.id);
                    deferral.resolve(incomingMessage);
                } else if (message.messageType === $7srwU.MessageType.Binary) deferral.resolve(new $giFWJ.ConversationConnectionMessage(message.messageType, message.binaryContent, undefined, message.id));
            } catch (e) {
                deferral.reject("Error formatting the message. Error: " + e);
            }
            return deferral.promise;
        };
        /**
         * Format outgoing messages: text (commands or IM)
         */ this.fromConnectionMessage = function(message) {
            var deferral = new $7srwU.Deferred();
            try {
                if (message.messageType === $7srwU.MessageType.Text) {
                    var payload = "" + (message.textBody ? message.textBody : "");
                    deferral.resolve(new $7srwU.RawWebsocketMessage($7srwU.MessageType.Text, payload, message.id));
                }
            } catch (e) {
                deferral.reject("Error formatting the message. " + e);
            }
            return deferral.promise;
        };
    }
    return ConversationWebsocketMessageFormatter;
}();
module.exports.ConversationWebsocketMessageFormatter = $ae2c9ba90800f984$var$ConversationWebsocketMessageFormatter;

});
parcelRequire.register("giFWJ", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
var $bddedd7643088515$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ConversationConnectionMessage = void 0;

var $7srwU = parcelRequire("7srwU");
var $bddedd7643088515$var$ConversationConnectionMessage = /** @class */ function(_super) {
    $bddedd7643088515$var$__extends(ConversationConnectionMessage, _super);
    function ConversationConnectionMessage(messageType, body, headers, id) {
        var _this = _super.call(this, messageType, body, headers, id) || this;
        var json = JSON.parse(_this.textBody);
        if (json.type !== undefined) _this.privConversationMessageType = json.type;
        return _this;
    }
    Object.defineProperty(ConversationConnectionMessage.prototype, "conversationMessageType", {
        get: function() {
            return this.privConversationMessageType;
        },
        enumerable: false,
        configurable: true
    });
    return ConversationConnectionMessage;
}($7srwU.ConnectionMessage);
module.exports.ConversationConnectionMessage = $bddedd7643088515$var$ConversationConnectionMessage;

});



parcelRequire.register("asmm2", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
var $79cddc0cb233ba5c$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $79cddc0cb233ba5c$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $79cddc0cb233ba5c$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ConversationServiceAdapter = void 0;

var $7srwU = parcelRequire("7srwU");

var $iQDnw = parcelRequire("iQDnw");

var $9MAMI = parcelRequire("9MAMI");

var $giFWJ = parcelRequire("giFWJ");

var $iuMaA = parcelRequire("iuMaA");

var $j6vE5 = parcelRequire("j6vE5");

var $3c9ZA = parcelRequire("3c9ZA");

var $jQHYw = parcelRequire("jQHYw");
/***
 * The service adapter handles sending and receiving messages to the Conversation Translator websocket.
 */ var $79cddc0cb233ba5c$var$ConversationServiceAdapter = /** @class */ function(_super) {
    $79cddc0cb233ba5c$var$__extends(ConversationServiceAdapter, _super);
    function ConversationServiceAdapter(authentication, connectionFactory, audioSource, recognizerConfig, conversationServiceConnector) {
        var _this = _super.call(this, authentication, connectionFactory, audioSource, recognizerConfig, conversationServiceConnector) || this;
        _this.privLastPartialUtteranceId = "";
        _this.noOp = function() {
        // operation not supported
        };
        _this.privConversationServiceConnector = conversationServiceConnector;
        _this.privConversationAuthentication = authentication;
        _this.receiveMessageOverride = _this.receiveConversationMessageOverride;
        _this.recognizeOverride = _this.noOp;
        _this.postConnectImplOverride = _this.conversationConnectImpl;
        _this.configConnectionOverride = _this.configConnection;
        _this.disconnectOverride = _this.privDisconnect;
        _this.privConversationRequestSession = new $iuMaA.ConversationRequestSession($7srwU.createNoDashGuid());
        _this.privConversationConnectionFactory = connectionFactory;
        _this.privConversationIsDisposed = false;
        return _this;
    }
    ConversationServiceAdapter.prototype.isDisposed = function() {
        return _super.prototype.isDisposed.call(this) || this.privConversationIsDisposed;
    };
    ConversationServiceAdapter.prototype.dispose = function(reason) {
        return $79cddc0cb233ba5c$var$__awaiter(this, void 0, void 0, function() {
            var connection;
            return $79cddc0cb233ba5c$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        this.privConversationIsDisposed = true;
                        if (!this.privConnectionConfigPromise) return [
                            3 /*break*/ ,
                            3
                        ];
                        return [
                            4 /*yield*/ ,
                            this.privConnectionConfigPromise
                        ];
                    case 1:
                        connection = _a.sent();
                        return [
                            4 /*yield*/ ,
                            connection.dispose(reason)
                        ];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3:
                        return [
                            4 /*yield*/ ,
                            _super.prototype.dispose.call(this, reason)
                        ];
                    case 4:
                        _a.sent();
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    ConversationServiceAdapter.prototype.sendMessage = function(message) {
        return $79cddc0cb233ba5c$var$__awaiter(this, void 0, void 0, function() {
            var connection;
            return $79cddc0cb233ba5c$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.fetchConnection()
                        ];
                    case 1:
                        connection = _a.sent();
                        return [
                            2 /*return*/ ,
                            connection.send(new $giFWJ.ConversationConnectionMessage($7srwU.MessageType.Text, message))
                        ];
                }
            });
        });
    };
    ConversationServiceAdapter.prototype.sendMessageAsync = function(message) {
        return $79cddc0cb233ba5c$var$__awaiter(this, void 0, void 0, function() {
            var sink, connection;
            return $79cddc0cb233ba5c$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        sink = new $7srwU.Deferred();
                        return [
                            4 /*yield*/ ,
                            this.fetchConnection()
                        ];
                    case 1:
                        connection = _a.sent();
                        return [
                            4 /*yield*/ ,
                            connection.send(new $giFWJ.ConversationConnectionMessage($7srwU.MessageType.Text, message))
                        ];
                    case 2:
                        _a.sent();
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    ConversationServiceAdapter.prototype.privDisconnect = function() {
        if (this.terminateMessageLoop) return;
        this.cancelRecognition(this.privConversationRequestSession.sessionId, this.privConversationRequestSession.requestId, $iQDnw.CancellationReason.Error, $iQDnw.CancellationErrorCode.NoError, "Disconnecting");
        this.terminateMessageLoop = true;
        return Promise.resolve();
    };
    ConversationServiceAdapter.prototype.processTypeSpecificMessages = function(connectionMessage, successCallback, errorCallBack) {
        return $79cddc0cb233ba5c$var$__awaiter(this, void 0, void 0, function() {
            return $79cddc0cb233ba5c$var$__generator(this, function(_a) {
                return [
                    2 /*return*/ ,
                    true
                ];
            });
        });
    };
    // Cancels recognition.
    ConversationServiceAdapter.prototype.cancelRecognition = function(sessionId, requestId, cancellationReason, errorCode, error) {
        this.terminateMessageLoop = true;
        var cancelEvent = new $iQDnw.ConversationTranslationCanceledEventArgs(cancellationReason, error, errorCode, undefined, sessionId);
        try {
            if (!!this.privConversationServiceConnector.canceled) this.privConversationServiceConnector.canceled(this.privConversationServiceConnector, cancelEvent);
        } catch (_a) {
        // continue on error
        }
    };
    /**
     * Establishes a websocket connection to the end point.
     * @param isUnAuthorized
     */ ConversationServiceAdapter.prototype.conversationConnectImpl = function(connection) {
        return $79cddc0cb233ba5c$var$__awaiter(this, void 0, void 0, function() {
            return $79cddc0cb233ba5c$var$__generator(this, function(_a) {
                this.privConnectionLoop = this.startMessageLoop();
                return [
                    2 /*return*/ ,
                    connection
                ];
            });
        });
    };
    /**
     * Process incoming websocket messages
     */ ConversationServiceAdapter.prototype.receiveConversationMessageOverride = function() {
        return $79cddc0cb233ba5c$var$__awaiter(this, void 0, void 0, function() {
            var communicationCustodian, connection, message, sessionId, sendFinal, commandPayload, participantsPayload, participantsResult, joinParticipantPayload, joiningParticipant, leavingParticipant, disconnectParticipant, speechPayload, speechResult, textPayload, textResult, e_1;
            return $79cddc0cb233ba5c$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (this.isDisposed() || this.terminateMessageLoop) return [
                            2 /*return*/ ,
                            Promise.resolve()
                        ];
                        communicationCustodian = new $7srwU.Deferred();
                        _a.label = 1;
                    case 1:
                        _a.trys.push([
                            1,
                            4,
                            ,
                            5
                        ]);
                        return [
                            4 /*yield*/ ,
                            this.fetchConnection()
                        ];
                    case 2:
                        connection = _a.sent();
                        return [
                            4 /*yield*/ ,
                            connection.read()
                        ];
                    case 3:
                        message = _a.sent();
                        if (this.isDisposed() || this.terminateMessageLoop) {
                            // We're done.
                            communicationCustodian.resolve();
                            return [
                                2 /*return*/ ,
                                Promise.resolve()
                            ];
                        }
                        if (!message) return [
                            2 /*return*/ ,
                            this.receiveConversationMessageOverride()
                        ];
                        sessionId = this.privConversationRequestSession.sessionId;
                        sendFinal = false;
                        try {
                            switch(message.conversationMessageType.toLowerCase()){
                                case "info":
                                case "participant_command":
                                case "command":
                                    commandPayload = $jQHYw.CommandResponsePayload.fromJSON(message.textBody);
                                    switch(commandPayload.command.toLowerCase()){
                                        /**
                                         * 'ParticpantList' is the first message sent to the user after the websocket connection has opened.
                                         * The consuming client must wait for this message to arrive
                                         * before starting to send their own data.
                                         */ case "participantlist":
                                            participantsPayload = $jQHYw.ParticipantsListPayloadResponse.fromJSON(message.textBody);
                                            participantsResult = participantsPayload.participants.map(function(p) {
                                                var participant = {
                                                    avatar: p.avatar,
                                                    displayName: p.nickname,
                                                    id: p.participantId,
                                                    isHost: p.ishost,
                                                    isMuted: p.ismuted,
                                                    isUsingTts: p.usetts,
                                                    preferredLanguage: p.locale
                                                };
                                                return participant;
                                            });
                                            if (!!this.privConversationServiceConnector.participantsListReceived) this.privConversationServiceConnector.participantsListReceived(this.privConversationServiceConnector, new $j6vE5.ParticipantsListEventArgs(participantsPayload.roomid, participantsPayload.token, participantsPayload.translateTo, participantsPayload.profanityFilter, participantsPayload.roomProfanityFilter, participantsPayload.roomLocked, participantsPayload.muteAll, participantsResult, sessionId));
                                            break;
                                        /**
                                         * 'SetTranslateToLanguages' represents the list of languages being used in the Conversation by all users(?).
                                         * This is sent at the start of the Conversation
                                         */ case "settranslatetolanguages":
                                            if (!!this.privConversationServiceConnector.participantUpdateCommandReceived) this.privConversationServiceConnector.participantUpdateCommandReceived(this.privConversationServiceConnector, new $j6vE5.ParticipantAttributeEventArgs(commandPayload.participantId, $3c9ZA.ConversationTranslatorCommandTypes.setTranslateToLanguages, commandPayload.value, sessionId));
                                            break;
                                        /**
                                         * 'SetProfanityFiltering' lets the client set the level of profanity filtering.
                                         * If sent by the participant the setting will effect only their own profanity level.
                                         * If sent by the host, the setting will effect all participants including the host.
                                         * Note: the profanity filters differ from Speech Service (?): 'marked', 'raw', 'removed', 'tagged'
                                         */ case "setprofanityfiltering":
                                            if (!!this.privConversationServiceConnector.participantUpdateCommandReceived) this.privConversationServiceConnector.participantUpdateCommandReceived(this.privConversationServiceConnector, new $j6vE5.ParticipantAttributeEventArgs(commandPayload.participantId, $3c9ZA.ConversationTranslatorCommandTypes.setProfanityFiltering, commandPayload.value, sessionId));
                                            break;
                                        /**
                                         * 'SetMute' is sent if the participant has been muted by the host.
                                         * Check the 'participantId' to determine if the current user has been muted.
                                         */ case "setmute":
                                            if (!!this.privConversationServiceConnector.participantUpdateCommandReceived) this.privConversationServiceConnector.participantUpdateCommandReceived(this.privConversationServiceConnector, new $j6vE5.ParticipantAttributeEventArgs(commandPayload.participantId, $3c9ZA.ConversationTranslatorCommandTypes.setMute, commandPayload.value, sessionId));
                                            break;
                                        /**
                                         * 'SetMuteAll' is sent if the Conversation has been muted by the host.
                                         */ case "setmuteall":
                                            if (!!this.privConversationServiceConnector.muteAllCommandReceived) this.privConversationServiceConnector.muteAllCommandReceived(this.privConversationServiceConnector, new $j6vE5.MuteAllEventArgs(commandPayload.value, sessionId));
                                            break;
                                        /**
                                         * 'RoomExpirationWarning' is sent towards the end of the Conversation session to give a timeout warning.
                                         */ case "roomexpirationwarning":
                                            if (!!this.privConversationServiceConnector.conversationExpiration) this.privConversationServiceConnector.conversationExpiration(this.privConversationServiceConnector, new $iQDnw.ConversationExpirationEventArgs(commandPayload.value, this.privConversationRequestSession.sessionId));
                                            break;
                                        /**
                                         * 'SetUseTts' is sent as a confirmation if the user requests TTS to be turned on or off.
                                         */ case "setusetts":
                                            if (!!this.privConversationServiceConnector.participantUpdateCommandReceived) this.privConversationServiceConnector.participantUpdateCommandReceived(this.privConversationServiceConnector, new $j6vE5.ParticipantAttributeEventArgs(commandPayload.participantId, $3c9ZA.ConversationTranslatorCommandTypes.setUseTTS, commandPayload.value, sessionId));
                                            break;
                                        /**
                                         * 'SetLockState' is set if the host has locked or unlocked the Conversation.
                                         */ case "setlockstate":
                                            if (!!this.privConversationServiceConnector.lockRoomCommandReceived) this.privConversationServiceConnector.lockRoomCommandReceived(this.privConversationServiceConnector, new $j6vE5.LockRoomEventArgs(commandPayload.value, sessionId));
                                            break;
                                        /**
                                         * 'ChangeNickname' is received if a user changes their display name.
                                         * Any cached particpiants list should be updated to reflect the display name.
                                         */ case "changenickname":
                                            if (!!this.privConversationServiceConnector.participantUpdateCommandReceived) this.privConversationServiceConnector.participantUpdateCommandReceived(this.privConversationServiceConnector, new $j6vE5.ParticipantAttributeEventArgs(commandPayload.participantId, $3c9ZA.ConversationTranslatorCommandTypes.changeNickname, commandPayload.nickname, sessionId));
                                            break;
                                        /**
                                         * 'JoinSession' is sent when a user joins the Conversation.
                                         */ case "joinsession":
                                            joinParticipantPayload = $jQHYw.ParticipantPayloadResponse.fromJSON(message.textBody);
                                            joiningParticipant = {
                                                avatar: joinParticipantPayload.avatar,
                                                displayName: joinParticipantPayload.nickname,
                                                id: joinParticipantPayload.participantId,
                                                isHost: joinParticipantPayload.ishost,
                                                isMuted: joinParticipantPayload.ismuted,
                                                isUsingTts: joinParticipantPayload.usetts,
                                                preferredLanguage: joinParticipantPayload.locale
                                            };
                                            if (!!this.privConversationServiceConnector.participantJoinCommandReceived) this.privConversationServiceConnector.participantJoinCommandReceived(this.privConversationServiceConnector, new $j6vE5.ParticipantEventArgs(joiningParticipant, sessionId));
                                            break;
                                        /**
                                         * 'LeaveSession' is sent when a user leaves the Conversation'.
                                         */ case "leavesession":
                                            leavingParticipant = {
                                                id: commandPayload.participantId
                                            };
                                            if (!!this.privConversationServiceConnector.participantLeaveCommandReceived) this.privConversationServiceConnector.participantLeaveCommandReceived(this.privConversationServiceConnector, new $j6vE5.ParticipantEventArgs(leavingParticipant, sessionId));
                                            break;
                                        /**
                                         * 'DisconnectSession' is sent when a user is disconnected from the session (e.g. network problem).
                                         * Check the 'ParticipantId' to check whether the message is for the current user.
                                         */ case "disconnectsession":
                                            disconnectParticipant = {
                                                id: commandPayload.participantId
                                            };
                                            break;
                                        /**
                                         * Message not recognized.
                                         */ default:
                                            break;
                                    }
                                    break;
                                /**
                                 * 'partial' (or 'hypothesis') represents a unfinalized speech message.
                                 */ case "partial":
                                /**
                                 * 'final' (or 'phrase') represents a finalized speech message.
                                 */ case "final":
                                    speechPayload = $jQHYw.SpeechResponsePayload.fromJSON(message.textBody);
                                    speechResult = new $iQDnw.ConversationTranslationResult(speechPayload.participantId, this.getTranslations(speechPayload.translations), speechPayload.language, undefined, undefined, speechPayload.recognition, undefined, undefined, message.textBody, undefined);
                                    if (speechPayload.isFinal) {
                                        // check the length, sometimes empty finals are returned
                                        if (speechResult.text !== undefined && speechResult.text.length > 0) sendFinal = true;
                                        else if (speechPayload.id === this.privLastPartialUtteranceId) // send final as normal. We had a non-empty partial for this same utterance
                                        // so sending the empty final is important
                                        sendFinal = true;
                                        if (sendFinal) {
                                            if (!!this.privConversationServiceConnector.translationReceived) this.privConversationServiceConnector.translationReceived(this.privConversationServiceConnector, new $j6vE5.ConversationReceivedTranslationEventArgs($3c9ZA.ConversationTranslatorMessageTypes.final, speechResult, sessionId));
                                        }
                                    } else if (speechResult.text !== undefined) {
                                        this.privLastPartialUtteranceId = speechPayload.id;
                                        if (!!this.privConversationServiceConnector.translationReceived) this.privConversationServiceConnector.translationReceived(this.privConversationServiceConnector, new $j6vE5.ConversationReceivedTranslationEventArgs($3c9ZA.ConversationTranslatorMessageTypes.partial, speechResult, sessionId));
                                    }
                                    break;
                                /**
                                 * "translated_message" is a text message or instant message (IM).
                                 */ case "translated_message":
                                    textPayload = $jQHYw.TextResponsePayload.fromJSON(message.textBody);
                                    textResult = new $iQDnw.ConversationTranslationResult(textPayload.participantId, this.getTranslations(textPayload.translations), textPayload.language, undefined, undefined, textPayload.originalText, undefined, undefined, undefined, message.textBody, undefined);
                                    if (!!this.privConversationServiceConnector.translationReceived) this.privConversationServiceConnector.translationReceived(this.privConversationServiceConnector, new $j6vE5.ConversationReceivedTranslationEventArgs($3c9ZA.ConversationTranslatorMessageTypes.instantMessage, textResult, sessionId));
                                    break;
                                default:
                                    break;
                            }
                        } catch (e) {
                        // continue
                        }
                        return [
                            2 /*return*/ ,
                            this.receiveConversationMessageOverride()
                        ];
                    case 4:
                        e_1 = _a.sent();
                        this.terminateMessageLoop = true;
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 5:
                        return [
                            2 /*return*/ ,
                            communicationCustodian.promise
                        ];
                }
            });
        });
    };
    ConversationServiceAdapter.prototype.startMessageLoop = function() {
        return $79cddc0cb233ba5c$var$__awaiter(this, void 0, void 0, function() {
            var messageRetrievalPromise, r, error_1;
            return $79cddc0cb233ba5c$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (this.isDisposed()) return [
                            2 /*return*/ ,
                            Promise.resolve()
                        ];
                        this.terminateMessageLoop = false;
                        messageRetrievalPromise = this.receiveConversationMessageOverride();
                        _a.label = 1;
                    case 1:
                        _a.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4 /*yield*/ ,
                            messageRetrievalPromise
                        ];
                    case 2:
                        r = _a.sent();
                        return [
                            2 /*return*/ ,
                            r
                        ];
                    case 3:
                        error_1 = _a.sent();
                        this.cancelRecognition(this.privRequestSession ? this.privRequestSession.sessionId : "", this.privRequestSession ? this.privRequestSession.requestId : "", $iQDnw.CancellationReason.Error, $iQDnw.CancellationErrorCode.RuntimeError, error_1);
                        return [
                            2 /*return*/ ,
                            null
                        ];
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    // Takes an established websocket connection to the endpoint
    ConversationServiceAdapter.prototype.configConnection = function() {
        var _this = this;
        if (this.isDisposed()) return Promise.resolve(undefined);
        if (this.privConnectionConfigPromise) return this.privConnectionConfigPromise.then(function(connection) {
            if (connection.state() === $7srwU.ConnectionState.Disconnected) {
                _this.privConnectionId = null;
                _this.privConnectionConfigPromise = null;
                return _this.configConnection();
            }
            return _this.privConnectionConfigPromise;
        }, function(error) {
            _this.privConnectionId = null;
            _this.privConnectionConfigPromise = null;
            return _this.configConnection();
        });
        if (this.terminateMessageLoop) return Promise.resolve(undefined);
        this.privConnectionConfigPromise = this.connectImpl().then(function(connection) {
            return connection;
        });
        return this.privConnectionConfigPromise;
    };
    ConversationServiceAdapter.prototype.getTranslations = function(serviceResultTranslations) {
        var translations;
        if (undefined !== serviceResultTranslations) {
            translations = new $iQDnw.Translations();
            for(var _i = 0, serviceResultTranslations_1 = serviceResultTranslations; _i < serviceResultTranslations_1.length; _i++){
                var translation = serviceResultTranslations_1[_i];
                translations.set(translation.lang, translation.translation);
            }
        }
        return translations;
    };
    return ConversationServiceAdapter;
}($9MAMI.ServiceRecognizerBase);
module.exports.ConversationServiceAdapter = $79cddc0cb233ba5c$var$ConversationServiceAdapter;

});
parcelRequire.register("iuMaA", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
var $d77064ddf4c06806$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $d77064ddf4c06806$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ConversationRequestSession = void 0;

var $7srwU = parcelRequire("7srwU");
/**
 * Placeholder class for the Conversation Request Session. Based off RequestSession.
 * TODO: define what telemetry is required.
 */ var $d77064ddf4c06806$var$ConversationRequestSession = /** @class */ function() {
    function ConversationRequestSession(sessionId) {
        var _this = this;
        this.privIsDisposed = false;
        this.privDetachables = new Array();
        this.onPreConnectionStart = function(authFetchEventId, connectionId) {
            _this.privSessionId = connectionId;
        };
        this.onAuthCompleted = function(isError, error) {
            if (isError) _this.onComplete();
        };
        this.onConnectionEstablishCompleted = function(statusCode, reason) {
            if (statusCode === 200) return;
            else if (statusCode === 403) _this.onComplete();
        };
        this.onServiceTurnEndResponse = function(continuousRecognition) {
            if (!continuousRecognition) _this.onComplete();
            else _this.privRequestId = $7srwU.createNoDashGuid();
        };
        this.onComplete = function() {
        //
        };
        this.privSessionId = sessionId;
        this.privRequestId = $7srwU.createNoDashGuid();
        this.privRequestCompletionDeferral = new $7srwU.Deferred();
    }
    Object.defineProperty(ConversationRequestSession.prototype, "sessionId", {
        get: function() {
            return this.privSessionId;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ConversationRequestSession.prototype, "requestId", {
        get: function() {
            return this.privRequestId;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ConversationRequestSession.prototype, "completionPromise", {
        get: function() {
            return this.privRequestCompletionDeferral.promise;
        },
        enumerable: false,
        configurable: true
    });
    ConversationRequestSession.prototype.dispose = function(error) {
        return $d77064ddf4c06806$var$__awaiter(this, void 0, void 0, function() {
            var _i, _a, detachable;
            return $d77064ddf4c06806$var$__generator(this, function(_b) {
                switch(_b.label){
                    case 0:
                        if (!!this.privIsDisposed) return [
                            3 /*break*/ ,
                            4
                        ];
                        // we should have completed by now. If we did not its an unknown error.
                        this.privIsDisposed = true;
                        _i = 0, _a = this.privDetachables;
                        _b.label = 1;
                    case 1:
                        if (!(_i < _a.length)) return [
                            3 /*break*/ ,
                            4
                        ];
                        detachable = _a[_i];
                        return [
                            4 /*yield*/ ,
                            detachable.detach()
                        ];
                    case 2:
                        _b.sent();
                        _b.label = 3;
                    case 3:
                        _i++;
                        return [
                            3 /*break*/ ,
                            1
                        ];
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    return ConversationRequestSession;
}();
module.exports.ConversationRequestSession = $d77064ddf4c06806$var$ConversationRequestSession;

});

parcelRequire.register("j6vE5", function(module, exports) {
"use strict";
var $de871ffb8104875a$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ConversationReceivedTranslationEventArgs = module.exports.ParticipantsListEventArgs = module.exports.ParticipantAttributeEventArgs = module.exports.ParticipantEventArgs = module.exports.LockRoomEventArgs = module.exports.MuteAllEventArgs = void 0;

var $iQDnw = parcelRequire("iQDnw");
var $de871ffb8104875a$var$MuteAllEventArgs = /** @class */ function(_super) {
    $de871ffb8104875a$var$__extends(MuteAllEventArgs, _super);
    function MuteAllEventArgs(isMuted, sessionId) {
        var _this = _super.call(this, sessionId) || this;
        _this.privIsMuted = isMuted;
        return _this;
    }
    Object.defineProperty(MuteAllEventArgs.prototype, "isMuted", {
        get: function() {
            return this.privIsMuted;
        },
        enumerable: false,
        configurable: true
    });
    return MuteAllEventArgs;
}($iQDnw.SessionEventArgs);
module.exports.MuteAllEventArgs = $de871ffb8104875a$var$MuteAllEventArgs;
// tslint:disable-next-line: max-classes-per-file
var $de871ffb8104875a$var$LockRoomEventArgs = /** @class */ function(_super) {
    $de871ffb8104875a$var$__extends(LockRoomEventArgs, _super);
    function LockRoomEventArgs(isLocked, sessionId) {
        var _this = _super.call(this, sessionId) || this;
        _this.privIsLocked = isLocked;
        return _this;
    }
    Object.defineProperty(LockRoomEventArgs.prototype, "isMuted", {
        get: function() {
            return this.privIsLocked;
        },
        enumerable: false,
        configurable: true
    });
    return LockRoomEventArgs;
}($iQDnw.SessionEventArgs);
module.exports.LockRoomEventArgs = $de871ffb8104875a$var$LockRoomEventArgs;
// tslint:disable-next-line: max-classes-per-file
var $de871ffb8104875a$var$ParticipantEventArgs = /** @class */ function(_super) {
    $de871ffb8104875a$var$__extends(ParticipantEventArgs, _super);
    function ParticipantEventArgs(participant, sessionId) {
        var _this = _super.call(this, sessionId) || this;
        _this.privParticipant = participant;
        return _this;
    }
    Object.defineProperty(ParticipantEventArgs.prototype, "participant", {
        get: function() {
            return this.privParticipant;
        },
        enumerable: false,
        configurable: true
    });
    return ParticipantEventArgs;
}($iQDnw.SessionEventArgs);
module.exports.ParticipantEventArgs = $de871ffb8104875a$var$ParticipantEventArgs;
// tslint:disable-next-line: max-classes-per-file
var $de871ffb8104875a$var$ParticipantAttributeEventArgs = /** @class */ function(_super) {
    $de871ffb8104875a$var$__extends(ParticipantAttributeEventArgs, _super);
    function ParticipantAttributeEventArgs(participantId, key, value, sessionId) {
        var _this = _super.call(this, sessionId) || this;
        _this.privKey = key;
        _this.privValue = value;
        _this.privParticipantId = participantId;
        return _this;
    }
    Object.defineProperty(ParticipantAttributeEventArgs.prototype, "value", {
        get: function() {
            return this.privValue;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ParticipantAttributeEventArgs.prototype, "key", {
        get: function() {
            return this.privKey;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ParticipantAttributeEventArgs.prototype, "id", {
        get: function() {
            return this.privParticipantId;
        },
        enumerable: false,
        configurable: true
    });
    return ParticipantAttributeEventArgs;
}($iQDnw.SessionEventArgs);
module.exports.ParticipantAttributeEventArgs = $de871ffb8104875a$var$ParticipantAttributeEventArgs;
// tslint:disable-next-line: max-classes-per-file
var $de871ffb8104875a$var$ParticipantsListEventArgs = /** @class */ function(_super) {
    $de871ffb8104875a$var$__extends(ParticipantsListEventArgs, _super);
    function ParticipantsListEventArgs(conversationId, token, translateTo, profanityFilter, roomProfanityFilter, isRoomLocked, isMuteAll, participants, sessionId) {
        var _this = _super.call(this, sessionId) || this;
        _this.privRoomId = conversationId;
        _this.privSessionToken = token;
        _this.privTranslateTo = translateTo;
        _this.privProfanityFilter = profanityFilter;
        _this.privRoomProfanityFilter = roomProfanityFilter;
        _this.privIsRoomLocked = isRoomLocked;
        _this.privIsRoomLocked = isMuteAll;
        _this.privParticipants = participants;
        return _this;
    }
    Object.defineProperty(ParticipantsListEventArgs.prototype, "sessionToken", {
        get: function() {
            return this.privSessionToken;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ParticipantsListEventArgs.prototype, "conversationId", {
        get: function() {
            return this.privRoomId;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ParticipantsListEventArgs.prototype, "translateTo", {
        get: function() {
            return this.privTranslateTo;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ParticipantsListEventArgs.prototype, "profanityFilter", {
        get: function() {
            return this.privProfanityFilter;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ParticipantsListEventArgs.prototype, "roomProfanityFilter", {
        get: function() {
            return this.privRoomProfanityFilter;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ParticipantsListEventArgs.prototype, "isRoomLocked", {
        get: function() {
            return this.privIsRoomLocked;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ParticipantsListEventArgs.prototype, "isMuteAll", {
        get: function() {
            return this.privIsMuteAll;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ParticipantsListEventArgs.prototype, "participants", {
        get: function() {
            return this.privParticipants;
        },
        enumerable: false,
        configurable: true
    });
    return ParticipantsListEventArgs;
}($iQDnw.SessionEventArgs);
module.exports.ParticipantsListEventArgs = $de871ffb8104875a$var$ParticipantsListEventArgs;
// tslint:disable-next-line: max-classes-per-file
var $de871ffb8104875a$var$ConversationReceivedTranslationEventArgs = /** @class */ function() {
    function ConversationReceivedTranslationEventArgs(command, payload, sessionId) {
        this.privPayload = payload;
        this.privCommand = command;
        this.privSessionId = sessionId;
    }
    Object.defineProperty(ConversationReceivedTranslationEventArgs.prototype, "payload", {
        get: function() {
            return this.privPayload;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ConversationReceivedTranslationEventArgs.prototype, "command", {
        get: function() {
            return this.privCommand;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ConversationReceivedTranslationEventArgs.prototype, "sessionId", {
        get: function() {
            return this.privSessionId;
        },
        enumerable: false,
        configurable: true
    });
    return ConversationReceivedTranslationEventArgs;
}();
module.exports.ConversationReceivedTranslationEventArgs = $de871ffb8104875a$var$ConversationReceivedTranslationEventArgs;

});

parcelRequire.register("3c9ZA", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ConversationTranslatorCommandTypes = module.exports.ConversationTranslatorMessageTypes = module.exports.InternalParticipants = void 0;
/** Users participating in the conversation */ var $253a3e5a234e9c0d$var$InternalParticipants = /** @class */ function() {
    function InternalParticipants(participants, meId) {
        if (participants === void 0) participants = [];
        this.participants = participants;
        this.meId = meId;
    }
    /**
     * Add or update a participant
     * @param value
     */ InternalParticipants.prototype.addOrUpdateParticipant = function(value) {
        if (value === undefined) return;
        var exists = this.getParticipantIndex(value.id);
        if (exists > -1) this.participants.splice(exists, 1, value);
        else this.participants.push(value);
        // ensure it was added ok
        return this.getParticipant(value.id);
    };
    /**
     * Find the participant's position in the participants list.
     * @param id
     */ InternalParticipants.prototype.getParticipantIndex = function(id) {
        return this.participants.findIndex(function(p) {
            return p.id === id;
        });
    };
    /**
     * Find the participant by id.
     * @param id
     */ InternalParticipants.prototype.getParticipant = function(id) {
        return this.participants.find(function(p) {
            return p.id === id;
        });
    };
    /***
     * Remove a participant from the participants list.
     */ InternalParticipants.prototype.deleteParticipant = function(id) {
        this.participants = this.participants.filter(function(p) {
            return p.id !== id;
        });
    };
    Object.defineProperty(InternalParticipants.prototype, "host", {
        /***
         * Helper to return the conversation host.
         */ get: function() {
            return this.participants.find(function(p) {
                return p.isHost === true;
            });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InternalParticipants.prototype, "me", {
        /**
         * Helper to return the current user.
         */ get: function() {
            return this.getParticipant(this.meId);
        },
        enumerable: false,
        configurable: true
    });
    return InternalParticipants;
}();
module.exports.InternalParticipants = $253a3e5a234e9c0d$var$InternalParticipants;
/**
 * List of command message types
 */ module.exports.ConversationTranslatorMessageTypes = {
    command: "command",
    final: "final",
    info: "info",
    instantMessage: "instant_message",
    partial: "partial",
    participantCommand: "participant_command",
    translatedMessage: "translated_message"
};
/**
 * List of command types
 */ module.exports.ConversationTranslatorCommandTypes = {
    changeNickname: "ChangeNickname",
    disconnectSession: "DisconnectSession",
    ejectParticipant: "EjectParticipant",
    instant_message: "instant_message",
    joinSession: "JoinSession",
    leaveSession: "LeaveSession",
    participantList: "ParticipantList",
    roomExpirationWarning: "RoomExpirationWarning",
    setLockState: "SetLockState",
    setMute: "SetMute",
    setMuteAll: "SetMuteAll",
    setProfanityFiltering: "SetProfanityFiltering",
    setTranslateToLanguages: "SetTranslateToLanguages",
    setUseTTS: "SetUseTTS"
};

});

parcelRequire.register("jQHYw", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $HLpLb = parcelRequire("HLpLb");
Object.defineProperty(module.exports, "CommandResponsePayload", {
    enumerable: true,
    get: function() {
        return $HLpLb.CommandResponsePayload;
    }
});

var $11iDQ = parcelRequire("11iDQ");
Object.defineProperty(module.exports, "ParticipantsListPayloadResponse", {
    enumerable: true,
    get: function() {
        return $11iDQ.ParticipantsListPayloadResponse;
    }
});
Object.defineProperty(module.exports, "ParticipantPayloadResponse", {
    enumerable: true,
    get: function() {
        return $11iDQ.ParticipantPayloadResponse;
    }
});

var $8dKWE = parcelRequire("8dKWE");
Object.defineProperty(module.exports, "SpeechResponsePayload", {
    enumerable: true,
    get: function() {
        return $8dKWE.SpeechResponsePayload;
    }
});
Object.defineProperty(module.exports, "TextResponsePayload", {
    enumerable: true,
    get: function() {
        return $8dKWE.TextResponsePayload;
    }
});

});
parcelRequire.register("HLpLb", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CommandResponsePayload = void 0;
var $0838cbcba930f240$var$CommandResponsePayload = /** @class */ function() {
    function CommandResponsePayload(json) {
        this.privCommandResponse = JSON.parse(json);
    }
    CommandResponsePayload.fromJSON = function(json) {
        return new CommandResponsePayload(json);
    };
    Object.defineProperty(CommandResponsePayload.prototype, "type", {
        get: function() {
            return this.privCommandResponse.type;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CommandResponsePayload.prototype, "command", {
        get: function() {
            return this.privCommandResponse.command;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CommandResponsePayload.prototype, "id", {
        get: function() {
            return this.privCommandResponse.id;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CommandResponsePayload.prototype, "nickname", {
        get: function() {
            return this.privCommandResponse.nickname;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CommandResponsePayload.prototype, "participantId", {
        get: function() {
            return this.privCommandResponse.participantId;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CommandResponsePayload.prototype, "roomid", {
        get: function() {
            return this.privCommandResponse.roomid;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CommandResponsePayload.prototype, "value", {
        get: function() {
            return this.privCommandResponse.value;
        },
        enumerable: false,
        configurable: true
    });
    return CommandResponsePayload;
}();
module.exports.CommandResponsePayload = $0838cbcba930f240$var$CommandResponsePayload;

});

parcelRequire.register("11iDQ", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ParticipantPayloadResponse = module.exports.ParticipantsListPayloadResponse = void 0;
var $0be458465b42fc61$var$ParticipantsListPayloadResponse = /** @class */ function() {
    function ParticipantsListPayloadResponse(json) {
        this.privParticipantsPayloadResponse = JSON.parse(json);
    }
    ParticipantsListPayloadResponse.fromJSON = function(json) {
        return new ParticipantsListPayloadResponse(json);
    };
    Object.defineProperty(ParticipantsListPayloadResponse.prototype, "roomid", {
        get: function() {
            return this.privParticipantsPayloadResponse.roomid;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ParticipantsListPayloadResponse.prototype, "id", {
        get: function() {
            return this.privParticipantsPayloadResponse.id;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ParticipantsListPayloadResponse.prototype, "command", {
        get: function() {
            return this.privParticipantsPayloadResponse.command;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ParticipantsListPayloadResponse.prototype, "participants", {
        get: function() {
            return this.privParticipantsPayloadResponse.participants;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ParticipantsListPayloadResponse.prototype, "token", {
        get: function() {
            return this.privParticipantsPayloadResponse.token;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ParticipantsListPayloadResponse.prototype, "translateTo", {
        get: function() {
            return this.privParticipantsPayloadResponse.translateTo;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ParticipantsListPayloadResponse.prototype, "profanityFilter", {
        get: function() {
            return this.privParticipantsPayloadResponse.profanityFilter;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ParticipantsListPayloadResponse.prototype, "roomProfanityFilter", {
        get: function() {
            return this.privParticipantsPayloadResponse.roomProfanityFilter;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ParticipantsListPayloadResponse.prototype, "roomLocked", {
        get: function() {
            return this.privParticipantsPayloadResponse.roomLocked;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ParticipantsListPayloadResponse.prototype, "muteAll", {
        get: function() {
            return this.privParticipantsPayloadResponse.muteAll;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ParticipantsListPayloadResponse.prototype, "type", {
        get: function() {
            return this.privParticipantsPayloadResponse.type;
        },
        enumerable: false,
        configurable: true
    });
    return ParticipantsListPayloadResponse;
}();
module.exports.ParticipantsListPayloadResponse = $0be458465b42fc61$var$ParticipantsListPayloadResponse;
// tslint:disable-next-line: max-classes-per-file
var $0be458465b42fc61$var$ParticipantPayloadResponse = /** @class */ function() {
    function ParticipantPayloadResponse(json) {
        this.privParticipantPayloadResponse = JSON.parse(json);
    }
    ParticipantPayloadResponse.fromJSON = function(json) {
        return new ParticipantPayloadResponse(json);
    };
    Object.defineProperty(ParticipantPayloadResponse.prototype, "nickname", {
        get: function() {
            return this.privParticipantPayloadResponse.nickname;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ParticipantPayloadResponse.prototype, "locale", {
        get: function() {
            return this.privParticipantPayloadResponse.locale;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ParticipantPayloadResponse.prototype, "usetts", {
        get: function() {
            return this.privParticipantPayloadResponse.usetts;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ParticipantPayloadResponse.prototype, "ismuted", {
        get: function() {
            return this.privParticipantPayloadResponse.ismuted;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ParticipantPayloadResponse.prototype, "ishost", {
        get: function() {
            return this.privParticipantPayloadResponse.ishost;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ParticipantPayloadResponse.prototype, "participantId", {
        get: function() {
            return this.privParticipantPayloadResponse.participantId;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ParticipantPayloadResponse.prototype, "avatar", {
        get: function() {
            return this.privParticipantPayloadResponse.avatar;
        },
        enumerable: false,
        configurable: true
    });
    return ParticipantPayloadResponse;
}();
module.exports.ParticipantPayloadResponse = $0be458465b42fc61$var$ParticipantPayloadResponse;

});

parcelRequire.register("8dKWE", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TextResponsePayload = module.exports.SpeechResponsePayload = void 0;
var $5fc3f3eb518c6ea9$var$SpeechResponsePayload = /** @class */ function() {
    function SpeechResponsePayload(json) {
        this.privSpeechResponse = JSON.parse(json);
    }
    SpeechResponsePayload.fromJSON = function(json) {
        return new SpeechResponsePayload(json);
    };
    Object.defineProperty(SpeechResponsePayload.prototype, "recognition", {
        get: function() {
            return this.privSpeechResponse.recognition;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SpeechResponsePayload.prototype, "translations", {
        get: function() {
            return this.privSpeechResponse.translations;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SpeechResponsePayload.prototype, "id", {
        get: function() {
            return this.privSpeechResponse.id;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SpeechResponsePayload.prototype, "language", {
        get: function() {
            return this.privSpeechResponse.language;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SpeechResponsePayload.prototype, "nickname", {
        get: function() {
            return this.privSpeechResponse.nickname;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SpeechResponsePayload.prototype, "participantId", {
        get: function() {
            return this.privSpeechResponse.participantId;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SpeechResponsePayload.prototype, "roomid", {
        get: function() {
            return this.privSpeechResponse.roomid;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SpeechResponsePayload.prototype, "timestamp", {
        get: function() {
            return this.privSpeechResponse.timestamp;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SpeechResponsePayload.prototype, "type", {
        get: function() {
            return this.privSpeechResponse.type;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SpeechResponsePayload.prototype, "isFinal", {
        get: function() {
            return this.privSpeechResponse.type === "final";
        },
        enumerable: false,
        configurable: true
    });
    return SpeechResponsePayload;
}();
module.exports.SpeechResponsePayload = $5fc3f3eb518c6ea9$var$SpeechResponsePayload;
// tslint:disable-next-line: max-classes-per-file
var $5fc3f3eb518c6ea9$var$TextResponsePayload = /** @class */ function() {
    function TextResponsePayload(json) {
        this.privTextResponse = JSON.parse(json);
    }
    TextResponsePayload.fromJSON = function(json) {
        return new TextResponsePayload(json);
    };
    Object.defineProperty(TextResponsePayload.prototype, "originalText", {
        get: function() {
            return this.privTextResponse.originalText;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TextResponsePayload.prototype, "translations", {
        get: function() {
            return this.privTextResponse.translations;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TextResponsePayload.prototype, "id", {
        get: function() {
            return this.privTextResponse.id;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TextResponsePayload.prototype, "language", {
        get: function() {
            return this.privTextResponse.language;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TextResponsePayload.prototype, "nickname", {
        get: function() {
            return this.privTextResponse.nickname;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TextResponsePayload.prototype, "participantId", {
        get: function() {
            return this.privTextResponse.participantId;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TextResponsePayload.prototype, "roomid", {
        get: function() {
            return this.privTextResponse.roomid;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TextResponsePayload.prototype, "timestamp", {
        get: function() {
            return this.privTextResponse.timestamp;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TextResponsePayload.prototype, "type", {
        get: function() {
            return this.privTextResponse.type;
        },
        enumerable: false,
        configurable: true
    });
    return TextResponsePayload;
}();
module.exports.TextResponsePayload = $5fc3f3eb518c6ea9$var$TextResponsePayload;

});




parcelRequire.register("bTT88", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
var $8a9f98754c6b98a1$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $8a9f98754c6b98a1$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $8a9f98754c6b98a1$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TranscriberRecognizer = void 0;

var $7srwU = parcelRequire("7srwU");

var $evvAW = parcelRequire("evvAW");

var $iQDnw = parcelRequire("iQDnw");

var $9MAMI = parcelRequire("9MAMI");
var $8a9f98754c6b98a1$var$TranscriberRecognizer = /** @class */ function(_super) {
    $8a9f98754c6b98a1$var$__extends(TranscriberRecognizer, _super);
    /**
     * TranscriberRecognizer constructor.
     * @constructor
     * @param {AudioConfig} audioConfig - An optional audio configuration associated with the recognizer
     */ function TranscriberRecognizer(speechTranslationConfig, audioConfig) {
        var _this = this;
        var speechTranslationConfigImpl = speechTranslationConfig;
        $evvAW.Contracts.throwIfNull(speechTranslationConfigImpl, "speechTranslationConfig");
        $evvAW.Contracts.throwIfNullOrWhitespace(speechTranslationConfigImpl.speechRecognitionLanguage, $iQDnw.PropertyId[$iQDnw.PropertyId.SpeechServiceConnection_RecoLanguage]);
        _this = _super.call(this, audioConfig, speechTranslationConfigImpl.properties, new $9MAMI.TranscriberConnectionFactory()) || this;
        _this.privDisposedRecognizer = false;
        return _this;
    }
    TranscriberRecognizer.prototype.getConversationInfo = function() {
        $evvAW.Contracts.throwIfNullOrUndefined(this.privConversation, "Conversation");
        return this.privConversation.conversationInfo;
    };
    Object.defineProperty(TranscriberRecognizer.prototype, "authorizationToken", {
        get: function() {
            return this.properties.getProperty($iQDnw.PropertyId.SpeechServiceAuthorization_Token);
        },
        set: function(token) {
            $evvAW.Contracts.throwIfNullOrWhitespace(token, "token");
            this.properties.setProperty($iQDnw.PropertyId.SpeechServiceAuthorization_Token, token);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TranscriberRecognizer.prototype, "conversation", {
        set: function(c) {
            $evvAW.Contracts.throwIfNullOrUndefined(c, "Conversation");
            this.privConversation = c;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TranscriberRecognizer.prototype, "speechRecognitionLanguage", {
        get: function() {
            $evvAW.Contracts.throwIfDisposed(this.privDisposedRecognizer);
            return this.properties.getProperty($iQDnw.PropertyId.SpeechServiceConnection_RecoLanguage);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TranscriberRecognizer.prototype, "properties", {
        get: function() {
            return this.privProperties;
        },
        enumerable: false,
        configurable: true
    });
    TranscriberRecognizer.prototype.startContinuousRecognitionAsync = function(cb, err) {
        $7srwU.marshalPromiseToCallbacks(this.startContinuousRecognitionAsyncImpl($9MAMI.RecognitionMode.Conversation), cb, err);
    };
    TranscriberRecognizer.prototype.stopContinuousRecognitionAsync = function(cb, err) {
        $7srwU.marshalPromiseToCallbacks(this.stopContinuousRecognitionAsyncImpl(), cb, err);
    };
    TranscriberRecognizer.prototype.close = function() {
        return $8a9f98754c6b98a1$var$__awaiter(this, void 0, void 0, function() {
            return $8a9f98754c6b98a1$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        $evvAW.Contracts.throwIfDisposed(this.privDisposedRecognizer);
                        return [
                            4 /*yield*/ ,
                            this.dispose(true)
                        ];
                    case 1:
                        _a.sent();
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    // Push async join/leave conversation message via serviceRecognizer
    TranscriberRecognizer.prototype.pushConversationEvent = function(conversationInfo, command) {
        return $8a9f98754c6b98a1$var$__awaiter(this, void 0, void 0, function() {
            var reco;
            return $8a9f98754c6b98a1$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        reco = this.privReco;
                        $evvAW.Contracts.throwIfNullOrUndefined(reco, "serviceRecognizer");
                        return [
                            4 /*yield*/ ,
                            reco.sendSpeechEventAsync(conversationInfo, command)
                        ];
                    case 1:
                        _a.sent();
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    TranscriberRecognizer.prototype.connectCallbacks = function(transcriber) {
        this.canceled = function(s, e) {
            if (!!transcriber.canceled) transcriber.canceled(transcriber, e);
        };
        this.recognizing = function(s, e) {
            if (!!transcriber.transcribing) transcriber.transcribing(transcriber, e);
        };
        this.recognized = function(s, e) {
            if (!!transcriber.transcribed) transcriber.transcribed(transcriber, e);
        };
        this.sessionStarted = function(s, e) {
            if (!!transcriber.sessionStarted) transcriber.sessionStarted(transcriber, e);
        };
        this.sessionStopped = function(s, e) {
            if (!!transcriber.sessionStopped) transcriber.sessionStopped(transcriber, e);
        };
    };
    TranscriberRecognizer.prototype.disconnectCallbacks = function() {
        this.canceled = undefined;
        this.recognizing = undefined;
        this.recognized = undefined;
        this.sessionStarted = undefined;
        this.sessionStopped = undefined;
    };
    /**
     * Disposes any resources held by the object.
     * @member ConversationTranscriber.prototype.dispose
     * @function
     * @public
     * @param {boolean} disposing - true if disposing the object.
     */ TranscriberRecognizer.prototype.dispose = function(disposing) {
        return $8a9f98754c6b98a1$var$__awaiter(this, void 0, void 0, function() {
            return $8a9f98754c6b98a1$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (this.privDisposedRecognizer) return [
                            2 /*return*/ 
                        ];
                        if (!disposing) return [
                            3 /*break*/ ,
                            2
                        ];
                        this.privDisposedRecognizer = true;
                        return [
                            4 /*yield*/ ,
                            this.implRecognizerStop()
                        ];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        return [
                            4 /*yield*/ ,
                            _super.prototype.dispose.call(this, disposing)
                        ];
                    case 3:
                        _a.sent();
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    TranscriberRecognizer.prototype.createRecognizerConfig = function(speechConfig) {
        return new $9MAMI.RecognizerConfig(speechConfig, this.properties);
    };
    TranscriberRecognizer.prototype.createServiceRecognizer = function(authentication, connectionFactory, audioConfig, recognizerConfig) {
        var configImpl = audioConfig;
        return new $9MAMI.TranscriptionServiceRecognizer(authentication, connectionFactory, configImpl, recognizerConfig, this);
    };
    return TranscriberRecognizer;
}($iQDnw.Recognizer);
module.exports.TranscriberRecognizer = $8a9f98754c6b98a1$var$TranscriberRecognizer;

});


parcelRequire.register("2u1qE", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SynthesisAudioMetadata = module.exports.MetadataType = void 0;
var $1cef7dd672a47d26$var$MetadataType;
(function(MetadataType) {
    MetadataType["WordBoundary"] = "WordBoundary";
    MetadataType["Bookmark"] = "Bookmark";
    MetadataType["Viseme"] = "Viseme";
})($1cef7dd672a47d26$var$MetadataType = module.exports.MetadataType || (module.exports.MetadataType = {}));
var $1cef7dd672a47d26$var$SynthesisAudioMetadata = /** @class */ function() {
    function SynthesisAudioMetadata(json) {
        this.privSynthesisAudioMetadata = JSON.parse(json);
    }
    SynthesisAudioMetadata.fromJSON = function(json) {
        return new SynthesisAudioMetadata(json);
    };
    Object.defineProperty(SynthesisAudioMetadata.prototype, "Metadata", {
        get: function() {
            return this.privSynthesisAudioMetadata.Metadata;
        },
        enumerable: false,
        configurable: true
    });
    return SynthesisAudioMetadata;
}();
module.exports.SynthesisAudioMetadata = $1cef7dd672a47d26$var$SynthesisAudioMetadata;

});

parcelRequire.register("dbuqV", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
var $9993e8e19c5bd8ce$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $9993e8e19c5bd8ce$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SynthesisTurn = void 0;

var $7srwU = parcelRequire("7srwU");

var $epVjg = parcelRequire("epVjg");

var $lzout = parcelRequire("lzout");

var $gc98k = parcelRequire("gc98k");
var $9993e8e19c5bd8ce$var$SynthesisTurn = /** @class */ function() {
    function SynthesisTurn() {
        var _this = this;
        this.privIsDisposed = false;
        this.privIsSynthesizing = false;
        this.privIsSynthesisEnded = false;
        this.privBytesReceived = 0;
        this.privInTurn = false;
        this.privTextOffset = 0;
        this.privNextSearchTextIndex = 0;
        this.onPreConnectionStart = function(authFetchEventId, connectionId) {
            _this.privAuthFetchEventId = authFetchEventId;
            _this.onEvent(new $gc98k.ConnectingToSynthesisServiceEvent(_this.privRequestId, _this.privAuthFetchEventId));
        };
        this.onAuthCompleted = function(isError, error) {
            if (isError) _this.onComplete();
        };
        this.onConnectionEstablishCompleted = function(statusCode, reason) {
            if (statusCode === 200) {
                _this.onEvent(new $gc98k.SynthesisStartedEvent(_this.requestId, _this.privAuthFetchEventId));
                _this.privBytesReceived = 0;
                return;
            } else if (statusCode === 403) _this.onComplete();
        };
        this.onServiceResponseMessage = function(responseJson) {
            var response = JSON.parse(responseJson);
            _this.streamId = response.audio.streamId;
        };
        this.onServiceTurnEndResponse = function() {
            _this.privInTurn = false;
            _this.privTurnDeferral.resolve();
            _this.onComplete();
        };
        this.onServiceTurnStartResponse = function() {
            if (!!_this.privTurnDeferral && !!_this.privInTurn) {
                // What? How are we starting a turn with another not done?
                _this.privTurnDeferral.reject("Another turn started before current completed.");
                // Avoid UnhandledPromiseRejection if privTurnDeferral is not being awaited
                /* tslint:disable:no-empty */ _this.privTurnDeferral.promise.then().catch(function() {});
            }
            _this.privInTurn = true;
            _this.privTurnDeferral = new $7srwU.Deferred();
        };
        this.dispose = function(error) {
            if (!_this.privIsDisposed) // we should have completed by now. If we did not its an unknown error.
            _this.privIsDisposed = true;
        };
        this.onEvent = function(event) {
            $7srwU.Events.instance.onEvent(event);
        };
        this.onComplete = function() {
            if (_this.privIsSynthesizing) {
                _this.privIsSynthesizing = false;
                _this.privIsSynthesisEnded = true;
                _this.privAudioOutputStream.close();
                _this.privInTurn = false;
                if (_this.privTurnAudioDestination !== undefined) {
                    _this.privTurnAudioDestination.close();
                    _this.privTurnAudioDestination = undefined;
                }
            }
        };
        this.privRequestId = $7srwU.createNoDashGuid();
        this.privTurnDeferral = new $7srwU.Deferred();
        // We're not in a turn, so resolve.
        this.privTurnDeferral.resolve();
    }
    Object.defineProperty(SynthesisTurn.prototype, "requestId", {
        get: function() {
            return this.privRequestId;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SynthesisTurn.prototype, "streamId", {
        get: function() {
            return this.privStreamId;
        },
        set: function(value) {
            this.privStreamId = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SynthesisTurn.prototype, "audioOutputFormat", {
        get: function() {
            return this.privAudioOutputFormat;
        },
        set: function(format) {
            this.privAudioOutputFormat = format;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SynthesisTurn.prototype, "turnCompletionPromise", {
        get: function() {
            return this.privTurnDeferral.promise;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SynthesisTurn.prototype, "isSynthesisEnded", {
        get: function() {
            return this.privIsSynthesisEnded;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SynthesisTurn.prototype, "isSynthesizing", {
        get: function() {
            return this.privIsSynthesizing;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SynthesisTurn.prototype, "currentTextOffset", {
        get: function() {
            return this.privTextOffset;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SynthesisTurn.prototype, "bytesReceived", {
        // The number of bytes received for current turn
        get: function() {
            return this.privBytesReceived;
        },
        enumerable: false,
        configurable: true
    });
    SynthesisTurn.prototype.getAllReceivedAudio = function() {
        return $9993e8e19c5bd8ce$var$__awaiter(this, void 0, void 0, function() {
            return $9993e8e19c5bd8ce$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!!this.privReceivedAudio) return [
                            2 /*return*/ ,
                            Promise.resolve(this.privReceivedAudio)
                        ];
                        if (!this.privIsSynthesisEnded) return [
                            2 /*return*/ ,
                            null
                        ];
                        return [
                            4 /*yield*/ ,
                            this.readAllAudioFromStream()
                        ];
                    case 1:
                        _a.sent();
                        return [
                            2 /*return*/ ,
                            Promise.resolve(this.privReceivedAudio)
                        ];
                }
            });
        });
    };
    SynthesisTurn.prototype.getAllReceivedAudioWithHeader = function() {
        return $9993e8e19c5bd8ce$var$__awaiter(this, void 0, void 0, function() {
            var audio;
            return $9993e8e19c5bd8ce$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!!this.privReceivedAudioWithHeader) return [
                            2 /*return*/ ,
                            this.privReceivedAudioWithHeader
                        ];
                        if (!this.privIsSynthesisEnded) return [
                            2 /*return*/ ,
                            null
                        ];
                        if (!this.audioOutputFormat.hasHeader) return [
                            3 /*break*/ ,
                            2
                        ];
                        return [
                            4 /*yield*/ ,
                            this.getAllReceivedAudio()
                        ];
                    case 1:
                        audio = _a.sent();
                        this.privReceivedAudioWithHeader = $lzout.SynthesisAdapterBase.addHeader(audio, this.audioOutputFormat);
                        return [
                            2 /*return*/ ,
                            this.privReceivedAudioWithHeader
                        ];
                    case 2:
                        return [
                            2 /*return*/ ,
                            this.getAllReceivedAudio()
                        ];
                }
            });
        });
    };
    SynthesisTurn.prototype.startNewSynthesis = function(requestId, rawText, isSSML, audioDestination) {
        this.privIsSynthesisEnded = false;
        this.privIsSynthesizing = true;
        this.privRequestId = requestId;
        this.privRawText = rawText;
        this.privIsSSML = isSSML;
        this.privAudioOutputStream = new $epVjg.PullAudioOutputStreamImpl();
        this.privAudioOutputStream.format = this.privAudioOutputFormat;
        this.privReceivedAudio = null;
        this.privReceivedAudioWithHeader = null;
        this.privBytesReceived = 0;
        this.privTextOffset = 0;
        this.privNextSearchTextIndex = 0;
        this.privPartialVisemeAnimation = "";
        if (audioDestination !== undefined) {
            this.privTurnAudioDestination = audioDestination;
            this.privTurnAudioDestination.format = this.privAudioOutputFormat;
        }
        this.onEvent(new $gc98k.SynthesisTriggeredEvent(this.requestId, undefined, audioDestination === undefined ? undefined : audioDestination.id()));
    };
    SynthesisTurn.prototype.onAudioChunkReceived = function(data) {
        if (this.isSynthesizing) {
            this.privAudioOutputStream.write(data);
            this.privBytesReceived += data.byteLength;
            if (this.privTurnAudioDestination !== undefined) this.privTurnAudioDestination.write(data);
        }
    };
    SynthesisTurn.prototype.onWordBoundaryEvent = function(text) {
        this.updateTextOffset(text);
    };
    SynthesisTurn.prototype.onVisemeMetadataReceived = function(metadata) {
        if (metadata.Data.AnimationChunk !== undefined) this.privPartialVisemeAnimation += metadata.Data.AnimationChunk;
    };
    SynthesisTurn.prototype.onStopSynthesizing = function() {
        this.onComplete();
    };
    /**
     * Gets the viseme animation string (merged from animation chunk), and clears the internal
     * partial animation.
     */ SynthesisTurn.prototype.getAndClearVisemeAnimation = function() {
        var animation = this.privPartialVisemeAnimation;
        this.privPartialVisemeAnimation = "";
        return animation;
    };
    SynthesisTurn.prototype.updateTextOffset = function(text) {
        if (this.privTextOffset >= 0) {
            this.privTextOffset = this.privRawText.indexOf(text, this.privNextSearchTextIndex);
            if (this.privTextOffset >= 0) this.privNextSearchTextIndex = this.privTextOffset + text.length;
            if (this.privIsSSML) {
                if (this.privRawText.indexOf("<", this.privTextOffset + 1) > this.privRawText.indexOf(">", this.privTextOffset + 1)) this.updateTextOffset(text);
            }
        }
    };
    SynthesisTurn.prototype.readAllAudioFromStream = function() {
        return $9993e8e19c5bd8ce$var$__awaiter(this, void 0, void 0, function() {
            var e_1;
            return $9993e8e19c5bd8ce$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!this.privIsSynthesisEnded) return [
                            3 /*break*/ ,
                            4
                        ];
                        this.privReceivedAudio = new ArrayBuffer(this.bytesReceived);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4 /*yield*/ ,
                            this.privAudioOutputStream.read(this.privReceivedAudio)
                        ];
                    case 2:
                        _a.sent();
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 3:
                        e_1 = _a.sent();
                        this.privReceivedAudio = new ArrayBuffer(0);
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    return SynthesisTurn;
}();
module.exports.SynthesisTurn = $9993e8e19c5bd8ce$var$SynthesisTurn;

});
parcelRequire.register("lzout", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
var $fb3fdd2438f6996c$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $fb3fdd2438f6996c$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SynthesisAdapterBase = void 0;

var $7srwU = parcelRequire("7srwU");

var $iQDnw = parcelRequire("iQDnw");

var $9MAMI = parcelRequire("9MAMI");

var $eqPE4 = parcelRequire("eqPE4");
var $fb3fdd2438f6996c$var$SynthesisAdapterBase = /** @class */ function() {
    function SynthesisAdapterBase(authentication, connectionFactory, synthesizerConfig, speechSynthesizer, audioDestination) {
        var _this = this;
        this.speakOverride = undefined;
        this.receiveMessageOverride = undefined;
        this.connectImplOverride = undefined;
        this.configConnectionOverride = undefined;
        this.sendSynthesisContext = function(connection) {
            var synthesisContextJson = _this.synthesisContext.toJSON();
            if (synthesisContextJson) return connection.send(new $eqPE4.SpeechConnectionMessage($7srwU.MessageType.Text, "synthesis.context", _this.privSynthesisTurn.requestId, "application/json", synthesisContextJson));
            return;
        };
        this.sendSpeechServiceConfig = function(connection, SpeechServiceConfigJson) {
            if (SpeechServiceConfigJson) return connection.send(new $eqPE4.SpeechConnectionMessage($7srwU.MessageType.Text, "speech.config", _this.privSynthesisTurn.requestId, "application/json", SpeechServiceConfigJson));
        };
        this.sendSsmlMessage = function(connection, ssml, requestId) {
            return connection.send(new $eqPE4.SpeechConnectionMessage($7srwU.MessageType.Text, "ssml", requestId, "application/ssml+xml", ssml));
        };
        if (!authentication) throw new $7srwU.ArgumentNullError("authentication");
        if (!connectionFactory) throw new $7srwU.ArgumentNullError("connectionFactory");
        if (!synthesizerConfig) throw new $7srwU.ArgumentNullError("synthesizerConfig");
        this.privAuthentication = authentication;
        this.privConnectionFactory = connectionFactory;
        this.privSynthesizerConfig = synthesizerConfig;
        this.privIsDisposed = false;
        this.privSpeechSynthesizer = speechSynthesizer;
        this.privSessionAudioDestination = audioDestination;
        this.privSynthesisTurn = new $9MAMI.SynthesisTurn();
        this.privConnectionEvents = new $7srwU.EventSource();
        this.privServiceEvents = new $7srwU.EventSource();
        this.privSynthesisContext = new $9MAMI.SynthesisContext(this.privSpeechSynthesizer);
        this.privAgentConfig = new $9MAMI.AgentConfig();
        this.connectionEvents.attach(function(connectionEvent) {
            if (connectionEvent.name === "ConnectionClosedEvent") {
                var connectionClosedEvent = connectionEvent;
                if (connectionClosedEvent.statusCode !== 1000) _this.cancelSynthesisLocal($iQDnw.CancellationReason.Error, connectionClosedEvent.statusCode === 1007 ? $iQDnw.CancellationErrorCode.BadRequestParameters : $iQDnw.CancellationErrorCode.ConnectionFailure, connectionClosedEvent.reason + " websocket error code: " + connectionClosedEvent.statusCode);
            }
        });
    }
    Object.defineProperty(SynthesisAdapterBase.prototype, "synthesisContext", {
        get: function() {
            return this.privSynthesisContext;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SynthesisAdapterBase.prototype, "agentConfig", {
        get: function() {
            return this.privAgentConfig;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SynthesisAdapterBase.prototype, "connectionEvents", {
        get: function() {
            return this.privConnectionEvents;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SynthesisAdapterBase.prototype, "serviceEvents", {
        get: function() {
            return this.privServiceEvents;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SynthesisAdapterBase.prototype, "activityTemplate", {
        get: function() {
            return this.privActivityTemplate;
        },
        set: function(messagePayload) {
            this.privActivityTemplate = messagePayload;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SynthesisAdapterBase.prototype, "audioOutputFormat", {
        set: function(format) {
            this.privAudioOutputFormat = format;
            this.privSynthesisTurn.audioOutputFormat = format;
            if (this.privSessionAudioDestination !== undefined) this.privSessionAudioDestination.format = format;
            if (this.synthesisContext !== undefined) this.synthesisContext.audioOutputFormat = format;
        },
        enumerable: false,
        configurable: true
    });
    SynthesisAdapterBase.addHeader = function(audio, format) {
        if (!format.hasHeader) return audio;
        format.updateHeader(audio.byteLength);
        var tmp = new Uint8Array(audio.byteLength + format.header.byteLength);
        tmp.set(new Uint8Array(format.header), 0);
        tmp.set(new Uint8Array(audio), format.header.byteLength);
        return tmp.buffer;
    };
    SynthesisAdapterBase.prototype.isDisposed = function() {
        return this.privIsDisposed;
    };
    SynthesisAdapterBase.prototype.dispose = function(reason) {
        return $fb3fdd2438f6996c$var$__awaiter(this, void 0, void 0, function() {
            var connection;
            return $fb3fdd2438f6996c$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        this.privIsDisposed = true;
                        if (this.privSessionAudioDestination !== undefined) this.privSessionAudioDestination.close();
                        if (!this.privConnectionConfigurationPromise) return [
                            3 /*break*/ ,
                            3
                        ];
                        return [
                            4 /*yield*/ ,
                            this.privConnectionConfigurationPromise
                        ];
                    case 1:
                        connection = _a.sent();
                        return [
                            4 /*yield*/ ,
                            connection.dispose(reason)
                        ];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    SynthesisAdapterBase.prototype.connect = function() {
        return $fb3fdd2438f6996c$var$__awaiter(this, void 0, void 0, function() {
            return $fb3fdd2438f6996c$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.connectImpl()
                        ];
                    case 1:
                        _a.sent();
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    SynthesisAdapterBase.prototype.sendNetworkMessage = function(path, payload) {
        return $fb3fdd2438f6996c$var$__awaiter(this, void 0, void 0, function() {
            var type, contentType, connection;
            return $fb3fdd2438f6996c$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        type = typeof payload === "string" ? $7srwU.MessageType.Text : $7srwU.MessageType.Binary;
                        contentType = typeof payload === "string" ? "application/json" : "";
                        return [
                            4 /*yield*/ ,
                            this.fetchConnection()
                        ];
                    case 1:
                        connection = _a.sent();
                        return [
                            2 /*return*/ ,
                            connection.send(new $eqPE4.SpeechConnectionMessage(type, path, this.privSynthesisTurn.requestId, contentType, payload))
                        ];
                }
            });
        });
    };
    SynthesisAdapterBase.prototype.Speak = function(text, isSSML, requestId, successCallback, errorCallBack, audioDestination) {
        return $fb3fdd2438f6996c$var$__awaiter(this, void 0, void 0, function() {
            var ssml, connection, synthesisStartEventArgs, messageRetrievalPromise, e_1;
            return $fb3fdd2438f6996c$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (isSSML) ssml = text;
                        else ssml = this.privSpeechSynthesizer.buildSsml(text);
                        if (this.speakOverride !== undefined) return [
                            2 /*return*/ ,
                            this.speakOverride(ssml, requestId, successCallback, errorCallBack)
                        ];
                        this.privSuccessCallback = successCallback;
                        this.privErrorCallback = errorCallBack;
                        this.privSynthesisTurn.startNewSynthesis(requestId, text, isSSML, audioDestination);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([
                            1,
                            6,
                            ,
                            7
                        ]);
                        return [
                            4 /*yield*/ ,
                            this.connectImpl()
                        ];
                    case 2:
                        _a.sent();
                        return [
                            4 /*yield*/ ,
                            this.fetchConnection()
                        ];
                    case 3:
                        connection = _a.sent();
                        return [
                            4 /*yield*/ ,
                            this.sendSynthesisContext(connection)
                        ];
                    case 4:
                        _a.sent();
                        return [
                            4 /*yield*/ ,
                            this.sendSsmlMessage(connection, ssml, requestId)
                        ];
                    case 5:
                        _a.sent();
                        synthesisStartEventArgs = new $iQDnw.SpeechSynthesisEventArgs(new $iQDnw.SpeechSynthesisResult(requestId, $iQDnw.ResultReason.SynthesizingAudioStarted));
                        if (!!this.privSpeechSynthesizer.synthesisStarted) this.privSpeechSynthesizer.synthesisStarted(this.privSpeechSynthesizer, synthesisStartEventArgs);
                        messageRetrievalPromise = this.receiveMessage();
                        return [
                            3 /*break*/ ,
                            7
                        ];
                    case 6:
                        e_1 = _a.sent();
                        this.cancelSynthesisLocal($iQDnw.CancellationReason.Error, $iQDnw.CancellationErrorCode.ConnectionFailure, e_1);
                        return [
                            2 /*return*/ ,
                            Promise.reject(e_1)
                        ];
                    case 7:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    // Cancels synthesis.
    SynthesisAdapterBase.prototype.cancelSynthesis = function(requestId, cancellationReason, errorCode, error) {
        var properties = new $iQDnw.PropertyCollection();
        properties.setProperty($9MAMI.CancellationErrorCodePropertyName, $iQDnw.CancellationErrorCode[errorCode]);
        var result = new $iQDnw.SpeechSynthesisResult(requestId, $iQDnw.ResultReason.Canceled, undefined, error, properties);
        if (!!this.privSpeechSynthesizer.SynthesisCanceled) {
            var cancelEvent = new $iQDnw.SpeechSynthesisEventArgs(result);
            try {
                this.privSpeechSynthesizer.SynthesisCanceled(this.privSpeechSynthesizer, cancelEvent);
            /* tslint:disable:no-empty */ } catch (_a) {}
        }
        if (!!this.privSuccessCallback) try {
            this.privSuccessCallback(result);
        /* tslint:disable:no-empty */ } catch (_b) {}
    };
    // Cancels synthesis.
    SynthesisAdapterBase.prototype.cancelSynthesisLocal = function(cancellationReason, errorCode, error) {
        if (!!this.privSynthesisTurn.isSynthesizing) {
            this.privSynthesisTurn.onStopSynthesizing();
            this.cancelSynthesis(this.privSynthesisTurn.requestId, cancellationReason, errorCode, error);
        }
    };
    SynthesisAdapterBase.prototype.processTypeSpecificMessages = function(connectionMessage, successCallback, errorCallBack) {
        return true;
    };
    SynthesisAdapterBase.prototype.receiveMessage = function() {
        return $fb3fdd2438f6996c$var$__awaiter(this, void 0, void 0, function() {
            var connection, message, connectionMessage, _a, audioWithHeader, ev, metadataList, _i, metadataList_1, metadata, wordBoundaryEventArgs, bookmarkEventArgs, visemeEventArgs, result, audioBuffer, error_1, e_2;
            return $fb3fdd2438f6996c$var$__generator(this, function(_b) {
                switch(_b.label){
                    case 0:
                        _b.trys.push([
                            0,
                            14,
                            ,
                            15
                        ]);
                        return [
                            4 /*yield*/ ,
                            this.fetchConnection()
                        ];
                    case 1:
                        connection = _b.sent();
                        return [
                            4 /*yield*/ ,
                            connection.read()
                        ];
                    case 2:
                        message = _b.sent();
                        if (this.receiveMessageOverride !== undefined) return [
                            2 /*return*/ ,
                            this.receiveMessageOverride()
                        ];
                        if (this.privIsDisposed) // We're done.
                        return [
                            2 /*return*/ 
                        ];
                        // indicates we are draining the queue and it came with no message;
                        if (!message) {
                            if (!this.privSynthesisTurn.isSynthesizing) return [
                                2 /*return*/ 
                            ];
                            else return [
                                2 /*return*/ ,
                                this.receiveMessage()
                            ];
                        }
                        this.privServiceHasSentMessage = true;
                        connectionMessage = $eqPE4.SpeechConnectionMessage.fromConnectionMessage(message);
                        if (!(connectionMessage.requestId.toLowerCase() === this.privSynthesisTurn.requestId.toLowerCase())) return [
                            3 /*break*/ ,
                            13
                        ];
                        _a = connectionMessage.path.toLowerCase();
                        switch(_a){
                            case "turn.start":
                                return [
                                    3 /*break*/ ,
                                    3
                                ];
                            case "response":
                                return [
                                    3 /*break*/ ,
                                    4
                                ];
                            case "audio":
                                return [
                                    3 /*break*/ ,
                                    5
                                ];
                            case "audio.metadata":
                                return [
                                    3 /*break*/ ,
                                    6
                                ];
                            case "turn.end":
                                return [
                                    3 /*break*/ ,
                                    7
                                ];
                        }
                        return [
                            3 /*break*/ ,
                            12
                        ];
                    case 3:
                        this.privSynthesisTurn.onServiceTurnStartResponse();
                        return [
                            3 /*break*/ ,
                            13
                        ];
                    case 4:
                        this.privSynthesisTurn.onServiceResponseMessage(connectionMessage.textBody);
                        return [
                            3 /*break*/ ,
                            13
                        ];
                    case 5:
                        if (this.privSynthesisTurn.streamId.toLowerCase() === connectionMessage.streamId.toLowerCase() && !!connectionMessage.binaryBody) {
                            this.privSynthesisTurn.onAudioChunkReceived(connectionMessage.binaryBody);
                            if (!!this.privSpeechSynthesizer.synthesizing) try {
                                audioWithHeader = SynthesisAdapterBase.addHeader(connectionMessage.binaryBody, this.privSynthesisTurn.audioOutputFormat);
                                ev = new $iQDnw.SpeechSynthesisEventArgs(new $iQDnw.SpeechSynthesisResult(this.privSynthesisTurn.requestId, $iQDnw.ResultReason.SynthesizingAudio, audioWithHeader));
                                this.privSpeechSynthesizer.synthesizing(this.privSpeechSynthesizer, ev);
                            } catch (error) {
                            // Not going to let errors in the event handler
                            // trip things up.
                            }
                            if (this.privSessionAudioDestination !== undefined) this.privSessionAudioDestination.write(connectionMessage.binaryBody);
                        }
                        return [
                            3 /*break*/ ,
                            13
                        ];
                    case 6:
                        metadataList = $9MAMI.SynthesisAudioMetadata.fromJSON(connectionMessage.textBody).Metadata;
                        for(_i = 0, metadataList_1 = metadataList; _i < metadataList_1.length; _i++){
                            metadata = metadataList_1[_i];
                            switch(metadata.Type){
                                case $9MAMI.MetadataType.WordBoundary:
                                    this.privSynthesisTurn.onWordBoundaryEvent(metadata.Data.text.Text);
                                    wordBoundaryEventArgs = new $iQDnw.SpeechSynthesisWordBoundaryEventArgs(metadata.Data.Offset, metadata.Data.text.Text, metadata.Data.text.Length, this.privSynthesisTurn.currentTextOffset);
                                    if (!!this.privSpeechSynthesizer.wordBoundary) try {
                                        this.privSpeechSynthesizer.wordBoundary(this.privSpeechSynthesizer, wordBoundaryEventArgs);
                                    } catch (error) {
                                    // Not going to let errors in the event handler
                                    // trip things up.
                                    }
                                    break;
                                case $9MAMI.MetadataType.Bookmark:
                                    bookmarkEventArgs = new $iQDnw.SpeechSynthesisBookmarkEventArgs(metadata.Data.Offset, metadata.Data.Bookmark);
                                    if (!!this.privSpeechSynthesizer.bookmarkReached) try {
                                        this.privSpeechSynthesizer.bookmarkReached(this.privSpeechSynthesizer, bookmarkEventArgs);
                                    } catch (error) {
                                    // Not going to let errors in the event handler
                                    // trip things up.
                                    }
                                    break;
                                case $9MAMI.MetadataType.Viseme:
                                    this.privSynthesisTurn.onVisemeMetadataReceived(metadata);
                                    if (metadata.Data.IsLastAnimation) {
                                        visemeEventArgs = new $iQDnw.SpeechSynthesisVisemeEventArgs(metadata.Data.Offset, metadata.Data.VisemeId, this.privSynthesisTurn.getAndClearVisemeAnimation());
                                        if (!!this.privSpeechSynthesizer.visemeReceived) try {
                                            this.privSpeechSynthesizer.visemeReceived(this.privSpeechSynthesizer, visemeEventArgs);
                                        } catch (error) {
                                        // Not going to let errors in the event handler
                                        // trip things up.
                                        }
                                    }
                                    break;
                            }
                        }
                        return [
                            3 /*break*/ ,
                            13
                        ];
                    case 7:
                        this.privSynthesisTurn.onServiceTurnEndResponse();
                        result = void 0;
                        _b.label = 8;
                    case 8:
                        _b.trys.push([
                            8,
                            10,
                            ,
                            11
                        ]);
                        return [
                            4 /*yield*/ ,
                            this.privSynthesisTurn.getAllReceivedAudioWithHeader()
                        ];
                    case 9:
                        audioBuffer = _b.sent();
                        result = new $iQDnw.SpeechSynthesisResult(this.privSynthesisTurn.requestId, $iQDnw.ResultReason.SynthesizingAudioCompleted, audioBuffer);
                        if (!!this.privSuccessCallback) this.privSuccessCallback(result);
                        return [
                            3 /*break*/ ,
                            11
                        ];
                    case 10:
                        error_1 = _b.sent();
                        if (!!this.privErrorCallback) this.privErrorCallback(error_1);
                        return [
                            3 /*break*/ ,
                            11
                        ];
                    case 11:
                        if (this.privSpeechSynthesizer.synthesisCompleted) try {
                            this.privSpeechSynthesizer.synthesisCompleted(this.privSpeechSynthesizer, new $iQDnw.SpeechSynthesisEventArgs(result));
                        } catch (e) {
                        // Not going to let errors in the event handler
                        // trip things up.
                        }
                        return [
                            3 /*break*/ ,
                            13
                        ];
                    case 12:
                        if (!this.processTypeSpecificMessages(connectionMessage)) // here are some messages that the derived class has not processed, dispatch them to connect class
                        {
                            if (!!this.privServiceEvents) this.serviceEvents.onEvent(new $7srwU.ServiceEvent(connectionMessage.path.toLowerCase(), connectionMessage.textBody));
                        }
                        _b.label = 13;
                    case 13:
                        return [
                            2 /*return*/ ,
                            this.receiveMessage()
                        ];
                    case 14:
                        e_2 = _b.sent();
                        return [
                            3 /*break*/ ,
                            15
                        ];
                    case 15:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    SynthesisAdapterBase.prototype.connectImpl = function(isUnAuthorized) {
        var _this = this;
        if (isUnAuthorized === void 0) isUnAuthorized = false;
        if (this.privConnectionPromise) return this.privConnectionPromise.then(function(connection) {
            if (connection.state() === $7srwU.ConnectionState.Disconnected) {
                _this.privConnectionId = null;
                _this.privConnectionPromise = null;
                _this.privServiceHasSentMessage = false;
                return _this.connectImpl();
            }
            return _this.privConnectionPromise;
        }, function(error) {
            _this.privConnectionId = null;
            _this.privConnectionPromise = null;
            _this.privServiceHasSentMessage = false;
            return _this.connectImpl();
        });
        this.privAuthFetchEventId = $7srwU.createNoDashGuid();
        this.privConnectionId = $7srwU.createNoDashGuid();
        this.privSynthesisTurn.onPreConnectionStart(this.privAuthFetchEventId, this.privConnectionId);
        var authPromise = isUnAuthorized ? this.privAuthentication.fetchOnExpiry(this.privAuthFetchEventId) : this.privAuthentication.fetch(this.privAuthFetchEventId);
        this.privConnectionPromise = authPromise.then(function(result) {
            return $fb3fdd2438f6996c$var$__awaiter(_this, void 0, void 0, function() {
                var connection, response;
                var _this = this;
                return $fb3fdd2438f6996c$var$__generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            return [
                                4 /*yield*/ ,
                                this.privSynthesisTurn.onAuthCompleted(false)
                            ];
                        case 1:
                            _a.sent();
                            connection = this.privConnectionFactory.create(this.privSynthesizerConfig, result, this.privConnectionId);
                            // Attach to the underlying event. No need to hold onto the detach pointers as in the event the connection goes away,
                            // it'll stop sending events.
                            connection.events.attach(function(event) {
                                _this.connectionEvents.onEvent(event);
                            });
                            return [
                                4 /*yield*/ ,
                                connection.open()
                            ];
                        case 2:
                            response = _a.sent();
                            if (!(response.statusCode === 200)) return [
                                3 /*break*/ ,
                                4
                            ];
                            return [
                                4 /*yield*/ ,
                                this.privSynthesisTurn.onConnectionEstablishCompleted(response.statusCode)
                            ];
                        case 3:
                            _a.sent();
                            return [
                                2 /*return*/ ,
                                Promise.resolve(connection)
                            ];
                        case 4:
                            if (!(response.statusCode === 403 && !isUnAuthorized)) return [
                                3 /*break*/ ,
                                5
                            ];
                            return [
                                2 /*return*/ ,
                                this.connectImpl(true)
                            ];
                        case 5:
                            return [
                                4 /*yield*/ ,
                                this.privSynthesisTurn.onConnectionEstablishCompleted(response.statusCode, response.reason)
                            ];
                        case 6:
                            _a.sent();
                            return [
                                2 /*return*/ ,
                                Promise.reject("Unable to contact server. StatusCode: " + response.statusCode + ", " + this.privSynthesizerConfig.parameters.getProperty($iQDnw.PropertyId.SpeechServiceConnection_Endpoint) + " Reason: " + response.reason)
                            ];
                    }
                });
            });
        }, function(error) {
            return $fb3fdd2438f6996c$var$__awaiter(_this, void 0, void 0, function() {
                return $fb3fdd2438f6996c$var$__generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            return [
                                4 /*yield*/ ,
                                this.privSynthesisTurn.onAuthCompleted(true, error)
                            ];
                        case 1:
                            _a.sent();
                            throw new Error(error);
                    }
                });
            });
        });
        // Attach an empty handler to allow the promise to run in the background while
        // other startup events happen. It'll eventually be awaited on.
        this.privConnectionPromise.catch(function() {});
        return this.privConnectionPromise;
    };
    SynthesisAdapterBase.prototype.fetchConnection = function() {
        return $fb3fdd2438f6996c$var$__awaiter(this, void 0, void 0, function() {
            var _this = this;
            return $fb3fdd2438f6996c$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (this.privConnectionConfigurationPromise) return [
                            2 /*return*/ ,
                            this.privConnectionConfigurationPromise.then(function(connection) {
                                if (connection.state() === $7srwU.ConnectionState.Disconnected) {
                                    _this.privConnectionId = null;
                                    _this.privConnectionConfigurationPromise = null;
                                    _this.privServiceHasSentMessage = false;
                                    return _this.fetchConnection();
                                }
                                return _this.privConnectionConfigurationPromise;
                            }, function(error) {
                                _this.privConnectionId = null;
                                _this.privConnectionConfigurationPromise = null;
                                _this.privServiceHasSentMessage = false;
                                return _this.fetchConnection();
                            })
                        ];
                        this.privConnectionConfigurationPromise = this.configureConnection();
                        return [
                            4 /*yield*/ ,
                            this.privConnectionConfigurationPromise
                        ];
                    case 1:
                        return [
                            2 /*return*/ ,
                            _a.sent()
                        ];
                }
            });
        });
    };
    // Takes an established websocket connection to the endpoint and sends speech configuration information.
    SynthesisAdapterBase.prototype.configureConnection = function() {
        return $fb3fdd2438f6996c$var$__awaiter(this, void 0, void 0, function() {
            var connection;
            return $fb3fdd2438f6996c$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.connectImpl()
                        ];
                    case 1:
                        connection = _a.sent();
                        if (this.configConnectionOverride !== undefined) return [
                            2 /*return*/ ,
                            this.configConnectionOverride(connection)
                        ];
                        return [
                            4 /*yield*/ ,
                            this.sendSpeechServiceConfig(connection, this.privSynthesizerConfig.SpeechServiceConfig.serialize())
                        ];
                    case 2:
                        _a.sent();
                        return [
                            2 /*return*/ ,
                            connection
                        ];
                }
            });
        });
    };
    SynthesisAdapterBase.telemetryDataEnabled = true;
    return SynthesisAdapterBase;
}();
module.exports.SynthesisAdapterBase = $fb3fdd2438f6996c$var$SynthesisAdapterBase;

});

parcelRequire.register("gc98k", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
var $bca4da084d5a0ac7$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SynthesisStartedEvent = module.exports.ConnectingToSynthesisServiceEvent = module.exports.SynthesisTriggeredEvent = module.exports.SpeechSynthesisEvent = void 0;

var $7srwU = parcelRequire("7srwU");
var $bca4da084d5a0ac7$var$SpeechSynthesisEvent = /** @class */ function(_super) {
    $bca4da084d5a0ac7$var$__extends(SpeechSynthesisEvent, _super);
    function SpeechSynthesisEvent(eventName, requestId, eventType) {
        if (eventType === void 0) eventType = $7srwU.EventType.Info;
        var _this = _super.call(this, eventName, eventType) || this;
        _this.privRequestId = requestId;
        return _this;
    }
    Object.defineProperty(SpeechSynthesisEvent.prototype, "requestId", {
        get: function() {
            return this.privRequestId;
        },
        enumerable: false,
        configurable: true
    });
    return SpeechSynthesisEvent;
}($7srwU.PlatformEvent);
module.exports.SpeechSynthesisEvent = $bca4da084d5a0ac7$var$SpeechSynthesisEvent;
var $bca4da084d5a0ac7$var$SynthesisTriggeredEvent = /** @class */ function(_super) {
    $bca4da084d5a0ac7$var$__extends(SynthesisTriggeredEvent, _super);
    function SynthesisTriggeredEvent(requestId, sessionAudioDestinationId, turnAudioDestinationId) {
        var _this = _super.call(this, "SynthesisTriggeredEvent", requestId) || this;
        _this.privSessionAudioDestinationId = sessionAudioDestinationId;
        _this.privTurnAudioDestinationId = turnAudioDestinationId;
        return _this;
    }
    Object.defineProperty(SynthesisTriggeredEvent.prototype, "audioSessionDestinationId", {
        get: function() {
            return this.privSessionAudioDestinationId;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SynthesisTriggeredEvent.prototype, "audioTurnDestinationId", {
        get: function() {
            return this.privTurnAudioDestinationId;
        },
        enumerable: false,
        configurable: true
    });
    return SynthesisTriggeredEvent;
}($bca4da084d5a0ac7$var$SpeechSynthesisEvent);
module.exports.SynthesisTriggeredEvent = $bca4da084d5a0ac7$var$SynthesisTriggeredEvent;
var $bca4da084d5a0ac7$var$ConnectingToSynthesisServiceEvent = /** @class */ function(_super) {
    $bca4da084d5a0ac7$var$__extends(ConnectingToSynthesisServiceEvent, _super);
    function ConnectingToSynthesisServiceEvent(requestId, authFetchEventId) {
        var _this = _super.call(this, "ConnectingToSynthesisServiceEvent", requestId) || this;
        _this.privAuthFetchEventId = authFetchEventId;
        return _this;
    }
    Object.defineProperty(ConnectingToSynthesisServiceEvent.prototype, "authFetchEventId", {
        get: function() {
            return this.privAuthFetchEventId;
        },
        enumerable: false,
        configurable: true
    });
    return ConnectingToSynthesisServiceEvent;
}($bca4da084d5a0ac7$var$SpeechSynthesisEvent);
module.exports.ConnectingToSynthesisServiceEvent = $bca4da084d5a0ac7$var$ConnectingToSynthesisServiceEvent;
var $bca4da084d5a0ac7$var$SynthesisStartedEvent = /** @class */ function(_super) {
    $bca4da084d5a0ac7$var$__extends(SynthesisStartedEvent, _super);
    function SynthesisStartedEvent(requestId, authFetchEventId) {
        var _this = _super.call(this, "SynthesisStartedEvent", requestId) || this;
        _this.privAuthFetchEventId = authFetchEventId;
        return _this;
    }
    Object.defineProperty(SynthesisStartedEvent.prototype, "authFetchEventId", {
        get: function() {
            return this.privAuthFetchEventId;
        },
        enumerable: false,
        configurable: true
    });
    return SynthesisStartedEvent;
}($bca4da084d5a0ac7$var$SpeechSynthesisEvent);
module.exports.SynthesisStartedEvent = $bca4da084d5a0ac7$var$SynthesisStartedEvent;

});


parcelRequire.register("gYgJV", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SynthesizerConfig = module.exports.SynthesisServiceType = void 0;

var $9MAMI = parcelRequire("9MAMI");
var $c5af3c1d79a8ce75$var$SynthesisServiceType;
(function(SynthesisServiceType) {
    SynthesisServiceType[SynthesisServiceType["Standard"] = 0] = "Standard";
    SynthesisServiceType[SynthesisServiceType["Custom"] = 1] = "Custom";
})($c5af3c1d79a8ce75$var$SynthesisServiceType = module.exports.SynthesisServiceType || (module.exports.SynthesisServiceType = {}));
var $c5af3c1d79a8ce75$var$SynthesizerConfig = /** @class */ function() {
    function SynthesizerConfig(speechServiceConfig, parameters) {
        this.privSynthesisServiceType = $c5af3c1d79a8ce75$var$SynthesisServiceType.Standard;
        this.privSpeechServiceConfig = speechServiceConfig ? speechServiceConfig : new $9MAMI.SpeechServiceConfig(new $9MAMI.Context(null));
        this.privParameters = parameters;
    }
    Object.defineProperty(SynthesizerConfig.prototype, "parameters", {
        get: function() {
            return this.privParameters;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SynthesizerConfig.prototype, "synthesisServiceType", {
        get: function() {
            return this.privSynthesisServiceType;
        },
        set: function(value) {
            this.privSynthesisServiceType = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SynthesizerConfig.prototype, "SpeechServiceConfig", {
        get: function() {
            return this.privSpeechServiceConfig;
        },
        enumerable: false,
        configurable: true
    });
    return SynthesizerConfig;
}();
module.exports.SynthesizerConfig = $c5af3c1d79a8ce75$var$SynthesizerConfig;

});

parcelRequire.register("kJuuX", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SynthesisContext = void 0;
/**
 * Represents the JSON used in the synthesis.context message sent to the speech service.
 * The dynamic grammar is always refreshed from the encapsulated dynamic grammar object.
 */ var $f17faaf530ddec2c$var$SynthesisContext = /** @class */ function() {
    function SynthesisContext(speechSynthesizer) {
        this.privContext = {};
        this.privSpeechSynthesizer = speechSynthesizer;
    }
    /**
     * Adds a section to the synthesis.context object.
     * @param sectionName Name of the section to add.
     * @param value JSON serializable object that represents the value.
     */ SynthesisContext.prototype.setSection = function(sectionName, value) {
        this.privContext[sectionName] = value;
    };
    Object.defineProperty(SynthesisContext.prototype, "audioOutputFormat", {
        /**
         * Sets the audio output format for synthesis context generation.
         * @param format {AudioOutputFormatImpl} the output format
         */ set: function(format) {
            this.privAudioOutputFormat = format;
        },
        enumerable: false,
        configurable: true
    });
    SynthesisContext.prototype.toJSON = function() {
        var synthesisSection = this.buildSynthesisContext();
        this.setSection("synthesis", synthesisSection);
        return JSON.stringify(this.privContext);
    };
    SynthesisContext.prototype.buildSynthesisContext = function() {
        return {
            audio: {
                metadataOptions: {
                    bookmarkEnabled: !!this.privSpeechSynthesizer.bookmarkReached,
                    sentenceBoundaryEnabled: false,
                    visemeEnabled: !!this.privSpeechSynthesizer.visemeReceived,
                    wordBoundaryEnabled: !!this.privSpeechSynthesizer.wordBoundary
                },
                outputFormat: this.privAudioOutputFormat.requestAudioFormatString
            },
            language: {
                autoDetection: this.privSpeechSynthesizer.autoDetectSourceLanguage
            }
        };
    };
    return SynthesisContext;
}();
module.exports.SynthesisContext = $f17faaf530ddec2c$var$SynthesisContext;

});

parcelRequire.register("jXSj0", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SpeakerRecognitionConfig = void 0;

var $9MAMI = parcelRequire("9MAMI");
var $e88da6f89d40680d$var$SpeakerRecognitionConfig = /** @class */ function() {
    function SpeakerRecognitionConfig(context, parameters) {
        this.privContext = context ? context : new $9MAMI.Context(null);
        this.privParameters = parameters;
    }
    Object.defineProperty(SpeakerRecognitionConfig.prototype, "parameters", {
        get: function() {
            return this.privParameters;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SpeakerRecognitionConfig.prototype, "Context", {
        get: function() {
            return this.privContext;
        },
        enumerable: false,
        configurable: true
    });
    return SpeakerRecognitionConfig;
}();
module.exports.SpeakerRecognitionConfig = $e88da6f89d40680d$var$SpeakerRecognitionConfig;

});

parcelRequire.register("8x4f9", function(module, exports) {
"use strict";
var $6364b26d483150f5$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $6364b26d483150f5$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SpeakerIdMessageAdapter = void 0;

var $9h4kO = parcelRequire("9h4kO");

var $iQDnw = parcelRequire("iQDnw");
/**
 * Implements methods for speaker recognition classes, sending requests to endpoint
 * and parsing response into expected format
 * @class SpeakerIdMessageAdapter
 */ var $6364b26d483150f5$var$SpeakerIdMessageAdapter = /** @class */ function() {
    function SpeakerIdMessageAdapter(config) {
        var endpoint = config.parameters.getProperty($iQDnw.PropertyId.SpeechServiceConnection_Endpoint, undefined);
        if (!endpoint) {
            var region = config.parameters.getProperty($iQDnw.PropertyId.SpeechServiceConnection_Region, "westus");
            var hostSuffix = region && region.toLowerCase().startsWith("china") ? ".azure.cn" : ".microsoft.com";
            var host = config.parameters.getProperty($iQDnw.PropertyId.SpeechServiceConnection_Host, "https://" + region + ".api.cognitive" + hostSuffix + "/speaker/{mode}/v2.0/{dependency}");
            endpoint = host + "/profiles";
        }
        this.privUri = endpoint;
        var options = $9h4kO.RestConfigBase.requestOptions;
        options.headers[$9h4kO.RestConfigBase.configParams.subscriptionKey] = config.parameters.getProperty($iQDnw.PropertyId.SpeechServiceConnection_Key, undefined);
        this.privRestAdapter = new $9h4kO.RestMessageAdapter(options);
    }
    /**
     * Sends create profile request to endpoint.
     * @function
     * @param {VoiceProfileType} profileType - type of voice profile to create.
     * @param {string} lang - language/locale of voice profile
     * @public
     * @returns {Promise<IRestResponse>} promised rest response containing id of created profile.
     */ SpeakerIdMessageAdapter.prototype.createProfile = function(profileType, lang) {
        var uri = this.getOperationUri(profileType);
        this.privRestAdapter.setHeaders($9h4kO.RestConfigBase.configParams.contentTypeKey, "application/json");
        return this.privRestAdapter.request($9h4kO.RestRequestType.Post, uri, {}, {
            locale: lang
        });
    };
    /**
     * Sends create enrollment request to endpoint.
     * @function
     * @param {VoiceProfile} profileType - voice profile for which to create new enrollment.
     * @param {IAudioSource} audioSource - audioSource from which to pull data to send
     * @public
     * @returns {Promise<IRestResponse>} rest response to enrollment request.
     */ SpeakerIdMessageAdapter.prototype.createEnrollment = function(profile, audioSource) {
        var _this = this;
        this.privRestAdapter.setHeaders($9h4kO.RestConfigBase.configParams.contentTypeKey, "multipart/form-data");
        var uri = this.getOperationUri(profile.profileType) + "/" + profile.profileId + "/enrollments";
        return audioSource.blob.then(function(result) {
            return _this.privRestAdapter.request($9h4kO.RestRequestType.File, uri, {
                ignoreMinLength: "true"
            }, null, result);
        });
    };
    /**
     * Sends verification request to endpoint.
     * @function
     * @param {SpeakerVerificationModel} model - voice model to verify against.
     * @param {IAudioSource} audioSource - audioSource from which to pull data to send
     * @public
     * @returns {Promise<IRestResponse>} rest response to enrollment request.
     */ SpeakerIdMessageAdapter.prototype.verifySpeaker = function(model, audioSource) {
        return $6364b26d483150f5$var$__awaiter(this, void 0, void 0, function() {
            var uri, result, e_1;
            return $6364b26d483150f5$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        this.privRestAdapter.setHeaders($9h4kO.RestConfigBase.configParams.contentTypeKey, "multipart/form-data");
                        uri = this.getOperationUri(model.voiceProfile.profileType) + "/" + model.voiceProfile.profileId + "/verify";
                        _a.label = 1;
                    case 1:
                        _a.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4 /*yield*/ ,
                            audioSource.blob
                        ];
                    case 2:
                        result = _a.sent();
                        return [
                            2 /*return*/ ,
                            this.privRestAdapter.request($9h4kO.RestRequestType.File, uri, {
                                ignoreMinLength: "true"
                            }, null, result)
                        ];
                    case 3:
                        e_1 = _a.sent();
                        return [
                            2 /*return*/ ,
                            Promise.resolve({
                                data: e_1
                            })
                        ];
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * Sends identification request to endpoint.
     * @function
     * @param {SpeakerIdentificationModel} model - voice profiles against which to identify.
     * @param {IAudioSource} audioSource - audioSource from which to pull data to send
     * @public
     * @returns {Promise<IRestResponse>} rest response to enrollment request.
     */ SpeakerIdMessageAdapter.prototype.identifySpeaker = function(model, audioSource) {
        return $6364b26d483150f5$var$__awaiter(this, void 0, void 0, function() {
            var uri, result, e_2;
            return $6364b26d483150f5$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        this.privRestAdapter.setHeaders($9h4kO.RestConfigBase.configParams.contentTypeKey, "multipart/form-data");
                        uri = this.getOperationUri($iQDnw.VoiceProfileType.TextIndependentIdentification) + "/identifySingleSpeaker";
                        _a.label = 1;
                    case 1:
                        _a.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4 /*yield*/ ,
                            audioSource.blob
                        ];
                    case 2:
                        result = _a.sent();
                        return [
                            2 /*return*/ ,
                            this.privRestAdapter.request($9h4kO.RestRequestType.File, uri, {
                                profileIds: model.voiceProfileIds,
                                ignoreMinLength: "true"
                            }, null, result)
                        ];
                    case 3:
                        e_2 = _a.sent();
                        return [
                            2 /*return*/ ,
                            Promise.resolve({
                                data: e_2
                            })
                        ];
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * Sends profile status request to endpoint.
     * @function
     * @param {VoiceProfile} profile - voice profile to check.
     * @public
     * @returns {Promise<IRestResponse>} rest response to status request
     */ SpeakerIdMessageAdapter.prototype.getProfileStatus = function(profile) {
        var uri = this.getOperationUri(profile.profileType) + "/" + profile.profileId;
        return this.privRestAdapter.request($9h4kO.RestRequestType.Get, uri, {});
    };
    /**
     * Sends get all profiles request to endpoint.
     * @function
     * @param {VoiceProfileType} profileType - type of profiles to return list of
     * @public
     * @returns {Promise<IRestResponse>} promised rest response containing all profiles
     */ SpeakerIdMessageAdapter.prototype.getProfiles = function(profileType) {
        var uri = this.getOperationUri(profileType);
        return this.privRestAdapter.request($9h4kO.RestRequestType.Get, uri, {});
    };
    /**
     * Sends get authorization phrases request to endpoint.
     * @function
     * @param {string} lang - language/locale of voice profile
     * @public
     * @returns {Promise<IRestResponse>} promised rest response containing list of valid phrases
     */ SpeakerIdMessageAdapter.prototype.getAuthorizationPhrases = function(lang) {
        var uri = ("" + this.getOperationUri($iQDnw.VoiceProfileType.TextDependentVerification)).replace("profiles", "phrases") + "/" + lang;
        return this.privRestAdapter.request($9h4kO.RestRequestType.Get, uri, {});
    };
    /**
     * Sends delete profile request to endpoint.
     * @function
     * @param {VoiceProfile} profile - voice profile to delete.
     * @public
     * @returns {Promise<IRestResponse>} rest response to deletion request
     */ SpeakerIdMessageAdapter.prototype.deleteProfile = function(profile) {
        var uri = this.getOperationUri(profile.profileType) + "/" + profile.profileId;
        return this.privRestAdapter.request($9h4kO.RestRequestType.Delete, uri, {});
    };
    /**
     * Sends reset profile request to endpoint.
     * @function
     * @param {VoiceProfile} profile - voice profile to reset enrollments for.
     * @public
     * @returns {Promise<IRestResponse>} rest response to reset request
     */ SpeakerIdMessageAdapter.prototype.resetProfile = function(profile) {
        var uri = this.getOperationUri(profile.profileType) + "/" + profile.profileId + "/reset";
        return this.privRestAdapter.request($9h4kO.RestRequestType.Post, uri, {});
    };
    SpeakerIdMessageAdapter.prototype.getOperationUri = function(profileType) {
        var mode = profileType === $iQDnw.VoiceProfileType.TextIndependentIdentification ? "identification" : "verification";
        var dependency = profileType === $iQDnw.VoiceProfileType.TextDependentVerification ? "text-dependent" : "text-independent";
        return this.privUri.replace("{mode}", mode).replace("{dependency}", dependency);
    };
    return SpeakerIdMessageAdapter;
}();
module.exports.SpeakerIdMessageAdapter = $6364b26d483150f5$var$SpeakerIdMessageAdapter;

});



parcelRequire.register("if33N", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
var $d47c0067abc18229$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $d47c0067abc18229$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.FileAudioSource = void 0;

var $9MAMI = parcelRequire("9MAMI");

var $7srwU = parcelRequire("7srwU");

var $7PHxc = parcelRequire("7PHxc");
var $d47c0067abc18229$var$FileAudioSource = /** @class */ function() {
    function FileAudioSource(file, filename, audioSourceId) {
        var _this = this;
        this.privStreams = {};
        this.privHeaderEnd = 44;
        this.turnOn = function() {
            if (_this.privFilename.lastIndexOf(".wav") !== _this.privFilename.length - 4) {
                var errorMsg = _this.privFilename + " is not supported. Only WAVE files are allowed at the moment.";
                _this.onEvent(new $7srwU.AudioSourceErrorEvent(errorMsg, ""));
                return Promise.reject(errorMsg);
            }
            _this.onEvent(new $7srwU.AudioSourceInitializingEvent(_this.privId)); // no stream id
            _this.onEvent(new $7srwU.AudioSourceReadyEvent(_this.privId));
            return;
        };
        this.id = function() {
            return _this.privId;
        };
        this.attach = function(audioNodeId) {
            return $d47c0067abc18229$var$__awaiter(_this, void 0, void 0, function() {
                var stream;
                var _this = this;
                return $d47c0067abc18229$var$__generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            this.onEvent(new $7srwU.AudioStreamNodeAttachingEvent(this.privId, audioNodeId));
                            return [
                                4 /*yield*/ ,
                                this.upload(audioNodeId)
                            ];
                        case 1:
                            stream = _a.sent();
                            this.onEvent(new $7srwU.AudioStreamNodeAttachedEvent(this.privId, audioNodeId));
                            return [
                                2 /*return*/ ,
                                Promise.resolve({
                                    detach: function() {
                                        return $d47c0067abc18229$var$__awaiter(_this, void 0, void 0, function() {
                                            return $d47c0067abc18229$var$__generator(this, function(_a) {
                                                switch(_a.label){
                                                    case 0:
                                                        stream.readEnded();
                                                        delete this.privStreams[audioNodeId];
                                                        this.onEvent(new $7srwU.AudioStreamNodeDetachedEvent(this.privId, audioNodeId));
                                                        return [
                                                            4 /*yield*/ ,
                                                            this.turnOff()
                                                        ];
                                                    case 1:
                                                        _a.sent();
                                                        return [
                                                            2 /*return*/ 
                                                        ];
                                                }
                                            });
                                        });
                                    },
                                    id: function() {
                                        return audioNodeId;
                                    },
                                    read: function() {
                                        return stream.read();
                                    }
                                })
                            ];
                    }
                });
            });
        };
        this.detach = function(audioNodeId) {
            if (audioNodeId && _this.privStreams[audioNodeId]) {
                _this.privStreams[audioNodeId].close();
                delete _this.privStreams[audioNodeId];
                _this.onEvent(new $7srwU.AudioStreamNodeDetachedEvent(_this.privId, audioNodeId));
            }
        };
        this.turnOff = function() {
            for(var streamId in _this.privStreams)if (streamId) {
                var stream = _this.privStreams[streamId];
                if (stream && !stream.isClosed) stream.close();
            }
            _this.onEvent(new $7srwU.AudioSourceOffEvent(_this.privId)); // no stream now
            return Promise.resolve();
        };
        this.onEvent = function(event) {
            _this.privEvents.onEvent(event);
            $7srwU.Events.instance.onEvent(event);
        };
        this.privId = audioSourceId ? audioSourceId : $7srwU.createNoDashGuid();
        this.privEvents = new $7srwU.EventSource();
        this.privSource = file;
        if (typeof window !== "undefined" && typeof Blob !== "undefined" && this.privSource instanceof Blob) this.privFilename = file.name;
        else this.privFilename = filename || "unknown.wav";
        // Read the header.
        this.privAudioFormatPromise = this.readHeader();
    }
    Object.defineProperty(FileAudioSource.prototype, "format", {
        get: function() {
            return this.privAudioFormatPromise;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FileAudioSource.prototype, "blob", {
        get: function() {
            return Promise.resolve(this.privSource);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FileAudioSource.prototype, "events", {
        get: function() {
            return this.privEvents;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FileAudioSource.prototype, "deviceInfo", {
        get: function() {
            return this.privAudioFormatPromise.then(function(result) {
                return Promise.resolve({
                    bitspersample: result.bitsPerSample,
                    channelcount: result.channels,
                    connectivity: $9MAMI.connectivity.Unknown,
                    manufacturer: "Speech SDK",
                    model: "File",
                    samplerate: result.samplesPerSec,
                    type: $9MAMI.type.File
                });
            });
        },
        enumerable: false,
        configurable: true
    });
    FileAudioSource.prototype.readHeader = function() {
        var _this = this;
        // Read the wave header.
        var maxHeaderSize = 512;
        var header = this.privSource.slice(0, maxHeaderSize);
        var headerResult = new $7srwU.Deferred();
        var processHeader = function(header) {
            var view = new DataView(header);
            var getWord = function(index) {
                return String.fromCharCode(view.getUint8(index), view.getUint8(index + 1), view.getUint8(index + 2), view.getUint8(index + 3));
            };
            // RIFF 4 bytes.
            if ("RIFF" !== getWord(0)) {
                headerResult.reject("Invalid WAV header in file, RIFF was not found");
                return;
            }
            // length, 4 bytes
            // RIFF Type & fmt 8 bytes
            if ("WAVE" !== getWord(8) || "fmt " !== getWord(12)) {
                headerResult.reject("Invalid WAV header in file, WAVEfmt was not found");
                return;
            }
            var formatSize = view.getInt32(16, true);
            var channelCount = view.getUint16(22, true);
            var sampleRate = view.getUint32(24, true);
            var bitsPerSample = view.getUint16(34, true);
            // Confirm if header is 44 bytes long.
            var pos = 36 + Math.max(formatSize - 16, 0);
            for(; getWord(pos) !== "data"; pos += 2)if (pos > maxHeaderSize - 8) {
                headerResult.reject("Invalid WAV header in file, data block was not found");
                return;
            }
            _this.privHeaderEnd = pos + 8;
            headerResult.resolve($7PHxc.AudioStreamFormat.getWaveFormatPCM(sampleRate, bitsPerSample, channelCount));
        };
        if (typeof window !== "undefined" && typeof Blob !== "undefined" && header instanceof Blob) {
            var reader = new FileReader();
            reader.onload = function(event) {
                var header = event.target.result;
                processHeader(header);
            };
            reader.readAsArrayBuffer(header);
        } else {
            var h = header;
            processHeader(h.buffer.slice(h.byteOffset, h.byteOffset + h.byteLength));
        }
        return headerResult.promise;
    };
    FileAudioSource.prototype.upload = function(audioNodeId) {
        return $d47c0067abc18229$var$__awaiter(this, void 0, void 0, function() {
            var onerror, format, stream_1, chunk, processFile_1, reader, c, e_1;
            var _this = this;
            return $d47c0067abc18229$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        onerror = function(error) {
                            var errorMsg = "Error occurred while processing '" + _this.privFilename + "'. " + error;
                            _this.onEvent(new $7srwU.AudioStreamNodeErrorEvent(_this.privId, audioNodeId, errorMsg));
                            throw new Error(errorMsg);
                        };
                        _a.label = 1;
                    case 1:
                        _a.trys.push([
                            1,
                            4,
                            ,
                            5
                        ]);
                        return [
                            4 /*yield*/ ,
                            this.turnOn()
                        ];
                    case 2:
                        _a.sent();
                        return [
                            4 /*yield*/ ,
                            this.privAudioFormatPromise
                        ];
                    case 3:
                        format = _a.sent();
                        stream_1 = new $7srwU.ChunkedArrayBufferStream(format.avgBytesPerSec / 10, audioNodeId);
                        this.privStreams[audioNodeId] = stream_1;
                        chunk = this.privSource.slice(this.privHeaderEnd);
                        processFile_1 = function(buff) {
                            if (stream_1.isClosed) return; // output stream was closed (somebody called TurnOff). We're done here.
                            stream_1.writeStreamChunk({
                                buffer: buff,
                                isEnd: false,
                                timeReceived: Date.now()
                            });
                            stream_1.close();
                        };
                        if (typeof window !== "undefined" && typeof Blob !== "undefined" && chunk instanceof Blob) {
                            reader = new FileReader();
                            reader.onerror = function(ev) {
                                onerror(ev.toString());
                            };
                            reader.onload = function(event) {
                                var fileBuffer = event.target.result;
                                processFile_1(fileBuffer);
                            };
                            reader.readAsArrayBuffer(chunk);
                        } else {
                            c = chunk;
                            processFile_1(c.buffer.slice(c.byteOffset, c.byteOffset + c.byteLength));
                        }
                        return [
                            2 /*return*/ ,
                            stream_1
                        ];
                    case 4:
                        e_1 = _a.sent();
                        onerror(e_1);
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 5:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    return FileAudioSource;
}();
module.exports.FileAudioSource = $d47c0067abc18229$var$FileAudioSource;

});

parcelRequire.register("kEtWl", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PcmRecorder = void 0;

var $7srwU = parcelRequire("7srwU");
var $f08ec48bb5741ac2$var$PcmRecorder = /** @class */ function() {
    function PcmRecorder() {
        var _this = this;
        this.record = function(context, mediaStream, outputStream) {
            var desiredSampleRate = 16000;
            var scriptNode = function() {
                var bufferSize = 0;
                try {
                    return context.createScriptProcessor(bufferSize, 1, 1);
                } catch (error) {
                    // Webkit (<= version 31) requires a valid bufferSize.
                    bufferSize = 2048;
                    var audioSampleRate = context.sampleRate;
                    while(bufferSize < 16384 && audioSampleRate >= 2 * desiredSampleRate){
                        bufferSize <<= 1;
                        audioSampleRate >>= 1;
                    }
                    return context.createScriptProcessor(bufferSize, 1, 1);
                }
            }();
            var waveStreamEncoder = new $7srwU.RiffPcmEncoder(context.sampleRate, desiredSampleRate);
            var needHeader = true;
            var that = _this;
            scriptNode.onaudioprocess = function(event) {
                var inputFrame = event.inputBuffer.getChannelData(0);
                if (outputStream && !outputStream.isClosed) {
                    var waveFrame = waveStreamEncoder.encode(inputFrame);
                    if (!!waveFrame) {
                        outputStream.writeStreamChunk({
                            buffer: waveFrame,
                            isEnd: false,
                            timeReceived: Date.now()
                        });
                        needHeader = false;
                    }
                }
            };
            var micInput = context.createMediaStreamSource(mediaStream);
            // https://webaudio.github.io/web-audio-api/#audioworklet
            // Using AudioWorklet to improve audio quality and avoid audio glitches due to blocking the UI thread
            if (!!_this.privSpeechProcessorScript && !!context.audioWorklet) context.audioWorklet.addModule(_this.privSpeechProcessorScript).then(function() {
                var workletNode = new AudioWorkletNode(context, "speech-processor");
                workletNode.port.onmessage = function(ev) {
                    var inputFrame = ev.data;
                    if (outputStream && !outputStream.isClosed) {
                        var waveFrame = waveStreamEncoder.encode(inputFrame);
                        if (!!waveFrame) {
                            outputStream.writeStreamChunk({
                                buffer: waveFrame,
                                isEnd: false,
                                timeReceived: Date.now()
                            });
                            needHeader = false;
                        }
                    }
                };
                micInput.connect(workletNode);
                workletNode.connect(context.destination);
                _this.privMediaResources = {
                    scriptProcessorNode: workletNode,
                    source: micInput,
                    stream: mediaStream
                };
            }).catch(function() {
                micInput.connect(scriptNode);
                scriptNode.connect(context.destination);
                _this.privMediaResources = {
                    scriptProcessorNode: scriptNode,
                    source: micInput,
                    stream: mediaStream
                };
            });
            else {
                micInput.connect(scriptNode);
                scriptNode.connect(context.destination);
                _this.privMediaResources = {
                    scriptProcessorNode: scriptNode,
                    source: micInput,
                    stream: mediaStream
                };
            }
        };
        this.releaseMediaResources = function(context) {
            if (_this.privMediaResources) {
                if (_this.privMediaResources.scriptProcessorNode) {
                    _this.privMediaResources.scriptProcessorNode.disconnect(context.destination);
                    _this.privMediaResources.scriptProcessorNode = null;
                }
                if (_this.privMediaResources.source) {
                    _this.privMediaResources.source.disconnect();
                    _this.privMediaResources.stream.getTracks().forEach(function(track) {
                        return track.stop();
                    });
                    _this.privMediaResources.source = null;
                }
            }
        };
    }
    PcmRecorder.prototype.setWorkletUrl = function(url) {
        this.privSpeechProcessorScript = url;
    };
    return PcmRecorder;
}();
module.exports.PcmRecorder = $f08ec48bb5741ac2$var$PcmRecorder;

});

parcelRequire.register("yaYst", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
var $066bb0532a1b14b4$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $066bb0532a1b14b4$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.WebsocketConnection = void 0;

var $7srwU = parcelRequire("7srwU");

var $hmlgZ = parcelRequire("hmlgZ");
var $066bb0532a1b14b4$var$WebsocketConnection = /** @class */ function() {
    function WebsocketConnection(uri, queryParameters, headers, messageFormatter, proxyInfo, enableCompression, connectionId) {
        var _this = this;
        if (enableCompression === void 0) enableCompression = false;
        this.privIsDisposed = false;
        this.isDisposed = function() {
            return _this.privIsDisposed;
        };
        this.state = function() {
            return _this.privConnectionMessageAdapter.state;
        };
        this.open = function() {
            return _this.privConnectionMessageAdapter.open();
        };
        this.send = function(message) {
            return _this.privConnectionMessageAdapter.send(message);
        };
        this.read = function() {
            return _this.privConnectionMessageAdapter.read();
        };
        if (!uri) throw new $7srwU.ArgumentNullError("uri");
        if (!messageFormatter) throw new $7srwU.ArgumentNullError("messageFormatter");
        this.privMessageFormatter = messageFormatter;
        var queryParams = "";
        var i = 0;
        if (queryParameters) {
            for(var paramName in queryParameters)if (paramName) {
                queryParams += i === 0 && uri.indexOf("?") === -1 ? "?" : "&";
                var val = encodeURIComponent(queryParameters[paramName]);
                queryParams += paramName + "=" + val;
                i++;
            }
        }
        if (headers) {
            for(var headerName in headers)if (headerName) {
                queryParams += i === 0 && uri.indexOf("?") === -1 ? "?" : "&";
                var val = encodeURIComponent(headers[headerName]);
                queryParams += headerName + "=" + val;
                i++;
            }
        }
        this.privUri = uri + queryParams;
        this.privId = connectionId ? connectionId : $7srwU.createNoDashGuid();
        this.privConnectionMessageAdapter = new $hmlgZ.WebsocketMessageAdapter(this.privUri, this.id, this.privMessageFormatter, proxyInfo, headers, enableCompression);
    }
    WebsocketConnection.prototype.dispose = function() {
        return $066bb0532a1b14b4$var$__awaiter(this, void 0, void 0, function() {
            return $066bb0532a1b14b4$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        this.privIsDisposed = true;
                        if (!this.privConnectionMessageAdapter) return [
                            3 /*break*/ ,
                            2
                        ];
                        return [
                            4 /*yield*/ ,
                            this.privConnectionMessageAdapter.close()
                        ];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    Object.defineProperty(WebsocketConnection.prototype, "id", {
        get: function() {
            return this.privId;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(WebsocketConnection.prototype, "events", {
        get: function() {
            return this.privConnectionMessageAdapter.events;
        },
        enumerable: false,
        configurable: true
    });
    return WebsocketConnection;
}();
module.exports.WebsocketConnection = $066bb0532a1b14b4$var$WebsocketConnection;

});
parcelRequire.register("hmlgZ", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
var $ca34fe200b679897$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $ca34fe200b679897$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $ca34fe200b679897$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.WebsocketMessageAdapter = void 0;

var $hiJX4 = parcelRequire("hiJX4");

var $7srwU = parcelRequire("7srwU");

// Node.JS specific web socket / browser support.
var $ca34fe200b679897$var$ws_1 = $ca34fe200b679897$var$__importDefault((parcelRequire("gR5sk")));

var $4KNJI = parcelRequire("4KNJI");
var $ca34fe200b679897$var$WebsocketMessageAdapter = /** @class */ function() {
    function WebsocketMessageAdapter(uri, connectionId, messageFormatter, proxyInfo, headers, enableCompression) {
        var _this = this;
        this.open = function() {
            if (_this.privConnectionState === $7srwU.ConnectionState.Disconnected) return Promise.reject("Cannot open a connection that is in " + _this.privConnectionState + " state");
            if (_this.privConnectionEstablishDeferral) return _this.privConnectionEstablishDeferral.promise;
            _this.privConnectionEstablishDeferral = new $7srwU.Deferred();
            _this.privCertificateValidatedDeferral = new $7srwU.Deferred();
            _this.privConnectionState = $7srwU.ConnectionState.Connecting;
            try {
                if (typeof WebSocket !== "undefined" && !WebsocketMessageAdapter.forceNpmWebSocket) {
                    // Browser handles cert checks.
                    _this.privCertificateValidatedDeferral.resolve();
                    _this.privWebsocketClient = new WebSocket(_this.privUri);
                } else {
                    var options = {
                        headers: _this.privHeaders,
                        perMessageDeflate: _this.privEnableCompression
                    };
                    // The ocsp library will handle validation for us and fail the connection if needed.
                    _this.privCertificateValidatedDeferral.resolve();
                    var checkAgent = new $4KNJI.CertCheckAgent(_this.proxyInfo);
                    options.agent = checkAgent.GetAgent();
                    _this.privWebsocketClient = new $ca34fe200b679897$var$ws_1.default(_this.privUri, options);
                }
                _this.privWebsocketClient.binaryType = "arraybuffer";
                _this.privReceivingMessageQueue = new $7srwU.Queue();
                _this.privDisconnectDeferral = new $7srwU.Deferred();
                _this.privSendMessageQueue = new $7srwU.Queue();
                _this.processSendQueue().catch(function(reason) {
                    $7srwU.Events.instance.onEvent(new $7srwU.BackgroundEvent(reason));
                });
            } catch (error) {
                _this.privConnectionEstablishDeferral.resolve(new $7srwU.ConnectionOpenResponse(500, error));
                return _this.privConnectionEstablishDeferral.promise;
            }
            _this.onEvent(new $7srwU.ConnectionStartEvent(_this.privConnectionId, _this.privUri));
            _this.privWebsocketClient.onopen = function(e) {
                _this.privCertificateValidatedDeferral.promise.then(function() {
                    _this.privConnectionState = $7srwU.ConnectionState.Connected;
                    _this.onEvent(new $7srwU.ConnectionEstablishedEvent(_this.privConnectionId));
                    _this.privConnectionEstablishDeferral.resolve(new $7srwU.ConnectionOpenResponse(200, ""));
                }, function(error) {
                    _this.privConnectionEstablishDeferral.reject(error);
                });
            };
            _this.privWebsocketClient.onerror = function(e) {
                _this.onEvent(new $7srwU.ConnectionErrorEvent(_this.privConnectionId, e.message, e.type));
                _this.privLastErrorReceived = e.message;
            };
            _this.privWebsocketClient.onclose = function(e) {
                if (_this.privConnectionState === $7srwU.ConnectionState.Connecting) {
                    _this.privConnectionState = $7srwU.ConnectionState.Disconnected;
                    // this.onEvent(new ConnectionEstablishErrorEvent(this.connectionId, e.code, e.reason));
                    _this.privConnectionEstablishDeferral.resolve(new $7srwU.ConnectionOpenResponse(e.code, e.reason + " " + _this.privLastErrorReceived));
                } else {
                    _this.privConnectionState = $7srwU.ConnectionState.Disconnected;
                    _this.privWebsocketClient = null;
                    _this.onEvent(new $7srwU.ConnectionClosedEvent(_this.privConnectionId, e.code, e.reason));
                }
                _this.onClose(e.code, e.reason).catch(function(reason) {
                    $7srwU.Events.instance.onEvent(new $7srwU.BackgroundEvent(reason));
                });
            };
            _this.privWebsocketClient.onmessage = function(e) {
                var networkReceivedTime = new Date().toISOString();
                if (_this.privConnectionState === $7srwU.ConnectionState.Connected) {
                    var deferred_1 = new $7srwU.Deferred();
                    // let id = ++this.idCounter;
                    _this.privReceivingMessageQueue.enqueueFromPromise(deferred_1.promise);
                    if (e.data instanceof ArrayBuffer) {
                        var rawMessage = new $7srwU.RawWebsocketMessage($7srwU.MessageType.Binary, e.data);
                        _this.privMessageFormatter.toConnectionMessage(rawMessage).then(function(connectionMessage) {
                            _this.onEvent(new $7srwU.ConnectionMessageReceivedEvent(_this.privConnectionId, networkReceivedTime, connectionMessage));
                            deferred_1.resolve(connectionMessage);
                        }, function(error) {
                            // TODO: Events for these ?
                            deferred_1.reject("Invalid binary message format. Error: " + error);
                        });
                    } else {
                        var rawMessage = new $7srwU.RawWebsocketMessage($7srwU.MessageType.Text, e.data);
                        _this.privMessageFormatter.toConnectionMessage(rawMessage).then(function(connectionMessage) {
                            _this.onEvent(new $7srwU.ConnectionMessageReceivedEvent(_this.privConnectionId, networkReceivedTime, connectionMessage));
                            deferred_1.resolve(connectionMessage);
                        }, function(error) {
                            // TODO: Events for these ?
                            deferred_1.reject("Invalid text message format. Error: " + error);
                        });
                    }
                }
            };
            return _this.privConnectionEstablishDeferral.promise;
        };
        this.send = function(message) {
            if (_this.privConnectionState !== $7srwU.ConnectionState.Connected) return Promise.reject("Cannot send on connection that is in " + $7srwU.ConnectionState[_this.privConnectionState] + " state");
            var messageSendStatusDeferral = new $7srwU.Deferred();
            var messageSendDeferral = new $7srwU.Deferred();
            _this.privSendMessageQueue.enqueueFromPromise(messageSendDeferral.promise);
            _this.privMessageFormatter.fromConnectionMessage(message).then(function(rawMessage) {
                messageSendDeferral.resolve({
                    Message: message,
                    RawWebsocketMessage: rawMessage,
                    sendStatusDeferral: messageSendStatusDeferral
                });
            }, function(error) {
                messageSendDeferral.reject("Error formatting the message. " + error);
            });
            return messageSendStatusDeferral.promise;
        };
        this.read = function() {
            if (_this.privConnectionState !== $7srwU.ConnectionState.Connected) return Promise.reject("Cannot read on connection that is in " + _this.privConnectionState + " state");
            return _this.privReceivingMessageQueue.dequeue();
        };
        this.close = function(reason) {
            if (_this.privWebsocketClient) {
                if (_this.privConnectionState !== $7srwU.ConnectionState.Disconnected) _this.privWebsocketClient.close(1000, reason ? reason : "Normal closure by client");
            } else return Promise.resolve();
            return _this.privDisconnectDeferral.promise;
        };
        this.sendRawMessage = function(sendItem) {
            try {
                // indicates we are draining the queue and it came with no message;
                if (!sendItem) return Promise.resolve();
                _this.onEvent(new $7srwU.ConnectionMessageSentEvent(_this.privConnectionId, new Date().toISOString(), sendItem.Message));
                // add a check for the ws readystate in order to stop the red console error 'WebSocket is already in CLOSING or CLOSED state' appearing
                if (_this.isWebsocketOpen) _this.privWebsocketClient.send(sendItem.RawWebsocketMessage.payload);
                else return Promise.reject("websocket send error: Websocket not ready " + _this.privConnectionId + " " + sendItem.Message.id + " " + new Error().stack);
                return Promise.resolve();
            } catch (e) {
                return Promise.reject("websocket send error: " + e);
            }
        };
        this.onEvent = function(event) {
            _this.privConnectionEvents.onEvent(event);
            $7srwU.Events.instance.onEvent(event);
        };
        if (!uri) throw new $7srwU.ArgumentNullError("uri");
        if (!messageFormatter) throw new $7srwU.ArgumentNullError("messageFormatter");
        this.proxyInfo = proxyInfo;
        this.privConnectionEvents = new $7srwU.EventSource();
        this.privConnectionId = connectionId;
        this.privMessageFormatter = messageFormatter;
        this.privConnectionState = $7srwU.ConnectionState.None;
        this.privUri = uri;
        this.privHeaders = headers;
        this.privEnableCompression = enableCompression;
        // Add the connection ID to the headers
        this.privHeaders[$hiJX4.HeaderNames.ConnectionId] = this.privConnectionId;
        this.privLastErrorReceived = "";
    }
    Object.defineProperty(WebsocketMessageAdapter.prototype, "state", {
        get: function() {
            return this.privConnectionState;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(WebsocketMessageAdapter.prototype, "events", {
        get: function() {
            return this.privConnectionEvents;
        },
        enumerable: false,
        configurable: true
    });
    WebsocketMessageAdapter.prototype.onClose = function(code, reason) {
        return $ca34fe200b679897$var$__awaiter(this, void 0, void 0, function() {
            var closeReason;
            return $ca34fe200b679897$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        closeReason = "Connection closed. " + code + ": " + reason;
                        this.privConnectionState = $7srwU.ConnectionState.Disconnected;
                        this.privDisconnectDeferral.resolve();
                        return [
                            4 /*yield*/ ,
                            this.privReceivingMessageQueue.drainAndDispose(function(pendingReceiveItem) {
                            // TODO: Events for these ?
                            // Logger.instance.onEvent(new LoggingEvent(LogType.Warning, null, `Failed to process received message. Reason: ${closeReason}, Message: ${JSON.stringify(pendingReceiveItem)}`));
                            }, closeReason)
                        ];
                    case 1:
                        _a.sent();
                        return [
                            4 /*yield*/ ,
                            this.privSendMessageQueue.drainAndDispose(function(pendingSendItem) {
                                pendingSendItem.sendStatusDeferral.reject(closeReason);
                            }, closeReason)
                        ];
                    case 2:
                        _a.sent();
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    WebsocketMessageAdapter.prototype.processSendQueue = function() {
        return $ca34fe200b679897$var$__awaiter(this, void 0, void 0, function() {
            var itemToSend, sendItem, sendError_1;
            return $ca34fe200b679897$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        itemToSend = this.privSendMessageQueue.dequeue();
                        return [
                            4 /*yield*/ ,
                            itemToSend
                        ];
                    case 1:
                        sendItem = _a.sent();
                        // indicates we are draining the queue and it came with no message;
                        if (!sendItem) return [
                            2 /*return*/ 
                        ];
                        _a.label = 2;
                    case 2:
                        _a.trys.push([
                            2,
                            4,
                            ,
                            5
                        ]);
                        return [
                            4 /*yield*/ ,
                            this.sendRawMessage(sendItem)
                        ];
                    case 3:
                        _a.sent();
                        sendItem.sendStatusDeferral.resolve();
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 4:
                        sendError_1 = _a.sent();
                        sendItem.sendStatusDeferral.reject(sendError_1);
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 5:
                        return [
                            3 /*break*/ ,
                            0
                        ];
                    case 6:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    Object.defineProperty(WebsocketMessageAdapter.prototype, "isWebsocketOpen", {
        get: function() {
            return this.privWebsocketClient && this.privWebsocketClient.readyState === this.privWebsocketClient.OPEN;
        },
        enumerable: false,
        configurable: true
    });
    WebsocketMessageAdapter.forceNpmWebSocket = false;
    return WebsocketMessageAdapter;
}();
module.exports.WebsocketMessageAdapter = $ca34fe200b679897$var$WebsocketMessageAdapter;

});
parcelRequire.register("4KNJI", function(module, exports) {

var $hIXGI = parcelRequire("hIXGI");

var $cBXue = parcelRequire("cBXue");
var $376209eac0176ebe$require$Buffer = $cBXue.Buffer;
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
var $376209eac0176ebe$var$__assign = module.exports && module.exports.__assign || function() {
    $376209eac0176ebe$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $376209eac0176ebe$var$__assign.apply(this, arguments);
};
var $376209eac0176ebe$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $376209eac0176ebe$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $376209eac0176ebe$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.hasOwnProperty.call(mod, k)) $376209eac0176ebe$var$__createBinding(result, mod, k);
    }
    $376209eac0176ebe$var$__setModuleDefault(result, mod);
    return result;
};
var $376209eac0176ebe$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $376209eac0176ebe$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $376209eac0176ebe$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CertCheckAgent = void 0;

var $376209eac0176ebe$var$tls = $376209eac0176ebe$var$__importStar((parcelRequire("gR5sk")));

var $376209eac0176ebe$var$parse = $376209eac0176ebe$var$__importStar((parcelRequire("eIIKM")));

var $376209eac0176ebe$var$ocsp = $376209eac0176ebe$var$__importStar((parcelRequire("eRdtr")));

var $7srwU = parcelRequire("7srwU");

var $376209eac0176ebe$var$agent_base_1 = $376209eac0176ebe$var$__importDefault((parcelRequire("gR5sk")));

// @ts-ignore
var $376209eac0176ebe$var$async_disk_cache_1 = $376209eac0176ebe$var$__importDefault((parcelRequire("gR5sk")));

var $376209eac0176ebe$var$https_proxy_agent_1 = $376209eac0176ebe$var$__importDefault((parcelRequire("gR5sk")));

var $376209eac0176ebe$var$net = $376209eac0176ebe$var$__importStar((parcelRequire("gR5sk")));

var $5AaWw = parcelRequire("5AaWw");
var $376209eac0176ebe$var$CertCheckAgent = /** @class */ function() {
    function CertCheckAgent(proxyInfo) {
        if (!!proxyInfo) this.privProxyInfo = proxyInfo;
        // Initialize this here to allow tests to set the env variable before the cache is constructed.
        if (!CertCheckAgent.privDiskCache) CertCheckAgent.privDiskCache = new $376209eac0176ebe$var$async_disk_cache_1.default("microsoft-cognitiveservices-speech-sdk-cache", {
            supportBuffer: true,
            location: (typeof $hIXGI, undefined)
        });
    }
    // Test hook to force the disk cache to be recreated.
    CertCheckAgent.forceReinitDiskCache = function() {
        CertCheckAgent.privDiskCache = undefined;
        CertCheckAgent.privMemCache = {};
    };
    CertCheckAgent.prototype.GetAgent = function(disableStapling) {
        var agent = new $376209eac0176ebe$var$agent_base_1.default.Agent(this.CreateConnection);
        if (this.privProxyInfo !== undefined && this.privProxyInfo.HostName !== undefined && this.privProxyInfo.Port > 0) {
            var proxyName = "privProxyInfo";
            agent[proxyName] = this.privProxyInfo;
        }
        return agent;
    };
    CertCheckAgent.GetProxyAgent = function(proxyInfo) {
        var httpProxyOptions = {
            host: proxyInfo.HostName,
            port: proxyInfo.Port
        };
        if (!!proxyInfo.UserName) httpProxyOptions.headers = {
            "Proxy-Authentication": "Basic " + new $376209eac0176ebe$require$Buffer(proxyInfo.UserName + ":" + (proxyInfo.Password === undefined) ? "" : proxyInfo.Password).toString("base64")
        };
        else httpProxyOptions.headers = {};
        httpProxyOptions.headers.requestOCSP = "true";
        var httpProxyAgent = new $376209eac0176ebe$var$https_proxy_agent_1.default(httpProxyOptions);
        return httpProxyAgent;
    };
    CertCheckAgent.OCSPCheck = function(socketPromise, proxyInfo) {
        return $376209eac0176ebe$var$__awaiter(this, void 0, void 0, function() {
            var ocspRequest, stapling, resolved, socket, tlsSocket;
            var _this = this;
            return $376209eac0176ebe$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        resolved = false;
                        return [
                            4 /*yield*/ ,
                            socketPromise
                        ];
                    case 1:
                        socket = _a.sent();
                        socket.cork();
                        tlsSocket = socket;
                        return [
                            2 /*return*/ ,
                            new Promise(function(resolve, reject) {
                                socket.on("OCSPResponse", function(data) {
                                    if (!!data) {
                                        _this.onEvent(new $7srwU.OCSPStapleReceivedEvent());
                                        stapling = data;
                                    }
                                });
                                socket.on("error", function(error) {
                                    if (!resolved) {
                                        resolved = true;
                                        socket.destroy();
                                        reject(error);
                                    }
                                });
                                tlsSocket.on("secure", function() {
                                    return $376209eac0176ebe$var$__awaiter(_this, void 0, void 0, function() {
                                        var peer, issuer, sig, cacheEntry, e_1;
                                        return $376209eac0176ebe$var$__generator(this, function(_a) {
                                            switch(_a.label){
                                                case 0:
                                                    peer = tlsSocket.getPeerCertificate(true);
                                                    _a.label = 1;
                                                case 1:
                                                    _a.trys.push([
                                                        1,
                                                        6,
                                                        ,
                                                        7
                                                    ]);
                                                    return [
                                                        4 /*yield*/ ,
                                                        this.GetIssuer(peer)
                                                    ];
                                                case 2:
                                                    issuer = _a.sent();
                                                    // We always need a request to verify the response.
                                                    ocspRequest = $376209eac0176ebe$var$ocsp.request.generate(peer.raw, issuer.raw);
                                                    sig = ocspRequest.id.toString("hex");
                                                    if (!!stapling) return [
                                                        3 /*break*/ ,
                                                        4
                                                    ];
                                                    return [
                                                        4 /*yield*/ ,
                                                        CertCheckAgent.GetResponseFromCache(sig, ocspRequest, proxyInfo)
                                                    ];
                                                case 3:
                                                    cacheEntry = _a.sent();
                                                    stapling = cacheEntry;
                                                    _a.label = 4;
                                                case 4:
                                                    return [
                                                        4 /*yield*/ ,
                                                        this.VerifyOCSPResponse(stapling, ocspRequest, proxyInfo)
                                                    ];
                                                case 5:
                                                    _a.sent();
                                                    socket.uncork();
                                                    resolved = true;
                                                    resolve(socket);
                                                    return [
                                                        3 /*break*/ ,
                                                        7
                                                    ];
                                                case 6:
                                                    e_1 = _a.sent();
                                                    socket.destroy();
                                                    resolved = true;
                                                    reject(e_1);
                                                    return [
                                                        3 /*break*/ ,
                                                        7
                                                    ];
                                                case 7:
                                                    return [
                                                        2 /*return*/ 
                                                    ];
                                            }
                                        });
                                    });
                                });
                            })
                        ];
                }
            });
        });
    };
    CertCheckAgent.GetIssuer = function(peer) {
        if (peer.issuerCertificate) return Promise.resolve(peer.issuerCertificate);
        return new Promise(function(resolve, reject) {
            var ocspAgent = new $376209eac0176ebe$var$ocsp.Agent({});
            ocspAgent.fetchIssuer(peer, null, function(error, value) {
                if (!!error) {
                    reject(error);
                    return;
                }
                resolve(value);
            });
        });
    };
    CertCheckAgent.GetResponseFromCache = function(signature, ocspRequest, proxyInfo) {
        return $376209eac0176ebe$var$__awaiter(this, void 0, void 0, function() {
            var cachedResponse, diskCacheResponse, error_1, cachedOcspResponse, tbsData, cachedStartTime, cachedNextTime, minUpdate;
            var _this = this;
            return $376209eac0176ebe$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        cachedResponse = CertCheckAgent.privMemCache[signature];
                        if (!!cachedResponse) this.onEvent(new $7srwU.OCSPMemoryCacheHitEvent(signature));
                        if (!!cachedResponse) return [
                            3 /*break*/ ,
                            4
                        ];
                        _a.label = 1;
                    case 1:
                        _a.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4 /*yield*/ ,
                            CertCheckAgent.privDiskCache.get(signature)
                        ];
                    case 2:
                        diskCacheResponse = _a.sent();
                        if (!!diskCacheResponse.isCached) {
                            CertCheckAgent.onEvent(new $7srwU.OCSPDiskCacheHitEvent(signature));
                            CertCheckAgent.StoreMemoryCacheEntry(signature, diskCacheResponse.value);
                            cachedResponse = diskCacheResponse.value;
                        }
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 3:
                        error_1 = _a.sent();
                        cachedResponse = null;
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 4:
                        if (!cachedResponse) return [
                            2 /*return*/ ,
                            cachedResponse
                        ];
                        try {
                            cachedOcspResponse = $376209eac0176ebe$var$ocsp.utils.parseResponse(cachedResponse);
                            tbsData = cachedOcspResponse.value.tbsResponseData;
                            if (tbsData.responses.length < 1) {
                                this.onEvent(new $7srwU.OCSPCacheFetchErrorEvent(signature, "Not enough data in cached response"));
                                return [
                                    2 /*return*/ 
                                ];
                            }
                            cachedStartTime = tbsData.responses[0].thisUpdate;
                            cachedNextTime = tbsData.responses[0].nextUpdate;
                            if (cachedNextTime < Date.now() + this.testTimeOffset - 60000) {
                                // Cached entry has expired.
                                this.onEvent(new $7srwU.OCSPCacheEntryExpiredEvent(signature, cachedNextTime));
                                cachedResponse = null;
                            } else {
                                minUpdate = Math.min(86400000, (cachedNextTime - cachedStartTime) / 2);
                                if (cachedNextTime - (Date.now() + this.testTimeOffset) < minUpdate) {
                                    this.onEvent(new $7srwU.OCSPCacheEntryNeedsRefreshEvent(signature, cachedStartTime, cachedNextTime));
                                    this.UpdateCache(ocspRequest, proxyInfo).catch(function(error) {
                                        // Well, not much we can do here.
                                        _this.onEvent(new $5AaWw.OCSPCacheUpdateErrorEvent(signature, error.toString()));
                                    });
                                } else this.onEvent(new $7srwU.OCSPCacheHitEvent(signature, cachedStartTime, cachedNextTime));
                            }
                        } catch (error) {
                            this.onEvent(new $7srwU.OCSPCacheFetchErrorEvent(signature, error));
                            cachedResponse = null;
                        }
                        if (!cachedResponse) this.onEvent(new $7srwU.OCSPCacheMissEvent(signature));
                        return [
                            2 /*return*/ ,
                            cachedResponse
                        ];
                }
            });
        });
    };
    CertCheckAgent.VerifyOCSPResponse = function(cacheValue, ocspRequest, proxyInfo) {
        return $376209eac0176ebe$var$__awaiter(this, void 0, void 0, function() {
            var ocspResponse, sig;
            var _this = this;
            return $376209eac0176ebe$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        ocspResponse = cacheValue;
                        sig = ocspRequest.certID.toString("hex");
                        if (!!ocspResponse) return [
                            3 /*break*/ ,
                            2
                        ];
                        return [
                            4 /*yield*/ ,
                            CertCheckAgent.GetOCSPResponse(ocspRequest, proxyInfo)
                        ];
                    case 1:
                        ocspResponse = _a.sent();
                        _a.label = 2;
                    case 2:
                        return [
                            2 /*return*/ ,
                            new Promise(function(resolve, reject) {
                                $376209eac0176ebe$var$ocsp.verify({
                                    request: ocspRequest,
                                    response: ocspResponse
                                }, function(error, result) {
                                    if (!!error) {
                                        CertCheckAgent.onEvent(new $7srwU.OCSPVerificationFailedEvent(ocspRequest.id.toString("hex"), error));
                                        // Bad Cached Value? One more try without the cache.
                                        if (!!cacheValue) _this.VerifyOCSPResponse(null, ocspRequest, proxyInfo).then(function() {
                                            resolve();
                                        }, function(error) {
                                            reject(error);
                                        });
                                        else reject(error);
                                    } else {
                                        if (!cacheValue) CertCheckAgent.StoreCacheEntry(ocspRequest.id.toString("hex"), ocspResponse);
                                        resolve();
                                    }
                                });
                            })
                        ];
                }
            });
        });
    };
    CertCheckAgent.UpdateCache = function(req, proxyInfo) {
        return $376209eac0176ebe$var$__awaiter(this, void 0, void 0, function() {
            var signature, rawResponse;
            return $376209eac0176ebe$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        signature = req.id.toString("hex");
                        this.onEvent(new $7srwU.OCSPCacheUpdateNeededEvent(signature));
                        return [
                            4 /*yield*/ ,
                            this.GetOCSPResponse(req, proxyInfo)
                        ];
                    case 1:
                        rawResponse = _a.sent();
                        this.StoreCacheEntry(signature, rawResponse);
                        this.onEvent(new $7srwU.OCSPCacheUpdatehCompleteEvent(req.id.toString("hex")));
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    CertCheckAgent.StoreCacheEntry = function(sig, rawResponse) {
        this.StoreMemoryCacheEntry(sig, rawResponse);
        this.StoreDiskCacheEntry(sig, rawResponse);
    };
    CertCheckAgent.StoreMemoryCacheEntry = function(sig, rawResponse) {
        this.privMemCache[sig] = rawResponse;
        this.onEvent(new $7srwU.OCSPMemoryCacheStoreEvent(sig));
    };
    CertCheckAgent.StoreDiskCacheEntry = function(sig, rawResponse) {
        var _this = this;
        this.privDiskCache.set(sig, rawResponse).then(function() {
            _this.onEvent(new $7srwU.OCSPDiskCacheStoreEvent(sig));
        });
    };
    CertCheckAgent.GetOCSPResponse = function(req, proxyInfo) {
        var _this = this;
        var ocspMethod = "1.3.6.1.5.5.7.48.1";
        var options = {};
        if (!!proxyInfo) {
            var agent = CertCheckAgent.GetProxyAgent(proxyInfo);
            options.agent = agent;
        }
        return new Promise(function(resolve, reject) {
            $376209eac0176ebe$var$ocsp.utils.getAuthorityInfo(req.cert, ocspMethod, function(error, uri) {
                if (error) {
                    reject(error);
                    return;
                }
                var parsedUri = $376209eac0176ebe$var$parse.default(uri);
                parsedUri.path = parsedUri.pathname;
                options = $376209eac0176ebe$var$__assign($376209eac0176ebe$var$__assign({}, options), parsedUri);
                $376209eac0176ebe$var$ocsp.utils.getResponse(options, req.data, function(error, raw) {
                    if (error) {
                        reject(error);
                        return;
                    }
                    _this.onEvent(new $7srwU.OCSPResponseRetrievedEvent(req.certID.toString("hex")));
                    resolve(raw);
                });
            });
        });
    };
    CertCheckAgent.prototype.CreateConnection = function(request, options) {
        var enableOCSP = typeof $hIXGI !== "undefined" && true && true && options.secureEndpoint;
        var socketPromise;
        options = $376209eac0176ebe$var$__assign($376209eac0176ebe$var$__assign({}, options), {
            requestOCSP: !CertCheckAgent.forceDisableOCSPStapling,
            servername: options.host
        });
        if (!!this.privProxyInfo) {
            var httpProxyAgent = CertCheckAgent.GetProxyAgent(this.privProxyInfo);
            var baseAgent_1 = httpProxyAgent;
            socketPromise = new Promise(function(resolve, reject) {
                baseAgent_1.callback(request, options, function(error, socket) {
                    if (!!error) reject(error);
                    else resolve(socket);
                });
            });
        } else if (!!options.secureEndpoint) socketPromise = Promise.resolve($376209eac0176ebe$var$tls.connect(options));
        else socketPromise = Promise.resolve($376209eac0176ebe$var$net.connect(options));
        if (!!enableOCSP) return CertCheckAgent.OCSPCheck(socketPromise, this.privProxyInfo);
        else return socketPromise;
    };
    // Test hook to enable forcing expiration / refresh to happen.
    CertCheckAgent.testTimeOffset = 0;
    // Test hook to disable stapling for cache testing.
    CertCheckAgent.forceDisableOCSPStapling = false;
    // An in memory cache for recived responses.
    CertCheckAgent.privMemCache = {};
    CertCheckAgent.onEvent = function(event) {
        $7srwU.Events.instance.onEvent(event);
    };
    return CertCheckAgent;
}();
module.exports.CertCheckAgent = $376209eac0176ebe$var$CertCheckAgent;

});
parcelRequire.register("eIIKM", function(module, exports) {
"use strict";

var $3biuL = parcelRequire("3biuL");

var $9kycz = parcelRequire("9kycz");
var $ab77e3e2991c7c6b$var$controlOrWhitespace = /^[\x00-\x20\u00a0\u1680\u2000-\u200a\u2028\u2029\u202f\u205f\u3000\ufeff]+/, $ab77e3e2991c7c6b$var$CRHTLF = /[\n\r\t]/g, $ab77e3e2991c7c6b$var$slashes = /^[A-Za-z][A-Za-z0-9+-.]*:\/\//, $ab77e3e2991c7c6b$var$port = /:\d+$/, $ab77e3e2991c7c6b$var$protocolre = /^([a-z][a-z0-9.+-]*:)?(\/\/)?([\\/]+)?([\S\s]*)/i, $ab77e3e2991c7c6b$var$windowsDriveLetter = /^[a-zA-Z]:/;
/**
 * Remove control characters and whitespace from the beginning of a string.
 *
 * @param {Object|String} str String to trim.
 * @returns {String} A new string representing `str` stripped of control
 *     characters and whitespace from its beginning.
 * @public
 */ function $ab77e3e2991c7c6b$var$trimLeft(str) {
    return (str ? str : "").toString().replace($ab77e3e2991c7c6b$var$controlOrWhitespace, "");
}
/**
 * These are the parse rules for the URL parser, it informs the parser
 * about:
 *
 * 0. The char it Needs to parse, if it's a string it should be done using
 *    indexOf, RegExp using exec and NaN means set as current value.
 * 1. The property we should set when parsing this value.
 * 2. Indication if it's backwards or forward parsing, when set as number it's
 *    the value of extra chars that should be split off.
 * 3. Inherit from location if non existing in the parser.
 * 4. `toLowerCase` the resulting value.
 */ var $ab77e3e2991c7c6b$var$rules = [
    [
        "#",
        "hash"
    ],
    [
        "?",
        "query"
    ],
    function sanitize(address, url) {
        return $ab77e3e2991c7c6b$var$isSpecial(url.protocol) ? address.replace(/\\/g, "/") : address;
    },
    [
        "/",
        "pathname"
    ],
    [
        "@",
        "auth",
        1
    ],
    [
        NaN,
        "host",
        undefined,
        1,
        1
    ],
    [
        /:(\d*)$/,
        "port",
        undefined,
        1
    ],
    [
        NaN,
        "hostname",
        undefined,
        1,
        1
    ] // Set left over.
];
/**
 * These properties should not be copied or inherited from. This is only needed
 * for all non blob URL's as a blob URL does not include a hash, only the
 * origin.
 *
 * @type {Object}
 * @private
 */ var $ab77e3e2991c7c6b$var$ignore = {
    hash: 1,
    query: 1
};
/**
 * The location object differs when your code is loaded through a normal page,
 * Worker or through a worker using a blob. And with the blobble begins the
 * trouble as the location object will contain the URL of the blob, not the
 * location of the page where our code is loaded in. The actual origin is
 * encoded in the `pathname` so we can thankfully generate a good "default"
 * location from it so we can generate proper relative URL's again.
 *
 * @param {Object|String} loc Optional default location object.
 * @returns {Object} lolcation object.
 * @public
 */ function $ab77e3e2991c7c6b$var$lolcation(loc) {
    var globalVar;
    if (typeof window !== "undefined") globalVar = window;
    else if (typeof $parcel$global !== "undefined") globalVar = $parcel$global;
    else if (typeof self !== "undefined") globalVar = self;
    else globalVar = {};
    var location = globalVar.location || {};
    loc = loc || location;
    var finaldestination = {}, type = typeof loc, key;
    if ("blob:" === loc.protocol) finaldestination = new $ab77e3e2991c7c6b$var$Url(unescape(loc.pathname), {});
    else if ("string" === type) {
        finaldestination = new $ab77e3e2991c7c6b$var$Url(loc, {});
        for(key in $ab77e3e2991c7c6b$var$ignore)delete finaldestination[key];
    } else if ("object" === type) {
        for(key in loc){
            if (key in $ab77e3e2991c7c6b$var$ignore) continue;
            finaldestination[key] = loc[key];
        }
        if (finaldestination.slashes === undefined) finaldestination.slashes = $ab77e3e2991c7c6b$var$slashes.test(loc.href);
    }
    return finaldestination;
}
/**
 * Check whether a protocol scheme is special.
 *
 * @param {String} The protocol scheme of the URL
 * @return {Boolean} `true` if the protocol scheme is special, else `false`
 * @private
 */ function $ab77e3e2991c7c6b$var$isSpecial(scheme) {
    return scheme === "file:" || scheme === "ftp:" || scheme === "http:" || scheme === "https:" || scheme === "ws:" || scheme === "wss:";
}
/**
 * @typedef ProtocolExtract
 * @type Object
 * @property {String} protocol Protocol matched in the URL, in lowercase.
 * @property {Boolean} slashes `true` if protocol is followed by "//", else `false`.
 * @property {String} rest Rest of the URL that is not part of the protocol.
 */ /**
 * Extract protocol information from a URL with/without double slash ("//").
 *
 * @param {String} address URL we want to extract from.
 * @param {Object} location
 * @return {ProtocolExtract} Extracted information.
 * @private
 */ function $ab77e3e2991c7c6b$var$extractProtocol(address, location) {
    address = $ab77e3e2991c7c6b$var$trimLeft(address);
    address = address.replace($ab77e3e2991c7c6b$var$CRHTLF, "");
    location = location || {};
    var match = $ab77e3e2991c7c6b$var$protocolre.exec(address);
    var protocol = match[1] ? match[1].toLowerCase() : "";
    var forwardSlashes = !!match[2];
    var otherSlashes = !!match[3];
    var slashesCount = 0;
    var rest;
    if (forwardSlashes) {
        if (otherSlashes) {
            rest = match[2] + match[3] + match[4];
            slashesCount = match[2].length + match[3].length;
        } else {
            rest = match[2] + match[4];
            slashesCount = match[2].length;
        }
    } else if (otherSlashes) {
        rest = match[3] + match[4];
        slashesCount = match[3].length;
    } else rest = match[4];
    if (protocol === "file:") {
        if (slashesCount >= 2) rest = rest.slice(2);
    } else if ($ab77e3e2991c7c6b$var$isSpecial(protocol)) rest = match[4];
    else if (protocol) {
        if (forwardSlashes) rest = rest.slice(2);
    } else if (slashesCount >= 2 && $ab77e3e2991c7c6b$var$isSpecial(location.protocol)) rest = match[4];
    return {
        protocol: protocol,
        slashes: forwardSlashes || $ab77e3e2991c7c6b$var$isSpecial(protocol),
        slashesCount: slashesCount,
        rest: rest
    };
}
/**
 * Resolve a relative URL pathname against a base URL pathname.
 *
 * @param {String} relative Pathname of the relative URL.
 * @param {String} base Pathname of the base URL.
 * @return {String} Resolved pathname.
 * @private
 */ function $ab77e3e2991c7c6b$var$resolve(relative, base) {
    if (relative === "") return base;
    var path = (base || "/").split("/").slice(0, -1).concat(relative.split("/")), i = path.length, last = path[i - 1], unshift = false, up = 0;
    while(i--){
        if (path[i] === ".") path.splice(i, 1);
        else if (path[i] === "..") {
            path.splice(i, 1);
            up++;
        } else if (up) {
            if (i === 0) unshift = true;
            path.splice(i, 1);
            up--;
        }
    }
    if (unshift) path.unshift("");
    if (last === "." || last === "..") path.push("");
    return path.join("/");
}
/**
 * The actual URL instance. Instead of returning an object we've opted-in to
 * create an actual constructor as it's much more memory efficient and
 * faster and it pleases my OCD.
 *
 * It is worth noting that we should not use `URL` as class name to prevent
 * clashes with the global URL instance that got introduced in browsers.
 *
 * @constructor
 * @param {String} address URL we want to parse.
 * @param {Object|String} [location] Location defaults for relative paths.
 * @param {Boolean|Function} [parser] Parser for the query string.
 * @private
 */ function $ab77e3e2991c7c6b$var$Url(address, location, parser) {
    address = $ab77e3e2991c7c6b$var$trimLeft(address);
    address = address.replace($ab77e3e2991c7c6b$var$CRHTLF, "");
    if (!(this instanceof $ab77e3e2991c7c6b$var$Url)) return new $ab77e3e2991c7c6b$var$Url(address, location, parser);
    var relative, extracted, parse, instruction, index, key, instructions = $ab77e3e2991c7c6b$var$rules.slice(), type = typeof location, url = this, i = 0;
    //
    // The following if statements allows this module two have compatibility with
    // 2 different API:
    //
    // 1. Node.js's `url.parse` api which accepts a URL, boolean as arguments
    //    where the boolean indicates that the query string should also be parsed.
    //
    // 2. The `URL` interface of the browser which accepts a URL, object as
    //    arguments. The supplied object will be used as default values / fall-back
    //    for relative paths.
    //
    if ("object" !== type && "string" !== type) {
        parser = location;
        location = null;
    }
    if (parser && "function" !== typeof parser) parser = $9kycz.parse;
    location = $ab77e3e2991c7c6b$var$lolcation(location);
    //
    // Extract protocol information before running the instructions.
    //
    extracted = $ab77e3e2991c7c6b$var$extractProtocol(address || "", location);
    relative = !extracted.protocol && !extracted.slashes;
    url.slashes = extracted.slashes || relative && location.slashes;
    url.protocol = extracted.protocol || location.protocol || "";
    address = extracted.rest;
    //
    // When the authority component is absent the URL starts with a path
    // component.
    //
    if (extracted.protocol === "file:" && (extracted.slashesCount !== 2 || $ab77e3e2991c7c6b$var$windowsDriveLetter.test(address)) || !extracted.slashes && (extracted.protocol || extracted.slashesCount < 2 || !$ab77e3e2991c7c6b$var$isSpecial(url.protocol))) instructions[3] = [
        /(.*)/,
        "pathname"
    ];
    for(; i < instructions.length; i++){
        instruction = instructions[i];
        if (typeof instruction === "function") {
            address = instruction(address, url);
            continue;
        }
        parse = instruction[0];
        key = instruction[1];
        if (parse !== parse) url[key] = address;
        else if ("string" === typeof parse) {
            index = parse === "@" ? address.lastIndexOf(parse) : address.indexOf(parse);
            if (~index) {
                if ("number" === typeof instruction[2]) {
                    url[key] = address.slice(0, index);
                    address = address.slice(index + instruction[2]);
                } else {
                    url[key] = address.slice(index);
                    address = address.slice(0, index);
                }
            }
        } else if (index = parse.exec(address)) {
            url[key] = index[1];
            address = address.slice(0, index.index);
        }
        url[key] = url[key] || (relative && instruction[3] ? location[key] || "" : "");
        //
        // Hostname, host and protocol should be lowercased so they can be used to
        // create a proper `origin`.
        //
        if (instruction[4]) url[key] = url[key].toLowerCase();
    }
    //
    // Also parse the supplied query string in to an object. If we're supplied
    // with a custom parser as function use that instead of the default build-in
    // parser.
    //
    if (parser) url.query = parser(url.query);
    //
    // If the URL is relative, resolve the pathname against the base URL.
    //
    if (relative && location.slashes && url.pathname.charAt(0) !== "/" && (url.pathname !== "" || location.pathname !== "")) url.pathname = $ab77e3e2991c7c6b$var$resolve(url.pathname, location.pathname);
    //
    // Default to a / for pathname if none exists. This normalizes the URL
    // to always have a /
    //
    if (url.pathname.charAt(0) !== "/" && $ab77e3e2991c7c6b$var$isSpecial(url.protocol)) url.pathname = "/" + url.pathname;
    //
    // We should not add port numbers if they are already the default port number
    // for a given protocol. As the host also contains the port number we're going
    // override it with the hostname which contains no port number.
    //
    if (!$3biuL(url.port, url.protocol)) {
        url.host = url.hostname;
        url.port = "";
    }
    //
    // Parse down the `auth` for the username and password.
    //
    url.username = url.password = "";
    if (url.auth) {
        index = url.auth.indexOf(":");
        if (~index) {
            url.username = url.auth.slice(0, index);
            url.username = encodeURIComponent(decodeURIComponent(url.username));
            url.password = url.auth.slice(index + 1);
            url.password = encodeURIComponent(decodeURIComponent(url.password));
        } else url.username = encodeURIComponent(decodeURIComponent(url.auth));
        url.auth = url.password ? url.username + ":" + url.password : url.username;
    }
    url.origin = url.protocol !== "file:" && $ab77e3e2991c7c6b$var$isSpecial(url.protocol) && url.host ? url.protocol + "//" + url.host : "null";
    //
    // The href is just the compiled result.
    //
    url.href = url.toString();
}
/**
 * This is convenience method for changing properties in the URL instance to
 * insure that they all propagate correctly.
 *
 * @param {String} part          Property we need to adjust.
 * @param {Mixed} value          The newly assigned value.
 * @param {Boolean|Function} fn  When setting the query, it will be the function
 *                               used to parse the query.
 *                               When setting the protocol, double slash will be
 *                               removed from the final url if it is true.
 * @returns {URL} URL instance for chaining.
 * @public
 */ function $ab77e3e2991c7c6b$var$set(part, value, fn) {
    var url = this;
    switch(part){
        case "query":
            if ("string" === typeof value && value.length) value = (fn || $9kycz.parse)(value);
            url[part] = value;
            break;
        case "port":
            url[part] = value;
            if (!$3biuL(value, url.protocol)) {
                url.host = url.hostname;
                url[part] = "";
            } else if (value) url.host = url.hostname + ":" + value;
            break;
        case "hostname":
            url[part] = value;
            if (url.port) value += ":" + url.port;
            url.host = value;
            break;
        case "host":
            url[part] = value;
            if ($ab77e3e2991c7c6b$var$port.test(value)) {
                value = value.split(":");
                url.port = value.pop();
                url.hostname = value.join(":");
            } else {
                url.hostname = value;
                url.port = "";
            }
            break;
        case "protocol":
            url.protocol = value.toLowerCase();
            url.slashes = !fn;
            break;
        case "pathname":
        case "hash":
            if (value) {
                var char = part === "pathname" ? "/" : "#";
                url[part] = value.charAt(0) !== char ? char + value : value;
            } else url[part] = value;
            break;
        case "username":
        case "password":
            url[part] = encodeURIComponent(value);
            break;
        case "auth":
            var index = value.indexOf(":");
            if (~index) {
                url.username = value.slice(0, index);
                url.username = encodeURIComponent(decodeURIComponent(url.username));
                url.password = value.slice(index + 1);
                url.password = encodeURIComponent(decodeURIComponent(url.password));
            } else url.username = encodeURIComponent(decodeURIComponent(value));
    }
    for(var i = 0; i < $ab77e3e2991c7c6b$var$rules.length; i++){
        var ins = $ab77e3e2991c7c6b$var$rules[i];
        if (ins[4]) url[ins[1]] = url[ins[1]].toLowerCase();
    }
    url.auth = url.password ? url.username + ":" + url.password : url.username;
    url.origin = url.protocol !== "file:" && $ab77e3e2991c7c6b$var$isSpecial(url.protocol) && url.host ? url.protocol + "//" + url.host : "null";
    url.href = url.toString();
    return url;
}
/**
 * Transform the properties back in to a valid and full URL string.
 *
 * @param {Function} stringify Optional query stringify function.
 * @returns {String} Compiled version of the URL.
 * @public
 */ function $ab77e3e2991c7c6b$var$toString(stringify) {
    if (!stringify || "function" !== typeof stringify) stringify = $9kycz.stringify;
    var query, url = this, host = url.host, protocol = url.protocol;
    if (protocol && protocol.charAt(protocol.length - 1) !== ":") protocol += ":";
    var result = protocol + (url.protocol && url.slashes || $ab77e3e2991c7c6b$var$isSpecial(url.protocol) ? "//" : "");
    if (url.username) {
        result += url.username;
        if (url.password) result += ":" + url.password;
        result += "@";
    } else if (url.password) {
        result += ":" + url.password;
        result += "@";
    } else if (url.protocol !== "file:" && $ab77e3e2991c7c6b$var$isSpecial(url.protocol) && !host && url.pathname !== "/") //
    // Add back the empty userinfo, otherwise the original invalid URL
    // might be transformed into a valid one with `url.pathname` as host.
    //
    result += "@";
    //
    // Trailing colon is removed from `url.host` when it is parsed. If it still
    // ends with a colon, then add back the trailing colon that was removed. This
    // prevents an invalid URL from being transformed into a valid one.
    //
    if (host[host.length - 1] === ":" || $ab77e3e2991c7c6b$var$port.test(url.hostname) && !url.port) host += ":";
    result += host + url.pathname;
    query = "object" === typeof url.query ? stringify(url.query) : url.query;
    if (query) result += "?" !== query.charAt(0) ? "?" + query : query;
    if (url.hash) result += url.hash;
    return result;
}
$ab77e3e2991c7c6b$var$Url.prototype = {
    set: $ab77e3e2991c7c6b$var$set,
    toString: $ab77e3e2991c7c6b$var$toString
};
//
// Expose the URL parser and some additional properties that might be useful for
// others or testing.
//
$ab77e3e2991c7c6b$var$Url.extractProtocol = $ab77e3e2991c7c6b$var$extractProtocol;
$ab77e3e2991c7c6b$var$Url.location = $ab77e3e2991c7c6b$var$lolcation;
$ab77e3e2991c7c6b$var$Url.trimLeft = $ab77e3e2991c7c6b$var$trimLeft;
$ab77e3e2991c7c6b$var$Url.qs = $9kycz;
module.exports = $ab77e3e2991c7c6b$var$Url;

});
parcelRequire.register("3biuL", function(module, exports) {
"use strict";
/**
 * Check if we're required to add a port number.
 *
 * @see https://url.spec.whatwg.org/#default-port
 * @param {Number|String} port Port number we need to check
 * @param {String} protocol Protocol we need to check against.
 * @returns {Boolean} Is it a default port for the given protocol
 * @api private
 */ module.exports = function required(port, protocol) {
    protocol = protocol.split(":")[0];
    port = +port;
    if (!port) return false;
    switch(protocol){
        case "http":
        case "ws":
            return port !== 80;
        case "https":
        case "wss":
            return port !== 443;
        case "ftp":
            return port !== 21;
        case "gopher":
            return port !== 70;
        case "file":
            return false;
    }
    return port !== 0;
};

});

parcelRequire.register("9kycz", function(module, exports) {

$parcel$export(module.exports, "stringify", () => $6cb083152a5a187d$export$fac44ee5b035f737, (v) => $6cb083152a5a187d$export$fac44ee5b035f737 = v);
$parcel$export(module.exports, "parse", () => $6cb083152a5a187d$export$98e6a39c04603d36, (v) => $6cb083152a5a187d$export$98e6a39c04603d36 = v);
//
// Expose the module.
//
var $6cb083152a5a187d$export$fac44ee5b035f737;
var $6cb083152a5a187d$export$98e6a39c04603d36;
"use strict";
var $6cb083152a5a187d$var$has = Object.prototype.hasOwnProperty, $6cb083152a5a187d$var$undef;
/**
 * Decode a URI encoded string.
 *
 * @param {String} input The URI encoded string.
 * @returns {String|Null} The decoded string.
 * @api private
 */ function $6cb083152a5a187d$var$decode(input) {
    try {
        return decodeURIComponent(input.replace(/\+/g, " "));
    } catch (e) {
        return null;
    }
}
/**
 * Attempts to encode a given input.
 *
 * @param {String} input The string that needs to be encoded.
 * @returns {String|Null} The encoded string.
 * @api private
 */ function $6cb083152a5a187d$var$encode(input) {
    try {
        return encodeURIComponent(input);
    } catch (e) {
        return null;
    }
}
/**
 * Simple query string parser.
 *
 * @param {String} query The query string that needs to be parsed.
 * @returns {Object}
 * @api public
 */ function $6cb083152a5a187d$var$querystring(query) {
    var parser = /([^=?#&]+)=?([^&]*)/g, result = {}, part;
    while(part = parser.exec(query)){
        var key = $6cb083152a5a187d$var$decode(part[1]), value = $6cb083152a5a187d$var$decode(part[2]);
        //
        // Prevent overriding of existing properties. This ensures that build-in
        // methods like `toString` or __proto__ are not overriden by malicious
        // querystrings.
        //
        // In the case if failed decoding, we want to omit the key/value pairs
        // from the result.
        //
        if (key === null || value === null || key in result) continue;
        result[key] = value;
    }
    return result;
}
/**
 * Transform a query string to an object.
 *
 * @param {Object} obj Object that should be transformed.
 * @param {String} prefix Optional prefix.
 * @returns {String}
 * @api public
 */ function $6cb083152a5a187d$var$querystringify(obj, prefix) {
    prefix = prefix || "";
    var pairs = [], value, key;
    //
    // Optionally prefix with a '?' if needed
    //
    if ("string" !== typeof prefix) prefix = "?";
    for(key in obj)if ($6cb083152a5a187d$var$has.call(obj, key)) {
        value = obj[key];
        //
        // Edge cases where we actually want to encode the value to an empty
        // string instead of the stringified value.
        //
        if (!value && (value === null || value === $6cb083152a5a187d$var$undef || isNaN(value))) value = "";
        key = $6cb083152a5a187d$var$encode(key);
        value = $6cb083152a5a187d$var$encode(value);
        //
        // If we failed to encode the strings, we should bail out as we don't
        // want to add invalid strings to the query.
        //
        if (key === null || value === null) continue;
        pairs.push(key + "=" + value);
    }
    return pairs.length ? prefix + pairs.join("&") : "";
}
$6cb083152a5a187d$export$fac44ee5b035f737 = $6cb083152a5a187d$var$querystringify;
$6cb083152a5a187d$export$98e6a39c04603d36 = $6cb083152a5a187d$var$querystring;

});


parcelRequire.register("eRdtr", function(module, exports) {

$parcel$export(module.exports, "Cache", () => $ad10779399cf921e$export$94affb487e701bf2, (v) => $ad10779399cf921e$export$94affb487e701bf2 = v);
$parcel$export(module.exports, "Agent", () => $ad10779399cf921e$export$f05c48a4001d5356, (v) => $ad10779399cf921e$export$f05c48a4001d5356 = v);
$parcel$export(module.exports, "getOCSPURI", () => $ad10779399cf921e$export$d13669af3ccf7e71, (v) => $ad10779399cf921e$export$d13669af3ccf7e71 = v);
$parcel$export(module.exports, "request", () => $ad10779399cf921e$export$b5fe3f66a567bec0, (v) => $ad10779399cf921e$export$b5fe3f66a567bec0 = v);
$parcel$export(module.exports, "check", () => $ad10779399cf921e$export$35dc45686fc2dbd7, (v) => $ad10779399cf921e$export$35dc45686fc2dbd7 = v);
$parcel$export(module.exports, "verify", () => $ad10779399cf921e$export$532244b5b8b0b4b6, (v) => $ad10779399cf921e$export$532244b5b8b0b4b6 = v);
$parcel$export(module.exports, "utils", () => $ad10779399cf921e$export$eab97d15b1788b8d, (v) => $ad10779399cf921e$export$eab97d15b1788b8d = v);
var $ad10779399cf921e$export$94affb487e701bf2;
var $ad10779399cf921e$export$f05c48a4001d5356;
var $ad10779399cf921e$export$d13669af3ccf7e71;
var $ad10779399cf921e$export$b5fe3f66a567bec0;
var $ad10779399cf921e$export$35dc45686fc2dbd7;
var $ad10779399cf921e$export$532244b5b8b0b4b6;
var $ad10779399cf921e$export$eab97d15b1788b8d;
"use strict";

$ad10779399cf921e$export$94affb487e701bf2 = (parcelRequire("7lATu"));

$ad10779399cf921e$export$f05c48a4001d5356 = (parcelRequire("05RYr"));

$ad10779399cf921e$export$d13669af3ccf7e71 = (parcelRequire("kbu4D")).getOCSPURI;

$ad10779399cf921e$export$b5fe3f66a567bec0 = (parcelRequire("bAXxn"));

$ad10779399cf921e$export$35dc45686fc2dbd7 = (parcelRequire("dD14r"));

$ad10779399cf921e$export$532244b5b8b0b4b6 = (parcelRequire("1a35T"));

$ad10779399cf921e$export$eab97d15b1788b8d = (parcelRequire("dNFSU"));

});
parcelRequire.register("7lATu", function(module, exports) {
"use strict";

var $eRdtr = parcelRequire("eRdtr");
function $55971cf09ab921e9$var$Cache(options) {
    this.options = options || {};
    this.cache = {};
    // Override methods
    if (this.options.probe) this.probe = this.options.probe;
    if (this.options.store) this.store = this.options.store;
    if (this.options.filter) this.filter = this.options.filter;
}
module.exports = $55971cf09ab921e9$var$Cache;
$55971cf09ab921e9$var$Cache.prototype.filter = function filter(url, callback) {
    callback(null);
};
$55971cf09ab921e9$var$Cache.prototype.probe = function probe(id, callback) {
    if (this.cache.hasOwnProperty(id)) callback(null, this.cache[id]);
    else callback(null, false);
};
$55971cf09ab921e9$var$Cache.prototype.store = function store(id, response, maxTime, callback) {
    if (this.cache.hasOwnProperty(id)) clearTimeout(this.cache[id].timer);
    var self = this;
    this.cache[id] = {
        response: response,
        timer: setTimeout(function() {
            delete self.cache[id];
        }, maxTime)
    };
    callback(null, null);
};
$55971cf09ab921e9$var$Cache.prototype.request = function request(id, data, callback) {
    var self = this;
    function done(err, response) {
        if (callback) callback(err, response);
        callback = null;
    }
    function onResponse(err, ocsp) {
        if (err) return done(err);
        // Respond early
        done(null, ocsp);
        // Try parsing and caching response
        self.getMaxStoreTime(ocsp, function(err, maxTime) {
            if (err) return;
            self.store(id, ocsp, maxTime, function() {
            // No-op
            });
        });
    }
    // Check that url isn't blacklisted
    this.filter(data.url, function(err) {
        if (err) return done(err, null);
        $eRdtr.utils.getResponse(data.url, data.ocsp, onResponse);
    });
};
$55971cf09ab921e9$var$Cache.prototype.getMaxStoreTime = function getMaxStoreTime(response, callback) {
    var basic;
    try {
        basic = $eRdtr.utils.parseResponse(response).value;
    } catch (e) {
        return callback(e);
    }
    // Not enough responses
    if (basic.tbsResponseData.responses.length === 0) return callback(new Error("No OCSP responses"));
    var responses = basic.tbsResponseData.responses;
    // Every response should be positive
    var good = responses.every(function(response) {
        return response.certStatus.type === "good";
    });
    // No good - no cache
    if (!good) return callback(new Error("Some OCSP responses are not good"));
    // Find minimum nextUpdate time
    var nextUpdate = 0;
    for(var i = 0; i < responses.length; i++){
        var response = responses[i];
        var responseNext = response.nextUpdate;
        if (!responseNext) continue;
        if (nextUpdate === 0 || nextUpdate > responseNext) nextUpdate = responseNext;
    }
    return callback(null, Math.max(0, nextUpdate - new Date()));
};

});

parcelRequire.register("05RYr", function(module, exports) {

var $cBXue = parcelRequire("cBXue");
var $00048dc56d6dda6d$require$Buffer = $cBXue.Buffer;
"use strict";

var $eRdtr = parcelRequire("eRdtr");

var $2PcSP = parcelRequire("2PcSP");

var $8jiUm = parcelRequire("8jiUm");

var $bUJWB = parcelRequire("bUJWB");

var $gR5sk = parcelRequire("gR5sk");

var $gR5sk = parcelRequire("gR5sk");
function $00048dc56d6dda6d$var$Agent(options) {
    if (!options) options = {};
    $bUJWB.Agent.call(this, options);
    this.caCache = new $gR5sk({
        maxSize: options.CACacheSize || 1024
    });
}
module.exports = $00048dc56d6dda6d$var$Agent;
$2PcSP.inherits($00048dc56d6dda6d$var$Agent, $bUJWB.Agent);
$00048dc56d6dda6d$var$Agent.prototype.createConnection = function createConnection(port, host, options) {
    if (port !== null && typeof port === "object") {
        options = port;
        port = null;
    } else if (host !== null && typeof host === "object") {
        options = host;
        host = null;
    } else if (options === null || typeof options !== "object") options = {};
    if (typeof port === "number") options.port = port;
    if (typeof host === "string") options.host = host;
    var ocspOptions = $2PcSP._extend({
        requestOCSP: true
    }, options);
    var socket = $bUJWB.Agent.prototype.createConnection.call(this, port, host, ocspOptions);
    var self = this;
    var stapling = null;
    socket.on("OCSPResponse", function(data) {
        stapling = data;
    });
    socket.on("secure", function() {
        return self.handleOCSPResponse(socket, stapling, function(err) {
            if (err) return socket.destroy(err);
            // Time to allow all writes!
            socket.uncork();
        });
    });
    // Do not let any writes come through until we will verify OCSP
    socket.cork();
    return socket;
};
$00048dc56d6dda6d$var$Agent.prototype.handleOCSPResponse = function handleOCSPResponse(socket, stapling, cb) {
    var cert = socket.ssl.getPeerCertificate(true);
    var issuer = cert.issuerCertificate;
    cert = cert.raw;
    try {
        cert = $gR5sk.Certificate.decode(cert, "der");
        if (issuer) {
            issuer = issuer.raw;
            issuer = $gR5sk.Certificate.decode(issuer, "der");
        }
    } catch (e) {
        return cb(e);
    }
    function onIssuer(err, x509) {
        if (err) return cb(err);
        issuer = x509;
        if (stapling) {
            var req = $eRdtr.request.generate(cert, issuer);
            $eRdtr.verify({
                request: req,
                response: stapling
            }, cb);
        } else return $eRdtr.check({
            cert: cert,
            issuer: issuer
        }, cb);
    }
    if (issuer) return onIssuer(null, issuer);
    else return this.fetchIssuer(cert, stapling, onIssuer);
};
$00048dc56d6dda6d$var$Agent.prototype.fetchIssuer = function fetchIssuer(cert, stapling, cb) {
    var issuers = $eRdtr.utils["id-ad-caIssuers"].join(".");
    var self = this;
    // TODO(indutny): use info from stapling response
    $eRdtr.utils.getAuthorityInfo(cert, issuers, function(err, uri) {
        if (err) return cb(err);
        var ca = self.caCache.get(uri);
        if (ca) return cb(null, ca);
        var once = false;
        function done(err, data) {
            if (once) return;
            once = true;
            cb(err, data);
        }
        function onResponse(res) {
            if (res.statusCode < 200 || res.statusCode >= 400) return done(new Error("Failed to fetch CA: " + res.statusCode));
            var chunks = [];
            res.on("readable", function() {
                var chunk = res.read();
                if (!chunk) return;
                chunks.push(chunk);
            });
            res.on("end", function() {
                var cert = $00048dc56d6dda6d$require$Buffer.concat(chunks);
                try {
                    cert = $gR5sk.Certificate.decode(cert, "der");
                } catch (e) {
                    return done(e);
                }
                self.caCache.set(uri, cert);
                done(null, cert);
            });
        }
        $8jiUm.get(uri).on("error", done).on("response", onResponse);
    });
};

});
parcelRequire.register("2PcSP", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var $hIXGI = parcelRequire("hIXGI");
var $20ea5687c7bafd77$var$getOwnPropertyDescriptors = Object.getOwnPropertyDescriptors || function getOwnPropertyDescriptors(obj) {
    var keys = Object.keys(obj);
    var descriptors = {};
    for(var i = 0; i < keys.length; i++)descriptors[keys[i]] = Object.getOwnPropertyDescriptor(obj, keys[i]);
    return descriptors;
};
var $20ea5687c7bafd77$var$formatRegExp = /%[sdj%]/g;
module.exports.format = function(f) {
    if (!$20ea5687c7bafd77$var$isString(f)) {
        var objects = [];
        for(var i = 0; i < arguments.length; i++)objects.push($20ea5687c7bafd77$var$inspect(arguments[i]));
        return objects.join(" ");
    }
    var i = 1;
    var args = arguments;
    var len = args.length;
    var str = String(f).replace($20ea5687c7bafd77$var$formatRegExp, function(x) {
        if (x === "%%") return "%";
        if (i >= len) return x;
        switch(x){
            case "%s":
                return String(args[i++]);
            case "%d":
                return Number(args[i++]);
            case "%j":
                try {
                    return JSON.stringify(args[i++]);
                } catch (_) {
                    return "[Circular]";
                }
            default:
                return x;
        }
    });
    for(var x = args[i]; i < len; x = args[++i])if ($20ea5687c7bafd77$var$isNull(x) || !$20ea5687c7bafd77$var$isObject(x)) str += " " + x;
    else str += " " + $20ea5687c7bafd77$var$inspect(x);
    return str;
};
// Mark that a method should not be used.
// Returns a modified function which warns once by default.
// If --no-deprecation is set, then it is a no-op.
module.exports.deprecate = function(fn, msg) {
    if (typeof $hIXGI !== "undefined" && $hIXGI.noDeprecation === true) return fn;
    // Allow for deprecating things in the process of starting up.
    if (typeof $hIXGI === "undefined") return function() {
        return module.exports.deprecate(fn, msg).apply(this, arguments);
    };
    var warned = false;
    function deprecated() {
        if (!warned) {
            if ($hIXGI.throwDeprecation) throw new Error(msg);
            else if ($hIXGI.traceDeprecation) console.trace(msg);
            else console.error(msg);
            warned = true;
        }
        return fn.apply(this, arguments);
    }
    return deprecated;
};
var $20ea5687c7bafd77$var$debugs = {};
var $20ea5687c7bafd77$var$debugEnvRegex = /^$/;
var $20ea5687c7bafd77$var$debugEnv;
module.exports.debuglog = function(set) {
    set = set.toUpperCase();
    if (!$20ea5687c7bafd77$var$debugs[set]) {
        if ($20ea5687c7bafd77$var$debugEnvRegex.test(set)) {
            var pid = $hIXGI.pid;
            $20ea5687c7bafd77$var$debugs[set] = function() {
                var msg = module.exports.format.apply(module.exports, arguments);
                console.error("%s %d: %s", set, pid, msg);
            };
        } else $20ea5687c7bafd77$var$debugs[set] = function() {};
    }
    return $20ea5687c7bafd77$var$debugs[set];
};
/**
 * Echos the value of a value. Trys to print the value out
 * in the best way possible given the different types.
 *
 * @param {Object} obj The object to print out.
 * @param {Object} opts Optional options object that alters the output.
 */ /* legacy: obj, showHidden, depth, colors*/ function $20ea5687c7bafd77$var$inspect(obj, opts) {
    // default options
    var ctx = {
        seen: [],
        stylize: $20ea5687c7bafd77$var$stylizeNoColor
    };
    // legacy...
    if (arguments.length >= 3) ctx.depth = arguments[2];
    if (arguments.length >= 4) ctx.colors = arguments[3];
    if ($20ea5687c7bafd77$var$isBoolean(opts)) // legacy...
    ctx.showHidden = opts;
    else if (opts) // got an "options" object
    module.exports._extend(ctx, opts);
    // set default options
    if ($20ea5687c7bafd77$var$isUndefined(ctx.showHidden)) ctx.showHidden = false;
    if ($20ea5687c7bafd77$var$isUndefined(ctx.depth)) ctx.depth = 2;
    if ($20ea5687c7bafd77$var$isUndefined(ctx.colors)) ctx.colors = false;
    if ($20ea5687c7bafd77$var$isUndefined(ctx.customInspect)) ctx.customInspect = true;
    if (ctx.colors) ctx.stylize = $20ea5687c7bafd77$var$stylizeWithColor;
    return $20ea5687c7bafd77$var$formatValue(ctx, obj, ctx.depth);
}
module.exports.inspect = $20ea5687c7bafd77$var$inspect;
// http://en.wikipedia.org/wiki/ANSI_escape_code#graphics
$20ea5687c7bafd77$var$inspect.colors = {
    "bold": [
        1,
        22
    ],
    "italic": [
        3,
        23
    ],
    "underline": [
        4,
        24
    ],
    "inverse": [
        7,
        27
    ],
    "white": [
        37,
        39
    ],
    "grey": [
        90,
        39
    ],
    "black": [
        30,
        39
    ],
    "blue": [
        34,
        39
    ],
    "cyan": [
        36,
        39
    ],
    "green": [
        32,
        39
    ],
    "magenta": [
        35,
        39
    ],
    "red": [
        31,
        39
    ],
    "yellow": [
        33,
        39
    ]
};
// Don't use 'blue' not visible on cmd.exe
$20ea5687c7bafd77$var$inspect.styles = {
    "special": "cyan",
    "number": "yellow",
    "boolean": "yellow",
    "undefined": "grey",
    "null": "bold",
    "string": "green",
    "date": "magenta",
    // "name": intentionally not styling
    "regexp": "red"
};
function $20ea5687c7bafd77$var$stylizeWithColor(str, styleType) {
    var style = $20ea5687c7bafd77$var$inspect.styles[styleType];
    if (style) return "\x1b[" + $20ea5687c7bafd77$var$inspect.colors[style][0] + "m" + str + "\x1b[" + $20ea5687c7bafd77$var$inspect.colors[style][1] + "m";
    else return str;
}
function $20ea5687c7bafd77$var$stylizeNoColor(str, styleType) {
    return str;
}
function $20ea5687c7bafd77$var$arrayToHash(array) {
    var hash = {};
    array.forEach(function(val, idx) {
        hash[val] = true;
    });
    return hash;
}
function $20ea5687c7bafd77$var$formatValue(ctx, value, recurseTimes) {
    // Provide a hook for user-specified inspect functions.
    // Check that value is an object with an inspect function on it
    if (ctx.customInspect && value && $20ea5687c7bafd77$var$isFunction(value.inspect) && // Filter out the util module, it's inspect function is special
    value.inspect !== module.exports.inspect && // Also filter out any prototype objects using the circular check.
    !(value.constructor && value.constructor.prototype === value)) {
        var ret = value.inspect(recurseTimes, ctx);
        if (!$20ea5687c7bafd77$var$isString(ret)) ret = $20ea5687c7bafd77$var$formatValue(ctx, ret, recurseTimes);
        return ret;
    }
    // Primitive types cannot have properties
    var primitive = $20ea5687c7bafd77$var$formatPrimitive(ctx, value);
    if (primitive) return primitive;
    // Look up the keys of the object.
    var keys = Object.keys(value);
    var visibleKeys = $20ea5687c7bafd77$var$arrayToHash(keys);
    if (ctx.showHidden) keys = Object.getOwnPropertyNames(value);
    // IE doesn't make error fields non-enumerable
    // http://msdn.microsoft.com/en-us/library/ie/dww52sbt(v=vs.94).aspx
    if ($20ea5687c7bafd77$var$isError(value) && (keys.indexOf("message") >= 0 || keys.indexOf("description") >= 0)) return $20ea5687c7bafd77$var$formatError(value);
    // Some type of object without properties can be shortcutted.
    if (keys.length === 0) {
        if ($20ea5687c7bafd77$var$isFunction(value)) {
            var name = value.name ? ": " + value.name : "";
            return ctx.stylize("[Function" + name + "]", "special");
        }
        if ($20ea5687c7bafd77$var$isRegExp(value)) return ctx.stylize(RegExp.prototype.toString.call(value), "regexp");
        if ($20ea5687c7bafd77$var$isDate(value)) return ctx.stylize(Date.prototype.toString.call(value), "date");
        if ($20ea5687c7bafd77$var$isError(value)) return $20ea5687c7bafd77$var$formatError(value);
    }
    var base = "", array = false, braces = [
        "{",
        "}"
    ];
    // Make Array say that they are Array
    if ($20ea5687c7bafd77$var$isArray(value)) {
        array = true;
        braces = [
            "[",
            "]"
        ];
    }
    // Make functions say that they are functions
    if ($20ea5687c7bafd77$var$isFunction(value)) {
        var n = value.name ? ": " + value.name : "";
        base = " [Function" + n + "]";
    }
    // Make RegExps say that they are RegExps
    if ($20ea5687c7bafd77$var$isRegExp(value)) base = " " + RegExp.prototype.toString.call(value);
    // Make dates with properties first say the date
    if ($20ea5687c7bafd77$var$isDate(value)) base = " " + Date.prototype.toUTCString.call(value);
    // Make error with message first say the error
    if ($20ea5687c7bafd77$var$isError(value)) base = " " + $20ea5687c7bafd77$var$formatError(value);
    if (keys.length === 0 && (!array || value.length == 0)) return braces[0] + base + braces[1];
    if (recurseTimes < 0) {
        if ($20ea5687c7bafd77$var$isRegExp(value)) return ctx.stylize(RegExp.prototype.toString.call(value), "regexp");
        else return ctx.stylize("[Object]", "special");
    }
    ctx.seen.push(value);
    var output;
    if (array) output = $20ea5687c7bafd77$var$formatArray(ctx, value, recurseTimes, visibleKeys, keys);
    else output = keys.map(function(key) {
        return $20ea5687c7bafd77$var$formatProperty(ctx, value, recurseTimes, visibleKeys, key, array);
    });
    ctx.seen.pop();
    return $20ea5687c7bafd77$var$reduceToSingleString(output, base, braces);
}
function $20ea5687c7bafd77$var$formatPrimitive(ctx, value) {
    if ($20ea5687c7bafd77$var$isUndefined(value)) return ctx.stylize("undefined", "undefined");
    if ($20ea5687c7bafd77$var$isString(value)) {
        var simple = "'" + JSON.stringify(value).replace(/^"|"$/g, "").replace(/'/g, "\\'").replace(/\\"/g, '"') + "'";
        return ctx.stylize(simple, "string");
    }
    if ($20ea5687c7bafd77$var$isNumber(value)) return ctx.stylize("" + value, "number");
    if ($20ea5687c7bafd77$var$isBoolean(value)) return ctx.stylize("" + value, "boolean");
    // For some reason typeof null is "object", so special case here.
    if ($20ea5687c7bafd77$var$isNull(value)) return ctx.stylize("null", "null");
}
function $20ea5687c7bafd77$var$formatError(value) {
    return "[" + Error.prototype.toString.call(value) + "]";
}
function $20ea5687c7bafd77$var$formatArray(ctx, value, recurseTimes, visibleKeys, keys) {
    var output = [];
    for(var i = 0, l = value.length; i < l; ++i)if ($20ea5687c7bafd77$var$hasOwnProperty(value, String(i))) output.push($20ea5687c7bafd77$var$formatProperty(ctx, value, recurseTimes, visibleKeys, String(i), true));
    else output.push("");
    keys.forEach(function(key) {
        if (!key.match(/^\d+$/)) output.push($20ea5687c7bafd77$var$formatProperty(ctx, value, recurseTimes, visibleKeys, key, true));
    });
    return output;
}
function $20ea5687c7bafd77$var$formatProperty(ctx, value, recurseTimes, visibleKeys, key, array) {
    var name, str, desc;
    desc = Object.getOwnPropertyDescriptor(value, key) || {
        value: value[key]
    };
    if (desc.get) {
        if (desc.set) str = ctx.stylize("[Getter/Setter]", "special");
        else str = ctx.stylize("[Getter]", "special");
    } else if (desc.set) str = ctx.stylize("[Setter]", "special");
    if (!$20ea5687c7bafd77$var$hasOwnProperty(visibleKeys, key)) name = "[" + key + "]";
    if (!str) {
        if (ctx.seen.indexOf(desc.value) < 0) {
            if ($20ea5687c7bafd77$var$isNull(recurseTimes)) str = $20ea5687c7bafd77$var$formatValue(ctx, desc.value, null);
            else str = $20ea5687c7bafd77$var$formatValue(ctx, desc.value, recurseTimes - 1);
            if (str.indexOf("\n") > -1) {
                if (array) str = str.split("\n").map(function(line) {
                    return "  " + line;
                }).join("\n").slice(2);
                else str = "\n" + str.split("\n").map(function(line) {
                    return "   " + line;
                }).join("\n");
            }
        } else str = ctx.stylize("[Circular]", "special");
    }
    if ($20ea5687c7bafd77$var$isUndefined(name)) {
        if (array && key.match(/^\d+$/)) return str;
        name = JSON.stringify("" + key);
        if (name.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)) {
            name = name.slice(1, -1);
            name = ctx.stylize(name, "name");
        } else {
            name = name.replace(/'/g, "\\'").replace(/\\"/g, '"').replace(/(^"|"$)/g, "'");
            name = ctx.stylize(name, "string");
        }
    }
    return name + ": " + str;
}
function $20ea5687c7bafd77$var$reduceToSingleString(output, base, braces) {
    var numLinesEst = 0;
    var length = output.reduce(function(prev, cur) {
        numLinesEst++;
        if (cur.indexOf("\n") >= 0) numLinesEst++;
        return prev + cur.replace(/\u001b\[\d\d?m/g, "").length + 1;
    }, 0);
    if (length > 60) return braces[0] + (base === "" ? "" : base + "\n ") + " " + output.join(",\n  ") + " " + braces[1];
    return braces[0] + base + " " + output.join(", ") + " " + braces[1];
}

// NOTE: These type checking functions intentionally don't use `instanceof`
// because it is fragile and can be easily faked with `Object.create()`.
module.exports.types = (parcelRequire("aG2Ys"));
function $20ea5687c7bafd77$var$isArray(ar) {
    return Array.isArray(ar);
}
module.exports.isArray = $20ea5687c7bafd77$var$isArray;
function $20ea5687c7bafd77$var$isBoolean(arg) {
    return typeof arg === "boolean";
}
module.exports.isBoolean = $20ea5687c7bafd77$var$isBoolean;
function $20ea5687c7bafd77$var$isNull(arg) {
    return arg === null;
}
module.exports.isNull = $20ea5687c7bafd77$var$isNull;
function $20ea5687c7bafd77$var$isNullOrUndefined(arg) {
    return arg == null;
}
module.exports.isNullOrUndefined = $20ea5687c7bafd77$var$isNullOrUndefined;
function $20ea5687c7bafd77$var$isNumber(arg) {
    return typeof arg === "number";
}
module.exports.isNumber = $20ea5687c7bafd77$var$isNumber;
function $20ea5687c7bafd77$var$isString(arg) {
    return typeof arg === "string";
}
module.exports.isString = $20ea5687c7bafd77$var$isString;
function $20ea5687c7bafd77$var$isSymbol(arg) {
    return typeof arg === "symbol";
}
module.exports.isSymbol = $20ea5687c7bafd77$var$isSymbol;
function $20ea5687c7bafd77$var$isUndefined(arg) {
    return arg === void 0;
}
module.exports.isUndefined = $20ea5687c7bafd77$var$isUndefined;
function $20ea5687c7bafd77$var$isRegExp(re) {
    return $20ea5687c7bafd77$var$isObject(re) && $20ea5687c7bafd77$var$objectToString(re) === "[object RegExp]";
}
module.exports.isRegExp = $20ea5687c7bafd77$var$isRegExp;
module.exports.types.isRegExp = $20ea5687c7bafd77$var$isRegExp;
function $20ea5687c7bafd77$var$isObject(arg) {
    return typeof arg === "object" && arg !== null;
}
module.exports.isObject = $20ea5687c7bafd77$var$isObject;
function $20ea5687c7bafd77$var$isDate(d) {
    return $20ea5687c7bafd77$var$isObject(d) && $20ea5687c7bafd77$var$objectToString(d) === "[object Date]";
}
module.exports.isDate = $20ea5687c7bafd77$var$isDate;
module.exports.types.isDate = $20ea5687c7bafd77$var$isDate;
function $20ea5687c7bafd77$var$isError(e) {
    return $20ea5687c7bafd77$var$isObject(e) && ($20ea5687c7bafd77$var$objectToString(e) === "[object Error]" || e instanceof Error);
}
module.exports.isError = $20ea5687c7bafd77$var$isError;
module.exports.types.isNativeError = $20ea5687c7bafd77$var$isError;
function $20ea5687c7bafd77$var$isFunction(arg) {
    return typeof arg === "function";
}
module.exports.isFunction = $20ea5687c7bafd77$var$isFunction;
function $20ea5687c7bafd77$var$isPrimitive(arg) {
    return arg === null || typeof arg === "boolean" || typeof arg === "number" || typeof arg === "string" || typeof arg === "symbol" || // ES6 symbol
    typeof arg === "undefined";
}
module.exports.isPrimitive = $20ea5687c7bafd77$var$isPrimitive;

module.exports.isBuffer = (parcelRequire("7wgB4"));
function $20ea5687c7bafd77$var$objectToString(o) {
    return Object.prototype.toString.call(o);
}
function $20ea5687c7bafd77$var$pad(n) {
    return n < 10 ? "0" + n.toString(10) : n.toString(10);
}
var $20ea5687c7bafd77$var$months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
];
// 26 Feb 16:19:34
function $20ea5687c7bafd77$var$timestamp() {
    var d = new Date();
    var time = [
        $20ea5687c7bafd77$var$pad(d.getHours()),
        $20ea5687c7bafd77$var$pad(d.getMinutes()),
        $20ea5687c7bafd77$var$pad(d.getSeconds())
    ].join(":");
    return [
        d.getDate(),
        $20ea5687c7bafd77$var$months[d.getMonth()],
        time
    ].join(" ");
}
// log is just a thin wrapper to console.log that prepends a timestamp
module.exports.log = function() {
    console.log("%s - %s", $20ea5687c7bafd77$var$timestamp(), module.exports.format.apply(module.exports, arguments));
};

/**
 * Inherit the prototype methods from one constructor into another.
 *
 * The Function.prototype.inherits from lang.js rewritten as a standalone
 * function (not on Function.prototype). NOTE: If this file is to be loaded
 * during bootstrapping this function needs to be rewritten using some native
 * functions as prototype setup using normal JavaScript does not work as
 * expected during bootstrapping (see mirror.js in r114903).
 *
 * @param {function} ctor Constructor function which needs to inherit the
 *     prototype.
 * @param {function} superCtor Constructor function to inherit prototype from.
 */ module.exports.inherits = (parcelRequire("5SAkX"));
module.exports._extend = function(origin, add) {
    // Don't do anything if add isn't an object
    if (!add || !$20ea5687c7bafd77$var$isObject(add)) return origin;
    var keys = Object.keys(add);
    var i = keys.length;
    while(i--)origin[keys[i]] = add[keys[i]];
    return origin;
};
function $20ea5687c7bafd77$var$hasOwnProperty(obj, prop) {
    return Object.prototype.hasOwnProperty.call(obj, prop);
}
var $20ea5687c7bafd77$var$kCustomPromisifiedSymbol = typeof Symbol !== "undefined" ? Symbol("util.promisify.custom") : undefined;
module.exports.promisify = function promisify(original) {
    if (typeof original !== "function") throw new TypeError('The "original" argument must be of type Function');
    if ($20ea5687c7bafd77$var$kCustomPromisifiedSymbol && original[$20ea5687c7bafd77$var$kCustomPromisifiedSymbol]) {
        var fn = original[$20ea5687c7bafd77$var$kCustomPromisifiedSymbol];
        if (typeof fn !== "function") throw new TypeError('The "util.promisify.custom" argument must be of type Function');
        Object.defineProperty(fn, $20ea5687c7bafd77$var$kCustomPromisifiedSymbol, {
            value: fn,
            enumerable: false,
            writable: false,
            configurable: true
        });
        return fn;
    }
    function fn() {
        var promiseResolve, promiseReject;
        var promise = new Promise(function(resolve, reject) {
            promiseResolve = resolve;
            promiseReject = reject;
        });
        var args = [];
        for(var i = 0; i < arguments.length; i++)args.push(arguments[i]);
        args.push(function(err, value) {
            if (err) promiseReject(err);
            else promiseResolve(value);
        });
        try {
            original.apply(this, args);
        } catch (err) {
            promiseReject(err);
        }
        return promise;
    }
    Object.setPrototypeOf(fn, Object.getPrototypeOf(original));
    if ($20ea5687c7bafd77$var$kCustomPromisifiedSymbol) Object.defineProperty(fn, $20ea5687c7bafd77$var$kCustomPromisifiedSymbol, {
        value: fn,
        enumerable: false,
        writable: false,
        configurable: true
    });
    return Object.defineProperties(fn, $20ea5687c7bafd77$var$getOwnPropertyDescriptors(original));
};
module.exports.promisify.custom = $20ea5687c7bafd77$var$kCustomPromisifiedSymbol;
function $20ea5687c7bafd77$var$callbackifyOnRejected(reason, cb) {
    // `!reason` guard inspired by bluebird (Ref: https://goo.gl/t5IS6M).
    // Because `null` is a special error value in callbacks which means "no error
    // occurred", we error-wrap so the callback consumer can distinguish between
    // "the promise rejected with null" or "the promise fulfilled with undefined".
    if (!reason) {
        var newReason = new Error("Promise was rejected with a falsy value");
        newReason.reason = reason;
        reason = newReason;
    }
    return cb(reason);
}
function $20ea5687c7bafd77$var$callbackify(original) {
    if (typeof original !== "function") throw new TypeError('The "original" argument must be of type Function');
    // We DO NOT return the promise as it gives the user a false sense that
    // the promise is actually somehow related to the callback's execution
    // and that the callback throwing will reject the promise.
    function callbackified() {
        var args = [];
        for(var i = 0; i < arguments.length; i++)args.push(arguments[i]);
        var maybeCb = args.pop();
        if (typeof maybeCb !== "function") throw new TypeError("The last argument must be of type Function");
        var self = this;
        var cb = function() {
            return maybeCb.apply(self, arguments);
        };
        // In true node style we process the callback on `nextTick` with all the
        // implications (stack, `uncaughtException`, `async_hooks`)
        original.apply(this, args).then(function(ret) {
            $hIXGI.nextTick(cb.bind(null, null, ret));
        }, function(rej) {
            $hIXGI.nextTick($20ea5687c7bafd77$var$callbackifyOnRejected.bind(null, rej, cb));
        });
    }
    Object.setPrototypeOf(callbackified, Object.getPrototypeOf(original));
    Object.defineProperties(callbackified, $20ea5687c7bafd77$var$getOwnPropertyDescriptors(original));
    return callbackified;
}
module.exports.callbackify = $20ea5687c7bafd77$var$callbackify;

});
parcelRequire.register("aG2Ys", function(module, exports) {
// Currently in sync with Node.js lib/internal/util/types.js
// https://github.com/nodejs/node/commit/112cc7c27551254aa2b17098fb774867f05ed0d9
"use strict";

var $55AkD = parcelRequire("55AkD");

var $hdXwQ = parcelRequire("hdXwQ");

var $ldGla = parcelRequire("ldGla");

var $jxa5R = parcelRequire("jxa5R");
function $7c60223cb39cc931$var$uncurryThis(f) {
    return f.call.bind(f);
}
var $7c60223cb39cc931$var$BigIntSupported = typeof BigInt !== "undefined";
var $7c60223cb39cc931$var$SymbolSupported = typeof Symbol !== "undefined";
var $7c60223cb39cc931$var$ObjectToString = $7c60223cb39cc931$var$uncurryThis(Object.prototype.toString);
var $7c60223cb39cc931$var$numberValue = $7c60223cb39cc931$var$uncurryThis(Number.prototype.valueOf);
var $7c60223cb39cc931$var$stringValue = $7c60223cb39cc931$var$uncurryThis(String.prototype.valueOf);
var $7c60223cb39cc931$var$booleanValue = $7c60223cb39cc931$var$uncurryThis(Boolean.prototype.valueOf);
if ($7c60223cb39cc931$var$BigIntSupported) var $7c60223cb39cc931$var$bigIntValue = $7c60223cb39cc931$var$uncurryThis(BigInt.prototype.valueOf);
if ($7c60223cb39cc931$var$SymbolSupported) var $7c60223cb39cc931$var$symbolValue = $7c60223cb39cc931$var$uncurryThis(Symbol.prototype.valueOf);
function $7c60223cb39cc931$var$checkBoxedPrimitive(value, prototypeValueOf) {
    if (typeof value !== "object") return false;
    try {
        prototypeValueOf(value);
        return true;
    } catch (e) {
        return false;
    }
}
module.exports.isArgumentsObject = $55AkD;
module.exports.isGeneratorFunction = $hdXwQ;
module.exports.isTypedArray = $jxa5R;
// Taken from here and modified for better browser support
// https://github.com/sindresorhus/p-is-promise/blob/cda35a513bda03f977ad5cde3a079d237e82d7ef/index.js
function $7c60223cb39cc931$var$isPromise(input) {
    return typeof Promise !== "undefined" && input instanceof Promise || input !== null && typeof input === "object" && typeof input.then === "function" && typeof input.catch === "function";
}
module.exports.isPromise = $7c60223cb39cc931$var$isPromise;
function $7c60223cb39cc931$var$isArrayBufferView(value) {
    if (typeof ArrayBuffer !== "undefined" && ArrayBuffer.isView) return ArrayBuffer.isView(value);
    return $jxa5R(value) || $7c60223cb39cc931$var$isDataView(value);
}
module.exports.isArrayBufferView = $7c60223cb39cc931$var$isArrayBufferView;
function $7c60223cb39cc931$var$isUint8Array(value) {
    return $ldGla(value) === "Uint8Array";
}
module.exports.isUint8Array = $7c60223cb39cc931$var$isUint8Array;
function $7c60223cb39cc931$var$isUint8ClampedArray(value) {
    return $ldGla(value) === "Uint8ClampedArray";
}
module.exports.isUint8ClampedArray = $7c60223cb39cc931$var$isUint8ClampedArray;
function $7c60223cb39cc931$var$isUint16Array(value) {
    return $ldGla(value) === "Uint16Array";
}
module.exports.isUint16Array = $7c60223cb39cc931$var$isUint16Array;
function $7c60223cb39cc931$var$isUint32Array(value) {
    return $ldGla(value) === "Uint32Array";
}
module.exports.isUint32Array = $7c60223cb39cc931$var$isUint32Array;
function $7c60223cb39cc931$var$isInt8Array(value) {
    return $ldGla(value) === "Int8Array";
}
module.exports.isInt8Array = $7c60223cb39cc931$var$isInt8Array;
function $7c60223cb39cc931$var$isInt16Array(value) {
    return $ldGla(value) === "Int16Array";
}
module.exports.isInt16Array = $7c60223cb39cc931$var$isInt16Array;
function $7c60223cb39cc931$var$isInt32Array(value) {
    return $ldGla(value) === "Int32Array";
}
module.exports.isInt32Array = $7c60223cb39cc931$var$isInt32Array;
function $7c60223cb39cc931$var$isFloat32Array(value) {
    return $ldGla(value) === "Float32Array";
}
module.exports.isFloat32Array = $7c60223cb39cc931$var$isFloat32Array;
function $7c60223cb39cc931$var$isFloat64Array(value) {
    return $ldGla(value) === "Float64Array";
}
module.exports.isFloat64Array = $7c60223cb39cc931$var$isFloat64Array;
function $7c60223cb39cc931$var$isBigInt64Array(value) {
    return $ldGla(value) === "BigInt64Array";
}
module.exports.isBigInt64Array = $7c60223cb39cc931$var$isBigInt64Array;
function $7c60223cb39cc931$var$isBigUint64Array(value) {
    return $ldGla(value) === "BigUint64Array";
}
module.exports.isBigUint64Array = $7c60223cb39cc931$var$isBigUint64Array;
function $7c60223cb39cc931$var$isMapToString(value) {
    return $7c60223cb39cc931$var$ObjectToString(value) === "[object Map]";
}
$7c60223cb39cc931$var$isMapToString.working = typeof Map !== "undefined" && $7c60223cb39cc931$var$isMapToString(new Map());
function $7c60223cb39cc931$var$isMap(value) {
    if (typeof Map === "undefined") return false;
    return $7c60223cb39cc931$var$isMapToString.working ? $7c60223cb39cc931$var$isMapToString(value) : value instanceof Map;
}
module.exports.isMap = $7c60223cb39cc931$var$isMap;
function $7c60223cb39cc931$var$isSetToString(value) {
    return $7c60223cb39cc931$var$ObjectToString(value) === "[object Set]";
}
$7c60223cb39cc931$var$isSetToString.working = typeof Set !== "undefined" && $7c60223cb39cc931$var$isSetToString(new Set());
function $7c60223cb39cc931$var$isSet(value) {
    if (typeof Set === "undefined") return false;
    return $7c60223cb39cc931$var$isSetToString.working ? $7c60223cb39cc931$var$isSetToString(value) : value instanceof Set;
}
module.exports.isSet = $7c60223cb39cc931$var$isSet;
function $7c60223cb39cc931$var$isWeakMapToString(value) {
    return $7c60223cb39cc931$var$ObjectToString(value) === "[object WeakMap]";
}
$7c60223cb39cc931$var$isWeakMapToString.working = typeof WeakMap !== "undefined" && $7c60223cb39cc931$var$isWeakMapToString(new WeakMap());
function $7c60223cb39cc931$var$isWeakMap(value) {
    if (typeof WeakMap === "undefined") return false;
    return $7c60223cb39cc931$var$isWeakMapToString.working ? $7c60223cb39cc931$var$isWeakMapToString(value) : value instanceof WeakMap;
}
module.exports.isWeakMap = $7c60223cb39cc931$var$isWeakMap;
function $7c60223cb39cc931$var$isWeakSetToString(value) {
    return $7c60223cb39cc931$var$ObjectToString(value) === "[object WeakSet]";
}
$7c60223cb39cc931$var$isWeakSetToString.working = typeof WeakSet !== "undefined" && $7c60223cb39cc931$var$isWeakSetToString(new WeakSet());
function $7c60223cb39cc931$var$isWeakSet(value) {
    return $7c60223cb39cc931$var$isWeakSetToString(value);
}
module.exports.isWeakSet = $7c60223cb39cc931$var$isWeakSet;
function $7c60223cb39cc931$var$isArrayBufferToString(value) {
    return $7c60223cb39cc931$var$ObjectToString(value) === "[object ArrayBuffer]";
}
$7c60223cb39cc931$var$isArrayBufferToString.working = typeof ArrayBuffer !== "undefined" && $7c60223cb39cc931$var$isArrayBufferToString(new ArrayBuffer());
function $7c60223cb39cc931$var$isArrayBuffer(value) {
    if (typeof ArrayBuffer === "undefined") return false;
    return $7c60223cb39cc931$var$isArrayBufferToString.working ? $7c60223cb39cc931$var$isArrayBufferToString(value) : value instanceof ArrayBuffer;
}
module.exports.isArrayBuffer = $7c60223cb39cc931$var$isArrayBuffer;
function $7c60223cb39cc931$var$isDataViewToString(value) {
    return $7c60223cb39cc931$var$ObjectToString(value) === "[object DataView]";
}
$7c60223cb39cc931$var$isDataViewToString.working = typeof ArrayBuffer !== "undefined" && typeof DataView !== "undefined" && $7c60223cb39cc931$var$isDataViewToString(new DataView(new ArrayBuffer(1), 0, 1));
function $7c60223cb39cc931$var$isDataView(value) {
    if (typeof DataView === "undefined") return false;
    return $7c60223cb39cc931$var$isDataViewToString.working ? $7c60223cb39cc931$var$isDataViewToString(value) : value instanceof DataView;
}
module.exports.isDataView = $7c60223cb39cc931$var$isDataView;
// Store a copy of SharedArrayBuffer in case it's deleted elsewhere
var $7c60223cb39cc931$var$SharedArrayBufferCopy = typeof SharedArrayBuffer !== "undefined" ? SharedArrayBuffer : undefined;
function $7c60223cb39cc931$var$isSharedArrayBufferToString(value) {
    return $7c60223cb39cc931$var$ObjectToString(value) === "[object SharedArrayBuffer]";
}
function $7c60223cb39cc931$var$isSharedArrayBuffer(value) {
    if (typeof $7c60223cb39cc931$var$SharedArrayBufferCopy === "undefined") return false;
    if (typeof $7c60223cb39cc931$var$isSharedArrayBufferToString.working === "undefined") $7c60223cb39cc931$var$isSharedArrayBufferToString.working = $7c60223cb39cc931$var$isSharedArrayBufferToString(new $7c60223cb39cc931$var$SharedArrayBufferCopy());
    return $7c60223cb39cc931$var$isSharedArrayBufferToString.working ? $7c60223cb39cc931$var$isSharedArrayBufferToString(value) : value instanceof $7c60223cb39cc931$var$SharedArrayBufferCopy;
}
module.exports.isSharedArrayBuffer = $7c60223cb39cc931$var$isSharedArrayBuffer;
function $7c60223cb39cc931$var$isAsyncFunction(value) {
    return $7c60223cb39cc931$var$ObjectToString(value) === "[object AsyncFunction]";
}
module.exports.isAsyncFunction = $7c60223cb39cc931$var$isAsyncFunction;
function $7c60223cb39cc931$var$isMapIterator(value) {
    return $7c60223cb39cc931$var$ObjectToString(value) === "[object Map Iterator]";
}
module.exports.isMapIterator = $7c60223cb39cc931$var$isMapIterator;
function $7c60223cb39cc931$var$isSetIterator(value) {
    return $7c60223cb39cc931$var$ObjectToString(value) === "[object Set Iterator]";
}
module.exports.isSetIterator = $7c60223cb39cc931$var$isSetIterator;
function $7c60223cb39cc931$var$isGeneratorObject(value) {
    return $7c60223cb39cc931$var$ObjectToString(value) === "[object Generator]";
}
module.exports.isGeneratorObject = $7c60223cb39cc931$var$isGeneratorObject;
function $7c60223cb39cc931$var$isWebAssemblyCompiledModule(value) {
    return $7c60223cb39cc931$var$ObjectToString(value) === "[object WebAssembly.Module]";
}
module.exports.isWebAssemblyCompiledModule = $7c60223cb39cc931$var$isWebAssemblyCompiledModule;
function $7c60223cb39cc931$var$isNumberObject(value) {
    return $7c60223cb39cc931$var$checkBoxedPrimitive(value, $7c60223cb39cc931$var$numberValue);
}
module.exports.isNumberObject = $7c60223cb39cc931$var$isNumberObject;
function $7c60223cb39cc931$var$isStringObject(value) {
    return $7c60223cb39cc931$var$checkBoxedPrimitive(value, $7c60223cb39cc931$var$stringValue);
}
module.exports.isStringObject = $7c60223cb39cc931$var$isStringObject;
function $7c60223cb39cc931$var$isBooleanObject(value) {
    return $7c60223cb39cc931$var$checkBoxedPrimitive(value, $7c60223cb39cc931$var$booleanValue);
}
module.exports.isBooleanObject = $7c60223cb39cc931$var$isBooleanObject;
function $7c60223cb39cc931$var$isBigIntObject(value) {
    return $7c60223cb39cc931$var$BigIntSupported && $7c60223cb39cc931$var$checkBoxedPrimitive(value, $7c60223cb39cc931$var$bigIntValue);
}
module.exports.isBigIntObject = $7c60223cb39cc931$var$isBigIntObject;
function $7c60223cb39cc931$var$isSymbolObject(value) {
    return $7c60223cb39cc931$var$SymbolSupported && $7c60223cb39cc931$var$checkBoxedPrimitive(value, $7c60223cb39cc931$var$symbolValue);
}
module.exports.isSymbolObject = $7c60223cb39cc931$var$isSymbolObject;
function $7c60223cb39cc931$var$isBoxedPrimitive(value) {
    return $7c60223cb39cc931$var$isNumberObject(value) || $7c60223cb39cc931$var$isStringObject(value) || $7c60223cb39cc931$var$isBooleanObject(value) || $7c60223cb39cc931$var$isBigIntObject(value) || $7c60223cb39cc931$var$isSymbolObject(value);
}
module.exports.isBoxedPrimitive = $7c60223cb39cc931$var$isBoxedPrimitive;
function $7c60223cb39cc931$var$isAnyArrayBuffer(value) {
    return typeof Uint8Array !== "undefined" && ($7c60223cb39cc931$var$isArrayBuffer(value) || $7c60223cb39cc931$var$isSharedArrayBuffer(value));
}
module.exports.isAnyArrayBuffer = $7c60223cb39cc931$var$isAnyArrayBuffer;
[
    "isProxy",
    "isExternal",
    "isModuleNamespaceObject"
].forEach(function(method) {
    Object.defineProperty(module.exports, method, {
        enumerable: false,
        value: function() {
            throw new Error(method + " is not supported in userland");
        }
    });
});

});
parcelRequire.register("55AkD", function(module, exports) {
"use strict";

var $3b499a1fbc5c928c$var$hasToStringTag = (parcelRequire("cUn2I"))();

var $8VKch = parcelRequire("8VKch");
var $3b499a1fbc5c928c$var$$toString = $8VKch("Object.prototype.toString");
var $3b499a1fbc5c928c$var$isStandardArguments = function isArguments(value) {
    if ($3b499a1fbc5c928c$var$hasToStringTag && value && typeof value === "object" && Symbol.toStringTag in value) return false;
    return $3b499a1fbc5c928c$var$$toString(value) === "[object Arguments]";
};
var $3b499a1fbc5c928c$var$isLegacyArguments = function isArguments(value) {
    if ($3b499a1fbc5c928c$var$isStandardArguments(value)) return true;
    return value !== null && typeof value === "object" && typeof value.length === "number" && value.length >= 0 && $3b499a1fbc5c928c$var$$toString(value) !== "[object Array]" && $3b499a1fbc5c928c$var$$toString(value.callee) === "[object Function]";
};
var $3b499a1fbc5c928c$var$supportsStandardArguments = function() {
    return $3b499a1fbc5c928c$var$isStandardArguments(arguments);
}();
$3b499a1fbc5c928c$var$isStandardArguments.isLegacyArguments = $3b499a1fbc5c928c$var$isLegacyArguments; // for tests
module.exports = $3b499a1fbc5c928c$var$supportsStandardArguments ? $3b499a1fbc5c928c$var$isStandardArguments : $3b499a1fbc5c928c$var$isLegacyArguments;

});
parcelRequire.register("cUn2I", function(module, exports) {
"use strict";

var $8luVB = parcelRequire("8luVB");
module.exports = function hasToStringTagShams() {
    return $8luVB() && !!Symbol.toStringTag;
};

});
parcelRequire.register("8luVB", function(module, exports) {
"use strict";
/* eslint complexity: [2, 18], max-statements: [2, 33] */ module.exports = function hasSymbols() {
    if (typeof Symbol !== "function" || typeof Object.getOwnPropertySymbols !== "function") return false;
    if (typeof Symbol.iterator === "symbol") return true;
    var obj = {};
    var sym = Symbol("test");
    var symObj = Object(sym);
    if (typeof sym === "string") return false;
    if (Object.prototype.toString.call(sym) !== "[object Symbol]") return false;
    if (Object.prototype.toString.call(symObj) !== "[object Symbol]") return false;
    // temp disabled per https://github.com/ljharb/object.assign/issues/17
    // if (sym instanceof Symbol) { return false; }
    // temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
    // if (!(symObj instanceof Symbol)) { return false; }
    // if (typeof Symbol.prototype.toString !== 'function') { return false; }
    // if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }
    var symVal = 42;
    obj[sym] = symVal;
    for(sym in obj)return false;
     // eslint-disable-line no-restricted-syntax, no-unreachable-loop
    if (typeof Object.keys === "function" && Object.keys(obj).length !== 0) return false;
    if (typeof Object.getOwnPropertyNames === "function" && Object.getOwnPropertyNames(obj).length !== 0) return false;
    var syms = Object.getOwnPropertySymbols(obj);
    if (syms.length !== 1 || syms[0] !== sym) return false;
    if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) return false;
    if (typeof Object.getOwnPropertyDescriptor === "function") {
        var descriptor = Object.getOwnPropertyDescriptor(obj, sym);
        if (descriptor.value !== symVal || descriptor.enumerable !== true) return false;
    }
    return true;
};

});


parcelRequire.register("8VKch", function(module, exports) {
"use strict";

var $4Mbpx = parcelRequire("4Mbpx");

var $706eK = parcelRequire("706eK");
var $68077b5e48473712$var$$indexOf = $706eK($4Mbpx("String.prototype.indexOf"));
module.exports = function callBoundIntrinsic(name, allowMissing) {
    var intrinsic = $4Mbpx(name, !!allowMissing);
    if (typeof intrinsic === "function" && $68077b5e48473712$var$$indexOf(name, ".prototype.") > -1) return $706eK(intrinsic);
    return intrinsic;
};

});
parcelRequire.register("4Mbpx", function(module, exports) {
"use strict";
var $37a47f157126f369$var$undefined;
var $37a47f157126f369$var$$SyntaxError = SyntaxError;
var $37a47f157126f369$var$$Function = Function;
var $37a47f157126f369$var$$TypeError = TypeError;
// eslint-disable-next-line consistent-return
var $37a47f157126f369$var$getEvalledConstructor = function(expressionSyntax) {
    try {
        return $37a47f157126f369$var$$Function('"use strict"; return (' + expressionSyntax + ").constructor;")();
    } catch (e) {}
};
var $37a47f157126f369$var$$gOPD = Object.getOwnPropertyDescriptor;
if ($37a47f157126f369$var$$gOPD) try {
    $37a47f157126f369$var$$gOPD({}, "");
} catch (e) {
    $37a47f157126f369$var$$gOPD = null; // this is IE 8, which has a broken gOPD
}
var $37a47f157126f369$var$throwTypeError = function() {
    throw new $37a47f157126f369$var$$TypeError();
};
var $37a47f157126f369$var$ThrowTypeError = $37a47f157126f369$var$$gOPD ? function() {
    try {
        // eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
        arguments.callee; // IE 8 does not throw here
        return $37a47f157126f369$var$throwTypeError;
    } catch (calleeThrows) {
        try {
            // IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
            return $37a47f157126f369$var$$gOPD(arguments, "callee").get;
        } catch (gOPDthrows) {
            return $37a47f157126f369$var$throwTypeError;
        }
    }
}() : $37a47f157126f369$var$throwTypeError;

var $37a47f157126f369$var$hasSymbols = (parcelRequire("jWLFR"))();

var $37a47f157126f369$var$hasProto = (parcelRequire("6xM8M"))();
var $37a47f157126f369$var$getProto = Object.getPrototypeOf || ($37a47f157126f369$var$hasProto ? function(x) {
    return x.__proto__;
} // eslint-disable-line no-proto
 : null);
var $37a47f157126f369$var$needsEval = {};
var $37a47f157126f369$var$TypedArray = typeof Uint8Array === "undefined" || !$37a47f157126f369$var$getProto ? $37a47f157126f369$var$undefined : $37a47f157126f369$var$getProto(Uint8Array);
var $37a47f157126f369$var$INTRINSICS = {
    "%AggregateError%": typeof AggregateError === "undefined" ? $37a47f157126f369$var$undefined : AggregateError,
    "%Array%": Array,
    "%ArrayBuffer%": typeof ArrayBuffer === "undefined" ? $37a47f157126f369$var$undefined : ArrayBuffer,
    "%ArrayIteratorPrototype%": $37a47f157126f369$var$hasSymbols && $37a47f157126f369$var$getProto ? $37a47f157126f369$var$getProto([][Symbol.iterator]()) : $37a47f157126f369$var$undefined,
    "%AsyncFromSyncIteratorPrototype%": $37a47f157126f369$var$undefined,
    "%AsyncFunction%": $37a47f157126f369$var$needsEval,
    "%AsyncGenerator%": $37a47f157126f369$var$needsEval,
    "%AsyncGeneratorFunction%": $37a47f157126f369$var$needsEval,
    "%AsyncIteratorPrototype%": $37a47f157126f369$var$needsEval,
    "%Atomics%": typeof Atomics === "undefined" ? $37a47f157126f369$var$undefined : Atomics,
    "%BigInt%": typeof BigInt === "undefined" ? $37a47f157126f369$var$undefined : BigInt,
    "%BigInt64Array%": typeof BigInt64Array === "undefined" ? $37a47f157126f369$var$undefined : BigInt64Array,
    "%BigUint64Array%": typeof BigUint64Array === "undefined" ? $37a47f157126f369$var$undefined : BigUint64Array,
    "%Boolean%": Boolean,
    "%DataView%": typeof DataView === "undefined" ? $37a47f157126f369$var$undefined : DataView,
    "%Date%": Date,
    "%decodeURI%": decodeURI,
    "%decodeURIComponent%": decodeURIComponent,
    "%encodeURI%": encodeURI,
    "%encodeURIComponent%": encodeURIComponent,
    "%Error%": Error,
    "%eval%": eval,
    "%EvalError%": EvalError,
    "%Float32Array%": typeof Float32Array === "undefined" ? $37a47f157126f369$var$undefined : Float32Array,
    "%Float64Array%": typeof Float64Array === "undefined" ? $37a47f157126f369$var$undefined : Float64Array,
    "%FinalizationRegistry%": typeof FinalizationRegistry === "undefined" ? $37a47f157126f369$var$undefined : FinalizationRegistry,
    "%Function%": $37a47f157126f369$var$$Function,
    "%GeneratorFunction%": $37a47f157126f369$var$needsEval,
    "%Int8Array%": typeof Int8Array === "undefined" ? $37a47f157126f369$var$undefined : Int8Array,
    "%Int16Array%": typeof Int16Array === "undefined" ? $37a47f157126f369$var$undefined : Int16Array,
    "%Int32Array%": typeof Int32Array === "undefined" ? $37a47f157126f369$var$undefined : Int32Array,
    "%isFinite%": isFinite,
    "%isNaN%": isNaN,
    "%IteratorPrototype%": $37a47f157126f369$var$hasSymbols && $37a47f157126f369$var$getProto ? $37a47f157126f369$var$getProto($37a47f157126f369$var$getProto([][Symbol.iterator]())) : $37a47f157126f369$var$undefined,
    "%JSON%": typeof JSON === "object" ? JSON : $37a47f157126f369$var$undefined,
    "%Map%": typeof Map === "undefined" ? $37a47f157126f369$var$undefined : Map,
    "%MapIteratorPrototype%": typeof Map === "undefined" || !$37a47f157126f369$var$hasSymbols || !$37a47f157126f369$var$getProto ? $37a47f157126f369$var$undefined : $37a47f157126f369$var$getProto(new Map()[Symbol.iterator]()),
    "%Math%": Math,
    "%Number%": Number,
    "%Object%": Object,
    "%parseFloat%": parseFloat,
    "%parseInt%": parseInt,
    "%Promise%": typeof Promise === "undefined" ? $37a47f157126f369$var$undefined : Promise,
    "%Proxy%": typeof Proxy === "undefined" ? $37a47f157126f369$var$undefined : Proxy,
    "%RangeError%": RangeError,
    "%ReferenceError%": ReferenceError,
    "%Reflect%": typeof Reflect === "undefined" ? $37a47f157126f369$var$undefined : Reflect,
    "%RegExp%": RegExp,
    "%Set%": typeof Set === "undefined" ? $37a47f157126f369$var$undefined : Set,
    "%SetIteratorPrototype%": typeof Set === "undefined" || !$37a47f157126f369$var$hasSymbols || !$37a47f157126f369$var$getProto ? $37a47f157126f369$var$undefined : $37a47f157126f369$var$getProto(new Set()[Symbol.iterator]()),
    "%SharedArrayBuffer%": typeof SharedArrayBuffer === "undefined" ? $37a47f157126f369$var$undefined : SharedArrayBuffer,
    "%String%": String,
    "%StringIteratorPrototype%": $37a47f157126f369$var$hasSymbols && $37a47f157126f369$var$getProto ? $37a47f157126f369$var$getProto(""[Symbol.iterator]()) : $37a47f157126f369$var$undefined,
    "%Symbol%": $37a47f157126f369$var$hasSymbols ? Symbol : $37a47f157126f369$var$undefined,
    "%SyntaxError%": $37a47f157126f369$var$$SyntaxError,
    "%ThrowTypeError%": $37a47f157126f369$var$ThrowTypeError,
    "%TypedArray%": $37a47f157126f369$var$TypedArray,
    "%TypeError%": $37a47f157126f369$var$$TypeError,
    "%Uint8Array%": typeof Uint8Array === "undefined" ? $37a47f157126f369$var$undefined : Uint8Array,
    "%Uint8ClampedArray%": typeof Uint8ClampedArray === "undefined" ? $37a47f157126f369$var$undefined : Uint8ClampedArray,
    "%Uint16Array%": typeof Uint16Array === "undefined" ? $37a47f157126f369$var$undefined : Uint16Array,
    "%Uint32Array%": typeof Uint32Array === "undefined" ? $37a47f157126f369$var$undefined : Uint32Array,
    "%URIError%": URIError,
    "%WeakMap%": typeof WeakMap === "undefined" ? $37a47f157126f369$var$undefined : WeakMap,
    "%WeakRef%": typeof WeakRef === "undefined" ? $37a47f157126f369$var$undefined : WeakRef,
    "%WeakSet%": typeof WeakSet === "undefined" ? $37a47f157126f369$var$undefined : WeakSet
};
if ($37a47f157126f369$var$getProto) try {
    null.error; // eslint-disable-line no-unused-expressions
} catch (e) {
    // https://github.com/tc39/proposal-shadowrealm/pull/384#issuecomment-1364264229
    var $37a47f157126f369$var$errorProto = $37a47f157126f369$var$getProto($37a47f157126f369$var$getProto(e));
    $37a47f157126f369$var$INTRINSICS["%Error.prototype%"] = $37a47f157126f369$var$errorProto;
}
var $37a47f157126f369$var$doEval = function doEval(name) {
    var value;
    if (name === "%AsyncFunction%") value = $37a47f157126f369$var$getEvalledConstructor("async function () {}");
    else if (name === "%GeneratorFunction%") value = $37a47f157126f369$var$getEvalledConstructor("function* () {}");
    else if (name === "%AsyncGeneratorFunction%") value = $37a47f157126f369$var$getEvalledConstructor("async function* () {}");
    else if (name === "%AsyncGenerator%") {
        var fn = doEval("%AsyncGeneratorFunction%");
        if (fn) value = fn.prototype;
    } else if (name === "%AsyncIteratorPrototype%") {
        var gen = doEval("%AsyncGenerator%");
        if (gen && $37a47f157126f369$var$getProto) value = $37a47f157126f369$var$getProto(gen.prototype);
    }
    $37a47f157126f369$var$INTRINSICS[name] = value;
    return value;
};
var $37a47f157126f369$var$LEGACY_ALIASES = {
    "%ArrayBufferPrototype%": [
        "ArrayBuffer",
        "prototype"
    ],
    "%ArrayPrototype%": [
        "Array",
        "prototype"
    ],
    "%ArrayProto_entries%": [
        "Array",
        "prototype",
        "entries"
    ],
    "%ArrayProto_forEach%": [
        "Array",
        "prototype",
        "forEach"
    ],
    "%ArrayProto_keys%": [
        "Array",
        "prototype",
        "keys"
    ],
    "%ArrayProto_values%": [
        "Array",
        "prototype",
        "values"
    ],
    "%AsyncFunctionPrototype%": [
        "AsyncFunction",
        "prototype"
    ],
    "%AsyncGenerator%": [
        "AsyncGeneratorFunction",
        "prototype"
    ],
    "%AsyncGeneratorPrototype%": [
        "AsyncGeneratorFunction",
        "prototype",
        "prototype"
    ],
    "%BooleanPrototype%": [
        "Boolean",
        "prototype"
    ],
    "%DataViewPrototype%": [
        "DataView",
        "prototype"
    ],
    "%DatePrototype%": [
        "Date",
        "prototype"
    ],
    "%ErrorPrototype%": [
        "Error",
        "prototype"
    ],
    "%EvalErrorPrototype%": [
        "EvalError",
        "prototype"
    ],
    "%Float32ArrayPrototype%": [
        "Float32Array",
        "prototype"
    ],
    "%Float64ArrayPrototype%": [
        "Float64Array",
        "prototype"
    ],
    "%FunctionPrototype%": [
        "Function",
        "prototype"
    ],
    "%Generator%": [
        "GeneratorFunction",
        "prototype"
    ],
    "%GeneratorPrototype%": [
        "GeneratorFunction",
        "prototype",
        "prototype"
    ],
    "%Int8ArrayPrototype%": [
        "Int8Array",
        "prototype"
    ],
    "%Int16ArrayPrototype%": [
        "Int16Array",
        "prototype"
    ],
    "%Int32ArrayPrototype%": [
        "Int32Array",
        "prototype"
    ],
    "%JSONParse%": [
        "JSON",
        "parse"
    ],
    "%JSONStringify%": [
        "JSON",
        "stringify"
    ],
    "%MapPrototype%": [
        "Map",
        "prototype"
    ],
    "%NumberPrototype%": [
        "Number",
        "prototype"
    ],
    "%ObjectPrototype%": [
        "Object",
        "prototype"
    ],
    "%ObjProto_toString%": [
        "Object",
        "prototype",
        "toString"
    ],
    "%ObjProto_valueOf%": [
        "Object",
        "prototype",
        "valueOf"
    ],
    "%PromisePrototype%": [
        "Promise",
        "prototype"
    ],
    "%PromiseProto_then%": [
        "Promise",
        "prototype",
        "then"
    ],
    "%Promise_all%": [
        "Promise",
        "all"
    ],
    "%Promise_reject%": [
        "Promise",
        "reject"
    ],
    "%Promise_resolve%": [
        "Promise",
        "resolve"
    ],
    "%RangeErrorPrototype%": [
        "RangeError",
        "prototype"
    ],
    "%ReferenceErrorPrototype%": [
        "ReferenceError",
        "prototype"
    ],
    "%RegExpPrototype%": [
        "RegExp",
        "prototype"
    ],
    "%SetPrototype%": [
        "Set",
        "prototype"
    ],
    "%SharedArrayBufferPrototype%": [
        "SharedArrayBuffer",
        "prototype"
    ],
    "%StringPrototype%": [
        "String",
        "prototype"
    ],
    "%SymbolPrototype%": [
        "Symbol",
        "prototype"
    ],
    "%SyntaxErrorPrototype%": [
        "SyntaxError",
        "prototype"
    ],
    "%TypedArrayPrototype%": [
        "TypedArray",
        "prototype"
    ],
    "%TypeErrorPrototype%": [
        "TypeError",
        "prototype"
    ],
    "%Uint8ArrayPrototype%": [
        "Uint8Array",
        "prototype"
    ],
    "%Uint8ClampedArrayPrototype%": [
        "Uint8ClampedArray",
        "prototype"
    ],
    "%Uint16ArrayPrototype%": [
        "Uint16Array",
        "prototype"
    ],
    "%Uint32ArrayPrototype%": [
        "Uint32Array",
        "prototype"
    ],
    "%URIErrorPrototype%": [
        "URIError",
        "prototype"
    ],
    "%WeakMapPrototype%": [
        "WeakMap",
        "prototype"
    ],
    "%WeakSetPrototype%": [
        "WeakSet",
        "prototype"
    ]
};

var $k0tHG = parcelRequire("k0tHG");

var $9Md34 = parcelRequire("9Md34");
var $37a47f157126f369$var$$concat = $k0tHG.call(Function.call, Array.prototype.concat);
var $37a47f157126f369$var$$spliceApply = $k0tHG.call(Function.apply, Array.prototype.splice);
var $37a47f157126f369$var$$replace = $k0tHG.call(Function.call, String.prototype.replace);
var $37a47f157126f369$var$$strSlice = $k0tHG.call(Function.call, String.prototype.slice);
var $37a47f157126f369$var$$exec = $k0tHG.call(Function.call, RegExp.prototype.exec);
/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */ var $37a47f157126f369$var$rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var $37a47f157126f369$var$reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */ 
var $37a47f157126f369$var$stringToPath = function stringToPath(string) {
    var first = $37a47f157126f369$var$$strSlice(string, 0, 1);
    var last = $37a47f157126f369$var$$strSlice(string, -1);
    if (first === "%" && last !== "%") throw new $37a47f157126f369$var$$SyntaxError("invalid intrinsic syntax, expected closing `%`");
    else if (last === "%" && first !== "%") throw new $37a47f157126f369$var$$SyntaxError("invalid intrinsic syntax, expected opening `%`");
    var result = [];
    $37a47f157126f369$var$$replace(string, $37a47f157126f369$var$rePropName, function(match, number, quote, subString) {
        result[result.length] = quote ? $37a47f157126f369$var$$replace(subString, $37a47f157126f369$var$reEscapeChar, "$1") : number || match;
    });
    return result;
};
/* end adaptation */ var $37a47f157126f369$var$getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
    var intrinsicName = name;
    var alias;
    if ($9Md34($37a47f157126f369$var$LEGACY_ALIASES, intrinsicName)) {
        alias = $37a47f157126f369$var$LEGACY_ALIASES[intrinsicName];
        intrinsicName = "%" + alias[0] + "%";
    }
    if ($9Md34($37a47f157126f369$var$INTRINSICS, intrinsicName)) {
        var value = $37a47f157126f369$var$INTRINSICS[intrinsicName];
        if (value === $37a47f157126f369$var$needsEval) value = $37a47f157126f369$var$doEval(intrinsicName);
        if (typeof value === "undefined" && !allowMissing) throw new $37a47f157126f369$var$$TypeError("intrinsic " + name + " exists, but is not available. Please file an issue!");
        return {
            alias: alias,
            name: intrinsicName,
            value: value
        };
    }
    throw new $37a47f157126f369$var$$SyntaxError("intrinsic " + name + " does not exist!");
};
module.exports = function GetIntrinsic(name, allowMissing) {
    if (typeof name !== "string" || name.length === 0) throw new $37a47f157126f369$var$$TypeError("intrinsic name must be a non-empty string");
    if (arguments.length > 1 && typeof allowMissing !== "boolean") throw new $37a47f157126f369$var$$TypeError('"allowMissing" argument must be a boolean');
    if ($37a47f157126f369$var$$exec(/^%?[^%]*%?$/, name) === null) throw new $37a47f157126f369$var$$SyntaxError("`%` may not be present anywhere but at the beginning and end of the intrinsic name");
    var parts = $37a47f157126f369$var$stringToPath(name);
    var intrinsicBaseName = parts.length > 0 ? parts[0] : "";
    var intrinsic = $37a47f157126f369$var$getBaseIntrinsic("%" + intrinsicBaseName + "%", allowMissing);
    var intrinsicRealName = intrinsic.name;
    var value = intrinsic.value;
    var skipFurtherCaching = false;
    var alias = intrinsic.alias;
    if (alias) {
        intrinsicBaseName = alias[0];
        $37a47f157126f369$var$$spliceApply(parts, $37a47f157126f369$var$$concat([
            0,
            1
        ], alias));
    }
    for(var i = 1, isOwn = true; i < parts.length; i += 1){
        var part = parts[i];
        var first = $37a47f157126f369$var$$strSlice(part, 0, 1);
        var last = $37a47f157126f369$var$$strSlice(part, -1);
        if ((first === '"' || first === "'" || first === "`" || last === '"' || last === "'" || last === "`") && first !== last) throw new $37a47f157126f369$var$$SyntaxError("property names with quotes must have matching quotes");
        if (part === "constructor" || !isOwn) skipFurtherCaching = true;
        intrinsicBaseName += "." + part;
        intrinsicRealName = "%" + intrinsicBaseName + "%";
        if ($9Md34($37a47f157126f369$var$INTRINSICS, intrinsicRealName)) value = $37a47f157126f369$var$INTRINSICS[intrinsicRealName];
        else if (value != null) {
            if (!(part in value)) {
                if (!allowMissing) throw new $37a47f157126f369$var$$TypeError("base intrinsic for " + name + " exists, but the property is not available.");
                return void 0;
            }
            if ($37a47f157126f369$var$$gOPD && i + 1 >= parts.length) {
                var desc = $37a47f157126f369$var$$gOPD(value, part);
                isOwn = !!desc;
                // By convention, when a data property is converted to an accessor
                // property to emulate a data property that does not suffer from
                // the override mistake, that accessor's getter is marked with
                // an `originalValue` property. Here, when we detect this, we
                // uphold the illusion by pretending to see that original data
                // property, i.e., returning the value rather than the getter
                // itself.
                if (isOwn && "get" in desc && !("originalValue" in desc.get)) value = desc.get;
                else value = value[part];
            } else {
                isOwn = $9Md34(value, part);
                value = value[part];
            }
            if (isOwn && !skipFurtherCaching) $37a47f157126f369$var$INTRINSICS[intrinsicRealName] = value;
        }
    }
    return value;
};

});
parcelRequire.register("jWLFR", function(module, exports) {
"use strict";
var $e8586a306ac45df7$var$origSymbol = typeof Symbol !== "undefined" && Symbol;

var $8luVB = parcelRequire("8luVB");
module.exports = function hasNativeSymbols() {
    if (typeof $e8586a306ac45df7$var$origSymbol !== "function") return false;
    if (typeof Symbol !== "function") return false;
    if (typeof $e8586a306ac45df7$var$origSymbol("foo") !== "symbol") return false;
    if (typeof Symbol("bar") !== "symbol") return false;
    return $8luVB();
};

});

parcelRequire.register("6xM8M", function(module, exports) {
"use strict";
var $4c3b2adebb39e2da$var$test = {
    foo: {}
};
var $4c3b2adebb39e2da$var$$Object = Object;
module.exports = function hasProto() {
    return ({
        __proto__: $4c3b2adebb39e2da$var$test
    }).foo === $4c3b2adebb39e2da$var$test.foo && !(({
        __proto__: null
    }) instanceof $4c3b2adebb39e2da$var$$Object);
};

});

parcelRequire.register("k0tHG", function(module, exports) {
"use strict";

var $j6Ao5 = parcelRequire("j6Ao5");
module.exports = Function.prototype.bind || $j6Ao5;

});
parcelRequire.register("j6Ao5", function(module, exports) {
"use strict";
/* eslint no-invalid-this: 1 */ var $de8acdaa8d3f93da$var$ERROR_MESSAGE = "Function.prototype.bind called on incompatible ";
var $de8acdaa8d3f93da$var$slice = Array.prototype.slice;
var $de8acdaa8d3f93da$var$toStr = Object.prototype.toString;
var $de8acdaa8d3f93da$var$funcType = "[object Function]";
module.exports = function bind(that) {
    var target = this;
    if (typeof target !== "function" || $de8acdaa8d3f93da$var$toStr.call(target) !== $de8acdaa8d3f93da$var$funcType) throw new TypeError($de8acdaa8d3f93da$var$ERROR_MESSAGE + target);
    var args = $de8acdaa8d3f93da$var$slice.call(arguments, 1);
    var bound;
    var binder = function() {
        if (this instanceof bound) {
            var result = target.apply(this, args.concat($de8acdaa8d3f93da$var$slice.call(arguments)));
            if (Object(result) === result) return result;
            return this;
        } else return target.apply(that, args.concat($de8acdaa8d3f93da$var$slice.call(arguments)));
    };
    var boundLength = Math.max(0, target.length - args.length);
    var boundArgs = [];
    for(var i = 0; i < boundLength; i++)boundArgs.push("$" + i);
    bound = Function("binder", "return function (" + boundArgs.join(",") + "){ return binder.apply(this,arguments); }")(binder);
    if (target.prototype) {
        var Empty = function Empty() {};
        Empty.prototype = target.prototype;
        bound.prototype = new Empty();
        Empty.prototype = null;
    }
    return bound;
};

});


parcelRequire.register("9Md34", function(module, exports) {
"use strict";

var $k0tHG = parcelRequire("k0tHG");
module.exports = $k0tHG.call(Function.call, Object.prototype.hasOwnProperty);

});


parcelRequire.register("706eK", function(module, exports) {
"use strict";

var $k0tHG = parcelRequire("k0tHG");

var $4Mbpx = parcelRequire("4Mbpx");
var $518d5f06fdcb2091$var$$apply = $4Mbpx("%Function.prototype.apply%");
var $518d5f06fdcb2091$var$$call = $4Mbpx("%Function.prototype.call%");
var $518d5f06fdcb2091$var$$reflectApply = $4Mbpx("%Reflect.apply%", true) || $k0tHG.call($518d5f06fdcb2091$var$$call, $518d5f06fdcb2091$var$$apply);
var $518d5f06fdcb2091$var$$gOPD = $4Mbpx("%Object.getOwnPropertyDescriptor%", true);
var $518d5f06fdcb2091$var$$defineProperty = $4Mbpx("%Object.defineProperty%", true);
var $518d5f06fdcb2091$var$$max = $4Mbpx("%Math.max%");
if ($518d5f06fdcb2091$var$$defineProperty) try {
    $518d5f06fdcb2091$var$$defineProperty({}, "a", {
        value: 1
    });
} catch (e) {
    // IE 8 has a broken defineProperty
    $518d5f06fdcb2091$var$$defineProperty = null;
}
module.exports = function callBind(originalFunction) {
    var func = $518d5f06fdcb2091$var$$reflectApply($k0tHG, $518d5f06fdcb2091$var$$call, arguments);
    if ($518d5f06fdcb2091$var$$gOPD && $518d5f06fdcb2091$var$$defineProperty) {
        var desc = $518d5f06fdcb2091$var$$gOPD(func, "length");
        if (desc.configurable) // original length, plus the receiver, minus any additional arguments (after the receiver)
        $518d5f06fdcb2091$var$$defineProperty(func, "length", {
            value: 1 + $518d5f06fdcb2091$var$$max(0, originalFunction.length - (arguments.length - 1))
        });
    }
    return func;
};
var $518d5f06fdcb2091$var$applyBind = function applyBind() {
    return $518d5f06fdcb2091$var$$reflectApply($k0tHG, $518d5f06fdcb2091$var$$apply, arguments);
};
if ($518d5f06fdcb2091$var$$defineProperty) $518d5f06fdcb2091$var$$defineProperty(module.exports, "apply", {
    value: $518d5f06fdcb2091$var$applyBind
});
else module.exports.apply = $518d5f06fdcb2091$var$applyBind;

});



parcelRequire.register("hdXwQ", function(module, exports) {
"use strict";
var $c8a1d3bef016c9b2$var$toStr = Object.prototype.toString;
var $c8a1d3bef016c9b2$var$fnToStr = Function.prototype.toString;
var $c8a1d3bef016c9b2$var$isFnRegex = /^\s*(?:function)?\*/;

var $c8a1d3bef016c9b2$var$hasToStringTag = (parcelRequire("cUn2I"))();
var $c8a1d3bef016c9b2$var$getProto = Object.getPrototypeOf;
var $c8a1d3bef016c9b2$var$getGeneratorFunc = function() {
    if (!$c8a1d3bef016c9b2$var$hasToStringTag) return false;
    try {
        return Function("return function*() {}")();
    } catch (e) {}
};
var $c8a1d3bef016c9b2$var$GeneratorFunction;
module.exports = function isGeneratorFunction(fn) {
    if (typeof fn !== "function") return false;
    if ($c8a1d3bef016c9b2$var$isFnRegex.test($c8a1d3bef016c9b2$var$fnToStr.call(fn))) return true;
    if (!$c8a1d3bef016c9b2$var$hasToStringTag) {
        var str = $c8a1d3bef016c9b2$var$toStr.call(fn);
        return str === "[object GeneratorFunction]";
    }
    if (!$c8a1d3bef016c9b2$var$getProto) return false;
    if (typeof $c8a1d3bef016c9b2$var$GeneratorFunction === "undefined") {
        var generatorFunc = $c8a1d3bef016c9b2$var$getGeneratorFunc();
        $c8a1d3bef016c9b2$var$GeneratorFunction = generatorFunc ? $c8a1d3bef016c9b2$var$getProto(generatorFunc) : false;
    }
    return $c8a1d3bef016c9b2$var$getProto(fn) === $c8a1d3bef016c9b2$var$GeneratorFunction;
};

});

parcelRequire.register("ldGla", function(module, exports) {
"use strict";

var $lKcqe = parcelRequire("lKcqe");

var $gqy49 = parcelRequire("gqy49");

var $8VKch = parcelRequire("8VKch");

var $aeWRd = parcelRequire("aeWRd");
var $f72ba7c6f25b4d05$var$$toString = $8VKch("Object.prototype.toString");

var $f72ba7c6f25b4d05$var$hasToStringTag = (parcelRequire("cUn2I"))();
var $f72ba7c6f25b4d05$var$g = typeof globalThis === "undefined" ? $parcel$global : globalThis;
var $f72ba7c6f25b4d05$var$typedArrays = $gqy49();
var $f72ba7c6f25b4d05$var$$slice = $8VKch("String.prototype.slice");
var $f72ba7c6f25b4d05$var$toStrTags = {};
var $f72ba7c6f25b4d05$var$getPrototypeOf = Object.getPrototypeOf; // require('getprototypeof');
if ($f72ba7c6f25b4d05$var$hasToStringTag && $aeWRd && $f72ba7c6f25b4d05$var$getPrototypeOf) $lKcqe($f72ba7c6f25b4d05$var$typedArrays, function(typedArray) {
    if (typeof $f72ba7c6f25b4d05$var$g[typedArray] === "function") {
        var arr = new $f72ba7c6f25b4d05$var$g[typedArray]();
        if (Symbol.toStringTag in arr) {
            var proto = $f72ba7c6f25b4d05$var$getPrototypeOf(arr);
            var descriptor = $aeWRd(proto, Symbol.toStringTag);
            if (!descriptor) {
                var superProto = $f72ba7c6f25b4d05$var$getPrototypeOf(proto);
                descriptor = $aeWRd(superProto, Symbol.toStringTag);
            }
            $f72ba7c6f25b4d05$var$toStrTags[typedArray] = descriptor.get;
        }
    }
});
var $f72ba7c6f25b4d05$var$tryTypedArrays = function tryAllTypedArrays(value) {
    var foundName = false;
    $lKcqe($f72ba7c6f25b4d05$var$toStrTags, function(getter, typedArray) {
        if (!foundName) try {
            var name = getter.call(value);
            if (name === typedArray) foundName = name;
        } catch (e) {}
    });
    return foundName;
};

var $jxa5R = parcelRequire("jxa5R");
module.exports = function whichTypedArray(value) {
    if (!$jxa5R(value)) return false;
    if (!$f72ba7c6f25b4d05$var$hasToStringTag || !(Symbol.toStringTag in value)) return $f72ba7c6f25b4d05$var$$slice($f72ba7c6f25b4d05$var$$toString(value), 8, -1);
    return $f72ba7c6f25b4d05$var$tryTypedArrays(value);
};

});
parcelRequire.register("lKcqe", function(module, exports) {
"use strict";

var $fBFAO = parcelRequire("fBFAO");
var $fd4787a0aea405e8$var$toStr = Object.prototype.toString;
var $fd4787a0aea405e8$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $fd4787a0aea405e8$var$forEachArray = function forEachArray(array, iterator, receiver) {
    for(var i = 0, len = array.length; i < len; i++)if ($fd4787a0aea405e8$var$hasOwnProperty.call(array, i)) {
        if (receiver == null) iterator(array[i], i, array);
        else iterator.call(receiver, array[i], i, array);
    }
};
var $fd4787a0aea405e8$var$forEachString = function forEachString(string, iterator, receiver) {
    for(var i = 0, len = string.length; i < len; i++)// no such thing as a sparse string.
    if (receiver == null) iterator(string.charAt(i), i, string);
    else iterator.call(receiver, string.charAt(i), i, string);
};
var $fd4787a0aea405e8$var$forEachObject = function forEachObject(object, iterator, receiver) {
    for(var k in object)if ($fd4787a0aea405e8$var$hasOwnProperty.call(object, k)) {
        if (receiver == null) iterator(object[k], k, object);
        else iterator.call(receiver, object[k], k, object);
    }
};
var $fd4787a0aea405e8$var$forEach = function forEach(list, iterator, thisArg) {
    if (!$fBFAO(iterator)) throw new TypeError("iterator must be a function");
    var receiver;
    if (arguments.length >= 3) receiver = thisArg;
    if ($fd4787a0aea405e8$var$toStr.call(list) === "[object Array]") $fd4787a0aea405e8$var$forEachArray(list, iterator, receiver);
    else if (typeof list === "string") $fd4787a0aea405e8$var$forEachString(list, iterator, receiver);
    else $fd4787a0aea405e8$var$forEachObject(list, iterator, receiver);
};
module.exports = $fd4787a0aea405e8$var$forEach;

});
parcelRequire.register("fBFAO", function(module, exports) {
"use strict";
var $b5ca9329694ec7df$var$fnToStr = Function.prototype.toString;
var $b5ca9329694ec7df$var$reflectApply = typeof Reflect === "object" && Reflect !== null && Reflect.apply;
var $b5ca9329694ec7df$var$badArrayLike;
var $b5ca9329694ec7df$var$isCallableMarker;
if (typeof $b5ca9329694ec7df$var$reflectApply === "function" && typeof Object.defineProperty === "function") try {
    $b5ca9329694ec7df$var$badArrayLike = Object.defineProperty({}, "length", {
        get: function() {
            throw $b5ca9329694ec7df$var$isCallableMarker;
        }
    });
    $b5ca9329694ec7df$var$isCallableMarker = {};
    // eslint-disable-next-line no-throw-literal
    $b5ca9329694ec7df$var$reflectApply(function() {
        throw 42;
    }, null, $b5ca9329694ec7df$var$badArrayLike);
} catch (_) {
    if (_ !== $b5ca9329694ec7df$var$isCallableMarker) $b5ca9329694ec7df$var$reflectApply = null;
}
else $b5ca9329694ec7df$var$reflectApply = null;
var $b5ca9329694ec7df$var$constructorRegex = /^\s*class\b/;
var $b5ca9329694ec7df$var$isES6ClassFn = function isES6ClassFunction(value) {
    try {
        var fnStr = $b5ca9329694ec7df$var$fnToStr.call(value);
        return $b5ca9329694ec7df$var$constructorRegex.test(fnStr);
    } catch (e) {
        return false; // not a function
    }
};
var $b5ca9329694ec7df$var$tryFunctionObject = function tryFunctionToStr(value) {
    try {
        if ($b5ca9329694ec7df$var$isES6ClassFn(value)) return false;
        $b5ca9329694ec7df$var$fnToStr.call(value);
        return true;
    } catch (e) {
        return false;
    }
};
var $b5ca9329694ec7df$var$toStr = Object.prototype.toString;
var $b5ca9329694ec7df$var$objectClass = "[object Object]";
var $b5ca9329694ec7df$var$fnClass = "[object Function]";
var $b5ca9329694ec7df$var$genClass = "[object GeneratorFunction]";
var $b5ca9329694ec7df$var$ddaClass = "[object HTMLAllCollection]"; // IE 11
var $b5ca9329694ec7df$var$ddaClass2 = "[object HTML document.all class]";
var $b5ca9329694ec7df$var$ddaClass3 = "[object HTMLCollection]"; // IE 9-10
var $b5ca9329694ec7df$var$hasToStringTag = typeof Symbol === "function" && !!Symbol.toStringTag; // better: use `has-tostringtag`
var $b5ca9329694ec7df$var$isIE68 = !(0 in [
    , 
]); // eslint-disable-line no-sparse-arrays, comma-spacing
var $b5ca9329694ec7df$var$isDDA = function isDocumentDotAll() {
    return false;
};
if (typeof document === "object") {
    // Firefox 3 canonicalizes DDA to undefined when it's not accessed directly
    var $b5ca9329694ec7df$var$all = document.all;
    if ($b5ca9329694ec7df$var$toStr.call($b5ca9329694ec7df$var$all) === $b5ca9329694ec7df$var$toStr.call(document.all)) $b5ca9329694ec7df$var$isDDA = function isDocumentDotAll(value) {
        /* globals document: false */ // in IE 6-8, typeof document.all is "object" and it's truthy
        if (($b5ca9329694ec7df$var$isIE68 || !value) && (typeof value === "undefined" || typeof value === "object")) try {
            var str = $b5ca9329694ec7df$var$toStr.call(value);
            return (str === $b5ca9329694ec7df$var$ddaClass || str === $b5ca9329694ec7df$var$ddaClass2 || str === $b5ca9329694ec7df$var$ddaClass3 // opera 12.16
             || str === $b5ca9329694ec7df$var$objectClass // IE 6-8
            ) && value("") == null; // eslint-disable-line eqeqeq
        } catch (e) {}
        return false;
    };
}
module.exports = $b5ca9329694ec7df$var$reflectApply ? function isCallable(value) {
    if ($b5ca9329694ec7df$var$isDDA(value)) return true;
    if (!value) return false;
    if (typeof value !== "function" && typeof value !== "object") return false;
    try {
        $b5ca9329694ec7df$var$reflectApply(value, null, $b5ca9329694ec7df$var$badArrayLike);
    } catch (e) {
        if (e !== $b5ca9329694ec7df$var$isCallableMarker) return false;
    }
    return !$b5ca9329694ec7df$var$isES6ClassFn(value) && $b5ca9329694ec7df$var$tryFunctionObject(value);
} : function isCallable(value) {
    if ($b5ca9329694ec7df$var$isDDA(value)) return true;
    if (!value) return false;
    if (typeof value !== "function" && typeof value !== "object") return false;
    if ($b5ca9329694ec7df$var$hasToStringTag) return $b5ca9329694ec7df$var$tryFunctionObject(value);
    if ($b5ca9329694ec7df$var$isES6ClassFn(value)) return false;
    var strClass = $b5ca9329694ec7df$var$toStr.call(value);
    if (strClass !== $b5ca9329694ec7df$var$fnClass && strClass !== $b5ca9329694ec7df$var$genClass && !/^\[object HTML/.test(strClass)) return false;
    return $b5ca9329694ec7df$var$tryFunctionObject(value);
};

});


parcelRequire.register("gqy49", function(module, exports) {
"use strict";
var $bf597fd82b64accc$var$possibleNames = [
    "BigInt64Array",
    "BigUint64Array",
    "Float32Array",
    "Float64Array",
    "Int16Array",
    "Int32Array",
    "Int8Array",
    "Uint16Array",
    "Uint32Array",
    "Uint8Array",
    "Uint8ClampedArray"
];
var $bf597fd82b64accc$var$g = typeof globalThis === "undefined" ? $parcel$global : globalThis;
module.exports = function availableTypedArrays() {
    var out = [];
    for(var i = 0; i < $bf597fd82b64accc$var$possibleNames.length; i++)if (typeof $bf597fd82b64accc$var$g[$bf597fd82b64accc$var$possibleNames[i]] === "function") out[out.length] = $bf597fd82b64accc$var$possibleNames[i];
    return out;
};

});

parcelRequire.register("aeWRd", function(module, exports) {
"use strict";

var $4Mbpx = parcelRequire("4Mbpx");
var $7748de045dcdfdf5$var$$gOPD = $4Mbpx("%Object.getOwnPropertyDescriptor%", true);
if ($7748de045dcdfdf5$var$$gOPD) try {
    $7748de045dcdfdf5$var$$gOPD([], "length");
} catch (e) {
    // IE 8 has a broken gOPD
    $7748de045dcdfdf5$var$$gOPD = null;
}
module.exports = $7748de045dcdfdf5$var$$gOPD;

});

parcelRequire.register("jxa5R", function(module, exports) {
"use strict";

var $lKcqe = parcelRequire("lKcqe");

var $gqy49 = parcelRequire("gqy49");

var $8VKch = parcelRequire("8VKch");
var $e388edc295df5cf2$var$$toString = $8VKch("Object.prototype.toString");

var $e388edc295df5cf2$var$hasToStringTag = (parcelRequire("cUn2I"))();

var $aeWRd = parcelRequire("aeWRd");
var $e388edc295df5cf2$var$g = typeof globalThis === "undefined" ? $parcel$global : globalThis;
var $e388edc295df5cf2$var$typedArrays = $gqy49();
var $e388edc295df5cf2$var$$indexOf = $8VKch("Array.prototype.indexOf", true) || function indexOf(array, value) {
    for(var i = 0; i < array.length; i += 1){
        if (array[i] === value) return i;
    }
    return -1;
};
var $e388edc295df5cf2$var$$slice = $8VKch("String.prototype.slice");
var $e388edc295df5cf2$var$toStrTags = {};
var $e388edc295df5cf2$var$getPrototypeOf = Object.getPrototypeOf; // require('getprototypeof');
if ($e388edc295df5cf2$var$hasToStringTag && $aeWRd && $e388edc295df5cf2$var$getPrototypeOf) $lKcqe($e388edc295df5cf2$var$typedArrays, function(typedArray) {
    var arr = new $e388edc295df5cf2$var$g[typedArray]();
    if (Symbol.toStringTag in arr) {
        var proto = $e388edc295df5cf2$var$getPrototypeOf(arr);
        var descriptor = $aeWRd(proto, Symbol.toStringTag);
        if (!descriptor) {
            var superProto = $e388edc295df5cf2$var$getPrototypeOf(proto);
            descriptor = $aeWRd(superProto, Symbol.toStringTag);
        }
        $e388edc295df5cf2$var$toStrTags[typedArray] = descriptor.get;
    }
});
var $e388edc295df5cf2$var$tryTypedArrays = function tryAllTypedArrays(value) {
    var anyTrue = false;
    $lKcqe($e388edc295df5cf2$var$toStrTags, function(getter, typedArray) {
        if (!anyTrue) try {
            anyTrue = getter.call(value) === typedArray;
        } catch (e) {}
    });
    return anyTrue;
};
module.exports = function isTypedArray(value) {
    if (!value || typeof value !== "object") return false;
    if (!$e388edc295df5cf2$var$hasToStringTag || !(Symbol.toStringTag in value)) {
        var tag = $e388edc295df5cf2$var$$slice($e388edc295df5cf2$var$$toString(value), 8, -1);
        return $e388edc295df5cf2$var$$indexOf($e388edc295df5cf2$var$typedArrays, tag) > -1;
    }
    if (!$aeWRd) return false;
    return $e388edc295df5cf2$var$tryTypedArrays(value);
};

});



parcelRequire.register("7wgB4", function(module, exports) {
module.exports = function isBuffer(arg) {
    return arg && typeof arg === "object" && typeof arg.copy === "function" && typeof arg.fill === "function" && typeof arg.readUInt8 === "function";
};

});

parcelRequire.register("5SAkX", function(module, exports) {
if (typeof Object.create === "function") // implementation from standard node.js 'util' module
module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
        ctor.super_ = superCtor;
        ctor.prototype = Object.create(superCtor.prototype, {
            constructor: {
                value: ctor,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
    }
};
else // old school shim for old browsers
module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
};

});


parcelRequire.register("8jiUm", function(module, exports) {

var $4KsTn = parcelRequire("4KsTn");

var $dYOpr = parcelRequire("dYOpr");

var $9eKsl = parcelRequire("9eKsl");

var $7g6zO = parcelRequire("7g6zO");

var $aaypF = parcelRequire("aaypF");
var $60cec3d8d038a5d0$var$http = module.exports;
$60cec3d8d038a5d0$var$http.request = function(opts, cb) {
    if (typeof opts === "string") opts = $aaypF.parse(opts);
    else opts = $9eKsl(opts);
    // Normally, the page is loaded from http or https, so not specifying a protocol
    // will result in a (valid) protocol-relative url. However, this won't work if
    // the protocol is something else, like 'file:'
    var defaultProtocol = $parcel$global.location.protocol.search(/^https?:$/) === -1 ? "http:" : "";
    var protocol = opts.protocol || defaultProtocol;
    var host = opts.hostname || opts.host;
    var port = opts.port;
    var path = opts.path || "/";
    // Necessary for IPv6 addresses
    if (host && host.indexOf(":") !== -1) host = "[" + host + "]";
    // This may be a relative url. The browser should always be able to interpret it correctly.
    opts.url = (host ? protocol + "//" + host : "") + (port ? ":" + port : "") + path;
    opts.method = (opts.method || "GET").toUpperCase();
    opts.headers = opts.headers || {};
    // Also valid opts.auth, opts.mode
    var req = new $4KsTn(opts);
    if (cb) req.on("response", cb);
    return req;
};
$60cec3d8d038a5d0$var$http.get = function get(opts, cb) {
    var req = $60cec3d8d038a5d0$var$http.request(opts, cb);
    req.end();
    return req;
};
$60cec3d8d038a5d0$var$http.ClientRequest = $4KsTn;
$60cec3d8d038a5d0$var$http.IncomingMessage = $dYOpr.IncomingMessage;
$60cec3d8d038a5d0$var$http.Agent = function() {};
$60cec3d8d038a5d0$var$http.Agent.defaultMaxSockets = 4;
$60cec3d8d038a5d0$var$http.globalAgent = new $60cec3d8d038a5d0$var$http.Agent();
$60cec3d8d038a5d0$var$http.STATUS_CODES = $7g6zO;
$60cec3d8d038a5d0$var$http.METHODS = [
    "CHECKOUT",
    "CONNECT",
    "COPY",
    "DELETE",
    "GET",
    "HEAD",
    "LOCK",
    "M-SEARCH",
    "MERGE",
    "MKACTIVITY",
    "MKCOL",
    "MOVE",
    "NOTIFY",
    "OPTIONS",
    "PATCH",
    "POST",
    "PROPFIND",
    "PROPPATCH",
    "PURGE",
    "PUT",
    "REPORT",
    "SEARCH",
    "SUBSCRIBE",
    "TRACE",
    "UNLOCK",
    "UNSUBSCRIBE"
];

});
parcelRequire.register("4KsTn", function(module, exports) {

var $cBXue = parcelRequire("cBXue");
var $3751deb126410767$require$Buffer = $cBXue.Buffer;

var $hIXGI = parcelRequire("hIXGI");

var $5E951 = parcelRequire("5E951");

var $5SAkX = parcelRequire("5SAkX");

var $dYOpr = parcelRequire("dYOpr");

var $gwqwh = parcelRequire("gwqwh");
var $3751deb126410767$var$IncomingMessage = $dYOpr.IncomingMessage;
var $3751deb126410767$var$rStates = $dYOpr.readyStates;
function $3751deb126410767$var$decideMode(preferBinary, useFetch) {
    if ($5E951.fetch && useFetch) return "fetch";
    else if ($5E951.mozchunkedarraybuffer) return "moz-chunked-arraybuffer";
    else if ($5E951.msstream) return "ms-stream";
    else if ($5E951.arraybuffer && preferBinary) return "arraybuffer";
    else return "text";
}
var $3751deb126410767$var$ClientRequest = module.exports = function(opts) {
    var self = this;
    $gwqwh.Writable.call(self);
    self._opts = opts;
    self._body = [];
    self._headers = {};
    if (opts.auth) self.setHeader("Authorization", "Basic " + $3751deb126410767$require$Buffer.from(opts.auth).toString("base64"));
    Object.keys(opts.headers).forEach(function(name) {
        self.setHeader(name, opts.headers[name]);
    });
    var preferBinary;
    var useFetch = true;
    if (opts.mode === "disable-fetch" || "requestTimeout" in opts && !$5E951.abortController) {
        // If the use of XHR should be preferred. Not typically needed.
        useFetch = false;
        preferBinary = true;
    } else if (opts.mode === "prefer-streaming") // If streaming is a high priority but binary compatibility and
    // the accuracy of the 'content-type' header aren't
    preferBinary = false;
    else if (opts.mode === "allow-wrong-content-type") // If streaming is more important than preserving the 'content-type' header
    preferBinary = !$5E951.overrideMimeType;
    else if (!opts.mode || opts.mode === "default" || opts.mode === "prefer-fast") // Use binary if text streaming may corrupt data or the content-type header, or for speed
    preferBinary = true;
    else throw new Error("Invalid value for opts.mode");
    self._mode = $3751deb126410767$var$decideMode(preferBinary, useFetch);
    self._fetchTimer = null;
    self._socketTimeout = null;
    self._socketTimer = null;
    self.on("finish", function() {
        self._onFinish();
    });
};
$5SAkX($3751deb126410767$var$ClientRequest, $gwqwh.Writable);
$3751deb126410767$var$ClientRequest.prototype.setHeader = function(name, value) {
    var self = this;
    var lowerName = name.toLowerCase();
    // This check is not necessary, but it prevents warnings from browsers about setting unsafe
    // headers. To be honest I'm not entirely sure hiding these warnings is a good thing, but
    // http-browserify did it, so I will too.
    if ($3751deb126410767$var$unsafeHeaders.indexOf(lowerName) !== -1) return;
    self._headers[lowerName] = {
        name: name,
        value: value
    };
};
$3751deb126410767$var$ClientRequest.prototype.getHeader = function(name) {
    var header = this._headers[name.toLowerCase()];
    if (header) return header.value;
    return null;
};
$3751deb126410767$var$ClientRequest.prototype.removeHeader = function(name) {
    var self = this;
    delete self._headers[name.toLowerCase()];
};
$3751deb126410767$var$ClientRequest.prototype._onFinish = function() {
    var self = this;
    if (self._destroyed) return;
    var opts = self._opts;
    if ("timeout" in opts && opts.timeout !== 0) self.setTimeout(opts.timeout);
    var headersObj = self._headers;
    var body = null;
    if (opts.method !== "GET" && opts.method !== "HEAD") body = new Blob(self._body, {
        type: (headersObj["content-type"] || {}).value || ""
    });
    // create flattened list of headers
    var headersList = [];
    Object.keys(headersObj).forEach(function(keyName) {
        var name = headersObj[keyName].name;
        var value = headersObj[keyName].value;
        if (Array.isArray(value)) value.forEach(function(v) {
            headersList.push([
                name,
                v
            ]);
        });
        else headersList.push([
            name,
            value
        ]);
    });
    if (self._mode === "fetch") {
        var signal = null;
        if ($5E951.abortController) {
            var controller = new AbortController();
            signal = controller.signal;
            self._fetchAbortController = controller;
            if ("requestTimeout" in opts && opts.requestTimeout !== 0) self._fetchTimer = $parcel$global.setTimeout(function() {
                self.emit("requestTimeout");
                if (self._fetchAbortController) self._fetchAbortController.abort();
            }, opts.requestTimeout);
        }
        $parcel$global.fetch(self._opts.url, {
            method: self._opts.method,
            headers: headersList,
            body: body || undefined,
            mode: "cors",
            credentials: opts.withCredentials ? "include" : "same-origin",
            signal: signal
        }).then(function(response) {
            self._fetchResponse = response;
            self._resetTimers(false);
            self._connect();
        }, function(reason) {
            self._resetTimers(true);
            if (!self._destroyed) self.emit("error", reason);
        });
    } else {
        var xhr = self._xhr = new $parcel$global.XMLHttpRequest();
        try {
            xhr.open(self._opts.method, self._opts.url, true);
        } catch (err) {
            $hIXGI.nextTick(function() {
                self.emit("error", err);
            });
            return;
        }
        // Can't set responseType on really old browsers
        if ("responseType" in xhr) xhr.responseType = self._mode;
        if ("withCredentials" in xhr) xhr.withCredentials = !!opts.withCredentials;
        if (self._mode === "text" && "overrideMimeType" in xhr) xhr.overrideMimeType("text/plain; charset=x-user-defined");
        if ("requestTimeout" in opts) {
            xhr.timeout = opts.requestTimeout;
            xhr.ontimeout = function() {
                self.emit("requestTimeout");
            };
        }
        headersList.forEach(function(header) {
            xhr.setRequestHeader(header[0], header[1]);
        });
        self._response = null;
        xhr.onreadystatechange = function() {
            switch(xhr.readyState){
                case $3751deb126410767$var$rStates.LOADING:
                case $3751deb126410767$var$rStates.DONE:
                    self._onXHRProgress();
                    break;
            }
        };
        // Necessary for streaming in Firefox, since xhr.response is ONLY defined
        // in onprogress, not in onreadystatechange with xhr.readyState = 3
        if (self._mode === "moz-chunked-arraybuffer") xhr.onprogress = function() {
            self._onXHRProgress();
        };
        xhr.onerror = function() {
            if (self._destroyed) return;
            self._resetTimers(true);
            self.emit("error", new Error("XHR error"));
        };
        try {
            xhr.send(body);
        } catch (err) {
            $hIXGI.nextTick(function() {
                self.emit("error", err);
            });
            return;
        }
    }
};
/**
 * Checks if xhr.status is readable and non-zero, indicating no error.
 * Even though the spec says it should be available in readyState 3,
 * accessing it throws an exception in IE8
 */ function $3751deb126410767$var$statusValid(xhr) {
    try {
        var status = xhr.status;
        return status !== null && status !== 0;
    } catch (e) {
        return false;
    }
}
$3751deb126410767$var$ClientRequest.prototype._onXHRProgress = function() {
    var self = this;
    self._resetTimers(false);
    if (!$3751deb126410767$var$statusValid(self._xhr) || self._destroyed) return;
    if (!self._response) self._connect();
    self._response._onXHRProgress(self._resetTimers.bind(self));
};
$3751deb126410767$var$ClientRequest.prototype._connect = function() {
    var self = this;
    if (self._destroyed) return;
    self._response = new $3751deb126410767$var$IncomingMessage(self._xhr, self._fetchResponse, self._mode, self._resetTimers.bind(self));
    self._response.on("error", function(err) {
        self.emit("error", err);
    });
    self.emit("response", self._response);
};
$3751deb126410767$var$ClientRequest.prototype._write = function(chunk, encoding, cb) {
    var self = this;
    self._body.push(chunk);
    cb();
};
$3751deb126410767$var$ClientRequest.prototype._resetTimers = function(done) {
    var self = this;
    $parcel$global.clearTimeout(self._socketTimer);
    self._socketTimer = null;
    if (done) {
        $parcel$global.clearTimeout(self._fetchTimer);
        self._fetchTimer = null;
    } else if (self._socketTimeout) self._socketTimer = $parcel$global.setTimeout(function() {
        self.emit("timeout");
    }, self._socketTimeout);
};
$3751deb126410767$var$ClientRequest.prototype.abort = $3751deb126410767$var$ClientRequest.prototype.destroy = function(err) {
    var self = this;
    self._destroyed = true;
    self._resetTimers(true);
    if (self._response) self._response._destroyed = true;
    if (self._xhr) self._xhr.abort();
    else if (self._fetchAbortController) self._fetchAbortController.abort();
    if (err) self.emit("error", err);
};
$3751deb126410767$var$ClientRequest.prototype.end = function(data, encoding, cb) {
    var self = this;
    if (typeof data === "function") {
        cb = data;
        data = undefined;
    }
    $gwqwh.Writable.prototype.end.call(self, data, encoding, cb);
};
$3751deb126410767$var$ClientRequest.prototype.setTimeout = function(timeout, cb) {
    var self = this;
    if (cb) self.once("timeout", cb);
    self._socketTimeout = timeout;
    self._resetTimers(false);
};
$3751deb126410767$var$ClientRequest.prototype.flushHeaders = function() {};
$3751deb126410767$var$ClientRequest.prototype.setNoDelay = function() {};
$3751deb126410767$var$ClientRequest.prototype.setSocketKeepAlive = function() {};
// Taken from http://www.w3.org/TR/XMLHttpRequest/#the-setrequestheader%28%29-method
var $3751deb126410767$var$unsafeHeaders = [
    "accept-charset",
    "accept-encoding",
    "access-control-request-headers",
    "access-control-request-method",
    "connection",
    "content-length",
    "cookie",
    "cookie2",
    "date",
    "dnt",
    "expect",
    "host",
    "keep-alive",
    "origin",
    "referer",
    "te",
    "trailer",
    "transfer-encoding",
    "upgrade",
    "via"
];

});
parcelRequire.register("5E951", function(module, exports) {

$parcel$export(module.exports, "fetch", () => $41c7bb459d215b23$export$e7aa7bc5c1b3cfb3, (v) => $41c7bb459d215b23$export$e7aa7bc5c1b3cfb3 = v);
$parcel$export(module.exports, "writableStream", () => $41c7bb459d215b23$export$37489d82087dc5d1, (v) => $41c7bb459d215b23$export$37489d82087dc5d1 = v);
$parcel$export(module.exports, "abortController", () => $41c7bb459d215b23$export$f137bf8a46425a6f, (v) => $41c7bb459d215b23$export$f137bf8a46425a6f = v);
$parcel$export(module.exports, "arraybuffer", () => $41c7bb459d215b23$export$724c4efdc2b90612, (v) => $41c7bb459d215b23$export$724c4efdc2b90612 = v);
$parcel$export(module.exports, "msstream", () => $41c7bb459d215b23$export$a9aa1e45c4448986, (v) => $41c7bb459d215b23$export$a9aa1e45c4448986 = v);
$parcel$export(module.exports, "mozchunkedarraybuffer", () => $41c7bb459d215b23$export$4c3c163e941f6ba3, (v) => $41c7bb459d215b23$export$4c3c163e941f6ba3 = v);
$parcel$export(module.exports, "overrideMimeType", () => $41c7bb459d215b23$export$8f1269d6d73f87ef, (v) => $41c7bb459d215b23$export$8f1269d6d73f87ef = v);
var $41c7bb459d215b23$export$e7aa7bc5c1b3cfb3;
var $41c7bb459d215b23$export$37489d82087dc5d1;
var $41c7bb459d215b23$export$f137bf8a46425a6f;
// If fetch is supported, then arraybuffer will be supported too. Skip calling
// checkTypeSupport(), since that calls getXHR().
var $41c7bb459d215b23$export$724c4efdc2b90612;
// These next two tests unavoidably show warnings in Chrome. Since fetch will always
// be used if it's available, just return false for these to avoid the warnings.
var $41c7bb459d215b23$export$a9aa1e45c4448986;
var $41c7bb459d215b23$export$4c3c163e941f6ba3;
// If fetch is supported, then overrideMimeType will be supported too. Skip calling
// getXHR().
var $41c7bb459d215b23$export$8f1269d6d73f87ef;
$41c7bb459d215b23$export$e7aa7bc5c1b3cfb3 = $41c7bb459d215b23$var$isFunction($parcel$global.fetch) && $41c7bb459d215b23$var$isFunction($parcel$global.ReadableStream);
$41c7bb459d215b23$export$37489d82087dc5d1 = $41c7bb459d215b23$var$isFunction($parcel$global.WritableStream);
$41c7bb459d215b23$export$f137bf8a46425a6f = $41c7bb459d215b23$var$isFunction($parcel$global.AbortController);
// The xhr request to example.com may violate some restrictive CSP configurations,
// so if we're running in a browser that supports `fetch`, avoid calling getXHR()
// and assume support for certain features below.
var $41c7bb459d215b23$var$xhr;
function $41c7bb459d215b23$var$getXHR() {
    // Cache the xhr value
    if ($41c7bb459d215b23$var$xhr !== undefined) return $41c7bb459d215b23$var$xhr;
    if ($parcel$global.XMLHttpRequest) {
        $41c7bb459d215b23$var$xhr = new $parcel$global.XMLHttpRequest();
        // If XDomainRequest is available (ie only, where xhr might not work
        // cross domain), use the page location. Otherwise use example.com
        // Note: this doesn't actually make an http request.
        try {
            $41c7bb459d215b23$var$xhr.open("GET", $parcel$global.XDomainRequest ? "/" : "https://example.com");
        } catch (e) {
            $41c7bb459d215b23$var$xhr = null;
        }
    } else // Service workers don't have XHR
    $41c7bb459d215b23$var$xhr = null;
    return $41c7bb459d215b23$var$xhr;
}
function $41c7bb459d215b23$var$checkTypeSupport(type) {
    var xhr = $41c7bb459d215b23$var$getXHR();
    if (!xhr) return false;
    try {
        xhr.responseType = type;
        return xhr.responseType === type;
    } catch (e) {}
    return false;
}
$41c7bb459d215b23$export$724c4efdc2b90612 = $41c7bb459d215b23$export$e7aa7bc5c1b3cfb3 || $41c7bb459d215b23$var$checkTypeSupport("arraybuffer");
$41c7bb459d215b23$export$a9aa1e45c4448986 = !$41c7bb459d215b23$export$e7aa7bc5c1b3cfb3 && $41c7bb459d215b23$var$checkTypeSupport("ms-stream");
$41c7bb459d215b23$export$4c3c163e941f6ba3 = !$41c7bb459d215b23$export$e7aa7bc5c1b3cfb3 && $41c7bb459d215b23$var$checkTypeSupport("moz-chunked-arraybuffer");
$41c7bb459d215b23$export$8f1269d6d73f87ef = $41c7bb459d215b23$export$e7aa7bc5c1b3cfb3 || ($41c7bb459d215b23$var$getXHR() ? $41c7bb459d215b23$var$isFunction($41c7bb459d215b23$var$getXHR().overrideMimeType) : false);
function $41c7bb459d215b23$var$isFunction(value) {
    return typeof value === "function";
}
$41c7bb459d215b23$var$xhr = null // Help gc
;

});

parcelRequire.register("dYOpr", function(module, exports) {

$parcel$export(module.exports, "readyStates", () => $a2d7fb3a15b9ee01$export$8e4da25483e314e6, (v) => $a2d7fb3a15b9ee01$export$8e4da25483e314e6 = v);
$parcel$export(module.exports, "IncomingMessage", () => $a2d7fb3a15b9ee01$export$9d4333345ffa4fd6, (v) => $a2d7fb3a15b9ee01$export$9d4333345ffa4fd6 = v);
var $a2d7fb3a15b9ee01$export$8e4da25483e314e6;
var $a2d7fb3a15b9ee01$export$9d4333345ffa4fd6;

var $hIXGI = parcelRequire("hIXGI");

var $cBXue = parcelRequire("cBXue");
var $a2d7fb3a15b9ee01$require$Buffer = $cBXue.Buffer;

var $5E951 = parcelRequire("5E951");

var $5SAkX = parcelRequire("5SAkX");

var $gwqwh = parcelRequire("gwqwh");
var $a2d7fb3a15b9ee01$var$rStates = $a2d7fb3a15b9ee01$export$8e4da25483e314e6 = {
    UNSENT: 0,
    OPENED: 1,
    HEADERS_RECEIVED: 2,
    LOADING: 3,
    DONE: 4
};
var $a2d7fb3a15b9ee01$var$IncomingMessage = $a2d7fb3a15b9ee01$export$9d4333345ffa4fd6 = function(xhr, response, mode, resetTimers) {
    var self = this;
    $gwqwh.Readable.call(self);
    self._mode = mode;
    self.headers = {};
    self.rawHeaders = [];
    self.trailers = {};
    self.rawTrailers = [];
    // Fake the 'close' event, but only once 'end' fires
    self.on("end", function() {
        // The nextTick is necessary to prevent the 'request' module from causing an infinite loop
        $hIXGI.nextTick(function() {
            self.emit("close");
        });
    });
    if (mode === "fetch") {
        self._fetchResponse = response;
        self.url = response.url;
        self.statusCode = response.status;
        self.statusMessage = response.statusText;
        response.headers.forEach(function(header, key) {
            self.headers[key.toLowerCase()] = header;
            self.rawHeaders.push(key, header);
        });
        if ($5E951.writableStream) {
            var writable = new WritableStream({
                write: function(chunk) {
                    resetTimers(false);
                    return new Promise(function(resolve, reject) {
                        if (self._destroyed) reject();
                        else if (self.push($a2d7fb3a15b9ee01$require$Buffer.from(chunk))) resolve();
                        else self._resumeFetch = resolve;
                    });
                },
                close: function() {
                    resetTimers(true);
                    if (!self._destroyed) self.push(null);
                },
                abort: function(err) {
                    resetTimers(true);
                    if (!self._destroyed) self.emit("error", err);
                }
            });
            try {
                response.body.pipeTo(writable).catch(function(err) {
                    resetTimers(true);
                    if (!self._destroyed) self.emit("error", err);
                });
                return;
            } catch (e) {} // pipeTo method isn't defined. Can't find a better way to feature test this
        }
        // fallback for when writableStream or pipeTo aren't available
        var reader = response.body.getReader();
        function read() {
            reader.read().then(function(result) {
                if (self._destroyed) return;
                resetTimers(result.done);
                if (result.done) {
                    self.push(null);
                    return;
                }
                self.push($a2d7fb3a15b9ee01$require$Buffer.from(result.value));
                read();
            }).catch(function(err) {
                resetTimers(true);
                if (!self._destroyed) self.emit("error", err);
            });
        }
        read();
    } else {
        self._xhr = xhr;
        self._pos = 0;
        self.url = xhr.responseURL;
        self.statusCode = xhr.status;
        self.statusMessage = xhr.statusText;
        var headers = xhr.getAllResponseHeaders().split(/\r?\n/);
        headers.forEach(function(header) {
            var matches = header.match(/^([^:]+):\s*(.*)/);
            if (matches) {
                var key = matches[1].toLowerCase();
                if (key === "set-cookie") {
                    if (self.headers[key] === undefined) self.headers[key] = [];
                    self.headers[key].push(matches[2]);
                } else if (self.headers[key] !== undefined) self.headers[key] += ", " + matches[2];
                else self.headers[key] = matches[2];
                self.rawHeaders.push(matches[1], matches[2]);
            }
        });
        self._charset = "x-user-defined";
        if (!$5E951.overrideMimeType) {
            var mimeType = self.rawHeaders["mime-type"];
            if (mimeType) {
                var charsetMatch = mimeType.match(/;\s*charset=([^;])(;|$)/);
                if (charsetMatch) self._charset = charsetMatch[1].toLowerCase();
            }
            if (!self._charset) self._charset = "utf-8" // best guess
            ;
        }
    }
};
$5SAkX($a2d7fb3a15b9ee01$var$IncomingMessage, $gwqwh.Readable);
$a2d7fb3a15b9ee01$var$IncomingMessage.prototype._read = function() {
    var self = this;
    var resolve = self._resumeFetch;
    if (resolve) {
        self._resumeFetch = null;
        resolve();
    }
};
$a2d7fb3a15b9ee01$var$IncomingMessage.prototype._onXHRProgress = function(resetTimers) {
    var self = this;
    var xhr = self._xhr;
    var response = null;
    switch(self._mode){
        case "text":
            response = xhr.responseText;
            if (response.length > self._pos) {
                var newData = response.substr(self._pos);
                if (self._charset === "x-user-defined") {
                    var buffer = $a2d7fb3a15b9ee01$require$Buffer.alloc(newData.length);
                    for(var i = 0; i < newData.length; i++)buffer[i] = newData.charCodeAt(i) & 0xff;
                    self.push(buffer);
                } else self.push(newData, self._charset);
                self._pos = response.length;
            }
            break;
        case "arraybuffer":
            if (xhr.readyState !== $a2d7fb3a15b9ee01$var$rStates.DONE || !xhr.response) break;
            response = xhr.response;
            self.push($a2d7fb3a15b9ee01$require$Buffer.from(new Uint8Array(response)));
            break;
        case "moz-chunked-arraybuffer":
            response = xhr.response;
            if (xhr.readyState !== $a2d7fb3a15b9ee01$var$rStates.LOADING || !response) break;
            self.push($a2d7fb3a15b9ee01$require$Buffer.from(new Uint8Array(response)));
            break;
        case "ms-stream":
            response = xhr.response;
            if (xhr.readyState !== $a2d7fb3a15b9ee01$var$rStates.LOADING) break;
            var reader = new $parcel$global.MSStreamReader();
            reader.onprogress = function() {
                if (reader.result.byteLength > self._pos) {
                    self.push($a2d7fb3a15b9ee01$require$Buffer.from(new Uint8Array(reader.result.slice(self._pos))));
                    self._pos = reader.result.byteLength;
                }
            };
            reader.onload = function() {
                resetTimers(true);
                self.push(null);
            };
            // reader.onerror = ??? // TODO: this
            reader.readAsArrayBuffer(response);
            break;
    }
    // The ms-stream case handles end separately in reader.onload()
    if (self._xhr.readyState === $a2d7fb3a15b9ee01$var$rStates.DONE && self._mode !== "ms-stream") {
        resetTimers(true);
        self.push(null);
    }
};

});
parcelRequire.register("gwqwh", function(module, exports) {

exports = module.exports = (parcelRequire("hoMkK"));
exports.Stream = exports;
exports.Readable = exports;

exports.Writable = (parcelRequire("h31UB"));

exports.Duplex = (parcelRequire("cMizL"));

exports.Transform = (parcelRequire("6vslQ"));

exports.PassThrough = (parcelRequire("kMGT2"));

exports.finished = (parcelRequire("jIV9q"));

exports.pipeline = (parcelRequire("8a2DY"));

});
parcelRequire.register("hoMkK", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var $hIXGI = parcelRequire("hIXGI");
"use strict";
module.exports = $caaa2b971285b6b6$var$Readable;
/*<replacement>*/ var $caaa2b971285b6b6$var$Duplex;
/*</replacement>*/ $caaa2b971285b6b6$var$Readable.ReadableState = $caaa2b971285b6b6$var$ReadableState;

var $ikynl = parcelRequire("ikynl");
var $caaa2b971285b6b6$require$EE = $ikynl.EventEmitter;
var $caaa2b971285b6b6$var$EElistenerCount = function EElistenerCount(emitter, type) {
    return emitter.listeners(type).length;
};

var $67rTV = parcelRequire("67rTV");

var $iuRmA = parcelRequire("iuRmA");
var $caaa2b971285b6b6$require$Buffer = $iuRmA.Buffer;
var $caaa2b971285b6b6$var$OurUint8Array = (typeof $parcel$global !== "undefined" ? $parcel$global : typeof window !== "undefined" ? window : typeof self !== "undefined" ? self : {}).Uint8Array || function() {};
function $caaa2b971285b6b6$var$_uint8ArrayToBuffer(chunk) {
    return $caaa2b971285b6b6$require$Buffer.from(chunk);
}
function $caaa2b971285b6b6$var$_isUint8Array(obj) {
    return $caaa2b971285b6b6$require$Buffer.isBuffer(obj) || obj instanceof $caaa2b971285b6b6$var$OurUint8Array;
}

var $gR5sk = parcelRequire("gR5sk");
var $caaa2b971285b6b6$var$debug;
if ($gR5sk && $gR5sk.debuglog) $caaa2b971285b6b6$var$debug = $gR5sk.debuglog("stream");
else $caaa2b971285b6b6$var$debug = function debug() {};

var $1VSGA = parcelRequire("1VSGA");

var $7vKbY = parcelRequire("7vKbY");

var $7S7pQ = parcelRequire("7S7pQ");
var $caaa2b971285b6b6$var$getHighWaterMark = $7S7pQ.getHighWaterMark;

var $jqb3Z = parcelRequire("jqb3Z");
var $caaa2b971285b6b6$require$_require$codes = $jqb3Z.codes;
var $caaa2b971285b6b6$var$ERR_INVALID_ARG_TYPE = $caaa2b971285b6b6$require$_require$codes.ERR_INVALID_ARG_TYPE, $caaa2b971285b6b6$var$ERR_STREAM_PUSH_AFTER_EOF = $caaa2b971285b6b6$require$_require$codes.ERR_STREAM_PUSH_AFTER_EOF, $caaa2b971285b6b6$var$ERR_METHOD_NOT_IMPLEMENTED = $caaa2b971285b6b6$require$_require$codes.ERR_METHOD_NOT_IMPLEMENTED, $caaa2b971285b6b6$var$ERR_STREAM_UNSHIFT_AFTER_END_EVENT = $caaa2b971285b6b6$require$_require$codes.ERR_STREAM_UNSHIFT_AFTER_END_EVENT;
// Lazy loaded to improve the startup performance.
var $caaa2b971285b6b6$var$StringDecoder;
var $caaa2b971285b6b6$var$createReadableStreamAsyncIterator;
var $caaa2b971285b6b6$var$from;

(parcelRequire("5SAkX"))($caaa2b971285b6b6$var$Readable, $67rTV);
var $caaa2b971285b6b6$var$errorOrDestroy = $7vKbY.errorOrDestroy;
var $caaa2b971285b6b6$var$kProxyEvents = [
    "error",
    "close",
    "destroy",
    "pause",
    "resume"
];
function $caaa2b971285b6b6$var$prependListener(emitter, event, fn) {
    // Sadly this is not cacheable as some libraries bundle their own
    // event emitter implementation with them.
    if (typeof emitter.prependListener === "function") return emitter.prependListener(event, fn);
    // This is a hack to make sure that our error handler is attached before any
    // userland ones.  NEVER DO THIS. This is here only because this code needs
    // to continue to work with older versions of Node.js that do not include
    // the prependListener() method. The goal is to eventually remove this hack.
    if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);
    else if (Array.isArray(emitter._events[event])) emitter._events[event].unshift(fn);
    else emitter._events[event] = [
        fn,
        emitter._events[event]
    ];
}


function $caaa2b971285b6b6$var$ReadableState(options, stream, isDuplex) {
    $caaa2b971285b6b6$var$Duplex = $caaa2b971285b6b6$var$Duplex || (parcelRequire("cMizL"));
    options = options || {};
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream.
    // These options can be provided separately as readableXXX and writableXXX.
    if (typeof isDuplex !== "boolean") isDuplex = stream instanceof $caaa2b971285b6b6$var$Duplex;
    // object stream flag. Used to make read(n) ignore n and to
    // make all the buffer merging and length checks go away
    this.objectMode = !!options.objectMode;
    if (isDuplex) this.objectMode = this.objectMode || !!options.readableObjectMode;
    // the point at which it stops calling _read() to fill the buffer
    // Note: 0 is a valid value, means "don't call _read preemptively ever"
    this.highWaterMark = $caaa2b971285b6b6$var$getHighWaterMark(this, options, "readableHighWaterMark", isDuplex);
    // A linked list is used to store data chunks instead of an array because the
    // linked list can remove elements from the beginning faster than
    // array.shift()
    this.buffer = new $1VSGA();
    this.length = 0;
    this.pipes = null;
    this.pipesCount = 0;
    this.flowing = null;
    this.ended = false;
    this.endEmitted = false;
    this.reading = false;
    // a flag to be able to tell if the event 'readable'/'data' is emitted
    // immediately, or on a later tick.  We set this to true at first, because
    // any actions that shouldn't happen until "later" should generally also
    // not happen before the first read call.
    this.sync = true;
    // whenever we return null, then we set a flag to say
    // that we're awaiting a 'readable' event emission.
    this.needReadable = false;
    this.emittedReadable = false;
    this.readableListening = false;
    this.resumeScheduled = false;
    this.paused = true;
    // Should close be emitted on destroy. Defaults to true.
    this.emitClose = options.emitClose !== false;
    // Should .destroy() be called after 'end' (and potentially 'finish')
    this.autoDestroy = !!options.autoDestroy;
    // has it been destroyed
    this.destroyed = false;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options.defaultEncoding || "utf8";
    // the number of writers that are awaiting a drain event in .pipe()s
    this.awaitDrain = 0;
    // if true, a maybeReadMore has been scheduled
    this.readingMore = false;
    this.decoder = null;
    this.encoding = null;
    if (options.encoding) {
        if (!$caaa2b971285b6b6$var$StringDecoder) $caaa2b971285b6b6$var$StringDecoder = (parcelRequire("d23j5")).StringDecoder;
        this.decoder = new $caaa2b971285b6b6$var$StringDecoder(options.encoding);
        this.encoding = options.encoding;
    }
}

function $caaa2b971285b6b6$var$Readable(options) {
    $caaa2b971285b6b6$var$Duplex = $caaa2b971285b6b6$var$Duplex || (parcelRequire("cMizL"));
    if (!(this instanceof $caaa2b971285b6b6$var$Readable)) return new $caaa2b971285b6b6$var$Readable(options);
    // Checking for a Stream.Duplex instance is faster here instead of inside
    // the ReadableState constructor, at least with V8 6.5
    var isDuplex = this instanceof $caaa2b971285b6b6$var$Duplex;
    this._readableState = new $caaa2b971285b6b6$var$ReadableState(options, this, isDuplex);
    // legacy
    this.readable = true;
    if (options) {
        if (typeof options.read === "function") this._read = options.read;
        if (typeof options.destroy === "function") this._destroy = options.destroy;
    }
    $67rTV.call(this);
}
Object.defineProperty($caaa2b971285b6b6$var$Readable.prototype, "destroyed", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        if (this._readableState === undefined) return false;
        return this._readableState.destroyed;
    },
    set: function set(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (!this._readableState) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._readableState.destroyed = value;
    }
});
$caaa2b971285b6b6$var$Readable.prototype.destroy = $7vKbY.destroy;
$caaa2b971285b6b6$var$Readable.prototype._undestroy = $7vKbY.undestroy;
$caaa2b971285b6b6$var$Readable.prototype._destroy = function(err, cb) {
    cb(err);
};
// Manually shove something into the read() buffer.
// This returns true if the highWaterMark has not been hit yet,
// similar to how Writable.write() returns true if you should
// write() some more.
$caaa2b971285b6b6$var$Readable.prototype.push = function(chunk, encoding) {
    var state = this._readableState;
    var skipChunkCheck;
    if (!state.objectMode) {
        if (typeof chunk === "string") {
            encoding = encoding || state.defaultEncoding;
            if (encoding !== state.encoding) {
                chunk = $caaa2b971285b6b6$require$Buffer.from(chunk, encoding);
                encoding = "";
            }
            skipChunkCheck = true;
        }
    } else skipChunkCheck = true;
    return $caaa2b971285b6b6$var$readableAddChunk(this, chunk, encoding, false, skipChunkCheck);
};
// Unshift should *always* be something directly out of read()
$caaa2b971285b6b6$var$Readable.prototype.unshift = function(chunk) {
    return $caaa2b971285b6b6$var$readableAddChunk(this, chunk, null, true, false);
};
function $caaa2b971285b6b6$var$readableAddChunk(stream, chunk, encoding, addToFront, skipChunkCheck) {
    $caaa2b971285b6b6$var$debug("readableAddChunk", chunk);
    var state = stream._readableState;
    if (chunk === null) {
        state.reading = false;
        $caaa2b971285b6b6$var$onEofChunk(stream, state);
    } else {
        var er;
        if (!skipChunkCheck) er = $caaa2b971285b6b6$var$chunkInvalid(state, chunk);
        if (er) $caaa2b971285b6b6$var$errorOrDestroy(stream, er);
        else if (state.objectMode || chunk && chunk.length > 0) {
            if (typeof chunk !== "string" && !state.objectMode && Object.getPrototypeOf(chunk) !== $caaa2b971285b6b6$require$Buffer.prototype) chunk = $caaa2b971285b6b6$var$_uint8ArrayToBuffer(chunk);
            if (addToFront) {
                if (state.endEmitted) $caaa2b971285b6b6$var$errorOrDestroy(stream, new $caaa2b971285b6b6$var$ERR_STREAM_UNSHIFT_AFTER_END_EVENT());
                else $caaa2b971285b6b6$var$addChunk(stream, state, chunk, true);
            } else if (state.ended) $caaa2b971285b6b6$var$errorOrDestroy(stream, new $caaa2b971285b6b6$var$ERR_STREAM_PUSH_AFTER_EOF());
            else if (state.destroyed) return false;
            else {
                state.reading = false;
                if (state.decoder && !encoding) {
                    chunk = state.decoder.write(chunk);
                    if (state.objectMode || chunk.length !== 0) $caaa2b971285b6b6$var$addChunk(stream, state, chunk, false);
                    else $caaa2b971285b6b6$var$maybeReadMore(stream, state);
                } else $caaa2b971285b6b6$var$addChunk(stream, state, chunk, false);
            }
        } else if (!addToFront) {
            state.reading = false;
            $caaa2b971285b6b6$var$maybeReadMore(stream, state);
        }
    }
    // We can push more data if we are below the highWaterMark.
    // Also, if we have no data yet, we can stand some more bytes.
    // This is to work around cases where hwm=0, such as the repl.
    return !state.ended && (state.length < state.highWaterMark || state.length === 0);
}
function $caaa2b971285b6b6$var$addChunk(stream, state, chunk, addToFront) {
    if (state.flowing && state.length === 0 && !state.sync) {
        state.awaitDrain = 0;
        stream.emit("data", chunk);
    } else {
        // update the buffer info.
        state.length += state.objectMode ? 1 : chunk.length;
        if (addToFront) state.buffer.unshift(chunk);
        else state.buffer.push(chunk);
        if (state.needReadable) $caaa2b971285b6b6$var$emitReadable(stream);
    }
    $caaa2b971285b6b6$var$maybeReadMore(stream, state);
}
function $caaa2b971285b6b6$var$chunkInvalid(state, chunk) {
    var er;
    if (!$caaa2b971285b6b6$var$_isUint8Array(chunk) && typeof chunk !== "string" && chunk !== undefined && !state.objectMode) er = new $caaa2b971285b6b6$var$ERR_INVALID_ARG_TYPE("chunk", [
        "string",
        "Buffer",
        "Uint8Array"
    ], chunk);
    return er;
}
$caaa2b971285b6b6$var$Readable.prototype.isPaused = function() {
    return this._readableState.flowing === false;
};

// backwards compatibility.
$caaa2b971285b6b6$var$Readable.prototype.setEncoding = function(enc) {
    if (!$caaa2b971285b6b6$var$StringDecoder) $caaa2b971285b6b6$var$StringDecoder = (parcelRequire("d23j5")).StringDecoder;
    var decoder = new $caaa2b971285b6b6$var$StringDecoder(enc);
    this._readableState.decoder = decoder;
    // If setEncoding(null), decoder.encoding equals utf8
    this._readableState.encoding = this._readableState.decoder.encoding;
    // Iterate over current buffer to convert already stored Buffers:
    var p = this._readableState.buffer.head;
    var content = "";
    while(p !== null){
        content += decoder.write(p.data);
        p = p.next;
    }
    this._readableState.buffer.clear();
    if (content !== "") this._readableState.buffer.push(content);
    this._readableState.length = content.length;
    return this;
};
// Don't raise the hwm > 1GB
var $caaa2b971285b6b6$var$MAX_HWM = 0x40000000;
function $caaa2b971285b6b6$var$computeNewHighWaterMark(n) {
    if (n >= $caaa2b971285b6b6$var$MAX_HWM) // TODO(ronag): Throw ERR_VALUE_OUT_OF_RANGE.
    n = $caaa2b971285b6b6$var$MAX_HWM;
    else {
        // Get the next highest power of 2 to prevent increasing hwm excessively in
        // tiny amounts
        n--;
        n |= n >>> 1;
        n |= n >>> 2;
        n |= n >>> 4;
        n |= n >>> 8;
        n |= n >>> 16;
        n++;
    }
    return n;
}
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $caaa2b971285b6b6$var$howMuchToRead(n, state) {
    if (n <= 0 || state.length === 0 && state.ended) return 0;
    if (state.objectMode) return 1;
    if (n !== n) {
        // Only flow one buffer at a time
        if (state.flowing && state.length) return state.buffer.head.data.length;
        else return state.length;
    }
    // If we're asking for more than the current hwm, then raise the hwm.
    if (n > state.highWaterMark) state.highWaterMark = $caaa2b971285b6b6$var$computeNewHighWaterMark(n);
    if (n <= state.length) return n;
    // Don't have enough
    if (!state.ended) {
        state.needReadable = true;
        return 0;
    }
    return state.length;
}
// you can override either this method, or the async _read(n) below.
$caaa2b971285b6b6$var$Readable.prototype.read = function(n) {
    $caaa2b971285b6b6$var$debug("read", n);
    n = parseInt(n, 10);
    var state = this._readableState;
    var nOrig = n;
    if (n !== 0) state.emittedReadable = false;
    // if we're doing read(0) to trigger a readable event, but we
    // already have a bunch of data in the buffer, then just trigger
    // the 'readable' event and move on.
    if (n === 0 && state.needReadable && ((state.highWaterMark !== 0 ? state.length >= state.highWaterMark : state.length > 0) || state.ended)) {
        $caaa2b971285b6b6$var$debug("read: emitReadable", state.length, state.ended);
        if (state.length === 0 && state.ended) $caaa2b971285b6b6$var$endReadable(this);
        else $caaa2b971285b6b6$var$emitReadable(this);
        return null;
    }
    n = $caaa2b971285b6b6$var$howMuchToRead(n, state);
    // if we've ended, and we're now clear, then finish it up.
    if (n === 0 && state.ended) {
        if (state.length === 0) $caaa2b971285b6b6$var$endReadable(this);
        return null;
    }
    // All the actual chunk generation logic needs to be
    // *below* the call to _read.  The reason is that in certain
    // synthetic stream cases, such as passthrough streams, _read
    // may be a completely synchronous operation which may change
    // the state of the read buffer, providing enough data when
    // before there was *not* enough.
    //
    // So, the steps are:
    // 1. Figure out what the state of things will be after we do
    // a read from the buffer.
    //
    // 2. If that resulting state will trigger a _read, then call _read.
    // Note that this may be asynchronous, or synchronous.  Yes, it is
    // deeply ugly to write APIs this way, but that still doesn't mean
    // that the Readable class should behave improperly, as streams are
    // designed to be sync/async agnostic.
    // Take note if the _read call is sync or async (ie, if the read call
    // has returned yet), so that we know whether or not it's safe to emit
    // 'readable' etc.
    //
    // 3. Actually pull the requested chunks out of the buffer and return.
    // if we need a readable event, then we need to do some reading.
    var doRead = state.needReadable;
    $caaa2b971285b6b6$var$debug("need readable", doRead);
    // if we currently have less than the highWaterMark, then also read some
    if (state.length === 0 || state.length - n < state.highWaterMark) {
        doRead = true;
        $caaa2b971285b6b6$var$debug("length less than watermark", doRead);
    }
    // however, if we've ended, then there's no point, and if we're already
    // reading, then it's unnecessary.
    if (state.ended || state.reading) {
        doRead = false;
        $caaa2b971285b6b6$var$debug("reading or ended", doRead);
    } else if (doRead) {
        $caaa2b971285b6b6$var$debug("do read");
        state.reading = true;
        state.sync = true;
        // if the length is currently zero, then we *need* a readable event.
        if (state.length === 0) state.needReadable = true;
        // call internal read method
        this._read(state.highWaterMark);
        state.sync = false;
        // If _read pushed data synchronously, then `reading` will be false,
        // and we need to re-evaluate how much data we can return to the user.
        if (!state.reading) n = $caaa2b971285b6b6$var$howMuchToRead(nOrig, state);
    }
    var ret;
    if (n > 0) ret = $caaa2b971285b6b6$var$fromList(n, state);
    else ret = null;
    if (ret === null) {
        state.needReadable = state.length <= state.highWaterMark;
        n = 0;
    } else {
        state.length -= n;
        state.awaitDrain = 0;
    }
    if (state.length === 0) {
        // If we have nothing in the buffer, then we want to know
        // as soon as we *do* get something into the buffer.
        if (!state.ended) state.needReadable = true;
        // If we tried to read() past the EOF, then emit end on the next tick.
        if (nOrig !== n && state.ended) $caaa2b971285b6b6$var$endReadable(this);
    }
    if (ret !== null) this.emit("data", ret);
    return ret;
};
function $caaa2b971285b6b6$var$onEofChunk(stream, state) {
    $caaa2b971285b6b6$var$debug("onEofChunk");
    if (state.ended) return;
    if (state.decoder) {
        var chunk = state.decoder.end();
        if (chunk && chunk.length) {
            state.buffer.push(chunk);
            state.length += state.objectMode ? 1 : chunk.length;
        }
    }
    state.ended = true;
    if (state.sync) // if we are sync, wait until next tick to emit the data.
    // Otherwise we risk emitting data in the flow()
    // the readable code triggers during a read() call
    $caaa2b971285b6b6$var$emitReadable(stream);
    else {
        // emit 'readable' now to make sure it gets picked up.
        state.needReadable = false;
        if (!state.emittedReadable) {
            state.emittedReadable = true;
            $caaa2b971285b6b6$var$emitReadable_(stream);
        }
    }
}
// Don't emit readable right away in sync mode, because this can trigger
// another read() call => stack overflow.  This way, it might trigger
// a nextTick recursion warning, but that's not so bad.
function $caaa2b971285b6b6$var$emitReadable(stream) {
    var state = stream._readableState;
    $caaa2b971285b6b6$var$debug("emitReadable", state.needReadable, state.emittedReadable);
    state.needReadable = false;
    if (!state.emittedReadable) {
        $caaa2b971285b6b6$var$debug("emitReadable", state.flowing);
        state.emittedReadable = true;
        $hIXGI.nextTick($caaa2b971285b6b6$var$emitReadable_, stream);
    }
}
function $caaa2b971285b6b6$var$emitReadable_(stream) {
    var state = stream._readableState;
    $caaa2b971285b6b6$var$debug("emitReadable_", state.destroyed, state.length, state.ended);
    if (!state.destroyed && (state.length || state.ended)) {
        stream.emit("readable");
        state.emittedReadable = false;
    }
    // The stream needs another readable event if
    // 1. It is not flowing, as the flow mechanism will take
    //    care of it.
    // 2. It is not ended.
    // 3. It is below the highWaterMark, so we can schedule
    //    another readable later.
    state.needReadable = !state.flowing && !state.ended && state.length <= state.highWaterMark;
    $caaa2b971285b6b6$var$flow(stream);
}
// at this point, the user has presumably seen the 'readable' event,
// and called read() to consume some data.  that may have triggered
// in turn another _read(n) call, in which case reading = true if
// it's in progress.
// However, if we're not ended, or reading, and the length < hwm,
// then go ahead and try to read some more preemptively.
function $caaa2b971285b6b6$var$maybeReadMore(stream, state) {
    if (!state.readingMore) {
        state.readingMore = true;
        $hIXGI.nextTick($caaa2b971285b6b6$var$maybeReadMore_, stream, state);
    }
}
function $caaa2b971285b6b6$var$maybeReadMore_(stream, state) {
    // Attempt to read more data if we should.
    //
    // The conditions for reading more data are (one of):
    // - Not enough data buffered (state.length < state.highWaterMark). The loop
    //   is responsible for filling the buffer with enough data if such data
    //   is available. If highWaterMark is 0 and we are not in the flowing mode
    //   we should _not_ attempt to buffer any extra data. We'll get more data
    //   when the stream consumer calls read() instead.
    // - No data in the buffer, and the stream is in flowing mode. In this mode
    //   the loop below is responsible for ensuring read() is called. Failing to
    //   call read here would abort the flow and there's no other mechanism for
    //   continuing the flow if the stream consumer has just subscribed to the
    //   'data' event.
    //
    // In addition to the above conditions to keep reading data, the following
    // conditions prevent the data from being read:
    // - The stream has ended (state.ended).
    // - There is already a pending 'read' operation (state.reading). This is a
    //   case where the the stream has called the implementation defined _read()
    //   method, but they are processing the call asynchronously and have _not_
    //   called push() with new data. In this case we skip performing more
    //   read()s. The execution ends in this method again after the _read() ends
    //   up calling push() with more data.
    while(!state.reading && !state.ended && (state.length < state.highWaterMark || state.flowing && state.length === 0)){
        var len = state.length;
        $caaa2b971285b6b6$var$debug("maybeReadMore read 0");
        stream.read(0);
        if (len === state.length) break;
    }
    state.readingMore = false;
}
// abstract method.  to be overridden in specific implementation classes.
// call cb(er, data) where data is <= n in length.
// for virtual (non-string, non-buffer) streams, "length" is somewhat
// arbitrary, and perhaps not very meaningful.
$caaa2b971285b6b6$var$Readable.prototype._read = function(n) {
    $caaa2b971285b6b6$var$errorOrDestroy(this, new $caaa2b971285b6b6$var$ERR_METHOD_NOT_IMPLEMENTED("_read()"));
};
$caaa2b971285b6b6$var$Readable.prototype.pipe = function(dest, pipeOpts) {
    var src = this;
    var state = this._readableState;
    switch(state.pipesCount){
        case 0:
            state.pipes = dest;
            break;
        case 1:
            state.pipes = [
                state.pipes,
                dest
            ];
            break;
        default:
            state.pipes.push(dest);
            break;
    }
    state.pipesCount += 1;
    $caaa2b971285b6b6$var$debug("pipe count=%d opts=%j", state.pipesCount, pipeOpts);
    var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== $hIXGI.stdout && dest !== $hIXGI.stderr;
    var endFn = doEnd ? onend : unpipe;
    if (state.endEmitted) $hIXGI.nextTick(endFn);
    else src.once("end", endFn);
    dest.on("unpipe", onunpipe);
    function onunpipe(readable, unpipeInfo) {
        $caaa2b971285b6b6$var$debug("onunpipe");
        if (readable === src) {
            if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
                unpipeInfo.hasUnpiped = true;
                cleanup();
            }
        }
    }
    function onend() {
        $caaa2b971285b6b6$var$debug("onend");
        dest.end();
    }
    // when the dest drains, it reduces the awaitDrain counter
    // on the source.  This would be more elegant with a .once()
    // handler in flow(), but adding and removing repeatedly is
    // too slow.
    var ondrain = $caaa2b971285b6b6$var$pipeOnDrain(src);
    dest.on("drain", ondrain);
    var cleanedUp = false;
    function cleanup() {
        $caaa2b971285b6b6$var$debug("cleanup");
        // cleanup event handlers once the pipe is broken
        dest.removeListener("close", onclose);
        dest.removeListener("finish", onfinish);
        dest.removeListener("drain", ondrain);
        dest.removeListener("error", onerror);
        dest.removeListener("unpipe", onunpipe);
        src.removeListener("end", onend);
        src.removeListener("end", unpipe);
        src.removeListener("data", ondata);
        cleanedUp = true;
        // if the reader is waiting for a drain event from this
        // specific writer, then it would cause it to never start
        // flowing again.
        // So, if this is awaiting a drain, then we just call it now.
        // If we don't know, then assume that we are waiting for one.
        if (state.awaitDrain && (!dest._writableState || dest._writableState.needDrain)) ondrain();
    }
    src.on("data", ondata);
    function ondata(chunk) {
        $caaa2b971285b6b6$var$debug("ondata");
        var ret = dest.write(chunk);
        $caaa2b971285b6b6$var$debug("dest.write", ret);
        if (ret === false) {
            // If the user unpiped during `dest.write()`, it is possible
            // to get stuck in a permanently paused state if that write
            // also returned false.
            // => Check whether `dest` is still a piping destination.
            if ((state.pipesCount === 1 && state.pipes === dest || state.pipesCount > 1 && $caaa2b971285b6b6$var$indexOf(state.pipes, dest) !== -1) && !cleanedUp) {
                $caaa2b971285b6b6$var$debug("false write response, pause", state.awaitDrain);
                state.awaitDrain++;
            }
            src.pause();
        }
    }
    // if the dest has an error, then stop piping into it.
    // however, don't suppress the throwing behavior for this.
    function onerror(er) {
        $caaa2b971285b6b6$var$debug("onerror", er);
        unpipe();
        dest.removeListener("error", onerror);
        if ($caaa2b971285b6b6$var$EElistenerCount(dest, "error") === 0) $caaa2b971285b6b6$var$errorOrDestroy(dest, er);
    }
    // Make sure our error handler is attached before userland ones.
    $caaa2b971285b6b6$var$prependListener(dest, "error", onerror);
    // Both close and finish should trigger unpipe, but only once.
    function onclose() {
        dest.removeListener("finish", onfinish);
        unpipe();
    }
    dest.once("close", onclose);
    function onfinish() {
        $caaa2b971285b6b6$var$debug("onfinish");
        dest.removeListener("close", onclose);
        unpipe();
    }
    dest.once("finish", onfinish);
    function unpipe() {
        $caaa2b971285b6b6$var$debug("unpipe");
        src.unpipe(dest);
    }
    // tell the dest that it's being piped to
    dest.emit("pipe", src);
    // start the flow if it hasn't been started already.
    if (!state.flowing) {
        $caaa2b971285b6b6$var$debug("pipe resume");
        src.resume();
    }
    return dest;
};
function $caaa2b971285b6b6$var$pipeOnDrain(src) {
    return function pipeOnDrainFunctionResult() {
        var state = src._readableState;
        $caaa2b971285b6b6$var$debug("pipeOnDrain", state.awaitDrain);
        if (state.awaitDrain) state.awaitDrain--;
        if (state.awaitDrain === 0 && $caaa2b971285b6b6$var$EElistenerCount(src, "data")) {
            state.flowing = true;
            $caaa2b971285b6b6$var$flow(src);
        }
    };
}
$caaa2b971285b6b6$var$Readable.prototype.unpipe = function(dest) {
    var state = this._readableState;
    var unpipeInfo = {
        hasUnpiped: false
    };
    // if we're not piping anywhere, then do nothing.
    if (state.pipesCount === 0) return this;
    // just one destination.  most common case.
    if (state.pipesCount === 1) {
        // passed in one, but it's not the right one.
        if (dest && dest !== state.pipes) return this;
        if (!dest) dest = state.pipes;
        // got a match.
        state.pipes = null;
        state.pipesCount = 0;
        state.flowing = false;
        if (dest) dest.emit("unpipe", this, unpipeInfo);
        return this;
    }
    // slow case. multiple pipe destinations.
    if (!dest) {
        // remove all.
        var dests = state.pipes;
        var len = state.pipesCount;
        state.pipes = null;
        state.pipesCount = 0;
        state.flowing = false;
        for(var i = 0; i < len; i++)dests[i].emit("unpipe", this, {
            hasUnpiped: false
        });
        return this;
    }
    // try to find the right one.
    var index = $caaa2b971285b6b6$var$indexOf(state.pipes, dest);
    if (index === -1) return this;
    state.pipes.splice(index, 1);
    state.pipesCount -= 1;
    if (state.pipesCount === 1) state.pipes = state.pipes[0];
    dest.emit("unpipe", this, unpipeInfo);
    return this;
};
// set up data events if they are asked for
// Ensure readable listeners eventually get something
$caaa2b971285b6b6$var$Readable.prototype.on = function(ev, fn) {
    var res = $67rTV.prototype.on.call(this, ev, fn);
    var state = this._readableState;
    if (ev === "data") {
        // update readableListening so that resume() may be a no-op
        // a few lines down. This is needed to support once('readable').
        state.readableListening = this.listenerCount("readable") > 0;
        // Try start flowing on next tick if stream isn't explicitly paused
        if (state.flowing !== false) this.resume();
    } else if (ev === "readable") {
        if (!state.endEmitted && !state.readableListening) {
            state.readableListening = state.needReadable = true;
            state.flowing = false;
            state.emittedReadable = false;
            $caaa2b971285b6b6$var$debug("on readable", state.length, state.reading);
            if (state.length) $caaa2b971285b6b6$var$emitReadable(this);
            else if (!state.reading) $hIXGI.nextTick($caaa2b971285b6b6$var$nReadingNextTick, this);
        }
    }
    return res;
};
$caaa2b971285b6b6$var$Readable.prototype.addListener = $caaa2b971285b6b6$var$Readable.prototype.on;
$caaa2b971285b6b6$var$Readable.prototype.removeListener = function(ev, fn) {
    var res = $67rTV.prototype.removeListener.call(this, ev, fn);
    if (ev === "readable") // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    $hIXGI.nextTick($caaa2b971285b6b6$var$updateReadableListening, this);
    return res;
};
$caaa2b971285b6b6$var$Readable.prototype.removeAllListeners = function(ev) {
    var res = $67rTV.prototype.removeAllListeners.apply(this, arguments);
    if (ev === "readable" || ev === undefined) // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    $hIXGI.nextTick($caaa2b971285b6b6$var$updateReadableListening, this);
    return res;
};
function $caaa2b971285b6b6$var$updateReadableListening(self1) {
    var state = self1._readableState;
    state.readableListening = self1.listenerCount("readable") > 0;
    if (state.resumeScheduled && !state.paused) // flowing needs to be set to true now, otherwise
    // the upcoming resume will not flow.
    state.flowing = true;
    else if (self1.listenerCount("data") > 0) self1.resume();
}
function $caaa2b971285b6b6$var$nReadingNextTick(self1) {
    $caaa2b971285b6b6$var$debug("readable nexttick read 0");
    self1.read(0);
}
// pause() and resume() are remnants of the legacy readable stream API
// If the user uses them, then switch into old mode.
$caaa2b971285b6b6$var$Readable.prototype.resume = function() {
    var state = this._readableState;
    if (!state.flowing) {
        $caaa2b971285b6b6$var$debug("resume");
        // we flow only if there is no one listening
        // for readable, but we still have to call
        // resume()
        state.flowing = !state.readableListening;
        $caaa2b971285b6b6$var$resume(this, state);
    }
    state.paused = false;
    return this;
};
function $caaa2b971285b6b6$var$resume(stream, state) {
    if (!state.resumeScheduled) {
        state.resumeScheduled = true;
        $hIXGI.nextTick($caaa2b971285b6b6$var$resume_, stream, state);
    }
}
function $caaa2b971285b6b6$var$resume_(stream, state) {
    $caaa2b971285b6b6$var$debug("resume", state.reading);
    if (!state.reading) stream.read(0);
    state.resumeScheduled = false;
    stream.emit("resume");
    $caaa2b971285b6b6$var$flow(stream);
    if (state.flowing && !state.reading) stream.read(0);
}
$caaa2b971285b6b6$var$Readable.prototype.pause = function() {
    $caaa2b971285b6b6$var$debug("call pause flowing=%j", this._readableState.flowing);
    if (this._readableState.flowing !== false) {
        $caaa2b971285b6b6$var$debug("pause");
        this._readableState.flowing = false;
        this.emit("pause");
    }
    this._readableState.paused = true;
    return this;
};
function $caaa2b971285b6b6$var$flow(stream) {
    var state = stream._readableState;
    $caaa2b971285b6b6$var$debug("flow", state.flowing);
    while(state.flowing && stream.read() !== null);
}
// wrap an old-style stream as the async data source.
// This is *not* part of the readable stream interface.
// It is an ugly unfortunate mess of history.
$caaa2b971285b6b6$var$Readable.prototype.wrap = function(stream) {
    var _this = this;
    var state = this._readableState;
    var paused = false;
    stream.on("end", function() {
        $caaa2b971285b6b6$var$debug("wrapped end");
        if (state.decoder && !state.ended) {
            var chunk = state.decoder.end();
            if (chunk && chunk.length) _this.push(chunk);
        }
        _this.push(null);
    });
    stream.on("data", function(chunk) {
        $caaa2b971285b6b6$var$debug("wrapped data");
        if (state.decoder) chunk = state.decoder.write(chunk);
        // don't skip over falsy values in objectMode
        if (state.objectMode && (chunk === null || chunk === undefined)) return;
        else if (!state.objectMode && (!chunk || !chunk.length)) return;
        var ret = _this.push(chunk);
        if (!ret) {
            paused = true;
            stream.pause();
        }
    });
    // proxy all the other methods.
    // important when wrapping filters and duplexes.
    for(var i in stream)if (this[i] === undefined && typeof stream[i] === "function") this[i] = function methodWrap(method) {
        return function methodWrapReturnFunction() {
            return stream[method].apply(stream, arguments);
        };
    }(i);
    // proxy certain important events.
    for(var n = 0; n < $caaa2b971285b6b6$var$kProxyEvents.length; n++)stream.on($caaa2b971285b6b6$var$kProxyEvents[n], this.emit.bind(this, $caaa2b971285b6b6$var$kProxyEvents[n]));
    // when we try to consume some more bytes, simply unpause the
    // underlying stream.
    this._read = function(n) {
        $caaa2b971285b6b6$var$debug("wrapped _read", n);
        if (paused) {
            paused = false;
            stream.resume();
        }
    };
    return this;
};

if (typeof Symbol === "function") $caaa2b971285b6b6$var$Readable.prototype[Symbol.asyncIterator] = function() {
    if ($caaa2b971285b6b6$var$createReadableStreamAsyncIterator === undefined) $caaa2b971285b6b6$var$createReadableStreamAsyncIterator = (parcelRequire("eSo8i"));
    return $caaa2b971285b6b6$var$createReadableStreamAsyncIterator(this);
};
Object.defineProperty($caaa2b971285b6b6$var$Readable.prototype, "readableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState.highWaterMark;
    }
});
Object.defineProperty($caaa2b971285b6b6$var$Readable.prototype, "readableBuffer", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState && this._readableState.buffer;
    }
});
Object.defineProperty($caaa2b971285b6b6$var$Readable.prototype, "readableFlowing", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState.flowing;
    },
    set: function set(state) {
        if (this._readableState) this._readableState.flowing = state;
    }
});
// exposed for testing purposes only.
$caaa2b971285b6b6$var$Readable._fromList = $caaa2b971285b6b6$var$fromList;
Object.defineProperty($caaa2b971285b6b6$var$Readable.prototype, "readableLength", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState.length;
    }
});
// Pluck off n bytes from an array of buffers.
// Length is the combined lengths of all the buffers in the list.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $caaa2b971285b6b6$var$fromList(n, state) {
    // nothing buffered
    if (state.length === 0) return null;
    var ret;
    if (state.objectMode) ret = state.buffer.shift();
    else if (!n || n >= state.length) {
        // read it all, truncate the list
        if (state.decoder) ret = state.buffer.join("");
        else if (state.buffer.length === 1) ret = state.buffer.first();
        else ret = state.buffer.concat(state.length);
        state.buffer.clear();
    } else // read part of list
    ret = state.buffer.consume(n, state.decoder);
    return ret;
}
function $caaa2b971285b6b6$var$endReadable(stream) {
    var state = stream._readableState;
    $caaa2b971285b6b6$var$debug("endReadable", state.endEmitted);
    if (!state.endEmitted) {
        state.ended = true;
        $hIXGI.nextTick($caaa2b971285b6b6$var$endReadableNT, state, stream);
    }
}
function $caaa2b971285b6b6$var$endReadableNT(state, stream) {
    $caaa2b971285b6b6$var$debug("endReadableNT", state.endEmitted, state.length);
    // Check that we didn't get one last unshift.
    if (!state.endEmitted && state.length === 0) {
        state.endEmitted = true;
        stream.readable = false;
        stream.emit("end");
        if (state.autoDestroy) {
            // In case of duplex streams we need a way to detect
            // if the writable side is ready for autoDestroy as well
            var wState = stream._writableState;
            if (!wState || wState.autoDestroy && wState.finished) stream.destroy();
        }
    }
}

if (typeof Symbol === "function") $caaa2b971285b6b6$var$Readable.from = function(iterable, opts) {
    if ($caaa2b971285b6b6$var$from === undefined) $caaa2b971285b6b6$var$from = (parcelRequire("bbssr"));
    return $caaa2b971285b6b6$var$from($caaa2b971285b6b6$var$Readable, iterable, opts);
};
function $caaa2b971285b6b6$var$indexOf(xs, x) {
    for(var i = 0, l = xs.length; i < l; i++){
        if (xs[i] === x) return i;
    }
    return -1;
}

});
parcelRequire.register("ikynl", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
"use strict";
var $d584c2851e6395e1$var$R = typeof Reflect === "object" ? Reflect : null;
var $d584c2851e6395e1$var$ReflectApply = $d584c2851e6395e1$var$R && typeof $d584c2851e6395e1$var$R.apply === "function" ? $d584c2851e6395e1$var$R.apply : function ReflectApply(target, receiver, args) {
    return Function.prototype.apply.call(target, receiver, args);
};
var $d584c2851e6395e1$var$ReflectOwnKeys;
if ($d584c2851e6395e1$var$R && typeof $d584c2851e6395e1$var$R.ownKeys === "function") $d584c2851e6395e1$var$ReflectOwnKeys = $d584c2851e6395e1$var$R.ownKeys;
else if (Object.getOwnPropertySymbols) $d584c2851e6395e1$var$ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target).concat(Object.getOwnPropertySymbols(target));
};
else $d584c2851e6395e1$var$ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target);
};
function $d584c2851e6395e1$var$ProcessEmitWarning(warning) {
    if (console && console.warn) console.warn(warning);
}
var $d584c2851e6395e1$var$NumberIsNaN = Number.isNaN || function NumberIsNaN(value) {
    return value !== value;
};
function $d584c2851e6395e1$var$EventEmitter() {
    $d584c2851e6395e1$var$EventEmitter.init.call(this);
}
module.exports = $d584c2851e6395e1$var$EventEmitter;
module.exports.once = $d584c2851e6395e1$var$once;
// Backwards-compat with node 0.10.x
$d584c2851e6395e1$var$EventEmitter.EventEmitter = $d584c2851e6395e1$var$EventEmitter;
$d584c2851e6395e1$var$EventEmitter.prototype._events = undefined;
$d584c2851e6395e1$var$EventEmitter.prototype._eventsCount = 0;
$d584c2851e6395e1$var$EventEmitter.prototype._maxListeners = undefined;
// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
var $d584c2851e6395e1$var$defaultMaxListeners = 10;
function $d584c2851e6395e1$var$checkListener(listener) {
    if (typeof listener !== "function") throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
}
Object.defineProperty($d584c2851e6395e1$var$EventEmitter, "defaultMaxListeners", {
    enumerable: true,
    get: function() {
        return $d584c2851e6395e1$var$defaultMaxListeners;
    },
    set: function(arg) {
        if (typeof arg !== "number" || arg < 0 || $d584c2851e6395e1$var$NumberIsNaN(arg)) throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + arg + ".");
        $d584c2851e6395e1$var$defaultMaxListeners = arg;
    }
});
$d584c2851e6395e1$var$EventEmitter.init = function() {
    if (this._events === undefined || this._events === Object.getPrototypeOf(this)._events) {
        this._events = Object.create(null);
        this._eventsCount = 0;
    }
    this._maxListeners = this._maxListeners || undefined;
};
// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
$d584c2851e6395e1$var$EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
    if (typeof n !== "number" || n < 0 || $d584c2851e6395e1$var$NumberIsNaN(n)) throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + n + ".");
    this._maxListeners = n;
    return this;
};
function $d584c2851e6395e1$var$_getMaxListeners(that) {
    if (that._maxListeners === undefined) return $d584c2851e6395e1$var$EventEmitter.defaultMaxListeners;
    return that._maxListeners;
}
$d584c2851e6395e1$var$EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
    return $d584c2851e6395e1$var$_getMaxListeners(this);
};
$d584c2851e6395e1$var$EventEmitter.prototype.emit = function emit(type) {
    var args = [];
    for(var i = 1; i < arguments.length; i++)args.push(arguments[i]);
    var doError = type === "error";
    var events = this._events;
    if (events !== undefined) doError = doError && events.error === undefined;
    else if (!doError) return false;
    // If there is no 'error' event listener then throw.
    if (doError) {
        var er;
        if (args.length > 0) er = args[0];
        if (er instanceof Error) // Note: The comments on the `throw` lines are intentional, they show
        // up in Node's output if this results in an unhandled exception.
        throw er; // Unhandled 'error' event
        // At least give some kind of context to the user
        var err = new Error("Unhandled error." + (er ? " (" + er.message + ")" : ""));
        err.context = er;
        throw err; // Unhandled 'error' event
    }
    var handler = events[type];
    if (handler === undefined) return false;
    if (typeof handler === "function") $d584c2851e6395e1$var$ReflectApply(handler, this, args);
    else {
        var len = handler.length;
        var listeners = $d584c2851e6395e1$var$arrayClone(handler, len);
        for(var i = 0; i < len; ++i)$d584c2851e6395e1$var$ReflectApply(listeners[i], this, args);
    }
    return true;
};
function $d584c2851e6395e1$var$_addListener(target, type, listener, prepend) {
    var m;
    var events;
    var existing;
    $d584c2851e6395e1$var$checkListener(listener);
    events = target._events;
    if (events === undefined) {
        events = target._events = Object.create(null);
        target._eventsCount = 0;
    } else {
        // To avoid recursion in the case that type === "newListener"! Before
        // adding it to the listeners, first emit "newListener".
        if (events.newListener !== undefined) {
            target.emit("newListener", type, listener.listener ? listener.listener : listener);
            // Re-assign `events` because a newListener handler could have caused the
            // this._events to be assigned to a new object
            events = target._events;
        }
        existing = events[type];
    }
    if (existing === undefined) {
        // Optimize the case of one listener. Don't need the extra array object.
        existing = events[type] = listener;
        ++target._eventsCount;
    } else {
        if (typeof existing === "function") // Adding the second element, need to change to array.
        existing = events[type] = prepend ? [
            listener,
            existing
        ] : [
            existing,
            listener
        ];
        else if (prepend) existing.unshift(listener);
        else existing.push(listener);
        // Check for listener leak
        m = $d584c2851e6395e1$var$_getMaxListeners(target);
        if (m > 0 && existing.length > m && !existing.warned) {
            existing.warned = true;
            // No error code for this since it is a Warning
            // eslint-disable-next-line no-restricted-syntax
            var w = new Error("Possible EventEmitter memory leak detected. " + existing.length + " " + String(type) + " listeners " + "added. Use emitter.setMaxListeners() to " + "increase limit");
            w.name = "MaxListenersExceededWarning";
            w.emitter = target;
            w.type = type;
            w.count = existing.length;
            $d584c2851e6395e1$var$ProcessEmitWarning(w);
        }
    }
    return target;
}
$d584c2851e6395e1$var$EventEmitter.prototype.addListener = function addListener(type, listener) {
    return $d584c2851e6395e1$var$_addListener(this, type, listener, false);
};
$d584c2851e6395e1$var$EventEmitter.prototype.on = $d584c2851e6395e1$var$EventEmitter.prototype.addListener;
$d584c2851e6395e1$var$EventEmitter.prototype.prependListener = function prependListener(type, listener) {
    return $d584c2851e6395e1$var$_addListener(this, type, listener, true);
};
function $d584c2851e6395e1$var$onceWrapper() {
    if (!this.fired) {
        this.target.removeListener(this.type, this.wrapFn);
        this.fired = true;
        if (arguments.length === 0) return this.listener.call(this.target);
        return this.listener.apply(this.target, arguments);
    }
}
function $d584c2851e6395e1$var$_onceWrap(target, type, listener) {
    var state = {
        fired: false,
        wrapFn: undefined,
        target: target,
        type: type,
        listener: listener
    };
    var wrapped = $d584c2851e6395e1$var$onceWrapper.bind(state);
    wrapped.listener = listener;
    state.wrapFn = wrapped;
    return wrapped;
}
$d584c2851e6395e1$var$EventEmitter.prototype.once = function once(type, listener) {
    $d584c2851e6395e1$var$checkListener(listener);
    this.on(type, $d584c2851e6395e1$var$_onceWrap(this, type, listener));
    return this;
};
$d584c2851e6395e1$var$EventEmitter.prototype.prependOnceListener = function prependOnceListener(type, listener) {
    $d584c2851e6395e1$var$checkListener(listener);
    this.prependListener(type, $d584c2851e6395e1$var$_onceWrap(this, type, listener));
    return this;
};
// Emits a 'removeListener' event if and only if the listener was removed.
$d584c2851e6395e1$var$EventEmitter.prototype.removeListener = function removeListener(type, listener) {
    var list, events, position, i, originalListener;
    $d584c2851e6395e1$var$checkListener(listener);
    events = this._events;
    if (events === undefined) return this;
    list = events[type];
    if (list === undefined) return this;
    if (list === listener || list.listener === listener) {
        if (--this._eventsCount === 0) this._events = Object.create(null);
        else {
            delete events[type];
            if (events.removeListener) this.emit("removeListener", type, list.listener || listener);
        }
    } else if (typeof list !== "function") {
        position = -1;
        for(i = list.length - 1; i >= 0; i--)if (list[i] === listener || list[i].listener === listener) {
            originalListener = list[i].listener;
            position = i;
            break;
        }
        if (position < 0) return this;
        if (position === 0) list.shift();
        else $d584c2851e6395e1$var$spliceOne(list, position);
        if (list.length === 1) events[type] = list[0];
        if (events.removeListener !== undefined) this.emit("removeListener", type, originalListener || listener);
    }
    return this;
};
$d584c2851e6395e1$var$EventEmitter.prototype.off = $d584c2851e6395e1$var$EventEmitter.prototype.removeListener;
$d584c2851e6395e1$var$EventEmitter.prototype.removeAllListeners = function removeAllListeners(type) {
    var listeners, events, i;
    events = this._events;
    if (events === undefined) return this;
    // not listening for removeListener, no need to emit
    if (events.removeListener === undefined) {
        if (arguments.length === 0) {
            this._events = Object.create(null);
            this._eventsCount = 0;
        } else if (events[type] !== undefined) {
            if (--this._eventsCount === 0) this._events = Object.create(null);
            else delete events[type];
        }
        return this;
    }
    // emit removeListener for all listeners on all events
    if (arguments.length === 0) {
        var keys = Object.keys(events);
        var key;
        for(i = 0; i < keys.length; ++i){
            key = keys[i];
            if (key === "removeListener") continue;
            this.removeAllListeners(key);
        }
        this.removeAllListeners("removeListener");
        this._events = Object.create(null);
        this._eventsCount = 0;
        return this;
    }
    listeners = events[type];
    if (typeof listeners === "function") this.removeListener(type, listeners);
    else if (listeners !== undefined) // LIFO order
    for(i = listeners.length - 1; i >= 0; i--)this.removeListener(type, listeners[i]);
    return this;
};
function $d584c2851e6395e1$var$_listeners(target, type, unwrap) {
    var events = target._events;
    if (events === undefined) return [];
    var evlistener = events[type];
    if (evlistener === undefined) return [];
    if (typeof evlistener === "function") return unwrap ? [
        evlistener.listener || evlistener
    ] : [
        evlistener
    ];
    return unwrap ? $d584c2851e6395e1$var$unwrapListeners(evlistener) : $d584c2851e6395e1$var$arrayClone(evlistener, evlistener.length);
}
$d584c2851e6395e1$var$EventEmitter.prototype.listeners = function listeners(type) {
    return $d584c2851e6395e1$var$_listeners(this, type, true);
};
$d584c2851e6395e1$var$EventEmitter.prototype.rawListeners = function rawListeners(type) {
    return $d584c2851e6395e1$var$_listeners(this, type, false);
};
$d584c2851e6395e1$var$EventEmitter.listenerCount = function(emitter, type) {
    if (typeof emitter.listenerCount === "function") return emitter.listenerCount(type);
    else return $d584c2851e6395e1$var$listenerCount.call(emitter, type);
};
$d584c2851e6395e1$var$EventEmitter.prototype.listenerCount = $d584c2851e6395e1$var$listenerCount;
function $d584c2851e6395e1$var$listenerCount(type) {
    var events = this._events;
    if (events !== undefined) {
        var evlistener = events[type];
        if (typeof evlistener === "function") return 1;
        else if (evlistener !== undefined) return evlistener.length;
    }
    return 0;
}
$d584c2851e6395e1$var$EventEmitter.prototype.eventNames = function eventNames() {
    return this._eventsCount > 0 ? $d584c2851e6395e1$var$ReflectOwnKeys(this._events) : [];
};
function $d584c2851e6395e1$var$arrayClone(arr, n) {
    var copy = new Array(n);
    for(var i = 0; i < n; ++i)copy[i] = arr[i];
    return copy;
}
function $d584c2851e6395e1$var$spliceOne(list, index) {
    for(; index + 1 < list.length; index++)list[index] = list[index + 1];
    list.pop();
}
function $d584c2851e6395e1$var$unwrapListeners(arr) {
    var ret = new Array(arr.length);
    for(var i = 0; i < ret.length; ++i)ret[i] = arr[i].listener || arr[i];
    return ret;
}
function $d584c2851e6395e1$var$once(emitter, name) {
    return new Promise(function(resolve, reject) {
        function errorListener(err) {
            emitter.removeListener(name, resolver);
            reject(err);
        }
        function resolver() {
            if (typeof emitter.removeListener === "function") emitter.removeListener("error", errorListener);
            resolve([].slice.call(arguments));
        }
        $d584c2851e6395e1$var$eventTargetAgnosticAddListener(emitter, name, resolver, {
            once: true
        });
        if (name !== "error") $d584c2851e6395e1$var$addErrorHandlerIfEventEmitter(emitter, errorListener, {
            once: true
        });
    });
}
function $d584c2851e6395e1$var$addErrorHandlerIfEventEmitter(emitter, handler, flags) {
    if (typeof emitter.on === "function") $d584c2851e6395e1$var$eventTargetAgnosticAddListener(emitter, "error", handler, flags);
}
function $d584c2851e6395e1$var$eventTargetAgnosticAddListener(emitter, name, listener, flags) {
    if (typeof emitter.on === "function") {
        if (flags.once) emitter.once(name, listener);
        else emitter.on(name, listener);
    } else if (typeof emitter.addEventListener === "function") // EventTarget does not have `error` event semantics like Node
    // EventEmitters, we do not listen for `error` events here.
    emitter.addEventListener(name, function wrapListener(arg) {
        // IE does not have builtin `{ once: true }` support so we
        // have to do it manually.
        if (flags.once) emitter.removeEventListener(name, wrapListener);
        listener(arg);
    });
    else throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof emitter);
}

});

parcelRequire.register("67rTV", function(module, exports) {

module.exports = (parcelRequire("ikynl")).EventEmitter;

});

parcelRequire.register("iuRmA", function(module, exports) {

$parcel$export(module.exports, "Buffer", () => $d7746c2c27aed368$export$a143d493d941bafc, (v) => $d7746c2c27aed368$export$a143d493d941bafc = v);
$parcel$export(module.exports, "SlowBuffer", () => $d7746c2c27aed368$export$e4cf37d7f6fb9e0a, (v) => $d7746c2c27aed368$export$e4cf37d7f6fb9e0a = v);
$parcel$export(module.exports, "INSPECT_MAX_BYTES", () => $d7746c2c27aed368$export$f99ded8fe4b79145, (v) => $d7746c2c27aed368$export$f99ded8fe4b79145 = v);
$parcel$export(module.exports, "kMaxLength", () => $d7746c2c27aed368$export$599f31c3813fae4d, (v) => $d7746c2c27aed368$export$599f31c3813fae4d = v);
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $d7746c2c27aed368$export$a143d493d941bafc;
var $d7746c2c27aed368$export$e4cf37d7f6fb9e0a;
var $d7746c2c27aed368$export$f99ded8fe4b79145;
var $d7746c2c27aed368$export$599f31c3813fae4d;
"use strict";

var $l4PI2 = parcelRequire("l4PI2");

var $9BUzF = parcelRequire("9BUzF");
var $d7746c2c27aed368$var$customInspectSymbol = typeof Symbol === "function" && typeof Symbol["for"] === "function" // eslint-disable-line dot-notation
 ? Symbol["for"]("nodejs.util.inspect.custom") // eslint-disable-line dot-notation
 : null;
$d7746c2c27aed368$export$a143d493d941bafc = $d7746c2c27aed368$var$Buffer;
$d7746c2c27aed368$export$e4cf37d7f6fb9e0a = $d7746c2c27aed368$var$SlowBuffer;
$d7746c2c27aed368$export$f99ded8fe4b79145 = 50;
var $d7746c2c27aed368$var$K_MAX_LENGTH = 0x7fffffff;
$d7746c2c27aed368$export$599f31c3813fae4d = $d7746c2c27aed368$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $d7746c2c27aed368$var$Buffer.TYPED_ARRAY_SUPPORT = $d7746c2c27aed368$var$typedArraySupport();
if (!$d7746c2c27aed368$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== "undefined" && typeof console.error === "function") console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $d7746c2c27aed368$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        var arr = new Uint8Array(1);
        var proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($d7746c2c27aed368$var$Buffer.prototype, "parent", {
    enumerable: true,
    get: function() {
        if (!$d7746c2c27aed368$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($d7746c2c27aed368$var$Buffer.prototype, "offset", {
    enumerable: true,
    get: function() {
        if (!$d7746c2c27aed368$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $d7746c2c27aed368$var$createBuffer(length) {
    if (length > $d7746c2c27aed368$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    var buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $d7746c2c27aed368$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $d7746c2c27aed368$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === "number") {
        if (typeof encodingOrOffset === "string") throw new TypeError('The "string" argument must be of type string. Received type number');
        return $d7746c2c27aed368$var$allocUnsafe(arg);
    }
    return $d7746c2c27aed368$var$from(arg, encodingOrOffset, length);
}
$d7746c2c27aed368$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $d7746c2c27aed368$var$from(value, encodingOrOffset, length) {
    if (typeof value === "string") return $d7746c2c27aed368$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $d7746c2c27aed368$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($d7746c2c27aed368$var$isInstance(value, ArrayBuffer) || value && $d7746c2c27aed368$var$isInstance(value.buffer, ArrayBuffer)) return $d7746c2c27aed368$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== "undefined" && ($d7746c2c27aed368$var$isInstance(value, SharedArrayBuffer) || value && $d7746c2c27aed368$var$isInstance(value.buffer, SharedArrayBuffer))) return $d7746c2c27aed368$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === "number") throw new TypeError('The "value" argument must not be of type number. Received type number');
    var valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $d7746c2c27aed368$var$Buffer.from(valueOf, encodingOrOffset, length);
    var b = $d7746c2c27aed368$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== "undefined" && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === "function") return $d7746c2c27aed368$var$Buffer.from(value[Symbol.toPrimitive]("string"), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $d7746c2c27aed368$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $d7746c2c27aed368$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($d7746c2c27aed368$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($d7746c2c27aed368$var$Buffer, Uint8Array);
function $d7746c2c27aed368$var$assertSize(size) {
    if (typeof size !== "number") throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $d7746c2c27aed368$var$alloc(size, fill, encoding) {
    $d7746c2c27aed368$var$assertSize(size);
    if (size <= 0) return $d7746c2c27aed368$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === "string" ? $d7746c2c27aed368$var$createBuffer(size).fill(fill, encoding) : $d7746c2c27aed368$var$createBuffer(size).fill(fill);
    return $d7746c2c27aed368$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $d7746c2c27aed368$var$Buffer.alloc = function(size, fill, encoding) {
    return $d7746c2c27aed368$var$alloc(size, fill, encoding);
};
function $d7746c2c27aed368$var$allocUnsafe(size) {
    $d7746c2c27aed368$var$assertSize(size);
    return $d7746c2c27aed368$var$createBuffer(size < 0 ? 0 : $d7746c2c27aed368$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $d7746c2c27aed368$var$Buffer.allocUnsafe = function(size) {
    return $d7746c2c27aed368$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $d7746c2c27aed368$var$Buffer.allocUnsafeSlow = function(size) {
    return $d7746c2c27aed368$var$allocUnsafe(size);
};
function $d7746c2c27aed368$var$fromString(string, encoding) {
    if (typeof encoding !== "string" || encoding === "") encoding = "utf8";
    if (!$d7746c2c27aed368$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
    var length = $d7746c2c27aed368$var$byteLength(string, encoding) | 0;
    var buf = $d7746c2c27aed368$var$createBuffer(length);
    var actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $d7746c2c27aed368$var$fromArrayLike(array) {
    var length = array.length < 0 ? 0 : $d7746c2c27aed368$var$checked(array.length) | 0;
    var buf = $d7746c2c27aed368$var$createBuffer(length);
    for(var i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $d7746c2c27aed368$var$fromArrayView(arrayView) {
    if ($d7746c2c27aed368$var$isInstance(arrayView, Uint8Array)) {
        var copy = new Uint8Array(arrayView);
        return $d7746c2c27aed368$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $d7746c2c27aed368$var$fromArrayLike(arrayView);
}
function $d7746c2c27aed368$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    var buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $d7746c2c27aed368$var$Buffer.prototype);
    return buf;
}
function $d7746c2c27aed368$var$fromObject(obj) {
    if ($d7746c2c27aed368$var$Buffer.isBuffer(obj)) {
        var len = $d7746c2c27aed368$var$checked(obj.length) | 0;
        var buf = $d7746c2c27aed368$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== "number" || $d7746c2c27aed368$var$numberIsNaN(obj.length)) return $d7746c2c27aed368$var$createBuffer(0);
        return $d7746c2c27aed368$var$fromArrayLike(obj);
    }
    if (obj.type === "Buffer" && Array.isArray(obj.data)) return $d7746c2c27aed368$var$fromArrayLike(obj.data);
}
function $d7746c2c27aed368$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $d7746c2c27aed368$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $d7746c2c27aed368$var$K_MAX_LENGTH.toString(16) + " bytes");
    return length | 0;
}
function $d7746c2c27aed368$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $d7746c2c27aed368$var$Buffer.alloc(+length);
}
$d7746c2c27aed368$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $d7746c2c27aed368$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$d7746c2c27aed368$var$Buffer.compare = function compare(a, b) {
    if ($d7746c2c27aed368$var$isInstance(a, Uint8Array)) a = $d7746c2c27aed368$var$Buffer.from(a, a.offset, a.byteLength);
    if ($d7746c2c27aed368$var$isInstance(b, Uint8Array)) b = $d7746c2c27aed368$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$d7746c2c27aed368$var$Buffer.isBuffer(a) || !$d7746c2c27aed368$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    var x = a.length;
    var y = b.length;
    for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$d7746c2c27aed368$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "latin1":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return true;
        default:
            return false;
    }
};
$d7746c2c27aed368$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $d7746c2c27aed368$var$Buffer.alloc(0);
    var i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    var buffer = $d7746c2c27aed368$var$Buffer.allocUnsafe(length);
    var pos = 0;
    for(i = 0; i < list.length; ++i){
        var buf = list[i];
        if ($d7746c2c27aed368$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) $d7746c2c27aed368$var$Buffer.from(buf).copy(buffer, pos);
            else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$d7746c2c27aed368$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $d7746c2c27aed368$var$byteLength(string, encoding) {
    if ($d7746c2c27aed368$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $d7746c2c27aed368$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== "string") throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    var len = string.length;
    var mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    var loweredCase = false;
    for(;;)switch(encoding){
        case "ascii":
        case "latin1":
        case "binary":
            return len;
        case "utf8":
        case "utf-8":
            return $d7746c2c27aed368$var$utf8ToBytes(string).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return len * 2;
        case "hex":
            return len >>> 1;
        case "base64":
            return $d7746c2c27aed368$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $d7746c2c27aed368$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
}
$d7746c2c27aed368$var$Buffer.byteLength = $d7746c2c27aed368$var$byteLength;
function $d7746c2c27aed368$var$slowToString(encoding, start, end) {
    var loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return "";
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return "";
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return "";
    if (!encoding) encoding = "utf8";
    while(true)switch(encoding){
        case "hex":
            return $d7746c2c27aed368$var$hexSlice(this, start, end);
        case "utf8":
        case "utf-8":
            return $d7746c2c27aed368$var$utf8Slice(this, start, end);
        case "ascii":
            return $d7746c2c27aed368$var$asciiSlice(this, start, end);
        case "latin1":
        case "binary":
            return $d7746c2c27aed368$var$latin1Slice(this, start, end);
        case "base64":
            return $d7746c2c27aed368$var$base64Slice(this, start, end);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $d7746c2c27aed368$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = (encoding + "").toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$d7746c2c27aed368$var$Buffer.prototype._isBuffer = true;
function $d7746c2c27aed368$var$swap(b, n, m) {
    var i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$d7746c2c27aed368$var$Buffer.prototype.swap16 = function swap16() {
    var len = this.length;
    if (len % 2 !== 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
    for(var i = 0; i < len; i += 2)$d7746c2c27aed368$var$swap(this, i, i + 1);
    return this;
};
$d7746c2c27aed368$var$Buffer.prototype.swap32 = function swap32() {
    var len = this.length;
    if (len % 4 !== 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
    for(var i = 0; i < len; i += 4){
        $d7746c2c27aed368$var$swap(this, i, i + 3);
        $d7746c2c27aed368$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$d7746c2c27aed368$var$Buffer.prototype.swap64 = function swap64() {
    var len = this.length;
    if (len % 8 !== 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
    for(var i = 0; i < len; i += 8){
        $d7746c2c27aed368$var$swap(this, i, i + 7);
        $d7746c2c27aed368$var$swap(this, i + 1, i + 6);
        $d7746c2c27aed368$var$swap(this, i + 2, i + 5);
        $d7746c2c27aed368$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$d7746c2c27aed368$var$Buffer.prototype.toString = function toString() {
    var length = this.length;
    if (length === 0) return "";
    if (arguments.length === 0) return $d7746c2c27aed368$var$utf8Slice(this, 0, length);
    return $d7746c2c27aed368$var$slowToString.apply(this, arguments);
};
$d7746c2c27aed368$var$Buffer.prototype.toLocaleString = $d7746c2c27aed368$var$Buffer.prototype.toString;
$d7746c2c27aed368$var$Buffer.prototype.equals = function equals(b) {
    if (!$d7746c2c27aed368$var$Buffer.isBuffer(b)) throw new TypeError("Argument must be a Buffer");
    if (this === b) return true;
    return $d7746c2c27aed368$var$Buffer.compare(this, b) === 0;
};
$d7746c2c27aed368$var$Buffer.prototype.inspect = function inspect() {
    var str = "";
    var max = $d7746c2c27aed368$export$f99ded8fe4b79145;
    str = this.toString("hex", 0, max).replace(/(.{2})/g, "$1 ").trim();
    if (this.length > max) str += " ... ";
    return "<Buffer " + str + ">";
};
if ($d7746c2c27aed368$var$customInspectSymbol) $d7746c2c27aed368$var$Buffer.prototype[$d7746c2c27aed368$var$customInspectSymbol] = $d7746c2c27aed368$var$Buffer.prototype.inspect;
$d7746c2c27aed368$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($d7746c2c27aed368$var$isInstance(target, Uint8Array)) target = $d7746c2c27aed368$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$d7746c2c27aed368$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError("out of range index");
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    var x = thisEnd - thisStart;
    var y = end - start;
    var len = Math.min(x, y);
    var thisCopy = this.slice(thisStart, thisEnd);
    var targetCopy = target.slice(start, end);
    for(var i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $d7746c2c27aed368$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === "string") {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($d7746c2c27aed368$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === "string") val = $d7746c2c27aed368$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($d7746c2c27aed368$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $d7746c2c27aed368$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === "number") {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === "function") {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $d7746c2c27aed368$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError("val must be string, number or Buffer");
}
function $d7746c2c27aed368$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    var indexSize = 1;
    var arrLength = arr.length;
    var valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === "ucs2" || encoding === "ucs-2" || encoding === "utf16le" || encoding === "utf-16le") {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    var i;
    if (dir) {
        var foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            var found = true;
            for(var j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$d7746c2c27aed368$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$d7746c2c27aed368$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $d7746c2c27aed368$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$d7746c2c27aed368$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $d7746c2c27aed368$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $d7746c2c27aed368$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    var remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    var strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    for(var i = 0; i < length; ++i){
        var parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($d7746c2c27aed368$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $d7746c2c27aed368$var$utf8Write(buf, string, offset, length) {
    return $d7746c2c27aed368$var$blitBuffer($d7746c2c27aed368$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $d7746c2c27aed368$var$asciiWrite(buf, string, offset, length) {
    return $d7746c2c27aed368$var$blitBuffer($d7746c2c27aed368$var$asciiToBytes(string), buf, offset, length);
}
function $d7746c2c27aed368$var$base64Write(buf, string, offset, length) {
    return $d7746c2c27aed368$var$blitBuffer($d7746c2c27aed368$var$base64ToBytes(string), buf, offset, length);
}
function $d7746c2c27aed368$var$ucs2Write(buf, string, offset, length) {
    return $d7746c2c27aed368$var$blitBuffer($d7746c2c27aed368$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$d7746c2c27aed368$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = "utf8";
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === "string") {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = "utf8";
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
    var remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError("Attempt to write outside buffer bounds");
    if (!encoding) encoding = "utf8";
    var loweredCase = false;
    for(;;)switch(encoding){
        case "hex":
            return $d7746c2c27aed368$var$hexWrite(this, string, offset, length);
        case "utf8":
        case "utf-8":
            return $d7746c2c27aed368$var$utf8Write(this, string, offset, length);
        case "ascii":
        case "latin1":
        case "binary":
            return $d7746c2c27aed368$var$asciiWrite(this, string, offset, length);
        case "base64":
            // Warning: maxLength not taken into account in base64Write
            return $d7746c2c27aed368$var$base64Write(this, string, offset, length);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $d7746c2c27aed368$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
};
$d7746c2c27aed368$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: "Buffer",
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $d7746c2c27aed368$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $l4PI2.fromByteArray(buf);
    else return $l4PI2.fromByteArray(buf.slice(start, end));
}
function $d7746c2c27aed368$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    var res = [];
    var i = start;
    while(i < end){
        var firstByte = buf[i];
        var codePoint = null;
        var bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            var secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $d7746c2c27aed368$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var $d7746c2c27aed368$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $d7746c2c27aed368$var$decodeCodePointsArray(codePoints) {
    var len = codePoints.length;
    if (len <= $d7746c2c27aed368$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    var res = "";
    var i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $d7746c2c27aed368$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $d7746c2c27aed368$var$asciiSlice(buf, start, end) {
    var ret = "";
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $d7746c2c27aed368$var$latin1Slice(buf, start, end) {
    var ret = "";
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $d7746c2c27aed368$var$hexSlice(buf, start, end) {
    var len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    var out = "";
    for(var i = start; i < end; ++i)out += $d7746c2c27aed368$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $d7746c2c27aed368$var$utf16leSlice(buf, start, end) {
    var bytes = buf.slice(start, end);
    var res = "";
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(var i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$d7746c2c27aed368$var$Buffer.prototype.slice = function slice(start, end) {
    var len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    var newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $d7746c2c27aed368$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $d7746c2c27aed368$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError("offset is not uint");
    if (offset + ext > length) throw new RangeError("Trying to access beyond buffer length");
}
$d7746c2c27aed368$var$Buffer.prototype.readUintLE = $d7746c2c27aed368$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $d7746c2c27aed368$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$d7746c2c27aed368$var$Buffer.prototype.readUintBE = $d7746c2c27aed368$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $d7746c2c27aed368$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset + --byteLength];
    var mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$d7746c2c27aed368$var$Buffer.prototype.readUint8 = $d7746c2c27aed368$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d7746c2c27aed368$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$d7746c2c27aed368$var$Buffer.prototype.readUint16LE = $d7746c2c27aed368$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d7746c2c27aed368$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$d7746c2c27aed368$var$Buffer.prototype.readUint16BE = $d7746c2c27aed368$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d7746c2c27aed368$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$d7746c2c27aed368$var$Buffer.prototype.readUint32LE = $d7746c2c27aed368$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d7746c2c27aed368$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$d7746c2c27aed368$var$Buffer.prototype.readUint32BE = $d7746c2c27aed368$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d7746c2c27aed368$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$d7746c2c27aed368$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $d7746c2c27aed368$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$d7746c2c27aed368$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $d7746c2c27aed368$var$checkOffset(offset, byteLength, this.length);
    var i = byteLength;
    var mul = 1;
    var val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$d7746c2c27aed368$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d7746c2c27aed368$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$d7746c2c27aed368$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d7746c2c27aed368$var$checkOffset(offset, 2, this.length);
    var val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$d7746c2c27aed368$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d7746c2c27aed368$var$checkOffset(offset, 2, this.length);
    var val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$d7746c2c27aed368$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d7746c2c27aed368$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$d7746c2c27aed368$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d7746c2c27aed368$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$d7746c2c27aed368$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d7746c2c27aed368$var$checkOffset(offset, 4, this.length);
    return $9BUzF.read(this, offset, true, 23, 4);
};
$d7746c2c27aed368$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d7746c2c27aed368$var$checkOffset(offset, 4, this.length);
    return $9BUzF.read(this, offset, false, 23, 4);
};
$d7746c2c27aed368$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d7746c2c27aed368$var$checkOffset(offset, 8, this.length);
    return $9BUzF.read(this, offset, true, 52, 8);
};
$d7746c2c27aed368$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d7746c2c27aed368$var$checkOffset(offset, 8, this.length);
    return $9BUzF.read(this, offset, false, 52, 8);
};
function $d7746c2c27aed368$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$d7746c2c27aed368$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
}
$d7746c2c27aed368$var$Buffer.prototype.writeUintLE = $d7746c2c27aed368$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $d7746c2c27aed368$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var mul = 1;
    var i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$d7746c2c27aed368$var$Buffer.prototype.writeUintBE = $d7746c2c27aed368$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $d7746c2c27aed368$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var i = byteLength - 1;
    var mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$d7746c2c27aed368$var$Buffer.prototype.writeUint8 = $d7746c2c27aed368$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d7746c2c27aed368$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$d7746c2c27aed368$var$Buffer.prototype.writeUint16LE = $d7746c2c27aed368$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d7746c2c27aed368$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$d7746c2c27aed368$var$Buffer.prototype.writeUint16BE = $d7746c2c27aed368$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d7746c2c27aed368$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$d7746c2c27aed368$var$Buffer.prototype.writeUint32LE = $d7746c2c27aed368$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d7746c2c27aed368$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$d7746c2c27aed368$var$Buffer.prototype.writeUint32BE = $d7746c2c27aed368$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d7746c2c27aed368$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$d7746c2c27aed368$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $d7746c2c27aed368$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = 0;
    var mul = 1;
    var sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$d7746c2c27aed368$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $d7746c2c27aed368$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = byteLength - 1;
    var mul = 1;
    var sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$d7746c2c27aed368$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d7746c2c27aed368$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$d7746c2c27aed368$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d7746c2c27aed368$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$d7746c2c27aed368$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d7746c2c27aed368$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$d7746c2c27aed368$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d7746c2c27aed368$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$d7746c2c27aed368$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d7746c2c27aed368$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $d7746c2c27aed368$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
    if (offset < 0) throw new RangeError("Index out of range");
}
function $d7746c2c27aed368$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d7746c2c27aed368$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $9BUzF.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$d7746c2c27aed368$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $d7746c2c27aed368$var$writeFloat(this, value, offset, true, noAssert);
};
$d7746c2c27aed368$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $d7746c2c27aed368$var$writeFloat(this, value, offset, false, noAssert);
};
function $d7746c2c27aed368$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d7746c2c27aed368$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $9BUzF.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$d7746c2c27aed368$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $d7746c2c27aed368$var$writeDouble(this, value, offset, true, noAssert);
};
$d7746c2c27aed368$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $d7746c2c27aed368$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$d7746c2c27aed368$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$d7746c2c27aed368$var$Buffer.isBuffer(target)) throw new TypeError("argument should be a Buffer");
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError("targetStart out of bounds");
    if (start < 0 || start >= this.length) throw new RangeError("Index out of range");
    if (end < 0) throw new RangeError("sourceEnd out of bounds");
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    var len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === "function") // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$d7746c2c27aed368$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === "string") {
        if (typeof start === "string") {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === "string") {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== "string") throw new TypeError("encoding must be a string");
        if (typeof encoding === "string" && !$d7746c2c27aed368$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
        if (val.length === 1) {
            var code = val.charCodeAt(0);
            if (encoding === "utf8" && code < 128 || encoding === "latin1") // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === "number") val = val & 255;
    else if (typeof val === "boolean") val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError("Out of range index");
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    var i;
    if (typeof val === "number") for(i = start; i < end; ++i)this[i] = val;
    else {
        var bytes = $d7746c2c27aed368$var$Buffer.isBuffer(val) ? val : $d7746c2c27aed368$var$Buffer.from(val, encoding);
        var len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// HELPER FUNCTIONS
// ================
var $d7746c2c27aed368$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $d7746c2c27aed368$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split("=")[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($d7746c2c27aed368$var$INVALID_BASE64_RE, "");
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return "";
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + "=";
    return str;
}
function $d7746c2c27aed368$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    var codePoint;
    var length = string.length;
    var leadSurrogate = null;
    var bytes = [];
    for(var i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error("Invalid code point");
    }
    return bytes;
}
function $d7746c2c27aed368$var$asciiToBytes(str) {
    var byteArray = [];
    for(var i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $d7746c2c27aed368$var$utf16leToBytes(str, units) {
    var c, hi, lo;
    var byteArray = [];
    for(var i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $d7746c2c27aed368$var$base64ToBytes(str) {
    return $l4PI2.toByteArray($d7746c2c27aed368$var$base64clean(str));
}
function $d7746c2c27aed368$var$blitBuffer(src, dst, offset, length) {
    for(var i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $d7746c2c27aed368$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $d7746c2c27aed368$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
var $d7746c2c27aed368$var$hexSliceLookupTable = function() {
    var alphabet = "0123456789abcdef";
    var table = new Array(256);
    for(var i = 0; i < 16; ++i){
        var i16 = i * 16;
        for(var j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();

});

parcelRequire.register("1VSGA", function(module, exports) {
"use strict";
function $168588ccbd65ea82$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $168588ccbd65ea82$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $168588ccbd65ea82$var$ownKeys(Object(source), !0).forEach(function(key) {
            $168588ccbd65ea82$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $168588ccbd65ea82$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $168588ccbd65ea82$var$_defineProperty(obj, key, value) {
    key = $168588ccbd65ea82$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $168588ccbd65ea82$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $168588ccbd65ea82$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $168588ccbd65ea82$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $168588ccbd65ea82$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $168588ccbd65ea82$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $168588ccbd65ea82$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $168588ccbd65ea82$var$_toPropertyKey(arg) {
    var key = $168588ccbd65ea82$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $168588ccbd65ea82$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}

var $iuRmA = parcelRequire("iuRmA");
var $168588ccbd65ea82$var$Buffer = $iuRmA.Buffer;

var $gR5sk = parcelRequire("gR5sk");
var $168588ccbd65ea82$var$inspect = $gR5sk.inspect;
var $168588ccbd65ea82$var$custom = $168588ccbd65ea82$var$inspect && $168588ccbd65ea82$var$inspect.custom || "inspect";
function $168588ccbd65ea82$var$copyBuffer(src, target, offset) {
    $168588ccbd65ea82$var$Buffer.prototype.copy.call(src, target, offset);
}
module.exports = /*#__PURE__*/ function() {
    function BufferList() {
        $168588ccbd65ea82$var$_classCallCheck(this, BufferList);
        this.head = null;
        this.tail = null;
        this.length = 0;
    }
    $168588ccbd65ea82$var$_createClass(BufferList, [
        {
            key: "push",
            value: function push(v) {
                var entry = {
                    data: v,
                    next: null
                };
                if (this.length > 0) this.tail.next = entry;
                else this.head = entry;
                this.tail = entry;
                ++this.length;
            }
        },
        {
            key: "unshift",
            value: function unshift(v) {
                var entry = {
                    data: v,
                    next: this.head
                };
                if (this.length === 0) this.tail = entry;
                this.head = entry;
                ++this.length;
            }
        },
        {
            key: "shift",
            value: function shift() {
                if (this.length === 0) return;
                var ret = this.head.data;
                if (this.length === 1) this.head = this.tail = null;
                else this.head = this.head.next;
                --this.length;
                return ret;
            }
        },
        {
            key: "clear",
            value: function clear() {
                this.head = this.tail = null;
                this.length = 0;
            }
        },
        {
            key: "join",
            value: function join(s) {
                if (this.length === 0) return "";
                var p = this.head;
                var ret = "" + p.data;
                while(p = p.next)ret += s + p.data;
                return ret;
            }
        },
        {
            key: "concat",
            value: function concat(n) {
                if (this.length === 0) return $168588ccbd65ea82$var$Buffer.alloc(0);
                var ret = $168588ccbd65ea82$var$Buffer.allocUnsafe(n >>> 0);
                var p = this.head;
                var i = 0;
                while(p){
                    $168588ccbd65ea82$var$copyBuffer(p.data, ret, i);
                    i += p.data.length;
                    p = p.next;
                }
                return ret;
            }
        },
        {
            key: "consume",
            value: function consume(n, hasStrings) {
                var ret;
                if (n < this.head.data.length) {
                    // `slice` is the same for buffers and strings.
                    ret = this.head.data.slice(0, n);
                    this.head.data = this.head.data.slice(n);
                } else if (n === this.head.data.length) // First chunk is a perfect match.
                ret = this.shift();
                else // Result spans more than one buffer.
                ret = hasStrings ? this._getString(n) : this._getBuffer(n);
                return ret;
            }
        },
        {
            key: "first",
            value: function first() {
                return this.head.data;
            }
        },
        {
            key: "_getString",
            value: function _getString(n) {
                var p = this.head;
                var c = 1;
                var ret = p.data;
                n -= ret.length;
                while(p = p.next){
                    var str = p.data;
                    var nb = n > str.length ? str.length : n;
                    if (nb === str.length) ret += str;
                    else ret += str.slice(0, n);
                    n -= nb;
                    if (n === 0) {
                        if (nb === str.length) {
                            ++c;
                            if (p.next) this.head = p.next;
                            else this.head = this.tail = null;
                        } else {
                            this.head = p;
                            p.data = str.slice(nb);
                        }
                        break;
                    }
                    ++c;
                }
                this.length -= c;
                return ret;
            }
        },
        {
            key: "_getBuffer",
            value: function _getBuffer(n) {
                var ret = $168588ccbd65ea82$var$Buffer.allocUnsafe(n);
                var p = this.head;
                var c = 1;
                p.data.copy(ret);
                n -= p.data.length;
                while(p = p.next){
                    var buf = p.data;
                    var nb = n > buf.length ? buf.length : n;
                    buf.copy(ret, ret.length - n, 0, nb);
                    n -= nb;
                    if (n === 0) {
                        if (nb === buf.length) {
                            ++c;
                            if (p.next) this.head = p.next;
                            else this.head = this.tail = null;
                        } else {
                            this.head = p;
                            p.data = buf.slice(nb);
                        }
                        break;
                    }
                    ++c;
                }
                this.length -= c;
                return ret;
            }
        },
        {
            key: $168588ccbd65ea82$var$custom,
            value: function value(_, options) {
                return $168588ccbd65ea82$var$inspect(this, $168588ccbd65ea82$var$_objectSpread($168588ccbd65ea82$var$_objectSpread({}, options), {}, {
                    // Only inspect one level.
                    depth: 0,
                    // It should not recurse.
                    customInspect: false
                }));
            }
        }
    ]);
    return BufferList;
}();

});

parcelRequire.register("7vKbY", function(module, exports) {

var $hIXGI = parcelRequire("hIXGI");
"use strict";
// undocumented cb() API, needed for core, not for public API
function $577f426e26782ace$var$destroy(err, cb) {
    var _this = this;
    var readableDestroyed = this._readableState && this._readableState.destroyed;
    var writableDestroyed = this._writableState && this._writableState.destroyed;
    if (readableDestroyed || writableDestroyed) {
        if (cb) cb(err);
        else if (err) {
            if (!this._writableState) $hIXGI.nextTick($577f426e26782ace$var$emitErrorNT, this, err);
            else if (!this._writableState.errorEmitted) {
                this._writableState.errorEmitted = true;
                $hIXGI.nextTick($577f426e26782ace$var$emitErrorNT, this, err);
            }
        }
        return this;
    }
    // we set destroyed to true before firing error callbacks in order
    // to make it re-entrance safe in case destroy() is called within callbacks
    if (this._readableState) this._readableState.destroyed = true;
    // if this is a duplex stream mark the writable part as destroyed as well
    if (this._writableState) this._writableState.destroyed = true;
    this._destroy(err || null, function(err) {
        if (!cb && err) {
            if (!_this._writableState) $hIXGI.nextTick($577f426e26782ace$var$emitErrorAndCloseNT, _this, err);
            else if (!_this._writableState.errorEmitted) {
                _this._writableState.errorEmitted = true;
                $hIXGI.nextTick($577f426e26782ace$var$emitErrorAndCloseNT, _this, err);
            } else $hIXGI.nextTick($577f426e26782ace$var$emitCloseNT, _this);
        } else if (cb) {
            $hIXGI.nextTick($577f426e26782ace$var$emitCloseNT, _this);
            cb(err);
        } else $hIXGI.nextTick($577f426e26782ace$var$emitCloseNT, _this);
    });
    return this;
}
function $577f426e26782ace$var$emitErrorAndCloseNT(self, err) {
    $577f426e26782ace$var$emitErrorNT(self, err);
    $577f426e26782ace$var$emitCloseNT(self);
}
function $577f426e26782ace$var$emitCloseNT(self) {
    if (self._writableState && !self._writableState.emitClose) return;
    if (self._readableState && !self._readableState.emitClose) return;
    self.emit("close");
}
function $577f426e26782ace$var$undestroy() {
    if (this._readableState) {
        this._readableState.destroyed = false;
        this._readableState.reading = false;
        this._readableState.ended = false;
        this._readableState.endEmitted = false;
    }
    if (this._writableState) {
        this._writableState.destroyed = false;
        this._writableState.ended = false;
        this._writableState.ending = false;
        this._writableState.finalCalled = false;
        this._writableState.prefinished = false;
        this._writableState.finished = false;
        this._writableState.errorEmitted = false;
    }
}
function $577f426e26782ace$var$emitErrorNT(self, err) {
    self.emit("error", err);
}
function $577f426e26782ace$var$errorOrDestroy(stream, err) {
    // We have tests that rely on errors being emitted
    // in the same tick, so changing this is semver major.
    // For now when you opt-in to autoDestroy we allow
    // the error to be emitted nextTick. In a future
    // semver major update we should change the default to this.
    var rState = stream._readableState;
    var wState = stream._writableState;
    if (rState && rState.autoDestroy || wState && wState.autoDestroy) stream.destroy(err);
    else stream.emit("error", err);
}
module.exports = {
    destroy: $577f426e26782ace$var$destroy,
    undestroy: $577f426e26782ace$var$undestroy,
    errorOrDestroy: $577f426e26782ace$var$errorOrDestroy
};

});

parcelRequire.register("7S7pQ", function(module, exports) {
"use strict";

var $jqb3Z = parcelRequire("jqb3Z");
var $5bb35429c8f6ff3f$var$ERR_INVALID_OPT_VALUE = $jqb3Z.codes.ERR_INVALID_OPT_VALUE;
function $5bb35429c8f6ff3f$var$highWaterMarkFrom(options, isDuplex, duplexKey) {
    return options.highWaterMark != null ? options.highWaterMark : isDuplex ? options[duplexKey] : null;
}
function $5bb35429c8f6ff3f$var$getHighWaterMark(state, options, duplexKey, isDuplex) {
    var hwm = $5bb35429c8f6ff3f$var$highWaterMarkFrom(options, isDuplex, duplexKey);
    if (hwm != null) {
        if (!(isFinite(hwm) && Math.floor(hwm) === hwm) || hwm < 0) {
            var name = isDuplex ? duplexKey : "highWaterMark";
            throw new $5bb35429c8f6ff3f$var$ERR_INVALID_OPT_VALUE(name, hwm);
        }
        return Math.floor(hwm);
    }
    // Default value
    return state.objectMode ? 16 : 16384;
}
module.exports = {
    getHighWaterMark: $5bb35429c8f6ff3f$var$getHighWaterMark
};

});
parcelRequire.register("jqb3Z", function(module, exports) {

$parcel$export(module.exports, "codes", () => $e23906fdf36eec50$export$e45cb6485273080e, (v) => $e23906fdf36eec50$export$e45cb6485273080e = v);
var $e23906fdf36eec50$export$e45cb6485273080e;
"use strict";
function $e23906fdf36eec50$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
var $e23906fdf36eec50$var$codes = {};
function $e23906fdf36eec50$var$createErrorType(code, message, Base) {
    if (!Base) Base = Error;
    function getMessage(arg1, arg2, arg3) {
        if (typeof message === "string") return message;
        else return message(arg1, arg2, arg3);
    }
    var NodeError = /*#__PURE__*/ function(_Base) {
        $e23906fdf36eec50$var$_inheritsLoose(NodeError, _Base);
        function NodeError(arg1, arg2, arg3) {
            return _Base.call(this, getMessage(arg1, arg2, arg3)) || this;
        }
        return NodeError;
    }(Base);
    NodeError.prototype.name = Base.name;
    NodeError.prototype.code = code;
    $e23906fdf36eec50$var$codes[code] = NodeError;
} // https://github.com/nodejs/node/blob/v10.8.0/lib/internal/errors.js
function $e23906fdf36eec50$var$oneOf(expected, thing) {
    if (Array.isArray(expected)) {
        var len = expected.length;
        expected = expected.map(function(i) {
            return String(i);
        });
        if (len > 2) return "one of ".concat(thing, " ").concat(expected.slice(0, len - 1).join(", "), ", or ") + expected[len - 1];
        else if (len === 2) return "one of ".concat(thing, " ").concat(expected[0], " or ").concat(expected[1]);
        else return "of ".concat(thing, " ").concat(expected[0]);
    } else return "of ".concat(thing, " ").concat(String(expected));
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/startsWith
function $e23906fdf36eec50$var$startsWith(str, search, pos) {
    return str.substr(!pos || pos < 0 ? 0 : +pos, search.length) === search;
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/endsWith
function $e23906fdf36eec50$var$endsWith(str, search, this_len) {
    if (this_len === undefined || this_len > str.length) this_len = str.length;
    return str.substring(this_len - search.length, this_len) === search;
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/includes
function $e23906fdf36eec50$var$includes(str, search, start) {
    if (typeof start !== "number") start = 0;
    if (start + search.length > str.length) return false;
    else return str.indexOf(search, start) !== -1;
}
$e23906fdf36eec50$var$createErrorType("ERR_INVALID_OPT_VALUE", function(name, value) {
    return 'The value "' + value + '" is invalid for option "' + name + '"';
}, TypeError);
$e23906fdf36eec50$var$createErrorType("ERR_INVALID_ARG_TYPE", function(name, expected, actual) {
    // determiner: 'must be' or 'must not be'
    var determiner;
    if (typeof expected === "string" && $e23906fdf36eec50$var$startsWith(expected, "not ")) {
        determiner = "must not be";
        expected = expected.replace(/^not /, "");
    } else determiner = "must be";
    var msg;
    if ($e23906fdf36eec50$var$endsWith(name, " argument")) // For cases like 'first argument'
    msg = "The ".concat(name, " ").concat(determiner, " ").concat($e23906fdf36eec50$var$oneOf(expected, "type"));
    else {
        var type = $e23906fdf36eec50$var$includes(name, ".") ? "property" : "argument";
        msg = 'The "'.concat(name, '" ').concat(type, " ").concat(determiner, " ").concat($e23906fdf36eec50$var$oneOf(expected, "type"));
    }
    msg += ". Received type ".concat(typeof actual);
    return msg;
}, TypeError);
$e23906fdf36eec50$var$createErrorType("ERR_STREAM_PUSH_AFTER_EOF", "stream.push() after EOF");
$e23906fdf36eec50$var$createErrorType("ERR_METHOD_NOT_IMPLEMENTED", function(name) {
    return "The " + name + " method is not implemented";
});
$e23906fdf36eec50$var$createErrorType("ERR_STREAM_PREMATURE_CLOSE", "Premature close");
$e23906fdf36eec50$var$createErrorType("ERR_STREAM_DESTROYED", function(name) {
    return "Cannot call " + name + " after a stream was destroyed";
});
$e23906fdf36eec50$var$createErrorType("ERR_MULTIPLE_CALLBACK", "Callback called multiple times");
$e23906fdf36eec50$var$createErrorType("ERR_STREAM_CANNOT_PIPE", "Cannot pipe, not readable");
$e23906fdf36eec50$var$createErrorType("ERR_STREAM_WRITE_AFTER_END", "write after end");
$e23906fdf36eec50$var$createErrorType("ERR_STREAM_NULL_VALUES", "May not write null values to stream", TypeError);
$e23906fdf36eec50$var$createErrorType("ERR_UNKNOWN_ENCODING", function(arg) {
    return "Unknown encoding: " + arg;
}, TypeError);
$e23906fdf36eec50$var$createErrorType("ERR_STREAM_UNSHIFT_AFTER_END_EVENT", "stream.unshift() after end event");
$e23906fdf36eec50$export$e45cb6485273080e = $e23906fdf36eec50$var$codes;

});


parcelRequire.register("cMizL", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a duplex stream is just a stream that is both readable and writable.
// Since JS doesn't have multiple prototypal inheritance, this class
// prototypally inherits from Readable, and then parasitically from
// Writable.

var $hIXGI = parcelRequire("hIXGI");
"use strict";
/*<replacement>*/ var $94d8607b97bd3b0b$var$objectKeys = Object.keys || function(obj) {
    var keys = [];
    for(var key in obj)keys.push(key);
    return keys;
};
/*</replacement>*/ module.exports = $94d8607b97bd3b0b$var$Duplex;

var $hoMkK = parcelRequire("hoMkK");

var $h31UB = parcelRequire("h31UB");

(parcelRequire("5SAkX"))($94d8607b97bd3b0b$var$Duplex, $hoMkK);
// Allow the keys array to be GC'ed.
var $94d8607b97bd3b0b$var$keys = $94d8607b97bd3b0b$var$objectKeys($h31UB.prototype);
for(var $94d8607b97bd3b0b$var$v = 0; $94d8607b97bd3b0b$var$v < $94d8607b97bd3b0b$var$keys.length; $94d8607b97bd3b0b$var$v++){
    var $94d8607b97bd3b0b$var$method = $94d8607b97bd3b0b$var$keys[$94d8607b97bd3b0b$var$v];
    if (!$94d8607b97bd3b0b$var$Duplex.prototype[$94d8607b97bd3b0b$var$method]) $94d8607b97bd3b0b$var$Duplex.prototype[$94d8607b97bd3b0b$var$method] = $h31UB.prototype[$94d8607b97bd3b0b$var$method];
}
function $94d8607b97bd3b0b$var$Duplex(options) {
    if (!(this instanceof $94d8607b97bd3b0b$var$Duplex)) return new $94d8607b97bd3b0b$var$Duplex(options);
    $hoMkK.call(this, options);
    $h31UB.call(this, options);
    this.allowHalfOpen = true;
    if (options) {
        if (options.readable === false) this.readable = false;
        if (options.writable === false) this.writable = false;
        if (options.allowHalfOpen === false) {
            this.allowHalfOpen = false;
            this.once("end", $94d8607b97bd3b0b$var$onend);
        }
    }
}
Object.defineProperty($94d8607b97bd3b0b$var$Duplex.prototype, "writableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.highWaterMark;
    }
});
Object.defineProperty($94d8607b97bd3b0b$var$Duplex.prototype, "writableBuffer", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState && this._writableState.getBuffer();
    }
});
Object.defineProperty($94d8607b97bd3b0b$var$Duplex.prototype, "writableLength", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.length;
    }
});
// the no-half-open enforcer
function $94d8607b97bd3b0b$var$onend() {
    // If the writable side ended, then we're ok.
    if (this._writableState.ended) return;
    // no more data can be written.
    // But allow more writes to happen in this tick.
    $hIXGI.nextTick($94d8607b97bd3b0b$var$onEndNT, this);
}
function $94d8607b97bd3b0b$var$onEndNT(self) {
    self.end();
}
Object.defineProperty($94d8607b97bd3b0b$var$Duplex.prototype, "destroyed", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        if (this._readableState === undefined || this._writableState === undefined) return false;
        return this._readableState.destroyed && this._writableState.destroyed;
    },
    set: function set(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (this._readableState === undefined || this._writableState === undefined) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._readableState.destroyed = value;
        this._writableState.destroyed = value;
    }
});

});
parcelRequire.register("h31UB", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// A bit simpler than readable streams.
// Implement an async ._write(chunk, encoding, cb), and it'll handle all
// the drain event emission and buffering.

var $hIXGI = parcelRequire("hIXGI");
"use strict";
module.exports = $c694332331ce94e8$var$Writable;
/* <replacement> */ function $c694332331ce94e8$var$WriteReq(chunk, encoding, cb) {
    this.chunk = chunk;
    this.encoding = encoding;
    this.callback = cb;
    this.next = null;
}
// It seems a linked list but it is not
// there will be only 2 of these for each stream
function $c694332331ce94e8$var$CorkedRequest(state) {
    var _this = this;
    this.next = null;
    this.entry = null;
    this.finish = function() {
        $c694332331ce94e8$var$onCorkedFinish(_this, state);
    };
}
/* </replacement> */ /*<replacement>*/ var $c694332331ce94e8$var$Duplex;
/*</replacement>*/ $c694332331ce94e8$var$Writable.WritableState = $c694332331ce94e8$var$WritableState;

/*<replacement>*/ var $c694332331ce94e8$var$internalUtil = {
    deprecate: (parcelRequire("1nbMz"))
};

var $67rTV = parcelRequire("67rTV");

var $iuRmA = parcelRequire("iuRmA");
var $c694332331ce94e8$require$Buffer = $iuRmA.Buffer;
var $c694332331ce94e8$var$OurUint8Array = (typeof $parcel$global !== "undefined" ? $parcel$global : typeof window !== "undefined" ? window : typeof self !== "undefined" ? self : {}).Uint8Array || function() {};
function $c694332331ce94e8$var$_uint8ArrayToBuffer(chunk) {
    return $c694332331ce94e8$require$Buffer.from(chunk);
}
function $c694332331ce94e8$var$_isUint8Array(obj) {
    return $c694332331ce94e8$require$Buffer.isBuffer(obj) || obj instanceof $c694332331ce94e8$var$OurUint8Array;
}

var $7vKbY = parcelRequire("7vKbY");

var $7S7pQ = parcelRequire("7S7pQ");
var $c694332331ce94e8$var$getHighWaterMark = $7S7pQ.getHighWaterMark;

var $jqb3Z = parcelRequire("jqb3Z");
var $c694332331ce94e8$require$_require$codes = $jqb3Z.codes;
var $c694332331ce94e8$var$ERR_INVALID_ARG_TYPE = $c694332331ce94e8$require$_require$codes.ERR_INVALID_ARG_TYPE, $c694332331ce94e8$var$ERR_METHOD_NOT_IMPLEMENTED = $c694332331ce94e8$require$_require$codes.ERR_METHOD_NOT_IMPLEMENTED, $c694332331ce94e8$var$ERR_MULTIPLE_CALLBACK = $c694332331ce94e8$require$_require$codes.ERR_MULTIPLE_CALLBACK, $c694332331ce94e8$var$ERR_STREAM_CANNOT_PIPE = $c694332331ce94e8$require$_require$codes.ERR_STREAM_CANNOT_PIPE, $c694332331ce94e8$var$ERR_STREAM_DESTROYED = $c694332331ce94e8$require$_require$codes.ERR_STREAM_DESTROYED, $c694332331ce94e8$var$ERR_STREAM_NULL_VALUES = $c694332331ce94e8$require$_require$codes.ERR_STREAM_NULL_VALUES, $c694332331ce94e8$var$ERR_STREAM_WRITE_AFTER_END = $c694332331ce94e8$require$_require$codes.ERR_STREAM_WRITE_AFTER_END, $c694332331ce94e8$var$ERR_UNKNOWN_ENCODING = $c694332331ce94e8$require$_require$codes.ERR_UNKNOWN_ENCODING;
var $c694332331ce94e8$var$errorOrDestroy = $7vKbY.errorOrDestroy;

(parcelRequire("5SAkX"))($c694332331ce94e8$var$Writable, $67rTV);
function $c694332331ce94e8$var$nop() {}

function $c694332331ce94e8$var$WritableState(options, stream, isDuplex) {
    $c694332331ce94e8$var$Duplex = $c694332331ce94e8$var$Duplex || (parcelRequire("cMizL"));
    options = options || {};
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream,
    // e.g. options.readableObjectMode vs. options.writableObjectMode, etc.
    if (typeof isDuplex !== "boolean") isDuplex = stream instanceof $c694332331ce94e8$var$Duplex;
    // object stream flag to indicate whether or not this stream
    // contains buffers or objects.
    this.objectMode = !!options.objectMode;
    if (isDuplex) this.objectMode = this.objectMode || !!options.writableObjectMode;
    // the point at which write() starts returning false
    // Note: 0 is a valid value, means that we always return false if
    // the entire buffer is not flushed immediately on write()
    this.highWaterMark = $c694332331ce94e8$var$getHighWaterMark(this, options, "writableHighWaterMark", isDuplex);
    // if _final has been called
    this.finalCalled = false;
    // drain event flag.
    this.needDrain = false;
    // at the start of calling end()
    this.ending = false;
    // when end() has been called, and returned
    this.ended = false;
    // when 'finish' is emitted
    this.finished = false;
    // has it been destroyed
    this.destroyed = false;
    // should we decode strings into buffers before passing to _write?
    // this is here so that some node-core streams can optimize string
    // handling at a lower level.
    var noDecode = options.decodeStrings === false;
    this.decodeStrings = !noDecode;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options.defaultEncoding || "utf8";
    // not an actual buffer we keep track of, but a measurement
    // of how much we're waiting to get pushed to some underlying
    // socket or file.
    this.length = 0;
    // a flag to see when we're in the middle of a write.
    this.writing = false;
    // when true all writes will be buffered until .uncork() call
    this.corked = 0;
    // a flag to be able to tell if the onwrite cb is called immediately,
    // or on a later tick.  We set this to true at first, because any
    // actions that shouldn't happen until "later" should generally also
    // not happen before the first write call.
    this.sync = true;
    // a flag to know if we're processing previously buffered items, which
    // may call the _write() callback in the same tick, so that we don't
    // end up in an overlapped onwrite situation.
    this.bufferProcessing = false;
    // the callback that's passed to _write(chunk,cb)
    this.onwrite = function(er) {
        $c694332331ce94e8$var$onwrite(stream, er);
    };
    // the callback that the user supplies to write(chunk,encoding,cb)
    this.writecb = null;
    // the amount that is being written when _write is called.
    this.writelen = 0;
    this.bufferedRequest = null;
    this.lastBufferedRequest = null;
    // number of pending user-supplied write callbacks
    // this must be 0 before 'finish' can be emitted
    this.pendingcb = 0;
    // emit prefinish if the only thing we're waiting for is _write cbs
    // This is relevant for synchronous Transform streams
    this.prefinished = false;
    // True if the error was already emitted and should not be thrown again
    this.errorEmitted = false;
    // Should close be emitted on destroy. Defaults to true.
    this.emitClose = options.emitClose !== false;
    // Should .destroy() be called after 'finish' (and potentially 'end')
    this.autoDestroy = !!options.autoDestroy;
    // count buffered requests
    this.bufferedRequestCount = 0;
    // allocate the first CorkedRequest, there is always
    // one allocated and free to use, and we maintain at most two
    this.corkedRequestsFree = new $c694332331ce94e8$var$CorkedRequest(this);
}
$c694332331ce94e8$var$WritableState.prototype.getBuffer = function getBuffer() {
    var current = this.bufferedRequest;
    var out = [];
    while(current){
        out.push(current);
        current = current.next;
    }
    return out;
};
(function() {
    try {
        Object.defineProperty($c694332331ce94e8$var$WritableState.prototype, "buffer", {
            get: $c694332331ce94e8$var$internalUtil.deprecate(function writableStateBufferGetter() {
                return this.getBuffer();
            }, "_writableState.buffer is deprecated. Use _writableState.getBuffer instead.", "DEP0003")
        });
    } catch (_) {}
})();
// Test _writableState for inheritance to account for Duplex streams,
// whose prototype chain only points to Readable.
var $c694332331ce94e8$var$realHasInstance;
if (typeof Symbol === "function" && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] === "function") {
    $c694332331ce94e8$var$realHasInstance = Function.prototype[Symbol.hasInstance];
    Object.defineProperty($c694332331ce94e8$var$Writable, Symbol.hasInstance, {
        value: function value(object) {
            if ($c694332331ce94e8$var$realHasInstance.call(this, object)) return true;
            if (this !== $c694332331ce94e8$var$Writable) return false;
            return object && object._writableState instanceof $c694332331ce94e8$var$WritableState;
        }
    });
} else $c694332331ce94e8$var$realHasInstance = function realHasInstance(object) {
    return object instanceof this;
};

function $c694332331ce94e8$var$Writable(options) {
    $c694332331ce94e8$var$Duplex = $c694332331ce94e8$var$Duplex || (parcelRequire("cMizL"));
    // Writable ctor is applied to Duplexes, too.
    // `realHasInstance` is necessary because using plain `instanceof`
    // would return false, as no `_writableState` property is attached.
    // Trying to use the custom `instanceof` for Writable here will also break the
    // Node.js LazyTransform implementation, which has a non-trivial getter for
    // `_writableState` that would lead to infinite recursion.
    // Checking for a Stream.Duplex instance is faster here instead of inside
    // the WritableState constructor, at least with V8 6.5
    var isDuplex = this instanceof $c694332331ce94e8$var$Duplex;
    if (!isDuplex && !$c694332331ce94e8$var$realHasInstance.call($c694332331ce94e8$var$Writable, this)) return new $c694332331ce94e8$var$Writable(options);
    this._writableState = new $c694332331ce94e8$var$WritableState(options, this, isDuplex);
    // legacy.
    this.writable = true;
    if (options) {
        if (typeof options.write === "function") this._write = options.write;
        if (typeof options.writev === "function") this._writev = options.writev;
        if (typeof options.destroy === "function") this._destroy = options.destroy;
        if (typeof options.final === "function") this._final = options.final;
    }
    $67rTV.call(this);
}
// Otherwise people can pipe Writable streams, which is just wrong.
$c694332331ce94e8$var$Writable.prototype.pipe = function() {
    $c694332331ce94e8$var$errorOrDestroy(this, new $c694332331ce94e8$var$ERR_STREAM_CANNOT_PIPE());
};
function $c694332331ce94e8$var$writeAfterEnd(stream, cb) {
    var er = new $c694332331ce94e8$var$ERR_STREAM_WRITE_AFTER_END();
    // TODO: defer error events consistently everywhere, not just the cb
    $c694332331ce94e8$var$errorOrDestroy(stream, er);
    $hIXGI.nextTick(cb, er);
}
// Checks that a user-supplied chunk is valid, especially for the particular
// mode the stream is in. Currently this means that `null` is never accepted
// and undefined/non-string values are only allowed in object mode.
function $c694332331ce94e8$var$validChunk(stream, state, chunk, cb) {
    var er;
    if (chunk === null) er = new $c694332331ce94e8$var$ERR_STREAM_NULL_VALUES();
    else if (typeof chunk !== "string" && !state.objectMode) er = new $c694332331ce94e8$var$ERR_INVALID_ARG_TYPE("chunk", [
        "string",
        "Buffer"
    ], chunk);
    if (er) {
        $c694332331ce94e8$var$errorOrDestroy(stream, er);
        $hIXGI.nextTick(cb, er);
        return false;
    }
    return true;
}
$c694332331ce94e8$var$Writable.prototype.write = function(chunk, encoding, cb) {
    var state = this._writableState;
    var ret = false;
    var isBuf = !state.objectMode && $c694332331ce94e8$var$_isUint8Array(chunk);
    if (isBuf && !$c694332331ce94e8$require$Buffer.isBuffer(chunk)) chunk = $c694332331ce94e8$var$_uint8ArrayToBuffer(chunk);
    if (typeof encoding === "function") {
        cb = encoding;
        encoding = null;
    }
    if (isBuf) encoding = "buffer";
    else if (!encoding) encoding = state.defaultEncoding;
    if (typeof cb !== "function") cb = $c694332331ce94e8$var$nop;
    if (state.ending) $c694332331ce94e8$var$writeAfterEnd(this, cb);
    else if (isBuf || $c694332331ce94e8$var$validChunk(this, state, chunk, cb)) {
        state.pendingcb++;
        ret = $c694332331ce94e8$var$writeOrBuffer(this, state, isBuf, chunk, encoding, cb);
    }
    return ret;
};
$c694332331ce94e8$var$Writable.prototype.cork = function() {
    this._writableState.corked++;
};
$c694332331ce94e8$var$Writable.prototype.uncork = function() {
    var state = this._writableState;
    if (state.corked) {
        state.corked--;
        if (!state.writing && !state.corked && !state.bufferProcessing && state.bufferedRequest) $c694332331ce94e8$var$clearBuffer(this, state);
    }
};
$c694332331ce94e8$var$Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
    // node::ParseEncoding() requires lower case.
    if (typeof encoding === "string") encoding = encoding.toLowerCase();
    if (!([
        "hex",
        "utf8",
        "utf-8",
        "ascii",
        "binary",
        "base64",
        "ucs2",
        "ucs-2",
        "utf16le",
        "utf-16le",
        "raw"
    ].indexOf((encoding + "").toLowerCase()) > -1)) throw new $c694332331ce94e8$var$ERR_UNKNOWN_ENCODING(encoding);
    this._writableState.defaultEncoding = encoding;
    return this;
};
Object.defineProperty($c694332331ce94e8$var$Writable.prototype, "writableBuffer", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState && this._writableState.getBuffer();
    }
});
function $c694332331ce94e8$var$decodeChunk(state, chunk, encoding) {
    if (!state.objectMode && state.decodeStrings !== false && typeof chunk === "string") chunk = $c694332331ce94e8$require$Buffer.from(chunk, encoding);
    return chunk;
}
Object.defineProperty($c694332331ce94e8$var$Writable.prototype, "writableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.highWaterMark;
    }
});
// if we're already writing something, then just put this
// in the queue, and wait our turn.  Otherwise, call _write
// If we return false, then we need a drain event, so set that flag.
function $c694332331ce94e8$var$writeOrBuffer(stream, state, isBuf, chunk, encoding, cb) {
    if (!isBuf) {
        var newChunk = $c694332331ce94e8$var$decodeChunk(state, chunk, encoding);
        if (chunk !== newChunk) {
            isBuf = true;
            encoding = "buffer";
            chunk = newChunk;
        }
    }
    var len = state.objectMode ? 1 : chunk.length;
    state.length += len;
    var ret = state.length < state.highWaterMark;
    // we must ensure that previous needDrain will not be reset to false.
    if (!ret) state.needDrain = true;
    if (state.writing || state.corked) {
        var last = state.lastBufferedRequest;
        state.lastBufferedRequest = {
            chunk: chunk,
            encoding: encoding,
            isBuf: isBuf,
            callback: cb,
            next: null
        };
        if (last) last.next = state.lastBufferedRequest;
        else state.bufferedRequest = state.lastBufferedRequest;
        state.bufferedRequestCount += 1;
    } else $c694332331ce94e8$var$doWrite(stream, state, false, len, chunk, encoding, cb);
    return ret;
}
function $c694332331ce94e8$var$doWrite(stream, state, writev, len, chunk, encoding, cb) {
    state.writelen = len;
    state.writecb = cb;
    state.writing = true;
    state.sync = true;
    if (state.destroyed) state.onwrite(new $c694332331ce94e8$var$ERR_STREAM_DESTROYED("write"));
    else if (writev) stream._writev(chunk, state.onwrite);
    else stream._write(chunk, encoding, state.onwrite);
    state.sync = false;
}
function $c694332331ce94e8$var$onwriteError(stream, state, sync, er, cb) {
    --state.pendingcb;
    if (sync) {
        // defer the callback if we are being called synchronously
        // to avoid piling up things on the stack
        $hIXGI.nextTick(cb, er);
        // this can emit finish, and it will always happen
        // after error
        $hIXGI.nextTick($c694332331ce94e8$var$finishMaybe, stream, state);
        stream._writableState.errorEmitted = true;
        $c694332331ce94e8$var$errorOrDestroy(stream, er);
    } else {
        // the caller expect this to happen before if
        // it is async
        cb(er);
        stream._writableState.errorEmitted = true;
        $c694332331ce94e8$var$errorOrDestroy(stream, er);
        // this can emit finish, but finish must
        // always follow error
        $c694332331ce94e8$var$finishMaybe(stream, state);
    }
}
function $c694332331ce94e8$var$onwriteStateUpdate(state) {
    state.writing = false;
    state.writecb = null;
    state.length -= state.writelen;
    state.writelen = 0;
}
function $c694332331ce94e8$var$onwrite(stream, er) {
    var state = stream._writableState;
    var sync = state.sync;
    var cb = state.writecb;
    if (typeof cb !== "function") throw new $c694332331ce94e8$var$ERR_MULTIPLE_CALLBACK();
    $c694332331ce94e8$var$onwriteStateUpdate(state);
    if (er) $c694332331ce94e8$var$onwriteError(stream, state, sync, er, cb);
    else {
        // Check if we're actually ready to finish, but don't emit yet
        var finished = $c694332331ce94e8$var$needFinish(state) || stream.destroyed;
        if (!finished && !state.corked && !state.bufferProcessing && state.bufferedRequest) $c694332331ce94e8$var$clearBuffer(stream, state);
        if (sync) $hIXGI.nextTick($c694332331ce94e8$var$afterWrite, stream, state, finished, cb);
        else $c694332331ce94e8$var$afterWrite(stream, state, finished, cb);
    }
}
function $c694332331ce94e8$var$afterWrite(stream, state, finished, cb) {
    if (!finished) $c694332331ce94e8$var$onwriteDrain(stream, state);
    state.pendingcb--;
    cb();
    $c694332331ce94e8$var$finishMaybe(stream, state);
}
// Must force callback to be called on nextTick, so that we don't
// emit 'drain' before the write() consumer gets the 'false' return
// value, and has a chance to attach a 'drain' listener.
function $c694332331ce94e8$var$onwriteDrain(stream, state) {
    if (state.length === 0 && state.needDrain) {
        state.needDrain = false;
        stream.emit("drain");
    }
}
// if there's something in the buffer waiting, then process it
function $c694332331ce94e8$var$clearBuffer(stream, state) {
    state.bufferProcessing = true;
    var entry = state.bufferedRequest;
    if (stream._writev && entry && entry.next) {
        // Fast case, write everything using _writev()
        var l = state.bufferedRequestCount;
        var buffer = new Array(l);
        var holder = state.corkedRequestsFree;
        holder.entry = entry;
        var count = 0;
        var allBuffers = true;
        while(entry){
            buffer[count] = entry;
            if (!entry.isBuf) allBuffers = false;
            entry = entry.next;
            count += 1;
        }
        buffer.allBuffers = allBuffers;
        $c694332331ce94e8$var$doWrite(stream, state, true, state.length, buffer, "", holder.finish);
        // doWrite is almost always async, defer these to save a bit of time
        // as the hot path ends with doWrite
        state.pendingcb++;
        state.lastBufferedRequest = null;
        if (holder.next) {
            state.corkedRequestsFree = holder.next;
            holder.next = null;
        } else state.corkedRequestsFree = new $c694332331ce94e8$var$CorkedRequest(state);
        state.bufferedRequestCount = 0;
    } else {
        // Slow case, write chunks one-by-one
        while(entry){
            var chunk = entry.chunk;
            var encoding = entry.encoding;
            var cb = entry.callback;
            var len = state.objectMode ? 1 : chunk.length;
            $c694332331ce94e8$var$doWrite(stream, state, false, len, chunk, encoding, cb);
            entry = entry.next;
            state.bufferedRequestCount--;
            // if we didn't call the onwrite immediately, then
            // it means that we need to wait until it does.
            // also, that means that the chunk and cb are currently
            // being processed, so move the buffer counter past them.
            if (state.writing) break;
        }
        if (entry === null) state.lastBufferedRequest = null;
    }
    state.bufferedRequest = entry;
    state.bufferProcessing = false;
}
$c694332331ce94e8$var$Writable.prototype._write = function(chunk, encoding, cb) {
    cb(new $c694332331ce94e8$var$ERR_METHOD_NOT_IMPLEMENTED("_write()"));
};
$c694332331ce94e8$var$Writable.prototype._writev = null;
$c694332331ce94e8$var$Writable.prototype.end = function(chunk, encoding, cb) {
    var state = this._writableState;
    if (typeof chunk === "function") {
        cb = chunk;
        chunk = null;
        encoding = null;
    } else if (typeof encoding === "function") {
        cb = encoding;
        encoding = null;
    }
    if (chunk !== null && chunk !== undefined) this.write(chunk, encoding);
    // .end() fully uncorks
    if (state.corked) {
        state.corked = 1;
        this.uncork();
    }
    // ignore unnecessary end() calls.
    if (!state.ending) $c694332331ce94e8$var$endWritable(this, state, cb);
    return this;
};
Object.defineProperty($c694332331ce94e8$var$Writable.prototype, "writableLength", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.length;
    }
});
function $c694332331ce94e8$var$needFinish(state) {
    return state.ending && state.length === 0 && state.bufferedRequest === null && !state.finished && !state.writing;
}
function $c694332331ce94e8$var$callFinal(stream, state) {
    stream._final(function(err) {
        state.pendingcb--;
        if (err) $c694332331ce94e8$var$errorOrDestroy(stream, err);
        state.prefinished = true;
        stream.emit("prefinish");
        $c694332331ce94e8$var$finishMaybe(stream, state);
    });
}
function $c694332331ce94e8$var$prefinish(stream, state) {
    if (!state.prefinished && !state.finalCalled) {
        if (typeof stream._final === "function" && !state.destroyed) {
            state.pendingcb++;
            state.finalCalled = true;
            $hIXGI.nextTick($c694332331ce94e8$var$callFinal, stream, state);
        } else {
            state.prefinished = true;
            stream.emit("prefinish");
        }
    }
}
function $c694332331ce94e8$var$finishMaybe(stream, state) {
    var need = $c694332331ce94e8$var$needFinish(state);
    if (need) {
        $c694332331ce94e8$var$prefinish(stream, state);
        if (state.pendingcb === 0) {
            state.finished = true;
            stream.emit("finish");
            if (state.autoDestroy) {
                // In case of duplex streams we need a way to detect
                // if the readable side is ready for autoDestroy as well
                var rState = stream._readableState;
                if (!rState || rState.autoDestroy && rState.endEmitted) stream.destroy();
            }
        }
    }
    return need;
}
function $c694332331ce94e8$var$endWritable(stream, state, cb) {
    state.ending = true;
    $c694332331ce94e8$var$finishMaybe(stream, state);
    if (cb) {
        if (state.finished) $hIXGI.nextTick(cb);
        else stream.once("finish", cb);
    }
    state.ended = true;
    stream.writable = false;
}
function $c694332331ce94e8$var$onCorkedFinish(corkReq, state, err) {
    var entry = corkReq.entry;
    corkReq.entry = null;
    while(entry){
        var cb = entry.callback;
        state.pendingcb--;
        cb(err);
        entry = entry.next;
    }
    // reuse the free corkReq.
    state.corkedRequestsFree.next = corkReq;
}
Object.defineProperty($c694332331ce94e8$var$Writable.prototype, "destroyed", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        if (this._writableState === undefined) return false;
        return this._writableState.destroyed;
    },
    set: function set(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (!this._writableState) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._writableState.destroyed = value;
    }
});
$c694332331ce94e8$var$Writable.prototype.destroy = $7vKbY.destroy;
$c694332331ce94e8$var$Writable.prototype._undestroy = $7vKbY.undestroy;
$c694332331ce94e8$var$Writable.prototype._destroy = function(err, cb) {
    cb(err);
};

});
parcelRequire.register("1nbMz", function(module, exports) {
/**
 * Module exports.
 */ module.exports = $1001142816154617$var$deprecate;
/**
 * Mark that a method should not be used.
 * Returns a modified function which warns once by default.
 *
 * If `localStorage.noDeprecation = true` is set, then it is a no-op.
 *
 * If `localStorage.throwDeprecation = true` is set, then deprecated functions
 * will throw an Error when invoked.
 *
 * If `localStorage.traceDeprecation = true` is set, then deprecated functions
 * will invoke `console.trace()` instead of `console.error()`.
 *
 * @param {Function} fn - the function to deprecate
 * @param {String} msg - the string to print to the console when `fn` is invoked
 * @returns {Function} a new "deprecated" version of `fn`
 * @api public
 */ function $1001142816154617$var$deprecate(fn, msg) {
    if ($1001142816154617$var$config("noDeprecation")) return fn;
    var warned = false;
    function deprecated() {
        if (!warned) {
            if ($1001142816154617$var$config("throwDeprecation")) throw new Error(msg);
            else if ($1001142816154617$var$config("traceDeprecation")) console.trace(msg);
            else console.warn(msg);
            warned = true;
        }
        return fn.apply(this, arguments);
    }
    return deprecated;
}
/**
 * Checks `localStorage` for boolean values for the given `name`.
 *
 * @param {String} name
 * @returns {Boolean}
 * @api private
 */ function $1001142816154617$var$config(name) {
    // accessing global.localStorage can trigger a DOMException in sandboxed iframes
    try {
        if (!$parcel$global.localStorage) return false;
    } catch (_) {
        return false;
    }
    var val = $parcel$global.localStorage[name];
    if (null == val) return false;
    return String(val).toLowerCase() === "true";
}

});



parcelRequire.register("d23j5", function(module, exports) {

$parcel$export(module.exports, "StringDecoder", () => $97ce06f09ba4eb15$export$63a7aa211a91ed69, (v) => $97ce06f09ba4eb15$export$63a7aa211a91ed69 = v);
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// StringDecoder provides an interface for efficiently splitting a series of
// buffers into a series of JS strings without breaking apart multi-byte
// characters.
var $97ce06f09ba4eb15$export$63a7aa211a91ed69;
"use strict";

var $dmB1T = parcelRequire("dmB1T");
var $97ce06f09ba4eb15$require$Buffer = $dmB1T.Buffer;
/*</replacement>*/ var $97ce06f09ba4eb15$var$isEncoding = $97ce06f09ba4eb15$require$Buffer.isEncoding || function(encoding) {
    encoding = "" + encoding;
    switch(encoding && encoding.toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
        case "raw":
            return true;
        default:
            return false;
    }
};
function $97ce06f09ba4eb15$var$_normalizeEncoding(enc) {
    if (!enc) return "utf8";
    var retried;
    while(true)switch(enc){
        case "utf8":
        case "utf-8":
            return "utf8";
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return "utf16le";
        case "latin1":
        case "binary":
            return "latin1";
        case "base64":
        case "ascii":
        case "hex":
            return enc;
        default:
            if (retried) return; // undefined
            enc = ("" + enc).toLowerCase();
            retried = true;
    }
}
// Do not cache `Buffer.isEncoding` when checking encoding names as some
// modules monkey-patch it to support additional encodings
function $97ce06f09ba4eb15$var$normalizeEncoding(enc) {
    var nenc = $97ce06f09ba4eb15$var$_normalizeEncoding(enc);
    if (typeof nenc !== "string" && ($97ce06f09ba4eb15$require$Buffer.isEncoding === $97ce06f09ba4eb15$var$isEncoding || !$97ce06f09ba4eb15$var$isEncoding(enc))) throw new Error("Unknown encoding: " + enc);
    return nenc || enc;
}
$97ce06f09ba4eb15$export$63a7aa211a91ed69 = $97ce06f09ba4eb15$var$StringDecoder;
function $97ce06f09ba4eb15$var$StringDecoder(encoding) {
    this.encoding = $97ce06f09ba4eb15$var$normalizeEncoding(encoding);
    var nb;
    switch(this.encoding){
        case "utf16le":
            this.text = $97ce06f09ba4eb15$var$utf16Text;
            this.end = $97ce06f09ba4eb15$var$utf16End;
            nb = 4;
            break;
        case "utf8":
            this.fillLast = $97ce06f09ba4eb15$var$utf8FillLast;
            nb = 4;
            break;
        case "base64":
            this.text = $97ce06f09ba4eb15$var$base64Text;
            this.end = $97ce06f09ba4eb15$var$base64End;
            nb = 3;
            break;
        default:
            this.write = $97ce06f09ba4eb15$var$simpleWrite;
            this.end = $97ce06f09ba4eb15$var$simpleEnd;
            return;
    }
    this.lastNeed = 0;
    this.lastTotal = 0;
    this.lastChar = $97ce06f09ba4eb15$require$Buffer.allocUnsafe(nb);
}
$97ce06f09ba4eb15$var$StringDecoder.prototype.write = function(buf) {
    if (buf.length === 0) return "";
    var r;
    var i;
    if (this.lastNeed) {
        r = this.fillLast(buf);
        if (r === undefined) return "";
        i = this.lastNeed;
        this.lastNeed = 0;
    } else i = 0;
    if (i < buf.length) return r ? r + this.text(buf, i) : this.text(buf, i);
    return r || "";
};
$97ce06f09ba4eb15$var$StringDecoder.prototype.end = $97ce06f09ba4eb15$var$utf8End;
// Returns only complete characters in a Buffer
$97ce06f09ba4eb15$var$StringDecoder.prototype.text = $97ce06f09ba4eb15$var$utf8Text;
// Attempts to complete a partial non-UTF-8 character using bytes from a Buffer
$97ce06f09ba4eb15$var$StringDecoder.prototype.fillLast = function(buf) {
    if (this.lastNeed <= buf.length) {
        buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed);
        return this.lastChar.toString(this.encoding, 0, this.lastTotal);
    }
    buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, buf.length);
    this.lastNeed -= buf.length;
};
// Checks the type of a UTF-8 byte, whether it's ASCII, a leading byte, or a
// continuation byte. If an invalid byte is detected, -2 is returned.
function $97ce06f09ba4eb15$var$utf8CheckByte(byte) {
    if (byte <= 0x7F) return 0;
    else if (byte >> 5 === 0x06) return 2;
    else if (byte >> 4 === 0x0E) return 3;
    else if (byte >> 3 === 0x1E) return 4;
    return byte >> 6 === 0x02 ? -1 : -2;
}
// Checks at most 3 bytes at the end of a Buffer in order to detect an
// incomplete multi-byte UTF-8 character. The total number of bytes (2, 3, or 4)
// needed to complete the UTF-8 character (if applicable) are returned.
function $97ce06f09ba4eb15$var$utf8CheckIncomplete(self, buf, i) {
    var j = buf.length - 1;
    if (j < i) return 0;
    var nb = $97ce06f09ba4eb15$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) self.lastNeed = nb - 1;
        return nb;
    }
    if (--j < i || nb === -2) return 0;
    nb = $97ce06f09ba4eb15$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) self.lastNeed = nb - 2;
        return nb;
    }
    if (--j < i || nb === -2) return 0;
    nb = $97ce06f09ba4eb15$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) {
            if (nb === 2) nb = 0;
            else self.lastNeed = nb - 3;
        }
        return nb;
    }
    return 0;
}
// Validates as many continuation bytes for a multi-byte UTF-8 character as
// needed or are available. If we see a non-continuation byte where we expect
// one, we "replace" the validated continuation bytes we've seen so far with
// a single UTF-8 replacement character ('\ufffd'), to match v8's UTF-8 decoding
// behavior. The continuation byte check is included three times in the case
// where all of the continuation bytes for a character exist in the same buffer.
// It is also done this way as a slight performance increase instead of using a
// loop.
function $97ce06f09ba4eb15$var$utf8CheckExtraBytes(self, buf, p) {
    if ((buf[0] & 0xC0) !== 0x80) {
        self.lastNeed = 0;
        return "�";
    }
    if (self.lastNeed > 1 && buf.length > 1) {
        if ((buf[1] & 0xC0) !== 0x80) {
            self.lastNeed = 1;
            return "�";
        }
        if (self.lastNeed > 2 && buf.length > 2) {
            if ((buf[2] & 0xC0) !== 0x80) {
                self.lastNeed = 2;
                return "�";
            }
        }
    }
}
// Attempts to complete a multi-byte UTF-8 character using bytes from a Buffer.
function $97ce06f09ba4eb15$var$utf8FillLast(buf) {
    var p = this.lastTotal - this.lastNeed;
    var r = $97ce06f09ba4eb15$var$utf8CheckExtraBytes(this, buf, p);
    if (r !== undefined) return r;
    if (this.lastNeed <= buf.length) {
        buf.copy(this.lastChar, p, 0, this.lastNeed);
        return this.lastChar.toString(this.encoding, 0, this.lastTotal);
    }
    buf.copy(this.lastChar, p, 0, buf.length);
    this.lastNeed -= buf.length;
}
// Returns all complete UTF-8 characters in a Buffer. If the Buffer ended on a
// partial character, the character's bytes are buffered until the required
// number of bytes are available.
function $97ce06f09ba4eb15$var$utf8Text(buf, i) {
    var total = $97ce06f09ba4eb15$var$utf8CheckIncomplete(this, buf, i);
    if (!this.lastNeed) return buf.toString("utf8", i);
    this.lastTotal = total;
    var end = buf.length - (total - this.lastNeed);
    buf.copy(this.lastChar, 0, end);
    return buf.toString("utf8", i, end);
}
// For UTF-8, a replacement character is added when ending on a partial
// character.
function $97ce06f09ba4eb15$var$utf8End(buf) {
    var r = buf && buf.length ? this.write(buf) : "";
    if (this.lastNeed) return r + "�";
    return r;
}
// UTF-16LE typically needs two bytes per character, but even if we have an even
// number of bytes available, we need to check if we end on a leading/high
// surrogate. In that case, we need to wait for the next two bytes in order to
// decode the last character properly.
function $97ce06f09ba4eb15$var$utf16Text(buf, i) {
    if ((buf.length - i) % 2 === 0) {
        var r = buf.toString("utf16le", i);
        if (r) {
            var c = r.charCodeAt(r.length - 1);
            if (c >= 0xD800 && c <= 0xDBFF) {
                this.lastNeed = 2;
                this.lastTotal = 4;
                this.lastChar[0] = buf[buf.length - 2];
                this.lastChar[1] = buf[buf.length - 1];
                return r.slice(0, -1);
            }
        }
        return r;
    }
    this.lastNeed = 1;
    this.lastTotal = 2;
    this.lastChar[0] = buf[buf.length - 1];
    return buf.toString("utf16le", i, buf.length - 1);
}
// For UTF-16LE we do not explicitly append special replacement characters if we
// end on a partial character, we simply let v8 handle that.
function $97ce06f09ba4eb15$var$utf16End(buf) {
    var r = buf && buf.length ? this.write(buf) : "";
    if (this.lastNeed) {
        var end = this.lastTotal - this.lastNeed;
        return r + this.lastChar.toString("utf16le", 0, end);
    }
    return r;
}
function $97ce06f09ba4eb15$var$base64Text(buf, i) {
    var n = (buf.length - i) % 3;
    if (n === 0) return buf.toString("base64", i);
    this.lastNeed = 3 - n;
    this.lastTotal = 3;
    if (n === 1) this.lastChar[0] = buf[buf.length - 1];
    else {
        this.lastChar[0] = buf[buf.length - 2];
        this.lastChar[1] = buf[buf.length - 1];
    }
    return buf.toString("base64", i, buf.length - n);
}
function $97ce06f09ba4eb15$var$base64End(buf) {
    var r = buf && buf.length ? this.write(buf) : "";
    if (this.lastNeed) return r + this.lastChar.toString("base64", 0, 3 - this.lastNeed);
    return r;
}
// Pass bytes on through for single-byte encodings (e.g. ascii, latin1, hex)
function $97ce06f09ba4eb15$var$simpleWrite(buf) {
    return buf.toString(this.encoding);
}
function $97ce06f09ba4eb15$var$simpleEnd(buf) {
    return buf && buf.length ? this.write(buf) : "";
}

});
parcelRequire.register("dmB1T", function(module, exports) {
/*! safe-buffer. MIT License. Feross Aboukhadijeh <https://feross.org/opensource> */ /* eslint-disable node/no-deprecated-api */ 
var $iuRmA = parcelRequire("iuRmA");
var $9baa0db49086829d$var$Buffer = $iuRmA.Buffer;
// alternative to using Object.keys for old browsers
function $9baa0db49086829d$var$copyProps(src, dst) {
    for(var key in src)dst[key] = src[key];
}
if ($9baa0db49086829d$var$Buffer.from && $9baa0db49086829d$var$Buffer.alloc && $9baa0db49086829d$var$Buffer.allocUnsafe && $9baa0db49086829d$var$Buffer.allocUnsafeSlow) module.exports = $iuRmA;
else {
    // Copy properties from require('buffer')
    $9baa0db49086829d$var$copyProps($iuRmA, module.exports);
    module.exports.Buffer = $9baa0db49086829d$var$SafeBuffer;
}
function $9baa0db49086829d$var$SafeBuffer(arg, encodingOrOffset, length) {
    return $9baa0db49086829d$var$Buffer(arg, encodingOrOffset, length);
}
$9baa0db49086829d$var$SafeBuffer.prototype = Object.create($9baa0db49086829d$var$Buffer.prototype);
// Copy static methods from Buffer
$9baa0db49086829d$var$copyProps($9baa0db49086829d$var$Buffer, $9baa0db49086829d$var$SafeBuffer);
$9baa0db49086829d$var$SafeBuffer.from = function(arg, encodingOrOffset, length) {
    if (typeof arg === "number") throw new TypeError("Argument must not be a number");
    return $9baa0db49086829d$var$Buffer(arg, encodingOrOffset, length);
};
$9baa0db49086829d$var$SafeBuffer.alloc = function(size, fill, encoding) {
    if (typeof size !== "number") throw new TypeError("Argument must be a number");
    var buf = $9baa0db49086829d$var$Buffer(size);
    if (fill !== undefined) {
        if (typeof encoding === "string") buf.fill(fill, encoding);
        else buf.fill(fill);
    } else buf.fill(0);
    return buf;
};
$9baa0db49086829d$var$SafeBuffer.allocUnsafe = function(size) {
    if (typeof size !== "number") throw new TypeError("Argument must be a number");
    return $9baa0db49086829d$var$Buffer(size);
};
$9baa0db49086829d$var$SafeBuffer.allocUnsafeSlow = function(size) {
    if (typeof size !== "number") throw new TypeError("Argument must be a number");
    return $iuRmA.SlowBuffer(size);
};

});


parcelRequire.register("eSo8i", function(module, exports) {

var $hIXGI = parcelRequire("hIXGI");
"use strict";
var $ad48d41f0b10fc44$var$_Object$setPrototypeO;
function $ad48d41f0b10fc44$var$_defineProperty(obj, key, value) {
    key = $ad48d41f0b10fc44$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $ad48d41f0b10fc44$var$_toPropertyKey(arg) {
    var key = $ad48d41f0b10fc44$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $ad48d41f0b10fc44$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}

var $jIV9q = parcelRequire("jIV9q");
var $ad48d41f0b10fc44$var$kLastResolve = Symbol("lastResolve");
var $ad48d41f0b10fc44$var$kLastReject = Symbol("lastReject");
var $ad48d41f0b10fc44$var$kError = Symbol("error");
var $ad48d41f0b10fc44$var$kEnded = Symbol("ended");
var $ad48d41f0b10fc44$var$kLastPromise = Symbol("lastPromise");
var $ad48d41f0b10fc44$var$kHandlePromise = Symbol("handlePromise");
var $ad48d41f0b10fc44$var$kStream = Symbol("stream");
function $ad48d41f0b10fc44$var$createIterResult(value, done) {
    return {
        value: value,
        done: done
    };
}
function $ad48d41f0b10fc44$var$readAndResolve(iter) {
    var resolve = iter[$ad48d41f0b10fc44$var$kLastResolve];
    if (resolve !== null) {
        var data = iter[$ad48d41f0b10fc44$var$kStream].read();
        // we defer if data is null
        // we can be expecting either 'end' or
        // 'error'
        if (data !== null) {
            iter[$ad48d41f0b10fc44$var$kLastPromise] = null;
            iter[$ad48d41f0b10fc44$var$kLastResolve] = null;
            iter[$ad48d41f0b10fc44$var$kLastReject] = null;
            resolve($ad48d41f0b10fc44$var$createIterResult(data, false));
        }
    }
}
function $ad48d41f0b10fc44$var$onReadable(iter) {
    // we wait for the next tick, because it might
    // emit an error with process.nextTick
    $hIXGI.nextTick($ad48d41f0b10fc44$var$readAndResolve, iter);
}
function $ad48d41f0b10fc44$var$wrapForNext(lastPromise, iter) {
    return function(resolve, reject) {
        lastPromise.then(function() {
            if (iter[$ad48d41f0b10fc44$var$kEnded]) {
                resolve($ad48d41f0b10fc44$var$createIterResult(undefined, true));
                return;
            }
            iter[$ad48d41f0b10fc44$var$kHandlePromise](resolve, reject);
        }, reject);
    };
}
var $ad48d41f0b10fc44$var$AsyncIteratorPrototype = Object.getPrototypeOf(function() {});
var $ad48d41f0b10fc44$var$ReadableStreamAsyncIteratorPrototype = Object.setPrototypeOf(($ad48d41f0b10fc44$var$_Object$setPrototypeO = {
    get stream () {
        return this[$ad48d41f0b10fc44$var$kStream];
    },
    next: function next() {
        var _this = this;
        // if we have detected an error in the meanwhile
        // reject straight away
        var error = this[$ad48d41f0b10fc44$var$kError];
        if (error !== null) return Promise.reject(error);
        if (this[$ad48d41f0b10fc44$var$kEnded]) return Promise.resolve($ad48d41f0b10fc44$var$createIterResult(undefined, true));
        if (this[$ad48d41f0b10fc44$var$kStream].destroyed) // We need to defer via nextTick because if .destroy(err) is
        // called, the error will be emitted via nextTick, and
        // we cannot guarantee that there is no error lingering around
        // waiting to be emitted.
        return new Promise(function(resolve, reject) {
            $hIXGI.nextTick(function() {
                if (_this[$ad48d41f0b10fc44$var$kError]) reject(_this[$ad48d41f0b10fc44$var$kError]);
                else resolve($ad48d41f0b10fc44$var$createIterResult(undefined, true));
            });
        });
        // if we have multiple next() calls
        // we will wait for the previous Promise to finish
        // this logic is optimized to support for await loops,
        // where next() is only called once at a time
        var lastPromise = this[$ad48d41f0b10fc44$var$kLastPromise];
        var promise;
        if (lastPromise) promise = new Promise($ad48d41f0b10fc44$var$wrapForNext(lastPromise, this));
        else {
            // fast path needed to support multiple this.push()
            // without triggering the next() queue
            var data = this[$ad48d41f0b10fc44$var$kStream].read();
            if (data !== null) return Promise.resolve($ad48d41f0b10fc44$var$createIterResult(data, false));
            promise = new Promise(this[$ad48d41f0b10fc44$var$kHandlePromise]);
        }
        this[$ad48d41f0b10fc44$var$kLastPromise] = promise;
        return promise;
    }
}, $ad48d41f0b10fc44$var$_defineProperty($ad48d41f0b10fc44$var$_Object$setPrototypeO, Symbol.asyncIterator, function() {
    return this;
}), $ad48d41f0b10fc44$var$_defineProperty($ad48d41f0b10fc44$var$_Object$setPrototypeO, "return", function _return() {
    var _this2 = this;
    // destroy(err, cb) is a private API
    // we can guarantee we have that here, because we control the
    // Readable class this is attached to
    return new Promise(function(resolve, reject) {
        _this2[$ad48d41f0b10fc44$var$kStream].destroy(null, function(err) {
            if (err) {
                reject(err);
                return;
            }
            resolve($ad48d41f0b10fc44$var$createIterResult(undefined, true));
        });
    });
}), $ad48d41f0b10fc44$var$_Object$setPrototypeO), $ad48d41f0b10fc44$var$AsyncIteratorPrototype);
var $ad48d41f0b10fc44$var$createReadableStreamAsyncIterator = function createReadableStreamAsyncIterator(stream) {
    var _Object$create;
    var iterator = Object.create($ad48d41f0b10fc44$var$ReadableStreamAsyncIteratorPrototype, (_Object$create = {}, $ad48d41f0b10fc44$var$_defineProperty(_Object$create, $ad48d41f0b10fc44$var$kStream, {
        value: stream,
        writable: true
    }), $ad48d41f0b10fc44$var$_defineProperty(_Object$create, $ad48d41f0b10fc44$var$kLastResolve, {
        value: null,
        writable: true
    }), $ad48d41f0b10fc44$var$_defineProperty(_Object$create, $ad48d41f0b10fc44$var$kLastReject, {
        value: null,
        writable: true
    }), $ad48d41f0b10fc44$var$_defineProperty(_Object$create, $ad48d41f0b10fc44$var$kError, {
        value: null,
        writable: true
    }), $ad48d41f0b10fc44$var$_defineProperty(_Object$create, $ad48d41f0b10fc44$var$kEnded, {
        value: stream._readableState.endEmitted,
        writable: true
    }), $ad48d41f0b10fc44$var$_defineProperty(_Object$create, $ad48d41f0b10fc44$var$kHandlePromise, {
        value: function value(resolve, reject) {
            var data = iterator[$ad48d41f0b10fc44$var$kStream].read();
            if (data) {
                iterator[$ad48d41f0b10fc44$var$kLastPromise] = null;
                iterator[$ad48d41f0b10fc44$var$kLastResolve] = null;
                iterator[$ad48d41f0b10fc44$var$kLastReject] = null;
                resolve($ad48d41f0b10fc44$var$createIterResult(data, false));
            } else {
                iterator[$ad48d41f0b10fc44$var$kLastResolve] = resolve;
                iterator[$ad48d41f0b10fc44$var$kLastReject] = reject;
            }
        },
        writable: true
    }), _Object$create));
    iterator[$ad48d41f0b10fc44$var$kLastPromise] = null;
    $jIV9q(stream, function(err) {
        if (err && err.code !== "ERR_STREAM_PREMATURE_CLOSE") {
            var reject = iterator[$ad48d41f0b10fc44$var$kLastReject];
            // reject if we are waiting for data in the Promise
            // returned by next() and store the error
            if (reject !== null) {
                iterator[$ad48d41f0b10fc44$var$kLastPromise] = null;
                iterator[$ad48d41f0b10fc44$var$kLastResolve] = null;
                iterator[$ad48d41f0b10fc44$var$kLastReject] = null;
                reject(err);
            }
            iterator[$ad48d41f0b10fc44$var$kError] = err;
            return;
        }
        var resolve = iterator[$ad48d41f0b10fc44$var$kLastResolve];
        if (resolve !== null) {
            iterator[$ad48d41f0b10fc44$var$kLastPromise] = null;
            iterator[$ad48d41f0b10fc44$var$kLastResolve] = null;
            iterator[$ad48d41f0b10fc44$var$kLastReject] = null;
            resolve($ad48d41f0b10fc44$var$createIterResult(undefined, true));
        }
        iterator[$ad48d41f0b10fc44$var$kEnded] = true;
    });
    stream.on("readable", $ad48d41f0b10fc44$var$onReadable.bind(null, iterator));
    return iterator;
};
module.exports = $ad48d41f0b10fc44$var$createReadableStreamAsyncIterator;

});
parcelRequire.register("jIV9q", function(module, exports) {
// Ported from https://github.com/mafintosh/end-of-stream with
// permission from the author, Mathias Buus (@mafintosh).
"use strict";

var $jqb3Z = parcelRequire("jqb3Z");
var $e5be75687dbf500f$var$ERR_STREAM_PREMATURE_CLOSE = $jqb3Z.codes.ERR_STREAM_PREMATURE_CLOSE;
function $e5be75687dbf500f$var$once(callback) {
    var called = false;
    return function() {
        if (called) return;
        called = true;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        callback.apply(this, args);
    };
}
function $e5be75687dbf500f$var$noop() {}
function $e5be75687dbf500f$var$isRequest(stream) {
    return stream.setHeader && typeof stream.abort === "function";
}
function $e5be75687dbf500f$var$eos(stream, opts, callback) {
    if (typeof opts === "function") return $e5be75687dbf500f$var$eos(stream, null, opts);
    if (!opts) opts = {};
    callback = $e5be75687dbf500f$var$once(callback || $e5be75687dbf500f$var$noop);
    var readable = opts.readable || opts.readable !== false && stream.readable;
    var writable = opts.writable || opts.writable !== false && stream.writable;
    var onlegacyfinish = function onlegacyfinish() {
        if (!stream.writable) onfinish();
    };
    var writableEnded = stream._writableState && stream._writableState.finished;
    var onfinish = function onfinish() {
        writable = false;
        writableEnded = true;
        if (!readable) callback.call(stream);
    };
    var readableEnded = stream._readableState && stream._readableState.endEmitted;
    var onend = function onend() {
        readable = false;
        readableEnded = true;
        if (!writable) callback.call(stream);
    };
    var onerror = function onerror(err) {
        callback.call(stream, err);
    };
    var onclose = function onclose() {
        var err;
        if (readable && !readableEnded) {
            if (!stream._readableState || !stream._readableState.ended) err = new $e5be75687dbf500f$var$ERR_STREAM_PREMATURE_CLOSE();
            return callback.call(stream, err);
        }
        if (writable && !writableEnded) {
            if (!stream._writableState || !stream._writableState.ended) err = new $e5be75687dbf500f$var$ERR_STREAM_PREMATURE_CLOSE();
            return callback.call(stream, err);
        }
    };
    var onrequest = function onrequest() {
        stream.req.on("finish", onfinish);
    };
    if ($e5be75687dbf500f$var$isRequest(stream)) {
        stream.on("complete", onfinish);
        stream.on("abort", onclose);
        if (stream.req) onrequest();
        else stream.on("request", onrequest);
    } else if (writable && !stream._writableState) {
        // legacy streams
        stream.on("end", onlegacyfinish);
        stream.on("close", onlegacyfinish);
    }
    stream.on("end", onend);
    stream.on("finish", onfinish);
    if (opts.error !== false) stream.on("error", onerror);
    stream.on("close", onclose);
    return function() {
        stream.removeListener("complete", onfinish);
        stream.removeListener("abort", onclose);
        stream.removeListener("request", onrequest);
        if (stream.req) stream.req.removeListener("finish", onfinish);
        stream.removeListener("end", onlegacyfinish);
        stream.removeListener("close", onlegacyfinish);
        stream.removeListener("finish", onfinish);
        stream.removeListener("end", onend);
        stream.removeListener("error", onerror);
        stream.removeListener("close", onclose);
    };
}
module.exports = $e5be75687dbf500f$var$eos;

});


parcelRequire.register("bbssr", function(module, exports) {
module.exports = function() {
    throw new Error("Readable.from is not available in the browser");
};

});


parcelRequire.register("6vslQ", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a transform stream is a readable/writable stream where you do
// something with the data.  Sometimes it's called a "filter",
// but that's not a great name for it, since that implies a thing where
// some bits pass through, and others are simply ignored.  (That would
// be a valid example of a transform, of course.)
//
// While the output is causally related to the input, it's not a
// necessarily symmetric or synchronous transformation.  For example,
// a zlib stream might take multiple plain-text writes(), and then
// emit a single compressed chunk some time in the future.
//
// Here's how this works:
//
// The Transform stream has all the aspects of the readable and writable
// stream classes.  When you write(chunk), that calls _write(chunk,cb)
// internally, and returns false if there's a lot of pending writes
// buffered up.  When you call read(), that calls _read(n) until
// there's enough pending readable data buffered up.
//
// In a transform stream, the written data is placed in a buffer.  When
// _read(n) is called, it transforms the queued up data, calling the
// buffered _write cb's as it consumes chunks.  If consuming a single
// written chunk would result in multiple output chunks, then the first
// outputted bit calls the readcb, and subsequent chunks just go into
// the read buffer, and will cause it to emit 'readable' if necessary.
//
// This way, back-pressure is actually determined by the reading side,
// since _read has to be called to start processing a new chunk.  However,
// a pathological inflate type of transform can cause excessive buffering
// here.  For example, imagine a stream where every byte of input is
// interpreted as an integer from 0-255, and then results in that many
// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
// 1kb of data being output.  In this case, you could write a very small
// amount of input, and end up with a very large amount of output.  In
// such a pathological inflating mechanism, there'd be no way to tell
// the system to stop doing the transform.  A single 4MB write could
// cause the system to run out of memory.
//
// However, even in such a pathological case, only a single written chunk
// would be consumed, and then the rest would wait (un-transformed) until
// the results of the previous transformed chunk were consumed.
"use strict";
module.exports = $4bcba14b5b676e63$var$Transform;

var $jqb3Z = parcelRequire("jqb3Z");
var $4bcba14b5b676e63$require$_require$codes = $jqb3Z.codes;
var $4bcba14b5b676e63$var$ERR_METHOD_NOT_IMPLEMENTED = $4bcba14b5b676e63$require$_require$codes.ERR_METHOD_NOT_IMPLEMENTED, $4bcba14b5b676e63$var$ERR_MULTIPLE_CALLBACK = $4bcba14b5b676e63$require$_require$codes.ERR_MULTIPLE_CALLBACK, $4bcba14b5b676e63$var$ERR_TRANSFORM_ALREADY_TRANSFORMING = $4bcba14b5b676e63$require$_require$codes.ERR_TRANSFORM_ALREADY_TRANSFORMING, $4bcba14b5b676e63$var$ERR_TRANSFORM_WITH_LENGTH_0 = $4bcba14b5b676e63$require$_require$codes.ERR_TRANSFORM_WITH_LENGTH_0;

var $cMizL = parcelRequire("cMizL");

(parcelRequire("5SAkX"))($4bcba14b5b676e63$var$Transform, $cMizL);
function $4bcba14b5b676e63$var$afterTransform(er, data) {
    var ts = this._transformState;
    ts.transforming = false;
    var cb = ts.writecb;
    if (cb === null) return this.emit("error", new $4bcba14b5b676e63$var$ERR_MULTIPLE_CALLBACK());
    ts.writechunk = null;
    ts.writecb = null;
    if (data != null) // single equals check for both `null` and `undefined`
    this.push(data);
    cb(er);
    var rs = this._readableState;
    rs.reading = false;
    if (rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
}
function $4bcba14b5b676e63$var$Transform(options) {
    if (!(this instanceof $4bcba14b5b676e63$var$Transform)) return new $4bcba14b5b676e63$var$Transform(options);
    $cMizL.call(this, options);
    this._transformState = {
        afterTransform: $4bcba14b5b676e63$var$afterTransform.bind(this),
        needTransform: false,
        transforming: false,
        writecb: null,
        writechunk: null,
        writeencoding: null
    };
    // start out asking for a readable event once data is transformed.
    this._readableState.needReadable = true;
    // we have implemented the _read method, and done the other things
    // that Readable wants before the first _read call, so unset the
    // sync guard flag.
    this._readableState.sync = false;
    if (options) {
        if (typeof options.transform === "function") this._transform = options.transform;
        if (typeof options.flush === "function") this._flush = options.flush;
    }
    // When the writable side finishes, then flush out anything remaining.
    this.on("prefinish", $4bcba14b5b676e63$var$prefinish);
}
function $4bcba14b5b676e63$var$prefinish() {
    var _this = this;
    if (typeof this._flush === "function" && !this._readableState.destroyed) this._flush(function(er, data) {
        $4bcba14b5b676e63$var$done(_this, er, data);
    });
    else $4bcba14b5b676e63$var$done(this, null, null);
}
$4bcba14b5b676e63$var$Transform.prototype.push = function(chunk, encoding) {
    this._transformState.needTransform = false;
    return $cMizL.prototype.push.call(this, chunk, encoding);
};
// This is the part where you do stuff!
// override this function in implementation classes.
// 'chunk' is an input chunk.
//
// Call `push(newChunk)` to pass along transformed output
// to the readable side.  You may call 'push' zero or more times.
//
// Call `cb(err)` when you are done with this chunk.  If you pass
// an error, then that'll put the hurt on the whole operation.  If you
// never call cb(), then you'll never get another chunk.
$4bcba14b5b676e63$var$Transform.prototype._transform = function(chunk, encoding, cb) {
    cb(new $4bcba14b5b676e63$var$ERR_METHOD_NOT_IMPLEMENTED("_transform()"));
};
$4bcba14b5b676e63$var$Transform.prototype._write = function(chunk, encoding, cb) {
    var ts = this._transformState;
    ts.writecb = cb;
    ts.writechunk = chunk;
    ts.writeencoding = encoding;
    if (!ts.transforming) {
        var rs = this._readableState;
        if (ts.needTransform || rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
    }
};
// Doesn't matter what the args are here.
// _transform does all the work.
// That we got here means that the readable side wants more data.
$4bcba14b5b676e63$var$Transform.prototype._read = function(n) {
    var ts = this._transformState;
    if (ts.writechunk !== null && !ts.transforming) {
        ts.transforming = true;
        this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
    } else // mark that we need a transform, so that any data that comes in
    // will get processed, now that we've asked for it.
    ts.needTransform = true;
};
$4bcba14b5b676e63$var$Transform.prototype._destroy = function(err, cb) {
    $cMizL.prototype._destroy.call(this, err, function(err2) {
        cb(err2);
    });
};
function $4bcba14b5b676e63$var$done(stream, er, data) {
    if (er) return stream.emit("error", er);
    if (data != null) // single equals check for both `null` and `undefined`
    stream.push(data);
    // TODO(BridgeAR): Write a test for these two error cases
    // if there's nothing in the write buffer, then that means
    // that nothing more will ever be provided
    if (stream._writableState.length) throw new $4bcba14b5b676e63$var$ERR_TRANSFORM_WITH_LENGTH_0();
    if (stream._transformState.transforming) throw new $4bcba14b5b676e63$var$ERR_TRANSFORM_ALREADY_TRANSFORMING();
    return stream.push(null);
}

});

parcelRequire.register("kMGT2", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a passthrough stream.
// basically just the most minimal sort of Transform stream.
// Every written chunk gets output as-is.
"use strict";
module.exports = $f2198ec179402a8c$var$PassThrough;

var $6vslQ = parcelRequire("6vslQ");

(parcelRequire("5SAkX"))($f2198ec179402a8c$var$PassThrough, $6vslQ);
function $f2198ec179402a8c$var$PassThrough(options) {
    if (!(this instanceof $f2198ec179402a8c$var$PassThrough)) return new $f2198ec179402a8c$var$PassThrough(options);
    $6vslQ.call(this, options);
}
$f2198ec179402a8c$var$PassThrough.prototype._transform = function(chunk, encoding, cb) {
    cb(null, chunk);
};

});

parcelRequire.register("8a2DY", function(module, exports) {
// Ported from https://github.com/mafintosh/pump with
// permission from the author, Mathias Buus (@mafintosh).
"use strict";
var $5f114ee67b0cbb57$var$eos;
function $5f114ee67b0cbb57$var$once(callback) {
    var called = false;
    return function() {
        if (called) return;
        called = true;
        callback.apply(void 0, arguments);
    };
}

var $jqb3Z = parcelRequire("jqb3Z");
var $5f114ee67b0cbb57$require$_require$codes = $jqb3Z.codes;
var $5f114ee67b0cbb57$var$ERR_MISSING_ARGS = $5f114ee67b0cbb57$require$_require$codes.ERR_MISSING_ARGS, $5f114ee67b0cbb57$var$ERR_STREAM_DESTROYED = $5f114ee67b0cbb57$require$_require$codes.ERR_STREAM_DESTROYED;
function $5f114ee67b0cbb57$var$noop(err) {
    // Rethrow the error if it exists to avoid swallowing it
    if (err) throw err;
}
function $5f114ee67b0cbb57$var$isRequest(stream) {
    return stream.setHeader && typeof stream.abort === "function";
}

function $5f114ee67b0cbb57$var$destroyer(stream, reading, writing, callback) {
    callback = $5f114ee67b0cbb57$var$once(callback);
    var closed = false;
    stream.on("close", function() {
        closed = true;
    });
    if ($5f114ee67b0cbb57$var$eos === undefined) $5f114ee67b0cbb57$var$eos = (parcelRequire("jIV9q"));
    $5f114ee67b0cbb57$var$eos(stream, {
        readable: reading,
        writable: writing
    }, function(err) {
        if (err) return callback(err);
        closed = true;
        callback();
    });
    var destroyed = false;
    return function(err) {
        if (closed) return;
        if (destroyed) return;
        destroyed = true;
        // request.destroy just do .end - .abort is what we want
        if ($5f114ee67b0cbb57$var$isRequest(stream)) return stream.abort();
        if (typeof stream.destroy === "function") return stream.destroy();
        callback(err || new $5f114ee67b0cbb57$var$ERR_STREAM_DESTROYED("pipe"));
    };
}
function $5f114ee67b0cbb57$var$call(fn) {
    fn();
}
function $5f114ee67b0cbb57$var$pipe(from, to) {
    return from.pipe(to);
}
function $5f114ee67b0cbb57$var$popCallback(streams) {
    if (!streams.length) return $5f114ee67b0cbb57$var$noop;
    if (typeof streams[streams.length - 1] !== "function") return $5f114ee67b0cbb57$var$noop;
    return streams.pop();
}
function $5f114ee67b0cbb57$var$pipeline() {
    for(var _len = arguments.length, streams = new Array(_len), _key = 0; _key < _len; _key++)streams[_key] = arguments[_key];
    var callback = $5f114ee67b0cbb57$var$popCallback(streams);
    if (Array.isArray(streams[0])) streams = streams[0];
    if (streams.length < 2) throw new $5f114ee67b0cbb57$var$ERR_MISSING_ARGS("streams");
    var error;
    var destroys = streams.map(function(stream, i) {
        var reading = i < streams.length - 1;
        var writing = i > 0;
        return $5f114ee67b0cbb57$var$destroyer(stream, reading, writing, function(err) {
            if (!error) error = err;
            if (err) destroys.forEach($5f114ee67b0cbb57$var$call);
            if (reading) return;
            destroys.forEach($5f114ee67b0cbb57$var$call);
            callback(error);
        });
    });
    return streams.reduce($5f114ee67b0cbb57$var$pipe);
}
module.exports = $5f114ee67b0cbb57$var$pipeline;

});




parcelRequire.register("9eKsl", function(module, exports) {
module.exports = $6b9975189ace9837$var$extend;
var $6b9975189ace9837$var$hasOwnProperty = Object.prototype.hasOwnProperty;
function $6b9975189ace9837$var$extend() {
    var target = {};
    for(var i = 0; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if ($6b9975189ace9837$var$hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
}

});

parcelRequire.register("7g6zO", function(module, exports) {
module.exports = {
    "100": "Continue",
    "101": "Switching Protocols",
    "102": "Processing",
    "200": "OK",
    "201": "Created",
    "202": "Accepted",
    "203": "Non-Authoritative Information",
    "204": "No Content",
    "205": "Reset Content",
    "206": "Partial Content",
    "207": "Multi-Status",
    "208": "Already Reported",
    "226": "IM Used",
    "300": "Multiple Choices",
    "301": "Moved Permanently",
    "302": "Found",
    "303": "See Other",
    "304": "Not Modified",
    "305": "Use Proxy",
    "307": "Temporary Redirect",
    "308": "Permanent Redirect",
    "400": "Bad Request",
    "401": "Unauthorized",
    "402": "Payment Required",
    "403": "Forbidden",
    "404": "Not Found",
    "405": "Method Not Allowed",
    "406": "Not Acceptable",
    "407": "Proxy Authentication Required",
    "408": "Request Timeout",
    "409": "Conflict",
    "410": "Gone",
    "411": "Length Required",
    "412": "Precondition Failed",
    "413": "Payload Too Large",
    "414": "URI Too Long",
    "415": "Unsupported Media Type",
    "416": "Range Not Satisfiable",
    "417": "Expectation Failed",
    "418": "I'm a teapot",
    "421": "Misdirected Request",
    "422": "Unprocessable Entity",
    "423": "Locked",
    "424": "Failed Dependency",
    "425": "Unordered Collection",
    "426": "Upgrade Required",
    "428": "Precondition Required",
    "429": "Too Many Requests",
    "431": "Request Header Fields Too Large",
    "451": "Unavailable For Legal Reasons",
    "500": "Internal Server Error",
    "501": "Not Implemented",
    "502": "Bad Gateway",
    "503": "Service Unavailable",
    "504": "Gateway Timeout",
    "505": "HTTP Version Not Supported",
    "506": "Variant Also Negotiates",
    "507": "Insufficient Storage",
    "508": "Loop Detected",
    "509": "Bandwidth Limit Exceeded",
    "510": "Not Extended",
    "511": "Network Authentication Required"
};

});

parcelRequire.register("aaypF", function(module, exports) {

$parcel$export(module.exports, "parse", () => $7675883b5fed53f3$export$98e6a39c04603d36, (v) => $7675883b5fed53f3$export$98e6a39c04603d36 = v);
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
var $7675883b5fed53f3$export$98e6a39c04603d36;
var $7675883b5fed53f3$export$f7ad0328861e2f03;
var $7675883b5fed53f3$export$7daf1a5d2f4dd018;
var $7675883b5fed53f3$export$d9468344d3651243;
var $7675883b5fed53f3$export$59d795186a5d3f58;
"use strict";

var $z7No8 = parcelRequire("z7No8");

var $93MWl = parcelRequire("93MWl");
$7675883b5fed53f3$export$98e6a39c04603d36 = $7675883b5fed53f3$var$urlParse;
$7675883b5fed53f3$export$f7ad0328861e2f03 = $7675883b5fed53f3$var$urlResolve;
$7675883b5fed53f3$export$7daf1a5d2f4dd018 = $7675883b5fed53f3$var$urlResolveObject;
$7675883b5fed53f3$export$d9468344d3651243 = $7675883b5fed53f3$var$urlFormat;
$7675883b5fed53f3$export$59d795186a5d3f58 = $7675883b5fed53f3$var$Url;
function $7675883b5fed53f3$var$Url() {
    this.protocol = null;
    this.slashes = null;
    this.auth = null;
    this.host = null;
    this.port = null;
    this.hostname = null;
    this.hash = null;
    this.search = null;
    this.query = null;
    this.pathname = null;
    this.path = null;
    this.href = null;
}
// Reference: RFC 3986, RFC 1808, RFC 2396
// define these here so at least they only have to be
// compiled once on the first module load.
var $7675883b5fed53f3$var$protocolPattern = /^([a-z0-9.+-]+:)/i, $7675883b5fed53f3$var$portPattern = /:[0-9]*$/, // Special case for a simple path URL
$7675883b5fed53f3$var$simplePathPattern = /^(\/\/?(?!\/)[^\?\s]*)(\?[^\s]*)?$/, // RFC 2396: characters reserved for delimiting URLs.
// We actually just auto-escape these.
$7675883b5fed53f3$var$delims = [
    "<",
    ">",
    '"',
    "`",
    " ",
    "\r",
    "\n",
    "	"
], // RFC 2396: characters not allowed for various reasons.
$7675883b5fed53f3$var$unwise = [
    "{",
    "}",
    "|",
    "\\",
    "^",
    "`"
].concat($7675883b5fed53f3$var$delims), // Allowed by RFCs, but cause of XSS attacks.  Always escape these.
$7675883b5fed53f3$var$autoEscape = [
    "'"
].concat($7675883b5fed53f3$var$unwise), // Characters that are never ever allowed in a hostname.
// Note that any invalid chars are also handled, but these
// are the ones that are *expected* to be seen, so we fast-path
// them.
$7675883b5fed53f3$var$nonHostChars = [
    "%",
    "/",
    "?",
    ";",
    "#"
].concat($7675883b5fed53f3$var$autoEscape), $7675883b5fed53f3$var$hostEndingChars = [
    "/",
    "?",
    "#"
], $7675883b5fed53f3$var$hostnameMaxLen = 255, $7675883b5fed53f3$var$hostnamePartPattern = /^[+a-z0-9A-Z_-]{0,63}$/, $7675883b5fed53f3$var$hostnamePartStart = /^([+a-z0-9A-Z_-]{0,63})(.*)$/, // protocols that can allow "unsafe" and "unwise" chars.
$7675883b5fed53f3$var$unsafeProtocol = {
    "javascript": true,
    "javascript:": true
}, // protocols that never have a hostname.
$7675883b5fed53f3$var$hostlessProtocol = {
    "javascript": true,
    "javascript:": true
}, // protocols that always contain a // bit.
$7675883b5fed53f3$var$slashedProtocol = {
    "http": true,
    "https": true,
    "ftp": true,
    "gopher": true,
    "file": true,
    "http:": true,
    "https:": true,
    "ftp:": true,
    "gopher:": true,
    "file:": true
};

var $2Rldr = parcelRequire("2Rldr");
function $7675883b5fed53f3$var$urlParse(url, parseQueryString, slashesDenoteHost) {
    if (url && $93MWl.isObject(url) && url instanceof $7675883b5fed53f3$var$Url) return url;
    var u = new $7675883b5fed53f3$var$Url;
    u.parse(url, parseQueryString, slashesDenoteHost);
    return u;
}
$7675883b5fed53f3$var$Url.prototype.parse = function(url, parseQueryString, slashesDenoteHost) {
    if (!$93MWl.isString(url)) throw new TypeError("Parameter 'url' must be a string, not " + typeof url);
    // Copy chrome, IE, opera backslash-handling behavior.
    // Back slashes before the query string get converted to forward slashes
    // See: https://code.google.com/p/chromium/issues/detail?id=25916
    var queryIndex = url.indexOf("?"), splitter = queryIndex !== -1 && queryIndex < url.indexOf("#") ? "?" : "#", uSplit = url.split(splitter), slashRegex = /\\/g;
    uSplit[0] = uSplit[0].replace(slashRegex, "/");
    url = uSplit.join(splitter);
    var rest = url;
    // trim before proceeding.
    // This is to support parse stuff like "  http://foo.com  \n"
    rest = rest.trim();
    if (!slashesDenoteHost && url.split("#").length === 1) {
        // Try fast path regexp
        var simplePath = $7675883b5fed53f3$var$simplePathPattern.exec(rest);
        if (simplePath) {
            this.path = rest;
            this.href = rest;
            this.pathname = simplePath[1];
            if (simplePath[2]) {
                this.search = simplePath[2];
                if (parseQueryString) this.query = $2Rldr.parse(this.search.substr(1));
                else this.query = this.search.substr(1);
            } else if (parseQueryString) {
                this.search = "";
                this.query = {};
            }
            return this;
        }
    }
    var proto = $7675883b5fed53f3$var$protocolPattern.exec(rest);
    if (proto) {
        proto = proto[0];
        var lowerProto = proto.toLowerCase();
        this.protocol = lowerProto;
        rest = rest.substr(proto.length);
    }
    // figure out if it's got a host
    // user@server is *always* interpreted as a hostname, and url
    // resolution will treat //foo/bar as host=foo,path=bar because that's
    // how the browser resolves relative URLs.
    if (slashesDenoteHost || proto || rest.match(/^\/\/[^@\/]+@[^@\/]+/)) {
        var slashes = rest.substr(0, 2) === "//";
        if (slashes && !(proto && $7675883b5fed53f3$var$hostlessProtocol[proto])) {
            rest = rest.substr(2);
            this.slashes = true;
        }
    }
    if (!$7675883b5fed53f3$var$hostlessProtocol[proto] && (slashes || proto && !$7675883b5fed53f3$var$slashedProtocol[proto])) {
        // there's a hostname.
        // the first instance of /, ?, ;, or # ends the host.
        //
        // If there is an @ in the hostname, then non-host chars *are* allowed
        // to the left of the last @ sign, unless some host-ending character
        // comes *before* the @-sign.
        // URLs are obnoxious.
        //
        // ex:
        // http://a@b@c/ => user:a@b host:c
        // http://a@b?@c => user:a host:c path:/?@c
        // v0.12 TODO(isaacs): This is not quite how Chrome does things.
        // Review our test case against browsers more comprehensively.
        // find the first instance of any hostEndingChars
        var hostEnd = -1;
        for(var i = 0; i < $7675883b5fed53f3$var$hostEndingChars.length; i++){
            var hec = rest.indexOf($7675883b5fed53f3$var$hostEndingChars[i]);
            if (hec !== -1 && (hostEnd === -1 || hec < hostEnd)) hostEnd = hec;
        }
        // at this point, either we have an explicit point where the
        // auth portion cannot go past, or the last @ char is the decider.
        var auth, atSign;
        if (hostEnd === -1) // atSign can be anywhere.
        atSign = rest.lastIndexOf("@");
        else // atSign must be in auth portion.
        // http://a@b/c@d => host:b auth:a path:/c@d
        atSign = rest.lastIndexOf("@", hostEnd);
        // Now we have a portion which is definitely the auth.
        // Pull that off.
        if (atSign !== -1) {
            auth = rest.slice(0, atSign);
            rest = rest.slice(atSign + 1);
            this.auth = decodeURIComponent(auth);
        }
        // the host is the remaining to the left of the first non-host char
        hostEnd = -1;
        for(var i = 0; i < $7675883b5fed53f3$var$nonHostChars.length; i++){
            var hec = rest.indexOf($7675883b5fed53f3$var$nonHostChars[i]);
            if (hec !== -1 && (hostEnd === -1 || hec < hostEnd)) hostEnd = hec;
        }
        // if we still have not hit it, then the entire thing is a host.
        if (hostEnd === -1) hostEnd = rest.length;
        this.host = rest.slice(0, hostEnd);
        rest = rest.slice(hostEnd);
        // pull out port.
        this.parseHost();
        // we've indicated that there is a hostname,
        // so even if it's empty, it has to be present.
        this.hostname = this.hostname || "";
        // if hostname begins with [ and ends with ]
        // assume that it's an IPv6 address.
        var ipv6Hostname = this.hostname[0] === "[" && this.hostname[this.hostname.length - 1] === "]";
        // validate a little.
        if (!ipv6Hostname) {
            var hostparts = this.hostname.split(/\./);
            for(var i = 0, l = hostparts.length; i < l; i++){
                var part = hostparts[i];
                if (!part) continue;
                if (!part.match($7675883b5fed53f3$var$hostnamePartPattern)) {
                    var newpart = "";
                    for(var j = 0, k = part.length; j < k; j++)if (part.charCodeAt(j) > 127) // we replace non-ASCII char with a temporary placeholder
                    // we need this to make sure size of hostname is not
                    // broken by replacing non-ASCII by nothing
                    newpart += "x";
                    else newpart += part[j];
                    // we test again with ASCII char only
                    if (!newpart.match($7675883b5fed53f3$var$hostnamePartPattern)) {
                        var validParts = hostparts.slice(0, i);
                        var notHost = hostparts.slice(i + 1);
                        var bit = part.match($7675883b5fed53f3$var$hostnamePartStart);
                        if (bit) {
                            validParts.push(bit[1]);
                            notHost.unshift(bit[2]);
                        }
                        if (notHost.length) rest = "/" + notHost.join(".") + rest;
                        this.hostname = validParts.join(".");
                        break;
                    }
                }
            }
        }
        if (this.hostname.length > $7675883b5fed53f3$var$hostnameMaxLen) this.hostname = "";
        else // hostnames are always lower case.
        this.hostname = this.hostname.toLowerCase();
        if (!ipv6Hostname) // IDNA Support: Returns a punycoded representation of "domain".
        // It only converts parts of the domain name that
        // have non-ASCII characters, i.e. it doesn't matter if
        // you call it with a domain that already is ASCII-only.
        this.hostname = $z7No8.toASCII(this.hostname);
        var p = this.port ? ":" + this.port : "";
        var h = this.hostname || "";
        this.host = h + p;
        this.href += this.host;
        // strip [ and ] from the hostname
        // the host field still retains them, though
        if (ipv6Hostname) {
            this.hostname = this.hostname.substr(1, this.hostname.length - 2);
            if (rest[0] !== "/") rest = "/" + rest;
        }
    }
    // now rest is set to the post-host stuff.
    // chop off any delim chars.
    if (!$7675883b5fed53f3$var$unsafeProtocol[lowerProto]) // First, make 100% sure that any "autoEscape" chars get
    // escaped, even if encodeURIComponent doesn't think they
    // need to be.
    for(var i = 0, l = $7675883b5fed53f3$var$autoEscape.length; i < l; i++){
        var ae = $7675883b5fed53f3$var$autoEscape[i];
        if (rest.indexOf(ae) === -1) continue;
        var esc = encodeURIComponent(ae);
        if (esc === ae) esc = escape(ae);
        rest = rest.split(ae).join(esc);
    }
    // chop off from the tail first.
    var hash = rest.indexOf("#");
    if (hash !== -1) {
        // got a fragment string.
        this.hash = rest.substr(hash);
        rest = rest.slice(0, hash);
    }
    var qm = rest.indexOf("?");
    if (qm !== -1) {
        this.search = rest.substr(qm);
        this.query = rest.substr(qm + 1);
        if (parseQueryString) this.query = $2Rldr.parse(this.query);
        rest = rest.slice(0, qm);
    } else if (parseQueryString) {
        // no query string, but parseQueryString still requested
        this.search = "";
        this.query = {};
    }
    if (rest) this.pathname = rest;
    if ($7675883b5fed53f3$var$slashedProtocol[lowerProto] && this.hostname && !this.pathname) this.pathname = "/";
    //to support http.request
    if (this.pathname || this.search) {
        var p = this.pathname || "";
        var s = this.search || "";
        this.path = p + s;
    }
    // finally, reconstruct the href based on what has been validated.
    this.href = this.format();
    return this;
};
// format a parsed object into a url string
function $7675883b5fed53f3$var$urlFormat(obj) {
    // ensure it's an object, and not a string url.
    // If it's an obj, this is a no-op.
    // this way, you can call url_format() on strings
    // to clean up potentially wonky urls.
    if ($93MWl.isString(obj)) obj = $7675883b5fed53f3$var$urlParse(obj);
    if (!(obj instanceof $7675883b5fed53f3$var$Url)) return $7675883b5fed53f3$var$Url.prototype.format.call(obj);
    return obj.format();
}
$7675883b5fed53f3$var$Url.prototype.format = function() {
    var auth = this.auth || "";
    if (auth) {
        auth = encodeURIComponent(auth);
        auth = auth.replace(/%3A/i, ":");
        auth += "@";
    }
    var protocol = this.protocol || "", pathname = this.pathname || "", hash = this.hash || "", host = false, query = "";
    if (this.host) host = auth + this.host;
    else if (this.hostname) {
        host = auth + (this.hostname.indexOf(":") === -1 ? this.hostname : "[" + this.hostname + "]");
        if (this.port) host += ":" + this.port;
    }
    if (this.query && $93MWl.isObject(this.query) && Object.keys(this.query).length) query = $2Rldr.stringify(this.query);
    var search = this.search || query && "?" + query || "";
    if (protocol && protocol.substr(-1) !== ":") protocol += ":";
    // only the slashedProtocols get the //.  Not mailto:, xmpp:, etc.
    // unless they had them to begin with.
    if (this.slashes || (!protocol || $7675883b5fed53f3$var$slashedProtocol[protocol]) && host !== false) {
        host = "//" + (host || "");
        if (pathname && pathname.charAt(0) !== "/") pathname = "/" + pathname;
    } else if (!host) host = "";
    if (hash && hash.charAt(0) !== "#") hash = "#" + hash;
    if (search && search.charAt(0) !== "?") search = "?" + search;
    pathname = pathname.replace(/[?#]/g, function(match) {
        return encodeURIComponent(match);
    });
    search = search.replace("#", "%23");
    return protocol + host + pathname + search + hash;
};
function $7675883b5fed53f3$var$urlResolve(source, relative) {
    return $7675883b5fed53f3$var$urlParse(source, false, true).resolve(relative);
}
$7675883b5fed53f3$var$Url.prototype.resolve = function(relative) {
    return this.resolveObject($7675883b5fed53f3$var$urlParse(relative, false, true)).format();
};
function $7675883b5fed53f3$var$urlResolveObject(source, relative) {
    if (!source) return relative;
    return $7675883b5fed53f3$var$urlParse(source, false, true).resolveObject(relative);
}
$7675883b5fed53f3$var$Url.prototype.resolveObject = function(relative) {
    if ($93MWl.isString(relative)) {
        var rel = new $7675883b5fed53f3$var$Url();
        rel.parse(relative, false, true);
        relative = rel;
    }
    var result = new $7675883b5fed53f3$var$Url();
    var tkeys = Object.keys(this);
    for(var tk = 0; tk < tkeys.length; tk++){
        var tkey = tkeys[tk];
        result[tkey] = this[tkey];
    }
    // hash is always overridden, no matter what.
    // even href="" will remove it.
    result.hash = relative.hash;
    // if the relative url is empty, then there's nothing left to do here.
    if (relative.href === "") {
        result.href = result.format();
        return result;
    }
    // hrefs like //foo/bar always cut to the protocol.
    if (relative.slashes && !relative.protocol) {
        // take everything except the protocol from relative
        var rkeys = Object.keys(relative);
        for(var rk = 0; rk < rkeys.length; rk++){
            var rkey = rkeys[rk];
            if (rkey !== "protocol") result[rkey] = relative[rkey];
        }
        //urlParse appends trailing / to urls like http://www.example.com
        if ($7675883b5fed53f3$var$slashedProtocol[result.protocol] && result.hostname && !result.pathname) result.path = result.pathname = "/";
        result.href = result.format();
        return result;
    }
    if (relative.protocol && relative.protocol !== result.protocol) {
        // if it's a known url protocol, then changing
        // the protocol does weird things
        // first, if it's not file:, then we MUST have a host,
        // and if there was a path
        // to begin with, then we MUST have a path.
        // if it is file:, then the host is dropped,
        // because that's known to be hostless.
        // anything else is assumed to be absolute.
        if (!$7675883b5fed53f3$var$slashedProtocol[relative.protocol]) {
            var keys = Object.keys(relative);
            for(var v = 0; v < keys.length; v++){
                var k = keys[v];
                result[k] = relative[k];
            }
            result.href = result.format();
            return result;
        }
        result.protocol = relative.protocol;
        if (!relative.host && !$7675883b5fed53f3$var$hostlessProtocol[relative.protocol]) {
            var relPath = (relative.pathname || "").split("/");
            while(relPath.length && !(relative.host = relPath.shift()));
            if (!relative.host) relative.host = "";
            if (!relative.hostname) relative.hostname = "";
            if (relPath[0] !== "") relPath.unshift("");
            if (relPath.length < 2) relPath.unshift("");
            result.pathname = relPath.join("/");
        } else result.pathname = relative.pathname;
        result.search = relative.search;
        result.query = relative.query;
        result.host = relative.host || "";
        result.auth = relative.auth;
        result.hostname = relative.hostname || relative.host;
        result.port = relative.port;
        // to support http.request
        if (result.pathname || result.search) {
            var p = result.pathname || "";
            var s = result.search || "";
            result.path = p + s;
        }
        result.slashes = result.slashes || relative.slashes;
        result.href = result.format();
        return result;
    }
    var isSourceAbs = result.pathname && result.pathname.charAt(0) === "/", isRelAbs = relative.host || relative.pathname && relative.pathname.charAt(0) === "/", mustEndAbs = isRelAbs || isSourceAbs || result.host && relative.pathname, removeAllDots = mustEndAbs, srcPath = result.pathname && result.pathname.split("/") || [], relPath = relative.pathname && relative.pathname.split("/") || [], psychotic = result.protocol && !$7675883b5fed53f3$var$slashedProtocol[result.protocol];
    // if the url is a non-slashed url, then relative
    // links like ../.. should be able
    // to crawl up to the hostname, as well.  This is strange.
    // result.protocol has already been set by now.
    // Later on, put the first path part into the host field.
    if (psychotic) {
        result.hostname = "";
        result.port = null;
        if (result.host) {
            if (srcPath[0] === "") srcPath[0] = result.host;
            else srcPath.unshift(result.host);
        }
        result.host = "";
        if (relative.protocol) {
            relative.hostname = null;
            relative.port = null;
            if (relative.host) {
                if (relPath[0] === "") relPath[0] = relative.host;
                else relPath.unshift(relative.host);
            }
            relative.host = null;
        }
        mustEndAbs = mustEndAbs && (relPath[0] === "" || srcPath[0] === "");
    }
    if (isRelAbs) {
        // it's absolute.
        result.host = relative.host || relative.host === "" ? relative.host : result.host;
        result.hostname = relative.hostname || relative.hostname === "" ? relative.hostname : result.hostname;
        result.search = relative.search;
        result.query = relative.query;
        srcPath = relPath;
    // fall through to the dot-handling below.
    } else if (relPath.length) {
        // it's relative
        // throw away the existing file, and take the new path instead.
        if (!srcPath) srcPath = [];
        srcPath.pop();
        srcPath = srcPath.concat(relPath);
        result.search = relative.search;
        result.query = relative.query;
    } else if (!$93MWl.isNullOrUndefined(relative.search)) {
        // just pull out the search.
        // like href='?foo'.
        // Put this after the other two cases because it simplifies the booleans
        if (psychotic) {
            result.hostname = result.host = srcPath.shift();
            //occationaly the auth can get stuck only in host
            //this especially happens in cases like
            //url.resolveObject('mailto:local1@domain1', 'local2@domain2')
            var authInHost = result.host && result.host.indexOf("@") > 0 ? result.host.split("@") : false;
            if (authInHost) {
                result.auth = authInHost.shift();
                result.host = result.hostname = authInHost.shift();
            }
        }
        result.search = relative.search;
        result.query = relative.query;
        //to support http.request
        if (!$93MWl.isNull(result.pathname) || !$93MWl.isNull(result.search)) result.path = (result.pathname ? result.pathname : "") + (result.search ? result.search : "");
        result.href = result.format();
        return result;
    }
    if (!srcPath.length) {
        // no path at all.  easy.
        // we've already handled the other stuff above.
        result.pathname = null;
        //to support http.request
        if (result.search) result.path = "/" + result.search;
        else result.path = null;
        result.href = result.format();
        return result;
    }
    // if a url ENDs in . or .., then it must get a trailing slash.
    // however, if it ends in anything else non-slashy,
    // then it must NOT get a trailing slash.
    var last = srcPath.slice(-1)[0];
    var hasTrailingSlash = (result.host || relative.host || srcPath.length > 1) && (last === "." || last === "..") || last === "";
    // strip single dots, resolve double dots to parent dir
    // if the path tries to go above the root, `up` ends up > 0
    var up = 0;
    for(var i = srcPath.length; i >= 0; i--){
        last = srcPath[i];
        if (last === ".") srcPath.splice(i, 1);
        else if (last === "..") {
            srcPath.splice(i, 1);
            up++;
        } else if (up) {
            srcPath.splice(i, 1);
            up--;
        }
    }
    // if the path is allowed to go above the root, restore leading ..s
    if (!mustEndAbs && !removeAllDots) for(; up--; up)srcPath.unshift("..");
    if (mustEndAbs && srcPath[0] !== "" && (!srcPath[0] || srcPath[0].charAt(0) !== "/")) srcPath.unshift("");
    if (hasTrailingSlash && srcPath.join("/").substr(-1) !== "/") srcPath.push("");
    var isAbsolute = srcPath[0] === "" || srcPath[0] && srcPath[0].charAt(0) === "/";
    // put the host back
    if (psychotic) {
        result.hostname = result.host = isAbsolute ? "" : srcPath.length ? srcPath.shift() : "";
        //occationaly the auth can get stuck only in host
        //this especially happens in cases like
        //url.resolveObject('mailto:local1@domain1', 'local2@domain2')
        var authInHost = result.host && result.host.indexOf("@") > 0 ? result.host.split("@") : false;
        if (authInHost) {
            result.auth = authInHost.shift();
            result.host = result.hostname = authInHost.shift();
        }
    }
    mustEndAbs = mustEndAbs || result.host && srcPath.length;
    if (mustEndAbs && !isAbsolute) srcPath.unshift("");
    if (!srcPath.length) {
        result.pathname = null;
        result.path = null;
    } else result.pathname = srcPath.join("/");
    //to support request.http
    if (!$93MWl.isNull(result.pathname) || !$93MWl.isNull(result.search)) result.path = (result.pathname ? result.pathname : "") + (result.search ? result.search : "");
    result.auth = relative.auth || result.auth;
    result.slashes = result.slashes || relative.slashes;
    result.href = result.format();
    return result;
};
$7675883b5fed53f3$var$Url.prototype.parseHost = function() {
    var host = this.host;
    var port = $7675883b5fed53f3$var$portPattern.exec(host);
    if (port) {
        port = port[0];
        if (port !== ":") this.port = port.substr(1);
        host = host.substr(0, host.length - port.length);
    }
    if (host) this.hostname = host;
};

});
parcelRequire.register("z7No8", function(module, exports) {
(function(root) {
    /** Detect free variables */ var freeExports = exports && !exports.nodeType && exports;
    var freeModule = module && !module.nodeType && module;
    var freeGlobal = typeof $parcel$global == "object" && $parcel$global;
    if (freeGlobal.global === freeGlobal || freeGlobal.window === freeGlobal || freeGlobal.self === freeGlobal) root = freeGlobal;
    /**
	 * The `punycode` object.
	 * @name punycode
	 * @type Object
	 */ var punycode, /** Highest positive signed 32-bit float value */ maxInt = 2147483647, /** Bootstring parameters */ base = 36, tMin = 1, tMax = 26, skew = 38, damp = 700, initialBias = 72, initialN = 128, delimiter = "-", /** Regular expressions */ regexPunycode = /^xn--/, regexNonASCII = /[^\x20-\x7E]/, regexSeparators = /[\x2E\u3002\uFF0E\uFF61]/g, /** Error messages */ errors = {
        "overflow": "Overflow: input needs wider integers to process",
        "not-basic": "Illegal input >= 0x80 (not a basic code point)",
        "invalid-input": "Invalid input"
    }, /** Convenience shortcuts */ baseMinusTMin = base - tMin, floor = Math.floor, stringFromCharCode = String.fromCharCode, /** Temporary variable */ key;
    /*--------------------------------------------------------------------------*/ /**
	 * A generic error utility function.
	 * @private
	 * @param {String} type The error type.
	 * @returns {Error} Throws a `RangeError` with the applicable error message.
	 */ function error(type) {
        throw RangeError(errors[type]);
    }
    /**
	 * A generic `Array#map` utility function.
	 * @private
	 * @param {Array} array The array to iterate over.
	 * @param {Function} callback The function that gets called for every array
	 * item.
	 * @returns {Array} A new array of values returned by the callback function.
	 */ function map(array, fn) {
        var length = array.length;
        var result = [];
        while(length--)result[length] = fn(array[length]);
        return result;
    }
    /**
	 * A simple `Array#map`-like wrapper to work with domain name strings or email
	 * addresses.
	 * @private
	 * @param {String} domain The domain name or email address.
	 * @param {Function} callback The function that gets called for every
	 * character.
	 * @returns {Array} A new string of characters returned by the callback
	 * function.
	 */ function mapDomain(string, fn) {
        var parts = string.split("@");
        var result = "";
        if (parts.length > 1) {
            // In email addresses, only the domain name should be punycoded. Leave
            // the local part (i.e. everything up to `@`) intact.
            result = parts[0] + "@";
            string = parts[1];
        }
        // Avoid `split(regex)` for IE8 compatibility. See #17.
        string = string.replace(regexSeparators, ".");
        var labels = string.split(".");
        var encoded = map(labels, fn).join(".");
        return result + encoded;
    }
    /**
	 * Creates an array containing the numeric code points of each Unicode
	 * character in the string. While JavaScript uses UCS-2 internally,
	 * this function will convert a pair of surrogate halves (each of which
	 * UCS-2 exposes as separate characters) into a single code point,
	 * matching UTF-16.
	 * @see `punycode.ucs2.encode`
	 * @see <https://mathiasbynens.be/notes/javascript-encoding>
	 * @memberOf punycode.ucs2
	 * @name decode
	 * @param {String} string The Unicode input string (UCS-2).
	 * @returns {Array} The new array of code points.
	 */ function ucs2decode(string) {
        var output = [], counter = 0, length = string.length, value, extra;
        while(counter < length){
            value = string.charCodeAt(counter++);
            if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
                // high surrogate, and there is a next character
                extra = string.charCodeAt(counter++);
                if ((extra & 0xFC00) == 0xDC00) output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
                else {
                    // unmatched surrogate; only append this code unit, in case the next
                    // code unit is the high surrogate of a surrogate pair
                    output.push(value);
                    counter--;
                }
            } else output.push(value);
        }
        return output;
    }
    /**
	 * Creates a string based on an array of numeric code points.
	 * @see `punycode.ucs2.decode`
	 * @memberOf punycode.ucs2
	 * @name encode
	 * @param {Array} codePoints The array of numeric code points.
	 * @returns {String} The new Unicode string (UCS-2).
	 */ function ucs2encode(array) {
        return map(array, function(value) {
            var output = "";
            if (value > 0xFFFF) {
                value -= 0x10000;
                output += stringFromCharCode(value >>> 10 & 0x3FF | 0xD800);
                value = 0xDC00 | value & 0x3FF;
            }
            output += stringFromCharCode(value);
            return output;
        }).join("");
    }
    /**
	 * Converts a basic code point into a digit/integer.
	 * @see `digitToBasic()`
	 * @private
	 * @param {Number} codePoint The basic numeric code point value.
	 * @returns {Number} The numeric value of a basic code point (for use in
	 * representing integers) in the range `0` to `base - 1`, or `base` if
	 * the code point does not represent a value.
	 */ function basicToDigit(codePoint) {
        if (codePoint - 48 < 10) return codePoint - 22;
        if (codePoint - 65 < 26) return codePoint - 65;
        if (codePoint - 97 < 26) return codePoint - 97;
        return base;
    }
    /**
	 * Converts a digit/integer into a basic code point.
	 * @see `basicToDigit()`
	 * @private
	 * @param {Number} digit The numeric value of a basic code point.
	 * @returns {Number} The basic code point whose value (when used for
	 * representing integers) is `digit`, which needs to be in the range
	 * `0` to `base - 1`. If `flag` is non-zero, the uppercase form is
	 * used; else, the lowercase form is used. The behavior is undefined
	 * if `flag` is non-zero and `digit` has no uppercase form.
	 */ function digitToBasic(digit, flag) {
        //  0..25 map to ASCII a..z or A..Z
        // 26..35 map to ASCII 0..9
        return digit + 22 + 75 * (digit < 26) - ((flag != 0) << 5);
    }
    /**
	 * Bias adaptation function as per section 3.4 of RFC 3492.
	 * http://tools.ietf.org/html/rfc3492#section-3.4
	 * @private
	 */ function adapt(delta, numPoints, firstTime) {
        var k = 0;
        delta = firstTime ? floor(delta / damp) : delta >> 1;
        delta += floor(delta / numPoints);
        for(; delta > baseMinusTMin * tMax >> 1; k += base)delta = floor(delta / baseMinusTMin);
        return floor(k + (baseMinusTMin + 1) * delta / (delta + skew));
    }
    /**
	 * Converts a Punycode string of ASCII-only symbols to a string of Unicode
	 * symbols.
	 * @memberOf punycode
	 * @param {String} input The Punycode string of ASCII-only symbols.
	 * @returns {String} The resulting string of Unicode symbols.
	 */ function decode(input) {
        // Don't use UCS-2
        var output = [], inputLength = input.length, out, i = 0, n = initialN, bias = initialBias, basic, j, index, oldi, w, k, digit, t, /** Cached calculation results */ baseMinusT;
        // Handle the basic code points: let `basic` be the number of input code
        // points before the last delimiter, or `0` if there is none, then copy
        // the first basic code points to the output.
        basic = input.lastIndexOf(delimiter);
        if (basic < 0) basic = 0;
        for(j = 0; j < basic; ++j){
            // if it's not a basic code point
            if (input.charCodeAt(j) >= 0x80) error("not-basic");
            output.push(input.charCodeAt(j));
        }
        // Main decoding loop: start just after the last delimiter if any basic code
        // points were copied; start at the beginning otherwise.
        for(index = basic > 0 ? basic + 1 : 0; index < inputLength;){
            // `index` is the index of the next character to be consumed.
            // Decode a generalized variable-length integer into `delta`,
            // which gets added to `i`. The overflow checking is easier
            // if we increase `i` as we go, then subtract off its starting
            // value at the end to obtain `delta`.
            for(oldi = i, w = 1, k = base;; k += base){
                if (index >= inputLength) error("invalid-input");
                digit = basicToDigit(input.charCodeAt(index++));
                if (digit >= base || digit > floor((maxInt - i) / w)) error("overflow");
                i += digit * w;
                t = k <= bias ? tMin : k >= bias + tMax ? tMax : k - bias;
                if (digit < t) break;
                baseMinusT = base - t;
                if (w > floor(maxInt / baseMinusT)) error("overflow");
                w *= baseMinusT;
            }
            out = output.length + 1;
            bias = adapt(i - oldi, out, oldi == 0);
            // `i` was supposed to wrap around from `out` to `0`,
            // incrementing `n` each time, so we'll fix that now:
            if (floor(i / out) > maxInt - n) error("overflow");
            n += floor(i / out);
            i %= out;
            // Insert `n` at position `i` of the output
            output.splice(i++, 0, n);
        }
        return ucs2encode(output);
    }
    /**
	 * Converts a string of Unicode symbols (e.g. a domain name label) to a
	 * Punycode string of ASCII-only symbols.
	 * @memberOf punycode
	 * @param {String} input The string of Unicode symbols.
	 * @returns {String} The resulting Punycode string of ASCII-only symbols.
	 */ function encode(input) {
        var n, delta, handledCPCount, basicLength, bias, j, m, q, k, t, currentValue, output = [], /** `inputLength` will hold the number of code points in `input`. */ inputLength, /** Cached calculation results */ handledCPCountPlusOne, baseMinusT, qMinusT;
        // Convert the input in UCS-2 to Unicode
        input = ucs2decode(input);
        // Cache the length
        inputLength = input.length;
        // Initialize the state
        n = initialN;
        delta = 0;
        bias = initialBias;
        // Handle the basic code points
        for(j = 0; j < inputLength; ++j){
            currentValue = input[j];
            if (currentValue < 0x80) output.push(stringFromCharCode(currentValue));
        }
        handledCPCount = basicLength = output.length;
        // `handledCPCount` is the number of code points that have been handled;
        // `basicLength` is the number of basic code points.
        // Finish the basic string - if it is not empty - with a delimiter
        if (basicLength) output.push(delimiter);
        // Main encoding loop:
        while(handledCPCount < inputLength){
            // All non-basic code points < n have been handled already. Find the next
            // larger one:
            for(m = maxInt, j = 0; j < inputLength; ++j){
                currentValue = input[j];
                if (currentValue >= n && currentValue < m) m = currentValue;
            }
            // Increase `delta` enough to advance the decoder's <n,i> state to <m,0>,
            // but guard against overflow
            handledCPCountPlusOne = handledCPCount + 1;
            if (m - n > floor((maxInt - delta) / handledCPCountPlusOne)) error("overflow");
            delta += (m - n) * handledCPCountPlusOne;
            n = m;
            for(j = 0; j < inputLength; ++j){
                currentValue = input[j];
                if (currentValue < n && ++delta > maxInt) error("overflow");
                if (currentValue == n) {
                    // Represent delta as a generalized variable-length integer
                    for(q = delta, k = base;; k += base){
                        t = k <= bias ? tMin : k >= bias + tMax ? tMax : k - bias;
                        if (q < t) break;
                        qMinusT = q - t;
                        baseMinusT = base - t;
                        output.push(stringFromCharCode(digitToBasic(t + qMinusT % baseMinusT, 0)));
                        q = floor(qMinusT / baseMinusT);
                    }
                    output.push(stringFromCharCode(digitToBasic(q, 0)));
                    bias = adapt(delta, handledCPCountPlusOne, handledCPCount == basicLength);
                    delta = 0;
                    ++handledCPCount;
                }
            }
            ++delta;
            ++n;
        }
        return output.join("");
    }
    /**
	 * Converts a Punycode string representing a domain name or an email address
	 * to Unicode. Only the Punycoded parts of the input will be converted, i.e.
	 * it doesn't matter if you call it on a string that has already been
	 * converted to Unicode.
	 * @memberOf punycode
	 * @param {String} input The Punycoded domain name or email address to
	 * convert to Unicode.
	 * @returns {String} The Unicode representation of the given Punycode
	 * string.
	 */ function toUnicode(input) {
        return mapDomain(input, function(string) {
            return regexPunycode.test(string) ? decode(string.slice(4).toLowerCase()) : string;
        });
    }
    /**
	 * Converts a Unicode string representing a domain name or an email address to
	 * Punycode. Only the non-ASCII parts of the domain name will be converted,
	 * i.e. it doesn't matter if you call it with a domain that's already in
	 * ASCII.
	 * @memberOf punycode
	 * @param {String} input The domain name or email address to convert, as a
	 * Unicode string.
	 * @returns {String} The Punycode representation of the given domain name or
	 * email address.
	 */ function toASCII(input) {
        return mapDomain(input, function(string) {
            return regexNonASCII.test(string) ? "xn--" + encode(string) : string;
        });
    }
    /*--------------------------------------------------------------------------*/ /** Define the public API */ punycode = {
        /**
		 * A string representing the current Punycode.js version number.
		 * @memberOf punycode
		 * @type String
		 */ "version": "1.3.2",
        /**
		 * An object of methods to convert from JavaScript's internal character
		 * representation (UCS-2) to Unicode code points, and back.
		 * @see <https://mathiasbynens.be/notes/javascript-encoding>
		 * @memberOf punycode
		 * @type Object
		 */ "ucs2": {
            "decode": ucs2decode,
            "encode": ucs2encode
        },
        "decode": decode,
        "encode": encode,
        "toASCII": toASCII,
        "toUnicode": toUnicode
    };
    /** Expose `punycode` */ // Some AMD build optimizers, like r.js, check for specific condition patterns
    // like the following:
    if (typeof define == "function" && typeof define.amd == "object" && define.amd) define("punycode", function() {
        return punycode;
    });
    else if (freeExports && freeModule) {
        if (module.exports == freeExports) freeModule.exports = punycode;
        else for(key in punycode)punycode.hasOwnProperty(key) && (freeExports[key] = punycode[key]);
    } else root.punycode = punycode;
})(this);

});

parcelRequire.register("93MWl", function(module, exports) {
"use strict";
module.exports = {
    isString: function(arg) {
        return typeof arg === "string";
    },
    isObject: function(arg) {
        return typeof arg === "object" && arg !== null;
    },
    isNull: function(arg) {
        return arg === null;
    },
    isNullOrUndefined: function(arg) {
        return arg == null;
    }
};

});

parcelRequire.register("2Rldr", function(module, exports) {

$parcel$export(module.exports, "parse", () => $2150fd001aae5564$export$98e6a39c04603d36, (v) => $2150fd001aae5564$export$98e6a39c04603d36 = v);
$parcel$export(module.exports, "stringify", () => $2150fd001aae5564$export$fac44ee5b035f737, (v) => $2150fd001aae5564$export$fac44ee5b035f737 = v);
var $2150fd001aae5564$export$2f872c0f2117be69;
var $2150fd001aae5564$export$98e6a39c04603d36;
var $2150fd001aae5564$export$c564cdbbe6da493;
var $2150fd001aae5564$export$fac44ee5b035f737;
"use strict";

$2150fd001aae5564$export$2f872c0f2117be69 = $2150fd001aae5564$export$98e6a39c04603d36 = (parcelRequire("3W7a0"));

$2150fd001aae5564$export$c564cdbbe6da493 = $2150fd001aae5564$export$fac44ee5b035f737 = (parcelRequire("gLgiH"));

});
parcelRequire.register("3W7a0", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
"use strict";
// If obj.hasOwnProperty has been overridden, then calling
// obj.hasOwnProperty(prop) will break.
// See: https://github.com/joyent/node/issues/1707
function $2ddc57ca50ccd8df$var$hasOwnProperty(obj, prop) {
    return Object.prototype.hasOwnProperty.call(obj, prop);
}
module.exports = function(qs, sep, eq, options) {
    sep = sep || "&";
    eq = eq || "=";
    var obj = {};
    if (typeof qs !== "string" || qs.length === 0) return obj;
    var regexp = /\+/g;
    qs = qs.split(sep);
    var maxKeys = 1000;
    if (options && typeof options.maxKeys === "number") maxKeys = options.maxKeys;
    var len = qs.length;
    // maxKeys <= 0 means that we should not limit keys count
    if (maxKeys > 0 && len > maxKeys) len = maxKeys;
    for(var i = 0; i < len; ++i){
        var x = qs[i].replace(regexp, "%20"), idx = x.indexOf(eq), kstr, vstr, k, v;
        if (idx >= 0) {
            kstr = x.substr(0, idx);
            vstr = x.substr(idx + 1);
        } else {
            kstr = x;
            vstr = "";
        }
        k = decodeURIComponent(kstr);
        v = decodeURIComponent(vstr);
        if (!$2ddc57ca50ccd8df$var$hasOwnProperty(obj, k)) obj[k] = v;
        else if ($2ddc57ca50ccd8df$var$isArray(obj[k])) obj[k].push(v);
        else obj[k] = [
            obj[k],
            v
        ];
    }
    return obj;
};
var $2ddc57ca50ccd8df$var$isArray = Array.isArray || function(xs) {
    return Object.prototype.toString.call(xs) === "[object Array]";
};

});

parcelRequire.register("gLgiH", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
"use strict";
var $c33dae1c20ae2a74$var$stringifyPrimitive = function(v) {
    switch(typeof v){
        case "string":
            return v;
        case "boolean":
            return v ? "true" : "false";
        case "number":
            return isFinite(v) ? v : "";
        default:
            return "";
    }
};
module.exports = function(obj, sep, eq, name) {
    sep = sep || "&";
    eq = eq || "=";
    if (obj === null) obj = undefined;
    if (typeof obj === "object") return $c33dae1c20ae2a74$var$map($c33dae1c20ae2a74$var$objectKeys(obj), function(k) {
        var ks = encodeURIComponent($c33dae1c20ae2a74$var$stringifyPrimitive(k)) + eq;
        if ($c33dae1c20ae2a74$var$isArray(obj[k])) return $c33dae1c20ae2a74$var$map(obj[k], function(v) {
            return ks + encodeURIComponent($c33dae1c20ae2a74$var$stringifyPrimitive(v));
        }).join(sep);
        else return ks + encodeURIComponent($c33dae1c20ae2a74$var$stringifyPrimitive(obj[k]));
    }).join(sep);
    if (!name) return "";
    return encodeURIComponent($c33dae1c20ae2a74$var$stringifyPrimitive(name)) + eq + encodeURIComponent($c33dae1c20ae2a74$var$stringifyPrimitive(obj));
};
var $c33dae1c20ae2a74$var$isArray = Array.isArray || function(xs) {
    return Object.prototype.toString.call(xs) === "[object Array]";
};
function $c33dae1c20ae2a74$var$map(xs, f) {
    if (xs.map) return xs.map(f);
    var res = [];
    for(var i = 0; i < xs.length; i++)res.push(f(xs[i], i));
    return res;
}
var $c33dae1c20ae2a74$var$objectKeys = Object.keys || function(obj) {
    var res = [];
    for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) res.push(key);
    return res;
};

});




parcelRequire.register("bUJWB", function(module, exports) {

var $8jiUm = parcelRequire("8jiUm");

var $aaypF = parcelRequire("aaypF");
var $8ac8903cf83e48b8$var$https = module.exports;
for(var $8ac8903cf83e48b8$var$key in $8jiUm)if ($8jiUm.hasOwnProperty($8ac8903cf83e48b8$var$key)) $8ac8903cf83e48b8$var$https[$8ac8903cf83e48b8$var$key] = $8jiUm[$8ac8903cf83e48b8$var$key];
$8ac8903cf83e48b8$var$https.request = function(params, cb) {
    params = $8ac8903cf83e48b8$var$validateParams(params);
    return $8jiUm.request.call(this, params, cb);
};
$8ac8903cf83e48b8$var$https.get = function(params, cb) {
    params = $8ac8903cf83e48b8$var$validateParams(params);
    return $8jiUm.get.call(this, params, cb);
};
function $8ac8903cf83e48b8$var$validateParams(params) {
    if (typeof params === "string") params = $aaypF.parse(params);
    if (!params.protocol) params.protocol = "https:";
    if (params.protocol !== "https:") throw new Error('Protocol "' + params.protocol + '" not supported. Expected "https:"');
    return params;
}

});


parcelRequire.register("kbu4D", function(module, exports) {

$parcel$export(module.exports, "getOCSPURI", () => $eb1c29c11a04deca$export$d13669af3ccf7e71, (v) => $eb1c29c11a04deca$export$d13669af3ccf7e71 = v);
var $eb1c29c11a04deca$export$d13669af3ccf7e71;
"use strict";

var $eRdtr = parcelRequire("eRdtr");

var $gR5sk = parcelRequire("gR5sk");

var $gR5sk = parcelRequire("gR5sk");
$eb1c29c11a04deca$export$d13669af3ccf7e71 = function getOCSPURI(rawCert, cb) {
    var ocspMethod = $gR5sk["id-pkix-ocsp"].join(".");
    var cert = $eRdtr.utils.toDER(rawCert, "CERTIFICATE");
    cert = $gR5sk.Certificate.decode(cert, "der");
    $eRdtr.utils.getAuthorityInfo(cert, ocspMethod, cb);
};

});

parcelRequire.register("bAXxn", function(module, exports) {

$parcel$export(module.exports, "generate", () => $87113d6095c5edcd$export$80d376111cc09ad7, (v) => $87113d6095c5edcd$export$80d376111cc09ad7 = v);
var $87113d6095c5edcd$export$80d376111cc09ad7;
"use strict";

var $eRdtr = parcelRequire("eRdtr");

var $BAx0W = parcelRequire("BAx0W");

var $gR5sk = parcelRequire("gR5sk");

var $gR5sk = parcelRequire("gR5sk");
function $87113d6095c5edcd$var$sha1(data) {
    return $BAx0W.createHash("sha1").update(data).digest();
}
$87113d6095c5edcd$export$80d376111cc09ad7 = function generate(rawCert, rawIssuer) {
    var cert;
    if (rawCert.tbsCertificate) cert = rawCert;
    else cert = $gR5sk.Certificate.decode($eRdtr.utils.toDER(rawCert, "CERTIFICATE"), "der");
    var issuer;
    if (rawIssuer.tbsCertificate) issuer = rawIssuer;
    else issuer = $gR5sk.Certificate.decode($eRdtr.utils.toDER(rawIssuer, "CERTIFICATE"), "der");
    var tbsCert = cert.tbsCertificate;
    var tbsIssuer = issuer.tbsCertificate;
    var certID = {
        hashAlgorithm: {
            // algorithm: [ 2, 16, 840, 1, 101, 3, 4, 2, 1 ]  // sha256
            algorithm: [
                1,
                3,
                14,
                3,
                2,
                26
            ] // sha1
        },
        issuerNameHash: $87113d6095c5edcd$var$sha1($gR5sk.Name.encode(tbsCert.issuer, "der")),
        issuerKeyHash: $87113d6095c5edcd$var$sha1(tbsIssuer.subjectPublicKeyInfo.subjectPublicKey.data),
        serialNumber: tbsCert.serialNumber
    };
    var tbs = {
        version: "v1",
        requestList: [
            {
                reqCert: certID
            }
        ],
        requestExtensions: [
            {
                extnID: $gR5sk["id-pkix-ocsp-nonce"],
                critical: false,
                extnValue: $gR5sk.Nonce.encode($BAx0W.randomBytes(16), "der")
            }
        ]
    };
    var req = {
        tbsRequest: tbs
    };
    return {
        id: $87113d6095c5edcd$var$sha1($gR5sk.CertID.encode(certID, "der")),
        certID: certID,
        data: $gR5sk.OCSPRequest.encode(req, "der"),
        // Just to avoid re-parsing DER
        cert: cert,
        issuer: issuer
    };
};

});
parcelRequire.register("BAx0W", function(module, exports) {

$parcel$export(module.exports, "randomBytes", () => $070fcb35735bb9b5$export$5f828d93ff035aa8, (v) => $070fcb35735bb9b5$export$5f828d93ff035aa8 = v);
$parcel$export(module.exports, "createHash", () => $070fcb35735bb9b5$export$2fb37efbf6ae0c0e, (v) => $070fcb35735bb9b5$export$2fb37efbf6ae0c0e = v);
$parcel$export(module.exports, "createVerify", () => $070fcb35735bb9b5$export$6f65485f87568e37, (v) => $070fcb35735bb9b5$export$6f65485f87568e37 = v);
var $070fcb35735bb9b5$export$5f828d93ff035aa8;
var $070fcb35735bb9b5$export$cd94982b18c6332c;
var $070fcb35735bb9b5$export$1d518568e4f529b0;
var $070fcb35735bb9b5$export$5285b6d41c912b41;
var $070fcb35735bb9b5$export$2fb37efbf6ae0c0e;
var $070fcb35735bb9b5$export$ab85ecd77ce6a5cd;
var $070fcb35735bb9b5$export$da39cf97e1eb7c91;
var $070fcb35735bb9b5$export$52a9039d7177394f;
var $070fcb35735bb9b5$export$f7201db400317331;
var $070fcb35735bb9b5$export$448fa22aedc9dbca;
var $070fcb35735bb9b5$export$b80c7ba289c8fa56;
var $070fcb35735bb9b5$export$26e5786e8ac8e530;
var $070fcb35735bb9b5$export$bdd223f16383713e;
var $070fcb35735bb9b5$export$20533d26f07f1ee0;
var $070fcb35735bb9b5$export$2f64596b8cbf08b4;
var $070fcb35735bb9b5$export$2ce6d8d0e8b04e1a;
var $070fcb35735bb9b5$export$12ada9414fbc594c;
var $070fcb35735bb9b5$export$f5e7e39d57cd9700;
var $070fcb35735bb9b5$export$36b6d6ef312eab39;
var $070fcb35735bb9b5$export$58a258485f1e49f6;
var $070fcb35735bb9b5$export$dedd8dc3dc62b370;
var $070fcb35735bb9b5$export$971862a2fcb1bb40;
var $070fcb35735bb9b5$export$c6ff6a88acbeaf40;
var $070fcb35735bb9b5$export$fdc27893e98845cc;
var $070fcb35735bb9b5$export$6671fb9a1323bed;
var $070fcb35735bb9b5$export$d74daf141a551db;
var $070fcb35735bb9b5$export$45df7cae684751af;
var $070fcb35735bb9b5$export$1db683ad541682f6;
var $070fcb35735bb9b5$export$6f65485f87568e37;
var $070fcb35735bb9b5$export$91a8e56769aeb334;
var $070fcb35735bb9b5$export$2d4117e99c2179e4;
var $070fcb35735bb9b5$export$512823e338ddb1b7;
var $070fcb35735bb9b5$export$9d0e0c0c4a8d30f3;
var $070fcb35735bb9b5$export$b9d55ff329113abd;
var $070fcb35735bb9b5$export$7efb24e2fddf99b9;
var $070fcb35735bb9b5$export$bb1abf2ce84fc7e8;
var $070fcb35735bb9b5$export$2f7171e78e524d5e;
var $070fcb35735bb9b5$export$e1d879b482f37d98;
var $070fcb35735bb9b5$export$1a988e7317c65621;
"use strict";

$070fcb35735bb9b5$export$5f828d93ff035aa8 = $070fcb35735bb9b5$export$cd94982b18c6332c = $070fcb35735bb9b5$export$1d518568e4f529b0 = $070fcb35735bb9b5$export$5285b6d41c912b41 = (parcelRequire("cGE0H"));

$070fcb35735bb9b5$export$2fb37efbf6ae0c0e = $070fcb35735bb9b5$export$ab85ecd77ce6a5cd = (parcelRequire("bptsJ"));

$070fcb35735bb9b5$export$da39cf97e1eb7c91 = $070fcb35735bb9b5$export$52a9039d7177394f = (parcelRequire("7oblv"));

var $g3qIi = parcelRequire("g3qIi");
var $070fcb35735bb9b5$var$algoKeys = Object.keys($g3qIi);
var $070fcb35735bb9b5$var$hashes = [
    "sha1",
    "sha224",
    "sha256",
    "sha384",
    "sha512",
    "md5",
    "rmd160"
].concat($070fcb35735bb9b5$var$algoKeys);
$070fcb35735bb9b5$export$f7201db400317331 = function() {
    return $070fcb35735bb9b5$var$hashes;
};

var $cW6k9 = parcelRequire("cW6k9");
$070fcb35735bb9b5$export$448fa22aedc9dbca = $cW6k9.pbkdf2;
$070fcb35735bb9b5$export$b80c7ba289c8fa56 = $cW6k9.pbkdf2Sync;

var $jZo93 = parcelRequire("jZo93");
$070fcb35735bb9b5$export$26e5786e8ac8e530 = $jZo93.Cipher;
$070fcb35735bb9b5$export$bdd223f16383713e = $jZo93.createCipher;
$070fcb35735bb9b5$export$20533d26f07f1ee0 = $jZo93.Cipheriv;
$070fcb35735bb9b5$export$2f64596b8cbf08b4 = $jZo93.createCipheriv;
$070fcb35735bb9b5$export$2ce6d8d0e8b04e1a = $jZo93.Decipher;
$070fcb35735bb9b5$export$12ada9414fbc594c = $jZo93.createDecipher;
$070fcb35735bb9b5$export$f5e7e39d57cd9700 = $jZo93.Decipheriv;
$070fcb35735bb9b5$export$36b6d6ef312eab39 = $jZo93.createDecipheriv;
$070fcb35735bb9b5$export$58a258485f1e49f6 = $jZo93.getCiphers;
$070fcb35735bb9b5$export$dedd8dc3dc62b370 = $jZo93.listCiphers;

var $20Y99 = parcelRequire("20Y99");
$070fcb35735bb9b5$export$971862a2fcb1bb40 = $20Y99.DiffieHellmanGroup;
$070fcb35735bb9b5$export$c6ff6a88acbeaf40 = $20Y99.createDiffieHellmanGroup;
$070fcb35735bb9b5$export$fdc27893e98845cc = $20Y99.getDiffieHellman;
$070fcb35735bb9b5$export$6671fb9a1323bed = $20Y99.createDiffieHellman;
$070fcb35735bb9b5$export$d74daf141a551db = $20Y99.DiffieHellman;

var $csM0q = parcelRequire("csM0q");
$070fcb35735bb9b5$export$45df7cae684751af = $csM0q.createSign;
$070fcb35735bb9b5$export$1db683ad541682f6 = $csM0q.Sign;
$070fcb35735bb9b5$export$6f65485f87568e37 = $csM0q.createVerify;
$070fcb35735bb9b5$export$91a8e56769aeb334 = $csM0q.Verify;

$070fcb35735bb9b5$export$2d4117e99c2179e4 = (parcelRequire("kcZqP"));

var $8oEn1 = parcelRequire("8oEn1");
$070fcb35735bb9b5$export$512823e338ddb1b7 = $8oEn1.publicEncrypt;
$070fcb35735bb9b5$export$9d0e0c0c4a8d30f3 = $8oEn1.privateEncrypt;
$070fcb35735bb9b5$export$b9d55ff329113abd = $8oEn1.publicDecrypt;
$070fcb35735bb9b5$export$7efb24e2fddf99b9 = $8oEn1.privateDecrypt;

var $205kZ = parcelRequire("205kZ");
$070fcb35735bb9b5$export$bb1abf2ce84fc7e8 = $205kZ.randomFill;
$070fcb35735bb9b5$export$2f7171e78e524d5e = $205kZ.randomFillSync;
$070fcb35735bb9b5$export$e1d879b482f37d98 = function() {
    throw new Error([
        "sorry, createCredentials is not implemented yet",
        "we accept pull requests",
        "https://github.com/crypto-browserify/crypto-browserify"
    ].join("\n"));
};
$070fcb35735bb9b5$export$1a988e7317c65621 = {
    "DH_CHECK_P_NOT_SAFE_PRIME": 2,
    "DH_CHECK_P_NOT_PRIME": 1,
    "DH_UNABLE_TO_CHECK_GENERATOR": 4,
    "DH_NOT_SUITABLE_GENERATOR": 8,
    "NPN_ENABLED": 1,
    "ALPN_ENABLED": 1,
    "RSA_PKCS1_PADDING": 1,
    "RSA_SSLV23_PADDING": 2,
    "RSA_NO_PADDING": 3,
    "RSA_PKCS1_OAEP_PADDING": 4,
    "RSA_X931_PADDING": 5,
    "RSA_PKCS1_PSS_PADDING": 6,
    "POINT_CONVERSION_COMPRESSED": 2,
    "POINT_CONVERSION_UNCOMPRESSED": 4,
    "POINT_CONVERSION_HYBRID": 6
};

});
parcelRequire.register("cGE0H", function(module, exports) {

var $hIXGI = parcelRequire("hIXGI");
"use strict";
// limit of Crypto.getRandomValues()
// https://developer.mozilla.org/en-US/docs/Web/API/Crypto/getRandomValues
var $93c8718099b604a9$var$MAX_BYTES = 65536;
// Node supports requesting up to this number of bytes
// https://github.com/nodejs/node/blob/master/lib/internal/crypto/random.js#L48
var $93c8718099b604a9$var$MAX_UINT32 = 4294967295;
function $93c8718099b604a9$var$oldBrowser() {
    throw new Error("Secure random number generation is not supported by this browser.\nUse Chrome, Firefox or Internet Explorer 11");
}

var $3pA6p = parcelRequire("3pA6p");
var $93c8718099b604a9$require$Buffer = $3pA6p.Buffer;
var $93c8718099b604a9$var$crypto = $parcel$global.crypto || $parcel$global.msCrypto;
if ($93c8718099b604a9$var$crypto && $93c8718099b604a9$var$crypto.getRandomValues) module.exports = $93c8718099b604a9$var$randomBytes;
else module.exports = $93c8718099b604a9$var$oldBrowser;
function $93c8718099b604a9$var$randomBytes(size, cb) {
    // phantomjs needs to throw
    if (size > $93c8718099b604a9$var$MAX_UINT32) throw new RangeError("requested too many random bytes");
    var bytes = $93c8718099b604a9$require$Buffer.allocUnsafe(size);
    if (size > 0) {
        if (size > $93c8718099b604a9$var$MAX_BYTES) // can do at once see https://developer.mozilla.org/en-US/docs/Web/API/window.crypto.getRandomValues
        for(var generated = 0; generated < size; generated += $93c8718099b604a9$var$MAX_BYTES)// buffer.slice automatically checks if the end is past the end of
        // the buffer so we don't have to here
        $93c8718099b604a9$var$crypto.getRandomValues(bytes.slice(generated, generated + $93c8718099b604a9$var$MAX_BYTES));
        else $93c8718099b604a9$var$crypto.getRandomValues(bytes);
    }
    if (typeof cb === "function") return $hIXGI.nextTick(function() {
        cb(null, bytes);
    });
    return bytes;
}

});
parcelRequire.register("3pA6p", function(module, exports) {
/* eslint-disable node/no-deprecated-api */ 
var $iuRmA = parcelRequire("iuRmA");
var $27bfb6147ea22d2d$var$Buffer = $iuRmA.Buffer;
// alternative to using Object.keys for old browsers
function $27bfb6147ea22d2d$var$copyProps(src, dst) {
    for(var key in src)dst[key] = src[key];
}
if ($27bfb6147ea22d2d$var$Buffer.from && $27bfb6147ea22d2d$var$Buffer.alloc && $27bfb6147ea22d2d$var$Buffer.allocUnsafe && $27bfb6147ea22d2d$var$Buffer.allocUnsafeSlow) module.exports = $iuRmA;
else {
    // Copy properties from require('buffer')
    $27bfb6147ea22d2d$var$copyProps($iuRmA, module.exports);
    module.exports.Buffer = $27bfb6147ea22d2d$var$SafeBuffer;
}
function $27bfb6147ea22d2d$var$SafeBuffer(arg, encodingOrOffset, length) {
    return $27bfb6147ea22d2d$var$Buffer(arg, encodingOrOffset, length);
}
// Copy static methods from Buffer
$27bfb6147ea22d2d$var$copyProps($27bfb6147ea22d2d$var$Buffer, $27bfb6147ea22d2d$var$SafeBuffer);
$27bfb6147ea22d2d$var$SafeBuffer.from = function(arg, encodingOrOffset, length) {
    if (typeof arg === "number") throw new TypeError("Argument must not be a number");
    return $27bfb6147ea22d2d$var$Buffer(arg, encodingOrOffset, length);
};
$27bfb6147ea22d2d$var$SafeBuffer.alloc = function(size, fill, encoding) {
    if (typeof size !== "number") throw new TypeError("Argument must be a number");
    var buf = $27bfb6147ea22d2d$var$Buffer(size);
    if (fill !== undefined) {
        if (typeof encoding === "string") buf.fill(fill, encoding);
        else buf.fill(fill);
    } else buf.fill(0);
    return buf;
};
$27bfb6147ea22d2d$var$SafeBuffer.allocUnsafe = function(size) {
    if (typeof size !== "number") throw new TypeError("Argument must be a number");
    return $27bfb6147ea22d2d$var$Buffer(size);
};
$27bfb6147ea22d2d$var$SafeBuffer.allocUnsafeSlow = function(size) {
    if (typeof size !== "number") throw new TypeError("Argument must be a number");
    return $iuRmA.SlowBuffer(size);
};

});


parcelRequire.register("bptsJ", function(module, exports) {
"use strict";

var $5SAkX = parcelRequire("5SAkX");

var $lQqEc = parcelRequire("lQqEc");

var $cr6gj = parcelRequire("cr6gj");

var $4Dhna = parcelRequire("4Dhna");

var $gqjfY = parcelRequire("gqjfY");
function $84e8e220ca7e5349$var$Hash(hash) {
    $gqjfY.call(this, "digest");
    this._hash = hash;
}
$5SAkX($84e8e220ca7e5349$var$Hash, $gqjfY);
$84e8e220ca7e5349$var$Hash.prototype._update = function(data) {
    this._hash.update(data);
};
$84e8e220ca7e5349$var$Hash.prototype._final = function() {
    return this._hash.digest();
};
module.exports = function createHash(alg) {
    alg = alg.toLowerCase();
    if (alg === "md5") return new $lQqEc();
    if (alg === "rmd160" || alg === "ripemd160") return new $cr6gj();
    return new $84e8e220ca7e5349$var$Hash($4Dhna(alg));
};

});
parcelRequire.register("lQqEc", function(module, exports) {
"use strict";

var $5SAkX = parcelRequire("5SAkX");

var $3n4uu = parcelRequire("3n4uu");

var $3pA6p = parcelRequire("3pA6p");
var $fe731feb1ae1a9f7$require$Buffer = $3pA6p.Buffer;
var $fe731feb1ae1a9f7$var$ARRAY16 = new Array(16);
function $fe731feb1ae1a9f7$var$MD5() {
    $3n4uu.call(this, 64);
    // state
    this._a = 0x67452301;
    this._b = 0xefcdab89;
    this._c = 0x98badcfe;
    this._d = 0x10325476;
}
$5SAkX($fe731feb1ae1a9f7$var$MD5, $3n4uu);
$fe731feb1ae1a9f7$var$MD5.prototype._update = function() {
    var M = $fe731feb1ae1a9f7$var$ARRAY16;
    for(var i = 0; i < 16; ++i)M[i] = this._block.readInt32LE(i * 4);
    var a = this._a;
    var b = this._b;
    var c = this._c;
    var d = this._d;
    a = $fe731feb1ae1a9f7$var$fnF(a, b, c, d, M[0], 0xd76aa478, 7);
    d = $fe731feb1ae1a9f7$var$fnF(d, a, b, c, M[1], 0xe8c7b756, 12);
    c = $fe731feb1ae1a9f7$var$fnF(c, d, a, b, M[2], 0x242070db, 17);
    b = $fe731feb1ae1a9f7$var$fnF(b, c, d, a, M[3], 0xc1bdceee, 22);
    a = $fe731feb1ae1a9f7$var$fnF(a, b, c, d, M[4], 0xf57c0faf, 7);
    d = $fe731feb1ae1a9f7$var$fnF(d, a, b, c, M[5], 0x4787c62a, 12);
    c = $fe731feb1ae1a9f7$var$fnF(c, d, a, b, M[6], 0xa8304613, 17);
    b = $fe731feb1ae1a9f7$var$fnF(b, c, d, a, M[7], 0xfd469501, 22);
    a = $fe731feb1ae1a9f7$var$fnF(a, b, c, d, M[8], 0x698098d8, 7);
    d = $fe731feb1ae1a9f7$var$fnF(d, a, b, c, M[9], 0x8b44f7af, 12);
    c = $fe731feb1ae1a9f7$var$fnF(c, d, a, b, M[10], 0xffff5bb1, 17);
    b = $fe731feb1ae1a9f7$var$fnF(b, c, d, a, M[11], 0x895cd7be, 22);
    a = $fe731feb1ae1a9f7$var$fnF(a, b, c, d, M[12], 0x6b901122, 7);
    d = $fe731feb1ae1a9f7$var$fnF(d, a, b, c, M[13], 0xfd987193, 12);
    c = $fe731feb1ae1a9f7$var$fnF(c, d, a, b, M[14], 0xa679438e, 17);
    b = $fe731feb1ae1a9f7$var$fnF(b, c, d, a, M[15], 0x49b40821, 22);
    a = $fe731feb1ae1a9f7$var$fnG(a, b, c, d, M[1], 0xf61e2562, 5);
    d = $fe731feb1ae1a9f7$var$fnG(d, a, b, c, M[6], 0xc040b340, 9);
    c = $fe731feb1ae1a9f7$var$fnG(c, d, a, b, M[11], 0x265e5a51, 14);
    b = $fe731feb1ae1a9f7$var$fnG(b, c, d, a, M[0], 0xe9b6c7aa, 20);
    a = $fe731feb1ae1a9f7$var$fnG(a, b, c, d, M[5], 0xd62f105d, 5);
    d = $fe731feb1ae1a9f7$var$fnG(d, a, b, c, M[10], 0x02441453, 9);
    c = $fe731feb1ae1a9f7$var$fnG(c, d, a, b, M[15], 0xd8a1e681, 14);
    b = $fe731feb1ae1a9f7$var$fnG(b, c, d, a, M[4], 0xe7d3fbc8, 20);
    a = $fe731feb1ae1a9f7$var$fnG(a, b, c, d, M[9], 0x21e1cde6, 5);
    d = $fe731feb1ae1a9f7$var$fnG(d, a, b, c, M[14], 0xc33707d6, 9);
    c = $fe731feb1ae1a9f7$var$fnG(c, d, a, b, M[3], 0xf4d50d87, 14);
    b = $fe731feb1ae1a9f7$var$fnG(b, c, d, a, M[8], 0x455a14ed, 20);
    a = $fe731feb1ae1a9f7$var$fnG(a, b, c, d, M[13], 0xa9e3e905, 5);
    d = $fe731feb1ae1a9f7$var$fnG(d, a, b, c, M[2], 0xfcefa3f8, 9);
    c = $fe731feb1ae1a9f7$var$fnG(c, d, a, b, M[7], 0x676f02d9, 14);
    b = $fe731feb1ae1a9f7$var$fnG(b, c, d, a, M[12], 0x8d2a4c8a, 20);
    a = $fe731feb1ae1a9f7$var$fnH(a, b, c, d, M[5], 0xfffa3942, 4);
    d = $fe731feb1ae1a9f7$var$fnH(d, a, b, c, M[8], 0x8771f681, 11);
    c = $fe731feb1ae1a9f7$var$fnH(c, d, a, b, M[11], 0x6d9d6122, 16);
    b = $fe731feb1ae1a9f7$var$fnH(b, c, d, a, M[14], 0xfde5380c, 23);
    a = $fe731feb1ae1a9f7$var$fnH(a, b, c, d, M[1], 0xa4beea44, 4);
    d = $fe731feb1ae1a9f7$var$fnH(d, a, b, c, M[4], 0x4bdecfa9, 11);
    c = $fe731feb1ae1a9f7$var$fnH(c, d, a, b, M[7], 0xf6bb4b60, 16);
    b = $fe731feb1ae1a9f7$var$fnH(b, c, d, a, M[10], 0xbebfbc70, 23);
    a = $fe731feb1ae1a9f7$var$fnH(a, b, c, d, M[13], 0x289b7ec6, 4);
    d = $fe731feb1ae1a9f7$var$fnH(d, a, b, c, M[0], 0xeaa127fa, 11);
    c = $fe731feb1ae1a9f7$var$fnH(c, d, a, b, M[3], 0xd4ef3085, 16);
    b = $fe731feb1ae1a9f7$var$fnH(b, c, d, a, M[6], 0x04881d05, 23);
    a = $fe731feb1ae1a9f7$var$fnH(a, b, c, d, M[9], 0xd9d4d039, 4);
    d = $fe731feb1ae1a9f7$var$fnH(d, a, b, c, M[12], 0xe6db99e5, 11);
    c = $fe731feb1ae1a9f7$var$fnH(c, d, a, b, M[15], 0x1fa27cf8, 16);
    b = $fe731feb1ae1a9f7$var$fnH(b, c, d, a, M[2], 0xc4ac5665, 23);
    a = $fe731feb1ae1a9f7$var$fnI(a, b, c, d, M[0], 0xf4292244, 6);
    d = $fe731feb1ae1a9f7$var$fnI(d, a, b, c, M[7], 0x432aff97, 10);
    c = $fe731feb1ae1a9f7$var$fnI(c, d, a, b, M[14], 0xab9423a7, 15);
    b = $fe731feb1ae1a9f7$var$fnI(b, c, d, a, M[5], 0xfc93a039, 21);
    a = $fe731feb1ae1a9f7$var$fnI(a, b, c, d, M[12], 0x655b59c3, 6);
    d = $fe731feb1ae1a9f7$var$fnI(d, a, b, c, M[3], 0x8f0ccc92, 10);
    c = $fe731feb1ae1a9f7$var$fnI(c, d, a, b, M[10], 0xffeff47d, 15);
    b = $fe731feb1ae1a9f7$var$fnI(b, c, d, a, M[1], 0x85845dd1, 21);
    a = $fe731feb1ae1a9f7$var$fnI(a, b, c, d, M[8], 0x6fa87e4f, 6);
    d = $fe731feb1ae1a9f7$var$fnI(d, a, b, c, M[15], 0xfe2ce6e0, 10);
    c = $fe731feb1ae1a9f7$var$fnI(c, d, a, b, M[6], 0xa3014314, 15);
    b = $fe731feb1ae1a9f7$var$fnI(b, c, d, a, M[13], 0x4e0811a1, 21);
    a = $fe731feb1ae1a9f7$var$fnI(a, b, c, d, M[4], 0xf7537e82, 6);
    d = $fe731feb1ae1a9f7$var$fnI(d, a, b, c, M[11], 0xbd3af235, 10);
    c = $fe731feb1ae1a9f7$var$fnI(c, d, a, b, M[2], 0x2ad7d2bb, 15);
    b = $fe731feb1ae1a9f7$var$fnI(b, c, d, a, M[9], 0xeb86d391, 21);
    this._a = this._a + a | 0;
    this._b = this._b + b | 0;
    this._c = this._c + c | 0;
    this._d = this._d + d | 0;
};
$fe731feb1ae1a9f7$var$MD5.prototype._digest = function() {
    // create padding and handle blocks
    this._block[this._blockOffset++] = 0x80;
    if (this._blockOffset > 56) {
        this._block.fill(0, this._blockOffset, 64);
        this._update();
        this._blockOffset = 0;
    }
    this._block.fill(0, this._blockOffset, 56);
    this._block.writeUInt32LE(this._length[0], 56);
    this._block.writeUInt32LE(this._length[1], 60);
    this._update();
    // produce result
    var buffer = $fe731feb1ae1a9f7$require$Buffer.allocUnsafe(16);
    buffer.writeInt32LE(this._a, 0);
    buffer.writeInt32LE(this._b, 4);
    buffer.writeInt32LE(this._c, 8);
    buffer.writeInt32LE(this._d, 12);
    return buffer;
};
function $fe731feb1ae1a9f7$var$rotl(x, n) {
    return x << n | x >>> 32 - n;
}
function $fe731feb1ae1a9f7$var$fnF(a, b, c, d, m, k, s) {
    return $fe731feb1ae1a9f7$var$rotl(a + (b & c | ~b & d) + m + k | 0, s) + b | 0;
}
function $fe731feb1ae1a9f7$var$fnG(a, b, c, d, m, k, s) {
    return $fe731feb1ae1a9f7$var$rotl(a + (b & d | c & ~d) + m + k | 0, s) + b | 0;
}
function $fe731feb1ae1a9f7$var$fnH(a, b, c, d, m, k, s) {
    return $fe731feb1ae1a9f7$var$rotl(a + (b ^ c ^ d) + m + k | 0, s) + b | 0;
}
function $fe731feb1ae1a9f7$var$fnI(a, b, c, d, m, k, s) {
    return $fe731feb1ae1a9f7$var$rotl(a + (c ^ (b | ~d)) + m + k | 0, s) + b | 0;
}
module.exports = $fe731feb1ae1a9f7$var$MD5;

});
parcelRequire.register("3n4uu", function(module, exports) {
"use strict";

var $44M2Q = parcelRequire("44M2Q");
var $274700dfc9f1fff4$require$Buffer = $44M2Q.Buffer;

var $gwqwh = parcelRequire("gwqwh");
var $274700dfc9f1fff4$require$Transform = $gwqwh.Transform;

var $5SAkX = parcelRequire("5SAkX");
function $274700dfc9f1fff4$var$throwIfNotStringOrBuffer(val, prefix) {
    if (!$274700dfc9f1fff4$require$Buffer.isBuffer(val) && typeof val !== "string") throw new TypeError(prefix + " must be a string or a buffer");
}
function $274700dfc9f1fff4$var$HashBase(blockSize) {
    $274700dfc9f1fff4$require$Transform.call(this);
    this._block = $274700dfc9f1fff4$require$Buffer.allocUnsafe(blockSize);
    this._blockSize = blockSize;
    this._blockOffset = 0;
    this._length = [
        0,
        0,
        0,
        0
    ];
    this._finalized = false;
}
$5SAkX($274700dfc9f1fff4$var$HashBase, $274700dfc9f1fff4$require$Transform);
$274700dfc9f1fff4$var$HashBase.prototype._transform = function(chunk, encoding, callback) {
    var error = null;
    try {
        this.update(chunk, encoding);
    } catch (err) {
        error = err;
    }
    callback(error);
};
$274700dfc9f1fff4$var$HashBase.prototype._flush = function(callback) {
    var error = null;
    try {
        this.push(this.digest());
    } catch (err) {
        error = err;
    }
    callback(error);
};
$274700dfc9f1fff4$var$HashBase.prototype.update = function(data, encoding) {
    $274700dfc9f1fff4$var$throwIfNotStringOrBuffer(data, "Data");
    if (this._finalized) throw new Error("Digest already called");
    if (!$274700dfc9f1fff4$require$Buffer.isBuffer(data)) data = $274700dfc9f1fff4$require$Buffer.from(data, encoding);
    // consume data
    var block = this._block;
    var offset = 0;
    while(this._blockOffset + data.length - offset >= this._blockSize){
        for(var i = this._blockOffset; i < this._blockSize;)block[i++] = data[offset++];
        this._update();
        this._blockOffset = 0;
    }
    while(offset < data.length)block[this._blockOffset++] = data[offset++];
    // update length
    for(var j = 0, carry = data.length * 8; carry > 0; ++j){
        this._length[j] += carry;
        carry = this._length[j] / 0x0100000000 | 0;
        if (carry > 0) this._length[j] -= 0x0100000000 * carry;
    }
    return this;
};
$274700dfc9f1fff4$var$HashBase.prototype._update = function() {
    throw new Error("_update is not implemented");
};
$274700dfc9f1fff4$var$HashBase.prototype.digest = function(encoding) {
    if (this._finalized) throw new Error("Digest already called");
    this._finalized = true;
    var digest = this._digest();
    if (encoding !== undefined) digest = digest.toString(encoding);
    // reset state
    this._block.fill(0);
    this._blockOffset = 0;
    for(var i = 0; i < 4; ++i)this._length[i] = 0;
    return digest;
};
$274700dfc9f1fff4$var$HashBase.prototype._digest = function() {
    throw new Error("_digest is not implemented");
};
module.exports = $274700dfc9f1fff4$var$HashBase;

});
parcelRequire.register("44M2Q", function(module, exports) {
/*! safe-buffer. MIT License. Feross Aboukhadijeh <https://feross.org/opensource> */ /* eslint-disable node/no-deprecated-api */ 
var $iuRmA = parcelRequire("iuRmA");
var $2f7ccddbd5c5ddf1$var$Buffer = $iuRmA.Buffer;
// alternative to using Object.keys for old browsers
function $2f7ccddbd5c5ddf1$var$copyProps(src, dst) {
    for(var key in src)dst[key] = src[key];
}
if ($2f7ccddbd5c5ddf1$var$Buffer.from && $2f7ccddbd5c5ddf1$var$Buffer.alloc && $2f7ccddbd5c5ddf1$var$Buffer.allocUnsafe && $2f7ccddbd5c5ddf1$var$Buffer.allocUnsafeSlow) module.exports = $iuRmA;
else {
    // Copy properties from require('buffer')
    $2f7ccddbd5c5ddf1$var$copyProps($iuRmA, module.exports);
    module.exports.Buffer = $2f7ccddbd5c5ddf1$var$SafeBuffer;
}
function $2f7ccddbd5c5ddf1$var$SafeBuffer(arg, encodingOrOffset, length) {
    return $2f7ccddbd5c5ddf1$var$Buffer(arg, encodingOrOffset, length);
}
$2f7ccddbd5c5ddf1$var$SafeBuffer.prototype = Object.create($2f7ccddbd5c5ddf1$var$Buffer.prototype);
// Copy static methods from Buffer
$2f7ccddbd5c5ddf1$var$copyProps($2f7ccddbd5c5ddf1$var$Buffer, $2f7ccddbd5c5ddf1$var$SafeBuffer);
$2f7ccddbd5c5ddf1$var$SafeBuffer.from = function(arg, encodingOrOffset, length) {
    if (typeof arg === "number") throw new TypeError("Argument must not be a number");
    return $2f7ccddbd5c5ddf1$var$Buffer(arg, encodingOrOffset, length);
};
$2f7ccddbd5c5ddf1$var$SafeBuffer.alloc = function(size, fill, encoding) {
    if (typeof size !== "number") throw new TypeError("Argument must be a number");
    var buf = $2f7ccddbd5c5ddf1$var$Buffer(size);
    if (fill !== undefined) {
        if (typeof encoding === "string") buf.fill(fill, encoding);
        else buf.fill(fill);
    } else buf.fill(0);
    return buf;
};
$2f7ccddbd5c5ddf1$var$SafeBuffer.allocUnsafe = function(size) {
    if (typeof size !== "number") throw new TypeError("Argument must be a number");
    return $2f7ccddbd5c5ddf1$var$Buffer(size);
};
$2f7ccddbd5c5ddf1$var$SafeBuffer.allocUnsafeSlow = function(size) {
    if (typeof size !== "number") throw new TypeError("Argument must be a number");
    return $iuRmA.SlowBuffer(size);
};

});



parcelRequire.register("cr6gj", function(module, exports) {
"use strict";

var $iuRmA = parcelRequire("iuRmA");
var $90dcdd3154dc0cb3$require$Buffer = $iuRmA.Buffer;

var $5SAkX = parcelRequire("5SAkX");

var $3n4uu = parcelRequire("3n4uu");
var $90dcdd3154dc0cb3$var$ARRAY16 = new Array(16);
var $90dcdd3154dc0cb3$var$zl = [
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    7,
    4,
    13,
    1,
    10,
    6,
    15,
    3,
    12,
    0,
    9,
    5,
    2,
    14,
    11,
    8,
    3,
    10,
    14,
    4,
    9,
    15,
    8,
    1,
    2,
    7,
    0,
    6,
    13,
    11,
    5,
    12,
    1,
    9,
    11,
    10,
    0,
    8,
    12,
    4,
    13,
    3,
    7,
    15,
    14,
    5,
    6,
    2,
    4,
    0,
    5,
    9,
    7,
    12,
    2,
    10,
    14,
    1,
    3,
    8,
    11,
    6,
    15,
    13
];
var $90dcdd3154dc0cb3$var$zr = [
    5,
    14,
    7,
    0,
    9,
    2,
    11,
    4,
    13,
    6,
    15,
    8,
    1,
    10,
    3,
    12,
    6,
    11,
    3,
    7,
    0,
    13,
    5,
    10,
    14,
    15,
    8,
    12,
    4,
    9,
    1,
    2,
    15,
    5,
    1,
    3,
    7,
    14,
    6,
    9,
    11,
    8,
    12,
    2,
    10,
    0,
    4,
    13,
    8,
    6,
    4,
    1,
    3,
    11,
    15,
    0,
    5,
    12,
    2,
    13,
    9,
    7,
    10,
    14,
    12,
    15,
    10,
    4,
    1,
    5,
    8,
    7,
    6,
    2,
    13,
    14,
    0,
    3,
    9,
    11
];
var $90dcdd3154dc0cb3$var$sl = [
    11,
    14,
    15,
    12,
    5,
    8,
    7,
    9,
    11,
    13,
    14,
    15,
    6,
    7,
    9,
    8,
    7,
    6,
    8,
    13,
    11,
    9,
    7,
    15,
    7,
    12,
    15,
    9,
    11,
    7,
    13,
    12,
    11,
    13,
    6,
    7,
    14,
    9,
    13,
    15,
    14,
    8,
    13,
    6,
    5,
    12,
    7,
    5,
    11,
    12,
    14,
    15,
    14,
    15,
    9,
    8,
    9,
    14,
    5,
    6,
    8,
    6,
    5,
    12,
    9,
    15,
    5,
    11,
    6,
    8,
    13,
    12,
    5,
    12,
    13,
    14,
    11,
    8,
    5,
    6
];
var $90dcdd3154dc0cb3$var$sr = [
    8,
    9,
    9,
    11,
    13,
    15,
    15,
    5,
    7,
    7,
    8,
    11,
    14,
    14,
    12,
    6,
    9,
    13,
    15,
    7,
    12,
    8,
    9,
    11,
    7,
    7,
    12,
    7,
    6,
    15,
    13,
    11,
    9,
    7,
    15,
    11,
    8,
    6,
    6,
    14,
    12,
    13,
    5,
    14,
    13,
    13,
    7,
    5,
    15,
    5,
    8,
    11,
    14,
    14,
    6,
    14,
    6,
    9,
    12,
    9,
    12,
    5,
    15,
    8,
    8,
    5,
    12,
    9,
    12,
    5,
    14,
    6,
    8,
    13,
    6,
    5,
    15,
    13,
    11,
    11
];
var $90dcdd3154dc0cb3$var$hl = [
    0x00000000,
    0x5a827999,
    0x6ed9eba1,
    0x8f1bbcdc,
    0xa953fd4e
];
var $90dcdd3154dc0cb3$var$hr = [
    0x50a28be6,
    0x5c4dd124,
    0x6d703ef3,
    0x7a6d76e9,
    0x00000000
];
function $90dcdd3154dc0cb3$var$RIPEMD160() {
    $3n4uu.call(this, 64);
    // state
    this._a = 0x67452301;
    this._b = 0xefcdab89;
    this._c = 0x98badcfe;
    this._d = 0x10325476;
    this._e = 0xc3d2e1f0;
}
$5SAkX($90dcdd3154dc0cb3$var$RIPEMD160, $3n4uu);
$90dcdd3154dc0cb3$var$RIPEMD160.prototype._update = function() {
    var words = $90dcdd3154dc0cb3$var$ARRAY16;
    for(var j = 0; j < 16; ++j)words[j] = this._block.readInt32LE(j * 4);
    var al = this._a | 0;
    var bl = this._b | 0;
    var cl = this._c | 0;
    var dl = this._d | 0;
    var el = this._e | 0;
    var ar = this._a | 0;
    var br = this._b | 0;
    var cr = this._c | 0;
    var dr = this._d | 0;
    var er = this._e | 0;
    // computation
    for(var i = 0; i < 80; i += 1){
        var tl;
        var tr;
        if (i < 16) {
            tl = $90dcdd3154dc0cb3$var$fn1(al, bl, cl, dl, el, words[$90dcdd3154dc0cb3$var$zl[i]], $90dcdd3154dc0cb3$var$hl[0], $90dcdd3154dc0cb3$var$sl[i]);
            tr = $90dcdd3154dc0cb3$var$fn5(ar, br, cr, dr, er, words[$90dcdd3154dc0cb3$var$zr[i]], $90dcdd3154dc0cb3$var$hr[0], $90dcdd3154dc0cb3$var$sr[i]);
        } else if (i < 32) {
            tl = $90dcdd3154dc0cb3$var$fn2(al, bl, cl, dl, el, words[$90dcdd3154dc0cb3$var$zl[i]], $90dcdd3154dc0cb3$var$hl[1], $90dcdd3154dc0cb3$var$sl[i]);
            tr = $90dcdd3154dc0cb3$var$fn4(ar, br, cr, dr, er, words[$90dcdd3154dc0cb3$var$zr[i]], $90dcdd3154dc0cb3$var$hr[1], $90dcdd3154dc0cb3$var$sr[i]);
        } else if (i < 48) {
            tl = $90dcdd3154dc0cb3$var$fn3(al, bl, cl, dl, el, words[$90dcdd3154dc0cb3$var$zl[i]], $90dcdd3154dc0cb3$var$hl[2], $90dcdd3154dc0cb3$var$sl[i]);
            tr = $90dcdd3154dc0cb3$var$fn3(ar, br, cr, dr, er, words[$90dcdd3154dc0cb3$var$zr[i]], $90dcdd3154dc0cb3$var$hr[2], $90dcdd3154dc0cb3$var$sr[i]);
        } else if (i < 64) {
            tl = $90dcdd3154dc0cb3$var$fn4(al, bl, cl, dl, el, words[$90dcdd3154dc0cb3$var$zl[i]], $90dcdd3154dc0cb3$var$hl[3], $90dcdd3154dc0cb3$var$sl[i]);
            tr = $90dcdd3154dc0cb3$var$fn2(ar, br, cr, dr, er, words[$90dcdd3154dc0cb3$var$zr[i]], $90dcdd3154dc0cb3$var$hr[3], $90dcdd3154dc0cb3$var$sr[i]);
        } else {
            tl = $90dcdd3154dc0cb3$var$fn5(al, bl, cl, dl, el, words[$90dcdd3154dc0cb3$var$zl[i]], $90dcdd3154dc0cb3$var$hl[4], $90dcdd3154dc0cb3$var$sl[i]);
            tr = $90dcdd3154dc0cb3$var$fn1(ar, br, cr, dr, er, words[$90dcdd3154dc0cb3$var$zr[i]], $90dcdd3154dc0cb3$var$hr[4], $90dcdd3154dc0cb3$var$sr[i]);
        }
        al = el;
        el = dl;
        dl = $90dcdd3154dc0cb3$var$rotl(cl, 10);
        cl = bl;
        bl = tl;
        ar = er;
        er = dr;
        dr = $90dcdd3154dc0cb3$var$rotl(cr, 10);
        cr = br;
        br = tr;
    }
    // update state
    var t = this._b + cl + dr | 0;
    this._b = this._c + dl + er | 0;
    this._c = this._d + el + ar | 0;
    this._d = this._e + al + br | 0;
    this._e = this._a + bl + cr | 0;
    this._a = t;
};
$90dcdd3154dc0cb3$var$RIPEMD160.prototype._digest = function() {
    // create padding and handle blocks
    this._block[this._blockOffset++] = 0x80;
    if (this._blockOffset > 56) {
        this._block.fill(0, this._blockOffset, 64);
        this._update();
        this._blockOffset = 0;
    }
    this._block.fill(0, this._blockOffset, 56);
    this._block.writeUInt32LE(this._length[0], 56);
    this._block.writeUInt32LE(this._length[1], 60);
    this._update();
    // produce result
    var buffer = $90dcdd3154dc0cb3$require$Buffer.alloc ? $90dcdd3154dc0cb3$require$Buffer.alloc(20) : new $90dcdd3154dc0cb3$require$Buffer(20);
    buffer.writeInt32LE(this._a, 0);
    buffer.writeInt32LE(this._b, 4);
    buffer.writeInt32LE(this._c, 8);
    buffer.writeInt32LE(this._d, 12);
    buffer.writeInt32LE(this._e, 16);
    return buffer;
};
function $90dcdd3154dc0cb3$var$rotl(x, n) {
    return x << n | x >>> 32 - n;
}
function $90dcdd3154dc0cb3$var$fn1(a, b, c, d, e, m, k, s) {
    return $90dcdd3154dc0cb3$var$rotl(a + (b ^ c ^ d) + m + k | 0, s) + e | 0;
}
function $90dcdd3154dc0cb3$var$fn2(a, b, c, d, e, m, k, s) {
    return $90dcdd3154dc0cb3$var$rotl(a + (b & c | ~b & d) + m + k | 0, s) + e | 0;
}
function $90dcdd3154dc0cb3$var$fn3(a, b, c, d, e, m, k, s) {
    return $90dcdd3154dc0cb3$var$rotl(a + ((b | ~c) ^ d) + m + k | 0, s) + e | 0;
}
function $90dcdd3154dc0cb3$var$fn4(a, b, c, d, e, m, k, s) {
    return $90dcdd3154dc0cb3$var$rotl(a + (b & d | c & ~d) + m + k | 0, s) + e | 0;
}
function $90dcdd3154dc0cb3$var$fn5(a, b, c, d, e, m, k, s) {
    return $90dcdd3154dc0cb3$var$rotl(a + (b ^ (c | ~d)) + m + k | 0, s) + e | 0;
}
module.exports = $90dcdd3154dc0cb3$var$RIPEMD160;

});

parcelRequire.register("4Dhna", function(module, exports) {
var $35f847c8bd7b5450$var$exports = module.exports = function SHA(algorithm) {
    algorithm = algorithm.toLowerCase();
    var Algorithm = $35f847c8bd7b5450$var$exports[algorithm];
    if (!Algorithm) throw new Error(algorithm + " is not supported (we accept pull requests)");
    return new Algorithm();
};

$35f847c8bd7b5450$var$exports.sha = (parcelRequire("6rUhI"));

$35f847c8bd7b5450$var$exports.sha1 = (parcelRequire("fLGrt"));

$35f847c8bd7b5450$var$exports.sha224 = (parcelRequire("b5ZxT"));

$35f847c8bd7b5450$var$exports.sha256 = (parcelRequire("37NkZ"));

$35f847c8bd7b5450$var$exports.sha384 = (parcelRequire("2x49W"));

$35f847c8bd7b5450$var$exports.sha512 = (parcelRequire("c2SS9"));

});
parcelRequire.register("6rUhI", function(module, exports) {
/*
 * A JavaScript implementation of the Secure Hash Algorithm, SHA-0, as defined
 * in FIPS PUB 180-1
 * This source code is derived from sha1.js of the same repository.
 * The difference between SHA-0 and SHA-1 is just a bitwise rotate left
 * operation was added.
 */ 
var $5SAkX = parcelRequire("5SAkX");

var $6aSoY = parcelRequire("6aSoY");

var $3pA6p = parcelRequire("3pA6p");
var $4b20ecb188b9857a$require$Buffer = $3pA6p.Buffer;
var $4b20ecb188b9857a$var$K = [
    0x5a827999,
    0x6ed9eba1,
    -1894007588,
    -899497514
];
var $4b20ecb188b9857a$var$W = new Array(80);
function $4b20ecb188b9857a$var$Sha() {
    this.init();
    this._w = $4b20ecb188b9857a$var$W;
    $6aSoY.call(this, 64, 56);
}
$5SAkX($4b20ecb188b9857a$var$Sha, $6aSoY);
$4b20ecb188b9857a$var$Sha.prototype.init = function() {
    this._a = 0x67452301;
    this._b = 0xefcdab89;
    this._c = 0x98badcfe;
    this._d = 0x10325476;
    this._e = 0xc3d2e1f0;
    return this;
};
function $4b20ecb188b9857a$var$rotl5(num) {
    return num << 5 | num >>> 27;
}
function $4b20ecb188b9857a$var$rotl30(num) {
    return num << 30 | num >>> 2;
}
function $4b20ecb188b9857a$var$ft(s, b, c, d) {
    if (s === 0) return b & c | ~b & d;
    if (s === 2) return b & c | b & d | c & d;
    return b ^ c ^ d;
}
$4b20ecb188b9857a$var$Sha.prototype._update = function(M) {
    var W = this._w;
    var a = this._a | 0;
    var b = this._b | 0;
    var c = this._c | 0;
    var d = this._d | 0;
    var e = this._e | 0;
    for(var i = 0; i < 16; ++i)W[i] = M.readInt32BE(i * 4);
    for(; i < 80; ++i)W[i] = W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16];
    for(var j = 0; j < 80; ++j){
        var s = ~~(j / 20);
        var t = $4b20ecb188b9857a$var$rotl5(a) + $4b20ecb188b9857a$var$ft(s, b, c, d) + e + W[j] + $4b20ecb188b9857a$var$K[s] | 0;
        e = d;
        d = c;
        c = $4b20ecb188b9857a$var$rotl30(b);
        b = a;
        a = t;
    }
    this._a = a + this._a | 0;
    this._b = b + this._b | 0;
    this._c = c + this._c | 0;
    this._d = d + this._d | 0;
    this._e = e + this._e | 0;
};
$4b20ecb188b9857a$var$Sha.prototype._hash = function() {
    var H = $4b20ecb188b9857a$require$Buffer.allocUnsafe(20);
    H.writeInt32BE(this._a | 0, 0);
    H.writeInt32BE(this._b | 0, 4);
    H.writeInt32BE(this._c | 0, 8);
    H.writeInt32BE(this._d | 0, 12);
    H.writeInt32BE(this._e | 0, 16);
    return H;
};
module.exports = $4b20ecb188b9857a$var$Sha;

});
parcelRequire.register("6aSoY", function(module, exports) {

var $3pA6p = parcelRequire("3pA6p");
var $47ede04b10132806$require$Buffer = $3pA6p.Buffer;
// prototype class for hash functions
function $47ede04b10132806$var$Hash(blockSize, finalSize) {
    this._block = $47ede04b10132806$require$Buffer.alloc(blockSize);
    this._finalSize = finalSize;
    this._blockSize = blockSize;
    this._len = 0;
}
$47ede04b10132806$var$Hash.prototype.update = function(data, enc) {
    if (typeof data === "string") {
        enc = enc || "utf8";
        data = $47ede04b10132806$require$Buffer.from(data, enc);
    }
    var block = this._block;
    var blockSize = this._blockSize;
    var length = data.length;
    var accum = this._len;
    for(var offset = 0; offset < length;){
        var assigned = accum % blockSize;
        var remainder = Math.min(length - offset, blockSize - assigned);
        for(var i = 0; i < remainder; i++)block[assigned + i] = data[offset + i];
        accum += remainder;
        offset += remainder;
        if (accum % blockSize === 0) this._update(block);
    }
    this._len += length;
    return this;
};
$47ede04b10132806$var$Hash.prototype.digest = function(enc) {
    var rem = this._len % this._blockSize;
    this._block[rem] = 0x80;
    // zero (rem + 1) trailing bits, where (rem + 1) is the smallest
    // non-negative solution to the equation (length + 1 + (rem + 1)) === finalSize mod blockSize
    this._block.fill(0, rem + 1);
    if (rem >= this._finalSize) {
        this._update(this._block);
        this._block.fill(0);
    }
    var bits = this._len * 8;
    // uint32
    if (bits <= 0xffffffff) this._block.writeUInt32BE(bits, this._blockSize - 4);
    else {
        var lowBits = (bits & 0xffffffff) >>> 0;
        var highBits = (bits - lowBits) / 0x100000000;
        this._block.writeUInt32BE(highBits, this._blockSize - 8);
        this._block.writeUInt32BE(lowBits, this._blockSize - 4);
    }
    this._update(this._block);
    var hash = this._hash();
    return enc ? hash.toString(enc) : hash;
};
$47ede04b10132806$var$Hash.prototype._update = function() {
    throw new Error("_update must be implemented by subclass");
};
module.exports = $47ede04b10132806$var$Hash;

});


parcelRequire.register("fLGrt", function(module, exports) {
/*
 * A JavaScript implementation of the Secure Hash Algorithm, SHA-1, as defined
 * in FIPS PUB 180-1
 * Version 2.1a Copyright Paul Johnston 2000 - 2002.
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 * Distributed under the BSD License
 * See http://pajhome.org.uk/crypt/md5 for details.
 */ 
var $5SAkX = parcelRequire("5SAkX");

var $6aSoY = parcelRequire("6aSoY");

var $3pA6p = parcelRequire("3pA6p");
var $b7ac2ae7cfa614be$require$Buffer = $3pA6p.Buffer;
var $b7ac2ae7cfa614be$var$K = [
    0x5a827999,
    0x6ed9eba1,
    -1894007588,
    -899497514
];
var $b7ac2ae7cfa614be$var$W = new Array(80);
function $b7ac2ae7cfa614be$var$Sha1() {
    this.init();
    this._w = $b7ac2ae7cfa614be$var$W;
    $6aSoY.call(this, 64, 56);
}
$5SAkX($b7ac2ae7cfa614be$var$Sha1, $6aSoY);
$b7ac2ae7cfa614be$var$Sha1.prototype.init = function() {
    this._a = 0x67452301;
    this._b = 0xefcdab89;
    this._c = 0x98badcfe;
    this._d = 0x10325476;
    this._e = 0xc3d2e1f0;
    return this;
};
function $b7ac2ae7cfa614be$var$rotl1(num) {
    return num << 1 | num >>> 31;
}
function $b7ac2ae7cfa614be$var$rotl5(num) {
    return num << 5 | num >>> 27;
}
function $b7ac2ae7cfa614be$var$rotl30(num) {
    return num << 30 | num >>> 2;
}
function $b7ac2ae7cfa614be$var$ft(s, b, c, d) {
    if (s === 0) return b & c | ~b & d;
    if (s === 2) return b & c | b & d | c & d;
    return b ^ c ^ d;
}
$b7ac2ae7cfa614be$var$Sha1.prototype._update = function(M) {
    var W = this._w;
    var a = this._a | 0;
    var b = this._b | 0;
    var c = this._c | 0;
    var d = this._d | 0;
    var e = this._e | 0;
    for(var i = 0; i < 16; ++i)W[i] = M.readInt32BE(i * 4);
    for(; i < 80; ++i)W[i] = $b7ac2ae7cfa614be$var$rotl1(W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16]);
    for(var j = 0; j < 80; ++j){
        var s = ~~(j / 20);
        var t = $b7ac2ae7cfa614be$var$rotl5(a) + $b7ac2ae7cfa614be$var$ft(s, b, c, d) + e + W[j] + $b7ac2ae7cfa614be$var$K[s] | 0;
        e = d;
        d = c;
        c = $b7ac2ae7cfa614be$var$rotl30(b);
        b = a;
        a = t;
    }
    this._a = a + this._a | 0;
    this._b = b + this._b | 0;
    this._c = c + this._c | 0;
    this._d = d + this._d | 0;
    this._e = e + this._e | 0;
};
$b7ac2ae7cfa614be$var$Sha1.prototype._hash = function() {
    var H = $b7ac2ae7cfa614be$require$Buffer.allocUnsafe(20);
    H.writeInt32BE(this._a | 0, 0);
    H.writeInt32BE(this._b | 0, 4);
    H.writeInt32BE(this._c | 0, 8);
    H.writeInt32BE(this._d | 0, 12);
    H.writeInt32BE(this._e | 0, 16);
    return H;
};
module.exports = $b7ac2ae7cfa614be$var$Sha1;

});

parcelRequire.register("b5ZxT", function(module, exports) {
/**
 * A JavaScript implementation of the Secure Hash Algorithm, SHA-256, as defined
 * in FIPS 180-2
 * Version 2.2-beta Copyright Angel Marin, Paul Johnston 2000 - 2009.
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 *
 */ 
var $5SAkX = parcelRequire("5SAkX");

var $37NkZ = parcelRequire("37NkZ");

var $6aSoY = parcelRequire("6aSoY");

var $3pA6p = parcelRequire("3pA6p");
var $813fe7094cf67eb6$require$Buffer = $3pA6p.Buffer;
var $813fe7094cf67eb6$var$W = new Array(64);
function $813fe7094cf67eb6$var$Sha224() {
    this.init();
    this._w = $813fe7094cf67eb6$var$W // new Array(64)
    ;
    $6aSoY.call(this, 64, 56);
}
$5SAkX($813fe7094cf67eb6$var$Sha224, $37NkZ);
$813fe7094cf67eb6$var$Sha224.prototype.init = function() {
    this._a = 0xc1059ed8;
    this._b = 0x367cd507;
    this._c = 0x3070dd17;
    this._d = 0xf70e5939;
    this._e = 0xffc00b31;
    this._f = 0x68581511;
    this._g = 0x64f98fa7;
    this._h = 0xbefa4fa4;
    return this;
};
$813fe7094cf67eb6$var$Sha224.prototype._hash = function() {
    var H = $813fe7094cf67eb6$require$Buffer.allocUnsafe(28);
    H.writeInt32BE(this._a, 0);
    H.writeInt32BE(this._b, 4);
    H.writeInt32BE(this._c, 8);
    H.writeInt32BE(this._d, 12);
    H.writeInt32BE(this._e, 16);
    H.writeInt32BE(this._f, 20);
    H.writeInt32BE(this._g, 24);
    return H;
};
module.exports = $813fe7094cf67eb6$var$Sha224;

});
parcelRequire.register("37NkZ", function(module, exports) {
/**
 * A JavaScript implementation of the Secure Hash Algorithm, SHA-256, as defined
 * in FIPS 180-2
 * Version 2.2-beta Copyright Angel Marin, Paul Johnston 2000 - 2009.
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 *
 */ 
var $5SAkX = parcelRequire("5SAkX");

var $6aSoY = parcelRequire("6aSoY");

var $3pA6p = parcelRequire("3pA6p");
var $24684bf1d65ceb3a$require$Buffer = $3pA6p.Buffer;
var $24684bf1d65ceb3a$var$K = [
    0x428A2F98,
    0x71374491,
    0xB5C0FBCF,
    0xE9B5DBA5,
    0x3956C25B,
    0x59F111F1,
    0x923F82A4,
    0xAB1C5ED5,
    0xD807AA98,
    0x12835B01,
    0x243185BE,
    0x550C7DC3,
    0x72BE5D74,
    0x80DEB1FE,
    0x9BDC06A7,
    0xC19BF174,
    0xE49B69C1,
    0xEFBE4786,
    0x0FC19DC6,
    0x240CA1CC,
    0x2DE92C6F,
    0x4A7484AA,
    0x5CB0A9DC,
    0x76F988DA,
    0x983E5152,
    0xA831C66D,
    0xB00327C8,
    0xBF597FC7,
    0xC6E00BF3,
    0xD5A79147,
    0x06CA6351,
    0x14292967,
    0x27B70A85,
    0x2E1B2138,
    0x4D2C6DFC,
    0x53380D13,
    0x650A7354,
    0x766A0ABB,
    0x81C2C92E,
    0x92722C85,
    0xA2BFE8A1,
    0xA81A664B,
    0xC24B8B70,
    0xC76C51A3,
    0xD192E819,
    0xD6990624,
    0xF40E3585,
    0x106AA070,
    0x19A4C116,
    0x1E376C08,
    0x2748774C,
    0x34B0BCB5,
    0x391C0CB3,
    0x4ED8AA4A,
    0x5B9CCA4F,
    0x682E6FF3,
    0x748F82EE,
    0x78A5636F,
    0x84C87814,
    0x8CC70208,
    0x90BEFFFA,
    0xA4506CEB,
    0xBEF9A3F7,
    0xC67178F2
];
var $24684bf1d65ceb3a$var$W = new Array(64);
function $24684bf1d65ceb3a$var$Sha256() {
    this.init();
    this._w = $24684bf1d65ceb3a$var$W // new Array(64)
    ;
    $6aSoY.call(this, 64, 56);
}
$5SAkX($24684bf1d65ceb3a$var$Sha256, $6aSoY);
$24684bf1d65ceb3a$var$Sha256.prototype.init = function() {
    this._a = 0x6a09e667;
    this._b = 0xbb67ae85;
    this._c = 0x3c6ef372;
    this._d = 0xa54ff53a;
    this._e = 0x510e527f;
    this._f = 0x9b05688c;
    this._g = 0x1f83d9ab;
    this._h = 0x5be0cd19;
    return this;
};
function $24684bf1d65ceb3a$var$ch(x, y, z) {
    return z ^ x & (y ^ z);
}
function $24684bf1d65ceb3a$var$maj(x, y, z) {
    return x & y | z & (x | y);
}
function $24684bf1d65ceb3a$var$sigma0(x) {
    return (x >>> 2 | x << 30) ^ (x >>> 13 | x << 19) ^ (x >>> 22 | x << 10);
}
function $24684bf1d65ceb3a$var$sigma1(x) {
    return (x >>> 6 | x << 26) ^ (x >>> 11 | x << 21) ^ (x >>> 25 | x << 7);
}
function $24684bf1d65ceb3a$var$gamma0(x) {
    return (x >>> 7 | x << 25) ^ (x >>> 18 | x << 14) ^ x >>> 3;
}
function $24684bf1d65ceb3a$var$gamma1(x) {
    return (x >>> 17 | x << 15) ^ (x >>> 19 | x << 13) ^ x >>> 10;
}
$24684bf1d65ceb3a$var$Sha256.prototype._update = function(M) {
    var W = this._w;
    var a = this._a | 0;
    var b = this._b | 0;
    var c = this._c | 0;
    var d = this._d | 0;
    var e = this._e | 0;
    var f = this._f | 0;
    var g = this._g | 0;
    var h = this._h | 0;
    for(var i = 0; i < 16; ++i)W[i] = M.readInt32BE(i * 4);
    for(; i < 64; ++i)W[i] = $24684bf1d65ceb3a$var$gamma1(W[i - 2]) + W[i - 7] + $24684bf1d65ceb3a$var$gamma0(W[i - 15]) + W[i - 16] | 0;
    for(var j = 0; j < 64; ++j){
        var T1 = h + $24684bf1d65ceb3a$var$sigma1(e) + $24684bf1d65ceb3a$var$ch(e, f, g) + $24684bf1d65ceb3a$var$K[j] + W[j] | 0;
        var T2 = $24684bf1d65ceb3a$var$sigma0(a) + $24684bf1d65ceb3a$var$maj(a, b, c) | 0;
        h = g;
        g = f;
        f = e;
        e = d + T1 | 0;
        d = c;
        c = b;
        b = a;
        a = T1 + T2 | 0;
    }
    this._a = a + this._a | 0;
    this._b = b + this._b | 0;
    this._c = c + this._c | 0;
    this._d = d + this._d | 0;
    this._e = e + this._e | 0;
    this._f = f + this._f | 0;
    this._g = g + this._g | 0;
    this._h = h + this._h | 0;
};
$24684bf1d65ceb3a$var$Sha256.prototype._hash = function() {
    var H = $24684bf1d65ceb3a$require$Buffer.allocUnsafe(32);
    H.writeInt32BE(this._a, 0);
    H.writeInt32BE(this._b, 4);
    H.writeInt32BE(this._c, 8);
    H.writeInt32BE(this._d, 12);
    H.writeInt32BE(this._e, 16);
    H.writeInt32BE(this._f, 20);
    H.writeInt32BE(this._g, 24);
    H.writeInt32BE(this._h, 28);
    return H;
};
module.exports = $24684bf1d65ceb3a$var$Sha256;

});


parcelRequire.register("2x49W", function(module, exports) {

var $5SAkX = parcelRequire("5SAkX");

var $c2SS9 = parcelRequire("c2SS9");

var $6aSoY = parcelRequire("6aSoY");

var $3pA6p = parcelRequire("3pA6p");
var $1d81e3d00d23ab09$require$Buffer = $3pA6p.Buffer;
var $1d81e3d00d23ab09$var$W = new Array(160);
function $1d81e3d00d23ab09$var$Sha384() {
    this.init();
    this._w = $1d81e3d00d23ab09$var$W;
    $6aSoY.call(this, 128, 112);
}
$5SAkX($1d81e3d00d23ab09$var$Sha384, $c2SS9);
$1d81e3d00d23ab09$var$Sha384.prototype.init = function() {
    this._ah = 0xcbbb9d5d;
    this._bh = 0x629a292a;
    this._ch = 0x9159015a;
    this._dh = 0x152fecd8;
    this._eh = 0x67332667;
    this._fh = 0x8eb44a87;
    this._gh = 0xdb0c2e0d;
    this._hh = 0x47b5481d;
    this._al = 0xc1059ed8;
    this._bl = 0x367cd507;
    this._cl = 0x3070dd17;
    this._dl = 0xf70e5939;
    this._el = 0xffc00b31;
    this._fl = 0x68581511;
    this._gl = 0x64f98fa7;
    this._hl = 0xbefa4fa4;
    return this;
};
$1d81e3d00d23ab09$var$Sha384.prototype._hash = function() {
    var H = $1d81e3d00d23ab09$require$Buffer.allocUnsafe(48);
    function writeInt64BE(h, l, offset) {
        H.writeInt32BE(h, offset);
        H.writeInt32BE(l, offset + 4);
    }
    writeInt64BE(this._ah, this._al, 0);
    writeInt64BE(this._bh, this._bl, 8);
    writeInt64BE(this._ch, this._cl, 16);
    writeInt64BE(this._dh, this._dl, 24);
    writeInt64BE(this._eh, this._el, 32);
    writeInt64BE(this._fh, this._fl, 40);
    return H;
};
module.exports = $1d81e3d00d23ab09$var$Sha384;

});
parcelRequire.register("c2SS9", function(module, exports) {

var $5SAkX = parcelRequire("5SAkX");

var $6aSoY = parcelRequire("6aSoY");

var $3pA6p = parcelRequire("3pA6p");
var $8c503c6f86d31363$require$Buffer = $3pA6p.Buffer;
var $8c503c6f86d31363$var$K = [
    0x428a2f98,
    0xd728ae22,
    0x71374491,
    0x23ef65cd,
    0xb5c0fbcf,
    0xec4d3b2f,
    0xe9b5dba5,
    0x8189dbbc,
    0x3956c25b,
    0xf348b538,
    0x59f111f1,
    0xb605d019,
    0x923f82a4,
    0xaf194f9b,
    0xab1c5ed5,
    0xda6d8118,
    0xd807aa98,
    0xa3030242,
    0x12835b01,
    0x45706fbe,
    0x243185be,
    0x4ee4b28c,
    0x550c7dc3,
    0xd5ffb4e2,
    0x72be5d74,
    0xf27b896f,
    0x80deb1fe,
    0x3b1696b1,
    0x9bdc06a7,
    0x25c71235,
    0xc19bf174,
    0xcf692694,
    0xe49b69c1,
    0x9ef14ad2,
    0xefbe4786,
    0x384f25e3,
    0x0fc19dc6,
    0x8b8cd5b5,
    0x240ca1cc,
    0x77ac9c65,
    0x2de92c6f,
    0x592b0275,
    0x4a7484aa,
    0x6ea6e483,
    0x5cb0a9dc,
    0xbd41fbd4,
    0x76f988da,
    0x831153b5,
    0x983e5152,
    0xee66dfab,
    0xa831c66d,
    0x2db43210,
    0xb00327c8,
    0x98fb213f,
    0xbf597fc7,
    0xbeef0ee4,
    0xc6e00bf3,
    0x3da88fc2,
    0xd5a79147,
    0x930aa725,
    0x06ca6351,
    0xe003826f,
    0x14292967,
    0x0a0e6e70,
    0x27b70a85,
    0x46d22ffc,
    0x2e1b2138,
    0x5c26c926,
    0x4d2c6dfc,
    0x5ac42aed,
    0x53380d13,
    0x9d95b3df,
    0x650a7354,
    0x8baf63de,
    0x766a0abb,
    0x3c77b2a8,
    0x81c2c92e,
    0x47edaee6,
    0x92722c85,
    0x1482353b,
    0xa2bfe8a1,
    0x4cf10364,
    0xa81a664b,
    0xbc423001,
    0xc24b8b70,
    0xd0f89791,
    0xc76c51a3,
    0x0654be30,
    0xd192e819,
    0xd6ef5218,
    0xd6990624,
    0x5565a910,
    0xf40e3585,
    0x5771202a,
    0x106aa070,
    0x32bbd1b8,
    0x19a4c116,
    0xb8d2d0c8,
    0x1e376c08,
    0x5141ab53,
    0x2748774c,
    0xdf8eeb99,
    0x34b0bcb5,
    0xe19b48a8,
    0x391c0cb3,
    0xc5c95a63,
    0x4ed8aa4a,
    0xe3418acb,
    0x5b9cca4f,
    0x7763e373,
    0x682e6ff3,
    0xd6b2b8a3,
    0x748f82ee,
    0x5defb2fc,
    0x78a5636f,
    0x43172f60,
    0x84c87814,
    0xa1f0ab72,
    0x8cc70208,
    0x1a6439ec,
    0x90befffa,
    0x23631e28,
    0xa4506ceb,
    0xde82bde9,
    0xbef9a3f7,
    0xb2c67915,
    0xc67178f2,
    0xe372532b,
    0xca273ece,
    0xea26619c,
    0xd186b8c7,
    0x21c0c207,
    0xeada7dd6,
    0xcde0eb1e,
    0xf57d4f7f,
    0xee6ed178,
    0x06f067aa,
    0x72176fba,
    0x0a637dc5,
    0xa2c898a6,
    0x113f9804,
    0xbef90dae,
    0x1b710b35,
    0x131c471b,
    0x28db77f5,
    0x23047d84,
    0x32caab7b,
    0x40c72493,
    0x3c9ebe0a,
    0x15c9bebc,
    0x431d67c4,
    0x9c100d4c,
    0x4cc5d4be,
    0xcb3e42b6,
    0x597f299c,
    0xfc657e2a,
    0x5fcb6fab,
    0x3ad6faec,
    0x6c44198c,
    0x4a475817
];
var $8c503c6f86d31363$var$W = new Array(160);
function $8c503c6f86d31363$var$Sha512() {
    this.init();
    this._w = $8c503c6f86d31363$var$W;
    $6aSoY.call(this, 128, 112);
}
$5SAkX($8c503c6f86d31363$var$Sha512, $6aSoY);
$8c503c6f86d31363$var$Sha512.prototype.init = function() {
    this._ah = 0x6a09e667;
    this._bh = 0xbb67ae85;
    this._ch = 0x3c6ef372;
    this._dh = 0xa54ff53a;
    this._eh = 0x510e527f;
    this._fh = 0x9b05688c;
    this._gh = 0x1f83d9ab;
    this._hh = 0x5be0cd19;
    this._al = 0xf3bcc908;
    this._bl = 0x84caa73b;
    this._cl = 0xfe94f82b;
    this._dl = 0x5f1d36f1;
    this._el = 0xade682d1;
    this._fl = 0x2b3e6c1f;
    this._gl = 0xfb41bd6b;
    this._hl = 0x137e2179;
    return this;
};
function $8c503c6f86d31363$var$Ch(x, y, z) {
    return z ^ x & (y ^ z);
}
function $8c503c6f86d31363$var$maj(x, y, z) {
    return x & y | z & (x | y);
}
function $8c503c6f86d31363$var$sigma0(x, xl) {
    return (x >>> 28 | xl << 4) ^ (xl >>> 2 | x << 30) ^ (xl >>> 7 | x << 25);
}
function $8c503c6f86d31363$var$sigma1(x, xl) {
    return (x >>> 14 | xl << 18) ^ (x >>> 18 | xl << 14) ^ (xl >>> 9 | x << 23);
}
function $8c503c6f86d31363$var$Gamma0(x, xl) {
    return (x >>> 1 | xl << 31) ^ (x >>> 8 | xl << 24) ^ x >>> 7;
}
function $8c503c6f86d31363$var$Gamma0l(x, xl) {
    return (x >>> 1 | xl << 31) ^ (x >>> 8 | xl << 24) ^ (x >>> 7 | xl << 25);
}
function $8c503c6f86d31363$var$Gamma1(x, xl) {
    return (x >>> 19 | xl << 13) ^ (xl >>> 29 | x << 3) ^ x >>> 6;
}
function $8c503c6f86d31363$var$Gamma1l(x, xl) {
    return (x >>> 19 | xl << 13) ^ (xl >>> 29 | x << 3) ^ (x >>> 6 | xl << 26);
}
function $8c503c6f86d31363$var$getCarry(a, b) {
    return a >>> 0 < b >>> 0 ? 1 : 0;
}
$8c503c6f86d31363$var$Sha512.prototype._update = function(M) {
    var W = this._w;
    var ah = this._ah | 0;
    var bh = this._bh | 0;
    var ch = this._ch | 0;
    var dh = this._dh | 0;
    var eh = this._eh | 0;
    var fh = this._fh | 0;
    var gh = this._gh | 0;
    var hh = this._hh | 0;
    var al = this._al | 0;
    var bl = this._bl | 0;
    var cl = this._cl | 0;
    var dl = this._dl | 0;
    var el = this._el | 0;
    var fl = this._fl | 0;
    var gl = this._gl | 0;
    var hl = this._hl | 0;
    for(var i = 0; i < 32; i += 2){
        W[i] = M.readInt32BE(i * 4);
        W[i + 1] = M.readInt32BE(i * 4 + 4);
    }
    for(; i < 160; i += 2){
        var xh = W[i - 30];
        var xl = W[i - 30 + 1];
        var gamma0 = $8c503c6f86d31363$var$Gamma0(xh, xl);
        var gamma0l = $8c503c6f86d31363$var$Gamma0l(xl, xh);
        xh = W[i - 4];
        xl = W[i - 4 + 1];
        var gamma1 = $8c503c6f86d31363$var$Gamma1(xh, xl);
        var gamma1l = $8c503c6f86d31363$var$Gamma1l(xl, xh);
        // W[i] = gamma0 + W[i - 7] + gamma1 + W[i - 16]
        var Wi7h = W[i - 14];
        var Wi7l = W[i - 14 + 1];
        var Wi16h = W[i - 32];
        var Wi16l = W[i - 32 + 1];
        var Wil = gamma0l + Wi7l | 0;
        var Wih = gamma0 + Wi7h + $8c503c6f86d31363$var$getCarry(Wil, gamma0l) | 0;
        Wil = Wil + gamma1l | 0;
        Wih = Wih + gamma1 + $8c503c6f86d31363$var$getCarry(Wil, gamma1l) | 0;
        Wil = Wil + Wi16l | 0;
        Wih = Wih + Wi16h + $8c503c6f86d31363$var$getCarry(Wil, Wi16l) | 0;
        W[i] = Wih;
        W[i + 1] = Wil;
    }
    for(var j = 0; j < 160; j += 2){
        Wih = W[j];
        Wil = W[j + 1];
        var majh = $8c503c6f86d31363$var$maj(ah, bh, ch);
        var majl = $8c503c6f86d31363$var$maj(al, bl, cl);
        var sigma0h = $8c503c6f86d31363$var$sigma0(ah, al);
        var sigma0l = $8c503c6f86d31363$var$sigma0(al, ah);
        var sigma1h = $8c503c6f86d31363$var$sigma1(eh, el);
        var sigma1l = $8c503c6f86d31363$var$sigma1(el, eh);
        // t1 = h + sigma1 + ch + K[j] + W[j]
        var Kih = $8c503c6f86d31363$var$K[j];
        var Kil = $8c503c6f86d31363$var$K[j + 1];
        var chh = $8c503c6f86d31363$var$Ch(eh, fh, gh);
        var chl = $8c503c6f86d31363$var$Ch(el, fl, gl);
        var t1l = hl + sigma1l | 0;
        var t1h = hh + sigma1h + $8c503c6f86d31363$var$getCarry(t1l, hl) | 0;
        t1l = t1l + chl | 0;
        t1h = t1h + chh + $8c503c6f86d31363$var$getCarry(t1l, chl) | 0;
        t1l = t1l + Kil | 0;
        t1h = t1h + Kih + $8c503c6f86d31363$var$getCarry(t1l, Kil) | 0;
        t1l = t1l + Wil | 0;
        t1h = t1h + Wih + $8c503c6f86d31363$var$getCarry(t1l, Wil) | 0;
        // t2 = sigma0 + maj
        var t2l = sigma0l + majl | 0;
        var t2h = sigma0h + majh + $8c503c6f86d31363$var$getCarry(t2l, sigma0l) | 0;
        hh = gh;
        hl = gl;
        gh = fh;
        gl = fl;
        fh = eh;
        fl = el;
        el = dl + t1l | 0;
        eh = dh + t1h + $8c503c6f86d31363$var$getCarry(el, dl) | 0;
        dh = ch;
        dl = cl;
        ch = bh;
        cl = bl;
        bh = ah;
        bl = al;
        al = t1l + t2l | 0;
        ah = t1h + t2h + $8c503c6f86d31363$var$getCarry(al, t1l) | 0;
    }
    this._al = this._al + al | 0;
    this._bl = this._bl + bl | 0;
    this._cl = this._cl + cl | 0;
    this._dl = this._dl + dl | 0;
    this._el = this._el + el | 0;
    this._fl = this._fl + fl | 0;
    this._gl = this._gl + gl | 0;
    this._hl = this._hl + hl | 0;
    this._ah = this._ah + ah + $8c503c6f86d31363$var$getCarry(this._al, al) | 0;
    this._bh = this._bh + bh + $8c503c6f86d31363$var$getCarry(this._bl, bl) | 0;
    this._ch = this._ch + ch + $8c503c6f86d31363$var$getCarry(this._cl, cl) | 0;
    this._dh = this._dh + dh + $8c503c6f86d31363$var$getCarry(this._dl, dl) | 0;
    this._eh = this._eh + eh + $8c503c6f86d31363$var$getCarry(this._el, el) | 0;
    this._fh = this._fh + fh + $8c503c6f86d31363$var$getCarry(this._fl, fl) | 0;
    this._gh = this._gh + gh + $8c503c6f86d31363$var$getCarry(this._gl, gl) | 0;
    this._hh = this._hh + hh + $8c503c6f86d31363$var$getCarry(this._hl, hl) | 0;
};
$8c503c6f86d31363$var$Sha512.prototype._hash = function() {
    var H = $8c503c6f86d31363$require$Buffer.allocUnsafe(64);
    function writeInt64BE(h, l, offset) {
        H.writeInt32BE(h, offset);
        H.writeInt32BE(l, offset + 4);
    }
    writeInt64BE(this._ah, this._al, 0);
    writeInt64BE(this._bh, this._bl, 8);
    writeInt64BE(this._ch, this._cl, 16);
    writeInt64BE(this._dh, this._dl, 24);
    writeInt64BE(this._eh, this._el, 32);
    writeInt64BE(this._fh, this._fl, 40);
    writeInt64BE(this._gh, this._gl, 48);
    writeInt64BE(this._hh, this._hl, 56);
    return H;
};
module.exports = $8c503c6f86d31363$var$Sha512;

});



parcelRequire.register("gqjfY", function(module, exports) {

var $3pA6p = parcelRequire("3pA6p");
var $bf4e0307f0375d0e$require$Buffer = $3pA6p.Buffer;

var $rup7q = parcelRequire("rup7q");
var $bf4e0307f0375d0e$require$Transform = $rup7q.Transform;

var $d23j5 = parcelRequire("d23j5");
var $bf4e0307f0375d0e$require$StringDecoder = $d23j5.StringDecoder;

var $5SAkX = parcelRequire("5SAkX");
function $bf4e0307f0375d0e$var$CipherBase(hashMode) {
    $bf4e0307f0375d0e$require$Transform.call(this);
    this.hashMode = typeof hashMode === "string";
    if (this.hashMode) this[hashMode] = this._finalOrDigest;
    else this.final = this._finalOrDigest;
    if (this._final) {
        this.__final = this._final;
        this._final = null;
    }
    this._decoder = null;
    this._encoding = null;
}
$5SAkX($bf4e0307f0375d0e$var$CipherBase, $bf4e0307f0375d0e$require$Transform);
$bf4e0307f0375d0e$var$CipherBase.prototype.update = function(data, inputEnc, outputEnc) {
    if (typeof data === "string") data = $bf4e0307f0375d0e$require$Buffer.from(data, inputEnc);
    var outData = this._update(data);
    if (this.hashMode) return this;
    if (outputEnc) outData = this._toString(outData, outputEnc);
    return outData;
};
$bf4e0307f0375d0e$var$CipherBase.prototype.setAutoPadding = function() {};
$bf4e0307f0375d0e$var$CipherBase.prototype.getAuthTag = function() {
    throw new Error("trying to get auth tag in unsupported state");
};
$bf4e0307f0375d0e$var$CipherBase.prototype.setAuthTag = function() {
    throw new Error("trying to set auth tag in unsupported state");
};
$bf4e0307f0375d0e$var$CipherBase.prototype.setAAD = function() {
    throw new Error("trying to set aad in unsupported state");
};
$bf4e0307f0375d0e$var$CipherBase.prototype._transform = function(data, _, next) {
    var err;
    try {
        if (this.hashMode) this._update(data);
        else this.push(this._update(data));
    } catch (e) {
        err = e;
    } finally{
        next(err);
    }
};
$bf4e0307f0375d0e$var$CipherBase.prototype._flush = function(done) {
    var err;
    try {
        this.push(this.__final());
    } catch (e) {
        err = e;
    }
    done(err);
};
$bf4e0307f0375d0e$var$CipherBase.prototype._finalOrDigest = function(outputEnc) {
    var outData = this.__final() || $bf4e0307f0375d0e$require$Buffer.alloc(0);
    if (outputEnc) outData = this._toString(outData, outputEnc, true);
    return outData;
};
$bf4e0307f0375d0e$var$CipherBase.prototype._toString = function(value, enc, fin) {
    if (!this._decoder) {
        this._decoder = new $bf4e0307f0375d0e$require$StringDecoder(enc);
        this._encoding = enc;
    }
    if (this._encoding !== enc) throw new Error("can't switch encodings");
    var out = this._decoder.write(value);
    if (fin) out += this._decoder.end();
    return out;
};
module.exports = $bf4e0307f0375d0e$var$CipherBase;

});
parcelRequire.register("rup7q", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
module.exports = $052a1b5c35ee14fc$var$Stream;

var $ikynl = parcelRequire("ikynl");
var $052a1b5c35ee14fc$require$EE = $ikynl.EventEmitter;

var $5SAkX = parcelRequire("5SAkX");
$5SAkX($052a1b5c35ee14fc$var$Stream, $052a1b5c35ee14fc$require$EE);

$052a1b5c35ee14fc$var$Stream.Readable = (parcelRequire("hoMkK"));

$052a1b5c35ee14fc$var$Stream.Writable = (parcelRequire("h31UB"));

$052a1b5c35ee14fc$var$Stream.Duplex = (parcelRequire("cMizL"));

$052a1b5c35ee14fc$var$Stream.Transform = (parcelRequire("6vslQ"));

$052a1b5c35ee14fc$var$Stream.PassThrough = (parcelRequire("kMGT2"));

$052a1b5c35ee14fc$var$Stream.finished = (parcelRequire("jIV9q"));

$052a1b5c35ee14fc$var$Stream.pipeline = (parcelRequire("8a2DY"));
// Backwards-compat with node 0.4.x
$052a1b5c35ee14fc$var$Stream.Stream = $052a1b5c35ee14fc$var$Stream;
// old-style streams.  Note that the pipe method (the only relevant
// part of this class) is overridden in the Readable class.
function $052a1b5c35ee14fc$var$Stream() {
    $052a1b5c35ee14fc$require$EE.call(this);
}
$052a1b5c35ee14fc$var$Stream.prototype.pipe = function(dest, options) {
    var source = this;
    function ondata(chunk) {
        if (dest.writable) {
            if (false === dest.write(chunk) && source.pause) source.pause();
        }
    }
    source.on("data", ondata);
    function ondrain() {
        if (source.readable && source.resume) source.resume();
    }
    dest.on("drain", ondrain);
    // If the 'end' option is not supplied, dest.end() will be called when
    // source gets the 'end' or 'close' events.  Only dest.end() once.
    if (!dest._isStdio && (!options || options.end !== false)) {
        source.on("end", onend);
        source.on("close", onclose);
    }
    var didOnEnd = false;
    function onend() {
        if (didOnEnd) return;
        didOnEnd = true;
        dest.end();
    }
    function onclose() {
        if (didOnEnd) return;
        didOnEnd = true;
        if (typeof dest.destroy === "function") dest.destroy();
    }
    // don't leave dangling pipes when there are errors.
    function onerror(er) {
        cleanup();
        if ($052a1b5c35ee14fc$require$EE.listenerCount(this, "error") === 0) throw er; // Unhandled stream error in pipe.
    }
    source.on("error", onerror);
    dest.on("error", onerror);
    // remove all the event listeners that were added.
    function cleanup() {
        source.removeListener("data", ondata);
        dest.removeListener("drain", ondrain);
        source.removeListener("end", onend);
        source.removeListener("close", onclose);
        source.removeListener("error", onerror);
        dest.removeListener("error", onerror);
        source.removeListener("end", cleanup);
        source.removeListener("close", cleanup);
        dest.removeListener("close", cleanup);
    }
    source.on("end", cleanup);
    source.on("close", cleanup);
    dest.on("close", cleanup);
    dest.emit("pipe", source);
    // Allow for unix-like usage: A.pipe(B).pipe(C)
    return dest;
};

});



parcelRequire.register("7oblv", function(module, exports) {
"use strict";

var $5SAkX = parcelRequire("5SAkX");

var $emBku = parcelRequire("emBku");

var $gqjfY = parcelRequire("gqjfY");

var $3pA6p = parcelRequire("3pA6p");
var $5613935f600351c7$require$Buffer = $3pA6p.Buffer;

var $fNQ4a = parcelRequire("fNQ4a");

var $cr6gj = parcelRequire("cr6gj");

var $4Dhna = parcelRequire("4Dhna");
var $5613935f600351c7$var$ZEROS = $5613935f600351c7$require$Buffer.alloc(128);
function $5613935f600351c7$var$Hmac(alg, key) {
    $gqjfY.call(this, "digest");
    if (typeof key === "string") key = $5613935f600351c7$require$Buffer.from(key);
    var blocksize = alg === "sha512" || alg === "sha384" ? 128 : 64;
    this._alg = alg;
    this._key = key;
    if (key.length > blocksize) {
        var hash = alg === "rmd160" ? new $cr6gj() : $4Dhna(alg);
        key = hash.update(key).digest();
    } else if (key.length < blocksize) key = $5613935f600351c7$require$Buffer.concat([
        key,
        $5613935f600351c7$var$ZEROS
    ], blocksize);
    var ipad = this._ipad = $5613935f600351c7$require$Buffer.allocUnsafe(blocksize);
    var opad = this._opad = $5613935f600351c7$require$Buffer.allocUnsafe(blocksize);
    for(var i = 0; i < blocksize; i++){
        ipad[i] = key[i] ^ 0x36;
        opad[i] = key[i] ^ 0x5C;
    }
    this._hash = alg === "rmd160" ? new $cr6gj() : $4Dhna(alg);
    this._hash.update(ipad);
}
$5SAkX($5613935f600351c7$var$Hmac, $gqjfY);
$5613935f600351c7$var$Hmac.prototype._update = function(data) {
    this._hash.update(data);
};
$5613935f600351c7$var$Hmac.prototype._final = function() {
    var h = this._hash.digest();
    var hash = this._alg === "rmd160" ? new $cr6gj() : $4Dhna(this._alg);
    return hash.update(this._opad).update(h).digest();
};
module.exports = function createHmac(alg, key) {
    alg = alg.toLowerCase();
    if (alg === "rmd160" || alg === "ripemd160") return new $5613935f600351c7$var$Hmac("rmd160", key);
    if (alg === "md5") return new $emBku($fNQ4a, key);
    return new $5613935f600351c7$var$Hmac(alg, key);
};

});
parcelRequire.register("emBku", function(module, exports) {
"use strict";

var $5SAkX = parcelRequire("5SAkX");

var $3pA6p = parcelRequire("3pA6p");
var $a7501398697fbc88$require$Buffer = $3pA6p.Buffer;

var $gqjfY = parcelRequire("gqjfY");
var $a7501398697fbc88$var$ZEROS = $a7501398697fbc88$require$Buffer.alloc(128);
var $a7501398697fbc88$var$blocksize = 64;
function $a7501398697fbc88$var$Hmac(alg, key) {
    $gqjfY.call(this, "digest");
    if (typeof key === "string") key = $a7501398697fbc88$require$Buffer.from(key);
    this._alg = alg;
    this._key = key;
    if (key.length > $a7501398697fbc88$var$blocksize) key = alg(key);
    else if (key.length < $a7501398697fbc88$var$blocksize) key = $a7501398697fbc88$require$Buffer.concat([
        key,
        $a7501398697fbc88$var$ZEROS
    ], $a7501398697fbc88$var$blocksize);
    var ipad = this._ipad = $a7501398697fbc88$require$Buffer.allocUnsafe($a7501398697fbc88$var$blocksize);
    var opad = this._opad = $a7501398697fbc88$require$Buffer.allocUnsafe($a7501398697fbc88$var$blocksize);
    for(var i = 0; i < $a7501398697fbc88$var$blocksize; i++){
        ipad[i] = key[i] ^ 0x36;
        opad[i] = key[i] ^ 0x5C;
    }
    this._hash = [
        ipad
    ];
}
$5SAkX($a7501398697fbc88$var$Hmac, $gqjfY);
$a7501398697fbc88$var$Hmac.prototype._update = function(data) {
    this._hash.push(data);
};
$a7501398697fbc88$var$Hmac.prototype._final = function() {
    var h = this._alg($a7501398697fbc88$require$Buffer.concat(this._hash));
    return this._alg($a7501398697fbc88$require$Buffer.concat([
        this._opad,
        h
    ]));
};
module.exports = $a7501398697fbc88$var$Hmac;

});

parcelRequire.register("fNQ4a", function(module, exports) {

var $lQqEc = parcelRequire("lQqEc");
module.exports = function(buffer) {
    return new $lQqEc().update(buffer).digest();
};

});


parcelRequire.register("g3qIi", function(module, exports) {

module.exports = (parcelRequire("daoze"));

});
parcelRequire.register("daoze", function(module, exports) {
module.exports = JSON.parse('{"sha224WithRSAEncryption":{"sign":"rsa","hash":"sha224","id":"302d300d06096086480165030402040500041c"},"RSA-SHA224":{"sign":"ecdsa/rsa","hash":"sha224","id":"302d300d06096086480165030402040500041c"},"sha256WithRSAEncryption":{"sign":"rsa","hash":"sha256","id":"3031300d060960864801650304020105000420"},"RSA-SHA256":{"sign":"ecdsa/rsa","hash":"sha256","id":"3031300d060960864801650304020105000420"},"sha384WithRSAEncryption":{"sign":"rsa","hash":"sha384","id":"3041300d060960864801650304020205000430"},"RSA-SHA384":{"sign":"ecdsa/rsa","hash":"sha384","id":"3041300d060960864801650304020205000430"},"sha512WithRSAEncryption":{"sign":"rsa","hash":"sha512","id":"3051300d060960864801650304020305000440"},"RSA-SHA512":{"sign":"ecdsa/rsa","hash":"sha512","id":"3051300d060960864801650304020305000440"},"RSA-SHA1":{"sign":"rsa","hash":"sha1","id":"3021300906052b0e03021a05000414"},"ecdsa-with-SHA1":{"sign":"ecdsa","hash":"sha1","id":""},"sha256":{"sign":"ecdsa","hash":"sha256","id":""},"sha224":{"sign":"ecdsa","hash":"sha224","id":""},"sha384":{"sign":"ecdsa","hash":"sha384","id":""},"sha512":{"sign":"ecdsa","hash":"sha512","id":""},"DSA-SHA":{"sign":"dsa","hash":"sha1","id":""},"DSA-SHA1":{"sign":"dsa","hash":"sha1","id":""},"DSA":{"sign":"dsa","hash":"sha1","id":""},"DSA-WITH-SHA224":{"sign":"dsa","hash":"sha224","id":""},"DSA-SHA224":{"sign":"dsa","hash":"sha224","id":""},"DSA-WITH-SHA256":{"sign":"dsa","hash":"sha256","id":""},"DSA-SHA256":{"sign":"dsa","hash":"sha256","id":""},"DSA-WITH-SHA384":{"sign":"dsa","hash":"sha384","id":""},"DSA-SHA384":{"sign":"dsa","hash":"sha384","id":""},"DSA-WITH-SHA512":{"sign":"dsa","hash":"sha512","id":""},"DSA-SHA512":{"sign":"dsa","hash":"sha512","id":""},"DSA-RIPEMD160":{"sign":"dsa","hash":"rmd160","id":""},"ripemd160WithRSA":{"sign":"rsa","hash":"rmd160","id":"3021300906052b2403020105000414"},"RSA-RIPEMD160":{"sign":"rsa","hash":"rmd160","id":"3021300906052b2403020105000414"},"md5WithRSAEncryption":{"sign":"rsa","hash":"md5","id":"3020300c06082a864886f70d020505000410"},"RSA-MD5":{"sign":"rsa","hash":"md5","id":"3020300c06082a864886f70d020505000410"}}');

});


parcelRequire.register("cW6k9", function(module, exports) {

$parcel$export(module.exports, "pbkdf2", () => $96afce9ee7dbbdae$export$448fa22aedc9dbca, (v) => $96afce9ee7dbbdae$export$448fa22aedc9dbca = v);
$parcel$export(module.exports, "pbkdf2Sync", () => $96afce9ee7dbbdae$export$b80c7ba289c8fa56, (v) => $96afce9ee7dbbdae$export$b80c7ba289c8fa56 = v);
var $96afce9ee7dbbdae$export$448fa22aedc9dbca;
var $96afce9ee7dbbdae$export$b80c7ba289c8fa56;

$96afce9ee7dbbdae$export$448fa22aedc9dbca = (parcelRequire("4TwM6"));

$96afce9ee7dbbdae$export$b80c7ba289c8fa56 = (parcelRequire("5B730"));

});
parcelRequire.register("4TwM6", function(module, exports) {

var $3pA6p = parcelRequire("3pA6p");
var $3905b8e3a7798707$require$Buffer = $3pA6p.Buffer;

var $4wOKT = parcelRequire("4wOKT");

var $2ebQw = parcelRequire("2ebQw");

var $5B730 = parcelRequire("5B730");

var $b4C5p = parcelRequire("b4C5p");
var $3905b8e3a7798707$var$ZERO_BUF;
var $3905b8e3a7798707$var$subtle = $parcel$global.crypto && $parcel$global.crypto.subtle;
var $3905b8e3a7798707$var$toBrowser = {
    sha: "SHA-1",
    "sha-1": "SHA-1",
    sha1: "SHA-1",
    sha256: "SHA-256",
    "sha-256": "SHA-256",
    sha384: "SHA-384",
    "sha-384": "SHA-384",
    "sha-512": "SHA-512",
    sha512: "SHA-512"
};
var $3905b8e3a7798707$var$checks = [];
function $3905b8e3a7798707$var$checkNative(algo) {
    if ($parcel$global.process && !$parcel$global.process.browser) return Promise.resolve(false);
    if (!$3905b8e3a7798707$var$subtle || !$3905b8e3a7798707$var$subtle.importKey || !$3905b8e3a7798707$var$subtle.deriveBits) return Promise.resolve(false);
    if ($3905b8e3a7798707$var$checks[algo] !== undefined) return $3905b8e3a7798707$var$checks[algo];
    $3905b8e3a7798707$var$ZERO_BUF = $3905b8e3a7798707$var$ZERO_BUF || $3905b8e3a7798707$require$Buffer.alloc(8);
    var prom = $3905b8e3a7798707$var$browserPbkdf2($3905b8e3a7798707$var$ZERO_BUF, $3905b8e3a7798707$var$ZERO_BUF, 10, 128, algo).then(function() {
        return true;
    }).catch(function() {
        return false;
    });
    $3905b8e3a7798707$var$checks[algo] = prom;
    return prom;
}
var $3905b8e3a7798707$var$nextTick;
function $3905b8e3a7798707$var$getNextTick() {
    if ($3905b8e3a7798707$var$nextTick) return $3905b8e3a7798707$var$nextTick;
    if ($parcel$global.process && $parcel$global.process.nextTick) $3905b8e3a7798707$var$nextTick = $parcel$global.process.nextTick;
    else if ($parcel$global.queueMicrotask) $3905b8e3a7798707$var$nextTick = $parcel$global.queueMicrotask;
    else if ($parcel$global.setImmediate) $3905b8e3a7798707$var$nextTick = $parcel$global.setImmediate;
    else $3905b8e3a7798707$var$nextTick = $parcel$global.setTimeout;
    return $3905b8e3a7798707$var$nextTick;
}
function $3905b8e3a7798707$var$browserPbkdf2(password, salt, iterations, length, algo) {
    return $3905b8e3a7798707$var$subtle.importKey("raw", password, {
        name: "PBKDF2"
    }, false, [
        "deriveBits"
    ]).then(function(key) {
        return $3905b8e3a7798707$var$subtle.deriveBits({
            name: "PBKDF2",
            salt: salt,
            iterations: iterations,
            hash: {
                name: algo
            }
        }, key, length << 3);
    }).then(function(res) {
        return $3905b8e3a7798707$require$Buffer.from(res);
    });
}
function $3905b8e3a7798707$var$resolvePromise(promise, callback) {
    promise.then(function(out) {
        $3905b8e3a7798707$var$getNextTick()(function() {
            callback(null, out);
        });
    }, function(e) {
        $3905b8e3a7798707$var$getNextTick()(function() {
            callback(e);
        });
    });
}
module.exports = function(password, salt, iterations, keylen, digest, callback) {
    if (typeof digest === "function") {
        callback = digest;
        digest = undefined;
    }
    digest = digest || "sha1";
    var algo = $3905b8e3a7798707$var$toBrowser[digest.toLowerCase()];
    if (!algo || typeof $parcel$global.Promise !== "function") {
        $3905b8e3a7798707$var$getNextTick()(function() {
            var out;
            try {
                out = $5B730(password, salt, iterations, keylen, digest);
            } catch (e) {
                return callback(e);
            }
            callback(null, out);
        });
        return;
    }
    $4wOKT(iterations, keylen);
    password = $b4C5p(password, $2ebQw, "Password");
    salt = $b4C5p(salt, $2ebQw, "Salt");
    if (typeof callback !== "function") throw new Error("No callback provided to pbkdf2");
    $3905b8e3a7798707$var$resolvePromise($3905b8e3a7798707$var$checkNative(algo).then(function(resp) {
        if (resp) return $3905b8e3a7798707$var$browserPbkdf2(password, salt, iterations, keylen, algo);
        return $5B730(password, salt, iterations, keylen, digest);
    }), callback);
};

});
parcelRequire.register("4wOKT", function(module, exports) {
var $34c1858e76fad624$var$MAX_ALLOC = Math.pow(2, 30) - 1 // default in iojs
;
module.exports = function(iterations, keylen) {
    if (typeof iterations !== "number") throw new TypeError("Iterations not a number");
    if (iterations < 0) throw new TypeError("Bad iterations");
    if (typeof keylen !== "number") throw new TypeError("Key length not a number");
    if (keylen < 0 || keylen > $34c1858e76fad624$var$MAX_ALLOC || keylen !== keylen) throw new TypeError("Bad key length");
};

});

parcelRequire.register("2ebQw", function(module, exports) {

var $hIXGI = parcelRequire("hIXGI");
var $19f613f94ce76cd3$var$defaultEncoding;
/* istanbul ignore next */ if ($parcel$global.process && $parcel$global.process.browser) $19f613f94ce76cd3$var$defaultEncoding = "utf-8";
else if ($parcel$global.process && $parcel$global.process.version) {
    var $19f613f94ce76cd3$var$pVersionMajor = parseInt($hIXGI.version.split(".")[0].slice(1), 10);
    $19f613f94ce76cd3$var$defaultEncoding = $19f613f94ce76cd3$var$pVersionMajor >= 6 ? "utf-8" : "binary";
} else $19f613f94ce76cd3$var$defaultEncoding = "utf-8";
module.exports = $19f613f94ce76cd3$var$defaultEncoding;

});

parcelRequire.register("5B730", function(module, exports) {

var $fNQ4a = parcelRequire("fNQ4a");

var $cr6gj = parcelRequire("cr6gj");

var $4Dhna = parcelRequire("4Dhna");

var $3pA6p = parcelRequire("3pA6p");
var $4135dff30fd4c003$require$Buffer = $3pA6p.Buffer;

var $4wOKT = parcelRequire("4wOKT");

var $2ebQw = parcelRequire("2ebQw");

var $b4C5p = parcelRequire("b4C5p");
var $4135dff30fd4c003$var$ZEROS = $4135dff30fd4c003$require$Buffer.alloc(128);
var $4135dff30fd4c003$var$sizes = {
    md5: 16,
    sha1: 20,
    sha224: 28,
    sha256: 32,
    sha384: 48,
    sha512: 64,
    rmd160: 20,
    ripemd160: 20
};
function $4135dff30fd4c003$var$Hmac(alg, key, saltLen) {
    var hash = $4135dff30fd4c003$var$getDigest(alg);
    var blocksize = alg === "sha512" || alg === "sha384" ? 128 : 64;
    if (key.length > blocksize) key = hash(key);
    else if (key.length < blocksize) key = $4135dff30fd4c003$require$Buffer.concat([
        key,
        $4135dff30fd4c003$var$ZEROS
    ], blocksize);
    var ipad = $4135dff30fd4c003$require$Buffer.allocUnsafe(blocksize + $4135dff30fd4c003$var$sizes[alg]);
    var opad = $4135dff30fd4c003$require$Buffer.allocUnsafe(blocksize + $4135dff30fd4c003$var$sizes[alg]);
    for(var i = 0; i < blocksize; i++){
        ipad[i] = key[i] ^ 0x36;
        opad[i] = key[i] ^ 0x5C;
    }
    var ipad1 = $4135dff30fd4c003$require$Buffer.allocUnsafe(blocksize + saltLen + 4);
    ipad.copy(ipad1, 0, 0, blocksize);
    this.ipad1 = ipad1;
    this.ipad2 = ipad;
    this.opad = opad;
    this.alg = alg;
    this.blocksize = blocksize;
    this.hash = hash;
    this.size = $4135dff30fd4c003$var$sizes[alg];
}
$4135dff30fd4c003$var$Hmac.prototype.run = function(data, ipad) {
    data.copy(ipad, this.blocksize);
    var h = this.hash(ipad);
    h.copy(this.opad, this.blocksize);
    return this.hash(this.opad);
};
function $4135dff30fd4c003$var$getDigest(alg) {
    function shaFunc(data) {
        return $4Dhna(alg).update(data).digest();
    }
    function rmd160Func(data) {
        return new $cr6gj().update(data).digest();
    }
    if (alg === "rmd160" || alg === "ripemd160") return rmd160Func;
    if (alg === "md5") return $fNQ4a;
    return shaFunc;
}
function $4135dff30fd4c003$var$pbkdf2(password, salt, iterations, keylen, digest) {
    $4wOKT(iterations, keylen);
    password = $b4C5p(password, $2ebQw, "Password");
    salt = $b4C5p(salt, $2ebQw, "Salt");
    digest = digest || "sha1";
    var hmac = new $4135dff30fd4c003$var$Hmac(digest, password, salt.length);
    var DK = $4135dff30fd4c003$require$Buffer.allocUnsafe(keylen);
    var block1 = $4135dff30fd4c003$require$Buffer.allocUnsafe(salt.length + 4);
    salt.copy(block1, 0, 0, salt.length);
    var destPos = 0;
    var hLen = $4135dff30fd4c003$var$sizes[digest];
    var l = Math.ceil(keylen / hLen);
    for(var i = 1; i <= l; i++){
        block1.writeUInt32BE(i, salt.length);
        var T = hmac.run(block1, hmac.ipad1);
        var U = T;
        for(var j = 1; j < iterations; j++){
            U = hmac.run(U, hmac.ipad2);
            for(var k = 0; k < hLen; k++)T[k] ^= U[k];
        }
        T.copy(DK, destPos);
        destPos += hLen;
    }
    return DK;
}
module.exports = $4135dff30fd4c003$var$pbkdf2;

});
parcelRequire.register("b4C5p", function(module, exports) {

var $3pA6p = parcelRequire("3pA6p");
var $80fd9c96a913234a$require$Buffer = $3pA6p.Buffer;
module.exports = function(thing, encoding, name) {
    if ($80fd9c96a913234a$require$Buffer.isBuffer(thing)) return thing;
    else if (typeof thing === "string") return $80fd9c96a913234a$require$Buffer.from(thing, encoding);
    else if (ArrayBuffer.isView(thing)) return $80fd9c96a913234a$require$Buffer.from(thing.buffer);
    else throw new TypeError(name + " must be a string, a Buffer, a typed array or a DataView");
};

});




parcelRequire.register("jZo93", function(module, exports) {

$parcel$export(module.exports, "createCipher", () => $e8d6718a4c138af7$export$bdd223f16383713e, (v) => $e8d6718a4c138af7$export$bdd223f16383713e = v);
$parcel$export(module.exports, "Cipher", () => $e8d6718a4c138af7$export$26e5786e8ac8e530, (v) => $e8d6718a4c138af7$export$26e5786e8ac8e530 = v);
$parcel$export(module.exports, "createCipheriv", () => $e8d6718a4c138af7$export$2f64596b8cbf08b4, (v) => $e8d6718a4c138af7$export$2f64596b8cbf08b4 = v);
$parcel$export(module.exports, "Cipheriv", () => $e8d6718a4c138af7$export$20533d26f07f1ee0, (v) => $e8d6718a4c138af7$export$20533d26f07f1ee0 = v);
$parcel$export(module.exports, "createDecipher", () => $e8d6718a4c138af7$export$12ada9414fbc594c, (v) => $e8d6718a4c138af7$export$12ada9414fbc594c = v);
$parcel$export(module.exports, "Decipher", () => $e8d6718a4c138af7$export$2ce6d8d0e8b04e1a, (v) => $e8d6718a4c138af7$export$2ce6d8d0e8b04e1a = v);
$parcel$export(module.exports, "createDecipheriv", () => $e8d6718a4c138af7$export$36b6d6ef312eab39, (v) => $e8d6718a4c138af7$export$36b6d6ef312eab39 = v);
$parcel$export(module.exports, "Decipheriv", () => $e8d6718a4c138af7$export$f5e7e39d57cd9700, (v) => $e8d6718a4c138af7$export$f5e7e39d57cd9700 = v);
$parcel$export(module.exports, "listCiphers", () => $e8d6718a4c138af7$export$dedd8dc3dc62b370, (v) => $e8d6718a4c138af7$export$dedd8dc3dc62b370 = v);
$parcel$export(module.exports, "getCiphers", () => $e8d6718a4c138af7$export$58a258485f1e49f6, (v) => $e8d6718a4c138af7$export$58a258485f1e49f6 = v);
var $e8d6718a4c138af7$export$bdd223f16383713e;
var $e8d6718a4c138af7$export$26e5786e8ac8e530;
var $e8d6718a4c138af7$export$2f64596b8cbf08b4;
var $e8d6718a4c138af7$export$20533d26f07f1ee0;
var $e8d6718a4c138af7$export$12ada9414fbc594c;
var $e8d6718a4c138af7$export$2ce6d8d0e8b04e1a;
var $e8d6718a4c138af7$export$36b6d6ef312eab39;
var $e8d6718a4c138af7$export$f5e7e39d57cd9700;
var $e8d6718a4c138af7$export$dedd8dc3dc62b370;
var $e8d6718a4c138af7$export$58a258485f1e49f6;

var $7i2VE = parcelRequire("7i2VE");

var $eSUIi = parcelRequire("eSUIi");

var $7S8Y3 = parcelRequire("7S8Y3");

var $l5SK0 = parcelRequire("l5SK0");

var $ijkRj = parcelRequire("ijkRj");
function $e8d6718a4c138af7$var$createCipher(suite, password) {
    suite = suite.toLowerCase();
    var keyLen, ivLen;
    if ($7S8Y3[suite]) {
        keyLen = $7S8Y3[suite].key;
        ivLen = $7S8Y3[suite].iv;
    } else if ($l5SK0[suite]) {
        keyLen = $l5SK0[suite].key * 8;
        ivLen = $l5SK0[suite].iv;
    } else throw new TypeError("invalid suite type");
    var keys = $ijkRj(password, false, keyLen, ivLen);
    return $e8d6718a4c138af7$var$createCipheriv(suite, keys.key, keys.iv);
}
function $e8d6718a4c138af7$var$createDecipher(suite, password) {
    suite = suite.toLowerCase();
    var keyLen, ivLen;
    if ($7S8Y3[suite]) {
        keyLen = $7S8Y3[suite].key;
        ivLen = $7S8Y3[suite].iv;
    } else if ($l5SK0[suite]) {
        keyLen = $l5SK0[suite].key * 8;
        ivLen = $l5SK0[suite].iv;
    } else throw new TypeError("invalid suite type");
    var keys = $ijkRj(password, false, keyLen, ivLen);
    return $e8d6718a4c138af7$var$createDecipheriv(suite, keys.key, keys.iv);
}
function $e8d6718a4c138af7$var$createCipheriv(suite, key, iv) {
    suite = suite.toLowerCase();
    if ($7S8Y3[suite]) return $eSUIi.createCipheriv(suite, key, iv);
    if ($l5SK0[suite]) return new $7i2VE({
        key: key,
        iv: iv,
        mode: suite
    });
    throw new TypeError("invalid suite type");
}
function $e8d6718a4c138af7$var$createDecipheriv(suite, key, iv) {
    suite = suite.toLowerCase();
    if ($7S8Y3[suite]) return $eSUIi.createDecipheriv(suite, key, iv);
    if ($l5SK0[suite]) return new $7i2VE({
        key: key,
        iv: iv,
        mode: suite,
        decrypt: true
    });
    throw new TypeError("invalid suite type");
}
function $e8d6718a4c138af7$var$getCiphers() {
    return Object.keys($l5SK0).concat($eSUIi.getCiphers());
}
$e8d6718a4c138af7$export$bdd223f16383713e = $e8d6718a4c138af7$export$26e5786e8ac8e530 = $e8d6718a4c138af7$var$createCipher;
$e8d6718a4c138af7$export$2f64596b8cbf08b4 = $e8d6718a4c138af7$export$20533d26f07f1ee0 = $e8d6718a4c138af7$var$createCipheriv;
$e8d6718a4c138af7$export$12ada9414fbc594c = $e8d6718a4c138af7$export$2ce6d8d0e8b04e1a = $e8d6718a4c138af7$var$createDecipher;
$e8d6718a4c138af7$export$36b6d6ef312eab39 = $e8d6718a4c138af7$export$f5e7e39d57cd9700 = $e8d6718a4c138af7$var$createDecipheriv;
$e8d6718a4c138af7$export$dedd8dc3dc62b370 = $e8d6718a4c138af7$export$58a258485f1e49f6 = $e8d6718a4c138af7$var$getCiphers;

});
parcelRequire.register("7i2VE", function(module, exports) {

var $gqjfY = parcelRequire("gqjfY");

var $8gzJ5 = parcelRequire("8gzJ5");

var $5SAkX = parcelRequire("5SAkX");

var $3pA6p = parcelRequire("3pA6p");
var $54ec7c7a67d91806$require$Buffer = $3pA6p.Buffer;
var $54ec7c7a67d91806$var$modes = {
    "des-ede3-cbc": $8gzJ5.CBC.instantiate($8gzJ5.EDE),
    "des-ede3": $8gzJ5.EDE,
    "des-ede-cbc": $8gzJ5.CBC.instantiate($8gzJ5.EDE),
    "des-ede": $8gzJ5.EDE,
    "des-cbc": $8gzJ5.CBC.instantiate($8gzJ5.DES),
    "des-ecb": $8gzJ5.DES
};
$54ec7c7a67d91806$var$modes.des = $54ec7c7a67d91806$var$modes["des-cbc"];
$54ec7c7a67d91806$var$modes.des3 = $54ec7c7a67d91806$var$modes["des-ede3-cbc"];
module.exports = $54ec7c7a67d91806$var$DES;
$5SAkX($54ec7c7a67d91806$var$DES, $gqjfY);
function $54ec7c7a67d91806$var$DES(opts) {
    $gqjfY.call(this);
    var modeName = opts.mode.toLowerCase();
    var mode = $54ec7c7a67d91806$var$modes[modeName];
    var type;
    if (opts.decrypt) type = "decrypt";
    else type = "encrypt";
    var key = opts.key;
    if (!$54ec7c7a67d91806$require$Buffer.isBuffer(key)) key = $54ec7c7a67d91806$require$Buffer.from(key);
    if (modeName === "des-ede" || modeName === "des-ede-cbc") key = $54ec7c7a67d91806$require$Buffer.concat([
        key,
        key.slice(0, 8)
    ]);
    var iv = opts.iv;
    if (!$54ec7c7a67d91806$require$Buffer.isBuffer(iv)) iv = $54ec7c7a67d91806$require$Buffer.from(iv);
    this._des = mode.create({
        key: key,
        iv: iv,
        type: type
    });
}
$54ec7c7a67d91806$var$DES.prototype._update = function(data) {
    return $54ec7c7a67d91806$require$Buffer.from(this._des.update(data));
};
$54ec7c7a67d91806$var$DES.prototype._final = function() {
    return $54ec7c7a67d91806$require$Buffer.from(this._des.final());
};

});
parcelRequire.register("8gzJ5", function(module, exports) {

$parcel$export(module.exports, "DES", () => $604b87dadbefdeb3$export$cc8859615686b300, (v) => $604b87dadbefdeb3$export$cc8859615686b300 = v);
$parcel$export(module.exports, "CBC", () => $604b87dadbefdeb3$export$8ad3f227af08fcc5, (v) => $604b87dadbefdeb3$export$8ad3f227af08fcc5 = v);
$parcel$export(module.exports, "EDE", () => $604b87dadbefdeb3$export$947646e34766044f, (v) => $604b87dadbefdeb3$export$947646e34766044f = v);
var $604b87dadbefdeb3$export$eab97d15b1788b8d;
var $604b87dadbefdeb3$export$26e5786e8ac8e530;
var $604b87dadbefdeb3$export$cc8859615686b300;
var $604b87dadbefdeb3$export$8ad3f227af08fcc5;
var $604b87dadbefdeb3$export$947646e34766044f;
"use strict";

$604b87dadbefdeb3$export$eab97d15b1788b8d = (parcelRequire("4m0P7"));

$604b87dadbefdeb3$export$26e5786e8ac8e530 = (parcelRequire("gqNIC"));

$604b87dadbefdeb3$export$cc8859615686b300 = (parcelRequire("8VWKA"));

$604b87dadbefdeb3$export$8ad3f227af08fcc5 = (parcelRequire("6ZgbN"));

$604b87dadbefdeb3$export$947646e34766044f = (parcelRequire("auk2E"));

});
parcelRequire.register("4m0P7", function(module, exports) {

$parcel$export(module.exports, "readUInt32BE", () => $32b9db00bd24d628$export$cfaef8ed399428b0, (v) => $32b9db00bd24d628$export$cfaef8ed399428b0 = v);
$parcel$export(module.exports, "writeUInt32BE", () => $32b9db00bd24d628$export$a80c7deaea7cbd80, (v) => $32b9db00bd24d628$export$a80c7deaea7cbd80 = v);
$parcel$export(module.exports, "ip", () => $32b9db00bd24d628$export$ed7577ae6e1cd0ef, (v) => $32b9db00bd24d628$export$ed7577ae6e1cd0ef = v);
$parcel$export(module.exports, "rip", () => $32b9db00bd24d628$export$5dcbef3aa594f567, (v) => $32b9db00bd24d628$export$5dcbef3aa594f567 = v);
$parcel$export(module.exports, "pc1", () => $32b9db00bd24d628$export$5bc8001ca71ed9c5, (v) => $32b9db00bd24d628$export$5bc8001ca71ed9c5 = v);
$parcel$export(module.exports, "r28shl", () => $32b9db00bd24d628$export$3e714e2c5d5d8cb2, (v) => $32b9db00bd24d628$export$3e714e2c5d5d8cb2 = v);
$parcel$export(module.exports, "pc2", () => $32b9db00bd24d628$export$94c3e544fd062b7f, (v) => $32b9db00bd24d628$export$94c3e544fd062b7f = v);
$parcel$export(module.exports, "expand", () => $32b9db00bd24d628$export$9f77e0932fb78f72, (v) => $32b9db00bd24d628$export$9f77e0932fb78f72 = v);
$parcel$export(module.exports, "substitute", () => $32b9db00bd24d628$export$d865ce2836f5927f, (v) => $32b9db00bd24d628$export$d865ce2836f5927f = v);
$parcel$export(module.exports, "permute", () => $32b9db00bd24d628$export$95e62ad65da8b7d2, (v) => $32b9db00bd24d628$export$95e62ad65da8b7d2 = v);
$parcel$export(module.exports, "padSplit", () => $32b9db00bd24d628$export$209139ff098c441a, (v) => $32b9db00bd24d628$export$209139ff098c441a = v);
var $32b9db00bd24d628$export$cfaef8ed399428b0;
var $32b9db00bd24d628$export$a80c7deaea7cbd80;
var $32b9db00bd24d628$export$ed7577ae6e1cd0ef;
var $32b9db00bd24d628$export$5dcbef3aa594f567;
var $32b9db00bd24d628$export$5bc8001ca71ed9c5;
var $32b9db00bd24d628$export$3e714e2c5d5d8cb2;
var $32b9db00bd24d628$export$94c3e544fd062b7f;
var $32b9db00bd24d628$export$9f77e0932fb78f72;
var $32b9db00bd24d628$export$d865ce2836f5927f;
var $32b9db00bd24d628$export$95e62ad65da8b7d2;
var $32b9db00bd24d628$export$209139ff098c441a;
"use strict";
$32b9db00bd24d628$export$cfaef8ed399428b0 = function readUInt32BE(bytes, off) {
    var res = bytes[0 + off] << 24 | bytes[1 + off] << 16 | bytes[2 + off] << 8 | bytes[3 + off];
    return res >>> 0;
};
$32b9db00bd24d628$export$a80c7deaea7cbd80 = function writeUInt32BE(bytes, value, off) {
    bytes[0 + off] = value >>> 24;
    bytes[1 + off] = value >>> 16 & 0xff;
    bytes[2 + off] = value >>> 8 & 0xff;
    bytes[3 + off] = value & 0xff;
};
$32b9db00bd24d628$export$ed7577ae6e1cd0ef = function ip(inL, inR, out, off) {
    var outL = 0;
    var outR = 0;
    for(var i = 6; i >= 0; i -= 2){
        for(var j = 0; j <= 24; j += 8){
            outL <<= 1;
            outL |= inR >>> j + i & 1;
        }
        for(var j = 0; j <= 24; j += 8){
            outL <<= 1;
            outL |= inL >>> j + i & 1;
        }
    }
    for(var i = 6; i >= 0; i -= 2){
        for(var j = 1; j <= 25; j += 8){
            outR <<= 1;
            outR |= inR >>> j + i & 1;
        }
        for(var j = 1; j <= 25; j += 8){
            outR <<= 1;
            outR |= inL >>> j + i & 1;
        }
    }
    out[off + 0] = outL >>> 0;
    out[off + 1] = outR >>> 0;
};
$32b9db00bd24d628$export$5dcbef3aa594f567 = function rip(inL, inR, out, off) {
    var outL = 0;
    var outR = 0;
    for(var i = 0; i < 4; i++)for(var j = 24; j >= 0; j -= 8){
        outL <<= 1;
        outL |= inR >>> j + i & 1;
        outL <<= 1;
        outL |= inL >>> j + i & 1;
    }
    for(var i = 4; i < 8; i++)for(var j = 24; j >= 0; j -= 8){
        outR <<= 1;
        outR |= inR >>> j + i & 1;
        outR <<= 1;
        outR |= inL >>> j + i & 1;
    }
    out[off + 0] = outL >>> 0;
    out[off + 1] = outR >>> 0;
};
$32b9db00bd24d628$export$5bc8001ca71ed9c5 = function pc1(inL, inR, out, off) {
    var outL = 0;
    var outR = 0;
    // 7, 15, 23, 31, 39, 47, 55, 63
    // 6, 14, 22, 30, 39, 47, 55, 63
    // 5, 13, 21, 29, 39, 47, 55, 63
    // 4, 12, 20, 28
    for(var i = 7; i >= 5; i--){
        for(var j = 0; j <= 24; j += 8){
            outL <<= 1;
            outL |= inR >> j + i & 1;
        }
        for(var j = 0; j <= 24; j += 8){
            outL <<= 1;
            outL |= inL >> j + i & 1;
        }
    }
    for(var j = 0; j <= 24; j += 8){
        outL <<= 1;
        outL |= inR >> j + i & 1;
    }
    // 1, 9, 17, 25, 33, 41, 49, 57
    // 2, 10, 18, 26, 34, 42, 50, 58
    // 3, 11, 19, 27, 35, 43, 51, 59
    // 36, 44, 52, 60
    for(var i = 1; i <= 3; i++){
        for(var j = 0; j <= 24; j += 8){
            outR <<= 1;
            outR |= inR >> j + i & 1;
        }
        for(var j = 0; j <= 24; j += 8){
            outR <<= 1;
            outR |= inL >> j + i & 1;
        }
    }
    for(var j = 0; j <= 24; j += 8){
        outR <<= 1;
        outR |= inL >> j + i & 1;
    }
    out[off + 0] = outL >>> 0;
    out[off + 1] = outR >>> 0;
};
$32b9db00bd24d628$export$3e714e2c5d5d8cb2 = function r28shl(num, shift) {
    return num << shift & 0xfffffff | num >>> 28 - shift;
};
var $32b9db00bd24d628$var$pc2table = [
    // inL => outL
    14,
    11,
    17,
    4,
    27,
    23,
    25,
    0,
    13,
    22,
    7,
    18,
    5,
    9,
    16,
    24,
    2,
    20,
    12,
    21,
    1,
    8,
    15,
    26,
    // inR => outR
    15,
    4,
    25,
    19,
    9,
    1,
    26,
    16,
    5,
    11,
    23,
    8,
    12,
    7,
    17,
    0,
    22,
    3,
    10,
    14,
    6,
    20,
    27,
    24
];
$32b9db00bd24d628$export$94c3e544fd062b7f = function pc2(inL, inR, out, off) {
    var outL = 0;
    var outR = 0;
    var len = $32b9db00bd24d628$var$pc2table.length >>> 1;
    for(var i = 0; i < len; i++){
        outL <<= 1;
        outL |= inL >>> $32b9db00bd24d628$var$pc2table[i] & 0x1;
    }
    for(var i = len; i < $32b9db00bd24d628$var$pc2table.length; i++){
        outR <<= 1;
        outR |= inR >>> $32b9db00bd24d628$var$pc2table[i] & 0x1;
    }
    out[off + 0] = outL >>> 0;
    out[off + 1] = outR >>> 0;
};
$32b9db00bd24d628$export$9f77e0932fb78f72 = function expand(r, out, off) {
    var outL = 0;
    var outR = 0;
    outL = (r & 1) << 5 | r >>> 27;
    for(var i = 23; i >= 15; i -= 4){
        outL <<= 6;
        outL |= r >>> i & 0x3f;
    }
    for(var i = 11; i >= 3; i -= 4){
        outR |= r >>> i & 0x3f;
        outR <<= 6;
    }
    outR |= (r & 0x1f) << 1 | r >>> 31;
    out[off + 0] = outL >>> 0;
    out[off + 1] = outR >>> 0;
};
var $32b9db00bd24d628$var$sTable = [
    14,
    0,
    4,
    15,
    13,
    7,
    1,
    4,
    2,
    14,
    15,
    2,
    11,
    13,
    8,
    1,
    3,
    10,
    10,
    6,
    6,
    12,
    12,
    11,
    5,
    9,
    9,
    5,
    0,
    3,
    7,
    8,
    4,
    15,
    1,
    12,
    14,
    8,
    8,
    2,
    13,
    4,
    6,
    9,
    2,
    1,
    11,
    7,
    15,
    5,
    12,
    11,
    9,
    3,
    7,
    14,
    3,
    10,
    10,
    0,
    5,
    6,
    0,
    13,
    15,
    3,
    1,
    13,
    8,
    4,
    14,
    7,
    6,
    15,
    11,
    2,
    3,
    8,
    4,
    14,
    9,
    12,
    7,
    0,
    2,
    1,
    13,
    10,
    12,
    6,
    0,
    9,
    5,
    11,
    10,
    5,
    0,
    13,
    14,
    8,
    7,
    10,
    11,
    1,
    10,
    3,
    4,
    15,
    13,
    4,
    1,
    2,
    5,
    11,
    8,
    6,
    12,
    7,
    6,
    12,
    9,
    0,
    3,
    5,
    2,
    14,
    15,
    9,
    10,
    13,
    0,
    7,
    9,
    0,
    14,
    9,
    6,
    3,
    3,
    4,
    15,
    6,
    5,
    10,
    1,
    2,
    13,
    8,
    12,
    5,
    7,
    14,
    11,
    12,
    4,
    11,
    2,
    15,
    8,
    1,
    13,
    1,
    6,
    10,
    4,
    13,
    9,
    0,
    8,
    6,
    15,
    9,
    3,
    8,
    0,
    7,
    11,
    4,
    1,
    15,
    2,
    14,
    12,
    3,
    5,
    11,
    10,
    5,
    14,
    2,
    7,
    12,
    7,
    13,
    13,
    8,
    14,
    11,
    3,
    5,
    0,
    6,
    6,
    15,
    9,
    0,
    10,
    3,
    1,
    4,
    2,
    7,
    8,
    2,
    5,
    12,
    11,
    1,
    12,
    10,
    4,
    14,
    15,
    9,
    10,
    3,
    6,
    15,
    9,
    0,
    0,
    6,
    12,
    10,
    11,
    1,
    7,
    13,
    13,
    8,
    15,
    9,
    1,
    4,
    3,
    5,
    14,
    11,
    5,
    12,
    2,
    7,
    8,
    2,
    4,
    14,
    2,
    14,
    12,
    11,
    4,
    2,
    1,
    12,
    7,
    4,
    10,
    7,
    11,
    13,
    6,
    1,
    8,
    5,
    5,
    0,
    3,
    15,
    15,
    10,
    13,
    3,
    0,
    9,
    14,
    8,
    9,
    6,
    4,
    11,
    2,
    8,
    1,
    12,
    11,
    7,
    10,
    1,
    13,
    14,
    7,
    2,
    8,
    13,
    15,
    6,
    9,
    15,
    12,
    0,
    5,
    9,
    6,
    10,
    3,
    4,
    0,
    5,
    14,
    3,
    12,
    10,
    1,
    15,
    10,
    4,
    15,
    2,
    9,
    7,
    2,
    12,
    6,
    9,
    8,
    5,
    0,
    6,
    13,
    1,
    3,
    13,
    4,
    14,
    14,
    0,
    7,
    11,
    5,
    3,
    11,
    8,
    9,
    4,
    14,
    3,
    15,
    2,
    5,
    12,
    2,
    9,
    8,
    5,
    12,
    15,
    3,
    10,
    7,
    11,
    0,
    14,
    4,
    1,
    10,
    7,
    1,
    6,
    13,
    0,
    11,
    8,
    6,
    13,
    4,
    13,
    11,
    0,
    2,
    11,
    14,
    7,
    15,
    4,
    0,
    9,
    8,
    1,
    13,
    10,
    3,
    14,
    12,
    3,
    9,
    5,
    7,
    12,
    5,
    2,
    10,
    15,
    6,
    8,
    1,
    6,
    1,
    6,
    4,
    11,
    11,
    13,
    13,
    8,
    12,
    1,
    3,
    4,
    7,
    10,
    14,
    7,
    10,
    9,
    15,
    5,
    6,
    0,
    8,
    15,
    0,
    14,
    5,
    2,
    9,
    3,
    2,
    12,
    13,
    1,
    2,
    15,
    8,
    13,
    4,
    8,
    6,
    10,
    15,
    3,
    11,
    7,
    1,
    4,
    10,
    12,
    9,
    5,
    3,
    6,
    14,
    11,
    5,
    0,
    0,
    14,
    12,
    9,
    7,
    2,
    7,
    2,
    11,
    1,
    4,
    14,
    1,
    7,
    9,
    4,
    12,
    10,
    14,
    8,
    2,
    13,
    0,
    15,
    6,
    12,
    10,
    9,
    13,
    0,
    15,
    3,
    3,
    5,
    5,
    6,
    8,
    11
];
$32b9db00bd24d628$export$d865ce2836f5927f = function substitute(inL, inR) {
    var out = 0;
    for(var i = 0; i < 4; i++){
        var b = inL >>> 18 - i * 6 & 0x3f;
        var sb = $32b9db00bd24d628$var$sTable[i * 0x40 + b];
        out <<= 4;
        out |= sb;
    }
    for(var i = 0; i < 4; i++){
        var b = inR >>> 18 - i * 6 & 0x3f;
        var sb = $32b9db00bd24d628$var$sTable[256 + i * 0x40 + b];
        out <<= 4;
        out |= sb;
    }
    return out >>> 0;
};
var $32b9db00bd24d628$var$permuteTable = [
    16,
    25,
    12,
    11,
    3,
    20,
    4,
    15,
    31,
    17,
    9,
    6,
    27,
    14,
    1,
    22,
    30,
    24,
    8,
    18,
    0,
    5,
    29,
    23,
    13,
    19,
    2,
    26,
    10,
    21,
    28,
    7
];
$32b9db00bd24d628$export$95e62ad65da8b7d2 = function permute(num) {
    var out = 0;
    for(var i = 0; i < $32b9db00bd24d628$var$permuteTable.length; i++){
        out <<= 1;
        out |= num >>> $32b9db00bd24d628$var$permuteTable[i] & 0x1;
    }
    return out >>> 0;
};
$32b9db00bd24d628$export$209139ff098c441a = function padSplit(num, size, group) {
    var str = num.toString(2);
    while(str.length < size)str = "0" + str;
    var out = [];
    for(var i = 0; i < size; i += group)out.push(str.slice(i, i + group));
    return out.join(" ");
};

});

parcelRequire.register("gqNIC", function(module, exports) {
"use strict";

var $93fa9 = parcelRequire("93fa9");
function $bf65a41f3f81e0d2$var$Cipher(options) {
    this.options = options;
    this.type = this.options.type;
    this.blockSize = 8;
    this._init();
    this.buffer = new Array(this.blockSize);
    this.bufferOff = 0;
    this.padding = options.padding !== false;
}
module.exports = $bf65a41f3f81e0d2$var$Cipher;
$bf65a41f3f81e0d2$var$Cipher.prototype._init = function _init() {
// Might be overrided
};
$bf65a41f3f81e0d2$var$Cipher.prototype.update = function update(data) {
    if (data.length === 0) return [];
    if (this.type === "decrypt") return this._updateDecrypt(data);
    else return this._updateEncrypt(data);
};
$bf65a41f3f81e0d2$var$Cipher.prototype._buffer = function _buffer(data, off) {
    // Append data to buffer
    var min = Math.min(this.buffer.length - this.bufferOff, data.length - off);
    for(var i = 0; i < min; i++)this.buffer[this.bufferOff + i] = data[off + i];
    this.bufferOff += min;
    // Shift next
    return min;
};
$bf65a41f3f81e0d2$var$Cipher.prototype._flushBuffer = function _flushBuffer(out, off) {
    this._update(this.buffer, 0, out, off);
    this.bufferOff = 0;
    return this.blockSize;
};
$bf65a41f3f81e0d2$var$Cipher.prototype._updateEncrypt = function _updateEncrypt(data) {
    var inputOff = 0;
    var outputOff = 0;
    var count = (this.bufferOff + data.length) / this.blockSize | 0;
    var out = new Array(count * this.blockSize);
    if (this.bufferOff !== 0) {
        inputOff += this._buffer(data, inputOff);
        if (this.bufferOff === this.buffer.length) outputOff += this._flushBuffer(out, outputOff);
    }
    // Write blocks
    var max = data.length - (data.length - inputOff) % this.blockSize;
    for(; inputOff < max; inputOff += this.blockSize){
        this._update(data, inputOff, out, outputOff);
        outputOff += this.blockSize;
    }
    // Queue rest
    for(; inputOff < data.length; inputOff++, this.bufferOff++)this.buffer[this.bufferOff] = data[inputOff];
    return out;
};
$bf65a41f3f81e0d2$var$Cipher.prototype._updateDecrypt = function _updateDecrypt(data) {
    var inputOff = 0;
    var outputOff = 0;
    var count = Math.ceil((this.bufferOff + data.length) / this.blockSize) - 1;
    var out = new Array(count * this.blockSize);
    // TODO(indutny): optimize it, this is far from optimal
    for(; count > 0; count--){
        inputOff += this._buffer(data, inputOff);
        outputOff += this._flushBuffer(out, outputOff);
    }
    // Buffer rest of the input
    inputOff += this._buffer(data, inputOff);
    return out;
};
$bf65a41f3f81e0d2$var$Cipher.prototype.final = function final(buffer) {
    var first;
    if (buffer) first = this.update(buffer);
    var last;
    if (this.type === "encrypt") last = this._finalEncrypt();
    else last = this._finalDecrypt();
    if (first) return first.concat(last);
    else return last;
};
$bf65a41f3f81e0d2$var$Cipher.prototype._pad = function _pad(buffer, off) {
    if (off === 0) return false;
    while(off < buffer.length)buffer[off++] = 0;
    return true;
};
$bf65a41f3f81e0d2$var$Cipher.prototype._finalEncrypt = function _finalEncrypt() {
    if (!this._pad(this.buffer, this.bufferOff)) return [];
    var out = new Array(this.blockSize);
    this._update(this.buffer, 0, out, 0);
    return out;
};
$bf65a41f3f81e0d2$var$Cipher.prototype._unpad = function _unpad(buffer) {
    return buffer;
};
$bf65a41f3f81e0d2$var$Cipher.prototype._finalDecrypt = function _finalDecrypt() {
    $93fa9.equal(this.bufferOff, this.blockSize, "Not enough data to decrypt");
    var out = new Array(this.blockSize);
    this._flushBuffer(out, 0);
    return this._unpad(out);
};

});
parcelRequire.register("93fa9", function(module, exports) {
module.exports = $697027e27d2e7a63$var$assert;
function $697027e27d2e7a63$var$assert(val, msg) {
    if (!val) throw new Error(msg || "Assertion failed");
}
$697027e27d2e7a63$var$assert.equal = function assertEqual(l, r, msg) {
    if (l != r) throw new Error(msg || "Assertion failed: " + l + " != " + r);
};

});


parcelRequire.register("8VWKA", function(module, exports) {
"use strict";

var $93fa9 = parcelRequire("93fa9");

var $5SAkX = parcelRequire("5SAkX");

var $4m0P7 = parcelRequire("4m0P7");

var $gqNIC = parcelRequire("gqNIC");
function $68113834341da4f1$var$DESState() {
    this.tmp = new Array(2);
    this.keys = null;
}
function $68113834341da4f1$var$DES(options) {
    $gqNIC.call(this, options);
    var state = new $68113834341da4f1$var$DESState();
    this._desState = state;
    this.deriveKeys(state, options.key);
}
$5SAkX($68113834341da4f1$var$DES, $gqNIC);
module.exports = $68113834341da4f1$var$DES;
$68113834341da4f1$var$DES.create = function create(options) {
    return new $68113834341da4f1$var$DES(options);
};
var $68113834341da4f1$var$shiftTable = [
    1,
    1,
    2,
    2,
    2,
    2,
    2,
    2,
    1,
    2,
    2,
    2,
    2,
    2,
    2,
    1
];
$68113834341da4f1$var$DES.prototype.deriveKeys = function deriveKeys(state, key) {
    state.keys = new Array(32);
    $93fa9.equal(key.length, this.blockSize, "Invalid key length");
    var kL = $4m0P7.readUInt32BE(key, 0);
    var kR = $4m0P7.readUInt32BE(key, 4);
    $4m0P7.pc1(kL, kR, state.tmp, 0);
    kL = state.tmp[0];
    kR = state.tmp[1];
    for(var i = 0; i < state.keys.length; i += 2){
        var shift = $68113834341da4f1$var$shiftTable[i >>> 1];
        kL = $4m0P7.r28shl(kL, shift);
        kR = $4m0P7.r28shl(kR, shift);
        $4m0P7.pc2(kL, kR, state.keys, i);
    }
};
$68113834341da4f1$var$DES.prototype._update = function _update(inp, inOff, out, outOff) {
    var state = this._desState;
    var l = $4m0P7.readUInt32BE(inp, inOff);
    var r = $4m0P7.readUInt32BE(inp, inOff + 4);
    // Initial Permutation
    $4m0P7.ip(l, r, state.tmp, 0);
    l = state.tmp[0];
    r = state.tmp[1];
    if (this.type === "encrypt") this._encrypt(state, l, r, state.tmp, 0);
    else this._decrypt(state, l, r, state.tmp, 0);
    l = state.tmp[0];
    r = state.tmp[1];
    $4m0P7.writeUInt32BE(out, l, outOff);
    $4m0P7.writeUInt32BE(out, r, outOff + 4);
};
$68113834341da4f1$var$DES.prototype._pad = function _pad(buffer, off) {
    if (this.padding === false) return false;
    var value = buffer.length - off;
    for(var i = off; i < buffer.length; i++)buffer[i] = value;
    return true;
};
$68113834341da4f1$var$DES.prototype._unpad = function _unpad(buffer) {
    if (this.padding === false) return buffer;
    var pad = buffer[buffer.length - 1];
    for(var i = buffer.length - pad; i < buffer.length; i++)$93fa9.equal(buffer[i], pad);
    return buffer.slice(0, buffer.length - pad);
};
$68113834341da4f1$var$DES.prototype._encrypt = function _encrypt(state, lStart, rStart, out, off) {
    var l = lStart;
    var r = rStart;
    // Apply f() x16 times
    for(var i = 0; i < state.keys.length; i += 2){
        var keyL = state.keys[i];
        var keyR = state.keys[i + 1];
        // f(r, k)
        $4m0P7.expand(r, state.tmp, 0);
        keyL ^= state.tmp[0];
        keyR ^= state.tmp[1];
        var s = $4m0P7.substitute(keyL, keyR);
        var f = $4m0P7.permute(s);
        var t = r;
        r = (l ^ f) >>> 0;
        l = t;
    }
    // Reverse Initial Permutation
    $4m0P7.rip(r, l, out, off);
};
$68113834341da4f1$var$DES.prototype._decrypt = function _decrypt(state, lStart, rStart, out, off) {
    var l = rStart;
    var r = lStart;
    // Apply f() x16 times
    for(var i = state.keys.length - 2; i >= 0; i -= 2){
        var keyL = state.keys[i];
        var keyR = state.keys[i + 1];
        // f(r, k)
        $4m0P7.expand(l, state.tmp, 0);
        keyL ^= state.tmp[0];
        keyR ^= state.tmp[1];
        var s = $4m0P7.substitute(keyL, keyR);
        var f = $4m0P7.permute(s);
        var t = l;
        l = (r ^ f) >>> 0;
        r = t;
    }
    // Reverse Initial Permutation
    $4m0P7.rip(l, r, out, off);
};

});

parcelRequire.register("6ZgbN", function(module, exports) {

$parcel$export(module.exports, "instantiate", () => $5164ff6b25c3092c$export$f9bb8d20ccc7477a, (v) => $5164ff6b25c3092c$export$f9bb8d20ccc7477a = v);
var $5164ff6b25c3092c$export$f9bb8d20ccc7477a;
"use strict";

var $93fa9 = parcelRequire("93fa9");

var $5SAkX = parcelRequire("5SAkX");
var $5164ff6b25c3092c$var$proto = {};
function $5164ff6b25c3092c$var$CBCState(iv) {
    $93fa9.equal(iv.length, 8, "Invalid IV length");
    this.iv = new Array(8);
    for(var i = 0; i < this.iv.length; i++)this.iv[i] = iv[i];
}
function $5164ff6b25c3092c$var$instantiate(Base) {
    function CBC(options) {
        Base.call(this, options);
        this._cbcInit();
    }
    $5SAkX(CBC, Base);
    var keys = Object.keys($5164ff6b25c3092c$var$proto);
    for(var i = 0; i < keys.length; i++){
        var key = keys[i];
        CBC.prototype[key] = $5164ff6b25c3092c$var$proto[key];
    }
    CBC.create = function create(options) {
        return new CBC(options);
    };
    return CBC;
}
$5164ff6b25c3092c$export$f9bb8d20ccc7477a = $5164ff6b25c3092c$var$instantiate;
$5164ff6b25c3092c$var$proto._cbcInit = function _cbcInit() {
    var state = new $5164ff6b25c3092c$var$CBCState(this.options.iv);
    this._cbcState = state;
};
$5164ff6b25c3092c$var$proto._update = function _update(inp, inOff, out, outOff) {
    var state = this._cbcState;
    var superProto = this.constructor.super_.prototype;
    var iv = state.iv;
    if (this.type === "encrypt") {
        for(var i = 0; i < this.blockSize; i++)iv[i] ^= inp[inOff + i];
        superProto._update.call(this, iv, 0, out, outOff);
        for(var i = 0; i < this.blockSize; i++)iv[i] = out[outOff + i];
    } else {
        superProto._update.call(this, inp, inOff, out, outOff);
        for(var i = 0; i < this.blockSize; i++)out[outOff + i] ^= iv[i];
        for(var i = 0; i < this.blockSize; i++)iv[i] = inp[inOff + i];
    }
};

});

parcelRequire.register("auk2E", function(module, exports) {
"use strict";

var $93fa9 = parcelRequire("93fa9");

var $5SAkX = parcelRequire("5SAkX");

var $gqNIC = parcelRequire("gqNIC");

var $8VWKA = parcelRequire("8VWKA");
function $7a2c40947f69d4f1$var$EDEState(type, key) {
    $93fa9.equal(key.length, 24, "Invalid key length");
    var k1 = key.slice(0, 8);
    var k2 = key.slice(8, 16);
    var k3 = key.slice(16, 24);
    if (type === "encrypt") this.ciphers = [
        $8VWKA.create({
            type: "encrypt",
            key: k1
        }),
        $8VWKA.create({
            type: "decrypt",
            key: k2
        }),
        $8VWKA.create({
            type: "encrypt",
            key: k3
        })
    ];
    else this.ciphers = [
        $8VWKA.create({
            type: "decrypt",
            key: k3
        }),
        $8VWKA.create({
            type: "encrypt",
            key: k2
        }),
        $8VWKA.create({
            type: "decrypt",
            key: k1
        })
    ];
}
function $7a2c40947f69d4f1$var$EDE(options) {
    $gqNIC.call(this, options);
    var state = new $7a2c40947f69d4f1$var$EDEState(this.type, this.options.key);
    this._edeState = state;
}
$5SAkX($7a2c40947f69d4f1$var$EDE, $gqNIC);
module.exports = $7a2c40947f69d4f1$var$EDE;
$7a2c40947f69d4f1$var$EDE.create = function create(options) {
    return new $7a2c40947f69d4f1$var$EDE(options);
};
$7a2c40947f69d4f1$var$EDE.prototype._update = function _update(inp, inOff, out, outOff) {
    var state = this._edeState;
    state.ciphers[0]._update(inp, inOff, out, outOff);
    state.ciphers[1]._update(out, outOff, out, outOff);
    state.ciphers[2]._update(out, outOff, out, outOff);
};
$7a2c40947f69d4f1$var$EDE.prototype._pad = $8VWKA.prototype._pad;
$7a2c40947f69d4f1$var$EDE.prototype._unpad = $8VWKA.prototype._unpad;

});



parcelRequire.register("eSUIi", function(module, exports) {

$parcel$export(module.exports, "createCipheriv", () => $ad6219f53a7ce0ce$export$2f64596b8cbf08b4, (v) => $ad6219f53a7ce0ce$export$2f64596b8cbf08b4 = v);
$parcel$export(module.exports, "createDecipheriv", () => $ad6219f53a7ce0ce$export$36b6d6ef312eab39, (v) => $ad6219f53a7ce0ce$export$36b6d6ef312eab39 = v);
$parcel$export(module.exports, "getCiphers", () => $ad6219f53a7ce0ce$export$58a258485f1e49f6, (v) => $ad6219f53a7ce0ce$export$58a258485f1e49f6 = v);
var $ad6219f53a7ce0ce$export$bdd223f16383713e;
var $ad6219f53a7ce0ce$export$26e5786e8ac8e530;
var $ad6219f53a7ce0ce$export$2f64596b8cbf08b4;
var $ad6219f53a7ce0ce$export$20533d26f07f1ee0;
var $ad6219f53a7ce0ce$export$12ada9414fbc594c;
var $ad6219f53a7ce0ce$export$2ce6d8d0e8b04e1a;
var $ad6219f53a7ce0ce$export$36b6d6ef312eab39;
var $ad6219f53a7ce0ce$export$f5e7e39d57cd9700;
var $ad6219f53a7ce0ce$export$dedd8dc3dc62b370;
var $ad6219f53a7ce0ce$export$58a258485f1e49f6;

var $67eJA = parcelRequire("67eJA");

var $9QcAf = parcelRequire("9QcAf");

var $dAr2z = parcelRequire("dAr2z");
function $ad6219f53a7ce0ce$var$getCiphers() {
    return Object.keys($dAr2z);
}
$ad6219f53a7ce0ce$export$bdd223f16383713e = $ad6219f53a7ce0ce$export$26e5786e8ac8e530 = $67eJA.createCipher;
$ad6219f53a7ce0ce$export$2f64596b8cbf08b4 = $ad6219f53a7ce0ce$export$20533d26f07f1ee0 = $67eJA.createCipheriv;
$ad6219f53a7ce0ce$export$12ada9414fbc594c = $ad6219f53a7ce0ce$export$2ce6d8d0e8b04e1a = $9QcAf.createDecipher;
$ad6219f53a7ce0ce$export$36b6d6ef312eab39 = $ad6219f53a7ce0ce$export$f5e7e39d57cd9700 = $9QcAf.createDecipheriv;
$ad6219f53a7ce0ce$export$dedd8dc3dc62b370 = $ad6219f53a7ce0ce$export$58a258485f1e49f6 = $ad6219f53a7ce0ce$var$getCiphers;

});
parcelRequire.register("67eJA", function(module, exports) {

$parcel$export(module.exports, "createCipheriv", () => $473ed374f8e0430c$export$2f64596b8cbf08b4, (v) => $473ed374f8e0430c$export$2f64596b8cbf08b4 = v);
$parcel$export(module.exports, "createCipher", () => $473ed374f8e0430c$export$bdd223f16383713e, (v) => $473ed374f8e0430c$export$bdd223f16383713e = v);
var $473ed374f8e0430c$export$2f64596b8cbf08b4;
var $473ed374f8e0430c$export$bdd223f16383713e;

var $7S8Y3 = parcelRequire("7S8Y3");

var $2rwRa = parcelRequire("2rwRa");

var $3pA6p = parcelRequire("3pA6p");
var $473ed374f8e0430c$require$Buffer = $3pA6p.Buffer;

var $1yG8n = parcelRequire("1yG8n");

var $gqjfY = parcelRequire("gqjfY");

var $gkeO7 = parcelRequire("gkeO7");

var $ijkRj = parcelRequire("ijkRj");

var $5SAkX = parcelRequire("5SAkX");
function $473ed374f8e0430c$var$Cipher(mode, key, iv) {
    $gqjfY.call(this);
    this._cache = new $473ed374f8e0430c$var$Splitter();
    this._cipher = new $gkeO7.AES(key);
    this._prev = $473ed374f8e0430c$require$Buffer.from(iv);
    this._mode = mode;
    this._autopadding = true;
}
$5SAkX($473ed374f8e0430c$var$Cipher, $gqjfY);
$473ed374f8e0430c$var$Cipher.prototype._update = function(data) {
    this._cache.add(data);
    var chunk;
    var thing;
    var out = [];
    while(chunk = this._cache.get()){
        thing = this._mode.encrypt(this, chunk);
        out.push(thing);
    }
    return $473ed374f8e0430c$require$Buffer.concat(out);
};
var $473ed374f8e0430c$var$PADDING = $473ed374f8e0430c$require$Buffer.alloc(16, 0x10);
$473ed374f8e0430c$var$Cipher.prototype._final = function() {
    var chunk = this._cache.flush();
    if (this._autopadding) {
        chunk = this._mode.encrypt(this, chunk);
        this._cipher.scrub();
        return chunk;
    }
    if (!chunk.equals($473ed374f8e0430c$var$PADDING)) {
        this._cipher.scrub();
        throw new Error("data not multiple of block length");
    }
};
$473ed374f8e0430c$var$Cipher.prototype.setAutoPadding = function(setTo) {
    this._autopadding = !!setTo;
    return this;
};
function $473ed374f8e0430c$var$Splitter() {
    this.cache = $473ed374f8e0430c$require$Buffer.allocUnsafe(0);
}
$473ed374f8e0430c$var$Splitter.prototype.add = function(data) {
    this.cache = $473ed374f8e0430c$require$Buffer.concat([
        this.cache,
        data
    ]);
};
$473ed374f8e0430c$var$Splitter.prototype.get = function() {
    if (this.cache.length > 15) {
        var out = this.cache.slice(0, 16);
        this.cache = this.cache.slice(16);
        return out;
    }
    return null;
};
$473ed374f8e0430c$var$Splitter.prototype.flush = function() {
    var len = 16 - this.cache.length;
    var padBuff = $473ed374f8e0430c$require$Buffer.allocUnsafe(len);
    var i = -1;
    while(++i < len)padBuff.writeUInt8(len, i);
    return $473ed374f8e0430c$require$Buffer.concat([
        this.cache,
        padBuff
    ]);
};
function $473ed374f8e0430c$var$createCipheriv(suite, password, iv) {
    var config = $7S8Y3[suite.toLowerCase()];
    if (!config) throw new TypeError("invalid suite type");
    if (typeof password === "string") password = $473ed374f8e0430c$require$Buffer.from(password);
    if (password.length !== config.key / 8) throw new TypeError("invalid key length " + password.length);
    if (typeof iv === "string") iv = $473ed374f8e0430c$require$Buffer.from(iv);
    if (config.mode !== "GCM" && iv.length !== config.iv) throw new TypeError("invalid iv length " + iv.length);
    if (config.type === "stream") return new $1yG8n(config.module, password, iv);
    else if (config.type === "auth") return new $2rwRa(config.module, password, iv);
    return new $473ed374f8e0430c$var$Cipher(config.module, password, iv);
}
function $473ed374f8e0430c$var$createCipher(suite, password) {
    var config = $7S8Y3[suite.toLowerCase()];
    if (!config) throw new TypeError("invalid suite type");
    var keys = $ijkRj(password, false, config.key, config.iv);
    return $473ed374f8e0430c$var$createCipheriv(suite, keys.key, keys.iv);
}
$473ed374f8e0430c$export$2f64596b8cbf08b4 = $473ed374f8e0430c$var$createCipheriv;
$473ed374f8e0430c$export$bdd223f16383713e = $473ed374f8e0430c$var$createCipher;

});
parcelRequire.register("7S8Y3", function(module, exports) {








var $5bb488512d6b90dc$var$modeModules = {
    ECB: (parcelRequire("a88l3")),
    CBC: (parcelRequire("h4PXC")),
    CFB: (parcelRequire("giGvJ")),
    CFB8: (parcelRequire("b7nby")),
    CFB1: (parcelRequire("2uAXD")),
    OFB: (parcelRequire("8G8Ve")),
    CTR: (parcelRequire("flauE")),
    GCM: (parcelRequire("flauE"))
};

var $dAr2z = parcelRequire("dAr2z");
for(var $5bb488512d6b90dc$var$key in $dAr2z)$dAr2z[$5bb488512d6b90dc$var$key].module = $5bb488512d6b90dc$var$modeModules[$dAr2z[$5bb488512d6b90dc$var$key].mode];
module.exports = $dAr2z;

});
parcelRequire.register("a88l3", function(module, exports) {

$parcel$export(module.exports, "encrypt", () => $76011e98d4273e38$export$5b0f6292f11d1d18, (v) => $76011e98d4273e38$export$5b0f6292f11d1d18 = v);
$parcel$export(module.exports, "decrypt", () => $76011e98d4273e38$export$e85a0c9a1067c5d3, (v) => $76011e98d4273e38$export$e85a0c9a1067c5d3 = v);
var $76011e98d4273e38$export$5b0f6292f11d1d18;
var $76011e98d4273e38$export$e85a0c9a1067c5d3;
$76011e98d4273e38$export$5b0f6292f11d1d18 = function(self, block) {
    return self._cipher.encryptBlock(block);
};
$76011e98d4273e38$export$e85a0c9a1067c5d3 = function(self, block) {
    return self._cipher.decryptBlock(block);
};

});

parcelRequire.register("h4PXC", function(module, exports) {

$parcel$export(module.exports, "encrypt", () => $c6eb1dab50b8baa3$export$5b0f6292f11d1d18, (v) => $c6eb1dab50b8baa3$export$5b0f6292f11d1d18 = v);
$parcel$export(module.exports, "decrypt", () => $c6eb1dab50b8baa3$export$e85a0c9a1067c5d3, (v) => $c6eb1dab50b8baa3$export$e85a0c9a1067c5d3 = v);
var $c6eb1dab50b8baa3$export$5b0f6292f11d1d18;
var $c6eb1dab50b8baa3$export$e85a0c9a1067c5d3;

var $b6GVh = parcelRequire("b6GVh");
$c6eb1dab50b8baa3$export$5b0f6292f11d1d18 = function(self, block) {
    var data = $b6GVh(block, self._prev);
    self._prev = self._cipher.encryptBlock(data);
    return self._prev;
};
$c6eb1dab50b8baa3$export$e85a0c9a1067c5d3 = function(self, block) {
    var pad = self._prev;
    self._prev = block;
    var out = self._cipher.decryptBlock(block);
    return $b6GVh(out, pad);
};

});
parcelRequire.register("b6GVh", function(module, exports) {

var $cBXue = parcelRequire("cBXue");
var $81618cd525de8987$require$Buffer = $cBXue.Buffer;
module.exports = function xor(a, b) {
    var length = Math.min(a.length, b.length);
    var buffer = new $81618cd525de8987$require$Buffer(length);
    for(var i = 0; i < length; ++i)buffer[i] = a[i] ^ b[i];
    return buffer;
};

});


parcelRequire.register("giGvJ", function(module, exports) {

$parcel$export(module.exports, "encrypt", () => $bddf4d90f158f50c$export$5b0f6292f11d1d18, (v) => $bddf4d90f158f50c$export$5b0f6292f11d1d18 = v);
var $bddf4d90f158f50c$export$5b0f6292f11d1d18;

var $3pA6p = parcelRequire("3pA6p");
var $bddf4d90f158f50c$require$Buffer = $3pA6p.Buffer;

var $b6GVh = parcelRequire("b6GVh");
function $bddf4d90f158f50c$var$encryptStart(self, data, decrypt) {
    var len = data.length;
    var out = $b6GVh(data, self._cache);
    self._cache = self._cache.slice(len);
    self._prev = $bddf4d90f158f50c$require$Buffer.concat([
        self._prev,
        decrypt ? data : out
    ]);
    return out;
}
$bddf4d90f158f50c$export$5b0f6292f11d1d18 = function(self, data, decrypt) {
    var out = $bddf4d90f158f50c$require$Buffer.allocUnsafe(0);
    var len;
    while(data.length){
        if (self._cache.length === 0) {
            self._cache = self._cipher.encryptBlock(self._prev);
            self._prev = $bddf4d90f158f50c$require$Buffer.allocUnsafe(0);
        }
        if (self._cache.length <= data.length) {
            len = self._cache.length;
            out = $bddf4d90f158f50c$require$Buffer.concat([
                out,
                $bddf4d90f158f50c$var$encryptStart(self, data.slice(0, len), decrypt)
            ]);
            data = data.slice(len);
        } else {
            out = $bddf4d90f158f50c$require$Buffer.concat([
                out,
                $bddf4d90f158f50c$var$encryptStart(self, data, decrypt)
            ]);
            break;
        }
    }
    return out;
};

});

parcelRequire.register("b7nby", function(module, exports) {

$parcel$export(module.exports, "encrypt", () => $818255433b079308$export$5b0f6292f11d1d18, (v) => $818255433b079308$export$5b0f6292f11d1d18 = v);
var $818255433b079308$export$5b0f6292f11d1d18;

var $3pA6p = parcelRequire("3pA6p");
var $818255433b079308$require$Buffer = $3pA6p.Buffer;
function $818255433b079308$var$encryptByte(self, byteParam, decrypt) {
    var pad = self._cipher.encryptBlock(self._prev);
    var out = pad[0] ^ byteParam;
    self._prev = $818255433b079308$require$Buffer.concat([
        self._prev.slice(1),
        $818255433b079308$require$Buffer.from([
            decrypt ? byteParam : out
        ])
    ]);
    return out;
}
$818255433b079308$export$5b0f6292f11d1d18 = function(self, chunk, decrypt) {
    var len = chunk.length;
    var out = $818255433b079308$require$Buffer.allocUnsafe(len);
    var i = -1;
    while(++i < len)out[i] = $818255433b079308$var$encryptByte(self, chunk[i], decrypt);
    return out;
};

});

parcelRequire.register("2uAXD", function(module, exports) {

$parcel$export(module.exports, "encrypt", () => $1d0b0dcb3effb1ae$export$5b0f6292f11d1d18, (v) => $1d0b0dcb3effb1ae$export$5b0f6292f11d1d18 = v);
var $1d0b0dcb3effb1ae$export$5b0f6292f11d1d18;

var $3pA6p = parcelRequire("3pA6p");
var $1d0b0dcb3effb1ae$require$Buffer = $3pA6p.Buffer;
function $1d0b0dcb3effb1ae$var$encryptByte(self, byteParam, decrypt) {
    var pad;
    var i = -1;
    var len = 8;
    var out = 0;
    var bit, value;
    while(++i < len){
        pad = self._cipher.encryptBlock(self._prev);
        bit = byteParam & 1 << 7 - i ? 0x80 : 0;
        value = pad[0] ^ bit;
        out += (value & 0x80) >> i % 8;
        self._prev = $1d0b0dcb3effb1ae$var$shiftIn(self._prev, decrypt ? bit : value);
    }
    return out;
}
function $1d0b0dcb3effb1ae$var$shiftIn(buffer, value) {
    var len = buffer.length;
    var i = -1;
    var out = $1d0b0dcb3effb1ae$require$Buffer.allocUnsafe(buffer.length);
    buffer = $1d0b0dcb3effb1ae$require$Buffer.concat([
        buffer,
        $1d0b0dcb3effb1ae$require$Buffer.from([
            value
        ])
    ]);
    while(++i < len)out[i] = buffer[i] << 1 | buffer[i + 1] >> 7;
    return out;
}
$1d0b0dcb3effb1ae$export$5b0f6292f11d1d18 = function(self, chunk, decrypt) {
    var len = chunk.length;
    var out = $1d0b0dcb3effb1ae$require$Buffer.allocUnsafe(len);
    var i = -1;
    while(++i < len)out[i] = $1d0b0dcb3effb1ae$var$encryptByte(self, chunk[i], decrypt);
    return out;
};

});

parcelRequire.register("8G8Ve", function(module, exports) {

$parcel$export(module.exports, "encrypt", () => $65192ab35d93250f$export$5b0f6292f11d1d18, (v) => $65192ab35d93250f$export$5b0f6292f11d1d18 = v);
var $65192ab35d93250f$export$5b0f6292f11d1d18;

var $cBXue = parcelRequire("cBXue");
var $65192ab35d93250f$require$Buffer = $cBXue.Buffer;

var $b6GVh = parcelRequire("b6GVh");
function $65192ab35d93250f$var$getBlock(self) {
    self._prev = self._cipher.encryptBlock(self._prev);
    return self._prev;
}
$65192ab35d93250f$export$5b0f6292f11d1d18 = function(self, chunk) {
    while(self._cache.length < chunk.length)self._cache = $65192ab35d93250f$require$Buffer.concat([
        self._cache,
        $65192ab35d93250f$var$getBlock(self)
    ]);
    var pad = self._cache.slice(0, chunk.length);
    self._cache = self._cache.slice(chunk.length);
    return $b6GVh(chunk, pad);
};

});

parcelRequire.register("flauE", function(module, exports) {

$parcel$export(module.exports, "encrypt", () => $b2b0f4eba9e0dd4b$export$5b0f6292f11d1d18, (v) => $b2b0f4eba9e0dd4b$export$5b0f6292f11d1d18 = v);
var $b2b0f4eba9e0dd4b$export$5b0f6292f11d1d18;

var $b6GVh = parcelRequire("b6GVh");

var $3pA6p = parcelRequire("3pA6p");
var $b2b0f4eba9e0dd4b$require$Buffer = $3pA6p.Buffer;

var $5Ar65 = parcelRequire("5Ar65");
function $b2b0f4eba9e0dd4b$var$getBlock(self) {
    var out = self._cipher.encryptBlockRaw(self._prev);
    $5Ar65(self._prev);
    return out;
}
var $b2b0f4eba9e0dd4b$var$blockSize = 16;
$b2b0f4eba9e0dd4b$export$5b0f6292f11d1d18 = function(self, chunk) {
    var chunkNum = Math.ceil(chunk.length / $b2b0f4eba9e0dd4b$var$blockSize);
    var start = self._cache.length;
    self._cache = $b2b0f4eba9e0dd4b$require$Buffer.concat([
        self._cache,
        $b2b0f4eba9e0dd4b$require$Buffer.allocUnsafe(chunkNum * $b2b0f4eba9e0dd4b$var$blockSize)
    ]);
    for(var i = 0; i < chunkNum; i++){
        var out = $b2b0f4eba9e0dd4b$var$getBlock(self);
        var offset = start + i * $b2b0f4eba9e0dd4b$var$blockSize;
        self._cache.writeUInt32BE(out[0], offset + 0);
        self._cache.writeUInt32BE(out[1], offset + 4);
        self._cache.writeUInt32BE(out[2], offset + 8);
        self._cache.writeUInt32BE(out[3], offset + 12);
    }
    var pad = self._cache.slice(0, chunk.length);
    self._cache = self._cache.slice(chunk.length);
    return $b6GVh(chunk, pad);
};

});
parcelRequire.register("5Ar65", function(module, exports) {
function $411555800efe96f3$var$incr32(iv) {
    var len = iv.length;
    var item;
    while(len--){
        item = iv.readUInt8(len);
        if (item === 255) iv.writeUInt8(0, len);
        else {
            item++;
            iv.writeUInt8(item, len);
            break;
        }
    }
}
module.exports = $411555800efe96f3$var$incr32;

});


parcelRequire.register("dAr2z", function(module, exports) {
module.exports = JSON.parse('{"aes-128-ecb":{"cipher":"AES","key":128,"iv":0,"mode":"ECB","type":"block"},"aes-192-ecb":{"cipher":"AES","key":192,"iv":0,"mode":"ECB","type":"block"},"aes-256-ecb":{"cipher":"AES","key":256,"iv":0,"mode":"ECB","type":"block"},"aes-128-cbc":{"cipher":"AES","key":128,"iv":16,"mode":"CBC","type":"block"},"aes-192-cbc":{"cipher":"AES","key":192,"iv":16,"mode":"CBC","type":"block"},"aes-256-cbc":{"cipher":"AES","key":256,"iv":16,"mode":"CBC","type":"block"},"aes128":{"cipher":"AES","key":128,"iv":16,"mode":"CBC","type":"block"},"aes192":{"cipher":"AES","key":192,"iv":16,"mode":"CBC","type":"block"},"aes256":{"cipher":"AES","key":256,"iv":16,"mode":"CBC","type":"block"},"aes-128-cfb":{"cipher":"AES","key":128,"iv":16,"mode":"CFB","type":"stream"},"aes-192-cfb":{"cipher":"AES","key":192,"iv":16,"mode":"CFB","type":"stream"},"aes-256-cfb":{"cipher":"AES","key":256,"iv":16,"mode":"CFB","type":"stream"},"aes-128-cfb8":{"cipher":"AES","key":128,"iv":16,"mode":"CFB8","type":"stream"},"aes-192-cfb8":{"cipher":"AES","key":192,"iv":16,"mode":"CFB8","type":"stream"},"aes-256-cfb8":{"cipher":"AES","key":256,"iv":16,"mode":"CFB8","type":"stream"},"aes-128-cfb1":{"cipher":"AES","key":128,"iv":16,"mode":"CFB1","type":"stream"},"aes-192-cfb1":{"cipher":"AES","key":192,"iv":16,"mode":"CFB1","type":"stream"},"aes-256-cfb1":{"cipher":"AES","key":256,"iv":16,"mode":"CFB1","type":"stream"},"aes-128-ofb":{"cipher":"AES","key":128,"iv":16,"mode":"OFB","type":"stream"},"aes-192-ofb":{"cipher":"AES","key":192,"iv":16,"mode":"OFB","type":"stream"},"aes-256-ofb":{"cipher":"AES","key":256,"iv":16,"mode":"OFB","type":"stream"},"aes-128-ctr":{"cipher":"AES","key":128,"iv":16,"mode":"CTR","type":"stream"},"aes-192-ctr":{"cipher":"AES","key":192,"iv":16,"mode":"CTR","type":"stream"},"aes-256-ctr":{"cipher":"AES","key":256,"iv":16,"mode":"CTR","type":"stream"},"aes-128-gcm":{"cipher":"AES","key":128,"iv":12,"mode":"GCM","type":"auth"},"aes-192-gcm":{"cipher":"AES","key":192,"iv":12,"mode":"GCM","type":"auth"},"aes-256-gcm":{"cipher":"AES","key":256,"iv":12,"mode":"GCM","type":"auth"}}');

});


parcelRequire.register("2rwRa", function(module, exports) {

var $gkeO7 = parcelRequire("gkeO7");

var $3pA6p = parcelRequire("3pA6p");
var $1c7796ff9ae1e9af$require$Buffer = $3pA6p.Buffer;

var $gqjfY = parcelRequire("gqjfY");

var $5SAkX = parcelRequire("5SAkX");

var $b8xc1 = parcelRequire("b8xc1");

var $b6GVh = parcelRequire("b6GVh");

var $5Ar65 = parcelRequire("5Ar65");
function $1c7796ff9ae1e9af$var$xorTest(a, b) {
    var out = 0;
    if (a.length !== b.length) out++;
    var len = Math.min(a.length, b.length);
    for(var i = 0; i < len; ++i)out += a[i] ^ b[i];
    return out;
}
function $1c7796ff9ae1e9af$var$calcIv(self, iv, ck) {
    if (iv.length === 12) {
        self._finID = $1c7796ff9ae1e9af$require$Buffer.concat([
            iv,
            $1c7796ff9ae1e9af$require$Buffer.from([
                0,
                0,
                0,
                1
            ])
        ]);
        return $1c7796ff9ae1e9af$require$Buffer.concat([
            iv,
            $1c7796ff9ae1e9af$require$Buffer.from([
                0,
                0,
                0,
                2
            ])
        ]);
    }
    var ghash = new $b8xc1(ck);
    var len = iv.length;
    var toPad = len % 16;
    ghash.update(iv);
    if (toPad) {
        toPad = 16 - toPad;
        ghash.update($1c7796ff9ae1e9af$require$Buffer.alloc(toPad, 0));
    }
    ghash.update($1c7796ff9ae1e9af$require$Buffer.alloc(8, 0));
    var ivBits = len * 8;
    var tail = $1c7796ff9ae1e9af$require$Buffer.alloc(8);
    tail.writeUIntBE(ivBits, 0, 8);
    ghash.update(tail);
    self._finID = ghash.state;
    var out = $1c7796ff9ae1e9af$require$Buffer.from(self._finID);
    $5Ar65(out);
    return out;
}
function $1c7796ff9ae1e9af$var$StreamCipher(mode, key, iv, decrypt) {
    $gqjfY.call(this);
    var h = $1c7796ff9ae1e9af$require$Buffer.alloc(4, 0);
    this._cipher = new $gkeO7.AES(key);
    var ck = this._cipher.encryptBlock(h);
    this._ghash = new $b8xc1(ck);
    iv = $1c7796ff9ae1e9af$var$calcIv(this, iv, ck);
    this._prev = $1c7796ff9ae1e9af$require$Buffer.from(iv);
    this._cache = $1c7796ff9ae1e9af$require$Buffer.allocUnsafe(0);
    this._secCache = $1c7796ff9ae1e9af$require$Buffer.allocUnsafe(0);
    this._decrypt = decrypt;
    this._alen = 0;
    this._len = 0;
    this._mode = mode;
    this._authTag = null;
    this._called = false;
}
$5SAkX($1c7796ff9ae1e9af$var$StreamCipher, $gqjfY);
$1c7796ff9ae1e9af$var$StreamCipher.prototype._update = function(chunk) {
    if (!this._called && this._alen) {
        var rump = 16 - this._alen % 16;
        if (rump < 16) {
            rump = $1c7796ff9ae1e9af$require$Buffer.alloc(rump, 0);
            this._ghash.update(rump);
        }
    }
    this._called = true;
    var out = this._mode.encrypt(this, chunk);
    if (this._decrypt) this._ghash.update(chunk);
    else this._ghash.update(out);
    this._len += chunk.length;
    return out;
};
$1c7796ff9ae1e9af$var$StreamCipher.prototype._final = function() {
    if (this._decrypt && !this._authTag) throw new Error("Unsupported state or unable to authenticate data");
    var tag = $b6GVh(this._ghash.final(this._alen * 8, this._len * 8), this._cipher.encryptBlock(this._finID));
    if (this._decrypt && $1c7796ff9ae1e9af$var$xorTest(tag, this._authTag)) throw new Error("Unsupported state or unable to authenticate data");
    this._authTag = tag;
    this._cipher.scrub();
};
$1c7796ff9ae1e9af$var$StreamCipher.prototype.getAuthTag = function getAuthTag() {
    if (this._decrypt || !$1c7796ff9ae1e9af$require$Buffer.isBuffer(this._authTag)) throw new Error("Attempting to get auth tag in unsupported state");
    return this._authTag;
};
$1c7796ff9ae1e9af$var$StreamCipher.prototype.setAuthTag = function setAuthTag(tag) {
    if (!this._decrypt) throw new Error("Attempting to set auth tag in unsupported state");
    this._authTag = tag;
};
$1c7796ff9ae1e9af$var$StreamCipher.prototype.setAAD = function setAAD(buf) {
    if (this._called) throw new Error("Attempting to set AAD in unsupported state");
    this._ghash.update(buf);
    this._alen += buf.length;
};
module.exports = $1c7796ff9ae1e9af$var$StreamCipher;

});
parcelRequire.register("gkeO7", function(module, exports) {

$parcel$export(module.exports, "AES", () => $be2a00033db56e11$export$b80fbe1c3a2b92b5, (v) => $be2a00033db56e11$export$b80fbe1c3a2b92b5 = v);
// based on the aes implimentation in triple sec
// https://github.com/keybase/triplesec
// which is in turn based on the one from crypto-js
// https://code.google.com/p/crypto-js/
var $be2a00033db56e11$export$b80fbe1c3a2b92b5;

var $3pA6p = parcelRequire("3pA6p");
var $be2a00033db56e11$require$Buffer = $3pA6p.Buffer;
function $be2a00033db56e11$var$asUInt32Array(buf) {
    if (!$be2a00033db56e11$require$Buffer.isBuffer(buf)) buf = $be2a00033db56e11$require$Buffer.from(buf);
    var len = buf.length / 4 | 0;
    var out = new Array(len);
    for(var i = 0; i < len; i++)out[i] = buf.readUInt32BE(i * 4);
    return out;
}
function $be2a00033db56e11$var$scrubVec(v) {
    for(var i = 0; i < v.length; v++)v[i] = 0;
}
function $be2a00033db56e11$var$cryptBlock(M, keySchedule, SUB_MIX, SBOX, nRounds) {
    var SUB_MIX0 = SUB_MIX[0];
    var SUB_MIX1 = SUB_MIX[1];
    var SUB_MIX2 = SUB_MIX[2];
    var SUB_MIX3 = SUB_MIX[3];
    var s0 = M[0] ^ keySchedule[0];
    var s1 = M[1] ^ keySchedule[1];
    var s2 = M[2] ^ keySchedule[2];
    var s3 = M[3] ^ keySchedule[3];
    var t0, t1, t2, t3;
    var ksRow = 4;
    for(var round = 1; round < nRounds; round++){
        t0 = SUB_MIX0[s0 >>> 24] ^ SUB_MIX1[s1 >>> 16 & 0xff] ^ SUB_MIX2[s2 >>> 8 & 0xff] ^ SUB_MIX3[s3 & 0xff] ^ keySchedule[ksRow++];
        t1 = SUB_MIX0[s1 >>> 24] ^ SUB_MIX1[s2 >>> 16 & 0xff] ^ SUB_MIX2[s3 >>> 8 & 0xff] ^ SUB_MIX3[s0 & 0xff] ^ keySchedule[ksRow++];
        t2 = SUB_MIX0[s2 >>> 24] ^ SUB_MIX1[s3 >>> 16 & 0xff] ^ SUB_MIX2[s0 >>> 8 & 0xff] ^ SUB_MIX3[s1 & 0xff] ^ keySchedule[ksRow++];
        t3 = SUB_MIX0[s3 >>> 24] ^ SUB_MIX1[s0 >>> 16 & 0xff] ^ SUB_MIX2[s1 >>> 8 & 0xff] ^ SUB_MIX3[s2 & 0xff] ^ keySchedule[ksRow++];
        s0 = t0;
        s1 = t1;
        s2 = t2;
        s3 = t3;
    }
    t0 = (SBOX[s0 >>> 24] << 24 | SBOX[s1 >>> 16 & 0xff] << 16 | SBOX[s2 >>> 8 & 0xff] << 8 | SBOX[s3 & 0xff]) ^ keySchedule[ksRow++];
    t1 = (SBOX[s1 >>> 24] << 24 | SBOX[s2 >>> 16 & 0xff] << 16 | SBOX[s3 >>> 8 & 0xff] << 8 | SBOX[s0 & 0xff]) ^ keySchedule[ksRow++];
    t2 = (SBOX[s2 >>> 24] << 24 | SBOX[s3 >>> 16 & 0xff] << 16 | SBOX[s0 >>> 8 & 0xff] << 8 | SBOX[s1 & 0xff]) ^ keySchedule[ksRow++];
    t3 = (SBOX[s3 >>> 24] << 24 | SBOX[s0 >>> 16 & 0xff] << 16 | SBOX[s1 >>> 8 & 0xff] << 8 | SBOX[s2 & 0xff]) ^ keySchedule[ksRow++];
    t0 = t0 >>> 0;
    t1 = t1 >>> 0;
    t2 = t2 >>> 0;
    t3 = t3 >>> 0;
    return [
        t0,
        t1,
        t2,
        t3
    ];
}
// AES constants
var $be2a00033db56e11$var$RCON = [
    0x00,
    0x01,
    0x02,
    0x04,
    0x08,
    0x10,
    0x20,
    0x40,
    0x80,
    0x1b,
    0x36
];
var $be2a00033db56e11$var$G = function() {
    // Compute double table
    var d = new Array(256);
    for(var j = 0; j < 256; j++)if (j < 128) d[j] = j << 1;
    else d[j] = j << 1 ^ 0x11b;
    var SBOX = [];
    var INV_SBOX = [];
    var SUB_MIX = [
        [],
        [],
        [],
        []
    ];
    var INV_SUB_MIX = [
        [],
        [],
        [],
        []
    ];
    // Walk GF(2^8)
    var x = 0;
    var xi = 0;
    for(var i = 0; i < 256; ++i){
        // Compute sbox
        var sx = xi ^ xi << 1 ^ xi << 2 ^ xi << 3 ^ xi << 4;
        sx = sx >>> 8 ^ sx & 0xff ^ 0x63;
        SBOX[x] = sx;
        INV_SBOX[sx] = x;
        // Compute multiplication
        var x2 = d[x];
        var x4 = d[x2];
        var x8 = d[x4];
        // Compute sub bytes, mix columns tables
        var t = d[sx] * 0x101 ^ sx * 0x1010100;
        SUB_MIX[0][x] = t << 24 | t >>> 8;
        SUB_MIX[1][x] = t << 16 | t >>> 16;
        SUB_MIX[2][x] = t << 8 | t >>> 24;
        SUB_MIX[3][x] = t;
        // Compute inv sub bytes, inv mix columns tables
        t = x8 * 0x1010101 ^ x4 * 0x10001 ^ x2 * 0x101 ^ x * 0x1010100;
        INV_SUB_MIX[0][sx] = t << 24 | t >>> 8;
        INV_SUB_MIX[1][sx] = t << 16 | t >>> 16;
        INV_SUB_MIX[2][sx] = t << 8 | t >>> 24;
        INV_SUB_MIX[3][sx] = t;
        if (x === 0) x = xi = 1;
        else {
            x = x2 ^ d[d[d[x8 ^ x2]]];
            xi ^= d[d[xi]];
        }
    }
    return {
        SBOX: SBOX,
        INV_SBOX: INV_SBOX,
        SUB_MIX: SUB_MIX,
        INV_SUB_MIX: INV_SUB_MIX
    };
}();
function $be2a00033db56e11$var$AES(key) {
    this._key = $be2a00033db56e11$var$asUInt32Array(key);
    this._reset();
}
$be2a00033db56e11$var$AES.blockSize = 16;
$be2a00033db56e11$var$AES.keySize = 32;
$be2a00033db56e11$var$AES.prototype.blockSize = $be2a00033db56e11$var$AES.blockSize;
$be2a00033db56e11$var$AES.prototype.keySize = $be2a00033db56e11$var$AES.keySize;
$be2a00033db56e11$var$AES.prototype._reset = function() {
    var keyWords = this._key;
    var keySize = keyWords.length;
    var nRounds = keySize + 6;
    var ksRows = (nRounds + 1) * 4;
    var keySchedule = [];
    for(var k = 0; k < keySize; k++)keySchedule[k] = keyWords[k];
    for(k = keySize; k < ksRows; k++){
        var t = keySchedule[k - 1];
        if (k % keySize === 0) {
            t = t << 8 | t >>> 24;
            t = $be2a00033db56e11$var$G.SBOX[t >>> 24] << 24 | $be2a00033db56e11$var$G.SBOX[t >>> 16 & 0xff] << 16 | $be2a00033db56e11$var$G.SBOX[t >>> 8 & 0xff] << 8 | $be2a00033db56e11$var$G.SBOX[t & 0xff];
            t ^= $be2a00033db56e11$var$RCON[k / keySize | 0] << 24;
        } else if (keySize > 6 && k % keySize === 4) t = $be2a00033db56e11$var$G.SBOX[t >>> 24] << 24 | $be2a00033db56e11$var$G.SBOX[t >>> 16 & 0xff] << 16 | $be2a00033db56e11$var$G.SBOX[t >>> 8 & 0xff] << 8 | $be2a00033db56e11$var$G.SBOX[t & 0xff];
        keySchedule[k] = keySchedule[k - keySize] ^ t;
    }
    var invKeySchedule = [];
    for(var ik = 0; ik < ksRows; ik++){
        var ksR = ksRows - ik;
        var tt = keySchedule[ksR - (ik % 4 ? 0 : 4)];
        if (ik < 4 || ksR <= 4) invKeySchedule[ik] = tt;
        else invKeySchedule[ik] = $be2a00033db56e11$var$G.INV_SUB_MIX[0][$be2a00033db56e11$var$G.SBOX[tt >>> 24]] ^ $be2a00033db56e11$var$G.INV_SUB_MIX[1][$be2a00033db56e11$var$G.SBOX[tt >>> 16 & 0xff]] ^ $be2a00033db56e11$var$G.INV_SUB_MIX[2][$be2a00033db56e11$var$G.SBOX[tt >>> 8 & 0xff]] ^ $be2a00033db56e11$var$G.INV_SUB_MIX[3][$be2a00033db56e11$var$G.SBOX[tt & 0xff]];
    }
    this._nRounds = nRounds;
    this._keySchedule = keySchedule;
    this._invKeySchedule = invKeySchedule;
};
$be2a00033db56e11$var$AES.prototype.encryptBlockRaw = function(M) {
    M = $be2a00033db56e11$var$asUInt32Array(M);
    return $be2a00033db56e11$var$cryptBlock(M, this._keySchedule, $be2a00033db56e11$var$G.SUB_MIX, $be2a00033db56e11$var$G.SBOX, this._nRounds);
};
$be2a00033db56e11$var$AES.prototype.encryptBlock = function(M) {
    var out = this.encryptBlockRaw(M);
    var buf = $be2a00033db56e11$require$Buffer.allocUnsafe(16);
    buf.writeUInt32BE(out[0], 0);
    buf.writeUInt32BE(out[1], 4);
    buf.writeUInt32BE(out[2], 8);
    buf.writeUInt32BE(out[3], 12);
    return buf;
};
$be2a00033db56e11$var$AES.prototype.decryptBlock = function(M) {
    M = $be2a00033db56e11$var$asUInt32Array(M);
    // swap
    var m1 = M[1];
    M[1] = M[3];
    M[3] = m1;
    var out = $be2a00033db56e11$var$cryptBlock(M, this._invKeySchedule, $be2a00033db56e11$var$G.INV_SUB_MIX, $be2a00033db56e11$var$G.INV_SBOX, this._nRounds);
    var buf = $be2a00033db56e11$require$Buffer.allocUnsafe(16);
    buf.writeUInt32BE(out[0], 0);
    buf.writeUInt32BE(out[3], 4);
    buf.writeUInt32BE(out[2], 8);
    buf.writeUInt32BE(out[1], 12);
    return buf;
};
$be2a00033db56e11$var$AES.prototype.scrub = function() {
    $be2a00033db56e11$var$scrubVec(this._keySchedule);
    $be2a00033db56e11$var$scrubVec(this._invKeySchedule);
    $be2a00033db56e11$var$scrubVec(this._key);
};
$be2a00033db56e11$export$b80fbe1c3a2b92b5 = $be2a00033db56e11$var$AES;

});

parcelRequire.register("b8xc1", function(module, exports) {

var $3pA6p = parcelRequire("3pA6p");
var $81ba30823a60fc74$require$Buffer = $3pA6p.Buffer;
var $81ba30823a60fc74$var$ZEROES = $81ba30823a60fc74$require$Buffer.alloc(16, 0);
function $81ba30823a60fc74$var$toArray(buf) {
    return [
        buf.readUInt32BE(0),
        buf.readUInt32BE(4),
        buf.readUInt32BE(8),
        buf.readUInt32BE(12)
    ];
}
function $81ba30823a60fc74$var$fromArray(out) {
    var buf = $81ba30823a60fc74$require$Buffer.allocUnsafe(16);
    buf.writeUInt32BE(out[0] >>> 0, 0);
    buf.writeUInt32BE(out[1] >>> 0, 4);
    buf.writeUInt32BE(out[2] >>> 0, 8);
    buf.writeUInt32BE(out[3] >>> 0, 12);
    return buf;
}
function $81ba30823a60fc74$var$GHASH(key) {
    this.h = key;
    this.state = $81ba30823a60fc74$require$Buffer.alloc(16, 0);
    this.cache = $81ba30823a60fc74$require$Buffer.allocUnsafe(0);
}
// from http://bitwiseshiftleft.github.io/sjcl/doc/symbols/src/core_gcm.js.html
// by Juho Vähä-Herttua
$81ba30823a60fc74$var$GHASH.prototype.ghash = function(block) {
    var i = -1;
    while(++i < block.length)this.state[i] ^= block[i];
    this._multiply();
};
$81ba30823a60fc74$var$GHASH.prototype._multiply = function() {
    var Vi = $81ba30823a60fc74$var$toArray(this.h);
    var Zi = [
        0,
        0,
        0,
        0
    ];
    var j, xi, lsbVi;
    var i = -1;
    while(++i < 128){
        xi = (this.state[~~(i / 8)] & 1 << 7 - i % 8) !== 0;
        if (xi) {
            // Z_i+1 = Z_i ^ V_i
            Zi[0] ^= Vi[0];
            Zi[1] ^= Vi[1];
            Zi[2] ^= Vi[2];
            Zi[3] ^= Vi[3];
        }
        // Store the value of LSB(V_i)
        lsbVi = (Vi[3] & 1) !== 0;
        // V_i+1 = V_i >> 1
        for(j = 3; j > 0; j--)Vi[j] = Vi[j] >>> 1 | (Vi[j - 1] & 1) << 31;
        Vi[0] = Vi[0] >>> 1;
        // If LSB(V_i) is 1, V_i+1 = (V_i >> 1) ^ R
        if (lsbVi) Vi[0] = Vi[0] ^ -520093696;
    }
    this.state = $81ba30823a60fc74$var$fromArray(Zi);
};
$81ba30823a60fc74$var$GHASH.prototype.update = function(buf) {
    this.cache = $81ba30823a60fc74$require$Buffer.concat([
        this.cache,
        buf
    ]);
    var chunk;
    while(this.cache.length >= 16){
        chunk = this.cache.slice(0, 16);
        this.cache = this.cache.slice(16);
        this.ghash(chunk);
    }
};
$81ba30823a60fc74$var$GHASH.prototype.final = function(abl, bl) {
    if (this.cache.length) this.ghash($81ba30823a60fc74$require$Buffer.concat([
        this.cache,
        $81ba30823a60fc74$var$ZEROES
    ], 16));
    this.ghash($81ba30823a60fc74$var$fromArray([
        0,
        abl,
        0,
        bl
    ]));
    return this.state;
};
module.exports = $81ba30823a60fc74$var$GHASH;

});


parcelRequire.register("1yG8n", function(module, exports) {

var $gkeO7 = parcelRequire("gkeO7");

var $3pA6p = parcelRequire("3pA6p");
var $1229a65f83551293$require$Buffer = $3pA6p.Buffer;

var $gqjfY = parcelRequire("gqjfY");

var $5SAkX = parcelRequire("5SAkX");
function $1229a65f83551293$var$StreamCipher(mode, key, iv, decrypt) {
    $gqjfY.call(this);
    this._cipher = new $gkeO7.AES(key);
    this._prev = $1229a65f83551293$require$Buffer.from(iv);
    this._cache = $1229a65f83551293$require$Buffer.allocUnsafe(0);
    this._secCache = $1229a65f83551293$require$Buffer.allocUnsafe(0);
    this._decrypt = decrypt;
    this._mode = mode;
}
$5SAkX($1229a65f83551293$var$StreamCipher, $gqjfY);
$1229a65f83551293$var$StreamCipher.prototype._update = function(chunk) {
    return this._mode.encrypt(this, chunk, this._decrypt);
};
$1229a65f83551293$var$StreamCipher.prototype._final = function() {
    this._cipher.scrub();
};
module.exports = $1229a65f83551293$var$StreamCipher;

});

parcelRequire.register("ijkRj", function(module, exports) {

var $3pA6p = parcelRequire("3pA6p");
var $d54a2e7d365745e5$require$Buffer = $3pA6p.Buffer;

var $lQqEc = parcelRequire("lQqEc");
/* eslint-disable camelcase */ function $d54a2e7d365745e5$var$EVP_BytesToKey(password, salt, keyBits, ivLen) {
    if (!$d54a2e7d365745e5$require$Buffer.isBuffer(password)) password = $d54a2e7d365745e5$require$Buffer.from(password, "binary");
    if (salt) {
        if (!$d54a2e7d365745e5$require$Buffer.isBuffer(salt)) salt = $d54a2e7d365745e5$require$Buffer.from(salt, "binary");
        if (salt.length !== 8) throw new RangeError("salt should be Buffer with 8 byte length");
    }
    var keyLen = keyBits / 8;
    var key = $d54a2e7d365745e5$require$Buffer.alloc(keyLen);
    var iv = $d54a2e7d365745e5$require$Buffer.alloc(ivLen || 0);
    var tmp = $d54a2e7d365745e5$require$Buffer.alloc(0);
    while(keyLen > 0 || ivLen > 0){
        var hash = new $lQqEc();
        hash.update(tmp);
        hash.update(password);
        if (salt) hash.update(salt);
        tmp = hash.digest();
        var used = 0;
        if (keyLen > 0) {
            var keyStart = key.length - keyLen;
            used = Math.min(keyLen, tmp.length);
            tmp.copy(key, keyStart, 0, used);
            keyLen -= used;
        }
        if (used < tmp.length && ivLen > 0) {
            var ivStart = iv.length - ivLen;
            var length = Math.min(ivLen, tmp.length - used);
            tmp.copy(iv, ivStart, used, used + length);
            ivLen -= length;
        }
    }
    tmp.fill(0);
    return {
        key: key,
        iv: iv
    };
}
module.exports = $d54a2e7d365745e5$var$EVP_BytesToKey;

});


parcelRequire.register("9QcAf", function(module, exports) {

$parcel$export(module.exports, "createDecipher", () => $72a2bb38a84d1a62$export$12ada9414fbc594c, (v) => $72a2bb38a84d1a62$export$12ada9414fbc594c = v);
$parcel$export(module.exports, "createDecipheriv", () => $72a2bb38a84d1a62$export$36b6d6ef312eab39, (v) => $72a2bb38a84d1a62$export$36b6d6ef312eab39 = v);
var $72a2bb38a84d1a62$export$12ada9414fbc594c;
var $72a2bb38a84d1a62$export$36b6d6ef312eab39;

var $2rwRa = parcelRequire("2rwRa");

var $3pA6p = parcelRequire("3pA6p");
var $72a2bb38a84d1a62$require$Buffer = $3pA6p.Buffer;

var $7S8Y3 = parcelRequire("7S8Y3");

var $1yG8n = parcelRequire("1yG8n");

var $gqjfY = parcelRequire("gqjfY");

var $gkeO7 = parcelRequire("gkeO7");

var $ijkRj = parcelRequire("ijkRj");

var $5SAkX = parcelRequire("5SAkX");
function $72a2bb38a84d1a62$var$Decipher(mode, key, iv) {
    $gqjfY.call(this);
    this._cache = new $72a2bb38a84d1a62$var$Splitter();
    this._last = void 0;
    this._cipher = new $gkeO7.AES(key);
    this._prev = $72a2bb38a84d1a62$require$Buffer.from(iv);
    this._mode = mode;
    this._autopadding = true;
}
$5SAkX($72a2bb38a84d1a62$var$Decipher, $gqjfY);
$72a2bb38a84d1a62$var$Decipher.prototype._update = function(data) {
    this._cache.add(data);
    var chunk;
    var thing;
    var out = [];
    while(chunk = this._cache.get(this._autopadding)){
        thing = this._mode.decrypt(this, chunk);
        out.push(thing);
    }
    return $72a2bb38a84d1a62$require$Buffer.concat(out);
};
$72a2bb38a84d1a62$var$Decipher.prototype._final = function() {
    var chunk = this._cache.flush();
    if (this._autopadding) return $72a2bb38a84d1a62$var$unpad(this._mode.decrypt(this, chunk));
    else if (chunk) throw new Error("data not multiple of block length");
};
$72a2bb38a84d1a62$var$Decipher.prototype.setAutoPadding = function(setTo) {
    this._autopadding = !!setTo;
    return this;
};
function $72a2bb38a84d1a62$var$Splitter() {
    this.cache = $72a2bb38a84d1a62$require$Buffer.allocUnsafe(0);
}
$72a2bb38a84d1a62$var$Splitter.prototype.add = function(data) {
    this.cache = $72a2bb38a84d1a62$require$Buffer.concat([
        this.cache,
        data
    ]);
};
$72a2bb38a84d1a62$var$Splitter.prototype.get = function(autoPadding) {
    var out;
    if (autoPadding) {
        if (this.cache.length > 16) {
            out = this.cache.slice(0, 16);
            this.cache = this.cache.slice(16);
            return out;
        }
    } else if (this.cache.length >= 16) {
        out = this.cache.slice(0, 16);
        this.cache = this.cache.slice(16);
        return out;
    }
    return null;
};
$72a2bb38a84d1a62$var$Splitter.prototype.flush = function() {
    if (this.cache.length) return this.cache;
};
function $72a2bb38a84d1a62$var$unpad(last) {
    var padded = last[15];
    if (padded < 1 || padded > 16) throw new Error("unable to decrypt data");
    var i = -1;
    while(++i < padded){
        if (last[i + (16 - padded)] !== padded) throw new Error("unable to decrypt data");
    }
    if (padded === 16) return;
    return last.slice(0, 16 - padded);
}
function $72a2bb38a84d1a62$var$createDecipheriv(suite, password, iv) {
    var config = $7S8Y3[suite.toLowerCase()];
    if (!config) throw new TypeError("invalid suite type");
    if (typeof iv === "string") iv = $72a2bb38a84d1a62$require$Buffer.from(iv);
    if (config.mode !== "GCM" && iv.length !== config.iv) throw new TypeError("invalid iv length " + iv.length);
    if (typeof password === "string") password = $72a2bb38a84d1a62$require$Buffer.from(password);
    if (password.length !== config.key / 8) throw new TypeError("invalid key length " + password.length);
    if (config.type === "stream") return new $1yG8n(config.module, password, iv, true);
    else if (config.type === "auth") return new $2rwRa(config.module, password, iv, true);
    return new $72a2bb38a84d1a62$var$Decipher(config.module, password, iv);
}
function $72a2bb38a84d1a62$var$createDecipher(suite, password) {
    var config = $7S8Y3[suite.toLowerCase()];
    if (!config) throw new TypeError("invalid suite type");
    var keys = $ijkRj(password, false, config.key, config.iv);
    return $72a2bb38a84d1a62$var$createDecipheriv(suite, keys.key, keys.iv);
}
$72a2bb38a84d1a62$export$12ada9414fbc594c = $72a2bb38a84d1a62$var$createDecipher;
$72a2bb38a84d1a62$export$36b6d6ef312eab39 = $72a2bb38a84d1a62$var$createDecipheriv;

});


parcelRequire.register("l5SK0", function(module, exports) {

$parcel$export(module.exports, "des-ecb", () => $f5b4870c03dc7ab6$export$116f8a5cee447347, (v) => $f5b4870c03dc7ab6$export$116f8a5cee447347 = v);
$parcel$export(module.exports, "des-cbc", () => $f5b4870c03dc7ab6$export$7483c4066bfb7ae9, (v) => $f5b4870c03dc7ab6$export$7483c4066bfb7ae9 = v);
$parcel$export(module.exports, "des", () => $f5b4870c03dc7ab6$export$e7a565d2e588bb06, (v) => $f5b4870c03dc7ab6$export$e7a565d2e588bb06 = v);
$parcel$export(module.exports, "des-ede3-cbc", () => $f5b4870c03dc7ab6$export$aaa2f54a426f3eb8, (v) => $f5b4870c03dc7ab6$export$aaa2f54a426f3eb8 = v);
$parcel$export(module.exports, "des3", () => $f5b4870c03dc7ab6$export$eba20568dde4ada, (v) => $f5b4870c03dc7ab6$export$eba20568dde4ada = v);
$parcel$export(module.exports, "des-ede3", () => $f5b4870c03dc7ab6$export$d3b5e5996938f5ae, (v) => $f5b4870c03dc7ab6$export$d3b5e5996938f5ae = v);
$parcel$export(module.exports, "des-ede-cbc", () => $f5b4870c03dc7ab6$export$57c08356130bc99b, (v) => $f5b4870c03dc7ab6$export$57c08356130bc99b = v);
$parcel$export(module.exports, "des-ede", () => $f5b4870c03dc7ab6$export$c7169791d5c1e65d, (v) => $f5b4870c03dc7ab6$export$c7169791d5c1e65d = v);
var $f5b4870c03dc7ab6$export$116f8a5cee447347;
var $f5b4870c03dc7ab6$export$7483c4066bfb7ae9;
var $f5b4870c03dc7ab6$export$e7a565d2e588bb06;
var $f5b4870c03dc7ab6$export$aaa2f54a426f3eb8;
var $f5b4870c03dc7ab6$export$eba20568dde4ada;
var $f5b4870c03dc7ab6$export$d3b5e5996938f5ae;
var $f5b4870c03dc7ab6$export$57c08356130bc99b;
var $f5b4870c03dc7ab6$export$c7169791d5c1e65d;
$f5b4870c03dc7ab6$export$116f8a5cee447347 = {
    key: 8,
    iv: 0
};
$f5b4870c03dc7ab6$export$7483c4066bfb7ae9 = $f5b4870c03dc7ab6$export$e7a565d2e588bb06 = {
    key: 8,
    iv: 8
};
$f5b4870c03dc7ab6$export$aaa2f54a426f3eb8 = $f5b4870c03dc7ab6$export$eba20568dde4ada = {
    key: 24,
    iv: 8
};
$f5b4870c03dc7ab6$export$d3b5e5996938f5ae = {
    key: 24,
    iv: 0
};
$f5b4870c03dc7ab6$export$57c08356130bc99b = {
    key: 16,
    iv: 8
};
$f5b4870c03dc7ab6$export$c7169791d5c1e65d = {
    key: 16,
    iv: 0
};

});


parcelRequire.register("20Y99", function(module, exports) {

$parcel$export(module.exports, "DiffieHellmanGroup", () => $177a3cb67640d1c8$export$971862a2fcb1bb40, (v) => $177a3cb67640d1c8$export$971862a2fcb1bb40 = v);
$parcel$export(module.exports, "createDiffieHellmanGroup", () => $177a3cb67640d1c8$export$c6ff6a88acbeaf40, (v) => $177a3cb67640d1c8$export$c6ff6a88acbeaf40 = v);
$parcel$export(module.exports, "getDiffieHellman", () => $177a3cb67640d1c8$export$fdc27893e98845cc, (v) => $177a3cb67640d1c8$export$fdc27893e98845cc = v);
$parcel$export(module.exports, "createDiffieHellman", () => $177a3cb67640d1c8$export$6671fb9a1323bed, (v) => $177a3cb67640d1c8$export$6671fb9a1323bed = v);
$parcel$export(module.exports, "DiffieHellman", () => $177a3cb67640d1c8$export$d74daf141a551db, (v) => $177a3cb67640d1c8$export$d74daf141a551db = v);
var $177a3cb67640d1c8$export$971862a2fcb1bb40;
var $177a3cb67640d1c8$export$c6ff6a88acbeaf40;
var $177a3cb67640d1c8$export$fdc27893e98845cc;
var $177a3cb67640d1c8$export$6671fb9a1323bed;
var $177a3cb67640d1c8$export$d74daf141a551db;

var $cBXue = parcelRequire("cBXue");
var $177a3cb67640d1c8$require$Buffer = $cBXue.Buffer;

var $1LYL1 = parcelRequire("1LYL1");

var $632z2 = parcelRequire("632z2");

var $1IUU8 = parcelRequire("1IUU8");
function $177a3cb67640d1c8$var$getDiffieHellman(mod) {
    var prime = new $177a3cb67640d1c8$require$Buffer($632z2[mod].prime, "hex");
    var gen = new $177a3cb67640d1c8$require$Buffer($632z2[mod].gen, "hex");
    return new $1IUU8(prime, gen);
}
var $177a3cb67640d1c8$var$ENCODINGS = {
    "binary": true,
    "hex": true,
    "base64": true
};
function $177a3cb67640d1c8$var$createDiffieHellman(prime, enc, generator, genc) {
    if ($177a3cb67640d1c8$require$Buffer.isBuffer(enc) || $177a3cb67640d1c8$var$ENCODINGS[enc] === undefined) return $177a3cb67640d1c8$var$createDiffieHellman(prime, "binary", enc, generator);
    enc = enc || "binary";
    genc = genc || "binary";
    generator = generator || new $177a3cb67640d1c8$require$Buffer([
        2
    ]);
    if (!$177a3cb67640d1c8$require$Buffer.isBuffer(generator)) generator = new $177a3cb67640d1c8$require$Buffer(generator, genc);
    if (typeof prime === "number") return new $1IUU8($1LYL1(prime, generator), generator, true);
    if (!$177a3cb67640d1c8$require$Buffer.isBuffer(prime)) prime = new $177a3cb67640d1c8$require$Buffer(prime, enc);
    return new $1IUU8(prime, generator, true);
}
$177a3cb67640d1c8$export$971862a2fcb1bb40 = $177a3cb67640d1c8$export$c6ff6a88acbeaf40 = $177a3cb67640d1c8$export$fdc27893e98845cc = $177a3cb67640d1c8$var$getDiffieHellman;
$177a3cb67640d1c8$export$6671fb9a1323bed = $177a3cb67640d1c8$export$d74daf141a551db = $177a3cb67640d1c8$var$createDiffieHellman;

});
parcelRequire.register("1LYL1", function(module, exports) {

var $cGE0H = parcelRequire("cGE0H");
module.exports = $14a94f5e385db707$var$findPrime;
$14a94f5e385db707$var$findPrime.simpleSieve = $14a94f5e385db707$var$simpleSieve;
$14a94f5e385db707$var$findPrime.fermatTest = $14a94f5e385db707$var$fermatTest;

var $bYm7x = parcelRequire("bYm7x");
var $14a94f5e385db707$var$TWENTYFOUR = new $bYm7x(24);

var $bFkrV = parcelRequire("bFkrV");
var $14a94f5e385db707$var$millerRabin = new $bFkrV();
var $14a94f5e385db707$var$ONE = new $bYm7x(1);
var $14a94f5e385db707$var$TWO = new $bYm7x(2);
var $14a94f5e385db707$var$FIVE = new $bYm7x(5);
var $14a94f5e385db707$var$SIXTEEN = new $bYm7x(16);
var $14a94f5e385db707$var$EIGHT = new $bYm7x(8);
var $14a94f5e385db707$var$TEN = new $bYm7x(10);
var $14a94f5e385db707$var$THREE = new $bYm7x(3);
var $14a94f5e385db707$var$SEVEN = new $bYm7x(7);
var $14a94f5e385db707$var$ELEVEN = new $bYm7x(11);
var $14a94f5e385db707$var$FOUR = new $bYm7x(4);
var $14a94f5e385db707$var$TWELVE = new $bYm7x(12);
var $14a94f5e385db707$var$primes = null;
function $14a94f5e385db707$var$_getPrimes() {
    if ($14a94f5e385db707$var$primes !== null) return $14a94f5e385db707$var$primes;
    var limit = 0x100000;
    var res = [];
    res[0] = 2;
    for(var i = 1, k = 3; k < limit; k += 2){
        var sqrt = Math.ceil(Math.sqrt(k));
        for(var j = 0; j < i && res[j] <= sqrt; j++)if (k % res[j] === 0) break;
        if (i !== j && res[j] <= sqrt) continue;
        res[i++] = k;
    }
    $14a94f5e385db707$var$primes = res;
    return res;
}
function $14a94f5e385db707$var$simpleSieve(p) {
    var primes = $14a94f5e385db707$var$_getPrimes();
    for(var i = 0; i < primes.length; i++)if (p.modn(primes[i]) === 0) {
        if (p.cmpn(primes[i]) === 0) return true;
        else return false;
    }
    return true;
}
function $14a94f5e385db707$var$fermatTest(p) {
    var red = $bYm7x.mont(p);
    return $14a94f5e385db707$var$TWO.toRed(red).redPow(p.subn(1)).fromRed().cmpn(1) === 0;
}
function $14a94f5e385db707$var$findPrime(bits, gen) {
    if (bits < 16) {
        // this is what openssl does
        if (gen === 2 || gen === 5) return new $bYm7x([
            0x8c,
            0x7b
        ]);
        else return new $bYm7x([
            0x8c,
            0x27
        ]);
    }
    gen = new $bYm7x(gen);
    var num, n2;
    while(true){
        num = new $bYm7x($cGE0H(Math.ceil(bits / 8)));
        while(num.bitLength() > bits)num.ishrn(1);
        if (num.isEven()) num.iadd($14a94f5e385db707$var$ONE);
        if (!num.testn(1)) num.iadd($14a94f5e385db707$var$TWO);
        if (!gen.cmp($14a94f5e385db707$var$TWO)) while(num.mod($14a94f5e385db707$var$TWENTYFOUR).cmp($14a94f5e385db707$var$ELEVEN))num.iadd($14a94f5e385db707$var$FOUR);
        else if (!gen.cmp($14a94f5e385db707$var$FIVE)) while(num.mod($14a94f5e385db707$var$TEN).cmp($14a94f5e385db707$var$THREE))num.iadd($14a94f5e385db707$var$FOUR);
        n2 = num.shrn(1);
        if ($14a94f5e385db707$var$simpleSieve(n2) && $14a94f5e385db707$var$simpleSieve(num) && $14a94f5e385db707$var$fermatTest(n2) && $14a94f5e385db707$var$fermatTest(num) && $14a94f5e385db707$var$millerRabin.test(n2) && $14a94f5e385db707$var$millerRabin.test(num)) return num;
    }
}

});
parcelRequire.register("bYm7x", function(module, exports) {

(function(module1, exports) {
    "use strict";
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || "Assertion failed");
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === "le" || base === "be") {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || "be");
        }
    }
    if (typeof module1 === "object") module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== "undefined" && typeof window.Buffer !== "undefined") Buffer = window.Buffer;
        else Buffer = (parcelRequire("gR5sk")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === "object" && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === "number") return this._initNumber(number, base, endian);
        if (typeof number === "object") return this._initArray(number, base, endian);
        if (base === "hex") base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, "");
        var start = 0;
        if (number[0] === "-") {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === "le") this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== "le") return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === "number");
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === "be") for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === "le") for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this.strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // 'A' - 'F'
        if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else return c - 48 & 0xf;
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === "be") for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this.strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) r += c - 49 + 0xa;
            else if (c >= 17) r += c - 17 + 0xa;
            else r += c;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this.strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype.strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    BN.prototype.inspect = function inspect() {
        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
    };
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        "",
        "0",
        "00",
        "000",
        "0000",
        "00000",
        "000000",
        "0000000",
        "00000000",
        "000000000",
        "0000000000",
        "00000000000",
        "000000000000",
        "0000000000000",
        "00000000000000",
        "000000000000000",
        "0000000000000000",
        "00000000000000000",
        "000000000000000000",
        "0000000000000000000",
        "00000000000000000000",
        "000000000000000000000",
        "0000000000000000000000",
        "00000000000000000000000",
        "000000000000000000000000",
        "0000000000000000000000000"
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === "hex") {
            out = "";
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = "";
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = "0" + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        assert(false, "Base should be between 2 and 36");
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, "Number can only safely store up to 53 bits");
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16);
    };
    BN.prototype.toBuffer = function toBuffer(endian, length) {
        assert(typeof Buffer !== "undefined");
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, "byte array longer than desired length");
        assert(reqLength > 0, "Requested array length <= 0");
        this.strip();
        var littleEndian = endian === "le";
        var res = new ArrayType(reqLength);
        var b, i;
        var q = this.clone();
        if (!littleEndian) {
            // Assume big-endian
            for(i = 0; i < reqLength - byteLength; i++)res[i] = 0;
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[reqLength - i - 1] = b;
            }
        } else {
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[i] = b;
            }
            for(; i < reqLength; i++)res[i] = 0;
        }
        return res;
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = (num.words[off] & 1 << wbit) >>> wbit;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this.strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this.strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this.strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === "number" && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this.strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === "number" && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this.strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this.strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out.strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out.strip();
    }
    function jumboMulTo(self, num, out) {
        var fftm = new FFTM();
        return fftm.mulp(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out.strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this.strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === "number" && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this.strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === "number" && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, "imaskn works only with positive numbers");
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this.strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) < num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this.strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this.strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this.strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== "mod") {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q.strip();
        a.strip();
        // Denormalize
        if (mode !== "div" && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== "mod") div = res.div.neg();
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== "mod") div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === "div") return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === "mod") return {
                div: null,
                mod: new BN(this.modn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, "div", false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, "mod", false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, "mod", true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modn = function modn(num) {
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return acc;
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        return this.strip();
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === "number");
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this.strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, "Number is too big");
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        assert(this.negative === 0, "red works only with positives");
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, "fromRed works only with numbers in reduction context");
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, "redAdd works only with red numbers");
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, "redIAdd works only with red numbers");
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, "redSub works only with red numbers");
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, "redISub works only with red numbers");
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, "redShl works only with red numbers");
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, "redSqr works only with red numbers");
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, "redISqr works only with red numbers");
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, "redSqrt works only with red numbers");
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, "redInvm works only with red numbers");
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, "redNeg works only with red numbers");
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, "redPow(normalNum)");
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is BN v4 instance
        r.strip();
        else // r is BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, "k256", "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f");
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, "p224", "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001");
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, "p192", "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff");
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, "25519", "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed");
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === "k256") prime = new K256();
        else if (name === "p224") prime = new P224();
        else if (name === "p192") prime = new P192();
        else if (name === "p25519") prime = new P25519();
        else throw new Error("Unknown prime " + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === "string") {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), "modulus must be greater than 1");
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, "red works only with positives");
        assert(a.red, "red works only with red numbers");
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, "red works only with positives");
        assert(a.red && a.red === b.red, "red works only with red numbers");
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        return a.umod(this.m)._forceRed(this);
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});

parcelRequire.register("bFkrV", function(module, exports) {

var $S0laj = parcelRequire("S0laj");

var $9OawI = parcelRequire("9OawI");
function $87e362dca8743596$var$MillerRabin(rand) {
    this.rand = rand || new $9OawI.Rand();
}
module.exports = $87e362dca8743596$var$MillerRabin;
$87e362dca8743596$var$MillerRabin.create = function create(rand) {
    return new $87e362dca8743596$var$MillerRabin(rand);
};
$87e362dca8743596$var$MillerRabin.prototype._randbelow = function _randbelow(n) {
    var len = n.bitLength();
    var min_bytes = Math.ceil(len / 8);
    // Generage random bytes until a number less than n is found.
    // This ensures that 0..n-1 have an equal probability of being selected.
    do var a = new $S0laj(this.rand.generate(min_bytes));
    while (a.cmp(n) >= 0);
    return a;
};
$87e362dca8743596$var$MillerRabin.prototype._randrange = function _randrange(start, stop) {
    // Generate a random number greater than or equal to start and less than stop.
    var size = stop.sub(start);
    return start.add(this._randbelow(size));
};
$87e362dca8743596$var$MillerRabin.prototype.test = function test(n, k, cb) {
    var len = n.bitLength();
    var red = $S0laj.mont(n);
    var rone = new $S0laj(1).toRed(red);
    if (!k) k = Math.max(1, len / 48 | 0);
    // Find d and s, (n - 1) = (2 ^ s) * d;
    var n1 = n.subn(1);
    for(var s = 0; !n1.testn(s); s++);
    var d = n.shrn(s);
    var rn1 = n1.toRed(red);
    var prime = true;
    for(; k > 0; k--){
        var a = this._randrange(new $S0laj(2), n1);
        if (cb) cb(a);
        var x = a.toRed(red).redPow(d);
        if (x.cmp(rone) === 0 || x.cmp(rn1) === 0) continue;
        for(var i = 1; i < s; i++){
            x = x.redSqr();
            if (x.cmp(rone) === 0) return false;
            if (x.cmp(rn1) === 0) break;
        }
        if (i === s) return false;
    }
    return prime;
};
$87e362dca8743596$var$MillerRabin.prototype.getDivisor = function getDivisor(n, k) {
    var len = n.bitLength();
    var red = $S0laj.mont(n);
    var rone = new $S0laj(1).toRed(red);
    if (!k) k = Math.max(1, len / 48 | 0);
    // Find d and s, (n - 1) = (2 ^ s) * d;
    var n1 = n.subn(1);
    for(var s = 0; !n1.testn(s); s++);
    var d = n.shrn(s);
    var rn1 = n1.toRed(red);
    for(; k > 0; k--){
        var a = this._randrange(new $S0laj(2), n1);
        var g = n.gcd(a);
        if (g.cmpn(1) !== 0) return g;
        var x = a.toRed(red).redPow(d);
        if (x.cmp(rone) === 0 || x.cmp(rn1) === 0) continue;
        for(var i = 1; i < s; i++){
            x = x.redSqr();
            if (x.cmp(rone) === 0) return x.fromRed().subn(1).gcd(n);
            if (x.cmp(rn1) === 0) break;
        }
        if (i === s) {
            x = x.redSqr();
            return x.fromRed().subn(1).gcd(n);
        }
    }
    return false;
};

});
parcelRequire.register("S0laj", function(module, exports) {

(function(module1, exports) {
    "use strict";
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || "Assertion failed");
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === "le" || base === "be") {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || "be");
        }
    }
    if (typeof module1 === "object") module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== "undefined" && typeof window.Buffer !== "undefined") Buffer = window.Buffer;
        else Buffer = (parcelRequire("gR5sk")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === "object" && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === "number") return this._initNumber(number, base, endian);
        if (typeof number === "object") return this._initArray(number, base, endian);
        if (base === "hex") base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, "");
        var start = 0;
        if (number[0] === "-") {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === "le") this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== "le") return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === "number");
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === "be") for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === "le") for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this.strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // 'A' - 'F'
        if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else return c - 48 & 0xf;
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === "be") for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this.strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) r += c - 49 + 0xa;
            else if (c >= 17) r += c - 17 + 0xa;
            else r += c;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this.strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype.strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    BN.prototype.inspect = function inspect() {
        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
    };
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        "",
        "0",
        "00",
        "000",
        "0000",
        "00000",
        "000000",
        "0000000",
        "00000000",
        "000000000",
        "0000000000",
        "00000000000",
        "000000000000",
        "0000000000000",
        "00000000000000",
        "000000000000000",
        "0000000000000000",
        "00000000000000000",
        "000000000000000000",
        "0000000000000000000",
        "00000000000000000000",
        "000000000000000000000",
        "0000000000000000000000",
        "00000000000000000000000",
        "000000000000000000000000",
        "0000000000000000000000000"
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === "hex") {
            out = "";
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = "";
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = "0" + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        assert(false, "Base should be between 2 and 36");
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, "Number can only safely store up to 53 bits");
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16);
    };
    BN.prototype.toBuffer = function toBuffer(endian, length) {
        assert(typeof Buffer !== "undefined");
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, "byte array longer than desired length");
        assert(reqLength > 0, "Requested array length <= 0");
        this.strip();
        var littleEndian = endian === "le";
        var res = new ArrayType(reqLength);
        var b, i;
        var q = this.clone();
        if (!littleEndian) {
            // Assume big-endian
            for(i = 0; i < reqLength - byteLength; i++)res[i] = 0;
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[reqLength - i - 1] = b;
            }
        } else {
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[i] = b;
            }
            for(; i < reqLength; i++)res[i] = 0;
        }
        return res;
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = (num.words[off] & 1 << wbit) >>> wbit;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this.strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this.strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this.strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === "number" && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this.strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === "number" && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this.strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this.strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out.strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out.strip();
    }
    function jumboMulTo(self, num, out) {
        var fftm = new FFTM();
        return fftm.mulp(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out.strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this.strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === "number" && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this.strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === "number" && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, "imaskn works only with positive numbers");
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this.strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) < num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this.strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this.strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this.strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== "mod") {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q.strip();
        a.strip();
        // Denormalize
        if (mode !== "div" && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== "mod") div = res.div.neg();
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== "mod") div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === "div") return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === "mod") return {
                div: null,
                mod: new BN(this.modn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, "div", false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, "mod", false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, "mod", true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modn = function modn(num) {
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return acc;
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        return this.strip();
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === "number");
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this.strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, "Number is too big");
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        assert(this.negative === 0, "red works only with positives");
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, "fromRed works only with numbers in reduction context");
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, "redAdd works only with red numbers");
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, "redIAdd works only with red numbers");
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, "redSub works only with red numbers");
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, "redISub works only with red numbers");
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, "redShl works only with red numbers");
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, "redSqr works only with red numbers");
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, "redISqr works only with red numbers");
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, "redSqrt works only with red numbers");
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, "redInvm works only with red numbers");
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, "redNeg works only with red numbers");
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, "redPow(normalNum)");
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is BN v4 instance
        r.strip();
        else // r is BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, "k256", "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f");
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, "p224", "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001");
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, "p192", "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff");
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, "25519", "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed");
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === "k256") prime = new K256();
        else if (name === "p224") prime = new P224();
        else if (name === "p192") prime = new P192();
        else if (name === "p25519") prime = new P25519();
        else throw new Error("Unknown prime " + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === "string") {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), "modulus must be greater than 1");
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, "red works only with positives");
        assert(a.red, "red works only with red numbers");
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, "red works only with positives");
        assert(a.red && a.red === b.red, "red works only with red numbers");
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        return a.umod(this.m)._forceRed(this);
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});

parcelRequire.register("9OawI", function(module, exports) {
var $01d7c1da8ab24957$var$r;
module.exports = function rand(len) {
    if (!$01d7c1da8ab24957$var$r) $01d7c1da8ab24957$var$r = new $01d7c1da8ab24957$var$Rand(null);
    return $01d7c1da8ab24957$var$r.generate(len);
};
function $01d7c1da8ab24957$var$Rand(rand) {
    this.rand = rand;
}
module.exports.Rand = $01d7c1da8ab24957$var$Rand;
$01d7c1da8ab24957$var$Rand.prototype.generate = function generate(len) {
    return this._rand(len);
};
// Emulate crypto API using randy
$01d7c1da8ab24957$var$Rand.prototype._rand = function _rand(n) {
    if (this.rand.getBytes) return this.rand.getBytes(n);
    var res = new Uint8Array(n);
    for(var i = 0; i < res.length; i++)res[i] = this.rand.getByte();
    return res;
};

if (typeof self === "object") {
    if (self.crypto && self.crypto.getRandomValues) // Modern browsers
    $01d7c1da8ab24957$var$Rand.prototype._rand = function _rand(n) {
        var arr = new Uint8Array(n);
        self.crypto.getRandomValues(arr);
        return arr;
    };
    else if (self.msCrypto && self.msCrypto.getRandomValues) // IE
    $01d7c1da8ab24957$var$Rand.prototype._rand = function _rand(n) {
        var arr = new Uint8Array(n);
        self.msCrypto.getRandomValues(arr);
        return arr;
    };
    else if (typeof window === "object") // Old junk
    $01d7c1da8ab24957$var$Rand.prototype._rand = function() {
        throw new Error("Not implemented yet");
    };
} else // Node.js or Web worker with no crypto support
try {
    var $01d7c1da8ab24957$var$crypto = (parcelRequire("gR5sk"));
    if (typeof $01d7c1da8ab24957$var$crypto.randomBytes !== "function") throw new Error("Not supported");
    $01d7c1da8ab24957$var$Rand.prototype._rand = function _rand(n) {
        return $01d7c1da8ab24957$var$crypto.randomBytes(n);
    };
} catch (e) {}

});



parcelRequire.register("632z2", function(module, exports) {
module.exports = JSON.parse('{"modp1":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a63a3620ffffffffffffffff"},"modp2":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece65381ffffffffffffffff"},"modp5":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca237327ffffffffffffffff"},"modp14":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aacaa68ffffffffffffffff"},"modp15":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a93ad2caffffffffffffffff"},"modp16":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c934063199ffffffffffffffff"},"modp17":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c93402849236c3fab4d27c7026c1d4dcb2602646dec9751e763dba37bdf8ff9406ad9e530ee5db382f413001aeb06a53ed9027d831179727b0865a8918da3edbebcf9b14ed44ce6cbaced4bb1bdb7f1447e6cc254b332051512bd7af426fb8f401378cd2bf5983ca01c64b92ecf032ea15d1721d03f482d7ce6e74fef6d55e702f46980c82b5a84031900b1c9e59e7c97fbec7e8f323a97a7e36cc88be0f1d45b7ff585ac54bd407b22b4154aacc8f6d7ebf48e1d814cc5ed20f8037e0a79715eef29be32806a1d58bb7c5da76f550aa3d8a1fbff0eb19ccb1a313d55cda56c9ec2ef29632387fe8d76e3c0468043e8f663f4860ee12bf2d5b0b7474d6e694f91e6dcc4024ffffffffffffffff"},"modp18":{"gen":"02","prime":"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"}}');

});

parcelRequire.register("1IUU8", function(module, exports) {

var $cBXue = parcelRequire("cBXue");
var $14160a885ab48ae2$require$Buffer = $cBXue.Buffer;

var $bYm7x = parcelRequire("bYm7x");

var $bFkrV = parcelRequire("bFkrV");
var $14160a885ab48ae2$var$millerRabin = new $bFkrV();
var $14160a885ab48ae2$var$TWENTYFOUR = new $bYm7x(24);
var $14160a885ab48ae2$var$ELEVEN = new $bYm7x(11);
var $14160a885ab48ae2$var$TEN = new $bYm7x(10);
var $14160a885ab48ae2$var$THREE = new $bYm7x(3);
var $14160a885ab48ae2$var$SEVEN = new $bYm7x(7);

var $1LYL1 = parcelRequire("1LYL1");

var $cGE0H = parcelRequire("cGE0H");
module.exports = $14160a885ab48ae2$var$DH;
function $14160a885ab48ae2$var$setPublicKey(pub, enc) {
    enc = enc || "utf8";
    if (!$14160a885ab48ae2$require$Buffer.isBuffer(pub)) pub = new $14160a885ab48ae2$require$Buffer(pub, enc);
    this._pub = new $bYm7x(pub);
    return this;
}
function $14160a885ab48ae2$var$setPrivateKey(priv, enc) {
    enc = enc || "utf8";
    if (!$14160a885ab48ae2$require$Buffer.isBuffer(priv)) priv = new $14160a885ab48ae2$require$Buffer(priv, enc);
    this._priv = new $bYm7x(priv);
    return this;
}
var $14160a885ab48ae2$var$primeCache = {};
function $14160a885ab48ae2$var$checkPrime(prime, generator) {
    var gen = generator.toString("hex");
    var hex = [
        gen,
        prime.toString(16)
    ].join("_");
    if (hex in $14160a885ab48ae2$var$primeCache) return $14160a885ab48ae2$var$primeCache[hex];
    var error = 0;
    if (prime.isEven() || !$1LYL1.simpleSieve || !$1LYL1.fermatTest(prime) || !$14160a885ab48ae2$var$millerRabin.test(prime)) {
        //not a prime so +1
        error += 1;
        if (gen === "02" || gen === "05") // we'd be able to check the generator
        // it would fail so +8
        error += 8;
        else //we wouldn't be able to test the generator
        // so +4
        error += 4;
        $14160a885ab48ae2$var$primeCache[hex] = error;
        return error;
    }
    if (!$14160a885ab48ae2$var$millerRabin.test(prime.shrn(1))) //not a safe prime
    error += 2;
    var rem;
    switch(gen){
        case "02":
            if (prime.mod($14160a885ab48ae2$var$TWENTYFOUR).cmp($14160a885ab48ae2$var$ELEVEN)) // unsuidable generator
            error += 8;
            break;
        case "05":
            rem = prime.mod($14160a885ab48ae2$var$TEN);
            if (rem.cmp($14160a885ab48ae2$var$THREE) && rem.cmp($14160a885ab48ae2$var$SEVEN)) // prime mod 10 needs to equal 3 or 7
            error += 8;
            break;
        default:
            error += 4;
    }
    $14160a885ab48ae2$var$primeCache[hex] = error;
    return error;
}
function $14160a885ab48ae2$var$DH(prime, generator, malleable) {
    this.setGenerator(generator);
    this.__prime = new $bYm7x(prime);
    this._prime = $bYm7x.mont(this.__prime);
    this._primeLen = prime.length;
    this._pub = undefined;
    this._priv = undefined;
    this._primeCode = undefined;
    if (malleable) {
        this.setPublicKey = $14160a885ab48ae2$var$setPublicKey;
        this.setPrivateKey = $14160a885ab48ae2$var$setPrivateKey;
    } else this._primeCode = 8;
}
Object.defineProperty($14160a885ab48ae2$var$DH.prototype, "verifyError", {
    enumerable: true,
    get: function() {
        if (typeof this._primeCode !== "number") this._primeCode = $14160a885ab48ae2$var$checkPrime(this.__prime, this.__gen);
        return this._primeCode;
    }
});
$14160a885ab48ae2$var$DH.prototype.generateKeys = function() {
    if (!this._priv) this._priv = new $bYm7x($cGE0H(this._primeLen));
    this._pub = this._gen.toRed(this._prime).redPow(this._priv).fromRed();
    return this.getPublicKey();
};
$14160a885ab48ae2$var$DH.prototype.computeSecret = function(other) {
    other = new $bYm7x(other);
    other = other.toRed(this._prime);
    var secret = other.redPow(this._priv).fromRed();
    var out = new $14160a885ab48ae2$require$Buffer(secret.toArray());
    var prime = this.getPrime();
    if (out.length < prime.length) {
        var front = new $14160a885ab48ae2$require$Buffer(prime.length - out.length);
        front.fill(0);
        out = $14160a885ab48ae2$require$Buffer.concat([
            front,
            out
        ]);
    }
    return out;
};
$14160a885ab48ae2$var$DH.prototype.getPublicKey = function getPublicKey(enc) {
    return $14160a885ab48ae2$var$formatReturnValue(this._pub, enc);
};
$14160a885ab48ae2$var$DH.prototype.getPrivateKey = function getPrivateKey(enc) {
    return $14160a885ab48ae2$var$formatReturnValue(this._priv, enc);
};
$14160a885ab48ae2$var$DH.prototype.getPrime = function(enc) {
    return $14160a885ab48ae2$var$formatReturnValue(this.__prime, enc);
};
$14160a885ab48ae2$var$DH.prototype.getGenerator = function(enc) {
    return $14160a885ab48ae2$var$formatReturnValue(this._gen, enc);
};
$14160a885ab48ae2$var$DH.prototype.setGenerator = function(gen, enc) {
    enc = enc || "utf8";
    if (!$14160a885ab48ae2$require$Buffer.isBuffer(gen)) gen = new $14160a885ab48ae2$require$Buffer(gen, enc);
    this.__gen = gen;
    this._gen = new $bYm7x(gen);
    return this;
};
function $14160a885ab48ae2$var$formatReturnValue(bn, enc) {
    var buf = new $14160a885ab48ae2$require$Buffer(bn.toArray());
    if (!enc) return buf;
    else return buf.toString(enc);
}

});


parcelRequire.register("csM0q", function(module, exports) {

var $8AWE0 = parcelRequire("8AWE0");
var $912d56805fbe065d$require$Buffer = $8AWE0.Buffer;

var $bptsJ = parcelRequire("bptsJ");

var $gwqwh = parcelRequire("gwqwh");

var $5SAkX = parcelRequire("5SAkX");

var $8bYbt = parcelRequire("8bYbt");

var $5q8Sv = parcelRequire("5q8Sv");

var $daoze = parcelRequire("daoze");
Object.keys($daoze).forEach(function(key) {
    $daoze[key].id = $912d56805fbe065d$require$Buffer.from($daoze[key].id, "hex");
    $daoze[key.toLowerCase()] = $daoze[key];
});
function $912d56805fbe065d$var$Sign(algorithm) {
    $gwqwh.Writable.call(this);
    var data = $daoze[algorithm];
    if (!data) throw new Error("Unknown message digest");
    this._hashType = data.hash;
    this._hash = $bptsJ(data.hash);
    this._tag = data.id;
    this._signType = data.sign;
}
$5SAkX($912d56805fbe065d$var$Sign, $gwqwh.Writable);
$912d56805fbe065d$var$Sign.prototype._write = function _write(data, _, done) {
    this._hash.update(data);
    done();
};
$912d56805fbe065d$var$Sign.prototype.update = function update(data, enc) {
    if (typeof data === "string") data = $912d56805fbe065d$require$Buffer.from(data, enc);
    this._hash.update(data);
    return this;
};
$912d56805fbe065d$var$Sign.prototype.sign = function signMethod(key, enc) {
    this.end();
    var hash = this._hash.digest();
    var sig = $8bYbt(hash, key, this._hashType, this._signType, this._tag);
    return enc ? sig.toString(enc) : sig;
};
function $912d56805fbe065d$var$Verify(algorithm) {
    $gwqwh.Writable.call(this);
    var data = $daoze[algorithm];
    if (!data) throw new Error("Unknown message digest");
    this._hash = $bptsJ(data.hash);
    this._tag = data.id;
    this._signType = data.sign;
}
$5SAkX($912d56805fbe065d$var$Verify, $gwqwh.Writable);
$912d56805fbe065d$var$Verify.prototype._write = function _write(data, _, done) {
    this._hash.update(data);
    done();
};
$912d56805fbe065d$var$Verify.prototype.update = function update(data, enc) {
    if (typeof data === "string") data = $912d56805fbe065d$require$Buffer.from(data, enc);
    this._hash.update(data);
    return this;
};
$912d56805fbe065d$var$Verify.prototype.verify = function verifyMethod(key, sig, enc) {
    if (typeof sig === "string") sig = $912d56805fbe065d$require$Buffer.from(sig, enc);
    this.end();
    var hash = this._hash.digest();
    return $5q8Sv(sig, hash, key, this._signType, this._tag);
};
function $912d56805fbe065d$var$createSign(algorithm) {
    return new $912d56805fbe065d$var$Sign(algorithm);
}
function $912d56805fbe065d$var$createVerify(algorithm) {
    return new $912d56805fbe065d$var$Verify(algorithm);
}
module.exports = {
    Sign: $912d56805fbe065d$var$createSign,
    Verify: $912d56805fbe065d$var$createVerify,
    createSign: $912d56805fbe065d$var$createSign,
    createVerify: $912d56805fbe065d$var$createVerify
};

});
parcelRequire.register("8AWE0", function(module, exports) {
/*! safe-buffer. MIT License. Feross Aboukhadijeh <https://feross.org/opensource> */ /* eslint-disable node/no-deprecated-api */ 
var $iuRmA = parcelRequire("iuRmA");
var $641f2d0b91331a14$var$Buffer = $iuRmA.Buffer;
// alternative to using Object.keys for old browsers
function $641f2d0b91331a14$var$copyProps(src, dst) {
    for(var key in src)dst[key] = src[key];
}
if ($641f2d0b91331a14$var$Buffer.from && $641f2d0b91331a14$var$Buffer.alloc && $641f2d0b91331a14$var$Buffer.allocUnsafe && $641f2d0b91331a14$var$Buffer.allocUnsafeSlow) module.exports = $iuRmA;
else {
    // Copy properties from require('buffer')
    $641f2d0b91331a14$var$copyProps($iuRmA, module.exports);
    module.exports.Buffer = $641f2d0b91331a14$var$SafeBuffer;
}
function $641f2d0b91331a14$var$SafeBuffer(arg, encodingOrOffset, length) {
    return $641f2d0b91331a14$var$Buffer(arg, encodingOrOffset, length);
}
$641f2d0b91331a14$var$SafeBuffer.prototype = Object.create($641f2d0b91331a14$var$Buffer.prototype);
// Copy static methods from Buffer
$641f2d0b91331a14$var$copyProps($641f2d0b91331a14$var$Buffer, $641f2d0b91331a14$var$SafeBuffer);
$641f2d0b91331a14$var$SafeBuffer.from = function(arg, encodingOrOffset, length) {
    if (typeof arg === "number") throw new TypeError("Argument must not be a number");
    return $641f2d0b91331a14$var$Buffer(arg, encodingOrOffset, length);
};
$641f2d0b91331a14$var$SafeBuffer.alloc = function(size, fill, encoding) {
    if (typeof size !== "number") throw new TypeError("Argument must be a number");
    var buf = $641f2d0b91331a14$var$Buffer(size);
    if (fill !== undefined) {
        if (typeof encoding === "string") buf.fill(fill, encoding);
        else buf.fill(fill);
    } else buf.fill(0);
    return buf;
};
$641f2d0b91331a14$var$SafeBuffer.allocUnsafe = function(size) {
    if (typeof size !== "number") throw new TypeError("Argument must be a number");
    return $641f2d0b91331a14$var$Buffer(size);
};
$641f2d0b91331a14$var$SafeBuffer.allocUnsafeSlow = function(size) {
    if (typeof size !== "number") throw new TypeError("Argument must be a number");
    return $iuRmA.SlowBuffer(size);
};

});

parcelRequire.register("8bYbt", function(module, exports) {
// much of this based on https://github.com/indutny/self-signed/blob/gh-pages/lib/rsa.js

var $8AWE0 = parcelRequire("8AWE0");
var $5f6e0921b66f8626$require$Buffer = $8AWE0.Buffer;

var $7oblv = parcelRequire("7oblv");

var $9KpIc = parcelRequire("9KpIc");

var $crn2y = parcelRequire("crn2y");
var $5f6e0921b66f8626$require$EC = $crn2y.ec;

var $jNP1I = parcelRequire("jNP1I");

var $j13Ls = parcelRequire("j13Ls");

var $f6nBz = parcelRequire("f6nBz");
function $5f6e0921b66f8626$var$sign(hash, key, hashType, signType, tag) {
    var priv = $j13Ls(key);
    if (priv.curve) {
        // rsa keys can be interpreted as ecdsa ones in openssl
        if (signType !== "ecdsa" && signType !== "ecdsa/rsa") throw new Error("wrong private key type");
        return $5f6e0921b66f8626$var$ecSign(hash, priv);
    } else if (priv.type === "dsa") {
        if (signType !== "dsa") throw new Error("wrong private key type");
        return $5f6e0921b66f8626$var$dsaSign(hash, priv, hashType);
    } else {
        if (signType !== "rsa" && signType !== "ecdsa/rsa") throw new Error("wrong private key type");
    }
    hash = $5f6e0921b66f8626$require$Buffer.concat([
        tag,
        hash
    ]);
    var len = priv.modulus.byteLength();
    var pad = [
        0,
        1
    ];
    while(hash.length + pad.length + 1 < len)pad.push(0xff);
    pad.push(0x00);
    var i = -1;
    while(++i < hash.length)pad.push(hash[i]);
    var out = $9KpIc(pad, priv);
    return out;
}
function $5f6e0921b66f8626$var$ecSign(hash, priv) {
    var curveId = $f6nBz[priv.curve.join(".")];
    if (!curveId) throw new Error("unknown curve " + priv.curve.join("."));
    var curve = new $5f6e0921b66f8626$require$EC(curveId);
    var key = curve.keyFromPrivate(priv.privateKey);
    var out = key.sign(hash);
    return $5f6e0921b66f8626$require$Buffer.from(out.toDER());
}
function $5f6e0921b66f8626$var$dsaSign(hash, priv, algo) {
    var x = priv.params.priv_key;
    var p = priv.params.p;
    var q = priv.params.q;
    var g = priv.params.g;
    var r = new $jNP1I(0);
    var k;
    var H = $5f6e0921b66f8626$var$bits2int(hash, q).mod(q);
    var s = false;
    var kv = $5f6e0921b66f8626$var$getKey(x, q, hash, algo);
    while(s === false){
        k = $5f6e0921b66f8626$var$makeKey(q, kv, algo);
        r = $5f6e0921b66f8626$var$makeR(g, k, p, q);
        s = k.invm(q).imul(H.add(x.mul(r))).mod(q);
        if (s.cmpn(0) === 0) {
            s = false;
            r = new $jNP1I(0);
        }
    }
    return $5f6e0921b66f8626$var$toDER(r, s);
}
function $5f6e0921b66f8626$var$toDER(r, s) {
    r = r.toArray();
    s = s.toArray();
    // Pad values
    if (r[0] & 0x80) r = [
        0
    ].concat(r);
    if (s[0] & 0x80) s = [
        0
    ].concat(s);
    var total = r.length + s.length + 4;
    var res = [
        0x30,
        total,
        0x02,
        r.length
    ];
    res = res.concat(r, [
        0x02,
        s.length
    ], s);
    return $5f6e0921b66f8626$require$Buffer.from(res);
}
function $5f6e0921b66f8626$var$getKey(x, q, hash, algo) {
    x = $5f6e0921b66f8626$require$Buffer.from(x.toArray());
    if (x.length < q.byteLength()) {
        var zeros = $5f6e0921b66f8626$require$Buffer.alloc(q.byteLength() - x.length);
        x = $5f6e0921b66f8626$require$Buffer.concat([
            zeros,
            x
        ]);
    }
    var hlen = hash.length;
    var hbits = $5f6e0921b66f8626$var$bits2octets(hash, q);
    var v = $5f6e0921b66f8626$require$Buffer.alloc(hlen);
    v.fill(1);
    var k = $5f6e0921b66f8626$require$Buffer.alloc(hlen);
    k = $7oblv(algo, k).update(v).update($5f6e0921b66f8626$require$Buffer.from([
        0
    ])).update(x).update(hbits).digest();
    v = $7oblv(algo, k).update(v).digest();
    k = $7oblv(algo, k).update(v).update($5f6e0921b66f8626$require$Buffer.from([
        1
    ])).update(x).update(hbits).digest();
    v = $7oblv(algo, k).update(v).digest();
    return {
        k: k,
        v: v
    };
}
function $5f6e0921b66f8626$var$bits2int(obits, q) {
    var bits = new $jNP1I(obits);
    var shift = (obits.length << 3) - q.bitLength();
    if (shift > 0) bits.ishrn(shift);
    return bits;
}
function $5f6e0921b66f8626$var$bits2octets(bits, q) {
    bits = $5f6e0921b66f8626$var$bits2int(bits, q);
    bits = bits.mod(q);
    var out = $5f6e0921b66f8626$require$Buffer.from(bits.toArray());
    if (out.length < q.byteLength()) {
        var zeros = $5f6e0921b66f8626$require$Buffer.alloc(q.byteLength() - out.length);
        out = $5f6e0921b66f8626$require$Buffer.concat([
            zeros,
            out
        ]);
    }
    return out;
}
function $5f6e0921b66f8626$var$makeKey(q, kv, algo) {
    var t;
    var k;
    do {
        t = $5f6e0921b66f8626$require$Buffer.alloc(0);
        while(t.length * 8 < q.bitLength()){
            kv.v = $7oblv(algo, kv.k).update(kv.v).digest();
            t = $5f6e0921b66f8626$require$Buffer.concat([
                t,
                kv.v
            ]);
        }
        k = $5f6e0921b66f8626$var$bits2int(t, q);
        kv.k = $7oblv(algo, kv.k).update(kv.v).update($5f6e0921b66f8626$require$Buffer.from([
            0
        ])).digest();
        kv.v = $7oblv(algo, kv.k).update(kv.v).digest();
    }while (k.cmp(q) !== -1);
    return k;
}
function $5f6e0921b66f8626$var$makeR(g, k, p, q) {
    return g.toRed($jNP1I.mont(p)).redPow(k).fromRed().mod(q);
}
module.exports = $5f6e0921b66f8626$var$sign;
module.exports.getKey = $5f6e0921b66f8626$var$getKey;
module.exports.makeKey = $5f6e0921b66f8626$var$makeKey;

});
parcelRequire.register("9KpIc", function(module, exports) {

var $cBXue = parcelRequire("cBXue");
var $718c5ac5aa8b2db9$require$Buffer = $cBXue.Buffer;

var $jNP1I = parcelRequire("jNP1I");

var $cGE0H = parcelRequire("cGE0H");
function $718c5ac5aa8b2db9$var$blind(priv) {
    var r = $718c5ac5aa8b2db9$var$getr(priv);
    var blinder = r.toRed($jNP1I.mont(priv.modulus)).redPow(new $jNP1I(priv.publicExponent)).fromRed();
    return {
        blinder: blinder,
        unblinder: r.invm(priv.modulus)
    };
}
function $718c5ac5aa8b2db9$var$getr(priv) {
    var len = priv.modulus.byteLength();
    var r;
    do r = new $jNP1I($cGE0H(len));
    while (r.cmp(priv.modulus) >= 0 || !r.umod(priv.prime1) || !r.umod(priv.prime2));
    return r;
}
function $718c5ac5aa8b2db9$var$crt(msg, priv) {
    var blinds = $718c5ac5aa8b2db9$var$blind(priv);
    var len = priv.modulus.byteLength();
    var blinded = new $jNP1I(msg).mul(blinds.blinder).umod(priv.modulus);
    var c1 = blinded.toRed($jNP1I.mont(priv.prime1));
    var c2 = blinded.toRed($jNP1I.mont(priv.prime2));
    var qinv = priv.coefficient;
    var p = priv.prime1;
    var q = priv.prime2;
    var m1 = c1.redPow(priv.exponent1).fromRed();
    var m2 = c2.redPow(priv.exponent2).fromRed();
    var h = m1.isub(m2).imul(qinv).umod(p).imul(q);
    return m2.iadd(h).imul(blinds.unblinder).umod(priv.modulus).toArrayLike($718c5ac5aa8b2db9$require$Buffer, "be", len);
}
$718c5ac5aa8b2db9$var$crt.getr = $718c5ac5aa8b2db9$var$getr;
module.exports = $718c5ac5aa8b2db9$var$crt;

});
parcelRequire.register("jNP1I", function(module, exports) {

(function(module1, exports) {
    "use strict";
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || "Assertion failed");
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === "le" || base === "be") {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || "be");
        }
    }
    if (typeof module1 === "object") module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== "undefined" && typeof window.Buffer !== "undefined") Buffer = window.Buffer;
        else Buffer = (parcelRequire("gR5sk")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === "object" && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === "number") return this._initNumber(number, base, endian);
        if (typeof number === "object") return this._initArray(number, base, endian);
        if (base === "hex") base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, "");
        var start = 0;
        if (number[0] === "-") {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === "le") this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== "le") return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === "number");
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === "be") for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === "le") for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this._strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // '0' - '9'
        if (c >= 48 && c <= 57) return c - 48;
        else if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else assert(false, "Invalid character in " + string);
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === "be") for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this._strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var b = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) b = c - 49 + 0xa;
            else if (c >= 17) b = c - 17 + 0xa;
            else b = c;
            assert(c >= 0 && b < mul, "Invalid character");
            r += b;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this._strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    function move(dest, src) {
        dest.words = src.words;
        dest.length = src.length;
        dest.negative = src.negative;
        dest.red = src.red;
    }
    BN.prototype._move = function _move(dest) {
        move(dest, this);
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype._strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    // Check Symbol.for because not everywhere where Symbol defined
    // See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol#Browser_compatibility
    if (typeof Symbol !== "undefined" && typeof Symbol.for === "function") try {
        BN.prototype[Symbol.for("nodejs.util.inspect.custom")] = inspect;
    } catch (e) {
        BN.prototype.inspect = inspect;
    }
    else BN.prototype.inspect = inspect;
    function inspect() {
        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
    }
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        "",
        "0",
        "00",
        "000",
        "0000",
        "00000",
        "000000",
        "0000000",
        "00000000",
        "000000000",
        "0000000000",
        "00000000000",
        "000000000000",
        "0000000000000",
        "00000000000000",
        "000000000000000",
        "0000000000000000",
        "00000000000000000",
        "000000000000000000",
        "0000000000000000000",
        "00000000000000000000",
        "000000000000000000000",
        "0000000000000000000000",
        "00000000000000000000000",
        "000000000000000000000000",
        "0000000000000000000000000"
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === "hex") {
            out = "";
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = "";
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modrn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = "0" + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        assert(false, "Base should be between 2 and 36");
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, "Number can only safely store up to 53 bits");
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16, 2);
    };
    if (Buffer) BN.prototype.toBuffer = function toBuffer(endian, length) {
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    var allocate = function allocate(ArrayType, size) {
        if (ArrayType.allocUnsafe) return ArrayType.allocUnsafe(size);
        return new ArrayType(size);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        this._strip();
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, "byte array longer than desired length");
        assert(reqLength > 0, "Requested array length <= 0");
        var res = allocate(ArrayType, reqLength);
        var postfix = endian === "le" ? "LE" : "BE";
        this["_toArrayLike" + postfix](res, byteLength);
        return res;
    };
    BN.prototype._toArrayLikeLE = function _toArrayLikeLE(res, byteLength) {
        var position = 0;
        var carry = 0;
        for(var i = 0, shift = 0; i < this.length; i++){
            var word = this.words[i] << shift | carry;
            res[position++] = word & 0xff;
            if (position < res.length) res[position++] = word >> 8 & 0xff;
            if (position < res.length) res[position++] = word >> 16 & 0xff;
            if (shift === 6) {
                if (position < res.length) res[position++] = word >> 24 & 0xff;
                carry = 0;
                shift = 0;
            } else {
                carry = word >>> 24;
                shift += 2;
            }
        }
        if (position < res.length) {
            res[position++] = carry;
            while(position < res.length)res[position++] = 0;
        }
    };
    BN.prototype._toArrayLikeBE = function _toArrayLikeBE(res, byteLength) {
        var position = res.length - 1;
        var carry = 0;
        for(var i = 0, shift = 0; i < this.length; i++){
            var word = this.words[i] << shift | carry;
            res[position--] = word & 0xff;
            if (position >= 0) res[position--] = word >> 8 & 0xff;
            if (position >= 0) res[position--] = word >> 16 & 0xff;
            if (shift === 6) {
                if (position >= 0) res[position--] = word >> 24 & 0xff;
                carry = 0;
                shift = 0;
            } else {
                carry = word >>> 24;
                shift += 2;
            }
        }
        if (position >= 0) {
            res[position--] = carry;
            while(position >= 0)res[position--] = 0;
        }
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = num.words[off] >>> wbit & 0x01;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this._strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this._strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this._strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === "number" && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this._strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === "number" && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this._strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this._strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out._strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out._strip();
    }
    function jumboMulTo(self, num, out) {
        // Temporary disable, see https://github.com/indutny/bn.js/issues/211
        // var fftm = new FFTM();
        // return fftm.mulp(self, num, out);
        return bigMulTo(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out._strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(typeof num === "number");
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return isNegNum ? this.ineg() : this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this._strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === "number" && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this._strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === "number" && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, "imaskn works only with positive numbers");
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this._strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) <= num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this._strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this._strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this._strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== "mod") {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q._strip();
        a._strip();
        // Denormalize
        if (mode !== "div" && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== "mod") div = res.div.neg();
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== "mod") div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === "div") return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === "mod") return {
                div: null,
                mod: new BN(this.modrn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modrn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, "div", false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, "mod", false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, "mod", true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modrn = function modrn(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return isNegNum ? -acc : acc;
    };
    // WARNING: DEPRECATED
    BN.prototype.modn = function modn(num) {
        return this.modrn(num);
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        this._strip();
        return isNegNum ? this.ineg() : this;
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === "number");
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this._strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, "Number is too big");
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        assert(this.negative === 0, "red works only with positives");
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, "fromRed works only with numbers in reduction context");
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, "redAdd works only with red numbers");
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, "redIAdd works only with red numbers");
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, "redSub works only with red numbers");
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, "redISub works only with red numbers");
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, "redShl works only with red numbers");
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, "redSqr works only with red numbers");
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, "redISqr works only with red numbers");
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, "redSqrt works only with red numbers");
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, "redInvm works only with red numbers");
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, "redNeg works only with red numbers");
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, "redPow(normalNum)");
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is a BN v4 instance
        r.strip();
        else // r is a BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, "k256", "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f");
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, "p224", "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001");
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, "p192", "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff");
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, "25519", "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed");
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === "k256") prime = new K256();
        else if (name === "p224") prime = new P224();
        else if (name === "p192") prime = new P192();
        else if (name === "p25519") prime = new P25519();
        else throw new Error("Unknown prime " + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === "string") {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), "modulus must be greater than 1");
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, "red works only with positives");
        assert(a.red, "red works only with red numbers");
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, "red works only with positives");
        assert(a.red && a.red === b.red, "red works only with red numbers");
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        move(a, a.umod(this.m)._forceRed(this));
        return a;
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});


parcelRequire.register("crn2y", function(module, exports) {
"use strict";
var $90e9e0f885fe674e$var$elliptic = module.exports;

$90e9e0f885fe674e$var$elliptic.version = (parcelRequire("hk4nY")).version;

$90e9e0f885fe674e$var$elliptic.utils = (parcelRequire("axXvD"));

$90e9e0f885fe674e$var$elliptic.rand = (parcelRequire("9OawI"));

$90e9e0f885fe674e$var$elliptic.curve = (parcelRequire("5Db4y"));

$90e9e0f885fe674e$var$elliptic.curves = (parcelRequire("lkAVm"));

// Protocols
$90e9e0f885fe674e$var$elliptic.ec = (parcelRequire("kiF8o"));

$90e9e0f885fe674e$var$elliptic.eddsa = (parcelRequire("ds844"));

});
parcelRequire.register("hk4nY", function(module, exports) {
module.exports = JSON.parse('{"name":"elliptic","version":"6.5.4","description":"EC cryptography","main":"lib/elliptic.js","files":["lib"],"scripts":{"lint":"eslint lib test","lint:fix":"npm run lint -- --fix","unit":"istanbul test _mocha --reporter=spec test/index.js","test":"npm run lint && npm run unit","version":"grunt dist && git add dist/"},"repository":{"type":"git","url":"git@github.com:indutny/elliptic"},"keywords":["EC","Elliptic","curve","Cryptography"],"author":"Fedor Indutny <fedor@indutny.com>","license":"MIT","bugs":{"url":"https://github.com/indutny/elliptic/issues"},"homepage":"https://github.com/indutny/elliptic","devDependencies":{"brfs":"^2.0.2","coveralls":"^3.1.0","eslint":"^7.6.0","grunt":"^1.2.1","grunt-browserify":"^5.3.0","grunt-cli":"^1.3.2","grunt-contrib-connect":"^3.0.0","grunt-contrib-copy":"^1.0.0","grunt-contrib-uglify":"^5.0.0","grunt-mocha-istanbul":"^5.0.2","grunt-saucelabs":"^9.0.1","istanbul":"^0.4.5","mocha":"^8.0.1"},"dependencies":{"bn.js":"^4.11.9","brorand":"^1.1.0","hash.js":"^1.0.0","hmac-drbg":"^1.0.1","inherits":"^2.0.4","minimalistic-assert":"^1.0.1","minimalistic-crypto-utils":"^1.0.1"}}');

});

parcelRequire.register("axXvD", function(module, exports) {
"use strict";
var $7adb25bfd90dd03c$var$utils = module.exports;

var $73nMH = parcelRequire("73nMH");

var $93fa9 = parcelRequire("93fa9");

var $h2Wqj = parcelRequire("h2Wqj");
$7adb25bfd90dd03c$var$utils.assert = $93fa9;
$7adb25bfd90dd03c$var$utils.toArray = $h2Wqj.toArray;
$7adb25bfd90dd03c$var$utils.zero2 = $h2Wqj.zero2;
$7adb25bfd90dd03c$var$utils.toHex = $h2Wqj.toHex;
$7adb25bfd90dd03c$var$utils.encode = $h2Wqj.encode;
// Represent num in a w-NAF form
function $7adb25bfd90dd03c$var$getNAF(num, w, bits) {
    var naf = new Array(Math.max(num.bitLength(), bits) + 1);
    naf.fill(0);
    var ws = 1 << w + 1;
    var k = num.clone();
    for(var i = 0; i < naf.length; i++){
        var z;
        var mod = k.andln(ws - 1);
        if (k.isOdd()) {
            if (mod > (ws >> 1) - 1) z = (ws >> 1) - mod;
            else z = mod;
            k.isubn(z);
        } else z = 0;
        naf[i] = z;
        k.iushrn(1);
    }
    return naf;
}
$7adb25bfd90dd03c$var$utils.getNAF = $7adb25bfd90dd03c$var$getNAF;
// Represent k1, k2 in a Joint Sparse Form
function $7adb25bfd90dd03c$var$getJSF(k1, k2) {
    var jsf = [
        [],
        []
    ];
    k1 = k1.clone();
    k2 = k2.clone();
    var d1 = 0;
    var d2 = 0;
    var m8;
    while(k1.cmpn(-d1) > 0 || k2.cmpn(-d2) > 0){
        // First phase
        var m14 = k1.andln(3) + d1 & 3;
        var m24 = k2.andln(3) + d2 & 3;
        if (m14 === 3) m14 = -1;
        if (m24 === 3) m24 = -1;
        var u1;
        if ((m14 & 1) === 0) u1 = 0;
        else {
            m8 = k1.andln(7) + d1 & 7;
            if ((m8 === 3 || m8 === 5) && m24 === 2) u1 = -m14;
            else u1 = m14;
        }
        jsf[0].push(u1);
        var u2;
        if ((m24 & 1) === 0) u2 = 0;
        else {
            m8 = k2.andln(7) + d2 & 7;
            if ((m8 === 3 || m8 === 5) && m14 === 2) u2 = -m24;
            else u2 = m24;
        }
        jsf[1].push(u2);
        // Second phase
        if (2 * d1 === u1 + 1) d1 = 1 - d1;
        if (2 * d2 === u2 + 1) d2 = 1 - d2;
        k1.iushrn(1);
        k2.iushrn(1);
    }
    return jsf;
}
$7adb25bfd90dd03c$var$utils.getJSF = $7adb25bfd90dd03c$var$getJSF;
function $7adb25bfd90dd03c$var$cachedProperty(obj, name, computer) {
    var key = "_" + name;
    obj.prototype[name] = function cachedProperty() {
        return this[key] !== undefined ? this[key] : this[key] = computer.call(this);
    };
}
$7adb25bfd90dd03c$var$utils.cachedProperty = $7adb25bfd90dd03c$var$cachedProperty;
function $7adb25bfd90dd03c$var$parseBytes(bytes) {
    return typeof bytes === "string" ? $7adb25bfd90dd03c$var$utils.toArray(bytes, "hex") : bytes;
}
$7adb25bfd90dd03c$var$utils.parseBytes = $7adb25bfd90dd03c$var$parseBytes;
function $7adb25bfd90dd03c$var$intFromLE(bytes) {
    return new $73nMH(bytes, "hex", "le");
}
$7adb25bfd90dd03c$var$utils.intFromLE = $7adb25bfd90dd03c$var$intFromLE;

});
parcelRequire.register("73nMH", function(module, exports) {

(function(module1, exports) {
    "use strict";
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || "Assertion failed");
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === "le" || base === "be") {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || "be");
        }
    }
    if (typeof module1 === "object") module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== "undefined" && typeof window.Buffer !== "undefined") Buffer = window.Buffer;
        else Buffer = (parcelRequire("gR5sk")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === "object" && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === "number") return this._initNumber(number, base, endian);
        if (typeof number === "object") return this._initArray(number, base, endian);
        if (base === "hex") base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, "");
        var start = 0;
        if (number[0] === "-") {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === "le") this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== "le") return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === "number");
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === "be") for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === "le") for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this.strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // 'A' - 'F'
        if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else return c - 48 & 0xf;
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === "be") for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this.strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) r += c - 49 + 0xa;
            else if (c >= 17) r += c - 17 + 0xa;
            else r += c;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this.strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype.strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    BN.prototype.inspect = function inspect() {
        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
    };
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        "",
        "0",
        "00",
        "000",
        "0000",
        "00000",
        "000000",
        "0000000",
        "00000000",
        "000000000",
        "0000000000",
        "00000000000",
        "000000000000",
        "0000000000000",
        "00000000000000",
        "000000000000000",
        "0000000000000000",
        "00000000000000000",
        "000000000000000000",
        "0000000000000000000",
        "00000000000000000000",
        "000000000000000000000",
        "0000000000000000000000",
        "00000000000000000000000",
        "000000000000000000000000",
        "0000000000000000000000000"
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === "hex") {
            out = "";
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = "";
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = "0" + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        assert(false, "Base should be between 2 and 36");
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, "Number can only safely store up to 53 bits");
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16);
    };
    BN.prototype.toBuffer = function toBuffer(endian, length) {
        assert(typeof Buffer !== "undefined");
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, "byte array longer than desired length");
        assert(reqLength > 0, "Requested array length <= 0");
        this.strip();
        var littleEndian = endian === "le";
        var res = new ArrayType(reqLength);
        var b, i;
        var q = this.clone();
        if (!littleEndian) {
            // Assume big-endian
            for(i = 0; i < reqLength - byteLength; i++)res[i] = 0;
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[reqLength - i - 1] = b;
            }
        } else {
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[i] = b;
            }
            for(; i < reqLength; i++)res[i] = 0;
        }
        return res;
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = (num.words[off] & 1 << wbit) >>> wbit;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this.strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this.strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this.strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === "number" && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this.strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === "number" && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this.strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this.strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out.strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out.strip();
    }
    function jumboMulTo(self, num, out) {
        var fftm = new FFTM();
        return fftm.mulp(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out.strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this.strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === "number" && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this.strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === "number" && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, "imaskn works only with positive numbers");
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this.strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) < num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this.strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this.strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this.strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== "mod") {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q.strip();
        a.strip();
        // Denormalize
        if (mode !== "div" && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== "mod") div = res.div.neg();
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== "mod") div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === "div") return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === "mod") return {
                div: null,
                mod: new BN(this.modn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, "div", false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, "mod", false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, "mod", true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modn = function modn(num) {
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return acc;
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        return this.strip();
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === "number");
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this.strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, "Number is too big");
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        assert(this.negative === 0, "red works only with positives");
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, "fromRed works only with numbers in reduction context");
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, "redAdd works only with red numbers");
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, "redIAdd works only with red numbers");
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, "redSub works only with red numbers");
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, "redISub works only with red numbers");
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, "redShl works only with red numbers");
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, "redSqr works only with red numbers");
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, "redISqr works only with red numbers");
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, "redSqrt works only with red numbers");
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, "redInvm works only with red numbers");
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, "redNeg works only with red numbers");
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, "redPow(normalNum)");
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is BN v4 instance
        r.strip();
        else // r is BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, "k256", "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f");
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, "p224", "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001");
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, "p192", "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff");
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, "25519", "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed");
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === "k256") prime = new K256();
        else if (name === "p224") prime = new P224();
        else if (name === "p192") prime = new P192();
        else if (name === "p25519") prime = new P25519();
        else throw new Error("Unknown prime " + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === "string") {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), "modulus must be greater than 1");
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, "red works only with positives");
        assert(a.red, "red works only with red numbers");
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, "red works only with positives");
        assert(a.red && a.red === b.red, "red works only with red numbers");
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        return a.umod(this.m)._forceRed(this);
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});

parcelRequire.register("h2Wqj", function(module, exports) {
"use strict";
var $c68ff14009c18bbc$var$utils = module.exports;
function $c68ff14009c18bbc$var$toArray(msg, enc) {
    if (Array.isArray(msg)) return msg.slice();
    if (!msg) return [];
    var res = [];
    if (typeof msg !== "string") {
        for(var i = 0; i < msg.length; i++)res[i] = msg[i] | 0;
        return res;
    }
    if (enc === "hex") {
        msg = msg.replace(/[^a-z0-9]+/ig, "");
        if (msg.length % 2 !== 0) msg = "0" + msg;
        for(var i = 0; i < msg.length; i += 2)res.push(parseInt(msg[i] + msg[i + 1], 16));
    } else for(var i = 0; i < msg.length; i++){
        var c = msg.charCodeAt(i);
        var hi = c >> 8;
        var lo = c & 0xff;
        if (hi) res.push(hi, lo);
        else res.push(lo);
    }
    return res;
}
$c68ff14009c18bbc$var$utils.toArray = $c68ff14009c18bbc$var$toArray;
function $c68ff14009c18bbc$var$zero2(word) {
    if (word.length === 1) return "0" + word;
    else return word;
}
$c68ff14009c18bbc$var$utils.zero2 = $c68ff14009c18bbc$var$zero2;
function $c68ff14009c18bbc$var$toHex(msg) {
    var res = "";
    for(var i = 0; i < msg.length; i++)res += $c68ff14009c18bbc$var$zero2(msg[i].toString(16));
    return res;
}
$c68ff14009c18bbc$var$utils.toHex = $c68ff14009c18bbc$var$toHex;
$c68ff14009c18bbc$var$utils.encode = function encode(arr, enc) {
    if (enc === "hex") return $c68ff14009c18bbc$var$toHex(arr);
    else return arr;
};

});


parcelRequire.register("5Db4y", function(module, exports) {
"use strict";
var $41992f02fed52e49$var$curve = module.exports;

$41992f02fed52e49$var$curve.base = (parcelRequire("3FMSa"));

$41992f02fed52e49$var$curve.short = (parcelRequire("f5GrO"));

$41992f02fed52e49$var$curve.mont = (parcelRequire("6M4Qa"));

$41992f02fed52e49$var$curve.edwards = (parcelRequire("ilzyN"));

});
parcelRequire.register("3FMSa", function(module, exports) {
"use strict";

var $73nMH = parcelRequire("73nMH");

var $axXvD = parcelRequire("axXvD");
var $2acb1c8be09e2bc2$var$getNAF = $axXvD.getNAF;
var $2acb1c8be09e2bc2$var$getJSF = $axXvD.getJSF;
var $2acb1c8be09e2bc2$var$assert = $axXvD.assert;
function $2acb1c8be09e2bc2$var$BaseCurve(type, conf) {
    this.type = type;
    this.p = new $73nMH(conf.p, 16);
    // Use Montgomery, when there is no fast reduction for the prime
    this.red = conf.prime ? $73nMH.red(conf.prime) : $73nMH.mont(this.p);
    // Useful for many curves
    this.zero = new $73nMH(0).toRed(this.red);
    this.one = new $73nMH(1).toRed(this.red);
    this.two = new $73nMH(2).toRed(this.red);
    // Curve configuration, optional
    this.n = conf.n && new $73nMH(conf.n, 16);
    this.g = conf.g && this.pointFromJSON(conf.g, conf.gRed);
    // Temporary arrays
    this._wnafT1 = new Array(4);
    this._wnafT2 = new Array(4);
    this._wnafT3 = new Array(4);
    this._wnafT4 = new Array(4);
    this._bitLength = this.n ? this.n.bitLength() : 0;
    // Generalized Greg Maxwell's trick
    var adjustCount = this.n && this.p.div(this.n);
    if (!adjustCount || adjustCount.cmpn(100) > 0) this.redN = null;
    else {
        this._maxwellTrick = true;
        this.redN = this.n.toRed(this.red);
    }
}
module.exports = $2acb1c8be09e2bc2$var$BaseCurve;
$2acb1c8be09e2bc2$var$BaseCurve.prototype.point = function point() {
    throw new Error("Not implemented");
};
$2acb1c8be09e2bc2$var$BaseCurve.prototype.validate = function validate() {
    throw new Error("Not implemented");
};
$2acb1c8be09e2bc2$var$BaseCurve.prototype._fixedNafMul = function _fixedNafMul(p, k) {
    $2acb1c8be09e2bc2$var$assert(p.precomputed);
    var doubles = p._getDoubles();
    var naf = $2acb1c8be09e2bc2$var$getNAF(k, 1, this._bitLength);
    var I = (1 << doubles.step + 1) - (doubles.step % 2 === 0 ? 2 : 1);
    I /= 3;
    // Translate into more windowed form
    var repr = [];
    var j;
    var nafW;
    for(j = 0; j < naf.length; j += doubles.step){
        nafW = 0;
        for(var l = j + doubles.step - 1; l >= j; l--)nafW = (nafW << 1) + naf[l];
        repr.push(nafW);
    }
    var a = this.jpoint(null, null, null);
    var b = this.jpoint(null, null, null);
    for(var i = I; i > 0; i--){
        for(j = 0; j < repr.length; j++){
            nafW = repr[j];
            if (nafW === i) b = b.mixedAdd(doubles.points[j]);
            else if (nafW === -i) b = b.mixedAdd(doubles.points[j].neg());
        }
        a = a.add(b);
    }
    return a.toP();
};
$2acb1c8be09e2bc2$var$BaseCurve.prototype._wnafMul = function _wnafMul(p, k) {
    var w = 4;
    // Precompute window
    var nafPoints = p._getNAFPoints(w);
    w = nafPoints.wnd;
    var wnd = nafPoints.points;
    // Get NAF form
    var naf = $2acb1c8be09e2bc2$var$getNAF(k, w, this._bitLength);
    // Add `this`*(N+1) for every w-NAF index
    var acc = this.jpoint(null, null, null);
    for(var i = naf.length - 1; i >= 0; i--){
        // Count zeroes
        for(var l = 0; i >= 0 && naf[i] === 0; i--)l++;
        if (i >= 0) l++;
        acc = acc.dblp(l);
        if (i < 0) break;
        var z = naf[i];
        $2acb1c8be09e2bc2$var$assert(z !== 0);
        if (p.type === "affine") {
            // J +- P
            if (z > 0) acc = acc.mixedAdd(wnd[z - 1 >> 1]);
            else acc = acc.mixedAdd(wnd[-z - 1 >> 1].neg());
        } else // J +- J
        if (z > 0) acc = acc.add(wnd[z - 1 >> 1]);
        else acc = acc.add(wnd[-z - 1 >> 1].neg());
    }
    return p.type === "affine" ? acc.toP() : acc;
};
$2acb1c8be09e2bc2$var$BaseCurve.prototype._wnafMulAdd = function _wnafMulAdd(defW, points, coeffs, len, jacobianResult) {
    var wndWidth = this._wnafT1;
    var wnd = this._wnafT2;
    var naf = this._wnafT3;
    // Fill all arrays
    var max = 0;
    var i;
    var j;
    var p;
    for(i = 0; i < len; i++){
        p = points[i];
        var nafPoints = p._getNAFPoints(defW);
        wndWidth[i] = nafPoints.wnd;
        wnd[i] = nafPoints.points;
    }
    // Comb small window NAFs
    for(i = len - 1; i >= 1; i -= 2){
        var a = i - 1;
        var b = i;
        if (wndWidth[a] !== 1 || wndWidth[b] !== 1) {
            naf[a] = $2acb1c8be09e2bc2$var$getNAF(coeffs[a], wndWidth[a], this._bitLength);
            naf[b] = $2acb1c8be09e2bc2$var$getNAF(coeffs[b], wndWidth[b], this._bitLength);
            max = Math.max(naf[a].length, max);
            max = Math.max(naf[b].length, max);
            continue;
        }
        var comb = [
            points[a],
            /* 1 */ null,
            /* 3 */ null,
            /* 5 */ points[b]
        ];
        // Try to avoid Projective points, if possible
        if (points[a].y.cmp(points[b].y) === 0) {
            comb[1] = points[a].add(points[b]);
            comb[2] = points[a].toJ().mixedAdd(points[b].neg());
        } else if (points[a].y.cmp(points[b].y.redNeg()) === 0) {
            comb[1] = points[a].toJ().mixedAdd(points[b]);
            comb[2] = points[a].add(points[b].neg());
        } else {
            comb[1] = points[a].toJ().mixedAdd(points[b]);
            comb[2] = points[a].toJ().mixedAdd(points[b].neg());
        }
        var index = [
            -3,
            /* -1 -1 */ -1,
            /* -1 0 */ -5,
            /* -1 1 */ -7,
            /* 0 -1 */ 0,
            /* 0 0 */ 7,
            /* 0 1 */ 5,
            /* 1 -1 */ 1,
            /* 1 0 */ 3
        ];
        var jsf = $2acb1c8be09e2bc2$var$getJSF(coeffs[a], coeffs[b]);
        max = Math.max(jsf[0].length, max);
        naf[a] = new Array(max);
        naf[b] = new Array(max);
        for(j = 0; j < max; j++){
            var ja = jsf[0][j] | 0;
            var jb = jsf[1][j] | 0;
            naf[a][j] = index[(ja + 1) * 3 + (jb + 1)];
            naf[b][j] = 0;
            wnd[a] = comb;
        }
    }
    var acc = this.jpoint(null, null, null);
    var tmp = this._wnafT4;
    for(i = max; i >= 0; i--){
        var k = 0;
        while(i >= 0){
            var zero = true;
            for(j = 0; j < len; j++){
                tmp[j] = naf[j][i] | 0;
                if (tmp[j] !== 0) zero = false;
            }
            if (!zero) break;
            k++;
            i--;
        }
        if (i >= 0) k++;
        acc = acc.dblp(k);
        if (i < 0) break;
        for(j = 0; j < len; j++){
            var z = tmp[j];
            p;
            if (z === 0) continue;
            else if (z > 0) p = wnd[j][z - 1 >> 1];
            else if (z < 0) p = wnd[j][-z - 1 >> 1].neg();
            if (p.type === "affine") acc = acc.mixedAdd(p);
            else acc = acc.add(p);
        }
    }
    // Zeroify references
    for(i = 0; i < len; i++)wnd[i] = null;
    if (jacobianResult) return acc;
    else return acc.toP();
};
function $2acb1c8be09e2bc2$var$BasePoint(curve, type) {
    this.curve = curve;
    this.type = type;
    this.precomputed = null;
}
$2acb1c8be09e2bc2$var$BaseCurve.BasePoint = $2acb1c8be09e2bc2$var$BasePoint;
$2acb1c8be09e2bc2$var$BasePoint.prototype.eq = function eq() {
    throw new Error("Not implemented");
};
$2acb1c8be09e2bc2$var$BasePoint.prototype.validate = function validate() {
    return this.curve.validate(this);
};
$2acb1c8be09e2bc2$var$BaseCurve.prototype.decodePoint = function decodePoint(bytes, enc) {
    bytes = $axXvD.toArray(bytes, enc);
    var len = this.p.byteLength();
    // uncompressed, hybrid-odd, hybrid-even
    if ((bytes[0] === 0x04 || bytes[0] === 0x06 || bytes[0] === 0x07) && bytes.length - 1 === 2 * len) {
        if (bytes[0] === 0x06) $2acb1c8be09e2bc2$var$assert(bytes[bytes.length - 1] % 2 === 0);
        else if (bytes[0] === 0x07) $2acb1c8be09e2bc2$var$assert(bytes[bytes.length - 1] % 2 === 1);
        var res = this.point(bytes.slice(1, 1 + len), bytes.slice(1 + len, 1 + 2 * len));
        return res;
    } else if ((bytes[0] === 0x02 || bytes[0] === 0x03) && bytes.length - 1 === len) return this.pointFromX(bytes.slice(1, 1 + len), bytes[0] === 0x03);
    throw new Error("Unknown point format");
};
$2acb1c8be09e2bc2$var$BasePoint.prototype.encodeCompressed = function encodeCompressed(enc) {
    return this.encode(enc, true);
};
$2acb1c8be09e2bc2$var$BasePoint.prototype._encode = function _encode(compact) {
    var len = this.curve.p.byteLength();
    var x = this.getX().toArray("be", len);
    if (compact) return [
        this.getY().isEven() ? 0x02 : 0x03
    ].concat(x);
    return [
        0x04
    ].concat(x, this.getY().toArray("be", len));
};
$2acb1c8be09e2bc2$var$BasePoint.prototype.encode = function encode(enc, compact) {
    return $axXvD.encode(this._encode(compact), enc);
};
$2acb1c8be09e2bc2$var$BasePoint.prototype.precompute = function precompute(power) {
    if (this.precomputed) return this;
    var precomputed = {
        doubles: null,
        naf: null,
        beta: null
    };
    precomputed.naf = this._getNAFPoints(8);
    precomputed.doubles = this._getDoubles(4, power);
    precomputed.beta = this._getBeta();
    this.precomputed = precomputed;
    return this;
};
$2acb1c8be09e2bc2$var$BasePoint.prototype._hasDoubles = function _hasDoubles(k) {
    if (!this.precomputed) return false;
    var doubles = this.precomputed.doubles;
    if (!doubles) return false;
    return doubles.points.length >= Math.ceil((k.bitLength() + 1) / doubles.step);
};
$2acb1c8be09e2bc2$var$BasePoint.prototype._getDoubles = function _getDoubles(step, power) {
    if (this.precomputed && this.precomputed.doubles) return this.precomputed.doubles;
    var doubles = [
        this
    ];
    var acc = this;
    for(var i = 0; i < power; i += step){
        for(var j = 0; j < step; j++)acc = acc.dbl();
        doubles.push(acc);
    }
    return {
        step: step,
        points: doubles
    };
};
$2acb1c8be09e2bc2$var$BasePoint.prototype._getNAFPoints = function _getNAFPoints(wnd) {
    if (this.precomputed && this.precomputed.naf) return this.precomputed.naf;
    var res = [
        this
    ];
    var max = (1 << wnd) - 1;
    var dbl = max === 1 ? null : this.dbl();
    for(var i = 1; i < max; i++)res[i] = res[i - 1].add(dbl);
    return {
        wnd: wnd,
        points: res
    };
};
$2acb1c8be09e2bc2$var$BasePoint.prototype._getBeta = function _getBeta() {
    return null;
};
$2acb1c8be09e2bc2$var$BasePoint.prototype.dblp = function dblp(k) {
    var r = this;
    for(var i = 0; i < k; i++)r = r.dbl();
    return r;
};

});

parcelRequire.register("f5GrO", function(module, exports) {
"use strict";

var $axXvD = parcelRequire("axXvD");

var $73nMH = parcelRequire("73nMH");

var $5SAkX = parcelRequire("5SAkX");

var $3FMSa = parcelRequire("3FMSa");
var $afc83fd53de501af$var$assert = $axXvD.assert;
function $afc83fd53de501af$var$ShortCurve(conf) {
    $3FMSa.call(this, "short", conf);
    this.a = new $73nMH(conf.a, 16).toRed(this.red);
    this.b = new $73nMH(conf.b, 16).toRed(this.red);
    this.tinv = this.two.redInvm();
    this.zeroA = this.a.fromRed().cmpn(0) === 0;
    this.threeA = this.a.fromRed().sub(this.p).cmpn(-3) === 0;
    // If the curve is endomorphic, precalculate beta and lambda
    this.endo = this._getEndomorphism(conf);
    this._endoWnafT1 = new Array(4);
    this._endoWnafT2 = new Array(4);
}
$5SAkX($afc83fd53de501af$var$ShortCurve, $3FMSa);
module.exports = $afc83fd53de501af$var$ShortCurve;
$afc83fd53de501af$var$ShortCurve.prototype._getEndomorphism = function _getEndomorphism(conf) {
    // No efficient endomorphism
    if (!this.zeroA || !this.g || !this.n || this.p.modn(3) !== 1) return;
    // Compute beta and lambda, that lambda * P = (beta * Px; Py)
    var beta;
    var lambda;
    if (conf.beta) beta = new $73nMH(conf.beta, 16).toRed(this.red);
    else {
        var betas = this._getEndoRoots(this.p);
        // Choose the smallest beta
        beta = betas[0].cmp(betas[1]) < 0 ? betas[0] : betas[1];
        beta = beta.toRed(this.red);
    }
    if (conf.lambda) lambda = new $73nMH(conf.lambda, 16);
    else {
        // Choose the lambda that is matching selected beta
        var lambdas = this._getEndoRoots(this.n);
        if (this.g.mul(lambdas[0]).x.cmp(this.g.x.redMul(beta)) === 0) lambda = lambdas[0];
        else {
            lambda = lambdas[1];
            $afc83fd53de501af$var$assert(this.g.mul(lambda).x.cmp(this.g.x.redMul(beta)) === 0);
        }
    }
    // Get basis vectors, used for balanced length-two representation
    var basis;
    if (conf.basis) basis = conf.basis.map(function(vec) {
        return {
            a: new $73nMH(vec.a, 16),
            b: new $73nMH(vec.b, 16)
        };
    });
    else basis = this._getEndoBasis(lambda);
    return {
        beta: beta,
        lambda: lambda,
        basis: basis
    };
};
$afc83fd53de501af$var$ShortCurve.prototype._getEndoRoots = function _getEndoRoots(num) {
    // Find roots of for x^2 + x + 1 in F
    // Root = (-1 +- Sqrt(-3)) / 2
    //
    var red = num === this.p ? this.red : $73nMH.mont(num);
    var tinv = new $73nMH(2).toRed(red).redInvm();
    var ntinv = tinv.redNeg();
    var s = new $73nMH(3).toRed(red).redNeg().redSqrt().redMul(tinv);
    var l1 = ntinv.redAdd(s).fromRed();
    var l2 = ntinv.redSub(s).fromRed();
    return [
        l1,
        l2
    ];
};
$afc83fd53de501af$var$ShortCurve.prototype._getEndoBasis = function _getEndoBasis(lambda) {
    // aprxSqrt >= sqrt(this.n)
    var aprxSqrt = this.n.ushrn(Math.floor(this.n.bitLength() / 2));
    // 3.74
    // Run EGCD, until r(L + 1) < aprxSqrt
    var u = lambda;
    var v = this.n.clone();
    var x1 = new $73nMH(1);
    var y1 = new $73nMH(0);
    var x2 = new $73nMH(0);
    var y2 = new $73nMH(1);
    // NOTE: all vectors are roots of: a + b * lambda = 0 (mod n)
    var a0;
    var b0;
    // First vector
    var a1;
    var b1;
    // Second vector
    var a2;
    var b2;
    var prevR;
    var i = 0;
    var r;
    var x;
    while(u.cmpn(0) !== 0){
        var q = v.div(u);
        r = v.sub(q.mul(u));
        x = x2.sub(q.mul(x1));
        var y = y2.sub(q.mul(y1));
        if (!a1 && r.cmp(aprxSqrt) < 0) {
            a0 = prevR.neg();
            b0 = x1;
            a1 = r.neg();
            b1 = x;
        } else if (a1 && ++i === 2) break;
        prevR = r;
        v = u;
        u = r;
        x2 = x1;
        x1 = x;
        y2 = y1;
        y1 = y;
    }
    a2 = r.neg();
    b2 = x;
    var len1 = a1.sqr().add(b1.sqr());
    var len2 = a2.sqr().add(b2.sqr());
    if (len2.cmp(len1) >= 0) {
        a2 = a0;
        b2 = b0;
    }
    // Normalize signs
    if (a1.negative) {
        a1 = a1.neg();
        b1 = b1.neg();
    }
    if (a2.negative) {
        a2 = a2.neg();
        b2 = b2.neg();
    }
    return [
        {
            a: a1,
            b: b1
        },
        {
            a: a2,
            b: b2
        }
    ];
};
$afc83fd53de501af$var$ShortCurve.prototype._endoSplit = function _endoSplit(k) {
    var basis = this.endo.basis;
    var v1 = basis[0];
    var v2 = basis[1];
    var c1 = v2.b.mul(k).divRound(this.n);
    var c2 = v1.b.neg().mul(k).divRound(this.n);
    var p1 = c1.mul(v1.a);
    var p2 = c2.mul(v2.a);
    var q1 = c1.mul(v1.b);
    var q2 = c2.mul(v2.b);
    // Calculate answer
    var k1 = k.sub(p1).sub(p2);
    var k2 = q1.add(q2).neg();
    return {
        k1: k1,
        k2: k2
    };
};
$afc83fd53de501af$var$ShortCurve.prototype.pointFromX = function pointFromX(x, odd) {
    x = new $73nMH(x, 16);
    if (!x.red) x = x.toRed(this.red);
    var y2 = x.redSqr().redMul(x).redIAdd(x.redMul(this.a)).redIAdd(this.b);
    var y = y2.redSqrt();
    if (y.redSqr().redSub(y2).cmp(this.zero) !== 0) throw new Error("invalid point");
    // XXX Is there any way to tell if the number is odd without converting it
    // to non-red form?
    var isOdd = y.fromRed().isOdd();
    if (odd && !isOdd || !odd && isOdd) y = y.redNeg();
    return this.point(x, y);
};
$afc83fd53de501af$var$ShortCurve.prototype.validate = function validate(point) {
    if (point.inf) return true;
    var x = point.x;
    var y = point.y;
    var ax = this.a.redMul(x);
    var rhs = x.redSqr().redMul(x).redIAdd(ax).redIAdd(this.b);
    return y.redSqr().redISub(rhs).cmpn(0) === 0;
};
$afc83fd53de501af$var$ShortCurve.prototype._endoWnafMulAdd = function _endoWnafMulAdd(points, coeffs, jacobianResult) {
    var npoints = this._endoWnafT1;
    var ncoeffs = this._endoWnafT2;
    for(var i = 0; i < points.length; i++){
        var split = this._endoSplit(coeffs[i]);
        var p = points[i];
        var beta = p._getBeta();
        if (split.k1.negative) {
            split.k1.ineg();
            p = p.neg(true);
        }
        if (split.k2.negative) {
            split.k2.ineg();
            beta = beta.neg(true);
        }
        npoints[i * 2] = p;
        npoints[i * 2 + 1] = beta;
        ncoeffs[i * 2] = split.k1;
        ncoeffs[i * 2 + 1] = split.k2;
    }
    var res = this._wnafMulAdd(1, npoints, ncoeffs, i * 2, jacobianResult);
    // Clean-up references to points and coefficients
    for(var j = 0; j < i * 2; j++){
        npoints[j] = null;
        ncoeffs[j] = null;
    }
    return res;
};
function $afc83fd53de501af$var$Point(curve, x, y, isRed) {
    $3FMSa.BasePoint.call(this, curve, "affine");
    if (x === null && y === null) {
        this.x = null;
        this.y = null;
        this.inf = true;
    } else {
        this.x = new $73nMH(x, 16);
        this.y = new $73nMH(y, 16);
        // Force redgomery representation when loading from JSON
        if (isRed) {
            this.x.forceRed(this.curve.red);
            this.y.forceRed(this.curve.red);
        }
        if (!this.x.red) this.x = this.x.toRed(this.curve.red);
        if (!this.y.red) this.y = this.y.toRed(this.curve.red);
        this.inf = false;
    }
}
$5SAkX($afc83fd53de501af$var$Point, $3FMSa.BasePoint);
$afc83fd53de501af$var$ShortCurve.prototype.point = function point(x, y, isRed) {
    return new $afc83fd53de501af$var$Point(this, x, y, isRed);
};
$afc83fd53de501af$var$ShortCurve.prototype.pointFromJSON = function pointFromJSON(obj, red) {
    return $afc83fd53de501af$var$Point.fromJSON(this, obj, red);
};
$afc83fd53de501af$var$Point.prototype._getBeta = function _getBeta() {
    if (!this.curve.endo) return;
    var pre = this.precomputed;
    if (pre && pre.beta) return pre.beta;
    var beta = this.curve.point(this.x.redMul(this.curve.endo.beta), this.y);
    if (pre) {
        var curve = this.curve;
        var endoMul = function(p) {
            return curve.point(p.x.redMul(curve.endo.beta), p.y);
        };
        pre.beta = beta;
        beta.precomputed = {
            beta: null,
            naf: pre.naf && {
                wnd: pre.naf.wnd,
                points: pre.naf.points.map(endoMul)
            },
            doubles: pre.doubles && {
                step: pre.doubles.step,
                points: pre.doubles.points.map(endoMul)
            }
        };
    }
    return beta;
};
$afc83fd53de501af$var$Point.prototype.toJSON = function toJSON() {
    if (!this.precomputed) return [
        this.x,
        this.y
    ];
    return [
        this.x,
        this.y,
        this.precomputed && {
            doubles: this.precomputed.doubles && {
                step: this.precomputed.doubles.step,
                points: this.precomputed.doubles.points.slice(1)
            },
            naf: this.precomputed.naf && {
                wnd: this.precomputed.naf.wnd,
                points: this.precomputed.naf.points.slice(1)
            }
        }
    ];
};
$afc83fd53de501af$var$Point.fromJSON = function fromJSON(curve, obj, red) {
    if (typeof obj === "string") obj = JSON.parse(obj);
    var res = curve.point(obj[0], obj[1], red);
    if (!obj[2]) return res;
    function obj2point(obj) {
        return curve.point(obj[0], obj[1], red);
    }
    var pre = obj[2];
    res.precomputed = {
        beta: null,
        doubles: pre.doubles && {
            step: pre.doubles.step,
            points: [
                res
            ].concat(pre.doubles.points.map(obj2point))
        },
        naf: pre.naf && {
            wnd: pre.naf.wnd,
            points: [
                res
            ].concat(pre.naf.points.map(obj2point))
        }
    };
    return res;
};
$afc83fd53de501af$var$Point.prototype.inspect = function inspect() {
    if (this.isInfinity()) return "<EC Point Infinity>";
    return "<EC Point x: " + this.x.fromRed().toString(16, 2) + " y: " + this.y.fromRed().toString(16, 2) + ">";
};
$afc83fd53de501af$var$Point.prototype.isInfinity = function isInfinity() {
    return this.inf;
};
$afc83fd53de501af$var$Point.prototype.add = function add(p) {
    // O + P = P
    if (this.inf) return p;
    // P + O = P
    if (p.inf) return this;
    // P + P = 2P
    if (this.eq(p)) return this.dbl();
    // P + (-P) = O
    if (this.neg().eq(p)) return this.curve.point(null, null);
    // P + Q = O
    if (this.x.cmp(p.x) === 0) return this.curve.point(null, null);
    var c = this.y.redSub(p.y);
    if (c.cmpn(0) !== 0) c = c.redMul(this.x.redSub(p.x).redInvm());
    var nx = c.redSqr().redISub(this.x).redISub(p.x);
    var ny = c.redMul(this.x.redSub(nx)).redISub(this.y);
    return this.curve.point(nx, ny);
};
$afc83fd53de501af$var$Point.prototype.dbl = function dbl() {
    if (this.inf) return this;
    // 2P = O
    var ys1 = this.y.redAdd(this.y);
    if (ys1.cmpn(0) === 0) return this.curve.point(null, null);
    var a = this.curve.a;
    var x2 = this.x.redSqr();
    var dyinv = ys1.redInvm();
    var c = x2.redAdd(x2).redIAdd(x2).redIAdd(a).redMul(dyinv);
    var nx = c.redSqr().redISub(this.x.redAdd(this.x));
    var ny = c.redMul(this.x.redSub(nx)).redISub(this.y);
    return this.curve.point(nx, ny);
};
$afc83fd53de501af$var$Point.prototype.getX = function getX() {
    return this.x.fromRed();
};
$afc83fd53de501af$var$Point.prototype.getY = function getY() {
    return this.y.fromRed();
};
$afc83fd53de501af$var$Point.prototype.mul = function mul(k) {
    k = new $73nMH(k, 16);
    if (this.isInfinity()) return this;
    else if (this._hasDoubles(k)) return this.curve._fixedNafMul(this, k);
    else if (this.curve.endo) return this.curve._endoWnafMulAdd([
        this
    ], [
        k
    ]);
    else return this.curve._wnafMul(this, k);
};
$afc83fd53de501af$var$Point.prototype.mulAdd = function mulAdd(k1, p2, k2) {
    var points = [
        this,
        p2
    ];
    var coeffs = [
        k1,
        k2
    ];
    if (this.curve.endo) return this.curve._endoWnafMulAdd(points, coeffs);
    else return this.curve._wnafMulAdd(1, points, coeffs, 2);
};
$afc83fd53de501af$var$Point.prototype.jmulAdd = function jmulAdd(k1, p2, k2) {
    var points = [
        this,
        p2
    ];
    var coeffs = [
        k1,
        k2
    ];
    if (this.curve.endo) return this.curve._endoWnafMulAdd(points, coeffs, true);
    else return this.curve._wnafMulAdd(1, points, coeffs, 2, true);
};
$afc83fd53de501af$var$Point.prototype.eq = function eq(p) {
    return this === p || this.inf === p.inf && (this.inf || this.x.cmp(p.x) === 0 && this.y.cmp(p.y) === 0);
};
$afc83fd53de501af$var$Point.prototype.neg = function neg(_precompute) {
    if (this.inf) return this;
    var res = this.curve.point(this.x, this.y.redNeg());
    if (_precompute && this.precomputed) {
        var pre = this.precomputed;
        var negate = function(p) {
            return p.neg();
        };
        res.precomputed = {
            naf: pre.naf && {
                wnd: pre.naf.wnd,
                points: pre.naf.points.map(negate)
            },
            doubles: pre.doubles && {
                step: pre.doubles.step,
                points: pre.doubles.points.map(negate)
            }
        };
    }
    return res;
};
$afc83fd53de501af$var$Point.prototype.toJ = function toJ() {
    if (this.inf) return this.curve.jpoint(null, null, null);
    var res = this.curve.jpoint(this.x, this.y, this.curve.one);
    return res;
};
function $afc83fd53de501af$var$JPoint(curve, x, y, z) {
    $3FMSa.BasePoint.call(this, curve, "jacobian");
    if (x === null && y === null && z === null) {
        this.x = this.curve.one;
        this.y = this.curve.one;
        this.z = new $73nMH(0);
    } else {
        this.x = new $73nMH(x, 16);
        this.y = new $73nMH(y, 16);
        this.z = new $73nMH(z, 16);
    }
    if (!this.x.red) this.x = this.x.toRed(this.curve.red);
    if (!this.y.red) this.y = this.y.toRed(this.curve.red);
    if (!this.z.red) this.z = this.z.toRed(this.curve.red);
    this.zOne = this.z === this.curve.one;
}
$5SAkX($afc83fd53de501af$var$JPoint, $3FMSa.BasePoint);
$afc83fd53de501af$var$ShortCurve.prototype.jpoint = function jpoint(x, y, z) {
    return new $afc83fd53de501af$var$JPoint(this, x, y, z);
};
$afc83fd53de501af$var$JPoint.prototype.toP = function toP() {
    if (this.isInfinity()) return this.curve.point(null, null);
    var zinv = this.z.redInvm();
    var zinv2 = zinv.redSqr();
    var ax = this.x.redMul(zinv2);
    var ay = this.y.redMul(zinv2).redMul(zinv);
    return this.curve.point(ax, ay);
};
$afc83fd53de501af$var$JPoint.prototype.neg = function neg() {
    return this.curve.jpoint(this.x, this.y.redNeg(), this.z);
};
$afc83fd53de501af$var$JPoint.prototype.add = function add(p) {
    // O + P = P
    if (this.isInfinity()) return p;
    // P + O = P
    if (p.isInfinity()) return this;
    // 12M + 4S + 7A
    var pz2 = p.z.redSqr();
    var z2 = this.z.redSqr();
    var u1 = this.x.redMul(pz2);
    var u2 = p.x.redMul(z2);
    var s1 = this.y.redMul(pz2.redMul(p.z));
    var s2 = p.y.redMul(z2.redMul(this.z));
    var h = u1.redSub(u2);
    var r = s1.redSub(s2);
    if (h.cmpn(0) === 0) {
        if (r.cmpn(0) !== 0) return this.curve.jpoint(null, null, null);
        else return this.dbl();
    }
    var h2 = h.redSqr();
    var h3 = h2.redMul(h);
    var v = u1.redMul(h2);
    var nx = r.redSqr().redIAdd(h3).redISub(v).redISub(v);
    var ny = r.redMul(v.redISub(nx)).redISub(s1.redMul(h3));
    var nz = this.z.redMul(p.z).redMul(h);
    return this.curve.jpoint(nx, ny, nz);
};
$afc83fd53de501af$var$JPoint.prototype.mixedAdd = function mixedAdd(p) {
    // O + P = P
    if (this.isInfinity()) return p.toJ();
    // P + O = P
    if (p.isInfinity()) return this;
    // 8M + 3S + 7A
    var z2 = this.z.redSqr();
    var u1 = this.x;
    var u2 = p.x.redMul(z2);
    var s1 = this.y;
    var s2 = p.y.redMul(z2).redMul(this.z);
    var h = u1.redSub(u2);
    var r = s1.redSub(s2);
    if (h.cmpn(0) === 0) {
        if (r.cmpn(0) !== 0) return this.curve.jpoint(null, null, null);
        else return this.dbl();
    }
    var h2 = h.redSqr();
    var h3 = h2.redMul(h);
    var v = u1.redMul(h2);
    var nx = r.redSqr().redIAdd(h3).redISub(v).redISub(v);
    var ny = r.redMul(v.redISub(nx)).redISub(s1.redMul(h3));
    var nz = this.z.redMul(h);
    return this.curve.jpoint(nx, ny, nz);
};
$afc83fd53de501af$var$JPoint.prototype.dblp = function dblp(pow) {
    if (pow === 0) return this;
    if (this.isInfinity()) return this;
    if (!pow) return this.dbl();
    var i;
    if (this.curve.zeroA || this.curve.threeA) {
        var r = this;
        for(i = 0; i < pow; i++)r = r.dbl();
        return r;
    }
    // 1M + 2S + 1A + N * (4S + 5M + 8A)
    // N = 1 => 6M + 6S + 9A
    var a = this.curve.a;
    var tinv = this.curve.tinv;
    var jx = this.x;
    var jy = this.y;
    var jz = this.z;
    var jz4 = jz.redSqr().redSqr();
    // Reuse results
    var jyd = jy.redAdd(jy);
    for(i = 0; i < pow; i++){
        var jx2 = jx.redSqr();
        var jyd2 = jyd.redSqr();
        var jyd4 = jyd2.redSqr();
        var c = jx2.redAdd(jx2).redIAdd(jx2).redIAdd(a.redMul(jz4));
        var t1 = jx.redMul(jyd2);
        var nx = c.redSqr().redISub(t1.redAdd(t1));
        var t2 = t1.redISub(nx);
        var dny = c.redMul(t2);
        dny = dny.redIAdd(dny).redISub(jyd4);
        var nz = jyd.redMul(jz);
        if (i + 1 < pow) jz4 = jz4.redMul(jyd4);
        jx = nx;
        jz = nz;
        jyd = dny;
    }
    return this.curve.jpoint(jx, jyd.redMul(tinv), jz);
};
$afc83fd53de501af$var$JPoint.prototype.dbl = function dbl() {
    if (this.isInfinity()) return this;
    if (this.curve.zeroA) return this._zeroDbl();
    else if (this.curve.threeA) return this._threeDbl();
    else return this._dbl();
};
$afc83fd53de501af$var$JPoint.prototype._zeroDbl = function _zeroDbl() {
    var nx;
    var ny;
    var nz;
    // Z = 1
    if (this.zOne) {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html
        //     #doubling-mdbl-2007-bl
        // 1M + 5S + 14A
        // XX = X1^2
        var xx = this.x.redSqr();
        // YY = Y1^2
        var yy = this.y.redSqr();
        // YYYY = YY^2
        var yyyy = yy.redSqr();
        // S = 2 * ((X1 + YY)^2 - XX - YYYY)
        var s = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
        s = s.redIAdd(s);
        // M = 3 * XX + a; a = 0
        var m = xx.redAdd(xx).redIAdd(xx);
        // T = M ^ 2 - 2*S
        var t = m.redSqr().redISub(s).redISub(s);
        // 8 * YYYY
        var yyyy8 = yyyy.redIAdd(yyyy);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        // X3 = T
        nx = t;
        // Y3 = M * (S - T) - 8 * YYYY
        ny = m.redMul(s.redISub(t)).redISub(yyyy8);
        // Z3 = 2*Y1
        nz = this.y.redAdd(this.y);
    } else {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html
        //     #doubling-dbl-2009-l
        // 2M + 5S + 13A
        // A = X1^2
        var a = this.x.redSqr();
        // B = Y1^2
        var b = this.y.redSqr();
        // C = B^2
        var c = b.redSqr();
        // D = 2 * ((X1 + B)^2 - A - C)
        var d = this.x.redAdd(b).redSqr().redISub(a).redISub(c);
        d = d.redIAdd(d);
        // E = 3 * A
        var e = a.redAdd(a).redIAdd(a);
        // F = E^2
        var f = e.redSqr();
        // 8 * C
        var c8 = c.redIAdd(c);
        c8 = c8.redIAdd(c8);
        c8 = c8.redIAdd(c8);
        // X3 = F - 2 * D
        nx = f.redISub(d).redISub(d);
        // Y3 = E * (D - X3) - 8 * C
        ny = e.redMul(d.redISub(nx)).redISub(c8);
        // Z3 = 2 * Y1 * Z1
        nz = this.y.redMul(this.z);
        nz = nz.redIAdd(nz);
    }
    return this.curve.jpoint(nx, ny, nz);
};
$afc83fd53de501af$var$JPoint.prototype._threeDbl = function _threeDbl() {
    var nx;
    var ny;
    var nz;
    // Z = 1
    if (this.zOne) {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-3.html
        //     #doubling-mdbl-2007-bl
        // 1M + 5S + 15A
        // XX = X1^2
        var xx = this.x.redSqr();
        // YY = Y1^2
        var yy = this.y.redSqr();
        // YYYY = YY^2
        var yyyy = yy.redSqr();
        // S = 2 * ((X1 + YY)^2 - XX - YYYY)
        var s = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
        s = s.redIAdd(s);
        // M = 3 * XX + a
        var m = xx.redAdd(xx).redIAdd(xx).redIAdd(this.curve.a);
        // T = M^2 - 2 * S
        var t = m.redSqr().redISub(s).redISub(s);
        // X3 = T
        nx = t;
        // Y3 = M * (S - T) - 8 * YYYY
        var yyyy8 = yyyy.redIAdd(yyyy);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        ny = m.redMul(s.redISub(t)).redISub(yyyy8);
        // Z3 = 2 * Y1
        nz = this.y.redAdd(this.y);
    } else {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-3.html#doubling-dbl-2001-b
        // 3M + 5S
        // delta = Z1^2
        var delta = this.z.redSqr();
        // gamma = Y1^2
        var gamma = this.y.redSqr();
        // beta = X1 * gamma
        var beta = this.x.redMul(gamma);
        // alpha = 3 * (X1 - delta) * (X1 + delta)
        var alpha = this.x.redSub(delta).redMul(this.x.redAdd(delta));
        alpha = alpha.redAdd(alpha).redIAdd(alpha);
        // X3 = alpha^2 - 8 * beta
        var beta4 = beta.redIAdd(beta);
        beta4 = beta4.redIAdd(beta4);
        var beta8 = beta4.redAdd(beta4);
        nx = alpha.redSqr().redISub(beta8);
        // Z3 = (Y1 + Z1)^2 - gamma - delta
        nz = this.y.redAdd(this.z).redSqr().redISub(gamma).redISub(delta);
        // Y3 = alpha * (4 * beta - X3) - 8 * gamma^2
        var ggamma8 = gamma.redSqr();
        ggamma8 = ggamma8.redIAdd(ggamma8);
        ggamma8 = ggamma8.redIAdd(ggamma8);
        ggamma8 = ggamma8.redIAdd(ggamma8);
        ny = alpha.redMul(beta4.redISub(nx)).redISub(ggamma8);
    }
    return this.curve.jpoint(nx, ny, nz);
};
$afc83fd53de501af$var$JPoint.prototype._dbl = function _dbl() {
    var a = this.curve.a;
    // 4M + 6S + 10A
    var jx = this.x;
    var jy = this.y;
    var jz = this.z;
    var jz4 = jz.redSqr().redSqr();
    var jx2 = jx.redSqr();
    var jy2 = jy.redSqr();
    var c = jx2.redAdd(jx2).redIAdd(jx2).redIAdd(a.redMul(jz4));
    var jxd4 = jx.redAdd(jx);
    jxd4 = jxd4.redIAdd(jxd4);
    var t1 = jxd4.redMul(jy2);
    var nx = c.redSqr().redISub(t1.redAdd(t1));
    var t2 = t1.redISub(nx);
    var jyd8 = jy2.redSqr();
    jyd8 = jyd8.redIAdd(jyd8);
    jyd8 = jyd8.redIAdd(jyd8);
    jyd8 = jyd8.redIAdd(jyd8);
    var ny = c.redMul(t2).redISub(jyd8);
    var nz = jy.redAdd(jy).redMul(jz);
    return this.curve.jpoint(nx, ny, nz);
};
$afc83fd53de501af$var$JPoint.prototype.trpl = function trpl() {
    if (!this.curve.zeroA) return this.dbl().add(this);
    // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html#tripling-tpl-2007-bl
    // 5M + 10S + ...
    // XX = X1^2
    var xx = this.x.redSqr();
    // YY = Y1^2
    var yy = this.y.redSqr();
    // ZZ = Z1^2
    var zz = this.z.redSqr();
    // YYYY = YY^2
    var yyyy = yy.redSqr();
    // M = 3 * XX + a * ZZ2; a = 0
    var m = xx.redAdd(xx).redIAdd(xx);
    // MM = M^2
    var mm = m.redSqr();
    // E = 6 * ((X1 + YY)^2 - XX - YYYY) - MM
    var e = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
    e = e.redIAdd(e);
    e = e.redAdd(e).redIAdd(e);
    e = e.redISub(mm);
    // EE = E^2
    var ee = e.redSqr();
    // T = 16*YYYY
    var t = yyyy.redIAdd(yyyy);
    t = t.redIAdd(t);
    t = t.redIAdd(t);
    t = t.redIAdd(t);
    // U = (M + E)^2 - MM - EE - T
    var u = m.redIAdd(e).redSqr().redISub(mm).redISub(ee).redISub(t);
    // X3 = 4 * (X1 * EE - 4 * YY * U)
    var yyu4 = yy.redMul(u);
    yyu4 = yyu4.redIAdd(yyu4);
    yyu4 = yyu4.redIAdd(yyu4);
    var nx = this.x.redMul(ee).redISub(yyu4);
    nx = nx.redIAdd(nx);
    nx = nx.redIAdd(nx);
    // Y3 = 8 * Y1 * (U * (T - U) - E * EE)
    var ny = this.y.redMul(u.redMul(t.redISub(u)).redISub(e.redMul(ee)));
    ny = ny.redIAdd(ny);
    ny = ny.redIAdd(ny);
    ny = ny.redIAdd(ny);
    // Z3 = (Z1 + E)^2 - ZZ - EE
    var nz = this.z.redAdd(e).redSqr().redISub(zz).redISub(ee);
    return this.curve.jpoint(nx, ny, nz);
};
$afc83fd53de501af$var$JPoint.prototype.mul = function mul(k, kbase) {
    k = new $73nMH(k, kbase);
    return this.curve._wnafMul(this, k);
};
$afc83fd53de501af$var$JPoint.prototype.eq = function eq(p) {
    if (p.type === "affine") return this.eq(p.toJ());
    if (this === p) return true;
    // x1 * z2^2 == x2 * z1^2
    var z2 = this.z.redSqr();
    var pz2 = p.z.redSqr();
    if (this.x.redMul(pz2).redISub(p.x.redMul(z2)).cmpn(0) !== 0) return false;
    // y1 * z2^3 == y2 * z1^3
    var z3 = z2.redMul(this.z);
    var pz3 = pz2.redMul(p.z);
    return this.y.redMul(pz3).redISub(p.y.redMul(z3)).cmpn(0) === 0;
};
$afc83fd53de501af$var$JPoint.prototype.eqXToP = function eqXToP(x) {
    var zs = this.z.redSqr();
    var rx = x.toRed(this.curve.red).redMul(zs);
    if (this.x.cmp(rx) === 0) return true;
    var xc = x.clone();
    var t = this.curve.redN.redMul(zs);
    for(;;){
        xc.iadd(this.curve.n);
        if (xc.cmp(this.curve.p) >= 0) return false;
        rx.redIAdd(t);
        if (this.x.cmp(rx) === 0) return true;
    }
};
$afc83fd53de501af$var$JPoint.prototype.inspect = function inspect() {
    if (this.isInfinity()) return "<EC JPoint Infinity>";
    return "<EC JPoint x: " + this.x.toString(16, 2) + " y: " + this.y.toString(16, 2) + " z: " + this.z.toString(16, 2) + ">";
};
$afc83fd53de501af$var$JPoint.prototype.isInfinity = function isInfinity() {
    // XXX This code assumes that zero is always zero in red
    return this.z.cmpn(0) === 0;
};

});

parcelRequire.register("6M4Qa", function(module, exports) {
"use strict";

var $73nMH = parcelRequire("73nMH");

var $5SAkX = parcelRequire("5SAkX");

var $3FMSa = parcelRequire("3FMSa");

var $axXvD = parcelRequire("axXvD");
function $4eeafafca83bdc09$var$MontCurve(conf) {
    $3FMSa.call(this, "mont", conf);
    this.a = new $73nMH(conf.a, 16).toRed(this.red);
    this.b = new $73nMH(conf.b, 16).toRed(this.red);
    this.i4 = new $73nMH(4).toRed(this.red).redInvm();
    this.two = new $73nMH(2).toRed(this.red);
    this.a24 = this.i4.redMul(this.a.redAdd(this.two));
}
$5SAkX($4eeafafca83bdc09$var$MontCurve, $3FMSa);
module.exports = $4eeafafca83bdc09$var$MontCurve;
$4eeafafca83bdc09$var$MontCurve.prototype.validate = function validate(point) {
    var x = point.normalize().x;
    var x2 = x.redSqr();
    var rhs = x2.redMul(x).redAdd(x2.redMul(this.a)).redAdd(x);
    var y = rhs.redSqrt();
    return y.redSqr().cmp(rhs) === 0;
};
function $4eeafafca83bdc09$var$Point(curve, x, z) {
    $3FMSa.BasePoint.call(this, curve, "projective");
    if (x === null && z === null) {
        this.x = this.curve.one;
        this.z = this.curve.zero;
    } else {
        this.x = new $73nMH(x, 16);
        this.z = new $73nMH(z, 16);
        if (!this.x.red) this.x = this.x.toRed(this.curve.red);
        if (!this.z.red) this.z = this.z.toRed(this.curve.red);
    }
}
$5SAkX($4eeafafca83bdc09$var$Point, $3FMSa.BasePoint);
$4eeafafca83bdc09$var$MontCurve.prototype.decodePoint = function decodePoint(bytes, enc) {
    return this.point($axXvD.toArray(bytes, enc), 1);
};
$4eeafafca83bdc09$var$MontCurve.prototype.point = function point(x, z) {
    return new $4eeafafca83bdc09$var$Point(this, x, z);
};
$4eeafafca83bdc09$var$MontCurve.prototype.pointFromJSON = function pointFromJSON(obj) {
    return $4eeafafca83bdc09$var$Point.fromJSON(this, obj);
};
$4eeafafca83bdc09$var$Point.prototype.precompute = function precompute() {
// No-op
};
$4eeafafca83bdc09$var$Point.prototype._encode = function _encode() {
    return this.getX().toArray("be", this.curve.p.byteLength());
};
$4eeafafca83bdc09$var$Point.fromJSON = function fromJSON(curve, obj) {
    return new $4eeafafca83bdc09$var$Point(curve, obj[0], obj[1] || curve.one);
};
$4eeafafca83bdc09$var$Point.prototype.inspect = function inspect() {
    if (this.isInfinity()) return "<EC Point Infinity>";
    return "<EC Point x: " + this.x.fromRed().toString(16, 2) + " z: " + this.z.fromRed().toString(16, 2) + ">";
};
$4eeafafca83bdc09$var$Point.prototype.isInfinity = function isInfinity() {
    // XXX This code assumes that zero is always zero in red
    return this.z.cmpn(0) === 0;
};
$4eeafafca83bdc09$var$Point.prototype.dbl = function dbl() {
    // http://hyperelliptic.org/EFD/g1p/auto-montgom-xz.html#doubling-dbl-1987-m-3
    // 2M + 2S + 4A
    // A = X1 + Z1
    var a = this.x.redAdd(this.z);
    // AA = A^2
    var aa = a.redSqr();
    // B = X1 - Z1
    var b = this.x.redSub(this.z);
    // BB = B^2
    var bb = b.redSqr();
    // C = AA - BB
    var c = aa.redSub(bb);
    // X3 = AA * BB
    var nx = aa.redMul(bb);
    // Z3 = C * (BB + A24 * C)
    var nz = c.redMul(bb.redAdd(this.curve.a24.redMul(c)));
    return this.curve.point(nx, nz);
};
$4eeafafca83bdc09$var$Point.prototype.add = function add() {
    throw new Error("Not supported on Montgomery curve");
};
$4eeafafca83bdc09$var$Point.prototype.diffAdd = function diffAdd(p, diff) {
    // http://hyperelliptic.org/EFD/g1p/auto-montgom-xz.html#diffadd-dadd-1987-m-3
    // 4M + 2S + 6A
    // A = X2 + Z2
    var a = this.x.redAdd(this.z);
    // B = X2 - Z2
    var b = this.x.redSub(this.z);
    // C = X3 + Z3
    var c = p.x.redAdd(p.z);
    // D = X3 - Z3
    var d = p.x.redSub(p.z);
    // DA = D * A
    var da = d.redMul(a);
    // CB = C * B
    var cb = c.redMul(b);
    // X5 = Z1 * (DA + CB)^2
    var nx = diff.z.redMul(da.redAdd(cb).redSqr());
    // Z5 = X1 * (DA - CB)^2
    var nz = diff.x.redMul(da.redISub(cb).redSqr());
    return this.curve.point(nx, nz);
};
$4eeafafca83bdc09$var$Point.prototype.mul = function mul(k) {
    var t = k.clone();
    var a = this; // (N / 2) * Q + Q
    var b = this.curve.point(null, null); // (N / 2) * Q
    var c = this; // Q
    for(var bits = []; t.cmpn(0) !== 0; t.iushrn(1))bits.push(t.andln(1));
    for(var i = bits.length - 1; i >= 0; i--)if (bits[i] === 0) {
        // N * Q + Q = ((N / 2) * Q + Q)) + (N / 2) * Q
        a = a.diffAdd(b, c);
        // N * Q = 2 * ((N / 2) * Q + Q))
        b = b.dbl();
    } else {
        // N * Q = ((N / 2) * Q + Q) + ((N / 2) * Q)
        b = a.diffAdd(b, c);
        // N * Q + Q = 2 * ((N / 2) * Q + Q)
        a = a.dbl();
    }
    return b;
};
$4eeafafca83bdc09$var$Point.prototype.mulAdd = function mulAdd() {
    throw new Error("Not supported on Montgomery curve");
};
$4eeafafca83bdc09$var$Point.prototype.jumlAdd = function jumlAdd() {
    throw new Error("Not supported on Montgomery curve");
};
$4eeafafca83bdc09$var$Point.prototype.eq = function eq(other) {
    return this.getX().cmp(other.getX()) === 0;
};
$4eeafafca83bdc09$var$Point.prototype.normalize = function normalize() {
    this.x = this.x.redMul(this.z.redInvm());
    this.z = this.curve.one;
    return this;
};
$4eeafafca83bdc09$var$Point.prototype.getX = function getX() {
    // Normalize coordinates
    this.normalize();
    return this.x.fromRed();
};

});

parcelRequire.register("ilzyN", function(module, exports) {
"use strict";

var $axXvD = parcelRequire("axXvD");

var $73nMH = parcelRequire("73nMH");

var $5SAkX = parcelRequire("5SAkX");

var $3FMSa = parcelRequire("3FMSa");
var $d5b5c5a9e10cba37$var$assert = $axXvD.assert;
function $d5b5c5a9e10cba37$var$EdwardsCurve(conf) {
    // NOTE: Important as we are creating point in Base.call()
    this.twisted = (conf.a | 0) !== 1;
    this.mOneA = this.twisted && (conf.a | 0) === -1;
    this.extended = this.mOneA;
    $3FMSa.call(this, "edwards", conf);
    this.a = new $73nMH(conf.a, 16).umod(this.red.m);
    this.a = this.a.toRed(this.red);
    this.c = new $73nMH(conf.c, 16).toRed(this.red);
    this.c2 = this.c.redSqr();
    this.d = new $73nMH(conf.d, 16).toRed(this.red);
    this.dd = this.d.redAdd(this.d);
    $d5b5c5a9e10cba37$var$assert(!this.twisted || this.c.fromRed().cmpn(1) === 0);
    this.oneC = (conf.c | 0) === 1;
}
$5SAkX($d5b5c5a9e10cba37$var$EdwardsCurve, $3FMSa);
module.exports = $d5b5c5a9e10cba37$var$EdwardsCurve;
$d5b5c5a9e10cba37$var$EdwardsCurve.prototype._mulA = function _mulA(num) {
    if (this.mOneA) return num.redNeg();
    else return this.a.redMul(num);
};
$d5b5c5a9e10cba37$var$EdwardsCurve.prototype._mulC = function _mulC(num) {
    if (this.oneC) return num;
    else return this.c.redMul(num);
};
// Just for compatibility with Short curve
$d5b5c5a9e10cba37$var$EdwardsCurve.prototype.jpoint = function jpoint(x, y, z, t) {
    return this.point(x, y, z, t);
};
$d5b5c5a9e10cba37$var$EdwardsCurve.prototype.pointFromX = function pointFromX(x, odd) {
    x = new $73nMH(x, 16);
    if (!x.red) x = x.toRed(this.red);
    var x2 = x.redSqr();
    var rhs = this.c2.redSub(this.a.redMul(x2));
    var lhs = this.one.redSub(this.c2.redMul(this.d).redMul(x2));
    var y2 = rhs.redMul(lhs.redInvm());
    var y = y2.redSqrt();
    if (y.redSqr().redSub(y2).cmp(this.zero) !== 0) throw new Error("invalid point");
    var isOdd = y.fromRed().isOdd();
    if (odd && !isOdd || !odd && isOdd) y = y.redNeg();
    return this.point(x, y);
};
$d5b5c5a9e10cba37$var$EdwardsCurve.prototype.pointFromY = function pointFromY(y, odd) {
    y = new $73nMH(y, 16);
    if (!y.red) y = y.toRed(this.red);
    // x^2 = (y^2 - c^2) / (c^2 d y^2 - a)
    var y2 = y.redSqr();
    var lhs = y2.redSub(this.c2);
    var rhs = y2.redMul(this.d).redMul(this.c2).redSub(this.a);
    var x2 = lhs.redMul(rhs.redInvm());
    if (x2.cmp(this.zero) === 0) {
        if (odd) throw new Error("invalid point");
        else return this.point(this.zero, y);
    }
    var x = x2.redSqrt();
    if (x.redSqr().redSub(x2).cmp(this.zero) !== 0) throw new Error("invalid point");
    if (x.fromRed().isOdd() !== odd) x = x.redNeg();
    return this.point(x, y);
};
$d5b5c5a9e10cba37$var$EdwardsCurve.prototype.validate = function validate(point) {
    if (point.isInfinity()) return true;
    // Curve: A * X^2 + Y^2 = C^2 * (1 + D * X^2 * Y^2)
    point.normalize();
    var x2 = point.x.redSqr();
    var y2 = point.y.redSqr();
    var lhs = x2.redMul(this.a).redAdd(y2);
    var rhs = this.c2.redMul(this.one.redAdd(this.d.redMul(x2).redMul(y2)));
    return lhs.cmp(rhs) === 0;
};
function $d5b5c5a9e10cba37$var$Point(curve, x, y, z, t) {
    $3FMSa.BasePoint.call(this, curve, "projective");
    if (x === null && y === null && z === null) {
        this.x = this.curve.zero;
        this.y = this.curve.one;
        this.z = this.curve.one;
        this.t = this.curve.zero;
        this.zOne = true;
    } else {
        this.x = new $73nMH(x, 16);
        this.y = new $73nMH(y, 16);
        this.z = z ? new $73nMH(z, 16) : this.curve.one;
        this.t = t && new $73nMH(t, 16);
        if (!this.x.red) this.x = this.x.toRed(this.curve.red);
        if (!this.y.red) this.y = this.y.toRed(this.curve.red);
        if (!this.z.red) this.z = this.z.toRed(this.curve.red);
        if (this.t && !this.t.red) this.t = this.t.toRed(this.curve.red);
        this.zOne = this.z === this.curve.one;
        // Use extended coordinates
        if (this.curve.extended && !this.t) {
            this.t = this.x.redMul(this.y);
            if (!this.zOne) this.t = this.t.redMul(this.z.redInvm());
        }
    }
}
$5SAkX($d5b5c5a9e10cba37$var$Point, $3FMSa.BasePoint);
$d5b5c5a9e10cba37$var$EdwardsCurve.prototype.pointFromJSON = function pointFromJSON(obj) {
    return $d5b5c5a9e10cba37$var$Point.fromJSON(this, obj);
};
$d5b5c5a9e10cba37$var$EdwardsCurve.prototype.point = function point(x, y, z, t) {
    return new $d5b5c5a9e10cba37$var$Point(this, x, y, z, t);
};
$d5b5c5a9e10cba37$var$Point.fromJSON = function fromJSON(curve, obj) {
    return new $d5b5c5a9e10cba37$var$Point(curve, obj[0], obj[1], obj[2]);
};
$d5b5c5a9e10cba37$var$Point.prototype.inspect = function inspect() {
    if (this.isInfinity()) return "<EC Point Infinity>";
    return "<EC Point x: " + this.x.fromRed().toString(16, 2) + " y: " + this.y.fromRed().toString(16, 2) + " z: " + this.z.fromRed().toString(16, 2) + ">";
};
$d5b5c5a9e10cba37$var$Point.prototype.isInfinity = function isInfinity() {
    // XXX This code assumes that zero is always zero in red
    return this.x.cmpn(0) === 0 && (this.y.cmp(this.z) === 0 || this.zOne && this.y.cmp(this.curve.c) === 0);
};
$d5b5c5a9e10cba37$var$Point.prototype._extDbl = function _extDbl() {
    // hyperelliptic.org/EFD/g1p/auto-twisted-extended-1.html
    //     #doubling-dbl-2008-hwcd
    // 4M + 4S
    // A = X1^2
    var a = this.x.redSqr();
    // B = Y1^2
    var b = this.y.redSqr();
    // C = 2 * Z1^2
    var c = this.z.redSqr();
    c = c.redIAdd(c);
    // D = a * A
    var d = this.curve._mulA(a);
    // E = (X1 + Y1)^2 - A - B
    var e = this.x.redAdd(this.y).redSqr().redISub(a).redISub(b);
    // G = D + B
    var g = d.redAdd(b);
    // F = G - C
    var f = g.redSub(c);
    // H = D - B
    var h = d.redSub(b);
    // X3 = E * F
    var nx = e.redMul(f);
    // Y3 = G * H
    var ny = g.redMul(h);
    // T3 = E * H
    var nt = e.redMul(h);
    // Z3 = F * G
    var nz = f.redMul(g);
    return this.curve.point(nx, ny, nz, nt);
};
$d5b5c5a9e10cba37$var$Point.prototype._projDbl = function _projDbl() {
    // hyperelliptic.org/EFD/g1p/auto-twisted-projective.html
    //     #doubling-dbl-2008-bbjlp
    //     #doubling-dbl-2007-bl
    // and others
    // Generally 3M + 4S or 2M + 4S
    // B = (X1 + Y1)^2
    var b = this.x.redAdd(this.y).redSqr();
    // C = X1^2
    var c = this.x.redSqr();
    // D = Y1^2
    var d = this.y.redSqr();
    var nx;
    var ny;
    var nz;
    var e;
    var h;
    var j;
    if (this.curve.twisted) {
        // E = a * C
        e = this.curve._mulA(c);
        // F = E + D
        var f = e.redAdd(d);
        if (this.zOne) {
            // X3 = (B - C - D) * (F - 2)
            nx = b.redSub(c).redSub(d).redMul(f.redSub(this.curve.two));
            // Y3 = F * (E - D)
            ny = f.redMul(e.redSub(d));
            // Z3 = F^2 - 2 * F
            nz = f.redSqr().redSub(f).redSub(f);
        } else {
            // H = Z1^2
            h = this.z.redSqr();
            // J = F - 2 * H
            j = f.redSub(h).redISub(h);
            // X3 = (B-C-D)*J
            nx = b.redSub(c).redISub(d).redMul(j);
            // Y3 = F * (E - D)
            ny = f.redMul(e.redSub(d));
            // Z3 = F * J
            nz = f.redMul(j);
        }
    } else {
        // E = C + D
        e = c.redAdd(d);
        // H = (c * Z1)^2
        h = this.curve._mulC(this.z).redSqr();
        // J = E - 2 * H
        j = e.redSub(h).redSub(h);
        // X3 = c * (B - E) * J
        nx = this.curve._mulC(b.redISub(e)).redMul(j);
        // Y3 = c * E * (C - D)
        ny = this.curve._mulC(e).redMul(c.redISub(d));
        // Z3 = E * J
        nz = e.redMul(j);
    }
    return this.curve.point(nx, ny, nz);
};
$d5b5c5a9e10cba37$var$Point.prototype.dbl = function dbl() {
    if (this.isInfinity()) return this;
    // Double in extended coordinates
    if (this.curve.extended) return this._extDbl();
    else return this._projDbl();
};
$d5b5c5a9e10cba37$var$Point.prototype._extAdd = function _extAdd(p) {
    // hyperelliptic.org/EFD/g1p/auto-twisted-extended-1.html
    //     #addition-add-2008-hwcd-3
    // 8M
    // A = (Y1 - X1) * (Y2 - X2)
    var a = this.y.redSub(this.x).redMul(p.y.redSub(p.x));
    // B = (Y1 + X1) * (Y2 + X2)
    var b = this.y.redAdd(this.x).redMul(p.y.redAdd(p.x));
    // C = T1 * k * T2
    var c = this.t.redMul(this.curve.dd).redMul(p.t);
    // D = Z1 * 2 * Z2
    var d = this.z.redMul(p.z.redAdd(p.z));
    // E = B - A
    var e = b.redSub(a);
    // F = D - C
    var f = d.redSub(c);
    // G = D + C
    var g = d.redAdd(c);
    // H = B + A
    var h = b.redAdd(a);
    // X3 = E * F
    var nx = e.redMul(f);
    // Y3 = G * H
    var ny = g.redMul(h);
    // T3 = E * H
    var nt = e.redMul(h);
    // Z3 = F * G
    var nz = f.redMul(g);
    return this.curve.point(nx, ny, nz, nt);
};
$d5b5c5a9e10cba37$var$Point.prototype._projAdd = function _projAdd(p) {
    // hyperelliptic.org/EFD/g1p/auto-twisted-projective.html
    //     #addition-add-2008-bbjlp
    //     #addition-add-2007-bl
    // 10M + 1S
    // A = Z1 * Z2
    var a = this.z.redMul(p.z);
    // B = A^2
    var b = a.redSqr();
    // C = X1 * X2
    var c = this.x.redMul(p.x);
    // D = Y1 * Y2
    var d = this.y.redMul(p.y);
    // E = d * C * D
    var e = this.curve.d.redMul(c).redMul(d);
    // F = B - E
    var f = b.redSub(e);
    // G = B + E
    var g = b.redAdd(e);
    // X3 = A * F * ((X1 + Y1) * (X2 + Y2) - C - D)
    var tmp = this.x.redAdd(this.y).redMul(p.x.redAdd(p.y)).redISub(c).redISub(d);
    var nx = a.redMul(f).redMul(tmp);
    var ny;
    var nz;
    if (this.curve.twisted) {
        // Y3 = A * G * (D - a * C)
        ny = a.redMul(g).redMul(d.redSub(this.curve._mulA(c)));
        // Z3 = F * G
        nz = f.redMul(g);
    } else {
        // Y3 = A * G * (D - C)
        ny = a.redMul(g).redMul(d.redSub(c));
        // Z3 = c * F * G
        nz = this.curve._mulC(f).redMul(g);
    }
    return this.curve.point(nx, ny, nz);
};
$d5b5c5a9e10cba37$var$Point.prototype.add = function add(p) {
    if (this.isInfinity()) return p;
    if (p.isInfinity()) return this;
    if (this.curve.extended) return this._extAdd(p);
    else return this._projAdd(p);
};
$d5b5c5a9e10cba37$var$Point.prototype.mul = function mul(k) {
    if (this._hasDoubles(k)) return this.curve._fixedNafMul(this, k);
    else return this.curve._wnafMul(this, k);
};
$d5b5c5a9e10cba37$var$Point.prototype.mulAdd = function mulAdd(k1, p, k2) {
    return this.curve._wnafMulAdd(1, [
        this,
        p
    ], [
        k1,
        k2
    ], 2, false);
};
$d5b5c5a9e10cba37$var$Point.prototype.jmulAdd = function jmulAdd(k1, p, k2) {
    return this.curve._wnafMulAdd(1, [
        this,
        p
    ], [
        k1,
        k2
    ], 2, true);
};
$d5b5c5a9e10cba37$var$Point.prototype.normalize = function normalize() {
    if (this.zOne) return this;
    // Normalize coordinates
    var zi = this.z.redInvm();
    this.x = this.x.redMul(zi);
    this.y = this.y.redMul(zi);
    if (this.t) this.t = this.t.redMul(zi);
    this.z = this.curve.one;
    this.zOne = true;
    return this;
};
$d5b5c5a9e10cba37$var$Point.prototype.neg = function neg() {
    return this.curve.point(this.x.redNeg(), this.y, this.z, this.t && this.t.redNeg());
};
$d5b5c5a9e10cba37$var$Point.prototype.getX = function getX() {
    this.normalize();
    return this.x.fromRed();
};
$d5b5c5a9e10cba37$var$Point.prototype.getY = function getY() {
    this.normalize();
    return this.y.fromRed();
};
$d5b5c5a9e10cba37$var$Point.prototype.eq = function eq(other) {
    return this === other || this.getX().cmp(other.getX()) === 0 && this.getY().cmp(other.getY()) === 0;
};
$d5b5c5a9e10cba37$var$Point.prototype.eqXToP = function eqXToP(x) {
    var rx = x.toRed(this.curve.red).redMul(this.z);
    if (this.x.cmp(rx) === 0) return true;
    var xc = x.clone();
    var t = this.curve.redN.redMul(this.z);
    for(;;){
        xc.iadd(this.curve.n);
        if (xc.cmp(this.curve.p) >= 0) return false;
        rx.redIAdd(t);
        if (this.x.cmp(rx) === 0) return true;
    }
};
// Compatibility with BaseCurve
$d5b5c5a9e10cba37$var$Point.prototype.toP = $d5b5c5a9e10cba37$var$Point.prototype.normalize;
$d5b5c5a9e10cba37$var$Point.prototype.mixedAdd = $d5b5c5a9e10cba37$var$Point.prototype.add;

});


parcelRequire.register("lkAVm", function(module, exports) {
"use strict";
var $f8781b963c05f36e$var$curves = module.exports;

var $3RPTD = parcelRequire("3RPTD");

var $5Db4y = parcelRequire("5Db4y");

var $axXvD = parcelRequire("axXvD");
var $f8781b963c05f36e$var$assert = $axXvD.assert;
function $f8781b963c05f36e$var$PresetCurve(options) {
    if (options.type === "short") this.curve = new $5Db4y.short(options);
    else if (options.type === "edwards") this.curve = new $5Db4y.edwards(options);
    else this.curve = new $5Db4y.mont(options);
    this.g = this.curve.g;
    this.n = this.curve.n;
    this.hash = options.hash;
    $f8781b963c05f36e$var$assert(this.g.validate(), "Invalid curve");
    $f8781b963c05f36e$var$assert(this.g.mul(this.n).isInfinity(), "Invalid curve, G*N != O");
}
$f8781b963c05f36e$var$curves.PresetCurve = $f8781b963c05f36e$var$PresetCurve;
function $f8781b963c05f36e$var$defineCurve(name, options) {
    Object.defineProperty($f8781b963c05f36e$var$curves, name, {
        configurable: true,
        enumerable: true,
        get: function() {
            var curve = new $f8781b963c05f36e$var$PresetCurve(options);
            Object.defineProperty($f8781b963c05f36e$var$curves, name, {
                configurable: true,
                enumerable: true,
                value: curve
            });
            return curve;
        }
    });
}
$f8781b963c05f36e$var$defineCurve("p192", {
    type: "short",
    prime: "p192",
    p: "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff",
    a: "ffffffff ffffffff ffffffff fffffffe ffffffff fffffffc",
    b: "64210519 e59c80e7 0fa7e9ab 72243049 feb8deec c146b9b1",
    n: "ffffffff ffffffff ffffffff 99def836 146bc9b1 b4d22831",
    hash: $3RPTD.sha256,
    gRed: false,
    g: [
        "188da80e b03090f6 7cbf20eb 43a18800 f4ff0afd 82ff1012",
        "07192b95 ffc8da78 631011ed 6b24cdd5 73f977a1 1e794811"
    ]
});
$f8781b963c05f36e$var$defineCurve("p224", {
    type: "short",
    prime: "p224",
    p: "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001",
    a: "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff fffffffe",
    b: "b4050a85 0c04b3ab f5413256 5044b0b7 d7bfd8ba 270b3943 2355ffb4",
    n: "ffffffff ffffffff ffffffff ffff16a2 e0b8f03e 13dd2945 5c5c2a3d",
    hash: $3RPTD.sha256,
    gRed: false,
    g: [
        "b70e0cbd 6bb4bf7f 321390b9 4a03c1d3 56c21122 343280d6 115c1d21",
        "bd376388 b5f723fb 4c22dfe6 cd4375a0 5a074764 44d58199 85007e34"
    ]
});
$f8781b963c05f36e$var$defineCurve("p256", {
    type: "short",
    prime: null,
    p: "ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff ffffffff",
    a: "ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff fffffffc",
    b: "5ac635d8 aa3a93e7 b3ebbd55 769886bc 651d06b0 cc53b0f6 3bce3c3e 27d2604b",
    n: "ffffffff 00000000 ffffffff ffffffff bce6faad a7179e84 f3b9cac2 fc632551",
    hash: $3RPTD.sha256,
    gRed: false,
    g: [
        "6b17d1f2 e12c4247 f8bce6e5 63a440f2 77037d81 2deb33a0 f4a13945 d898c296",
        "4fe342e2 fe1a7f9b 8ee7eb4a 7c0f9e16 2bce3357 6b315ece cbb64068 37bf51f5"
    ]
});
$f8781b963c05f36e$var$defineCurve("p384", {
    type: "short",
    prime: null,
    p: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 ffffffff",
    a: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 fffffffc",
    b: "b3312fa7 e23ee7e4 988e056b e3f82d19 181d9c6e fe814112 0314088f 5013875a c656398d 8a2ed19d 2a85c8ed d3ec2aef",
    n: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff c7634d81 f4372ddf 581a0db2 48b0a77a ecec196a ccc52973",
    hash: $3RPTD.sha384,
    gRed: false,
    g: [
        "aa87ca22 be8b0537 8eb1c71e f320ad74 6e1d3b62 8ba79b98 59f741e0 82542a38 5502f25d bf55296c 3a545e38 72760ab7",
        "3617de4a 96262c6f 5d9e98bf 9292dc29 f8f41dbd 289a147c e9da3113 b5f0b8c0 0a60b1ce 1d7e819d 7a431d7c 90ea0e5f"
    ]
});
$f8781b963c05f36e$var$defineCurve("p521", {
    type: "short",
    prime: null,
    p: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff",
    a: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffc",
    b: "00000051 953eb961 8e1c9a1f 929a21a0 b68540ee a2da725b 99b315f3 b8b48991 8ef109e1 56193951 ec7e937b 1652c0bd 3bb1bf07 3573df88 3d2c34f1 ef451fd4 6b503f00",
    n: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffa 51868783 bf2f966b 7fcc0148 f709a5d0 3bb5c9b8 899c47ae bb6fb71e 91386409",
    hash: $3RPTD.sha512,
    gRed: false,
    g: [
        "000000c6 858e06b7 0404e9cd 9e3ecb66 2395b442 9c648139 053fb521 f828af60 6b4d3dba a14b5e77 efe75928 fe1dc127 a2ffa8de 3348b3c1 856a429b f97e7e31 c2e5bd66",
        "00000118 39296a78 9a3bc004 5c8a5fb4 2c7d1bd9 98f54449 579b4468 17afbd17 273e662c 97ee7299 5ef42640 c550b901 3fad0761 353c7086 a272c240 88be9476 9fd16650"
    ]
});
$f8781b963c05f36e$var$defineCurve("curve25519", {
    type: "mont",
    prime: "p25519",
    p: "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed",
    a: "76d06",
    b: "1",
    n: "1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed",
    hash: $3RPTD.sha256,
    gRed: false,
    g: [
        "9"
    ]
});
$f8781b963c05f36e$var$defineCurve("ed25519", {
    type: "edwards",
    prime: "p25519",
    p: "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed",
    a: "-1",
    c: "1",
    // -121665 * (121666^(-1)) (mod P)
    d: "52036cee2b6ffe73 8cc740797779e898 00700a4d4141d8ab 75eb4dca135978a3",
    n: "1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed",
    hash: $3RPTD.sha256,
    gRed: false,
    g: [
        "216936d3cd6e53fec0a4e231fdd6dc5c692cc7609525a7b2c9562d608f25d51a",
        // 4/5
        "6666666666666666666666666666666666666666666666666666666666666658"
    ]
});
var $f8781b963c05f36e$var$pre;

try {
    $f8781b963c05f36e$var$pre = (parcelRequire("fT3YI"));
} catch (e) {
    $f8781b963c05f36e$var$pre = undefined;
}
$f8781b963c05f36e$var$defineCurve("secp256k1", {
    type: "short",
    prime: "k256",
    p: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f",
    a: "0",
    b: "7",
    n: "ffffffff ffffffff ffffffff fffffffe baaedce6 af48a03b bfd25e8c d0364141",
    h: "1",
    hash: $3RPTD.sha256,
    // Precomputed endomorphism
    beta: "7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee",
    lambda: "5363ad4cc05c30e0a5261c028812645a122e22ea20816678df02967c1b23bd72",
    basis: [
        {
            a: "3086d221a7d46bcde86c90e49284eb15",
            b: "-e4437ed6010e88286f547fa90abfe4c3"
        },
        {
            a: "114ca50f7a8e2f3f657c1108d9d44cfd8",
            b: "3086d221a7d46bcde86c90e49284eb15"
        }
    ],
    gRed: false,
    g: [
        "79be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798",
        "483ada7726a3c4655da4fbfc0e1108a8fd17b448a68554199c47d08ffb10d4b8",
        $f8781b963c05f36e$var$pre
    ]
});

});
parcelRequire.register("3RPTD", function(module, exports) {
var $2d0e93df7c0f044d$var$hash = module.exports;

$2d0e93df7c0f044d$var$hash.utils = (parcelRequire("cSGZk"));

$2d0e93df7c0f044d$var$hash.common = (parcelRequire("5J6OM"));

$2d0e93df7c0f044d$var$hash.sha = (parcelRequire("4z0yO"));

$2d0e93df7c0f044d$var$hash.ripemd = (parcelRequire("hbdMe"));

$2d0e93df7c0f044d$var$hash.hmac = (parcelRequire("7HBWL"));
// Proxy hash functions to the main object
$2d0e93df7c0f044d$var$hash.sha1 = $2d0e93df7c0f044d$var$hash.sha.sha1;
$2d0e93df7c0f044d$var$hash.sha256 = $2d0e93df7c0f044d$var$hash.sha.sha256;
$2d0e93df7c0f044d$var$hash.sha224 = $2d0e93df7c0f044d$var$hash.sha.sha224;
$2d0e93df7c0f044d$var$hash.sha384 = $2d0e93df7c0f044d$var$hash.sha.sha384;
$2d0e93df7c0f044d$var$hash.sha512 = $2d0e93df7c0f044d$var$hash.sha.sha512;
$2d0e93df7c0f044d$var$hash.ripemd160 = $2d0e93df7c0f044d$var$hash.ripemd.ripemd160;

});
parcelRequire.register("cSGZk", function(module, exports) {

$parcel$export(module.exports, "inherits", () => $960bdfb664b57d47$export$69f1b2dcda23c5f8, (v) => $960bdfb664b57d47$export$69f1b2dcda23c5f8 = v);
$parcel$export(module.exports, "toArray", () => $960bdfb664b57d47$export$45b10814cc054894, (v) => $960bdfb664b57d47$export$45b10814cc054894 = v);
$parcel$export(module.exports, "toHex", () => $960bdfb664b57d47$export$7ea66e3774a60b67, (v) => $960bdfb664b57d47$export$7ea66e3774a60b67 = v);
$parcel$export(module.exports, "htonl", () => $960bdfb664b57d47$export$34a52f00f601f6f1, (v) => $960bdfb664b57d47$export$34a52f00f601f6f1 = v);
$parcel$export(module.exports, "toHex32", () => $960bdfb664b57d47$export$812b0cbd5e8a72ab, (v) => $960bdfb664b57d47$export$812b0cbd5e8a72ab = v);
$parcel$export(module.exports, "zero2", () => $960bdfb664b57d47$export$f24f9e11d63bb314, (v) => $960bdfb664b57d47$export$f24f9e11d63bb314 = v);
$parcel$export(module.exports, "zero8", () => $960bdfb664b57d47$export$b71357c7e07ca1f1, (v) => $960bdfb664b57d47$export$b71357c7e07ca1f1 = v);
$parcel$export(module.exports, "join32", () => $960bdfb664b57d47$export$2e58a4b541fdcbe8, (v) => $960bdfb664b57d47$export$2e58a4b541fdcbe8 = v);
$parcel$export(module.exports, "split32", () => $960bdfb664b57d47$export$183b950bde9faab8, (v) => $960bdfb664b57d47$export$183b950bde9faab8 = v);
$parcel$export(module.exports, "rotr32", () => $960bdfb664b57d47$export$4785c77169fea59e, (v) => $960bdfb664b57d47$export$4785c77169fea59e = v);
$parcel$export(module.exports, "rotl32", () => $960bdfb664b57d47$export$242a185dfcffac5b, (v) => $960bdfb664b57d47$export$242a185dfcffac5b = v);
$parcel$export(module.exports, "sum32", () => $960bdfb664b57d47$export$58c04ae0ae31877d, (v) => $960bdfb664b57d47$export$58c04ae0ae31877d = v);
$parcel$export(module.exports, "sum32_3", () => $960bdfb664b57d47$export$d058ca695f8c6f11, (v) => $960bdfb664b57d47$export$d058ca695f8c6f11 = v);
$parcel$export(module.exports, "sum32_4", () => $960bdfb664b57d47$export$a1efd7fc3e986367, (v) => $960bdfb664b57d47$export$a1efd7fc3e986367 = v);
$parcel$export(module.exports, "sum32_5", () => $960bdfb664b57d47$export$bbfea4a2b5abaab4, (v) => $960bdfb664b57d47$export$bbfea4a2b5abaab4 = v);
$parcel$export(module.exports, "sum64", () => $960bdfb664b57d47$export$97ad4afc7de86152, (v) => $960bdfb664b57d47$export$97ad4afc7de86152 = v);
$parcel$export(module.exports, "sum64_hi", () => $960bdfb664b57d47$export$ce4673d9a79f6a4b, (v) => $960bdfb664b57d47$export$ce4673d9a79f6a4b = v);
$parcel$export(module.exports, "sum64_lo", () => $960bdfb664b57d47$export$786cc99fc6eedc0b, (v) => $960bdfb664b57d47$export$786cc99fc6eedc0b = v);
$parcel$export(module.exports, "sum64_4_hi", () => $960bdfb664b57d47$export$45c59b9a1848dd0, (v) => $960bdfb664b57d47$export$45c59b9a1848dd0 = v);
$parcel$export(module.exports, "sum64_4_lo", () => $960bdfb664b57d47$export$50d8f613e76d3034, (v) => $960bdfb664b57d47$export$50d8f613e76d3034 = v);
$parcel$export(module.exports, "sum64_5_hi", () => $960bdfb664b57d47$export$b8e83683c60ee162, (v) => $960bdfb664b57d47$export$b8e83683c60ee162 = v);
$parcel$export(module.exports, "sum64_5_lo", () => $960bdfb664b57d47$export$aeeb51790d1bcc4a, (v) => $960bdfb664b57d47$export$aeeb51790d1bcc4a = v);
$parcel$export(module.exports, "rotr64_hi", () => $960bdfb664b57d47$export$bb7c616f719ad9c, (v) => $960bdfb664b57d47$export$bb7c616f719ad9c = v);
$parcel$export(module.exports, "rotr64_lo", () => $960bdfb664b57d47$export$4d63290824f9d7df, (v) => $960bdfb664b57d47$export$4d63290824f9d7df = v);
$parcel$export(module.exports, "shr64_hi", () => $960bdfb664b57d47$export$2f64ceb90ef28ea1, (v) => $960bdfb664b57d47$export$2f64ceb90ef28ea1 = v);
$parcel$export(module.exports, "shr64_lo", () => $960bdfb664b57d47$export$8d2089d465f6d10d, (v) => $960bdfb664b57d47$export$8d2089d465f6d10d = v);
var $960bdfb664b57d47$export$69f1b2dcda23c5f8;
var $960bdfb664b57d47$export$45b10814cc054894;
var $960bdfb664b57d47$export$7ea66e3774a60b67;
var $960bdfb664b57d47$export$34a52f00f601f6f1;
var $960bdfb664b57d47$export$812b0cbd5e8a72ab;
var $960bdfb664b57d47$export$f24f9e11d63bb314;
var $960bdfb664b57d47$export$b71357c7e07ca1f1;
var $960bdfb664b57d47$export$2e58a4b541fdcbe8;
var $960bdfb664b57d47$export$183b950bde9faab8;
var $960bdfb664b57d47$export$4785c77169fea59e;
var $960bdfb664b57d47$export$242a185dfcffac5b;
var $960bdfb664b57d47$export$58c04ae0ae31877d;
var $960bdfb664b57d47$export$d058ca695f8c6f11;
var $960bdfb664b57d47$export$a1efd7fc3e986367;
var $960bdfb664b57d47$export$bbfea4a2b5abaab4;
var $960bdfb664b57d47$export$97ad4afc7de86152;
var $960bdfb664b57d47$export$ce4673d9a79f6a4b;
var $960bdfb664b57d47$export$786cc99fc6eedc0b;
var $960bdfb664b57d47$export$45c59b9a1848dd0;
var $960bdfb664b57d47$export$50d8f613e76d3034;
var $960bdfb664b57d47$export$b8e83683c60ee162;
var $960bdfb664b57d47$export$aeeb51790d1bcc4a;
var $960bdfb664b57d47$export$bb7c616f719ad9c;
var $960bdfb664b57d47$export$4d63290824f9d7df;
var $960bdfb664b57d47$export$2f64ceb90ef28ea1;
var $960bdfb664b57d47$export$8d2089d465f6d10d;
"use strict";

var $93fa9 = parcelRequire("93fa9");

var $5SAkX = parcelRequire("5SAkX");
$960bdfb664b57d47$export$69f1b2dcda23c5f8 = $5SAkX;
function $960bdfb664b57d47$var$isSurrogatePair(msg, i) {
    if ((msg.charCodeAt(i) & 0xFC00) !== 0xD800) return false;
    if (i < 0 || i + 1 >= msg.length) return false;
    return (msg.charCodeAt(i + 1) & 0xFC00) === 0xDC00;
}
function $960bdfb664b57d47$var$toArray(msg, enc) {
    if (Array.isArray(msg)) return msg.slice();
    if (!msg) return [];
    var res = [];
    if (typeof msg === "string") {
        if (!enc) {
            // Inspired by stringToUtf8ByteArray() in closure-library by Google
            // https://github.com/google/closure-library/blob/8598d87242af59aac233270742c8984e2b2bdbe0/closure/goog/crypt/crypt.js#L117-L143
            // Apache License 2.0
            // https://github.com/google/closure-library/blob/master/LICENSE
            var p = 0;
            for(var i = 0; i < msg.length; i++){
                var c = msg.charCodeAt(i);
                if (c < 128) res[p++] = c;
                else if (c < 2048) {
                    res[p++] = c >> 6 | 192;
                    res[p++] = c & 63 | 128;
                } else if ($960bdfb664b57d47$var$isSurrogatePair(msg, i)) {
                    c = 0x10000 + ((c & 0x03FF) << 10) + (msg.charCodeAt(++i) & 0x03FF);
                    res[p++] = c >> 18 | 240;
                    res[p++] = c >> 12 & 63 | 128;
                    res[p++] = c >> 6 & 63 | 128;
                    res[p++] = c & 63 | 128;
                } else {
                    res[p++] = c >> 12 | 224;
                    res[p++] = c >> 6 & 63 | 128;
                    res[p++] = c & 63 | 128;
                }
            }
        } else if (enc === "hex") {
            msg = msg.replace(/[^a-z0-9]+/ig, "");
            if (msg.length % 2 !== 0) msg = "0" + msg;
            for(i = 0; i < msg.length; i += 2)res.push(parseInt(msg[i] + msg[i + 1], 16));
        }
    } else for(i = 0; i < msg.length; i++)res[i] = msg[i] | 0;
    return res;
}
$960bdfb664b57d47$export$45b10814cc054894 = $960bdfb664b57d47$var$toArray;
function $960bdfb664b57d47$var$toHex(msg) {
    var res = "";
    for(var i = 0; i < msg.length; i++)res += $960bdfb664b57d47$var$zero2(msg[i].toString(16));
    return res;
}
$960bdfb664b57d47$export$7ea66e3774a60b67 = $960bdfb664b57d47$var$toHex;
function $960bdfb664b57d47$var$htonl(w) {
    var res = w >>> 24 | w >>> 8 & 0xff00 | w << 8 & 0xff0000 | (w & 0xff) << 24;
    return res >>> 0;
}
$960bdfb664b57d47$export$34a52f00f601f6f1 = $960bdfb664b57d47$var$htonl;
function $960bdfb664b57d47$var$toHex32(msg, endian) {
    var res = "";
    for(var i = 0; i < msg.length; i++){
        var w = msg[i];
        if (endian === "little") w = $960bdfb664b57d47$var$htonl(w);
        res += $960bdfb664b57d47$var$zero8(w.toString(16));
    }
    return res;
}
$960bdfb664b57d47$export$812b0cbd5e8a72ab = $960bdfb664b57d47$var$toHex32;
function $960bdfb664b57d47$var$zero2(word) {
    if (word.length === 1) return "0" + word;
    else return word;
}
$960bdfb664b57d47$export$f24f9e11d63bb314 = $960bdfb664b57d47$var$zero2;
function $960bdfb664b57d47$var$zero8(word) {
    if (word.length === 7) return "0" + word;
    else if (word.length === 6) return "00" + word;
    else if (word.length === 5) return "000" + word;
    else if (word.length === 4) return "0000" + word;
    else if (word.length === 3) return "00000" + word;
    else if (word.length === 2) return "000000" + word;
    else if (word.length === 1) return "0000000" + word;
    else return word;
}
$960bdfb664b57d47$export$b71357c7e07ca1f1 = $960bdfb664b57d47$var$zero8;
function $960bdfb664b57d47$var$join32(msg, start, end, endian) {
    var len = end - start;
    $93fa9(len % 4 === 0);
    var res = new Array(len / 4);
    for(var i = 0, k = start; i < res.length; i++, k += 4){
        var w;
        if (endian === "big") w = msg[k] << 24 | msg[k + 1] << 16 | msg[k + 2] << 8 | msg[k + 3];
        else w = msg[k + 3] << 24 | msg[k + 2] << 16 | msg[k + 1] << 8 | msg[k];
        res[i] = w >>> 0;
    }
    return res;
}
$960bdfb664b57d47$export$2e58a4b541fdcbe8 = $960bdfb664b57d47$var$join32;
function $960bdfb664b57d47$var$split32(msg, endian) {
    var res = new Array(msg.length * 4);
    for(var i = 0, k = 0; i < msg.length; i++, k += 4){
        var m = msg[i];
        if (endian === "big") {
            res[k] = m >>> 24;
            res[k + 1] = m >>> 16 & 0xff;
            res[k + 2] = m >>> 8 & 0xff;
            res[k + 3] = m & 0xff;
        } else {
            res[k + 3] = m >>> 24;
            res[k + 2] = m >>> 16 & 0xff;
            res[k + 1] = m >>> 8 & 0xff;
            res[k] = m & 0xff;
        }
    }
    return res;
}
$960bdfb664b57d47$export$183b950bde9faab8 = $960bdfb664b57d47$var$split32;
function $960bdfb664b57d47$var$rotr32(w, b) {
    return w >>> b | w << 32 - b;
}
$960bdfb664b57d47$export$4785c77169fea59e = $960bdfb664b57d47$var$rotr32;
function $960bdfb664b57d47$var$rotl32(w, b) {
    return w << b | w >>> 32 - b;
}
$960bdfb664b57d47$export$242a185dfcffac5b = $960bdfb664b57d47$var$rotl32;
function $960bdfb664b57d47$var$sum32(a, b) {
    return a + b >>> 0;
}
$960bdfb664b57d47$export$58c04ae0ae31877d = $960bdfb664b57d47$var$sum32;
function $960bdfb664b57d47$var$sum32_3(a, b, c) {
    return a + b + c >>> 0;
}
$960bdfb664b57d47$export$d058ca695f8c6f11 = $960bdfb664b57d47$var$sum32_3;
function $960bdfb664b57d47$var$sum32_4(a, b, c, d) {
    return a + b + c + d >>> 0;
}
$960bdfb664b57d47$export$a1efd7fc3e986367 = $960bdfb664b57d47$var$sum32_4;
function $960bdfb664b57d47$var$sum32_5(a, b, c, d, e) {
    return a + b + c + d + e >>> 0;
}
$960bdfb664b57d47$export$bbfea4a2b5abaab4 = $960bdfb664b57d47$var$sum32_5;
function $960bdfb664b57d47$var$sum64(buf, pos, ah, al) {
    var bh = buf[pos];
    var bl = buf[pos + 1];
    var lo = al + bl >>> 0;
    var hi = (lo < al ? 1 : 0) + ah + bh;
    buf[pos] = hi >>> 0;
    buf[pos + 1] = lo;
}
$960bdfb664b57d47$export$97ad4afc7de86152 = $960bdfb664b57d47$var$sum64;
function $960bdfb664b57d47$var$sum64_hi(ah, al, bh, bl) {
    var lo = al + bl >>> 0;
    var hi = (lo < al ? 1 : 0) + ah + bh;
    return hi >>> 0;
}
$960bdfb664b57d47$export$ce4673d9a79f6a4b = $960bdfb664b57d47$var$sum64_hi;
function $960bdfb664b57d47$var$sum64_lo(ah, al, bh, bl) {
    var lo = al + bl;
    return lo >>> 0;
}
$960bdfb664b57d47$export$786cc99fc6eedc0b = $960bdfb664b57d47$var$sum64_lo;
function $960bdfb664b57d47$var$sum64_4_hi(ah, al, bh, bl, ch, cl, dh, dl) {
    var carry = 0;
    var lo = al;
    lo = lo + bl >>> 0;
    carry += lo < al ? 1 : 0;
    lo = lo + cl >>> 0;
    carry += lo < cl ? 1 : 0;
    lo = lo + dl >>> 0;
    carry += lo < dl ? 1 : 0;
    var hi = ah + bh + ch + dh + carry;
    return hi >>> 0;
}
$960bdfb664b57d47$export$45c59b9a1848dd0 = $960bdfb664b57d47$var$sum64_4_hi;
function $960bdfb664b57d47$var$sum64_4_lo(ah, al, bh, bl, ch, cl, dh, dl) {
    var lo = al + bl + cl + dl;
    return lo >>> 0;
}
$960bdfb664b57d47$export$50d8f613e76d3034 = $960bdfb664b57d47$var$sum64_4_lo;
function $960bdfb664b57d47$var$sum64_5_hi(ah, al, bh, bl, ch, cl, dh, dl, eh, el) {
    var carry = 0;
    var lo = al;
    lo = lo + bl >>> 0;
    carry += lo < al ? 1 : 0;
    lo = lo + cl >>> 0;
    carry += lo < cl ? 1 : 0;
    lo = lo + dl >>> 0;
    carry += lo < dl ? 1 : 0;
    lo = lo + el >>> 0;
    carry += lo < el ? 1 : 0;
    var hi = ah + bh + ch + dh + eh + carry;
    return hi >>> 0;
}
$960bdfb664b57d47$export$b8e83683c60ee162 = $960bdfb664b57d47$var$sum64_5_hi;
function $960bdfb664b57d47$var$sum64_5_lo(ah, al, bh, bl, ch, cl, dh, dl, eh, el) {
    var lo = al + bl + cl + dl + el;
    return lo >>> 0;
}
$960bdfb664b57d47$export$aeeb51790d1bcc4a = $960bdfb664b57d47$var$sum64_5_lo;
function $960bdfb664b57d47$var$rotr64_hi(ah, al, num) {
    var r = al << 32 - num | ah >>> num;
    return r >>> 0;
}
$960bdfb664b57d47$export$bb7c616f719ad9c = $960bdfb664b57d47$var$rotr64_hi;
function $960bdfb664b57d47$var$rotr64_lo(ah, al, num) {
    var r = ah << 32 - num | al >>> num;
    return r >>> 0;
}
$960bdfb664b57d47$export$4d63290824f9d7df = $960bdfb664b57d47$var$rotr64_lo;
function $960bdfb664b57d47$var$shr64_hi(ah, al, num) {
    return ah >>> num;
}
$960bdfb664b57d47$export$2f64ceb90ef28ea1 = $960bdfb664b57d47$var$shr64_hi;
function $960bdfb664b57d47$var$shr64_lo(ah, al, num) {
    var r = ah << 32 - num | al >>> num;
    return r >>> 0;
}
$960bdfb664b57d47$export$8d2089d465f6d10d = $960bdfb664b57d47$var$shr64_lo;

});

parcelRequire.register("5J6OM", function(module, exports) {

$parcel$export(module.exports, "BlockHash", () => $42b671a1d92bd7d4$export$8687658379b577e6, (v) => $42b671a1d92bd7d4$export$8687658379b577e6 = v);
var $42b671a1d92bd7d4$export$8687658379b577e6;
"use strict";

var $cSGZk = parcelRequire("cSGZk");

var $93fa9 = parcelRequire("93fa9");
function $42b671a1d92bd7d4$var$BlockHash() {
    this.pending = null;
    this.pendingTotal = 0;
    this.blockSize = this.constructor.blockSize;
    this.outSize = this.constructor.outSize;
    this.hmacStrength = this.constructor.hmacStrength;
    this.padLength = this.constructor.padLength / 8;
    this.endian = "big";
    this._delta8 = this.blockSize / 8;
    this._delta32 = this.blockSize / 32;
}
$42b671a1d92bd7d4$export$8687658379b577e6 = $42b671a1d92bd7d4$var$BlockHash;
$42b671a1d92bd7d4$var$BlockHash.prototype.update = function update(msg, enc) {
    // Convert message to array, pad it, and join into 32bit blocks
    msg = $cSGZk.toArray(msg, enc);
    if (!this.pending) this.pending = msg;
    else this.pending = this.pending.concat(msg);
    this.pendingTotal += msg.length;
    // Enough data, try updating
    if (this.pending.length >= this._delta8) {
        msg = this.pending;
        // Process pending data in blocks
        var r = msg.length % this._delta8;
        this.pending = msg.slice(msg.length - r, msg.length);
        if (this.pending.length === 0) this.pending = null;
        msg = $cSGZk.join32(msg, 0, msg.length - r, this.endian);
        for(var i = 0; i < msg.length; i += this._delta32)this._update(msg, i, i + this._delta32);
    }
    return this;
};
$42b671a1d92bd7d4$var$BlockHash.prototype.digest = function digest(enc) {
    this.update(this._pad());
    $93fa9(this.pending === null);
    return this._digest(enc);
};
$42b671a1d92bd7d4$var$BlockHash.prototype._pad = function pad() {
    var len = this.pendingTotal;
    var bytes = this._delta8;
    var k = bytes - (len + this.padLength) % bytes;
    var res = new Array(k + this.padLength);
    res[0] = 0x80;
    for(var i = 1; i < k; i++)res[i] = 0;
    // Append length
    len <<= 3;
    if (this.endian === "big") {
        for(var t = 8; t < this.padLength; t++)res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = len >>> 24 & 0xff;
        res[i++] = len >>> 16 & 0xff;
        res[i++] = len >>> 8 & 0xff;
        res[i++] = len & 0xff;
    } else {
        res[i++] = len & 0xff;
        res[i++] = len >>> 8 & 0xff;
        res[i++] = len >>> 16 & 0xff;
        res[i++] = len >>> 24 & 0xff;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        for(t = 8; t < this.padLength; t++)res[i++] = 0;
    }
    return res;
};

});

parcelRequire.register("4z0yO", function(module, exports) {

$parcel$export(module.exports, "sha1", () => $352adda00949cadc$export$5091bdda49ba90f5, (v) => $352adda00949cadc$export$5091bdda49ba90f5 = v);
$parcel$export(module.exports, "sha224", () => $352adda00949cadc$export$97b70509d4e397ea, (v) => $352adda00949cadc$export$97b70509d4e397ea = v);
$parcel$export(module.exports, "sha256", () => $352adda00949cadc$export$bced8d2aada2d1c9, (v) => $352adda00949cadc$export$bced8d2aada2d1c9 = v);
$parcel$export(module.exports, "sha384", () => $352adda00949cadc$export$612d47d55dedde45, (v) => $352adda00949cadc$export$612d47d55dedde45 = v);
$parcel$export(module.exports, "sha512", () => $352adda00949cadc$export$a888d2532e6dc7bb, (v) => $352adda00949cadc$export$a888d2532e6dc7bb = v);
var $352adda00949cadc$export$5091bdda49ba90f5;
var $352adda00949cadc$export$97b70509d4e397ea;
var $352adda00949cadc$export$bced8d2aada2d1c9;
var $352adda00949cadc$export$612d47d55dedde45;
var $352adda00949cadc$export$a888d2532e6dc7bb;
"use strict";

$352adda00949cadc$export$5091bdda49ba90f5 = (parcelRequire("jsYy3"));

$352adda00949cadc$export$97b70509d4e397ea = (parcelRequire("5oSzC"));

$352adda00949cadc$export$bced8d2aada2d1c9 = (parcelRequire("84EiW"));

$352adda00949cadc$export$612d47d55dedde45 = (parcelRequire("d3JVX"));

$352adda00949cadc$export$a888d2532e6dc7bb = (parcelRequire("atCXT"));

});
parcelRequire.register("jsYy3", function(module, exports) {
"use strict";

var $cSGZk = parcelRequire("cSGZk");

var $5J6OM = parcelRequire("5J6OM");

var $hLt9V = parcelRequire("hLt9V");
var $e2bf99736286f749$var$rotl32 = $cSGZk.rotl32;
var $e2bf99736286f749$var$sum32 = $cSGZk.sum32;
var $e2bf99736286f749$var$sum32_5 = $cSGZk.sum32_5;
var $e2bf99736286f749$var$ft_1 = $hLt9V.ft_1;
var $e2bf99736286f749$var$BlockHash = $5J6OM.BlockHash;
var $e2bf99736286f749$var$sha1_K = [
    0x5A827999,
    0x6ED9EBA1,
    0x8F1BBCDC,
    0xCA62C1D6
];
function $e2bf99736286f749$var$SHA1() {
    if (!(this instanceof $e2bf99736286f749$var$SHA1)) return new $e2bf99736286f749$var$SHA1();
    $e2bf99736286f749$var$BlockHash.call(this);
    this.h = [
        0x67452301,
        0xefcdab89,
        0x98badcfe,
        0x10325476,
        0xc3d2e1f0
    ];
    this.W = new Array(80);
}
$cSGZk.inherits($e2bf99736286f749$var$SHA1, $e2bf99736286f749$var$BlockHash);
module.exports = $e2bf99736286f749$var$SHA1;
$e2bf99736286f749$var$SHA1.blockSize = 512;
$e2bf99736286f749$var$SHA1.outSize = 160;
$e2bf99736286f749$var$SHA1.hmacStrength = 80;
$e2bf99736286f749$var$SHA1.padLength = 64;
$e2bf99736286f749$var$SHA1.prototype._update = function _update(msg, start) {
    var W = this.W;
    for(var i = 0; i < 16; i++)W[i] = msg[start + i];
    for(; i < W.length; i++)W[i] = $e2bf99736286f749$var$rotl32(W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16], 1);
    var a = this.h[0];
    var b = this.h[1];
    var c = this.h[2];
    var d = this.h[3];
    var e = this.h[4];
    for(i = 0; i < W.length; i++){
        var s = ~~(i / 20);
        var t = $e2bf99736286f749$var$sum32_5($e2bf99736286f749$var$rotl32(a, 5), $e2bf99736286f749$var$ft_1(s, b, c, d), e, W[i], $e2bf99736286f749$var$sha1_K[s]);
        e = d;
        d = c;
        c = $e2bf99736286f749$var$rotl32(b, 30);
        b = a;
        a = t;
    }
    this.h[0] = $e2bf99736286f749$var$sum32(this.h[0], a);
    this.h[1] = $e2bf99736286f749$var$sum32(this.h[1], b);
    this.h[2] = $e2bf99736286f749$var$sum32(this.h[2], c);
    this.h[3] = $e2bf99736286f749$var$sum32(this.h[3], d);
    this.h[4] = $e2bf99736286f749$var$sum32(this.h[4], e);
};
$e2bf99736286f749$var$SHA1.prototype._digest = function digest(enc) {
    if (enc === "hex") return $cSGZk.toHex32(this.h, "big");
    else return $cSGZk.split32(this.h, "big");
};

});
parcelRequire.register("hLt9V", function(module, exports) {

$parcel$export(module.exports, "ft_1", () => $ceed71d43de481a1$export$5a92649d7ddb9f63, (v) => $ceed71d43de481a1$export$5a92649d7ddb9f63 = v);
$parcel$export(module.exports, "ch32", () => $ceed71d43de481a1$export$c6d0d020c3a6269, (v) => $ceed71d43de481a1$export$c6d0d020c3a6269 = v);
$parcel$export(module.exports, "maj32", () => $ceed71d43de481a1$export$eb90c27fca05f956, (v) => $ceed71d43de481a1$export$eb90c27fca05f956 = v);
$parcel$export(module.exports, "s0_256", () => $ceed71d43de481a1$export$14a4a98e063b1999, (v) => $ceed71d43de481a1$export$14a4a98e063b1999 = v);
$parcel$export(module.exports, "s1_256", () => $ceed71d43de481a1$export$d20cecfa1564c686, (v) => $ceed71d43de481a1$export$d20cecfa1564c686 = v);
$parcel$export(module.exports, "g0_256", () => $ceed71d43de481a1$export$44fd472a12fc6db, (v) => $ceed71d43de481a1$export$44fd472a12fc6db = v);
$parcel$export(module.exports, "g1_256", () => $ceed71d43de481a1$export$1ed238bb6ea1dd47, (v) => $ceed71d43de481a1$export$1ed238bb6ea1dd47 = v);
var $ceed71d43de481a1$export$5a92649d7ddb9f63;
var $ceed71d43de481a1$export$c6d0d020c3a6269;
var $ceed71d43de481a1$export$eb90c27fca05f956;
var $ceed71d43de481a1$export$cc992891a14496a1;
var $ceed71d43de481a1$export$14a4a98e063b1999;
var $ceed71d43de481a1$export$d20cecfa1564c686;
var $ceed71d43de481a1$export$44fd472a12fc6db;
var $ceed71d43de481a1$export$1ed238bb6ea1dd47;
"use strict";

var $cSGZk = parcelRequire("cSGZk");
var $ceed71d43de481a1$var$rotr32 = $cSGZk.rotr32;
function $ceed71d43de481a1$var$ft_1(s, x, y, z) {
    if (s === 0) return $ceed71d43de481a1$var$ch32(x, y, z);
    if (s === 1 || s === 3) return $ceed71d43de481a1$var$p32(x, y, z);
    if (s === 2) return $ceed71d43de481a1$var$maj32(x, y, z);
}
$ceed71d43de481a1$export$5a92649d7ddb9f63 = $ceed71d43de481a1$var$ft_1;
function $ceed71d43de481a1$var$ch32(x, y, z) {
    return x & y ^ ~x & z;
}
$ceed71d43de481a1$export$c6d0d020c3a6269 = $ceed71d43de481a1$var$ch32;
function $ceed71d43de481a1$var$maj32(x, y, z) {
    return x & y ^ x & z ^ y & z;
}
$ceed71d43de481a1$export$eb90c27fca05f956 = $ceed71d43de481a1$var$maj32;
function $ceed71d43de481a1$var$p32(x, y, z) {
    return x ^ y ^ z;
}
$ceed71d43de481a1$export$cc992891a14496a1 = $ceed71d43de481a1$var$p32;
function $ceed71d43de481a1$var$s0_256(x) {
    return $ceed71d43de481a1$var$rotr32(x, 2) ^ $ceed71d43de481a1$var$rotr32(x, 13) ^ $ceed71d43de481a1$var$rotr32(x, 22);
}
$ceed71d43de481a1$export$14a4a98e063b1999 = $ceed71d43de481a1$var$s0_256;
function $ceed71d43de481a1$var$s1_256(x) {
    return $ceed71d43de481a1$var$rotr32(x, 6) ^ $ceed71d43de481a1$var$rotr32(x, 11) ^ $ceed71d43de481a1$var$rotr32(x, 25);
}
$ceed71d43de481a1$export$d20cecfa1564c686 = $ceed71d43de481a1$var$s1_256;
function $ceed71d43de481a1$var$g0_256(x) {
    return $ceed71d43de481a1$var$rotr32(x, 7) ^ $ceed71d43de481a1$var$rotr32(x, 18) ^ x >>> 3;
}
$ceed71d43de481a1$export$44fd472a12fc6db = $ceed71d43de481a1$var$g0_256;
function $ceed71d43de481a1$var$g1_256(x) {
    return $ceed71d43de481a1$var$rotr32(x, 17) ^ $ceed71d43de481a1$var$rotr32(x, 19) ^ x >>> 10;
}
$ceed71d43de481a1$export$1ed238bb6ea1dd47 = $ceed71d43de481a1$var$g1_256;

});


parcelRequire.register("5oSzC", function(module, exports) {
"use strict";

var $cSGZk = parcelRequire("cSGZk");

var $84EiW = parcelRequire("84EiW");
function $3ee986d1fe8e089a$var$SHA224() {
    if (!(this instanceof $3ee986d1fe8e089a$var$SHA224)) return new $3ee986d1fe8e089a$var$SHA224();
    $84EiW.call(this);
    this.h = [
        0xc1059ed8,
        0x367cd507,
        0x3070dd17,
        0xf70e5939,
        0xffc00b31,
        0x68581511,
        0x64f98fa7,
        0xbefa4fa4
    ];
}
$cSGZk.inherits($3ee986d1fe8e089a$var$SHA224, $84EiW);
module.exports = $3ee986d1fe8e089a$var$SHA224;
$3ee986d1fe8e089a$var$SHA224.blockSize = 512;
$3ee986d1fe8e089a$var$SHA224.outSize = 224;
$3ee986d1fe8e089a$var$SHA224.hmacStrength = 192;
$3ee986d1fe8e089a$var$SHA224.padLength = 64;
$3ee986d1fe8e089a$var$SHA224.prototype._digest = function digest(enc) {
    // Just truncate output
    if (enc === "hex") return $cSGZk.toHex32(this.h.slice(0, 7), "big");
    else return $cSGZk.split32(this.h.slice(0, 7), "big");
};

});
parcelRequire.register("84EiW", function(module, exports) {
"use strict";

var $cSGZk = parcelRequire("cSGZk");

var $5J6OM = parcelRequire("5J6OM");

var $hLt9V = parcelRequire("hLt9V");

var $93fa9 = parcelRequire("93fa9");
var $5e0df61cb4969d99$var$sum32 = $cSGZk.sum32;
var $5e0df61cb4969d99$var$sum32_4 = $cSGZk.sum32_4;
var $5e0df61cb4969d99$var$sum32_5 = $cSGZk.sum32_5;
var $5e0df61cb4969d99$var$ch32 = $hLt9V.ch32;
var $5e0df61cb4969d99$var$maj32 = $hLt9V.maj32;
var $5e0df61cb4969d99$var$s0_256 = $hLt9V.s0_256;
var $5e0df61cb4969d99$var$s1_256 = $hLt9V.s1_256;
var $5e0df61cb4969d99$var$g0_256 = $hLt9V.g0_256;
var $5e0df61cb4969d99$var$g1_256 = $hLt9V.g1_256;
var $5e0df61cb4969d99$var$BlockHash = $5J6OM.BlockHash;
var $5e0df61cb4969d99$var$sha256_K = [
    0x428a2f98,
    0x71374491,
    0xb5c0fbcf,
    0xe9b5dba5,
    0x3956c25b,
    0x59f111f1,
    0x923f82a4,
    0xab1c5ed5,
    0xd807aa98,
    0x12835b01,
    0x243185be,
    0x550c7dc3,
    0x72be5d74,
    0x80deb1fe,
    0x9bdc06a7,
    0xc19bf174,
    0xe49b69c1,
    0xefbe4786,
    0x0fc19dc6,
    0x240ca1cc,
    0x2de92c6f,
    0x4a7484aa,
    0x5cb0a9dc,
    0x76f988da,
    0x983e5152,
    0xa831c66d,
    0xb00327c8,
    0xbf597fc7,
    0xc6e00bf3,
    0xd5a79147,
    0x06ca6351,
    0x14292967,
    0x27b70a85,
    0x2e1b2138,
    0x4d2c6dfc,
    0x53380d13,
    0x650a7354,
    0x766a0abb,
    0x81c2c92e,
    0x92722c85,
    0xa2bfe8a1,
    0xa81a664b,
    0xc24b8b70,
    0xc76c51a3,
    0xd192e819,
    0xd6990624,
    0xf40e3585,
    0x106aa070,
    0x19a4c116,
    0x1e376c08,
    0x2748774c,
    0x34b0bcb5,
    0x391c0cb3,
    0x4ed8aa4a,
    0x5b9cca4f,
    0x682e6ff3,
    0x748f82ee,
    0x78a5636f,
    0x84c87814,
    0x8cc70208,
    0x90befffa,
    0xa4506ceb,
    0xbef9a3f7,
    0xc67178f2
];
function $5e0df61cb4969d99$var$SHA256() {
    if (!(this instanceof $5e0df61cb4969d99$var$SHA256)) return new $5e0df61cb4969d99$var$SHA256();
    $5e0df61cb4969d99$var$BlockHash.call(this);
    this.h = [
        0x6a09e667,
        0xbb67ae85,
        0x3c6ef372,
        0xa54ff53a,
        0x510e527f,
        0x9b05688c,
        0x1f83d9ab,
        0x5be0cd19
    ];
    this.k = $5e0df61cb4969d99$var$sha256_K;
    this.W = new Array(64);
}
$cSGZk.inherits($5e0df61cb4969d99$var$SHA256, $5e0df61cb4969d99$var$BlockHash);
module.exports = $5e0df61cb4969d99$var$SHA256;
$5e0df61cb4969d99$var$SHA256.blockSize = 512;
$5e0df61cb4969d99$var$SHA256.outSize = 256;
$5e0df61cb4969d99$var$SHA256.hmacStrength = 192;
$5e0df61cb4969d99$var$SHA256.padLength = 64;
$5e0df61cb4969d99$var$SHA256.prototype._update = function _update(msg, start) {
    var W = this.W;
    for(var i = 0; i < 16; i++)W[i] = msg[start + i];
    for(; i < W.length; i++)W[i] = $5e0df61cb4969d99$var$sum32_4($5e0df61cb4969d99$var$g1_256(W[i - 2]), W[i - 7], $5e0df61cb4969d99$var$g0_256(W[i - 15]), W[i - 16]);
    var a = this.h[0];
    var b = this.h[1];
    var c = this.h[2];
    var d = this.h[3];
    var e = this.h[4];
    var f = this.h[5];
    var g = this.h[6];
    var h = this.h[7];
    $93fa9(this.k.length === W.length);
    for(i = 0; i < W.length; i++){
        var T1 = $5e0df61cb4969d99$var$sum32_5(h, $5e0df61cb4969d99$var$s1_256(e), $5e0df61cb4969d99$var$ch32(e, f, g), this.k[i], W[i]);
        var T2 = $5e0df61cb4969d99$var$sum32($5e0df61cb4969d99$var$s0_256(a), $5e0df61cb4969d99$var$maj32(a, b, c));
        h = g;
        g = f;
        f = e;
        e = $5e0df61cb4969d99$var$sum32(d, T1);
        d = c;
        c = b;
        b = a;
        a = $5e0df61cb4969d99$var$sum32(T1, T2);
    }
    this.h[0] = $5e0df61cb4969d99$var$sum32(this.h[0], a);
    this.h[1] = $5e0df61cb4969d99$var$sum32(this.h[1], b);
    this.h[2] = $5e0df61cb4969d99$var$sum32(this.h[2], c);
    this.h[3] = $5e0df61cb4969d99$var$sum32(this.h[3], d);
    this.h[4] = $5e0df61cb4969d99$var$sum32(this.h[4], e);
    this.h[5] = $5e0df61cb4969d99$var$sum32(this.h[5], f);
    this.h[6] = $5e0df61cb4969d99$var$sum32(this.h[6], g);
    this.h[7] = $5e0df61cb4969d99$var$sum32(this.h[7], h);
};
$5e0df61cb4969d99$var$SHA256.prototype._digest = function digest(enc) {
    if (enc === "hex") return $cSGZk.toHex32(this.h, "big");
    else return $cSGZk.split32(this.h, "big");
};

});


parcelRequire.register("d3JVX", function(module, exports) {
"use strict";

var $cSGZk = parcelRequire("cSGZk");

var $atCXT = parcelRequire("atCXT");
function $981f2fa8d6f70850$var$SHA384() {
    if (!(this instanceof $981f2fa8d6f70850$var$SHA384)) return new $981f2fa8d6f70850$var$SHA384();
    $atCXT.call(this);
    this.h = [
        0xcbbb9d5d,
        0xc1059ed8,
        0x629a292a,
        0x367cd507,
        0x9159015a,
        0x3070dd17,
        0x152fecd8,
        0xf70e5939,
        0x67332667,
        0xffc00b31,
        0x8eb44a87,
        0x68581511,
        0xdb0c2e0d,
        0x64f98fa7,
        0x47b5481d,
        0xbefa4fa4
    ];
}
$cSGZk.inherits($981f2fa8d6f70850$var$SHA384, $atCXT);
module.exports = $981f2fa8d6f70850$var$SHA384;
$981f2fa8d6f70850$var$SHA384.blockSize = 1024;
$981f2fa8d6f70850$var$SHA384.outSize = 384;
$981f2fa8d6f70850$var$SHA384.hmacStrength = 192;
$981f2fa8d6f70850$var$SHA384.padLength = 128;
$981f2fa8d6f70850$var$SHA384.prototype._digest = function digest(enc) {
    if (enc === "hex") return $cSGZk.toHex32(this.h.slice(0, 12), "big");
    else return $cSGZk.split32(this.h.slice(0, 12), "big");
};

});
parcelRequire.register("atCXT", function(module, exports) {
"use strict";

var $cSGZk = parcelRequire("cSGZk");

var $5J6OM = parcelRequire("5J6OM");

var $93fa9 = parcelRequire("93fa9");
var $7a0ad678fa0633e8$var$rotr64_hi = $cSGZk.rotr64_hi;
var $7a0ad678fa0633e8$var$rotr64_lo = $cSGZk.rotr64_lo;
var $7a0ad678fa0633e8$var$shr64_hi = $cSGZk.shr64_hi;
var $7a0ad678fa0633e8$var$shr64_lo = $cSGZk.shr64_lo;
var $7a0ad678fa0633e8$var$sum64 = $cSGZk.sum64;
var $7a0ad678fa0633e8$var$sum64_hi = $cSGZk.sum64_hi;
var $7a0ad678fa0633e8$var$sum64_lo = $cSGZk.sum64_lo;
var $7a0ad678fa0633e8$var$sum64_4_hi = $cSGZk.sum64_4_hi;
var $7a0ad678fa0633e8$var$sum64_4_lo = $cSGZk.sum64_4_lo;
var $7a0ad678fa0633e8$var$sum64_5_hi = $cSGZk.sum64_5_hi;
var $7a0ad678fa0633e8$var$sum64_5_lo = $cSGZk.sum64_5_lo;
var $7a0ad678fa0633e8$var$BlockHash = $5J6OM.BlockHash;
var $7a0ad678fa0633e8$var$sha512_K = [
    0x428a2f98,
    0xd728ae22,
    0x71374491,
    0x23ef65cd,
    0xb5c0fbcf,
    0xec4d3b2f,
    0xe9b5dba5,
    0x8189dbbc,
    0x3956c25b,
    0xf348b538,
    0x59f111f1,
    0xb605d019,
    0x923f82a4,
    0xaf194f9b,
    0xab1c5ed5,
    0xda6d8118,
    0xd807aa98,
    0xa3030242,
    0x12835b01,
    0x45706fbe,
    0x243185be,
    0x4ee4b28c,
    0x550c7dc3,
    0xd5ffb4e2,
    0x72be5d74,
    0xf27b896f,
    0x80deb1fe,
    0x3b1696b1,
    0x9bdc06a7,
    0x25c71235,
    0xc19bf174,
    0xcf692694,
    0xe49b69c1,
    0x9ef14ad2,
    0xefbe4786,
    0x384f25e3,
    0x0fc19dc6,
    0x8b8cd5b5,
    0x240ca1cc,
    0x77ac9c65,
    0x2de92c6f,
    0x592b0275,
    0x4a7484aa,
    0x6ea6e483,
    0x5cb0a9dc,
    0xbd41fbd4,
    0x76f988da,
    0x831153b5,
    0x983e5152,
    0xee66dfab,
    0xa831c66d,
    0x2db43210,
    0xb00327c8,
    0x98fb213f,
    0xbf597fc7,
    0xbeef0ee4,
    0xc6e00bf3,
    0x3da88fc2,
    0xd5a79147,
    0x930aa725,
    0x06ca6351,
    0xe003826f,
    0x14292967,
    0x0a0e6e70,
    0x27b70a85,
    0x46d22ffc,
    0x2e1b2138,
    0x5c26c926,
    0x4d2c6dfc,
    0x5ac42aed,
    0x53380d13,
    0x9d95b3df,
    0x650a7354,
    0x8baf63de,
    0x766a0abb,
    0x3c77b2a8,
    0x81c2c92e,
    0x47edaee6,
    0x92722c85,
    0x1482353b,
    0xa2bfe8a1,
    0x4cf10364,
    0xa81a664b,
    0xbc423001,
    0xc24b8b70,
    0xd0f89791,
    0xc76c51a3,
    0x0654be30,
    0xd192e819,
    0xd6ef5218,
    0xd6990624,
    0x5565a910,
    0xf40e3585,
    0x5771202a,
    0x106aa070,
    0x32bbd1b8,
    0x19a4c116,
    0xb8d2d0c8,
    0x1e376c08,
    0x5141ab53,
    0x2748774c,
    0xdf8eeb99,
    0x34b0bcb5,
    0xe19b48a8,
    0x391c0cb3,
    0xc5c95a63,
    0x4ed8aa4a,
    0xe3418acb,
    0x5b9cca4f,
    0x7763e373,
    0x682e6ff3,
    0xd6b2b8a3,
    0x748f82ee,
    0x5defb2fc,
    0x78a5636f,
    0x43172f60,
    0x84c87814,
    0xa1f0ab72,
    0x8cc70208,
    0x1a6439ec,
    0x90befffa,
    0x23631e28,
    0xa4506ceb,
    0xde82bde9,
    0xbef9a3f7,
    0xb2c67915,
    0xc67178f2,
    0xe372532b,
    0xca273ece,
    0xea26619c,
    0xd186b8c7,
    0x21c0c207,
    0xeada7dd6,
    0xcde0eb1e,
    0xf57d4f7f,
    0xee6ed178,
    0x06f067aa,
    0x72176fba,
    0x0a637dc5,
    0xa2c898a6,
    0x113f9804,
    0xbef90dae,
    0x1b710b35,
    0x131c471b,
    0x28db77f5,
    0x23047d84,
    0x32caab7b,
    0x40c72493,
    0x3c9ebe0a,
    0x15c9bebc,
    0x431d67c4,
    0x9c100d4c,
    0x4cc5d4be,
    0xcb3e42b6,
    0x597f299c,
    0xfc657e2a,
    0x5fcb6fab,
    0x3ad6faec,
    0x6c44198c,
    0x4a475817
];
function $7a0ad678fa0633e8$var$SHA512() {
    if (!(this instanceof $7a0ad678fa0633e8$var$SHA512)) return new $7a0ad678fa0633e8$var$SHA512();
    $7a0ad678fa0633e8$var$BlockHash.call(this);
    this.h = [
        0x6a09e667,
        0xf3bcc908,
        0xbb67ae85,
        0x84caa73b,
        0x3c6ef372,
        0xfe94f82b,
        0xa54ff53a,
        0x5f1d36f1,
        0x510e527f,
        0xade682d1,
        0x9b05688c,
        0x2b3e6c1f,
        0x1f83d9ab,
        0xfb41bd6b,
        0x5be0cd19,
        0x137e2179
    ];
    this.k = $7a0ad678fa0633e8$var$sha512_K;
    this.W = new Array(160);
}
$cSGZk.inherits($7a0ad678fa0633e8$var$SHA512, $7a0ad678fa0633e8$var$BlockHash);
module.exports = $7a0ad678fa0633e8$var$SHA512;
$7a0ad678fa0633e8$var$SHA512.blockSize = 1024;
$7a0ad678fa0633e8$var$SHA512.outSize = 512;
$7a0ad678fa0633e8$var$SHA512.hmacStrength = 192;
$7a0ad678fa0633e8$var$SHA512.padLength = 128;
$7a0ad678fa0633e8$var$SHA512.prototype._prepareBlock = function _prepareBlock(msg, start) {
    var W = this.W;
    // 32 x 32bit words
    for(var i = 0; i < 32; i++)W[i] = msg[start + i];
    for(; i < W.length; i += 2){
        var c0_hi = $7a0ad678fa0633e8$var$g1_512_hi(W[i - 4], W[i - 3]); // i - 2
        var c0_lo = $7a0ad678fa0633e8$var$g1_512_lo(W[i - 4], W[i - 3]);
        var c1_hi = W[i - 14]; // i - 7
        var c1_lo = W[i - 13];
        var c2_hi = $7a0ad678fa0633e8$var$g0_512_hi(W[i - 30], W[i - 29]); // i - 15
        var c2_lo = $7a0ad678fa0633e8$var$g0_512_lo(W[i - 30], W[i - 29]);
        var c3_hi = W[i - 32]; // i - 16
        var c3_lo = W[i - 31];
        W[i] = $7a0ad678fa0633e8$var$sum64_4_hi(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo);
        W[i + 1] = $7a0ad678fa0633e8$var$sum64_4_lo(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo);
    }
};
$7a0ad678fa0633e8$var$SHA512.prototype._update = function _update(msg, start) {
    this._prepareBlock(msg, start);
    var W = this.W;
    var ah = this.h[0];
    var al = this.h[1];
    var bh = this.h[2];
    var bl = this.h[3];
    var ch = this.h[4];
    var cl = this.h[5];
    var dh = this.h[6];
    var dl = this.h[7];
    var eh = this.h[8];
    var el = this.h[9];
    var fh = this.h[10];
    var fl = this.h[11];
    var gh = this.h[12];
    var gl = this.h[13];
    var hh = this.h[14];
    var hl = this.h[15];
    $93fa9(this.k.length === W.length);
    for(var i = 0; i < W.length; i += 2){
        var c0_hi = hh;
        var c0_lo = hl;
        var c1_hi = $7a0ad678fa0633e8$var$s1_512_hi(eh, el);
        var c1_lo = $7a0ad678fa0633e8$var$s1_512_lo(eh, el);
        var c2_hi = $7a0ad678fa0633e8$var$ch64_hi(eh, el, fh, fl, gh, gl);
        var c2_lo = $7a0ad678fa0633e8$var$ch64_lo(eh, el, fh, fl, gh, gl);
        var c3_hi = this.k[i];
        var c3_lo = this.k[i + 1];
        var c4_hi = W[i];
        var c4_lo = W[i + 1];
        var T1_hi = $7a0ad678fa0633e8$var$sum64_5_hi(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo, c4_hi, c4_lo);
        var T1_lo = $7a0ad678fa0633e8$var$sum64_5_lo(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo, c4_hi, c4_lo);
        c0_hi = $7a0ad678fa0633e8$var$s0_512_hi(ah, al);
        c0_lo = $7a0ad678fa0633e8$var$s0_512_lo(ah, al);
        c1_hi = $7a0ad678fa0633e8$var$maj64_hi(ah, al, bh, bl, ch, cl);
        c1_lo = $7a0ad678fa0633e8$var$maj64_lo(ah, al, bh, bl, ch, cl);
        var T2_hi = $7a0ad678fa0633e8$var$sum64_hi(c0_hi, c0_lo, c1_hi, c1_lo);
        var T2_lo = $7a0ad678fa0633e8$var$sum64_lo(c0_hi, c0_lo, c1_hi, c1_lo);
        hh = gh;
        hl = gl;
        gh = fh;
        gl = fl;
        fh = eh;
        fl = el;
        eh = $7a0ad678fa0633e8$var$sum64_hi(dh, dl, T1_hi, T1_lo);
        el = $7a0ad678fa0633e8$var$sum64_lo(dl, dl, T1_hi, T1_lo);
        dh = ch;
        dl = cl;
        ch = bh;
        cl = bl;
        bh = ah;
        bl = al;
        ah = $7a0ad678fa0633e8$var$sum64_hi(T1_hi, T1_lo, T2_hi, T2_lo);
        al = $7a0ad678fa0633e8$var$sum64_lo(T1_hi, T1_lo, T2_hi, T2_lo);
    }
    $7a0ad678fa0633e8$var$sum64(this.h, 0, ah, al);
    $7a0ad678fa0633e8$var$sum64(this.h, 2, bh, bl);
    $7a0ad678fa0633e8$var$sum64(this.h, 4, ch, cl);
    $7a0ad678fa0633e8$var$sum64(this.h, 6, dh, dl);
    $7a0ad678fa0633e8$var$sum64(this.h, 8, eh, el);
    $7a0ad678fa0633e8$var$sum64(this.h, 10, fh, fl);
    $7a0ad678fa0633e8$var$sum64(this.h, 12, gh, gl);
    $7a0ad678fa0633e8$var$sum64(this.h, 14, hh, hl);
};
$7a0ad678fa0633e8$var$SHA512.prototype._digest = function digest(enc) {
    if (enc === "hex") return $cSGZk.toHex32(this.h, "big");
    else return $cSGZk.split32(this.h, "big");
};
function $7a0ad678fa0633e8$var$ch64_hi(xh, xl, yh, yl, zh) {
    var r = xh & yh ^ ~xh & zh;
    if (r < 0) r += 0x100000000;
    return r;
}
function $7a0ad678fa0633e8$var$ch64_lo(xh, xl, yh, yl, zh, zl) {
    var r = xl & yl ^ ~xl & zl;
    if (r < 0) r += 0x100000000;
    return r;
}
function $7a0ad678fa0633e8$var$maj64_hi(xh, xl, yh, yl, zh) {
    var r = xh & yh ^ xh & zh ^ yh & zh;
    if (r < 0) r += 0x100000000;
    return r;
}
function $7a0ad678fa0633e8$var$maj64_lo(xh, xl, yh, yl, zh, zl) {
    var r = xl & yl ^ xl & zl ^ yl & zl;
    if (r < 0) r += 0x100000000;
    return r;
}
function $7a0ad678fa0633e8$var$s0_512_hi(xh, xl) {
    var c0_hi = $7a0ad678fa0633e8$var$rotr64_hi(xh, xl, 28);
    var c1_hi = $7a0ad678fa0633e8$var$rotr64_hi(xl, xh, 2); // 34
    var c2_hi = $7a0ad678fa0633e8$var$rotr64_hi(xl, xh, 7); // 39
    var r = c0_hi ^ c1_hi ^ c2_hi;
    if (r < 0) r += 0x100000000;
    return r;
}
function $7a0ad678fa0633e8$var$s0_512_lo(xh, xl) {
    var c0_lo = $7a0ad678fa0633e8$var$rotr64_lo(xh, xl, 28);
    var c1_lo = $7a0ad678fa0633e8$var$rotr64_lo(xl, xh, 2); // 34
    var c2_lo = $7a0ad678fa0633e8$var$rotr64_lo(xl, xh, 7); // 39
    var r = c0_lo ^ c1_lo ^ c2_lo;
    if (r < 0) r += 0x100000000;
    return r;
}
function $7a0ad678fa0633e8$var$s1_512_hi(xh, xl) {
    var c0_hi = $7a0ad678fa0633e8$var$rotr64_hi(xh, xl, 14);
    var c1_hi = $7a0ad678fa0633e8$var$rotr64_hi(xh, xl, 18);
    var c2_hi = $7a0ad678fa0633e8$var$rotr64_hi(xl, xh, 9); // 41
    var r = c0_hi ^ c1_hi ^ c2_hi;
    if (r < 0) r += 0x100000000;
    return r;
}
function $7a0ad678fa0633e8$var$s1_512_lo(xh, xl) {
    var c0_lo = $7a0ad678fa0633e8$var$rotr64_lo(xh, xl, 14);
    var c1_lo = $7a0ad678fa0633e8$var$rotr64_lo(xh, xl, 18);
    var c2_lo = $7a0ad678fa0633e8$var$rotr64_lo(xl, xh, 9); // 41
    var r = c0_lo ^ c1_lo ^ c2_lo;
    if (r < 0) r += 0x100000000;
    return r;
}
function $7a0ad678fa0633e8$var$g0_512_hi(xh, xl) {
    var c0_hi = $7a0ad678fa0633e8$var$rotr64_hi(xh, xl, 1);
    var c1_hi = $7a0ad678fa0633e8$var$rotr64_hi(xh, xl, 8);
    var c2_hi = $7a0ad678fa0633e8$var$shr64_hi(xh, xl, 7);
    var r = c0_hi ^ c1_hi ^ c2_hi;
    if (r < 0) r += 0x100000000;
    return r;
}
function $7a0ad678fa0633e8$var$g0_512_lo(xh, xl) {
    var c0_lo = $7a0ad678fa0633e8$var$rotr64_lo(xh, xl, 1);
    var c1_lo = $7a0ad678fa0633e8$var$rotr64_lo(xh, xl, 8);
    var c2_lo = $7a0ad678fa0633e8$var$shr64_lo(xh, xl, 7);
    var r = c0_lo ^ c1_lo ^ c2_lo;
    if (r < 0) r += 0x100000000;
    return r;
}
function $7a0ad678fa0633e8$var$g1_512_hi(xh, xl) {
    var c0_hi = $7a0ad678fa0633e8$var$rotr64_hi(xh, xl, 19);
    var c1_hi = $7a0ad678fa0633e8$var$rotr64_hi(xl, xh, 29); // 61
    var c2_hi = $7a0ad678fa0633e8$var$shr64_hi(xh, xl, 6);
    var r = c0_hi ^ c1_hi ^ c2_hi;
    if (r < 0) r += 0x100000000;
    return r;
}
function $7a0ad678fa0633e8$var$g1_512_lo(xh, xl) {
    var c0_lo = $7a0ad678fa0633e8$var$rotr64_lo(xh, xl, 19);
    var c1_lo = $7a0ad678fa0633e8$var$rotr64_lo(xl, xh, 29); // 61
    var c2_lo = $7a0ad678fa0633e8$var$shr64_lo(xh, xl, 6);
    var r = c0_lo ^ c1_lo ^ c2_lo;
    if (r < 0) r += 0x100000000;
    return r;
}

});



parcelRequire.register("hbdMe", function(module, exports) {

$parcel$export(module.exports, "ripemd160", () => $c81e2694cdd524d4$export$d1cea0ee4e3f0d3e, (v) => $c81e2694cdd524d4$export$d1cea0ee4e3f0d3e = v);
var $c81e2694cdd524d4$export$d1cea0ee4e3f0d3e;
"use strict";

var $cSGZk = parcelRequire("cSGZk");

var $5J6OM = parcelRequire("5J6OM");
var $c81e2694cdd524d4$var$rotl32 = $cSGZk.rotl32;
var $c81e2694cdd524d4$var$sum32 = $cSGZk.sum32;
var $c81e2694cdd524d4$var$sum32_3 = $cSGZk.sum32_3;
var $c81e2694cdd524d4$var$sum32_4 = $cSGZk.sum32_4;
var $c81e2694cdd524d4$var$BlockHash = $5J6OM.BlockHash;
function $c81e2694cdd524d4$var$RIPEMD160() {
    if (!(this instanceof $c81e2694cdd524d4$var$RIPEMD160)) return new $c81e2694cdd524d4$var$RIPEMD160();
    $c81e2694cdd524d4$var$BlockHash.call(this);
    this.h = [
        0x67452301,
        0xefcdab89,
        0x98badcfe,
        0x10325476,
        0xc3d2e1f0
    ];
    this.endian = "little";
}
$cSGZk.inherits($c81e2694cdd524d4$var$RIPEMD160, $c81e2694cdd524d4$var$BlockHash);
$c81e2694cdd524d4$export$d1cea0ee4e3f0d3e = $c81e2694cdd524d4$var$RIPEMD160;
$c81e2694cdd524d4$var$RIPEMD160.blockSize = 512;
$c81e2694cdd524d4$var$RIPEMD160.outSize = 160;
$c81e2694cdd524d4$var$RIPEMD160.hmacStrength = 192;
$c81e2694cdd524d4$var$RIPEMD160.padLength = 64;
$c81e2694cdd524d4$var$RIPEMD160.prototype._update = function update(msg, start) {
    var A = this.h[0];
    var B = this.h[1];
    var C = this.h[2];
    var D = this.h[3];
    var E = this.h[4];
    var Ah = A;
    var Bh = B;
    var Ch = C;
    var Dh = D;
    var Eh = E;
    for(var j = 0; j < 80; j++){
        var T = $c81e2694cdd524d4$var$sum32($c81e2694cdd524d4$var$rotl32($c81e2694cdd524d4$var$sum32_4(A, $c81e2694cdd524d4$var$f(j, B, C, D), msg[$c81e2694cdd524d4$var$r[j] + start], $c81e2694cdd524d4$var$K(j)), $c81e2694cdd524d4$var$s[j]), E);
        A = E;
        E = D;
        D = $c81e2694cdd524d4$var$rotl32(C, 10);
        C = B;
        B = T;
        T = $c81e2694cdd524d4$var$sum32($c81e2694cdd524d4$var$rotl32($c81e2694cdd524d4$var$sum32_4(Ah, $c81e2694cdd524d4$var$f(79 - j, Bh, Ch, Dh), msg[$c81e2694cdd524d4$var$rh[j] + start], $c81e2694cdd524d4$var$Kh(j)), $c81e2694cdd524d4$var$sh[j]), Eh);
        Ah = Eh;
        Eh = Dh;
        Dh = $c81e2694cdd524d4$var$rotl32(Ch, 10);
        Ch = Bh;
        Bh = T;
    }
    T = $c81e2694cdd524d4$var$sum32_3(this.h[1], C, Dh);
    this.h[1] = $c81e2694cdd524d4$var$sum32_3(this.h[2], D, Eh);
    this.h[2] = $c81e2694cdd524d4$var$sum32_3(this.h[3], E, Ah);
    this.h[3] = $c81e2694cdd524d4$var$sum32_3(this.h[4], A, Bh);
    this.h[4] = $c81e2694cdd524d4$var$sum32_3(this.h[0], B, Ch);
    this.h[0] = T;
};
$c81e2694cdd524d4$var$RIPEMD160.prototype._digest = function digest(enc) {
    if (enc === "hex") return $cSGZk.toHex32(this.h, "little");
    else return $cSGZk.split32(this.h, "little");
};
function $c81e2694cdd524d4$var$f(j, x, y, z) {
    if (j <= 15) return x ^ y ^ z;
    else if (j <= 31) return x & y | ~x & z;
    else if (j <= 47) return (x | ~y) ^ z;
    else if (j <= 63) return x & z | y & ~z;
    else return x ^ (y | ~z);
}
function $c81e2694cdd524d4$var$K(j) {
    if (j <= 15) return 0x00000000;
    else if (j <= 31) return 0x5a827999;
    else if (j <= 47) return 0x6ed9eba1;
    else if (j <= 63) return 0x8f1bbcdc;
    else return 0xa953fd4e;
}
function $c81e2694cdd524d4$var$Kh(j) {
    if (j <= 15) return 0x50a28be6;
    else if (j <= 31) return 0x5c4dd124;
    else if (j <= 47) return 0x6d703ef3;
    else if (j <= 63) return 0x7a6d76e9;
    else return 0x00000000;
}
var $c81e2694cdd524d4$var$r = [
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    7,
    4,
    13,
    1,
    10,
    6,
    15,
    3,
    12,
    0,
    9,
    5,
    2,
    14,
    11,
    8,
    3,
    10,
    14,
    4,
    9,
    15,
    8,
    1,
    2,
    7,
    0,
    6,
    13,
    11,
    5,
    12,
    1,
    9,
    11,
    10,
    0,
    8,
    12,
    4,
    13,
    3,
    7,
    15,
    14,
    5,
    6,
    2,
    4,
    0,
    5,
    9,
    7,
    12,
    2,
    10,
    14,
    1,
    3,
    8,
    11,
    6,
    15,
    13
];
var $c81e2694cdd524d4$var$rh = [
    5,
    14,
    7,
    0,
    9,
    2,
    11,
    4,
    13,
    6,
    15,
    8,
    1,
    10,
    3,
    12,
    6,
    11,
    3,
    7,
    0,
    13,
    5,
    10,
    14,
    15,
    8,
    12,
    4,
    9,
    1,
    2,
    15,
    5,
    1,
    3,
    7,
    14,
    6,
    9,
    11,
    8,
    12,
    2,
    10,
    0,
    4,
    13,
    8,
    6,
    4,
    1,
    3,
    11,
    15,
    0,
    5,
    12,
    2,
    13,
    9,
    7,
    10,
    14,
    12,
    15,
    10,
    4,
    1,
    5,
    8,
    7,
    6,
    2,
    13,
    14,
    0,
    3,
    9,
    11
];
var $c81e2694cdd524d4$var$s = [
    11,
    14,
    15,
    12,
    5,
    8,
    7,
    9,
    11,
    13,
    14,
    15,
    6,
    7,
    9,
    8,
    7,
    6,
    8,
    13,
    11,
    9,
    7,
    15,
    7,
    12,
    15,
    9,
    11,
    7,
    13,
    12,
    11,
    13,
    6,
    7,
    14,
    9,
    13,
    15,
    14,
    8,
    13,
    6,
    5,
    12,
    7,
    5,
    11,
    12,
    14,
    15,
    14,
    15,
    9,
    8,
    9,
    14,
    5,
    6,
    8,
    6,
    5,
    12,
    9,
    15,
    5,
    11,
    6,
    8,
    13,
    12,
    5,
    12,
    13,
    14,
    11,
    8,
    5,
    6
];
var $c81e2694cdd524d4$var$sh = [
    8,
    9,
    9,
    11,
    13,
    15,
    15,
    5,
    7,
    7,
    8,
    11,
    14,
    14,
    12,
    6,
    9,
    13,
    15,
    7,
    12,
    8,
    9,
    11,
    7,
    7,
    12,
    7,
    6,
    15,
    13,
    11,
    9,
    7,
    15,
    11,
    8,
    6,
    6,
    14,
    12,
    13,
    5,
    14,
    13,
    13,
    7,
    5,
    15,
    5,
    8,
    11,
    14,
    14,
    6,
    14,
    6,
    9,
    12,
    9,
    12,
    5,
    15,
    8,
    8,
    5,
    12,
    9,
    12,
    5,
    14,
    6,
    8,
    13,
    6,
    5,
    15,
    13,
    11,
    11
];

});

parcelRequire.register("7HBWL", function(module, exports) {
"use strict";

var $cSGZk = parcelRequire("cSGZk");

var $93fa9 = parcelRequire("93fa9");
function $59b9fc0556ec5421$var$Hmac(hash, key, enc) {
    if (!(this instanceof $59b9fc0556ec5421$var$Hmac)) return new $59b9fc0556ec5421$var$Hmac(hash, key, enc);
    this.Hash = hash;
    this.blockSize = hash.blockSize / 8;
    this.outSize = hash.outSize / 8;
    this.inner = null;
    this.outer = null;
    this._init($cSGZk.toArray(key, enc));
}
module.exports = $59b9fc0556ec5421$var$Hmac;
$59b9fc0556ec5421$var$Hmac.prototype._init = function init(key) {
    // Shorten key, if needed
    if (key.length > this.blockSize) key = new this.Hash().update(key).digest();
    $93fa9(key.length <= this.blockSize);
    // Add padding to key
    for(var i = key.length; i < this.blockSize; i++)key.push(0);
    for(i = 0; i < key.length; i++)key[i] ^= 0x36;
    this.inner = new this.Hash().update(key);
    // 0x36 ^ 0x5c = 0x6a
    for(i = 0; i < key.length; i++)key[i] ^= 0x6a;
    this.outer = new this.Hash().update(key);
};
$59b9fc0556ec5421$var$Hmac.prototype.update = function update(msg, enc) {
    this.inner.update(msg, enc);
    return this;
};
$59b9fc0556ec5421$var$Hmac.prototype.digest = function digest(enc) {
    this.outer.update(this.inner.digest());
    return this.outer.digest(enc);
};

});


parcelRequire.register("fT3YI", function(module, exports) {
module.exports = {
    doubles: {
        step: 4,
        points: [
            [
                "e60fce93b59e9ec53011aabc21c23e97b2a31369b87a5ae9c44ee89e2a6dec0a",
                "f7e3507399e595929db99f34f57937101296891e44d23f0be1f32cce69616821"
            ],
            [
                "8282263212c609d9ea2a6e3e172de238d8c39cabd5ac1ca10646e23fd5f51508",
                "11f8a8098557dfe45e8256e830b60ace62d613ac2f7b17bed31b6eaff6e26caf"
            ],
            [
                "175e159f728b865a72f99cc6c6fc846de0b93833fd2222ed73fce5b551e5b739",
                "d3506e0d9e3c79eba4ef97a51ff71f5eacb5955add24345c6efa6ffee9fed695"
            ],
            [
                "363d90d447b00c9c99ceac05b6262ee053441c7e55552ffe526bad8f83ff4640",
                "4e273adfc732221953b445397f3363145b9a89008199ecb62003c7f3bee9de9"
            ],
            [
                "8b4b5f165df3c2be8c6244b5b745638843e4a781a15bcd1b69f79a55dffdf80c",
                "4aad0a6f68d308b4b3fbd7813ab0da04f9e336546162ee56b3eff0c65fd4fd36"
            ],
            [
                "723cbaa6e5db996d6bf771c00bd548c7b700dbffa6c0e77bcb6115925232fcda",
                "96e867b5595cc498a921137488824d6e2660a0653779494801dc069d9eb39f5f"
            ],
            [
                "eebfa4d493bebf98ba5feec812c2d3b50947961237a919839a533eca0e7dd7fa",
                "5d9a8ca3970ef0f269ee7edaf178089d9ae4cdc3a711f712ddfd4fdae1de8999"
            ],
            [
                "100f44da696e71672791d0a09b7bde459f1215a29b3c03bfefd7835b39a48db0",
                "cdd9e13192a00b772ec8f3300c090666b7ff4a18ff5195ac0fbd5cd62bc65a09"
            ],
            [
                "e1031be262c7ed1b1dc9227a4a04c017a77f8d4464f3b3852c8acde6e534fd2d",
                "9d7061928940405e6bb6a4176597535af292dd419e1ced79a44f18f29456a00d"
            ],
            [
                "feea6cae46d55b530ac2839f143bd7ec5cf8b266a41d6af52d5e688d9094696d",
                "e57c6b6c97dce1bab06e4e12bf3ecd5c981c8957cc41442d3155debf18090088"
            ],
            [
                "da67a91d91049cdcb367be4be6ffca3cfeed657d808583de33fa978bc1ec6cb1",
                "9bacaa35481642bc41f463f7ec9780e5dec7adc508f740a17e9ea8e27a68be1d"
            ],
            [
                "53904faa0b334cdda6e000935ef22151ec08d0f7bb11069f57545ccc1a37b7c0",
                "5bc087d0bc80106d88c9eccac20d3c1c13999981e14434699dcb096b022771c8"
            ],
            [
                "8e7bcd0bd35983a7719cca7764ca906779b53a043a9b8bcaeff959f43ad86047",
                "10b7770b2a3da4b3940310420ca9514579e88e2e47fd68b3ea10047e8460372a"
            ],
            [
                "385eed34c1cdff21e6d0818689b81bde71a7f4f18397e6690a841e1599c43862",
                "283bebc3e8ea23f56701de19e9ebf4576b304eec2086dc8cc0458fe5542e5453"
            ],
            [
                "6f9d9b803ecf191637c73a4413dfa180fddf84a5947fbc9c606ed86c3fac3a7",
                "7c80c68e603059ba69b8e2a30e45c4d47ea4dd2f5c281002d86890603a842160"
            ],
            [
                "3322d401243c4e2582a2147c104d6ecbf774d163db0f5e5313b7e0e742d0e6bd",
                "56e70797e9664ef5bfb019bc4ddaf9b72805f63ea2873af624f3a2e96c28b2a0"
            ],
            [
                "85672c7d2de0b7da2bd1770d89665868741b3f9af7643397721d74d28134ab83",
                "7c481b9b5b43b2eb6374049bfa62c2e5e77f17fcc5298f44c8e3094f790313a6"
            ],
            [
                "948bf809b1988a46b06c9f1919413b10f9226c60f668832ffd959af60c82a0a",
                "53a562856dcb6646dc6b74c5d1c3418c6d4dff08c97cd2bed4cb7f88d8c8e589"
            ],
            [
                "6260ce7f461801c34f067ce0f02873a8f1b0e44dfc69752accecd819f38fd8e8",
                "bc2da82b6fa5b571a7f09049776a1ef7ecd292238051c198c1a84e95b2b4ae17"
            ],
            [
                "e5037de0afc1d8d43d8348414bbf4103043ec8f575bfdc432953cc8d2037fa2d",
                "4571534baa94d3b5f9f98d09fb990bddbd5f5b03ec481f10e0e5dc841d755bda"
            ],
            [
                "e06372b0f4a207adf5ea905e8f1771b4e7e8dbd1c6a6c5b725866a0ae4fce725",
                "7a908974bce18cfe12a27bb2ad5a488cd7484a7787104870b27034f94eee31dd"
            ],
            [
                "213c7a715cd5d45358d0bbf9dc0ce02204b10bdde2a3f58540ad6908d0559754",
                "4b6dad0b5ae462507013ad06245ba190bb4850f5f36a7eeddff2c27534b458f2"
            ],
            [
                "4e7c272a7af4b34e8dbb9352a5419a87e2838c70adc62cddf0cc3a3b08fbd53c",
                "17749c766c9d0b18e16fd09f6def681b530b9614bff7dd33e0b3941817dcaae6"
            ],
            [
                "fea74e3dbe778b1b10f238ad61686aa5c76e3db2be43057632427e2840fb27b6",
                "6e0568db9b0b13297cf674deccb6af93126b596b973f7b77701d3db7f23cb96f"
            ],
            [
                "76e64113f677cf0e10a2570d599968d31544e179b760432952c02a4417bdde39",
                "c90ddf8dee4e95cf577066d70681f0d35e2a33d2b56d2032b4b1752d1901ac01"
            ],
            [
                "c738c56b03b2abe1e8281baa743f8f9a8f7cc643df26cbee3ab150242bcbb891",
                "893fb578951ad2537f718f2eacbfbbbb82314eef7880cfe917e735d9699a84c3"
            ],
            [
                "d895626548b65b81e264c7637c972877d1d72e5f3a925014372e9f6588f6c14b",
                "febfaa38f2bc7eae728ec60818c340eb03428d632bb067e179363ed75d7d991f"
            ],
            [
                "b8da94032a957518eb0f6433571e8761ceffc73693e84edd49150a564f676e03",
                "2804dfa44805a1e4d7c99cc9762808b092cc584d95ff3b511488e4e74efdf6e7"
            ],
            [
                "e80fea14441fb33a7d8adab9475d7fab2019effb5156a792f1a11778e3c0df5d",
                "eed1de7f638e00771e89768ca3ca94472d155e80af322ea9fcb4291b6ac9ec78"
            ],
            [
                "a301697bdfcd704313ba48e51d567543f2a182031efd6915ddc07bbcc4e16070",
                "7370f91cfb67e4f5081809fa25d40f9b1735dbf7c0a11a130c0d1a041e177ea1"
            ],
            [
                "90ad85b389d6b936463f9d0512678de208cc330b11307fffab7ac63e3fb04ed4",
                "e507a3620a38261affdcbd9427222b839aefabe1582894d991d4d48cb6ef150"
            ],
            [
                "8f68b9d2f63b5f339239c1ad981f162ee88c5678723ea3351b7b444c9ec4c0da",
                "662a9f2dba063986de1d90c2b6be215dbbea2cfe95510bfdf23cbf79501fff82"
            ],
            [
                "e4f3fb0176af85d65ff99ff9198c36091f48e86503681e3e6686fd5053231e11",
                "1e63633ad0ef4f1c1661a6d0ea02b7286cc7e74ec951d1c9822c38576feb73bc"
            ],
            [
                "8c00fa9b18ebf331eb961537a45a4266c7034f2f0d4e1d0716fb6eae20eae29e",
                "efa47267fea521a1a9dc343a3736c974c2fadafa81e36c54e7d2a4c66702414b"
            ],
            [
                "e7a26ce69dd4829f3e10cec0a9e98ed3143d084f308b92c0997fddfc60cb3e41",
                "2a758e300fa7984b471b006a1aafbb18d0a6b2c0420e83e20e8a9421cf2cfd51"
            ],
            [
                "b6459e0ee3662ec8d23540c223bcbdc571cbcb967d79424f3cf29eb3de6b80ef",
                "67c876d06f3e06de1dadf16e5661db3c4b3ae6d48e35b2ff30bf0b61a71ba45"
            ],
            [
                "d68a80c8280bb840793234aa118f06231d6f1fc67e73c5a5deda0f5b496943e8",
                "db8ba9fff4b586d00c4b1f9177b0e28b5b0e7b8f7845295a294c84266b133120"
            ],
            [
                "324aed7df65c804252dc0270907a30b09612aeb973449cea4095980fc28d3d5d",
                "648a365774b61f2ff130c0c35aec1f4f19213b0c7e332843967224af96ab7c84"
            ],
            [
                "4df9c14919cde61f6d51dfdbe5fee5dceec4143ba8d1ca888e8bd373fd054c96",
                "35ec51092d8728050974c23a1d85d4b5d506cdc288490192ebac06cad10d5d"
            ],
            [
                "9c3919a84a474870faed8a9c1cc66021523489054d7f0308cbfc99c8ac1f98cd",
                "ddb84f0f4a4ddd57584f044bf260e641905326f76c64c8e6be7e5e03d4fc599d"
            ],
            [
                "6057170b1dd12fdf8de05f281d8e06bb91e1493a8b91d4cc5a21382120a959e5",
                "9a1af0b26a6a4807add9a2daf71df262465152bc3ee24c65e899be932385a2a8"
            ],
            [
                "a576df8e23a08411421439a4518da31880cef0fba7d4df12b1a6973eecb94266",
                "40a6bf20e76640b2c92b97afe58cd82c432e10a7f514d9f3ee8be11ae1b28ec8"
            ],
            [
                "7778a78c28dec3e30a05fe9629de8c38bb30d1f5cf9a3a208f763889be58ad71",
                "34626d9ab5a5b22ff7098e12f2ff580087b38411ff24ac563b513fc1fd9f43ac"
            ],
            [
                "928955ee637a84463729fd30e7afd2ed5f96274e5ad7e5cb09eda9c06d903ac",
                "c25621003d3f42a827b78a13093a95eeac3d26efa8a8d83fc5180e935bcd091f"
            ],
            [
                "85d0fef3ec6db109399064f3a0e3b2855645b4a907ad354527aae75163d82751",
                "1f03648413a38c0be29d496e582cf5663e8751e96877331582c237a24eb1f962"
            ],
            [
                "ff2b0dce97eece97c1c9b6041798b85dfdfb6d8882da20308f5404824526087e",
                "493d13fef524ba188af4c4dc54d07936c7b7ed6fb90e2ceb2c951e01f0c29907"
            ],
            [
                "827fbbe4b1e880ea9ed2b2e6301b212b57f1ee148cd6dd28780e5e2cf856e241",
                "c60f9c923c727b0b71bef2c67d1d12687ff7a63186903166d605b68baec293ec"
            ],
            [
                "eaa649f21f51bdbae7be4ae34ce6e5217a58fdce7f47f9aa7f3b58fa2120e2b3",
                "be3279ed5bbbb03ac69a80f89879aa5a01a6b965f13f7e59d47a5305ba5ad93d"
            ],
            [
                "e4a42d43c5cf169d9391df6decf42ee541b6d8f0c9a137401e23632dda34d24f",
                "4d9f92e716d1c73526fc99ccfb8ad34ce886eedfa8d8e4f13a7f7131deba9414"
            ],
            [
                "1ec80fef360cbdd954160fadab352b6b92b53576a88fea4947173b9d4300bf19",
                "aeefe93756b5340d2f3a4958a7abbf5e0146e77f6295a07b671cdc1cc107cefd"
            ],
            [
                "146a778c04670c2f91b00af4680dfa8bce3490717d58ba889ddb5928366642be",
                "b318e0ec3354028add669827f9d4b2870aaa971d2f7e5ed1d0b297483d83efd0"
            ],
            [
                "fa50c0f61d22e5f07e3acebb1aa07b128d0012209a28b9776d76a8793180eef9",
                "6b84c6922397eba9b72cd2872281a68a5e683293a57a213b38cd8d7d3f4f2811"
            ],
            [
                "da1d61d0ca721a11b1a5bf6b7d88e8421a288ab5d5bba5220e53d32b5f067ec2",
                "8157f55a7c99306c79c0766161c91e2966a73899d279b48a655fba0f1ad836f1"
            ],
            [
                "a8e282ff0c9706907215ff98e8fd416615311de0446f1e062a73b0610d064e13",
                "7f97355b8db81c09abfb7f3c5b2515888b679a3e50dd6bd6cef7c73111f4cc0c"
            ],
            [
                "174a53b9c9a285872d39e56e6913cab15d59b1fa512508c022f382de8319497c",
                "ccc9dc37abfc9c1657b4155f2c47f9e6646b3a1d8cb9854383da13ac079afa73"
            ],
            [
                "959396981943785c3d3e57edf5018cdbe039e730e4918b3d884fdff09475b7ba",
                "2e7e552888c331dd8ba0386a4b9cd6849c653f64c8709385e9b8abf87524f2fd"
            ],
            [
                "d2a63a50ae401e56d645a1153b109a8fcca0a43d561fba2dbb51340c9d82b151",
                "e82d86fb6443fcb7565aee58b2948220a70f750af484ca52d4142174dcf89405"
            ],
            [
                "64587e2335471eb890ee7896d7cfdc866bacbdbd3839317b3436f9b45617e073",
                "d99fcdd5bf6902e2ae96dd6447c299a185b90a39133aeab358299e5e9faf6589"
            ],
            [
                "8481bde0e4e4d885b3a546d3e549de042f0aa6cea250e7fd358d6c86dd45e458",
                "38ee7b8cba5404dd84a25bf39cecb2ca900a79c42b262e556d64b1b59779057e"
            ],
            [
                "13464a57a78102aa62b6979ae817f4637ffcfed3c4b1ce30bcd6303f6caf666b",
                "69be159004614580ef7e433453ccb0ca48f300a81d0942e13f495a907f6ecc27"
            ],
            [
                "bc4a9df5b713fe2e9aef430bcc1dc97a0cd9ccede2f28588cada3a0d2d83f366",
                "d3a81ca6e785c06383937adf4b798caa6e8a9fbfa547b16d758d666581f33c1"
            ],
            [
                "8c28a97bf8298bc0d23d8c749452a32e694b65e30a9472a3954ab30fe5324caa",
                "40a30463a3305193378fedf31f7cc0eb7ae784f0451cb9459e71dc73cbef9482"
            ],
            [
                "8ea9666139527a8c1dd94ce4f071fd23c8b350c5a4bb33748c4ba111faccae0",
                "620efabbc8ee2782e24e7c0cfb95c5d735b783be9cf0f8e955af34a30e62b945"
            ],
            [
                "dd3625faef5ba06074669716bbd3788d89bdde815959968092f76cc4eb9a9787",
                "7a188fa3520e30d461da2501045731ca941461982883395937f68d00c644a573"
            ],
            [
                "f710d79d9eb962297e4f6232b40e8f7feb2bc63814614d692c12de752408221e",
                "ea98e67232d3b3295d3b535532115ccac8612c721851617526ae47a9c77bfc82"
            ]
        ]
    },
    naf: {
        wnd: 7,
        points: [
            [
                "f9308a019258c31049344f85f89d5229b531c845836f99b08601f113bce036f9",
                "388f7b0f632de8140fe337e62a37f3566500a99934c2231b6cb9fd7584b8e672"
            ],
            [
                "2f8bde4d1a07209355b4a7250a5c5128e88b84bddc619ab7cba8d569b240efe4",
                "d8ac222636e5e3d6d4dba9dda6c9c426f788271bab0d6840dca87d3aa6ac62d6"
            ],
            [
                "5cbdf0646e5db4eaa398f365f2ea7a0e3d419b7e0330e39ce92bddedcac4f9bc",
                "6aebca40ba255960a3178d6d861a54dba813d0b813fde7b5a5082628087264da"
            ],
            [
                "acd484e2f0c7f65309ad178a9f559abde09796974c57e714c35f110dfc27ccbe",
                "cc338921b0a7d9fd64380971763b61e9add888a4375f8e0f05cc262ac64f9c37"
            ],
            [
                "774ae7f858a9411e5ef4246b70c65aac5649980be5c17891bbec17895da008cb",
                "d984a032eb6b5e190243dd56d7b7b365372db1e2dff9d6a8301d74c9c953c61b"
            ],
            [
                "f28773c2d975288bc7d1d205c3748651b075fbc6610e58cddeeddf8f19405aa8",
                "ab0902e8d880a89758212eb65cdaf473a1a06da521fa91f29b5cb52db03ed81"
            ],
            [
                "d7924d4f7d43ea965a465ae3095ff41131e5946f3c85f79e44adbcf8e27e080e",
                "581e2872a86c72a683842ec228cc6defea40af2bd896d3a5c504dc9ff6a26b58"
            ],
            [
                "defdea4cdb677750a420fee807eacf21eb9898ae79b9768766e4faa04a2d4a34",
                "4211ab0694635168e997b0ead2a93daeced1f4a04a95c0f6cfb199f69e56eb77"
            ],
            [
                "2b4ea0a797a443d293ef5cff444f4979f06acfebd7e86d277475656138385b6c",
                "85e89bc037945d93b343083b5a1c86131a01f60c50269763b570c854e5c09b7a"
            ],
            [
                "352bbf4a4cdd12564f93fa332ce333301d9ad40271f8107181340aef25be59d5",
                "321eb4075348f534d59c18259dda3e1f4a1b3b2e71b1039c67bd3d8bcf81998c"
            ],
            [
                "2fa2104d6b38d11b0230010559879124e42ab8dfeff5ff29dc9cdadd4ecacc3f",
                "2de1068295dd865b64569335bd5dd80181d70ecfc882648423ba76b532b7d67"
            ],
            [
                "9248279b09b4d68dab21a9b066edda83263c3d84e09572e269ca0cd7f5453714",
                "73016f7bf234aade5d1aa71bdea2b1ff3fc0de2a887912ffe54a32ce97cb3402"
            ],
            [
                "daed4f2be3a8bf278e70132fb0beb7522f570e144bf615c07e996d443dee8729",
                "a69dce4a7d6c98e8d4a1aca87ef8d7003f83c230f3afa726ab40e52290be1c55"
            ],
            [
                "c44d12c7065d812e8acf28d7cbb19f9011ecd9e9fdf281b0e6a3b5e87d22e7db",
                "2119a460ce326cdc76c45926c982fdac0e106e861edf61c5a039063f0e0e6482"
            ],
            [
                "6a245bf6dc698504c89a20cfded60853152b695336c28063b61c65cbd269e6b4",
                "e022cf42c2bd4a708b3f5126f16a24ad8b33ba48d0423b6efd5e6348100d8a82"
            ],
            [
                "1697ffa6fd9de627c077e3d2fe541084ce13300b0bec1146f95ae57f0d0bd6a5",
                "b9c398f186806f5d27561506e4557433a2cf15009e498ae7adee9d63d01b2396"
            ],
            [
                "605bdb019981718b986d0f07e834cb0d9deb8360ffb7f61df982345ef27a7479",
                "2972d2de4f8d20681a78d93ec96fe23c26bfae84fb14db43b01e1e9056b8c49"
            ],
            [
                "62d14dab4150bf497402fdc45a215e10dcb01c354959b10cfe31c7e9d87ff33d",
                "80fc06bd8cc5b01098088a1950eed0db01aa132967ab472235f5642483b25eaf"
            ],
            [
                "80c60ad0040f27dade5b4b06c408e56b2c50e9f56b9b8b425e555c2f86308b6f",
                "1c38303f1cc5c30f26e66bad7fe72f70a65eed4cbe7024eb1aa01f56430bd57a"
            ],
            [
                "7a9375ad6167ad54aa74c6348cc54d344cc5dc9487d847049d5eabb0fa03c8fb",
                "d0e3fa9eca8726909559e0d79269046bdc59ea10c70ce2b02d499ec224dc7f7"
            ],
            [
                "d528ecd9b696b54c907a9ed045447a79bb408ec39b68df504bb51f459bc3ffc9",
                "eecf41253136e5f99966f21881fd656ebc4345405c520dbc063465b521409933"
            ],
            [
                "49370a4b5f43412ea25f514e8ecdad05266115e4a7ecb1387231808f8b45963",
                "758f3f41afd6ed428b3081b0512fd62a54c3f3afbb5b6764b653052a12949c9a"
            ],
            [
                "77f230936ee88cbbd73df930d64702ef881d811e0e1498e2f1c13eb1fc345d74",
                "958ef42a7886b6400a08266e9ba1b37896c95330d97077cbbe8eb3c7671c60d6"
            ],
            [
                "f2dac991cc4ce4b9ea44887e5c7c0bce58c80074ab9d4dbaeb28531b7739f530",
                "e0dedc9b3b2f8dad4da1f32dec2531df9eb5fbeb0598e4fd1a117dba703a3c37"
            ],
            [
                "463b3d9f662621fb1b4be8fbbe2520125a216cdfc9dae3debcba4850c690d45b",
                "5ed430d78c296c3543114306dd8622d7c622e27c970a1de31cb377b01af7307e"
            ],
            [
                "f16f804244e46e2a09232d4aff3b59976b98fac14328a2d1a32496b49998f247",
                "cedabd9b82203f7e13d206fcdf4e33d92a6c53c26e5cce26d6579962c4e31df6"
            ],
            [
                "caf754272dc84563b0352b7a14311af55d245315ace27c65369e15f7151d41d1",
                "cb474660ef35f5f2a41b643fa5e460575f4fa9b7962232a5c32f908318a04476"
            ],
            [
                "2600ca4b282cb986f85d0f1709979d8b44a09c07cb86d7c124497bc86f082120",
                "4119b88753c15bd6a693b03fcddbb45d5ac6be74ab5f0ef44b0be9475a7e4b40"
            ],
            [
                "7635ca72d7e8432c338ec53cd12220bc01c48685e24f7dc8c602a7746998e435",
                "91b649609489d613d1d5e590f78e6d74ecfc061d57048bad9e76f302c5b9c61"
            ],
            [
                "754e3239f325570cdbbf4a87deee8a66b7f2b33479d468fbc1a50743bf56cc18",
                "673fb86e5bda30fb3cd0ed304ea49a023ee33d0197a695d0c5d98093c536683"
            ],
            [
                "e3e6bd1071a1e96aff57859c82d570f0330800661d1c952f9fe2694691d9b9e8",
                "59c9e0bba394e76f40c0aa58379a3cb6a5a2283993e90c4167002af4920e37f5"
            ],
            [
                "186b483d056a033826ae73d88f732985c4ccb1f32ba35f4b4cc47fdcf04aa6eb",
                "3b952d32c67cf77e2e17446e204180ab21fb8090895138b4a4a797f86e80888b"
            ],
            [
                "df9d70a6b9876ce544c98561f4be4f725442e6d2b737d9c91a8321724ce0963f",
                "55eb2dafd84d6ccd5f862b785dc39d4ab157222720ef9da217b8c45cf2ba2417"
            ],
            [
                "5edd5cc23c51e87a497ca815d5dce0f8ab52554f849ed8995de64c5f34ce7143",
                "efae9c8dbc14130661e8cec030c89ad0c13c66c0d17a2905cdc706ab7399a868"
            ],
            [
                "290798c2b6476830da12fe02287e9e777aa3fba1c355b17a722d362f84614fba",
                "e38da76dcd440621988d00bcf79af25d5b29c094db2a23146d003afd41943e7a"
            ],
            [
                "af3c423a95d9f5b3054754efa150ac39cd29552fe360257362dfdecef4053b45",
                "f98a3fd831eb2b749a93b0e6f35cfb40c8cd5aa667a15581bc2feded498fd9c6"
            ],
            [
                "766dbb24d134e745cccaa28c99bf274906bb66b26dcf98df8d2fed50d884249a",
                "744b1152eacbe5e38dcc887980da38b897584a65fa06cedd2c924f97cbac5996"
            ],
            [
                "59dbf46f8c94759ba21277c33784f41645f7b44f6c596a58ce92e666191abe3e",
                "c534ad44175fbc300f4ea6ce648309a042ce739a7919798cd85e216c4a307f6e"
            ],
            [
                "f13ada95103c4537305e691e74e9a4a8dd647e711a95e73cb62dc6018cfd87b8",
                "e13817b44ee14de663bf4bc808341f326949e21a6a75c2570778419bdaf5733d"
            ],
            [
                "7754b4fa0e8aced06d4167a2c59cca4cda1869c06ebadfb6488550015a88522c",
                "30e93e864e669d82224b967c3020b8fa8d1e4e350b6cbcc537a48b57841163a2"
            ],
            [
                "948dcadf5990e048aa3874d46abef9d701858f95de8041d2a6828c99e2262519",
                "e491a42537f6e597d5d28a3224b1bc25df9154efbd2ef1d2cbba2cae5347d57e"
            ],
            [
                "7962414450c76c1689c7b48f8202ec37fb224cf5ac0bfa1570328a8a3d7c77ab",
                "100b610ec4ffb4760d5c1fc133ef6f6b12507a051f04ac5760afa5b29db83437"
            ],
            [
                "3514087834964b54b15b160644d915485a16977225b8847bb0dd085137ec47ca",
                "ef0afbb2056205448e1652c48e8127fc6039e77c15c2378b7e7d15a0de293311"
            ],
            [
                "d3cc30ad6b483e4bc79ce2c9dd8bc54993e947eb8df787b442943d3f7b527eaf",
                "8b378a22d827278d89c5e9be8f9508ae3c2ad46290358630afb34db04eede0a4"
            ],
            [
                "1624d84780732860ce1c78fcbfefe08b2b29823db913f6493975ba0ff4847610",
                "68651cf9b6da903e0914448c6cd9d4ca896878f5282be4c8cc06e2a404078575"
            ],
            [
                "733ce80da955a8a26902c95633e62a985192474b5af207da6df7b4fd5fc61cd4",
                "f5435a2bd2badf7d485a4d8b8db9fcce3e1ef8e0201e4578c54673bc1dc5ea1d"
            ],
            [
                "15d9441254945064cf1a1c33bbd3b49f8966c5092171e699ef258dfab81c045c",
                "d56eb30b69463e7234f5137b73b84177434800bacebfc685fc37bbe9efe4070d"
            ],
            [
                "a1d0fcf2ec9de675b612136e5ce70d271c21417c9d2b8aaaac138599d0717940",
                "edd77f50bcb5a3cab2e90737309667f2641462a54070f3d519212d39c197a629"
            ],
            [
                "e22fbe15c0af8ccc5780c0735f84dbe9a790badee8245c06c7ca37331cb36980",
                "a855babad5cd60c88b430a69f53a1a7a38289154964799be43d06d77d31da06"
            ],
            [
                "311091dd9860e8e20ee13473c1155f5f69635e394704eaa74009452246cfa9b3",
                "66db656f87d1f04fffd1f04788c06830871ec5a64feee685bd80f0b1286d8374"
            ],
            [
                "34c1fd04d301be89b31c0442d3e6ac24883928b45a9340781867d4232ec2dbdf",
                "9414685e97b1b5954bd46f730174136d57f1ceeb487443dc5321857ba73abee"
            ],
            [
                "f219ea5d6b54701c1c14de5b557eb42a8d13f3abbcd08affcc2a5e6b049b8d63",
                "4cb95957e83d40b0f73af4544cccf6b1f4b08d3c07b27fb8d8c2962a400766d1"
            ],
            [
                "d7b8740f74a8fbaab1f683db8f45de26543a5490bca627087236912469a0b448",
                "fa77968128d9c92ee1010f337ad4717eff15db5ed3c049b3411e0315eaa4593b"
            ],
            [
                "32d31c222f8f6f0ef86f7c98d3a3335ead5bcd32abdd94289fe4d3091aa824bf",
                "5f3032f5892156e39ccd3d7915b9e1da2e6dac9e6f26e961118d14b8462e1661"
            ],
            [
                "7461f371914ab32671045a155d9831ea8793d77cd59592c4340f86cbc18347b5",
                "8ec0ba238b96bec0cbdddcae0aa442542eee1ff50c986ea6b39847b3cc092ff6"
            ],
            [
                "ee079adb1df1860074356a25aa38206a6d716b2c3e67453d287698bad7b2b2d6",
                "8dc2412aafe3be5c4c5f37e0ecc5f9f6a446989af04c4e25ebaac479ec1c8c1e"
            ],
            [
                "16ec93e447ec83f0467b18302ee620f7e65de331874c9dc72bfd8616ba9da6b5",
                "5e4631150e62fb40d0e8c2a7ca5804a39d58186a50e497139626778e25b0674d"
            ],
            [
                "eaa5f980c245f6f038978290afa70b6bd8855897f98b6aa485b96065d537bd99",
                "f65f5d3e292c2e0819a528391c994624d784869d7e6ea67fb18041024edc07dc"
            ],
            [
                "78c9407544ac132692ee1910a02439958ae04877151342ea96c4b6b35a49f51",
                "f3e0319169eb9b85d5404795539a5e68fa1fbd583c064d2462b675f194a3ddb4"
            ],
            [
                "494f4be219a1a77016dcd838431aea0001cdc8ae7a6fc688726578d9702857a5",
                "42242a969283a5f339ba7f075e36ba2af925ce30d767ed6e55f4b031880d562c"
            ],
            [
                "a598a8030da6d86c6bc7f2f5144ea549d28211ea58faa70ebf4c1e665c1fe9b5",
                "204b5d6f84822c307e4b4a7140737aec23fc63b65b35f86a10026dbd2d864e6b"
            ],
            [
                "c41916365abb2b5d09192f5f2dbeafec208f020f12570a184dbadc3e58595997",
                "4f14351d0087efa49d245b328984989d5caf9450f34bfc0ed16e96b58fa9913"
            ],
            [
                "841d6063a586fa475a724604da03bc5b92a2e0d2e0a36acfe4c73a5514742881",
                "73867f59c0659e81904f9a1c7543698e62562d6744c169ce7a36de01a8d6154"
            ],
            [
                "5e95bb399a6971d376026947f89bde2f282b33810928be4ded112ac4d70e20d5",
                "39f23f366809085beebfc71181313775a99c9aed7d8ba38b161384c746012865"
            ],
            [
                "36e4641a53948fd476c39f8a99fd974e5ec07564b5315d8bf99471bca0ef2f66",
                "d2424b1b1abe4eb8164227b085c9aa9456ea13493fd563e06fd51cf5694c78fc"
            ],
            [
                "336581ea7bfbbb290c191a2f507a41cf5643842170e914faeab27c2c579f726",
                "ead12168595fe1be99252129b6e56b3391f7ab1410cd1e0ef3dcdcabd2fda224"
            ],
            [
                "8ab89816dadfd6b6a1f2634fcf00ec8403781025ed6890c4849742706bd43ede",
                "6fdcef09f2f6d0a044e654aef624136f503d459c3e89845858a47a9129cdd24e"
            ],
            [
                "1e33f1a746c9c5778133344d9299fcaa20b0938e8acff2544bb40284b8c5fb94",
                "60660257dd11b3aa9c8ed618d24edff2306d320f1d03010e33a7d2057f3b3b6"
            ],
            [
                "85b7c1dcb3cec1b7ee7f30ded79dd20a0ed1f4cc18cbcfcfa410361fd8f08f31",
                "3d98a9cdd026dd43f39048f25a8847f4fcafad1895d7a633c6fed3c35e999511"
            ],
            [
                "29df9fbd8d9e46509275f4b125d6d45d7fbe9a3b878a7af872a2800661ac5f51",
                "b4c4fe99c775a606e2d8862179139ffda61dc861c019e55cd2876eb2a27d84b"
            ],
            [
                "a0b1cae06b0a847a3fea6e671aaf8adfdfe58ca2f768105c8082b2e449fce252",
                "ae434102edde0958ec4b19d917a6a28e6b72da1834aff0e650f049503a296cf2"
            ],
            [
                "4e8ceafb9b3e9a136dc7ff67e840295b499dfb3b2133e4ba113f2e4c0e121e5",
                "cf2174118c8b6d7a4b48f6d534ce5c79422c086a63460502b827ce62a326683c"
            ],
            [
                "d24a44e047e19b6f5afb81c7ca2f69080a5076689a010919f42725c2b789a33b",
                "6fb8d5591b466f8fc63db50f1c0f1c69013f996887b8244d2cdec417afea8fa3"
            ],
            [
                "ea01606a7a6c9cdd249fdfcfacb99584001edd28abbab77b5104e98e8e3b35d4",
                "322af4908c7312b0cfbfe369f7a7b3cdb7d4494bc2823700cfd652188a3ea98d"
            ],
            [
                "af8addbf2b661c8a6c6328655eb96651252007d8c5ea31be4ad196de8ce2131f",
                "6749e67c029b85f52a034eafd096836b2520818680e26ac8f3dfbcdb71749700"
            ],
            [
                "e3ae1974566ca06cc516d47e0fb165a674a3dabcfca15e722f0e3450f45889",
                "2aeabe7e4531510116217f07bf4d07300de97e4874f81f533420a72eeb0bd6a4"
            ],
            [
                "591ee355313d99721cf6993ffed1e3e301993ff3ed258802075ea8ced397e246",
                "b0ea558a113c30bea60fc4775460c7901ff0b053d25ca2bdeee98f1a4be5d196"
            ],
            [
                "11396d55fda54c49f19aa97318d8da61fa8584e47b084945077cf03255b52984",
                "998c74a8cd45ac01289d5833a7beb4744ff536b01b257be4c5767bea93ea57a4"
            ],
            [
                "3c5d2a1ba39c5a1790000738c9e0c40b8dcdfd5468754b6405540157e017aa7a",
                "b2284279995a34e2f9d4de7396fc18b80f9b8b9fdd270f6661f79ca4c81bd257"
            ],
            [
                "cc8704b8a60a0defa3a99a7299f2e9c3fbc395afb04ac078425ef8a1793cc030",
                "bdd46039feed17881d1e0862db347f8cf395b74fc4bcdc4e940b74e3ac1f1b13"
            ],
            [
                "c533e4f7ea8555aacd9777ac5cad29b97dd4defccc53ee7ea204119b2889b197",
                "6f0a256bc5efdf429a2fb6242f1a43a2d9b925bb4a4b3a26bb8e0f45eb596096"
            ],
            [
                "c14f8f2ccb27d6f109f6d08d03cc96a69ba8c34eec07bbcf566d48e33da6593",
                "c359d6923bb398f7fd4473e16fe1c28475b740dd098075e6c0e8649113dc3a38"
            ],
            [
                "a6cbc3046bc6a450bac24789fa17115a4c9739ed75f8f21ce441f72e0b90e6ef",
                "21ae7f4680e889bb130619e2c0f95a360ceb573c70603139862afd617fa9b9f"
            ],
            [
                "347d6d9a02c48927ebfb86c1359b1caf130a3c0267d11ce6344b39f99d43cc38",
                "60ea7f61a353524d1c987f6ecec92f086d565ab687870cb12689ff1e31c74448"
            ],
            [
                "da6545d2181db8d983f7dcb375ef5866d47c67b1bf31c8cf855ef7437b72656a",
                "49b96715ab6878a79e78f07ce5680c5d6673051b4935bd897fea824b77dc208a"
            ],
            [
                "c40747cc9d012cb1a13b8148309c6de7ec25d6945d657146b9d5994b8feb1111",
                "5ca560753be2a12fc6de6caf2cb489565db936156b9514e1bb5e83037e0fa2d4"
            ],
            [
                "4e42c8ec82c99798ccf3a610be870e78338c7f713348bd34c8203ef4037f3502",
                "7571d74ee5e0fb92a7a8b33a07783341a5492144cc54bcc40a94473693606437"
            ],
            [
                "3775ab7089bc6af823aba2e1af70b236d251cadb0c86743287522a1b3b0dedea",
                "be52d107bcfa09d8bcb9736a828cfa7fac8db17bf7a76a2c42ad961409018cf7"
            ],
            [
                "cee31cbf7e34ec379d94fb814d3d775ad954595d1314ba8846959e3e82f74e26",
                "8fd64a14c06b589c26b947ae2bcf6bfa0149ef0be14ed4d80f448a01c43b1c6d"
            ],
            [
                "b4f9eaea09b6917619f6ea6a4eb5464efddb58fd45b1ebefcdc1a01d08b47986",
                "39e5c9925b5a54b07433a4f18c61726f8bb131c012ca542eb24a8ac07200682a"
            ],
            [
                "d4263dfc3d2df923a0179a48966d30ce84e2515afc3dccc1b77907792ebcc60e",
                "62dfaf07a0f78feb30e30d6295853ce189e127760ad6cf7fae164e122a208d54"
            ],
            [
                "48457524820fa65a4f8d35eb6930857c0032acc0a4a2de422233eeda897612c4",
                "25a748ab367979d98733c38a1fa1c2e7dc6cc07db2d60a9ae7a76aaa49bd0f77"
            ],
            [
                "dfeeef1881101f2cb11644f3a2afdfc2045e19919152923f367a1767c11cceda",
                "ecfb7056cf1de042f9420bab396793c0c390bde74b4bbdff16a83ae09a9a7517"
            ],
            [
                "6d7ef6b17543f8373c573f44e1f389835d89bcbc6062ced36c82df83b8fae859",
                "cd450ec335438986dfefa10c57fea9bcc521a0959b2d80bbf74b190dca712d10"
            ],
            [
                "e75605d59102a5a2684500d3b991f2e3f3c88b93225547035af25af66e04541f",
                "f5c54754a8f71ee540b9b48728473e314f729ac5308b06938360990e2bfad125"
            ],
            [
                "eb98660f4c4dfaa06a2be453d5020bc99a0c2e60abe388457dd43fefb1ed620c",
                "6cb9a8876d9cb8520609af3add26cd20a0a7cd8a9411131ce85f44100099223e"
            ],
            [
                "13e87b027d8514d35939f2e6892b19922154596941888336dc3563e3b8dba942",
                "fef5a3c68059a6dec5d624114bf1e91aac2b9da568d6abeb2570d55646b8adf1"
            ],
            [
                "ee163026e9fd6fe017c38f06a5be6fc125424b371ce2708e7bf4491691e5764a",
                "1acb250f255dd61c43d94ccc670d0f58f49ae3fa15b96623e5430da0ad6c62b2"
            ],
            [
                "b268f5ef9ad51e4d78de3a750c2dc89b1e626d43505867999932e5db33af3d80",
                "5f310d4b3c99b9ebb19f77d41c1dee018cf0d34fd4191614003e945a1216e423"
            ],
            [
                "ff07f3118a9df035e9fad85eb6c7bfe42b02f01ca99ceea3bf7ffdba93c4750d",
                "438136d603e858a3a5c440c38eccbaddc1d2942114e2eddd4740d098ced1f0d8"
            ],
            [
                "8d8b9855c7c052a34146fd20ffb658bea4b9f69e0d825ebec16e8c3ce2b526a1",
                "cdb559eedc2d79f926baf44fb84ea4d44bcf50fee51d7ceb30e2e7f463036758"
            ],
            [
                "52db0b5384dfbf05bfa9d472d7ae26dfe4b851ceca91b1eba54263180da32b63",
                "c3b997d050ee5d423ebaf66a6db9f57b3180c902875679de924b69d84a7b375"
            ],
            [
                "e62f9490d3d51da6395efd24e80919cc7d0f29c3f3fa48c6fff543becbd43352",
                "6d89ad7ba4876b0b22c2ca280c682862f342c8591f1daf5170e07bfd9ccafa7d"
            ],
            [
                "7f30ea2476b399b4957509c88f77d0191afa2ff5cb7b14fd6d8e7d65aaab1193",
                "ca5ef7d4b231c94c3b15389a5f6311e9daff7bb67b103e9880ef4bff637acaec"
            ],
            [
                "5098ff1e1d9f14fb46a210fada6c903fef0fb7b4a1dd1d9ac60a0361800b7a00",
                "9731141d81fc8f8084d37c6e7542006b3ee1b40d60dfe5362a5b132fd17ddc0"
            ],
            [
                "32b78c7de9ee512a72895be6b9cbefa6e2f3c4ccce445c96b9f2c81e2778ad58",
                "ee1849f513df71e32efc3896ee28260c73bb80547ae2275ba497237794c8753c"
            ],
            [
                "e2cb74fddc8e9fbcd076eef2a7c72b0ce37d50f08269dfc074b581550547a4f7",
                "d3aa2ed71c9dd2247a62df062736eb0baddea9e36122d2be8641abcb005cc4a4"
            ],
            [
                "8438447566d4d7bedadc299496ab357426009a35f235cb141be0d99cd10ae3a8",
                "c4e1020916980a4da5d01ac5e6ad330734ef0d7906631c4f2390426b2edd791f"
            ],
            [
                "4162d488b89402039b584c6fc6c308870587d9c46f660b878ab65c82c711d67e",
                "67163e903236289f776f22c25fb8a3afc1732f2b84b4e95dbda47ae5a0852649"
            ],
            [
                "3fad3fa84caf0f34f0f89bfd2dcf54fc175d767aec3e50684f3ba4a4bf5f683d",
                "cd1bc7cb6cc407bb2f0ca647c718a730cf71872e7d0d2a53fa20efcdfe61826"
            ],
            [
                "674f2600a3007a00568c1a7ce05d0816c1fb84bf1370798f1c69532faeb1a86b",
                "299d21f9413f33b3edf43b257004580b70db57da0b182259e09eecc69e0d38a5"
            ],
            [
                "d32f4da54ade74abb81b815ad1fb3b263d82d6c692714bcff87d29bd5ee9f08f",
                "f9429e738b8e53b968e99016c059707782e14f4535359d582fc416910b3eea87"
            ],
            [
                "30e4e670435385556e593657135845d36fbb6931f72b08cb1ed954f1e3ce3ff6",
                "462f9bce619898638499350113bbc9b10a878d35da70740dc695a559eb88db7b"
            ],
            [
                "be2062003c51cc3004682904330e4dee7f3dcd10b01e580bf1971b04d4cad297",
                "62188bc49d61e5428573d48a74e1c655b1c61090905682a0d5558ed72dccb9bc"
            ],
            [
                "93144423ace3451ed29e0fb9ac2af211cb6e84a601df5993c419859fff5df04a",
                "7c10dfb164c3425f5c71a3f9d7992038f1065224f72bb9d1d902a6d13037b47c"
            ],
            [
                "b015f8044f5fcbdcf21ca26d6c34fb8197829205c7b7d2a7cb66418c157b112c",
                "ab8c1e086d04e813744a655b2df8d5f83b3cdc6faa3088c1d3aea1454e3a1d5f"
            ],
            [
                "d5e9e1da649d97d89e4868117a465a3a4f8a18de57a140d36b3f2af341a21b52",
                "4cb04437f391ed73111a13cc1d4dd0db1693465c2240480d8955e8592f27447a"
            ],
            [
                "d3ae41047dd7ca065dbf8ed77b992439983005cd72e16d6f996a5316d36966bb",
                "bd1aeb21ad22ebb22a10f0303417c6d964f8cdd7df0aca614b10dc14d125ac46"
            ],
            [
                "463e2763d885f958fc66cdd22800f0a487197d0a82e377b49f80af87c897b065",
                "bfefacdb0e5d0fd7df3a311a94de062b26b80c61fbc97508b79992671ef7ca7f"
            ],
            [
                "7985fdfd127c0567c6f53ec1bb63ec3158e597c40bfe747c83cddfc910641917",
                "603c12daf3d9862ef2b25fe1de289aed24ed291e0ec6708703a5bd567f32ed03"
            ],
            [
                "74a1ad6b5f76e39db2dd249410eac7f99e74c59cb83d2d0ed5ff1543da7703e9",
                "cc6157ef18c9c63cd6193d83631bbea0093e0968942e8c33d5737fd790e0db08"
            ],
            [
                "30682a50703375f602d416664ba19b7fc9bab42c72747463a71d0896b22f6da3",
                "553e04f6b018b4fa6c8f39e7f311d3176290d0e0f19ca73f17714d9977a22ff8"
            ],
            [
                "9e2158f0d7c0d5f26c3791efefa79597654e7a2b2464f52b1ee6c1347769ef57",
                "712fcdd1b9053f09003a3481fa7762e9ffd7c8ef35a38509e2fbf2629008373"
            ],
            [
                "176e26989a43c9cfeba4029c202538c28172e566e3c4fce7322857f3be327d66",
                "ed8cc9d04b29eb877d270b4878dc43c19aefd31f4eee09ee7b47834c1fa4b1c3"
            ],
            [
                "75d46efea3771e6e68abb89a13ad747ecf1892393dfc4f1b7004788c50374da8",
                "9852390a99507679fd0b86fd2b39a868d7efc22151346e1a3ca4726586a6bed8"
            ],
            [
                "809a20c67d64900ffb698c4c825f6d5f2310fb0451c869345b7319f645605721",
                "9e994980d9917e22b76b061927fa04143d096ccc54963e6a5ebfa5f3f8e286c1"
            ],
            [
                "1b38903a43f7f114ed4500b4eac7083fdefece1cf29c63528d563446f972c180",
                "4036edc931a60ae889353f77fd53de4a2708b26b6f5da72ad3394119daf408f9"
            ]
        ]
    }
};

});


parcelRequire.register("kiF8o", function(module, exports) {
"use strict";

var $73nMH = parcelRequire("73nMH");

var $azGIt = parcelRequire("azGIt");

var $axXvD = parcelRequire("axXvD");

var $lkAVm = parcelRequire("lkAVm");

var $9OawI = parcelRequire("9OawI");
var $ec756589ef3c2426$var$assert = $axXvD.assert;

var $iFgwo = parcelRequire("iFgwo");

var $jZWy6 = parcelRequire("jZWy6");
function $ec756589ef3c2426$var$EC(options) {
    if (!(this instanceof $ec756589ef3c2426$var$EC)) return new $ec756589ef3c2426$var$EC(options);
    // Shortcut `elliptic.ec(curve-name)`
    if (typeof options === "string") {
        $ec756589ef3c2426$var$assert(Object.prototype.hasOwnProperty.call($lkAVm, options), "Unknown curve " + options);
        options = $lkAVm[options];
    }
    // Shortcut for `elliptic.ec(elliptic.curves.curveName)`
    if (options instanceof $lkAVm.PresetCurve) options = {
        curve: options
    };
    this.curve = options.curve.curve;
    this.n = this.curve.n;
    this.nh = this.n.ushrn(1);
    this.g = this.curve.g;
    // Point on curve
    this.g = options.curve.g;
    this.g.precompute(options.curve.n.bitLength() + 1);
    // Hash for function for DRBG
    this.hash = options.hash || options.curve.hash;
}
module.exports = $ec756589ef3c2426$var$EC;
$ec756589ef3c2426$var$EC.prototype.keyPair = function keyPair(options) {
    return new $iFgwo(this, options);
};
$ec756589ef3c2426$var$EC.prototype.keyFromPrivate = function keyFromPrivate(priv, enc) {
    return $iFgwo.fromPrivate(this, priv, enc);
};
$ec756589ef3c2426$var$EC.prototype.keyFromPublic = function keyFromPublic(pub, enc) {
    return $iFgwo.fromPublic(this, pub, enc);
};
$ec756589ef3c2426$var$EC.prototype.genKeyPair = function genKeyPair(options) {
    if (!options) options = {};
    // Instantiate Hmac_DRBG
    var drbg = new $azGIt({
        hash: this.hash,
        pers: options.pers,
        persEnc: options.persEnc || "utf8",
        entropy: options.entropy || $9OawI(this.hash.hmacStrength),
        entropyEnc: options.entropy && options.entropyEnc || "utf8",
        nonce: this.n.toArray()
    });
    var bytes = this.n.byteLength();
    var ns2 = this.n.sub(new $73nMH(2));
    for(;;){
        var priv = new $73nMH(drbg.generate(bytes));
        if (priv.cmp(ns2) > 0) continue;
        priv.iaddn(1);
        return this.keyFromPrivate(priv);
    }
};
$ec756589ef3c2426$var$EC.prototype._truncateToN = function _truncateToN(msg, truncOnly) {
    var delta = msg.byteLength() * 8 - this.n.bitLength();
    if (delta > 0) msg = msg.ushrn(delta);
    if (!truncOnly && msg.cmp(this.n) >= 0) return msg.sub(this.n);
    else return msg;
};
$ec756589ef3c2426$var$EC.prototype.sign = function sign(msg, key, enc, options) {
    if (typeof enc === "object") {
        options = enc;
        enc = null;
    }
    if (!options) options = {};
    key = this.keyFromPrivate(key, enc);
    msg = this._truncateToN(new $73nMH(msg, 16));
    // Zero-extend key to provide enough entropy
    var bytes = this.n.byteLength();
    var bkey = key.getPrivate().toArray("be", bytes);
    // Zero-extend nonce to have the same byte size as N
    var nonce = msg.toArray("be", bytes);
    // Instantiate Hmac_DRBG
    var drbg = new $azGIt({
        hash: this.hash,
        entropy: bkey,
        nonce: nonce,
        pers: options.pers,
        persEnc: options.persEnc || "utf8"
    });
    // Number of bytes to generate
    var ns1 = this.n.sub(new $73nMH(1));
    for(var iter = 0;; iter++){
        var k = options.k ? options.k(iter) : new $73nMH(drbg.generate(this.n.byteLength()));
        k = this._truncateToN(k, true);
        if (k.cmpn(1) <= 0 || k.cmp(ns1) >= 0) continue;
        var kp = this.g.mul(k);
        if (kp.isInfinity()) continue;
        var kpX = kp.getX();
        var r = kpX.umod(this.n);
        if (r.cmpn(0) === 0) continue;
        var s = k.invm(this.n).mul(r.mul(key.getPrivate()).iadd(msg));
        s = s.umod(this.n);
        if (s.cmpn(0) === 0) continue;
        var recoveryParam = (kp.getY().isOdd() ? 1 : 0) | (kpX.cmp(r) !== 0 ? 2 : 0);
        // Use complement of `s`, if it is > `n / 2`
        if (options.canonical && s.cmp(this.nh) > 0) {
            s = this.n.sub(s);
            recoveryParam ^= 1;
        }
        return new $jZWy6({
            r: r,
            s: s,
            recoveryParam: recoveryParam
        });
    }
};
$ec756589ef3c2426$var$EC.prototype.verify = function verify(msg, signature, key, enc) {
    msg = this._truncateToN(new $73nMH(msg, 16));
    key = this.keyFromPublic(key, enc);
    signature = new $jZWy6(signature, "hex");
    // Perform primitive values validation
    var r = signature.r;
    var s = signature.s;
    if (r.cmpn(1) < 0 || r.cmp(this.n) >= 0) return false;
    if (s.cmpn(1) < 0 || s.cmp(this.n) >= 0) return false;
    // Validate signature
    var sinv = s.invm(this.n);
    var u1 = sinv.mul(msg).umod(this.n);
    var u2 = sinv.mul(r).umod(this.n);
    var p;
    if (!this.curve._maxwellTrick) {
        p = this.g.mulAdd(u1, key.getPublic(), u2);
        if (p.isInfinity()) return false;
        return p.getX().umod(this.n).cmp(r) === 0;
    }
    // NOTE: Greg Maxwell's trick, inspired by:
    // https://git.io/vad3K
    p = this.g.jmulAdd(u1, key.getPublic(), u2);
    if (p.isInfinity()) return false;
    // Compare `p.x` of Jacobian point with `r`,
    // this will do `p.x == r * p.z^2` instead of multiplying `p.x` by the
    // inverse of `p.z^2`
    return p.eqXToP(r);
};
$ec756589ef3c2426$var$EC.prototype.recoverPubKey = function(msg, signature, j, enc) {
    $ec756589ef3c2426$var$assert((3 & j) === j, "The recovery param is more than two bits");
    signature = new $jZWy6(signature, enc);
    var n = this.n;
    var e = new $73nMH(msg);
    var r = signature.r;
    var s = signature.s;
    // A set LSB signifies that the y-coordinate is odd
    var isYOdd = j & 1;
    var isSecondKey = j >> 1;
    if (r.cmp(this.curve.p.umod(this.curve.n)) >= 0 && isSecondKey) throw new Error("Unable to find sencond key candinate");
    // 1.1. Let x = r + jn.
    if (isSecondKey) r = this.curve.pointFromX(r.add(this.curve.n), isYOdd);
    else r = this.curve.pointFromX(r, isYOdd);
    var rInv = signature.r.invm(n);
    var s1 = n.sub(e).mul(rInv).umod(n);
    var s2 = s.mul(rInv).umod(n);
    // 1.6.1 Compute Q = r^-1 (sR -  eG)
    //               Q = r^-1 (sR + -eG)
    return this.g.mulAdd(s1, r, s2);
};
$ec756589ef3c2426$var$EC.prototype.getKeyRecoveryParam = function(e, signature, Q, enc) {
    signature = new $jZWy6(signature, enc);
    if (signature.recoveryParam !== null) return signature.recoveryParam;
    for(var i = 0; i < 4; i++){
        var Qprime;
        try {
            Qprime = this.recoverPubKey(e, signature, i);
        } catch (e) {
            continue;
        }
        if (Qprime.eq(Q)) return i;
    }
    throw new Error("Unable to find valid recovery factor");
};

});
parcelRequire.register("azGIt", function(module, exports) {
"use strict";

var $3RPTD = parcelRequire("3RPTD");

var $h2Wqj = parcelRequire("h2Wqj");

var $93fa9 = parcelRequire("93fa9");
function $7b2e4ed10abeff54$var$HmacDRBG(options) {
    if (!(this instanceof $7b2e4ed10abeff54$var$HmacDRBG)) return new $7b2e4ed10abeff54$var$HmacDRBG(options);
    this.hash = options.hash;
    this.predResist = !!options.predResist;
    this.outLen = this.hash.outSize;
    this.minEntropy = options.minEntropy || this.hash.hmacStrength;
    this._reseed = null;
    this.reseedInterval = null;
    this.K = null;
    this.V = null;
    var entropy = $h2Wqj.toArray(options.entropy, options.entropyEnc || "hex");
    var nonce = $h2Wqj.toArray(options.nonce, options.nonceEnc || "hex");
    var pers = $h2Wqj.toArray(options.pers, options.persEnc || "hex");
    $93fa9(entropy.length >= this.minEntropy / 8, "Not enough entropy. Minimum is: " + this.minEntropy + " bits");
    this._init(entropy, nonce, pers);
}
module.exports = $7b2e4ed10abeff54$var$HmacDRBG;
$7b2e4ed10abeff54$var$HmacDRBG.prototype._init = function init(entropy, nonce, pers) {
    var seed = entropy.concat(nonce).concat(pers);
    this.K = new Array(this.outLen / 8);
    this.V = new Array(this.outLen / 8);
    for(var i = 0; i < this.V.length; i++){
        this.K[i] = 0x00;
        this.V[i] = 0x01;
    }
    this._update(seed);
    this._reseed = 1;
    this.reseedInterval = 0x1000000000000; // 2^48
};
$7b2e4ed10abeff54$var$HmacDRBG.prototype._hmac = function hmac() {
    return new $3RPTD.hmac(this.hash, this.K);
};
$7b2e4ed10abeff54$var$HmacDRBG.prototype._update = function update(seed) {
    var kmac = this._hmac().update(this.V).update([
        0x00
    ]);
    if (seed) kmac = kmac.update(seed);
    this.K = kmac.digest();
    this.V = this._hmac().update(this.V).digest();
    if (!seed) return;
    this.K = this._hmac().update(this.V).update([
        0x01
    ]).update(seed).digest();
    this.V = this._hmac().update(this.V).digest();
};
$7b2e4ed10abeff54$var$HmacDRBG.prototype.reseed = function reseed(entropy, entropyEnc, add, addEnc) {
    // Optional entropy enc
    if (typeof entropyEnc !== "string") {
        addEnc = add;
        add = entropyEnc;
        entropyEnc = null;
    }
    entropy = $h2Wqj.toArray(entropy, entropyEnc);
    add = $h2Wqj.toArray(add, addEnc);
    $93fa9(entropy.length >= this.minEntropy / 8, "Not enough entropy. Minimum is: " + this.minEntropy + " bits");
    this._update(entropy.concat(add || []));
    this._reseed = 1;
};
$7b2e4ed10abeff54$var$HmacDRBG.prototype.generate = function generate(len, enc, add, addEnc) {
    if (this._reseed > this.reseedInterval) throw new Error("Reseed is required");
    // Optional encoding
    if (typeof enc !== "string") {
        addEnc = add;
        add = enc;
        enc = null;
    }
    // Optional additional data
    if (add) {
        add = $h2Wqj.toArray(add, addEnc || "hex");
        this._update(add);
    }
    var temp = [];
    while(temp.length < len){
        this.V = this._hmac().update(this.V).digest();
        temp = temp.concat(this.V);
    }
    var res = temp.slice(0, len);
    this._update(add);
    this._reseed++;
    return $h2Wqj.encode(res, enc);
};

});

parcelRequire.register("iFgwo", function(module, exports) {
"use strict";

var $73nMH = parcelRequire("73nMH");

var $axXvD = parcelRequire("axXvD");
var $d968df279d94816b$var$assert = $axXvD.assert;
function $d968df279d94816b$var$KeyPair(ec, options) {
    this.ec = ec;
    this.priv = null;
    this.pub = null;
    // KeyPair(ec, { priv: ..., pub: ... })
    if (options.priv) this._importPrivate(options.priv, options.privEnc);
    if (options.pub) this._importPublic(options.pub, options.pubEnc);
}
module.exports = $d968df279d94816b$var$KeyPair;
$d968df279d94816b$var$KeyPair.fromPublic = function fromPublic(ec, pub, enc) {
    if (pub instanceof $d968df279d94816b$var$KeyPair) return pub;
    return new $d968df279d94816b$var$KeyPair(ec, {
        pub: pub,
        pubEnc: enc
    });
};
$d968df279d94816b$var$KeyPair.fromPrivate = function fromPrivate(ec, priv, enc) {
    if (priv instanceof $d968df279d94816b$var$KeyPair) return priv;
    return new $d968df279d94816b$var$KeyPair(ec, {
        priv: priv,
        privEnc: enc
    });
};
$d968df279d94816b$var$KeyPair.prototype.validate = function validate() {
    var pub = this.getPublic();
    if (pub.isInfinity()) return {
        result: false,
        reason: "Invalid public key"
    };
    if (!pub.validate()) return {
        result: false,
        reason: "Public key is not a point"
    };
    if (!pub.mul(this.ec.curve.n).isInfinity()) return {
        result: false,
        reason: "Public key * N != O"
    };
    return {
        result: true,
        reason: null
    };
};
$d968df279d94816b$var$KeyPair.prototype.getPublic = function getPublic(compact, enc) {
    // compact is optional argument
    if (typeof compact === "string") {
        enc = compact;
        compact = null;
    }
    if (!this.pub) this.pub = this.ec.g.mul(this.priv);
    if (!enc) return this.pub;
    return this.pub.encode(enc, compact);
};
$d968df279d94816b$var$KeyPair.prototype.getPrivate = function getPrivate(enc) {
    if (enc === "hex") return this.priv.toString(16, 2);
    else return this.priv;
};
$d968df279d94816b$var$KeyPair.prototype._importPrivate = function _importPrivate(key, enc) {
    this.priv = new $73nMH(key, enc || 16);
    // Ensure that the priv won't be bigger than n, otherwise we may fail
    // in fixed multiplication method
    this.priv = this.priv.umod(this.ec.curve.n);
};
$d968df279d94816b$var$KeyPair.prototype._importPublic = function _importPublic(key, enc) {
    if (key.x || key.y) {
        // Montgomery points only have an `x` coordinate.
        // Weierstrass/Edwards points on the other hand have both `x` and
        // `y` coordinates.
        if (this.ec.curve.type === "mont") $d968df279d94816b$var$assert(key.x, "Need x coordinate");
        else if (this.ec.curve.type === "short" || this.ec.curve.type === "edwards") $d968df279d94816b$var$assert(key.x && key.y, "Need both x and y coordinate");
        this.pub = this.ec.curve.point(key.x, key.y);
        return;
    }
    this.pub = this.ec.curve.decodePoint(key, enc);
};
// ECDH
$d968df279d94816b$var$KeyPair.prototype.derive = function derive(pub) {
    if (!pub.validate()) $d968df279d94816b$var$assert(pub.validate(), "public point not validated");
    return pub.mul(this.priv).getX();
};
// ECDSA
$d968df279d94816b$var$KeyPair.prototype.sign = function sign(msg, enc, options) {
    return this.ec.sign(msg, this, enc, options);
};
$d968df279d94816b$var$KeyPair.prototype.verify = function verify(msg, signature) {
    return this.ec.verify(msg, signature, this);
};
$d968df279d94816b$var$KeyPair.prototype.inspect = function inspect() {
    return "<Key priv: " + (this.priv && this.priv.toString(16, 2)) + " pub: " + (this.pub && this.pub.inspect()) + " >";
};

});

parcelRequire.register("jZWy6", function(module, exports) {
"use strict";

var $73nMH = parcelRequire("73nMH");

var $axXvD = parcelRequire("axXvD");
var $03c1d31ec5765c67$var$assert = $axXvD.assert;
function $03c1d31ec5765c67$var$Signature(options, enc) {
    if (options instanceof $03c1d31ec5765c67$var$Signature) return options;
    if (this._importDER(options, enc)) return;
    $03c1d31ec5765c67$var$assert(options.r && options.s, "Signature without r or s");
    this.r = new $73nMH(options.r, 16);
    this.s = new $73nMH(options.s, 16);
    if (options.recoveryParam === undefined) this.recoveryParam = null;
    else this.recoveryParam = options.recoveryParam;
}
module.exports = $03c1d31ec5765c67$var$Signature;
function $03c1d31ec5765c67$var$Position() {
    this.place = 0;
}
function $03c1d31ec5765c67$var$getLength(buf, p) {
    var initial = buf[p.place++];
    if (!(initial & 0x80)) return initial;
    var octetLen = initial & 0xf;
    // Indefinite length or overflow
    if (octetLen === 0 || octetLen > 4) return false;
    var val = 0;
    for(var i = 0, off = p.place; i < octetLen; i++, off++){
        val <<= 8;
        val |= buf[off];
        val >>>= 0;
    }
    // Leading zeroes
    if (val <= 0x7f) return false;
    p.place = off;
    return val;
}
function $03c1d31ec5765c67$var$rmPadding(buf) {
    var i = 0;
    var len = buf.length - 1;
    while(!buf[i] && !(buf[i + 1] & 0x80) && i < len)i++;
    if (i === 0) return buf;
    return buf.slice(i);
}
$03c1d31ec5765c67$var$Signature.prototype._importDER = function _importDER(data, enc) {
    data = $axXvD.toArray(data, enc);
    var p = new $03c1d31ec5765c67$var$Position();
    if (data[p.place++] !== 0x30) return false;
    var len = $03c1d31ec5765c67$var$getLength(data, p);
    if (len === false) return false;
    if (len + p.place !== data.length) return false;
    if (data[p.place++] !== 0x02) return false;
    var rlen = $03c1d31ec5765c67$var$getLength(data, p);
    if (rlen === false) return false;
    var r = data.slice(p.place, rlen + p.place);
    p.place += rlen;
    if (data[p.place++] !== 0x02) return false;
    var slen = $03c1d31ec5765c67$var$getLength(data, p);
    if (slen === false) return false;
    if (data.length !== slen + p.place) return false;
    var s = data.slice(p.place, slen + p.place);
    if (r[0] === 0) {
        if (r[1] & 0x80) r = r.slice(1);
        else // Leading zeroes
        return false;
    }
    if (s[0] === 0) {
        if (s[1] & 0x80) s = s.slice(1);
        else // Leading zeroes
        return false;
    }
    this.r = new $73nMH(r);
    this.s = new $73nMH(s);
    this.recoveryParam = null;
    return true;
};
function $03c1d31ec5765c67$var$constructLength(arr, len) {
    if (len < 0x80) {
        arr.push(len);
        return;
    }
    var octets = 1 + (Math.log(len) / Math.LN2 >>> 3);
    arr.push(octets | 0x80);
    while(--octets)arr.push(len >>> (octets << 3) & 0xff);
    arr.push(len);
}
$03c1d31ec5765c67$var$Signature.prototype.toDER = function toDER(enc) {
    var r = this.r.toArray();
    var s = this.s.toArray();
    // Pad values
    if (r[0] & 0x80) r = [
        0
    ].concat(r);
    // Pad values
    if (s[0] & 0x80) s = [
        0
    ].concat(s);
    r = $03c1d31ec5765c67$var$rmPadding(r);
    s = $03c1d31ec5765c67$var$rmPadding(s);
    while(!s[0] && !(s[1] & 0x80))s = s.slice(1);
    var arr = [
        0x02
    ];
    $03c1d31ec5765c67$var$constructLength(arr, r.length);
    arr = arr.concat(r);
    arr.push(0x02);
    $03c1d31ec5765c67$var$constructLength(arr, s.length);
    var backHalf = arr.concat(s);
    var res = [
        0x30
    ];
    $03c1d31ec5765c67$var$constructLength(res, backHalf.length);
    res = res.concat(backHalf);
    return $axXvD.encode(res, enc);
};

});


parcelRequire.register("ds844", function(module, exports) {
"use strict";

var $3RPTD = parcelRequire("3RPTD");

var $lkAVm = parcelRequire("lkAVm");

var $axXvD = parcelRequire("axXvD");
var $9cb425593582bd7a$var$assert = $axXvD.assert;
var $9cb425593582bd7a$var$parseBytes = $axXvD.parseBytes;

var $bxiz6 = parcelRequire("bxiz6");

var $eZjku = parcelRequire("eZjku");
function $9cb425593582bd7a$var$EDDSA(curve) {
    $9cb425593582bd7a$var$assert(curve === "ed25519", "only tested with ed25519 so far");
    if (!(this instanceof $9cb425593582bd7a$var$EDDSA)) return new $9cb425593582bd7a$var$EDDSA(curve);
    curve = $lkAVm[curve].curve;
    this.curve = curve;
    this.g = curve.g;
    this.g.precompute(curve.n.bitLength() + 1);
    this.pointClass = curve.point().constructor;
    this.encodingLength = Math.ceil(curve.n.bitLength() / 8);
    this.hash = $3RPTD.sha512;
}
module.exports = $9cb425593582bd7a$var$EDDSA;
/**
* @param {Array|String} message - message bytes
* @param {Array|String|KeyPair} secret - secret bytes or a keypair
* @returns {Signature} - signature
*/ $9cb425593582bd7a$var$EDDSA.prototype.sign = function sign(message, secret) {
    message = $9cb425593582bd7a$var$parseBytes(message);
    var key = this.keyFromSecret(secret);
    var r = this.hashInt(key.messagePrefix(), message);
    var R = this.g.mul(r);
    var Rencoded = this.encodePoint(R);
    var s_ = this.hashInt(Rencoded, key.pubBytes(), message).mul(key.priv());
    var S = r.add(s_).umod(this.curve.n);
    return this.makeSignature({
        R: R,
        S: S,
        Rencoded: Rencoded
    });
};
/**
* @param {Array} message - message bytes
* @param {Array|String|Signature} sig - sig bytes
* @param {Array|String|Point|KeyPair} pub - public key
* @returns {Boolean} - true if public key matches sig of message
*/ $9cb425593582bd7a$var$EDDSA.prototype.verify = function verify(message, sig, pub) {
    message = $9cb425593582bd7a$var$parseBytes(message);
    sig = this.makeSignature(sig);
    var key = this.keyFromPublic(pub);
    var h = this.hashInt(sig.Rencoded(), key.pubBytes(), message);
    var SG = this.g.mul(sig.S());
    var RplusAh = sig.R().add(key.pub().mul(h));
    return RplusAh.eq(SG);
};
$9cb425593582bd7a$var$EDDSA.prototype.hashInt = function hashInt() {
    var hash = this.hash();
    for(var i = 0; i < arguments.length; i++)hash.update(arguments[i]);
    return $axXvD.intFromLE(hash.digest()).umod(this.curve.n);
};
$9cb425593582bd7a$var$EDDSA.prototype.keyFromPublic = function keyFromPublic(pub) {
    return $bxiz6.fromPublic(this, pub);
};
$9cb425593582bd7a$var$EDDSA.prototype.keyFromSecret = function keyFromSecret(secret) {
    return $bxiz6.fromSecret(this, secret);
};
$9cb425593582bd7a$var$EDDSA.prototype.makeSignature = function makeSignature(sig) {
    if (sig instanceof $eZjku) return sig;
    return new $eZjku(this, sig);
};
/**
* * https://tools.ietf.org/html/draft-josefsson-eddsa-ed25519-03#section-5.2
*
* EDDSA defines methods for encoding and decoding points and integers. These are
* helper convenience methods, that pass along to utility functions implied
* parameters.
*
*/ $9cb425593582bd7a$var$EDDSA.prototype.encodePoint = function encodePoint(point) {
    var enc = point.getY().toArray("le", this.encodingLength);
    enc[this.encodingLength - 1] |= point.getX().isOdd() ? 0x80 : 0;
    return enc;
};
$9cb425593582bd7a$var$EDDSA.prototype.decodePoint = function decodePoint(bytes) {
    bytes = $axXvD.parseBytes(bytes);
    var lastIx = bytes.length - 1;
    var normed = bytes.slice(0, lastIx).concat(bytes[lastIx] & -129);
    var xIsOdd = (bytes[lastIx] & 0x80) !== 0;
    var y = $axXvD.intFromLE(normed);
    return this.curve.pointFromY(y, xIsOdd);
};
$9cb425593582bd7a$var$EDDSA.prototype.encodeInt = function encodeInt(num) {
    return num.toArray("le", this.encodingLength);
};
$9cb425593582bd7a$var$EDDSA.prototype.decodeInt = function decodeInt(bytes) {
    return $axXvD.intFromLE(bytes);
};
$9cb425593582bd7a$var$EDDSA.prototype.isPoint = function isPoint(val) {
    return val instanceof this.pointClass;
};

});
parcelRequire.register("bxiz6", function(module, exports) {
"use strict";

var $axXvD = parcelRequire("axXvD");
var $86612d699b965f1b$var$assert = $axXvD.assert;
var $86612d699b965f1b$var$parseBytes = $axXvD.parseBytes;
var $86612d699b965f1b$var$cachedProperty = $axXvD.cachedProperty;
/**
* @param {EDDSA} eddsa - instance
* @param {Object} params - public/private key parameters
*
* @param {Array<Byte>} [params.secret] - secret seed bytes
* @param {Point} [params.pub] - public key point (aka `A` in eddsa terms)
* @param {Array<Byte>} [params.pub] - public key point encoded as bytes
*
*/ function $86612d699b965f1b$var$KeyPair(eddsa, params) {
    this.eddsa = eddsa;
    this._secret = $86612d699b965f1b$var$parseBytes(params.secret);
    if (eddsa.isPoint(params.pub)) this._pub = params.pub;
    else this._pubBytes = $86612d699b965f1b$var$parseBytes(params.pub);
}
$86612d699b965f1b$var$KeyPair.fromPublic = function fromPublic(eddsa, pub) {
    if (pub instanceof $86612d699b965f1b$var$KeyPair) return pub;
    return new $86612d699b965f1b$var$KeyPair(eddsa, {
        pub: pub
    });
};
$86612d699b965f1b$var$KeyPair.fromSecret = function fromSecret(eddsa, secret) {
    if (secret instanceof $86612d699b965f1b$var$KeyPair) return secret;
    return new $86612d699b965f1b$var$KeyPair(eddsa, {
        secret: secret
    });
};
$86612d699b965f1b$var$KeyPair.prototype.secret = function secret() {
    return this._secret;
};
$86612d699b965f1b$var$cachedProperty($86612d699b965f1b$var$KeyPair, "pubBytes", function pubBytes() {
    return this.eddsa.encodePoint(this.pub());
});
$86612d699b965f1b$var$cachedProperty($86612d699b965f1b$var$KeyPair, "pub", function pub() {
    if (this._pubBytes) return this.eddsa.decodePoint(this._pubBytes);
    return this.eddsa.g.mul(this.priv());
});
$86612d699b965f1b$var$cachedProperty($86612d699b965f1b$var$KeyPair, "privBytes", function privBytes() {
    var eddsa = this.eddsa;
    var hash = this.hash();
    var lastIx = eddsa.encodingLength - 1;
    var a = hash.slice(0, eddsa.encodingLength);
    a[0] &= 248;
    a[lastIx] &= 127;
    a[lastIx] |= 64;
    return a;
});
$86612d699b965f1b$var$cachedProperty($86612d699b965f1b$var$KeyPair, "priv", function priv() {
    return this.eddsa.decodeInt(this.privBytes());
});
$86612d699b965f1b$var$cachedProperty($86612d699b965f1b$var$KeyPair, "hash", function hash() {
    return this.eddsa.hash().update(this.secret()).digest();
});
$86612d699b965f1b$var$cachedProperty($86612d699b965f1b$var$KeyPair, "messagePrefix", function messagePrefix() {
    return this.hash().slice(this.eddsa.encodingLength);
});
$86612d699b965f1b$var$KeyPair.prototype.sign = function sign(message) {
    $86612d699b965f1b$var$assert(this._secret, "KeyPair can only verify");
    return this.eddsa.sign(message, this);
};
$86612d699b965f1b$var$KeyPair.prototype.verify = function verify(message, sig) {
    return this.eddsa.verify(message, sig, this);
};
$86612d699b965f1b$var$KeyPair.prototype.getSecret = function getSecret(enc) {
    $86612d699b965f1b$var$assert(this._secret, "KeyPair is public only");
    return $axXvD.encode(this.secret(), enc);
};
$86612d699b965f1b$var$KeyPair.prototype.getPublic = function getPublic(enc) {
    return $axXvD.encode(this.pubBytes(), enc);
};
module.exports = $86612d699b965f1b$var$KeyPair;

});

parcelRequire.register("eZjku", function(module, exports) {
"use strict";

var $73nMH = parcelRequire("73nMH");

var $axXvD = parcelRequire("axXvD");
var $ae95c19ae64017a3$var$assert = $axXvD.assert;
var $ae95c19ae64017a3$var$cachedProperty = $axXvD.cachedProperty;
var $ae95c19ae64017a3$var$parseBytes = $axXvD.parseBytes;
/**
* @param {EDDSA} eddsa - eddsa instance
* @param {Array<Bytes>|Object} sig -
* @param {Array<Bytes>|Point} [sig.R] - R point as Point or bytes
* @param {Array<Bytes>|bn} [sig.S] - S scalar as bn or bytes
* @param {Array<Bytes>} [sig.Rencoded] - R point encoded
* @param {Array<Bytes>} [sig.Sencoded] - S scalar encoded
*/ function $ae95c19ae64017a3$var$Signature(eddsa, sig) {
    this.eddsa = eddsa;
    if (typeof sig !== "object") sig = $ae95c19ae64017a3$var$parseBytes(sig);
    if (Array.isArray(sig)) sig = {
        R: sig.slice(0, eddsa.encodingLength),
        S: sig.slice(eddsa.encodingLength)
    };
    $ae95c19ae64017a3$var$assert(sig.R && sig.S, "Signature without R or S");
    if (eddsa.isPoint(sig.R)) this._R = sig.R;
    if (sig.S instanceof $73nMH) this._S = sig.S;
    this._Rencoded = Array.isArray(sig.R) ? sig.R : sig.Rencoded;
    this._Sencoded = Array.isArray(sig.S) ? sig.S : sig.Sencoded;
}
$ae95c19ae64017a3$var$cachedProperty($ae95c19ae64017a3$var$Signature, "S", function S() {
    return this.eddsa.decodeInt(this.Sencoded());
});
$ae95c19ae64017a3$var$cachedProperty($ae95c19ae64017a3$var$Signature, "R", function R() {
    return this.eddsa.decodePoint(this.Rencoded());
});
$ae95c19ae64017a3$var$cachedProperty($ae95c19ae64017a3$var$Signature, "Rencoded", function Rencoded() {
    return this.eddsa.encodePoint(this.R());
});
$ae95c19ae64017a3$var$cachedProperty($ae95c19ae64017a3$var$Signature, "Sencoded", function Sencoded() {
    return this.eddsa.encodeInt(this.S());
});
$ae95c19ae64017a3$var$Signature.prototype.toBytes = function toBytes() {
    return this.Rencoded().concat(this.Sencoded());
};
$ae95c19ae64017a3$var$Signature.prototype.toHex = function toHex() {
    return $axXvD.encode(this.toBytes(), "hex").toUpperCase();
};
module.exports = $ae95c19ae64017a3$var$Signature;

});



parcelRequire.register("j13Ls", function(module, exports) {

var $fD3aQ = parcelRequire("fD3aQ");

var $l7hjR = parcelRequire("l7hjR");

var $8Iy9K = parcelRequire("8Iy9K");

var $eSUIi = parcelRequire("eSUIi");

var $cW6k9 = parcelRequire("cW6k9");

var $3pA6p = parcelRequire("3pA6p");
var $dd8107d9ae30d85d$require$Buffer = $3pA6p.Buffer;
module.exports = $dd8107d9ae30d85d$var$parseKeys;
function $dd8107d9ae30d85d$var$parseKeys(buffer) {
    var password;
    if (typeof buffer === "object" && !$dd8107d9ae30d85d$require$Buffer.isBuffer(buffer)) {
        password = buffer.passphrase;
        buffer = buffer.key;
    }
    if (typeof buffer === "string") buffer = $dd8107d9ae30d85d$require$Buffer.from(buffer);
    var stripped = $8Iy9K(buffer, password);
    var type = stripped.tag;
    var data = stripped.data;
    var subtype, ndata;
    switch(type){
        case "CERTIFICATE":
            ndata = $fD3aQ.certificate.decode(data, "der").tbsCertificate.subjectPublicKeyInfo;
        // falls through
        case "PUBLIC KEY":
            if (!ndata) ndata = $fD3aQ.PublicKey.decode(data, "der");
            subtype = ndata.algorithm.algorithm.join(".");
            switch(subtype){
                case "1.2.840.113549.1.1.1":
                    return $fD3aQ.RSAPublicKey.decode(ndata.subjectPublicKey.data, "der");
                case "1.2.840.10045.2.1":
                    ndata.subjectPrivateKey = ndata.subjectPublicKey;
                    return {
                        type: "ec",
                        data: ndata
                    };
                case "1.2.840.10040.4.1":
                    ndata.algorithm.params.pub_key = $fD3aQ.DSAparam.decode(ndata.subjectPublicKey.data, "der");
                    return {
                        type: "dsa",
                        data: ndata.algorithm.params
                    };
                default:
                    throw new Error("unknown key id " + subtype);
            }
        // throw new Error('unknown key type ' + type)
        case "ENCRYPTED PRIVATE KEY":
            data = $fD3aQ.EncryptedPrivateKey.decode(data, "der");
            data = $dd8107d9ae30d85d$var$decrypt(data, password);
        // falls through
        case "PRIVATE KEY":
            ndata = $fD3aQ.PrivateKey.decode(data, "der");
            subtype = ndata.algorithm.algorithm.join(".");
            switch(subtype){
                case "1.2.840.113549.1.1.1":
                    return $fD3aQ.RSAPrivateKey.decode(ndata.subjectPrivateKey, "der");
                case "1.2.840.10045.2.1":
                    return {
                        curve: ndata.algorithm.curve,
                        privateKey: $fD3aQ.ECPrivateKey.decode(ndata.subjectPrivateKey, "der").privateKey
                    };
                case "1.2.840.10040.4.1":
                    ndata.algorithm.params.priv_key = $fD3aQ.DSAparam.decode(ndata.subjectPrivateKey, "der");
                    return {
                        type: "dsa",
                        params: ndata.algorithm.params
                    };
                default:
                    throw new Error("unknown key id " + subtype);
            }
        // throw new Error('unknown key type ' + type)
        case "RSA PUBLIC KEY":
            return $fD3aQ.RSAPublicKey.decode(data, "der");
        case "RSA PRIVATE KEY":
            return $fD3aQ.RSAPrivateKey.decode(data, "der");
        case "DSA PRIVATE KEY":
            return {
                type: "dsa",
                params: $fD3aQ.DSAPrivateKey.decode(data, "der")
            };
        case "EC PRIVATE KEY":
            data = $fD3aQ.ECPrivateKey.decode(data, "der");
            return {
                curve: data.parameters.value,
                privateKey: data.privateKey
            };
        default:
            throw new Error("unknown key type " + type);
    }
}
$dd8107d9ae30d85d$var$parseKeys.signature = $fD3aQ.signature;
function $dd8107d9ae30d85d$var$decrypt(data, password) {
    var salt = data.algorithm.decrypt.kde.kdeparams.salt;
    var iters = parseInt(data.algorithm.decrypt.kde.kdeparams.iters.toString(), 10);
    var algo = $l7hjR[data.algorithm.decrypt.cipher.algo.join(".")];
    var iv = data.algorithm.decrypt.cipher.iv;
    var cipherText = data.subjectPrivateKey;
    var keylen = parseInt(algo.split("-")[1], 10) / 8;
    var key = $cW6k9.pbkdf2Sync(password, salt, iters, keylen, "sha1");
    var cipher = $eSUIi.createDecipheriv(algo, key, iv);
    var out = [];
    out.push(cipher.update(cipherText));
    out.push(cipher.final());
    return $dd8107d9ae30d85d$require$Buffer.concat(out);
}

});
parcelRequire.register("fD3aQ", function(module, exports) {

$parcel$export(module.exports, "certificate", () => $b60cf5d3cd6d3b10$export$c98397a6eb8d0678, (v) => $b60cf5d3cd6d3b10$export$c98397a6eb8d0678 = v);
$parcel$export(module.exports, "RSAPrivateKey", () => $b60cf5d3cd6d3b10$export$f4aab6816f64fa6b, (v) => $b60cf5d3cd6d3b10$export$f4aab6816f64fa6b = v);
$parcel$export(module.exports, "RSAPublicKey", () => $b60cf5d3cd6d3b10$export$4471f5c65d097c11, (v) => $b60cf5d3cd6d3b10$export$4471f5c65d097c11 = v);
$parcel$export(module.exports, "PublicKey", () => $b60cf5d3cd6d3b10$export$ca8b6604d6ce14de, (v) => $b60cf5d3cd6d3b10$export$ca8b6604d6ce14de = v);
$parcel$export(module.exports, "PrivateKey", () => $b60cf5d3cd6d3b10$export$8f54525b330fd87b, (v) => $b60cf5d3cd6d3b10$export$8f54525b330fd87b = v);
$parcel$export(module.exports, "EncryptedPrivateKey", () => $b60cf5d3cd6d3b10$export$23cd2842b44ca3e7, (v) => $b60cf5d3cd6d3b10$export$23cd2842b44ca3e7 = v);
$parcel$export(module.exports, "DSAPrivateKey", () => $b60cf5d3cd6d3b10$export$245c9aaa9f5ce4ce, (v) => $b60cf5d3cd6d3b10$export$245c9aaa9f5ce4ce = v);
$parcel$export(module.exports, "DSAparam", () => $b60cf5d3cd6d3b10$export$8ad762e3e6399afe, (v) => $b60cf5d3cd6d3b10$export$8ad762e3e6399afe = v);
$parcel$export(module.exports, "ECPrivateKey", () => $b60cf5d3cd6d3b10$export$32ef6f92e22c6ab0, (v) => $b60cf5d3cd6d3b10$export$32ef6f92e22c6ab0 = v);
$parcel$export(module.exports, "signature", () => $b60cf5d3cd6d3b10$export$c9cd164b539ebb63, (v) => $b60cf5d3cd6d3b10$export$c9cd164b539ebb63 = v);
// from https://github.com/indutny/self-signed/blob/gh-pages/lib/asn1.js
// Fedor, you are amazing.
var $b60cf5d3cd6d3b10$export$c98397a6eb8d0678;
var $b60cf5d3cd6d3b10$export$f4aab6816f64fa6b;
var $b60cf5d3cd6d3b10$export$4471f5c65d097c11;
var $b60cf5d3cd6d3b10$export$ca8b6604d6ce14de;
var $b60cf5d3cd6d3b10$export$8f54525b330fd87b;
var $b60cf5d3cd6d3b10$export$23cd2842b44ca3e7;
var $b60cf5d3cd6d3b10$export$245c9aaa9f5ce4ce;
var $b60cf5d3cd6d3b10$export$8ad762e3e6399afe;
var $b60cf5d3cd6d3b10$export$32ef6f92e22c6ab0;
var $b60cf5d3cd6d3b10$export$c9cd164b539ebb63;
"use strict";

var $d7iYd = parcelRequire("d7iYd");

$b60cf5d3cd6d3b10$export$c98397a6eb8d0678 = (parcelRequire("ikq9H"));
var $b60cf5d3cd6d3b10$var$RSAPrivateKey = $d7iYd.define("RSAPrivateKey", function() {
    this.seq().obj(this.key("version").int(), this.key("modulus").int(), this.key("publicExponent").int(), this.key("privateExponent").int(), this.key("prime1").int(), this.key("prime2").int(), this.key("exponent1").int(), this.key("exponent2").int(), this.key("coefficient").int());
});
$b60cf5d3cd6d3b10$export$f4aab6816f64fa6b = $b60cf5d3cd6d3b10$var$RSAPrivateKey;
var $b60cf5d3cd6d3b10$var$RSAPublicKey = $d7iYd.define("RSAPublicKey", function() {
    this.seq().obj(this.key("modulus").int(), this.key("publicExponent").int());
});
$b60cf5d3cd6d3b10$export$4471f5c65d097c11 = $b60cf5d3cd6d3b10$var$RSAPublicKey;
var $b60cf5d3cd6d3b10$var$PublicKey = $d7iYd.define("SubjectPublicKeyInfo", function() {
    this.seq().obj(this.key("algorithm").use($b60cf5d3cd6d3b10$var$AlgorithmIdentifier), this.key("subjectPublicKey").bitstr());
});
$b60cf5d3cd6d3b10$export$ca8b6604d6ce14de = $b60cf5d3cd6d3b10$var$PublicKey;
var $b60cf5d3cd6d3b10$var$AlgorithmIdentifier = $d7iYd.define("AlgorithmIdentifier", function() {
    this.seq().obj(this.key("algorithm").objid(), this.key("none").null_().optional(), this.key("curve").objid().optional(), this.key("params").seq().obj(this.key("p").int(), this.key("q").int(), this.key("g").int()).optional());
});
var $b60cf5d3cd6d3b10$var$PrivateKeyInfo = $d7iYd.define("PrivateKeyInfo", function() {
    this.seq().obj(this.key("version").int(), this.key("algorithm").use($b60cf5d3cd6d3b10$var$AlgorithmIdentifier), this.key("subjectPrivateKey").octstr());
});
$b60cf5d3cd6d3b10$export$8f54525b330fd87b = $b60cf5d3cd6d3b10$var$PrivateKeyInfo;
var $b60cf5d3cd6d3b10$var$EncryptedPrivateKeyInfo = $d7iYd.define("EncryptedPrivateKeyInfo", function() {
    this.seq().obj(this.key("algorithm").seq().obj(this.key("id").objid(), this.key("decrypt").seq().obj(this.key("kde").seq().obj(this.key("id").objid(), this.key("kdeparams").seq().obj(this.key("salt").octstr(), this.key("iters").int())), this.key("cipher").seq().obj(this.key("algo").objid(), this.key("iv").octstr()))), this.key("subjectPrivateKey").octstr());
});
$b60cf5d3cd6d3b10$export$23cd2842b44ca3e7 = $b60cf5d3cd6d3b10$var$EncryptedPrivateKeyInfo;
var $b60cf5d3cd6d3b10$var$DSAPrivateKey = $d7iYd.define("DSAPrivateKey", function() {
    this.seq().obj(this.key("version").int(), this.key("p").int(), this.key("q").int(), this.key("g").int(), this.key("pub_key").int(), this.key("priv_key").int());
});
$b60cf5d3cd6d3b10$export$245c9aaa9f5ce4ce = $b60cf5d3cd6d3b10$var$DSAPrivateKey;
$b60cf5d3cd6d3b10$export$8ad762e3e6399afe = $d7iYd.define("DSAparam", function() {
    this.int();
});
var $b60cf5d3cd6d3b10$var$ECPrivateKey = $d7iYd.define("ECPrivateKey", function() {
    this.seq().obj(this.key("version").int(), this.key("privateKey").octstr(), this.key("parameters").optional().explicit(0).use($b60cf5d3cd6d3b10$var$ECParameters), this.key("publicKey").optional().explicit(1).bitstr());
});
$b60cf5d3cd6d3b10$export$32ef6f92e22c6ab0 = $b60cf5d3cd6d3b10$var$ECPrivateKey;
var $b60cf5d3cd6d3b10$var$ECParameters = $d7iYd.define("ECParameters", function() {
    this.choice({
        namedCurve: this.objid()
    });
});
$b60cf5d3cd6d3b10$export$c9cd164b539ebb63 = $d7iYd.define("signature", function() {
    this.seq().obj(this.key("r").int(), this.key("s").int());
});

});
parcelRequire.register("d7iYd", function(module, exports) {
"use strict";
const $98caa4e6c5ed8dce$var$asn1 = module.exports;

$98caa4e6c5ed8dce$var$asn1.bignum = (parcelRequire("kCR7T"));

$98caa4e6c5ed8dce$var$asn1.define = (parcelRequire("hcMEH")).define;

$98caa4e6c5ed8dce$var$asn1.base = (parcelRequire("UftQj"));

$98caa4e6c5ed8dce$var$asn1.constants = (parcelRequire("dyQed"));

$98caa4e6c5ed8dce$var$asn1.decoders = (parcelRequire("jMfDc"));

$98caa4e6c5ed8dce$var$asn1.encoders = (parcelRequire("9M0pB"));

});
parcelRequire.register("kCR7T", function(module, exports) {

(function(module1, exports) {
    "use strict";
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || "Assertion failed");
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === "le" || base === "be") {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || "be");
        }
    }
    if (typeof module1 === "object") module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== "undefined" && typeof window.Buffer !== "undefined") Buffer = window.Buffer;
        else Buffer = (parcelRequire("gR5sk")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === "object" && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === "number") return this._initNumber(number, base, endian);
        if (typeof number === "object") return this._initArray(number, base, endian);
        if (base === "hex") base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, "");
        var start = 0;
        if (number[0] === "-") {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === "le") this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== "le") return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === "number");
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === "be") for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === "le") for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this.strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // 'A' - 'F'
        if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else return c - 48 & 0xf;
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === "be") for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this.strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) r += c - 49 + 0xa;
            else if (c >= 17) r += c - 17 + 0xa;
            else r += c;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this.strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype.strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    BN.prototype.inspect = function inspect() {
        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
    };
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        "",
        "0",
        "00",
        "000",
        "0000",
        "00000",
        "000000",
        "0000000",
        "00000000",
        "000000000",
        "0000000000",
        "00000000000",
        "000000000000",
        "0000000000000",
        "00000000000000",
        "000000000000000",
        "0000000000000000",
        "00000000000000000",
        "000000000000000000",
        "0000000000000000000",
        "00000000000000000000",
        "000000000000000000000",
        "0000000000000000000000",
        "00000000000000000000000",
        "000000000000000000000000",
        "0000000000000000000000000"
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === "hex") {
            out = "";
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = "";
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = "0" + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        assert(false, "Base should be between 2 and 36");
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, "Number can only safely store up to 53 bits");
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16);
    };
    BN.prototype.toBuffer = function toBuffer(endian, length) {
        assert(typeof Buffer !== "undefined");
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, "byte array longer than desired length");
        assert(reqLength > 0, "Requested array length <= 0");
        this.strip();
        var littleEndian = endian === "le";
        var res = new ArrayType(reqLength);
        var b, i;
        var q = this.clone();
        if (!littleEndian) {
            // Assume big-endian
            for(i = 0; i < reqLength - byteLength; i++)res[i] = 0;
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[reqLength - i - 1] = b;
            }
        } else {
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[i] = b;
            }
            for(; i < reqLength; i++)res[i] = 0;
        }
        return res;
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = (num.words[off] & 1 << wbit) >>> wbit;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this.strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this.strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this.strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === "number" && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this.strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === "number" && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this.strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this.strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out.strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out.strip();
    }
    function jumboMulTo(self, num, out) {
        var fftm = new FFTM();
        return fftm.mulp(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out.strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this.strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === "number" && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this.strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === "number" && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, "imaskn works only with positive numbers");
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this.strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) < num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this.strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this.strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this.strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== "mod") {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q.strip();
        a.strip();
        // Denormalize
        if (mode !== "div" && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== "mod") div = res.div.neg();
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== "mod") div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === "div") return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === "mod") return {
                div: null,
                mod: new BN(this.modn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, "div", false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, "mod", false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, "mod", true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modn = function modn(num) {
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return acc;
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        return this.strip();
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === "number");
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this.strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, "Number is too big");
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        assert(this.negative === 0, "red works only with positives");
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, "fromRed works only with numbers in reduction context");
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, "redAdd works only with red numbers");
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, "redIAdd works only with red numbers");
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, "redSub works only with red numbers");
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, "redISub works only with red numbers");
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, "redShl works only with red numbers");
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, "redSqr works only with red numbers");
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, "redISqr works only with red numbers");
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, "redSqrt works only with red numbers");
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, "redInvm works only with red numbers");
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, "redNeg works only with red numbers");
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, "redPow(normalNum)");
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is BN v4 instance
        r.strip();
        else // r is BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, "k256", "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f");
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, "p224", "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001");
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, "p192", "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff");
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, "25519", "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed");
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === "k256") prime = new K256();
        else if (name === "p224") prime = new P224();
        else if (name === "p192") prime = new P192();
        else if (name === "p25519") prime = new P25519();
        else throw new Error("Unknown prime " + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === "string") {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), "modulus must be greater than 1");
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, "red works only with positives");
        assert(a.red, "red works only with red numbers");
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, "red works only with positives");
        assert(a.red && a.red === b.red, "red works only with red numbers");
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        return a.umod(this.m)._forceRed(this);
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});

parcelRequire.register("hcMEH", function(module, exports) {
"use strict";

var $9M0pB = parcelRequire("9M0pB");

var $jMfDc = parcelRequire("jMfDc");

var $5SAkX = parcelRequire("5SAkX");
const $c8694c9a6ef1b9f1$var$api = module.exports;
$c8694c9a6ef1b9f1$var$api.define = function define(name, body) {
    return new $c8694c9a6ef1b9f1$var$Entity(name, body);
};
function $c8694c9a6ef1b9f1$var$Entity(name, body) {
    this.name = name;
    this.body = body;
    this.decoders = {};
    this.encoders = {};
}
$c8694c9a6ef1b9f1$var$Entity.prototype._createNamed = function createNamed(Base) {
    const name = this.name;
    function Generated(entity) {
        this._initNamed(entity, name);
    }
    $5SAkX(Generated, Base);
    Generated.prototype._initNamed = function _initNamed(entity, name) {
        Base.call(this, entity, name);
    };
    return new Generated(this);
};
$c8694c9a6ef1b9f1$var$Entity.prototype._getDecoder = function _getDecoder(enc) {
    enc = enc || "der";
    // Lazily create decoder
    if (!this.decoders.hasOwnProperty(enc)) this.decoders[enc] = this._createNamed($jMfDc[enc]);
    return this.decoders[enc];
};
$c8694c9a6ef1b9f1$var$Entity.prototype.decode = function decode(data, enc, options) {
    return this._getDecoder(enc).decode(data, options);
};
$c8694c9a6ef1b9f1$var$Entity.prototype._getEncoder = function _getEncoder(enc) {
    enc = enc || "der";
    // Lazily create encoder
    if (!this.encoders.hasOwnProperty(enc)) this.encoders[enc] = this._createNamed($9M0pB[enc]);
    return this.encoders[enc];
};
$c8694c9a6ef1b9f1$var$Entity.prototype.encode = function encode(data, enc, /* internal */ reporter) {
    return this._getEncoder(enc).encode(data, reporter);
};

});
parcelRequire.register("9M0pB", function(module, exports) {
"use strict";
const $71d8ea8f25d63e46$var$encoders = module.exports;

$71d8ea8f25d63e46$var$encoders.der = (parcelRequire("6LvYo"));

$71d8ea8f25d63e46$var$encoders.pem = (parcelRequire("7g2Fz"));

});
parcelRequire.register("6LvYo", function(module, exports) {
"use strict";

var $5SAkX = parcelRequire("5SAkX");

var $lQd7x = parcelRequire("lQd7x");
var $4ecfef11494a1315$require$Buffer = $lQd7x.Buffer;

var $4pqnM = parcelRequire("4pqnM");

var $8jruE = parcelRequire("8jruE");
function $4ecfef11494a1315$var$DEREncoder(entity) {
    this.enc = "der";
    this.name = entity.name;
    this.entity = entity;
    // Construct base tree
    this.tree = new $4ecfef11494a1315$var$DERNode();
    this.tree._init(entity.body);
}
module.exports = $4ecfef11494a1315$var$DEREncoder;
$4ecfef11494a1315$var$DEREncoder.prototype.encode = function encode(data, reporter) {
    return this.tree._encode(data, reporter).join();
};
// Tree methods
function $4ecfef11494a1315$var$DERNode(parent) {
    $4pqnM.call(this, "der", parent);
}
$5SAkX($4ecfef11494a1315$var$DERNode, $4pqnM);
$4ecfef11494a1315$var$DERNode.prototype._encodeComposite = function encodeComposite(tag, primitive, cls, content) {
    const encodedTag = $4ecfef11494a1315$var$encodeTag(tag, primitive, cls, this.reporter);
    // Short form
    if (content.length < 0x80) {
        const header = $4ecfef11494a1315$require$Buffer.alloc(2);
        header[0] = encodedTag;
        header[1] = content.length;
        return this._createEncoderBuffer([
            header,
            content
        ]);
    }
    // Long form
    // Count octets required to store length
    let lenOctets = 1;
    for(let i = content.length; i >= 0x100; i >>= 8)lenOctets++;
    const header = $4ecfef11494a1315$require$Buffer.alloc(2 + lenOctets);
    header[0] = encodedTag;
    header[1] = 0x80 | lenOctets;
    for(let i = 1 + lenOctets, j = content.length; j > 0; i--, j >>= 8)header[i] = j & 0xff;
    return this._createEncoderBuffer([
        header,
        content
    ]);
};
$4ecfef11494a1315$var$DERNode.prototype._encodeStr = function encodeStr(str, tag) {
    if (tag === "bitstr") return this._createEncoderBuffer([
        str.unused | 0,
        str.data
    ]);
    else if (tag === "bmpstr") {
        const buf = $4ecfef11494a1315$require$Buffer.alloc(str.length * 2);
        for(let i = 0; i < str.length; i++)buf.writeUInt16BE(str.charCodeAt(i), i * 2);
        return this._createEncoderBuffer(buf);
    } else if (tag === "numstr") {
        if (!this._isNumstr(str)) return this.reporter.error("Encoding of string type: numstr supports only digits and space");
        return this._createEncoderBuffer(str);
    } else if (tag === "printstr") {
        if (!this._isPrintstr(str)) return this.reporter.error("Encoding of string type: printstr supports only latin upper and lower case letters, digits, space, apostrophe, left and rigth parenthesis, plus sign, comma, hyphen, dot, slash, colon, equal sign, question mark");
        return this._createEncoderBuffer(str);
    } else if (/str$/.test(tag)) return this._createEncoderBuffer(str);
    else if (tag === "objDesc") return this._createEncoderBuffer(str);
    else return this.reporter.error("Encoding of string type: " + tag + " unsupported");
};
$4ecfef11494a1315$var$DERNode.prototype._encodeObjid = function encodeObjid(id, values, relative) {
    if (typeof id === "string") {
        if (!values) return this.reporter.error("string objid given, but no values map found");
        if (!values.hasOwnProperty(id)) return this.reporter.error("objid not found in values map");
        id = values[id].split(/[\s.]+/g);
        for(let i = 0; i < id.length; i++)id[i] |= 0;
    } else if (Array.isArray(id)) {
        id = id.slice();
        for(let i = 0; i < id.length; i++)id[i] |= 0;
    }
    if (!Array.isArray(id)) return this.reporter.error("objid() should be either array or string, got: " + JSON.stringify(id));
    if (!relative) {
        if (id[1] >= 40) return this.reporter.error("Second objid identifier OOB");
        id.splice(0, 2, id[0] * 40 + id[1]);
    }
    // Count number of octets
    let size = 0;
    for(let i = 0; i < id.length; i++){
        let ident = id[i];
        for(size++; ident >= 0x80; ident >>= 7)size++;
    }
    const objid = $4ecfef11494a1315$require$Buffer.alloc(size);
    let offset = objid.length - 1;
    for(let i = id.length - 1; i >= 0; i--){
        let ident = id[i];
        objid[offset--] = ident & 0x7f;
        while((ident >>= 7) > 0)objid[offset--] = 0x80 | ident & 0x7f;
    }
    return this._createEncoderBuffer(objid);
};
function $4ecfef11494a1315$var$two(num) {
    if (num < 10) return "0" + num;
    else return num;
}
$4ecfef11494a1315$var$DERNode.prototype._encodeTime = function encodeTime(time, tag) {
    let str;
    const date = new Date(time);
    if (tag === "gentime") str = [
        $4ecfef11494a1315$var$two(date.getUTCFullYear()),
        $4ecfef11494a1315$var$two(date.getUTCMonth() + 1),
        $4ecfef11494a1315$var$two(date.getUTCDate()),
        $4ecfef11494a1315$var$two(date.getUTCHours()),
        $4ecfef11494a1315$var$two(date.getUTCMinutes()),
        $4ecfef11494a1315$var$two(date.getUTCSeconds()),
        "Z"
    ].join("");
    else if (tag === "utctime") str = [
        $4ecfef11494a1315$var$two(date.getUTCFullYear() % 100),
        $4ecfef11494a1315$var$two(date.getUTCMonth() + 1),
        $4ecfef11494a1315$var$two(date.getUTCDate()),
        $4ecfef11494a1315$var$two(date.getUTCHours()),
        $4ecfef11494a1315$var$two(date.getUTCMinutes()),
        $4ecfef11494a1315$var$two(date.getUTCSeconds()),
        "Z"
    ].join("");
    else this.reporter.error("Encoding " + tag + " time is not supported yet");
    return this._encodeStr(str, "octstr");
};
$4ecfef11494a1315$var$DERNode.prototype._encodeNull = function encodeNull() {
    return this._createEncoderBuffer("");
};
$4ecfef11494a1315$var$DERNode.prototype._encodeInt = function encodeInt(num, values) {
    if (typeof num === "string") {
        if (!values) return this.reporter.error("String int or enum given, but no values map");
        if (!values.hasOwnProperty(num)) return this.reporter.error("Values map doesn't contain: " + JSON.stringify(num));
        num = values[num];
    }
    // Bignum, assume big endian
    if (typeof num !== "number" && !$4ecfef11494a1315$require$Buffer.isBuffer(num)) {
        const numArray = num.toArray();
        if (!num.sign && numArray[0] & 0x80) numArray.unshift(0);
        num = $4ecfef11494a1315$require$Buffer.from(numArray);
    }
    if ($4ecfef11494a1315$require$Buffer.isBuffer(num)) {
        let size = num.length;
        if (num.length === 0) size++;
        const out = $4ecfef11494a1315$require$Buffer.alloc(size);
        num.copy(out);
        if (num.length === 0) out[0] = 0;
        return this._createEncoderBuffer(out);
    }
    if (num < 0x80) return this._createEncoderBuffer(num);
    if (num < 0x100) return this._createEncoderBuffer([
        0,
        num
    ]);
    let size = 1;
    for(let i = num; i >= 0x100; i >>= 8)size++;
    const out = new Array(size);
    for(let i = out.length - 1; i >= 0; i--){
        out[i] = num & 0xff;
        num >>= 8;
    }
    if (out[0] & 0x80) out.unshift(0);
    return this._createEncoderBuffer($4ecfef11494a1315$require$Buffer.from(out));
};
$4ecfef11494a1315$var$DERNode.prototype._encodeBool = function encodeBool(value) {
    return this._createEncoderBuffer(value ? 0xff : 0);
};
$4ecfef11494a1315$var$DERNode.prototype._use = function use(entity, obj) {
    if (typeof entity === "function") entity = entity(obj);
    return entity._getEncoder("der").tree;
};
$4ecfef11494a1315$var$DERNode.prototype._skipDefault = function skipDefault(dataBuffer, reporter, parent) {
    const state = this._baseState;
    let i;
    if (state["default"] === null) return false;
    const data = dataBuffer.join();
    if (state.defaultBuffer === undefined) state.defaultBuffer = this._encodeValue(state["default"], reporter, parent).join();
    if (data.length !== state.defaultBuffer.length) return false;
    for(i = 0; i < data.length; i++)if (data[i] !== state.defaultBuffer[i]) return false;
    return true;
};
// Utility methods
function $4ecfef11494a1315$var$encodeTag(tag, primitive, cls, reporter) {
    let res;
    if (tag === "seqof") tag = "seq";
    else if (tag === "setof") tag = "set";
    if ($8jruE.tagByName.hasOwnProperty(tag)) res = $8jruE.tagByName[tag];
    else if (typeof tag === "number" && (tag | 0) === tag) res = tag;
    else return reporter.error("Unknown tag: " + tag);
    if (res >= 0x1f) return reporter.error("Multi-octet tag encoding unsupported");
    if (!primitive) res |= 0x20;
    res |= $8jruE.tagClassByName[cls || "universal"] << 6;
    return res;
}

});
parcelRequire.register("lQd7x", function(module, exports) {
/* eslint-disable node/no-deprecated-api */ 
var $hIXGI = parcelRequire("hIXGI");
"use strict";

var $iuRmA = parcelRequire("iuRmA");
var $fe68a1c478e73dde$var$Buffer = $iuRmA.Buffer;
var $fe68a1c478e73dde$var$safer = {};
var $fe68a1c478e73dde$var$key;
for($fe68a1c478e73dde$var$key in $iuRmA){
    if (!$iuRmA.hasOwnProperty($fe68a1c478e73dde$var$key)) continue;
    if ($fe68a1c478e73dde$var$key === "SlowBuffer" || $fe68a1c478e73dde$var$key === "Buffer") continue;
    $fe68a1c478e73dde$var$safer[$fe68a1c478e73dde$var$key] = $iuRmA[$fe68a1c478e73dde$var$key];
}
var $fe68a1c478e73dde$var$Safer = $fe68a1c478e73dde$var$safer.Buffer = {};
for($fe68a1c478e73dde$var$key in $fe68a1c478e73dde$var$Buffer){
    if (!$fe68a1c478e73dde$var$Buffer.hasOwnProperty($fe68a1c478e73dde$var$key)) continue;
    if ($fe68a1c478e73dde$var$key === "allocUnsafe" || $fe68a1c478e73dde$var$key === "allocUnsafeSlow") continue;
    $fe68a1c478e73dde$var$Safer[$fe68a1c478e73dde$var$key] = $fe68a1c478e73dde$var$Buffer[$fe68a1c478e73dde$var$key];
}
$fe68a1c478e73dde$var$safer.Buffer.prototype = $fe68a1c478e73dde$var$Buffer.prototype;
if (!$fe68a1c478e73dde$var$Safer.from || $fe68a1c478e73dde$var$Safer.from === Uint8Array.from) $fe68a1c478e73dde$var$Safer.from = function(value, encodingOrOffset, length) {
    if (typeof value === "number") throw new TypeError('The "value" argument must not be of type number. Received type ' + typeof value);
    if (value && typeof value.length === "undefined") throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    return $fe68a1c478e73dde$var$Buffer(value, encodingOrOffset, length);
};
if (!$fe68a1c478e73dde$var$Safer.alloc) $fe68a1c478e73dde$var$Safer.alloc = function(size, fill, encoding) {
    if (typeof size !== "number") throw new TypeError('The "size" argument must be of type number. Received type ' + typeof size);
    if (size < 0 || size >= 2 * 1073741824) throw new RangeError('The value "' + size + '" is invalid for option "size"');
    var buf = $fe68a1c478e73dde$var$Buffer(size);
    if (!fill || fill.length === 0) buf.fill(0);
    else if (typeof encoding === "string") buf.fill(fill, encoding);
    else buf.fill(fill);
    return buf;
};
if (!$fe68a1c478e73dde$var$safer.kStringMaxLength) try {
    $fe68a1c478e73dde$var$safer.kStringMaxLength = $hIXGI.binding("buffer").kStringMaxLength;
} catch (e) {
// we can't determine kStringMaxLength in environments where process.binding
// is unsupported, so let's not set it
}
if (!$fe68a1c478e73dde$var$safer.constants) {
    $fe68a1c478e73dde$var$safer.constants = {
        MAX_LENGTH: $fe68a1c478e73dde$var$safer.kMaxLength
    };
    if ($fe68a1c478e73dde$var$safer.kStringMaxLength) $fe68a1c478e73dde$var$safer.constants.MAX_STRING_LENGTH = $fe68a1c478e73dde$var$safer.kStringMaxLength;
}
module.exports = $fe68a1c478e73dde$var$safer;

});

parcelRequire.register("4pqnM", function(module, exports) {
"use strict";

var $hfPoF = parcelRequire("hfPoF");
var $335df64445647598$require$Reporter = $hfPoF.Reporter;

var $1zUl1 = parcelRequire("1zUl1");
var $335df64445647598$require$EncoderBuffer = $1zUl1.EncoderBuffer;

var $1zUl1 = parcelRequire("1zUl1");
var $335df64445647598$require$DecoderBuffer = $1zUl1.DecoderBuffer;

var $93fa9 = parcelRequire("93fa9");
// Supported tags
const $335df64445647598$var$tags = [
    "seq",
    "seqof",
    "set",
    "setof",
    "objid",
    "bool",
    "gentime",
    "utctime",
    "null_",
    "enum",
    "int",
    "objDesc",
    "bitstr",
    "bmpstr",
    "charstr",
    "genstr",
    "graphstr",
    "ia5str",
    "iso646str",
    "numstr",
    "octstr",
    "printstr",
    "t61str",
    "unistr",
    "utf8str",
    "videostr"
];
// Public methods list
const $335df64445647598$var$methods = [
    "key",
    "obj",
    "use",
    "optional",
    "explicit",
    "implicit",
    "def",
    "choice",
    "any",
    "contains"
].concat($335df64445647598$var$tags);
// Overrided methods list
const $335df64445647598$var$overrided = [
    "_peekTag",
    "_decodeTag",
    "_use",
    "_decodeStr",
    "_decodeObjid",
    "_decodeTime",
    "_decodeNull",
    "_decodeInt",
    "_decodeBool",
    "_decodeList",
    "_encodeComposite",
    "_encodeStr",
    "_encodeObjid",
    "_encodeTime",
    "_encodeNull",
    "_encodeInt",
    "_encodeBool"
];
function $335df64445647598$var$Node(enc, parent, name) {
    const state = {};
    this._baseState = state;
    state.name = name;
    state.enc = enc;
    state.parent = parent || null;
    state.children = null;
    // State
    state.tag = null;
    state.args = null;
    state.reverseArgs = null;
    state.choice = null;
    state.optional = false;
    state.any = false;
    state.obj = false;
    state.use = null;
    state.useDecoder = null;
    state.key = null;
    state["default"] = null;
    state.explicit = null;
    state.implicit = null;
    state.contains = null;
    // Should create new instance on each method
    if (!state.parent) {
        state.children = [];
        this._wrap();
    }
}
module.exports = $335df64445647598$var$Node;
const $335df64445647598$var$stateProps = [
    "enc",
    "parent",
    "children",
    "tag",
    "args",
    "reverseArgs",
    "choice",
    "optional",
    "any",
    "obj",
    "use",
    "alteredUse",
    "key",
    "default",
    "explicit",
    "implicit",
    "contains"
];
$335df64445647598$var$Node.prototype.clone = function clone() {
    const state = this._baseState;
    const cstate = {};
    $335df64445647598$var$stateProps.forEach(function(prop) {
        cstate[prop] = state[prop];
    });
    const res = new this.constructor(cstate.parent);
    res._baseState = cstate;
    return res;
};
$335df64445647598$var$Node.prototype._wrap = function wrap() {
    const state = this._baseState;
    $335df64445647598$var$methods.forEach(function(method) {
        this[method] = function _wrappedMethod() {
            const clone = new this.constructor(this);
            state.children.push(clone);
            return clone[method].apply(clone, arguments);
        };
    }, this);
};
$335df64445647598$var$Node.prototype._init = function init(body) {
    const state = this._baseState;
    $93fa9(state.parent === null);
    body.call(this);
    // Filter children
    state.children = state.children.filter(function(child) {
        return child._baseState.parent === this;
    }, this);
    $93fa9.equal(state.children.length, 1, "Root node can have only one child");
};
$335df64445647598$var$Node.prototype._useArgs = function useArgs(args) {
    const state = this._baseState;
    // Filter children and args
    const children = args.filter(function(arg) {
        return arg instanceof this.constructor;
    }, this);
    args = args.filter(function(arg) {
        return !(arg instanceof this.constructor);
    }, this);
    if (children.length !== 0) {
        $93fa9(state.children === null);
        state.children = children;
        // Replace parent to maintain backward link
        children.forEach(function(child) {
            child._baseState.parent = this;
        }, this);
    }
    if (args.length !== 0) {
        $93fa9(state.args === null);
        state.args = args;
        state.reverseArgs = args.map(function(arg) {
            if (typeof arg !== "object" || arg.constructor !== Object) return arg;
            const res = {};
            Object.keys(arg).forEach(function(key) {
                if (key == (key | 0)) key |= 0;
                const value = arg[key];
                res[value] = key;
            });
            return res;
        });
    }
};
//
// Overrided methods
//
$335df64445647598$var$overrided.forEach(function(method) {
    $335df64445647598$var$Node.prototype[method] = function _overrided() {
        const state = this._baseState;
        throw new Error(method + " not implemented for encoding: " + state.enc);
    };
});
//
// Public methods
//
$335df64445647598$var$tags.forEach(function(tag) {
    $335df64445647598$var$Node.prototype[tag] = function _tagMethod() {
        const state = this._baseState;
        const args = Array.prototype.slice.call(arguments);
        $93fa9(state.tag === null);
        state.tag = tag;
        this._useArgs(args);
        return this;
    };
});
$335df64445647598$var$Node.prototype.use = function use(item) {
    $93fa9(item);
    const state = this._baseState;
    $93fa9(state.use === null);
    state.use = item;
    return this;
};
$335df64445647598$var$Node.prototype.optional = function optional() {
    const state = this._baseState;
    state.optional = true;
    return this;
};
$335df64445647598$var$Node.prototype.def = function def(val) {
    const state = this._baseState;
    $93fa9(state["default"] === null);
    state["default"] = val;
    state.optional = true;
    return this;
};
$335df64445647598$var$Node.prototype.explicit = function explicit(num) {
    const state = this._baseState;
    $93fa9(state.explicit === null && state.implicit === null);
    state.explicit = num;
    return this;
};
$335df64445647598$var$Node.prototype.implicit = function implicit(num) {
    const state = this._baseState;
    $93fa9(state.explicit === null && state.implicit === null);
    state.implicit = num;
    return this;
};
$335df64445647598$var$Node.prototype.obj = function obj() {
    const state = this._baseState;
    const args = Array.prototype.slice.call(arguments);
    state.obj = true;
    if (args.length !== 0) this._useArgs(args);
    return this;
};
$335df64445647598$var$Node.prototype.key = function key(newKey) {
    const state = this._baseState;
    $93fa9(state.key === null);
    state.key = newKey;
    return this;
};
$335df64445647598$var$Node.prototype.any = function any() {
    const state = this._baseState;
    state.any = true;
    return this;
};
$335df64445647598$var$Node.prototype.choice = function choice(obj) {
    const state = this._baseState;
    $93fa9(state.choice === null);
    state.choice = obj;
    this._useArgs(Object.keys(obj).map(function(key) {
        return obj[key];
    }));
    return this;
};
$335df64445647598$var$Node.prototype.contains = function contains(item) {
    const state = this._baseState;
    $93fa9(state.use === null);
    state.contains = item;
    return this;
};
//
// Decoding
//
$335df64445647598$var$Node.prototype._decode = function decode(input, options) {
    const state = this._baseState;
    // Decode root node
    if (state.parent === null) return input.wrapResult(state.children[0]._decode(input, options));
    let result = state["default"];
    let present = true;
    let prevKey = null;
    if (state.key !== null) prevKey = input.enterKey(state.key);
    // Check if tag is there
    if (state.optional) {
        let tag = null;
        if (state.explicit !== null) tag = state.explicit;
        else if (state.implicit !== null) tag = state.implicit;
        else if (state.tag !== null) tag = state.tag;
        if (tag === null && !state.any) {
            // Trial and Error
            const save = input.save();
            try {
                if (state.choice === null) this._decodeGeneric(state.tag, input, options);
                else this._decodeChoice(input, options);
                present = true;
            } catch (e) {
                present = false;
            }
            input.restore(save);
        } else {
            present = this._peekTag(input, tag, state.any);
            if (input.isError(present)) return present;
        }
    }
    // Push object on stack
    let prevObj;
    if (state.obj && present) prevObj = input.enterObject();
    if (present) {
        // Unwrap explicit values
        if (state.explicit !== null) {
            const explicit = this._decodeTag(input, state.explicit);
            if (input.isError(explicit)) return explicit;
            input = explicit;
        }
        const start = input.offset;
        // Unwrap implicit and normal values
        if (state.use === null && state.choice === null) {
            let save;
            if (state.any) save = input.save();
            const body = this._decodeTag(input, state.implicit !== null ? state.implicit : state.tag, state.any);
            if (input.isError(body)) return body;
            if (state.any) result = input.raw(save);
            else input = body;
        }
        if (options && options.track && state.tag !== null) options.track(input.path(), start, input.length, "tagged");
        if (options && options.track && state.tag !== null) options.track(input.path(), input.offset, input.length, "content");
        // Select proper method for tag
        if (state.any) ;
        else if (state.choice === null) result = this._decodeGeneric(state.tag, input, options);
        else result = this._decodeChoice(input, options);
        if (input.isError(result)) return result;
        // Decode children
        if (!state.any && state.choice === null && state.children !== null) state.children.forEach(function decodeChildren(child) {
            // NOTE: We are ignoring errors here, to let parser continue with other
            // parts of encoded data
            child._decode(input, options);
        });
        // Decode contained/encoded by schema, only in bit or octet strings
        if (state.contains && (state.tag === "octstr" || state.tag === "bitstr")) {
            const data = new $335df64445647598$require$DecoderBuffer(result);
            result = this._getUse(state.contains, input._reporterState.obj)._decode(data, options);
        }
    }
    // Pop object
    if (state.obj && present) result = input.leaveObject(prevObj);
    // Set key
    if (state.key !== null && (result !== null || present === true)) input.leaveKey(prevKey, state.key, result);
    else if (prevKey !== null) input.exitKey(prevKey);
    return result;
};
$335df64445647598$var$Node.prototype._decodeGeneric = function decodeGeneric(tag, input, options) {
    const state = this._baseState;
    if (tag === "seq" || tag === "set") return null;
    if (tag === "seqof" || tag === "setof") return this._decodeList(input, tag, state.args[0], options);
    else if (/str$/.test(tag)) return this._decodeStr(input, tag, options);
    else if (tag === "objid" && state.args) return this._decodeObjid(input, state.args[0], state.args[1], options);
    else if (tag === "objid") return this._decodeObjid(input, null, null, options);
    else if (tag === "gentime" || tag === "utctime") return this._decodeTime(input, tag, options);
    else if (tag === "null_") return this._decodeNull(input, options);
    else if (tag === "bool") return this._decodeBool(input, options);
    else if (tag === "objDesc") return this._decodeStr(input, tag, options);
    else if (tag === "int" || tag === "enum") return this._decodeInt(input, state.args && state.args[0], options);
    if (state.use !== null) return this._getUse(state.use, input._reporterState.obj)._decode(input, options);
    else return input.error("unknown tag: " + tag);
};
$335df64445647598$var$Node.prototype._getUse = function _getUse(entity, obj) {
    const state = this._baseState;
    // Create altered use decoder if implicit is set
    state.useDecoder = this._use(entity, obj);
    $93fa9(state.useDecoder._baseState.parent === null);
    state.useDecoder = state.useDecoder._baseState.children[0];
    if (state.implicit !== state.useDecoder._baseState.implicit) {
        state.useDecoder = state.useDecoder.clone();
        state.useDecoder._baseState.implicit = state.implicit;
    }
    return state.useDecoder;
};
$335df64445647598$var$Node.prototype._decodeChoice = function decodeChoice(input, options) {
    const state = this._baseState;
    let result = null;
    let match = false;
    Object.keys(state.choice).some(function(key) {
        const save = input.save();
        const node = state.choice[key];
        try {
            const value = node._decode(input, options);
            if (input.isError(value)) return false;
            result = {
                type: key,
                value: value
            };
            match = true;
        } catch (e) {
            input.restore(save);
            return false;
        }
        return true;
    }, this);
    if (!match) return input.error("Choice not matched");
    return result;
};
//
// Encoding
//
$335df64445647598$var$Node.prototype._createEncoderBuffer = function createEncoderBuffer(data) {
    return new $335df64445647598$require$EncoderBuffer(data, this.reporter);
};
$335df64445647598$var$Node.prototype._encode = function encode(data, reporter, parent) {
    const state = this._baseState;
    if (state["default"] !== null && state["default"] === data) return;
    const result = this._encodeValue(data, reporter, parent);
    if (result === undefined) return;
    if (this._skipDefault(result, reporter, parent)) return;
    return result;
};
$335df64445647598$var$Node.prototype._encodeValue = function encode(data, reporter, parent) {
    const state = this._baseState;
    // Decode root node
    if (state.parent === null) return state.children[0]._encode(data, reporter || new $335df64445647598$require$Reporter());
    let result = null;
    // Set reporter to share it with a child class
    this.reporter = reporter;
    // Check if data is there
    if (state.optional && data === undefined) {
        if (state["default"] !== null) data = state["default"];
        else return;
    }
    // Encode children first
    let content = null;
    let primitive = false;
    if (state.any) // Anything that was given is translated to buffer
    result = this._createEncoderBuffer(data);
    else if (state.choice) result = this._encodeChoice(data, reporter);
    else if (state.contains) {
        content = this._getUse(state.contains, parent)._encode(data, reporter);
        primitive = true;
    } else if (state.children) {
        content = state.children.map(function(child) {
            if (child._baseState.tag === "null_") return child._encode(null, reporter, data);
            if (child._baseState.key === null) return reporter.error("Child should have a key");
            const prevKey = reporter.enterKey(child._baseState.key);
            if (typeof data !== "object") return reporter.error("Child expected, but input is not object");
            const res = child._encode(data[child._baseState.key], reporter, data);
            reporter.leaveKey(prevKey);
            return res;
        }, this).filter(function(child) {
            return child;
        });
        content = this._createEncoderBuffer(content);
    } else {
        if (state.tag === "seqof" || state.tag === "setof") {
            // TODO(indutny): this should be thrown on DSL level
            if (!(state.args && state.args.length === 1)) return reporter.error("Too many args for : " + state.tag);
            if (!Array.isArray(data)) return reporter.error("seqof/setof, but data is not Array");
            const child = this.clone();
            child._baseState.implicit = null;
            content = this._createEncoderBuffer(data.map(function(item) {
                const state = this._baseState;
                return this._getUse(state.args[0], data)._encode(item, reporter);
            }, child));
        } else if (state.use !== null) result = this._getUse(state.use, parent)._encode(data, reporter);
        else {
            content = this._encodePrimitive(state.tag, data);
            primitive = true;
        }
    }
    // Encode data itself
    if (!state.any && state.choice === null) {
        const tag = state.implicit !== null ? state.implicit : state.tag;
        const cls = state.implicit === null ? "universal" : "context";
        if (tag === null) {
            if (state.use === null) reporter.error("Tag could be omitted only for .use()");
        } else if (state.use === null) result = this._encodeComposite(tag, primitive, cls, content);
    }
    // Wrap in explicit
    if (state.explicit !== null) result = this._encodeComposite(state.explicit, false, "context", result);
    return result;
};
$335df64445647598$var$Node.prototype._encodeChoice = function encodeChoice(data, reporter) {
    const state = this._baseState;
    const node = state.choice[data.type];
    if (!node) $93fa9(false, data.type + " not found in " + JSON.stringify(Object.keys(state.choice)));
    return node._encode(data.value, reporter);
};
$335df64445647598$var$Node.prototype._encodePrimitive = function encodePrimitive(tag, data) {
    const state = this._baseState;
    if (/str$/.test(tag)) return this._encodeStr(data, tag);
    else if (tag === "objid" && state.args) return this._encodeObjid(data, state.reverseArgs[0], state.args[1]);
    else if (tag === "objid") return this._encodeObjid(data, null, null);
    else if (tag === "gentime" || tag === "utctime") return this._encodeTime(data, tag);
    else if (tag === "null_") return this._encodeNull();
    else if (tag === "int" || tag === "enum") return this._encodeInt(data, state.args && state.reverseArgs[0]);
    else if (tag === "bool") return this._encodeBool(data);
    else if (tag === "objDesc") return this._encodeStr(data, tag);
    else throw new Error("Unsupported tag: " + tag);
};
$335df64445647598$var$Node.prototype._isNumstr = function isNumstr(str) {
    return /^[0-9 ]*$/.test(str);
};
$335df64445647598$var$Node.prototype._isPrintstr = function isPrintstr(str) {
    return /^[A-Za-z0-9 '()+,-./:=?]*$/.test(str);
};

});
parcelRequire.register("hfPoF", function(module, exports) {

$parcel$export(module.exports, "Reporter", () => $c8fbb4bb2d84b8c3$export$957313a2f485e5ed, (v) => $c8fbb4bb2d84b8c3$export$957313a2f485e5ed = v);
var $c8fbb4bb2d84b8c3$export$957313a2f485e5ed;
"use strict";

var $5SAkX = parcelRequire("5SAkX");
function $c8fbb4bb2d84b8c3$var$Reporter(options) {
    this._reporterState = {
        obj: null,
        path: [],
        options: options || {},
        errors: []
    };
}
$c8fbb4bb2d84b8c3$export$957313a2f485e5ed = $c8fbb4bb2d84b8c3$var$Reporter;
$c8fbb4bb2d84b8c3$var$Reporter.prototype.isError = function isError(obj) {
    return obj instanceof $c8fbb4bb2d84b8c3$var$ReporterError;
};
$c8fbb4bb2d84b8c3$var$Reporter.prototype.save = function save() {
    const state = this._reporterState;
    return {
        obj: state.obj,
        pathLen: state.path.length
    };
};
$c8fbb4bb2d84b8c3$var$Reporter.prototype.restore = function restore(data) {
    const state = this._reporterState;
    state.obj = data.obj;
    state.path = state.path.slice(0, data.pathLen);
};
$c8fbb4bb2d84b8c3$var$Reporter.prototype.enterKey = function enterKey(key) {
    return this._reporterState.path.push(key);
};
$c8fbb4bb2d84b8c3$var$Reporter.prototype.exitKey = function exitKey(index) {
    const state = this._reporterState;
    state.path = state.path.slice(0, index - 1);
};
$c8fbb4bb2d84b8c3$var$Reporter.prototype.leaveKey = function leaveKey(index, key, value) {
    const state = this._reporterState;
    this.exitKey(index);
    if (state.obj !== null) state.obj[key] = value;
};
$c8fbb4bb2d84b8c3$var$Reporter.prototype.path = function path() {
    return this._reporterState.path.join("/");
};
$c8fbb4bb2d84b8c3$var$Reporter.prototype.enterObject = function enterObject() {
    const state = this._reporterState;
    const prev = state.obj;
    state.obj = {};
    return prev;
};
$c8fbb4bb2d84b8c3$var$Reporter.prototype.leaveObject = function leaveObject(prev) {
    const state = this._reporterState;
    const now = state.obj;
    state.obj = prev;
    return now;
};
$c8fbb4bb2d84b8c3$var$Reporter.prototype.error = function error(msg) {
    let err;
    const state = this._reporterState;
    const inherited = msg instanceof $c8fbb4bb2d84b8c3$var$ReporterError;
    if (inherited) err = msg;
    else err = new $c8fbb4bb2d84b8c3$var$ReporterError(state.path.map(function(elem) {
        return "[" + JSON.stringify(elem) + "]";
    }).join(""), msg.message || msg, msg.stack);
    if (!state.options.partial) throw err;
    if (!inherited) state.errors.push(err);
    return err;
};
$c8fbb4bb2d84b8c3$var$Reporter.prototype.wrapResult = function wrapResult(result) {
    const state = this._reporterState;
    if (!state.options.partial) return result;
    return {
        result: this.isError(result) ? null : result,
        errors: state.errors
    };
};
function $c8fbb4bb2d84b8c3$var$ReporterError(path, msg) {
    this.path = path;
    this.rethrow(msg);
}
$5SAkX($c8fbb4bb2d84b8c3$var$ReporterError, Error);
$c8fbb4bb2d84b8c3$var$ReporterError.prototype.rethrow = function rethrow(msg) {
    this.message = msg + " at: " + (this.path || "(shallow)");
    if (Error.captureStackTrace) Error.captureStackTrace(this, $c8fbb4bb2d84b8c3$var$ReporterError);
    if (!this.stack) try {
        // IE only adds stack when thrown
        throw new Error(this.message);
    } catch (e) {
        this.stack = e.stack;
    }
    return this;
};

});

parcelRequire.register("1zUl1", function(module, exports) {

$parcel$export(module.exports, "DecoderBuffer", () => $1264c2e635fed401$export$bf9f79cdc4a49163, (v) => $1264c2e635fed401$export$bf9f79cdc4a49163 = v);
$parcel$export(module.exports, "EncoderBuffer", () => $1264c2e635fed401$export$8ff24f7760c7a78e, (v) => $1264c2e635fed401$export$8ff24f7760c7a78e = v);
var $1264c2e635fed401$export$bf9f79cdc4a49163;
var $1264c2e635fed401$export$8ff24f7760c7a78e;
"use strict";

var $5SAkX = parcelRequire("5SAkX");

var $hfPoF = parcelRequire("hfPoF");
var $1264c2e635fed401$require$Reporter = $hfPoF.Reporter;

var $lQd7x = parcelRequire("lQd7x");
var $1264c2e635fed401$require$Buffer = $lQd7x.Buffer;
function $1264c2e635fed401$var$DecoderBuffer(base, options) {
    $1264c2e635fed401$require$Reporter.call(this, options);
    if (!$1264c2e635fed401$require$Buffer.isBuffer(base)) {
        this.error("Input not Buffer");
        return;
    }
    this.base = base;
    this.offset = 0;
    this.length = base.length;
}
$5SAkX($1264c2e635fed401$var$DecoderBuffer, $1264c2e635fed401$require$Reporter);
$1264c2e635fed401$export$bf9f79cdc4a49163 = $1264c2e635fed401$var$DecoderBuffer;
$1264c2e635fed401$var$DecoderBuffer.isDecoderBuffer = function isDecoderBuffer(data) {
    if (data instanceof $1264c2e635fed401$var$DecoderBuffer) return true;
    // Or accept compatible API
    const isCompatible = typeof data === "object" && $1264c2e635fed401$require$Buffer.isBuffer(data.base) && data.constructor.name === "DecoderBuffer" && typeof data.offset === "number" && typeof data.length === "number" && typeof data.save === "function" && typeof data.restore === "function" && typeof data.isEmpty === "function" && typeof data.readUInt8 === "function" && typeof data.skip === "function" && typeof data.raw === "function";
    return isCompatible;
};
$1264c2e635fed401$var$DecoderBuffer.prototype.save = function save() {
    return {
        offset: this.offset,
        reporter: $1264c2e635fed401$require$Reporter.prototype.save.call(this)
    };
};
$1264c2e635fed401$var$DecoderBuffer.prototype.restore = function restore(save) {
    // Return skipped data
    const res = new $1264c2e635fed401$var$DecoderBuffer(this.base);
    res.offset = save.offset;
    res.length = this.offset;
    this.offset = save.offset;
    $1264c2e635fed401$require$Reporter.prototype.restore.call(this, save.reporter);
    return res;
};
$1264c2e635fed401$var$DecoderBuffer.prototype.isEmpty = function isEmpty() {
    return this.offset === this.length;
};
$1264c2e635fed401$var$DecoderBuffer.prototype.readUInt8 = function readUInt8(fail) {
    if (this.offset + 1 <= this.length) return this.base.readUInt8(this.offset++, true);
    else return this.error(fail || "DecoderBuffer overrun");
};
$1264c2e635fed401$var$DecoderBuffer.prototype.skip = function skip(bytes, fail) {
    if (!(this.offset + bytes <= this.length)) return this.error(fail || "DecoderBuffer overrun");
    const res = new $1264c2e635fed401$var$DecoderBuffer(this.base);
    // Share reporter state
    res._reporterState = this._reporterState;
    res.offset = this.offset;
    res.length = this.offset + bytes;
    this.offset += bytes;
    return res;
};
$1264c2e635fed401$var$DecoderBuffer.prototype.raw = function raw(save) {
    return this.base.slice(save ? save.offset : this.offset, this.length);
};
function $1264c2e635fed401$var$EncoderBuffer(value, reporter) {
    if (Array.isArray(value)) {
        this.length = 0;
        this.value = value.map(function(item) {
            if (!$1264c2e635fed401$var$EncoderBuffer.isEncoderBuffer(item)) item = new $1264c2e635fed401$var$EncoderBuffer(item, reporter);
            this.length += item.length;
            return item;
        }, this);
    } else if (typeof value === "number") {
        if (!(0 <= value && value <= 0xff)) return reporter.error("non-byte EncoderBuffer value");
        this.value = value;
        this.length = 1;
    } else if (typeof value === "string") {
        this.value = value;
        this.length = $1264c2e635fed401$require$Buffer.byteLength(value);
    } else if ($1264c2e635fed401$require$Buffer.isBuffer(value)) {
        this.value = value;
        this.length = value.length;
    } else return reporter.error("Unsupported type: " + typeof value);
}
$1264c2e635fed401$export$8ff24f7760c7a78e = $1264c2e635fed401$var$EncoderBuffer;
$1264c2e635fed401$var$EncoderBuffer.isEncoderBuffer = function isEncoderBuffer(data) {
    if (data instanceof $1264c2e635fed401$var$EncoderBuffer) return true;
    // Or accept compatible API
    const isCompatible = typeof data === "object" && data.constructor.name === "EncoderBuffer" && typeof data.length === "number" && typeof data.join === "function";
    return isCompatible;
};
$1264c2e635fed401$var$EncoderBuffer.prototype.join = function join(out, offset) {
    if (!out) out = $1264c2e635fed401$require$Buffer.alloc(this.length);
    if (!offset) offset = 0;
    if (this.length === 0) return out;
    if (Array.isArray(this.value)) this.value.forEach(function(item) {
        item.join(out, offset);
        offset += item.length;
    });
    else {
        if (typeof this.value === "number") out[offset] = this.value;
        else if (typeof this.value === "string") out.write(this.value, offset);
        else if ($1264c2e635fed401$require$Buffer.isBuffer(this.value)) this.value.copy(out, offset);
        offset += this.length;
    }
    return out;
};

});


parcelRequire.register("8jruE", function(module, exports) {

$parcel$export(module.exports, "tagClass", () => $60d56cb2a3487077$export$3584c46ed60baee8, (v) => $60d56cb2a3487077$export$3584c46ed60baee8 = v);
$parcel$export(module.exports, "tagClassByName", () => $60d56cb2a3487077$export$f18596ef8d632e49, (v) => $60d56cb2a3487077$export$f18596ef8d632e49 = v);
$parcel$export(module.exports, "tag", () => $60d56cb2a3487077$export$2b067c6666111485, (v) => $60d56cb2a3487077$export$2b067c6666111485 = v);
$parcel$export(module.exports, "tagByName", () => $60d56cb2a3487077$export$f17df38a421ab9e3, (v) => $60d56cb2a3487077$export$f17df38a421ab9e3 = v);
var $60d56cb2a3487077$export$3584c46ed60baee8;
var $60d56cb2a3487077$export$f18596ef8d632e49;
var $60d56cb2a3487077$export$2b067c6666111485;
var $60d56cb2a3487077$export$f17df38a421ab9e3;
"use strict";
// Helper
function $60d56cb2a3487077$var$reverse(map) {
    const res = {};
    Object.keys(map).forEach(function(key) {
        // Convert key to integer if it is stringified
        if ((key | 0) == key) key = key | 0;
        const value = map[key];
        res[value] = key;
    });
    return res;
}
$60d56cb2a3487077$export$3584c46ed60baee8 = {
    0: "universal",
    1: "application",
    2: "context",
    3: "private"
};
$60d56cb2a3487077$export$f18596ef8d632e49 = $60d56cb2a3487077$var$reverse($60d56cb2a3487077$export$3584c46ed60baee8);
$60d56cb2a3487077$export$2b067c6666111485 = {
    0x00: "end",
    0x01: "bool",
    0x02: "int",
    0x03: "bitstr",
    0x04: "octstr",
    0x05: "null_",
    0x06: "objid",
    0x07: "objDesc",
    0x08: "external",
    0x09: "real",
    0x0a: "enum",
    0x0b: "embed",
    0x0c: "utf8str",
    0x0d: "relativeOid",
    0x10: "seq",
    0x11: "set",
    0x12: "numstr",
    0x13: "printstr",
    0x14: "t61str",
    0x15: "videostr",
    0x16: "ia5str",
    0x17: "utctime",
    0x18: "gentime",
    0x19: "graphstr",
    0x1a: "iso646str",
    0x1b: "genstr",
    0x1c: "unistr",
    0x1d: "charstr",
    0x1e: "bmpstr"
};
$60d56cb2a3487077$export$f17df38a421ab9e3 = $60d56cb2a3487077$var$reverse($60d56cb2a3487077$export$2b067c6666111485);

});


parcelRequire.register("7g2Fz", function(module, exports) {
"use strict";

var $5SAkX = parcelRequire("5SAkX");

var $6LvYo = parcelRequire("6LvYo");
function $548c1924736debd6$var$PEMEncoder(entity) {
    $6LvYo.call(this, entity);
    this.enc = "pem";
}
$5SAkX($548c1924736debd6$var$PEMEncoder, $6LvYo);
module.exports = $548c1924736debd6$var$PEMEncoder;
$548c1924736debd6$var$PEMEncoder.prototype.encode = function encode(data, options) {
    const buf = $6LvYo.prototype.encode.call(this, data);
    const p = buf.toString("base64");
    const out = [
        "-----BEGIN " + options.label + "-----"
    ];
    for(let i = 0; i < p.length; i += 64)out.push(p.slice(i, i + 64));
    out.push("-----END " + options.label + "-----");
    return out.join("\n");
};

});


parcelRequire.register("jMfDc", function(module, exports) {
"use strict";
const $e65ea0081980b7f8$var$decoders = module.exports;

$e65ea0081980b7f8$var$decoders.der = (parcelRequire("fkSYR"));

$e65ea0081980b7f8$var$decoders.pem = (parcelRequire("cLXja"));

});
parcelRequire.register("fkSYR", function(module, exports) {
"use strict";

var $5SAkX = parcelRequire("5SAkX");

var $kCR7T = parcelRequire("kCR7T");

var $1zUl1 = parcelRequire("1zUl1");
var $b2a35f49d4224b45$require$DecoderBuffer = $1zUl1.DecoderBuffer;

var $4pqnM = parcelRequire("4pqnM");

var $8jruE = parcelRequire("8jruE");
function $b2a35f49d4224b45$var$DERDecoder(entity) {
    this.enc = "der";
    this.name = entity.name;
    this.entity = entity;
    // Construct base tree
    this.tree = new $b2a35f49d4224b45$var$DERNode();
    this.tree._init(entity.body);
}
module.exports = $b2a35f49d4224b45$var$DERDecoder;
$b2a35f49d4224b45$var$DERDecoder.prototype.decode = function decode(data, options) {
    if (!$b2a35f49d4224b45$require$DecoderBuffer.isDecoderBuffer(data)) data = new $b2a35f49d4224b45$require$DecoderBuffer(data, options);
    return this.tree._decode(data, options);
};
// Tree methods
function $b2a35f49d4224b45$var$DERNode(parent) {
    $4pqnM.call(this, "der", parent);
}
$5SAkX($b2a35f49d4224b45$var$DERNode, $4pqnM);
$b2a35f49d4224b45$var$DERNode.prototype._peekTag = function peekTag(buffer, tag, any) {
    if (buffer.isEmpty()) return false;
    const state = buffer.save();
    const decodedTag = $b2a35f49d4224b45$var$derDecodeTag(buffer, 'Failed to peek tag: "' + tag + '"');
    if (buffer.isError(decodedTag)) return decodedTag;
    buffer.restore(state);
    return decodedTag.tag === tag || decodedTag.tagStr === tag || decodedTag.tagStr + "of" === tag || any;
};
$b2a35f49d4224b45$var$DERNode.prototype._decodeTag = function decodeTag(buffer, tag, any) {
    const decodedTag = $b2a35f49d4224b45$var$derDecodeTag(buffer, 'Failed to decode tag of "' + tag + '"');
    if (buffer.isError(decodedTag)) return decodedTag;
    let len = $b2a35f49d4224b45$var$derDecodeLen(buffer, decodedTag.primitive, 'Failed to get length of "' + tag + '"');
    // Failure
    if (buffer.isError(len)) return len;
    if (!any && decodedTag.tag !== tag && decodedTag.tagStr !== tag && decodedTag.tagStr + "of" !== tag) return buffer.error('Failed to match tag: "' + tag + '"');
    if (decodedTag.primitive || len !== null) return buffer.skip(len, 'Failed to match body of: "' + tag + '"');
    // Indefinite length... find END tag
    const state = buffer.save();
    const res = this._skipUntilEnd(buffer, 'Failed to skip indefinite length body: "' + this.tag + '"');
    if (buffer.isError(res)) return res;
    len = buffer.offset - state.offset;
    buffer.restore(state);
    return buffer.skip(len, 'Failed to match body of: "' + tag + '"');
};
$b2a35f49d4224b45$var$DERNode.prototype._skipUntilEnd = function skipUntilEnd(buffer, fail) {
    for(;;){
        const tag = $b2a35f49d4224b45$var$derDecodeTag(buffer, fail);
        if (buffer.isError(tag)) return tag;
        const len = $b2a35f49d4224b45$var$derDecodeLen(buffer, tag.primitive, fail);
        if (buffer.isError(len)) return len;
        let res;
        if (tag.primitive || len !== null) res = buffer.skip(len);
        else res = this._skipUntilEnd(buffer, fail);
        // Failure
        if (buffer.isError(res)) return res;
        if (tag.tagStr === "end") break;
    }
};
$b2a35f49d4224b45$var$DERNode.prototype._decodeList = function decodeList(buffer, tag, decoder, options) {
    const result = [];
    while(!buffer.isEmpty()){
        const possibleEnd = this._peekTag(buffer, "end");
        if (buffer.isError(possibleEnd)) return possibleEnd;
        const res = decoder.decode(buffer, "der", options);
        if (buffer.isError(res) && possibleEnd) break;
        result.push(res);
    }
    return result;
};
$b2a35f49d4224b45$var$DERNode.prototype._decodeStr = function decodeStr(buffer, tag) {
    if (tag === "bitstr") {
        const unused = buffer.readUInt8();
        if (buffer.isError(unused)) return unused;
        return {
            unused: unused,
            data: buffer.raw()
        };
    } else if (tag === "bmpstr") {
        const raw = buffer.raw();
        if (raw.length % 2 === 1) return buffer.error("Decoding of string type: bmpstr length mismatch");
        let str = "";
        for(let i = 0; i < raw.length / 2; i++)str += String.fromCharCode(raw.readUInt16BE(i * 2));
        return str;
    } else if (tag === "numstr") {
        const numstr = buffer.raw().toString("ascii");
        if (!this._isNumstr(numstr)) return buffer.error("Decoding of string type: numstr unsupported characters");
        return numstr;
    } else if (tag === "octstr") return buffer.raw();
    else if (tag === "objDesc") return buffer.raw();
    else if (tag === "printstr") {
        const printstr = buffer.raw().toString("ascii");
        if (!this._isPrintstr(printstr)) return buffer.error("Decoding of string type: printstr unsupported characters");
        return printstr;
    } else if (/str$/.test(tag)) return buffer.raw().toString();
    else return buffer.error("Decoding of string type: " + tag + " unsupported");
};
$b2a35f49d4224b45$var$DERNode.prototype._decodeObjid = function decodeObjid(buffer, values, relative) {
    let result;
    const identifiers = [];
    let ident = 0;
    let subident = 0;
    while(!buffer.isEmpty()){
        subident = buffer.readUInt8();
        ident <<= 7;
        ident |= subident & 0x7f;
        if ((subident & 0x80) === 0) {
            identifiers.push(ident);
            ident = 0;
        }
    }
    if (subident & 0x80) identifiers.push(ident);
    const first = identifiers[0] / 40 | 0;
    const second = identifiers[0] % 40;
    if (relative) result = identifiers;
    else result = [
        first,
        second
    ].concat(identifiers.slice(1));
    if (values) {
        let tmp = values[result.join(" ")];
        if (tmp === undefined) tmp = values[result.join(".")];
        if (tmp !== undefined) result = tmp;
    }
    return result;
};
$b2a35f49d4224b45$var$DERNode.prototype._decodeTime = function decodeTime(buffer, tag) {
    const str = buffer.raw().toString();
    let year;
    let mon;
    let day;
    let hour;
    let min;
    let sec;
    if (tag === "gentime") {
        year = str.slice(0, 4) | 0;
        mon = str.slice(4, 6) | 0;
        day = str.slice(6, 8) | 0;
        hour = str.slice(8, 10) | 0;
        min = str.slice(10, 12) | 0;
        sec = str.slice(12, 14) | 0;
    } else if (tag === "utctime") {
        year = str.slice(0, 2) | 0;
        mon = str.slice(2, 4) | 0;
        day = str.slice(4, 6) | 0;
        hour = str.slice(6, 8) | 0;
        min = str.slice(8, 10) | 0;
        sec = str.slice(10, 12) | 0;
        if (year < 70) year = 2000 + year;
        else year = 1900 + year;
    } else return buffer.error("Decoding " + tag + " time is not supported yet");
    return Date.UTC(year, mon - 1, day, hour, min, sec, 0);
};
$b2a35f49d4224b45$var$DERNode.prototype._decodeNull = function decodeNull() {
    return null;
};
$b2a35f49d4224b45$var$DERNode.prototype._decodeBool = function decodeBool(buffer) {
    const res = buffer.readUInt8();
    if (buffer.isError(res)) return res;
    else return res !== 0;
};
$b2a35f49d4224b45$var$DERNode.prototype._decodeInt = function decodeInt(buffer, values) {
    // Bigint, return as it is (assume big endian)
    const raw = buffer.raw();
    let res = new $kCR7T(raw);
    if (values) res = values[res.toString(10)] || res;
    return res;
};
$b2a35f49d4224b45$var$DERNode.prototype._use = function use(entity, obj) {
    if (typeof entity === "function") entity = entity(obj);
    return entity._getDecoder("der").tree;
};
// Utility methods
function $b2a35f49d4224b45$var$derDecodeTag(buf, fail) {
    let tag = buf.readUInt8(fail);
    if (buf.isError(tag)) return tag;
    const cls = $8jruE.tagClass[tag >> 6];
    const primitive = (tag & 0x20) === 0;
    // Multi-octet tag - load
    if ((tag & 0x1f) === 0x1f) {
        let oct = tag;
        tag = 0;
        while((oct & 0x80) === 0x80){
            oct = buf.readUInt8(fail);
            if (buf.isError(oct)) return oct;
            tag <<= 7;
            tag |= oct & 0x7f;
        }
    } else tag &= 0x1f;
    const tagStr = $8jruE.tag[tag];
    return {
        cls: cls,
        primitive: primitive,
        tag: tag,
        tagStr: tagStr
    };
}
function $b2a35f49d4224b45$var$derDecodeLen(buf, primitive, fail) {
    let len = buf.readUInt8(fail);
    if (buf.isError(len)) return len;
    // Indefinite form
    if (!primitive && len === 0x80) return null;
    // Definite form
    if ((len & 0x80) === 0) // Short form
    return len;
    // Long form
    const num = len & 0x7f;
    if (num > 4) return buf.error("length octect is too long");
    len = 0;
    for(let i = 0; i < num; i++){
        len <<= 8;
        const j = buf.readUInt8(fail);
        if (buf.isError(j)) return j;
        len |= j;
    }
    return len;
}

});

parcelRequire.register("cLXja", function(module, exports) {
"use strict";

var $5SAkX = parcelRequire("5SAkX");

var $lQd7x = parcelRequire("lQd7x");
var $94c7e128f53ae502$require$Buffer = $lQd7x.Buffer;

var $fkSYR = parcelRequire("fkSYR");
function $94c7e128f53ae502$var$PEMDecoder(entity) {
    $fkSYR.call(this, entity);
    this.enc = "pem";
}
$5SAkX($94c7e128f53ae502$var$PEMDecoder, $fkSYR);
module.exports = $94c7e128f53ae502$var$PEMDecoder;
$94c7e128f53ae502$var$PEMDecoder.prototype.decode = function decode(data, options) {
    const lines = data.toString().split(/[\r\n]+/g);
    const label = options.label.toUpperCase();
    const re = /^-----(BEGIN|END) ([^-]+)-----$/;
    let start = -1;
    let end = -1;
    for(let i = 0; i < lines.length; i++){
        const match = lines[i].match(re);
        if (match === null) continue;
        if (match[2] !== label) continue;
        if (start === -1) {
            if (match[1] !== "BEGIN") break;
            start = i;
        } else {
            if (match[1] !== "END") break;
            end = i;
            break;
        }
    }
    if (start === -1 || end === -1) throw new Error("PEM section not found for: " + label);
    const base64 = lines.slice(start + 1, end).join("");
    // Remove excessive symbols
    base64.replace(/[^a-z0-9+/=]+/gi, "");
    const input = $94c7e128f53ae502$require$Buffer.from(base64, "base64");
    return $fkSYR.prototype.decode.call(this, input, options);
};

});



parcelRequire.register("UftQj", function(module, exports) {
"use strict";
const $0a913d263cbb1e3c$var$base = module.exports;

$0a913d263cbb1e3c$var$base.Reporter = (parcelRequire("hfPoF")).Reporter;

$0a913d263cbb1e3c$var$base.DecoderBuffer = (parcelRequire("1zUl1")).DecoderBuffer;

$0a913d263cbb1e3c$var$base.EncoderBuffer = (parcelRequire("1zUl1")).EncoderBuffer;

$0a913d263cbb1e3c$var$base.Node = (parcelRequire("4pqnM"));

});

parcelRequire.register("dyQed", function(module, exports) {
"use strict";
const $9df6f6c600f274a3$var$constants = module.exports;
// Helper
$9df6f6c600f274a3$var$constants._reverse = function reverse(map) {
    const res = {};
    Object.keys(map).forEach(function(key) {
        // Convert key to integer if it is stringified
        if ((key | 0) == key) key = key | 0;
        const value = map[key];
        res[value] = key;
    });
    return res;
};

$9df6f6c600f274a3$var$constants.der = (parcelRequire("8jruE"));

});


parcelRequire.register("ikq9H", function(module, exports) {
// from https://github.com/Rantanen/node-dtls/blob/25a7dc861bda38cfeac93a723500eea4f0ac2e86/Certificate.js
// thanks to @Rantanen
"use strict";

var $d7iYd = parcelRequire("d7iYd");
var $d57e6227b9c3a39b$var$Time = $d7iYd.define("Time", function() {
    this.choice({
        utcTime: this.utctime(),
        generalTime: this.gentime()
    });
});
var $d57e6227b9c3a39b$var$AttributeTypeValue = $d7iYd.define("AttributeTypeValue", function() {
    this.seq().obj(this.key("type").objid(), this.key("value").any());
});
var $d57e6227b9c3a39b$var$AlgorithmIdentifier = $d7iYd.define("AlgorithmIdentifier", function() {
    this.seq().obj(this.key("algorithm").objid(), this.key("parameters").optional(), this.key("curve").objid().optional());
});
var $d57e6227b9c3a39b$var$SubjectPublicKeyInfo = $d7iYd.define("SubjectPublicKeyInfo", function() {
    this.seq().obj(this.key("algorithm").use($d57e6227b9c3a39b$var$AlgorithmIdentifier), this.key("subjectPublicKey").bitstr());
});
var $d57e6227b9c3a39b$var$RelativeDistinguishedName = $d7iYd.define("RelativeDistinguishedName", function() {
    this.setof($d57e6227b9c3a39b$var$AttributeTypeValue);
});
var $d57e6227b9c3a39b$var$RDNSequence = $d7iYd.define("RDNSequence", function() {
    this.seqof($d57e6227b9c3a39b$var$RelativeDistinguishedName);
});
var $d57e6227b9c3a39b$var$Name = $d7iYd.define("Name", function() {
    this.choice({
        rdnSequence: this.use($d57e6227b9c3a39b$var$RDNSequence)
    });
});
var $d57e6227b9c3a39b$var$Validity = $d7iYd.define("Validity", function() {
    this.seq().obj(this.key("notBefore").use($d57e6227b9c3a39b$var$Time), this.key("notAfter").use($d57e6227b9c3a39b$var$Time));
});
var $d57e6227b9c3a39b$var$Extension = $d7iYd.define("Extension", function() {
    this.seq().obj(this.key("extnID").objid(), this.key("critical").bool().def(false), this.key("extnValue").octstr());
});
var $d57e6227b9c3a39b$var$TBSCertificate = $d7iYd.define("TBSCertificate", function() {
    this.seq().obj(this.key("version").explicit(0).int().optional(), this.key("serialNumber").int(), this.key("signature").use($d57e6227b9c3a39b$var$AlgorithmIdentifier), this.key("issuer").use($d57e6227b9c3a39b$var$Name), this.key("validity").use($d57e6227b9c3a39b$var$Validity), this.key("subject").use($d57e6227b9c3a39b$var$Name), this.key("subjectPublicKeyInfo").use($d57e6227b9c3a39b$var$SubjectPublicKeyInfo), this.key("issuerUniqueID").implicit(1).bitstr().optional(), this.key("subjectUniqueID").implicit(2).bitstr().optional(), this.key("extensions").explicit(3).seqof($d57e6227b9c3a39b$var$Extension).optional());
});
var $d57e6227b9c3a39b$var$X509Certificate = $d7iYd.define("X509Certificate", function() {
    this.seq().obj(this.key("tbsCertificate").use($d57e6227b9c3a39b$var$TBSCertificate), this.key("signatureAlgorithm").use($d57e6227b9c3a39b$var$AlgorithmIdentifier), this.key("signatureValue").bitstr());
});
module.exports = $d57e6227b9c3a39b$var$X509Certificate;

});


parcelRequire.register("l7hjR", function(module, exports) {
module.exports = JSON.parse('{"2.16.840.1.101.3.4.1.1":"aes-128-ecb","2.16.840.1.101.3.4.1.2":"aes-128-cbc","2.16.840.1.101.3.4.1.3":"aes-128-ofb","2.16.840.1.101.3.4.1.4":"aes-128-cfb","2.16.840.1.101.3.4.1.21":"aes-192-ecb","2.16.840.1.101.3.4.1.22":"aes-192-cbc","2.16.840.1.101.3.4.1.23":"aes-192-ofb","2.16.840.1.101.3.4.1.24":"aes-192-cfb","2.16.840.1.101.3.4.1.41":"aes-256-ecb","2.16.840.1.101.3.4.1.42":"aes-256-cbc","2.16.840.1.101.3.4.1.43":"aes-256-ofb","2.16.840.1.101.3.4.1.44":"aes-256-cfb"}');

});

parcelRequire.register("8Iy9K", function(module, exports) {
// adapted from https://github.com/apatil/pemstrip
var $658ced836ad0c087$var$findProc = /Proc-Type: 4,ENCRYPTED[\n\r]+DEK-Info: AES-((?:128)|(?:192)|(?:256))-CBC,([0-9A-H]+)[\n\r]+([0-9A-z\n\r+/=]+)[\n\r]+/m;
var $658ced836ad0c087$var$startRegex = /^-----BEGIN ((?:.*? KEY)|CERTIFICATE)-----/m;
var $658ced836ad0c087$var$fullRegex = /^-----BEGIN ((?:.*? KEY)|CERTIFICATE)-----([0-9A-z\n\r+/=]+)-----END \1-----$/m;

var $ijkRj = parcelRequire("ijkRj");

var $eSUIi = parcelRequire("eSUIi");

var $3pA6p = parcelRequire("3pA6p");
var $658ced836ad0c087$require$Buffer = $3pA6p.Buffer;
module.exports = function(okey, password) {
    var key = okey.toString();
    var match = key.match($658ced836ad0c087$var$findProc);
    var decrypted;
    if (!match) {
        var match2 = key.match($658ced836ad0c087$var$fullRegex);
        decrypted = $658ced836ad0c087$require$Buffer.from(match2[2].replace(/[\r\n]/g, ""), "base64");
    } else {
        var suite = "aes" + match[1];
        var iv = $658ced836ad0c087$require$Buffer.from(match[2], "hex");
        var cipherText = $658ced836ad0c087$require$Buffer.from(match[3].replace(/[\r\n]/g, ""), "base64");
        var cipherKey = $ijkRj(password, iv.slice(0, 8), parseInt(match[1], 10)).key;
        var out = [];
        var cipher = $eSUIi.createDecipheriv(suite, cipherKey, iv);
        out.push(cipher.update(cipherText));
        out.push(cipher.final());
        decrypted = $658ced836ad0c087$require$Buffer.concat(out);
    }
    var tag = key.match($658ced836ad0c087$var$startRegex)[1];
    return {
        tag: tag,
        data: decrypted
    };
};

});


parcelRequire.register("f6nBz", function(module, exports) {
module.exports = JSON.parse('{"1.3.132.0.10":"secp256k1","1.3.132.0.33":"p224","1.2.840.10045.3.1.1":"p192","1.2.840.10045.3.1.7":"p256","1.3.132.0.34":"p384","1.3.132.0.35":"p521"}');

});


parcelRequire.register("5q8Sv", function(module, exports) {
// much of this based on https://github.com/indutny/self-signed/blob/gh-pages/lib/rsa.js

var $8AWE0 = parcelRequire("8AWE0");
var $3f264475a90b988b$require$Buffer = $8AWE0.Buffer;

var $jNP1I = parcelRequire("jNP1I");

var $crn2y = parcelRequire("crn2y");
var $3f264475a90b988b$require$EC = $crn2y.ec;

var $j13Ls = parcelRequire("j13Ls");

var $f6nBz = parcelRequire("f6nBz");
function $3f264475a90b988b$var$verify(sig, hash, key, signType, tag) {
    var pub = $j13Ls(key);
    if (pub.type === "ec") {
        // rsa keys can be interpreted as ecdsa ones in openssl
        if (signType !== "ecdsa" && signType !== "ecdsa/rsa") throw new Error("wrong public key type");
        return $3f264475a90b988b$var$ecVerify(sig, hash, pub);
    } else if (pub.type === "dsa") {
        if (signType !== "dsa") throw new Error("wrong public key type");
        return $3f264475a90b988b$var$dsaVerify(sig, hash, pub);
    } else {
        if (signType !== "rsa" && signType !== "ecdsa/rsa") throw new Error("wrong public key type");
    }
    hash = $3f264475a90b988b$require$Buffer.concat([
        tag,
        hash
    ]);
    var len = pub.modulus.byteLength();
    var pad = [
        1
    ];
    var padNum = 0;
    while(hash.length + pad.length + 2 < len){
        pad.push(0xff);
        padNum++;
    }
    pad.push(0x00);
    var i = -1;
    while(++i < hash.length)pad.push(hash[i]);
    pad = $3f264475a90b988b$require$Buffer.from(pad);
    var red = $jNP1I.mont(pub.modulus);
    sig = new $jNP1I(sig).toRed(red);
    sig = sig.redPow(new $jNP1I(pub.publicExponent));
    sig = $3f264475a90b988b$require$Buffer.from(sig.fromRed().toArray());
    var out = padNum < 8 ? 1 : 0;
    len = Math.min(sig.length, pad.length);
    if (sig.length !== pad.length) out = 1;
    i = -1;
    while(++i < len)out |= sig[i] ^ pad[i];
    return out === 0;
}
function $3f264475a90b988b$var$ecVerify(sig, hash, pub) {
    var curveId = $f6nBz[pub.data.algorithm.curve.join(".")];
    if (!curveId) throw new Error("unknown curve " + pub.data.algorithm.curve.join("."));
    var curve = new $3f264475a90b988b$require$EC(curveId);
    var pubkey = pub.data.subjectPrivateKey.data;
    return curve.verify(hash, sig, pubkey);
}
function $3f264475a90b988b$var$dsaVerify(sig, hash, pub) {
    var p = pub.data.p;
    var q = pub.data.q;
    var g = pub.data.g;
    var y = pub.data.pub_key;
    var unpacked = $j13Ls.signature.decode(sig, "der");
    var s = unpacked.s;
    var r = unpacked.r;
    $3f264475a90b988b$var$checkValue(s, q);
    $3f264475a90b988b$var$checkValue(r, q);
    var montp = $jNP1I.mont(p);
    var w = s.invm(q);
    var v = g.toRed(montp).redPow(new $jNP1I(hash).mul(w).mod(q)).fromRed().mul(y.toRed(montp).redPow(r.mul(w).mod(q)).fromRed()).mod(p).mod(q);
    return v.cmp(r) === 0;
}
function $3f264475a90b988b$var$checkValue(b, q) {
    if (b.cmpn(0) <= 0) throw new Error("invalid sig");
    if (b.cmp(q) >= q) throw new Error("invalid sig");
}
module.exports = $3f264475a90b988b$var$verify;

});


parcelRequire.register("kcZqP", function(module, exports) {

var $cBXue = parcelRequire("cBXue");
var $eb6494ae88f50ddb$require$Buffer = $cBXue.Buffer;

var $crn2y = parcelRequire("crn2y");

var $hQJLM = parcelRequire("hQJLM");
module.exports = function createECDH(curve) {
    return new $eb6494ae88f50ddb$var$ECDH(curve);
};
var $eb6494ae88f50ddb$var$aliases = {
    secp256k1: {
        name: "secp256k1",
        byteLength: 32
    },
    secp224r1: {
        name: "p224",
        byteLength: 28
    },
    prime256v1: {
        name: "p256",
        byteLength: 32
    },
    prime192v1: {
        name: "p192",
        byteLength: 24
    },
    ed25519: {
        name: "ed25519",
        byteLength: 32
    },
    secp384r1: {
        name: "p384",
        byteLength: 48
    },
    secp521r1: {
        name: "p521",
        byteLength: 66
    }
};
$eb6494ae88f50ddb$var$aliases.p224 = $eb6494ae88f50ddb$var$aliases.secp224r1;
$eb6494ae88f50ddb$var$aliases.p256 = $eb6494ae88f50ddb$var$aliases.secp256r1 = $eb6494ae88f50ddb$var$aliases.prime256v1;
$eb6494ae88f50ddb$var$aliases.p192 = $eb6494ae88f50ddb$var$aliases.secp192r1 = $eb6494ae88f50ddb$var$aliases.prime192v1;
$eb6494ae88f50ddb$var$aliases.p384 = $eb6494ae88f50ddb$var$aliases.secp384r1;
$eb6494ae88f50ddb$var$aliases.p521 = $eb6494ae88f50ddb$var$aliases.secp521r1;
function $eb6494ae88f50ddb$var$ECDH(curve) {
    this.curveType = $eb6494ae88f50ddb$var$aliases[curve];
    if (!this.curveType) this.curveType = {
        name: curve
    };
    this.curve = new $crn2y.ec(this.curveType.name) // eslint-disable-line new-cap
    ;
    this.keys = void 0;
}
$eb6494ae88f50ddb$var$ECDH.prototype.generateKeys = function(enc, format) {
    this.keys = this.curve.genKeyPair();
    return this.getPublicKey(enc, format);
};
$eb6494ae88f50ddb$var$ECDH.prototype.computeSecret = function(other, inenc, enc) {
    inenc = inenc || "utf8";
    if (!$eb6494ae88f50ddb$require$Buffer.isBuffer(other)) other = new $eb6494ae88f50ddb$require$Buffer(other, inenc);
    var otherPub = this.curve.keyFromPublic(other).getPublic();
    var out = otherPub.mul(this.keys.getPrivate()).getX();
    return $eb6494ae88f50ddb$var$formatReturnValue(out, enc, this.curveType.byteLength);
};
$eb6494ae88f50ddb$var$ECDH.prototype.getPublicKey = function(enc, format) {
    var key = this.keys.getPublic(format === "compressed", true);
    if (format === "hybrid") {
        if (key[key.length - 1] % 2) key[0] = 7;
        else key[0] = 6;
    }
    return $eb6494ae88f50ddb$var$formatReturnValue(key, enc);
};
$eb6494ae88f50ddb$var$ECDH.prototype.getPrivateKey = function(enc) {
    return $eb6494ae88f50ddb$var$formatReturnValue(this.keys.getPrivate(), enc);
};
$eb6494ae88f50ddb$var$ECDH.prototype.setPublicKey = function(pub, enc) {
    enc = enc || "utf8";
    if (!$eb6494ae88f50ddb$require$Buffer.isBuffer(pub)) pub = new $eb6494ae88f50ddb$require$Buffer(pub, enc);
    this.keys._importPublic(pub);
    return this;
};
$eb6494ae88f50ddb$var$ECDH.prototype.setPrivateKey = function(priv, enc) {
    enc = enc || "utf8";
    if (!$eb6494ae88f50ddb$require$Buffer.isBuffer(priv)) priv = new $eb6494ae88f50ddb$require$Buffer(priv, enc);
    var _priv = new $hQJLM(priv);
    _priv = _priv.toString(16);
    this.keys = this.curve.genKeyPair();
    this.keys._importPrivate(_priv);
    return this;
};
function $eb6494ae88f50ddb$var$formatReturnValue(bn, enc, len) {
    if (!Array.isArray(bn)) bn = bn.toArray();
    var buf = new $eb6494ae88f50ddb$require$Buffer(bn);
    if (len && buf.length < len) {
        var zeros = new $eb6494ae88f50ddb$require$Buffer(len - buf.length);
        zeros.fill(0);
        buf = $eb6494ae88f50ddb$require$Buffer.concat([
            zeros,
            buf
        ]);
    }
    if (!enc) return buf;
    else return buf.toString(enc);
}

});
parcelRequire.register("hQJLM", function(module, exports) {

(function(module1, exports) {
    "use strict";
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || "Assertion failed");
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === "le" || base === "be") {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || "be");
        }
    }
    if (typeof module1 === "object") module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== "undefined" && typeof window.Buffer !== "undefined") Buffer = window.Buffer;
        else Buffer = (parcelRequire("gR5sk")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === "object" && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === "number") return this._initNumber(number, base, endian);
        if (typeof number === "object") return this._initArray(number, base, endian);
        if (base === "hex") base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, "");
        var start = 0;
        if (number[0] === "-") {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === "le") this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== "le") return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === "number");
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === "be") for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === "le") for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this.strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // 'A' - 'F'
        if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else return c - 48 & 0xf;
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === "be") for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this.strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) r += c - 49 + 0xa;
            else if (c >= 17) r += c - 17 + 0xa;
            else r += c;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this.strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype.strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    BN.prototype.inspect = function inspect() {
        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
    };
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        "",
        "0",
        "00",
        "000",
        "0000",
        "00000",
        "000000",
        "0000000",
        "00000000",
        "000000000",
        "0000000000",
        "00000000000",
        "000000000000",
        "0000000000000",
        "00000000000000",
        "000000000000000",
        "0000000000000000",
        "00000000000000000",
        "000000000000000000",
        "0000000000000000000",
        "00000000000000000000",
        "000000000000000000000",
        "0000000000000000000000",
        "00000000000000000000000",
        "000000000000000000000000",
        "0000000000000000000000000"
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === "hex") {
            out = "";
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = "";
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = "0" + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        assert(false, "Base should be between 2 and 36");
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, "Number can only safely store up to 53 bits");
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16);
    };
    BN.prototype.toBuffer = function toBuffer(endian, length) {
        assert(typeof Buffer !== "undefined");
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, "byte array longer than desired length");
        assert(reqLength > 0, "Requested array length <= 0");
        this.strip();
        var littleEndian = endian === "le";
        var res = new ArrayType(reqLength);
        var b, i;
        var q = this.clone();
        if (!littleEndian) {
            // Assume big-endian
            for(i = 0; i < reqLength - byteLength; i++)res[i] = 0;
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[reqLength - i - 1] = b;
            }
        } else {
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[i] = b;
            }
            for(; i < reqLength; i++)res[i] = 0;
        }
        return res;
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = (num.words[off] & 1 << wbit) >>> wbit;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this.strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this.strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this.strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === "number" && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this.strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === "number" && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this.strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this.strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out.strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out.strip();
    }
    function jumboMulTo(self, num, out) {
        var fftm = new FFTM();
        return fftm.mulp(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out.strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this.strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === "number" && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this.strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === "number" && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, "imaskn works only with positive numbers");
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this.strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) < num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this.strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this.strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this.strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== "mod") {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q.strip();
        a.strip();
        // Denormalize
        if (mode !== "div" && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== "mod") div = res.div.neg();
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== "mod") div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === "div") return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === "mod") return {
                div: null,
                mod: new BN(this.modn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, "div", false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, "mod", false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, "mod", true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modn = function modn(num) {
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return acc;
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        return this.strip();
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === "number");
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this.strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, "Number is too big");
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        assert(this.negative === 0, "red works only with positives");
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, "fromRed works only with numbers in reduction context");
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, "redAdd works only with red numbers");
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, "redIAdd works only with red numbers");
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, "redSub works only with red numbers");
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, "redISub works only with red numbers");
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, "redShl works only with red numbers");
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, "redSqr works only with red numbers");
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, "redISqr works only with red numbers");
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, "redSqrt works only with red numbers");
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, "redInvm works only with red numbers");
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, "redNeg works only with red numbers");
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, "redPow(normalNum)");
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is BN v4 instance
        r.strip();
        else // r is BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, "k256", "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f");
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, "p224", "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001");
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, "p192", "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff");
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, "25519", "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed");
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === "k256") prime = new K256();
        else if (name === "p224") prime = new P224();
        else if (name === "p192") prime = new P192();
        else if (name === "p25519") prime = new P25519();
        else throw new Error("Unknown prime " + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === "string") {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), "modulus must be greater than 1");
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, "red works only with positives");
        assert(a.red, "red works only with red numbers");
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, "red works only with positives");
        assert(a.red && a.red === b.red, "red works only with red numbers");
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        return a.umod(this.m)._forceRed(this);
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});


parcelRequire.register("8oEn1", function(module, exports) {

$parcel$export(module.exports, "publicEncrypt", () => $61cfe1560a52c4ad$export$512823e338ddb1b7, (v) => $61cfe1560a52c4ad$export$512823e338ddb1b7 = v);
$parcel$export(module.exports, "privateDecrypt", () => $61cfe1560a52c4ad$export$7efb24e2fddf99b9, (v) => $61cfe1560a52c4ad$export$7efb24e2fddf99b9 = v);
$parcel$export(module.exports, "privateEncrypt", () => $61cfe1560a52c4ad$export$9d0e0c0c4a8d30f3, (v) => $61cfe1560a52c4ad$export$9d0e0c0c4a8d30f3 = v);
$parcel$export(module.exports, "publicDecrypt", () => $61cfe1560a52c4ad$export$b9d55ff329113abd, (v) => $61cfe1560a52c4ad$export$b9d55ff329113abd = v);
var $61cfe1560a52c4ad$export$512823e338ddb1b7;
var $61cfe1560a52c4ad$export$7efb24e2fddf99b9;
var $61cfe1560a52c4ad$export$9d0e0c0c4a8d30f3;
var $61cfe1560a52c4ad$export$b9d55ff329113abd;

$61cfe1560a52c4ad$export$512823e338ddb1b7 = (parcelRequire("fzgug"));

$61cfe1560a52c4ad$export$7efb24e2fddf99b9 = (parcelRequire("jULeI"));
$61cfe1560a52c4ad$export$9d0e0c0c4a8d30f3 = function privateEncrypt(key, buf) {
    return $61cfe1560a52c4ad$export$512823e338ddb1b7(key, buf, true);
};
$61cfe1560a52c4ad$export$b9d55ff329113abd = function publicDecrypt(key, buf) {
    return $61cfe1560a52c4ad$export$7efb24e2fddf99b9(key, buf, true);
};

});
parcelRequire.register("fzgug", function(module, exports) {

var $j13Ls = parcelRequire("j13Ls");

var $cGE0H = parcelRequire("cGE0H");

var $bptsJ = parcelRequire("bptsJ");

var $8HFNS = parcelRequire("8HFNS");

var $irSHp = parcelRequire("irSHp");

var $dt7SM = parcelRequire("dt7SM");

var $i7can = parcelRequire("i7can");

var $9KpIc = parcelRequire("9KpIc");

var $3pA6p = parcelRequire("3pA6p");
var $b556e9e01b062a02$require$Buffer = $3pA6p.Buffer;
module.exports = function publicEncrypt(publicKey, msg, reverse) {
    var padding;
    if (publicKey.padding) padding = publicKey.padding;
    else if (reverse) padding = 1;
    else padding = 4;
    var key = $j13Ls(publicKey);
    var paddedMsg;
    if (padding === 4) paddedMsg = $b556e9e01b062a02$var$oaep(key, msg);
    else if (padding === 1) paddedMsg = $b556e9e01b062a02$var$pkcs1(key, msg, reverse);
    else if (padding === 3) {
        paddedMsg = new $dt7SM(msg);
        if (paddedMsg.cmp(key.modulus) >= 0) throw new Error("data too long for modulus");
    } else throw new Error("unknown padding");
    if (reverse) return $9KpIc(paddedMsg, key);
    else return $i7can(paddedMsg, key);
};
function $b556e9e01b062a02$var$oaep(key, msg) {
    var k = key.modulus.byteLength();
    var mLen = msg.length;
    var iHash = $bptsJ("sha1").update($b556e9e01b062a02$require$Buffer.alloc(0)).digest();
    var hLen = iHash.length;
    var hLen2 = 2 * hLen;
    if (mLen > k - hLen2 - 2) throw new Error("message too long");
    var ps = $b556e9e01b062a02$require$Buffer.alloc(k - mLen - hLen2 - 2);
    var dblen = k - hLen - 1;
    var seed = $cGE0H(hLen);
    var maskedDb = $irSHp($b556e9e01b062a02$require$Buffer.concat([
        iHash,
        ps,
        $b556e9e01b062a02$require$Buffer.alloc(1, 1),
        msg
    ], dblen), $8HFNS(seed, dblen));
    var maskedSeed = $irSHp(seed, $8HFNS(maskedDb, hLen));
    return new $dt7SM($b556e9e01b062a02$require$Buffer.concat([
        $b556e9e01b062a02$require$Buffer.alloc(1),
        maskedSeed,
        maskedDb
    ], k));
}
function $b556e9e01b062a02$var$pkcs1(key, msg, reverse) {
    var mLen = msg.length;
    var k = key.modulus.byteLength();
    if (mLen > k - 11) throw new Error("message too long");
    var ps;
    if (reverse) ps = $b556e9e01b062a02$require$Buffer.alloc(k - mLen - 3, 0xff);
    else ps = $b556e9e01b062a02$var$nonZero(k - mLen - 3);
    return new $dt7SM($b556e9e01b062a02$require$Buffer.concat([
        $b556e9e01b062a02$require$Buffer.from([
            0,
            reverse ? 1 : 2
        ]),
        ps,
        $b556e9e01b062a02$require$Buffer.alloc(1),
        msg
    ], k));
}
function $b556e9e01b062a02$var$nonZero(len) {
    var out = $b556e9e01b062a02$require$Buffer.allocUnsafe(len);
    var i = 0;
    var cache = $cGE0H(len * 2);
    var cur = 0;
    var num;
    while(i < len){
        if (cur === cache.length) {
            cache = $cGE0H(len * 2);
            cur = 0;
        }
        num = cache[cur++];
        if (num) out[i++] = num;
    }
    return out;
}

});
parcelRequire.register("8HFNS", function(module, exports) {

var $bptsJ = parcelRequire("bptsJ");

var $3pA6p = parcelRequire("3pA6p");
var $6562c432805afccc$require$Buffer = $3pA6p.Buffer;
module.exports = function(seed, len) {
    var t = $6562c432805afccc$require$Buffer.alloc(0);
    var i = 0;
    var c;
    while(t.length < len){
        c = $6562c432805afccc$var$i2ops(i++);
        t = $6562c432805afccc$require$Buffer.concat([
            t,
            $bptsJ("sha1").update(seed).update(c).digest()
        ]);
    }
    return t.slice(0, len);
};
function $6562c432805afccc$var$i2ops(c) {
    var out = $6562c432805afccc$require$Buffer.allocUnsafe(4);
    out.writeUInt32BE(c, 0);
    return out;
}

});

parcelRequire.register("irSHp", function(module, exports) {
module.exports = function xor(a, b) {
    var len = a.length;
    var i = -1;
    while(++i < len)a[i] ^= b[i];
    return a;
};

});

parcelRequire.register("dt7SM", function(module, exports) {

(function(module1, exports) {
    "use strict";
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || "Assertion failed");
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === "le" || base === "be") {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || "be");
        }
    }
    if (typeof module1 === "object") module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== "undefined" && typeof window.Buffer !== "undefined") Buffer = window.Buffer;
        else Buffer = (parcelRequire("gR5sk")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === "object" && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === "number") return this._initNumber(number, base, endian);
        if (typeof number === "object") return this._initArray(number, base, endian);
        if (base === "hex") base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, "");
        var start = 0;
        if (number[0] === "-") {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === "le") this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== "le") return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === "number");
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === "be") for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === "le") for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this.strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // 'A' - 'F'
        if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else return c - 48 & 0xf;
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === "be") for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this.strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) r += c - 49 + 0xa;
            else if (c >= 17) r += c - 17 + 0xa;
            else r += c;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this.strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype.strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    BN.prototype.inspect = function inspect() {
        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
    };
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        "",
        "0",
        "00",
        "000",
        "0000",
        "00000",
        "000000",
        "0000000",
        "00000000",
        "000000000",
        "0000000000",
        "00000000000",
        "000000000000",
        "0000000000000",
        "00000000000000",
        "000000000000000",
        "0000000000000000",
        "00000000000000000",
        "000000000000000000",
        "0000000000000000000",
        "00000000000000000000",
        "000000000000000000000",
        "0000000000000000000000",
        "00000000000000000000000",
        "000000000000000000000000",
        "0000000000000000000000000"
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === "hex") {
            out = "";
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = "";
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = "0" + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        assert(false, "Base should be between 2 and 36");
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, "Number can only safely store up to 53 bits");
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16);
    };
    BN.prototype.toBuffer = function toBuffer(endian, length) {
        assert(typeof Buffer !== "undefined");
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, "byte array longer than desired length");
        assert(reqLength > 0, "Requested array length <= 0");
        this.strip();
        var littleEndian = endian === "le";
        var res = new ArrayType(reqLength);
        var b, i;
        var q = this.clone();
        if (!littleEndian) {
            // Assume big-endian
            for(i = 0; i < reqLength - byteLength; i++)res[i] = 0;
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[reqLength - i - 1] = b;
            }
        } else {
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[i] = b;
            }
            for(; i < reqLength; i++)res[i] = 0;
        }
        return res;
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = (num.words[off] & 1 << wbit) >>> wbit;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this.strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this.strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this.strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === "number" && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this.strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === "number" && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this.strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this.strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out.strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out.strip();
    }
    function jumboMulTo(self, num, out) {
        var fftm = new FFTM();
        return fftm.mulp(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out.strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this.strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === "number" && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this.strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === "number" && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, "imaskn works only with positive numbers");
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this.strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) < num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this.strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this.strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this.strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== "mod") {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q.strip();
        a.strip();
        // Denormalize
        if (mode !== "div" && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== "mod") div = res.div.neg();
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== "mod") div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === "div") return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === "mod") return {
                div: null,
                mod: new BN(this.modn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, "div", false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, "mod", false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, "mod", true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modn = function modn(num) {
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return acc;
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        return this.strip();
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === "number");
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this.strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, "Number is too big");
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        assert(this.negative === 0, "red works only with positives");
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, "fromRed works only with numbers in reduction context");
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, "redAdd works only with red numbers");
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, "redIAdd works only with red numbers");
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, "redSub works only with red numbers");
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, "redISub works only with red numbers");
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, "redShl works only with red numbers");
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, "redSqr works only with red numbers");
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, "redISqr works only with red numbers");
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, "redSqrt works only with red numbers");
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, "redInvm works only with red numbers");
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, "redNeg works only with red numbers");
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, "redPow(normalNum)");
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is BN v4 instance
        r.strip();
        else // r is BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, "k256", "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f");
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, "p224", "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001");
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, "p192", "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff");
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, "25519", "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed");
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === "k256") prime = new K256();
        else if (name === "p224") prime = new P224();
        else if (name === "p192") prime = new P192();
        else if (name === "p25519") prime = new P25519();
        else throw new Error("Unknown prime " + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === "string") {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), "modulus must be greater than 1");
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, "red works only with positives");
        assert(a.red, "red works only with red numbers");
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, "red works only with positives");
        assert(a.red && a.red === b.red, "red works only with red numbers");
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        return a.umod(this.m)._forceRed(this);
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});

parcelRequire.register("i7can", function(module, exports) {

var $dt7SM = parcelRequire("dt7SM");

var $3pA6p = parcelRequire("3pA6p");
var $d302516a1aebaeab$require$Buffer = $3pA6p.Buffer;
function $d302516a1aebaeab$var$withPublic(paddedMsg, key) {
    return $d302516a1aebaeab$require$Buffer.from(paddedMsg.toRed($dt7SM.mont(key.modulus)).redPow(new $dt7SM(key.publicExponent)).fromRed().toArray());
}
module.exports = $d302516a1aebaeab$var$withPublic;

});


parcelRequire.register("jULeI", function(module, exports) {

var $j13Ls = parcelRequire("j13Ls");

var $8HFNS = parcelRequire("8HFNS");

var $irSHp = parcelRequire("irSHp");

var $dt7SM = parcelRequire("dt7SM");

var $9KpIc = parcelRequire("9KpIc");

var $bptsJ = parcelRequire("bptsJ");

var $i7can = parcelRequire("i7can");

var $3pA6p = parcelRequire("3pA6p");
var $e7f7e36cc3afcfbe$require$Buffer = $3pA6p.Buffer;
module.exports = function privateDecrypt(privateKey, enc, reverse) {
    var padding;
    if (privateKey.padding) padding = privateKey.padding;
    else if (reverse) padding = 1;
    else padding = 4;
    var key = $j13Ls(privateKey);
    var k = key.modulus.byteLength();
    if (enc.length > k || new $dt7SM(enc).cmp(key.modulus) >= 0) throw new Error("decryption error");
    var msg;
    if (reverse) msg = $i7can(new $dt7SM(enc), key);
    else msg = $9KpIc(enc, key);
    var zBuffer = $e7f7e36cc3afcfbe$require$Buffer.alloc(k - msg.length);
    msg = $e7f7e36cc3afcfbe$require$Buffer.concat([
        zBuffer,
        msg
    ], k);
    if (padding === 4) return $e7f7e36cc3afcfbe$var$oaep(key, msg);
    else if (padding === 1) return $e7f7e36cc3afcfbe$var$pkcs1(key, msg, reverse);
    else if (padding === 3) return msg;
    else throw new Error("unknown padding");
};
function $e7f7e36cc3afcfbe$var$oaep(key, msg) {
    var k = key.modulus.byteLength();
    var iHash = $bptsJ("sha1").update($e7f7e36cc3afcfbe$require$Buffer.alloc(0)).digest();
    var hLen = iHash.length;
    if (msg[0] !== 0) throw new Error("decryption error");
    var maskedSeed = msg.slice(1, hLen + 1);
    var maskedDb = msg.slice(hLen + 1);
    var seed = $irSHp(maskedSeed, $8HFNS(maskedDb, hLen));
    var db = $irSHp(maskedDb, $8HFNS(seed, k - hLen - 1));
    if ($e7f7e36cc3afcfbe$var$compare(iHash, db.slice(0, hLen))) throw new Error("decryption error");
    var i = hLen;
    while(db[i] === 0)i++;
    if (db[i++] !== 1) throw new Error("decryption error");
    return db.slice(i);
}
function $e7f7e36cc3afcfbe$var$pkcs1(key, msg, reverse) {
    var p1 = msg.slice(0, 2);
    var i = 2;
    var status = 0;
    while(msg[i++] !== 0)if (i >= msg.length) {
        status++;
        break;
    }
    var ps = msg.slice(2, i - 1);
    if (p1.toString("hex") !== "0002" && !reverse || p1.toString("hex") !== "0001" && reverse) status++;
    if (ps.length < 8) status++;
    if (status) throw new Error("decryption error");
    return msg.slice(i);
}
function $e7f7e36cc3afcfbe$var$compare(a, b) {
    a = $e7f7e36cc3afcfbe$require$Buffer.from(a);
    b = $e7f7e36cc3afcfbe$require$Buffer.from(b);
    var dif = 0;
    var len = a.length;
    if (a.length !== b.length) {
        dif++;
        len = Math.min(a.length, b.length);
    }
    var i = -1;
    while(++i < len)dif += a[i] ^ b[i];
    return dif;
}

});


parcelRequire.register("205kZ", function(module, exports) {

$parcel$export(module.exports, "randomFill", () => $174fb8c505ec4365$export$bb1abf2ce84fc7e8, (v) => $174fb8c505ec4365$export$bb1abf2ce84fc7e8 = v);
$parcel$export(module.exports, "randomFillSync", () => $174fb8c505ec4365$export$2f7171e78e524d5e, (v) => $174fb8c505ec4365$export$2f7171e78e524d5e = v);
var $174fb8c505ec4365$export$bb1abf2ce84fc7e8;
var $174fb8c505ec4365$export$2f7171e78e524d5e;

var $hIXGI = parcelRequire("hIXGI");
"use strict";
function $174fb8c505ec4365$var$oldBrowser() {
    throw new Error("secure random number generation not supported by this browser\nuse chrome, FireFox or Internet Explorer 11");
}

var $3pA6p = parcelRequire("3pA6p");

var $cGE0H = parcelRequire("cGE0H");
var $174fb8c505ec4365$var$Buffer = $3pA6p.Buffer;
var $174fb8c505ec4365$var$kBufferMaxLength = $3pA6p.kMaxLength;
var $174fb8c505ec4365$var$crypto = $parcel$global.crypto || $parcel$global.msCrypto;
var $174fb8c505ec4365$var$kMaxUint32 = Math.pow(2, 32) - 1;
function $174fb8c505ec4365$var$assertOffset(offset, length) {
    if (typeof offset !== "number" || offset !== offset) throw new TypeError("offset must be a number");
    if (offset > $174fb8c505ec4365$var$kMaxUint32 || offset < 0) throw new TypeError("offset must be a uint32");
    if (offset > $174fb8c505ec4365$var$kBufferMaxLength || offset > length) throw new RangeError("offset out of range");
}
function $174fb8c505ec4365$var$assertSize(size, offset, length) {
    if (typeof size !== "number" || size !== size) throw new TypeError("size must be a number");
    if (size > $174fb8c505ec4365$var$kMaxUint32 || size < 0) throw new TypeError("size must be a uint32");
    if (size + offset > length || size > $174fb8c505ec4365$var$kBufferMaxLength) throw new RangeError("buffer too small");
}
if ($174fb8c505ec4365$var$crypto && $174fb8c505ec4365$var$crypto.getRandomValues || false) {
    $174fb8c505ec4365$export$bb1abf2ce84fc7e8 = $174fb8c505ec4365$var$randomFill;
    $174fb8c505ec4365$export$2f7171e78e524d5e = $174fb8c505ec4365$var$randomFillSync;
} else {
    $174fb8c505ec4365$export$bb1abf2ce84fc7e8 = $174fb8c505ec4365$var$oldBrowser;
    $174fb8c505ec4365$export$2f7171e78e524d5e = $174fb8c505ec4365$var$oldBrowser;
}
function $174fb8c505ec4365$var$randomFill(buf, offset, size, cb) {
    if (!$174fb8c505ec4365$var$Buffer.isBuffer(buf) && !(buf instanceof $parcel$global.Uint8Array)) throw new TypeError('"buf" argument must be a Buffer or Uint8Array');
    if (typeof offset === "function") {
        cb = offset;
        offset = 0;
        size = buf.length;
    } else if (typeof size === "function") {
        cb = size;
        size = buf.length - offset;
    } else if (typeof cb !== "function") throw new TypeError('"cb" argument must be a function');
    $174fb8c505ec4365$var$assertOffset(offset, buf.length);
    $174fb8c505ec4365$var$assertSize(size, offset, buf.length);
    return $174fb8c505ec4365$var$actualFill(buf, offset, size, cb);
}
function $174fb8c505ec4365$var$actualFill(buf, offset, size, cb) {
    var ourBuf = buf.buffer;
    var uint = new Uint8Array(ourBuf, offset, size);
    $174fb8c505ec4365$var$crypto.getRandomValues(uint);
    if (cb) {
        $hIXGI.nextTick(function() {
            cb(null, buf);
        });
        return;
    }
    return buf;
    if (cb) {
        $cGE0H(size, function(err, bytes) {
            if (err) return cb(err);
            bytes.copy(buf, offset);
            cb(null, buf);
        });
        return;
    }
    var bytes = $cGE0H(size);
    bytes.copy(buf, offset);
    return buf;
}
function $174fb8c505ec4365$var$randomFillSync(buf, offset, size) {
    if (typeof offset === "undefined") offset = 0;
    if (!$174fb8c505ec4365$var$Buffer.isBuffer(buf) && !(buf instanceof $parcel$global.Uint8Array)) throw new TypeError('"buf" argument must be a Buffer or Uint8Array');
    $174fb8c505ec4365$var$assertOffset(offset, buf.length);
    if (size === undefined) size = buf.length - offset;
    $174fb8c505ec4365$var$assertSize(size, offset, buf.length);
    return $174fb8c505ec4365$var$actualFill(buf, offset, size);
}

});



parcelRequire.register("dD14r", function(module, exports) {

var $hIXGI = parcelRequire("hIXGI");
"use strict";

var $eRdtr = parcelRequire("eRdtr");

var $2PcSP = parcelRequire("2PcSP");

var $aaypF = parcelRequire("aaypF");

var $gR5sk = parcelRequire("gR5sk");
module.exports = function check(options, cb) {
    var sync = true;
    var req;
    function done(err, data) {
        if (sync) {
            sync = false;
            $hIXGI.nextTick(function() {
                cb(err, data);
            });
            return;
        }
        cb(err, data);
    }
    try {
        req = $eRdtr.request.generate(options.cert, options.issuer);
    } catch (e) {
        return done(e);
    }
    var ocspMethod = $gR5sk["id-pkix-ocsp"].join(".");
    $eRdtr.utils.getAuthorityInfo(req.cert, ocspMethod, function(err, uri) {
        if (err) return done(err);
        var httpOptions;
        if (options.httpOptions !== undefined) httpOptions = $2PcSP._extend(options.httpOptions, $aaypF.parse(uri));
        else httpOptions = uri;
        $eRdtr.utils.getResponse(httpOptions, req.data, function(err, raw) {
            if (err) return done(err);
            $eRdtr.verify({
                request: req,
                response: raw
            }, done);
        });
    });
    sync = false;
};

});

parcelRequire.register("1a35T", function(module, exports) {

var $hIXGI = parcelRequire("hIXGI");
"use strict";

var $eRdtr = parcelRequire("eRdtr");

var $gR5sk = parcelRequire("gR5sk");

var $BAx0W = parcelRequire("BAx0W");
// TODO(indutny): verify issuer, etc...
function $0d89200d434cda8d$var$findResponder(issuer, certs, raws) {
    var issuerKey = issuer.tbsCertificate.subjectPublicKeyInfo;
    issuerKey = $eRdtr.utils.toPEM($gR5sk.SubjectPublicKeyInfo.encode(issuerKey, "der"), "PUBLIC KEY");
    for(var i = 0; i < certs.length; i++){
        var cert = certs[i];
        var signAlg = $eRdtr.utils.sign[cert.signatureAlgorithm.algorithm.join(".")];
        if (!signAlg) throw new Error("Unknown signature algorithm " + cert.signatureAlgorithm.algorithm);
        var verify = $BAx0W.createVerify(signAlg);
        verify.update(raws[i]);
        if (!verify.verify(issuerKey, cert.signature.data)) throw new Error("Invalid signature");
        var certKey = cert.tbsCertificate.subjectPublicKeyInfo;
        certKey = $eRdtr.utils.toPEM($gR5sk.SubjectPublicKeyInfo.encode(certKey, "der"), "PUBLIC KEY");
        return certKey;
    }
    return issuerKey;
}
module.exports = function verify(options, cb) {
    var req = options.request;
    var issuer;
    var res;
    function done(err) {
        $hIXGI.nextTick(function() {
            cb(err, res && res.certStatus);
        });
    }
    try {
        issuer = req.issuer || $gR5sk.Certificate.decode($eRdtr.utils.toDER(options.issuer, "CERTIFICATE"), "der");
        res = $eRdtr.utils.parseResponse(options.response);
    } catch (e) {
        return done(e);
    }
    var rawTBS = options.response.slice(res.start, res.end);
    var certs = res.certs;
    var raws = res.certsTbs.map(function(tbs) {
        return options.response.slice(tbs.start, tbs.end);
    });
    res = res.value;
    // Verify signature using CAs Public Key
    var signAlg = $eRdtr.utils.sign[res.signatureAlgorithm.algorithm.join(".")];
    if (!signAlg) {
        done(new Error("Unknown signature algorithm " + res.signatureAlgorithm.algorithm));
        return;
    }
    var responderKey = $0d89200d434cda8d$var$findResponder(issuer, certs, raws);
    var verify = $BAx0W.createVerify(signAlg);
    var tbs = res.tbsResponseData;
    var signature = res.signature.data;
    verify.update(rawTBS);
    if (!verify.verify(responderKey, signature)) return done(new Error("Invalid signature"));
    if (tbs.responses.length < 1) return done(new Error("Expected at least one response"));
    var res = tbs.responses[0];
    // Verify CertID
    // XXX(indutny): verify parameters
    if (res.certId.hashAlgorithm.algorithm.join(".") !== req.certID.hashAlgorithm.algorithm.join(".")) return done(new Error("Hash algorithm mismatch"));
    if (res.certId.issuerNameHash.toString("hex") !== req.certID.issuerNameHash.toString("hex")) return done(new Error("Issuer name hash mismatch"));
    if (res.certId.issuerKeyHash.toString("hex") !== req.certID.issuerKeyHash.toString("hex")) return done(new Error("Issuer key hash mismatch"));
    if (res.certId.serialNumber.cmp(req.certID.serialNumber) !== 0) return done(new Error("Serial number mismatch"));
    if (res.certStatus.type !== "good") return done(new Error("OCSP Status: " + res.certStatus.type));
    var now = +new Date();
    var nudge = options.nudge || 60000;
    if (res.thisUpdate - nudge > now || res.nextUpdate + nudge < now) return done(new Error("OCSP Response expired"));
    return done(null);
};

});

parcelRequire.register("dNFSU", function(module, exports) {

$parcel$export(module.exports, "id-ad-caIssuers", () => $a0c05760304c3030$export$4fec380fe713e5f0, (v) => $a0c05760304c3030$export$4fec380fe713e5f0 = v);
$parcel$export(module.exports, "id-kp-OCSPSigning", () => $a0c05760304c3030$export$cc129aae36a95970, (v) => $a0c05760304c3030$export$cc129aae36a95970 = v);
$parcel$export(module.exports, "getResponse", () => $a0c05760304c3030$export$fd3c80c00b3490e, (v) => $a0c05760304c3030$export$fd3c80c00b3490e = v);
$parcel$export(module.exports, "parseResponse", () => $a0c05760304c3030$export$ba14d9a5a581e827, (v) => $a0c05760304c3030$export$ba14d9a5a581e827 = v);
$parcel$export(module.exports, "digest", () => $a0c05760304c3030$export$4dc2d9f0820a4918, (v) => $a0c05760304c3030$export$4dc2d9f0820a4918 = v);
$parcel$export(module.exports, "digestRev", () => $a0c05760304c3030$export$c8ea77706602d916, (v) => $a0c05760304c3030$export$c8ea77706602d916 = v);
$parcel$export(module.exports, "sign", () => $a0c05760304c3030$export$c5552dfdbc7cec71, (v) => $a0c05760304c3030$export$c5552dfdbc7cec71 = v);
$parcel$export(module.exports, "signRev", () => $a0c05760304c3030$export$5a8675f8a69a5b77, (v) => $a0c05760304c3030$export$5a8675f8a69a5b77 = v);
$parcel$export(module.exports, "toPEM", () => $a0c05760304c3030$export$2e9cf5b395720b17, (v) => $a0c05760304c3030$export$2e9cf5b395720b17 = v);
$parcel$export(module.exports, "toDER", () => $a0c05760304c3030$export$9c9ec61016848ce4, (v) => $a0c05760304c3030$export$9c9ec61016848ce4 = v);
$parcel$export(module.exports, "getAuthorityInfo", () => $a0c05760304c3030$export$e5f363520dce6300, (v) => $a0c05760304c3030$export$e5f363520dce6300 = v);
$parcel$export(module.exports, "RSAPrivateKey", () => $a0c05760304c3030$export$f4aab6816f64fa6b, (v) => $a0c05760304c3030$export$f4aab6816f64fa6b = v);
var $a0c05760304c3030$export$4fec380fe713e5f0;
var $a0c05760304c3030$export$cc129aae36a95970;
var $a0c05760304c3030$export$fd3c80c00b3490e;
var $a0c05760304c3030$export$ba14d9a5a581e827;
var $a0c05760304c3030$export$4dc2d9f0820a4918;
var $a0c05760304c3030$export$c8ea77706602d916;
var $a0c05760304c3030$export$c5552dfdbc7cec71;
var $a0c05760304c3030$export$5a8675f8a69a5b77;
var $a0c05760304c3030$export$2e9cf5b395720b17;
var $a0c05760304c3030$export$9c9ec61016848ce4;
var $a0c05760304c3030$export$e5f363520dce6300;
var $a0c05760304c3030$export$f4aab6816f64fa6b;

var $cBXue = parcelRequire("cBXue");
var $a0c05760304c3030$require$Buffer = $cBXue.Buffer;
"use strict";

var $8jiUm = parcelRequire("8jiUm");

var $2PcSP = parcelRequire("2PcSP");

var $aaypF = parcelRequire("aaypF");

var $d7iYd = parcelRequire("d7iYd");

var $gR5sk = parcelRequire("gR5sk");
$a0c05760304c3030$export$4fec380fe713e5f0 = [
    1,
    3,
    6,
    1,
    5,
    5,
    7,
    48,
    2
];
$a0c05760304c3030$export$cc129aae36a95970 = [
    1,
    3,
    6,
    1,
    5,
    5,
    7,
    3,
    9
];
$a0c05760304c3030$export$fd3c80c00b3490e = function getResponse(uri, req, cb) {
    if (typeof uri !== "object") uri = $aaypF.parse(uri);
    var options = $2PcSP._extend({
        method: "POST",
        headers: {
            "Content-Type": "application/ocsp-request",
            "Content-Length": req.length
        }
    }, uri);
    function done(err, response) {
        if (cb) cb(err, response);
        cb = null;
    }
    function onResponse(response) {
        if (response.statusCode < 200 || response.statusCode >= 400) return done(new Error("Failed to obtain OCSP response: " + response.statusCode));
        var chunks = [];
        response.on("readable", function() {
            var chunk = response.read();
            if (!chunk) return;
            chunks.push(chunk);
        });
        response.on("end", function() {
            var ocsp = $a0c05760304c3030$require$Buffer.concat(chunks);
            done(null, ocsp);
        });
    }
    $8jiUm.request(options, onResponse).on("error", done).end(req);
};
$a0c05760304c3030$export$ba14d9a5a581e827 = function parseResponse(raw) {
    var body = {
        start: 0,
        end: raw.length
    };
    var response = $gR5sk.OCSPResponse.decode(raw, "der", {
        track: function(key, start, end, type) {
            if (type !== "content" || key !== "responseBytes/response") return;
            body.start = start;
            body.end = end;
        }
    });
    var status = response.responseStatus;
    if (status !== "successful") throw new Error("Bad OCSP response status: " + status);
    // Unknown response type
    var responseType = response.responseBytes.responseType;
    if (responseType !== "id-pkix-ocsp-basic") throw new Error("Unknown OCSP response type: " + responseType);
    var bytes = response.responseBytes.response;
    var tbs = {
        start: body.start,
        end: body.end
    };
    var certsTbs = [];
    var basic = $gR5sk.BasicOCSPResponse.decode(bytes, "der", {
        track: function(key, start, end, type) {
            if (type !== "tagged") return;
            if (key === "tbsResponseData") {
                tbs.start = body.start + start;
                tbs.end = body.start + end;
            } else if (key === "certs/tbsCertificate") certsTbs.push({
                start: body.start + start,
                end: body.start + end
            });
        }
    });
    var OCSPSigning = $a0c05760304c3030$export$cc129aae36a95970.join(".");
    var certs = (basic.certs || []).filter(function(cert) {
        return cert.tbsCertificate.extensions.some(function(ext) {
            if (ext.extnID !== "extendedKeyUsage") return false;
            return ext.extnValue.some(function(value) {
                return value.join(".") === OCSPSigning;
            });
        });
    });
    return {
        start: tbs.start,
        end: tbs.end,
        value: basic,
        certs: certs,
        certsTbs: certsTbs
    };
};
$a0c05760304c3030$export$4dc2d9f0820a4918 = {
    "1.3.14.3.2.26": "sha1",
    "2.16.840.1.101.3.4.2.1": "sha256"
};
$a0c05760304c3030$export$c8ea77706602d916 = {
    sha1: "1.3.14.3.2.26",
    sha256: "2.16.840.1.101.3.4.2.1"
};
$a0c05760304c3030$export$c5552dfdbc7cec71 = {
    "1.2.840.113549.1.1.5": "sha1WithRSAEncryption",
    "1.2.840.113549.1.1.11": "sha256WithRSAEncryption",
    "1.2.840.113549.1.1.12": "sha384WithRSAEncryption",
    "1.2.840.113549.1.1.13": "sha512WithRSAEncryption"
};
$a0c05760304c3030$export$5a8675f8a69a5b77 = {
    sha1WithRSAEncryption: [
        1,
        2,
        840,
        113549,
        1,
        1,
        5
    ],
    sha256WithRSAEncryption: [
        1,
        2,
        840,
        113549,
        1,
        1,
        11
    ],
    sha384WithRSAEncryption: [
        1,
        2,
        840,
        113549,
        1,
        1,
        12
    ],
    sha512WithRSAEncryption: [
        1,
        2,
        840,
        113549,
        1,
        1,
        13
    ]
};
$a0c05760304c3030$export$2e9cf5b395720b17 = function toPEM(buf, label) {
    var p = buf.toString("base64");
    var out = [
        "-----BEGIN " + label + "-----"
    ];
    for(var i = 0; i < p.length; i += 64)out.push(p.slice(i, i + 64));
    out.push("-----END " + label + "-----");
    return out.join("\n");
};
$a0c05760304c3030$export$9c9ec61016848ce4 = function toDER(raw, what) {
    var der = raw.toString().match(new RegExp("-----BEGIN " + what + "-----([^-]*)-----END " + what + "-----"));
    if (der) der = new $a0c05760304c3030$require$Buffer(der[1].replace(/[\r\n]/g, ""), "base64");
    else if (typeof raw === "string") der = new $a0c05760304c3030$require$Buffer(raw);
    else der = raw;
    return der;
};
$a0c05760304c3030$export$e5f363520dce6300 = function getAuthorityInfo(cert, key, done) {
    var exts = cert.tbsCertificate.extensions;
    if (!exts) exts = [];
    var infoAccess = exts.filter(function(ext) {
        return ext.extnID === "authorityInformationAccess";
    });
    if (infoAccess.length === 0) return done(new Error("AuthorityInfoAccess not found in extensions"));
    var res = null;
    var found = infoAccess.some(function(info) {
        var ext = info.extnValue;
        return ext.some(function(ad) {
            if (ad.accessMethod.join(".") !== key) return false;
            var loc = ad.accessLocation;
            if (loc.type !== "uniformResourceIdentifier") return false;
            res = loc.value + "";
            return true;
        });
    });
    if (!found) return done(new Error(key + " not found in AuthorityInfoAccess"));
    return done(null, res);
};
var $a0c05760304c3030$var$RSAPrivateKey = $d7iYd.define("RSAPrivateKey", function() {
    this.seq().obj(this.key("version").int(), this.key("modulus").int(), this.key("publicExponent").int(), this.key("privateExponent").int(), this.key("prime1").int(), this.key("prime2").int(), this.key("exponent1").int(), this.key("exponent2").int(), this.key("coefficient").int());
});
$a0c05760304c3030$export$f4aab6816f64fa6b = $a0c05760304c3030$var$RSAPrivateKey;

});





parcelRequire.register("1U5qe", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ReplayableAudioNode = void 0;
var $162f3a21b5dd28d9$var$ReplayableAudioNode = /** @class */ function() {
    function ReplayableAudioNode(audioSource, bytesPerSecond) {
        var _this = this;
        this.privBuffers = [];
        this.privReplayOffset = 0;
        this.privLastShrinkOffset = 0;
        this.privBufferStartOffset = 0;
        this.privBufferSerial = 0;
        this.privBufferedBytes = 0;
        this.privReplay = false;
        this.privLastChunkAcquiredTime = 0;
        this.id = function() {
            return _this.privAudioNode.id();
        };
        this.privAudioNode = audioSource;
        this.privBytesPerSecond = bytesPerSecond;
    }
    // Reads and returns the next chunk of audio buffer.
    // If replay of existing buffers are needed, read() will first seek and replay
    // existing content, and upoin completion it will read new content from the underlying
    // audio node, saving that content into the replayable buffers.
    ReplayableAudioNode.prototype.read = function() {
        var _this = this;
        // if there is a replay request to honor.
        if (!!this.privReplay && this.privBuffers.length !== 0) {
            // Find the start point in the buffers.
            // Offsets are in 100ns increments.
            // So how many bytes do we need to seek to get the right offset?
            var offsetToSeek = this.privReplayOffset - this.privBufferStartOffset;
            var bytesToSeek = Math.round(offsetToSeek * this.privBytesPerSecond * 1e-7);
            if (0 !== bytesToSeek % 2) bytesToSeek++;
            var i = 0;
            while(i < this.privBuffers.length && bytesToSeek >= this.privBuffers[i].chunk.buffer.byteLength)bytesToSeek -= this.privBuffers[i++].chunk.buffer.byteLength;
            if (i < this.privBuffers.length) {
                var retVal = this.privBuffers[i].chunk.buffer.slice(bytesToSeek);
                this.privReplayOffset += retVal.byteLength / this.privBytesPerSecond * 1e+7;
                // If we've reached the end of the buffers, stop replaying.
                if (i === this.privBuffers.length - 1) this.privReplay = false;
                return Promise.resolve({
                    buffer: retVal,
                    isEnd: false,
                    timeReceived: this.privBuffers[i].chunk.timeReceived
                });
            }
        }
        return this.privAudioNode.read().then(function(result) {
            if (result && result.buffer) {
                _this.privBuffers.push(new $162f3a21b5dd28d9$var$BufferEntry(result, _this.privBufferSerial++, _this.privBufferedBytes));
                _this.privBufferedBytes += result.buffer.byteLength;
            }
            return result;
        });
    };
    ReplayableAudioNode.prototype.detach = function() {
        this.privBuffers = undefined;
        return this.privAudioNode.detach();
    };
    ReplayableAudioNode.prototype.replay = function() {
        if (this.privBuffers && 0 !== this.privBuffers.length) {
            this.privReplay = true;
            this.privReplayOffset = this.privLastShrinkOffset;
        }
    };
    // Shrinks the existing audio buffers to start at the new offset, or at the
    // beginning of the buffer closest to the requested offset.
    // A replay request will start from the last shrink point.
    ReplayableAudioNode.prototype.shrinkBuffers = function(offset) {
        if (this.privBuffers === undefined || this.privBuffers.length === 0) return;
        this.privLastShrinkOffset = offset;
        // Find the start point in the buffers.
        // Offsets are in 100ns increments.
        // So how many bytes do we need to seek to get the right offset?
        var offsetToSeek = offset - this.privBufferStartOffset;
        var bytesToSeek = Math.round(offsetToSeek * this.privBytesPerSecond * 1e-7);
        var i = 0;
        while(i < this.privBuffers.length && bytesToSeek >= this.privBuffers[i].chunk.buffer.byteLength)bytesToSeek -= this.privBuffers[i++].chunk.buffer.byteLength;
        this.privBufferStartOffset = Math.round(offset - bytesToSeek / this.privBytesPerSecond * 1e+7);
        this.privBuffers = this.privBuffers.slice(i);
    };
    // Finds the time a buffer of audio was first seen by offset.
    ReplayableAudioNode.prototype.findTimeAtOffset = function(offset) {
        if (offset < this.privBufferStartOffset || this.privBuffers === undefined) return 0;
        for(var _i = 0, _a = this.privBuffers; _i < _a.length; _i++){
            var value = _a[_i];
            var startOffset = value.byteOffset / this.privBytesPerSecond * 1e7;
            var endOffset = startOffset + value.chunk.buffer.byteLength / this.privBytesPerSecond * 1e7;
            if (offset >= startOffset && offset <= endOffset) return value.chunk.timeReceived;
        }
        return 0;
    };
    return ReplayableAudioNode;
}();
module.exports.ReplayableAudioNode = $162f3a21b5dd28d9$var$ReplayableAudioNode;
// Primary use of this class is to help debugging problems with the replay
// code. If the memory cost of alloc / dealloc gets too much, drop it and just use
// the ArrayBuffer directly.
// tslint:disable-next-line:max-classes-per-file
var $162f3a21b5dd28d9$var$BufferEntry = /** @class */ function() {
    function BufferEntry(chunk, serial, byteOffset) {
        this.chunk = chunk;
        this.serial = serial;
        this.byteOffset = byteOffset;
    }
    return BufferEntry;
}();

});

parcelRequire.register("4DhJM", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ProxyInfo = void 0;

var $iQDnw = parcelRequire("iQDnw");
var $35f89039f71ea7ee$var$ProxyInfo = /** @class */ function() {
    function ProxyInfo(proxyHostName, proxyPort, proxyUserName, proxyPassword) {
        this.privProxyHostName = proxyHostName;
        this.privProxyPort = proxyPort;
        this.privProxyUserName = proxyUserName;
        this.privProxyPassword = proxyPassword;
    }
    ProxyInfo.fromParameters = function(parameters) {
        return new ProxyInfo(parameters.getProperty($iQDnw.PropertyId.SpeechServiceConnection_ProxyHostName), parseInt(parameters.getProperty($iQDnw.PropertyId.SpeechServiceConnection_ProxyPort), 10), parameters.getProperty($iQDnw.PropertyId.SpeechServiceConnection_ProxyUserName), parameters.getProperty($iQDnw.PropertyId.SpeechServiceConnection_ProxyPassword));
    };
    ProxyInfo.fromRecognizerConfig = function(config) {
        return this.fromParameters(config.parameters);
    };
    Object.defineProperty(ProxyInfo.prototype, "HostName", {
        get: function() {
            return this.privProxyHostName;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ProxyInfo.prototype, "Port", {
        get: function() {
            return this.privProxyPort;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ProxyInfo.prototype, "UserName", {
        get: function() {
            return this.privProxyUserName;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ProxyInfo.prototype, "Password", {
        get: function() {
            return this.privProxyPassword;
        },
        enumerable: false,
        configurable: true
    });
    return ProxyInfo;
}();
module.exports.ProxyInfo = $35f89039f71ea7ee$var$ProxyInfo;

});

parcelRequire.register("c3lLr", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
var $8c66a5c171793045$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $8c66a5c171793045$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $8c66a5c171793045$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.hasOwnProperty.call(mod, k)) $8c66a5c171793045$var$__createBinding(result, mod, k);
    }
    $8c66a5c171793045$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RestMessageAdapter = module.exports.RestRequestType = void 0;

var $7srwU = parcelRequire("7srwU");

// Node.JS specific xmlhttprequest / browser support.
var $8c66a5c171793045$var$XHR = $8c66a5c171793045$var$__importStar((parcelRequire("gR5sk")));
var $8c66a5c171793045$var$RestRequestType;
(function(RestRequestType) {
    RestRequestType["Get"] = "get";
    RestRequestType["Post"] = "post";
    RestRequestType["Delete"] = "delete";
    RestRequestType["File"] = "file";
})($8c66a5c171793045$var$RestRequestType = module.exports.RestRequestType || (module.exports.RestRequestType = {}));
// accept rest operations via request method and return abstracted objects from server response
var $8c66a5c171793045$var$RestMessageAdapter = /** @class */ function() {
    function RestMessageAdapter(configParams, connectionId) {
        if (!configParams) throw new $7srwU.ArgumentNullError("configParams");
        this.privHeaders = configParams.headers;
        this.privTimeout = configParams.timeout;
        this.privIgnoreCache = configParams.ignoreCache;
    }
    RestMessageAdapter.prototype.setHeaders = function(key, value) {
        this.privHeaders[key] = value;
    };
    RestMessageAdapter.prototype.request = function(method, uri, queryParams, body, binaryBody) {
        var _this = this;
        if (queryParams === void 0) queryParams = {};
        if (body === void 0) body = null;
        if (binaryBody === void 0) binaryBody = null;
        var responseReceivedDeferral = new $7srwU.Deferred();
        var xhr;
        if (typeof XMLHttpRequest === "undefined") xhr = new $8c66a5c171793045$var$XHR.XMLHttpRequest();
        else xhr = new XMLHttpRequest();
        var requestCommand = method === $8c66a5c171793045$var$RestRequestType.File ? "post" : method;
        xhr.open(requestCommand, this.withQuery(uri, queryParams), true);
        if (this.privHeaders) Object.keys(this.privHeaders).forEach(function(key) {
            return xhr.setRequestHeader(key, _this.privHeaders[key]);
        });
        if (this.privIgnoreCache) xhr.setRequestHeader("Cache-Control", "no-cache");
        xhr.timeout = this.privTimeout;
        xhr.onload = function() {
            responseReceivedDeferral.resolve(_this.parseXHRResult(xhr));
        };
        xhr.onerror = function() {
            responseReceivedDeferral.resolve(_this.errorResponse(xhr, "Failed to make request."));
        };
        xhr.ontimeout = function() {
            responseReceivedDeferral.resolve(_this.errorResponse(xhr, "Request took longer than expected."));
        };
        if (method === $8c66a5c171793045$var$RestRequestType.File && binaryBody) {
            xhr.setRequestHeader("Content-Type", "multipart/form-data");
            xhr.send(binaryBody);
        } else if (method === $8c66a5c171793045$var$RestRequestType.Post && body) {
            xhr.setRequestHeader("Content-Type", "application/json");
            xhr.send(JSON.stringify(body));
        } else xhr.send();
        return responseReceivedDeferral.promise;
    };
    RestMessageAdapter.prototype.parseXHRResult = function(xhr) {
        return {
            data: xhr.responseText,
            headers: xhr.getAllResponseHeaders(),
            json: function() {
                return JSON.parse(xhr.responseText);
            },
            ok: xhr.status >= 200 && xhr.status < 300,
            status: xhr.status,
            statusText: xhr.statusText
        };
    };
    RestMessageAdapter.prototype.errorResponse = function(xhr, message) {
        if (message === void 0) message = null;
        return {
            data: message || xhr.statusText,
            headers: xhr.getAllResponseHeaders(),
            json: function() {
                return JSON.parse(message || '"' + xhr.statusText + '"');
            },
            ok: false,
            status: xhr.status,
            statusText: xhr.statusText
        };
    };
    RestMessageAdapter.prototype.withQuery = function(url, params) {
        if (params === void 0) params = {};
        var queryString = this.queryParams(params);
        return queryString ? url + (url.indexOf("?") === -1 ? "?" : "&") + queryString : url;
    };
    RestMessageAdapter.prototype.queryParams = function(params) {
        if (params === void 0) params = {};
        return Object.keys(params).map(function(k) {
            return encodeURIComponent(k) + "=" + encodeURIComponent(params[k]);
        }).join("&");
    };
    return RestMessageAdapter;
}();
module.exports.RestMessageAdapter = $8c66a5c171793045$var$RestMessageAdapter;

});





parcelRequire.register("9QKOF", function(module, exports) {
"use strict";

var $lsqXV = parcelRequire("lsqXV");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $72bd4920b4d26266$var$_default;

var $72bd4920b4d26266$var$_pDeferEs = $lsqXV((parcelRequire("5la41")));
function $72bd4920b4d26266$var$_default() {
    var shiftDeferred;
    var queue = [];
    var push = function push(value) {
        if (shiftDeferred) {
            var _shiftDeferred = shiftDeferred, resolve = _shiftDeferred.resolve;
            shiftDeferred = null;
            resolve(value);
        } else queue.push(value);
    };
    var shift = function shift() {
        if (queue.length) return Promise.resolve(queue.shift());
        return (shiftDeferred || (shiftDeferred = (0, $72bd4920b4d26266$var$_pDeferEs.default)())).promise;
    };
    return {
        push: push,
        shift: shift
    };
}

});

parcelRequire.register("crqHc", function(module, exports) {
"use strict";

var $lsqXV = parcelRequire("lsqXV");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $90ecb6db2891be75$var$patchOptions;

var $90ecb6db2891be75$var$_regenerator = $lsqXV((parcelRequire("jfaTe")));

var $90ecb6db2891be75$var$_defineProperty2 = $lsqXV((parcelRequire("7jg8p")));

var $90ecb6db2891be75$var$_asyncToGenerator2 = $lsqXV((parcelRequire("jT3Iz")));

var $90ecb6db2891be75$var$_objectWithoutProperties2 = $lsqXV((parcelRequire("6hdic")));

var $90ecb6db2891be75$var$_resolveFunctionOrReturnValue = $lsqXV((parcelRequire("bUUqZ")));
var $90ecb6db2891be75$var$_excluded = [
    "authorizationToken",
    "credentials",
    "looseEvent",
    "looseEvents",
    "region",
    "subscriptionKey"
];
function $90ecb6db2891be75$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $90ecb6db2891be75$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $90ecb6db2891be75$var$ownKeys(Object(source), !0).forEach(function(key) {
            (0, $90ecb6db2891be75$var$_defineProperty2.default)(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $90ecb6db2891be75$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var $90ecb6db2891be75$var$shouldWarnOnSubscriptionKey = true;
function $90ecb6db2891be75$var$patchOptions() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var authorizationToken = _ref.authorizationToken, credentials = _ref.credentials, looseEvent = _ref.looseEvent, looseEvents = _ref.looseEvents, _ref$region = _ref.region, region = _ref$region === void 0 ? "westus" : _ref$region, subscriptionKey = _ref.subscriptionKey, otherOptions = (0, $90ecb6db2891be75$var$_objectWithoutProperties2.default)(_ref, $90ecb6db2891be75$var$_excluded);
    if (typeof looseEvent !== "undefined") {
        console.warn('web-speech-cognitive-services: The option "looseEvent" should be named as "looseEvents".');
        looseEvents = looseEvent;
    }
    if (!credentials) {
        if (!authorizationToken && !subscriptionKey) throw new Error("web-speech-cognitive-services: Credentials must be specified.");
        else {
            console.warn("web-speech-cognitive-services: We are deprecating authorizationToken, region, and subscriptionKey. Please use credentials instead. The deprecated option will be removed on or after 2020-11-14.");
            credentials = /*#__PURE__*/ function() {
                var _ref2 = (0, $90ecb6db2891be75$var$_asyncToGenerator2.default)(/*#__PURE__*/ $90ecb6db2891be75$var$_regenerator.default.mark(function _callee() {
                    return $90ecb6db2891be75$var$_regenerator.default.wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                if (!authorizationToken) {
                                    _context.next = 8;
                                    break;
                                }
                                _context.next = 3;
                                return (0, $90ecb6db2891be75$var$_resolveFunctionOrReturnValue.default)(authorizationToken);
                            case 3:
                                _context.t1 = _context.sent;
                                _context.t2 = region;
                                _context.t0 = {
                                    authorizationToken: _context.t1,
                                    region: _context.t2
                                };
                                _context.next = 13;
                                break;
                            case 8:
                                _context.t3 = region;
                                _context.next = 11;
                                return (0, $90ecb6db2891be75$var$_resolveFunctionOrReturnValue.default)(subscriptionKey);
                            case 11:
                                _context.t4 = _context.sent;
                                _context.t0 = {
                                    region: _context.t3,
                                    subscriptionKey: _context.t4
                                };
                            case 13:
                                return _context.abrupt("return", _context.t0);
                            case 14:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee);
                }));
                return function credentials() {
                    return _ref2.apply(this, arguments);
                };
            }();
        }
    }
    return $90ecb6db2891be75$var$_objectSpread($90ecb6db2891be75$var$_objectSpread({}, otherOptions), {}, {
        fetchCredentials: function() {
            var _fetchCredentials = (0, $90ecb6db2891be75$var$_asyncToGenerator2.default)(/*#__PURE__*/ $90ecb6db2891be75$var$_regenerator.default.mark(function _callee2() {
                var _yield$resolveFunctio, authorizationToken, customVoiceHostname, region, speechRecognitionHostname, speechSynthesisHostname, subscriptionKey, resolvedCredentials;
                return $90ecb6db2891be75$var$_regenerator.default.wrap(function _callee2$(_context2) {
                    while(true)switch(_context2.prev = _context2.next){
                        case 0:
                            _context2.next = 2;
                            return (0, $90ecb6db2891be75$var$_resolveFunctionOrReturnValue.default)(credentials);
                        case 2:
                            _yield$resolveFunctio = _context2.sent;
                            authorizationToken = _yield$resolveFunctio.authorizationToken;
                            customVoiceHostname = _yield$resolveFunctio.customVoiceHostname;
                            region = _yield$resolveFunctio.region;
                            speechRecognitionHostname = _yield$resolveFunctio.speechRecognitionHostname;
                            speechSynthesisHostname = _yield$resolveFunctio.speechSynthesisHostname;
                            subscriptionKey = _yield$resolveFunctio.subscriptionKey;
                            if (!(!authorizationToken && !subscriptionKey || authorizationToken && subscriptionKey)) {
                                _context2.next = 13;
                                break;
                            }
                            throw new Error('web-speech-cognitive-services: Either "authorizationToken" or "subscriptionKey" must be provided.');
                        case 13:
                            if (!(!region && !(speechRecognitionHostname && speechSynthesisHostname))) {
                                _context2.next = 17;
                                break;
                            }
                            throw new Error('web-speech-cognitive-services: Either "region" or "speechRecognitionHostname" and "speechSynthesisHostname" must be set.');
                        case 17:
                            if (!(region && (customVoiceHostname || speechRecognitionHostname || speechSynthesisHostname))) {
                                _context2.next = 21;
                                break;
                            }
                            throw new Error('web-speech-cognitive-services: Only either "region" or "customVoiceHostname", "speechRecognitionHostname" and "speechSynthesisHostname" can be set.');
                        case 21:
                            if (!authorizationToken) {
                                _context2.next = 26;
                                break;
                            }
                            if (!(typeof authorizationToken !== "string")) {
                                _context2.next = 24;
                                break;
                            }
                            throw new Error('web-speech-cognitive-services: "authorizationToken" must be a string.');
                        case 24:
                            _context2.next = 28;
                            break;
                        case 26:
                            if (!(typeof subscriptionKey !== "string")) {
                                _context2.next = 28;
                                break;
                            }
                            throw new Error('web-speech-cognitive-services: "subscriptionKey" must be a string.');
                        case 28:
                            if ($90ecb6db2891be75$var$shouldWarnOnSubscriptionKey && subscriptionKey) {
                                console.warn("web-speech-cognitive-services: In production environment, subscription key should not be used, authorization token should be used instead.");
                                $90ecb6db2891be75$var$shouldWarnOnSubscriptionKey = false;
                            }
                            resolvedCredentials = authorizationToken ? {
                                authorizationToken: authorizationToken
                            } : {
                                subscriptionKey: subscriptionKey
                            };
                            if (region) resolvedCredentials.region = region;
                            else {
                                resolvedCredentials.customVoiceHostname = customVoiceHostname;
                                resolvedCredentials.speechRecognitionHostname = speechRecognitionHostname;
                                resolvedCredentials.speechSynthesisHostname = speechSynthesisHostname;
                            }
                            return _context2.abrupt("return", resolvedCredentials);
                        case 32:
                        case "end":
                            return _context2.stop();
                    }
                }, _callee2);
            }));
            function fetchCredentials() {
                return _fetchCredentials.apply(this, arguments);
            }
            return fetchCredentials;
        }(),
        looseEvents: looseEvents
    });
}

});
parcelRequire.register("6hdic", function(module, exports) {

var $5LTnI = parcelRequire("5LTnI");
function $491ea43a8a9aa535$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $5LTnI(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
module.exports = $491ea43a8a9aa535$var$_objectWithoutProperties, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRequire.register("5LTnI", function(module, exports) {
function $433c4d21a5bd012d$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
module.exports = $433c4d21a5bd012d$var$_objectWithoutPropertiesLoose, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRequire.register("bUUqZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $8ad0b356b2cb6153$var$resolveFunctionOrReturnValue;
function $8ad0b356b2cb6153$var$resolveFunctionOrReturnValue(fnOrValue) {
    return typeof fnOrValue === "function" ? fnOrValue() : fnOrValue;
}

});


parcelRequire.register("f9mFT", function(module, exports) {
"use strict";

var $lsqXV = parcelRequire("lsqXV");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b0794902497f163d$var$_classCallCheck2 = $lsqXV((parcelRequire("2wF0s")));

var $b0794902497f163d$var$_createClass2 = $lsqXV((parcelRequire("fQlXT")));
/* eslint class-methods-use-this: "off" */ var $b0794902497f163d$var$_default = /*#__PURE__*/ function() {
    function _default() {
        (0, $b0794902497f163d$var$_classCallCheck2.default)(this, _default);
        this._phrases = [];
    }
    (0, $b0794902497f163d$var$_createClass2.default)(_default, [
        {
            key: "addFromString",
            value: function addFromString() {
                throw new Error("JSGF is not supported");
            }
        },
        {
            key: "phrases",
            get: function get() {
                return this._phrases;
            },
            set: function set(value) {
                if (Array.isArray(value)) this._phrases = value;
                else if (typeof value === "string") this._phrases = [
                    value
                ];
                else throw new Error("The provided value is not an array or of type 'string'");
            }
        }
    ]);
    return _default;
}();
module.exports.default = $b0794902497f163d$var$_default;

});



parcelRequire.register("hpbgl", function(module, exports) {
"use strict";

var $lsqXV = parcelRequire("lsqXV");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $cabd81fb99563851$var$_createSpeechSynthesisPonyfill = $lsqXV((parcelRequire("KGElI")));
var $cabd81fb99563851$var$_default = $cabd81fb99563851$var$_createSpeechSynthesisPonyfill.default;
module.exports.default = $cabd81fb99563851$var$_default;

});
parcelRequire.register("KGElI", function(module, exports) {
"use strict";

var $lsqXV = parcelRequire("lsqXV");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $08c5615a7a3e2002$var$_regenerator = $lsqXV((parcelRequire("jfaTe")));

var $08c5615a7a3e2002$var$_asyncToGenerator2 = $lsqXV((parcelRequire("jT3Iz")));

var $08c5615a7a3e2002$var$_classCallCheck2 = $lsqXV((parcelRequire("2wF0s")));

var $08c5615a7a3e2002$var$_createClass2 = $lsqXV((parcelRequire("fQlXT")));

var $08c5615a7a3e2002$var$_inherits2 = $lsqXV((parcelRequire("i2Ce6")));

var $08c5615a7a3e2002$var$_possibleConstructorReturn2 = $lsqXV((parcelRequire("2cKO9")));

var $08c5615a7a3e2002$var$_getPrototypeOf2 = $lsqXV((parcelRequire("1AdHm")));

var $bgEWP = parcelRequire("bgEWP");

var $08c5615a7a3e2002$var$_pDeferEs = $lsqXV((parcelRequire("5la41")));

var $08c5615a7a3e2002$var$_onErrorResumeNext = $lsqXV((parcelRequire("bw7hH")));

var $08c5615a7a3e2002$var$_AudioContextQueue = $lsqXV((parcelRequire("i9CS5")));

var $08c5615a7a3e2002$var$_fetchCustomVoices = $lsqXV((parcelRequire("aDfHb")));

var $08c5615a7a3e2002$var$_fetchVoices = $lsqXV((parcelRequire("gv658")));

var $08c5615a7a3e2002$var$_patchOptions2 = $lsqXV((parcelRequire("crqHc")));

var $08c5615a7a3e2002$var$_SpeechSynthesisEvent = $lsqXV((parcelRequire("8tD1j")));

var $08c5615a7a3e2002$var$_SpeechSynthesisUtterance = $lsqXV((parcelRequire("lUs3M")));
function $08c5615a7a3e2002$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $08c5615a7a3e2002$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, $08c5615a7a3e2002$var$_getPrototypeOf2.default)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $08c5615a7a3e2002$var$_getPrototypeOf2.default)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $08c5615a7a3e2002$var$_possibleConstructorReturn2.default)(this, result);
    };
}
function $08c5615a7a3e2002$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
// Supported output format can be found at https://docs.microsoft.com/en-us/azure/cognitive-services/speech-service/rest-text-to-speech#audio-outputs
var $08c5615a7a3e2002$var$DEFAULT_OUTPUT_FORMAT = "audio-24khz-160kbitrate-mono-mp3";
var $08c5615a7a3e2002$var$EMPTY_ARRAY = [];
var $08c5615a7a3e2002$var$_default = function _default(options) {
    var _patchOptions = (0, $08c5615a7a3e2002$var$_patchOptions2.default)(options), audioContext = _patchOptions.audioContext, fetchCredentials = _patchOptions.fetchCredentials, _patchOptions$ponyfil = _patchOptions.ponyfill, ponyfill = _patchOptions$ponyfil === void 0 ? {
        AudioContext: window.AudioContext || window.webkitAudioContext
    } : _patchOptions$ponyfil, speechSynthesisDeploymentId = _patchOptions.speechSynthesisDeploymentId, _patchOptions$speechS = _patchOptions.speechSynthesisOutputFormat, speechSynthesisOutputFormat = _patchOptions$speechS === void 0 ? $08c5615a7a3e2002$var$DEFAULT_OUTPUT_FORMAT : _patchOptions$speechS;
    if (!audioContext && !ponyfill.AudioContext) {
        console.warn("web-speech-cognitive-services: This browser does not support Web Audio and it will not work with Cognitive Services Speech Services.");
        return {};
    }
    var SpeechSynthesis = /*#__PURE__*/ function(_EventTarget) {
        (0, $08c5615a7a3e2002$var$_inherits2.default)(SpeechSynthesis, _EventTarget);
        var _super = $08c5615a7a3e2002$var$_createSuper(SpeechSynthesis);
        function SpeechSynthesis() {
            var _this;
            (0, $08c5615a7a3e2002$var$_classCallCheck2.default)(this, SpeechSynthesis);
            _this = _super.call(this);
            _this.queue = new $08c5615a7a3e2002$var$_AudioContextQueue.default({
                audioContext: audioContext,
                ponyfill: ponyfill
            });
            _this.updateVoices();
            return _this;
        }
        (0, $08c5615a7a3e2002$var$_createClass2.default)(SpeechSynthesis, [
            {
                key: "cancel",
                value: function cancel() {
                    this.queue.stop();
                }
            },
            {
                key: "getVoices",
                value: function getVoices() {
                    return $08c5615a7a3e2002$var$EMPTY_ARRAY;
                }
            },
            {
                key: "onvoiceschanged",
                get: function get() {
                    return (0, $bgEWP.getEventAttributeValue)(this, "voiceschanged");
                },
                set: function set(value) {
                    (0, $bgEWP.setEventAttributeValue)(this, "voiceschanged", value);
                }
            },
            {
                key: "pause",
                value: function pause() {
                    this.queue.pause();
                }
            },
            {
                key: "resume",
                value: function resume() {
                    this.queue.resume();
                }
            },
            {
                key: "speak",
                value: function speak(utterance) {
                    if (!(utterance instanceof $08c5615a7a3e2002$var$_SpeechSynthesisUtterance.default)) throw new Error("invalid utterance");
                    var _createDeferred = (0, $08c5615a7a3e2002$var$_pDeferEs.default)(), reject = _createDeferred.reject, resolve = _createDeferred.resolve, promise = _createDeferred.promise;
                    var handleError = function handleError(_ref) {
                        var errorCode = _ref.error, message = _ref.message;
                        var error = new Error(errorCode);
                        error.stack = message;
                        reject(error);
                    };
                    utterance.addEventListener("end", resolve);
                    utterance.addEventListener("error", handleError);
                    utterance.preload({
                        deploymentId: speechSynthesisDeploymentId,
                        fetchCredentials: fetchCredentials,
                        outputFormat: speechSynthesisOutputFormat
                    });
                    this.queue.push(utterance);
                    return promise.finally(function() {
                        utterance.removeEventListener("end", resolve);
                        utterance.removeEventListener("error", handleError);
                    });
                }
            },
            {
                key: "speaking",
                get: function get() {
                    return this.queue.speaking;
                }
            },
            {
                key: "updateVoices",
                value: function() {
                    var _updateVoices = (0, $08c5615a7a3e2002$var$_asyncToGenerator2.default)(/*#__PURE__*/ $08c5615a7a3e2002$var$_regenerator.default.mark(function _callee3() {
                        var _this2 = this;
                        var _yield$fetchCredentia, customVoiceHostname, region, speechSynthesisHostname, subscriptionKey;
                        return $08c5615a7a3e2002$var$_regenerator.default.wrap(function _callee3$(_context3) {
                            while(true)switch(_context3.prev = _context3.next){
                                case 0:
                                    _context3.next = 2;
                                    return fetchCredentials();
                                case 2:
                                    _yield$fetchCredentia = _context3.sent;
                                    customVoiceHostname = _yield$fetchCredentia.customVoiceHostname;
                                    region = _yield$fetchCredentia.region;
                                    speechSynthesisHostname = _yield$fetchCredentia.speechSynthesisHostname;
                                    subscriptionKey = _yield$fetchCredentia.subscriptionKey;
                                    if (!speechSynthesisDeploymentId) {
                                        _context3.next = 14;
                                        break;
                                    }
                                    if (!subscriptionKey) {
                                        _context3.next = 12;
                                        break;
                                    }
                                    console.warn("web-speech-cognitive-services: Listing of custom voice models are only available when using subscription key.");
                                    _context3.next = 12;
                                    return (0, $08c5615a7a3e2002$var$_onErrorResumeNext.default)(/*#__PURE__*/ (0, $08c5615a7a3e2002$var$_asyncToGenerator2.default)(/*#__PURE__*/ $08c5615a7a3e2002$var$_regenerator.default.mark(function _callee() {
                                        var voices;
                                        return $08c5615a7a3e2002$var$_regenerator.default.wrap(function _callee$(_context) {
                                            while(true)switch(_context.prev = _context.next){
                                                case 0:
                                                    _context.next = 2;
                                                    return (0, $08c5615a7a3e2002$var$_fetchCustomVoices.default)({
                                                        customVoiceHostname: customVoiceHostname,
                                                        deploymentId: speechSynthesisDeploymentId,
                                                        region: region,
                                                        speechSynthesisHostname: speechSynthesisHostname,
                                                        subscriptionKey: subscriptionKey
                                                    });
                                                case 2:
                                                    voices = _context.sent;
                                                    _this2.getVoices = function() {
                                                        return voices;
                                                    };
                                                case 4:
                                                case "end":
                                                    return _context.stop();
                                            }
                                        }, _callee);
                                    })));
                                case 12:
                                    _context3.next = 16;
                                    break;
                                case 14:
                                    _context3.next = 16;
                                    return (0, $08c5615a7a3e2002$var$_onErrorResumeNext.default)(/*#__PURE__*/ (0, $08c5615a7a3e2002$var$_asyncToGenerator2.default)(/*#__PURE__*/ $08c5615a7a3e2002$var$_regenerator.default.mark(function _callee2() {
                                        var voices;
                                        return $08c5615a7a3e2002$var$_regenerator.default.wrap(function _callee2$(_context2) {
                                            while(true)switch(_context2.prev = _context2.next){
                                                case 0:
                                                    _context2.t0 = $08c5615a7a3e2002$var$_fetchVoices.default;
                                                    _context2.next = 3;
                                                    return fetchCredentials();
                                                case 3:
                                                    _context2.t1 = _context2.sent;
                                                    _context2.next = 6;
                                                    return (0, _context2.t0)(_context2.t1);
                                                case 6:
                                                    voices = _context2.sent;
                                                    _this2.getVoices = function() {
                                                        return voices;
                                                    };
                                                case 8:
                                                case "end":
                                                    return _context2.stop();
                                            }
                                        }, _callee2);
                                    })));
                                case 16:
                                    this.dispatchEvent(new $08c5615a7a3e2002$var$_SpeechSynthesisEvent.default("voiceschanged"));
                                case 17:
                                case "end":
                                    return _context3.stop();
                            }
                        }, _callee3, this);
                    }));
                    function updateVoices() {
                        return _updateVoices.apply(this, arguments);
                    }
                    return updateVoices;
                }()
            }
        ]);
        return SpeechSynthesis;
    }($bgEWP.EventTarget);
    return {
        speechSynthesis: new SpeechSynthesis(),
        SpeechSynthesisEvent: $08c5615a7a3e2002$var$_SpeechSynthesisEvent.default,
        SpeechSynthesisUtterance: $08c5615a7a3e2002$var$_SpeechSynthesisUtterance.default
    };
};
module.exports.default = $08c5615a7a3e2002$var$_default;

});
parcelRequire.register("bw7hH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $8628556bc4e43b90$var$onErrorResumeNext;
function $8628556bc4e43b90$var$onErrorResumeNext(fn) {
    var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    try {
        var result = fn.call(context);
        if (typeof result.then === "function") return new Promise(function(resolve) {
            result.then(resolve, function() {
                return resolve();
            });
        });
        else return result;
    } catch (err) {}
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});

parcelRequire.register("i9CS5", function(module, exports) {
"use strict";

var $lsqXV = parcelRequire("lsqXV");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d37738536574b2be$var$_regenerator = $lsqXV((parcelRequire("jfaTe")));

var $d37738536574b2be$var$_asyncToGenerator2 = $lsqXV((parcelRequire("jT3Iz")));

var $d37738536574b2be$var$_classCallCheck2 = $lsqXV((parcelRequire("2wF0s")));

var $d37738536574b2be$var$_createClass2 = $lsqXV((parcelRequire("fQlXT")));

var $d37738536574b2be$var$_memoizeOne = $lsqXV((parcelRequire("9gRzx")));

var $d37738536574b2be$var$_AudioContextConsumer = $lsqXV((parcelRequire("aaxBv")));
/* eslint no-await-in-loop: "off" */ var $d37738536574b2be$var$_default = /*#__PURE__*/ function() {
    function _default(_ref) {
        var audioContext = _ref.audioContext, ponyfill = _ref.ponyfill;
        (0, $d37738536574b2be$var$_classCallCheck2.default)(this, _default);
        this.consumer = null;
        this.paused = false;
        this.queue = [];
        this.getAudioContext = (0, $d37738536574b2be$var$_memoizeOne.default)(function() {
            return audioContext || new ponyfill.AudioContext();
        });
    }
    (0, $d37738536574b2be$var$_createClass2.default)(_default, [
        {
            key: "pause",
            value: function pause() {
                this.paused = true;
                this.consumer && this.consumer.pause();
            }
        },
        {
            key: "push",
            value: function push(utterance) {
                this.queue.push(utterance);
                this.startConsumer();
            }
        },
        {
            key: "resume",
            value: function resume() {
                this.paused = false;
                if (this.consumer) this.consumer.resume();
                else this.startConsumer();
            }
        },
        {
            key: "speaking",
            get: function get() {
                return !!this.consumer;
            }
        },
        {
            key: "startConsumer",
            value: function() {
                var _startConsumer = (0, $d37738536574b2be$var$_asyncToGenerator2.default)(/*#__PURE__*/ $d37738536574b2be$var$_regenerator.default.mark(function _callee() {
                    return $d37738536574b2be$var$_regenerator.default.wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                if (!(!this.paused && this.queue.length && !this.consumer)) {
                                    _context.next = 7;
                                    break;
                                }
                                this.consumer = new $d37738536574b2be$var$_AudioContextConsumer.default(this.getAudioContext());
                                _context.next = 4;
                                return this.consumer.start(this.queue);
                            case 4:
                                this.consumer = null;
                                _context.next = 0;
                                break;
                            case 7:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this);
                }));
                function startConsumer() {
                    return _startConsumer.apply(this, arguments);
                }
                return startConsumer;
            }()
        },
        {
            key: "stop",
            value: function stop() {
                this.queue.splice(0);
                this.consumer && this.consumer.stop();
            }
        }
    ]);
    return _default;
}();
module.exports.default = $d37738536574b2be$var$_default;

});
parcelRequire.register("aaxBv", function(module, exports) {
"use strict";

var $lsqXV = parcelRequire("lsqXV");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7674e79cf5bc139e$var$_regenerator = $lsqXV((parcelRequire("jfaTe")));

var $7674e79cf5bc139e$var$_asyncToGenerator2 = $lsqXV((parcelRequire("jT3Iz")));

var $7674e79cf5bc139e$var$_classCallCheck2 = $lsqXV((parcelRequire("2wF0s")));

var $7674e79cf5bc139e$var$_createClass2 = $lsqXV((parcelRequire("fQlXT")));
/* eslint no-await-in-loop: "off" */ var $7674e79cf5bc139e$var$_default = /*#__PURE__*/ function() {
    function _default(audioContext) {
        (0, $7674e79cf5bc139e$var$_classCallCheck2.default)(this, _default);
        this.audioContext = audioContext;
    }
    (0, $7674e79cf5bc139e$var$_createClass2.default)(_default, [
        {
            key: "pause",
            value: function pause() {
                this.audioContext && this.audioContext.suspend();
                this.playingUtterance && this.playingUtterance.dispatchEvent(new CustomEvent("pause"));
            }
        },
        {
            key: "resume",
            value: function resume() {
                this.audioContext && this.audioContext.resume();
                this.playingUtterance && this.playingUtterance.dispatchEvent(new CustomEvent("resume"));
            }
        },
        {
            key: "start",
            value: function() {
                var _start = (0, $7674e79cf5bc139e$var$_asyncToGenerator2.default)(/*#__PURE__*/ $7674e79cf5bc139e$var$_regenerator.default.mark(function _callee(queue) {
                    var utterance;
                    return $7674e79cf5bc139e$var$_regenerator.default.wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                if (!(utterance = queue.shift())) {
                                    _context.next = 7;
                                    break;
                                }
                                this.playingUtterance = utterance;
                                _context.next = 4;
                                return utterance.play(this.audioContext);
                            case 4:
                                this.playingUtterance = null;
                                _context.next = 0;
                                break;
                            case 7:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this);
                }));
                function start(_x) {
                    return _start.apply(this, arguments);
                }
                return start;
            }()
        },
        {
            key: "stop",
            value: function stop() {
                this.playingUtterance && this.playingUtterance.stop();
                if (this.audioContext.state === "suspended") // Play -> Pause -> Cancel (stop)
                // This would generate these events: "start", "pause", "end"
                // Without this code, the "end" event will not emit until resume() is called
                // Cancelling an unstarted utterance will not emit any "start" or "end" event
                this.audioContext.resume();
            }
        }
    ]);
    return _default;
}();
module.exports.default = $7674e79cf5bc139e$var$_default;

});


parcelRequire.register("aDfHb", function(module, exports) {
"use strict";

var $lsqXV = parcelRequire("lsqXV");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $7bd9b8b8f364be75$var$_default;

var $7bd9b8b8f364be75$var$_regenerator = $lsqXV((parcelRequire("jfaTe")));

var $7bd9b8b8f364be75$var$_asyncToGenerator2 = $lsqXV((parcelRequire("jT3Iz")));

var $7bd9b8b8f364be75$var$_SpeechSynthesisVoice = $lsqXV((parcelRequire("lPiZc")));
/* eslint no-magic-numbers: ["error", { "ignore": [0, 1, -1] }] */ function $7bd9b8b8f364be75$var$fetchCustomVoices(_x) {
    return $7bd9b8b8f364be75$var$_fetchCustomVoices.apply(this, arguments);
}
function $7bd9b8b8f364be75$var$_fetchCustomVoices() {
    $7bd9b8b8f364be75$var$_fetchCustomVoices = (0, $7bd9b8b8f364be75$var$_asyncToGenerator2.default)(/*#__PURE__*/ $7bd9b8b8f364be75$var$_regenerator.default.mark(function _callee(_ref) {
        var customVoiceHostname, deploymentId, region, subscriptionKey, hostname, res;
        return $7bd9b8b8f364be75$var$_regenerator.default.wrap(function _callee$(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    customVoiceHostname = _ref.customVoiceHostname, deploymentId = _ref.deploymentId, region = _ref.region, subscriptionKey = _ref.subscriptionKey;
                    hostname = customVoiceHostname || "".concat(region, ".customvoice.api.speech.microsoft.com"); // Although encodeURI on a hostname doesn't work as expected for hostname, at least, it will fail peacefully.
                    _context.next = 4;
                    return fetch("https://".concat(encodeURI(hostname), "/api/texttospeech/v2.0/endpoints/").concat(encodeURIComponent(deploymentId)), {
                        headers: {
                            accept: "application/json",
                            "ocp-apim-subscription-key": subscriptionKey
                        }
                    });
                case 4:
                    res = _context.sent;
                    if (res.ok) {
                        _context.next = 7;
                        break;
                    }
                    throw new Error("Failed to fetch custom voices");
                case 7:
                    return _context.abrupt("return", res.json());
                case 8:
                case "end":
                    return _context.stop();
            }
        }, _callee);
    }));
    return $7bd9b8b8f364be75$var$_fetchCustomVoices.apply(this, arguments);
}
function $7bd9b8b8f364be75$var$_default(_x2) {
    return $7bd9b8b8f364be75$var$_ref3.apply(this, arguments);
}
function $7bd9b8b8f364be75$var$_ref3() {
    $7bd9b8b8f364be75$var$_ref3 = (0, $7bd9b8b8f364be75$var$_asyncToGenerator2.default)(/*#__PURE__*/ $7bd9b8b8f364be75$var$_regenerator.default.mark(function _callee2(_ref2) {
        var customVoiceHostname, deploymentId, region, subscriptionKey, _yield$fetchCustomVoi, models;
        return $7bd9b8b8f364be75$var$_regenerator.default.wrap(function _callee2$(_context2) {
            while(true)switch(_context2.prev = _context2.next){
                case 0:
                    customVoiceHostname = _ref2.customVoiceHostname, deploymentId = _ref2.deploymentId, region = _ref2.region, subscriptionKey = _ref2.subscriptionKey;
                    _context2.next = 3;
                    return $7bd9b8b8f364be75$var$fetchCustomVoices({
                        customVoiceHostname: customVoiceHostname,
                        deploymentId: deploymentId,
                        region: region,
                        subscriptionKey: subscriptionKey
                    });
                case 3:
                    _yield$fetchCustomVoi = _context2.sent;
                    models = _yield$fetchCustomVoi.models;
                    return _context2.abrupt("return", models.map(function(_ref4) {
                        var gender = _ref4.properties.Gender, lang = _ref4.locale, voiceURI = _ref4.name;
                        return new $7bd9b8b8f364be75$var$_SpeechSynthesisVoice.default({
                            gender: gender,
                            lang: lang,
                            voiceURI: voiceURI
                        });
                    }).sort(function(_ref5, _ref6) {
                        var x = _ref5.name;
                        var y = _ref6.name;
                        return x > y ? 1 : x < y ? -1 : 0;
                    }));
                case 6:
                case "end":
                    return _context2.stop();
            }
        }, _callee2);
    }));
    return $7bd9b8b8f364be75$var$_ref3.apply(this, arguments);
}

});
parcelRequire.register("lPiZc", function(module, exports) {
"use strict";

var $lsqXV = parcelRequire("lsqXV");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $fe3d16a4ca87f514$var$_classCallCheck2 = $lsqXV((parcelRequire("2wF0s")));

var $fe3d16a4ca87f514$var$_createClass2 = $lsqXV((parcelRequire("fQlXT")));
var $fe3d16a4ca87f514$var$_default = /*#__PURE__*/ function() {
    function _default(_ref) {
        var gender = _ref.gender, lang = _ref.lang, voiceURI = _ref.voiceURI;
        (0, $fe3d16a4ca87f514$var$_classCallCheck2.default)(this, _default);
        this._default = false;
        this._gender = gender;
        this._lang = lang;
        this._localService = false;
        this._name = voiceURI;
        this._voiceURI = voiceURI;
    }
    (0, $fe3d16a4ca87f514$var$_createClass2.default)(_default, [
        {
            key: "default",
            get: function get() {
                return this._default;
            }
        },
        {
            key: "gender",
            get: function get() {
                return this._gender;
            }
        },
        {
            key: "lang",
            get: function get() {
                return this._lang;
            }
        },
        {
            key: "localService",
            get: function get() {
                return this._localService;
            }
        },
        {
            key: "name",
            get: function get() {
                return this._name;
            }
        },
        {
            key: "voiceURI",
            get: function get() {
                return this._voiceURI;
            }
        }
    ]);
    return _default;
}();
module.exports.default = $fe3d16a4ca87f514$var$_default;

});


parcelRequire.register("gv658", function(module, exports) {
"use strict";

var $lsqXV = parcelRequire("lsqXV");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $c034425428df3f45$var$fetchVoices;

var $c034425428df3f45$var$_regenerator = $lsqXV((parcelRequire("jfaTe")));

var $c034425428df3f45$var$_defineProperty2 = $lsqXV((parcelRequire("7jg8p")));

var $c034425428df3f45$var$_asyncToGenerator2 = $lsqXV((parcelRequire("jT3Iz")));

var $c034425428df3f45$var$_SpeechSynthesisVoice = $lsqXV((parcelRequire("lPiZc")));
function $c034425428df3f45$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $c034425428df3f45$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $c034425428df3f45$var$ownKeys(Object(source), !0).forEach(function(key) {
            (0, $c034425428df3f45$var$_defineProperty2.default)(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $c034425428df3f45$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $c034425428df3f45$var$fetchVoices(_x) {
    return $c034425428df3f45$var$_fetchVoices.apply(this, arguments);
}
function $c034425428df3f45$var$_fetchVoices() {
    $c034425428df3f45$var$_fetchVoices = (0, $c034425428df3f45$var$_asyncToGenerator2.default)(/*#__PURE__*/ $c034425428df3f45$var$_regenerator.default.mark(function _callee(_ref) {
        var authorizationToken, region, speechSynthesisHostname, subscriptionKey, hostname, res, voices;
        return $c034425428df3f45$var$_regenerator.default.wrap(function _callee$(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    authorizationToken = _ref.authorizationToken, region = _ref.region, speechSynthesisHostname = _ref.speechSynthesisHostname, subscriptionKey = _ref.subscriptionKey;
                    // Although encodeURI on a hostname doesn't work as expected for hostname, at least, it will fail peacefully.
                    hostname = speechSynthesisHostname || "".concat(encodeURI(region), ".tts.speech.microsoft.com");
                    _context.next = 4;
                    return fetch("https://".concat(hostname, "/cognitiveservices/voices/list"), {
                        headers: $c034425428df3f45$var$_objectSpread({
                            "content-type": "application/json"
                        }, authorizationToken ? {
                            authorization: "Bearer ".concat(authorizationToken)
                        } : {
                            "Ocp-Apim-Subscription-Key": subscriptionKey
                        })
                    });
                case 4:
                    res = _context.sent;
                    if (res.ok) {
                        _context.next = 7;
                        break;
                    }
                    throw new Error("Failed to fetch voices");
                case 7:
                    _context.next = 9;
                    return res.json();
                case 9:
                    voices = _context.sent;
                    return _context.abrupt("return", voices.map(function(_ref2) {
                        var gender = _ref2.Gender, lang = _ref2.Locale, voiceURI = _ref2.Name;
                        return new $c034425428df3f45$var$_SpeechSynthesisVoice.default({
                            gender: gender,
                            lang: lang,
                            voiceURI: voiceURI
                        });
                    }).sort(function(_ref3, _ref4) {
                        var x = _ref3.name;
                        var y = _ref4.name;
                        return x > y ? 1 : x < y ? -1 : 0;
                    }));
                case 11:
                case "end":
                    return _context.stop();
            }
        }, _callee);
    }));
    return $c034425428df3f45$var$_fetchVoices.apply(this, arguments);
}

});

parcelRequire.register("8tD1j", function(module, exports) {
"use strict";

var $lsqXV = parcelRequire("lsqXV");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $62bf4cc4836c9c27$var$_createClass2 = $lsqXV((parcelRequire("fQlXT")));

var $62bf4cc4836c9c27$var$_classCallCheck2 = $lsqXV((parcelRequire("2wF0s")));

var $62bf4cc4836c9c27$var$_inherits2 = $lsqXV((parcelRequire("i2Ce6")));

var $62bf4cc4836c9c27$var$_possibleConstructorReturn2 = $lsqXV((parcelRequire("2cKO9")));

var $62bf4cc4836c9c27$var$_getPrototypeOf2 = $lsqXV((parcelRequire("1AdHm")));

var $bgEWP = parcelRequire("bgEWP");
function $62bf4cc4836c9c27$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $62bf4cc4836c9c27$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, $62bf4cc4836c9c27$var$_getPrototypeOf2.default)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $62bf4cc4836c9c27$var$_getPrototypeOf2.default)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $62bf4cc4836c9c27$var$_possibleConstructorReturn2.default)(this, result);
    };
}
function $62bf4cc4836c9c27$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
var $62bf4cc4836c9c27$var$SpeechSynthesisEvent = /*#__PURE__*/ function(_Event) {
    (0, $62bf4cc4836c9c27$var$_inherits2.default)(SpeechSynthesisEvent, _Event);
    var _super = $62bf4cc4836c9c27$var$_createSuper(SpeechSynthesisEvent);
    function SpeechSynthesisEvent(type) {
        (0, $62bf4cc4836c9c27$var$_classCallCheck2.default)(this, SpeechSynthesisEvent);
        return _super.call(this, type);
    }
    return (0, $62bf4cc4836c9c27$var$_createClass2.default)(SpeechSynthesisEvent);
}($bgEWP.Event);
module.exports.default = $62bf4cc4836c9c27$var$SpeechSynthesisEvent;

});

parcelRequire.register("lUs3M", function(module, exports) {
"use strict";

var $lsqXV = parcelRequire("lsqXV");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ff34980b521cf20d$var$_regenerator = $lsqXV((parcelRequire("jfaTe")));

var $ff34980b521cf20d$var$_asyncToGenerator2 = $lsqXV((parcelRequire("jT3Iz")));

var $ff34980b521cf20d$var$_classCallCheck2 = $lsqXV((parcelRequire("2wF0s")));

var $ff34980b521cf20d$var$_createClass2 = $lsqXV((parcelRequire("fQlXT")));

var $ff34980b521cf20d$var$_inherits2 = $lsqXV((parcelRequire("i2Ce6")));

var $ff34980b521cf20d$var$_possibleConstructorReturn2 = $lsqXV((parcelRequire("2cKO9")));

var $ff34980b521cf20d$var$_getPrototypeOf2 = $lsqXV((parcelRequire("1AdHm")));

var $bgEWP = parcelRequire("bgEWP");

var $ff34980b521cf20d$var$_eventAsPromise = $lsqXV((parcelRequire("2pzIa")));

var $ff34980b521cf20d$var$_fetchSpeechData = $lsqXV((parcelRequire("fqDP0")));

var $ff34980b521cf20d$var$_SpeechSynthesisEvent = $lsqXV((parcelRequire("8tD1j")));

var $ff34980b521cf20d$var$_subscribeEvent = $lsqXV((parcelRequire("cj2SF")));
function $ff34980b521cf20d$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $ff34980b521cf20d$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, $ff34980b521cf20d$var$_getPrototypeOf2.default)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $ff34980b521cf20d$var$_getPrototypeOf2.default)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $ff34980b521cf20d$var$_possibleConstructorReturn2.default)(this, result);
    };
}
function $ff34980b521cf20d$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $ff34980b521cf20d$var$asyncDecodeAudioData(audioContext, arrayBuffer) {
    return new Promise(function(resolve, reject) {
        var promise = audioContext.decodeAudioData(arrayBuffer, resolve, reject); // Newer implementation of "decodeAudioData" will return a Promise
        promise && typeof promise.then === "function" && resolve(promise);
    });
}
function $ff34980b521cf20d$var$playDecoded(audioContext, audioBuffer, source) {
    return new Promise(function(resolve, reject) {
        var audioContextClosed = new $ff34980b521cf20d$var$_eventAsPromise.default();
        var sourceEnded = new $ff34980b521cf20d$var$_eventAsPromise.default();
        var unsubscribe = (0, $ff34980b521cf20d$var$_subscribeEvent.default)(audioContext, "statechange", function(_ref) {
            var state = _ref.target.state;
            return state === "closed" && audioContextClosed.eventListener();
        });
        try {
            source.buffer = audioBuffer; // "ended" may not fire if the underlying AudioContext is closed prematurely
            source.onended = sourceEnded.eventListener;
            source.connect(audioContext.destination);
            source.start(0);
            Promise.race([
                audioContextClosed.upcoming(),
                sourceEnded.upcoming()
            ]).then(resolve);
        } catch (err) {
            reject(err);
        } finally{
            unsubscribe();
        }
    });
}
var $ff34980b521cf20d$var$SpeechSynthesisUtterance = /*#__PURE__*/ function(_EventTarget) {
    (0, $ff34980b521cf20d$var$_inherits2.default)(SpeechSynthesisUtterance, _EventTarget);
    var _super = $ff34980b521cf20d$var$_createSuper(SpeechSynthesisUtterance);
    function SpeechSynthesisUtterance(text) {
        var _this;
        (0, $ff34980b521cf20d$var$_classCallCheck2.default)(this, SpeechSynthesisUtterance);
        _this = _super.call(this);
        _this._lang = null;
        _this._pitch = 1;
        _this._rate = 1;
        _this._voice = null;
        _this._volume = 1;
        _this.text = text;
        _this.onboundary = null;
        _this.onend = null;
        _this.onerror = null;
        _this.onmark = null;
        _this.onpause = null;
        _this.onresume = null;
        _this.onstart = null;
        return _this;
    }
    (0, $ff34980b521cf20d$var$_createClass2.default)(SpeechSynthesisUtterance, [
        {
            key: "lang",
            get: function get() {
                return this._lang;
            },
            set: function set(value) {
                this._lang = value;
            }
        },
        {
            key: "onboundary",
            get: function get() {
                return (0, $bgEWP.getEventAttributeValue)(this, "boundary");
            },
            set: function set(value) {
                (0, $bgEWP.setEventAttributeValue)(this, "boundary", value);
            }
        },
        {
            key: "onend",
            get: function get() {
                return (0, $bgEWP.getEventAttributeValue)(this, "end");
            },
            set: function set(value) {
                (0, $bgEWP.setEventAttributeValue)(this, "end", value);
            }
        },
        {
            key: "onerror",
            get: function get() {
                return (0, $bgEWP.getEventAttributeValue)(this, "error");
            },
            set: function set(value) {
                (0, $bgEWP.setEventAttributeValue)(this, "error", value);
            }
        },
        {
            key: "onmark",
            get: function get() {
                return (0, $bgEWP.getEventAttributeValue)(this, "mark");
            },
            set: function set(value) {
                (0, $bgEWP.setEventAttributeValue)(this, "mark", value);
            }
        },
        {
            key: "onpause",
            get: function get() {
                return (0, $bgEWP.getEventAttributeValue)(this, "pause");
            },
            set: function set(value) {
                (0, $bgEWP.setEventAttributeValue)(this, "pause", value);
            }
        },
        {
            key: "onresume",
            get: function get() {
                return (0, $bgEWP.getEventAttributeValue)(this, "resume");
            },
            set: function set(value) {
                (0, $bgEWP.setEventAttributeValue)(this, "resume", value);
            }
        },
        {
            key: "onstart",
            get: function get() {
                return (0, $bgEWP.getEventAttributeValue)(this, "start");
            },
            set: function set(value) {
                (0, $bgEWP.setEventAttributeValue)(this, "start", value);
            }
        },
        {
            key: "pitch",
            get: function get() {
                return this._pitch;
            },
            set: function set(value) {
                this._pitch = value;
            }
        },
        {
            key: "rate",
            get: function get() {
                return this._rate;
            },
            set: function set(value) {
                this._rate = value;
            }
        },
        {
            key: "voice",
            get: function get() {
                return this._voice;
            },
            set: function set(value) {
                this._voice = value;
            }
        },
        {
            key: "volume",
            get: function get() {
                return this._volume;
            },
            set: function set(value) {
                this._volume = value;
            }
        },
        {
            key: "preload",
            value: function preload(_ref2) {
                var deploymentId = _ref2.deploymentId, fetchCredentials = _ref2.fetchCredentials, outputFormat = _ref2.outputFormat;
                this.arrayBufferPromise = (0, $ff34980b521cf20d$var$_fetchSpeechData.default)({
                    fetchCredentials: fetchCredentials,
                    deploymentId: deploymentId,
                    lang: this.lang || window.navigator.language,
                    outputFormat: outputFormat,
                    pitch: this.pitch,
                    rate: this.rate,
                    text: this.text,
                    voice: this.voice && this.voice.voiceURI,
                    volume: this.volume
                }); // We need to call "catch" to make sure the Promise is running.
                // We will ignore the reject result and handled in play() later.
                this.arrayBufferPromise.catch();
            }
        },
        {
            key: "play",
            value: function() {
                var _play = (0, $ff34980b521cf20d$var$_asyncToGenerator2.default)(/*#__PURE__*/ $ff34980b521cf20d$var$_regenerator.default.mark(function _callee(audioContext) {
                    var source, audioBuffer;
                    return $ff34980b521cf20d$var$_regenerator.default.wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                _context.prev = 0;
                                // We should emit "start" event even if preload() failed.
                                this.dispatchEvent(new $ff34980b521cf20d$var$_SpeechSynthesisEvent.default("start")); // HACK: iOS requires bufferSourceNode to be constructed before decoding data.
                                source = audioContext.createBufferSource();
                                _context.t0 = $ff34980b521cf20d$var$asyncDecodeAudioData;
                                _context.t1 = audioContext;
                                _context.next = 7;
                                return this.arrayBufferPromise;
                            case 7:
                                _context.t2 = _context.sent;
                                _context.next = 10;
                                return (0, _context.t0)(_context.t1, _context.t2);
                            case 10:
                                audioBuffer = _context.sent;
                                this._playingSource = source;
                                _context.next = 14;
                                return $ff34980b521cf20d$var$playDecoded(audioContext, audioBuffer, source);
                            case 14:
                                this._playingSource = null;
                                this.dispatchEvent(new $ff34980b521cf20d$var$_SpeechSynthesisEvent.default("end"));
                                _context.next = 21;
                                break;
                            case 18:
                                _context.prev = 18;
                                _context.t3 = _context["catch"](0);
                                // "message" is not in spec but to provide a friendly message.
                                this.dispatchEvent(new ErrorEvent("error", {
                                    error: "synthesis-failed",
                                    message: _context.t3.stack
                                }));
                            case 21:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this, [
                        [
                            0,
                            18
                        ]
                    ]);
                }));
                function play(_x) {
                    return _play.apply(this, arguments);
                }
                return play;
            }()
        },
        {
            key: "stop",
            value: function stop() {
                this._playingSource && this._playingSource.stop();
            }
        }
    ]);
    return SpeechSynthesisUtterance;
}($bgEWP.EventTarget);
var $ff34980b521cf20d$var$_default = $ff34980b521cf20d$var$SpeechSynthesisUtterance;
module.exports.default = $ff34980b521cf20d$var$_default;

});
parcelRequire.register("2pzIa", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1c199e153c518367$var$_pDefer = $1c199e153c518367$var$_interopRequireDefault((parcelRequire("gmCnw")));
function $1c199e153c518367$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $1c199e153c518367$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $1c199e153c518367$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $1c199e153c518367$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $1c199e153c518367$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $1c199e153c518367$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
var $1c199e153c518367$var$EventAsPromise = /*#__PURE__*/ function() {
    function EventAsPromise() {
        var _this = this;
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        $1c199e153c518367$var$_classCallCheck(this, EventAsPromise);
        this.defers = [];
        this.upcomingDeferred = null;
        this.eventListener = this.eventListener.bind(this);
        this.options = options;
        this.one = this.one.bind(this);
        this.upcoming = this.upcoming.bind(this);
        this[Symbol.iterator] = function() {
            return {
                next: function next() {
                    return {
                        done: false,
                        value: _this.upcoming()
                    };
                }
            };
        };
    }
    $1c199e153c518367$var$_createClass(EventAsPromise, [
        {
            key: "eventListener",
            value: function eventListener(event) {
                var deferred = this.defers.shift();
                var args = this.options.array ? [].slice.call(arguments) : event;
                deferred && deferred.resolve(args);
                if (this.upcomingDeferred) {
                    this.upcomingDeferred.resolve(args);
                    this.upcomingDeferred = null;
                }
            }
        },
        {
            key: "one",
            value: function one() {
                var deferred = (0, $1c199e153c518367$var$_pDefer.default)();
                this.defers.push(deferred);
                return deferred.promise;
            }
        },
        {
            key: "upcoming",
            value: function upcoming() {
                if (!this.upcomingDeferred) this.upcomingDeferred = (0, $1c199e153c518367$var$_pDefer.default)();
                return this.upcomingDeferred.promise;
            }
        }
    ]);
    return EventAsPromise;
}();
module.exports.default = $1c199e153c518367$var$EventAsPromise;
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});
parcelRequire.register("gmCnw", function(module, exports) {
// The MIT License (MIT)
//
// Copyright (c) Sindre Sorhus <sindresorhus@gmail.com> (sindresorhus.com)
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.
// This piece of code is adopted from https://github.com/sindresorhus/p-defer
// The reason why we need to fork it is because:
// - The original package published to NPM is not ES5-compliant
//    - Due to the use of arrow functions
// - create-react-app@1 does not play nice with packages that are not ES5-compliant
//    - create-react-app@2 do play nice, but it was so new that most of the people are still on @1
// Criteria to remove this package:
// - When create-react-app@2 become mainstream, or,
// - When p-defer start publishing a ES5-compliant version on NPM
"use strict";
module.exports = function() {
    var ret = {};
    ret.promise = new Promise(function(resolve, reject) {
        ret.resolve = resolve;
        ret.reject = reject;
    });
    return ret;
};

});


parcelRequire.register("fqDP0", function(module, exports) {
"use strict";

var $lsqXV = parcelRequire("lsqXV");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $b3b82c7ea7991286$var$_default;

var $b3b82c7ea7991286$var$_regenerator = $lsqXV((parcelRequire("jfaTe")));

var $b3b82c7ea7991286$var$_defineProperty2 = $lsqXV((parcelRequire("7jg8p")));

var $b3b82c7ea7991286$var$_asyncToGenerator2 = $lsqXV((parcelRequire("jT3Iz")));

var $gmKnH = parcelRequire("gmKnH");

var $b3b82c7ea7991286$var$_buildSSML = $lsqXV((parcelRequire("fj7Se")));

var $b3b82c7ea7991286$var$_isSSML = $lsqXV((parcelRequire("dYATw")));
function $b3b82c7ea7991286$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $b3b82c7ea7991286$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $b3b82c7ea7991286$var$ownKeys(Object(source), !0).forEach(function(key) {
            (0, $b3b82c7ea7991286$var$_defineProperty2.default)(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $b3b82c7ea7991286$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var $b3b82c7ea7991286$var$DEFAULT_LANGUAGE = "en-US";
var $b3b82c7ea7991286$var$DEFAULT_OUTPUT_FORMAT = "riff-16khz-16bit-mono-pcm";
var $b3b82c7ea7991286$var$DEFAULT_VOICE = "Microsoft Server Speech Text to Speech Voice (en-US, AriaNeural)";
var $b3b82c7ea7991286$var$EMPTY_MP3_BASE64 = "SUQzBAAAAAAAI1RTU0UAAAAPAAADTGF2ZjU3LjU2LjEwMQAAAAAAAAAAAAAA//tAwAAAAAAAAAAAAAAAAAAAAAAASW5mbwAAAA8AAAACAAABhgC7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7//////////////////////////////////////////////////////////////////8AAAAATGF2YzU3LjY0AAAAAAAAAAAAAAAAJAUHAAAAAAAAAYYoRBqpAAAAAAD/+xDEAAPAAAGkAAAAIAAANIAAAARMQU1FMy45OS41VVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVf/7EMQpg8AAAaQAAAAgAAA0gAAABFVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVV";
function $b3b82c7ea7991286$var$_default(_x) {
    return $b3b82c7ea7991286$var$_ref2.apply(this, arguments);
}
function $b3b82c7ea7991286$var$_ref2() {
    $b3b82c7ea7991286$var$_ref2 = (0, $b3b82c7ea7991286$var$_asyncToGenerator2.default)(/*#__PURE__*/ $b3b82c7ea7991286$var$_regenerator.default.mark(function _callee(_ref) {
        var deploymentId, fetchCredentials, _ref$lang, lang, _ref$outputFormat, outputFormat, pitch, rate, text, _ref$voice, voice, volume, _yield$fetchCredentia, authorizationToken, region, speechSynthesisHostname, subscriptionKey, ssml, hostname, search, url, res;
        return $b3b82c7ea7991286$var$_regenerator.default.wrap(function _callee$(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    deploymentId = _ref.deploymentId, fetchCredentials = _ref.fetchCredentials, _ref$lang = _ref.lang, lang = _ref$lang === void 0 ? $b3b82c7ea7991286$var$DEFAULT_LANGUAGE : _ref$lang, _ref$outputFormat = _ref.outputFormat, outputFormat = _ref$outputFormat === void 0 ? $b3b82c7ea7991286$var$DEFAULT_OUTPUT_FORMAT : _ref$outputFormat, pitch = _ref.pitch, rate = _ref.rate, text = _ref.text, _ref$voice = _ref.voice, voice = _ref$voice === void 0 ? $b3b82c7ea7991286$var$DEFAULT_VOICE : _ref$voice, volume = _ref.volume;
                    if (text) {
                        _context.next = 3;
                        break;
                    }
                    return _context.abrupt("return", (0, $gmKnH.decode)($b3b82c7ea7991286$var$EMPTY_MP3_BASE64));
                case 3:
                    _context.next = 5;
                    return fetchCredentials();
                case 5:
                    _yield$fetchCredentia = _context.sent;
                    authorizationToken = _yield$fetchCredentia.authorizationToken;
                    region = _yield$fetchCredentia.region;
                    speechSynthesisHostname = _yield$fetchCredentia.speechSynthesisHostname;
                    subscriptionKey = _yield$fetchCredentia.subscriptionKey;
                    if (!(authorizationToken && subscriptionKey || !authorizationToken && !subscriptionKey)) {
                        _context.next = 14;
                        break;
                    }
                    throw new Error('Only "authorizationToken" or "subscriptionKey" should be set.');
                case 14:
                    if (!(region && speechSynthesisHostname || !region && !speechSynthesisHostname)) {
                        _context.next = 16;
                        break;
                    }
                    throw new Error('Only "region" or "speechSynthesisHostnamename" should be set.');
                case 16:
                    ssml = (0, $b3b82c7ea7991286$var$_isSSML.default)(text) ? text : (0, $b3b82c7ea7991286$var$_buildSSML.default)({
                        lang: lang,
                        pitch: pitch,
                        rate: rate,
                        text: text,
                        voice: voice,
                        volume: volume
                    }); // Although calling encodeURI on hostname does not actually works, it fails faster and safer.
                    hostname = speechSynthesisHostname || (deploymentId ? "".concat(encodeURI(region), ".voice.speech.microsoft.com") : "".concat(encodeURI(region), ".tts.speech.microsoft.com"));
                    search = deploymentId ? "?deploymentId=".concat(encodeURI(deploymentId)) : "";
                    url = "https://".concat(hostname, "/cognitiveservices/v1").concat(search);
                    _context.next = 22;
                    return fetch(url, {
                        headers: $b3b82c7ea7991286$var$_objectSpread({
                            "Content-Type": "application/ssml+xml",
                            "X-Microsoft-OutputFormat": outputFormat
                        }, authorizationToken ? {
                            Authorization: "Bearer ".concat(authorizationToken)
                        } : {
                            "Ocp-Apim-Subscription-Key": subscriptionKey
                        }),
                        method: "POST",
                        body: ssml
                    });
                case 22:
                    res = _context.sent;
                    if (res.ok) {
                        _context.next = 25;
                        break;
                    }
                    throw new Error("web-speech-cognitive-services: Failed to syntheis speech, server returned ".concat(res.status));
                case 25:
                    return _context.abrupt("return", res.arrayBuffer());
                case 26:
                case "end":
                    return _context.stop();
            }
        }, _callee);
    }));
    return $b3b82c7ea7991286$var$_ref2.apply(this, arguments);
}

});
parcelRequire.register("gmKnH", function(module, exports) {

$parcel$export(module.exports, "decode", () => $bea2adbf6326183f$export$2f872c0f2117be69);
/*
 * base64-arraybuffer 1.0.2 <https://github.com/niklasvh/base64-arraybuffer>
 * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
 * Released under MIT License
 */ var $bea2adbf6326183f$var$chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
// Use a lookup table to find the index.
var $bea2adbf6326183f$var$lookup = typeof Uint8Array === "undefined" ? [] : new Uint8Array(256);
for(var $bea2adbf6326183f$var$i = 0; $bea2adbf6326183f$var$i < $bea2adbf6326183f$var$chars.length; $bea2adbf6326183f$var$i++)$bea2adbf6326183f$var$lookup[$bea2adbf6326183f$var$chars.charCodeAt($bea2adbf6326183f$var$i)] = $bea2adbf6326183f$var$i;
var $bea2adbf6326183f$export$c564cdbbe6da493 = function(arraybuffer) {
    var bytes = new Uint8Array(arraybuffer), i, len = bytes.length, base64 = "";
    for(i = 0; i < len; i += 3){
        base64 += $bea2adbf6326183f$var$chars[bytes[i] >> 2];
        base64 += $bea2adbf6326183f$var$chars[(bytes[i] & 3) << 4 | bytes[i + 1] >> 4];
        base64 += $bea2adbf6326183f$var$chars[(bytes[i + 1] & 15) << 2 | bytes[i + 2] >> 6];
        base64 += $bea2adbf6326183f$var$chars[bytes[i + 2] & 63];
    }
    if (len % 3 === 2) base64 = base64.substring(0, base64.length - 1) + "=";
    else if (len % 3 === 1) base64 = base64.substring(0, base64.length - 2) + "==";
    return base64;
};
var $bea2adbf6326183f$export$2f872c0f2117be69 = function(base64) {
    var bufferLength = base64.length * 0.75, len = base64.length, i, p = 0, encoded1, encoded2, encoded3, encoded4;
    if (base64[base64.length - 1] === "=") {
        bufferLength--;
        if (base64[base64.length - 2] === "=") bufferLength--;
    }
    var arraybuffer = new ArrayBuffer(bufferLength), bytes = new Uint8Array(arraybuffer);
    for(i = 0; i < len; i += 4){
        encoded1 = $bea2adbf6326183f$var$lookup[base64.charCodeAt(i)];
        encoded2 = $bea2adbf6326183f$var$lookup[base64.charCodeAt(i + 1)];
        encoded3 = $bea2adbf6326183f$var$lookup[base64.charCodeAt(i + 2)];
        encoded4 = $bea2adbf6326183f$var$lookup[base64.charCodeAt(i + 3)];
        bytes[p++] = encoded1 << 2 | encoded2 >> 4;
        bytes[p++] = (encoded2 & 15) << 4 | encoded3 >> 2;
        bytes[p++] = (encoded3 & 3) << 6 | encoded4 & 63;
    }
    return arraybuffer;
};

});

parcelRequire.register("fj7Se", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $b24ebce5478c73cf$var$buildSSML;
/* eslint no-magic-numbers: ["error", { "ignore": [0, 1, 100] }] */ // Cognitive Services does not support unsigned percentage
// It must be converted into +/- first.
function $b24ebce5478c73cf$var$relativePercentage(value) {
    var relative = Math.round((value - 1) * 100);
    if (relative >= 0) relative = "+" + relative;
    return relative + "%";
}
function $b24ebce5478c73cf$var$buildSSML(_ref) {
    var lang = _ref.lang, _ref$pitch = _ref.pitch, pitch = _ref$pitch === void 0 ? 1 : _ref$pitch, _ref$rate = _ref.rate, rate = _ref$rate === void 0 ? 1 : _ref$rate, text = _ref.text, voice = _ref.voice, volume = _ref.volume;
    return '<speak version="1.0" xml:lang="'.concat(lang, '">\n  <voice xml:lang="').concat(lang, '" name="').concat(voice, '">\n    <prosody pitch="').concat($b24ebce5478c73cf$var$relativePercentage(pitch), '" rate="').concat($b24ebce5478c73cf$var$relativePercentage(rate), '" volume="').concat($b24ebce5478c73cf$var$relativePercentage(volume), '">\n      ').concat(text, "\n    </prosody>\n  </voice>\n</speak>");
}

});

parcelRequire.register("dYATw", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $a2cd7f75ceb71aec$var$isSSML;
var $a2cd7f75ceb71aec$var$SPEAK_TAG_PATTERN = /^[\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]*<speak([\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]|\/?>)/;
var $a2cd7f75ceb71aec$var$XML_PROLOG_PATTERN = /^[\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]*<\?xml[\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]/;
function $a2cd7f75ceb71aec$var$isSSML(text) {
    return $a2cd7f75ceb71aec$var$SPEAK_TAG_PATTERN.test(text) || $a2cd7f75ceb71aec$var$XML_PROLOG_PATTERN.test(text);
}

});


parcelRequire.register("cj2SF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $8f597e6ac765ee9b$var$subscribeEvent;
function $8f597e6ac765ee9b$var$subscribeEvent(target, name, handler) {
    target.addEventListener(name, handler);
    return function() {
        return target.removeEventListener(name, handler);
    };
}

});




parcelRequire.register("g3aCs", function(module, exports) {
"use strict";

var $lsqXV = parcelRequire("lsqXV");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $baf529eaba2fde61$var$_default;

var $baf529eaba2fde61$var$_regenerator = $lsqXV((parcelRequire("jfaTe")));

var $baf529eaba2fde61$var$_asyncToGenerator2 = $lsqXV((parcelRequire("jT3Iz")));
var $baf529eaba2fde61$var$TOKEN_URL_TEMPLATE = "https://{region}.api.cognitive.microsoft.com/sts/v1.0/issueToken";
function $baf529eaba2fde61$var$_default(_x) {
    return $baf529eaba2fde61$var$_ref2.apply(this, arguments);
}
function $baf529eaba2fde61$var$_ref2() {
    $baf529eaba2fde61$var$_ref2 = (0, $baf529eaba2fde61$var$_asyncToGenerator2.default)(/*#__PURE__*/ $baf529eaba2fde61$var$_regenerator.default.mark(function _callee(_ref) {
        var region, subscriptionKey, res;
        return $baf529eaba2fde61$var$_regenerator.default.wrap(function _callee$(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    region = _ref.region, subscriptionKey = _ref.subscriptionKey;
                    _context.next = 3;
                    return fetch($baf529eaba2fde61$var$TOKEN_URL_TEMPLATE.replace(/\{region\}/, region), {
                        headers: {
                            "Ocp-Apim-Subscription-Key": subscriptionKey
                        },
                        method: "POST"
                    });
                case 3:
                    res = _context.sent;
                    if (res.ok) {
                        _context.next = 6;
                        break;
                    }
                    throw new Error("Failed to fetch authorization token, server returned ".concat(res.status));
                case 6:
                    return _context.abrupt("return", res.text());
                case 7:
                case "end":
                    return _context.stop();
            }
        }, _callee);
    }));
    return $baf529eaba2fde61$var$_ref2.apply(this, arguments);
}

});


parcelRequire.register("iKa9Q", function(module, exports) {
"use strict";

var $luOtD = parcelRequire("luOtD");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $da5466fd2bc9ebc3$var$createMicrophoneAudioConfigAndAudioContext;

var $da5466fd2bc9ebc3$var$_regenerator = $luOtD((parcelRequire("dn7GQ")));

var $da5466fd2bc9ebc3$var$_slicedToArray2 = $luOtD((parcelRequire("fhBCP")));

var $da5466fd2bc9ebc3$var$_asyncToGenerator2 = $luOtD((parcelRequire("7F1D9")));

var $7srwU = parcelRequire("7srwU");

var $9h4kO = parcelRequire("9h4kO");

var $da5466fd2bc9ebc3$var$_bytesPerSample = $luOtD((parcelRequire("H5wPj")));

var $da5466fd2bc9ebc3$var$_createAudioConfig = $luOtD((parcelRequire("JF2oB")));

var $da5466fd2bc9ebc3$var$_createAudioContext = $luOtD((parcelRequire("58U4K")));

var $da5466fd2bc9ebc3$var$_getUserMedia = $luOtD((parcelRequire("4J6xC")));
// This is how often we are flushing audio buffer to the network. Modify this value will affect latency.
var $da5466fd2bc9ebc3$var$DEFAULT_BUFFER_DURATION_IN_MS = 100; // TODO: [P2] #3975 We should consider building our own PcmRecorder:
//       - Use Audio Worklet via blob URL
//       - Not hardcoding the sample rate or other values
// PcmRecorder always downscale to 16000 Hz. We cannot use the dynamic value from MediaConstraints or MediaTrackSettings.
var $da5466fd2bc9ebc3$var$PCM_RECORDER_HARDCODED_SETTINGS = Object.freeze({
    channelCount: 1,
    sampleRate: 16000,
    sampleSize: 16
});
var $da5466fd2bc9ebc3$var$PCM_RECORDER_HARDCODED_FORMAT = Object.freeze({
    bitsPerSample: $da5466fd2bc9ebc3$var$PCM_RECORDER_HARDCODED_SETTINGS.sampleSize,
    // `channelCount` is not on @types/web@0.0.54 yet, related to https://github.com/microsoft/TypeScript-DOM-lib-generator/issues/1290.
    // @ts-ignore
    channels: $da5466fd2bc9ebc3$var$PCM_RECORDER_HARDCODED_SETTINGS.channelCount,
    samplesPerSec: $da5466fd2bc9ebc3$var$PCM_RECORDER_HARDCODED_SETTINGS.sampleRate
});
function $da5466fd2bc9ebc3$var$createMicrophoneAudioConfig(options) {
    var audioConstraints = options.audioConstraints, audioContext = options.audioContext, debug = options.debug, enableTelemetry = options.enableTelemetry, pcmRecorderWorkletUrl = options.pcmRecorderWorkletUrl;
    var bufferDurationInMS = options.bufferDurationInMS || $da5466fd2bc9ebc3$var$DEFAULT_BUFFER_DURATION_IN_MS; // Related to #4523.
    // When bumping to recent version of `microsoft-cognitiveservices-speech-sdk@>=1.23.0`, pass `true` to the constructor.
    // const pcmRecorder = new PcmRecorder(true);
    var pcmRecorder = new $9h4kO.PcmRecorder();
    pcmRecorderWorkletUrl && pcmRecorder.setWorkletUrl(pcmRecorderWorkletUrl);
    return (0, $da5466fd2bc9ebc3$var$_createAudioConfig.default)({
        attach: function attach(audioNodeId) {
            return (0, $da5466fd2bc9ebc3$var$_asyncToGenerator2.default)(/*#__PURE__*/ $da5466fd2bc9ebc3$var$_regenerator.default.mark(function _callee() {
                var mediaStream, _mediaStream$getAudio, _mediaStream$getAudio2, firstAudioTrack, outputStream;
                return $da5466fd2bc9ebc3$var$_regenerator.default.wrap(function _callee$(_context) {
                    while(true)switch(_context.prev = _context.next){
                        case 0:
                            _context.next = 2;
                            return (0, $da5466fd2bc9ebc3$var$_getUserMedia.default)({
                                audio: audioConstraints,
                                video: false
                            });
                        case 2:
                            mediaStream = _context.sent;
                            _mediaStream$getAudio = mediaStream.getAudioTracks(), _mediaStream$getAudio2 = (0, $da5466fd2bc9ebc3$var$_slicedToArray2.default)(_mediaStream$getAudio, 1), firstAudioTrack = _mediaStream$getAudio2[0];
                            if (firstAudioTrack) {
                                _context.next = 6;
                                break;
                            }
                            throw new Error("No audio device is found.");
                        case 6:
                            outputStream = new $7srwU.ChunkedArrayBufferStream((0, $da5466fd2bc9ebc3$var$_bytesPerSample.default)($da5466fd2bc9ebc3$var$PCM_RECORDER_HARDCODED_SETTINGS) * ((bufferDurationInMS || $da5466fd2bc9ebc3$var$DEFAULT_BUFFER_DURATION_IN_MS) / 1000), audioNodeId);
                            pcmRecorder.record(audioContext, mediaStream, outputStream);
                            return _context.abrupt("return", {
                                audioStreamNode: {
                                    // Speech SDK quirks: In SDK's original MicAudioSource implementation, it call turnOff() during detach().
                                    //                    That means, it call turnOff(), then detach(), then turnOff() again. Seems redundant.
                                    //                    When using with Direct Line Speech, turnOff() is never called.
                                    detach: function detach() {
                                        // Speech SDK quirks: In SDK, it call outputStream.close() in turnOff() before outputStream.readEnded() in detach().
                                        //                    I think it make sense to call readEnded() before close().
                                        outputStream.readEnded();
                                        outputStream.close(); // PcmRecorder.releaseMediaResources() will disconnect/stop the MediaStream.
                                        // We cannot use MediaStream again after turned off.
                                        pcmRecorder.releaseMediaResources(audioContext); // MediaStream will become inactive after all tracks are removed.
                                        mediaStream.getTracks().forEach(function(track) {
                                            return mediaStream.removeTrack(track);
                                        }); // ESLint: "return" is required by TypeScript
                                        // eslint-disable-next-line no-useless-return
                                        return;
                                    },
                                    id: function id() {
                                        return audioNodeId;
                                    },
                                    read: function read() {
                                        return outputStream.read();
                                    }
                                },
                                deviceInfo: {
                                    manufacturer: "Bot Framework Web Chat",
                                    model: enableTelemetry ? firstAudioTrack.label : "",
                                    type: enableTelemetry ? "Microphones" : "Unknown"
                                },
                                // Speech SDK quirks: PcmRecorder hardcoded sample rate of 16000 Hz.
                                //                    We cannot obtain this number other than looking at their source code.
                                //                    I.e. no getter property.
                                // PcmRecorder always downscale to 16000 Hz. We cannot use the dynamic value from MediaConstraints or MediaTrackSettings.
                                format: $da5466fd2bc9ebc3$var$PCM_RECORDER_HARDCODED_FORMAT
                            });
                        case 9:
                        case "end":
                            return _context.stop();
                    }
                }, _callee);
            }))();
        },
        debug: debug
    });
}
function $da5466fd2bc9ebc3$var$createMicrophoneAudioConfigAndAudioContext(_ref) {
    var audioContext = _ref.audioContext, audioInputDeviceId = _ref.audioInputDeviceId, enableTelemetry = _ref.enableTelemetry;
    // Web Chat has an implementation of AudioConfig for microphone that would enable better support on Safari:
    // - Maintain same instance of `AudioContext` across recognitions;
    // - Resume suspended `AudioContext` on user gestures.
    //
    // This is filed as https://github.com/microsoft/cognitive-services-speech-sdk-js/issues/571.
    // Before Speech SDK team take our suggestion, we need to continue using a custom AudioConfig object to persist the blessing.
    audioContext || (audioContext = (0, $da5466fd2bc9ebc3$var$_createAudioContext.default)());
    return {
        audioConfig: $da5466fd2bc9ebc3$var$createMicrophoneAudioConfig({
            audioConstraints: audioInputDeviceId ? {
                deviceId: audioInputDeviceId
            } : true,
            audioContext: audioContext,
            enableTelemetry: enableTelemetry ? true : undefined
        }),
        audioContext: audioContext
    };
}

});
parcelRequire.register("dn7GQ", function(module, exports) {
// TODO(Babel 8): Remove this file.

var $9bc36370c28557e8$var$runtime = (parcelRequire("6XPtx"))();
module.exports = $9bc36370c28557e8$var$runtime;
// Copied from https://github.com/facebook/regenerator/blob/main/packages/runtime/runtime.js#L736=
try {
    regeneratorRuntime = $9bc36370c28557e8$var$runtime;
} catch (accidentalStrictMode) {
    if (typeof globalThis === "object") globalThis.regeneratorRuntime = $9bc36370c28557e8$var$runtime;
    else Function("r", "regeneratorRuntime = r")($9bc36370c28557e8$var$runtime);
}

});
parcelRequire.register("6XPtx", function(module, exports) {

var $2PxO1 = parcelRequire("2PxO1");
var $51202eb34019a095$var$_typeof = $2PxO1.default;
function $51202eb34019a095$var$_regeneratorRuntime() {
    "use strict";
    /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ module.exports = $51202eb34019a095$var$_regeneratorRuntime = function _regeneratorRuntime() {
        return exports;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports;
    var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
    function define(obj, key, value) {
        return Object.defineProperty(obj, key, {
            value: value,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }), obj[key];
    }
    try {
        define({}, "");
    } catch (err) {
        define = function define(obj, key, value) {
            return obj[key] = value;
        };
    }
    function wrap(innerFn, outerFn, self, tryLocsList) {
        var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []);
        return generator._invoke = function(innerFn, self, context) {
            var state = "suspendedStart";
            return function(method, arg) {
                if ("executing" === state) throw new Error("Generator is already running");
                if ("completed" === state) {
                    if ("throw" === method) throw arg;
                    return doneResult();
                }
                for(context.method = method, context.arg = arg;;){
                    var delegate = context.delegate;
                    if (delegate) {
                        var delegateResult = maybeInvokeDelegate(delegate, context);
                        if (delegateResult) {
                            if (delegateResult === ContinueSentinel) continue;
                            return delegateResult;
                        }
                    }
                    if ("next" === context.method) context.sent = context._sent = context.arg;
                    else if ("throw" === context.method) {
                        if ("suspendedStart" === state) throw state = "completed", context.arg;
                        context.dispatchException(context.arg);
                    } else "return" === context.method && context.abrupt("return", context.arg);
                    state = "executing";
                    var record = tryCatch(innerFn, self, context);
                    if ("normal" === record.type) {
                        if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue;
                        return {
                            value: record.arg,
                            done: context.done
                        };
                    }
                    "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg);
                }
            };
        }(innerFn, self, context), generator;
    }
    function tryCatch(fn, obj, arg) {
        try {
            return {
                type: "normal",
                arg: fn.call(obj, arg)
            };
        } catch (err) {
            return {
                type: "throw",
                arg: err
            };
        }
    }
    exports.wrap = wrap;
    var ContinueSentinel = {};
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    var IteratorPrototype = {};
    define(IteratorPrototype, iteratorSymbol, function() {
        return this;
    });
    var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([])));
    NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype);
    var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
    function defineIteratorMethods(prototype) {
        [
            "next",
            "throw",
            "return"
        ].forEach(function(method) {
            define(prototype, method, function(arg) {
                return this._invoke(method, arg);
            });
        });
    }
    function AsyncIterator(generator, PromiseImpl) {
        function invoke(method, arg, resolve, reject) {
            var record = tryCatch(generator[method], generator, arg);
            if ("throw" !== record.type) {
                var result = record.arg, value = result.value;
                return value && "object" == $51202eb34019a095$var$_typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function(value) {
                    invoke("next", value, resolve, reject);
                }, function(err) {
                    invoke("throw", err, resolve, reject);
                }) : PromiseImpl.resolve(value).then(function(unwrapped) {
                    result.value = unwrapped, resolve(result);
                }, function(error) {
                    return invoke("throw", error, resolve, reject);
                });
            }
            reject(record.arg);
        }
        var previousPromise;
        this._invoke = function(method, arg) {
            function callInvokeWithMethodAndArg() {
                return new PromiseImpl(function(resolve, reject) {
                    invoke(method, arg, resolve, reject);
                });
            }
            return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
        };
    }
    function maybeInvokeDelegate(delegate, context) {
        var method = delegate.iterator[context.method];
        if (undefined === method) {
            if (context.delegate = null, "throw" === context.method) {
                if (delegate.iterator["return"] && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel;
                context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method");
            }
            return ContinueSentinel;
        }
        var record = tryCatch(method, delegate.iterator, context.arg);
        if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel;
        var info = record.arg;
        return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel);
    }
    function pushTryEntry(locs) {
        var entry = {
            tryLoc: locs[0]
        };
        1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry);
    }
    function resetTryEntry(entry) {
        var record = entry.completion || {};
        record.type = "normal", delete record.arg, entry.completion = record;
    }
    function Context(tryLocsList) {
        this.tryEntries = [
            {
                tryLoc: "root"
            }
        ], tryLocsList.forEach(pushTryEntry, this), this.reset(!0);
    }
    function values(iterable) {
        if (iterable) {
            var iteratorMethod = iterable[iteratorSymbol];
            if (iteratorMethod) return iteratorMethod.call(iterable);
            if ("function" == typeof iterable.next) return iterable;
            if (!isNaN(iterable.length)) {
                var i = -1, next = function next() {
                    for(; ++i < iterable.length;){
                        if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next;
                    }
                    return next.value = undefined, next.done = !0, next;
                };
                return next.next = next;
            }
        }
        return {
            next: doneResult
        };
    }
    function doneResult() {
        return {
            value: undefined,
            done: !0
        };
    }
    return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function(genFun) {
        var ctor = "function" == typeof genFun && genFun.constructor;
        return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name));
    }, exports.mark = function(genFun) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun;
    }, exports.awrap = function(arg) {
        return {
            __await: arg
        };
    }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function() {
        return this;
    }), exports.AsyncIterator = AsyncIterator, exports.async = function(innerFn, outerFn, self, tryLocsList, PromiseImpl) {
        void 0 === PromiseImpl && (PromiseImpl = Promise);
        var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
        return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function(result) {
            return result.done ? result.value : iter.next();
        });
    }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function() {
        return this;
    }), define(Gp, "toString", function() {
        return "[object Generator]";
    }), exports.keys = function(object) {
        var keys = [];
        for(var key in object)keys.push(key);
        return keys.reverse(), function next() {
            for(; keys.length;){
                var key = keys.pop();
                if (key in object) return next.value = key, next.done = !1, next;
            }
            return next.done = !0, next;
        };
    }, exports.values = values, Context.prototype = {
        constructor: Context,
        reset: function reset(skipTempReset) {
            if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for(var name in this)"t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined);
        },
        stop: function stop() {
            this.done = !0;
            var rootRecord = this.tryEntries[0].completion;
            if ("throw" === rootRecord.type) throw rootRecord.arg;
            return this.rval;
        },
        dispatchException: function dispatchException(exception) {
            if (this.done) throw exception;
            var context = this;
            function handle(loc, caught) {
                return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught;
            }
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i], record = entry.completion;
                if ("root" === entry.tryLoc) return handle("end");
                if (entry.tryLoc <= this.prev) {
                    var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc");
                    if (hasCatch && hasFinally) {
                        if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
                        if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
                    } else if (hasCatch) {
                        if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
                    } else {
                        if (!hasFinally) throw new Error("try statement without catch or finally");
                        if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
                    }
                }
            }
        },
        abrupt: function abrupt(type, arg) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
                    var finallyEntry = entry;
                    break;
                }
            }
            finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null);
            var record = finallyEntry ? finallyEntry.completion : {};
            return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record);
        },
        complete: function complete(record, afterLoc) {
            if ("throw" === record.type) throw record.arg;
            return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel;
        },
        finish: function finish(finallyLoc) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel;
            }
        },
        "catch": function _catch(tryLoc) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.tryLoc === tryLoc) {
                    var record = entry.completion;
                    if ("throw" === record.type) {
                        var thrown = record.arg;
                        resetTryEntry(entry);
                    }
                    return thrown;
                }
            }
            throw new Error("illegal catch attempt");
        },
        delegateYield: function delegateYield(iterable, resultName, nextLoc) {
            return this.delegate = {
                iterator: values(iterable),
                resultName: resultName,
                nextLoc: nextLoc
            }, "next" === this.method && (this.arg = undefined), ContinueSentinel;
        }
    }, exports;
}
module.exports = $51202eb34019a095$var$_regeneratorRuntime, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRequire.register("7F1D9", function(module, exports) {
function $593da0837501893c$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) resolve(value);
    else Promise.resolve(value).then(_next, _throw);
}
function $593da0837501893c$var$_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                $593da0837501893c$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                $593da0837501893c$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
module.exports = $593da0837501893c$var$_asyncToGenerator, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRequire.register("H5wPj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $08184e1a9fa9c73a$var$bytesPerSample;
function $08184e1a9fa9c73a$var$bytesPerSample(settings) {
    // `channelCount` is not on @types/web@0.0.54 yet, related to https://github.com/microsoft/TypeScript-DOM-lib-generator/issues/1290.
    // @ts-ignore
    // eslint-disable-next-line no-magic-numbers
    return (settings.sampleSize >> 3) * settings.channelCount * settings.sampleRate;
}

});

parcelRequire.register("JF2oB", function(module, exports) {
"use strict";

var $luOtD = parcelRequire("luOtD");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $0894094e1002624a$var$createAudioConfig;

var $0894094e1002624a$var$_classCallCheck2 = $luOtD((parcelRequire("hYNAh")));

var $0894094e1002624a$var$_createClass2 = $luOtD((parcelRequire("8Eu5W")));

var $0894094e1002624a$var$_assertThisInitialized2 = $luOtD((parcelRequire("LgN0b")));

var $0894094e1002624a$var$_inherits2 = $luOtD((parcelRequire("lCAS6")));

var $0894094e1002624a$var$_possibleConstructorReturn2 = $luOtD((parcelRequire("l6X0V")));

var $0894094e1002624a$var$_getPrototypeOf2 = $luOtD((parcelRequire("f0Kuj")));

var $0894094e1002624a$var$_defineProperty2 = $luOtD((parcelRequire("3w8Sv")));

var $jZE2L = parcelRequire("jZE2L");

var $0894094e1002624a$var$_CustomAudioInputStream = $luOtD((parcelRequire("1yh3Y")));
function $0894094e1002624a$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $0894094e1002624a$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, $0894094e1002624a$var$_getPrototypeOf2.default)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $0894094e1002624a$var$_getPrototypeOf2.default)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $0894094e1002624a$var$_possibleConstructorReturn2.default)(this, result);
    };
}
function $0894094e1002624a$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
var $0894094e1002624a$var$SYMBOL_ATTACH = Symbol("attach");
var $0894094e1002624a$var$SYMBOL_TURN_OFF = Symbol("turnOff");
var $0894094e1002624a$var$CreateAudioConfigAudioInputStream = /*#__PURE__*/ function(_CustomAudioInputStre) {
    (0, $0894094e1002624a$var$_inherits2.default)(CreateAudioConfigAudioInputStream, _CustomAudioInputStre);
    var _super = $0894094e1002624a$var$_createSuper(CreateAudioConfigAudioInputStream);
    function CreateAudioConfigAudioInputStream(_ref) {
        var _this;
        var attach = _ref.attach, debug = _ref.debug, turnOff = _ref.turnOff;
        (0, $0894094e1002624a$var$_classCallCheck2.default)(this, CreateAudioConfigAudioInputStream);
        if (!attach || typeof attach !== "function") throw new Error('"attach" must be a function.');
        if (turnOff && typeof turnOff !== "function") throw new Error('"turnOff", if defined, must be a function.');
        _this = _super.call(this, {
            debug: debug
        }); // False alarm: indexer is a constant of type Symbol.
        // eslint-disable-next-line security/detect-object-injection
        (0, $0894094e1002624a$var$_defineProperty2.default)((0, $0894094e1002624a$var$_assertThisInitialized2.default)(_this), $0894094e1002624a$var$SYMBOL_ATTACH, void 0);
        (0, $0894094e1002624a$var$_defineProperty2.default)((0, $0894094e1002624a$var$_assertThisInitialized2.default)(_this), $0894094e1002624a$var$SYMBOL_TURN_OFF, void 0);
        _this[$0894094e1002624a$var$SYMBOL_ATTACH] = attach; // False alarm: indexer is a constant of type Symbol.
        // eslint-disable-next-line security/detect-object-injection
        _this[$0894094e1002624a$var$SYMBOL_TURN_OFF] = turnOff;
        return _this;
    }
    (0, $0894094e1002624a$var$_createClass2.default)(CreateAudioConfigAudioInputStream, [
        {
            key: "performAttach",
            value: function performAttach(audioNodeId) {
                // False alarm: indexer is a constant of type Symbol.
                // eslint-disable-next-line security/detect-object-injection
                return this[$0894094e1002624a$var$SYMBOL_ATTACH](audioNodeId);
            }
        },
        {
            key: "performTurnOff",
            value: function performTurnOff() {
                var turnOff = this[$0894094e1002624a$var$SYMBOL_TURN_OFF];
                return turnOff && turnOff();
            }
        }
    ]);
    return CreateAudioConfigAudioInputStream;
}($0894094e1002624a$var$_CustomAudioInputStream.default);
function $0894094e1002624a$var$createAudioConfig(options) {
    return $jZE2L.AudioConfig.fromStreamInput(new $0894094e1002624a$var$CreateAudioConfigAudioInputStream(options));
}

});
parcelRequire.register("LgN0b", function(module, exports) {
function $08e169eaaec8c584$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
module.exports = $08e169eaaec8c584$var$_assertThisInitialized, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRequire.register("lCAS6", function(module, exports) {

var $cWBZU = parcelRequire("cWBZU");
function $fbd9bf8709c41109$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $cWBZU(subClass, superClass);
}
module.exports = $fbd9bf8709c41109$var$_inherits, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRequire.register("cWBZU", function(module, exports) {
function $96c86057fcc760d3$var$_setPrototypeOf(o, p) {
    module.exports = $96c86057fcc760d3$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports;
    return $96c86057fcc760d3$var$_setPrototypeOf(o, p);
}
module.exports = $96c86057fcc760d3$var$_setPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRequire.register("l6X0V", function(module, exports) {

var $2PxO1 = parcelRequire("2PxO1");
var $f5e7ef7387b220ea$var$_typeof = $2PxO1.default;

var $LgN0b = parcelRequire("LgN0b");
function $f5e7ef7387b220ea$var$_possibleConstructorReturn(self, call) {
    if (call && ($f5e7ef7387b220ea$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $LgN0b(self);
}
module.exports = $f5e7ef7387b220ea$var$_possibleConstructorReturn, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRequire.register("f0Kuj", function(module, exports) {
function $aedaeaa824cf0e2b$var$_getPrototypeOf(o) {
    module.exports = $aedaeaa824cf0e2b$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    }, module.exports.__esModule = true, module.exports["default"] = module.exports;
    return $aedaeaa824cf0e2b$var$_getPrototypeOf(o);
}
module.exports = $aedaeaa824cf0e2b$var$_getPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRequire.register("jZE2L", function(module, exports) {

$parcel$export(module.exports, "AudioConfig", () => $e8e2c6a4ed3bd381$export$3b730bf34c92a0f9);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
parcelRequire("if2Nv");
var $7tK1S = parcelRequire("7tK1S");
var $6CzcC = parcelRequire("6CzcC");
var $7caxD = parcelRequire("7caxD");

var $gSYyK = parcelRequire("gSYyK");

var $4hIrn = parcelRequire("4hIrn");
var $krC72 = parcelRequire("krC72");
var $eijUb = parcelRequire("eijUb");
var $hwoOI = parcelRequire("hwoOI");
var $8fy4F = parcelRequire("8fy4F");

var $g7EHq = parcelRequire("g7EHq");

var $4hIrn = parcelRequire("4hIrn");

var $eijUb = parcelRequire("eijUb");
class $e8e2c6a4ed3bd381$export$3b730bf34c92a0f9 {
    /**
     * Creates an AudioConfig object representing the default microphone on the system.
     * @member AudioConfig.fromDefaultMicrophoneInput
     * @function
     * @public
     * @returns {AudioConfig} The audio input configuration being created.
     */ static fromDefaultMicrophoneInput() {
        const pcmRecorder = new (0, $7tK1S.PcmRecorder)();
        return new $e8e2c6a4ed3bd381$export$7da309f8663a918b(new (0, $6CzcC.MicAudioSource)(pcmRecorder));
    }
    /**
     * Creates an AudioConfig object representing a microphone with the specified device ID.
     * @member AudioConfig.fromMicrophoneInput
     * @function
     * @public
     * @param {string | undefined} deviceId - Specifies the device ID of the microphone to be used.
     *        Default microphone is used the value is omitted.
     * @returns {AudioConfig} The audio input configuration being created.
     */ static fromMicrophoneInput(deviceId) {
        const pcmRecorder = new (0, $7tK1S.PcmRecorder)();
        return new $e8e2c6a4ed3bd381$export$7da309f8663a918b(new (0, $6CzcC.MicAudioSource)(pcmRecorder, deviceId));
    }
    /**
     * Creates an AudioConfig object representing the specified file.
     * @member AudioConfig.fromWavFileInput
     * @function
     * @public
     * @param {File} fileName - Specifies the audio input file. Currently, only WAV / PCM is supported.
     * @returns {AudioConfig} The audio input configuration being created.
     */ static fromWavFileInput(file, name = "unnamedBuffer.wav") {
        return new $e8e2c6a4ed3bd381$export$7da309f8663a918b(new (0, $7caxD.FileAudioSource)(file, name));
    }
    /**
     * Creates an AudioConfig object representing the specified stream.
     * @member AudioConfig.fromStreamInput
     * @function
     * @public
     * @param {AudioInputStream | PullAudioInputStreamCallback | MediaStream} audioStream - Specifies the custom audio input
     *        stream. Currently, only WAV / PCM is supported.
     * @returns {AudioConfig} The audio input configuration being created.
     */ static fromStreamInput(audioStream) {
        if (audioStream instanceof (0, $krC72.PullAudioInputStreamCallback)) return new $e8e2c6a4ed3bd381$export$7da309f8663a918b(new (0, $4hIrn.PullAudioInputStreamImpl)(audioStream));
        if (audioStream instanceof (0, $4hIrn.AudioInputStream)) return new $e8e2c6a4ed3bd381$export$7da309f8663a918b(audioStream);
        if (typeof MediaStream !== "undefined" && audioStream instanceof MediaStream) {
            const pcmRecorder = new (0, $7tK1S.PcmRecorder)();
            return new $e8e2c6a4ed3bd381$export$7da309f8663a918b(new (0, $6CzcC.MicAudioSource)(pcmRecorder, null, null, audioStream));
        }
        throw new Error("Not Supported Type");
    }
    /**
     * Creates an AudioConfig object representing the default speaker.
     * @member AudioConfig.fromDefaultSpeakerOutput
     * @function
     * @public
     * @returns {AudioConfig} The audio output configuration being created.
     * Added in version 1.11.0
     */ static fromDefaultSpeakerOutput() {
        return new $e8e2c6a4ed3bd381$export$6474c8308a86365e(new (0, $8fy4F.SpeakerAudioDestination)());
    }
    /**
     * Creates an AudioConfig object representing the custom IPlayer object.
     * You can use the IPlayer object to control pause, resume, etc.
     * @member AudioConfig.fromSpeakerOutput
     * @function
     * @public
     * @param {IPlayer} player - the IPlayer object for playback.
     * @returns {AudioConfig} The audio output configuration being created.
     * Added in version 1.12.0
     */ static fromSpeakerOutput(player) {
        if (player === undefined) return $e8e2c6a4ed3bd381$export$3b730bf34c92a0f9.fromDefaultSpeakerOutput();
        if (player instanceof (0, $8fy4F.SpeakerAudioDestination)) return new $e8e2c6a4ed3bd381$export$6474c8308a86365e(player);
        throw new Error("Not Supported Type");
    }
    /**
     * Creates an AudioConfig object representing a specified output audio file
     * @member AudioConfig.fromAudioFileOutput
     * @function
     * @public
     * @param {PathLike} filename - the filename of the output audio file
     * @returns {AudioConfig} The audio output configuration being created.
     * Added in version 1.11.0
     */ static fromAudioFileOutput(filename) {
        return new $e8e2c6a4ed3bd381$export$6474c8308a86365e(new (0, $g7EHq.AudioFileWriter)(filename));
    }
    /**
     * Creates an AudioConfig object representing a specified audio output stream
     * @member AudioConfig.fromStreamOutput
     * @function
     * @public
     * @param {AudioOutputStream | PushAudioOutputStreamCallback} audioStream - Specifies the custom audio output
     *        stream.
     * @returns {AudioConfig} The audio output configuration being created.
     * Added in version 1.11.0
     */ static fromStreamOutput(audioStream) {
        if (audioStream instanceof (0, $hwoOI.PushAudioOutputStreamCallback)) return new $e8e2c6a4ed3bd381$export$6474c8308a86365e(new (0, $eijUb.PushAudioOutputStreamImpl)(audioStream));
        if (audioStream instanceof (0, $eijUb.PushAudioOutputStream)) return new $e8e2c6a4ed3bd381$export$6474c8308a86365e(audioStream);
        if (audioStream instanceof (0, $eijUb.PullAudioOutputStream)) return new $e8e2c6a4ed3bd381$export$6474c8308a86365e(audioStream);
        throw new Error("Not Supported Type");
    }
}
class $e8e2c6a4ed3bd381$export$7da309f8663a918b extends $e8e2c6a4ed3bd381$export$3b730bf34c92a0f9 {
    /**
     * Creates and initializes an instance of this class.
     * @constructor
     * @param {IAudioSource} source - An audio source.
     */ constructor(source){
        super();
        this.privSource = source;
    }
    /**
     * Format information for the audio
     */ get format() {
        return this.privSource.format;
    }
    /**
     * @member AudioConfigImpl.prototype.close
     * @function
     * @public
     */ close(cb, err) {
        this.privSource.turnOff().then(()=>{
            if (!!cb) cb();
        }, (error)=>{
            if (!!err) err(error);
        });
    }
    /**
     * @member AudioConfigImpl.prototype.id
     * @function
     * @public
     */ id() {
        return this.privSource.id();
    }
    /**
     * @member AudioConfigImpl.prototype.blob
     * @function
     * @public
     */ get blob() {
        return this.privSource.blob;
    }
    /**
     * @member AudioConfigImpl.prototype.turnOn
     * @function
     * @public
     * @returns {Promise<void>} A promise.
     */ turnOn() {
        return this.privSource.turnOn();
    }
    /**
     * @member AudioConfigImpl.prototype.attach
     * @function
     * @public
     * @param {string} audioNodeId - The audio node id.
     * @returns {Promise<IAudioStreamNode>} A promise.
     */ attach(audioNodeId) {
        return this.privSource.attach(audioNodeId);
    }
    /**
     * @member AudioConfigImpl.prototype.detach
     * @function
     * @public
     * @param {string} audioNodeId - The audio node id.
     */ detach(audioNodeId) {
        return this.privSource.detach(audioNodeId);
    }
    /**
     * @member AudioConfigImpl.prototype.turnOff
     * @function
     * @public
     * @returns {Promise<void>} A promise.
     */ turnOff() {
        return this.privSource.turnOff();
    }
    /**
     * @member AudioConfigImpl.prototype.events
     * @function
     * @public
     * @returns {EventSource<AudioSourceEvent>} An event source for audio events.
     */ get events() {
        return this.privSource.events;
    }
    setProperty(name, value) {
        (0, $gSYyK.Contracts).throwIfNull(value, "value");
        if (undefined !== this.privSource.setProperty) this.privSource.setProperty(name, value);
        else throw new Error("This AudioConfig instance does not support setting properties.");
    }
    getProperty(name, def) {
        if (undefined !== this.privSource.getProperty) return this.privSource.getProperty(name, def);
        else throw new Error("This AudioConfig instance does not support getting properties.");
        return def;
    }
    get deviceInfo() {
        return this.privSource.deviceInfo;
    }
}
class $e8e2c6a4ed3bd381$export$6474c8308a86365e extends $e8e2c6a4ed3bd381$export$3b730bf34c92a0f9 {
    /**
     * Creates and initializes an instance of this class.
     * @constructor
     * @param {IAudioDestination} destination - An audio destination.
     */ constructor(destination){
        super();
        this.privDestination = destination;
    }
    set format(format) {
        this.privDestination.format = format;
    }
    write(buffer) {
        this.privDestination.write(buffer);
    }
    close() {
        this.privDestination.close();
    }
    id() {
        return this.privDestination.id();
    }
    setProperty(name, value) {
        throw new Error("This AudioConfig instance does not support setting properties.");
    }
    getProperty(name, def) {
        throw new Error("This AudioConfig instance does not support getting properties.");
    }
}

});
parcelRequire.register("if2Nv", function(module, exports) {
$parcel$export(module.exports, "ConsoleLoggingListener", () => (parcelRequire("9tRWF")).ConsoleLoggingListener);
$parcel$export(module.exports, "PcmRecorder", () => (parcelRequire("7tK1S")).PcmRecorder);
$parcel$export(module.exports, "ReplayableAudioNode", () => (parcelRequire("cGmX2")).ReplayableAudioNode);
$parcel$export(module.exports, "ProxyInfo", () => (parcelRequire("2g5X6")).ProxyInfo);
$parcel$export(module.exports, "RestMessageAdapter", () => (parcelRequire("8OSsj")).RestMessageAdapter);
$parcel$export(module.exports, "RestRequestType", () => (parcelRequire("8OSsj")).RestRequestType);
$parcel$export(module.exports, "RestConfigBase", () => (parcelRequire("bP1UF")).RestConfigBase);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
parcelRequire("9tRWF");


var $6CzcC = parcelRequire("6CzcC");

var $7caxD = parcelRequire("7caxD");
parcelRequire("7tK1S");

var $71kSu = parcelRequire("71kSu");

var $6Nb8B = parcelRequire("6Nb8B");
parcelRequire("cGmX2");
parcelRequire("2g5X6");
parcelRequire("8OSsj");
parcelRequire("bP1UF");
$parcel$exportWildcard(module.exports, $6CzcC);
$parcel$exportWildcard(module.exports, $7caxD);
$parcel$exportWildcard(module.exports, $71kSu);
$parcel$exportWildcard(module.exports, $6Nb8B);

});
parcelRequire.register("9tRWF", function(module, exports) {

$parcel$export(module.exports, "ConsoleLoggingListener", () => $6e70aae3f605e48a$export$724e95fb67472979);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
parcelRequire("3KVS5");
var $aAKrf = parcelRequire("aAKrf");
class $6e70aae3f605e48a$export$724e95fb67472979 {
    constructor(logLevelFilter = (0, $aAKrf.EventType).Warning){
        this.onEvent = (event)=>{
            if (event.eventType >= this.privLogLevelFilter) {
                const log = this.toString(event);
                switch(event.eventType){
                    case (0, $aAKrf.EventType).Debug:
                        // tslint:disable-next-line:no-console
                        console.debug(log);
                        break;
                    case (0, $aAKrf.EventType).Info:
                        // tslint:disable-next-line:no-console
                        console.info(log);
                        break;
                    case (0, $aAKrf.EventType).Warning:
                        // tslint:disable-next-line:no-console
                        console.warn(log);
                        break;
                    case (0, $aAKrf.EventType).Error:
                        // tslint:disable-next-line:no-console
                        console.error(log);
                        break;
                    default:
                        // tslint:disable-next-line:no-console
                        console.log(log);
                        break;
                }
            }
        };
        this.toString = (event)=>{
            const logFragments = [
                `${event.EventTime}`,
                `${event.Name}`
            ];
            for(const prop in event)if (prop && event.hasOwnProperty(prop) && prop !== "eventTime" && prop !== "eventType" && prop !== "eventId" && prop !== "name" && prop !== "constructor") {
                const value = event[prop];
                let valueToLog = "<NULL>";
                if (value !== undefined && value !== null) {
                    if (typeof value === "number" || typeof value === "string") valueToLog = value.toString();
                    else valueToLog = JSON.stringify(value);
                }
                logFragments.push(`${prop}: ${valueToLog}`);
            }
            return logFragments.join(" | ");
        };
        this.privLogLevelFilter = logLevelFilter;
    }
}

});
parcelRequire.register("3KVS5", function(module, exports) {
$parcel$export(module.exports, "AudioSourceErrorEvent", () => (parcelRequire("btwY7")).AudioSourceErrorEvent);
$parcel$export(module.exports, "AudioSourceInitializingEvent", () => (parcelRequire("btwY7")).AudioSourceInitializingEvent);
$parcel$export(module.exports, "AudioSourceOffEvent", () => (parcelRequire("btwY7")).AudioSourceOffEvent);
$parcel$export(module.exports, "AudioSourceReadyEvent", () => (parcelRequire("btwY7")).AudioSourceReadyEvent);
$parcel$export(module.exports, "AudioStreamNodeAttachedEvent", () => (parcelRequire("btwY7")).AudioStreamNodeAttachedEvent);
$parcel$export(module.exports, "AudioStreamNodeAttachingEvent", () => (parcelRequire("btwY7")).AudioStreamNodeAttachingEvent);
$parcel$export(module.exports, "AudioStreamNodeDetachedEvent", () => (parcelRequire("btwY7")).AudioStreamNodeDetachedEvent);
$parcel$export(module.exports, "AudioStreamNodeErrorEvent", () => (parcelRequire("btwY7")).AudioStreamNodeErrorEvent);
$parcel$export(module.exports, "ConnectionClosedEvent", () => (parcelRequire("l8CKy")).ConnectionClosedEvent);
$parcel$export(module.exports, "ConnectionErrorEvent", () => (parcelRequire("l8CKy")).ConnectionErrorEvent);
$parcel$export(module.exports, "ConnectionEstablishedEvent", () => (parcelRequire("l8CKy")).ConnectionEstablishedEvent);
$parcel$export(module.exports, "ConnectionEstablishErrorEvent", () => (parcelRequire("l8CKy")).ConnectionEstablishErrorEvent);
$parcel$export(module.exports, "ConnectionMessageReceivedEvent", () => (parcelRequire("l8CKy")).ConnectionMessageReceivedEvent);
$parcel$export(module.exports, "ConnectionMessageSentEvent", () => (parcelRequire("l8CKy")).ConnectionMessageSentEvent);
$parcel$export(module.exports, "ConnectionStartEvent", () => (parcelRequire("l8CKy")).ConnectionStartEvent);
$parcel$export(module.exports, "ServiceEvent", () => (parcelRequire("l8CKy")).ServiceEvent);
$parcel$export(module.exports, "ConnectionMessage", () => (parcelRequire("4gz8B")).ConnectionMessage);
$parcel$export(module.exports, "MessageType", () => (parcelRequire("4gz8B")).MessageType);
$parcel$export(module.exports, "ConnectionOpenResponse", () => (parcelRequire("9rn5w")).ConnectionOpenResponse);
$parcel$export(module.exports, "ArgumentNullError", () => (parcelRequire("4Cx0W")).ArgumentNullError);
$parcel$export(module.exports, "Events", () => (parcelRequire("l9cUE")).Events);
$parcel$export(module.exports, "EventSource", () => (parcelRequire("76ZQQ")).EventSource);
$parcel$export(module.exports, "createGuid", () => (parcelRequire("kSC7p")).createGuid);
$parcel$export(module.exports, "createNoDashGuid", () => (parcelRequire("kSC7p")).createNoDashGuid);
$parcel$export(module.exports, "ConnectionState", () => (parcelRequire("8wq1O")).ConnectionState);
$parcel$export(module.exports, "EventType", () => (parcelRequire("aAKrf")).EventType);
$parcel$export(module.exports, "PlatformEvent", () => (parcelRequire("aAKrf")).PlatformEvent);
$parcel$export(module.exports, "Deferred", () => (parcelRequire("9MSEb")).Deferred);
$parcel$export(module.exports, "marshalPromiseToCallbacks", () => (parcelRequire("9MSEb")).marshalPromiseToCallbacks);
$parcel$export(module.exports, "RawWebsocketMessage", () => (parcelRequire("gcTfx")).RawWebsocketMessage);
$parcel$export(module.exports, "RiffPcmEncoder", () => (parcelRequire("lpx1B")).RiffPcmEncoder);
$parcel$export(module.exports, "ChunkedArrayBufferStream", () => (parcelRequire("18oN3")).ChunkedArrayBufferStream);
$parcel$export(module.exports, "Timeout", () => (parcelRequire("57VkO")).Timeout);
$parcel$export(module.exports, "OCSPCacheEntryExpiredEvent", () => (parcelRequire("1Uzk5")).OCSPCacheEntryExpiredEvent);
$parcel$export(module.exports, "OCSPCacheEntryNeedsRefreshEvent", () => (parcelRequire("1Uzk5")).OCSPCacheEntryNeedsRefreshEvent);
$parcel$export(module.exports, "OCSPCacheFetchErrorEvent", () => (parcelRequire("1Uzk5")).OCSPCacheFetchErrorEvent);
$parcel$export(module.exports, "OCSPCacheHitEvent", () => (parcelRequire("1Uzk5")).OCSPCacheHitEvent);
$parcel$export(module.exports, "OCSPCacheMissEvent", () => (parcelRequire("1Uzk5")).OCSPCacheMissEvent);
$parcel$export(module.exports, "OCSPCacheUpdatehCompleteEvent", () => (parcelRequire("1Uzk5")).OCSPCacheUpdatehCompleteEvent);
$parcel$export(module.exports, "OCSPCacheUpdateNeededEvent", () => (parcelRequire("1Uzk5")).OCSPCacheUpdateNeededEvent);
$parcel$export(module.exports, "OCSPDiskCacheHitEvent", () => (parcelRequire("1Uzk5")).OCSPDiskCacheHitEvent);
$parcel$export(module.exports, "OCSPDiskCacheStoreEvent", () => (parcelRequire("1Uzk5")).OCSPDiskCacheStoreEvent);
$parcel$export(module.exports, "OCSPMemoryCacheHitEvent", () => (parcelRequire("1Uzk5")).OCSPMemoryCacheHitEvent);
$parcel$export(module.exports, "OCSPMemoryCacheStoreEvent", () => (parcelRequire("1Uzk5")).OCSPMemoryCacheStoreEvent);
$parcel$export(module.exports, "OCSPResponseRetrievedEvent", () => (parcelRequire("1Uzk5")).OCSPResponseRetrievedEvent);
$parcel$export(module.exports, "OCSPStapleReceivedEvent", () => (parcelRequire("1Uzk5")).OCSPStapleReceivedEvent);
$parcel$export(module.exports, "OCSPVerificationFailedEvent", () => (parcelRequire("1Uzk5")).OCSPVerificationFailedEvent);
$parcel$export(module.exports, "BackgroundEvent", () => (parcelRequire("6p3HD")).BackgroundEvent);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
parcelRequire("btwY7");
parcelRequire("l8CKy");
parcelRequire("4gz8B");
parcelRequire("9rn5w");

parcelRequire("4Cx0W");
parcelRequire("l9cUE");
parcelRequire("76ZQQ");
parcelRequire("kSC7p");

parcelRequire("8wq1O");








parcelRequire("aAKrf");
parcelRequire("9MSEb");

var $i8Rdf = parcelRequire("i8Rdf");
parcelRequire("gcTfx");
parcelRequire("lpx1B");

var $5PiFE = parcelRequire("5PiFE");

var $gzURB = parcelRequire("gzURB");
parcelRequire("18oN3");

parcelRequire("57VkO");
parcelRequire("1Uzk5");
parcelRequire("6p3HD");
$parcel$exportWildcard(module.exports, $i8Rdf);
$parcel$exportWildcard(module.exports, $5PiFE);

});
parcelRequire.register("btwY7", function(module, exports) {

$parcel$export(module.exports, "AudioSourceInitializingEvent", () => $85abfa093befad6a$export$3ea896e783b014bc);
$parcel$export(module.exports, "AudioSourceReadyEvent", () => $85abfa093befad6a$export$54b576ec7ac02ebe);
$parcel$export(module.exports, "AudioSourceOffEvent", () => $85abfa093befad6a$export$6b78daffb3d5512d);
$parcel$export(module.exports, "AudioSourceErrorEvent", () => $85abfa093befad6a$export$846353fbe6243328);
$parcel$export(module.exports, "AudioStreamNodeAttachingEvent", () => $85abfa093befad6a$export$4fd6277c5ad6f287);
$parcel$export(module.exports, "AudioStreamNodeAttachedEvent", () => $85abfa093befad6a$export$5080ccbedcd117ea);
$parcel$export(module.exports, "AudioStreamNodeDetachedEvent", () => $85abfa093befad6a$export$cc8a6ff2edb60616);
$parcel$export(module.exports, "AudioStreamNodeErrorEvent", () => $85abfa093befad6a$export$787ac83068e70a4c);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
// tslint:disable:max-classes-per-file

var $aAKrf = parcelRequire("aAKrf");
class $85abfa093befad6a$export$46570d6d6ccc791d extends (0, $aAKrf.PlatformEvent) {
    constructor(eventName, audioSourceId, eventType = (0, $aAKrf.EventType).Info){
        super(eventName, eventType);
        this.privAudioSourceId = audioSourceId;
    }
    get audioSourceId() {
        return this.privAudioSourceId;
    }
}
class $85abfa093befad6a$export$3ea896e783b014bc extends $85abfa093befad6a$export$46570d6d6ccc791d {
    constructor(audioSourceId){
        super("AudioSourceInitializingEvent", audioSourceId);
    }
}
class $85abfa093befad6a$export$54b576ec7ac02ebe extends $85abfa093befad6a$export$46570d6d6ccc791d {
    constructor(audioSourceId){
        super("AudioSourceReadyEvent", audioSourceId);
    }
}
class $85abfa093befad6a$export$6b78daffb3d5512d extends $85abfa093befad6a$export$46570d6d6ccc791d {
    constructor(audioSourceId){
        super("AudioSourceOffEvent", audioSourceId);
    }
}
class $85abfa093befad6a$export$846353fbe6243328 extends $85abfa093befad6a$export$46570d6d6ccc791d {
    constructor(audioSourceId, error){
        super("AudioSourceErrorEvent", audioSourceId, (0, $aAKrf.EventType).Error);
        this.privError = error;
    }
    get error() {
        return this.privError;
    }
}
class $85abfa093befad6a$export$bcf1319de53b0d5d extends $85abfa093befad6a$export$46570d6d6ccc791d {
    constructor(eventName, audioSourceId, audioNodeId){
        super(eventName, audioSourceId);
        this.privAudioNodeId = audioNodeId;
    }
    get audioNodeId() {
        return this.privAudioNodeId;
    }
}
class $85abfa093befad6a$export$4fd6277c5ad6f287 extends $85abfa093befad6a$export$bcf1319de53b0d5d {
    constructor(audioSourceId, audioNodeId){
        super("AudioStreamNodeAttachingEvent", audioSourceId, audioNodeId);
    }
}
class $85abfa093befad6a$export$5080ccbedcd117ea extends $85abfa093befad6a$export$bcf1319de53b0d5d {
    constructor(audioSourceId, audioNodeId){
        super("AudioStreamNodeAttachedEvent", audioSourceId, audioNodeId);
    }
}
class $85abfa093befad6a$export$cc8a6ff2edb60616 extends $85abfa093befad6a$export$bcf1319de53b0d5d {
    constructor(audioSourceId, audioNodeId){
        super("AudioStreamNodeDetachedEvent", audioSourceId, audioNodeId);
    }
}
class $85abfa093befad6a$export$787ac83068e70a4c extends $85abfa093befad6a$export$bcf1319de53b0d5d {
    constructor(audioSourceId, audioNodeId, error){
        super("AudioStreamNodeErrorEvent", audioSourceId, audioNodeId);
        this.privError = error;
    }
    get error() {
        return this.privError;
    }
}

});
parcelRequire.register("aAKrf", function(module, exports) {

$parcel$export(module.exports, "EventType", () => $7b6149e3254fee9f$export$3d7865934588d77e);
$parcel$export(module.exports, "PlatformEvent", () => $7b6149e3254fee9f$export$fd68248162ec482a);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.

var $kSC7p = parcelRequire("kSC7p");
var $7b6149e3254fee9f$export$3d7865934588d77e;
(function(EventType) {
    EventType[EventType["Debug"] = 0] = "Debug";
    EventType[EventType["Info"] = 1] = "Info";
    EventType[EventType["Warning"] = 2] = "Warning";
    EventType[EventType["Error"] = 3] = "Error";
})($7b6149e3254fee9f$export$3d7865934588d77e || ($7b6149e3254fee9f$export$3d7865934588d77e = {}));
class $7b6149e3254fee9f$export$fd68248162ec482a {
    constructor(eventName, eventType){
        this.privName = eventName;
        this.privEventId = (0, $kSC7p.createNoDashGuid)();
        this.privEventTime = new Date().toISOString();
        this.privEventType = eventType;
        this.privMetadata = {};
    }
    get name() {
        return this.privName;
    }
    get eventId() {
        return this.privEventId;
    }
    get eventTime() {
        return this.privEventTime;
    }
    get eventType() {
        return this.privEventType;
    }
    get metadata() {
        return this.privMetadata;
    }
}

});
parcelRequire.register("kSC7p", function(module, exports) {

$parcel$export(module.exports, "createGuid", () => $f3366b54cfcc012e$export$7571c350ed9fec74);
$parcel$export(module.exports, "createNoDashGuid", () => $f3366b54cfcc012e$export$992f04952fbcb07f);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.

var $hG6NY = parcelRequire("hG6NY");
const $f3366b54cfcc012e$export$7571c350ed9fec74 = ()=>{
    return (0, $hG6NY.v4)();
};
const $f3366b54cfcc012e$export$992f04952fbcb07f = ()=>{
    return $f3366b54cfcc012e$export$7571c350ed9fec74().replace(new RegExp("-", "g"), "").toUpperCase();
};

});



parcelRequire.register("l8CKy", function(module, exports) {

$parcel$export(module.exports, "ServiceEvent", () => $f6386744539e996c$export$4a3bd582097411);
$parcel$export(module.exports, "ConnectionStartEvent", () => $f6386744539e996c$export$b07a5b383e429393);
$parcel$export(module.exports, "ConnectionEstablishedEvent", () => $f6386744539e996c$export$89bbcdbfdd7f98d6);
$parcel$export(module.exports, "ConnectionClosedEvent", () => $f6386744539e996c$export$c0d6050433d51d03);
$parcel$export(module.exports, "ConnectionErrorEvent", () => $f6386744539e996c$export$3299e654b279c3f8);
$parcel$export(module.exports, "ConnectionEstablishErrorEvent", () => $f6386744539e996c$export$e916fc8e35135338);
$parcel$export(module.exports, "ConnectionMessageReceivedEvent", () => $f6386744539e996c$export$60c815f18d84ea31);
$parcel$export(module.exports, "ConnectionMessageSentEvent", () => $f6386744539e996c$export$41b2353b9658d253);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.

var $aAKrf = parcelRequire("aAKrf");
class $f6386744539e996c$export$4a3bd582097411 extends (0, $aAKrf.PlatformEvent) {
    constructor(eventName, jsonstring, eventType = (0, $aAKrf.EventType).Info){
        super(eventName, eventType);
        this.privJsonResult = jsonstring;
    }
    get jsonString() {
        return this.privJsonResult;
    }
}
class $f6386744539e996c$export$a5d2cb21a485eb9 extends (0, $aAKrf.PlatformEvent) {
    constructor(eventName, connectionId, eventType = (0, $aAKrf.EventType).Info){
        super(eventName, eventType);
        this.privConnectionId = connectionId;
    }
    get connectionId() {
        return this.privConnectionId;
    }
}
class $f6386744539e996c$export$b07a5b383e429393 extends $f6386744539e996c$export$a5d2cb21a485eb9 {
    constructor(connectionId, uri, headers){
        super("ConnectionStartEvent", connectionId);
        this.privUri = uri;
        this.privHeaders = headers;
    }
    get uri() {
        return this.privUri;
    }
    get headers() {
        return this.privHeaders;
    }
}
class $f6386744539e996c$export$89bbcdbfdd7f98d6 extends $f6386744539e996c$export$a5d2cb21a485eb9 {
    constructor(connectionId, metadata){
        super("ConnectionEstablishedEvent", connectionId);
    }
}
class $f6386744539e996c$export$c0d6050433d51d03 extends $f6386744539e996c$export$a5d2cb21a485eb9 {
    constructor(connectionId, statusCode, reason){
        super("ConnectionClosedEvent", connectionId, (0, $aAKrf.EventType).Debug);
        this.privReason = reason;
        this.privStatusCode = statusCode;
    }
    get reason() {
        return this.privReason;
    }
    get statusCode() {
        return this.privStatusCode;
    }
}
class $f6386744539e996c$export$3299e654b279c3f8 extends $f6386744539e996c$export$a5d2cb21a485eb9 {
    constructor(connectionId, message, type){
        super("ConnectionErrorEvent", connectionId, (0, $aAKrf.EventType).Debug);
        this.privMessage = message;
        this.privType = type;
    }
    get message() {
        return this.privMessage;
    }
    get type() {
        return this.privType;
    }
}
class $f6386744539e996c$export$e916fc8e35135338 extends $f6386744539e996c$export$a5d2cb21a485eb9 {
    constructor(connectionId, statuscode, reason){
        super("ConnectionEstablishErrorEvent", connectionId, (0, $aAKrf.EventType).Error);
        this.privStatusCode = statuscode;
        this.privReason = reason;
    }
    get reason() {
        return this.privReason;
    }
    get statusCode() {
        return this.privStatusCode;
    }
}
class $f6386744539e996c$export$60c815f18d84ea31 extends $f6386744539e996c$export$a5d2cb21a485eb9 {
    constructor(connectionId, networkReceivedTimeISO, message){
        super("ConnectionMessageReceivedEvent", connectionId);
        this.privNetworkReceivedTime = networkReceivedTimeISO;
        this.privMessage = message;
    }
    get networkReceivedTime() {
        return this.privNetworkReceivedTime;
    }
    get message() {
        return this.privMessage;
    }
}
class $f6386744539e996c$export$41b2353b9658d253 extends $f6386744539e996c$export$a5d2cb21a485eb9 {
    constructor(connectionId, networkSentTimeISO, message){
        super("ConnectionMessageSentEvent", connectionId);
        this.privNetworkSentTime = networkSentTimeISO;
        this.privMessage = message;
    }
    get networkSentTime() {
        return this.privNetworkSentTime;
    }
    get message() {
        return this.privMessage;
    }
}

});

parcelRequire.register("4gz8B", function(module, exports) {

$parcel$export(module.exports, "MessageType", () => $31b3e9b1db961da9$export$80edbf15fa61a4db);
$parcel$export(module.exports, "ConnectionMessage", () => $31b3e9b1db961da9$export$fa43bbfea96f2015);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.

var $4Cx0W = parcelRequire("4Cx0W");

var $kSC7p = parcelRequire("kSC7p");
var $31b3e9b1db961da9$export$80edbf15fa61a4db;
(function(MessageType) {
    MessageType[MessageType["Text"] = 0] = "Text";
    MessageType[MessageType["Binary"] = 1] = "Binary";
})($31b3e9b1db961da9$export$80edbf15fa61a4db || ($31b3e9b1db961da9$export$80edbf15fa61a4db = {}));
class $31b3e9b1db961da9$export$fa43bbfea96f2015 {
    constructor(messageType, body, headers, id){
        this.privBody = null;
        if (messageType === $31b3e9b1db961da9$export$80edbf15fa61a4db.Text && body && !(typeof body === "string")) throw new (0, $4Cx0W.InvalidOperationError)("Payload must be a string");
        if (messageType === $31b3e9b1db961da9$export$80edbf15fa61a4db.Binary && body && !(body instanceof ArrayBuffer)) throw new (0, $4Cx0W.InvalidOperationError)("Payload must be ArrayBuffer");
        this.privMessageType = messageType;
        this.privBody = body;
        this.privHeaders = headers ? headers : {};
        this.privId = id ? id : (0, $kSC7p.createNoDashGuid)();
        switch(this.messageType){
            case $31b3e9b1db961da9$export$80edbf15fa61a4db.Binary:
                this.privSize = this.binaryBody !== null ? this.binaryBody.byteLength : 0;
                break;
            case $31b3e9b1db961da9$export$80edbf15fa61a4db.Text:
                this.privSize = this.textBody.length;
        }
    }
    get messageType() {
        return this.privMessageType;
    }
    get headers() {
        return this.privHeaders;
    }
    get body() {
        return this.privBody;
    }
    get textBody() {
        if (this.privMessageType === $31b3e9b1db961da9$export$80edbf15fa61a4db.Binary) throw new (0, $4Cx0W.InvalidOperationError)("Not supported for binary message");
        return this.privBody;
    }
    get binaryBody() {
        if (this.privMessageType === $31b3e9b1db961da9$export$80edbf15fa61a4db.Text) throw new (0, $4Cx0W.InvalidOperationError)("Not supported for text message");
        return this.privBody;
    }
    get id() {
        return this.privId;
    }
}

});
parcelRequire.register("4Cx0W", function(module, exports) {

$parcel$export(module.exports, "ArgumentNullError", () => $35d451f5d1954b6b$export$5ab68a1dbe1fe1a4);
$parcel$export(module.exports, "InvalidOperationError", () => $35d451f5d1954b6b$export$59a732e9476f38b5);
$parcel$export(module.exports, "ObjectDisposedError", () => $35d451f5d1954b6b$export$1697868c944415ee);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
// tslint:disable:max-classes-per-file
/**
 * The error that is thrown when an argument passed in is null.
 *
 * @export
 * @class ArgumentNullError
 * @extends {Error}
 */ class $35d451f5d1954b6b$export$5ab68a1dbe1fe1a4 extends Error {
    /**
     * Creates an instance of ArgumentNullError.
     *
     * @param {string} argumentName - Name of the argument that is null
     *
     * @memberOf ArgumentNullError
     */ constructor(argumentName){
        super(argumentName);
        this.name = "ArgumentNull";
        this.message = argumentName;
    }
}
class $35d451f5d1954b6b$export$59a732e9476f38b5 extends Error {
    /**
     * Creates an instance of InvalidOperationError.
     *
     * @param {string} error - The error
     *
     * @memberOf InvalidOperationError
     */ constructor(error){
        super(error);
        this.name = "InvalidOperation";
        this.message = error;
    }
}
class $35d451f5d1954b6b$export$1697868c944415ee extends Error {
    /**
     * Creates an instance of ObjectDisposedError.
     *
     * @param {string} objectName - The object that is disposed
     * @param {string} error - The error
     *
     * @memberOf ObjectDisposedError
     */ constructor(objectName, error){
        super(error);
        this.name = objectName + "ObjectDisposed";
        this.message = error;
    }
}

});


parcelRequire.register("9rn5w", function(module, exports) {

$parcel$export(module.exports, "ConnectionOpenResponse", () => $6df88b7cfc819c4b$export$c90e9ce8e513a038);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
class $6df88b7cfc819c4b$export$c90e9ce8e513a038 {
    constructor(statusCode, reason){
        this.privStatusCode = statusCode;
        this.privReason = reason;
    }
    get statusCode() {
        return this.privStatusCode;
    }
    get reason() {
        return this.privReason;
    }
}

});

parcelRequire.register("l9cUE", function(module, exports) {

$parcel$export(module.exports, "Events", () => $f6547469135946bc$export$ada873a34909da65);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.

var $4Cx0W = parcelRequire("4Cx0W");

var $76ZQQ = parcelRequire("76ZQQ");
class $f6547469135946bc$export$ada873a34909da65 {
    static get instance() {
        return $f6547469135946bc$export$ada873a34909da65.privInstance;
    }
}
$f6547469135946bc$export$ada873a34909da65.privInstance = new (0, $76ZQQ.EventSource)();
$f6547469135946bc$export$ada873a34909da65.setEventSource = (eventSource)=>{
    if (!eventSource) throw new (0, $4Cx0W.ArgumentNullError)("eventSource");
    $f6547469135946bc$export$ada873a34909da65.privInstance = eventSource;
};

});
parcelRequire.register("76ZQQ", function(module, exports) {

$parcel$export(module.exports, "EventSource", () => $52d9124fdff2056b$export$31c54eb8781d4391);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.

var $4Cx0W = parcelRequire("4Cx0W");

var $kSC7p = parcelRequire("kSC7p");
class $52d9124fdff2056b$export$31c54eb8781d4391 {
    constructor(metadata){
        this.privEventListeners = {};
        this.privIsDisposed = false;
        this.onEvent = (event)=>{
            if (this.isDisposed()) throw new (0, $4Cx0W.ObjectDisposedError)("EventSource");
            if (this.metadata) {
                for(const paramName in this.metadata)if (paramName) {
                    if (event.metadata) {
                        if (!event.metadata[paramName]) event.metadata[paramName] = this.metadata[paramName];
                    }
                }
            }
            for(const eventId in this.privEventListeners)if (eventId && this.privEventListeners[eventId]) this.privEventListeners[eventId](event);
        };
        this.attach = (onEventCallback)=>{
            const id = (0, $kSC7p.createNoDashGuid)();
            this.privEventListeners[id] = onEventCallback;
            return {
                detach: ()=>{
                    delete this.privEventListeners[id];
                    return Promise.resolve();
                }
            };
        };
        this.attachListener = (listener)=>{
            return this.attach(listener.onEvent);
        };
        this.isDisposed = ()=>{
            return this.privIsDisposed;
        };
        this.dispose = ()=>{
            this.privEventListeners = null;
            this.privIsDisposed = true;
        };
        this.privMetadata = metadata;
    }
    get metadata() {
        return this.privMetadata;
    }
}

});


parcelRequire.register("8wq1O", function(module, exports) {

$parcel$export(module.exports, "ConnectionState", () => $6345808d81f95a42$export$cd9c3c6bf535afc9);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
var $6345808d81f95a42$export$cd9c3c6bf535afc9;
(function(ConnectionState) {
    ConnectionState[ConnectionState["None"] = 0] = "None";
    ConnectionState[ConnectionState["Connected"] = 1] = "Connected";
    ConnectionState[ConnectionState["Connecting"] = 2] = "Connecting";
    ConnectionState[ConnectionState["Disconnected"] = 3] = "Disconnected";
})($6345808d81f95a42$export$cd9c3c6bf535afc9 || ($6345808d81f95a42$export$cd9c3c6bf535afc9 = {}));

});

parcelRequire.register("9MSEb", function(module, exports) {

$parcel$export(module.exports, "Deferred", () => $7202fc8395913091$export$85f6557964517f1a);
$parcel$export(module.exports, "marshalPromiseToCallbacks", () => $7202fc8395913091$export$509551f10457d7e0);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
var $7202fc8395913091$export$7bc76142acab2181;
(function(PromiseState) {
    PromiseState[PromiseState["None"] = 0] = "None";
    PromiseState[PromiseState["Resolved"] = 1] = "Resolved";
    PromiseState[PromiseState["Rejected"] = 2] = "Rejected";
})($7202fc8395913091$export$7bc76142acab2181 || ($7202fc8395913091$export$7bc76142acab2181 = {}));
class $7202fc8395913091$export$66aad414e2a6f5ad {
    constructor(promiseResultEventSource){
        this.throwIfError = ()=>{
            if (this.isError) throw this.error;
        };
        promiseResultEventSource.on((result)=>{
            if (!this.privIsCompleted) {
                this.privIsCompleted = true;
                this.privIsError = false;
                this.privResult = result;
            }
        }, (error)=>{
            if (!this.privIsCompleted) {
                this.privIsCompleted = true;
                this.privIsError = true;
                this.privError = error;
            }
        });
    }
    get isCompleted() {
        return this.privIsCompleted;
    }
    get isError() {
        return this.privIsError;
    }
    get error() {
        return this.privError;
    }
    get result() {
        return this.privResult;
    }
}
class $7202fc8395913091$export$30541693eb0f7895 {
    constructor(){
        this.setResult = (result)=>{
            this.privOnSetResult(result);
        };
        this.setError = (error)=>{
            this.privOnSetError(error);
        };
        this.on = (onSetResult, onSetError)=>{
            this.privOnSetResult = onSetResult;
            this.privOnSetError = onSetError;
        };
    }
}
class $7202fc8395913091$export$85f6557964517f1a {
    constructor(){
        this.resolve = (result)=>{
            this.privResolve(result);
            return this;
        };
        this.reject = (error)=>{
            this.privReject(error);
            return this;
        };
        this.privPromise = new Promise((resolve, reject)=>{
            this.privResolve = resolve;
            this.privReject = reject;
        });
    }
    get promise() {
        return this.privPromise;
    }
}
class $7202fc8395913091$export$e287445474a1d9bf {
    constructor(){
        this.privState = $7202fc8395913091$export$7bc76142acab2181.None;
        this.privPromiseResult = null;
        this.privPromiseResultEvents = null;
        this.privSuccessHandlers = [];
        this.privErrorHandlers = [];
        this.resolve = (result)=>{
            if (this.privState !== $7202fc8395913091$export$7bc76142acab2181.None) throw new Error("'Cannot resolve a completed promise'");
            this.privState = $7202fc8395913091$export$7bc76142acab2181.Resolved;
            this.privPromiseResultEvents.setResult(result);
            for(let i = 0; i < this.privSuccessHandlers.length; i++)this.executeSuccessCallback(result, this.privSuccessHandlers[i], this.privErrorHandlers[i]);
            this.detachHandlers();
        };
        this.reject = (error)=>{
            if (this.privState !== $7202fc8395913091$export$7bc76142acab2181.None) throw new Error("'Cannot reject a completed promise'");
            this.privState = $7202fc8395913091$export$7bc76142acab2181.Rejected;
            this.privPromiseResultEvents.setError(error);
            for (const errorHandler of this.privErrorHandlers)this.executeErrorCallback(error, errorHandler);
            this.detachHandlers();
        };
        this.on = (successCallback, errorCallback)=>{
            if (successCallback == null) successCallback = (r)=>{
                return;
            };
            if (this.privState === $7202fc8395913091$export$7bc76142acab2181.None) {
                this.privSuccessHandlers.push(successCallback);
                this.privErrorHandlers.push(errorCallback);
            } else {
                if (this.privState === $7202fc8395913091$export$7bc76142acab2181.Resolved) this.executeSuccessCallback(this.privPromiseResult.result, successCallback, errorCallback);
                else if (this.privState === $7202fc8395913091$export$7bc76142acab2181.Rejected) this.executeErrorCallback(this.privPromiseResult.error, errorCallback);
                this.detachHandlers();
            }
        };
        this.executeSuccessCallback = (result, successCallback, errorCallback)=>{
            try {
                successCallback(result);
            } catch (e) {
                this.executeErrorCallback(`'Unhandled callback error: ${e}'`, errorCallback);
            }
        };
        this.executeErrorCallback = (error, errorCallback)=>{
            if (errorCallback) try {
                errorCallback(error);
            } catch (e) {
                throw new Error(`'Unhandled callback error: ${e}. InnerError: ${error}'`);
            }
            else throw new Error(`'Unhandled error: ${error}'`);
        };
        this.detachHandlers = ()=>{
            this.privErrorHandlers = [];
            this.privSuccessHandlers = [];
        };
        this.privPromiseResultEvents = new $7202fc8395913091$export$30541693eb0f7895();
        this.privPromiseResult = new $7202fc8395913091$export$66aad414e2a6f5ad(this.privPromiseResultEvents);
    }
    get state() {
        return this.privState;
    }
    get result() {
        return this.privPromiseResult;
    }
}
function $7202fc8395913091$export$509551f10457d7e0(promise, cb, err) {
    promise.then((val)=>{
        try {
            if (!!cb) cb(val);
        } catch (error) {
            if (!!err) try {
                if (error instanceof Error) {
                    const typedError = error;
                    err(typedError.name + ": " + typedError.message);
                } else err(error);
            /* tslint:disable:no-empty */ } catch (error) {}
        }
    }, (error)=>{
        if (!!err) try {
            if (error instanceof Error) {
                const typedError = error;
                err(typedError.name + ": " + typedError.message);
            } else err(error);
        /* tslint:disable:no-empty */ } catch (error) {}
    });
}

});

parcelRequire.register("i8Rdf", function(module, exports) {

$parcel$export(module.exports, "Queue", () => $d3524043855e980a$export$3dc07afe418952bc);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.

var $4Cx0W = parcelRequire("4Cx0W");

var $ekL96 = parcelRequire("ekL96");

var $9MSEb = parcelRequire("9MSEb");
var $d3524043855e980a$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $d3524043855e980a$var$SubscriberType;
(function(SubscriberType) {
    SubscriberType[SubscriberType["Dequeue"] = 0] = "Dequeue";
    SubscriberType[SubscriberType["Peek"] = 1] = "Peek";
})($d3524043855e980a$var$SubscriberType || ($d3524043855e980a$var$SubscriberType = {}));
class $d3524043855e980a$export$3dc07afe418952bc {
    constructor(list){
        this.privPromiseStore = new (0, $ekL96.List)();
        this.privIsDrainInProgress = false;
        this.privIsDisposing = false;
        this.privDisposeReason = null;
        this.enqueue = (item)=>{
            this.throwIfDispose();
            this.enqueueFromPromise(new Promise((resolve, reject)=>{
                resolve(item);
            }));
        };
        this.enqueueFromPromise = (promise)=>{
            this.throwIfDispose();
            promise.then((val)=>{
                this.privList.add(val);
            /* tslint:disable:no-empty */ }, (error)=>{});
        };
        this.dequeue = ()=>{
            this.throwIfDispose();
            const deferredSubscriber = new (0, $9MSEb.Deferred)();
            if (this.privSubscribers) {
                this.privSubscribers.add({
                    deferral: deferredSubscriber,
                    type: $d3524043855e980a$var$SubscriberType.Dequeue
                });
                this.drain();
            }
            return deferredSubscriber.promise;
        };
        this.peek = ()=>{
            this.throwIfDispose();
            const deferredSubscriber = new (0, $9MSEb.Deferred)();
            const subs = this.privSubscribers;
            if (subs) {
                this.privSubscribers.add({
                    deferral: deferredSubscriber,
                    type: $d3524043855e980a$var$SubscriberType.Peek
                });
                this.drain();
            }
            return deferredSubscriber.promise;
        };
        this.length = ()=>{
            this.throwIfDispose();
            return this.privList.length();
        };
        this.isDisposed = ()=>{
            return this.privSubscribers == null;
        };
        this.drain = ()=>{
            if (!this.privIsDrainInProgress && !this.privIsDisposing) {
                this.privIsDrainInProgress = true;
                const subs = this.privSubscribers;
                const lists = this.privList;
                if (subs && lists) {
                    while(lists.length() > 0 && subs.length() > 0 && !this.privIsDisposing){
                        const subscriber = subs.removeFirst();
                        if (subscriber.type === $d3524043855e980a$var$SubscriberType.Peek) subscriber.deferral.resolve(lists.first());
                        else {
                            const dequeuedItem = lists.removeFirst();
                            subscriber.deferral.resolve(dequeuedItem);
                        }
                    }
                    // note: this block assumes cooperative multitasking, i.e.,
                    // between the if-statement and the assignment there are no
                    // thread switches.
                    // Reason is that between the initial const = this.; and this
                    // point there is the derral.resolve() operation that might have
                    // caused recursive calls to the Queue, especially, calling
                    // Dispose() on the queue alredy (which would reset the var
                    // here to null!).
                    // That should generally hold true for javascript...
                    if (this.privSubscribers === subs) this.privSubscribers = subs;
                    // note: this block assumes cooperative multitasking, i.e.,
                    // between the if-statement and the assignment there are no
                    // thread switches.
                    // Reason is that between the initial const = this.; and this
                    // point there is the derral.resolve() operation that might have
                    // caused recursive calls to the Queue, especially, calling
                    // Dispose() on the queue alredy (which would reset the var
                    // here to null!).
                    // That should generally hold true for javascript...
                    if (this.privList === lists) this.privList = lists;
                }
                this.privIsDrainInProgress = false;
            }
        };
        this.throwIfDispose = ()=>{
            if (this.isDisposed()) {
                if (this.privDisposeReason) throw new (0, $4Cx0W.InvalidOperationError)(this.privDisposeReason);
                throw new (0, $4Cx0W.ObjectDisposedError)("Queue");
            } else if (this.privIsDisposing) throw new (0, $4Cx0W.InvalidOperationError)("Queue disposing");
        };
        this.privList = list ? list : new (0, $ekL96.List)();
        this.privDetachables = [];
        this.privSubscribers = new (0, $ekL96.List)();
        this.privDetachables.push(this.privList.onAdded(this.drain));
    }
    drainAndDispose(pendingItemProcessor, reason) {
        return $d3524043855e980a$var$__awaiter(this, void 0, void 0, function*() {
            if (!this.isDisposed() && !this.privIsDisposing) {
                this.privDisposeReason = reason;
                this.privIsDisposing = true;
                const subs = this.privSubscribers;
                if (subs) {
                    while(subs.length() > 0){
                        const subscriber = subs.removeFirst();
                        // TODO: this needs work (Resolve(null) instead?).
                        subscriber.deferral.resolve(undefined);
                    // subscriber.deferral.reject("Disposed");
                    }
                    // note: this block assumes cooperative multitasking, i.e.,
                    // between the if-statement and the assignment there are no
                    // thread switches.
                    // Reason is that between the initial const = this.; and this
                    // point there is the derral.resolve() operation that might have
                    // caused recursive calls to the Queue, especially, calling
                    // Dispose() on the queue alredy (which would reset the var
                    // here to null!).
                    // That should generally hold true for javascript...
                    if (this.privSubscribers === subs) this.privSubscribers = subs;
                }
                for (const detachable of this.privDetachables)yield detachable.detach();
                if (this.privPromiseStore.length() > 0 && pendingItemProcessor) {
                    const promiseArray = [];
                    this.privPromiseStore.toArray().forEach((wrapper)=>{
                        promiseArray.push(wrapper);
                    });
                    return Promise.all(promiseArray).finally(()=>{
                        this.privSubscribers = null;
                        this.privList.forEach((item, index)=>{
                            pendingItemProcessor(item);
                        });
                        this.privList = null;
                        return;
                    }).then();
                } else {
                    this.privSubscribers = null;
                    this.privList = null;
                }
            }
        });
    }
    dispose(reason) {
        return $d3524043855e980a$var$__awaiter(this, void 0, void 0, function*() {
            yield this.drainAndDispose(null, reason);
        });
    }
}

});
parcelRequire.register("ekL96", function(module, exports) {

$parcel$export(module.exports, "List", () => $a6f7811a79663dd4$export$54c2e3dc7acea9f5);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.

var $4Cx0W = parcelRequire("4Cx0W");
class $a6f7811a79663dd4$export$54c2e3dc7acea9f5 {
    constructor(list){
        this.privSubscriptionIdCounter = 0;
        this.privAddSubscriptions = {};
        this.privRemoveSubscriptions = {};
        this.privDisposedSubscriptions = {};
        this.privDisposeReason = null;
        this.get = (itemIndex)=>{
            this.throwIfDisposed();
            return this.privList[itemIndex];
        };
        this.first = ()=>{
            return this.get(0);
        };
        this.last = ()=>{
            return this.get(this.length() - 1);
        };
        this.add = (item)=>{
            this.throwIfDisposed();
            this.insertAt(this.privList.length, item);
        };
        this.insertAt = (index, item)=>{
            this.throwIfDisposed();
            if (index === 0) this.privList.unshift(item);
            else if (index === this.privList.length) this.privList.push(item);
            else this.privList.splice(index, 0, item);
            this.triggerSubscriptions(this.privAddSubscriptions);
        };
        this.removeFirst = ()=>{
            this.throwIfDisposed();
            return this.removeAt(0);
        };
        this.removeLast = ()=>{
            this.throwIfDisposed();
            return this.removeAt(this.length() - 1);
        };
        this.removeAt = (index)=>{
            this.throwIfDisposed();
            return this.remove(index, 1)[0];
        };
        this.remove = (index, count)=>{
            this.throwIfDisposed();
            const removedElements = this.privList.splice(index, count);
            this.triggerSubscriptions(this.privRemoveSubscriptions);
            return removedElements;
        };
        this.clear = ()=>{
            this.throwIfDisposed();
            this.remove(0, this.length());
        };
        this.length = ()=>{
            this.throwIfDisposed();
            return this.privList.length;
        };
        this.onAdded = (addedCallback)=>{
            this.throwIfDisposed();
            const subscriptionId = this.privSubscriptionIdCounter++;
            this.privAddSubscriptions[subscriptionId] = addedCallback;
            return {
                detach: ()=>{
                    delete this.privAddSubscriptions[subscriptionId];
                    return Promise.resolve();
                }
            };
        };
        this.onRemoved = (removedCallback)=>{
            this.throwIfDisposed();
            const subscriptionId = this.privSubscriptionIdCounter++;
            this.privRemoveSubscriptions[subscriptionId] = removedCallback;
            return {
                detach: ()=>{
                    delete this.privRemoveSubscriptions[subscriptionId];
                    return Promise.resolve();
                }
            };
        };
        this.onDisposed = (disposedCallback)=>{
            this.throwIfDisposed();
            const subscriptionId = this.privSubscriptionIdCounter++;
            this.privDisposedSubscriptions[subscriptionId] = disposedCallback;
            return {
                detach: ()=>{
                    delete this.privDisposedSubscriptions[subscriptionId];
                    return Promise.resolve();
                }
            };
        };
        this.join = (seperator)=>{
            this.throwIfDisposed();
            return this.privList.join(seperator);
        };
        this.toArray = ()=>{
            const cloneCopy = Array();
            this.privList.forEach((val)=>{
                cloneCopy.push(val);
            });
            return cloneCopy;
        };
        this.any = (callback)=>{
            this.throwIfDisposed();
            if (callback) return this.where(callback).length() > 0;
            else return this.length() > 0;
        };
        this.all = (callback)=>{
            this.throwIfDisposed();
            return this.where(callback).length() === this.length();
        };
        this.forEach = (callback)=>{
            this.throwIfDisposed();
            for(let i = 0; i < this.length(); i++)callback(this.privList[i], i);
        };
        this.select = (callback)=>{
            this.throwIfDisposed();
            const selectList = [];
            for(let i = 0; i < this.privList.length; i++)selectList.push(callback(this.privList[i], i));
            return new $a6f7811a79663dd4$export$54c2e3dc7acea9f5(selectList);
        };
        this.where = (callback)=>{
            this.throwIfDisposed();
            const filteredList = new $a6f7811a79663dd4$export$54c2e3dc7acea9f5();
            for(let i = 0; i < this.privList.length; i++)if (callback(this.privList[i], i)) filteredList.add(this.privList[i]);
            return filteredList;
        };
        this.orderBy = (compareFn)=>{
            this.throwIfDisposed();
            const clonedArray = this.toArray();
            const orderedArray = clonedArray.sort(compareFn);
            return new $a6f7811a79663dd4$export$54c2e3dc7acea9f5(orderedArray);
        };
        this.orderByDesc = (compareFn)=>{
            this.throwIfDisposed();
            return this.orderBy((a, b)=>compareFn(b, a));
        };
        this.clone = ()=>{
            this.throwIfDisposed();
            return new $a6f7811a79663dd4$export$54c2e3dc7acea9f5(this.toArray());
        };
        this.concat = (list)=>{
            this.throwIfDisposed();
            return new $a6f7811a79663dd4$export$54c2e3dc7acea9f5(this.privList.concat(list.toArray()));
        };
        this.concatArray = (array)=>{
            this.throwIfDisposed();
            return new $a6f7811a79663dd4$export$54c2e3dc7acea9f5(this.privList.concat(array));
        };
        this.isDisposed = ()=>{
            return this.privList == null;
        };
        this.dispose = (reason)=>{
            if (!this.isDisposed()) {
                this.privDisposeReason = reason;
                this.privList = null;
                this.privAddSubscriptions = null;
                this.privRemoveSubscriptions = null;
                this.triggerSubscriptions(this.privDisposedSubscriptions);
            }
        };
        this.throwIfDisposed = ()=>{
            if (this.isDisposed()) throw new (0, $4Cx0W.ObjectDisposedError)("List", this.privDisposeReason);
        };
        this.triggerSubscriptions = (subscriptions)=>{
            if (subscriptions) {
                for(const subscriptionId in subscriptions)if (subscriptionId) subscriptions[subscriptionId]();
            }
        };
        this.privList = [];
        // copy the list rather than taking as is.
        if (list) for (const item of list)this.privList.push(item);
    }
}

});


parcelRequire.register("gcTfx", function(module, exports) {

$parcel$export(module.exports, "RawWebsocketMessage", () => $bcc89fbe9fd94185$export$4d4fca4599964cf2);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.

var $4gz8B = parcelRequire("4gz8B");

var $4Cx0W = parcelRequire("4Cx0W");

var $kSC7p = parcelRequire("kSC7p");
class $bcc89fbe9fd94185$export$4d4fca4599964cf2 {
    constructor(messageType, payload, id){
        this.privPayload = null;
        if (!payload) throw new (0, $4Cx0W.ArgumentNullError)("payload");
        if (messageType === (0, $4gz8B.MessageType).Binary && payload.__proto__.constructor.name !== "ArrayBuffer") throw new (0, $4Cx0W.InvalidOperationError)("Payload must be ArrayBuffer");
        if (messageType === (0, $4gz8B.MessageType).Text && !(typeof payload === "string")) throw new (0, $4Cx0W.InvalidOperationError)("Payload must be a string");
        this.privMessageType = messageType;
        this.privPayload = payload;
        this.privId = id ? id : (0, $kSC7p.createNoDashGuid)();
    }
    get messageType() {
        return this.privMessageType;
    }
    get payload() {
        return this.privPayload;
    }
    get textContent() {
        if (this.privMessageType === (0, $4gz8B.MessageType).Binary) throw new (0, $4Cx0W.InvalidOperationError)("Not supported for binary message");
        return this.privPayload;
    }
    get binaryContent() {
        if (this.privMessageType === (0, $4gz8B.MessageType).Text) throw new (0, $4Cx0W.InvalidOperationError)("Not supported for text message");
        return this.privPayload;
    }
    get id() {
        return this.privId;
    }
}

});

parcelRequire.register("lpx1B", function(module, exports) {

$parcel$export(module.exports, "RiffPcmEncoder", () => $f9658cced81eaa1f$export$f0c1cabbb64251f4);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
class $f9658cced81eaa1f$export$f0c1cabbb64251f4 {
    constructor(actualSampleRate, desiredSampleRate){
        this.encode = (actualAudioFrame)=>{
            const audioFrame = this.downSampleAudioFrame(actualAudioFrame, this.privActualSampleRate, this.privDesiredSampleRate);
            if (!audioFrame) return null;
            const audioLength = audioFrame.length * 2;
            const buffer = new ArrayBuffer(audioLength);
            const view = new DataView(buffer);
            this.floatTo16BitPCM(view, 0, audioFrame);
            return buffer;
        };
        this.setString = (view, offset, str)=>{
            for(let i = 0; i < str.length; i++)view.setUint8(offset + i, str.charCodeAt(i));
        };
        this.floatTo16BitPCM = (view, offset, input)=>{
            for(let i = 0; i < input.length; i++, offset += 2){
                const s = Math.max(-1, Math.min(1, input[i]));
                view.setInt16(offset, s < 0 ? s * 0x8000 : s * 0x7FFF, true);
            }
        };
        this.downSampleAudioFrame = (srcFrame, srcRate, dstRate)=>{
            if (dstRate === srcRate || dstRate > srcRate) return srcFrame;
            const ratio = srcRate / dstRate;
            const dstLength = Math.round(srcFrame.length / ratio);
            const dstFrame = new Float32Array(dstLength);
            let srcOffset = 0;
            let dstOffset = 0;
            while(dstOffset < dstLength){
                const nextSrcOffset = Math.round((dstOffset + 1) * ratio);
                let accum = 0;
                let count = 0;
                while(srcOffset < nextSrcOffset && srcOffset < srcFrame.length){
                    accum += srcFrame[srcOffset++];
                    count++;
                }
                dstFrame[dstOffset++] = accum / count;
            }
            return dstFrame;
        };
        this.privActualSampleRate = actualSampleRate;
        this.privDesiredSampleRate = desiredSampleRate;
    }
}

});

parcelRequire.register("5PiFE", function(module, exports) {

$parcel$export(module.exports, "Stream", () => $43e032d02efa6ed5$export$6a4eb2e7fc9e8903);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.

var $4Cx0W = parcelRequire("4Cx0W");

var $kSC7p = parcelRequire("kSC7p");

var $i8Rdf = parcelRequire("i8Rdf");
var $43e032d02efa6ed5$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
class $43e032d02efa6ed5$export$6a4eb2e7fc9e8903 {
    constructor(streamId){
        this.privIsWriteEnded = false;
        this.privIsReadEnded = false;
        this.read = ()=>{
            if (this.privIsReadEnded) throw new (0, $4Cx0W.InvalidOperationError)("Stream read has already finished");
            return this.privReaderQueue.dequeue().then((streamChunk)=>$43e032d02efa6ed5$var$__awaiter(this, void 0, void 0, function*() {
                    if (streamChunk === undefined || streamChunk.isEnd) yield this.privReaderQueue.dispose("End of stream reached");
                    return streamChunk;
                }));
        };
        this.readEnded = ()=>{
            if (!this.privIsReadEnded) {
                this.privIsReadEnded = true;
                this.privReaderQueue = new (0, $i8Rdf.Queue)();
            }
        };
        this.throwIfClosed = ()=>{
            if (this.privIsWriteEnded) throw new (0, $4Cx0W.InvalidOperationError)("Stream closed");
        };
        this.privId = streamId ? streamId : (0, $kSC7p.createNoDashGuid)();
        this.privReaderQueue = new (0, $i8Rdf.Queue)();
    }
    get isClosed() {
        return this.privIsWriteEnded;
    }
    get isReadEnded() {
        return this.privIsReadEnded;
    }
    get id() {
        return this.privId;
    }
    close() {
        if (!this.privIsWriteEnded) {
            this.writeStreamChunk({
                buffer: null,
                isEnd: true,
                timeReceived: Date.now()
            });
            this.privIsWriteEnded = true;
        }
    }
    writeStreamChunk(streamChunk) {
        this.throwIfClosed();
        if (!this.privReaderQueue.isDisposed()) try {
            this.privReaderQueue.enqueue(streamChunk);
        } catch (e) {
        // Do nothing
        }
    }
}

});

parcelRequire.register("gzURB", function(module, exports) {

$parcel$export(module.exports, "TranslationStatus", () => $c11c06245c022a17$export$96c657d6fc0132e5);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
/**
 * Defines translation status.
 * @class TranslationStatus
 */ var $c11c06245c022a17$export$96c657d6fc0132e5;
(function(TranslationStatus) {
    /**
     * @member TranslationStatus.Success
     */ TranslationStatus[TranslationStatus["Success"] = 0] = "Success";
    /**
     * @member TranslationStatus.Error
     */ TranslationStatus[TranslationStatus["Error"] = 1] = "Error";
})($c11c06245c022a17$export$96c657d6fc0132e5 || ($c11c06245c022a17$export$96c657d6fc0132e5 = {}));

});

parcelRequire.register("18oN3", function(module, exports) {

$parcel$export(module.exports, "ChunkedArrayBufferStream", () => $0d39c498647f51f8$export$8451797d25cb97b2);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
parcelRequire("3KVS5");
var $5PiFE = parcelRequire("5PiFE");
class $0d39c498647f51f8$export$8451797d25cb97b2 extends (0, $5PiFE.Stream) {
    constructor(targetChunkSize, streamId){
        super(streamId);
        this.privTargetChunkSize = targetChunkSize;
        this.privNextBufferReadyBytes = 0;
    }
    writeStreamChunk(chunk) {
        // No pending write, and the buffer is the right size so write it.
        if (chunk.isEnd || 0 === this.privNextBufferReadyBytes && chunk.buffer.byteLength === this.privTargetChunkSize) {
            super.writeStreamChunk(chunk);
            return;
        }
        let bytesCopiedFromBuffer = 0;
        while(bytesCopiedFromBuffer < chunk.buffer.byteLength){
            // Fill the next buffer.
            if (undefined === this.privNextBufferToWrite) {
                this.privNextBufferToWrite = new ArrayBuffer(this.privTargetChunkSize);
                this.privNextBufferStartTime = chunk.timeReceived;
            }
            // Find out how many bytes we can copy into the read buffer.
            const bytesToCopy = Math.min(chunk.buffer.byteLength - bytesCopiedFromBuffer, this.privTargetChunkSize - this.privNextBufferReadyBytes);
            const targetView = new Uint8Array(this.privNextBufferToWrite);
            const sourceView = new Uint8Array(chunk.buffer.slice(bytesCopiedFromBuffer, bytesToCopy + bytesCopiedFromBuffer));
            targetView.set(sourceView, this.privNextBufferReadyBytes);
            this.privNextBufferReadyBytes += bytesToCopy;
            bytesCopiedFromBuffer += bytesToCopy;
            // Are we ready to write?
            if (this.privNextBufferReadyBytes === this.privTargetChunkSize) {
                super.writeStreamChunk({
                    buffer: this.privNextBufferToWrite,
                    isEnd: false,
                    timeReceived: this.privNextBufferStartTime
                });
                this.privNextBufferReadyBytes = 0;
                this.privNextBufferToWrite = undefined;
            }
        }
    }
    close() {
        // Send whatever is pending, then close the base class.
        if (0 !== this.privNextBufferReadyBytes && !this.isClosed) super.writeStreamChunk({
            buffer: this.privNextBufferToWrite.slice(0, this.privNextBufferReadyBytes),
            isEnd: false,
            timeReceived: this.privNextBufferStartTime
        });
        super.close();
    }
}

});

parcelRequire.register("57VkO", function(module, exports) {

$parcel$export(module.exports, "Timeout", () => $3bba14adc0161fc2$export$786b4da70f00938b);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
class $3bba14adc0161fc2$export$786b4da70f00938b {
}
$3bba14adc0161fc2$export$786b4da70f00938b.workerTimers = null;
$3bba14adc0161fc2$export$786b4da70f00938b.clearTimeout = (timerId)=>$3bba14adc0161fc2$export$786b4da70f00938b.timers().clearTimeout(timerId);
$3bba14adc0161fc2$export$786b4da70f00938b.setTimeout = (func, delay)=>$3bba14adc0161fc2$export$786b4da70f00938b.timers().setTimeout(func, delay);
$3bba14adc0161fc2$export$786b4da70f00938b.load = (url)=>{
    // Prefilling the Maps with a function indexed by zero is necessary to be compliant with the specification.
    const scheduledTimeoutFunctions = new Map([
        [
            0,
            ()=>{}
        ]
    ]); // tslint:disable-line no-empty
    const unhandledRequests = new Map();
    const worker = new Worker(url);
    worker.addEventListener("message", ({ data: data })=>{
        if ($3bba14adc0161fc2$export$786b4da70f00938b.isCallNotification(data)) {
            const { params: { timerId: timerId } } = data;
            const idOrFunc = scheduledTimeoutFunctions.get(timerId);
            if (typeof idOrFunc === "number") {
                const unhandledTimerId = unhandledRequests.get(idOrFunc);
                if (unhandledTimerId === undefined || unhandledTimerId !== timerId) throw new Error("The timer is in an undefined state.");
            } else if (typeof idOrFunc !== "undefined") {
                idOrFunc();
                // A timeout can be safely deleted because it is only called once.
                scheduledTimeoutFunctions.delete(timerId);
            } else throw new Error("The timer is in an undefined state.");
        } else if ($3bba14adc0161fc2$export$786b4da70f00938b.isClearResponse(data)) {
            const { id: id } = data;
            const unhandledTimerId = unhandledRequests.get(id);
            if (unhandledTimerId === undefined) throw new Error("The timer is in an undefined state.");
            unhandledRequests.delete(id);
            scheduledTimeoutFunctions.delete(unhandledTimerId);
        } else {
            const { error: { message: message } } = data;
            throw new Error(message);
        }
    });
    const clearTimeout = (timerId)=>{
        const id = Math.random();
        unhandledRequests.set(id, timerId);
        scheduledTimeoutFunctions.set(timerId, id);
        worker.postMessage({
            id: id,
            method: "clear",
            params: {
                timerId: timerId
            }
        });
    };
    const setTimeout = (func, delay)=>{
        const timerId = Math.random();
        scheduledTimeoutFunctions.set(timerId, func);
        worker.postMessage({
            id: null,
            method: "set",
            params: {
                delay: delay,
                now: performance.now(),
                timerId: timerId
            }
        });
        return timerId;
    };
    return {
        clearTimeout: clearTimeout,
        setTimeout: setTimeout
    };
};
$3bba14adc0161fc2$export$786b4da70f00938b.loadWorkerTimers = ()=>{
    const worker = `!function(e){var t={};function n(r){if(t[r])return t[r].exports;var o=t[r]={i:r,l:!1,exports:{}};return e[r].call(o.exports,o,o.exports,n),o.l=!0,o.exports}n.m=e,n.c=t,n.d=function(e,t,r){n.o(e,t)||Object.defineProperty(e,t,{enumerable:!0,get:r})},n.r=function(e){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(e,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(e,"__esModule",{value:!0})},n.t=function(e,t){if(1&t&&(e=n(e)),8&t)return e;if(4&t&&"object"==typeof e&&e&&e.__esModule)return e;var r=Object.create(null);if(n.r(r),Object.defineProperty(r,"default",{enumerable:!0,value:e}),2&t&&"string"!=typeof e)for(var o in e)n.d(r,o,function(t){return e[t]}.bind(null,o));return r},n.n=function(e){var t=e&&e.__esModule?function(){return e.default}:function(){return e};return n.d(t,"a",t),t},n.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},n.p="",n(n.s=14)}([function(e,t,n){"use strict";n.d(t,"a",(function(){return i})),n.d(t,"b",(function(){return u})),n.d(t,"c",(function(){return a})),n.d(t,"d",(function(){return d}));const r=new Map,o=new Map,i=e=>{const t=r.get(e);if(void 0===t)throw new Error('There is no interval scheduled with the given id "'.concat(e,'".'));clearTimeout(t),r.delete(e)},u=e=>{const t=o.get(e);if(void 0===t)throw new Error('There is no timeout scheduled with the given id "'.concat(e,'".'));clearTimeout(t),o.delete(e)},f=(e,t)=>{let n,r;if("performance"in self){const o=performance.now();n=o,r=e-Math.max(0,o-t)}else n=Date.now(),r=e;return{expected:n+r,remainingDelay:r}},c=(e,t,n,r)=>{const o="performance"in self?performance.now():Date.now();o>n?postMessage({id:null,method:"call",params:{timerId:t}}):e.set(t,setTimeout(c,n-o,e,t,n))},a=(e,t,n)=>{const{expected:o,remainingDelay:i}=f(e,n);r.set(t,setTimeout(c,i,r,t,o))},d=(e,t,n)=>{const{expected:r,remainingDelay:i}=f(e,n);o.set(t,setTimeout(c,i,o,t,r))}},function(e,t,n){"use strict";n.r(t);var r=n(2);for(var o in r)"default"!==o&&function(e){n.d(t,e,(function(){return r[e]}))}(o);var i=n(3);for(var o in i)"default"!==o&&function(e){n.d(t,e,(function(){return i[e]}))}(o);var u=n(4);for(var o in u)"default"!==o&&function(e){n.d(t,e,(function(){return u[e]}))}(o);var f=n(5);for(var o in f)"default"!==o&&function(e){n.d(t,e,(function(){return f[e]}))}(o);var c=n(6);for(var o in c)"default"!==o&&function(e){n.d(t,e,(function(){return c[e]}))}(o);var a=n(7);for(var o in a)"default"!==o&&function(e){n.d(t,e,(function(){return a[e]}))}(o);var d=n(8);for(var o in d)"default"!==o&&function(e){n.d(t,e,(function(){return d[e]}))}(o);var s=n(9);for(var o in s)"default"!==o&&function(e){n.d(t,e,(function(){return s[e]}))}(o)},function(e,t){},function(e,t){},function(e,t){},function(e,t){},function(e,t){},function(e,t){},function(e,t){},function(e,t){},function(e,t,n){"use strict";n.r(t);var r=n(11);for(var o in r)"default"!==o&&function(e){n.d(t,e,(function(){return r[e]}))}(o);var i=n(12);for(var o in i)"default"!==o&&function(e){n.d(t,e,(function(){return i[e]}))}(o);var u=n(13);for(var o in u)"default"!==o&&function(e){n.d(t,e,(function(){return u[e]}))}(o)},function(e,t){},function(e,t){},function(e,t){},function(e,t,n){"use strict";n.r(t);var r=n(0),o=n(1);for(var i in o)"default"!==i&&function(e){n.d(t,e,(function(){return o[e]}))}(i);var u=n(10);for(var i in u)"default"!==i&&function(e){n.d(t,e,(function(){return u[e]}))}(i);addEventListener("message",({data:e})=>{try{if("clear"===e.method){const{id:t,params:{timerId:n}}=e;Object(r.b)(n),postMessage({error:null,id:t})}else{if("set"!==e.method)throw new Error('The given method "'.concat(e.method,'" is not supported'));{const{params:{delay:t,now:n,timerId:o}}=e;Object(r.d)(t,o,n)}}}catch(t){postMessage({error:{message:t.message},id:e.id,result:null})}})}]);`; // tslint:disable-line:max-line-length
    return ()=>{
        if ($3bba14adc0161fc2$export$786b4da70f00938b.workerTimers !== null) return $3bba14adc0161fc2$export$786b4da70f00938b.workerTimers;
        const blob = new Blob([
            worker
        ], {
            type: "application/javascript; charset=utf-8"
        });
        const url = URL.createObjectURL(blob);
        $3bba14adc0161fc2$export$786b4da70f00938b.workerTimers = $3bba14adc0161fc2$export$786b4da70f00938b.load(url);
        // Edge doesn't like the URL to be revoked directly.
        $3bba14adc0161fc2$export$786b4da70f00938b.workerTimers.setTimeout(()=>URL.revokeObjectURL(url), 0);
        return $3bba14adc0161fc2$export$786b4da70f00938b.workerTimers;
    };
};
$3bba14adc0161fc2$export$786b4da70f00938b.timers = $3bba14adc0161fc2$export$786b4da70f00938b.loadWorkerTimers();
$3bba14adc0161fc2$export$786b4da70f00938b.isCallNotification = (message)=>{
    return message.method !== undefined && message.method === "call";
};
$3bba14adc0161fc2$export$786b4da70f00938b.isClearResponse = (message)=>{
    return message.error === null && typeof message.id === "number";
};

});

parcelRequire.register("1Uzk5", function(module, exports) {

$parcel$export(module.exports, "OCSPMemoryCacheHitEvent", () => $16466bd30101bd07$export$727bdc6ea2d7d659);
$parcel$export(module.exports, "OCSPCacheMissEvent", () => $16466bd30101bd07$export$c5ac9e1d20d642ad);
$parcel$export(module.exports, "OCSPDiskCacheHitEvent", () => $16466bd30101bd07$export$40ce39df4d331eb2);
$parcel$export(module.exports, "OCSPCacheUpdateNeededEvent", () => $16466bd30101bd07$export$2f3fdf3403152271);
$parcel$export(module.exports, "OCSPMemoryCacheStoreEvent", () => $16466bd30101bd07$export$c04f02d29f272e8f);
$parcel$export(module.exports, "OCSPDiskCacheStoreEvent", () => $16466bd30101bd07$export$c55c23e50c6a1fca);
$parcel$export(module.exports, "OCSPCacheUpdatehCompleteEvent", () => $16466bd30101bd07$export$5c857f4df103c5d0);
$parcel$export(module.exports, "OCSPStapleReceivedEvent", () => $16466bd30101bd07$export$8c5f66440417a919);
$parcel$export(module.exports, "OCSPCacheEntryExpiredEvent", () => $16466bd30101bd07$export$53b5ef0ca5f3448d);
$parcel$export(module.exports, "OCSPCacheEntryNeedsRefreshEvent", () => $16466bd30101bd07$export$3aa1fb234cf84ca7);
$parcel$export(module.exports, "OCSPCacheHitEvent", () => $16466bd30101bd07$export$f871a2a96bab2c9d);
$parcel$export(module.exports, "OCSPVerificationFailedEvent", () => $16466bd30101bd07$export$b6fca22dc0c395d3);
$parcel$export(module.exports, "OCSPCacheFetchErrorEvent", () => $16466bd30101bd07$export$1013fc1d6931ed63);
$parcel$export(module.exports, "OCSPResponseRetrievedEvent", () => $16466bd30101bd07$export$5afea247d5a89aee);
$parcel$export(module.exports, "OCSPCacheUpdateErrorEvent", () => $16466bd30101bd07$export$aad41e3deb48ab65);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
// tslint:disable:max-classes-per-file

var $aAKrf = parcelRequire("aAKrf");
class $16466bd30101bd07$export$d36d9c8f9fc444c5 extends (0, $aAKrf.PlatformEvent) {
    constructor(eventName, eventType, signature){
        super(eventName, eventType);
        this.privSignature = signature;
    }
}
class $16466bd30101bd07$export$727bdc6ea2d7d659 extends $16466bd30101bd07$export$d36d9c8f9fc444c5 {
    constructor(signature){
        super("OCSPMemoryCacheHitEvent", (0, $aAKrf.EventType).Debug, signature);
    }
}
class $16466bd30101bd07$export$c5ac9e1d20d642ad extends $16466bd30101bd07$export$d36d9c8f9fc444c5 {
    constructor(signature){
        super("OCSPCacheMissEvent", (0, $aAKrf.EventType).Debug, signature);
    }
}
class $16466bd30101bd07$export$40ce39df4d331eb2 extends $16466bd30101bd07$export$d36d9c8f9fc444c5 {
    constructor(signature){
        super("OCSPDiskCacheHitEvent", (0, $aAKrf.EventType).Debug, signature);
    }
}
class $16466bd30101bd07$export$2f3fdf3403152271 extends $16466bd30101bd07$export$d36d9c8f9fc444c5 {
    constructor(signature){
        super("OCSPCacheUpdateNeededEvent", (0, $aAKrf.EventType).Debug, signature);
    }
}
class $16466bd30101bd07$export$c04f02d29f272e8f extends $16466bd30101bd07$export$d36d9c8f9fc444c5 {
    constructor(signature){
        super("OCSPMemoryCacheStoreEvent", (0, $aAKrf.EventType).Debug, signature);
    }
}
class $16466bd30101bd07$export$c55c23e50c6a1fca extends $16466bd30101bd07$export$d36d9c8f9fc444c5 {
    constructor(signature){
        super("OCSPDiskCacheStoreEvent", (0, $aAKrf.EventType).Debug, signature);
    }
}
class $16466bd30101bd07$export$5c857f4df103c5d0 extends $16466bd30101bd07$export$d36d9c8f9fc444c5 {
    constructor(signature){
        super("OCSPCacheUpdatehCompleteEvent", (0, $aAKrf.EventType).Debug, signature);
    }
}
class $16466bd30101bd07$export$8c5f66440417a919 extends $16466bd30101bd07$export$d36d9c8f9fc444c5 {
    constructor(){
        super("OCSPStapleReceivedEvent", (0, $aAKrf.EventType).Debug, "");
    }
}
class $16466bd30101bd07$export$95f40dadf7fef9ba extends $16466bd30101bd07$export$d36d9c8f9fc444c5 {
    constructor(serialNumber){
        super("OCSPWSUpgradeStartedEvent", (0, $aAKrf.EventType).Debug, serialNumber);
    }
}
class $16466bd30101bd07$export$53b5ef0ca5f3448d extends $16466bd30101bd07$export$d36d9c8f9fc444c5 {
    constructor(serialNumber, expireTime){
        super("OCSPCacheEntryExpiredEvent", (0, $aAKrf.EventType).Debug, serialNumber);
        this.privExpireTime = expireTime;
    }
}
class $16466bd30101bd07$export$3aa1fb234cf84ca7 extends $16466bd30101bd07$export$d36d9c8f9fc444c5 {
    constructor(serialNumber, startTime, expireTime){
        super("OCSPCacheEntryNeedsRefreshEvent", (0, $aAKrf.EventType).Debug, serialNumber);
        this.privExpireTime = expireTime;
        this.privStartTime = startTime;
    }
}
class $16466bd30101bd07$export$f871a2a96bab2c9d extends $16466bd30101bd07$export$d36d9c8f9fc444c5 {
    constructor(serialNumber, startTime, expireTime){
        super("OCSPCacheHitEvent", (0, $aAKrf.EventType).Debug, serialNumber);
        this.privExpireTime = expireTime;
        this.privExpireTimeString = new Date(expireTime).toLocaleDateString();
        this.privStartTime = startTime;
        this.privStartTimeString = new Date(startTime).toLocaleTimeString();
    }
}
class $16466bd30101bd07$export$b6fca22dc0c395d3 extends $16466bd30101bd07$export$d36d9c8f9fc444c5 {
    constructor(serialNumber, error){
        super("OCSPVerificationFailedEvent", (0, $aAKrf.EventType).Debug, serialNumber);
        this.privError = error;
    }
}
class $16466bd30101bd07$export$1013fc1d6931ed63 extends $16466bd30101bd07$export$d36d9c8f9fc444c5 {
    constructor(serialNumber, error){
        super("OCSPCacheFetchErrorEvent", (0, $aAKrf.EventType).Debug, serialNumber);
        this.privError = error;
    }
}
class $16466bd30101bd07$export$5afea247d5a89aee extends $16466bd30101bd07$export$d36d9c8f9fc444c5 {
    constructor(serialNumber){
        super("OCSPResponseRetrievedEvent", (0, $aAKrf.EventType).Debug, serialNumber);
    }
}
class $16466bd30101bd07$export$aad41e3deb48ab65 extends $16466bd30101bd07$export$d36d9c8f9fc444c5 {
    constructor(serialNumber, error){
        super("OCSPCacheUpdateErrorEvent", (0, $aAKrf.EventType).Debug, serialNumber);
        this.privError = error;
    }
}

});

parcelRequire.register("6p3HD", function(module, exports) {

$parcel$export(module.exports, "BackgroundEvent", () => $4a97f32998fac0bb$export$3e33db5d08e1fac7);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
parcelRequire("3KVS5");
var $aAKrf = parcelRequire("aAKrf");
class $4a97f32998fac0bb$export$3e33db5d08e1fac7 extends (0, $aAKrf.PlatformEvent) {
    constructor(error){
        super("BackgroundEvent", (0, $aAKrf.EventType).Error);
        this.privError = error;
    }
    get error() {
        return this.privError;
    }
}

});



parcelRequire.register("6CzcC", function(module, exports) {

$parcel$export(module.exports, "MicAudioSource", () => $4d219931909b2471$export$401b719c640c9369);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
parcelRequire("g6k3z");
var $iWV5t = parcelRequire("iWV5t");
parcelRequire("3KVS5");
var $9MSEb = parcelRequire("9MSEb");
var $btwY7 = parcelRequire("btwY7");
var $18oN3 = parcelRequire("18oN3");
var $l9cUE = parcelRequire("l9cUE");
var $kSC7p = parcelRequire("kSC7p");
var $76ZQQ = parcelRequire("76ZQQ");

var $bFdRB = parcelRequire("bFdRB");
var $4d219931909b2471$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const $4d219931909b2471$export$a38f7a762545a7e0 = "MICROPHONE-WorkletSourceUrl";
class $4d219931909b2471$export$401b719c640c9369 {
    constructor(privRecorder, deviceId, audioSourceId, mediaStream){
        this.privRecorder = privRecorder;
        this.deviceId = deviceId;
        this.privStreams = {};
        this.turnOn = ()=>{
            if (this.privInitializeDeferral) return this.privInitializeDeferral.promise;
            this.privInitializeDeferral = new (0, $9MSEb.Deferred)();
            try {
                this.createAudioContext();
            } catch (error) {
                if (error instanceof Error) {
                    const typedError = error;
                    this.privInitializeDeferral.reject(typedError.name + ": " + typedError.message);
                } else this.privInitializeDeferral.reject(error);
                return this.privInitializeDeferral.promise;
            }
            const nav = window.navigator;
            let getUserMedia = nav.getUserMedia || nav.webkitGetUserMedia || nav.mozGetUserMedia || nav.msGetUserMedia;
            if (!!nav.mediaDevices) getUserMedia = (constraints, successCallback, errorCallback)=>{
                nav.mediaDevices.getUserMedia(constraints).then(successCallback).catch(errorCallback);
            };
            if (!getUserMedia) {
                const errorMsg = "Browser does not support getUserMedia.";
                this.privInitializeDeferral.reject(errorMsg);
                this.onEvent(new (0, $btwY7.AudioSourceErrorEvent)(errorMsg, "")); // mic initialized error - no streamid at this point
            } else {
                const next = ()=>{
                    this.onEvent(new (0, $btwY7.AudioSourceInitializingEvent)(this.privId)); // no stream id
                    if (this.privMediaStream && this.privMediaStream.active) {
                        this.onEvent(new (0, $btwY7.AudioSourceReadyEvent)(this.privId));
                        this.privInitializeDeferral.resolve();
                    } else getUserMedia({
                        audio: this.deviceId ? {
                            deviceId: this.deviceId
                        } : true,
                        video: false
                    }, (mediaStream)=>{
                        this.privMediaStream = mediaStream;
                        this.onEvent(new (0, $btwY7.AudioSourceReadyEvent)(this.privId));
                        this.privInitializeDeferral.resolve();
                    }, (error)=>{
                        const errorMsg = `Error occurred during microphone initialization: ${error}`;
                        this.privInitializeDeferral.reject(errorMsg);
                        this.onEvent(new (0, $btwY7.AudioSourceErrorEvent)(this.privId, errorMsg));
                    });
                };
                if (this.privContext.state === "suspended") // NOTE: On iOS, the Web Audio API requires sounds to be triggered from an explicit user action.
                // https://github.com/WebAudio/web-audio-api/issues/790
                this.privContext.resume().then(next).catch((reason)=>{
                    this.privInitializeDeferral.reject(`Failed to initialize audio context: ${reason}`);
                });
                else next();
            }
            return this.privInitializeDeferral.promise;
        };
        this.id = ()=>{
            return this.privId;
        };
        this.attach = (audioNodeId)=>{
            this.onEvent(new (0, $btwY7.AudioStreamNodeAttachingEvent)(this.privId, audioNodeId));
            return this.listen(audioNodeId).then((stream)=>{
                this.onEvent(new (0, $btwY7.AudioStreamNodeAttachedEvent)(this.privId, audioNodeId));
                return {
                    detach: ()=>$4d219931909b2471$var$__awaiter(this, void 0, void 0, function*() {
                            stream.readEnded();
                            delete this.privStreams[audioNodeId];
                            this.onEvent(new (0, $btwY7.AudioStreamNodeDetachedEvent)(this.privId, audioNodeId));
                            return this.turnOff();
                        }),
                    id: ()=>{
                        return audioNodeId;
                    },
                    read: ()=>{
                        return stream.read();
                    }
                };
            });
        };
        this.detach = (audioNodeId)=>{
            if (audioNodeId && this.privStreams[audioNodeId]) {
                this.privStreams[audioNodeId].close();
                delete this.privStreams[audioNodeId];
                this.onEvent(new (0, $btwY7.AudioStreamNodeDetachedEvent)(this.privId, audioNodeId));
            }
        };
        this.listen = (audioNodeId)=>$4d219931909b2471$var$__awaiter(this, void 0, void 0, function*() {
                yield this.turnOn();
                const stream = new (0, $18oN3.ChunkedArrayBufferStream)(this.privOutputChunkSize, audioNodeId);
                this.privStreams[audioNodeId] = stream;
                try {
                    this.privRecorder.record(this.privContext, this.privMediaStream, stream);
                } catch (error) {
                    this.onEvent(new (0, $btwY7.AudioStreamNodeErrorEvent)(this.privId, audioNodeId, error));
                    throw error;
                }
                const result = stream;
                return result;
            });
        this.onEvent = (event)=>{
            this.privEvents.onEvent(event);
            (0, $l9cUE.Events).instance.onEvent(event);
        };
        this.createAudioContext = ()=>{
            if (!!this.privContext) return;
            this.privContext = (0, $bFdRB.AudioStreamFormatImpl).getAudioContext($4d219931909b2471$export$401b719c640c9369.AUDIOFORMAT.samplesPerSec);
        };
        this.privOutputChunkSize = $4d219931909b2471$export$401b719c640c9369.AUDIOFORMAT.avgBytesPerSec / 10;
        this.privId = audioSourceId ? audioSourceId : (0, $kSC7p.createNoDashGuid)();
        this.privEvents = new (0, $76ZQQ.EventSource)();
        this.privMediaStream = mediaStream || null;
    }
    get format() {
        return Promise.resolve($4d219931909b2471$export$401b719c640c9369.AUDIOFORMAT);
    }
    get blob() {
        return Promise.reject("Not implemented for Mic input");
    }
    turnOff() {
        return $4d219931909b2471$var$__awaiter(this, void 0, void 0, function*() {
            for(const streamId in this.privStreams)if (streamId) {
                const stream = this.privStreams[streamId];
                if (stream) stream.close();
            }
            this.onEvent(new (0, $btwY7.AudioSourceOffEvent)(this.privId)); // no stream now
            if (this.privInitializeDeferral) {
                // Correctly handle when browser forces mic off before turnOn() completes
                yield this.privInitializeDeferral;
                this.privInitializeDeferral = null;
            }
            yield this.destroyAudioContext();
            return;
        });
    }
    get events() {
        return this.privEvents;
    }
    get deviceInfo() {
        return this.getMicrophoneLabel().then((label)=>{
            return {
                bitspersample: $4d219931909b2471$export$401b719c640c9369.AUDIOFORMAT.bitsPerSample,
                channelcount: $4d219931909b2471$export$401b719c640c9369.AUDIOFORMAT.channels,
                connectivity: (0, $iWV5t.connectivity).Unknown,
                manufacturer: "Speech SDK",
                model: label,
                samplerate: $4d219931909b2471$export$401b719c640c9369.AUDIOFORMAT.samplesPerSec,
                type: (0, $iWV5t.type).Microphones
            };
        });
    }
    setProperty(name, value) {
        if (name === $4d219931909b2471$export$a38f7a762545a7e0) this.privRecorder.setWorkletUrl(value);
        else throw new Error("Property '" + name + "' is not supported on Microphone.");
    }
    getMicrophoneLabel() {
        const defaultMicrophoneName = "microphone";
        // If we did this already, return the value.
        if (this.privMicrophoneLabel !== undefined) return Promise.resolve(this.privMicrophoneLabel);
        // If the stream isn't currently running, we can't query devices because security.
        if (this.privMediaStream === undefined || !this.privMediaStream.active) return Promise.resolve(defaultMicrophoneName);
        // Setup a default
        this.privMicrophoneLabel = defaultMicrophoneName;
        // Get the id of the device running the audio track.
        const microphoneDeviceId = this.privMediaStream.getTracks()[0].getSettings().deviceId;
        // If the browser doesn't support getting the device ID, set a default and return.
        if (undefined === microphoneDeviceId) return Promise.resolve(this.privMicrophoneLabel);
        const deferred = new (0, $9MSEb.Deferred)();
        // Enumerate the media devices.
        navigator.mediaDevices.enumerateDevices().then((devices)=>{
            for (const device of devices)if (device.deviceId === microphoneDeviceId) {
                // Found the device
                this.privMicrophoneLabel = device.label;
                break;
            }
            deferred.resolve(this.privMicrophoneLabel);
        }, ()=>deferred.resolve(this.privMicrophoneLabel));
        return deferred.promise;
    }
    destroyAudioContext() {
        return $4d219931909b2471$var$__awaiter(this, void 0, void 0, function*() {
            if (!this.privContext) return;
            this.privRecorder.releaseMediaResources(this.privContext);
            // This pattern brought to you by a bug in the TypeScript compiler where it
            // confuses the ("close" in this.privContext) with this.privContext always being null as the alternate.
            // https://github.com/Microsoft/TypeScript/issues/11498
            let hasClose = false;
            if ("close" in this.privContext) hasClose = true;
            if (hasClose) {
                yield this.privContext.close();
                this.privContext = null;
            } else if (null !== this.privContext && this.privContext.state === "running") // Suspend actually takes a callback, but analogous to the
            // resume method, it'll be only fired if suspend is called
            // in a direct response to a user action. The later is not always
            // the case, as TurnOff is also called, when we receive an
            // end-of-speech message from the service. So, doing a best effort
            // fire-and-forget here.
            yield this.privContext.suspend();
        });
    }
}
$4d219931909b2471$export$401b719c640c9369.AUDIOFORMAT = (0, $bFdRB.AudioStreamFormat).getDefaultInputFormat();

});
parcelRequire.register("g6k3z", function(module, exports) {
$parcel$export(module.exports, "CognitiveSubscriptionKeyAuthentication", () => (parcelRequire("a3Tmp")).CognitiveSubscriptionKeyAuthentication);
$parcel$export(module.exports, "CognitiveTokenAuthentication", () => (parcelRequire("2nHY6")).CognitiveTokenAuthentication);
$parcel$export(module.exports, "connectivity", () => (parcelRequire("iWV5t")).connectivity);
$parcel$export(module.exports, "Context", () => (parcelRequire("iWV5t")).Context);
$parcel$export(module.exports, "OS", () => (parcelRequire("iWV5t")).OS);
$parcel$export(module.exports, "RecognitionMode", () => (parcelRequire("iWV5t")).RecognitionMode);
$parcel$export(module.exports, "RecognizerConfig", () => (parcelRequire("iWV5t")).RecognizerConfig);
$parcel$export(module.exports, "SpeechServiceConfig", () => (parcelRequire("iWV5t")).SpeechServiceConfig);
$parcel$export(module.exports, "type", () => (parcelRequire("iWV5t")).type);
$parcel$export(module.exports, "WebsocketMessageFormatter", () => (parcelRequire("dLS1h")).WebsocketMessageFormatter);
$parcel$export(module.exports, "EnumTranslation", () => (parcelRequire("28Rmc")).EnumTranslation);
$parcel$export(module.exports, "RecognitionStatus", () => (parcelRequire("15fen")).RecognitionStatus);
$parcel$export(module.exports, "SynthesisStatus", () => (parcelRequire("15fen")).SynthesisStatus);
$parcel$export(module.exports, "TranslationSynthesisEnd", () => (parcelRequire("kGC9p")).TranslationSynthesisEnd);
$parcel$export(module.exports, "TranslationHypothesis", () => (parcelRequire("9g1Bf")).TranslationHypothesis);
$parcel$export(module.exports, "TranslationPhrase", () => (parcelRequire("3bITd")).TranslationPhrase);
$parcel$export(module.exports, "SpeechDetected", () => (parcelRequire("iYdLz")).SpeechDetected);
$parcel$export(module.exports, "SpeechHypothesis", () => (parcelRequire("QS7Xa")).SpeechHypothesis);
$parcel$export(module.exports, "SpeechKeyword", () => (parcelRequire("b1X1y")).SpeechKeyword);
$parcel$export(module.exports, "DetailedSpeechPhrase", () => (parcelRequire("2FaWH")).DetailedSpeechPhrase);
$parcel$export(module.exports, "SimpleSpeechPhrase", () => (parcelRequire("9HHlE")).SimpleSpeechPhrase);
$parcel$export(module.exports, "IntentResponse", () => (parcelRequire("hQuYb")).IntentResponse);
$parcel$export(module.exports, "SpeechContext", () => (parcelRequire("f6F4R")).SpeechContext);
$parcel$export(module.exports, "DynamicGrammarBuilder", () => (parcelRequire("fT1hb")).DynamicGrammarBuilder);
$parcel$export(module.exports, "AgentConfig", () => (parcelRequire("jzrBu")).AgentConfig);
$parcel$export(module.exports, "MetadataType", () => (parcelRequire("8gNBb")).MetadataType);
$parcel$export(module.exports, "SynthesisAudioMetadata", () => (parcelRequire("8gNBb")).SynthesisAudioMetadata);
$parcel$export(module.exports, "SynthesisContext", () => (parcelRequire("iTkn8")).SynthesisContext);

$parcel$export(module.exports, "OutputFormatPropertyName", () => $bb8cc3b7acab3e42$export$ad4e0600dd11837f);
$parcel$export(module.exports, "CancellationErrorCodePropertyName", () => $bb8cc3b7acab3e42$export$cbbf1d2efc001695);
$parcel$export(module.exports, "ServicePropertiesPropertyName", () => $bb8cc3b7acab3e42$export$84df797b3b5f7f6c);
$parcel$export(module.exports, "ForceDictationPropertyName", () => $bb8cc3b7acab3e42$export$9fd1049e23088e5e);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
// Make sure not to export internal modules.
//
parcelRequire("a3Tmp");
parcelRequire("2nHY6");






var $ldYFi = parcelRequire("ldYFi");
parcelRequire("iWV5t");

parcelRequire("dLS1h");




parcelRequire("28Rmc");
parcelRequire("15fen");
parcelRequire("kGC9p");
parcelRequire("9g1Bf");
parcelRequire("3bITd");

var $3xfJT = parcelRequire("3xfJT");
parcelRequire("iYdLz");
parcelRequire("QS7Xa");
parcelRequire("b1X1y");

var $o6HDO = parcelRequire("o6HDO");

var $55gfL = parcelRequire("55gfL");
parcelRequire("2FaWH");
parcelRequire("9HHlE");


var $fZUgp = parcelRequire("fZUgp");
parcelRequire("hQuYb");

var $8nrH1 = parcelRequire("8nrH1");
parcelRequire("f6F4R");
parcelRequire("fT1hb");


var $hRiKl = parcelRequire("hRiKl");
parcelRequire("jzrBu");

parcelRequire("8gNBb");

var $fDfnQ = parcelRequire("fDfnQ");

var $5e6W5 = parcelRequire("5e6W5");

parcelRequire("iTkn8");


var $2DVKD = parcelRequire("2DVKD");
const $bb8cc3b7acab3e42$export$ad4e0600dd11837f = "OutputFormat";
const $bb8cc3b7acab3e42$export$cbbf1d2efc001695 = "CancellationErrorCode";
const $bb8cc3b7acab3e42$export$84df797b3b5f7f6c = "ServiceProperties";
const $bb8cc3b7acab3e42$export$9fd1049e23088e5e = "ForceDictation";
const $bb8cc3b7acab3e42$export$dfb31ff7bb3a5cb4 = "OpenRange";
$parcel$exportWildcard(module.exports, $ldYFi);
$parcel$exportWildcard(module.exports, $3xfJT);
$parcel$exportWildcard(module.exports, $o6HDO);
$parcel$exportWildcard(module.exports, $55gfL);
$parcel$exportWildcard(module.exports, $fZUgp);
$parcel$exportWildcard(module.exports, $8nrH1);
$parcel$exportWildcard(module.exports, $hRiKl);
$parcel$exportWildcard(module.exports, $fDfnQ);
$parcel$exportWildcard(module.exports, $5e6W5);
$parcel$exportWildcard(module.exports, $2DVKD);

});
parcelRequire.register("a3Tmp", function(module, exports) {

$parcel$export(module.exports, "CognitiveSubscriptionKeyAuthentication", () => $7535209c0547232d$export$953fe81aaa517010);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
parcelRequire("3KVS5");
var $4Cx0W = parcelRequire("4Cx0W");

var $2V1Xw = parcelRequire("2V1Xw");

var $kvtEs = parcelRequire("kvtEs");
class $7535209c0547232d$export$953fe81aaa517010 {
    /**
     * Creates and initializes an instance of the CognitiveSubscriptionKeyAuthentication class.
     * @constructor
     * @param {string} subscriptionKey - The subscription key
     */ constructor(subscriptionKey){
        /**
         * Fetches the subscription key.
         * @member
         * @function
         * @public
         * @param {string} authFetchEventId - The id to fetch.
         */ this.fetch = (authFetchEventId)=>{
            return Promise.resolve(this.privAuthInfo);
        };
        /**
         * Fetches the subscription key.
         * @member
         * @function
         * @public
         * @param {string} authFetchEventId - The id to fetch.
         */ this.fetchOnExpiry = (authFetchEventId)=>{
            return Promise.resolve(this.privAuthInfo);
        };
        if (!subscriptionKey) throw new (0, $4Cx0W.ArgumentNullError)("subscriptionKey");
        this.privAuthInfo = new (0, $kvtEs.AuthInfo)((0, $2V1Xw.HeaderNames).AuthKey, subscriptionKey);
    }
}

});
parcelRequire.register("2V1Xw", function(module, exports) {

$parcel$export(module.exports, "HeaderNames", () => $22026cb062102f69$export$28d77f87efed1d88);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
class $22026cb062102f69$export$28d77f87efed1d88 {
}
$22026cb062102f69$export$28d77f87efed1d88.AuthKey = "Ocp-Apim-Subscription-Key";
$22026cb062102f69$export$28d77f87efed1d88.ConnectionId = "X-ConnectionId";
$22026cb062102f69$export$28d77f87efed1d88.ContentType = "Content-Type";
$22026cb062102f69$export$28d77f87efed1d88.CustomCommandsAppId = "X-CommandsAppId";
$22026cb062102f69$export$28d77f87efed1d88.Path = "Path";
$22026cb062102f69$export$28d77f87efed1d88.RequestId = "X-RequestId";
$22026cb062102f69$export$28d77f87efed1d88.RequestStreamId = "X-StreamId";
$22026cb062102f69$export$28d77f87efed1d88.RequestTimestamp = "X-Timestamp";

});

parcelRequire.register("kvtEs", function(module, exports) {

$parcel$export(module.exports, "AuthInfo", () => $eeddb4121df975d9$export$12e76865728ad4c1);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
class $eeddb4121df975d9$export$12e76865728ad4c1 {
    constructor(headerName, token){
        this.privHeaderName = headerName;
        this.privToken = token;
    }
    get headerName() {
        return this.privHeaderName;
    }
    get token() {
        return this.privToken;
    }
}

});


parcelRequire.register("2nHY6", function(module, exports) {

$parcel$export(module.exports, "CognitiveTokenAuthentication", () => $1bbfd5efb5920327$export$d54ea9b3174205e1);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
parcelRequire("3KVS5");
var $4Cx0W = parcelRequire("4Cx0W");

var $kvtEs = parcelRequire("kvtEs");
const $1bbfd5efb5920327$var$AuthHeader = "Authorization";
class $1bbfd5efb5920327$export$d54ea9b3174205e1 {
    constructor(fetchCallback, fetchOnExpiryCallback){
        this.fetch = (authFetchEventId)=>{
            return this.privFetchCallback(authFetchEventId).then((token)=>new (0, $kvtEs.AuthInfo)($1bbfd5efb5920327$var$AuthHeader, token));
        };
        this.fetchOnExpiry = (authFetchEventId)=>{
            return this.privFetchOnExpiryCallback(authFetchEventId).then((token)=>new (0, $kvtEs.AuthInfo)($1bbfd5efb5920327$var$AuthHeader, token));
        };
        if (!fetchCallback) throw new (0, $4Cx0W.ArgumentNullError)("fetchCallback");
        if (!fetchOnExpiryCallback) throw new (0, $4Cx0W.ArgumentNullError)("fetchOnExpiryCallback");
        this.privFetchCallback = fetchCallback;
        this.privFetchOnExpiryCallback = fetchOnExpiryCallback;
    }
}

});

parcelRequire.register("ldYFi", function(module, exports) {

$parcel$export(module.exports, "ServiceRecognizerBase", () => $f739deac85bf8223$export$984734d84ac7a9a1);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
parcelRequire("if2Nv");
var $cGmX2 = parcelRequire("cGmX2");
parcelRequire("3KVS5");
var $4gz8B = parcelRequire("4gz8B");
var $4Cx0W = parcelRequire("4Cx0W");
var $76ZQQ = parcelRequire("76ZQQ");
var $57VkO = parcelRequire("57VkO");
var $l8CKy = parcelRequire("l8CKy");
var $8wq1O = parcelRequire("8wq1O");
var $kSC7p = parcelRequire("kSC7p");

var $8g0TV = parcelRequire("8g0TV");
var $GCsZL = parcelRequire("GCsZL");
var $jJjdG = parcelRequire("jJjdG");
var $lst3T = parcelRequire("lst3T");
var $9Pi8Y = parcelRequire("9Pi8Y");
parcelRequire("g6k3z");
var $8nrH1 = parcelRequire("8nrH1");
var $fT1hb = parcelRequire("fT1hb");
var $f6F4R = parcelRequire("f6F4R");
var $jzrBu = parcelRequire("jzrBu");
var $iWV5t = parcelRequire("iWV5t");
var $iYdLz = parcelRequire("iYdLz");

var $MRQbb = parcelRequire("MRQbb");
var $f739deac85bf8223$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
class $f739deac85bf8223$export$984734d84ac7a9a1 {
    constructor(authentication, connectionFactory, audioSource, recognizerConfig, recognizer){
        this.privSetTimeout = setTimeout;
        this.privIsLiveAudio = false;
        this.recognizeOverride = undefined;
        this.disconnectOverride = undefined;
        this.receiveMessageOverride = undefined;
        this.sendSpeechContext = (connection)=>{
            const speechContextJson = this.speechContext.toJSON();
            if (speechContextJson) return connection.send(new (0, $MRQbb.SpeechConnectionMessage)((0, $4gz8B.MessageType).Text, "speech.context", this.privRequestSession.requestId, "application/json", speechContextJson));
            return;
        };
        this.sendPrePayloadJSONOverride = undefined;
        this.postConnectImplOverride = undefined;
        this.configConnectionOverride = undefined;
        this.sendSpeechServiceConfig = (connection, requestSession, SpeechServiceConfigJson)=>{
            // filter out anything that is not required for the service to work.
            if ($f739deac85bf8223$export$984734d84ac7a9a1.telemetryDataEnabled !== true) {
                const withTelemetry = JSON.parse(SpeechServiceConfigJson);
                const replacement = {
                    context: {
                        system: withTelemetry.context.system
                    }
                };
                SpeechServiceConfigJson = JSON.stringify(replacement);
            }
            if (this.privRecognizerConfig.parameters.getProperty("TranscriptionService_SingleChannel", "false").toLowerCase() === "true") {
                const json = JSON.parse(SpeechServiceConfigJson);
                json.context.DisableReferenceChannel = "True";
                json.context.MicSpec = "1_0_0";
                SpeechServiceConfigJson = JSON.stringify(json);
            }
            if (SpeechServiceConfigJson) return connection.send(new (0, $MRQbb.SpeechConnectionMessage)((0, $4gz8B.MessageType).Text, "speech.config", requestSession.requestId, "application/json", SpeechServiceConfigJson));
            return;
        };
        if (!authentication) throw new (0, $4Cx0W.ArgumentNullError)("authentication");
        if (!connectionFactory) throw new (0, $4Cx0W.ArgumentNullError)("connectionFactory");
        if (!audioSource) throw new (0, $4Cx0W.ArgumentNullError)("audioSource");
        if (!recognizerConfig) throw new (0, $4Cx0W.ArgumentNullError)("recognizerConfig");
        this.privMustReportEndOfStream = false;
        this.privAuthentication = authentication;
        this.privConnectionFactory = connectionFactory;
        this.privAudioSource = audioSource;
        this.privRecognizerConfig = recognizerConfig;
        this.privIsDisposed = false;
        this.privRecognizer = recognizer;
        this.privRequestSession = new (0, $8nrH1.RequestSession)(this.privAudioSource.id());
        this.privConnectionEvents = new (0, $76ZQQ.EventSource)();
        this.privServiceEvents = new (0, $76ZQQ.EventSource)();
        this.privDynamicGrammar = new (0, $fT1hb.DynamicGrammarBuilder)();
        this.privSpeechContext = new (0, $f6F4R.SpeechContext)(this.privDynamicGrammar);
        this.privAgentConfig = new (0, $jzrBu.AgentConfig)();
        if (typeof Blob !== "undefined" && typeof Worker !== "undefined") this.privSetTimeout = (0, $57VkO.Timeout).setTimeout;
        this.connectionEvents.attach((connectionEvent)=>$f739deac85bf8223$var$__awaiter(this, void 0, void 0, function*() {
                if (connectionEvent.name === "ConnectionClosedEvent") {
                    const connectionClosedEvent = connectionEvent;
                    if (connectionClosedEvent.statusCode === 1003 || connectionClosedEvent.statusCode === 1007 || connectionClosedEvent.statusCode === 1002 || connectionClosedEvent.statusCode === 4000 || this.privRequestSession.numConnectionAttempts > this.privRecognizerConfig.maxRetryCount) yield this.cancelRecognitionLocal((0, $GCsZL.CancellationReason).Error, connectionClosedEvent.statusCode === 1007 ? (0, $8g0TV.CancellationErrorCode).BadRequestParameters : (0, $8g0TV.CancellationErrorCode).ConnectionFailure, connectionClosedEvent.reason + " websocket error code: " + connectionClosedEvent.statusCode);
                }
            }));
    }
    get audioSource() {
        return this.privAudioSource;
    }
    get speechContext() {
        return this.privSpeechContext;
    }
    get dynamicGrammar() {
        return this.privDynamicGrammar;
    }
    get agentConfig() {
        return this.privAgentConfig;
    }
    set conversationTranslatorToken(token) {
        this.privRecognizerConfig.parameters.setProperty((0, $jJjdG.PropertyId).ConversationTranslator_Token, token);
    }
    set authentication(auth) {
        this.privAuthentication = this.authentication;
    }
    isDisposed() {
        return this.privIsDisposed;
    }
    dispose(reason) {
        return $f739deac85bf8223$var$__awaiter(this, void 0, void 0, function*() {
            this.privIsDisposed = true;
            if (this.privConnectionConfigurationPromise) try {
                const connection = yield this.privConnectionConfigurationPromise;
                yield connection.dispose(reason);
            } catch (error) {
                // The connection is in a bad state. But we're trying to kill it, so...
                return;
            }
        });
    }
    get connectionEvents() {
        return this.privConnectionEvents;
    }
    get serviceEvents() {
        return this.privServiceEvents;
    }
    get recognitionMode() {
        return this.privRecognizerConfig.recognitionMode;
    }
    recognize(recoMode, successCallback, errorCallBack) {
        return $f739deac85bf8223$var$__awaiter(this, void 0, void 0, function*() {
            if (this.recognizeOverride !== undefined) return this.recognizeOverride(recoMode, successCallback, errorCallBack);
            // Clear the existing configuration promise to force a re-transmission of config and context.
            this.privConnectionConfigurationPromise = null;
            this.privRecognizerConfig.recognitionMode = recoMode;
            this.privSuccessCallback = successCallback;
            this.privErrorCallback = errorCallBack;
            this.privRequestSession.startNewRecognition();
            this.privRequestSession.listenForServiceTelemetry(this.privAudioSource.events);
            // Start the connection to the service. The promise this will create is stored and will be used by configureConnection().
            const conPromise = this.connectImpl();
            let audioNode;
            try {
                const audioStreamNode = yield this.audioSource.attach(this.privRequestSession.audioNodeId);
                const format = yield this.audioSource.format;
                const deviceInfo = yield this.audioSource.deviceInfo;
                this.privIsLiveAudio = deviceInfo.type && deviceInfo.type === (0, $iWV5t.type).Microphones;
                audioNode = new (0, $cGmX2.ReplayableAudioNode)(audioStreamNode, format.avgBytesPerSec);
                yield this.privRequestSession.onAudioSourceAttachCompleted(audioNode, false);
                this.privRecognizerConfig.SpeechServiceConfig.Context.audio = {
                    source: deviceInfo
                };
            } catch (error) {
                yield this.privRequestSession.onStopRecognizing();
                throw error;
            }
            try {
                yield conPromise;
            } catch (error) {
                yield this.cancelRecognitionLocal((0, $GCsZL.CancellationReason).Error, (0, $8g0TV.CancellationErrorCode).ConnectionFailure, error);
                return;
            }
            const sessionStartEventArgs = new (0, $9Pi8Y.SessionEventArgs)(this.privRequestSession.sessionId);
            if (!!this.privRecognizer.sessionStarted) this.privRecognizer.sessionStarted(this.privRecognizer, sessionStartEventArgs);
            const messageRetrievalPromise = this.receiveMessage();
            const audioSendPromise = this.sendAudio(audioNode);
            audioSendPromise.catch((error)=>$f739deac85bf8223$var$__awaiter(this, void 0, void 0, function*() {
                    yield this.cancelRecognitionLocal((0, $GCsZL.CancellationReason).Error, (0, $8g0TV.CancellationErrorCode).RuntimeError, error);
                }));
            return;
        });
    }
    stopRecognizing() {
        return $f739deac85bf8223$var$__awaiter(this, void 0, void 0, function*() {
            if (this.privRequestSession.isRecognizing) try {
                yield this.audioSource.turnOff();
                yield this.sendFinalAudio();
                yield this.privRequestSession.onStopRecognizing();
                yield this.privRequestSession.turnCompletionPromise;
            } finally{
                yield this.privRequestSession.dispose();
            }
            return;
        });
    }
    connect() {
        return $f739deac85bf8223$var$__awaiter(this, void 0, void 0, function*() {
            yield this.connectImpl();
            return Promise.resolve();
        });
    }
    connectAsync(cb, err) {
        this.connectImpl().then((connection)=>{
            try {
                if (!!cb) cb();
            } catch (e) {
                if (!!err) err(e);
            }
        }, (reason)=>{
            try {
                if (!!err) err(reason);
            /* tslint:disable:no-empty */ } catch (error) {}
        });
    }
    disconnect() {
        return $f739deac85bf8223$var$__awaiter(this, void 0, void 0, function*() {
            yield this.cancelRecognitionLocal((0, $GCsZL.CancellationReason).Error, (0, $8g0TV.CancellationErrorCode).NoError, "Disconnecting");
            if (this.disconnectOverride !== undefined) yield this.disconnectOverride();
            try {
                yield (yield this.privConnectionPromise).dispose();
            } catch (error) {}
            this.privConnectionPromise = null;
        });
    }
    sendMessage(message) {}
    sendNetworkMessage(path, payload) {
        return $f739deac85bf8223$var$__awaiter(this, void 0, void 0, function*() {
            const type = typeof payload === "string" ? (0, $4gz8B.MessageType).Text : (0, $4gz8B.MessageType).Binary;
            const contentType = typeof payload === "string" ? "application/json" : "";
            const connection = yield this.fetchConnection();
            return connection.send(new (0, $MRQbb.SpeechConnectionMessage)(type, path, this.privRequestSession.requestId, contentType, payload));
        });
    }
    set activityTemplate(messagePayload) {
        this.privActivityTemplate = messagePayload;
    }
    get activityTemplate() {
        return this.privActivityTemplate;
    }
    sendTelemetryData() {
        return $f739deac85bf8223$var$__awaiter(this, void 0, void 0, function*() {
            const telemetryData = this.privRequestSession.getTelemetry();
            if ($f739deac85bf8223$export$984734d84ac7a9a1.telemetryDataEnabled !== true || this.privIsDisposed || null === telemetryData) return;
            if (!!$f739deac85bf8223$export$984734d84ac7a9a1.telemetryData) try {
                $f739deac85bf8223$export$984734d84ac7a9a1.telemetryData(telemetryData);
            /* tslint:disable:no-empty */ } catch (_a) {}
            const connection = yield this.fetchConnection();
            yield connection.send(new (0, $MRQbb.SpeechConnectionMessage)((0, $4gz8B.MessageType).Text, "telemetry", this.privRequestSession.requestId, "application/json", telemetryData));
        });
    }
    // Cancels recognition.
    cancelRecognitionLocal(cancellationReason, errorCode, error) {
        return $f739deac85bf8223$var$__awaiter(this, void 0, void 0, function*() {
            if (!!this.privRequestSession.isRecognizing) {
                yield this.privRequestSession.onStopRecognizing();
                this.cancelRecognition(this.privRequestSession.sessionId, this.privRequestSession.requestId, cancellationReason, errorCode, error);
            }
        });
    }
    receiveMessage() {
        return $f739deac85bf8223$var$__awaiter(this, void 0, void 0, function*() {
            try {
                if (this.privIsDisposed) // We're done.
                return;
                let connection = yield this.fetchConnection();
                const message = yield connection.read();
                if (this.receiveMessageOverride !== undefined) return this.receiveMessageOverride();
                // indicates we are draining the queue and it came with no message;
                if (!message) {
                    if (!this.privRequestSession.isRecognizing) return;
                    else return this.receiveMessage();
                }
                this.privServiceHasSentMessage = true;
                const connectionMessage = (0, $MRQbb.SpeechConnectionMessage).fromConnectionMessage(message);
                if (connectionMessage.requestId.toLowerCase() === this.privRequestSession.requestId.toLowerCase()) switch(connectionMessage.path.toLowerCase()){
                    case "turn.start":
                        this.privMustReportEndOfStream = true;
                        this.privRequestSession.onServiceTurnStartResponse();
                        break;
                    case "speech.startdetected":
                        const speechStartDetected = (0, $iYdLz.SpeechDetected).fromJSON(connectionMessage.textBody);
                        const speechStartEventArgs = new (0, $lst3T.RecognitionEventArgs)(speechStartDetected.Offset, this.privRequestSession.sessionId);
                        if (!!this.privRecognizer.speechStartDetected) this.privRecognizer.speechStartDetected(this.privRecognizer, speechStartEventArgs);
                        break;
                    case "speech.enddetected":
                        let json;
                        if (connectionMessage.textBody.length > 0) json = connectionMessage.textBody;
                        else // If the request was empty, the JSON returned is empty.
                        json = "{ Offset: 0 }";
                        const speechStopDetected = (0, $iYdLz.SpeechDetected).fromJSON(json);
                        // Only shrink the buffers for continuous recognition.
                        // For single shot, the speech.phrase message will come after the speech.end and it should own buffer shrink.
                        if (this.privRecognizerConfig.isContinuousRecognition) this.privRequestSession.onServiceRecognized(speechStopDetected.Offset + this.privRequestSession.currentTurnAudioOffset);
                        const speechStopEventArgs = new (0, $lst3T.RecognitionEventArgs)(speechStopDetected.Offset + this.privRequestSession.currentTurnAudioOffset, this.privRequestSession.sessionId);
                        if (!!this.privRecognizer.speechEndDetected) this.privRecognizer.speechEndDetected(this.privRecognizer, speechStopEventArgs);
                        break;
                    case "turn.end":
                        yield this.sendTelemetryData();
                        if (this.privRequestSession.isSpeechEnded && this.privMustReportEndOfStream) {
                            this.privMustReportEndOfStream = false;
                            yield this.cancelRecognitionLocal((0, $GCsZL.CancellationReason).EndOfStream, (0, $8g0TV.CancellationErrorCode).NoError, undefined);
                        }
                        const sessionStopEventArgs = new (0, $9Pi8Y.SessionEventArgs)(this.privRequestSession.sessionId);
                        yield this.privRequestSession.onServiceTurnEndResponse(this.privRecognizerConfig.isContinuousRecognition);
                        if (!this.privRecognizerConfig.isContinuousRecognition || this.privRequestSession.isSpeechEnded || !this.privRequestSession.isRecognizing) {
                            if (!!this.privRecognizer.sessionStopped) this.privRecognizer.sessionStopped(this.privRecognizer, sessionStopEventArgs);
                            return;
                        } else {
                            connection = yield this.fetchConnection();
                            yield this.sendPrePayloadJSON(connection);
                        }
                        break;
                    default:
                        if (!(yield this.processTypeSpecificMessages(connectionMessage))) // here are some messages that the derived class has not processed, dispatch them to connect class
                        {
                            if (!!this.privServiceEvents) this.serviceEvents.onEvent(new (0, $l8CKy.ServiceEvent)(connectionMessage.path.toLowerCase(), connectionMessage.textBody));
                        }
                }
                return this.receiveMessage();
            } catch (error) {
                return null;
            }
        });
    }
    // Encapsulated for derived service recognizers that need to send additional JSON
    sendPrePayloadJSON(connection) {
        return $f739deac85bf8223$var$__awaiter(this, void 0, void 0, function*() {
            if (this.sendPrePayloadJSONOverride !== undefined) return this.sendPrePayloadJSONOverride(connection);
            yield this.sendSpeechContext(connection);
            yield this.sendWaveHeader(connection);
            return;
        });
    }
    sendWaveHeader(connection) {
        return $f739deac85bf8223$var$__awaiter(this, void 0, void 0, function*() {
            const format = yield this.audioSource.format;
            // this.writeBufferToConsole(format.header);
            return connection.send(new (0, $MRQbb.SpeechConnectionMessage)((0, $4gz8B.MessageType).Binary, "audio", this.privRequestSession.requestId, "audio/x-wav", format.header));
        });
    }
    // Establishes a websocket connection to the end point.
    connectImpl() {
        if (this.privConnectionPromise) return this.privConnectionPromise.then((connection)=>{
            if (connection.state() === (0, $8wq1O.ConnectionState).Disconnected) {
                this.privConnectionId = null;
                this.privConnectionPromise = null;
                this.privServiceHasSentMessage = false;
                return this.connectImpl();
            }
            return this.privConnectionPromise;
        }, (error)=>{
            this.privConnectionId = null;
            this.privConnectionPromise = null;
            this.privServiceHasSentMessage = false;
            return this.connectImpl();
        });
        this.privConnectionPromise = this.retryableConnect();
        // Attach an empty handler to allow the promise to run in the background while
        // other startup events happen. It'll eventually be awaited on.
        this.privConnectionPromise.catch(()=>{});
        if (this.postConnectImplOverride !== undefined) return this.postConnectImplOverride(this.privConnectionPromise);
        return this.privConnectionPromise;
    }
    fetchConnection() {
        return $f739deac85bf8223$var$__awaiter(this, void 0, void 0, function*() {
            if (this.privConnectionConfigurationPromise) return this.privConnectionConfigurationPromise.then((connection)=>{
                if (connection.state() === (0, $8wq1O.ConnectionState).Disconnected) {
                    this.privConnectionId = null;
                    this.privConnectionConfigurationPromise = null;
                    this.privServiceHasSentMessage = false;
                    return this.fetchConnection();
                }
                return this.privConnectionConfigurationPromise;
            }, (error)=>{
                this.privConnectionId = null;
                this.privConnectionConfigurationPromise = null;
                this.privServiceHasSentMessage = false;
                return this.fetchConnection();
            });
            this.privConnectionConfigurationPromise = this.configureConnection();
            return yield this.privConnectionConfigurationPromise;
        });
    }
    sendAudio(audioStreamNode) {
        return $f739deac85bf8223$var$__awaiter(this, void 0, void 0, function*() {
            const audioFormat = yield this.audioSource.format;
            // The time we last sent data to the service.
            let nextSendTime = Date.now();
            // Max amount to send before we start to throttle
            const fastLaneSizeMs = this.privRecognizerConfig.parameters.getProperty("SPEECH-TransmitLengthBeforThrottleMs", "5000");
            const maxSendUnthrottledBytes = audioFormat.avgBytesPerSec / 1000 * parseInt(fastLaneSizeMs, 10);
            const startRecogNumber = this.privRequestSession.recogNumber;
            const readAndUploadCycle = ()=>$f739deac85bf8223$var$__awaiter(this, void 0, void 0, function*() {
                    // If speech is done, stop sending audio.
                    if (!this.privIsDisposed && !this.privRequestSession.isSpeechEnded && this.privRequestSession.isRecognizing && this.privRequestSession.recogNumber === startRecogNumber) {
                        const connection = yield this.fetchConnection();
                        const audioStreamChunk = yield audioStreamNode.read();
                        // we have a new audio chunk to upload.
                        if (this.privRequestSession.isSpeechEnded) // If service already recognized audio end then don't send any more audio
                        return;
                        let payload;
                        let sendDelay;
                        if (!audioStreamChunk || audioStreamChunk.isEnd) {
                            payload = null;
                            sendDelay = 0;
                        } else {
                            payload = audioStreamChunk.buffer;
                            this.privRequestSession.onAudioSent(payload.byteLength);
                            if (maxSendUnthrottledBytes >= this.privRequestSession.bytesSent) sendDelay = 0;
                            else sendDelay = Math.max(0, nextSendTime - Date.now());
                        }
                        if (0 !== sendDelay) yield this.delay(sendDelay);
                        if (payload !== null) nextSendTime = Date.now() + payload.byteLength * 1000 / (audioFormat.avgBytesPerSec * 2);
                        // Are we still alive?
                        if (!this.privIsDisposed && !this.privRequestSession.isSpeechEnded && this.privRequestSession.isRecognizing && this.privRequestSession.recogNumber === startRecogNumber) {
                            connection.send(new (0, $MRQbb.SpeechConnectionMessage)((0, $4gz8B.MessageType).Binary, "audio", this.privRequestSession.requestId, null, payload)).catch(()=>{
                                this.privRequestSession.onServiceTurnEndResponse(this.privRecognizerConfig.isContinuousRecognition).catch(()=>{});
                            });
                            if (!(audioStreamChunk === null || audioStreamChunk === void 0 ? void 0 : audioStreamChunk.isEnd)) // this.writeBufferToConsole(payload);
                            // Regardless of success or failure, schedule the next upload.
                            // If the underlying connection was broken, the next cycle will
                            // get a new connection and re-transmit missing audio automatically.
                            return readAndUploadCycle();
                            else // the audio stream has been closed, no need to schedule next
                            // read-upload cycle.
                            if (!this.privIsLiveAudio) this.privRequestSession.onSpeechEnded();
                        }
                    }
                });
            return readAndUploadCycle();
        });
    }
    retryableConnect() {
        return $f739deac85bf8223$var$__awaiter(this, void 0, void 0, function*() {
            let isUnAuthorized = false;
            this.privAuthFetchEventId = (0, $kSC7p.createNoDashGuid)();
            const sessionId = this.privRequestSession.sessionId;
            this.privConnectionId = sessionId !== undefined ? sessionId : (0, $kSC7p.createNoDashGuid)();
            this.privRequestSession.onPreConnectionStart(this.privAuthFetchEventId, this.privConnectionId);
            let lastStatusCode = 0;
            let lastReason = "";
            while(this.privRequestSession.numConnectionAttempts <= this.privRecognizerConfig.maxRetryCount){
                // Get the auth information for the connection. This is a bit of overkill for the current API surface, but leaving the plumbing in place to be able to raise a developer-customer
                // facing event when a connection fails to let them try and provide new auth information.
                const authPromise = isUnAuthorized ? this.privAuthentication.fetchOnExpiry(this.privAuthFetchEventId) : this.privAuthentication.fetch(this.privAuthFetchEventId);
                const auth = yield authPromise;
                yield this.privRequestSession.onAuthCompleted(false);
                // Create the connection
                const connection = this.privConnectionFactory.create(this.privRecognizerConfig, auth, this.privConnectionId);
                // Attach the telemetry handlers.
                this.privRequestSession.listenForServiceTelemetry(connection.events);
                // Attach to the underlying event. No need to hold onto the detach pointers as in the event the connection goes away,
                // it'll stop sending events.
                connection.events.attach((event)=>{
                    this.connectionEvents.onEvent(event);
                });
                const response = yield connection.open();
                // 200 == everything is fine.
                if (response.statusCode === 200) {
                    yield this.privRequestSession.onConnectionEstablishCompleted(response.statusCode);
                    return Promise.resolve(connection);
                } else if (response.statusCode === 1006) isUnAuthorized = true;
                lastStatusCode = response.statusCode;
                lastReason = response.reason;
                this.privRequestSession.onRetryConnection();
            }
            yield this.privRequestSession.onConnectionEstablishCompleted(lastStatusCode, lastReason);
            return Promise.reject(`Unable to contact server. StatusCode: ${lastStatusCode}, ${this.privRecognizerConfig.parameters.getProperty((0, $jJjdG.PropertyId).SpeechServiceConnection_Endpoint)} Reason: ${lastReason}`);
        });
    }
    delay(delayMs) {
        return new Promise((resolve, reject)=>{
            this.privSetTimeout(resolve, delayMs);
        });
    }
    writeBufferToConsole(buffer) {
        let out = "Buffer Size: ";
        if (null === buffer) out += "null";
        else {
            const readView = new Uint8Array(buffer);
            out += buffer.byteLength + "\r\n";
            for(let i = 0; i < buffer.byteLength; i++)out += readView[i].toString(16).padStart(2, "0") + " ";
        }
        // tslint:disable-next-line:no-console
        console.info(out);
    }
    sendFinalAudio() {
        return $f739deac85bf8223$var$__awaiter(this, void 0, void 0, function*() {
            const connection = yield this.fetchConnection();
            yield connection.send(new (0, $MRQbb.SpeechConnectionMessage)((0, $4gz8B.MessageType).Binary, "audio", this.privRequestSession.requestId, null, null));
            return;
        });
    }
    // Takes an established websocket connection to the endpoint and sends speech configuration information.
    configureConnection() {
        return $f739deac85bf8223$var$__awaiter(this, void 0, void 0, function*() {
            const connection = yield this.connectImpl();
            if (this.configConnectionOverride !== undefined) return this.configConnectionOverride(connection);
            yield this.sendSpeechServiceConfig(connection, this.privRequestSession, this.privRecognizerConfig.SpeechServiceConfig.serialize());
            yield this.sendPrePayloadJSON(connection);
            return connection;
        });
    }
}
$f739deac85bf8223$export$984734d84ac7a9a1.telemetryDataEnabled = true;

});
parcelRequire.register("8g0TV", function(module, exports) {

$parcel$export(module.exports, "CancellationErrorCode", () => $603084484bca7d66$export$b0e2ad361e796e97);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
/**
 *  Defines error code in case that CancellationReason is Error.
 *  Added in version 1.1.0.
 */ var $603084484bca7d66$export$b0e2ad361e796e97;
(function(CancellationErrorCode) {
    /**
     * Indicates that no error occurred during speech recognition.
     */ CancellationErrorCode[CancellationErrorCode["NoError"] = 0] = "NoError";
    /**
     * Indicates an authentication error.
     */ CancellationErrorCode[CancellationErrorCode["AuthenticationFailure"] = 1] = "AuthenticationFailure";
    /**
     * Indicates that one or more recognition parameters are invalid.
     */ CancellationErrorCode[CancellationErrorCode["BadRequestParameters"] = 2] = "BadRequestParameters";
    /**
     * Indicates that the number of parallel requests exceeded the number of allowed
     * concurrent transcriptions for the subscription.
     */ CancellationErrorCode[CancellationErrorCode["TooManyRequests"] = 3] = "TooManyRequests";
    /**
     * Indicates a connection error.
     */ CancellationErrorCode[CancellationErrorCode["ConnectionFailure"] = 4] = "ConnectionFailure";
    /**
     * Indicates a time-out error when waiting for response from service.
     */ CancellationErrorCode[CancellationErrorCode["ServiceTimeout"] = 5] = "ServiceTimeout";
    /**
     * Indicates that an error is returned by the service.
     */ CancellationErrorCode[CancellationErrorCode["ServiceError"] = 6] = "ServiceError";
    /**
     * Indicates an unexpected runtime error.
     */ CancellationErrorCode[CancellationErrorCode["RuntimeError"] = 7] = "RuntimeError";
})($603084484bca7d66$export$b0e2ad361e796e97 || ($603084484bca7d66$export$b0e2ad361e796e97 = {}));

});

parcelRequire.register("GCsZL", function(module, exports) {

$parcel$export(module.exports, "CancellationReason", () => $0801c30981cd8afe$export$cbce095b92028433);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
/**
 * Defines the possible reasons a recognition result might be canceled.
 * @class CancellationReason
 */ var $0801c30981cd8afe$export$cbce095b92028433;
(function(CancellationReason) {
    /**
     * Indicates that an error occurred during speech recognition.
     * @member CancellationReason.Error
     */ CancellationReason[CancellationReason["Error"] = 0] = "Error";
    /**
     * Indicates that the end of the audio stream was reached.
     * @member CancellationReason.EndOfStream
     */ CancellationReason[CancellationReason["EndOfStream"] = 1] = "EndOfStream";
})($0801c30981cd8afe$export$cbce095b92028433 || ($0801c30981cd8afe$export$cbce095b92028433 = {}));

});

parcelRequire.register("jJjdG", function(module, exports) {

$parcel$export(module.exports, "PropertyId", () => $e5d120eddadb5a53$export$f7caa2a6f083d81);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
/**
 * Defines speech property ids.
 * @class PropertyId
 */ var $e5d120eddadb5a53$export$f7caa2a6f083d81;
(function(PropertyId) {
    /**
     * The Cognitive Services Speech Service subscription Key. If you are using an intent recognizer, you need to specify
     * to specify the LUIS endpoint key for your particular LUIS app. Under normal circumstances, you shouldn't
     * have to use this property directly.
     * Instead, use [[SpeechConfig.fromSubscription]].
     * @member PropertyId.SpeechServiceConnection_Key
     */ PropertyId[PropertyId["SpeechServiceConnection_Key"] = 0] = "SpeechServiceConnection_Key";
    /**
     * The Cognitive Services Speech Service endpoint (url). Under normal circumstances, you shouldn't
     * have to use this property directly.
     * Instead, use [[SpeechConfig.fromEndpoint]].
     * NOTE: This endpoint is not the same as the endpoint used to obtain an access token.
     * @member PropertyId.SpeechServiceConnection_Endpoint
     */ PropertyId[PropertyId["SpeechServiceConnection_Endpoint"] = 1] = "SpeechServiceConnection_Endpoint";
    /**
     * The Cognitive Services Speech Service region. Under normal circumstances, you shouldn't have to
     * use this property directly.
     * Instead, use [[SpeechConfig.fromSubscription]], [[SpeechConfig.fromEndpoint]], [[SpeechConfig.fromAuthorizationToken]].
     * @member PropertyId.SpeechServiceConnection_Region
     */ PropertyId[PropertyId["SpeechServiceConnection_Region"] = 2] = "SpeechServiceConnection_Region";
    /**
     * The Cognitive Services Speech Service authorization token (aka access token). Under normal circumstances,
     * you shouldn't have to use this property directly.
     * Instead, use [[SpeechConfig.fromAuthorizationToken]], [[SpeechRecognizer.authorizationToken]],
     * [[IntentRecognizer.authorizationToken]], [[TranslationRecognizer.authorizationToken]], [[SpeakerRecognizer.authorizationToken]].
     * @member PropertyId.SpeechServiceAuthorization_Token
     */ PropertyId[PropertyId["SpeechServiceAuthorization_Token"] = 3] = "SpeechServiceAuthorization_Token";
    /**
     * The Cognitive Services Speech Service authorization type. Currently unused.
     * @member PropertyId.SpeechServiceAuthorization_Type
     */ PropertyId[PropertyId["SpeechServiceAuthorization_Type"] = 4] = "SpeechServiceAuthorization_Type";
    /**
     * The Cognitive Services Speech Service endpoint id. Under normal circumstances, you shouldn't
     * have to use this property directly.
     * Instead, use [[SpeechConfig.endpointId]].
     * NOTE: The endpoint id is available in the Speech Portal, listed under Endpoint Details.
     * @member PropertyId.SpeechServiceConnection_EndpointId
     */ PropertyId[PropertyId["SpeechServiceConnection_EndpointId"] = 5] = "SpeechServiceConnection_EndpointId";
    /**
     * The list of comma separated languages (BCP-47 format) used as target translation languages. Under normal circumstances,
     * you shouldn't have to use this property directly.
     * Instead use [[SpeechTranslationConfig.addTargetLanguage]],
     * [[SpeechTranslationConfig.targetLanguages]], [[TranslationRecognizer.targetLanguages]].
     * @member PropertyId.SpeechServiceConnection_TranslationToLanguages
     */ PropertyId[PropertyId["SpeechServiceConnection_TranslationToLanguages"] = 6] = "SpeechServiceConnection_TranslationToLanguages";
    /**
     * The name of the Cognitive Service Text to Speech Service Voice. Under normal circumstances, you shouldn't have to use this
     * property directly.
     * Instead, use [[SpeechTranslationConfig.voiceName]].
     * NOTE: Valid voice names can be found <a href="https://aka.ms/csspeech/voicenames">here</a>.
     * @member PropertyId.SpeechServiceConnection_TranslationVoice
     */ PropertyId[PropertyId["SpeechServiceConnection_TranslationVoice"] = 7] = "SpeechServiceConnection_TranslationVoice";
    /**
     * Translation features.
     * @member PropertyId.SpeechServiceConnection_TranslationFeatures
     */ PropertyId[PropertyId["SpeechServiceConnection_TranslationFeatures"] = 8] = "SpeechServiceConnection_TranslationFeatures";
    /**
     * The Language Understanding Service Region. Under normal circumstances, you shouldn't have to use this property directly.
     * Instead, use [[LanguageUnderstandingModel]].
     * @member PropertyId.SpeechServiceConnection_IntentRegion
     */ PropertyId[PropertyId["SpeechServiceConnection_IntentRegion"] = 9] = "SpeechServiceConnection_IntentRegion";
    /**
     * The host name of the proxy server used to connect to the Cognitive Services Speech Service. Only relevant in Node.js environments.
     * You shouldn't have to use this property directly.
     * Instead use <see cref="SpeechConfig.SetProxy(string,int,string,string)"/>.
     * Added in version 1.4.0.
     */ PropertyId[PropertyId["SpeechServiceConnection_ProxyHostName"] = 10] = "SpeechServiceConnection_ProxyHostName";
    /**
     * The port of the proxy server used to connect to the Cognitive Services Speech Service. Only relevant in Node.js environments.
     * You shouldn't have to use this property directly.
     * Instead use <see cref="SpeechConfig.SetProxy(string,int,string,string)"/>.
     * Added in version 1.4.0.
     */ PropertyId[PropertyId["SpeechServiceConnection_ProxyPort"] = 11] = "SpeechServiceConnection_ProxyPort";
    /**
     * The user name of the proxy server used to connect to the Cognitive Services Speech Service. Only relevant in Node.js environments.
     * You shouldn't have to use this property directly.
     * Instead use <see cref="SpeechConfig.SetProxy(string,int,string,string)"/>.
     * Added in version 1.4.0.
     */ PropertyId[PropertyId["SpeechServiceConnection_ProxyUserName"] = 12] = "SpeechServiceConnection_ProxyUserName";
    /**
     * The password of the proxy server used to connect to the Cognitive Services Speech Service. Only relevant in Node.js environments.
     * You shouldn't have to use this property directly.
     * Instead use <see cref="SpeechConfig.SetProxy(string,int,string,string)"/>.
     * Added in version 1.4.0.
     */ PropertyId[PropertyId["SpeechServiceConnection_ProxyPassword"] = 13] = "SpeechServiceConnection_ProxyPassword";
    /**
     * The Cognitive Services Speech Service recognition Mode. Can be "INTERACTIVE", "CONVERSATION", "DICTATION".
     * This property is intended to be read-only. The SDK is using it internally.
     * @member PropertyId.SpeechServiceConnection_RecoMode
     */ PropertyId[PropertyId["SpeechServiceConnection_RecoMode"] = 14] = "SpeechServiceConnection_RecoMode";
    /**
     * The spoken language to be recognized (in BCP-47 format). Under normal circumstances, you shouldn't have to use this property
     * directly.
     * Instead, use [[SpeechConfig.speechRecognitionLanguage]].
     * @member PropertyId.SpeechServiceConnection_RecoLanguage
     */ PropertyId[PropertyId["SpeechServiceConnection_RecoLanguage"] = 15] = "SpeechServiceConnection_RecoLanguage";
    /**
     * The session id. This id is a universally unique identifier (aka UUID) representing a specific binding of an audio input stream
     * and the underlying speech recognition instance to which it is bound. Under normal circumstances, you shouldn't have to use this
     * property directly.
     * Instead use [[SessionEventArgs.sessionId]].
     * @member PropertyId.Speech_SessionId
     */ PropertyId[PropertyId["Speech_SessionId"] = 16] = "Speech_SessionId";
    /**
     * The spoken language to be synthesized (e.g. en-US)
     * @member PropertyId.SpeechServiceConnection_SynthLanguage
     */ PropertyId[PropertyId["SpeechServiceConnection_SynthLanguage"] = 17] = "SpeechServiceConnection_SynthLanguage";
    /**
     * The name of the TTS voice to be used for speech synthesis
     * @member PropertyId.SpeechServiceConnection_SynthVoice
     */ PropertyId[PropertyId["SpeechServiceConnection_SynthVoice"] = 18] = "SpeechServiceConnection_SynthVoice";
    /**
     * The string to specify TTS output audio format
     * @member PropertyId.SpeechServiceConnection_SynthOutputFormat
     */ PropertyId[PropertyId["SpeechServiceConnection_SynthOutputFormat"] = 19] = "SpeechServiceConnection_SynthOutputFormat";
    /**
     * The list of comma separated languages used as possible source languages
     * Added in version 1.13.0
     * @member PropertyId.SpeechServiceConnection_AutoDetectSourceLanguages
     */ PropertyId[PropertyId["SpeechServiceConnection_AutoDetectSourceLanguages"] = 20] = "SpeechServiceConnection_AutoDetectSourceLanguages";
    /**
     * The requested Cognitive Services Speech Service response output format (simple or detailed). Under normal circumstances, you shouldn't have
     * to use this property directly.
     * Instead use [[SpeechConfig.outputFormat]].
     * @member PropertyId.SpeechServiceResponse_RequestDetailedResultTrueFalse
     */ PropertyId[PropertyId["SpeechServiceResponse_RequestDetailedResultTrueFalse"] = 21] = "SpeechServiceResponse_RequestDetailedResultTrueFalse";
    /**
     * The requested Cognitive Services Speech Service response output profanity level. Currently unused.
     * @member PropertyId.SpeechServiceResponse_RequestProfanityFilterTrueFalse
     */ PropertyId[PropertyId["SpeechServiceResponse_RequestProfanityFilterTrueFalse"] = 22] = "SpeechServiceResponse_RequestProfanityFilterTrueFalse";
    /**
     * The Cognitive Services Speech Service response output (in JSON format). This property is available on recognition result objects only.
     * @member PropertyId.SpeechServiceResponse_JsonResult
     */ PropertyId[PropertyId["SpeechServiceResponse_JsonResult"] = 23] = "SpeechServiceResponse_JsonResult";
    /**
     * The Cognitive Services Speech Service error details (in JSON format). Under normal circumstances, you shouldn't have to
     * use this property directly. Instead use [[CancellationDetails.errorDetails]].
     * @member PropertyId.SpeechServiceResponse_JsonErrorDetails
     */ PropertyId[PropertyId["SpeechServiceResponse_JsonErrorDetails"] = 24] = "SpeechServiceResponse_JsonErrorDetails";
    /**
     * The cancellation reason. Currently unused.
     * @member PropertyId.CancellationDetails_Reason
     */ PropertyId[PropertyId["CancellationDetails_Reason"] = 25] = "CancellationDetails_Reason";
    /**
     * The cancellation text. Currently unused.
     * @member PropertyId.CancellationDetails_ReasonText
     */ PropertyId[PropertyId["CancellationDetails_ReasonText"] = 26] = "CancellationDetails_ReasonText";
    /**
     * The Cancellation detailed text. Currently unused.
     * @member PropertyId.CancellationDetails_ReasonDetailedText
     */ PropertyId[PropertyId["CancellationDetails_ReasonDetailedText"] = 27] = "CancellationDetails_ReasonDetailedText";
    /**
     * The Language Understanding Service response output (in JSON format). Available via [[IntentRecognitionResult]]
     * @member PropertyId.LanguageUnderstandingServiceResponse_JsonResult
     */ PropertyId[PropertyId["LanguageUnderstandingServiceResponse_JsonResult"] = 28] = "LanguageUnderstandingServiceResponse_JsonResult";
    /**
     * The URL string built from speech configuration.
     * This property is intended to be read-only. The SDK is using it internally.
     * NOTE: Added in version 1.7.0.
     */ PropertyId[PropertyId["SpeechServiceConnection_Url"] = 29] = "SpeechServiceConnection_Url";
    /**
     * The initial silence timeout value (in milliseconds) used by the service.
     * Added in version 1.7.0
     */ PropertyId[PropertyId["SpeechServiceConnection_InitialSilenceTimeoutMs"] = 30] = "SpeechServiceConnection_InitialSilenceTimeoutMs";
    /**
     * The end silence timeout value (in milliseconds) used by the service.
     * Added in version 1.7.0
     */ PropertyId[PropertyId["SpeechServiceConnection_EndSilenceTimeoutMs"] = 31] = "SpeechServiceConnection_EndSilenceTimeoutMs";
    /**
     * A boolean value specifying whether audio logging is enabled in the service or not.
     * Added in version 1.7.0
     */ PropertyId[PropertyId["SpeechServiceConnection_EnableAudioLogging"] = 32] = "SpeechServiceConnection_EnableAudioLogging";
    /**
     * The requested Cognitive Services Speech Service response output profanity setting.
     * Allowed values are "masked", "removed", and "raw".
     * Added in version 1.7.0.
     */ PropertyId[PropertyId["SpeechServiceResponse_ProfanityOption"] = 33] = "SpeechServiceResponse_ProfanityOption";
    /**
     * A string value specifying which post processing option should be used by service.
     * Allowed values are "TrueText".
     * Added in version 1.7.0
     */ PropertyId[PropertyId["SpeechServiceResponse_PostProcessingOption"] = 34] = "SpeechServiceResponse_PostProcessingOption";
    /**
     *  A boolean value specifying whether to include word-level timestamps in the response result.
     * Added in version 1.7.0
     */ PropertyId[PropertyId["SpeechServiceResponse_RequestWordLevelTimestamps"] = 35] = "SpeechServiceResponse_RequestWordLevelTimestamps";
    /**
     * The number of times a word has to be in partial results to be returned.
     * Added in version 1.7.0
     */ PropertyId[PropertyId["SpeechServiceResponse_StablePartialResultThreshold"] = 36] = "SpeechServiceResponse_StablePartialResultThreshold";
    /**
     * A string value specifying the output format option in the response result. Internal use only.
     * Added in version 1.7.0.
     */ PropertyId[PropertyId["SpeechServiceResponse_OutputFormatOption"] = 37] = "SpeechServiceResponse_OutputFormatOption";
    /**
     * A boolean value to request for stabilizing translation partial results by omitting words in the end.
     * Added in version 1.7.0.
     */ PropertyId[PropertyId["SpeechServiceResponse_TranslationRequestStablePartialResult"] = 38] = "SpeechServiceResponse_TranslationRequestStablePartialResult";
    /**
     * Identifier used to connect to the backend service.
     * @member PropertyId.Conversation_ApplicationId
     */ PropertyId[PropertyId["Conversation_ApplicationId"] = 39] = "Conversation_ApplicationId";
    /**
     * Type of dialog backend to connect to.
     * @member PropertyId.Conversation_DialogType
     */ PropertyId[PropertyId["Conversation_DialogType"] = 40] = "Conversation_DialogType";
    /**
     * Silence timeout for listening
     * @member PropertyId.Conversation_Initial_Silence_Timeout
     */ PropertyId[PropertyId["Conversation_Initial_Silence_Timeout"] = 41] = "Conversation_Initial_Silence_Timeout";
    /**
     * From Id to add to speech recognition activities.
     * @member PropertyId.Conversation_From_Id
     */ PropertyId[PropertyId["Conversation_From_Id"] = 42] = "Conversation_From_Id";
    /**
     * ConversationId for the session.
     * @member PropertyId.Conversation_Conversation_Id
     */ PropertyId[PropertyId["Conversation_Conversation_Id"] = 43] = "Conversation_Conversation_Id";
    /**
     * Comma separated list of custom voice deployment ids.
     * @member PropertyId.Conversation_Custom_Voice_Deployment_Ids
     */ PropertyId[PropertyId["Conversation_Custom_Voice_Deployment_Ids"] = 44] = "Conversation_Custom_Voice_Deployment_Ids";
    /**
     * Speech activity template, stamp properties from the template on the activity generated by the service for speech.
     * @member PropertyId.Conversation_Speech_Activity_Template
     * Added in version 1.10.0.
     */ PropertyId[PropertyId["Conversation_Speech_Activity_Template"] = 45] = "Conversation_Speech_Activity_Template";
    /**
     * Enables or disables the receipt of turn status messages as obtained on the turnStatusReceived event.
     * @member PropertyId.Conversation_Request_Bot_Status_Messages
     * Added in version 1.15.0.
     */ PropertyId[PropertyId["Conversation_Request_Bot_Status_Messages"] = 46] = "Conversation_Request_Bot_Status_Messages";
    /**
     * Specifies the connection ID to be provided in the Agent configuration message, e.g. a Direct Line token for
     * channel authentication.
     * Added in version 1.15.1.
     */ PropertyId[PropertyId["Conversation_Agent_Connection_Id"] = 47] = "Conversation_Agent_Connection_Id";
    /**
     * The Cognitive Services Speech Service host (url). Under normal circumstances, you shouldn't have to use this property directly.
     * Instead, use [[SpeechConfig.fromHost]].
     */ PropertyId[PropertyId["SpeechServiceConnection_Host"] = 48] = "SpeechServiceConnection_Host";
    /**
     * Set the host for service calls to the Conversation Translator REST management and websocket calls.
     */ PropertyId[PropertyId["ConversationTranslator_Host"] = 49] = "ConversationTranslator_Host";
    /**
     * Optionally set the the host's display name.
     * Used when joining a conversation.
     */ PropertyId[PropertyId["ConversationTranslator_Name"] = 50] = "ConversationTranslator_Name";
    /**
     * Optionally set a value for the X-CorrelationId request header.
     * Used for troubleshooting errors in the server logs. It should be a valid guid.
     */ PropertyId[PropertyId["ConversationTranslator_CorrelationId"] = 51] = "ConversationTranslator_CorrelationId";
    /**
     * Set the conversation token to be sent to the speech service. This enables the
     * service to service call from the speech service to the Conversation Translator service for relaying
     * recognitions. For internal use.
     */ PropertyId[PropertyId["ConversationTranslator_Token"] = 52] = "ConversationTranslator_Token";
    /**
     * The reference text of the audio for pronunciation evaluation.
     * For this and the following pronunciation assessment parameters, see
     * https://docs.microsoft.com/azure/cognitive-services/speech-service/rest-speech-to-text#pronunciation-assessment-parameters for details.
     * Under normal circumstances, you shouldn't have to use this property directly.
     * Added in version 1.15.0
     */ PropertyId[PropertyId["PronunciationAssessment_ReferenceText"] = 53] = "PronunciationAssessment_ReferenceText";
    /**
     * The point system for pronunciation score calibration (FivePoint or HundredMark).
     * Under normal circumstances, you shouldn't have to use this property directly.
     * Added in version 1.15.0
     */ PropertyId[PropertyId["PronunciationAssessment_GradingSystem"] = 54] = "PronunciationAssessment_GradingSystem";
    /**
     * The pronunciation evaluation granularity (Phoneme, Word, or FullText).
     * Under normal circumstances, you shouldn't have to use this property directly.
     * Added in version 1.15.0
     */ PropertyId[PropertyId["PronunciationAssessment_Granularity"] = 55] = "PronunciationAssessment_Granularity";
    /**
     * Defines if enable miscue calculation.
     * With this enabled, the pronounced words will be compared to the reference text,
     * and will be marked with omission/insertion based on the comparison. The default setting is False.
     * Under normal circumstances, you shouldn't have to use this property directly.
     * Added in version 1.15.0
     */ PropertyId[PropertyId["PronunciationAssessment_EnableMiscue"] = 56] = "PronunciationAssessment_EnableMiscue";
    /**
     * The json string of pronunciation assessment parameters
     * Under normal circumstances, you shouldn't have to use this property directly.
     * Added in version 1.15.0
     */ PropertyId[PropertyId["PronunciationAssessment_Json"] = 57] = "PronunciationAssessment_Json";
    /**
     * Pronunciation assessment parameters.
     * This property is intended to be read-only. The SDK is using it internally.
     * Added in version 1.15.0
     */ PropertyId[PropertyId["PronunciationAssessment_Params"] = 58] = "PronunciationAssessment_Params";
})($e5d120eddadb5a53$export$f7caa2a6f083d81 || ($e5d120eddadb5a53$export$f7caa2a6f083d81 = {}));

});

parcelRequire.register("lst3T", function(module, exports) {

$parcel$export(module.exports, "RecognitionEventArgs", () => $f9f2c18acb1bf1ee$export$12431311bd74173);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.

var $9Pi8Y = parcelRequire("9Pi8Y");
class $f9f2c18acb1bf1ee$export$12431311bd74173 extends (0, $9Pi8Y.SessionEventArgs) {
    /**
     * Creates and initializes an instance of this class.
     * @constructor
     * @param {number} offset - The offset.
     * @param {string} sessionId - The session id.
     */ constructor(offset, sessionId){
        super(sessionId);
        this.privOffset = offset;
    }
    /**
     * Represents the message offset
     * @member RecognitionEventArgs.prototype.offset
     * @function
     * @public
     */ get offset() {
        return this.privOffset;
    }
}

});
parcelRequire.register("9Pi8Y", function(module, exports) {

$parcel$export(module.exports, "SessionEventArgs", () => $7276f372043d5c32$export$ddbc7bb13aa93fd9);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
/**
 * Defines content for session events like SessionStarted/Stopped, SoundStarted/Stopped.
 * @class SessionEventArgs
 */ class $7276f372043d5c32$export$ddbc7bb13aa93fd9 {
    /**
     * Creates and initializes an instance of this class.
     * @constructor
     * @param {string} sessionId - The session id.
     */ constructor(sessionId){
        this.privSessionId = sessionId;
    }
    /**
     * Represents the session identifier.
     * @member SessionEventArgs.prototype.sessionId
     * @function
     * @public
     * @returns {string} Represents the session identifier.
     */ get sessionId() {
        return this.privSessionId;
    }
}

});


parcelRequire.register("MRQbb", function(module, exports) {

$parcel$export(module.exports, "SpeechConnectionMessage", () => $092e3f6e8dd8a65f$export$d7d1294d295e5b2a);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
parcelRequire("3KVS5");
var $4Cx0W = parcelRequire("4Cx0W");
var $4gz8B = parcelRequire("4gz8B");

var $2V1Xw = parcelRequire("2V1Xw");
class $092e3f6e8dd8a65f$export$d7d1294d295e5b2a extends (0, $4gz8B.ConnectionMessage) {
    constructor(messageType, path, requestId, contentType, body, streamId, additionalHeaders, id){
        if (!path) throw new (0, $4Cx0W.ArgumentNullError)("path");
        if (!requestId) throw new (0, $4Cx0W.ArgumentNullError)("requestId");
        const headers = {};
        headers[(0, $2V1Xw.HeaderNames).Path] = path;
        headers[(0, $2V1Xw.HeaderNames).RequestId] = requestId;
        headers[(0, $2V1Xw.HeaderNames).RequestTimestamp] = new Date().toISOString();
        if (contentType) headers[(0, $2V1Xw.HeaderNames).ContentType] = contentType;
        if (streamId) headers[(0, $2V1Xw.HeaderNames).RequestStreamId] = streamId;
        if (additionalHeaders) {
            for(const headerName in additionalHeaders)if (headerName) headers[headerName] = additionalHeaders[headerName];
        }
        if (id) super(messageType, body, headers, id);
        else super(messageType, body, headers);
        this.privPath = path;
        this.privRequestId = requestId;
        this.privContentType = contentType;
        this.privStreamId = streamId;
        this.privAdditionalHeaders = additionalHeaders;
    }
    get path() {
        return this.privPath;
    }
    get requestId() {
        return this.privRequestId;
    }
    get contentType() {
        return this.privContentType;
    }
    get streamId() {
        return this.privStreamId;
    }
    get additionalHeaders() {
        return this.privAdditionalHeaders;
    }
}
$092e3f6e8dd8a65f$export$d7d1294d295e5b2a.fromConnectionMessage = (message)=>{
    let path = null;
    let requestId = null;
    let contentType = null;
    let requestTimestamp = null;
    let streamId = null;
    const additionalHeaders = {};
    if (message.headers) {
        for(const headerName in message.headers)if (headerName) {
            if (headerName.toLowerCase() === (0, $2V1Xw.HeaderNames).Path.toLowerCase()) path = message.headers[headerName];
            else if (headerName.toLowerCase() === (0, $2V1Xw.HeaderNames).RequestId.toLowerCase()) requestId = message.headers[headerName];
            else if (headerName.toLowerCase() === (0, $2V1Xw.HeaderNames).RequestTimestamp.toLowerCase()) requestTimestamp = message.headers[headerName];
            else if (headerName.toLowerCase() === (0, $2V1Xw.HeaderNames).ContentType.toLowerCase()) contentType = message.headers[headerName];
            else if (headerName.toLowerCase() === (0, $2V1Xw.HeaderNames).RequestStreamId.toLowerCase()) streamId = message.headers[headerName];
            else additionalHeaders[headerName] = message.headers[headerName];
        }
    }
    return new $092e3f6e8dd8a65f$export$d7d1294d295e5b2a(message.messageType, path, requestId, contentType, message.body, streamId, additionalHeaders, message.id);
};

});


parcelRequire.register("iWV5t", function(module, exports) {

$parcel$export(module.exports, "RecognitionMode", () => $dcb9ed195a91969a$export$79403a05110b2cfc);
$parcel$export(module.exports, "RecognizerConfig", () => $dcb9ed195a91969a$export$6036b6a06cf1bd7e);
$parcel$export(module.exports, "SpeechServiceConfig", () => $dcb9ed195a91969a$export$51f52f0a07e48303);
$parcel$export(module.exports, "Context", () => $dcb9ed195a91969a$export$841858b892ce1f4c);
$parcel$export(module.exports, "OS", () => $dcb9ed195a91969a$export$decc4a6e69bbf763);
$parcel$export(module.exports, "connectivity", () => $dcb9ed195a91969a$export$bc2c1e1c80c298f2);
$parcel$export(module.exports, "type", () => $dcb9ed195a91969a$export$bf9fb029d174d554);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
// tslint:disable:max-classes-per-file

var $jJjdG = parcelRequire("jJjdG");
var $dcb9ed195a91969a$export$79403a05110b2cfc;
(function(RecognitionMode) {
    RecognitionMode[RecognitionMode["Interactive"] = 0] = "Interactive";
    RecognitionMode[RecognitionMode["Conversation"] = 1] = "Conversation";
    RecognitionMode[RecognitionMode["Dictation"] = 2] = "Dictation";
})($dcb9ed195a91969a$export$79403a05110b2cfc || ($dcb9ed195a91969a$export$79403a05110b2cfc = {}));
var $dcb9ed195a91969a$export$e92bebf6311e8221;
(function(SpeechResultFormat) {
    SpeechResultFormat[SpeechResultFormat["Simple"] = 0] = "Simple";
    SpeechResultFormat[SpeechResultFormat["Detailed"] = 1] = "Detailed";
})($dcb9ed195a91969a$export$e92bebf6311e8221 || ($dcb9ed195a91969a$export$e92bebf6311e8221 = {}));
class $dcb9ed195a91969a$export$6036b6a06cf1bd7e {
    constructor(speechServiceConfig, parameters){
        this.privRecognitionMode = $dcb9ed195a91969a$export$79403a05110b2cfc.Interactive;
        this.privSpeechServiceConfig = speechServiceConfig ? speechServiceConfig : new $dcb9ed195a91969a$export$51f52f0a07e48303(new $dcb9ed195a91969a$export$841858b892ce1f4c(null));
        this.privParameters = parameters;
        this.privMaxRetryCount = parseInt(parameters.getProperty("SPEECH-Error-MaxRetryCount", "4"), 10);
    }
    get parameters() {
        return this.privParameters;
    }
    get recognitionMode() {
        return this.privRecognitionMode;
    }
    set recognitionMode(value) {
        this.privRecognitionMode = value;
        this.privRecognitionActivityTimeout = value === $dcb9ed195a91969a$export$79403a05110b2cfc.Interactive ? 8000 : 25000;
        this.privSpeechServiceConfig.Recognition = $dcb9ed195a91969a$export$79403a05110b2cfc[value];
    }
    get SpeechServiceConfig() {
        return this.privSpeechServiceConfig;
    }
    get recognitionActivityTimeout() {
        return this.privRecognitionActivityTimeout;
    }
    get isContinuousRecognition() {
        return this.privRecognitionMode !== $dcb9ed195a91969a$export$79403a05110b2cfc.Interactive;
    }
    get autoDetectSourceLanguages() {
        return this.parameters.getProperty((0, $jJjdG.PropertyId).SpeechServiceConnection_AutoDetectSourceLanguages, undefined);
    }
    get maxRetryCount() {
        return this.privMaxRetryCount;
    }
}
class $dcb9ed195a91969a$export$51f52f0a07e48303 {
    constructor(context){
        this.serialize = ()=>{
            return JSON.stringify(this, (key, value)=>{
                if (value && typeof value === "object") {
                    const replacement = {};
                    for(const k in value)if (Object.hasOwnProperty.call(value, k)) replacement[k && k.charAt(0).toLowerCase() + k.substring(1)] = value[k];
                    return replacement;
                }
                return value;
            });
        };
        this.context = context;
    }
    get Context() {
        return this.context;
    }
    get Recognition() {
        return this.recognition;
    }
    set Recognition(value) {
        this.recognition = value.toLowerCase();
    }
}
class $dcb9ed195a91969a$export$841858b892ce1f4c {
    constructor(os){
        this.system = new $dcb9ed195a91969a$export$e1dae5660003ffa7();
        this.os = os;
    }
}
class $dcb9ed195a91969a$export$e1dae5660003ffa7 {
    constructor(){
        // Note: below will be patched for official builds.
        const SPEECHSDK_CLIENTSDK_VERSION = "1.17.0";
        this.name = "SpeechSDK";
        this.version = SPEECHSDK_CLIENTSDK_VERSION;
        this.build = "JavaScript";
        this.lang = "JavaScript";
    }
}
class $dcb9ed195a91969a$export$decc4a6e69bbf763 {
    constructor(platform, name, version){
        this.platform = platform;
        this.name = name;
        this.version = version;
    }
}
class $dcb9ed195a91969a$export$8215d14a63d9fb10 {
    constructor(manufacturer, model, version){
        this.manufacturer = manufacturer;
        this.model = model;
        this.version = version;
    }
}
var $dcb9ed195a91969a$export$bc2c1e1c80c298f2;
(function(connectivity) {
    connectivity["Bluetooth"] = "Bluetooth";
    connectivity["Wired"] = "Wired";
    connectivity["WiFi"] = "WiFi";
    connectivity["Cellular"] = "Cellular";
    connectivity["InBuilt"] = "InBuilt";
    connectivity["Unknown"] = "Unknown";
})($dcb9ed195a91969a$export$bc2c1e1c80c298f2 || ($dcb9ed195a91969a$export$bc2c1e1c80c298f2 = {}));
var $dcb9ed195a91969a$export$bf9fb029d174d554;
(function(type) {
    type["Phone"] = "Phone";
    type["Speaker"] = "Speaker";
    type["Car"] = "Car";
    type["Headset"] = "Headset";
    type["Thermostat"] = "Thermostat";
    type["Microphones"] = "Microphones";
    type["Deskphone"] = "Deskphone";
    type["RemoteControl"] = "RemoteControl";
    type["Unknown"] = "Unknown";
    type["File"] = "File";
    type["Stream"] = "Stream";
})($dcb9ed195a91969a$export$bf9fb029d174d554 || ($dcb9ed195a91969a$export$bf9fb029d174d554 = {}));

});

parcelRequire.register("dLS1h", function(module, exports) {

$parcel$export(module.exports, "WebsocketMessageFormatter", () => $a06991534099bef9$export$668bf8a6f768f67a);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
parcelRequire("3KVS5");
var $9MSEb = parcelRequire("9MSEb");
var $4gz8B = parcelRequire("4gz8B");
var $gcTfx = parcelRequire("gcTfx");
const $a06991534099bef9$var$CRLF = "\r\n";
class $a06991534099bef9$export$668bf8a6f768f67a {
    constructor(){
        this.toConnectionMessage = (message)=>{
            const deferral = new (0, $9MSEb.Deferred)();
            try {
                if (message.messageType === (0, $4gz8B.MessageType).Text) {
                    const textMessage = message.textContent;
                    let headers = {};
                    let body = null;
                    if (textMessage) {
                        const headerBodySplit = textMessage.split("\r\n\r\n");
                        if (headerBodySplit && headerBodySplit.length > 0) {
                            headers = this.parseHeaders(headerBodySplit[0]);
                            if (headerBodySplit.length > 1) body = headerBodySplit[1];
                        }
                    }
                    deferral.resolve(new (0, $4gz8B.ConnectionMessage)(message.messageType, body, headers, message.id));
                } else if (message.messageType === (0, $4gz8B.MessageType).Binary) {
                    const binaryMessage = message.binaryContent;
                    let headers = {};
                    let body = null;
                    if (!binaryMessage || binaryMessage.byteLength < 2) throw new Error("Invalid binary message format. Header length missing.");
                    const dataView = new DataView(binaryMessage);
                    const headerLength = dataView.getInt16(0);
                    if (binaryMessage.byteLength < headerLength + 2) throw new Error("Invalid binary message format. Header content missing.");
                    let headersString = "";
                    for(let i = 0; i < headerLength; i++)headersString += String.fromCharCode(dataView.getInt8(i + 2));
                    headers = this.parseHeaders(headersString);
                    if (binaryMessage.byteLength > headerLength + 2) body = binaryMessage.slice(2 + headerLength);
                    deferral.resolve(new (0, $4gz8B.ConnectionMessage)(message.messageType, body, headers, message.id));
                }
            } catch (e) {
                deferral.reject(`Error formatting the message. Error: ${e}`);
            }
            return deferral.promise;
        };
        this.fromConnectionMessage = (message)=>{
            const deferral = new (0, $9MSEb.Deferred)();
            try {
                if (message.messageType === (0, $4gz8B.MessageType).Text) {
                    const payload = `${this.makeHeaders(message)}${$a06991534099bef9$var$CRLF}${message.textBody ? message.textBody : ""}`;
                    deferral.resolve(new (0, $gcTfx.RawWebsocketMessage)((0, $4gz8B.MessageType).Text, payload, message.id));
                } else if (message.messageType === (0, $4gz8B.MessageType).Binary) {
                    const headersString = this.makeHeaders(message);
                    const content = message.binaryBody;
                    const headerBuffer = this.stringToArrayBuffer(headersString);
                    const headerInt8Array = new Int8Array(headerBuffer);
                    const headerLength = headerInt8Array.byteLength;
                    const payloadInt8Array = new Int8Array(2 + headerLength + (content ? content.byteLength : 0));
                    payloadInt8Array[0] = headerLength >> 8 & 0xff;
                    payloadInt8Array[1] = headerLength & 0xff;
                    payloadInt8Array.set(headerInt8Array, 2);
                    if (content) {
                        const bodyInt8Array = new Int8Array(content);
                        payloadInt8Array.set(bodyInt8Array, 2 + headerLength);
                    }
                    const payload = payloadInt8Array.buffer;
                    deferral.resolve(new (0, $gcTfx.RawWebsocketMessage)((0, $4gz8B.MessageType).Binary, payload, message.id));
                }
            } catch (e) {
                deferral.reject(`Error formatting the message. ${e}`);
            }
            return deferral.promise;
        };
        this.makeHeaders = (message)=>{
            let headersString = "";
            if (message.headers) {
                for(const header in message.headers)if (header) headersString += `${header}: ${message.headers[header]}${$a06991534099bef9$var$CRLF}`;
            }
            return headersString;
        };
        this.parseHeaders = (headersString)=>{
            const headers = {};
            if (headersString) {
                const headerMatches = headersString.match(/[^\r\n]+/g);
                if (headers) {
                    for (const header of headerMatches)if (header) {
                        const separatorIndex = header.indexOf(":");
                        const headerName = separatorIndex > 0 ? header.substr(0, separatorIndex).trim().toLowerCase() : header;
                        const headerValue = separatorIndex > 0 && header.length > separatorIndex + 1 ? header.substr(separatorIndex + 1).trim() : "";
                        headers[headerName] = headerValue;
                    }
                }
            }
            return headers;
        };
        this.stringToArrayBuffer = (str)=>{
            const buffer = new ArrayBuffer(str.length);
            const view = new DataView(buffer);
            for(let i = 0; i < str.length; i++)view.setUint8(i, str.charCodeAt(i));
            return buffer;
        };
    }
}

});

parcelRequire.register("28Rmc", function(module, exports) {

$parcel$export(module.exports, "EnumTranslation", () => $18f5b7b6f7de3011$export$f8492c3e19247e15);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.

var $8g0TV = parcelRequire("8g0TV");
var $GCsZL = parcelRequire("GCsZL");
var $dptOd = parcelRequire("dptOd");
parcelRequire("g6k3z");
var $15fen = parcelRequire("15fen");
class $18f5b7b6f7de3011$export$f8492c3e19247e15 {
    static implTranslateRecognitionResult(recognitionStatus) {
        let reason = (0, $dptOd.ResultReason).Canceled;
        switch(recognitionStatus){
            case (0, $15fen.RecognitionStatus).Success:
                reason = (0, $dptOd.ResultReason).RecognizedSpeech;
                break;
            case (0, $15fen.RecognitionStatus).NoMatch:
            case (0, $15fen.RecognitionStatus).InitialSilenceTimeout:
            case (0, $15fen.RecognitionStatus).BabbleTimeout:
            case (0, $15fen.RecognitionStatus).EndOfDictation:
                reason = (0, $dptOd.ResultReason).NoMatch;
                break;
            case (0, $15fen.RecognitionStatus).Error:
            default:
                reason = (0, $dptOd.ResultReason).Canceled;
                break;
        }
        return reason;
    }
    static implTranslateCancelResult(recognitionStatus) {
        let reason = (0, $GCsZL.CancellationReason).EndOfStream;
        switch(recognitionStatus){
            case (0, $15fen.RecognitionStatus).Success:
            case (0, $15fen.RecognitionStatus).EndOfDictation:
            case (0, $15fen.RecognitionStatus).NoMatch:
                reason = (0, $GCsZL.CancellationReason).EndOfStream;
                break;
            case (0, $15fen.RecognitionStatus).InitialSilenceTimeout:
            case (0, $15fen.RecognitionStatus).BabbleTimeout:
            case (0, $15fen.RecognitionStatus).Error:
            default:
                reason = (0, $GCsZL.CancellationReason).Error;
                break;
        }
        return reason;
    }
    static implTranslateCancelErrorCode(recognitionStatus) {
        let reason = (0, $8g0TV.CancellationErrorCode).NoError;
        switch(recognitionStatus){
            case (0, $15fen.RecognitionStatus).Error:
                reason = (0, $8g0TV.CancellationErrorCode).ServiceError;
                break;
            case (0, $15fen.RecognitionStatus).TooManyRequests:
                reason = (0, $8g0TV.CancellationErrorCode).TooManyRequests;
                break;
            default:
                reason = (0, $8g0TV.CancellationErrorCode).NoError;
                break;
        }
        return reason;
    }
}

});
parcelRequire.register("dptOd", function(module, exports) {

$parcel$export(module.exports, "ResultReason", () => $9c34bb9baf1bcf50$export$3527eaa7db1a45df);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
/**
 * Defines the possible reasons a recognition result might be generated.
 * @class ResultReason
 */ var $9c34bb9baf1bcf50$export$3527eaa7db1a45df;
(function(ResultReason) {
    /**
     * Indicates speech could not be recognized. More details
     * can be found in the NoMatchDetails object.
     * @member ResultReason.NoMatch
     */ ResultReason[ResultReason["NoMatch"] = 0] = "NoMatch";
    /**
     * Indicates that the recognition was canceled. More details
     * can be found using the CancellationDetails object.
     * @member ResultReason.Canceled
     */ ResultReason[ResultReason["Canceled"] = 1] = "Canceled";
    /**
     * Indicates the speech result contains hypothesis text.
     * @member ResultReason.RecognizedSpeech
     */ ResultReason[ResultReason["RecognizingSpeech"] = 2] = "RecognizingSpeech";
    /**
     * Indicates the speech result contains final text that has been recognized.
     * Speech Recognition is now complete for this phrase.
     * @member ResultReason.RecognizedSpeech
     */ ResultReason[ResultReason["RecognizedSpeech"] = 3] = "RecognizedSpeech";
    /**
     * Indicates the speech result contains a finalized acceptance of a provided keyword.
     * Speech recognition will continue unless otherwise configured.
     * @member ResultReason.RecognizedKeyword
     */ ResultReason[ResultReason["RecognizedKeyword"] = 4] = "RecognizedKeyword";
    /**
     * Indicates the intent result contains hypothesis text and intent.
     * @member ResultReason.RecognizingIntent
     */ ResultReason[ResultReason["RecognizingIntent"] = 5] = "RecognizingIntent";
    /**
     * Indicates the intent result contains final text and intent.
     * Speech Recognition and Intent determination are now complete for this phrase.
     * @member ResultReason.RecognizedIntent
     */ ResultReason[ResultReason["RecognizedIntent"] = 6] = "RecognizedIntent";
    /**
     * Indicates the translation result contains hypothesis text and its translation(s).
     * @member ResultReason.TranslatingSpeech
     */ ResultReason[ResultReason["TranslatingSpeech"] = 7] = "TranslatingSpeech";
    /**
     * Indicates the translation result contains final text and corresponding translation(s).
     * Speech Recognition and Translation are now complete for this phrase.
     * @member ResultReason.TranslatedSpeech
     */ ResultReason[ResultReason["TranslatedSpeech"] = 8] = "TranslatedSpeech";
    /**
     * Indicates the synthesized audio result contains a non-zero amount of audio data
     * @member ResultReason.SynthesizingAudio
     */ ResultReason[ResultReason["SynthesizingAudio"] = 9] = "SynthesizingAudio";
    /**
     * Indicates the synthesized audio is now complete for this phrase.
     * @member ResultReason.SynthesizingAudioCompleted
     */ ResultReason[ResultReason["SynthesizingAudioCompleted"] = 10] = "SynthesizingAudioCompleted";
    /**
     * Indicates the speech synthesis is now started
     * @member ResultReason.SynthesizingAudioStarted
     */ ResultReason[ResultReason["SynthesizingAudioStarted"] = 11] = "SynthesizingAudioStarted";
    /**
     * Indicates the voice profile is being enrolled and customers need to send more audio to create a voice profile.
     * @member ResultReason.EnrollingVoiceProfile
     */ ResultReason[ResultReason["EnrollingVoiceProfile"] = 12] = "EnrollingVoiceProfile";
    /**
     * Indicates the voice profile has been enrolled.
     * @member ResultReason.EnrolledVoiceProfile
     */ ResultReason[ResultReason["EnrolledVoiceProfile"] = 13] = "EnrolledVoiceProfile";
    /**
     * Indicates successful identification of some speakers.
     * @member ResultReason.RecognizedSpeakers
     */ ResultReason[ResultReason["RecognizedSpeakers"] = 14] = "RecognizedSpeakers";
    /**
     * Indicates successfully verified one speaker.
     * @member ResultReason.RecognizedSpeaker
     */ ResultReason[ResultReason["RecognizedSpeaker"] = 15] = "RecognizedSpeaker";
    /**
     * Indicates a voice profile has been reset successfully.
     * @member ResultReason.ResetVoiceProfile
     */ ResultReason[ResultReason["ResetVoiceProfile"] = 16] = "ResetVoiceProfile";
    /**
     * Indicates a voice profile has been deleted successfully.
     * @member ResultReason.DeletedVoiceProfile
     */ ResultReason[ResultReason["DeletedVoiceProfile"] = 17] = "DeletedVoiceProfile";
})($9c34bb9baf1bcf50$export$3527eaa7db1a45df || ($9c34bb9baf1bcf50$export$3527eaa7db1a45df = {}));

});


parcelRequire.register("15fen", function(module, exports) {

$parcel$export(module.exports, "SynthesisStatus", () => $0ca212981e39ddb0$export$7be11a9ec645348f);
$parcel$export(module.exports, "RecognitionStatus", () => $0ca212981e39ddb0$export$9eb5d8ff1b75c8c9);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
/**
 * @class SynthesisStatus
 * @private
 */ var $0ca212981e39ddb0$export$7be11a9ec645348f;
(function(SynthesisStatus) {
    /**
     * The response contains valid audio data.
     * @member SynthesisStatus.Success
     */ SynthesisStatus[SynthesisStatus["Success"] = 0] = "Success";
    /**
     * Indicates the end of audio data. No valid audio data is included in the message.
     * @member SynthesisStatus.SynthesisEnd
     */ SynthesisStatus[SynthesisStatus["SynthesisEnd"] = 1] = "SynthesisEnd";
    /**
     * Indicates an error occurred during synthesis data processing.
     * @member SynthesisStatus.Error
     */ SynthesisStatus[SynthesisStatus["Error"] = 2] = "Error";
})($0ca212981e39ddb0$export$7be11a9ec645348f || ($0ca212981e39ddb0$export$7be11a9ec645348f = {}));
var $0ca212981e39ddb0$export$9eb5d8ff1b75c8c9;
(function(RecognitionStatus) {
    RecognitionStatus[RecognitionStatus["Success"] = 0] = "Success";
    RecognitionStatus[RecognitionStatus["NoMatch"] = 1] = "NoMatch";
    RecognitionStatus[RecognitionStatus["InitialSilenceTimeout"] = 2] = "InitialSilenceTimeout";
    RecognitionStatus[RecognitionStatus["BabbleTimeout"] = 3] = "BabbleTimeout";
    RecognitionStatus[RecognitionStatus["Error"] = 4] = "Error";
    RecognitionStatus[RecognitionStatus["EndOfDictation"] = 5] = "EndOfDictation";
    RecognitionStatus[RecognitionStatus["TooManyRequests"] = 6] = "TooManyRequests";
})($0ca212981e39ddb0$export$9eb5d8ff1b75c8c9 || ($0ca212981e39ddb0$export$9eb5d8ff1b75c8c9 = {}));

});

parcelRequire.register("kGC9p", function(module, exports) {

$parcel$export(module.exports, "TranslationSynthesisEnd", () => $f0f552daa64af03b$export$3de8adee428d019);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
parcelRequire("g6k3z");
var $15fen = parcelRequire("15fen");
class $f0f552daa64af03b$export$3de8adee428d019 {
    constructor(json){
        this.privSynthesisEnd = JSON.parse(json);
        this.privSynthesisEnd.SynthesisStatus = (0, $15fen.SynthesisStatus)[this.privSynthesisEnd.SynthesisStatus];
    }
    static fromJSON(json) {
        return new $f0f552daa64af03b$export$3de8adee428d019(json);
    }
    get SynthesisStatus() {
        return this.privSynthesisEnd.SynthesisStatus;
    }
    get FailureReason() {
        return this.privSynthesisEnd.FailureReason;
    }
}

});

parcelRequire.register("9g1Bf", function(module, exports) {

$parcel$export(module.exports, "TranslationHypothesis", () => $6bd6d95d1a43e8db$export$1c96cbc019746d38);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.

var $gzURB = parcelRequire("gzURB");
class $6bd6d95d1a43e8db$export$1c96cbc019746d38 {
    constructor(json){
        this.privTranslationHypothesis = JSON.parse(json);
        this.privTranslationHypothesis.Translation.TranslationStatus = (0, $gzURB.TranslationStatus)[this.privTranslationHypothesis.Translation.TranslationStatus];
    }
    static fromJSON(json) {
        return new $6bd6d95d1a43e8db$export$1c96cbc019746d38(json);
    }
    get Duration() {
        return this.privTranslationHypothesis.Duration;
    }
    get Offset() {
        return this.privTranslationHypothesis.Offset;
    }
    get Text() {
        return this.privTranslationHypothesis.Text;
    }
    get Translation() {
        return this.privTranslationHypothesis.Translation;
    }
}

});

parcelRequire.register("3bITd", function(module, exports) {

$parcel$export(module.exports, "TranslationPhrase", () => $252538553cf03897$export$cc005ab76f972fce);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
parcelRequire("g6k3z");
var $15fen = parcelRequire("15fen");

var $gzURB = parcelRequire("gzURB");
class $252538553cf03897$export$cc005ab76f972fce {
    constructor(json){
        this.privTranslationPhrase = JSON.parse(json);
        this.privTranslationPhrase.RecognitionStatus = (0, $15fen.RecognitionStatus)[this.privTranslationPhrase.RecognitionStatus];
        if (this.privTranslationPhrase.Translation !== undefined) this.privTranslationPhrase.Translation.TranslationStatus = (0, $gzURB.TranslationStatus)[this.privTranslationPhrase.Translation.TranslationStatus];
    }
    static fromJSON(json) {
        return new $252538553cf03897$export$cc005ab76f972fce(json);
    }
    get RecognitionStatus() {
        return this.privTranslationPhrase.RecognitionStatus;
    }
    get Offset() {
        return this.privTranslationPhrase.Offset;
    }
    get Duration() {
        return this.privTranslationPhrase.Duration;
    }
    get Text() {
        return this.privTranslationPhrase.Text;
    }
    get Translation() {
        return this.privTranslationPhrase.Translation;
    }
}

});

parcelRequire.register("3xfJT", function(module, exports) {
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
parcelRequire("3KVS5");
var $4gz8B = parcelRequire("4gz8B");
var $gzURB = parcelRequire("gzURB");

var $8g0TV = parcelRequire("8g0TV");
var $GCsZL = parcelRequire("GCsZL");
var $eDSF6 = parcelRequire("eDSF6");
var $jJjdG = parcelRequire("jJjdG");
var $dptOd = parcelRequire("dptOd");
var $1Cc6a = parcelRequire("1Cc6a");
var $cDkPt = parcelRequire("cDkPt");
var $7T042 = parcelRequire("7T042");
var $gIFpF = parcelRequire("gIFpF");
var $fYaP3 = parcelRequire("fYaP3");
var $dBIeC = parcelRequire("dBIeC");
parcelRequire("g6k3z");
var $9g1Bf = parcelRequire("9g1Bf");
var $3bITd = parcelRequire("3bITd");
var $15fen = parcelRequire("15fen");
var $28Rmc = parcelRequire("28Rmc");
var $kGC9p = parcelRequire("kGC9p");
var $g6k3z = parcelRequire("g6k3z");
var $ldYFi = parcelRequire("ldYFi");
var $2930a9a77d3b2c3b$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
class $2930a9a77d3b2c3b$export$bf332edf125f0dc6 extends (0, $ldYFi.ServiceRecognizerBase) {
    constructor(authentication, connectionFactory, audioSource, recognizerConfig, translationRecognizer){
        super(authentication, connectionFactory, audioSource, recognizerConfig, translationRecognizer);
        this.privTranslationRecognizer = translationRecognizer;
        this.connectionEvents.attach((connectionEvent)=>$2930a9a77d3b2c3b$var$__awaiter(this, void 0, void 0, function*() {
                if (connectionEvent.name === "ConnectionEstablishedEvent") this.privTranslationRecognizer.onConnection();
                else if (connectionEvent.name === "ConnectionClosedEvent") yield this.privTranslationRecognizer.onDisconnection();
            }));
    }
    processTypeSpecificMessages(connectionMessage) {
        return $2930a9a77d3b2c3b$var$__awaiter(this, void 0, void 0, function*() {
            const resultProps = new (0, $eDSF6.PropertyCollection)();
            let processed = false;
            if (connectionMessage.messageType === (0, $4gz8B.MessageType).Text) resultProps.setProperty((0, $jJjdG.PropertyId).SpeechServiceResponse_JsonResult, connectionMessage.textBody);
            switch(connectionMessage.path.toLowerCase()){
                case "translation.hypothesis":
                    const result = this.fireEventForResult((0, $9g1Bf.TranslationHypothesis).fromJSON(connectionMessage.textBody), resultProps);
                    this.privRequestSession.onHypothesis(this.privRequestSession.currentTurnAudioOffset + result.offset);
                    if (!!this.privTranslationRecognizer.recognizing) try {
                        this.privTranslationRecognizer.recognizing(this.privTranslationRecognizer, result);
                    /* tslint:disable:no-empty */ } catch (error) {
                    // Not going to let errors in the event handler
                    // trip things up.
                    }
                    processed = true;
                    break;
                case "translation.phrase":
                    const translatedPhrase = (0, $3bITd.TranslationPhrase).fromJSON(connectionMessage.textBody);
                    this.privRequestSession.onPhraseRecognized(this.privRequestSession.currentTurnAudioOffset + translatedPhrase.Offset + translatedPhrase.Duration);
                    if (translatedPhrase.RecognitionStatus === (0, $15fen.RecognitionStatus).Success) {
                        // OK, the recognition was successful. How'd the translation do?
                        const result = this.fireEventForResult(translatedPhrase, resultProps);
                        if (!!this.privTranslationRecognizer.recognized) try {
                            this.privTranslationRecognizer.recognized(this.privTranslationRecognizer, result);
                        /* tslint:disable:no-empty */ } catch (error) {
                        // Not going to let errors in the event handler
                        // trip things up.
                        }
                        // report result to promise.
                        if (!!this.privSuccessCallback) {
                            try {
                                this.privSuccessCallback(result.result);
                            } catch (e) {
                                if (!!this.privErrorCallback) this.privErrorCallback(e);
                            }
                            // Only invoke the call back once.
                            // and if it's successful don't invoke the
                            // error after that.
                            this.privSuccessCallback = undefined;
                            this.privErrorCallback = undefined;
                        }
                        break;
                    } else {
                        const reason = (0, $28Rmc.EnumTranslation).implTranslateRecognitionResult(translatedPhrase.RecognitionStatus);
                        const result = new (0, $7T042.TranslationRecognitionResult)(undefined, this.privRequestSession.requestId, reason, translatedPhrase.Text, translatedPhrase.Duration, this.privRequestSession.currentTurnAudioOffset + translatedPhrase.Offset, undefined, connectionMessage.textBody, resultProps);
                        if (reason === (0, $dptOd.ResultReason).Canceled) {
                            const cancelReason = (0, $28Rmc.EnumTranslation).implTranslateCancelResult(translatedPhrase.RecognitionStatus);
                            yield this.cancelRecognitionLocal(cancelReason, (0, $28Rmc.EnumTranslation).implTranslateCancelErrorCode(translatedPhrase.RecognitionStatus), undefined);
                        } else {
                            if (!(this.privRequestSession.isSpeechEnded && reason === (0, $dptOd.ResultReason).NoMatch && translatedPhrase.RecognitionStatus !== (0, $15fen.RecognitionStatus).InitialSilenceTimeout)) {
                                const ev = new (0, $cDkPt.TranslationRecognitionEventArgs)(result, result.offset, this.privRequestSession.sessionId);
                                if (!!this.privTranslationRecognizer.recognized) try {
                                    this.privTranslationRecognizer.recognized(this.privTranslationRecognizer, ev);
                                /* tslint:disable:no-empty */ } catch (error) {
                                // Not going to let errors in the event handler
                                // trip things up.
                                }
                            }
                            // report result to promise.
                            if (!!this.privSuccessCallback) {
                                try {
                                    this.privSuccessCallback(result);
                                } catch (e) {
                                    if (!!this.privErrorCallback) this.privErrorCallback(e);
                                }
                                // Only invoke the call back once.
                                // and if it's successful don't invoke the
                                // error after that.
                                this.privSuccessCallback = undefined;
                                this.privErrorCallback = undefined;
                            }
                        }
                    }
                    processed = true;
                    break;
                case "translation.synthesis":
                    this.sendSynthesisAudio(connectionMessage.binaryBody, this.privRequestSession.sessionId);
                    processed = true;
                    break;
                case "translation.synthesis.end":
                    const synthEnd = (0, $kGC9p.TranslationSynthesisEnd).fromJSON(connectionMessage.textBody);
                    switch(synthEnd.SynthesisStatus){
                        case (0, $15fen.SynthesisStatus).Error:
                            if (!!this.privTranslationRecognizer.synthesizing) {
                                const result = new (0, $dBIeC.TranslationSynthesisResult)((0, $dptOd.ResultReason).Canceled, undefined);
                                const retEvent = new (0, $fYaP3.TranslationSynthesisEventArgs)(result, this.privRequestSession.sessionId);
                                try {
                                    this.privTranslationRecognizer.synthesizing(this.privTranslationRecognizer, retEvent);
                                /* tslint:disable:no-empty */ } catch (error) {
                                // Not going to let errors in the event handler
                                // trip things up.
                                }
                            }
                            if (!!this.privTranslationRecognizer.canceled) {
                                // And raise a canceled event to send the rich(er) error message back.
                                const canceledResult = new (0, $1Cc6a.TranslationRecognitionCanceledEventArgs)(this.privRequestSession.sessionId, (0, $GCsZL.CancellationReason).Error, synthEnd.FailureReason, (0, $8g0TV.CancellationErrorCode).ServiceError, null);
                                try {
                                    this.privTranslationRecognizer.canceled(this.privTranslationRecognizer, canceledResult);
                                /* tslint:disable:no-empty */ } catch (error) {
                                // Not going to let errors in the event handler
                                // trip things up.
                                }
                            }
                            break;
                        case (0, $15fen.SynthesisStatus).Success:
                            this.sendSynthesisAudio(undefined, this.privRequestSession.sessionId);
                            break;
                        default:
                            break;
                    }
                    processed = true;
                    break;
                default:
                    break;
            }
            return processed;
        });
    }
    // Cancels recognition.
    cancelRecognition(sessionId, requestId, cancellationReason, errorCode, error) {
        const properties = new (0, $eDSF6.PropertyCollection)();
        properties.setProperty((0, $g6k3z.CancellationErrorCodePropertyName), (0, $8g0TV.CancellationErrorCode)[errorCode]);
        if (!!this.privTranslationRecognizer.canceled) {
            const cancelEvent = new (0, $1Cc6a.TranslationRecognitionCanceledEventArgs)(sessionId, cancellationReason, error, errorCode, undefined);
            try {
                this.privTranslationRecognizer.canceled(this.privTranslationRecognizer, cancelEvent);
            /* tslint:disable:no-empty */ } catch (_a) {}
        }
        if (!!this.privSuccessCallback) {
            const result = new (0, $7T042.TranslationRecognitionResult)(undefined, requestId, (0, $dptOd.ResultReason).Canceled, undefined, undefined, undefined, error, undefined, properties);
            try {
                this.privSuccessCallback(result);
                /* tslint:disable:no-empty */ this.privSuccessCallback = undefined;
            } catch (_b) {}
        }
    }
    fireEventForResult(serviceResult, properties) {
        let translations;
        if (undefined !== serviceResult.Translation.Translations) {
            translations = new (0, $gIFpF.Translations)();
            for (const translation of serviceResult.Translation.Translations)translations.set(translation.Language, translation.Text);
        }
        let resultReason;
        if (serviceResult instanceof (0, $3bITd.TranslationPhrase)) {
            if (serviceResult.Translation.TranslationStatus === (0, $gzURB.TranslationStatus).Success) resultReason = (0, $dptOd.ResultReason).TranslatedSpeech;
            else resultReason = (0, $dptOd.ResultReason).RecognizedSpeech;
        } else resultReason = (0, $dptOd.ResultReason).TranslatingSpeech;
        const offset = serviceResult.Offset + this.privRequestSession.currentTurnAudioOffset;
        const result = new (0, $7T042.TranslationRecognitionResult)(translations, this.privRequestSession.requestId, resultReason, serviceResult.Text, serviceResult.Duration, offset, serviceResult.Translation.FailureReason, JSON.stringify(serviceResult), properties);
        const ev = new (0, $cDkPt.TranslationRecognitionEventArgs)(result, offset, this.privRequestSession.sessionId);
        return ev;
    }
    sendSynthesisAudio(audio, sessionId) {
        const reason = undefined === audio ? (0, $dptOd.ResultReason).SynthesizingAudioCompleted : (0, $dptOd.ResultReason).SynthesizingAudio;
        const result = new (0, $dBIeC.TranslationSynthesisResult)(reason, audio);
        const retEvent = new (0, $fYaP3.TranslationSynthesisEventArgs)(result, sessionId);
        if (!!this.privTranslationRecognizer.synthesizing) try {
            this.privTranslationRecognizer.synthesizing(this.privTranslationRecognizer, retEvent);
        /* tslint:disable:no-empty */ } catch (error) {
        // Not going to let errors in the event handler
        // trip things up.
        }
    }
}

});
parcelRequire.register("eDSF6", function(module, exports) {

$parcel$export(module.exports, "PropertyCollection", () => $aa8f1bee4c6d3226$export$a9938bacf0fbb927);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.

var $jJjdG = parcelRequire("jJjdG");
class $aa8f1bee4c6d3226$export$a9938bacf0fbb927 {
    constructor(){
        this.privKeys = [];
        this.privValues = [];
    }
    /**
     * Returns the property value in type String. The parameter must have the same type as String.
     * Currently only String, int and bool are allowed.
     * If the name is not available, the specified defaultValue is returned.
     * @member PropertyCollection.prototype.getProperty
     * @function
     * @public
     * @param {string} key - The parameter name.
     * @param {string} def - The default value which is returned if the parameter
     *        is not available in the collection.
     * @returns {string} value of the parameter.
     */ getProperty(key, def) {
        let keyToUse;
        if (typeof key === "string") keyToUse = key;
        else keyToUse = (0, $jJjdG.PropertyId)[key];
        for(let n = 0; n < this.privKeys.length; n++){
            if (this.privKeys[n] === keyToUse) return this.privValues[n];
        }
        return def;
    }
    /**
     * Sets the String value of the parameter specified by name.
     * @member PropertyCollection.prototype.setProperty
     * @function
     * @public
     * @param {string} key - The parameter name.
     * @param {string} value - The value of the parameter.
     */ setProperty(key, value) {
        let keyToUse;
        if (typeof key === "string") keyToUse = key;
        else keyToUse = (0, $jJjdG.PropertyId)[key];
        for(let n = 0; n < this.privKeys.length; n++)if (this.privKeys[n] === keyToUse) {
            this.privValues[n] = value;
            return;
        }
        this.privKeys.push(keyToUse);
        this.privValues.push(value);
    }
    /**
     * Clones the collection.
     * @member PropertyCollection.prototype.clone
     * @function
     * @public
     * @returns {PropertyCollection} A copy of the collection.
     */ clone() {
        const clonedMap = new $aa8f1bee4c6d3226$export$a9938bacf0fbb927();
        for(let n = 0; n < this.privKeys.length; n++){
            clonedMap.privKeys.push(this.privKeys[n]);
            clonedMap.privValues.push(this.privValues[n]);
        }
        return clonedMap;
    }
    /**
     * Merges this set of properties into another, no overwrites.
     * @member PropertyCollection.prototype.mergeTo
     * @function
     * @public
     * @param {PropertyCollection} The collection to merge into.
     */ mergeTo(destinationCollection) {
        this.privKeys.forEach((key)=>{
            if (destinationCollection.getProperty(key, undefined) === undefined) {
                const value = this.getProperty(key);
                destinationCollection.setProperty(key, value);
            }
        });
    }
}

});

parcelRequire.register("1Cc6a", function(module, exports) {

$parcel$export(module.exports, "TranslationRecognitionCanceledEventArgs", () => $12d2b98cc874db5d$export$99f29a98babb31f);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
/**
 * Define payload of speech recognition canceled result events.
 * @class TranslationRecognitionCanceledEventArgs
 */ class $12d2b98cc874db5d$export$99f29a98babb31f {
    /**
     * Creates and initializes an instance of this class.
     * @constructor
     * @param {string} sessionid - The session id.
     * @param {CancellationReason} cancellationReason - The cancellation reason.
     * @param {string} errorDetails - Error details, if provided.
     * @param {TranslationRecognitionResult} result - The result.
     */ constructor(sessionid, cancellationReason, errorDetails, errorCode, result){
        this.privCancelReason = cancellationReason;
        this.privErrorDetails = errorDetails;
        this.privResult = result;
        this.privSessionId = sessionid;
        this.privErrorCode = errorCode;
    }
    /**
     * Specifies the recognition result.
     * @member TranslationRecognitionCanceledEventArgs.prototype.result
     * @function
     * @public
     * @returns {TranslationRecognitionResult} the recognition result.
     */ get result() {
        return this.privResult;
    }
    /**
     * Specifies the session identifier.
     * @member TranslationRecognitionCanceledEventArgs.prototype.sessionId
     * @function
     * @public
     * @returns {string} the session identifier.
     */ get sessionId() {
        return this.privSessionId;
    }
    /**
     * The reason the recognition was canceled.
     * @member TranslationRecognitionCanceledEventArgs.prototype.reason
     * @function
     * @public
     * @returns {CancellationReason} Specifies the reason canceled.
     */ get reason() {
        return this.privCancelReason;
    }
    /**
     * The error code in case of an unsuccessful recognition.
     * Added in version 1.1.0.
     * @return An error code that represents the error reason.
     */ get errorCode() {
        return this.privErrorCode;
    }
    /**
     * In case of an unsuccessful recognition, provides details of the occurred error.
     * @member TranslationRecognitionCanceledEventArgs.prototype.errorDetails
     * @function
     * @public
     * @returns {string} A String that represents the error details.
     */ get errorDetails() {
        return this.privErrorDetails;
    }
}

});

parcelRequire.register("cDkPt", function(module, exports) {

$parcel$export(module.exports, "TranslationRecognitionEventArgs", () => $932948d07aebe798$export$3d30fcebb19c1429);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.

var $lst3T = parcelRequire("lst3T");
class $932948d07aebe798$export$3d30fcebb19c1429 extends (0, $lst3T.RecognitionEventArgs) {
    /**
     * Creates and initializes an instance of this class.
     * @constructor
     * @param {TranslationRecognitionResult} result - The translation recognition result.
     * @param {number} offset - The offset.
     * @param {string} sessionId - The session id.
     */ constructor(result, offset, sessionId){
        super(offset, sessionId);
        this.privResult = result;
    }
    /**
     * Specifies the recognition result.
     * @member TranslationRecognitionEventArgs.prototype.result
     * @function
     * @public
     * @returns {TranslationRecognitionResult} the recognition result.
     */ get result() {
        return this.privResult;
    }
}

});

parcelRequire.register("7T042", function(module, exports) {

$parcel$export(module.exports, "TranslationRecognitionResult", () => $5bddb831e09d5e60$export$a82ef3e7bb29fe5f);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.

var $cBVoI = parcelRequire("cBVoI");
class $5bddb831e09d5e60$export$a82ef3e7bb29fe5f extends (0, $cBVoI.SpeechRecognitionResult) {
    /**
     * Creates and initializes an instance of this class.
     * @constructor
     * @param {Translations} translations - The translations.
     * @param {string} resultId - The result id.
     * @param {ResultReason} reason - The reason.
     * @param {string} text - The recognized text.
     * @param {number} duration - The duration.
     * @param {number} offset - The offset into the stream.
     * @param {string} errorDetails - Error details, if provided.
     * @param {string} json - Additional Json, if provided.
     * @param {PropertyCollection} properties - Additional properties, if provided.
     */ constructor(translations, resultId, reason, text, duration, offset, errorDetails, json, properties){
        super(resultId, reason, text, duration, offset, undefined, undefined, undefined, errorDetails, json, properties);
        this.privTranslations = translations;
    }
    /**
     * Presents the translation results. Each item in the dictionary represents
     * a translation result in one of target languages, where the key is the name
     * of the target language, in BCP-47 format, and the value is the translation
     * text in the specified language.
     * @member TranslationRecognitionResult.prototype.translations
     * @function
     * @public
     * @returns {Translations} the current translation map that holds all translations requested.
     */ get translations() {
        return this.privTranslations;
    }
}

});
parcelRequire.register("cBVoI", function(module, exports) {

$parcel$export(module.exports, "SpeechRecognitionResult", () => $92e576bb2bc5764d$export$e41fbbd40b4d7802);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.

var $1I7tF = parcelRequire("1I7tF");
class $92e576bb2bc5764d$export$e41fbbd40b4d7802 extends (0, $1I7tF.RecognitionResult) {
    /**
     * Creates and initializes an instance of this class.
     * @constructor
     * @public
     * @param {string} resultId - The result id.
     * @param {ResultReason} reason - The reason.
     * @param {string} text - The recognized text.
     * @param {number} duration - The duration.
     * @param {number} offset - The offset into the stream.
     * @param {string} language - Primary Language detected, if provided.
     * @param {string} languageDetectionConfidence - Primary Language confidence ("Unknown," "Low," "Medium," "High"...), if provided.
     * @param {string} speakerId - speaker id for conversation transcription, if provided.
     * @param {string} errorDetails - Error details, if provided.
     * @param {string} json - Additional Json, if provided.
     * @param {PropertyCollection} properties - Additional properties, if provided.
     */ constructor(resultId, reason, text, duration, offset, language, languageDetectionConfidence, speakerId, errorDetails, json, properties){
        super(resultId, reason, text, duration, offset, language, languageDetectionConfidence, errorDetails, json, properties);
        this.privSpeakerId = speakerId;
    }
    /**
     * speaker id from conversation transcription/id scenarios
     * @member SpeechRecognitionResult.prototype.speakerId
     * @function
     * @public
     * @returns {string} id of speaker in given result
     */ get speakerId() {
        return this.privSpeakerId;
    }
}

});
parcelRequire.register("1I7tF", function(module, exports) {

$parcel$export(module.exports, "RecognitionResult", () => $13efb35dfea0f880$export$fbb9fad6e09cd236);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
/**
 * Defines result of speech recognition.
 * @class RecognitionResult
 */ class $13efb35dfea0f880$export$fbb9fad6e09cd236 {
    /**
     * Creates and initializes an instance of this class.
     * @constructor
     * @param {string} resultId - The result id.
     * @param {ResultReason} reason - The reason.
     * @param {string} text - The recognized text.
     * @param {number} duration - The duration.
     * @param {number} offset - The offset into the stream.
     * @param {string} language - Primary Language detected, if provided.
     * @param {string} languageDetectionConfidence - Primary Language confidence ("Unknown," "Low," "Medium," "High"...), if provided.
     * @param {string} errorDetails - Error details, if provided.
     * @param {string} json - Additional Json, if provided.
     * @param {PropertyCollection} properties - Additional properties, if provided.
     */ constructor(resultId, reason, text, duration, offset, language, languageDetectionConfidence, errorDetails, json, properties){
        this.privResultId = resultId;
        this.privReason = reason;
        this.privText = text;
        this.privDuration = duration;
        this.privOffset = offset;
        this.privLanguage = language;
        this.privLanguageDetectionConfidence = languageDetectionConfidence;
        this.privErrorDetails = errorDetails;
        this.privJson = json;
        this.privProperties = properties;
    }
    /**
     * Specifies the result identifier.
     * @member RecognitionResult.prototype.resultId
     * @function
     * @public
     * @returns {string} Specifies the result identifier.
     */ get resultId() {
        return this.privResultId;
    }
    /**
     * Specifies status of the result.
     * @member RecognitionResult.prototype.reason
     * @function
     * @public
     * @returns {ResultReason} Specifies status of the result.
     */ get reason() {
        return this.privReason;
    }
    /**
     * Presents the recognized text in the result.
     * @member RecognitionResult.prototype.text
     * @function
     * @public
     * @returns {string} Presents the recognized text in the result.
     */ get text() {
        return this.privText;
    }
    /**
     * Duration of recognized speech in 100 nano second incements.
     * @member RecognitionResult.prototype.duration
     * @function
     * @public
     * @returns {number} Duration of recognized speech in 100 nano second incements.
     */ get duration() {
        return this.privDuration;
    }
    /**
     * Offset of recognized speech in 100 nano second incements.
     * @member RecognitionResult.prototype.offset
     * @function
     * @public
     * @returns {number} Offset of recognized speech in 100 nano second incements.
     */ get offset() {
        return this.privOffset;
    }
    /**
     * Primary Language detected.
     * @member RecognitionResult.prototype.language
     * @function
     * @public
     * @returns {string} language detected.
     */ get language() {
        return this.privLanguage;
    }
    /**
     * Primary Language detection confidence (Unknown, Low, Medium, High).
     * @member RecognitionResult.prototype.languageDetectionConfidence
     * @function
     * @public
     * @returns {string} detection confidence strength.
     */ get languageDetectionConfidence() {
        return this.privLanguageDetectionConfidence;
    }
    /**
     * In case of an unsuccessful recognition, provides details of the occurred error.
     * @member RecognitionResult.prototype.errorDetails
     * @function
     * @public
     * @returns {string} a brief description of an error.
     */ get errorDetails() {
        return this.privErrorDetails;
    }
    /**
     * A string containing Json serialized recognition result as it was received from the service.
     * @member RecognitionResult.prototype.json
     * @function
     * @private
     * @returns {string} Json serialized representation of the result.
     */ get json() {
        return this.privJson;
    }
    /**
     *  The set of properties exposed in the result.
     * @member RecognitionResult.prototype.properties
     * @function
     * @public
     * @returns {PropertyCollection} The set of properties exposed in the result.
     */ get properties() {
        return this.privProperties;
    }
}

});



parcelRequire.register("gIFpF", function(module, exports) {

$parcel$export(module.exports, "Translations", () => $c2c0e1298395b761$export$1f12680e68c5100d);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.

var $eDSF6 = parcelRequire("eDSF6");
class $c2c0e1298395b761$export$1f12680e68c5100d {
    constructor(){
        // Use an PropertyCollection internally, just wrapping it to hide the | enum syntax it has.
        this.privMap = new (0, $eDSF6.PropertyCollection)();
    }
    /**
     * Returns the parameter value in type String. The parameter must have the same type as String.
     * Currently only String, int and bool are allowed.
     * If the name is not available, the specified defaultValue is returned.
     * @member Translation.prototype.get
     * @function
     * @public
     * @param {string} key - The parameter name.
     * @param {string} def - The default value which is returned if the parameter is not available in the collection.
     * @returns {string} value of the parameter.
     */ get(key, def) {
        return this.privMap.getProperty(key, def);
    }
    /**
     * Sets the String value of the parameter specified by name.
     * @member Translation.prototype.set
     * @function
     * @public
     * @param {string} key - The parameter name.
     * @param {string} value - The value of the parameter.
     */ set(key, value) {
        this.privMap.setProperty(key, value);
    }
}

});

parcelRequire.register("fYaP3", function(module, exports) {

$parcel$export(module.exports, "TranslationSynthesisEventArgs", () => $ba04dabb775c2b03$export$137d31b3848d9c32);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.

var $9Pi8Y = parcelRequire("9Pi8Y");
class $ba04dabb775c2b03$export$137d31b3848d9c32 extends (0, $9Pi8Y.SessionEventArgs) {
    /**
     * Creates and initializes an instance of this class.
     * @constructor
     * @param {TranslationSynthesisResult} result - The translation synthesis result.
     * @param {string} sessionId - The session id.
     */ constructor(result, sessionId){
        super(sessionId);
        this.privResult = result;
    }
    /**
     * Specifies the translation synthesis result.
     * @member TranslationSynthesisEventArgs.prototype.result
     * @function
     * @public
     * @returns {TranslationSynthesisResult} Specifies the translation synthesis result.
     */ get result() {
        return this.privResult;
    }
}

});

parcelRequire.register("dBIeC", function(module, exports) {

$parcel$export(module.exports, "TranslationSynthesisResult", () => $9e810b2cea1388aa$export$17f18d3f3dbd9330);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
/**
 * Defines translation synthesis result, i.e. the voice output of the translated
 * text in the target language.
 * @class TranslationSynthesisResult
 */ class $9e810b2cea1388aa$export$17f18d3f3dbd9330 {
    /**
     * Creates and initializes an instance of this class.
     * @constructor
     * @param {ResultReason} reason - The synthesis reason.
     * @param {ArrayBuffer} audio - The audio data.
     */ constructor(reason, audio){
        this.privReason = reason;
        this.privAudio = audio;
    }
    /**
     * Translated text in the target language.
     * @member TranslationSynthesisResult.prototype.audio
     * @function
     * @public
     * @returns {ArrayBuffer} Translated audio in the target language.
     */ get audio() {
        return this.privAudio;
    }
    /**
     * The synthesis status.
     * @member TranslationSynthesisResult.prototype.reason
     * @function
     * @public
     * @returns {ResultReason} The synthesis status.
     */ get reason() {
        return this.privReason;
    }
}

});


parcelRequire.register("iYdLz", function(module, exports) {

$parcel$export(module.exports, "SpeechDetected", () => $dcf8824c1e14b181$export$fa943fcb498ea779);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
class $dcf8824c1e14b181$export$fa943fcb498ea779 {
    constructor(json){
        this.privSpeechStartDetected = JSON.parse(json);
    }
    static fromJSON(json) {
        return new $dcf8824c1e14b181$export$fa943fcb498ea779(json);
    }
    get Offset() {
        return this.privSpeechStartDetected.Offset;
    }
}

});

parcelRequire.register("QS7Xa", function(module, exports) {

$parcel$export(module.exports, "SpeechHypothesis", () => $09eed7fe4e3a92b3$export$b698b2694660f661);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
class $09eed7fe4e3a92b3$export$b698b2694660f661 {
    constructor(json){
        this.privSpeechHypothesis = JSON.parse(json);
    }
    static fromJSON(json) {
        return new $09eed7fe4e3a92b3$export$b698b2694660f661(json);
    }
    get Text() {
        return this.privSpeechHypothesis.Text;
    }
    get Offset() {
        return this.privSpeechHypothesis.Offset;
    }
    get Duration() {
        return this.privSpeechHypothesis.Duration;
    }
    get Language() {
        return this.privSpeechHypothesis.PrimaryLanguage === undefined ? undefined : this.privSpeechHypothesis.PrimaryLanguage.Language;
    }
    get LanguageDetectionConfidence() {
        return this.privSpeechHypothesis.PrimaryLanguage === undefined ? undefined : this.privSpeechHypothesis.PrimaryLanguage.Confidence;
    }
    get SpeakerId() {
        return this.privSpeechHypothesis.SpeakerId;
    }
}

});

parcelRequire.register("b1X1y", function(module, exports) {

$parcel$export(module.exports, "SpeechKeyword", () => $807d92a5010e5175$export$f0f3620dc9fff52f);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
class $807d92a5010e5175$export$f0f3620dc9fff52f {
    constructor(json){
        this.privSpeechKeyword = JSON.parse(json);
    }
    static fromJSON(json) {
        return new $807d92a5010e5175$export$f0f3620dc9fff52f(json);
    }
    get Status() {
        return this.privSpeechKeyword.Status;
    }
    get Text() {
        return this.privSpeechKeyword.Text;
    }
    get Offset() {
        return this.privSpeechKeyword.Offset;
    }
    get Duration() {
        return this.privSpeechKeyword.Duration;
    }
}

});

parcelRequire.register("o6HDO", function(module, exports) {
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.

var $8g0TV = parcelRequire("8g0TV");
var $5tg4o = parcelRequire("5tg4o");
var $eDSF6 = parcelRequire("eDSF6");
var $jJjdG = parcelRequire("jJjdG");
var $dptOd = parcelRequire("dptOd");
var $b9O7R = parcelRequire("b9O7R");
var $evfM9 = parcelRequire("evfM9");
var $cBVoI = parcelRequire("cBVoI");
parcelRequire("g6k3z");
var $QS7Xa = parcelRequire("QS7Xa");
var $9HHlE = parcelRequire("9HHlE");
var $28Rmc = parcelRequire("28Rmc");
var $15fen = parcelRequire("15fen");
var $g6k3z = parcelRequire("g6k3z");
var $2FaWH = parcelRequire("2FaWH");
var $ldYFi = parcelRequire("ldYFi");
var $0487710f5da598c4$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
class $0487710f5da598c4$export$ed87a00dda91f8bd extends (0, $ldYFi.ServiceRecognizerBase) {
    constructor(authentication, connectionFactory, audioSource, recognizerConfig, speechRecognizer){
        super(authentication, connectionFactory, audioSource, recognizerConfig, speechRecognizer);
        this.privSpeechRecognizer = speechRecognizer;
        if (recognizerConfig.autoDetectSourceLanguages !== undefined) {
            const sourceLanguages = recognizerConfig.autoDetectSourceLanguages.split(",");
            this.privSpeechContext.setSection("languageId", {
                languages: sourceLanguages,
                onSuccess: {
                    action: "Recognize"
                },
                onUnknown: {
                    action: "None"
                }
            });
            this.privSpeechContext.setSection("phraseOutput", {
                interimResults: {
                    resultType: "Auto"
                },
                phraseResults: {
                    resultType: "Always"
                }
            });
        }
    }
    processTypeSpecificMessages(connectionMessage) {
        return $0487710f5da598c4$var$__awaiter(this, void 0, void 0, function*() {
            let result;
            const resultProps = new (0, $eDSF6.PropertyCollection)();
            resultProps.setProperty((0, $jJjdG.PropertyId).SpeechServiceResponse_JsonResult, connectionMessage.textBody);
            let processed = false;
            switch(connectionMessage.path.toLowerCase()){
                case "speech.hypothesis":
                case "speech.fragment":
                    const hypothesis = (0, $QS7Xa.SpeechHypothesis).fromJSON(connectionMessage.textBody);
                    const offset = hypothesis.Offset + this.privRequestSession.currentTurnAudioOffset;
                    result = new (0, $cBVoI.SpeechRecognitionResult)(this.privRequestSession.requestId, (0, $dptOd.ResultReason).RecognizingSpeech, hypothesis.Text, hypothesis.Duration, offset, hypothesis.Language, hypothesis.LanguageDetectionConfidence, undefined, undefined, connectionMessage.textBody, resultProps);
                    this.privRequestSession.onHypothesis(offset);
                    const ev = new (0, $evfM9.SpeechRecognitionEventArgs)(result, hypothesis.Duration, this.privRequestSession.sessionId);
                    if (!!this.privSpeechRecognizer.recognizing) try {
                        this.privSpeechRecognizer.recognizing(this.privSpeechRecognizer, ev);
                    /* tslint:disable:no-empty */ } catch (error) {
                    // Not going to let errors in the event handler
                    // trip things up.
                    }
                    processed = true;
                    break;
                case "speech.phrase":
                    const simple = (0, $9HHlE.SimpleSpeechPhrase).fromJSON(connectionMessage.textBody);
                    const resultReason = (0, $28Rmc.EnumTranslation).implTranslateRecognitionResult(simple.RecognitionStatus);
                    this.privRequestSession.onPhraseRecognized(this.privRequestSession.currentTurnAudioOffset + simple.Offset + simple.Duration);
                    if ((0, $dptOd.ResultReason).Canceled === resultReason) {
                        const cancelReason = (0, $28Rmc.EnumTranslation).implTranslateCancelResult(simple.RecognitionStatus);
                        yield this.cancelRecognitionLocal(cancelReason, (0, $28Rmc.EnumTranslation).implTranslateCancelErrorCode(simple.RecognitionStatus), undefined);
                    } else {
                        if (!(this.privRequestSession.isSpeechEnded && resultReason === (0, $dptOd.ResultReason).NoMatch && simple.RecognitionStatus !== (0, $15fen.RecognitionStatus).InitialSilenceTimeout)) {
                            if (this.privRecognizerConfig.parameters.getProperty((0, $g6k3z.OutputFormatPropertyName)) === (0, $5tg4o.OutputFormat)[(0, $5tg4o.OutputFormat).Simple]) result = new (0, $cBVoI.SpeechRecognitionResult)(this.privRequestSession.requestId, resultReason, simple.DisplayText, simple.Duration, simple.Offset + this.privRequestSession.currentTurnAudioOffset, simple.Language, simple.LanguageDetectionConfidence, undefined, undefined, connectionMessage.textBody, resultProps);
                            else {
                                const detailed = (0, $2FaWH.DetailedSpeechPhrase).fromJSON(connectionMessage.textBody);
                                result = new (0, $cBVoI.SpeechRecognitionResult)(this.privRequestSession.requestId, resultReason, detailed.RecognitionStatus === (0, $15fen.RecognitionStatus).Success ? detailed.NBest[0].Display : undefined, detailed.Duration, detailed.Offset + this.privRequestSession.currentTurnAudioOffset, detailed.Language, detailed.LanguageDetectionConfidence, undefined, undefined, connectionMessage.textBody, resultProps);
                            }
                            const event = new (0, $evfM9.SpeechRecognitionEventArgs)(result, result.offset, this.privRequestSession.sessionId);
                            if (!!this.privSpeechRecognizer.recognized) try {
                                this.privSpeechRecognizer.recognized(this.privSpeechRecognizer, event);
                            /* tslint:disable:no-empty */ } catch (error) {
                            // Not going to let errors in the event handler
                            // trip things up.
                            }
                        }
                        if (!!this.privSuccessCallback) {
                            try {
                                this.privSuccessCallback(result);
                            } catch (e) {
                                if (!!this.privErrorCallback) this.privErrorCallback(e);
                            }
                            // Only invoke the call back once.
                            // and if it's successful don't invoke the
                            // error after that.
                            this.privSuccessCallback = undefined;
                            this.privErrorCallback = undefined;
                        }
                    }
                    processed = true;
                    break;
                default:
                    break;
            }
            return processed;
        });
    }
    // Cancels recognition.
    cancelRecognition(sessionId, requestId, cancellationReason, errorCode, error) {
        const properties = new (0, $eDSF6.PropertyCollection)();
        properties.setProperty((0, $g6k3z.CancellationErrorCodePropertyName), (0, $8g0TV.CancellationErrorCode)[errorCode]);
        if (!!this.privSpeechRecognizer.canceled) {
            const cancelEvent = new (0, $b9O7R.SpeechRecognitionCanceledEventArgs)(cancellationReason, error, errorCode, undefined, sessionId);
            try {
                this.privSpeechRecognizer.canceled(this.privSpeechRecognizer, cancelEvent);
            /* tslint:disable:no-empty */ } catch (_a) {}
        }
        if (!!this.privSuccessCallback) {
            const result = new (0, $cBVoI.SpeechRecognitionResult)(requestId, (0, $dptOd.ResultReason).Canceled, undefined, undefined, undefined, undefined, undefined, undefined, error, undefined, properties);
            try {
                this.privSuccessCallback(result);
                this.privSuccessCallback = undefined;
            /* tslint:disable:no-empty */ } catch (_b) {}
        }
    }
}

});
parcelRequire.register("5tg4o", function(module, exports) {

$parcel$export(module.exports, "OutputFormat", () => $3fbc20567c33a74c$export$ed6df354c75a09e0);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
/**
 * Define Speech Recognizer output formats.
 * @class OutputFormat
 */ var $3fbc20567c33a74c$export$ed6df354c75a09e0;
(function(OutputFormat) {
    /**
     * @member OutputFormat.Simple
     */ OutputFormat[OutputFormat["Simple"] = 0] = "Simple";
    /**
     * @member OutputFormat.Detailed
     */ OutputFormat[OutputFormat["Detailed"] = 1] = "Detailed";
})($3fbc20567c33a74c$export$ed6df354c75a09e0 || ($3fbc20567c33a74c$export$ed6df354c75a09e0 = {}));

});

parcelRequire.register("b9O7R", function(module, exports) {

$parcel$export(module.exports, "SpeechRecognitionCanceledEventArgs", () => $81f76aea85a81528$export$15ff9e6d819b9207);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.

var $4AZAD = parcelRequire("4AZAD");
class $81f76aea85a81528$export$15ff9e6d819b9207 extends (0, $4AZAD.CancellationEventArgsBase) {
}

});
parcelRequire.register("4AZAD", function(module, exports) {

$parcel$export(module.exports, "CancellationEventArgsBase", () => $358a4caa4910921b$export$dd228f7536b5286b);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.

var $lst3T = parcelRequire("lst3T");
class $358a4caa4910921b$export$dd228f7536b5286b extends (0, $lst3T.RecognitionEventArgs) {
    /**
     * Creates and initializes an instance of this class.
     * @constructor
     * @param {CancellationReason} reason - The cancellation reason.
     * @param {string} errorDetails - Error details, if provided.
     * @param {number} offset - The offset.
     * @param {string} sessionId - The session id.
     */ constructor(reason, errorDetails, errorCode, offset, sessionId){
        super(offset, sessionId);
        this.privReason = reason;
        this.privErrorDetails = errorDetails;
        this.privErrorCode = errorCode;
    }
    /**
     * The reason the recognition was canceled.
     * @member CancellationEventArgsBase.prototype.reason
     * @function
     * @public
     * @returns {CancellationReason} Specifies the reason canceled.
     */ get reason() {
        return this.privReason;
    }
    /**
     * The error code in case of an unsuccessful operation.
     * @return An error code that represents the error reason.
     */ get errorCode() {
        return this.privErrorCode;
    }
    /**
     * In case of an unsuccessful operation, provides details of the occurred error.
     * @member CancellationEventArgsBase.prototype.errorDetails
     * @function
     * @public
     * @returns {string} A String that represents the error details.
     */ get errorDetails() {
        return this.privErrorDetails;
    }
}

});


parcelRequire.register("evfM9", function(module, exports) {

$parcel$export(module.exports, "SpeechRecognitionEventArgs", () => $a8f032a318c6f7e3$export$a9c37a51b7d8dc18);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.

var $lst3T = parcelRequire("lst3T");
class $a8f032a318c6f7e3$export$a9c37a51b7d8dc18 extends (0, $lst3T.RecognitionEventArgs) {
    /**
     * Creates and initializes an instance of this class.
     * @constructor
     * @param {SpeechRecognitionResult} result - The speech recognition result.
     * @param {number} offset - The offset.
     * @param {string} sessionId - The session id.
     */ constructor(result, offset, sessionId){
        super(offset, sessionId);
        this.privResult = result;
    }
    /**
     * Specifies the recognition result.
     * @member SpeechRecognitionEventArgs.prototype.result
     * @function
     * @public
     * @returns {SpeechRecognitionResult} the recognition result.
     */ get result() {
        return this.privResult;
    }
}
class $a8f032a318c6f7e3$export$bdeacab7c8f9ce49 extends $a8f032a318c6f7e3$export$a9c37a51b7d8dc18 {
}

});


parcelRequire.register("55gfL", function(module, exports) {
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
parcelRequire("3KVS5");
var $4gz8B = parcelRequire("4gz8B");

var $8g0TV = parcelRequire("8g0TV");
var $5raFR = parcelRequire("5raFR");
var $5tg4o = parcelRequire("5tg4o");
var $eDSF6 = parcelRequire("eDSF6");
var $jJjdG = parcelRequire("jJjdG");
var $dptOd = parcelRequire("dptOd");
var $evfM9 = parcelRequire("evfM9");
var $cBVoI = parcelRequire("cBVoI");
parcelRequire("g6k3z");
var $QS7Xa = parcelRequire("QS7Xa");
var $9HHlE = parcelRequire("9HHlE");
var $28Rmc = parcelRequire("28Rmc");
var $15fen = parcelRequire("15fen");
var $g6k3z = parcelRequire("g6k3z");
var $2FaWH = parcelRequire("2FaWH");
var $ldYFi = parcelRequire("ldYFi");

var $MRQbb = parcelRequire("MRQbb");
var $3b3a06ea9a6f8e08$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
class $3b3a06ea9a6f8e08$export$f161eb90b75c9577 extends (0, $ldYFi.ServiceRecognizerBase) {
    constructor(authentication, connectionFactory, audioSource, recognizerConfig, transcriber){
        super(authentication, connectionFactory, audioSource, recognizerConfig, transcriber);
        this.sendSpeechEvent = (connection, payload)=>{
            const speechEventJson = JSON.stringify(payload);
            if (speechEventJson) return connection.send(new (0, $MRQbb.SpeechConnectionMessage)((0, $4gz8B.MessageType).Text, "speech.event", this.privRequestSession.requestId, "application/json", speechEventJson));
            return;
        };
        this.privTranscriberRecognizer = transcriber;
        this.sendPrePayloadJSONOverride = this.sendTranscriptionStartJSON;
    }
    sendSpeechEventAsync(info, command) {
        return $3b3a06ea9a6f8e08$var$__awaiter(this, void 0, void 0, function*() {
            if (!!this.privRequestSession.isRecognizing) {
                const connection = yield this.fetchConnection();
                yield this.sendSpeechEvent(connection, this.createSpeechEventPayload(info, command));
            }
        });
    }
    processTypeSpecificMessages(connectionMessage) {
        return $3b3a06ea9a6f8e08$var$__awaiter(this, void 0, void 0, function*() {
            let result;
            const resultProps = new (0, $eDSF6.PropertyCollection)();
            resultProps.setProperty((0, $jJjdG.PropertyId).SpeechServiceResponse_JsonResult, connectionMessage.textBody);
            let processed = false;
            switch(connectionMessage.path.toLowerCase()){
                case "speech.hypothesis":
                case "speech.fragment":
                    const hypothesis = (0, $QS7Xa.SpeechHypothesis).fromJSON(connectionMessage.textBody);
                    const offset = hypothesis.Offset + this.privRequestSession.currentTurnAudioOffset;
                    result = new (0, $cBVoI.SpeechRecognitionResult)(this.privRequestSession.requestId, (0, $dptOd.ResultReason).RecognizingSpeech, hypothesis.Text, hypothesis.Duration, offset, hypothesis.Language, hypothesis.LanguageDetectionConfidence, hypothesis.SpeakerId, undefined, connectionMessage.textBody, resultProps);
                    this.privRequestSession.onHypothesis(offset);
                    const ev = new (0, $evfM9.SpeechRecognitionEventArgs)(result, hypothesis.Duration, this.privRequestSession.sessionId);
                    if (!!this.privTranscriberRecognizer.recognizing) try {
                        this.privTranscriberRecognizer.recognizing(this.privTranscriberRecognizer, ev);
                    /* tslint:disable:no-empty */ } catch (error) {
                    // Not going to let errors in the event handler
                    // trip things up.
                    }
                    processed = true;
                    break;
                case "speech.phrase":
                    const simple = (0, $9HHlE.SimpleSpeechPhrase).fromJSON(connectionMessage.textBody);
                    const resultReason = (0, $28Rmc.EnumTranslation).implTranslateRecognitionResult(simple.RecognitionStatus);
                    this.privRequestSession.onPhraseRecognized(this.privRequestSession.currentTurnAudioOffset + simple.Offset + simple.Duration);
                    if ((0, $dptOd.ResultReason).Canceled === resultReason) {
                        const cancelReason = (0, $28Rmc.EnumTranslation).implTranslateCancelResult(simple.RecognitionStatus);
                        yield this.cancelRecognitionLocal(cancelReason, (0, $28Rmc.EnumTranslation).implTranslateCancelErrorCode(simple.RecognitionStatus), undefined);
                    } else {
                        if (!(this.privRequestSession.isSpeechEnded && resultReason === (0, $dptOd.ResultReason).NoMatch && simple.RecognitionStatus !== (0, $15fen.RecognitionStatus).InitialSilenceTimeout)) {
                            if (this.privRecognizerConfig.parameters.getProperty((0, $g6k3z.OutputFormatPropertyName)) === (0, $5tg4o.OutputFormat)[(0, $5tg4o.OutputFormat).Simple]) result = new (0, $cBVoI.SpeechRecognitionResult)(this.privRequestSession.requestId, resultReason, simple.DisplayText, simple.Duration, simple.Offset + this.privRequestSession.currentTurnAudioOffset, simple.Language, simple.LanguageDetectionConfidence, simple.SpeakerId, undefined, connectionMessage.textBody, resultProps);
                            else {
                                const detailed = (0, $2FaWH.DetailedSpeechPhrase).fromJSON(connectionMessage.textBody);
                                result = new (0, $cBVoI.SpeechRecognitionResult)(this.privRequestSession.requestId, resultReason, detailed.RecognitionStatus === (0, $15fen.RecognitionStatus).Success ? detailed.NBest[0].Display : undefined, detailed.Duration, detailed.Offset + this.privRequestSession.currentTurnAudioOffset, detailed.Language, detailed.LanguageDetectionConfidence, undefined, undefined, connectionMessage.textBody, resultProps);
                            }
                            const event = new (0, $evfM9.SpeechRecognitionEventArgs)(result, result.offset, this.privRequestSession.sessionId);
                            if (!!this.privTranscriberRecognizer.recognized) try {
                                this.privTranscriberRecognizer.recognized(this.privTranscriberRecognizer, event);
                            /* tslint:disable:no-empty */ } catch (error) {
                            // Not going to let errors in the event handler
                            // trip things up.
                            }
                        }
                        if (!!this.privSuccessCallback) {
                            try {
                                this.privSuccessCallback(result);
                            } catch (e) {
                                if (!!this.privErrorCallback) this.privErrorCallback(e);
                            }
                            // Only invoke the call back once.
                            // and if it's successful don't invoke the
                            // error after that.
                            this.privSuccessCallback = undefined;
                            this.privErrorCallback = undefined;
                        }
                    }
                    processed = true;
                    break;
                default:
                    break;
            }
            return processed;
        });
    }
    // Cancels recognition.
    cancelRecognition(sessionId, requestId, cancellationReason, errorCode, error) {
        const properties = new (0, $eDSF6.PropertyCollection)();
        properties.setProperty((0, $g6k3z.CancellationErrorCodePropertyName), (0, $8g0TV.CancellationErrorCode)[errorCode]);
        if (!!this.privTranscriberRecognizer.canceled) {
            const cancelEvent = new (0, $5raFR.ConversationTranscriptionCanceledEventArgs)(cancellationReason, error, errorCode, undefined, sessionId);
            try {
                this.privTranscriberRecognizer.canceled(this.privTranscriberRecognizer, cancelEvent);
            /* tslint:disable:no-empty */ } catch (_a) {}
        }
        if (!!this.privSuccessCallback) {
            const result = new (0, $cBVoI.SpeechRecognitionResult)(requestId, (0, $dptOd.ResultReason).Canceled, undefined, undefined, undefined, undefined, undefined, undefined, error, undefined, properties);
            try {
                this.privSuccessCallback(result);
                this.privSuccessCallback = undefined;
            /* tslint:disable:no-empty */ } catch (_b) {}
        }
    }
    // Encapsulated for derived service recognizers that need to send additional JSON
    sendTranscriptionStartJSON(connection) {
        return $3b3a06ea9a6f8e08$var$__awaiter(this, void 0, void 0, function*() {
            yield this.sendSpeechContext(connection);
            const info = this.privTranscriberRecognizer.getConversationInfo();
            const payload = this.createSpeechEventPayload(info, "start");
            yield this.sendSpeechEvent(connection, payload);
            yield this.sendWaveHeader(connection);
            return;
        });
    }
    createSpeechEventPayload(info, command) {
        const meeting = "meeting";
        const eventDict = {
            id: meeting,
            name: command,
            meeting: info.conversationProperties
        };
        const idString = "id";
        const attendees = "attendees";
        const record = "record";
        eventDict[meeting][idString] = info.id;
        eventDict[meeting][attendees] = info.participants;
        eventDict[meeting][record] = info.conversationProperties.audiorecording === "on" ? "true" : "false";
        return eventDict;
    }
}

});
parcelRequire.register("5raFR", function(module, exports) {

$parcel$export(module.exports, "ConversationTranscriptionCanceledEventArgs", () => $3f57c10764257f62$export$9601f7f2aa8b229e);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.

var $4AZAD = parcelRequire("4AZAD");
class $3f57c10764257f62$export$9601f7f2aa8b229e extends (0, $4AZAD.CancellationEventArgsBase) {
}

});


parcelRequire.register("2FaWH", function(module, exports) {

$parcel$export(module.exports, "DetailedSpeechPhrase", () => $1f07e6b2f3f95aee$export$a2619747d8979906);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
parcelRequire("g6k3z");
var $15fen = parcelRequire("15fen");
class $1f07e6b2f3f95aee$export$a2619747d8979906 {
    constructor(json){
        this.privDetailedSpeechPhrase = JSON.parse(json);
        this.privDetailedSpeechPhrase.RecognitionStatus = (0, $15fen.RecognitionStatus)[this.privDetailedSpeechPhrase.RecognitionStatus];
    }
    static fromJSON(json) {
        return new $1f07e6b2f3f95aee$export$a2619747d8979906(json);
    }
    get RecognitionStatus() {
        return this.privDetailedSpeechPhrase.RecognitionStatus;
    }
    get NBest() {
        return this.privDetailedSpeechPhrase.NBest;
    }
    get Duration() {
        return this.privDetailedSpeechPhrase.Duration;
    }
    get Offset() {
        return this.privDetailedSpeechPhrase.Offset;
    }
    get Language() {
        return this.privDetailedSpeechPhrase.PrimaryLanguage === undefined ? undefined : this.privDetailedSpeechPhrase.PrimaryLanguage.Language;
    }
    get LanguageDetectionConfidence() {
        return this.privDetailedSpeechPhrase.PrimaryLanguage === undefined ? undefined : this.privDetailedSpeechPhrase.PrimaryLanguage.Confidence;
    }
}

});

parcelRequire.register("9HHlE", function(module, exports) {

$parcel$export(module.exports, "SimpleSpeechPhrase", () => $01d2bcec6499adc7$export$20e2c3c1649e1f71);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
parcelRequire("g6k3z");
var $15fen = parcelRequire("15fen");
class $01d2bcec6499adc7$export$20e2c3c1649e1f71 {
    constructor(json){
        this.privSimpleSpeechPhrase = JSON.parse(json);
        this.privSimpleSpeechPhrase.RecognitionStatus = (0, $15fen.RecognitionStatus)[this.privSimpleSpeechPhrase.RecognitionStatus];
    }
    static fromJSON(json) {
        return new $01d2bcec6499adc7$export$20e2c3c1649e1f71(json);
    }
    get RecognitionStatus() {
        return this.privSimpleSpeechPhrase.RecognitionStatus;
    }
    get DisplayText() {
        return this.privSimpleSpeechPhrase.DisplayText;
    }
    get Offset() {
        return this.privSimpleSpeechPhrase.Offset;
    }
    get Duration() {
        return this.privSimpleSpeechPhrase.Duration;
    }
    get Language() {
        return this.privSimpleSpeechPhrase.PrimaryLanguage === undefined ? undefined : this.privSimpleSpeechPhrase.PrimaryLanguage.Language;
    }
    get LanguageDetectionConfidence() {
        return this.privSimpleSpeechPhrase.PrimaryLanguage === undefined ? undefined : this.privSimpleSpeechPhrase.PrimaryLanguage.Confidence;
    }
    get SpeakerId() {
        return this.privSimpleSpeechPhrase.SpeakerId;
    }
}

});

parcelRequire.register("fZUgp", function(module, exports) {
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
parcelRequire("3KVS5");
var $4gz8B = parcelRequire("4gz8B");

var $8g0TV = parcelRequire("8g0TV");
var $k5noc = parcelRequire("k5noc");
var $3r3LC = parcelRequire("3r3LC");
var $2TUeF = parcelRequire("2TUeF");
var $eDSF6 = parcelRequire("eDSF6");
var $jJjdG = parcelRequire("jJjdG");
var $dptOd = parcelRequire("dptOd");
parcelRequire("g6k3z");
var $QS7Xa = parcelRequire("QS7Xa");
var $9HHlE = parcelRequire("9HHlE");
var $28Rmc = parcelRequire("28Rmc");
var $hQuYb = parcelRequire("hQuYb");
var $g6k3z = parcelRequire("g6k3z");
var $ldYFi = parcelRequire("ldYFi");
var $ba58324d6c5802dc$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
class $ba58324d6c5802dc$export$8a30468677ffdc9 extends (0, $ldYFi.ServiceRecognizerBase) {
    constructor(authentication, connectionFactory, audioSource, recognizerConfig, recognizer){
        super(authentication, connectionFactory, audioSource, recognizerConfig, recognizer);
        this.privIntentRecognizer = recognizer;
        this.privIntentDataSent = false;
    }
    setIntents(addedIntents, umbrellaIntent) {
        this.privAddedLmIntents = addedIntents;
        this.privUmbrellaIntent = umbrellaIntent;
        this.privIntentDataSent = true;
    }
    processTypeSpecificMessages(connectionMessage) {
        return $ba58324d6c5802dc$var$__awaiter(this, void 0, void 0, function*() {
            let result;
            let ev;
            let processed = false;
            const resultProps = new (0, $eDSF6.PropertyCollection)();
            if (connectionMessage.messageType === (0, $4gz8B.MessageType).Text) resultProps.setProperty((0, $jJjdG.PropertyId).SpeechServiceResponse_JsonResult, connectionMessage.textBody);
            switch(connectionMessage.path.toLowerCase()){
                case "speech.hypothesis":
                    const speechHypothesis = (0, $QS7Xa.SpeechHypothesis).fromJSON(connectionMessage.textBody);
                    result = new (0, $2TUeF.IntentRecognitionResult)(undefined, this.privRequestSession.requestId, (0, $dptOd.ResultReason).RecognizingIntent, speechHypothesis.Text, speechHypothesis.Duration, speechHypothesis.Offset + this.privRequestSession.currentTurnAudioOffset, speechHypothesis.Language, speechHypothesis.LanguageDetectionConfidence, undefined, connectionMessage.textBody, resultProps);
                    this.privRequestSession.onHypothesis(result.offset);
                    ev = new (0, $3r3LC.IntentRecognitionEventArgs)(result, speechHypothesis.Offset + this.privRequestSession.currentTurnAudioOffset, this.privRequestSession.sessionId);
                    if (!!this.privIntentRecognizer.recognizing) try {
                        this.privIntentRecognizer.recognizing(this.privIntentRecognizer, ev);
                    /* tslint:disable:no-empty */ } catch (error) {
                    // Not going to let errors in the event handler
                    // trip things up.
                    }
                    processed = true;
                    break;
                case "speech.phrase":
                    const simple = (0, $9HHlE.SimpleSpeechPhrase).fromJSON(connectionMessage.textBody);
                    result = new (0, $2TUeF.IntentRecognitionResult)(undefined, this.privRequestSession.requestId, (0, $28Rmc.EnumTranslation).implTranslateRecognitionResult(simple.RecognitionStatus), simple.DisplayText, simple.Duration, simple.Offset + this.privRequestSession.currentTurnAudioOffset, simple.Language, simple.LanguageDetectionConfidence, undefined, connectionMessage.textBody, resultProps);
                    ev = new (0, $3r3LC.IntentRecognitionEventArgs)(result, result.offset, this.privRequestSession.sessionId);
                    const sendEvent = ()=>{
                        if (!!this.privIntentRecognizer.recognized) try {
                            this.privIntentRecognizer.recognized(this.privIntentRecognizer, ev);
                        /* tslint:disable:no-empty */ } catch (error) {
                        // Not going to let errors in the event handler
                        // trip things up.
                        }
                        // report result to promise.
                        if (!!this.privSuccessCallback) {
                            try {
                                this.privSuccessCallback(result);
                            } catch (e) {
                                if (!!this.privErrorCallback) this.privErrorCallback(e);
                            }
                            // Only invoke the call back once.
                            // and if it's successful don't invoke the
                            // error after that.
                            this.privSuccessCallback = undefined;
                            this.privErrorCallback = undefined;
                        }
                    };
                    // If intent data was sent, the terminal result for this recognizer is an intent being found.
                    // If no intent data was sent, the terminal event is speech recognition being successful.
                    if (false === this.privIntentDataSent || (0, $dptOd.ResultReason).NoMatch === ev.result.reason) {
                        // Advance the buffers.
                        this.privRequestSession.onPhraseRecognized(ev.offset + ev.result.duration);
                        sendEvent();
                    } else // Squirrel away the args, when the response event arrives it will build upon them
                    // and then return
                    this.privPendingIntentArgs = ev;
                    processed = true;
                    break;
                case "response":
                    // Response from LUIS
                    ev = this.privPendingIntentArgs;
                    this.privPendingIntentArgs = undefined;
                    if (undefined === ev) {
                        if ("" === connectionMessage.textBody) // This condition happens if there is nothing but silence in the
                        // audio sent to the service.
                        return;
                        // Odd... Not sure this can happen
                        ev = new (0, $3r3LC.IntentRecognitionEventArgs)(new (0, $2TUeF.IntentRecognitionResult)(), 0 /*TODO*/ , this.privRequestSession.sessionId);
                    }
                    const intentResponse = (0, $hQuYb.IntentResponse).fromJSON(connectionMessage.textBody);
                    // If LUIS didn't return anything, send the existing event, else
                    // modify it to show the match.
                    // See if the intent found is in the list of intents asked for.
                    let addedIntent = this.privAddedLmIntents[intentResponse.topScoringIntent.intent];
                    if (this.privUmbrellaIntent !== undefined) addedIntent = this.privUmbrellaIntent;
                    if (null !== intentResponse && addedIntent !== undefined) {
                        const intentId = addedIntent.intentName === undefined ? intentResponse.topScoringIntent.intent : addedIntent.intentName;
                        let reason = ev.result.reason;
                        if (undefined !== intentId) reason = (0, $dptOd.ResultReason).RecognizedIntent;
                        // make sure, properties is set.
                        const properties = undefined !== ev.result.properties ? ev.result.properties : new (0, $eDSF6.PropertyCollection)();
                        properties.setProperty((0, $jJjdG.PropertyId).LanguageUnderstandingServiceResponse_JsonResult, connectionMessage.textBody);
                        ev = new (0, $3r3LC.IntentRecognitionEventArgs)(new (0, $2TUeF.IntentRecognitionResult)(intentId, ev.result.resultId, reason, ev.result.text, ev.result.duration, ev.result.offset, undefined, undefined, ev.result.errorDetails, ev.result.json, properties), ev.offset, ev.sessionId);
                    }
                    this.privRequestSession.onPhraseRecognized(ev.offset + ev.result.duration);
                    if (!!this.privIntentRecognizer.recognized) try {
                        this.privIntentRecognizer.recognized(this.privIntentRecognizer, ev);
                    /* tslint:disable:no-empty */ } catch (error) {
                    // Not going to let errors in the event handler
                    // trip things up.
                    }
                    // report result to promise.
                    if (!!this.privSuccessCallback) {
                        try {
                            this.privSuccessCallback(ev.result);
                        } catch (e) {
                            if (!!this.privErrorCallback) this.privErrorCallback(e);
                        }
                        // Only invoke the call back once.
                        // and if it's successful don't invoke the
                        // error after that.
                        this.privSuccessCallback = undefined;
                        this.privErrorCallback = undefined;
                    }
                    processed = true;
                    break;
                default:
                    break;
            }
            return processed;
        });
    }
    // Cancels recognition.
    cancelRecognition(sessionId, requestId, cancellationReason, errorCode, error) {
        const properties = new (0, $eDSF6.PropertyCollection)();
        properties.setProperty((0, $g6k3z.CancellationErrorCodePropertyName), (0, $8g0TV.CancellationErrorCode)[errorCode]);
        if (!!this.privIntentRecognizer.canceled) {
            const cancelEvent = new (0, $k5noc.IntentRecognitionCanceledEventArgs)(cancellationReason, error, errorCode, undefined, undefined, sessionId);
            try {
                this.privIntentRecognizer.canceled(this.privIntentRecognizer, cancelEvent);
            /* tslint:disable:no-empty */ } catch (_a) {}
        }
        if (!!this.privSuccessCallback) {
            const result = new (0, $2TUeF.IntentRecognitionResult)(undefined, requestId, (0, $dptOd.ResultReason).Canceled, undefined, undefined, undefined, undefined, undefined, error, undefined, properties);
            try {
                this.privSuccessCallback(result);
                this.privSuccessCallback = undefined;
            /* tslint:disable:no-empty */ } catch (_b) {}
        }
    }
}

});
parcelRequire.register("k5noc", function(module, exports) {

$parcel$export(module.exports, "IntentRecognitionCanceledEventArgs", () => $e9f66ae9f9df4bf9$export$48bd4e04b47da8b4);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.

var $3r3LC = parcelRequire("3r3LC");
class $e9f66ae9f9df4bf9$export$48bd4e04b47da8b4 extends (0, $3r3LC.IntentRecognitionEventArgs) {
    /**
     * Creates and initializes an instance of this class.
     * @constructor
     * @param {CancellationReason} result - The result of the intent recognition.
     * @param {string} offset - The offset.
     * @param {IntentRecognitionResult} sessionId - The session id.
     */ constructor(reason, errorDetails, errorCode, result, offset, sessionId){
        super(result, offset, sessionId);
        this.privReason = reason;
        this.privErrorDetails = errorDetails;
        this.privErrorCode = errorCode;
    }
    /**
     * The reason the recognition was canceled.
     * @member IntentRecognitionCanceledEventArgs.prototype.reason
     * @function
     * @public
     * @returns {CancellationReason} Specifies the reason canceled.
     */ get reason() {
        return this.privReason;
    }
    /**
     * The error code in case of an unsuccessful recognition.
     * Added in version 1.1.0.
     * @return An error code that represents the error reason.
     */ get errorCode() {
        return this.privErrorCode;
    }
    /**
     * In case of an unsuccessful recognition, provides details of the occurred error.
     * @member IntentRecognitionCanceledEventArgs.prototype.errorDetails
     * @function
     * @public
     * @returns {string} A String that represents the error details.
     */ get errorDetails() {
        return this.privErrorDetails;
    }
}

});
parcelRequire.register("3r3LC", function(module, exports) {

$parcel$export(module.exports, "IntentRecognitionEventArgs", () => $2806d0c39f40957c$export$ec3dfd035cb5121a);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.

var $lst3T = parcelRequire("lst3T");
class $2806d0c39f40957c$export$ec3dfd035cb5121a extends (0, $lst3T.RecognitionEventArgs) {
    /**
     * Creates and initializes an instance of this class.
     * @constructor
     * @param result - The result of the intent recognition.
     * @param offset - The offset.
     * @param sessionId - The session id.
     */ constructor(result, offset, sessionId){
        super(offset, sessionId);
        this.privResult = result;
    }
    /**
     * Represents the intent recognition result.
     * @member IntentRecognitionEventArgs.prototype.result
     * @function
     * @public
     * @returns {IntentRecognitionResult} Represents the intent recognition result.
     */ get result() {
        return this.privResult;
    }
}

});


parcelRequire.register("2TUeF", function(module, exports) {

$parcel$export(module.exports, "IntentRecognitionResult", () => $21cc570eddccb579$export$ba99cb5fd4cd02ac);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.

var $cBVoI = parcelRequire("cBVoI");
class $21cc570eddccb579$export$ba99cb5fd4cd02ac extends (0, $cBVoI.SpeechRecognitionResult) {
    /**
     * Creates and initializes an instance of this class.
     * @constructor
     * @param intentId - The intent id.
     * @param resultId - The result id.
     * @param reason - The reason.
     * @param text - The recognized text.
     * @param duration - The duration.
     * @param offset - The offset into the stream.
     * @param language - Primary Language detected, if provided.
     * @param languageDetectionConfidence - Primary Language confidence ("Unknown," "Low," "Medium," "High"...), if provided.
     * @param errorDetails - Error details, if provided.
     * @param json - Additional Json, if provided.
     * @param properties - Additional properties, if provided.
     */ constructor(intentId, resultId, reason, text, duration, offset, language, languageDetectionConfidence, errorDetails, json, properties){
        super(resultId, reason, text, duration, offset, language, languageDetectionConfidence, undefined, errorDetails, json, properties);
        this.privIntentId = intentId;
    }
    /**
     * A String that represents the intent identifier being recognized.
     * @member IntentRecognitionResult.prototype.intentId
     * @function
     * @public
     * @returns {string} A String that represents the intent identifier being recognized.
     */ get intentId() {
        return this.privIntentId;
    }
}

});


parcelRequire.register("hQuYb", function(module, exports) {

$parcel$export(module.exports, "IntentResponse", () => $cfdf50f024402349$export$ab895fc89c7c43a);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
// response
class $cfdf50f024402349$export$ab895fc89c7c43a {
    constructor(json){
        this.privIntentResponse = JSON.parse(json);
    }
    static fromJSON(json) {
        return new $cfdf50f024402349$export$ab895fc89c7c43a(json);
    }
    get query() {
        return this.privIntentResponse.query;
    }
    get topScoringIntent() {
        return this.privIntentResponse.topScoringIntent;
    }
    get entities() {
        return this.privIntentResponse.entities;
    }
}

});

parcelRequire.register("8nrH1", function(module, exports) {

$parcel$export(module.exports, "RequestSession", () => $6195f3f3ae390e9f$export$64a8db883c198597);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
parcelRequire("3KVS5");
var $9MSEb = parcelRequire("9MSEb");
var $l9cUE = parcelRequire("l9cUE");
var $kSC7p = parcelRequire("kSC7p");

var $3dqsU = parcelRequire("3dqsU");

var $hSxhe = parcelRequire("hSxhe");
var $6195f3f3ae390e9f$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
class $6195f3f3ae390e9f$export$64a8db883c198597 {
    constructor(audioSourceId){
        this.privIsDisposed = false;
        this.privDetachables = new Array();
        this.privIsAudioNodeDetached = false;
        this.privIsRecognizing = false;
        this.privIsSpeechEnded = false;
        this.privTurnStartAudioOffset = 0;
        this.privLastRecoOffset = 0;
        this.privHypothesisReceived = false;
        this.privBytesSent = 0;
        this.privRecogNumber = 0;
        this.privInTurn = false;
        this.privConnectionAttempts = 0;
        this.onPreConnectionStart = (authFetchEventId, connectionId)=>{
            this.privAuthFetchEventId = authFetchEventId;
            this.privSessionId = connectionId;
            this.onEvent(new (0, $3dqsU.ConnectingToServiceEvent)(this.privRequestId, this.privAuthFetchEventId, this.privSessionId));
        };
        this.onServiceTurnStartResponse = ()=>{
            if (!!this.privTurnDeferral && !!this.privInTurn) {
                // What? How are we starting a turn with another not done?
                this.privTurnDeferral.reject("Another turn started before current completed.");
                // Avoid UnhandledPromiseRejection if privTurnDeferral is not being awaited
                /* tslint:disable:no-empty */ this.privTurnDeferral.promise.then().catch(()=>{});
            }
            this.privInTurn = true;
            this.privTurnDeferral = new (0, $9MSEb.Deferred)();
        };
        this.getTelemetry = ()=>{
            if (this.privServiceTelemetryListener.hasTelemetry) return this.privServiceTelemetryListener.getTelemetry();
            else return null;
        };
        this.onEvent = (event)=>{
            if (!!this.privServiceTelemetryListener) this.privServiceTelemetryListener.onEvent(event);
            (0, $l9cUE.Events).instance.onEvent(event);
        };
        this.privAudioSourceId = audioSourceId;
        this.privRequestId = (0, $kSC7p.createNoDashGuid)();
        this.privAudioNodeId = (0, $kSC7p.createNoDashGuid)();
        this.privTurnDeferral = new (0, $9MSEb.Deferred)();
        // We're not in a turn, so resolve.
        this.privTurnDeferral.resolve();
    }
    get sessionId() {
        return this.privSessionId;
    }
    get requestId() {
        return this.privRequestId;
    }
    get audioNodeId() {
        return this.privAudioNodeId;
    }
    get turnCompletionPromise() {
        return this.privTurnDeferral.promise;
    }
    get isSpeechEnded() {
        return this.privIsSpeechEnded;
    }
    get isRecognizing() {
        return this.privIsRecognizing;
    }
    get currentTurnAudioOffset() {
        return this.privTurnStartAudioOffset;
    }
    get recogNumber() {
        return this.privRecogNumber;
    }
    get numConnectionAttempts() {
        return this.privConnectionAttempts;
    }
    // The number of bytes sent for the current connection.
    // Counter is reset to 0 each time a connection is established.
    get bytesSent() {
        return this.privBytesSent;
    }
    listenForServiceTelemetry(eventSource) {
        if (!!this.privServiceTelemetryListener) this.privDetachables.push(eventSource.attachListener(this.privServiceTelemetryListener));
    }
    startNewRecognition() {
        this.privIsSpeechEnded = false;
        this.privIsRecognizing = true;
        this.privTurnStartAudioOffset = 0;
        this.privLastRecoOffset = 0;
        this.privRequestId = (0, $kSC7p.createNoDashGuid)();
        this.privRecogNumber++;
        this.privServiceTelemetryListener = new (0, $hSxhe.ServiceTelemetryListener)(this.privRequestId, this.privAudioSourceId, this.privAudioNodeId);
        this.onEvent(new (0, $3dqsU.RecognitionTriggeredEvent)(this.requestId, this.privSessionId, this.privAudioSourceId, this.privAudioNodeId));
    }
    onAudioSourceAttachCompleted(audioNode, isError, error) {
        return $6195f3f3ae390e9f$var$__awaiter(this, void 0, void 0, function*() {
            this.privAudioNode = audioNode;
            this.privIsAudioNodeDetached = false;
            if (isError) yield this.onComplete();
            else this.onEvent(new (0, $3dqsU.ListeningStartedEvent)(this.privRequestId, this.privSessionId, this.privAudioSourceId, this.privAudioNodeId));
        });
    }
    onAuthCompleted(isError, error) {
        return $6195f3f3ae390e9f$var$__awaiter(this, void 0, void 0, function*() {
            if (isError) yield this.onComplete();
        });
    }
    onConnectionEstablishCompleted(statusCode, reason) {
        return $6195f3f3ae390e9f$var$__awaiter(this, void 0, void 0, function*() {
            if (statusCode === 200) {
                this.onEvent(new (0, $3dqsU.RecognitionStartedEvent)(this.requestId, this.privAudioSourceId, this.privAudioNodeId, this.privAuthFetchEventId, this.privSessionId));
                if (!!this.privAudioNode) this.privAudioNode.replay();
                this.privTurnStartAudioOffset = this.privLastRecoOffset;
                this.privBytesSent = 0;
                return;
            } else if (statusCode === 403) yield this.onComplete();
        });
    }
    onServiceTurnEndResponse(continuousRecognition) {
        return $6195f3f3ae390e9f$var$__awaiter(this, void 0, void 0, function*() {
            this.privTurnDeferral.resolve();
            if (!continuousRecognition || this.isSpeechEnded) {
                yield this.onComplete();
                this.privInTurn = false;
            } else {
                // Start a new request set.
                this.privTurnStartAudioOffset = this.privLastRecoOffset;
                this.privRequestId = (0, $kSC7p.createNoDashGuid)();
                this.privAudioNode.replay();
            }
        });
    }
    onHypothesis(offset) {
        if (!this.privHypothesisReceived) {
            this.privHypothesisReceived = true;
            this.privServiceTelemetryListener.hypothesisReceived(this.privAudioNode.findTimeAtOffset(offset));
        }
    }
    onPhraseRecognized(offset) {
        this.privServiceTelemetryListener.phraseReceived(this.privAudioNode.findTimeAtOffset(offset));
        this.onServiceRecognized(offset);
    }
    onServiceRecognized(offset) {
        this.privLastRecoOffset = offset;
        this.privHypothesisReceived = false;
        this.privAudioNode.shrinkBuffers(offset);
        this.privConnectionAttempts = 0;
    }
    onAudioSent(bytesSent) {
        this.privBytesSent += bytesSent;
    }
    onRetryConnection() {
        this.privConnectionAttempts++;
    }
    dispose(error) {
        return $6195f3f3ae390e9f$var$__awaiter(this, void 0, void 0, function*() {
            if (!this.privIsDisposed) {
                // we should have completed by now. If we did not its an unknown error.
                this.privIsDisposed = true;
                for (const detachable of this.privDetachables)yield detachable.detach();
                this.privServiceTelemetryListener.dispose();
                this.privIsRecognizing = false;
            }
        });
    }
    onStopRecognizing() {
        return $6195f3f3ae390e9f$var$__awaiter(this, void 0, void 0, function*() {
            yield this.onComplete();
        });
    }
    // Should be called with the audioNode for this session has indicated that it is out of speech.
    onSpeechEnded() {
        this.privIsSpeechEnded = true;
    }
    onComplete() {
        return $6195f3f3ae390e9f$var$__awaiter(this, void 0, void 0, function*() {
            if (!!this.privIsRecognizing) {
                this.privIsRecognizing = false;
                yield this.detachAudioNode();
            }
        });
    }
    detachAudioNode() {
        return $6195f3f3ae390e9f$var$__awaiter(this, void 0, void 0, function*() {
            if (!this.privIsAudioNodeDetached) {
                this.privIsAudioNodeDetached = true;
                if (this.privAudioNode) yield this.privAudioNode.detach();
            }
        });
    }
}

});
parcelRequire.register("3dqsU", function(module, exports) {

$parcel$export(module.exports, "RecognitionTriggeredEvent", () => $25771d7291d8be0b$export$5a7a93aa45921175);
$parcel$export(module.exports, "ListeningStartedEvent", () => $25771d7291d8be0b$export$4093ad2c899cda43);
$parcel$export(module.exports, "ConnectingToServiceEvent", () => $25771d7291d8be0b$export$beef32cc459c1496);
$parcel$export(module.exports, "RecognitionStartedEvent", () => $25771d7291d8be0b$export$32b70f34e60833d0);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
// tslint:disable:max-classes-per-file
parcelRequire("3KVS5");
var $aAKrf = parcelRequire("aAKrf");
class $25771d7291d8be0b$export$2faa991ee52d1699 extends (0, $aAKrf.PlatformEvent) {
    constructor(eventName, requestId, sessionId, eventType = (0, $aAKrf.EventType).Info){
        super(eventName, eventType);
        this.privRequestId = requestId;
        this.privSessionId = sessionId;
    }
    get requestId() {
        return this.privRequestId;
    }
    get sessionId() {
        return this.privSessionId;
    }
}
class $25771d7291d8be0b$export$5a7a93aa45921175 extends $25771d7291d8be0b$export$2faa991ee52d1699 {
    constructor(requestId, sessionId, audioSourceId, audioNodeId){
        super("RecognitionTriggeredEvent", requestId, sessionId);
        this.privAudioSourceId = audioSourceId;
        this.privAudioNodeId = audioNodeId;
    }
    get audioSourceId() {
        return this.privAudioSourceId;
    }
    get audioNodeId() {
        return this.privAudioNodeId;
    }
}
class $25771d7291d8be0b$export$4093ad2c899cda43 extends $25771d7291d8be0b$export$2faa991ee52d1699 {
    constructor(requestId, sessionId, audioSourceId, audioNodeId){
        super("ListeningStartedEvent", requestId, sessionId);
        this.privAudioSourceId = audioSourceId;
        this.privAudioNodeId = audioNodeId;
    }
    get audioSourceId() {
        return this.privAudioSourceId;
    }
    get audioNodeId() {
        return this.privAudioNodeId;
    }
}
class $25771d7291d8be0b$export$beef32cc459c1496 extends $25771d7291d8be0b$export$2faa991ee52d1699 {
    constructor(requestId, authFetchEventid, sessionId){
        super("ConnectingToServiceEvent", requestId, sessionId);
        this.privAuthFetchEventid = authFetchEventid;
    }
    get authFetchEventid() {
        return this.privAuthFetchEventid;
    }
}
class $25771d7291d8be0b$export$32b70f34e60833d0 extends $25771d7291d8be0b$export$2faa991ee52d1699 {
    constructor(requestId, audioSourceId, audioNodeId, authFetchEventId, sessionId){
        super("RecognitionStartedEvent", requestId, sessionId);
        this.privAudioSourceId = audioSourceId;
        this.privAudioNodeId = audioNodeId;
        this.privAuthFetchEventId = authFetchEventId;
    }
    get audioSourceId() {
        return this.privAudioSourceId;
    }
    get audioNodeId() {
        return this.privAudioNodeId;
    }
    get authFetchEventId() {
        return this.privAuthFetchEventId;
    }
}
var $25771d7291d8be0b$export$ed6cf71006422f40;
(function(RecognitionCompletionStatus) {
    RecognitionCompletionStatus[RecognitionCompletionStatus["Success"] = 0] = "Success";
    RecognitionCompletionStatus[RecognitionCompletionStatus["AudioSourceError"] = 1] = "AudioSourceError";
    RecognitionCompletionStatus[RecognitionCompletionStatus["AudioSourceTimeout"] = 2] = "AudioSourceTimeout";
    RecognitionCompletionStatus[RecognitionCompletionStatus["AuthTokenFetchError"] = 3] = "AuthTokenFetchError";
    RecognitionCompletionStatus[RecognitionCompletionStatus["AuthTokenFetchTimeout"] = 4] = "AuthTokenFetchTimeout";
    RecognitionCompletionStatus[RecognitionCompletionStatus["UnAuthorized"] = 5] = "UnAuthorized";
    RecognitionCompletionStatus[RecognitionCompletionStatus["ConnectTimeout"] = 6] = "ConnectTimeout";
    RecognitionCompletionStatus[RecognitionCompletionStatus["ConnectError"] = 7] = "ConnectError";
    RecognitionCompletionStatus[RecognitionCompletionStatus["ClientRecognitionActivityTimeout"] = 8] = "ClientRecognitionActivityTimeout";
    RecognitionCompletionStatus[RecognitionCompletionStatus["UnknownError"] = 9] = "UnknownError";
})($25771d7291d8be0b$export$ed6cf71006422f40 || ($25771d7291d8be0b$export$ed6cf71006422f40 = {}));
class $25771d7291d8be0b$export$8de1ba0528dc7861 extends $25771d7291d8be0b$export$2faa991ee52d1699 {
    constructor(requestId, audioSourceId, audioNodeId, authFetchEventId, sessionId, serviceTag, status, error){
        super("RecognitionEndedEvent", requestId, sessionId, status === $25771d7291d8be0b$export$ed6cf71006422f40.Success ? (0, $aAKrf.EventType).Info : (0, $aAKrf.EventType).Error);
        this.privAudioSourceId = audioSourceId;
        this.privAudioNodeId = audioNodeId;
        this.privAuthFetchEventId = authFetchEventId;
        this.privStatus = status;
        this.privError = error;
        this.privServiceTag = serviceTag;
    }
    get audioSourceId() {
        return this.privAudioSourceId;
    }
    get audioNodeId() {
        return this.privAudioNodeId;
    }
    get authFetchEventId() {
        return this.privAuthFetchEventId;
    }
    get serviceTag() {
        return this.privServiceTag;
    }
    get status() {
        return this.privStatus;
    }
    get error() {
        return this.privError;
    }
}

});

parcelRequire.register("hSxhe", function(module, exports) {

$parcel$export(module.exports, "ServiceTelemetryListener", () => $d0414aefcce8836d$export$12a36cb0f88ffb8d);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
// tslint:disable:max-classes-per-file
parcelRequire("3KVS5");
var $btwY7 = parcelRequire("btwY7");
var $l8CKy = parcelRequire("l8CKy");

var $3dqsU = parcelRequire("3dqsU");
class $d0414aefcce8836d$export$12a36cb0f88ffb8d {
    constructor(requestId, audioSourceId, audioNodeId){
        this.privIsDisposed = false;
        this.privListeningTriggerMetric = null;
        this.privMicMetric = null;
        this.privConnectionEstablishMetric = null;
        this.onEvent = (e)=>{
            if (this.privIsDisposed) return;
            if (e instanceof (0, $3dqsU.RecognitionTriggeredEvent) && e.requestId === this.privRequestId) this.privListeningTriggerMetric = {
                End: e.eventTime,
                Name: "ListeningTrigger",
                Start: e.eventTime
            };
            if (e instanceof (0, $btwY7.AudioStreamNodeAttachingEvent) && e.audioSourceId === this.privAudioSourceId && e.audioNodeId === this.privAudioNodeId) this.privMicStartTime = e.eventTime;
            if (e instanceof (0, $btwY7.AudioStreamNodeAttachedEvent) && e.audioSourceId === this.privAudioSourceId && e.audioNodeId === this.privAudioNodeId) this.privMicStartTime = e.eventTime;
            if (e instanceof (0, $btwY7.AudioSourceErrorEvent) && e.audioSourceId === this.privAudioSourceId) {
                if (!this.privMicMetric) this.privMicMetric = {
                    End: e.eventTime,
                    Error: e.error,
                    Name: "Microphone",
                    Start: this.privMicStartTime
                };
            }
            if (e instanceof (0, $btwY7.AudioStreamNodeErrorEvent) && e.audioSourceId === this.privAudioSourceId && e.audioNodeId === this.privAudioNodeId) {
                if (!this.privMicMetric) this.privMicMetric = {
                    End: e.eventTime,
                    Error: e.error,
                    Name: "Microphone",
                    Start: this.privMicStartTime
                };
            }
            if (e instanceof (0, $btwY7.AudioStreamNodeDetachedEvent) && e.audioSourceId === this.privAudioSourceId && e.audioNodeId === this.privAudioNodeId) {
                if (!this.privMicMetric) this.privMicMetric = {
                    End: e.eventTime,
                    Name: "Microphone",
                    Start: this.privMicStartTime
                };
            }
            if (e instanceof (0, $3dqsU.ConnectingToServiceEvent) && e.requestId === this.privRequestId) this.privConnectionId = e.sessionId;
            if (e instanceof (0, $l8CKy.ConnectionStartEvent) && e.connectionId === this.privConnectionId) this.privConnectionStartTime = e.eventTime;
            if (e instanceof (0, $l8CKy.ConnectionEstablishedEvent) && e.connectionId === this.privConnectionId) {
                if (!this.privConnectionEstablishMetric) this.privConnectionEstablishMetric = {
                    End: e.eventTime,
                    Id: this.privConnectionId,
                    Name: "Connection",
                    Start: this.privConnectionStartTime
                };
            }
            if (e instanceof (0, $l8CKy.ConnectionEstablishErrorEvent) && e.connectionId === this.privConnectionId) {
                if (!this.privConnectionEstablishMetric) this.privConnectionEstablishMetric = {
                    End: e.eventTime,
                    Error: this.getConnectionError(e.statusCode),
                    Id: this.privConnectionId,
                    Name: "Connection",
                    Start: this.privConnectionStartTime
                };
            }
            if (e instanceof (0, $l8CKy.ConnectionMessageReceivedEvent) && e.connectionId === this.privConnectionId) {
                if (e.message && e.message.headers && e.message.headers.path) {
                    if (!this.privReceivedMessages[e.message.headers.path]) this.privReceivedMessages[e.message.headers.path] = new Array();
                    this.privReceivedMessages[e.message.headers.path].push(e.networkReceivedTime);
                }
            }
        };
        this.getTelemetry = ()=>{
            const metrics = new Array();
            if (this.privListeningTriggerMetric) metrics.push(this.privListeningTriggerMetric);
            if (this.privMicMetric) metrics.push(this.privMicMetric);
            if (this.privConnectionEstablishMetric) metrics.push(this.privConnectionEstablishMetric);
            if (this.privPhraseLatencies.length > 0) metrics.push({
                PhraseLatencyMs: this.privPhraseLatencies
            });
            if (this.privHypothesisLatencies.length > 0) metrics.push({
                FirstHypothesisLatencyMs: this.privHypothesisLatencies
            });
            const telemetry = {
                Metrics: metrics,
                ReceivedMessages: this.privReceivedMessages
            };
            const json = JSON.stringify(telemetry);
            // We dont want to send the same telemetry again. So clean those out.
            this.privReceivedMessages = {};
            this.privListeningTriggerMetric = null;
            this.privMicMetric = null;
            this.privConnectionEstablishMetric = null;
            this.privPhraseLatencies = [];
            this.privHypothesisLatencies = [];
            return json;
        };
        this.dispose = ()=>{
            this.privIsDisposed = true;
        };
        this.getConnectionError = (statusCode)=>{
            /*
            -- Websocket status codes --
            NormalClosure = 1000,
            EndpointUnavailable = 1001,
            ProtocolError = 1002,
            InvalidMessageType = 1003,
            Empty = 1005,
            InvalidPayloadData = 1007,
            PolicyViolation = 1008,
            MessageTooBig = 1009,
            MandatoryExtension = 1010,
            InternalServerError = 1011
            */ switch(statusCode){
                case 400:
                case 1002:
                case 1003:
                case 1005:
                case 1007:
                case 1008:
                case 1009:
                    return "BadRequest";
                case 401:
                    return "Unauthorized";
                case 403:
                    return "Forbidden";
                case 503:
                case 1001:
                    return "ServerUnavailable";
                case 500:
                case 1011:
                    return "ServerError";
                case 408:
                case 504:
                    return "Timeout";
                default:
                    return "statuscode:" + statusCode.toString();
            }
        };
        this.privRequestId = requestId;
        this.privAudioSourceId = audioSourceId;
        this.privAudioNodeId = audioNodeId;
        this.privReceivedMessages = {};
        this.privPhraseLatencies = [];
        this.privHypothesisLatencies = [];
    }
    phraseReceived(audioReceivedTime) {
        if (audioReceivedTime > 0) this.privPhraseLatencies.push(Date.now() - audioReceivedTime);
    }
    hypothesisReceived(audioReceivedTime) {
        if (audioReceivedTime > 0) this.privHypothesisLatencies.push(Date.now() - audioReceivedTime);
    }
    // Determines if there are any telemetry events to send to the service.
    get hasTelemetry() {
        return Object.keys(this.privReceivedMessages).length !== 0 || this.privListeningTriggerMetric !== null || this.privMicMetric !== null || this.privConnectionEstablishMetric !== null || this.privPhraseLatencies.length !== 0 || this.privHypothesisLatencies.length !== 0;
    }
}

});


parcelRequire.register("f6F4R", function(module, exports) {

$parcel$export(module.exports, "SpeechContext", () => $aff747ad3c443b2c$export$11ed12a49459a250);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
/**
 * Represents the JSON used in the speech.context message sent to the speech service.
 * The dynamic grammar is always refreshed from the encapsulated dynamic grammar object.
 */ class $aff747ad3c443b2c$export$11ed12a49459a250 {
    constructor(dynamicGrammar){
        this.privContext = {};
        this.privDynamicGrammar = dynamicGrammar;
    }
    /**
     * Adds a section to the speech.context object.
     * @param sectionName Name of the section to add.
     * @param value JSON serializable object that represents the value.
     */ setSection(sectionName, value) {
        this.privContext[sectionName] = value;
    }
    /**
     * @Internal
     * This is only used by pronunciation assessment config.
     * Do not use externally, object returned will change without warning or notice.
     */ setPronunciationAssessmentParams(params) {
        if (this.privContext.phraseDetection === undefined) this.privContext.phraseDetection = {
            enrichment: {
                pronunciationAssessment: {}
            }
        };
        this.privContext.phraseDetection.enrichment.pronunciationAssessment = JSON.parse(params);
        if (this.privContext.phraseOutput === undefined) this.privContext.phraseOutput = {
            detailed: {
                options: []
            },
            format: {}
        };
        this.privContext.phraseOutput.format = "Detailed";
        this.privContext.phraseOutput.detailed.options.push("PronunciationAssessment");
        if (this.privContext.phraseOutput.detailed.options.indexOf("WordTimings") === -1) this.privContext.phraseOutput.detailed.options.push("WordTimings");
    }
    toJSON() {
        const dgi = this.privDynamicGrammar.generateGrammarObject();
        this.setSection("dgi", dgi);
        const ret = JSON.stringify(this.privContext);
        return ret;
    }
}

});

parcelRequire.register("fT1hb", function(module, exports) {

$parcel$export(module.exports, "DynamicGrammarBuilder", () => $b90cfb80830f51cf$export$feefa659188a6539);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
/**
 * Responsible for building the object to be sent to the speech service to support dynamic grammars.
 * @class DynamicGrammarBuilder
 */ class $b90cfb80830f51cf$export$feefa659188a6539 {
    // Adds one more reference phrases to the dynamic grammar to send.
    // All added phrases are generic phrases.
    addPhrase(phrase) {
        if (!this.privPhrases) this.privPhrases = [];
        if (phrase instanceof Array) this.privPhrases = this.privPhrases.concat(phrase);
        else this.privPhrases.push(phrase);
    }
    // Clears all phrases stored in the current object.
    clearPhrases() {
        this.privPhrases = undefined;
    }
    // Adds one or more reference grammars to the current grammar.
    addReferenceGrammar(grammar) {
        if (!this.privGrammars) this.privGrammars = [];
        if (grammar instanceof Array) this.privGrammars = this.privGrammars.concat(grammar);
        else this.privGrammars.push(grammar);
    }
    // clears all grammars stored on the recognizer.
    clearGrammars() {
        this.privGrammars = undefined;
    }
    // Generates an object that represents the dynamic grammar used by the Speech Service.
    // This is done by building an object with the correct layout based on the phrases and reference grammars added to this instance
    // of a DynamicGrammarBuilder
    generateGrammarObject() {
        if (this.privGrammars === undefined && this.privPhrases === undefined) return undefined;
        const retObj = {};
        retObj.ReferenceGrammars = this.privGrammars;
        if (undefined !== this.privPhrases && 0 !== this.privPhrases.length) {
            const retPhrases = [];
            this.privPhrases.forEach((value, index, array)=>{
                retPhrases.push({
                    Text: value
                });
            });
            retObj.Groups = [
                {
                    Type: "Generic",
                    Items: retPhrases
                }
            ];
        }
        return retObj;
    }
}

});

parcelRequire.register("hRiKl", function(module, exports) {

$parcel$export(module.exports, "DialogServiceAdapter", () => $d005ed8fd82e217e$export$6c74c1d33ebaa2d2);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
parcelRequire("if2Nv");
var $cGmX2 = parcelRequire("cGmX2");

var $j1RgB = parcelRequire("j1RgB");
parcelRequire("3KVS5");
var $4gz8B = parcelRequire("4gz8B");
var $kSC7p = parcelRequire("kSC7p");
var $l9cUE = parcelRequire("l9cUE");
var $6p3HD = parcelRequire("6p3HD");
var $76ZQQ = parcelRequire("76ZQQ");
var $9MSEb = parcelRequire("9MSEb");
var $l8CKy = parcelRequire("l8CKy");

var $5WyXj = parcelRequire("5WyXj");

var $fHq4P = parcelRequire("fHq4P");
var $8g0TV = parcelRequire("8g0TV");
var $GCsZL = parcelRequire("GCsZL");
var $9Xv9r = parcelRequire("9Xv9r");
var $eDSF6 = parcelRequire("eDSF6");
var $jJjdG = parcelRequire("jJjdG");
var $lst3T = parcelRequire("lst3T");
var $dptOd = parcelRequire("dptOd");
var $9Pi8Y = parcelRequire("9Pi8Y");
var $b9O7R = parcelRequire("b9O7R");
var $evfM9 = parcelRequire("evfM9");
var $cBVoI = parcelRequire("cBVoI");
var $etyPc = parcelRequire("etyPc");

var $3Ea4Y = parcelRequire("3Ea4Y");
parcelRequire("g6k3z");
var $9HHlE = parcelRequire("9HHlE");
var $15fen = parcelRequire("15fen");
var $QS7Xa = parcelRequire("QS7Xa");
var $b1X1y = parcelRequire("b1X1y");
var $g6k3z = parcelRequire("g6k3z");
var $iYdLz = parcelRequire("iYdLz");
var $28Rmc = parcelRequire("28Rmc");
var $ldYFi = parcelRequire("ldYFi");

var $8Efdj = parcelRequire("8Efdj");

var $MRQbb = parcelRequire("MRQbb");
var $d005ed8fd82e217e$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
class $d005ed8fd82e217e$export$6c74c1d33ebaa2d2 extends (0, $ldYFi.ServiceRecognizerBase) {
    constructor(authentication, connectionFactory, audioSource, recognizerConfig, dialogServiceConnector){
        super(authentication, connectionFactory, audioSource, recognizerConfig, dialogServiceConnector);
        this.sendAgentConfig = (connection)=>{
            if (this.agentConfig && !this.agentConfigSent) {
                if (this.privRecognizerConfig.parameters.getProperty((0, $jJjdG.PropertyId).Conversation_DialogType) === (0, $9Xv9r.DialogServiceConfig).DialogTypes.CustomCommands) {
                    const config = this.agentConfig.get();
                    config.botInfo.commandsCulture = this.privRecognizerConfig.parameters.getProperty((0, $jJjdG.PropertyId).SpeechServiceConnection_RecoLanguage, "en-us");
                    this.agentConfig.set(config);
                }
                this.onEvent(new (0, $j1RgB.SendingAgentContextMessageEvent)(this.agentConfig));
                const agentConfigJson = this.agentConfig.toJsonString();
                // guard against sending this multiple times on one connection
                this.agentConfigSent = true;
                return connection.send(new (0, $MRQbb.SpeechConnectionMessage)((0, $4gz8B.MessageType).Text, "agent.config", this.privRequestSession.requestId, "application/json", agentConfigJson));
            }
            return;
        };
        this.sendAgentContext = (connection)=>{
            const guid = (0, $kSC7p.createGuid)();
            const speechActivityTemplate = this.privDialogServiceConnector.properties.getProperty((0, $jJjdG.PropertyId).Conversation_Speech_Activity_Template);
            const agentContext = {
                channelData: "",
                context: {
                    interactionId: guid
                },
                messagePayload: speechActivityTemplate,
                version: 0.5
            };
            const agentContextJson = JSON.stringify(agentContext);
            return connection.send(new (0, $MRQbb.SpeechConnectionMessage)((0, $4gz8B.MessageType).Text, "speech.agent.context", this.privRequestSession.requestId, "application/json", agentContextJson));
        };
        this.handleResponseMessage = (responseMessage)=>{
            // "response" messages can contain either "message" (activity) or "MessageStatus" data. Fire the appropriate
            // event according to the message type that's specified.
            const responsePayload = JSON.parse(responseMessage.textBody);
            switch(responsePayload.messageType.toLowerCase()){
                case "message":
                    const responseRequestId = responseMessage.requestId.toUpperCase();
                    const activityPayload = (0, $8Efdj.ActivityPayloadResponse).fromJSON(responseMessage.textBody);
                    const turn = this.privTurnStateManager.GetTurn(responseRequestId);
                    // update the conversation Id
                    if (activityPayload.conversationId) {
                        const updateAgentConfig = this.agentConfig.get();
                        updateAgentConfig.botInfo.conversationId = activityPayload.conversationId;
                        this.agentConfig.set(updateAgentConfig);
                    }
                    const pullAudioOutputStream = turn.processActivityPayload(activityPayload, (0, $5WyXj.AudioOutputFormatImpl).fromSpeechSynthesisOutputFormatString(this.privDialogServiceConnector.properties.getProperty((0, $jJjdG.PropertyId).SpeechServiceConnection_SynthOutputFormat, undefined)));
                    const activity = new (0, $fHq4P.ActivityReceivedEventArgs)(activityPayload.messagePayload, pullAudioOutputStream);
                    if (!!this.privDialogServiceConnector.activityReceived) try {
                        this.privDialogServiceConnector.activityReceived(this.privDialogServiceConnector, activity);
                    /* tslint:disable:no-empty */ } catch (error) {
                    // Not going to let errors in the event handler
                    // trip things up.
                    }
                    break;
                case "messagestatus":
                    if (!!this.privDialogServiceConnector.turnStatusReceived) try {
                        this.privDialogServiceConnector.turnStatusReceived(this.privDialogServiceConnector, new (0, $etyPc.TurnStatusReceivedEventArgs)(responseMessage.textBody));
                    /* tslint:disable:no-empty */ } catch (error) {
                    // Not going to let errors in the event handler
                    // trip things up.
                    }
                    break;
                default:
                    (0, $l9cUE.Events).instance.onEvent(new (0, $6p3HD.BackgroundEvent)(`Unexpected response of type ${responsePayload.messageType}. Ignoring.`));
                    break;
            }
        };
        this.privEvents = new (0, $76ZQQ.EventSource)();
        this.privDialogServiceConnector = dialogServiceConnector;
        this.receiveMessageOverride = this.receiveDialogMessageOverride;
        this.privTurnStateManager = new (0, $3Ea4Y.DialogServiceTurnStateManager)();
        this.recognizeOverride = this.listenOnce;
        this.postConnectImplOverride = this.dialogConnectImpl;
        this.configConnectionOverride = this.configConnection;
        this.disconnectOverride = this.privDisconnect;
        this.privDialogAudioSource = audioSource;
        this.agentConfigSent = false;
        this.privLastResult = null;
        this.connectionEvents.attach((connectionEvent)=>$d005ed8fd82e217e$var$__awaiter(this, void 0, void 0, function*() {
                if (connectionEvent.name === "ConnectionClosedEvent") this.terminateMessageLoop = true;
            }));
    }
    sendMessage(message) {
        return $d005ed8fd82e217e$var$__awaiter(this, void 0, void 0, function*() {
            const interactionGuid = (0, $kSC7p.createGuid)();
            const requestId = (0, $kSC7p.createNoDashGuid)();
            const agentMessage = {
                context: {
                    interactionId: interactionGuid
                },
                messagePayload: JSON.parse(message),
                version: 0.5
            };
            const agentMessageJson = JSON.stringify(agentMessage);
            const connection = yield this.fetchConnection();
            yield connection.send(new (0, $MRQbb.SpeechConnectionMessage)((0, $4gz8B.MessageType).Text, "agent", requestId, "application/json", agentMessageJson));
        });
    }
    privDisconnect() {
        return $d005ed8fd82e217e$var$__awaiter(this, void 0, void 0, function*() {
            yield this.cancelRecognition(this.privRequestSession.sessionId, this.privRequestSession.requestId, (0, $GCsZL.CancellationReason).Error, (0, $8g0TV.CancellationErrorCode).NoError, "Disconnecting");
            this.terminateMessageLoop = true;
            this.agentConfigSent = false;
            return;
        });
    }
    processTypeSpecificMessages(connectionMessage) {
        return $d005ed8fd82e217e$var$__awaiter(this, void 0, void 0, function*() {
            const resultProps = new (0, $eDSF6.PropertyCollection)();
            if (connectionMessage.messageType === (0, $4gz8B.MessageType).Text) resultProps.setProperty((0, $jJjdG.PropertyId).SpeechServiceResponse_JsonResult, connectionMessage.textBody);
            let result;
            let processed;
            switch(connectionMessage.path.toLowerCase()){
                case "speech.phrase":
                    const speechPhrase = (0, $9HHlE.SimpleSpeechPhrase).fromJSON(connectionMessage.textBody);
                    this.privRequestSession.onPhraseRecognized(this.privRequestSession.currentTurnAudioOffset + speechPhrase.Offset + speechPhrase.Duration);
                    if (speechPhrase.RecognitionStatus !== (0, $15fen.RecognitionStatus).TooManyRequests && speechPhrase.RecognitionStatus !== (0, $15fen.RecognitionStatus).Error) {
                        const args = this.fireEventForResult(speechPhrase, resultProps);
                        this.privLastResult = args.result;
                        if (!!this.privDialogServiceConnector.recognized) try {
                            this.privDialogServiceConnector.recognized(this.privDialogServiceConnector, args);
                        /* tslint:disable:no-empty */ } catch (error) {
                        // Not going to let errors in the event handler
                        // trip things up.
                        }
                    }
                    processed = true;
                    break;
                case "speech.hypothesis":
                    const hypothesis = (0, $QS7Xa.SpeechHypothesis).fromJSON(connectionMessage.textBody);
                    const offset = hypothesis.Offset + this.privRequestSession.currentTurnAudioOffset;
                    result = new (0, $cBVoI.SpeechRecognitionResult)(this.privRequestSession.requestId, (0, $dptOd.ResultReason).RecognizingSpeech, hypothesis.Text, hypothesis.Duration, offset, hypothesis.Language, hypothesis.LanguageDetectionConfidence, undefined, undefined, connectionMessage.textBody, resultProps);
                    this.privRequestSession.onHypothesis(offset);
                    const ev = new (0, $evfM9.SpeechRecognitionEventArgs)(result, hypothesis.Duration, this.privRequestSession.sessionId);
                    if (!!this.privDialogServiceConnector.recognizing) try {
                        this.privDialogServiceConnector.recognizing(this.privDialogServiceConnector, ev);
                    /* tslint:disable:no-empty */ } catch (error) {
                    // Not going to let errors in the event handler
                    // trip things up.
                    }
                    processed = true;
                    break;
                case "speech.keyword":
                    const keyword = (0, $b1X1y.SpeechKeyword).fromJSON(connectionMessage.textBody);
                    result = new (0, $cBVoI.SpeechRecognitionResult)(this.privRequestSession.requestId, keyword.Status === "Accepted" ? (0, $dptOd.ResultReason).RecognizedKeyword : (0, $dptOd.ResultReason).NoMatch, keyword.Text, keyword.Duration, keyword.Offset, undefined, undefined, undefined, undefined, connectionMessage.textBody, resultProps);
                    if (keyword.Status !== "Accepted") this.privLastResult = result;
                    const event = new (0, $evfM9.SpeechRecognitionEventArgs)(result, result.duration, result.resultId);
                    if (!!this.privDialogServiceConnector.recognized) try {
                        this.privDialogServiceConnector.recognized(this.privDialogServiceConnector, event);
                    /* tslint:disable:no-empty */ } catch (error) {
                    // Not going to let errors in the event handler
                    // trip things up.
                    }
                    processed = true;
                    break;
                case "audio":
                    {
                        const audioRequestId = connectionMessage.requestId.toUpperCase();
                        const turn = this.privTurnStateManager.GetTurn(audioRequestId);
                        try {
                            // Empty binary message signals end of stream.
                            if (!connectionMessage.binaryBody) turn.endAudioStream();
                            else turn.audioStream.write(connectionMessage.binaryBody);
                        } catch (error) {
                        // Not going to let errors in the event handler
                        // trip things up.
                        }
                    }
                    processed = true;
                    break;
                case "response":
                    this.handleResponseMessage(connectionMessage);
                    processed = true;
                    break;
                default:
                    break;
            }
            return processed;
        });
    }
    // Cancels recognition.
    cancelRecognition(sessionId, requestId, cancellationReason, errorCode, error) {
        return $d005ed8fd82e217e$var$__awaiter(this, void 0, void 0, function*() {
            this.terminateMessageLoop = true;
            if (!!this.privRequestSession.isRecognizing) yield this.privRequestSession.onStopRecognizing();
            if (!!this.privDialogServiceConnector.canceled) {
                const properties = new (0, $eDSF6.PropertyCollection)();
                properties.setProperty((0, $g6k3z.CancellationErrorCodePropertyName), (0, $8g0TV.CancellationErrorCode)[errorCode]);
                const cancelEvent = new (0, $b9O7R.SpeechRecognitionCanceledEventArgs)(cancellationReason, error, errorCode, undefined, sessionId);
                try {
                    this.privDialogServiceConnector.canceled(this.privDialogServiceConnector, cancelEvent);
                /* tslint:disable:no-empty */ } catch (_a) {}
                if (!!this.privSuccessCallback) {
                    const result = new (0, $cBVoI.SpeechRecognitionResult)(undefined, (0, $dptOd.ResultReason).Canceled, undefined, undefined, undefined, undefined, undefined, undefined, error, undefined, properties);
                    try {
                        this.privSuccessCallback(result);
                        this.privSuccessCallback = undefined;
                    /* tslint:disable:no-empty */ } catch (_b) {}
                }
            }
        });
    }
    listenOnce(recoMode, successCallback, errorCallback) {
        return $d005ed8fd82e217e$var$__awaiter(this, void 0, void 0, function*() {
            this.privRecognizerConfig.recognitionMode = recoMode;
            this.privSuccessCallback = successCallback;
            this.privErrorCallback = errorCallback;
            this.privRequestSession.startNewRecognition();
            this.privRequestSession.listenForServiceTelemetry(this.privDialogAudioSource.events);
            this.privRecognizerConfig.parameters.setProperty((0, $jJjdG.PropertyId).Speech_SessionId, this.privRequestSession.sessionId);
            // Start the connection to the service. The promise this will create is stored and will be used by configureConnection().
            const conPromise = this.connectImpl();
            const preAudioPromise = this.sendPreAudioMessages();
            const node = yield this.privDialogAudioSource.attach(this.privRequestSession.audioNodeId);
            const format = yield this.privDialogAudioSource.format;
            const deviceInfo = yield this.privDialogAudioSource.deviceInfo;
            const audioNode = new (0, $cGmX2.ReplayableAudioNode)(node, format.avgBytesPerSec);
            yield this.privRequestSession.onAudioSourceAttachCompleted(audioNode, false);
            this.privRecognizerConfig.SpeechServiceConfig.Context.audio = {
                source: deviceInfo
            };
            try {
                yield conPromise;
                yield preAudioPromise;
            } catch (error) {
                yield this.cancelRecognition(this.privRequestSession.sessionId, this.privRequestSession.requestId, (0, $GCsZL.CancellationReason).Error, (0, $8g0TV.CancellationErrorCode).ConnectionFailure, error);
                return Promise.resolve();
            }
            const sessionStartEventArgs = new (0, $9Pi8Y.SessionEventArgs)(this.privRequestSession.sessionId);
            if (!!this.privRecognizer.sessionStarted) this.privRecognizer.sessionStarted(this.privRecognizer, sessionStartEventArgs);
            const audioSendPromise = this.sendAudio(audioNode);
            // /* tslint:disable:no-empty */
            audioSendPromise.then(()=>{}, (error)=>$d005ed8fd82e217e$var$__awaiter(this, void 0, void 0, function*() {
                    yield this.cancelRecognition(this.privRequestSession.sessionId, this.privRequestSession.requestId, (0, $GCsZL.CancellationReason).Error, (0, $8g0TV.CancellationErrorCode).RuntimeError, error);
                }));
        });
    }
    // Establishes a websocket connection to the end point.
    dialogConnectImpl(connection) {
        this.privConnectionLoop = this.startMessageLoop();
        return connection;
    }
    receiveDialogMessageOverride() {
        // we won't rely on the cascading promises of the connection since we want to continually be available to receive messages
        const communicationCustodian = new (0, $9MSEb.Deferred)();
        const loop = ()=>$d005ed8fd82e217e$var$__awaiter(this, void 0, void 0, function*() {
                try {
                    const isDisposed = this.isDisposed();
                    const terminateMessageLoop = !this.isDisposed() && this.terminateMessageLoop;
                    if (isDisposed || terminateMessageLoop) {
                        // We're done.
                        communicationCustodian.resolve(undefined);
                        return;
                    }
                    const connection = yield this.fetchConnection();
                    const message = yield connection.read();
                    if (!message) return loop();
                    const connectionMessage = (0, $MRQbb.SpeechConnectionMessage).fromConnectionMessage(message);
                    switch(connectionMessage.path.toLowerCase()){
                        case "turn.start":
                            {
                                const turnRequestId = connectionMessage.requestId.toUpperCase();
                                const audioSessionReqId = this.privRequestSession.requestId.toUpperCase();
                                // turn started by the service
                                if (turnRequestId !== audioSessionReqId) this.privTurnStateManager.StartTurn(turnRequestId);
                                else this.privRequestSession.onServiceTurnStartResponse();
                            }
                            break;
                        case "speech.startdetected":
                            const speechStartDetected = (0, $iYdLz.SpeechDetected).fromJSON(connectionMessage.textBody);
                            const speechStartEventArgs = new (0, $lst3T.RecognitionEventArgs)(speechStartDetected.Offset, this.privRequestSession.sessionId);
                            if (!!this.privRecognizer.speechStartDetected) this.privRecognizer.speechStartDetected(this.privRecognizer, speechStartEventArgs);
                            break;
                        case "speech.enddetected":
                            let json;
                            if (connectionMessage.textBody.length > 0) json = connectionMessage.textBody;
                            else // If the request was empty, the JSON returned is empty.
                            json = "{ Offset: 0 }";
                            const speechStopDetected = (0, $iYdLz.SpeechDetected).fromJSON(json);
                            this.privRequestSession.onServiceRecognized(speechStopDetected.Offset + this.privRequestSession.currentTurnAudioOffset);
                            const speechStopEventArgs = new (0, $lst3T.RecognitionEventArgs)(speechStopDetected.Offset + this.privRequestSession.currentTurnAudioOffset, this.privRequestSession.sessionId);
                            if (!!this.privRecognizer.speechEndDetected) this.privRecognizer.speechEndDetected(this.privRecognizer, speechStopEventArgs);
                            break;
                        case "turn.end":
                            {
                                const turnEndRequestId = connectionMessage.requestId.toUpperCase();
                                const audioSessionReqId = this.privRequestSession.requestId.toUpperCase();
                                // turn started by the service
                                if (turnEndRequestId !== audioSessionReqId) this.privTurnStateManager.CompleteTurn(turnEndRequestId);
                                else {
                                    // Audio session turn
                                    const sessionStopEventArgs = new (0, $9Pi8Y.SessionEventArgs)(this.privRequestSession.sessionId);
                                    yield this.privRequestSession.onServiceTurnEndResponse(false);
                                    if (!this.privRecognizerConfig.isContinuousRecognition || this.privRequestSession.isSpeechEnded || !this.privRequestSession.isRecognizing) {
                                        if (!!this.privRecognizer.sessionStopped) this.privRecognizer.sessionStopped(this.privRecognizer, sessionStopEventArgs);
                                    }
                                    // report result to promise.
                                    if (!!this.privSuccessCallback && this.privLastResult) {
                                        try {
                                            this.privSuccessCallback(this.privLastResult);
                                            this.privLastResult = null;
                                        } catch (e) {
                                            if (!!this.privErrorCallback) this.privErrorCallback(e);
                                        }
                                        // Only invoke the call back once.
                                        // and if it's successful don't invoke the
                                        // error after that.
                                        this.privSuccessCallback = undefined;
                                        this.privErrorCallback = undefined;
                                    }
                                }
                            }
                            break;
                        default:
                            if (!this.processTypeSpecificMessages(connectionMessage)) {
                                if (!!this.serviceEvents) this.serviceEvents.onEvent(new (0, $l8CKy.ServiceEvent)(connectionMessage.path.toLowerCase(), connectionMessage.textBody));
                            }
                    }
                    const ret = loop();
                    return ret;
                } catch (error) {
                    this.terminateMessageLoop = true;
                    communicationCustodian.resolve();
                }
            });
        loop().catch((reason)=>{
            (0, $l9cUE.Events).instance.onEvent(new (0, $6p3HD.BackgroundEvent)(reason));
        });
        return communicationCustodian.promise;
    }
    startMessageLoop() {
        return $d005ed8fd82e217e$var$__awaiter(this, void 0, void 0, function*() {
            this.terminateMessageLoop = false;
            try {
                yield this.receiveDialogMessageOverride();
            } catch (error) {
                yield this.cancelRecognition(this.privRequestSession.sessionId, this.privRequestSession.requestId, (0, $GCsZL.CancellationReason).Error, (0, $8g0TV.CancellationErrorCode).RuntimeError, error);
            }
            return Promise.resolve();
        });
    }
    // Takes an established websocket connection to the endpoint and sends speech configuration information.
    configConnection(connection) {
        return $d005ed8fd82e217e$var$__awaiter(this, void 0, void 0, function*() {
            if (this.terminateMessageLoop) {
                this.terminateMessageLoop = false;
                return Promise.reject(`Connection to service terminated.`);
            }
            yield this.sendSpeechServiceConfig(connection, this.privRequestSession, this.privRecognizerConfig.SpeechServiceConfig.serialize());
            yield this.sendAgentConfig(connection);
            return connection;
        });
    }
    sendPreAudioMessages() {
        return $d005ed8fd82e217e$var$__awaiter(this, void 0, void 0, function*() {
            const connection = yield this.fetchConnection();
            this.addKeywordContextData();
            yield this.sendSpeechContext(connection);
            yield this.sendAgentContext(connection);
            yield this.sendWaveHeader(connection);
        });
    }
    fireEventForResult(serviceResult, properties) {
        const resultReason = (0, $28Rmc.EnumTranslation).implTranslateRecognitionResult(serviceResult.RecognitionStatus);
        const offset = serviceResult.Offset + this.privRequestSession.currentTurnAudioOffset;
        const result = new (0, $cBVoI.SpeechRecognitionResult)(this.privRequestSession.requestId, resultReason, serviceResult.DisplayText, serviceResult.Duration, offset, serviceResult.Language, serviceResult.LanguageDetectionConfidence, undefined, undefined, JSON.stringify(serviceResult), properties);
        const ev = new (0, $evfM9.SpeechRecognitionEventArgs)(result, offset, this.privRequestSession.sessionId);
        return ev;
    }
    onEvent(event) {
        this.privEvents.onEvent(event);
        (0, $l9cUE.Events).instance.onEvent(event);
    }
    addKeywordContextData() {
        const keywordPropertyValue = this.privRecognizerConfig.parameters.getProperty("SPEECH-KeywordsToDetect");
        if (keywordPropertyValue === undefined) return;
        const keywordOffsetPropertyValue = this.privRecognizerConfig.parameters.getProperty("SPEECH-KeywordsToDetect-Offsets");
        const keywordDurationPropertyValue = this.privRecognizerConfig.parameters.getProperty("SPEECH-KeywordsToDetect-Durations");
        const keywords = keywordPropertyValue.split(";");
        const keywordOffsets = keywordOffsetPropertyValue === undefined ? [] : keywordOffsetPropertyValue.split(";");
        const keywordDurations = keywordDurationPropertyValue === undefined ? [] : keywordDurationPropertyValue.split(";");
        const keywordDefinitionArray = [];
        for(let i = 0; i < keywords.length; i++){
            const definition = {};
            definition.text = keywords[i];
            if (i < keywordOffsets.length) definition.offset = Number(keywordOffsets[i]);
            if (i < keywordDurations.length) definition.duration = Number(keywordDurations[i]);
            keywordDefinitionArray.push(definition);
        }
        this.speechContext.setSection("invocationSource", "VoiceActivationWithKeyword");
        this.speechContext.setSection("keywordDetection", [
            {
                clientDetectedKeywords: keywordDefinitionArray,
                onReject: {
                    action: "EndOfTurn"
                },
                type: "startTrigger"
            }
        ]);
    }
}

});
parcelRequire.register("j1RgB", function(module, exports) {

$parcel$export(module.exports, "SendingAgentContextMessageEvent", () => $dda76df8497f26ed$export$7ea279b2e8f18604);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.

var $aAKrf = parcelRequire("aAKrf");
class $dda76df8497f26ed$export$8c08a5d7274b175d extends (0, $aAKrf.PlatformEvent) {
    constructor(eventName, eventType = (0, $aAKrf.EventType).Info){
        super(eventName, eventType);
    }
}
class $dda76df8497f26ed$export$7ea279b2e8f18604 extends $dda76df8497f26ed$export$8c08a5d7274b175d {
    constructor(agentConfig){
        super("SendingAgentContextMessageEvent");
        this.privAgentConfig = agentConfig;
    }
    get agentConfig() {
        return this.privAgentConfig;
    }
}

});

parcelRequire.register("5WyXj", function(module, exports) {

$parcel$export(module.exports, "AudioOutputFormatImpl", () => $453d7c002f5e75da$export$53c5e8ad1050e453);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.

var $hmMsi = parcelRequire("hmMsi");

var $bFdRB = parcelRequire("bFdRB");
class $453d7c002f5e75da$export$53c5e8ad1050e453 extends (0, $bFdRB.AudioStreamFormatImpl) {
    /**
     * Creates an instance with the given values.
     * @constructor
     * @param formatTag
     * @param {number} channels - Number of channels.
     * @param {number} samplesPerSec - Samples per second.
     * @param {number} avgBytesPerSec - Average bytes per second.
     * @param {number} blockAlign - Block alignment.
     * @param {number} bitsPerSample - Bits per sample.
     * @param {string} audioFormatString - Audio format string
     * @param {string} requestAudioFormatString - Audio format string sent to service.
     * @param {boolean} hasHeader - If the format has header or not.
     */ constructor(formatTag, channels, samplesPerSec, avgBytesPerSec, blockAlign, bitsPerSample, audioFormatString, requestAudioFormatString, hasHeader){
        super(samplesPerSec, bitsPerSample, channels, formatTag);
        this.formatTag = formatTag;
        this.avgBytesPerSec = avgBytesPerSec;
        this.blockAlign = blockAlign;
        this.priAudioFormatString = audioFormatString;
        this.priRequestAudioFormatString = requestAudioFormatString;
        this.priHasHeader = hasHeader;
    }
    static fromSpeechSynthesisOutputFormat(speechSynthesisOutputFormat) {
        if (speechSynthesisOutputFormat === undefined) return $453d7c002f5e75da$export$53c5e8ad1050e453.getDefaultOutputFormat();
        return $453d7c002f5e75da$export$53c5e8ad1050e453.fromSpeechSynthesisOutputFormatString($453d7c002f5e75da$export$53c5e8ad1050e453.SpeechSynthesisOutputFormatToString[speechSynthesisOutputFormat]);
    }
    static fromSpeechSynthesisOutputFormatString(speechSynthesisOutputFormatString) {
        switch(speechSynthesisOutputFormatString){
            case "raw-8khz-8bit-mono-mulaw":
                return new $453d7c002f5e75da$export$53c5e8ad1050e453((0, $bFdRB.AudioFormatTag).MuLaw, 1, 8000, 8000, 1, 8, speechSynthesisOutputFormatString, speechSynthesisOutputFormatString, false);
            case "riff-16khz-16kbps-mono-siren":
                return new $453d7c002f5e75da$export$53c5e8ad1050e453((0, $bFdRB.AudioFormatTag).Siren, 1, 16000, 2000, 40, 0, speechSynthesisOutputFormatString, "audio-16khz-16kbps-mono-siren", true);
            case "audio-16khz-16kbps-mono-siren":
                return new $453d7c002f5e75da$export$53c5e8ad1050e453((0, $bFdRB.AudioFormatTag).Siren, 1, 16000, 2000, 40, 0, speechSynthesisOutputFormatString, speechSynthesisOutputFormatString, false);
            case "audio-16khz-32kbitrate-mono-mp3":
                return new $453d7c002f5e75da$export$53c5e8ad1050e453((0, $bFdRB.AudioFormatTag).MP3, 1, 16000, 4096, 2, 16, speechSynthesisOutputFormatString, speechSynthesisOutputFormatString, false);
            case "audio-16khz-128kbitrate-mono-mp3":
                return new $453d7c002f5e75da$export$53c5e8ad1050e453((0, $bFdRB.AudioFormatTag).MP3, 1, 16000, 16384, 2, 16, speechSynthesisOutputFormatString, speechSynthesisOutputFormatString, false);
            case "audio-16khz-64kbitrate-mono-mp3":
                return new $453d7c002f5e75da$export$53c5e8ad1050e453((0, $bFdRB.AudioFormatTag).MP3, 1, 16000, 8192, 2, 16, speechSynthesisOutputFormatString, speechSynthesisOutputFormatString, false);
            case "audio-24khz-48kbitrate-mono-mp3":
                return new $453d7c002f5e75da$export$53c5e8ad1050e453((0, $bFdRB.AudioFormatTag).MP3, 1, 24000, 6144, 2, 16, speechSynthesisOutputFormatString, speechSynthesisOutputFormatString, false);
            case "audio-24khz-96kbitrate-mono-mp3":
                return new $453d7c002f5e75da$export$53c5e8ad1050e453((0, $bFdRB.AudioFormatTag).MP3, 1, 24000, 12288, 2, 16, speechSynthesisOutputFormatString, speechSynthesisOutputFormatString, false);
            case "audio-24khz-160kbitrate-mono-mp3":
                return new $453d7c002f5e75da$export$53c5e8ad1050e453((0, $bFdRB.AudioFormatTag).MP3, 1, 24000, 20480, 2, 16, speechSynthesisOutputFormatString, speechSynthesisOutputFormatString, false);
            case "raw-16khz-16bit-mono-truesilk":
                return new $453d7c002f5e75da$export$53c5e8ad1050e453((0, $bFdRB.AudioFormatTag).SILKSkype, 1, 16000, 32000, 2, 16, speechSynthesisOutputFormatString, speechSynthesisOutputFormatString, false);
            case "riff-8khz-16bit-mono-pcm":
                return new $453d7c002f5e75da$export$53c5e8ad1050e453((0, $bFdRB.AudioFormatTag).PCM, 1, 8000, 16000, 2, 16, speechSynthesisOutputFormatString, "raw-8khz-16bit-mono-pcm", true);
            case "riff-24khz-16bit-mono-pcm":
                return new $453d7c002f5e75da$export$53c5e8ad1050e453((0, $bFdRB.AudioFormatTag).PCM, 1, 24000, 48000, 2, 16, speechSynthesisOutputFormatString, "raw-24khz-16bit-mono-pcm", true);
            case "riff-8khz-8bit-mono-mulaw":
                return new $453d7c002f5e75da$export$53c5e8ad1050e453((0, $bFdRB.AudioFormatTag).MuLaw, 1, 8000, 8000, 1, 8, speechSynthesisOutputFormatString, "raw-8khz-8bit-mono-mulaw", true);
            case "raw-16khz-16bit-mono-pcm":
                return new $453d7c002f5e75da$export$53c5e8ad1050e453((0, $bFdRB.AudioFormatTag).PCM, 1, 16000, 32000, 2, 16, speechSynthesisOutputFormatString, "raw-16khz-16bit-mono-pcm", false);
            case "raw-24khz-16bit-mono-pcm":
                return new $453d7c002f5e75da$export$53c5e8ad1050e453((0, $bFdRB.AudioFormatTag).PCM, 1, 24000, 48000, 2, 16, speechSynthesisOutputFormatString, "raw-24khz-16bit-mono-pcm", false);
            case "raw-8khz-16bit-mono-pcm":
                return new $453d7c002f5e75da$export$53c5e8ad1050e453((0, $bFdRB.AudioFormatTag).PCM, 1, 8000, 16000, 2, 16, speechSynthesisOutputFormatString, "raw-8khz-16bit-mono-pcm", false);
            case "ogg-16khz-16bit-mono-opus":
                return new $453d7c002f5e75da$export$53c5e8ad1050e453((0, $bFdRB.AudioFormatTag).OGG_OPUS, 1, 16000, 8192, 2, 16, speechSynthesisOutputFormatString, speechSynthesisOutputFormatString, false);
            case "ogg-24khz-16bit-mono-opus":
                return new $453d7c002f5e75da$export$53c5e8ad1050e453((0, $bFdRB.AudioFormatTag).OGG_OPUS, 1, 24000, 8192, 2, 16, speechSynthesisOutputFormatString, speechSynthesisOutputFormatString, false);
            case "raw-48khz-16bit-mono-pcm":
                return new $453d7c002f5e75da$export$53c5e8ad1050e453((0, $bFdRB.AudioFormatTag).PCM, 1, 48000, 96000, 2, 16, speechSynthesisOutputFormatString, "raw-48khz-16bit-mono-pcm", false);
            case "riff-48khz-16bit-mono-pcm":
                return new $453d7c002f5e75da$export$53c5e8ad1050e453((0, $bFdRB.AudioFormatTag).PCM, 1, 48000, 96000, 2, 16, speechSynthesisOutputFormatString, "raw-48khz-16bit-mono-pcm", true);
            case "audio-48khz-96kbitrate-mono-mp3":
                return new $453d7c002f5e75da$export$53c5e8ad1050e453((0, $bFdRB.AudioFormatTag).MP3, 1, 48000, 12288, 2, 16, speechSynthesisOutputFormatString, speechSynthesisOutputFormatString, false);
            case "audio-48khz-192kbitrate-mono-mp3":
                return new $453d7c002f5e75da$export$53c5e8ad1050e453((0, $bFdRB.AudioFormatTag).MP3, 1, 48000, 24576, 2, 16, speechSynthesisOutputFormatString, speechSynthesisOutputFormatString, false);
            case "ogg-48khz-16bit-mono-opus":
                return new $453d7c002f5e75da$export$53c5e8ad1050e453((0, $bFdRB.AudioFormatTag).OGG_OPUS, 1, 48000, 12000, 2, 16, speechSynthesisOutputFormatString, speechSynthesisOutputFormatString, false);
            case "webm-16khz-16bit-mono-opus":
                return new $453d7c002f5e75da$export$53c5e8ad1050e453((0, $bFdRB.AudioFormatTag).WEBM_OPUS, 1, 16000, 8000, 2, 16, speechSynthesisOutputFormatString, speechSynthesisOutputFormatString, false);
            case "webm-24khz-16bit-mono-opus":
                return new $453d7c002f5e75da$export$53c5e8ad1050e453((0, $bFdRB.AudioFormatTag).WEBM_OPUS, 1, 24000, 8000, 2, 16, speechSynthesisOutputFormatString, speechSynthesisOutputFormatString, false);
            case "raw-24khz-16bit-mono-truesilk":
                return new $453d7c002f5e75da$export$53c5e8ad1050e453((0, $bFdRB.AudioFormatTag).SILKSkype, 1, 24000, 48000, 2, 16, speechSynthesisOutputFormatString, speechSynthesisOutputFormatString, false);
            case "raw-8khz-8bit-mono-alaw":
                return new $453d7c002f5e75da$export$53c5e8ad1050e453((0, $bFdRB.AudioFormatTag).ALaw, 1, 8000, 8000, 1, 8, speechSynthesisOutputFormatString, speechSynthesisOutputFormatString, false);
            case "riff-8khz-8bit-mono-alaw":
                return new $453d7c002f5e75da$export$53c5e8ad1050e453((0, $bFdRB.AudioFormatTag).ALaw, 1, 8000, 8000, 1, 8, speechSynthesisOutputFormatString, "raw-8khz-8bit-mono-alaw", true);
            case "riff-16khz-16bit-mono-pcm":
            default:
                return new $453d7c002f5e75da$export$53c5e8ad1050e453((0, $bFdRB.AudioFormatTag).PCM, 1, 16000, 32000, 2, 16, "riff-16khz-16bit-mono-pcm", "raw-16khz-16bit-mono-pcm", true);
        }
    }
    static getDefaultOutputFormat() {
        return $453d7c002f5e75da$export$53c5e8ad1050e453.fromSpeechSynthesisOutputFormatString(typeof window !== "undefined" ? "audio-24khz-48kbitrate-mono-mp3" : "riff-16khz-16bit-mono-pcm");
    }
    /**
     * Specifies if this audio output format has a header
     * @boolean AudioOutputFormatImpl.prototype.hasHeader
     * @function
     * @public
     */ get hasHeader() {
        return this.priHasHeader;
    }
    /**
     * Specifies the header of this format
     * @ArrayBuffer AudioOutputFormatImpl.prototype.header
     * @function
     * @public
     */ get header() {
        if (this.hasHeader) return this.privHeader;
        return undefined;
    }
    /**
     * Updates the header based on the audio length
     * @member AudioOutputFormatImpl.updateHeader
     * @function
     * @public
     * @param {number} audioLength - the audio length
     */ updateHeader(audioLength) {
        if (this.priHasHeader) {
            const view = new DataView(this.privHeader);
            view.setUint32(40, audioLength, true);
        }
    }
    /**
     * Specifies the audio format string to be sent to the service
     * @string AudioOutputFormatImpl.prototype.requestAudioFormatString
     * @function
     * @public
     */ get requestAudioFormatString() {
        return this.priRequestAudioFormatString;
    }
}
$453d7c002f5e75da$export$53c5e8ad1050e453.SpeechSynthesisOutputFormatToString = {
    [(0, $hmMsi.SpeechSynthesisOutputFormat).Raw8Khz8BitMonoMULaw]: "raw-8khz-8bit-mono-mulaw",
    [(0, $hmMsi.SpeechSynthesisOutputFormat).Riff16Khz16KbpsMonoSiren]: "riff-16khz-16kbps-mono-siren",
    [(0, $hmMsi.SpeechSynthesisOutputFormat).Audio16Khz16KbpsMonoSiren]: "audio-16khz-16kbps-mono-siren",
    [(0, $hmMsi.SpeechSynthesisOutputFormat).Audio16Khz32KBitRateMonoMp3]: "audio-16khz-32kbitrate-mono-mp3",
    [(0, $hmMsi.SpeechSynthesisOutputFormat).Audio16Khz128KBitRateMonoMp3]: "audio-16khz-128kbitrate-mono-mp3",
    [(0, $hmMsi.SpeechSynthesisOutputFormat).Audio16Khz64KBitRateMonoMp3]: "audio-16khz-64kbitrate-mono-mp3",
    [(0, $hmMsi.SpeechSynthesisOutputFormat).Audio24Khz48KBitRateMonoMp3]: "audio-24khz-48kbitrate-mono-mp3",
    [(0, $hmMsi.SpeechSynthesisOutputFormat).Audio24Khz96KBitRateMonoMp3]: "audio-24khz-96kbitrate-mono-mp3",
    [(0, $hmMsi.SpeechSynthesisOutputFormat).Audio24Khz160KBitRateMonoMp3]: "audio-24khz-160kbitrate-mono-mp3",
    [(0, $hmMsi.SpeechSynthesisOutputFormat).Raw16Khz16BitMonoTrueSilk]: "raw-16khz-16bit-mono-truesilk",
    [(0, $hmMsi.SpeechSynthesisOutputFormat).Riff16Khz16BitMonoPcm]: "riff-16khz-16bit-mono-pcm",
    [(0, $hmMsi.SpeechSynthesisOutputFormat).Riff8Khz16BitMonoPcm]: "riff-8khz-16bit-mono-pcm",
    [(0, $hmMsi.SpeechSynthesisOutputFormat).Riff24Khz16BitMonoPcm]: "riff-24khz-16bit-mono-pcm",
    [(0, $hmMsi.SpeechSynthesisOutputFormat).Riff8Khz8BitMonoMULaw]: "riff-8khz-8bit-mono-mulaw",
    [(0, $hmMsi.SpeechSynthesisOutputFormat).Raw16Khz16BitMonoPcm]: "raw-16khz-16bit-mono-pcm",
    [(0, $hmMsi.SpeechSynthesisOutputFormat).Raw24Khz16BitMonoPcm]: "raw-24khz-16bit-mono-pcm",
    [(0, $hmMsi.SpeechSynthesisOutputFormat).Raw8Khz16BitMonoPcm]: "raw-8khz-16bit-mono-pcm",
    [(0, $hmMsi.SpeechSynthesisOutputFormat).Ogg16Khz16BitMonoOpus]: "ogg-16khz-16bit-mono-opus",
    [(0, $hmMsi.SpeechSynthesisOutputFormat).Ogg24Khz16BitMonoOpus]: "ogg-24khz-16bit-mono-opus",
    [(0, $hmMsi.SpeechSynthesisOutputFormat).Raw48Khz16BitMonoPcm]: "raw-48khz-16bit-mono-pcm",
    [(0, $hmMsi.SpeechSynthesisOutputFormat).Riff48Khz16BitMonoPcm]: "riff-48khz-16bit-mono-pcm",
    [(0, $hmMsi.SpeechSynthesisOutputFormat).Audio48Khz96KBitRateMonoMp3]: "audio-48khz-96kbitrate-mono-mp3",
    [(0, $hmMsi.SpeechSynthesisOutputFormat).Audio48Khz192KBitRateMonoMp3]: "audio-48khz-192kbitrate-mono-mp3",
    [(0, $hmMsi.SpeechSynthesisOutputFormat).Ogg48Khz16BitMonoOpus]: "ogg-48khz-16bit-mono-opus",
    [(0, $hmMsi.SpeechSynthesisOutputFormat).Webm16Khz16BitMonoOpus]: "webm-16khz-16bit-mono-opus",
    [(0, $hmMsi.SpeechSynthesisOutputFormat).Webm24Khz16BitMonoOpus]: "webm-24khz-16bit-mono-opus",
    [(0, $hmMsi.SpeechSynthesisOutputFormat).Raw24Khz16BitMonoTrueSilk]: "raw-24khz-16bit-mono-truesilk",
    [(0, $hmMsi.SpeechSynthesisOutputFormat).Raw8Khz8BitMonoALaw]: "raw-8khz-8bit-mono-alaw",
    [(0, $hmMsi.SpeechSynthesisOutputFormat).Riff8Khz8BitMonoALaw]: "riff-8khz-8bit-mono-alaw"
};

});
parcelRequire.register("hmMsi", function(module, exports) {

$parcel$export(module.exports, "SpeechSynthesisOutputFormat", () => $ca4a13f75cfd6200$export$3671c0863ecfe8a6);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
/**
 * Define speech synthesis audio output formats.
 * @enum SpeechSynthesisOutputFormat
 * Updated in version 1.17.0
 */ var $ca4a13f75cfd6200$export$3671c0863ecfe8a6;
(function(SpeechSynthesisOutputFormat) {
    /**
     * raw-8khz-8bit-mono-mulaw
     * @member SpeechSynthesisOutputFormat.Raw8Khz8BitMonoMULaw,
     */ SpeechSynthesisOutputFormat[SpeechSynthesisOutputFormat["Raw8Khz8BitMonoMULaw"] = 0] = "Raw8Khz8BitMonoMULaw";
    /**
     * riff-16khz-16kbps-mono-siren
     * @note Unsupported by the service. Do not use this value.
     * @member SpeechSynthesisOutputFormat.Riff16Khz16KbpsMonoSiren
     */ SpeechSynthesisOutputFormat[SpeechSynthesisOutputFormat["Riff16Khz16KbpsMonoSiren"] = 1] = "Riff16Khz16KbpsMonoSiren";
    /**
     * audio-16khz-16kbps-mono-siren
     * @note Unsupported by the service. Do not use this value.
     * @member SpeechSynthesisOutputFormat.Audio16Khz16KbpsMonoSiren
     */ SpeechSynthesisOutputFormat[SpeechSynthesisOutputFormat["Audio16Khz16KbpsMonoSiren"] = 2] = "Audio16Khz16KbpsMonoSiren";
    /**
     * audio-16khz-32kbitrate-mono-mp3
     * @member SpeechSynthesisOutputFormat.Audio16Khz32KBitRateMonoMp3
     */ SpeechSynthesisOutputFormat[SpeechSynthesisOutputFormat["Audio16Khz32KBitRateMonoMp3"] = 3] = "Audio16Khz32KBitRateMonoMp3";
    /**
     * audio-16khz-128kbitrate-mono-mp3
     * @member SpeechSynthesisOutputFormat.Audio16Khz128KBitRateMonoMp3
     */ SpeechSynthesisOutputFormat[SpeechSynthesisOutputFormat["Audio16Khz128KBitRateMonoMp3"] = 4] = "Audio16Khz128KBitRateMonoMp3";
    /**
     * audio-16khz-64kbitrate-mono-mp3
     * @member SpeechSynthesisOutputFormat.Audio16Khz64KBitRateMonoMp3
     */ SpeechSynthesisOutputFormat[SpeechSynthesisOutputFormat["Audio16Khz64KBitRateMonoMp3"] = 5] = "Audio16Khz64KBitRateMonoMp3";
    /**
     * audio-24khz-48kbitrate-mono-mp3
     * @member SpeechSynthesisOutputFormat.Audio24Khz48KBitRateMonoMp3
     */ SpeechSynthesisOutputFormat[SpeechSynthesisOutputFormat["Audio24Khz48KBitRateMonoMp3"] = 6] = "Audio24Khz48KBitRateMonoMp3";
    /**
     * audio-24khz-96kbitrate-mono-mp3
     * @member SpeechSynthesisOutputFormat.Audio24Khz96KBitRateMonoMp3
     */ SpeechSynthesisOutputFormat[SpeechSynthesisOutputFormat["Audio24Khz96KBitRateMonoMp3"] = 7] = "Audio24Khz96KBitRateMonoMp3";
    /**
     * audio-24khz-160kbitrate-mono-mp3
     * @member SpeechSynthesisOutputFormat.Audio24Khz160KBitRateMonoMp3
     */ SpeechSynthesisOutputFormat[SpeechSynthesisOutputFormat["Audio24Khz160KBitRateMonoMp3"] = 8] = "Audio24Khz160KBitRateMonoMp3";
    /**
     * raw-16khz-16bit-mono-truesilk
     * @member SpeechSynthesisOutputFormat.Raw16Khz16BitMonoTrueSilk
     */ SpeechSynthesisOutputFormat[SpeechSynthesisOutputFormat["Raw16Khz16BitMonoTrueSilk"] = 9] = "Raw16Khz16BitMonoTrueSilk";
    /**
     * riff-16khz-16bit-mono-pcm
     * @member SpeechSynthesisOutputFormat.Riff16Khz16BitMonoPcm
     */ SpeechSynthesisOutputFormat[SpeechSynthesisOutputFormat["Riff16Khz16BitMonoPcm"] = 10] = "Riff16Khz16BitMonoPcm";
    /**
     * riff-8khz-16bit-mono-pcm
     * @member SpeechSynthesisOutputFormat.Riff8Khz16BitMonoPcm
     */ SpeechSynthesisOutputFormat[SpeechSynthesisOutputFormat["Riff8Khz16BitMonoPcm"] = 11] = "Riff8Khz16BitMonoPcm";
    /**
     * riff-24khz-16bit-mono-pcm
     * @member SpeechSynthesisOutputFormat.Riff24Khz16BitMonoPcm
     */ SpeechSynthesisOutputFormat[SpeechSynthesisOutputFormat["Riff24Khz16BitMonoPcm"] = 12] = "Riff24Khz16BitMonoPcm";
    /**
     * riff-8khz-8bit-mono-mulaw
     * @member SpeechSynthesisOutputFormat.Riff8Khz8BitMonoMULaw
     */ SpeechSynthesisOutputFormat[SpeechSynthesisOutputFormat["Riff8Khz8BitMonoMULaw"] = 13] = "Riff8Khz8BitMonoMULaw";
    /**
     * raw-16khz-16bit-mono-pcm
     * @member SpeechSynthesisOutputFormat.Raw16Khz16BitMonoPcm
     */ SpeechSynthesisOutputFormat[SpeechSynthesisOutputFormat["Raw16Khz16BitMonoPcm"] = 14] = "Raw16Khz16BitMonoPcm";
    /**
     * raw-24khz-16bit-mono-pcm
     * @member SpeechSynthesisOutputFormat.Raw24Khz16BitMonoPcm
     */ SpeechSynthesisOutputFormat[SpeechSynthesisOutputFormat["Raw24Khz16BitMonoPcm"] = 15] = "Raw24Khz16BitMonoPcm";
    /**
     * raw-8khz-16bit-mono-pcm
     * @member SpeechSynthesisOutputFormat.Raw8Khz16BitMonoPcm
     */ SpeechSynthesisOutputFormat[SpeechSynthesisOutputFormat["Raw8Khz16BitMonoPcm"] = 16] = "Raw8Khz16BitMonoPcm";
    /**
     * ogg-16khz-16bit-mono-opus
     * @member SpeechSynthesisOutputFormat.Ogg16Khz16BitMonoOpus
     */ SpeechSynthesisOutputFormat[SpeechSynthesisOutputFormat["Ogg16Khz16BitMonoOpus"] = 17] = "Ogg16Khz16BitMonoOpus";
    /**
     * ogg-24khz-16bit-mono-opus
     * @member SpeechSynthesisOutputFormat.Ogg24Khz16BitMonoOpus
     */ SpeechSynthesisOutputFormat[SpeechSynthesisOutputFormat["Ogg24Khz16BitMonoOpus"] = 18] = "Ogg24Khz16BitMonoOpus";
    /**
     * raw-48khz-16bit-mono-pcm
     * @member SpeechSynthesisOutputFormat.Raw48Khz16BitMonoPcm
     */ SpeechSynthesisOutputFormat[SpeechSynthesisOutputFormat["Raw48Khz16BitMonoPcm"] = 19] = "Raw48Khz16BitMonoPcm";
    /**
     * riff-48khz-16bit-mono-pcm
     * @member SpeechSynthesisOutputFormat.Riff48Khz16BitMonoPcm
     */ SpeechSynthesisOutputFormat[SpeechSynthesisOutputFormat["Riff48Khz16BitMonoPcm"] = 20] = "Riff48Khz16BitMonoPcm";
    /**
     * audio-48khz-96kbitrate-mono-mp3
     * @member SpeechSynthesisOutputFormat.Audio48Khz96KBitRateMonoMp3
     */ SpeechSynthesisOutputFormat[SpeechSynthesisOutputFormat["Audio48Khz96KBitRateMonoMp3"] = 21] = "Audio48Khz96KBitRateMonoMp3";
    /**
     * audio-48khz-192kbitrate-mono-mp3
     * @member SpeechSynthesisOutputFormat.Audio48Khz192KBitRateMonoMp3
     */ SpeechSynthesisOutputFormat[SpeechSynthesisOutputFormat["Audio48Khz192KBitRateMonoMp3"] = 22] = "Audio48Khz192KBitRateMonoMp3";
    /**
     * ogg-48khz-16bit-mono-opus
     * Added in version 1.16.0
     * @member SpeechSynthesisOutputFormat.Ogg48Khz16BitMonoOpus
     */ SpeechSynthesisOutputFormat[SpeechSynthesisOutputFormat["Ogg48Khz16BitMonoOpus"] = 23] = "Ogg48Khz16BitMonoOpus";
    /**
     * webm-16khz-16bit-mono-opus
     * Added in version 1.16.0
     * @member SpeechSynthesisOutputFormat.Webm16Khz16BitMonoOpus
     */ SpeechSynthesisOutputFormat[SpeechSynthesisOutputFormat["Webm16Khz16BitMonoOpus"] = 24] = "Webm16Khz16BitMonoOpus";
    /**
     * webm-24khz-16bit-mono-opus
     * Added in version 1.16.0
     * @member SpeechSynthesisOutputFormat.Webm24Khz16BitMonoOpus
     */ SpeechSynthesisOutputFormat[SpeechSynthesisOutputFormat["Webm24Khz16BitMonoOpus"] = 25] = "Webm24Khz16BitMonoOpus";
    /**
     * raw-24khz-16bit-mono-truesilk
     * Added in version 1.17.0
     * @member SpeechSynthesisOutputFormat.Raw24Khz16BitMonoTrueSilk
     */ SpeechSynthesisOutputFormat[SpeechSynthesisOutputFormat["Raw24Khz16BitMonoTrueSilk"] = 26] = "Raw24Khz16BitMonoTrueSilk";
    /**
     * raw-8khz-8bit-mono-alaw
     * Added in version 1.17.0
     * @member SpeechSynthesisOutputFormat.Raw8Khz8BitMonoALaw
     */ SpeechSynthesisOutputFormat[SpeechSynthesisOutputFormat["Raw8Khz8BitMonoALaw"] = 27] = "Raw8Khz8BitMonoALaw";
    /**
     * riff-8khz-8bit-mono-alaw
     * Added in version 1.17.0
     * @member SpeechSynthesisOutputFormat.Riff8Khz8BitMonoALaw
     */ SpeechSynthesisOutputFormat[SpeechSynthesisOutputFormat["Riff8Khz8BitMonoALaw"] = 28] = "Riff8Khz8BitMonoALaw";
})($ca4a13f75cfd6200$export$3671c0863ecfe8a6 || ($ca4a13f75cfd6200$export$3671c0863ecfe8a6 = {}));

});

parcelRequire.register("bFdRB", function(module, exports) {

$parcel$export(module.exports, "AudioFormatTag", () => $87de470b83136fe3$export$97592a59cf8dc84a);
$parcel$export(module.exports, "AudioStreamFormat", () => $87de470b83136fe3$export$2d50fcba14d14cb0);
$parcel$export(module.exports, "AudioStreamFormatImpl", () => $87de470b83136fe3$export$22b9ff0cbb278347);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
var $87de470b83136fe3$export$97592a59cf8dc84a;
(function(AudioFormatTag) {
    AudioFormatTag[AudioFormatTag["PCM"] = 1] = "PCM";
    AudioFormatTag[AudioFormatTag["MuLaw"] = 2] = "MuLaw";
    AudioFormatTag[AudioFormatTag["Siren"] = 3] = "Siren";
    AudioFormatTag[AudioFormatTag["MP3"] = 4] = "MP3";
    AudioFormatTag[AudioFormatTag["SILKSkype"] = 5] = "SILKSkype";
    AudioFormatTag[AudioFormatTag["OGG_OPUS"] = 6] = "OGG_OPUS";
    AudioFormatTag[AudioFormatTag["WEBM_OPUS"] = 7] = "WEBM_OPUS";
    AudioFormatTag[AudioFormatTag["ALaw"] = 8] = "ALaw";
})($87de470b83136fe3$export$97592a59cf8dc84a || ($87de470b83136fe3$export$97592a59cf8dc84a = {}));
class $87de470b83136fe3$export$2d50fcba14d14cb0 {
    /**
     * Creates an audio stream format object representing the default audio stream
     * format (16KHz 16bit mono PCM).
     * @member AudioStreamFormat.getDefaultInputFormat
     * @function
     * @public
     * @returns {AudioStreamFormat} The audio stream format being created.
     */ static getDefaultInputFormat() {
        return $87de470b83136fe3$export$22b9ff0cbb278347.getDefaultInputFormat();
    }
    /**
     * Creates an audio stream format object with the specified pcm waveformat characteristics.
     * @member AudioStreamFormat.getWaveFormatPCM
     * @function
     * @public
     * @param {number} samplesPerSecond - Sample rate, in samples per second (Hertz).
     * @param {number} bitsPerSample - Bits per sample, typically 16.
     * @param {number} channels - Number of channels in the waveform-audio data. Monaural data
     *        uses one channel and stereo data uses two channels.
     * @returns {AudioStreamFormat} The audio stream format being created.
     */ static getWaveFormatPCM(samplesPerSecond, bitsPerSample, channels) {
        return new $87de470b83136fe3$export$22b9ff0cbb278347(samplesPerSecond, bitsPerSample, channels);
    }
}
class $87de470b83136fe3$export$22b9ff0cbb278347 extends $87de470b83136fe3$export$2d50fcba14d14cb0 {
    /**
     * Creates an instance with the given values.
     * @constructor
     * @param {number} samplesPerSec - Samples per second.
     * @param {number} bitsPerSample - Bits per sample.
     * @param {number} channels - Number of channels.
     * @param {AudioFormatTag} format - Audio format (PCM, alaw or mulaw).
     */ constructor(samplesPerSec = 16000, bitsPerSample = 16, channels = 1, format = $87de470b83136fe3$export$97592a59cf8dc84a.PCM){
        super();
        this.setString = (view, offset, str)=>{
            for(let i = 0; i < str.length; i++)view.setUint8(offset + i, str.charCodeAt(i));
        };
        /* 1 for PCM; 6 for alaw; 7 for mulaw */ switch(format){
            case $87de470b83136fe3$export$97592a59cf8dc84a.PCM:
                this.formatTag = 1;
                break;
            case $87de470b83136fe3$export$97592a59cf8dc84a.ALaw:
                this.formatTag = 6;
                break;
            case $87de470b83136fe3$export$97592a59cf8dc84a.MuLaw:
                this.formatTag = 7;
                break;
            default:
        }
        this.bitsPerSample = bitsPerSample;
        this.samplesPerSec = samplesPerSec;
        this.channels = channels;
        this.avgBytesPerSec = this.samplesPerSec * this.channels * (this.bitsPerSample / 8);
        this.blockAlign = this.channels * Math.max(this.bitsPerSample, 8);
        this.privHeader = new ArrayBuffer(44);
        // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DataView
        const view = new DataView(this.privHeader);
        /* RIFF identifier */ this.setString(view, 0, "RIFF");
        /* file length */ view.setUint32(4, 0, true);
        /* RIFF type & Format */ this.setString(view, 8, "WAVEfmt ");
        /* format chunk length */ view.setUint32(16, 16, true);
        /* audio format */ view.setUint16(20, this.formatTag, true);
        /* channel count */ view.setUint16(22, this.channels, true);
        /* sample rate */ view.setUint32(24, this.samplesPerSec, true);
        /* byte rate (sample rate * block align) */ view.setUint32(28, this.avgBytesPerSec, true);
        /* block align (channel count * bytes per sample) */ view.setUint16(32, this.channels * (this.bitsPerSample / 8), true);
        /* bits per sample */ view.setUint16(34, this.bitsPerSample, true);
        /* data chunk identifier */ this.setString(view, 36, "data");
        /* data chunk length */ view.setUint32(40, 0, true);
    }
    /**
     * Retrieves the default input format.
     * @member AudioStreamFormatImpl.getDefaultInputFormat
     * @function
     * @public
     * @returns {AudioStreamFormatImpl} The default input format.
     */ static getDefaultInputFormat() {
        return new $87de470b83136fe3$export$22b9ff0cbb278347();
    }
    /**
     * Creates an audio context appropriate to current browser
     * @member AudioStreamFormatImpl.getAudioContext
     * @function
     * @public
     * @returns {AudioContext} An audio context instance
     */ static getAudioContext(sampleRate) {
        // Workaround for Speech SDK bug in Safari.
        const AudioContext = window.AudioContext // our preferred impl
         || window.webkitAudioContext // fallback, mostly when on Safari
         || false; // could not find.
        // https://developer.mozilla.org/en-US/docs/Web/API/AudioContext
        if (!!AudioContext) {
            if (sampleRate !== undefined && navigator.mediaDevices.getSupportedConstraints().sampleRate) return new AudioContext({
                sampleRate: sampleRate
            });
            else return new AudioContext();
        } else throw new Error("Browser does not support Web Audio API (AudioContext is not available).");
    }
    /**
     * Closes the configuration object.
     * @member AudioStreamFormatImpl.prototype.close
     * @function
     * @public
     */ close() {
        return;
    }
    get header() {
        return this.privHeader;
    }
}

});


parcelRequire.register("fHq4P", function(module, exports) {

$parcel$export(module.exports, "ActivityReceivedEventArgs", () => $b6df19830b5e6b3c$export$1a8a3934f34e049c);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
/**
 * Defines contents of received message/events.
 * @class ActivityReceivedEventArgs
 */ class $b6df19830b5e6b3c$export$1a8a3934f34e049c {
    /**
     * Creates and initializes an instance of this class.
     * @constructor
     * @param {any} activity - The activity..
     */ constructor(activity, audioStream){
        this.privActivity = activity;
        this.privAudioStream = audioStream;
    }
    /**
     * Gets the received activity
     * @member ActivityReceivedEventArgs.prototype.activity
     * @function
     * @public
     * @returns {any} the received activity.
     */ get activity() {
        return this.privActivity;
    }
    get audioStream() {
        return this.privAudioStream;
    }
}

});

parcelRequire.register("9Xv9r", function(module, exports) {

$parcel$export(module.exports, "DialogServiceConfig", () => $7401c9bf0509c029$export$dff5a88488f70ec8);
$parcel$export(module.exports, "DialogServiceConfigImpl", () => $7401c9bf0509c029$export$77638a68c815581e);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.

var $gSYyK = parcelRequire("gSYyK");

var $jJjdG = parcelRequire("jJjdG");
var $j5i8M = parcelRequire("j5i8M");
var $7401c9bf0509c029$var$_a;
class $7401c9bf0509c029$export$dff5a88488f70ec8 {
    /**
     * Creates an instance of DialogService config.
     * @constructor
     */ constructor(){}
    /**
     * Sets the corresponding backend application identifier.
     * @member DialogServiceConfig.prototype.Conversation_ApplicationId
     * @function
     * @public
     * @param {string} value - The application identifier to set.
     */ // tslint:disable-next-line: no-empty
    set applicationId(value) {}
}
$7401c9bf0509c029$export$dff5a88488f70ec8.DialogTypes = ($7401c9bf0509c029$var$_a = class {
}, $7401c9bf0509c029$var$_a.BotFramework = "bot_framework", $7401c9bf0509c029$var$_a.CustomCommands = "custom_commands", $7401c9bf0509c029$var$_a);
class $7401c9bf0509c029$export$77638a68c815581e extends $7401c9bf0509c029$export$dff5a88488f70ec8 {
    /**
     * Creates an instance of dialogService config.
     */ constructor(){
        super();
        this.privSpeechConfig = new (0, $j5i8M.SpeechConfigImpl)();
    }
    /**
     * Provides access to custom properties.
     * @member DialogServiceConfigImpl.prototype.properties
     * @function
     * @public
     * @returns {PropertyCollection} The properties.
     */ get properties() {
        return this.privSpeechConfig.properties;
    }
    /**
     * Gets the speech recognition language.
     * @member DialogServiceConfigImpl.prototype.speechRecognitionLanguage
     * @function
     * @public
     */ get speechRecognitionLanguage() {
        return this.privSpeechConfig.speechRecognitionLanguage;
    }
    /**
     * Sets the speech recognition language.
     * @member DialogServiceConfigImpl.prototype.speechRecognitionLanguage
     * @function
     * @public
     * @param {string} value - The language to set.
     */ set speechRecognitionLanguage(value) {
        (0, $gSYyK.Contracts).throwIfNullOrWhitespace(value, "value");
        this.privSpeechConfig.speechRecognitionLanguage = value;
    }
    get outputFormat() {
        return this.privSpeechConfig.outputFormat;
    }
    set outputFormat(value) {
        this.privSpeechConfig.outputFormat = value;
    }
    /**
     * Sets a named property as value
     * @member DialogServiceConfigImpl.prototype.setProperty
     * @function
     * @public
     * @param {PropertyId | string} name - The property to set.
     * @param {string} value - The value.
     */ setProperty(name, value) {
        this.privSpeechConfig.setProperty(name, value);
    }
    /**
     * Sets a named property as value
     * @member DialogServiceConfigImpl.prototype.getProperty
     * @function
     * @public
     * @param {PropertyId | string} name - The property to get.
     * @param {string} def - The default value to return in case the property is not known.
     * @returns {string} The current value, or provided default, of the given property.
     */ getProperty(name, def) {
        return this.privSpeechConfig.getProperty(name);
    }
    /**
     * Sets the proxy configuration.
     * Only relevant in Node.js environments.
     * Added in version 1.4.0.
     * @param proxyHostName The host name of the proxy server, without the protocol scheme (http://)
     * @param proxyPort The port number of the proxy server.
     * @param proxyUserName The user name of the proxy server.
     * @param proxyPassword The password of the proxy server.
     */ setProxy(proxyHostName, proxyPort, proxyUserName, proxyPassword) {
        this.setProperty((0, $jJjdG.PropertyId).SpeechServiceConnection_ProxyHostName, proxyHostName);
        this.setProperty((0, $jJjdG.PropertyId).SpeechServiceConnection_ProxyPort, `${proxyPort}`);
        if (proxyUserName) this.setProperty((0, $jJjdG.PropertyId).SpeechServiceConnection_ProxyUserName, proxyUserName);
        if (proxyPassword) this.setProperty((0, $jJjdG.PropertyId).SpeechServiceConnection_ProxyPassword, proxyPassword);
    }
    setServiceProperty(name, value, channel) {
        this.privSpeechConfig.setServiceProperty(name, value, channel);
    }
    /**
     * Dispose of associated resources.
     * @member DialogServiceConfigImpl.prototype.close
     * @function
     * @public
     */ close() {
        return;
    }
}

});
parcelRequire.register("gSYyK", function(module, exports) {

$parcel$export(module.exports, "Contracts", () => $c4b0aa59cbf72335$export$e93adfd13fa159ba);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
/**
 * @class Contracts
 * @private
 */ class $c4b0aa59cbf72335$export$e93adfd13fa159ba {
    static throwIfNullOrUndefined(param, name) {
        if (param === undefined || param === null) throw new Error("throwIfNullOrUndefined:" + name);
    }
    static throwIfNull(param, name) {
        if (param === null) throw new Error("throwIfNull:" + name);
    }
    static throwIfNullOrWhitespace(param, name) {
        $c4b0aa59cbf72335$export$e93adfd13fa159ba.throwIfNullOrUndefined(param, name);
        if (("" + param).trim().length < 1) throw new Error("throwIfNullOrWhitespace:" + name);
    }
    static throwIfDisposed(isDisposed) {
        if (isDisposed) throw new Error("the object is already disposed");
    }
    static throwIfArrayEmptyOrWhitespace(array, name) {
        $c4b0aa59cbf72335$export$e93adfd13fa159ba.throwIfNullOrUndefined(array, name);
        if (array.length === 0) throw new Error("throwIfArrayEmptyOrWhitespace:" + name);
        for (const item of array)$c4b0aa59cbf72335$export$e93adfd13fa159ba.throwIfNullOrWhitespace(item, name);
    }
    static throwIfFileDoesNotExist(param, name) {
        $c4b0aa59cbf72335$export$e93adfd13fa159ba.throwIfNullOrWhitespace(param, name);
    // TODO check for file existence.
    }
    static throwIfNotUndefined(param, name) {
        if (param !== undefined) throw new Error("throwIfNotUndefined:" + name);
    }
}

});

parcelRequire.register("j5i8M", function(module, exports) {

$parcel$export(module.exports, "SpeechConfigImpl", () => $de4c8e51da86291b$export$974c5658476a7259);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.

var $g6k3z = parcelRequire("g6k3z");

var $gSYyK = parcelRequire("gSYyK");

var $5tg4o = parcelRequire("5tg4o");
var $jJdfb = parcelRequire("jJdfb");
var $eDSF6 = parcelRequire("eDSF6");
var $jJjdG = parcelRequire("jJjdG");
var $hmMsi = parcelRequire("hmMsi");
class $de4c8e51da86291b$export$de011cb7b5310b31 {
    /**
     * Creates and initializes an instance.
     * @constructor
     */ constructor(){}
    /**
     * Static instance of SpeechConfig returned by passing subscriptionKey and service region.
     * Note: Please use your LanguageUnderstanding subscription key in case you want to use the Intent recognizer.
     * @member SpeechConfig.fromSubscription
     * @function
     * @public
     * @param {string} subscriptionKey - The subscription key.
     * @param {string} region - The region name (see the <a href="https://aka.ms/csspeech/region">region page</a>).
     * @returns {SpeechConfig} The speech factory
     */ static fromSubscription(subscriptionKey, region) {
        (0, $gSYyK.Contracts).throwIfNullOrWhitespace(subscriptionKey, "subscriptionKey");
        (0, $gSYyK.Contracts).throwIfNullOrWhitespace(region, "region");
        const speechImpl = new $de4c8e51da86291b$export$974c5658476a7259();
        speechImpl.setProperty((0, $jJjdG.PropertyId).SpeechServiceConnection_Region, region);
        speechImpl.setProperty((0, $jJjdG.PropertyId).SpeechServiceConnection_IntentRegion, region);
        speechImpl.setProperty((0, $jJjdG.PropertyId).SpeechServiceConnection_Key, subscriptionKey);
        return speechImpl;
    }
    /**
     * Creates an instance of the speech config with specified endpoint and subscription key.
     * This method is intended only for users who use a non-standard service endpoint or parameters.
     * Note: Please use your LanguageUnderstanding subscription key in case you want to use the Intent recognizer.
     * Note: The query parameters specified in the endpoint URL are not changed, even if they are set by any other APIs.
     * For example, if language is defined in the uri as query parameter "language=de-DE", and also set by
     *              SpeechConfig.speechRecognitionLanguage = "en-US", the language setting in uri takes precedence,
     *              and the effective language is "de-DE". Only the parameters that are not specified in the
     *              endpoint URL can be set by other APIs.
     * Note: To use authorization token with fromEndpoint, pass an empty string to the subscriptionKey in the
     *       fromEndpoint method, and then set authorizationToken="token" on the created SpeechConfig instance to
     *       use the authorization token.
     * @member SpeechConfig.fromEndpoint
     * @function
     * @public
     * @param {URL} endpoint - The service endpoint to connect to.
     * @param {string} subscriptionKey - The subscription key. If a subscription key is not specified, an authorization token must be set.
     * @returns {SpeechConfig} A speech factory instance.
     */ static fromEndpoint(endpoint, subscriptionKey) {
        (0, $gSYyK.Contracts).throwIfNull(endpoint, "endpoint");
        const speechImpl = new $de4c8e51da86291b$export$974c5658476a7259();
        speechImpl.setProperty((0, $jJjdG.PropertyId).SpeechServiceConnection_Endpoint, endpoint.href);
        if (undefined !== subscriptionKey) speechImpl.setProperty((0, $jJjdG.PropertyId).SpeechServiceConnection_Key, subscriptionKey);
        return speechImpl;
    }
    /**
     * Creates an instance of the speech config with specified host and subscription key.
     * This method is intended only for users who use a non-default service host. Standard resource path will be assumed.
     * For services with a non-standard resource path or no path at all, use fromEndpoint instead.
     * Note: Query parameters are not allowed in the host URI and must be set by other APIs.
     * Note: To use an authorization token with fromHost, use fromHost(URL),
     * and then set the AuthorizationToken property on the created SpeechConfig instance.
     * Note: Added in version 1.9.0.
     * @member SpeechConfig.fromHost
     * @function
     * @public
     * @param {URL} host - The service endpoint to connect to. Format is "protocol://host:port" where ":port" is optional.
     * @param {string} subscriptionKey - The subscription key. If a subscription key is not specified, an authorization token must be set.
     * @returns {SpeechConfig} A speech factory instance.
     */ static fromHost(hostName, subscriptionKey) {
        (0, $gSYyK.Contracts).throwIfNull(hostName, "hostName");
        const speechImpl = new $de4c8e51da86291b$export$974c5658476a7259();
        speechImpl.setProperty((0, $jJjdG.PropertyId).SpeechServiceConnection_Host, hostName.protocol + "//" + hostName.hostname + (hostName.port === "" ? "" : ":" + hostName.port));
        if (undefined !== subscriptionKey) speechImpl.setProperty((0, $jJjdG.PropertyId).SpeechServiceConnection_Key, subscriptionKey);
        return speechImpl;
    }
    /**
     * Creates an instance of the speech factory with specified initial authorization token and region.
     * Note: The caller needs to ensure that the authorization token is valid. Before the authorization token
     *       expires, the caller needs to refresh it by calling this setter with a new valid token.
     * Note: Please use a token derived from your LanguageUnderstanding subscription key in case you want
     *       to use the Intent recognizer. As configuration values are copied when creating a new recognizer,
     *       the new token value will not apply to recognizers that have already been created. For recognizers
     *       that have been created before, you need to set authorization token of the corresponding recognizer
     *       to refresh the token. Otherwise, the recognizers will encounter errors during recognition.
     * @member SpeechConfig.fromAuthorizationToken
     * @function
     * @public
     * @param {string} authorizationToken - The initial authorization token.
     * @param {string} region - The region name (see the <a href="https://aka.ms/csspeech/region">region page</a>).
     * @returns {SpeechConfig} A speech factory instance.
     */ static fromAuthorizationToken(authorizationToken, region) {
        (0, $gSYyK.Contracts).throwIfNull(authorizationToken, "authorizationToken");
        (0, $gSYyK.Contracts).throwIfNullOrWhitespace(region, "region");
        const speechImpl = new $de4c8e51da86291b$export$974c5658476a7259();
        speechImpl.setProperty((0, $jJjdG.PropertyId).SpeechServiceConnection_Region, region);
        speechImpl.setProperty((0, $jJjdG.PropertyId).SpeechServiceConnection_IntentRegion, region);
        speechImpl.authorizationToken = authorizationToken;
        return speechImpl;
    }
    /**
     * Closes the configuration.
     * @member SpeechConfig.prototype.close
     * @function
     * @public
     */ /* tslint:disable:no-empty */ close() {}
}
class $de4c8e51da86291b$export$974c5658476a7259 extends $de4c8e51da86291b$export$de011cb7b5310b31 {
    constructor(){
        super();
        this.privProperties = new (0, $eDSF6.PropertyCollection)();
        this.speechRecognitionLanguage = "en-US"; // Should we have a default?
        this.outputFormat = (0, $5tg4o.OutputFormat).Simple;
    }
    get properties() {
        return this.privProperties;
    }
    get endPoint() {
        return new URL(this.privProperties.getProperty((0, $jJjdG.PropertyId).SpeechServiceConnection_Endpoint));
    }
    get subscriptionKey() {
        return this.privProperties.getProperty((0, $jJjdG.PropertyId).SpeechServiceConnection_Key);
    }
    get region() {
        return this.privProperties.getProperty((0, $jJjdG.PropertyId).SpeechServiceConnection_Region);
    }
    get authorizationToken() {
        return this.privProperties.getProperty((0, $jJjdG.PropertyId).SpeechServiceAuthorization_Token);
    }
    set authorizationToken(value) {
        this.privProperties.setProperty((0, $jJjdG.PropertyId).SpeechServiceAuthorization_Token, value);
    }
    get speechRecognitionLanguage() {
        return this.privProperties.getProperty((0, $jJjdG.PropertyId).SpeechServiceConnection_RecoLanguage);
    }
    set speechRecognitionLanguage(value) {
        this.privProperties.setProperty((0, $jJjdG.PropertyId).SpeechServiceConnection_RecoLanguage, value);
    }
    get autoDetectSourceLanguages() {
        return this.privProperties.getProperty((0, $jJjdG.PropertyId).SpeechServiceConnection_AutoDetectSourceLanguages);
    }
    set autoDetectSourceLanguages(value) {
        this.privProperties.setProperty((0, $jJjdG.PropertyId).SpeechServiceConnection_AutoDetectSourceLanguages, value);
    }
    get outputFormat() {
        return (0, $5tg4o.OutputFormat)[this.privProperties.getProperty((0, $g6k3z.OutputFormatPropertyName), undefined)];
    }
    set outputFormat(value) {
        this.privProperties.setProperty((0, $g6k3z.OutputFormatPropertyName), (0, $5tg4o.OutputFormat)[value]);
    }
    get endpointId() {
        return this.privProperties.getProperty((0, $jJjdG.PropertyId).SpeechServiceConnection_EndpointId);
    }
    set endpointId(value) {
        this.privProperties.setProperty((0, $jJjdG.PropertyId).SpeechServiceConnection_EndpointId, value);
    }
    setProperty(name, value) {
        (0, $gSYyK.Contracts).throwIfNull(value, "value");
        this.privProperties.setProperty(name, value);
    }
    getProperty(name, def) {
        return this.privProperties.getProperty(name, def);
    }
    setProxy(proxyHostName, proxyPort, proxyUserName, proxyPassword) {
        this.setProperty((0, $jJjdG.PropertyId)[(0, $jJjdG.PropertyId).SpeechServiceConnection_ProxyHostName], proxyHostName);
        this.setProperty((0, $jJjdG.PropertyId)[(0, $jJjdG.PropertyId).SpeechServiceConnection_ProxyPort], proxyPort);
        this.setProperty((0, $jJjdG.PropertyId)[(0, $jJjdG.PropertyId).SpeechServiceConnection_ProxyUserName], proxyUserName);
        this.setProperty((0, $jJjdG.PropertyId)[(0, $jJjdG.PropertyId).SpeechServiceConnection_ProxyPassword], proxyPassword);
    }
    setServiceProperty(name, value, channel) {
        const currentProperties = JSON.parse(this.privProperties.getProperty((0, $g6k3z.ServicePropertiesPropertyName), "{}"));
        currentProperties[name] = value;
        this.privProperties.setProperty((0, $g6k3z.ServicePropertiesPropertyName), JSON.stringify(currentProperties));
    }
    setProfanity(profanity) {
        this.privProperties.setProperty((0, $jJjdG.PropertyId).SpeechServiceResponse_ProfanityOption, (0, $jJdfb.ProfanityOption)[profanity]);
    }
    enableAudioLogging() {
        this.privProperties.setProperty((0, $jJjdG.PropertyId).SpeechServiceConnection_EnableAudioLogging, "true");
    }
    requestWordLevelTimestamps() {
        this.privProperties.setProperty((0, $jJjdG.PropertyId).SpeechServiceResponse_RequestWordLevelTimestamps, "true");
    }
    enableDictation() {
        this.privProperties.setProperty((0, $g6k3z.ForceDictationPropertyName), "true");
    }
    clone() {
        const ret = new $de4c8e51da86291b$export$974c5658476a7259();
        ret.privProperties = this.privProperties.clone();
        return ret;
    }
    get speechSynthesisLanguage() {
        return this.privProperties.getProperty((0, $jJjdG.PropertyId).SpeechServiceConnection_SynthLanguage);
    }
    set speechSynthesisLanguage(language) {
        this.privProperties.setProperty((0, $jJjdG.PropertyId).SpeechServiceConnection_SynthLanguage, language);
    }
    get speechSynthesisVoiceName() {
        return this.privProperties.getProperty((0, $jJjdG.PropertyId).SpeechServiceConnection_SynthVoice);
    }
    set speechSynthesisVoiceName(voice) {
        this.privProperties.setProperty((0, $jJjdG.PropertyId).SpeechServiceConnection_SynthVoice, voice);
    }
    get speechSynthesisOutputFormat() {
        return (0, $hmMsi.SpeechSynthesisOutputFormat)[this.privProperties.getProperty((0, $jJjdG.PropertyId).SpeechServiceConnection_SynthOutputFormat, undefined)];
    }
    set speechSynthesisOutputFormat(format) {
        this.privProperties.setProperty((0, $jJjdG.PropertyId).SpeechServiceConnection_SynthOutputFormat, (0, $hmMsi.SpeechSynthesisOutputFormat)[format]);
    }
}

});
parcelRequire.register("jJdfb", function(module, exports) {

$parcel$export(module.exports, "ProfanityOption", () => $e5cc7e3db4cf3cdf$export$84f426873273f221);
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
/**
 * Profanity option.
 * Added in version 1.7.0.
 */ var $e5cc7e3db4cf3cdf$export$84f426873273f221;
(function(ProfanityOption) {
    ProfanityOption[ProfanityOption["Masked"] = 0] = "Masked";
    ProfanityOption[ProfanityOption["Removed"] = 1] = "Removed";
    ProfanityOption[ProfanityOption["Raw"] = 2] = "Raw";
})($e5cc7e3db4cf3cdf$export$84f426873273f221 || ($e5cc7e3db4cf3cdf$export$84f426873273f221 = {}));

});



parcelRequire.register("etyPc", function(module, exports) {

$parcel$export(module.exports, "TurnStatusReceivedEventArgs", () => $a89ec99ce64a275b$export$5ce0e8ca4b442b8a);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.

var $5VNI8 = parcelRequire("5VNI8");
class $a89ec99ce64a275b$export$5ce0e8ca4b442b8a {
    /**
     * Creates and initializes an instance of this class.
     * @constructor
     * @param {string} turnStatus - The JSON-encoded turn status message.
     */ constructor(turnStatus){
        this.privTurnStatus = (0, $5VNI8.TurnStatusResponsePayload).fromJSON(turnStatus);
    }
    /**
     * Gets the interaction identifier associated with this turn status event.
     * @member TurnStatusReceivedEventArgs.prototype.interactionId
     * @function
     * @public
     * @returns {any} the received interaction id.
     */ get interactionId() {
        return this.privTurnStatus.interactionId;
    }
    /**
     * Gets the conversation identifier associated with this turn status event.
     * @member TurnStatusReceivedEventArgs.prototype.conversationId
     * @function
     * @public
     * @returns {any} the received conversation id.
     */ get conversationId() {
        return this.privTurnStatus.conversationId;
    }
    /**
     * Gets the received turn status code.
     * @member TurnStatusReceivedEventArgs.prototype.statusCode
     * @function
     * @public
     * @returns {number} the received turn status.
     */ get statusCode() {
        return this.privTurnStatus.statusCode;
    }
}

});
parcelRequire.register("5VNI8", function(module, exports) {

$parcel$export(module.exports, "TurnStatusResponsePayload", () => $4518d62dd3032437$export$844c4df474757a2d);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
class $4518d62dd3032437$export$844c4df474757a2d {
    constructor(json){
        this.privMessageStatusResponse = JSON.parse(json);
    }
    static fromJSON(json) {
        return new $4518d62dd3032437$export$844c4df474757a2d(json);
    }
    get interactionId() {
        return this.privMessageStatusResponse.interactionId;
    }
    get conversationId() {
        return this.privMessageStatusResponse.conversationId;
    }
    get statusCode() {
        // Payloads may contain a limited set of textual representations or a numeric status
        // code. The textual values are here converted into numeric ones.
        switch(this.privMessageStatusResponse.statusCode){
            case "Success":
                return 200;
            case "Failed":
                return 400;
            case "TimedOut":
                return 429;
            default:
                return this.privMessageStatusResponse.statusCode;
        }
    }
}

});


parcelRequire.register("3Ea4Y", function(module, exports) {

$parcel$export(module.exports, "DialogServiceTurnStateManager", () => $2a7ced0fd12eb0e2$export$6277820b28ebdcfc);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.

var $4Cx0W = parcelRequire("4Cx0W");

var $fNPp0 = parcelRequire("fNPp0");
class $2a7ced0fd12eb0e2$export$6277820b28ebdcfc {
    constructor(){
        this.privTurnMap = new Map();
        return;
    }
    StartTurn(id) {
        if (this.privTurnMap.has(id)) throw new (0, $4Cx0W.InvalidOperationError)("Service error: There is already a turn with id:" + id);
        const turnState = new (0, $fNPp0.DialogServiceTurnState)(this, id);
        this.privTurnMap.set(id, turnState);
        return this.privTurnMap.get(id);
    }
    GetTurn(id) {
        return this.privTurnMap.get(id);
    }
    CompleteTurn(id) {
        if (!this.privTurnMap.has(id)) throw new (0, $4Cx0W.InvalidOperationError)("Service error: Received turn end for an unknown turn id:" + id);
        const turnState = this.privTurnMap.get(id);
        turnState.complete();
        this.privTurnMap.delete(id);
        return turnState;
    }
}

});
parcelRequire.register("fNPp0", function(module, exports) {

$parcel$export(module.exports, "DialogServiceTurnState", () => $b8134e10b72fd7a0$export$3bb70bcf565a069a);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.

var $5WyXj = parcelRequire("5WyXj");

var $eijUb = parcelRequire("eijUb");

var $8Efdj = parcelRequire("8Efdj");
class $b8134e10b72fd7a0$export$3bb70bcf565a069a {
    constructor(manager, requestId){
        this.privRequestId = requestId;
        this.privIsCompleted = false;
        this.privAudioStream = null;
        this.privTurnManager = manager;
        this.resetTurnEndTimeout();
    // tslint:disable-next-line:no-console
    // console.info("DialogServiceTurnState debugturn start:" + this.privRequestId);
    }
    get audioStream() {
        // Called when is needed to stream.
        this.resetTurnEndTimeout();
        return this.privAudioStream;
    }
    processActivityPayload(payload, audioFormat) {
        if (payload.messageDataStreamType === (0, $8Efdj.MessageDataStreamType).TextToSpeechAudio) {
            this.privAudioStream = (0, $eijUb.AudioOutputStream).createPullStream();
            this.privAudioStream.format = audioFormat !== undefined ? audioFormat : (0, $5WyXj.AudioOutputFormatImpl).getDefaultOutputFormat();
        // tslint:disable-next-line:no-console
        // console.info("Audio start debugturn:" + this.privRequestId);
        }
        return this.privAudioStream;
    }
    endAudioStream() {
        if (this.privAudioStream !== null && !this.privAudioStream.isClosed) this.privAudioStream.close();
    }
    complete() {
        if (this.privTimeoutToken !== undefined) clearTimeout(this.privTimeoutToken);
        this.endAudioStream();
    }
    resetTurnEndTimeout() {
        if (this.privTimeoutToken !== undefined) clearTimeout(this.privTimeoutToken);
        // tslint:disable-next-line:no-console
        // console.info("Timeout reset debugturn:" + this.privRequestId);
        this.privTimeoutToken = setTimeout(()=>{
            // tslint:disable-next-line:no-console
            // console.info("Timeout complete debugturn:" + this.privRequestId);
            this.privTurnManager.CompleteTurn(this.privRequestId);
            return;
        }, 2000);
    }
}

});
parcelRequire.register("eijUb", function(module, exports) {

$parcel$export(module.exports, "AudioOutputStream", () => $a6822fe3bbaca9a0$export$e0b7acef3648253f);
$parcel$export(module.exports, "PullAudioOutputStream", () => $a6822fe3bbaca9a0$export$bdc5f48d2816203a);
$parcel$export(module.exports, "PullAudioOutputStreamImpl", () => $a6822fe3bbaca9a0$export$ccb0817f052cc8c4);
$parcel$export(module.exports, "PushAudioOutputStream", () => $a6822fe3bbaca9a0$export$cabdb2d97c90043d);
$parcel$export(module.exports, "PushAudioOutputStreamImpl", () => $a6822fe3bbaca9a0$export$8469916a21360061);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
parcelRequire("3KVS5");
var $kSC7p = parcelRequire("kSC7p");
var $5PiFE = parcelRequire("5PiFE");

var $gSYyK = parcelRequire("gSYyK");

var $5WyXj = parcelRequire("5WyXj");
var $a6822fe3bbaca9a0$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
class $a6822fe3bbaca9a0$export$e0b7acef3648253f {
    /**
     * Creates and initializes an instance.
     * @constructor
     */ constructor(){}
    /**
     * Creates a memory backed PullAudioOutputStream with the specified audio format.
     * @member AudioOutputStream.createPullStream
     * @function
     * @public
     * @returns {PullAudioOutputStream} The audio output stream being created.
     */ static createPullStream() {
        return $a6822fe3bbaca9a0$export$bdc5f48d2816203a.create();
    }
}
class $a6822fe3bbaca9a0$export$bdc5f48d2816203a extends $a6822fe3bbaca9a0$export$e0b7acef3648253f {
    /**
     * Creates a memory backed PullAudioOutputStream with the specified audio format.
     * @member PullAudioOutputStream.create
     * @function
     * @public
     * @returns {PullAudioOutputStream} The push audio output stream being created.
     */ static create() {
        return new $a6822fe3bbaca9a0$export$ccb0817f052cc8c4();
    }
}
class $a6822fe3bbaca9a0$export$ccb0817f052cc8c4 extends $a6822fe3bbaca9a0$export$bdc5f48d2816203a {
    /**
     * Creates and initializes an instance with the given values.
     * @constructor
     */ constructor(){
        super();
        this.privId = (0, $kSC7p.createNoDashGuid)();
        this.privStream = new (0, $5PiFE.Stream)();
    }
    /**
     * Sets the format information to the stream. For internal use only.
     * @param {AudioStreamFormat} format - the format to be set.
     */ set format(format) {
        if (format === undefined || format === null) this.privFormat = (0, $5WyXj.AudioOutputFormatImpl).getDefaultOutputFormat();
        this.privFormat = format;
    }
    /**
     * Format information for the audio
     */ get format() {
        return this.privFormat;
    }
    /**
     * Checks if the stream is closed
     * @member PullAudioOutputStreamImpl.prototype.isClosed
     * @property
     * @public
     */ get isClosed() {
        return this.privStream.isClosed;
    }
    /**
     * Gets the id of the stream
     * @member PullAudioOutputStreamImpl.prototype.id
     * @property
     * @public
     */ id() {
        return this.privId;
    }
    /**
     * Reads audio data from the internal buffer.
     * @member PullAudioOutputStreamImpl.prototype.read
     * @function
     * @public
     * @param {ArrayBuffer} dataBuffer - An ArrayBuffer to store the read data.
     * @returns {Promise<number>} - Audio buffer length has been read.
     */ read(dataBuffer) {
        return $a6822fe3bbaca9a0$var$__awaiter(this, void 0, void 0, function*() {
            const intView = new Int8Array(dataBuffer);
            let totalBytes = 0;
            if (this.privLastChunkView !== undefined) {
                if (this.privLastChunkView.length > dataBuffer.byteLength) {
                    intView.set(this.privLastChunkView.slice(0, dataBuffer.byteLength));
                    this.privLastChunkView = this.privLastChunkView.slice(dataBuffer.byteLength);
                    return Promise.resolve(dataBuffer.byteLength);
                }
                intView.set(this.privLastChunkView);
                totalBytes = this.privLastChunkView.length;
                this.privLastChunkView = undefined;
            }
            // Until we have the minimum number of bytes to send in a transmission, keep asking for more.
            while(totalBytes < dataBuffer.byteLength && !this.privStream.isReadEnded){
                const chunk = yield this.privStream.read();
                if (chunk !== undefined && !chunk.isEnd) {
                    let tmpBuffer;
                    if (chunk.buffer.byteLength > dataBuffer.byteLength - totalBytes) {
                        tmpBuffer = chunk.buffer.slice(0, dataBuffer.byteLength - totalBytes);
                        this.privLastChunkView = new Int8Array(chunk.buffer.slice(dataBuffer.byteLength - totalBytes));
                    } else tmpBuffer = chunk.buffer;
                    intView.set(new Int8Array(tmpBuffer), totalBytes);
                    totalBytes += tmpBuffer.byteLength;
                } else yield this.privStream.readEnded();
            }
            return totalBytes;
        });
    }
    /**
     * Writes the audio data specified by making an internal copy of the data.
     * @member PullAudioOutputStreamImpl.prototype.write
     * @function
     * @public
     * @param {ArrayBuffer} dataBuffer - The audio buffer of which this function will make a copy.
     */ write(dataBuffer) {
        (0, $gSYyK.Contracts).throwIfNullOrUndefined(this.privStream, "must set format before writing");
        this.privStream.writeStreamChunk({
            buffer: dataBuffer,
            isEnd: false,
            timeReceived: Date.now()
        });
    }
    /**
     * Closes the stream.
     * @member PullAudioOutputStreamImpl.prototype.close
     * @function
     * @public
     */ close() {
        this.privStream.close();
    }
}
class $a6822fe3bbaca9a0$export$cabdb2d97c90043d extends $a6822fe3bbaca9a0$export$e0b7acef3648253f {
    /**
     * Creates and initializes and instance.
     * @constructor
     */ constructor(){
        super();
    }
    /**
     * Creates a PushAudioOutputStream that delegates to the specified callback interface for
     * write() and close() methods.
     * @member PushAudioOutputStream.create
     * @function
     * @public
     * @param {PushAudioOutputStreamCallback} callback - The custom audio output object,
     *        derived from PushAudioOutputStreamCallback
     * @returns {PushAudioOutputStream} The push audio output stream being created.
     */ static create(callback) {
        return new $a6822fe3bbaca9a0$export$8469916a21360061(callback);
    }
}
class $a6822fe3bbaca9a0$export$8469916a21360061 extends $a6822fe3bbaca9a0$export$cabdb2d97c90043d {
    /**
     * Creates a PushAudioOutputStream that delegates to the specified callback interface for
     * read() and close() methods.
     * @constructor
     * @param {PushAudioOutputStreamCallback} callback - The custom audio output object,
     *        derived from PushAudioOutputStreamCallback
     */ constructor(callback){
        super();
        this.privId = (0, $kSC7p.createNoDashGuid)();
        this.privCallback = callback;
    }
    // tslint:disable-next-line:no-empty
    set format(format) {}
    write(buffer) {
        if (!!this.privCallback.write) this.privCallback.write(buffer);
    }
    close() {
        if (!!this.privCallback.close) this.privCallback.close();
    }
    id() {
        return this.privId;
    }
}

});

parcelRequire.register("8Efdj", function(module, exports) {

$parcel$export(module.exports, "ActivityPayloadResponse", () => $64bddc4bcd8e7464$export$32a9af590766ce14);
$parcel$export(module.exports, "MessageDataStreamType", () => $64bddc4bcd8e7464$export$f73f8c1ce60bb199);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
// response
class $64bddc4bcd8e7464$export$32a9af590766ce14 {
    constructor(json){
        this.privActivityResponse = JSON.parse(json);
    }
    static fromJSON(json) {
        return new $64bddc4bcd8e7464$export$32a9af590766ce14(json);
    }
    get conversationId() {
        return this.privActivityResponse.conversationId;
    }
    get messageDataStreamType() {
        return this.privActivityResponse.messageDataStreamType;
    }
    get messagePayload() {
        return this.privActivityResponse.messagePayload;
    }
    get version() {
        return this.privActivityResponse.version;
    }
}
var $64bddc4bcd8e7464$export$f73f8c1ce60bb199;
(function(MessageDataStreamType) {
    MessageDataStreamType[MessageDataStreamType["None"] = 0] = "None";
    MessageDataStreamType[MessageDataStreamType["TextToSpeechAudio"] = 1] = "TextToSpeechAudio";
})($64bddc4bcd8e7464$export$f73f8c1ce60bb199 || ($64bddc4bcd8e7464$export$f73f8c1ce60bb199 = {}));

});




parcelRequire.register("jzrBu", function(module, exports) {

$parcel$export(module.exports, "AgentConfig", () => $e3f6b2badad5d909$export$561104de51a59cce);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
/**
 * Represents the JSON used in the agent.config message sent to the speech service.
 */ class $e3f6b2badad5d909$export$561104de51a59cce {
    toJsonString() {
        return JSON.stringify(this.iPrivConfig);
    }
    get() {
        return this.iPrivConfig;
    }
    /**
     * Setter for the agent.config object.
     * @param value a JSON serializable object.
     */ set(value) {
        this.iPrivConfig = value;
    }
}

});

parcelRequire.register("8gNBb", function(module, exports) {

$parcel$export(module.exports, "MetadataType", () => $60564a9ea17625a6$export$aaf15ef60576e95);
$parcel$export(module.exports, "SynthesisAudioMetadata", () => $60564a9ea17625a6$export$82529c92128bfe6c);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
var $60564a9ea17625a6$export$aaf15ef60576e95;
(function(MetadataType) {
    MetadataType["WordBoundary"] = "WordBoundary";
    MetadataType["Bookmark"] = "Bookmark";
    MetadataType["Viseme"] = "Viseme";
})($60564a9ea17625a6$export$aaf15ef60576e95 || ($60564a9ea17625a6$export$aaf15ef60576e95 = {}));
class $60564a9ea17625a6$export$82529c92128bfe6c {
    constructor(json){
        this.privSynthesisAudioMetadata = JSON.parse(json);
    }
    static fromJSON(json) {
        return new $60564a9ea17625a6$export$82529c92128bfe6c(json);
    }
    get Metadata() {
        return this.privSynthesisAudioMetadata.Metadata;
    }
}

});

parcelRequire.register("fDfnQ", function(module, exports) {

$parcel$export(module.exports, "SynthesisTurn", () => $b6166e5eb27706f9$export$ffc1d5309a5caa5f);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
parcelRequire("3KVS5");
var $9MSEb = parcelRequire("9MSEb");
var $l9cUE = parcelRequire("l9cUE");
var $kSC7p = parcelRequire("kSC7p");

var $eijUb = parcelRequire("eijUb");

var $5e6W5 = parcelRequire("5e6W5");

var $6tbTG = parcelRequire("6tbTG");
var $b6166e5eb27706f9$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
class $b6166e5eb27706f9$export$ffc1d5309a5caa5f {
    constructor(){
        this.privIsDisposed = false;
        this.privIsSynthesizing = false;
        this.privIsSynthesisEnded = false;
        this.privBytesReceived = 0;
        this.privInTurn = false;
        this.privTextOffset = 0;
        this.privNextSearchTextIndex = 0;
        this.onPreConnectionStart = (authFetchEventId, connectionId)=>{
            this.privAuthFetchEventId = authFetchEventId;
            this.onEvent(new (0, $6tbTG.ConnectingToSynthesisServiceEvent)(this.privRequestId, this.privAuthFetchEventId));
        };
        this.onAuthCompleted = (isError, error)=>{
            if (isError) this.onComplete();
        };
        this.onConnectionEstablishCompleted = (statusCode, reason)=>{
            if (statusCode === 200) {
                this.onEvent(new (0, $6tbTG.SynthesisStartedEvent)(this.requestId, this.privAuthFetchEventId));
                this.privBytesReceived = 0;
                return;
            } else if (statusCode === 403) this.onComplete();
        };
        this.onServiceResponseMessage = (responseJson)=>{
            const response = JSON.parse(responseJson);
            this.streamId = response.audio.streamId;
        };
        this.onServiceTurnEndResponse = ()=>{
            this.privInTurn = false;
            this.privTurnDeferral.resolve();
            this.onComplete();
        };
        this.onServiceTurnStartResponse = ()=>{
            if (!!this.privTurnDeferral && !!this.privInTurn) {
                // What? How are we starting a turn with another not done?
                this.privTurnDeferral.reject("Another turn started before current completed.");
                // Avoid UnhandledPromiseRejection if privTurnDeferral is not being awaited
                /* tslint:disable:no-empty */ this.privTurnDeferral.promise.then().catch(()=>{});
            }
            this.privInTurn = true;
            this.privTurnDeferral = new (0, $9MSEb.Deferred)();
        };
        this.dispose = (error)=>{
            if (!this.privIsDisposed) // we should have completed by now. If we did not its an unknown error.
            this.privIsDisposed = true;
        };
        this.onEvent = (event)=>{
            (0, $l9cUE.Events).instance.onEvent(event);
        };
        this.onComplete = ()=>{
            if (this.privIsSynthesizing) {
                this.privIsSynthesizing = false;
                this.privIsSynthesisEnded = true;
                this.privAudioOutputStream.close();
                this.privInTurn = false;
                if (this.privTurnAudioDestination !== undefined) {
                    this.privTurnAudioDestination.close();
                    this.privTurnAudioDestination = undefined;
                }
            }
        };
        this.privRequestId = (0, $kSC7p.createNoDashGuid)();
        this.privTurnDeferral = new (0, $9MSEb.Deferred)();
        // We're not in a turn, so resolve.
        this.privTurnDeferral.resolve();
    }
    get requestId() {
        return this.privRequestId;
    }
    get streamId() {
        return this.privStreamId;
    }
    set streamId(value) {
        this.privStreamId = value;
    }
    get audioOutputFormat() {
        return this.privAudioOutputFormat;
    }
    set audioOutputFormat(format) {
        this.privAudioOutputFormat = format;
    }
    get turnCompletionPromise() {
        return this.privTurnDeferral.promise;
    }
    get isSynthesisEnded() {
        return this.privIsSynthesisEnded;
    }
    get isSynthesizing() {
        return this.privIsSynthesizing;
    }
    get currentTextOffset() {
        return this.privTextOffset;
    }
    // The number of bytes received for current turn
    get bytesReceived() {
        return this.privBytesReceived;
    }
    getAllReceivedAudio() {
        return $b6166e5eb27706f9$var$__awaiter(this, void 0, void 0, function*() {
            if (!!this.privReceivedAudio) return Promise.resolve(this.privReceivedAudio);
            if (!this.privIsSynthesisEnded) return null;
            yield this.readAllAudioFromStream();
            return Promise.resolve(this.privReceivedAudio);
        });
    }
    getAllReceivedAudioWithHeader() {
        return $b6166e5eb27706f9$var$__awaiter(this, void 0, void 0, function*() {
            if (!!this.privReceivedAudioWithHeader) return this.privReceivedAudioWithHeader;
            if (!this.privIsSynthesisEnded) return null;
            if (this.audioOutputFormat.hasHeader) {
                const audio = yield this.getAllReceivedAudio();
                this.privReceivedAudioWithHeader = (0, $5e6W5.SynthesisAdapterBase).addHeader(audio, this.audioOutputFormat);
                return this.privReceivedAudioWithHeader;
            } else return this.getAllReceivedAudio();
        });
    }
    startNewSynthesis(requestId, rawText, isSSML, audioDestination) {
        this.privIsSynthesisEnded = false;
        this.privIsSynthesizing = true;
        this.privRequestId = requestId;
        this.privRawText = rawText;
        this.privIsSSML = isSSML;
        this.privAudioOutputStream = new (0, $eijUb.PullAudioOutputStreamImpl)();
        this.privAudioOutputStream.format = this.privAudioOutputFormat;
        this.privReceivedAudio = null;
        this.privReceivedAudioWithHeader = null;
        this.privBytesReceived = 0;
        this.privTextOffset = 0;
        this.privNextSearchTextIndex = 0;
        this.privPartialVisemeAnimation = "";
        if (audioDestination !== undefined) {
            this.privTurnAudioDestination = audioDestination;
            this.privTurnAudioDestination.format = this.privAudioOutputFormat;
        }
        this.onEvent(new (0, $6tbTG.SynthesisTriggeredEvent)(this.requestId, undefined, audioDestination === undefined ? undefined : audioDestination.id()));
    }
    onAudioChunkReceived(data) {
        if (this.isSynthesizing) {
            this.privAudioOutputStream.write(data);
            this.privBytesReceived += data.byteLength;
            if (this.privTurnAudioDestination !== undefined) this.privTurnAudioDestination.write(data);
        }
    }
    onWordBoundaryEvent(text) {
        this.updateTextOffset(text);
    }
    onVisemeMetadataReceived(metadata) {
        if (metadata.Data.AnimationChunk !== undefined) this.privPartialVisemeAnimation += metadata.Data.AnimationChunk;
    }
    onStopSynthesizing() {
        this.onComplete();
    }
    /**
     * Gets the viseme animation string (merged from animation chunk), and clears the internal
     * partial animation.
     */ getAndClearVisemeAnimation() {
        const animation = this.privPartialVisemeAnimation;
        this.privPartialVisemeAnimation = "";
        return animation;
    }
    updateTextOffset(text) {
        if (this.privTextOffset >= 0) {
            this.privTextOffset = this.privRawText.indexOf(text, this.privNextSearchTextIndex);
            if (this.privTextOffset >= 0) this.privNextSearchTextIndex = this.privTextOffset + text.length;
            if (this.privIsSSML) {
                if (this.privRawText.indexOf("<", this.privTextOffset + 1) > this.privRawText.indexOf(">", this.privTextOffset + 1)) this.updateTextOffset(text);
            }
        }
    }
    readAllAudioFromStream() {
        return $b6166e5eb27706f9$var$__awaiter(this, void 0, void 0, function*() {
            if (this.privIsSynthesisEnded) {
                this.privReceivedAudio = new ArrayBuffer(this.bytesReceived);
                try {
                    yield this.privAudioOutputStream.read(this.privReceivedAudio);
                } catch (e) {
                    this.privReceivedAudio = new ArrayBuffer(0);
                }
            }
        });
    }
}

});
parcelRequire.register("5e6W5", function(module, exports) {

$parcel$export(module.exports, "SynthesisAdapterBase", () => $3ce3a3e00aee65b3$export$6a9ae5f91b217634);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
parcelRequire("3KVS5");
var $4gz8B = parcelRequire("4gz8B");
var $4Cx0W = parcelRequire("4Cx0W");
var $76ZQQ = parcelRequire("76ZQQ");
var $l8CKy = parcelRequire("l8CKy");
var $8wq1O = parcelRequire("8wq1O");
var $kSC7p = parcelRequire("kSC7p");

var $8g0TV = parcelRequire("8g0TV");
var $GCsZL = parcelRequire("GCsZL");
var $eDSF6 = parcelRequire("eDSF6");
var $jJjdG = parcelRequire("jJjdG");
var $dptOd = parcelRequire("dptOd");
var $hMSAZ = parcelRequire("hMSAZ");
var $8z6rw = parcelRequire("8z6rw");
var $gYwsC = parcelRequire("gYwsC");
var $2SIlq = parcelRequire("2SIlq");
var $9yqAX = parcelRequire("9yqAX");
parcelRequire("g6k3z");
var $fDfnQ = parcelRequire("fDfnQ");
var $iTkn8 = parcelRequire("iTkn8");
var $jzrBu = parcelRequire("jzrBu");
var $g6k3z = parcelRequire("g6k3z");
var $8gNBb = parcelRequire("8gNBb");

var $MRQbb = parcelRequire("MRQbb");
var $3ce3a3e00aee65b3$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
class $3ce3a3e00aee65b3$export$6a9ae5f91b217634 {
    constructor(authentication, connectionFactory, synthesizerConfig, speechSynthesizer, audioDestination){
        this.speakOverride = undefined;
        this.receiveMessageOverride = undefined;
        this.connectImplOverride = undefined;
        this.configConnectionOverride = undefined;
        this.sendSynthesisContext = (connection)=>{
            const synthesisContextJson = this.synthesisContext.toJSON();
            if (synthesisContextJson) return connection.send(new (0, $MRQbb.SpeechConnectionMessage)((0, $4gz8B.MessageType).Text, "synthesis.context", this.privSynthesisTurn.requestId, "application/json", synthesisContextJson));
            return;
        };
        this.sendSpeechServiceConfig = (connection, SpeechServiceConfigJson)=>{
            if (SpeechServiceConfigJson) return connection.send(new (0, $MRQbb.SpeechConnectionMessage)((0, $4gz8B.MessageType).Text, "speech.config", this.privSynthesisTurn.requestId, "application/json", SpeechServiceConfigJson));
        };
        this.sendSsmlMessage = (connection, ssml, requestId)=>{
            return connection.send(new (0, $MRQbb.SpeechConnectionMessage)((0, $4gz8B.MessageType).Text, "ssml", requestId, "application/ssml+xml", ssml));
        };
        if (!authentication) throw new (0, $4Cx0W.ArgumentNullError)("authentication");
        if (!connectionFactory) throw new (0, $4Cx0W.ArgumentNullError)("connectionFactory");
        if (!synthesizerConfig) throw new (0, $4Cx0W.ArgumentNullError)("synthesizerConfig");
        this.privAuthentication = authentication;
        this.privConnectionFactory = connectionFactory;
        this.privSynthesizerConfig = synthesizerConfig;
        this.privIsDisposed = false;
        this.privSpeechSynthesizer = speechSynthesizer;
        this.privSessionAudioDestination = audioDestination;
        this.privSynthesisTurn = new (0, $fDfnQ.SynthesisTurn)();
        this.privConnectionEvents = new (0, $76ZQQ.EventSource)();
        this.privServiceEvents = new (0, $76ZQQ.EventSource)();
        this.privSynthesisContext = new (0, $iTkn8.SynthesisContext)(this.privSpeechSynthesizer);
        this.privAgentConfig = new (0, $jzrBu.AgentConfig)();
        this.connectionEvents.attach((connectionEvent)=>{
            if (connectionEvent.name === "ConnectionClosedEvent") {
                const connectionClosedEvent = connectionEvent;
                if (connectionClosedEvent.statusCode !== 1000) this.cancelSynthesisLocal((0, $GCsZL.CancellationReason).Error, connectionClosedEvent.statusCode === 1007 ? (0, $8g0TV.CancellationErrorCode).BadRequestParameters : (0, $8g0TV.CancellationErrorCode).ConnectionFailure, connectionClosedEvent.reason + " websocket error code: " + connectionClosedEvent.statusCode);
            }
        });
    }
    get synthesisContext() {
        return this.privSynthesisContext;
    }
    get agentConfig() {
        return this.privAgentConfig;
    }
    get connectionEvents() {
        return this.privConnectionEvents;
    }
    get serviceEvents() {
        return this.privServiceEvents;
    }
    set activityTemplate(messagePayload) {
        this.privActivityTemplate = messagePayload;
    }
    get activityTemplate() {
        return this.privActivityTemplate;
    }
    set audioOutputFormat(format) {
        this.privAudioOutputFormat = format;
        this.privSynthesisTurn.audioOutputFormat = format;
        if (this.privSessionAudioDestination !== undefined) this.privSessionAudioDestination.format = format;
        if (this.synthesisContext !== undefined) this.synthesisContext.audioOutputFormat = format;
    }
    static addHeader(audio, format) {
        if (!format.hasHeader) return audio;
        format.updateHeader(audio.byteLength);
        const tmp = new Uint8Array(audio.byteLength + format.header.byteLength);
        tmp.set(new Uint8Array(format.header), 0);
        tmp.set(new Uint8Array(audio), format.header.byteLength);
        return tmp.buffer;
    }
    isDisposed() {
        return this.privIsDisposed;
    }
    dispose(reason) {
        return $3ce3a3e00aee65b3$var$__awaiter(this, void 0, void 0, function*() {
            this.privIsDisposed = true;
            if (this.privSessionAudioDestination !== undefined) this.privSessionAudioDestination.close();
            if (this.privConnectionConfigurationPromise) {
                const connection = yield this.privConnectionConfigurationPromise;
                yield connection.dispose(reason);
            }
        });
    }
    connect() {
        return $3ce3a3e00aee65b3$var$__awaiter(this, void 0, void 0, function*() {
            yield this.connectImpl();
        });
    }
    sendNetworkMessage(path, payload) {
        return $3ce3a3e00aee65b3$var$__awaiter(this, void 0, void 0, function*() {
            const type = typeof payload === "string" ? (0, $4gz8B.MessageType).Text : (0, $4gz8B.MessageType).Binary;
            const contentType = typeof payload === "string" ? "application/json" : "";
            const connection = yield this.fetchConnection();
            return connection.send(new (0, $MRQbb.SpeechConnectionMessage)(type, path, this.privSynthesisTurn.requestId, contentType, payload));
        });
    }
    Speak(text, isSSML, requestId, successCallback, errorCallBack, audioDestination) {
        return $3ce3a3e00aee65b3$var$__awaiter(this, void 0, void 0, function*() {
            let ssml;
            if (isSSML) ssml = text;
            else ssml = this.privSpeechSynthesizer.buildSsml(text);
            if (this.speakOverride !== undefined) return this.speakOverride(ssml, requestId, successCallback, errorCallBack);
            this.privSuccessCallback = successCallback;
            this.privErrorCallback = errorCallBack;
            this.privSynthesisTurn.startNewSynthesis(requestId, text, isSSML, audioDestination);
            try {
                yield this.connectImpl();
                const connection = yield this.fetchConnection();
                yield this.sendSynthesisContext(connection);
                yield this.sendSsmlMessage(connection, ssml, requestId);
                const synthesisStartEventArgs = new (0, $8z6rw.SpeechSynthesisEventArgs)(new (0, $gYwsC.SpeechSynthesisResult)(requestId, (0, $dptOd.ResultReason).SynthesizingAudioStarted));
                if (!!this.privSpeechSynthesizer.synthesisStarted) this.privSpeechSynthesizer.synthesisStarted(this.privSpeechSynthesizer, synthesisStartEventArgs);
                const messageRetrievalPromise = this.receiveMessage();
            } catch (e) {
                this.cancelSynthesisLocal((0, $GCsZL.CancellationReason).Error, (0, $8g0TV.CancellationErrorCode).ConnectionFailure, e);
                return Promise.reject(e);
            }
        });
    }
    // Cancels synthesis.
    cancelSynthesis(requestId, cancellationReason, errorCode, error) {
        const properties = new (0, $eDSF6.PropertyCollection)();
        properties.setProperty((0, $g6k3z.CancellationErrorCodePropertyName), (0, $8g0TV.CancellationErrorCode)[errorCode]);
        const result = new (0, $gYwsC.SpeechSynthesisResult)(requestId, (0, $dptOd.ResultReason).Canceled, undefined, error, properties);
        if (!!this.privSpeechSynthesizer.SynthesisCanceled) {
            const cancelEvent = new (0, $8z6rw.SpeechSynthesisEventArgs)(result);
            try {
                this.privSpeechSynthesizer.SynthesisCanceled(this.privSpeechSynthesizer, cancelEvent);
            /* tslint:disable:no-empty */ } catch (_a) {}
        }
        if (!!this.privSuccessCallback) try {
            this.privSuccessCallback(result);
        /* tslint:disable:no-empty */ } catch (_b) {}
    }
    // Cancels synthesis.
    cancelSynthesisLocal(cancellationReason, errorCode, error) {
        if (!!this.privSynthesisTurn.isSynthesizing) {
            this.privSynthesisTurn.onStopSynthesizing();
            this.cancelSynthesis(this.privSynthesisTurn.requestId, cancellationReason, errorCode, error);
        }
    }
    processTypeSpecificMessages(connectionMessage, successCallback, errorCallBack) {
        return true;
    }
    receiveMessage() {
        return $3ce3a3e00aee65b3$var$__awaiter(this, void 0, void 0, function*() {
            try {
                const connection = yield this.fetchConnection();
                const message = yield connection.read();
                if (this.receiveMessageOverride !== undefined) return this.receiveMessageOverride();
                if (this.privIsDisposed) // We're done.
                return;
                // indicates we are draining the queue and it came with no message;
                if (!message) {
                    if (!this.privSynthesisTurn.isSynthesizing) return;
                    else return this.receiveMessage();
                }
                this.privServiceHasSentMessage = true;
                const connectionMessage = (0, $MRQbb.SpeechConnectionMessage).fromConnectionMessage(message);
                if (connectionMessage.requestId.toLowerCase() === this.privSynthesisTurn.requestId.toLowerCase()) switch(connectionMessage.path.toLowerCase()){
                    case "turn.start":
                        this.privSynthesisTurn.onServiceTurnStartResponse();
                        break;
                    case "response":
                        this.privSynthesisTurn.onServiceResponseMessage(connectionMessage.textBody);
                        break;
                    case "audio":
                        if (this.privSynthesisTurn.streamId.toLowerCase() === connectionMessage.streamId.toLowerCase() && !!connectionMessage.binaryBody) {
                            this.privSynthesisTurn.onAudioChunkReceived(connectionMessage.binaryBody);
                            if (!!this.privSpeechSynthesizer.synthesizing) try {
                                const audioWithHeader = $3ce3a3e00aee65b3$export$6a9ae5f91b217634.addHeader(connectionMessage.binaryBody, this.privSynthesisTurn.audioOutputFormat);
                                const ev = new (0, $8z6rw.SpeechSynthesisEventArgs)(new (0, $gYwsC.SpeechSynthesisResult)(this.privSynthesisTurn.requestId, (0, $dptOd.ResultReason).SynthesizingAudio, audioWithHeader));
                                this.privSpeechSynthesizer.synthesizing(this.privSpeechSynthesizer, ev);
                            } catch (error) {
                            // Not going to let errors in the event handler
                            // trip things up.
                            }
                            if (this.privSessionAudioDestination !== undefined) this.privSessionAudioDestination.write(connectionMessage.binaryBody);
                        }
                        break;
                    case "audio.metadata":
                        const metadataList = (0, $8gNBb.SynthesisAudioMetadata).fromJSON(connectionMessage.textBody).Metadata;
                        for (const metadata of metadataList)switch(metadata.Type){
                            case (0, $8gNBb.MetadataType).WordBoundary:
                                this.privSynthesisTurn.onWordBoundaryEvent(metadata.Data.text.Text);
                                const wordBoundaryEventArgs = new (0, $9yqAX.SpeechSynthesisWordBoundaryEventArgs)(metadata.Data.Offset, metadata.Data.text.Text, metadata.Data.text.Length, this.privSynthesisTurn.currentTextOffset);
                                if (!!this.privSpeechSynthesizer.wordBoundary) try {
                                    this.privSpeechSynthesizer.wordBoundary(this.privSpeechSynthesizer, wordBoundaryEventArgs);
                                } catch (error) {
                                // Not going to let errors in the event handler
                                // trip things up.
                                }
                                break;
                            case (0, $8gNBb.MetadataType).Bookmark:
                                const bookmarkEventArgs = new (0, $hMSAZ.SpeechSynthesisBookmarkEventArgs)(metadata.Data.Offset, metadata.Data.Bookmark);
                                if (!!this.privSpeechSynthesizer.bookmarkReached) try {
                                    this.privSpeechSynthesizer.bookmarkReached(this.privSpeechSynthesizer, bookmarkEventArgs);
                                } catch (error) {
                                // Not going to let errors in the event handler
                                // trip things up.
                                }
                                break;
                            case (0, $8gNBb.MetadataType).Viseme:
                                this.privSynthesisTurn.onVisemeMetadataReceived(metadata);
                                if (metadata.Data.IsLastAnimation) {
                                    const visemeEventArgs = new (0, $2SIlq.SpeechSynthesisVisemeEventArgs)(metadata.Data.Offset, metadata.Data.VisemeId, this.privSynthesisTurn.getAndClearVisemeAnimation());
                                    if (!!this.privSpeechSynthesizer.visemeReceived) try {
                                        this.privSpeechSynthesizer.visemeReceived(this.privSpeechSynthesizer, visemeEventArgs);
                                    } catch (error) {
                                    // Not going to let errors in the event handler
                                    // trip things up.
                                    }
                                }
                                break;
                        }
                        break;
                    case "turn.end":
                        this.privSynthesisTurn.onServiceTurnEndResponse();
                        let result;
                        try {
                            const audioBuffer = yield this.privSynthesisTurn.getAllReceivedAudioWithHeader();
                            result = new (0, $gYwsC.SpeechSynthesisResult)(this.privSynthesisTurn.requestId, (0, $dptOd.ResultReason).SynthesizingAudioCompleted, audioBuffer);
                            if (!!this.privSuccessCallback) this.privSuccessCallback(result);
                        } catch (error) {
                            if (!!this.privErrorCallback) this.privErrorCallback(error);
                        }
                        if (this.privSpeechSynthesizer.synthesisCompleted) try {
                            this.privSpeechSynthesizer.synthesisCompleted(this.privSpeechSynthesizer, new (0, $8z6rw.SpeechSynthesisEventArgs)(result));
                        } catch (e) {
                        // Not going to let errors in the event handler
                        // trip things up.
                        }
                        break;
                    default:
                        if (!this.processTypeSpecificMessages(connectionMessage)) // here are some messages that the derived class has not processed, dispatch them to connect class
                        {
                            if (!!this.privServiceEvents) this.serviceEvents.onEvent(new (0, $l8CKy.ServiceEvent)(connectionMessage.path.toLowerCase(), connectionMessage.textBody));
                        }
                }
                return this.receiveMessage();
            } catch (e) {
            // TODO: What goes here?
            }
        });
    }
    connectImpl(isUnAuthorized = false) {
        if (this.privConnectionPromise) return this.privConnectionPromise.then((connection)=>{
            if (connection.state() === (0, $8wq1O.ConnectionState).Disconnected) {
                this.privConnectionId = null;
                this.privConnectionPromise = null;
                this.privServiceHasSentMessage = false;
                return this.connectImpl();
            }
            return this.privConnectionPromise;
        }, (error)=>{
            this.privConnectionId = null;
            this.privConnectionPromise = null;
            this.privServiceHasSentMessage = false;
            return this.connectImpl();
        });
        this.privAuthFetchEventId = (0, $kSC7p.createNoDashGuid)();
        this.privConnectionId = (0, $kSC7p.createNoDashGuid)();
        this.privSynthesisTurn.onPreConnectionStart(this.privAuthFetchEventId, this.privConnectionId);
        const authPromise = isUnAuthorized ? this.privAuthentication.fetchOnExpiry(this.privAuthFetchEventId) : this.privAuthentication.fetch(this.privAuthFetchEventId);
        this.privConnectionPromise = authPromise.then((result)=>$3ce3a3e00aee65b3$var$__awaiter(this, void 0, void 0, function*() {
                yield this.privSynthesisTurn.onAuthCompleted(false);
                const connection = this.privConnectionFactory.create(this.privSynthesizerConfig, result, this.privConnectionId);
                // Attach to the underlying event. No need to hold onto the detach pointers as in the event the connection goes away,
                // it'll stop sending events.
                connection.events.attach((event)=>{
                    this.connectionEvents.onEvent(event);
                });
                const response = yield connection.open();
                if (response.statusCode === 200) {
                    yield this.privSynthesisTurn.onConnectionEstablishCompleted(response.statusCode);
                    return Promise.resolve(connection);
                } else if (response.statusCode === 403 && !isUnAuthorized) return this.connectImpl(true);
                else {
                    yield this.privSynthesisTurn.onConnectionEstablishCompleted(response.statusCode, response.reason);
                    return Promise.reject(`Unable to contact server. StatusCode: ${response.statusCode}, ${this.privSynthesizerConfig.parameters.getProperty((0, $jJjdG.PropertyId).SpeechServiceConnection_Endpoint)} Reason: ${response.reason}`);
                }
            }), (error)=>$3ce3a3e00aee65b3$var$__awaiter(this, void 0, void 0, function*() {
                yield this.privSynthesisTurn.onAuthCompleted(true, error);
                throw new Error(error);
            }));
        // Attach an empty handler to allow the promise to run in the background while
        // other startup events happen. It'll eventually be awaited on.
        this.privConnectionPromise.catch(()=>{});
        return this.privConnectionPromise;
    }
    fetchConnection() {
        return $3ce3a3e00aee65b3$var$__awaiter(this, void 0, void 0, function*() {
            if (this.privConnectionConfigurationPromise) return this.privConnectionConfigurationPromise.then((connection)=>{
                if (connection.state() === (0, $8wq1O.ConnectionState).Disconnected) {
                    this.privConnectionId = null;
                    this.privConnectionConfigurationPromise = null;
                    this.privServiceHasSentMessage = false;
                    return this.fetchConnection();
                }
                return this.privConnectionConfigurationPromise;
            }, (error)=>{
                this.privConnectionId = null;
                this.privConnectionConfigurationPromise = null;
                this.privServiceHasSentMessage = false;
                return this.fetchConnection();
            });
            this.privConnectionConfigurationPromise = this.configureConnection();
            return yield this.privConnectionConfigurationPromise;
        });
    }
    // Takes an established websocket connection to the endpoint and sends speech configuration information.
    configureConnection() {
        return $3ce3a3e00aee65b3$var$__awaiter(this, void 0, void 0, function*() {
            const connection = yield this.connectImpl();
            if (this.configConnectionOverride !== undefined) return this.configConnectionOverride(connection);
            yield this.sendSpeechServiceConfig(connection, this.privSynthesizerConfig.SpeechServiceConfig.serialize());
            return connection;
        });
    }
}
$3ce3a3e00aee65b3$export$6a9ae5f91b217634.telemetryDataEnabled = true;

});
parcelRequire.register("hMSAZ", function(module, exports) {

$parcel$export(module.exports, "SpeechSynthesisBookmarkEventArgs", () => $cf3144efcb18247b$export$8f9389ce6b5310bb);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
/**
 * Defines contents of speech synthesis bookmark event.
 * @class SpeechSynthesisBookmarkEventArgs
 * Added in version 1.16.0
 */ class $cf3144efcb18247b$export$8f9389ce6b5310bb {
    /**
     * Creates and initializes an instance of this class.
     * @constructor
     * @param {number} audioOffset - The audio offset.
     * @param {string} text - The bookmark text.
     */ constructor(audioOffset, text){
        this.privAudioOffset = audioOffset;
        this.privText = text;
    }
    /**
     * Specifies the audio offset.
     * @member SpeechSynthesisBookmarkEventArgs.prototype.audioOffset
     * @function
     * @public
     * @returns {number} the audio offset.
     */ get audioOffset() {
        return this.privAudioOffset;
    }
    /**
     * Specifies the bookmark.
     * @member SpeechSynthesisBookmarkEventArgs.prototype.text
     * @function
     * @public
     * @returns {string} the bookmark text.
     */ get text() {
        return this.privText;
    }
}

});

parcelRequire.register("8z6rw", function(module, exports) {

$parcel$export(module.exports, "SpeechSynthesisEventArgs", () => $63c6970bebfd8fc0$export$771b44dbfb6bc7af);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
/**
 * Defines contents of speech synthesis events.
 * @class SpeechSynthesisEventArgs
 * Added in version 1.11.0
 */ class $63c6970bebfd8fc0$export$771b44dbfb6bc7af {
    /**
     * Creates and initializes an instance of this class.
     * @constructor
     * @param {SpeechSynthesisResult} result - The speech synthesis result.
     */ constructor(result){
        this.privResult = result;
    }
    /**
     * Specifies the synthesis result.
     * @member SpeechSynthesisEventArgs.prototype.result
     * @function
     * @public
     * @returns {SpeechSynthesisResult} the synthesis result.
     */ get result() {
        return this.privResult;
    }
}

});

parcelRequire.register("gYwsC", function(module, exports) {

$parcel$export(module.exports, "SpeechSynthesisResult", () => $c5bb6dea2654181f$export$7483af638e01359e);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
/**
 * Defines result of speech synthesis.
 * @class SpeechSynthesisResult
 * Added in version 1.11.0
 */ class $c5bb6dea2654181f$export$7483af638e01359e {
    /**
     * Creates and initializes an instance of this class.
     * @constructor
     * @param {string} resultId - The result id.
     * @param {ResultReason} reason - The reason.
     * @param {number} audioData - The offset into the stream.
     * @param {string} errorDetails - Error details, if provided.
     * @param {PropertyCollection} properties - Additional properties, if provided.
     */ constructor(resultId, reason, audioData, errorDetails, properties){
        this.privResultId = resultId;
        this.privReason = reason;
        this.privAudioData = audioData;
        this.privErrorDetails = errorDetails;
        this.privProperties = properties;
    }
    /**
     * Specifies the result identifier.
     * @member SpeechSynthesisResult.prototype.resultId
     * @function
     * @public
     * @returns {string} Specifies the result identifier.
     */ get resultId() {
        return this.privResultId;
    }
    /**
     * Specifies status of the result.
     * @member SpeechSynthesisResult.prototype.reason
     * @function
     * @public
     * @returns {ResultReason} Specifies status of the result.
     */ get reason() {
        return this.privReason;
    }
    /**
     * The synthesized audio data
     * @member SpeechSynthesisResult.prototype.audioData
     * @function
     * @public
     * @returns {ArrayBuffer} The synthesized audio data.
     */ get audioData() {
        return this.privAudioData;
    }
    /**
     * In case of an unsuccessful synthesis, provides details of the occurred error.
     * @member SpeechSynthesisResult.prototype.errorDetails
     * @function
     * @public
     * @returns {string} a brief description of an error.
     */ get errorDetails() {
        return this.privErrorDetails;
    }
    /**
     *  The set of properties exposed in the result.
     * @member SpeechSynthesisResult.prototype.properties
     * @function
     * @public
     * @returns {PropertyCollection} The set of properties exposed in the result.
     */ get properties() {
        return this.privProperties;
    }
}

});

parcelRequire.register("2SIlq", function(module, exports) {

$parcel$export(module.exports, "SpeechSynthesisVisemeEventArgs", () => $219305d2bddd7793$export$bed102a9cb8b5da);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
/**
 * Defines contents of speech synthesis viseme event.
 * @class SpeechSynthesisVisemeEventArgs
 * Added in version 1.16.0
 */ class $219305d2bddd7793$export$bed102a9cb8b5da {
    /**
     * Creates and initializes an instance of this class.
     * @constructor
     * @param {number} audioOffset - The audio offset.
     * @param {number} visemeId - The viseme ID.
     * @param {string} animation - The animation, could be in svg or other format.
     */ constructor(audioOffset, visemeId, animation){
        this.privAudioOffset = audioOffset;
        this.privVisemeId = visemeId;
        this.privAnimation = animation;
    }
    /**
     * Specifies the audio offset.
     * @member SpeechSynthesisVisemeEventArgs.prototype.audioOffset
     * @function
     * @public
     * @returns {number} the audio offset.
     */ get audioOffset() {
        return this.privAudioOffset;
    }
    /**
     * Specifies the viseme ID.
     * @member SpeechSynthesisVisemeEventArgs.prototype.visemeId
     * @function
     * @public
     * @returns {number} the viseme ID.
     */ get visemeId() {
        return this.privVisemeId;
    }
    /**
     * Specifies the animation.
     * @member SpeechSynthesisVisemeEventArgs.prototype.animation
     * @function
     * @public
     * @returns {string} the animation, could be in svg or other format.
     */ get animation() {
        return this.privAnimation;
    }
}

});

parcelRequire.register("9yqAX", function(module, exports) {

$parcel$export(module.exports, "SpeechSynthesisWordBoundaryEventArgs", () => $6f4beb4187e80dae$export$5baece3a3f21e6ae);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
/**
 * Defines contents of speech synthesis word boundary event.
 * @class SpeechSynthesisWordBoundaryEventArgs
 * Added in version 1.11.0
 */ class $6f4beb4187e80dae$export$5baece3a3f21e6ae {
    /**
     * Creates and initializes an instance of this class.
     * @constructor
     * @param {number} audioOffset - The audio offset.
     * @param {string} text - The text.
     * @param {number} wordLength - The length of the word.
     * @param {number} textOffset - The text offset.
     */ constructor(audioOffset, text, wordLength, textOffset){
        this.privAudioOffset = audioOffset;
        this.privText = text;
        this.privWordLength = wordLength;
        this.privTextOffset = textOffset;
    }
    /**
     * Specifies the audio offset.
     * @member SpeechSynthesisWordBoundaryEventArgs.prototype.audioOffset
     * @function
     * @public
     * @returns {number} the audio offset.
     */ get audioOffset() {
        return this.privAudioOffset;
    }
    /**
     * Specifies the text of the word boundary event.
     * @member SpeechSynthesisWordBoundaryEventArgs.prototype.text
     * @function
     * @public
     * @returns {string} the text.
     */ get text() {
        return this.privText;
    }
    /**
     * Specifies the word length
     * @member SpeechSynthesisWordBoundaryEventArgs.prototype.wordLength
     * @function
     * @public
     * @returns {number} the word length
     */ get wordLength() {
        return this.privWordLength;
    }
    /**
     * Specifies the text offset.
     * @member SpeechSynthesisWordBoundaryEventArgs.prototype.textOffset
     * @function
     * @public
     * @returns {number} the text offset.
     */ get textOffset() {
        return this.privTextOffset;
    }
}

});


parcelRequire.register("6tbTG", function(module, exports) {

$parcel$export(module.exports, "SynthesisTriggeredEvent", () => $4b5eae07ad4c517d$export$4bdadafede730bd5);
$parcel$export(module.exports, "ConnectingToSynthesisServiceEvent", () => $4b5eae07ad4c517d$export$2024970667be27b8);
$parcel$export(module.exports, "SynthesisStartedEvent", () => $4b5eae07ad4c517d$export$4aa6db8ac8b32039);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
// tslint:disable:max-classes-per-file
parcelRequire("3KVS5");
var $aAKrf = parcelRequire("aAKrf");
class $4b5eae07ad4c517d$export$cd674f01be9bedfb extends (0, $aAKrf.PlatformEvent) {
    constructor(eventName, requestId, eventType = (0, $aAKrf.EventType).Info){
        super(eventName, eventType);
        this.privRequestId = requestId;
    }
    get requestId() {
        return this.privRequestId;
    }
}
class $4b5eae07ad4c517d$export$4bdadafede730bd5 extends $4b5eae07ad4c517d$export$cd674f01be9bedfb {
    constructor(requestId, sessionAudioDestinationId, turnAudioDestinationId){
        super("SynthesisTriggeredEvent", requestId);
        this.privSessionAudioDestinationId = sessionAudioDestinationId;
        this.privTurnAudioDestinationId = turnAudioDestinationId;
    }
    get audioSessionDestinationId() {
        return this.privSessionAudioDestinationId;
    }
    get audioTurnDestinationId() {
        return this.privTurnAudioDestinationId;
    }
}
class $4b5eae07ad4c517d$export$2024970667be27b8 extends $4b5eae07ad4c517d$export$cd674f01be9bedfb {
    constructor(requestId, authFetchEventId){
        super("ConnectingToSynthesisServiceEvent", requestId);
        this.privAuthFetchEventId = authFetchEventId;
    }
    get authFetchEventId() {
        return this.privAuthFetchEventId;
    }
}
class $4b5eae07ad4c517d$export$4aa6db8ac8b32039 extends $4b5eae07ad4c517d$export$cd674f01be9bedfb {
    constructor(requestId, authFetchEventId){
        super("SynthesisStartedEvent", requestId);
        this.privAuthFetchEventId = authFetchEventId;
    }
    get authFetchEventId() {
        return this.privAuthFetchEventId;
    }
}

});


parcelRequire.register("iTkn8", function(module, exports) {

$parcel$export(module.exports, "SynthesisContext", () => $dc0d2a8cef42dbd7$export$a7af640f564c9d7a);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
/**
 * Represents the JSON used in the synthesis.context message sent to the speech service.
 * The dynamic grammar is always refreshed from the encapsulated dynamic grammar object.
 */ class $dc0d2a8cef42dbd7$export$a7af640f564c9d7a {
    constructor(speechSynthesizer){
        this.privContext = {};
        this.privSpeechSynthesizer = speechSynthesizer;
    }
    /**
     * Adds a section to the synthesis.context object.
     * @param sectionName Name of the section to add.
     * @param value JSON serializable object that represents the value.
     */ setSection(sectionName, value) {
        this.privContext[sectionName] = value;
    }
    /**
     * Sets the audio output format for synthesis context generation.
     * @param format {AudioOutputFormatImpl} the output format
     */ set audioOutputFormat(format) {
        this.privAudioOutputFormat = format;
    }
    toJSON() {
        const synthesisSection = this.buildSynthesisContext();
        this.setSection("synthesis", synthesisSection);
        return JSON.stringify(this.privContext);
    }
    buildSynthesisContext() {
        return {
            audio: {
                metadataOptions: {
                    bookmarkEnabled: !!this.privSpeechSynthesizer.bookmarkReached,
                    sentenceBoundaryEnabled: false,
                    visemeEnabled: !!this.privSpeechSynthesizer.visemeReceived,
                    wordBoundaryEnabled: !!this.privSpeechSynthesizer.wordBoundary
                },
                outputFormat: this.privAudioOutputFormat.requestAudioFormatString
            },
            language: {
                autoDetection: this.privSpeechSynthesizer.autoDetectSourceLanguage
            }
        };
    }
}

});

parcelRequire.register("2DVKD", function(module, exports) {
parcelRequire("if2Nv");
var $bP1UF = parcelRequire("bP1UF");
var $8OSsj = parcelRequire("8OSsj");

var $jJjdG = parcelRequire("jJjdG");
var $2aH1K = parcelRequire("2aH1K");
var $1ecc0573f83c420d$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
class $1ecc0573f83c420d$export$995ec02a36c07249 {
    constructor(config){
        let endpoint = config.parameters.getProperty((0, $jJjdG.PropertyId).SpeechServiceConnection_Endpoint, undefined);
        if (!endpoint) {
            const region = config.parameters.getProperty((0, $jJjdG.PropertyId).SpeechServiceConnection_Region, "westus");
            const hostSuffix = region && region.toLowerCase().startsWith("china") ? ".azure.cn" : ".microsoft.com";
            const host = config.parameters.getProperty((0, $jJjdG.PropertyId).SpeechServiceConnection_Host, "https://" + region + ".api.cognitive" + hostSuffix + "/speaker/{mode}/v2.0/{dependency}");
            endpoint = host + "/profiles";
        }
        this.privUri = endpoint;
        const options = (0, $bP1UF.RestConfigBase).requestOptions;
        options.headers[(0, $bP1UF.RestConfigBase).configParams.subscriptionKey] = config.parameters.getProperty((0, $jJjdG.PropertyId).SpeechServiceConnection_Key, undefined);
        this.privRestAdapter = new (0, $8OSsj.RestMessageAdapter)(options);
    }
    /**
     * Sends create profile request to endpoint.
     * @function
     * @param {VoiceProfileType} profileType - type of voice profile to create.
     * @param {string} lang - language/locale of voice profile
     * @public
     * @returns {Promise<IRestResponse>} promised rest response containing id of created profile.
     */ createProfile(profileType, lang) {
        const uri = this.getOperationUri(profileType);
        this.privRestAdapter.setHeaders((0, $bP1UF.RestConfigBase).configParams.contentTypeKey, "application/json");
        return this.privRestAdapter.request((0, $8OSsj.RestRequestType).Post, uri, {}, {
            locale: lang
        });
    }
    /**
     * Sends create enrollment request to endpoint.
     * @function
     * @param {VoiceProfile} profileType - voice profile for which to create new enrollment.
     * @param {IAudioSource} audioSource - audioSource from which to pull data to send
     * @public
     * @returns {Promise<IRestResponse>} rest response to enrollment request.
     */ createEnrollment(profile, audioSource) {
        this.privRestAdapter.setHeaders((0, $bP1UF.RestConfigBase).configParams.contentTypeKey, "multipart/form-data");
        const uri = this.getOperationUri(profile.profileType) + "/" + profile.profileId + "/enrollments";
        return audioSource.blob.then((result)=>{
            return this.privRestAdapter.request((0, $8OSsj.RestRequestType).File, uri, {
                ignoreMinLength: "true"
            }, null, result);
        });
    }
    /**
     * Sends verification request to endpoint.
     * @function
     * @param {SpeakerVerificationModel} model - voice model to verify against.
     * @param {IAudioSource} audioSource - audioSource from which to pull data to send
     * @public
     * @returns {Promise<IRestResponse>} rest response to enrollment request.
     */ verifySpeaker(model, audioSource) {
        return $1ecc0573f83c420d$var$__awaiter(this, void 0, void 0, function*() {
            this.privRestAdapter.setHeaders((0, $bP1UF.RestConfigBase).configParams.contentTypeKey, "multipart/form-data");
            const uri = this.getOperationUri(model.voiceProfile.profileType) + "/" + model.voiceProfile.profileId + "/verify";
            try {
                const result = yield audioSource.blob;
                return this.privRestAdapter.request((0, $8OSsj.RestRequestType).File, uri, {
                    ignoreMinLength: "true"
                }, null, result);
            } catch (e) {
                return Promise.resolve({
                    data: e
                });
            }
        });
    }
    /**
     * Sends identification request to endpoint.
     * @function
     * @param {SpeakerIdentificationModel} model - voice profiles against which to identify.
     * @param {IAudioSource} audioSource - audioSource from which to pull data to send
     * @public
     * @returns {Promise<IRestResponse>} rest response to enrollment request.
     */ identifySpeaker(model, audioSource) {
        return $1ecc0573f83c420d$var$__awaiter(this, void 0, void 0, function*() {
            this.privRestAdapter.setHeaders((0, $bP1UF.RestConfigBase).configParams.contentTypeKey, "multipart/form-data");
            const uri = this.getOperationUri((0, $2aH1K.VoiceProfileType).TextIndependentIdentification) + "/identifySingleSpeaker";
            try {
                const result = yield audioSource.blob;
                return this.privRestAdapter.request((0, $8OSsj.RestRequestType).File, uri, {
                    profileIds: model.voiceProfileIds,
                    ignoreMinLength: "true"
                }, null, result);
            } catch (e) {
                return Promise.resolve({
                    data: e
                });
            }
        });
    }
    /**
     * Sends profile status request to endpoint.
     * @function
     * @param {VoiceProfile} profile - voice profile to check.
     * @public
     * @returns {Promise<IRestResponse>} rest response to status request
     */ getProfileStatus(profile) {
        const uri = `${this.getOperationUri(profile.profileType)}/${profile.profileId}`;
        return this.privRestAdapter.request((0, $8OSsj.RestRequestType).Get, uri, {});
    }
    /**
     * Sends get all profiles request to endpoint.
     * @function
     * @param {VoiceProfileType} profileType - type of profiles to return list of
     * @public
     * @returns {Promise<IRestResponse>} promised rest response containing all profiles
     */ getProfiles(profileType) {
        const uri = this.getOperationUri(profileType);
        return this.privRestAdapter.request((0, $8OSsj.RestRequestType).Get, uri, {});
    }
    /**
     * Sends get authorization phrases request to endpoint.
     * @function
     * @param {string} lang - language/locale of voice profile
     * @public
     * @returns {Promise<IRestResponse>} promised rest response containing list of valid phrases
     */ getAuthorizationPhrases(lang) {
        const uri = `${this.getOperationUri((0, $2aH1K.VoiceProfileType).TextDependentVerification)}`.replace(`profiles`, `phrases`) + "/" + lang;
        return this.privRestAdapter.request((0, $8OSsj.RestRequestType).Get, uri, {});
    }
    /**
     * Sends delete profile request to endpoint.
     * @function
     * @param {VoiceProfile} profile - voice profile to delete.
     * @public
     * @returns {Promise<IRestResponse>} rest response to deletion request
     */ deleteProfile(profile) {
        const uri = this.getOperationUri(profile.profileType) + "/" + profile.profileId;
        return this.privRestAdapter.request((0, $8OSsj.RestRequestType).Delete, uri, {});
    }
    /**
     * Sends reset profile request to endpoint.
     * @function
     * @param {VoiceProfile} profile - voice profile to reset enrollments for.
     * @public
     * @returns {Promise<IRestResponse>} rest response to reset request
     */ resetProfile(profile) {
        const uri = this.getOperationUri(profile.profileType) + "/" + profile.profileId + "/reset";
        return this.privRestAdapter.request((0, $8OSsj.RestRequestType).Post, uri, {});
    }
    getOperationUri(profileType) {
        const mode = profileType === (0, $2aH1K.VoiceProfileType).TextIndependentIdentification ? "identification" : "verification";
        const dependency = profileType === (0, $2aH1K.VoiceProfileType).TextDependentVerification ? "text-dependent" : "text-independent";
        return this.privUri.replace("{mode}", mode).replace("{dependency}", dependency);
    }
}

});
parcelRequire.register("2aH1K", function(module, exports) {

$parcel$export(module.exports, "VoiceProfileType", () => $194de43daf93013e$export$bcc212421e479399);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
/**
 * Output format
 * @class VoiceProfileType
 */ var $194de43daf93013e$export$bcc212421e479399;
(function(VoiceProfileType) {
    /**
     * Text independent speaker identification
     * @member VoiceProfileType.TextIndependentIdentification
     */ VoiceProfileType[VoiceProfileType["TextIndependentIdentification"] = 0] = "TextIndependentIdentification";
    /**
     * Text dependent speaker verification
     * @member VoiceProfileType.TextDependentVerification
     */ VoiceProfileType[VoiceProfileType["TextDependentVerification"] = 1] = "TextDependentVerification";
    /**
     * Text independent speaker verification
     * @member VoiceProfileType.TextIndependentVerification
     */ VoiceProfileType[VoiceProfileType["TextIndependentVerification"] = 2] = "TextIndependentVerification";
})($194de43daf93013e$export$bcc212421e479399 || ($194de43daf93013e$export$bcc212421e479399 = {}));

});




parcelRequire.register("7caxD", function(module, exports) {

$parcel$export(module.exports, "FileAudioSource", () => $53d1d4b838931f28$export$2457f6fad5859840);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
parcelRequire("g6k3z");
var $iWV5t = parcelRequire("iWV5t");
parcelRequire("3KVS5");
var $btwY7 = parcelRequire("btwY7");
var $l9cUE = parcelRequire("l9cUE");
var $kSC7p = parcelRequire("kSC7p");
var $76ZQQ = parcelRequire("76ZQQ");
var $9MSEb = parcelRequire("9MSEb");
var $18oN3 = parcelRequire("18oN3");

var $bFdRB = parcelRequire("bFdRB");
var $53d1d4b838931f28$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
class $53d1d4b838931f28$export$2457f6fad5859840 {
    constructor(file, filename, audioSourceId){
        this.privStreams = {};
        this.privHeaderEnd = 44;
        this.turnOn = ()=>{
            if (this.privFilename.lastIndexOf(".wav") !== this.privFilename.length - 4) {
                const errorMsg = this.privFilename + " is not supported. Only WAVE files are allowed at the moment.";
                this.onEvent(new (0, $btwY7.AudioSourceErrorEvent)(errorMsg, ""));
                return Promise.reject(errorMsg);
            }
            this.onEvent(new (0, $btwY7.AudioSourceInitializingEvent)(this.privId)); // no stream id
            this.onEvent(new (0, $btwY7.AudioSourceReadyEvent)(this.privId));
            return;
        };
        this.id = ()=>{
            return this.privId;
        };
        this.attach = (audioNodeId)=>$53d1d4b838931f28$var$__awaiter(this, void 0, void 0, function*() {
                this.onEvent(new (0, $btwY7.AudioStreamNodeAttachingEvent)(this.privId, audioNodeId));
                const stream = yield this.upload(audioNodeId);
                this.onEvent(new (0, $btwY7.AudioStreamNodeAttachedEvent)(this.privId, audioNodeId));
                return Promise.resolve({
                    detach: ()=>$53d1d4b838931f28$var$__awaiter(this, void 0, void 0, function*() {
                            stream.readEnded();
                            delete this.privStreams[audioNodeId];
                            this.onEvent(new (0, $btwY7.AudioStreamNodeDetachedEvent)(this.privId, audioNodeId));
                            yield this.turnOff();
                        }),
                    id: ()=>{
                        return audioNodeId;
                    },
                    read: ()=>{
                        return stream.read();
                    }
                });
            });
        this.detach = (audioNodeId)=>{
            if (audioNodeId && this.privStreams[audioNodeId]) {
                this.privStreams[audioNodeId].close();
                delete this.privStreams[audioNodeId];
                this.onEvent(new (0, $btwY7.AudioStreamNodeDetachedEvent)(this.privId, audioNodeId));
            }
        };
        this.turnOff = ()=>{
            for(const streamId in this.privStreams)if (streamId) {
                const stream = this.privStreams[streamId];
                if (stream && !stream.isClosed) stream.close();
            }
            this.onEvent(new (0, $btwY7.AudioSourceOffEvent)(this.privId)); // no stream now
            return Promise.resolve();
        };
        this.onEvent = (event)=>{
            this.privEvents.onEvent(event);
            (0, $l9cUE.Events).instance.onEvent(event);
        };
        this.privId = audioSourceId ? audioSourceId : (0, $kSC7p.createNoDashGuid)();
        this.privEvents = new (0, $76ZQQ.EventSource)();
        this.privSource = file;
        if (typeof window !== "undefined" && typeof Blob !== "undefined" && this.privSource instanceof Blob) this.privFilename = file.name;
        else this.privFilename = filename || "unknown.wav";
        // Read the header.
        this.privAudioFormatPromise = this.readHeader();
    }
    get format() {
        return this.privAudioFormatPromise;
    }
    get blob() {
        return Promise.resolve(this.privSource);
    }
    get events() {
        return this.privEvents;
    }
    get deviceInfo() {
        return this.privAudioFormatPromise.then((result)=>{
            return Promise.resolve({
                bitspersample: result.bitsPerSample,
                channelcount: result.channels,
                connectivity: (0, $iWV5t.connectivity).Unknown,
                manufacturer: "Speech SDK",
                model: "File",
                samplerate: result.samplesPerSec,
                type: (0, $iWV5t.type).File
            });
        });
    }
    readHeader() {
        // Read the wave header.
        const maxHeaderSize = 512;
        const header = this.privSource.slice(0, maxHeaderSize);
        const headerResult = new (0, $9MSEb.Deferred)();
        const processHeader = (header)=>{
            const view = new DataView(header);
            const getWord = (index)=>{
                return String.fromCharCode(view.getUint8(index), view.getUint8(index + 1), view.getUint8(index + 2), view.getUint8(index + 3));
            };
            // RIFF 4 bytes.
            if ("RIFF" !== getWord(0)) {
                headerResult.reject("Invalid WAV header in file, RIFF was not found");
                return;
            }
            // length, 4 bytes
            // RIFF Type & fmt 8 bytes
            if ("WAVE" !== getWord(8) || "fmt " !== getWord(12)) {
                headerResult.reject("Invalid WAV header in file, WAVEfmt was not found");
                return;
            }
            const formatSize = view.getInt32(16, true);
            const channelCount = view.getUint16(22, true);
            const sampleRate = view.getUint32(24, true);
            const bitsPerSample = view.getUint16(34, true);
            // Confirm if header is 44 bytes long.
            let pos = 36 + Math.max(formatSize - 16, 0);
            for(; getWord(pos) !== "data"; pos += 2)if (pos > maxHeaderSize - 8) {
                headerResult.reject("Invalid WAV header in file, data block was not found");
                return;
            }
            this.privHeaderEnd = pos + 8;
            headerResult.resolve((0, $bFdRB.AudioStreamFormat).getWaveFormatPCM(sampleRate, bitsPerSample, channelCount));
        };
        if (typeof window !== "undefined" && typeof Blob !== "undefined" && header instanceof Blob) {
            const reader = new FileReader();
            reader.onload = (event)=>{
                const header = event.target.result;
                processHeader(header);
            };
            reader.readAsArrayBuffer(header);
        } else {
            const h = header;
            processHeader(h.buffer.slice(h.byteOffset, h.byteOffset + h.byteLength));
        }
        return headerResult.promise;
    }
    upload(audioNodeId) {
        return $53d1d4b838931f28$var$__awaiter(this, void 0, void 0, function*() {
            const onerror = (error)=>{
                const errorMsg = `Error occurred while processing '${this.privFilename}'. ${error}`;
                this.onEvent(new (0, $btwY7.AudioStreamNodeErrorEvent)(this.privId, audioNodeId, errorMsg));
                throw new Error(errorMsg);
            };
            try {
                yield this.turnOn();
                const format = yield this.privAudioFormatPromise;
                const stream = new (0, $18oN3.ChunkedArrayBufferStream)(format.avgBytesPerSec / 10, audioNodeId);
                this.privStreams[audioNodeId] = stream;
                const chunk = this.privSource.slice(this.privHeaderEnd);
                const processFile = (buff)=>{
                    if (stream.isClosed) return; // output stream was closed (somebody called TurnOff). We're done here.
                    stream.writeStreamChunk({
                        buffer: buff,
                        isEnd: false,
                        timeReceived: Date.now()
                    });
                    stream.close();
                };
                if (typeof window !== "undefined" && typeof Blob !== "undefined" && chunk instanceof Blob) {
                    const reader = new FileReader();
                    reader.onerror = (ev)=>{
                        onerror(ev.toString());
                    };
                    reader.onload = (event)=>{
                        const fileBuffer = event.target.result;
                        processFile(fileBuffer);
                    };
                    reader.readAsArrayBuffer(chunk);
                } else {
                    const c = chunk;
                    processFile(c.buffer.slice(c.byteOffset, c.byteOffset + c.byteLength));
                }
                return stream;
            } catch (e) {
                onerror(e);
            }
        });
    }
}

});

parcelRequire.register("7tK1S", function(module, exports) {

$parcel$export(module.exports, "PcmRecorder", () => $571ef2485af7efff$export$b4d48a500005f7a2);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
parcelRequire("3KVS5");
var $lpx1B = parcelRequire("lpx1B");
class $571ef2485af7efff$export$b4d48a500005f7a2 {
    constructor(){
        this.record = (context, mediaStream, outputStream)=>{
            const desiredSampleRate = 16000;
            const scriptNode = (()=>{
                let bufferSize = 0;
                try {
                    return context.createScriptProcessor(bufferSize, 1, 1);
                } catch (error) {
                    // Webkit (<= version 31) requires a valid bufferSize.
                    bufferSize = 2048;
                    let audioSampleRate = context.sampleRate;
                    while(bufferSize < 16384 && audioSampleRate >= 2 * desiredSampleRate){
                        bufferSize <<= 1;
                        audioSampleRate >>= 1;
                    }
                    return context.createScriptProcessor(bufferSize, 1, 1);
                }
            })();
            const waveStreamEncoder = new (0, $lpx1B.RiffPcmEncoder)(context.sampleRate, desiredSampleRate);
            let needHeader = true;
            const that = this;
            scriptNode.onaudioprocess = (event)=>{
                const inputFrame = event.inputBuffer.getChannelData(0);
                if (outputStream && !outputStream.isClosed) {
                    const waveFrame = waveStreamEncoder.encode(inputFrame);
                    if (!!waveFrame) {
                        outputStream.writeStreamChunk({
                            buffer: waveFrame,
                            isEnd: false,
                            timeReceived: Date.now()
                        });
                        needHeader = false;
                    }
                }
            };
            const micInput = context.createMediaStreamSource(mediaStream);
            // https://webaudio.github.io/web-audio-api/#audioworklet
            // Using AudioWorklet to improve audio quality and avoid audio glitches due to blocking the UI thread
            if (!!this.privSpeechProcessorScript && !!context.audioWorklet) context.audioWorklet.addModule(this.privSpeechProcessorScript).then(()=>{
                const workletNode = new AudioWorkletNode(context, "speech-processor");
                workletNode.port.onmessage = (ev)=>{
                    const inputFrame = ev.data;
                    if (outputStream && !outputStream.isClosed) {
                        const waveFrame = waveStreamEncoder.encode(inputFrame);
                        if (!!waveFrame) {
                            outputStream.writeStreamChunk({
                                buffer: waveFrame,
                                isEnd: false,
                                timeReceived: Date.now()
                            });
                            needHeader = false;
                        }
                    }
                };
                micInput.connect(workletNode);
                workletNode.connect(context.destination);
                this.privMediaResources = {
                    scriptProcessorNode: workletNode,
                    source: micInput,
                    stream: mediaStream
                };
            }).catch(()=>{
                micInput.connect(scriptNode);
                scriptNode.connect(context.destination);
                this.privMediaResources = {
                    scriptProcessorNode: scriptNode,
                    source: micInput,
                    stream: mediaStream
                };
            });
            else {
                micInput.connect(scriptNode);
                scriptNode.connect(context.destination);
                this.privMediaResources = {
                    scriptProcessorNode: scriptNode,
                    source: micInput,
                    stream: mediaStream
                };
            }
        };
        this.releaseMediaResources = (context)=>{
            if (this.privMediaResources) {
                if (this.privMediaResources.scriptProcessorNode) {
                    this.privMediaResources.scriptProcessorNode.disconnect(context.destination);
                    this.privMediaResources.scriptProcessorNode = null;
                }
                if (this.privMediaResources.source) {
                    this.privMediaResources.source.disconnect();
                    this.privMediaResources.stream.getTracks().forEach((track)=>track.stop());
                    this.privMediaResources.source = null;
                }
            }
        };
    }
    setWorkletUrl(url) {
        this.privSpeechProcessorScript = url;
    }
}

});

parcelRequire.register("71kSu", function(module, exports) {

$parcel$export(module.exports, "WebsocketConnection", () => $51c8d25596074da9$export$659cb444c1aa6c10);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
parcelRequire("3KVS5");
var $4Cx0W = parcelRequire("4Cx0W");
var $kSC7p = parcelRequire("kSC7p");

var $6Nb8B = parcelRequire("6Nb8B");
var $51c8d25596074da9$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
class $51c8d25596074da9$export$659cb444c1aa6c10 {
    constructor(uri, queryParameters, headers, messageFormatter, proxyInfo, enableCompression = false, connectionId){
        this.privIsDisposed = false;
        this.isDisposed = ()=>{
            return this.privIsDisposed;
        };
        this.state = ()=>{
            return this.privConnectionMessageAdapter.state;
        };
        this.open = ()=>{
            return this.privConnectionMessageAdapter.open();
        };
        this.send = (message)=>{
            return this.privConnectionMessageAdapter.send(message);
        };
        this.read = ()=>{
            return this.privConnectionMessageAdapter.read();
        };
        if (!uri) throw new (0, $4Cx0W.ArgumentNullError)("uri");
        if (!messageFormatter) throw new (0, $4Cx0W.ArgumentNullError)("messageFormatter");
        this.privMessageFormatter = messageFormatter;
        let queryParams = "";
        let i = 0;
        if (queryParameters) {
            for(const paramName in queryParameters)if (paramName) {
                queryParams += i === 0 && uri.indexOf("?") === -1 ? "?" : "&";
                const val = encodeURIComponent(queryParameters[paramName]);
                queryParams += `${paramName}=${val}`;
                i++;
            }
        }
        if (headers) {
            for(const headerName in headers)if (headerName) {
                queryParams += i === 0 && uri.indexOf("?") === -1 ? "?" : "&";
                const val = encodeURIComponent(headers[headerName]);
                queryParams += `${headerName}=${val}`;
                i++;
            }
        }
        this.privUri = uri + queryParams;
        this.privId = connectionId ? connectionId : (0, $kSC7p.createNoDashGuid)();
        this.privConnectionMessageAdapter = new (0, $6Nb8B.WebsocketMessageAdapter)(this.privUri, this.id, this.privMessageFormatter, proxyInfo, headers, enableCompression);
    }
    dispose() {
        return $51c8d25596074da9$var$__awaiter(this, void 0, void 0, function*() {
            this.privIsDisposed = true;
            if (this.privConnectionMessageAdapter) yield this.privConnectionMessageAdapter.close();
        });
    }
    get id() {
        return this.privId;
    }
    get events() {
        return this.privConnectionMessageAdapter.events;
    }
}

});
parcelRequire.register("6Nb8B", function(module, exports) {

$parcel$export(module.exports, "WebsocketMessageAdapter", () => $4f1ff5652324051f$export$2b2f6d87ad7998b5);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.

var $2V1Xw = parcelRequire("2V1Xw");
parcelRequire("3KVS5");
var $8wq1O = parcelRequire("8wq1O");
var $9MSEb = parcelRequire("9MSEb");
var $i8Rdf = parcelRequire("i8Rdf");
var $l9cUE = parcelRequire("l9cUE");
var $6p3HD = parcelRequire("6p3HD");
var $9rn5w = parcelRequire("9rn5w");
var $l8CKy = parcelRequire("l8CKy");
var $gcTfx = parcelRequire("gcTfx");
var $4gz8B = parcelRequire("4gz8B");
var $4Cx0W = parcelRequire("4Cx0W");
var $76ZQQ = parcelRequire("76ZQQ");

var $gR5sk = parcelRequire("gR5sk");

var $jwwez = parcelRequire("jwwez");
var $4f1ff5652324051f$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
class $4f1ff5652324051f$export$2b2f6d87ad7998b5 {
    constructor(uri, connectionId, messageFormatter, proxyInfo, headers, enableCompression){
        this.open = ()=>{
            if (this.privConnectionState === (0, $8wq1O.ConnectionState).Disconnected) return Promise.reject(`Cannot open a connection that is in ${this.privConnectionState} state`);
            if (this.privConnectionEstablishDeferral) return this.privConnectionEstablishDeferral.promise;
            this.privConnectionEstablishDeferral = new (0, $9MSEb.Deferred)();
            this.privCertificateValidatedDeferral = new (0, $9MSEb.Deferred)();
            this.privConnectionState = (0, $8wq1O.ConnectionState).Connecting;
            try {
                if (typeof WebSocket !== "undefined" && !$4f1ff5652324051f$export$2b2f6d87ad7998b5.forceNpmWebSocket) {
                    // Browser handles cert checks.
                    this.privCertificateValidatedDeferral.resolve();
                    this.privWebsocketClient = new WebSocket(this.privUri);
                } else {
                    const options = {
                        headers: this.privHeaders,
                        perMessageDeflate: this.privEnableCompression
                    };
                    // The ocsp library will handle validation for us and fail the connection if needed.
                    this.privCertificateValidatedDeferral.resolve();
                    const checkAgent = new (0, $jwwez.CertCheckAgent)(this.proxyInfo);
                    options.agent = checkAgent.GetAgent();
                    this.privWebsocketClient = new (0, (/*@__PURE__*/$parcel$interopDefault($gR5sk)))(this.privUri, options);
                }
                this.privWebsocketClient.binaryType = "arraybuffer";
                this.privReceivingMessageQueue = new (0, $i8Rdf.Queue)();
                this.privDisconnectDeferral = new (0, $9MSEb.Deferred)();
                this.privSendMessageQueue = new (0, $i8Rdf.Queue)();
                this.processSendQueue().catch((reason)=>{
                    (0, $l9cUE.Events).instance.onEvent(new (0, $6p3HD.BackgroundEvent)(reason));
                });
            } catch (error) {
                this.privConnectionEstablishDeferral.resolve(new (0, $9rn5w.ConnectionOpenResponse)(500, error));
                return this.privConnectionEstablishDeferral.promise;
            }
            this.onEvent(new (0, $l8CKy.ConnectionStartEvent)(this.privConnectionId, this.privUri));
            this.privWebsocketClient.onopen = (e)=>{
                this.privCertificateValidatedDeferral.promise.then(()=>{
                    this.privConnectionState = (0, $8wq1O.ConnectionState).Connected;
                    this.onEvent(new (0, $l8CKy.ConnectionEstablishedEvent)(this.privConnectionId));
                    this.privConnectionEstablishDeferral.resolve(new (0, $9rn5w.ConnectionOpenResponse)(200, ""));
                }, (error)=>{
                    this.privConnectionEstablishDeferral.reject(error);
                });
            };
            this.privWebsocketClient.onerror = (e)=>{
                this.onEvent(new (0, $l8CKy.ConnectionErrorEvent)(this.privConnectionId, e.message, e.type));
                this.privLastErrorReceived = e.message;
            };
            this.privWebsocketClient.onclose = (e)=>{
                if (this.privConnectionState === (0, $8wq1O.ConnectionState).Connecting) {
                    this.privConnectionState = (0, $8wq1O.ConnectionState).Disconnected;
                    // this.onEvent(new ConnectionEstablishErrorEvent(this.connectionId, e.code, e.reason));
                    this.privConnectionEstablishDeferral.resolve(new (0, $9rn5w.ConnectionOpenResponse)(e.code, e.reason + " " + this.privLastErrorReceived));
                } else {
                    this.privConnectionState = (0, $8wq1O.ConnectionState).Disconnected;
                    this.privWebsocketClient = null;
                    this.onEvent(new (0, $l8CKy.ConnectionClosedEvent)(this.privConnectionId, e.code, e.reason));
                }
                this.onClose(e.code, e.reason).catch((reason)=>{
                    (0, $l9cUE.Events).instance.onEvent(new (0, $6p3HD.BackgroundEvent)(reason));
                });
            };
            this.privWebsocketClient.onmessage = (e)=>{
                const networkReceivedTime = new Date().toISOString();
                if (this.privConnectionState === (0, $8wq1O.ConnectionState).Connected) {
                    const deferred = new (0, $9MSEb.Deferred)();
                    // let id = ++this.idCounter;
                    this.privReceivingMessageQueue.enqueueFromPromise(deferred.promise);
                    if (e.data instanceof ArrayBuffer) {
                        const rawMessage = new (0, $gcTfx.RawWebsocketMessage)((0, $4gz8B.MessageType).Binary, e.data);
                        this.privMessageFormatter.toConnectionMessage(rawMessage).then((connectionMessage)=>{
                            this.onEvent(new (0, $l8CKy.ConnectionMessageReceivedEvent)(this.privConnectionId, networkReceivedTime, connectionMessage));
                            deferred.resolve(connectionMessage);
                        }, (error)=>{
                            // TODO: Events for these ?
                            deferred.reject(`Invalid binary message format. Error: ${error}`);
                        });
                    } else {
                        const rawMessage = new (0, $gcTfx.RawWebsocketMessage)((0, $4gz8B.MessageType).Text, e.data);
                        this.privMessageFormatter.toConnectionMessage(rawMessage).then((connectionMessage)=>{
                            this.onEvent(new (0, $l8CKy.ConnectionMessageReceivedEvent)(this.privConnectionId, networkReceivedTime, connectionMessage));
                            deferred.resolve(connectionMessage);
                        }, (error)=>{
                            // TODO: Events for these ?
                            deferred.reject(`Invalid text message format. Error: ${error}`);
                        });
                    }
                }
            };
            return this.privConnectionEstablishDeferral.promise;
        };
        this.send = (message)=>{
            if (this.privConnectionState !== (0, $8wq1O.ConnectionState).Connected) return Promise.reject(`Cannot send on connection that is in ${(0, $8wq1O.ConnectionState)[this.privConnectionState]} state`);
            const messageSendStatusDeferral = new (0, $9MSEb.Deferred)();
            const messageSendDeferral = new (0, $9MSEb.Deferred)();
            this.privSendMessageQueue.enqueueFromPromise(messageSendDeferral.promise);
            this.privMessageFormatter.fromConnectionMessage(message).then((rawMessage)=>{
                messageSendDeferral.resolve({
                    Message: message,
                    RawWebsocketMessage: rawMessage,
                    sendStatusDeferral: messageSendStatusDeferral
                });
            }, (error)=>{
                messageSendDeferral.reject(`Error formatting the message. ${error}`);
            });
            return messageSendStatusDeferral.promise;
        };
        this.read = ()=>{
            if (this.privConnectionState !== (0, $8wq1O.ConnectionState).Connected) return Promise.reject(`Cannot read on connection that is in ${this.privConnectionState} state`);
            return this.privReceivingMessageQueue.dequeue();
        };
        this.close = (reason)=>{
            if (this.privWebsocketClient) {
                if (this.privConnectionState !== (0, $8wq1O.ConnectionState).Disconnected) this.privWebsocketClient.close(1000, reason ? reason : "Normal closure by client");
            } else return Promise.resolve();
            return this.privDisconnectDeferral.promise;
        };
        this.sendRawMessage = (sendItem)=>{
            try {
                // indicates we are draining the queue and it came with no message;
                if (!sendItem) return Promise.resolve();
                this.onEvent(new (0, $l8CKy.ConnectionMessageSentEvent)(this.privConnectionId, new Date().toISOString(), sendItem.Message));
                // add a check for the ws readystate in order to stop the red console error 'WebSocket is already in CLOSING or CLOSED state' appearing
                if (this.isWebsocketOpen) this.privWebsocketClient.send(sendItem.RawWebsocketMessage.payload);
                else return Promise.reject("websocket send error: Websocket not ready " + this.privConnectionId + " " + sendItem.Message.id + " " + new Error().stack);
                return Promise.resolve();
            } catch (e) {
                return Promise.reject(`websocket send error: ${e}`);
            }
        };
        this.onEvent = (event)=>{
            this.privConnectionEvents.onEvent(event);
            (0, $l9cUE.Events).instance.onEvent(event);
        };
        if (!uri) throw new (0, $4Cx0W.ArgumentNullError)("uri");
        if (!messageFormatter) throw new (0, $4Cx0W.ArgumentNullError)("messageFormatter");
        this.proxyInfo = proxyInfo;
        this.privConnectionEvents = new (0, $76ZQQ.EventSource)();
        this.privConnectionId = connectionId;
        this.privMessageFormatter = messageFormatter;
        this.privConnectionState = (0, $8wq1O.ConnectionState).None;
        this.privUri = uri;
        this.privHeaders = headers;
        this.privEnableCompression = enableCompression;
        // Add the connection ID to the headers
        this.privHeaders[(0, $2V1Xw.HeaderNames).ConnectionId] = this.privConnectionId;
        this.privLastErrorReceived = "";
    }
    get state() {
        return this.privConnectionState;
    }
    get events() {
        return this.privConnectionEvents;
    }
    onClose(code, reason) {
        return $4f1ff5652324051f$var$__awaiter(this, void 0, void 0, function*() {
            const closeReason = `Connection closed. ${code}: ${reason}`;
            this.privConnectionState = (0, $8wq1O.ConnectionState).Disconnected;
            this.privDisconnectDeferral.resolve();
            yield this.privReceivingMessageQueue.drainAndDispose((pendingReceiveItem)=>{
            // TODO: Events for these ?
            // Logger.instance.onEvent(new LoggingEvent(LogType.Warning, null, `Failed to process received message. Reason: ${closeReason}, Message: ${JSON.stringify(pendingReceiveItem)}`));
            }, closeReason);
            yield this.privSendMessageQueue.drainAndDispose((pendingSendItem)=>{
                pendingSendItem.sendStatusDeferral.reject(closeReason);
            }, closeReason);
        });
    }
    processSendQueue() {
        return $4f1ff5652324051f$var$__awaiter(this, void 0, void 0, function*() {
            while(true){
                const itemToSend = this.privSendMessageQueue.dequeue();
                const sendItem = yield itemToSend;
                // indicates we are draining the queue and it came with no message;
                if (!sendItem) return;
                try {
                    yield this.sendRawMessage(sendItem);
                    sendItem.sendStatusDeferral.resolve();
                } catch (sendError) {
                    sendItem.sendStatusDeferral.reject(sendError);
                }
            }
        });
    }
    get isWebsocketOpen() {
        return this.privWebsocketClient && this.privWebsocketClient.readyState === this.privWebsocketClient.OPEN;
    }
}
$4f1ff5652324051f$export$2b2f6d87ad7998b5.forceNpmWebSocket = false;

});
parcelRequire.register("jwwez", function(module, exports) {

$parcel$export(module.exports, "CertCheckAgent", () => $e36a027a0ef1ddd9$export$33c6fb0cef10017f);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.

var $gR5sk = parcelRequire("gR5sk");

var $eIIKM = parcelRequire("eIIKM");

var $fG4Tq = parcelRequire("fG4Tq");
parcelRequire("3KVS5");
var $1Uzk5 = parcelRequire("1Uzk5");
var $l9cUE = parcelRequire("l9cUE");

var $gR5sk = parcelRequire("gR5sk");

var $gR5sk = parcelRequire("gR5sk");

var $gR5sk = parcelRequire("gR5sk");

var $gR5sk = parcelRequire("gR5sk");

var $1Uzk5 = parcelRequire("1Uzk5");

var $hIXGI = parcelRequire("hIXGI");

var $cBXue = parcelRequire("cBXue");
var $e36a027a0ef1ddd9$require$Buffer = $cBXue.Buffer;
var $e36a027a0ef1ddd9$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
class $e36a027a0ef1ddd9$export$33c6fb0cef10017f {
    constructor(proxyInfo){
        if (!!proxyInfo) this.privProxyInfo = proxyInfo;
        // Initialize this here to allow tests to set the env variable before the cache is constructed.
        if (!$e36a027a0ef1ddd9$export$33c6fb0cef10017f.privDiskCache) $e36a027a0ef1ddd9$export$33c6fb0cef10017f.privDiskCache = new (0, (/*@__PURE__*/$parcel$interopDefault($gR5sk)))("microsoft-cognitiveservices-speech-sdk-cache", {
            supportBuffer: true,
            location: (typeof $hIXGI, undefined)
        });
    }
    // Test hook to force the disk cache to be recreated.
    static forceReinitDiskCache() {
        $e36a027a0ef1ddd9$export$33c6fb0cef10017f.privDiskCache = undefined;
        $e36a027a0ef1ddd9$export$33c6fb0cef10017f.privMemCache = {};
    }
    GetAgent(disableStapling) {
        const agent = new (0, (/*@__PURE__*/$parcel$interopDefault($gR5sk))).Agent(this.CreateConnection);
        if (this.privProxyInfo !== undefined && this.privProxyInfo.HostName !== undefined && this.privProxyInfo.Port > 0) {
            const proxyName = "privProxyInfo";
            agent[proxyName] = this.privProxyInfo;
        }
        return agent;
    }
    static GetProxyAgent(proxyInfo) {
        const httpProxyOptions = {
            host: proxyInfo.HostName,
            port: proxyInfo.Port
        };
        if (!!proxyInfo.UserName) httpProxyOptions.headers = {
            "Proxy-Authentication": "Basic " + new $e36a027a0ef1ddd9$require$Buffer(proxyInfo.UserName + ":" + (proxyInfo.Password === undefined) ? "" : proxyInfo.Password).toString("base64")
        };
        else httpProxyOptions.headers = {};
        httpProxyOptions.headers.requestOCSP = "true";
        const httpProxyAgent = new (0, (/*@__PURE__*/$parcel$interopDefault($gR5sk)))(httpProxyOptions);
        return httpProxyAgent;
    }
    static OCSPCheck(socketPromise, proxyInfo) {
        return $e36a027a0ef1ddd9$var$__awaiter(this, void 0, void 0, function*() {
            let ocspRequest;
            let stapling;
            let resolved = false;
            const socket = yield socketPromise;
            socket.cork();
            const tlsSocket = socket;
            return new Promise((resolve, reject)=>{
                socket.on("OCSPResponse", (data)=>{
                    if (!!data) {
                        this.onEvent(new (0, $1Uzk5.OCSPStapleReceivedEvent)());
                        stapling = data;
                    }
                });
                socket.on("error", (error)=>{
                    if (!resolved) {
                        resolved = true;
                        socket.destroy();
                        reject(error);
                    }
                });
                tlsSocket.on("secure", ()=>$e36a027a0ef1ddd9$var$__awaiter(this, void 0, void 0, function*() {
                        const peer = tlsSocket.getPeerCertificate(true);
                        try {
                            const issuer = yield this.GetIssuer(peer);
                            // We always need a request to verify the response.
                            ocspRequest = $fG4Tq.request.generate(peer.raw, issuer.raw);
                            // Do we have a result for this certificate in our memory cache?
                            const sig = ocspRequest.id.toString("hex");
                            // Stapled response trumps cached response.
                            if (!stapling) {
                                const cacheEntry = yield $e36a027a0ef1ddd9$export$33c6fb0cef10017f.GetResponseFromCache(sig, ocspRequest, proxyInfo);
                                stapling = cacheEntry;
                            }
                            yield this.VerifyOCSPResponse(stapling, ocspRequest, proxyInfo);
                            socket.uncork();
                            resolved = true;
                            resolve(socket);
                        } catch (e) {
                            socket.destroy();
                            resolved = true;
                            reject(e);
                        }
                    }));
            });
        });
    }
    static GetIssuer(peer) {
        if (peer.issuerCertificate) return Promise.resolve(peer.issuerCertificate);
        return new Promise((resolve, reject)=>{
            const ocspAgent = new $fG4Tq.Agent({});
            ocspAgent.fetchIssuer(peer, null, (error, value)=>{
                if (!!error) {
                    reject(error);
                    return;
                }
                resolve(value);
            });
        });
    }
    static GetResponseFromCache(signature, ocspRequest, proxyInfo) {
        return $e36a027a0ef1ddd9$var$__awaiter(this, void 0, void 0, function*() {
            let cachedResponse = $e36a027a0ef1ddd9$export$33c6fb0cef10017f.privMemCache[signature];
            if (!!cachedResponse) this.onEvent(new (0, $1Uzk5.OCSPMemoryCacheHitEvent)(signature));
            // Do we have a result for this certificate on disk in %TMP%?
            if (!cachedResponse) try {
                const diskCacheResponse = yield $e36a027a0ef1ddd9$export$33c6fb0cef10017f.privDiskCache.get(signature);
                if (!!diskCacheResponse.isCached) {
                    $e36a027a0ef1ddd9$export$33c6fb0cef10017f.onEvent(new (0, $1Uzk5.OCSPDiskCacheHitEvent)(signature));
                    $e36a027a0ef1ddd9$export$33c6fb0cef10017f.StoreMemoryCacheEntry(signature, diskCacheResponse.value);
                    cachedResponse = diskCacheResponse.value;
                }
            } catch (error) {
                cachedResponse = null;
            }
            if (!cachedResponse) return cachedResponse;
            try {
                const cachedOcspResponse = $fG4Tq.utils.parseResponse(cachedResponse);
                const tbsData = cachedOcspResponse.value.tbsResponseData;
                if (tbsData.responses.length < 1) {
                    this.onEvent(new (0, $1Uzk5.OCSPCacheFetchErrorEvent)(signature, "Not enough data in cached response"));
                    return;
                }
                const cachedStartTime = tbsData.responses[0].thisUpdate;
                const cachedNextTime = tbsData.responses[0].nextUpdate;
                if (cachedNextTime < Date.now() + this.testTimeOffset - 60000) {
                    // Cached entry has expired.
                    this.onEvent(new (0, $1Uzk5.OCSPCacheEntryExpiredEvent)(signature, cachedNextTime));
                    cachedResponse = null;
                } else {
                    // If we're within one day of the next update, or 50% of the way through the validity period,
                    // background an update to the cache.
                    const minUpdate = Math.min(86400000, (cachedNextTime - cachedStartTime) / 2);
                    if (cachedNextTime - (Date.now() + this.testTimeOffset) < minUpdate) {
                        this.onEvent(new (0, $1Uzk5.OCSPCacheEntryNeedsRefreshEvent)(signature, cachedStartTime, cachedNextTime));
                        this.UpdateCache(ocspRequest, proxyInfo).catch((error)=>{
                            // Well, not much we can do here.
                            this.onEvent(new (0, $1Uzk5.OCSPCacheUpdateErrorEvent)(signature, error.toString()));
                        });
                    } else this.onEvent(new (0, $1Uzk5.OCSPCacheHitEvent)(signature, cachedStartTime, cachedNextTime));
                }
            } catch (error) {
                this.onEvent(new (0, $1Uzk5.OCSPCacheFetchErrorEvent)(signature, error));
                cachedResponse = null;
            }
            if (!cachedResponse) this.onEvent(new (0, $1Uzk5.OCSPCacheMissEvent)(signature));
            return cachedResponse;
        });
    }
    static VerifyOCSPResponse(cacheValue, ocspRequest, proxyInfo) {
        return $e36a027a0ef1ddd9$var$__awaiter(this, void 0, void 0, function*() {
            let ocspResponse = cacheValue;
            const sig = ocspRequest.certID.toString("hex");
            // Do we have a valid response?
            if (!ocspResponse) ocspResponse = yield $e36a027a0ef1ddd9$export$33c6fb0cef10017f.GetOCSPResponse(ocspRequest, proxyInfo);
            return new Promise((resolve, reject)=>{
                $fG4Tq.verify({
                    request: ocspRequest,
                    response: ocspResponse
                }, (error, result)=>{
                    if (!!error) {
                        $e36a027a0ef1ddd9$export$33c6fb0cef10017f.onEvent(new (0, $1Uzk5.OCSPVerificationFailedEvent)(ocspRequest.id.toString("hex"), error));
                        // Bad Cached Value? One more try without the cache.
                        if (!!cacheValue) this.VerifyOCSPResponse(null, ocspRequest, proxyInfo).then(()=>{
                            resolve();
                        }, (error)=>{
                            reject(error);
                        });
                        else reject(error);
                    } else {
                        if (!cacheValue) $e36a027a0ef1ddd9$export$33c6fb0cef10017f.StoreCacheEntry(ocspRequest.id.toString("hex"), ocspResponse);
                        resolve();
                    }
                });
            });
        });
    }
    static UpdateCache(req, proxyInfo) {
        return $e36a027a0ef1ddd9$var$__awaiter(this, void 0, void 0, function*() {
            const signature = req.id.toString("hex");
            this.onEvent(new (0, $1Uzk5.OCSPCacheUpdateNeededEvent)(signature));
            const rawResponse = yield this.GetOCSPResponse(req, proxyInfo);
            this.StoreCacheEntry(signature, rawResponse);
            this.onEvent(new (0, $1Uzk5.OCSPCacheUpdatehCompleteEvent)(req.id.toString("hex")));
        });
    }
    static StoreCacheEntry(sig, rawResponse) {
        this.StoreMemoryCacheEntry(sig, rawResponse);
        this.StoreDiskCacheEntry(sig, rawResponse);
    }
    static StoreMemoryCacheEntry(sig, rawResponse) {
        this.privMemCache[sig] = rawResponse;
        this.onEvent(new (0, $1Uzk5.OCSPMemoryCacheStoreEvent)(sig));
    }
    static StoreDiskCacheEntry(sig, rawResponse) {
        this.privDiskCache.set(sig, rawResponse).then(()=>{
            this.onEvent(new (0, $1Uzk5.OCSPDiskCacheStoreEvent)(sig));
        });
    }
    static GetOCSPResponse(req, proxyInfo) {
        const ocspMethod = "1.3.6.1.5.5.7.48.1";
        let options = {};
        if (!!proxyInfo) {
            const agent = $e36a027a0ef1ddd9$export$33c6fb0cef10017f.GetProxyAgent(proxyInfo);
            options.agent = agent;
        }
        return new Promise((resolve, reject)=>{
            $fG4Tq.utils.getAuthorityInfo(req.cert, ocspMethod, (error, uri)=>{
                if (error) {
                    reject(error);
                    return;
                }
                const parsedUri = (/*@__PURE__*/$parcel$interopDefault($eIIKM))(uri);
                parsedUri.path = parsedUri.pathname;
                options = Object.assign(Object.assign({}, options), parsedUri);
                $fG4Tq.utils.getResponse(options, req.data, (error, raw)=>{
                    if (error) {
                        reject(error);
                        return;
                    }
                    this.onEvent(new (0, $1Uzk5.OCSPResponseRetrievedEvent)(req.certID.toString("hex")));
                    resolve(raw);
                });
            });
        });
    }
    CreateConnection(request, options) {
        const enableOCSP = typeof $hIXGI !== "undefined" && true && true && options.secureEndpoint;
        let socketPromise;
        options = Object.assign(Object.assign({}, options), {
            requestOCSP: !$e36a027a0ef1ddd9$export$33c6fb0cef10017f.forceDisableOCSPStapling,
            servername: options.host
        });
        if (!!this.privProxyInfo) {
            const httpProxyAgent = $e36a027a0ef1ddd9$export$33c6fb0cef10017f.GetProxyAgent(this.privProxyInfo);
            const baseAgent = httpProxyAgent;
            socketPromise = new Promise((resolve, reject)=>{
                baseAgent.callback(request, options, (error, socket)=>{
                    if (!!error) reject(error);
                    else resolve(socket);
                });
            });
        } else if (!!options.secureEndpoint) socketPromise = Promise.resolve($gR5sk.connect(options));
        else socketPromise = Promise.resolve($gR5sk.connect(options));
        if (!!enableOCSP) return $e36a027a0ef1ddd9$export$33c6fb0cef10017f.OCSPCheck(socketPromise, this.privProxyInfo);
        else return socketPromise;
    }
}
// Test hook to enable forcing expiration / refresh to happen.
$e36a027a0ef1ddd9$export$33c6fb0cef10017f.testTimeOffset = 0;
// Test hook to disable stapling for cache testing.
$e36a027a0ef1ddd9$export$33c6fb0cef10017f.forceDisableOCSPStapling = false;
// An in memory cache for recived responses.
$e36a027a0ef1ddd9$export$33c6fb0cef10017f.privMemCache = {};
$e36a027a0ef1ddd9$export$33c6fb0cef10017f.onEvent = (event)=>{
    (0, $l9cUE.Events).instance.onEvent(event);
};

});
parcelRequire.register("fG4Tq", function(module, exports) {

$parcel$export(module.exports, "Agent", () => $b69e92df97f29ace$export$f05c48a4001d5356, (v) => $b69e92df97f29ace$export$f05c48a4001d5356 = v);
$parcel$export(module.exports, "request", () => $b69e92df97f29ace$export$b5fe3f66a567bec0, (v) => $b69e92df97f29ace$export$b5fe3f66a567bec0 = v);
$parcel$export(module.exports, "check", () => $b69e92df97f29ace$export$35dc45686fc2dbd7, (v) => $b69e92df97f29ace$export$35dc45686fc2dbd7 = v);
$parcel$export(module.exports, "verify", () => $b69e92df97f29ace$export$532244b5b8b0b4b6, (v) => $b69e92df97f29ace$export$532244b5b8b0b4b6 = v);
$parcel$export(module.exports, "utils", () => $b69e92df97f29ace$export$eab97d15b1788b8d, (v) => $b69e92df97f29ace$export$eab97d15b1788b8d = v);
var $b69e92df97f29ace$export$94affb487e701bf2;
var $b69e92df97f29ace$export$f05c48a4001d5356;
var $b69e92df97f29ace$export$d13669af3ccf7e71;
var $b69e92df97f29ace$export$b5fe3f66a567bec0;
var $b69e92df97f29ace$export$35dc45686fc2dbd7;
var $b69e92df97f29ace$export$532244b5b8b0b4b6;
var $b69e92df97f29ace$export$eab97d15b1788b8d;
"use strict";

$b69e92df97f29ace$export$94affb487e701bf2 = (parcelRequire("5wqRw"));

$b69e92df97f29ace$export$f05c48a4001d5356 = (parcelRequire("lTRQz"));

$b69e92df97f29ace$export$d13669af3ccf7e71 = (parcelRequire("4iBuq")).getOCSPURI;

$b69e92df97f29ace$export$b5fe3f66a567bec0 = (parcelRequire("9DeST"));

$b69e92df97f29ace$export$35dc45686fc2dbd7 = (parcelRequire("ebXWq"));

$b69e92df97f29ace$export$532244b5b8b0b4b6 = (parcelRequire("lsocy"));

$b69e92df97f29ace$export$eab97d15b1788b8d = (parcelRequire("gXQEB"));

});
parcelRequire.register("5wqRw", function(module, exports) {
"use strict";

var $fG4Tq = parcelRequire("fG4Tq");
function $4054c72f64f1fb1a$var$Cache(options) {
    this.options = options || {};
    this.cache = {};
    // Override methods
    if (this.options.probe) this.probe = this.options.probe;
    if (this.options.store) this.store = this.options.store;
    if (this.options.filter) this.filter = this.options.filter;
}
module.exports = $4054c72f64f1fb1a$var$Cache;
$4054c72f64f1fb1a$var$Cache.prototype.filter = function filter(url, callback) {
    callback(null);
};
$4054c72f64f1fb1a$var$Cache.prototype.probe = function probe(id, callback) {
    if (this.cache.hasOwnProperty(id)) callback(null, this.cache[id]);
    else callback(null, false);
};
$4054c72f64f1fb1a$var$Cache.prototype.store = function store(id, response, maxTime, callback) {
    if (this.cache.hasOwnProperty(id)) clearTimeout(this.cache[id].timer);
    var self = this;
    this.cache[id] = {
        response: response,
        timer: setTimeout(function() {
            delete self.cache[id];
        }, maxTime)
    };
    callback(null, null);
};
$4054c72f64f1fb1a$var$Cache.prototype.request = function request(id, data, callback) {
    var self = this;
    function done(err, response) {
        if (callback) callback(err, response);
        callback = null;
    }
    function onResponse(err, ocsp) {
        if (err) return done(err);
        // Respond early
        done(null, ocsp);
        // Try parsing and caching response
        self.getMaxStoreTime(ocsp, function(err, maxTime) {
            if (err) return;
            self.store(id, ocsp, maxTime, function() {
            // No-op
            });
        });
    }
    // Check that url isn't blacklisted
    this.filter(data.url, function(err) {
        if (err) return done(err, null);
        $fG4Tq.utils.getResponse(data.url, data.ocsp, onResponse);
    });
};
$4054c72f64f1fb1a$var$Cache.prototype.getMaxStoreTime = function getMaxStoreTime(response, callback) {
    var basic;
    try {
        basic = $fG4Tq.utils.parseResponse(response).value;
    } catch (e) {
        return callback(e);
    }
    // Not enough responses
    if (basic.tbsResponseData.responses.length === 0) return callback(new Error("No OCSP responses"));
    var responses = basic.tbsResponseData.responses;
    // Every response should be positive
    var good = responses.every(function(response) {
        return response.certStatus.type === "good";
    });
    // No good - no cache
    if (!good) return callback(new Error("Some OCSP responses are not good"));
    // Find minimum nextUpdate time
    var nextUpdate = 0;
    for(var i = 0; i < responses.length; i++){
        var response = responses[i];
        var responseNext = response.nextUpdate;
        if (!responseNext) continue;
        if (nextUpdate === 0 || nextUpdate > responseNext) nextUpdate = responseNext;
    }
    return callback(null, Math.max(0, nextUpdate - new Date()));
};

});

parcelRequire.register("lTRQz", function(module, exports) {

var $cBXue = parcelRequire("cBXue");
var $ff1880e42171546e$require$Buffer = $cBXue.Buffer;
"use strict";

var $fG4Tq = parcelRequire("fG4Tq");

var $2PcSP = parcelRequire("2PcSP");

var $8jiUm = parcelRequire("8jiUm");

var $bUJWB = parcelRequire("bUJWB");

var $gR5sk = parcelRequire("gR5sk");

var $gR5sk = parcelRequire("gR5sk");
function $ff1880e42171546e$var$Agent(options) {
    if (!options) options = {};
    $bUJWB.Agent.call(this, options);
    this.caCache = new $gR5sk({
        maxSize: options.CACacheSize || 1024
    });
}
module.exports = $ff1880e42171546e$var$Agent;
$2PcSP.inherits($ff1880e42171546e$var$Agent, $bUJWB.Agent);
$ff1880e42171546e$var$Agent.prototype.createConnection = function createConnection(port, host, options) {
    if (port !== null && typeof port === "object") {
        options = port;
        port = null;
    } else if (host !== null && typeof host === "object") {
        options = host;
        host = null;
    } else if (options === null || typeof options !== "object") options = {};
    if (typeof port === "number") options.port = port;
    if (typeof host === "string") options.host = host;
    var ocspOptions = $2PcSP._extend({
        requestOCSP: true
    }, options);
    var socket = $bUJWB.Agent.prototype.createConnection.call(this, port, host, ocspOptions);
    var self = this;
    var stapling = null;
    socket.on("OCSPResponse", function(data) {
        stapling = data;
    });
    socket.on("secure", function() {
        return self.handleOCSPResponse(socket, stapling, function(err) {
            if (err) return socket.destroy(err);
            // Time to allow all writes!
            socket.uncork();
        });
    });
    // Do not let any writes come through until we will verify OCSP
    socket.cork();
    return socket;
};
$ff1880e42171546e$var$Agent.prototype.handleOCSPResponse = function handleOCSPResponse(socket, stapling, cb) {
    var cert = socket.ssl.getPeerCertificate(true);
    var issuer = cert.issuerCertificate;
    cert = cert.raw;
    try {
        cert = $gR5sk.Certificate.decode(cert, "der");
        if (issuer) {
            issuer = issuer.raw;
            issuer = $gR5sk.Certificate.decode(issuer, "der");
        }
    } catch (e) {
        return cb(e);
    }
    function onIssuer(err, x509) {
        if (err) return cb(err);
        issuer = x509;
        if (stapling) {
            var req = $fG4Tq.request.generate(cert, issuer);
            $fG4Tq.verify({
                request: req,
                response: stapling
            }, cb);
        } else return $fG4Tq.check({
            cert: cert,
            issuer: issuer
        }, cb);
    }
    if (issuer) return onIssuer(null, issuer);
    else return this.fetchIssuer(cert, stapling, onIssuer);
};
$ff1880e42171546e$var$Agent.prototype.fetchIssuer = function fetchIssuer(cert, stapling, cb) {
    var issuers = $fG4Tq.utils["id-ad-caIssuers"].join(".");
    var self = this;
    // TODO(indutny): use info from stapling response
    $fG4Tq.utils.getAuthorityInfo(cert, issuers, function(err, uri) {
        if (err) return cb(err);
        var ca = self.caCache.get(uri);
        if (ca) return cb(null, ca);
        var once = false;
        function done(err, data) {
            if (once) return;
            once = true;
            cb(err, data);
        }
        function onResponse(res) {
            if (res.statusCode < 200 || res.statusCode >= 400) return done(new Error("Failed to fetch CA: " + res.statusCode));
            var chunks = [];
            res.on("readable", function() {
                var chunk = res.read();
                if (!chunk) return;
                chunks.push(chunk);
            });
            res.on("end", function() {
                var cert = $ff1880e42171546e$require$Buffer.concat(chunks);
                try {
                    cert = $gR5sk.Certificate.decode(cert, "der");
                } catch (e) {
                    return done(e);
                }
                self.caCache.set(uri, cert);
                done(null, cert);
            });
        }
        $8jiUm.get(uri).on("error", done).on("response", onResponse);
    });
};

});

parcelRequire.register("4iBuq", function(module, exports) {

$parcel$export(module.exports, "getOCSPURI", () => $3215ec8fd4c8ed8a$export$d13669af3ccf7e71, (v) => $3215ec8fd4c8ed8a$export$d13669af3ccf7e71 = v);
var $3215ec8fd4c8ed8a$export$d13669af3ccf7e71;
"use strict";

var $fG4Tq = parcelRequire("fG4Tq");

var $gR5sk = parcelRequire("gR5sk");

var $gR5sk = parcelRequire("gR5sk");
$3215ec8fd4c8ed8a$export$d13669af3ccf7e71 = function getOCSPURI(rawCert, cb) {
    var ocspMethod = $gR5sk["id-pkix-ocsp"].join(".");
    var cert = $fG4Tq.utils.toDER(rawCert, "CERTIFICATE");
    cert = $gR5sk.Certificate.decode(cert, "der");
    $fG4Tq.utils.getAuthorityInfo(cert, ocspMethod, cb);
};

});

parcelRequire.register("9DeST", function(module, exports) {

$parcel$export(module.exports, "generate", () => $70334d52b2479953$export$80d376111cc09ad7, (v) => $70334d52b2479953$export$80d376111cc09ad7 = v);
var $70334d52b2479953$export$80d376111cc09ad7;
"use strict";

var $fG4Tq = parcelRequire("fG4Tq");

var $BAx0W = parcelRequire("BAx0W");

var $gR5sk = parcelRequire("gR5sk");

var $gR5sk = parcelRequire("gR5sk");
function $70334d52b2479953$var$sha1(data) {
    return $BAx0W.createHash("sha1").update(data).digest();
}
$70334d52b2479953$export$80d376111cc09ad7 = function generate(rawCert, rawIssuer) {
    var cert;
    if (rawCert.tbsCertificate) cert = rawCert;
    else cert = $gR5sk.Certificate.decode($fG4Tq.utils.toDER(rawCert, "CERTIFICATE"), "der");
    var issuer;
    if (rawIssuer.tbsCertificate) issuer = rawIssuer;
    else issuer = $gR5sk.Certificate.decode($fG4Tq.utils.toDER(rawIssuer, "CERTIFICATE"), "der");
    var tbsCert = cert.tbsCertificate;
    var tbsIssuer = issuer.tbsCertificate;
    var certID = {
        hashAlgorithm: {
            // algorithm: [ 2, 16, 840, 1, 101, 3, 4, 2, 1 ]  // sha256
            algorithm: [
                1,
                3,
                14,
                3,
                2,
                26
            ] // sha1
        },
        issuerNameHash: $70334d52b2479953$var$sha1($gR5sk.Name.encode(tbsCert.issuer, "der")),
        issuerKeyHash: $70334d52b2479953$var$sha1(tbsIssuer.subjectPublicKeyInfo.subjectPublicKey.data),
        serialNumber: tbsCert.serialNumber
    };
    var tbs = {
        version: "v1",
        requestList: [
            {
                reqCert: certID
            }
        ],
        requestExtensions: [
            {
                extnID: $gR5sk["id-pkix-ocsp-nonce"],
                critical: false,
                extnValue: $gR5sk.Nonce.encode($BAx0W.randomBytes(16), "der")
            }
        ]
    };
    var req = {
        tbsRequest: tbs
    };
    return {
        id: $70334d52b2479953$var$sha1($gR5sk.CertID.encode(certID, "der")),
        certID: certID,
        data: $gR5sk.OCSPRequest.encode(req, "der"),
        // Just to avoid re-parsing DER
        cert: cert,
        issuer: issuer
    };
};

});

parcelRequire.register("ebXWq", function(module, exports) {

var $hIXGI = parcelRequire("hIXGI");
"use strict";

var $fG4Tq = parcelRequire("fG4Tq");

var $2PcSP = parcelRequire("2PcSP");

var $aaypF = parcelRequire("aaypF");

var $gR5sk = parcelRequire("gR5sk");
module.exports = function check(options, cb) {
    var sync = true;
    var req;
    function done(err, data) {
        if (sync) {
            sync = false;
            $hIXGI.nextTick(function() {
                cb(err, data);
            });
            return;
        }
        cb(err, data);
    }
    try {
        req = $fG4Tq.request.generate(options.cert, options.issuer);
    } catch (e) {
        return done(e);
    }
    var ocspMethod = $gR5sk["id-pkix-ocsp"].join(".");
    $fG4Tq.utils.getAuthorityInfo(req.cert, ocspMethod, function(err, uri) {
        if (err) return done(err);
        var httpOptions;
        if (options.httpOptions !== undefined) httpOptions = $2PcSP._extend(options.httpOptions, $aaypF.parse(uri));
        else httpOptions = uri;
        $fG4Tq.utils.getResponse(httpOptions, req.data, function(err, raw) {
            if (err) return done(err);
            $fG4Tq.verify({
                request: req,
                response: raw
            }, done);
        });
    });
    sync = false;
};

});

parcelRequire.register("lsocy", function(module, exports) {

var $hIXGI = parcelRequire("hIXGI");
"use strict";

var $fG4Tq = parcelRequire("fG4Tq");

var $gR5sk = parcelRequire("gR5sk");

var $BAx0W = parcelRequire("BAx0W");
// TODO(indutny): verify issuer, etc...
function $f9eefc67e1a73759$var$findResponder(issuer, certs, raws) {
    var issuerKey = issuer.tbsCertificate.subjectPublicKeyInfo;
    issuerKey = $fG4Tq.utils.toPEM($gR5sk.SubjectPublicKeyInfo.encode(issuerKey, "der"), "PUBLIC KEY");
    for(var i = 0; i < certs.length; i++){
        var cert = certs[i];
        var signAlg = $fG4Tq.utils.sign[cert.signatureAlgorithm.algorithm.join(".")];
        if (!signAlg) throw new Error("Unknown signature algorithm " + cert.signatureAlgorithm.algorithm);
        var verify = $BAx0W.createVerify(signAlg);
        verify.update(raws[i]);
        if (!verify.verify(issuerKey, cert.signature.data)) throw new Error("Invalid signature");
        var certKey = cert.tbsCertificate.subjectPublicKeyInfo;
        certKey = $fG4Tq.utils.toPEM($gR5sk.SubjectPublicKeyInfo.encode(certKey, "der"), "PUBLIC KEY");
        return certKey;
    }
    return issuerKey;
}
module.exports = function verify(options, cb) {
    var req = options.request;
    var issuer;
    var res;
    function done(err) {
        $hIXGI.nextTick(function() {
            cb(err, res && res.certStatus);
        });
    }
    try {
        issuer = req.issuer || $gR5sk.Certificate.decode($fG4Tq.utils.toDER(options.issuer, "CERTIFICATE"), "der");
        res = $fG4Tq.utils.parseResponse(options.response);
    } catch (e) {
        return done(e);
    }
    var rawTBS = options.response.slice(res.start, res.end);
    var certs = res.certs;
    var raws = res.certsTbs.map(function(tbs) {
        return options.response.slice(tbs.start, tbs.end);
    });
    res = res.value;
    // Verify signature using CAs Public Key
    var signAlg = $fG4Tq.utils.sign[res.signatureAlgorithm.algorithm.join(".")];
    if (!signAlg) {
        done(new Error("Unknown signature algorithm " + res.signatureAlgorithm.algorithm));
        return;
    }
    var responderKey = $f9eefc67e1a73759$var$findResponder(issuer, certs, raws);
    var verify = $BAx0W.createVerify(signAlg);
    var tbs = res.tbsResponseData;
    var signature = res.signature.data;
    verify.update(rawTBS);
    if (!verify.verify(responderKey, signature)) return done(new Error("Invalid signature"));
    if (tbs.responses.length < 1) return done(new Error("Expected at least one response"));
    var res = tbs.responses[0];
    // Verify CertID
    // XXX(indutny): verify parameters
    if (res.certId.hashAlgorithm.algorithm.join(".") !== req.certID.hashAlgorithm.algorithm.join(".")) return done(new Error("Hash algorithm mismatch"));
    if (res.certId.issuerNameHash.toString("hex") !== req.certID.issuerNameHash.toString("hex")) return done(new Error("Issuer name hash mismatch"));
    if (res.certId.issuerKeyHash.toString("hex") !== req.certID.issuerKeyHash.toString("hex")) return done(new Error("Issuer key hash mismatch"));
    if (res.certId.serialNumber.cmp(req.certID.serialNumber) !== 0) return done(new Error("Serial number mismatch"));
    if (res.certStatus.type !== "good") return done(new Error("OCSP Status: " + res.certStatus.type));
    var now = +new Date();
    var nudge = options.nudge || 60000;
    if (res.thisUpdate - nudge > now || res.nextUpdate + nudge < now) return done(new Error("OCSP Response expired"));
    return done(null);
};

});

parcelRequire.register("gXQEB", function(module, exports) {

$parcel$export(module.exports, "id-ad-caIssuers", () => $c59b000417a5128f$export$4fec380fe713e5f0, (v) => $c59b000417a5128f$export$4fec380fe713e5f0 = v);
$parcel$export(module.exports, "id-kp-OCSPSigning", () => $c59b000417a5128f$export$cc129aae36a95970, (v) => $c59b000417a5128f$export$cc129aae36a95970 = v);
$parcel$export(module.exports, "getResponse", () => $c59b000417a5128f$export$fd3c80c00b3490e, (v) => $c59b000417a5128f$export$fd3c80c00b3490e = v);
$parcel$export(module.exports, "parseResponse", () => $c59b000417a5128f$export$ba14d9a5a581e827, (v) => $c59b000417a5128f$export$ba14d9a5a581e827 = v);
$parcel$export(module.exports, "digest", () => $c59b000417a5128f$export$4dc2d9f0820a4918, (v) => $c59b000417a5128f$export$4dc2d9f0820a4918 = v);
$parcel$export(module.exports, "digestRev", () => $c59b000417a5128f$export$c8ea77706602d916, (v) => $c59b000417a5128f$export$c8ea77706602d916 = v);
$parcel$export(module.exports, "sign", () => $c59b000417a5128f$export$c5552dfdbc7cec71, (v) => $c59b000417a5128f$export$c5552dfdbc7cec71 = v);
$parcel$export(module.exports, "signRev", () => $c59b000417a5128f$export$5a8675f8a69a5b77, (v) => $c59b000417a5128f$export$5a8675f8a69a5b77 = v);
$parcel$export(module.exports, "toPEM", () => $c59b000417a5128f$export$2e9cf5b395720b17, (v) => $c59b000417a5128f$export$2e9cf5b395720b17 = v);
$parcel$export(module.exports, "toDER", () => $c59b000417a5128f$export$9c9ec61016848ce4, (v) => $c59b000417a5128f$export$9c9ec61016848ce4 = v);
$parcel$export(module.exports, "getAuthorityInfo", () => $c59b000417a5128f$export$e5f363520dce6300, (v) => $c59b000417a5128f$export$e5f363520dce6300 = v);
$parcel$export(module.exports, "RSAPrivateKey", () => $c59b000417a5128f$export$f4aab6816f64fa6b, (v) => $c59b000417a5128f$export$f4aab6816f64fa6b = v);
var $c59b000417a5128f$export$4fec380fe713e5f0;
var $c59b000417a5128f$export$cc129aae36a95970;
var $c59b000417a5128f$export$fd3c80c00b3490e;
var $c59b000417a5128f$export$ba14d9a5a581e827;
var $c59b000417a5128f$export$4dc2d9f0820a4918;
var $c59b000417a5128f$export$c8ea77706602d916;
var $c59b000417a5128f$export$c5552dfdbc7cec71;
var $c59b000417a5128f$export$5a8675f8a69a5b77;
var $c59b000417a5128f$export$2e9cf5b395720b17;
var $c59b000417a5128f$export$9c9ec61016848ce4;
var $c59b000417a5128f$export$e5f363520dce6300;
var $c59b000417a5128f$export$f4aab6816f64fa6b;

var $cBXue = parcelRequire("cBXue");
var $c59b000417a5128f$require$Buffer = $cBXue.Buffer;
"use strict";

var $8jiUm = parcelRequire("8jiUm");

var $2PcSP = parcelRequire("2PcSP");

var $aaypF = parcelRequire("aaypF");

var $d7iYd = parcelRequire("d7iYd");

var $gR5sk = parcelRequire("gR5sk");
$c59b000417a5128f$export$4fec380fe713e5f0 = [
    1,
    3,
    6,
    1,
    5,
    5,
    7,
    48,
    2
];
$c59b000417a5128f$export$cc129aae36a95970 = [
    1,
    3,
    6,
    1,
    5,
    5,
    7,
    3,
    9
];
$c59b000417a5128f$export$fd3c80c00b3490e = function getResponse(uri, req, cb) {
    if (typeof uri !== "object") uri = $aaypF.parse(uri);
    var options = $2PcSP._extend({
        method: "POST",
        headers: {
            "Content-Type": "application/ocsp-request",
            "Content-Length": req.length
        }
    }, uri);
    function done(err, response) {
        if (cb) cb(err, response);
        cb = null;
    }
    function onResponse(response) {
        if (response.statusCode < 200 || response.statusCode >= 400) return done(new Error("Failed to obtain OCSP response: " + response.statusCode));
        var chunks = [];
        response.on("readable", function() {
            var chunk = response.read();
            if (!chunk) return;
            chunks.push(chunk);
        });
        response.on("end", function() {
            var ocsp = $c59b000417a5128f$require$Buffer.concat(chunks);
            done(null, ocsp);
        });
    }
    $8jiUm.request(options, onResponse).on("error", done).end(req);
};
$c59b000417a5128f$export$ba14d9a5a581e827 = function parseResponse(raw) {
    var body = {
        start: 0,
        end: raw.length
    };
    var response = $gR5sk.OCSPResponse.decode(raw, "der", {
        track: function(key, start, end, type) {
            if (type !== "content" || key !== "responseBytes/response") return;
            body.start = start;
            body.end = end;
        }
    });
    var status = response.responseStatus;
    if (status !== "successful") throw new Error("Bad OCSP response status: " + status);
    // Unknown response type
    var responseType = response.responseBytes.responseType;
    if (responseType !== "id-pkix-ocsp-basic") throw new Error("Unknown OCSP response type: " + responseType);
    var bytes = response.responseBytes.response;
    var tbs = {
        start: body.start,
        end: body.end
    };
    var certsTbs = [];
    var basic = $gR5sk.BasicOCSPResponse.decode(bytes, "der", {
        track: function(key, start, end, type) {
            if (type !== "tagged") return;
            if (key === "tbsResponseData") {
                tbs.start = body.start + start;
                tbs.end = body.start + end;
            } else if (key === "certs/tbsCertificate") certsTbs.push({
                start: body.start + start,
                end: body.start + end
            });
        }
    });
    var OCSPSigning = $c59b000417a5128f$export$cc129aae36a95970.join(".");
    var certs = (basic.certs || []).filter(function(cert) {
        return cert.tbsCertificate.extensions.some(function(ext) {
            if (ext.extnID !== "extendedKeyUsage") return false;
            return ext.extnValue.some(function(value) {
                return value.join(".") === OCSPSigning;
            });
        });
    });
    return {
        start: tbs.start,
        end: tbs.end,
        value: basic,
        certs: certs,
        certsTbs: certsTbs
    };
};
$c59b000417a5128f$export$4dc2d9f0820a4918 = {
    "1.3.14.3.2.26": "sha1",
    "2.16.840.1.101.3.4.2.1": "sha256"
};
$c59b000417a5128f$export$c8ea77706602d916 = {
    sha1: "1.3.14.3.2.26",
    sha256: "2.16.840.1.101.3.4.2.1"
};
$c59b000417a5128f$export$c5552dfdbc7cec71 = {
    "1.2.840.113549.1.1.5": "sha1WithRSAEncryption",
    "1.2.840.113549.1.1.11": "sha256WithRSAEncryption",
    "1.2.840.113549.1.1.12": "sha384WithRSAEncryption",
    "1.2.840.113549.1.1.13": "sha512WithRSAEncryption"
};
$c59b000417a5128f$export$5a8675f8a69a5b77 = {
    sha1WithRSAEncryption: [
        1,
        2,
        840,
        113549,
        1,
        1,
        5
    ],
    sha256WithRSAEncryption: [
        1,
        2,
        840,
        113549,
        1,
        1,
        11
    ],
    sha384WithRSAEncryption: [
        1,
        2,
        840,
        113549,
        1,
        1,
        12
    ],
    sha512WithRSAEncryption: [
        1,
        2,
        840,
        113549,
        1,
        1,
        13
    ]
};
$c59b000417a5128f$export$2e9cf5b395720b17 = function toPEM(buf, label) {
    var p = buf.toString("base64");
    var out = [
        "-----BEGIN " + label + "-----"
    ];
    for(var i = 0; i < p.length; i += 64)out.push(p.slice(i, i + 64));
    out.push("-----END " + label + "-----");
    return out.join("\n");
};
$c59b000417a5128f$export$9c9ec61016848ce4 = function toDER(raw, what) {
    var der = raw.toString().match(new RegExp("-----BEGIN " + what + "-----([^-]*)-----END " + what + "-----"));
    if (der) der = new $c59b000417a5128f$require$Buffer(der[1].replace(/[\r\n]/g, ""), "base64");
    else if (typeof raw === "string") der = new $c59b000417a5128f$require$Buffer(raw);
    else der = raw;
    return der;
};
$c59b000417a5128f$export$e5f363520dce6300 = function getAuthorityInfo(cert, key, done) {
    var exts = cert.tbsCertificate.extensions;
    if (!exts) exts = [];
    var infoAccess = exts.filter(function(ext) {
        return ext.extnID === "authorityInformationAccess";
    });
    if (infoAccess.length === 0) return done(new Error("AuthorityInfoAccess not found in extensions"));
    var res = null;
    var found = infoAccess.some(function(info) {
        var ext = info.extnValue;
        return ext.some(function(ad) {
            if (ad.accessMethod.join(".") !== key) return false;
            var loc = ad.accessLocation;
            if (loc.type !== "uniformResourceIdentifier") return false;
            res = loc.value + "";
            return true;
        });
    });
    if (!found) return done(new Error(key + " not found in AuthorityInfoAccess"));
    return done(null, res);
};
var $c59b000417a5128f$var$RSAPrivateKey = $d7iYd.define("RSAPrivateKey", function() {
    this.seq().obj(this.key("version").int(), this.key("modulus").int(), this.key("publicExponent").int(), this.key("privateExponent").int(), this.key("prime1").int(), this.key("prime2").int(), this.key("exponent1").int(), this.key("exponent2").int(), this.key("coefficient").int());
});
$c59b000417a5128f$export$f4aab6816f64fa6b = $c59b000417a5128f$var$RSAPrivateKey;

});





parcelRequire.register("cGmX2", function(module, exports) {

$parcel$export(module.exports, "ReplayableAudioNode", () => $93bb35e5fb1ae57e$export$3553271f667249af);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
class $93bb35e5fb1ae57e$export$3553271f667249af {
    constructor(audioSource, bytesPerSecond){
        this.privBuffers = [];
        this.privReplayOffset = 0;
        this.privLastShrinkOffset = 0;
        this.privBufferStartOffset = 0;
        this.privBufferSerial = 0;
        this.privBufferedBytes = 0;
        this.privReplay = false;
        this.privLastChunkAcquiredTime = 0;
        this.id = ()=>{
            return this.privAudioNode.id();
        };
        this.privAudioNode = audioSource;
        this.privBytesPerSecond = bytesPerSecond;
    }
    // Reads and returns the next chunk of audio buffer.
    // If replay of existing buffers are needed, read() will first seek and replay
    // existing content, and upoin completion it will read new content from the underlying
    // audio node, saving that content into the replayable buffers.
    read() {
        // if there is a replay request to honor.
        if (!!this.privReplay && this.privBuffers.length !== 0) {
            // Find the start point in the buffers.
            // Offsets are in 100ns increments.
            // So how many bytes do we need to seek to get the right offset?
            const offsetToSeek = this.privReplayOffset - this.privBufferStartOffset;
            let bytesToSeek = Math.round(offsetToSeek * this.privBytesPerSecond * 1e-7);
            if (0 !== bytesToSeek % 2) bytesToSeek++;
            let i = 0;
            while(i < this.privBuffers.length && bytesToSeek >= this.privBuffers[i].chunk.buffer.byteLength)bytesToSeek -= this.privBuffers[i++].chunk.buffer.byteLength;
            if (i < this.privBuffers.length) {
                const retVal = this.privBuffers[i].chunk.buffer.slice(bytesToSeek);
                this.privReplayOffset += retVal.byteLength / this.privBytesPerSecond * 1e+7;
                // If we've reached the end of the buffers, stop replaying.
                if (i === this.privBuffers.length - 1) this.privReplay = false;
                return Promise.resolve({
                    buffer: retVal,
                    isEnd: false,
                    timeReceived: this.privBuffers[i].chunk.timeReceived
                });
            }
        }
        return this.privAudioNode.read().then((result)=>{
            if (result && result.buffer) {
                this.privBuffers.push(new $93bb35e5fb1ae57e$var$BufferEntry(result, this.privBufferSerial++, this.privBufferedBytes));
                this.privBufferedBytes += result.buffer.byteLength;
            }
            return result;
        });
    }
    detach() {
        this.privBuffers = undefined;
        return this.privAudioNode.detach();
    }
    replay() {
        if (this.privBuffers && 0 !== this.privBuffers.length) {
            this.privReplay = true;
            this.privReplayOffset = this.privLastShrinkOffset;
        }
    }
    // Shrinks the existing audio buffers to start at the new offset, or at the
    // beginning of the buffer closest to the requested offset.
    // A replay request will start from the last shrink point.
    shrinkBuffers(offset) {
        if (this.privBuffers === undefined || this.privBuffers.length === 0) return;
        this.privLastShrinkOffset = offset;
        // Find the start point in the buffers.
        // Offsets are in 100ns increments.
        // So how many bytes do we need to seek to get the right offset?
        const offsetToSeek = offset - this.privBufferStartOffset;
        let bytesToSeek = Math.round(offsetToSeek * this.privBytesPerSecond * 1e-7);
        let i = 0;
        while(i < this.privBuffers.length && bytesToSeek >= this.privBuffers[i].chunk.buffer.byteLength)bytesToSeek -= this.privBuffers[i++].chunk.buffer.byteLength;
        this.privBufferStartOffset = Math.round(offset - bytesToSeek / this.privBytesPerSecond * 1e+7);
        this.privBuffers = this.privBuffers.slice(i);
    }
    // Finds the time a buffer of audio was first seen by offset.
    findTimeAtOffset(offset) {
        if (offset < this.privBufferStartOffset || this.privBuffers === undefined) return 0;
        for (const value of this.privBuffers){
            const startOffset = value.byteOffset / this.privBytesPerSecond * 1e7;
            const endOffset = startOffset + value.chunk.buffer.byteLength / this.privBytesPerSecond * 1e7;
            if (offset >= startOffset && offset <= endOffset) return value.chunk.timeReceived;
        }
        return 0;
    }
}
// Primary use of this class is to help debugging problems with the replay
// code. If the memory cost of alloc / dealloc gets too much, drop it and just use
// the ArrayBuffer directly.
// tslint:disable-next-line:max-classes-per-file
class $93bb35e5fb1ae57e$var$BufferEntry {
    constructor(chunk, serial, byteOffset){
        this.chunk = chunk;
        this.serial = serial;
        this.byteOffset = byteOffset;
    }
}

});

parcelRequire.register("2g5X6", function(module, exports) {

$parcel$export(module.exports, "ProxyInfo", () => $1a51b16509e93236$export$3199a3edab3bbf8);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.

var $jJjdG = parcelRequire("jJjdG");
class $1a51b16509e93236$export$3199a3edab3bbf8 {
    constructor(proxyHostName, proxyPort, proxyUserName, proxyPassword){
        this.privProxyHostName = proxyHostName;
        this.privProxyPort = proxyPort;
        this.privProxyUserName = proxyUserName;
        this.privProxyPassword = proxyPassword;
    }
    static fromParameters(parameters) {
        return new $1a51b16509e93236$export$3199a3edab3bbf8(parameters.getProperty((0, $jJjdG.PropertyId).SpeechServiceConnection_ProxyHostName), parseInt(parameters.getProperty((0, $jJjdG.PropertyId).SpeechServiceConnection_ProxyPort), 10), parameters.getProperty((0, $jJjdG.PropertyId).SpeechServiceConnection_ProxyUserName), parameters.getProperty((0, $jJjdG.PropertyId).SpeechServiceConnection_ProxyPassword));
    }
    static fromRecognizerConfig(config) {
        return this.fromParameters(config.parameters);
    }
    get HostName() {
        return this.privProxyHostName;
    }
    get Port() {
        return this.privProxyPort;
    }
    get UserName() {
        return this.privProxyUserName;
    }
    get Password() {
        return this.privProxyPassword;
    }
}

});

parcelRequire.register("8OSsj", function(module, exports) {

$parcel$export(module.exports, "RestRequestType", () => $66bd3bfc9dbf6782$export$7e4a254cc224227f);
$parcel$export(module.exports, "RestMessageAdapter", () => $66bd3bfc9dbf6782$export$9721ae21c2a3931a);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
parcelRequire("3KVS5");
var $4Cx0W = parcelRequire("4Cx0W");
var $9MSEb = parcelRequire("9MSEb");

var $gR5sk = parcelRequire("gR5sk");
var $66bd3bfc9dbf6782$export$7e4a254cc224227f;
(function(RestRequestType) {
    RestRequestType["Get"] = "get";
    RestRequestType["Post"] = "post";
    RestRequestType["Delete"] = "delete";
    RestRequestType["File"] = "file";
})($66bd3bfc9dbf6782$export$7e4a254cc224227f || ($66bd3bfc9dbf6782$export$7e4a254cc224227f = {}));
class $66bd3bfc9dbf6782$export$9721ae21c2a3931a {
    constructor(configParams, connectionId){
        if (!configParams) throw new (0, $4Cx0W.ArgumentNullError)("configParams");
        this.privHeaders = configParams.headers;
        this.privTimeout = configParams.timeout;
        this.privIgnoreCache = configParams.ignoreCache;
    }
    setHeaders(key, value) {
        this.privHeaders[key] = value;
    }
    request(method, uri, queryParams = {}, body = null, binaryBody = null) {
        const responseReceivedDeferral = new (0, $9MSEb.Deferred)();
        let xhr;
        if (typeof XMLHttpRequest === "undefined") xhr = new $gR5sk.XMLHttpRequest();
        else xhr = new XMLHttpRequest();
        const requestCommand = method === $66bd3bfc9dbf6782$export$7e4a254cc224227f.File ? "post" : method;
        xhr.open(requestCommand, this.withQuery(uri, queryParams), true);
        if (this.privHeaders) Object.keys(this.privHeaders).forEach((key)=>xhr.setRequestHeader(key, this.privHeaders[key]));
        if (this.privIgnoreCache) xhr.setRequestHeader("Cache-Control", "no-cache");
        xhr.timeout = this.privTimeout;
        xhr.onload = ()=>{
            responseReceivedDeferral.resolve(this.parseXHRResult(xhr));
        };
        xhr.onerror = ()=>{
            responseReceivedDeferral.resolve(this.errorResponse(xhr, "Failed to make request."));
        };
        xhr.ontimeout = ()=>{
            responseReceivedDeferral.resolve(this.errorResponse(xhr, "Request took longer than expected."));
        };
        if (method === $66bd3bfc9dbf6782$export$7e4a254cc224227f.File && binaryBody) {
            xhr.setRequestHeader("Content-Type", "multipart/form-data");
            xhr.send(binaryBody);
        } else if (method === $66bd3bfc9dbf6782$export$7e4a254cc224227f.Post && body) {
            xhr.setRequestHeader("Content-Type", "application/json");
            xhr.send(JSON.stringify(body));
        } else xhr.send();
        return responseReceivedDeferral.promise;
    }
    parseXHRResult(xhr) {
        return {
            data: xhr.responseText,
            headers: xhr.getAllResponseHeaders(),
            json: ()=>JSON.parse(xhr.responseText),
            ok: xhr.status >= 200 && xhr.status < 300,
            status: xhr.status,
            statusText: xhr.statusText
        };
    }
    errorResponse(xhr, message = null) {
        return {
            data: message || xhr.statusText,
            headers: xhr.getAllResponseHeaders(),
            json: ()=>JSON.parse(message || '"' + xhr.statusText + '"'),
            ok: false,
            status: xhr.status,
            statusText: xhr.statusText
        };
    }
    withQuery(url, params = {}) {
        const queryString = this.queryParams(params);
        return queryString ? url + (url.indexOf("?") === -1 ? "?" : "&") + queryString : url;
    }
    queryParams(params = {}) {
        return Object.keys(params).map((k)=>encodeURIComponent(k) + "=" + encodeURIComponent(params[k])).join("&");
    }
}

});

parcelRequire.register("bP1UF", function(module, exports) {

$parcel$export(module.exports, "RestConfigBase", () => $89b5f0fe246fd5fd$export$8d374502f37c0343);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
class $89b5f0fe246fd5fd$export$8d374502f37c0343 {
    static get requestOptions() {
        return $89b5f0fe246fd5fd$export$8d374502f37c0343.privDefaultRequestOptions;
    }
    static get configParams() {
        return $89b5f0fe246fd5fd$export$8d374502f37c0343.privDefaultParams;
    }
    static get restErrors() {
        return $89b5f0fe246fd5fd$export$8d374502f37c0343.privRestErrors;
    }
}
$89b5f0fe246fd5fd$export$8d374502f37c0343.privDefaultRequestOptions = {
    headers: {
        Accept: "application/json"
    },
    ignoreCache: false,
    timeout: 10000
};
$89b5f0fe246fd5fd$export$8d374502f37c0343.privRestErrors = {
    authInvalidSubscriptionKey: "You must specify either an authentication token to use, or a Cognitive Speech subscription key.",
    authInvalidSubscriptionRegion: "You must specify the Cognitive Speech region to use.",
    invalidArgs: "Required input not found: {arg}.",
    invalidCreateJoinConversationResponse: "Creating/Joining conversation failed with HTTP {status}.",
    invalidParticipantRequest: "The requested participant was not found.",
    permissionDeniedConnect: "Required credentials not found.",
    permissionDeniedConversation: "Invalid operation: only the host can {command} the conversation.",
    permissionDeniedParticipant: "Invalid operation: only the host can {command} a participant.",
    permissionDeniedSend: "Invalid operation: the conversation is not in a connected state.",
    permissionDeniedStart: "Invalid operation: there is already an active conversation."
};
$89b5f0fe246fd5fd$export$8d374502f37c0343.privDefaultParams = {
    apiVersion: "api-version",
    authorization: "Authorization",
    clientAppId: "X-ClientAppId",
    contentTypeKey: "Content-Type",
    correlationId: "X-CorrelationId",
    languageCode: "language",
    nickname: "nickname",
    profanity: "profanity",
    requestId: "X-RequestId",
    roomId: "roomid",
    sessionToken: "token",
    subscriptionKey: "Ocp-Apim-Subscription-Key",
    subscriptionRegion: "Ocp-Apim-Subscription-Region",
    token: "X-CapitoToken"
};

});


parcelRequire.register("4hIrn", function(module, exports) {

$parcel$export(module.exports, "AudioInputStream", () => $31eb38e9b7b08fe1$export$d2b41ea729bcd23a);
$parcel$export(module.exports, "PullAudioInputStreamImpl", () => $31eb38e9b7b08fe1$export$aa28c96dd85a430d);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
parcelRequire("g6k3z");
var $iWV5t = parcelRequire("iWV5t");
parcelRequire("3KVS5");
var $l9cUE = parcelRequire("l9cUE");
var $76ZQQ = parcelRequire("76ZQQ");
var $18oN3 = parcelRequire("18oN3");
var $btwY7 = parcelRequire("btwY7");

var $kSC7p = parcelRequire("kSC7p");

var $bFdRB = parcelRequire("bFdRB");

var $bFdRB = parcelRequire("bFdRB");

var $cBXue = parcelRequire("cBXue");
var $31eb38e9b7b08fe1$require$Buffer = $cBXue.Buffer;
var $31eb38e9b7b08fe1$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
class $31eb38e9b7b08fe1$export$d2b41ea729bcd23a {
    /**
     * Creates and initializes an instance.
     * @constructor
     */ constructor(){}
    /**
     * Creates a memory backed PushAudioInputStream with the specified audio format.
     * @member AudioInputStream.createPushStream
     * @function
     * @public
     * @param {AudioStreamFormat} format - The audio data format in which audio will be
     *        written to the push audio stream's write() method (Required if format is not 16 kHz 16bit mono PCM).
     * @returns {PushAudioInputStream} The audio input stream being created.
     */ static createPushStream(format) {
        return $31eb38e9b7b08fe1$export$c65274612fceab73.create(format);
    }
    /**
     * Creates a PullAudioInputStream that delegates to the specified callback interface for read()
     * and close() methods.
     * @member AudioInputStream.createPullStream
     * @function
     * @public
     * @param {PullAudioInputStreamCallback} callback - The custom audio input object, derived from
     *        PullAudioInputStreamCallback
     * @param {AudioStreamFormat} format - The audio data format in which audio will be returned from
     *        the callback's read() method (Required if format is not 16 kHz 16bit mono PCM).
     * @returns {PullAudioInputStream} The audio input stream being created.
     */ static createPullStream(callback, format) {
        return $31eb38e9b7b08fe1$export$2b6293045b3dda4e.create(callback, format);
    // throw new Error("Oops");
    }
}
class $31eb38e9b7b08fe1$export$c65274612fceab73 extends $31eb38e9b7b08fe1$export$d2b41ea729bcd23a {
    /**
     * Creates a memory backed PushAudioInputStream with the specified audio format.
     * @member PushAudioInputStream.create
     * @function
     * @public
     * @param {AudioStreamFormat} format - The audio data format in which audio will be written to the
     *        push audio stream's write() method (Required if format is not 16 kHz 16bit mono PCM).
     * @returns {PushAudioInputStream} The push audio input stream being created.
     */ static create(format) {
        return new $31eb38e9b7b08fe1$export$96d17a539b8936d6(format);
    }
}
class $31eb38e9b7b08fe1$export$96d17a539b8936d6 extends $31eb38e9b7b08fe1$export$c65274612fceab73 {
    /**
     * Creates and initalizes an instance with the given values.
     * @constructor
     * @param {AudioStreamFormat} format - The audio stream format.
     */ constructor(format){
        super();
        this.onEvent = (event)=>{
            this.privEvents.onEvent(event);
            (0, $l9cUE.Events).instance.onEvent(event);
        };
        if (format === undefined) this.privFormat = (0, $bFdRB.AudioStreamFormatImpl).getDefaultInputFormat();
        else this.privFormat = format;
        this.privEvents = new (0, $76ZQQ.EventSource)();
        this.privId = (0, $kSC7p.createNoDashGuid)();
        this.privStream = new (0, $18oN3.ChunkedArrayBufferStream)(this.privFormat.avgBytesPerSec / 10);
    }
    /**
     * Format information for the audio
     */ get format() {
        return Promise.resolve(this.privFormat);
    }
    /**
     * Writes the audio data specified by making an internal copy of the data.
     * @member PushAudioInputStreamImpl.prototype.write
     * @function
     * @public
     * @param {ArrayBuffer} dataBuffer - The audio buffer of which this function will make a copy.
     */ write(dataBuffer) {
        this.privStream.writeStreamChunk({
            buffer: dataBuffer,
            isEnd: false,
            timeReceived: Date.now()
        });
    }
    /**
     * Closes the stream.
     * @member PushAudioInputStreamImpl.prototype.close
     * @function
     * @public
     */ close() {
        this.privStream.close();
    }
    id() {
        return this.privId;
    }
    get blob() {
        return this.attach("id").then((audioNode)=>{
            const data = [];
            let bufferData = $31eb38e9b7b08fe1$require$Buffer.from("");
            const readCycle = ()=>{
                return audioNode.read().then((audioStreamChunk)=>{
                    if (!audioStreamChunk || audioStreamChunk.isEnd) {
                        if (typeof XMLHttpRequest !== "undefined" && typeof Blob !== "undefined") return Promise.resolve(new Blob(data));
                        else return Promise.resolve($31eb38e9b7b08fe1$require$Buffer.from(bufferData));
                    } else {
                        if (typeof Blob !== "undefined") data.push(audioStreamChunk.buffer);
                        else bufferData = $31eb38e9b7b08fe1$require$Buffer.concat([
                            bufferData,
                            this.toBuffer(audioStreamChunk.buffer)
                        ]);
                        return readCycle();
                    }
                });
            };
            return readCycle();
        });
    }
    turnOn() {
        this.onEvent(new (0, $btwY7.AudioSourceInitializingEvent)(this.privId)); // no stream id
        this.onEvent(new (0, $btwY7.AudioSourceReadyEvent)(this.privId));
        return;
    }
    attach(audioNodeId) {
        return $31eb38e9b7b08fe1$var$__awaiter(this, void 0, void 0, function*() {
            this.onEvent(new (0, $btwY7.AudioStreamNodeAttachingEvent)(this.privId, audioNodeId));
            yield this.turnOn();
            const stream = this.privStream;
            this.onEvent(new (0, $btwY7.AudioStreamNodeAttachedEvent)(this.privId, audioNodeId));
            return {
                detach: ()=>$31eb38e9b7b08fe1$var$__awaiter(this, void 0, void 0, function*() {
                        stream.readEnded();
                        this.onEvent(new (0, $btwY7.AudioStreamNodeDetachedEvent)(this.privId, audioNodeId));
                        return this.turnOff();
                    }),
                id: ()=>{
                    return audioNodeId;
                },
                read: ()=>{
                    return stream.read();
                }
            };
        });
    }
    detach(audioNodeId) {
        this.onEvent(new (0, $btwY7.AudioStreamNodeDetachedEvent)(this.privId, audioNodeId));
    }
    turnOff() {
        return;
    }
    get events() {
        return this.privEvents;
    }
    get deviceInfo() {
        return Promise.resolve({
            bitspersample: this.privFormat.bitsPerSample,
            channelcount: this.privFormat.channels,
            connectivity: (0, $iWV5t.connectivity).Unknown,
            manufacturer: "Speech SDK",
            model: "PushStream",
            samplerate: this.privFormat.samplesPerSec,
            type: (0, $iWV5t.type).Stream
        });
    }
    toBuffer(arrayBuffer) {
        const buf = $31eb38e9b7b08fe1$require$Buffer.alloc(arrayBuffer.byteLength);
        const view = new Uint8Array(arrayBuffer);
        for(let i = 0; i < buf.length; ++i)buf[i] = view[i];
        return buf;
    }
}
class $31eb38e9b7b08fe1$export$2b6293045b3dda4e extends $31eb38e9b7b08fe1$export$d2b41ea729bcd23a {
    /**
     * Creates and initializes and instance.
     * @constructor
     */ constructor(){
        super();
    }
    /**
     * Creates a PullAudioInputStream that delegates to the specified callback interface for
     * read() and close() methods, using the default format (16 kHz 16bit mono PCM).
     * @member PullAudioInputStream.create
     * @function
     * @public
     * @param {PullAudioInputStreamCallback} callback - The custom audio input object,
     *        derived from PullAudioInputStreamCustomCallback
     * @param {AudioStreamFormat} format - The audio data format in which audio will be
     *        returned from the callback's read() method (Required if format is not 16 kHz 16bit mono PCM).
     * @returns {PullAudioInputStream} The push audio input stream being created.
     */ static create(callback, format) {
        return new $31eb38e9b7b08fe1$export$aa28c96dd85a430d(callback, format);
    }
}
class $31eb38e9b7b08fe1$export$aa28c96dd85a430d extends $31eb38e9b7b08fe1$export$2b6293045b3dda4e {
    /**
     * Creates a PullAudioInputStream that delegates to the specified callback interface for
     * read() and close() methods, using the default format (16 kHz 16bit mono PCM).
     * @constructor
     * @param {PullAudioInputStreamCallback} callback - The custom audio input object,
     *        derived from PullAudioInputStreamCustomCallback
     * @param {AudioStreamFormat} format - The audio data format in which audio will be
     *        returned from the callback's read() method (Required if format is not 16 kHz 16bit mono PCM).
     */ constructor(callback, format){
        super();
        this.onEvent = (event)=>{
            this.privEvents.onEvent(event);
            (0, $l9cUE.Events).instance.onEvent(event);
        };
        if (undefined === format) this.privFormat = (0, $bFdRB.AudioStreamFormat).getDefaultInputFormat();
        else this.privFormat = format;
        this.privEvents = new (0, $76ZQQ.EventSource)();
        this.privId = (0, $kSC7p.createNoDashGuid)();
        this.privCallback = callback;
        this.privIsClosed = false;
        this.privBufferSize = this.privFormat.avgBytesPerSec / 10;
    }
    /**
     * Format information for the audio
     */ get format() {
        return Promise.resolve(this.privFormat);
    }
    /**
     * Closes the stream.
     * @member PullAudioInputStreamImpl.prototype.close
     * @function
     * @public
     */ close() {
        this.privIsClosed = true;
        this.privCallback.close();
    }
    id() {
        return this.privId;
    }
    get blob() {
        return Promise.reject("Not implemented");
    }
    turnOn() {
        this.onEvent(new (0, $btwY7.AudioSourceInitializingEvent)(this.privId)); // no stream id
        this.onEvent(new (0, $btwY7.AudioSourceReadyEvent)(this.privId));
        return;
    }
    attach(audioNodeId) {
        return $31eb38e9b7b08fe1$var$__awaiter(this, void 0, void 0, function*() {
            this.onEvent(new (0, $btwY7.AudioStreamNodeAttachingEvent)(this.privId, audioNodeId));
            yield this.turnOn();
            this.onEvent(new (0, $btwY7.AudioStreamNodeAttachedEvent)(this.privId, audioNodeId));
            return {
                detach: ()=>{
                    this.privCallback.close();
                    this.onEvent(new (0, $btwY7.AudioStreamNodeDetachedEvent)(this.privId, audioNodeId));
                    return this.turnOff();
                },
                id: ()=>{
                    return audioNodeId;
                },
                read: ()=>{
                    let totalBytes = 0;
                    let transmitBuff;
                    // Until we have the minimum number of bytes to send in a transmission, keep asking for more.
                    while(totalBytes < this.privBufferSize){
                        // Sizing the read buffer to the delta between the perfect size and what's left means we won't ever get too much
                        // data back.
                        const readBuff = new ArrayBuffer(this.privBufferSize - totalBytes);
                        const pulledBytes = this.privCallback.read(readBuff);
                        // If there is no return buffer yet defined, set the return buffer to the that was just populated.
                        // This was, if we have enough data there's no copy penalty, but if we don't we have a buffer that's the
                        // preferred size allocated.
                        if (undefined === transmitBuff) transmitBuff = readBuff;
                        else {
                            // Not the first bite at the apple, so fill the return buffer with the data we got back.
                            const intView = new Int8Array(transmitBuff);
                            intView.set(new Int8Array(readBuff), totalBytes);
                        }
                        // If there are no bytes to read, just break out and be done.
                        if (0 === pulledBytes) break;
                        totalBytes += pulledBytes;
                    }
                    return Promise.resolve({
                        buffer: transmitBuff.slice(0, totalBytes),
                        isEnd: this.privIsClosed || totalBytes === 0,
                        timeReceived: Date.now()
                    });
                }
            };
        });
    }
    detach(audioNodeId) {
        this.onEvent(new (0, $btwY7.AudioStreamNodeDetachedEvent)(this.privId, audioNodeId));
    }
    turnOff() {
        return;
    }
    get events() {
        return this.privEvents;
    }
    get deviceInfo() {
        return Promise.resolve({
            bitspersample: this.privFormat.bitsPerSample,
            channelcount: this.privFormat.channels,
            connectivity: (0, $iWV5t.connectivity).Unknown,
            manufacturer: "Speech SDK",
            model: "PullStream",
            samplerate: this.privFormat.samplesPerSec,
            type: (0, $iWV5t.type).Stream
        });
    }
}

});

parcelRequire.register("krC72", function(module, exports) {

$parcel$export(module.exports, "PullAudioInputStreamCallback", () => $ee23e49b06e7c46f$export$2d63425b32f9d538);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
/**
 * An abstract base class that defines callback methods (read() and close()) for
 * custom audio input streams).
 * @class PullAudioInputStreamCallback
 */ class $ee23e49b06e7c46f$export$2d63425b32f9d538 {
}

});

parcelRequire.register("hwoOI", function(module, exports) {

$parcel$export(module.exports, "PushAudioOutputStreamCallback", () => $cc18acfc6056bbbb$export$af7283ebc568ec10);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
/**
 * An abstract base class that defines callback methods (write() and close()) for
 * custom audio output streams).
 * @class PushAudioOutputStreamCallback
 */ class $cc18acfc6056bbbb$export$af7283ebc568ec10 {
}

});

parcelRequire.register("8fy4F", function(module, exports) {

$parcel$export(module.exports, "SpeakerAudioDestination", () => $601a27de3eec2a1d$export$c717373bdea3ec69);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
parcelRequire("g6k3z");
var $5e6W5 = parcelRequire("5e6W5");
parcelRequire("3KVS5");
var $kSC7p = parcelRequire("kSC7p");
var $l9cUE = parcelRequire("l9cUE");
var $6p3HD = parcelRequire("6p3HD");

var $eijUb = parcelRequire("eijUb");

var $bFdRB = parcelRequire("bFdRB");
var $601a27de3eec2a1d$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const $601a27de3eec2a1d$var$MediaDurationPlaceholderSeconds = 1800;
const $601a27de3eec2a1d$var$AudioFormatToMimeType = {
    [(0, $bFdRB.AudioFormatTag).PCM]: "audio/wav",
    [(0, $bFdRB.AudioFormatTag).MuLaw]: "audio/x-wav",
    [(0, $bFdRB.AudioFormatTag).MP3]: "audio/mpeg",
    [(0, $bFdRB.AudioFormatTag).OGG_OPUS]: "audio/ogg",
    [(0, $bFdRB.AudioFormatTag).WEBM_OPUS]: "audio/webm; codecs=opus",
    [(0, $bFdRB.AudioFormatTag).ALaw]: "audio/x-wav"
};
class $601a27de3eec2a1d$export$c717373bdea3ec69 {
    constructor(audioDestinationId){
        this.privPlaybackStarted = false;
        this.privAppendingToBuffer = false;
        this.privMediaSourceOpened = false;
        this.privBytesReceived = 0;
        this.privId = audioDestinationId ? audioDestinationId : (0, $kSC7p.createNoDashGuid)();
        this.privIsPaused = false;
        this.privIsClosed = false;
    }
    id() {
        return this.privId;
    }
    write(buffer, cb, err) {
        if (this.privAudioBuffer !== undefined) {
            this.privAudioBuffer.push(buffer);
            this.updateSourceBuffer().then(()=>{
                if (!!cb) cb();
            }, (error)=>{
                if (!!err) err(error);
            });
        } else if (this.privAudioOutputStream !== undefined) {
            this.privAudioOutputStream.write(buffer);
            this.privBytesReceived += buffer.byteLength;
        }
    }
    close(cb, err) {
        this.privIsClosed = true;
        if (this.privSourceBuffer !== undefined) this.handleSourceBufferUpdateEnd().then(()=>{
            if (!!cb) cb();
        }, (error)=>{
            if (!!err) err(error);
        });
        else if (this.privAudioOutputStream !== undefined) {
            if ((this.privFormat.formatTag === (0, $bFdRB.AudioFormatTag).PCM || this.privFormat.formatTag === (0, $bFdRB.AudioFormatTag).MuLaw || this.privFormat.formatTag === (0, $bFdRB.AudioFormatTag).ALaw) && this.privFormat.hasHeader === false) {
                // tslint:disable-next-line:no-console
                console.warn(`Play back is not supported for raw PCM, mulaw or alaw format without header.`);
                if (!!this.onAudioEnd) this.onAudioEnd(this);
            } else {
                let receivedAudio = new ArrayBuffer(this.privBytesReceived);
                this.privAudioOutputStream.read(receivedAudio).then((_)=>{
                    receivedAudio = (0, $5e6W5.SynthesisAdapterBase).addHeader(receivedAudio, this.privFormat);
                    const audioBlob = new Blob([
                        receivedAudio
                    ], {
                        type: $601a27de3eec2a1d$var$AudioFormatToMimeType[this.privFormat.formatTag]
                    });
                    this.privAudio.src = window.URL.createObjectURL(audioBlob);
                    this.notifyPlayback().then(()=>{
                        if (!!cb) cb();
                    }, (error)=>{
                        if (!!err) err(error);
                    });
                }, (error)=>{
                    if (!!err) err(error);
                });
            }
        } else // unsupported format, call onAudioEnd directly.
        if (!!this.onAudioEnd) this.onAudioEnd(this);
    }
    set format(format) {
        if (typeof AudioContext !== "undefined" || typeof window.webkitAudioContext !== "undefined") {
            this.privFormat = format;
            const mimeType = $601a27de3eec2a1d$var$AudioFormatToMimeType[this.privFormat.formatTag];
            if (mimeType === undefined) // tslint:disable-next-line:no-console
            console.warn(`Unknown mimeType for format ${(0, $bFdRB.AudioFormatTag)[this.privFormat.formatTag]}; playback is not supported.`);
            else if (typeof MediaSource !== "undefined" && MediaSource.isTypeSupported(mimeType)) {
                this.privAudio = new Audio();
                this.privAudioBuffer = [];
                this.privMediaSource = new MediaSource();
                this.privAudio.src = URL.createObjectURL(this.privMediaSource);
                this.privAudio.load();
                this.privMediaSource.onsourceopen = (event)=>{
                    this.privMediaSourceOpened = true;
                    this.privMediaSource.duration = $601a27de3eec2a1d$var$MediaDurationPlaceholderSeconds;
                    this.privSourceBuffer = this.privMediaSource.addSourceBuffer(mimeType);
                    this.privSourceBuffer.onupdate = (_)=>{
                        this.updateSourceBuffer().catch((reason)=>{
                            (0, $l9cUE.Events).instance.onEvent(new (0, $6p3HD.BackgroundEvent)(reason));
                        });
                    };
                    this.privSourceBuffer.onupdateend = (_)=>{
                        this.handleSourceBufferUpdateEnd().catch((reason)=>{
                            (0, $l9cUE.Events).instance.onEvent(new (0, $6p3HD.BackgroundEvent)(reason));
                        });
                    };
                    this.privSourceBuffer.onupdatestart = (_)=>{
                        this.privAppendingToBuffer = false;
                    };
                };
                this.updateSourceBuffer().catch((reason)=>{
                    (0, $l9cUE.Events).instance.onEvent(new (0, $6p3HD.BackgroundEvent)(reason));
                });
            } else {
                // tslint:disable-next-line:no-console
                console.warn(`Format ${(0, $bFdRB.AudioFormatTag)[this.privFormat.formatTag]} could not be played by MSE, streaming playback is not enabled.`);
                this.privAudioOutputStream = new (0, $eijUb.PullAudioOutputStreamImpl)();
                this.privAudioOutputStream.format = this.privFormat;
                this.privAudio = new Audio();
            }
        }
    }
    get isClosed() {
        return this.privIsClosed;
    }
    get currentTime() {
        if (this.privAudio !== undefined) return this.privAudio.currentTime;
        return -1;
    }
    pause() {
        if (!this.privIsPaused && this.privAudio !== undefined) {
            this.privAudio.pause();
            this.privIsPaused = true;
        }
    }
    resume(cb, err) {
        if (this.privIsPaused && this.privAudio !== undefined) {
            this.privAudio.play().then(()=>{
                if (!!cb) cb();
            }, (error)=>{
                if (!!err) err(error);
            });
            this.privIsPaused = false;
        }
    }
    get internalAudio() {
        return this.privAudio;
    }
    updateSourceBuffer() {
        return $601a27de3eec2a1d$var$__awaiter(this, void 0, void 0, function*() {
            if (this.privAudioBuffer !== undefined && this.privAudioBuffer.length > 0 && this.sourceBufferAvailable()) {
                this.privAppendingToBuffer = true;
                const binary = this.privAudioBuffer.shift();
                try {
                    this.privSourceBuffer.appendBuffer(binary);
                } catch (error) {
                    this.privAudioBuffer.unshift(binary);
                    // tslint:disable-next-line:no-console
                    console.log("buffer filled, pausing addition of binaries until space is made");
                    return;
                }
                yield this.notifyPlayback();
            } else if (this.canEndStream()) yield this.handleSourceBufferUpdateEnd();
        });
    }
    handleSourceBufferUpdateEnd() {
        return $601a27de3eec2a1d$var$__awaiter(this, void 0, void 0, function*() {
            if (this.canEndStream() && this.sourceBufferAvailable()) {
                this.privMediaSource.endOfStream();
                yield this.notifyPlayback();
            }
        });
    }
    notifyPlayback() {
        return $601a27de3eec2a1d$var$__awaiter(this, void 0, void 0, function*() {
            if (!this.privPlaybackStarted && this.privAudio !== undefined) {
                this.privPlaybackStarted = true;
                if (!!this.onAudioStart) this.onAudioStart(this);
                this.privAudio.onended = ()=>{
                    if (!!this.onAudioEnd) this.onAudioEnd(this);
                };
                if (!this.privIsPaused) yield this.privAudio.play();
            }
        });
    }
    canEndStream() {
        return this.isClosed && this.privSourceBuffer !== undefined && this.privAudioBuffer.length === 0 && this.privMediaSourceOpened && !this.privAppendingToBuffer && this.privMediaSource.readyState === "open";
    }
    sourceBufferAvailable() {
        return this.privSourceBuffer !== undefined && !this.privSourceBuffer.updating;
    }
}

});

parcelRequire.register("g7EHq", function(module, exports) {

$parcel$export(module.exports, "AudioFileWriter", () => $bbccdeda5cf8d736$export$b18256b0fa0aa326);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.

var $gR5sk = parcelRequire("gR5sk");

var $gSYyK = parcelRequire("gSYyK");
class $bbccdeda5cf8d736$export$b18256b0fa0aa326 {
    constructor(filename){
        this.id = ()=>{
            return this.privId;
        };
        (0, $gSYyK.Contracts).throwIfNullOrUndefined($gR5sk.openSync, "\nFile System access not available, please use Push or PullAudioOutputStream");
        this.privFd = $gR5sk.openSync(filename, "w");
    }
    set format(format) {
        (0, $gSYyK.Contracts).throwIfNotUndefined(this.privAudioFormat, "format is already set");
        this.privAudioFormat = format;
        let headerOffset = 0;
        if (this.privAudioFormat.hasHeader) headerOffset = this.privAudioFormat.header.byteLength;
        if (this.privFd !== undefined) this.privWriteStream = $gR5sk.createWriteStream("", {
            fd: this.privFd,
            start: headerOffset,
            autoClose: false
        });
    }
    write(buffer) {
        (0, $gSYyK.Contracts).throwIfNullOrUndefined(this.privAudioFormat, "must set format before writing.");
        if (this.privWriteStream !== undefined) this.privWriteStream.write(new Uint8Array(buffer.slice(0)));
    }
    close() {
        if (this.privFd !== undefined) {
            this.privWriteStream.on("finish", ()=>{
                if (this.privAudioFormat.hasHeader) {
                    this.privAudioFormat.updateHeader(this.privWriteStream.bytesWritten);
                    $gR5sk.writeSync(this.privFd, new Int8Array(this.privAudioFormat.header), 0, this.privAudioFormat.header.byteLength, 0);
                }
                $gR5sk.closeSync(this.privFd);
                this.privFd = undefined;
            });
            this.privWriteStream.end();
        }
    }
}

});


parcelRequire.register("1yh3Y", function(module, exports) {
"use strict";

var $luOtD = parcelRequire("luOtD");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $121633ca24f1cbdc$var$_regenerator = $luOtD((parcelRequire("dn7GQ")));

var $121633ca24f1cbdc$var$_slicedToArray2 = $luOtD((parcelRequire("fhBCP")));

var $121633ca24f1cbdc$var$_asyncToGenerator2 = $luOtD((parcelRequire("7F1D9")));

var $121633ca24f1cbdc$var$_classCallCheck2 = $luOtD((parcelRequire("hYNAh")));

var $121633ca24f1cbdc$var$_createClass2 = $luOtD((parcelRequire("8Eu5W")));

var $121633ca24f1cbdc$var$_assertThisInitialized2 = $luOtD((parcelRequire("LgN0b")));

var $121633ca24f1cbdc$var$_inherits2 = $luOtD((parcelRequire("lCAS6")));

var $121633ca24f1cbdc$var$_possibleConstructorReturn2 = $luOtD((parcelRequire("l6X0V")));

var $121633ca24f1cbdc$var$_getPrototypeOf2 = $luOtD((parcelRequire("f0Kuj")));

var $121633ca24f1cbdc$var$_defineProperty2 = $luOtD((parcelRequire("3w8Sv")));

var $4hIrn = parcelRequire("4hIrn");

var $7srwU = parcelRequire("7srwU");

var $7PHxc = parcelRequire("7PHxc");

var $9MAMI = parcelRequire("9MAMI");

var $cG9B9 = parcelRequire("cG9B9");

var $4HXeJ = parcelRequire("4HXeJ");

var $121633ca24f1cbdc$var$_pDeferEs = $luOtD((parcelRequire("5la41")));
function $121633ca24f1cbdc$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $121633ca24f1cbdc$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, $121633ca24f1cbdc$var$_getPrototypeOf2.default)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $121633ca24f1cbdc$var$_getPrototypeOf2.default)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $121633ca24f1cbdc$var$_possibleConstructorReturn2.default)(this, result);
    };
}
function $121633ca24f1cbdc$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
var $121633ca24f1cbdc$var$SYMBOL_DEVICE_INFO_DEFERRED = Symbol("deviceInfoDeferred");
var $121633ca24f1cbdc$var$SYMBOL_EVENTS = Symbol("events");
var $121633ca24f1cbdc$var$SYMBOL_FORMAT_DEFERRED = Symbol("formatDeferred");
var $121633ca24f1cbdc$var$SYMBOL_OPTIONS = Symbol("options"); // Speech SDK quirks: Only 2 lifecycle functions are actually used.
//                    They are: attach() and turnOff().
//                    Others are not used, including: blob(), close(), detach(), turnOn().
var $121633ca24f1cbdc$var$CustomAudioInputStream = /*#__PURE__*/ function(_AudioInputStream) {
    (0, $121633ca24f1cbdc$var$_inherits2.default)(CustomAudioInputStream, _AudioInputStream);
    var _super = $121633ca24f1cbdc$var$_createSuper(CustomAudioInputStream);
    function CustomAudioInputStream() {
        var _this;
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        (0, $121633ca24f1cbdc$var$_classCallCheck2.default)(this, CustomAudioInputStream);
        _this = _super.call(this);
        (0, $121633ca24f1cbdc$var$_defineProperty2.default)((0, $121633ca24f1cbdc$var$_assertThisInitialized2.default)(_this), $121633ca24f1cbdc$var$SYMBOL_DEVICE_INFO_DEFERRED, void 0);
        (0, $121633ca24f1cbdc$var$_defineProperty2.default)((0, $121633ca24f1cbdc$var$_assertThisInitialized2.default)(_this), $121633ca24f1cbdc$var$SYMBOL_EVENTS, void 0);
        (0, $121633ca24f1cbdc$var$_defineProperty2.default)((0, $121633ca24f1cbdc$var$_assertThisInitialized2.default)(_this), $121633ca24f1cbdc$var$SYMBOL_FORMAT_DEFERRED, void 0);
        (0, $121633ca24f1cbdc$var$_defineProperty2.default)((0, $121633ca24f1cbdc$var$_assertThisInitialized2.default)(_this), $121633ca24f1cbdc$var$SYMBOL_OPTIONS, void 0);
        var normalizedOptions = {
            debug: options.debug || false,
            id: options.id || (0, $4HXeJ.default)().replace(/\x2D/g, "")
        }; // False alarm: indexer is a constant of type Symbol.
        // eslint-disable-next-line security/detect-object-injection
        _this[$121633ca24f1cbdc$var$SYMBOL_DEVICE_INFO_DEFERRED] = (0, $121633ca24f1cbdc$var$_pDeferEs.default)(); // False alarm: indexer is a constant of type Symbol.
        // eslint-disable-next-line security/detect-object-injection
        _this[$121633ca24f1cbdc$var$SYMBOL_EVENTS] = new $7srwU.EventSource(); // False alarm: indexer is a constant of type Symbol.
        // eslint-disable-next-line security/detect-object-injection
        _this[$121633ca24f1cbdc$var$SYMBOL_FORMAT_DEFERRED] = (0, $121633ca24f1cbdc$var$_pDeferEs.default)(); // False alarm: indexer is a constant of type Symbol.
        // eslint-disable-next-line security/detect-object-injection
        _this[$121633ca24f1cbdc$var$SYMBOL_OPTIONS] = normalizedOptions;
        return _this;
    }
    (0, $121633ca24f1cbdc$var$_createClass2.default)(CustomAudioInputStream, [
        {
            key: "events",
            get: /** Gets the event source for listening to events. */ // ESLint: This code will only works in browsers other than IE11. Only works in ES5 is okay.
            // @ts-ignore Accessors are only available when targeting ECMAScript 5 and higher.ts(1056)
            function get() {
                // False alarm: indexer is a constant of type Symbol.
                // eslint-disable-next-line security/detect-object-injection
                return this[$121633ca24f1cbdc$var$SYMBOL_EVENTS];
            }
        },
        {
            key: "format",
            get: function get() {
                this.debug('Getting "format".'); // False alarm: indexer is a constant of type Symbol.
                // eslint-disable-next-line security/detect-object-injection
                return this[$121633ca24f1cbdc$var$SYMBOL_FORMAT_DEFERRED].promise;
            }
        },
        {
            key: "id",
            value: function id() {
                // False alarm: indexer is a constant of type Symbol.
                // eslint-disable-next-line security/detect-object-injection
                return this[$121633ca24f1cbdc$var$SYMBOL_OPTIONS].id;
            }
        },
        {
            key: "onEvent",
            value: function onEvent(event) {
                // False alarm: indexer is a constant of type Symbol.
                // eslint-disable-next-line security/detect-object-injection
                this[$121633ca24f1cbdc$var$SYMBOL_EVENTS].onEvent(event);
                $7srwU.Events.instance.onEvent(event);
            }
        },
        {
            key: "emitInitializing",
            value: function emitInitializing() {
                this.debug('Emitting "AudioSourceInitializingEvent".');
                this.onEvent(new $7srwU.AudioSourceInitializingEvent(this.id()));
            }
        },
        {
            key: "emitReady",
            value: function emitReady() {
                this.debug('Emitting "AudioSourceReadyEvent".');
                this.onEvent(new $7srwU.AudioSourceReadyEvent(this.id()));
            }
        },
        {
            key: "emitError",
            value: function emitError(error) {
                this.debug('Emitting "AudioSourceErrorEvent".', {
                    error: error
                }); // Speech SDK quirks: "error" is a string, instead of object of type "Error".
                this.onEvent(new $7srwU.AudioSourceErrorEvent(this.id(), error.message));
            }
        },
        {
            key: "emitNodeAttaching",
            value: function emitNodeAttaching(audioNodeId) {
                this.debug('Emitting "AudioStreamNodeAttachingEvent" for node "'.concat(audioNodeId, '".'));
                this.onEvent(new $7srwU.AudioStreamNodeAttachingEvent(this.id(), audioNodeId));
            }
        },
        {
            key: "emitNodeAttached",
            value: function emitNodeAttached(audioNodeId) {
                this.debug('Emitting "AudioStreamNodeAttachedEvent" for node "'.concat(audioNodeId, '".'));
                this.onEvent(new $7srwU.AudioStreamNodeAttachedEvent(this.id(), audioNodeId));
            }
        },
        {
            key: "emitNodeError",
            value: function emitNodeError(audioNodeId, error) {
                this.debug('Emitting "AudioStreamNodeErrorEvent" for node "'.concat(audioNodeId, '".'), {
                    error: error
                }); // Speech SDK quirks: "error" is a string, instead of object of type "Error".
                this.onEvent(new $7srwU.AudioStreamNodeErrorEvent(this.id(), audioNodeId, error.message));
            }
        },
        {
            key: "emitNodeDetached",
            value: function emitNodeDetached(audioNodeId) {
                this.debug('Emitting "AudioStreamNodeDetachedEvent".');
                this.onEvent(new $7srwU.AudioStreamNodeDetachedEvent(this.id(), audioNodeId));
            }
        },
        {
            key: "emitOff",
            value: function emitOff() {
                this.debug('Emitting "AudioSourceOffEvent".');
                this.onEvent(new $7srwU.AudioSourceOffEvent(this.id()));
            } // Speech SDK quirks: Although "close" is marked as abstract, it is never called in our observations.
        },
        {
            key: "close",
            value: function close() {
                this.debug('Callback for "close".');
                throw new Error("Not implemented");
            } // Speech SDK quirks: Although "turnOn" is implemented in Speech SDK Push/PullAudioInputStream, it is never called in our observations.
        },
        {
            key: "turnOn",
            value: function turnOn() {
                this.debug('Callback for "turnOn".');
                throw new Error("Not implemented");
            } // Speech SDK quirks: Although "detach" is implemented in Speech SDK Push/PullAudioInputStream, it is never called in our observations.
        },
        {
            key: "detach",
            value: function detach() {
                this.debug('Callback for "detach".');
                throw new Error("Not implemented");
            }
        },
        {
            key: "debug",
            value: function debug(message) {
                var _console;
                for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
                // ESLint: For debugging, will only log when "debug" is set to "true".
                // False alarm: indexer is a constant of type Symbol.
                // eslint-disable-next-line no-console, security/detect-object-injection
                this[$121633ca24f1cbdc$var$SYMBOL_OPTIONS].debug && (_console = console).info.apply(_console, [
                    "CustomAudioInputStream: ".concat(message)
                ].concat(args));
            }
        },
        {
            key: "attach",
            value: /** Attaches the device by returning an audio node. */ function attach(audioNodeId) {
                var _this2 = this;
                this.debug('Callback for "attach" with "'.concat(audioNodeId, '".'));
                this.emitNodeAttaching(audioNodeId);
                return Promise.resolve().then(/*#__PURE__*/ (0, $121633ca24f1cbdc$var$_asyncToGenerator2.default)(/*#__PURE__*/ $121633ca24f1cbdc$var$_regenerator.default.mark(function _callee2() {
                    var _yield$_this2$perform, audioStreamNode, deviceInfo, format;
                    return $121633ca24f1cbdc$var$_regenerator.default.wrap(function _callee2$(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                _this2.emitInitializing();
                                _context2.prev = 1;
                                _context2.next = 4;
                                return _this2.performAttach(audioNodeId);
                            case 4:
                                _yield$_this2$perform = _context2.sent;
                                audioStreamNode = _yield$_this2$perform.audioStreamNode;
                                deviceInfo = _yield$_this2$perform.deviceInfo;
                                format = _yield$_this2$perform.format;
                                // Although only getter of "format" is called before "attach" (in Direct Line Speech),
                                // we are handling both "deviceInfo" and "format" in similar way for uniformity.
                                // False alarm: indexer is a constant of type Symbol.
                                // eslint-disable-next-line security/detect-object-injection
                                _this2[$121633ca24f1cbdc$var$SYMBOL_DEVICE_INFO_DEFERRED].resolve(deviceInfo); // False alarm: indexer is a constant of type Symbol.
                                // eslint-disable-next-line security/detect-object-injection
                                _this2[$121633ca24f1cbdc$var$SYMBOL_FORMAT_DEFERRED].resolve(new $7PHxc.AudioStreamFormatImpl(format.samplesPerSec, format.bitsPerSample, format.channels));
                                _this2.emitReady();
                                _this2.emitNodeAttached(audioNodeId);
                                return _context2.abrupt("return", {
                                    detach: function() {
                                        var _detach = (0, $121633ca24f1cbdc$var$_asyncToGenerator2.default)(/*#__PURE__*/ $121633ca24f1cbdc$var$_regenerator.default.mark(function _callee() {
                                            return $121633ca24f1cbdc$var$_regenerator.default.wrap(function _callee$(_context) {
                                                while(true)switch(_context.prev = _context.next){
                                                    case 0:
                                                        _this2.debug('Detaching audio node "'.concat(audioNodeId, '".'));
                                                        _context.next = 3;
                                                        return audioStreamNode.detach();
                                                    case 3:
                                                        // Speech SDK quirks: Since "turnOff" is not called in Direct Line Speech, we will emit event "source off" here instead.
                                                        _this2.emitOff();
                                                        _this2.emitNodeDetached(audioNodeId);
                                                    case 5:
                                                    case "end":
                                                        return _context.stop();
                                                }
                                            }, _callee);
                                        }));
                                        function detach() {
                                            return _detach.apply(this, arguments);
                                        }
                                        return detach;
                                    }(),
                                    id: function id() {
                                        return audioStreamNode.id();
                                    },
                                    read: function read() {
                                        _this2.debug("Reading");
                                        return audioStreamNode.read();
                                    }
                                });
                            case 15:
                                _context2.prev = 15;
                                _context2.t0 = _context2["catch"](1);
                                _this2.emitNodeError(audioNodeId, _context2.t0);
                                throw _context2.t0;
                            case 19:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, null, [
                        [
                            1,
                            15
                        ]
                    ]);
                })));
            }
        },
        {
            key: "performTurnOff",
            value: function performTurnOff() {
                // ESLint: "return" is required by TypeScript
                // eslint-disable-next-line no-useless-return
                return;
            }
        },
        {
            key: "turnOff",
            value: function() {
                var _turnOff = (0, $121633ca24f1cbdc$var$_asyncToGenerator2.default)(/*#__PURE__*/ $121633ca24f1cbdc$var$_regenerator.default.mark(function _callee3() {
                    return $121633ca24f1cbdc$var$_regenerator.default.wrap(function _callee3$(_context3) {
                        while(true)switch(_context3.prev = _context3.next){
                            case 0:
                                this.debug('Callback for "turnOff".');
                                _context3.next = 3;
                                return this.performTurnOff();
                            case 3:
                            case "end":
                                return _context3.stop();
                        }
                    }, _callee3, this);
                }));
                function turnOff() {
                    return _turnOff.apply(this, arguments);
                }
                return turnOff;
            }()
        },
        {
            key: "deviceInfo",
            get: function get() {
                this.debug('Getting "deviceInfo".'); // False alarm: indexer is a constant of type Symbol.
                // eslint-disable-next-line security/detect-object-injection
                return Promise.all([
                    this[$121633ca24f1cbdc$var$SYMBOL_DEVICE_INFO_DEFERRED].promise,
                    this[$121633ca24f1cbdc$var$SYMBOL_FORMAT_DEFERRED].promise
                ]).then(function(_ref2) {
                    var _ref3 = (0, $121633ca24f1cbdc$var$_slicedToArray2.default)(_ref2, 2), _ref3$ = _ref3[0], connectivity = _ref3$.connectivity, manufacturer = _ref3$.manufacturer, model = _ref3$.model, type = _ref3$.type, _ref3$2 = _ref3[1], bitsPerSample = _ref3$2.bitsPerSample, channels = _ref3$2.channels, samplesPerSec = _ref3$2.samplesPerSec;
                    return {
                        bitspersample: bitsPerSample,
                        channelcount: channels,
                        connectivity: typeof connectivity === "string" && !(0, $cG9B9.isForbiddenPropertyName)(connectivity) ? // eslint-disable-next-line security/detect-object-injection
                        $9MAMI.connectivity[connectivity] : connectivity || $9MAMI.connectivity.Unknown,
                        manufacturer: manufacturer || "",
                        model: model || "",
                        samplerate: samplesPerSec,
                        // Mitigated through denylisting.
                        // eslint-disable-next-line security/detect-object-injection
                        type: typeof type === "string" && !(0, $cG9B9.isForbiddenPropertyName)(type) ? $9MAMI.type[type] : type || $9MAMI.type.Unknown
                    };
                });
            }
        }
    ]);
    return CustomAudioInputStream;
}($4hIrn.AudioInputStream);
var $121633ca24f1cbdc$var$_default = $121633ca24f1cbdc$var$CustomAudioInputStream;
module.exports.default = $121633ca24f1cbdc$var$_default;

});
parcelRequire.register("4HXeJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $36d920bc2826fb70$export$2e2bcd8739ae039);

var $3aawC = parcelRequire("3aawC");

var $1xL24 = parcelRequire("1xL24");
function $36d920bc2826fb70$var$v4(options, buf, offset) {
    options = options || {};
    var rnds = options.random || (options.rng || (0, $3aawC.default))(); // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80; // Copy bytes to buffer, if provided
    if (buf) {
        offset = offset || 0;
        for(var i = 0; i < 16; ++i)buf[offset + i] = rnds[i];
        return buf;
    }
    return (0, $1xL24.default)(rnds);
}
var $36d920bc2826fb70$export$2e2bcd8739ae039 = $36d920bc2826fb70$var$v4;

});
parcelRequire.register("3aawC", function(module, exports) {

$parcel$export(module.exports, "default", () => $24da785088de6b48$export$2e2bcd8739ae039);
// Unique ID creation requires a high quality random # generator. In the browser we therefore
// require the crypto API and do not support built-in fallback to lower quality random number
// generators (like Math.random()).
var $24da785088de6b48$var$getRandomValues;
var $24da785088de6b48$var$rnds8 = new Uint8Array(16);
function $24da785088de6b48$export$2e2bcd8739ae039() {
    // lazy load so that environments that need to polyfill have a chance to do so
    if (!$24da785088de6b48$var$getRandomValues) {
        // getRandomValues needs to be invoked in a context where "this" is a Crypto implementation. Also,
        // find the complete implementation of crypto (msCrypto) on IE11.
        $24da785088de6b48$var$getRandomValues = typeof crypto !== "undefined" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto !== "undefined" && typeof msCrypto.getRandomValues === "function" && msCrypto.getRandomValues.bind(msCrypto);
        if (!$24da785088de6b48$var$getRandomValues) throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
    }
    return $24da785088de6b48$var$getRandomValues($24da785088de6b48$var$rnds8);
}

});

parcelRequire.register("1xL24", function(module, exports) {

$parcel$export(module.exports, "default", () => $11fd5b2af37aa837$export$2e2bcd8739ae039);

var $ltW5h = parcelRequire("ltW5h");
/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */ var $11fd5b2af37aa837$var$byteToHex = [];
for(var $11fd5b2af37aa837$var$i = 0; $11fd5b2af37aa837$var$i < 256; ++$11fd5b2af37aa837$var$i)$11fd5b2af37aa837$var$byteToHex.push(($11fd5b2af37aa837$var$i + 0x100).toString(16).substr(1));
function $11fd5b2af37aa837$var$stringify(arr) {
    var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    // Note: Be careful editing this code!  It's been tuned for performance
    // and works in ways you may not expect. See https://github.com/uuidjs/uuid/pull/434
    var uuid = ($11fd5b2af37aa837$var$byteToHex[arr[offset + 0]] + $11fd5b2af37aa837$var$byteToHex[arr[offset + 1]] + $11fd5b2af37aa837$var$byteToHex[arr[offset + 2]] + $11fd5b2af37aa837$var$byteToHex[arr[offset + 3]] + "-" + $11fd5b2af37aa837$var$byteToHex[arr[offset + 4]] + $11fd5b2af37aa837$var$byteToHex[arr[offset + 5]] + "-" + $11fd5b2af37aa837$var$byteToHex[arr[offset + 6]] + $11fd5b2af37aa837$var$byteToHex[arr[offset + 7]] + "-" + $11fd5b2af37aa837$var$byteToHex[arr[offset + 8]] + $11fd5b2af37aa837$var$byteToHex[arr[offset + 9]] + "-" + $11fd5b2af37aa837$var$byteToHex[arr[offset + 10]] + $11fd5b2af37aa837$var$byteToHex[arr[offset + 11]] + $11fd5b2af37aa837$var$byteToHex[arr[offset + 12]] + $11fd5b2af37aa837$var$byteToHex[arr[offset + 13]] + $11fd5b2af37aa837$var$byteToHex[arr[offset + 14]] + $11fd5b2af37aa837$var$byteToHex[arr[offset + 15]]).toLowerCase(); // Consistency check for valid UUID.  If this throws, it's likely due to one
    // of the following:
    // - One or more input array values don't map to a hex octet (leading to
    // "undefined" in the uuid)
    // - Invalid input values for the RFC `version` or `variant` fields
    if (!(0, $ltW5h.default)(uuid)) throw TypeError("Stringified UUID is invalid");
    return uuid;
}
var $11fd5b2af37aa837$export$2e2bcd8739ae039 = $11fd5b2af37aa837$var$stringify;

});
parcelRequire.register("ltW5h", function(module, exports) {

$parcel$export(module.exports, "default", () => $fa395cbc334b61e3$export$2e2bcd8739ae039);

var $aycJm = parcelRequire("aycJm");
function $fa395cbc334b61e3$var$validate(uuid) {
    return typeof uuid === "string" && (0, $aycJm.default).test(uuid);
}
var $fa395cbc334b61e3$export$2e2bcd8739ae039 = $fa395cbc334b61e3$var$validate;

});
parcelRequire.register("aycJm", function(module, exports) {

$parcel$export(module.exports, "default", () => $7ae6f46aa006bf5d$export$2e2bcd8739ae039);
var $7ae6f46aa006bf5d$export$2e2bcd8739ae039 = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;

});






parcelRequire.register("58U4K", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $3be9328a94a65a34$var$createAudioContext;
/** Creates an AudioContext object. */ function $3be9328a94a65a34$var$createAudioContext() {
    if (typeof window.AudioContext !== "undefined") return new window.AudioContext(); // Required by TypeScript.
    else if (typeof window["webkitAudioContext"] !== "undefined") // This is for Safari as Web Audio API is still under vendor-prefixed.
    // eslint-disable-next-line dot-notation
    return new window["webkitAudioContext"]();
     // TODO: Fix this.
    throw new Error("This browser does not support Web Audio API.");
}

});

parcelRequire.register("4J6xC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $3710705652db73b2$var$getUserMedia;
function $3710705652db73b2$var$getUserMedia(constraints) {
    var _window = window, navigator = _window.navigator;
    if (typeof navigator.mediaDevices !== "undefined") return navigator.mediaDevices.getUserMedia(constraints);
     // We are intentionally using the deprecated `navigator.getUserMedia` to make sure backward compatibility.
    // @ts-ignore
    if (typeof navigator.getUserMedia !== "undefined") // We are intentionally using the deprecated `navigator.getUserMedia` to make sure backward compatibility.
    // @ts-ignore
    return new Promise(function(resolve, reject) {
        return navigator.getUserMedia(constraints, resolve, reject);
    });
    throw new Error("This browser does not support Web Audio API.");
}

});



parcelRequire.register("MZIq5", function(module, exports) {
"use strict";

var $luOtD = parcelRequire("luOtD");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $09345b361f9fabe0$var$createDirectLineSpeechAdapters;

var $d4wHE = parcelRequire("d4wHE");

var $09345b361f9fabe0$var$_createMicrophoneAudioConfigAndAudioContext = $luOtD((parcelRequire("iKa9Q")));
var $09345b361f9fabe0$var$DEFAULT_LANGUAGE = "en-US"; // TODO: When using DLSpeech via bundle, we will add our own MicrophoneAudioConfig.
function $09345b361f9fabe0$var$createDirectLineSpeechAdapters(_ref) {
    var _window, _window$navigator;
    var audioConfig = _ref.audioConfig, audioContext = _ref.audioContext, audioInputDeviceId = _ref.audioInputDeviceId, enableInternalHTTPSupport = _ref.enableInternalHTTPSupport, enableTelemetry = _ref.enableTelemetry, fetchCredentials = _ref.fetchCredentials, speechRecognitionEndpointId = _ref.speechRecognitionEndpointId, _ref$speechRecognitio = _ref.speechRecognitionLanguage, speechRecognitionLanguage = _ref$speechRecognitio === void 0 ? ((_window = window) === null || _window === void 0 ? void 0 : (_window$navigator = _window.navigator) === null || _window$navigator === void 0 ? void 0 : _window$navigator.language) || $09345b361f9fabe0$var$DEFAULT_LANGUAGE : _ref$speechRecognitio, speechSynthesisDeploymentId = _ref.speechSynthesisDeploymentId, speechSynthesisOutputFormat = _ref.speechSynthesisOutputFormat, textNormalization = _ref.textNormalization, userID = _ref.userID, username = _ref.username;
    if (audioConfig) {
        audioInputDeviceId && console.warn('botframework-webchat: "audioConfig" and "audioInputDeviceId" cannot be set at the same time; ignoring "audioInputDeviceId".');
        audioContext && console.warn('botframework-webchat: "audioConfig" and "audioContext" cannot be set at the same time; ignoring "audioContext" for speech recognition.');
    } else if (!window.navigator.mediaDevices) // If the browser does not support or allow microphone access, we will continue to create Direct Line Speech adapter without custom "audioConfig" and "audioContext".
    // In Direct Line Speech SDK, it will disable speech functionality, only leaving text chat available via the protocol.
    console.warn('botframework-webchat: Your browser does not support or allow microphone access or the page is not loaded via HTTPS or localhost. Speech is disabled for Direct Line Speech. However, you may pass a custom "audioConfig" to enable speech in this environment.');
    else {
        var _createMicrophoneAudi = (0, $09345b361f9fabe0$var$_createMicrophoneAudioConfigAndAudioContext.default)({
            audioContext: audioContext,
            audioInputDeviceId: audioInputDeviceId,
            enableTelemetry: enableTelemetry
        });
        audioConfig = _createMicrophoneAudi.audioConfig;
        audioContext = _createMicrophoneAudi.audioContext;
    }
    return (0, $d4wHE.createAdapters)({
        audioConfig: audioConfig,
        audioContext: audioContext,
        enableInternalHTTPSupport: enableInternalHTTPSupport,
        enableTelemetry: enableTelemetry,
        fetchCredentials: fetchCredentials,
        speechRecognitionEndpointId: speechRecognitionEndpointId,
        speechRecognitionLanguage: speechRecognitionLanguage,
        speechSynthesisDeploymentId: speechSynthesisDeploymentId,
        speechSynthesisOutputFormat: speechSynthesisOutputFormat,
        textNormalization: textNormalization,
        userID: userID,
        username: username
    });
}

});
parcelRequire.register("d4wHE", function(module, exports) {
"use strict";

var $cP3px = parcelRequire("cP3px");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "createAdapters", {
    enumerable: true,
    get: function get() {
        return $98450435d341207b$var$_createAdapters.default;
    }
});
parcelRequire("7WYsV");

var $98450435d341207b$var$_createAdapters = $cP3px((parcelRequire("hYyeZ")));
if (typeof HTMLDocument !== "undefined" && typeof document !== "undefined" && document instanceof HTMLDocument) {
    var $98450435d341207b$var$meta = document.createElement("meta");
    $98450435d341207b$var$meta.setAttribute("name", "botframework-directlinespeech:version"); // We injected "process.env.npm_package_version" during compilation.
    // eslint-disable-next-line no-undef
    $98450435d341207b$var$meta.setAttribute("content", "4.15.8");
    document.head.appendChild($98450435d341207b$var$meta);
}

});
parcelRequire.register("cP3px", function(module, exports) {
function $955ce4c64c32d5b0$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
module.exports = $955ce4c64c32d5b0$var$_interopRequireDefault, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRequire.register("7WYsV", function(module, exports) {

module.exports = (parcelRequire("63md0"));

});
parcelRequire.register("63md0", function(module, exports) {

var $jjTLM = parcelRequire("jjTLM");
module.exports = $jjTLM;

});
parcelRequire.register("jjTLM", function(module, exports) {

var $8xG3o = parcelRequire("8xG3o");
module.exports = $8xG3o;

});
parcelRequire.register("8xG3o", function(module, exports) {

var $eKlUb = parcelRequire("eKlUb");
module.exports = $eKlUb;

});
parcelRequire.register("eKlUb", function(module, exports) {
parcelRequire("iRD2L");

var $9LfIn = parcelRequire("9LfIn");
module.exports = $9LfIn.Object.entries;

});
parcelRequire.register("iRD2L", function(module, exports) {

var $cliN7 = parcelRequire("cliN7");

var $8iVJA = parcelRequire("8iVJA");
var $dbbb7673e43dd0c8$require$$entries = $8iVJA.entries;
// `Object.entries` method
// https://tc39.es/ecma262/#sec-object.entries
$cliN7({
    target: "Object",
    stat: true
}, {
    entries: function entries(O) {
        return $dbbb7673e43dd0c8$require$$entries(O);
    }
});

});
parcelRequire.register("cliN7", function(module, exports) {

var $7nYI8 = parcelRequire("7nYI8");

var $7HSVt = parcelRequire("7HSVt");
var $8fc605bce798e469$require$getOwnPropertyDescriptor = $7HSVt.f;

var $kBgag = parcelRequire("kBgag");

var $02JSJ = parcelRequire("02JSJ");

var $aE4sm = parcelRequire("aE4sm");

var $cutjL = parcelRequire("cutjL");

var $k5zO5 = parcelRequire("k5zO5");
/*
  options.target         - name of the target object
  options.global         - target is the global object
  options.stat           - export as static methods of target
  options.proto          - export as prototype methods of target
  options.real           - real prototype method for the `pure` version
  options.forced         - export even if the native feature is available
  options.bind           - bind methods to the target, required for the `pure` version
  options.wrap           - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe         - use the simple assignment of property instead of delete + defineProperty
  options.sham           - add a flag to not completely full polyfills
  options.enumerable     - export as enumerable property
  options.dontCallGetSet - prevent calling a getter on target
  options.name           - the .name of the function if it does not match the key
*/ module.exports = function(options, source) {
    var TARGET = options.target;
    var GLOBAL = options.global;
    var STATIC = options.stat;
    var FORCED, target, key, targetProperty, sourceProperty, descriptor;
    if (GLOBAL) target = $7nYI8;
    else if (STATIC) target = $7nYI8[TARGET] || $aE4sm(TARGET, {});
    else target = ($7nYI8[TARGET] || {}).prototype;
    if (target) for(key in source){
        sourceProperty = source[key];
        if (options.dontCallGetSet) {
            descriptor = $8fc605bce798e469$require$getOwnPropertyDescriptor(target, key);
            targetProperty = descriptor && descriptor.value;
        } else targetProperty = target[key];
        FORCED = $k5zO5(GLOBAL ? key : TARGET + (STATIC ? "." : "#") + key, options.forced);
        // contained in target
        if (!FORCED && targetProperty !== undefined) {
            if (typeof sourceProperty == typeof targetProperty) continue;
            $cutjL(sourceProperty, targetProperty);
        }
        // add a flag to not completely full polyfills
        if (options.sham || targetProperty && targetProperty.sham) $kBgag(sourceProperty, "sham", true);
        $02JSJ(target, key, sourceProperty, options);
    }
};

});
parcelRequire.register("7nYI8", function(module, exports) {
var $5609c645a5db6de1$var$check = function(it) {
    return it && it.Math == Math && it;
};
// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
module.exports = // eslint-disable-next-line es/no-global-this -- safe
$5609c645a5db6de1$var$check(typeof globalThis == "object" && globalThis) || $5609c645a5db6de1$var$check(typeof window == "object" && window) || // eslint-disable-next-line no-restricted-globals -- safe
$5609c645a5db6de1$var$check(typeof self == "object" && self) || $5609c645a5db6de1$var$check(typeof $parcel$global == "object" && $parcel$global) || // eslint-disable-next-line no-new-func -- fallback
function() {
    return this;
}() || Function("return this")();

});

parcelRequire.register("7HSVt", function(module, exports) {

$parcel$export(module.exports, "f", () => $59c727b2ecdaa85a$export$2d1720544b23b823, (v) => $59c727b2ecdaa85a$export$2d1720544b23b823 = v);
// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
var $59c727b2ecdaa85a$export$2d1720544b23b823;

var $foS3H = parcelRequire("foS3H");

var $1sYuu = parcelRequire("1sYuu");

var $2Zd8f = parcelRequire("2Zd8f");

var $edNYr = parcelRequire("edNYr");

var $3XtJI = parcelRequire("3XtJI");

var $7HyCZ = parcelRequire("7HyCZ");

var $aZx1N = parcelRequire("aZx1N");

var $cLBI2 = parcelRequire("cLBI2");
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $59c727b2ecdaa85a$var$$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
$59c727b2ecdaa85a$export$2d1720544b23b823 = $foS3H ? $59c727b2ecdaa85a$var$$getOwnPropertyDescriptor : function getOwnPropertyDescriptor(O, P) {
    O = $3XtJI(O);
    P = $7HyCZ(P);
    if ($cLBI2) try {
        return $59c727b2ecdaa85a$var$$getOwnPropertyDescriptor(O, P);
    } catch (error) {}
    if ($aZx1N(O, P)) return $edNYr(!$1sYuu($2Zd8f.f, O, P), O[P]);
};

});
parcelRequire.register("foS3H", function(module, exports) {

var $2aNMZ = parcelRequire("2aNMZ");
// Detect IE8's incomplete defineProperty implementation
module.exports = !$2aNMZ(function() {
    // eslint-disable-next-line es/no-object-defineproperty -- required for testing
    return Object.defineProperty({}, 1, {
        get: function() {
            return 7;
        }
    })[1] != 7;
});

});
parcelRequire.register("2aNMZ", function(module, exports) {
module.exports = function(exec) {
    try {
        return !!exec();
    } catch (error) {
        return true;
    }
};

});


parcelRequire.register("1sYuu", function(module, exports) {

var $ejHpM = parcelRequire("ejHpM");
var $1117542e864afe29$var$call = Function.prototype.call;
module.exports = $ejHpM ? $1117542e864afe29$var$call.bind($1117542e864afe29$var$call) : function() {
    return $1117542e864afe29$var$call.apply($1117542e864afe29$var$call, arguments);
};

});
parcelRequire.register("ejHpM", function(module, exports) {

var $2aNMZ = parcelRequire("2aNMZ");
module.exports = !$2aNMZ(function() {
    // eslint-disable-next-line es/no-function-prototype-bind -- safe
    var test = (function() {}).bind();
    // eslint-disable-next-line no-prototype-builtins -- safe
    return typeof test != "function" || test.hasOwnProperty("prototype");
});

});


parcelRequire.register("2Zd8f", function(module, exports) {

$parcel$export(module.exports, "f", () => $22cb770c461311de$export$2d1720544b23b823, (v) => $22cb770c461311de$export$2d1720544b23b823 = v);
// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable
var $22cb770c461311de$export$2d1720544b23b823;
"use strict";
var $22cb770c461311de$var$$propertyIsEnumerable = {}.propertyIsEnumerable;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $22cb770c461311de$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
// Nashorn ~ JDK8 bug
var $22cb770c461311de$var$NASHORN_BUG = $22cb770c461311de$var$getOwnPropertyDescriptor && !$22cb770c461311de$var$$propertyIsEnumerable.call({
    1: 2
}, 1);
$22cb770c461311de$export$2d1720544b23b823 = $22cb770c461311de$var$NASHORN_BUG ? function propertyIsEnumerable(V) {
    var descriptor = $22cb770c461311de$var$getOwnPropertyDescriptor(this, V);
    return !!descriptor && descriptor.enumerable;
} : $22cb770c461311de$var$$propertyIsEnumerable;

});

parcelRequire.register("edNYr", function(module, exports) {
module.exports = function(bitmap, value) {
    return {
        enumerable: !(bitmap & 1),
        configurable: !(bitmap & 2),
        writable: !(bitmap & 4),
        value: value
    };
};

});

parcelRequire.register("3XtJI", function(module, exports) {
// toObject with fallback for non-array-like ES3 strings

var $18zgF = parcelRequire("18zgF");

var $kMH4t = parcelRequire("kMH4t");
module.exports = function(it) {
    return $18zgF($kMH4t(it));
};

});
parcelRequire.register("18zgF", function(module, exports) {

var $kkBYw = parcelRequire("kkBYw");

var $2aNMZ = parcelRequire("2aNMZ");

var $8E2yy = parcelRequire("8E2yy");
var $0d41e540d2f79178$var$$Object = Object;
var $0d41e540d2f79178$var$split = $kkBYw("".split);
// fallback for non-array-like ES3 and non-enumerable old V8 strings
module.exports = $2aNMZ(function() {
    // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
    // eslint-disable-next-line no-prototype-builtins -- safe
    return !$0d41e540d2f79178$var$$Object("z").propertyIsEnumerable(0);
}) ? function(it) {
    return $8E2yy(it) == "String" ? $0d41e540d2f79178$var$split(it, "") : $0d41e540d2f79178$var$$Object(it);
} : $0d41e540d2f79178$var$$Object;

});
parcelRequire.register("kkBYw", function(module, exports) {

var $ejHpM = parcelRequire("ejHpM");
var $ecd321f8b31fe2b2$var$FunctionPrototype = Function.prototype;
var $ecd321f8b31fe2b2$var$call = $ecd321f8b31fe2b2$var$FunctionPrototype.call;
var $ecd321f8b31fe2b2$var$uncurryThisWithBind = $ejHpM && $ecd321f8b31fe2b2$var$FunctionPrototype.bind.bind($ecd321f8b31fe2b2$var$call, $ecd321f8b31fe2b2$var$call);
module.exports = $ejHpM ? $ecd321f8b31fe2b2$var$uncurryThisWithBind : function(fn) {
    return function() {
        return $ecd321f8b31fe2b2$var$call.apply(fn, arguments);
    };
};

});

parcelRequire.register("8E2yy", function(module, exports) {

var $kkBYw = parcelRequire("kkBYw");
var $64b40acf2db6581d$var$toString = $kkBYw({}.toString);
var $64b40acf2db6581d$var$stringSlice = $kkBYw("".slice);
module.exports = function(it) {
    return $64b40acf2db6581d$var$stringSlice($64b40acf2db6581d$var$toString(it), 8, -1);
};

});


parcelRequire.register("kMH4t", function(module, exports) {

var $gkj3g = parcelRequire("gkj3g");
var $f219b36439e4e5fb$var$$TypeError = TypeError;
// `RequireObjectCoercible` abstract operation
// https://tc39.es/ecma262/#sec-requireobjectcoercible
module.exports = function(it) {
    if ($gkj3g(it)) throw $f219b36439e4e5fb$var$$TypeError("Can't call method on " + it);
    return it;
};

});
parcelRequire.register("gkj3g", function(module, exports) {
// we can't use just `it == null` since of `document.all` special case
// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot-aec
module.exports = function(it) {
    return it === null || it === undefined;
};

});



parcelRequire.register("7HyCZ", function(module, exports) {

var $lySm1 = parcelRequire("lySm1");

var $jEXxX = parcelRequire("jEXxX");
// `ToPropertyKey` abstract operation
// https://tc39.es/ecma262/#sec-topropertykey
module.exports = function(argument) {
    var key = $lySm1(argument, "string");
    return $jEXxX(key) ? key : key + "";
};

});
parcelRequire.register("lySm1", function(module, exports) {

var $1sYuu = parcelRequire("1sYuu");

var $6FOrH = parcelRequire("6FOrH");

var $jEXxX = parcelRequire("jEXxX");

var $3hbLp = parcelRequire("3hbLp");

var $6Zgmg = parcelRequire("6Zgmg");

var $4r2jm = parcelRequire("4r2jm");
var $fb26ef9110daa5b1$var$$TypeError = TypeError;
var $fb26ef9110daa5b1$var$TO_PRIMITIVE = $4r2jm("toPrimitive");
// `ToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-toprimitive
module.exports = function(input, pref) {
    if (!$6FOrH(input) || $jEXxX(input)) return input;
    var exoticToPrim = $3hbLp(input, $fb26ef9110daa5b1$var$TO_PRIMITIVE);
    var result;
    if (exoticToPrim) {
        if (pref === undefined) pref = "default";
        result = $1sYuu(exoticToPrim, input, pref);
        if (!$6FOrH(result) || $jEXxX(result)) return result;
        throw $fb26ef9110daa5b1$var$$TypeError("Can't convert object to primitive value");
    }
    if (pref === undefined) pref = "number";
    return $6Zgmg(input, pref);
};

});
parcelRequire.register("6FOrH", function(module, exports) {

var $18VOO = parcelRequire("18VOO");

var $2In0s = parcelRequire("2In0s");
var $4dbdb3e1fa092b2d$var$documentAll = $2In0s.all;
module.exports = $2In0s.IS_HTMLDDA ? function(it) {
    return typeof it == "object" ? it !== null : $18VOO(it) || it === $4dbdb3e1fa092b2d$var$documentAll;
} : function(it) {
    return typeof it == "object" ? it !== null : $18VOO(it);
};

});
parcelRequire.register("18VOO", function(module, exports) {

var $2In0s = parcelRequire("2In0s");
var $0d53635836ef9b24$var$documentAll = $2In0s.all;
// `IsCallable` abstract operation
// https://tc39.es/ecma262/#sec-iscallable
module.exports = $2In0s.IS_HTMLDDA ? function(argument) {
    return typeof argument == "function" || argument === $0d53635836ef9b24$var$documentAll;
} : function(argument) {
    return typeof argument == "function";
};

});
parcelRequire.register("2In0s", function(module, exports) {
var $1fa1897201bfbce9$var$documentAll = typeof document == "object" && document.all;
// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot
// eslint-disable-next-line unicorn/no-typeof-undefined -- required for testing
var $1fa1897201bfbce9$var$IS_HTMLDDA = typeof $1fa1897201bfbce9$var$documentAll == "undefined" && $1fa1897201bfbce9$var$documentAll !== undefined;
module.exports = {
    all: $1fa1897201bfbce9$var$documentAll,
    IS_HTMLDDA: $1fa1897201bfbce9$var$IS_HTMLDDA
};

});



parcelRequire.register("jEXxX", function(module, exports) {

var $7oweL = parcelRequire("7oweL");

var $18VOO = parcelRequire("18VOO");

var $xsCLe = parcelRequire("xsCLe");

var $55jPq = parcelRequire("55jPq");
var $e4fff177a8673117$var$$Object = Object;
module.exports = $55jPq ? function(it) {
    return typeof it == "symbol";
} : function(it) {
    var $Symbol = $7oweL("Symbol");
    return $18VOO($Symbol) && $xsCLe($Symbol.prototype, $e4fff177a8673117$var$$Object(it));
};

});
parcelRequire.register("7oweL", function(module, exports) {

var $7nYI8 = parcelRequire("7nYI8");

var $18VOO = parcelRequire("18VOO");
var $5623c7e99adc8ca9$var$aFunction = function(argument) {
    return $18VOO(argument) ? argument : undefined;
};
module.exports = function(namespace, method) {
    return arguments.length < 2 ? $5623c7e99adc8ca9$var$aFunction($7nYI8[namespace]) : $7nYI8[namespace] && $7nYI8[namespace][method];
};

});

parcelRequire.register("xsCLe", function(module, exports) {

var $kkBYw = parcelRequire("kkBYw");
module.exports = $kkBYw({}.isPrototypeOf);

});

parcelRequire.register("55jPq", function(module, exports) {
/* eslint-disable es/no-symbol -- required for testing */ 
var $auxz1 = parcelRequire("auxz1");
module.exports = $auxz1 && !Symbol.sham && typeof Symbol.iterator == "symbol";

});
parcelRequire.register("auxz1", function(module, exports) {
/* eslint-disable es/no-symbol -- required for testing */ 
var $jSUEf = parcelRequire("jSUEf");

var $2aNMZ = parcelRequire("2aNMZ");
// eslint-disable-next-line es/no-object-getownpropertysymbols -- required for testing
module.exports = !!Object.getOwnPropertySymbols && !$2aNMZ(function() {
    var symbol = Symbol();
    // Chrome 38 Symbol has incorrect toString conversion
    // `get-own-property-symbols` polyfill symbols converted to object are not Symbol instances
    return !String(symbol) || !(Object(symbol) instanceof Symbol) || // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
    !Symbol.sham && $jSUEf && $jSUEf < 41;
});

});
parcelRequire.register("jSUEf", function(module, exports) {

var $7nYI8 = parcelRequire("7nYI8");

var $anJdC = parcelRequire("anJdC");
var $e79f00a109898cce$var$process = $7nYI8.process;
var $e79f00a109898cce$var$Deno = $7nYI8.Deno;
var $e79f00a109898cce$var$versions = $e79f00a109898cce$var$process && $e79f00a109898cce$var$process.versions || $e79f00a109898cce$var$Deno && $e79f00a109898cce$var$Deno.version;
var $e79f00a109898cce$var$v8 = $e79f00a109898cce$var$versions && $e79f00a109898cce$var$versions.v8;
var $e79f00a109898cce$var$match, $e79f00a109898cce$var$version;
if ($e79f00a109898cce$var$v8) {
    $e79f00a109898cce$var$match = $e79f00a109898cce$var$v8.split(".");
    // in old Chrome, versions of V8 isn't V8 = Chrome / 10
    // but their correct versions are not interesting for us
    $e79f00a109898cce$var$version = $e79f00a109898cce$var$match[0] > 0 && $e79f00a109898cce$var$match[0] < 4 ? 1 : +($e79f00a109898cce$var$match[0] + $e79f00a109898cce$var$match[1]);
}
// BrowserFS NodeJS `process` polyfill incorrectly set `.v8` to `0.0`
// so check `userAgent` even if `.v8` exists, but 0
if (!$e79f00a109898cce$var$version && $anJdC) {
    $e79f00a109898cce$var$match = $anJdC.match(/Edge\/(\d+)/);
    if (!$e79f00a109898cce$var$match || $e79f00a109898cce$var$match[1] >= 74) {
        $e79f00a109898cce$var$match = $anJdC.match(/Chrome\/(\d+)/);
        if ($e79f00a109898cce$var$match) $e79f00a109898cce$var$version = +$e79f00a109898cce$var$match[1];
    }
}
module.exports = $e79f00a109898cce$var$version;

});
parcelRequire.register("anJdC", function(module, exports) {
module.exports = typeof navigator != "undefined" && String(navigator.userAgent) || "";

});





parcelRequire.register("3hbLp", function(module, exports) {

var $8FpFb = parcelRequire("8FpFb");

var $gkj3g = parcelRequire("gkj3g");
// `GetMethod` abstract operation
// https://tc39.es/ecma262/#sec-getmethod
module.exports = function(V, P) {
    var func = V[P];
    return $gkj3g(func) ? undefined : $8FpFb(func);
};

});
parcelRequire.register("8FpFb", function(module, exports) {

var $18VOO = parcelRequire("18VOO");

var $2TjaA = parcelRequire("2TjaA");
var $64f60f42ba78f0da$var$$TypeError = TypeError;
// `Assert: IsCallable(argument) is true`
module.exports = function(argument) {
    if ($18VOO(argument)) return argument;
    throw $64f60f42ba78f0da$var$$TypeError($2TjaA(argument) + " is not a function");
};

});
parcelRequire.register("2TjaA", function(module, exports) {
var $21af96882523116b$var$$String = String;
module.exports = function(argument) {
    try {
        return $21af96882523116b$var$$String(argument);
    } catch (error) {
        return "Object";
    }
};

});



parcelRequire.register("6Zgmg", function(module, exports) {

var $1sYuu = parcelRequire("1sYuu");

var $18VOO = parcelRequire("18VOO");

var $6FOrH = parcelRequire("6FOrH");
var $516520f974a3d7e6$var$$TypeError = TypeError;
// `OrdinaryToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-ordinarytoprimitive
module.exports = function(input, pref) {
    var fn, val;
    if (pref === "string" && $18VOO(fn = input.toString) && !$6FOrH(val = $1sYuu(fn, input))) return val;
    if ($18VOO(fn = input.valueOf) && !$6FOrH(val = $1sYuu(fn, input))) return val;
    if (pref !== "string" && $18VOO(fn = input.toString) && !$6FOrH(val = $1sYuu(fn, input))) return val;
    throw $516520f974a3d7e6$var$$TypeError("Can't convert object to primitive value");
};

});

parcelRequire.register("4r2jm", function(module, exports) {

var $7nYI8 = parcelRequire("7nYI8");

var $apufN = parcelRequire("apufN");

var $aZx1N = parcelRequire("aZx1N");

var $7ZXaq = parcelRequire("7ZXaq");

var $auxz1 = parcelRequire("auxz1");

var $55jPq = parcelRequire("55jPq");
var $33ab7a02655232ca$var$Symbol = $7nYI8.Symbol;
var $33ab7a02655232ca$var$WellKnownSymbolsStore = $apufN("wks");
var $33ab7a02655232ca$var$createWellKnownSymbol = $55jPq ? $33ab7a02655232ca$var$Symbol["for"] || $33ab7a02655232ca$var$Symbol : $33ab7a02655232ca$var$Symbol && $33ab7a02655232ca$var$Symbol.withoutSetter || $7ZXaq;
module.exports = function(name) {
    if (!$aZx1N($33ab7a02655232ca$var$WellKnownSymbolsStore, name)) $33ab7a02655232ca$var$WellKnownSymbolsStore[name] = $auxz1 && $aZx1N($33ab7a02655232ca$var$Symbol, name) ? $33ab7a02655232ca$var$Symbol[name] : $33ab7a02655232ca$var$createWellKnownSymbol("Symbol." + name);
    return $33ab7a02655232ca$var$WellKnownSymbolsStore[name];
};

});
parcelRequire.register("apufN", function(module, exports) {

var $gOsdW = parcelRequire("gOsdW");

var $7QCHl = parcelRequire("7QCHl");
(module.exports = function(key, value) {
    return $7QCHl[key] || ($7QCHl[key] = value !== undefined ? value : {});
})("versions", []).push({
    version: "3.28.0",
    mode: $gOsdW ? "pure" : "global",
    copyright: "\xa9 2014-2023 Denis Pushkarev (zloirock.ru)",
    license: "https://github.com/zloirock/core-js/blob/v3.28.0/LICENSE",
    source: "https://github.com/zloirock/core-js"
});

});
parcelRequire.register("gOsdW", function(module, exports) {
module.exports = false;

});

parcelRequire.register("7QCHl", function(module, exports) {

var $7nYI8 = parcelRequire("7nYI8");

var $aE4sm = parcelRequire("aE4sm");
var $5b6b685c298ce5be$var$SHARED = "__core-js_shared__";
var $5b6b685c298ce5be$var$store = $7nYI8[$5b6b685c298ce5be$var$SHARED] || $aE4sm($5b6b685c298ce5be$var$SHARED, {});
module.exports = $5b6b685c298ce5be$var$store;

});
parcelRequire.register("aE4sm", function(module, exports) {

var $7nYI8 = parcelRequire("7nYI8");
// eslint-disable-next-line es/no-object-defineproperty -- safe
var $7c0118bea3c84cbd$var$defineProperty = Object.defineProperty;
module.exports = function(key, value) {
    try {
        $7c0118bea3c84cbd$var$defineProperty($7nYI8, key, {
            value: value,
            configurable: true,
            writable: true
        });
    } catch (error) {
        $7nYI8[key] = value;
    }
    return value;
};

});



parcelRequire.register("aZx1N", function(module, exports) {

var $kkBYw = parcelRequire("kkBYw");

var $lCYro = parcelRequire("lCYro");
var $8009388ffd30fd14$var$hasOwnProperty = $kkBYw({}.hasOwnProperty);
// `HasOwnProperty` abstract operation
// https://tc39.es/ecma262/#sec-hasownproperty
// eslint-disable-next-line es/no-object-hasown -- safe
module.exports = Object.hasOwn || function hasOwn(it, key) {
    return $8009388ffd30fd14$var$hasOwnProperty($lCYro(it), key);
};

});
parcelRequire.register("lCYro", function(module, exports) {

var $kMH4t = parcelRequire("kMH4t");
var $fbec07df2ea02fba$var$$Object = Object;
// `ToObject` abstract operation
// https://tc39.es/ecma262/#sec-toobject
module.exports = function(argument) {
    return $fbec07df2ea02fba$var$$Object($kMH4t(argument));
};

});


parcelRequire.register("7ZXaq", function(module, exports) {

var $kkBYw = parcelRequire("kkBYw");
var $5d2c204835e82de8$var$id = 0;
var $5d2c204835e82de8$var$postfix = Math.random();
var $5d2c204835e82de8$var$toString = $kkBYw(1.0.toString);
module.exports = function(key) {
    return "Symbol(" + (key === undefined ? "" : key) + ")_" + $5d2c204835e82de8$var$toString(++$5d2c204835e82de8$var$id + $5d2c204835e82de8$var$postfix, 36);
};

});




parcelRequire.register("cLBI2", function(module, exports) {

var $foS3H = parcelRequire("foS3H");

var $2aNMZ = parcelRequire("2aNMZ");

var $9ish2 = parcelRequire("9ish2");
// Thanks to IE8 for its funny defineProperty
module.exports = !$foS3H && !$2aNMZ(function() {
    // eslint-disable-next-line es/no-object-defineproperty -- required for testing
    return Object.defineProperty($9ish2("div"), "a", {
        get: function() {
            return 7;
        }
    }).a != 7;
});

});
parcelRequire.register("9ish2", function(module, exports) {

var $7nYI8 = parcelRequire("7nYI8");

var $6FOrH = parcelRequire("6FOrH");
var $6c4bba1b5648b7e1$var$document = $7nYI8.document;
// typeof document.createElement is 'object' in old IE
var $6c4bba1b5648b7e1$var$EXISTS = $6FOrH($6c4bba1b5648b7e1$var$document) && $6FOrH($6c4bba1b5648b7e1$var$document.createElement);
module.exports = function(it) {
    return $6c4bba1b5648b7e1$var$EXISTS ? $6c4bba1b5648b7e1$var$document.createElement(it) : {};
};

});



parcelRequire.register("kBgag", function(module, exports) {

var $foS3H = parcelRequire("foS3H");

var $fmCgr = parcelRequire("fmCgr");

var $edNYr = parcelRequire("edNYr");
module.exports = $foS3H ? function(object, key, value) {
    return $fmCgr.f(object, key, $edNYr(1, value));
} : function(object, key, value) {
    object[key] = value;
    return object;
};

});
parcelRequire.register("fmCgr", function(module, exports) {

$parcel$export(module.exports, "f", () => $b2f6978f45eafe04$export$2d1720544b23b823, (v) => $b2f6978f45eafe04$export$2d1720544b23b823 = v);
// `Object.defineProperty` method
// https://tc39.es/ecma262/#sec-object.defineproperty
var $b2f6978f45eafe04$export$2d1720544b23b823;

var $foS3H = parcelRequire("foS3H");

var $cLBI2 = parcelRequire("cLBI2");

var $kmDOo = parcelRequire("kmDOo");

var $78ijy = parcelRequire("78ijy");

var $7HyCZ = parcelRequire("7HyCZ");
var $b2f6978f45eafe04$var$$TypeError = TypeError;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var $b2f6978f45eafe04$var$$defineProperty = Object.defineProperty;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $b2f6978f45eafe04$var$$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $b2f6978f45eafe04$var$ENUMERABLE = "enumerable";
var $b2f6978f45eafe04$var$CONFIGURABLE = "configurable";
var $b2f6978f45eafe04$var$WRITABLE = "writable";
$b2f6978f45eafe04$export$2d1720544b23b823 = $foS3H ? $kmDOo ? function defineProperty(O, P, Attributes) {
    $78ijy(O);
    P = $7HyCZ(P);
    $78ijy(Attributes);
    if (typeof O === "function" && P === "prototype" && "value" in Attributes && $b2f6978f45eafe04$var$WRITABLE in Attributes && !Attributes[$b2f6978f45eafe04$var$WRITABLE]) {
        var current = $b2f6978f45eafe04$var$$getOwnPropertyDescriptor(O, P);
        if (current && current[$b2f6978f45eafe04$var$WRITABLE]) {
            O[P] = Attributes.value;
            Attributes = {
                configurable: $b2f6978f45eafe04$var$CONFIGURABLE in Attributes ? Attributes[$b2f6978f45eafe04$var$CONFIGURABLE] : current[$b2f6978f45eafe04$var$CONFIGURABLE],
                enumerable: $b2f6978f45eafe04$var$ENUMERABLE in Attributes ? Attributes[$b2f6978f45eafe04$var$ENUMERABLE] : current[$b2f6978f45eafe04$var$ENUMERABLE],
                writable: false
            };
        }
    }
    return $b2f6978f45eafe04$var$$defineProperty(O, P, Attributes);
} : $b2f6978f45eafe04$var$$defineProperty : function defineProperty(O, P, Attributes) {
    $78ijy(O);
    P = $7HyCZ(P);
    $78ijy(Attributes);
    if ($cLBI2) try {
        return $b2f6978f45eafe04$var$$defineProperty(O, P, Attributes);
    } catch (error) {}
    if ("get" in Attributes || "set" in Attributes) throw $b2f6978f45eafe04$var$$TypeError("Accessors not supported");
    if ("value" in Attributes) O[P] = Attributes.value;
    return O;
};

});
parcelRequire.register("kmDOo", function(module, exports) {

var $foS3H = parcelRequire("foS3H");

var $2aNMZ = parcelRequire("2aNMZ");
// V8 ~ Chrome 36-
// https://bugs.chromium.org/p/v8/issues/detail?id=3334
module.exports = $foS3H && $2aNMZ(function() {
    // eslint-disable-next-line es/no-object-defineproperty -- required for testing
    return Object.defineProperty(function() {}, "prototype", {
        value: 42,
        writable: false
    }).prototype != 42;
});

});

parcelRequire.register("78ijy", function(module, exports) {

var $6FOrH = parcelRequire("6FOrH");
var $53177ca28071ca03$var$$String = String;
var $53177ca28071ca03$var$$TypeError = TypeError;
// `Assert: Type(argument) is Object`
module.exports = function(argument) {
    if ($6FOrH(argument)) return argument;
    throw $53177ca28071ca03$var$$TypeError($53177ca28071ca03$var$$String(argument) + " is not an object");
};

});



parcelRequire.register("02JSJ", function(module, exports) {

var $18VOO = parcelRequire("18VOO");

var $fmCgr = parcelRequire("fmCgr");

var $h4k14 = parcelRequire("h4k14");

var $aE4sm = parcelRequire("aE4sm");
module.exports = function(O, key, value, options) {
    if (!options) options = {};
    var simple = options.enumerable;
    var name = options.name !== undefined ? options.name : key;
    if ($18VOO(value)) $h4k14(value, name, options);
    if (options.global) {
        if (simple) O[key] = value;
        else $aE4sm(key, value);
    } else {
        try {
            if (!options.unsafe) delete O[key];
            else if (O[key]) simple = true;
        } catch (error) {}
        if (simple) O[key] = value;
        else $fmCgr.f(O, key, {
            value: value,
            enumerable: false,
            configurable: !options.nonConfigurable,
            writable: !options.nonWritable
        });
    }
    return O;
};

});
parcelRequire.register("h4k14", function(module, exports) {

var $kkBYw = parcelRequire("kkBYw");

var $2aNMZ = parcelRequire("2aNMZ");

var $18VOO = parcelRequire("18VOO");

var $aZx1N = parcelRequire("aZx1N");

var $foS3H = parcelRequire("foS3H");

var $bUJAi = parcelRequire("bUJAi");
var $c6d2562eb68855af$require$CONFIGURABLE_FUNCTION_NAME = $bUJAi.CONFIGURABLE;

var $98fRx = parcelRequire("98fRx");

var $jAamA = parcelRequire("jAamA");
var $c6d2562eb68855af$var$enforceInternalState = $jAamA.enforce;
var $c6d2562eb68855af$var$getInternalState = $jAamA.get;
var $c6d2562eb68855af$var$$String = String;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var $c6d2562eb68855af$var$defineProperty = Object.defineProperty;
var $c6d2562eb68855af$var$stringSlice = $kkBYw("".slice);
var $c6d2562eb68855af$var$replace = $kkBYw("".replace);
var $c6d2562eb68855af$var$join = $kkBYw([].join);
var $c6d2562eb68855af$var$CONFIGURABLE_LENGTH = $foS3H && !$2aNMZ(function() {
    return $c6d2562eb68855af$var$defineProperty(function() {}, "length", {
        value: 8
    }).length !== 8;
});
var $c6d2562eb68855af$var$TEMPLATE = String(String).split("String");
var $c6d2562eb68855af$var$makeBuiltIn = module.exports = function(value, name, options) {
    if ($c6d2562eb68855af$var$stringSlice($c6d2562eb68855af$var$$String(name), 0, 7) === "Symbol(") name = "[" + $c6d2562eb68855af$var$replace($c6d2562eb68855af$var$$String(name), /^Symbol\(([^)]*)\)/, "$1") + "]";
    if (options && options.getter) name = "get " + name;
    if (options && options.setter) name = "set " + name;
    if (!$aZx1N(value, "name") || $c6d2562eb68855af$require$CONFIGURABLE_FUNCTION_NAME && value.name !== name) {
        if ($foS3H) $c6d2562eb68855af$var$defineProperty(value, "name", {
            value: name,
            configurable: true
        });
        else value.name = name;
    }
    if ($c6d2562eb68855af$var$CONFIGURABLE_LENGTH && options && $aZx1N(options, "arity") && value.length !== options.arity) $c6d2562eb68855af$var$defineProperty(value, "length", {
        value: options.arity
    });
    try {
        if (options && $aZx1N(options, "constructor") && options.constructor) {
            if ($foS3H) $c6d2562eb68855af$var$defineProperty(value, "prototype", {
                writable: false
            });
        } else if (value.prototype) value.prototype = undefined;
    } catch (error) {}
    var state = $c6d2562eb68855af$var$enforceInternalState(value);
    if (!$aZx1N(state, "source")) state.source = $c6d2562eb68855af$var$join($c6d2562eb68855af$var$TEMPLATE, typeof name == "string" ? name : "");
    return value;
};
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
// eslint-disable-next-line no-extend-native -- required
Function.prototype.toString = $c6d2562eb68855af$var$makeBuiltIn(function toString() {
    return $18VOO(this) && $c6d2562eb68855af$var$getInternalState(this).source || $98fRx(this);
}, "toString");

});
parcelRequire.register("bUJAi", function(module, exports) {

var $foS3H = parcelRequire("foS3H");

var $aZx1N = parcelRequire("aZx1N");
var $8ac848c6e40848fa$var$FunctionPrototype = Function.prototype;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $8ac848c6e40848fa$var$getDescriptor = $foS3H && Object.getOwnPropertyDescriptor;
var $8ac848c6e40848fa$var$EXISTS = $aZx1N($8ac848c6e40848fa$var$FunctionPrototype, "name");
// additional protection from minified / mangled / dropped function names
var $8ac848c6e40848fa$var$PROPER = $8ac848c6e40848fa$var$EXISTS && (function something() {}).name === "something";
var $8ac848c6e40848fa$var$CONFIGURABLE = $8ac848c6e40848fa$var$EXISTS && (!$foS3H || $foS3H && $8ac848c6e40848fa$var$getDescriptor($8ac848c6e40848fa$var$FunctionPrototype, "name").configurable);
module.exports = {
    EXISTS: $8ac848c6e40848fa$var$EXISTS,
    PROPER: $8ac848c6e40848fa$var$PROPER,
    CONFIGURABLE: $8ac848c6e40848fa$var$CONFIGURABLE
};

});

parcelRequire.register("98fRx", function(module, exports) {

var $kkBYw = parcelRequire("kkBYw");

var $18VOO = parcelRequire("18VOO");

var $7QCHl = parcelRequire("7QCHl");
var $6a612a5f054a5c60$var$functionToString = $kkBYw(Function.toString);
// this helper broken in `core-js@3.4.1-3.4.4`, so we can't use `shared` helper
if (!$18VOO($7QCHl.inspectSource)) $7QCHl.inspectSource = function(it) {
    return $6a612a5f054a5c60$var$functionToString(it);
};
module.exports = $7QCHl.inspectSource;

});

parcelRequire.register("jAamA", function(module, exports) {

var $2Ouok = parcelRequire("2Ouok");

var $7nYI8 = parcelRequire("7nYI8");

var $6FOrH = parcelRequire("6FOrH");

var $kBgag = parcelRequire("kBgag");

var $aZx1N = parcelRequire("aZx1N");

var $7QCHl = parcelRequire("7QCHl");

var $4x3Dd = parcelRequire("4x3Dd");

var $hW3C9 = parcelRequire("hW3C9");
var $e4196b104a1cc521$var$OBJECT_ALREADY_INITIALIZED = "Object already initialized";
var $e4196b104a1cc521$var$TypeError = $7nYI8.TypeError;
var $e4196b104a1cc521$var$WeakMap = $7nYI8.WeakMap;
var $e4196b104a1cc521$var$set, $e4196b104a1cc521$var$get, $e4196b104a1cc521$var$has;
var $e4196b104a1cc521$var$enforce = function(it) {
    return $e4196b104a1cc521$var$has(it) ? $e4196b104a1cc521$var$get(it) : $e4196b104a1cc521$var$set(it, {});
};
var $e4196b104a1cc521$var$getterFor = function(TYPE) {
    return function(it) {
        var state;
        if (!$6FOrH(it) || (state = $e4196b104a1cc521$var$get(it)).type !== TYPE) throw $e4196b104a1cc521$var$TypeError("Incompatible receiver, " + TYPE + " required");
        return state;
    };
};
if ($2Ouok || $7QCHl.state) {
    var $e4196b104a1cc521$var$store = $7QCHl.state || ($7QCHl.state = new $e4196b104a1cc521$var$WeakMap());
    /* eslint-disable no-self-assign -- prototype methods protection */ $e4196b104a1cc521$var$store.get = $e4196b104a1cc521$var$store.get;
    $e4196b104a1cc521$var$store.has = $e4196b104a1cc521$var$store.has;
    $e4196b104a1cc521$var$store.set = $e4196b104a1cc521$var$store.set;
    /* eslint-enable no-self-assign -- prototype methods protection */ $e4196b104a1cc521$var$set = function(it, metadata) {
        if ($e4196b104a1cc521$var$store.has(it)) throw $e4196b104a1cc521$var$TypeError($e4196b104a1cc521$var$OBJECT_ALREADY_INITIALIZED);
        metadata.facade = it;
        $e4196b104a1cc521$var$store.set(it, metadata);
        return metadata;
    };
    $e4196b104a1cc521$var$get = function(it) {
        return $e4196b104a1cc521$var$store.get(it) || {};
    };
    $e4196b104a1cc521$var$has = function(it) {
        return $e4196b104a1cc521$var$store.has(it);
    };
} else {
    var $e4196b104a1cc521$var$STATE = $4x3Dd("state");
    $hW3C9[$e4196b104a1cc521$var$STATE] = true;
    $e4196b104a1cc521$var$set = function(it, metadata) {
        if ($aZx1N(it, $e4196b104a1cc521$var$STATE)) throw $e4196b104a1cc521$var$TypeError($e4196b104a1cc521$var$OBJECT_ALREADY_INITIALIZED);
        metadata.facade = it;
        $kBgag(it, $e4196b104a1cc521$var$STATE, metadata);
        return metadata;
    };
    $e4196b104a1cc521$var$get = function(it) {
        return $aZx1N(it, $e4196b104a1cc521$var$STATE) ? it[$e4196b104a1cc521$var$STATE] : {};
    };
    $e4196b104a1cc521$var$has = function(it) {
        return $aZx1N(it, $e4196b104a1cc521$var$STATE);
    };
}
module.exports = {
    set: $e4196b104a1cc521$var$set,
    get: $e4196b104a1cc521$var$get,
    has: $e4196b104a1cc521$var$has,
    enforce: $e4196b104a1cc521$var$enforce,
    getterFor: $e4196b104a1cc521$var$getterFor
};

});
parcelRequire.register("2Ouok", function(module, exports) {

var $7nYI8 = parcelRequire("7nYI8");

var $18VOO = parcelRequire("18VOO");
var $20c7d35b424d08df$var$WeakMap = $7nYI8.WeakMap;
module.exports = $18VOO($20c7d35b424d08df$var$WeakMap) && /native code/.test(String($20c7d35b424d08df$var$WeakMap));

});

parcelRequire.register("4x3Dd", function(module, exports) {

var $apufN = parcelRequire("apufN");

var $7ZXaq = parcelRequire("7ZXaq");
var $34cd0fa43d93971f$var$keys = $apufN("keys");
module.exports = function(key) {
    return $34cd0fa43d93971f$var$keys[key] || ($34cd0fa43d93971f$var$keys[key] = $7ZXaq(key));
};

});

parcelRequire.register("hW3C9", function(module, exports) {
module.exports = {};

});




parcelRequire.register("cutjL", function(module, exports) {

var $aZx1N = parcelRequire("aZx1N");

var $liWLi = parcelRequire("liWLi");

var $7HSVt = parcelRequire("7HSVt");

var $fmCgr = parcelRequire("fmCgr");
module.exports = function(target, source, exceptions) {
    var keys = $liWLi(source);
    var defineProperty = $fmCgr.f;
    var getOwnPropertyDescriptor = $7HSVt.f;
    for(var i = 0; i < keys.length; i++){
        var key = keys[i];
        if (!$aZx1N(target, key) && !(exceptions && $aZx1N(exceptions, key))) defineProperty(target, key, getOwnPropertyDescriptor(source, key));
    }
};

});
parcelRequire.register("liWLi", function(module, exports) {

var $7oweL = parcelRequire("7oweL");

var $kkBYw = parcelRequire("kkBYw");

var $3B3gQ = parcelRequire("3B3gQ");

var $6Dvlb = parcelRequire("6Dvlb");

var $78ijy = parcelRequire("78ijy");
var $f828dc463b3be41f$var$concat = $kkBYw([].concat);
// all object keys, includes non-enumerable and symbols
module.exports = $7oweL("Reflect", "ownKeys") || function ownKeys(it) {
    var keys = $3B3gQ.f($78ijy(it));
    var getOwnPropertySymbols = $6Dvlb.f;
    return getOwnPropertySymbols ? $f828dc463b3be41f$var$concat(keys, getOwnPropertySymbols(it)) : keys;
};

});
parcelRequire.register("3B3gQ", function(module, exports) {

$parcel$export(module.exports, "f", () => $29e75d48397d82fb$export$2d1720544b23b823, (v) => $29e75d48397d82fb$export$2d1720544b23b823 = v);
// `Object.getOwnPropertyNames` method
// https://tc39.es/ecma262/#sec-object.getownpropertynames
// eslint-disable-next-line es/no-object-getownpropertynames -- safe
var $29e75d48397d82fb$export$2d1720544b23b823;

var $7VCeS = parcelRequire("7VCeS");

var $jG3Gs = parcelRequire("jG3Gs");
var $29e75d48397d82fb$var$hiddenKeys = $jG3Gs.concat("length", "prototype");
$29e75d48397d82fb$export$2d1720544b23b823 = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
    return $7VCeS(O, $29e75d48397d82fb$var$hiddenKeys);
};

});
parcelRequire.register("7VCeS", function(module, exports) {

var $kkBYw = parcelRequire("kkBYw");

var $aZx1N = parcelRequire("aZx1N");

var $3XtJI = parcelRequire("3XtJI");

var $imgeX = parcelRequire("imgeX");
var $5c5b84bca888d823$require$indexOf = $imgeX.indexOf;

var $hW3C9 = parcelRequire("hW3C9");
var $5c5b84bca888d823$var$push = $kkBYw([].push);
module.exports = function(object, names) {
    var O = $3XtJI(object);
    var i = 0;
    var result = [];
    var key;
    for(key in O)!$aZx1N($hW3C9, key) && $aZx1N(O, key) && $5c5b84bca888d823$var$push(result, key);
    // Don't enum bug & hidden keys
    while(names.length > i)if ($aZx1N(O, key = names[i++])) ~$5c5b84bca888d823$require$indexOf(result, key) || $5c5b84bca888d823$var$push(result, key);
    return result;
};

});
parcelRequire.register("imgeX", function(module, exports) {

var $3XtJI = parcelRequire("3XtJI");

var $42z7E = parcelRequire("42z7E");

var $eTBA7 = parcelRequire("eTBA7");
// `Array.prototype.{ indexOf, includes }` methods implementation
var $d5d6e10cab5b84a5$var$createMethod = function(IS_INCLUDES) {
    return function($this, el, fromIndex) {
        var O = $3XtJI($this);
        var length = $eTBA7(O);
        var index = $42z7E(fromIndex, length);
        var value;
        // Array#includes uses SameValueZero equality algorithm
        // eslint-disable-next-line no-self-compare -- NaN check
        if (IS_INCLUDES && el != el) while(length > index){
            value = O[index++];
            // eslint-disable-next-line no-self-compare -- NaN check
            if (value != value) return true;
        // Array#indexOf ignores holes, Array#includes - not
        }
        else for(; length > index; index++){
            if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
        }
        return !IS_INCLUDES && -1;
    };
};
module.exports = {
    // `Array.prototype.includes` method
    // https://tc39.es/ecma262/#sec-array.prototype.includes
    includes: $d5d6e10cab5b84a5$var$createMethod(true),
    // `Array.prototype.indexOf` method
    // https://tc39.es/ecma262/#sec-array.prototype.indexof
    indexOf: $d5d6e10cab5b84a5$var$createMethod(false)
};

});
parcelRequire.register("42z7E", function(module, exports) {

var $dxgcn = parcelRequire("dxgcn");
var $2f1297ee8992f7ce$var$max = Math.max;
var $2f1297ee8992f7ce$var$min = Math.min;
// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
module.exports = function(index, length) {
    var integer = $dxgcn(index);
    return integer < 0 ? $2f1297ee8992f7ce$var$max(integer + length, 0) : $2f1297ee8992f7ce$var$min(integer, length);
};

});
parcelRequire.register("dxgcn", function(module, exports) {

var $2onun = parcelRequire("2onun");
// `ToIntegerOrInfinity` abstract operation
// https://tc39.es/ecma262/#sec-tointegerorinfinity
module.exports = function(argument) {
    var number = +argument;
    // eslint-disable-next-line no-self-compare -- NaN check
    return number !== number || number === 0 ? 0 : $2onun(number);
};

});
parcelRequire.register("2onun", function(module, exports) {
var $1be00b1367743b69$var$ceil = Math.ceil;
var $1be00b1367743b69$var$floor = Math.floor;
// `Math.trunc` method
// https://tc39.es/ecma262/#sec-math.trunc
// eslint-disable-next-line es/no-math-trunc -- safe
module.exports = Math.trunc || function trunc(x) {
    var n = +x;
    return (n > 0 ? $1be00b1367743b69$var$floor : $1be00b1367743b69$var$ceil)(n);
};

});



parcelRequire.register("eTBA7", function(module, exports) {

var $fzz7M = parcelRequire("fzz7M");
// `LengthOfArrayLike` abstract operation
// https://tc39.es/ecma262/#sec-lengthofarraylike
module.exports = function(obj) {
    return $fzz7M(obj.length);
};

});
parcelRequire.register("fzz7M", function(module, exports) {

var $dxgcn = parcelRequire("dxgcn");
var $b5655ee7c3df9ad3$var$min = Math.min;
// `ToLength` abstract operation
// https://tc39.es/ecma262/#sec-tolength
module.exports = function(argument) {
    return argument > 0 ? $b5655ee7c3df9ad3$var$min($dxgcn(argument), 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};

});




parcelRequire.register("jG3Gs", function(module, exports) {
// IE8- don't enum bug keys
module.exports = [
    "constructor",
    "hasOwnProperty",
    "isPrototypeOf",
    "propertyIsEnumerable",
    "toLocaleString",
    "toString",
    "valueOf"
];

});


parcelRequire.register("6Dvlb", function(module, exports) {

$parcel$export(module.exports, "f", () => $4d4eb233fd2bdc47$export$2d1720544b23b823, (v) => $4d4eb233fd2bdc47$export$2d1720544b23b823 = v);
// eslint-disable-next-line es/no-object-getownpropertysymbols -- safe
var $4d4eb233fd2bdc47$export$2d1720544b23b823;
$4d4eb233fd2bdc47$export$2d1720544b23b823 = Object.getOwnPropertySymbols;

});



parcelRequire.register("k5zO5", function(module, exports) {

var $2aNMZ = parcelRequire("2aNMZ");

var $18VOO = parcelRequire("18VOO");
var $ea000ccacf7e2340$var$replacement = /#|\.prototype\./;
var $ea000ccacf7e2340$var$isForced = function(feature, detection) {
    var value = $ea000ccacf7e2340$var$data[$ea000ccacf7e2340$var$normalize(feature)];
    return value == $ea000ccacf7e2340$var$POLYFILL ? true : value == $ea000ccacf7e2340$var$NATIVE ? false : $18VOO(detection) ? $2aNMZ(detection) : !!detection;
};
var $ea000ccacf7e2340$var$normalize = $ea000ccacf7e2340$var$isForced.normalize = function(string) {
    return String(string).replace($ea000ccacf7e2340$var$replacement, ".").toLowerCase();
};
var $ea000ccacf7e2340$var$data = $ea000ccacf7e2340$var$isForced.data = {};
var $ea000ccacf7e2340$var$NATIVE = $ea000ccacf7e2340$var$isForced.NATIVE = "N";
var $ea000ccacf7e2340$var$POLYFILL = $ea000ccacf7e2340$var$isForced.POLYFILL = "P";
module.exports = $ea000ccacf7e2340$var$isForced;

});


parcelRequire.register("8iVJA", function(module, exports) {

var $foS3H = parcelRequire("foS3H");

var $kkBYw = parcelRequire("kkBYw");

var $5ilfb = parcelRequire("5ilfb");

var $3XtJI = parcelRequire("3XtJI");

var $2Zd8f = parcelRequire("2Zd8f");
var $60bcc9feffbbc03c$require$$propertyIsEnumerable = $2Zd8f.f;
var $60bcc9feffbbc03c$var$propertyIsEnumerable = $kkBYw($60bcc9feffbbc03c$require$$propertyIsEnumerable);
var $60bcc9feffbbc03c$var$push = $kkBYw([].push);
// `Object.{ entries, values }` methods implementation
var $60bcc9feffbbc03c$var$createMethod = function(TO_ENTRIES) {
    return function(it) {
        var O = $3XtJI(it);
        var keys = $5ilfb(O);
        var length = keys.length;
        var i = 0;
        var result = [];
        var key;
        while(length > i){
            key = keys[i++];
            if (!$foS3H || $60bcc9feffbbc03c$var$propertyIsEnumerable(O, key)) $60bcc9feffbbc03c$var$push(result, TO_ENTRIES ? [
                key,
                O[key]
            ] : O[key]);
        }
        return result;
    };
};
module.exports = {
    // `Object.entries` method
    // https://tc39.es/ecma262/#sec-object.entries
    entries: $60bcc9feffbbc03c$var$createMethod(true),
    // `Object.values` method
    // https://tc39.es/ecma262/#sec-object.values
    values: $60bcc9feffbbc03c$var$createMethod(false)
};

});
parcelRequire.register("5ilfb", function(module, exports) {

var $7VCeS = parcelRequire("7VCeS");

var $jG3Gs = parcelRequire("jG3Gs");
// `Object.keys` method
// https://tc39.es/ecma262/#sec-object.keys
// eslint-disable-next-line es/no-object-keys -- safe
module.exports = Object.keys || function keys(O) {
    return $7VCeS(O, $jG3Gs);
};

});



parcelRequire.register("9LfIn", function(module, exports) {

var $7nYI8 = parcelRequire("7nYI8");
module.exports = $7nYI8;

});






parcelRequire.register("hYyeZ", function(module, exports) {
"use strict";

var $cP3px = parcelRequire("cP3px");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $d16299c42164329e$var$create;

var $d16299c42164329e$var$_regenerator = $cP3px((parcelRequire("foOOj")));

var $d16299c42164329e$var$_asyncToGenerator2 = $cP3px((parcelRequire("iV07h")));

var $jZE2L = parcelRequire("jZE2L");
var $uGEBp = parcelRequire("uGEBp");
var $id7qa = parcelRequire("id7qa");
var $jJjdG = parcelRequire("jJjdG");

var $d16299c42164329e$var$_createWebSpeechPonyfillFactory = $cP3px((parcelRequire("7ej26")));

var $d16299c42164329e$var$_DirectLineSpeech = $cP3px((parcelRequire("dYn8H")));

var $d16299c42164329e$var$_patchDialogServiceConnectorInline = $cP3px((parcelRequire("aayCS")));

var $d16299c42164329e$var$_refreshDirectLineToken = $cP3px((parcelRequire("9O5Pd")));

var $d16299c42164329e$var$_resolveFunctionOrReturnValue = $cP3px((parcelRequire("4v0uz")));
/* eslint complexity: ["error", 33] */ var $d16299c42164329e$var$DIRECT_LINE_TOKEN_RENEWAL_INTERVAL = 900000; // 15 minutes
var $d16299c42164329e$var$TOKEN_RENEWAL_INTERVAL = 120000; // eslint-disable-next-line complexity
function $d16299c42164329e$var$create(_x) {
    return $d16299c42164329e$var$_create.apply(this, arguments);
}
function $d16299c42164329e$var$_create() {
    $d16299c42164329e$var$_create = (0, $d16299c42164329e$var$_asyncToGenerator2.default)(/*#__PURE__*/ $d16299c42164329e$var$_regenerator.default.mark(function _callee3(_ref) {
        var audioConfig, audioContext, audioInputDeviceId, enableInternalHTTPSupport, enableTelemetry, fetchCredentials, speechRecognitionEndpointId, _ref$speechRecognitio, speechRecognitionLanguage, speechSynthesisDeploymentId, speechSynthesisOutputFormat, textNormalization, userID, username, _yield$resolveFunctio, authorizationToken, directLineToken, directLineSpeechHostname, region, subscriptionKey, config, dialogServiceConnector, interval, _interval, directLine, webSpeechPonyfillFactory;
        return $d16299c42164329e$var$_regenerator.default.wrap(function _callee3$(_context3) {
            while(true)switch(_context3.prev = _context3.next){
                case 0:
                    audioConfig = _ref.audioConfig, audioContext = _ref.audioContext, audioInputDeviceId = _ref.audioInputDeviceId, enableInternalHTTPSupport = _ref.enableInternalHTTPSupport, enableTelemetry = _ref.enableTelemetry, fetchCredentials = _ref.fetchCredentials, speechRecognitionEndpointId = _ref.speechRecognitionEndpointId, _ref$speechRecognitio = _ref.speechRecognitionLanguage, speechRecognitionLanguage = _ref$speechRecognitio === void 0 ? typeof window !== "undefined" && typeof window.navigator !== "undefined" && window.navigator.language || "en-US" : _ref$speechRecognitio, speechSynthesisDeploymentId = _ref.speechSynthesisDeploymentId, speechSynthesisOutputFormat = _ref.speechSynthesisOutputFormat, textNormalization = _ref.textNormalization, userID = _ref.userID, username = _ref.username;
                    if (fetchCredentials) {
                        _context3.next = 3;
                        break;
                    }
                    throw new Error('"fetchCredentials" must be specified.');
                case 3:
                    _context3.next = 5;
                    return (0, $d16299c42164329e$var$_resolveFunctionOrReturnValue.default)(fetchCredentials);
                case 5:
                    _yield$resolveFunctio = _context3.sent;
                    authorizationToken = _yield$resolveFunctio.authorizationToken;
                    directLineToken = _yield$resolveFunctio.directLineToken;
                    directLineSpeechHostname = _yield$resolveFunctio.directLineSpeechHostname;
                    region = _yield$resolveFunctio.region;
                    subscriptionKey = _yield$resolveFunctio.subscriptionKey;
                    if (!(!authorizationToken && !subscriptionKey || authorizationToken && subscriptionKey || authorizationToken && typeof authorizationToken !== "string" || subscriptionKey && typeof subscriptionKey !== "string" || enableInternalHTTPSupport && !directLineToken)) {
                        _context3.next = 13;
                        break;
                    }
                    throw new Error('"fetchCredentials" must return either "authorizationToken" or "subscriptionKey" as a non-empty string only. If enableInternalHTTPSupport is set to true, then it should also return a non-empty "directLineToken"');
                case 13:
                    if (typeof enableTelemetry !== "undefined") console.warn("botframework-directlinespeech: Telemetry options are not yet supported. Please refer to Cognitive Services documentation for details.");
                    if (!(directLineSpeechHostname && region || !directLineSpeechHostname && !region)) {
                        _context3.next = 16;
                        break;
                    }
                    throw new Error('"fetchCredentials" must return either "directLineSpeechHostname" or "region" and it must not be an empty string.');
                case 16:
                    if (!directLineSpeechHostname) {
                        _context3.next = 23;
                        break;
                    }
                    if (!(typeof directLineSpeechHostname !== "string")) {
                        _context3.next = 19;
                        break;
                    }
                    throw new Error('"fetchCredentials" must return "directLineSpeechHostname" as a string.');
                case 19:
                    if (!enableInternalHTTPSupport) {
                        _context3.next = 21;
                        break;
                    }
                    throw new Error('"fetchCredentials" must not return "directLineSpeechHostname" if "enableInternalHTTPSupport" is set.');
                case 21:
                    _context3.next = 25;
                    break;
                case 23:
                    if (!(typeof region !== "string")) {
                        _context3.next = 25;
                        break;
                    }
                    throw new Error('"fetchCredentials" must return "region" as a string.');
                case 25:
                    if (audioConfig && audioInputDeviceId) console.warn('botframework-directlinespeech-sdk: Only "audioConfig" or "audioInputDeviceId" can be specified, but not both; ignoring "audioInputDeviceId".');
                    else if (!audioConfig) {
                        if (audioInputDeviceId) audioConfig = $jZE2L.AudioConfig.fromMicrophoneInput(audioInputDeviceId);
                        else audioConfig = $jZE2L.AudioConfig.fromDefaultMicrophoneInput();
                    }
                    if (speechRecognitionEndpointId) console.warn('botframework-directlinespeech: Custom Speech is currently not supported; ignoring "speechRecognitionEndpointId".');
                    if (speechSynthesisDeploymentId) console.warn('botframework-directlinespeech: Custom Voice is currently not supported; ignoring "speechSynthesisDeploymentId".');
                    if (speechSynthesisOutputFormat) console.warn('botframework-directlinespeech: Synthesis output format is currently not supported; ignoring "speechSynthesisOutputFormat".');
                    if (textNormalization) console.warn('botframework-directlinespeech: Text normalization is currently not supported; ignoring "textNormalization".');
                    if (userID || username) console.warn('botframework-directlinespeech: Custom "userId" and "username" are currently not supported and are ignored.');
                    if (directLineSpeechHostname) {
                        if (authorizationToken) {
                            config = $uGEBp.BotFrameworkConfig.fromHost(new URL("wss://".concat(directLineSpeechHostname)));
                            config.setProperty($jJjdG.PropertyId.SpeechServiceAuthorization_Token, authorizationToken);
                        } else config = $uGEBp.BotFrameworkConfig.fromHost(new URL("wss://".concat(directLineSpeechHostname)), subscriptionKey);
                    } else {
                        if (authorizationToken) config = $uGEBp.BotFrameworkConfig.fromAuthorizationToken(authorizationToken, region);
                        else config = $uGEBp.BotFrameworkConfig.fromSubscription(subscriptionKey, region);
                         // If internal HTTP support is enabled, switch the endpoint to Direct Line on Direct Line Speech service.
                        if (enableInternalHTTPSupport) {
                            config.setProperty($jJjdG.PropertyId.SpeechServiceConnection_Endpoint, "wss://".concat(encodeURI(region), ".convai.speech.microsoft.com/directline/api/v1"));
                            config.setProperty($jJjdG.PropertyId.Conversation_Agent_Connection_Id, directLineToken);
                        }
                    } // Supported options can be found in DialogConnectorFactory.js.
                    // Set the language used for recognition.
                    config.setProperty($jJjdG.PropertyId.SpeechServiceConnection_RecoLanguage, speechRecognitionLanguage); // The following code sets the output format.
                    // As advised by the Speech team, this API may be subject to future changes.
                    // We are not enabling output format option because it does not send detailed output format to the bot, rendering this option useless.
                    // config.setProperty(PropertyId.SpeechServiceResponse_OutputFormatOption, OutputFormat[OutputFormat.Detailed]);
                    // Set the user ID for starting the conversation.
                    userID && config.setProperty($jJjdG.PropertyId.Conversation_From_Id, userID); // Set Custom Speech and Custom Voice.
                    // The following code is copied from C#, and it is not working yet.
                    // https://github.com/Azure-Samples/Cognitive-Services-Direct-Line-Speech-Client/blob/master/DLSpeechClient/MainWindow.xaml.cs
                    // speechRecognitionEndpointId && config.setServiceProperty('cid', speechRecognitionEndpointId, ServicePropertyChannel.UriQueryParameter);
                    // speechSynthesisDeploymentId && config.setProperty(PropertyId.conversation_Custom_Voice_Deployment_Ids, speechSynthesisDeploymentId);
                    dialogServiceConnector = (0, $d16299c42164329e$var$_patchDialogServiceConnectorInline.default)(new $id7qa.DialogServiceConnector(config, audioConfig)); // Renew token per interval.
                    if (authorizationToken) interval = setInterval(/*#__PURE__*/ (0, $d16299c42164329e$var$_asyncToGenerator2.default)(/*#__PURE__*/ $d16299c42164329e$var$_regenerator.default.mark(function _callee() {
                        var _yield$resolveFunctio2, authorizationToken, nextDirectLineSpeechHostname, nextRegion;
                        return $d16299c42164329e$var$_regenerator.default.wrap(function _callee$(_context) {
                            while(true)switch(_context.prev = _context.next){
                                case 0:
                                    // #2660 If the connector has been disposed, we should stop renewing the token.
                                    // TODO: We should use a public implementation if Speech SDK has one related to "privIsDisposed".
                                    if (dialogServiceConnector.privIsDisposed) clearInterval(interval);
                                    _context.next = 3;
                                    return (0, $d16299c42164329e$var$_resolveFunctionOrReturnValue.default)(fetchCredentials);
                                case 3:
                                    _yield$resolveFunctio2 = _context.sent;
                                    authorizationToken = _yield$resolveFunctio2.authorizationToken;
                                    nextDirectLineSpeechHostname = _yield$resolveFunctio2.directLineSpeechHostname;
                                    nextRegion = _yield$resolveFunctio2.region;
                                    if (authorizationToken) {
                                        _context.next = 9;
                                        break;
                                    }
                                    return _context.abrupt("return", console.warn('botframework-directlinespeech-sdk: Renew token failed because "fetchCredentials" call returned no authorization token.'));
                                case 9:
                                    if (!directLineSpeechHostname) {
                                        _context.next = 14;
                                        break;
                                    }
                                    if (!(directLineSpeechHostname !== nextDirectLineSpeechHostname)) {
                                        _context.next = 12;
                                        break;
                                    }
                                    return _context.abrupt("return", console.warn('botframework-directlinespeech-sdk: "directLineSpeechHostname" change is not supported for renewed token. Authorization token is not renewed.'));
                                case 12:
                                    _context.next = 16;
                                    break;
                                case 14:
                                    if (!(region !== nextRegion)) {
                                        _context.next = 16;
                                        break;
                                    }
                                    return _context.abrupt("return", console.warn("botframework-directlinespeech-sdk: Region change is not supported for renewed token. Authorization token is not renewed."));
                                case 16:
                                    dialogServiceConnector.authorizationToken = authorizationToken; // eslint-disable-line require-atomic-updates
                                case 17:
                                case "end":
                                    return _context.stop();
                            }
                        }, _callee);
                    })), $d16299c42164329e$var$TOKEN_RENEWAL_INTERVAL);
                     // Renew token per interval.
                    if (enableInternalHTTPSupport) _interval = setInterval(/*#__PURE__*/ (0, $d16299c42164329e$var$_asyncToGenerator2.default)(/*#__PURE__*/ $d16299c42164329e$var$_regenerator.default.mark(function _callee2() {
                        var refreshedDirectLineToken;
                        return $d16299c42164329e$var$_regenerator.default.wrap(function _callee2$(_context2) {
                            while(true)switch(_context2.prev = _context2.next){
                                case 0:
                                    // #2660 If the connector has been disposed, we should stop renewing the token.
                                    // TODO: We should use a public implementation if Speech SDK has one related to "privIsDisposed".
                                    if (dialogServiceConnector.privIsDisposed) clearInterval(_interval);
                                    _context2.next = 3;
                                    return (0, $d16299c42164329e$var$_refreshDirectLineToken.default)(directLineToken);
                                case 3:
                                    refreshedDirectLineToken = _context2.sent;
                                    if (refreshedDirectLineToken) {
                                        _context2.next = 6;
                                        break;
                                    }
                                    return _context2.abrupt("return", console.warn("botframework-directlinespeech-sdk: Renew token failed because call to refresh token Direct Line API did not return a new token."));
                                case 6:
                                    config.setProperty($jJjdG.PropertyId.Conversation_Agent_Connection_Id, refreshedDirectLineToken);
                                    dialogServiceConnector.properties.setProperty($jJjdG.PropertyId.Conversation_Agent_Connection_Id, refreshedDirectLineToken);
                                    dialogServiceConnector.connect();
                                case 9:
                                case "end":
                                    return _context2.stop();
                            }
                        }, _callee2);
                    })), $d16299c42164329e$var$DIRECT_LINE_TOKEN_RENEWAL_INTERVAL);
                    directLine = new $d16299c42164329e$var$_DirectLineSpeech.default({
                        dialogServiceConnector: dialogServiceConnector
                    });
                    webSpeechPonyfillFactory = (0, $d16299c42164329e$var$_createWebSpeechPonyfillFactory.default)({
                        audioContext: audioContext,
                        enableTelemetry: enableTelemetry,
                        recognizer: dialogServiceConnector,
                        textNormalization: textNormalization
                    });
                    return _context3.abrupt("return", {
                        directLine: directLine,
                        webSpeechPonyfillFactory: webSpeechPonyfillFactory
                    });
                case 40:
                case "end":
                    return _context3.stop();
            }
        }, _callee3);
    }));
    return $d16299c42164329e$var$_create.apply(this, arguments);
}

});
parcelRequire.register("foOOj", function(module, exports) {
// TODO(Babel 8): Remove this file.

var $b36082cb8436cb55$var$runtime = (parcelRequire("SKLZA"))();
module.exports = $b36082cb8436cb55$var$runtime;
// Copied from https://github.com/facebook/regenerator/blob/main/packages/runtime/runtime.js#L736=
try {
    regeneratorRuntime = $b36082cb8436cb55$var$runtime;
} catch (accidentalStrictMode) {
    if (typeof globalThis === "object") globalThis.regeneratorRuntime = $b36082cb8436cb55$var$runtime;
    else Function("r", "regeneratorRuntime = r")($b36082cb8436cb55$var$runtime);
}

});
parcelRequire.register("SKLZA", function(module, exports) {

var $jwgnX = parcelRequire("jwgnX");
var $0a49536ae6a8d82d$var$_typeof = $jwgnX.default;
function $0a49536ae6a8d82d$var$_regeneratorRuntime() {
    "use strict";
    /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ module.exports = $0a49536ae6a8d82d$var$_regeneratorRuntime = function _regeneratorRuntime() {
        return exports;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports;
    var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
    function define(obj, key, value) {
        return Object.defineProperty(obj, key, {
            value: value,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }), obj[key];
    }
    try {
        define({}, "");
    } catch (err) {
        define = function define(obj, key, value) {
            return obj[key] = value;
        };
    }
    function wrap(innerFn, outerFn, self, tryLocsList) {
        var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []);
        return generator._invoke = function(innerFn, self, context) {
            var state = "suspendedStart";
            return function(method, arg) {
                if ("executing" === state) throw new Error("Generator is already running");
                if ("completed" === state) {
                    if ("throw" === method) throw arg;
                    return doneResult();
                }
                for(context.method = method, context.arg = arg;;){
                    var delegate = context.delegate;
                    if (delegate) {
                        var delegateResult = maybeInvokeDelegate(delegate, context);
                        if (delegateResult) {
                            if (delegateResult === ContinueSentinel) continue;
                            return delegateResult;
                        }
                    }
                    if ("next" === context.method) context.sent = context._sent = context.arg;
                    else if ("throw" === context.method) {
                        if ("suspendedStart" === state) throw state = "completed", context.arg;
                        context.dispatchException(context.arg);
                    } else "return" === context.method && context.abrupt("return", context.arg);
                    state = "executing";
                    var record = tryCatch(innerFn, self, context);
                    if ("normal" === record.type) {
                        if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue;
                        return {
                            value: record.arg,
                            done: context.done
                        };
                    }
                    "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg);
                }
            };
        }(innerFn, self, context), generator;
    }
    function tryCatch(fn, obj, arg) {
        try {
            return {
                type: "normal",
                arg: fn.call(obj, arg)
            };
        } catch (err) {
            return {
                type: "throw",
                arg: err
            };
        }
    }
    exports.wrap = wrap;
    var ContinueSentinel = {};
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    var IteratorPrototype = {};
    define(IteratorPrototype, iteratorSymbol, function() {
        return this;
    });
    var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([])));
    NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype);
    var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
    function defineIteratorMethods(prototype) {
        [
            "next",
            "throw",
            "return"
        ].forEach(function(method) {
            define(prototype, method, function(arg) {
                return this._invoke(method, arg);
            });
        });
    }
    function AsyncIterator(generator, PromiseImpl) {
        function invoke(method, arg, resolve, reject) {
            var record = tryCatch(generator[method], generator, arg);
            if ("throw" !== record.type) {
                var result = record.arg, value = result.value;
                return value && "object" == $0a49536ae6a8d82d$var$_typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function(value) {
                    invoke("next", value, resolve, reject);
                }, function(err) {
                    invoke("throw", err, resolve, reject);
                }) : PromiseImpl.resolve(value).then(function(unwrapped) {
                    result.value = unwrapped, resolve(result);
                }, function(error) {
                    return invoke("throw", error, resolve, reject);
                });
            }
            reject(record.arg);
        }
        var previousPromise;
        this._invoke = function(method, arg) {
            function callInvokeWithMethodAndArg() {
                return new PromiseImpl(function(resolve, reject) {
                    invoke(method, arg, resolve, reject);
                });
            }
            return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
        };
    }
    function maybeInvokeDelegate(delegate, context) {
        var method = delegate.iterator[context.method];
        if (undefined === method) {
            if (context.delegate = null, "throw" === context.method) {
                if (delegate.iterator["return"] && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel;
                context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method");
            }
            return ContinueSentinel;
        }
        var record = tryCatch(method, delegate.iterator, context.arg);
        if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel;
        var info = record.arg;
        return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel);
    }
    function pushTryEntry(locs) {
        var entry = {
            tryLoc: locs[0]
        };
        1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry);
    }
    function resetTryEntry(entry) {
        var record = entry.completion || {};
        record.type = "normal", delete record.arg, entry.completion = record;
    }
    function Context(tryLocsList) {
        this.tryEntries = [
            {
                tryLoc: "root"
            }
        ], tryLocsList.forEach(pushTryEntry, this), this.reset(!0);
    }
    function values(iterable) {
        if (iterable) {
            var iteratorMethod = iterable[iteratorSymbol];
            if (iteratorMethod) return iteratorMethod.call(iterable);
            if ("function" == typeof iterable.next) return iterable;
            if (!isNaN(iterable.length)) {
                var i = -1, next = function next() {
                    for(; ++i < iterable.length;){
                        if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next;
                    }
                    return next.value = undefined, next.done = !0, next;
                };
                return next.next = next;
            }
        }
        return {
            next: doneResult
        };
    }
    function doneResult() {
        return {
            value: undefined,
            done: !0
        };
    }
    return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function(genFun) {
        var ctor = "function" == typeof genFun && genFun.constructor;
        return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name));
    }, exports.mark = function(genFun) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun;
    }, exports.awrap = function(arg) {
        return {
            __await: arg
        };
    }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function() {
        return this;
    }), exports.AsyncIterator = AsyncIterator, exports.async = function(innerFn, outerFn, self, tryLocsList, PromiseImpl) {
        void 0 === PromiseImpl && (PromiseImpl = Promise);
        var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
        return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function(result) {
            return result.done ? result.value : iter.next();
        });
    }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function() {
        return this;
    }), define(Gp, "toString", function() {
        return "[object Generator]";
    }), exports.keys = function(object) {
        var keys = [];
        for(var key in object)keys.push(key);
        return keys.reverse(), function next() {
            for(; keys.length;){
                var key = keys.pop();
                if (key in object) return next.value = key, next.done = !1, next;
            }
            return next.done = !0, next;
        };
    }, exports.values = values, Context.prototype = {
        constructor: Context,
        reset: function reset(skipTempReset) {
            if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for(var name in this)"t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined);
        },
        stop: function stop() {
            this.done = !0;
            var rootRecord = this.tryEntries[0].completion;
            if ("throw" === rootRecord.type) throw rootRecord.arg;
            return this.rval;
        },
        dispatchException: function dispatchException(exception) {
            if (this.done) throw exception;
            var context = this;
            function handle(loc, caught) {
                return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught;
            }
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i], record = entry.completion;
                if ("root" === entry.tryLoc) return handle("end");
                if (entry.tryLoc <= this.prev) {
                    var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc");
                    if (hasCatch && hasFinally) {
                        if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
                        if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
                    } else if (hasCatch) {
                        if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
                    } else {
                        if (!hasFinally) throw new Error("try statement without catch or finally");
                        if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
                    }
                }
            }
        },
        abrupt: function abrupt(type, arg) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
                    var finallyEntry = entry;
                    break;
                }
            }
            finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null);
            var record = finallyEntry ? finallyEntry.completion : {};
            return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record);
        },
        complete: function complete(record, afterLoc) {
            if ("throw" === record.type) throw record.arg;
            return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel;
        },
        finish: function finish(finallyLoc) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel;
            }
        },
        "catch": function _catch(tryLoc) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.tryLoc === tryLoc) {
                    var record = entry.completion;
                    if ("throw" === record.type) {
                        var thrown = record.arg;
                        resetTryEntry(entry);
                    }
                    return thrown;
                }
            }
            throw new Error("illegal catch attempt");
        },
        delegateYield: function delegateYield(iterable, resultName, nextLoc) {
            return this.delegate = {
                iterator: values(iterable),
                resultName: resultName,
                nextLoc: nextLoc
            }, "next" === this.method && (this.arg = undefined), ContinueSentinel;
        }
    }, exports;
}
module.exports = $0a49536ae6a8d82d$var$_regeneratorRuntime, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRequire.register("jwgnX", function(module, exports) {
function $e35db742fe37884c$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return module.exports = $e35db742fe37884c$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $e35db742fe37884c$var$_typeof(obj);
}
module.exports = $e35db742fe37884c$var$_typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

});



parcelRequire.register("iV07h", function(module, exports) {
function $dc5da401459f9cef$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) resolve(value);
    else Promise.resolve(value).then(_next, _throw);
}
function $dc5da401459f9cef$var$_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                $dc5da401459f9cef$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                $dc5da401459f9cef$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
module.exports = $dc5da401459f9cef$var$_asyncToGenerator, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRequire.register("uGEBp", function(module, exports) {

$parcel$export(module.exports, "BotFrameworkConfig", () => $05c3e3a0d3872cf7$export$69c9ce1ee38f09c4);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.

var $gSYyK = parcelRequire("gSYyK");

var $9Xv9r = parcelRequire("9Xv9r");

var $jJjdG = parcelRequire("jJjdG");
class $05c3e3a0d3872cf7$export$69c9ce1ee38f09c4 extends (0, $9Xv9r.DialogServiceConfigImpl) {
    /**
     * Creates an instance of BotFrameworkConfig.
     */ constructor(){
        super();
    }
    /**
     * Creates a bot framework configuration instance with the provided subscription information.
     * @member BotFrameworkConfig.fromSubscription
     * @function
     * @public
     * @param subscription Subscription key associated with the bot
     * @param region The region name (see the <a href="https://aka.ms/csspeech/region">region page</a>).
     * @param botId Optional. Identifier for using a specific bot within an Azure resource group. Equivalent to the
     *        resource name.
     * @returns {BotFrameworkConfig} A new bot framework configuration instance.
     */ static fromSubscription(subscription, region, botId) {
        (0, $gSYyK.Contracts).throwIfNullOrWhitespace(subscription, "subscription");
        (0, $gSYyK.Contracts).throwIfNullOrWhitespace(region, "region");
        const botFrameworkConfig = new (0, $9Xv9r.DialogServiceConfigImpl)();
        botFrameworkConfig.setProperty((0, $jJjdG.PropertyId).Conversation_DialogType, (0, $9Xv9r.DialogServiceConfig).DialogTypes.BotFramework);
        botFrameworkConfig.setProperty((0, $jJjdG.PropertyId).SpeechServiceConnection_Key, subscription);
        botFrameworkConfig.setProperty((0, $jJjdG.PropertyId).SpeechServiceConnection_Region, region);
        if (botId) botFrameworkConfig.setProperty((0, $jJjdG.PropertyId).Conversation_ApplicationId, botId);
        return botFrameworkConfig;
    }
    /**
     * Creates a bot framework configuration instance for the specified authorization token and region.
     * Note: The caller must ensure that an authorization token is valid. Before an authorization token expires, the
     *       caller must refresh it by setting the authorizationToken property on the corresponding
     *       DialogServiceConnector instance created with this config. The contents of configuration objects are copied
     *       when connectors are created, so setting authorizationToken on a DialogServiceConnector will not update the
     *       original configuration's authorization token. Create a new configuration instance or set the
     *       SpeechServiceAuthorization_Token property to update an existing instance if it will be used to create
     *       further DialogServiceConnectors.
     * @member BotFrameworkConfig.fromAuthorizationToken
     * @function
     * @public
     * @param authorizationToken The authorization token associated with the bot
     * @param region The region name (see the <a href="https://aka.ms/csspeech/region">region page</a>).
     * @param botId Optional. Identifier for using a specific bot within an Azure resource group. Equivalent to the
     *        resource name.
     * @returns {BotFrameworkConfig} A new bot framework configuration instance.
     */ static fromAuthorizationToken(authorizationToken, region, botId) {
        (0, $gSYyK.Contracts).throwIfNullOrWhitespace(authorizationToken, "authorizationToken");
        (0, $gSYyK.Contracts).throwIfNullOrWhitespace(region, "region");
        const botFrameworkConfig = new (0, $9Xv9r.DialogServiceConfigImpl)();
        botFrameworkConfig.setProperty((0, $jJjdG.PropertyId).Conversation_DialogType, (0, $9Xv9r.DialogServiceConfig).DialogTypes.BotFramework);
        botFrameworkConfig.setProperty((0, $jJjdG.PropertyId).SpeechServiceAuthorization_Token, authorizationToken);
        botFrameworkConfig.setProperty((0, $jJjdG.PropertyId).SpeechServiceConnection_Region, region);
        if (botId) botFrameworkConfig.setProperty((0, $jJjdG.PropertyId).Conversation_ApplicationId, botId);
        return botFrameworkConfig;
    }
    /**
     * Creates an instance of a BotFrameworkConfig.
     * This method is intended only for users who use a non-default service host. The standard resource path will be
     * assumed. For services with a non-standard resource path or no path at all, use fromEndpoint instead.
     * Note: Query parameters are not allowed in the host URI and must be set by other APIs.
     * Note: To use an authorization token with fromHost, use fromHost(URL) and then set the AuthorizationToken
     *       property on the created BotFrameworkConfig instance.
     * Note: Added in version 1.15.0.
     * @member BotFrameworkConfig.fromHost
     * @function
     * @public
     * @param {URL | string} host - If a URL is provided, the fully-qualified host with protocol (e.g.
     *        wss://your.host.com:1234) will be used. If a string is provided, it will be embedded in
     *        wss://{host}.convai.speech.azure.us.
     * @param {string} subscriptionKey - The subscription key. If a subscription key is not specified, an authorization
     *        token must be set.
     * @param botId Optional. Identifier for using a specific bot within an Azure resource group. Equivalent to the
     *        resource name.
     * @returns {BotFrameworkConfig} A new bot framework configuration instance.
     */ static fromHost(host, subscriptionKey, botId) {
        (0, $gSYyK.Contracts).throwIfNullOrUndefined(host, "host");
        const resolvedHost = host instanceof URL ? host : new URL(`wss://${host}.convai.speech.azure.us`);
        (0, $gSYyK.Contracts).throwIfNullOrUndefined(resolvedHost, "resolvedHost");
        const botFrameworkConfig = new (0, $9Xv9r.DialogServiceConfigImpl)();
        botFrameworkConfig.setProperty((0, $jJjdG.PropertyId).Conversation_DialogType, (0, $9Xv9r.DialogServiceConfig).DialogTypes.BotFramework);
        botFrameworkConfig.setProperty((0, $jJjdG.PropertyId).SpeechServiceConnection_Host, resolvedHost.toString());
        if (undefined !== subscriptionKey) botFrameworkConfig.setProperty((0, $jJjdG.PropertyId).SpeechServiceConnection_Key, subscriptionKey);
        return botFrameworkConfig;
    }
    /**
     * Creates an instance of a BotFrameworkConfig.
     * This method is intended only for users who use a non-standard service endpoint or parameters.
     * Note: The query parameters specified in the endpoint URL are not changed, even if they are set by any other APIs.
     * Note: To use authorization token with fromEndpoint, pass an empty string to the subscriptionKey in the
     *       fromEndpoint method, and then set authorizationToken="token" on the created BotFrameworkConfig instance to
     *       use the authorization token.
     * Note: Added in version 1.15.0.
     * @member BotFrameworkConfig.fromEndpoint
     * @function
     * @public
     * @param {URL} endpoint - The service endpoint to connect to.
     * @param {string} subscriptionKey - The subscription key. If a subscription key is not specified, an authorization
     *        token must be set.
     * @returns {BotFrameworkConfig} - A new bot framework configuration instance using the provided endpoint.
     */ static fromEndpoint(endpoint, subscriptionKey) {
        (0, $gSYyK.Contracts).throwIfNull(endpoint, "endpoint");
        const botFrameworkConfig = new (0, $9Xv9r.DialogServiceConfigImpl)();
        botFrameworkConfig.setProperty((0, $jJjdG.PropertyId).Conversation_DialogType, (0, $9Xv9r.DialogServiceConfig).DialogTypes.BotFramework);
        botFrameworkConfig.setProperty((0, $jJjdG.PropertyId).SpeechServiceConnection_Endpoint, endpoint.toString());
        if (undefined !== subscriptionKey) botFrameworkConfig.setProperty((0, $jJjdG.PropertyId).SpeechServiceConnection_Key, subscriptionKey);
        return botFrameworkConfig;
    }
}

});

parcelRequire.register("id7qa", function(module, exports) {

$parcel$export(module.exports, "DialogServiceConnector", () => $036bdba76ffe6d4c$export$9cb1651fa7fc72f4);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.

var $8lV9l = parcelRequire("8lV9l");
parcelRequire("g6k3z");
var $iWV5t = parcelRequire("iWV5t");
var $hRiKl = parcelRequire("hRiKl");
parcelRequire("3KVS5");
var $9MSEb = parcelRequire("9MSEb");

var $gSYyK = parcelRequire("gSYyK");

var $1iUCx = parcelRequire("1iUCx");

var $jJjdG = parcelRequire("jJjdG");
var $036bdba76ffe6d4c$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
class $036bdba76ffe6d4c$export$9cb1651fa7fc72f4 extends (0, $1iUCx.Recognizer) {
    /**
     * Initializes an instance of the DialogServiceConnector.
     * @constructor
     * @param {DialogServiceConfig} dialogConfig - Set of properties to configure this recognizer.
     * @param {AudioConfig} audioConfig - An optional audio config associated with the recognizer
     */ constructor(dialogConfig, audioConfig){
        const dialogServiceConfigImpl = dialogConfig;
        (0, $gSYyK.Contracts).throwIfNull(dialogConfig, "dialogConfig");
        super(audioConfig, dialogServiceConfigImpl.properties, new (0, $8lV9l.DialogConnectionFactory)());
        this.isTurnComplete = true;
        this.privIsDisposed = false;
        this.privProperties = dialogServiceConfigImpl.properties.clone();
        const agentConfig = this.buildAgentConfig();
        this.privReco.agentConfig.set(agentConfig);
    }
    /**
     * Starts a connection to the service.
     * Users can optionally call connect() to manually set up a connection in advance, before starting interactions.
     *
     * Note: On return, the connection might not be ready yet. Please subscribe to the Connected event to
     * be notified when the connection is established.
     * @member DialogServiceConnector.prototype.connect
     * @function
     * @public
     */ connect(cb, err) {
        (0, $9MSEb.marshalPromiseToCallbacks)(this.privReco.connect(), cb, err);
    }
    /**
     * Closes the connection the service.
     * Users can optionally call disconnect() to manually shutdown the connection of the associated DialogServiceConnector.
     *
     * If disconnect() is called during a recognition, recognition will fail and cancel with an error.
     */ disconnect(cb, err) {
        (0, $9MSEb.marshalPromiseToCallbacks)(this.privReco.disconnect(), cb, err);
    }
    /**
     * Gets the authorization token used to communicate with the service.
     * @member DialogServiceConnector.prototype.authorizationToken
     * @function
     * @public
     * @returns {string} Authorization token.
     */ get authorizationToken() {
        return this.properties.getProperty((0, $jJjdG.PropertyId).SpeechServiceAuthorization_Token);
    }
    /**
     * Sets the authorization token used to communicate with the service.
     * @member DialogServiceConnector.prototype.authorizationToken
     * @function
     * @public
     * @param {string} token - Authorization token.
     */ set authorizationToken(token) {
        (0, $gSYyK.Contracts).throwIfNullOrWhitespace(token, "token");
        this.properties.setProperty((0, $jJjdG.PropertyId).SpeechServiceAuthorization_Token, token);
    }
    /**
     * The collection of properties and their values defined for this DialogServiceConnector.
     * @member DialogServiceConnector.prototype.properties
     * @function
     * @public
     * @returns {PropertyCollection} The collection of properties and their values defined for this DialogServiceConnector.
     */ get properties() {
        return this.privProperties;
    }
    /** Gets the template for the activity generated by service from speech.
     * Properties from the template will be stamped on the generated activity.
     * It can be empty
     */ get speechActivityTemplate() {
        return this.properties.getProperty((0, $jJjdG.PropertyId).Conversation_Speech_Activity_Template);
    }
    /** Sets the template for the activity generated by service from speech.
     * Properties from the template will be stamped on the generated activity.
     * It can be null or empty.
     * Note: it has to be a valid Json object.
     */ set speechActivityTemplate(speechActivityTemplate) {
        this.properties.setProperty((0, $jJjdG.PropertyId).Conversation_Speech_Activity_Template, speechActivityTemplate);
    }
    /**
     * Starts recognition and stops after the first utterance is recognized.
     * @member DialogServiceConnector.prototype.listenOnceAsync
     * @function
     * @public
     * @param cb - Callback that received the result when the reco has completed.
     * @param err - Callback invoked in case of an error.
     */ listenOnceAsync(cb, err) {
        if (this.isTurnComplete) {
            (0, $gSYyK.Contracts).throwIfDisposed(this.privIsDisposed);
            const callbackHolder = ()=>$036bdba76ffe6d4c$var$__awaiter(this, void 0, void 0, function*() {
                    yield this.privReco.connect();
                    yield this.implRecognizerStop();
                    this.isTurnComplete = false;
                    const ret = new (0, $9MSEb.Deferred)();
                    yield this.privReco.recognize((0, $iWV5t.RecognitionMode).Conversation, ret.resolve, ret.reject);
                    const e = yield ret.promise;
                    yield this.implRecognizerStop();
                    return e;
                });
            const retPromise = callbackHolder();
            retPromise.catch(()=>{
                // Destroy the recognizer.
                /* tslint:disable:no-empty */ // We've done all we can here.
                this.dispose(true).catch(()=>{});
            });
            (0, $9MSEb.marshalPromiseToCallbacks)(retPromise.finally(()=>{
                this.isTurnComplete = true;
            }), cb, err);
        }
    }
    sendActivityAsync(activity, cb, errCb) {
        (0, $9MSEb.marshalPromiseToCallbacks)(this.privReco.sendMessage(activity), cb, errCb);
    }
    /**
     * closes all external resources held by an instance of this class.
     * @member DialogServiceConnector.prototype.close
     * @function
     * @public
     */ close(cb, err) {
        (0, $gSYyK.Contracts).throwIfDisposed(this.privIsDisposed);
        (0, $9MSEb.marshalPromiseToCallbacks)(this.dispose(true), cb, err);
    }
    dispose(disposing) {
        const _super = Object.create(null, {
            dispose: {
                get: ()=>super.dispose
            }
        });
        return $036bdba76ffe6d4c$var$__awaiter(this, void 0, void 0, function*() {
            if (this.privIsDisposed) return;
            if (disposing) {
                this.privIsDisposed = true;
                yield this.implRecognizerStop();
                yield _super.dispose.call(this, disposing);
            }
        });
    }
    createRecognizerConfig(speechConfig) {
        return new (0, $iWV5t.RecognizerConfig)(speechConfig, this.privProperties);
    }
    createServiceRecognizer(authentication, connectionFactory, audioConfig, recognizerConfig) {
        const audioSource = audioConfig;
        return new (0, $hRiKl.DialogServiceAdapter)(authentication, connectionFactory, audioSource, recognizerConfig, this);
    }
    buildAgentConfig() {
        const communicationType = this.properties.getProperty("Conversation_Communication_Type", "Default");
        return {
            botInfo: {
                commType: communicationType,
                commandsCulture: undefined,
                connectionId: this.properties.getProperty((0, $jJjdG.PropertyId).Conversation_Agent_Connection_Id),
                conversationId: this.properties.getProperty((0, $jJjdG.PropertyId).Conversation_Conversation_Id, undefined),
                fromId: this.properties.getProperty((0, $jJjdG.PropertyId).Conversation_From_Id, undefined),
                ttsAudioFormat: this.properties.getProperty((0, $jJjdG.PropertyId).SpeechServiceConnection_SynthOutputFormat, undefined)
            },
            version: 0.2
        };
    }
}

});
parcelRequire.register("8lV9l", function(module, exports) {

$parcel$export(module.exports, "DialogConnectionFactory", () => $614c9da83bbbd787$export$89137e0f16048078);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
parcelRequire("if2Nv");
var $71kSu = parcelRequire("71kSu");
var $2g5X6 = parcelRequire("2g5X6");

var $g6k3z = parcelRequire("g6k3z");

var $9Xv9r = parcelRequire("9Xv9r");
var $5tg4o = parcelRequire("5tg4o");
var $jJjdG = parcelRequire("jJjdG");

var $gNVb9 = parcelRequire("gNVb9");
parcelRequire("g6k3z");
var $dLS1h = parcelRequire("dLS1h");

var $2V1Xw = parcelRequire("2V1Xw");

var $6zhmZ = parcelRequire("6zhmZ");
var $614c9da83bbbd787$var$_a;
class $614c9da83bbbd787$export$89137e0f16048078 extends (0, $gNVb9.ConnectionFactoryBase) {
    constructor(){
        super(...arguments);
        this.create = (config, authInfo, connectionId)=>{
            const applicationId = config.parameters.getProperty((0, $jJjdG.PropertyId).Conversation_ApplicationId, "");
            const dialogType = config.parameters.getProperty((0, $jJjdG.PropertyId).Conversation_DialogType);
            const region = config.parameters.getProperty((0, $jJjdG.PropertyId).SpeechServiceConnection_Region);
            const language = config.parameters.getProperty((0, $jJjdG.PropertyId).SpeechServiceConnection_RecoLanguage, "en-US");
            const requestTurnStatus = config.parameters.getProperty((0, $jJjdG.PropertyId).Conversation_Request_Bot_Status_Messages, "true");
            const queryParams = {};
            queryParams[(0, $2V1Xw.HeaderNames).ConnectionId] = connectionId;
            queryParams[(0, $6zhmZ.QueryParameterNames).Format] = config.parameters.getProperty((0, $g6k3z.OutputFormatPropertyName), (0, $5tg4o.OutputFormat)[(0, $5tg4o.OutputFormat).Simple]).toLowerCase();
            queryParams[(0, $6zhmZ.QueryParameterNames).Language] = language;
            queryParams[(0, $6zhmZ.QueryParameterNames).RequestBotStatusMessages] = requestTurnStatus;
            if (applicationId) {
                queryParams[(0, $6zhmZ.QueryParameterNames).BotId] = applicationId;
                if (dialogType === (0, $9Xv9r.DialogServiceConfig).DialogTypes.CustomCommands) queryParams[(0, $2V1Xw.HeaderNames).CustomCommandsAppId] = applicationId;
            }
            const resourceInfix = dialogType === (0, $9Xv9r.DialogServiceConfig).DialogTypes.CustomCommands ? "commands/" : "";
            const version = dialogType === (0, $9Xv9r.DialogServiceConfig).DialogTypes.CustomCommands ? "v1" : dialogType === (0, $9Xv9r.DialogServiceConfig).DialogTypes.BotFramework ? "v3" : "v0";
            const headers = {};
            if (authInfo.token != null && authInfo.token !== "") headers[authInfo.headerName] = authInfo.token;
            // The URL used for connection is chosen in a priority order of specification:
            //  1. If a custom endpoint is provided, that URL is used verbatim.
            //  2. If a custom host is provided (e.g. "wss://my.custom.endpoint.com:1123"), a URL is constructed from it.
            //  3. If no custom connection details are provided, a URL is constructed from default values.
            let endpoint = config.parameters.getProperty((0, $jJjdG.PropertyId).SpeechServiceConnection_Endpoint, "");
            if (!endpoint) {
                const hostSuffix = region && region.toLowerCase().startsWith("china") ? ".azure.cn" : ".microsoft.com";
                const host = config.parameters.getProperty((0, $jJjdG.PropertyId).SpeechServiceConnection_Host, `wss://${region}.${$614c9da83bbbd787$export$89137e0f16048078.Constants.BaseUrl}${hostSuffix}`);
                const standardizedHost = host.endsWith("/") ? host : host + "/";
                endpoint = `${standardizedHost}${resourceInfix}${$614c9da83bbbd787$export$89137e0f16048078.Constants.ApiKey}/${version}`;
            }
            this.setCommonUrlParams(config, queryParams, endpoint);
            const enableCompression = config.parameters.getProperty("SPEECH-EnableWebsocketCompression", "false") === "true";
            return new (0, $71kSu.WebsocketConnection)(endpoint, queryParams, headers, new (0, $dLS1h.WebsocketMessageFormatter)(), (0, $2g5X6.ProxyInfo).fromRecognizerConfig(config), enableCompression, connectionId);
        };
    }
}
$614c9da83bbbd787$export$89137e0f16048078.Constants = ($614c9da83bbbd787$var$_a = class {
}, $614c9da83bbbd787$var$_a.ApiKey = "api", $614c9da83bbbd787$var$_a.BaseUrl = "convai.speech", $614c9da83bbbd787$var$_a);

});
parcelRequire.register("gNVb9", function(module, exports) {

$parcel$export(module.exports, "ConnectionFactoryBase", () => $c3bd937f7417e100$export$7cee44a940f2294a);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.

var $g6k3z = parcelRequire("g6k3z");

var $jJjdG = parcelRequire("jJjdG");

var $6zhmZ = parcelRequire("6zhmZ");
class $c3bd937f7417e100$export$7cee44a940f2294a {
    setCommonUrlParams(config, queryParams, endpoint) {
        this.setUrlParameter((0, $jJjdG.PropertyId).SpeechServiceConnection_EnableAudioLogging, (0, $6zhmZ.QueryParameterNames).EnableAudioLogging, config, queryParams, endpoint);
        this.setUrlParameter((0, $jJjdG.PropertyId).SpeechServiceResponse_RequestWordLevelTimestamps, (0, $6zhmZ.QueryParameterNames).EnableWordLevelTimestamps, config, queryParams, endpoint);
        this.setUrlParameter((0, $jJjdG.PropertyId).SpeechServiceResponse_ProfanityOption, (0, $6zhmZ.QueryParameterNames).Profanity, config, queryParams, endpoint);
        this.setUrlParameter((0, $jJjdG.PropertyId).SpeechServiceConnection_InitialSilenceTimeoutMs, (0, $6zhmZ.QueryParameterNames).InitialSilenceTimeoutMs, config, queryParams, endpoint);
        this.setUrlParameter((0, $jJjdG.PropertyId).SpeechServiceConnection_EndSilenceTimeoutMs, (0, $6zhmZ.QueryParameterNames).EndSilenceTimeoutMs, config, queryParams, endpoint);
        this.setUrlParameter((0, $jJjdG.PropertyId).SpeechServiceResponse_StablePartialResultThreshold, (0, $6zhmZ.QueryParameterNames).StableIntermediateThreshold, config, queryParams, endpoint);
        const serviceProperties = JSON.parse(config.parameters.getProperty((0, $g6k3z.ServicePropertiesPropertyName), "{}"));
        Object.keys(serviceProperties).forEach((value, num, array)=>{
            queryParams[value] = serviceProperties[value];
        });
    }
    setUrlParameter(propId, parameterName, config, queryParams, endpoint) {
        const value = config.parameters.getProperty(propId, undefined);
        if (value && (!endpoint || endpoint.search(parameterName) === -1)) queryParams[parameterName] = value.toLocaleLowerCase();
    }
}

});
parcelRequire.register("6zhmZ", function(module, exports) {

$parcel$export(module.exports, "QueryParameterNames", () => $4c837c3acac9a710$export$cb816fe21be94f3);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
class $4c837c3acac9a710$export$cb816fe21be94f3 {
}
$4c837c3acac9a710$export$cb816fe21be94f3.BotId = "botid";
$4c837c3acac9a710$export$cb816fe21be94f3.CustomSpeechDeploymentId = "cid";
$4c837c3acac9a710$export$cb816fe21be94f3.CustomVoiceDeploymentId = "deploymentId";
$4c837c3acac9a710$export$cb816fe21be94f3.EnableAudioLogging = "storeAudio";
$4c837c3acac9a710$export$cb816fe21be94f3.EnableLanguageId = "lidEnabled";
$4c837c3acac9a710$export$cb816fe21be94f3.EnableWordLevelTimestamps = "wordLevelTimestamps";
$4c837c3acac9a710$export$cb816fe21be94f3.EndSilenceTimeoutMs = "endSilenceTimeoutMs";
$4c837c3acac9a710$export$cb816fe21be94f3.Format = "format";
$4c837c3acac9a710$export$cb816fe21be94f3.InitialSilenceTimeoutMs = "initialSilenceTimeoutMs";
$4c837c3acac9a710$export$cb816fe21be94f3.Language = "language";
$4c837c3acac9a710$export$cb816fe21be94f3.Profanity = "profanity";
$4c837c3acac9a710$export$cb816fe21be94f3.RequestBotStatusMessages = "enableBotMessageStatus";
$4c837c3acac9a710$export$cb816fe21be94f3.StableIntermediateThreshold = "stableIntermediateThreshold";
$4c837c3acac9a710$export$cb816fe21be94f3.StableTranslation = "stableTranslation";
$4c837c3acac9a710$export$cb816fe21be94f3.TestHooks = "testhooks";

});



parcelRequire.register("1iUCx", function(module, exports) {

$parcel$export(module.exports, "Recognizer", () => $0f33649195c6065f$export$d051b53981c4a264);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
parcelRequire("g6k3z");
var $ldYFi = parcelRequire("ldYFi");
var $iWV5t = parcelRequire("iWV5t");
var $a3Tmp = parcelRequire("a3Tmp");
var $2nHY6 = parcelRequire("2nHY6");
parcelRequire("3KVS5");
var $9MSEb = parcelRequire("9MSEb");

var $gSYyK = parcelRequire("gSYyK");

var $jZE2L = parcelRequire("jZE2L");
var $jJjdG = parcelRequire("jJjdG");
var $0f33649195c6065f$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
class $0f33649195c6065f$export$d051b53981c4a264 {
    /**
     * Creates and initializes an instance of a Recognizer
     * @constructor
     * @param {AudioConfig} audioInput - An optional audio input stream associated with the recognizer
     */ constructor(audioConfig, properties, connectionFactory){
        this.audioConfig = audioConfig !== undefined ? audioConfig : (0, $jZE2L.AudioConfig).fromDefaultMicrophoneInput();
        this.privDisposed = false;
        this.privProperties = properties.clone();
        this.privConnectionFactory = connectionFactory;
        this.implCommonRecognizerSetup();
    }
    /**
     * Dispose of associated resources.
     * @member Recognizer.prototype.close
     * @function
     * @public
     */ close(cb, errorCb) {
        (0, $gSYyK.Contracts).throwIfDisposed(this.privDisposed);
        (0, $9MSEb.marshalPromiseToCallbacks)(this.dispose(true), cb, errorCb);
    }
    /**
     * @Internal
     * Internal data member to support fromRecognizer* pattern methods on other classes.
     * Do not use externally, object returned will change without warning or notice.
     */ get internalData() {
        return this.privReco;
    }
    /**
     * This method performs cleanup of resources.
     * The Boolean parameter disposing indicates whether the method is called
     * from Dispose (if disposing is true) or from the finalizer (if disposing is false).
     * Derived classes should override this method to dispose resource if needed.
     * @member Recognizer.prototype.dispose
     * @function
     * @public
     * @param {boolean} disposing - Flag to request disposal.
     */ dispose(disposing) {
        return $0f33649195c6065f$var$__awaiter(this, void 0, void 0, function*() {
            if (this.privDisposed) return;
            this.privDisposed = true;
            if (disposing) {
                if (this.privReco) {
                    yield this.privReco.audioSource.turnOff();
                    yield this.privReco.dispose();
                }
            }
        });
    }
    /**
     * This method returns the current state of the telemetry setting.
     * @member Recognizer.prototype.telemetryEnabled
     * @function
     * @public
     * @returns true if the telemetry is enabled, false otherwise.
     */ static get telemetryEnabled() {
        return (0, $ldYFi.ServiceRecognizerBase).telemetryDataEnabled;
    }
    /**
     * This method globally enables or disables telemetry.
     * @member Recognizer.prototype.enableTelemetry
     * @function
     * @public
     * @param enabled - Global setting for telemetry collection.
     * If set to true, telemetry information like microphone errors,
     * recognition errors are collected and sent to Microsoft.
     * If set to false, no telemetry is sent to Microsoft.
     */ /* tslint:disable:member-ordering */ static enableTelemetry(enabled) {
        (0, $ldYFi.ServiceRecognizerBase).telemetryDataEnabled = enabled;
    }
    // Does the generic recognizer setup that is common across all recognizer types.
    implCommonRecognizerSetup() {
        let osPlatform = typeof window !== "undefined" ? "Browser" : "Node";
        let osName = "unknown";
        let osVersion = "unknown";
        if (typeof navigator !== "undefined") {
            osPlatform = osPlatform + "/" + navigator.platform;
            osName = navigator.userAgent;
            osVersion = navigator.appVersion;
        }
        const recognizerConfig = this.createRecognizerConfig(new (0, $iWV5t.SpeechServiceConfig)(new (0, $iWV5t.Context)(new (0, $iWV5t.OS)(osPlatform, osName, osVersion))));
        this.privReco = this.createServiceRecognizer($0f33649195c6065f$export$d051b53981c4a264.getAuthFromProperties(this.privProperties), this.privConnectionFactory, this.audioConfig, recognizerConfig);
    }
    recognizeOnceAsyncImpl(recognitionMode) {
        return $0f33649195c6065f$var$__awaiter(this, void 0, void 0, function*() {
            (0, $gSYyK.Contracts).throwIfDisposed(this.privDisposed);
            const ret = new (0, $9MSEb.Deferred)();
            yield this.implRecognizerStop();
            yield this.privReco.recognize(recognitionMode, ret.resolve, ret.reject);
            const result = yield ret.promise;
            yield this.implRecognizerStop();
            return result;
        });
    }
    startContinuousRecognitionAsyncImpl(recognitionMode) {
        return $0f33649195c6065f$var$__awaiter(this, void 0, void 0, function*() {
            (0, $gSYyK.Contracts).throwIfDisposed(this.privDisposed);
            yield this.implRecognizerStop();
            yield this.privReco.recognize(recognitionMode, undefined, undefined);
        });
    }
    stopContinuousRecognitionAsyncImpl() {
        return $0f33649195c6065f$var$__awaiter(this, void 0, void 0, function*() {
            (0, $gSYyK.Contracts).throwIfDisposed(this.privDisposed);
            yield this.implRecognizerStop();
        });
    }
    implRecognizerStop() {
        return $0f33649195c6065f$var$__awaiter(this, void 0, void 0, function*() {
            if (this.privReco) yield this.privReco.stopRecognizing();
            return;
        });
    }
    static getAuthFromProperties(properties) {
        const subscriptionKey = properties.getProperty((0, $jJjdG.PropertyId).SpeechServiceConnection_Key, undefined);
        const authentication = subscriptionKey && subscriptionKey !== "" ? new (0, $a3Tmp.CognitiveSubscriptionKeyAuthentication)(subscriptionKey) : new (0, $2nHY6.CognitiveTokenAuthentication)((authFetchEventId)=>{
            const authorizationToken = properties.getProperty((0, $jJjdG.PropertyId).SpeechServiceAuthorization_Token, undefined);
            return Promise.resolve(authorizationToken);
        }, (authFetchEventId)=>{
            const authorizationToken = properties.getProperty((0, $jJjdG.PropertyId).SpeechServiceAuthorization_Token, undefined);
            return Promise.resolve(authorizationToken);
        });
        return authentication;
    }
}

});


parcelRequire.register("7ej26", function(module, exports) {
"use strict";

var $cP3px = parcelRequire("cP3px");

var $jwgnX = parcelRequire("jwgnX");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $54389abf13628c7c$var$_default;

var $54389abf13628c7c$var$_regenerator = $cP3px((parcelRequire("foOOj")));

var $54389abf13628c7c$var$_asyncToGenerator2 = $cP3px((parcelRequire("iV07h")));

var $54389abf13628c7c$var$_classCallCheck2 = $cP3px((parcelRequire("4g3Cu")));

var $54389abf13628c7c$var$_createClass2 = $cP3px((parcelRequire("03avT")));

var $54389abf13628c7c$var$_inherits2 = $cP3px((parcelRequire("aCeLW")));

var $54389abf13628c7c$var$_possibleConstructorReturn2 = $cP3px((parcelRequire("epYPS")));

var $54389abf13628c7c$var$_getPrototypeOf2 = $cP3px((parcelRequire("hbGgl")));

var $5vyQ7 = parcelRequire("5vyQ7");

var $g7sYb = parcelRequire("g7sYb");

var $54389abf13628c7c$var$_createTaskQueue2 = $cP3px((parcelRequire("hXF0h")));

var $54389abf13628c7c$var$_es = $54389abf13628c7c$var$_interopRequireWildcard((parcelRequire("bgEWP")));

var $54389abf13628c7c$var$_playCognitiveServicesStream = $cP3px((parcelRequire("aJZJ6")));

var $54389abf13628c7c$var$_playWhiteNoise = $cP3px((parcelRequire("jBa43")));

var $54389abf13628c7c$var$_SpeechSynthesisAudioStreamUtterance = $cP3px((parcelRequire("3QFt7")));
function $54389abf13628c7c$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($54389abf13628c7c$var$_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $54389abf13628c7c$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || $jwgnX(obj) !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $54389abf13628c7c$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $54389abf13628c7c$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $54389abf13628c7c$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, $54389abf13628c7c$var$_getPrototypeOf2.default)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $54389abf13628c7c$var$_getPrototypeOf2.default)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $54389abf13628c7c$var$_possibleConstructorReturn2.default)(this, result);
    };
}
function $54389abf13628c7c$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $54389abf13628c7c$var$_default(_ref) {
    var audioContext = _ref.audioContext, enableTelemetry = _ref.enableTelemetry, _ref$ponyfill = _ref.ponyfill, ponyfill = _ref$ponyfill === void 0 ? {
        AudioContext: window.AudioContext || window.webkitAudioContext
    } : _ref$ponyfill, recognizer = _ref.recognizer, textNormalization = _ref.textNormalization;
    if (!ponyfill.AudioContext) {
        console.warn("botframework-directlinespeech-sdk: This browser does not support Web Audio API. Speech support is disabled.");
        return function() {
            return {};
        };
    }
    return function() {
        var _createSpeechRecognit = (0, $g7sYb.createSpeechRecognitionPonyfillFromRecognizer)({
            createRecognizer: function createRecognizer() {
                return recognizer;
            },
            enableTelemetry: enableTelemetry,
            looseEvents: true,
            textNormalization: textNormalization
        }), SpeechGrammarList = _createSpeechRecognit.SpeechGrammarList, SpeechRecognition = _createSpeechRecognit.SpeechRecognition;
        if (!audioContext) audioContext = new ponyfill.AudioContext();
        var _createTaskQueue = (0, $54389abf13628c7c$var$_createTaskQueue2.default)(), cancelAll = _createTaskQueue.cancelAll, push = _createTaskQueue.push;
        var SpeechSynthesis = /*#__PURE__*/ function(_EventTarget) {
            (0, $54389abf13628c7c$var$_inherits2.default)(SpeechSynthesis, _EventTarget);
            var _super = $54389abf13628c7c$var$_createSuper(SpeechSynthesis);
            function SpeechSynthesis() {
                (0, $54389abf13628c7c$var$_classCallCheck2.default)(this, SpeechSynthesis);
                return _super.apply(this, arguments);
            }
            (0, $54389abf13628c7c$var$_createClass2.default)(SpeechSynthesis, [
                {
                    key: "cancel",
                    value: function cancel() {
                        cancelAll();
                    } // Returns an empty array.
                },
                {
                    key: "getVoices",
                    value: function getVoices() {
                        return [];
                    }
                },
                {
                    key: "speak",
                    value: function speak(utterance) {
                        var _push = push(function() {
                            var controller = new $5vyQ7.AbortController();
                            var signal = controller.signal;
                            return {
                                abort: controller.abort.bind(controller),
                                result: (0, $54389abf13628c7c$var$_asyncToGenerator2.default)(/*#__PURE__*/ $54389abf13628c7c$var$_regenerator.default.mark(function _callee() {
                                    return $54389abf13628c7c$var$_regenerator.default.wrap(function _callee$(_context) {
                                        while(true)switch(_context.prev = _context.next){
                                            case 0:
                                                utterance.dispatchEvent(new $54389abf13628c7c$var$_es.Event("start"));
                                                _context.prev = 1;
                                                if (!utterance.audioStream) {
                                                    _context.next = 7;
                                                    break;
                                                }
                                                _context.next = 5;
                                                return (0, $54389abf13628c7c$var$_playCognitiveServicesStream.default)(audioContext, utterance.audioStream, {
                                                    signal: signal
                                                });
                                            case 5:
                                                _context.next = 9;
                                                break;
                                            case 7:
                                                _context.next = 9;
                                                return (0, $54389abf13628c7c$var$_playWhiteNoise.default)(audioContext);
                                            case 9:
                                                _context.next = 15;
                                                break;
                                            case 11:
                                                _context.prev = 11;
                                                _context.t0 = _context["catch"](1);
                                                if (!(_context.t0.message !== "aborted")) {
                                                    _context.next = 15;
                                                    break;
                                                }
                                                return _context.abrupt("return", utterance.dispatchEvent(new ErrorEvent(_context.t0)));
                                            case 15:
                                                utterance.dispatchEvent(new $54389abf13628c7c$var$_es.Event("end"));
                                            case 16:
                                            case "end":
                                                return _context.stop();
                                        }
                                    }, _callee, null, [
                                        [
                                            1,
                                            11
                                        ]
                                    ]);
                                }))()
                            };
                        }), result = _push.result; // Catching the error to prevent uncaught promise error due to cancellation.
                        result.catch(function(error) {
                            if (!/^cancelled/i.test(error.message)) throw error;
                        });
                    }
                },
                {
                    key: "onvoiceschanged",
                    get: function get() {
                        return (0, $54389abf13628c7c$var$_es.getEventAttributeValue)(this, "voiceschanged");
                    },
                    set: function set(value) {
                        (0, $54389abf13628c7c$var$_es.setEventAttributeValue)(this, "voiceschanged", value);
                    }
                }
            ]);
            return SpeechSynthesis;
        }($54389abf13628c7c$var$_es.default);
        return {
            SpeechGrammarList: SpeechGrammarList,
            SpeechRecognition: SpeechRecognition,
            speechSynthesis: new SpeechSynthesis(),
            SpeechSynthesisUtterance: $54389abf13628c7c$var$_SpeechSynthesisAudioStreamUtterance.default
        };
    };
}

});
parcelRequire.register("4g3Cu", function(module, exports) {
function $319b76e1a4d482c7$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
module.exports = $319b76e1a4d482c7$var$_classCallCheck, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRequire.register("03avT", function(module, exports) {
function $00986fa914e591e9$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $00986fa914e591e9$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $00986fa914e591e9$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $00986fa914e591e9$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
module.exports = $00986fa914e591e9$var$_createClass, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRequire.register("aCeLW", function(module, exports) {

var $1lxtv = parcelRequire("1lxtv");
function $7ba8e974a6807b6b$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $1lxtv(subClass, superClass);
}
module.exports = $7ba8e974a6807b6b$var$_inherits, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRequire.register("1lxtv", function(module, exports) {
function $0fb1b805e84fe59f$var$_setPrototypeOf(o, p) {
    module.exports = $0fb1b805e84fe59f$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports;
    return $0fb1b805e84fe59f$var$_setPrototypeOf(o, p);
}
module.exports = $0fb1b805e84fe59f$var$_setPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRequire.register("epYPS", function(module, exports) {

var $jwgnX = parcelRequire("jwgnX");
var $a7f29736c9de71a0$var$_typeof = $jwgnX.default;

var $dCjBO = parcelRequire("dCjBO");
function $a7f29736c9de71a0$var$_possibleConstructorReturn(self, call) {
    if (call && ($a7f29736c9de71a0$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $dCjBO(self);
}
module.exports = $a7f29736c9de71a0$var$_possibleConstructorReturn, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRequire.register("dCjBO", function(module, exports) {
function $9e9e08e356c4911b$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
module.exports = $9e9e08e356c4911b$var$_assertThisInitialized, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRequire.register("hbGgl", function(module, exports) {
function $c8343f3325984651$var$_getPrototypeOf(o) {
    module.exports = $c8343f3325984651$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    }, module.exports.__esModule = true, module.exports["default"] = module.exports;
    return $c8343f3325984651$var$_getPrototypeOf(o);
}
module.exports = $c8343f3325984651$var$_getPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRequire.register("5vyQ7", function(module, exports) {

$parcel$export(module.exports, "AbortController", () => $3e37fcb38e9922ac$export$48f7e099c149af88);

var $bKYE6 = parcelRequire("bKYE6");

var $5VaZn = parcelRequire("5VaZn");

var $13hPS = parcelRequire("13hPS");

var $oEtlu = parcelRequire("oEtlu");

var $juDH3 = parcelRequire("juDH3");

var $hBFcN = parcelRequire("hBFcN");

var $7f1eV = parcelRequire("7f1eV");

var $bzi9N = parcelRequire("bzi9N");

var $8JKeG = parcelRequire("8JKeG");

var $35Nb0 = parcelRequire("35Nb0");

var $6EVuG = parcelRequire("6EVuG");

var $R6zBU = parcelRequire("R6zBU");

var $bUr91 = parcelRequire("bUr91");

var $iPwyO = parcelRequire("iPwyO");

var $aG0Zx = parcelRequire("aG0Zx");

var $lExYg = parcelRequire("lExYg");

var $77Z8P = parcelRequire("77Z8P");

var $erh1S = parcelRequire("erh1S");

var $jR58D = parcelRequire("jR58D");

var $9doz1 = parcelRequire("9doz1");
var $3e37fcb38e9922ac$var$__create = (0, (/*@__PURE__*/$parcel$interopDefault($7f1eV)));
var $3e37fcb38e9922ac$var$__defProp = (0, (/*@__PURE__*/$parcel$interopDefault($bzi9N)));
var $3e37fcb38e9922ac$var$__getOwnPropDesc = (0, (/*@__PURE__*/$parcel$interopDefault($8JKeG)));
var $3e37fcb38e9922ac$var$__getOwnPropNames = (0, (/*@__PURE__*/$parcel$interopDefault($35Nb0)));
var $3e37fcb38e9922ac$var$__getProtoOf = (0, (/*@__PURE__*/$parcel$interopDefault($6EVuG)));
var $3e37fcb38e9922ac$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $3e37fcb38e9922ac$var$__commonJS = function __commonJS(cb, mod) {
    return function __require() {
        return mod || (0, cb[$3e37fcb38e9922ac$var$__getOwnPropNames(cb)[0]])((mod = {
            exports: {}
        }).exports, mod), mod.exports;
    };
};
var $3e37fcb38e9922ac$var$__copyProps = function __copyProps(to, from, except, desc) {
    if (from && (0, (/*@__PURE__*/$parcel$interopDefault($hBFcN)))(from) === "object" || typeof from === "function") {
        var _iterator = (0, (/*@__PURE__*/$parcel$interopDefault($juDH3)))($3e37fcb38e9922ac$var$__getOwnPropNames(from)), _step;
        try {
            var _loop = function _loop() {
                var key = _step.value;
                if (!$3e37fcb38e9922ac$var$__hasOwnProp.call(to, key) && key !== except) $3e37fcb38e9922ac$var$__defProp(to, key, {
                    get: function get() {
                        return from[key];
                    },
                    enumerable: !(desc = $3e37fcb38e9922ac$var$__getOwnPropDesc(from, key)) || desc.enumerable
                });
            };
            for(_iterator.s(); !(_step = _iterator.n()).done;)_loop();
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
    }
    return to;
};
var $3e37fcb38e9922ac$var$__toESM = function __toESM(mod, isNodeMode, target) {
    return target = mod != null ? $3e37fcb38e9922ac$var$__create($3e37fcb38e9922ac$var$__getProtoOf(mod)) : {}, $3e37fcb38e9922ac$var$__copyProps(isNodeMode || !mod || !mod.__esModule ? $3e37fcb38e9922ac$var$__defProp(target, "default", {
        value: mod,
        enumerable: true
    }) : target, mod);
};
// ../abort-controller/node_modules/event-target-shim/dist/event-target-shim.js
var $3e37fcb38e9922ac$var$require_event_target_shim = $3e37fcb38e9922ac$var$__commonJS({
    "../abort-controller/node_modules/event-target-shim/dist/event-target-shim.js": function abortControllerNode_modulesEventTargetShimDistEventTargetShimJs(exports, module) {
        "use strict";
        (0, (/*@__PURE__*/$parcel$interopDefault($bzi9N)))(exports, "__esModule", {
            value: true
        });
        var privateData = /* @__PURE__ */ new (0, (/*@__PURE__*/$parcel$interopDefault($R6zBU)))();
        var wrappers = /* @__PURE__ */ new (0, (/*@__PURE__*/$parcel$interopDefault($R6zBU)))();
        function pd(event) {
            var retv = privateData.get(event);
            console.assert(retv != null, "'this' is expected an Event object, but got", event);
            return retv;
        }
        function setCancelFlag(data) {
            if (data.passiveListener != null) {
                if (typeof console !== "undefined" && typeof console.error === "function") console.error("Unable to preventDefault inside passive event listener invocation.", data.passiveListener);
                return;
            }
            if (!data.event.cancelable) return;
            data.canceled = true;
            if (typeof data.event.preventDefault === "function") data.event.preventDefault();
        }
        function Event(eventTarget, event) {
            privateData.set(this, {
                eventTarget: eventTarget,
                event: event,
                eventPhase: 2,
                currentTarget: eventTarget,
                canceled: false,
                stopped: false,
                immediateStopped: false,
                passiveListener: null,
                timeStamp: event.timeStamp || (0, (/*@__PURE__*/$parcel$interopDefault($bUr91)))()
            });
            (0, (/*@__PURE__*/$parcel$interopDefault($bzi9N)))(this, "isTrusted", {
                value: false,
                enumerable: true
            });
            var keys = (0, (/*@__PURE__*/$parcel$interopDefault($iPwyO)))(event);
            for(var i = 0; i < keys.length; ++i){
                var key = keys[i];
                if (!(key in this)) (0, (/*@__PURE__*/$parcel$interopDefault($bzi9N)))(this, key, defineRedirectDescriptor(key));
            }
        }
        Event.prototype = {
            get type () {
                return pd(this).event.type;
            },
            get target () {
                return pd(this).eventTarget;
            },
            get currentTarget () {
                return pd(this).currentTarget;
            },
            composedPath: function composedPath() {
                var currentTarget = pd(this).currentTarget;
                if (currentTarget == null) return [];
                return [
                    currentTarget
                ];
            },
            get NONE () {
                return 0;
            },
            get CAPTURING_PHASE () {
                return 1;
            },
            get AT_TARGET () {
                return 2;
            },
            get BUBBLING_PHASE () {
                return 3;
            },
            get eventPhase () {
                return pd(this).eventPhase;
            },
            stopPropagation: function stopPropagation() {
                var data = pd(this);
                data.stopped = true;
                if (typeof data.event.stopPropagation === "function") data.event.stopPropagation();
            },
            stopImmediatePropagation: function stopImmediatePropagation() {
                var data = pd(this);
                data.stopped = true;
                data.immediateStopped = true;
                if (typeof data.event.stopImmediatePropagation === "function") data.event.stopImmediatePropagation();
            },
            get bubbles () {
                return Boolean(pd(this).event.bubbles);
            },
            get cancelable () {
                return Boolean(pd(this).event.cancelable);
            },
            preventDefault: function preventDefault() {
                setCancelFlag(pd(this));
            },
            get defaultPrevented () {
                return pd(this).canceled;
            },
            get composed () {
                return Boolean(pd(this).event.composed);
            },
            get timeStamp () {
                return pd(this).timeStamp;
            },
            get srcElement () {
                return pd(this).eventTarget;
            },
            get cancelBubble () {
                return pd(this).stopped;
            },
            set cancelBubble (value){
                if (!value) return;
                var data = pd(this);
                data.stopped = true;
                if (typeof data.event.cancelBubble === "boolean") data.event.cancelBubble = true;
            },
            get returnValue () {
                return !pd(this).canceled;
            },
            set returnValue (value){
                if (!value) setCancelFlag(pd(this));
            },
            initEvent: function initEvent() {}
        };
        (0, (/*@__PURE__*/$parcel$interopDefault($bzi9N)))(Event.prototype, "constructor", {
            value: Event,
            configurable: true,
            writable: true
        });
        if (typeof window !== "undefined" && typeof window.Event !== "undefined") {
            (0, (/*@__PURE__*/$parcel$interopDefault($aG0Zx)))(Event.prototype, window.Event.prototype);
            wrappers.set(window.Event.prototype, Event);
        }
        function defineRedirectDescriptor(key) {
            return {
                get: function get() {
                    return pd(this).event[key];
                },
                set: function set(value1) {
                    pd(this).event[key] = value1;
                },
                configurable: true,
                enumerable: true
            };
        }
        function defineCallDescriptor(key) {
            return {
                value: function value1() {
                    var event = pd(this).event;
                    return event[key].apply(event, arguments);
                },
                configurable: true,
                enumerable: true
            };
        }
        function defineWrapper(BaseEvent, proto) {
            var keys = (0, (/*@__PURE__*/$parcel$interopDefault($iPwyO)))(proto);
            if (keys.length === 0) return BaseEvent;
            function CustomEvent(eventTarget, event) {
                BaseEvent.call(this, eventTarget, event);
            }
            CustomEvent.prototype = (0, (/*@__PURE__*/$parcel$interopDefault($7f1eV)))(BaseEvent.prototype, {
                constructor: {
                    value: CustomEvent,
                    configurable: true,
                    writable: true
                }
            });
            for(var i = 0; i < keys.length; ++i){
                var key = keys[i];
                if (!(key in BaseEvent.prototype)) {
                    var descriptor = (0, (/*@__PURE__*/$parcel$interopDefault($8JKeG)))(proto, key);
                    var isFunc = typeof descriptor.value === "function";
                    (0, (/*@__PURE__*/$parcel$interopDefault($bzi9N)))(CustomEvent.prototype, key, isFunc ? defineCallDescriptor(key) : defineRedirectDescriptor(key));
                }
            }
            return CustomEvent;
        }
        function getWrapper(proto) {
            if (proto == null || proto === Object.prototype) return Event;
            var wrapper = wrappers.get(proto);
            if (wrapper == null) {
                wrapper = defineWrapper(getWrapper((0, (/*@__PURE__*/$parcel$interopDefault($6EVuG)))(proto)), proto);
                wrappers.set(proto, wrapper);
            }
            return wrapper;
        }
        function wrapEvent(eventTarget, event) {
            var Wrapper = getWrapper((0, (/*@__PURE__*/$parcel$interopDefault($6EVuG)))(event));
            return new Wrapper(eventTarget, event);
        }
        function isStopped(event) {
            return pd(event).immediateStopped;
        }
        function setEventPhase(event, eventPhase) {
            pd(event).eventPhase = eventPhase;
        }
        function setCurrentTarget(event, currentTarget) {
            pd(event).currentTarget = currentTarget;
        }
        function setPassiveListener(event, passiveListener) {
            pd(event).passiveListener = passiveListener;
        }
        var listenersMap = /* @__PURE__ */ new (0, (/*@__PURE__*/$parcel$interopDefault($R6zBU)))();
        var CAPTURE = 1;
        var BUBBLE = 2;
        var ATTRIBUTE = 3;
        function isObject(x) {
            return x !== null && (0, (/*@__PURE__*/$parcel$interopDefault($hBFcN)))(x) === "object";
        }
        function getListeners(eventTarget) {
            var listeners = listenersMap.get(eventTarget);
            if (listeners == null) throw new TypeError("'this' is expected an EventTarget object, but got another value.");
            return listeners;
        }
        function defineEventAttributeDescriptor(eventName) {
            return {
                get: function get() {
                    var listeners = getListeners(this);
                    var node = listeners.get(eventName);
                    while(node != null){
                        if (node.listenerType === ATTRIBUTE) return node.listener;
                        node = node.next;
                    }
                    return null;
                },
                set: function set(listener) {
                    if (typeof listener !== "function" && !isObject(listener)) listener = null;
                    var listeners = getListeners(this);
                    var prev = null;
                    var node = listeners.get(eventName);
                    while(node != null){
                        if (node.listenerType === ATTRIBUTE) {
                            if (prev !== null) prev.next = node.next;
                            else if (node.next !== null) listeners.set(eventName, node.next);
                            else listeners["delete"](eventName);
                        } else prev = node;
                        node = node.next;
                    }
                    if (listener !== null) {
                        var newNode = {
                            listener: listener,
                            listenerType: ATTRIBUTE,
                            passive: false,
                            once: false,
                            next: null
                        };
                        if (prev === null) listeners.set(eventName, newNode);
                        else prev.next = newNode;
                    }
                },
                configurable: true,
                enumerable: true
            };
        }
        function defineEventAttribute2(eventTargetPrototype, eventName) {
            (0, (/*@__PURE__*/$parcel$interopDefault($bzi9N)))(eventTargetPrototype, "on".concat(eventName), defineEventAttributeDescriptor(eventName));
        }
        function defineCustomEventTarget(eventNames) {
            function CustomEventTarget() {
                EventTarget2.call(this);
            }
            CustomEventTarget.prototype = (0, (/*@__PURE__*/$parcel$interopDefault($7f1eV)))(EventTarget2.prototype, {
                constructor: {
                    value: CustomEventTarget,
                    configurable: true,
                    writable: true
                }
            });
            for(var i = 0; i < eventNames.length; ++i)defineEventAttribute2(CustomEventTarget.prototype, eventNames[i]);
            return CustomEventTarget;
        }
        function EventTarget2() {
            if (this instanceof EventTarget2) {
                listenersMap.set(this, /* @__PURE__ */ new (0, (/*@__PURE__*/$parcel$interopDefault($lExYg)))());
                return;
            }
            if (arguments.length === 1 && (0, (/*@__PURE__*/$parcel$interopDefault($77Z8P)))(arguments[0])) return defineCustomEventTarget(arguments[0]);
            if (arguments.length > 0) {
                var types = new Array(arguments.length);
                for(var i = 0; i < arguments.length; ++i)types[i] = arguments[i];
                return defineCustomEventTarget(types);
            }
            throw new TypeError("Cannot call a class as a function");
        }
        EventTarget2.prototype = {
            addEventListener: function addEventListener(eventName, listener, options) {
                if (listener == null) return;
                if (typeof listener !== "function" && !isObject(listener)) throw new TypeError("'listener' should be a function or an object.");
                var listeners = getListeners(this);
                var optionsIsObj = isObject(options);
                var capture = optionsIsObj ? Boolean(options.capture) : Boolean(options);
                var listenerType = capture ? CAPTURE : BUBBLE;
                var newNode = {
                    listener: listener,
                    listenerType: listenerType,
                    passive: optionsIsObj && Boolean(options.passive),
                    once: optionsIsObj && Boolean(options.once),
                    next: null
                };
                var node = listeners.get(eventName);
                if (node === void 0) {
                    listeners.set(eventName, newNode);
                    return;
                }
                var prev = null;
                while(node != null){
                    if (node.listener === listener && node.listenerType === listenerType) return;
                    prev = node;
                    node = node.next;
                }
                prev.next = newNode;
            },
            removeEventListener: function removeEventListener(eventName, listener, options) {
                if (listener == null) return;
                var listeners = getListeners(this);
                var capture = isObject(options) ? Boolean(options.capture) : Boolean(options);
                var listenerType = capture ? CAPTURE : BUBBLE;
                var prev = null;
                var node = listeners.get(eventName);
                while(node != null){
                    if (node.listener === listener && node.listenerType === listenerType) {
                        if (prev !== null) prev.next = node.next;
                        else if (node.next !== null) listeners.set(eventName, node.next);
                        else listeners["delete"](eventName);
                        return;
                    }
                    prev = node;
                    node = node.next;
                }
            },
            dispatchEvent: function dispatchEvent(event) {
                if (event == null || typeof event.type !== "string") throw new TypeError('"event.type" should be a string.');
                var listeners = getListeners(this);
                var eventName = event.type;
                var node = listeners.get(eventName);
                if (node == null) return true;
                var wrappedEvent = wrapEvent(this, event);
                var prev = null;
                while(node != null){
                    if (node.once) {
                        if (prev !== null) prev.next = node.next;
                        else if (node.next !== null) listeners.set(eventName, node.next);
                        else listeners["delete"](eventName);
                    } else prev = node;
                    setPassiveListener(wrappedEvent, node.passive ? node.listener : null);
                    if (typeof node.listener === "function") try {
                        node.listener.call(this, wrappedEvent);
                    } catch (err) {
                        if (typeof console !== "undefined" && typeof console.error === "function") console.error(err);
                    }
                    else if (node.listenerType !== ATTRIBUTE && typeof node.listener.handleEvent === "function") node.listener.handleEvent(wrappedEvent);
                    if (isStopped(wrappedEvent)) break;
                    node = node.next;
                }
                setPassiveListener(wrappedEvent, null);
                setEventPhase(wrappedEvent, 0);
                setCurrentTarget(wrappedEvent, null);
                return !wrappedEvent.defaultPrevented;
            }
        };
        (0, (/*@__PURE__*/$parcel$interopDefault($bzi9N)))(EventTarget2.prototype, "constructor", {
            value: EventTarget2,
            configurable: true,
            writable: true
        });
        if (typeof window !== "undefined" && typeof window.EventTarget !== "undefined") (0, (/*@__PURE__*/$parcel$interopDefault($aG0Zx)))(EventTarget2.prototype, window.EventTarget.prototype);
        exports.defineEventAttribute = defineEventAttribute2;
        exports.EventTarget = EventTarget2;
        exports["default"] = EventTarget2;
        module.exports = EventTarget2;
        module.exports.EventTarget = module.exports["default"] = EventTarget2;
        module.exports.defineEventAttribute = defineEventAttribute2;
    }
});
// ../abort-controller/dist/abort-controller.mjs
var $3e37fcb38e9922ac$var$import_event_target_shim = $3e37fcb38e9922ac$var$__toESM($3e37fcb38e9922ac$var$require_event_target_shim(), 1);
var $3e37fcb38e9922ac$var$AbortSignal = /*#__PURE__*/ function(_import_event_target_) {
    (0, (/*@__PURE__*/$parcel$interopDefault($13hPS)))(AbortSignal, _import_event_target_);
    var _super = (0, (/*@__PURE__*/$parcel$interopDefault($oEtlu)))(AbortSignal);
    function AbortSignal() {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($bKYE6)))(this, AbortSignal);
        _this = _super.call(this);
        throw new TypeError("AbortSignal cannot be constructed directly");
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($5VaZn)))(AbortSignal, [
        {
            key: "aborted",
            get: function get() {
                var aborted = $3e37fcb38e9922ac$var$abortedFlags.get(this);
                if (typeof aborted !== "boolean") throw new TypeError("Expected 'this' to be an 'AbortSignal' object, but got ".concat(this === null ? "null" : (0, (/*@__PURE__*/$parcel$interopDefault($hBFcN)))(this)));
                return aborted;
            }
        }
    ]);
    return AbortSignal;
}($3e37fcb38e9922ac$var$import_event_target_shim.EventTarget);
(0, $3e37fcb38e9922ac$var$import_event_target_shim.defineEventAttribute)($3e37fcb38e9922ac$var$AbortSignal.prototype, "abort");
function $3e37fcb38e9922ac$var$createAbortSignal() {
    var signal = (0, (/*@__PURE__*/$parcel$interopDefault($7f1eV)))($3e37fcb38e9922ac$var$AbortSignal.prototype);
    $3e37fcb38e9922ac$var$import_event_target_shim.EventTarget.call(signal);
    $3e37fcb38e9922ac$var$abortedFlags.set(signal, false);
    return signal;
}
function $3e37fcb38e9922ac$var$abortSignal(signal) {
    if ($3e37fcb38e9922ac$var$abortedFlags.get(signal) !== false) return;
    $3e37fcb38e9922ac$var$abortedFlags.set(signal, true);
    signal.dispatchEvent({
        type: "abort"
    });
}
var $3e37fcb38e9922ac$var$abortedFlags = /* @__PURE__ */ new (0, (/*@__PURE__*/$parcel$interopDefault($R6zBU)))();
(0, (/*@__PURE__*/$parcel$interopDefault($erh1S)))($3e37fcb38e9922ac$var$AbortSignal.prototype, {
    aborted: {
        enumerable: true
    }
});
if (typeof (0, (/*@__PURE__*/$parcel$interopDefault($jR58D))) === "function" && (0, (/*@__PURE__*/$parcel$interopDefault($hBFcN)))((0, (/*@__PURE__*/$parcel$interopDefault($9doz1)))) === "symbol") (0, (/*@__PURE__*/$parcel$interopDefault($bzi9N)))($3e37fcb38e9922ac$var$AbortSignal.prototype, (0, (/*@__PURE__*/$parcel$interopDefault($9doz1))), {
    configurable: true,
    value: "AbortSignal"
});
var $3e37fcb38e9922ac$var$AbortController = /*#__PURE__*/ function() {
    function AbortController() {
        (0, (/*@__PURE__*/$parcel$interopDefault($bKYE6)))(this, AbortController);
        $3e37fcb38e9922ac$var$signals.set(this, $3e37fcb38e9922ac$var$createAbortSignal());
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($5VaZn)))(AbortController, [
        {
            key: "signal",
            get: function get() {
                return $3e37fcb38e9922ac$var$getSignal(this);
            }
        },
        {
            key: "abort",
            value: function abort() {
                $3e37fcb38e9922ac$var$abortSignal($3e37fcb38e9922ac$var$getSignal(this));
            }
        }
    ]);
    return AbortController;
}();
var $3e37fcb38e9922ac$var$signals = /* @__PURE__ */ new (0, (/*@__PURE__*/$parcel$interopDefault($R6zBU)))();
function $3e37fcb38e9922ac$var$getSignal(controller) {
    var signal = $3e37fcb38e9922ac$var$signals.get(controller);
    if (signal == null) throw new TypeError("Expected 'this' to be an 'AbortController' object, but got ".concat(controller === null ? "null" : (0, (/*@__PURE__*/$parcel$interopDefault($hBFcN)))(controller)));
    return signal;
}
(0, (/*@__PURE__*/$parcel$interopDefault($erh1S)))($3e37fcb38e9922ac$var$AbortController.prototype, {
    signal: {
        enumerable: true
    },
    abort: {
        enumerable: true
    }
});
if (typeof (0, (/*@__PURE__*/$parcel$interopDefault($jR58D))) === "function" && (0, (/*@__PURE__*/$parcel$interopDefault($hBFcN)))((0, (/*@__PURE__*/$parcel$interopDefault($9doz1)))) === "symbol") (0, (/*@__PURE__*/$parcel$interopDefault($bzi9N)))($3e37fcb38e9922ac$var$AbortController.prototype, (0, (/*@__PURE__*/$parcel$interopDefault($9doz1))), {
    configurable: true,
    value: "AbortController"
});
var $3e37fcb38e9922ac$var$abort_controller_default = $3e37fcb38e9922ac$var$AbortController;
// src/index.mjs
var $3e37fcb38e9922ac$var$NativeAbortController = (typeof window === "undefined" ? {} : window).AbortController;
var $3e37fcb38e9922ac$export$48f7e099c149af88 = $3e37fcb38e9922ac$var$NativeAbortController || $3e37fcb38e9922ac$var$abort_controller_default;
var $3e37fcb38e9922ac$var$NativeAbortSignal = (typeof window === "undefined" ? {} : window).AbortSignal;
var $3e37fcb38e9922ac$export$e42c54032314dc1d = $3e37fcb38e9922ac$var$NativeAbortSignal || $3e37fcb38e9922ac$var$AbortSignal;
var $3e37fcb38e9922ac$export$2e2bcd8739ae039 = $3e37fcb38e9922ac$export$48f7e099c149af88;

});
parcelRequire.register("bKYE6", function(module, exports) {
function $88f30898dc779d4d$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
module.exports = $88f30898dc779d4d$var$_classCallCheck, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRequire.register("5VaZn", function(module, exports) {

var $jODSY = parcelRequire("jODSY");

var $kY1PA = parcelRequire("kY1PA");
function $44faccc8b814abb2$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        $jODSY(target, $kY1PA(descriptor.key), descriptor);
    }
}
function $44faccc8b814abb2$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $44faccc8b814abb2$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $44faccc8b814abb2$var$_defineProperties(Constructor, staticProps);
    $jODSY(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
module.exports = $44faccc8b814abb2$var$_createClass, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRequire.register("13hPS", function(module, exports) {

var $1crzi = parcelRequire("1crzi");

var $jODSY = parcelRequire("jODSY");

var $jYEOF = parcelRequire("jYEOF");
function $0c43e80d4ef40ffe$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = $1crzi(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    $jODSY(subClass, "prototype", {
        writable: false
    });
    if (superClass) $jYEOF(subClass, superClass);
}
module.exports = $0c43e80d4ef40ffe$var$_inherits, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRequire.register("jYEOF", function(module, exports) {

var $jwvn9 = parcelRequire("jwvn9");

var $ayKtv = parcelRequire("ayKtv");
function $e8b3482eb0ab46b7$var$_setPrototypeOf(o, p) {
    var _context;
    module.exports = $e8b3482eb0ab46b7$var$_setPrototypeOf = $jwvn9 ? $ayKtv(_context = $jwvn9).call(_context) : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports;
    return $e8b3482eb0ab46b7$var$_setPrototypeOf(o, p);
}
module.exports = $e8b3482eb0ab46b7$var$_setPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRequire.register("ayKtv", function(module, exports) {

module.exports = (parcelRequire("eoy1F"));

});
parcelRequire.register("eoy1F", function(module, exports) {

var $czoow = parcelRequire("czoow");
module.exports = $czoow;

});
parcelRequire.register("czoow", function(module, exports) {

var $aUvWg = parcelRequire("aUvWg");
module.exports = $aUvWg;

});
parcelRequire.register("aUvWg", function(module, exports) {

var $iTq6U = parcelRequire("iTq6U");
module.exports = $iTq6U;

});
parcelRequire.register("iTq6U", function(module, exports) {

var $53bMe = parcelRequire("53bMe");

var $kcmBU = parcelRequire("kcmBU");
var $dc119e0bbfecbe09$var$FunctionPrototype = Function.prototype;
module.exports = function(it) {
    var own = it.bind;
    return it === $dc119e0bbfecbe09$var$FunctionPrototype || $53bMe($dc119e0bbfecbe09$var$FunctionPrototype, it) && own === $dc119e0bbfecbe09$var$FunctionPrototype.bind ? $kcmBU : own;
};

});
parcelRequire.register("kcmBU", function(module, exports) {
parcelRequire("kZvAj");

var $5zMeE = parcelRequire("5zMeE");
module.exports = $5zMeE("Function").bind;

});
parcelRequire.register("kZvAj", function(module, exports) {
// TODO: Remove from `core-js@4`

var $2iwSV = parcelRequire("2iwSV");

var $grreJ = parcelRequire("grreJ");
// `Function.prototype.bind` method
// https://tc39.es/ecma262/#sec-function.prototype.bind
// eslint-disable-next-line es/no-function-prototype-bind -- detection
$2iwSV({
    target: "Function",
    proto: true,
    forced: Function.bind !== $grreJ
}, {
    bind: $grreJ
});

});
parcelRequire.register("grreJ", function(module, exports) {
"use strict";

var $dqhay = parcelRequire("dqhay");

var $f9Leu = parcelRequire("f9Leu");

var $2IxWL = parcelRequire("2IxWL");

var $dj4ij = parcelRequire("dj4ij");

var $iEWV5 = parcelRequire("iEWV5");

var $5ycCS = parcelRequire("5ycCS");
var $bf844b9a17572593$var$$Function = Function;
var $bf844b9a17572593$var$concat = $dqhay([].concat);
var $bf844b9a17572593$var$join = $dqhay([].join);
var $bf844b9a17572593$var$factories = {};
var $bf844b9a17572593$var$construct = function(C, argsLength, args) {
    if (!$dj4ij($bf844b9a17572593$var$factories, argsLength)) {
        for(var list = [], i = 0; i < argsLength; i++)list[i] = "a[" + i + "]";
        $bf844b9a17572593$var$factories[argsLength] = $bf844b9a17572593$var$$Function("C,a", "return new C(" + $bf844b9a17572593$var$join(list, ",") + ")");
    }
    return $bf844b9a17572593$var$factories[argsLength](C, args);
};
// `Function.prototype.bind` method implementation
// https://tc39.es/ecma262/#sec-function.prototype.bind
// eslint-disable-next-line es/no-function-prototype-bind -- detection
module.exports = $5ycCS ? $bf844b9a17572593$var$$Function.bind : function bind(that /* , ...args */ ) {
    var F = $f9Leu(this);
    var Prototype = F.prototype;
    var partArgs = $iEWV5(arguments, 1);
    var boundFunction = function bound() {
        var args = $bf844b9a17572593$var$concat(partArgs, $iEWV5(arguments));
        return this instanceof boundFunction ? $bf844b9a17572593$var$construct(F, args.length, args) : F.apply(that, args);
    };
    if ($2IxWL(Prototype)) boundFunction.prototype = Prototype;
    return boundFunction;
};

});










parcelRequire.register("oEtlu", function(module, exports) {

var $4AdGR = parcelRequire("4AdGR");

var $NVma2 = parcelRequire("NVma2");

var $bDcpl = parcelRequire("bDcpl");

var $2p33d = parcelRequire("2p33d");
function $04a1a2f7087f4856$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $bDcpl();
    return function _createSuperInternal() {
        var Super = $NVma2(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $NVma2(this).constructor;
            result = $4AdGR(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $2p33d(this, result);
    };
}
module.exports = $04a1a2f7087f4856$var$_createSuper, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRequire.register("4AdGR", function(module, exports) {

module.exports = (parcelRequire("kcG94"));

});
parcelRequire.register("kcG94", function(module, exports) {

var $eVOvF = parcelRequire("eVOvF");
module.exports = $eVOvF;

});
parcelRequire.register("eVOvF", function(module, exports) {

var $iwFtS = parcelRequire("iwFtS");
module.exports = $iwFtS;

});
parcelRequire.register("iwFtS", function(module, exports) {

var $lWDc0 = parcelRequire("lWDc0");
module.exports = $lWDc0;

});
parcelRequire.register("lWDc0", function(module, exports) {
parcelRequire("l80Sl");

var $lahb7 = parcelRequire("lahb7");
module.exports = $lahb7.Reflect.construct;

});
parcelRequire.register("l80Sl", function(module, exports) {

var $2iwSV = parcelRequire("2iwSV");

var $7J5vx = parcelRequire("7J5vx");

var $9ujZx = parcelRequire("9ujZx");

var $grreJ = parcelRequire("grreJ");

var $kpyQh = parcelRequire("kpyQh");

var $3CMpt = parcelRequire("3CMpt");

var $2IxWL = parcelRequire("2IxWL");

var $6m5Sk = parcelRequire("6m5Sk");

var $bSIUO = parcelRequire("bSIUO");
var $f61b062c525e40cd$var$nativeConstruct = $7J5vx("Reflect", "construct");
var $f61b062c525e40cd$var$ObjectPrototype = Object.prototype;
var $f61b062c525e40cd$var$push = [].push;
// `Reflect.construct` method
// https://tc39.es/ecma262/#sec-reflect.construct
// MS Edge supports only 2 arguments and argumentsList argument is optional
// FF Nightly sets third argument as `new.target`, but does not create `this` from it
var $f61b062c525e40cd$var$NEW_TARGET_BUG = $bSIUO(function() {
    function F() {}
    return !($f61b062c525e40cd$var$nativeConstruct(function() {}, [], F) instanceof F);
});
var $f61b062c525e40cd$var$ARGS_BUG = !$bSIUO(function() {
    $f61b062c525e40cd$var$nativeConstruct(function() {});
});
var $f61b062c525e40cd$var$FORCED = $f61b062c525e40cd$var$NEW_TARGET_BUG || $f61b062c525e40cd$var$ARGS_BUG;
$2iwSV({
    target: "Reflect",
    stat: true,
    forced: $f61b062c525e40cd$var$FORCED,
    sham: $f61b062c525e40cd$var$FORCED
}, {
    construct: function construct(Target, args /* , newTarget */ ) {
        $kpyQh(Target);
        $3CMpt(args);
        var newTarget = arguments.length < 3 ? Target : $kpyQh(arguments[2]);
        if ($f61b062c525e40cd$var$ARGS_BUG && !$f61b062c525e40cd$var$NEW_TARGET_BUG) return $f61b062c525e40cd$var$nativeConstruct(Target, args, newTarget);
        if (Target == newTarget) {
            // w/o altered newTarget, optimization for 0-4 arguments
            switch(args.length){
                case 0:
                    return new Target();
                case 1:
                    return new Target(args[0]);
                case 2:
                    return new Target(args[0], args[1]);
                case 3:
                    return new Target(args[0], args[1], args[2]);
                case 4:
                    return new Target(args[0], args[1], args[2], args[3]);
            }
            // w/o altered newTarget, lot of arguments case
            var $args = [
                null
            ];
            $9ujZx($f61b062c525e40cd$var$push, $args, args);
            return new ($9ujZx($grreJ, Target, $args))();
        }
        // with altered newTarget, not support built-in constructors
        var proto = newTarget.prototype;
        var instance = $6m5Sk($2IxWL(proto) ? proto : $f61b062c525e40cd$var$ObjectPrototype);
        var result = $9ujZx(Target, instance, args);
        return $2IxWL(result) ? result : instance;
    }
});

});






parcelRequire.register("NVma2", function(module, exports) {

var $jwvn9 = parcelRequire("jwvn9");

var $ayKtv = parcelRequire("ayKtv");

var $djYKm = parcelRequire("djYKm");
function $09611182e12a319d$var$_getPrototypeOf(o) {
    var _context;
    module.exports = $09611182e12a319d$var$_getPrototypeOf = $jwvn9 ? $ayKtv(_context = $djYKm).call(_context) : function _getPrototypeOf(o) {
        return o.__proto__ || $djYKm(o);
    }, module.exports.__esModule = true, module.exports["default"] = module.exports;
    return $09611182e12a319d$var$_getPrototypeOf(o);
}
module.exports = $09611182e12a319d$var$_getPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRequire.register("bDcpl", function(module, exports) {

var $4AdGR = parcelRequire("4AdGR");
function $877cf62325047d15$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !$4AdGR) return false;
    if ($4AdGR.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call($4AdGR(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
module.exports = $877cf62325047d15$var$_isNativeReflectConstruct, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRequire.register("2p33d", function(module, exports) {

var $hBFcN = parcelRequire("hBFcN");
var $1c0048681dd92757$var$_typeof = $hBFcN.default;

var $gMER2 = parcelRequire("gMER2");
function $1c0048681dd92757$var$_possibleConstructorReturn(self, call) {
    if (call && ($1c0048681dd92757$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $gMER2(self);
}
module.exports = $1c0048681dd92757$var$_possibleConstructorReturn, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRequire.register("gMER2", function(module, exports) {
function $c380d1e53e1c3732$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
module.exports = $c380d1e53e1c3732$var$_assertThisInitialized, module.exports.__esModule = true, module.exports["default"] = module.exports;

});



parcelRequire.register("juDH3", function(module, exports) {

var $5XC68 = parcelRequire("5XC68");

var $aoWGW = parcelRequire("aoWGW");

var $6jPy4 = parcelRequire("6jPy4");

var $gANtj = parcelRequire("gANtj");
function $e30f9bf25101ee3f$var$_createForOfIteratorHelper(o, allowArrayLike) {
    var it = typeof $5XC68 !== "undefined" && $aoWGW(o) || o["@@iterator"];
    if (!it) {
        if ($6jPy4(o) || (it = $gANtj(o)) || allowArrayLike && o && typeof o.length === "number") {
            if (it) o = it;
            var i = 0;
            var F = function F() {};
            return {
                s: F,
                n: function n() {
                    if (i >= o.length) return {
                        done: true
                    };
                    return {
                        done: false,
                        value: o[i++]
                    };
                },
                e: function e(_e) {
                    throw _e;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var normalCompletion = true, didErr = false, err;
    return {
        s: function s() {
            it = it.call(o);
        },
        n: function n() {
            var step = it.next();
            normalCompletion = step.done;
            return step;
        },
        e: function e(_e2) {
            didErr = true;
            err = _e2;
        },
        f: function f() {
            try {
                if (!normalCompletion && it["return"] != null) it["return"]();
            } finally{
                if (didErr) throw err;
            }
        }
    };
}
module.exports = $e30f9bf25101ee3f$var$_createForOfIteratorHelper, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRequire.register("35Nb0", function(module, exports) {

module.exports = (parcelRequire("jxMEa"));

});
parcelRequire.register("jxMEa", function(module, exports) {

var $fMVfI = parcelRequire("fMVfI");
module.exports = $fMVfI;

});
parcelRequire.register("fMVfI", function(module, exports) {
parcelRequire("dT4Kp");

var $lahb7 = parcelRequire("lahb7");
var $b7e7bfdd6cf07df2$var$Object = $lahb7.Object;
module.exports = function getOwnPropertyNames(it) {
    return $b7e7bfdd6cf07df2$var$Object.getOwnPropertyNames(it);
};

});
parcelRequire.register("dT4Kp", function(module, exports) {

var $2iwSV = parcelRequire("2iwSV");

var $bSIUO = parcelRequire("bSIUO");

var $aiPMg = parcelRequire("aiPMg");
var $a1c4183145ffd6d7$require$getOwnPropertyNames = $aiPMg.f;
// eslint-disable-next-line es/no-object-getownpropertynames -- required for testing
var $a1c4183145ffd6d7$var$FAILS_ON_PRIMITIVES = $bSIUO(function() {
    return !Object.getOwnPropertyNames(1);
});
// `Object.getOwnPropertyNames` method
// https://tc39.es/ecma262/#sec-object.getownpropertynames
$2iwSV({
    target: "Object",
    stat: true,
    forced: $a1c4183145ffd6d7$var$FAILS_ON_PRIMITIVES
}, {
    getOwnPropertyNames: $a1c4183145ffd6d7$require$getOwnPropertyNames
});

});




parcelRequire.register("6EVuG", function(module, exports) {

module.exports = (parcelRequire("yj0fK"));

});

parcelRequire.register("R6zBU", function(module, exports) {

module.exports = (parcelRequire("aoiC8"));

});
parcelRequire.register("aoiC8", function(module, exports) {

var $gGkus = parcelRequire("gGkus");
parcelRequire("a8ZHm");
module.exports = $gGkus;

});
parcelRequire.register("gGkus", function(module, exports) {
parcelRequire("7V1Sz");
parcelRequire("evDrA");
parcelRequire("15V79");

var $lahb7 = parcelRequire("lahb7");
module.exports = $lahb7.WeakMap;

});
parcelRequire.register("15V79", function(module, exports) {
// TODO: Remove this module from `core-js@4` since it's replaced to module below
parcelRequire("eFxvi");

});
parcelRequire.register("eFxvi", function(module, exports) {
"use strict";

var $7uphW = parcelRequire("7uphW");

var $bbWQF = parcelRequire("bbWQF");

var $dqhay = parcelRequire("dqhay");

var $fzeJb = parcelRequire("fzeJb");

var $iRUf8 = parcelRequire("iRUf8");

var $423rT = parcelRequire("423rT");

var $d3meb = parcelRequire("d3meb");

var $2IxWL = parcelRequire("2IxWL");

var $cDGcw = parcelRequire("cDGcw");
var $aadee229c1806fd7$require$enforceInternalState = $cDGcw.enforce;

var $bSIUO = parcelRequire("bSIUO");

var $hYhNw = parcelRequire("hYhNw");
var $aadee229c1806fd7$var$$Object = Object;
// eslint-disable-next-line es/no-array-isarray -- safe
var $aadee229c1806fd7$var$isArray = Array.isArray;
// eslint-disable-next-line es/no-object-isextensible -- safe
var $aadee229c1806fd7$var$isExtensible = $aadee229c1806fd7$var$$Object.isExtensible;
// eslint-disable-next-line es/no-object-isfrozen -- safe
var $aadee229c1806fd7$var$isFrozen = $aadee229c1806fd7$var$$Object.isFrozen;
// eslint-disable-next-line es/no-object-issealed -- safe
var $aadee229c1806fd7$var$isSealed = $aadee229c1806fd7$var$$Object.isSealed;
// eslint-disable-next-line es/no-object-freeze -- safe
var $aadee229c1806fd7$var$freeze = $aadee229c1806fd7$var$$Object.freeze;
// eslint-disable-next-line es/no-object-seal -- safe
var $aadee229c1806fd7$var$seal = $aadee229c1806fd7$var$$Object.seal;
var $aadee229c1806fd7$var$FROZEN = {};
var $aadee229c1806fd7$var$SEALED = {};
var $aadee229c1806fd7$var$IS_IE11 = !$bbWQF.ActiveXObject && "ActiveXObject" in $bbWQF;
var $aadee229c1806fd7$var$InternalWeakMap;
var $aadee229c1806fd7$var$wrapper = function(init) {
    return function WeakMap() {
        return init(this, arguments.length ? arguments[0] : undefined);
    };
};
// `WeakMap` constructor
// https://tc39.es/ecma262/#sec-weakmap-constructor
var $aadee229c1806fd7$var$$WeakMap = $423rT("WeakMap", $aadee229c1806fd7$var$wrapper, $d3meb);
var $aadee229c1806fd7$var$WeakMapPrototype = $aadee229c1806fd7$var$$WeakMap.prototype;
var $aadee229c1806fd7$var$nativeSet = $dqhay($aadee229c1806fd7$var$WeakMapPrototype.set);
// Chakra Edge bug: adding frozen arrays to WeakMap unfreeze them
var $aadee229c1806fd7$var$hasMSEdgeFreezingBug = function() {
    return $7uphW && $bSIUO(function() {
        var frozenArray = $aadee229c1806fd7$var$freeze([]);
        $aadee229c1806fd7$var$nativeSet(new $aadee229c1806fd7$var$$WeakMap(), frozenArray, 1);
        return !$aadee229c1806fd7$var$isFrozen(frozenArray);
    });
};
// IE11 WeakMap frozen keys fix
// We can't use feature detection because it crash some old IE builds
// https://github.com/zloirock/core-js/issues/485
if ($hYhNw) {
    if ($aadee229c1806fd7$var$IS_IE11) {
        $aadee229c1806fd7$var$InternalWeakMap = $d3meb.getConstructor($aadee229c1806fd7$var$wrapper, "WeakMap", true);
        $iRUf8.enable();
        var $aadee229c1806fd7$var$nativeDelete = $dqhay($aadee229c1806fd7$var$WeakMapPrototype["delete"]);
        var $aadee229c1806fd7$var$nativeHas = $dqhay($aadee229c1806fd7$var$WeakMapPrototype.has);
        var $aadee229c1806fd7$var$nativeGet = $dqhay($aadee229c1806fd7$var$WeakMapPrototype.get);
        $fzeJb($aadee229c1806fd7$var$WeakMapPrototype, {
            "delete": function(key) {
                if ($2IxWL(key) && !$aadee229c1806fd7$var$isExtensible(key)) {
                    var state = $aadee229c1806fd7$require$enforceInternalState(this);
                    if (!state.frozen) state.frozen = new $aadee229c1806fd7$var$InternalWeakMap();
                    return $aadee229c1806fd7$var$nativeDelete(this, key) || state.frozen["delete"](key);
                }
                return $aadee229c1806fd7$var$nativeDelete(this, key);
            },
            has: function has(key) {
                if ($2IxWL(key) && !$aadee229c1806fd7$var$isExtensible(key)) {
                    var state = $aadee229c1806fd7$require$enforceInternalState(this);
                    if (!state.frozen) state.frozen = new $aadee229c1806fd7$var$InternalWeakMap();
                    return $aadee229c1806fd7$var$nativeHas(this, key) || state.frozen.has(key);
                }
                return $aadee229c1806fd7$var$nativeHas(this, key);
            },
            get: function get(key) {
                if ($2IxWL(key) && !$aadee229c1806fd7$var$isExtensible(key)) {
                    var state = $aadee229c1806fd7$require$enforceInternalState(this);
                    if (!state.frozen) state.frozen = new $aadee229c1806fd7$var$InternalWeakMap();
                    return $aadee229c1806fd7$var$nativeHas(this, key) ? $aadee229c1806fd7$var$nativeGet(this, key) : state.frozen.get(key);
                }
                return $aadee229c1806fd7$var$nativeGet(this, key);
            },
            set: function set(key, value) {
                if ($2IxWL(key) && !$aadee229c1806fd7$var$isExtensible(key)) {
                    var state = $aadee229c1806fd7$require$enforceInternalState(this);
                    if (!state.frozen) state.frozen = new $aadee229c1806fd7$var$InternalWeakMap();
                    $aadee229c1806fd7$var$nativeHas(this, key) ? $aadee229c1806fd7$var$nativeSet(this, key, value) : state.frozen.set(key, value);
                } else $aadee229c1806fd7$var$nativeSet(this, key, value);
                return this;
            }
        });
    // Chakra Edge frozen keys fix
    } else if ($aadee229c1806fd7$var$hasMSEdgeFreezingBug()) $fzeJb($aadee229c1806fd7$var$WeakMapPrototype, {
        set: function set(key, value) {
            var arrayIntegrityLevel;
            if ($aadee229c1806fd7$var$isArray(key)) {
                if ($aadee229c1806fd7$var$isFrozen(key)) arrayIntegrityLevel = $aadee229c1806fd7$var$FROZEN;
                else if ($aadee229c1806fd7$var$isSealed(key)) arrayIntegrityLevel = $aadee229c1806fd7$var$SEALED;
            }
            $aadee229c1806fd7$var$nativeSet(this, key, value);
            if (arrayIntegrityLevel == $aadee229c1806fd7$var$FROZEN) $aadee229c1806fd7$var$freeze(key);
            if (arrayIntegrityLevel == $aadee229c1806fd7$var$SEALED) $aadee229c1806fd7$var$seal(key);
            return this;
        }
    });
}

});
parcelRequire.register("7uphW", function(module, exports) {

var $bSIUO = parcelRequire("bSIUO");
module.exports = !$bSIUO(function() {
    // eslint-disable-next-line es/no-object-isextensible, es/no-object-preventextensions -- required for testing
    return Object.isExtensible(Object.preventExtensions({}));
});

});

parcelRequire.register("fzeJb", function(module, exports) {

var $hY10v = parcelRequire("hY10v");
module.exports = function(target, src, options) {
    for(var key in src)if (options && options.unsafe && target[key]) target[key] = src[key];
    else $hY10v(target, key, src[key], options);
    return target;
};

});

parcelRequire.register("iRUf8", function(module, exports) {

var $2iwSV = parcelRequire("2iwSV");

var $dqhay = parcelRequire("dqhay");

var $aBDiK = parcelRequire("aBDiK");

var $2IxWL = parcelRequire("2IxWL");

var $dj4ij = parcelRequire("dj4ij");

var $8wt5F = parcelRequire("8wt5F");
var $dbc8cded1b5fba13$require$defineProperty = $8wt5F.f;

var $aTQ7d = parcelRequire("aTQ7d");

var $aiPMg = parcelRequire("aiPMg");

var $hSq30 = parcelRequire("hSq30");

var $kzqqN = parcelRequire("kzqqN");

var $7uphW = parcelRequire("7uphW");
var $dbc8cded1b5fba13$var$REQUIRED = false;
var $dbc8cded1b5fba13$var$METADATA = $kzqqN("meta");
var $dbc8cded1b5fba13$var$id = 0;
var $dbc8cded1b5fba13$var$setMetadata = function(it) {
    $dbc8cded1b5fba13$require$defineProperty(it, $dbc8cded1b5fba13$var$METADATA, {
        value: {
            objectID: "O" + $dbc8cded1b5fba13$var$id++,
            weakData: {} // weak collections IDs
        }
    });
};
var $dbc8cded1b5fba13$var$fastKey = function(it, create) {
    // return a primitive with prefix
    if (!$2IxWL(it)) return typeof it == "symbol" ? it : (typeof it == "string" ? "S" : "P") + it;
    if (!$dj4ij(it, $dbc8cded1b5fba13$var$METADATA)) {
        // can't set metadata to uncaught frozen object
        if (!$hSq30(it)) return "F";
        // not necessary to add metadata
        if (!create) return "E";
        // add missing metadata
        $dbc8cded1b5fba13$var$setMetadata(it);
    // return object ID
    }
    return it[$dbc8cded1b5fba13$var$METADATA].objectID;
};
var $dbc8cded1b5fba13$var$getWeakData = function(it, create) {
    if (!$dj4ij(it, $dbc8cded1b5fba13$var$METADATA)) {
        // can't set metadata to uncaught frozen object
        if (!$hSq30(it)) return true;
        // not necessary to add metadata
        if (!create) return false;
        // add missing metadata
        $dbc8cded1b5fba13$var$setMetadata(it);
    // return the store of weak collections IDs
    }
    return it[$dbc8cded1b5fba13$var$METADATA].weakData;
};
// add metadata on freeze-family methods calling
var $dbc8cded1b5fba13$var$onFreeze = function(it) {
    if ($7uphW && $dbc8cded1b5fba13$var$REQUIRED && $hSq30(it) && !$dj4ij(it, $dbc8cded1b5fba13$var$METADATA)) $dbc8cded1b5fba13$var$setMetadata(it);
    return it;
};
var $dbc8cded1b5fba13$var$enable = function() {
    $dbc8cded1b5fba13$var$meta.enable = function() {};
    $dbc8cded1b5fba13$var$REQUIRED = true;
    var getOwnPropertyNames = $aTQ7d.f;
    var splice = $dqhay([].splice);
    var test = {};
    test[$dbc8cded1b5fba13$var$METADATA] = 1;
    // prevent exposing of metadata key
    if (getOwnPropertyNames(test).length) {
        $aTQ7d.f = function(it) {
            var result = getOwnPropertyNames(it);
            for(var i = 0, length = result.length; i < length; i++)if (result[i] === $dbc8cded1b5fba13$var$METADATA) {
                splice(result, i, 1);
                break;
            }
            return result;
        };
        $2iwSV({
            target: "Object",
            stat: true,
            forced: true
        }, {
            getOwnPropertyNames: $aiPMg.f
        });
    }
};
var $dbc8cded1b5fba13$var$meta = module.exports = {
    enable: $dbc8cded1b5fba13$var$enable,
    fastKey: $dbc8cded1b5fba13$var$fastKey,
    getWeakData: $dbc8cded1b5fba13$var$getWeakData,
    onFreeze: $dbc8cded1b5fba13$var$onFreeze
};
$aBDiK[$dbc8cded1b5fba13$var$METADATA] = true;

});
parcelRequire.register("hSq30", function(module, exports) {

var $bSIUO = parcelRequire("bSIUO");

var $2IxWL = parcelRequire("2IxWL");

var $gir1t = parcelRequire("gir1t");

var $egu1R = parcelRequire("egu1R");
// eslint-disable-next-line es/no-object-isextensible -- safe
var $d03baf51a9473099$var$$isExtensible = Object.isExtensible;
var $d03baf51a9473099$var$FAILS_ON_PRIMITIVES = $bSIUO(function() {
    $d03baf51a9473099$var$$isExtensible(1);
});
// `Object.isExtensible` method
// https://tc39.es/ecma262/#sec-object.isextensible
module.exports = $d03baf51a9473099$var$FAILS_ON_PRIMITIVES || $egu1R ? function isExtensible(it) {
    if (!$2IxWL(it)) return false;
    if ($egu1R && $gir1t(it) == "ArrayBuffer") return false;
    return $d03baf51a9473099$var$$isExtensible ? $d03baf51a9473099$var$$isExtensible(it) : true;
} : $d03baf51a9473099$var$$isExtensible;

});
parcelRequire.register("egu1R", function(module, exports) {
// FF26- bug: ArrayBuffers are non-extensible, but Object.isExtensible does not report it

var $bSIUO = parcelRequire("bSIUO");
module.exports = $bSIUO(function() {
    if (typeof ArrayBuffer == "function") {
        var buffer = new ArrayBuffer(8);
        // eslint-disable-next-line es/no-object-isextensible, es/no-object-defineproperty -- safe
        if (Object.isExtensible(buffer)) Object.defineProperty(buffer, "a", {
            value: 8
        });
    }
});

});



parcelRequire.register("423rT", function(module, exports) {
"use strict";

var $2iwSV = parcelRequire("2iwSV");

var $bbWQF = parcelRequire("bbWQF");

var $iRUf8 = parcelRequire("iRUf8");

var $bSIUO = parcelRequire("bSIUO");

var $b77ug = parcelRequire("b77ug");

var $gCDer = parcelRequire("gCDer");

var $cAgU5 = parcelRequire("cAgU5");

var $g0TxJ = parcelRequire("g0TxJ");

var $2IxWL = parcelRequire("2IxWL");

var $7dwMK = parcelRequire("7dwMK");

var $8wt5F = parcelRequire("8wt5F");
var $2efa0630eab98e6b$require$defineProperty = $8wt5F.f;

var $9e7Wd = parcelRequire("9e7Wd");
var $2efa0630eab98e6b$require$forEach = $9e7Wd.forEach;

var $awFtp = parcelRequire("awFtp");

var $cDGcw = parcelRequire("cDGcw");
var $2efa0630eab98e6b$var$setInternalState = $cDGcw.set;
var $2efa0630eab98e6b$var$internalStateGetterFor = $cDGcw.getterFor;
module.exports = function(CONSTRUCTOR_NAME, wrapper, common) {
    var IS_MAP = CONSTRUCTOR_NAME.indexOf("Map") !== -1;
    var IS_WEAK = CONSTRUCTOR_NAME.indexOf("Weak") !== -1;
    var ADDER = IS_MAP ? "set" : "add";
    var NativeConstructor = $bbWQF[CONSTRUCTOR_NAME];
    var NativePrototype = NativeConstructor && NativeConstructor.prototype;
    var exported = {};
    var Constructor;
    if (!$awFtp || !$g0TxJ(NativeConstructor) || !(IS_WEAK || NativePrototype.forEach && !$bSIUO(function() {
        new NativeConstructor().entries().next();
    }))) {
        // create collection constructor
        Constructor = common.getConstructor(wrapper, CONSTRUCTOR_NAME, IS_MAP, ADDER);
        $iRUf8.enable();
    } else {
        Constructor = wrapper(function(target, iterable) {
            $2efa0630eab98e6b$var$setInternalState($cAgU5(target, Prototype), {
                type: CONSTRUCTOR_NAME,
                collection: new NativeConstructor()
            });
            if (iterable != undefined) $gCDer(iterable, target[ADDER], {
                that: target,
                AS_ENTRIES: IS_MAP
            });
        });
        var Prototype = Constructor.prototype;
        var getInternalState = $2efa0630eab98e6b$var$internalStateGetterFor(CONSTRUCTOR_NAME);
        $2efa0630eab98e6b$require$forEach([
            "add",
            "clear",
            "delete",
            "forEach",
            "get",
            "has",
            "set",
            "keys",
            "values",
            "entries"
        ], function(KEY) {
            var IS_ADDER = KEY == "add" || KEY == "set";
            if (KEY in NativePrototype && !(IS_WEAK && KEY == "clear")) $b77ug(Prototype, KEY, function(a, b) {
                var collection = getInternalState(this).collection;
                if (!IS_ADDER && IS_WEAK && !$2IxWL(a)) return KEY == "get" ? undefined : false;
                var result = collection[KEY](a === 0 ? 0 : a, b);
                return IS_ADDER ? this : result;
            });
        });
        IS_WEAK || $2efa0630eab98e6b$require$defineProperty(Prototype, "size", {
            configurable: true,
            get: function() {
                return getInternalState(this).collection.size;
            }
        });
    }
    $7dwMK(Constructor, CONSTRUCTOR_NAME, false, true);
    exported[CONSTRUCTOR_NAME] = Constructor;
    $2iwSV({
        global: true,
        forced: true
    }, exported);
    if (!IS_WEAK) common.setStrong(Constructor, CONSTRUCTOR_NAME, IS_MAP);
    return Constructor;
};

});

parcelRequire.register("d3meb", function(module, exports) {
"use strict";

var $dqhay = parcelRequire("dqhay");

var $fzeJb = parcelRequire("fzeJb");

var $iRUf8 = parcelRequire("iRUf8");
var $980ccc1fc24b1568$require$getWeakData = $iRUf8.getWeakData;

var $cAgU5 = parcelRequire("cAgU5");

var $3CMpt = parcelRequire("3CMpt");

var $cp3Nc = parcelRequire("cp3Nc");

var $2IxWL = parcelRequire("2IxWL");

var $gCDer = parcelRequire("gCDer");

var $9e7Wd = parcelRequire("9e7Wd");

var $dj4ij = parcelRequire("dj4ij");

var $cDGcw = parcelRequire("cDGcw");
var $980ccc1fc24b1568$var$setInternalState = $cDGcw.set;
var $980ccc1fc24b1568$var$internalStateGetterFor = $cDGcw.getterFor;
var $980ccc1fc24b1568$var$find = $9e7Wd.find;
var $980ccc1fc24b1568$var$findIndex = $9e7Wd.findIndex;
var $980ccc1fc24b1568$var$splice = $dqhay([].splice);
var $980ccc1fc24b1568$var$id = 0;
// fallback for uncaught frozen keys
var $980ccc1fc24b1568$var$uncaughtFrozenStore = function(state) {
    return state.frozen || (state.frozen = new $980ccc1fc24b1568$var$UncaughtFrozenStore());
};
var $980ccc1fc24b1568$var$UncaughtFrozenStore = function() {
    this.entries = [];
};
var $980ccc1fc24b1568$var$findUncaughtFrozen = function(store, key) {
    return $980ccc1fc24b1568$var$find(store.entries, function(it) {
        return it[0] === key;
    });
};
$980ccc1fc24b1568$var$UncaughtFrozenStore.prototype = {
    get: function(key) {
        var entry = $980ccc1fc24b1568$var$findUncaughtFrozen(this, key);
        if (entry) return entry[1];
    },
    has: function(key) {
        return !!$980ccc1fc24b1568$var$findUncaughtFrozen(this, key);
    },
    set: function(key, value) {
        var entry = $980ccc1fc24b1568$var$findUncaughtFrozen(this, key);
        if (entry) entry[1] = value;
        else this.entries.push([
            key,
            value
        ]);
    },
    "delete": function(key) {
        var index = $980ccc1fc24b1568$var$findIndex(this.entries, function(it) {
            return it[0] === key;
        });
        if (~index) $980ccc1fc24b1568$var$splice(this.entries, index, 1);
        return !!~index;
    }
};
module.exports = {
    getConstructor: function(wrapper, CONSTRUCTOR_NAME, IS_MAP, ADDER) {
        var Constructor = wrapper(function(that, iterable) {
            $cAgU5(that, Prototype);
            $980ccc1fc24b1568$var$setInternalState(that, {
                type: CONSTRUCTOR_NAME,
                id: $980ccc1fc24b1568$var$id++,
                frozen: undefined
            });
            if (!$cp3Nc(iterable)) $gCDer(iterable, that[ADDER], {
                that: that,
                AS_ENTRIES: IS_MAP
            });
        });
        var Prototype = Constructor.prototype;
        var getInternalState = $980ccc1fc24b1568$var$internalStateGetterFor(CONSTRUCTOR_NAME);
        var define = function(that, key, value) {
            var state = getInternalState(that);
            var data = $980ccc1fc24b1568$require$getWeakData($3CMpt(key), true);
            if (data === true) $980ccc1fc24b1568$var$uncaughtFrozenStore(state).set(key, value);
            else data[state.id] = value;
            return that;
        };
        $fzeJb(Prototype, {
            // `{ WeakMap, WeakSet }.prototype.delete(key)` methods
            // https://tc39.es/ecma262/#sec-weakmap.prototype.delete
            // https://tc39.es/ecma262/#sec-weakset.prototype.delete
            "delete": function(key) {
                var state = getInternalState(this);
                if (!$2IxWL(key)) return false;
                var data = $980ccc1fc24b1568$require$getWeakData(key);
                if (data === true) return $980ccc1fc24b1568$var$uncaughtFrozenStore(state)["delete"](key);
                return data && $dj4ij(data, state.id) && delete data[state.id];
            },
            // `{ WeakMap, WeakSet }.prototype.has(key)` methods
            // https://tc39.es/ecma262/#sec-weakmap.prototype.has
            // https://tc39.es/ecma262/#sec-weakset.prototype.has
            has: function has(key) {
                var state = getInternalState(this);
                if (!$2IxWL(key)) return false;
                var data = $980ccc1fc24b1568$require$getWeakData(key);
                if (data === true) return $980ccc1fc24b1568$var$uncaughtFrozenStore(state).has(key);
                return data && $dj4ij(data, state.id);
            }
        });
        $fzeJb(Prototype, IS_MAP ? {
            // `WeakMap.prototype.get(key)` method
            // https://tc39.es/ecma262/#sec-weakmap.prototype.get
            get: function get(key) {
                var state = getInternalState(this);
                if ($2IxWL(key)) {
                    var data = $980ccc1fc24b1568$require$getWeakData(key);
                    if (data === true) return $980ccc1fc24b1568$var$uncaughtFrozenStore(state).get(key);
                    return data ? data[state.id] : undefined;
                }
            },
            // `WeakMap.prototype.set(key, value)` method
            // https://tc39.es/ecma262/#sec-weakmap.prototype.set
            set: function set(key, value) {
                return define(this, key, value);
            }
        } : {
            // `WeakSet.prototype.add(value)` method
            // https://tc39.es/ecma262/#sec-weakset.prototype.add
            add: function add(value) {
                return define(this, value, true);
            }
        });
        return Constructor;
    }
};

});






parcelRequire.register("aG0Zx", function(module, exports) {

module.exports = (parcelRequire("1Y2Sh"));

});

parcelRequire.register("lExYg", function(module, exports) {

module.exports = (parcelRequire("KyBD2"));

});
parcelRequire.register("KyBD2", function(module, exports) {

var $dzjsb = parcelRequire("dzjsb");
parcelRequire("a8ZHm");
module.exports = $dzjsb;

});
parcelRequire.register("dzjsb", function(module, exports) {
parcelRequire("7V1Sz");
parcelRequire("aHzXa");
parcelRequire("evDrA");
parcelRequire("vGpAn");

var $lahb7 = parcelRequire("lahb7");
module.exports = $lahb7.Map;

});
parcelRequire.register("aHzXa", function(module, exports) {
// TODO: Remove this module from `core-js@4` since it's replaced to module below
parcelRequire("6YLKY");

});
parcelRequire.register("6YLKY", function(module, exports) {
"use strict";

var $423rT = parcelRequire("423rT");

var $aqjSV = parcelRequire("aqjSV");
// `Map` constructor
// https://tc39.es/ecma262/#sec-map-objects
$423rT("Map", function(init) {
    return function Map() {
        return init(this, arguments.length ? arguments[0] : undefined);
    };
}, $aqjSV);

});
parcelRequire.register("aqjSV", function(module, exports) {
"use strict";

var $6m5Sk = parcelRequire("6m5Sk");

var $9L6Pl = parcelRequire("9L6Pl");

var $fzeJb = parcelRequire("fzeJb");

var $jjTxh = parcelRequire("jjTxh");

var $cAgU5 = parcelRequire("cAgU5");

var $cp3Nc = parcelRequire("cp3Nc");

var $gCDer = parcelRequire("gCDer");

var $17u0H = parcelRequire("17u0H");

var $9xi7m = parcelRequire("9xi7m");

var $6eNI9 = parcelRequire("6eNI9");

var $awFtp = parcelRequire("awFtp");

var $iRUf8 = parcelRequire("iRUf8");
var $796bc1cf7d82338d$require$fastKey = $iRUf8.fastKey;

var $cDGcw = parcelRequire("cDGcw");
var $796bc1cf7d82338d$var$setInternalState = $cDGcw.set;
var $796bc1cf7d82338d$var$internalStateGetterFor = $cDGcw.getterFor;
module.exports = {
    getConstructor: function(wrapper, CONSTRUCTOR_NAME, IS_MAP, ADDER) {
        var Constructor = wrapper(function(that, iterable) {
            $cAgU5(that, Prototype);
            $796bc1cf7d82338d$var$setInternalState(that, {
                type: CONSTRUCTOR_NAME,
                index: $6m5Sk(null),
                first: undefined,
                last: undefined,
                size: 0
            });
            if (!$awFtp) that.size = 0;
            if (!$cp3Nc(iterable)) $gCDer(iterable, that[ADDER], {
                that: that,
                AS_ENTRIES: IS_MAP
            });
        });
        var Prototype = Constructor.prototype;
        var getInternalState = $796bc1cf7d82338d$var$internalStateGetterFor(CONSTRUCTOR_NAME);
        var define = function(that, key, value) {
            var state = getInternalState(that);
            var entry = getEntry(that, key);
            var previous, index;
            // change existing entry
            if (entry) entry.value = value;
            else {
                state.last = entry = {
                    index: index = $796bc1cf7d82338d$require$fastKey(key, true),
                    key: key,
                    value: value,
                    previous: previous = state.last,
                    next: undefined,
                    removed: false
                };
                if (!state.first) state.first = entry;
                if (previous) previous.next = entry;
                if ($awFtp) state.size++;
                else that.size++;
                // add to index
                if (index !== "F") state.index[index] = entry;
            }
            return that;
        };
        var getEntry = function(that, key) {
            var state = getInternalState(that);
            // fast case
            var index = $796bc1cf7d82338d$require$fastKey(key);
            var entry;
            if (index !== "F") return state.index[index];
            // frozen object case
            for(entry = state.first; entry; entry = entry.next){
                if (entry.key == key) return entry;
            }
        };
        $fzeJb(Prototype, {
            // `{ Map, Set }.prototype.clear()` methods
            // https://tc39.es/ecma262/#sec-map.prototype.clear
            // https://tc39.es/ecma262/#sec-set.prototype.clear
            clear: function clear() {
                var that = this;
                var state = getInternalState(that);
                var data = state.index;
                var entry = state.first;
                while(entry){
                    entry.removed = true;
                    if (entry.previous) entry.previous = entry.previous.next = undefined;
                    delete data[entry.index];
                    entry = entry.next;
                }
                state.first = state.last = undefined;
                if ($awFtp) state.size = 0;
                else that.size = 0;
            },
            // `{ Map, Set }.prototype.delete(key)` methods
            // https://tc39.es/ecma262/#sec-map.prototype.delete
            // https://tc39.es/ecma262/#sec-set.prototype.delete
            "delete": function(key) {
                var that = this;
                var state = getInternalState(that);
                var entry = getEntry(that, key);
                if (entry) {
                    var next = entry.next;
                    var prev = entry.previous;
                    delete state.index[entry.index];
                    entry.removed = true;
                    if (prev) prev.next = next;
                    if (next) next.previous = prev;
                    if (state.first == entry) state.first = next;
                    if (state.last == entry) state.last = prev;
                    if ($awFtp) state.size--;
                    else that.size--;
                }
                return !!entry;
            },
            // `{ Map, Set }.prototype.forEach(callbackfn, thisArg = undefined)` methods
            // https://tc39.es/ecma262/#sec-map.prototype.foreach
            // https://tc39.es/ecma262/#sec-set.prototype.foreach
            forEach: function forEach(callbackfn /* , that = undefined */ ) {
                var state = getInternalState(this);
                var boundFunction = $jjTxh(callbackfn, arguments.length > 1 ? arguments[1] : undefined);
                var entry;
                while(entry = entry ? entry.next : state.first){
                    boundFunction(entry.value, entry.key, this);
                    // revert to the last existing entry
                    while(entry && entry.removed)entry = entry.previous;
                }
            },
            // `{ Map, Set}.prototype.has(key)` methods
            // https://tc39.es/ecma262/#sec-map.prototype.has
            // https://tc39.es/ecma262/#sec-set.prototype.has
            has: function has(key) {
                return !!getEntry(this, key);
            }
        });
        $fzeJb(Prototype, IS_MAP ? {
            // `Map.prototype.get(key)` method
            // https://tc39.es/ecma262/#sec-map.prototype.get
            get: function get(key) {
                var entry = getEntry(this, key);
                return entry && entry.value;
            },
            // `Map.prototype.set(key, value)` method
            // https://tc39.es/ecma262/#sec-map.prototype.set
            set: function set(key, value) {
                return define(this, key === 0 ? 0 : key, value);
            }
        } : {
            // `Set.prototype.add(value)` method
            // https://tc39.es/ecma262/#sec-set.prototype.add
            add: function add(value) {
                return define(this, value = value === 0 ? 0 : value, value);
            }
        });
        if ($awFtp) $9L6Pl(Prototype, "size", {
            configurable: true,
            get: function() {
                return getInternalState(this).size;
            }
        });
        return Constructor;
    },
    setStrong: function(Constructor, CONSTRUCTOR_NAME, IS_MAP) {
        var ITERATOR_NAME = CONSTRUCTOR_NAME + " Iterator";
        var getInternalCollectionState = $796bc1cf7d82338d$var$internalStateGetterFor(CONSTRUCTOR_NAME);
        var getInternalIteratorState = $796bc1cf7d82338d$var$internalStateGetterFor(ITERATOR_NAME);
        // `{ Map, Set }.prototype.{ keys, values, entries, @@iterator }()` methods
        // https://tc39.es/ecma262/#sec-map.prototype.entries
        // https://tc39.es/ecma262/#sec-map.prototype.keys
        // https://tc39.es/ecma262/#sec-map.prototype.values
        // https://tc39.es/ecma262/#sec-map.prototype-@@iterator
        // https://tc39.es/ecma262/#sec-set.prototype.entries
        // https://tc39.es/ecma262/#sec-set.prototype.keys
        // https://tc39.es/ecma262/#sec-set.prototype.values
        // https://tc39.es/ecma262/#sec-set.prototype-@@iterator
        $17u0H(Constructor, CONSTRUCTOR_NAME, function(iterated, kind) {
            $796bc1cf7d82338d$var$setInternalState(this, {
                type: ITERATOR_NAME,
                target: iterated,
                state: getInternalCollectionState(iterated),
                kind: kind,
                last: undefined
            });
        }, function() {
            var state = getInternalIteratorState(this);
            var kind = state.kind;
            var entry = state.last;
            // revert to the last existing entry
            while(entry && entry.removed)entry = entry.previous;
            // get next entry
            if (!state.target || !(state.last = entry = entry ? entry.next : state.state.first)) {
                // or finish the iteration
                state.target = undefined;
                return $9xi7m(undefined, true);
            }
            // return step by kind
            if (kind == "keys") return $9xi7m(entry.key, false);
            if (kind == "values") return $9xi7m(entry.value, false);
            return $9xi7m([
                entry.key,
                entry.value
            ], false);
        }, IS_MAP ? "entries" : "values", !IS_MAP, true);
        // `{ Map, Set }.prototype[@@species]` accessors
        // https://tc39.es/ecma262/#sec-get-map-@@species
        // https://tc39.es/ecma262/#sec-get-set-@@species
        $6eNI9(CONSTRUCTOR_NAME);
    }
};

});






parcelRequire.register("jR58D", function(module, exports) {

module.exports = (parcelRequire("V091A"));

});

parcelRequire.register("9doz1", function(module, exports) {

module.exports = (parcelRequire("9L6ZS"));

});
parcelRequire.register("9L6ZS", function(module, exports) {

var $6jYo6 = parcelRequire("6jYo6");
module.exports = $6jYo6;

});
parcelRequire.register("6jYo6", function(module, exports) {
parcelRequire("fMP2K");
parcelRequire("53Jre");
parcelRequire("evDrA");
parcelRequire("aOnxa");
parcelRequire("1Mz4D");

var $b5crT = parcelRequire("b5crT");
module.exports = $b5crT.f("toStringTag");

});




parcelRequire.register("hXF0h", function(module, exports) {
"use strict";

var $cP3px = parcelRequire("cP3px");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $d137c0cdd57ab1ca$var$createTaskQueue;

var $d137c0cdd57ab1ca$var$_regenerator = $cP3px((parcelRequire("foOOj")));

var $d137c0cdd57ab1ca$var$_asyncToGenerator2 = $cP3px((parcelRequire("iV07h")));

var $d137c0cdd57ab1ca$var$_pDeferEs = $cP3px((parcelRequire("5la41")));
function $d137c0cdd57ab1ca$var$createTaskQueue() {
    var queueWithCurrent = [];
    var queue = {
        cancelAll: function cancelAll() {
            queueWithCurrent.forEach(function(_ref) {
                var cancel = _ref.cancel;
                return cancel();
            });
        },
        push: function push(fn) {
            var cancelDeferred = (0, $d137c0cdd57ab1ca$var$_pDeferEs.default)();
            var resultDeferred = (0, $d137c0cdd57ab1ca$var$_pDeferEs.default)();
            var entry = {
                promise: resultDeferred.promise
            };
            var abort;
            var cancel = entry.cancel = function() {
                // Override the "fn" so we don't call the actual "fn" later.
                // In this approach, we can reuse the logic inside "start" to handle post-cancellation.
                fn = function fn() {
                    return {
                        result: Promise.reject(new Error("cancelled before start"))
                    };
                }; // Abort the task if it is currently running.
                abort && abort();
                cancelDeferred.reject(new Error("cancelled in the midway"));
            };
            var start = /*#__PURE__*/ function() {
                var _ref2 = (0, $d137c0cdd57ab1ca$var$_asyncToGenerator2.default)(/*#__PURE__*/ $d137c0cdd57ab1ca$var$_regenerator.default.mark(function _callee() {
                    var _fn, abortFn, result;
                    return $d137c0cdd57ab1ca$var$_regenerator.default.wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                _fn = fn(), abortFn = _fn.abort, result = _fn.result;
                                abort = abortFn;
                                _context.prev = 2;
                                _context.t0 = resultDeferred;
                                _context.next = 6;
                                return Promise.race([
                                    result,
                                    cancelDeferred.promise
                                ]);
                            case 6:
                                _context.t1 = _context.sent;
                                _context.t0.resolve.call(_context.t0, _context.t1);
                                _context.next = 13;
                                break;
                            case 10:
                                _context.prev = 10;
                                _context.t2 = _context["catch"](2);
                                resultDeferred.reject(_context.t2);
                            case 13:
                                queueWithCurrent = queueWithCurrent.filter(function(e) {
                                    return e !== entry;
                                });
                            case 14:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, null, [
                        [
                            2,
                            10
                        ]
                    ]);
                }));
                return function start() {
                    return _ref2.apply(this, arguments);
                };
            }();
            var lastEntry = queueWithCurrent[queueWithCurrent.length - 1];
            var lastPromise = lastEntry && lastEntry.promise || Promise.resolve();
            queueWithCurrent.push(entry); // After the last promise resolved/rejected, we will start this task.
            // We will start even if the last promise rejected.
            lastPromise.then(start, start);
            return {
                cancel: cancel,
                result: resultDeferred.promise
            };
        }
    };
    Object.defineProperty(queue, "length", {
        get: function get() {
            return queueWithCurrent.length;
        }
    });
    return queue;
}

});

parcelRequire.register("aJZJ6", function(module, exports) {
"use strict";

var $cP3px = parcelRequire("cP3px");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $7d1dfcf591b58136$var$playCognitiveServicesStream;

var $7d1dfcf591b58136$var$_regenerator = $cP3px((parcelRequire("foOOj")));

var $7d1dfcf591b58136$var$_defineProperty2 = $cP3px((parcelRequire("2AzOD")));

var $7d1dfcf591b58136$var$_asyncToGenerator2 = $cP3px((parcelRequire("iV07h")));

var $7d1dfcf591b58136$var$_createMultiBufferingPlayer = $cP3px((parcelRequire("7Jric")));
function $7d1dfcf591b58136$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $7d1dfcf591b58136$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $7d1dfcf591b58136$var$ownKeys(Object(source), !0).forEach(function(key) {
            (0, $7d1dfcf591b58136$var$_defineProperty2.default)(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $7d1dfcf591b58136$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
// Safari requires an audio buffer with a sample rate of 22050 Hz.
// Using a minimum sample rate of 44100 Hz as an example, the Speech SDK's default 16000 Hz will be upsampled to 48000 Hz.
var $7d1dfcf591b58136$var$MIN_SAMPLE_RATE = 44100; // The Speech SDK is hardcoded to chop packets to 4096 bytes.
// Web Chat's multi-buffering player is set up with 3 buffers; each is 4096 bytes (2048 16-bit samples).
// For simplicity, the multi-buffer player currently does not support progressive buffering.
// Progressive buffering allows queuing at any sample size and will be concatenated.
// If 1000 samples are queued, then 1048 samples are queued, they will be concatenated into a single buffer of size 2048.
// For simplicity, data will be queued to two buffers.
// The first buffer is 1000 samples followed by 1048 zeroes, and the second buffer is 1048 samples followed by 1000 zeroes.
// There is no plan to support progressive buffering until the Speech SDK chops data at dynamic size.
var $7d1dfcf591b58136$var$DEFAULT_BUFFER_SIZE = 4096;
function $7d1dfcf591b58136$var$average(array) {
    return array.reduce(function(sum, value) {
        return sum + value;
    }, 0) / array.length;
}
function $7d1dfcf591b58136$var$formatTypedBitArrayToFloatArray(audioData, maxValue) {
    var float32Data = new Float32Array(audioData.length);
    for(var i = 0; i < audioData.length; i++)float32Data[+i] = audioData[+i] / maxValue;
    return float32Data;
}
function $7d1dfcf591b58136$var$formatAudioDataArrayBufferToFloatArray(_ref, arrayBuffer) {
    var bitsPerSample = _ref.bitsPerSample;
    switch(bitsPerSample){
        case 8:
            return $7d1dfcf591b58136$var$formatTypedBitArrayToFloatArray(new Int8Array(arrayBuffer), 128);
        case 16:
            return $7d1dfcf591b58136$var$formatTypedBitArrayToFloatArray(new Int16Array(arrayBuffer), 32768);
        case 32:
            return $7d1dfcf591b58136$var$formatTypedBitArrayToFloatArray(new Int32Array(arrayBuffer), 2147483648);
        default:
            throw new Error("Only WAVE_FORMAT_PCM (8/16/32 bps) format supported at this time");
    }
}
function $7d1dfcf591b58136$var$abortToReject(signal) {
    return new Promise(function(_, reject) {
        signal.onabort = function() {
            return reject(new Error("aborted"));
        };
    });
} // In a 2 channel audio (e.g. A/B), the data arrives as interleaved, like "ABABABABAB".
// This function will take "ABABABABAB" and return an array ["AAAAA", "BBBBB"].
function $7d1dfcf591b58136$var$deinterleave(channelInterleavedAudioData, _ref2) {
    var channels = _ref2.channels;
    var multiChannelArrayBuffer = new Array(channels);
    var frameSize = channelInterleavedAudioData.length / channels;
    for(var channel = 0; channel < channels; channel++){
        var audioData = new Float32Array(frameSize);
        multiChannelArrayBuffer[+channel] = audioData;
        for(var offset = 0; offset < frameSize; offset++)audioData[+offset] = channelInterleavedAudioData[offset * channels + channel];
    }
    return multiChannelArrayBuffer;
} // This function upsamples the audio data via an integer multiplier.
// Web Chat uses simple anti-aliasing. For simplicity, the anti-aliasing does not roll over to next buffer.
function $7d1dfcf591b58136$var$multiplySampleRate(source, sampleRateMultiplier) {
    if (sampleRateMultiplier === 1) return source;
    var lastValues = new Array(sampleRateMultiplier).fill(source[0]);
    var target = new Float32Array(source.length * sampleRateMultiplier);
    for(var sourceOffset = 0; sourceOffset < source.length; sourceOffset++){
        var value = source[+sourceOffset];
        var targetOffset = sourceOffset * sampleRateMultiplier;
        for(var multiplierIndex = 0; multiplierIndex < sampleRateMultiplier; multiplierIndex++){
            lastValues.shift();
            lastValues.push(value);
            target[targetOffset + multiplierIndex] = $7d1dfcf591b58136$var$average(lastValues);
        }
    }
    return target;
}
function $7d1dfcf591b58136$var$playCognitiveServicesStream(_x, _x2) {
    return $7d1dfcf591b58136$var$_playCognitiveServicesStream.apply(this, arguments);
}
function $7d1dfcf591b58136$var$_playCognitiveServicesStream() {
    $7d1dfcf591b58136$var$_playCognitiveServicesStream = (0, $7d1dfcf591b58136$var$_asyncToGenerator2.default)(/*#__PURE__*/ $7d1dfcf591b58136$var$_regenerator.default.mark(function _callee2(audioContext, stream) {
        var _ref3, _ref3$signal, signal, queuedBufferSourceNodes, _args2 = arguments;
        return $7d1dfcf591b58136$var$_regenerator.default.wrap(function _callee2$(_context2) {
            while(true)switch(_context2.prev = _context2.next){
                case 0:
                    _ref3 = _args2.length > 2 && _args2[2] !== undefined ? _args2[2] : {}, _ref3$signal = _ref3.signal, signal = _ref3$signal === void 0 ? {} : _ref3$signal;
                    if (audioContext) {
                        _context2.next = 5;
                        break;
                    }
                    throw new Error("botframework-directlinespeech-sdk: audioContext must be specified.");
                case 5:
                    if (stream) {
                        _context2.next = 9;
                        break;
                    }
                    throw new Error("botframework-directlinespeech-sdk: stream must be specified.");
                case 9:
                    if (stream.format) {
                        _context2.next = 13;
                        break;
                    }
                    throw new Error("botframework-directlinespeech-sdk: stream is missing format.");
                case 13:
                    if (!(typeof stream.read !== "function")) {
                        _context2.next = 15;
                        break;
                    }
                    throw new Error("botframework-directlinespeech-sdk: stream is missing read().");
                case 15:
                    queuedBufferSourceNodes = [];
                    _context2.prev = 16;
                    return _context2.delegateYield(/*#__PURE__*/ $7d1dfcf591b58136$var$_regenerator.default.mark(function _callee() {
                        var format, abortPromise, array, read, samplesPerSec, newSamplesPerSec, sampleRateMultiplier, player, chunk, maxChunks, interleavedArray, multiChannelArray, upsampledMultiChannelArray;
                        return $7d1dfcf591b58136$var$_regenerator.default.wrap(function _callee$(_context) {
                            while(true)switch(_context.prev = _context.next){
                                case 0:
                                    format = stream.format;
                                    abortPromise = $7d1dfcf591b58136$var$abortToReject(signal);
                                    array = new Uint8Array($7d1dfcf591b58136$var$DEFAULT_BUFFER_SIZE);
                                    read = function read() {
                                        return Promise.race([
                                            abortPromise.catch(function() {}),
                                            stream.read(array.buffer).then(function(numBytes) {
                                                return numBytes === array.byteLength ? array : numBytes ? array.slice(0, numBytes) : undefined;
                                            })
                                        ]);
                                    };
                                    if (!signal.aborted) {
                                        _context.next = 6;
                                        break;
                                    }
                                    throw new Error("aborted");
                                case 6:
                                    samplesPerSec = format.samplesPerSec; // TODO: [P0] #3692 Remove the following if-condition block when the underlying bugs are resolved.
                                    //       There is a bug in Speech SDK 1.15.0 that returns 24kHz instead of 16kHz.
                                    //       Even if we explicitly specify the output audio format to 16kHz, there is another bug that ignored it.
                                    //       In short, DLSpeech service currently always streams in RIFF WAV format, instead of MP3.
                                    //       https://github.com/microsoft/cognitive-services-speech-sdk-js/issues/313
                                    //       https://github.com/microsoft/cognitive-services-speech-sdk-js/issues/314
                                    if (format.requestAudioFormatString === "audio-24khz-48kbitrate-mono-mp3") samplesPerSec = 16000;
                                    newSamplesPerSec = samplesPerSec;
                                    sampleRateMultiplier = 1; // Safari requires a minimum sample rate of 22100 Hz.
                                    // A multiplier is calculated the the data meets the minimum sample rate.
                                    // An integer-based multiplier to simplify our upsampler.
                                    // For security, data will only be upsampled up to 96000 Hz.
                                    while(newSamplesPerSec < $7d1dfcf591b58136$var$MIN_SAMPLE_RATE && newSamplesPerSec < 96000){
                                        sampleRateMultiplier++;
                                        newSamplesPerSec = samplesPerSec * sampleRateMultiplier;
                                    } // The third parameter is the sample size in bytes.
                                    // For example, if the Speech SDK sends Web Chat 4096 bytes of 16-bit samples, there will be 2048 samples per channel.
                                    // The multi-buffering player is set up to handle 2048 samples per buffer.
                                    // If the multiplier 3x, it will handle 6144 samples per buffer.
                                    player = (0, $7d1dfcf591b58136$var$_createMultiBufferingPlayer.default)(audioContext, $7d1dfcf591b58136$var$_objectSpread($7d1dfcf591b58136$var$_objectSpread({}, format), {}, {
                                        samplesPerSec: newSamplesPerSec
                                    }), $7d1dfcf591b58136$var$DEFAULT_BUFFER_SIZE / (format.bitsPerSample / 8) * sampleRateMultiplier); // For security, the maximum number of chunks handled will be 1000.
                                    _context.next = 14;
                                    return read();
                                case 14:
                                    chunk = _context.sent;
                                    maxChunks = 0;
                                case 16:
                                    if (!(chunk && maxChunks < 1000 && !signal.aborted)) {
                                        _context.next = 29;
                                        break;
                                    }
                                    if (!signal.aborted) {
                                        _context.next = 19;
                                        break;
                                    }
                                    return _context.abrupt("break", 29);
                                case 19:
                                    // Data received from Speech SDK is interleaved; 2 channels (e.g. A and B) will be sent as "ABABABABAB"
                                    // And each sample (A/B) will be an 8 to 32-bit number.
                                    // Convert the 8 - 32-bit number into a floating-point number, as required by Web Audio API.
                                    interleavedArray = $7d1dfcf591b58136$var$formatAudioDataArrayBufferToFloatArray(format, chunk.buffer); // Deinterleave data back into two array buffer, e.g. "AAAAA" and "BBBBB".
                                    multiChannelArray = $7d1dfcf591b58136$var$deinterleave(interleavedArray, format); // Upsample data if necessary. If the multiplier is 2x, "AAAAA" will be upsampled to "AAAAAAAAAA" (with anti-alias).
                                    upsampledMultiChannelArray = multiChannelArray.map(function(array) {
                                        return $7d1dfcf591b58136$var$multiplySampleRate(array, sampleRateMultiplier);
                                    }); // Queue to the buffering player.
                                    player.push(upsampledMultiChannelArray);
                                case 23:
                                    _context.next = 25;
                                    return read();
                                case 25:
                                    chunk = _context.sent;
                                    maxChunks++;
                                    _context.next = 16;
                                    break;
                                case 29:
                                    abortPromise.catch(function() {
                                        return player.cancelAll();
                                    });
                                    if (!signal.aborted) {
                                        _context.next = 32;
                                        break;
                                    }
                                    throw new Error("aborted");
                                case 32:
                                    _context.next = 34;
                                    return Promise.race([
                                        abortPromise,
                                        player.flush()
                                    ]);
                                case 34:
                                case "end":
                                    return _context.stop();
                            }
                        }, _callee);
                    })(), "t0", 18);
                case 18:
                    _context2.prev = 18;
                    queuedBufferSourceNodes.forEach(function(node) {
                        return node.stop();
                    });
                    return _context2.finish(18);
                case 21:
                case "end":
                    return _context2.stop();
            }
        }, _callee2, null, [
            [
                16,
                ,
                18,
                21
            ]
        ]);
    }));
    return $7d1dfcf591b58136$var$_playCognitiveServicesStream.apply(this, arguments);
}

});
parcelRequire.register("2AzOD", function(module, exports) {
function $1e2ab9cb36590338$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
module.exports = $1e2ab9cb36590338$var$_defineProperty, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRequire.register("7Jric", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $5a11e81ffcc26d8e$var$createMultiBufferingPlayer;
// Currently, Web Chat uses a triple-buffer approach.
var $5a11e81ffcc26d8e$var$NUM_BUFFER = 3;
function $5a11e81ffcc26d8e$var$zeroBuffer(buffer) {
    var channels = buffer.numberOfChannels;
    for(var channel = 0; channel < channels; channel++){
        var audioData = buffer.getChannelData(channel);
        [].fill.call(audioData, 0);
    }
}
function $5a11e81ffcc26d8e$var$copyBuffer(buffer, multiChannelArray) {
    var channels = buffer.numberOfChannels;
    for(var channel = 0; channel < channels; channel++){
        var float32Array = multiChannelArray[+channel]; // Note that Safari does not support AudioBuffer.copyToChannel yet.
        if (buffer.copyToChannel) buffer.copyToChannel(float32Array, channel);
        else {
            var float32ArrayLength = float32Array.length;
            var perChannelBuffer = buffer.getChannelData(channel);
            for(var offset = 0; offset < float32ArrayLength; offset++)perChannelBuffer[+offset] = float32Array[+offset];
        }
    }
} // This is a multi-buffering player. Users can keep pushing buffer to Web Chat.
// The buffer, realized as BufferSource, is queued to AudioContext.
// Data will be queued as quickly and frequently as possible.
// Web Chat does not support progressive buffering (pushing a partial buffer) and there are currently no plans to implement.
function $5a11e81ffcc26d8e$var$createMultiBufferingPlayer(audioContext, _ref, numSamplePerBuffer) {
    var channels = _ref.channels, samplesPerSec = _ref.samplesPerSec;
    var freeBuffers = new Array($5a11e81ffcc26d8e$var$NUM_BUFFER).fill().map(function() {
        return audioContext.createBuffer(channels, numSamplePerBuffer, samplesPerSec);
    });
    var queuedBufferSources = [];
    var nextSchedule;
    var queue = [];
    var playNext = function playNext() {
        if (typeof nextSchedule !== "number") nextSchedule = audioContext.currentTime;
        var bufferSource = audioContext.createBufferSource();
        var multiChannelArray = queue.shift();
        if (typeof multiChannelArray === "function") // If the queued item is a function, it is because the user called "flush".
        // The "flush" function will callback when all queued buffers before the "flush" call have played.
        multiChannelArray();
        else if (multiChannelArray) {
            var nextBuffer = freeBuffers.shift(); // If all buffers are currently occupied, prepend the data back to the queue.
            // When one of the buffers finish, it will call playNext() again to pick up items from the queue.
            if (!nextBuffer) {
                queue.unshift(multiChannelArray);
                return;
            }
            $5a11e81ffcc26d8e$var$zeroBuffer(nextBuffer);
            $5a11e81ffcc26d8e$var$copyBuffer(nextBuffer, multiChannelArray);
            bufferSource.buffer = nextBuffer;
            bufferSource.connect(audioContext.destination);
            bufferSource.start(nextSchedule); // All BufferSource data that is currently queued will be stored at the AudioContext, via bufferSource.start().
            // This is for cancelAll() to effectively cancel all BufferSource queued at the AudioContext.
            queuedBufferSources.push(bufferSource);
            nextSchedule += nextBuffer.duration;
            bufferSource.addEventListener("ended", function() {
                queuedBufferSources = queuedBufferSources.filter(function(target) {
                    return target !== bufferSource;
                }); // Declare the buffer is free to pick up on the next iteration.
                freeBuffers.push(nextBuffer);
                playNext();
            });
        }
    };
    return {
        cancelAll: function cancelAll() {
            queue.splice(0); // Although all buffers are cleared, there are still some BufferSources queued at the AudioContext that need to be stopped.
            queuedBufferSources.forEach(function(bufferSource) {
                return bufferSource.stop();
            });
        },
        flush: function flush() {
            return new Promise(function(resolve) {
                return queue.push(resolve);
            });
        },
        push: function push(multiChannelArray) {
            if (!multiChannelArray) throw new Error("multiChannelArray must not be falsy.");
            queue.push(multiChannelArray);
            playNext();
        }
    };
}

});


parcelRequire.register("jBa43", function(module, exports) {
"use strict";

var $cP3px = parcelRequire("cP3px");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $e449479ecdc09e3b$var$playWhiteNoise;

var $e449479ecdc09e3b$var$_regenerator = $cP3px((parcelRequire("foOOj")));

var $e449479ecdc09e3b$var$_asyncToGenerator2 = $cP3px((parcelRequire("iV07h")));

var $gmKnH = parcelRequire("gmKnH");

var $e449479ecdc09e3b$var$_eventAsPromise = $cP3px((parcelRequire("2pzIa")));
var $e449479ecdc09e3b$var$EMPTY_MP3_BASE64 = "SUQzBAAAAAAAI1RTU0UAAAAPAAADTGF2ZjU3LjU2LjEwMQAAAAAAAAAAAAAA//tAwAAAAAAAAAAAAAAAAAAAAAAASW5mbwAAAA8AAAACAAABhgC7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7//////////////////////////////////////////////////////////////////8AAAAATGF2YzU3LjY0AAAAAAAAAAAAAAAAJAUHAAAAAAAAAYYoRBqpAAAAAAD/+xDEAAPAAAGkAAAAIAAANIAAAARMQU1FMy45OS41VVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVf/7EMQpg8AAAaQAAAAgAAA0gAAABFVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVV";
function $e449479ecdc09e3b$var$subscribeEvent(target, name, handler) {
    target.addEventListener(name, handler);
    return function() {
        return target.removeEventListener(name, handler);
    };
}
function $e449479ecdc09e3b$var$asyncDecodeAudioData(audioContext, arrayBuffer) {
    return new Promise(function(resolve, reject) {
        var promise = audioContext.decodeAudioData(arrayBuffer, resolve, reject); // Newer implementation of "decodeAudioData" will return a Promise
        promise && typeof promise.then === "function" && resolve(promise);
    });
}
function $e449479ecdc09e3b$var$playDecoded(audioContext, audioBuffer, source) {
    return new Promise(function(resolve, reject) {
        var audioContextClosed = new $e449479ecdc09e3b$var$_eventAsPromise.default();
        var sourceEnded = new $e449479ecdc09e3b$var$_eventAsPromise.default();
        var unsubscribe = $e449479ecdc09e3b$var$subscribeEvent(audioContext, "statechange", function(_ref) {
            var state = _ref.target.state;
            return state === "closed" && audioContextClosed.eventListener();
        });
        try {
            source.buffer = audioBuffer; // "ended" may not fire if the underlying AudioContext is closed prematurely
            source.onended = sourceEnded.eventListener;
            source.connect(audioContext.destination);
            source.start(0);
            Promise.race([
                audioContextClosed.upcoming(),
                sourceEnded.upcoming()
            ]).then(resolve);
        } catch (err) {
            reject(err);
        } finally{
            unsubscribe();
        }
    });
}
function $e449479ecdc09e3b$var$playWhiteNoise(_x) {
    return $e449479ecdc09e3b$var$_playWhiteNoise.apply(this, arguments);
}
function $e449479ecdc09e3b$var$_playWhiteNoise() {
    $e449479ecdc09e3b$var$_playWhiteNoise = (0, $e449479ecdc09e3b$var$_asyncToGenerator2.default)(/*#__PURE__*/ $e449479ecdc09e3b$var$_regenerator.default.mark(function _callee(audioContext) {
        var source, audioBuffer;
        return $e449479ecdc09e3b$var$_regenerator.default.wrap(function _callee$(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    source = audioContext.createBufferSource();
                    _context.next = 3;
                    return $e449479ecdc09e3b$var$asyncDecodeAudioData(audioContext, (0, $gmKnH.decode)($e449479ecdc09e3b$var$EMPTY_MP3_BASE64));
                case 3:
                    audioBuffer = _context.sent;
                    _context.next = 6;
                    return $e449479ecdc09e3b$var$playDecoded(audioContext, audioBuffer, source);
                case 6:
                case "end":
                    return _context.stop();
            }
        }, _callee);
    }));
    return $e449479ecdc09e3b$var$_playWhiteNoise.apply(this, arguments);
}

});

parcelRequire.register("3QFt7", function(module, exports) {
"use strict";

var $cP3px = parcelRequire("cP3px");

var $jwgnX = parcelRequire("jwgnX");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2cd6653b602fba80$var$_classCallCheck2 = $cP3px((parcelRequire("4g3Cu")));

var $2cd6653b602fba80$var$_createClass2 = $cP3px((parcelRequire("03avT")));

var $2cd6653b602fba80$var$_inherits2 = $cP3px((parcelRequire("aCeLW")));

var $2cd6653b602fba80$var$_possibleConstructorReturn2 = $cP3px((parcelRequire("epYPS")));

var $2cd6653b602fba80$var$_getPrototypeOf2 = $cP3px((parcelRequire("hbGgl")));

var $2cd6653b602fba80$var$_es = $2cd6653b602fba80$var$_interopRequireWildcard((parcelRequire("bgEWP")));
function $2cd6653b602fba80$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($2cd6653b602fba80$var$_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $2cd6653b602fba80$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || $jwgnX(obj) !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $2cd6653b602fba80$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $2cd6653b602fba80$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $2cd6653b602fba80$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, $2cd6653b602fba80$var$_getPrototypeOf2.default)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $2cd6653b602fba80$var$_getPrototypeOf2.default)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $2cd6653b602fba80$var$_possibleConstructorReturn2.default)(this, result);
    };
}
function $2cd6653b602fba80$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
var $2cd6653b602fba80$var$SpeechSynthesisAudioStreamUtterance = /*#__PURE__*/ function(_EventTarget) {
    (0, $2cd6653b602fba80$var$_inherits2.default)(SpeechSynthesisAudioStreamUtterance, _EventTarget);
    var _super = $2cd6653b602fba80$var$_createSuper(SpeechSynthesisAudioStreamUtterance);
    function SpeechSynthesisAudioStreamUtterance(audioStream) {
        var _this;
        (0, $2cd6653b602fba80$var$_classCallCheck2.default)(this, SpeechSynthesisAudioStreamUtterance);
        _this = _super.call(this);
        if (audioStream && !(audioStream.format && typeof audioStream.read === "function")) throw new Error("botframework-directlinespeech-sdk: If the first argument is specified, it must be a Cognitive Services audio stream.");
        _this.audioStream = audioStream;
        return _this;
    }
    (0, $2cd6653b602fba80$var$_createClass2.default)(SpeechSynthesisAudioStreamUtterance, [
        {
            key: "onboundary",
            get: function get() {
                return (0, $2cd6653b602fba80$var$_es.getEventAttributeValue)(this, "boundary");
            },
            set: function set(value) {
                (0, $2cd6653b602fba80$var$_es.setEventAttributeValue)(this, "boundary", value);
            }
        },
        {
            key: "onend",
            get: function get() {
                return (0, $2cd6653b602fba80$var$_es.getEventAttributeValue)(this, "end");
            },
            set: function set(value) {
                (0, $2cd6653b602fba80$var$_es.setEventAttributeValue)(this, "end", value);
            }
        },
        {
            key: "onerror",
            get: function get() {
                return (0, $2cd6653b602fba80$var$_es.getEventAttributeValue)(this, "error");
            },
            set: function set(value) {
                (0, $2cd6653b602fba80$var$_es.setEventAttributeValue)(this, "error", value);
            }
        },
        {
            key: "onstart",
            get: function get() {
                return (0, $2cd6653b602fba80$var$_es.getEventAttributeValue)(this, "start");
            },
            set: function set(value) {
                (0, $2cd6653b602fba80$var$_es.setEventAttributeValue)(this, "start", value);
            }
        }
    ]);
    return SpeechSynthesisAudioStreamUtterance;
}($2cd6653b602fba80$var$_es.default);
var $2cd6653b602fba80$var$_default = $2cd6653b602fba80$var$SpeechSynthesisAudioStreamUtterance;
module.exports.default = $2cd6653b602fba80$var$_default;

});


parcelRequire.register("dYn8H", function(module, exports) {
"use strict";

var $cP3px = parcelRequire("cP3px");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a2c2d3f5b81c0414$var$_defineProperty2 = $cP3px((parcelRequire("2AzOD")));

var $a2c2d3f5b81c0414$var$_classCallCheck2 = $cP3px((parcelRequire("4g3Cu")));

var $a2c2d3f5b81c0414$var$_createClass2 = $cP3px((parcelRequire("03avT")));

var $a2c2d3f5b81c0414$var$_observable = $cP3px((parcelRequire("3tPpG")));

var $a2c2d3f5b81c0414$var$_mathRandom = $cP3px((parcelRequire("atZsr")));

var $a2c2d3f5b81c0414$var$_shareObservable = $cP3px((parcelRequire("aTBap")));

var $a2c2d3f5b81c0414$var$_SpeechSynthesisAudioStreamUtterance = $cP3px((parcelRequire("3QFt7")));
function $a2c2d3f5b81c0414$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $a2c2d3f5b81c0414$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $a2c2d3f5b81c0414$var$ownKeys(Object(source), !0).forEach(function(key) {
            (0, $a2c2d3f5b81c0414$var$_defineProperty2.default)(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $a2c2d3f5b81c0414$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $a2c2d3f5b81c0414$var$randomActivityId() {
    return (0, $a2c2d3f5b81c0414$var$_mathRandom.default)().toString(36).substr(2);
}
var $a2c2d3f5b81c0414$var$DirectLineSpeech = /*#__PURE__*/ function() {
    function DirectLineSpeech(_ref) {
        var _this = this;
        var dialogServiceConnector = _ref.dialogServiceConnector;
        (0, $a2c2d3f5b81c0414$var$_classCallCheck2.default)(this, DirectLineSpeech);
        var connectionStatusObserver;
        this.dialogServiceConnector = dialogServiceConnector;
        this.activity$ = (0, $a2c2d3f5b81c0414$var$_shareObservable.default)(new $a2c2d3f5b81c0414$var$_observable.default(function(observer) {
            _this._activityObserver = observer;
            connectionStatusObserver.next(0);
            connectionStatusObserver.next(1);
            dialogServiceConnector.connect(function() {
                connectionStatusObserver.next(2);
            }, function(error) {
                connectionStatusObserver.next(4);
                console.warn("botframework-directlinespeech-sdk: Failed to connect", {
                    error: error
                });
            });
        }));
        this.connectionStatus$ = (0, $a2c2d3f5b81c0414$var$_shareObservable.default)(new $a2c2d3f5b81c0414$var$_observable.default(function(observer) {
            connectionStatusObserver = observer;
        }));
        dialogServiceConnector.activityReceived = function(_, _ref2) {
            var activity = _ref2.activity, audioStream = _ref2.audioStream;
            try {
                _this._activityObserver && _this._activityObserver.next($a2c2d3f5b81c0414$var$_objectSpread($a2c2d3f5b81c0414$var$_objectSpread({}, activity), {}, {
                    channelData: $a2c2d3f5b81c0414$var$_objectSpread($a2c2d3f5b81c0414$var$_objectSpread({}, activity.channelData), {}, {
                        speechSynthesisUtterance: new $a2c2d3f5b81c0414$var$_SpeechSynthesisAudioStreamUtterance.default(audioStream)
                    }),
                    from: $a2c2d3f5b81c0414$var$_objectSpread($a2c2d3f5b81c0414$var$_objectSpread({}, activity.from), {}, {
                        // Since DLSpeech service never ACK our outgoing activity, this activity must be from bot.
                        role: "bot"
                    }),
                    // Since DLSpeech never ACK our outgoing activity, the "replyToId" will rarely able to point to an existing activity.
                    replyToId: undefined,
                    // Direct Line Speech server currently do not timestamp outgoing activities.
                    // Thus, it will be easier to just re-timestamp every incoming/outgoing activities using local time.
                    timestamp: new Date().toISOString()
                }));
            } catch (error) {
                console.error(error);
            }
        };
    }
    (0, $a2c2d3f5b81c0414$var$_createClass2.default)(DirectLineSpeech, [
        {
            key: "end",
            value: function end() {
                try {
                    this.dialogServiceConnector.close();
                } catch (err) {
                    if (!~err.message.indexOf("already disposed")) throw err;
                }
            }
        },
        {
            key: "postActivity",
            value: function postActivity(activity) {
                // Currently, Web Chat set user ID on all outgoing activities.
                // As Direct Line Speech maintains its own user ID, Web Chat should not set the user ID.
                // TODO: [P2] We should move user ID into options of DirectLineJS, instead of Web Chat.
                activity = $a2c2d3f5b81c0414$var$_objectSpread($a2c2d3f5b81c0414$var$_objectSpread({}, activity), {}, {
                    from: {
                        role: "user"
                    }
                });
                try {
                    var _activity$channelData;
                    // TODO: [P1] Direct Line Speech server currently do not ack the outgoing activities with any activity ID or timestamp.
                    var pseudoActivityId = $a2c2d3f5b81c0414$var$randomActivityId();
                    var isSpeech = !!((_activity$channelData = activity.channelData) !== null && _activity$channelData !== void 0 && _activity$channelData.speech); // Do not send the activity if it was from speech.
                    if (!isSpeech) // Starting from Speech SDK 1.13.0, they accept JSON text instead of JavaScript object.
                    // https://github.com/microsoft/cognitive-services-speech-sdk-js/commit/2f3a35446692b6d492a6c68e3237a48de67e293f
                    this.dialogServiceConnector.sendActivityAsync(JSON.stringify(activity));
                    this._activityObserver && this._activityObserver.next($a2c2d3f5b81c0414$var$_objectSpread($a2c2d3f5b81c0414$var$_objectSpread({}, activity), {}, {
                        id: pseudoActivityId,
                        timestamp: new Date().toISOString()
                    }));
                    return $a2c2d3f5b81c0414$var$_observable.default.of(pseudoActivityId);
                } catch (err) {
                    return new $a2c2d3f5b81c0414$var$_observable.default(function(observer) {
                        return observer.error(err);
                    });
                }
            }
        }
    ]);
    return DirectLineSpeech;
}(); // Interfaces not yet implemented in Web Chat:
// referenceGrammarId?: string,
// getSessionId? : () => Observable<string>
module.exports.default = $a2c2d3f5b81c0414$var$DirectLineSpeech;

});
parcelRequire.register("3tPpG", function(module, exports) {

module.exports = (parcelRequire("fOn8q"));

});
parcelRequire.register("fOn8q", function(module, exports) {
parcelRequire("79hlA");
parcelRequire("7VrO7");
parcelRequire("4O74H");
parcelRequire("jWGiO");
parcelRequire("6QS1f");

var $9LfIn = parcelRequire("9LfIn");
module.exports = $9LfIn.Observable;

});
parcelRequire.register("79hlA", function(module, exports) {
// TODO: Remove this module from `core-js@4` since it's split to modules listed below
parcelRequire("a4eRA");
parcelRequire("D8fhb");
parcelRequire("1j0bv");

});
parcelRequire.register("a4eRA", function(module, exports) {
"use strict";

var $cliN7 = parcelRequire("cliN7");

var $1sYuu = parcelRequire("1sYuu");

var $foS3H = parcelRequire("foS3H");

var $ka2RW = parcelRequire("ka2RW");

var $8FpFb = parcelRequire("8FpFb");

var $78ijy = parcelRequire("78ijy");

var $kUuYg = parcelRequire("kUuYg");

var $18VOO = parcelRequire("18VOO");

var $gkj3g = parcelRequire("gkj3g");

var $6FOrH = parcelRequire("6FOrH");

var $3hbLp = parcelRequire("3hbLp");

var $02JSJ = parcelRequire("02JSJ");

var $6ckzM = parcelRequire("6ckzM");

var $8F77J = parcelRequire("8F77J");

var $5ywCo = parcelRequire("5ywCo");

var $4r2jm = parcelRequire("4r2jm");

var $jAamA = parcelRequire("jAamA");

var $80ke7 = parcelRequire("80ke7");
var $7545cea8736fc6cc$var$$$OBSERVABLE = $4r2jm("observable");
var $7545cea8736fc6cc$var$OBSERVABLE = "Observable";
var $7545cea8736fc6cc$var$SUBSCRIPTION = "Subscription";
var $7545cea8736fc6cc$var$SUBSCRIPTION_OBSERVER = "SubscriptionObserver";
var $7545cea8736fc6cc$var$getterFor = $jAamA.getterFor;
var $7545cea8736fc6cc$var$setInternalState = $jAamA.set;
var $7545cea8736fc6cc$var$getObservableInternalState = $7545cea8736fc6cc$var$getterFor($7545cea8736fc6cc$var$OBSERVABLE);
var $7545cea8736fc6cc$var$getSubscriptionInternalState = $7545cea8736fc6cc$var$getterFor($7545cea8736fc6cc$var$SUBSCRIPTION);
var $7545cea8736fc6cc$var$getSubscriptionObserverInternalState = $7545cea8736fc6cc$var$getterFor($7545cea8736fc6cc$var$SUBSCRIPTION_OBSERVER);
var $7545cea8736fc6cc$var$SubscriptionState = function(observer) {
    this.observer = $78ijy(observer);
    this.cleanup = undefined;
    this.subscriptionObserver = undefined;
};
$7545cea8736fc6cc$var$SubscriptionState.prototype = {
    type: $7545cea8736fc6cc$var$SUBSCRIPTION,
    clean: function() {
        var cleanup = this.cleanup;
        if (cleanup) {
            this.cleanup = undefined;
            try {
                cleanup();
            } catch (error) {
                $5ywCo(error);
            }
        }
    },
    close: function() {
        if (!$foS3H) {
            var subscription = this.facade;
            var subscriptionObserver = this.subscriptionObserver;
            subscription.closed = true;
            if (subscriptionObserver) subscriptionObserver.closed = true;
        }
        this.observer = undefined;
    },
    isClosed: function() {
        return this.observer === undefined;
    }
};
var $7545cea8736fc6cc$var$Subscription = function(observer, subscriber) {
    var subscriptionState = $7545cea8736fc6cc$var$setInternalState(this, new $7545cea8736fc6cc$var$SubscriptionState(observer));
    var start;
    if (!$foS3H) this.closed = false;
    try {
        if (start = $3hbLp(observer, "start")) $1sYuu(start, observer, this);
    } catch (error) {
        $5ywCo(error);
    }
    if (subscriptionState.isClosed()) return;
    var subscriptionObserver = subscriptionState.subscriptionObserver = new $7545cea8736fc6cc$var$SubscriptionObserver(subscriptionState);
    try {
        var cleanup = subscriber(subscriptionObserver);
        var subscription = cleanup;
        if (!$gkj3g(cleanup)) subscriptionState.cleanup = $18VOO(cleanup.unsubscribe) ? function() {
            subscription.unsubscribe();
        } : $8FpFb(cleanup);
    } catch (error) {
        subscriptionObserver.error(error);
        return;
    }
    if (subscriptionState.isClosed()) subscriptionState.clean();
};
$7545cea8736fc6cc$var$Subscription.prototype = $6ckzM({}, {
    unsubscribe: function unsubscribe() {
        var subscriptionState = $7545cea8736fc6cc$var$getSubscriptionInternalState(this);
        if (!subscriptionState.isClosed()) {
            subscriptionState.close();
            subscriptionState.clean();
        }
    }
});
if ($foS3H) $8F77J($7545cea8736fc6cc$var$Subscription.prototype, "closed", {
    configurable: true,
    get: function closed() {
        return $7545cea8736fc6cc$var$getSubscriptionInternalState(this).isClosed();
    }
});
var $7545cea8736fc6cc$var$SubscriptionObserver = function(subscriptionState) {
    $7545cea8736fc6cc$var$setInternalState(this, {
        type: $7545cea8736fc6cc$var$SUBSCRIPTION_OBSERVER,
        subscriptionState: subscriptionState
    });
    if (!$foS3H) this.closed = false;
};
$7545cea8736fc6cc$var$SubscriptionObserver.prototype = $6ckzM({}, {
    next: function next(value) {
        var subscriptionState = $7545cea8736fc6cc$var$getSubscriptionObserverInternalState(this).subscriptionState;
        if (!subscriptionState.isClosed()) {
            var observer = subscriptionState.observer;
            try {
                var nextMethod = $3hbLp(observer, "next");
                if (nextMethod) $1sYuu(nextMethod, observer, value);
            } catch (error) {
                $5ywCo(error);
            }
        }
    },
    error: function error(value) {
        var subscriptionState = $7545cea8736fc6cc$var$getSubscriptionObserverInternalState(this).subscriptionState;
        if (!subscriptionState.isClosed()) {
            var observer = subscriptionState.observer;
            subscriptionState.close();
            try {
                var errorMethod = $3hbLp(observer, "error");
                if (errorMethod) $1sYuu(errorMethod, observer, value);
                else $5ywCo(value);
            } catch (err) {
                $5ywCo(err);
            }
            subscriptionState.clean();
        }
    },
    complete: function complete() {
        var subscriptionState = $7545cea8736fc6cc$var$getSubscriptionObserverInternalState(this).subscriptionState;
        if (!subscriptionState.isClosed()) {
            var observer = subscriptionState.observer;
            subscriptionState.close();
            try {
                var completeMethod = $3hbLp(observer, "complete");
                if (completeMethod) $1sYuu(completeMethod, observer);
            } catch (error) {
                $5ywCo(error);
            }
            subscriptionState.clean();
        }
    }
});
if ($foS3H) $8F77J($7545cea8736fc6cc$var$SubscriptionObserver.prototype, "closed", {
    configurable: true,
    get: function closed() {
        return $7545cea8736fc6cc$var$getSubscriptionObserverInternalState(this).subscriptionState.isClosed();
    }
});
var $7545cea8736fc6cc$var$$Observable = function Observable(subscriber) {
    $kUuYg(this, $7545cea8736fc6cc$var$ObservablePrototype);
    $7545cea8736fc6cc$var$setInternalState(this, {
        type: $7545cea8736fc6cc$var$OBSERVABLE,
        subscriber: $8FpFb(subscriber)
    });
};
var $7545cea8736fc6cc$var$ObservablePrototype = $7545cea8736fc6cc$var$$Observable.prototype;
$6ckzM($7545cea8736fc6cc$var$ObservablePrototype, {
    subscribe: function subscribe(observer) {
        var length = arguments.length;
        return new $7545cea8736fc6cc$var$Subscription($18VOO(observer) ? {
            next: observer,
            error: length > 1 ? arguments[1] : undefined,
            complete: length > 2 ? arguments[2] : undefined
        } : $6FOrH(observer) ? observer : {}, $7545cea8736fc6cc$var$getObservableInternalState(this).subscriber);
    }
});
$02JSJ($7545cea8736fc6cc$var$ObservablePrototype, $7545cea8736fc6cc$var$$$OBSERVABLE, function() {
    return this;
});
$cliN7({
    global: true,
    constructor: true,
    forced: $80ke7
}, {
    Observable: $7545cea8736fc6cc$var$$Observable
});
$ka2RW($7545cea8736fc6cc$var$OBSERVABLE);

});
parcelRequire.register("ka2RW", function(module, exports) {
"use strict";

var $7oweL = parcelRequire("7oweL");

var $8F77J = parcelRequire("8F77J");

var $4r2jm = parcelRequire("4r2jm");

var $foS3H = parcelRequire("foS3H");
var $ead6f78994377c05$var$SPECIES = $4r2jm("species");
module.exports = function(CONSTRUCTOR_NAME) {
    var Constructor = $7oweL(CONSTRUCTOR_NAME);
    if ($foS3H && Constructor && !Constructor[$ead6f78994377c05$var$SPECIES]) $8F77J(Constructor, $ead6f78994377c05$var$SPECIES, {
        configurable: true,
        get: function() {
            return this;
        }
    });
};

});
parcelRequire.register("8F77J", function(module, exports) {

var $h4k14 = parcelRequire("h4k14");

var $fmCgr = parcelRequire("fmCgr");
module.exports = function(target, name, descriptor) {
    if (descriptor.get) $h4k14(descriptor.get, name, {
        getter: true
    });
    if (descriptor.set) $h4k14(descriptor.set, name, {
        setter: true
    });
    return $fmCgr.f(target, name, descriptor);
};

});


parcelRequire.register("kUuYg", function(module, exports) {

var $xsCLe = parcelRequire("xsCLe");
var $f3910fcfa89156ad$var$$TypeError = TypeError;
module.exports = function(it, Prototype) {
    if ($xsCLe(Prototype, it)) return it;
    throw $f3910fcfa89156ad$var$$TypeError("Incorrect invocation");
};

});

parcelRequire.register("6ckzM", function(module, exports) {

var $02JSJ = parcelRequire("02JSJ");
module.exports = function(target, src, options) {
    for(var key in src)$02JSJ(target, key, src[key], options);
    return target;
};

});

parcelRequire.register("5ywCo", function(module, exports) {
module.exports = function(a, b) {
    try {
        // eslint-disable-next-line no-console -- safe
        arguments.length == 1 ? console.error(a) : console.error(a, b);
    } catch (error) {}
};

});

parcelRequire.register("80ke7", function(module, exports) {

var $7nYI8 = parcelRequire("7nYI8");

var $18VOO = parcelRequire("18VOO");

var $4r2jm = parcelRequire("4r2jm");
var $5d3e036f470281c7$var$$$OBSERVABLE = $4r2jm("observable");
var $5d3e036f470281c7$var$NativeObservable = $7nYI8.Observable;
var $5d3e036f470281c7$var$NativeObservablePrototype = $5d3e036f470281c7$var$NativeObservable && $5d3e036f470281c7$var$NativeObservable.prototype;
module.exports = !$18VOO($5d3e036f470281c7$var$NativeObservable) || !$18VOO($5d3e036f470281c7$var$NativeObservable.from) || !$18VOO($5d3e036f470281c7$var$NativeObservable.of) || !$18VOO($5d3e036f470281c7$var$NativeObservablePrototype.subscribe) || !$18VOO($5d3e036f470281c7$var$NativeObservablePrototype[$5d3e036f470281c7$var$$$OBSERVABLE]);

});


parcelRequire.register("D8fhb", function(module, exports) {
"use strict";

var $cliN7 = parcelRequire("cliN7");

var $7oweL = parcelRequire("7oweL");

var $1sYuu = parcelRequire("1sYuu");

var $78ijy = parcelRequire("78ijy");

var $8pz6l = parcelRequire("8pz6l");

var $3KSOd = parcelRequire("3KSOd");

var $3hbLp = parcelRequire("3hbLp");

var $4KW5j = parcelRequire("4KW5j");

var $4r2jm = parcelRequire("4r2jm");

var $80ke7 = parcelRequire("80ke7");
var $075a09fee7cb11f7$var$$$OBSERVABLE = $4r2jm("observable");
// `Observable.from` method
// https://github.com/tc39/proposal-observable
$cliN7({
    target: "Observable",
    stat: true,
    forced: $80ke7
}, {
    from: function from(x) {
        var C = $8pz6l(this) ? this : $7oweL("Observable");
        var observableMethod = $3hbLp($78ijy(x), $075a09fee7cb11f7$var$$$OBSERVABLE);
        if (observableMethod) {
            var observable = $78ijy($1sYuu(observableMethod, x));
            return observable.constructor === C ? observable : new C(function(observer) {
                return observable.subscribe(observer);
            });
        }
        var iterator = $3KSOd(x);
        return new C(function(observer) {
            $4KW5j(iterator, function(it, stop) {
                observer.next(it);
                if (observer.closed) return stop();
            }, {
                IS_ITERATOR: true,
                INTERRUPTED: true
            });
            observer.complete();
        });
    }
});

});
parcelRequire.register("8pz6l", function(module, exports) {

var $kkBYw = parcelRequire("kkBYw");

var $2aNMZ = parcelRequire("2aNMZ");

var $18VOO = parcelRequire("18VOO");

var $kX3vM = parcelRequire("kX3vM");

var $7oweL = parcelRequire("7oweL");

var $98fRx = parcelRequire("98fRx");
var $61fbe2ed2fde2bbb$var$noop = function() {};
var $61fbe2ed2fde2bbb$var$empty = [];
var $61fbe2ed2fde2bbb$var$construct = $7oweL("Reflect", "construct");
var $61fbe2ed2fde2bbb$var$constructorRegExp = /^\s*(?:class|function)\b/;
var $61fbe2ed2fde2bbb$var$exec = $kkBYw($61fbe2ed2fde2bbb$var$constructorRegExp.exec);
var $61fbe2ed2fde2bbb$var$INCORRECT_TO_STRING = !$61fbe2ed2fde2bbb$var$constructorRegExp.exec($61fbe2ed2fde2bbb$var$noop);
var $61fbe2ed2fde2bbb$var$isConstructorModern = function isConstructor(argument) {
    if (!$18VOO(argument)) return false;
    try {
        $61fbe2ed2fde2bbb$var$construct($61fbe2ed2fde2bbb$var$noop, $61fbe2ed2fde2bbb$var$empty, argument);
        return true;
    } catch (error) {
        return false;
    }
};
var $61fbe2ed2fde2bbb$var$isConstructorLegacy = function isConstructor(argument) {
    if (!$18VOO(argument)) return false;
    switch($kX3vM(argument)){
        case "AsyncFunction":
        case "GeneratorFunction":
        case "AsyncGeneratorFunction":
            return false;
    }
    try {
        // we can't check .prototype since constructors produced by .bind haven't it
        // `Function#toString` throws on some built-it function in some legacy engines
        // (for example, `DOMQuad` and similar in FF41-)
        return $61fbe2ed2fde2bbb$var$INCORRECT_TO_STRING || !!$61fbe2ed2fde2bbb$var$exec($61fbe2ed2fde2bbb$var$constructorRegExp, $98fRx(argument));
    } catch (error) {
        return true;
    }
};
$61fbe2ed2fde2bbb$var$isConstructorLegacy.sham = true;
// `IsConstructor` abstract operation
// https://tc39.es/ecma262/#sec-isconstructor
module.exports = !$61fbe2ed2fde2bbb$var$construct || $2aNMZ(function() {
    var called;
    return $61fbe2ed2fde2bbb$var$isConstructorModern($61fbe2ed2fde2bbb$var$isConstructorModern.call) || !$61fbe2ed2fde2bbb$var$isConstructorModern(Object) || !$61fbe2ed2fde2bbb$var$isConstructorModern(function() {
        called = true;
    }) || called;
}) ? $61fbe2ed2fde2bbb$var$isConstructorLegacy : $61fbe2ed2fde2bbb$var$isConstructorModern;

});
parcelRequire.register("kX3vM", function(module, exports) {

var $diise = parcelRequire("diise");

var $18VOO = parcelRequire("18VOO");

var $8E2yy = parcelRequire("8E2yy");

var $4r2jm = parcelRequire("4r2jm");
var $f40c0aacfcd8c86f$var$TO_STRING_TAG = $4r2jm("toStringTag");
var $f40c0aacfcd8c86f$var$$Object = Object;
// ES3 wrong here
var $f40c0aacfcd8c86f$var$CORRECT_ARGUMENTS = $8E2yy(function() {
    return arguments;
}()) == "Arguments";
// fallback for IE11 Script Access Denied error
var $f40c0aacfcd8c86f$var$tryGet = function(it, key) {
    try {
        return it[key];
    } catch (error) {}
};
// getting tag from ES6+ `Object.prototype.toString`
module.exports = $diise ? $8E2yy : function(it) {
    var O, tag, result;
    return it === undefined ? "Undefined" : it === null ? "Null" : typeof (tag = $f40c0aacfcd8c86f$var$tryGet(O = $f40c0aacfcd8c86f$var$$Object(it), $f40c0aacfcd8c86f$var$TO_STRING_TAG)) == "string" ? tag : $f40c0aacfcd8c86f$var$CORRECT_ARGUMENTS ? $8E2yy(O) : (result = $8E2yy(O)) == "Object" && $18VOO(O.callee) ? "Arguments" : result;
};

});
parcelRequire.register("diise", function(module, exports) {

var $4r2jm = parcelRequire("4r2jm");
var $9adb45715dfecc95$var$TO_STRING_TAG = $4r2jm("toStringTag");
var $9adb45715dfecc95$var$test = {};
$9adb45715dfecc95$var$test[$9adb45715dfecc95$var$TO_STRING_TAG] = "z";
module.exports = String($9adb45715dfecc95$var$test) === "[object z]";

});



parcelRequire.register("3KSOd", function(module, exports) {

var $1sYuu = parcelRequire("1sYuu");

var $8FpFb = parcelRequire("8FpFb");

var $78ijy = parcelRequire("78ijy");

var $2TjaA = parcelRequire("2TjaA");

var $9o8iB = parcelRequire("9o8iB");
var $2bc02ee98a0b66c9$var$$TypeError = TypeError;
module.exports = function(argument, usingIterator) {
    var iteratorMethod = arguments.length < 2 ? $9o8iB(argument) : usingIterator;
    if ($8FpFb(iteratorMethod)) return $78ijy($1sYuu(iteratorMethod, argument));
    throw $2bc02ee98a0b66c9$var$$TypeError($2TjaA(argument) + " is not iterable");
};

});
parcelRequire.register("9o8iB", function(module, exports) {

var $kX3vM = parcelRequire("kX3vM");

var $3hbLp = parcelRequire("3hbLp");

var $gkj3g = parcelRequire("gkj3g");

var $63DG3 = parcelRequire("63DG3");

var $4r2jm = parcelRequire("4r2jm");
var $6d5ccaf75d9b3515$var$ITERATOR = $4r2jm("iterator");
module.exports = function(it) {
    if (!$gkj3g(it)) return $3hbLp(it, $6d5ccaf75d9b3515$var$ITERATOR) || $3hbLp(it, "@@iterator") || $63DG3[$kX3vM(it)];
};

});
parcelRequire.register("63DG3", function(module, exports) {
module.exports = {};

});



parcelRequire.register("4KW5j", function(module, exports) {

var $2ynkv = parcelRequire("2ynkv");

var $1sYuu = parcelRequire("1sYuu");

var $78ijy = parcelRequire("78ijy");

var $2TjaA = parcelRequire("2TjaA");

var $rWRaE = parcelRequire("rWRaE");

var $eTBA7 = parcelRequire("eTBA7");

var $xsCLe = parcelRequire("xsCLe");

var $3KSOd = parcelRequire("3KSOd");

var $9o8iB = parcelRequire("9o8iB");

var $2bH5V = parcelRequire("2bH5V");
var $376883b20b9e933b$var$$TypeError = TypeError;
var $376883b20b9e933b$var$Result = function(stopped, result) {
    this.stopped = stopped;
    this.result = result;
};
var $376883b20b9e933b$var$ResultPrototype = $376883b20b9e933b$var$Result.prototype;
module.exports = function(iterable, unboundFunction, options) {
    var that = options && options.that;
    var AS_ENTRIES = !!(options && options.AS_ENTRIES);
    var IS_RECORD = !!(options && options.IS_RECORD);
    var IS_ITERATOR = !!(options && options.IS_ITERATOR);
    var INTERRUPTED = !!(options && options.INTERRUPTED);
    var fn = $2ynkv(unboundFunction, that);
    var iterator, iterFn, index, length, result, next, step;
    var stop = function(condition) {
        if (iterator) $2bH5V(iterator, "normal", condition);
        return new $376883b20b9e933b$var$Result(true, condition);
    };
    var callFn = function(value) {
        if (AS_ENTRIES) {
            $78ijy(value);
            return INTERRUPTED ? fn(value[0], value[1], stop) : fn(value[0], value[1]);
        }
        return INTERRUPTED ? fn(value, stop) : fn(value);
    };
    if (IS_RECORD) iterator = iterable.iterator;
    else if (IS_ITERATOR) iterator = iterable;
    else {
        iterFn = $9o8iB(iterable);
        if (!iterFn) throw $376883b20b9e933b$var$$TypeError($2TjaA(iterable) + " is not iterable");
        // optimisation for array iterators
        if ($rWRaE(iterFn)) {
            for(index = 0, length = $eTBA7(iterable); length > index; index++){
                result = callFn(iterable[index]);
                if (result && $xsCLe($376883b20b9e933b$var$ResultPrototype, result)) return result;
            }
            return new $376883b20b9e933b$var$Result(false);
        }
        iterator = $3KSOd(iterable, iterFn);
    }
    next = IS_RECORD ? iterable.next : iterator.next;
    while(!(step = $1sYuu(next, iterator)).done){
        try {
            result = callFn(step.value);
        } catch (error) {
            $2bH5V(iterator, "throw", error);
        }
        if (typeof result == "object" && result && $xsCLe($376883b20b9e933b$var$ResultPrototype, result)) return result;
    }
    return new $376883b20b9e933b$var$Result(false);
};

});
parcelRequire.register("2ynkv", function(module, exports) {

var $fKUt3 = parcelRequire("fKUt3");

var $8FpFb = parcelRequire("8FpFb");

var $ejHpM = parcelRequire("ejHpM");
var $1dc0da89876076c2$var$bind = $fKUt3($fKUt3.bind);
// optional / simple context binding
module.exports = function(fn, that) {
    $8FpFb(fn);
    return that === undefined ? fn : $ejHpM ? $1dc0da89876076c2$var$bind(fn, that) : function() {
        return fn.apply(that, arguments);
    };
};

});
parcelRequire.register("fKUt3", function(module, exports) {

var $8E2yy = parcelRequire("8E2yy");

var $kkBYw = parcelRequire("kkBYw");
module.exports = function(fn) {
    // Nashorn bug:
    //   https://github.com/zloirock/core-js/issues/1128
    //   https://github.com/zloirock/core-js/issues/1130
    if ($8E2yy(fn) === "Function") return $kkBYw(fn);
};

});


parcelRequire.register("rWRaE", function(module, exports) {

var $4r2jm = parcelRequire("4r2jm");

var $63DG3 = parcelRequire("63DG3");
var $05402d6caeef685d$var$ITERATOR = $4r2jm("iterator");
var $05402d6caeef685d$var$ArrayPrototype = Array.prototype;
// check on default Array iterator
module.exports = function(it) {
    return it !== undefined && ($63DG3.Array === it || $05402d6caeef685d$var$ArrayPrototype[$05402d6caeef685d$var$ITERATOR] === it);
};

});

parcelRequire.register("2bH5V", function(module, exports) {

var $1sYuu = parcelRequire("1sYuu");

var $78ijy = parcelRequire("78ijy");

var $3hbLp = parcelRequire("3hbLp");
module.exports = function(iterator, kind, value) {
    var innerResult, innerError;
    $78ijy(iterator);
    try {
        innerResult = $3hbLp(iterator, "return");
        if (!innerResult) {
            if (kind === "throw") throw value;
            return value;
        }
        innerResult = $1sYuu(innerResult, iterator);
    } catch (error) {
        innerError = true;
        innerResult = error;
    }
    if (kind === "throw") throw value;
    if (innerError) throw innerResult;
    $78ijy(innerResult);
    return value;
};

});



parcelRequire.register("1j0bv", function(module, exports) {
"use strict";

var $cliN7 = parcelRequire("cliN7");

var $7oweL = parcelRequire("7oweL");

var $8pz6l = parcelRequire("8pz6l");

var $80ke7 = parcelRequire("80ke7");
var $0f37b5758829104b$var$Array = $7oweL("Array");
// `Observable.of` method
// https://github.com/tc39/proposal-observable
$cliN7({
    target: "Observable",
    stat: true,
    forced: $80ke7
}, {
    of: function of() {
        var C = $8pz6l(this) ? this : $7oweL("Observable");
        var length = arguments.length;
        var items = $0f37b5758829104b$var$Array(length);
        var index = 0;
        while(index < length)items[index] = arguments[index++];
        return new C(function(observer) {
            for(var i = 0; i < length; i++){
                observer.next(items[i]);
                if (observer.closed) return;
            }
            observer.complete();
        });
    }
});

});


parcelRequire.register("7VrO7", function(module, exports) {

var $htRUe = parcelRequire("htRUe");
// `Symbol.observable` well-known symbol
// https://github.com/tc39/proposal-observable
$htRUe("observable");

});
parcelRequire.register("htRUe", function(module, exports) {

var $9LfIn = parcelRequire("9LfIn");

var $aZx1N = parcelRequire("aZx1N");

var $1A3nW = parcelRequire("1A3nW");

var $fmCgr = parcelRequire("fmCgr");
var $cb9ef5b8cbb25de5$require$defineProperty = $fmCgr.f;
module.exports = function(NAME) {
    var Symbol = $9LfIn.Symbol || ($9LfIn.Symbol = {});
    if (!$aZx1N(Symbol, NAME)) $cb9ef5b8cbb25de5$require$defineProperty(Symbol, NAME, {
        value: $1A3nW.f(NAME)
    });
};

});
parcelRequire.register("1A3nW", function(module, exports) {

$parcel$export(module.exports, "f", () => $126bc777217a51ab$export$2d1720544b23b823, (v) => $126bc777217a51ab$export$2d1720544b23b823 = v);
var $126bc777217a51ab$export$2d1720544b23b823;

var $4r2jm = parcelRequire("4r2jm");
$126bc777217a51ab$export$2d1720544b23b823 = $4r2jm;

});



parcelRequire.register("4O74H", function(module, exports) {

var $diise = parcelRequire("diise");

var $02JSJ = parcelRequire("02JSJ");

var $7bUSU = parcelRequire("7bUSU");
// `Object.prototype.toString` method
// https://tc39.es/ecma262/#sec-object.prototype.tostring
if (!$diise) $02JSJ(Object.prototype, "toString", $7bUSU, {
    unsafe: true
});

});
parcelRequire.register("7bUSU", function(module, exports) {
"use strict";

var $diise = parcelRequire("diise");

var $kX3vM = parcelRequire("kX3vM");
// `Object.prototype.toString` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.tostring
module.exports = $diise ? ({}).toString : function toString() {
    return "[object " + $kX3vM(this) + "]";
};

});


parcelRequire.register("jWGiO", function(module, exports) {
"use strict";

var $blPhI = parcelRequire("blPhI");
var $e8543f814bc3e8f8$require$charAt = $blPhI.charAt;

var $4svOe = parcelRequire("4svOe");

var $jAamA = parcelRequire("jAamA");

var $jBzdX = parcelRequire("jBzdX");

var $jdLGr = parcelRequire("jdLGr");
var $e8543f814bc3e8f8$var$STRING_ITERATOR = "String Iterator";
var $e8543f814bc3e8f8$var$setInternalState = $jAamA.set;
var $e8543f814bc3e8f8$var$getInternalState = $jAamA.getterFor($e8543f814bc3e8f8$var$STRING_ITERATOR);
// `String.prototype[@@iterator]` method
// https://tc39.es/ecma262/#sec-string.prototype-@@iterator
$jBzdX(String, "String", function(iterated) {
    $e8543f814bc3e8f8$var$setInternalState(this, {
        type: $e8543f814bc3e8f8$var$STRING_ITERATOR,
        string: $4svOe(iterated),
        index: 0
    });
// `%StringIteratorPrototype%.next` method
// https://tc39.es/ecma262/#sec-%stringiteratorprototype%.next
}, function next() {
    var state = $e8543f814bc3e8f8$var$getInternalState(this);
    var string = state.string;
    var index = state.index;
    var point;
    if (index >= string.length) return $jdLGr(undefined, true);
    point = $e8543f814bc3e8f8$require$charAt(string, index);
    state.index += point.length;
    return $jdLGr(point, false);
});

});
parcelRequire.register("blPhI", function(module, exports) {

var $kkBYw = parcelRequire("kkBYw");

var $dxgcn = parcelRequire("dxgcn");

var $4svOe = parcelRequire("4svOe");

var $kMH4t = parcelRequire("kMH4t");
var $84396ff54ae01642$var$charAt = $kkBYw("".charAt);
var $84396ff54ae01642$var$charCodeAt = $kkBYw("".charCodeAt);
var $84396ff54ae01642$var$stringSlice = $kkBYw("".slice);
var $84396ff54ae01642$var$createMethod = function(CONVERT_TO_STRING) {
    return function($this, pos) {
        var S = $4svOe($kMH4t($this));
        var position = $dxgcn(pos);
        var size = S.length;
        var first, second;
        if (position < 0 || position >= size) return CONVERT_TO_STRING ? "" : undefined;
        first = $84396ff54ae01642$var$charCodeAt(S, position);
        return first < 0xD800 || first > 0xDBFF || position + 1 === size || (second = $84396ff54ae01642$var$charCodeAt(S, position + 1)) < 0xDC00 || second > 0xDFFF ? CONVERT_TO_STRING ? $84396ff54ae01642$var$charAt(S, position) : first : CONVERT_TO_STRING ? $84396ff54ae01642$var$stringSlice(S, position, position + 2) : (first - 0xD800 << 10) + (second - 0xDC00) + 0x10000;
    };
};
module.exports = {
    // `String.prototype.codePointAt` method
    // https://tc39.es/ecma262/#sec-string.prototype.codepointat
    codeAt: $84396ff54ae01642$var$createMethod(false),
    // `String.prototype.at` method
    // https://github.com/mathiasbynens/String.prototype.at
    charAt: $84396ff54ae01642$var$createMethod(true)
};

});
parcelRequire.register("4svOe", function(module, exports) {

var $kX3vM = parcelRequire("kX3vM");
var $33f2739852bacf39$var$$String = String;
module.exports = function(argument) {
    if ($kX3vM(argument) === "Symbol") throw TypeError("Cannot convert a Symbol value to a string");
    return $33f2739852bacf39$var$$String(argument);
};

});


parcelRequire.register("jBzdX", function(module, exports) {
"use strict";

var $cliN7 = parcelRequire("cliN7");

var $1sYuu = parcelRequire("1sYuu");

var $gOsdW = parcelRequire("gOsdW");

var $bUJAi = parcelRequire("bUJAi");

var $18VOO = parcelRequire("18VOO");

var $9RTj6 = parcelRequire("9RTj6");

var $6Lw1Y = parcelRequire("6Lw1Y");

var $eRJKI = parcelRequire("eRJKI");

var $18pYh = parcelRequire("18pYh");

var $kBgag = parcelRequire("kBgag");

var $02JSJ = parcelRequire("02JSJ");

var $4r2jm = parcelRequire("4r2jm");

var $63DG3 = parcelRequire("63DG3");

var $9UX5D = parcelRequire("9UX5D");
var $e45ccbcae5438abe$var$PROPER_FUNCTION_NAME = $bUJAi.PROPER;
var $e45ccbcae5438abe$var$CONFIGURABLE_FUNCTION_NAME = $bUJAi.CONFIGURABLE;
var $e45ccbcae5438abe$var$IteratorPrototype = $9UX5D.IteratorPrototype;
var $e45ccbcae5438abe$var$BUGGY_SAFARI_ITERATORS = $9UX5D.BUGGY_SAFARI_ITERATORS;
var $e45ccbcae5438abe$var$ITERATOR = $4r2jm("iterator");
var $e45ccbcae5438abe$var$KEYS = "keys";
var $e45ccbcae5438abe$var$VALUES = "values";
var $e45ccbcae5438abe$var$ENTRIES = "entries";
var $e45ccbcae5438abe$var$returnThis = function() {
    return this;
};
module.exports = function(Iterable, NAME, IteratorConstructor, next, DEFAULT, IS_SET, FORCED) {
    $9RTj6(IteratorConstructor, NAME, next);
    var getIterationMethod = function(KIND) {
        if (KIND === DEFAULT && defaultIterator) return defaultIterator;
        if (!$e45ccbcae5438abe$var$BUGGY_SAFARI_ITERATORS && KIND in IterablePrototype) return IterablePrototype[KIND];
        switch(KIND){
            case $e45ccbcae5438abe$var$KEYS:
                return function keys() {
                    return new IteratorConstructor(this, KIND);
                };
            case $e45ccbcae5438abe$var$VALUES:
                return function values() {
                    return new IteratorConstructor(this, KIND);
                };
            case $e45ccbcae5438abe$var$ENTRIES:
                return function entries() {
                    return new IteratorConstructor(this, KIND);
                };
        }
        return function() {
            return new IteratorConstructor(this);
        };
    };
    var TO_STRING_TAG = NAME + " Iterator";
    var INCORRECT_VALUES_NAME = false;
    var IterablePrototype = Iterable.prototype;
    var nativeIterator = IterablePrototype[$e45ccbcae5438abe$var$ITERATOR] || IterablePrototype["@@iterator"] || DEFAULT && IterablePrototype[DEFAULT];
    var defaultIterator = !$e45ccbcae5438abe$var$BUGGY_SAFARI_ITERATORS && nativeIterator || getIterationMethod(DEFAULT);
    var anyNativeIterator = NAME == "Array" ? IterablePrototype.entries || nativeIterator : nativeIterator;
    var CurrentIteratorPrototype, methods, KEY;
    // fix native
    if (anyNativeIterator) {
        CurrentIteratorPrototype = $6Lw1Y(anyNativeIterator.call(new Iterable()));
        if (CurrentIteratorPrototype !== Object.prototype && CurrentIteratorPrototype.next) {
            if (!$gOsdW && $6Lw1Y(CurrentIteratorPrototype) !== $e45ccbcae5438abe$var$IteratorPrototype) {
                if ($eRJKI) $eRJKI(CurrentIteratorPrototype, $e45ccbcae5438abe$var$IteratorPrototype);
                else if (!$18VOO(CurrentIteratorPrototype[$e45ccbcae5438abe$var$ITERATOR])) $02JSJ(CurrentIteratorPrototype, $e45ccbcae5438abe$var$ITERATOR, $e45ccbcae5438abe$var$returnThis);
            }
            // Set @@toStringTag to native iterators
            $18pYh(CurrentIteratorPrototype, TO_STRING_TAG, true, true);
            if ($gOsdW) $63DG3[TO_STRING_TAG] = $e45ccbcae5438abe$var$returnThis;
        }
    }
    // fix Array.prototype.{ values, @@iterator }.name in V8 / FF
    if ($e45ccbcae5438abe$var$PROPER_FUNCTION_NAME && DEFAULT == $e45ccbcae5438abe$var$VALUES && nativeIterator && nativeIterator.name !== $e45ccbcae5438abe$var$VALUES) {
        if (!$gOsdW && $e45ccbcae5438abe$var$CONFIGURABLE_FUNCTION_NAME) $kBgag(IterablePrototype, "name", $e45ccbcae5438abe$var$VALUES);
        else {
            INCORRECT_VALUES_NAME = true;
            defaultIterator = function values() {
                return $1sYuu(nativeIterator, this);
            };
        }
    }
    // export additional methods
    if (DEFAULT) {
        methods = {
            values: getIterationMethod($e45ccbcae5438abe$var$VALUES),
            keys: IS_SET ? defaultIterator : getIterationMethod($e45ccbcae5438abe$var$KEYS),
            entries: getIterationMethod($e45ccbcae5438abe$var$ENTRIES)
        };
        if (FORCED) {
            for(KEY in methods)if ($e45ccbcae5438abe$var$BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME || !(KEY in IterablePrototype)) $02JSJ(IterablePrototype, KEY, methods[KEY]);
        } else $cliN7({
            target: NAME,
            proto: true,
            forced: $e45ccbcae5438abe$var$BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME
        }, methods);
    }
    // define iterator
    if ((!$gOsdW || FORCED) && IterablePrototype[$e45ccbcae5438abe$var$ITERATOR] !== defaultIterator) $02JSJ(IterablePrototype, $e45ccbcae5438abe$var$ITERATOR, defaultIterator, {
        name: DEFAULT
    });
    $63DG3[NAME] = defaultIterator;
    return methods;
};

});
parcelRequire.register("9RTj6", function(module, exports) {
"use strict";

var $9UX5D = parcelRequire("9UX5D");
var $72f3f727fc4b0484$require$IteratorPrototype = $9UX5D.IteratorPrototype;

var $5Cv8B = parcelRequire("5Cv8B");

var $edNYr = parcelRequire("edNYr");

var $18pYh = parcelRequire("18pYh");

var $63DG3 = parcelRequire("63DG3");
var $72f3f727fc4b0484$var$returnThis = function() {
    return this;
};
module.exports = function(IteratorConstructor, NAME, next, ENUMERABLE_NEXT) {
    var TO_STRING_TAG = NAME + " Iterator";
    IteratorConstructor.prototype = $5Cv8B($72f3f727fc4b0484$require$IteratorPrototype, {
        next: $edNYr(+!ENUMERABLE_NEXT, next)
    });
    $18pYh(IteratorConstructor, TO_STRING_TAG, false, true);
    $63DG3[TO_STRING_TAG] = $72f3f727fc4b0484$var$returnThis;
    return IteratorConstructor;
};

});
parcelRequire.register("9UX5D", function(module, exports) {
"use strict";

var $2aNMZ = parcelRequire("2aNMZ");

var $18VOO = parcelRequire("18VOO");

var $6FOrH = parcelRequire("6FOrH");

var $5Cv8B = parcelRequire("5Cv8B");

var $6Lw1Y = parcelRequire("6Lw1Y");

var $02JSJ = parcelRequire("02JSJ");

var $4r2jm = parcelRequire("4r2jm");

var $gOsdW = parcelRequire("gOsdW");
var $73872e09978047a6$var$ITERATOR = $4r2jm("iterator");
var $73872e09978047a6$var$BUGGY_SAFARI_ITERATORS = false;
// `%IteratorPrototype%` object
// https://tc39.es/ecma262/#sec-%iteratorprototype%-object
var $73872e09978047a6$var$IteratorPrototype, $73872e09978047a6$var$PrototypeOfArrayIteratorPrototype, $73872e09978047a6$var$arrayIterator;
/* eslint-disable es/no-array-prototype-keys -- safe */ if ([].keys) {
    $73872e09978047a6$var$arrayIterator = [].keys();
    // Safari 8 has buggy iterators w/o `next`
    if (!("next" in $73872e09978047a6$var$arrayIterator)) $73872e09978047a6$var$BUGGY_SAFARI_ITERATORS = true;
    else {
        $73872e09978047a6$var$PrototypeOfArrayIteratorPrototype = $6Lw1Y($6Lw1Y($73872e09978047a6$var$arrayIterator));
        if ($73872e09978047a6$var$PrototypeOfArrayIteratorPrototype !== Object.prototype) $73872e09978047a6$var$IteratorPrototype = $73872e09978047a6$var$PrototypeOfArrayIteratorPrototype;
    }
}
var $73872e09978047a6$var$NEW_ITERATOR_PROTOTYPE = !$6FOrH($73872e09978047a6$var$IteratorPrototype) || $2aNMZ(function() {
    var test = {};
    // FF44- legacy iterators case
    return $73872e09978047a6$var$IteratorPrototype[$73872e09978047a6$var$ITERATOR].call(test) !== test;
});
if ($73872e09978047a6$var$NEW_ITERATOR_PROTOTYPE) $73872e09978047a6$var$IteratorPrototype = {};
else if ($gOsdW) $73872e09978047a6$var$IteratorPrototype = $5Cv8B($73872e09978047a6$var$IteratorPrototype);
// `%IteratorPrototype%[@@iterator]()` method
// https://tc39.es/ecma262/#sec-%iteratorprototype%-@@iterator
if (!$18VOO($73872e09978047a6$var$IteratorPrototype[$73872e09978047a6$var$ITERATOR])) $02JSJ($73872e09978047a6$var$IteratorPrototype, $73872e09978047a6$var$ITERATOR, function() {
    return this;
});
module.exports = {
    IteratorPrototype: $73872e09978047a6$var$IteratorPrototype,
    BUGGY_SAFARI_ITERATORS: $73872e09978047a6$var$BUGGY_SAFARI_ITERATORS
};

});
parcelRequire.register("5Cv8B", function(module, exports) {
/* global ActiveXObject -- old IE, WSH */ 
var $78ijy = parcelRequire("78ijy");

var $fwQBd = parcelRequire("fwQBd");

var $jG3Gs = parcelRequire("jG3Gs");

var $hW3C9 = parcelRequire("hW3C9");

var $dHiOg = parcelRequire("dHiOg");

var $9ish2 = parcelRequire("9ish2");

var $4x3Dd = parcelRequire("4x3Dd");
var $4178a7ae91812070$var$GT = ">";
var $4178a7ae91812070$var$LT = "<";
var $4178a7ae91812070$var$PROTOTYPE = "prototype";
var $4178a7ae91812070$var$SCRIPT = "script";
var $4178a7ae91812070$var$IE_PROTO = $4x3Dd("IE_PROTO");
var $4178a7ae91812070$var$EmptyConstructor = function() {};
var $4178a7ae91812070$var$scriptTag = function(content) {
    return $4178a7ae91812070$var$LT + $4178a7ae91812070$var$SCRIPT + $4178a7ae91812070$var$GT + content + $4178a7ae91812070$var$LT + "/" + $4178a7ae91812070$var$SCRIPT + $4178a7ae91812070$var$GT;
};
// Create object with fake `null` prototype: use ActiveX Object with cleared prototype
var $4178a7ae91812070$var$NullProtoObjectViaActiveX = function(activeXDocument) {
    activeXDocument.write($4178a7ae91812070$var$scriptTag(""));
    activeXDocument.close();
    var temp = activeXDocument.parentWindow.Object;
    activeXDocument = null; // avoid memory leak
    return temp;
};
// Create object with fake `null` prototype: use iframe Object with cleared prototype
var $4178a7ae91812070$var$NullProtoObjectViaIFrame = function() {
    // Thrash, waste and sodomy: IE GC bug
    var iframe = $9ish2("iframe");
    var JS = "java" + $4178a7ae91812070$var$SCRIPT + ":";
    var iframeDocument;
    iframe.style.display = "none";
    $dHiOg.appendChild(iframe);
    // https://github.com/zloirock/core-js/issues/475
    iframe.src = String(JS);
    iframeDocument = iframe.contentWindow.document;
    iframeDocument.open();
    iframeDocument.write($4178a7ae91812070$var$scriptTag("document.F=Object"));
    iframeDocument.close();
    return iframeDocument.F;
};
// Check for document.domain and active x support
// No need to use active x approach when document.domain is not set
// see https://github.com/es-shims/es5-shim/issues/150
// variation of https://github.com/kitcambridge/es5-shim/commit/4f738ac066346
// avoid IE GC bug
var $4178a7ae91812070$var$activeXDocument;
var $4178a7ae91812070$var$NullProtoObject = function() {
    try {
        $4178a7ae91812070$var$activeXDocument = new ActiveXObject("htmlfile");
    } catch (error) {}
    $4178a7ae91812070$var$NullProtoObject = typeof document != "undefined" ? document.domain && $4178a7ae91812070$var$activeXDocument ? $4178a7ae91812070$var$NullProtoObjectViaActiveX($4178a7ae91812070$var$activeXDocument) // old IE
     : $4178a7ae91812070$var$NullProtoObjectViaIFrame() : $4178a7ae91812070$var$NullProtoObjectViaActiveX($4178a7ae91812070$var$activeXDocument); // WSH
    var length = $jG3Gs.length;
    while(length--)delete $4178a7ae91812070$var$NullProtoObject[$4178a7ae91812070$var$PROTOTYPE][$jG3Gs[length]];
    return $4178a7ae91812070$var$NullProtoObject();
};
$hW3C9[$4178a7ae91812070$var$IE_PROTO] = true;
// `Object.create` method
// https://tc39.es/ecma262/#sec-object.create
// eslint-disable-next-line es/no-object-create -- safe
module.exports = Object.create || function create(O, Properties) {
    var result;
    if (O !== null) {
        $4178a7ae91812070$var$EmptyConstructor[$4178a7ae91812070$var$PROTOTYPE] = $78ijy(O);
        result = new $4178a7ae91812070$var$EmptyConstructor();
        $4178a7ae91812070$var$EmptyConstructor[$4178a7ae91812070$var$PROTOTYPE] = null;
        // add "__proto__" for Object.getPrototypeOf polyfill
        result[$4178a7ae91812070$var$IE_PROTO] = O;
    } else result = $4178a7ae91812070$var$NullProtoObject();
    return Properties === undefined ? result : $fwQBd.f(result, Properties);
};

});
parcelRequire.register("fwQBd", function(module, exports) {

$parcel$export(module.exports, "f", () => $b4e2a54b3483b48e$export$2d1720544b23b823, (v) => $b4e2a54b3483b48e$export$2d1720544b23b823 = v);
// `Object.defineProperties` method
// https://tc39.es/ecma262/#sec-object.defineproperties
// eslint-disable-next-line es/no-object-defineproperties -- safe
var $b4e2a54b3483b48e$export$2d1720544b23b823;

var $foS3H = parcelRequire("foS3H");

var $kmDOo = parcelRequire("kmDOo");

var $fmCgr = parcelRequire("fmCgr");

var $78ijy = parcelRequire("78ijy");

var $3XtJI = parcelRequire("3XtJI");

var $5ilfb = parcelRequire("5ilfb");
$b4e2a54b3483b48e$export$2d1720544b23b823 = $foS3H && !$kmDOo ? Object.defineProperties : function defineProperties(O, Properties) {
    $78ijy(O);
    var props = $3XtJI(Properties);
    var keys = $5ilfb(Properties);
    var length = keys.length;
    var index = 0;
    var key;
    while(length > index)$fmCgr.f(O, key = keys[index++], props[key]);
    return O;
};

});

parcelRequire.register("dHiOg", function(module, exports) {

var $7oweL = parcelRequire("7oweL");
module.exports = $7oweL("document", "documentElement");

});


parcelRequire.register("6Lw1Y", function(module, exports) {

var $aZx1N = parcelRequire("aZx1N");

var $18VOO = parcelRequire("18VOO");

var $lCYro = parcelRequire("lCYro");

var $4x3Dd = parcelRequire("4x3Dd");

var $aSkMf = parcelRequire("aSkMf");
var $4ecffa87c05db84b$var$IE_PROTO = $4x3Dd("IE_PROTO");
var $4ecffa87c05db84b$var$$Object = Object;
var $4ecffa87c05db84b$var$ObjectPrototype = $4ecffa87c05db84b$var$$Object.prototype;
// `Object.getPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.getprototypeof
// eslint-disable-next-line es/no-object-getprototypeof -- safe
module.exports = $aSkMf ? $4ecffa87c05db84b$var$$Object.getPrototypeOf : function(O) {
    var object = $lCYro(O);
    if ($aZx1N(object, $4ecffa87c05db84b$var$IE_PROTO)) return object[$4ecffa87c05db84b$var$IE_PROTO];
    var constructor = object.constructor;
    if ($18VOO(constructor) && object instanceof constructor) return constructor.prototype;
    return object instanceof $4ecffa87c05db84b$var$$Object ? $4ecffa87c05db84b$var$ObjectPrototype : null;
};

});
parcelRequire.register("aSkMf", function(module, exports) {

var $2aNMZ = parcelRequire("2aNMZ");
module.exports = !$2aNMZ(function() {
    function F() {}
    F.prototype.constructor = null;
    // eslint-disable-next-line es/no-object-getprototypeof -- required for testing
    return Object.getPrototypeOf(new F()) !== F.prototype;
});

});



parcelRequire.register("18pYh", function(module, exports) {

var $fmCgr = parcelRequire("fmCgr");
var $0d3aaf2029d40ca5$require$defineProperty = $fmCgr.f;

var $aZx1N = parcelRequire("aZx1N");

var $4r2jm = parcelRequire("4r2jm");
var $0d3aaf2029d40ca5$var$TO_STRING_TAG = $4r2jm("toStringTag");
module.exports = function(target, TAG, STATIC) {
    if (target && !STATIC) target = target.prototype;
    if (target && !$aZx1N(target, $0d3aaf2029d40ca5$var$TO_STRING_TAG)) $0d3aaf2029d40ca5$require$defineProperty(target, $0d3aaf2029d40ca5$var$TO_STRING_TAG, {
        configurable: true,
        value: TAG
    });
};

});


parcelRequire.register("eRJKI", function(module, exports) {
/* eslint-disable no-proto -- safe */ 
var $7TtbX = parcelRequire("7TtbX");

var $78ijy = parcelRequire("78ijy");

var $9LijC = parcelRequire("9LijC");
// `Object.setPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.setprototypeof
// Works with __proto__ only. Old v8 can't work with null proto objects.
// eslint-disable-next-line es/no-object-setprototypeof -- safe
module.exports = Object.setPrototypeOf || ("__proto__" in {} ? function() {
    var CORRECT_SETTER = false;
    var test = {};
    var setter;
    try {
        setter = $7TtbX(Object.prototype, "__proto__", "set");
        setter(test, []);
        CORRECT_SETTER = test instanceof Array;
    } catch (error) {}
    return function setPrototypeOf(O, proto) {
        $78ijy(O);
        $9LijC(proto);
        if (CORRECT_SETTER) setter(O, proto);
        else O.__proto__ = proto;
        return O;
    };
}() : undefined);

});
parcelRequire.register("7TtbX", function(module, exports) {

var $kkBYw = parcelRequire("kkBYw");

var $8FpFb = parcelRequire("8FpFb");
module.exports = function(object, key, method) {
    try {
        // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
        return $kkBYw($8FpFb(Object.getOwnPropertyDescriptor(object, key)[method]));
    } catch (error) {}
};

});

parcelRequire.register("9LijC", function(module, exports) {

var $18VOO = parcelRequire("18VOO");
var $71b6b5e7bc2975ad$var$$String = String;
var $71b6b5e7bc2975ad$var$$TypeError = TypeError;
module.exports = function(argument) {
    if (typeof argument == "object" || $18VOO(argument)) return argument;
    throw $71b6b5e7bc2975ad$var$$TypeError("Can't set " + $71b6b5e7bc2975ad$var$$String(argument) + " as a prototype");
};

});



parcelRequire.register("jdLGr", function(module, exports) {
// `CreateIterResultObject` abstract operation
// https://tc39.es/ecma262/#sec-createiterresultobject
module.exports = function(value, done) {
    return {
        value: value,
        done: done
    };
};

});


parcelRequire.register("6QS1f", function(module, exports) {

var $7nYI8 = parcelRequire("7nYI8");

var $bAZju = parcelRequire("bAZju");

var $flK19 = parcelRequire("flK19");

var $iyFU1 = parcelRequire("iyFU1");

var $kBgag = parcelRequire("kBgag");

var $4r2jm = parcelRequire("4r2jm");
var $01499296a9770742$var$ITERATOR = $4r2jm("iterator");
var $01499296a9770742$var$TO_STRING_TAG = $4r2jm("toStringTag");
var $01499296a9770742$var$ArrayValues = $iyFU1.values;
var $01499296a9770742$var$handlePrototype = function(CollectionPrototype, COLLECTION_NAME) {
    if (CollectionPrototype) {
        // some Chrome versions have non-configurable methods on DOMTokenList
        if (CollectionPrototype[$01499296a9770742$var$ITERATOR] !== $01499296a9770742$var$ArrayValues) try {
            $kBgag(CollectionPrototype, $01499296a9770742$var$ITERATOR, $01499296a9770742$var$ArrayValues);
        } catch (error) {
            CollectionPrototype[$01499296a9770742$var$ITERATOR] = $01499296a9770742$var$ArrayValues;
        }
        if (!CollectionPrototype[$01499296a9770742$var$TO_STRING_TAG]) $kBgag(CollectionPrototype, $01499296a9770742$var$TO_STRING_TAG, COLLECTION_NAME);
        if ($bAZju[COLLECTION_NAME]) for(var METHOD_NAME in $iyFU1){
            // some Chrome versions have non-configurable methods on DOMTokenList
            if (CollectionPrototype[METHOD_NAME] !== $iyFU1[METHOD_NAME]) try {
                $kBgag(CollectionPrototype, METHOD_NAME, $iyFU1[METHOD_NAME]);
            } catch (error) {
                CollectionPrototype[METHOD_NAME] = $iyFU1[METHOD_NAME];
            }
        }
    }
};
for(var $01499296a9770742$var$COLLECTION_NAME in $bAZju)$01499296a9770742$var$handlePrototype($7nYI8[$01499296a9770742$var$COLLECTION_NAME] && $7nYI8[$01499296a9770742$var$COLLECTION_NAME].prototype, $01499296a9770742$var$COLLECTION_NAME);
$01499296a9770742$var$handlePrototype($flK19, "DOMTokenList");

});
parcelRequire.register("bAZju", function(module, exports) {
// iterable DOM collections
// flag - `iterable` interface - 'entries', 'keys', 'values', 'forEach' methods
module.exports = {
    CSSRuleList: 0,
    CSSStyleDeclaration: 0,
    CSSValueList: 0,
    ClientRectList: 0,
    DOMRectList: 0,
    DOMStringList: 0,
    DOMTokenList: 1,
    DataTransferItemList: 0,
    FileList: 0,
    HTMLAllCollection: 0,
    HTMLCollection: 0,
    HTMLFormElement: 0,
    HTMLSelectElement: 0,
    MediaList: 0,
    MimeTypeArray: 0,
    NamedNodeMap: 0,
    NodeList: 1,
    PaintRequestList: 0,
    Plugin: 0,
    PluginArray: 0,
    SVGLengthList: 0,
    SVGNumberList: 0,
    SVGPathSegList: 0,
    SVGPointList: 0,
    SVGStringList: 0,
    SVGTransformList: 0,
    SourceBufferList: 0,
    StyleSheetList: 0,
    TextTrackCueList: 0,
    TextTrackList: 0,
    TouchList: 0
};

});

parcelRequire.register("flK19", function(module, exports) {
// in old WebKit versions, `element.classList` is not an instance of global `DOMTokenList`

var $9ish2 = parcelRequire("9ish2");
var $b2cc8351a48ac5da$var$classList = $9ish2("span").classList;
var $b2cc8351a48ac5da$var$DOMTokenListPrototype = $b2cc8351a48ac5da$var$classList && $b2cc8351a48ac5da$var$classList.constructor && $b2cc8351a48ac5da$var$classList.constructor.prototype;
module.exports = $b2cc8351a48ac5da$var$DOMTokenListPrototype === Object.prototype ? undefined : $b2cc8351a48ac5da$var$DOMTokenListPrototype;

});

parcelRequire.register("iyFU1", function(module, exports) {
"use strict";

var $3XtJI = parcelRequire("3XtJI");

var $gHLKf = parcelRequire("gHLKf");

var $63DG3 = parcelRequire("63DG3");

var $jAamA = parcelRequire("jAamA");

var $fmCgr = parcelRequire("fmCgr");
var $d82be7f3fc97fcf8$require$defineProperty = $fmCgr.f;

var $jBzdX = parcelRequire("jBzdX");

var $jdLGr = parcelRequire("jdLGr");

var $gOsdW = parcelRequire("gOsdW");

var $foS3H = parcelRequire("foS3H");
var $d82be7f3fc97fcf8$var$ARRAY_ITERATOR = "Array Iterator";
var $d82be7f3fc97fcf8$var$setInternalState = $jAamA.set;
var $d82be7f3fc97fcf8$var$getInternalState = $jAamA.getterFor($d82be7f3fc97fcf8$var$ARRAY_ITERATOR);
// `Array.prototype.entries` method
// https://tc39.es/ecma262/#sec-array.prototype.entries
// `Array.prototype.keys` method
// https://tc39.es/ecma262/#sec-array.prototype.keys
// `Array.prototype.values` method
// https://tc39.es/ecma262/#sec-array.prototype.values
// `Array.prototype[@@iterator]` method
// https://tc39.es/ecma262/#sec-array.prototype-@@iterator
// `CreateArrayIterator` internal method
// https://tc39.es/ecma262/#sec-createarrayiterator
module.exports = $jBzdX(Array, "Array", function(iterated, kind) {
    $d82be7f3fc97fcf8$var$setInternalState(this, {
        type: $d82be7f3fc97fcf8$var$ARRAY_ITERATOR,
        target: $3XtJI(iterated),
        index: 0,
        kind: kind // kind
    });
// `%ArrayIteratorPrototype%.next` method
// https://tc39.es/ecma262/#sec-%arrayiteratorprototype%.next
}, function() {
    var state = $d82be7f3fc97fcf8$var$getInternalState(this);
    var target = state.target;
    var kind = state.kind;
    var index = state.index++;
    if (!target || index >= target.length) {
        state.target = undefined;
        return $jdLGr(undefined, true);
    }
    if (kind == "keys") return $jdLGr(index, false);
    if (kind == "values") return $jdLGr(target[index], false);
    return $jdLGr([
        index,
        target[index]
    ], false);
}, "values");
// argumentsList[@@iterator] is %ArrayProto_values%
// https://tc39.es/ecma262/#sec-createunmappedargumentsobject
// https://tc39.es/ecma262/#sec-createmappedargumentsobject
var $d82be7f3fc97fcf8$var$values = $63DG3.Arguments = $63DG3.Array;
// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
$gHLKf("keys");
$gHLKf("values");
$gHLKf("entries");
// V8 ~ Chrome 45- bug
if (!$gOsdW && $foS3H && $d82be7f3fc97fcf8$var$values.name !== "values") try {
    $d82be7f3fc97fcf8$require$defineProperty($d82be7f3fc97fcf8$var$values, "name", {
        value: "values"
    });
} catch (error) {}

});
parcelRequire.register("gHLKf", function(module, exports) {

var $4r2jm = parcelRequire("4r2jm");

var $5Cv8B = parcelRequire("5Cv8B");

var $fmCgr = parcelRequire("fmCgr");
var $c295b2a3ec3bacb1$require$defineProperty = $fmCgr.f;
var $c295b2a3ec3bacb1$var$UNSCOPABLES = $4r2jm("unscopables");
var $c295b2a3ec3bacb1$var$ArrayPrototype = Array.prototype;
// Array.prototype[@@unscopables]
// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
if ($c295b2a3ec3bacb1$var$ArrayPrototype[$c295b2a3ec3bacb1$var$UNSCOPABLES] == undefined) $c295b2a3ec3bacb1$require$defineProperty($c295b2a3ec3bacb1$var$ArrayPrototype, $c295b2a3ec3bacb1$var$UNSCOPABLES, {
    configurable: true,
    value: $5Cv8B(null)
});
// add a key to Array.prototype[@@unscopables]
module.exports = function(key) {
    $c295b2a3ec3bacb1$var$ArrayPrototype[$c295b2a3ec3bacb1$var$UNSCOPABLES][key] = true;
};

});





parcelRequire.register("aTBap", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $7eebdefd946e4c50$var$shareObservable;
/* global Observable */ function $7eebdefd946e4c50$var$shareObservable(observable) {
    var observers = [];
    var subscription;
    return new Observable(function(observer) {
        if (!subscription) subscription = observable.subscribe({
            complete: function complete() {
                observers.forEach(function(observer) {
                    return observer.complete();
                });
            },
            error: function error(err) {
                observers.forEach(function(observer) {
                    return observer.error(err);
                });
            },
            next: function next(value) {
                observers.forEach(function(observer) {
                    return observer.next(value);
                });
            }
        });
        observers.push(observer);
        return function() {
            observers = observers.filter(function(o) {
                return o !== observer;
            });
            if (!observers.length) {
                subscription.unsubscribe();
                subscription = null;
            }
        };
    });
}

});


parcelRequire.register("aayCS", function(module, exports) {
"use strict";

var $cP3px = parcelRequire("cP3px");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $7675b28e1fb490f9$var$patchDialogServiceConnectorInline;

var $7675b28e1fb490f9$var$_toConsumableArray2 = $cP3px((parcelRequire("fJegQ")));

var $7675b28e1fb490f9$var$_pDeferEs = $cP3px((parcelRequire("5la41")));
// Patching a function to add pre-processing of arguments and post-processing of result.
function $7675b28e1fb490f9$var$patchFunction(fn, pre, post) {
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        args = pre ? pre.apply(void 0, (0, $7675b28e1fb490f9$var$_toConsumableArray2.default)(args)) : args;
        var result = fn.apply(void 0, (0, $7675b28e1fb490f9$var$_toConsumableArray2.default)(args));
        return post ? post(result) : result;
    };
}
function $7675b28e1fb490f9$var$patchDialogServiceConnectorInline(dialogServiceConnector) {
    // This function will patch DialogServiceConnector by modifying the object.
    // The patches are intended to fill-in features to make DialogServiceConnector object works like the full-fledged Recognizer object.
    var lastRecognitionDeferred;
    dialogServiceConnector.listenOnceAsync = $7675b28e1fb490f9$var$patchFunction(dialogServiceConnector.listenOnceAsync.bind(dialogServiceConnector), function(resolve, reject) {
        lastRecognitionDeferred = (0, $7675b28e1fb490f9$var$_pDeferEs.default)();
        for(var _len2 = arguments.length, args = new Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++)args[_key2 - 2] = arguments[_key2];
        return [
            $7675b28e1fb490f9$var$patchFunction(resolve, null, function(result) {
                lastRecognitionDeferred.resolve(result);
                return result;
            }),
            $7675b28e1fb490f9$var$patchFunction(reject, null, function(error) {
                lastRecognitionDeferred.reject(error);
                return error;
            })
        ].concat(args);
    }); // TODO: [P1] #2664 startContinuousRecognitionAsync is not working yet in Speech SDK 1.15.0.
    //       We need to polyfill to use listenOnceAsync instead, and disable stopContinuousRecognitionAsync.
    dialogServiceConnector.startContinuousRecognitionAsync = function(resolve, reject) {
        dialogServiceConnector.listenOnceAsync(function() {}, function(err) {
            resolve = null;
            reject && reject(err);
        });
        setTimeout(function() {
            reject = null;
            resolve && resolve();
        }, 0);
    }; // TODO: stopContinuousRecognitionAsync is not working yet.
    //       We will leave out the implementation as falsy, Web Chat will disable the microphone button after start dictate.
    //       This will prevent user from aborting speech recognition.
    // dialogServiceConnector.stopContinuousRecognitionAsync = resolve => {
    // };
    return dialogServiceConnector;
}

});
parcelRequire.register("fJegQ", function(module, exports) {

var $e1evP = parcelRequire("e1evP");

var $5U49y = parcelRequire("5U49y");

var $2BJYv = parcelRequire("2BJYv");

var $eVzlx = parcelRequire("eVzlx");
function $b73620dc81aed00c$var$_toConsumableArray(arr) {
    return $e1evP(arr) || $5U49y(arr) || $2BJYv(arr) || $eVzlx();
}
module.exports = $b73620dc81aed00c$var$_toConsumableArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRequire.register("e1evP", function(module, exports) {

var $969aR = parcelRequire("969aR");
function $a34c6a8e5c541d04$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $969aR(arr);
}
module.exports = $a34c6a8e5c541d04$var$_arrayWithoutHoles, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRequire.register("969aR", function(module, exports) {
function $69fbca69f7d19269$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
module.exports = $69fbca69f7d19269$var$_arrayLikeToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRequire.register("5U49y", function(module, exports) {
function $44c56771e6741e19$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
module.exports = $44c56771e6741e19$var$_iterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRequire.register("2BJYv", function(module, exports) {

var $969aR = parcelRequire("969aR");
function $1e62b32562ef6587$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $969aR(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $969aR(o, minLen);
}
module.exports = $1e62b32562ef6587$var$_unsupportedIterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRequire.register("eVzlx", function(module, exports) {
function $ade1ce9a70e17b6d$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
module.exports = $ade1ce9a70e17b6d$var$_nonIterableSpread, module.exports.__esModule = true, module.exports["default"] = module.exports;

});



parcelRequire.register("9O5Pd", function(module, exports) {
"use strict";

var $cP3px = parcelRequire("cP3px");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $723d4d536bde317f$var$refreshDirectLineToken;

var $723d4d536bde317f$var$_regenerator = $cP3px((parcelRequire("foOOj")));

var $723d4d536bde317f$var$_asyncToGenerator2 = $cP3px((parcelRequire("iV07h")));

var $723d4d536bde317f$var$_fetchJSON = $cP3px((parcelRequire("a13Kw")));
// Refreshes the given token
function $723d4d536bde317f$var$refreshDirectLineToken(_x) {
    return $723d4d536bde317f$var$_refreshDirectLineToken.apply(this, arguments);
}
function $723d4d536bde317f$var$_refreshDirectLineToken() {
    $723d4d536bde317f$var$_refreshDirectLineToken = (0, $723d4d536bde317f$var$_asyncToGenerator2.default)(/*#__PURE__*/ $723d4d536bde317f$var$_regenerator.default.mark(function _callee(token) {
        var _yield$fetchJSON, refreshedToken;
        return $723d4d536bde317f$var$_regenerator.default.wrap(function _callee$(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    _context.next = 2;
                    return (0, $723d4d536bde317f$var$_fetchJSON.default)("https://directline.botframework.com/v3/directline/tokens/refresh", {
                        headers: {
                            authorization: "Bearer ".concat(token)
                        },
                        method: "POST"
                    });
                case 2:
                    _yield$fetchJSON = _context.sent;
                    refreshedToken = _yield$fetchJSON.token;
                    return _context.abrupt("return", refreshedToken);
                case 5:
                case "end":
                    return _context.stop();
            }
        }, _callee);
    }));
    return $723d4d536bde317f$var$_refreshDirectLineToken.apply(this, arguments);
}

});
parcelRequire.register("a13Kw", function(module, exports) {
"use strict";

var $cP3px = parcelRequire("cP3px");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $74ace7eb6bc51e3e$var$fetchJSON;

var $74ace7eb6bc51e3e$var$_regenerator = $cP3px((parcelRequire("foOOj")));

var $74ace7eb6bc51e3e$var$_defineProperty2 = $cP3px((parcelRequire("2AzOD")));

var $74ace7eb6bc51e3e$var$_asyncToGenerator2 = $cP3px((parcelRequire("iV07h")));
function $74ace7eb6bc51e3e$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $74ace7eb6bc51e3e$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $74ace7eb6bc51e3e$var$ownKeys(Object(source), !0).forEach(function(key) {
            (0, $74ace7eb6bc51e3e$var$_defineProperty2.default)(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $74ace7eb6bc51e3e$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
// Helper function for fetching network resource as JSON
function $74ace7eb6bc51e3e$var$fetchJSON(_x, _x2) {
    return $74ace7eb6bc51e3e$var$_fetchJSON.apply(this, arguments);
}
function $74ace7eb6bc51e3e$var$_fetchJSON() {
    $74ace7eb6bc51e3e$var$_fetchJSON = (0, $74ace7eb6bc51e3e$var$_asyncToGenerator2.default)(/*#__PURE__*/ $74ace7eb6bc51e3e$var$_regenerator.default.mark(function _callee(url, options) {
        var res;
        return $74ace7eb6bc51e3e$var$_regenerator.default.wrap(function _callee$(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    _context.next = 2;
                    return fetch(url, $74ace7eb6bc51e3e$var$_objectSpread($74ace7eb6bc51e3e$var$_objectSpread({}, options), {}, {
                        headers: $74ace7eb6bc51e3e$var$_objectSpread($74ace7eb6bc51e3e$var$_objectSpread({}, options.headers), {}, {
                            accept: "application/json"
                        })
                    }));
                case 2:
                    res = _context.sent;
                    if (res.ok) {
                        _context.next = 5;
                        break;
                    }
                    throw new Error("Failed to fetch JSON from server due to ".concat(res.status));
                case 5:
                    return _context.abrupt("return", res.json());
                case 6:
                case "end":
                    return _context.stop();
            }
        }, _callee);
    }));
    return $74ace7eb6bc51e3e$var$_fetchJSON.apply(this, arguments);
}

});


parcelRequire.register("4v0uz", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $346a7069185ce169$var$resolveFunctionOrReturnValue;
function $346a7069185ce169$var$resolveFunctionOrReturnValue(fnOrValue) {
    return typeof fnOrValue === "function" ? fnOrValue() : fnOrValue;
}

});




parcelRequire.register("bpJl4", function(module, exports) {
"use strict";

var $luOtD = parcelRequire("luOtD");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $84f532de86e36f69$var$createFullStyleSet;

var $84f532de86e36f69$var$_defineProperty2 = $luOtD((parcelRequire("3w8Sv")));

var $fD7D4 = parcelRequire("fD7D4");

var $84f532de86e36f69$var$_createAdaptiveCardsStyleSet = $luOtD((parcelRequire("71Jjt")));
function $84f532de86e36f69$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $84f532de86e36f69$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $84f532de86e36f69$var$ownKeys(Object(source), !0).forEach(function(key) {
            (0, $84f532de86e36f69$var$_defineProperty2.default)(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $84f532de86e36f69$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
// TODO: [P4] We should add a notice for people who want to use "styleSet" instead of "styleOptions".
//       "styleSet" is actually CSS stylesheet and it is based on the DOM tree.
//       DOM tree may change from time to time, thus, maintaining "styleSet" becomes a constant effort.
function $84f532de86e36f69$var$createFullStyleSet(options) {
    return $84f532de86e36f69$var$_objectSpread($84f532de86e36f69$var$_objectSpread({}, (0, $fD7D4.createStyleSet)(options)), (0, $84f532de86e36f69$var$_createAdaptiveCardsStyleSet.default)(options));
}

});
parcelRequire.register("71Jjt", function(module, exports) {
"use strict";

var $luOtD = parcelRequire("luOtD");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $51dbc6a0ede22139$var$createAdaptiveCardsStyleSet;

var $51dbc6a0ede22139$var$_defineProperty2 = $luOtD((parcelRequire("3w8Sv")));

var $hd4g0 = parcelRequire("hd4g0");

var $51dbc6a0ede22139$var$_AdaptiveCardRenderer = $luOtD((parcelRequire("i4iEM")));

var $51dbc6a0ede22139$var$_AnimationCardAttachment = $luOtD((parcelRequire("3CXoQ")));

var $51dbc6a0ede22139$var$_AudioCardAttachment = $luOtD((parcelRequire("9ujFh")));

var $51dbc6a0ede22139$var$_normalizeStyleOptions = $luOtD((parcelRequire("gSEu1")));
function $51dbc6a0ede22139$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $51dbc6a0ede22139$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $51dbc6a0ede22139$var$ownKeys(Object(source), !0).forEach(function(key) {
            (0, $51dbc6a0ede22139$var$_defineProperty2.default)(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $51dbc6a0ede22139$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
// TODO: [P4] We should add a notice for people who want to use "styleSet" instead of "styleOptions".
//       "styleSet" is actually CSS stylesheet and it is based on the DOM tree.
//       DOM tree may change from time to time, thus, maintaining "styleSet" becomes a constant effort.
function $51dbc6a0ede22139$var$createAdaptiveCardsStyleSet(options) {
    var strictOptions = $51dbc6a0ede22139$var$_objectSpread($51dbc6a0ede22139$var$_objectSpread({}, (0, $hd4g0.normalizeStyleOptions)(options)), (0, $51dbc6a0ede22139$var$_normalizeStyleOptions.default)(options));
    return {
        adaptiveCardRenderer: (0, $51dbc6a0ede22139$var$_AdaptiveCardRenderer.default)(strictOptions),
        animationCardAttachment: (0, $51dbc6a0ede22139$var$_AnimationCardAttachment.default)(),
        audioCardAttachment: (0, $51dbc6a0ede22139$var$_AudioCardAttachment.default)(strictOptions)
    };
}

});
parcelRequire.register("i4iEM", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $d277129170cf81fa$var$_default;
function $d277129170cf81fa$var$_default(_ref) {
    var cardPushButtonBackgroundColor = _ref.cardPushButtonBackgroundColor, cardPushButtonTextColor = _ref.cardPushButtonTextColor, accent = _ref.accent, paddingRegular = _ref.paddingRegular, primaryFont = _ref.primaryFont;
    return {
        "&.webchat__adaptive-card-renderer": {
            // Related to #4075.
            // Adaptive Cards assume its host is in "forced border-box" mode.
            // In CSS, the default is "content-box" mode.
            // https://developer.mozilla.org/en-US/docs/Web/CSS/box-sizing#values
            "& *": {
                boxSizing: "border-box"
            },
            "& .ac-input, & .ac-inlineActionButton, & .ac-quickActionButton": {
                fontFamily: primaryFont
            },
            "& .ac-multichoiceInput": {
                padding: paddingRegular
            },
            "& .ac-pushButton": {
                appearance: "none",
                backgroundColor: "White",
                borderStyle: "solid",
                borderWidth: 1,
                color: accent,
                fontWeight: 600,
                padding: paddingRegular
            },
            "& .ac-pushButton.style-destructive": {
                backgroundColor: "#E50000",
                color: "white"
            },
            "& .ac-pushButton.style-destructive:hover, & .ac-pushButton.style-destructive:active": {
                backgroundColor: "#BF0000"
            },
            "& .ac-pushButton.style-positive": {
                backgroundColor: "#0078D7",
                color: "white"
            },
            "& .ac-pushButton.style-positive:hover, & .ac-pushButton.style-positive:active": {
                backgroundColor: "#006ABC"
            },
            // The following styles are copied from :disabled via Chromium.
            "& .ac-pushButton, & input, & select, & textarea": {
                '&[aria-disabled="true"]': {
                    backgroundColor: "rgba(239, 239, 239, 0.3)",
                    borderColor: "rgba(118, 118, 118, 0.3)",
                    borderStyle: "solid",
                    borderWidth: 1,
                    color: "#545454"
                }
            },
            '& .ac-pushButton[aria-disabled="true"]': {
                backgroundColor: "#EEE",
                color: "#4F4F4F"
            },
            '& .ac-pushButton[aria-pressed="true"]': {
                backgroundColor: cardPushButtonBackgroundColor,
                borderColor: cardPushButtonBackgroundColor,
                color: cardPushButtonTextColor
            },
            '& input[aria-disabled="true"]': {
                padding: "2px 1px"
            }
        }
    };
}

});

parcelRequire.register("3CXoQ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $2a42ff4492779307$var$AnimationCardAttachment;
// TODO: [P4] We are moving attachments related to Adaptive Cards out of "component"
//       Later, we will rewrite these attachments without Adaptive Cards
//       We are leaving the CSS here as-is for now
function $2a42ff4492779307$var$AnimationCardAttachment() {
    return {
        // TODO: [P2] We should not set "display" in styleSet, this will allow the user to break the layout for no good reasons.
        display: "flex",
        flexDirection: "column",
        "& > ul.media-list": {
            // TODO: [P2] We should not set "listStyleType" in styleSet, the user have no good reasons to change this.
            listStyleType: "none",
            margin: 0,
            padding: 0
        }
    };
}

});

parcelRequire.register("9ujFh", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $6e862b695df33249$var$AudioCardAttachment;
// TODO: [P4] We are moving attachments related to Adaptive Cards out of "component"
//       Later, we will rewrite these attachments without Adaptive Cards
//       We are leaving the CSS here as-is for now
function $6e862b695df33249$var$AudioCardAttachment(_ref) {
    var _ref$paddingRegular = _ref.paddingRegular, paddingRegular = _ref$paddingRegular === void 0 ? undefined : _ref$paddingRegular;
    return {
        // TODO: [P2] We should not set "display" in styleSet, this will allow the user to break the layout for no good reasons.
        display: "flex",
        flexDirection: "column",
        "& > ul.media-list": {
            // TODO: [P2] We should not set "listStyleType" in styleSet, the user have no good reasons to change this.
            listStyleType: "none",
            margin: paddingRegular,
            padding: 0
        }
    };
}

});



parcelRequire.register("caYbs", function(module, exports) {
"use strict";

var $luOtD = parcelRequire("luOtD");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8dd51a78718b3d65$var$_defineProperty2 = $luOtD((parcelRequire("3w8Sv")));

var $8dd51a78718b3d65$var$_extends2 = $luOtD((parcelRequire("aoGM2")));

var $fD7D4 = parcelRequire("fD7D4");

var $8dd51a78718b3d65$var$_propTypes = $luOtD((parcelRequire("f7UXb")));

var $8dd51a78718b3d65$var$_react = $luOtD((parcelRequire("eO7Kz")));

var $8dd51a78718b3d65$var$_AddFullBundle = $luOtD((parcelRequire("lj7VX")));
function $8dd51a78718b3d65$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $8dd51a78718b3d65$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $8dd51a78718b3d65$var$ownKeys(Object(source), !0).forEach(function(key) {
            (0, $8dd51a78718b3d65$var$_defineProperty2.default)(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $8dd51a78718b3d65$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var $8dd51a78718b3d65$var$Composer = $fD7D4.Components.Composer;
var $8dd51a78718b3d65$var$FullComposer = function FullComposer(props) {
    return /*#__PURE__*/ $8dd51a78718b3d65$var$_react.default.createElement($8dd51a78718b3d65$var$_AddFullBundle.default, props, function(extraProps) {
        return /*#__PURE__*/ $8dd51a78718b3d65$var$_react.default.createElement($8dd51a78718b3d65$var$Composer, (0, $8dd51a78718b3d65$var$_extends2.default)({}, props, extraProps), props.children);
    });
};
$8dd51a78718b3d65$var$FullComposer.defaultProps = $8dd51a78718b3d65$var$_objectSpread($8dd51a78718b3d65$var$_objectSpread({}, $8dd51a78718b3d65$var$Composer.defaultProps), {}, {
    adaptiveCardsHostConfig: undefined,
    adaptiveCardsPackage: undefined,
    children: undefined
});
$8dd51a78718b3d65$var$FullComposer.propTypes = $8dd51a78718b3d65$var$_objectSpread($8dd51a78718b3d65$var$_objectSpread({}, $8dd51a78718b3d65$var$Composer.propTypes), {}, {
    adaptiveCardsHostConfig: $8dd51a78718b3d65$var$_propTypes.default.any,
    adaptiveCardsPackage: $8dd51a78718b3d65$var$_propTypes.default.any,
    children: $8dd51a78718b3d65$var$_propTypes.default.any
});
var $8dd51a78718b3d65$var$_default = $8dd51a78718b3d65$var$FullComposer;
module.exports.default = $8dd51a78718b3d65$var$_default;

});
parcelRequire.register("aoGM2", function(module, exports) {
function $791d5340851a1775$var$_extends() {
    module.exports = $791d5340851a1775$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports;
    return $791d5340851a1775$var$_extends.apply(this, arguments);
}
module.exports = $791d5340851a1775$var$_extends, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRequire.register("lj7VX", function(module, exports) {
"use strict";

var $luOtD = parcelRequire("luOtD");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $cG9B9 = parcelRequire("cG9B9");

var $f83186cff892d5da$var$_propTypes = $luOtD((parcelRequire("f7UXb")));

var $f83186cff892d5da$var$_react = $luOtD((parcelRequire("eO7Kz")));

var $f83186cff892d5da$var$_AdaptiveCardsComposer = $luOtD((parcelRequire("h7jee")));

var $f83186cff892d5da$var$_useComposerProps = $luOtD((parcelRequire("7ffLf")));
var $f83186cff892d5da$var$adaptiveCardHostConfigDeprecation = (0, $cG9B9.warnOnce)('"adaptiveCardHostConfig" is deprecated. Please use "adaptiveCardsHostConfig" instead. "adaptiveCardHostConfig" will be removed on or after 2022-01-01.');
var $f83186cff892d5da$var$AddFullBundle = function AddFullBundle(_ref) {
    var adaptiveCardHostConfig = _ref.adaptiveCardHostConfig, adaptiveCardsHostConfig = _ref.adaptiveCardsHostConfig, adaptiveCardsPackage = _ref.adaptiveCardsPackage, attachmentForScreenReaderMiddleware = _ref.attachmentForScreenReaderMiddleware, attachmentMiddleware = _ref.attachmentMiddleware, children = _ref.children, renderMarkdown = _ref.renderMarkdown, styleOptions = _ref.styleOptions, styleSet = _ref.styleSet;
    adaptiveCardHostConfig && $f83186cff892d5da$var$adaptiveCardHostConfigDeprecation();
    var patchedProps = (0, $f83186cff892d5da$var$_useComposerProps.default)({
        attachmentForScreenReaderMiddleware: (0, $cG9B9.singleToArray)(attachmentForScreenReaderMiddleware),
        attachmentMiddleware: (0, $cG9B9.singleToArray)(attachmentMiddleware),
        renderMarkdown: renderMarkdown,
        styleOptions: styleOptions,
        styleSet: styleSet
    });
    return /*#__PURE__*/ $f83186cff892d5da$var$_react.default.createElement($f83186cff892d5da$var$_AdaptiveCardsComposer.default, {
        adaptiveCardsHostConfig: adaptiveCardHostConfig || adaptiveCardsHostConfig,
        adaptiveCardsPackage: adaptiveCardsPackage
    }, children(patchedProps));
};
$f83186cff892d5da$var$AddFullBundle.defaultProps = {
    adaptiveCardHostConfig: undefined,
    adaptiveCardsHostConfig: undefined,
    adaptiveCardsPackage: undefined,
    attachmentForScreenReaderMiddleware: undefined,
    attachmentMiddleware: undefined,
    renderMarkdown: undefined,
    styleOptions: undefined,
    styleSet: undefined
};
$f83186cff892d5da$var$AddFullBundle.propTypes = {
    adaptiveCardHostConfig: $f83186cff892d5da$var$_propTypes.default.any,
    adaptiveCardsHostConfig: $f83186cff892d5da$var$_propTypes.default.any,
    // TypeScript class is not mappable to PropTypes.func
    // @ts-ignore
    adaptiveCardsPackage: $f83186cff892d5da$var$_propTypes.default.shape({
        AdaptiveCard: $f83186cff892d5da$var$_propTypes.default.func.isRequired,
        HorizontalAlignment: $f83186cff892d5da$var$_propTypes.default.any.isRequired,
        TextSize: $f83186cff892d5da$var$_propTypes.default.any.isRequired,
        TextWeight: $f83186cff892d5da$var$_propTypes.default.any.isRequired
    }),
    attachmentForScreenReaderMiddleware: $f83186cff892d5da$var$_propTypes.default.oneOfType([
        $f83186cff892d5da$var$_propTypes.default.arrayOf($f83186cff892d5da$var$_propTypes.default.func),
        $f83186cff892d5da$var$_propTypes.default.func
    ]),
    attachmentMiddleware: $f83186cff892d5da$var$_propTypes.default.oneOfType([
        $f83186cff892d5da$var$_propTypes.default.arrayOf($f83186cff892d5da$var$_propTypes.default.func),
        $f83186cff892d5da$var$_propTypes.default.func
    ]),
    children: $f83186cff892d5da$var$_propTypes.default.func.isRequired,
    renderMarkdown: $f83186cff892d5da$var$_propTypes.default.func,
    styleOptions: $f83186cff892d5da$var$_propTypes.default.any,
    styleSet: $f83186cff892d5da$var$_propTypes.default.any
};
var $f83186cff892d5da$var$_default = $f83186cff892d5da$var$AddFullBundle;
module.exports.default = $f83186cff892d5da$var$_default;

});
parcelRequire.register("h7jee", function(module, exports) {
"use strict";

var $luOtD = parcelRequire("luOtD");

var $2PxO1 = parcelRequire("2PxO1");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c762017bc8d12fce$var$defaultAdaptiveCardsPackage = $c762017bc8d12fce$var$_interopRequireWildcard((parcelRequire("gqJaI")));

var $c762017bc8d12fce$var$_propTypes = $luOtD((parcelRequire("f7UXb")));

var $c762017bc8d12fce$var$_react = $c762017bc8d12fce$var$_interopRequireWildcard((parcelRequire("eO7Kz")));

var $c762017bc8d12fce$var$_AdaptiveCardsContext = $luOtD((parcelRequire("16V6h")));
function $c762017bc8d12fce$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($c762017bc8d12fce$var$_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $c762017bc8d12fce$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || $2PxO1(obj) !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $c762017bc8d12fce$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
var $c762017bc8d12fce$var$AdaptiveCardsComposer = function AdaptiveCardsComposer(_ref) {
    var adaptiveCardsHostConfig = _ref.adaptiveCardsHostConfig, adaptiveCardsPackage = _ref.adaptiveCardsPackage, children = _ref.children;
    var patchedAdaptiveCardsPackage = (0, $c762017bc8d12fce$var$_react.useMemo)(function() {
        return adaptiveCardsPackage || $c762017bc8d12fce$var$defaultAdaptiveCardsPackage;
    }, [
        adaptiveCardsPackage
    ]);
    var adaptiveCardsContext = (0, $c762017bc8d12fce$var$_react.useMemo)(function() {
        return {
            adaptiveCardsPackage: patchedAdaptiveCardsPackage,
            hostConfigFromProps: adaptiveCardsHostConfig
        };
    }, [
        adaptiveCardsHostConfig,
        patchedAdaptiveCardsPackage
    ]);
    return /*#__PURE__*/ $c762017bc8d12fce$var$_react.default.createElement($c762017bc8d12fce$var$_AdaptiveCardsContext.default.Provider, {
        value: adaptiveCardsContext
    }, children);
};
$c762017bc8d12fce$var$AdaptiveCardsComposer.defaultProps = {
    adaptiveCardsHostConfig: undefined,
    adaptiveCardsPackage: undefined,
    children: undefined
};
$c762017bc8d12fce$var$AdaptiveCardsComposer.propTypes = {
    adaptiveCardsHostConfig: $c762017bc8d12fce$var$_propTypes.default.any,
    adaptiveCardsPackage: $c762017bc8d12fce$var$_propTypes.default.any,
    children: $c762017bc8d12fce$var$_propTypes.default.any
};
var $c762017bc8d12fce$var$_default = $c762017bc8d12fce$var$AdaptiveCardsComposer;
module.exports.default = $c762017bc8d12fce$var$_default;

});

parcelRequire.register("7ffLf", function(module, exports) {
"use strict";

var $luOtD = parcelRequire("luOtD");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $546628f14614e6d8$var$useComposerProps;

var $546628f14614e6d8$var$_toConsumableArray2 = $luOtD((parcelRequire("9ErOw")));

var $eO7Kz = parcelRequire("eO7Kz");

var $546628f14614e6d8$var$_createAdaptiveCardsAttachmentForScreenReaderMiddleware = $luOtD((parcelRequire("gixiP")));

var $546628f14614e6d8$var$_createAdaptiveCardsAttachmentMiddleware = $luOtD((parcelRequire("kgxJb")));

var $546628f14614e6d8$var$_createAdaptiveCardsStyleSet = $luOtD((parcelRequire("71Jjt")));

var $546628f14614e6d8$var$_renderMarkdown = $luOtD((parcelRequire("gPdBB")));
function $546628f14614e6d8$var$useComposerProps(_ref) {
    var attachmentForScreenReaderMiddleware = _ref.attachmentForScreenReaderMiddleware, attachmentMiddleware = _ref.attachmentMiddleware, renderMarkdown = _ref.renderMarkdown, styleOptions = _ref.styleOptions, styleSet = _ref.styleSet;
    var patchedAttachmentMiddleware = (0, $eO7Kz.useMemo)(function() {
        return [].concat((0, $546628f14614e6d8$var$_toConsumableArray2.default)(attachmentMiddleware), [
            (0, $546628f14614e6d8$var$_createAdaptiveCardsAttachmentMiddleware.default)()
        ]);
    }, [
        attachmentMiddleware
    ]);
    var patchedAttachmentForScreenReaderMiddleware = (0, $eO7Kz.useMemo)(function() {
        return [].concat((0, $546628f14614e6d8$var$_toConsumableArray2.default)(attachmentForScreenReaderMiddleware), [
            (0, $546628f14614e6d8$var$_createAdaptiveCardsAttachmentForScreenReaderMiddleware.default)()
        ]);
    }, [
        attachmentForScreenReaderMiddleware
    ]); // When styleSet is not specified, the styleOptions will be used to create Adaptive Cards styleSet and merged into useStyleSet.
    var extraStyleSet = (0, $eO7Kz.useMemo)(function() {
        return styleSet ? undefined : (0, $546628f14614e6d8$var$_createAdaptiveCardsStyleSet.default)(styleOptions);
    }, [
        styleOptions,
        styleSet
    ]);
    var patchedRenderMarkdown = (0, $eO7Kz.useMemo)(function() {
        return typeof renderMarkdown === "undefined" ? $546628f14614e6d8$var$_renderMarkdown.default : renderMarkdown;
    }, [
        renderMarkdown
    ]);
    return {
        attachmentForScreenReaderMiddleware: patchedAttachmentForScreenReaderMiddleware,
        attachmentMiddleware: patchedAttachmentMiddleware,
        extraStyleSet: extraStyleSet,
        renderMarkdown: patchedRenderMarkdown
    };
}

});
parcelRequire.register("gPdBB", function(module, exports) {
"use strict";

var $luOtD = parcelRequire("luOtD");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $c3fbf68267224aa3$var$render;

var $c3fbf68267224aa3$var$_toConsumableArray2 = $luOtD((parcelRequire("9ErOw")));

var $c3fbf68267224aa3$var$_slicedToArray2 = $luOtD((parcelRequire("fhBCP")));

var $c3fbf68267224aa3$var$_markdownItForInline = $luOtD((parcelRequire("dN4Wm")));

var $c3fbf68267224aa3$var$_markdownIt = $luOtD((parcelRequire("4hDiw")));

var $c3fbf68267224aa3$var$_markdownItAttrsEs = $luOtD((parcelRequire("i3LEX")));

var $c3fbf68267224aa3$var$_sanitizeHtml = $luOtD((parcelRequire("9dNlI")));
/* eslint no-magic-numbers: ["error", { "ignore": [0, 1, 2] }] */ var $c3fbf68267224aa3$var$SANITIZE_HTML_OPTIONS = {
    allowedAttributes: {
        a: [
            "aria-label",
            "href",
            "name",
            "rel",
            "target",
            "title"
        ],
        img: [
            "alt",
            "class",
            "src"
        ]
    },
    allowedSchemes: [
        "data",
        "http",
        "https",
        "ftp",
        "mailto",
        "sip",
        "tel"
    ],
    allowedTags: [
        "a",
        "b",
        "blockquote",
        "br",
        "caption",
        "code",
        "del",
        "div",
        "em",
        "h1",
        "h2",
        "h3",
        "h4",
        "h5",
        "h6",
        "hr",
        "i",
        "img",
        "ins",
        "li",
        "nl",
        "ol",
        "p",
        "pre",
        "s",
        "span",
        "strike",
        "strong",
        "table",
        "tbody",
        "td",
        "tfoot",
        "th",
        "thead",
        "tr",
        "ul"
    ]
}; // Put a transparent pixel instead of the "open in new window" icon, so developers can easily modify the icon in CSS.
var $c3fbf68267224aa3$var$TRANSPARENT_GIF = "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7"; // This is used for parsing Markdown for external links.
var $c3fbf68267224aa3$var$internalMarkdownIt = new $c3fbf68267224aa3$var$_markdownIt.default();
var $c3fbf68267224aa3$var$MARKDOWN_ATTRS_LEFT_DELIMITER = "⟬"; // Make sure the delimiter is free from any RegExp characters, such as *, ?, etc.
// IE11 does not support "u" flag and Babel could not remove it. We intentionally omitting the "u" flag here.
// eslint-disable-next-line require-unicode-regexp
var $c3fbf68267224aa3$var$MARKDOWN_ATTRS_LEFT_DELIMITER_PATTERN = new RegExp($c3fbf68267224aa3$var$MARKDOWN_ATTRS_LEFT_DELIMITER, "g");
var $c3fbf68267224aa3$var$MARKDOWN_ATTRS_RIGHT_DELIMITER = "⟭"; // Make sure the delimiter is free from any RegExp characters, such as *, ?, etc.
// IE11 does not support "u" flag and Babel could not remove it. We intentionally omitting the "u" flag here.
// eslint-disable-next-line require-unicode-regexp
var $c3fbf68267224aa3$var$MARKDOWN_ATTRS_RIGHT_DELIMITER_PATTERN = new RegExp($c3fbf68267224aa3$var$MARKDOWN_ATTRS_RIGHT_DELIMITER, "g");
function $c3fbf68267224aa3$var$render(markdown, _ref) {
    var markdownRespectCRLF = _ref.markdownRespectCRLF;
    var _ref2 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {}, _ref2$externalLinkAlt = _ref2.externalLinkAlt, externalLinkAlt = _ref2$externalLinkAlt === void 0 ? "" : _ref2$externalLinkAlt;
    if (markdownRespectCRLF) markdown = markdown.replace(/\n\r|\r\n/g, function(carriageReturn) {
        return carriageReturn === "\n\r" ? "\r\n" : "\n\r";
    });
     // Related to #3165.
    // We only support attributes "aria-label" and should leave other attributes as-is.
    // However, `markdown-it-attrs` remove unrecognized attributes, such as {hello}.
    // Before passing to `markdown-it-attrs`, we will convert known attributes from {aria-label="..."} into ⟬aria-label="..."⟭ (using white tortoise shell brackets).
    // Then, we ask `markdown-it-attrs` to only process the new brackets, so it should only try to process things that we allowlisted.
    // Lastly, we revert tortoise shell brackets back to curly brackets, for unprocessed attributes.
    markdown = markdown.replace(/\{[\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]*aria\x2Dlabel()[\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]*\}/gi, "".concat($c3fbf68267224aa3$var$MARKDOWN_ATTRS_LEFT_DELIMITER, "aria-label").concat($c3fbf68267224aa3$var$MARKDOWN_ATTRS_RIGHT_DELIMITER)).replace(/\{[\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]*aria\x2Dlabel=("(?:(?!")[\s\S])*"|(?:(?![\t-\r \}\xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF])[\s\S])*)[\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]*\}/gi, function(_, valueInsideQuotes) {
        return "".concat($c3fbf68267224aa3$var$MARKDOWN_ATTRS_LEFT_DELIMITER, "aria-label=").concat(valueInsideQuotes).concat($c3fbf68267224aa3$var$MARKDOWN_ATTRS_RIGHT_DELIMITER);
    });
    var html = new $c3fbf68267224aa3$var$_markdownIt.default({
        breaks: false,
        html: false,
        linkify: true,
        typographer: true,
        xhtmlOut: true
    }).use($c3fbf68267224aa3$var$_markdownItAttrsEs.default, {
        // `markdown-it-attrs` is added for accessibility and allow bot developers to specify `aria-label`.
        // We are allowlisting `aria-label` only as it is allowlisted in `sanitize-html`.
        // Other `aria-*` will be sanitized even we allowlisted here.
        allowedAttributes: [
            "aria-label"
        ],
        leftDelimiter: $c3fbf68267224aa3$var$MARKDOWN_ATTRS_LEFT_DELIMITER,
        rightDelimiter: $c3fbf68267224aa3$var$MARKDOWN_ATTRS_RIGHT_DELIMITER
    }).use($c3fbf68267224aa3$var$_markdownItForInline.default, "url_new_win", "link_open", function(tokens, index) {
        var token = tokens[+index];
        token.attrSet("rel", "noopener noreferrer");
        token.attrSet("target", "_blank");
        var linkOpenToken = tokens.find(function(_ref3) {
            var type = _ref3.type;
            return type === "link_open";
        });
        var _linkOpenToken$attrs$ = linkOpenToken.attrs.find(function(_ref4) {
            var _ref5 = (0, $c3fbf68267224aa3$var$_slicedToArray2.default)(_ref4, 1), name = _ref5[0];
            return name === "href";
        }), _linkOpenToken$attrs$2 = (0, $c3fbf68267224aa3$var$_slicedToArray2.default)(_linkOpenToken$attrs$, 2), href = _linkOpenToken$attrs$2[1]; // Adds a new icon if the link is http: or https:.
        // Don't add if it's a phone number, etc.
        if (/^http[s\u017F]?:/i.test(href)) {
            externalLinkAlt && token.attrSet("title", externalLinkAlt);
            var iconTokens = $c3fbf68267224aa3$var$internalMarkdownIt.parseInline("![".concat(externalLinkAlt, "](").concat($c3fbf68267224aa3$var$TRANSPARENT_GIF, ")"))[0].children;
            iconTokens[0].attrJoin("class", "webchat__markdown__external-link-icon");
            tokens.splice.apply(tokens, [
                index + 2,
                0
            ].concat((0, $c3fbf68267224aa3$var$_toConsumableArray2.default)(iconTokens)));
        }
    }).render(markdown); // Restore attributes not processed by `markdown-it-attrs`.
    // TODO: [P2] #2511 After we fixed our polyfill story, we should use "String.prototype.replaceAll" instead of RegExp for replace all occurrences.
    html = html.replace($c3fbf68267224aa3$var$MARKDOWN_ATTRS_LEFT_DELIMITER_PATTERN, "{").replace($c3fbf68267224aa3$var$MARKDOWN_ATTRS_RIGHT_DELIMITER_PATTERN, "}"); // The signature from "sanitize-html" module is not correct.
    // @ts-ignore
    return (0, $c3fbf68267224aa3$var$_sanitizeHtml.default)(html, $c3fbf68267224aa3$var$SANITIZE_HTML_OPTIONS);
}

});
parcelRequire.register("dN4Wm", function(module, exports) {
"use strict";
module.exports = function for_inline_plugin(md, ruleName, tokenType, iteartor) {
    function scan(state) {
        var i, blkIdx, inlineTokens;
        for(blkIdx = state.tokens.length - 1; blkIdx >= 0; blkIdx--){
            if (state.tokens[blkIdx].type !== "inline") continue;
            inlineTokens = state.tokens[blkIdx].children;
            for(i = inlineTokens.length - 1; i >= 0; i--){
                if (inlineTokens[i].type !== tokenType) continue;
                iteartor(inlineTokens, i);
            }
        }
    }
    md.core.ruler.push(ruleName, scan);
};

});

parcelRequire.register("4hDiw", function(module, exports) {
"use strict";

module.exports = (parcelRequire("eopWU"));

});
parcelRequire.register("eopWU", function(module, exports) {
// Main parser class
"use strict";

var $iXVVQ = parcelRequire("iXVVQ");

var $702rI = parcelRequire("702rI");

var $dBmFH = parcelRequire("dBmFH");

var $2llij = parcelRequire("2llij");

var $4s2Z6 = parcelRequire("4s2Z6");

var $cyNW1 = parcelRequire("cyNW1");

var $jAtt2 = parcelRequire("jAtt2");

var $e2HUE = parcelRequire("e2HUE");

var $i3uit = parcelRequire("i3uit");



var $a7a76f86b0b20fdd$var$config = {
    default: (parcelRequire("4ixx2")),
    zero: (parcelRequire("3LBk3")),
    commonmark: (parcelRequire("bJcaQ"))
};
////////////////////////////////////////////////////////////////////////////////
//
// This validator can prohibit more than really needed to prevent XSS. It's a
// tradeoff to keep code simple and to be secure by default.
//
// If you need different setup - override validator method as you wish. Or
// replace it with dummy function and use external sanitizer.
//
var $a7a76f86b0b20fdd$var$BAD_PROTO_RE = /^(vbscript|javascript|file|data):/;
var $a7a76f86b0b20fdd$var$GOOD_DATA_RE = /^data:image\/(gif|png|jpeg|webp);/;
function $a7a76f86b0b20fdd$var$validateLink(url) {
    // url should be normalized at this point, and existing entities are decoded
    var str = url.trim().toLowerCase();
    return $a7a76f86b0b20fdd$var$BAD_PROTO_RE.test(str) ? $a7a76f86b0b20fdd$var$GOOD_DATA_RE.test(str) ? true : false : true;
}
////////////////////////////////////////////////////////////////////////////////
var $a7a76f86b0b20fdd$var$RECODE_HOSTNAME_FOR = [
    "http:",
    "https:",
    "mailto:"
];
function $a7a76f86b0b20fdd$var$normalizeLink(url) {
    var parsed = $e2HUE.parse(url, true);
    if (parsed.hostname) {
        // Encode hostnames in urls like:
        // `http://host/`, `https://host/`, `mailto:user@host`, `//host/`
        //
        // We don't encode unknown schemas, because it's likely that we encode
        // something we shouldn't (e.g. `skype:name` treated as `skype:host`)
        //
        if (!parsed.protocol || $a7a76f86b0b20fdd$var$RECODE_HOSTNAME_FOR.indexOf(parsed.protocol) >= 0) try {
            parsed.hostname = $i3uit.toASCII(parsed.hostname);
        } catch (er) {}
    }
    return $e2HUE.encode($e2HUE.format(parsed));
}
function $a7a76f86b0b20fdd$var$normalizeLinkText(url) {
    var parsed = $e2HUE.parse(url, true);
    if (parsed.hostname) {
        // Encode hostnames in urls like:
        // `http://host/`, `https://host/`, `mailto:user@host`, `//host/`
        //
        // We don't encode unknown schemas, because it's likely that we encode
        // something we shouldn't (e.g. `skype:name` treated as `skype:host`)
        //
        if (!parsed.protocol || $a7a76f86b0b20fdd$var$RECODE_HOSTNAME_FOR.indexOf(parsed.protocol) >= 0) try {
            parsed.hostname = $i3uit.toUnicode(parsed.hostname);
        } catch (er) {}
    }
    // add '%' to exclude list because of https://github.com/markdown-it/markdown-it/issues/720
    return $e2HUE.decode($e2HUE.format(parsed), $e2HUE.decode.defaultChars + "%");
}
/**
 * class MarkdownIt
 *
 * Main parser/renderer class.
 *
 * ##### Usage
 *
 * ```javascript
 * // node.js, "classic" way:
 * var MarkdownIt = require('markdown-it'),
 *     md = new MarkdownIt();
 * var result = md.render('# markdown-it rulezz!');
 *
 * // node.js, the same, but with sugar:
 * var md = require('markdown-it')();
 * var result = md.render('# markdown-it rulezz!');
 *
 * // browser without AMD, added to "window" on script load
 * // Note, there are no dash.
 * var md = window.markdownit();
 * var result = md.render('# markdown-it rulezz!');
 * ```
 *
 * Single line rendering, without paragraph wrap:
 *
 * ```javascript
 * var md = require('markdown-it')();
 * var result = md.renderInline('__markdown-it__ rulezz!');
 * ```
 **/ /**
 * new MarkdownIt([presetName, options])
 * - presetName (String): optional, `commonmark` / `zero`
 * - options (Object)
 *
 * Creates parser instanse with given config. Can be called without `new`.
 *
 * ##### presetName
 *
 * MarkdownIt provides named presets as a convenience to quickly
 * enable/disable active syntax rules and options for common use cases.
 *
 * - ["commonmark"](https://github.com/markdown-it/markdown-it/blob/master/lib/presets/commonmark.js) -
 *   configures parser to strict [CommonMark](http://commonmark.org/) mode.
 * - [default](https://github.com/markdown-it/markdown-it/blob/master/lib/presets/default.js) -
 *   similar to GFM, used when no preset name given. Enables all available rules,
 *   but still without html, typographer & autolinker.
 * - ["zero"](https://github.com/markdown-it/markdown-it/blob/master/lib/presets/zero.js) -
 *   all rules disabled. Useful to quickly setup your config via `.enable()`.
 *   For example, when you need only `bold` and `italic` markup and nothing else.
 *
 * ##### options:
 *
 * - __html__ - `false`. Set `true` to enable HTML tags in source. Be careful!
 *   That's not safe! You may need external sanitizer to protect output from XSS.
 *   It's better to extend features via plugins, instead of enabling HTML.
 * - __xhtmlOut__ - `false`. Set `true` to add '/' when closing single tags
 *   (`<br />`). This is needed only for full CommonMark compatibility. In real
 *   world you will need HTML output.
 * - __breaks__ - `false`. Set `true` to convert `\n` in paragraphs into `<br>`.
 * - __langPrefix__ - `language-`. CSS language class prefix for fenced blocks.
 *   Can be useful for external highlighters.
 * - __linkify__ - `false`. Set `true` to autoconvert URL-like text to links.
 * - __typographer__  - `false`. Set `true` to enable [some language-neutral
 *   replacement](https://github.com/markdown-it/markdown-it/blob/master/lib/rules_core/replacements.js) +
 *   quotes beautification (smartquotes).
 * - __quotes__ - `“”‘’`, String or Array. Double + single quotes replacement
 *   pairs, when typographer enabled and smartquotes on. For example, you can
 *   use `'«»„“'` for Russian, `'„“‚‘'` for German, and
 *   `['«\xA0', '\xA0»', '‹\xA0', '\xA0›']` for French (including nbsp).
 * - __highlight__ - `null`. Highlighter function for fenced code blocks.
 *   Highlighter `function (str, lang)` should return escaped HTML. It can also
 *   return empty string if the source was not changed and should be escaped
 *   externaly. If result starts with <pre... internal wrapper is skipped.
 *
 * ##### Example
 *
 * ```javascript
 * // commonmark mode
 * var md = require('markdown-it')('commonmark');
 *
 * // default mode
 * var md = require('markdown-it')();
 *
 * // enable everything
 * var md = require('markdown-it')({
 *   html: true,
 *   linkify: true,
 *   typographer: true
 * });
 * ```
 *
 * ##### Syntax highlighting
 *
 * ```js
 * var hljs = require('highlight.js') // https://highlightjs.org/
 *
 * var md = require('markdown-it')({
 *   highlight: function (str, lang) {
 *     if (lang && hljs.getLanguage(lang)) {
 *       try {
 *         return hljs.highlight(str, { language: lang, ignoreIllegals: true }).value;
 *       } catch (__) {}
 *     }
 *
 *     return ''; // use external default escaping
 *   }
 * });
 * ```
 *
 * Or with full wrapper override (if you need assign class to `<pre>`):
 *
 * ```javascript
 * var hljs = require('highlight.js') // https://highlightjs.org/
 *
 * // Actual default values
 * var md = require('markdown-it')({
 *   highlight: function (str, lang) {
 *     if (lang && hljs.getLanguage(lang)) {
 *       try {
 *         return '<pre class="hljs"><code>' +
 *                hljs.highlight(str, { language: lang, ignoreIllegals: true }).value +
 *                '</code></pre>';
 *       } catch (__) {}
 *     }
 *
 *     return '<pre class="hljs"><code>' + md.utils.escapeHtml(str) + '</code></pre>';
 *   }
 * });
 * ```
 *
 **/ function $a7a76f86b0b20fdd$var$MarkdownIt(presetName, options) {
    if (!(this instanceof $a7a76f86b0b20fdd$var$MarkdownIt)) return new $a7a76f86b0b20fdd$var$MarkdownIt(presetName, options);
    if (!options) {
        if (!$iXVVQ.isString(presetName)) {
            options = presetName || {};
            presetName = "default";
        }
    }
    /**
   * MarkdownIt#inline -> ParserInline
   *
   * Instance of [[ParserInline]]. You may need it to add new rules when
   * writing plugins. For simple rules control use [[MarkdownIt.disable]] and
   * [[MarkdownIt.enable]].
   **/ this.inline = new $cyNW1();
    /**
   * MarkdownIt#block -> ParserBlock
   *
   * Instance of [[ParserBlock]]. You may need it to add new rules when
   * writing plugins. For simple rules control use [[MarkdownIt.disable]] and
   * [[MarkdownIt.enable]].
   **/ this.block = new $4s2Z6();
    /**
   * MarkdownIt#core -> Core
   *
   * Instance of [[Core]] chain executor. You may need it to add new rules when
   * writing plugins. For simple rules control use [[MarkdownIt.disable]] and
   * [[MarkdownIt.enable]].
   **/ this.core = new $2llij();
    /**
   * MarkdownIt#renderer -> Renderer
   *
   * Instance of [[Renderer]]. Use it to modify output look. Or to add rendering
   * rules for new token types, generated by plugins.
   *
   * ##### Example
   *
   * ```javascript
   * var md = require('markdown-it')();
   *
   * function myToken(tokens, idx, options, env, self) {
   *   //...
   *   return result;
   * };
   *
   * md.renderer.rules['my_token'] = myToken
   * ```
   *
   * See [[Renderer]] docs and [source code](https://github.com/markdown-it/markdown-it/blob/master/lib/renderer.js).
   **/ this.renderer = new $dBmFH();
    /**
   * MarkdownIt#linkify -> LinkifyIt
   *
   * [linkify-it](https://github.com/markdown-it/linkify-it) instance.
   * Used by [linkify](https://github.com/markdown-it/markdown-it/blob/master/lib/rules_core/linkify.js)
   * rule.
   **/ this.linkify = new $jAtt2();
    /**
   * MarkdownIt#validateLink(url) -> Boolean
   *
   * Link validation function. CommonMark allows too much in links. By default
   * we disable `javascript:`, `vbscript:`, `file:` schemas, and almost all `data:...` schemas
   * except some embedded image types.
   *
   * You can change this behaviour:
   *
   * ```javascript
   * var md = require('markdown-it')();
   * // enable everything
   * md.validateLink = function () { return true; }
   * ```
   **/ this.validateLink = $a7a76f86b0b20fdd$var$validateLink;
    /**
   * MarkdownIt#normalizeLink(url) -> String
   *
   * Function used to encode link url to a machine-readable format,
   * which includes url-encoding, punycode, etc.
   **/ this.normalizeLink = $a7a76f86b0b20fdd$var$normalizeLink;
    /**
   * MarkdownIt#normalizeLinkText(url) -> String
   *
   * Function used to decode link url to a human-readable format`
   **/ this.normalizeLinkText = $a7a76f86b0b20fdd$var$normalizeLinkText;
    // Expose utils & helpers for easy acces from plugins
    /**
   * MarkdownIt#utils -> utils
   *
   * Assorted utility functions, useful to write plugins. See details
   * [here](https://github.com/markdown-it/markdown-it/blob/master/lib/common/utils.js).
   **/ this.utils = $iXVVQ;
    /**
   * MarkdownIt#helpers -> helpers
   *
   * Link components parser functions, useful to write plugins. See details
   * [here](https://github.com/markdown-it/markdown-it/blob/master/lib/helpers).
   **/ this.helpers = $iXVVQ.assign({}, $702rI);
    this.options = {};
    this.configure(presetName);
    if (options) this.set(options);
}
/** chainable
 * MarkdownIt.set(options)
 *
 * Set parser options (in the same format as in constructor). Probably, you
 * will never need it, but you can change options after constructor call.
 *
 * ##### Example
 *
 * ```javascript
 * var md = require('markdown-it')()
 *             .set({ html: true, breaks: true })
 *             .set({ typographer, true });
 * ```
 *
 * __Note:__ To achieve the best possible performance, don't modify a
 * `markdown-it` instance options on the fly. If you need multiple configurations
 * it's best to create multiple instances and initialize each with separate
 * config.
 **/ $a7a76f86b0b20fdd$var$MarkdownIt.prototype.set = function(options) {
    $iXVVQ.assign(this.options, options);
    return this;
};
/** chainable, internal
 * MarkdownIt.configure(presets)
 *
 * Batch load of all options and compenent settings. This is internal method,
 * and you probably will not need it. But if you will - see available presets
 * and data structure [here](https://github.com/markdown-it/markdown-it/tree/master/lib/presets)
 *
 * We strongly recommend to use presets instead of direct config loads. That
 * will give better compatibility with next versions.
 **/ $a7a76f86b0b20fdd$var$MarkdownIt.prototype.configure = function(presets) {
    var self = this, presetName;
    if ($iXVVQ.isString(presets)) {
        presetName = presets;
        presets = $a7a76f86b0b20fdd$var$config[presetName];
        if (!presets) throw new Error('Wrong `markdown-it` preset "' + presetName + '", check name');
    }
    if (!presets) throw new Error("Wrong `markdown-it` preset, can't be empty");
    if (presets.options) self.set(presets.options);
    if (presets.components) Object.keys(presets.components).forEach(function(name) {
        if (presets.components[name].rules) self[name].ruler.enableOnly(presets.components[name].rules);
        if (presets.components[name].rules2) self[name].ruler2.enableOnly(presets.components[name].rules2);
    });
    return this;
};
/** chainable
 * MarkdownIt.enable(list, ignoreInvalid)
 * - list (String|Array): rule name or list of rule names to enable
 * - ignoreInvalid (Boolean): set `true` to ignore errors when rule not found.
 *
 * Enable list or rules. It will automatically find appropriate components,
 * containing rules with given names. If rule not found, and `ignoreInvalid`
 * not set - throws exception.
 *
 * ##### Example
 *
 * ```javascript
 * var md = require('markdown-it')()
 *             .enable(['sub', 'sup'])
 *             .disable('smartquotes');
 * ```
 **/ $a7a76f86b0b20fdd$var$MarkdownIt.prototype.enable = function(list, ignoreInvalid) {
    var result = [];
    if (!Array.isArray(list)) list = [
        list
    ];
    [
        "core",
        "block",
        "inline"
    ].forEach(function(chain) {
        result = result.concat(this[chain].ruler.enable(list, true));
    }, this);
    result = result.concat(this.inline.ruler2.enable(list, true));
    var missed = list.filter(function(name) {
        return result.indexOf(name) < 0;
    });
    if (missed.length && !ignoreInvalid) throw new Error("MarkdownIt. Failed to enable unknown rule(s): " + missed);
    return this;
};
/** chainable
 * MarkdownIt.disable(list, ignoreInvalid)
 * - list (String|Array): rule name or list of rule names to disable.
 * - ignoreInvalid (Boolean): set `true` to ignore errors when rule not found.
 *
 * The same as [[MarkdownIt.enable]], but turn specified rules off.
 **/ $a7a76f86b0b20fdd$var$MarkdownIt.prototype.disable = function(list, ignoreInvalid) {
    var result = [];
    if (!Array.isArray(list)) list = [
        list
    ];
    [
        "core",
        "block",
        "inline"
    ].forEach(function(chain) {
        result = result.concat(this[chain].ruler.disable(list, true));
    }, this);
    result = result.concat(this.inline.ruler2.disable(list, true));
    var missed = list.filter(function(name) {
        return result.indexOf(name) < 0;
    });
    if (missed.length && !ignoreInvalid) throw new Error("MarkdownIt. Failed to disable unknown rule(s): " + missed);
    return this;
};
/** chainable
 * MarkdownIt.use(plugin, params)
 *
 * Load specified plugin with given params into current parser instance.
 * It's just a sugar to call `plugin(md, params)` with curring.
 *
 * ##### Example
 *
 * ```javascript
 * var iterator = require('markdown-it-for-inline');
 * var md = require('markdown-it')()
 *             .use(iterator, 'foo_replace', 'text', function (tokens, idx) {
 *               tokens[idx].content = tokens[idx].content.replace(/foo/g, 'bar');
 *             });
 * ```
 **/ $a7a76f86b0b20fdd$var$MarkdownIt.prototype.use = function(plugin /*, params, ... */ ) {
    var args = [
        this
    ].concat(Array.prototype.slice.call(arguments, 1));
    plugin.apply(plugin, args);
    return this;
};
/** internal
 * MarkdownIt.parse(src, env) -> Array
 * - src (String): source string
 * - env (Object): environment sandbox
 *
 * Parse input string and return list of block tokens (special token type
 * "inline" will contain list of inline tokens). You should not call this
 * method directly, until you write custom renderer (for example, to produce
 * AST).
 *
 * `env` is used to pass data between "distributed" rules and return additional
 * metadata like reference info, needed for the renderer. It also can be used to
 * inject data in specific cases. Usually, you will be ok to pass `{}`,
 * and then pass updated object to renderer.
 **/ $a7a76f86b0b20fdd$var$MarkdownIt.prototype.parse = function(src, env) {
    if (typeof src !== "string") throw new Error("Input data should be a String");
    var state = new this.core.State(src, this, env);
    this.core.process(state);
    return state.tokens;
};
/**
 * MarkdownIt.render(src [, env]) -> String
 * - src (String): source string
 * - env (Object): environment sandbox
 *
 * Render markdown string into html. It does all magic for you :).
 *
 * `env` can be used to inject additional metadata (`{}` by default).
 * But you will not need it with high probability. See also comment
 * in [[MarkdownIt.parse]].
 **/ $a7a76f86b0b20fdd$var$MarkdownIt.prototype.render = function(src, env) {
    env = env || {};
    return this.renderer.render(this.parse(src, env), this.options, env);
};
/** internal
 * MarkdownIt.parseInline(src, env) -> Array
 * - src (String): source string
 * - env (Object): environment sandbox
 *
 * The same as [[MarkdownIt.parse]] but skip all block rules. It returns the
 * block tokens list with the single `inline` element, containing parsed inline
 * tokens in `children` property. Also updates `env` object.
 **/ $a7a76f86b0b20fdd$var$MarkdownIt.prototype.parseInline = function(src, env) {
    var state = new this.core.State(src, this, env);
    state.inlineMode = true;
    this.core.process(state);
    return state.tokens;
};
/**
 * MarkdownIt.renderInline(src [, env]) -> String
 * - src (String): source string
 * - env (Object): environment sandbox
 *
 * Similar to [[MarkdownIt.render]] but for single paragraph content. Result
 * will NOT be wrapped into `<p>` tags.
 **/ $a7a76f86b0b20fdd$var$MarkdownIt.prototype.renderInline = function(src, env) {
    env = env || {};
    return this.renderer.render(this.parseInline(src, env), this.options, env);
};
module.exports = $a7a76f86b0b20fdd$var$MarkdownIt;

});
parcelRequire.register("iXVVQ", function(module, exports) {

$parcel$export(module.exports, "lib", () => $dceaacc5d06ba6ec$export$16c08b91f883959a, (v) => $dceaacc5d06ba6ec$export$16c08b91f883959a = v);
$parcel$export(module.exports, "assign", () => $dceaacc5d06ba6ec$export$e6e34fd1f2686227, (v) => $dceaacc5d06ba6ec$export$e6e34fd1f2686227 = v);
$parcel$export(module.exports, "isString", () => $dceaacc5d06ba6ec$export$844ec244b1367d54, (v) => $dceaacc5d06ba6ec$export$844ec244b1367d54 = v);
$parcel$export(module.exports, "has", () => $dceaacc5d06ba6ec$export$a4f4bb6b1453fff5, (v) => $dceaacc5d06ba6ec$export$a4f4bb6b1453fff5 = v);
$parcel$export(module.exports, "unescapeMd", () => $dceaacc5d06ba6ec$export$5ccde1ea0c14bb03, (v) => $dceaacc5d06ba6ec$export$5ccde1ea0c14bb03 = v);
$parcel$export(module.exports, "unescapeAll", () => $dceaacc5d06ba6ec$export$db8a17c6655f7e2c, (v) => $dceaacc5d06ba6ec$export$db8a17c6655f7e2c = v);
$parcel$export(module.exports, "isValidEntityCode", () => $dceaacc5d06ba6ec$export$644a8f5b13b2a36d, (v) => $dceaacc5d06ba6ec$export$644a8f5b13b2a36d = v);
$parcel$export(module.exports, "fromCodePoint", () => $dceaacc5d06ba6ec$export$73bfc63873071f74, (v) => $dceaacc5d06ba6ec$export$73bfc63873071f74 = v);
$parcel$export(module.exports, "escapeHtml", () => $dceaacc5d06ba6ec$export$4cf11838cdc2a8a8, (v) => $dceaacc5d06ba6ec$export$4cf11838cdc2a8a8 = v);
$parcel$export(module.exports, "arrayReplaceAt", () => $dceaacc5d06ba6ec$export$f78478f71955b6bc, (v) => $dceaacc5d06ba6ec$export$f78478f71955b6bc = v);
$parcel$export(module.exports, "isSpace", () => $dceaacc5d06ba6ec$export$1d5ccafae59b4926, (v) => $dceaacc5d06ba6ec$export$1d5ccafae59b4926 = v);
$parcel$export(module.exports, "isWhiteSpace", () => $dceaacc5d06ba6ec$export$3c52dd84024ae72c, (v) => $dceaacc5d06ba6ec$export$3c52dd84024ae72c = v);
$parcel$export(module.exports, "isMdAsciiPunct", () => $dceaacc5d06ba6ec$export$829a0d33ae4e744, (v) => $dceaacc5d06ba6ec$export$829a0d33ae4e744 = v);
$parcel$export(module.exports, "isPunctChar", () => $dceaacc5d06ba6ec$export$4888a643af800fc1, (v) => $dceaacc5d06ba6ec$export$4888a643af800fc1 = v);
$parcel$export(module.exports, "escapeRE", () => $dceaacc5d06ba6ec$export$bc616c8f7dc20d5d, (v) => $dceaacc5d06ba6ec$export$bc616c8f7dc20d5d = v);
$parcel$export(module.exports, "normalizeReference", () => $dceaacc5d06ba6ec$export$20ef46802c8744b, (v) => $dceaacc5d06ba6ec$export$20ef46802c8744b = v);
// Utilities
//
////////////////////////////////////////////////////////////////////////////////
// Re-export libraries commonly used in both markdown-it and its plugins,
// so plugins won't have to depend on them explicitly, which reduces their
// bundled size (e.g. a browser build).
//
var $dceaacc5d06ba6ec$export$16c08b91f883959a;
var $dceaacc5d06ba6ec$export$e6e34fd1f2686227;
var $dceaacc5d06ba6ec$export$844ec244b1367d54;
var $dceaacc5d06ba6ec$export$a4f4bb6b1453fff5;
var $dceaacc5d06ba6ec$export$5ccde1ea0c14bb03;
var $dceaacc5d06ba6ec$export$db8a17c6655f7e2c;
var $dceaacc5d06ba6ec$export$644a8f5b13b2a36d;
var $dceaacc5d06ba6ec$export$73bfc63873071f74;
// exports.replaceEntities     = replaceEntities;
var $dceaacc5d06ba6ec$export$4cf11838cdc2a8a8;
var $dceaacc5d06ba6ec$export$f78478f71955b6bc;
var $dceaacc5d06ba6ec$export$1d5ccafae59b4926;
var $dceaacc5d06ba6ec$export$3c52dd84024ae72c;
var $dceaacc5d06ba6ec$export$829a0d33ae4e744;
var $dceaacc5d06ba6ec$export$4888a643af800fc1;
var $dceaacc5d06ba6ec$export$bc616c8f7dc20d5d;
var $dceaacc5d06ba6ec$export$20ef46802c8744b;
"use strict";
function $dceaacc5d06ba6ec$var$_class(obj) {
    return Object.prototype.toString.call(obj);
}
function $dceaacc5d06ba6ec$var$isString(obj) {
    return $dceaacc5d06ba6ec$var$_class(obj) === "[object String]";
}
var $dceaacc5d06ba6ec$var$_hasOwnProperty = Object.prototype.hasOwnProperty;
function $dceaacc5d06ba6ec$var$has(object, key) {
    return $dceaacc5d06ba6ec$var$_hasOwnProperty.call(object, key);
}
// Merge objects
//
function $dceaacc5d06ba6ec$var$assign(obj /*from1, from2, from3, ...*/ ) {
    var sources = Array.prototype.slice.call(arguments, 1);
    sources.forEach(function(source) {
        if (!source) return;
        if (typeof source !== "object") throw new TypeError(source + "must be object");
        Object.keys(source).forEach(function(key) {
            obj[key] = source[key];
        });
    });
    return obj;
}
// Remove element from array and put another array at those position.
// Useful for some operations with tokens
function $dceaacc5d06ba6ec$var$arrayReplaceAt(src, pos, newElements) {
    return [].concat(src.slice(0, pos), newElements, src.slice(pos + 1));
}
////////////////////////////////////////////////////////////////////////////////
function $dceaacc5d06ba6ec$var$isValidEntityCode(c) {
    /*eslint no-bitwise:0*/ // broken sequence
    if (c >= 0xD800 && c <= 0xDFFF) return false;
    // never used
    if (c >= 0xFDD0 && c <= 0xFDEF) return false;
    if ((c & 0xFFFF) === 0xFFFF || (c & 0xFFFF) === 0xFFFE) return false;
    // control codes
    if (c >= 0x00 && c <= 0x08) return false;
    if (c === 0x0B) return false;
    if (c >= 0x0E && c <= 0x1F) return false;
    if (c >= 0x7F && c <= 0x9F) return false;
    // out of range
    if (c > 0x10FFFF) return false;
    return true;
}
function $dceaacc5d06ba6ec$var$fromCodePoint(c) {
    /*eslint no-bitwise:0*/ if (c > 0xffff) {
        c -= 0x10000;
        var surrogate1 = 0xd800 + (c >> 10), surrogate2 = 0xdc00 + (c & 0x3ff);
        return String.fromCharCode(surrogate1, surrogate2);
    }
    return String.fromCharCode(c);
}
var $dceaacc5d06ba6ec$var$UNESCAPE_MD_RE = /\\([!"#$%&'()*+,\-.\/:;<=>?@[\\\]^_`{|}~])/g;
var $dceaacc5d06ba6ec$var$ENTITY_RE = /&([a-z#][a-z0-9]{1,31});/gi;
var $dceaacc5d06ba6ec$var$UNESCAPE_ALL_RE = new RegExp($dceaacc5d06ba6ec$var$UNESCAPE_MD_RE.source + "|" + $dceaacc5d06ba6ec$var$ENTITY_RE.source, "gi");
var $dceaacc5d06ba6ec$var$DIGITAL_ENTITY_TEST_RE = /^#((?:x[a-f0-9]{1,8}|[0-9]{1,8}))/i;

var $hNNPq = parcelRequire("hNNPq");
function $dceaacc5d06ba6ec$var$replaceEntityPattern(match, name) {
    var code = 0;
    if ($dceaacc5d06ba6ec$var$has($hNNPq, name)) return $hNNPq[name];
    if (name.charCodeAt(0) === 0x23 /* # */  && $dceaacc5d06ba6ec$var$DIGITAL_ENTITY_TEST_RE.test(name)) {
        code = name[1].toLowerCase() === "x" ? parseInt(name.slice(2), 16) : parseInt(name.slice(1), 10);
        if ($dceaacc5d06ba6ec$var$isValidEntityCode(code)) return $dceaacc5d06ba6ec$var$fromCodePoint(code);
    }
    return match;
}
/*function replaceEntities(str) {
  if (str.indexOf('&') < 0) { return str; }

  return str.replace(ENTITY_RE, replaceEntityPattern);
}*/ function $dceaacc5d06ba6ec$var$unescapeMd(str) {
    if (str.indexOf("\\") < 0) return str;
    return str.replace($dceaacc5d06ba6ec$var$UNESCAPE_MD_RE, "$1");
}
function $dceaacc5d06ba6ec$var$unescapeAll(str) {
    if (str.indexOf("\\") < 0 && str.indexOf("&") < 0) return str;
    return str.replace($dceaacc5d06ba6ec$var$UNESCAPE_ALL_RE, function(match, escaped, entity) {
        if (escaped) return escaped;
        return $dceaacc5d06ba6ec$var$replaceEntityPattern(match, entity);
    });
}
////////////////////////////////////////////////////////////////////////////////
var $dceaacc5d06ba6ec$var$HTML_ESCAPE_TEST_RE = /[&<>"]/;
var $dceaacc5d06ba6ec$var$HTML_ESCAPE_REPLACE_RE = /[&<>"]/g;
var $dceaacc5d06ba6ec$var$HTML_REPLACEMENTS = {
    "&": "&amp;",
    "<": "&lt;",
    ">": "&gt;",
    '"': "&quot;"
};
function $dceaacc5d06ba6ec$var$replaceUnsafeChar(ch) {
    return $dceaacc5d06ba6ec$var$HTML_REPLACEMENTS[ch];
}
function $dceaacc5d06ba6ec$var$escapeHtml(str) {
    if ($dceaacc5d06ba6ec$var$HTML_ESCAPE_TEST_RE.test(str)) return str.replace($dceaacc5d06ba6ec$var$HTML_ESCAPE_REPLACE_RE, $dceaacc5d06ba6ec$var$replaceUnsafeChar);
    return str;
}
////////////////////////////////////////////////////////////////////////////////
var $dceaacc5d06ba6ec$var$REGEXP_ESCAPE_RE = /[.?*+^$[\]\\(){}|-]/g;
function $dceaacc5d06ba6ec$var$escapeRE(str) {
    return str.replace($dceaacc5d06ba6ec$var$REGEXP_ESCAPE_RE, "\\$&");
}
////////////////////////////////////////////////////////////////////////////////
function $dceaacc5d06ba6ec$var$isSpace(code) {
    switch(code){
        case 0x09:
        case 0x20:
            return true;
    }
    return false;
}
// Zs (unicode class) || [\t\f\v\r\n]
function $dceaacc5d06ba6ec$var$isWhiteSpace(code) {
    if (code >= 0x2000 && code <= 0x200A) return true;
    switch(code){
        case 0x09:
        case 0x0A:
        case 0x0B:
        case 0x0C:
        case 0x0D:
        case 0x20:
        case 0xA0:
        case 0x1680:
        case 0x202F:
        case 0x205F:
        case 0x3000:
            return true;
    }
    return false;
}

var $7X6km = parcelRequire("7X6km");
// Currently without astral characters support.
function $dceaacc5d06ba6ec$var$isPunctChar(ch) {
    return $7X6km.test(ch);
}
// Markdown ASCII punctuation characters.
//
// !, ", #, $, %, &, ', (, ), *, +, ,, -, ., /, :, ;, <, =, >, ?, @, [, \, ], ^, _, `, {, |, }, or ~
// http://spec.commonmark.org/0.15/#ascii-punctuation-character
//
// Don't confuse with unicode punctuation !!! It lacks some chars in ascii range.
//
function $dceaacc5d06ba6ec$var$isMdAsciiPunct(ch) {
    switch(ch){
        case 0x21 /* ! */ :
        case 0x22 /* " */ :
        case 0x23 /* # */ :
        case 0x24 /* $ */ :
        case 0x25 /* % */ :
        case 0x26 /* & */ :
        case 0x27 /* ' */ :
        case 0x28 /* ( */ :
        case 0x29 /* ) */ :
        case 0x2A /* * */ :
        case 0x2B /* + */ :
        case 0x2C /* , */ :
        case 0x2D /* - */ :
        case 0x2E /* . */ :
        case 0x2F /* / */ :
        case 0x3A /* : */ :
        case 0x3B /* ; */ :
        case 0x3C /* < */ :
        case 0x3D /* = */ :
        case 0x3E /* > */ :
        case 0x3F /* ? */ :
        case 0x40 /* @ */ :
        case 0x5B /* [ */ :
        case 0x5C /* \ */ :
        case 0x5D /* ] */ :
        case 0x5E /* ^ */ :
        case 0x5F /* _ */ :
        case 0x60 /* ` */ :
        case 0x7B /* { */ :
        case 0x7C /* | */ :
        case 0x7D /* } */ :
        case 0x7E /* ~ */ :
            return true;
        default:
            return false;
    }
}
// Hepler to unify [reference labels].
//
function $dceaacc5d06ba6ec$var$normalizeReference(str) {
    // Trim and collapse whitespace
    //
    str = str.trim().replace(/\s+/g, " ");
    // In node v10 'ẞ'.toLowerCase() === 'Ṿ', which is presumed to be a bug
    // fixed in v12 (couldn't find any details).
    //
    // So treat this one as a special case
    // (remove this when node v10 is no longer supported).
    //
    if ("ẞ".toLowerCase() === "Ṿ") str = str.replace(/ẞ/g, "\xdf");
    // .toLowerCase().toUpperCase() should get rid of all differences
    // between letter variants.
    //
    // Simple .toLowerCase() doesn't normalize 125 code points correctly,
    // and .toUpperCase doesn't normalize 6 of them (list of exceptions:
    // İ, ϴ, ẞ, Ω, K, Å - those are already uppercased, but have differently
    // uppercased versions).
    //
    // Here's an example showing how it happens. Lets take greek letter omega:
    // uppercase U+0398 (Θ), U+03f4 (ϴ) and lowercase U+03b8 (θ), U+03d1 (ϑ)
    //
    // Unicode entries:
    // 0398;GREEK CAPITAL LETTER THETA;Lu;0;L;;;;;N;;;;03B8;
    // 03B8;GREEK SMALL LETTER THETA;Ll;0;L;;;;;N;;;0398;;0398
    // 03D1;GREEK THETA SYMBOL;Ll;0;L;<compat> 03B8;;;;N;GREEK SMALL LETTER SCRIPT THETA;;0398;;0398
    // 03F4;GREEK CAPITAL THETA SYMBOL;Lu;0;L;<compat> 0398;;;;N;;;;03B8;
    //
    // Case-insensitive comparison should treat all of them as equivalent.
    //
    // But .toLowerCase() doesn't change ϑ (it's already lowercase),
    // and .toUpperCase() doesn't change ϴ (already uppercase).
    //
    // Applying first lower then upper case normalizes any character:
    // '\u0398\u03f4\u03b8\u03d1'.toLowerCase().toUpperCase() === '\u0398\u0398\u0398\u0398'
    //
    // Note: this is equivalent to unicode case folding; unicode normalization
    // is a different step that is not required here.
    //
    // Final result should be uppercased, because it's later stored in an object
    // (this avoid a conflict with Object.prototype members,
    // most notably, `__proto__`)
    //
    return str.toLowerCase().toUpperCase();
}
$dceaacc5d06ba6ec$export$16c08b91f883959a = {};

$dceaacc5d06ba6ec$export$16c08b91f883959a.mdurl = (parcelRequire("e2HUE"));

$dceaacc5d06ba6ec$export$16c08b91f883959a.ucmicro = (parcelRequire("7rqQE"));
$dceaacc5d06ba6ec$export$e6e34fd1f2686227 = $dceaacc5d06ba6ec$var$assign;
$dceaacc5d06ba6ec$export$844ec244b1367d54 = $dceaacc5d06ba6ec$var$isString;
$dceaacc5d06ba6ec$export$a4f4bb6b1453fff5 = $dceaacc5d06ba6ec$var$has;
$dceaacc5d06ba6ec$export$5ccde1ea0c14bb03 = $dceaacc5d06ba6ec$var$unescapeMd;
$dceaacc5d06ba6ec$export$db8a17c6655f7e2c = $dceaacc5d06ba6ec$var$unescapeAll;
$dceaacc5d06ba6ec$export$644a8f5b13b2a36d = $dceaacc5d06ba6ec$var$isValidEntityCode;
$dceaacc5d06ba6ec$export$73bfc63873071f74 = $dceaacc5d06ba6ec$var$fromCodePoint;
$dceaacc5d06ba6ec$export$4cf11838cdc2a8a8 = $dceaacc5d06ba6ec$var$escapeHtml;
$dceaacc5d06ba6ec$export$f78478f71955b6bc = $dceaacc5d06ba6ec$var$arrayReplaceAt;
$dceaacc5d06ba6ec$export$1d5ccafae59b4926 = $dceaacc5d06ba6ec$var$isSpace;
$dceaacc5d06ba6ec$export$3c52dd84024ae72c = $dceaacc5d06ba6ec$var$isWhiteSpace;
$dceaacc5d06ba6ec$export$829a0d33ae4e744 = $dceaacc5d06ba6ec$var$isMdAsciiPunct;
$dceaacc5d06ba6ec$export$4888a643af800fc1 = $dceaacc5d06ba6ec$var$isPunctChar;
$dceaacc5d06ba6ec$export$bc616c8f7dc20d5d = $dceaacc5d06ba6ec$var$escapeRE;
$dceaacc5d06ba6ec$export$20ef46802c8744b = $dceaacc5d06ba6ec$var$normalizeReference;

});
parcelRequire.register("hNNPq", function(module, exports) {
// HTML5 entities map: { name -> utf16string }
//
"use strict";

/*eslint quotes:0*/ module.exports = (parcelRequire("aggSE"));

});
parcelRequire.register("aggSE", function(module, exports) {
module.exports = JSON.parse('{"Aacute":"\xc1","aacute":"\xe1","Abreve":"Ă","abreve":"ă","ac":"∾","acd":"∿","acE":"∾̳","Acirc":"\xc2","acirc":"\xe2","acute":"\xb4","Acy":"А","acy":"а","AElig":"\xc6","aelig":"\xe6","af":"⁡","Afr":"\uD835\uDD04","afr":"\uD835\uDD1E","Agrave":"\xc0","agrave":"\xe0","alefsym":"ℵ","aleph":"ℵ","Alpha":"Α","alpha":"α","Amacr":"Ā","amacr":"ā","amalg":"⨿","amp":"&","AMP":"&","andand":"⩕","And":"⩓","and":"∧","andd":"⩜","andslope":"⩘","andv":"⩚","ang":"∠","ange":"⦤","angle":"∠","angmsdaa":"⦨","angmsdab":"⦩","angmsdac":"⦪","angmsdad":"⦫","angmsdae":"⦬","angmsdaf":"⦭","angmsdag":"⦮","angmsdah":"⦯","angmsd":"∡","angrt":"∟","angrtvb":"⊾","angrtvbd":"⦝","angsph":"∢","angst":"\xc5","angzarr":"⍼","Aogon":"Ą","aogon":"ą","Aopf":"\uD835\uDD38","aopf":"\uD835\uDD52","apacir":"⩯","ap":"≈","apE":"⩰","ape":"≊","apid":"≋","apos":"\'","ApplyFunction":"⁡","approx":"≈","approxeq":"≊","Aring":"\xc5","aring":"\xe5","Ascr":"\uD835\uDC9C","ascr":"\uD835\uDCB6","Assign":"≔","ast":"*","asymp":"≈","asympeq":"≍","Atilde":"\xc3","atilde":"\xe3","Auml":"\xc4","auml":"\xe4","awconint":"∳","awint":"⨑","backcong":"≌","backepsilon":"϶","backprime":"‵","backsim":"∽","backsimeq":"⋍","Backslash":"∖","Barv":"⫧","barvee":"⊽","barwed":"⌅","Barwed":"⌆","barwedge":"⌅","bbrk":"⎵","bbrktbrk":"⎶","bcong":"≌","Bcy":"Б","bcy":"б","bdquo":"„","becaus":"∵","because":"∵","Because":"∵","bemptyv":"⦰","bepsi":"϶","bernou":"ℬ","Bernoullis":"ℬ","Beta":"Β","beta":"β","beth":"ℶ","between":"≬","Bfr":"\uD835\uDD05","bfr":"\uD835\uDD1F","bigcap":"⋂","bigcirc":"◯","bigcup":"⋃","bigodot":"⨀","bigoplus":"⨁","bigotimes":"⨂","bigsqcup":"⨆","bigstar":"★","bigtriangledown":"▽","bigtriangleup":"△","biguplus":"⨄","bigvee":"⋁","bigwedge":"⋀","bkarow":"⤍","blacklozenge":"⧫","blacksquare":"▪","blacktriangle":"▴","blacktriangledown":"▾","blacktriangleleft":"◂","blacktriangleright":"▸","blank":"␣","blk12":"▒","blk14":"░","blk34":"▓","block":"█","bne":"=⃥","bnequiv":"≡⃥","bNot":"⫭","bnot":"⌐","Bopf":"\uD835\uDD39","bopf":"\uD835\uDD53","bot":"⊥","bottom":"⊥","bowtie":"⋈","boxbox":"⧉","boxdl":"┐","boxdL":"╕","boxDl":"╖","boxDL":"╗","boxdr":"┌","boxdR":"╒","boxDr":"╓","boxDR":"╔","boxh":"─","boxH":"═","boxhd":"┬","boxHd":"╤","boxhD":"╥","boxHD":"╦","boxhu":"┴","boxHu":"╧","boxhU":"╨","boxHU":"╩","boxminus":"⊟","boxplus":"⊞","boxtimes":"⊠","boxul":"┘","boxuL":"╛","boxUl":"╜","boxUL":"╝","boxur":"└","boxuR":"╘","boxUr":"╙","boxUR":"╚","boxv":"│","boxV":"║","boxvh":"┼","boxvH":"╪","boxVh":"╫","boxVH":"╬","boxvl":"┤","boxvL":"╡","boxVl":"╢","boxVL":"╣","boxvr":"├","boxvR":"╞","boxVr":"╟","boxVR":"╠","bprime":"‵","breve":"˘","Breve":"˘","brvbar":"\xa6","bscr":"\uD835\uDCB7","Bscr":"ℬ","bsemi":"⁏","bsim":"∽","bsime":"⋍","bsolb":"⧅","bsol":"\\\\","bsolhsub":"⟈","bull":"•","bullet":"•","bump":"≎","bumpE":"⪮","bumpe":"≏","Bumpeq":"≎","bumpeq":"≏","Cacute":"Ć","cacute":"ć","capand":"⩄","capbrcup":"⩉","capcap":"⩋","cap":"∩","Cap":"⋒","capcup":"⩇","capdot":"⩀","CapitalDifferentialD":"ⅅ","caps":"∩︀","caret":"⁁","caron":"ˇ","Cayleys":"ℭ","ccaps":"⩍","Ccaron":"Č","ccaron":"č","Ccedil":"\xc7","ccedil":"\xe7","Ccirc":"Ĉ","ccirc":"ĉ","Cconint":"∰","ccups":"⩌","ccupssm":"⩐","Cdot":"Ċ","cdot":"ċ","cedil":"\xb8","Cedilla":"\xb8","cemptyv":"⦲","cent":"\xa2","centerdot":"\xb7","CenterDot":"\xb7","cfr":"\uD835\uDD20","Cfr":"ℭ","CHcy":"Ч","chcy":"ч","check":"✓","checkmark":"✓","Chi":"Χ","chi":"χ","circ":"ˆ","circeq":"≗","circlearrowleft":"↺","circlearrowright":"↻","circledast":"⊛","circledcirc":"⊚","circleddash":"⊝","CircleDot":"⊙","circledR":"\xae","circledS":"Ⓢ","CircleMinus":"⊖","CirclePlus":"⊕","CircleTimes":"⊗","cir":"○","cirE":"⧃","cire":"≗","cirfnint":"⨐","cirmid":"⫯","cirscir":"⧂","ClockwiseContourIntegral":"∲","CloseCurlyDoubleQuote":"”","CloseCurlyQuote":"’","clubs":"♣","clubsuit":"♣","colon":":","Colon":"∷","Colone":"⩴","colone":"≔","coloneq":"≔","comma":",","commat":"@","comp":"∁","compfn":"∘","complement":"∁","complexes":"ℂ","cong":"≅","congdot":"⩭","Congruent":"≡","conint":"∮","Conint":"∯","ContourIntegral":"∮","copf":"\uD835\uDD54","Copf":"ℂ","coprod":"∐","Coproduct":"∐","copy":"\xa9","COPY":"\xa9","copysr":"℗","CounterClockwiseContourIntegral":"∳","crarr":"↵","cross":"✗","Cross":"⨯","Cscr":"\uD835\uDC9E","cscr":"\uD835\uDCB8","csub":"⫏","csube":"⫑","csup":"⫐","csupe":"⫒","ctdot":"⋯","cudarrl":"⤸","cudarrr":"⤵","cuepr":"⋞","cuesc":"⋟","cularr":"↶","cularrp":"⤽","cupbrcap":"⩈","cupcap":"⩆","CupCap":"≍","cup":"∪","Cup":"⋓","cupcup":"⩊","cupdot":"⊍","cupor":"⩅","cups":"∪︀","curarr":"↷","curarrm":"⤼","curlyeqprec":"⋞","curlyeqsucc":"⋟","curlyvee":"⋎","curlywedge":"⋏","curren":"\xa4","curvearrowleft":"↶","curvearrowright":"↷","cuvee":"⋎","cuwed":"⋏","cwconint":"∲","cwint":"∱","cylcty":"⌭","dagger":"†","Dagger":"‡","daleth":"ℸ","darr":"↓","Darr":"↡","dArr":"⇓","dash":"‐","Dashv":"⫤","dashv":"⊣","dbkarow":"⤏","dblac":"˝","Dcaron":"Ď","dcaron":"ď","Dcy":"Д","dcy":"д","ddagger":"‡","ddarr":"⇊","DD":"ⅅ","dd":"ⅆ","DDotrahd":"⤑","ddotseq":"⩷","deg":"\xb0","Del":"∇","Delta":"Δ","delta":"δ","demptyv":"⦱","dfisht":"⥿","Dfr":"\uD835\uDD07","dfr":"\uD835\uDD21","dHar":"⥥","dharl":"⇃","dharr":"⇂","DiacriticalAcute":"\xb4","DiacriticalDot":"˙","DiacriticalDoubleAcute":"˝","DiacriticalGrave":"`","DiacriticalTilde":"˜","diam":"⋄","diamond":"⋄","Diamond":"⋄","diamondsuit":"♦","diams":"♦","die":"\xa8","DifferentialD":"ⅆ","digamma":"ϝ","disin":"⋲","div":"\xf7","divide":"\xf7","divideontimes":"⋇","divonx":"⋇","DJcy":"Ђ","djcy":"ђ","dlcorn":"⌞","dlcrop":"⌍","dollar":"$","Dopf":"\uD835\uDD3B","dopf":"\uD835\uDD55","Dot":"\xa8","dot":"˙","DotDot":"⃜","doteq":"≐","doteqdot":"≑","DotEqual":"≐","dotminus":"∸","dotplus":"∔","dotsquare":"⊡","doublebarwedge":"⌆","DoubleContourIntegral":"∯","DoubleDot":"\xa8","DoubleDownArrow":"⇓","DoubleLeftArrow":"⇐","DoubleLeftRightArrow":"⇔","DoubleLeftTee":"⫤","DoubleLongLeftArrow":"⟸","DoubleLongLeftRightArrow":"⟺","DoubleLongRightArrow":"⟹","DoubleRightArrow":"⇒","DoubleRightTee":"⊨","DoubleUpArrow":"⇑","DoubleUpDownArrow":"⇕","DoubleVerticalBar":"∥","DownArrowBar":"⤓","downarrow":"↓","DownArrow":"↓","Downarrow":"⇓","DownArrowUpArrow":"⇵","DownBreve":"̑","downdownarrows":"⇊","downharpoonleft":"⇃","downharpoonright":"⇂","DownLeftRightVector":"⥐","DownLeftTeeVector":"⥞","DownLeftVectorBar":"⥖","DownLeftVector":"↽","DownRightTeeVector":"⥟","DownRightVectorBar":"⥗","DownRightVector":"⇁","DownTeeArrow":"↧","DownTee":"⊤","drbkarow":"⤐","drcorn":"⌟","drcrop":"⌌","Dscr":"\uD835\uDC9F","dscr":"\uD835\uDCB9","DScy":"Ѕ","dscy":"ѕ","dsol":"⧶","Dstrok":"Đ","dstrok":"đ","dtdot":"⋱","dtri":"▿","dtrif":"▾","duarr":"⇵","duhar":"⥯","dwangle":"⦦","DZcy":"Џ","dzcy":"џ","dzigrarr":"⟿","Eacute":"\xc9","eacute":"\xe9","easter":"⩮","Ecaron":"Ě","ecaron":"ě","Ecirc":"\xca","ecirc":"\xea","ecir":"≖","ecolon":"≕","Ecy":"Э","ecy":"э","eDDot":"⩷","Edot":"Ė","edot":"ė","eDot":"≑","ee":"ⅇ","efDot":"≒","Efr":"\uD835\uDD08","efr":"\uD835\uDD22","eg":"⪚","Egrave":"\xc8","egrave":"\xe8","egs":"⪖","egsdot":"⪘","el":"⪙","Element":"∈","elinters":"⏧","ell":"ℓ","els":"⪕","elsdot":"⪗","Emacr":"Ē","emacr":"ē","empty":"∅","emptyset":"∅","EmptySmallSquare":"◻","emptyv":"∅","EmptyVerySmallSquare":"▫","emsp13":" ","emsp14":" ","emsp":" ","ENG":"Ŋ","eng":"ŋ","ensp":" ","Eogon":"Ę","eogon":"ę","Eopf":"\uD835\uDD3C","eopf":"\uD835\uDD56","epar":"⋕","eparsl":"⧣","eplus":"⩱","epsi":"ε","Epsilon":"Ε","epsilon":"ε","epsiv":"ϵ","eqcirc":"≖","eqcolon":"≕","eqsim":"≂","eqslantgtr":"⪖","eqslantless":"⪕","Equal":"⩵","equals":"=","EqualTilde":"≂","equest":"≟","Equilibrium":"⇌","equiv":"≡","equivDD":"⩸","eqvparsl":"⧥","erarr":"⥱","erDot":"≓","escr":"ℯ","Escr":"ℰ","esdot":"≐","Esim":"⩳","esim":"≂","Eta":"Η","eta":"η","ETH":"\xd0","eth":"\xf0","Euml":"\xcb","euml":"\xeb","euro":"€","excl":"!","exist":"∃","Exists":"∃","expectation":"ℰ","exponentiale":"ⅇ","ExponentialE":"ⅇ","fallingdotseq":"≒","Fcy":"Ф","fcy":"ф","female":"♀","ffilig":"ﬃ","fflig":"ﬀ","ffllig":"ﬄ","Ffr":"\uD835\uDD09","ffr":"\uD835\uDD23","filig":"ﬁ","FilledSmallSquare":"◼","FilledVerySmallSquare":"▪","fjlig":"fj","flat":"♭","fllig":"ﬂ","fltns":"▱","fnof":"ƒ","Fopf":"\uD835\uDD3D","fopf":"\uD835\uDD57","forall":"∀","ForAll":"∀","fork":"⋔","forkv":"⫙","Fouriertrf":"ℱ","fpartint":"⨍","frac12":"\xbd","frac13":"⅓","frac14":"\xbc","frac15":"⅕","frac16":"⅙","frac18":"⅛","frac23":"⅔","frac25":"⅖","frac34":"\xbe","frac35":"⅗","frac38":"⅜","frac45":"⅘","frac56":"⅚","frac58":"⅝","frac78":"⅞","frasl":"⁄","frown":"⌢","fscr":"\uD835\uDCBB","Fscr":"ℱ","gacute":"ǵ","Gamma":"Γ","gamma":"γ","Gammad":"Ϝ","gammad":"ϝ","gap":"⪆","Gbreve":"Ğ","gbreve":"ğ","Gcedil":"Ģ","Gcirc":"Ĝ","gcirc":"ĝ","Gcy":"Г","gcy":"г","Gdot":"Ġ","gdot":"ġ","ge":"≥","gE":"≧","gEl":"⪌","gel":"⋛","geq":"≥","geqq":"≧","geqslant":"⩾","gescc":"⪩","ges":"⩾","gesdot":"⪀","gesdoto":"⪂","gesdotol":"⪄","gesl":"⋛︀","gesles":"⪔","Gfr":"\uD835\uDD0A","gfr":"\uD835\uDD24","gg":"≫","Gg":"⋙","ggg":"⋙","gimel":"ℷ","GJcy":"Ѓ","gjcy":"ѓ","gla":"⪥","gl":"≷","glE":"⪒","glj":"⪤","gnap":"⪊","gnapprox":"⪊","gne":"⪈","gnE":"≩","gneq":"⪈","gneqq":"≩","gnsim":"⋧","Gopf":"\uD835\uDD3E","gopf":"\uD835\uDD58","grave":"`","GreaterEqual":"≥","GreaterEqualLess":"⋛","GreaterFullEqual":"≧","GreaterGreater":"⪢","GreaterLess":"≷","GreaterSlantEqual":"⩾","GreaterTilde":"≳","Gscr":"\uD835\uDCA2","gscr":"ℊ","gsim":"≳","gsime":"⪎","gsiml":"⪐","gtcc":"⪧","gtcir":"⩺","gt":">","GT":">","Gt":"≫","gtdot":"⋗","gtlPar":"⦕","gtquest":"⩼","gtrapprox":"⪆","gtrarr":"⥸","gtrdot":"⋗","gtreqless":"⋛","gtreqqless":"⪌","gtrless":"≷","gtrsim":"≳","gvertneqq":"≩︀","gvnE":"≩︀","Hacek":"ˇ","hairsp":" ","half":"\xbd","hamilt":"ℋ","HARDcy":"Ъ","hardcy":"ъ","harrcir":"⥈","harr":"↔","hArr":"⇔","harrw":"↭","Hat":"^","hbar":"ℏ","Hcirc":"Ĥ","hcirc":"ĥ","hearts":"♥","heartsuit":"♥","hellip":"…","hercon":"⊹","hfr":"\uD835\uDD25","Hfr":"ℌ","HilbertSpace":"ℋ","hksearow":"⤥","hkswarow":"⤦","hoarr":"⇿","homtht":"∻","hookleftarrow":"↩","hookrightarrow":"↪","hopf":"\uD835\uDD59","Hopf":"ℍ","horbar":"―","HorizontalLine":"─","hscr":"\uD835\uDCBD","Hscr":"ℋ","hslash":"ℏ","Hstrok":"Ħ","hstrok":"ħ","HumpDownHump":"≎","HumpEqual":"≏","hybull":"⁃","hyphen":"‐","Iacute":"\xcd","iacute":"\xed","ic":"⁣","Icirc":"\xce","icirc":"\xee","Icy":"И","icy":"и","Idot":"İ","IEcy":"Е","iecy":"е","iexcl":"\xa1","iff":"⇔","ifr":"\uD835\uDD26","Ifr":"ℑ","Igrave":"\xcc","igrave":"\xec","ii":"ⅈ","iiiint":"⨌","iiint":"∭","iinfin":"⧜","iiota":"℩","IJlig":"Ĳ","ijlig":"ĳ","Imacr":"Ī","imacr":"ī","image":"ℑ","ImaginaryI":"ⅈ","imagline":"ℐ","imagpart":"ℑ","imath":"ı","Im":"ℑ","imof":"⊷","imped":"Ƶ","Implies":"⇒","incare":"℅","in":"∈","infin":"∞","infintie":"⧝","inodot":"ı","intcal":"⊺","int":"∫","Int":"∬","integers":"ℤ","Integral":"∫","intercal":"⊺","Intersection":"⋂","intlarhk":"⨗","intprod":"⨼","InvisibleComma":"⁣","InvisibleTimes":"⁢","IOcy":"Ё","iocy":"ё","Iogon":"Į","iogon":"į","Iopf":"\uD835\uDD40","iopf":"\uD835\uDD5A","Iota":"Ι","iota":"ι","iprod":"⨼","iquest":"\xbf","iscr":"\uD835\uDCBE","Iscr":"ℐ","isin":"∈","isindot":"⋵","isinE":"⋹","isins":"⋴","isinsv":"⋳","isinv":"∈","it":"⁢","Itilde":"Ĩ","itilde":"ĩ","Iukcy":"І","iukcy":"і","Iuml":"\xcf","iuml":"\xef","Jcirc":"Ĵ","jcirc":"ĵ","Jcy":"Й","jcy":"й","Jfr":"\uD835\uDD0D","jfr":"\uD835\uDD27","jmath":"ȷ","Jopf":"\uD835\uDD41","jopf":"\uD835\uDD5B","Jscr":"\uD835\uDCA5","jscr":"\uD835\uDCBF","Jsercy":"Ј","jsercy":"ј","Jukcy":"Є","jukcy":"є","Kappa":"Κ","kappa":"κ","kappav":"ϰ","Kcedil":"Ķ","kcedil":"ķ","Kcy":"К","kcy":"к","Kfr":"\uD835\uDD0E","kfr":"\uD835\uDD28","kgreen":"ĸ","KHcy":"Х","khcy":"х","KJcy":"Ќ","kjcy":"ќ","Kopf":"\uD835\uDD42","kopf":"\uD835\uDD5C","Kscr":"\uD835\uDCA6","kscr":"\uD835\uDCC0","lAarr":"⇚","Lacute":"Ĺ","lacute":"ĺ","laemptyv":"⦴","lagran":"ℒ","Lambda":"Λ","lambda":"λ","lang":"⟨","Lang":"⟪","langd":"⦑","langle":"⟨","lap":"⪅","Laplacetrf":"ℒ","laquo":"\xab","larrb":"⇤","larrbfs":"⤟","larr":"←","Larr":"↞","lArr":"⇐","larrfs":"⤝","larrhk":"↩","larrlp":"↫","larrpl":"⤹","larrsim":"⥳","larrtl":"↢","latail":"⤙","lAtail":"⤛","lat":"⪫","late":"⪭","lates":"⪭︀","lbarr":"⤌","lBarr":"⤎","lbbrk":"❲","lbrace":"{","lbrack":"[","lbrke":"⦋","lbrksld":"⦏","lbrkslu":"⦍","Lcaron":"Ľ","lcaron":"ľ","Lcedil":"Ļ","lcedil":"ļ","lceil":"⌈","lcub":"{","Lcy":"Л","lcy":"л","ldca":"⤶","ldquo":"“","ldquor":"„","ldrdhar":"⥧","ldrushar":"⥋","ldsh":"↲","le":"≤","lE":"≦","LeftAngleBracket":"⟨","LeftArrowBar":"⇤","leftarrow":"←","LeftArrow":"←","Leftarrow":"⇐","LeftArrowRightArrow":"⇆","leftarrowtail":"↢","LeftCeiling":"⌈","LeftDoubleBracket":"⟦","LeftDownTeeVector":"⥡","LeftDownVectorBar":"⥙","LeftDownVector":"⇃","LeftFloor":"⌊","leftharpoondown":"↽","leftharpoonup":"↼","leftleftarrows":"⇇","leftrightarrow":"↔","LeftRightArrow":"↔","Leftrightarrow":"⇔","leftrightarrows":"⇆","leftrightharpoons":"⇋","leftrightsquigarrow":"↭","LeftRightVector":"⥎","LeftTeeArrow":"↤","LeftTee":"⊣","LeftTeeVector":"⥚","leftthreetimes":"⋋","LeftTriangleBar":"⧏","LeftTriangle":"⊲","LeftTriangleEqual":"⊴","LeftUpDownVector":"⥑","LeftUpTeeVector":"⥠","LeftUpVectorBar":"⥘","LeftUpVector":"↿","LeftVectorBar":"⥒","LeftVector":"↼","lEg":"⪋","leg":"⋚","leq":"≤","leqq":"≦","leqslant":"⩽","lescc":"⪨","les":"⩽","lesdot":"⩿","lesdoto":"⪁","lesdotor":"⪃","lesg":"⋚︀","lesges":"⪓","lessapprox":"⪅","lessdot":"⋖","lesseqgtr":"⋚","lesseqqgtr":"⪋","LessEqualGreater":"⋚","LessFullEqual":"≦","LessGreater":"≶","lessgtr":"≶","LessLess":"⪡","lesssim":"≲","LessSlantEqual":"⩽","LessTilde":"≲","lfisht":"⥼","lfloor":"⌊","Lfr":"\uD835\uDD0F","lfr":"\uD835\uDD29","lg":"≶","lgE":"⪑","lHar":"⥢","lhard":"↽","lharu":"↼","lharul":"⥪","lhblk":"▄","LJcy":"Љ","ljcy":"љ","llarr":"⇇","ll":"≪","Ll":"⋘","llcorner":"⌞","Lleftarrow":"⇚","llhard":"⥫","lltri":"◺","Lmidot":"Ŀ","lmidot":"ŀ","lmoustache":"⎰","lmoust":"⎰","lnap":"⪉","lnapprox":"⪉","lne":"⪇","lnE":"≨","lneq":"⪇","lneqq":"≨","lnsim":"⋦","loang":"⟬","loarr":"⇽","lobrk":"⟦","longleftarrow":"⟵","LongLeftArrow":"⟵","Longleftarrow":"⟸","longleftrightarrow":"⟷","LongLeftRightArrow":"⟷","Longleftrightarrow":"⟺","longmapsto":"⟼","longrightarrow":"⟶","LongRightArrow":"⟶","Longrightarrow":"⟹","looparrowleft":"↫","looparrowright":"↬","lopar":"⦅","Lopf":"\uD835\uDD43","lopf":"\uD835\uDD5D","loplus":"⨭","lotimes":"⨴","lowast":"∗","lowbar":"_","LowerLeftArrow":"↙","LowerRightArrow":"↘","loz":"◊","lozenge":"◊","lozf":"⧫","lpar":"(","lparlt":"⦓","lrarr":"⇆","lrcorner":"⌟","lrhar":"⇋","lrhard":"⥭","lrm":"‎","lrtri":"⊿","lsaquo":"‹","lscr":"\uD835\uDCC1","Lscr":"ℒ","lsh":"↰","Lsh":"↰","lsim":"≲","lsime":"⪍","lsimg":"⪏","lsqb":"[","lsquo":"‘","lsquor":"‚","Lstrok":"Ł","lstrok":"ł","ltcc":"⪦","ltcir":"⩹","lt":"<","LT":"<","Lt":"≪","ltdot":"⋖","lthree":"⋋","ltimes":"⋉","ltlarr":"⥶","ltquest":"⩻","ltri":"◃","ltrie":"⊴","ltrif":"◂","ltrPar":"⦖","lurdshar":"⥊","luruhar":"⥦","lvertneqq":"≨︀","lvnE":"≨︀","macr":"\xaf","male":"♂","malt":"✠","maltese":"✠","Map":"⤅","map":"↦","mapsto":"↦","mapstodown":"↧","mapstoleft":"↤","mapstoup":"↥","marker":"▮","mcomma":"⨩","Mcy":"М","mcy":"м","mdash":"—","mDDot":"∺","measuredangle":"∡","MediumSpace":" ","Mellintrf":"ℳ","Mfr":"\uD835\uDD10","mfr":"\uD835\uDD2A","mho":"℧","micro":"\xb5","midast":"*","midcir":"⫰","mid":"∣","middot":"\xb7","minusb":"⊟","minus":"−","minusd":"∸","minusdu":"⨪","MinusPlus":"∓","mlcp":"⫛","mldr":"…","mnplus":"∓","models":"⊧","Mopf":"\uD835\uDD44","mopf":"\uD835\uDD5E","mp":"∓","mscr":"\uD835\uDCC2","Mscr":"ℳ","mstpos":"∾","Mu":"Μ","mu":"μ","multimap":"⊸","mumap":"⊸","nabla":"∇","Nacute":"Ń","nacute":"ń","nang":"∠⃒","nap":"≉","napE":"⩰̸","napid":"≋̸","napos":"ŉ","napprox":"≉","natural":"♮","naturals":"ℕ","natur":"♮","nbsp":"\xa0","nbump":"≎̸","nbumpe":"≏̸","ncap":"⩃","Ncaron":"Ň","ncaron":"ň","Ncedil":"Ņ","ncedil":"ņ","ncong":"≇","ncongdot":"⩭̸","ncup":"⩂","Ncy":"Н","ncy":"н","ndash":"–","nearhk":"⤤","nearr":"↗","neArr":"⇗","nearrow":"↗","ne":"≠","nedot":"≐̸","NegativeMediumSpace":"​","NegativeThickSpace":"​","NegativeThinSpace":"​","NegativeVeryThinSpace":"​","nequiv":"≢","nesear":"⤨","nesim":"≂̸","NestedGreaterGreater":"≫","NestedLessLess":"≪","NewLine":"\\n","nexist":"∄","nexists":"∄","Nfr":"\uD835\uDD11","nfr":"\uD835\uDD2B","ngE":"≧̸","nge":"≱","ngeq":"≱","ngeqq":"≧̸","ngeqslant":"⩾̸","nges":"⩾̸","nGg":"⋙̸","ngsim":"≵","nGt":"≫⃒","ngt":"≯","ngtr":"≯","nGtv":"≫̸","nharr":"↮","nhArr":"⇎","nhpar":"⫲","ni":"∋","nis":"⋼","nisd":"⋺","niv":"∋","NJcy":"Њ","njcy":"њ","nlarr":"↚","nlArr":"⇍","nldr":"‥","nlE":"≦̸","nle":"≰","nleftarrow":"↚","nLeftarrow":"⇍","nleftrightarrow":"↮","nLeftrightarrow":"⇎","nleq":"≰","nleqq":"≦̸","nleqslant":"⩽̸","nles":"⩽̸","nless":"≮","nLl":"⋘̸","nlsim":"≴","nLt":"≪⃒","nlt":"≮","nltri":"⋪","nltrie":"⋬","nLtv":"≪̸","nmid":"∤","NoBreak":"⁠","NonBreakingSpace":"\xa0","nopf":"\uD835\uDD5F","Nopf":"ℕ","Not":"⫬","not":"\xac","NotCongruent":"≢","NotCupCap":"≭","NotDoubleVerticalBar":"∦","NotElement":"∉","NotEqual":"≠","NotEqualTilde":"≂̸","NotExists":"∄","NotGreater":"≯","NotGreaterEqual":"≱","NotGreaterFullEqual":"≧̸","NotGreaterGreater":"≫̸","NotGreaterLess":"≹","NotGreaterSlantEqual":"⩾̸","NotGreaterTilde":"≵","NotHumpDownHump":"≎̸","NotHumpEqual":"≏̸","notin":"∉","notindot":"⋵̸","notinE":"⋹̸","notinva":"∉","notinvb":"⋷","notinvc":"⋶","NotLeftTriangleBar":"⧏̸","NotLeftTriangle":"⋪","NotLeftTriangleEqual":"⋬","NotLess":"≮","NotLessEqual":"≰","NotLessGreater":"≸","NotLessLess":"≪̸","NotLessSlantEqual":"⩽̸","NotLessTilde":"≴","NotNestedGreaterGreater":"⪢̸","NotNestedLessLess":"⪡̸","notni":"∌","notniva":"∌","notnivb":"⋾","notnivc":"⋽","NotPrecedes":"⊀","NotPrecedesEqual":"⪯̸","NotPrecedesSlantEqual":"⋠","NotReverseElement":"∌","NotRightTriangleBar":"⧐̸","NotRightTriangle":"⋫","NotRightTriangleEqual":"⋭","NotSquareSubset":"⊏̸","NotSquareSubsetEqual":"⋢","NotSquareSuperset":"⊐̸","NotSquareSupersetEqual":"⋣","NotSubset":"⊂⃒","NotSubsetEqual":"⊈","NotSucceeds":"⊁","NotSucceedsEqual":"⪰̸","NotSucceedsSlantEqual":"⋡","NotSucceedsTilde":"≿̸","NotSuperset":"⊃⃒","NotSupersetEqual":"⊉","NotTilde":"≁","NotTildeEqual":"≄","NotTildeFullEqual":"≇","NotTildeTilde":"≉","NotVerticalBar":"∤","nparallel":"∦","npar":"∦","nparsl":"⫽⃥","npart":"∂̸","npolint":"⨔","npr":"⊀","nprcue":"⋠","nprec":"⊀","npreceq":"⪯̸","npre":"⪯̸","nrarrc":"⤳̸","nrarr":"↛","nrArr":"⇏","nrarrw":"↝̸","nrightarrow":"↛","nRightarrow":"⇏","nrtri":"⋫","nrtrie":"⋭","nsc":"⊁","nsccue":"⋡","nsce":"⪰̸","Nscr":"\uD835\uDCA9","nscr":"\uD835\uDCC3","nshortmid":"∤","nshortparallel":"∦","nsim":"≁","nsime":"≄","nsimeq":"≄","nsmid":"∤","nspar":"∦","nsqsube":"⋢","nsqsupe":"⋣","nsub":"⊄","nsubE":"⫅̸","nsube":"⊈","nsubset":"⊂⃒","nsubseteq":"⊈","nsubseteqq":"⫅̸","nsucc":"⊁","nsucceq":"⪰̸","nsup":"⊅","nsupE":"⫆̸","nsupe":"⊉","nsupset":"⊃⃒","nsupseteq":"⊉","nsupseteqq":"⫆̸","ntgl":"≹","Ntilde":"\xd1","ntilde":"\xf1","ntlg":"≸","ntriangleleft":"⋪","ntrianglelefteq":"⋬","ntriangleright":"⋫","ntrianglerighteq":"⋭","Nu":"Ν","nu":"ν","num":"#","numero":"№","numsp":" ","nvap":"≍⃒","nvdash":"⊬","nvDash":"⊭","nVdash":"⊮","nVDash":"⊯","nvge":"≥⃒","nvgt":">⃒","nvHarr":"⤄","nvinfin":"⧞","nvlArr":"⤂","nvle":"≤⃒","nvlt":"<⃒","nvltrie":"⊴⃒","nvrArr":"⤃","nvrtrie":"⊵⃒","nvsim":"∼⃒","nwarhk":"⤣","nwarr":"↖","nwArr":"⇖","nwarrow":"↖","nwnear":"⤧","Oacute":"\xd3","oacute":"\xf3","oast":"⊛","Ocirc":"\xd4","ocirc":"\xf4","ocir":"⊚","Ocy":"О","ocy":"о","odash":"⊝","Odblac":"Ő","odblac":"ő","odiv":"⨸","odot":"⊙","odsold":"⦼","OElig":"Œ","oelig":"œ","ofcir":"⦿","Ofr":"\uD835\uDD12","ofr":"\uD835\uDD2C","ogon":"˛","Ograve":"\xd2","ograve":"\xf2","ogt":"⧁","ohbar":"⦵","ohm":"Ω","oint":"∮","olarr":"↺","olcir":"⦾","olcross":"⦻","oline":"‾","olt":"⧀","Omacr":"Ō","omacr":"ō","Omega":"Ω","omega":"ω","Omicron":"Ο","omicron":"ο","omid":"⦶","ominus":"⊖","Oopf":"\uD835\uDD46","oopf":"\uD835\uDD60","opar":"⦷","OpenCurlyDoubleQuote":"“","OpenCurlyQuote":"‘","operp":"⦹","oplus":"⊕","orarr":"↻","Or":"⩔","or":"∨","ord":"⩝","order":"ℴ","orderof":"ℴ","ordf":"\xaa","ordm":"\xba","origof":"⊶","oror":"⩖","orslope":"⩗","orv":"⩛","oS":"Ⓢ","Oscr":"\uD835\uDCAA","oscr":"ℴ","Oslash":"\xd8","oslash":"\xf8","osol":"⊘","Otilde":"\xd5","otilde":"\xf5","otimesas":"⨶","Otimes":"⨷","otimes":"⊗","Ouml":"\xd6","ouml":"\xf6","ovbar":"⌽","OverBar":"‾","OverBrace":"⏞","OverBracket":"⎴","OverParenthesis":"⏜","para":"\xb6","parallel":"∥","par":"∥","parsim":"⫳","parsl":"⫽","part":"∂","PartialD":"∂","Pcy":"П","pcy":"п","percnt":"%","period":".","permil":"‰","perp":"⊥","pertenk":"‱","Pfr":"\uD835\uDD13","pfr":"\uD835\uDD2D","Phi":"Φ","phi":"φ","phiv":"ϕ","phmmat":"ℳ","phone":"☎","Pi":"Π","pi":"π","pitchfork":"⋔","piv":"ϖ","planck":"ℏ","planckh":"ℎ","plankv":"ℏ","plusacir":"⨣","plusb":"⊞","pluscir":"⨢","plus":"+","plusdo":"∔","plusdu":"⨥","pluse":"⩲","PlusMinus":"\xb1","plusmn":"\xb1","plussim":"⨦","plustwo":"⨧","pm":"\xb1","Poincareplane":"ℌ","pointint":"⨕","popf":"\uD835\uDD61","Popf":"ℙ","pound":"\xa3","prap":"⪷","Pr":"⪻","pr":"≺","prcue":"≼","precapprox":"⪷","prec":"≺","preccurlyeq":"≼","Precedes":"≺","PrecedesEqual":"⪯","PrecedesSlantEqual":"≼","PrecedesTilde":"≾","preceq":"⪯","precnapprox":"⪹","precneqq":"⪵","precnsim":"⋨","pre":"⪯","prE":"⪳","precsim":"≾","prime":"′","Prime":"″","primes":"ℙ","prnap":"⪹","prnE":"⪵","prnsim":"⋨","prod":"∏","Product":"∏","profalar":"⌮","profline":"⌒","profsurf":"⌓","prop":"∝","Proportional":"∝","Proportion":"∷","propto":"∝","prsim":"≾","prurel":"⊰","Pscr":"\uD835\uDCAB","pscr":"\uD835\uDCC5","Psi":"Ψ","psi":"ψ","puncsp":" ","Qfr":"\uD835\uDD14","qfr":"\uD835\uDD2E","qint":"⨌","qopf":"\uD835\uDD62","Qopf":"ℚ","qprime":"⁗","Qscr":"\uD835\uDCAC","qscr":"\uD835\uDCC6","quaternions":"ℍ","quatint":"⨖","quest":"?","questeq":"≟","quot":"\\"","QUOT":"\\"","rAarr":"⇛","race":"∽̱","Racute":"Ŕ","racute":"ŕ","radic":"√","raemptyv":"⦳","rang":"⟩","Rang":"⟫","rangd":"⦒","range":"⦥","rangle":"⟩","raquo":"\xbb","rarrap":"⥵","rarrb":"⇥","rarrbfs":"⤠","rarrc":"⤳","rarr":"→","Rarr":"↠","rArr":"⇒","rarrfs":"⤞","rarrhk":"↪","rarrlp":"↬","rarrpl":"⥅","rarrsim":"⥴","Rarrtl":"⤖","rarrtl":"↣","rarrw":"↝","ratail":"⤚","rAtail":"⤜","ratio":"∶","rationals":"ℚ","rbarr":"⤍","rBarr":"⤏","RBarr":"⤐","rbbrk":"❳","rbrace":"}","rbrack":"]","rbrke":"⦌","rbrksld":"⦎","rbrkslu":"⦐","Rcaron":"Ř","rcaron":"ř","Rcedil":"Ŗ","rcedil":"ŗ","rceil":"⌉","rcub":"}","Rcy":"Р","rcy":"р","rdca":"⤷","rdldhar":"⥩","rdquo":"”","rdquor":"”","rdsh":"↳","real":"ℜ","realine":"ℛ","realpart":"ℜ","reals":"ℝ","Re":"ℜ","rect":"▭","reg":"\xae","REG":"\xae","ReverseElement":"∋","ReverseEquilibrium":"⇋","ReverseUpEquilibrium":"⥯","rfisht":"⥽","rfloor":"⌋","rfr":"\uD835\uDD2F","Rfr":"ℜ","rHar":"⥤","rhard":"⇁","rharu":"⇀","rharul":"⥬","Rho":"Ρ","rho":"ρ","rhov":"ϱ","RightAngleBracket":"⟩","RightArrowBar":"⇥","rightarrow":"→","RightArrow":"→","Rightarrow":"⇒","RightArrowLeftArrow":"⇄","rightarrowtail":"↣","RightCeiling":"⌉","RightDoubleBracket":"⟧","RightDownTeeVector":"⥝","RightDownVectorBar":"⥕","RightDownVector":"⇂","RightFloor":"⌋","rightharpoondown":"⇁","rightharpoonup":"⇀","rightleftarrows":"⇄","rightleftharpoons":"⇌","rightrightarrows":"⇉","rightsquigarrow":"↝","RightTeeArrow":"↦","RightTee":"⊢","RightTeeVector":"⥛","rightthreetimes":"⋌","RightTriangleBar":"⧐","RightTriangle":"⊳","RightTriangleEqual":"⊵","RightUpDownVector":"⥏","RightUpTeeVector":"⥜","RightUpVectorBar":"⥔","RightUpVector":"↾","RightVectorBar":"⥓","RightVector":"⇀","ring":"˚","risingdotseq":"≓","rlarr":"⇄","rlhar":"⇌","rlm":"‏","rmoustache":"⎱","rmoust":"⎱","rnmid":"⫮","roang":"⟭","roarr":"⇾","robrk":"⟧","ropar":"⦆","ropf":"\uD835\uDD63","Ropf":"ℝ","roplus":"⨮","rotimes":"⨵","RoundImplies":"⥰","rpar":")","rpargt":"⦔","rppolint":"⨒","rrarr":"⇉","Rrightarrow":"⇛","rsaquo":"›","rscr":"\uD835\uDCC7","Rscr":"ℛ","rsh":"↱","Rsh":"↱","rsqb":"]","rsquo":"’","rsquor":"’","rthree":"⋌","rtimes":"⋊","rtri":"▹","rtrie":"⊵","rtrif":"▸","rtriltri":"⧎","RuleDelayed":"⧴","ruluhar":"⥨","rx":"℞","Sacute":"Ś","sacute":"ś","sbquo":"‚","scap":"⪸","Scaron":"Š","scaron":"š","Sc":"⪼","sc":"≻","sccue":"≽","sce":"⪰","scE":"⪴","Scedil":"Ş","scedil":"ş","Scirc":"Ŝ","scirc":"ŝ","scnap":"⪺","scnE":"⪶","scnsim":"⋩","scpolint":"⨓","scsim":"≿","Scy":"С","scy":"с","sdotb":"⊡","sdot":"⋅","sdote":"⩦","searhk":"⤥","searr":"↘","seArr":"⇘","searrow":"↘","sect":"\xa7","semi":";","seswar":"⤩","setminus":"∖","setmn":"∖","sext":"✶","Sfr":"\uD835\uDD16","sfr":"\uD835\uDD30","sfrown":"⌢","sharp":"♯","SHCHcy":"Щ","shchcy":"щ","SHcy":"Ш","shcy":"ш","ShortDownArrow":"↓","ShortLeftArrow":"←","shortmid":"∣","shortparallel":"∥","ShortRightArrow":"→","ShortUpArrow":"↑","shy":"\xad","Sigma":"Σ","sigma":"σ","sigmaf":"ς","sigmav":"ς","sim":"∼","simdot":"⩪","sime":"≃","simeq":"≃","simg":"⪞","simgE":"⪠","siml":"⪝","simlE":"⪟","simne":"≆","simplus":"⨤","simrarr":"⥲","slarr":"←","SmallCircle":"∘","smallsetminus":"∖","smashp":"⨳","smeparsl":"⧤","smid":"∣","smile":"⌣","smt":"⪪","smte":"⪬","smtes":"⪬︀","SOFTcy":"Ь","softcy":"ь","solbar":"⌿","solb":"⧄","sol":"/","Sopf":"\uD835\uDD4A","sopf":"\uD835\uDD64","spades":"♠","spadesuit":"♠","spar":"∥","sqcap":"⊓","sqcaps":"⊓︀","sqcup":"⊔","sqcups":"⊔︀","Sqrt":"√","sqsub":"⊏","sqsube":"⊑","sqsubset":"⊏","sqsubseteq":"⊑","sqsup":"⊐","sqsupe":"⊒","sqsupset":"⊐","sqsupseteq":"⊒","square":"□","Square":"□","SquareIntersection":"⊓","SquareSubset":"⊏","SquareSubsetEqual":"⊑","SquareSuperset":"⊐","SquareSupersetEqual":"⊒","SquareUnion":"⊔","squarf":"▪","squ":"□","squf":"▪","srarr":"→","Sscr":"\uD835\uDCAE","sscr":"\uD835\uDCC8","ssetmn":"∖","ssmile":"⌣","sstarf":"⋆","Star":"⋆","star":"☆","starf":"★","straightepsilon":"ϵ","straightphi":"ϕ","strns":"\xaf","sub":"⊂","Sub":"⋐","subdot":"⪽","subE":"⫅","sube":"⊆","subedot":"⫃","submult":"⫁","subnE":"⫋","subne":"⊊","subplus":"⪿","subrarr":"⥹","subset":"⊂","Subset":"⋐","subseteq":"⊆","subseteqq":"⫅","SubsetEqual":"⊆","subsetneq":"⊊","subsetneqq":"⫋","subsim":"⫇","subsub":"⫕","subsup":"⫓","succapprox":"⪸","succ":"≻","succcurlyeq":"≽","Succeeds":"≻","SucceedsEqual":"⪰","SucceedsSlantEqual":"≽","SucceedsTilde":"≿","succeq":"⪰","succnapprox":"⪺","succneqq":"⪶","succnsim":"⋩","succsim":"≿","SuchThat":"∋","sum":"∑","Sum":"∑","sung":"♪","sup1":"\xb9","sup2":"\xb2","sup3":"\xb3","sup":"⊃","Sup":"⋑","supdot":"⪾","supdsub":"⫘","supE":"⫆","supe":"⊇","supedot":"⫄","Superset":"⊃","SupersetEqual":"⊇","suphsol":"⟉","suphsub":"⫗","suplarr":"⥻","supmult":"⫂","supnE":"⫌","supne":"⊋","supplus":"⫀","supset":"⊃","Supset":"⋑","supseteq":"⊇","supseteqq":"⫆","supsetneq":"⊋","supsetneqq":"⫌","supsim":"⫈","supsub":"⫔","supsup":"⫖","swarhk":"⤦","swarr":"↙","swArr":"⇙","swarrow":"↙","swnwar":"⤪","szlig":"\xdf","Tab":"\\t","target":"⌖","Tau":"Τ","tau":"τ","tbrk":"⎴","Tcaron":"Ť","tcaron":"ť","Tcedil":"Ţ","tcedil":"ţ","Tcy":"Т","tcy":"т","tdot":"⃛","telrec":"⌕","Tfr":"\uD835\uDD17","tfr":"\uD835\uDD31","there4":"∴","therefore":"∴","Therefore":"∴","Theta":"Θ","theta":"θ","thetasym":"ϑ","thetav":"ϑ","thickapprox":"≈","thicksim":"∼","ThickSpace":"  ","ThinSpace":" ","thinsp":" ","thkap":"≈","thksim":"∼","THORN":"\xde","thorn":"\xfe","tilde":"˜","Tilde":"∼","TildeEqual":"≃","TildeFullEqual":"≅","TildeTilde":"≈","timesbar":"⨱","timesb":"⊠","times":"\xd7","timesd":"⨰","tint":"∭","toea":"⤨","topbot":"⌶","topcir":"⫱","top":"⊤","Topf":"\uD835\uDD4B","topf":"\uD835\uDD65","topfork":"⫚","tosa":"⤩","tprime":"‴","trade":"™","TRADE":"™","triangle":"▵","triangledown":"▿","triangleleft":"◃","trianglelefteq":"⊴","triangleq":"≜","triangleright":"▹","trianglerighteq":"⊵","tridot":"◬","trie":"≜","triminus":"⨺","TripleDot":"⃛","triplus":"⨹","trisb":"⧍","tritime":"⨻","trpezium":"⏢","Tscr":"\uD835\uDCAF","tscr":"\uD835\uDCC9","TScy":"Ц","tscy":"ц","TSHcy":"Ћ","tshcy":"ћ","Tstrok":"Ŧ","tstrok":"ŧ","twixt":"≬","twoheadleftarrow":"↞","twoheadrightarrow":"↠","Uacute":"\xda","uacute":"\xfa","uarr":"↑","Uarr":"↟","uArr":"⇑","Uarrocir":"⥉","Ubrcy":"Ў","ubrcy":"ў","Ubreve":"Ŭ","ubreve":"ŭ","Ucirc":"\xdb","ucirc":"\xfb","Ucy":"У","ucy":"у","udarr":"⇅","Udblac":"Ű","udblac":"ű","udhar":"⥮","ufisht":"⥾","Ufr":"\uD835\uDD18","ufr":"\uD835\uDD32","Ugrave":"\xd9","ugrave":"\xf9","uHar":"⥣","uharl":"↿","uharr":"↾","uhblk":"▀","ulcorn":"⌜","ulcorner":"⌜","ulcrop":"⌏","ultri":"◸","Umacr":"Ū","umacr":"ū","uml":"\xa8","UnderBar":"_","UnderBrace":"⏟","UnderBracket":"⎵","UnderParenthesis":"⏝","Union":"⋃","UnionPlus":"⊎","Uogon":"Ų","uogon":"ų","Uopf":"\uD835\uDD4C","uopf":"\uD835\uDD66","UpArrowBar":"⤒","uparrow":"↑","UpArrow":"↑","Uparrow":"⇑","UpArrowDownArrow":"⇅","updownarrow":"↕","UpDownArrow":"↕","Updownarrow":"⇕","UpEquilibrium":"⥮","upharpoonleft":"↿","upharpoonright":"↾","uplus":"⊎","UpperLeftArrow":"↖","UpperRightArrow":"↗","upsi":"υ","Upsi":"ϒ","upsih":"ϒ","Upsilon":"Υ","upsilon":"υ","UpTeeArrow":"↥","UpTee":"⊥","upuparrows":"⇈","urcorn":"⌝","urcorner":"⌝","urcrop":"⌎","Uring":"Ů","uring":"ů","urtri":"◹","Uscr":"\uD835\uDCB0","uscr":"\uD835\uDCCA","utdot":"⋰","Utilde":"Ũ","utilde":"ũ","utri":"▵","utrif":"▴","uuarr":"⇈","Uuml":"\xdc","uuml":"\xfc","uwangle":"⦧","vangrt":"⦜","varepsilon":"ϵ","varkappa":"ϰ","varnothing":"∅","varphi":"ϕ","varpi":"ϖ","varpropto":"∝","varr":"↕","vArr":"⇕","varrho":"ϱ","varsigma":"ς","varsubsetneq":"⊊︀","varsubsetneqq":"⫋︀","varsupsetneq":"⊋︀","varsupsetneqq":"⫌︀","vartheta":"ϑ","vartriangleleft":"⊲","vartriangleright":"⊳","vBar":"⫨","Vbar":"⫫","vBarv":"⫩","Vcy":"В","vcy":"в","vdash":"⊢","vDash":"⊨","Vdash":"⊩","VDash":"⊫","Vdashl":"⫦","veebar":"⊻","vee":"∨","Vee":"⋁","veeeq":"≚","vellip":"⋮","verbar":"|","Verbar":"‖","vert":"|","Vert":"‖","VerticalBar":"∣","VerticalLine":"|","VerticalSeparator":"❘","VerticalTilde":"≀","VeryThinSpace":" ","Vfr":"\uD835\uDD19","vfr":"\uD835\uDD33","vltri":"⊲","vnsub":"⊂⃒","vnsup":"⊃⃒","Vopf":"\uD835\uDD4D","vopf":"\uD835\uDD67","vprop":"∝","vrtri":"⊳","Vscr":"\uD835\uDCB1","vscr":"\uD835\uDCCB","vsubnE":"⫋︀","vsubne":"⊊︀","vsupnE":"⫌︀","vsupne":"⊋︀","Vvdash":"⊪","vzigzag":"⦚","Wcirc":"Ŵ","wcirc":"ŵ","wedbar":"⩟","wedge":"∧","Wedge":"⋀","wedgeq":"≙","weierp":"℘","Wfr":"\uD835\uDD1A","wfr":"\uD835\uDD34","Wopf":"\uD835\uDD4E","wopf":"\uD835\uDD68","wp":"℘","wr":"≀","wreath":"≀","Wscr":"\uD835\uDCB2","wscr":"\uD835\uDCCC","xcap":"⋂","xcirc":"◯","xcup":"⋃","xdtri":"▽","Xfr":"\uD835\uDD1B","xfr":"\uD835\uDD35","xharr":"⟷","xhArr":"⟺","Xi":"Ξ","xi":"ξ","xlarr":"⟵","xlArr":"⟸","xmap":"⟼","xnis":"⋻","xodot":"⨀","Xopf":"\uD835\uDD4F","xopf":"\uD835\uDD69","xoplus":"⨁","xotime":"⨂","xrarr":"⟶","xrArr":"⟹","Xscr":"\uD835\uDCB3","xscr":"\uD835\uDCCD","xsqcup":"⨆","xuplus":"⨄","xutri":"△","xvee":"⋁","xwedge":"⋀","Yacute":"\xdd","yacute":"\xfd","YAcy":"Я","yacy":"я","Ycirc":"Ŷ","ycirc":"ŷ","Ycy":"Ы","ycy":"ы","yen":"\xa5","Yfr":"\uD835\uDD1C","yfr":"\uD835\uDD36","YIcy":"Ї","yicy":"ї","Yopf":"\uD835\uDD50","yopf":"\uD835\uDD6A","Yscr":"\uD835\uDCB4","yscr":"\uD835\uDCCE","YUcy":"Ю","yucy":"ю","yuml":"\xff","Yuml":"Ÿ","Zacute":"Ź","zacute":"ź","Zcaron":"Ž","zcaron":"ž","Zcy":"З","zcy":"з","Zdot":"Ż","zdot":"ż","zeetrf":"ℨ","ZeroWidthSpace":"​","Zeta":"Ζ","zeta":"ζ","zfr":"\uD835\uDD37","Zfr":"ℨ","ZHcy":"Ж","zhcy":"ж","zigrarr":"⇝","zopf":"\uD835\uDD6B","Zopf":"ℤ","Zscr":"\uD835\uDCB5","zscr":"\uD835\uDCCF","zwj":"‍","zwnj":"‌"}');

});



parcelRequire.register("702rI", function(module, exports) {

$parcel$export(module.exports, "parseLinkLabel", () => $518a6e3318f315d6$export$2a2c8612930e58d0, (v) => $518a6e3318f315d6$export$2a2c8612930e58d0 = v);
$parcel$export(module.exports, "parseLinkDestination", () => $518a6e3318f315d6$export$22bd24080f95f2b3, (v) => $518a6e3318f315d6$export$22bd24080f95f2b3 = v);
$parcel$export(module.exports, "parseLinkTitle", () => $518a6e3318f315d6$export$89650c5477a69db9, (v) => $518a6e3318f315d6$export$89650c5477a69db9 = v);
// Just a shortcut for bulk export
var $518a6e3318f315d6$export$2a2c8612930e58d0;
var $518a6e3318f315d6$export$22bd24080f95f2b3;
var $518a6e3318f315d6$export$89650c5477a69db9;
"use strict";

$518a6e3318f315d6$export$2a2c8612930e58d0 = (parcelRequire("dOXAK"));

$518a6e3318f315d6$export$22bd24080f95f2b3 = (parcelRequire("9z6Aw"));

$518a6e3318f315d6$export$89650c5477a69db9 = (parcelRequire("kp7YO"));

});
parcelRequire.register("dOXAK", function(module, exports) {
// Parse link label
//
// this function assumes that first character ("[") already matches;
// returns the end of the label
//
"use strict";
module.exports = function parseLinkLabel(state, start, disableNested) {
    var level, found, marker, prevPos, labelEnd = -1, max = state.posMax, oldPos = state.pos;
    state.pos = start + 1;
    level = 1;
    while(state.pos < max){
        marker = state.src.charCodeAt(state.pos);
        if (marker === 0x5D /* ] */ ) {
            level--;
            if (level === 0) {
                found = true;
                break;
            }
        }
        prevPos = state.pos;
        state.md.inline.skipToken(state);
        if (marker === 0x5B /* [ */ ) {
            if (prevPos === state.pos - 1) // increase level if we find text `[`, which is not a part of any token
            level++;
            else if (disableNested) {
                state.pos = oldPos;
                return -1;
            }
        }
    }
    if (found) labelEnd = state.pos;
    // restore old state
    state.pos = oldPos;
    return labelEnd;
};

});

parcelRequire.register("9z6Aw", function(module, exports) {
// Parse link destination
//
"use strict";

var $iXVVQ = parcelRequire("iXVVQ");
var $6f6c7e2d94afd6a5$require$unescapeAll = $iXVVQ.unescapeAll;
module.exports = function parseLinkDestination(str, pos, max) {
    var code, level, lines = 0, start = pos, result = {
        ok: false,
        pos: 0,
        lines: 0,
        str: ""
    };
    if (str.charCodeAt(pos) === 0x3C /* < */ ) {
        pos++;
        while(pos < max){
            code = str.charCodeAt(pos);
            if (code === 0x0A /* \n */ ) return result;
            if (code === 0x3C /* < */ ) return result;
            if (code === 0x3E /* > */ ) {
                result.pos = pos + 1;
                result.str = $6f6c7e2d94afd6a5$require$unescapeAll(str.slice(start + 1, pos));
                result.ok = true;
                return result;
            }
            if (code === 0x5C /* \ */  && pos + 1 < max) {
                pos += 2;
                continue;
            }
            pos++;
        }
        // no closing '>'
        return result;
    }
    // this should be ... } else { ... branch
    level = 0;
    while(pos < max){
        code = str.charCodeAt(pos);
        if (code === 0x20) break;
        // ascii control characters
        if (code < 0x20 || code === 0x7F) break;
        if (code === 0x5C /* \ */  && pos + 1 < max) {
            if (str.charCodeAt(pos + 1) === 0x20) break;
            pos += 2;
            continue;
        }
        if (code === 0x28 /* ( */ ) {
            level++;
            if (level > 32) return result;
        }
        if (code === 0x29 /* ) */ ) {
            if (level === 0) break;
            level--;
        }
        pos++;
    }
    if (start === pos) return result;
    if (level !== 0) return result;
    result.str = $6f6c7e2d94afd6a5$require$unescapeAll(str.slice(start, pos));
    result.lines = lines;
    result.pos = pos;
    result.ok = true;
    return result;
};

});

parcelRequire.register("kp7YO", function(module, exports) {
// Parse link title
//
"use strict";

var $iXVVQ = parcelRequire("iXVVQ");
var $edac5510584d0827$require$unescapeAll = $iXVVQ.unescapeAll;
module.exports = function parseLinkTitle(str, pos, max) {
    var code, marker, lines = 0, start = pos, result = {
        ok: false,
        pos: 0,
        lines: 0,
        str: ""
    };
    if (pos >= max) return result;
    marker = str.charCodeAt(pos);
    if (marker !== 0x22 /* " */  && marker !== 0x27 /* ' */  && marker !== 0x28 /* ( */ ) return result;
    pos++;
    // if opening marker is "(", switch it to closing marker ")"
    if (marker === 0x28) marker = 0x29;
    while(pos < max){
        code = str.charCodeAt(pos);
        if (code === marker) {
            result.pos = pos + 1;
            result.lines = lines;
            result.str = $edac5510584d0827$require$unescapeAll(str.slice(start + 1, pos));
            result.ok = true;
            return result;
        } else if (code === 0x28 /* ( */  && marker === 0x29 /* ) */ ) return result;
        else if (code === 0x0A) lines++;
        else if (code === 0x5C /* \ */  && pos + 1 < max) {
            pos++;
            if (str.charCodeAt(pos) === 0x0A) lines++;
        }
        pos++;
    }
    return result;
};

});


parcelRequire.register("dBmFH", function(module, exports) {
/**
 * class Renderer
 *
 * Generates HTML from parsed token stream. Each instance has independent
 * copy of rules. Those can be rewritten with ease. Also, you can add new
 * rules if you create plugin and adds new token types.
 **/ "use strict";

var $iXVVQ = parcelRequire("iXVVQ");
var $9e70512970c7d9dc$require$assign = $iXVVQ.assign;

var $iXVVQ = parcelRequire("iXVVQ");
var $9e70512970c7d9dc$require$unescapeAll = $iXVVQ.unescapeAll;

var $iXVVQ = parcelRequire("iXVVQ");
var $9e70512970c7d9dc$require$escapeHtml = $iXVVQ.escapeHtml;
////////////////////////////////////////////////////////////////////////////////
var $9e70512970c7d9dc$var$default_rules = {};
$9e70512970c7d9dc$var$default_rules.code_inline = function(tokens, idx, options, env, slf) {
    var token = tokens[idx];
    return "<code" + slf.renderAttrs(token) + ">" + $9e70512970c7d9dc$require$escapeHtml(tokens[idx].content) + "</code>";
};
$9e70512970c7d9dc$var$default_rules.code_block = function(tokens, idx, options, env, slf) {
    var token = tokens[idx];
    return "<pre" + slf.renderAttrs(token) + "><code>" + $9e70512970c7d9dc$require$escapeHtml(tokens[idx].content) + "</code></pre>\n";
};
$9e70512970c7d9dc$var$default_rules.fence = function(tokens, idx, options, env, slf) {
    var token = tokens[idx], info = token.info ? $9e70512970c7d9dc$require$unescapeAll(token.info).trim() : "", langName = "", langAttrs = "", highlighted, i, arr, tmpAttrs, tmpToken;
    if (info) {
        arr = info.split(/(\s+)/g);
        langName = arr[0];
        langAttrs = arr.slice(2).join("");
    }
    if (options.highlight) highlighted = options.highlight(token.content, langName, langAttrs) || $9e70512970c7d9dc$require$escapeHtml(token.content);
    else highlighted = $9e70512970c7d9dc$require$escapeHtml(token.content);
    if (highlighted.indexOf("<pre") === 0) return highlighted + "\n";
    // If language exists, inject class gently, without modifying original token.
    // May be, one day we will add .deepClone() for token and simplify this part, but
    // now we prefer to keep things local.
    if (info) {
        i = token.attrIndex("class");
        tmpAttrs = token.attrs ? token.attrs.slice() : [];
        if (i < 0) tmpAttrs.push([
            "class",
            options.langPrefix + langName
        ]);
        else {
            tmpAttrs[i] = tmpAttrs[i].slice();
            tmpAttrs[i][1] += " " + options.langPrefix + langName;
        }
        // Fake token just to render attributes
        tmpToken = {
            attrs: tmpAttrs
        };
        return "<pre><code" + slf.renderAttrs(tmpToken) + ">" + highlighted + "</code></pre>\n";
    }
    return "<pre><code" + slf.renderAttrs(token) + ">" + highlighted + "</code></pre>\n";
};
$9e70512970c7d9dc$var$default_rules.image = function(tokens, idx, options, env, slf) {
    var token = tokens[idx];
    // "alt" attr MUST be set, even if empty. Because it's mandatory and
    // should be placed on proper position for tests.
    //
    // Replace content with actual value
    token.attrs[token.attrIndex("alt")][1] = slf.renderInlineAsText(token.children, options, env);
    return slf.renderToken(tokens, idx, options);
};
$9e70512970c7d9dc$var$default_rules.hardbreak = function(tokens, idx, options /*, env */ ) {
    return options.xhtmlOut ? "<br />\n" : "<br>\n";
};
$9e70512970c7d9dc$var$default_rules.softbreak = function(tokens, idx, options /*, env */ ) {
    return options.breaks ? options.xhtmlOut ? "<br />\n" : "<br>\n" : "\n";
};
$9e70512970c7d9dc$var$default_rules.text = function(tokens, idx /*, options, env */ ) {
    return $9e70512970c7d9dc$require$escapeHtml(tokens[idx].content);
};
$9e70512970c7d9dc$var$default_rules.html_block = function(tokens, idx /*, options, env */ ) {
    return tokens[idx].content;
};
$9e70512970c7d9dc$var$default_rules.html_inline = function(tokens, idx /*, options, env */ ) {
    return tokens[idx].content;
};
/**
 * new Renderer()
 *
 * Creates new [[Renderer]] instance and fill [[Renderer#rules]] with defaults.
 **/ function $9e70512970c7d9dc$var$Renderer() {
    /**
   * Renderer#rules -> Object
   *
   * Contains render rules for tokens. Can be updated and extended.
   *
   * ##### Example
   *
   * ```javascript
   * var md = require('markdown-it')();
   *
   * md.renderer.rules.strong_open  = function () { return '<b>'; };
   * md.renderer.rules.strong_close = function () { return '</b>'; };
   *
   * var result = md.renderInline(...);
   * ```
   *
   * Each rule is called as independent static function with fixed signature:
   *
   * ```javascript
   * function my_token_render(tokens, idx, options, env, renderer) {
   *   // ...
   *   return renderedHTML;
   * }
   * ```
   *
   * See [source code](https://github.com/markdown-it/markdown-it/blob/master/lib/renderer.js)
   * for more details and examples.
   **/ this.rules = $9e70512970c7d9dc$require$assign({}, $9e70512970c7d9dc$var$default_rules);
}
/**
 * Renderer.renderAttrs(token) -> String
 *
 * Render token attributes to string.
 **/ $9e70512970c7d9dc$var$Renderer.prototype.renderAttrs = function renderAttrs(token) {
    var i, l, result;
    if (!token.attrs) return "";
    result = "";
    for(i = 0, l = token.attrs.length; i < l; i++)result += " " + $9e70512970c7d9dc$require$escapeHtml(token.attrs[i][0]) + '="' + $9e70512970c7d9dc$require$escapeHtml(token.attrs[i][1]) + '"';
    return result;
};
/**
 * Renderer.renderToken(tokens, idx, options) -> String
 * - tokens (Array): list of tokens
 * - idx (Numbed): token index to render
 * - options (Object): params of parser instance
 *
 * Default token renderer. Can be overriden by custom function
 * in [[Renderer#rules]].
 **/ $9e70512970c7d9dc$var$Renderer.prototype.renderToken = function renderToken(tokens, idx, options) {
    var nextToken, result = "", needLf = false, token = tokens[idx];
    // Tight list paragraphs
    if (token.hidden) return "";
    // Insert a newline between hidden paragraph and subsequent opening
    // block-level tag.
    //
    // For example, here we should insert a newline before blockquote:
    //  - a
    //    >
    //
    if (token.block && token.nesting !== -1 && idx && tokens[idx - 1].hidden) result += "\n";
    // Add token name, e.g. `<img`
    result += (token.nesting === -1 ? "</" : "<") + token.tag;
    // Encode attributes, e.g. `<img src="foo"`
    result += this.renderAttrs(token);
    // Add a slash for self-closing tags, e.g. `<img src="foo" /`
    if (token.nesting === 0 && options.xhtmlOut) result += " /";
    // Check if we need to add a newline after this tag
    if (token.block) {
        needLf = true;
        if (token.nesting === 1) {
            if (idx + 1 < tokens.length) {
                nextToken = tokens[idx + 1];
                if (nextToken.type === "inline" || nextToken.hidden) // Block-level tag containing an inline tag.
                //
                needLf = false;
                else if (nextToken.nesting === -1 && nextToken.tag === token.tag) // Opening tag + closing tag of the same type. E.g. `<li></li>`.
                //
                needLf = false;
            }
        }
    }
    result += needLf ? ">\n" : ">";
    return result;
};
/**
 * Renderer.renderInline(tokens, options, env) -> String
 * - tokens (Array): list on block tokens to render
 * - options (Object): params of parser instance
 * - env (Object): additional data from parsed input (references, for example)
 *
 * The same as [[Renderer.render]], but for single token of `inline` type.
 **/ $9e70512970c7d9dc$var$Renderer.prototype.renderInline = function(tokens, options, env) {
    var type, result = "", rules = this.rules;
    for(var i = 0, len = tokens.length; i < len; i++){
        type = tokens[i].type;
        if (typeof rules[type] !== "undefined") result += rules[type](tokens, i, options, env, this);
        else result += this.renderToken(tokens, i, options);
    }
    return result;
};
/** internal
 * Renderer.renderInlineAsText(tokens, options, env) -> String
 * - tokens (Array): list on block tokens to render
 * - options (Object): params of parser instance
 * - env (Object): additional data from parsed input (references, for example)
 *
 * Special kludge for image `alt` attributes to conform CommonMark spec.
 * Don't try to use it! Spec requires to show `alt` content with stripped markup,
 * instead of simple escaping.
 **/ $9e70512970c7d9dc$var$Renderer.prototype.renderInlineAsText = function(tokens, options, env) {
    var result = "";
    for(var i = 0, len = tokens.length; i < len; i++){
        if (tokens[i].type === "text") result += tokens[i].content;
        else if (tokens[i].type === "image") result += this.renderInlineAsText(tokens[i].children, options, env);
        else if (tokens[i].type === "softbreak") result += "\n";
    }
    return result;
};
/**
 * Renderer.render(tokens, options, env) -> String
 * - tokens (Array): list on block tokens to render
 * - options (Object): params of parser instance
 * - env (Object): additional data from parsed input (references, for example)
 *
 * Takes token stream and generates HTML. Probably, you will never need to call
 * this method directly.
 **/ $9e70512970c7d9dc$var$Renderer.prototype.render = function(tokens, options, env) {
    var i, len, type, result = "", rules = this.rules;
    for(i = 0, len = tokens.length; i < len; i++){
        type = tokens[i].type;
        if (type === "inline") result += this.renderInline(tokens[i].children, options, env);
        else if (typeof rules[type] !== "undefined") result += rules[tokens[i].type](tokens, i, options, env, this);
        else result += this.renderToken(tokens, i, options, env);
    }
    return result;
};
module.exports = $9e70512970c7d9dc$var$Renderer;

});

parcelRequire.register("2llij", function(module, exports) {
/** internal
 * class Core
 *
 * Top-level rules executor. Glues block/inline parsers and does intermediate
 * transformations.
 **/ "use strict";

var $7QkZh = parcelRequire("7QkZh");







var $1b4e0f9176753427$var$_rules = [
    [
        "normalize",
        (parcelRequire("7xPBN"))
    ],
    [
        "block",
        (parcelRequire("2tbyv"))
    ],
    [
        "inline",
        (parcelRequire("56SbH"))
    ],
    [
        "linkify",
        (parcelRequire("1PxLg"))
    ],
    [
        "replacements",
        (parcelRequire("kJLbc"))
    ],
    [
        "smartquotes",
        (parcelRequire("f0oXX"))
    ],
    // `text_join` finds `text_special` tokens (for escape sequences)
    // and joins them with the rest of the text
    [
        "text_join",
        (parcelRequire("dwsAj"))
    ]
];
/**
 * new Core()
 **/ function $1b4e0f9176753427$var$Core() {
    /**
   * Core#ruler -> Ruler
   *
   * [[Ruler]] instance. Keep configuration of core rules.
   **/ this.ruler = new $7QkZh();
    for(var i = 0; i < $1b4e0f9176753427$var$_rules.length; i++)this.ruler.push($1b4e0f9176753427$var$_rules[i][0], $1b4e0f9176753427$var$_rules[i][1]);
}
/**
 * Core.process(state)
 *
 * Executes core chain rules.
 **/ $1b4e0f9176753427$var$Core.prototype.process = function(state) {
    var i, l, rules;
    rules = this.ruler.getRules("");
    for(i = 0, l = rules.length; i < l; i++)rules[i](state);
};

$1b4e0f9176753427$var$Core.prototype.State = (parcelRequire("6LPy9"));
module.exports = $1b4e0f9176753427$var$Core;

});
parcelRequire.register("7QkZh", function(module, exports) {
/**
 * class Ruler
 *
 * Helper class, used by [[MarkdownIt#core]], [[MarkdownIt#block]] and
 * [[MarkdownIt#inline]] to manage sequences of functions (rules):
 *
 * - keep rules in defined order
 * - assign the name to each rule
 * - enable/disable rules
 * - add/replace rules
 * - allow assign rules to additional named chains (in the same)
 * - cacheing lists of active rules
 *
 * You will not need use this class directly until write plugins. For simple
 * rules control use [[MarkdownIt.disable]], [[MarkdownIt.enable]] and
 * [[MarkdownIt.use]].
 **/ "use strict";
/**
 * new Ruler()
 **/ function $5b5dab622d76eb0d$var$Ruler() {
    // List of added rules. Each element is:
    //
    // {
    //   name: XXX,
    //   enabled: Boolean,
    //   fn: Function(),
    //   alt: [ name2, name3 ]
    // }
    //
    this.__rules__ = [];
    // Cached rule chains.
    //
    // First level - chain name, '' for default.
    // Second level - diginal anchor for fast filtering by charcodes.
    //
    this.__cache__ = null;
}
////////////////////////////////////////////////////////////////////////////////
// Helper methods, should not be used directly
// Find rule index by name
//
$5b5dab622d76eb0d$var$Ruler.prototype.__find__ = function(name) {
    for(var i = 0; i < this.__rules__.length; i++){
        if (this.__rules__[i].name === name) return i;
    }
    return -1;
};
// Build rules lookup cache
//
$5b5dab622d76eb0d$var$Ruler.prototype.__compile__ = function() {
    var self = this;
    var chains = [
        ""
    ];
    // collect unique names
    self.__rules__.forEach(function(rule) {
        if (!rule.enabled) return;
        rule.alt.forEach(function(altName) {
            if (chains.indexOf(altName) < 0) chains.push(altName);
        });
    });
    self.__cache__ = {};
    chains.forEach(function(chain) {
        self.__cache__[chain] = [];
        self.__rules__.forEach(function(rule) {
            if (!rule.enabled) return;
            if (chain && rule.alt.indexOf(chain) < 0) return;
            self.__cache__[chain].push(rule.fn);
        });
    });
};
/**
 * Ruler.at(name, fn [, options])
 * - name (String): rule name to replace.
 * - fn (Function): new rule function.
 * - options (Object): new rule options (not mandatory).
 *
 * Replace rule by name with new function & options. Throws error if name not
 * found.
 *
 * ##### Options:
 *
 * - __alt__ - array with names of "alternate" chains.
 *
 * ##### Example
 *
 * Replace existing typographer replacement rule with new one:
 *
 * ```javascript
 * var md = require('markdown-it')();
 *
 * md.core.ruler.at('replacements', function replace(state) {
 *   //...
 * });
 * ```
 **/ $5b5dab622d76eb0d$var$Ruler.prototype.at = function(name, fn, options) {
    var index = this.__find__(name);
    var opt = options || {};
    if (index === -1) throw new Error("Parser rule not found: " + name);
    this.__rules__[index].fn = fn;
    this.__rules__[index].alt = opt.alt || [];
    this.__cache__ = null;
};
/**
 * Ruler.before(beforeName, ruleName, fn [, options])
 * - beforeName (String): new rule will be added before this one.
 * - ruleName (String): name of added rule.
 * - fn (Function): rule function.
 * - options (Object): rule options (not mandatory).
 *
 * Add new rule to chain before one with given name. See also
 * [[Ruler.after]], [[Ruler.push]].
 *
 * ##### Options:
 *
 * - __alt__ - array with names of "alternate" chains.
 *
 * ##### Example
 *
 * ```javascript
 * var md = require('markdown-it')();
 *
 * md.block.ruler.before('paragraph', 'my_rule', function replace(state) {
 *   //...
 * });
 * ```
 **/ $5b5dab622d76eb0d$var$Ruler.prototype.before = function(beforeName, ruleName, fn, options) {
    var index = this.__find__(beforeName);
    var opt = options || {};
    if (index === -1) throw new Error("Parser rule not found: " + beforeName);
    this.__rules__.splice(index, 0, {
        name: ruleName,
        enabled: true,
        fn: fn,
        alt: opt.alt || []
    });
    this.__cache__ = null;
};
/**
 * Ruler.after(afterName, ruleName, fn [, options])
 * - afterName (String): new rule will be added after this one.
 * - ruleName (String): name of added rule.
 * - fn (Function): rule function.
 * - options (Object): rule options (not mandatory).
 *
 * Add new rule to chain after one with given name. See also
 * [[Ruler.before]], [[Ruler.push]].
 *
 * ##### Options:
 *
 * - __alt__ - array with names of "alternate" chains.
 *
 * ##### Example
 *
 * ```javascript
 * var md = require('markdown-it')();
 *
 * md.inline.ruler.after('text', 'my_rule', function replace(state) {
 *   //...
 * });
 * ```
 **/ $5b5dab622d76eb0d$var$Ruler.prototype.after = function(afterName, ruleName, fn, options) {
    var index = this.__find__(afterName);
    var opt = options || {};
    if (index === -1) throw new Error("Parser rule not found: " + afterName);
    this.__rules__.splice(index + 1, 0, {
        name: ruleName,
        enabled: true,
        fn: fn,
        alt: opt.alt || []
    });
    this.__cache__ = null;
};
/**
 * Ruler.push(ruleName, fn [, options])
 * - ruleName (String): name of added rule.
 * - fn (Function): rule function.
 * - options (Object): rule options (not mandatory).
 *
 * Push new rule to the end of chain. See also
 * [[Ruler.before]], [[Ruler.after]].
 *
 * ##### Options:
 *
 * - __alt__ - array with names of "alternate" chains.
 *
 * ##### Example
 *
 * ```javascript
 * var md = require('markdown-it')();
 *
 * md.core.ruler.push('my_rule', function replace(state) {
 *   //...
 * });
 * ```
 **/ $5b5dab622d76eb0d$var$Ruler.prototype.push = function(ruleName, fn, options) {
    var opt = options || {};
    this.__rules__.push({
        name: ruleName,
        enabled: true,
        fn: fn,
        alt: opt.alt || []
    });
    this.__cache__ = null;
};
/**
 * Ruler.enable(list [, ignoreInvalid]) -> Array
 * - list (String|Array): list of rule names to enable.
 * - ignoreInvalid (Boolean): set `true` to ignore errors when rule not found.
 *
 * Enable rules with given names. If any rule name not found - throw Error.
 * Errors can be disabled by second param.
 *
 * Returns list of found rule names (if no exception happened).
 *
 * See also [[Ruler.disable]], [[Ruler.enableOnly]].
 **/ $5b5dab622d76eb0d$var$Ruler.prototype.enable = function(list, ignoreInvalid) {
    if (!Array.isArray(list)) list = [
        list
    ];
    var result = [];
    // Search by name and enable
    list.forEach(function(name) {
        var idx = this.__find__(name);
        if (idx < 0) {
            if (ignoreInvalid) return;
            throw new Error("Rules manager: invalid rule name " + name);
        }
        this.__rules__[idx].enabled = true;
        result.push(name);
    }, this);
    this.__cache__ = null;
    return result;
};
/**
 * Ruler.enableOnly(list [, ignoreInvalid])
 * - list (String|Array): list of rule names to enable (whitelist).
 * - ignoreInvalid (Boolean): set `true` to ignore errors when rule not found.
 *
 * Enable rules with given names, and disable everything else. If any rule name
 * not found - throw Error. Errors can be disabled by second param.
 *
 * See also [[Ruler.disable]], [[Ruler.enable]].
 **/ $5b5dab622d76eb0d$var$Ruler.prototype.enableOnly = function(list, ignoreInvalid) {
    if (!Array.isArray(list)) list = [
        list
    ];
    this.__rules__.forEach(function(rule) {
        rule.enabled = false;
    });
    this.enable(list, ignoreInvalid);
};
/**
 * Ruler.disable(list [, ignoreInvalid]) -> Array
 * - list (String|Array): list of rule names to disable.
 * - ignoreInvalid (Boolean): set `true` to ignore errors when rule not found.
 *
 * Disable rules with given names. If any rule name not found - throw Error.
 * Errors can be disabled by second param.
 *
 * Returns list of found rule names (if no exception happened).
 *
 * See also [[Ruler.enable]], [[Ruler.enableOnly]].
 **/ $5b5dab622d76eb0d$var$Ruler.prototype.disable = function(list, ignoreInvalid) {
    if (!Array.isArray(list)) list = [
        list
    ];
    var result = [];
    // Search by name and disable
    list.forEach(function(name) {
        var idx = this.__find__(name);
        if (idx < 0) {
            if (ignoreInvalid) return;
            throw new Error("Rules manager: invalid rule name " + name);
        }
        this.__rules__[idx].enabled = false;
        result.push(name);
    }, this);
    this.__cache__ = null;
    return result;
};
/**
 * Ruler.getRules(chainName) -> Array
 *
 * Return array of active functions (rules) for given chain name. It analyzes
 * rules configuration, compiles caches if not exists and returns result.
 *
 * Default chain name is `''` (empty string). It can't be skipped. That's
 * done intentionally, to keep signature monomorphic for high speed.
 **/ $5b5dab622d76eb0d$var$Ruler.prototype.getRules = function(chainName) {
    if (this.__cache__ === null) this.__compile__();
    // Chain can be empty, if rules disabled. But we still have to return Array.
    return this.__cache__[chainName] || [];
};
module.exports = $5b5dab622d76eb0d$var$Ruler;

});

parcelRequire.register("7xPBN", function(module, exports) {
// Normalize input string
"use strict";
// https://spec.commonmark.org/0.29/#line-ending
var $57e3a5d957d77993$var$NEWLINES_RE = /\r\n?|\n/g;
var $57e3a5d957d77993$var$NULL_RE = /\0/g;
module.exports = function normalize(state) {
    var str;
    // Normalize newlines
    str = state.src.replace($57e3a5d957d77993$var$NEWLINES_RE, "\n");
    // Replace NULL characters
    str = str.replace($57e3a5d957d77993$var$NULL_RE, "�");
    state.src = str;
};

});

parcelRequire.register("2tbyv", function(module, exports) {
"use strict";
module.exports = function block(state) {
    var token;
    if (state.inlineMode) {
        token = new state.Token("inline", "", 0);
        token.content = state.src;
        token.map = [
            0,
            1
        ];
        token.children = [];
        state.tokens.push(token);
    } else state.md.block.parse(state.src, state.md, state.env, state.tokens);
};

});

parcelRequire.register("56SbH", function(module, exports) {
"use strict";
module.exports = function inline(state) {
    var tokens = state.tokens, tok, i, l;
    // Parse inlines
    for(i = 0, l = tokens.length; i < l; i++){
        tok = tokens[i];
        if (tok.type === "inline") state.md.inline.parse(tok.content, state.md, state.env, tok.children);
    }
};

});

parcelRequire.register("1PxLg", function(module, exports) {
// Replace link-like texts with link nodes.
//
// Currently restricted by `md.validateLink()` to http/https/ftp
//
"use strict";

var $iXVVQ = parcelRequire("iXVVQ");
var $1554be2b94d1f24e$require$arrayReplaceAt = $iXVVQ.arrayReplaceAt;
function $1554be2b94d1f24e$var$isLinkOpen(str) {
    return /^<a[>\s]/i.test(str);
}
function $1554be2b94d1f24e$var$isLinkClose(str) {
    return /^<\/a\s*>/i.test(str);
}
module.exports = function linkify(state) {
    var i, j, l, tokens, token, currentToken, nodes, ln, text, pos, lastPos, level, htmlLinkLevel, url, fullUrl, urlText, blockTokens = state.tokens, links;
    if (!state.md.options.linkify) return;
    for(j = 0, l = blockTokens.length; j < l; j++){
        if (blockTokens[j].type !== "inline" || !state.md.linkify.pretest(blockTokens[j].content)) continue;
        tokens = blockTokens[j].children;
        htmlLinkLevel = 0;
        // We scan from the end, to keep position when new tags added.
        // Use reversed logic in links start/end match
        for(i = tokens.length - 1; i >= 0; i--){
            currentToken = tokens[i];
            // Skip content of markdown links
            if (currentToken.type === "link_close") {
                i--;
                while(tokens[i].level !== currentToken.level && tokens[i].type !== "link_open")i--;
                continue;
            }
            // Skip content of html tag links
            if (currentToken.type === "html_inline") {
                if ($1554be2b94d1f24e$var$isLinkOpen(currentToken.content) && htmlLinkLevel > 0) htmlLinkLevel--;
                if ($1554be2b94d1f24e$var$isLinkClose(currentToken.content)) htmlLinkLevel++;
            }
            if (htmlLinkLevel > 0) continue;
            if (currentToken.type === "text" && state.md.linkify.test(currentToken.content)) {
                text = currentToken.content;
                links = state.md.linkify.match(text);
                // Now split string to nodes
                nodes = [];
                level = currentToken.level;
                lastPos = 0;
                // forbid escape sequence at the start of the string,
                // this avoids http\://example.com/ from being linkified as
                // http:<a href="//example.com/">//example.com/</a>
                if (links.length > 0 && links[0].index === 0 && i > 0 && tokens[i - 1].type === "text_special") links = links.slice(1);
                for(ln = 0; ln < links.length; ln++){
                    url = links[ln].url;
                    fullUrl = state.md.normalizeLink(url);
                    if (!state.md.validateLink(fullUrl)) continue;
                    urlText = links[ln].text;
                    // Linkifier might send raw hostnames like "example.com", where url
                    // starts with domain name. So we prepend http:// in those cases,
                    // and remove it afterwards.
                    //
                    if (!links[ln].schema) urlText = state.md.normalizeLinkText("http://" + urlText).replace(/^http:\/\//, "");
                    else if (links[ln].schema === "mailto:" && !/^mailto:/i.test(urlText)) urlText = state.md.normalizeLinkText("mailto:" + urlText).replace(/^mailto:/, "");
                    else urlText = state.md.normalizeLinkText(urlText);
                    pos = links[ln].index;
                    if (pos > lastPos) {
                        token = new state.Token("text", "", 0);
                        token.content = text.slice(lastPos, pos);
                        token.level = level;
                        nodes.push(token);
                    }
                    token = new state.Token("link_open", "a", 1);
                    token.attrs = [
                        [
                            "href",
                            fullUrl
                        ]
                    ];
                    token.level = level++;
                    token.markup = "linkify";
                    token.info = "auto";
                    nodes.push(token);
                    token = new state.Token("text", "", 0);
                    token.content = urlText;
                    token.level = level;
                    nodes.push(token);
                    token = new state.Token("link_close", "a", -1);
                    token.level = --level;
                    token.markup = "linkify";
                    token.info = "auto";
                    nodes.push(token);
                    lastPos = links[ln].lastIndex;
                }
                if (lastPos < text.length) {
                    token = new state.Token("text", "", 0);
                    token.content = text.slice(lastPos);
                    token.level = level;
                    nodes.push(token);
                }
                // replace current node
                blockTokens[j].children = tokens = $1554be2b94d1f24e$require$arrayReplaceAt(tokens, i, nodes);
            }
        }
    }
};

});

parcelRequire.register("kJLbc", function(module, exports) {
// Simple typographic replacements
//
// (c) (C) → ©
// (tm) (TM) → ™
// (r) (R) → ®
// +- → ±
// (p) (P) -> §
// ... → … (also ?.... → ?.., !.... → !..)
// ???????? → ???, !!!!! → !!!, `,,` → `,`
// -- → &ndash;, --- → &mdash;
//
"use strict";
// TODO:
// - fractionals 1/2, 1/4, 3/4 -> ½, ¼, ¾
// - multiplications 2 x 4 -> 2 × 4
var $f18c9b87e6bb1c26$var$RARE_RE = /\+-|\.\.|\?\?\?\?|!!!!|,,|--/;
// Workaround for phantomjs - need regex without /g flag,
// or root check will fail every second time
var $f18c9b87e6bb1c26$var$SCOPED_ABBR_TEST_RE = /\((c|tm|r)\)/i;
var $f18c9b87e6bb1c26$var$SCOPED_ABBR_RE = /\((c|tm|r)\)/ig;
var $f18c9b87e6bb1c26$var$SCOPED_ABBR = {
    c: "\xa9",
    r: "\xae",
    tm: "™"
};
function $f18c9b87e6bb1c26$var$replaceFn(match, name) {
    return $f18c9b87e6bb1c26$var$SCOPED_ABBR[name.toLowerCase()];
}
function $f18c9b87e6bb1c26$var$replace_scoped(inlineTokens) {
    var i, token, inside_autolink = 0;
    for(i = inlineTokens.length - 1; i >= 0; i--){
        token = inlineTokens[i];
        if (token.type === "text" && !inside_autolink) token.content = token.content.replace($f18c9b87e6bb1c26$var$SCOPED_ABBR_RE, $f18c9b87e6bb1c26$var$replaceFn);
        if (token.type === "link_open" && token.info === "auto") inside_autolink--;
        if (token.type === "link_close" && token.info === "auto") inside_autolink++;
    }
}
function $f18c9b87e6bb1c26$var$replace_rare(inlineTokens) {
    var i, token, inside_autolink = 0;
    for(i = inlineTokens.length - 1; i >= 0; i--){
        token = inlineTokens[i];
        if (token.type === "text" && !inside_autolink) {
            if ($f18c9b87e6bb1c26$var$RARE_RE.test(token.content)) token.content = token.content.replace(/\+-/g, "\xb1")// .., ..., ....... -> …
            // but ?..... & !..... -> ?.. & !..
            .replace(/\.{2,}/g, "…").replace(/([?!])…/g, "$1..").replace(/([?!]){4,}/g, "$1$1$1").replace(/,{2,}/g, ",")// em-dash
            .replace(/(^|[^-])---(?=[^-]|$)/mg, "$1—")// en-dash
            .replace(/(^|\s)--(?=\s|$)/mg, "$1–").replace(/(^|[^-\s])--(?=[^-\s]|$)/mg, "$1–");
        }
        if (token.type === "link_open" && token.info === "auto") inside_autolink--;
        if (token.type === "link_close" && token.info === "auto") inside_autolink++;
    }
}
module.exports = function replace(state) {
    var blkIdx;
    if (!state.md.options.typographer) return;
    for(blkIdx = state.tokens.length - 1; blkIdx >= 0; blkIdx--){
        if (state.tokens[blkIdx].type !== "inline") continue;
        if ($f18c9b87e6bb1c26$var$SCOPED_ABBR_TEST_RE.test(state.tokens[blkIdx].content)) $f18c9b87e6bb1c26$var$replace_scoped(state.tokens[blkIdx].children);
        if ($f18c9b87e6bb1c26$var$RARE_RE.test(state.tokens[blkIdx].content)) $f18c9b87e6bb1c26$var$replace_rare(state.tokens[blkIdx].children);
    }
};

});

parcelRequire.register("f0oXX", function(module, exports) {
// Convert straight quotation marks to typographic ones
//
"use strict";

var $iXVVQ = parcelRequire("iXVVQ");
var $aeca38d22e04d5ef$require$isWhiteSpace = $iXVVQ.isWhiteSpace;

var $iXVVQ = parcelRequire("iXVVQ");
var $aeca38d22e04d5ef$require$isPunctChar = $iXVVQ.isPunctChar;

var $iXVVQ = parcelRequire("iXVVQ");
var $aeca38d22e04d5ef$require$isMdAsciiPunct = $iXVVQ.isMdAsciiPunct;
var $aeca38d22e04d5ef$var$QUOTE_TEST_RE = /['"]/;
var $aeca38d22e04d5ef$var$QUOTE_RE = /['"]/g;
var $aeca38d22e04d5ef$var$APOSTROPHE = "’"; /* ’ */ 
function $aeca38d22e04d5ef$var$replaceAt(str, index, ch) {
    return str.slice(0, index) + ch + str.slice(index + 1);
}
function $aeca38d22e04d5ef$var$process_inlines(tokens, state) {
    var i, token, text, t, pos, max, thisLevel, item, lastChar, nextChar, isLastPunctChar, isNextPunctChar, isLastWhiteSpace, isNextWhiteSpace, canOpen, canClose, j, isSingle, stack, openQuote, closeQuote;
    stack = [];
    for(i = 0; i < tokens.length; i++){
        token = tokens[i];
        thisLevel = tokens[i].level;
        for(j = stack.length - 1; j >= 0; j--){
            if (stack[j].level <= thisLevel) break;
        }
        stack.length = j + 1;
        if (token.type !== "text") continue;
        text = token.content;
        pos = 0;
        max = text.length;
        /*eslint no-labels:0,block-scoped-var:0*/ OUTER: while(pos < max){
            $aeca38d22e04d5ef$var$QUOTE_RE.lastIndex = pos;
            t = $aeca38d22e04d5ef$var$QUOTE_RE.exec(text);
            if (!t) break;
            canOpen = canClose = true;
            pos = t.index + 1;
            isSingle = t[0] === "'";
            // Find previous character,
            // default to space if it's the beginning of the line
            //
            lastChar = 0x20;
            if (t.index - 1 >= 0) lastChar = text.charCodeAt(t.index - 1);
            else for(j = i - 1; j >= 0; j--){
                if (tokens[j].type === "softbreak" || tokens[j].type === "hardbreak") break; // lastChar defaults to 0x20
                if (!tokens[j].content) continue; // should skip all tokens except 'text', 'html_inline' or 'code_inline'
                lastChar = tokens[j].content.charCodeAt(tokens[j].content.length - 1);
                break;
            }
            // Find next character,
            // default to space if it's the end of the line
            //
            nextChar = 0x20;
            if (pos < max) nextChar = text.charCodeAt(pos);
            else for(j = i + 1; j < tokens.length; j++){
                if (tokens[j].type === "softbreak" || tokens[j].type === "hardbreak") break; // nextChar defaults to 0x20
                if (!tokens[j].content) continue; // should skip all tokens except 'text', 'html_inline' or 'code_inline'
                nextChar = tokens[j].content.charCodeAt(0);
                break;
            }
            isLastPunctChar = $aeca38d22e04d5ef$require$isMdAsciiPunct(lastChar) || $aeca38d22e04d5ef$require$isPunctChar(String.fromCharCode(lastChar));
            isNextPunctChar = $aeca38d22e04d5ef$require$isMdAsciiPunct(nextChar) || $aeca38d22e04d5ef$require$isPunctChar(String.fromCharCode(nextChar));
            isLastWhiteSpace = $aeca38d22e04d5ef$require$isWhiteSpace(lastChar);
            isNextWhiteSpace = $aeca38d22e04d5ef$require$isWhiteSpace(nextChar);
            if (isNextWhiteSpace) canOpen = false;
            else if (isNextPunctChar) {
                if (!(isLastWhiteSpace || isLastPunctChar)) canOpen = false;
            }
            if (isLastWhiteSpace) canClose = false;
            else if (isLastPunctChar) {
                if (!(isNextWhiteSpace || isNextPunctChar)) canClose = false;
            }
            if (nextChar === 0x22 /* " */  && t[0] === '"') {
                if (lastChar >= 0x30 /* 0 */  && lastChar <= 0x39 /* 9 */ ) // special case: 1"" - count first quote as an inch
                canClose = canOpen = false;
            }
            if (canOpen && canClose) {
                // Replace quotes in the middle of punctuation sequence, but not
                // in the middle of the words, i.e.:
                //
                // 1. foo " bar " baz - not replaced
                // 2. foo-"-bar-"-baz - replaced
                // 3. foo"bar"baz     - not replaced
                //
                canOpen = isLastPunctChar;
                canClose = isNextPunctChar;
            }
            if (!canOpen && !canClose) {
                // middle of word
                if (isSingle) token.content = $aeca38d22e04d5ef$var$replaceAt(token.content, t.index, $aeca38d22e04d5ef$var$APOSTROPHE);
                continue;
            }
            if (canClose) // this could be a closing quote, rewind the stack to get a match
            for(j = stack.length - 1; j >= 0; j--){
                item = stack[j];
                if (stack[j].level < thisLevel) break;
                if (item.single === isSingle && stack[j].level === thisLevel) {
                    item = stack[j];
                    if (isSingle) {
                        openQuote = state.md.options.quotes[2];
                        closeQuote = state.md.options.quotes[3];
                    } else {
                        openQuote = state.md.options.quotes[0];
                        closeQuote = state.md.options.quotes[1];
                    }
                    // replace token.content *before* tokens[item.token].content,
                    // because, if they are pointing at the same token, replaceAt
                    // could mess up indices when quote length != 1
                    token.content = $aeca38d22e04d5ef$var$replaceAt(token.content, t.index, closeQuote);
                    tokens[item.token].content = $aeca38d22e04d5ef$var$replaceAt(tokens[item.token].content, item.pos, openQuote);
                    pos += closeQuote.length - 1;
                    if (item.token === i) pos += openQuote.length - 1;
                    text = token.content;
                    max = text.length;
                    stack.length = j;
                    continue OUTER;
                }
            }
            if (canOpen) stack.push({
                token: i,
                pos: t.index,
                single: isSingle,
                level: thisLevel
            });
            else if (canClose && isSingle) token.content = $aeca38d22e04d5ef$var$replaceAt(token.content, t.index, $aeca38d22e04d5ef$var$APOSTROPHE);
        }
    }
}
module.exports = function smartquotes(state) {
    /*eslint max-depth:0*/ var blkIdx;
    if (!state.md.options.typographer) return;
    for(blkIdx = state.tokens.length - 1; blkIdx >= 0; blkIdx--){
        if (state.tokens[blkIdx].type !== "inline" || !$aeca38d22e04d5ef$var$QUOTE_TEST_RE.test(state.tokens[blkIdx].content)) continue;
        $aeca38d22e04d5ef$var$process_inlines(state.tokens[blkIdx].children, state);
    }
};

});

parcelRequire.register("dwsAj", function(module, exports) {
// Join raw text tokens with the rest of the text
//
// This is set as a separate rule to provide an opportunity for plugins
// to run text replacements after text join, but before escape join.
//
// For example, `\:)` shouldn't be replaced with an emoji.
//
"use strict";
module.exports = function text_join(state) {
    var j, l, tokens, curr, max, last, blockTokens = state.tokens;
    for(j = 0, l = blockTokens.length; j < l; j++){
        if (blockTokens[j].type !== "inline") continue;
        tokens = blockTokens[j].children;
        max = tokens.length;
        for(curr = 0; curr < max; curr++)if (tokens[curr].type === "text_special") tokens[curr].type = "text";
        for(curr = last = 0; curr < max; curr++)if (tokens[curr].type === "text" && curr + 1 < max && tokens[curr + 1].type === "text") // collapse two adjacent text nodes
        tokens[curr + 1].content = tokens[curr].content + tokens[curr + 1].content;
        else {
            if (curr !== last) tokens[last] = tokens[curr];
            last++;
        }
        if (curr !== last) tokens.length = last;
    }
};

});

parcelRequire.register("6LPy9", function(module, exports) {
// Core state object
//
"use strict";

var $lGPSc = parcelRequire("lGPSc");
function $4edf1e9b04261fb1$var$StateCore(src, md, env) {
    this.src = src;
    this.env = env;
    this.tokens = [];
    this.inlineMode = false;
    this.md = md; // link to parser instance
}
// re-export Token class to use in core rules
$4edf1e9b04261fb1$var$StateCore.prototype.Token = $lGPSc;
module.exports = $4edf1e9b04261fb1$var$StateCore;

});
parcelRequire.register("lGPSc", function(module, exports) {
// Token class
"use strict";
/**
 * class Token
 **/ /**
 * new Token(type, tag, nesting)
 *
 * Create new token and fill passed properties.
 **/ function $fca5c227d40fe416$var$Token(type, tag, nesting) {
    /**
   * Token#type -> String
   *
   * Type of the token (string, e.g. "paragraph_open")
   **/ this.type = type;
    /**
   * Token#tag -> String
   *
   * html tag name, e.g. "p"
   **/ this.tag = tag;
    /**
   * Token#attrs -> Array
   *
   * Html attributes. Format: `[ [ name1, value1 ], [ name2, value2 ] ]`
   **/ this.attrs = null;
    /**
   * Token#map -> Array
   *
   * Source map info. Format: `[ line_begin, line_end ]`
   **/ this.map = null;
    /**
   * Token#nesting -> Number
   *
   * Level change (number in {-1, 0, 1} set), where:
   *
   * -  `1` means the tag is opening
   * -  `0` means the tag is self-closing
   * - `-1` means the tag is closing
   **/ this.nesting = nesting;
    /**
   * Token#level -> Number
   *
   * nesting level, the same as `state.level`
   **/ this.level = 0;
    /**
   * Token#children -> Array
   *
   * An array of child nodes (inline and img tokens)
   **/ this.children = null;
    /**
   * Token#content -> String
   *
   * In a case of self-closing tag (code, html, fence, etc.),
   * it has contents of this tag.
   **/ this.content = "";
    /**
   * Token#markup -> String
   *
   * '*' or '_' for emphasis, fence string for fence, etc.
   **/ this.markup = "";
    /**
   * Token#info -> String
   *
   * Additional information:
   *
   * - Info string for "fence" tokens
   * - The value "auto" for autolink "link_open" and "link_close" tokens
   * - The string value of the item marker for ordered-list "list_item_open" tokens
   **/ this.info = "";
    /**
   * Token#meta -> Object
   *
   * A place for plugins to store an arbitrary data
   **/ this.meta = null;
    /**
   * Token#block -> Boolean
   *
   * True for block-level tokens, false for inline tokens.
   * Used in renderer to calculate line breaks
   **/ this.block = false;
    /**
   * Token#hidden -> Boolean
   *
   * If it's true, ignore this element when rendering. Used for tight lists
   * to hide paragraphs.
   **/ this.hidden = false;
}
/**
 * Token.attrIndex(name) -> Number
 *
 * Search attribute index by name.
 **/ $fca5c227d40fe416$var$Token.prototype.attrIndex = function attrIndex(name) {
    var attrs, i, len;
    if (!this.attrs) return -1;
    attrs = this.attrs;
    for(i = 0, len = attrs.length; i < len; i++){
        if (attrs[i][0] === name) return i;
    }
    return -1;
};
/**
 * Token.attrPush(attrData)
 *
 * Add `[ name, value ]` attribute to list. Init attrs if necessary
 **/ $fca5c227d40fe416$var$Token.prototype.attrPush = function attrPush(attrData) {
    if (this.attrs) this.attrs.push(attrData);
    else this.attrs = [
        attrData
    ];
};
/**
 * Token.attrSet(name, value)
 *
 * Set `name` attribute to `value`. Override old value if exists.
 **/ $fca5c227d40fe416$var$Token.prototype.attrSet = function attrSet(name, value) {
    var idx = this.attrIndex(name), attrData = [
        name,
        value
    ];
    if (idx < 0) this.attrPush(attrData);
    else this.attrs[idx] = attrData;
};
/**
 * Token.attrGet(name)
 *
 * Get the value of attribute `name`, or null if it does not exist.
 **/ $fca5c227d40fe416$var$Token.prototype.attrGet = function attrGet(name) {
    var idx = this.attrIndex(name), value = null;
    if (idx >= 0) value = this.attrs[idx][1];
    return value;
};
/**
 * Token.attrJoin(name, value)
 *
 * Join value to existing attribute via space. Or create new attribute if not
 * exists. Useful to operate with token classes.
 **/ $fca5c227d40fe416$var$Token.prototype.attrJoin = function attrJoin(name, value) {
    var idx = this.attrIndex(name);
    if (idx < 0) this.attrPush([
        name,
        value
    ]);
    else this.attrs[idx][1] = this.attrs[idx][1] + " " + value;
};
module.exports = $fca5c227d40fe416$var$Token;

});



parcelRequire.register("4s2Z6", function(module, exports) {
/** internal
 * class ParserBlock
 *
 * Block-level tokenizer.
 **/ "use strict";

var $7QkZh = parcelRequire("7QkZh");











var $33dc179b20c9d6df$var$_rules = [
    // First 2 params - rule name & source. Secondary array - list of rules,
    // which can be terminated by this one.
    [
        "table",
        (parcelRequire("aiY9V")),
        [
            "paragraph",
            "reference"
        ]
    ],
    [
        "code",
        (parcelRequire("5tS63"))
    ],
    [
        "fence",
        (parcelRequire("3g623")),
        [
            "paragraph",
            "reference",
            "blockquote",
            "list"
        ]
    ],
    [
        "blockquote",
        (parcelRequire("frvdb")),
        [
            "paragraph",
            "reference",
            "blockquote",
            "list"
        ]
    ],
    [
        "hr",
        (parcelRequire("1SKTg")),
        [
            "paragraph",
            "reference",
            "blockquote",
            "list"
        ]
    ],
    [
        "list",
        (parcelRequire("fP2pa")),
        [
            "paragraph",
            "reference",
            "blockquote"
        ]
    ],
    [
        "reference",
        (parcelRequire("b08Li"))
    ],
    [
        "html_block",
        (parcelRequire("aaI3i")),
        [
            "paragraph",
            "reference",
            "blockquote"
        ]
    ],
    [
        "heading",
        (parcelRequire("2xOl8")),
        [
            "paragraph",
            "reference",
            "blockquote"
        ]
    ],
    [
        "lheading",
        (parcelRequire("6LRgJ"))
    ],
    [
        "paragraph",
        (parcelRequire("2aG2t"))
    ]
];
/**
 * new ParserBlock()
 **/ function $33dc179b20c9d6df$var$ParserBlock() {
    /**
   * ParserBlock#ruler -> Ruler
   *
   * [[Ruler]] instance. Keep configuration of block rules.
   **/ this.ruler = new $7QkZh();
    for(var i = 0; i < $33dc179b20c9d6df$var$_rules.length; i++)this.ruler.push($33dc179b20c9d6df$var$_rules[i][0], $33dc179b20c9d6df$var$_rules[i][1], {
        alt: ($33dc179b20c9d6df$var$_rules[i][2] || []).slice()
    });
}
// Generate tokens for input range
//
$33dc179b20c9d6df$var$ParserBlock.prototype.tokenize = function(state, startLine, endLine) {
    var ok, i, rules = this.ruler.getRules(""), len = rules.length, line = startLine, hasEmptyLines = false, maxNesting = state.md.options.maxNesting;
    while(line < endLine){
        state.line = line = state.skipEmptyLines(line);
        if (line >= endLine) break;
        // Termination condition for nested calls.
        // Nested calls currently used for blockquotes & lists
        if (state.sCount[line] < state.blkIndent) break;
        // If nesting level exceeded - skip tail to the end. That's not ordinary
        // situation and we should not care about content.
        if (state.level >= maxNesting) {
            state.line = endLine;
            break;
        }
        // Try all possible rules.
        // On success, rule should:
        //
        // - update `state.line`
        // - update `state.tokens`
        // - return true
        for(i = 0; i < len; i++){
            ok = rules[i](state, line, endLine, false);
            if (ok) break;
        }
        // set state.tight if we had an empty line before current tag
        // i.e. latest empty line should not count
        state.tight = !hasEmptyLines;
        // paragraph might "eat" one newline after it in nested lists
        if (state.isEmpty(state.line - 1)) hasEmptyLines = true;
        line = state.line;
        if (line < endLine && state.isEmpty(line)) {
            hasEmptyLines = true;
            line++;
            state.line = line;
        }
    }
};
/**
 * ParserBlock.parse(str, md, env, outTokens)
 *
 * Process input string and push block tokens into `outTokens`
 **/ $33dc179b20c9d6df$var$ParserBlock.prototype.parse = function(src, md, env, outTokens) {
    var state;
    if (!src) return;
    state = new this.State(src, md, env, outTokens);
    this.tokenize(state, state.line, state.lineMax);
};

$33dc179b20c9d6df$var$ParserBlock.prototype.State = (parcelRequire("hb4Rf"));
module.exports = $33dc179b20c9d6df$var$ParserBlock;

});
parcelRequire.register("aiY9V", function(module, exports) {
// GFM table, https://github.github.com/gfm/#tables-extension-
"use strict";

var $iXVVQ = parcelRequire("iXVVQ");
var $780a402f792355ba$require$isSpace = $iXVVQ.isSpace;
function $780a402f792355ba$var$getLine(state, line) {
    var pos = state.bMarks[line] + state.tShift[line], max = state.eMarks[line];
    return state.src.slice(pos, max);
}
function $780a402f792355ba$var$escapedSplit(str) {
    var result = [], pos = 0, max = str.length, ch, isEscaped = false, lastPos = 0, current = "";
    ch = str.charCodeAt(pos);
    while(pos < max){
        if (ch === 0x7c /* | */ ) {
            if (!isEscaped) {
                // pipe separating cells, '|'
                result.push(current + str.substring(lastPos, pos));
                current = "";
                lastPos = pos + 1;
            } else {
                // escaped pipe, '\|'
                current += str.substring(lastPos, pos - 1);
                lastPos = pos;
            }
        }
        isEscaped = ch === 0x5c /* \ */ ;
        pos++;
        ch = str.charCodeAt(pos);
    }
    result.push(current + str.substring(lastPos));
    return result;
}
module.exports = function table(state, startLine, endLine, silent) {
    var ch, lineText, pos, i, l, nextLine, columns, columnCount, token, aligns, t, tableLines, tbodyLines, oldParentType, terminate, terminatorRules, firstCh, secondCh;
    // should have at least two lines
    if (startLine + 2 > endLine) return false;
    nextLine = startLine + 1;
    if (state.sCount[nextLine] < state.blkIndent) return false;
    // if it's indented more than 3 spaces, it should be a code block
    if (state.sCount[nextLine] - state.blkIndent >= 4) return false;
    // first character of the second line should be '|', '-', ':',
    // and no other characters are allowed but spaces;
    // basically, this is the equivalent of /^[-:|][-:|\s]*$/ regexp
    pos = state.bMarks[nextLine] + state.tShift[nextLine];
    if (pos >= state.eMarks[nextLine]) return false;
    firstCh = state.src.charCodeAt(pos++);
    if (firstCh !== 0x7C /* | */  && firstCh !== 0x2D /* - */  && firstCh !== 0x3A /* : */ ) return false;
    if (pos >= state.eMarks[nextLine]) return false;
    secondCh = state.src.charCodeAt(pos++);
    if (secondCh !== 0x7C /* | */  && secondCh !== 0x2D /* - */  && secondCh !== 0x3A /* : */  && !$780a402f792355ba$require$isSpace(secondCh)) return false;
    // if first character is '-', then second character must not be a space
    // (due to parsing ambiguity with list)
    if (firstCh === 0x2D /* - */  && $780a402f792355ba$require$isSpace(secondCh)) return false;
    while(pos < state.eMarks[nextLine]){
        ch = state.src.charCodeAt(pos);
        if (ch !== 0x7C /* | */  && ch !== 0x2D /* - */  && ch !== 0x3A /* : */  && !$780a402f792355ba$require$isSpace(ch)) return false;
        pos++;
    }
    lineText = $780a402f792355ba$var$getLine(state, startLine + 1);
    columns = lineText.split("|");
    aligns = [];
    for(i = 0; i < columns.length; i++){
        t = columns[i].trim();
        if (!t) {
            // allow empty columns before and after table, but not in between columns;
            // e.g. allow ` |---| `, disallow ` ---||--- `
            if (i === 0 || i === columns.length - 1) continue;
            else return false;
        }
        if (!/^:?-+:?$/.test(t)) return false;
        if (t.charCodeAt(t.length - 1) === 0x3A /* : */ ) aligns.push(t.charCodeAt(0) === 0x3A /* : */  ? "center" : "right");
        else if (t.charCodeAt(0) === 0x3A /* : */ ) aligns.push("left");
        else aligns.push("");
    }
    lineText = $780a402f792355ba$var$getLine(state, startLine).trim();
    if (lineText.indexOf("|") === -1) return false;
    if (state.sCount[startLine] - state.blkIndent >= 4) return false;
    columns = $780a402f792355ba$var$escapedSplit(lineText);
    if (columns.length && columns[0] === "") columns.shift();
    if (columns.length && columns[columns.length - 1] === "") columns.pop();
    // header row will define an amount of columns in the entire table,
    // and align row should be exactly the same (the rest of the rows can differ)
    columnCount = columns.length;
    if (columnCount === 0 || columnCount !== aligns.length) return false;
    if (silent) return true;
    oldParentType = state.parentType;
    state.parentType = "table";
    // use 'blockquote' lists for termination because it's
    // the most similar to tables
    terminatorRules = state.md.block.ruler.getRules("blockquote");
    token = state.push("table_open", "table", 1);
    token.map = tableLines = [
        startLine,
        0
    ];
    token = state.push("thead_open", "thead", 1);
    token.map = [
        startLine,
        startLine + 1
    ];
    token = state.push("tr_open", "tr", 1);
    token.map = [
        startLine,
        startLine + 1
    ];
    for(i = 0; i < columns.length; i++){
        token = state.push("th_open", "th", 1);
        if (aligns[i]) token.attrs = [
            [
                "style",
                "text-align:" + aligns[i]
            ]
        ];
        token = state.push("inline", "", 0);
        token.content = columns[i].trim();
        token.children = [];
        token = state.push("th_close", "th", -1);
    }
    token = state.push("tr_close", "tr", -1);
    token = state.push("thead_close", "thead", -1);
    for(nextLine = startLine + 2; nextLine < endLine; nextLine++){
        if (state.sCount[nextLine] < state.blkIndent) break;
        terminate = false;
        for(i = 0, l = terminatorRules.length; i < l; i++)if (terminatorRules[i](state, nextLine, endLine, true)) {
            terminate = true;
            break;
        }
        if (terminate) break;
        lineText = $780a402f792355ba$var$getLine(state, nextLine).trim();
        if (!lineText) break;
        if (state.sCount[nextLine] - state.blkIndent >= 4) break;
        columns = $780a402f792355ba$var$escapedSplit(lineText);
        if (columns.length && columns[0] === "") columns.shift();
        if (columns.length && columns[columns.length - 1] === "") columns.pop();
        if (nextLine === startLine + 2) {
            token = state.push("tbody_open", "tbody", 1);
            token.map = tbodyLines = [
                startLine + 2,
                0
            ];
        }
        token = state.push("tr_open", "tr", 1);
        token.map = [
            nextLine,
            nextLine + 1
        ];
        for(i = 0; i < columnCount; i++){
            token = state.push("td_open", "td", 1);
            if (aligns[i]) token.attrs = [
                [
                    "style",
                    "text-align:" + aligns[i]
                ]
            ];
            token = state.push("inline", "", 0);
            token.content = columns[i] ? columns[i].trim() : "";
            token.children = [];
            token = state.push("td_close", "td", -1);
        }
        token = state.push("tr_close", "tr", -1);
    }
    if (tbodyLines) {
        token = state.push("tbody_close", "tbody", -1);
        tbodyLines[1] = nextLine;
    }
    token = state.push("table_close", "table", -1);
    tableLines[1] = nextLine;
    state.parentType = oldParentType;
    state.line = nextLine;
    return true;
};

});

parcelRequire.register("5tS63", function(module, exports) {
// Code block (4 spaces padded)
"use strict";
module.exports = function code(state, startLine, endLine /*, silent*/ ) {
    var nextLine, last, token;
    if (state.sCount[startLine] - state.blkIndent < 4) return false;
    last = nextLine = startLine + 1;
    while(nextLine < endLine){
        if (state.isEmpty(nextLine)) {
            nextLine++;
            continue;
        }
        if (state.sCount[nextLine] - state.blkIndent >= 4) {
            nextLine++;
            last = nextLine;
            continue;
        }
        break;
    }
    state.line = last;
    token = state.push("code_block", "code", 0);
    token.content = state.getLines(startLine, last, 4 + state.blkIndent, false) + "\n";
    token.map = [
        startLine,
        state.line
    ];
    return true;
};

});

parcelRequire.register("3g623", function(module, exports) {
// fences (``` lang, ~~~ lang)
"use strict";
module.exports = function fence(state, startLine, endLine, silent) {
    var marker, len, params, nextLine, mem, token, markup, haveEndMarker = false, pos = state.bMarks[startLine] + state.tShift[startLine], max = state.eMarks[startLine];
    // if it's indented more than 3 spaces, it should be a code block
    if (state.sCount[startLine] - state.blkIndent >= 4) return false;
    if (pos + 3 > max) return false;
    marker = state.src.charCodeAt(pos);
    if (marker !== 0x7E /* ~ */  && marker !== 0x60 /* ` */ ) return false;
    // scan marker length
    mem = pos;
    pos = state.skipChars(pos, marker);
    len = pos - mem;
    if (len < 3) return false;
    markup = state.src.slice(mem, pos);
    params = state.src.slice(pos, max);
    if (marker === 0x60 /* ` */ ) {
        if (params.indexOf(String.fromCharCode(marker)) >= 0) return false;
    }
    // Since start is found, we can report success here in validation mode
    if (silent) return true;
    // search end of block
    nextLine = startLine;
    for(;;){
        nextLine++;
        if (nextLine >= endLine) break;
        pos = mem = state.bMarks[nextLine] + state.tShift[nextLine];
        max = state.eMarks[nextLine];
        if (pos < max && state.sCount[nextLine] < state.blkIndent) break;
        if (state.src.charCodeAt(pos) !== marker) continue;
        if (state.sCount[nextLine] - state.blkIndent >= 4) continue;
        pos = state.skipChars(pos, marker);
        // closing code fence must be at least as long as the opening one
        if (pos - mem < len) continue;
        // make sure tail has spaces only
        pos = state.skipSpaces(pos);
        if (pos < max) continue;
        haveEndMarker = true;
        break;
    }
    // If a fence has heading spaces, they should be removed from its inner block
    len = state.sCount[startLine];
    state.line = nextLine + (haveEndMarker ? 1 : 0);
    token = state.push("fence", "code", 0);
    token.info = params;
    token.content = state.getLines(startLine + 1, nextLine, len, true);
    token.markup = markup;
    token.map = [
        startLine,
        state.line
    ];
    return true;
};

});

parcelRequire.register("frvdb", function(module, exports) {
// Block quotes
"use strict";

var $iXVVQ = parcelRequire("iXVVQ");
var $b3e19699e6324761$require$isSpace = $iXVVQ.isSpace;
module.exports = function blockquote(state, startLine, endLine, silent) {
    var adjustTab, ch, i, initial, l, lastLineEmpty, lines, nextLine, offset, oldBMarks, oldBSCount, oldIndent, oldParentType, oldSCount, oldTShift, spaceAfterMarker, terminate, terminatorRules, token, isOutdented, oldLineMax = state.lineMax, pos = state.bMarks[startLine] + state.tShift[startLine], max = state.eMarks[startLine];
    // if it's indented more than 3 spaces, it should be a code block
    if (state.sCount[startLine] - state.blkIndent >= 4) return false;
    // check the block quote marker
    if (state.src.charCodeAt(pos++) !== 0x3E /* > */ ) return false;
    // we know that it's going to be a valid blockquote,
    // so no point trying to find the end of it in silent mode
    if (silent) return true;
    // set offset past spaces and ">"
    initial = offset = state.sCount[startLine] + 1;
    // skip one optional space after '>'
    if (state.src.charCodeAt(pos) === 0x20 /* space */ ) {
        // ' >   test '
        //     ^ -- position start of line here:
        pos++;
        initial++;
        offset++;
        adjustTab = false;
        spaceAfterMarker = true;
    } else if (state.src.charCodeAt(pos) === 0x09 /* tab */ ) {
        spaceAfterMarker = true;
        if ((state.bsCount[startLine] + offset) % 4 === 3) {
            // '  >\t  test '
            //       ^ -- position start of line here (tab has width===1)
            pos++;
            initial++;
            offset++;
            adjustTab = false;
        } else // ' >\t  test '
        //    ^ -- position start of line here + shift bsCount slightly
        //         to make extra space appear
        adjustTab = true;
    } else spaceAfterMarker = false;
    oldBMarks = [
        state.bMarks[startLine]
    ];
    state.bMarks[startLine] = pos;
    while(pos < max){
        ch = state.src.charCodeAt(pos);
        if ($b3e19699e6324761$require$isSpace(ch)) {
            if (ch === 0x09) offset += 4 - (offset + state.bsCount[startLine] + (adjustTab ? 1 : 0)) % 4;
            else offset++;
        } else break;
        pos++;
    }
    oldBSCount = [
        state.bsCount[startLine]
    ];
    state.bsCount[startLine] = state.sCount[startLine] + 1 + (spaceAfterMarker ? 1 : 0);
    lastLineEmpty = pos >= max;
    oldSCount = [
        state.sCount[startLine]
    ];
    state.sCount[startLine] = offset - initial;
    oldTShift = [
        state.tShift[startLine]
    ];
    state.tShift[startLine] = pos - state.bMarks[startLine];
    terminatorRules = state.md.block.ruler.getRules("blockquote");
    oldParentType = state.parentType;
    state.parentType = "blockquote";
    // Search the end of the block
    //
    // Block ends with either:
    //  1. an empty line outside:
    //     ```
    //     > test
    //
    //     ```
    //  2. an empty line inside:
    //     ```
    //     >
    //     test
    //     ```
    //  3. another tag:
    //     ```
    //     > test
    //      - - -
    //     ```
    for(nextLine = startLine + 1; nextLine < endLine; nextLine++){
        // check if it's outdented, i.e. it's inside list item and indented
        // less than said list item:
        //
        // ```
        // 1. anything
        //    > current blockquote
        // 2. checking this line
        // ```
        isOutdented = state.sCount[nextLine] < state.blkIndent;
        pos = state.bMarks[nextLine] + state.tShift[nextLine];
        max = state.eMarks[nextLine];
        if (pos >= max) break;
        if (state.src.charCodeAt(pos++) === 0x3E /* > */  && !isOutdented) {
            // This line is inside the blockquote.
            // set offset past spaces and ">"
            initial = offset = state.sCount[nextLine] + 1;
            // skip one optional space after '>'
            if (state.src.charCodeAt(pos) === 0x20 /* space */ ) {
                // ' >   test '
                //     ^ -- position start of line here:
                pos++;
                initial++;
                offset++;
                adjustTab = false;
                spaceAfterMarker = true;
            } else if (state.src.charCodeAt(pos) === 0x09 /* tab */ ) {
                spaceAfterMarker = true;
                if ((state.bsCount[nextLine] + offset) % 4 === 3) {
                    // '  >\t  test '
                    //       ^ -- position start of line here (tab has width===1)
                    pos++;
                    initial++;
                    offset++;
                    adjustTab = false;
                } else // ' >\t  test '
                //    ^ -- position start of line here + shift bsCount slightly
                //         to make extra space appear
                adjustTab = true;
            } else spaceAfterMarker = false;
            oldBMarks.push(state.bMarks[nextLine]);
            state.bMarks[nextLine] = pos;
            while(pos < max){
                ch = state.src.charCodeAt(pos);
                if ($b3e19699e6324761$require$isSpace(ch)) {
                    if (ch === 0x09) offset += 4 - (offset + state.bsCount[nextLine] + (adjustTab ? 1 : 0)) % 4;
                    else offset++;
                } else break;
                pos++;
            }
            lastLineEmpty = pos >= max;
            oldBSCount.push(state.bsCount[nextLine]);
            state.bsCount[nextLine] = state.sCount[nextLine] + 1 + (spaceAfterMarker ? 1 : 0);
            oldSCount.push(state.sCount[nextLine]);
            state.sCount[nextLine] = offset - initial;
            oldTShift.push(state.tShift[nextLine]);
            state.tShift[nextLine] = pos - state.bMarks[nextLine];
            continue;
        }
        // Case 2: line is not inside the blockquote, and the last line was empty.
        if (lastLineEmpty) break;
        // Case 3: another tag found.
        terminate = false;
        for(i = 0, l = terminatorRules.length; i < l; i++)if (terminatorRules[i](state, nextLine, endLine, true)) {
            terminate = true;
            break;
        }
        if (terminate) {
            // Quirk to enforce "hard termination mode" for paragraphs;
            // normally if you call `tokenize(state, startLine, nextLine)`,
            // paragraphs will look below nextLine for paragraph continuation,
            // but if blockquote is terminated by another tag, they shouldn't
            state.lineMax = nextLine;
            if (state.blkIndent !== 0) {
                // state.blkIndent was non-zero, we now set it to zero,
                // so we need to re-calculate all offsets to appear as
                // if indent wasn't changed
                oldBMarks.push(state.bMarks[nextLine]);
                oldBSCount.push(state.bsCount[nextLine]);
                oldTShift.push(state.tShift[nextLine]);
                oldSCount.push(state.sCount[nextLine]);
                state.sCount[nextLine] -= state.blkIndent;
            }
            break;
        }
        oldBMarks.push(state.bMarks[nextLine]);
        oldBSCount.push(state.bsCount[nextLine]);
        oldTShift.push(state.tShift[nextLine]);
        oldSCount.push(state.sCount[nextLine]);
        // A negative indentation means that this is a paragraph continuation
        //
        state.sCount[nextLine] = -1;
    }
    oldIndent = state.blkIndent;
    state.blkIndent = 0;
    token = state.push("blockquote_open", "blockquote", 1);
    token.markup = ">";
    token.map = lines = [
        startLine,
        0
    ];
    state.md.block.tokenize(state, startLine, nextLine);
    token = state.push("blockquote_close", "blockquote", -1);
    token.markup = ">";
    state.lineMax = oldLineMax;
    state.parentType = oldParentType;
    lines[1] = state.line;
    // Restore original tShift; this might not be necessary since the parser
    // has already been here, but just to make sure we can do that.
    for(i = 0; i < oldTShift.length; i++){
        state.bMarks[i + startLine] = oldBMarks[i];
        state.tShift[i + startLine] = oldTShift[i];
        state.sCount[i + startLine] = oldSCount[i];
        state.bsCount[i + startLine] = oldBSCount[i];
    }
    state.blkIndent = oldIndent;
    return true;
};

});

parcelRequire.register("1SKTg", function(module, exports) {
// Horizontal rule
"use strict";

var $iXVVQ = parcelRequire("iXVVQ");
var $15ef35081aa9d8c0$require$isSpace = $iXVVQ.isSpace;
module.exports = function hr(state, startLine, endLine, silent) {
    var marker, cnt, ch, token, pos = state.bMarks[startLine] + state.tShift[startLine], max = state.eMarks[startLine];
    // if it's indented more than 3 spaces, it should be a code block
    if (state.sCount[startLine] - state.blkIndent >= 4) return false;
    marker = state.src.charCodeAt(pos++);
    // Check hr marker
    if (marker !== 0x2A /* * */  && marker !== 0x2D /* - */  && marker !== 0x5F /* _ */ ) return false;
    // markers can be mixed with spaces, but there should be at least 3 of them
    cnt = 1;
    while(pos < max){
        ch = state.src.charCodeAt(pos++);
        if (ch !== marker && !$15ef35081aa9d8c0$require$isSpace(ch)) return false;
        if (ch === marker) cnt++;
    }
    if (cnt < 3) return false;
    if (silent) return true;
    state.line = startLine + 1;
    token = state.push("hr", "hr", 0);
    token.map = [
        startLine,
        state.line
    ];
    token.markup = Array(cnt + 1).join(String.fromCharCode(marker));
    return true;
};

});

parcelRequire.register("fP2pa", function(module, exports) {
// Lists
"use strict";

var $iXVVQ = parcelRequire("iXVVQ");
var $b84d7bfb1e5d2169$require$isSpace = $iXVVQ.isSpace;
// Search `[-+*][\n ]`, returns next pos after marker on success
// or -1 on fail.
function $b84d7bfb1e5d2169$var$skipBulletListMarker(state, startLine) {
    var marker, pos, max, ch;
    pos = state.bMarks[startLine] + state.tShift[startLine];
    max = state.eMarks[startLine];
    marker = state.src.charCodeAt(pos++);
    // Check bullet
    if (marker !== 0x2A /* * */  && marker !== 0x2D /* - */  && marker !== 0x2B /* + */ ) return -1;
    if (pos < max) {
        ch = state.src.charCodeAt(pos);
        if (!$b84d7bfb1e5d2169$require$isSpace(ch)) // " -test " - is not a list item
        return -1;
    }
    return pos;
}
// Search `\d+[.)][\n ]`, returns next pos after marker on success
// or -1 on fail.
function $b84d7bfb1e5d2169$var$skipOrderedListMarker(state, startLine) {
    var ch, start = state.bMarks[startLine] + state.tShift[startLine], pos = start, max = state.eMarks[startLine];
    // List marker should have at least 2 chars (digit + dot)
    if (pos + 1 >= max) return -1;
    ch = state.src.charCodeAt(pos++);
    if (ch < 0x30 /* 0 */  || ch > 0x39 /* 9 */ ) return -1;
    for(;;){
        // EOL -> fail
        if (pos >= max) return -1;
        ch = state.src.charCodeAt(pos++);
        if (ch >= 0x30 /* 0 */  && ch <= 0x39 /* 9 */ ) {
            // List marker should have no more than 9 digits
            // (prevents integer overflow in browsers)
            if (pos - start >= 10) return -1;
            continue;
        }
        // found valid marker
        if (ch === 0x29 /* ) */  || ch === 0x2e /* . */ ) break;
        return -1;
    }
    if (pos < max) {
        ch = state.src.charCodeAt(pos);
        if (!$b84d7bfb1e5d2169$require$isSpace(ch)) // " 1.test " - is not a list item
        return -1;
    }
    return pos;
}
function $b84d7bfb1e5d2169$var$markTightParagraphs(state, idx) {
    var i, l, level = state.level + 2;
    for(i = idx + 2, l = state.tokens.length - 2; i < l; i++)if (state.tokens[i].level === level && state.tokens[i].type === "paragraph_open") {
        state.tokens[i + 2].hidden = true;
        state.tokens[i].hidden = true;
        i += 2;
    }
}
module.exports = function list(state, startLine, endLine, silent) {
    var ch, contentStart, i, indent, indentAfterMarker, initial, isOrdered, itemLines, l, listLines, listTokIdx, markerCharCode, markerValue, max, nextLine, offset, oldListIndent, oldParentType, oldSCount, oldTShift, oldTight, pos, posAfterMarker, prevEmptyEnd, start, terminate, terminatorRules, token, isTerminatingParagraph = false, tight = true;
    // if it's indented more than 3 spaces, it should be a code block
    if (state.sCount[startLine] - state.blkIndent >= 4) return false;
    // Special case:
    //  - item 1
    //   - item 2
    //    - item 3
    //     - item 4
    //      - this one is a paragraph continuation
    if (state.listIndent >= 0 && state.sCount[startLine] - state.listIndent >= 4 && state.sCount[startLine] < state.blkIndent) return false;
    // limit conditions when list can interrupt
    // a paragraph (validation mode only)
    if (silent && state.parentType === "paragraph") // Next list item should still terminate previous list item;
    //
    // This code can fail if plugins use blkIndent as well as lists,
    // but I hope the spec gets fixed long before that happens.
    //
    {
        if (state.sCount[startLine] >= state.blkIndent) isTerminatingParagraph = true;
    }
    // Detect list type and position after marker
    if ((posAfterMarker = $b84d7bfb1e5d2169$var$skipOrderedListMarker(state, startLine)) >= 0) {
        isOrdered = true;
        start = state.bMarks[startLine] + state.tShift[startLine];
        markerValue = Number(state.src.slice(start, posAfterMarker - 1));
        // If we're starting a new ordered list right after
        // a paragraph, it should start with 1.
        if (isTerminatingParagraph && markerValue !== 1) return false;
    } else if ((posAfterMarker = $b84d7bfb1e5d2169$var$skipBulletListMarker(state, startLine)) >= 0) isOrdered = false;
    else return false;
    // If we're starting a new unordered list right after
    // a paragraph, first line should not be empty.
    if (isTerminatingParagraph) {
        if (state.skipSpaces(posAfterMarker) >= state.eMarks[startLine]) return false;
    }
    // We should terminate list on style change. Remember first one to compare.
    markerCharCode = state.src.charCodeAt(posAfterMarker - 1);
    // For validation mode we can terminate immediately
    if (silent) return true;
    // Start list
    listTokIdx = state.tokens.length;
    if (isOrdered) {
        token = state.push("ordered_list_open", "ol", 1);
        if (markerValue !== 1) token.attrs = [
            [
                "start",
                markerValue
            ]
        ];
    } else token = state.push("bullet_list_open", "ul", 1);
    token.map = listLines = [
        startLine,
        0
    ];
    token.markup = String.fromCharCode(markerCharCode);
    //
    // Iterate list items
    //
    nextLine = startLine;
    prevEmptyEnd = false;
    terminatorRules = state.md.block.ruler.getRules("list");
    oldParentType = state.parentType;
    state.parentType = "list";
    while(nextLine < endLine){
        pos = posAfterMarker;
        max = state.eMarks[nextLine];
        initial = offset = state.sCount[nextLine] + posAfterMarker - (state.bMarks[startLine] + state.tShift[startLine]);
        while(pos < max){
            ch = state.src.charCodeAt(pos);
            if (ch === 0x09) offset += 4 - (offset + state.bsCount[nextLine]) % 4;
            else if (ch === 0x20) offset++;
            else break;
            pos++;
        }
        contentStart = pos;
        if (contentStart >= max) // trimming space in "-    \n  3" case, indent is 1 here
        indentAfterMarker = 1;
        else indentAfterMarker = offset - initial;
        // If we have more than 4 spaces, the indent is 1
        // (the rest is just indented code block)
        if (indentAfterMarker > 4) indentAfterMarker = 1;
        // "  -  test"
        //  ^^^^^ - calculating total length of this thing
        indent = initial + indentAfterMarker;
        // Run subparser & write tokens
        token = state.push("list_item_open", "li", 1);
        token.markup = String.fromCharCode(markerCharCode);
        token.map = itemLines = [
            startLine,
            0
        ];
        if (isOrdered) token.info = state.src.slice(start, posAfterMarker - 1);
        // change current state, then restore it after parser subcall
        oldTight = state.tight;
        oldTShift = state.tShift[startLine];
        oldSCount = state.sCount[startLine];
        //  - example list
        // ^ listIndent position will be here
        //   ^ blkIndent position will be here
        //
        oldListIndent = state.listIndent;
        state.listIndent = state.blkIndent;
        state.blkIndent = indent;
        state.tight = true;
        state.tShift[startLine] = contentStart - state.bMarks[startLine];
        state.sCount[startLine] = offset;
        if (contentStart >= max && state.isEmpty(startLine + 1)) // workaround for this case
        // (list item is empty, list terminates before "foo"):
        // ~~~~~~~~
        //   -
        //
        //     foo
        // ~~~~~~~~
        state.line = Math.min(state.line + 2, endLine);
        else state.md.block.tokenize(state, startLine, endLine, true);
        // If any of list item is tight, mark list as tight
        if (!state.tight || prevEmptyEnd) tight = false;
        // Item become loose if finish with empty line,
        // but we should filter last element, because it means list finish
        prevEmptyEnd = state.line - startLine > 1 && state.isEmpty(state.line - 1);
        state.blkIndent = state.listIndent;
        state.listIndent = oldListIndent;
        state.tShift[startLine] = oldTShift;
        state.sCount[startLine] = oldSCount;
        state.tight = oldTight;
        token = state.push("list_item_close", "li", -1);
        token.markup = String.fromCharCode(markerCharCode);
        nextLine = startLine = state.line;
        itemLines[1] = nextLine;
        contentStart = state.bMarks[startLine];
        if (nextLine >= endLine) break;
        //
        // Try to check if list is terminated or continued.
        //
        if (state.sCount[nextLine] < state.blkIndent) break;
        // if it's indented more than 3 spaces, it should be a code block
        if (state.sCount[startLine] - state.blkIndent >= 4) break;
        // fail if terminating block found
        terminate = false;
        for(i = 0, l = terminatorRules.length; i < l; i++)if (terminatorRules[i](state, nextLine, endLine, true)) {
            terminate = true;
            break;
        }
        if (terminate) break;
        // fail if list has another type
        if (isOrdered) {
            posAfterMarker = $b84d7bfb1e5d2169$var$skipOrderedListMarker(state, nextLine);
            if (posAfterMarker < 0) break;
            start = state.bMarks[nextLine] + state.tShift[nextLine];
        } else {
            posAfterMarker = $b84d7bfb1e5d2169$var$skipBulletListMarker(state, nextLine);
            if (posAfterMarker < 0) break;
        }
        if (markerCharCode !== state.src.charCodeAt(posAfterMarker - 1)) break;
    }
    // Finalize list
    if (isOrdered) token = state.push("ordered_list_close", "ol", -1);
    else token = state.push("bullet_list_close", "ul", -1);
    token.markup = String.fromCharCode(markerCharCode);
    listLines[1] = nextLine;
    state.line = nextLine;
    state.parentType = oldParentType;
    // mark paragraphs tight if needed
    if (tight) $b84d7bfb1e5d2169$var$markTightParagraphs(state, listTokIdx);
    return true;
};

});

parcelRequire.register("b08Li", function(module, exports) {
"use strict";

var $iXVVQ = parcelRequire("iXVVQ");
var $80267db5e699c2d2$require$normalizeReference = $iXVVQ.normalizeReference;

var $iXVVQ = parcelRequire("iXVVQ");
var $80267db5e699c2d2$require$isSpace = $iXVVQ.isSpace;
module.exports = function reference(state, startLine, _endLine, silent) {
    var ch, destEndPos, destEndLineNo, endLine, href, i, l, label, labelEnd, oldParentType, res, start, str, terminate, terminatorRules, title, lines = 0, pos = state.bMarks[startLine] + state.tShift[startLine], max = state.eMarks[startLine], nextLine = startLine + 1;
    // if it's indented more than 3 spaces, it should be a code block
    if (state.sCount[startLine] - state.blkIndent >= 4) return false;
    if (state.src.charCodeAt(pos) !== 0x5B /* [ */ ) return false;
    // Simple check to quickly interrupt scan on [link](url) at the start of line.
    // Can be useful on practice: https://github.com/markdown-it/markdown-it/issues/54
    while(++pos < max)if (state.src.charCodeAt(pos) === 0x5D /* ] */  && state.src.charCodeAt(pos - 1) !== 0x5C /* \ */ ) {
        if (pos + 1 === max) return false;
        if (state.src.charCodeAt(pos + 1) !== 0x3A /* : */ ) return false;
        break;
    }
    endLine = state.lineMax;
    // jump line-by-line until empty one or EOF
    terminatorRules = state.md.block.ruler.getRules("reference");
    oldParentType = state.parentType;
    state.parentType = "reference";
    for(; nextLine < endLine && !state.isEmpty(nextLine); nextLine++){
        // this would be a code block normally, but after paragraph
        // it's considered a lazy continuation regardless of what's there
        if (state.sCount[nextLine] - state.blkIndent > 3) continue;
        // quirk for blockquotes, this line should already be checked by that rule
        if (state.sCount[nextLine] < 0) continue;
        // Some tags can terminate paragraph without empty line.
        terminate = false;
        for(i = 0, l = terminatorRules.length; i < l; i++)if (terminatorRules[i](state, nextLine, endLine, true)) {
            terminate = true;
            break;
        }
        if (terminate) break;
    }
    str = state.getLines(startLine, nextLine, state.blkIndent, false).trim();
    max = str.length;
    for(pos = 1; pos < max; pos++){
        ch = str.charCodeAt(pos);
        if (ch === 0x5B /* [ */ ) return false;
        else if (ch === 0x5D /* ] */ ) {
            labelEnd = pos;
            break;
        } else if (ch === 0x0A /* \n */ ) lines++;
        else if (ch === 0x5C /* \ */ ) {
            pos++;
            if (pos < max && str.charCodeAt(pos) === 0x0A) lines++;
        }
    }
    if (labelEnd < 0 || str.charCodeAt(labelEnd + 1) !== 0x3A /* : */ ) return false;
    // [label]:   destination   'title'
    //         ^^^ skip optional whitespace here
    for(pos = labelEnd + 2; pos < max; pos++){
        ch = str.charCodeAt(pos);
        if (ch === 0x0A) lines++;
        else if ($80267db5e699c2d2$require$isSpace(ch)) ;
        else break;
    }
    // [label]:   destination   'title'
    //            ^^^^^^^^^^^ parse this
    res = state.md.helpers.parseLinkDestination(str, pos, max);
    if (!res.ok) return false;
    href = state.md.normalizeLink(res.str);
    if (!state.md.validateLink(href)) return false;
    pos = res.pos;
    lines += res.lines;
    // save cursor state, we could require to rollback later
    destEndPos = pos;
    destEndLineNo = lines;
    // [label]:   destination   'title'
    //                       ^^^ skipping those spaces
    start = pos;
    for(; pos < max; pos++){
        ch = str.charCodeAt(pos);
        if (ch === 0x0A) lines++;
        else if ($80267db5e699c2d2$require$isSpace(ch)) ;
        else break;
    }
    // [label]:   destination   'title'
    //                          ^^^^^^^ parse this
    res = state.md.helpers.parseLinkTitle(str, pos, max);
    if (pos < max && start !== pos && res.ok) {
        title = res.str;
        pos = res.pos;
        lines += res.lines;
    } else {
        title = "";
        pos = destEndPos;
        lines = destEndLineNo;
    }
    // skip trailing spaces until the rest of the line
    while(pos < max){
        ch = str.charCodeAt(pos);
        if (!$80267db5e699c2d2$require$isSpace(ch)) break;
        pos++;
    }
    if (pos < max && str.charCodeAt(pos) !== 0x0A) {
        if (title) {
            // garbage at the end of the line after title,
            // but it could still be a valid reference if we roll back
            title = "";
            pos = destEndPos;
            lines = destEndLineNo;
            while(pos < max){
                ch = str.charCodeAt(pos);
                if (!$80267db5e699c2d2$require$isSpace(ch)) break;
                pos++;
            }
        }
    }
    if (pos < max && str.charCodeAt(pos) !== 0x0A) // garbage at the end of the line
    return false;
    label = $80267db5e699c2d2$require$normalizeReference(str.slice(1, labelEnd));
    if (!label) // CommonMark 0.20 disallows empty labels
    return false;
    // Reference can not terminate anything. This check is for safety only.
    /*istanbul ignore if*/ if (silent) return true;
    if (typeof state.env.references === "undefined") state.env.references = {};
    if (typeof state.env.references[label] === "undefined") state.env.references[label] = {
        title: title,
        href: href
    };
    state.parentType = oldParentType;
    state.line = startLine + lines + 1;
    return true;
};

});

parcelRequire.register("aaI3i", function(module, exports) {
// HTML block
"use strict";

var $aVFpO = parcelRequire("aVFpO");

var $khGdz = parcelRequire("khGdz");
var $767d0260a021486b$require$HTML_OPEN_CLOSE_TAG_RE = $khGdz.HTML_OPEN_CLOSE_TAG_RE;
// An array of opening and corresponding closing sequences for html tags,
// last argument defines whether it can terminate a paragraph or not
//
var $767d0260a021486b$var$HTML_SEQUENCES = [
    [
        /^<(script|pre|style|textarea)(?=(\s|>|$))/i,
        /<\/(script|pre|style|textarea)>/i,
        true
    ],
    [
        /^<!--/,
        /-->/,
        true
    ],
    [
        /^<\?/,
        /\?>/,
        true
    ],
    [
        /^<![A-Z]/,
        />/,
        true
    ],
    [
        /^<!\[CDATA\[/,
        /\]\]>/,
        true
    ],
    [
        new RegExp("^</?(" + $aVFpO.join("|") + ")(?=(\\s|/?>|$))", "i"),
        /^$/,
        true
    ],
    [
        new RegExp($767d0260a021486b$require$HTML_OPEN_CLOSE_TAG_RE.source + "\\s*$"),
        /^$/,
        false
    ]
];
module.exports = function html_block(state, startLine, endLine, silent) {
    var i, nextLine, token, lineText, pos = state.bMarks[startLine] + state.tShift[startLine], max = state.eMarks[startLine];
    // if it's indented more than 3 spaces, it should be a code block
    if (state.sCount[startLine] - state.blkIndent >= 4) return false;
    if (!state.md.options.html) return false;
    if (state.src.charCodeAt(pos) !== 0x3C /* < */ ) return false;
    lineText = state.src.slice(pos, max);
    for(i = 0; i < $767d0260a021486b$var$HTML_SEQUENCES.length; i++){
        if ($767d0260a021486b$var$HTML_SEQUENCES[i][0].test(lineText)) break;
    }
    if (i === $767d0260a021486b$var$HTML_SEQUENCES.length) return false;
    if (silent) // true if this sequence can be a terminator, false otherwise
    return $767d0260a021486b$var$HTML_SEQUENCES[i][2];
    nextLine = startLine + 1;
    // If we are here - we detected HTML block.
    // Let's roll down till block end.
    if (!$767d0260a021486b$var$HTML_SEQUENCES[i][1].test(lineText)) for(; nextLine < endLine; nextLine++){
        if (state.sCount[nextLine] < state.blkIndent) break;
        pos = state.bMarks[nextLine] + state.tShift[nextLine];
        max = state.eMarks[nextLine];
        lineText = state.src.slice(pos, max);
        if ($767d0260a021486b$var$HTML_SEQUENCES[i][1].test(lineText)) {
            if (lineText.length !== 0) nextLine++;
            break;
        }
    }
    state.line = nextLine;
    token = state.push("html_block", "", 0);
    token.map = [
        startLine,
        nextLine
    ];
    token.content = state.getLines(startLine, nextLine, state.blkIndent, true);
    return true;
};

});
parcelRequire.register("aVFpO", function(module, exports) {
// List of valid html blocks names, accorting to commonmark spec
// http://jgm.github.io/CommonMark/spec.html#html-blocks
"use strict";
module.exports = [
    "address",
    "article",
    "aside",
    "base",
    "basefont",
    "blockquote",
    "body",
    "caption",
    "center",
    "col",
    "colgroup",
    "dd",
    "details",
    "dialog",
    "dir",
    "div",
    "dl",
    "dt",
    "fieldset",
    "figcaption",
    "figure",
    "footer",
    "form",
    "frame",
    "frameset",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "head",
    "header",
    "hr",
    "html",
    "iframe",
    "legend",
    "li",
    "link",
    "main",
    "menu",
    "menuitem",
    "nav",
    "noframes",
    "ol",
    "optgroup",
    "option",
    "p",
    "param",
    "section",
    "source",
    "summary",
    "table",
    "tbody",
    "td",
    "tfoot",
    "th",
    "thead",
    "title",
    "tr",
    "track",
    "ul"
];

});

parcelRequire.register("khGdz", function(module, exports) {

$parcel$export(module.exports, "HTML_TAG_RE", () => $ec4624c39854b0cf$export$6db61d2c3a16e419, (v) => $ec4624c39854b0cf$export$6db61d2c3a16e419 = v);
$parcel$export(module.exports, "HTML_OPEN_CLOSE_TAG_RE", () => $ec4624c39854b0cf$export$cd48660d06f74639, (v) => $ec4624c39854b0cf$export$cd48660d06f74639 = v);
// Regexps to match html elements
var $ec4624c39854b0cf$export$6db61d2c3a16e419;
var $ec4624c39854b0cf$export$cd48660d06f74639;
"use strict";
var $ec4624c39854b0cf$var$attr_name = "[a-zA-Z_:][a-zA-Z0-9:._-]*";
var $ec4624c39854b0cf$var$unquoted = "[^\"'=<>`\\x00-\\x20]+";
var $ec4624c39854b0cf$var$single_quoted = "'[^']*'";
var $ec4624c39854b0cf$var$double_quoted = '"[^"]*"';
var $ec4624c39854b0cf$var$attr_value = "(?:" + $ec4624c39854b0cf$var$unquoted + "|" + $ec4624c39854b0cf$var$single_quoted + "|" + $ec4624c39854b0cf$var$double_quoted + ")";
var $ec4624c39854b0cf$var$attribute = "(?:\\s+" + $ec4624c39854b0cf$var$attr_name + "(?:\\s*=\\s*" + $ec4624c39854b0cf$var$attr_value + ")?)";
var $ec4624c39854b0cf$var$open_tag = "<[A-Za-z][A-Za-z0-9\\-]*" + $ec4624c39854b0cf$var$attribute + "*\\s*\\/?>";
var $ec4624c39854b0cf$var$close_tag = "<\\/[A-Za-z][A-Za-z0-9\\-]*\\s*>";
var $ec4624c39854b0cf$var$comment = "<!---->|<!--(?:-?[^>-])(?:-?[^-])*-->";
var $ec4624c39854b0cf$var$processing = "<[?][\\s\\S]*?[?]>";
var $ec4624c39854b0cf$var$declaration = "<![A-Z]+\\s+[^>]*>";
var $ec4624c39854b0cf$var$cdata = "<!\\[CDATA\\[[\\s\\S]*?\\]\\]>";
var $ec4624c39854b0cf$var$HTML_TAG_RE = new RegExp("^(?:" + $ec4624c39854b0cf$var$open_tag + "|" + $ec4624c39854b0cf$var$close_tag + "|" + $ec4624c39854b0cf$var$comment + "|" + $ec4624c39854b0cf$var$processing + "|" + $ec4624c39854b0cf$var$declaration + "|" + $ec4624c39854b0cf$var$cdata + ")");
var $ec4624c39854b0cf$var$HTML_OPEN_CLOSE_TAG_RE = new RegExp("^(?:" + $ec4624c39854b0cf$var$open_tag + "|" + $ec4624c39854b0cf$var$close_tag + ")");
$ec4624c39854b0cf$export$6db61d2c3a16e419 = $ec4624c39854b0cf$var$HTML_TAG_RE;
$ec4624c39854b0cf$export$cd48660d06f74639 = $ec4624c39854b0cf$var$HTML_OPEN_CLOSE_TAG_RE;

});


parcelRequire.register("2xOl8", function(module, exports) {
// heading (#, ##, ...)
"use strict";

var $iXVVQ = parcelRequire("iXVVQ");
var $1da5b64d0cf3a9a7$require$isSpace = $iXVVQ.isSpace;
module.exports = function heading(state, startLine, endLine, silent) {
    var ch, level, tmp, token, pos = state.bMarks[startLine] + state.tShift[startLine], max = state.eMarks[startLine];
    // if it's indented more than 3 spaces, it should be a code block
    if (state.sCount[startLine] - state.blkIndent >= 4) return false;
    ch = state.src.charCodeAt(pos);
    if (ch !== 0x23 /* # */  || pos >= max) return false;
    // count heading level
    level = 1;
    ch = state.src.charCodeAt(++pos);
    while(ch === 0x23 /* # */  && pos < max && level <= 6){
        level++;
        ch = state.src.charCodeAt(++pos);
    }
    if (level > 6 || pos < max && !$1da5b64d0cf3a9a7$require$isSpace(ch)) return false;
    if (silent) return true;
    // Let's cut tails like '    ###  ' from the end of string
    max = state.skipSpacesBack(max, pos);
    tmp = state.skipCharsBack(max, 0x23, pos); // #
    if (tmp > pos && $1da5b64d0cf3a9a7$require$isSpace(state.src.charCodeAt(tmp - 1))) max = tmp;
    state.line = startLine + 1;
    token = state.push("heading_open", "h" + String(level), 1);
    token.markup = "########".slice(0, level);
    token.map = [
        startLine,
        state.line
    ];
    token = state.push("inline", "", 0);
    token.content = state.src.slice(pos, max).trim();
    token.map = [
        startLine,
        state.line
    ];
    token.children = [];
    token = state.push("heading_close", "h" + String(level), -1);
    token.markup = "########".slice(0, level);
    return true;
};

});

parcelRequire.register("6LRgJ", function(module, exports) {
// lheading (---, ===)
"use strict";
module.exports = function lheading(state, startLine, endLine /*, silent*/ ) {
    var content, terminate, i, l, token, pos, max, level, marker, nextLine = startLine + 1, oldParentType, terminatorRules = state.md.block.ruler.getRules("paragraph");
    // if it's indented more than 3 spaces, it should be a code block
    if (state.sCount[startLine] - state.blkIndent >= 4) return false;
    oldParentType = state.parentType;
    state.parentType = "paragraph"; // use paragraph to match terminatorRules
    // jump line-by-line until empty one or EOF
    for(; nextLine < endLine && !state.isEmpty(nextLine); nextLine++){
        // this would be a code block normally, but after paragraph
        // it's considered a lazy continuation regardless of what's there
        if (state.sCount[nextLine] - state.blkIndent > 3) continue;
        //
        // Check for underline in setext header
        //
        if (state.sCount[nextLine] >= state.blkIndent) {
            pos = state.bMarks[nextLine] + state.tShift[nextLine];
            max = state.eMarks[nextLine];
            if (pos < max) {
                marker = state.src.charCodeAt(pos);
                if (marker === 0x2D /* - */  || marker === 0x3D /* = */ ) {
                    pos = state.skipChars(pos, marker);
                    pos = state.skipSpaces(pos);
                    if (pos >= max) {
                        level = marker === 0x3D /* = */  ? 1 : 2;
                        break;
                    }
                }
            }
        }
        // quirk for blockquotes, this line should already be checked by that rule
        if (state.sCount[nextLine] < 0) continue;
        // Some tags can terminate paragraph without empty line.
        terminate = false;
        for(i = 0, l = terminatorRules.length; i < l; i++)if (terminatorRules[i](state, nextLine, endLine, true)) {
            terminate = true;
            break;
        }
        if (terminate) break;
    }
    if (!level) // Didn't find valid underline
    return false;
    content = state.getLines(startLine, nextLine, state.blkIndent, false).trim();
    state.line = nextLine + 1;
    token = state.push("heading_open", "h" + String(level), 1);
    token.markup = String.fromCharCode(marker);
    token.map = [
        startLine,
        state.line
    ];
    token = state.push("inline", "", 0);
    token.content = content;
    token.map = [
        startLine,
        state.line - 1
    ];
    token.children = [];
    token = state.push("heading_close", "h" + String(level), -1);
    token.markup = String.fromCharCode(marker);
    state.parentType = oldParentType;
    return true;
};

});

parcelRequire.register("2aG2t", function(module, exports) {
// Paragraph
"use strict";
module.exports = function paragraph(state, startLine /*, endLine*/ ) {
    var content, terminate, i, l, token, oldParentType, nextLine = startLine + 1, terminatorRules = state.md.block.ruler.getRules("paragraph"), endLine = state.lineMax;
    oldParentType = state.parentType;
    state.parentType = "paragraph";
    // jump line-by-line until empty one or EOF
    for(; nextLine < endLine && !state.isEmpty(nextLine); nextLine++){
        // this would be a code block normally, but after paragraph
        // it's considered a lazy continuation regardless of what's there
        if (state.sCount[nextLine] - state.blkIndent > 3) continue;
        // quirk for blockquotes, this line should already be checked by that rule
        if (state.sCount[nextLine] < 0) continue;
        // Some tags can terminate paragraph without empty line.
        terminate = false;
        for(i = 0, l = terminatorRules.length; i < l; i++)if (terminatorRules[i](state, nextLine, endLine, true)) {
            terminate = true;
            break;
        }
        if (terminate) break;
    }
    content = state.getLines(startLine, nextLine, state.blkIndent, false).trim();
    state.line = nextLine;
    token = state.push("paragraph_open", "p", 1);
    token.map = [
        startLine,
        state.line
    ];
    token = state.push("inline", "", 0);
    token.content = content;
    token.map = [
        startLine,
        state.line
    ];
    token.children = [];
    token = state.push("paragraph_close", "p", -1);
    state.parentType = oldParentType;
    return true;
};

});

parcelRequire.register("hb4Rf", function(module, exports) {
// Parser state class
"use strict";

var $lGPSc = parcelRequire("lGPSc");

var $iXVVQ = parcelRequire("iXVVQ");
var $033a2e60c00167e3$require$isSpace = $iXVVQ.isSpace;
function $033a2e60c00167e3$var$StateBlock(src, md, env, tokens) {
    var ch, s, start, pos, len, indent, offset, indent_found;
    this.src = src;
    // link to parser instance
    this.md = md;
    this.env = env;
    //
    // Internal state vartiables
    //
    this.tokens = tokens;
    this.bMarks = []; // line begin offsets for fast jumps
    this.eMarks = []; // line end offsets for fast jumps
    this.tShift = []; // offsets of the first non-space characters (tabs not expanded)
    this.sCount = []; // indents for each line (tabs expanded)
    // An amount of virtual spaces (tabs expanded) between beginning
    // of each line (bMarks) and real beginning of that line.
    //
    // It exists only as a hack because blockquotes override bMarks
    // losing information in the process.
    //
    // It's used only when expanding tabs, you can think about it as
    // an initial tab length, e.g. bsCount=21 applied to string `\t123`
    // means first tab should be expanded to 4-21%4 === 3 spaces.
    //
    this.bsCount = [];
    // block parser variables
    this.blkIndent = 0; // required block content indent (for example, if we are
    // inside a list, it would be positioned after list marker)
    this.line = 0; // line index in src
    this.lineMax = 0; // lines count
    this.tight = false; // loose/tight mode for lists
    this.ddIndent = -1; // indent of the current dd block (-1 if there isn't any)
    this.listIndent = -1; // indent of the current list block (-1 if there isn't any)
    // can be 'blockquote', 'list', 'root', 'paragraph' or 'reference'
    // used in lists to determine if they interrupt a paragraph
    this.parentType = "root";
    this.level = 0;
    // renderer
    this.result = "";
    // Create caches
    // Generate markers.
    s = this.src;
    indent_found = false;
    for(start = pos = indent = offset = 0, len = s.length; pos < len; pos++){
        ch = s.charCodeAt(pos);
        if (!indent_found) {
            if ($033a2e60c00167e3$require$isSpace(ch)) {
                indent++;
                if (ch === 0x09) offset += 4 - offset % 4;
                else offset++;
                continue;
            } else indent_found = true;
        }
        if (ch === 0x0A || pos === len - 1) {
            if (ch !== 0x0A) pos++;
            this.bMarks.push(start);
            this.eMarks.push(pos);
            this.tShift.push(indent);
            this.sCount.push(offset);
            this.bsCount.push(0);
            indent_found = false;
            indent = 0;
            offset = 0;
            start = pos + 1;
        }
    }
    // Push fake entry to simplify cache bounds checks
    this.bMarks.push(s.length);
    this.eMarks.push(s.length);
    this.tShift.push(0);
    this.sCount.push(0);
    this.bsCount.push(0);
    this.lineMax = this.bMarks.length - 1; // don't count last fake line
}
// Push new token to "stream".
//
$033a2e60c00167e3$var$StateBlock.prototype.push = function(type, tag, nesting) {
    var token = new $lGPSc(type, tag, nesting);
    token.block = true;
    if (nesting < 0) this.level--; // closing tag
    token.level = this.level;
    if (nesting > 0) this.level++; // opening tag
    this.tokens.push(token);
    return token;
};
$033a2e60c00167e3$var$StateBlock.prototype.isEmpty = function isEmpty(line) {
    return this.bMarks[line] + this.tShift[line] >= this.eMarks[line];
};
$033a2e60c00167e3$var$StateBlock.prototype.skipEmptyLines = function skipEmptyLines(from) {
    for(var max = this.lineMax; from < max; from++){
        if (this.bMarks[from] + this.tShift[from] < this.eMarks[from]) break;
    }
    return from;
};
// Skip spaces from given position.
$033a2e60c00167e3$var$StateBlock.prototype.skipSpaces = function skipSpaces(pos) {
    var ch;
    for(var max = this.src.length; pos < max; pos++){
        ch = this.src.charCodeAt(pos);
        if (!$033a2e60c00167e3$require$isSpace(ch)) break;
    }
    return pos;
};
// Skip spaces from given position in reverse.
$033a2e60c00167e3$var$StateBlock.prototype.skipSpacesBack = function skipSpacesBack(pos, min) {
    if (pos <= min) return pos;
    while(pos > min){
        if (!$033a2e60c00167e3$require$isSpace(this.src.charCodeAt(--pos))) return pos + 1;
    }
    return pos;
};
// Skip char codes from given position
$033a2e60c00167e3$var$StateBlock.prototype.skipChars = function skipChars(pos, code) {
    for(var max = this.src.length; pos < max; pos++){
        if (this.src.charCodeAt(pos) !== code) break;
    }
    return pos;
};
// Skip char codes reverse from given position - 1
$033a2e60c00167e3$var$StateBlock.prototype.skipCharsBack = function skipCharsBack(pos, code, min) {
    if (pos <= min) return pos;
    while(pos > min){
        if (code !== this.src.charCodeAt(--pos)) return pos + 1;
    }
    return pos;
};
// cut lines range from source.
$033a2e60c00167e3$var$StateBlock.prototype.getLines = function getLines(begin, end, indent, keepLastLF) {
    var i, lineIndent, ch, first, last, queue, lineStart, line = begin;
    if (begin >= end) return "";
    queue = new Array(end - begin);
    for(i = 0; line < end; line++, i++){
        lineIndent = 0;
        lineStart = first = this.bMarks[line];
        if (line + 1 < end || keepLastLF) // No need for bounds check because we have fake entry on tail.
        last = this.eMarks[line] + 1;
        else last = this.eMarks[line];
        while(first < last && lineIndent < indent){
            ch = this.src.charCodeAt(first);
            if ($033a2e60c00167e3$require$isSpace(ch)) {
                if (ch === 0x09) lineIndent += 4 - (lineIndent + this.bsCount[line]) % 4;
                else lineIndent++;
            } else if (first - lineStart < this.tShift[line]) // patched tShift masked characters to look like spaces (blockquotes, list markers)
            lineIndent++;
            else break;
            first++;
        }
        if (lineIndent > indent) // partially expanding tabs in code blocks, e.g '\t\tfoobar'
        // with indent=2 becomes '  \tfoobar'
        queue[i] = new Array(lineIndent - indent + 1).join(" ") + this.src.slice(first, last);
        else queue[i] = this.src.slice(first, last);
    }
    return queue.join("");
};
// re-export Token class to use in block rules
$033a2e60c00167e3$var$StateBlock.prototype.Token = $lGPSc;
module.exports = $033a2e60c00167e3$var$StateBlock;

});


parcelRequire.register("cyNW1", function(module, exports) {
/** internal
 * class ParserInline
 *
 * Tokenizes paragraph content.
 **/ "use strict";

var $7QkZh = parcelRequire("7QkZh");












////////////////////////////////////////////////////////////////////////////////
// Parser rules
var $924f6504bef0c2df$var$_rules = [
    [
        "text",
        (parcelRequire("2dhC4"))
    ],
    [
        "linkify",
        (parcelRequire("gVDek"))
    ],
    [
        "newline",
        (parcelRequire("7gABJ"))
    ],
    [
        "escape",
        (parcelRequire("2RZlb"))
    ],
    [
        "backticks",
        (parcelRequire("kAUpT"))
    ],
    [
        "strikethrough",
        (parcelRequire("8nw2s")).tokenize
    ],
    [
        "emphasis",
        (parcelRequire("bq667")).tokenize
    ],
    [
        "link",
        (parcelRequire("6B87x"))
    ],
    [
        "image",
        (parcelRequire("iGKWD"))
    ],
    [
        "autolink",
        (parcelRequire("lOAzZ"))
    ],
    [
        "html_inline",
        (parcelRequire("kzbab"))
    ],
    [
        "entity",
        (parcelRequire("oyioI"))
    ]
];




// `rule2` ruleset was created specifically for emphasis/strikethrough
// post-processing and may be changed in the future.
//
// Don't use this for anything except pairs (plugins working with `balance_pairs`).
//
var $924f6504bef0c2df$var$_rules2 = [
    [
        "balance_pairs",
        (parcelRequire("1FD9r"))
    ],
    [
        "strikethrough",
        (parcelRequire("8nw2s")).postProcess
    ],
    [
        "emphasis",
        (parcelRequire("bq667")).postProcess
    ],
    // rules for pairs separate '**' into its own text tokens, which may be left unused,
    // rule below merges unused segments back with the rest of the text
    [
        "fragments_join",
        (parcelRequire("knxlV"))
    ]
];
/**
 * new ParserInline()
 **/ function $924f6504bef0c2df$var$ParserInline() {
    var i;
    /**
   * ParserInline#ruler -> Ruler
   *
   * [[Ruler]] instance. Keep configuration of inline rules.
   **/ this.ruler = new $7QkZh();
    for(i = 0; i < $924f6504bef0c2df$var$_rules.length; i++)this.ruler.push($924f6504bef0c2df$var$_rules[i][0], $924f6504bef0c2df$var$_rules[i][1]);
    /**
   * ParserInline#ruler2 -> Ruler
   *
   * [[Ruler]] instance. Second ruler used for post-processing
   * (e.g. in emphasis-like rules).
   **/ this.ruler2 = new $7QkZh();
    for(i = 0; i < $924f6504bef0c2df$var$_rules2.length; i++)this.ruler2.push($924f6504bef0c2df$var$_rules2[i][0], $924f6504bef0c2df$var$_rules2[i][1]);
}
// Skip single token by running all rules in validation mode;
// returns `true` if any rule reported success
//
$924f6504bef0c2df$var$ParserInline.prototype.skipToken = function(state) {
    var ok, i, pos = state.pos, rules = this.ruler.getRules(""), len = rules.length, maxNesting = state.md.options.maxNesting, cache = state.cache;
    if (typeof cache[pos] !== "undefined") {
        state.pos = cache[pos];
        return;
    }
    if (state.level < maxNesting) for(i = 0; i < len; i++){
        // Increment state.level and decrement it later to limit recursion.
        // It's harmless to do here, because no tokens are created. But ideally,
        // we'd need a separate private state variable for this purpose.
        //
        state.level++;
        ok = rules[i](state, true);
        state.level--;
        if (ok) break;
    }
    else // Too much nesting, just skip until the end of the paragraph.
    //
    // NOTE: this will cause links to behave incorrectly in the following case,
    //       when an amount of `[` is exactly equal to `maxNesting + 1`:
    //
    //       [[[[[[[[[[[[[[[[[[[[[foo]()
    //
    // TODO: remove this workaround when CM standard will allow nested links
    //       (we can replace it by preventing links from being parsed in
    //       validation mode)
    //
    state.pos = state.posMax;
    if (!ok) state.pos++;
    cache[pos] = state.pos;
};
// Generate tokens for input range
//
$924f6504bef0c2df$var$ParserInline.prototype.tokenize = function(state) {
    var ok, i, rules = this.ruler.getRules(""), len = rules.length, end = state.posMax, maxNesting = state.md.options.maxNesting;
    while(state.pos < end){
        // Try all possible rules.
        // On success, rule should:
        //
        // - update `state.pos`
        // - update `state.tokens`
        // - return true
        if (state.level < maxNesting) for(i = 0; i < len; i++){
            ok = rules[i](state, false);
            if (ok) break;
        }
        if (ok) {
            if (state.pos >= end) break;
            continue;
        }
        state.pending += state.src[state.pos++];
    }
    if (state.pending) state.pushPending();
};
/**
 * ParserInline.parse(str, md, env, outTokens)
 *
 * Process input string and push inline tokens into `outTokens`
 **/ $924f6504bef0c2df$var$ParserInline.prototype.parse = function(str, md, env, outTokens) {
    var i, rules, len;
    var state = new this.State(str, md, env, outTokens);
    this.tokenize(state);
    rules = this.ruler2.getRules("");
    len = rules.length;
    for(i = 0; i < len; i++)rules[i](state);
};

$924f6504bef0c2df$var$ParserInline.prototype.State = (parcelRequire("cSzuq"));
module.exports = $924f6504bef0c2df$var$ParserInline;

});
parcelRequire.register("2dhC4", function(module, exports) {
// Skip text characters for text token, place those to pending buffer
// and increment current pos
"use strict";
// Rule to skip pure text
// '{}$%@~+=:' reserved for extentions
// !, ", #, $, %, &, ', (, ), *, +, ,, -, ., /, :, ;, <, =, >, ?, @, [, \, ], ^, _, `, {, |, }, or ~
// !!!! Don't confuse with "Markdown ASCII Punctuation" chars
// http://spec.commonmark.org/0.15/#ascii-punctuation-character
function $19ca75462d8817a8$var$isTerminatorChar(ch) {
    switch(ch){
        case 0x0A /* \n */ :
        case 0x21 /* ! */ :
        case 0x23 /* # */ :
        case 0x24 /* $ */ :
        case 0x25 /* % */ :
        case 0x26 /* & */ :
        case 0x2A /* * */ :
        case 0x2B /* + */ :
        case 0x2D /* - */ :
        case 0x3A /* : */ :
        case 0x3C /* < */ :
        case 0x3D /* = */ :
        case 0x3E /* > */ :
        case 0x40 /* @ */ :
        case 0x5B /* [ */ :
        case 0x5C /* \ */ :
        case 0x5D /* ] */ :
        case 0x5E /* ^ */ :
        case 0x5F /* _ */ :
        case 0x60 /* ` */ :
        case 0x7B /* { */ :
        case 0x7D /* } */ :
        case 0x7E /* ~ */ :
            return true;
        default:
            return false;
    }
}
module.exports = function text(state, silent) {
    var pos = state.pos;
    while(pos < state.posMax && !$19ca75462d8817a8$var$isTerminatorChar(state.src.charCodeAt(pos)))pos++;
    if (pos === state.pos) return false;
    if (!silent) state.pending += state.src.slice(state.pos, pos);
    state.pos = pos;
    return true;
}; // Alternative implementation, for memory.
 //
 // It costs 10% of performance, but allows extend terminators list, if place it
 // to `ParcerInline` property. Probably, will switch to it sometime, such
 // flexibility required.
 /*
var TERMINATOR_RE = /[\n!#$%&*+\-:<=>@[\\\]^_`{}~]/;

module.exports = function text(state, silent) {
  var pos = state.pos,
      idx = state.src.slice(pos).search(TERMINATOR_RE);

  // first char is terminator -> empty text
  if (idx === 0) { return false; }

  // no terminator -> text till end of string
  if (idx < 0) {
    if (!silent) { state.pending += state.src.slice(pos); }
    state.pos = state.src.length;
    return true;
  }

  if (!silent) { state.pending += state.src.slice(pos, pos + idx); }

  state.pos += idx;

  return true;
};*/ 

});

parcelRequire.register("gVDek", function(module, exports) {
// Process links like https://example.org/
"use strict";
// RFC3986: scheme = ALPHA *( ALPHA / DIGIT / "+" / "-" / "." )
var $c530667e0ccca392$var$SCHEME_RE = /(?:^|[^a-z0-9.+-])([a-z][a-z0-9.+-]*)$/i;
module.exports = function linkify(state, silent) {
    var pos, max, match, proto, link, url, fullUrl, token;
    if (!state.md.options.linkify) return false;
    if (state.linkLevel > 0) return false;
    pos = state.pos;
    max = state.posMax;
    if (pos + 3 > max) return false;
    if (state.src.charCodeAt(pos) !== 0x3A /* : */ ) return false;
    if (state.src.charCodeAt(pos + 1) !== 0x2F /* / */ ) return false;
    if (state.src.charCodeAt(pos + 2) !== 0x2F /* / */ ) return false;
    match = state.pending.match($c530667e0ccca392$var$SCHEME_RE);
    if (!match) return false;
    proto = match[1];
    link = state.md.linkify.matchAtStart(state.src.slice(pos - proto.length));
    if (!link) return false;
    url = link.url;
    // disallow '*' at the end of the link (conflicts with emphasis)
    url = url.replace(/\*+$/, "");
    fullUrl = state.md.normalizeLink(url);
    if (!state.md.validateLink(fullUrl)) return false;
    if (!silent) {
        state.pending = state.pending.slice(0, -proto.length);
        token = state.push("link_open", "a", 1);
        token.attrs = [
            [
                "href",
                fullUrl
            ]
        ];
        token.markup = "linkify";
        token.info = "auto";
        token = state.push("text", "", 0);
        token.content = state.md.normalizeLinkText(url);
        token = state.push("link_close", "a", -1);
        token.markup = "linkify";
        token.info = "auto";
    }
    state.pos += url.length - proto.length;
    return true;
};

});

parcelRequire.register("7gABJ", function(module, exports) {
// Proceess '\n'
"use strict";

var $iXVVQ = parcelRequire("iXVVQ");
var $54a66c87c3956a17$require$isSpace = $iXVVQ.isSpace;
module.exports = function newline(state, silent) {
    var pmax, max, ws, pos = state.pos;
    if (state.src.charCodeAt(pos) !== 0x0A /* \n */ ) return false;
    pmax = state.pending.length - 1;
    max = state.posMax;
    // '  \n' -> hardbreak
    // Lookup in pending chars is bad practice! Don't copy to other rules!
    // Pending string is stored in concat mode, indexed lookups will cause
    // convertion to flat mode.
    if (!silent) {
        if (pmax >= 0 && state.pending.charCodeAt(pmax) === 0x20) {
            if (pmax >= 1 && state.pending.charCodeAt(pmax - 1) === 0x20) {
                // Find whitespaces tail of pending chars.
                ws = pmax - 1;
                while(ws >= 1 && state.pending.charCodeAt(ws - 1) === 0x20)ws--;
                state.pending = state.pending.slice(0, ws);
                state.push("hardbreak", "br", 0);
            } else {
                state.pending = state.pending.slice(0, -1);
                state.push("softbreak", "br", 0);
            }
        } else state.push("softbreak", "br", 0);
    }
    pos++;
    // skip heading spaces for next line
    while(pos < max && $54a66c87c3956a17$require$isSpace(state.src.charCodeAt(pos)))pos++;
    state.pos = pos;
    return true;
};

});

parcelRequire.register("2RZlb", function(module, exports) {
// Process escaped chars and hardbreaks
"use strict";

var $iXVVQ = parcelRequire("iXVVQ");
var $21701cf811741066$require$isSpace = $iXVVQ.isSpace;
var $21701cf811741066$var$ESCAPED = [];
for(var $21701cf811741066$var$i = 0; $21701cf811741066$var$i < 256; $21701cf811741066$var$i++)$21701cf811741066$var$ESCAPED.push(0);
"\\!\"#$%&'()*+,./:;<=>?@[]^_`{|}~-".split("").forEach(function(ch) {
    $21701cf811741066$var$ESCAPED[ch.charCodeAt(0)] = 1;
});
module.exports = function escape(state, silent) {
    var ch1, ch2, origStr, escapedStr, token, pos = state.pos, max = state.posMax;
    if (state.src.charCodeAt(pos) !== 0x5C /* \ */ ) return false;
    pos++;
    // '\' at the end of the inline block
    if (pos >= max) return false;
    ch1 = state.src.charCodeAt(pos);
    if (ch1 === 0x0A) {
        if (!silent) state.push("hardbreak", "br", 0);
        pos++;
        // skip leading whitespaces from next line
        while(pos < max){
            ch1 = state.src.charCodeAt(pos);
            if (!$21701cf811741066$require$isSpace(ch1)) break;
            pos++;
        }
        state.pos = pos;
        return true;
    }
    escapedStr = state.src[pos];
    if (ch1 >= 0xD800 && ch1 <= 0xDBFF && pos + 1 < max) {
        ch2 = state.src.charCodeAt(pos + 1);
        if (ch2 >= 0xDC00 && ch2 <= 0xDFFF) {
            escapedStr += state.src[pos + 1];
            pos++;
        }
    }
    origStr = "\\" + escapedStr;
    if (!silent) {
        token = state.push("text_special", "", 0);
        if (ch1 < 256 && $21701cf811741066$var$ESCAPED[ch1] !== 0) token.content = escapedStr;
        else token.content = origStr;
        token.markup = origStr;
        token.info = "escape";
    }
    state.pos = pos + 1;
    return true;
};

});

parcelRequire.register("kAUpT", function(module, exports) {
// Parse backticks
"use strict";
module.exports = function backtick(state, silent) {
    var start, max, marker, token, matchStart, matchEnd, openerLength, closerLength, pos = state.pos, ch = state.src.charCodeAt(pos);
    if (ch !== 0x60 /* ` */ ) return false;
    start = pos;
    pos++;
    max = state.posMax;
    // scan marker length
    while(pos < max && state.src.charCodeAt(pos) === 0x60 /* ` */ )pos++;
    marker = state.src.slice(start, pos);
    openerLength = marker.length;
    if (state.backticksScanned && (state.backticks[openerLength] || 0) <= start) {
        if (!silent) state.pending += marker;
        state.pos += openerLength;
        return true;
    }
    matchStart = matchEnd = pos;
    // Nothing found in the cache, scan until the end of the line (or until marker is found)
    while((matchStart = state.src.indexOf("`", matchEnd)) !== -1){
        matchEnd = matchStart + 1;
        // scan marker length
        while(matchEnd < max && state.src.charCodeAt(matchEnd) === 0x60 /* ` */ )matchEnd++;
        closerLength = matchEnd - matchStart;
        if (closerLength === openerLength) {
            // Found matching closer length.
            if (!silent) {
                token = state.push("code_inline", "code", 0);
                token.markup = marker;
                token.content = state.src.slice(pos, matchStart).replace(/\n/g, " ").replace(/^ (.+) $/, "$1");
            }
            state.pos = matchEnd;
            return true;
        }
        // Some different length found, put it in cache as upper limit of where closer can be found
        state.backticks[closerLength] = matchStart;
    }
    // Scanned through the end, didn't find anything
    state.backticksScanned = true;
    if (!silent) state.pending += marker;
    state.pos += openerLength;
    return true;
};

});

parcelRequire.register("8nw2s", function(module, exports) {

$parcel$export(module.exports, "tokenize", () => $619952ee044d205a$export$660b2ee2d4fb4eff, (v) => $619952ee044d205a$export$660b2ee2d4fb4eff = v);
$parcel$export(module.exports, "postProcess", () => $619952ee044d205a$export$7b804a0e0ce836d9, (v) => $619952ee044d205a$export$7b804a0e0ce836d9 = v);
// ~~strike through~~
//
// Insert each marker as a separate text token, and add it to delimiter list
//
var $619952ee044d205a$export$660b2ee2d4fb4eff;
// Walk through delimiter list and replace text tokens with tags
//
var $619952ee044d205a$export$7b804a0e0ce836d9;
"use strict";
$619952ee044d205a$export$660b2ee2d4fb4eff = function strikethrough(state, silent) {
    var i, scanned, token, len, ch, start = state.pos, marker = state.src.charCodeAt(start);
    if (silent) return false;
    if (marker !== 0x7E /* ~ */ ) return false;
    scanned = state.scanDelims(state.pos, true);
    len = scanned.length;
    ch = String.fromCharCode(marker);
    if (len < 2) return false;
    if (len % 2) {
        token = state.push("text", "", 0);
        token.content = ch;
        len--;
    }
    for(i = 0; i < len; i += 2){
        token = state.push("text", "", 0);
        token.content = ch + ch;
        state.delimiters.push({
            marker: marker,
            length: 0,
            token: state.tokens.length - 1,
            end: -1,
            open: scanned.can_open,
            close: scanned.can_close
        });
    }
    state.pos += scanned.length;
    return true;
};
function $619952ee044d205a$var$postProcess(state, delimiters) {
    var i, j, startDelim, endDelim, token, loneMarkers = [], max = delimiters.length;
    for(i = 0; i < max; i++){
        startDelim = delimiters[i];
        if (startDelim.marker !== 0x7E /* ~ */ ) continue;
        if (startDelim.end === -1) continue;
        endDelim = delimiters[startDelim.end];
        token = state.tokens[startDelim.token];
        token.type = "s_open";
        token.tag = "s";
        token.nesting = 1;
        token.markup = "~~";
        token.content = "";
        token = state.tokens[endDelim.token];
        token.type = "s_close";
        token.tag = "s";
        token.nesting = -1;
        token.markup = "~~";
        token.content = "";
        if (state.tokens[endDelim.token - 1].type === "text" && state.tokens[endDelim.token - 1].content === "~") loneMarkers.push(endDelim.token - 1);
    }
    // If a marker sequence has an odd number of characters, it's splitted
    // like this: `~~~~~` -> `~` + `~~` + `~~`, leaving one marker at the
    // start of the sequence.
    //
    // So, we have to move all those markers after subsequent s_close tags.
    //
    while(loneMarkers.length){
        i = loneMarkers.pop();
        j = i + 1;
        while(j < state.tokens.length && state.tokens[j].type === "s_close")j++;
        j--;
        if (i !== j) {
            token = state.tokens[j];
            state.tokens[j] = state.tokens[i];
            state.tokens[i] = token;
        }
    }
}
$619952ee044d205a$export$7b804a0e0ce836d9 = function strikethrough(state) {
    var curr, tokens_meta = state.tokens_meta, max = state.tokens_meta.length;
    $619952ee044d205a$var$postProcess(state, state.delimiters);
    for(curr = 0; curr < max; curr++)if (tokens_meta[curr] && tokens_meta[curr].delimiters) $619952ee044d205a$var$postProcess(state, tokens_meta[curr].delimiters);
};

});

parcelRequire.register("bq667", function(module, exports) {

$parcel$export(module.exports, "tokenize", () => $8506da4c6e4186cb$export$660b2ee2d4fb4eff, (v) => $8506da4c6e4186cb$export$660b2ee2d4fb4eff = v);
$parcel$export(module.exports, "postProcess", () => $8506da4c6e4186cb$export$7b804a0e0ce836d9, (v) => $8506da4c6e4186cb$export$7b804a0e0ce836d9 = v);
// Process *this* and _that_
//
// Insert each marker as a separate text token, and add it to delimiter list
//
var $8506da4c6e4186cb$export$660b2ee2d4fb4eff;
// Walk through delimiter list and replace text tokens with tags
//
var $8506da4c6e4186cb$export$7b804a0e0ce836d9;
"use strict";
$8506da4c6e4186cb$export$660b2ee2d4fb4eff = function emphasis(state, silent) {
    var i, scanned, token, start = state.pos, marker = state.src.charCodeAt(start);
    if (silent) return false;
    if (marker !== 0x5F /* _ */  && marker !== 0x2A /* * */ ) return false;
    scanned = state.scanDelims(state.pos, marker === 0x2A);
    for(i = 0; i < scanned.length; i++){
        token = state.push("text", "", 0);
        token.content = String.fromCharCode(marker);
        state.delimiters.push({
            // Char code of the starting marker (number).
            //
            marker: marker,
            // Total length of these series of delimiters.
            //
            length: scanned.length,
            // A position of the token this delimiter corresponds to.
            //
            token: state.tokens.length - 1,
            // If this delimiter is matched as a valid opener, `end` will be
            // equal to its position, otherwise it's `-1`.
            //
            end: -1,
            // Boolean flags that determine if this delimiter could open or close
            // an emphasis.
            //
            open: scanned.can_open,
            close: scanned.can_close
        });
    }
    state.pos += scanned.length;
    return true;
};
function $8506da4c6e4186cb$var$postProcess(state, delimiters) {
    var i, startDelim, endDelim, token, ch, isStrong, max = delimiters.length;
    for(i = max - 1; i >= 0; i--){
        startDelim = delimiters[i];
        if (startDelim.marker !== 0x5F /* _ */  && startDelim.marker !== 0x2A /* * */ ) continue;
        // Process only opening markers
        if (startDelim.end === -1) continue;
        endDelim = delimiters[startDelim.end];
        // If the previous delimiter has the same marker and is adjacent to this one,
        // merge those into one strong delimiter.
        //
        // `<em><em>whatever</em></em>` -> `<strong>whatever</strong>`
        //
        isStrong = i > 0 && delimiters[i - 1].end === startDelim.end + 1 && // check that first two markers match and adjacent
        delimiters[i - 1].marker === startDelim.marker && delimiters[i - 1].token === startDelim.token - 1 && // check that last two markers are adjacent (we can safely assume they match)
        delimiters[startDelim.end + 1].token === endDelim.token + 1;
        ch = String.fromCharCode(startDelim.marker);
        token = state.tokens[startDelim.token];
        token.type = isStrong ? "strong_open" : "em_open";
        token.tag = isStrong ? "strong" : "em";
        token.nesting = 1;
        token.markup = isStrong ? ch + ch : ch;
        token.content = "";
        token = state.tokens[endDelim.token];
        token.type = isStrong ? "strong_close" : "em_close";
        token.tag = isStrong ? "strong" : "em";
        token.nesting = -1;
        token.markup = isStrong ? ch + ch : ch;
        token.content = "";
        if (isStrong) {
            state.tokens[delimiters[i - 1].token].content = "";
            state.tokens[delimiters[startDelim.end + 1].token].content = "";
            i--;
        }
    }
}
$8506da4c6e4186cb$export$7b804a0e0ce836d9 = function emphasis(state) {
    var curr, tokens_meta = state.tokens_meta, max = state.tokens_meta.length;
    $8506da4c6e4186cb$var$postProcess(state, state.delimiters);
    for(curr = 0; curr < max; curr++)if (tokens_meta[curr] && tokens_meta[curr].delimiters) $8506da4c6e4186cb$var$postProcess(state, tokens_meta[curr].delimiters);
};

});

parcelRequire.register("6B87x", function(module, exports) {
// Process [link](<to> "stuff")
"use strict";

var $iXVVQ = parcelRequire("iXVVQ");
var $4cdc7f5dd9c87c9b$require$normalizeReference = $iXVVQ.normalizeReference;

var $iXVVQ = parcelRequire("iXVVQ");
var $4cdc7f5dd9c87c9b$require$isSpace = $iXVVQ.isSpace;
module.exports = function link(state, silent) {
    var attrs, code, label, labelEnd, labelStart, pos, res, ref, token, href = "", title = "", oldPos = state.pos, max = state.posMax, start = state.pos, parseReference = true;
    if (state.src.charCodeAt(state.pos) !== 0x5B /* [ */ ) return false;
    labelStart = state.pos + 1;
    labelEnd = state.md.helpers.parseLinkLabel(state, state.pos, true);
    // parser failed to find ']', so it's not a valid link
    if (labelEnd < 0) return false;
    pos = labelEnd + 1;
    if (pos < max && state.src.charCodeAt(pos) === 0x28 /* ( */ ) {
        //
        // Inline link
        //
        // might have found a valid shortcut link, disable reference parsing
        parseReference = false;
        // [link](  <href>  "title"  )
        //        ^^ skipping these spaces
        pos++;
        for(; pos < max; pos++){
            code = state.src.charCodeAt(pos);
            if (!$4cdc7f5dd9c87c9b$require$isSpace(code) && code !== 0x0A) break;
        }
        if (pos >= max) return false;
        // [link](  <href>  "title"  )
        //          ^^^^^^ parsing link destination
        start = pos;
        res = state.md.helpers.parseLinkDestination(state.src, pos, state.posMax);
        if (res.ok) {
            href = state.md.normalizeLink(res.str);
            if (state.md.validateLink(href)) pos = res.pos;
            else href = "";
            // [link](  <href>  "title"  )
            //                ^^ skipping these spaces
            start = pos;
            for(; pos < max; pos++){
                code = state.src.charCodeAt(pos);
                if (!$4cdc7f5dd9c87c9b$require$isSpace(code) && code !== 0x0A) break;
            }
            // [link](  <href>  "title"  )
            //                  ^^^^^^^ parsing link title
            res = state.md.helpers.parseLinkTitle(state.src, pos, state.posMax);
            if (pos < max && start !== pos && res.ok) {
                title = res.str;
                pos = res.pos;
                // [link](  <href>  "title"  )
                //                         ^^ skipping these spaces
                for(; pos < max; pos++){
                    code = state.src.charCodeAt(pos);
                    if (!$4cdc7f5dd9c87c9b$require$isSpace(code) && code !== 0x0A) break;
                }
            }
        }
        if (pos >= max || state.src.charCodeAt(pos) !== 0x29 /* ) */ ) // parsing a valid shortcut link failed, fallback to reference
        parseReference = true;
        pos++;
    }
    if (parseReference) {
        //
        // Link reference
        //
        if (typeof state.env.references === "undefined") return false;
        if (pos < max && state.src.charCodeAt(pos) === 0x5B /* [ */ ) {
            start = pos + 1;
            pos = state.md.helpers.parseLinkLabel(state, pos);
            if (pos >= 0) label = state.src.slice(start, pos++);
            else pos = labelEnd + 1;
        } else pos = labelEnd + 1;
        // covers label === '' and label === undefined
        // (collapsed reference link and shortcut reference link respectively)
        if (!label) label = state.src.slice(labelStart, labelEnd);
        ref = state.env.references[$4cdc7f5dd9c87c9b$require$normalizeReference(label)];
        if (!ref) {
            state.pos = oldPos;
            return false;
        }
        href = ref.href;
        title = ref.title;
    }
    //
    // We found the end of the link, and know for a fact it's a valid link;
    // so all that's left to do is to call tokenizer.
    //
    if (!silent) {
        state.pos = labelStart;
        state.posMax = labelEnd;
        token = state.push("link_open", "a", 1);
        token.attrs = attrs = [
            [
                "href",
                href
            ]
        ];
        if (title) attrs.push([
            "title",
            title
        ]);
        state.linkLevel++;
        state.md.inline.tokenize(state);
        state.linkLevel--;
        token = state.push("link_close", "a", -1);
    }
    state.pos = pos;
    state.posMax = max;
    return true;
};

});

parcelRequire.register("iGKWD", function(module, exports) {
// Process ![image](<src> "title")
"use strict";

var $iXVVQ = parcelRequire("iXVVQ");
var $d9b09080b856e3df$require$normalizeReference = $iXVVQ.normalizeReference;

var $iXVVQ = parcelRequire("iXVVQ");
var $d9b09080b856e3df$require$isSpace = $iXVVQ.isSpace;
module.exports = function image(state, silent) {
    var attrs, code, content, label, labelEnd, labelStart, pos, ref, res, title, token, tokens, start, href = "", oldPos = state.pos, max = state.posMax;
    if (state.src.charCodeAt(state.pos) !== 0x21 /* ! */ ) return false;
    if (state.src.charCodeAt(state.pos + 1) !== 0x5B /* [ */ ) return false;
    labelStart = state.pos + 2;
    labelEnd = state.md.helpers.parseLinkLabel(state, state.pos + 1, false);
    // parser failed to find ']', so it's not a valid link
    if (labelEnd < 0) return false;
    pos = labelEnd + 1;
    if (pos < max && state.src.charCodeAt(pos) === 0x28 /* ( */ ) {
        //
        // Inline link
        //
        // [link](  <href>  "title"  )
        //        ^^ skipping these spaces
        pos++;
        for(; pos < max; pos++){
            code = state.src.charCodeAt(pos);
            if (!$d9b09080b856e3df$require$isSpace(code) && code !== 0x0A) break;
        }
        if (pos >= max) return false;
        // [link](  <href>  "title"  )
        //          ^^^^^^ parsing link destination
        start = pos;
        res = state.md.helpers.parseLinkDestination(state.src, pos, state.posMax);
        if (res.ok) {
            href = state.md.normalizeLink(res.str);
            if (state.md.validateLink(href)) pos = res.pos;
            else href = "";
        }
        // [link](  <href>  "title"  )
        //                ^^ skipping these spaces
        start = pos;
        for(; pos < max; pos++){
            code = state.src.charCodeAt(pos);
            if (!$d9b09080b856e3df$require$isSpace(code) && code !== 0x0A) break;
        }
        // [link](  <href>  "title"  )
        //                  ^^^^^^^ parsing link title
        res = state.md.helpers.parseLinkTitle(state.src, pos, state.posMax);
        if (pos < max && start !== pos && res.ok) {
            title = res.str;
            pos = res.pos;
            // [link](  <href>  "title"  )
            //                         ^^ skipping these spaces
            for(; pos < max; pos++){
                code = state.src.charCodeAt(pos);
                if (!$d9b09080b856e3df$require$isSpace(code) && code !== 0x0A) break;
            }
        } else title = "";
        if (pos >= max || state.src.charCodeAt(pos) !== 0x29 /* ) */ ) {
            state.pos = oldPos;
            return false;
        }
        pos++;
    } else {
        //
        // Link reference
        //
        if (typeof state.env.references === "undefined") return false;
        if (pos < max && state.src.charCodeAt(pos) === 0x5B /* [ */ ) {
            start = pos + 1;
            pos = state.md.helpers.parseLinkLabel(state, pos);
            if (pos >= 0) label = state.src.slice(start, pos++);
            else pos = labelEnd + 1;
        } else pos = labelEnd + 1;
        // covers label === '' and label === undefined
        // (collapsed reference link and shortcut reference link respectively)
        if (!label) label = state.src.slice(labelStart, labelEnd);
        ref = state.env.references[$d9b09080b856e3df$require$normalizeReference(label)];
        if (!ref) {
            state.pos = oldPos;
            return false;
        }
        href = ref.href;
        title = ref.title;
    }
    //
    // We found the end of the link, and know for a fact it's a valid link;
    // so all that's left to do is to call tokenizer.
    //
    if (!silent) {
        content = state.src.slice(labelStart, labelEnd);
        state.md.inline.parse(content, state.md, state.env, tokens = []);
        token = state.push("image", "img", 0);
        token.attrs = attrs = [
            [
                "src",
                href
            ],
            [
                "alt",
                ""
            ]
        ];
        token.children = tokens;
        token.content = content;
        if (title) attrs.push([
            "title",
            title
        ]);
    }
    state.pos = pos;
    state.posMax = max;
    return true;
};

});

parcelRequire.register("lOAzZ", function(module, exports) {
// Process autolinks '<protocol:...>'
"use strict";
/*eslint max-len:0*/ var $fe1aa46c8fa176f3$var$EMAIL_RE = /^([a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*)$/;
var $fe1aa46c8fa176f3$var$AUTOLINK_RE = /^([a-zA-Z][a-zA-Z0-9+.\-]{1,31}):([^<>\x00-\x20]*)$/;
module.exports = function autolink(state, silent) {
    var url, fullUrl, token, ch, start, max, pos = state.pos;
    if (state.src.charCodeAt(pos) !== 0x3C /* < */ ) return false;
    start = state.pos;
    max = state.posMax;
    for(;;){
        if (++pos >= max) return false;
        ch = state.src.charCodeAt(pos);
        if (ch === 0x3C /* < */ ) return false;
        if (ch === 0x3E /* > */ ) break;
    }
    url = state.src.slice(start + 1, pos);
    if ($fe1aa46c8fa176f3$var$AUTOLINK_RE.test(url)) {
        fullUrl = state.md.normalizeLink(url);
        if (!state.md.validateLink(fullUrl)) return false;
        if (!silent) {
            token = state.push("link_open", "a", 1);
            token.attrs = [
                [
                    "href",
                    fullUrl
                ]
            ];
            token.markup = "autolink";
            token.info = "auto";
            token = state.push("text", "", 0);
            token.content = state.md.normalizeLinkText(url);
            token = state.push("link_close", "a", -1);
            token.markup = "autolink";
            token.info = "auto";
        }
        state.pos += url.length + 2;
        return true;
    }
    if ($fe1aa46c8fa176f3$var$EMAIL_RE.test(url)) {
        fullUrl = state.md.normalizeLink("mailto:" + url);
        if (!state.md.validateLink(fullUrl)) return false;
        if (!silent) {
            token = state.push("link_open", "a", 1);
            token.attrs = [
                [
                    "href",
                    fullUrl
                ]
            ];
            token.markup = "autolink";
            token.info = "auto";
            token = state.push("text", "", 0);
            token.content = state.md.normalizeLinkText(url);
            token = state.push("link_close", "a", -1);
            token.markup = "autolink";
            token.info = "auto";
        }
        state.pos += url.length + 2;
        return true;
    }
    return false;
};

});

parcelRequire.register("kzbab", function(module, exports) {
// Process html tags
"use strict";

var $khGdz = parcelRequire("khGdz");
var $ef8fbc53cd7e9c5a$require$HTML_TAG_RE = $khGdz.HTML_TAG_RE;
function $ef8fbc53cd7e9c5a$var$isLinkOpen(str) {
    return /^<a[>\s]/i.test(str);
}
function $ef8fbc53cd7e9c5a$var$isLinkClose(str) {
    return /^<\/a\s*>/i.test(str);
}
function $ef8fbc53cd7e9c5a$var$isLetter(ch) {
    /*eslint no-bitwise:0*/ var lc = ch | 0x20; // to lower case
    return lc >= 0x61 /* a */  && lc <= 0x7a /* z */ ;
}
module.exports = function html_inline(state, silent) {
    var ch, match, max, token, pos = state.pos;
    if (!state.md.options.html) return false;
    // Check start
    max = state.posMax;
    if (state.src.charCodeAt(pos) !== 0x3C /* < */  || pos + 2 >= max) return false;
    // Quick fail on second char
    ch = state.src.charCodeAt(pos + 1);
    if (ch !== 0x21 /* ! */  && ch !== 0x3F /* ? */  && ch !== 0x2F /* / */  && !$ef8fbc53cd7e9c5a$var$isLetter(ch)) return false;
    match = state.src.slice(pos).match($ef8fbc53cd7e9c5a$require$HTML_TAG_RE);
    if (!match) return false;
    if (!silent) {
        token = state.push("html_inline", "", 0);
        token.content = state.src.slice(pos, pos + match[0].length);
        if ($ef8fbc53cd7e9c5a$var$isLinkOpen(token.content)) state.linkLevel++;
        if ($ef8fbc53cd7e9c5a$var$isLinkClose(token.content)) state.linkLevel--;
    }
    state.pos += match[0].length;
    return true;
};

});

parcelRequire.register("oyioI", function(module, exports) {
// Process html entity - &#123;, &#xAF;, &quot;, ...
"use strict";

var $hNNPq = parcelRequire("hNNPq");

var $iXVVQ = parcelRequire("iXVVQ");
var $049cd86c96219865$require$has = $iXVVQ.has;

var $iXVVQ = parcelRequire("iXVVQ");
var $049cd86c96219865$require$isValidEntityCode = $iXVVQ.isValidEntityCode;

var $iXVVQ = parcelRequire("iXVVQ");
var $049cd86c96219865$require$fromCodePoint = $iXVVQ.fromCodePoint;
var $049cd86c96219865$var$DIGITAL_RE = /^&#((?:x[a-f0-9]{1,6}|[0-9]{1,7}));/i;
var $049cd86c96219865$var$NAMED_RE = /^&([a-z][a-z0-9]{1,31});/i;
module.exports = function entity(state, silent) {
    var ch, code, match, token, pos = state.pos, max = state.posMax;
    if (state.src.charCodeAt(pos) !== 0x26 /* & */ ) return false;
    if (pos + 1 >= max) return false;
    ch = state.src.charCodeAt(pos + 1);
    if (ch === 0x23 /* # */ ) {
        match = state.src.slice(pos).match($049cd86c96219865$var$DIGITAL_RE);
        if (match) {
            if (!silent) {
                code = match[1][0].toLowerCase() === "x" ? parseInt(match[1].slice(1), 16) : parseInt(match[1], 10);
                token = state.push("text_special", "", 0);
                token.content = $049cd86c96219865$require$isValidEntityCode(code) ? $049cd86c96219865$require$fromCodePoint(code) : $049cd86c96219865$require$fromCodePoint(0xFFFD);
                token.markup = match[0];
                token.info = "entity";
            }
            state.pos += match[0].length;
            return true;
        }
    } else {
        match = state.src.slice(pos).match($049cd86c96219865$var$NAMED_RE);
        if (match) {
            if ($049cd86c96219865$require$has($hNNPq, match[1])) {
                if (!silent) {
                    token = state.push("text_special", "", 0);
                    token.content = $hNNPq[match[1]];
                    token.markup = match[0];
                    token.info = "entity";
                }
                state.pos += match[0].length;
                return true;
            }
        }
    }
    return false;
};

});

parcelRequire.register("1FD9r", function(module, exports) {
// For each opening emphasis-like marker find a matching closing one
//
"use strict";
function $1377fd68099c125d$var$processDelimiters(state, delimiters) {
    var closerIdx, openerIdx, closer, opener, minOpenerIdx, newMinOpenerIdx, isOddMatch, lastJump, openersBottom = {}, max = delimiters.length;
    if (!max) return;
    // headerIdx is the first delimiter of the current (where closer is) delimiter run
    var headerIdx = 0;
    var lastTokenIdx = -2; // needs any value lower than -1
    var jumps = [];
    for(closerIdx = 0; closerIdx < max; closerIdx++){
        closer = delimiters[closerIdx];
        jumps.push(0);
        // markers belong to same delimiter run if:
        //  - they have adjacent tokens
        //  - AND markers are the same
        //
        if (delimiters[headerIdx].marker !== closer.marker || lastTokenIdx !== closer.token - 1) headerIdx = closerIdx;
        lastTokenIdx = closer.token;
        // Length is only used for emphasis-specific "rule of 3",
        // if it's not defined (in strikethrough or 3rd party plugins),
        // we can default it to 0 to disable those checks.
        //
        closer.length = closer.length || 0;
        if (!closer.close) continue;
        // Previously calculated lower bounds (previous fails)
        // for each marker, each delimiter length modulo 3,
        // and for whether this closer can be an opener;
        // https://github.com/commonmark/cmark/commit/34250e12ccebdc6372b8b49c44fab57c72443460
        if (!openersBottom.hasOwnProperty(closer.marker)) openersBottom[closer.marker] = [
            -1,
            -1,
            -1,
            -1,
            -1,
            -1
        ];
        minOpenerIdx = openersBottom[closer.marker][(closer.open ? 3 : 0) + closer.length % 3];
        openerIdx = headerIdx - jumps[headerIdx] - 1;
        newMinOpenerIdx = openerIdx;
        for(; openerIdx > minOpenerIdx; openerIdx -= jumps[openerIdx] + 1){
            opener = delimiters[openerIdx];
            if (opener.marker !== closer.marker) continue;
            if (opener.open && opener.end < 0) {
                isOddMatch = false;
                // from spec:
                //
                // If one of the delimiters can both open and close emphasis, then the
                // sum of the lengths of the delimiter runs containing the opening and
                // closing delimiters must not be a multiple of 3 unless both lengths
                // are multiples of 3.
                //
                if (opener.close || closer.open) {
                    if ((opener.length + closer.length) % 3 === 0) {
                        if (opener.length % 3 !== 0 || closer.length % 3 !== 0) isOddMatch = true;
                    }
                }
                if (!isOddMatch) {
                    // If previous delimiter cannot be an opener, we can safely skip
                    // the entire sequence in future checks. This is required to make
                    // sure algorithm has linear complexity (see *_*_*_*_*_... case).
                    //
                    lastJump = openerIdx > 0 && !delimiters[openerIdx - 1].open ? jumps[openerIdx - 1] + 1 : 0;
                    jumps[closerIdx] = closerIdx - openerIdx + lastJump;
                    jumps[openerIdx] = lastJump;
                    closer.open = false;
                    opener.end = closerIdx;
                    opener.close = false;
                    newMinOpenerIdx = -1;
                    // treat next token as start of run,
                    // it optimizes skips in **<...>**a**<...>** pathological case
                    lastTokenIdx = -2;
                    break;
                }
            }
        }
        if (newMinOpenerIdx !== -1) // If match for this delimiter run failed, we want to set lower bound for
        // future lookups. This is required to make sure algorithm has linear
        // complexity.
        //
        // See details here:
        // https://github.com/commonmark/cmark/issues/178#issuecomment-270417442
        //
        openersBottom[closer.marker][(closer.open ? 3 : 0) + (closer.length || 0) % 3] = newMinOpenerIdx;
    }
}
module.exports = function link_pairs(state) {
    var curr, tokens_meta = state.tokens_meta, max = state.tokens_meta.length;
    $1377fd68099c125d$var$processDelimiters(state, state.delimiters);
    for(curr = 0; curr < max; curr++)if (tokens_meta[curr] && tokens_meta[curr].delimiters) $1377fd68099c125d$var$processDelimiters(state, tokens_meta[curr].delimiters);
};

});

parcelRequire.register("knxlV", function(module, exports) {
// Clean up tokens after emphasis and strikethrough postprocessing:
// merge adjacent text nodes into one and re-calculate all token levels
//
// This is necessary because initially emphasis delimiter markers (*, _, ~)
// are treated as their own separate text tokens. Then emphasis rule either
// leaves them as text (needed to merge with adjacent text) or turns them
// into opening/closing tags (which messes up levels inside).
//
"use strict";
module.exports = function fragments_join(state) {
    var curr, last, level = 0, tokens = state.tokens, max = state.tokens.length;
    for(curr = last = 0; curr < max; curr++){
        // re-calculate levels after emphasis/strikethrough turns some text nodes
        // into opening/closing tags
        if (tokens[curr].nesting < 0) level--; // closing tag
        tokens[curr].level = level;
        if (tokens[curr].nesting > 0) level++; // opening tag
        if (tokens[curr].type === "text" && curr + 1 < max && tokens[curr + 1].type === "text") // collapse two adjacent text nodes
        tokens[curr + 1].content = tokens[curr].content + tokens[curr + 1].content;
        else {
            if (curr !== last) tokens[last] = tokens[curr];
            last++;
        }
    }
    if (curr !== last) tokens.length = last;
};

});

parcelRequire.register("cSzuq", function(module, exports) {
// Inline parser state
"use strict";

var $lGPSc = parcelRequire("lGPSc");

var $iXVVQ = parcelRequire("iXVVQ");
var $96060eb0e278cdc6$require$isWhiteSpace = $iXVVQ.isWhiteSpace;

var $iXVVQ = parcelRequire("iXVVQ");
var $96060eb0e278cdc6$require$isPunctChar = $iXVVQ.isPunctChar;

var $iXVVQ = parcelRequire("iXVVQ");
var $96060eb0e278cdc6$require$isMdAsciiPunct = $iXVVQ.isMdAsciiPunct;
function $96060eb0e278cdc6$var$StateInline(src, md, env, outTokens) {
    this.src = src;
    this.env = env;
    this.md = md;
    this.tokens = outTokens;
    this.tokens_meta = Array(outTokens.length);
    this.pos = 0;
    this.posMax = this.src.length;
    this.level = 0;
    this.pending = "";
    this.pendingLevel = 0;
    // Stores { start: end } pairs. Useful for backtrack
    // optimization of pairs parse (emphasis, strikes).
    this.cache = {};
    // List of emphasis-like delimiters for current tag
    this.delimiters = [];
    // Stack of delimiter lists for upper level tags
    this._prev_delimiters = [];
    // backtick length => last seen position
    this.backticks = {};
    this.backticksScanned = false;
    // Counter used to disable inline linkify-it execution
    // inside <a> and markdown links
    this.linkLevel = 0;
}
// Flush pending text
//
$96060eb0e278cdc6$var$StateInline.prototype.pushPending = function() {
    var token = new $lGPSc("text", "", 0);
    token.content = this.pending;
    token.level = this.pendingLevel;
    this.tokens.push(token);
    this.pending = "";
    return token;
};
// Push new token to "stream".
// If pending text exists - flush it as text token
//
$96060eb0e278cdc6$var$StateInline.prototype.push = function(type, tag, nesting) {
    if (this.pending) this.pushPending();
    var token = new $lGPSc(type, tag, nesting);
    var token_meta = null;
    if (nesting < 0) {
        // closing tag
        this.level--;
        this.delimiters = this._prev_delimiters.pop();
    }
    token.level = this.level;
    if (nesting > 0) {
        // opening tag
        this.level++;
        this._prev_delimiters.push(this.delimiters);
        this.delimiters = [];
        token_meta = {
            delimiters: this.delimiters
        };
    }
    this.pendingLevel = this.level;
    this.tokens.push(token);
    this.tokens_meta.push(token_meta);
    return token;
};
// Scan a sequence of emphasis-like markers, and determine whether
// it can start an emphasis sequence or end an emphasis sequence.
//
//  - start - position to scan from (it should point at a valid marker);
//  - canSplitWord - determine if these markers can be found inside a word
//
$96060eb0e278cdc6$var$StateInline.prototype.scanDelims = function(start, canSplitWord) {
    var pos = start, lastChar, nextChar, count, can_open, can_close, isLastWhiteSpace, isLastPunctChar, isNextWhiteSpace, isNextPunctChar, left_flanking = true, right_flanking = true, max = this.posMax, marker = this.src.charCodeAt(start);
    // treat beginning of the line as a whitespace
    lastChar = start > 0 ? this.src.charCodeAt(start - 1) : 0x20;
    while(pos < max && this.src.charCodeAt(pos) === marker)pos++;
    count = pos - start;
    // treat end of the line as a whitespace
    nextChar = pos < max ? this.src.charCodeAt(pos) : 0x20;
    isLastPunctChar = $96060eb0e278cdc6$require$isMdAsciiPunct(lastChar) || $96060eb0e278cdc6$require$isPunctChar(String.fromCharCode(lastChar));
    isNextPunctChar = $96060eb0e278cdc6$require$isMdAsciiPunct(nextChar) || $96060eb0e278cdc6$require$isPunctChar(String.fromCharCode(nextChar));
    isLastWhiteSpace = $96060eb0e278cdc6$require$isWhiteSpace(lastChar);
    isNextWhiteSpace = $96060eb0e278cdc6$require$isWhiteSpace(nextChar);
    if (isNextWhiteSpace) left_flanking = false;
    else if (isNextPunctChar) {
        if (!(isLastWhiteSpace || isLastPunctChar)) left_flanking = false;
    }
    if (isLastWhiteSpace) right_flanking = false;
    else if (isLastPunctChar) {
        if (!(isNextWhiteSpace || isNextPunctChar)) right_flanking = false;
    }
    if (!canSplitWord) {
        can_open = left_flanking && (!right_flanking || isLastPunctChar);
        can_close = right_flanking && (!left_flanking || isNextPunctChar);
    } else {
        can_open = left_flanking;
        can_close = right_flanking;
    }
    return {
        can_open: can_open,
        can_close: can_close,
        length: count
    };
};
// re-export Token class to use in block rules
$96060eb0e278cdc6$var$StateInline.prototype.Token = $lGPSc;
module.exports = $96060eb0e278cdc6$var$StateInline;

});


parcelRequire.register("jAtt2", function(module, exports) {
"use strict";
////////////////////////////////////////////////////////////////////////////////
// Helpers
// Merge objects
//
function $e4283cbbe9968e9c$var$assign(obj /*from1, from2, from3, ...*/ ) {
    var sources = Array.prototype.slice.call(arguments, 1);
    sources.forEach(function(source) {
        if (!source) return;
        Object.keys(source).forEach(function(key) {
            obj[key] = source[key];
        });
    });
    return obj;
}
function $e4283cbbe9968e9c$var$_class(obj) {
    return Object.prototype.toString.call(obj);
}
function $e4283cbbe9968e9c$var$isString(obj) {
    return $e4283cbbe9968e9c$var$_class(obj) === "[object String]";
}
function $e4283cbbe9968e9c$var$isObject(obj) {
    return $e4283cbbe9968e9c$var$_class(obj) === "[object Object]";
}
function $e4283cbbe9968e9c$var$isRegExp(obj) {
    return $e4283cbbe9968e9c$var$_class(obj) === "[object RegExp]";
}
function $e4283cbbe9968e9c$var$isFunction(obj) {
    return $e4283cbbe9968e9c$var$_class(obj) === "[object Function]";
}
function $e4283cbbe9968e9c$var$escapeRE(str) {
    return str.replace(/[.?*+^$[\]\\(){}|-]/g, "\\$&");
}
////////////////////////////////////////////////////////////////////////////////
var $e4283cbbe9968e9c$var$defaultOptions = {
    fuzzyLink: true,
    fuzzyEmail: true,
    fuzzyIP: false
};
function $e4283cbbe9968e9c$var$isOptionsObj(obj) {
    return Object.keys(obj || {}).reduce(function(acc, k) {
        return acc || $e4283cbbe9968e9c$var$defaultOptions.hasOwnProperty(k);
    }, false);
}
var $e4283cbbe9968e9c$var$defaultSchemas = {
    "http:": {
        validate: function(text, pos, self) {
            var tail = text.slice(pos);
            if (!self.re.http) // compile lazily, because "host"-containing variables can change on tlds update.
            self.re.http = new RegExp("^\\/\\/" + self.re.src_auth + self.re.src_host_port_strict + self.re.src_path, "i");
            if (self.re.http.test(tail)) return tail.match(self.re.http)[0].length;
            return 0;
        }
    },
    "https:": "http:",
    "ftp:": "http:",
    "//": {
        validate: function(text, pos, self) {
            var tail = text.slice(pos);
            if (!self.re.no_http) // compile lazily, because "host"-containing variables can change on tlds update.
            self.re.no_http = new RegExp("^" + self.re.src_auth + // Don't allow single-level domains, because of false positives like '//test'
            // with code comments
            "(?:localhost|(?:(?:" + self.re.src_domain + ")\\.)+" + self.re.src_domain_root + ")" + self.re.src_port + self.re.src_host_terminator + self.re.src_path, "i");
            if (self.re.no_http.test(tail)) {
                // should not be `://` & `///`, that protects from errors in protocol name
                if (pos >= 3 && text[pos - 3] === ":") return 0;
                if (pos >= 3 && text[pos - 3] === "/") return 0;
                return tail.match(self.re.no_http)[0].length;
            }
            return 0;
        }
    },
    "mailto:": {
        validate: function(text, pos, self) {
            var tail = text.slice(pos);
            if (!self.re.mailto) self.re.mailto = new RegExp("^" + self.re.src_email_name + "@" + self.re.src_host_strict, "i");
            if (self.re.mailto.test(tail)) return tail.match(self.re.mailto)[0].length;
            return 0;
        }
    }
};
/*eslint-disable max-len*/ // RE pattern for 2-character tlds (autogenerated by ./support/tlds_2char_gen.js)
var $e4283cbbe9968e9c$var$tlds_2ch_src_re = "a[cdefgilmnoqrstuwxz]|b[abdefghijmnorstvwyz]|c[acdfghiklmnoruvwxyz]|d[ejkmoz]|e[cegrstu]|f[ijkmor]|g[abdefghilmnpqrstuwy]|h[kmnrtu]|i[delmnoqrst]|j[emop]|k[eghimnprwyz]|l[abcikrstuvy]|m[acdeghklmnopqrstuvwxyz]|n[acefgilopruz]|om|p[aefghklmnrstwy]|qa|r[eosuw]|s[abcdeghijklmnortuvxyz]|t[cdfghjklmnortvwz]|u[agksyz]|v[aceginu]|w[fs]|y[et]|z[amw]";
// DON'T try to make PRs with changes. Extend TLDs with LinkifyIt.tlds() instead
var $e4283cbbe9968e9c$var$tlds_default = "biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|рф".split("|");
/*eslint-enable max-len*/ ////////////////////////////////////////////////////////////////////////////////
function $e4283cbbe9968e9c$var$resetScanCache(self) {
    self.__index__ = -1;
    self.__text_cache__ = "";
}
function $e4283cbbe9968e9c$var$createValidator(re) {
    return function(text, pos) {
        var tail = text.slice(pos);
        if (re.test(tail)) return tail.match(re)[0].length;
        return 0;
    };
}
function $e4283cbbe9968e9c$var$createNormalizer() {
    return function(match, self) {
        self.normalize(match);
    };
}

// Schemas compiler. Build regexps.
//
function $e4283cbbe9968e9c$var$compile(self) {
    // Load & clone RE patterns.
    var re = self.re = (parcelRequire("3foo6"))(self.__opts__);
    // Define dynamic patterns
    var tlds = self.__tlds__.slice();
    self.onCompile();
    if (!self.__tlds_replaced__) tlds.push($e4283cbbe9968e9c$var$tlds_2ch_src_re);
    tlds.push(re.src_xn);
    re.src_tlds = tlds.join("|");
    function untpl(tpl) {
        return tpl.replace("%TLDS%", re.src_tlds);
    }
    re.email_fuzzy = RegExp(untpl(re.tpl_email_fuzzy), "i");
    re.link_fuzzy = RegExp(untpl(re.tpl_link_fuzzy), "i");
    re.link_no_ip_fuzzy = RegExp(untpl(re.tpl_link_no_ip_fuzzy), "i");
    re.host_fuzzy_test = RegExp(untpl(re.tpl_host_fuzzy_test), "i");
    //
    // Compile each schema
    //
    var aliases = [];
    self.__compiled__ = {}; // Reset compiled data
    function schemaError(name, val) {
        throw new Error('(LinkifyIt) Invalid schema "' + name + '": ' + val);
    }
    Object.keys(self.__schemas__).forEach(function(name) {
        var val = self.__schemas__[name];
        // skip disabled methods
        if (val === null) return;
        var compiled = {
            validate: null,
            link: null
        };
        self.__compiled__[name] = compiled;
        if ($e4283cbbe9968e9c$var$isObject(val)) {
            if ($e4283cbbe9968e9c$var$isRegExp(val.validate)) compiled.validate = $e4283cbbe9968e9c$var$createValidator(val.validate);
            else if ($e4283cbbe9968e9c$var$isFunction(val.validate)) compiled.validate = val.validate;
            else schemaError(name, val);
            if ($e4283cbbe9968e9c$var$isFunction(val.normalize)) compiled.normalize = val.normalize;
            else if (!val.normalize) compiled.normalize = $e4283cbbe9968e9c$var$createNormalizer();
            else schemaError(name, val);
            return;
        }
        if ($e4283cbbe9968e9c$var$isString(val)) {
            aliases.push(name);
            return;
        }
        schemaError(name, val);
    });
    //
    // Compile postponed aliases
    //
    aliases.forEach(function(alias) {
        if (!self.__compiled__[self.__schemas__[alias]]) // Silently fail on missed schemas to avoid errons on disable.
        // schemaError(alias, self.__schemas__[alias]);
        return;
        self.__compiled__[alias].validate = self.__compiled__[self.__schemas__[alias]].validate;
        self.__compiled__[alias].normalize = self.__compiled__[self.__schemas__[alias]].normalize;
    });
    //
    // Fake record for guessed links
    //
    self.__compiled__[""] = {
        validate: null,
        normalize: $e4283cbbe9968e9c$var$createNormalizer()
    };
    //
    // Build schema condition
    //
    var slist = Object.keys(self.__compiled__).filter(function(name) {
        // Filter disabled & fake schemas
        return name.length > 0 && self.__compiled__[name];
    }).map($e4283cbbe9968e9c$var$escapeRE).join("|");
    // (?!_) cause 1.5x slowdown
    self.re.schema_test = RegExp("(^|(?!_)(?:[><｜]|" + re.src_ZPCc + "))(" + slist + ")", "i");
    self.re.schema_search = RegExp("(^|(?!_)(?:[><｜]|" + re.src_ZPCc + "))(" + slist + ")", "ig");
    self.re.schema_at_start = RegExp("^" + self.re.schema_search.source, "i");
    self.re.pretest = RegExp("(" + self.re.schema_test.source + ")|(" + self.re.host_fuzzy_test.source + ")|@", "i");
    //
    // Cleanup
    //
    $e4283cbbe9968e9c$var$resetScanCache(self);
}
/**
 * class Match
 *
 * Match result. Single element of array, returned by [[LinkifyIt#match]]
 **/ function $e4283cbbe9968e9c$var$Match(self, shift) {
    var start = self.__index__, end = self.__last_index__, text = self.__text_cache__.slice(start, end);
    /**
   * Match#schema -> String
   *
   * Prefix (protocol) for matched string.
   **/ this.schema = self.__schema__.toLowerCase();
    /**
   * Match#index -> Number
   *
   * First position of matched string.
   **/ this.index = start + shift;
    /**
   * Match#lastIndex -> Number
   *
   * Next position after matched string.
   **/ this.lastIndex = end + shift;
    /**
   * Match#raw -> String
   *
   * Matched string.
   **/ this.raw = text;
    /**
   * Match#text -> String
   *
   * Notmalized text of matched string.
   **/ this.text = text;
    /**
   * Match#url -> String
   *
   * Normalized url of matched string.
   **/ this.url = text;
}
function $e4283cbbe9968e9c$var$createMatch(self, shift) {
    var match = new $e4283cbbe9968e9c$var$Match(self, shift);
    self.__compiled__[match.schema].normalize(match, self);
    return match;
}
/**
 * class LinkifyIt
 **/ /**
 * new LinkifyIt(schemas, options)
 * - schemas (Object): Optional. Additional schemas to validate (prefix/validator)
 * - options (Object): { fuzzyLink|fuzzyEmail|fuzzyIP: true|false }
 *
 * Creates new linkifier instance with optional additional schemas.
 * Can be called without `new` keyword for convenience.
 *
 * By default understands:
 *
 * - `http(s)://...` , `ftp://...`, `mailto:...` & `//...` links
 * - "fuzzy" links and emails (example.com, foo@bar.com).
 *
 * `schemas` is an object, where each key/value describes protocol/rule:
 *
 * - __key__ - link prefix (usually, protocol name with `:` at the end, `skype:`
 *   for example). `linkify-it` makes shure that prefix is not preceeded with
 *   alphanumeric char and symbols. Only whitespaces and punctuation allowed.
 * - __value__ - rule to check tail after link prefix
 *   - _String_ - just alias to existing rule
 *   - _Object_
 *     - _validate_ - validator function (should return matched length on success),
 *       or `RegExp`.
 *     - _normalize_ - optional function to normalize text & url of matched result
 *       (for example, for @twitter mentions).
 *
 * `options`:
 *
 * - __fuzzyLink__ - recognige URL-s without `http(s):` prefix. Default `true`.
 * - __fuzzyIP__ - allow IPs in fuzzy links above. Can conflict with some texts
 *   like version numbers. Default `false`.
 * - __fuzzyEmail__ - recognize emails without `mailto:` prefix.
 *
 **/ function $e4283cbbe9968e9c$var$LinkifyIt(schemas, options) {
    if (!(this instanceof $e4283cbbe9968e9c$var$LinkifyIt)) return new $e4283cbbe9968e9c$var$LinkifyIt(schemas, options);
    if (!options) {
        if ($e4283cbbe9968e9c$var$isOptionsObj(schemas)) {
            options = schemas;
            schemas = {};
        }
    }
    this.__opts__ = $e4283cbbe9968e9c$var$assign({}, $e4283cbbe9968e9c$var$defaultOptions, options);
    // Cache last tested result. Used to skip repeating steps on next `match` call.
    this.__index__ = -1;
    this.__last_index__ = -1; // Next scan position
    this.__schema__ = "";
    this.__text_cache__ = "";
    this.__schemas__ = $e4283cbbe9968e9c$var$assign({}, $e4283cbbe9968e9c$var$defaultSchemas, schemas);
    this.__compiled__ = {};
    this.__tlds__ = $e4283cbbe9968e9c$var$tlds_default;
    this.__tlds_replaced__ = false;
    this.re = {};
    $e4283cbbe9968e9c$var$compile(this);
}
/** chainable
 * LinkifyIt#add(schema, definition)
 * - schema (String): rule name (fixed pattern prefix)
 * - definition (String|RegExp|Object): schema definition
 *
 * Add new rule definition. See constructor description for details.
 **/ $e4283cbbe9968e9c$var$LinkifyIt.prototype.add = function add(schema, definition) {
    this.__schemas__[schema] = definition;
    $e4283cbbe9968e9c$var$compile(this);
    return this;
};
/** chainable
 * LinkifyIt#set(options)
 * - options (Object): { fuzzyLink|fuzzyEmail|fuzzyIP: true|false }
 *
 * Set recognition options for links without schema.
 **/ $e4283cbbe9968e9c$var$LinkifyIt.prototype.set = function set(options) {
    this.__opts__ = $e4283cbbe9968e9c$var$assign(this.__opts__, options);
    return this;
};
/**
 * LinkifyIt#test(text) -> Boolean
 *
 * Searches linkifiable pattern and returns `true` on success or `false` on fail.
 **/ $e4283cbbe9968e9c$var$LinkifyIt.prototype.test = function test(text) {
    // Reset scan cache
    this.__text_cache__ = text;
    this.__index__ = -1;
    if (!text.length) return false;
    var m, ml, me, len, shift, next, re, tld_pos, at_pos;
    // try to scan for link with schema - that's the most simple rule
    if (this.re.schema_test.test(text)) {
        re = this.re.schema_search;
        re.lastIndex = 0;
        while((m = re.exec(text)) !== null){
            len = this.testSchemaAt(text, m[2], re.lastIndex);
            if (len) {
                this.__schema__ = m[2];
                this.__index__ = m.index + m[1].length;
                this.__last_index__ = m.index + m[0].length + len;
                break;
            }
        }
    }
    if (this.__opts__.fuzzyLink && this.__compiled__["http:"]) {
        // guess schemaless links
        tld_pos = text.search(this.re.host_fuzzy_test);
        if (tld_pos >= 0) {
            // if tld is located after found link - no need to check fuzzy pattern
            if (this.__index__ < 0 || tld_pos < this.__index__) {
                if ((ml = text.match(this.__opts__.fuzzyIP ? this.re.link_fuzzy : this.re.link_no_ip_fuzzy)) !== null) {
                    shift = ml.index + ml[1].length;
                    if (this.__index__ < 0 || shift < this.__index__) {
                        this.__schema__ = "";
                        this.__index__ = shift;
                        this.__last_index__ = ml.index + ml[0].length;
                    }
                }
            }
        }
    }
    if (this.__opts__.fuzzyEmail && this.__compiled__["mailto:"]) {
        // guess schemaless emails
        at_pos = text.indexOf("@");
        if (at_pos >= 0) // We can't skip this check, because this cases are possible:
        // 192.168.1.1@gmail.com, my.in@example.com
        {
            if ((me = text.match(this.re.email_fuzzy)) !== null) {
                shift = me.index + me[1].length;
                next = me.index + me[0].length;
                if (this.__index__ < 0 || shift < this.__index__ || shift === this.__index__ && next > this.__last_index__) {
                    this.__schema__ = "mailto:";
                    this.__index__ = shift;
                    this.__last_index__ = next;
                }
            }
        }
    }
    return this.__index__ >= 0;
};
/**
 * LinkifyIt#pretest(text) -> Boolean
 *
 * Very quick check, that can give false positives. Returns true if link MAY BE
 * can exists. Can be used for speed optimization, when you need to check that
 * link NOT exists.
 **/ $e4283cbbe9968e9c$var$LinkifyIt.prototype.pretest = function pretest(text) {
    return this.re.pretest.test(text);
};
/**
 * LinkifyIt#testSchemaAt(text, name, position) -> Number
 * - text (String): text to scan
 * - name (String): rule (schema) name
 * - position (Number): text offset to check from
 *
 * Similar to [[LinkifyIt#test]] but checks only specific protocol tail exactly
 * at given position. Returns length of found pattern (0 on fail).
 **/ $e4283cbbe9968e9c$var$LinkifyIt.prototype.testSchemaAt = function testSchemaAt(text, schema, pos) {
    // If not supported schema check requested - terminate
    if (!this.__compiled__[schema.toLowerCase()]) return 0;
    return this.__compiled__[schema.toLowerCase()].validate(text, pos, this);
};
/**
 * LinkifyIt#match(text) -> Array|null
 *
 * Returns array of found link descriptions or `null` on fail. We strongly
 * recommend to use [[LinkifyIt#test]] first, for best speed.
 *
 * ##### Result match description
 *
 * - __schema__ - link schema, can be empty for fuzzy links, or `//` for
 *   protocol-neutral  links.
 * - __index__ - offset of matched text
 * - __lastIndex__ - index of next char after mathch end
 * - __raw__ - matched text
 * - __text__ - normalized text
 * - __url__ - link, generated from matched text
 **/ $e4283cbbe9968e9c$var$LinkifyIt.prototype.match = function match(text) {
    var shift = 0, result = [];
    // Try to take previous element from cache, if .test() called before
    if (this.__index__ >= 0 && this.__text_cache__ === text) {
        result.push($e4283cbbe9968e9c$var$createMatch(this, shift));
        shift = this.__last_index__;
    }
    // Cut head if cache was used
    var tail = shift ? text.slice(shift) : text;
    // Scan string until end reached
    while(this.test(tail)){
        result.push($e4283cbbe9968e9c$var$createMatch(this, shift));
        tail = tail.slice(this.__last_index__);
        shift += this.__last_index__;
    }
    if (result.length) return result;
    return null;
};
/**
 * LinkifyIt#matchAtStart(text) -> Match|null
 *
 * Returns fully-formed (not fuzzy) link if it starts at the beginning
 * of the string, and null otherwise.
 **/ $e4283cbbe9968e9c$var$LinkifyIt.prototype.matchAtStart = function matchAtStart(text) {
    // Reset scan cache
    this.__text_cache__ = text;
    this.__index__ = -1;
    if (!text.length) return null;
    var m = this.re.schema_at_start.exec(text);
    if (!m) return null;
    var len = this.testSchemaAt(text, m[2], m[0].length);
    if (!len) return null;
    this.__schema__ = m[2];
    this.__index__ = m.index + m[1].length;
    this.__last_index__ = m.index + m[0].length + len;
    return $e4283cbbe9968e9c$var$createMatch(this, 0);
};
/** chainable
 * LinkifyIt#tlds(list [, keepOld]) -> this
 * - list (Array): list of tlds
 * - keepOld (Boolean): merge with current list if `true` (`false` by default)
 *
 * Load (or merge) new tlds list. Those are user for fuzzy links (without prefix)
 * to avoid false positives. By default this algorythm used:
 *
 * - hostname with any 2-letter root zones are ok.
 * - biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|рф
 *   are ok.
 * - encoded (`xn--...`) root zones are ok.
 *
 * If list is replaced, then exact match for 2-chars root zones will be checked.
 **/ $e4283cbbe9968e9c$var$LinkifyIt.prototype.tlds = function tlds(list, keepOld) {
    list = Array.isArray(list) ? list : [
        list
    ];
    if (!keepOld) {
        this.__tlds__ = list.slice();
        this.__tlds_replaced__ = true;
        $e4283cbbe9968e9c$var$compile(this);
        return this;
    }
    this.__tlds__ = this.__tlds__.concat(list).sort().filter(function(el, idx, arr) {
        return el !== arr[idx - 1];
    }).reverse();
    $e4283cbbe9968e9c$var$compile(this);
    return this;
};
/**
 * LinkifyIt#normalize(match)
 *
 * Default normalizer (if schema does not define it's own).
 **/ $e4283cbbe9968e9c$var$LinkifyIt.prototype.normalize = function normalize(match) {
    // Do minimal possible changes by default. Need to collect feedback prior
    // to move forward https://github.com/markdown-it/linkify-it/issues/1
    if (!match.schema) match.url = "http://" + match.url;
    if (match.schema === "mailto:" && !/^mailto:/i.test(match.url)) match.url = "mailto:" + match.url;
};
/**
 * LinkifyIt#onCompile()
 *
 * Override to modify basic RegExp-s.
 **/ $e4283cbbe9968e9c$var$LinkifyIt.prototype.onCompile = function onCompile() {};
module.exports = $e4283cbbe9968e9c$var$LinkifyIt;

});
parcelRequire.register("3foo6", function(module, exports) {
"use strict";




module.exports = function(opts) {
    var re = {};
    opts = opts || {};
    // Use direct extract instead of `regenerate` to reduse browserified size
    re.src_Any = (parcelRequire("73OXq")).source;
    re.src_Cc = (parcelRequire("c7ys3")).source;
    re.src_Z = (parcelRequire("kWxtK")).source;
    re.src_P = (parcelRequire("7X6km")).source;
    // \p{\Z\P\Cc\CF} (white spaces + control + format + punctuation)
    re.src_ZPCc = [
        re.src_Z,
        re.src_P,
        re.src_Cc
    ].join("|");
    // \p{\Z\Cc} (white spaces + control)
    re.src_ZCc = [
        re.src_Z,
        re.src_Cc
    ].join("|");
    // Experimental. List of chars, completely prohibited in links
    // because can separate it from other part of text
    var text_separators = "[><｜]";
    // All possible word characters (everything without punctuation, spaces & controls)
    // Defined via punctuation & spaces to save space
    // Should be something like \p{\L\N\S\M} (\w but without `_`)
    re.src_pseudo_letter = "(?:(?!" + text_separators + "|" + re.src_ZPCc + ")" + re.src_Any + ")";
    // The same as abothe but without [0-9]
    // var src_pseudo_letter_non_d = '(?:(?![0-9]|' + src_ZPCc + ')' + src_Any + ')';
    ////////////////////////////////////////////////////////////////////////////////
    re.src_ip4 = "(?:(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.){3}(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)";
    // Prohibit any of "@/[]()" in user/pass to avoid wrong domain fetch.
    re.src_auth = "(?:(?:(?!" + re.src_ZCc + "|[@/\\[\\]()]).)+@)?";
    re.src_port = "(?::(?:6(?:[0-4]\\d{3}|5(?:[0-4]\\d{2}|5(?:[0-2]\\d|3[0-5])))|[1-5]?\\d{1,4}))?";
    re.src_host_terminator = "(?=$|" + text_separators + "|" + re.src_ZPCc + ")" + "(?!" + (opts["---"] ? "-(?!--)|" : "-|") + "_|:\\d|\\.-|\\.(?!$|" + re.src_ZPCc + "))";
    re.src_path = "(?:[/?#](?:(?!" + re.src_ZCc + "|" + text_separators + "|[()[\\]{}.,\"'?!\\-;]).|" + "\\[(?:(?!" + re.src_ZCc + "|\\]).)*\\]|" + "\\((?:(?!" + re.src_ZCc + "|[)]).)*\\)|" + "\\{(?:(?!" + re.src_ZCc + "|[}]).)*\\}|" + '\\"(?:(?!' + re.src_ZCc + '|["]).)+\\"|' + "\\'(?:(?!" + re.src_ZCc + "|[']).)+\\'|" + "\\'(?=" + re.src_pseudo_letter + "|[-])|" + // allow `I'm_king` if no pair found
    "\\.{2,}[a-zA-Z0-9%/&]|" + // google has many dots in "google search" links (#66, #81).
    // github has ... in commit range links,
    // Restrict to
    // - english
    // - percent-encoded
    // - parts of file path
    // - params separator
    // until more examples found.
    "\\.(?!" + re.src_ZCc + "|[.]|$)|" + (opts["---"] ? "\\-(?!--(?:[^-]|$))(?:-*)|" // `---` => long dash, terminate
     : "\\-+|") + ",(?!" + re.src_ZCc + "|$)|" + // allow `,,,` in paths
    ";(?!" + re.src_ZCc + "|$)|" + // allow `;` if not followed by space-like char
    "\\!+(?!" + re.src_ZCc + "|[!]|$)|" + // allow `!!!` in paths, but not at the end
    "\\?(?!" + re.src_ZCc + "|[?]|$)" + ")+" + "|\\/" + ")?";
    // Allow anything in markdown spec, forbid quote (") at the first position
    // because emails enclosed in quotes are far more common
    re.src_email_name = '[\\-;:&=\\+\\$,\\.a-zA-Z0-9_][\\-;:&=\\+\\$,\\"\\.a-zA-Z0-9_]*';
    re.src_xn = "xn--[a-z0-9\\-]{1,59}";
    // More to read about domain names
    // http://serverfault.com/questions/638260/
    re.src_domain_root = // Allow letters & digits (http://test1)
    "(?:" + re.src_xn + "|" + re.src_pseudo_letter + "{1,63}" + ")";
    re.src_domain = "(?:" + re.src_xn + "|" + "(?:" + re.src_pseudo_letter + ")" + "|" + "(?:" + re.src_pseudo_letter + "(?:-|" + re.src_pseudo_letter + "){0,61}" + re.src_pseudo_letter + ")" + ")";
    re.src_host = "(?:(?:(?:(?:" + re.src_domain + ")\\.)*" + re.src_domain /*_root*/  + ")" + ")";
    re.tpl_host_fuzzy = "(?:" + re.src_ip4 + "|" + "(?:(?:(?:" + re.src_domain + ")\\.)+(?:%TLDS%))" + ")";
    re.tpl_host_no_ip_fuzzy = "(?:(?:(?:" + re.src_domain + ")\\.)+(?:%TLDS%))";
    re.src_host_strict = re.src_host + re.src_host_terminator;
    re.tpl_host_fuzzy_strict = re.tpl_host_fuzzy + re.src_host_terminator;
    re.src_host_port_strict = re.src_host + re.src_port + re.src_host_terminator;
    re.tpl_host_port_fuzzy_strict = re.tpl_host_fuzzy + re.src_port + re.src_host_terminator;
    re.tpl_host_port_no_ip_fuzzy_strict = re.tpl_host_no_ip_fuzzy + re.src_port + re.src_host_terminator;
    ////////////////////////////////////////////////////////////////////////////////
    // Main rules
    // Rude test fuzzy links by host, for quick deny
    re.tpl_host_fuzzy_test = "localhost|www\\.|\\.\\d{1,3}\\.|(?:\\.(?:%TLDS%)(?:" + re.src_ZPCc + "|>|$))";
    re.tpl_email_fuzzy = "(^|" + text_separators + '|"|\\(|' + re.src_ZCc + ")" + "(" + re.src_email_name + "@" + re.tpl_host_fuzzy_strict + ")";
    re.tpl_link_fuzzy = // Fuzzy link can't be prepended with .:/\- and non punctuation.
    // but can start with > (markdown blockquote)
    "(^|(?![.:/\\-_@])(?:[$+<=>^`|｜]|" + re.src_ZPCc + "))" + "((?![$+<=>^`|｜])" + re.tpl_host_port_fuzzy_strict + re.src_path + ")";
    re.tpl_link_no_ip_fuzzy = // Fuzzy link can't be prepended with .:/\- and non punctuation.
    // but can start with > (markdown blockquote)
    "(^|(?![.:/\\-_@])(?:[$+<=>^`|｜]|" + re.src_ZPCc + "))" + "((?![$+<=>^`|｜])" + re.tpl_host_port_no_ip_fuzzy_strict + re.src_path + ")";
    return re;
};

});


parcelRequire.register("4ixx2", function(module, exports) {
// markdown-it default options
"use strict";
module.exports = {
    options: {
        html: false,
        xhtmlOut: false,
        breaks: false,
        langPrefix: "language-",
        linkify: false,
        // Enable some language-neutral replacements + quotes beautification
        typographer: false,
        // Double + single quotes replacement pairs, when typographer enabled,
        // and smartquotes on. Could be either a String or an Array.
        //
        // For example, you can use '«»„“' for Russian, '„“‚‘' for German,
        // and ['«\xA0', '\xA0»', '‹\xA0', '\xA0›'] for French (including nbsp).
        quotes: "“”‘’",
        /* “”‘’ */ // Highlighter function. Should return escaped HTML,
        // or '' if the source string is not changed and should be escaped externaly.
        // If result starts with <pre... internal wrapper is skipped.
        //
        // function (/*str, lang*/) { return ''; }
        //
        highlight: null,
        maxNesting: 100 // Internal protection, recursion limit
    },
    components: {
        core: {},
        block: {},
        inline: {}
    }
};

});

parcelRequire.register("3LBk3", function(module, exports) {
// "Zero" preset, with nothing enabled. Useful for manual configuring of simple
// modes. For example, to parse bold/italic only.
"use strict";
module.exports = {
    options: {
        html: false,
        xhtmlOut: false,
        breaks: false,
        langPrefix: "language-",
        linkify: false,
        // Enable some language-neutral replacements + quotes beautification
        typographer: false,
        // Double + single quotes replacement pairs, when typographer enabled,
        // and smartquotes on. Could be either a String or an Array.
        //
        // For example, you can use '«»„“' for Russian, '„“‚‘' for German,
        // and ['«\xA0', '\xA0»', '‹\xA0', '\xA0›'] for French (including nbsp).
        quotes: "“”‘’",
        /* “”‘’ */ // Highlighter function. Should return escaped HTML,
        // or '' if the source string is not changed and should be escaped externaly.
        // If result starts with <pre... internal wrapper is skipped.
        //
        // function (/*str, lang*/) { return ''; }
        //
        highlight: null,
        maxNesting: 20 // Internal protection, recursion limit
    },
    components: {
        core: {
            rules: [
                "normalize",
                "block",
                "inline",
                "text_join"
            ]
        },
        block: {
            rules: [
                "paragraph"
            ]
        },
        inline: {
            rules: [
                "text"
            ],
            rules2: [
                "balance_pairs",
                "fragments_join"
            ]
        }
    }
};

});

parcelRequire.register("bJcaQ", function(module, exports) {
// Commonmark default options
"use strict";
module.exports = {
    options: {
        html: true,
        xhtmlOut: true,
        breaks: false,
        langPrefix: "language-",
        linkify: false,
        // Enable some language-neutral replacements + quotes beautification
        typographer: false,
        // Double + single quotes replacement pairs, when typographer enabled,
        // and smartquotes on. Could be either a String or an Array.
        //
        // For example, you can use '«»„“' for Russian, '„“‚‘' for German,
        // and ['«\xA0', '\xA0»', '‹\xA0', '\xA0›'] for French (including nbsp).
        quotes: "“”‘’",
        /* “”‘’ */ // Highlighter function. Should return escaped HTML,
        // or '' if the source string is not changed and should be escaped externaly.
        // If result starts with <pre... internal wrapper is skipped.
        //
        // function (/*str, lang*/) { return ''; }
        //
        highlight: null,
        maxNesting: 20 // Internal protection, recursion limit
    },
    components: {
        core: {
            rules: [
                "normalize",
                "block",
                "inline",
                "text_join"
            ]
        },
        block: {
            rules: [
                "blockquote",
                "code",
                "fence",
                "heading",
                "hr",
                "html_block",
                "lheading",
                "list",
                "reference",
                "paragraph"
            ]
        },
        inline: {
            rules: [
                "autolink",
                "backticks",
                "emphasis",
                "entity",
                "escape",
                "html_inline",
                "image",
                "link",
                "newline",
                "text"
            ],
            rules2: [
                "balance_pairs",
                "emphasis",
                "fragments_join"
            ]
        }
    }
};

});



parcelRequire.register("i3LEX", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $91faf4f36deea9e4$export$2e2bcd8739ae039);

var $juDH3 = parcelRequire("juDH3");

var $hBFcN = parcelRequire("hBFcN");

var $7f1eV = parcelRequire("7f1eV");

var $bzi9N = parcelRequire("bzi9N");

var $8JKeG = parcelRequire("8JKeG");

var $35Nb0 = parcelRequire("35Nb0");

var $6EVuG = parcelRequire("6EVuG");

var $h2Hd3 = parcelRequire("h2Hd3");

var $gSduy = parcelRequire("gSduy");

var $1d9Z2 = parcelRequire("1d9Z2");

var $8hNpw = parcelRequire("8hNpw");

var $3yVMU = parcelRequire("3yVMU");

var $13zC8 = parcelRequire("13zC8");

var $57aaW = parcelRequire("57aaW");

var $c7fZ0 = parcelRequire("c7fZ0");

var $iPwyO = parcelRequire("iPwyO");

var $77Z8P = parcelRequire("77Z8P");
var $91faf4f36deea9e4$var$__create = (0, (/*@__PURE__*/$parcel$interopDefault($7f1eV)));
var $91faf4f36deea9e4$var$__defProp = (0, (/*@__PURE__*/$parcel$interopDefault($bzi9N)));
var $91faf4f36deea9e4$var$__getOwnPropDesc = (0, (/*@__PURE__*/$parcel$interopDefault($8JKeG)));
var $91faf4f36deea9e4$var$__getOwnPropNames = (0, (/*@__PURE__*/$parcel$interopDefault($35Nb0)));
var $91faf4f36deea9e4$var$__getProtoOf = (0, (/*@__PURE__*/$parcel$interopDefault($6EVuG)));
var $91faf4f36deea9e4$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $91faf4f36deea9e4$var$__commonJS = function __commonJS(cb, mod) {
    return function __require() {
        return mod || (0, cb[$91faf4f36deea9e4$var$__getOwnPropNames(cb)[0]])((mod = {
            exports: {}
        }).exports, mod), mod.exports;
    };
};
var $91faf4f36deea9e4$var$__copyProps = function __copyProps(to, from, except, desc) {
    if (from && (0, (/*@__PURE__*/$parcel$interopDefault($hBFcN)))(from) === "object" || typeof from === "function") {
        var _iterator = (0, (/*@__PURE__*/$parcel$interopDefault($juDH3)))($91faf4f36deea9e4$var$__getOwnPropNames(from)), _step;
        try {
            var _loop = function _loop() {
                var key = _step.value;
                if (!$91faf4f36deea9e4$var$__hasOwnProp.call(to, key) && key !== except) $91faf4f36deea9e4$var$__defProp(to, key, {
                    get: function get() {
                        return from[key];
                    },
                    enumerable: !(desc = $91faf4f36deea9e4$var$__getOwnPropDesc(from, key)) || desc.enumerable
                });
            };
            for(_iterator.s(); !(_step = _iterator.n()).done;)_loop();
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
    }
    return to;
};
var $91faf4f36deea9e4$var$__toESM = function __toESM(mod, isNodeMode, target) {
    return target = mod != null ? $91faf4f36deea9e4$var$__create($91faf4f36deea9e4$var$__getProtoOf(mod)) : {}, $91faf4f36deea9e4$var$__copyProps(isNodeMode || !mod || !mod.__esModule ? $91faf4f36deea9e4$var$__defProp(target, "default", {
        value: mod,
        enumerable: true
    }) : target, mod);
};
// ../markdown-it-attrs/utils.js
var $91faf4f36deea9e4$var$require_utils = $91faf4f36deea9e4$var$__commonJS({
    "../markdown-it-attrs/utils.js": function markdownItAttrsUtilsJs(exports) {
        exports.getAttrs = function(str, start, options) {
            var allowedKeyChars = /[^\t\n\f />"'=]/;
            var pairSeparator = " ";
            var keySeparator = "=";
            var classChar = ".";
            var idChar = "#";
            var attrs = [];
            var key = "";
            var value = "";
            var parsingKey = true;
            var valueInsideQuotes = false;
            for(var i = start + options.leftDelimiter.length; i < str.length; i++){
                if ((0, (/*@__PURE__*/$parcel$interopDefault($h2Hd3)))(str).call(str, i, i + options.rightDelimiter.length) === options.rightDelimiter) {
                    if (key !== "") attrs.push([
                        key,
                        value
                    ]);
                    break;
                }
                var char_ = str.charAt(i);
                if (char_ === keySeparator && parsingKey) {
                    parsingKey = false;
                    continue;
                }
                if (char_ === classChar && key === "") {
                    if (str.charAt(i + 1) === classChar) {
                        key = "css-module";
                        i += 1;
                    } else key = "class";
                    parsingKey = false;
                    continue;
                }
                if (char_ === idChar && key === "") {
                    key = "id";
                    parsingKey = false;
                    continue;
                }
                if (char_ === '"' && value === "" && !valueInsideQuotes) {
                    valueInsideQuotes = true;
                    continue;
                }
                if (char_ === '"' && valueInsideQuotes) {
                    valueInsideQuotes = false;
                    continue;
                }
                if (char_ === pairSeparator && !valueInsideQuotes) {
                    if (key === "") continue;
                    attrs.push([
                        key,
                        value
                    ]);
                    key = "";
                    value = "";
                    parsingKey = true;
                    continue;
                }
                if (parsingKey && char_.search(allowedKeyChars) === -1) continue;
                if (parsingKey) {
                    key += char_;
                    continue;
                }
                value += char_;
            }
            if (options.allowedAttributes && options.allowedAttributes.length) {
                var allowedAttributes = options.allowedAttributes;
                return (0, (/*@__PURE__*/$parcel$interopDefault($gSduy)))(attrs).call(attrs, function(attrPair) {
                    var attr = attrPair[0];
                    function isAllowedAttribute(allowedAttribute) {
                        return attr === allowedAttribute || allowedAttribute instanceof RegExp && allowedAttribute.test(attr);
                    }
                    return (0, (/*@__PURE__*/$parcel$interopDefault($1d9Z2)))(allowedAttributes).call(allowedAttributes, isAllowedAttribute);
                });
            }
            return attrs;
        };
        exports.addAttrs = function(attrs, token) {
            for(var j = 0, l = attrs.length; j < l; ++j){
                var key = attrs[j][0];
                if (key === "class") token.attrJoin("class", attrs[j][1]);
                else if (key === "css-module") token.attrJoin("css-module", attrs[j][1]);
                else token.attrPush(attrs[j]);
            }
            return token;
        };
        exports.hasDelimiters = function(where, options) {
            if (!where) throw new Error('Parameter `where` not passed. Should be "start", "end" or "only".');
            return function(str) {
                var _context;
                var minCurlyLength = options.leftDelimiter.length + 1 + options.rightDelimiter.length;
                if (!str || typeof str !== "string" || str.length < minCurlyLength) return false;
                function validCurlyLength(curly) {
                    var isClass = curly.charAt(options.leftDelimiter.length) === ".";
                    var isId = curly.charAt(options.leftDelimiter.length) === "#";
                    return isClass || isId ? curly.length >= minCurlyLength + 1 : curly.length >= minCurlyLength;
                }
                var start, end, slice, nextChar;
                var rightDelimiterMinimumShift = minCurlyLength - options.rightDelimiter.length;
                switch(where){
                    case "start":
                        slice = (0, (/*@__PURE__*/$parcel$interopDefault($h2Hd3)))(str).call(str, 0, options.leftDelimiter.length);
                        start = slice === options.leftDelimiter ? 0 : -1;
                        end = start === -1 ? -1 : (0, (/*@__PURE__*/$parcel$interopDefault($8hNpw)))(str).call(str, options.rightDelimiter, rightDelimiterMinimumShift);
                        nextChar = str.charAt(end + options.rightDelimiter.length);
                        if (nextChar && (0, (/*@__PURE__*/$parcel$interopDefault($8hNpw)))(_context = options.rightDelimiter).call(_context, nextChar) !== -1) end = -1;
                        break;
                    case "end":
                        start = (0, (/*@__PURE__*/$parcel$interopDefault($3yVMU)))(str).call(str, options.leftDelimiter);
                        end = start === -1 ? -1 : (0, (/*@__PURE__*/$parcel$interopDefault($8hNpw)))(str).call(str, options.rightDelimiter, start + rightDelimiterMinimumShift);
                        end = end === str.length - options.rightDelimiter.length ? end : -1;
                        break;
                    case "only":
                        slice = (0, (/*@__PURE__*/$parcel$interopDefault($h2Hd3)))(str).call(str, 0, options.leftDelimiter.length);
                        start = slice === options.leftDelimiter ? 0 : -1;
                        slice = (0, (/*@__PURE__*/$parcel$interopDefault($h2Hd3)))(str).call(str, str.length - options.rightDelimiter.length);
                        end = slice === options.rightDelimiter ? str.length - options.rightDelimiter.length : -1;
                        break;
                    default:
                        throw new Error("Unexpected case ".concat(where, ", expected 'start', 'end' or 'only'"));
                }
                return start !== -1 && end !== -1 && validCurlyLength(str.substring(start, end + options.rightDelimiter.length));
            };
        };
        exports.removeDelimiter = function(str, options) {
            var start = escapeRegExp(options.leftDelimiter);
            var end = escapeRegExp(options.rightDelimiter);
            var curly = new RegExp("[ \\n]?" + start + "[^" + start + end + "]+" + end + "$");
            var pos = str.search(curly);
            return pos !== -1 ? (0, (/*@__PURE__*/$parcel$interopDefault($h2Hd3)))(str).call(str, 0, pos) : str;
        };
        function escapeRegExp(s) {
            return s.replace(/[-/\\^$*+?.()|[\]{}]/g, "\\$&");
        }
        exports.escapeRegExp = escapeRegExp;
        exports.getMatchingOpeningToken = function(tokens, i) {
            if (tokens[i].type === "softbreak") return false;
            if (tokens[i].nesting === 0) return tokens[i];
            var level = tokens[i].level;
            var type = tokens[i].type.replace("_close", "_open");
            for(; i >= 0; --i){
                if (tokens[i].type === type && tokens[i].level === level) return tokens[i];
            }
            return false;
        };
        var HTML_ESCAPE_TEST_RE = /[&<>"]/;
        var HTML_ESCAPE_REPLACE_RE = /[&<>"]/g;
        var HTML_REPLACEMENTS = {
            "&": "&amp;",
            "<": "&lt;",
            ">": "&gt;",
            '"': "&quot;"
        };
        function replaceUnsafeChar(ch) {
            return HTML_REPLACEMENTS[ch];
        }
        exports.escapeHtml = function(str) {
            if (HTML_ESCAPE_TEST_RE.test(str)) return str.replace(HTML_ESCAPE_REPLACE_RE, replaceUnsafeChar);
            return str;
        };
    }
});
// ../markdown-it-attrs/patterns.js
var $91faf4f36deea9e4$var$require_patterns = $91faf4f36deea9e4$var$__commonJS({
    "../markdown-it-attrs/patterns.js": function markdownItAttrsPatternsJs(exports, module) {
        "use strict";
        var utils = $91faf4f36deea9e4$var$require_utils();
        module.exports = function(options) {
            var __hr = new RegExp("^ {0,3}[-*_]{3,} ?" + utils.escapeRegExp(options.leftDelimiter) + "[^" + utils.escapeRegExp(options.rightDelimiter) + "]");
            return [
                {
                    name: "fenced code blocks",
                    tests: [
                        {
                            shift: 0,
                            block: true,
                            info: utils.hasDelimiters("end", options)
                        }
                    ],
                    transform: function transform(tokens, i) {
                        var _context2;
                        var token = tokens[i];
                        var start = (0, (/*@__PURE__*/$parcel$interopDefault($3yVMU)))(_context2 = token.info).call(_context2, options.leftDelimiter);
                        var attrs = utils.getAttrs(token.info, start, options);
                        utils.addAttrs(attrs, token);
                        token.info = utils.removeDelimiter(token.info, options);
                    }
                },
                {
                    name: "inline nesting 0",
                    tests: [
                        {
                            shift: 0,
                            type: "inline",
                            children: [
                                {
                                    shift: -1,
                                    type: function type(str) {
                                        return str === "image" || str === "code_inline";
                                    }
                                },
                                {
                                    shift: 0,
                                    type: "text",
                                    content: utils.hasDelimiters("start", options)
                                }
                            ]
                        }
                    ],
                    transform: function transform(tokens, i, j) {
                        var _context3;
                        var token = tokens[i].children[j];
                        var endChar = (0, (/*@__PURE__*/$parcel$interopDefault($8hNpw)))(_context3 = token.content).call(_context3, options.rightDelimiter);
                        var attrToken = tokens[i].children[j - 1];
                        var attrs = utils.getAttrs(token.content, 0, options);
                        utils.addAttrs(attrs, attrToken);
                        if (token.content.length === endChar + options.rightDelimiter.length) {
                            var _context4;
                            (0, (/*@__PURE__*/$parcel$interopDefault($13zC8)))(_context4 = tokens[i].children).call(_context4, j, 1);
                        } else {
                            var _context5;
                            token.content = (0, (/*@__PURE__*/$parcel$interopDefault($h2Hd3)))(_context5 = token.content).call(_context5, endChar + options.rightDelimiter.length);
                        }
                    }
                },
                {
                    name: "tables",
                    tests: [
                        {
                            shift: 0,
                            type: "table_close"
                        },
                        {
                            shift: 1,
                            type: "paragraph_open"
                        },
                        {
                            shift: 2,
                            type: "inline",
                            content: utils.hasDelimiters("only", options)
                        }
                    ],
                    transform: function transform(tokens, i) {
                        var token = tokens[i + 2];
                        var tableOpen = utils.getMatchingOpeningToken(tokens, i);
                        var attrs = utils.getAttrs(token.content, 0, options);
                        utils.addAttrs(attrs, tableOpen);
                        (0, (/*@__PURE__*/$parcel$interopDefault($13zC8)))(tokens).call(tokens, i + 1, 3);
                    }
                },
                {
                    name: "inline attributes",
                    tests: [
                        {
                            shift: 0,
                            type: "inline",
                            children: [
                                {
                                    shift: -1,
                                    nesting: -1
                                },
                                {
                                    shift: 0,
                                    type: "text",
                                    content: utils.hasDelimiters("start", options)
                                }
                            ]
                        }
                    ],
                    transform: function transform(tokens, i, j) {
                        var token = tokens[i].children[j];
                        var content = token.content;
                        var attrs = utils.getAttrs(content, 0, options);
                        var openingToken = utils.getMatchingOpeningToken(tokens[i].children, j - 1);
                        utils.addAttrs(attrs, openingToken);
                        token.content = (0, (/*@__PURE__*/$parcel$interopDefault($h2Hd3)))(content).call(content, (0, (/*@__PURE__*/$parcel$interopDefault($8hNpw)))(content).call(content, options.rightDelimiter) + options.rightDelimiter.length);
                    }
                },
                {
                    name: "list softbreak",
                    tests: [
                        {
                            shift: -2,
                            type: "list_item_open"
                        },
                        {
                            shift: 0,
                            type: "inline",
                            children: [
                                {
                                    position: -2,
                                    type: "softbreak"
                                },
                                {
                                    position: -1,
                                    type: "text",
                                    content: utils.hasDelimiters("only", options)
                                }
                            ]
                        }
                    ],
                    transform: function transform(tokens, i, j) {
                        var _context6;
                        var token = tokens[i].children[j];
                        var content = token.content;
                        var attrs = utils.getAttrs(content, 0, options);
                        var ii = i - 2;
                        while(tokens[ii - 1] && tokens[ii - 1].type !== "ordered_list_open" && tokens[ii - 1].type !== "bullet_list_open")ii--;
                        utils.addAttrs(attrs, tokens[ii - 1]);
                        tokens[i].children = (0, (/*@__PURE__*/$parcel$interopDefault($h2Hd3)))(_context6 = tokens[i].children).call(_context6, 0, -2);
                    }
                },
                {
                    name: "list double softbreak",
                    tests: [
                        {
                            shift: 0,
                            type: function type(str) {
                                return str === "bullet_list_close" || str === "ordered_list_close";
                            }
                        },
                        {
                            shift: 1,
                            type: "paragraph_open"
                        },
                        {
                            shift: 2,
                            type: "inline",
                            content: utils.hasDelimiters("only", options),
                            children: function children(arr) {
                                return arr.length === 1;
                            }
                        },
                        {
                            shift: 3,
                            type: "paragraph_close"
                        }
                    ],
                    transform: function transform(tokens, i) {
                        var token = tokens[i + 2];
                        var content = token.content;
                        var attrs = utils.getAttrs(content, 0, options);
                        var openingToken = utils.getMatchingOpeningToken(tokens, i);
                        utils.addAttrs(attrs, openingToken);
                        (0, (/*@__PURE__*/$parcel$interopDefault($13zC8)))(tokens).call(tokens, i + 1, 3);
                    }
                },
                {
                    name: "list item end",
                    tests: [
                        {
                            shift: -2,
                            type: "list_item_open"
                        },
                        {
                            shift: 0,
                            type: "inline",
                            children: [
                                {
                                    position: -1,
                                    type: "text",
                                    content: utils.hasDelimiters("end", options)
                                }
                            ]
                        }
                    ],
                    transform: function transform(tokens, i, j) {
                        var token = tokens[i].children[j];
                        var content = token.content;
                        var attrs = utils.getAttrs(content, (0, (/*@__PURE__*/$parcel$interopDefault($3yVMU)))(content).call(content, options.leftDelimiter), options);
                        utils.addAttrs(attrs, tokens[i - 2]);
                        var trimmed = (0, (/*@__PURE__*/$parcel$interopDefault($h2Hd3)))(content).call(content, 0, (0, (/*@__PURE__*/$parcel$interopDefault($3yVMU)))(content).call(content, options.leftDelimiter));
                        token.content = last(trimmed) !== " " ? trimmed : (0, (/*@__PURE__*/$parcel$interopDefault($h2Hd3)))(trimmed).call(trimmed, 0, -1);
                    }
                },
                {
                    name: "\n{.a} softbreak then curly in start",
                    tests: [
                        {
                            shift: 0,
                            type: "inline",
                            children: [
                                {
                                    position: -2,
                                    type: "softbreak"
                                },
                                {
                                    position: -1,
                                    type: "text",
                                    content: utils.hasDelimiters("only", options)
                                }
                            ]
                        }
                    ],
                    transform: function transform(tokens, i, j) {
                        var _context7;
                        var token = tokens[i].children[j];
                        var attrs = utils.getAttrs(token.content, 0, options);
                        var ii = i + 1;
                        while(tokens[ii + 1] && tokens[ii + 1].nesting === -1)ii++;
                        var openingToken = utils.getMatchingOpeningToken(tokens, ii);
                        utils.addAttrs(attrs, openingToken);
                        tokens[i].children = (0, (/*@__PURE__*/$parcel$interopDefault($h2Hd3)))(_context7 = tokens[i].children).call(_context7, 0, -2);
                    }
                },
                {
                    name: "horizontal rule",
                    tests: [
                        {
                            shift: 0,
                            type: "paragraph_open"
                        },
                        {
                            shift: 1,
                            type: "inline",
                            children: function children(arr) {
                                return arr.length === 1;
                            },
                            content: function content(str) {
                                return str.match(__hr) !== null;
                            }
                        },
                        {
                            shift: 2,
                            type: "paragraph_close"
                        }
                    ],
                    transform: function transform(tokens, i) {
                        var token = tokens[i];
                        token.type = "hr";
                        token.tag = "hr";
                        token.nesting = 0;
                        var content = tokens[i + 1].content;
                        var start = (0, (/*@__PURE__*/$parcel$interopDefault($3yVMU)))(content).call(content, options.leftDelimiter);
                        var attrs = utils.getAttrs(content, start, options);
                        utils.addAttrs(attrs, token);
                        token.markup = content;
                        (0, (/*@__PURE__*/$parcel$interopDefault($13zC8)))(tokens).call(tokens, i + 1, 2);
                    }
                },
                {
                    name: "end of block",
                    tests: [
                        {
                            shift: 0,
                            type: "inline",
                            children: [
                                {
                                    position: -1,
                                    content: utils.hasDelimiters("end", options),
                                    type: function type(t) {
                                        return t !== "code_inline" && t !== "math_inline";
                                    }
                                }
                            ]
                        }
                    ],
                    transform: function transform(tokens, i, j) {
                        var token = tokens[i].children[j];
                        var content = token.content;
                        var attrs = utils.getAttrs(content, (0, (/*@__PURE__*/$parcel$interopDefault($3yVMU)))(content).call(content, options.leftDelimiter), options);
                        var ii = i + 1;
                        while(tokens[ii + 1] && tokens[ii + 1].nesting === -1)ii++;
                        var openingToken = utils.getMatchingOpeningToken(tokens, ii);
                        utils.addAttrs(attrs, openingToken);
                        var trimmed = (0, (/*@__PURE__*/$parcel$interopDefault($h2Hd3)))(content).call(content, 0, (0, (/*@__PURE__*/$parcel$interopDefault($3yVMU)))(content).call(content, options.leftDelimiter));
                        token.content = last(trimmed) !== " " ? trimmed : (0, (/*@__PURE__*/$parcel$interopDefault($h2Hd3)))(trimmed).call(trimmed, 0, -1);
                    }
                }
            ];
        };
        function last(arr) {
            return (0, (/*@__PURE__*/$parcel$interopDefault($h2Hd3)))(arr).call(arr, -1)[0];
        }
    }
});
// ../markdown-it-attrs/index.js
var $91faf4f36deea9e4$var$require_markdown_it_attrs = $91faf4f36deea9e4$var$__commonJS({
    "../markdown-it-attrs/index.js": function markdownItAttrsIndexJs(exports, module) {
        "use strict";
        var patternsConfig = $91faf4f36deea9e4$var$require_patterns();
        var defaultOptions = {
            leftDelimiter: "{",
            rightDelimiter: "}",
            allowedAttributes: []
        };
        module.exports = function attributes(md, options_) {
            var options = (0, (/*@__PURE__*/$parcel$interopDefault($57aaW)))({}, defaultOptions);
            options = (0, (/*@__PURE__*/$parcel$interopDefault($57aaW)))(options, options_);
            var patterns = patternsConfig(options);
            function curlyAttrs(state) {
                var tokens = state.tokens;
                var _loop2 = function _loop2(i) {
                    var _loop3 = function _loop3(_p) {
                        var _context8;
                        var pattern = patterns[_p];
                        var j = null;
                        var match = (0, (/*@__PURE__*/$parcel$interopDefault($c7fZ0)))(_context8 = pattern.tests).call(_context8, function(t) {
                            var res = test(tokens, i, t);
                            if (res.j !== null) j = res.j;
                            return res.match;
                        });
                        if (match) {
                            pattern.transform(tokens, i, j);
                            if (pattern.name === "inline attributes" || pattern.name === "inline nesting 0") _p--;
                        }
                        p = _p;
                    };
                    for(var p = 0; p < patterns.length; p++)_loop3(p);
                };
                for(var i = 0; i < tokens.length; i++)_loop2(i);
            }
            md.core.ruler.before("linkify", "curly_attributes", curlyAttrs);
        };
        function test(tokens, i, t) {
            var res = {
                match: false,
                j: null
            };
            var ii = t.shift !== void 0 ? i + t.shift : t.position;
            if (t.shift !== void 0 && ii < 0) return res;
            var token = get(tokens, ii);
            if (token === void 0) return res;
            var _loop4 = function _loop4() {
                var key = _Object$keys[_i];
                if (key === "shift" || key === "position") return "continue";
                if (token[key] === void 0) return {
                    v: res
                };
                if (key === "children" && isArrayOfObjects(t.children)) {
                    if (token.children.length === 0) return {
                        v: res
                    };
                    var match;
                    var childTests = t.children;
                    var children = token.children;
                    if ((0, (/*@__PURE__*/$parcel$interopDefault($c7fZ0)))(childTests).call(childTests, function(tt) {
                        return tt.position !== void 0;
                    })) {
                        match = (0, (/*@__PURE__*/$parcel$interopDefault($c7fZ0)))(childTests).call(childTests, function(tt) {
                            return test(children, tt.position, tt).match;
                        });
                        if (match) {
                            var j = last(childTests).position;
                            res.j = j >= 0 ? j : children.length + j;
                        }
                    } else {
                        var _loop5 = function _loop5(_j) {
                            match = (0, (/*@__PURE__*/$parcel$interopDefault($c7fZ0)))(childTests).call(childTests, function(tt) {
                                return test(children, _j, tt).match;
                            });
                            if (match) {
                                res.j = _j;
                                return "break";
                            }
                        };
                        for(var _j = 0; _j < children.length; _j++){
                            var _ret2 = _loop5(_j);
                            if (_ret2 === "break") break;
                        }
                    }
                    if (match === false) return {
                        v: res
                    };
                    return "continue";
                }
                switch((0, (/*@__PURE__*/$parcel$interopDefault($hBFcN)))(t[key])){
                    case "boolean":
                    case "number":
                    case "string":
                        if (token[key] !== t[key]) return {
                            v: res
                        };
                        break;
                    case "function":
                        if (!t[key](token[key])) return {
                            v: res
                        };
                        break;
                    case "object":
                        if (isArrayOfFunctions(t[key])) {
                            var _context9;
                            var r = (0, (/*@__PURE__*/$parcel$interopDefault($c7fZ0)))(_context9 = t[key]).call(_context9, function(tt) {
                                return tt(token[key]);
                            });
                            if (r === false) return {
                                v: res
                            };
                            break;
                        }
                    default:
                        throw new Error("Unknown type of pattern test (key: ".concat(key, "). Test should be of type boolean, number, string, function or array of functions."));
                }
            };
            for(var _i = 0, _Object$keys = (0, (/*@__PURE__*/$parcel$interopDefault($iPwyO)))(t); _i < _Object$keys.length; _i++){
                var _ret = _loop4();
                if (_ret === "continue") continue;
                if ((0, (/*@__PURE__*/$parcel$interopDefault($hBFcN)))(_ret) === "object") return _ret.v;
            }
            res.match = true;
            return res;
        }
        function isArrayOfObjects(arr) {
            return (0, (/*@__PURE__*/$parcel$interopDefault($77Z8P)))(arr) && arr.length && (0, (/*@__PURE__*/$parcel$interopDefault($c7fZ0)))(arr).call(arr, function(i) {
                return (0, (/*@__PURE__*/$parcel$interopDefault($hBFcN)))(i) === "object";
            });
        }
        function isArrayOfFunctions(arr) {
            return (0, (/*@__PURE__*/$parcel$interopDefault($77Z8P)))(arr) && arr.length && (0, (/*@__PURE__*/$parcel$interopDefault($c7fZ0)))(arr).call(arr, function(i) {
                return typeof i === "function";
            });
        }
        function get(arr, n) {
            return n >= 0 ? arr[n] : arr[arr.length + n];
        }
        function last(arr) {
            return (0, (/*@__PURE__*/$parcel$interopDefault($h2Hd3)))(arr).call(arr, -1)[0] || {};
        }
    }
});
// src/index.mjs
var $91faf4f36deea9e4$var$import_markdown_it_attrs = $91faf4f36deea9e4$var$__toESM($91faf4f36deea9e4$var$require_markdown_it_attrs(), 1);
var $91faf4f36deea9e4$export$2e2bcd8739ae039 = $91faf4f36deea9e4$var$import_markdown_it_attrs["default"];

});
parcelRequire.register("h2Hd3", function(module, exports) {

module.exports = (parcelRequire("aqKUS"));

});

parcelRequire.register("1d9Z2", function(module, exports) {

module.exports = (parcelRequire("1hEE5"));

});
parcelRequire.register("1hEE5", function(module, exports) {

var $hU9Dp = parcelRequire("hU9Dp");
module.exports = $hU9Dp;

});
parcelRequire.register("hU9Dp", function(module, exports) {

var $53bMe = parcelRequire("53bMe");

var $hAHrW = parcelRequire("hAHrW");
var $d08f23e0c5da2b2d$var$ArrayPrototype = Array.prototype;
module.exports = function(it) {
    var own = it.some;
    return it === $d08f23e0c5da2b2d$var$ArrayPrototype || $53bMe($d08f23e0c5da2b2d$var$ArrayPrototype, it) && own === $d08f23e0c5da2b2d$var$ArrayPrototype.some ? $hAHrW : own;
};

});
parcelRequire.register("hAHrW", function(module, exports) {
parcelRequire("amQhA");

var $5zMeE = parcelRequire("5zMeE");
module.exports = $5zMeE("Array").some;

});
parcelRequire.register("amQhA", function(module, exports) {
"use strict";

var $2iwSV = parcelRequire("2iwSV");

var $9e7Wd = parcelRequire("9e7Wd");
var $78c483b7038721a7$require$$some = $9e7Wd.some;

var $gH3K8 = parcelRequire("gH3K8");
var $78c483b7038721a7$var$STRICT_METHOD = $gH3K8("some");
// `Array.prototype.some` method
// https://tc39.es/ecma262/#sec-array.prototype.some
$2iwSV({
    target: "Array",
    proto: true,
    forced: !$78c483b7038721a7$var$STRICT_METHOD
}, {
    some: function some(callbackfn /* , thisArg */ ) {
        return $78c483b7038721a7$require$$some(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    }
});

});





parcelRequire.register("3yVMU", function(module, exports) {

module.exports = (parcelRequire("e3VLF"));

});
parcelRequire.register("e3VLF", function(module, exports) {

var $eKqWD = parcelRequire("eKqWD");
module.exports = $eKqWD;

});
parcelRequire.register("eKqWD", function(module, exports) {

var $53bMe = parcelRequire("53bMe");

var $eotTZ = parcelRequire("eotTZ");
var $abca4333fd4fec21$var$ArrayPrototype = Array.prototype;
module.exports = function(it) {
    var own = it.lastIndexOf;
    return it === $abca4333fd4fec21$var$ArrayPrototype || $53bMe($abca4333fd4fec21$var$ArrayPrototype, it) && own === $abca4333fd4fec21$var$ArrayPrototype.lastIndexOf ? $eotTZ : own;
};

});
parcelRequire.register("eotTZ", function(module, exports) {
parcelRequire("fOpXy");

var $5zMeE = parcelRequire("5zMeE");
module.exports = $5zMeE("Array").lastIndexOf;

});
parcelRequire.register("fOpXy", function(module, exports) {

var $2iwSV = parcelRequire("2iwSV");

var $7wJMP = parcelRequire("7wJMP");
// `Array.prototype.lastIndexOf` method
// https://tc39.es/ecma262/#sec-array.prototype.lastindexof
// eslint-disable-next-line es/no-array-prototype-lastindexof -- required for testing
$2iwSV({
    target: "Array",
    proto: true,
    forced: $7wJMP !== [].lastIndexOf
}, {
    lastIndexOf: $7wJMP
});

});
parcelRequire.register("7wJMP", function(module, exports) {
"use strict";

var $9ujZx = parcelRequire("9ujZx");

var $gYLVQ = parcelRequire("gYLVQ");

var $cazda = parcelRequire("cazda");

var $f8kjp = parcelRequire("f8kjp");

var $gH3K8 = parcelRequire("gH3K8");
var $57af09cd119bcbaa$var$min = Math.min;
var $57af09cd119bcbaa$var$$lastIndexOf = [].lastIndexOf;
var $57af09cd119bcbaa$var$NEGATIVE_ZERO = !!$57af09cd119bcbaa$var$$lastIndexOf && 1 / [
    1
].lastIndexOf(1, -0) < 0;
var $57af09cd119bcbaa$var$STRICT_METHOD = $gH3K8("lastIndexOf");
var $57af09cd119bcbaa$var$FORCED = $57af09cd119bcbaa$var$NEGATIVE_ZERO || !$57af09cd119bcbaa$var$STRICT_METHOD;
// `Array.prototype.lastIndexOf` method implementation
// https://tc39.es/ecma262/#sec-array.prototype.lastindexof
module.exports = $57af09cd119bcbaa$var$FORCED ? function lastIndexOf(searchElement /* , fromIndex = @[*-1] */ ) {
    // convert -0 to +0
    if ($57af09cd119bcbaa$var$NEGATIVE_ZERO) return $9ujZx($57af09cd119bcbaa$var$$lastIndexOf, this, arguments) || 0;
    var O = $gYLVQ(this);
    var length = $f8kjp(O);
    var index = length - 1;
    if (arguments.length > 1) index = $57af09cd119bcbaa$var$min(index, $cazda(arguments[1]));
    if (index < 0) index = length + index;
    for(; index >= 0; index--)if (index in O && O[index] === searchElement) return index || 0;
    return -1;
} : $57af09cd119bcbaa$var$$lastIndexOf;

});






parcelRequire.register("57aaW", function(module, exports) {

module.exports = (parcelRequire("aP7BK"));

});
parcelRequire.register("aP7BK", function(module, exports) {

var $ajiB2 = parcelRequire("ajiB2");
module.exports = $ajiB2;

});
parcelRequire.register("ajiB2", function(module, exports) {
parcelRequire("1v6nZ");

var $lahb7 = parcelRequire("lahb7");
module.exports = $lahb7.Object.assign;

});
parcelRequire.register("1v6nZ", function(module, exports) {

var $2iwSV = parcelRequire("2iwSV");

var $8iPXR = parcelRequire("8iPXR");
// `Object.assign` method
// https://tc39.es/ecma262/#sec-object.assign
// eslint-disable-next-line es/no-object-assign -- required for testing
$2iwSV({
    target: "Object",
    stat: true,
    arity: 2,
    forced: Object.assign !== $8iPXR
}, {
    assign: $8iPXR
});

});
parcelRequire.register("8iPXR", function(module, exports) {
"use strict";

var $awFtp = parcelRequire("awFtp");

var $dqhay = parcelRequire("dqhay");

var $boD6Z = parcelRequire("boD6Z");

var $bSIUO = parcelRequire("bSIUO");

var $hQAxZ = parcelRequire("hQAxZ");

var $3R41N = parcelRequire("3R41N");

var $fsYnl = parcelRequire("fsYnl");

var $h90HQ = parcelRequire("h90HQ");

var $letw9 = parcelRequire("letw9");
// eslint-disable-next-line es/no-object-assign -- safe
var $60b8503fe872d0ae$var$$assign = Object.assign;
// eslint-disable-next-line es/no-object-defineproperty -- required for testing
var $60b8503fe872d0ae$var$defineProperty = Object.defineProperty;
var $60b8503fe872d0ae$var$concat = $dqhay([].concat);
// `Object.assign` method
// https://tc39.es/ecma262/#sec-object.assign
module.exports = !$60b8503fe872d0ae$var$$assign || $bSIUO(function() {
    // should have correct order of operations (Edge bug)
    if ($awFtp && $60b8503fe872d0ae$var$$assign({
        b: 1
    }, $60b8503fe872d0ae$var$$assign($60b8503fe872d0ae$var$defineProperty({}, "a", {
        enumerable: true,
        get: function() {
            $60b8503fe872d0ae$var$defineProperty(this, "b", {
                value: 3,
                enumerable: false
            });
        }
    }), {
        b: 2
    })).b !== 1) return true;
    // should work with symbols and should have deterministic property order (V8 bug)
    var A = {};
    var B = {};
    // eslint-disable-next-line es/no-symbol -- safe
    var symbol = Symbol();
    var alphabet = "abcdefghijklmnopqrst";
    A[symbol] = 7;
    alphabet.split("").forEach(function(chr) {
        B[chr] = chr;
    });
    return $60b8503fe872d0ae$var$$assign({}, A)[symbol] != 7 || $hQAxZ($60b8503fe872d0ae$var$$assign({}, B)).join("") != alphabet;
}) ? function assign(target, source) {
    var T = $h90HQ(target);
    var argumentsLength = arguments.length;
    var index = 1;
    var getOwnPropertySymbols = $3R41N.f;
    var propertyIsEnumerable = $fsYnl.f;
    while(argumentsLength > index){
        var S = $letw9(arguments[index++]);
        var keys = getOwnPropertySymbols ? $60b8503fe872d0ae$var$concat($hQAxZ(S), getOwnPropertySymbols(S)) : $hQAxZ(S);
        var length = keys.length;
        var j = 0;
        var key;
        while(length > j){
            key = keys[j++];
            if (!$awFtp || $boD6Z(propertyIsEnumerable, S, key)) T[key] = S[key];
        }
    }
    return T;
} : $60b8503fe872d0ae$var$$assign;

});





parcelRequire.register("c7fZ0", function(module, exports) {

module.exports = (parcelRequire("bSJYu"));

});
parcelRequire.register("bSJYu", function(module, exports) {

var $dLSHt = parcelRequire("dLSHt");
module.exports = $dLSHt;

});
parcelRequire.register("dLSHt", function(module, exports) {

var $53bMe = parcelRequire("53bMe");

var $khQEo = parcelRequire("khQEo");
var $a06a1878519efc71$var$ArrayPrototype = Array.prototype;
module.exports = function(it) {
    var own = it.every;
    return it === $a06a1878519efc71$var$ArrayPrototype || $53bMe($a06a1878519efc71$var$ArrayPrototype, it) && own === $a06a1878519efc71$var$ArrayPrototype.every ? $khQEo : own;
};

});
parcelRequire.register("khQEo", function(module, exports) {
parcelRequire("k6LoY");

var $5zMeE = parcelRequire("5zMeE");
module.exports = $5zMeE("Array").every;

});
parcelRequire.register("k6LoY", function(module, exports) {
"use strict";

var $2iwSV = parcelRequire("2iwSV");

var $9e7Wd = parcelRequire("9e7Wd");
var $ea39232fa406b600$require$$every = $9e7Wd.every;

var $gH3K8 = parcelRequire("gH3K8");
var $ea39232fa406b600$var$STRICT_METHOD = $gH3K8("every");
// `Array.prototype.every` method
// https://tc39.es/ecma262/#sec-array.prototype.every
$2iwSV({
    target: "Array",
    proto: true,
    forced: !$ea39232fa406b600$var$STRICT_METHOD
}, {
    every: function every(callbackfn /* , thisArg */ ) {
        return $ea39232fa406b600$require$$every(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    }
});

});






parcelRequire.register("9dNlI", function(module, exports) {
parcelRequire("90F2N");
var $egLXp = parcelRequire("egLXp");

var $hhT4E = parcelRequire("hhT4E");

var $1aQnO = parcelRequire("1aQnO");
var $6b6b9bb58af2ece7$require$isPlainObject = $1aQnO.isPlainObject;

var $lafU4 = parcelRequire("lafU4");

var $iDeqq = parcelRequire("iDeqq");

var $cPknf = parcelRequire("cPknf");
var $6b6b9bb58af2ece7$require$postcssParse = $cPknf.parse;
// Tags that can conceivably represent stand-alone media.
const $6b6b9bb58af2ece7$var$mediaTags = [
    "img",
    "audio",
    "video",
    "picture",
    "svg",
    "object",
    "map",
    "iframe",
    "embed"
];
// Tags that are inherently vulnerable to being used in XSS attacks.
const $6b6b9bb58af2ece7$var$vulnerableTags = [
    "script",
    "style"
];
function $6b6b9bb58af2ece7$var$each(obj, cb) {
    if (obj) Object.keys(obj).forEach(function(key) {
        cb(obj[key], key);
    });
}
// Avoid false positives with .__proto__, .hasOwnProperty, etc.
function $6b6b9bb58af2ece7$var$has(obj, key) {
    return ({}).hasOwnProperty.call(obj, key);
}
// Returns those elements of `a` for which `cb(a)` returns truthy
function $6b6b9bb58af2ece7$var$filter(a, cb) {
    const n = [];
    $6b6b9bb58af2ece7$var$each(a, function(v) {
        if (cb(v)) n.push(v);
    });
    return n;
}
function $6b6b9bb58af2ece7$var$isEmptyObject(obj) {
    for(const key in obj){
        if ($6b6b9bb58af2ece7$var$has(obj, key)) return false;
    }
    return true;
}
function $6b6b9bb58af2ece7$var$stringifySrcset(parsedSrcset) {
    return parsedSrcset.map(function(part) {
        if (!part.url) throw new Error("URL missing");
        return part.url + (part.w ? ` ${part.w}w` : "") + (part.h ? ` ${part.h}h` : "") + (part.d ? ` ${part.d}x` : "");
    }).join(", ");
}
module.exports = $6b6b9bb58af2ece7$var$sanitizeHtml;
// A valid attribute name.
// We use a tolerant definition based on the set of strings defined by
// html.spec.whatwg.org/multipage/parsing.html#before-attribute-name-state
// and html.spec.whatwg.org/multipage/parsing.html#attribute-name-state .
// The characters accepted are ones which can be appended to the attribute
// name buffer without triggering a parse error:
//   * unexpected-equals-sign-before-attribute-name
//   * unexpected-null-character
//   * unexpected-character-in-attribute-name
// We exclude the empty string because it's impossible to get to the after
// attribute name state with an empty attribute name buffer.
const $6b6b9bb58af2ece7$var$VALID_HTML_ATTRIBUTE_NAME = /^[^\0\t\n\f\r /<=>]+$/;
// Ignore the _recursing flag; it's there for recursive
// invocation as a guard against this exploit:
// https://github.com/fb55/htmlparser2/issues/105
function $6b6b9bb58af2ece7$var$sanitizeHtml(html, options, _recursing) {
    if (html == null) return "";
    if (typeof html === "number") html = html.toString();
    let result = "";
    // Used for hot swapping the result variable with an empty string in order to "capture" the text written to it.
    let tempResult = "";
    function Frame(tag, attribs) {
        const that = this;
        this.tag = tag;
        this.attribs = attribs || {};
        this.tagPosition = result.length;
        this.text = ""; // Node inner text
        this.mediaChildren = [];
        this.updateParentNodeText = function() {
            if (stack.length) {
                const parentFrame = stack[stack.length - 1];
                parentFrame.text += that.text;
            }
        };
        this.updateParentNodeMediaChildren = function() {
            if (stack.length && $6b6b9bb58af2ece7$var$mediaTags.includes(this.tag)) {
                const parentFrame = stack[stack.length - 1];
                parentFrame.mediaChildren.push(this.tag);
            }
        };
    }
    options = Object.assign({}, $6b6b9bb58af2ece7$var$sanitizeHtml.defaults, options);
    options.parser = Object.assign({}, $6b6b9bb58af2ece7$var$htmlParserDefaults, options.parser);
    const tagAllowed = function(name) {
        return options.allowedTags === false || (options.allowedTags || []).indexOf(name) > -1;
    };
    // vulnerableTags
    $6b6b9bb58af2ece7$var$vulnerableTags.forEach(function(tag) {
        if (tagAllowed(tag) && !options.allowVulnerableTags) console.warn(`\n\n⚠️ Your \`allowedTags\` option includes, \`${tag}\`, which is inherently\nvulnerable to XSS attacks. Please remove it from \`allowedTags\`.\nOr, to disable this warning, add the \`allowVulnerableTags\` option\nand ensure you are accounting for this risk.\n\n`);
    });
    // Tags that contain something other than HTML, or where discarding
    // the text when the tag is disallowed makes sense for other reasons.
    // If we are not allowing these tags, we should drop their content too.
    // For other tags you would drop the tag but keep its content.
    const nonTextTagsArray = options.nonTextTags || [
        "script",
        "style",
        "textarea",
        "option"
    ];
    let allowedAttributesMap;
    let allowedAttributesGlobMap;
    if (options.allowedAttributes) {
        allowedAttributesMap = {};
        allowedAttributesGlobMap = {};
        $6b6b9bb58af2ece7$var$each(options.allowedAttributes, function(attributes, tag) {
            allowedAttributesMap[tag] = [];
            const globRegex = [];
            attributes.forEach(function(obj) {
                if (typeof obj === "string" && obj.indexOf("*") >= 0) globRegex.push($hhT4E(obj).replace(/\\\*/g, ".*"));
                else allowedAttributesMap[tag].push(obj);
            });
            if (globRegex.length) allowedAttributesGlobMap[tag] = new RegExp("^(" + globRegex.join("|") + ")$");
        });
    }
    const allowedClassesMap = {};
    const allowedClassesGlobMap = {};
    const allowedClassesRegexMap = {};
    $6b6b9bb58af2ece7$var$each(options.allowedClasses, function(classes, tag) {
        // Implicitly allows the class attribute
        if (allowedAttributesMap) {
            if (!$6b6b9bb58af2ece7$var$has(allowedAttributesMap, tag)) allowedAttributesMap[tag] = [];
            allowedAttributesMap[tag].push("class");
        }
        allowedClassesMap[tag] = [];
        allowedClassesRegexMap[tag] = [];
        const globRegex = [];
        classes.forEach(function(obj) {
            if (typeof obj === "string" && obj.indexOf("*") >= 0) globRegex.push($hhT4E(obj).replace(/\\\*/g, ".*"));
            else if (obj instanceof RegExp) allowedClassesRegexMap[tag].push(obj);
            else allowedClassesMap[tag].push(obj);
        });
        if (globRegex.length) allowedClassesGlobMap[tag] = new RegExp("^(" + globRegex.join("|") + ")$");
    });
    const transformTagsMap = {};
    let transformTagsAll;
    $6b6b9bb58af2ece7$var$each(options.transformTags, function(transform, tag) {
        let transFun;
        if (typeof transform === "function") transFun = transform;
        else if (typeof transform === "string") transFun = $6b6b9bb58af2ece7$var$sanitizeHtml.simpleTransform(transform);
        if (tag === "*") transformTagsAll = transFun;
        else transformTagsMap[tag] = transFun;
    });
    let depth;
    let stack;
    let skipMap;
    let transformMap;
    let skipText;
    let skipTextDepth;
    let addedText = false;
    initializeState();
    const parser = new $egLXp.Parser({
        onopentag: function(name, attribs) {
            // If `enforceHtmlBoundary` is `true` and this has found the opening
            // `html` tag, reset the state.
            if (options.enforceHtmlBoundary && name === "html") initializeState();
            if (skipText) {
                skipTextDepth++;
                return;
            }
            const frame = new Frame(name, attribs);
            stack.push(frame);
            let skip = false;
            const hasText = !!frame.text;
            let transformedTag;
            if ($6b6b9bb58af2ece7$var$has(transformTagsMap, name)) {
                transformedTag = transformTagsMap[name](name, attribs);
                frame.attribs = attribs = transformedTag.attribs;
                if (transformedTag.text !== undefined) frame.innerText = transformedTag.text;
                if (name !== transformedTag.tagName) {
                    frame.name = name = transformedTag.tagName;
                    transformMap[depth] = transformedTag.tagName;
                }
            }
            if (transformTagsAll) {
                transformedTag = transformTagsAll(name, attribs);
                frame.attribs = attribs = transformedTag.attribs;
                if (name !== transformedTag.tagName) {
                    frame.name = name = transformedTag.tagName;
                    transformMap[depth] = transformedTag.tagName;
                }
            }
            if (!tagAllowed(name) || options.disallowedTagsMode === "recursiveEscape" && !$6b6b9bb58af2ece7$var$isEmptyObject(skipMap) || options.nestingLimit != null && depth >= options.nestingLimit) {
                skip = true;
                skipMap[depth] = true;
                if (options.disallowedTagsMode === "discard") {
                    if (nonTextTagsArray.indexOf(name) !== -1) {
                        skipText = true;
                        skipTextDepth = 1;
                    }
                }
                skipMap[depth] = true;
            }
            depth++;
            if (skip) {
                if (options.disallowedTagsMode === "discard") // We want the contents but not this tag
                return;
                tempResult = result;
                result = "";
            }
            result += "<" + name;
            if (name === "script") {
                if (options.allowedScriptHostnames || options.allowedScriptDomains) frame.innerText = "";
            }
            if (!allowedAttributesMap || $6b6b9bb58af2ece7$var$has(allowedAttributesMap, name) || allowedAttributesMap["*"]) $6b6b9bb58af2ece7$var$each(attribs, function(value, a) {
                if (!$6b6b9bb58af2ece7$var$VALID_HTML_ATTRIBUTE_NAME.test(a)) {
                    // This prevents part of an attribute name in the output from being
                    // interpreted as the end of an attribute, or end of a tag.
                    delete frame.attribs[a];
                    return;
                }
                // check allowedAttributesMap for the element and attribute and modify the value
                // as necessary if there are specific values defined.
                let passedAllowedAttributesMapCheck = false;
                if (!allowedAttributesMap || $6b6b9bb58af2ece7$var$has(allowedAttributesMap, name) && allowedAttributesMap[name].indexOf(a) !== -1 || allowedAttributesMap["*"] && allowedAttributesMap["*"].indexOf(a) !== -1 || $6b6b9bb58af2ece7$var$has(allowedAttributesGlobMap, name) && allowedAttributesGlobMap[name].test(a) || allowedAttributesGlobMap["*"] && allowedAttributesGlobMap["*"].test(a)) passedAllowedAttributesMapCheck = true;
                else if (allowedAttributesMap && allowedAttributesMap[name]) {
                    for (const o of allowedAttributesMap[name])if ($6b6b9bb58af2ece7$require$isPlainObject(o) && o.name && o.name === a) {
                        passedAllowedAttributesMapCheck = true;
                        let newValue = "";
                        if (o.multiple === true) {
                            // verify the values that are allowed
                            const splitStrArray = value.split(" ");
                            for (const s of splitStrArray)if (o.values.indexOf(s) !== -1) {
                                if (newValue === "") newValue = s;
                                else newValue += " " + s;
                            }
                        } else if (o.values.indexOf(value) >= 0) // verified an allowed value matches the entire attribute value
                        newValue = value;
                        value = newValue;
                    }
                }
                if (passedAllowedAttributesMapCheck) {
                    if (options.allowedSchemesAppliedToAttributes.indexOf(a) !== -1) {
                        if (naughtyHref(name, value)) {
                            delete frame.attribs[a];
                            return;
                        }
                    }
                    if (name === "script" && a === "src") {
                        let allowed = true;
                        try {
                            const parsed = parseUrl(value);
                            if (options.allowedScriptHostnames || options.allowedScriptDomains) {
                                const allowedHostname = (options.allowedScriptHostnames || []).find(function(hostname) {
                                    return hostname === parsed.url.hostname;
                                });
                                const allowedDomain = (options.allowedScriptDomains || []).find(function(domain) {
                                    return parsed.url.hostname === domain || parsed.url.hostname.endsWith(`.${domain}`);
                                });
                                allowed = allowedHostname || allowedDomain;
                            }
                        } catch (e) {
                            allowed = false;
                        }
                        if (!allowed) {
                            delete frame.attribs[a];
                            return;
                        }
                    }
                    if (name === "iframe" && a === "src") {
                        let allowed = true;
                        try {
                            const parsed = parseUrl(value);
                            if (parsed.isRelativeUrl) // default value of allowIframeRelativeUrls is true
                            // unless allowedIframeHostnames or allowedIframeDomains specified
                            allowed = $6b6b9bb58af2ece7$var$has(options, "allowIframeRelativeUrls") ? options.allowIframeRelativeUrls : !options.allowedIframeHostnames && !options.allowedIframeDomains;
                            else if (options.allowedIframeHostnames || options.allowedIframeDomains) {
                                const allowedHostname = (options.allowedIframeHostnames || []).find(function(hostname) {
                                    return hostname === parsed.url.hostname;
                                });
                                const allowedDomain = (options.allowedIframeDomains || []).find(function(domain) {
                                    return parsed.url.hostname === domain || parsed.url.hostname.endsWith(`.${domain}`);
                                });
                                allowed = allowedHostname || allowedDomain;
                            }
                        } catch (e) {
                            // Unparseable iframe src
                            allowed = false;
                        }
                        if (!allowed) {
                            delete frame.attribs[a];
                            return;
                        }
                    }
                    if (a === "srcset") try {
                        let parsed = $iDeqq(value);
                        parsed.forEach(function(value) {
                            if (naughtyHref("srcset", value.url)) value.evil = true;
                        });
                        parsed = $6b6b9bb58af2ece7$var$filter(parsed, function(v) {
                            return !v.evil;
                        });
                        if (!parsed.length) {
                            delete frame.attribs[a];
                            return;
                        } else {
                            value = $6b6b9bb58af2ece7$var$stringifySrcset($6b6b9bb58af2ece7$var$filter(parsed, function(v) {
                                return !v.evil;
                            }));
                            frame.attribs[a] = value;
                        }
                    } catch (e) {
                        // Unparseable srcset
                        delete frame.attribs[a];
                        return;
                    }
                    if (a === "class") {
                        const allowedSpecificClasses = allowedClassesMap[name];
                        const allowedWildcardClasses = allowedClassesMap["*"];
                        const allowedSpecificClassesGlob = allowedClassesGlobMap[name];
                        const allowedSpecificClassesRegex = allowedClassesRegexMap[name];
                        const allowedWildcardClassesGlob = allowedClassesGlobMap["*"];
                        const allowedClassesGlobs = [
                            allowedSpecificClassesGlob,
                            allowedWildcardClassesGlob
                        ].concat(allowedSpecificClassesRegex).filter(function(t) {
                            return t;
                        });
                        if (allowedSpecificClasses && allowedWildcardClasses) value = filterClasses(value, $lafU4(allowedSpecificClasses, allowedWildcardClasses), allowedClassesGlobs);
                        else value = filterClasses(value, allowedSpecificClasses || allowedWildcardClasses, allowedClassesGlobs);
                        if (!value.length) {
                            delete frame.attribs[a];
                            return;
                        }
                    }
                    if (a === "style") {
                        if (options.parseStyleAttributes) try {
                            const abstractSyntaxTree = $6b6b9bb58af2ece7$require$postcssParse(name + " {" + value + "}");
                            const filteredAST = filterCss(abstractSyntaxTree, options.allowedStyles);
                            value = stringifyStyleAttributes(filteredAST);
                            if (value.length === 0) {
                                delete frame.attribs[a];
                                return;
                            }
                        } catch (e) {
                            console.warn('Failed to parse "' + name + " {" + value + "}" + "\", If you're running this in a browser, we recommend to disable style parsing: options.parseStyleAttributes: false, since this only works in a node environment due to a postcss dependency, More info: https://github.com/apostrophecms/sanitize-html/issues/547");
                            delete frame.attribs[a];
                            return;
                        }
                        else if (options.allowedStyles) throw new Error("allowedStyles option cannot be used together with parseStyleAttributes: false.");
                    }
                    result += " " + a;
                    if (value && value.length) result += '="' + escapeHtml(value, true) + '"';
                } else delete frame.attribs[a];
            });
            if (options.selfClosing.indexOf(name) !== -1) result += " />";
            else {
                result += ">";
                if (frame.innerText && !hasText && !options.textFilter) {
                    result += escapeHtml(frame.innerText);
                    addedText = true;
                }
            }
            if (skip) {
                result = tempResult + escapeHtml(result);
                tempResult = "";
            }
        },
        ontext: function(text) {
            if (skipText) return;
            const lastFrame = stack[stack.length - 1];
            let tag;
            if (lastFrame) {
                tag = lastFrame.tag;
                // If inner text was set by transform function then let's use it
                text = lastFrame.innerText !== undefined ? lastFrame.innerText : text;
            }
            if (options.disallowedTagsMode === "discard" && (tag === "script" || tag === "style")) // htmlparser2 gives us these as-is. Escaping them ruins the content. Allowing
            // script tags is, by definition, game over for XSS protection, so if that's
            // your concern, don't allow them. The same is essentially true for style tags
            // which have their own collection of XSS vectors.
            result += text;
            else {
                const escaped = escapeHtml(text, false);
                if (options.textFilter && !addedText) result += options.textFilter(escaped, tag);
                else if (!addedText) result += escaped;
            }
            if (stack.length) {
                const frame = stack[stack.length - 1];
                frame.text += text;
            }
        },
        onclosetag: function(name, isImplied) {
            if (skipText) {
                skipTextDepth--;
                if (!skipTextDepth) skipText = false;
                else return;
            }
            const frame = stack.pop();
            if (!frame) // Do not crash on bad markup
            return;
            if (frame.tag !== name) {
                // Another case of bad markup.
                // Push to stack, so that it will be used in future closing tags.
                stack.push(frame);
                return;
            }
            skipText = options.enforceHtmlBoundary ? name === "html" : false;
            depth--;
            const skip = skipMap[depth];
            if (skip) {
                delete skipMap[depth];
                if (options.disallowedTagsMode === "discard") {
                    frame.updateParentNodeText();
                    return;
                }
                tempResult = result;
                result = "";
            }
            if (transformMap[depth]) {
                name = transformMap[depth];
                delete transformMap[depth];
            }
            if (options.exclusiveFilter && options.exclusiveFilter(frame)) {
                result = result.substr(0, frame.tagPosition);
                return;
            }
            frame.updateParentNodeMediaChildren();
            frame.updateParentNodeText();
            if (// Already output />
            options.selfClosing.indexOf(name) !== -1 || // Escaped tag, closing tag is implied
            isImplied && !tagAllowed(name) && [
                "escape",
                "recursiveEscape"
            ].indexOf(options.disallowedTagsMode) >= 0) {
                if (skip) {
                    result = tempResult;
                    tempResult = "";
                }
                return;
            }
            result += "</" + name + ">";
            if (skip) {
                result = tempResult + escapeHtml(result);
                tempResult = "";
            }
            addedText = false;
        }
    }, options.parser);
    parser.write(html);
    parser.end();
    return result;
    function initializeState() {
        result = "";
        depth = 0;
        stack = [];
        skipMap = {};
        transformMap = {};
        skipText = false;
        skipTextDepth = 0;
    }
    function escapeHtml(s, quote) {
        if (typeof s !== "string") s = s + "";
        if (options.parser.decodeEntities) {
            s = s.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
            if (quote) s = s.replace(/"/g, "&quot;");
        }
        // TODO: this is inadequate because it will pass `&0;`. This approach
        // will not work, each & must be considered with regard to whether it
        // is followed by a 100% syntactically valid entity or not, and escaped
        // if it is not. If this bothers you, don't set parser.decodeEntities
        // to false. (The default is true.)
        s = s.replace(/&(?![a-zA-Z0-9#]{1,20};)/g, "&amp;") // Match ampersands not part of existing HTML entity
        .replace(/</g, "&lt;").replace(/>/g, "&gt;");
        if (quote) s = s.replace(/"/g, "&quot;");
        return s;
    }
    function naughtyHref(name, href) {
        // Browsers ignore character codes of 32 (space) and below in a surprising
        // number of situations. Start reading here:
        // https://www.owasp.org/index.php/XSS_Filter_Evasion_Cheat_Sheet#Embedded_tab
        // eslint-disable-next-line no-control-regex
        href = href.replace(/[\x00-\x20]+/g, "");
        // Clobber any comments in URLs, which the browser might
        // interpret inside an XML data island, allowing
        // a javascript: URL to be snuck through
        while(true){
            const firstIndex = href.indexOf("<!--");
            if (firstIndex === -1) break;
            const lastIndex = href.indexOf("-->", firstIndex + 4);
            if (lastIndex === -1) break;
            href = href.substring(0, firstIndex) + href.substring(lastIndex + 3);
        }
        // Case insensitive so we don't get faked out by JAVASCRIPT #1
        // Allow more characters after the first so we don't get faked
        // out by certain schemes browsers accept
        const matches = href.match(/^([a-zA-Z][a-zA-Z0-9.\-+]*):/);
        if (!matches) {
            // Protocol-relative URL starting with any combination of '/' and '\'
            if (href.match(/^[/\\]{2}/)) return !options.allowProtocolRelative;
            // No scheme
            return false;
        }
        const scheme = matches[1].toLowerCase();
        if ($6b6b9bb58af2ece7$var$has(options.allowedSchemesByTag, name)) return options.allowedSchemesByTag[name].indexOf(scheme) === -1;
        return !options.allowedSchemes || options.allowedSchemes.indexOf(scheme) === -1;
    }
    function parseUrl(value) {
        value = value.replace(/^(\w+:)?\s*[\\/]\s*[\\/]/, "$1//");
        if (value.startsWith("relative:")) // An attempt to exploit our workaround for base URLs being
        // mandatory for relative URL validation in the WHATWG
        // URL parser, reject it
        throw new Error("relative: exploit attempt");
        // naughtyHref is in charge of whether protocol relative URLs
        // are cool. Here we are concerned just with allowed hostnames and
        // whether to allow relative URLs.
        //
        // Build a placeholder "base URL" against which any reasonable
        // relative URL may be parsed successfully
        let base = "relative://relative-site";
        for(let i = 0; i < 100; i++)base += `/${i}`;
        const parsed = new URL(value, base);
        const isRelativeUrl = parsed && parsed.hostname === "relative-site" && parsed.protocol === "relative:";
        return {
            isRelativeUrl: isRelativeUrl,
            url: parsed
        };
    }
    /**
   * Filters user input css properties by allowlisted regex attributes.
   * Modifies the abstractSyntaxTree object.
   *
   * @param {object} abstractSyntaxTree  - Object representation of CSS attributes.
   * @property {array[Declaration]} abstractSyntaxTree.nodes[0] - Each object cointains prop and value key, i.e { prop: 'color', value: 'red' }.
   * @param {object} allowedStyles       - Keys are properties (i.e color), value is list of permitted regex rules (i.e /green/i).
   * @return {object}                    - The modified tree.
   */ function filterCss(abstractSyntaxTree, allowedStyles) {
        if (!allowedStyles) return abstractSyntaxTree;
        const astRules = abstractSyntaxTree.nodes[0];
        let selectedRule;
        // Merge global and tag-specific styles into new AST.
        if (allowedStyles[astRules.selector] && allowedStyles["*"]) selectedRule = $lafU4(allowedStyles[astRules.selector], allowedStyles["*"]);
        else selectedRule = allowedStyles[astRules.selector] || allowedStyles["*"];
        if (selectedRule) abstractSyntaxTree.nodes[0].nodes = astRules.nodes.reduce(filterDeclarations(selectedRule), []);
        return abstractSyntaxTree;
    }
    /**
   * Extracts the style attributes from an AbstractSyntaxTree and formats those
   * values in the inline style attribute format.
   *
   * @param  {AbstractSyntaxTree} filteredAST
   * @return {string}             - Example: "color:yellow;text-align:center !important;font-family:helvetica;"
   */ function stringifyStyleAttributes(filteredAST) {
        return filteredAST.nodes[0].nodes.reduce(function(extractedAttributes, attrObject) {
            extractedAttributes.push(`${attrObject.prop}:${attrObject.value}${attrObject.important ? " !important" : ""}`);
            return extractedAttributes;
        }, []).join(";");
    }
    /**
    * Filters the existing attributes for the given property. Discards any attributes
    * which don't match the allowlist.
    *
    * @param  {object} selectedRule             - Example: { color: red, font-family: helvetica }
    * @param  {array} allowedDeclarationsList   - List of declarations which pass the allowlist.
    * @param  {object} attributeObject          - Object representing the current css property.
    * @property {string} attributeObject.type   - Typically 'declaration'.
    * @property {string} attributeObject.prop   - The CSS property, i.e 'color'.
    * @property {string} attributeObject.value  - The corresponding value to the css property, i.e 'red'.
    * @return {function}                        - When used in Array.reduce, will return an array of Declaration objects
    */ function filterDeclarations(selectedRule) {
        return function(allowedDeclarationsList, attributeObject) {
            // If this property is allowlisted...
            if ($6b6b9bb58af2ece7$var$has(selectedRule, attributeObject.prop)) {
                const matchesRegex = selectedRule[attributeObject.prop].some(function(regularExpression) {
                    return regularExpression.test(attributeObject.value);
                });
                if (matchesRegex) allowedDeclarationsList.push(attributeObject);
            }
            return allowedDeclarationsList;
        };
    }
    function filterClasses(classes, allowed, allowedGlobs) {
        if (!allowed) // The class attribute is allowed without filtering on this tag
        return classes;
        classes = classes.split(/\s+/);
        return classes.filter(function(clss) {
            return allowed.indexOf(clss) !== -1 || allowedGlobs.some(function(glob) {
                return glob.test(clss);
            });
        }).join(" ");
    }
}
// Defaults are accessible to you so that you can use them as a starting point
// programmatically if you wish
const $6b6b9bb58af2ece7$var$htmlParserDefaults = {
    decodeEntities: true
};
$6b6b9bb58af2ece7$var$sanitizeHtml.defaults = {
    allowedTags: [
        // Sections derived from MDN element categories and limited to the more
        // benign categories.
        // https://developer.mozilla.org/en-US/docs/Web/HTML/Element
        // Content sectioning
        "address",
        "article",
        "aside",
        "footer",
        "header",
        "h1",
        "h2",
        "h3",
        "h4",
        "h5",
        "h6",
        "hgroup",
        "main",
        "nav",
        "section",
        // Text content
        "blockquote",
        "dd",
        "div",
        "dl",
        "dt",
        "figcaption",
        "figure",
        "hr",
        "li",
        "main",
        "ol",
        "p",
        "pre",
        "ul",
        // Inline text semantics
        "a",
        "abbr",
        "b",
        "bdi",
        "bdo",
        "br",
        "cite",
        "code",
        "data",
        "dfn",
        "em",
        "i",
        "kbd",
        "mark",
        "q",
        "rb",
        "rp",
        "rt",
        "rtc",
        "ruby",
        "s",
        "samp",
        "small",
        "span",
        "strong",
        "sub",
        "sup",
        "time",
        "u",
        "var",
        "wbr",
        // Table content
        "caption",
        "col",
        "colgroup",
        "table",
        "tbody",
        "td",
        "tfoot",
        "th",
        "thead",
        "tr"
    ],
    disallowedTagsMode: "discard",
    allowedAttributes: {
        a: [
            "href",
            "name",
            "target"
        ],
        // We don't currently allow img itself by default, but
        // these attributes would make sense if we did.
        img: [
            "src",
            "srcset",
            "alt",
            "title",
            "width",
            "height",
            "loading"
        ]
    },
    // Lots of these won't come up by default because we don't allow them
    selfClosing: [
        "img",
        "br",
        "hr",
        "area",
        "base",
        "basefont",
        "input",
        "link",
        "meta"
    ],
    // URL schemes we permit
    allowedSchemes: [
        "http",
        "https",
        "ftp",
        "mailto",
        "tel"
    ],
    allowedSchemesByTag: {},
    allowedSchemesAppliedToAttributes: [
        "href",
        "src",
        "cite"
    ],
    allowProtocolRelative: true,
    enforceHtmlBoundary: false,
    parseStyleAttributes: true
};
$6b6b9bb58af2ece7$var$sanitizeHtml.simpleTransform = function(newTagName, newAttribs, merge) {
    merge = merge === undefined ? true : merge;
    newAttribs = newAttribs || {};
    return function(tagName, attribs) {
        let attrib;
        if (merge) for(attrib in newAttribs)attribs[attrib] = newAttribs[attrib];
        else attribs = newAttribs;
        return {
            tagName: newTagName,
            attribs: attribs
        };
    };
};

});
parcelRequire.register("90F2N", function(module, exports) {

$parcel$export(module.exports, "Parser", () => (parcelRequire("egLXp")).Parser);

var $egLXp = parcelRequire("egLXp");

var $CnBXM = parcelRequire("CnBXM");

var $U8ze2 = parcelRequire("U8ze2");

var $j8Fek = parcelRequire("j8Fek");
parcelRequire("460hx");
var $4qtZj = parcelRequire("4qtZj");
var $460hx = parcelRequire("460hx");
function $68f3f39fc389f127$export$b6a9369736b19f4d(data, options) {
    const handler = new (0, $CnBXM.DomHandler)(undefined, options);
    new (0, $egLXp.Parser)(handler, options).end(data);
    return handler.root;
}
function $68f3f39fc389f127$export$d66b332881d9723f(data, options) {
    return $68f3f39fc389f127$export$b6a9369736b19f4d(data, options).children;
}
function $68f3f39fc389f127$export$2bbd0317573b00fc(callback, options, elementCallback) {
    const handler = new (0, $CnBXM.DomHandler)(callback, options, elementCallback);
    return new (0, $egLXp.Parser)(handler, options);
}
const $68f3f39fc389f127$var$parseFeedDefaultOptions = {
    xmlMode: true
};
function $68f3f39fc389f127$export$5267abf679cd576b(feed, options = $68f3f39fc389f127$var$parseFeedDefaultOptions) {
    return (0, $4qtZj.getFeed)($68f3f39fc389f127$export$d66b332881d9723f(feed, options));
}

});
parcelRequire.register("egLXp", function(module, exports) {

$parcel$export(module.exports, "Parser", () => $a637c2a3c5f99433$export$7acfa6ed01010e37);

var $U8ze2 = parcelRequire("U8ze2");

var $cqudo = parcelRequire("cqudo");
const $a637c2a3c5f99433$var$formTags = new Set([
    "input",
    "option",
    "optgroup",
    "select",
    "button",
    "datalist",
    "textarea"
]);
const $a637c2a3c5f99433$var$pTag = new Set([
    "p"
]);
const $a637c2a3c5f99433$var$tableSectionTags = new Set([
    "thead",
    "tbody"
]);
const $a637c2a3c5f99433$var$ddtTags = new Set([
    "dd",
    "dt"
]);
const $a637c2a3c5f99433$var$rtpTags = new Set([
    "rt",
    "rp"
]);
const $a637c2a3c5f99433$var$openImpliesClose = new Map([
    [
        "tr",
        new Set([
            "tr",
            "th",
            "td"
        ])
    ],
    [
        "th",
        new Set([
            "th"
        ])
    ],
    [
        "td",
        new Set([
            "thead",
            "th",
            "td"
        ])
    ],
    [
        "body",
        new Set([
            "head",
            "link",
            "script"
        ])
    ],
    [
        "li",
        new Set([
            "li"
        ])
    ],
    [
        "p",
        $a637c2a3c5f99433$var$pTag
    ],
    [
        "h1",
        $a637c2a3c5f99433$var$pTag
    ],
    [
        "h2",
        $a637c2a3c5f99433$var$pTag
    ],
    [
        "h3",
        $a637c2a3c5f99433$var$pTag
    ],
    [
        "h4",
        $a637c2a3c5f99433$var$pTag
    ],
    [
        "h5",
        $a637c2a3c5f99433$var$pTag
    ],
    [
        "h6",
        $a637c2a3c5f99433$var$pTag
    ],
    [
        "select",
        $a637c2a3c5f99433$var$formTags
    ],
    [
        "input",
        $a637c2a3c5f99433$var$formTags
    ],
    [
        "output",
        $a637c2a3c5f99433$var$formTags
    ],
    [
        "button",
        $a637c2a3c5f99433$var$formTags
    ],
    [
        "datalist",
        $a637c2a3c5f99433$var$formTags
    ],
    [
        "textarea",
        $a637c2a3c5f99433$var$formTags
    ],
    [
        "option",
        new Set([
            "option"
        ])
    ],
    [
        "optgroup",
        new Set([
            "optgroup",
            "option"
        ])
    ],
    [
        "dd",
        $a637c2a3c5f99433$var$ddtTags
    ],
    [
        "dt",
        $a637c2a3c5f99433$var$ddtTags
    ],
    [
        "address",
        $a637c2a3c5f99433$var$pTag
    ],
    [
        "article",
        $a637c2a3c5f99433$var$pTag
    ],
    [
        "aside",
        $a637c2a3c5f99433$var$pTag
    ],
    [
        "blockquote",
        $a637c2a3c5f99433$var$pTag
    ],
    [
        "details",
        $a637c2a3c5f99433$var$pTag
    ],
    [
        "div",
        $a637c2a3c5f99433$var$pTag
    ],
    [
        "dl",
        $a637c2a3c5f99433$var$pTag
    ],
    [
        "fieldset",
        $a637c2a3c5f99433$var$pTag
    ],
    [
        "figcaption",
        $a637c2a3c5f99433$var$pTag
    ],
    [
        "figure",
        $a637c2a3c5f99433$var$pTag
    ],
    [
        "footer",
        $a637c2a3c5f99433$var$pTag
    ],
    [
        "form",
        $a637c2a3c5f99433$var$pTag
    ],
    [
        "header",
        $a637c2a3c5f99433$var$pTag
    ],
    [
        "hr",
        $a637c2a3c5f99433$var$pTag
    ],
    [
        "main",
        $a637c2a3c5f99433$var$pTag
    ],
    [
        "nav",
        $a637c2a3c5f99433$var$pTag
    ],
    [
        "ol",
        $a637c2a3c5f99433$var$pTag
    ],
    [
        "pre",
        $a637c2a3c5f99433$var$pTag
    ],
    [
        "section",
        $a637c2a3c5f99433$var$pTag
    ],
    [
        "table",
        $a637c2a3c5f99433$var$pTag
    ],
    [
        "ul",
        $a637c2a3c5f99433$var$pTag
    ],
    [
        "rt",
        $a637c2a3c5f99433$var$rtpTags
    ],
    [
        "rp",
        $a637c2a3c5f99433$var$rtpTags
    ],
    [
        "tbody",
        $a637c2a3c5f99433$var$tableSectionTags
    ],
    [
        "tfoot",
        $a637c2a3c5f99433$var$tableSectionTags
    ]
]);
const $a637c2a3c5f99433$var$voidElements = new Set([
    "area",
    "base",
    "basefont",
    "br",
    "col",
    "command",
    "embed",
    "frame",
    "hr",
    "img",
    "input",
    "isindex",
    "keygen",
    "link",
    "meta",
    "param",
    "source",
    "track",
    "wbr"
]);
const $a637c2a3c5f99433$var$foreignContextElements = new Set([
    "math",
    "svg"
]);
const $a637c2a3c5f99433$var$htmlIntegrationElements = new Set([
    "mi",
    "mo",
    "mn",
    "ms",
    "mtext",
    "annotation-xml",
    "foreignobject",
    "desc",
    "title"
]);
const $a637c2a3c5f99433$var$reNameEnd = /\s|\//;
class $a637c2a3c5f99433$export$7acfa6ed01010e37 {
    constructor(cbs, options = {}){
        var _a, _b, _c, _d, _e;
        this.options = options;
        /** The start index of the last event. */ this.startIndex = 0;
        /** The end index of the last event. */ this.endIndex = 0;
        /**
         * Store the start index of the current open tag,
         * so we can update the start index for attributes.
         */ this.openTagStart = 0;
        this.tagname = "";
        this.attribname = "";
        this.attribvalue = "";
        this.attribs = null;
        this.stack = [];
        this.foreignContext = [];
        this.buffers = [];
        this.bufferOffset = 0;
        /** The index of the last written buffer. Used when resuming after a `pause()`. */ this.writeIndex = 0;
        /** Indicates whether the parser has finished running / `.end` has been called. */ this.ended = false;
        this.cbs = cbs !== null && cbs !== void 0 ? cbs : {};
        this.lowerCaseTagNames = (_a = options.lowerCaseTags) !== null && _a !== void 0 ? _a : !options.xmlMode;
        this.lowerCaseAttributeNames = (_b = options.lowerCaseAttributeNames) !== null && _b !== void 0 ? _b : !options.xmlMode;
        this.tokenizer = new ((_c = options.Tokenizer) !== null && _c !== void 0 ? _c : (0, $U8ze2.default))(this.options, this);
        (_e = (_d = this.cbs).onparserinit) === null || _e === void 0 || _e.call(_d, this);
    }
    // Tokenizer event handlers
    /** @internal */ ontext(start, endIndex) {
        var _a, _b;
        const data = this.getSlice(start, endIndex);
        this.endIndex = endIndex - 1;
        (_b = (_a = this.cbs).ontext) === null || _b === void 0 || _b.call(_a, data);
        this.startIndex = endIndex;
    }
    /** @internal */ ontextentity(cp) {
        var _a, _b;
        /*
         * Entities can be emitted on the character, or directly after.
         * We use the section start here to get accurate indices.
         */ const index = this.tokenizer.getSectionStart();
        this.endIndex = index - 1;
        (_b = (_a = this.cbs).ontext) === null || _b === void 0 || _b.call(_a, (0, $cqudo.fromCodePoint)(cp));
        this.startIndex = index;
    }
    isVoidElement(name) {
        return !this.options.xmlMode && $a637c2a3c5f99433$var$voidElements.has(name);
    }
    /** @internal */ onopentagname(start, endIndex) {
        this.endIndex = endIndex;
        let name = this.getSlice(start, endIndex);
        if (this.lowerCaseTagNames) name = name.toLowerCase();
        this.emitOpenTag(name);
    }
    emitOpenTag(name) {
        var _a, _b, _c, _d;
        this.openTagStart = this.startIndex;
        this.tagname = name;
        const impliesClose = !this.options.xmlMode && $a637c2a3c5f99433$var$openImpliesClose.get(name);
        if (impliesClose) while(this.stack.length > 0 && impliesClose.has(this.stack[this.stack.length - 1])){
            const element = this.stack.pop();
            (_b = (_a = this.cbs).onclosetag) === null || _b === void 0 || _b.call(_a, element, true);
        }
        if (!this.isVoidElement(name)) {
            this.stack.push(name);
            if ($a637c2a3c5f99433$var$foreignContextElements.has(name)) this.foreignContext.push(true);
            else if ($a637c2a3c5f99433$var$htmlIntegrationElements.has(name)) this.foreignContext.push(false);
        }
        (_d = (_c = this.cbs).onopentagname) === null || _d === void 0 || _d.call(_c, name);
        if (this.cbs.onopentag) this.attribs = {};
    }
    endOpenTag(isImplied) {
        var _a, _b;
        this.startIndex = this.openTagStart;
        if (this.attribs) {
            (_b = (_a = this.cbs).onopentag) === null || _b === void 0 || _b.call(_a, this.tagname, this.attribs, isImplied);
            this.attribs = null;
        }
        if (this.cbs.onclosetag && this.isVoidElement(this.tagname)) this.cbs.onclosetag(this.tagname, true);
        this.tagname = "";
    }
    /** @internal */ onopentagend(endIndex) {
        this.endIndex = endIndex;
        this.endOpenTag(false);
        // Set `startIndex` for next node
        this.startIndex = endIndex + 1;
    }
    /** @internal */ onclosetag(start, endIndex) {
        var _a, _b, _c, _d, _e, _f;
        this.endIndex = endIndex;
        let name = this.getSlice(start, endIndex);
        if (this.lowerCaseTagNames) name = name.toLowerCase();
        if ($a637c2a3c5f99433$var$foreignContextElements.has(name) || $a637c2a3c5f99433$var$htmlIntegrationElements.has(name)) this.foreignContext.pop();
        if (!this.isVoidElement(name)) {
            const pos = this.stack.lastIndexOf(name);
            if (pos !== -1) {
                if (this.cbs.onclosetag) {
                    let count = this.stack.length - pos;
                    while(count--)// We know the stack has sufficient elements.
                    this.cbs.onclosetag(this.stack.pop(), count !== 0);
                } else this.stack.length = pos;
            } else if (!this.options.xmlMode && name === "p") {
                // Implicit open before close
                this.emitOpenTag("p");
                this.closeCurrentTag(true);
            }
        } else if (!this.options.xmlMode && name === "br") {
            // We can't use `emitOpenTag` for implicit open, as `br` would be implicitly closed.
            (_b = (_a = this.cbs).onopentagname) === null || _b === void 0 || _b.call(_a, "br");
            (_d = (_c = this.cbs).onopentag) === null || _d === void 0 || _d.call(_c, "br", {}, true);
            (_f = (_e = this.cbs).onclosetag) === null || _f === void 0 || _f.call(_e, "br", false);
        }
        // Set `startIndex` for next node
        this.startIndex = endIndex + 1;
    }
    /** @internal */ onselfclosingtag(endIndex) {
        this.endIndex = endIndex;
        if (this.options.xmlMode || this.options.recognizeSelfClosing || this.foreignContext[this.foreignContext.length - 1]) {
            this.closeCurrentTag(false);
            // Set `startIndex` for next node
            this.startIndex = endIndex + 1;
        } else // Ignore the fact that the tag is self-closing.
        this.onopentagend(endIndex);
    }
    closeCurrentTag(isOpenImplied) {
        var _a, _b;
        const name = this.tagname;
        this.endOpenTag(isOpenImplied);
        // Self-closing tags will be on the top of the stack
        if (this.stack[this.stack.length - 1] === name) {
            // If the opening tag isn't implied, the closing tag has to be implied.
            (_b = (_a = this.cbs).onclosetag) === null || _b === void 0 || _b.call(_a, name, !isOpenImplied);
            this.stack.pop();
        }
    }
    /** @internal */ onattribname(start, endIndex) {
        this.startIndex = start;
        const name = this.getSlice(start, endIndex);
        this.attribname = this.lowerCaseAttributeNames ? name.toLowerCase() : name;
    }
    /** @internal */ onattribdata(start, endIndex) {
        this.attribvalue += this.getSlice(start, endIndex);
    }
    /** @internal */ onattribentity(cp) {
        this.attribvalue += (0, $cqudo.fromCodePoint)(cp);
    }
    /** @internal */ onattribend(quote, endIndex) {
        var _a, _b;
        this.endIndex = endIndex;
        (_b = (_a = this.cbs).onattribute) === null || _b === void 0 || _b.call(_a, this.attribname, this.attribvalue, quote === (0, $U8ze2.QuoteType).Double ? '"' : quote === (0, $U8ze2.QuoteType).Single ? "'" : quote === (0, $U8ze2.QuoteType).NoValue ? undefined : null);
        if (this.attribs && !Object.prototype.hasOwnProperty.call(this.attribs, this.attribname)) this.attribs[this.attribname] = this.attribvalue;
        this.attribvalue = "";
    }
    getInstructionName(value) {
        const index = value.search($a637c2a3c5f99433$var$reNameEnd);
        let name = index < 0 ? value : value.substr(0, index);
        if (this.lowerCaseTagNames) name = name.toLowerCase();
        return name;
    }
    /** @internal */ ondeclaration(start, endIndex) {
        this.endIndex = endIndex;
        const value = this.getSlice(start, endIndex);
        if (this.cbs.onprocessinginstruction) {
            const name = this.getInstructionName(value);
            this.cbs.onprocessinginstruction(`!${name}`, `!${value}`);
        }
        // Set `startIndex` for next node
        this.startIndex = endIndex + 1;
    }
    /** @internal */ onprocessinginstruction(start, endIndex) {
        this.endIndex = endIndex;
        const value = this.getSlice(start, endIndex);
        if (this.cbs.onprocessinginstruction) {
            const name = this.getInstructionName(value);
            this.cbs.onprocessinginstruction(`?${name}`, `?${value}`);
        }
        // Set `startIndex` for next node
        this.startIndex = endIndex + 1;
    }
    /** @internal */ oncomment(start, endIndex, offset) {
        var _a, _b, _c, _d;
        this.endIndex = endIndex;
        (_b = (_a = this.cbs).oncomment) === null || _b === void 0 || _b.call(_a, this.getSlice(start, endIndex - offset));
        (_d = (_c = this.cbs).oncommentend) === null || _d === void 0 || _d.call(_c);
        // Set `startIndex` for next node
        this.startIndex = endIndex + 1;
    }
    /** @internal */ oncdata(start, endIndex, offset) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
        this.endIndex = endIndex;
        const value = this.getSlice(start, endIndex - offset);
        if (this.options.xmlMode || this.options.recognizeCDATA) {
            (_b = (_a = this.cbs).oncdatastart) === null || _b === void 0 || _b.call(_a);
            (_d = (_c = this.cbs).ontext) === null || _d === void 0 || _d.call(_c, value);
            (_f = (_e = this.cbs).oncdataend) === null || _f === void 0 || _f.call(_e);
        } else {
            (_h = (_g = this.cbs).oncomment) === null || _h === void 0 || _h.call(_g, `[CDATA[${value}]]`);
            (_k = (_j = this.cbs).oncommentend) === null || _k === void 0 || _k.call(_j);
        }
        // Set `startIndex` for next node
        this.startIndex = endIndex + 1;
    }
    /** @internal */ onend() {
        var _a, _b;
        if (this.cbs.onclosetag) {
            // Set the end index for all remaining tags
            this.endIndex = this.startIndex;
            for(let index = this.stack.length; index > 0; this.cbs.onclosetag(this.stack[--index], true));
        }
        (_b = (_a = this.cbs).onend) === null || _b === void 0 || _b.call(_a);
    }
    /**
     * Resets the parser to a blank state, ready to parse a new HTML document
     */ reset() {
        var _a, _b, _c, _d;
        (_b = (_a = this.cbs).onreset) === null || _b === void 0 || _b.call(_a);
        this.tokenizer.reset();
        this.tagname = "";
        this.attribname = "";
        this.attribs = null;
        this.stack.length = 0;
        this.startIndex = 0;
        this.endIndex = 0;
        (_d = (_c = this.cbs).onparserinit) === null || _d === void 0 || _d.call(_c, this);
        this.buffers.length = 0;
        this.bufferOffset = 0;
        this.writeIndex = 0;
        this.ended = false;
    }
    /**
     * Resets the parser, then parses a complete document and
     * pushes it to the handler.
     *
     * @param data Document to parse.
     */ parseComplete(data) {
        this.reset();
        this.end(data);
    }
    getSlice(start, end) {
        while(start - this.bufferOffset >= this.buffers[0].length)this.shiftBuffer();
        let slice = this.buffers[0].slice(start - this.bufferOffset, end - this.bufferOffset);
        while(end - this.bufferOffset > this.buffers[0].length){
            this.shiftBuffer();
            slice += this.buffers[0].slice(0, end - this.bufferOffset);
        }
        return slice;
    }
    shiftBuffer() {
        this.bufferOffset += this.buffers[0].length;
        this.writeIndex--;
        this.buffers.shift();
    }
    /**
     * Parses a chunk of data and calls the corresponding callbacks.
     *
     * @param chunk Chunk to parse.
     */ write(chunk) {
        var _a, _b;
        if (this.ended) {
            (_b = (_a = this.cbs).onerror) === null || _b === void 0 || _b.call(_a, new Error(".write() after done!"));
            return;
        }
        this.buffers.push(chunk);
        if (this.tokenizer.running) {
            this.tokenizer.write(chunk);
            this.writeIndex++;
        }
    }
    /**
     * Parses the end of the buffer and clears the stack, calls onend.
     *
     * @param chunk Optional final chunk to parse.
     */ end(chunk) {
        var _a, _b;
        if (this.ended) {
            (_b = (_a = this.cbs).onerror) === null || _b === void 0 || _b.call(_a, new Error(".end() after done!"));
            return;
        }
        if (chunk) this.write(chunk);
        this.ended = true;
        this.tokenizer.end();
    }
    /**
     * Pauses parsing. The parser won't emit events until `resume` is called.
     */ pause() {
        this.tokenizer.pause();
    }
    /**
     * Resumes parsing after `pause` was called.
     */ resume() {
        this.tokenizer.resume();
        while(this.tokenizer.running && this.writeIndex < this.buffers.length)this.tokenizer.write(this.buffers[this.writeIndex++]);
        if (this.ended) this.tokenizer.end();
    }
    /**
     * Alias of `write`, for backwards compatibility.
     *
     * @param chunk Chunk to parse.
     * @deprecated
     */ parseChunk(chunk) {
        this.write(chunk);
    }
    /**
     * Alias of `end`, for backwards compatibility.
     *
     * @param chunk Optional final chunk to parse.
     * @deprecated
     */ done(chunk) {
        this.end(chunk);
    }
}

});
parcelRequire.register("U8ze2", function(module, exports) {

$parcel$export(module.exports, "QuoteType", () => $0a8be055dcf7e2c9$export$cbf5509cea2ad22);
$parcel$export(module.exports, "default", () => $0a8be055dcf7e2c9$export$2e2bcd8739ae039);

var $cqudo = parcelRequire("cqudo");
var $0a8be055dcf7e2c9$var$CharCodes;
(function(CharCodes) {
    CharCodes[CharCodes["Tab"] = 9] = "Tab";
    CharCodes[CharCodes["NewLine"] = 10] = "NewLine";
    CharCodes[CharCodes["FormFeed"] = 12] = "FormFeed";
    CharCodes[CharCodes["CarriageReturn"] = 13] = "CarriageReturn";
    CharCodes[CharCodes["Space"] = 32] = "Space";
    CharCodes[CharCodes["ExclamationMark"] = 33] = "ExclamationMark";
    CharCodes[CharCodes["Number"] = 35] = "Number";
    CharCodes[CharCodes["Amp"] = 38] = "Amp";
    CharCodes[CharCodes["SingleQuote"] = 39] = "SingleQuote";
    CharCodes[CharCodes["DoubleQuote"] = 34] = "DoubleQuote";
    CharCodes[CharCodes["Dash"] = 45] = "Dash";
    CharCodes[CharCodes["Slash"] = 47] = "Slash";
    CharCodes[CharCodes["Zero"] = 48] = "Zero";
    CharCodes[CharCodes["Nine"] = 57] = "Nine";
    CharCodes[CharCodes["Semi"] = 59] = "Semi";
    CharCodes[CharCodes["Lt"] = 60] = "Lt";
    CharCodes[CharCodes["Eq"] = 61] = "Eq";
    CharCodes[CharCodes["Gt"] = 62] = "Gt";
    CharCodes[CharCodes["Questionmark"] = 63] = "Questionmark";
    CharCodes[CharCodes["UpperA"] = 65] = "UpperA";
    CharCodes[CharCodes["LowerA"] = 97] = "LowerA";
    CharCodes[CharCodes["UpperF"] = 70] = "UpperF";
    CharCodes[CharCodes["LowerF"] = 102] = "LowerF";
    CharCodes[CharCodes["UpperZ"] = 90] = "UpperZ";
    CharCodes[CharCodes["LowerZ"] = 122] = "LowerZ";
    CharCodes[CharCodes["LowerX"] = 120] = "LowerX";
    CharCodes[CharCodes["OpeningSquareBracket"] = 91] = "OpeningSquareBracket";
})($0a8be055dcf7e2c9$var$CharCodes || ($0a8be055dcf7e2c9$var$CharCodes = {}));
/** All the states the tokenizer can be in. */ var $0a8be055dcf7e2c9$var$State;
(function(State) {
    State[State["Text"] = 1] = "Text";
    State[State["BeforeTagName"] = 2] = "BeforeTagName";
    State[State["InTagName"] = 3] = "InTagName";
    State[State["InSelfClosingTag"] = 4] = "InSelfClosingTag";
    State[State["BeforeClosingTagName"] = 5] = "BeforeClosingTagName";
    State[State["InClosingTagName"] = 6] = "InClosingTagName";
    State[State["AfterClosingTagName"] = 7] = "AfterClosingTagName";
    // Attributes
    State[State["BeforeAttributeName"] = 8] = "BeforeAttributeName";
    State[State["InAttributeName"] = 9] = "InAttributeName";
    State[State["AfterAttributeName"] = 10] = "AfterAttributeName";
    State[State["BeforeAttributeValue"] = 11] = "BeforeAttributeValue";
    State[State["InAttributeValueDq"] = 12] = "InAttributeValueDq";
    State[State["InAttributeValueSq"] = 13] = "InAttributeValueSq";
    State[State["InAttributeValueNq"] = 14] = "InAttributeValueNq";
    // Declarations
    State[State["BeforeDeclaration"] = 15] = "BeforeDeclaration";
    State[State["InDeclaration"] = 16] = "InDeclaration";
    // Processing instructions
    State[State["InProcessingInstruction"] = 17] = "InProcessingInstruction";
    // Comments & CDATA
    State[State["BeforeComment"] = 18] = "BeforeComment";
    State[State["CDATASequence"] = 19] = "CDATASequence";
    State[State["InSpecialComment"] = 20] = "InSpecialComment";
    State[State["InCommentLike"] = 21] = "InCommentLike";
    // Special tags
    State[State["BeforeSpecialS"] = 22] = "BeforeSpecialS";
    State[State["SpecialStartSequence"] = 23] = "SpecialStartSequence";
    State[State["InSpecialTag"] = 24] = "InSpecialTag";
    State[State["BeforeEntity"] = 25] = "BeforeEntity";
    State[State["BeforeNumericEntity"] = 26] = "BeforeNumericEntity";
    State[State["InNamedEntity"] = 27] = "InNamedEntity";
    State[State["InNumericEntity"] = 28] = "InNumericEntity";
    State[State["InHexEntity"] = 29] = "InHexEntity";
})($0a8be055dcf7e2c9$var$State || ($0a8be055dcf7e2c9$var$State = {}));
function $0a8be055dcf7e2c9$var$isWhitespace(c) {
    return c === $0a8be055dcf7e2c9$var$CharCodes.Space || c === $0a8be055dcf7e2c9$var$CharCodes.NewLine || c === $0a8be055dcf7e2c9$var$CharCodes.Tab || c === $0a8be055dcf7e2c9$var$CharCodes.FormFeed || c === $0a8be055dcf7e2c9$var$CharCodes.CarriageReturn;
}
function $0a8be055dcf7e2c9$var$isEndOfTagSection(c) {
    return c === $0a8be055dcf7e2c9$var$CharCodes.Slash || c === $0a8be055dcf7e2c9$var$CharCodes.Gt || $0a8be055dcf7e2c9$var$isWhitespace(c);
}
function $0a8be055dcf7e2c9$var$isNumber(c) {
    return c >= $0a8be055dcf7e2c9$var$CharCodes.Zero && c <= $0a8be055dcf7e2c9$var$CharCodes.Nine;
}
function $0a8be055dcf7e2c9$var$isASCIIAlpha(c) {
    return c >= $0a8be055dcf7e2c9$var$CharCodes.LowerA && c <= $0a8be055dcf7e2c9$var$CharCodes.LowerZ || c >= $0a8be055dcf7e2c9$var$CharCodes.UpperA && c <= $0a8be055dcf7e2c9$var$CharCodes.UpperZ;
}
function $0a8be055dcf7e2c9$var$isHexDigit(c) {
    return c >= $0a8be055dcf7e2c9$var$CharCodes.UpperA && c <= $0a8be055dcf7e2c9$var$CharCodes.UpperF || c >= $0a8be055dcf7e2c9$var$CharCodes.LowerA && c <= $0a8be055dcf7e2c9$var$CharCodes.LowerF;
}
var $0a8be055dcf7e2c9$export$cbf5509cea2ad22;
(function(QuoteType) {
    QuoteType[QuoteType["NoValue"] = 0] = "NoValue";
    QuoteType[QuoteType["Unquoted"] = 1] = "Unquoted";
    QuoteType[QuoteType["Single"] = 2] = "Single";
    QuoteType[QuoteType["Double"] = 3] = "Double";
})($0a8be055dcf7e2c9$export$cbf5509cea2ad22 || ($0a8be055dcf7e2c9$export$cbf5509cea2ad22 = {}));
/**
 * Sequences used to match longer strings.
 *
 * We don't have `Script`, `Style`, or `Title` here. Instead, we re-use the *End
 * sequences with an increased offset.
 */ const $0a8be055dcf7e2c9$var$Sequences = {
    Cdata: new Uint8Array([
        0x43,
        0x44,
        0x41,
        0x54,
        0x41,
        0x5b
    ]),
    CdataEnd: new Uint8Array([
        0x5d,
        0x5d,
        0x3e
    ]),
    CommentEnd: new Uint8Array([
        0x2d,
        0x2d,
        0x3e
    ]),
    ScriptEnd: new Uint8Array([
        0x3c,
        0x2f,
        0x73,
        0x63,
        0x72,
        0x69,
        0x70,
        0x74
    ]),
    StyleEnd: new Uint8Array([
        0x3c,
        0x2f,
        0x73,
        0x74,
        0x79,
        0x6c,
        0x65
    ]),
    TitleEnd: new Uint8Array([
        0x3c,
        0x2f,
        0x74,
        0x69,
        0x74,
        0x6c,
        0x65
    ])
};
class $0a8be055dcf7e2c9$export$2e2bcd8739ae039 {
    constructor({ xmlMode: xmlMode = false, decodeEntities: decodeEntities = true }, cbs){
        this.cbs = cbs;
        /** The current state the tokenizer is in. */ this.state = $0a8be055dcf7e2c9$var$State.Text;
        /** The read buffer. */ this.buffer = "";
        /** The beginning of the section that is currently being read. */ this.sectionStart = 0;
        /** The index within the buffer that we are currently looking at. */ this.index = 0;
        /** Some behavior, eg. when decoding entities, is done while we are in another state. This keeps track of the other state type. */ this.baseState = $0a8be055dcf7e2c9$var$State.Text;
        /** For special parsing behavior inside of script and style tags. */ this.isSpecial = false;
        /** Indicates whether the tokenizer has been paused. */ this.running = true;
        /** The offset of the current buffer. */ this.offset = 0;
        this.currentSequence = undefined;
        this.sequenceIndex = 0;
        this.trieIndex = 0;
        this.trieCurrent = 0;
        /** For named entities, the index of the value. For numeric entities, the code point. */ this.entityResult = 0;
        this.entityExcess = 0;
        this.xmlMode = xmlMode;
        this.decodeEntities = decodeEntities;
        this.entityTrie = xmlMode ? (0, $cqudo.xmlDecodeTree) : (0, $cqudo.htmlDecodeTree);
    }
    reset() {
        this.state = $0a8be055dcf7e2c9$var$State.Text;
        this.buffer = "";
        this.sectionStart = 0;
        this.index = 0;
        this.baseState = $0a8be055dcf7e2c9$var$State.Text;
        this.currentSequence = undefined;
        this.running = true;
        this.offset = 0;
    }
    write(chunk) {
        this.offset += this.buffer.length;
        this.buffer = chunk;
        this.parse();
    }
    end() {
        if (this.running) this.finish();
    }
    pause() {
        this.running = false;
    }
    resume() {
        this.running = true;
        if (this.index < this.buffer.length + this.offset) this.parse();
    }
    /**
     * The current index within all of the written data.
     */ getIndex() {
        return this.index;
    }
    /**
     * The start of the current section.
     */ getSectionStart() {
        return this.sectionStart;
    }
    stateText(c) {
        if (c === $0a8be055dcf7e2c9$var$CharCodes.Lt || !this.decodeEntities && this.fastForwardTo($0a8be055dcf7e2c9$var$CharCodes.Lt)) {
            if (this.index > this.sectionStart) this.cbs.ontext(this.sectionStart, this.index);
            this.state = $0a8be055dcf7e2c9$var$State.BeforeTagName;
            this.sectionStart = this.index;
        } else if (this.decodeEntities && c === $0a8be055dcf7e2c9$var$CharCodes.Amp) this.state = $0a8be055dcf7e2c9$var$State.BeforeEntity;
    }
    stateSpecialStartSequence(c) {
        const isEnd = this.sequenceIndex === this.currentSequence.length;
        const isMatch = isEnd ? $0a8be055dcf7e2c9$var$isEndOfTagSection(c) : (c | 0x20) === this.currentSequence[this.sequenceIndex];
        if (!isMatch) this.isSpecial = false;
        else if (!isEnd) {
            this.sequenceIndex++;
            return;
        }
        this.sequenceIndex = 0;
        this.state = $0a8be055dcf7e2c9$var$State.InTagName;
        this.stateInTagName(c);
    }
    /** Look for an end tag. For <title> tags, also decode entities. */ stateInSpecialTag(c) {
        if (this.sequenceIndex === this.currentSequence.length) {
            if (c === $0a8be055dcf7e2c9$var$CharCodes.Gt || $0a8be055dcf7e2c9$var$isWhitespace(c)) {
                const endOfText = this.index - this.currentSequence.length;
                if (this.sectionStart < endOfText) {
                    // Spoof the index so that reported locations match up.
                    const actualIndex = this.index;
                    this.index = endOfText;
                    this.cbs.ontext(this.sectionStart, endOfText);
                    this.index = actualIndex;
                }
                this.isSpecial = false;
                this.sectionStart = endOfText + 2; // Skip over the `</`
                this.stateInClosingTagName(c);
                return; // We are done; skip the rest of the function.
            }
            this.sequenceIndex = 0;
        }
        if ((c | 0x20) === this.currentSequence[this.sequenceIndex]) this.sequenceIndex += 1;
        else if (this.sequenceIndex === 0) {
            if (this.currentSequence === $0a8be055dcf7e2c9$var$Sequences.TitleEnd) // We have to parse entities in <title> tags.
            {
                if (this.decodeEntities && c === $0a8be055dcf7e2c9$var$CharCodes.Amp) this.state = $0a8be055dcf7e2c9$var$State.BeforeEntity;
            } else if (this.fastForwardTo($0a8be055dcf7e2c9$var$CharCodes.Lt)) // Outside of <title> tags, we can fast-forward.
            this.sequenceIndex = 1;
        } else // If we see a `<`, set the sequence index to 1; useful for eg. `<</script>`.
        this.sequenceIndex = Number(c === $0a8be055dcf7e2c9$var$CharCodes.Lt);
    }
    stateCDATASequence(c) {
        if (c === $0a8be055dcf7e2c9$var$Sequences.Cdata[this.sequenceIndex]) {
            if (++this.sequenceIndex === $0a8be055dcf7e2c9$var$Sequences.Cdata.length) {
                this.state = $0a8be055dcf7e2c9$var$State.InCommentLike;
                this.currentSequence = $0a8be055dcf7e2c9$var$Sequences.CdataEnd;
                this.sequenceIndex = 0;
                this.sectionStart = this.index + 1;
            }
        } else {
            this.sequenceIndex = 0;
            this.state = $0a8be055dcf7e2c9$var$State.InDeclaration;
            this.stateInDeclaration(c); // Reconsume the character
        }
    }
    /**
     * When we wait for one specific character, we can speed things up
     * by skipping through the buffer until we find it.
     *
     * @returns Whether the character was found.
     */ fastForwardTo(c) {
        while(++this.index < this.buffer.length + this.offset){
            if (this.buffer.charCodeAt(this.index - this.offset) === c) return true;
        }
        /*
         * We increment the index at the end of the `parse` loop,
         * so set it to `buffer.length - 1` here.
         *
         * TODO: Refactor `parse` to increment index before calling states.
         */ this.index = this.buffer.length + this.offset - 1;
        return false;
    }
    /**
     * Comments and CDATA end with `-->` and `]]>`.
     *
     * Their common qualities are:
     * - Their end sequences have a distinct character they start with.
     * - That character is then repeated, so we have to check multiple repeats.
     * - All characters but the start character of the sequence can be skipped.
     */ stateInCommentLike(c) {
        if (c === this.currentSequence[this.sequenceIndex]) {
            if (++this.sequenceIndex === this.currentSequence.length) {
                if (this.currentSequence === $0a8be055dcf7e2c9$var$Sequences.CdataEnd) this.cbs.oncdata(this.sectionStart, this.index, 2);
                else this.cbs.oncomment(this.sectionStart, this.index, 2);
                this.sequenceIndex = 0;
                this.sectionStart = this.index + 1;
                this.state = $0a8be055dcf7e2c9$var$State.Text;
            }
        } else if (this.sequenceIndex === 0) // Fast-forward to the first character of the sequence
        {
            if (this.fastForwardTo(this.currentSequence[0])) this.sequenceIndex = 1;
        } else if (c !== this.currentSequence[this.sequenceIndex - 1]) // Allow long sequences, eg. --->, ]]]>
        this.sequenceIndex = 0;
    }
    /**
     * HTML only allows ASCII alpha characters (a-z and A-Z) at the beginning of a tag name.
     *
     * XML allows a lot more characters here (@see https://www.w3.org/TR/REC-xml/#NT-NameStartChar).
     * We allow anything that wouldn't end the tag.
     */ isTagStartChar(c) {
        return this.xmlMode ? !$0a8be055dcf7e2c9$var$isEndOfTagSection(c) : $0a8be055dcf7e2c9$var$isASCIIAlpha(c);
    }
    startSpecial(sequence, offset) {
        this.isSpecial = true;
        this.currentSequence = sequence;
        this.sequenceIndex = offset;
        this.state = $0a8be055dcf7e2c9$var$State.SpecialStartSequence;
    }
    stateBeforeTagName(c) {
        if (c === $0a8be055dcf7e2c9$var$CharCodes.ExclamationMark) {
            this.state = $0a8be055dcf7e2c9$var$State.BeforeDeclaration;
            this.sectionStart = this.index + 1;
        } else if (c === $0a8be055dcf7e2c9$var$CharCodes.Questionmark) {
            this.state = $0a8be055dcf7e2c9$var$State.InProcessingInstruction;
            this.sectionStart = this.index + 1;
        } else if (this.isTagStartChar(c)) {
            const lower = c | 0x20;
            this.sectionStart = this.index;
            if (!this.xmlMode && lower === $0a8be055dcf7e2c9$var$Sequences.TitleEnd[2]) this.startSpecial($0a8be055dcf7e2c9$var$Sequences.TitleEnd, 3);
            else this.state = !this.xmlMode && lower === $0a8be055dcf7e2c9$var$Sequences.ScriptEnd[2] ? $0a8be055dcf7e2c9$var$State.BeforeSpecialS : $0a8be055dcf7e2c9$var$State.InTagName;
        } else if (c === $0a8be055dcf7e2c9$var$CharCodes.Slash) this.state = $0a8be055dcf7e2c9$var$State.BeforeClosingTagName;
        else {
            this.state = $0a8be055dcf7e2c9$var$State.Text;
            this.stateText(c);
        }
    }
    stateInTagName(c) {
        if ($0a8be055dcf7e2c9$var$isEndOfTagSection(c)) {
            this.cbs.onopentagname(this.sectionStart, this.index);
            this.sectionStart = -1;
            this.state = $0a8be055dcf7e2c9$var$State.BeforeAttributeName;
            this.stateBeforeAttributeName(c);
        }
    }
    stateBeforeClosingTagName(c) {
        if ($0a8be055dcf7e2c9$var$isWhitespace(c)) ;
        else if (c === $0a8be055dcf7e2c9$var$CharCodes.Gt) this.state = $0a8be055dcf7e2c9$var$State.Text;
        else {
            this.state = this.isTagStartChar(c) ? $0a8be055dcf7e2c9$var$State.InClosingTagName : $0a8be055dcf7e2c9$var$State.InSpecialComment;
            this.sectionStart = this.index;
        }
    }
    stateInClosingTagName(c) {
        if (c === $0a8be055dcf7e2c9$var$CharCodes.Gt || $0a8be055dcf7e2c9$var$isWhitespace(c)) {
            this.cbs.onclosetag(this.sectionStart, this.index);
            this.sectionStart = -1;
            this.state = $0a8be055dcf7e2c9$var$State.AfterClosingTagName;
            this.stateAfterClosingTagName(c);
        }
    }
    stateAfterClosingTagName(c) {
        // Skip everything until ">"
        if (c === $0a8be055dcf7e2c9$var$CharCodes.Gt || this.fastForwardTo($0a8be055dcf7e2c9$var$CharCodes.Gt)) {
            this.state = $0a8be055dcf7e2c9$var$State.Text;
            this.baseState = $0a8be055dcf7e2c9$var$State.Text;
            this.sectionStart = this.index + 1;
        }
    }
    stateBeforeAttributeName(c) {
        if (c === $0a8be055dcf7e2c9$var$CharCodes.Gt) {
            this.cbs.onopentagend(this.index);
            if (this.isSpecial) {
                this.state = $0a8be055dcf7e2c9$var$State.InSpecialTag;
                this.sequenceIndex = 0;
            } else this.state = $0a8be055dcf7e2c9$var$State.Text;
            this.baseState = this.state;
            this.sectionStart = this.index + 1;
        } else if (c === $0a8be055dcf7e2c9$var$CharCodes.Slash) this.state = $0a8be055dcf7e2c9$var$State.InSelfClosingTag;
        else if (!$0a8be055dcf7e2c9$var$isWhitespace(c)) {
            this.state = $0a8be055dcf7e2c9$var$State.InAttributeName;
            this.sectionStart = this.index;
        }
    }
    stateInSelfClosingTag(c) {
        if (c === $0a8be055dcf7e2c9$var$CharCodes.Gt) {
            this.cbs.onselfclosingtag(this.index);
            this.state = $0a8be055dcf7e2c9$var$State.Text;
            this.baseState = $0a8be055dcf7e2c9$var$State.Text;
            this.sectionStart = this.index + 1;
            this.isSpecial = false; // Reset special state, in case of self-closing special tags
        } else if (!$0a8be055dcf7e2c9$var$isWhitespace(c)) {
            this.state = $0a8be055dcf7e2c9$var$State.BeforeAttributeName;
            this.stateBeforeAttributeName(c);
        }
    }
    stateInAttributeName(c) {
        if (c === $0a8be055dcf7e2c9$var$CharCodes.Eq || $0a8be055dcf7e2c9$var$isEndOfTagSection(c)) {
            this.cbs.onattribname(this.sectionStart, this.index);
            this.sectionStart = -1;
            this.state = $0a8be055dcf7e2c9$var$State.AfterAttributeName;
            this.stateAfterAttributeName(c);
        }
    }
    stateAfterAttributeName(c) {
        if (c === $0a8be055dcf7e2c9$var$CharCodes.Eq) this.state = $0a8be055dcf7e2c9$var$State.BeforeAttributeValue;
        else if (c === $0a8be055dcf7e2c9$var$CharCodes.Slash || c === $0a8be055dcf7e2c9$var$CharCodes.Gt) {
            this.cbs.onattribend($0a8be055dcf7e2c9$export$cbf5509cea2ad22.NoValue, this.index);
            this.state = $0a8be055dcf7e2c9$var$State.BeforeAttributeName;
            this.stateBeforeAttributeName(c);
        } else if (!$0a8be055dcf7e2c9$var$isWhitespace(c)) {
            this.cbs.onattribend($0a8be055dcf7e2c9$export$cbf5509cea2ad22.NoValue, this.index);
            this.state = $0a8be055dcf7e2c9$var$State.InAttributeName;
            this.sectionStart = this.index;
        }
    }
    stateBeforeAttributeValue(c) {
        if (c === $0a8be055dcf7e2c9$var$CharCodes.DoubleQuote) {
            this.state = $0a8be055dcf7e2c9$var$State.InAttributeValueDq;
            this.sectionStart = this.index + 1;
        } else if (c === $0a8be055dcf7e2c9$var$CharCodes.SingleQuote) {
            this.state = $0a8be055dcf7e2c9$var$State.InAttributeValueSq;
            this.sectionStart = this.index + 1;
        } else if (!$0a8be055dcf7e2c9$var$isWhitespace(c)) {
            this.sectionStart = this.index;
            this.state = $0a8be055dcf7e2c9$var$State.InAttributeValueNq;
            this.stateInAttributeValueNoQuotes(c); // Reconsume token
        }
    }
    handleInAttributeValue(c, quote) {
        if (c === quote || !this.decodeEntities && this.fastForwardTo(quote)) {
            this.cbs.onattribdata(this.sectionStart, this.index);
            this.sectionStart = -1;
            this.cbs.onattribend(quote === $0a8be055dcf7e2c9$var$CharCodes.DoubleQuote ? $0a8be055dcf7e2c9$export$cbf5509cea2ad22.Double : $0a8be055dcf7e2c9$export$cbf5509cea2ad22.Single, this.index);
            this.state = $0a8be055dcf7e2c9$var$State.BeforeAttributeName;
        } else if (this.decodeEntities && c === $0a8be055dcf7e2c9$var$CharCodes.Amp) {
            this.baseState = this.state;
            this.state = $0a8be055dcf7e2c9$var$State.BeforeEntity;
        }
    }
    stateInAttributeValueDoubleQuotes(c) {
        this.handleInAttributeValue(c, $0a8be055dcf7e2c9$var$CharCodes.DoubleQuote);
    }
    stateInAttributeValueSingleQuotes(c) {
        this.handleInAttributeValue(c, $0a8be055dcf7e2c9$var$CharCodes.SingleQuote);
    }
    stateInAttributeValueNoQuotes(c) {
        if ($0a8be055dcf7e2c9$var$isWhitespace(c) || c === $0a8be055dcf7e2c9$var$CharCodes.Gt) {
            this.cbs.onattribdata(this.sectionStart, this.index);
            this.sectionStart = -1;
            this.cbs.onattribend($0a8be055dcf7e2c9$export$cbf5509cea2ad22.Unquoted, this.index);
            this.state = $0a8be055dcf7e2c9$var$State.BeforeAttributeName;
            this.stateBeforeAttributeName(c);
        } else if (this.decodeEntities && c === $0a8be055dcf7e2c9$var$CharCodes.Amp) {
            this.baseState = this.state;
            this.state = $0a8be055dcf7e2c9$var$State.BeforeEntity;
        }
    }
    stateBeforeDeclaration(c) {
        if (c === $0a8be055dcf7e2c9$var$CharCodes.OpeningSquareBracket) {
            this.state = $0a8be055dcf7e2c9$var$State.CDATASequence;
            this.sequenceIndex = 0;
        } else this.state = c === $0a8be055dcf7e2c9$var$CharCodes.Dash ? $0a8be055dcf7e2c9$var$State.BeforeComment : $0a8be055dcf7e2c9$var$State.InDeclaration;
    }
    stateInDeclaration(c) {
        if (c === $0a8be055dcf7e2c9$var$CharCodes.Gt || this.fastForwardTo($0a8be055dcf7e2c9$var$CharCodes.Gt)) {
            this.cbs.ondeclaration(this.sectionStart, this.index);
            this.state = $0a8be055dcf7e2c9$var$State.Text;
            this.sectionStart = this.index + 1;
        }
    }
    stateInProcessingInstruction(c) {
        if (c === $0a8be055dcf7e2c9$var$CharCodes.Gt || this.fastForwardTo($0a8be055dcf7e2c9$var$CharCodes.Gt)) {
            this.cbs.onprocessinginstruction(this.sectionStart, this.index);
            this.state = $0a8be055dcf7e2c9$var$State.Text;
            this.sectionStart = this.index + 1;
        }
    }
    stateBeforeComment(c) {
        if (c === $0a8be055dcf7e2c9$var$CharCodes.Dash) {
            this.state = $0a8be055dcf7e2c9$var$State.InCommentLike;
            this.currentSequence = $0a8be055dcf7e2c9$var$Sequences.CommentEnd;
            // Allow short comments (eg. <!-->)
            this.sequenceIndex = 2;
            this.sectionStart = this.index + 1;
        } else this.state = $0a8be055dcf7e2c9$var$State.InDeclaration;
    }
    stateInSpecialComment(c) {
        if (c === $0a8be055dcf7e2c9$var$CharCodes.Gt || this.fastForwardTo($0a8be055dcf7e2c9$var$CharCodes.Gt)) {
            this.cbs.oncomment(this.sectionStart, this.index, 0);
            this.state = $0a8be055dcf7e2c9$var$State.Text;
            this.sectionStart = this.index + 1;
        }
    }
    stateBeforeSpecialS(c) {
        const lower = c | 0x20;
        if (lower === $0a8be055dcf7e2c9$var$Sequences.ScriptEnd[3]) this.startSpecial($0a8be055dcf7e2c9$var$Sequences.ScriptEnd, 4);
        else if (lower === $0a8be055dcf7e2c9$var$Sequences.StyleEnd[3]) this.startSpecial($0a8be055dcf7e2c9$var$Sequences.StyleEnd, 4);
        else {
            this.state = $0a8be055dcf7e2c9$var$State.InTagName;
            this.stateInTagName(c); // Consume the token again
        }
    }
    stateBeforeEntity(c) {
        // Start excess with 1 to include the '&'
        this.entityExcess = 1;
        this.entityResult = 0;
        if (c === $0a8be055dcf7e2c9$var$CharCodes.Number) this.state = $0a8be055dcf7e2c9$var$State.BeforeNumericEntity;
        else if (c === $0a8be055dcf7e2c9$var$CharCodes.Amp) ;
        else {
            this.trieIndex = 0;
            this.trieCurrent = this.entityTrie[0];
            this.state = $0a8be055dcf7e2c9$var$State.InNamedEntity;
            this.stateInNamedEntity(c);
        }
    }
    stateInNamedEntity(c) {
        this.entityExcess += 1;
        this.trieIndex = (0, $cqudo.determineBranch)(this.entityTrie, this.trieCurrent, this.trieIndex + 1, c);
        if (this.trieIndex < 0) {
            this.emitNamedEntity();
            this.index--;
            return;
        }
        this.trieCurrent = this.entityTrie[this.trieIndex];
        const masked = this.trieCurrent & (0, $cqudo.BinTrieFlags).VALUE_LENGTH;
        // If the branch is a value, store it and continue
        if (masked) {
            // The mask is the number of bytes of the value, including the current byte.
            const valueLength = (masked >> 14) - 1;
            // If we have a legacy entity while parsing strictly, just skip the number of bytes
            if (!this.allowLegacyEntity() && c !== $0a8be055dcf7e2c9$var$CharCodes.Semi) this.trieIndex += valueLength;
            else {
                // Add 1 as we have already incremented the excess
                const entityStart = this.index - this.entityExcess + 1;
                if (entityStart > this.sectionStart) this.emitPartial(this.sectionStart, entityStart);
                // If this is a surrogate pair, consume the next two bytes
                this.entityResult = this.trieIndex;
                this.trieIndex += valueLength;
                this.entityExcess = 0;
                this.sectionStart = this.index + 1;
                if (valueLength === 0) this.emitNamedEntity();
            }
        }
    }
    emitNamedEntity() {
        this.state = this.baseState;
        if (this.entityResult === 0) return;
        const valueLength = (this.entityTrie[this.entityResult] & (0, $cqudo.BinTrieFlags).VALUE_LENGTH) >> 14;
        switch(valueLength){
            case 1:
                this.emitCodePoint(this.entityTrie[this.entityResult] & ~(0, $cqudo.BinTrieFlags).VALUE_LENGTH);
                break;
            case 2:
                this.emitCodePoint(this.entityTrie[this.entityResult + 1]);
                break;
            case 3:
                this.emitCodePoint(this.entityTrie[this.entityResult + 1]);
                this.emitCodePoint(this.entityTrie[this.entityResult + 2]);
        }
    }
    stateBeforeNumericEntity(c) {
        if ((c | 0x20) === $0a8be055dcf7e2c9$var$CharCodes.LowerX) {
            this.entityExcess++;
            this.state = $0a8be055dcf7e2c9$var$State.InHexEntity;
        } else {
            this.state = $0a8be055dcf7e2c9$var$State.InNumericEntity;
            this.stateInNumericEntity(c);
        }
    }
    emitNumericEntity(strict) {
        const entityStart = this.index - this.entityExcess - 1;
        const numberStart = entityStart + 2 + Number(this.state === $0a8be055dcf7e2c9$var$State.InHexEntity);
        if (numberStart !== this.index) {
            // Emit leading data if any
            if (entityStart > this.sectionStart) this.emitPartial(this.sectionStart, entityStart);
            this.sectionStart = this.index + Number(strict);
            this.emitCodePoint((0, $cqudo.replaceCodePoint)(this.entityResult));
        }
        this.state = this.baseState;
    }
    stateInNumericEntity(c) {
        if (c === $0a8be055dcf7e2c9$var$CharCodes.Semi) this.emitNumericEntity(true);
        else if ($0a8be055dcf7e2c9$var$isNumber(c)) {
            this.entityResult = this.entityResult * 10 + (c - $0a8be055dcf7e2c9$var$CharCodes.Zero);
            this.entityExcess++;
        } else {
            if (this.allowLegacyEntity()) this.emitNumericEntity(false);
            else this.state = this.baseState;
            this.index--;
        }
    }
    stateInHexEntity(c) {
        if (c === $0a8be055dcf7e2c9$var$CharCodes.Semi) this.emitNumericEntity(true);
        else if ($0a8be055dcf7e2c9$var$isNumber(c)) {
            this.entityResult = this.entityResult * 16 + (c - $0a8be055dcf7e2c9$var$CharCodes.Zero);
            this.entityExcess++;
        } else if ($0a8be055dcf7e2c9$var$isHexDigit(c)) {
            this.entityResult = this.entityResult * 16 + ((c | 0x20) - $0a8be055dcf7e2c9$var$CharCodes.LowerA + 10);
            this.entityExcess++;
        } else {
            if (this.allowLegacyEntity()) this.emitNumericEntity(false);
            else this.state = this.baseState;
            this.index--;
        }
    }
    allowLegacyEntity() {
        return !this.xmlMode && (this.baseState === $0a8be055dcf7e2c9$var$State.Text || this.baseState === $0a8be055dcf7e2c9$var$State.InSpecialTag);
    }
    /**
     * Remove data that has already been consumed from the buffer.
     */ cleanup() {
        // If we are inside of text or attributes, emit what we already have.
        if (this.running && this.sectionStart !== this.index) {
            if (this.state === $0a8be055dcf7e2c9$var$State.Text || this.state === $0a8be055dcf7e2c9$var$State.InSpecialTag && this.sequenceIndex === 0) {
                this.cbs.ontext(this.sectionStart, this.index);
                this.sectionStart = this.index;
            } else if (this.state === $0a8be055dcf7e2c9$var$State.InAttributeValueDq || this.state === $0a8be055dcf7e2c9$var$State.InAttributeValueSq || this.state === $0a8be055dcf7e2c9$var$State.InAttributeValueNq) {
                this.cbs.onattribdata(this.sectionStart, this.index);
                this.sectionStart = this.index;
            }
        }
    }
    shouldContinue() {
        return this.index < this.buffer.length + this.offset && this.running;
    }
    /**
     * Iterates through the buffer, calling the function corresponding to the current state.
     *
     * States that are more likely to be hit are higher up, as a performance improvement.
     */ parse() {
        while(this.shouldContinue()){
            const c = this.buffer.charCodeAt(this.index - this.offset);
            switch(this.state){
                case $0a8be055dcf7e2c9$var$State.Text:
                    this.stateText(c);
                    break;
                case $0a8be055dcf7e2c9$var$State.SpecialStartSequence:
                    this.stateSpecialStartSequence(c);
                    break;
                case $0a8be055dcf7e2c9$var$State.InSpecialTag:
                    this.stateInSpecialTag(c);
                    break;
                case $0a8be055dcf7e2c9$var$State.CDATASequence:
                    this.stateCDATASequence(c);
                    break;
                case $0a8be055dcf7e2c9$var$State.InAttributeValueDq:
                    this.stateInAttributeValueDoubleQuotes(c);
                    break;
                case $0a8be055dcf7e2c9$var$State.InAttributeName:
                    this.stateInAttributeName(c);
                    break;
                case $0a8be055dcf7e2c9$var$State.InCommentLike:
                    this.stateInCommentLike(c);
                    break;
                case $0a8be055dcf7e2c9$var$State.InSpecialComment:
                    this.stateInSpecialComment(c);
                    break;
                case $0a8be055dcf7e2c9$var$State.BeforeAttributeName:
                    this.stateBeforeAttributeName(c);
                    break;
                case $0a8be055dcf7e2c9$var$State.InTagName:
                    this.stateInTagName(c);
                    break;
                case $0a8be055dcf7e2c9$var$State.InClosingTagName:
                    this.stateInClosingTagName(c);
                    break;
                case $0a8be055dcf7e2c9$var$State.BeforeTagName:
                    this.stateBeforeTagName(c);
                    break;
                case $0a8be055dcf7e2c9$var$State.AfterAttributeName:
                    this.stateAfterAttributeName(c);
                    break;
                case $0a8be055dcf7e2c9$var$State.InAttributeValueSq:
                    this.stateInAttributeValueSingleQuotes(c);
                    break;
                case $0a8be055dcf7e2c9$var$State.BeforeAttributeValue:
                    this.stateBeforeAttributeValue(c);
                    break;
                case $0a8be055dcf7e2c9$var$State.BeforeClosingTagName:
                    this.stateBeforeClosingTagName(c);
                    break;
                case $0a8be055dcf7e2c9$var$State.AfterClosingTagName:
                    this.stateAfterClosingTagName(c);
                    break;
                case $0a8be055dcf7e2c9$var$State.BeforeSpecialS:
                    this.stateBeforeSpecialS(c);
                    break;
                case $0a8be055dcf7e2c9$var$State.InAttributeValueNq:
                    this.stateInAttributeValueNoQuotes(c);
                    break;
                case $0a8be055dcf7e2c9$var$State.InSelfClosingTag:
                    this.stateInSelfClosingTag(c);
                    break;
                case $0a8be055dcf7e2c9$var$State.InDeclaration:
                    this.stateInDeclaration(c);
                    break;
                case $0a8be055dcf7e2c9$var$State.BeforeDeclaration:
                    this.stateBeforeDeclaration(c);
                    break;
                case $0a8be055dcf7e2c9$var$State.BeforeComment:
                    this.stateBeforeComment(c);
                    break;
                case $0a8be055dcf7e2c9$var$State.InProcessingInstruction:
                    this.stateInProcessingInstruction(c);
                    break;
                case $0a8be055dcf7e2c9$var$State.InNamedEntity:
                    this.stateInNamedEntity(c);
                    break;
                case $0a8be055dcf7e2c9$var$State.BeforeEntity:
                    this.stateBeforeEntity(c);
                    break;
                case $0a8be055dcf7e2c9$var$State.InHexEntity:
                    this.stateInHexEntity(c);
                    break;
                case $0a8be055dcf7e2c9$var$State.InNumericEntity:
                    this.stateInNumericEntity(c);
                    break;
                default:
                    // `this._state === State.BeforeNumericEntity`
                    this.stateBeforeNumericEntity(c);
            }
            this.index++;
        }
        this.cleanup();
    }
    finish() {
        if (this.state === $0a8be055dcf7e2c9$var$State.InNamedEntity) this.emitNamedEntity();
        // If there is remaining data, emit it in a reasonable way
        if (this.sectionStart < this.index) this.handleTrailingData();
        this.cbs.onend();
    }
    /** Handle any trailing data. */ handleTrailingData() {
        const endIndex = this.buffer.length + this.offset;
        if (this.state === $0a8be055dcf7e2c9$var$State.InCommentLike) {
            if (this.currentSequence === $0a8be055dcf7e2c9$var$Sequences.CdataEnd) this.cbs.oncdata(this.sectionStart, endIndex, 0);
            else this.cbs.oncomment(this.sectionStart, endIndex, 0);
        } else if (this.state === $0a8be055dcf7e2c9$var$State.InNumericEntity && this.allowLegacyEntity()) this.emitNumericEntity(false);
        else if (this.state === $0a8be055dcf7e2c9$var$State.InHexEntity && this.allowLegacyEntity()) this.emitNumericEntity(false);
        else if (this.state === $0a8be055dcf7e2c9$var$State.InTagName || this.state === $0a8be055dcf7e2c9$var$State.BeforeAttributeName || this.state === $0a8be055dcf7e2c9$var$State.BeforeAttributeValue || this.state === $0a8be055dcf7e2c9$var$State.AfterAttributeName || this.state === $0a8be055dcf7e2c9$var$State.InAttributeName || this.state === $0a8be055dcf7e2c9$var$State.InAttributeValueSq || this.state === $0a8be055dcf7e2c9$var$State.InAttributeValueDq || this.state === $0a8be055dcf7e2c9$var$State.InAttributeValueNq || this.state === $0a8be055dcf7e2c9$var$State.InClosingTagName) ;
        else this.cbs.ontext(this.sectionStart, endIndex);
    }
    emitPartial(start, endIndex) {
        if (this.baseState !== $0a8be055dcf7e2c9$var$State.Text && this.baseState !== $0a8be055dcf7e2c9$var$State.InSpecialTag) this.cbs.onattribdata(start, endIndex);
        else this.cbs.ontext(start, endIndex);
    }
    emitCodePoint(cp) {
        if (this.baseState !== $0a8be055dcf7e2c9$var$State.Text && this.baseState !== $0a8be055dcf7e2c9$var$State.InSpecialTag) this.cbs.onattribentity(cp);
        else this.cbs.ontextentity(cp);
    }
}

});
parcelRequire.register("cqudo", function(module, exports) {
"use strict";
var $90bf59d46037384b$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $90bf59d46037384b$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $90bf59d46037384b$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $90bf59d46037384b$var$__createBinding(result, mod, k);
    }
    $90bf59d46037384b$var$__setModuleDefault(result, mod);
    return result;
};
var $90bf59d46037384b$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.decodeXML = module.exports.decodeHTMLStrict = module.exports.decodeHTMLAttribute = module.exports.decodeHTML = module.exports.determineBranch = module.exports.EntityDecoder = module.exports.DecodingMode = module.exports.BinTrieFlags = module.exports.fromCodePoint = module.exports.replaceCodePoint = module.exports.decodeCodePoint = module.exports.xmlDecodeTree = module.exports.htmlDecodeTree = void 0;

var $90bf59d46037384b$var$decode_data_html_js_1 = $90bf59d46037384b$var$__importDefault((parcelRequire("8q0nX")));
module.exports.htmlDecodeTree = $90bf59d46037384b$var$decode_data_html_js_1.default;

var $90bf59d46037384b$var$decode_data_xml_js_1 = $90bf59d46037384b$var$__importDefault((parcelRequire("lgOev")));
module.exports.xmlDecodeTree = $90bf59d46037384b$var$decode_data_xml_js_1.default;

var $90bf59d46037384b$var$decode_codepoint_js_1 = $90bf59d46037384b$var$__importStar((parcelRequire("9MZiE")));
module.exports.decodeCodePoint = $90bf59d46037384b$var$decode_codepoint_js_1.default;

Object.defineProperty(module.exports, "replaceCodePoint", {
    enumerable: true,
    get: function() {
        return (parcelRequire("9MZiE")).replaceCodePoint;
    }
});
Object.defineProperty(module.exports, "fromCodePoint", {
    enumerable: true,
    get: function() {
        return (parcelRequire("9MZiE")).fromCodePoint;
    }
});
var $90bf59d46037384b$var$CharCodes;
(function(CharCodes) {
    CharCodes[CharCodes["NUM"] = 35] = "NUM";
    CharCodes[CharCodes["SEMI"] = 59] = "SEMI";
    CharCodes[CharCodes["EQUALS"] = 61] = "EQUALS";
    CharCodes[CharCodes["ZERO"] = 48] = "ZERO";
    CharCodes[CharCodes["NINE"] = 57] = "NINE";
    CharCodes[CharCodes["LOWER_A"] = 97] = "LOWER_A";
    CharCodes[CharCodes["LOWER_F"] = 102] = "LOWER_F";
    CharCodes[CharCodes["LOWER_X"] = 120] = "LOWER_X";
    CharCodes[CharCodes["LOWER_Z"] = 122] = "LOWER_Z";
    CharCodes[CharCodes["UPPER_A"] = 65] = "UPPER_A";
    CharCodes[CharCodes["UPPER_F"] = 70] = "UPPER_F";
    CharCodes[CharCodes["UPPER_Z"] = 90] = "UPPER_Z";
})($90bf59d46037384b$var$CharCodes || ($90bf59d46037384b$var$CharCodes = {}));
/** Bit that needs to be set to convert an upper case ASCII character to lower case */ var $90bf59d46037384b$var$TO_LOWER_BIT = 32;
var $90bf59d46037384b$var$BinTrieFlags;
(function(BinTrieFlags) {
    BinTrieFlags[BinTrieFlags["VALUE_LENGTH"] = 49152] = "VALUE_LENGTH";
    BinTrieFlags[BinTrieFlags["BRANCH_LENGTH"] = 16256] = "BRANCH_LENGTH";
    BinTrieFlags[BinTrieFlags["JUMP_TABLE"] = 127] = "JUMP_TABLE";
})($90bf59d46037384b$var$BinTrieFlags = module.exports.BinTrieFlags || (module.exports.BinTrieFlags = {}));
function $90bf59d46037384b$var$isNumber(code) {
    return code >= $90bf59d46037384b$var$CharCodes.ZERO && code <= $90bf59d46037384b$var$CharCodes.NINE;
}
function $90bf59d46037384b$var$isHexadecimalCharacter(code) {
    return code >= $90bf59d46037384b$var$CharCodes.UPPER_A && code <= $90bf59d46037384b$var$CharCodes.UPPER_F || code >= $90bf59d46037384b$var$CharCodes.LOWER_A && code <= $90bf59d46037384b$var$CharCodes.LOWER_F;
}
function $90bf59d46037384b$var$isAsciiAlphaNumeric(code) {
    return code >= $90bf59d46037384b$var$CharCodes.UPPER_A && code <= $90bf59d46037384b$var$CharCodes.UPPER_Z || code >= $90bf59d46037384b$var$CharCodes.LOWER_A && code <= $90bf59d46037384b$var$CharCodes.LOWER_Z || $90bf59d46037384b$var$isNumber(code);
}
/**
 * Checks if the given character is a valid end character for an entity in an attribute.
 *
 * Attribute values that aren't terminated properly aren't parsed, and shouldn't lead to a parser error.
 * See the example in https://html.spec.whatwg.org/multipage/parsing.html#named-character-reference-state
 */ function $90bf59d46037384b$var$isEntityInAttributeInvalidEnd(code) {
    return code === $90bf59d46037384b$var$CharCodes.EQUALS || $90bf59d46037384b$var$isAsciiAlphaNumeric(code);
}
var $90bf59d46037384b$var$EntityDecoderState;
(function(EntityDecoderState) {
    EntityDecoderState[EntityDecoderState["EntityStart"] = 0] = "EntityStart";
    EntityDecoderState[EntityDecoderState["NumericStart"] = 1] = "NumericStart";
    EntityDecoderState[EntityDecoderState["NumericDecimal"] = 2] = "NumericDecimal";
    EntityDecoderState[EntityDecoderState["NumericHex"] = 3] = "NumericHex";
    EntityDecoderState[EntityDecoderState["NamedEntity"] = 4] = "NamedEntity";
})($90bf59d46037384b$var$EntityDecoderState || ($90bf59d46037384b$var$EntityDecoderState = {}));
var $90bf59d46037384b$var$DecodingMode;
(function(DecodingMode) {
    /** Entities in text nodes that can end with any character. */ DecodingMode[DecodingMode["Legacy"] = 0] = "Legacy";
    /** Only allow entities terminated with a semicolon. */ DecodingMode[DecodingMode["Strict"] = 1] = "Strict";
    /** Entities in attributes have limitations on ending characters. */ DecodingMode[DecodingMode["Attribute"] = 2] = "Attribute";
})($90bf59d46037384b$var$DecodingMode = module.exports.DecodingMode || (module.exports.DecodingMode = {}));
/**
 * Token decoder with support of writing partial entities.
 */ var $90bf59d46037384b$var$EntityDecoder = /** @class */ function() {
    function EntityDecoder(/** The tree used to decode entities. */ decodeTree, /**
     * The function that is called when a codepoint is decoded.
     *
     * For multi-byte named entities, this will be called multiple times,
     * with the second codepoint, and the same `consumed` value.
     *
     * @param codepoint The decoded codepoint.
     * @param consumed The number of bytes consumed by the decoder.
     */ emitCodePoint, /** An object that is used to produce errors. */ errors) {
        this.decodeTree = decodeTree;
        this.emitCodePoint = emitCodePoint;
        this.errors = errors;
        /** The current state of the decoder. */ this.state = $90bf59d46037384b$var$EntityDecoderState.EntityStart;
        /** Characters that were consumed while parsing an entity. */ this.consumed = 1;
        /**
         * The result of the entity.
         *
         * Either the result index of a numeric entity, or the codepoint of a
         * numeric entity.
         */ this.result = 0;
        /** The current index in the decode tree. */ this.treeIndex = 0;
        /** The number of characters that were consumed in excess. */ this.excess = 1;
        /** The mode in which the decoder is operating. */ this.decodeMode = $90bf59d46037384b$var$DecodingMode.Strict;
    }
    /** Resets the instance to make it reusable. */ EntityDecoder.prototype.startEntity = function(decodeMode) {
        this.decodeMode = decodeMode;
        this.state = $90bf59d46037384b$var$EntityDecoderState.EntityStart;
        this.result = 0;
        this.treeIndex = 0;
        this.excess = 1;
        this.consumed = 1;
    };
    /**
     * Write an entity to the decoder. This can be called multiple times with partial entities.
     * If the entity is incomplete, the decoder will return -1.
     *
     * Mirrors the implementation of `getDecoder`, but with the ability to stop decoding if the
     * entity is incomplete, and resume when the next string is written.
     *
     * @param string The string containing the entity (or a continuation of the entity).
     * @param offset The offset at which the entity begins. Should be 0 if this is not the first call.
     * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
     */ EntityDecoder.prototype.write = function(str, offset) {
        switch(this.state){
            case $90bf59d46037384b$var$EntityDecoderState.EntityStart:
                if (str.charCodeAt(offset) === $90bf59d46037384b$var$CharCodes.NUM) {
                    this.state = $90bf59d46037384b$var$EntityDecoderState.NumericStart;
                    this.consumed += 1;
                    return this.stateNumericStart(str, offset + 1);
                }
                this.state = $90bf59d46037384b$var$EntityDecoderState.NamedEntity;
                return this.stateNamedEntity(str, offset);
            case $90bf59d46037384b$var$EntityDecoderState.NumericStart:
                return this.stateNumericStart(str, offset);
            case $90bf59d46037384b$var$EntityDecoderState.NumericDecimal:
                return this.stateNumericDecimal(str, offset);
            case $90bf59d46037384b$var$EntityDecoderState.NumericHex:
                return this.stateNumericHex(str, offset);
            case $90bf59d46037384b$var$EntityDecoderState.NamedEntity:
                return this.stateNamedEntity(str, offset);
        }
    };
    /**
     * Switches between the numeric decimal and hexadecimal states.
     *
     * Equivalent to the `Numeric character reference state` in the HTML spec.
     *
     * @param str The string containing the entity (or a continuation of the entity).
     * @param offset The current offset.
     * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
     */ EntityDecoder.prototype.stateNumericStart = function(str, offset) {
        if (offset >= str.length) return -1;
        if ((str.charCodeAt(offset) | $90bf59d46037384b$var$TO_LOWER_BIT) === $90bf59d46037384b$var$CharCodes.LOWER_X) {
            this.state = $90bf59d46037384b$var$EntityDecoderState.NumericHex;
            this.consumed += 1;
            return this.stateNumericHex(str, offset + 1);
        }
        this.state = $90bf59d46037384b$var$EntityDecoderState.NumericDecimal;
        return this.stateNumericDecimal(str, offset);
    };
    EntityDecoder.prototype.addToNumericResult = function(str, start, end, base) {
        if (start !== end) {
            var digitCount = end - start;
            this.result = this.result * Math.pow(base, digitCount) + parseInt(str.substr(start, digitCount), base);
            this.consumed += digitCount;
        }
    };
    /**
     * Parses a hexadecimal numeric entity.
     *
     * Equivalent to the `Hexademical character reference state` in the HTML spec.
     *
     * @param str The string containing the entity (or a continuation of the entity).
     * @param offset The current offset.
     * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
     */ EntityDecoder.prototype.stateNumericHex = function(str, offset) {
        var startIdx = offset;
        while(offset < str.length){
            var char = str.charCodeAt(offset);
            if ($90bf59d46037384b$var$isNumber(char) || $90bf59d46037384b$var$isHexadecimalCharacter(char)) offset += 1;
            else {
                this.addToNumericResult(str, startIdx, offset, 16);
                return this.emitNumericEntity(char, 3);
            }
        }
        this.addToNumericResult(str, startIdx, offset, 16);
        return -1;
    };
    /**
     * Parses a decimal numeric entity.
     *
     * Equivalent to the `Decimal character reference state` in the HTML spec.
     *
     * @param str The string containing the entity (or a continuation of the entity).
     * @param offset The current offset.
     * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
     */ EntityDecoder.prototype.stateNumericDecimal = function(str, offset) {
        var startIdx = offset;
        while(offset < str.length){
            var char = str.charCodeAt(offset);
            if ($90bf59d46037384b$var$isNumber(char)) offset += 1;
            else {
                this.addToNumericResult(str, startIdx, offset, 10);
                return this.emitNumericEntity(char, 2);
            }
        }
        this.addToNumericResult(str, startIdx, offset, 10);
        return -1;
    };
    /**
     * Validate and emit a numeric entity.
     *
     * Implements the logic from the `Hexademical character reference start
     * state` and `Numeric character reference end state` in the HTML spec.
     *
     * @param lastCp The last code point of the entity. Used to see if the
     *               entity was terminated with a semicolon.
     * @param expectedLength The minimum number of characters that should be
     *                       consumed. Used to validate that at least one digit
     *                       was consumed.
     * @returns The number of characters that were consumed.
     */ EntityDecoder.prototype.emitNumericEntity = function(lastCp, expectedLength) {
        var _a;
        // Ensure we consumed at least one digit.
        if (this.consumed <= expectedLength) {
            (_a = this.errors) === null || _a === void 0 || _a.absenceOfDigitsInNumericCharacterReference(this.consumed);
            return 0;
        }
        // Figure out if this is a legit end of the entity
        if (lastCp === $90bf59d46037384b$var$CharCodes.SEMI) this.consumed += 1;
        else if (this.decodeMode === $90bf59d46037384b$var$DecodingMode.Strict) return 0;
        this.emitCodePoint((0, $90bf59d46037384b$var$decode_codepoint_js_1.replaceCodePoint)(this.result), this.consumed);
        if (this.errors) {
            if (lastCp !== $90bf59d46037384b$var$CharCodes.SEMI) this.errors.missingSemicolonAfterCharacterReference();
            this.errors.validateNumericCharacterReference(this.result);
        }
        return this.consumed;
    };
    /**
     * Parses a named entity.
     *
     * Equivalent to the `Named character reference state` in the HTML spec.
     *
     * @param str The string containing the entity (or a continuation of the entity).
     * @param offset The current offset.
     * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
     */ EntityDecoder.prototype.stateNamedEntity = function(str, offset) {
        var decodeTree = this.decodeTree;
        var current = decodeTree[this.treeIndex];
        // The mask is the number of bytes of the value, including the current byte.
        var valueLength = (current & $90bf59d46037384b$var$BinTrieFlags.VALUE_LENGTH) >> 14;
        for(; offset < str.length; offset++, this.excess++){
            var char = str.charCodeAt(offset);
            this.treeIndex = $90bf59d46037384b$var$determineBranch(decodeTree, current, this.treeIndex + Math.max(1, valueLength), char);
            if (this.treeIndex < 0) return this.result === 0 || // If we are parsing an attribute
            this.decodeMode === $90bf59d46037384b$var$DecodingMode.Attribute && // We shouldn't have consumed any characters after the entity,
            (valueLength === 0 || // And there should be no invalid characters.
            $90bf59d46037384b$var$isEntityInAttributeInvalidEnd(char)) ? 0 : this.emitNotTerminatedNamedEntity();
            current = decodeTree[this.treeIndex];
            valueLength = (current & $90bf59d46037384b$var$BinTrieFlags.VALUE_LENGTH) >> 14;
            // If the branch is a value, store it and continue
            if (valueLength !== 0) {
                // If the entity is terminated by a semicolon, we are done.
                if (char === $90bf59d46037384b$var$CharCodes.SEMI) return this.emitNamedEntityData(this.treeIndex, valueLength, this.consumed + this.excess);
                // If we encounter a non-terminated (legacy) entity while parsing strictly, then ignore it.
                if (this.decodeMode !== $90bf59d46037384b$var$DecodingMode.Strict) {
                    this.result = this.treeIndex;
                    this.consumed += this.excess;
                    this.excess = 0;
                }
            }
        }
        return -1;
    };
    /**
     * Emit a named entity that was not terminated with a semicolon.
     *
     * @returns The number of characters consumed.
     */ EntityDecoder.prototype.emitNotTerminatedNamedEntity = function() {
        var _a;
        var _b = this, result = _b.result, decodeTree = _b.decodeTree;
        var valueLength = (decodeTree[result] & $90bf59d46037384b$var$BinTrieFlags.VALUE_LENGTH) >> 14;
        this.emitNamedEntityData(result, valueLength, this.consumed);
        (_a = this.errors) === null || _a === void 0 || _a.missingSemicolonAfterCharacterReference();
        return this.consumed;
    };
    /**
     * Emit a named entity.
     *
     * @param result The index of the entity in the decode tree.
     * @param valueLength The number of bytes in the entity.
     * @param consumed The number of characters consumed.
     *
     * @returns The number of characters consumed.
     */ EntityDecoder.prototype.emitNamedEntityData = function(result, valueLength, consumed) {
        var decodeTree = this.decodeTree;
        this.emitCodePoint(valueLength === 1 ? decodeTree[result] & ~$90bf59d46037384b$var$BinTrieFlags.VALUE_LENGTH : decodeTree[result + 1], consumed);
        if (valueLength === 3) // For multi-byte values, we need to emit the second byte.
        this.emitCodePoint(decodeTree[result + 2], consumed);
        return consumed;
    };
    /**
     * Signal to the parser that the end of the input was reached.
     *
     * Remaining data will be emitted and relevant errors will be produced.
     *
     * @returns The number of characters consumed.
     */ EntityDecoder.prototype.end = function() {
        var _a;
        switch(this.state){
            case $90bf59d46037384b$var$EntityDecoderState.NamedEntity:
                // Emit a named entity if we have one.
                return this.result !== 0 && (this.decodeMode !== $90bf59d46037384b$var$DecodingMode.Attribute || this.result === this.treeIndex) ? this.emitNotTerminatedNamedEntity() : 0;
            // Otherwise, emit a numeric entity if we have one.
            case $90bf59d46037384b$var$EntityDecoderState.NumericDecimal:
                return this.emitNumericEntity(0, 2);
            case $90bf59d46037384b$var$EntityDecoderState.NumericHex:
                return this.emitNumericEntity(0, 3);
            case $90bf59d46037384b$var$EntityDecoderState.NumericStart:
                (_a = this.errors) === null || _a === void 0 || _a.absenceOfDigitsInNumericCharacterReference(this.consumed);
                return 0;
            case $90bf59d46037384b$var$EntityDecoderState.EntityStart:
                // Return 0 if we have no entity.
                return 0;
        }
    };
    return EntityDecoder;
}();
module.exports.EntityDecoder = $90bf59d46037384b$var$EntityDecoder;
/**
 * Creates a function that decodes entities in a string.
 *
 * @param decodeTree The decode tree.
 * @returns A function that decodes entities in a string.
 */ function $90bf59d46037384b$var$getDecoder(decodeTree) {
    var ret = "";
    var decoder = new $90bf59d46037384b$var$EntityDecoder(decodeTree, function(str) {
        return ret += (0, $90bf59d46037384b$var$decode_codepoint_js_1.fromCodePoint)(str);
    });
    return function decodeWithTrie(str, decodeMode) {
        var lastIndex = 0;
        var offset = 0;
        while((offset = str.indexOf("&", offset)) >= 0){
            ret += str.slice(lastIndex, offset);
            decoder.startEntity(decodeMode);
            var len = decoder.write(str, // Skip the "&"
            offset + 1);
            if (len < 0) {
                lastIndex = offset + decoder.end();
                break;
            }
            lastIndex = offset + len;
            // If `len` is 0, skip the current `&` and continue.
            offset = len === 0 ? lastIndex + 1 : lastIndex;
        }
        var result = ret + str.slice(lastIndex);
        // Make sure we don't keep a reference to the final string.
        ret = "";
        return result;
    };
}
/**
 * Determines the branch of the current node that is taken given the current
 * character. This function is used to traverse the trie.
 *
 * @param decodeTree The trie.
 * @param current The current node.
 * @param nodeIdx The index right after the current node and its value.
 * @param char The current character.
 * @returns The index of the next node, or -1 if no branch is taken.
 */ function $90bf59d46037384b$var$determineBranch(decodeTree, current, nodeIdx, char) {
    var branchCount = (current & $90bf59d46037384b$var$BinTrieFlags.BRANCH_LENGTH) >> 7;
    var jumpOffset = current & $90bf59d46037384b$var$BinTrieFlags.JUMP_TABLE;
    // Case 1: Single branch encoded in jump offset
    if (branchCount === 0) return jumpOffset !== 0 && char === jumpOffset ? nodeIdx : -1;
    // Case 2: Multiple branches encoded in jump table
    if (jumpOffset) {
        var value = char - jumpOffset;
        return value < 0 || value >= branchCount ? -1 : decodeTree[nodeIdx + value] - 1;
    }
    // Case 3: Multiple branches encoded in dictionary
    // Binary search for the character.
    var lo = nodeIdx;
    var hi = lo + branchCount - 1;
    while(lo <= hi){
        var mid = lo + hi >>> 1;
        var midVal = decodeTree[mid];
        if (midVal < char) lo = mid + 1;
        else if (midVal > char) hi = mid - 1;
        else return decodeTree[mid + branchCount];
    }
    return -1;
}
module.exports.determineBranch = $90bf59d46037384b$var$determineBranch;
var $90bf59d46037384b$var$htmlDecoder = $90bf59d46037384b$var$getDecoder($90bf59d46037384b$var$decode_data_html_js_1.default);
var $90bf59d46037384b$var$xmlDecoder = $90bf59d46037384b$var$getDecoder($90bf59d46037384b$var$decode_data_xml_js_1.default);
/**
 * Decodes an HTML string.
 *
 * @param str The string to decode.
 * @param mode The decoding mode.
 * @returns The decoded string.
 */ function $90bf59d46037384b$var$decodeHTML(str, mode) {
    if (mode === void 0) mode = $90bf59d46037384b$var$DecodingMode.Legacy;
    return $90bf59d46037384b$var$htmlDecoder(str, mode);
}
module.exports.decodeHTML = $90bf59d46037384b$var$decodeHTML;
/**
 * Decodes an HTML string in an attribute.
 *
 * @param str The string to decode.
 * @returns The decoded string.
 */ function $90bf59d46037384b$var$decodeHTMLAttribute(str) {
    return $90bf59d46037384b$var$htmlDecoder(str, $90bf59d46037384b$var$DecodingMode.Attribute);
}
module.exports.decodeHTMLAttribute = $90bf59d46037384b$var$decodeHTMLAttribute;
/**
 * Decodes an HTML string, requiring all entities to be terminated by a semicolon.
 *
 * @param str The string to decode.
 * @returns The decoded string.
 */ function $90bf59d46037384b$var$decodeHTMLStrict(str) {
    return $90bf59d46037384b$var$htmlDecoder(str, $90bf59d46037384b$var$DecodingMode.Strict);
}
module.exports.decodeHTMLStrict = $90bf59d46037384b$var$decodeHTMLStrict;
/**
 * Decodes an XML string, requiring all entities to be terminated by a semicolon.
 *
 * @param str The string to decode.
 * @returns The decoded string.
 */ function $90bf59d46037384b$var$decodeXML(str) {
    return $90bf59d46037384b$var$xmlDecoder(str, $90bf59d46037384b$var$DecodingMode.Strict);
}
module.exports.decodeXML = $90bf59d46037384b$var$decodeXML;

});
parcelRequire.register("8q0nX", function(module, exports) {
"use strict";
// Generated using scripts/write-decode-map.ts
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = new Uint16Array(// prettier-ignore
'ᵁ<\xd5ıʊҝջאٵ۞ޢߖࠏ੊ઑඡ๭༉༦჊ረዡᐕᒝᓃᓟᔥ\x00\x00\x00\x00\x00\x00ᕫᛍᦍᰒᷝ὾⁠↰⊍⏀⏻⑂⠤⤒ⴈ⹈⿎〖㊺㘹㞬㣾㨨㩱㫠㬮ࠀEMabcfglmnoprstu\\bfms\x7f\x84\x8b\x90\x95\x98\xa6\xb3\xb9\xc8\xcflig耻\xc6䃆P耻&䀦cute耻\xc1䃁reve;䄂Āiyx}rc耻\xc2䃂;䐐r;쀀\ud835\udd04rave耻\xc0䃀pha;䎑acr;䄀d;橓Āgp\x9d\xa1on;䄄f;쀀\ud835\udd38plyFunction;恡ing耻\xc5䃅Ācs\xbe\xc3r;쀀\ud835\udc9cign;扔ilde耻\xc3䃃ml耻\xc4䃄Ѐaceforsu\xe5\xfb\xfeėĜĢħĪĀcr\xea\xf2kslash;或Ŷ\xf6\xf8;櫧ed;挆y;䐑ƀcrtąċĔause;戵noullis;愬a;䎒r;쀀\ud835\udd05pf;쀀\ud835\udd39eve;䋘c\xf2ēmpeq;扎܀HOacdefhilorsuōőŖƀƞƢƵƷƺǜȕɳɸɾcy;䐧PY耻\xa9䂩ƀcpyŝŢźute;䄆Ā;iŧŨ拒talDifferentialD;慅leys;愭ȀaeioƉƎƔƘron;䄌dil耻\xc7䃇rc;䄈nint;戰ot;䄊ĀdnƧƭilla;䂸terDot;䂷\xf2ſi;䎧rcleȀDMPTǇǋǑǖot;抙inus;抖lus;投imes;抗oĀcsǢǸkwiseContourIntegral;戲eCurlyĀDQȃȏoubleQuote;思uote;怙ȀlnpuȞȨɇɕonĀ;eȥȦ户;橴ƀgitȯȶȺruent;扡nt;戯ourIntegral;戮ĀfrɌɎ;愂oduct;成nterClockwiseContourIntegral;戳oss;樯cr;쀀\ud835\udc9epĀ;Cʄʅ拓ap;才րDJSZacefiosʠʬʰʴʸˋ˗ˡ˦̳ҍĀ;oŹʥtrahd;椑cy;䐂cy;䐅cy;䐏ƀgrsʿ˄ˇger;怡r;憡hv;櫤Āayː˕ron;䄎;䐔lĀ;t˝˞戇a;䎔r;쀀\ud835\udd07Āaf˫̧Ācm˰̢riticalȀADGT̖̜̀̆cute;䂴oŴ̋̍;䋙bleAcute;䋝rave;䁠ilde;䋜ond;拄ferentialD;慆Ѱ̽\x00\x00\x00͔͂\x00Ѕf;쀀\ud835\udd3bƀ;DE͈͉͍䂨ot;惜qual;扐blèCDLRUVͣͲ΂ϏϢϸontourIntegra\xecȹoɴ͹\x00\x00ͻ\xbb͉nArrow;懓Āeo·ΤftƀARTΐΖΡrrow;懐ightArrow;懔e\xe5ˊngĀLRΫτeftĀARγιrrow;柸ightArrow;柺ightArrow;柹ightĀATϘϞrrow;懒ee;抨pɁϩ\x00\x00ϯrrow;懑ownArrow;懕erticalBar;戥ǹABLRTaВЪаўѿͼrrowƀ;BUНОТ憓ar;椓pArrow;懵reve;䌑eft˒к\x00ц\x00ѐightVector;楐eeVector;楞ectorĀ;Bљњ憽ar;楖ightǔѧ\x00ѱeeVector;楟ectorĀ;BѺѻ懁ar;楗eeĀ;A҆҇护rrow;憧ĀctҒҗr;쀀\ud835\udc9frok;䄐ࠀNTacdfglmopqstuxҽӀӄӋӞӢӧӮӵԡԯԶՒ՝ՠեG;䅊H耻\xd0䃐cute耻\xc9䃉ƀaiyӒӗӜron;䄚rc耻\xca䃊;䐭ot;䄖r;쀀\ud835\udd08rave耻\xc8䃈ement;戈ĀapӺӾcr;䄒tyɓԆ\x00\x00ԒmallSquare;旻erySmallSquare;斫ĀgpԦԪon;䄘f;쀀\ud835\udd3csilon;䎕uĀaiԼՉlĀ;TՂՃ橵ilde;扂librium;懌Āci՗՚r;愰m;橳a;䎗ml耻\xcb䃋Āipժկsts;戃onentialE;慇ʀcfiosօֈ֍ֲ׌y;䐤r;쀀\ud835\udd09lledɓ֗\x00\x00֣mallSquare;旼erySmallSquare;斪Ͱֺ\x00ֿ\x00\x00ׄf;쀀\ud835\udd3dAll;戀riertrf;愱c\xf2׋؀JTabcdfgorstר׬ׯ׺؀ؒؖ؛؝أ٬ٲcy;䐃耻>䀾mmaĀ;d׷׸䎓;䏜reve;䄞ƀeiy؇،ؐdil;䄢rc;䄜;䐓ot;䄠r;쀀\ud835\udd0a;拙pf;쀀\ud835\udd3eeater̀EFGLSTصلَٖٛ٦qualĀ;Lؾؿ扥ess;招ullEqual;执reater;檢ess;扷lantEqual;橾ilde;扳cr;쀀\ud835\udca2;扫ЀAacfiosuڅڋږڛڞڪھۊRDcy;䐪Āctڐڔek;䋇;䁞irc;䄤r;愌lbertSpace;愋ǰگ\x00ڲf;愍izontalLine;攀Āctۃۅ\xf2کrok;䄦mpńېۘownHum\xf0įqual;扏܀EJOacdfgmnostuۺ۾܃܇܎ܚܞܡܨ݄ݸދޏޕcy;䐕lig;䄲cy;䐁cute耻\xcd䃍Āiyܓܘrc耻\xce䃎;䐘ot;䄰r;愑rave耻\xcc䃌ƀ;apܠܯܿĀcgܴܷr;䄪inaryI;慈lie\xf3ϝǴ݉\x00ݢĀ;eݍݎ戬Āgrݓݘral;戫section;拂isibleĀCTݬݲomma;恣imes;恢ƀgptݿރވon;䄮f;쀀\ud835\udd40a;䎙cr;愐ilde;䄨ǫޚ\x00ޞcy;䐆l耻\xcf䃏ʀcfosuެ޷޼߂ߐĀiyޱ޵rc;䄴;䐙r;쀀\ud835\udd0dpf;쀀\ud835\udd41ǣ߇\x00ߌr;쀀\ud835\udca5rcy;䐈kcy;䐄΀HJacfosߤߨ߽߬߱ࠂࠈcy;䐥cy;䐌ppa;䎚Āey߶߻dil;䄶;䐚r;쀀\ud835\udd0epf;쀀\ud835\udd42cr;쀀\ud835\udca6րJTaceflmostࠥࠩࠬࡐࡣ঳সে্਷ੇcy;䐉耻<䀼ʀcmnpr࠷࠼ࡁࡄࡍute;䄹bda;䎛g;柪lacetrf;愒r;憞ƀaeyࡗ࡜ࡡron;䄽dil;䄻;䐛Āfsࡨ॰tԀACDFRTUVarࡾࢩࢱࣦ࣠ࣼयज़ΐ४Ānrࢃ࢏gleBracket;柨rowƀ;BR࢙࢚࢞憐ar;懤ightArrow;懆eiling;挈oǵࢷ\x00ࣃbleBracket;柦nǔࣈ\x00࣒eeVector;楡ectorĀ;Bࣛࣜ懃ar;楙loor;挊ightĀAV࣯ࣵrrow;憔ector;楎Āerँगeƀ;AVउऊऐ抣rrow;憤ector;楚iangleƀ;BEतथऩ抲ar;槏qual;抴pƀDTVषूौownVector;楑eeVector;楠ectorĀ;Bॖॗ憿ar;楘ectorĀ;B॥०憼ar;楒ight\xe1Μs̀EFGLSTॾঋকঝঢভqualGreater;拚ullEqual;扦reater;扶ess;檡lantEqual;橽ilde;扲r;쀀\ud835\udd0fĀ;eঽা拘ftarrow;懚idot;䄿ƀnpw৔ਖਛgȀLRlr৞৷ਂਐeftĀAR০৬rrow;柵ightArrow;柷ightArrow;柶eftĀarγਊight\xe1οight\xe1ϊf;쀀\ud835\udd43erĀLRਢਬeftArrow;憙ightArrow;憘ƀchtਾੀੂ\xf2ࡌ;憰rok;䅁;扪Ѐacefiosuਗ਼੝੠੷੼અઋ઎p;椅y;䐜Ādl੥੯iumSpace;恟lintrf;愳r;쀀\ud835\udd10nusPlus;戓pf;쀀\ud835\udd44c\xf2੶;䎜ҀJacefostuણધભીଔଙඑ඗ඞcy;䐊cute;䅃ƀaey઴હાron;䅇dil;䅅;䐝ƀgswે૰଎ativeƀMTV૓૟૨ediumSpace;怋hiĀcn૦૘\xeb૙eryThi\xee૙tedĀGL૸ଆreaterGreate\xf2ٳessLes\xf3ੈLine;䀊r;쀀\ud835\udd11ȀBnptଢନଷ଺reak;恠BreakingSpace;䂠f;愕ڀ;CDEGHLNPRSTV୕ୖ୪୼஡௫ఄ౞಄ದ೘ൡඅ櫬Āou୛୤ngruent;扢pCap;扭oubleVerticalBar;戦ƀlqxஃஊ஛ement;戉ualĀ;Tஒஓ扠ilde;쀀≂̸ists;戄reater΀;EFGLSTஶஷ஽௉௓௘௥扯qual;扱ullEqual;쀀≧̸reater;쀀≫̸ess;批lantEqual;쀀⩾̸ilde;扵umpń௲௽ownHump;쀀≎̸qual;쀀≏̸eĀfsఊధtTriangleƀ;BEచఛడ拪ar;쀀⧏̸qual;括s̀;EGLSTవశ఼ౄోౘ扮qual;扰reater;扸ess;쀀≪̸lantEqual;쀀⩽̸ilde;扴estedĀGL౨౹reaterGreater;쀀⪢̸essLess;쀀⪡̸recedesƀ;ESಒಓಛ技qual;쀀⪯̸lantEqual;拠ĀeiಫಹverseElement;戌ghtTriangleƀ;BEೋೌ೒拫ar;쀀⧐̸qual;拭ĀquೝഌuareSuĀbp೨೹setĀ;E೰ೳ쀀⊏̸qual;拢ersetĀ;Eഃആ쀀⊐̸qual;拣ƀbcpഓതൎsetĀ;Eഛഞ쀀⊂⃒qual;抈ceedsȀ;ESTലള഻െ抁qual;쀀⪰̸lantEqual;拡ilde;쀀≿̸ersetĀ;E൘൛쀀⊃⃒qual;抉ildeȀ;EFT൮൯൵ൿ扁qual;扄ullEqual;扇ilde;扉erticalBar;戤cr;쀀\ud835\udca9ilde耻\xd1䃑;䎝܀Eacdfgmoprstuvලෂ෉෕ෛ෠෧෼ขภยา฿ไlig;䅒cute耻\xd3䃓Āiy෎ීrc耻\xd4䃔;䐞blac;䅐r;쀀\ud835\udd12rave耻\xd2䃒ƀaei෮ෲ෶cr;䅌ga;䎩cron;䎟pf;쀀\ud835\udd46enCurlyĀDQฎบoubleQuote;怜uote;怘;橔Āclวฬr;쀀\ud835\udcaaash耻\xd8䃘iŬื฼de耻\xd5䃕es;樷ml耻\xd6䃖erĀBP๋๠Āar๐๓r;怾acĀek๚๜;揞et;掴arenthesis;揜Ҁacfhilors๿ງຊຏຒດຝະ໼rtialD;戂y;䐟r;쀀\ud835\udd13i;䎦;䎠usMinus;䂱Āipຢອncareplan\xe5ڝf;愙Ȁ;eio຺ູ໠໤檻cedesȀ;EST່້໏໚扺qual;檯lantEqual;扼ilde;找me;怳Ādp໩໮uct;戏ortionĀ;aȥ໹l;戝Āci༁༆r;쀀\ud835\udcab;䎨ȀUfos༑༖༛༟OT耻"䀢r;쀀\ud835\udd14pf;愚cr;쀀\ud835\udcac؀BEacefhiorsu༾གྷཇའཱིྦྷྪྭ႖ႩႴႾarr;椐G耻\xae䂮ƀcnrཎནབute;䅔g;柫rĀ;tཛྷཝ憠l;椖ƀaeyཧཬཱron;䅘dil;䅖;䐠Ā;vླྀཹ愜erseĀEUྂྙĀlq྇ྎement;戋uilibrium;懋pEquilibrium;楯r\xbbཹo;䎡ghtЀACDFTUVa࿁࿫࿳ဢဨၛႇϘĀnr࿆࿒gleBracket;柩rowƀ;BL࿜࿝࿡憒ar;懥eftArrow;懄eiling;按oǵ࿹\x00စbleBracket;柧nǔည\x00နeeVector;楝ectorĀ;Bဝသ懂ar;楕loor;挋Āerိ၃eƀ;AVဵံြ抢rrow;憦ector;楛iangleƀ;BEၐၑၕ抳ar;槐qual;抵pƀDTVၣၮၸownVector;楏eeVector;楜ectorĀ;Bႂႃ憾ar;楔ectorĀ;B႑႒懀ar;楓Āpuႛ႞f;愝ndImplies;楰ightarrow;懛ĀchႹႼr;愛;憱leDelayed;槴ڀHOacfhimoqstuფჱჷჽᄙᄞᅑᅖᅡᅧᆵᆻᆿĀCcჩხHcy;䐩y;䐨FTcy;䐬cute;䅚ʀ;aeiyᄈᄉᄎᄓᄗ檼ron;䅠dil;䅞rc;䅜;䐡r;쀀\ud835\udd16ortȀDLRUᄪᄴᄾᅉownArrow\xbbОeftArrow\xbb࢚ightArrow\xbb࿝pArrow;憑gma;䎣allCircle;战pf;쀀\ud835\udd4aɲᅭ\x00\x00ᅰt;戚areȀ;ISUᅻᅼᆉᆯ斡ntersection;抓uĀbpᆏᆞsetĀ;Eᆗᆘ抏qual;抑ersetĀ;Eᆨᆩ抐qual;抒nion;抔cr;쀀\ud835\udcaear;拆ȀbcmpᇈᇛሉላĀ;sᇍᇎ拐etĀ;Eᇍᇕqual;抆ĀchᇠህeedsȀ;ESTᇭᇮᇴᇿ扻qual;檰lantEqual;扽ilde;承Th\xe1ྌ;我ƀ;esሒሓሣ拑rsetĀ;Eሜም抃qual;抇et\xbbሓրHRSacfhiorsሾቄ቉ቕ቞ቱቶኟዂወዑORN耻\xde䃞ADE;愢ĀHc቎ቒcy;䐋y;䐦Ābuቚቜ;䀉;䎤ƀaeyብቪቯron;䅤dil;䅢;䐢r;쀀\ud835\udd17Āeiቻ኉ǲኀ\x00ኇefore;戴a;䎘Ācn኎ኘkSpace;쀀  Space;怉ldeȀ;EFTካኬኲኼ戼qual;扃ullEqual;扅ilde;扈pf;쀀\ud835\udd4bipleDot;惛Āctዖዛr;쀀\ud835\udcafrok;䅦ૡዷጎጚጦ\x00ጬጱ\x00\x00\x00\x00\x00ጸጽ፷ᎅ\x00᏿ᐄᐊᐐĀcrዻጁute耻\xda䃚rĀ;oጇገ憟cir;楉rǣጓ\x00጖y;䐎ve;䅬Āiyጞጣrc耻\xdb䃛;䐣blac;䅰r;쀀\ud835\udd18rave耻\xd9䃙acr;䅪Ādiፁ፩erĀBPፈ፝Āarፍፐr;䁟acĀekፗፙ;揟et;掵arenthesis;揝onĀ;P፰፱拃lus;抎Āgp፻፿on;䅲f;쀀\ud835\udd4cЀADETadps᎕ᎮᎸᏄϨᏒᏗᏳrrowƀ;BDᅐᎠᎤar;椒ownArrow;懅ownArrow;憕quilibrium;楮eeĀ;AᏋᏌ报rrow;憥own\xe1ϳerĀLRᏞᏨeftArrow;憖ightArrow;憗iĀ;lᏹᏺ䏒on;䎥ing;䅮cr;쀀\ud835\udcb0ilde;䅨ml耻\xdc䃜ҀDbcdefosvᐧᐬᐰᐳᐾᒅᒊᒐᒖash;披ar;櫫y;䐒ashĀ;lᐻᐼ抩;櫦Āerᑃᑅ;拁ƀbtyᑌᑐᑺar;怖Ā;iᑏᑕcalȀBLSTᑡᑥᑪᑴar;戣ine;䁼eparator;杘ilde;所ThinSpace;怊r;쀀\ud835\udd19pf;쀀\ud835\udd4dcr;쀀\ud835\udcb1dash;抪ʀcefosᒧᒬᒱᒶᒼirc;䅴dge;拀r;쀀\ud835\udd1apf;쀀\ud835\udd4ecr;쀀\ud835\udcb2Ȁfiosᓋᓐᓒᓘr;쀀\ud835\udd1b;䎞pf;쀀\ud835\udd4fcr;쀀\ud835\udcb3ҀAIUacfosuᓱᓵᓹᓽᔄᔏᔔᔚᔠcy;䐯cy;䐇cy;䐮cute耻\xdd䃝Āiyᔉᔍrc;䅶;䐫r;쀀\ud835\udd1cpf;쀀\ud835\udd50cr;쀀\ud835\udcb4ml;䅸ЀHacdefosᔵᔹᔿᕋᕏᕝᕠᕤcy;䐖cute;䅹Āayᕄᕉron;䅽;䐗ot;䅻ǲᕔ\x00ᕛoWidt\xe8૙a;䎖r;愨pf;愤cr;쀀\ud835\udcb5௡ᖃᖊᖐ\x00ᖰᖶᖿ\x00\x00\x00\x00ᗆᗛᗫᙟ᙭\x00ᚕ᚛ᚲᚹ\x00ᚾcute耻\xe1䃡reve;䄃̀;Ediuyᖜᖝᖡᖣᖨᖭ戾;쀀∾̳;房rc耻\xe2䃢te肻\xb4̆;䐰lig耻\xe6䃦Ā;r\xb2ᖺ;쀀\ud835\udd1erave耻\xe0䃠ĀepᗊᗖĀfpᗏᗔsym;愵\xe8ᗓha;䎱ĀapᗟcĀclᗤᗧr;䄁g;樿ɤᗰ\x00\x00ᘊʀ;adsvᗺᗻᗿᘁᘇ戧nd;橕;橜lope;橘;橚΀;elmrszᘘᘙᘛᘞᘿᙏᙙ戠;榤e\xbbᘙsdĀ;aᘥᘦ戡ѡᘰᘲᘴᘶᘸᘺᘼᘾ;榨;榩;榪;榫;榬;榭;榮;榯tĀ;vᙅᙆ戟bĀ;dᙌᙍ抾;榝Āptᙔᙗh;戢\xbb\xb9arr;捼Āgpᙣᙧon;䄅f;쀀\ud835\udd52΀;Eaeiop዁ᙻᙽᚂᚄᚇᚊ;橰cir;橯;扊d;手s;䀧roxĀ;e዁ᚒ\xf1ᚃing耻\xe5䃥ƀctyᚡᚦᚨr;쀀\ud835\udcb6;䀪mpĀ;e዁ᚯ\xf1ʈilde耻\xe3䃣ml耻\xe4䃤Āciᛂᛈonin\xf4ɲnt;樑ࠀNabcdefiklnoprsu᛭ᛱᜰ᜼ᝃᝈ᝸᝽០៦ᠹᡐᜍ᤽᥈ᥰot;櫭Ācrᛶ᜞kȀcepsᜀᜅᜍᜓong;扌psilon;䏶rime;怵imĀ;e᜚᜛戽q;拍Ŷᜢᜦee;抽edĀ;gᜬᜭ挅e\xbbᜭrkĀ;t፜᜷brk;掶Āoyᜁᝁ;䐱quo;怞ʀcmprtᝓ᝛ᝡᝤᝨausĀ;eĊĉptyv;榰s\xe9ᜌno\xf5ēƀahwᝯ᝱ᝳ;䎲;愶een;扬r;쀀\ud835\udd1fg΀costuvwឍឝឳេ៕៛៞ƀaiuបពរ\xf0ݠrc;旯p\xbb፱ƀdptឤឨឭot;樀lus;樁imes;樂ɱឹ\x00\x00ើcup;樆ar;昅riangleĀdu៍្own;施p;斳plus;樄e\xe5ᑄ\xe5ᒭarow;植ƀako៭ᠦᠵĀcn៲ᠣkƀlst៺֫᠂ozenge;槫riangleȀ;dlr᠒᠓᠘᠝斴own;斾eft;旂ight;斸k;搣Ʊᠫ\x00ᠳƲᠯ\x00ᠱ;斒;斑4;斓ck;斈ĀeoᠾᡍĀ;qᡃᡆ쀀=⃥uiv;쀀≡⃥t;挐Ȁptwxᡙᡞᡧᡬf;쀀\ud835\udd53Ā;tᏋᡣom\xbbᏌtie;拈؀DHUVbdhmptuvᢅᢖᢪᢻᣗᣛᣬ᣿ᤅᤊᤐᤡȀLRlrᢎᢐᢒᢔ;敗;敔;敖;敓ʀ;DUduᢡᢢᢤᢦᢨ敐;敦;敩;敤;敧ȀLRlrᢳᢵᢷᢹ;敝;敚;敜;教΀;HLRhlrᣊᣋᣍᣏᣑᣓᣕ救;敬;散;敠;敫;敢;敟ox;槉ȀLRlrᣤᣦᣨᣪ;敕;敒;攐;攌ʀ;DUduڽ᣷᣹᣻᣽;敥;敨;攬;攴inus;抟lus;択imes;抠ȀLRlrᤙᤛᤝ᤟;敛;敘;攘;攔΀;HLRhlrᤰᤱᤳᤵᤷ᤻᤹攂;敪;敡;敞;攼;攤;攜Āevģ᥂bar耻\xa6䂦Ȁceioᥑᥖᥚᥠr;쀀\ud835\udcb7mi;恏mĀ;e᜚᜜lƀ;bhᥨᥩᥫ䁜;槅sub;柈Ŭᥴ᥾lĀ;e᥹᥺怢t\xbb᥺pƀ;Eeįᦅᦇ;檮Ā;qۜۛೡᦧ\x00᧨ᨑᨕᨲ\x00ᨷᩐ\x00\x00᪴\x00\x00᫁\x00\x00ᬡᬮ᭍᭒\x00᯽\x00ᰌƀcpr᦭ᦲ᧝ute;䄇̀;abcdsᦿᧀᧄ᧊᧕᧙戩nd;橄rcup;橉Āau᧏᧒p;橋p;橇ot;橀;쀀∩︀Āeo᧢᧥t;恁\xeeړȀaeiu᧰᧻ᨁᨅǰ᧵\x00᧸s;橍on;䄍dil耻\xe7䃧rc;䄉psĀ;sᨌᨍ橌m;橐ot;䄋ƀdmnᨛᨠᨦil肻\xb8ƭptyv;榲t脀\xa2;eᨭᨮ䂢r\xe4Ʋr;쀀\ud835\udd20ƀceiᨽᩀᩍy;䑇ckĀ;mᩇᩈ朓ark\xbbᩈ;䏇r΀;Ecefms᩟᩠ᩢᩫ᪤᪪᪮旋;槃ƀ;elᩩᩪᩭ䋆q;扗eɡᩴ\x00\x00᪈rrowĀlr᩼᪁eft;憺ight;憻ʀRSacd᪒᪔᪖᪚᪟\xbbཇ;擈st;抛irc;抚ash;抝nint;樐id;櫯cir;槂ubsĀ;u᪻᪼晣it\xbb᪼ˬ᫇᫔᫺\x00ᬊonĀ;eᫍᫎ䀺Ā;q\xc7\xc6ɭ᫙\x00\x00᫢aĀ;t᫞᫟䀬;䁀ƀ;fl᫨᫩᫫戁\xeeᅠeĀmx᫱᫶ent\xbb᫩e\xf3ɍǧ᫾\x00ᬇĀ;dኻᬂot;橭n\xf4Ɇƀfryᬐᬔᬗ;쀀\ud835\udd54o\xe4ɔ脀\xa9;sŕᬝr;愗Āaoᬥᬩrr;憵ss;朗Ācuᬲᬷr;쀀\ud835\udcb8Ābpᬼ᭄Ā;eᭁᭂ櫏;櫑Ā;eᭉᭊ櫐;櫒dot;拯΀delprvw᭠᭬᭷ᮂᮬᯔ᯹arrĀlr᭨᭪;椸;椵ɰ᭲\x00\x00᭵r;拞c;拟arrĀ;p᭿ᮀ憶;椽̀;bcdosᮏᮐᮖᮡᮥᮨ截rcap;橈Āauᮛᮞp;橆p;橊ot;抍r;橅;쀀∪︀Ȁalrv᮵ᮿᯞᯣrrĀ;mᮼᮽ憷;椼yƀevwᯇᯔᯘqɰᯎ\x00\x00ᯒre\xe3᭳u\xe3᭵ee;拎edge;拏en耻\xa4䂤earrowĀlrᯮ᯳eft\xbbᮀight\xbbᮽe\xe4ᯝĀciᰁᰇonin\xf4Ƿnt;戱lcty;挭ঀAHabcdefhijlorstuwz᰸᰻᰿ᱝᱩᱵᲊᲞᲬᲷ᳻᳿ᴍᵻᶑᶫᶻ᷆᷍r\xf2΁ar;楥Ȁglrs᱈ᱍ᱒᱔ger;怠eth;愸\xf2ᄳhĀ;vᱚᱛ怐\xbbऊūᱡᱧarow;椏a\xe3̕Āayᱮᱳron;䄏;䐴ƀ;ao̲ᱼᲄĀgrʿᲁr;懊tseq;橷ƀglmᲑᲔᲘ耻\xb0䂰ta;䎴ptyv;榱ĀirᲣᲨsht;楿;쀀\ud835\udd21arĀlrᲳᲵ\xbbࣜ\xbbသʀaegsv᳂͸᳖᳜᳠mƀ;oș᳊᳔ndĀ;ș᳑uit;晦amma;䏝in;拲ƀ;io᳧᳨᳸䃷de脀\xf7;o᳧ᳰntimes;拇n\xf8᳷cy;䑒cɯᴆ\x00\x00ᴊrn;挞op;挍ʀlptuwᴘᴝᴢᵉᵕlar;䀤f;쀀\ud835\udd55ʀ;emps̋ᴭᴷᴽᵂqĀ;d͒ᴳot;扑inus;戸lus;戔quare;抡blebarwedg\xe5\xfanƀadhᄮᵝᵧownarrow\xf3ᲃarpoonĀlrᵲᵶef\xf4Ჴigh\xf4ᲶŢᵿᶅkaro\xf7གɯᶊ\x00\x00ᶎrn;挟op;挌ƀcotᶘᶣᶦĀryᶝᶡ;쀀\ud835\udcb9;䑕l;槶rok;䄑Ādrᶰᶴot;拱iĀ;fᶺ᠖斿Āah᷀᷃r\xf2Щa\xf2ྦangle;榦Āci᷒ᷕy;䑟grarr;柿ऀDacdefglmnopqrstuxḁḉḙḸոḼṉṡṾấắẽỡἪἷὄ὎὚ĀDoḆᴴo\xf4ᲉĀcsḎḔute耻\xe9䃩ter;橮ȀaioyḢḧḱḶron;䄛rĀ;cḭḮ扖耻\xea䃪lon;払;䑍ot;䄗ĀDrṁṅot;扒;쀀\ud835\udd22ƀ;rsṐṑṗ檚ave耻\xe8䃨Ā;dṜṝ檖ot;檘Ȁ;ilsṪṫṲṴ檙nters;揧;愓Ā;dṹṺ檕ot;檗ƀapsẅẉẗcr;䄓tyƀ;svẒẓẕ戅et\xbbẓpĀ1;ẝẤĳạả;怄;怅怃ĀgsẪẬ;䅋p;怂ĀgpẴẸon;䄙f;쀀\ud835\udd56ƀalsỄỎỒrĀ;sỊị拕l;槣us;橱iƀ;lvỚớở䎵on\xbbớ;䏵ȀcsuvỪỳἋἣĀioữḱrc\xbbḮɩỹ\x00\x00ỻ\xedՈantĀglἂἆtr\xbbṝess\xbbṺƀaeiἒ἖Ἒls;䀽st;扟vĀ;DȵἠD;橸parsl;槥ĀDaἯἳot;打rr;楱ƀcdiἾὁỸr;愯o\xf4͒ĀahὉὋ;䎷耻\xf0䃰Āmrὓὗl耻\xeb䃫o;悬ƀcipὡὤὧl;䀡s\xf4ծĀeoὬὴctatio\xeeՙnential\xe5չৡᾒ\x00ᾞ\x00ᾡᾧ\x00\x00ῆῌ\x00ΐ\x00ῦῪ \x00 ⁚llingdotse\xf1Ṅy;䑄male;晀ƀilrᾭᾳ῁lig;耀ﬃɩᾹ\x00\x00᾽g;耀ﬀig;耀ﬄ;쀀\ud835\udd23lig;耀ﬁlig;쀀fjƀaltῙ῜ῡt;晭ig;耀ﬂns;斱of;䆒ǰ΅\x00ῳf;쀀\ud835\udd57ĀakֿῷĀ;vῼ´拔;櫙artint;樍Āao‌⁕Ācs‑⁒α‚‰‸⁅⁈\x00⁐β•‥‧‪‬\x00‮耻\xbd䂽;慓耻\xbc䂼;慕;慙;慛Ƴ‴\x00‶;慔;慖ʴ‾⁁\x00\x00⁃耻\xbe䂾;慗;慜5;慘ƶ⁌\x00⁎;慚;慝8;慞l;恄wn;挢cr;쀀\ud835\udcbbࢀEabcdefgijlnorstv₂₉₟₥₰₴⃰⃵⃺⃿℃ℒℸ̗ℾ⅒↞Ā;lٍ₇;檌ƀcmpₐₕ₝ute;䇵maĀ;dₜ᳚䎳;檆reve;䄟Āiy₪₮rc;䄝;䐳ot;䄡Ȁ;lqsؾق₽⃉ƀ;qsؾٌ⃄lan\xf4٥Ȁ;cdl٥⃒⃥⃕c;檩otĀ;o⃜⃝檀Ā;l⃢⃣檂;檄Ā;e⃪⃭쀀⋛︀s;檔r;쀀\ud835\udd24Ā;gٳ؛mel;愷cy;䑓Ȁ;Eajٚℌℎℐ;檒;檥;檤ȀEaesℛℝ℩ℴ;扩pĀ;p℣ℤ檊rox\xbbℤĀ;q℮ℯ檈Ā;q℮ℛim;拧pf;쀀\ud835\udd58Āci⅃ⅆr;愊mƀ;el٫ⅎ⅐;檎;檐茀>;cdlqr׮ⅠⅪⅮⅳⅹĀciⅥⅧ;檧r;橺ot;拗Par;榕uest;橼ʀadelsↄⅪ←ٖ↛ǰ↉\x00↎pro\xf8₞r;楸qĀlqؿ↖les\xf3₈i\xed٫Āen↣↭rtneqq;쀀≩︀\xc5↪ԀAabcefkosy⇄⇇⇱⇵⇺∘∝∯≨≽r\xf2ΠȀilmr⇐⇔⇗⇛rs\xf0ᒄf\xbb․il\xf4کĀdr⇠⇤cy;䑊ƀ;cwࣴ⇫⇯ir;楈;憭ar;意irc;䄥ƀalr∁∎∓rtsĀ;u∉∊晥it\xbb∊lip;怦con;抹r;쀀\ud835\udd25sĀew∣∩arow;椥arow;椦ʀamopr∺∾≃≞≣rr;懿tht;戻kĀlr≉≓eftarrow;憩ightarrow;憪f;쀀\ud835\udd59bar;怕ƀclt≯≴≸r;쀀\ud835\udcbdas\xe8⇴rok;䄧Ābp⊂⊇ull;恃hen\xbbᱛૡ⊣\x00⊪\x00⊸⋅⋎\x00⋕⋳\x00\x00⋸⌢⍧⍢⍿\x00⎆⎪⎴cute耻\xed䃭ƀ;iyݱ⊰⊵rc耻\xee䃮;䐸Ācx⊼⊿y;䐵cl耻\xa1䂡ĀfrΟ⋉;쀀\ud835\udd26rave耻\xec䃬Ȁ;inoܾ⋝⋩⋮Āin⋢⋦nt;樌t;戭fin;槜ta;愩lig;䄳ƀaop⋾⌚⌝ƀcgt⌅⌈⌗r;䄫ƀelpܟ⌏⌓in\xe5ގar\xf4ܠh;䄱f;抷ed;䆵ʀ;cfotӴ⌬⌱⌽⍁are;愅inĀ;t⌸⌹戞ie;槝do\xf4⌙ʀ;celpݗ⍌⍐⍛⍡al;抺Āgr⍕⍙er\xf3ᕣ\xe3⍍arhk;樗rod;樼Ȁcgpt⍯⍲⍶⍻y;䑑on;䄯f;쀀\ud835\udd5aa;䎹uest耻\xbf䂿Āci⎊⎏r;쀀\ud835\udcbenʀ;EdsvӴ⎛⎝⎡ӳ;拹ot;拵Ā;v⎦⎧拴;拳Ā;iݷ⎮lde;䄩ǫ⎸\x00⎼cy;䑖l耻\xef䃯̀cfmosu⏌⏗⏜⏡⏧⏵Āiy⏑⏕rc;䄵;䐹r;쀀\ud835\udd27ath;䈷pf;쀀\ud835\udd5bǣ⏬\x00⏱r;쀀\ud835\udcbfrcy;䑘kcy;䑔Ѐacfghjos␋␖␢␧␭␱␵␻ppaĀ;v␓␔䎺;䏰Āey␛␠dil;䄷;䐺r;쀀\ud835\udd28reen;䄸cy;䑅cy;䑜pf;쀀\ud835\udd5ccr;쀀\ud835\udcc0஀ABEHabcdefghjlmnoprstuv⑰⒁⒆⒍⒑┎┽╚▀♎♞♥♹♽⚚⚲⛘❝❨➋⟀⠁⠒ƀart⑷⑺⑼r\xf2৆\xf2Εail;椛arr;椎Ā;gঔ⒋;檋ar;楢ॣ⒥\x00⒪\x00⒱\x00\x00\x00\x00\x00⒵Ⓔ\x00ⓆⓈⓍ\x00⓹ute;䄺mptyv;榴ra\xeeࡌbda;䎻gƀ;dlࢎⓁⓃ;榑\xe5ࢎ;檅uo耻\xab䂫rЀ;bfhlpst࢙ⓞⓦⓩ⓫⓮⓱⓵Ā;f࢝ⓣs;椟s;椝\xeb≒p;憫l;椹im;楳l;憢ƀ;ae⓿─┄檫il;椙Ā;s┉┊檭;쀀⪭︀ƀabr┕┙┝rr;椌rk;杲Āak┢┬cĀek┨┪;䁻;䁛Āes┱┳;榋lĀdu┹┻;榏;榍Ȁaeuy╆╋╖╘ron;䄾Ādi═╔il;䄼\xecࢰ\xe2┩;䐻Ȁcqrs╣╦╭╽a;椶uoĀ;rนᝆĀdu╲╷har;楧shar;楋h;憲ʀ;fgqs▋▌উ◳◿扤tʀahlrt▘▤▷◂◨rrowĀ;t࢙□a\xe9⓶arpoonĀdu▯▴own\xbbњp\xbb०eftarrows;懇ightƀahs◍◖◞rrowĀ;sࣴࢧarpoon\xf3྘quigarro\xf7⇰hreetimes;拋ƀ;qs▋ও◺lan\xf4বʀ;cdgsব☊☍☝☨c;檨otĀ;o☔☕橿Ā;r☚☛檁;檃Ā;e☢☥쀀⋚︀s;檓ʀadegs☳☹☽♉♋ppro\xf8Ⓠot;拖qĀgq♃♅\xf4উgt\xf2⒌\xf4ছi\xedলƀilr♕࣡♚sht;楼;쀀\ud835\udd29Ā;Eজ♣;檑š♩♶rĀdu▲♮Ā;l॥♳;楪lk;斄cy;䑙ʀ;achtੈ⚈⚋⚑⚖r\xf2◁orne\xf2ᴈard;楫ri;旺Āio⚟⚤dot;䅀ustĀ;a⚬⚭掰che\xbb⚭ȀEaes⚻⚽⛉⛔;扨pĀ;p⛃⛄檉rox\xbb⛄Ā;q⛎⛏檇Ā;q⛎⚻im;拦Ѐabnoptwz⛩⛴⛷✚✯❁❇❐Ānr⛮⛱g;柬r;懽r\xebࣁgƀlmr⛿✍✔eftĀar০✇ight\xe1৲apsto;柼ight\xe1৽parrowĀlr✥✩ef\xf4⓭ight;憬ƀafl✶✹✽r;榅;쀀\ud835\udd5dus;樭imes;樴š❋❏st;戗\xe1ፎƀ;ef❗❘᠀旊nge\xbb❘arĀ;l❤❥䀨t;榓ʀachmt❳❶❼➅➇r\xf2ࢨorne\xf2ᶌarĀ;d྘➃;業;怎ri;抿̀achiqt➘➝ੀ➢➮➻quo;怹r;쀀\ud835\udcc1mƀ;egল➪➬;檍;檏Ābu┪➳oĀ;rฟ➹;怚rok;䅂萀<;cdhilqrࠫ⟒☹⟜⟠⟥⟪⟰Āci⟗⟙;檦r;橹re\xe5◲mes;拉arr;楶uest;橻ĀPi⟵⟹ar;榖ƀ;ef⠀भ᠛旃rĀdu⠇⠍shar;楊har;楦Āen⠗⠡rtneqq;쀀≨︀\xc5⠞܀Dacdefhilnopsu⡀⡅⢂⢎⢓⢠⢥⢨⣚⣢⣤ઃ⣳⤂Dot;戺Ȁclpr⡎⡒⡣⡽r耻\xaf䂯Āet⡗⡙;時Ā;e⡞⡟朠se\xbb⡟Ā;sျ⡨toȀ;dluျ⡳⡷⡻ow\xeeҌef\xf4ए\xf0Ꮡker;斮Āoy⢇⢌mma;権;䐼ash;怔asuredangle\xbbᘦr;쀀\ud835\udd2ao;愧ƀcdn⢯⢴⣉ro耻\xb5䂵Ȁ;acdᑤ⢽⣀⣄s\xf4ᚧir;櫰ot肻\xb7Ƶusƀ;bd⣒ᤃ⣓戒Ā;uᴼ⣘;横ţ⣞⣡p;櫛\xf2−\xf0ઁĀdp⣩⣮els;抧f;쀀\ud835\udd5eĀct⣸⣽r;쀀\ud835\udcc2pos\xbbᖝƀ;lm⤉⤊⤍䎼timap;抸ఀGLRVabcdefghijlmoprstuvw⥂⥓⥾⦉⦘⧚⧩⨕⨚⩘⩝⪃⪕⪤⪨⬄⬇⭄⭿⮮ⰴⱧⱼ⳩Āgt⥇⥋;쀀⋙̸Ā;v⥐௏쀀≫⃒ƀelt⥚⥲⥶ftĀar⥡⥧rrow;懍ightarrow;懎;쀀⋘̸Ā;v⥻ే쀀≪⃒ightarrow;懏ĀDd⦎⦓ash;抯ash;抮ʀbcnpt⦣⦧⦬⦱⧌la\xbb˞ute;䅄g;쀀∠⃒ʀ;Eiop඄⦼⧀⧅⧈;쀀⩰̸d;쀀≋̸s;䅉ro\xf8඄urĀ;a⧓⧔普lĀ;s⧓ସǳ⧟\x00⧣p肻\xa0ଷmpĀ;e௹ఀʀaeouy⧴⧾⨃⨐⨓ǰ⧹\x00⧻;橃on;䅈dil;䅆ngĀ;dൾ⨊ot;쀀⩭̸p;橂;䐽ash;怓΀;Aadqsxஒ⨩⨭⨻⩁⩅⩐rr;懗rĀhr⨳⨶k;椤Ā;oᏲᏰot;쀀≐̸ui\xf6ୣĀei⩊⩎ar;椨\xed஘istĀ;s஠டr;쀀\ud835\udd2bȀEest௅⩦⩹⩼ƀ;qs஼⩭௡ƀ;qs஼௅⩴lan\xf4௢i\xed௪Ā;rஶ⪁\xbbஷƀAap⪊⪍⪑r\xf2⥱rr;憮ar;櫲ƀ;svྍ⪜ྌĀ;d⪡⪢拼;拺cy;䑚΀AEadest⪷⪺⪾⫂⫅⫶⫹r\xf2⥦;쀀≦̸rr;憚r;急Ȁ;fqs఻⫎⫣⫯tĀar⫔⫙rro\xf7⫁ightarro\xf7⪐ƀ;qs఻⪺⫪lan\xf4ౕĀ;sౕ⫴\xbbశi\xedౝĀ;rవ⫾iĀ;eచథi\xe4ඐĀpt⬌⬑f;쀀\ud835\udd5f膀\xac;in⬙⬚⬶䂬nȀ;Edvஉ⬤⬨⬮;쀀⋹̸ot;쀀⋵̸ǡஉ⬳⬵;拷;拶iĀ;vಸ⬼ǡಸ⭁⭃;拾;拽ƀaor⭋⭣⭩rȀ;ast୻⭕⭚⭟lle\xec୻l;쀀⫽⃥;쀀∂̸lint;樔ƀ;ceಒ⭰⭳u\xe5ಥĀ;cಘ⭸Ā;eಒ⭽\xf1ಘȀAait⮈⮋⮝⮧r\xf2⦈rrƀ;cw⮔⮕⮙憛;쀀⤳̸;쀀↝̸ghtarrow\xbb⮕riĀ;eೋೖ΀chimpqu⮽⯍⯙⬄୸⯤⯯Ȁ;cerല⯆ഷ⯉u\xe5൅;쀀\ud835\udcc3ortɭ⬅\x00\x00⯖ar\xe1⭖mĀ;e൮⯟Ā;q൴൳suĀbp⯫⯭\xe5೸\xe5ഋƀbcp⯶ⰑⰙȀ;Ees⯿ⰀഢⰄ抄;쀀⫅̸etĀ;eഛⰋqĀ;qണⰀcĀ;eലⰗ\xf1സȀ;EesⰢⰣൟⰧ抅;쀀⫆̸etĀ;e൘ⰮqĀ;qൠⰣȀgilrⰽⰿⱅⱇ\xecௗlde耻\xf1䃱\xe7ృiangleĀlrⱒⱜeftĀ;eచⱚ\xf1దightĀ;eೋⱥ\xf1೗Ā;mⱬⱭ䎽ƀ;esⱴⱵⱹ䀣ro;愖p;怇ҀDHadgilrsⲏⲔⲙⲞⲣⲰⲶⳓⳣash;抭arr;椄p;쀀≍⃒ash;抬ĀetⲨⲬ;쀀≥⃒;쀀>⃒nfin;槞ƀAetⲽⳁⳅrr;椂;쀀≤⃒Ā;rⳊⳍ쀀<⃒ie;쀀⊴⃒ĀAtⳘⳜrr;椃rie;쀀⊵⃒im;쀀∼⃒ƀAan⳰⳴ⴂrr;懖rĀhr⳺⳽k;椣Ā;oᏧᏥear;椧ቓ᪕\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00ⴭ\x00ⴸⵈⵠⵥ⵲ⶄᬇ\x00\x00ⶍⶫ\x00ⷈⷎ\x00ⷜ⸙⸫⸾⹃Ācsⴱ᪗ute耻\xf3䃳ĀiyⴼⵅrĀ;c᪞ⵂ耻\xf4䃴;䐾ʀabios᪠ⵒⵗǈⵚlac;䅑v;樸old;榼lig;䅓Ācr⵩⵭ir;榿;쀀\ud835\udd2cͯ⵹\x00\x00⵼\x00ⶂn;䋛ave耻\xf2䃲;槁Ābmⶈ෴ar;榵Ȁacitⶕ⶘ⶥⶨr\xf2᪀Āir⶝ⶠr;榾oss;榻n\xe5๒;槀ƀaeiⶱⶵⶹcr;䅍ga;䏉ƀcdnⷀⷅǍron;䎿;榶pf;쀀\ud835\udd60ƀaelⷔ⷗ǒr;榷rp;榹΀;adiosvⷪⷫⷮ⸈⸍⸐⸖戨r\xf2᪆Ȁ;efmⷷⷸ⸂⸅橝rĀ;oⷾⷿ愴f\xbbⷿ耻\xaa䂪耻\xba䂺gof;抶r;橖lope;橗;橛ƀclo⸟⸡⸧\xf2⸁ash耻\xf8䃸l;折iŬⸯ⸴de耻\xf5䃵esĀ;aǛ⸺s;樶ml耻\xf6䃶bar;挽ૡ⹞\x00⹽\x00⺀⺝\x00⺢⺹\x00\x00⻋ຜ\x00⼓\x00\x00⼫⾼\x00⿈rȀ;astЃ⹧⹲຅脀\xb6;l⹭⹮䂶le\xecЃɩ⹸\x00\x00⹻m;櫳;櫽y;䐿rʀcimpt⺋⺏⺓ᡥ⺗nt;䀥od;䀮il;怰enk;怱r;쀀\ud835\udd2dƀimo⺨⺰⺴Ā;v⺭⺮䏆;䏕ma\xf4੶ne;明ƀ;tv⺿⻀⻈䏀chfork\xbb´;䏖Āau⻏⻟nĀck⻕⻝kĀ;h⇴⻛;愎\xf6⇴sҀ;abcdemst⻳⻴ᤈ⻹⻽⼄⼆⼊⼎䀫cir;樣ir;樢Āouᵀ⼂;樥;橲n肻\xb1ຝim;樦wo;樧ƀipu⼙⼠⼥ntint;樕f;쀀\ud835\udd61nd耻\xa3䂣Ԁ;Eaceinosu່⼿⽁⽄⽇⾁⾉⾒⽾⾶;檳p;檷u\xe5໙Ā;c໎⽌̀;acens່⽙⽟⽦⽨⽾ppro\xf8⽃urlye\xf1໙\xf1໎ƀaes⽯⽶⽺pprox;檹qq;檵im;拨i\xedໟmeĀ;s⾈ຮ怲ƀEas⽸⾐⽺\xf0⽵ƀdfp໬⾙⾯ƀals⾠⾥⾪lar;挮ine;挒urf;挓Ā;t໻⾴\xef໻rel;抰Āci⿀⿅r;쀀\ud835\udcc5;䏈ncsp;怈̀fiopsu⿚⋢⿟⿥⿫⿱r;쀀\ud835\udd2epf;쀀\ud835\udd62rime;恗cr;쀀\ud835\udcc6ƀaeo⿸〉〓tĀei⿾々rnion\xf3ڰnt;樖stĀ;e【】䀿\xf1Ἑ\xf4༔઀ABHabcdefhilmnoprstux぀けさすムㄎㄫㅇㅢㅲㆎ㈆㈕㈤㈩㉘㉮㉲㊐㊰㊷ƀartぇおがr\xf2Ⴓ\xf2ϝail;検ar\xf2ᱥar;楤΀cdenqrtとふへみわゔヌĀeuねぱ;쀀∽̱te;䅕i\xe3ᅮmptyv;榳gȀ;del࿑らるろ;榒;榥\xe5࿑uo耻\xbb䂻rր;abcfhlpstw࿜ガクシスゼゾダッデナp;極Ā;f࿠ゴs;椠;椳s;椞\xeb≝\xf0✮l;楅im;楴l;憣;憝Āaiパフil;椚oĀ;nホボ戶al\xf3༞ƀabrョリヮr\xf2៥rk;杳ĀakンヽcĀekヹ・;䁽;䁝Āes㄂㄄;榌lĀduㄊㄌ;榎;榐Ȁaeuyㄗㄜㄧㄩron;䅙Ādiㄡㄥil;䅗\xec࿲\xe2ヺ;䑀Ȁclqsㄴㄷㄽㅄa;椷dhar;楩uoĀ;rȎȍh;憳ƀacgㅎㅟངlȀ;ipsླྀㅘㅛႜn\xe5Ⴛar\xf4ྩt;断ƀilrㅩဣㅮsht;楽;쀀\ud835\udd2fĀaoㅷㆆrĀduㅽㅿ\xbbѻĀ;l႑ㆄ;楬Ā;vㆋㆌ䏁;䏱ƀgns㆕ㇹㇼht̀ahlrstㆤㆰ㇂㇘㇤㇮rrowĀ;t࿜ㆭa\xe9トarpoonĀduㆻㆿow\xeeㅾp\xbb႒eftĀah㇊㇐rrow\xf3࿪arpoon\xf3Ցightarrows;應quigarro\xf7ニhreetimes;拌g;䋚ingdotse\xf1ἲƀahm㈍㈐㈓r\xf2࿪a\xf2Ց;怏oustĀ;a㈞㈟掱che\xbb㈟mid;櫮Ȁabpt㈲㈽㉀㉒Ānr㈷㈺g;柭r;懾r\xebဃƀafl㉇㉊㉎r;榆;쀀\ud835\udd63us;樮imes;樵Āap㉝㉧rĀ;g㉣㉤䀩t;榔olint;樒ar\xf2㇣Ȁachq㉻㊀Ⴜ㊅quo;怺r;쀀\ud835\udcc7Ābu・㊊oĀ;rȔȓƀhir㊗㊛㊠re\xe5ㇸmes;拊iȀ;efl㊪ၙᠡ㊫方tri;槎luhar;楨;愞ൡ㋕㋛㋟㌬㌸㍱\x00㍺㎤\x00\x00㏬㏰\x00㐨㑈㑚㒭㒱㓊㓱\x00㘖\x00\x00㘳cute;䅛qu\xef➺Ԁ;Eaceinpsyᇭ㋳㋵㋿㌂㌋㌏㌟㌦㌩;檴ǰ㋺\x00㋼;檸on;䅡u\xe5ᇾĀ;dᇳ㌇il;䅟rc;䅝ƀEas㌖㌘㌛;檶p;檺im;择olint;樓i\xedሄ;䑁otƀ;be㌴ᵇ㌵担;橦΀Aacmstx㍆㍊㍗㍛㍞㍣㍭rr;懘rĀhr㍐㍒\xeb∨Ā;oਸ਼਴t耻\xa7䂧i;䀻war;椩mĀin㍩\xf0nu\xf3\xf1t;朶rĀ;o㍶⁕쀀\ud835\udd30Ȁacoy㎂㎆㎑㎠rp;景Āhy㎋㎏cy;䑉;䑈rtɭ㎙\x00\x00㎜i\xe4ᑤara\xec⹯耻\xad䂭Āgm㎨㎴maƀ;fv㎱㎲㎲䏃;䏂Ѐ;deglnprካ㏅㏉㏎㏖㏞㏡㏦ot;橪Ā;q኱ኰĀ;E㏓㏔檞;檠Ā;E㏛㏜檝;檟e;扆lus;樤arr;楲ar\xf2ᄽȀaeit㏸㐈㐏㐗Āls㏽㐄lsetm\xe9㍪hp;樳parsl;槤Ādlᑣ㐔e;挣Ā;e㐜㐝檪Ā;s㐢㐣檬;쀀⪬︀ƀflp㐮㐳㑂tcy;䑌Ā;b㐸㐹䀯Ā;a㐾㐿槄r;挿f;쀀\ud835\udd64aĀdr㑍ЂesĀ;u㑔㑕晠it\xbb㑕ƀcsu㑠㑹㒟Āau㑥㑯pĀ;sᆈ㑫;쀀⊓︀pĀ;sᆴ㑵;쀀⊔︀uĀbp㑿㒏ƀ;esᆗᆜ㒆etĀ;eᆗ㒍\xf1ᆝƀ;esᆨᆭ㒖etĀ;eᆨ㒝\xf1ᆮƀ;afᅻ㒦ְrť㒫ֱ\xbbᅼar\xf2ᅈȀcemt㒹㒾㓂㓅r;쀀\ud835\udcc8tm\xee\xf1i\xec㐕ar\xe6ᆾĀar㓎㓕rĀ;f㓔ឿ昆Āan㓚㓭ightĀep㓣㓪psilo\xeeỠh\xe9⺯s\xbb⡒ʀbcmnp㓻㕞ሉ㖋㖎Ҁ;Edemnprs㔎㔏㔑㔕㔞㔣㔬㔱㔶抂;櫅ot;檽Ā;dᇚ㔚ot;櫃ult;櫁ĀEe㔨㔪;櫋;把lus;檿arr;楹ƀeiu㔽㕒㕕tƀ;en㔎㕅㕋qĀ;qᇚ㔏eqĀ;q㔫㔨m;櫇Ābp㕚㕜;櫕;櫓c̀;acensᇭ㕬㕲㕹㕻㌦ppro\xf8㋺urlye\xf1ᇾ\xf1ᇳƀaes㖂㖈㌛ppro\xf8㌚q\xf1㌗g;晪ڀ123;Edehlmnps㖩㖬㖯ሜ㖲㖴㗀㗉㗕㗚㗟㗨㗭耻\xb9䂹耻\xb2䂲耻\xb3䂳;櫆Āos㖹㖼t;檾ub;櫘Ā;dሢ㗅ot;櫄sĀou㗏㗒l;柉b;櫗arr;楻ult;櫂ĀEe㗤㗦;櫌;抋lus;櫀ƀeiu㗴㘉㘌tƀ;enሜ㗼㘂qĀ;qሢ㖲eqĀ;q㗧㗤m;櫈Ābp㘑㘓;櫔;櫖ƀAan㘜㘠㘭rr;懙rĀhr㘦㘨\xeb∮Ā;oਫ਩war;椪lig耻\xdf䃟௡㙑㙝㙠ዎ㙳㙹\x00㙾㛂\x00\x00\x00\x00\x00㛛㜃\x00㜉㝬\x00\x00\x00㞇ɲ㙖\x00\x00㙛get;挖;䏄r\xeb๟ƀaey㙦㙫㙰ron;䅥dil;䅣;䑂lrec;挕r;쀀\ud835\udd31Ȁeiko㚆㚝㚵㚼ǲ㚋\x00㚑eĀ4fኄኁaƀ;sv㚘㚙㚛䎸ym;䏑Ācn㚢㚲kĀas㚨㚮ppro\xf8዁im\xbbኬs\xf0ኞĀas㚺㚮\xf0዁rn耻\xfe䃾Ǭ̟㛆⋧es膀\xd7;bd㛏㛐㛘䃗Ā;aᤏ㛕r;樱;樰ƀeps㛡㛣㜀\xe1⩍Ȁ;bcf҆㛬㛰㛴ot;挶ir;櫱Ā;o㛹㛼쀀\ud835\udd65rk;櫚\xe1㍢rime;怴ƀaip㜏㜒㝤d\xe5ቈ΀adempst㜡㝍㝀㝑㝗㝜㝟ngleʀ;dlqr㜰㜱㜶㝀㝂斵own\xbbᶻeftĀ;e⠀㜾\xf1म;扜ightĀ;e㊪㝋\xf1ၚot;旬inus;樺lus;樹b;槍ime;樻ezium;揢ƀcht㝲㝽㞁Āry㝷㝻;쀀\ud835\udcc9;䑆cy;䑛rok;䅧Āio㞋㞎x\xf4᝷headĀlr㞗㞠eftarro\xf7ࡏightarrow\xbbཝऀAHabcdfghlmoprstuw㟐㟓㟗㟤㟰㟼㠎㠜㠣㠴㡑㡝㡫㢩㣌㣒㣪㣶r\xf2ϭar;楣Ācr㟜㟢ute耻\xfa䃺\xf2ᅐrǣ㟪\x00㟭y;䑞ve;䅭Āiy㟵㟺rc耻\xfb䃻;䑃ƀabh㠃㠆㠋r\xf2Ꭽlac;䅱a\xf2ᏃĀir㠓㠘sht;楾;쀀\ud835\udd32rave耻\xf9䃹š㠧㠱rĀlr㠬㠮\xbbॗ\xbbႃlk;斀Āct㠹㡍ɯ㠿\x00\x00㡊rnĀ;e㡅㡆挜r\xbb㡆op;挏ri;旸Āal㡖㡚cr;䅫肻\xa8͉Āgp㡢㡦on;䅳f;쀀\ud835\udd66̀adhlsuᅋ㡸㡽፲㢑㢠own\xe1ᎳarpoonĀlr㢈㢌ef\xf4㠭igh\xf4㠯iƀ;hl㢙㢚㢜䏅\xbbᏺon\xbb㢚parrows;懈ƀcit㢰㣄㣈ɯ㢶\x00\x00㣁rnĀ;e㢼㢽挝r\xbb㢽op;挎ng;䅯ri;旹cr;쀀\ud835\udccaƀdir㣙㣝㣢ot;拰lde;䅩iĀ;f㜰㣨\xbb᠓Āam㣯㣲r\xf2㢨l耻\xfc䃼angle;榧ހABDacdeflnoprsz㤜㤟㤩㤭㦵㦸㦽㧟㧤㧨㧳㧹㧽㨁㨠r\xf2ϷarĀ;v㤦㤧櫨;櫩as\xe8ϡĀnr㤲㤷grt;榜΀eknprst㓣㥆㥋㥒㥝㥤㦖app\xe1␕othin\xe7ẖƀhir㓫⻈㥙op\xf4⾵Ā;hᎷ㥢\xefㆍĀiu㥩㥭gm\xe1㎳Ābp㥲㦄setneqĀ;q㥽㦀쀀⊊︀;쀀⫋︀setneqĀ;q㦏㦒쀀⊋︀;쀀⫌︀Āhr㦛㦟et\xe1㚜iangleĀlr㦪㦯eft\xbbथight\xbbၑy;䐲ash\xbbံƀelr㧄㧒㧗ƀ;beⷪ㧋㧏ar;抻q;扚lip;拮Ābt㧜ᑨa\xf2ᑩr;쀀\ud835\udd33tr\xe9㦮suĀbp㧯㧱\xbbജ\xbb൙pf;쀀\ud835\udd67ro\xf0໻tr\xe9㦴Ācu㨆㨋r;쀀\ud835\udccbĀbp㨐㨘nĀEe㦀㨖\xbb㥾nĀEe㦒㨞\xbb㦐igzag;榚΀cefoprs㨶㨻㩖㩛㩔㩡㩪irc;䅵Ādi㩀㩑Ābg㩅㩉ar;機eĀ;qᗺ㩏;扙erp;愘r;쀀\ud835\udd34pf;쀀\ud835\udd68Ā;eᑹ㩦at\xe8ᑹcr;쀀\ud835\udcccૣណ㪇\x00㪋\x00㪐㪛\x00\x00㪝㪨㪫㪯\x00\x00㫃㫎\x00㫘ៜ៟tr\xe9៑r;쀀\ud835\udd35ĀAa㪔㪗r\xf2σr\xf2৶;䎾ĀAa㪡㪤r\xf2θr\xf2৫a\xf0✓is;拻ƀdptឤ㪵㪾Āfl㪺ឩ;쀀\ud835\udd69im\xe5ឲĀAa㫇㫊r\xf2ώr\xf2ਁĀcq㫒ីr;쀀\ud835\udccdĀpt៖㫜r\xe9។Ѐacefiosu㫰㫽㬈㬌㬑㬕㬛㬡cĀuy㫶㫻te耻\xfd䃽;䑏Āiy㬂㬆rc;䅷;䑋n耻\xa5䂥r;쀀\ud835\udd36cy;䑗pf;쀀\ud835\udd6acr;쀀\ud835\udcceĀcm㬦㬩y;䑎l耻\xff䃿Ԁacdefhiosw㭂㭈㭔㭘㭤㭩㭭㭴㭺㮀cute;䅺Āay㭍㭒ron;䅾;䐷ot;䅼Āet㭝㭡tr\xe6ᕟa;䎶r;쀀\ud835\udd37cy;䐶grarr;懝pf;쀀\ud835\udd6bcr;쀀\ud835\udccfĀjn㮅㮇;怍j;怌'.split("").map(function(c) {
    return c.charCodeAt(0);
}));

});

parcelRequire.register("lgOev", function(module, exports) {
"use strict";
// Generated using scripts/write-decode-map.ts
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = new Uint16Array(// prettier-ignore
"Ȁaglq	\x15\x18\x1bɭ\x0f\x00\x00\x12p;䀦os;䀧t;䀾t;䀼uot;䀢".split("").map(function(c) {
    return c.charCodeAt(0);
}));

});

parcelRequire.register("9MZiE", function(module, exports) {
"use strict";
// Adapted from https://github.com/mathiasbynens/he/blob/36afe179392226cf1b6ccdb16ebbb7a5a844d93a/src/he.js#L106-L134
var $720825a2b3f32fa7$var$_a;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.replaceCodePoint = module.exports.fromCodePoint = void 0;
var $720825a2b3f32fa7$var$decodeMap = new Map([
    [
        0,
        65533
    ],
    // C1 Unicode control character reference replacements
    [
        128,
        8364
    ],
    [
        130,
        8218
    ],
    [
        131,
        402
    ],
    [
        132,
        8222
    ],
    [
        133,
        8230
    ],
    [
        134,
        8224
    ],
    [
        135,
        8225
    ],
    [
        136,
        710
    ],
    [
        137,
        8240
    ],
    [
        138,
        352
    ],
    [
        139,
        8249
    ],
    [
        140,
        338
    ],
    [
        142,
        381
    ],
    [
        145,
        8216
    ],
    [
        146,
        8217
    ],
    [
        147,
        8220
    ],
    [
        148,
        8221
    ],
    [
        149,
        8226
    ],
    [
        150,
        8211
    ],
    [
        151,
        8212
    ],
    [
        152,
        732
    ],
    [
        153,
        8482
    ],
    [
        154,
        353
    ],
    [
        155,
        8250
    ],
    [
        156,
        339
    ],
    [
        158,
        382
    ],
    [
        159,
        376
    ]
]);
/**
 * Polyfill for `String.fromCodePoint`. It is used to create a string from a Unicode code point.
 */ module.exports.fromCodePoint = // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition, node/no-unsupported-features/es-builtins
($720825a2b3f32fa7$var$_a = String.fromCodePoint) !== null && $720825a2b3f32fa7$var$_a !== void 0 ? $720825a2b3f32fa7$var$_a : function(codePoint) {
    var output = "";
    if (codePoint > 0xffff) {
        codePoint -= 0x10000;
        output += String.fromCharCode(codePoint >>> 10 & 0x3ff | 0xd800);
        codePoint = 0xdc00 | codePoint & 0x3ff;
    }
    output += String.fromCharCode(codePoint);
    return output;
};
/**
 * Replace the given code point with a replacement character if it is a
 * surrogate or is outside the valid range. Otherwise return the code
 * point unchanged.
 */ function $720825a2b3f32fa7$var$replaceCodePoint(codePoint) {
    var _a;
    if (codePoint >= 0xd800 && codePoint <= 0xdfff || codePoint > 0x10ffff) return 0xfffd;
    return (_a = $720825a2b3f32fa7$var$decodeMap.get(codePoint)) !== null && _a !== void 0 ? _a : codePoint;
}
module.exports.replaceCodePoint = $720825a2b3f32fa7$var$replaceCodePoint;
/**
 * Replace the code point if relevant, then convert it to a string.
 *
 * @deprecated Use `fromCodePoint(replaceCodePoint(codePoint))` instead.
 * @param codePoint The code point to decode.
 * @returns The decoded code point.
 */ function $720825a2b3f32fa7$var$decodeCodePoint(codePoint) {
    return (0, module.exports.fromCodePoint)($720825a2b3f32fa7$var$replaceCodePoint(codePoint));
}
module.exports.default = $720825a2b3f32fa7$var$decodeCodePoint;

});




parcelRequire.register("CnBXM", function(module, exports) {
$parcel$export(module.exports, "CDATA", () => (parcelRequire("iXsnt")).CDATA);
$parcel$export(module.exports, "Comment", () => (parcelRequire("iXsnt")).Comment);
$parcel$export(module.exports, "Document", () => (parcelRequire("iXsnt")).Document);
$parcel$export(module.exports, "Element", () => (parcelRequire("iXsnt")).Element);
$parcel$export(module.exports, "hasChildren", () => (parcelRequire("iXsnt")).hasChildren);
$parcel$export(module.exports, "isCDATA", () => (parcelRequire("iXsnt")).isCDATA);
$parcel$export(module.exports, "isComment", () => (parcelRequire("iXsnt")).isComment);
$parcel$export(module.exports, "isTag", () => (parcelRequire("iXsnt")).isTag);
$parcel$export(module.exports, "isText", () => (parcelRequire("iXsnt")).isText);
$parcel$export(module.exports, "ProcessingInstruction", () => (parcelRequire("iXsnt")).ProcessingInstruction);
$parcel$export(module.exports, "Text", () => (parcelRequire("iXsnt")).Text);

$parcel$export(module.exports, "DomHandler", () => $0735dd703e472d29$export$ff8ccbac9225de62);

var $j8Fek = parcelRequire("j8Fek");

var $iXsnt = parcelRequire("iXsnt");
// Default options
const $0735dd703e472d29$var$defaultOpts = {
    withStartIndices: false,
    withEndIndices: false,
    xmlMode: false
};
class $0735dd703e472d29$export$ff8ccbac9225de62 {
    /**
     * @param callback Called once parsing has completed.
     * @param options Settings for the handler.
     * @param elementCB Callback whenever a tag is closed.
     */ constructor(callback, options, elementCB){
        /** The elements of the DOM */ this.dom = [];
        /** The root element for the DOM */ this.root = new (0, $iXsnt.Document)(this.dom);
        /** Indicated whether parsing has been completed. */ this.done = false;
        /** Stack of open tags. */ this.tagStack = [
            this.root
        ];
        /** A data node that is still being written to. */ this.lastNode = null;
        /** Reference to the parser instance. Used for location information. */ this.parser = null;
        // Make it possible to skip arguments, for backwards-compatibility
        if (typeof options === "function") {
            elementCB = options;
            options = $0735dd703e472d29$var$defaultOpts;
        }
        if (typeof callback === "object") {
            options = callback;
            callback = undefined;
        }
        this.callback = callback !== null && callback !== void 0 ? callback : null;
        this.options = options !== null && options !== void 0 ? options : $0735dd703e472d29$var$defaultOpts;
        this.elementCB = elementCB !== null && elementCB !== void 0 ? elementCB : null;
    }
    onparserinit(parser) {
        this.parser = parser;
    }
    // Resets the handler back to starting state
    onreset() {
        this.dom = [];
        this.root = new (0, $iXsnt.Document)(this.dom);
        this.done = false;
        this.tagStack = [
            this.root
        ];
        this.lastNode = null;
        this.parser = null;
    }
    // Signals the handler that parsing is done
    onend() {
        if (this.done) return;
        this.done = true;
        this.parser = null;
        this.handleCallback(null);
    }
    onerror(error) {
        this.handleCallback(error);
    }
    onclosetag() {
        this.lastNode = null;
        const elem = this.tagStack.pop();
        if (this.options.withEndIndices) elem.endIndex = this.parser.endIndex;
        if (this.elementCB) this.elementCB(elem);
    }
    onopentag(name, attribs) {
        const type = this.options.xmlMode ? (0, $j8Fek.ElementType).Tag : undefined;
        const element = new (0, $iXsnt.Element)(name, attribs, undefined, type);
        this.addNode(element);
        this.tagStack.push(element);
    }
    ontext(data) {
        const { lastNode: lastNode } = this;
        if (lastNode && lastNode.type === (0, $j8Fek.ElementType).Text) {
            lastNode.data += data;
            if (this.options.withEndIndices) lastNode.endIndex = this.parser.endIndex;
        } else {
            const node = new (0, $iXsnt.Text)(data);
            this.addNode(node);
            this.lastNode = node;
        }
    }
    oncomment(data) {
        if (this.lastNode && this.lastNode.type === (0, $j8Fek.ElementType).Comment) {
            this.lastNode.data += data;
            return;
        }
        const node = new (0, $iXsnt.Comment)(data);
        this.addNode(node);
        this.lastNode = node;
    }
    oncommentend() {
        this.lastNode = null;
    }
    oncdatastart() {
        const text = new (0, $iXsnt.Text)("");
        const node = new (0, $iXsnt.CDATA)([
            text
        ]);
        this.addNode(node);
        text.parent = node;
        this.lastNode = text;
    }
    oncdataend() {
        this.lastNode = null;
    }
    onprocessinginstruction(name, data) {
        const node = new (0, $iXsnt.ProcessingInstruction)(name, data);
        this.addNode(node);
    }
    handleCallback(error) {
        if (typeof this.callback === "function") this.callback(error, this.dom);
        else if (error) throw error;
    }
    addNode(node) {
        const parent = this.tagStack[this.tagStack.length - 1];
        const previousSibling = parent.children[parent.children.length - 1];
        if (this.options.withStartIndices) node.startIndex = this.parser.startIndex;
        if (this.options.withEndIndices) node.endIndex = this.parser.endIndex;
        parent.children.push(node);
        if (previousSibling) {
            node.prev = previousSibling;
            previousSibling.next = node;
        }
        node.parent = parent;
        this.lastNode = null;
    }
}
var $0735dd703e472d29$export$2e2bcd8739ae039 = $0735dd703e472d29$export$ff8ccbac9225de62;

});
parcelRequire.register("j8Fek", function(module, exports) {

$parcel$export(module.exports, "ElementType", () => $deeebf19415caf3b$export$b992dc138d950e31);
$parcel$export(module.exports, "isTag", () => $deeebf19415caf3b$export$3bf645f08efe3292);
$parcel$export(module.exports, "Root", () => $deeebf19415caf3b$export$be92b6f5f03c0fe9);
$parcel$export(module.exports, "Text", () => $deeebf19415caf3b$export$5f1af8db9871e1d6);
$parcel$export(module.exports, "Directive", () => $deeebf19415caf3b$export$befdefbdce210f91);
$parcel$export(module.exports, "Comment", () => $deeebf19415caf3b$export$4d299b491347818a);
$parcel$export(module.exports, "Script", () => $deeebf19415caf3b$export$2f8b47a141e57afc);
$parcel$export(module.exports, "Style", () => $deeebf19415caf3b$export$d9e45bc13d335801);
$parcel$export(module.exports, "Tag", () => $deeebf19415caf3b$export$3288d34c523a1192);
$parcel$export(module.exports, "CDATA", () => $deeebf19415caf3b$export$1f8b8f7e5c763232);
$parcel$export(module.exports, "Doctype", () => $deeebf19415caf3b$export$31b44af36ff2c60f);
/** Types of elements found in htmlparser2's DOM */ var $deeebf19415caf3b$export$b992dc138d950e31;
(function(ElementType) {
    /** Type for the root element of a document */ ElementType["Root"] = "root";
    /** Type for Text */ ElementType["Text"] = "text";
    /** Type for <? ... ?> */ ElementType["Directive"] = "directive";
    /** Type for <!-- ... --> */ ElementType["Comment"] = "comment";
    /** Type for <script> tags */ ElementType["Script"] = "script";
    /** Type for <style> tags */ ElementType["Style"] = "style";
    /** Type for Any tag */ ElementType["Tag"] = "tag";
    /** Type for <![CDATA[ ... ]]> */ ElementType["CDATA"] = "cdata";
    /** Type for <!doctype ...> */ ElementType["Doctype"] = "doctype";
})($deeebf19415caf3b$export$b992dc138d950e31 || ($deeebf19415caf3b$export$b992dc138d950e31 = {}));
function $deeebf19415caf3b$export$3bf645f08efe3292(elem) {
    return elem.type === $deeebf19415caf3b$export$b992dc138d950e31.Tag || elem.type === $deeebf19415caf3b$export$b992dc138d950e31.Script || elem.type === $deeebf19415caf3b$export$b992dc138d950e31.Style;
}
const $deeebf19415caf3b$export$be92b6f5f03c0fe9 = $deeebf19415caf3b$export$b992dc138d950e31.Root;
const $deeebf19415caf3b$export$5f1af8db9871e1d6 = $deeebf19415caf3b$export$b992dc138d950e31.Text;
const $deeebf19415caf3b$export$befdefbdce210f91 = $deeebf19415caf3b$export$b992dc138d950e31.Directive;
const $deeebf19415caf3b$export$4d299b491347818a = $deeebf19415caf3b$export$b992dc138d950e31.Comment;
const $deeebf19415caf3b$export$2f8b47a141e57afc = $deeebf19415caf3b$export$b992dc138d950e31.Script;
const $deeebf19415caf3b$export$d9e45bc13d335801 = $deeebf19415caf3b$export$b992dc138d950e31.Style;
const $deeebf19415caf3b$export$3288d34c523a1192 = $deeebf19415caf3b$export$b992dc138d950e31.Tag;
const $deeebf19415caf3b$export$1f8b8f7e5c763232 = $deeebf19415caf3b$export$b992dc138d950e31.CDATA;
const $deeebf19415caf3b$export$31b44af36ff2c60f = $deeebf19415caf3b$export$b992dc138d950e31.Doctype;

});

parcelRequire.register("iXsnt", function(module, exports) {

$parcel$export(module.exports, "Text", () => $dcd3bfde7a749b6e$export$5f1af8db9871e1d6);
$parcel$export(module.exports, "Comment", () => $dcd3bfde7a749b6e$export$4d299b491347818a);
$parcel$export(module.exports, "ProcessingInstruction", () => $dcd3bfde7a749b6e$export$9269dce19ee35e96);
$parcel$export(module.exports, "CDATA", () => $dcd3bfde7a749b6e$export$1f8b8f7e5c763232);
$parcel$export(module.exports, "Document", () => $dcd3bfde7a749b6e$export$b34a105447964f9f);
$parcel$export(module.exports, "Element", () => $dcd3bfde7a749b6e$export$db77ccec0bb4ccac);
$parcel$export(module.exports, "isTag", () => $dcd3bfde7a749b6e$export$3bf645f08efe3292);
$parcel$export(module.exports, "isCDATA", () => $dcd3bfde7a749b6e$export$c2d65aed98d39b56);
$parcel$export(module.exports, "isText", () => $dcd3bfde7a749b6e$export$1879817ac5c922b7);
$parcel$export(module.exports, "isComment", () => $dcd3bfde7a749b6e$export$3ab01370f5e64ac8);
$parcel$export(module.exports, "hasChildren", () => $dcd3bfde7a749b6e$export$bd5ff50f0e53d41c);

var $j8Fek = parcelRequire("j8Fek");
class $dcd3bfde7a749b6e$export$85c928794f8d04d4 {
    constructor(){
        /** Parent of the node */ this.parent = null;
        /** Previous sibling */ this.prev = null;
        /** Next sibling */ this.next = null;
        /** The start index of the node. Requires `withStartIndices` on the handler to be `true. */ this.startIndex = null;
        /** The end index of the node. Requires `withEndIndices` on the handler to be `true. */ this.endIndex = null;
    }
    // Read-write aliases for properties
    /**
     * Same as {@link parent}.
     * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
     */ get parentNode() {
        return this.parent;
    }
    set parentNode(parent) {
        this.parent = parent;
    }
    /**
     * Same as {@link prev}.
     * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
     */ get previousSibling() {
        return this.prev;
    }
    set previousSibling(prev) {
        this.prev = prev;
    }
    /**
     * Same as {@link next}.
     * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
     */ get nextSibling() {
        return this.next;
    }
    set nextSibling(next) {
        this.next = next;
    }
    /**
     * Clone this node, and optionally its children.
     *
     * @param recursive Clone child nodes as well.
     * @returns A clone of the node.
     */ cloneNode(recursive = false) {
        return $dcd3bfde7a749b6e$export$ae8e35ea29ddac22(this, recursive);
    }
}
class $dcd3bfde7a749b6e$export$c3569d91cd44d357 extends $dcd3bfde7a749b6e$export$85c928794f8d04d4 {
    /**
     * @param data The content of the data node
     */ constructor(data){
        super();
        this.data = data;
    }
    /**
     * Same as {@link data}.
     * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
     */ get nodeValue() {
        return this.data;
    }
    set nodeValue(data) {
        this.data = data;
    }
}
class $dcd3bfde7a749b6e$export$5f1af8db9871e1d6 extends $dcd3bfde7a749b6e$export$c3569d91cd44d357 {
    constructor(){
        super(...arguments);
        this.type = (0, $j8Fek.ElementType).Text;
    }
    get nodeType() {
        return 3;
    }
}
class $dcd3bfde7a749b6e$export$4d299b491347818a extends $dcd3bfde7a749b6e$export$c3569d91cd44d357 {
    constructor(){
        super(...arguments);
        this.type = (0, $j8Fek.ElementType).Comment;
    }
    get nodeType() {
        return 8;
    }
}
class $dcd3bfde7a749b6e$export$9269dce19ee35e96 extends $dcd3bfde7a749b6e$export$c3569d91cd44d357 {
    constructor(name, data){
        super(data);
        this.name = name;
        this.type = (0, $j8Fek.ElementType).Directive;
    }
    get nodeType() {
        return 1;
    }
}
class $dcd3bfde7a749b6e$export$62be934f90997196 extends $dcd3bfde7a749b6e$export$85c928794f8d04d4 {
    /**
     * @param children Children of the node. Only certain node types can have children.
     */ constructor(children){
        super();
        this.children = children;
    }
    // Aliases
    /** First child of the node. */ get firstChild() {
        var _a;
        return (_a = this.children[0]) !== null && _a !== void 0 ? _a : null;
    }
    /** Last child of the node. */ get lastChild() {
        return this.children.length > 0 ? this.children[this.children.length - 1] : null;
    }
    /**
     * Same as {@link children}.
     * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
     */ get childNodes() {
        return this.children;
    }
    set childNodes(children) {
        this.children = children;
    }
}
class $dcd3bfde7a749b6e$export$1f8b8f7e5c763232 extends $dcd3bfde7a749b6e$export$62be934f90997196 {
    constructor(){
        super(...arguments);
        this.type = (0, $j8Fek.ElementType).CDATA;
    }
    get nodeType() {
        return 4;
    }
}
class $dcd3bfde7a749b6e$export$b34a105447964f9f extends $dcd3bfde7a749b6e$export$62be934f90997196 {
    constructor(){
        super(...arguments);
        this.type = (0, $j8Fek.ElementType).Root;
    }
    get nodeType() {
        return 9;
    }
}
class $dcd3bfde7a749b6e$export$db77ccec0bb4ccac extends $dcd3bfde7a749b6e$export$62be934f90997196 {
    /**
     * @param name Name of the tag, eg. `div`, `span`.
     * @param attribs Object mapping attribute names to attribute values.
     * @param children Children of the node.
     */ constructor(name, attribs, children = [], type = name === "script" ? (0, $j8Fek.ElementType).Script : name === "style" ? (0, $j8Fek.ElementType).Style : (0, $j8Fek.ElementType).Tag){
        super(children);
        this.name = name;
        this.attribs = attribs;
        this.type = type;
    }
    get nodeType() {
        return 1;
    }
    // DOM Level 1 aliases
    /**
     * Same as {@link name}.
     * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
     */ get tagName() {
        return this.name;
    }
    set tagName(name) {
        this.name = name;
    }
    get attributes() {
        return Object.keys(this.attribs).map((name)=>{
            var _a, _b;
            return {
                name: name,
                value: this.attribs[name],
                namespace: (_a = this["x-attribsNamespace"]) === null || _a === void 0 ? void 0 : _a[name],
                prefix: (_b = this["x-attribsPrefix"]) === null || _b === void 0 ? void 0 : _b[name]
            };
        });
    }
}
function $dcd3bfde7a749b6e$export$3bf645f08efe3292(node) {
    return (0, $j8Fek.isTag)(node);
}
function $dcd3bfde7a749b6e$export$c2d65aed98d39b56(node) {
    return node.type === (0, $j8Fek.ElementType).CDATA;
}
function $dcd3bfde7a749b6e$export$1879817ac5c922b7(node) {
    return node.type === (0, $j8Fek.ElementType).Text;
}
function $dcd3bfde7a749b6e$export$3ab01370f5e64ac8(node) {
    return node.type === (0, $j8Fek.ElementType).Comment;
}
function $dcd3bfde7a749b6e$export$4b5d79f26e0e3ad5(node) {
    return node.type === (0, $j8Fek.ElementType).Directive;
}
function $dcd3bfde7a749b6e$export$62858bae88b53fd0(node) {
    return node.type === (0, $j8Fek.ElementType).Root;
}
function $dcd3bfde7a749b6e$export$bd5ff50f0e53d41c(node) {
    return Object.prototype.hasOwnProperty.call(node, "children");
}
function $dcd3bfde7a749b6e$export$ae8e35ea29ddac22(node, recursive = false) {
    let result;
    if ($dcd3bfde7a749b6e$export$1879817ac5c922b7(node)) result = new $dcd3bfde7a749b6e$export$5f1af8db9871e1d6(node.data);
    else if ($dcd3bfde7a749b6e$export$3ab01370f5e64ac8(node)) result = new $dcd3bfde7a749b6e$export$4d299b491347818a(node.data);
    else if ($dcd3bfde7a749b6e$export$3bf645f08efe3292(node)) {
        const children = recursive ? $dcd3bfde7a749b6e$var$cloneChildren(node.children) : [];
        const clone = new $dcd3bfde7a749b6e$export$db77ccec0bb4ccac(node.name, {
            ...node.attribs
        }, children);
        children.forEach((child)=>child.parent = clone);
        if (node.namespace != null) clone.namespace = node.namespace;
        if (node["x-attribsNamespace"]) clone["x-attribsNamespace"] = {
            ...node["x-attribsNamespace"]
        };
        if (node["x-attribsPrefix"]) clone["x-attribsPrefix"] = {
            ...node["x-attribsPrefix"]
        };
        result = clone;
    } else if ($dcd3bfde7a749b6e$export$c2d65aed98d39b56(node)) {
        const children = recursive ? $dcd3bfde7a749b6e$var$cloneChildren(node.children) : [];
        const clone = new $dcd3bfde7a749b6e$export$1f8b8f7e5c763232(children);
        children.forEach((child)=>child.parent = clone);
        result = clone;
    } else if ($dcd3bfde7a749b6e$export$62858bae88b53fd0(node)) {
        const children = recursive ? $dcd3bfde7a749b6e$var$cloneChildren(node.children) : [];
        const clone = new $dcd3bfde7a749b6e$export$b34a105447964f9f(children);
        children.forEach((child)=>child.parent = clone);
        if (node["x-mode"]) clone["x-mode"] = node["x-mode"];
        result = clone;
    } else if ($dcd3bfde7a749b6e$export$4b5d79f26e0e3ad5(node)) {
        const instruction = new $dcd3bfde7a749b6e$export$9269dce19ee35e96(node.name, node.data);
        if (node["x-name"] != null) {
            instruction["x-name"] = node["x-name"];
            instruction["x-publicId"] = node["x-publicId"];
            instruction["x-systemId"] = node["x-systemId"];
        }
        result = instruction;
    } else throw new Error(`Not implemented yet: ${node.type}`);
    result.startIndex = node.startIndex;
    result.endIndex = node.endIndex;
    if (node.sourceCodeLocation != null) result.sourceCodeLocation = node.sourceCodeLocation;
    return result;
}
function $dcd3bfde7a749b6e$var$cloneChildren(childs) {
    const children = childs.map((child)=>$dcd3bfde7a749b6e$export$ae8e35ea29ddac22(child, true));
    for(let i = 1; i < children.length; i++){
        children[i].prev = children[i - 1];
        children[i - 1].next = children[i];
    }
    return children;
}

});


parcelRequire.register("460hx", function(module, exports) {
$parcel$export(module.exports, "getFeed", () => (parcelRequire("4qtZj")).getFeed);
parcelRequire("7LDPY");
parcelRequire("02PlG");
parcelRequire("eI5pT");
parcelRequire("ksADb");
parcelRequire("21oBJ");
parcelRequire("glLv3");
parcelRequire("4qtZj");
parcelRequire("CnBXM");
var $iXsnt = parcelRequire("iXsnt");

});
parcelRequire.register("7LDPY", function(module, exports) {

$parcel$export(module.exports, "textContent", () => $5a7bd30c0a4fc9d9$export$e0e0794250e9118f);
parcelRequire("CnBXM");
var $iXsnt = parcelRequire("iXsnt");

var $hU3ZE = parcelRequire("hU3ZE");

var $j8Fek = parcelRequire("j8Fek");
function $5a7bd30c0a4fc9d9$export$39484b727cc2f324(node, options) {
    return (0, $hU3ZE.default)(node, options);
}
function $5a7bd30c0a4fc9d9$export$7ed15b4d2218408(node, options) {
    return (0, $iXsnt.hasChildren)(node) ? node.children.map((node)=>$5a7bd30c0a4fc9d9$export$39484b727cc2f324(node, options)).join("") : "";
}
function $5a7bd30c0a4fc9d9$export$c72d34660a162238(node) {
    if (Array.isArray(node)) return node.map($5a7bd30c0a4fc9d9$export$c72d34660a162238).join("");
    if ((0, $iXsnt.isTag)(node)) return node.name === "br" ? "\n" : $5a7bd30c0a4fc9d9$export$c72d34660a162238(node.children);
    if ((0, $iXsnt.isCDATA)(node)) return $5a7bd30c0a4fc9d9$export$c72d34660a162238(node.children);
    if ((0, $iXsnt.isText)(node)) return node.data;
    return "";
}
function $5a7bd30c0a4fc9d9$export$e0e0794250e9118f(node) {
    if (Array.isArray(node)) return node.map($5a7bd30c0a4fc9d9$export$e0e0794250e9118f).join("");
    if ((0, $iXsnt.hasChildren)(node) && !(0, $iXsnt.isComment)(node)) return $5a7bd30c0a4fc9d9$export$e0e0794250e9118f(node.children);
    if ((0, $iXsnt.isText)(node)) return node.data;
    return "";
}
function $5a7bd30c0a4fc9d9$export$5864bc2a45f1eb81(node) {
    if (Array.isArray(node)) return node.map($5a7bd30c0a4fc9d9$export$5864bc2a45f1eb81).join("");
    if ((0, $iXsnt.hasChildren)(node) && (node.type === (0, $j8Fek.ElementType).Tag || (0, $iXsnt.isCDATA)(node))) return $5a7bd30c0a4fc9d9$export$5864bc2a45f1eb81(node.children);
    if ((0, $iXsnt.isText)(node)) return node.data;
    return "";
}

});
parcelRequire.register("hU3ZE", function(module, exports) {

$parcel$export(module.exports, "default", () => $d08ac3a2f3952b7f$export$2e2bcd8739ae039);
/*
 * Module dependencies
 */ 
var $j8Fek = parcelRequire("j8Fek");
parcelRequire("deXwU");
var $iwskN = parcelRequire("iwskN");

var $294rS = parcelRequire("294rS");
const $d08ac3a2f3952b7f$var$unencodedElements = new Set([
    "style",
    "script",
    "xmp",
    "iframe",
    "noembed",
    "noframes",
    "plaintext",
    "noscript"
]);
function $d08ac3a2f3952b7f$var$replaceQuotes(value) {
    return value.replace(/"/g, "&quot;");
}
/**
 * Format attributes
 */ function $d08ac3a2f3952b7f$var$formatAttributes(attributes, opts) {
    var _a;
    if (!attributes) return;
    const encode = ((_a = opts.encodeEntities) !== null && _a !== void 0 ? _a : opts.decodeEntities) === false ? $d08ac3a2f3952b7f$var$replaceQuotes : opts.xmlMode || opts.encodeEntities !== "utf8" ? (0, $iwskN.encodeXML) : (0, $iwskN.escapeAttribute);
    return Object.keys(attributes).map((key)=>{
        var _a, _b;
        const value = (_a = attributes[key]) !== null && _a !== void 0 ? _a : "";
        if (opts.xmlMode === "foreign") /* Fix up mixed-case attribute names */ key = (_b = (0, $294rS.attributeNames).get(key)) !== null && _b !== void 0 ? _b : key;
        if (!opts.emptyAttrs && !opts.xmlMode && value === "") return key;
        return `${key}="${encode(value)}"`;
    }).join(" ");
}
/**
 * Self-enclosing tags
 */ const $d08ac3a2f3952b7f$var$singleTag = new Set([
    "area",
    "base",
    "basefont",
    "br",
    "col",
    "command",
    "embed",
    "frame",
    "hr",
    "img",
    "input",
    "isindex",
    "keygen",
    "link",
    "meta",
    "param",
    "source",
    "track",
    "wbr"
]);
function $d08ac3a2f3952b7f$export$b3890eb0ae9dca99(node, options = {}) {
    const nodes = "length" in node ? node : [
        node
    ];
    let output = "";
    for(let i = 0; i < nodes.length; i++)output += $d08ac3a2f3952b7f$var$renderNode(nodes[i], options);
    return output;
}
var $d08ac3a2f3952b7f$export$2e2bcd8739ae039 = $d08ac3a2f3952b7f$export$b3890eb0ae9dca99;
function $d08ac3a2f3952b7f$var$renderNode(node, options) {
    switch(node.type){
        case $j8Fek.Root:
            return $d08ac3a2f3952b7f$export$b3890eb0ae9dca99(node.children, options);
        // @ts-expect-error We don't use `Doctype` yet
        case $j8Fek.Doctype:
        case $j8Fek.Directive:
            return $d08ac3a2f3952b7f$var$renderDirective(node);
        case $j8Fek.Comment:
            return $d08ac3a2f3952b7f$var$renderComment(node);
        case $j8Fek.CDATA:
            return $d08ac3a2f3952b7f$var$renderCdata(node);
        case $j8Fek.Script:
        case $j8Fek.Style:
        case $j8Fek.Tag:
            return $d08ac3a2f3952b7f$var$renderTag(node, options);
        case $j8Fek.Text:
            return $d08ac3a2f3952b7f$var$renderText(node, options);
    }
}
const $d08ac3a2f3952b7f$var$foreignModeIntegrationPoints = new Set([
    "mi",
    "mo",
    "mn",
    "ms",
    "mtext",
    "annotation-xml",
    "foreignObject",
    "desc",
    "title"
]);
const $d08ac3a2f3952b7f$var$foreignElements = new Set([
    "svg",
    "math"
]);
function $d08ac3a2f3952b7f$var$renderTag(elem, opts) {
    var _a;
    // Handle SVG / MathML in HTML
    if (opts.xmlMode === "foreign") {
        /* Fix up mixed-case element names */ elem.name = (_a = (0, $294rS.elementNames).get(elem.name)) !== null && _a !== void 0 ? _a : elem.name;
        /* Exit foreign mode at integration points */ if (elem.parent && $d08ac3a2f3952b7f$var$foreignModeIntegrationPoints.has(elem.parent.name)) opts = {
            ...opts,
            xmlMode: false
        };
    }
    if (!opts.xmlMode && $d08ac3a2f3952b7f$var$foreignElements.has(elem.name)) opts = {
        ...opts,
        xmlMode: "foreign"
    };
    let tag = `<${elem.name}`;
    const attribs = $d08ac3a2f3952b7f$var$formatAttributes(elem.attribs, opts);
    if (attribs) tag += ` ${attribs}`;
    if (elem.children.length === 0 && (opts.xmlMode ? opts.selfClosingTags !== false : opts.selfClosingTags && $d08ac3a2f3952b7f$var$singleTag.has(elem.name))) {
        if (!opts.xmlMode) tag += " ";
        tag += "/>";
    } else {
        tag += ">";
        if (elem.children.length > 0) tag += $d08ac3a2f3952b7f$export$b3890eb0ae9dca99(elem.children, opts);
        if (opts.xmlMode || !$d08ac3a2f3952b7f$var$singleTag.has(elem.name)) tag += `</${elem.name}>`;
    }
    return tag;
}
function $d08ac3a2f3952b7f$var$renderDirective(elem) {
    return `<${elem.data}>`;
}
function $d08ac3a2f3952b7f$var$renderText(elem, opts) {
    var _a;
    let data = elem.data || "";
    // If entities weren't decoded, no need to encode them back
    if (((_a = opts.encodeEntities) !== null && _a !== void 0 ? _a : opts.decodeEntities) !== false && !(!opts.xmlMode && elem.parent && $d08ac3a2f3952b7f$var$unencodedElements.has(elem.parent.name))) data = opts.xmlMode || opts.encodeEntities !== "utf8" ? (0, $iwskN.encodeXML)(data) : (0, $iwskN.escapeText)(data);
    return data;
}
function $d08ac3a2f3952b7f$var$renderCdata(elem) {
    return `<![CDATA[${elem.children[0].data}]]>`;
}
function $d08ac3a2f3952b7f$var$renderComment(elem) {
    return `<!--${elem.data}-->`;
}

});
parcelRequire.register("deXwU", function(module, exports) {

$parcel$export(module.exports, "encodeXML", () => (parcelRequire("iwskN")).encodeXML);
$parcel$export(module.exports, "escapeAttribute", () => (parcelRequire("iwskN")).escapeAttribute);
$parcel$export(module.exports, "escapeText", () => (parcelRequire("iwskN")).escapeText);

var $4y7VY = parcelRequire("4y7VY");

var $5Mfgh = parcelRequire("5Mfgh");

var $iwskN = parcelRequire("iwskN");
var $9a3ac28de14f80f3$export$b8c86583d9718b50;
(function(EntityLevel) {
    /** Support only XML entities. */ EntityLevel[EntityLevel["XML"] = 0] = "XML";
    /** Support HTML entities, which are a superset of XML entities. */ EntityLevel[EntityLevel["HTML"] = 1] = "HTML";
})($9a3ac28de14f80f3$export$b8c86583d9718b50 || ($9a3ac28de14f80f3$export$b8c86583d9718b50 = {}));
var $9a3ac28de14f80f3$export$1851b20d614eb756;
(function(EncodingMode) {
    /**
     * The output is UTF-8 encoded. Only characters that need escaping within
     * XML will be escaped.
     */ EncodingMode[EncodingMode["UTF8"] = 0] = "UTF8";
    /**
     * The output consists only of ASCII characters. Characters that need
     * escaping within HTML, and characters that aren't ASCII characters will
     * be escaped.
     */ EncodingMode[EncodingMode["ASCII"] = 1] = "ASCII";
    /**
     * Encode all characters that have an equivalent entity, as well as all
     * characters that are not ASCII characters.
     */ EncodingMode[EncodingMode["Extensive"] = 2] = "Extensive";
    /**
     * Encode all characters that have to be escaped in HTML attributes,
     * following {@link https://html.spec.whatwg.org/multipage/parsing.html#escapingString}.
     */ EncodingMode[EncodingMode["Attribute"] = 3] = "Attribute";
    /**
     * Encode all characters that have to be escaped in HTML text,
     * following {@link https://html.spec.whatwg.org/multipage/parsing.html#escapingString}.
     */ EncodingMode[EncodingMode["Text"] = 4] = "Text";
})($9a3ac28de14f80f3$export$1851b20d614eb756 || ($9a3ac28de14f80f3$export$1851b20d614eb756 = {}));
function $9a3ac28de14f80f3$export$2f872c0f2117be69(data, options = $9a3ac28de14f80f3$export$b8c86583d9718b50.XML) {
    const level = typeof options === "number" ? options : options.level;
    if (level === $9a3ac28de14f80f3$export$b8c86583d9718b50.HTML) {
        const mode = typeof options === "object" ? options.mode : undefined;
        return (0, $4y7VY.decodeHTML)(data, mode);
    }
    return (0, $4y7VY.decodeXML)(data);
}
function $9a3ac28de14f80f3$export$c94669f4c7d36be4(data, options = $9a3ac28de14f80f3$export$b8c86583d9718b50.XML) {
    var _a;
    const opts = typeof options === "number" ? {
        level: options
    } : options;
    (_a = opts.mode) !== null && _a !== void 0 ? _a : opts.mode = (0, $4y7VY.DecodingMode).Strict;
    return $9a3ac28de14f80f3$export$2f872c0f2117be69(data, opts);
}
function $9a3ac28de14f80f3$export$c564cdbbe6da493(data, options = $9a3ac28de14f80f3$export$b8c86583d9718b50.XML) {
    const opts = typeof options === "number" ? {
        level: options
    } : options;
    // Mode `UTF8` just escapes XML entities
    if (opts.mode === $9a3ac28de14f80f3$export$1851b20d614eb756.UTF8) return (0, $iwskN.escapeUTF8)(data);
    if (opts.mode === $9a3ac28de14f80f3$export$1851b20d614eb756.Attribute) return (0, $iwskN.escapeAttribute)(data);
    if (opts.mode === $9a3ac28de14f80f3$export$1851b20d614eb756.Text) return (0, $iwskN.escapeText)(data);
    if (opts.level === $9a3ac28de14f80f3$export$b8c86583d9718b50.HTML) {
        if (opts.mode === $9a3ac28de14f80f3$export$1851b20d614eb756.ASCII) return (0, $5Mfgh.encodeNonAsciiHTML)(data);
        return (0, $5Mfgh.encodeHTML)(data);
    }
    // ASCII and Extensive are equivalent
    return (0, $iwskN.encodeXML)(data);
}

});
parcelRequire.register("4y7VY", function(module, exports) {

$parcel$export(module.exports, "DecodingMode", () => $35007deb2069835f$export$8c8f129ce60f53c);
$parcel$export(module.exports, "decodeHTML", () => $35007deb2069835f$export$f045cb747ce77a19);
$parcel$export(module.exports, "decodeXML", () => $35007deb2069835f$export$88e3b9643a8bd06e);

var $elljx = parcelRequire("elljx");

var $9zLKC = parcelRequire("9zLKC");

var $9gkGz = parcelRequire("9gkGz");
var $35007deb2069835f$var$CharCodes;
(function(CharCodes) {
    CharCodes[CharCodes["NUM"] = 35] = "NUM";
    CharCodes[CharCodes["SEMI"] = 59] = "SEMI";
    CharCodes[CharCodes["EQUALS"] = 61] = "EQUALS";
    CharCodes[CharCodes["ZERO"] = 48] = "ZERO";
    CharCodes[CharCodes["NINE"] = 57] = "NINE";
    CharCodes[CharCodes["LOWER_A"] = 97] = "LOWER_A";
    CharCodes[CharCodes["LOWER_F"] = 102] = "LOWER_F";
    CharCodes[CharCodes["LOWER_X"] = 120] = "LOWER_X";
    CharCodes[CharCodes["LOWER_Z"] = 122] = "LOWER_Z";
    CharCodes[CharCodes["UPPER_A"] = 65] = "UPPER_A";
    CharCodes[CharCodes["UPPER_F"] = 70] = "UPPER_F";
    CharCodes[CharCodes["UPPER_Z"] = 90] = "UPPER_Z";
})($35007deb2069835f$var$CharCodes || ($35007deb2069835f$var$CharCodes = {}));
/** Bit that needs to be set to convert an upper case ASCII character to lower case */ const $35007deb2069835f$var$TO_LOWER_BIT = 32;
var $35007deb2069835f$export$6a4325c613e0faec;
(function(BinTrieFlags) {
    BinTrieFlags[BinTrieFlags["VALUE_LENGTH"] = 49152] = "VALUE_LENGTH";
    BinTrieFlags[BinTrieFlags["BRANCH_LENGTH"] = 16256] = "BRANCH_LENGTH";
    BinTrieFlags[BinTrieFlags["JUMP_TABLE"] = 127] = "JUMP_TABLE";
})($35007deb2069835f$export$6a4325c613e0faec || ($35007deb2069835f$export$6a4325c613e0faec = {}));
function $35007deb2069835f$var$isNumber(code) {
    return code >= $35007deb2069835f$var$CharCodes.ZERO && code <= $35007deb2069835f$var$CharCodes.NINE;
}
function $35007deb2069835f$var$isHexadecimalCharacter(code) {
    return code >= $35007deb2069835f$var$CharCodes.UPPER_A && code <= $35007deb2069835f$var$CharCodes.UPPER_F || code >= $35007deb2069835f$var$CharCodes.LOWER_A && code <= $35007deb2069835f$var$CharCodes.LOWER_F;
}
function $35007deb2069835f$var$isAsciiAlphaNumeric(code) {
    return code >= $35007deb2069835f$var$CharCodes.UPPER_A && code <= $35007deb2069835f$var$CharCodes.UPPER_Z || code >= $35007deb2069835f$var$CharCodes.LOWER_A && code <= $35007deb2069835f$var$CharCodes.LOWER_Z || $35007deb2069835f$var$isNumber(code);
}
/**
 * Checks if the given character is a valid end character for an entity in an attribute.
 *
 * Attribute values that aren't terminated properly aren't parsed, and shouldn't lead to a parser error.
 * See the example in https://html.spec.whatwg.org/multipage/parsing.html#named-character-reference-state
 */ function $35007deb2069835f$var$isEntityInAttributeInvalidEnd(code) {
    return code === $35007deb2069835f$var$CharCodes.EQUALS || $35007deb2069835f$var$isAsciiAlphaNumeric(code);
}
var $35007deb2069835f$var$EntityDecoderState;
(function(EntityDecoderState) {
    EntityDecoderState[EntityDecoderState["EntityStart"] = 0] = "EntityStart";
    EntityDecoderState[EntityDecoderState["NumericStart"] = 1] = "NumericStart";
    EntityDecoderState[EntityDecoderState["NumericDecimal"] = 2] = "NumericDecimal";
    EntityDecoderState[EntityDecoderState["NumericHex"] = 3] = "NumericHex";
    EntityDecoderState[EntityDecoderState["NamedEntity"] = 4] = "NamedEntity";
})($35007deb2069835f$var$EntityDecoderState || ($35007deb2069835f$var$EntityDecoderState = {}));
var $35007deb2069835f$export$8c8f129ce60f53c;
(function(DecodingMode) {
    /** Entities in text nodes that can end with any character. */ DecodingMode[DecodingMode["Legacy"] = 0] = "Legacy";
    /** Only allow entities terminated with a semicolon. */ DecodingMode[DecodingMode["Strict"] = 1] = "Strict";
    /** Entities in attributes have limitations on ending characters. */ DecodingMode[DecodingMode["Attribute"] = 2] = "Attribute";
})($35007deb2069835f$export$8c8f129ce60f53c || ($35007deb2069835f$export$8c8f129ce60f53c = {}));
class $35007deb2069835f$export$15263a93ff7ec8ba {
    constructor(/** The tree used to decode entities. */ decodeTree, /**
     * The function that is called when a codepoint is decoded.
     *
     * For multi-byte named entities, this will be called multiple times,
     * with the second codepoint, and the same `consumed` value.
     *
     * @param codepoint The decoded codepoint.
     * @param consumed The number of bytes consumed by the decoder.
     */ emitCodePoint, /** An object that is used to produce errors. */ errors){
        this.decodeTree = decodeTree;
        this.emitCodePoint = emitCodePoint;
        this.errors = errors;
        /** The current state of the decoder. */ this.state = $35007deb2069835f$var$EntityDecoderState.EntityStart;
        /** Characters that were consumed while parsing an entity. */ this.consumed = 1;
        /**
         * The result of the entity.
         *
         * Either the result index of a numeric entity, or the codepoint of a
         * numeric entity.
         */ this.result = 0;
        /** The current index in the decode tree. */ this.treeIndex = 0;
        /** The number of characters that were consumed in excess. */ this.excess = 1;
        /** The mode in which the decoder is operating. */ this.decodeMode = $35007deb2069835f$export$8c8f129ce60f53c.Strict;
    }
    /** Resets the instance to make it reusable. */ startEntity(decodeMode) {
        this.decodeMode = decodeMode;
        this.state = $35007deb2069835f$var$EntityDecoderState.EntityStart;
        this.result = 0;
        this.treeIndex = 0;
        this.excess = 1;
        this.consumed = 1;
    }
    /**
     * Write an entity to the decoder. This can be called multiple times with partial entities.
     * If the entity is incomplete, the decoder will return -1.
     *
     * Mirrors the implementation of `getDecoder`, but with the ability to stop decoding if the
     * entity is incomplete, and resume when the next string is written.
     *
     * @param string The string containing the entity (or a continuation of the entity).
     * @param offset The offset at which the entity begins. Should be 0 if this is not the first call.
     * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
     */ write(str, offset) {
        switch(this.state){
            case $35007deb2069835f$var$EntityDecoderState.EntityStart:
                if (str.charCodeAt(offset) === $35007deb2069835f$var$CharCodes.NUM) {
                    this.state = $35007deb2069835f$var$EntityDecoderState.NumericStart;
                    this.consumed += 1;
                    return this.stateNumericStart(str, offset + 1);
                }
                this.state = $35007deb2069835f$var$EntityDecoderState.NamedEntity;
                return this.stateNamedEntity(str, offset);
            case $35007deb2069835f$var$EntityDecoderState.NumericStart:
                return this.stateNumericStart(str, offset);
            case $35007deb2069835f$var$EntityDecoderState.NumericDecimal:
                return this.stateNumericDecimal(str, offset);
            case $35007deb2069835f$var$EntityDecoderState.NumericHex:
                return this.stateNumericHex(str, offset);
            case $35007deb2069835f$var$EntityDecoderState.NamedEntity:
                return this.stateNamedEntity(str, offset);
        }
    }
    /**
     * Switches between the numeric decimal and hexadecimal states.
     *
     * Equivalent to the `Numeric character reference state` in the HTML spec.
     *
     * @param str The string containing the entity (or a continuation of the entity).
     * @param offset The current offset.
     * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
     */ stateNumericStart(str, offset) {
        if (offset >= str.length) return -1;
        if ((str.charCodeAt(offset) | $35007deb2069835f$var$TO_LOWER_BIT) === $35007deb2069835f$var$CharCodes.LOWER_X) {
            this.state = $35007deb2069835f$var$EntityDecoderState.NumericHex;
            this.consumed += 1;
            return this.stateNumericHex(str, offset + 1);
        }
        this.state = $35007deb2069835f$var$EntityDecoderState.NumericDecimal;
        return this.stateNumericDecimal(str, offset);
    }
    addToNumericResult(str, start, end, base) {
        if (start !== end) {
            const digitCount = end - start;
            this.result = this.result * Math.pow(base, digitCount) + parseInt(str.substr(start, digitCount), base);
            this.consumed += digitCount;
        }
    }
    /**
     * Parses a hexadecimal numeric entity.
     *
     * Equivalent to the `Hexademical character reference state` in the HTML spec.
     *
     * @param str The string containing the entity (or a continuation of the entity).
     * @param offset The current offset.
     * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
     */ stateNumericHex(str, offset) {
        const startIdx = offset;
        while(offset < str.length){
            const char = str.charCodeAt(offset);
            if ($35007deb2069835f$var$isNumber(char) || $35007deb2069835f$var$isHexadecimalCharacter(char)) offset += 1;
            else {
                this.addToNumericResult(str, startIdx, offset, 16);
                return this.emitNumericEntity(char, 3);
            }
        }
        this.addToNumericResult(str, startIdx, offset, 16);
        return -1;
    }
    /**
     * Parses a decimal numeric entity.
     *
     * Equivalent to the `Decimal character reference state` in the HTML spec.
     *
     * @param str The string containing the entity (or a continuation of the entity).
     * @param offset The current offset.
     * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
     */ stateNumericDecimal(str, offset) {
        const startIdx = offset;
        while(offset < str.length){
            const char = str.charCodeAt(offset);
            if ($35007deb2069835f$var$isNumber(char)) offset += 1;
            else {
                this.addToNumericResult(str, startIdx, offset, 10);
                return this.emitNumericEntity(char, 2);
            }
        }
        this.addToNumericResult(str, startIdx, offset, 10);
        return -1;
    }
    /**
     * Validate and emit a numeric entity.
     *
     * Implements the logic from the `Hexademical character reference start
     * state` and `Numeric character reference end state` in the HTML spec.
     *
     * @param lastCp The last code point of the entity. Used to see if the
     *               entity was terminated with a semicolon.
     * @param expectedLength The minimum number of characters that should be
     *                       consumed. Used to validate that at least one digit
     *                       was consumed.
     * @returns The number of characters that were consumed.
     */ emitNumericEntity(lastCp, expectedLength) {
        var _a;
        // Ensure we consumed at least one digit.
        if (this.consumed <= expectedLength) {
            (_a = this.errors) === null || _a === void 0 || _a.absenceOfDigitsInNumericCharacterReference(this.consumed);
            return 0;
        }
        // Figure out if this is a legit end of the entity
        if (lastCp === $35007deb2069835f$var$CharCodes.SEMI) this.consumed += 1;
        else if (this.decodeMode === $35007deb2069835f$export$8c8f129ce60f53c.Strict) return 0;
        this.emitCodePoint((0, $9gkGz.replaceCodePoint)(this.result), this.consumed);
        if (this.errors) {
            if (lastCp !== $35007deb2069835f$var$CharCodes.SEMI) this.errors.missingSemicolonAfterCharacterReference();
            this.errors.validateNumericCharacterReference(this.result);
        }
        return this.consumed;
    }
    /**
     * Parses a named entity.
     *
     * Equivalent to the `Named character reference state` in the HTML spec.
     *
     * @param str The string containing the entity (or a continuation of the entity).
     * @param offset The current offset.
     * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
     */ stateNamedEntity(str, offset) {
        const { decodeTree: decodeTree } = this;
        let current = decodeTree[this.treeIndex];
        // The mask is the number of bytes of the value, including the current byte.
        let valueLength = (current & $35007deb2069835f$export$6a4325c613e0faec.VALUE_LENGTH) >> 14;
        for(; offset < str.length; offset++, this.excess++){
            const char = str.charCodeAt(offset);
            this.treeIndex = $35007deb2069835f$export$44c08d99945e6276(decodeTree, current, this.treeIndex + Math.max(1, valueLength), char);
            if (this.treeIndex < 0) return this.result === 0 || // If we are parsing an attribute
            this.decodeMode === $35007deb2069835f$export$8c8f129ce60f53c.Attribute && // We shouldn't have consumed any characters after the entity,
            (valueLength === 0 || // And there should be no invalid characters.
            $35007deb2069835f$var$isEntityInAttributeInvalidEnd(char)) ? 0 : this.emitNotTerminatedNamedEntity();
            current = decodeTree[this.treeIndex];
            valueLength = (current & $35007deb2069835f$export$6a4325c613e0faec.VALUE_LENGTH) >> 14;
            // If the branch is a value, store it and continue
            if (valueLength !== 0) {
                // If the entity is terminated by a semicolon, we are done.
                if (char === $35007deb2069835f$var$CharCodes.SEMI) return this.emitNamedEntityData(this.treeIndex, valueLength, this.consumed + this.excess);
                // If we encounter a non-terminated (legacy) entity while parsing strictly, then ignore it.
                if (this.decodeMode !== $35007deb2069835f$export$8c8f129ce60f53c.Strict) {
                    this.result = this.treeIndex;
                    this.consumed += this.excess;
                    this.excess = 0;
                }
            }
        }
        return -1;
    }
    /**
     * Emit a named entity that was not terminated with a semicolon.
     *
     * @returns The number of characters consumed.
     */ emitNotTerminatedNamedEntity() {
        var _a;
        const { result: result, decodeTree: decodeTree } = this;
        const valueLength = (decodeTree[result] & $35007deb2069835f$export$6a4325c613e0faec.VALUE_LENGTH) >> 14;
        this.emitNamedEntityData(result, valueLength, this.consumed);
        (_a = this.errors) === null || _a === void 0 || _a.missingSemicolonAfterCharacterReference();
        return this.consumed;
    }
    /**
     * Emit a named entity.
     *
     * @param result The index of the entity in the decode tree.
     * @param valueLength The number of bytes in the entity.
     * @param consumed The number of characters consumed.
     *
     * @returns The number of characters consumed.
     */ emitNamedEntityData(result, valueLength, consumed) {
        const { decodeTree: decodeTree } = this;
        this.emitCodePoint(valueLength === 1 ? decodeTree[result] & ~$35007deb2069835f$export$6a4325c613e0faec.VALUE_LENGTH : decodeTree[result + 1], consumed);
        if (valueLength === 3) // For multi-byte values, we need to emit the second byte.
        this.emitCodePoint(decodeTree[result + 2], consumed);
        return consumed;
    }
    /**
     * Signal to the parser that the end of the input was reached.
     *
     * Remaining data will be emitted and relevant errors will be produced.
     *
     * @returns The number of characters consumed.
     */ end() {
        var _a;
        switch(this.state){
            case $35007deb2069835f$var$EntityDecoderState.NamedEntity:
                // Emit a named entity if we have one.
                return this.result !== 0 && (this.decodeMode !== $35007deb2069835f$export$8c8f129ce60f53c.Attribute || this.result === this.treeIndex) ? this.emitNotTerminatedNamedEntity() : 0;
            // Otherwise, emit a numeric entity if we have one.
            case $35007deb2069835f$var$EntityDecoderState.NumericDecimal:
                return this.emitNumericEntity(0, 2);
            case $35007deb2069835f$var$EntityDecoderState.NumericHex:
                return this.emitNumericEntity(0, 3);
            case $35007deb2069835f$var$EntityDecoderState.NumericStart:
                (_a = this.errors) === null || _a === void 0 || _a.absenceOfDigitsInNumericCharacterReference(this.consumed);
                return 0;
            case $35007deb2069835f$var$EntityDecoderState.EntityStart:
                // Return 0 if we have no entity.
                return 0;
        }
    }
}
/**
 * Creates a function that decodes entities in a string.
 *
 * @param decodeTree The decode tree.
 * @returns A function that decodes entities in a string.
 */ function $35007deb2069835f$var$getDecoder(decodeTree) {
    let ret = "";
    const decoder = new $35007deb2069835f$export$15263a93ff7ec8ba(decodeTree, (str)=>ret += (0, $9gkGz.fromCodePoint)(str));
    return function decodeWithTrie(str, decodeMode) {
        let lastIndex = 0;
        let offset = 0;
        while((offset = str.indexOf("&", offset)) >= 0){
            ret += str.slice(lastIndex, offset);
            decoder.startEntity(decodeMode);
            const len = decoder.write(str, // Skip the "&"
            offset + 1);
            if (len < 0) {
                lastIndex = offset + decoder.end();
                break;
            }
            lastIndex = offset + len;
            // If `len` is 0, skip the current `&` and continue.
            offset = len === 0 ? lastIndex + 1 : lastIndex;
        }
        const result = ret + str.slice(lastIndex);
        // Make sure we don't keep a reference to the final string.
        ret = "";
        return result;
    };
}
function $35007deb2069835f$export$44c08d99945e6276(decodeTree, current, nodeIdx, char) {
    const branchCount = (current & $35007deb2069835f$export$6a4325c613e0faec.BRANCH_LENGTH) >> 7;
    const jumpOffset = current & $35007deb2069835f$export$6a4325c613e0faec.JUMP_TABLE;
    // Case 1: Single branch encoded in jump offset
    if (branchCount === 0) return jumpOffset !== 0 && char === jumpOffset ? nodeIdx : -1;
    // Case 2: Multiple branches encoded in jump table
    if (jumpOffset) {
        const value = char - jumpOffset;
        return value < 0 || value >= branchCount ? -1 : decodeTree[nodeIdx + value] - 1;
    }
    // Case 3: Multiple branches encoded in dictionary
    // Binary search for the character.
    let lo = nodeIdx;
    let hi = lo + branchCount - 1;
    while(lo <= hi){
        const mid = lo + hi >>> 1;
        const midVal = decodeTree[mid];
        if (midVal < char) lo = mid + 1;
        else if (midVal > char) hi = mid - 1;
        else return decodeTree[mid + branchCount];
    }
    return -1;
}
const $35007deb2069835f$var$htmlDecoder = $35007deb2069835f$var$getDecoder((0, $elljx.default));
const $35007deb2069835f$var$xmlDecoder = $35007deb2069835f$var$getDecoder((0, $9zLKC.default));
function $35007deb2069835f$export$f045cb747ce77a19(str, mode = $35007deb2069835f$export$8c8f129ce60f53c.Legacy) {
    return $35007deb2069835f$var$htmlDecoder(str, mode);
}
function $35007deb2069835f$export$49f5e8089adb006a(str) {
    return $35007deb2069835f$var$htmlDecoder(str, $35007deb2069835f$export$8c8f129ce60f53c.Attribute);
}
function $35007deb2069835f$export$da52f4371b3f37de(str) {
    return $35007deb2069835f$var$htmlDecoder(str, $35007deb2069835f$export$8c8f129ce60f53c.Strict);
}
function $35007deb2069835f$export$88e3b9643a8bd06e(str) {
    return $35007deb2069835f$var$xmlDecoder(str, $35007deb2069835f$export$8c8f129ce60f53c.Strict);
}

});
parcelRequire.register("elljx", function(module, exports) {

$parcel$export(module.exports, "default", () => $a7138f6c2845df8a$export$2e2bcd8739ae039);
// Generated using scripts/write-decode-map.ts
var $a7138f6c2845df8a$export$2e2bcd8739ae039 = new Uint16Array(// prettier-ignore
'ᵁ<\xd5ıʊҝջאٵ۞ޢߖࠏ੊ઑඡ๭༉༦჊ረዡᐕᒝᓃᓟᔥ\x00\x00\x00\x00\x00\x00ᕫᛍᦍᰒᷝ὾⁠↰⊍⏀⏻⑂⠤⤒ⴈ⹈⿎〖㊺㘹㞬㣾㨨㩱㫠㬮ࠀEMabcfglmnoprstu\\bfms\x7f\x84\x8b\x90\x95\x98\xa6\xb3\xb9\xc8\xcflig耻\xc6䃆P耻&䀦cute耻\xc1䃁reve;䄂Āiyx}rc耻\xc2䃂;䐐r;쀀\ud835\udd04rave耻\xc0䃀pha;䎑acr;䄀d;橓Āgp\x9d\xa1on;䄄f;쀀\ud835\udd38plyFunction;恡ing耻\xc5䃅Ācs\xbe\xc3r;쀀\ud835\udc9cign;扔ilde耻\xc3䃃ml耻\xc4䃄Ѐaceforsu\xe5\xfb\xfeėĜĢħĪĀcr\xea\xf2kslash;或Ŷ\xf6\xf8;櫧ed;挆y;䐑ƀcrtąċĔause;戵noullis;愬a;䎒r;쀀\ud835\udd05pf;쀀\ud835\udd39eve;䋘c\xf2ēmpeq;扎܀HOacdefhilorsuōőŖƀƞƢƵƷƺǜȕɳɸɾcy;䐧PY耻\xa9䂩ƀcpyŝŢźute;䄆Ā;iŧŨ拒talDifferentialD;慅leys;愭ȀaeioƉƎƔƘron;䄌dil耻\xc7䃇rc;䄈nint;戰ot;䄊ĀdnƧƭilla;䂸terDot;䂷\xf2ſi;䎧rcleȀDMPTǇǋǑǖot;抙inus;抖lus;投imes;抗oĀcsǢǸkwiseContourIntegral;戲eCurlyĀDQȃȏoubleQuote;思uote;怙ȀlnpuȞȨɇɕonĀ;eȥȦ户;橴ƀgitȯȶȺruent;扡nt;戯ourIntegral;戮ĀfrɌɎ;愂oduct;成nterClockwiseContourIntegral;戳oss;樯cr;쀀\ud835\udc9epĀ;Cʄʅ拓ap;才րDJSZacefiosʠʬʰʴʸˋ˗ˡ˦̳ҍĀ;oŹʥtrahd;椑cy;䐂cy;䐅cy;䐏ƀgrsʿ˄ˇger;怡r;憡hv;櫤Āayː˕ron;䄎;䐔lĀ;t˝˞戇a;䎔r;쀀\ud835\udd07Āaf˫̧Ācm˰̢riticalȀADGT̖̜̀̆cute;䂴oŴ̋̍;䋙bleAcute;䋝rave;䁠ilde;䋜ond;拄ferentialD;慆Ѱ̽\x00\x00\x00͔͂\x00Ѕf;쀀\ud835\udd3bƀ;DE͈͉͍䂨ot;惜qual;扐blèCDLRUVͣͲ΂ϏϢϸontourIntegra\xecȹoɴ͹\x00\x00ͻ\xbb͉nArrow;懓Āeo·ΤftƀARTΐΖΡrrow;懐ightArrow;懔e\xe5ˊngĀLRΫτeftĀARγιrrow;柸ightArrow;柺ightArrow;柹ightĀATϘϞrrow;懒ee;抨pɁϩ\x00\x00ϯrrow;懑ownArrow;懕erticalBar;戥ǹABLRTaВЪаўѿͼrrowƀ;BUНОТ憓ar;椓pArrow;懵reve;䌑eft˒к\x00ц\x00ѐightVector;楐eeVector;楞ectorĀ;Bљњ憽ar;楖ightǔѧ\x00ѱeeVector;楟ectorĀ;BѺѻ懁ar;楗eeĀ;A҆҇护rrow;憧ĀctҒҗr;쀀\ud835\udc9frok;䄐ࠀNTacdfglmopqstuxҽӀӄӋӞӢӧӮӵԡԯԶՒ՝ՠեG;䅊H耻\xd0䃐cute耻\xc9䃉ƀaiyӒӗӜron;䄚rc耻\xca䃊;䐭ot;䄖r;쀀\ud835\udd08rave耻\xc8䃈ement;戈ĀapӺӾcr;䄒tyɓԆ\x00\x00ԒmallSquare;旻erySmallSquare;斫ĀgpԦԪon;䄘f;쀀\ud835\udd3csilon;䎕uĀaiԼՉlĀ;TՂՃ橵ilde;扂librium;懌Āci՗՚r;愰m;橳a;䎗ml耻\xcb䃋Āipժկsts;戃onentialE;慇ʀcfiosօֈ֍ֲ׌y;䐤r;쀀\ud835\udd09lledɓ֗\x00\x00֣mallSquare;旼erySmallSquare;斪Ͱֺ\x00ֿ\x00\x00ׄf;쀀\ud835\udd3dAll;戀riertrf;愱c\xf2׋؀JTabcdfgorstר׬ׯ׺؀ؒؖ؛؝أ٬ٲcy;䐃耻>䀾mmaĀ;d׷׸䎓;䏜reve;䄞ƀeiy؇،ؐdil;䄢rc;䄜;䐓ot;䄠r;쀀\ud835\udd0a;拙pf;쀀\ud835\udd3eeater̀EFGLSTصلَٖٛ٦qualĀ;Lؾؿ扥ess;招ullEqual;执reater;檢ess;扷lantEqual;橾ilde;扳cr;쀀\ud835\udca2;扫ЀAacfiosuڅڋږڛڞڪھۊRDcy;䐪Āctڐڔek;䋇;䁞irc;䄤r;愌lbertSpace;愋ǰگ\x00ڲf;愍izontalLine;攀Āctۃۅ\xf2کrok;䄦mpńېۘownHum\xf0įqual;扏܀EJOacdfgmnostuۺ۾܃܇܎ܚܞܡܨ݄ݸދޏޕcy;䐕lig;䄲cy;䐁cute耻\xcd䃍Āiyܓܘrc耻\xce䃎;䐘ot;䄰r;愑rave耻\xcc䃌ƀ;apܠܯܿĀcgܴܷr;䄪inaryI;慈lie\xf3ϝǴ݉\x00ݢĀ;eݍݎ戬Āgrݓݘral;戫section;拂isibleĀCTݬݲomma;恣imes;恢ƀgptݿރވon;䄮f;쀀\ud835\udd40a;䎙cr;愐ilde;䄨ǫޚ\x00ޞcy;䐆l耻\xcf䃏ʀcfosuެ޷޼߂ߐĀiyޱ޵rc;䄴;䐙r;쀀\ud835\udd0dpf;쀀\ud835\udd41ǣ߇\x00ߌr;쀀\ud835\udca5rcy;䐈kcy;䐄΀HJacfosߤߨ߽߬߱ࠂࠈcy;䐥cy;䐌ppa;䎚Āey߶߻dil;䄶;䐚r;쀀\ud835\udd0epf;쀀\ud835\udd42cr;쀀\ud835\udca6րJTaceflmostࠥࠩࠬࡐࡣ঳সে্਷ੇcy;䐉耻<䀼ʀcmnpr࠷࠼ࡁࡄࡍute;䄹bda;䎛g;柪lacetrf;愒r;憞ƀaeyࡗ࡜ࡡron;䄽dil;䄻;䐛Āfsࡨ॰tԀACDFRTUVarࡾࢩࢱࣦ࣠ࣼयज़ΐ४Ānrࢃ࢏gleBracket;柨rowƀ;BR࢙࢚࢞憐ar;懤ightArrow;懆eiling;挈oǵࢷ\x00ࣃbleBracket;柦nǔࣈ\x00࣒eeVector;楡ectorĀ;Bࣛࣜ懃ar;楙loor;挊ightĀAV࣯ࣵrrow;憔ector;楎Āerँगeƀ;AVउऊऐ抣rrow;憤ector;楚iangleƀ;BEतथऩ抲ar;槏qual;抴pƀDTVषूौownVector;楑eeVector;楠ectorĀ;Bॖॗ憿ar;楘ectorĀ;B॥०憼ar;楒ight\xe1Μs̀EFGLSTॾঋকঝঢভqualGreater;拚ullEqual;扦reater;扶ess;檡lantEqual;橽ilde;扲r;쀀\ud835\udd0fĀ;eঽা拘ftarrow;懚idot;䄿ƀnpw৔ਖਛgȀLRlr৞৷ਂਐeftĀAR০৬rrow;柵ightArrow;柷ightArrow;柶eftĀarγਊight\xe1οight\xe1ϊf;쀀\ud835\udd43erĀLRਢਬeftArrow;憙ightArrow;憘ƀchtਾੀੂ\xf2ࡌ;憰rok;䅁;扪Ѐacefiosuਗ਼੝੠੷੼અઋ઎p;椅y;䐜Ādl੥੯iumSpace;恟lintrf;愳r;쀀\ud835\udd10nusPlus;戓pf;쀀\ud835\udd44c\xf2੶;䎜ҀJacefostuણધભીଔଙඑ඗ඞcy;䐊cute;䅃ƀaey઴હાron;䅇dil;䅅;䐝ƀgswે૰଎ativeƀMTV૓૟૨ediumSpace;怋hiĀcn૦૘\xeb૙eryThi\xee૙tedĀGL૸ଆreaterGreate\xf2ٳessLes\xf3ੈLine;䀊r;쀀\ud835\udd11ȀBnptଢନଷ଺reak;恠BreakingSpace;䂠f;愕ڀ;CDEGHLNPRSTV୕ୖ୪୼஡௫ఄ౞಄ದ೘ൡඅ櫬Āou୛୤ngruent;扢pCap;扭oubleVerticalBar;戦ƀlqxஃஊ஛ement;戉ualĀ;Tஒஓ扠ilde;쀀≂̸ists;戄reater΀;EFGLSTஶஷ஽௉௓௘௥扯qual;扱ullEqual;쀀≧̸reater;쀀≫̸ess;批lantEqual;쀀⩾̸ilde;扵umpń௲௽ownHump;쀀≎̸qual;쀀≏̸eĀfsఊధtTriangleƀ;BEచఛడ拪ar;쀀⧏̸qual;括s̀;EGLSTవశ఼ౄోౘ扮qual;扰reater;扸ess;쀀≪̸lantEqual;쀀⩽̸ilde;扴estedĀGL౨౹reaterGreater;쀀⪢̸essLess;쀀⪡̸recedesƀ;ESಒಓಛ技qual;쀀⪯̸lantEqual;拠ĀeiಫಹverseElement;戌ghtTriangleƀ;BEೋೌ೒拫ar;쀀⧐̸qual;拭ĀquೝഌuareSuĀbp೨೹setĀ;E೰ೳ쀀⊏̸qual;拢ersetĀ;Eഃആ쀀⊐̸qual;拣ƀbcpഓതൎsetĀ;Eഛഞ쀀⊂⃒qual;抈ceedsȀ;ESTലള഻െ抁qual;쀀⪰̸lantEqual;拡ilde;쀀≿̸ersetĀ;E൘൛쀀⊃⃒qual;抉ildeȀ;EFT൮൯൵ൿ扁qual;扄ullEqual;扇ilde;扉erticalBar;戤cr;쀀\ud835\udca9ilde耻\xd1䃑;䎝܀Eacdfgmoprstuvලෂ෉෕ෛ෠෧෼ขภยา฿ไlig;䅒cute耻\xd3䃓Āiy෎ීrc耻\xd4䃔;䐞blac;䅐r;쀀\ud835\udd12rave耻\xd2䃒ƀaei෮ෲ෶cr;䅌ga;䎩cron;䎟pf;쀀\ud835\udd46enCurlyĀDQฎบoubleQuote;怜uote;怘;橔Āclวฬr;쀀\ud835\udcaaash耻\xd8䃘iŬื฼de耻\xd5䃕es;樷ml耻\xd6䃖erĀBP๋๠Āar๐๓r;怾acĀek๚๜;揞et;掴arenthesis;揜Ҁacfhilors๿ງຊຏຒດຝະ໼rtialD;戂y;䐟r;쀀\ud835\udd13i;䎦;䎠usMinus;䂱Āipຢອncareplan\xe5ڝf;愙Ȁ;eio຺ູ໠໤檻cedesȀ;EST່້໏໚扺qual;檯lantEqual;扼ilde;找me;怳Ādp໩໮uct;戏ortionĀ;aȥ໹l;戝Āci༁༆r;쀀\ud835\udcab;䎨ȀUfos༑༖༛༟OT耻"䀢r;쀀\ud835\udd14pf;愚cr;쀀\ud835\udcac؀BEacefhiorsu༾གྷཇའཱིྦྷྪྭ႖ႩႴႾarr;椐G耻\xae䂮ƀcnrཎནབute;䅔g;柫rĀ;tཛྷཝ憠l;椖ƀaeyཧཬཱron;䅘dil;䅖;䐠Ā;vླྀཹ愜erseĀEUྂྙĀlq྇ྎement;戋uilibrium;懋pEquilibrium;楯r\xbbཹo;䎡ghtЀACDFTUVa࿁࿫࿳ဢဨၛႇϘĀnr࿆࿒gleBracket;柩rowƀ;BL࿜࿝࿡憒ar;懥eftArrow;懄eiling;按oǵ࿹\x00စbleBracket;柧nǔည\x00နeeVector;楝ectorĀ;Bဝသ懂ar;楕loor;挋Āerိ၃eƀ;AVဵံြ抢rrow;憦ector;楛iangleƀ;BEၐၑၕ抳ar;槐qual;抵pƀDTVၣၮၸownVector;楏eeVector;楜ectorĀ;Bႂႃ憾ar;楔ectorĀ;B႑႒懀ar;楓Āpuႛ႞f;愝ndImplies;楰ightarrow;懛ĀchႹႼr;愛;憱leDelayed;槴ڀHOacfhimoqstuფჱჷჽᄙᄞᅑᅖᅡᅧᆵᆻᆿĀCcჩხHcy;䐩y;䐨FTcy;䐬cute;䅚ʀ;aeiyᄈᄉᄎᄓᄗ檼ron;䅠dil;䅞rc;䅜;䐡r;쀀\ud835\udd16ortȀDLRUᄪᄴᄾᅉownArrow\xbbОeftArrow\xbb࢚ightArrow\xbb࿝pArrow;憑gma;䎣allCircle;战pf;쀀\ud835\udd4aɲᅭ\x00\x00ᅰt;戚areȀ;ISUᅻᅼᆉᆯ斡ntersection;抓uĀbpᆏᆞsetĀ;Eᆗᆘ抏qual;抑ersetĀ;Eᆨᆩ抐qual;抒nion;抔cr;쀀\ud835\udcaear;拆ȀbcmpᇈᇛሉላĀ;sᇍᇎ拐etĀ;Eᇍᇕqual;抆ĀchᇠህeedsȀ;ESTᇭᇮᇴᇿ扻qual;檰lantEqual;扽ilde;承Th\xe1ྌ;我ƀ;esሒሓሣ拑rsetĀ;Eሜም抃qual;抇et\xbbሓրHRSacfhiorsሾቄ቉ቕ቞ቱቶኟዂወዑORN耻\xde䃞ADE;愢ĀHc቎ቒcy;䐋y;䐦Ābuቚቜ;䀉;䎤ƀaeyብቪቯron;䅤dil;䅢;䐢r;쀀\ud835\udd17Āeiቻ኉ǲኀ\x00ኇefore;戴a;䎘Ācn኎ኘkSpace;쀀  Space;怉ldeȀ;EFTካኬኲኼ戼qual;扃ullEqual;扅ilde;扈pf;쀀\ud835\udd4bipleDot;惛Āctዖዛr;쀀\ud835\udcafrok;䅦ૡዷጎጚጦ\x00ጬጱ\x00\x00\x00\x00\x00ጸጽ፷ᎅ\x00᏿ᐄᐊᐐĀcrዻጁute耻\xda䃚rĀ;oጇገ憟cir;楉rǣጓ\x00጖y;䐎ve;䅬Āiyጞጣrc耻\xdb䃛;䐣blac;䅰r;쀀\ud835\udd18rave耻\xd9䃙acr;䅪Ādiፁ፩erĀBPፈ፝Āarፍፐr;䁟acĀekፗፙ;揟et;掵arenthesis;揝onĀ;P፰፱拃lus;抎Āgp፻፿on;䅲f;쀀\ud835\udd4cЀADETadps᎕ᎮᎸᏄϨᏒᏗᏳrrowƀ;BDᅐᎠᎤar;椒ownArrow;懅ownArrow;憕quilibrium;楮eeĀ;AᏋᏌ报rrow;憥own\xe1ϳerĀLRᏞᏨeftArrow;憖ightArrow;憗iĀ;lᏹᏺ䏒on;䎥ing;䅮cr;쀀\ud835\udcb0ilde;䅨ml耻\xdc䃜ҀDbcdefosvᐧᐬᐰᐳᐾᒅᒊᒐᒖash;披ar;櫫y;䐒ashĀ;lᐻᐼ抩;櫦Āerᑃᑅ;拁ƀbtyᑌᑐᑺar;怖Ā;iᑏᑕcalȀBLSTᑡᑥᑪᑴar;戣ine;䁼eparator;杘ilde;所ThinSpace;怊r;쀀\ud835\udd19pf;쀀\ud835\udd4dcr;쀀\ud835\udcb1dash;抪ʀcefosᒧᒬᒱᒶᒼirc;䅴dge;拀r;쀀\ud835\udd1apf;쀀\ud835\udd4ecr;쀀\ud835\udcb2Ȁfiosᓋᓐᓒᓘr;쀀\ud835\udd1b;䎞pf;쀀\ud835\udd4fcr;쀀\ud835\udcb3ҀAIUacfosuᓱᓵᓹᓽᔄᔏᔔᔚᔠcy;䐯cy;䐇cy;䐮cute耻\xdd䃝Āiyᔉᔍrc;䅶;䐫r;쀀\ud835\udd1cpf;쀀\ud835\udd50cr;쀀\ud835\udcb4ml;䅸ЀHacdefosᔵᔹᔿᕋᕏᕝᕠᕤcy;䐖cute;䅹Āayᕄᕉron;䅽;䐗ot;䅻ǲᕔ\x00ᕛoWidt\xe8૙a;䎖r;愨pf;愤cr;쀀\ud835\udcb5௡ᖃᖊᖐ\x00ᖰᖶᖿ\x00\x00\x00\x00ᗆᗛᗫᙟ᙭\x00ᚕ᚛ᚲᚹ\x00ᚾcute耻\xe1䃡reve;䄃̀;Ediuyᖜᖝᖡᖣᖨᖭ戾;쀀∾̳;房rc耻\xe2䃢te肻\xb4̆;䐰lig耻\xe6䃦Ā;r\xb2ᖺ;쀀\ud835\udd1erave耻\xe0䃠ĀepᗊᗖĀfpᗏᗔsym;愵\xe8ᗓha;䎱ĀapᗟcĀclᗤᗧr;䄁g;樿ɤᗰ\x00\x00ᘊʀ;adsvᗺᗻᗿᘁᘇ戧nd;橕;橜lope;橘;橚΀;elmrszᘘᘙᘛᘞᘿᙏᙙ戠;榤e\xbbᘙsdĀ;aᘥᘦ戡ѡᘰᘲᘴᘶᘸᘺᘼᘾ;榨;榩;榪;榫;榬;榭;榮;榯tĀ;vᙅᙆ戟bĀ;dᙌᙍ抾;榝Āptᙔᙗh;戢\xbb\xb9arr;捼Āgpᙣᙧon;䄅f;쀀\ud835\udd52΀;Eaeiop዁ᙻᙽᚂᚄᚇᚊ;橰cir;橯;扊d;手s;䀧roxĀ;e዁ᚒ\xf1ᚃing耻\xe5䃥ƀctyᚡᚦᚨr;쀀\ud835\udcb6;䀪mpĀ;e዁ᚯ\xf1ʈilde耻\xe3䃣ml耻\xe4䃤Āciᛂᛈonin\xf4ɲnt;樑ࠀNabcdefiklnoprsu᛭ᛱᜰ᜼ᝃᝈ᝸᝽០៦ᠹᡐᜍ᤽᥈ᥰot;櫭Ācrᛶ᜞kȀcepsᜀᜅᜍᜓong;扌psilon;䏶rime;怵imĀ;e᜚᜛戽q;拍Ŷᜢᜦee;抽edĀ;gᜬᜭ挅e\xbbᜭrkĀ;t፜᜷brk;掶Āoyᜁᝁ;䐱quo;怞ʀcmprtᝓ᝛ᝡᝤᝨausĀ;eĊĉptyv;榰s\xe9ᜌno\xf5ēƀahwᝯ᝱ᝳ;䎲;愶een;扬r;쀀\ud835\udd1fg΀costuvwឍឝឳេ៕៛៞ƀaiuបពរ\xf0ݠrc;旯p\xbb፱ƀdptឤឨឭot;樀lus;樁imes;樂ɱឹ\x00\x00ើcup;樆ar;昅riangleĀdu៍្own;施p;斳plus;樄e\xe5ᑄ\xe5ᒭarow;植ƀako៭ᠦᠵĀcn៲ᠣkƀlst៺֫᠂ozenge;槫riangleȀ;dlr᠒᠓᠘᠝斴own;斾eft;旂ight;斸k;搣Ʊᠫ\x00ᠳƲᠯ\x00ᠱ;斒;斑4;斓ck;斈ĀeoᠾᡍĀ;qᡃᡆ쀀=⃥uiv;쀀≡⃥t;挐Ȁptwxᡙᡞᡧᡬf;쀀\ud835\udd53Ā;tᏋᡣom\xbbᏌtie;拈؀DHUVbdhmptuvᢅᢖᢪᢻᣗᣛᣬ᣿ᤅᤊᤐᤡȀLRlrᢎᢐᢒᢔ;敗;敔;敖;敓ʀ;DUduᢡᢢᢤᢦᢨ敐;敦;敩;敤;敧ȀLRlrᢳᢵᢷᢹ;敝;敚;敜;教΀;HLRhlrᣊᣋᣍᣏᣑᣓᣕ救;敬;散;敠;敫;敢;敟ox;槉ȀLRlrᣤᣦᣨᣪ;敕;敒;攐;攌ʀ;DUduڽ᣷᣹᣻᣽;敥;敨;攬;攴inus;抟lus;択imes;抠ȀLRlrᤙᤛᤝ᤟;敛;敘;攘;攔΀;HLRhlrᤰᤱᤳᤵᤷ᤻᤹攂;敪;敡;敞;攼;攤;攜Āevģ᥂bar耻\xa6䂦Ȁceioᥑᥖᥚᥠr;쀀\ud835\udcb7mi;恏mĀ;e᜚᜜lƀ;bhᥨᥩᥫ䁜;槅sub;柈Ŭᥴ᥾lĀ;e᥹᥺怢t\xbb᥺pƀ;Eeįᦅᦇ;檮Ā;qۜۛೡᦧ\x00᧨ᨑᨕᨲ\x00ᨷᩐ\x00\x00᪴\x00\x00᫁\x00\x00ᬡᬮ᭍᭒\x00᯽\x00ᰌƀcpr᦭ᦲ᧝ute;䄇̀;abcdsᦿᧀᧄ᧊᧕᧙戩nd;橄rcup;橉Āau᧏᧒p;橋p;橇ot;橀;쀀∩︀Āeo᧢᧥t;恁\xeeړȀaeiu᧰᧻ᨁᨅǰ᧵\x00᧸s;橍on;䄍dil耻\xe7䃧rc;䄉psĀ;sᨌᨍ橌m;橐ot;䄋ƀdmnᨛᨠᨦil肻\xb8ƭptyv;榲t脀\xa2;eᨭᨮ䂢r\xe4Ʋr;쀀\ud835\udd20ƀceiᨽᩀᩍy;䑇ckĀ;mᩇᩈ朓ark\xbbᩈ;䏇r΀;Ecefms᩟᩠ᩢᩫ᪤᪪᪮旋;槃ƀ;elᩩᩪᩭ䋆q;扗eɡᩴ\x00\x00᪈rrowĀlr᩼᪁eft;憺ight;憻ʀRSacd᪒᪔᪖᪚᪟\xbbཇ;擈st;抛irc;抚ash;抝nint;樐id;櫯cir;槂ubsĀ;u᪻᪼晣it\xbb᪼ˬ᫇᫔᫺\x00ᬊonĀ;eᫍᫎ䀺Ā;q\xc7\xc6ɭ᫙\x00\x00᫢aĀ;t᫞᫟䀬;䁀ƀ;fl᫨᫩᫫戁\xeeᅠeĀmx᫱᫶ent\xbb᫩e\xf3ɍǧ᫾\x00ᬇĀ;dኻᬂot;橭n\xf4Ɇƀfryᬐᬔᬗ;쀀\ud835\udd54o\xe4ɔ脀\xa9;sŕᬝr;愗Āaoᬥᬩrr;憵ss;朗Ācuᬲᬷr;쀀\ud835\udcb8Ābpᬼ᭄Ā;eᭁᭂ櫏;櫑Ā;eᭉᭊ櫐;櫒dot;拯΀delprvw᭠᭬᭷ᮂᮬᯔ᯹arrĀlr᭨᭪;椸;椵ɰ᭲\x00\x00᭵r;拞c;拟arrĀ;p᭿ᮀ憶;椽̀;bcdosᮏᮐᮖᮡᮥᮨ截rcap;橈Āauᮛᮞp;橆p;橊ot;抍r;橅;쀀∪︀Ȁalrv᮵ᮿᯞᯣrrĀ;mᮼᮽ憷;椼yƀevwᯇᯔᯘqɰᯎ\x00\x00ᯒre\xe3᭳u\xe3᭵ee;拎edge;拏en耻\xa4䂤earrowĀlrᯮ᯳eft\xbbᮀight\xbbᮽe\xe4ᯝĀciᰁᰇonin\xf4Ƿnt;戱lcty;挭ঀAHabcdefhijlorstuwz᰸᰻᰿ᱝᱩᱵᲊᲞᲬᲷ᳻᳿ᴍᵻᶑᶫᶻ᷆᷍r\xf2΁ar;楥Ȁglrs᱈ᱍ᱒᱔ger;怠eth;愸\xf2ᄳhĀ;vᱚᱛ怐\xbbऊūᱡᱧarow;椏a\xe3̕Āayᱮᱳron;䄏;䐴ƀ;ao̲ᱼᲄĀgrʿᲁr;懊tseq;橷ƀglmᲑᲔᲘ耻\xb0䂰ta;䎴ptyv;榱ĀirᲣᲨsht;楿;쀀\ud835\udd21arĀlrᲳᲵ\xbbࣜ\xbbသʀaegsv᳂͸᳖᳜᳠mƀ;oș᳊᳔ndĀ;ș᳑uit;晦amma;䏝in;拲ƀ;io᳧᳨᳸䃷de脀\xf7;o᳧ᳰntimes;拇n\xf8᳷cy;䑒cɯᴆ\x00\x00ᴊrn;挞op;挍ʀlptuwᴘᴝᴢᵉᵕlar;䀤f;쀀\ud835\udd55ʀ;emps̋ᴭᴷᴽᵂqĀ;d͒ᴳot;扑inus;戸lus;戔quare;抡blebarwedg\xe5\xfanƀadhᄮᵝᵧownarrow\xf3ᲃarpoonĀlrᵲᵶef\xf4Ჴigh\xf4ᲶŢᵿᶅkaro\xf7གɯᶊ\x00\x00ᶎrn;挟op;挌ƀcotᶘᶣᶦĀryᶝᶡ;쀀\ud835\udcb9;䑕l;槶rok;䄑Ādrᶰᶴot;拱iĀ;fᶺ᠖斿Āah᷀᷃r\xf2Щa\xf2ྦangle;榦Āci᷒ᷕy;䑟grarr;柿ऀDacdefglmnopqrstuxḁḉḙḸոḼṉṡṾấắẽỡἪἷὄ὎὚ĀDoḆᴴo\xf4ᲉĀcsḎḔute耻\xe9䃩ter;橮ȀaioyḢḧḱḶron;䄛rĀ;cḭḮ扖耻\xea䃪lon;払;䑍ot;䄗ĀDrṁṅot;扒;쀀\ud835\udd22ƀ;rsṐṑṗ檚ave耻\xe8䃨Ā;dṜṝ檖ot;檘Ȁ;ilsṪṫṲṴ檙nters;揧;愓Ā;dṹṺ檕ot;檗ƀapsẅẉẗcr;䄓tyƀ;svẒẓẕ戅et\xbbẓpĀ1;ẝẤĳạả;怄;怅怃ĀgsẪẬ;䅋p;怂ĀgpẴẸon;䄙f;쀀\ud835\udd56ƀalsỄỎỒrĀ;sỊị拕l;槣us;橱iƀ;lvỚớở䎵on\xbbớ;䏵ȀcsuvỪỳἋἣĀioữḱrc\xbbḮɩỹ\x00\x00ỻ\xedՈantĀglἂἆtr\xbbṝess\xbbṺƀaeiἒ἖Ἒls;䀽st;扟vĀ;DȵἠD;橸parsl;槥ĀDaἯἳot;打rr;楱ƀcdiἾὁỸr;愯o\xf4͒ĀahὉὋ;䎷耻\xf0䃰Āmrὓὗl耻\xeb䃫o;悬ƀcipὡὤὧl;䀡s\xf4ծĀeoὬὴctatio\xeeՙnential\xe5չৡᾒ\x00ᾞ\x00ᾡᾧ\x00\x00ῆῌ\x00ΐ\x00ῦῪ \x00 ⁚llingdotse\xf1Ṅy;䑄male;晀ƀilrᾭᾳ῁lig;耀ﬃɩᾹ\x00\x00᾽g;耀ﬀig;耀ﬄ;쀀\ud835\udd23lig;耀ﬁlig;쀀fjƀaltῙ῜ῡt;晭ig;耀ﬂns;斱of;䆒ǰ΅\x00ῳf;쀀\ud835\udd57ĀakֿῷĀ;vῼ´拔;櫙artint;樍Āao‌⁕Ācs‑⁒α‚‰‸⁅⁈\x00⁐β•‥‧‪‬\x00‮耻\xbd䂽;慓耻\xbc䂼;慕;慙;慛Ƴ‴\x00‶;慔;慖ʴ‾⁁\x00\x00⁃耻\xbe䂾;慗;慜5;慘ƶ⁌\x00⁎;慚;慝8;慞l;恄wn;挢cr;쀀\ud835\udcbbࢀEabcdefgijlnorstv₂₉₟₥₰₴⃰⃵⃺⃿℃ℒℸ̗ℾ⅒↞Ā;lٍ₇;檌ƀcmpₐₕ₝ute;䇵maĀ;dₜ᳚䎳;檆reve;䄟Āiy₪₮rc;䄝;䐳ot;䄡Ȁ;lqsؾق₽⃉ƀ;qsؾٌ⃄lan\xf4٥Ȁ;cdl٥⃒⃥⃕c;檩otĀ;o⃜⃝檀Ā;l⃢⃣檂;檄Ā;e⃪⃭쀀⋛︀s;檔r;쀀\ud835\udd24Ā;gٳ؛mel;愷cy;䑓Ȁ;Eajٚℌℎℐ;檒;檥;檤ȀEaesℛℝ℩ℴ;扩pĀ;p℣ℤ檊rox\xbbℤĀ;q℮ℯ檈Ā;q℮ℛim;拧pf;쀀\ud835\udd58Āci⅃ⅆr;愊mƀ;el٫ⅎ⅐;檎;檐茀>;cdlqr׮ⅠⅪⅮⅳⅹĀciⅥⅧ;檧r;橺ot;拗Par;榕uest;橼ʀadelsↄⅪ←ٖ↛ǰ↉\x00↎pro\xf8₞r;楸qĀlqؿ↖les\xf3₈i\xed٫Āen↣↭rtneqq;쀀≩︀\xc5↪ԀAabcefkosy⇄⇇⇱⇵⇺∘∝∯≨≽r\xf2ΠȀilmr⇐⇔⇗⇛rs\xf0ᒄf\xbb․il\xf4کĀdr⇠⇤cy;䑊ƀ;cwࣴ⇫⇯ir;楈;憭ar;意irc;䄥ƀalr∁∎∓rtsĀ;u∉∊晥it\xbb∊lip;怦con;抹r;쀀\ud835\udd25sĀew∣∩arow;椥arow;椦ʀamopr∺∾≃≞≣rr;懿tht;戻kĀlr≉≓eftarrow;憩ightarrow;憪f;쀀\ud835\udd59bar;怕ƀclt≯≴≸r;쀀\ud835\udcbdas\xe8⇴rok;䄧Ābp⊂⊇ull;恃hen\xbbᱛૡ⊣\x00⊪\x00⊸⋅⋎\x00⋕⋳\x00\x00⋸⌢⍧⍢⍿\x00⎆⎪⎴cute耻\xed䃭ƀ;iyݱ⊰⊵rc耻\xee䃮;䐸Ācx⊼⊿y;䐵cl耻\xa1䂡ĀfrΟ⋉;쀀\ud835\udd26rave耻\xec䃬Ȁ;inoܾ⋝⋩⋮Āin⋢⋦nt;樌t;戭fin;槜ta;愩lig;䄳ƀaop⋾⌚⌝ƀcgt⌅⌈⌗r;䄫ƀelpܟ⌏⌓in\xe5ގar\xf4ܠh;䄱f;抷ed;䆵ʀ;cfotӴ⌬⌱⌽⍁are;愅inĀ;t⌸⌹戞ie;槝do\xf4⌙ʀ;celpݗ⍌⍐⍛⍡al;抺Āgr⍕⍙er\xf3ᕣ\xe3⍍arhk;樗rod;樼Ȁcgpt⍯⍲⍶⍻y;䑑on;䄯f;쀀\ud835\udd5aa;䎹uest耻\xbf䂿Āci⎊⎏r;쀀\ud835\udcbenʀ;EdsvӴ⎛⎝⎡ӳ;拹ot;拵Ā;v⎦⎧拴;拳Ā;iݷ⎮lde;䄩ǫ⎸\x00⎼cy;䑖l耻\xef䃯̀cfmosu⏌⏗⏜⏡⏧⏵Āiy⏑⏕rc;䄵;䐹r;쀀\ud835\udd27ath;䈷pf;쀀\ud835\udd5bǣ⏬\x00⏱r;쀀\ud835\udcbfrcy;䑘kcy;䑔Ѐacfghjos␋␖␢␧␭␱␵␻ppaĀ;v␓␔䎺;䏰Āey␛␠dil;䄷;䐺r;쀀\ud835\udd28reen;䄸cy;䑅cy;䑜pf;쀀\ud835\udd5ccr;쀀\ud835\udcc0஀ABEHabcdefghjlmnoprstuv⑰⒁⒆⒍⒑┎┽╚▀♎♞♥♹♽⚚⚲⛘❝❨➋⟀⠁⠒ƀart⑷⑺⑼r\xf2৆\xf2Εail;椛arr;椎Ā;gঔ⒋;檋ar;楢ॣ⒥\x00⒪\x00⒱\x00\x00\x00\x00\x00⒵Ⓔ\x00ⓆⓈⓍ\x00⓹ute;䄺mptyv;榴ra\xeeࡌbda;䎻gƀ;dlࢎⓁⓃ;榑\xe5ࢎ;檅uo耻\xab䂫rЀ;bfhlpst࢙ⓞⓦⓩ⓫⓮⓱⓵Ā;f࢝ⓣs;椟s;椝\xeb≒p;憫l;椹im;楳l;憢ƀ;ae⓿─┄檫il;椙Ā;s┉┊檭;쀀⪭︀ƀabr┕┙┝rr;椌rk;杲Āak┢┬cĀek┨┪;䁻;䁛Āes┱┳;榋lĀdu┹┻;榏;榍Ȁaeuy╆╋╖╘ron;䄾Ādi═╔il;䄼\xecࢰ\xe2┩;䐻Ȁcqrs╣╦╭╽a;椶uoĀ;rนᝆĀdu╲╷har;楧shar;楋h;憲ʀ;fgqs▋▌উ◳◿扤tʀahlrt▘▤▷◂◨rrowĀ;t࢙□a\xe9⓶arpoonĀdu▯▴own\xbbњp\xbb०eftarrows;懇ightƀahs◍◖◞rrowĀ;sࣴࢧarpoon\xf3྘quigarro\xf7⇰hreetimes;拋ƀ;qs▋ও◺lan\xf4বʀ;cdgsব☊☍☝☨c;檨otĀ;o☔☕橿Ā;r☚☛檁;檃Ā;e☢☥쀀⋚︀s;檓ʀadegs☳☹☽♉♋ppro\xf8Ⓠot;拖qĀgq♃♅\xf4উgt\xf2⒌\xf4ছi\xedলƀilr♕࣡♚sht;楼;쀀\ud835\udd29Ā;Eজ♣;檑š♩♶rĀdu▲♮Ā;l॥♳;楪lk;斄cy;䑙ʀ;achtੈ⚈⚋⚑⚖r\xf2◁orne\xf2ᴈard;楫ri;旺Āio⚟⚤dot;䅀ustĀ;a⚬⚭掰che\xbb⚭ȀEaes⚻⚽⛉⛔;扨pĀ;p⛃⛄檉rox\xbb⛄Ā;q⛎⛏檇Ā;q⛎⚻im;拦Ѐabnoptwz⛩⛴⛷✚✯❁❇❐Ānr⛮⛱g;柬r;懽r\xebࣁgƀlmr⛿✍✔eftĀar০✇ight\xe1৲apsto;柼ight\xe1৽parrowĀlr✥✩ef\xf4⓭ight;憬ƀafl✶✹✽r;榅;쀀\ud835\udd5dus;樭imes;樴š❋❏st;戗\xe1ፎƀ;ef❗❘᠀旊nge\xbb❘arĀ;l❤❥䀨t;榓ʀachmt❳❶❼➅➇r\xf2ࢨorne\xf2ᶌarĀ;d྘➃;業;怎ri;抿̀achiqt➘➝ੀ➢➮➻quo;怹r;쀀\ud835\udcc1mƀ;egল➪➬;檍;檏Ābu┪➳oĀ;rฟ➹;怚rok;䅂萀<;cdhilqrࠫ⟒☹⟜⟠⟥⟪⟰Āci⟗⟙;檦r;橹re\xe5◲mes;拉arr;楶uest;橻ĀPi⟵⟹ar;榖ƀ;ef⠀भ᠛旃rĀdu⠇⠍shar;楊har;楦Āen⠗⠡rtneqq;쀀≨︀\xc5⠞܀Dacdefhilnopsu⡀⡅⢂⢎⢓⢠⢥⢨⣚⣢⣤ઃ⣳⤂Dot;戺Ȁclpr⡎⡒⡣⡽r耻\xaf䂯Āet⡗⡙;時Ā;e⡞⡟朠se\xbb⡟Ā;sျ⡨toȀ;dluျ⡳⡷⡻ow\xeeҌef\xf4ए\xf0Ꮡker;斮Āoy⢇⢌mma;権;䐼ash;怔asuredangle\xbbᘦr;쀀\ud835\udd2ao;愧ƀcdn⢯⢴⣉ro耻\xb5䂵Ȁ;acdᑤ⢽⣀⣄s\xf4ᚧir;櫰ot肻\xb7Ƶusƀ;bd⣒ᤃ⣓戒Ā;uᴼ⣘;横ţ⣞⣡p;櫛\xf2−\xf0ઁĀdp⣩⣮els;抧f;쀀\ud835\udd5eĀct⣸⣽r;쀀\ud835\udcc2pos\xbbᖝƀ;lm⤉⤊⤍䎼timap;抸ఀGLRVabcdefghijlmoprstuvw⥂⥓⥾⦉⦘⧚⧩⨕⨚⩘⩝⪃⪕⪤⪨⬄⬇⭄⭿⮮ⰴⱧⱼ⳩Āgt⥇⥋;쀀⋙̸Ā;v⥐௏쀀≫⃒ƀelt⥚⥲⥶ftĀar⥡⥧rrow;懍ightarrow;懎;쀀⋘̸Ā;v⥻ే쀀≪⃒ightarrow;懏ĀDd⦎⦓ash;抯ash;抮ʀbcnpt⦣⦧⦬⦱⧌la\xbb˞ute;䅄g;쀀∠⃒ʀ;Eiop඄⦼⧀⧅⧈;쀀⩰̸d;쀀≋̸s;䅉ro\xf8඄urĀ;a⧓⧔普lĀ;s⧓ସǳ⧟\x00⧣p肻\xa0ଷmpĀ;e௹ఀʀaeouy⧴⧾⨃⨐⨓ǰ⧹\x00⧻;橃on;䅈dil;䅆ngĀ;dൾ⨊ot;쀀⩭̸p;橂;䐽ash;怓΀;Aadqsxஒ⨩⨭⨻⩁⩅⩐rr;懗rĀhr⨳⨶k;椤Ā;oᏲᏰot;쀀≐̸ui\xf6ୣĀei⩊⩎ar;椨\xed஘istĀ;s஠டr;쀀\ud835\udd2bȀEest௅⩦⩹⩼ƀ;qs஼⩭௡ƀ;qs஼௅⩴lan\xf4௢i\xed௪Ā;rஶ⪁\xbbஷƀAap⪊⪍⪑r\xf2⥱rr;憮ar;櫲ƀ;svྍ⪜ྌĀ;d⪡⪢拼;拺cy;䑚΀AEadest⪷⪺⪾⫂⫅⫶⫹r\xf2⥦;쀀≦̸rr;憚r;急Ȁ;fqs఻⫎⫣⫯tĀar⫔⫙rro\xf7⫁ightarro\xf7⪐ƀ;qs఻⪺⫪lan\xf4ౕĀ;sౕ⫴\xbbశi\xedౝĀ;rవ⫾iĀ;eచథi\xe4ඐĀpt⬌⬑f;쀀\ud835\udd5f膀\xac;in⬙⬚⬶䂬nȀ;Edvஉ⬤⬨⬮;쀀⋹̸ot;쀀⋵̸ǡஉ⬳⬵;拷;拶iĀ;vಸ⬼ǡಸ⭁⭃;拾;拽ƀaor⭋⭣⭩rȀ;ast୻⭕⭚⭟lle\xec୻l;쀀⫽⃥;쀀∂̸lint;樔ƀ;ceಒ⭰⭳u\xe5ಥĀ;cಘ⭸Ā;eಒ⭽\xf1ಘȀAait⮈⮋⮝⮧r\xf2⦈rrƀ;cw⮔⮕⮙憛;쀀⤳̸;쀀↝̸ghtarrow\xbb⮕riĀ;eೋೖ΀chimpqu⮽⯍⯙⬄୸⯤⯯Ȁ;cerല⯆ഷ⯉u\xe5൅;쀀\ud835\udcc3ortɭ⬅\x00\x00⯖ar\xe1⭖mĀ;e൮⯟Ā;q൴൳suĀbp⯫⯭\xe5೸\xe5ഋƀbcp⯶ⰑⰙȀ;Ees⯿ⰀഢⰄ抄;쀀⫅̸etĀ;eഛⰋqĀ;qണⰀcĀ;eലⰗ\xf1സȀ;EesⰢⰣൟⰧ抅;쀀⫆̸etĀ;e൘ⰮqĀ;qൠⰣȀgilrⰽⰿⱅⱇ\xecௗlde耻\xf1䃱\xe7ృiangleĀlrⱒⱜeftĀ;eచⱚ\xf1దightĀ;eೋⱥ\xf1೗Ā;mⱬⱭ䎽ƀ;esⱴⱵⱹ䀣ro;愖p;怇ҀDHadgilrsⲏⲔⲙⲞⲣⲰⲶⳓⳣash;抭arr;椄p;쀀≍⃒ash;抬ĀetⲨⲬ;쀀≥⃒;쀀>⃒nfin;槞ƀAetⲽⳁⳅrr;椂;쀀≤⃒Ā;rⳊⳍ쀀<⃒ie;쀀⊴⃒ĀAtⳘⳜrr;椃rie;쀀⊵⃒im;쀀∼⃒ƀAan⳰⳴ⴂrr;懖rĀhr⳺⳽k;椣Ā;oᏧᏥear;椧ቓ᪕\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00ⴭ\x00ⴸⵈⵠⵥ⵲ⶄᬇ\x00\x00ⶍⶫ\x00ⷈⷎ\x00ⷜ⸙⸫⸾⹃Ācsⴱ᪗ute耻\xf3䃳ĀiyⴼⵅrĀ;c᪞ⵂ耻\xf4䃴;䐾ʀabios᪠ⵒⵗǈⵚlac;䅑v;樸old;榼lig;䅓Ācr⵩⵭ir;榿;쀀\ud835\udd2cͯ⵹\x00\x00⵼\x00ⶂn;䋛ave耻\xf2䃲;槁Ābmⶈ෴ar;榵Ȁacitⶕ⶘ⶥⶨr\xf2᪀Āir⶝ⶠr;榾oss;榻n\xe5๒;槀ƀaeiⶱⶵⶹcr;䅍ga;䏉ƀcdnⷀⷅǍron;䎿;榶pf;쀀\ud835\udd60ƀaelⷔ⷗ǒr;榷rp;榹΀;adiosvⷪⷫⷮ⸈⸍⸐⸖戨r\xf2᪆Ȁ;efmⷷⷸ⸂⸅橝rĀ;oⷾⷿ愴f\xbbⷿ耻\xaa䂪耻\xba䂺gof;抶r;橖lope;橗;橛ƀclo⸟⸡⸧\xf2⸁ash耻\xf8䃸l;折iŬⸯ⸴de耻\xf5䃵esĀ;aǛ⸺s;樶ml耻\xf6䃶bar;挽ૡ⹞\x00⹽\x00⺀⺝\x00⺢⺹\x00\x00⻋ຜ\x00⼓\x00\x00⼫⾼\x00⿈rȀ;astЃ⹧⹲຅脀\xb6;l⹭⹮䂶le\xecЃɩ⹸\x00\x00⹻m;櫳;櫽y;䐿rʀcimpt⺋⺏⺓ᡥ⺗nt;䀥od;䀮il;怰enk;怱r;쀀\ud835\udd2dƀimo⺨⺰⺴Ā;v⺭⺮䏆;䏕ma\xf4੶ne;明ƀ;tv⺿⻀⻈䏀chfork\xbb´;䏖Āau⻏⻟nĀck⻕⻝kĀ;h⇴⻛;愎\xf6⇴sҀ;abcdemst⻳⻴ᤈ⻹⻽⼄⼆⼊⼎䀫cir;樣ir;樢Āouᵀ⼂;樥;橲n肻\xb1ຝim;樦wo;樧ƀipu⼙⼠⼥ntint;樕f;쀀\ud835\udd61nd耻\xa3䂣Ԁ;Eaceinosu່⼿⽁⽄⽇⾁⾉⾒⽾⾶;檳p;檷u\xe5໙Ā;c໎⽌̀;acens່⽙⽟⽦⽨⽾ppro\xf8⽃urlye\xf1໙\xf1໎ƀaes⽯⽶⽺pprox;檹qq;檵im;拨i\xedໟmeĀ;s⾈ຮ怲ƀEas⽸⾐⽺\xf0⽵ƀdfp໬⾙⾯ƀals⾠⾥⾪lar;挮ine;挒urf;挓Ā;t໻⾴\xef໻rel;抰Āci⿀⿅r;쀀\ud835\udcc5;䏈ncsp;怈̀fiopsu⿚⋢⿟⿥⿫⿱r;쀀\ud835\udd2epf;쀀\ud835\udd62rime;恗cr;쀀\ud835\udcc6ƀaeo⿸〉〓tĀei⿾々rnion\xf3ڰnt;樖stĀ;e【】䀿\xf1Ἑ\xf4༔઀ABHabcdefhilmnoprstux぀けさすムㄎㄫㅇㅢㅲㆎ㈆㈕㈤㈩㉘㉮㉲㊐㊰㊷ƀartぇおがr\xf2Ⴓ\xf2ϝail;検ar\xf2ᱥar;楤΀cdenqrtとふへみわゔヌĀeuねぱ;쀀∽̱te;䅕i\xe3ᅮmptyv;榳gȀ;del࿑らるろ;榒;榥\xe5࿑uo耻\xbb䂻rր;abcfhlpstw࿜ガクシスゼゾダッデナp;極Ā;f࿠ゴs;椠;椳s;椞\xeb≝\xf0✮l;楅im;楴l;憣;憝Āaiパフil;椚oĀ;nホボ戶al\xf3༞ƀabrョリヮr\xf2៥rk;杳ĀakンヽcĀekヹ・;䁽;䁝Āes㄂㄄;榌lĀduㄊㄌ;榎;榐Ȁaeuyㄗㄜㄧㄩron;䅙Ādiㄡㄥil;䅗\xec࿲\xe2ヺ;䑀Ȁclqsㄴㄷㄽㅄa;椷dhar;楩uoĀ;rȎȍh;憳ƀacgㅎㅟངlȀ;ipsླྀㅘㅛႜn\xe5Ⴛar\xf4ྩt;断ƀilrㅩဣㅮsht;楽;쀀\ud835\udd2fĀaoㅷㆆrĀduㅽㅿ\xbbѻĀ;l႑ㆄ;楬Ā;vㆋㆌ䏁;䏱ƀgns㆕ㇹㇼht̀ahlrstㆤㆰ㇂㇘㇤㇮rrowĀ;t࿜ㆭa\xe9トarpoonĀduㆻㆿow\xeeㅾp\xbb႒eftĀah㇊㇐rrow\xf3࿪arpoon\xf3Ցightarrows;應quigarro\xf7ニhreetimes;拌g;䋚ingdotse\xf1ἲƀahm㈍㈐㈓r\xf2࿪a\xf2Ց;怏oustĀ;a㈞㈟掱che\xbb㈟mid;櫮Ȁabpt㈲㈽㉀㉒Ānr㈷㈺g;柭r;懾r\xebဃƀafl㉇㉊㉎r;榆;쀀\ud835\udd63us;樮imes;樵Āap㉝㉧rĀ;g㉣㉤䀩t;榔olint;樒ar\xf2㇣Ȁachq㉻㊀Ⴜ㊅quo;怺r;쀀\ud835\udcc7Ābu・㊊oĀ;rȔȓƀhir㊗㊛㊠re\xe5ㇸmes;拊iȀ;efl㊪ၙᠡ㊫方tri;槎luhar;楨;愞ൡ㋕㋛㋟㌬㌸㍱\x00㍺㎤\x00\x00㏬㏰\x00㐨㑈㑚㒭㒱㓊㓱\x00㘖\x00\x00㘳cute;䅛qu\xef➺Ԁ;Eaceinpsyᇭ㋳㋵㋿㌂㌋㌏㌟㌦㌩;檴ǰ㋺\x00㋼;檸on;䅡u\xe5ᇾĀ;dᇳ㌇il;䅟rc;䅝ƀEas㌖㌘㌛;檶p;檺im;择olint;樓i\xedሄ;䑁otƀ;be㌴ᵇ㌵担;橦΀Aacmstx㍆㍊㍗㍛㍞㍣㍭rr;懘rĀhr㍐㍒\xeb∨Ā;oਸ਼਴t耻\xa7䂧i;䀻war;椩mĀin㍩\xf0nu\xf3\xf1t;朶rĀ;o㍶⁕쀀\ud835\udd30Ȁacoy㎂㎆㎑㎠rp;景Āhy㎋㎏cy;䑉;䑈rtɭ㎙\x00\x00㎜i\xe4ᑤara\xec⹯耻\xad䂭Āgm㎨㎴maƀ;fv㎱㎲㎲䏃;䏂Ѐ;deglnprካ㏅㏉㏎㏖㏞㏡㏦ot;橪Ā;q኱ኰĀ;E㏓㏔檞;檠Ā;E㏛㏜檝;檟e;扆lus;樤arr;楲ar\xf2ᄽȀaeit㏸㐈㐏㐗Āls㏽㐄lsetm\xe9㍪hp;樳parsl;槤Ādlᑣ㐔e;挣Ā;e㐜㐝檪Ā;s㐢㐣檬;쀀⪬︀ƀflp㐮㐳㑂tcy;䑌Ā;b㐸㐹䀯Ā;a㐾㐿槄r;挿f;쀀\ud835\udd64aĀdr㑍ЂesĀ;u㑔㑕晠it\xbb㑕ƀcsu㑠㑹㒟Āau㑥㑯pĀ;sᆈ㑫;쀀⊓︀pĀ;sᆴ㑵;쀀⊔︀uĀbp㑿㒏ƀ;esᆗᆜ㒆etĀ;eᆗ㒍\xf1ᆝƀ;esᆨᆭ㒖etĀ;eᆨ㒝\xf1ᆮƀ;afᅻ㒦ְrť㒫ֱ\xbbᅼar\xf2ᅈȀcemt㒹㒾㓂㓅r;쀀\ud835\udcc8tm\xee\xf1i\xec㐕ar\xe6ᆾĀar㓎㓕rĀ;f㓔ឿ昆Āan㓚㓭ightĀep㓣㓪psilo\xeeỠh\xe9⺯s\xbb⡒ʀbcmnp㓻㕞ሉ㖋㖎Ҁ;Edemnprs㔎㔏㔑㔕㔞㔣㔬㔱㔶抂;櫅ot;檽Ā;dᇚ㔚ot;櫃ult;櫁ĀEe㔨㔪;櫋;把lus;檿arr;楹ƀeiu㔽㕒㕕tƀ;en㔎㕅㕋qĀ;qᇚ㔏eqĀ;q㔫㔨m;櫇Ābp㕚㕜;櫕;櫓c̀;acensᇭ㕬㕲㕹㕻㌦ppro\xf8㋺urlye\xf1ᇾ\xf1ᇳƀaes㖂㖈㌛ppro\xf8㌚q\xf1㌗g;晪ڀ123;Edehlmnps㖩㖬㖯ሜ㖲㖴㗀㗉㗕㗚㗟㗨㗭耻\xb9䂹耻\xb2䂲耻\xb3䂳;櫆Āos㖹㖼t;檾ub;櫘Ā;dሢ㗅ot;櫄sĀou㗏㗒l;柉b;櫗arr;楻ult;櫂ĀEe㗤㗦;櫌;抋lus;櫀ƀeiu㗴㘉㘌tƀ;enሜ㗼㘂qĀ;qሢ㖲eqĀ;q㗧㗤m;櫈Ābp㘑㘓;櫔;櫖ƀAan㘜㘠㘭rr;懙rĀhr㘦㘨\xeb∮Ā;oਫ਩war;椪lig耻\xdf䃟௡㙑㙝㙠ዎ㙳㙹\x00㙾㛂\x00\x00\x00\x00\x00㛛㜃\x00㜉㝬\x00\x00\x00㞇ɲ㙖\x00\x00㙛get;挖;䏄r\xeb๟ƀaey㙦㙫㙰ron;䅥dil;䅣;䑂lrec;挕r;쀀\ud835\udd31Ȁeiko㚆㚝㚵㚼ǲ㚋\x00㚑eĀ4fኄኁaƀ;sv㚘㚙㚛䎸ym;䏑Ācn㚢㚲kĀas㚨㚮ppro\xf8዁im\xbbኬs\xf0ኞĀas㚺㚮\xf0዁rn耻\xfe䃾Ǭ̟㛆⋧es膀\xd7;bd㛏㛐㛘䃗Ā;aᤏ㛕r;樱;樰ƀeps㛡㛣㜀\xe1⩍Ȁ;bcf҆㛬㛰㛴ot;挶ir;櫱Ā;o㛹㛼쀀\ud835\udd65rk;櫚\xe1㍢rime;怴ƀaip㜏㜒㝤d\xe5ቈ΀adempst㜡㝍㝀㝑㝗㝜㝟ngleʀ;dlqr㜰㜱㜶㝀㝂斵own\xbbᶻeftĀ;e⠀㜾\xf1म;扜ightĀ;e㊪㝋\xf1ၚot;旬inus;樺lus;樹b;槍ime;樻ezium;揢ƀcht㝲㝽㞁Āry㝷㝻;쀀\ud835\udcc9;䑆cy;䑛rok;䅧Āio㞋㞎x\xf4᝷headĀlr㞗㞠eftarro\xf7ࡏightarrow\xbbཝऀAHabcdfghlmoprstuw㟐㟓㟗㟤㟰㟼㠎㠜㠣㠴㡑㡝㡫㢩㣌㣒㣪㣶r\xf2ϭar;楣Ācr㟜㟢ute耻\xfa䃺\xf2ᅐrǣ㟪\x00㟭y;䑞ve;䅭Āiy㟵㟺rc耻\xfb䃻;䑃ƀabh㠃㠆㠋r\xf2Ꭽlac;䅱a\xf2ᏃĀir㠓㠘sht;楾;쀀\ud835\udd32rave耻\xf9䃹š㠧㠱rĀlr㠬㠮\xbbॗ\xbbႃlk;斀Āct㠹㡍ɯ㠿\x00\x00㡊rnĀ;e㡅㡆挜r\xbb㡆op;挏ri;旸Āal㡖㡚cr;䅫肻\xa8͉Āgp㡢㡦on;䅳f;쀀\ud835\udd66̀adhlsuᅋ㡸㡽፲㢑㢠own\xe1ᎳarpoonĀlr㢈㢌ef\xf4㠭igh\xf4㠯iƀ;hl㢙㢚㢜䏅\xbbᏺon\xbb㢚parrows;懈ƀcit㢰㣄㣈ɯ㢶\x00\x00㣁rnĀ;e㢼㢽挝r\xbb㢽op;挎ng;䅯ri;旹cr;쀀\ud835\udccaƀdir㣙㣝㣢ot;拰lde;䅩iĀ;f㜰㣨\xbb᠓Āam㣯㣲r\xf2㢨l耻\xfc䃼angle;榧ހABDacdeflnoprsz㤜㤟㤩㤭㦵㦸㦽㧟㧤㧨㧳㧹㧽㨁㨠r\xf2ϷarĀ;v㤦㤧櫨;櫩as\xe8ϡĀnr㤲㤷grt;榜΀eknprst㓣㥆㥋㥒㥝㥤㦖app\xe1␕othin\xe7ẖƀhir㓫⻈㥙op\xf4⾵Ā;hᎷ㥢\xefㆍĀiu㥩㥭gm\xe1㎳Ābp㥲㦄setneqĀ;q㥽㦀쀀⊊︀;쀀⫋︀setneqĀ;q㦏㦒쀀⊋︀;쀀⫌︀Āhr㦛㦟et\xe1㚜iangleĀlr㦪㦯eft\xbbथight\xbbၑy;䐲ash\xbbံƀelr㧄㧒㧗ƀ;beⷪ㧋㧏ar;抻q;扚lip;拮Ābt㧜ᑨa\xf2ᑩr;쀀\ud835\udd33tr\xe9㦮suĀbp㧯㧱\xbbജ\xbb൙pf;쀀\ud835\udd67ro\xf0໻tr\xe9㦴Ācu㨆㨋r;쀀\ud835\udccbĀbp㨐㨘nĀEe㦀㨖\xbb㥾nĀEe㦒㨞\xbb㦐igzag;榚΀cefoprs㨶㨻㩖㩛㩔㩡㩪irc;䅵Ādi㩀㩑Ābg㩅㩉ar;機eĀ;qᗺ㩏;扙erp;愘r;쀀\ud835\udd34pf;쀀\ud835\udd68Ā;eᑹ㩦at\xe8ᑹcr;쀀\ud835\udcccૣណ㪇\x00㪋\x00㪐㪛\x00\x00㪝㪨㪫㪯\x00\x00㫃㫎\x00㫘ៜ៟tr\xe9៑r;쀀\ud835\udd35ĀAa㪔㪗r\xf2σr\xf2৶;䎾ĀAa㪡㪤r\xf2θr\xf2৫a\xf0✓is;拻ƀdptឤ㪵㪾Āfl㪺ឩ;쀀\ud835\udd69im\xe5ឲĀAa㫇㫊r\xf2ώr\xf2ਁĀcq㫒ីr;쀀\ud835\udccdĀpt៖㫜r\xe9។Ѐacefiosu㫰㫽㬈㬌㬑㬕㬛㬡cĀuy㫶㫻te耻\xfd䃽;䑏Āiy㬂㬆rc;䅷;䑋n耻\xa5䂥r;쀀\ud835\udd36cy;䑗pf;쀀\ud835\udd6acr;쀀\ud835\udcceĀcm㬦㬩y;䑎l耻\xff䃿Ԁacdefhiosw㭂㭈㭔㭘㭤㭩㭭㭴㭺㮀cute;䅺Āay㭍㭒ron;䅾;䐷ot;䅼Āet㭝㭡tr\xe6ᕟa;䎶r;쀀\ud835\udd37cy;䐶grarr;懝pf;쀀\ud835\udd6bcr;쀀\ud835\udccfĀjn㮅㮇;怍j;怌'.split("").map((c)=>c.charCodeAt(0)));

});

parcelRequire.register("9zLKC", function(module, exports) {

$parcel$export(module.exports, "default", () => $6f8c6c4ba36827d9$export$2e2bcd8739ae039);
// Generated using scripts/write-decode-map.ts
var $6f8c6c4ba36827d9$export$2e2bcd8739ae039 = new Uint16Array(// prettier-ignore
"Ȁaglq	\x15\x18\x1bɭ\x0f\x00\x00\x12p;䀦os;䀧t;䀾t;䀼uot;䀢".split("").map((c)=>c.charCodeAt(0)));

});

parcelRequire.register("9gkGz", function(module, exports) {

$parcel$export(module.exports, "fromCodePoint", () => $6be5a763d403d4d6$export$73bfc63873071f74);
$parcel$export(module.exports, "replaceCodePoint", () => $6be5a763d403d4d6$export$b978ab756102108a);
// Adapted from https://github.com/mathiasbynens/he/blob/36afe179392226cf1b6ccdb16ebbb7a5a844d93a/src/he.js#L106-L134
var $6be5a763d403d4d6$var$_a;
const $6be5a763d403d4d6$var$decodeMap = new Map([
    [
        0,
        65533
    ],
    // C1 Unicode control character reference replacements
    [
        128,
        8364
    ],
    [
        130,
        8218
    ],
    [
        131,
        402
    ],
    [
        132,
        8222
    ],
    [
        133,
        8230
    ],
    [
        134,
        8224
    ],
    [
        135,
        8225
    ],
    [
        136,
        710
    ],
    [
        137,
        8240
    ],
    [
        138,
        352
    ],
    [
        139,
        8249
    ],
    [
        140,
        338
    ],
    [
        142,
        381
    ],
    [
        145,
        8216
    ],
    [
        146,
        8217
    ],
    [
        147,
        8220
    ],
    [
        148,
        8221
    ],
    [
        149,
        8226
    ],
    [
        150,
        8211
    ],
    [
        151,
        8212
    ],
    [
        152,
        732
    ],
    [
        153,
        8482
    ],
    [
        154,
        353
    ],
    [
        155,
        8250
    ],
    [
        156,
        339
    ],
    [
        158,
        382
    ],
    [
        159,
        376
    ]
]);
const $6be5a763d403d4d6$export$73bfc63873071f74 = // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition, node/no-unsupported-features/es-builtins
($6be5a763d403d4d6$var$_a = String.fromCodePoint) !== null && $6be5a763d403d4d6$var$_a !== void 0 ? $6be5a763d403d4d6$var$_a : function(codePoint) {
    let output = "";
    if (codePoint > 0xffff) {
        codePoint -= 0x10000;
        output += String.fromCharCode(codePoint >>> 10 & 0x3ff | 0xd800);
        codePoint = 0xdc00 | codePoint & 0x3ff;
    }
    output += String.fromCharCode(codePoint);
    return output;
};
function $6be5a763d403d4d6$export$b978ab756102108a(codePoint) {
    var _a;
    if (codePoint >= 0xd800 && codePoint <= 0xdfff || codePoint > 0x10ffff) return 0xfffd;
    return (_a = $6be5a763d403d4d6$var$decodeMap.get(codePoint)) !== null && _a !== void 0 ? _a : codePoint;
}
function $6be5a763d403d4d6$export$2e2bcd8739ae039(codePoint) {
    return $6be5a763d403d4d6$export$73bfc63873071f74($6be5a763d403d4d6$export$b978ab756102108a(codePoint));
}

});


parcelRequire.register("5Mfgh", function(module, exports) {

$parcel$export(module.exports, "encodeHTML", () => $434d461784065ca0$export$f9d6449b9af28dc1);
$parcel$export(module.exports, "encodeNonAsciiHTML", () => $434d461784065ca0$export$e6e86c76506f1190);

var $iYidq = parcelRequire("iYidq");

var $iwskN = parcelRequire("iwskN");
const $434d461784065ca0$var$htmlReplacer = /[\t\n!-,./:-@[-`\f{-}$\x80-\uFFFF]/g;
function $434d461784065ca0$export$f9d6449b9af28dc1(data) {
    return $434d461784065ca0$var$encodeHTMLTrieRe($434d461784065ca0$var$htmlReplacer, data);
}
function $434d461784065ca0$export$e6e86c76506f1190(data) {
    return $434d461784065ca0$var$encodeHTMLTrieRe((0, $iwskN.xmlReplacer), data);
}
function $434d461784065ca0$var$encodeHTMLTrieRe(regExp, str) {
    let ret = "";
    let lastIdx = 0;
    let match;
    while((match = regExp.exec(str)) !== null){
        const i = match.index;
        ret += str.substring(lastIdx, i);
        const char = str.charCodeAt(i);
        let next = (0, $iYidq.default).get(char);
        if (typeof next === "object") {
            // We are in a branch. Try to match the next char.
            if (i + 1 < str.length) {
                const nextChar = str.charCodeAt(i + 1);
                const value = typeof next.n === "number" ? next.n === nextChar ? next.o : undefined : next.n.get(nextChar);
                if (value !== undefined) {
                    ret += value;
                    lastIdx = regExp.lastIndex += 1;
                    continue;
                }
            }
            next = next.v;
        }
        // We might have a tree node without a value; skip and use a numeric entity.
        if (next !== undefined) {
            ret += next;
            lastIdx = i + 1;
        } else {
            const cp = (0, $iwskN.getCodePoint)(str, i);
            ret += `&#x${cp.toString(16)};`;
            // Increase by 1 if we have a surrogate pair
            lastIdx = regExp.lastIndex += Number(cp !== char);
        }
    }
    return ret + str.substr(lastIdx);
}

});
parcelRequire.register("iYidq", function(module, exports) {

$parcel$export(module.exports, "default", () => $dcfbf5d0b477e0f3$export$2e2bcd8739ae039);
// Generated using scripts/write-encode-map.ts
function $dcfbf5d0b477e0f3$var$restoreDiff(arr) {
    for(let i = 1; i < arr.length; i++)arr[i][0] += arr[i - 1][0] + 1;
    return arr;
}
var // prettier-ignore
$dcfbf5d0b477e0f3$export$2e2bcd8739ae039 = new Map(/* #__PURE__ */ $dcfbf5d0b477e0f3$var$restoreDiff([
    [
        9,
        "&Tab;"
    ],
    [
        0,
        "&NewLine;"
    ],
    [
        22,
        "&excl;"
    ],
    [
        0,
        "&quot;"
    ],
    [
        0,
        "&num;"
    ],
    [
        0,
        "&dollar;"
    ],
    [
        0,
        "&percnt;"
    ],
    [
        0,
        "&amp;"
    ],
    [
        0,
        "&apos;"
    ],
    [
        0,
        "&lpar;"
    ],
    [
        0,
        "&rpar;"
    ],
    [
        0,
        "&ast;"
    ],
    [
        0,
        "&plus;"
    ],
    [
        0,
        "&comma;"
    ],
    [
        1,
        "&period;"
    ],
    [
        0,
        "&sol;"
    ],
    [
        10,
        "&colon;"
    ],
    [
        0,
        "&semi;"
    ],
    [
        0,
        {
            v: "&lt;",
            n: 8402,
            o: "&nvlt;"
        }
    ],
    [
        0,
        {
            v: "&equals;",
            n: 8421,
            o: "&bne;"
        }
    ],
    [
        0,
        {
            v: "&gt;",
            n: 8402,
            o: "&nvgt;"
        }
    ],
    [
        0,
        "&quest;"
    ],
    [
        0,
        "&commat;"
    ],
    [
        26,
        "&lbrack;"
    ],
    [
        0,
        "&bsol;"
    ],
    [
        0,
        "&rbrack;"
    ],
    [
        0,
        "&Hat;"
    ],
    [
        0,
        "&lowbar;"
    ],
    [
        0,
        "&DiacriticalGrave;"
    ],
    [
        5,
        {
            n: 106,
            o: "&fjlig;"
        }
    ],
    [
        20,
        "&lbrace;"
    ],
    [
        0,
        "&verbar;"
    ],
    [
        0,
        "&rbrace;"
    ],
    [
        34,
        "&nbsp;"
    ],
    [
        0,
        "&iexcl;"
    ],
    [
        0,
        "&cent;"
    ],
    [
        0,
        "&pound;"
    ],
    [
        0,
        "&curren;"
    ],
    [
        0,
        "&yen;"
    ],
    [
        0,
        "&brvbar;"
    ],
    [
        0,
        "&sect;"
    ],
    [
        0,
        "&die;"
    ],
    [
        0,
        "&copy;"
    ],
    [
        0,
        "&ordf;"
    ],
    [
        0,
        "&laquo;"
    ],
    [
        0,
        "&not;"
    ],
    [
        0,
        "&shy;"
    ],
    [
        0,
        "&circledR;"
    ],
    [
        0,
        "&macr;"
    ],
    [
        0,
        "&deg;"
    ],
    [
        0,
        "&PlusMinus;"
    ],
    [
        0,
        "&sup2;"
    ],
    [
        0,
        "&sup3;"
    ],
    [
        0,
        "&acute;"
    ],
    [
        0,
        "&micro;"
    ],
    [
        0,
        "&para;"
    ],
    [
        0,
        "&centerdot;"
    ],
    [
        0,
        "&cedil;"
    ],
    [
        0,
        "&sup1;"
    ],
    [
        0,
        "&ordm;"
    ],
    [
        0,
        "&raquo;"
    ],
    [
        0,
        "&frac14;"
    ],
    [
        0,
        "&frac12;"
    ],
    [
        0,
        "&frac34;"
    ],
    [
        0,
        "&iquest;"
    ],
    [
        0,
        "&Agrave;"
    ],
    [
        0,
        "&Aacute;"
    ],
    [
        0,
        "&Acirc;"
    ],
    [
        0,
        "&Atilde;"
    ],
    [
        0,
        "&Auml;"
    ],
    [
        0,
        "&angst;"
    ],
    [
        0,
        "&AElig;"
    ],
    [
        0,
        "&Ccedil;"
    ],
    [
        0,
        "&Egrave;"
    ],
    [
        0,
        "&Eacute;"
    ],
    [
        0,
        "&Ecirc;"
    ],
    [
        0,
        "&Euml;"
    ],
    [
        0,
        "&Igrave;"
    ],
    [
        0,
        "&Iacute;"
    ],
    [
        0,
        "&Icirc;"
    ],
    [
        0,
        "&Iuml;"
    ],
    [
        0,
        "&ETH;"
    ],
    [
        0,
        "&Ntilde;"
    ],
    [
        0,
        "&Ograve;"
    ],
    [
        0,
        "&Oacute;"
    ],
    [
        0,
        "&Ocirc;"
    ],
    [
        0,
        "&Otilde;"
    ],
    [
        0,
        "&Ouml;"
    ],
    [
        0,
        "&times;"
    ],
    [
        0,
        "&Oslash;"
    ],
    [
        0,
        "&Ugrave;"
    ],
    [
        0,
        "&Uacute;"
    ],
    [
        0,
        "&Ucirc;"
    ],
    [
        0,
        "&Uuml;"
    ],
    [
        0,
        "&Yacute;"
    ],
    [
        0,
        "&THORN;"
    ],
    [
        0,
        "&szlig;"
    ],
    [
        0,
        "&agrave;"
    ],
    [
        0,
        "&aacute;"
    ],
    [
        0,
        "&acirc;"
    ],
    [
        0,
        "&atilde;"
    ],
    [
        0,
        "&auml;"
    ],
    [
        0,
        "&aring;"
    ],
    [
        0,
        "&aelig;"
    ],
    [
        0,
        "&ccedil;"
    ],
    [
        0,
        "&egrave;"
    ],
    [
        0,
        "&eacute;"
    ],
    [
        0,
        "&ecirc;"
    ],
    [
        0,
        "&euml;"
    ],
    [
        0,
        "&igrave;"
    ],
    [
        0,
        "&iacute;"
    ],
    [
        0,
        "&icirc;"
    ],
    [
        0,
        "&iuml;"
    ],
    [
        0,
        "&eth;"
    ],
    [
        0,
        "&ntilde;"
    ],
    [
        0,
        "&ograve;"
    ],
    [
        0,
        "&oacute;"
    ],
    [
        0,
        "&ocirc;"
    ],
    [
        0,
        "&otilde;"
    ],
    [
        0,
        "&ouml;"
    ],
    [
        0,
        "&div;"
    ],
    [
        0,
        "&oslash;"
    ],
    [
        0,
        "&ugrave;"
    ],
    [
        0,
        "&uacute;"
    ],
    [
        0,
        "&ucirc;"
    ],
    [
        0,
        "&uuml;"
    ],
    [
        0,
        "&yacute;"
    ],
    [
        0,
        "&thorn;"
    ],
    [
        0,
        "&yuml;"
    ],
    [
        0,
        "&Amacr;"
    ],
    [
        0,
        "&amacr;"
    ],
    [
        0,
        "&Abreve;"
    ],
    [
        0,
        "&abreve;"
    ],
    [
        0,
        "&Aogon;"
    ],
    [
        0,
        "&aogon;"
    ],
    [
        0,
        "&Cacute;"
    ],
    [
        0,
        "&cacute;"
    ],
    [
        0,
        "&Ccirc;"
    ],
    [
        0,
        "&ccirc;"
    ],
    [
        0,
        "&Cdot;"
    ],
    [
        0,
        "&cdot;"
    ],
    [
        0,
        "&Ccaron;"
    ],
    [
        0,
        "&ccaron;"
    ],
    [
        0,
        "&Dcaron;"
    ],
    [
        0,
        "&dcaron;"
    ],
    [
        0,
        "&Dstrok;"
    ],
    [
        0,
        "&dstrok;"
    ],
    [
        0,
        "&Emacr;"
    ],
    [
        0,
        "&emacr;"
    ],
    [
        2,
        "&Edot;"
    ],
    [
        0,
        "&edot;"
    ],
    [
        0,
        "&Eogon;"
    ],
    [
        0,
        "&eogon;"
    ],
    [
        0,
        "&Ecaron;"
    ],
    [
        0,
        "&ecaron;"
    ],
    [
        0,
        "&Gcirc;"
    ],
    [
        0,
        "&gcirc;"
    ],
    [
        0,
        "&Gbreve;"
    ],
    [
        0,
        "&gbreve;"
    ],
    [
        0,
        "&Gdot;"
    ],
    [
        0,
        "&gdot;"
    ],
    [
        0,
        "&Gcedil;"
    ],
    [
        1,
        "&Hcirc;"
    ],
    [
        0,
        "&hcirc;"
    ],
    [
        0,
        "&Hstrok;"
    ],
    [
        0,
        "&hstrok;"
    ],
    [
        0,
        "&Itilde;"
    ],
    [
        0,
        "&itilde;"
    ],
    [
        0,
        "&Imacr;"
    ],
    [
        0,
        "&imacr;"
    ],
    [
        2,
        "&Iogon;"
    ],
    [
        0,
        "&iogon;"
    ],
    [
        0,
        "&Idot;"
    ],
    [
        0,
        "&imath;"
    ],
    [
        0,
        "&IJlig;"
    ],
    [
        0,
        "&ijlig;"
    ],
    [
        0,
        "&Jcirc;"
    ],
    [
        0,
        "&jcirc;"
    ],
    [
        0,
        "&Kcedil;"
    ],
    [
        0,
        "&kcedil;"
    ],
    [
        0,
        "&kgreen;"
    ],
    [
        0,
        "&Lacute;"
    ],
    [
        0,
        "&lacute;"
    ],
    [
        0,
        "&Lcedil;"
    ],
    [
        0,
        "&lcedil;"
    ],
    [
        0,
        "&Lcaron;"
    ],
    [
        0,
        "&lcaron;"
    ],
    [
        0,
        "&Lmidot;"
    ],
    [
        0,
        "&lmidot;"
    ],
    [
        0,
        "&Lstrok;"
    ],
    [
        0,
        "&lstrok;"
    ],
    [
        0,
        "&Nacute;"
    ],
    [
        0,
        "&nacute;"
    ],
    [
        0,
        "&Ncedil;"
    ],
    [
        0,
        "&ncedil;"
    ],
    [
        0,
        "&Ncaron;"
    ],
    [
        0,
        "&ncaron;"
    ],
    [
        0,
        "&napos;"
    ],
    [
        0,
        "&ENG;"
    ],
    [
        0,
        "&eng;"
    ],
    [
        0,
        "&Omacr;"
    ],
    [
        0,
        "&omacr;"
    ],
    [
        2,
        "&Odblac;"
    ],
    [
        0,
        "&odblac;"
    ],
    [
        0,
        "&OElig;"
    ],
    [
        0,
        "&oelig;"
    ],
    [
        0,
        "&Racute;"
    ],
    [
        0,
        "&racute;"
    ],
    [
        0,
        "&Rcedil;"
    ],
    [
        0,
        "&rcedil;"
    ],
    [
        0,
        "&Rcaron;"
    ],
    [
        0,
        "&rcaron;"
    ],
    [
        0,
        "&Sacute;"
    ],
    [
        0,
        "&sacute;"
    ],
    [
        0,
        "&Scirc;"
    ],
    [
        0,
        "&scirc;"
    ],
    [
        0,
        "&Scedil;"
    ],
    [
        0,
        "&scedil;"
    ],
    [
        0,
        "&Scaron;"
    ],
    [
        0,
        "&scaron;"
    ],
    [
        0,
        "&Tcedil;"
    ],
    [
        0,
        "&tcedil;"
    ],
    [
        0,
        "&Tcaron;"
    ],
    [
        0,
        "&tcaron;"
    ],
    [
        0,
        "&Tstrok;"
    ],
    [
        0,
        "&tstrok;"
    ],
    [
        0,
        "&Utilde;"
    ],
    [
        0,
        "&utilde;"
    ],
    [
        0,
        "&Umacr;"
    ],
    [
        0,
        "&umacr;"
    ],
    [
        0,
        "&Ubreve;"
    ],
    [
        0,
        "&ubreve;"
    ],
    [
        0,
        "&Uring;"
    ],
    [
        0,
        "&uring;"
    ],
    [
        0,
        "&Udblac;"
    ],
    [
        0,
        "&udblac;"
    ],
    [
        0,
        "&Uogon;"
    ],
    [
        0,
        "&uogon;"
    ],
    [
        0,
        "&Wcirc;"
    ],
    [
        0,
        "&wcirc;"
    ],
    [
        0,
        "&Ycirc;"
    ],
    [
        0,
        "&ycirc;"
    ],
    [
        0,
        "&Yuml;"
    ],
    [
        0,
        "&Zacute;"
    ],
    [
        0,
        "&zacute;"
    ],
    [
        0,
        "&Zdot;"
    ],
    [
        0,
        "&zdot;"
    ],
    [
        0,
        "&Zcaron;"
    ],
    [
        0,
        "&zcaron;"
    ],
    [
        19,
        "&fnof;"
    ],
    [
        34,
        "&imped;"
    ],
    [
        63,
        "&gacute;"
    ],
    [
        65,
        "&jmath;"
    ],
    [
        142,
        "&circ;"
    ],
    [
        0,
        "&caron;"
    ],
    [
        16,
        "&breve;"
    ],
    [
        0,
        "&DiacriticalDot;"
    ],
    [
        0,
        "&ring;"
    ],
    [
        0,
        "&ogon;"
    ],
    [
        0,
        "&DiacriticalTilde;"
    ],
    [
        0,
        "&dblac;"
    ],
    [
        51,
        "&DownBreve;"
    ],
    [
        127,
        "&Alpha;"
    ],
    [
        0,
        "&Beta;"
    ],
    [
        0,
        "&Gamma;"
    ],
    [
        0,
        "&Delta;"
    ],
    [
        0,
        "&Epsilon;"
    ],
    [
        0,
        "&Zeta;"
    ],
    [
        0,
        "&Eta;"
    ],
    [
        0,
        "&Theta;"
    ],
    [
        0,
        "&Iota;"
    ],
    [
        0,
        "&Kappa;"
    ],
    [
        0,
        "&Lambda;"
    ],
    [
        0,
        "&Mu;"
    ],
    [
        0,
        "&Nu;"
    ],
    [
        0,
        "&Xi;"
    ],
    [
        0,
        "&Omicron;"
    ],
    [
        0,
        "&Pi;"
    ],
    [
        0,
        "&Rho;"
    ],
    [
        1,
        "&Sigma;"
    ],
    [
        0,
        "&Tau;"
    ],
    [
        0,
        "&Upsilon;"
    ],
    [
        0,
        "&Phi;"
    ],
    [
        0,
        "&Chi;"
    ],
    [
        0,
        "&Psi;"
    ],
    [
        0,
        "&ohm;"
    ],
    [
        7,
        "&alpha;"
    ],
    [
        0,
        "&beta;"
    ],
    [
        0,
        "&gamma;"
    ],
    [
        0,
        "&delta;"
    ],
    [
        0,
        "&epsi;"
    ],
    [
        0,
        "&zeta;"
    ],
    [
        0,
        "&eta;"
    ],
    [
        0,
        "&theta;"
    ],
    [
        0,
        "&iota;"
    ],
    [
        0,
        "&kappa;"
    ],
    [
        0,
        "&lambda;"
    ],
    [
        0,
        "&mu;"
    ],
    [
        0,
        "&nu;"
    ],
    [
        0,
        "&xi;"
    ],
    [
        0,
        "&omicron;"
    ],
    [
        0,
        "&pi;"
    ],
    [
        0,
        "&rho;"
    ],
    [
        0,
        "&sigmaf;"
    ],
    [
        0,
        "&sigma;"
    ],
    [
        0,
        "&tau;"
    ],
    [
        0,
        "&upsi;"
    ],
    [
        0,
        "&phi;"
    ],
    [
        0,
        "&chi;"
    ],
    [
        0,
        "&psi;"
    ],
    [
        0,
        "&omega;"
    ],
    [
        7,
        "&thetasym;"
    ],
    [
        0,
        "&Upsi;"
    ],
    [
        2,
        "&phiv;"
    ],
    [
        0,
        "&piv;"
    ],
    [
        5,
        "&Gammad;"
    ],
    [
        0,
        "&digamma;"
    ],
    [
        18,
        "&kappav;"
    ],
    [
        0,
        "&rhov;"
    ],
    [
        3,
        "&epsiv;"
    ],
    [
        0,
        "&backepsilon;"
    ],
    [
        10,
        "&IOcy;"
    ],
    [
        0,
        "&DJcy;"
    ],
    [
        0,
        "&GJcy;"
    ],
    [
        0,
        "&Jukcy;"
    ],
    [
        0,
        "&DScy;"
    ],
    [
        0,
        "&Iukcy;"
    ],
    [
        0,
        "&YIcy;"
    ],
    [
        0,
        "&Jsercy;"
    ],
    [
        0,
        "&LJcy;"
    ],
    [
        0,
        "&NJcy;"
    ],
    [
        0,
        "&TSHcy;"
    ],
    [
        0,
        "&KJcy;"
    ],
    [
        1,
        "&Ubrcy;"
    ],
    [
        0,
        "&DZcy;"
    ],
    [
        0,
        "&Acy;"
    ],
    [
        0,
        "&Bcy;"
    ],
    [
        0,
        "&Vcy;"
    ],
    [
        0,
        "&Gcy;"
    ],
    [
        0,
        "&Dcy;"
    ],
    [
        0,
        "&IEcy;"
    ],
    [
        0,
        "&ZHcy;"
    ],
    [
        0,
        "&Zcy;"
    ],
    [
        0,
        "&Icy;"
    ],
    [
        0,
        "&Jcy;"
    ],
    [
        0,
        "&Kcy;"
    ],
    [
        0,
        "&Lcy;"
    ],
    [
        0,
        "&Mcy;"
    ],
    [
        0,
        "&Ncy;"
    ],
    [
        0,
        "&Ocy;"
    ],
    [
        0,
        "&Pcy;"
    ],
    [
        0,
        "&Rcy;"
    ],
    [
        0,
        "&Scy;"
    ],
    [
        0,
        "&Tcy;"
    ],
    [
        0,
        "&Ucy;"
    ],
    [
        0,
        "&Fcy;"
    ],
    [
        0,
        "&KHcy;"
    ],
    [
        0,
        "&TScy;"
    ],
    [
        0,
        "&CHcy;"
    ],
    [
        0,
        "&SHcy;"
    ],
    [
        0,
        "&SHCHcy;"
    ],
    [
        0,
        "&HARDcy;"
    ],
    [
        0,
        "&Ycy;"
    ],
    [
        0,
        "&SOFTcy;"
    ],
    [
        0,
        "&Ecy;"
    ],
    [
        0,
        "&YUcy;"
    ],
    [
        0,
        "&YAcy;"
    ],
    [
        0,
        "&acy;"
    ],
    [
        0,
        "&bcy;"
    ],
    [
        0,
        "&vcy;"
    ],
    [
        0,
        "&gcy;"
    ],
    [
        0,
        "&dcy;"
    ],
    [
        0,
        "&iecy;"
    ],
    [
        0,
        "&zhcy;"
    ],
    [
        0,
        "&zcy;"
    ],
    [
        0,
        "&icy;"
    ],
    [
        0,
        "&jcy;"
    ],
    [
        0,
        "&kcy;"
    ],
    [
        0,
        "&lcy;"
    ],
    [
        0,
        "&mcy;"
    ],
    [
        0,
        "&ncy;"
    ],
    [
        0,
        "&ocy;"
    ],
    [
        0,
        "&pcy;"
    ],
    [
        0,
        "&rcy;"
    ],
    [
        0,
        "&scy;"
    ],
    [
        0,
        "&tcy;"
    ],
    [
        0,
        "&ucy;"
    ],
    [
        0,
        "&fcy;"
    ],
    [
        0,
        "&khcy;"
    ],
    [
        0,
        "&tscy;"
    ],
    [
        0,
        "&chcy;"
    ],
    [
        0,
        "&shcy;"
    ],
    [
        0,
        "&shchcy;"
    ],
    [
        0,
        "&hardcy;"
    ],
    [
        0,
        "&ycy;"
    ],
    [
        0,
        "&softcy;"
    ],
    [
        0,
        "&ecy;"
    ],
    [
        0,
        "&yucy;"
    ],
    [
        0,
        "&yacy;"
    ],
    [
        1,
        "&iocy;"
    ],
    [
        0,
        "&djcy;"
    ],
    [
        0,
        "&gjcy;"
    ],
    [
        0,
        "&jukcy;"
    ],
    [
        0,
        "&dscy;"
    ],
    [
        0,
        "&iukcy;"
    ],
    [
        0,
        "&yicy;"
    ],
    [
        0,
        "&jsercy;"
    ],
    [
        0,
        "&ljcy;"
    ],
    [
        0,
        "&njcy;"
    ],
    [
        0,
        "&tshcy;"
    ],
    [
        0,
        "&kjcy;"
    ],
    [
        1,
        "&ubrcy;"
    ],
    [
        0,
        "&dzcy;"
    ],
    [
        7074,
        "&ensp;"
    ],
    [
        0,
        "&emsp;"
    ],
    [
        0,
        "&emsp13;"
    ],
    [
        0,
        "&emsp14;"
    ],
    [
        1,
        "&numsp;"
    ],
    [
        0,
        "&puncsp;"
    ],
    [
        0,
        "&ThinSpace;"
    ],
    [
        0,
        "&hairsp;"
    ],
    [
        0,
        "&NegativeMediumSpace;"
    ],
    [
        0,
        "&zwnj;"
    ],
    [
        0,
        "&zwj;"
    ],
    [
        0,
        "&lrm;"
    ],
    [
        0,
        "&rlm;"
    ],
    [
        0,
        "&dash;"
    ],
    [
        2,
        "&ndash;"
    ],
    [
        0,
        "&mdash;"
    ],
    [
        0,
        "&horbar;"
    ],
    [
        0,
        "&Verbar;"
    ],
    [
        1,
        "&lsquo;"
    ],
    [
        0,
        "&CloseCurlyQuote;"
    ],
    [
        0,
        "&lsquor;"
    ],
    [
        1,
        "&ldquo;"
    ],
    [
        0,
        "&CloseCurlyDoubleQuote;"
    ],
    [
        0,
        "&bdquo;"
    ],
    [
        1,
        "&dagger;"
    ],
    [
        0,
        "&Dagger;"
    ],
    [
        0,
        "&bull;"
    ],
    [
        2,
        "&nldr;"
    ],
    [
        0,
        "&hellip;"
    ],
    [
        9,
        "&permil;"
    ],
    [
        0,
        "&pertenk;"
    ],
    [
        0,
        "&prime;"
    ],
    [
        0,
        "&Prime;"
    ],
    [
        0,
        "&tprime;"
    ],
    [
        0,
        "&backprime;"
    ],
    [
        3,
        "&lsaquo;"
    ],
    [
        0,
        "&rsaquo;"
    ],
    [
        3,
        "&oline;"
    ],
    [
        2,
        "&caret;"
    ],
    [
        1,
        "&hybull;"
    ],
    [
        0,
        "&frasl;"
    ],
    [
        10,
        "&bsemi;"
    ],
    [
        7,
        "&qprime;"
    ],
    [
        7,
        {
            v: "&MediumSpace;",
            n: 8202,
            o: "&ThickSpace;"
        }
    ],
    [
        0,
        "&NoBreak;"
    ],
    [
        0,
        "&af;"
    ],
    [
        0,
        "&InvisibleTimes;"
    ],
    [
        0,
        "&ic;"
    ],
    [
        72,
        "&euro;"
    ],
    [
        46,
        "&tdot;"
    ],
    [
        0,
        "&DotDot;"
    ],
    [
        37,
        "&complexes;"
    ],
    [
        2,
        "&incare;"
    ],
    [
        4,
        "&gscr;"
    ],
    [
        0,
        "&hamilt;"
    ],
    [
        0,
        "&Hfr;"
    ],
    [
        0,
        "&Hopf;"
    ],
    [
        0,
        "&planckh;"
    ],
    [
        0,
        "&hbar;"
    ],
    [
        0,
        "&imagline;"
    ],
    [
        0,
        "&Ifr;"
    ],
    [
        0,
        "&lagran;"
    ],
    [
        0,
        "&ell;"
    ],
    [
        1,
        "&naturals;"
    ],
    [
        0,
        "&numero;"
    ],
    [
        0,
        "&copysr;"
    ],
    [
        0,
        "&weierp;"
    ],
    [
        0,
        "&Popf;"
    ],
    [
        0,
        "&Qopf;"
    ],
    [
        0,
        "&realine;"
    ],
    [
        0,
        "&real;"
    ],
    [
        0,
        "&reals;"
    ],
    [
        0,
        "&rx;"
    ],
    [
        3,
        "&trade;"
    ],
    [
        1,
        "&integers;"
    ],
    [
        2,
        "&mho;"
    ],
    [
        0,
        "&zeetrf;"
    ],
    [
        0,
        "&iiota;"
    ],
    [
        2,
        "&bernou;"
    ],
    [
        0,
        "&Cayleys;"
    ],
    [
        1,
        "&escr;"
    ],
    [
        0,
        "&Escr;"
    ],
    [
        0,
        "&Fouriertrf;"
    ],
    [
        1,
        "&Mellintrf;"
    ],
    [
        0,
        "&order;"
    ],
    [
        0,
        "&alefsym;"
    ],
    [
        0,
        "&beth;"
    ],
    [
        0,
        "&gimel;"
    ],
    [
        0,
        "&daleth;"
    ],
    [
        12,
        "&CapitalDifferentialD;"
    ],
    [
        0,
        "&dd;"
    ],
    [
        0,
        "&ee;"
    ],
    [
        0,
        "&ii;"
    ],
    [
        10,
        "&frac13;"
    ],
    [
        0,
        "&frac23;"
    ],
    [
        0,
        "&frac15;"
    ],
    [
        0,
        "&frac25;"
    ],
    [
        0,
        "&frac35;"
    ],
    [
        0,
        "&frac45;"
    ],
    [
        0,
        "&frac16;"
    ],
    [
        0,
        "&frac56;"
    ],
    [
        0,
        "&frac18;"
    ],
    [
        0,
        "&frac38;"
    ],
    [
        0,
        "&frac58;"
    ],
    [
        0,
        "&frac78;"
    ],
    [
        49,
        "&larr;"
    ],
    [
        0,
        "&ShortUpArrow;"
    ],
    [
        0,
        "&rarr;"
    ],
    [
        0,
        "&darr;"
    ],
    [
        0,
        "&harr;"
    ],
    [
        0,
        "&updownarrow;"
    ],
    [
        0,
        "&nwarr;"
    ],
    [
        0,
        "&nearr;"
    ],
    [
        0,
        "&LowerRightArrow;"
    ],
    [
        0,
        "&LowerLeftArrow;"
    ],
    [
        0,
        "&nlarr;"
    ],
    [
        0,
        "&nrarr;"
    ],
    [
        1,
        {
            v: "&rarrw;",
            n: 824,
            o: "&nrarrw;"
        }
    ],
    [
        0,
        "&Larr;"
    ],
    [
        0,
        "&Uarr;"
    ],
    [
        0,
        "&Rarr;"
    ],
    [
        0,
        "&Darr;"
    ],
    [
        0,
        "&larrtl;"
    ],
    [
        0,
        "&rarrtl;"
    ],
    [
        0,
        "&LeftTeeArrow;"
    ],
    [
        0,
        "&mapstoup;"
    ],
    [
        0,
        "&map;"
    ],
    [
        0,
        "&DownTeeArrow;"
    ],
    [
        1,
        "&hookleftarrow;"
    ],
    [
        0,
        "&hookrightarrow;"
    ],
    [
        0,
        "&larrlp;"
    ],
    [
        0,
        "&looparrowright;"
    ],
    [
        0,
        "&harrw;"
    ],
    [
        0,
        "&nharr;"
    ],
    [
        1,
        "&lsh;"
    ],
    [
        0,
        "&rsh;"
    ],
    [
        0,
        "&ldsh;"
    ],
    [
        0,
        "&rdsh;"
    ],
    [
        1,
        "&crarr;"
    ],
    [
        0,
        "&cularr;"
    ],
    [
        0,
        "&curarr;"
    ],
    [
        2,
        "&circlearrowleft;"
    ],
    [
        0,
        "&circlearrowright;"
    ],
    [
        0,
        "&leftharpoonup;"
    ],
    [
        0,
        "&DownLeftVector;"
    ],
    [
        0,
        "&RightUpVector;"
    ],
    [
        0,
        "&LeftUpVector;"
    ],
    [
        0,
        "&rharu;"
    ],
    [
        0,
        "&DownRightVector;"
    ],
    [
        0,
        "&dharr;"
    ],
    [
        0,
        "&dharl;"
    ],
    [
        0,
        "&RightArrowLeftArrow;"
    ],
    [
        0,
        "&udarr;"
    ],
    [
        0,
        "&LeftArrowRightArrow;"
    ],
    [
        0,
        "&leftleftarrows;"
    ],
    [
        0,
        "&upuparrows;"
    ],
    [
        0,
        "&rightrightarrows;"
    ],
    [
        0,
        "&ddarr;"
    ],
    [
        0,
        "&leftrightharpoons;"
    ],
    [
        0,
        "&Equilibrium;"
    ],
    [
        0,
        "&nlArr;"
    ],
    [
        0,
        "&nhArr;"
    ],
    [
        0,
        "&nrArr;"
    ],
    [
        0,
        "&DoubleLeftArrow;"
    ],
    [
        0,
        "&DoubleUpArrow;"
    ],
    [
        0,
        "&DoubleRightArrow;"
    ],
    [
        0,
        "&dArr;"
    ],
    [
        0,
        "&DoubleLeftRightArrow;"
    ],
    [
        0,
        "&DoubleUpDownArrow;"
    ],
    [
        0,
        "&nwArr;"
    ],
    [
        0,
        "&neArr;"
    ],
    [
        0,
        "&seArr;"
    ],
    [
        0,
        "&swArr;"
    ],
    [
        0,
        "&lAarr;"
    ],
    [
        0,
        "&rAarr;"
    ],
    [
        1,
        "&zigrarr;"
    ],
    [
        6,
        "&larrb;"
    ],
    [
        0,
        "&rarrb;"
    ],
    [
        15,
        "&DownArrowUpArrow;"
    ],
    [
        7,
        "&loarr;"
    ],
    [
        0,
        "&roarr;"
    ],
    [
        0,
        "&hoarr;"
    ],
    [
        0,
        "&forall;"
    ],
    [
        0,
        "&comp;"
    ],
    [
        0,
        {
            v: "&part;",
            n: 824,
            o: "&npart;"
        }
    ],
    [
        0,
        "&exist;"
    ],
    [
        0,
        "&nexist;"
    ],
    [
        0,
        "&empty;"
    ],
    [
        1,
        "&Del;"
    ],
    [
        0,
        "&Element;"
    ],
    [
        0,
        "&NotElement;"
    ],
    [
        1,
        "&ni;"
    ],
    [
        0,
        "&notni;"
    ],
    [
        2,
        "&prod;"
    ],
    [
        0,
        "&coprod;"
    ],
    [
        0,
        "&sum;"
    ],
    [
        0,
        "&minus;"
    ],
    [
        0,
        "&MinusPlus;"
    ],
    [
        0,
        "&dotplus;"
    ],
    [
        1,
        "&Backslash;"
    ],
    [
        0,
        "&lowast;"
    ],
    [
        0,
        "&compfn;"
    ],
    [
        1,
        "&radic;"
    ],
    [
        2,
        "&prop;"
    ],
    [
        0,
        "&infin;"
    ],
    [
        0,
        "&angrt;"
    ],
    [
        0,
        {
            v: "&ang;",
            n: 8402,
            o: "&nang;"
        }
    ],
    [
        0,
        "&angmsd;"
    ],
    [
        0,
        "&angsph;"
    ],
    [
        0,
        "&mid;"
    ],
    [
        0,
        "&nmid;"
    ],
    [
        0,
        "&DoubleVerticalBar;"
    ],
    [
        0,
        "&NotDoubleVerticalBar;"
    ],
    [
        0,
        "&and;"
    ],
    [
        0,
        "&or;"
    ],
    [
        0,
        {
            v: "&cap;",
            n: 65024,
            o: "&caps;"
        }
    ],
    [
        0,
        {
            v: "&cup;",
            n: 65024,
            o: "&cups;"
        }
    ],
    [
        0,
        "&int;"
    ],
    [
        0,
        "&Int;"
    ],
    [
        0,
        "&iiint;"
    ],
    [
        0,
        "&conint;"
    ],
    [
        0,
        "&Conint;"
    ],
    [
        0,
        "&Cconint;"
    ],
    [
        0,
        "&cwint;"
    ],
    [
        0,
        "&ClockwiseContourIntegral;"
    ],
    [
        0,
        "&awconint;"
    ],
    [
        0,
        "&there4;"
    ],
    [
        0,
        "&becaus;"
    ],
    [
        0,
        "&ratio;"
    ],
    [
        0,
        "&Colon;"
    ],
    [
        0,
        "&dotminus;"
    ],
    [
        1,
        "&mDDot;"
    ],
    [
        0,
        "&homtht;"
    ],
    [
        0,
        {
            v: "&sim;",
            n: 8402,
            o: "&nvsim;"
        }
    ],
    [
        0,
        {
            v: "&backsim;",
            n: 817,
            o: "&race;"
        }
    ],
    [
        0,
        {
            v: "&ac;",
            n: 819,
            o: "&acE;"
        }
    ],
    [
        0,
        "&acd;"
    ],
    [
        0,
        "&VerticalTilde;"
    ],
    [
        0,
        "&NotTilde;"
    ],
    [
        0,
        {
            v: "&eqsim;",
            n: 824,
            o: "&nesim;"
        }
    ],
    [
        0,
        "&sime;"
    ],
    [
        0,
        "&NotTildeEqual;"
    ],
    [
        0,
        "&cong;"
    ],
    [
        0,
        "&simne;"
    ],
    [
        0,
        "&ncong;"
    ],
    [
        0,
        "&ap;"
    ],
    [
        0,
        "&nap;"
    ],
    [
        0,
        "&ape;"
    ],
    [
        0,
        {
            v: "&apid;",
            n: 824,
            o: "&napid;"
        }
    ],
    [
        0,
        "&backcong;"
    ],
    [
        0,
        {
            v: "&asympeq;",
            n: 8402,
            o: "&nvap;"
        }
    ],
    [
        0,
        {
            v: "&bump;",
            n: 824,
            o: "&nbump;"
        }
    ],
    [
        0,
        {
            v: "&bumpe;",
            n: 824,
            o: "&nbumpe;"
        }
    ],
    [
        0,
        {
            v: "&doteq;",
            n: 824,
            o: "&nedot;"
        }
    ],
    [
        0,
        "&doteqdot;"
    ],
    [
        0,
        "&efDot;"
    ],
    [
        0,
        "&erDot;"
    ],
    [
        0,
        "&Assign;"
    ],
    [
        0,
        "&ecolon;"
    ],
    [
        0,
        "&ecir;"
    ],
    [
        0,
        "&circeq;"
    ],
    [
        1,
        "&wedgeq;"
    ],
    [
        0,
        "&veeeq;"
    ],
    [
        1,
        "&triangleq;"
    ],
    [
        2,
        "&equest;"
    ],
    [
        0,
        "&ne;"
    ],
    [
        0,
        {
            v: "&Congruent;",
            n: 8421,
            o: "&bnequiv;"
        }
    ],
    [
        0,
        "&nequiv;"
    ],
    [
        1,
        {
            v: "&le;",
            n: 8402,
            o: "&nvle;"
        }
    ],
    [
        0,
        {
            v: "&ge;",
            n: 8402,
            o: "&nvge;"
        }
    ],
    [
        0,
        {
            v: "&lE;",
            n: 824,
            o: "&nlE;"
        }
    ],
    [
        0,
        {
            v: "&gE;",
            n: 824,
            o: "&ngE;"
        }
    ],
    [
        0,
        {
            v: "&lnE;",
            n: 65024,
            o: "&lvertneqq;"
        }
    ],
    [
        0,
        {
            v: "&gnE;",
            n: 65024,
            o: "&gvertneqq;"
        }
    ],
    [
        0,
        {
            v: "&ll;",
            n: new Map(/* #__PURE__ */ $dcfbf5d0b477e0f3$var$restoreDiff([
                [
                    824,
                    "&nLtv;"
                ],
                [
                    7577,
                    "&nLt;"
                ]
            ]))
        }
    ],
    [
        0,
        {
            v: "&gg;",
            n: new Map(/* #__PURE__ */ $dcfbf5d0b477e0f3$var$restoreDiff([
                [
                    824,
                    "&nGtv;"
                ],
                [
                    7577,
                    "&nGt;"
                ]
            ]))
        }
    ],
    [
        0,
        "&between;"
    ],
    [
        0,
        "&NotCupCap;"
    ],
    [
        0,
        "&nless;"
    ],
    [
        0,
        "&ngt;"
    ],
    [
        0,
        "&nle;"
    ],
    [
        0,
        "&nge;"
    ],
    [
        0,
        "&lesssim;"
    ],
    [
        0,
        "&GreaterTilde;"
    ],
    [
        0,
        "&nlsim;"
    ],
    [
        0,
        "&ngsim;"
    ],
    [
        0,
        "&LessGreater;"
    ],
    [
        0,
        "&gl;"
    ],
    [
        0,
        "&NotLessGreater;"
    ],
    [
        0,
        "&NotGreaterLess;"
    ],
    [
        0,
        "&pr;"
    ],
    [
        0,
        "&sc;"
    ],
    [
        0,
        "&prcue;"
    ],
    [
        0,
        "&sccue;"
    ],
    [
        0,
        "&PrecedesTilde;"
    ],
    [
        0,
        {
            v: "&scsim;",
            n: 824,
            o: "&NotSucceedsTilde;"
        }
    ],
    [
        0,
        "&NotPrecedes;"
    ],
    [
        0,
        "&NotSucceeds;"
    ],
    [
        0,
        {
            v: "&sub;",
            n: 8402,
            o: "&NotSubset;"
        }
    ],
    [
        0,
        {
            v: "&sup;",
            n: 8402,
            o: "&NotSuperset;"
        }
    ],
    [
        0,
        "&nsub;"
    ],
    [
        0,
        "&nsup;"
    ],
    [
        0,
        "&sube;"
    ],
    [
        0,
        "&supe;"
    ],
    [
        0,
        "&NotSubsetEqual;"
    ],
    [
        0,
        "&NotSupersetEqual;"
    ],
    [
        0,
        {
            v: "&subne;",
            n: 65024,
            o: "&varsubsetneq;"
        }
    ],
    [
        0,
        {
            v: "&supne;",
            n: 65024,
            o: "&varsupsetneq;"
        }
    ],
    [
        1,
        "&cupdot;"
    ],
    [
        0,
        "&UnionPlus;"
    ],
    [
        0,
        {
            v: "&sqsub;",
            n: 824,
            o: "&NotSquareSubset;"
        }
    ],
    [
        0,
        {
            v: "&sqsup;",
            n: 824,
            o: "&NotSquareSuperset;"
        }
    ],
    [
        0,
        "&sqsube;"
    ],
    [
        0,
        "&sqsupe;"
    ],
    [
        0,
        {
            v: "&sqcap;",
            n: 65024,
            o: "&sqcaps;"
        }
    ],
    [
        0,
        {
            v: "&sqcup;",
            n: 65024,
            o: "&sqcups;"
        }
    ],
    [
        0,
        "&CirclePlus;"
    ],
    [
        0,
        "&CircleMinus;"
    ],
    [
        0,
        "&CircleTimes;"
    ],
    [
        0,
        "&osol;"
    ],
    [
        0,
        "&CircleDot;"
    ],
    [
        0,
        "&circledcirc;"
    ],
    [
        0,
        "&circledast;"
    ],
    [
        1,
        "&circleddash;"
    ],
    [
        0,
        "&boxplus;"
    ],
    [
        0,
        "&boxminus;"
    ],
    [
        0,
        "&boxtimes;"
    ],
    [
        0,
        "&dotsquare;"
    ],
    [
        0,
        "&RightTee;"
    ],
    [
        0,
        "&dashv;"
    ],
    [
        0,
        "&DownTee;"
    ],
    [
        0,
        "&bot;"
    ],
    [
        1,
        "&models;"
    ],
    [
        0,
        "&DoubleRightTee;"
    ],
    [
        0,
        "&Vdash;"
    ],
    [
        0,
        "&Vvdash;"
    ],
    [
        0,
        "&VDash;"
    ],
    [
        0,
        "&nvdash;"
    ],
    [
        0,
        "&nvDash;"
    ],
    [
        0,
        "&nVdash;"
    ],
    [
        0,
        "&nVDash;"
    ],
    [
        0,
        "&prurel;"
    ],
    [
        1,
        "&LeftTriangle;"
    ],
    [
        0,
        "&RightTriangle;"
    ],
    [
        0,
        {
            v: "&LeftTriangleEqual;",
            n: 8402,
            o: "&nvltrie;"
        }
    ],
    [
        0,
        {
            v: "&RightTriangleEqual;",
            n: 8402,
            o: "&nvrtrie;"
        }
    ],
    [
        0,
        "&origof;"
    ],
    [
        0,
        "&imof;"
    ],
    [
        0,
        "&multimap;"
    ],
    [
        0,
        "&hercon;"
    ],
    [
        0,
        "&intcal;"
    ],
    [
        0,
        "&veebar;"
    ],
    [
        1,
        "&barvee;"
    ],
    [
        0,
        "&angrtvb;"
    ],
    [
        0,
        "&lrtri;"
    ],
    [
        0,
        "&bigwedge;"
    ],
    [
        0,
        "&bigvee;"
    ],
    [
        0,
        "&bigcap;"
    ],
    [
        0,
        "&bigcup;"
    ],
    [
        0,
        "&diam;"
    ],
    [
        0,
        "&sdot;"
    ],
    [
        0,
        "&sstarf;"
    ],
    [
        0,
        "&divideontimes;"
    ],
    [
        0,
        "&bowtie;"
    ],
    [
        0,
        "&ltimes;"
    ],
    [
        0,
        "&rtimes;"
    ],
    [
        0,
        "&leftthreetimes;"
    ],
    [
        0,
        "&rightthreetimes;"
    ],
    [
        0,
        "&backsimeq;"
    ],
    [
        0,
        "&curlyvee;"
    ],
    [
        0,
        "&curlywedge;"
    ],
    [
        0,
        "&Sub;"
    ],
    [
        0,
        "&Sup;"
    ],
    [
        0,
        "&Cap;"
    ],
    [
        0,
        "&Cup;"
    ],
    [
        0,
        "&fork;"
    ],
    [
        0,
        "&epar;"
    ],
    [
        0,
        "&lessdot;"
    ],
    [
        0,
        "&gtdot;"
    ],
    [
        0,
        {
            v: "&Ll;",
            n: 824,
            o: "&nLl;"
        }
    ],
    [
        0,
        {
            v: "&Gg;",
            n: 824,
            o: "&nGg;"
        }
    ],
    [
        0,
        {
            v: "&leg;",
            n: 65024,
            o: "&lesg;"
        }
    ],
    [
        0,
        {
            v: "&gel;",
            n: 65024,
            o: "&gesl;"
        }
    ],
    [
        2,
        "&cuepr;"
    ],
    [
        0,
        "&cuesc;"
    ],
    [
        0,
        "&NotPrecedesSlantEqual;"
    ],
    [
        0,
        "&NotSucceedsSlantEqual;"
    ],
    [
        0,
        "&NotSquareSubsetEqual;"
    ],
    [
        0,
        "&NotSquareSupersetEqual;"
    ],
    [
        2,
        "&lnsim;"
    ],
    [
        0,
        "&gnsim;"
    ],
    [
        0,
        "&precnsim;"
    ],
    [
        0,
        "&scnsim;"
    ],
    [
        0,
        "&nltri;"
    ],
    [
        0,
        "&NotRightTriangle;"
    ],
    [
        0,
        "&nltrie;"
    ],
    [
        0,
        "&NotRightTriangleEqual;"
    ],
    [
        0,
        "&vellip;"
    ],
    [
        0,
        "&ctdot;"
    ],
    [
        0,
        "&utdot;"
    ],
    [
        0,
        "&dtdot;"
    ],
    [
        0,
        "&disin;"
    ],
    [
        0,
        "&isinsv;"
    ],
    [
        0,
        "&isins;"
    ],
    [
        0,
        {
            v: "&isindot;",
            n: 824,
            o: "&notindot;"
        }
    ],
    [
        0,
        "&notinvc;"
    ],
    [
        0,
        "&notinvb;"
    ],
    [
        1,
        {
            v: "&isinE;",
            n: 824,
            o: "&notinE;"
        }
    ],
    [
        0,
        "&nisd;"
    ],
    [
        0,
        "&xnis;"
    ],
    [
        0,
        "&nis;"
    ],
    [
        0,
        "&notnivc;"
    ],
    [
        0,
        "&notnivb;"
    ],
    [
        6,
        "&barwed;"
    ],
    [
        0,
        "&Barwed;"
    ],
    [
        1,
        "&lceil;"
    ],
    [
        0,
        "&rceil;"
    ],
    [
        0,
        "&LeftFloor;"
    ],
    [
        0,
        "&rfloor;"
    ],
    [
        0,
        "&drcrop;"
    ],
    [
        0,
        "&dlcrop;"
    ],
    [
        0,
        "&urcrop;"
    ],
    [
        0,
        "&ulcrop;"
    ],
    [
        0,
        "&bnot;"
    ],
    [
        1,
        "&profline;"
    ],
    [
        0,
        "&profsurf;"
    ],
    [
        1,
        "&telrec;"
    ],
    [
        0,
        "&target;"
    ],
    [
        5,
        "&ulcorn;"
    ],
    [
        0,
        "&urcorn;"
    ],
    [
        0,
        "&dlcorn;"
    ],
    [
        0,
        "&drcorn;"
    ],
    [
        2,
        "&frown;"
    ],
    [
        0,
        "&smile;"
    ],
    [
        9,
        "&cylcty;"
    ],
    [
        0,
        "&profalar;"
    ],
    [
        7,
        "&topbot;"
    ],
    [
        6,
        "&ovbar;"
    ],
    [
        1,
        "&solbar;"
    ],
    [
        60,
        "&angzarr;"
    ],
    [
        51,
        "&lmoustache;"
    ],
    [
        0,
        "&rmoustache;"
    ],
    [
        2,
        "&OverBracket;"
    ],
    [
        0,
        "&bbrk;"
    ],
    [
        0,
        "&bbrktbrk;"
    ],
    [
        37,
        "&OverParenthesis;"
    ],
    [
        0,
        "&UnderParenthesis;"
    ],
    [
        0,
        "&OverBrace;"
    ],
    [
        0,
        "&UnderBrace;"
    ],
    [
        2,
        "&trpezium;"
    ],
    [
        4,
        "&elinters;"
    ],
    [
        59,
        "&blank;"
    ],
    [
        164,
        "&circledS;"
    ],
    [
        55,
        "&boxh;"
    ],
    [
        1,
        "&boxv;"
    ],
    [
        9,
        "&boxdr;"
    ],
    [
        3,
        "&boxdl;"
    ],
    [
        3,
        "&boxur;"
    ],
    [
        3,
        "&boxul;"
    ],
    [
        3,
        "&boxvr;"
    ],
    [
        7,
        "&boxvl;"
    ],
    [
        7,
        "&boxhd;"
    ],
    [
        7,
        "&boxhu;"
    ],
    [
        7,
        "&boxvh;"
    ],
    [
        19,
        "&boxH;"
    ],
    [
        0,
        "&boxV;"
    ],
    [
        0,
        "&boxdR;"
    ],
    [
        0,
        "&boxDr;"
    ],
    [
        0,
        "&boxDR;"
    ],
    [
        0,
        "&boxdL;"
    ],
    [
        0,
        "&boxDl;"
    ],
    [
        0,
        "&boxDL;"
    ],
    [
        0,
        "&boxuR;"
    ],
    [
        0,
        "&boxUr;"
    ],
    [
        0,
        "&boxUR;"
    ],
    [
        0,
        "&boxuL;"
    ],
    [
        0,
        "&boxUl;"
    ],
    [
        0,
        "&boxUL;"
    ],
    [
        0,
        "&boxvR;"
    ],
    [
        0,
        "&boxVr;"
    ],
    [
        0,
        "&boxVR;"
    ],
    [
        0,
        "&boxvL;"
    ],
    [
        0,
        "&boxVl;"
    ],
    [
        0,
        "&boxVL;"
    ],
    [
        0,
        "&boxHd;"
    ],
    [
        0,
        "&boxhD;"
    ],
    [
        0,
        "&boxHD;"
    ],
    [
        0,
        "&boxHu;"
    ],
    [
        0,
        "&boxhU;"
    ],
    [
        0,
        "&boxHU;"
    ],
    [
        0,
        "&boxvH;"
    ],
    [
        0,
        "&boxVh;"
    ],
    [
        0,
        "&boxVH;"
    ],
    [
        19,
        "&uhblk;"
    ],
    [
        3,
        "&lhblk;"
    ],
    [
        3,
        "&block;"
    ],
    [
        8,
        "&blk14;"
    ],
    [
        0,
        "&blk12;"
    ],
    [
        0,
        "&blk34;"
    ],
    [
        13,
        "&square;"
    ],
    [
        8,
        "&blacksquare;"
    ],
    [
        0,
        "&EmptyVerySmallSquare;"
    ],
    [
        1,
        "&rect;"
    ],
    [
        0,
        "&marker;"
    ],
    [
        2,
        "&fltns;"
    ],
    [
        1,
        "&bigtriangleup;"
    ],
    [
        0,
        "&blacktriangle;"
    ],
    [
        0,
        "&triangle;"
    ],
    [
        2,
        "&blacktriangleright;"
    ],
    [
        0,
        "&rtri;"
    ],
    [
        3,
        "&bigtriangledown;"
    ],
    [
        0,
        "&blacktriangledown;"
    ],
    [
        0,
        "&dtri;"
    ],
    [
        2,
        "&blacktriangleleft;"
    ],
    [
        0,
        "&ltri;"
    ],
    [
        6,
        "&loz;"
    ],
    [
        0,
        "&cir;"
    ],
    [
        32,
        "&tridot;"
    ],
    [
        2,
        "&bigcirc;"
    ],
    [
        8,
        "&ultri;"
    ],
    [
        0,
        "&urtri;"
    ],
    [
        0,
        "&lltri;"
    ],
    [
        0,
        "&EmptySmallSquare;"
    ],
    [
        0,
        "&FilledSmallSquare;"
    ],
    [
        8,
        "&bigstar;"
    ],
    [
        0,
        "&star;"
    ],
    [
        7,
        "&phone;"
    ],
    [
        49,
        "&female;"
    ],
    [
        1,
        "&male;"
    ],
    [
        29,
        "&spades;"
    ],
    [
        2,
        "&clubs;"
    ],
    [
        1,
        "&hearts;"
    ],
    [
        0,
        "&diamondsuit;"
    ],
    [
        3,
        "&sung;"
    ],
    [
        2,
        "&flat;"
    ],
    [
        0,
        "&natural;"
    ],
    [
        0,
        "&sharp;"
    ],
    [
        163,
        "&check;"
    ],
    [
        3,
        "&cross;"
    ],
    [
        8,
        "&malt;"
    ],
    [
        21,
        "&sext;"
    ],
    [
        33,
        "&VerticalSeparator;"
    ],
    [
        25,
        "&lbbrk;"
    ],
    [
        0,
        "&rbbrk;"
    ],
    [
        84,
        "&bsolhsub;"
    ],
    [
        0,
        "&suphsol;"
    ],
    [
        28,
        "&LeftDoubleBracket;"
    ],
    [
        0,
        "&RightDoubleBracket;"
    ],
    [
        0,
        "&lang;"
    ],
    [
        0,
        "&rang;"
    ],
    [
        0,
        "&Lang;"
    ],
    [
        0,
        "&Rang;"
    ],
    [
        0,
        "&loang;"
    ],
    [
        0,
        "&roang;"
    ],
    [
        7,
        "&longleftarrow;"
    ],
    [
        0,
        "&longrightarrow;"
    ],
    [
        0,
        "&longleftrightarrow;"
    ],
    [
        0,
        "&DoubleLongLeftArrow;"
    ],
    [
        0,
        "&DoubleLongRightArrow;"
    ],
    [
        0,
        "&DoubleLongLeftRightArrow;"
    ],
    [
        1,
        "&longmapsto;"
    ],
    [
        2,
        "&dzigrarr;"
    ],
    [
        258,
        "&nvlArr;"
    ],
    [
        0,
        "&nvrArr;"
    ],
    [
        0,
        "&nvHarr;"
    ],
    [
        0,
        "&Map;"
    ],
    [
        6,
        "&lbarr;"
    ],
    [
        0,
        "&bkarow;"
    ],
    [
        0,
        "&lBarr;"
    ],
    [
        0,
        "&dbkarow;"
    ],
    [
        0,
        "&drbkarow;"
    ],
    [
        0,
        "&DDotrahd;"
    ],
    [
        0,
        "&UpArrowBar;"
    ],
    [
        0,
        "&DownArrowBar;"
    ],
    [
        2,
        "&Rarrtl;"
    ],
    [
        2,
        "&latail;"
    ],
    [
        0,
        "&ratail;"
    ],
    [
        0,
        "&lAtail;"
    ],
    [
        0,
        "&rAtail;"
    ],
    [
        0,
        "&larrfs;"
    ],
    [
        0,
        "&rarrfs;"
    ],
    [
        0,
        "&larrbfs;"
    ],
    [
        0,
        "&rarrbfs;"
    ],
    [
        2,
        "&nwarhk;"
    ],
    [
        0,
        "&nearhk;"
    ],
    [
        0,
        "&hksearow;"
    ],
    [
        0,
        "&hkswarow;"
    ],
    [
        0,
        "&nwnear;"
    ],
    [
        0,
        "&nesear;"
    ],
    [
        0,
        "&seswar;"
    ],
    [
        0,
        "&swnwar;"
    ],
    [
        8,
        {
            v: "&rarrc;",
            n: 824,
            o: "&nrarrc;"
        }
    ],
    [
        1,
        "&cudarrr;"
    ],
    [
        0,
        "&ldca;"
    ],
    [
        0,
        "&rdca;"
    ],
    [
        0,
        "&cudarrl;"
    ],
    [
        0,
        "&larrpl;"
    ],
    [
        2,
        "&curarrm;"
    ],
    [
        0,
        "&cularrp;"
    ],
    [
        7,
        "&rarrpl;"
    ],
    [
        2,
        "&harrcir;"
    ],
    [
        0,
        "&Uarrocir;"
    ],
    [
        0,
        "&lurdshar;"
    ],
    [
        0,
        "&ldrushar;"
    ],
    [
        2,
        "&LeftRightVector;"
    ],
    [
        0,
        "&RightUpDownVector;"
    ],
    [
        0,
        "&DownLeftRightVector;"
    ],
    [
        0,
        "&LeftUpDownVector;"
    ],
    [
        0,
        "&LeftVectorBar;"
    ],
    [
        0,
        "&RightVectorBar;"
    ],
    [
        0,
        "&RightUpVectorBar;"
    ],
    [
        0,
        "&RightDownVectorBar;"
    ],
    [
        0,
        "&DownLeftVectorBar;"
    ],
    [
        0,
        "&DownRightVectorBar;"
    ],
    [
        0,
        "&LeftUpVectorBar;"
    ],
    [
        0,
        "&LeftDownVectorBar;"
    ],
    [
        0,
        "&LeftTeeVector;"
    ],
    [
        0,
        "&RightTeeVector;"
    ],
    [
        0,
        "&RightUpTeeVector;"
    ],
    [
        0,
        "&RightDownTeeVector;"
    ],
    [
        0,
        "&DownLeftTeeVector;"
    ],
    [
        0,
        "&DownRightTeeVector;"
    ],
    [
        0,
        "&LeftUpTeeVector;"
    ],
    [
        0,
        "&LeftDownTeeVector;"
    ],
    [
        0,
        "&lHar;"
    ],
    [
        0,
        "&uHar;"
    ],
    [
        0,
        "&rHar;"
    ],
    [
        0,
        "&dHar;"
    ],
    [
        0,
        "&luruhar;"
    ],
    [
        0,
        "&ldrdhar;"
    ],
    [
        0,
        "&ruluhar;"
    ],
    [
        0,
        "&rdldhar;"
    ],
    [
        0,
        "&lharul;"
    ],
    [
        0,
        "&llhard;"
    ],
    [
        0,
        "&rharul;"
    ],
    [
        0,
        "&lrhard;"
    ],
    [
        0,
        "&udhar;"
    ],
    [
        0,
        "&duhar;"
    ],
    [
        0,
        "&RoundImplies;"
    ],
    [
        0,
        "&erarr;"
    ],
    [
        0,
        "&simrarr;"
    ],
    [
        0,
        "&larrsim;"
    ],
    [
        0,
        "&rarrsim;"
    ],
    [
        0,
        "&rarrap;"
    ],
    [
        0,
        "&ltlarr;"
    ],
    [
        1,
        "&gtrarr;"
    ],
    [
        0,
        "&subrarr;"
    ],
    [
        1,
        "&suplarr;"
    ],
    [
        0,
        "&lfisht;"
    ],
    [
        0,
        "&rfisht;"
    ],
    [
        0,
        "&ufisht;"
    ],
    [
        0,
        "&dfisht;"
    ],
    [
        5,
        "&lopar;"
    ],
    [
        0,
        "&ropar;"
    ],
    [
        4,
        "&lbrke;"
    ],
    [
        0,
        "&rbrke;"
    ],
    [
        0,
        "&lbrkslu;"
    ],
    [
        0,
        "&rbrksld;"
    ],
    [
        0,
        "&lbrksld;"
    ],
    [
        0,
        "&rbrkslu;"
    ],
    [
        0,
        "&langd;"
    ],
    [
        0,
        "&rangd;"
    ],
    [
        0,
        "&lparlt;"
    ],
    [
        0,
        "&rpargt;"
    ],
    [
        0,
        "&gtlPar;"
    ],
    [
        0,
        "&ltrPar;"
    ],
    [
        3,
        "&vzigzag;"
    ],
    [
        1,
        "&vangrt;"
    ],
    [
        0,
        "&angrtvbd;"
    ],
    [
        6,
        "&ange;"
    ],
    [
        0,
        "&range;"
    ],
    [
        0,
        "&dwangle;"
    ],
    [
        0,
        "&uwangle;"
    ],
    [
        0,
        "&angmsdaa;"
    ],
    [
        0,
        "&angmsdab;"
    ],
    [
        0,
        "&angmsdac;"
    ],
    [
        0,
        "&angmsdad;"
    ],
    [
        0,
        "&angmsdae;"
    ],
    [
        0,
        "&angmsdaf;"
    ],
    [
        0,
        "&angmsdag;"
    ],
    [
        0,
        "&angmsdah;"
    ],
    [
        0,
        "&bemptyv;"
    ],
    [
        0,
        "&demptyv;"
    ],
    [
        0,
        "&cemptyv;"
    ],
    [
        0,
        "&raemptyv;"
    ],
    [
        0,
        "&laemptyv;"
    ],
    [
        0,
        "&ohbar;"
    ],
    [
        0,
        "&omid;"
    ],
    [
        0,
        "&opar;"
    ],
    [
        1,
        "&operp;"
    ],
    [
        1,
        "&olcross;"
    ],
    [
        0,
        "&odsold;"
    ],
    [
        1,
        "&olcir;"
    ],
    [
        0,
        "&ofcir;"
    ],
    [
        0,
        "&olt;"
    ],
    [
        0,
        "&ogt;"
    ],
    [
        0,
        "&cirscir;"
    ],
    [
        0,
        "&cirE;"
    ],
    [
        0,
        "&solb;"
    ],
    [
        0,
        "&bsolb;"
    ],
    [
        3,
        "&boxbox;"
    ],
    [
        3,
        "&trisb;"
    ],
    [
        0,
        "&rtriltri;"
    ],
    [
        0,
        {
            v: "&LeftTriangleBar;",
            n: 824,
            o: "&NotLeftTriangleBar;"
        }
    ],
    [
        0,
        {
            v: "&RightTriangleBar;",
            n: 824,
            o: "&NotRightTriangleBar;"
        }
    ],
    [
        11,
        "&iinfin;"
    ],
    [
        0,
        "&infintie;"
    ],
    [
        0,
        "&nvinfin;"
    ],
    [
        4,
        "&eparsl;"
    ],
    [
        0,
        "&smeparsl;"
    ],
    [
        0,
        "&eqvparsl;"
    ],
    [
        5,
        "&blacklozenge;"
    ],
    [
        8,
        "&RuleDelayed;"
    ],
    [
        1,
        "&dsol;"
    ],
    [
        9,
        "&bigodot;"
    ],
    [
        0,
        "&bigoplus;"
    ],
    [
        0,
        "&bigotimes;"
    ],
    [
        1,
        "&biguplus;"
    ],
    [
        1,
        "&bigsqcup;"
    ],
    [
        5,
        "&iiiint;"
    ],
    [
        0,
        "&fpartint;"
    ],
    [
        2,
        "&cirfnint;"
    ],
    [
        0,
        "&awint;"
    ],
    [
        0,
        "&rppolint;"
    ],
    [
        0,
        "&scpolint;"
    ],
    [
        0,
        "&npolint;"
    ],
    [
        0,
        "&pointint;"
    ],
    [
        0,
        "&quatint;"
    ],
    [
        0,
        "&intlarhk;"
    ],
    [
        10,
        "&pluscir;"
    ],
    [
        0,
        "&plusacir;"
    ],
    [
        0,
        "&simplus;"
    ],
    [
        0,
        "&plusdu;"
    ],
    [
        0,
        "&plussim;"
    ],
    [
        0,
        "&plustwo;"
    ],
    [
        1,
        "&mcomma;"
    ],
    [
        0,
        "&minusdu;"
    ],
    [
        2,
        "&loplus;"
    ],
    [
        0,
        "&roplus;"
    ],
    [
        0,
        "&Cross;"
    ],
    [
        0,
        "&timesd;"
    ],
    [
        0,
        "&timesbar;"
    ],
    [
        1,
        "&smashp;"
    ],
    [
        0,
        "&lotimes;"
    ],
    [
        0,
        "&rotimes;"
    ],
    [
        0,
        "&otimesas;"
    ],
    [
        0,
        "&Otimes;"
    ],
    [
        0,
        "&odiv;"
    ],
    [
        0,
        "&triplus;"
    ],
    [
        0,
        "&triminus;"
    ],
    [
        0,
        "&tritime;"
    ],
    [
        0,
        "&intprod;"
    ],
    [
        2,
        "&amalg;"
    ],
    [
        0,
        "&capdot;"
    ],
    [
        1,
        "&ncup;"
    ],
    [
        0,
        "&ncap;"
    ],
    [
        0,
        "&capand;"
    ],
    [
        0,
        "&cupor;"
    ],
    [
        0,
        "&cupcap;"
    ],
    [
        0,
        "&capcup;"
    ],
    [
        0,
        "&cupbrcap;"
    ],
    [
        0,
        "&capbrcup;"
    ],
    [
        0,
        "&cupcup;"
    ],
    [
        0,
        "&capcap;"
    ],
    [
        0,
        "&ccups;"
    ],
    [
        0,
        "&ccaps;"
    ],
    [
        2,
        "&ccupssm;"
    ],
    [
        2,
        "&And;"
    ],
    [
        0,
        "&Or;"
    ],
    [
        0,
        "&andand;"
    ],
    [
        0,
        "&oror;"
    ],
    [
        0,
        "&orslope;"
    ],
    [
        0,
        "&andslope;"
    ],
    [
        1,
        "&andv;"
    ],
    [
        0,
        "&orv;"
    ],
    [
        0,
        "&andd;"
    ],
    [
        0,
        "&ord;"
    ],
    [
        1,
        "&wedbar;"
    ],
    [
        6,
        "&sdote;"
    ],
    [
        3,
        "&simdot;"
    ],
    [
        2,
        {
            v: "&congdot;",
            n: 824,
            o: "&ncongdot;"
        }
    ],
    [
        0,
        "&easter;"
    ],
    [
        0,
        "&apacir;"
    ],
    [
        0,
        {
            v: "&apE;",
            n: 824,
            o: "&napE;"
        }
    ],
    [
        0,
        "&eplus;"
    ],
    [
        0,
        "&pluse;"
    ],
    [
        0,
        "&Esim;"
    ],
    [
        0,
        "&Colone;"
    ],
    [
        0,
        "&Equal;"
    ],
    [
        1,
        "&ddotseq;"
    ],
    [
        0,
        "&equivDD;"
    ],
    [
        0,
        "&ltcir;"
    ],
    [
        0,
        "&gtcir;"
    ],
    [
        0,
        "&ltquest;"
    ],
    [
        0,
        "&gtquest;"
    ],
    [
        0,
        {
            v: "&leqslant;",
            n: 824,
            o: "&nleqslant;"
        }
    ],
    [
        0,
        {
            v: "&geqslant;",
            n: 824,
            o: "&ngeqslant;"
        }
    ],
    [
        0,
        "&lesdot;"
    ],
    [
        0,
        "&gesdot;"
    ],
    [
        0,
        "&lesdoto;"
    ],
    [
        0,
        "&gesdoto;"
    ],
    [
        0,
        "&lesdotor;"
    ],
    [
        0,
        "&gesdotol;"
    ],
    [
        0,
        "&lap;"
    ],
    [
        0,
        "&gap;"
    ],
    [
        0,
        "&lne;"
    ],
    [
        0,
        "&gne;"
    ],
    [
        0,
        "&lnap;"
    ],
    [
        0,
        "&gnap;"
    ],
    [
        0,
        "&lEg;"
    ],
    [
        0,
        "&gEl;"
    ],
    [
        0,
        "&lsime;"
    ],
    [
        0,
        "&gsime;"
    ],
    [
        0,
        "&lsimg;"
    ],
    [
        0,
        "&gsiml;"
    ],
    [
        0,
        "&lgE;"
    ],
    [
        0,
        "&glE;"
    ],
    [
        0,
        "&lesges;"
    ],
    [
        0,
        "&gesles;"
    ],
    [
        0,
        "&els;"
    ],
    [
        0,
        "&egs;"
    ],
    [
        0,
        "&elsdot;"
    ],
    [
        0,
        "&egsdot;"
    ],
    [
        0,
        "&el;"
    ],
    [
        0,
        "&eg;"
    ],
    [
        2,
        "&siml;"
    ],
    [
        0,
        "&simg;"
    ],
    [
        0,
        "&simlE;"
    ],
    [
        0,
        "&simgE;"
    ],
    [
        0,
        {
            v: "&LessLess;",
            n: 824,
            o: "&NotNestedLessLess;"
        }
    ],
    [
        0,
        {
            v: "&GreaterGreater;",
            n: 824,
            o: "&NotNestedGreaterGreater;"
        }
    ],
    [
        1,
        "&glj;"
    ],
    [
        0,
        "&gla;"
    ],
    [
        0,
        "&ltcc;"
    ],
    [
        0,
        "&gtcc;"
    ],
    [
        0,
        "&lescc;"
    ],
    [
        0,
        "&gescc;"
    ],
    [
        0,
        "&smt;"
    ],
    [
        0,
        "&lat;"
    ],
    [
        0,
        {
            v: "&smte;",
            n: 65024,
            o: "&smtes;"
        }
    ],
    [
        0,
        {
            v: "&late;",
            n: 65024,
            o: "&lates;"
        }
    ],
    [
        0,
        "&bumpE;"
    ],
    [
        0,
        {
            v: "&PrecedesEqual;",
            n: 824,
            o: "&NotPrecedesEqual;"
        }
    ],
    [
        0,
        {
            v: "&sce;",
            n: 824,
            o: "&NotSucceedsEqual;"
        }
    ],
    [
        2,
        "&prE;"
    ],
    [
        0,
        "&scE;"
    ],
    [
        0,
        "&precneqq;"
    ],
    [
        0,
        "&scnE;"
    ],
    [
        0,
        "&prap;"
    ],
    [
        0,
        "&scap;"
    ],
    [
        0,
        "&precnapprox;"
    ],
    [
        0,
        "&scnap;"
    ],
    [
        0,
        "&Pr;"
    ],
    [
        0,
        "&Sc;"
    ],
    [
        0,
        "&subdot;"
    ],
    [
        0,
        "&supdot;"
    ],
    [
        0,
        "&subplus;"
    ],
    [
        0,
        "&supplus;"
    ],
    [
        0,
        "&submult;"
    ],
    [
        0,
        "&supmult;"
    ],
    [
        0,
        "&subedot;"
    ],
    [
        0,
        "&supedot;"
    ],
    [
        0,
        {
            v: "&subE;",
            n: 824,
            o: "&nsubE;"
        }
    ],
    [
        0,
        {
            v: "&supE;",
            n: 824,
            o: "&nsupE;"
        }
    ],
    [
        0,
        "&subsim;"
    ],
    [
        0,
        "&supsim;"
    ],
    [
        2,
        {
            v: "&subnE;",
            n: 65024,
            o: "&varsubsetneqq;"
        }
    ],
    [
        0,
        {
            v: "&supnE;",
            n: 65024,
            o: "&varsupsetneqq;"
        }
    ],
    [
        2,
        "&csub;"
    ],
    [
        0,
        "&csup;"
    ],
    [
        0,
        "&csube;"
    ],
    [
        0,
        "&csupe;"
    ],
    [
        0,
        "&subsup;"
    ],
    [
        0,
        "&supsub;"
    ],
    [
        0,
        "&subsub;"
    ],
    [
        0,
        "&supsup;"
    ],
    [
        0,
        "&suphsub;"
    ],
    [
        0,
        "&supdsub;"
    ],
    [
        0,
        "&forkv;"
    ],
    [
        0,
        "&topfork;"
    ],
    [
        0,
        "&mlcp;"
    ],
    [
        8,
        "&Dashv;"
    ],
    [
        1,
        "&Vdashl;"
    ],
    [
        0,
        "&Barv;"
    ],
    [
        0,
        "&vBar;"
    ],
    [
        0,
        "&vBarv;"
    ],
    [
        1,
        "&Vbar;"
    ],
    [
        0,
        "&Not;"
    ],
    [
        0,
        "&bNot;"
    ],
    [
        0,
        "&rnmid;"
    ],
    [
        0,
        "&cirmid;"
    ],
    [
        0,
        "&midcir;"
    ],
    [
        0,
        "&topcir;"
    ],
    [
        0,
        "&nhpar;"
    ],
    [
        0,
        "&parsim;"
    ],
    [
        9,
        {
            v: "&parsl;",
            n: 8421,
            o: "&nparsl;"
        }
    ],
    [
        44343,
        {
            n: new Map(/* #__PURE__ */ $dcfbf5d0b477e0f3$var$restoreDiff([
                [
                    56476,
                    "&Ascr;"
                ],
                [
                    1,
                    "&Cscr;"
                ],
                [
                    0,
                    "&Dscr;"
                ],
                [
                    2,
                    "&Gscr;"
                ],
                [
                    2,
                    "&Jscr;"
                ],
                [
                    0,
                    "&Kscr;"
                ],
                [
                    2,
                    "&Nscr;"
                ],
                [
                    0,
                    "&Oscr;"
                ],
                [
                    0,
                    "&Pscr;"
                ],
                [
                    0,
                    "&Qscr;"
                ],
                [
                    1,
                    "&Sscr;"
                ],
                [
                    0,
                    "&Tscr;"
                ],
                [
                    0,
                    "&Uscr;"
                ],
                [
                    0,
                    "&Vscr;"
                ],
                [
                    0,
                    "&Wscr;"
                ],
                [
                    0,
                    "&Xscr;"
                ],
                [
                    0,
                    "&Yscr;"
                ],
                [
                    0,
                    "&Zscr;"
                ],
                [
                    0,
                    "&ascr;"
                ],
                [
                    0,
                    "&bscr;"
                ],
                [
                    0,
                    "&cscr;"
                ],
                [
                    0,
                    "&dscr;"
                ],
                [
                    1,
                    "&fscr;"
                ],
                [
                    1,
                    "&hscr;"
                ],
                [
                    0,
                    "&iscr;"
                ],
                [
                    0,
                    "&jscr;"
                ],
                [
                    0,
                    "&kscr;"
                ],
                [
                    0,
                    "&lscr;"
                ],
                [
                    0,
                    "&mscr;"
                ],
                [
                    0,
                    "&nscr;"
                ],
                [
                    1,
                    "&pscr;"
                ],
                [
                    0,
                    "&qscr;"
                ],
                [
                    0,
                    "&rscr;"
                ],
                [
                    0,
                    "&sscr;"
                ],
                [
                    0,
                    "&tscr;"
                ],
                [
                    0,
                    "&uscr;"
                ],
                [
                    0,
                    "&vscr;"
                ],
                [
                    0,
                    "&wscr;"
                ],
                [
                    0,
                    "&xscr;"
                ],
                [
                    0,
                    "&yscr;"
                ],
                [
                    0,
                    "&zscr;"
                ],
                [
                    52,
                    "&Afr;"
                ],
                [
                    0,
                    "&Bfr;"
                ],
                [
                    1,
                    "&Dfr;"
                ],
                [
                    0,
                    "&Efr;"
                ],
                [
                    0,
                    "&Ffr;"
                ],
                [
                    0,
                    "&Gfr;"
                ],
                [
                    2,
                    "&Jfr;"
                ],
                [
                    0,
                    "&Kfr;"
                ],
                [
                    0,
                    "&Lfr;"
                ],
                [
                    0,
                    "&Mfr;"
                ],
                [
                    0,
                    "&Nfr;"
                ],
                [
                    0,
                    "&Ofr;"
                ],
                [
                    0,
                    "&Pfr;"
                ],
                [
                    0,
                    "&Qfr;"
                ],
                [
                    1,
                    "&Sfr;"
                ],
                [
                    0,
                    "&Tfr;"
                ],
                [
                    0,
                    "&Ufr;"
                ],
                [
                    0,
                    "&Vfr;"
                ],
                [
                    0,
                    "&Wfr;"
                ],
                [
                    0,
                    "&Xfr;"
                ],
                [
                    0,
                    "&Yfr;"
                ],
                [
                    1,
                    "&afr;"
                ],
                [
                    0,
                    "&bfr;"
                ],
                [
                    0,
                    "&cfr;"
                ],
                [
                    0,
                    "&dfr;"
                ],
                [
                    0,
                    "&efr;"
                ],
                [
                    0,
                    "&ffr;"
                ],
                [
                    0,
                    "&gfr;"
                ],
                [
                    0,
                    "&hfr;"
                ],
                [
                    0,
                    "&ifr;"
                ],
                [
                    0,
                    "&jfr;"
                ],
                [
                    0,
                    "&kfr;"
                ],
                [
                    0,
                    "&lfr;"
                ],
                [
                    0,
                    "&mfr;"
                ],
                [
                    0,
                    "&nfr;"
                ],
                [
                    0,
                    "&ofr;"
                ],
                [
                    0,
                    "&pfr;"
                ],
                [
                    0,
                    "&qfr;"
                ],
                [
                    0,
                    "&rfr;"
                ],
                [
                    0,
                    "&sfr;"
                ],
                [
                    0,
                    "&tfr;"
                ],
                [
                    0,
                    "&ufr;"
                ],
                [
                    0,
                    "&vfr;"
                ],
                [
                    0,
                    "&wfr;"
                ],
                [
                    0,
                    "&xfr;"
                ],
                [
                    0,
                    "&yfr;"
                ],
                [
                    0,
                    "&zfr;"
                ],
                [
                    0,
                    "&Aopf;"
                ],
                [
                    0,
                    "&Bopf;"
                ],
                [
                    1,
                    "&Dopf;"
                ],
                [
                    0,
                    "&Eopf;"
                ],
                [
                    0,
                    "&Fopf;"
                ],
                [
                    0,
                    "&Gopf;"
                ],
                [
                    1,
                    "&Iopf;"
                ],
                [
                    0,
                    "&Jopf;"
                ],
                [
                    0,
                    "&Kopf;"
                ],
                [
                    0,
                    "&Lopf;"
                ],
                [
                    0,
                    "&Mopf;"
                ],
                [
                    1,
                    "&Oopf;"
                ],
                [
                    3,
                    "&Sopf;"
                ],
                [
                    0,
                    "&Topf;"
                ],
                [
                    0,
                    "&Uopf;"
                ],
                [
                    0,
                    "&Vopf;"
                ],
                [
                    0,
                    "&Wopf;"
                ],
                [
                    0,
                    "&Xopf;"
                ],
                [
                    0,
                    "&Yopf;"
                ],
                [
                    1,
                    "&aopf;"
                ],
                [
                    0,
                    "&bopf;"
                ],
                [
                    0,
                    "&copf;"
                ],
                [
                    0,
                    "&dopf;"
                ],
                [
                    0,
                    "&eopf;"
                ],
                [
                    0,
                    "&fopf;"
                ],
                [
                    0,
                    "&gopf;"
                ],
                [
                    0,
                    "&hopf;"
                ],
                [
                    0,
                    "&iopf;"
                ],
                [
                    0,
                    "&jopf;"
                ],
                [
                    0,
                    "&kopf;"
                ],
                [
                    0,
                    "&lopf;"
                ],
                [
                    0,
                    "&mopf;"
                ],
                [
                    0,
                    "&nopf;"
                ],
                [
                    0,
                    "&oopf;"
                ],
                [
                    0,
                    "&popf;"
                ],
                [
                    0,
                    "&qopf;"
                ],
                [
                    0,
                    "&ropf;"
                ],
                [
                    0,
                    "&sopf;"
                ],
                [
                    0,
                    "&topf;"
                ],
                [
                    0,
                    "&uopf;"
                ],
                [
                    0,
                    "&vopf;"
                ],
                [
                    0,
                    "&wopf;"
                ],
                [
                    0,
                    "&xopf;"
                ],
                [
                    0,
                    "&yopf;"
                ],
                [
                    0,
                    "&zopf;"
                ]
            ]))
        }
    ],
    [
        8906,
        "&fflig;"
    ],
    [
        0,
        "&filig;"
    ],
    [
        0,
        "&fllig;"
    ],
    [
        0,
        "&ffilig;"
    ],
    [
        0,
        "&ffllig;"
    ]
]));

});

parcelRequire.register("iwskN", function(module, exports) {

$parcel$export(module.exports, "xmlReplacer", () => $d7c131c213aba51d$export$5699810ce3244ab8);
$parcel$export(module.exports, "getCodePoint", () => $d7c131c213aba51d$export$e02688b8085d016b);
$parcel$export(module.exports, "encodeXML", () => $d7c131c213aba51d$export$18855ec5be97da16);
$parcel$export(module.exports, "escapeUTF8", () => $d7c131c213aba51d$export$9e081872deefdcb0);
$parcel$export(module.exports, "escapeAttribute", () => $d7c131c213aba51d$export$30330f3d5eb70e11);
$parcel$export(module.exports, "escapeText", () => $d7c131c213aba51d$export$96e6fc3a139b2555);
const $d7c131c213aba51d$export$5699810ce3244ab8 = /["&'<>$\x80-\uFFFF]/g;
const $d7c131c213aba51d$var$xmlCodeMap = new Map([
    [
        34,
        "&quot;"
    ],
    [
        38,
        "&amp;"
    ],
    [
        39,
        "&apos;"
    ],
    [
        60,
        "&lt;"
    ],
    [
        62,
        "&gt;"
    ]
]);
const $d7c131c213aba51d$export$e02688b8085d016b = // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
String.prototype.codePointAt != null ? (str, index)=>str.codePointAt(index) : (c, index)=>(c.charCodeAt(index) & 0xfc00) === 0xd800 ? (c.charCodeAt(index) - 0xd800) * 0x400 + c.charCodeAt(index + 1) - 0xdc00 + 0x10000 : c.charCodeAt(index);
function $d7c131c213aba51d$export$18855ec5be97da16(str) {
    let ret = "";
    let lastIdx = 0;
    let match;
    while((match = $d7c131c213aba51d$export$5699810ce3244ab8.exec(str)) !== null){
        const i = match.index;
        const char = str.charCodeAt(i);
        const next = $d7c131c213aba51d$var$xmlCodeMap.get(char);
        if (next !== undefined) {
            ret += str.substring(lastIdx, i) + next;
            lastIdx = i + 1;
        } else {
            ret += `${str.substring(lastIdx, i)}&#x${$d7c131c213aba51d$export$e02688b8085d016b(str, i).toString(16)};`;
            // Increase by 1 if we have a surrogate pair
            lastIdx = $d7c131c213aba51d$export$5699810ce3244ab8.lastIndex += Number((char & 0xfc00) === 0xd800);
        }
    }
    return ret + str.substr(lastIdx);
}
const $d7c131c213aba51d$export$4e7f196112fea3c5 = $d7c131c213aba51d$export$18855ec5be97da16;
/**
 * Creates a function that escapes all characters matched by the given regular
 * expression using the given map of characters to escape to their entities.
 *
 * @param regex Regular expression to match characters to escape.
 * @param map Map of characters to escape to their entities.
 *
 * @returns Function that escapes all characters matched by the given regular
 * expression using the given map of characters to escape to their entities.
 */ function $d7c131c213aba51d$var$getEscaper(regex, map) {
    return function escape(data) {
        let match;
        let lastIdx = 0;
        let result = "";
        while(match = regex.exec(data)){
            if (lastIdx !== match.index) result += data.substring(lastIdx, match.index);
            // We know that this character will be in the map.
            result += map.get(match[0].charCodeAt(0));
            // Every match will be of length 1
            lastIdx = match.index + 1;
        }
        return result + data.substring(lastIdx);
    };
}
const $d7c131c213aba51d$export$9e081872deefdcb0 = $d7c131c213aba51d$var$getEscaper(/[&<>'"]/g, $d7c131c213aba51d$var$xmlCodeMap);
const $d7c131c213aba51d$export$30330f3d5eb70e11 = $d7c131c213aba51d$var$getEscaper(/["&\u00A0]/g, new Map([
    [
        34,
        "&quot;"
    ],
    [
        38,
        "&amp;"
    ],
    [
        160,
        "&nbsp;"
    ]
]));
const $d7c131c213aba51d$export$96e6fc3a139b2555 = $d7c131c213aba51d$var$getEscaper(/[&<>\u00A0]/g, new Map([
    [
        38,
        "&amp;"
    ],
    [
        60,
        "&lt;"
    ],
    [
        62,
        "&gt;"
    ],
    [
        160,
        "&nbsp;"
    ]
]));

});



parcelRequire.register("294rS", function(module, exports) {

$parcel$export(module.exports, "elementNames", () => $18ffdf753e584222$export$82b917442d249e05);
$parcel$export(module.exports, "attributeNames", () => $18ffdf753e584222$export$b4cfbfd90280b005);
const $18ffdf753e584222$export$82b917442d249e05 = new Map([
    "altGlyph",
    "altGlyphDef",
    "altGlyphItem",
    "animateColor",
    "animateMotion",
    "animateTransform",
    "clipPath",
    "feBlend",
    "feColorMatrix",
    "feComponentTransfer",
    "feComposite",
    "feConvolveMatrix",
    "feDiffuseLighting",
    "feDisplacementMap",
    "feDistantLight",
    "feDropShadow",
    "feFlood",
    "feFuncA",
    "feFuncB",
    "feFuncG",
    "feFuncR",
    "feGaussianBlur",
    "feImage",
    "feMerge",
    "feMergeNode",
    "feMorphology",
    "feOffset",
    "fePointLight",
    "feSpecularLighting",
    "feSpotLight",
    "feTile",
    "feTurbulence",
    "foreignObject",
    "glyphRef",
    "linearGradient",
    "radialGradient",
    "textPath"
].map((val)=>[
        val.toLowerCase(),
        val
    ]));
const $18ffdf753e584222$export$b4cfbfd90280b005 = new Map([
    "definitionURL",
    "attributeName",
    "attributeType",
    "baseFrequency",
    "baseProfile",
    "calcMode",
    "clipPathUnits",
    "diffuseConstant",
    "edgeMode",
    "filterUnits",
    "glyphRef",
    "gradientTransform",
    "gradientUnits",
    "kernelMatrix",
    "kernelUnitLength",
    "keyPoints",
    "keySplines",
    "keyTimes",
    "lengthAdjust",
    "limitingConeAngle",
    "markerHeight",
    "markerUnits",
    "markerWidth",
    "maskContentUnits",
    "maskUnits",
    "numOctaves",
    "pathLength",
    "patternContentUnits",
    "patternTransform",
    "patternUnits",
    "pointsAtX",
    "pointsAtY",
    "pointsAtZ",
    "preserveAlpha",
    "preserveAspectRatio",
    "primitiveUnits",
    "refX",
    "refY",
    "repeatCount",
    "repeatDur",
    "requiredExtensions",
    "requiredFeatures",
    "specularConstant",
    "specularExponent",
    "spreadMethod",
    "startOffset",
    "stdDeviation",
    "stitchTiles",
    "surfaceScale",
    "systemLanguage",
    "tableValues",
    "targetX",
    "targetY",
    "textLength",
    "viewBox",
    "viewTarget",
    "xChannelSelector",
    "yChannelSelector",
    "zoomAndPan"
].map((val)=>[
        val.toLowerCase(),
        val
    ]));

});



parcelRequire.register("02PlG", function(module, exports) {
parcelRequire("CnBXM");
var $iXsnt = parcelRequire("iXsnt");
function $008804cd198b3953$export$f8cf48ee793b41be(elem) {
    return (0, $iXsnt.hasChildren)(elem) ? elem.children : [];
}
function $008804cd198b3953$export$58081aedf094d85b(elem) {
    return elem.parent || null;
}
function $008804cd198b3953$export$f312c3733b79ac0d(elem) {
    const parent = $008804cd198b3953$export$58081aedf094d85b(elem);
    if (parent != null) return $008804cd198b3953$export$f8cf48ee793b41be(parent);
    const siblings = [
        elem
    ];
    let { prev: prev, next: next } = elem;
    while(prev != null){
        siblings.unshift(prev);
        ({ prev: prev } = prev);
    }
    while(next != null){
        siblings.push(next);
        ({ next: next } = next);
    }
    return siblings;
}
function $008804cd198b3953$export$1e335898aa11b111(elem, name) {
    var _a;
    return (_a = elem.attribs) === null || _a === void 0 ? void 0 : _a[name];
}
function $008804cd198b3953$export$aa37f90c17957f38(elem, name) {
    return elem.attribs != null && Object.prototype.hasOwnProperty.call(elem.attribs, name) && elem.attribs[name] != null;
}
function $008804cd198b3953$export$7d9f7e9c1c02b41e(elem) {
    return elem.name;
}
function $008804cd198b3953$export$9be3779649ef9cc7(elem) {
    let { next: next } = elem;
    while(next !== null && !(0, $iXsnt.isTag)(next))({ next: next } = next);
    return next;
}
function $008804cd198b3953$export$c8bafb6e59c0b8e(elem) {
    let { prev: prev } = elem;
    while(prev !== null && !(0, $iXsnt.isTag)(prev))({ prev: prev } = prev);
    return prev;
}

});

parcelRequire.register("eI5pT", function(module, exports) {
/**
 * Remove an element from the dom
 *
 * @category Manipulation
 * @param elem The element to be removed
 */ function $ab59606167e43b9b$export$f883456a56996078(elem) {
    if (elem.prev) elem.prev.next = elem.next;
    if (elem.next) elem.next.prev = elem.prev;
    if (elem.parent) {
        const childs = elem.parent.children;
        const childsIndex = childs.lastIndexOf(elem);
        if (childsIndex >= 0) childs.splice(childsIndex, 1);
    }
    elem.next = null;
    elem.prev = null;
    elem.parent = null;
}
function $ab59606167e43b9b$export$2dfe578f95754f6a(elem, replacement) {
    const prev = replacement.prev = elem.prev;
    if (prev) prev.next = replacement;
    const next = replacement.next = elem.next;
    if (next) next.prev = replacement;
    const parent = replacement.parent = elem.parent;
    if (parent) {
        const childs = parent.children;
        childs[childs.lastIndexOf(elem)] = replacement;
        elem.parent = null;
    }
}
function $ab59606167e43b9b$export$1b8e57c9ea42f1d2(parent, child) {
    $ab59606167e43b9b$export$f883456a56996078(child);
    child.next = null;
    child.parent = parent;
    if (parent.children.push(child) > 1) {
        const sibling = parent.children[parent.children.length - 2];
        sibling.next = child;
        child.prev = sibling;
    } else child.prev = null;
}
function $ab59606167e43b9b$export$10d8903dec122b9d(elem, next) {
    $ab59606167e43b9b$export$f883456a56996078(next);
    const { parent: parent } = elem;
    const currNext = elem.next;
    next.next = currNext;
    next.prev = elem;
    elem.next = next;
    next.parent = parent;
    if (currNext) {
        currNext.prev = next;
        if (parent) {
            const childs = parent.children;
            childs.splice(childs.lastIndexOf(currNext), 0, next);
        }
    } else if (parent) parent.children.push(next);
}
function $ab59606167e43b9b$export$47b51e6d100007bc(parent, child) {
    $ab59606167e43b9b$export$f883456a56996078(child);
    child.parent = parent;
    child.prev = null;
    if (parent.children.unshift(child) !== 1) {
        const sibling = parent.children[1];
        sibling.prev = child;
        child.next = sibling;
    } else child.next = null;
}
function $ab59606167e43b9b$export$68159836694e22c1(elem, prev) {
    $ab59606167e43b9b$export$f883456a56996078(prev);
    const { parent: parent } = elem;
    if (parent) {
        const childs = parent.children;
        childs.splice(childs.indexOf(elem), 0, prev);
    }
    if (elem.prev) elem.prev.next = prev;
    prev.parent = parent;
    prev.prev = elem.prev;
    prev.next = elem;
    elem.prev = prev;
}

});

parcelRequire.register("ksADb", function(module, exports) {

$parcel$export(module.exports, "filter", () => $ee52d656a18dd475$export$3dea766d36a8935f);
$parcel$export(module.exports, "findOne", () => $ee52d656a18dd475$export$a541876d5d7daf90);
parcelRequire("CnBXM");
var $iXsnt = parcelRequire("iXsnt");
function $ee52d656a18dd475$export$3dea766d36a8935f(test, node, recurse = true, limit = Infinity) {
    return $ee52d656a18dd475$export$71aa6c912b956294(test, Array.isArray(node) ? node : [
        node
    ], recurse, limit);
}
function $ee52d656a18dd475$export$71aa6c912b956294(test, nodes, recurse, limit) {
    const result = [];
    /** Stack of the arrays we are looking at. */ const nodeStack = [
        nodes
    ];
    /** Stack of the indices within the arrays. */ const indexStack = [
        0
    ];
    for(;;){
        // First, check if the current array has any more elements to look at.
        if (indexStack[0] >= nodeStack[0].length) {
            // If we have no more arrays to look at, we are done.
            if (indexStack.length === 1) return result;
            // Otherwise, remove the current array from the stack.
            nodeStack.shift();
            indexStack.shift();
            continue;
        }
        const elem = nodeStack[0][indexStack[0]++];
        if (test(elem)) {
            result.push(elem);
            if (--limit <= 0) return result;
        }
        if (recurse && (0, $iXsnt.hasChildren)(elem) && elem.children.length > 0) {
            /*
             * Add the children to the stack. We are depth-first, so this is
             * the next array we look at.
             */ indexStack.unshift(0);
            nodeStack.unshift(elem.children);
        }
    }
}
function $ee52d656a18dd475$export$ac03a862904ce329(test, nodes) {
    return nodes.find(test);
}
function $ee52d656a18dd475$export$a541876d5d7daf90(test, nodes, recurse = true) {
    let elem = null;
    for(let i = 0; i < nodes.length && !elem; i++){
        const node = nodes[i];
        if (!(0, $iXsnt.isTag)(node)) continue;
        else if (test(node)) elem = node;
        else if (recurse && node.children.length > 0) elem = $ee52d656a18dd475$export$a541876d5d7daf90(test, node.children, true);
    }
    return elem;
}
function $ee52d656a18dd475$export$9d99dce58ac4a31b(test, nodes) {
    return nodes.some((checked)=>(0, $iXsnt.isTag)(checked) && (test(checked) || $ee52d656a18dd475$export$9d99dce58ac4a31b(test, checked.children)));
}
function $ee52d656a18dd475$export$18200ea6c8035394(test, nodes) {
    const result = [];
    const nodeStack = [
        nodes
    ];
    const indexStack = [
        0
    ];
    for(;;){
        if (indexStack[0] >= nodeStack[0].length) {
            if (nodeStack.length === 1) return result;
            // Otherwise, remove the current array from the stack.
            nodeStack.shift();
            indexStack.shift();
            continue;
        }
        const elem = nodeStack[0][indexStack[0]++];
        if (!(0, $iXsnt.isTag)(elem)) continue;
        if (test(elem)) result.push(elem);
        if (elem.children.length > 0) {
            indexStack.unshift(0);
            nodeStack.unshift(elem.children);
        }
    }
}

});

parcelRequire.register("21oBJ", function(module, exports) {

$parcel$export(module.exports, "getElementsByTagName", () => $178ec351f6e2f486$export$af941c3c7c3b40f5);
parcelRequire("CnBXM");
var $iXsnt = parcelRequire("iXsnt");

var $ksADb = parcelRequire("ksADb");
/**
 * A map of functions to check nodes against.
 */ const $178ec351f6e2f486$var$Checks = {
    tag_name (name) {
        if (typeof name === "function") return (elem)=>(0, $iXsnt.isTag)(elem) && name(elem.name);
        else if (name === "*") return 0, $iXsnt.isTag;
        return (elem)=>(0, $iXsnt.isTag)(elem) && elem.name === name;
    },
    tag_type (type) {
        if (typeof type === "function") return (elem)=>type(elem.type);
        return (elem)=>elem.type === type;
    },
    tag_contains (data) {
        if (typeof data === "function") return (elem)=>(0, $iXsnt.isText)(elem) && data(elem.data);
        return (elem)=>(0, $iXsnt.isText)(elem) && elem.data === data;
    }
};
/**
 * Returns a function to check whether a node has an attribute with a particular
 * value.
 *
 * @param attrib Attribute to check.
 * @param value Attribute value to look for.
 * @returns A function to check whether the a node has an attribute with a
 *   particular value.
 */ function $178ec351f6e2f486$var$getAttribCheck(attrib, value) {
    if (typeof value === "function") return (elem)=>(0, $iXsnt.isTag)(elem) && value(elem.attribs[attrib]);
    return (elem)=>(0, $iXsnt.isTag)(elem) && elem.attribs[attrib] === value;
}
/**
 * Returns a function that returns `true` if either of the input functions
 * returns `true` for a node.
 *
 * @param a First function to combine.
 * @param b Second function to combine.
 * @returns A function taking a node and returning `true` if either of the input
 *   functions returns `true` for the node.
 */ function $178ec351f6e2f486$var$combineFuncs(a, b) {
    return (elem)=>a(elem) || b(elem);
}
/**
 * Returns a function that executes all checks in `options` and returns `true`
 * if any of them match a node.
 *
 * @param options An object describing nodes to look for.
 * @returns A function that executes all checks in `options` and returns `true`
 *   if any of them match a node.
 */ function $178ec351f6e2f486$var$compileTest(options) {
    const funcs = Object.keys(options).map((key)=>{
        const value = options[key];
        return Object.prototype.hasOwnProperty.call($178ec351f6e2f486$var$Checks, key) ? $178ec351f6e2f486$var$Checks[key](value) : $178ec351f6e2f486$var$getAttribCheck(key, value);
    });
    return funcs.length === 0 ? null : funcs.reduce($178ec351f6e2f486$var$combineFuncs);
}
function $178ec351f6e2f486$export$7b31db6b5a0b2f32(options, node) {
    const test = $178ec351f6e2f486$var$compileTest(options);
    return test ? test(node) : true;
}
function $178ec351f6e2f486$export$73eac51a39d6b0eb(options, nodes, recurse, limit = Infinity) {
    const test = $178ec351f6e2f486$var$compileTest(options);
    return test ? (0, $ksADb.filter)(test, nodes, recurse, limit) : [];
}
function $178ec351f6e2f486$export$83595b84fc78b9b4(id, nodes, recurse = true) {
    if (!Array.isArray(nodes)) nodes = [
        nodes
    ];
    return (0, $ksADb.findOne)($178ec351f6e2f486$var$getAttribCheck("id", id), nodes, recurse);
}
function $178ec351f6e2f486$export$af941c3c7c3b40f5(tagName, nodes, recurse = true, limit = Infinity) {
    return (0, $ksADb.filter)($178ec351f6e2f486$var$Checks["tag_name"](tagName), nodes, recurse, limit);
}
function $178ec351f6e2f486$export$f5d981e30be5545b(type, nodes, recurse = true, limit = Infinity) {
    return (0, $ksADb.filter)($178ec351f6e2f486$var$Checks["tag_type"](type), nodes, recurse, limit);
}

});

parcelRequire.register("glLv3", function(module, exports) {
parcelRequire("CnBXM");
var $iXsnt = parcelRequire("iXsnt");
function $be737401912f185b$export$171dc294232ebeef(nodes) {
    let idx = nodes.length;
    /*
     * Check if each node (or one of its ancestors) is already contained in the
     * array.
     */ while(--idx >= 0){
        const node = nodes[idx];
        /*
         * Remove the node if it is not unique.
         * We are going through the array from the end, so we only
         * have to check nodes that preceed the node under consideration in the array.
         */ if (idx > 0 && nodes.lastIndexOf(node, idx - 1) >= 0) {
            nodes.splice(idx, 1);
            continue;
        }
        for(let ancestor = node.parent; ancestor; ancestor = ancestor.parent)if (nodes.includes(ancestor)) {
            nodes.splice(idx, 1);
            break;
        }
    }
    return nodes;
}
var $be737401912f185b$export$406a59d989e8005a;
(function(DocumentPosition) {
    DocumentPosition[DocumentPosition["DISCONNECTED"] = 1] = "DISCONNECTED";
    DocumentPosition[DocumentPosition["PRECEDING"] = 2] = "PRECEDING";
    DocumentPosition[DocumentPosition["FOLLOWING"] = 4] = "FOLLOWING";
    DocumentPosition[DocumentPosition["CONTAINS"] = 8] = "CONTAINS";
    DocumentPosition[DocumentPosition["CONTAINED_BY"] = 16] = "CONTAINED_BY";
})($be737401912f185b$export$406a59d989e8005a || ($be737401912f185b$export$406a59d989e8005a = {}));
function $be737401912f185b$export$17303b8fea718ecc(nodeA, nodeB) {
    const aParents = [];
    const bParents = [];
    if (nodeA === nodeB) return 0;
    let current = (0, $iXsnt.hasChildren)(nodeA) ? nodeA : nodeA.parent;
    while(current){
        aParents.unshift(current);
        current = current.parent;
    }
    current = (0, $iXsnt.hasChildren)(nodeB) ? nodeB : nodeB.parent;
    while(current){
        bParents.unshift(current);
        current = current.parent;
    }
    const maxIdx = Math.min(aParents.length, bParents.length);
    let idx = 0;
    while(idx < maxIdx && aParents[idx] === bParents[idx])idx++;
    if (idx === 0) return $be737401912f185b$export$406a59d989e8005a.DISCONNECTED;
    const sharedParent = aParents[idx - 1];
    const siblings = sharedParent.children;
    const aSibling = aParents[idx];
    const bSibling = bParents[idx];
    if (siblings.indexOf(aSibling) > siblings.indexOf(bSibling)) {
        if (sharedParent === nodeB) return $be737401912f185b$export$406a59d989e8005a.FOLLOWING | $be737401912f185b$export$406a59d989e8005a.CONTAINED_BY;
        return $be737401912f185b$export$406a59d989e8005a.FOLLOWING;
    }
    if (sharedParent === nodeA) return $be737401912f185b$export$406a59d989e8005a.PRECEDING | $be737401912f185b$export$406a59d989e8005a.CONTAINS;
    return $be737401912f185b$export$406a59d989e8005a.PRECEDING;
}
function $be737401912f185b$export$1c267319665a7e7e(nodes) {
    nodes = nodes.filter((node, i, arr)=>!arr.includes(node, i + 1));
    nodes.sort((a, b)=>{
        const relative = $be737401912f185b$export$17303b8fea718ecc(a, b);
        if (relative & $be737401912f185b$export$406a59d989e8005a.PRECEDING) return -1;
        else if (relative & $be737401912f185b$export$406a59d989e8005a.FOLLOWING) return 1;
        return 0;
    });
    return nodes;
}

});

parcelRequire.register("4qtZj", function(module, exports) {

$parcel$export(module.exports, "getFeed", () => $3390da1e4a4e36e1$export$ad32138c9e09ad4);

var $7LDPY = parcelRequire("7LDPY");

var $21oBJ = parcelRequire("21oBJ");
function $3390da1e4a4e36e1$export$ad32138c9e09ad4(doc) {
    const feedRoot = $3390da1e4a4e36e1$var$getOneElement($3390da1e4a4e36e1$var$isValidFeed, doc);
    return !feedRoot ? null : feedRoot.name === "feed" ? $3390da1e4a4e36e1$var$getAtomFeed(feedRoot) : $3390da1e4a4e36e1$var$getRssFeed(feedRoot);
}
/**
 * Parse an Atom feed.
 *
 * @param feedRoot The root of the feed.
 * @returns The parsed feed.
 */ function $3390da1e4a4e36e1$var$getAtomFeed(feedRoot) {
    var _a;
    const childs = feedRoot.children;
    const feed = {
        type: "atom",
        items: (0, $21oBJ.getElementsByTagName)("entry", childs).map((item)=>{
            var _a;
            const { children: children } = item;
            const entry = {
                media: $3390da1e4a4e36e1$var$getMediaElements(children)
            };
            $3390da1e4a4e36e1$var$addConditionally(entry, "id", "id", children);
            $3390da1e4a4e36e1$var$addConditionally(entry, "title", "title", children);
            const href = (_a = $3390da1e4a4e36e1$var$getOneElement("link", children)) === null || _a === void 0 ? void 0 : _a.attribs["href"];
            if (href) entry.link = href;
            const description = $3390da1e4a4e36e1$var$fetch("summary", children) || $3390da1e4a4e36e1$var$fetch("content", children);
            if (description) entry.description = description;
            const pubDate = $3390da1e4a4e36e1$var$fetch("updated", children);
            if (pubDate) entry.pubDate = new Date(pubDate);
            return entry;
        })
    };
    $3390da1e4a4e36e1$var$addConditionally(feed, "id", "id", childs);
    $3390da1e4a4e36e1$var$addConditionally(feed, "title", "title", childs);
    const href = (_a = $3390da1e4a4e36e1$var$getOneElement("link", childs)) === null || _a === void 0 ? void 0 : _a.attribs["href"];
    if (href) feed.link = href;
    $3390da1e4a4e36e1$var$addConditionally(feed, "description", "subtitle", childs);
    const updated = $3390da1e4a4e36e1$var$fetch("updated", childs);
    if (updated) feed.updated = new Date(updated);
    $3390da1e4a4e36e1$var$addConditionally(feed, "author", "email", childs, true);
    return feed;
}
/**
 * Parse a RSS feed.
 *
 * @param feedRoot The root of the feed.
 * @returns The parsed feed.
 */ function $3390da1e4a4e36e1$var$getRssFeed(feedRoot) {
    var _a, _b;
    const childs = (_b = (_a = $3390da1e4a4e36e1$var$getOneElement("channel", feedRoot.children)) === null || _a === void 0 ? void 0 : _a.children) !== null && _b !== void 0 ? _b : [];
    const feed = {
        type: feedRoot.name.substr(0, 3),
        id: "",
        items: (0, $21oBJ.getElementsByTagName)("item", feedRoot.children).map((item)=>{
            const { children: children } = item;
            const entry = {
                media: $3390da1e4a4e36e1$var$getMediaElements(children)
            };
            $3390da1e4a4e36e1$var$addConditionally(entry, "id", "guid", children);
            $3390da1e4a4e36e1$var$addConditionally(entry, "title", "title", children);
            $3390da1e4a4e36e1$var$addConditionally(entry, "link", "link", children);
            $3390da1e4a4e36e1$var$addConditionally(entry, "description", "description", children);
            const pubDate = $3390da1e4a4e36e1$var$fetch("pubDate", children) || $3390da1e4a4e36e1$var$fetch("dc:date", children);
            if (pubDate) entry.pubDate = new Date(pubDate);
            return entry;
        })
    };
    $3390da1e4a4e36e1$var$addConditionally(feed, "title", "title", childs);
    $3390da1e4a4e36e1$var$addConditionally(feed, "link", "link", childs);
    $3390da1e4a4e36e1$var$addConditionally(feed, "description", "description", childs);
    const updated = $3390da1e4a4e36e1$var$fetch("lastBuildDate", childs);
    if (updated) feed.updated = new Date(updated);
    $3390da1e4a4e36e1$var$addConditionally(feed, "author", "managingEditor", childs, true);
    return feed;
}
const $3390da1e4a4e36e1$var$MEDIA_KEYS_STRING = [
    "url",
    "type",
    "lang"
];
const $3390da1e4a4e36e1$var$MEDIA_KEYS_INT = [
    "fileSize",
    "bitrate",
    "framerate",
    "samplingrate",
    "channels",
    "duration",
    "height",
    "width"
];
/**
 * Get all media elements of a feed item.
 *
 * @param where Nodes to search in.
 * @returns Media elements.
 */ function $3390da1e4a4e36e1$var$getMediaElements(where) {
    return (0, $21oBJ.getElementsByTagName)("media:content", where).map((elem)=>{
        const { attribs: attribs } = elem;
        const media = {
            medium: attribs["medium"],
            isDefault: !!attribs["isDefault"]
        };
        for (const attrib of $3390da1e4a4e36e1$var$MEDIA_KEYS_STRING)if (attribs[attrib]) media[attrib] = attribs[attrib];
        for (const attrib of $3390da1e4a4e36e1$var$MEDIA_KEYS_INT)if (attribs[attrib]) media[attrib] = parseInt(attribs[attrib], 10);
        if (attribs["expression"]) media.expression = attribs["expression"];
        return media;
    });
}
/**
 * Get one element by tag name.
 *
 * @param tagName Tag name to look for
 * @param node Node to search in
 * @returns The element or null
 */ function $3390da1e4a4e36e1$var$getOneElement(tagName, node) {
    return (0, $21oBJ.getElementsByTagName)(tagName, node, true, 1)[0];
}
/**
 * Get the text content of an element with a certain tag name.
 *
 * @param tagName Tag name to look for.
 * @param where Node to search in.
 * @param recurse Whether to recurse into child nodes.
 * @returns The text content of the element.
 */ function $3390da1e4a4e36e1$var$fetch(tagName, where, recurse = false) {
    return (0, $7LDPY.textContent)((0, $21oBJ.getElementsByTagName)(tagName, where, recurse, 1)).trim();
}
/**
 * Adds a property to an object if it has a value.
 *
 * @param obj Object to be extended
 * @param prop Property name
 * @param tagName Tag name that contains the conditionally added property
 * @param where Element to search for the property
 * @param recurse Whether to recurse into child nodes.
 */ function $3390da1e4a4e36e1$var$addConditionally(obj, prop, tagName, where, recurse = false) {
    const val = $3390da1e4a4e36e1$var$fetch(tagName, where, recurse);
    if (val) obj[prop] = val;
}
/**
 * Checks if an element is a feed root node.
 *
 * @param value The name of the element to check.
 * @returns Whether an element is a feed root node.
 */ function $3390da1e4a4e36e1$var$isValidFeed(value) {
    return value === "rss" || value === "feed" || value === "rdf:RDF";
}

});



parcelRequire.register("hhT4E", function(module, exports) {
"use strict";
module.exports = (string)=>{
    if (typeof string !== "string") throw new TypeError("Expected a string");
    // Escape characters with special meaning either inside or outside character sets.
    // Use a simple backslash escape when it’s always valid, and a \unnnn escape when the simpler form would be disallowed by Unicode patterns’ stricter grammar.
    return string.replace(/[|\\{}()[\]^$+*?.]/g, "\\$&").replace(/-/g, "\\x2d");
};

});

parcelRequire.register("1aQnO", function(module, exports) {

$parcel$export(module.exports, "isPlainObject", () => $89b6154a23550edf$export$53b83ca8eaab0383);
/*!
 * is-plain-object <https://github.com/jonschlinkert/is-plain-object>
 *
 * Copyright (c) 2014-2017, Jon Schlinkert.
 * Released under the MIT License.
 */ function $89b6154a23550edf$var$isObject(o) {
    return Object.prototype.toString.call(o) === "[object Object]";
}
function $89b6154a23550edf$export$53b83ca8eaab0383(o) {
    var ctor, prot;
    if ($89b6154a23550edf$var$isObject(o) === false) return false;
    // If has modified constructor
    ctor = o.constructor;
    if (ctor === undefined) return true;
    // If has modified prototype
    prot = ctor.prototype;
    if ($89b6154a23550edf$var$isObject(prot) === false) return false;
    // If constructor does not have an Object-specific method
    if (prot.hasOwnProperty("isPrototypeOf") === false) return false;
    // Most likely a plain Object
    return true;
}

});

parcelRequire.register("lafU4", function(module, exports) {
"use strict";
var $f686de3356439bed$var$isMergeableObject = function isMergeableObject(value) {
    return $f686de3356439bed$var$isNonNullObject(value) && !$f686de3356439bed$var$isSpecial(value);
};
function $f686de3356439bed$var$isNonNullObject(value) {
    return !!value && typeof value === "object";
}
function $f686de3356439bed$var$isSpecial(value) {
    var stringValue = Object.prototype.toString.call(value);
    return stringValue === "[object RegExp]" || stringValue === "[object Date]" || $f686de3356439bed$var$isReactElement(value);
}
// see https://github.com/facebook/react/blob/b5ac963fb791d1298e7f396236383bc955f916c1/src/isomorphic/classic/element/ReactElement.js#L21-L25
var $f686de3356439bed$var$canUseSymbol = typeof Symbol === "function" && Symbol.for;
var $f686de3356439bed$var$REACT_ELEMENT_TYPE = $f686de3356439bed$var$canUseSymbol ? Symbol.for("react.element") : 0xeac7;
function $f686de3356439bed$var$isReactElement(value) {
    return value.$$typeof === $f686de3356439bed$var$REACT_ELEMENT_TYPE;
}
function $f686de3356439bed$var$emptyTarget(val) {
    return Array.isArray(val) ? [] : {};
}
function $f686de3356439bed$var$cloneUnlessOtherwiseSpecified(value, options) {
    return options.clone !== false && options.isMergeableObject(value) ? $f686de3356439bed$var$deepmerge($f686de3356439bed$var$emptyTarget(value), value, options) : value;
}
function $f686de3356439bed$var$defaultArrayMerge(target, source, options) {
    return target.concat(source).map(function(element) {
        return $f686de3356439bed$var$cloneUnlessOtherwiseSpecified(element, options);
    });
}
function $f686de3356439bed$var$getMergeFunction(key, options) {
    if (!options.customMerge) return $f686de3356439bed$var$deepmerge;
    var customMerge = options.customMerge(key);
    return typeof customMerge === "function" ? customMerge : $f686de3356439bed$var$deepmerge;
}
function $f686de3356439bed$var$getEnumerableOwnPropertySymbols(target) {
    return Object.getOwnPropertySymbols ? Object.getOwnPropertySymbols(target).filter(function(symbol) {
        return Object.propertyIsEnumerable.call(target, symbol);
    }) : [];
}
function $f686de3356439bed$var$getKeys(target) {
    return Object.keys(target).concat($f686de3356439bed$var$getEnumerableOwnPropertySymbols(target));
}
function $f686de3356439bed$var$propertyIsOnObject(object, property) {
    try {
        return property in object;
    } catch (_) {
        return false;
    }
}
// Protects from prototype poisoning and unexpected merging up the prototype chain.
function $f686de3356439bed$var$propertyIsUnsafe(target, key) {
    return $f686de3356439bed$var$propertyIsOnObject(target, key) // Properties are safe to merge if they don't exist in the target yet,
     && !(Object.hasOwnProperty.call(target, key) // unsafe if they exist up the prototype chain,
     && Object.propertyIsEnumerable.call(target, key) // and also unsafe if they're nonenumerable.
    );
}
function $f686de3356439bed$var$mergeObject(target, source, options) {
    var destination = {};
    if (options.isMergeableObject(target)) $f686de3356439bed$var$getKeys(target).forEach(function(key) {
        destination[key] = $f686de3356439bed$var$cloneUnlessOtherwiseSpecified(target[key], options);
    });
    $f686de3356439bed$var$getKeys(source).forEach(function(key) {
        if ($f686de3356439bed$var$propertyIsUnsafe(target, key)) return;
        if ($f686de3356439bed$var$propertyIsOnObject(target, key) && options.isMergeableObject(source[key])) destination[key] = $f686de3356439bed$var$getMergeFunction(key, options)(target[key], source[key], options);
        else destination[key] = $f686de3356439bed$var$cloneUnlessOtherwiseSpecified(source[key], options);
    });
    return destination;
}
function $f686de3356439bed$var$deepmerge(target, source, options) {
    options = options || {};
    options.arrayMerge = options.arrayMerge || $f686de3356439bed$var$defaultArrayMerge;
    options.isMergeableObject = options.isMergeableObject || $f686de3356439bed$var$isMergeableObject;
    // cloneUnlessOtherwiseSpecified is added to `options` so that custom arrayMerge()
    // implementations can use it. The caller may not replace it.
    options.cloneUnlessOtherwiseSpecified = $f686de3356439bed$var$cloneUnlessOtherwiseSpecified;
    var sourceIsArray = Array.isArray(source);
    var targetIsArray = Array.isArray(target);
    var sourceAndTargetTypesMatch = sourceIsArray === targetIsArray;
    if (!sourceAndTargetTypesMatch) return $f686de3356439bed$var$cloneUnlessOtherwiseSpecified(source, options);
    else if (sourceIsArray) return options.arrayMerge(target, source, options);
    else return $f686de3356439bed$var$mergeObject(target, source, options);
}
$f686de3356439bed$var$deepmerge.all = function deepmergeAll(array, options) {
    if (!Array.isArray(array)) throw new Error("first argument should be an array");
    return array.reduce(function(prev, next) {
        return $f686de3356439bed$var$deepmerge(prev, next, options);
    }, {});
};
var $f686de3356439bed$var$deepmerge_1 = $f686de3356439bed$var$deepmerge;
module.exports = $f686de3356439bed$var$deepmerge_1;

});

parcelRequire.register("iDeqq", function(module, exports) {
/**
 * Srcset Parser
 *
 * By Alex Bell |  MIT License
 *
 * JS Parser for the string value that appears in markup <img srcset="here">
 *
 * @returns Array [{url: _, d: _, w: _, h:_}, ...]
 *
 * Based super duper closely on the reference algorithm at:
 * https://html.spec.whatwg.org/multipage/embedded-content.html#parse-a-srcset-attribute
 *
 * Most comments are copied in directly from the spec
 * (except for comments in parens).
 */ (function(root, factory) {
    if (typeof define === "function" && define.amd) // AMD. Register as an anonymous module.
    define([], factory);
    else if (0, module.exports) // Node. Does not work with strict CommonJS, but
    // only CommonJS-like environments that support module.exports,
    // like Node.
    module.exports = factory();
    else // Browser globals (root is window)
    root.parseSrcset = factory();
})(module.exports, function() {
    // 1. Let input be the value passed to this algorithm.
    return function(input) {
        // UTILITY FUNCTIONS
        // Manual is faster than RegEx
        // http://bjorn.tipling.com/state-and-regular-expressions-in-javascript
        // http://jsperf.com/whitespace-character/5
        function isSpace(c) {
            return c === " " || // space
            c === "	" || // horizontal tab
            c === "\n" || // new line
            c === "\f" || // form feed
            c === "\r"; // carriage return
        }
        function collectCharacters(regEx) {
            var chars, match = regEx.exec(input.substring(pos));
            if (match) {
                chars = match[0];
                pos += chars.length;
                return chars;
            }
        }
        var inputLength = input.length, // (Don't use \s, to avoid matching non-breaking space)
        regexLeadingSpaces = /^[ \t\n\r\u000c]+/, regexLeadingCommasOrSpaces = /^[, \t\n\r\u000c]+/, regexLeadingNotSpaces = /^[^ \t\n\r\u000c]+/, regexTrailingCommas = /[,]+$/, regexNonNegativeInteger = /^\d+$/, // ( Positive or negative or unsigned integers or decimals, without or without exponents.
        // Must include at least one digit.
        // According to spec tests any decimal point must be followed by a digit.
        // No leading plus sign is allowed.)
        // https://html.spec.whatwg.org/multipage/infrastructure.html#valid-floating-point-number
        regexFloatingPoint = /^-?(?:[0-9]+|[0-9]*\.[0-9]+)(?:[eE][+-]?[0-9]+)?$/, url, descriptors, currentDescriptor, state, c, // 2. Let position be a pointer into input, initially pointing at the start
        //    of the string.
        pos = 0, // 3. Let candidates be an initially empty source set.
        candidates = [];
        // 4. Splitting loop: Collect a sequence of characters that are space
        //    characters or U+002C COMMA characters. If any U+002C COMMA characters
        //    were collected, that is a parse error.
        while(true){
            collectCharacters(regexLeadingCommasOrSpaces);
            // 5. If position is past the end of input, return candidates and abort these steps.
            if (pos >= inputLength) return candidates; // (we're done, this is the sole return path)
            // 6. Collect a sequence of characters that are not space characters,
            //    and let that be url.
            url = collectCharacters(regexLeadingNotSpaces);
            // 7. Let descriptors be a new empty list.
            descriptors = [];
            // 8. If url ends with a U+002C COMMA character (,), follow these substeps:
            //		(1). Remove all trailing U+002C COMMA characters from url. If this removed
            //         more than one character, that is a parse error.
            if (url.slice(-1) === ",") {
                url = url.replace(regexTrailingCommas, "");
                // (Jump ahead to step 9 to skip tokenization and just push the candidate).
                parseDescriptors();
            //	Otherwise, follow these substeps:
            } else tokenize();
             // (close else of step 8)
        // 16. Return to the step labeled splitting loop.
        } // (Close of big while loop.)
        /**
		 * Tokenizes descriptor properties prior to parsing
		 * Returns undefined.
		 */ function tokenize() {
            // 8.1. Descriptor tokeniser: Skip whitespace
            collectCharacters(regexLeadingSpaces);
            // 8.2. Let current descriptor be the empty string.
            currentDescriptor = "";
            // 8.3. Let state be in descriptor.
            state = "in descriptor";
            while(true){
                // 8.4. Let c be the character at position.
                c = input.charAt(pos);
                //  Do the following depending on the value of state.
                //  For the purpose of this step, "EOF" is a special character representing
                //  that position is past the end of input.
                // In descriptor
                if (state === "in descriptor") {
                    // Do the following, depending on the value of c:
                    // Space character
                    // If current descriptor is not empty, append current descriptor to
                    // descriptors and let current descriptor be the empty string.
                    // Set state to after descriptor.
                    if (isSpace(c)) {
                        if (currentDescriptor) {
                            descriptors.push(currentDescriptor);
                            currentDescriptor = "";
                            state = "after descriptor";
                        }
                    } else if (c === ",") {
                        pos += 1;
                        if (currentDescriptor) descriptors.push(currentDescriptor);
                        parseDescriptors();
                        return;
                    // U+0028 LEFT PARENTHESIS (()
                    // Append c to current descriptor. Set state to in parens.
                    } else if (c === "(") {
                        currentDescriptor = currentDescriptor + c;
                        state = "in parens";
                    // EOF
                    // If current descriptor is not empty, append current descriptor to
                    // descriptors. Jump to the step labeled descriptor parser.
                    } else if (c === "") {
                        if (currentDescriptor) descriptors.push(currentDescriptor);
                        parseDescriptors();
                        return;
                    // Anything else
                    // Append c to current descriptor.
                    } else currentDescriptor = currentDescriptor + c;
                // (end "in descriptor"
                // In parens
                } else if (state === "in parens") {
                    // U+0029 RIGHT PARENTHESIS ())
                    // Append c to current descriptor. Set state to in descriptor.
                    if (c === ")") {
                        currentDescriptor = currentDescriptor + c;
                        state = "in descriptor";
                    // EOF
                    // Append current descriptor to descriptors. Jump to the step labeled
                    // descriptor parser.
                    } else if (c === "") {
                        descriptors.push(currentDescriptor);
                        parseDescriptors();
                        return;
                    // Anything else
                    // Append c to current descriptor.
                    } else currentDescriptor = currentDescriptor + c;
                // After descriptor
                } else if (state === "after descriptor") {
                    // Do the following, depending on the value of c:
                    // Space character: Stay in this state.
                    if (isSpace(c)) ;
                    else if (c === "") {
                        parseDescriptors();
                        return;
                    // Anything else
                    // Set state to in descriptor. Set position to the previous character in input.
                    } else {
                        state = "in descriptor";
                        pos -= 1;
                    }
                }
                // Advance position to the next character in input.
                pos += 1;
            // Repeat this step.
            } // (close while true loop)
        }
        /**
		 * Adds descriptor properties to a candidate, pushes to the candidates array
		 * @return undefined
		 */ // Declared outside of the while loop so that it's only created once.
        function parseDescriptors() {
            // 9. Descriptor parser: Let error be no.
            var pError = false, // 10. Let width be absent.
            // 11. Let density be absent.
            // 12. Let future-compat-h be absent. (We're implementing it now as h)
            w, d, h, i, candidate = {}, desc, lastChar, value, intVal, floatVal;
            // 13. For each descriptor in descriptors, run the appropriate set of steps
            // from the following list:
            for(i = 0; i < descriptors.length; i++){
                desc = descriptors[i];
                lastChar = desc[desc.length - 1];
                value = desc.substring(0, desc.length - 1);
                intVal = parseInt(value, 10);
                floatVal = parseFloat(value);
                // If the descriptor consists of a valid non-negative integer followed by
                // a U+0077 LATIN SMALL LETTER W character
                if (regexNonNegativeInteger.test(value) && lastChar === "w") {
                    // If width and density are not both absent, then let error be yes.
                    if (w || d) pError = true;
                    // Apply the rules for parsing non-negative integers to the descriptor.
                    // If the result is zero, let error be yes.
                    // Otherwise, let width be the result.
                    if (intVal === 0) pError = true;
                    else w = intVal;
                // If the descriptor consists of a valid floating-point number followed by
                // a U+0078 LATIN SMALL LETTER X character
                } else if (regexFloatingPoint.test(value) && lastChar === "x") {
                    // If width, density and future-compat-h are not all absent, then let error
                    // be yes.
                    if (w || d || h) pError = true;
                    // Apply the rules for parsing floating-point number values to the descriptor.
                    // If the result is less than zero, let error be yes. Otherwise, let density
                    // be the result.
                    if (floatVal < 0) pError = true;
                    else d = floatVal;
                // If the descriptor consists of a valid non-negative integer followed by
                // a U+0068 LATIN SMALL LETTER H character
                } else if (regexNonNegativeInteger.test(value) && lastChar === "h") {
                    // If height and density are not both absent, then let error be yes.
                    if (h || d) pError = true;
                    // Apply the rules for parsing non-negative integers to the descriptor.
                    // If the result is zero, let error be yes. Otherwise, let future-compat-h
                    // be the result.
                    if (intVal === 0) pError = true;
                    else h = intVal;
                // Anything else, Let error be yes.
                } else pError = true;
            } // (close step 13 for loop)
            // 15. If error is still no, then append a new image source to candidates whose
            // URL is url, associated with a width width if not absent and a pixel
            // density density if not absent. Otherwise, there is a parse error.
            if (!pError) {
                candidate.url = url;
                if (w) candidate.w = w;
                if (d) candidate.d = d;
                if (h) candidate.h = h;
                candidates.push(candidate);
            } else if (console && console.log) console.log("Invalid srcset descriptor found in '" + input + "' at '" + desc + "'.");
        } // (close parseDescriptors fn)
    };
});

});

parcelRequire.register("cPknf", function(module, exports) {
"use strict";

var $6ANgp = parcelRequire("6ANgp");

var $gZeVH = parcelRequire("gZeVH");

var $5Faho = parcelRequire("5Faho");

var $7UdNM = parcelRequire("7UdNM");

var $gRQ9L = parcelRequire("gRQ9L");

var $5xBzD = parcelRequire("5xBzD");

var $lHSpH = parcelRequire("lHSpH");

var $4Cgdx = parcelRequire("4Cgdx");

var $kFs1D = parcelRequire("kFs1D");

var $fjcSu = parcelRequire("fjcSu");

var $eIKWx = parcelRequire("eIKWx");

var $jbyo6 = parcelRequire("jbyo6");

var $lirqv = parcelRequire("lirqv");

var $79gLn = parcelRequire("79gLn");

var $fcHjE = parcelRequire("fcHjE");

var $cDdV8 = parcelRequire("cDdV8");

var $4DHTo = parcelRequire("4DHTo");

var $htVhF = parcelRequire("htVhF");
function $956a0d4b2471a93d$var$postcss(...plugins) {
    if (plugins.length === 1 && Array.isArray(plugins[0])) plugins = plugins[0];
    return new $gRQ9L(plugins);
}
$956a0d4b2471a93d$var$postcss.plugin = function plugin(name, initializer) {
    let warningPrinted = false;
    function creator(...args) {
        // eslint-disable-next-line no-console
        if (console && console.warn && !warningPrinted) {
            warningPrinted = true;
            // eslint-disable-next-line no-console
            console.warn(name + ": postcss.plugin was deprecated. Migration guide:\n" + "https://evilmartians.com/chronicles/postcss-8-plugin-migration");
        }
        let transformer = initializer(...args);
        transformer.postcssPlugin = name;
        transformer.postcssVersion = new $gRQ9L().version;
        return transformer;
    }
    let cache;
    Object.defineProperty(creator, "postcss", {
        get () {
            if (!cache) cache = creator();
            return cache;
        }
    });
    creator.process = function(css, processOpts, pluginOpts) {
        return $956a0d4b2471a93d$var$postcss([
            creator(pluginOpts)
        ]).process(css, processOpts);
    };
    return creator;
};
$956a0d4b2471a93d$var$postcss.stringify = $5xBzD;
$956a0d4b2471a93d$var$postcss.parse = $79gLn;
$956a0d4b2471a93d$var$postcss.fromJSON = $lHSpH;
$956a0d4b2471a93d$var$postcss.list = $fcHjE;
$956a0d4b2471a93d$var$postcss.comment = (defaults)=>new $fjcSu(defaults);
$956a0d4b2471a93d$var$postcss.atRule = (defaults)=>new $eIKWx(defaults);
$956a0d4b2471a93d$var$postcss.decl = (defaults)=>new $gZeVH(defaults);
$956a0d4b2471a93d$var$postcss.rule = (defaults)=>new $cDdV8(defaults);
$956a0d4b2471a93d$var$postcss.root = (defaults)=>new $4DHTo(defaults);
$956a0d4b2471a93d$var$postcss.document = (defaults)=>new $4Cgdx(defaults);
$956a0d4b2471a93d$var$postcss.CssSyntaxError = $6ANgp;
$956a0d4b2471a93d$var$postcss.Declaration = $gZeVH;
$956a0d4b2471a93d$var$postcss.Container = $7UdNM;
$956a0d4b2471a93d$var$postcss.Processor = $gRQ9L;
$956a0d4b2471a93d$var$postcss.Document = $4Cgdx;
$956a0d4b2471a93d$var$postcss.Comment = $fjcSu;
$956a0d4b2471a93d$var$postcss.Warning = $kFs1D;
$956a0d4b2471a93d$var$postcss.AtRule = $eIKWx;
$956a0d4b2471a93d$var$postcss.Result = $jbyo6;
$956a0d4b2471a93d$var$postcss.Input = $lirqv;
$956a0d4b2471a93d$var$postcss.Rule = $cDdV8;
$956a0d4b2471a93d$var$postcss.Root = $4DHTo;
$956a0d4b2471a93d$var$postcss.Node = $htVhF;
$5Faho.registerPostcss($956a0d4b2471a93d$var$postcss);
module.exports = $956a0d4b2471a93d$var$postcss;
$956a0d4b2471a93d$var$postcss.default = $956a0d4b2471a93d$var$postcss;

});
parcelRequire.register("6ANgp", function(module, exports) {
"use strict";

var $43njn = parcelRequire("43njn");

var $gR5sk = parcelRequire("gR5sk");
class $4ccc5198578243fb$var$CssSyntaxError extends Error {
    constructor(message, line, column, source, file, plugin){
        super(message);
        this.name = "CssSyntaxError";
        this.reason = message;
        if (file) this.file = file;
        if (source) this.source = source;
        if (plugin) this.plugin = plugin;
        if (typeof line !== "undefined" && typeof column !== "undefined") {
            if (typeof line === "number") {
                this.line = line;
                this.column = column;
            } else {
                this.line = line.line;
                this.column = line.column;
                this.endLine = column.line;
                this.endColumn = column.column;
            }
        }
        this.setMessage();
        if (Error.captureStackTrace) Error.captureStackTrace(this, $4ccc5198578243fb$var$CssSyntaxError);
    }
    setMessage() {
        this.message = this.plugin ? this.plugin + ": " : "";
        this.message += this.file ? this.file : "<css input>";
        if (typeof this.line !== "undefined") this.message += ":" + this.line + ":" + this.column;
        this.message += ": " + this.reason;
    }
    showSourceCode(color) {
        if (!this.source) return "";
        let css = this.source;
        if (color == null) color = $43njn.isColorSupported;
        if ($gR5sk) {
            if (color) css = $gR5sk(css);
        }
        let lines = css.split(/\r?\n/);
        let start = Math.max(this.line - 3, 0);
        let end = Math.min(this.line + 2, lines.length);
        let maxWidth = String(end).length;
        let mark, aside;
        if (color) {
            let { bold: bold, red: red, gray: gray } = $43njn.createColors(true);
            mark = (text)=>bold(red(text));
            aside = (text)=>gray(text);
        } else mark = aside = (str)=>str;
        return lines.slice(start, end).map((line, index)=>{
            let number = start + 1 + index;
            let gutter = " " + (" " + number).slice(-maxWidth) + " | ";
            if (number === this.line) {
                let spacing = aside(gutter.replace(/\d/g, " ")) + line.slice(0, this.column - 1).replace(/[^\t]/g, " ");
                return mark(">") + aside(gutter) + line + "\n " + spacing + mark("^");
            }
            return " " + aside(gutter) + line;
        }).join("\n");
    }
    toString() {
        let code = this.showSourceCode();
        if (code) code = "\n\n" + code + "\n";
        return this.name + ": " + this.message + code;
    }
}
module.exports = $4ccc5198578243fb$var$CssSyntaxError;
$4ccc5198578243fb$var$CssSyntaxError.default = $4ccc5198578243fb$var$CssSyntaxError;

});
parcelRequire.register("43njn", function(module, exports) {
var $2f39866b66ba7c66$var$x = String;
var $2f39866b66ba7c66$var$create = function() {
    return {
        isColorSupported: false,
        reset: $2f39866b66ba7c66$var$x,
        bold: $2f39866b66ba7c66$var$x,
        dim: $2f39866b66ba7c66$var$x,
        italic: $2f39866b66ba7c66$var$x,
        underline: $2f39866b66ba7c66$var$x,
        inverse: $2f39866b66ba7c66$var$x,
        hidden: $2f39866b66ba7c66$var$x,
        strikethrough: $2f39866b66ba7c66$var$x,
        black: $2f39866b66ba7c66$var$x,
        red: $2f39866b66ba7c66$var$x,
        green: $2f39866b66ba7c66$var$x,
        yellow: $2f39866b66ba7c66$var$x,
        blue: $2f39866b66ba7c66$var$x,
        magenta: $2f39866b66ba7c66$var$x,
        cyan: $2f39866b66ba7c66$var$x,
        white: $2f39866b66ba7c66$var$x,
        gray: $2f39866b66ba7c66$var$x,
        bgBlack: $2f39866b66ba7c66$var$x,
        bgRed: $2f39866b66ba7c66$var$x,
        bgGreen: $2f39866b66ba7c66$var$x,
        bgYellow: $2f39866b66ba7c66$var$x,
        bgBlue: $2f39866b66ba7c66$var$x,
        bgMagenta: $2f39866b66ba7c66$var$x,
        bgCyan: $2f39866b66ba7c66$var$x,
        bgWhite: $2f39866b66ba7c66$var$x
    };
};
module.exports = $2f39866b66ba7c66$var$create();
module.exports.createColors = $2f39866b66ba7c66$var$create;

});


parcelRequire.register("gZeVH", function(module, exports) {
"use strict";

var $htVhF = parcelRequire("htVhF");
class $c5ddec929df324ba$var$Declaration extends $htVhF {
    constructor(defaults){
        if (defaults && typeof defaults.value !== "undefined" && typeof defaults.value !== "string") defaults = {
            ...defaults,
            value: String(defaults.value)
        };
        super(defaults);
        this.type = "decl";
    }
    get variable() {
        return this.prop.startsWith("--") || this.prop[0] === "$";
    }
}
module.exports = $c5ddec929df324ba$var$Declaration;
$c5ddec929df324ba$var$Declaration.default = $c5ddec929df324ba$var$Declaration;

});
parcelRequire.register("htVhF", function(module, exports) {
"use strict";

var $6gWYW = parcelRequire("6gWYW");
var $cba194852a3a6cb2$require$isClean = $6gWYW.isClean;
var $cba194852a3a6cb2$require$my = $6gWYW.my;

var $6ANgp = parcelRequire("6ANgp");

var $wkS9h = parcelRequire("wkS9h");

var $5xBzD = parcelRequire("5xBzD");
function $cba194852a3a6cb2$var$cloneNode(obj, parent) {
    let cloned = new obj.constructor();
    for(let i in obj){
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        if (i === "proxyCache") continue;
        let value = obj[i];
        let type = typeof value;
        if (i === "parent" && type === "object") {
            if (parent) cloned[i] = parent;
        } else if (i === "source") cloned[i] = value;
        else if (Array.isArray(value)) cloned[i] = value.map((j)=>$cba194852a3a6cb2$var$cloneNode(j, cloned));
        else {
            if (type === "object" && value !== null) value = $cba194852a3a6cb2$var$cloneNode(value);
            cloned[i] = value;
        }
    }
    return cloned;
}
class $cba194852a3a6cb2$var$Node {
    constructor(defaults = {}){
        this.raws = {};
        this[$cba194852a3a6cb2$require$isClean] = false;
        this[$cba194852a3a6cb2$require$my] = true;
        for(let name in defaults)if (name === "nodes") {
            this.nodes = [];
            for (let node of defaults[name])if (typeof node.clone === "function") this.append(node.clone());
            else this.append(node);
        } else this[name] = defaults[name];
    }
    error(message, opts = {}) {
        if (this.source) {
            let { start: start, end: end } = this.rangeBy(opts);
            return this.source.input.error(message, {
                line: start.line,
                column: start.column
            }, {
                line: end.line,
                column: end.column
            }, opts);
        }
        return new $6ANgp(message);
    }
    warn(result, text, opts) {
        let data = {
            node: this
        };
        for(let i in opts)data[i] = opts[i];
        return result.warn(text, data);
    }
    remove() {
        if (this.parent) this.parent.removeChild(this);
        this.parent = undefined;
        return this;
    }
    toString(stringifier = $5xBzD) {
        if (stringifier.stringify) stringifier = stringifier.stringify;
        let result = "";
        stringifier(this, (i)=>{
            result += i;
        });
        return result;
    }
    assign(overrides = {}) {
        for(let name in overrides)this[name] = overrides[name];
        return this;
    }
    clone(overrides = {}) {
        let cloned = $cba194852a3a6cb2$var$cloneNode(this);
        for(let name in overrides)cloned[name] = overrides[name];
        return cloned;
    }
    cloneBefore(overrides = {}) {
        let cloned = this.clone(overrides);
        this.parent.insertBefore(this, cloned);
        return cloned;
    }
    cloneAfter(overrides = {}) {
        let cloned = this.clone(overrides);
        this.parent.insertAfter(this, cloned);
        return cloned;
    }
    replaceWith(...nodes) {
        if (this.parent) {
            let bookmark = this;
            let foundSelf = false;
            for (let node of nodes){
                if (node === this) foundSelf = true;
                else if (foundSelf) {
                    this.parent.insertAfter(bookmark, node);
                    bookmark = node;
                } else this.parent.insertBefore(bookmark, node);
            }
            if (!foundSelf) this.remove();
        }
        return this;
    }
    next() {
        if (!this.parent) return undefined;
        let index = this.parent.index(this);
        return this.parent.nodes[index + 1];
    }
    prev() {
        if (!this.parent) return undefined;
        let index = this.parent.index(this);
        return this.parent.nodes[index - 1];
    }
    before(add) {
        this.parent.insertBefore(this, add);
        return this;
    }
    after(add) {
        this.parent.insertAfter(this, add);
        return this;
    }
    root() {
        let result = this;
        while(result.parent && result.parent.type !== "document")result = result.parent;
        return result;
    }
    raw(prop, defaultType) {
        let str = new $wkS9h();
        return str.raw(this, prop, defaultType);
    }
    cleanRaws(keepBetween) {
        delete this.raws.before;
        delete this.raws.after;
        if (!keepBetween) delete this.raws.between;
    }
    toJSON(_, inputs) {
        let fixed = {};
        let emitInputs = inputs == null;
        inputs = inputs || new Map();
        let inputsNextIndex = 0;
        for(let name in this){
            if (!Object.prototype.hasOwnProperty.call(this, name)) continue;
            if (name === "parent" || name === "proxyCache") continue;
            let value = this[name];
            if (Array.isArray(value)) fixed[name] = value.map((i)=>{
                if (typeof i === "object" && i.toJSON) return i.toJSON(null, inputs);
                else return i;
            });
            else if (typeof value === "object" && value.toJSON) fixed[name] = value.toJSON(null, inputs);
            else if (name === "source") {
                let inputId = inputs.get(value.input);
                if (inputId == null) {
                    inputId = inputsNextIndex;
                    inputs.set(value.input, inputsNextIndex);
                    inputsNextIndex++;
                }
                fixed[name] = {
                    inputId: inputId,
                    start: value.start,
                    end: value.end
                };
            } else fixed[name] = value;
        }
        if (emitInputs) fixed.inputs = [
            ...inputs.keys()
        ].map((input)=>input.toJSON());
        return fixed;
    }
    positionInside(index) {
        let string = this.toString();
        let column = this.source.start.column;
        let line = this.source.start.line;
        for(let i = 0; i < index; i++)if (string[i] === "\n") {
            column = 1;
            line += 1;
        } else column += 1;
        return {
            line: line,
            column: column
        };
    }
    positionBy(opts) {
        let pos = this.source.start;
        if (opts.index) pos = this.positionInside(opts.index);
        else if (opts.word) {
            let index = this.toString().indexOf(opts.word);
            if (index !== -1) pos = this.positionInside(index);
        }
        return pos;
    }
    rangeBy(opts) {
        let start = {
            line: this.source.start.line,
            column: this.source.start.column
        };
        let end = this.source.end ? {
            line: this.source.end.line,
            column: this.source.end.column + 1
        } : {
            line: start.line,
            column: start.column + 1
        };
        if (opts.word) {
            let index = this.toString().indexOf(opts.word);
            if (index !== -1) {
                start = this.positionInside(index);
                end = this.positionInside(index + opts.word.length);
            }
        } else {
            if (opts.start) start = {
                line: opts.start.line,
                column: opts.start.column
            };
            else if (opts.index) start = this.positionInside(opts.index);
            if (opts.end) end = {
                line: opts.end.line,
                column: opts.end.column
            };
            else if (opts.endIndex) end = this.positionInside(opts.endIndex);
            else if (opts.index) end = this.positionInside(opts.index + 1);
        }
        if (end.line < start.line || end.line === start.line && end.column <= start.column) end = {
            line: start.line,
            column: start.column + 1
        };
        return {
            start: start,
            end: end
        };
    }
    getProxyProcessor() {
        return {
            set (node, prop, value) {
                if (node[prop] === value) return true;
                node[prop] = value;
                if (prop === "prop" || prop === "value" || prop === "name" || prop === "params" || prop === "important" || /* c8 ignore next */ prop === "text") node.markDirty();
                return true;
            },
            get (node, prop) {
                if (prop === "proxyOf") return node;
                else if (prop === "root") return ()=>node.root().toProxy();
                else return node[prop];
            }
        };
    }
    toProxy() {
        if (!this.proxyCache) this.proxyCache = new Proxy(this, this.getProxyProcessor());
        return this.proxyCache;
    }
    addToError(error) {
        error.postcssNode = this;
        if (error.stack && this.source && /\n\s{4}at /.test(error.stack)) {
            let s = this.source;
            error.stack = error.stack.replace(/\n\s{4}at /, `$&${s.input.from}:${s.start.line}:${s.start.column}$&`);
        }
        return error;
    }
    markDirty() {
        if (this[$cba194852a3a6cb2$require$isClean]) {
            this[$cba194852a3a6cb2$require$isClean] = false;
            let next = this;
            while(next = next.parent)next[$cba194852a3a6cb2$require$isClean] = false;
        }
    }
    get proxyOf() {
        return this;
    }
}
module.exports = $cba194852a3a6cb2$var$Node;
$cba194852a3a6cb2$var$Node.default = $cba194852a3a6cb2$var$Node;

});
parcelRequire.register("6gWYW", function(module, exports) {

$parcel$export(module.exports, "isClean", () => $4911fd4d4ac62e01$export$ae5e7911ce0728f9, (v) => $4911fd4d4ac62e01$export$ae5e7911ce0728f9 = v);
$parcel$export(module.exports, "my", () => $4911fd4d4ac62e01$export$94fa0a6beb22f989, (v) => $4911fd4d4ac62e01$export$94fa0a6beb22f989 = v);
var $4911fd4d4ac62e01$export$ae5e7911ce0728f9;
var $4911fd4d4ac62e01$export$94fa0a6beb22f989;
"use strict";
$4911fd4d4ac62e01$export$ae5e7911ce0728f9 = Symbol("isClean");
$4911fd4d4ac62e01$export$94fa0a6beb22f989 = Symbol("my");

});

parcelRequire.register("wkS9h", function(module, exports) {
"use strict";
const $06132e1730eba394$var$DEFAULT_RAW = {
    colon: ": ",
    indent: "    ",
    beforeDecl: "\n",
    beforeRule: "\n",
    beforeOpen: " ",
    beforeClose: "\n",
    beforeComment: "\n",
    after: "\n",
    emptyBody: "",
    commentLeft: " ",
    commentRight: " ",
    semicolon: false
};
function $06132e1730eba394$var$capitalize(str) {
    return str[0].toUpperCase() + str.slice(1);
}
class $06132e1730eba394$var$Stringifier {
    constructor(builder){
        this.builder = builder;
    }
    stringify(node, semicolon) {
        /* c8 ignore start */ if (!this[node.type]) throw new Error("Unknown AST node type " + node.type + ". " + "Maybe you need to change PostCSS stringifier.");
        /* c8 ignore stop */ this[node.type](node, semicolon);
    }
    document(node) {
        this.body(node);
    }
    root(node) {
        this.body(node);
        if (node.raws.after) this.builder(node.raws.after);
    }
    comment(node) {
        let left = this.raw(node, "left", "commentLeft");
        let right = this.raw(node, "right", "commentRight");
        this.builder("/*" + left + node.text + right + "*/", node);
    }
    decl(node, semicolon) {
        let between = this.raw(node, "between", "colon");
        let string = node.prop + between + this.rawValue(node, "value");
        if (node.important) string += node.raws.important || " !important";
        if (semicolon) string += ";";
        this.builder(string, node);
    }
    rule(node) {
        this.block(node, this.rawValue(node, "selector"));
        if (node.raws.ownSemicolon) this.builder(node.raws.ownSemicolon, node, "end");
    }
    atrule(node, semicolon) {
        let name = "@" + node.name;
        let params = node.params ? this.rawValue(node, "params") : "";
        if (typeof node.raws.afterName !== "undefined") name += node.raws.afterName;
        else if (params) name += " ";
        if (node.nodes) this.block(node, name + params);
        else {
            let end = (node.raws.between || "") + (semicolon ? ";" : "");
            this.builder(name + params + end, node);
        }
    }
    body(node) {
        let last = node.nodes.length - 1;
        while(last > 0){
            if (node.nodes[last].type !== "comment") break;
            last -= 1;
        }
        let semicolon = this.raw(node, "semicolon");
        for(let i = 0; i < node.nodes.length; i++){
            let child = node.nodes[i];
            let before = this.raw(child, "before");
            if (before) this.builder(before);
            this.stringify(child, last !== i || semicolon);
        }
    }
    block(node, start) {
        let between = this.raw(node, "between", "beforeOpen");
        this.builder(start + between + "{", node, "start");
        let after;
        if (node.nodes && node.nodes.length) {
            this.body(node);
            after = this.raw(node, "after");
        } else after = this.raw(node, "after", "emptyBody");
        if (after) this.builder(after);
        this.builder("}", node, "end");
    }
    raw(node, own, detect) {
        let value;
        if (!detect) detect = own;
        // Already had
        if (own) {
            value = node.raws[own];
            if (typeof value !== "undefined") return value;
        }
        let parent = node.parent;
        if (detect === "before") {
            // Hack for first rule in CSS
            if (!parent || parent.type === "root" && parent.first === node) return "";
            // `root` nodes in `document` should use only their own raws
            if (parent && parent.type === "document") return "";
        }
        // Floating child without parent
        if (!parent) return $06132e1730eba394$var$DEFAULT_RAW[detect];
        // Detect style by other nodes
        let root = node.root();
        if (!root.rawCache) root.rawCache = {};
        if (typeof root.rawCache[detect] !== "undefined") return root.rawCache[detect];
        if (detect === "before" || detect === "after") return this.beforeAfter(node, detect);
        else {
            let method = "raw" + $06132e1730eba394$var$capitalize(detect);
            if (this[method]) value = this[method](root, node);
            else root.walk((i)=>{
                value = i.raws[own];
                if (typeof value !== "undefined") return false;
            });
        }
        if (typeof value === "undefined") value = $06132e1730eba394$var$DEFAULT_RAW[detect];
        root.rawCache[detect] = value;
        return value;
    }
    rawSemicolon(root) {
        let value;
        root.walk((i)=>{
            if (i.nodes && i.nodes.length && i.last.type === "decl") {
                value = i.raws.semicolon;
                if (typeof value !== "undefined") return false;
            }
        });
        return value;
    }
    rawEmptyBody(root) {
        let value;
        root.walk((i)=>{
            if (i.nodes && i.nodes.length === 0) {
                value = i.raws.after;
                if (typeof value !== "undefined") return false;
            }
        });
        return value;
    }
    rawIndent(root) {
        if (root.raws.indent) return root.raws.indent;
        let value;
        root.walk((i)=>{
            let p = i.parent;
            if (p && p !== root && p.parent && p.parent === root) {
                if (typeof i.raws.before !== "undefined") {
                    let parts = i.raws.before.split("\n");
                    value = parts[parts.length - 1];
                    value = value.replace(/\S/g, "");
                    return false;
                }
            }
        });
        return value;
    }
    rawBeforeComment(root, node) {
        let value;
        root.walkComments((i)=>{
            if (typeof i.raws.before !== "undefined") {
                value = i.raws.before;
                if (value.includes("\n")) value = value.replace(/[^\n]+$/, "");
                return false;
            }
        });
        if (typeof value === "undefined") value = this.raw(node, null, "beforeDecl");
        else if (value) value = value.replace(/\S/g, "");
        return value;
    }
    rawBeforeDecl(root, node) {
        let value;
        root.walkDecls((i)=>{
            if (typeof i.raws.before !== "undefined") {
                value = i.raws.before;
                if (value.includes("\n")) value = value.replace(/[^\n]+$/, "");
                return false;
            }
        });
        if (typeof value === "undefined") value = this.raw(node, null, "beforeRule");
        else if (value) value = value.replace(/\S/g, "");
        return value;
    }
    rawBeforeRule(root) {
        let value;
        root.walk((i)=>{
            if (i.nodes && (i.parent !== root || root.first !== i)) {
                if (typeof i.raws.before !== "undefined") {
                    value = i.raws.before;
                    if (value.includes("\n")) value = value.replace(/[^\n]+$/, "");
                    return false;
                }
            }
        });
        if (value) value = value.replace(/\S/g, "");
        return value;
    }
    rawBeforeClose(root) {
        let value;
        root.walk((i)=>{
            if (i.nodes && i.nodes.length > 0) {
                if (typeof i.raws.after !== "undefined") {
                    value = i.raws.after;
                    if (value.includes("\n")) value = value.replace(/[^\n]+$/, "");
                    return false;
                }
            }
        });
        if (value) value = value.replace(/\S/g, "");
        return value;
    }
    rawBeforeOpen(root) {
        let value;
        root.walk((i)=>{
            if (i.type !== "decl") {
                value = i.raws.between;
                if (typeof value !== "undefined") return false;
            }
        });
        return value;
    }
    rawColon(root) {
        let value;
        root.walkDecls((i)=>{
            if (typeof i.raws.between !== "undefined") {
                value = i.raws.between.replace(/[^\s:]/g, "");
                return false;
            }
        });
        return value;
    }
    beforeAfter(node, detect) {
        let value;
        if (node.type === "decl") value = this.raw(node, null, "beforeDecl");
        else if (node.type === "comment") value = this.raw(node, null, "beforeComment");
        else if (detect === "before") value = this.raw(node, null, "beforeRule");
        else value = this.raw(node, null, "beforeClose");
        let buf = node.parent;
        let depth = 0;
        while(buf && buf.type !== "root"){
            depth += 1;
            buf = buf.parent;
        }
        if (value.includes("\n")) {
            let indent = this.raw(node, null, "indent");
            if (indent.length) for(let step = 0; step < depth; step++)value += indent;
        }
        return value;
    }
    rawValue(node, prop) {
        let value = node[prop];
        let raw = node.raws[prop];
        if (raw && raw.value === value) return raw.raw;
        return value;
    }
}
module.exports = $06132e1730eba394$var$Stringifier;
$06132e1730eba394$var$Stringifier.default = $06132e1730eba394$var$Stringifier;

});

parcelRequire.register("5xBzD", function(module, exports) {
"use strict";

var $wkS9h = parcelRequire("wkS9h");
function $408d2e31fb9460ab$var$stringify(node, builder) {
    let str = new $wkS9h(builder);
    str.stringify(node);
}
module.exports = $408d2e31fb9460ab$var$stringify;
$408d2e31fb9460ab$var$stringify.default = $408d2e31fb9460ab$var$stringify;

});



parcelRequire.register("5Faho", function(module, exports) {
"use strict";

var $6gWYW = parcelRequire("6gWYW");
var $41f8c160e2ab1819$require$isClean = $6gWYW.isClean;
var $41f8c160e2ab1819$require$my = $6gWYW.my;

var $3dq0N = parcelRequire("3dq0N");

var $5xBzD = parcelRequire("5xBzD");

var $7UdNM = parcelRequire("7UdNM");

var $4Cgdx = parcelRequire("4Cgdx");
parcelRequire("5LKcu");

var $jbyo6 = parcelRequire("jbyo6");

var $79gLn = parcelRequire("79gLn");

var $4DHTo = parcelRequire("4DHTo");
const $41f8c160e2ab1819$var$TYPE_TO_CLASS_NAME = {
    document: "Document",
    root: "Root",
    atrule: "AtRule",
    rule: "Rule",
    decl: "Declaration",
    comment: "Comment"
};
const $41f8c160e2ab1819$var$PLUGIN_PROPS = {
    postcssPlugin: true,
    prepare: true,
    Once: true,
    Document: true,
    Root: true,
    Declaration: true,
    Rule: true,
    AtRule: true,
    Comment: true,
    DeclarationExit: true,
    RuleExit: true,
    AtRuleExit: true,
    CommentExit: true,
    RootExit: true,
    DocumentExit: true,
    OnceExit: true
};
const $41f8c160e2ab1819$var$NOT_VISITORS = {
    postcssPlugin: true,
    prepare: true,
    Once: true
};
const $41f8c160e2ab1819$var$CHILDREN = 0;
function $41f8c160e2ab1819$var$isPromise(obj) {
    return typeof obj === "object" && typeof obj.then === "function";
}
function $41f8c160e2ab1819$var$getEvents(node) {
    let key = false;
    let type = $41f8c160e2ab1819$var$TYPE_TO_CLASS_NAME[node.type];
    if (node.type === "decl") key = node.prop.toLowerCase();
    else if (node.type === "atrule") key = node.name.toLowerCase();
    if (key && node.append) return [
        type,
        type + "-" + key,
        $41f8c160e2ab1819$var$CHILDREN,
        type + "Exit",
        type + "Exit-" + key
    ];
    else if (key) return [
        type,
        type + "-" + key,
        type + "Exit",
        type + "Exit-" + key
    ];
    else if (node.append) return [
        type,
        $41f8c160e2ab1819$var$CHILDREN,
        type + "Exit"
    ];
    else return [
        type,
        type + "Exit"
    ];
}
function $41f8c160e2ab1819$var$toStack(node) {
    let events;
    if (node.type === "document") events = [
        "Document",
        $41f8c160e2ab1819$var$CHILDREN,
        "DocumentExit"
    ];
    else if (node.type === "root") events = [
        "Root",
        $41f8c160e2ab1819$var$CHILDREN,
        "RootExit"
    ];
    else events = $41f8c160e2ab1819$var$getEvents(node);
    return {
        node: node,
        events: events,
        eventIndex: 0,
        visitors: [],
        visitorIndex: 0,
        iterator: 0
    };
}
function $41f8c160e2ab1819$var$cleanMarks(node) {
    node[$41f8c160e2ab1819$require$isClean] = false;
    if (node.nodes) node.nodes.forEach((i)=>$41f8c160e2ab1819$var$cleanMarks(i));
    return node;
}
let $41f8c160e2ab1819$var$postcss = {};
class $41f8c160e2ab1819$var$LazyResult {
    constructor(processor, css, opts){
        this.stringified = false;
        this.processed = false;
        let root;
        if (typeof css === "object" && css !== null && (css.type === "root" || css.type === "document")) root = $41f8c160e2ab1819$var$cleanMarks(css);
        else if (css instanceof $41f8c160e2ab1819$var$LazyResult || css instanceof $jbyo6) {
            root = $41f8c160e2ab1819$var$cleanMarks(css.root);
            if (css.map) {
                if (typeof opts.map === "undefined") opts.map = {};
                if (!opts.map.inline) opts.map.inline = false;
                opts.map.prev = css.map;
            }
        } else {
            let parser = $79gLn;
            if (opts.syntax) parser = opts.syntax.parse;
            if (opts.parser) parser = opts.parser;
            if (parser.parse) parser = parser.parse;
            try {
                root = parser(css, opts);
            } catch (error) {
                this.processed = true;
                this.error = error;
            }
            if (root && !root[$41f8c160e2ab1819$require$my]) /* c8 ignore next 2 */ $7UdNM.rebuild(root);
        }
        this.result = new $jbyo6(processor, root, opts);
        this.helpers = {
            ...$41f8c160e2ab1819$var$postcss,
            result: this.result,
            postcss: $41f8c160e2ab1819$var$postcss
        };
        this.plugins = this.processor.plugins.map((plugin)=>{
            if (typeof plugin === "object" && plugin.prepare) return {
                ...plugin,
                ...plugin.prepare(this.result)
            };
            else return plugin;
        });
    }
    get [Symbol.toStringTag]() {
        return "LazyResult";
    }
    get processor() {
        return this.result.processor;
    }
    get opts() {
        return this.result.opts;
    }
    get css() {
        return this.stringify().css;
    }
    get content() {
        return this.stringify().content;
    }
    get map() {
        return this.stringify().map;
    }
    get root() {
        return this.sync().root;
    }
    get messages() {
        return this.sync().messages;
    }
    warnings() {
        return this.sync().warnings();
    }
    toString() {
        return this.css;
    }
    then(onFulfilled, onRejected) {
        return this.async().then(onFulfilled, onRejected);
    }
    catch(onRejected) {
        return this.async().catch(onRejected);
    }
    finally(onFinally) {
        return this.async().then(onFinally, onFinally);
    }
    async() {
        if (this.error) return Promise.reject(this.error);
        if (this.processed) return Promise.resolve(this.result);
        if (!this.processing) this.processing = this.runAsync();
        return this.processing;
    }
    sync() {
        if (this.error) throw this.error;
        if (this.processed) return this.result;
        this.processed = true;
        if (this.processing) throw this.getAsyncError();
        for (let plugin of this.plugins){
            let promise = this.runOnRoot(plugin);
            if ($41f8c160e2ab1819$var$isPromise(promise)) throw this.getAsyncError();
        }
        this.prepareVisitors();
        if (this.hasListener) {
            let root = this.result.root;
            while(!root[$41f8c160e2ab1819$require$isClean]){
                root[$41f8c160e2ab1819$require$isClean] = true;
                this.walkSync(root);
            }
            if (this.listeners.OnceExit) {
                if (root.type === "document") for (let subRoot of root.nodes)this.visitSync(this.listeners.OnceExit, subRoot);
                else this.visitSync(this.listeners.OnceExit, root);
            }
        }
        return this.result;
    }
    stringify() {
        if (this.error) throw this.error;
        if (this.stringified) return this.result;
        this.stringified = true;
        this.sync();
        let opts = this.result.opts;
        let str = $5xBzD;
        if (opts.syntax) str = opts.syntax.stringify;
        if (opts.stringifier) str = opts.stringifier;
        if (str.stringify) str = str.stringify;
        let map = new $3dq0N(str, this.result.root, this.result.opts);
        let data = map.generate();
        this.result.css = data[0];
        this.result.map = data[1];
        return this.result;
    }
    walkSync(node) {
        node[$41f8c160e2ab1819$require$isClean] = true;
        let events = $41f8c160e2ab1819$var$getEvents(node);
        for (let event of events){
            if (event === $41f8c160e2ab1819$var$CHILDREN) {
                if (node.nodes) node.each((child)=>{
                    if (!child[$41f8c160e2ab1819$require$isClean]) this.walkSync(child);
                });
            } else {
                let visitors = this.listeners[event];
                if (visitors) {
                    if (this.visitSync(visitors, node.toProxy())) return;
                }
            }
        }
    }
    visitSync(visitors, node) {
        for (let [plugin, visitor] of visitors){
            this.result.lastPlugin = plugin;
            let promise;
            try {
                promise = visitor(node, this.helpers);
            } catch (e) {
                throw this.handleError(e, node.proxyOf);
            }
            if (node.type !== "root" && node.type !== "document" && !node.parent) return true;
            if ($41f8c160e2ab1819$var$isPromise(promise)) throw this.getAsyncError();
        }
    }
    runOnRoot(plugin) {
        this.result.lastPlugin = plugin;
        try {
            if (typeof plugin === "object" && plugin.Once) {
                if (this.result.root.type === "document") {
                    let roots = this.result.root.nodes.map((root)=>plugin.Once(root, this.helpers));
                    if ($41f8c160e2ab1819$var$isPromise(roots[0])) return Promise.all(roots);
                    return roots;
                }
                return plugin.Once(this.result.root, this.helpers);
            } else if (typeof plugin === "function") return plugin(this.result.root, this.result);
        } catch (error) {
            throw this.handleError(error);
        }
    }
    getAsyncError() {
        throw new Error("Use process(css).then(cb) to work with async plugins");
    }
    handleError(error, node) {
        let plugin = this.result.lastPlugin;
        try {
            if (node) node.addToError(error);
            this.error = error;
            if (error.name === "CssSyntaxError" && !error.plugin) {
                error.plugin = plugin.postcssPlugin;
                error.setMessage();
            } else plugin.postcssVersion;
        } catch (err) {
            /* c8 ignore next 3 */ // eslint-disable-next-line no-console
            if (console && console.error) console.error(err);
        }
        return error;
    }
    async runAsync() {
        this.plugin = 0;
        for(let i = 0; i < this.plugins.length; i++){
            let plugin = this.plugins[i];
            let promise = this.runOnRoot(plugin);
            if ($41f8c160e2ab1819$var$isPromise(promise)) try {
                await promise;
            } catch (error) {
                throw this.handleError(error);
            }
        }
        this.prepareVisitors();
        if (this.hasListener) {
            let root = this.result.root;
            while(!root[$41f8c160e2ab1819$require$isClean]){
                root[$41f8c160e2ab1819$require$isClean] = true;
                let stack = [
                    $41f8c160e2ab1819$var$toStack(root)
                ];
                while(stack.length > 0){
                    let promise = this.visitTick(stack);
                    if ($41f8c160e2ab1819$var$isPromise(promise)) try {
                        await promise;
                    } catch (e) {
                        let node = stack[stack.length - 1].node;
                        throw this.handleError(e, node);
                    }
                }
            }
            if (this.listeners.OnceExit) for (let [plugin, visitor] of this.listeners.OnceExit){
                this.result.lastPlugin = plugin;
                try {
                    if (root.type === "document") {
                        let roots = root.nodes.map((subRoot)=>visitor(subRoot, this.helpers));
                        await Promise.all(roots);
                    } else await visitor(root, this.helpers);
                } catch (e) {
                    throw this.handleError(e);
                }
            }
        }
        this.processed = true;
        return this.stringify();
    }
    prepareVisitors() {
        this.listeners = {};
        let add = (plugin, type, cb)=>{
            if (!this.listeners[type]) this.listeners[type] = [];
            this.listeners[type].push([
                plugin,
                cb
            ]);
        };
        for (let plugin of this.plugins){
            if (typeof plugin === "object") for(let event in plugin){
                if (!$41f8c160e2ab1819$var$PLUGIN_PROPS[event] && /^[A-Z]/.test(event)) throw new Error(`Unknown event ${event} in ${plugin.postcssPlugin}. ` + `Try to update PostCSS (${this.processor.version} now).`);
                if (!$41f8c160e2ab1819$var$NOT_VISITORS[event]) {
                    if (typeof plugin[event] === "object") {
                        for(let filter in plugin[event])if (filter === "*") add(plugin, event, plugin[event][filter]);
                        else add(plugin, event + "-" + filter.toLowerCase(), plugin[event][filter]);
                    } else if (typeof plugin[event] === "function") add(plugin, event, plugin[event]);
                }
            }
        }
        this.hasListener = Object.keys(this.listeners).length > 0;
    }
    visitTick(stack) {
        let visit = stack[stack.length - 1];
        let { node: node, visitors: visitors } = visit;
        if (node.type !== "root" && node.type !== "document" && !node.parent) {
            stack.pop();
            return;
        }
        if (visitors.length > 0 && visit.visitorIndex < visitors.length) {
            let [plugin, visitor] = visitors[visit.visitorIndex];
            visit.visitorIndex += 1;
            if (visit.visitorIndex === visitors.length) {
                visit.visitors = [];
                visit.visitorIndex = 0;
            }
            this.result.lastPlugin = plugin;
            try {
                return visitor(node.toProxy(), this.helpers);
            } catch (e) {
                throw this.handleError(e, node);
            }
        }
        if (visit.iterator !== 0) {
            let iterator = visit.iterator;
            let child;
            while(child = node.nodes[node.indexes[iterator]]){
                node.indexes[iterator] += 1;
                if (!child[$41f8c160e2ab1819$require$isClean]) {
                    child[$41f8c160e2ab1819$require$isClean] = true;
                    stack.push($41f8c160e2ab1819$var$toStack(child));
                    return;
                }
            }
            visit.iterator = 0;
            delete node.indexes[iterator];
        }
        let events = visit.events;
        while(visit.eventIndex < events.length){
            let event = events[visit.eventIndex];
            visit.eventIndex += 1;
            if (event === $41f8c160e2ab1819$var$CHILDREN) {
                if (node.nodes && node.nodes.length) {
                    node[$41f8c160e2ab1819$require$isClean] = true;
                    visit.iterator = node.getIterator();
                }
                return;
            } else if (this.listeners[event]) {
                visit.visitors = this.listeners[event];
                return;
            }
        }
        stack.pop();
    }
}
$41f8c160e2ab1819$var$LazyResult.registerPostcss = (dependant)=>{
    $41f8c160e2ab1819$var$postcss = dependant;
};
module.exports = $41f8c160e2ab1819$var$LazyResult;
$41f8c160e2ab1819$var$LazyResult.default = $41f8c160e2ab1819$var$LazyResult;
$4DHTo.registerLazyResult($41f8c160e2ab1819$var$LazyResult);
$4Cgdx.registerLazyResult($41f8c160e2ab1819$var$LazyResult);

});
parcelRequire.register("3dq0N", function(module, exports) {

var $cBXue = parcelRequire("cBXue");
var $2576c367bb6895e5$require$Buffer = $cBXue.Buffer;
"use strict";

var $gR5sk = parcelRequire("gR5sk");
var $2576c367bb6895e5$require$SourceMapConsumer = $gR5sk.SourceMapConsumer;
var $2576c367bb6895e5$require$SourceMapGenerator = $gR5sk.SourceMapGenerator;

var $gR5sk = parcelRequire("gR5sk");
var $2576c367bb6895e5$require$dirname = $gR5sk.dirname;
var $2576c367bb6895e5$require$resolve = $gR5sk.resolve;
var $2576c367bb6895e5$require$relative = $gR5sk.relative;
var $2576c367bb6895e5$require$sep = $gR5sk.sep;

var $gR5sk = parcelRequire("gR5sk");
var $2576c367bb6895e5$require$pathToFileURL = $gR5sk.pathToFileURL;

var $lirqv = parcelRequire("lirqv");
let $2576c367bb6895e5$var$sourceMapAvailable = Boolean($2576c367bb6895e5$require$SourceMapConsumer && $2576c367bb6895e5$require$SourceMapGenerator);
let $2576c367bb6895e5$var$pathAvailable = Boolean($2576c367bb6895e5$require$dirname && $2576c367bb6895e5$require$resolve && $2576c367bb6895e5$require$relative && $2576c367bb6895e5$require$sep);
class $2576c367bb6895e5$var$MapGenerator {
    constructor(stringify, root, opts, cssString){
        this.stringify = stringify;
        this.mapOpts = opts.map || {};
        this.root = root;
        this.opts = opts;
        this.css = cssString;
        this.usesFileUrls = !this.mapOpts.from && this.mapOpts.absolute;
    }
    isMap() {
        if (typeof this.opts.map !== "undefined") return !!this.opts.map;
        return this.previous().length > 0;
    }
    previous() {
        if (!this.previousMaps) {
            this.previousMaps = [];
            if (this.root) this.root.walk((node)=>{
                if (node.source && node.source.input.map) {
                    let map = node.source.input.map;
                    if (!this.previousMaps.includes(map)) this.previousMaps.push(map);
                }
            });
            else {
                let input = new $lirqv(this.css, this.opts);
                if (input.map) this.previousMaps.push(input.map);
            }
        }
        return this.previousMaps;
    }
    isInline() {
        if (typeof this.mapOpts.inline !== "undefined") return this.mapOpts.inline;
        let annotation = this.mapOpts.annotation;
        if (typeof annotation !== "undefined" && annotation !== true) return false;
        if (this.previous().length) return this.previous().some((i)=>i.inline);
        return true;
    }
    isSourcesContent() {
        if (typeof this.mapOpts.sourcesContent !== "undefined") return this.mapOpts.sourcesContent;
        if (this.previous().length) return this.previous().some((i)=>i.withContent());
        return true;
    }
    clearAnnotation() {
        if (this.mapOpts.annotation === false) return;
        if (this.root) {
            let node;
            for(let i = this.root.nodes.length - 1; i >= 0; i--){
                node = this.root.nodes[i];
                if (node.type !== "comment") continue;
                if (node.text.indexOf("# sourceMappingURL=") === 0) this.root.removeChild(i);
            }
        } else if (this.css) this.css = this.css.replace(/(\n)?\/\*#[\S\s]*?\*\/$/gm, "");
    }
    setSourcesContent() {
        let already = {};
        if (this.root) this.root.walk((node)=>{
            if (node.source) {
                let from = node.source.input.from;
                if (from && !already[from]) {
                    already[from] = true;
                    let fromUrl = this.usesFileUrls ? this.toFileUrl(from) : this.toUrl(this.path(from));
                    this.map.setSourceContent(fromUrl, node.source.input.css);
                }
            }
        });
        else if (this.css) {
            let from = this.opts.from ? this.toUrl(this.path(this.opts.from)) : "<no source>";
            this.map.setSourceContent(from, this.css);
        }
    }
    applyPrevMaps() {
        for (let prev of this.previous()){
            let from = this.toUrl(this.path(prev.file));
            let root = prev.root || $2576c367bb6895e5$require$dirname(prev.file);
            let map;
            if (this.mapOpts.sourcesContent === false) {
                map = new $2576c367bb6895e5$require$SourceMapConsumer(prev.text);
                if (map.sourcesContent) map.sourcesContent = map.sourcesContent.map(()=>null);
            } else map = prev.consumer();
            this.map.applySourceMap(map, from, this.toUrl(this.path(root)));
        }
    }
    isAnnotation() {
        if (this.isInline()) return true;
        if (typeof this.mapOpts.annotation !== "undefined") return this.mapOpts.annotation;
        if (this.previous().length) return this.previous().some((i)=>i.annotation);
        return true;
    }
    toBase64(str) {
        if ($2576c367bb6895e5$require$Buffer) return $2576c367bb6895e5$require$Buffer.from(str).toString("base64");
        else return window.btoa(unescape(encodeURIComponent(str)));
    }
    addAnnotation() {
        let content;
        if (this.isInline()) content = "data:application/json;base64," + this.toBase64(this.map.toString());
        else if (typeof this.mapOpts.annotation === "string") content = this.mapOpts.annotation;
        else if (typeof this.mapOpts.annotation === "function") content = this.mapOpts.annotation(this.opts.to, this.root);
        else content = this.outputFile() + ".map";
        let eol = "\n";
        if (this.css.includes("\r\n")) eol = "\r\n";
        this.css += eol + "/*# sourceMappingURL=" + content + " */";
    }
    outputFile() {
        if (this.opts.to) return this.path(this.opts.to);
        else if (this.opts.from) return this.path(this.opts.from);
        else return "to.css";
    }
    generateMap() {
        if (this.root) this.generateString();
        else if (this.previous().length === 1) {
            let prev = this.previous()[0].consumer();
            prev.file = this.outputFile();
            this.map = $2576c367bb6895e5$require$SourceMapGenerator.fromSourceMap(prev);
        } else {
            this.map = new $2576c367bb6895e5$require$SourceMapGenerator({
                file: this.outputFile()
            });
            this.map.addMapping({
                source: this.opts.from ? this.toUrl(this.path(this.opts.from)) : "<no source>",
                generated: {
                    line: 1,
                    column: 0
                },
                original: {
                    line: 1,
                    column: 0
                }
            });
        }
        if (this.isSourcesContent()) this.setSourcesContent();
        if (this.root && this.previous().length > 0) this.applyPrevMaps();
        if (this.isAnnotation()) this.addAnnotation();
        if (this.isInline()) return [
            this.css
        ];
        else return [
            this.css,
            this.map
        ];
    }
    path(file) {
        if (file.indexOf("<") === 0) return file;
        if (/^\w+:\/\//.test(file)) return file;
        if (this.mapOpts.absolute) return file;
        let from = this.opts.to ? $2576c367bb6895e5$require$dirname(this.opts.to) : ".";
        if (typeof this.mapOpts.annotation === "string") from = $2576c367bb6895e5$require$dirname($2576c367bb6895e5$require$resolve(from, this.mapOpts.annotation));
        file = $2576c367bb6895e5$require$relative(from, file);
        return file;
    }
    toUrl(path) {
        if ($2576c367bb6895e5$require$sep === "\\") path = path.replace(/\\/g, "/");
        return encodeURI(path).replace(/[#?]/g, encodeURIComponent);
    }
    toFileUrl(path) {
        if ($2576c367bb6895e5$require$pathToFileURL) return $2576c367bb6895e5$require$pathToFileURL(path).toString();
        else throw new Error("`map.absolute` option is not available in this PostCSS build");
    }
    sourcePath(node) {
        if (this.mapOpts.from) return this.toUrl(this.mapOpts.from);
        else if (this.usesFileUrls) return this.toFileUrl(node.source.input.from);
        else return this.toUrl(this.path(node.source.input.from));
    }
    generateString() {
        this.css = "";
        this.map = new $2576c367bb6895e5$require$SourceMapGenerator({
            file: this.outputFile()
        });
        let line = 1;
        let column = 1;
        let noSource = "<no source>";
        let mapping = {
            source: "",
            generated: {
                line: 0,
                column: 0
            },
            original: {
                line: 0,
                column: 0
            }
        };
        let lines, last;
        this.stringify(this.root, (str, node, type)=>{
            this.css += str;
            if (node && type !== "end") {
                mapping.generated.line = line;
                mapping.generated.column = column - 1;
                if (node.source && node.source.start) {
                    mapping.source = this.sourcePath(node);
                    mapping.original.line = node.source.start.line;
                    mapping.original.column = node.source.start.column - 1;
                    this.map.addMapping(mapping);
                } else {
                    mapping.source = noSource;
                    mapping.original.line = 1;
                    mapping.original.column = 0;
                    this.map.addMapping(mapping);
                }
            }
            lines = str.match(/\n/g);
            if (lines) {
                line += lines.length;
                last = str.lastIndexOf("\n");
                column = str.length - last;
            } else column += str.length;
            if (node && type !== "start") {
                let p = node.parent || {
                    raws: {}
                };
                let childless = node.type === "decl" || node.type === "atrule" && !node.nodes;
                if (!childless || node !== p.last || p.raws.semicolon) {
                    if (node.source && node.source.end) {
                        mapping.source = this.sourcePath(node);
                        mapping.original.line = node.source.end.line;
                        mapping.original.column = node.source.end.column - 1;
                        mapping.generated.line = line;
                        mapping.generated.column = column - 2;
                        this.map.addMapping(mapping);
                    } else {
                        mapping.source = noSource;
                        mapping.original.line = 1;
                        mapping.original.column = 0;
                        mapping.generated.line = line;
                        mapping.generated.column = column - 1;
                        this.map.addMapping(mapping);
                    }
                }
            }
        });
    }
    generate() {
        this.clearAnnotation();
        if ($2576c367bb6895e5$var$pathAvailable && $2576c367bb6895e5$var$sourceMapAvailable && this.isMap()) return this.generateMap();
        else {
            let result = "";
            this.stringify(this.root, (i)=>{
                result += i;
            });
            return [
                result
            ];
        }
    }
}
module.exports = $2576c367bb6895e5$var$MapGenerator;

});
parcelRequire.register("lirqv", function(module, exports) {
"use strict";

var $gR5sk = parcelRequire("gR5sk");
var $f8108dbe47027861$require$SourceMapConsumer = $gR5sk.SourceMapConsumer;
var $f8108dbe47027861$require$SourceMapGenerator = $gR5sk.SourceMapGenerator;

var $gR5sk = parcelRequire("gR5sk");
var $f8108dbe47027861$require$fileURLToPath = $gR5sk.fileURLToPath;
var $f8108dbe47027861$require$pathToFileURL = $gR5sk.pathToFileURL;

var $gR5sk = parcelRequire("gR5sk");
var $f8108dbe47027861$require$resolve = $gR5sk.resolve;
var $f8108dbe47027861$require$isAbsolute = $gR5sk.isAbsolute;

var $1Owuo = parcelRequire("1Owuo");
var $f8108dbe47027861$require$nanoid = $1Owuo.nanoid;

var $gR5sk = parcelRequire("gR5sk");

var $6ANgp = parcelRequire("6ANgp");

var $7HRSx = parcelRequire("7HRSx");
let $f8108dbe47027861$var$fromOffsetCache = Symbol("fromOffsetCache");
let $f8108dbe47027861$var$sourceMapAvailable = Boolean($f8108dbe47027861$require$SourceMapConsumer && $f8108dbe47027861$require$SourceMapGenerator);
let $f8108dbe47027861$var$pathAvailable = Boolean($f8108dbe47027861$require$resolve && $f8108dbe47027861$require$isAbsolute);
class $f8108dbe47027861$var$Input {
    constructor(css, opts = {}){
        if (css === null || typeof css === "undefined" || typeof css === "object" && !css.toString) throw new Error(`PostCSS received ${css} instead of CSS string`);
        this.css = css.toString();
        if (this.css[0] === "\uFEFF" || this.css[0] === "￾") {
            this.hasBOM = true;
            this.css = this.css.slice(1);
        } else this.hasBOM = false;
        if (opts.from) {
            if (!$f8108dbe47027861$var$pathAvailable || /^\w+:\/\//.test(opts.from) || $f8108dbe47027861$require$isAbsolute(opts.from)) this.file = opts.from;
            else this.file = $f8108dbe47027861$require$resolve(opts.from);
        }
        if ($f8108dbe47027861$var$pathAvailable && $f8108dbe47027861$var$sourceMapAvailable) {
            let map = new $7HRSx(this.css, opts);
            if (map.text) {
                this.map = map;
                let file = map.consumer().file;
                if (!this.file && file) this.file = this.mapResolve(file);
            }
        }
        if (!this.file) this.id = "<input css " + $f8108dbe47027861$require$nanoid(6) + ">";
        if (this.map) this.map.file = this.from;
    }
    fromOffset(offset) {
        let lastLine, lineToIndex;
        if (!this[$f8108dbe47027861$var$fromOffsetCache]) {
            let lines = this.css.split("\n");
            lineToIndex = new Array(lines.length);
            let prevIndex = 0;
            for(let i = 0, l = lines.length; i < l; i++){
                lineToIndex[i] = prevIndex;
                prevIndex += lines[i].length + 1;
            }
            this[$f8108dbe47027861$var$fromOffsetCache] = lineToIndex;
        } else lineToIndex = this[$f8108dbe47027861$var$fromOffsetCache];
        lastLine = lineToIndex[lineToIndex.length - 1];
        let min = 0;
        if (offset >= lastLine) min = lineToIndex.length - 1;
        else {
            let max = lineToIndex.length - 2;
            let mid;
            while(min < max){
                mid = min + (max - min >> 1);
                if (offset < lineToIndex[mid]) max = mid - 1;
                else if (offset >= lineToIndex[mid + 1]) min = mid + 1;
                else {
                    min = mid;
                    break;
                }
            }
        }
        return {
            line: min + 1,
            col: offset - lineToIndex[min] + 1
        };
    }
    error(message, line, column, opts = {}) {
        let result, endLine, endColumn;
        if (line && typeof line === "object") {
            let start = line;
            let end = column;
            if (typeof start.offset === "number") {
                let pos = this.fromOffset(start.offset);
                line = pos.line;
                column = pos.col;
            } else {
                line = start.line;
                column = start.column;
            }
            if (typeof end.offset === "number") {
                let pos = this.fromOffset(end.offset);
                endLine = pos.line;
                endColumn = pos.col;
            } else {
                endLine = end.line;
                endColumn = end.column;
            }
        } else if (!column) {
            let pos = this.fromOffset(line);
            line = pos.line;
            column = pos.col;
        }
        let origin = this.origin(line, column, endLine, endColumn);
        if (origin) result = new $6ANgp(message, origin.endLine === undefined ? origin.line : {
            line: origin.line,
            column: origin.column
        }, origin.endLine === undefined ? origin.column : {
            line: origin.endLine,
            column: origin.endColumn
        }, origin.source, origin.file, opts.plugin);
        else result = new $6ANgp(message, endLine === undefined ? line : {
            line: line,
            column: column
        }, endLine === undefined ? column : {
            line: endLine,
            column: endColumn
        }, this.css, this.file, opts.plugin);
        result.input = {
            line: line,
            column: column,
            endLine: endLine,
            endColumn: endColumn,
            source: this.css
        };
        if (this.file) {
            if ($f8108dbe47027861$require$pathToFileURL) result.input.url = $f8108dbe47027861$require$pathToFileURL(this.file).toString();
            result.input.file = this.file;
        }
        return result;
    }
    origin(line, column, endLine, endColumn) {
        if (!this.map) return false;
        let consumer = this.map.consumer();
        let from = consumer.originalPositionFor({
            line: line,
            column: column
        });
        if (!from.source) return false;
        let to;
        if (typeof endLine === "number") to = consumer.originalPositionFor({
            line: endLine,
            column: endColumn
        });
        let fromUrl;
        if ($f8108dbe47027861$require$isAbsolute(from.source)) fromUrl = $f8108dbe47027861$require$pathToFileURL(from.source);
        else fromUrl = new URL(from.source, this.map.consumer().sourceRoot || $f8108dbe47027861$require$pathToFileURL(this.map.mapFile));
        let result = {
            url: fromUrl.toString(),
            line: from.line,
            column: from.column,
            endLine: to && to.line,
            endColumn: to && to.column
        };
        if (fromUrl.protocol === "file:") {
            if ($f8108dbe47027861$require$fileURLToPath) result.file = $f8108dbe47027861$require$fileURLToPath(fromUrl);
            else /* c8 ignore next 2 */ throw new Error(`file: protocol is not available in this PostCSS build`);
        }
        let source = consumer.sourceContentFor(from.source);
        if (source) result.source = source;
        return result;
    }
    mapResolve(file) {
        if (/^\w+:\/\//.test(file)) return file;
        return $f8108dbe47027861$require$resolve(this.map.consumer().sourceRoot || this.map.root || ".", file);
    }
    get from() {
        return this.file || this.id;
    }
    toJSON() {
        let json = {};
        for (let name of [
            "hasBOM",
            "css",
            "file",
            "id"
        ])if (this[name] != null) json[name] = this[name];
        if (this.map) {
            json.map = {
                ...this.map
            };
            if (json.map.consumerCache) json.map.consumerCache = undefined;
        }
        return json;
    }
}
module.exports = $f8108dbe47027861$var$Input;
$f8108dbe47027861$var$Input.default = $f8108dbe47027861$var$Input;
if ($gR5sk && $gR5sk.registerInput) $gR5sk.registerInput($f8108dbe47027861$var$Input);

});
parcelRequire.register("1Owuo", function(module, exports) {

$parcel$export(module.exports, "nanoid", () => $1523a9a23b39af21$export$ac4959f4f1338dfc);
let $1523a9a23b39af21$var$urlAlphabet = "useandom-26T198340PX75pxJACKVERYMINDBUSHWOLF_GQZbfghjklqvwyzrict";
let $1523a9a23b39af21$export$62e99e5c9f473d7f = (alphabet, defaultSize = 21)=>{
    return (size = defaultSize)=>{
        let id = "";
        let i = size;
        while(i--)id += alphabet[Math.random() * alphabet.length | 0];
        return id;
    };
};
let $1523a9a23b39af21$export$ac4959f4f1338dfc = (size = 21)=>{
    let id = "";
    let i = size;
    while(i--)id += $1523a9a23b39af21$var$urlAlphabet[Math.random() * 64 | 0];
    return id;
};

});

parcelRequire.register("7HRSx", function(module, exports) {

var $cBXue = parcelRequire("cBXue");
var $59c657c133e7b07e$require$Buffer = $cBXue.Buffer;
"use strict";

var $gR5sk = parcelRequire("gR5sk");
var $59c657c133e7b07e$require$SourceMapConsumer = $gR5sk.SourceMapConsumer;
var $59c657c133e7b07e$require$SourceMapGenerator = $gR5sk.SourceMapGenerator;

var $gR5sk = parcelRequire("gR5sk");
var $59c657c133e7b07e$require$existsSync = $gR5sk.existsSync;
var $59c657c133e7b07e$require$readFileSync = $gR5sk.readFileSync;

var $gR5sk = parcelRequire("gR5sk");
var $59c657c133e7b07e$require$dirname = $gR5sk.dirname;
var $59c657c133e7b07e$require$join = $gR5sk.join;
function $59c657c133e7b07e$var$fromBase64(str) {
    if ($59c657c133e7b07e$require$Buffer) return $59c657c133e7b07e$require$Buffer.from(str, "base64").toString();
    else /* c8 ignore next 2 */ return window.atob(str);
}
class $59c657c133e7b07e$var$PreviousMap {
    constructor(css, opts){
        if (opts.map === false) return;
        this.loadAnnotation(css);
        this.inline = this.startWith(this.annotation, "data:");
        let prev = opts.map ? opts.map.prev : undefined;
        let text = this.loadMap(opts.from, prev);
        if (!this.mapFile && opts.from) this.mapFile = opts.from;
        if (this.mapFile) this.root = $59c657c133e7b07e$require$dirname(this.mapFile);
        if (text) this.text = text;
    }
    consumer() {
        if (!this.consumerCache) this.consumerCache = new $59c657c133e7b07e$require$SourceMapConsumer(this.text);
        return this.consumerCache;
    }
    withContent() {
        return !!(this.consumer().sourcesContent && this.consumer().sourcesContent.length > 0);
    }
    startWith(string, start) {
        if (!string) return false;
        return string.substr(0, start.length) === start;
    }
    getAnnotationURL(sourceMapString) {
        return sourceMapString.replace(/^\/\*\s*# sourceMappingURL=/, "").trim();
    }
    loadAnnotation(css) {
        let comments = css.match(/\/\*\s*# sourceMappingURL=/gm);
        if (!comments) return;
        // sourceMappingURLs from comments, strings, etc.
        let start = css.lastIndexOf(comments.pop());
        let end = css.indexOf("*/", start);
        if (start > -1 && end > -1) // Locate the last sourceMappingURL to avoid pickin
        this.annotation = this.getAnnotationURL(css.substring(start, end));
    }
    decodeInline(text) {
        let baseCharsetUri = /^data:application\/json;charset=utf-?8;base64,/;
        let baseUri = /^data:application\/json;base64,/;
        let charsetUri = /^data:application\/json;charset=utf-?8,/;
        let uri = /^data:application\/json,/;
        if (charsetUri.test(text) || uri.test(text)) return decodeURIComponent(text.substr(RegExp.lastMatch.length));
        if (baseCharsetUri.test(text) || baseUri.test(text)) return $59c657c133e7b07e$var$fromBase64(text.substr(RegExp.lastMatch.length));
        let encoding = text.match(/data:application\/json;([^,]+),/)[1];
        throw new Error("Unsupported source map encoding " + encoding);
    }
    loadFile(path) {
        this.root = $59c657c133e7b07e$require$dirname(path);
        if ($59c657c133e7b07e$require$existsSync(path)) {
            this.mapFile = path;
            return $59c657c133e7b07e$require$readFileSync(path, "utf-8").toString().trim();
        }
    }
    loadMap(file, prev) {
        if (prev === false) return false;
        if (prev) {
            if (typeof prev === "string") return prev;
            else if (typeof prev === "function") {
                let prevPath = prev(file);
                if (prevPath) {
                    let map = this.loadFile(prevPath);
                    if (!map) throw new Error("Unable to load previous source map: " + prevPath.toString());
                    return map;
                }
            } else if (prev instanceof $59c657c133e7b07e$require$SourceMapConsumer) return $59c657c133e7b07e$require$SourceMapGenerator.fromSourceMap(prev).toString();
            else if (prev instanceof $59c657c133e7b07e$require$SourceMapGenerator) return prev.toString();
            else if (this.isMap(prev)) return JSON.stringify(prev);
            else throw new Error("Unsupported previous source map format: " + prev.toString());
        } else if (this.inline) return this.decodeInline(this.annotation);
        else if (this.annotation) {
            let map = this.annotation;
            if (file) map = $59c657c133e7b07e$require$join($59c657c133e7b07e$require$dirname(file), map);
            return this.loadFile(map);
        }
    }
    isMap(map) {
        if (typeof map !== "object") return false;
        return typeof map.mappings === "string" || typeof map._mappings === "string" || Array.isArray(map.sections);
    }
}
module.exports = $59c657c133e7b07e$var$PreviousMap;
$59c657c133e7b07e$var$PreviousMap.default = $59c657c133e7b07e$var$PreviousMap;

});



parcelRequire.register("7UdNM", function(module, exports) {
"use strict";

var $6gWYW = parcelRequire("6gWYW");
var $5c18781d70c6cf3c$require$isClean = $6gWYW.isClean;
var $5c18781d70c6cf3c$require$my = $6gWYW.my;

var $gZeVH = parcelRequire("gZeVH");

var $fjcSu = parcelRequire("fjcSu");

var $htVhF = parcelRequire("htVhF");
let $5c18781d70c6cf3c$var$parse, $5c18781d70c6cf3c$var$Rule, $5c18781d70c6cf3c$var$AtRule, $5c18781d70c6cf3c$var$Root;
function $5c18781d70c6cf3c$var$cleanSource(nodes) {
    return nodes.map((i)=>{
        if (i.nodes) i.nodes = $5c18781d70c6cf3c$var$cleanSource(i.nodes);
        delete i.source;
        return i;
    });
}
function $5c18781d70c6cf3c$var$markDirtyUp(node) {
    node[$5c18781d70c6cf3c$require$isClean] = false;
    if (node.proxyOf.nodes) for (let i of node.proxyOf.nodes)$5c18781d70c6cf3c$var$markDirtyUp(i);
}
class $5c18781d70c6cf3c$var$Container extends $htVhF {
    push(child) {
        child.parent = this;
        this.proxyOf.nodes.push(child);
        return this;
    }
    each(callback) {
        if (!this.proxyOf.nodes) return undefined;
        let iterator = this.getIterator();
        let index, result;
        while(this.indexes[iterator] < this.proxyOf.nodes.length){
            index = this.indexes[iterator];
            result = callback(this.proxyOf.nodes[index], index);
            if (result === false) break;
            this.indexes[iterator] += 1;
        }
        delete this.indexes[iterator];
        return result;
    }
    walk(callback) {
        return this.each((child, i)=>{
            let result;
            try {
                result = callback(child, i);
            } catch (e) {
                throw child.addToError(e);
            }
            if (result !== false && child.walk) result = child.walk(callback);
            return result;
        });
    }
    walkDecls(prop, callback) {
        if (!callback) {
            callback = prop;
            return this.walk((child, i)=>{
                if (child.type === "decl") return callback(child, i);
            });
        }
        if (prop instanceof RegExp) return this.walk((child, i)=>{
            if (child.type === "decl" && prop.test(child.prop)) return callback(child, i);
        });
        return this.walk((child, i)=>{
            if (child.type === "decl" && child.prop === prop) return callback(child, i);
        });
    }
    walkRules(selector, callback) {
        if (!callback) {
            callback = selector;
            return this.walk((child, i)=>{
                if (child.type === "rule") return callback(child, i);
            });
        }
        if (selector instanceof RegExp) return this.walk((child, i)=>{
            if (child.type === "rule" && selector.test(child.selector)) return callback(child, i);
        });
        return this.walk((child, i)=>{
            if (child.type === "rule" && child.selector === selector) return callback(child, i);
        });
    }
    walkAtRules(name, callback) {
        if (!callback) {
            callback = name;
            return this.walk((child, i)=>{
                if (child.type === "atrule") return callback(child, i);
            });
        }
        if (name instanceof RegExp) return this.walk((child, i)=>{
            if (child.type === "atrule" && name.test(child.name)) return callback(child, i);
        });
        return this.walk((child, i)=>{
            if (child.type === "atrule" && child.name === name) return callback(child, i);
        });
    }
    walkComments(callback) {
        return this.walk((child, i)=>{
            if (child.type === "comment") return callback(child, i);
        });
    }
    append(...children) {
        for (let child of children){
            let nodes = this.normalize(child, this.last);
            for (let node of nodes)this.proxyOf.nodes.push(node);
        }
        this.markDirty();
        return this;
    }
    prepend(...children) {
        children = children.reverse();
        for (let child of children){
            let nodes = this.normalize(child, this.first, "prepend").reverse();
            for (let node of nodes)this.proxyOf.nodes.unshift(node);
            for(let id in this.indexes)this.indexes[id] = this.indexes[id] + nodes.length;
        }
        this.markDirty();
        return this;
    }
    cleanRaws(keepBetween) {
        super.cleanRaws(keepBetween);
        if (this.nodes) for (let node of this.nodes)node.cleanRaws(keepBetween);
    }
    insertBefore(exist, add) {
        let existIndex = this.index(exist);
        let type = existIndex === 0 ? "prepend" : false;
        let nodes = this.normalize(add, this.proxyOf.nodes[existIndex], type).reverse();
        existIndex = this.index(exist);
        for (let node of nodes)this.proxyOf.nodes.splice(existIndex, 0, node);
        let index;
        for(let id in this.indexes){
            index = this.indexes[id];
            if (existIndex <= index) this.indexes[id] = index + nodes.length;
        }
        this.markDirty();
        return this;
    }
    insertAfter(exist, add) {
        let existIndex = this.index(exist);
        let nodes = this.normalize(add, this.proxyOf.nodes[existIndex]).reverse();
        existIndex = this.index(exist);
        for (let node of nodes)this.proxyOf.nodes.splice(existIndex + 1, 0, node);
        let index;
        for(let id in this.indexes){
            index = this.indexes[id];
            if (existIndex < index) this.indexes[id] = index + nodes.length;
        }
        this.markDirty();
        return this;
    }
    removeChild(child) {
        child = this.index(child);
        this.proxyOf.nodes[child].parent = undefined;
        this.proxyOf.nodes.splice(child, 1);
        let index;
        for(let id in this.indexes){
            index = this.indexes[id];
            if (index >= child) this.indexes[id] = index - 1;
        }
        this.markDirty();
        return this;
    }
    removeAll() {
        for (let node of this.proxyOf.nodes)node.parent = undefined;
        this.proxyOf.nodes = [];
        this.markDirty();
        return this;
    }
    replaceValues(pattern, opts, callback) {
        if (!callback) {
            callback = opts;
            opts = {};
        }
        this.walkDecls((decl)=>{
            if (opts.props && !opts.props.includes(decl.prop)) return;
            if (opts.fast && !decl.value.includes(opts.fast)) return;
            decl.value = decl.value.replace(pattern, callback);
        });
        this.markDirty();
        return this;
    }
    every(condition) {
        return this.nodes.every(condition);
    }
    some(condition) {
        return this.nodes.some(condition);
    }
    index(child) {
        if (typeof child === "number") return child;
        if (child.proxyOf) child = child.proxyOf;
        return this.proxyOf.nodes.indexOf(child);
    }
    get first() {
        if (!this.proxyOf.nodes) return undefined;
        return this.proxyOf.nodes[0];
    }
    get last() {
        if (!this.proxyOf.nodes) return undefined;
        return this.proxyOf.nodes[this.proxyOf.nodes.length - 1];
    }
    normalize(nodes, sample) {
        if (typeof nodes === "string") nodes = $5c18781d70c6cf3c$var$cleanSource($5c18781d70c6cf3c$var$parse(nodes).nodes);
        else if (Array.isArray(nodes)) {
            nodes = nodes.slice(0);
            for (let i of nodes)if (i.parent) i.parent.removeChild(i, "ignore");
        } else if (nodes.type === "root" && this.type !== "document") {
            nodes = nodes.nodes.slice(0);
            for (let i of nodes)if (i.parent) i.parent.removeChild(i, "ignore");
        } else if (nodes.type) nodes = [
            nodes
        ];
        else if (nodes.prop) {
            if (typeof nodes.value === "undefined") throw new Error("Value field is missed in node creation");
            else if (typeof nodes.value !== "string") nodes.value = String(nodes.value);
            nodes = [
                new $gZeVH(nodes)
            ];
        } else if (nodes.selector) nodes = [
            new $5c18781d70c6cf3c$var$Rule(nodes)
        ];
        else if (nodes.name) nodes = [
            new $5c18781d70c6cf3c$var$AtRule(nodes)
        ];
        else if (nodes.text) nodes = [
            new $fjcSu(nodes)
        ];
        else throw new Error("Unknown node type in node creation");
        let processed = nodes.map((i)=>{
            /* c8 ignore next */ if (!i[$5c18781d70c6cf3c$require$my]) $5c18781d70c6cf3c$var$Container.rebuild(i);
            i = i.proxyOf;
            if (i.parent) i.parent.removeChild(i);
            if (i[$5c18781d70c6cf3c$require$isClean]) $5c18781d70c6cf3c$var$markDirtyUp(i);
            if (typeof i.raws.before === "undefined") {
                if (sample && typeof sample.raws.before !== "undefined") i.raws.before = sample.raws.before.replace(/\S/g, "");
            }
            i.parent = this.proxyOf;
            return i;
        });
        return processed;
    }
    getProxyProcessor() {
        return {
            set (node, prop, value) {
                if (node[prop] === value) return true;
                node[prop] = value;
                if (prop === "name" || prop === "params" || prop === "selector") node.markDirty();
                return true;
            },
            get (node, prop) {
                if (prop === "proxyOf") return node;
                else if (!node[prop]) return node[prop];
                else if (prop === "each" || typeof prop === "string" && prop.startsWith("walk")) return (...args)=>{
                    return node[prop](...args.map((i)=>{
                        if (typeof i === "function") return (child, index)=>i(child.toProxy(), index);
                        else return i;
                    }));
                };
                else if (prop === "every" || prop === "some") return (cb)=>{
                    return node[prop]((child, ...other)=>cb(child.toProxy(), ...other));
                };
                else if (prop === "root") return ()=>node.root().toProxy();
                else if (prop === "nodes") return node.nodes.map((i)=>i.toProxy());
                else if (prop === "first" || prop === "last") return node[prop].toProxy();
                else return node[prop];
            }
        };
    }
    getIterator() {
        if (!this.lastEach) this.lastEach = 0;
        if (!this.indexes) this.indexes = {};
        this.lastEach += 1;
        let iterator = this.lastEach;
        this.indexes[iterator] = 0;
        return iterator;
    }
}
$5c18781d70c6cf3c$var$Container.registerParse = (dependant)=>{
    $5c18781d70c6cf3c$var$parse = dependant;
};
$5c18781d70c6cf3c$var$Container.registerRule = (dependant)=>{
    $5c18781d70c6cf3c$var$Rule = dependant;
};
$5c18781d70c6cf3c$var$Container.registerAtRule = (dependant)=>{
    $5c18781d70c6cf3c$var$AtRule = dependant;
};
$5c18781d70c6cf3c$var$Container.registerRoot = (dependant)=>{
    $5c18781d70c6cf3c$var$Root = dependant;
};
module.exports = $5c18781d70c6cf3c$var$Container;
$5c18781d70c6cf3c$var$Container.default = $5c18781d70c6cf3c$var$Container;
/* c8 ignore start */ $5c18781d70c6cf3c$var$Container.rebuild = (node)=>{
    if (node.type === "atrule") Object.setPrototypeOf(node, $5c18781d70c6cf3c$var$AtRule.prototype);
    else if (node.type === "rule") Object.setPrototypeOf(node, $5c18781d70c6cf3c$var$Rule.prototype);
    else if (node.type === "decl") Object.setPrototypeOf(node, $gZeVH.prototype);
    else if (node.type === "comment") Object.setPrototypeOf(node, $fjcSu.prototype);
    else if (node.type === "root") Object.setPrototypeOf(node, $5c18781d70c6cf3c$var$Root.prototype);
    node[$5c18781d70c6cf3c$require$my] = true;
    if (node.nodes) node.nodes.forEach((child)=>{
        $5c18781d70c6cf3c$var$Container.rebuild(child);
    });
} /* c8 ignore stop */ ;

});
parcelRequire.register("fjcSu", function(module, exports) {
"use strict";

var $htVhF = parcelRequire("htVhF");
class $b2529ea400d14c41$var$Comment extends $htVhF {
    constructor(defaults){
        super(defaults);
        this.type = "comment";
    }
}
module.exports = $b2529ea400d14c41$var$Comment;
$b2529ea400d14c41$var$Comment.default = $b2529ea400d14c41$var$Comment;

});


parcelRequire.register("4Cgdx", function(module, exports) {
"use strict";

var $7UdNM = parcelRequire("7UdNM");
let $35c74a77b700a1b2$var$LazyResult, $35c74a77b700a1b2$var$Processor;
class $35c74a77b700a1b2$var$Document extends $7UdNM {
    constructor(defaults){
        // type needs to be passed to super, otherwise child roots won't be normalized correctly
        super({
            type: "document",
            ...defaults
        });
        if (!this.nodes) this.nodes = [];
    }
    toResult(opts = {}) {
        let lazy = new $35c74a77b700a1b2$var$LazyResult(new $35c74a77b700a1b2$var$Processor(), this, opts);
        return lazy.stringify();
    }
}
$35c74a77b700a1b2$var$Document.registerLazyResult = (dependant)=>{
    $35c74a77b700a1b2$var$LazyResult = dependant;
};
$35c74a77b700a1b2$var$Document.registerProcessor = (dependant)=>{
    $35c74a77b700a1b2$var$Processor = dependant;
};
module.exports = $35c74a77b700a1b2$var$Document;
$35c74a77b700a1b2$var$Document.default = $35c74a77b700a1b2$var$Document;

});

parcelRequire.register("5LKcu", function(module, exports) {
/* eslint-disable no-console */ "use strict";
let $43352dfbac40207e$var$printed = {};
module.exports = function warnOnce(message) {
    if ($43352dfbac40207e$var$printed[message]) return;
    $43352dfbac40207e$var$printed[message] = true;
    if (typeof console !== "undefined" && console.warn) console.warn(message);
};

});

parcelRequire.register("jbyo6", function(module, exports) {
"use strict";

var $kFs1D = parcelRequire("kFs1D");
class $df79b81207b071dc$var$Result {
    constructor(processor, root, opts){
        this.processor = processor;
        this.messages = [];
        this.root = root;
        this.opts = opts;
        this.css = undefined;
        this.map = undefined;
    }
    toString() {
        return this.css;
    }
    warn(text, opts = {}) {
        if (!opts.plugin) {
            if (this.lastPlugin && this.lastPlugin.postcssPlugin) opts.plugin = this.lastPlugin.postcssPlugin;
        }
        let warning = new $kFs1D(text, opts);
        this.messages.push(warning);
        return warning;
    }
    warnings() {
        return this.messages.filter((i)=>i.type === "warning");
    }
    get content() {
        return this.css;
    }
}
module.exports = $df79b81207b071dc$var$Result;
$df79b81207b071dc$var$Result.default = $df79b81207b071dc$var$Result;

});
parcelRequire.register("kFs1D", function(module, exports) {
"use strict";
class $f0bd603ee0f7e19e$var$Warning {
    constructor(text, opts = {}){
        this.type = "warning";
        this.text = text;
        if (opts.node && opts.node.source) {
            let range = opts.node.rangeBy(opts);
            this.line = range.start.line;
            this.column = range.start.column;
            this.endLine = range.end.line;
            this.endColumn = range.end.column;
        }
        for(let opt in opts)this[opt] = opts[opt];
    }
    toString() {
        if (this.node) return this.node.error(this.text, {
            plugin: this.plugin,
            index: this.index,
            word: this.word
        }).message;
        if (this.plugin) return this.plugin + ": " + this.text;
        return this.text;
    }
}
module.exports = $f0bd603ee0f7e19e$var$Warning;
$f0bd603ee0f7e19e$var$Warning.default = $f0bd603ee0f7e19e$var$Warning;

});


parcelRequire.register("79gLn", function(module, exports) {
"use strict";

var $7UdNM = parcelRequire("7UdNM");

var $epMhE = parcelRequire("epMhE");

var $lirqv = parcelRequire("lirqv");
function $5346607d32636a67$var$parse(css, opts) {
    let input = new $lirqv(css, opts);
    let parser = new $epMhE(input);
    try {
        parser.parse();
    } catch (e) {
        throw e;
    }
    return parser.root;
}
module.exports = $5346607d32636a67$var$parse;
$5346607d32636a67$var$parse.default = $5346607d32636a67$var$parse;
$7UdNM.registerParse($5346607d32636a67$var$parse);

});
parcelRequire.register("epMhE", function(module, exports) {
"use strict";

var $gZeVH = parcelRequire("gZeVH");

var $dtY5F = parcelRequire("dtY5F");

var $fjcSu = parcelRequire("fjcSu");

var $eIKWx = parcelRequire("eIKWx");

var $4DHTo = parcelRequire("4DHTo");

var $cDdV8 = parcelRequire("cDdV8");
const $a7e8daa3a61fb966$var$SAFE_COMMENT_NEIGHBOR = {
    empty: true,
    space: true
};
function $a7e8daa3a61fb966$var$findLastWithPosition(tokens) {
    for(let i = tokens.length - 1; i >= 0; i--){
        let token = tokens[i];
        let pos = token[3] || token[2];
        if (pos) return pos;
    }
}
class $a7e8daa3a61fb966$var$Parser {
    constructor(input){
        this.input = input;
        this.root = new $4DHTo();
        this.current = this.root;
        this.spaces = "";
        this.semicolon = false;
        this.customProperty = false;
        this.createTokenizer();
        this.root.source = {
            input: input,
            start: {
                offset: 0,
                line: 1,
                column: 1
            }
        };
    }
    createTokenizer() {
        this.tokenizer = $dtY5F(this.input);
    }
    parse() {
        let token;
        while(!this.tokenizer.endOfFile()){
            token = this.tokenizer.nextToken();
            switch(token[0]){
                case "space":
                    this.spaces += token[1];
                    break;
                case ";":
                    this.freeSemicolon(token);
                    break;
                case "}":
                    this.end(token);
                    break;
                case "comment":
                    this.comment(token);
                    break;
                case "at-word":
                    this.atrule(token);
                    break;
                case "{":
                    this.emptyRule(token);
                    break;
                default:
                    this.other(token);
                    break;
            }
        }
        this.endFile();
    }
    comment(token) {
        let node = new $fjcSu();
        this.init(node, token[2]);
        node.source.end = this.getPosition(token[3] || token[2]);
        let text = token[1].slice(2, -2);
        if (/^\s*$/.test(text)) {
            node.text = "";
            node.raws.left = text;
            node.raws.right = "";
        } else {
            let match = text.match(/^(\s*)([^]*\S)(\s*)$/);
            node.text = match[2];
            node.raws.left = match[1];
            node.raws.right = match[3];
        }
    }
    emptyRule(token) {
        let node = new $cDdV8();
        this.init(node, token[2]);
        node.selector = "";
        node.raws.between = "";
        this.current = node;
    }
    other(start) {
        let end = false;
        let type = null;
        let colon = false;
        let bracket = null;
        let brackets = [];
        let customProperty = start[1].startsWith("--");
        let tokens = [];
        let token = start;
        while(token){
            type = token[0];
            tokens.push(token);
            if (type === "(" || type === "[") {
                if (!bracket) bracket = token;
                brackets.push(type === "(" ? ")" : "]");
            } else if (customProperty && colon && type === "{") {
                if (!bracket) bracket = token;
                brackets.push("}");
            } else if (brackets.length === 0) {
                if (type === ";") {
                    if (colon) {
                        this.decl(tokens, customProperty);
                        return;
                    } else break;
                } else if (type === "{") {
                    this.rule(tokens);
                    return;
                } else if (type === "}") {
                    this.tokenizer.back(tokens.pop());
                    end = true;
                    break;
                } else if (type === ":") colon = true;
            } else if (type === brackets[brackets.length - 1]) {
                brackets.pop();
                if (brackets.length === 0) bracket = null;
            }
            token = this.tokenizer.nextToken();
        }
        if (this.tokenizer.endOfFile()) end = true;
        if (brackets.length > 0) this.unclosedBracket(bracket);
        if (end && colon) {
            if (!customProperty) while(tokens.length){
                token = tokens[tokens.length - 1][0];
                if (token !== "space" && token !== "comment") break;
                this.tokenizer.back(tokens.pop());
            }
            this.decl(tokens, customProperty);
        } else this.unknownWord(tokens);
    }
    rule(tokens) {
        tokens.pop();
        let node = new $cDdV8();
        this.init(node, tokens[0][2]);
        node.raws.between = this.spacesAndCommentsFromEnd(tokens);
        this.raw(node, "selector", tokens);
        this.current = node;
    }
    decl(tokens, customProperty) {
        let node = new $gZeVH();
        this.init(node, tokens[0][2]);
        let last = tokens[tokens.length - 1];
        if (last[0] === ";") {
            this.semicolon = true;
            tokens.pop();
        }
        node.source.end = this.getPosition(last[3] || last[2] || $a7e8daa3a61fb966$var$findLastWithPosition(tokens));
        while(tokens[0][0] !== "word"){
            if (tokens.length === 1) this.unknownWord(tokens);
            node.raws.before += tokens.shift()[1];
        }
        node.source.start = this.getPosition(tokens[0][2]);
        node.prop = "";
        while(tokens.length){
            let type = tokens[0][0];
            if (type === ":" || type === "space" || type === "comment") break;
            node.prop += tokens.shift()[1];
        }
        node.raws.between = "";
        let token;
        while(tokens.length){
            token = tokens.shift();
            if (token[0] === ":") {
                node.raws.between += token[1];
                break;
            } else {
                if (token[0] === "word" && /\w/.test(token[1])) this.unknownWord([
                    token
                ]);
                node.raws.between += token[1];
            }
        }
        if (node.prop[0] === "_" || node.prop[0] === "*") {
            node.raws.before += node.prop[0];
            node.prop = node.prop.slice(1);
        }
        let firstSpaces = [];
        let next;
        while(tokens.length){
            next = tokens[0][0];
            if (next !== "space" && next !== "comment") break;
            firstSpaces.push(tokens.shift());
        }
        this.precheckMissedSemicolon(tokens);
        for(let i = tokens.length - 1; i >= 0; i--){
            token = tokens[i];
            if (token[1].toLowerCase() === "!important") {
                node.important = true;
                let string = this.stringFrom(tokens, i);
                string = this.spacesFromEnd(tokens) + string;
                if (string !== " !important") node.raws.important = string;
                break;
            } else if (token[1].toLowerCase() === "important") {
                let cache = tokens.slice(0);
                let str = "";
                for(let j = i; j > 0; j--){
                    let type = cache[j][0];
                    if (str.trim().indexOf("!") === 0 && type !== "space") break;
                    str = cache.pop()[1] + str;
                }
                if (str.trim().indexOf("!") === 0) {
                    node.important = true;
                    node.raws.important = str;
                    tokens = cache;
                }
            }
            if (token[0] !== "space" && token[0] !== "comment") break;
        }
        let hasWord = tokens.some((i)=>i[0] !== "space" && i[0] !== "comment");
        if (hasWord) {
            node.raws.between += firstSpaces.map((i)=>i[1]).join("");
            firstSpaces = [];
        }
        this.raw(node, "value", firstSpaces.concat(tokens), customProperty);
        if (node.value.includes(":") && !customProperty) this.checkMissedSemicolon(tokens);
    }
    atrule(token) {
        let node = new $eIKWx();
        node.name = token[1].slice(1);
        if (node.name === "") this.unnamedAtrule(node, token);
        this.init(node, token[2]);
        let type;
        let prev;
        let shift;
        let last = false;
        let open = false;
        let params = [];
        let brackets = [];
        while(!this.tokenizer.endOfFile()){
            token = this.tokenizer.nextToken();
            type = token[0];
            if (type === "(" || type === "[") brackets.push(type === "(" ? ")" : "]");
            else if (type === "{" && brackets.length > 0) brackets.push("}");
            else if (type === brackets[brackets.length - 1]) brackets.pop();
            if (brackets.length === 0) {
                if (type === ";") {
                    node.source.end = this.getPosition(token[2]);
                    this.semicolon = true;
                    break;
                } else if (type === "{") {
                    open = true;
                    break;
                } else if (type === "}") {
                    if (params.length > 0) {
                        shift = params.length - 1;
                        prev = params[shift];
                        while(prev && prev[0] === "space")prev = params[--shift];
                        if (prev) node.source.end = this.getPosition(prev[3] || prev[2]);
                    }
                    this.end(token);
                    break;
                } else params.push(token);
            } else params.push(token);
            if (this.tokenizer.endOfFile()) {
                last = true;
                break;
            }
        }
        node.raws.between = this.spacesAndCommentsFromEnd(params);
        if (params.length) {
            node.raws.afterName = this.spacesAndCommentsFromStart(params);
            this.raw(node, "params", params);
            if (last) {
                token = params[params.length - 1];
                node.source.end = this.getPosition(token[3] || token[2]);
                this.spaces = node.raws.between;
                node.raws.between = "";
            }
        } else {
            node.raws.afterName = "";
            node.params = "";
        }
        if (open) {
            node.nodes = [];
            this.current = node;
        }
    }
    end(token) {
        if (this.current.nodes && this.current.nodes.length) this.current.raws.semicolon = this.semicolon;
        this.semicolon = false;
        this.current.raws.after = (this.current.raws.after || "") + this.spaces;
        this.spaces = "";
        if (this.current.parent) {
            this.current.source.end = this.getPosition(token[2]);
            this.current = this.current.parent;
        } else this.unexpectedClose(token);
    }
    endFile() {
        if (this.current.parent) this.unclosedBlock();
        if (this.current.nodes && this.current.nodes.length) this.current.raws.semicolon = this.semicolon;
        this.current.raws.after = (this.current.raws.after || "") + this.spaces;
    }
    freeSemicolon(token) {
        this.spaces += token[1];
        if (this.current.nodes) {
            let prev = this.current.nodes[this.current.nodes.length - 1];
            if (prev && prev.type === "rule" && !prev.raws.ownSemicolon) {
                prev.raws.ownSemicolon = this.spaces;
                this.spaces = "";
            }
        }
    }
    // Helpers
    getPosition(offset) {
        let pos = this.input.fromOffset(offset);
        return {
            offset: offset,
            line: pos.line,
            column: pos.col
        };
    }
    init(node, offset) {
        this.current.push(node);
        node.source = {
            start: this.getPosition(offset),
            input: this.input
        };
        node.raws.before = this.spaces;
        this.spaces = "";
        if (node.type !== "comment") this.semicolon = false;
    }
    raw(node, prop, tokens, customProperty) {
        let token, type;
        let length = tokens.length;
        let value = "";
        let clean = true;
        let next, prev;
        for(let i = 0; i < length; i += 1){
            token = tokens[i];
            type = token[0];
            if (type === "space" && i === length - 1 && !customProperty) clean = false;
            else if (type === "comment") {
                prev = tokens[i - 1] ? tokens[i - 1][0] : "empty";
                next = tokens[i + 1] ? tokens[i + 1][0] : "empty";
                if (!$a7e8daa3a61fb966$var$SAFE_COMMENT_NEIGHBOR[prev] && !$a7e8daa3a61fb966$var$SAFE_COMMENT_NEIGHBOR[next]) {
                    if (value.slice(-1) === ",") clean = false;
                    else value += token[1];
                } else clean = false;
            } else value += token[1];
        }
        if (!clean) {
            let raw = tokens.reduce((all, i)=>all + i[1], "");
            node.raws[prop] = {
                value: value,
                raw: raw
            };
        }
        node[prop] = value;
    }
    spacesAndCommentsFromEnd(tokens) {
        let lastTokenType;
        let spaces = "";
        while(tokens.length){
            lastTokenType = tokens[tokens.length - 1][0];
            if (lastTokenType !== "space" && lastTokenType !== "comment") break;
            spaces = tokens.pop()[1] + spaces;
        }
        return spaces;
    }
    spacesAndCommentsFromStart(tokens) {
        let next;
        let spaces = "";
        while(tokens.length){
            next = tokens[0][0];
            if (next !== "space" && next !== "comment") break;
            spaces += tokens.shift()[1];
        }
        return spaces;
    }
    spacesFromEnd(tokens) {
        let lastTokenType;
        let spaces = "";
        while(tokens.length){
            lastTokenType = tokens[tokens.length - 1][0];
            if (lastTokenType !== "space") break;
            spaces = tokens.pop()[1] + spaces;
        }
        return spaces;
    }
    stringFrom(tokens, from) {
        let result = "";
        for(let i = from; i < tokens.length; i++)result += tokens[i][1];
        tokens.splice(from, tokens.length - from);
        return result;
    }
    colon(tokens) {
        let brackets = 0;
        let token, type, prev;
        for (let [i, element] of tokens.entries()){
            token = element;
            type = token[0];
            if (type === "(") brackets += 1;
            if (type === ")") brackets -= 1;
            if (brackets === 0 && type === ":") {
                if (!prev) this.doubleColon(token);
                else if (prev[0] === "word" && prev[1] === "progid") continue;
                else return i;
            }
            prev = token;
        }
        return false;
    }
    // Errors
    unclosedBracket(bracket) {
        throw this.input.error("Unclosed bracket", {
            offset: bracket[2]
        }, {
            offset: bracket[2] + 1
        });
    }
    unknownWord(tokens) {
        throw this.input.error("Unknown word", {
            offset: tokens[0][2]
        }, {
            offset: tokens[0][2] + tokens[0][1].length
        });
    }
    unexpectedClose(token) {
        throw this.input.error("Unexpected }", {
            offset: token[2]
        }, {
            offset: token[2] + 1
        });
    }
    unclosedBlock() {
        let pos = this.current.source.start;
        throw this.input.error("Unclosed block", pos.line, pos.column);
    }
    doubleColon(token) {
        throw this.input.error("Double colon", {
            offset: token[2]
        }, {
            offset: token[2] + token[1].length
        });
    }
    unnamedAtrule(node, token) {
        throw this.input.error("At-rule without name", {
            offset: token[2]
        }, {
            offset: token[2] + token[1].length
        });
    }
    precheckMissedSemicolon() {
    // Hook for Safe Parser
    }
    checkMissedSemicolon(tokens) {
        let colon = this.colon(tokens);
        if (colon === false) return;
        let founded = 0;
        let token;
        for(let j = colon - 1; j >= 0; j--){
            token = tokens[j];
            if (token[0] !== "space") {
                founded += 1;
                if (founded === 2) break;
            }
        }
        // If the token is a word, e.g. `!important`, `red` or any other valid property's value.
        // Then we need to return the colon after that word token. [3] is the "end" colon of that word.
        // And because we need it after that one we do +1 to get the next one.
        throw this.input.error("Missed semicolon", token[0] === "word" ? token[3] + 1 : token[2]);
    }
}
module.exports = $a7e8daa3a61fb966$var$Parser;

});
parcelRequire.register("dtY5F", function(module, exports) {
"use strict";
const $9d0c9884b1ff32b5$var$SINGLE_QUOTE = "'".charCodeAt(0);
const $9d0c9884b1ff32b5$var$DOUBLE_QUOTE = '"'.charCodeAt(0);
const $9d0c9884b1ff32b5$var$BACKSLASH = "\\".charCodeAt(0);
const $9d0c9884b1ff32b5$var$SLASH = "/".charCodeAt(0);
const $9d0c9884b1ff32b5$var$NEWLINE = "\n".charCodeAt(0);
const $9d0c9884b1ff32b5$var$SPACE = " ".charCodeAt(0);
const $9d0c9884b1ff32b5$var$FEED = "\f".charCodeAt(0);
const $9d0c9884b1ff32b5$var$TAB = "	".charCodeAt(0);
const $9d0c9884b1ff32b5$var$CR = "\r".charCodeAt(0);
const $9d0c9884b1ff32b5$var$OPEN_SQUARE = "[".charCodeAt(0);
const $9d0c9884b1ff32b5$var$CLOSE_SQUARE = "]".charCodeAt(0);
const $9d0c9884b1ff32b5$var$OPEN_PARENTHESES = "(".charCodeAt(0);
const $9d0c9884b1ff32b5$var$CLOSE_PARENTHESES = ")".charCodeAt(0);
const $9d0c9884b1ff32b5$var$OPEN_CURLY = "{".charCodeAt(0);
const $9d0c9884b1ff32b5$var$CLOSE_CURLY = "}".charCodeAt(0);
const $9d0c9884b1ff32b5$var$SEMICOLON = ";".charCodeAt(0);
const $9d0c9884b1ff32b5$var$ASTERISK = "*".charCodeAt(0);
const $9d0c9884b1ff32b5$var$COLON = ":".charCodeAt(0);
const $9d0c9884b1ff32b5$var$AT = "@".charCodeAt(0);
const $9d0c9884b1ff32b5$var$RE_AT_END = /[\t\n\f\r "#'()/;[\\\]{}]/g;
const $9d0c9884b1ff32b5$var$RE_WORD_END = /[\t\n\f\r !"#'():;@[\\\]{}]|\/(?=\*)/g;
const $9d0c9884b1ff32b5$var$RE_BAD_BRACKET = /.[\n"'(/\\]/;
const $9d0c9884b1ff32b5$var$RE_HEX_ESCAPE = /[\da-f]/i;
module.exports = function tokenizer(input, options = {}) {
    let css = input.css.valueOf();
    let ignore = options.ignoreErrors;
    let code, next, quote, content, escape;
    let escaped, escapePos, prev, n, currentToken;
    let length = css.length;
    let pos = 0;
    let buffer = [];
    let returned = [];
    function position() {
        return pos;
    }
    function unclosed(what) {
        throw input.error("Unclosed " + what, pos);
    }
    function endOfFile() {
        return returned.length === 0 && pos >= length;
    }
    function nextToken(opts) {
        if (returned.length) return returned.pop();
        if (pos >= length) return;
        let ignoreUnclosed = opts ? opts.ignoreUnclosed : false;
        code = css.charCodeAt(pos);
        switch(code){
            case $9d0c9884b1ff32b5$var$NEWLINE:
            case $9d0c9884b1ff32b5$var$SPACE:
            case $9d0c9884b1ff32b5$var$TAB:
            case $9d0c9884b1ff32b5$var$CR:
            case $9d0c9884b1ff32b5$var$FEED:
                next = pos;
                do {
                    next += 1;
                    code = css.charCodeAt(next);
                }while (code === $9d0c9884b1ff32b5$var$SPACE || code === $9d0c9884b1ff32b5$var$NEWLINE || code === $9d0c9884b1ff32b5$var$TAB || code === $9d0c9884b1ff32b5$var$CR || code === $9d0c9884b1ff32b5$var$FEED);
                currentToken = [
                    "space",
                    css.slice(pos, next)
                ];
                pos = next - 1;
                break;
            case $9d0c9884b1ff32b5$var$OPEN_SQUARE:
            case $9d0c9884b1ff32b5$var$CLOSE_SQUARE:
            case $9d0c9884b1ff32b5$var$OPEN_CURLY:
            case $9d0c9884b1ff32b5$var$CLOSE_CURLY:
            case $9d0c9884b1ff32b5$var$COLON:
            case $9d0c9884b1ff32b5$var$SEMICOLON:
            case $9d0c9884b1ff32b5$var$CLOSE_PARENTHESES:
                {
                    let controlChar = String.fromCharCode(code);
                    currentToken = [
                        controlChar,
                        controlChar,
                        pos
                    ];
                    break;
                }
            case $9d0c9884b1ff32b5$var$OPEN_PARENTHESES:
                prev = buffer.length ? buffer.pop()[1] : "";
                n = css.charCodeAt(pos + 1);
                if (prev === "url" && n !== $9d0c9884b1ff32b5$var$SINGLE_QUOTE && n !== $9d0c9884b1ff32b5$var$DOUBLE_QUOTE && n !== $9d0c9884b1ff32b5$var$SPACE && n !== $9d0c9884b1ff32b5$var$NEWLINE && n !== $9d0c9884b1ff32b5$var$TAB && n !== $9d0c9884b1ff32b5$var$FEED && n !== $9d0c9884b1ff32b5$var$CR) {
                    next = pos;
                    do {
                        escaped = false;
                        next = css.indexOf(")", next + 1);
                        if (next === -1) {
                            if (ignore || ignoreUnclosed) {
                                next = pos;
                                break;
                            } else unclosed("bracket");
                        }
                        escapePos = next;
                        while(css.charCodeAt(escapePos - 1) === $9d0c9884b1ff32b5$var$BACKSLASH){
                            escapePos -= 1;
                            escaped = !escaped;
                        }
                    }while (escaped);
                    currentToken = [
                        "brackets",
                        css.slice(pos, next + 1),
                        pos,
                        next
                    ];
                    pos = next;
                } else {
                    next = css.indexOf(")", pos + 1);
                    content = css.slice(pos, next + 1);
                    if (next === -1 || $9d0c9884b1ff32b5$var$RE_BAD_BRACKET.test(content)) currentToken = [
                        "(",
                        "(",
                        pos
                    ];
                    else {
                        currentToken = [
                            "brackets",
                            content,
                            pos,
                            next
                        ];
                        pos = next;
                    }
                }
                break;
            case $9d0c9884b1ff32b5$var$SINGLE_QUOTE:
            case $9d0c9884b1ff32b5$var$DOUBLE_QUOTE:
                quote = code === $9d0c9884b1ff32b5$var$SINGLE_QUOTE ? "'" : '"';
                next = pos;
                do {
                    escaped = false;
                    next = css.indexOf(quote, next + 1);
                    if (next === -1) {
                        if (ignore || ignoreUnclosed) {
                            next = pos + 1;
                            break;
                        } else unclosed("string");
                    }
                    escapePos = next;
                    while(css.charCodeAt(escapePos - 1) === $9d0c9884b1ff32b5$var$BACKSLASH){
                        escapePos -= 1;
                        escaped = !escaped;
                    }
                }while (escaped);
                currentToken = [
                    "string",
                    css.slice(pos, next + 1),
                    pos,
                    next
                ];
                pos = next;
                break;
            case $9d0c9884b1ff32b5$var$AT:
                $9d0c9884b1ff32b5$var$RE_AT_END.lastIndex = pos + 1;
                $9d0c9884b1ff32b5$var$RE_AT_END.test(css);
                if ($9d0c9884b1ff32b5$var$RE_AT_END.lastIndex === 0) next = css.length - 1;
                else next = $9d0c9884b1ff32b5$var$RE_AT_END.lastIndex - 2;
                currentToken = [
                    "at-word",
                    css.slice(pos, next + 1),
                    pos,
                    next
                ];
                pos = next;
                break;
            case $9d0c9884b1ff32b5$var$BACKSLASH:
                next = pos;
                escape = true;
                while(css.charCodeAt(next + 1) === $9d0c9884b1ff32b5$var$BACKSLASH){
                    next += 1;
                    escape = !escape;
                }
                code = css.charCodeAt(next + 1);
                if (escape && code !== $9d0c9884b1ff32b5$var$SLASH && code !== $9d0c9884b1ff32b5$var$SPACE && code !== $9d0c9884b1ff32b5$var$NEWLINE && code !== $9d0c9884b1ff32b5$var$TAB && code !== $9d0c9884b1ff32b5$var$CR && code !== $9d0c9884b1ff32b5$var$FEED) {
                    next += 1;
                    if ($9d0c9884b1ff32b5$var$RE_HEX_ESCAPE.test(css.charAt(next))) {
                        while($9d0c9884b1ff32b5$var$RE_HEX_ESCAPE.test(css.charAt(next + 1)))next += 1;
                        if (css.charCodeAt(next + 1) === $9d0c9884b1ff32b5$var$SPACE) next += 1;
                    }
                }
                currentToken = [
                    "word",
                    css.slice(pos, next + 1),
                    pos,
                    next
                ];
                pos = next;
                break;
            default:
                if (code === $9d0c9884b1ff32b5$var$SLASH && css.charCodeAt(pos + 1) === $9d0c9884b1ff32b5$var$ASTERISK) {
                    next = css.indexOf("*/", pos + 2) + 1;
                    if (next === 0) {
                        if (ignore || ignoreUnclosed) next = css.length;
                        else unclosed("comment");
                    }
                    currentToken = [
                        "comment",
                        css.slice(pos, next + 1),
                        pos,
                        next
                    ];
                    pos = next;
                } else {
                    $9d0c9884b1ff32b5$var$RE_WORD_END.lastIndex = pos + 1;
                    $9d0c9884b1ff32b5$var$RE_WORD_END.test(css);
                    if ($9d0c9884b1ff32b5$var$RE_WORD_END.lastIndex === 0) next = css.length - 1;
                    else next = $9d0c9884b1ff32b5$var$RE_WORD_END.lastIndex - 2;
                    currentToken = [
                        "word",
                        css.slice(pos, next + 1),
                        pos,
                        next
                    ];
                    buffer.push(currentToken);
                    pos = next;
                }
                break;
        }
        pos++;
        return currentToken;
    }
    function back(token) {
        returned.push(token);
    }
    return {
        back: back,
        nextToken: nextToken,
        endOfFile: endOfFile,
        position: position
    };
};

});

parcelRequire.register("eIKWx", function(module, exports) {
"use strict";

var $7UdNM = parcelRequire("7UdNM");
class $ab7996b5776eb3f1$var$AtRule extends $7UdNM {
    constructor(defaults){
        super(defaults);
        this.type = "atrule";
    }
    append(...children) {
        if (!this.proxyOf.nodes) this.nodes = [];
        return super.append(...children);
    }
    prepend(...children) {
        if (!this.proxyOf.nodes) this.nodes = [];
        return super.prepend(...children);
    }
}
module.exports = $ab7996b5776eb3f1$var$AtRule;
$ab7996b5776eb3f1$var$AtRule.default = $ab7996b5776eb3f1$var$AtRule;
$7UdNM.registerAtRule($ab7996b5776eb3f1$var$AtRule);

});

parcelRequire.register("4DHTo", function(module, exports) {
"use strict";

var $7UdNM = parcelRequire("7UdNM");
let $360cda0f45ad9f50$var$LazyResult, $360cda0f45ad9f50$var$Processor;
class $360cda0f45ad9f50$var$Root extends $7UdNM {
    constructor(defaults){
        super(defaults);
        this.type = "root";
        if (!this.nodes) this.nodes = [];
    }
    removeChild(child, ignore) {
        let index = this.index(child);
        if (!ignore && index === 0 && this.nodes.length > 1) this.nodes[1].raws.before = this.nodes[index].raws.before;
        return super.removeChild(child);
    }
    normalize(child, sample, type) {
        let nodes = super.normalize(child);
        if (sample) {
            if (type === "prepend") {
                if (this.nodes.length > 1) sample.raws.before = this.nodes[1].raws.before;
                else delete sample.raws.before;
            } else if (this.first !== sample) for (let node of nodes)node.raws.before = sample.raws.before;
        }
        return nodes;
    }
    toResult(opts = {}) {
        let lazy = new $360cda0f45ad9f50$var$LazyResult(new $360cda0f45ad9f50$var$Processor(), this, opts);
        return lazy.stringify();
    }
}
$360cda0f45ad9f50$var$Root.registerLazyResult = (dependant)=>{
    $360cda0f45ad9f50$var$LazyResult = dependant;
};
$360cda0f45ad9f50$var$Root.registerProcessor = (dependant)=>{
    $360cda0f45ad9f50$var$Processor = dependant;
};
module.exports = $360cda0f45ad9f50$var$Root;
$360cda0f45ad9f50$var$Root.default = $360cda0f45ad9f50$var$Root;
$7UdNM.registerRoot($360cda0f45ad9f50$var$Root);

});

parcelRequire.register("cDdV8", function(module, exports) {
"use strict";

var $7UdNM = parcelRequire("7UdNM");

var $fcHjE = parcelRequire("fcHjE");
class $9323ece812361038$var$Rule extends $7UdNM {
    constructor(defaults){
        super(defaults);
        this.type = "rule";
        if (!this.nodes) this.nodes = [];
    }
    get selectors() {
        return $fcHjE.comma(this.selector);
    }
    set selectors(values) {
        let match = this.selector ? this.selector.match(/,\s*/) : null;
        let sep = match ? match[0] : "," + this.raw("between", "beforeOpen");
        this.selector = values.join(sep);
    }
}
module.exports = $9323ece812361038$var$Rule;
$9323ece812361038$var$Rule.default = $9323ece812361038$var$Rule;
$7UdNM.registerRule($9323ece812361038$var$Rule);

});
parcelRequire.register("fcHjE", function(module, exports) {
"use strict";
let $b11993aa703b4a26$var$list = {
    split (string, separators, last) {
        let array = [];
        let current = "";
        let split = false;
        let func = 0;
        let inQuote = false;
        let prevQuote = "";
        let escape = false;
        for (let letter of string){
            if (escape) escape = false;
            else if (letter === "\\") escape = true;
            else if (inQuote) {
                if (letter === prevQuote) inQuote = false;
            } else if (letter === '"' || letter === "'") {
                inQuote = true;
                prevQuote = letter;
            } else if (letter === "(") func += 1;
            else if (letter === ")") {
                if (func > 0) func -= 1;
            } else if (func === 0) {
                if (separators.includes(letter)) split = true;
            }
            if (split) {
                if (current !== "") array.push(current.trim());
                current = "";
                split = false;
            } else current += letter;
        }
        if (last || current !== "") array.push(current.trim());
        return array;
    },
    space (string) {
        let spaces = [
            " ",
            "\n",
            "	"
        ];
        return $b11993aa703b4a26$var$list.split(string, spaces);
    },
    comma (string) {
        return $b11993aa703b4a26$var$list.split(string, [
            ","
        ], true);
    }
};
module.exports = $b11993aa703b4a26$var$list;
$b11993aa703b4a26$var$list.default = $b11993aa703b4a26$var$list;

});





parcelRequire.register("gRQ9L", function(module, exports) {
"use strict";

var $45x6w = parcelRequire("45x6w");

var $5Faho = parcelRequire("5Faho");

var $4Cgdx = parcelRequire("4Cgdx");

var $4DHTo = parcelRequire("4DHTo");
class $c47a0dc5d69ba310$var$Processor {
    constructor(plugins = []){
        this.version = "8.4.24";
        this.plugins = this.normalize(plugins);
    }
    use(plugin) {
        this.plugins = this.plugins.concat(this.normalize([
            plugin
        ]));
        return this;
    }
    process(css, opts = {}) {
        if (this.plugins.length === 0 && typeof opts.parser === "undefined" && typeof opts.stringifier === "undefined" && typeof opts.syntax === "undefined") return new $45x6w(this, css, opts);
        else return new $5Faho(this, css, opts);
    }
    normalize(plugins) {
        let normalized = [];
        for (let i of plugins){
            if (i.postcss === true) i = i();
            else if (i.postcss) i = i.postcss;
            if (typeof i === "object" && Array.isArray(i.plugins)) normalized = normalized.concat(i.plugins);
            else if (typeof i === "object" && i.postcssPlugin) normalized.push(i);
            else if (typeof i === "function") normalized.push(i);
            else if (typeof i === "object" && (i.parse || i.stringify)) ;
            else throw new Error(i + " is not a PostCSS plugin");
        }
        return normalized;
    }
}
module.exports = $c47a0dc5d69ba310$var$Processor;
$c47a0dc5d69ba310$var$Processor.default = $c47a0dc5d69ba310$var$Processor;
$4DHTo.registerProcessor($c47a0dc5d69ba310$var$Processor);
$4Cgdx.registerProcessor($c47a0dc5d69ba310$var$Processor);

});
parcelRequire.register("45x6w", function(module, exports) {
"use strict";

var $3dq0N = parcelRequire("3dq0N");

var $5xBzD = parcelRequire("5xBzD");
parcelRequire("5LKcu");

var $79gLn = parcelRequire("79gLn");

var $jbyo6 = parcelRequire("jbyo6");
class $2fa14ede51ec6e8b$var$NoWorkResult {
    constructor(processor, css, opts){
        css = css.toString();
        this.stringified = false;
        this._processor = processor;
        this._css = css;
        this._opts = opts;
        this._map = undefined;
        let root;
        let str = $5xBzD;
        this.result = new $jbyo6(this._processor, root, this._opts);
        this.result.css = css;
        let self = this;
        Object.defineProperty(this.result, "root", {
            get () {
                return self.root;
            }
        });
        let map = new $3dq0N(str, root, this._opts, css);
        if (map.isMap()) {
            let [generatedCSS, generatedMap] = map.generate();
            if (generatedCSS) this.result.css = generatedCSS;
            if (generatedMap) this.result.map = generatedMap;
        }
    }
    get [Symbol.toStringTag]() {
        return "NoWorkResult";
    }
    get processor() {
        return this.result.processor;
    }
    get opts() {
        return this.result.opts;
    }
    get css() {
        return this.result.css;
    }
    get content() {
        return this.result.css;
    }
    get map() {
        return this.result.map;
    }
    get root() {
        if (this._root) return this._root;
        let root;
        let parser = $79gLn;
        try {
            root = parser(this._css, this._opts);
        } catch (error) {
            this.error = error;
        }
        if (this.error) throw this.error;
        else {
            this._root = root;
            return root;
        }
    }
    get messages() {
        return [];
    }
    warnings() {
        return [];
    }
    toString() {
        return this._css;
    }
    then(onFulfilled, onRejected) {
        return this.async().then(onFulfilled, onRejected);
    }
    catch(onRejected) {
        return this.async().catch(onRejected);
    }
    finally(onFinally) {
        return this.async().then(onFinally, onFinally);
    }
    async() {
        if (this.error) return Promise.reject(this.error);
        return Promise.resolve(this.result);
    }
    sync() {
        if (this.error) throw this.error;
        return this.result;
    }
}
module.exports = $2fa14ede51ec6e8b$var$NoWorkResult;
$2fa14ede51ec6e8b$var$NoWorkResult.default = $2fa14ede51ec6e8b$var$NoWorkResult;

});


parcelRequire.register("lHSpH", function(module, exports) {
"use strict";

var $gZeVH = parcelRequire("gZeVH");

var $7HRSx = parcelRequire("7HRSx");

var $fjcSu = parcelRequire("fjcSu");

var $eIKWx = parcelRequire("eIKWx");

var $lirqv = parcelRequire("lirqv");

var $4DHTo = parcelRequire("4DHTo");

var $cDdV8 = parcelRequire("cDdV8");
function $fcd7d285fccfeff8$var$fromJSON(json, inputs) {
    if (Array.isArray(json)) return json.map((n)=>$fcd7d285fccfeff8$var$fromJSON(n));
    let { inputs: ownInputs, ...defaults } = json;
    if (ownInputs) {
        inputs = [];
        for (let input of ownInputs){
            let inputHydrated = {
                ...input,
                __proto__: $lirqv.prototype
            };
            if (inputHydrated.map) inputHydrated.map = {
                ...inputHydrated.map,
                __proto__: $7HRSx.prototype
            };
            inputs.push(inputHydrated);
        }
    }
    if (defaults.nodes) defaults.nodes = json.nodes.map((n)=>$fcd7d285fccfeff8$var$fromJSON(n, inputs));
    if (defaults.source) {
        let { inputId: inputId, ...source } = defaults.source;
        defaults.source = source;
        if (inputId != null) defaults.source.input = inputs[inputId];
    }
    if (defaults.type === "root") return new $4DHTo(defaults);
    else if (defaults.type === "decl") return new $gZeVH(defaults);
    else if (defaults.type === "rule") return new $cDdV8(defaults);
    else if (defaults.type === "comment") return new $fjcSu(defaults);
    else if (defaults.type === "atrule") return new $eIKWx(defaults);
    else throw new Error("Unknown node type: " + json.type);
}
module.exports = $fcd7d285fccfeff8$var$fromJSON;
$fcd7d285fccfeff8$var$fromJSON.default = $fcd7d285fccfeff8$var$fromJSON;

});







parcelRequire.register("bgVZk", function(module, exports) {
"use strict";

var $luOtD = parcelRequire("luOtD");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $834e2b8ee92b9fe9$var$_defineProperty2 = $luOtD((parcelRequire("3w8Sv")));

var $834e2b8ee92b9fe9$var$_extends2 = $luOtD((parcelRequire("aoGM2")));

var $834e2b8ee92b9fe9$var$_propTypes = $luOtD((parcelRequire("f7UXb")));

var $834e2b8ee92b9fe9$var$_react = $luOtD((parcelRequire("eO7Kz")));

var $834e2b8ee92b9fe9$var$_botframeworkWebchatComponent = $luOtD((parcelRequire("fD7D4")));

var $834e2b8ee92b9fe9$var$_AddFullBundle = $luOtD((parcelRequire("lj7VX")));
function $834e2b8ee92b9fe9$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $834e2b8ee92b9fe9$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $834e2b8ee92b9fe9$var$ownKeys(Object(source), !0).forEach(function(key) {
            (0, $834e2b8ee92b9fe9$var$_defineProperty2.default)(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $834e2b8ee92b9fe9$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
// Add additional props to <WebChat>, so it support additional features
var $834e2b8ee92b9fe9$var$FullReactWebChat = function FullReactWebChat(props) {
    return /*#__PURE__*/ $834e2b8ee92b9fe9$var$_react.default.createElement($834e2b8ee92b9fe9$var$_AddFullBundle.default, props, function(extraProps) {
        return /*#__PURE__*/ $834e2b8ee92b9fe9$var$_react.default.createElement($834e2b8ee92b9fe9$var$_botframeworkWebchatComponent.default, (0, $834e2b8ee92b9fe9$var$_extends2.default)({}, props, extraProps));
    });
};
$834e2b8ee92b9fe9$var$FullReactWebChat.defaultProps = $834e2b8ee92b9fe9$var$_objectSpread($834e2b8ee92b9fe9$var$_objectSpread({}, $834e2b8ee92b9fe9$var$_botframeworkWebchatComponent.default.defaultProps), {}, {
    adaptiveCardHostConfig: undefined,
    adaptiveCardsHostConfig: undefined,
    adaptiveCardsPackage: undefined,
    renderMarkdown: undefined
});
$834e2b8ee92b9fe9$var$FullReactWebChat.propTypes = $834e2b8ee92b9fe9$var$_objectSpread($834e2b8ee92b9fe9$var$_objectSpread({}, $834e2b8ee92b9fe9$var$_botframeworkWebchatComponent.default.propTypes), {}, {
    adaptiveCardHostConfig: $834e2b8ee92b9fe9$var$_propTypes.default.any,
    adaptiveCardsHostConfig: $834e2b8ee92b9fe9$var$_propTypes.default.any,
    adaptiveCardsPackage: $834e2b8ee92b9fe9$var$_propTypes.default.any,
    renderMarkdown: $834e2b8ee92b9fe9$var$_propTypes.default.func
});
var $834e2b8ee92b9fe9$var$_default = $834e2b8ee92b9fe9$var$FullReactWebChat;
module.exports.default = $834e2b8ee92b9fe9$var$_default;

});

parcelRequire.register("3E5Ww", function(module, exports) {
// Main parser class
"use strict";

var $iCsQ9 = parcelRequire("iCsQ9");

var $6Wdbg = parcelRequire("6Wdbg");

var $kgG75 = parcelRequire("kgG75");

var $6atM6 = parcelRequire("6atM6");

var $bjgBT = parcelRequire("bjgBT");

var $ju6pn = parcelRequire("ju6pn");

var $g1DP7 = parcelRequire("g1DP7");

var $e2HUE = parcelRequire("e2HUE");

var $i3uit = parcelRequire("i3uit");



var $2a79b7af2b27cf4b$var$config = {
    default: (parcelRequire("jWQte")),
    zero: (parcelRequire("cddfz")),
    commonmark: (parcelRequire("jSz5z"))
};
////////////////////////////////////////////////////////////////////////////////
//
// This validator can prohibit more than really needed to prevent XSS. It's a
// tradeoff to keep code simple and to be secure by default.
//
// If you need different setup - override validator method as you wish. Or
// replace it with dummy function and use external sanitizer.
//
var $2a79b7af2b27cf4b$var$BAD_PROTO_RE = /^(vbscript|javascript|file|data):/;
var $2a79b7af2b27cf4b$var$GOOD_DATA_RE = /^data:image\/(gif|png|jpeg|webp);/;
function $2a79b7af2b27cf4b$var$validateLink(url) {
    // url should be normalized at this point, and existing entities are decoded
    var str = url.trim().toLowerCase();
    return $2a79b7af2b27cf4b$var$BAD_PROTO_RE.test(str) ? $2a79b7af2b27cf4b$var$GOOD_DATA_RE.test(str) ? true : false : true;
}
////////////////////////////////////////////////////////////////////////////////
var $2a79b7af2b27cf4b$var$RECODE_HOSTNAME_FOR = [
    "http:",
    "https:",
    "mailto:"
];
function $2a79b7af2b27cf4b$var$normalizeLink(url) {
    var parsed = $e2HUE.parse(url, true);
    if (parsed.hostname) {
        // Encode hostnames in urls like:
        // `http://host/`, `https://host/`, `mailto:user@host`, `//host/`
        //
        // We don't encode unknown schemas, because it's likely that we encode
        // something we shouldn't (e.g. `skype:name` treated as `skype:host`)
        //
        if (!parsed.protocol || $2a79b7af2b27cf4b$var$RECODE_HOSTNAME_FOR.indexOf(parsed.protocol) >= 0) try {
            parsed.hostname = $i3uit.toASCII(parsed.hostname);
        } catch (er) {}
    }
    return $e2HUE.encode($e2HUE.format(parsed));
}
function $2a79b7af2b27cf4b$var$normalizeLinkText(url) {
    var parsed = $e2HUE.parse(url, true);
    if (parsed.hostname) {
        // Encode hostnames in urls like:
        // `http://host/`, `https://host/`, `mailto:user@host`, `//host/`
        //
        // We don't encode unknown schemas, because it's likely that we encode
        // something we shouldn't (e.g. `skype:name` treated as `skype:host`)
        //
        if (!parsed.protocol || $2a79b7af2b27cf4b$var$RECODE_HOSTNAME_FOR.indexOf(parsed.protocol) >= 0) try {
            parsed.hostname = $i3uit.toUnicode(parsed.hostname);
        } catch (er) {}
    }
    // add '%' to exclude list because of https://github.com/markdown-it/markdown-it/issues/720
    return $e2HUE.decode($e2HUE.format(parsed), $e2HUE.decode.defaultChars + "%");
}
/**
 * class MarkdownIt
 *
 * Main parser/renderer class.
 *
 * ##### Usage
 *
 * ```javascript
 * // node.js, "classic" way:
 * var MarkdownIt = require('markdown-it'),
 *     md = new MarkdownIt();
 * var result = md.render('# markdown-it rulezz!');
 *
 * // node.js, the same, but with sugar:
 * var md = require('markdown-it')();
 * var result = md.render('# markdown-it rulezz!');
 *
 * // browser without AMD, added to "window" on script load
 * // Note, there are no dash.
 * var md = window.markdownit();
 * var result = md.render('# markdown-it rulezz!');
 * ```
 *
 * Single line rendering, without paragraph wrap:
 *
 * ```javascript
 * var md = require('markdown-it')();
 * var result = md.renderInline('__markdown-it__ rulezz!');
 * ```
 **/ /**
 * new MarkdownIt([presetName, options])
 * - presetName (String): optional, `commonmark` / `zero`
 * - options (Object)
 *
 * Creates parser instanse with given config. Can be called without `new`.
 *
 * ##### presetName
 *
 * MarkdownIt provides named presets as a convenience to quickly
 * enable/disable active syntax rules and options for common use cases.
 *
 * - ["commonmark"](https://github.com/markdown-it/markdown-it/blob/master/lib/presets/commonmark.js) -
 *   configures parser to strict [CommonMark](http://commonmark.org/) mode.
 * - [default](https://github.com/markdown-it/markdown-it/blob/master/lib/presets/default.js) -
 *   similar to GFM, used when no preset name given. Enables all available rules,
 *   but still without html, typographer & autolinker.
 * - ["zero"](https://github.com/markdown-it/markdown-it/blob/master/lib/presets/zero.js) -
 *   all rules disabled. Useful to quickly setup your config via `.enable()`.
 *   For example, when you need only `bold` and `italic` markup and nothing else.
 *
 * ##### options:
 *
 * - __html__ - `false`. Set `true` to enable HTML tags in source. Be careful!
 *   That's not safe! You may need external sanitizer to protect output from XSS.
 *   It's better to extend features via plugins, instead of enabling HTML.
 * - __xhtmlOut__ - `false`. Set `true` to add '/' when closing single tags
 *   (`<br />`). This is needed only for full CommonMark compatibility. In real
 *   world you will need HTML output.
 * - __breaks__ - `false`. Set `true` to convert `\n` in paragraphs into `<br>`.
 * - __langPrefix__ - `language-`. CSS language class prefix for fenced blocks.
 *   Can be useful for external highlighters.
 * - __linkify__ - `false`. Set `true` to autoconvert URL-like text to links.
 * - __typographer__  - `false`. Set `true` to enable [some language-neutral
 *   replacement](https://github.com/markdown-it/markdown-it/blob/master/lib/rules_core/replacements.js) +
 *   quotes beautification (smartquotes).
 * - __quotes__ - `“”‘’`, String or Array. Double + single quotes replacement
 *   pairs, when typographer enabled and smartquotes on. For example, you can
 *   use `'«»„“'` for Russian, `'„“‚‘'` for German, and
 *   `['«\xA0', '\xA0»', '‹\xA0', '\xA0›']` for French (including nbsp).
 * - __highlight__ - `null`. Highlighter function for fenced code blocks.
 *   Highlighter `function (str, lang)` should return escaped HTML. It can also
 *   return empty string if the source was not changed and should be escaped
 *   externaly. If result starts with <pre... internal wrapper is skipped.
 *
 * ##### Example
 *
 * ```javascript
 * // commonmark mode
 * var md = require('markdown-it')('commonmark');
 *
 * // default mode
 * var md = require('markdown-it')();
 *
 * // enable everything
 * var md = require('markdown-it')({
 *   html: true,
 *   linkify: true,
 *   typographer: true
 * });
 * ```
 *
 * ##### Syntax highlighting
 *
 * ```js
 * var hljs = require('highlight.js') // https://highlightjs.org/
 *
 * var md = require('markdown-it')({
 *   highlight: function (str, lang) {
 *     if (lang && hljs.getLanguage(lang)) {
 *       try {
 *         return hljs.highlight(str, { language: lang, ignoreIllegals: true }).value;
 *       } catch (__) {}
 *     }
 *
 *     return ''; // use external default escaping
 *   }
 * });
 * ```
 *
 * Or with full wrapper override (if you need assign class to `<pre>`):
 *
 * ```javascript
 * var hljs = require('highlight.js') // https://highlightjs.org/
 *
 * // Actual default values
 * var md = require('markdown-it')({
 *   highlight: function (str, lang) {
 *     if (lang && hljs.getLanguage(lang)) {
 *       try {
 *         return '<pre class="hljs"><code>' +
 *                hljs.highlight(str, { language: lang, ignoreIllegals: true }).value +
 *                '</code></pre>';
 *       } catch (__) {}
 *     }
 *
 *     return '<pre class="hljs"><code>' + md.utils.escapeHtml(str) + '</code></pre>';
 *   }
 * });
 * ```
 *
 **/ function $2a79b7af2b27cf4b$var$MarkdownIt(presetName, options) {
    if (!(this instanceof $2a79b7af2b27cf4b$var$MarkdownIt)) return new $2a79b7af2b27cf4b$var$MarkdownIt(presetName, options);
    if (!options) {
        if (!$iCsQ9.isString(presetName)) {
            options = presetName || {};
            presetName = "default";
        }
    }
    /**
   * MarkdownIt#inline -> ParserInline
   *
   * Instance of [[ParserInline]]. You may need it to add new rules when
   * writing plugins. For simple rules control use [[MarkdownIt.disable]] and
   * [[MarkdownIt.enable]].
   **/ this.inline = new $ju6pn();
    /**
   * MarkdownIt#block -> ParserBlock
   *
   * Instance of [[ParserBlock]]. You may need it to add new rules when
   * writing plugins. For simple rules control use [[MarkdownIt.disable]] and
   * [[MarkdownIt.enable]].
   **/ this.block = new $bjgBT();
    /**
   * MarkdownIt#core -> Core
   *
   * Instance of [[Core]] chain executor. You may need it to add new rules when
   * writing plugins. For simple rules control use [[MarkdownIt.disable]] and
   * [[MarkdownIt.enable]].
   **/ this.core = new $6atM6();
    /**
   * MarkdownIt#renderer -> Renderer
   *
   * Instance of [[Renderer]]. Use it to modify output look. Or to add rendering
   * rules for new token types, generated by plugins.
   *
   * ##### Example
   *
   * ```javascript
   * var md = require('markdown-it')();
   *
   * function myToken(tokens, idx, options, env, self) {
   *   //...
   *   return result;
   * };
   *
   * md.renderer.rules['my_token'] = myToken
   * ```
   *
   * See [[Renderer]] docs and [source code](https://github.com/markdown-it/markdown-it/blob/master/lib/renderer.js).
   **/ this.renderer = new $kgG75();
    /**
   * MarkdownIt#linkify -> LinkifyIt
   *
   * [linkify-it](https://github.com/markdown-it/linkify-it) instance.
   * Used by [linkify](https://github.com/markdown-it/markdown-it/blob/master/lib/rules_core/linkify.js)
   * rule.
   **/ this.linkify = new $g1DP7();
    /**
   * MarkdownIt#validateLink(url) -> Boolean
   *
   * Link validation function. CommonMark allows too much in links. By default
   * we disable `javascript:`, `vbscript:`, `file:` schemas, and almost all `data:...` schemas
   * except some embedded image types.
   *
   * You can change this behaviour:
   *
   * ```javascript
   * var md = require('markdown-it')();
   * // enable everything
   * md.validateLink = function () { return true; }
   * ```
   **/ this.validateLink = $2a79b7af2b27cf4b$var$validateLink;
    /**
   * MarkdownIt#normalizeLink(url) -> String
   *
   * Function used to encode link url to a machine-readable format,
   * which includes url-encoding, punycode, etc.
   **/ this.normalizeLink = $2a79b7af2b27cf4b$var$normalizeLink;
    /**
   * MarkdownIt#normalizeLinkText(url) -> String
   *
   * Function used to decode link url to a human-readable format`
   **/ this.normalizeLinkText = $2a79b7af2b27cf4b$var$normalizeLinkText;
    // Expose utils & helpers for easy acces from plugins
    /**
   * MarkdownIt#utils -> utils
   *
   * Assorted utility functions, useful to write plugins. See details
   * [here](https://github.com/markdown-it/markdown-it/blob/master/lib/common/utils.js).
   **/ this.utils = $iCsQ9;
    /**
   * MarkdownIt#helpers -> helpers
   *
   * Link components parser functions, useful to write plugins. See details
   * [here](https://github.com/markdown-it/markdown-it/blob/master/lib/helpers).
   **/ this.helpers = $iCsQ9.assign({}, $6Wdbg);
    this.options = {};
    this.configure(presetName);
    if (options) this.set(options);
}
/** chainable
 * MarkdownIt.set(options)
 *
 * Set parser options (in the same format as in constructor). Probably, you
 * will never need it, but you can change options after constructor call.
 *
 * ##### Example
 *
 * ```javascript
 * var md = require('markdown-it')()
 *             .set({ html: true, breaks: true })
 *             .set({ typographer, true });
 * ```
 *
 * __Note:__ To achieve the best possible performance, don't modify a
 * `markdown-it` instance options on the fly. If you need multiple configurations
 * it's best to create multiple instances and initialize each with separate
 * config.
 **/ $2a79b7af2b27cf4b$var$MarkdownIt.prototype.set = function(options) {
    $iCsQ9.assign(this.options, options);
    return this;
};
/** chainable, internal
 * MarkdownIt.configure(presets)
 *
 * Batch load of all options and compenent settings. This is internal method,
 * and you probably will not need it. But if you will - see available presets
 * and data structure [here](https://github.com/markdown-it/markdown-it/tree/master/lib/presets)
 *
 * We strongly recommend to use presets instead of direct config loads. That
 * will give better compatibility with next versions.
 **/ $2a79b7af2b27cf4b$var$MarkdownIt.prototype.configure = function(presets) {
    var self = this, presetName;
    if ($iCsQ9.isString(presets)) {
        presetName = presets;
        presets = $2a79b7af2b27cf4b$var$config[presetName];
        if (!presets) throw new Error('Wrong `markdown-it` preset "' + presetName + '", check name');
    }
    if (!presets) throw new Error("Wrong `markdown-it` preset, can't be empty");
    if (presets.options) self.set(presets.options);
    if (presets.components) Object.keys(presets.components).forEach(function(name) {
        if (presets.components[name].rules) self[name].ruler.enableOnly(presets.components[name].rules);
        if (presets.components[name].rules2) self[name].ruler2.enableOnly(presets.components[name].rules2);
    });
    return this;
};
/** chainable
 * MarkdownIt.enable(list, ignoreInvalid)
 * - list (String|Array): rule name or list of rule names to enable
 * - ignoreInvalid (Boolean): set `true` to ignore errors when rule not found.
 *
 * Enable list or rules. It will automatically find appropriate components,
 * containing rules with given names. If rule not found, and `ignoreInvalid`
 * not set - throws exception.
 *
 * ##### Example
 *
 * ```javascript
 * var md = require('markdown-it')()
 *             .enable(['sub', 'sup'])
 *             .disable('smartquotes');
 * ```
 **/ $2a79b7af2b27cf4b$var$MarkdownIt.prototype.enable = function(list, ignoreInvalid) {
    var result = [];
    if (!Array.isArray(list)) list = [
        list
    ];
    [
        "core",
        "block",
        "inline"
    ].forEach(function(chain) {
        result = result.concat(this[chain].ruler.enable(list, true));
    }, this);
    result = result.concat(this.inline.ruler2.enable(list, true));
    var missed = list.filter(function(name) {
        return result.indexOf(name) < 0;
    });
    if (missed.length && !ignoreInvalid) throw new Error("MarkdownIt. Failed to enable unknown rule(s): " + missed);
    return this;
};
/** chainable
 * MarkdownIt.disable(list, ignoreInvalid)
 * - list (String|Array): rule name or list of rule names to disable.
 * - ignoreInvalid (Boolean): set `true` to ignore errors when rule not found.
 *
 * The same as [[MarkdownIt.enable]], but turn specified rules off.
 **/ $2a79b7af2b27cf4b$var$MarkdownIt.prototype.disable = function(list, ignoreInvalid) {
    var result = [];
    if (!Array.isArray(list)) list = [
        list
    ];
    [
        "core",
        "block",
        "inline"
    ].forEach(function(chain) {
        result = result.concat(this[chain].ruler.disable(list, true));
    }, this);
    result = result.concat(this.inline.ruler2.disable(list, true));
    var missed = list.filter(function(name) {
        return result.indexOf(name) < 0;
    });
    if (missed.length && !ignoreInvalid) throw new Error("MarkdownIt. Failed to disable unknown rule(s): " + missed);
    return this;
};
/** chainable
 * MarkdownIt.use(plugin, params)
 *
 * Load specified plugin with given params into current parser instance.
 * It's just a sugar to call `plugin(md, params)` with curring.
 *
 * ##### Example
 *
 * ```javascript
 * var iterator = require('markdown-it-for-inline');
 * var md = require('markdown-it')()
 *             .use(iterator, 'foo_replace', 'text', function (tokens, idx) {
 *               tokens[idx].content = tokens[idx].content.replace(/foo/g, 'bar');
 *             });
 * ```
 **/ $2a79b7af2b27cf4b$var$MarkdownIt.prototype.use = function(plugin /*, params, ... */ ) {
    var args = [
        this
    ].concat(Array.prototype.slice.call(arguments, 1));
    plugin.apply(plugin, args);
    return this;
};
/** internal
 * MarkdownIt.parse(src, env) -> Array
 * - src (String): source string
 * - env (Object): environment sandbox
 *
 * Parse input string and return list of block tokens (special token type
 * "inline" will contain list of inline tokens). You should not call this
 * method directly, until you write custom renderer (for example, to produce
 * AST).
 *
 * `env` is used to pass data between "distributed" rules and return additional
 * metadata like reference info, needed for the renderer. It also can be used to
 * inject data in specific cases. Usually, you will be ok to pass `{}`,
 * and then pass updated object to renderer.
 **/ $2a79b7af2b27cf4b$var$MarkdownIt.prototype.parse = function(src, env) {
    if (typeof src !== "string") throw new Error("Input data should be a String");
    var state = new this.core.State(src, this, env);
    this.core.process(state);
    return state.tokens;
};
/**
 * MarkdownIt.render(src [, env]) -> String
 * - src (String): source string
 * - env (Object): environment sandbox
 *
 * Render markdown string into html. It does all magic for you :).
 *
 * `env` can be used to inject additional metadata (`{}` by default).
 * But you will not need it with high probability. See also comment
 * in [[MarkdownIt.parse]].
 **/ $2a79b7af2b27cf4b$var$MarkdownIt.prototype.render = function(src, env) {
    env = env || {};
    return this.renderer.render(this.parse(src, env), this.options, env);
};
/** internal
 * MarkdownIt.parseInline(src, env) -> Array
 * - src (String): source string
 * - env (Object): environment sandbox
 *
 * The same as [[MarkdownIt.parse]] but skip all block rules. It returns the
 * block tokens list with the single `inline` element, containing parsed inline
 * tokens in `children` property. Also updates `env` object.
 **/ $2a79b7af2b27cf4b$var$MarkdownIt.prototype.parseInline = function(src, env) {
    var state = new this.core.State(src, this, env);
    state.inlineMode = true;
    this.core.process(state);
    return state.tokens;
};
/**
 * MarkdownIt.renderInline(src [, env]) -> String
 * - src (String): source string
 * - env (Object): environment sandbox
 *
 * Similar to [[MarkdownIt.render]] but for single paragraph content. Result
 * will NOT be wrapped into `<p>` tags.
 **/ $2a79b7af2b27cf4b$var$MarkdownIt.prototype.renderInline = function(src, env) {
    env = env || {};
    return this.renderer.render(this.parseInline(src, env), this.options, env);
};
module.exports = $2a79b7af2b27cf4b$var$MarkdownIt;

});
parcelRequire.register("iCsQ9", function(module, exports) {

$parcel$export(module.exports, "lib", () => $d8e225a1859f3aa8$export$16c08b91f883959a, (v) => $d8e225a1859f3aa8$export$16c08b91f883959a = v);
$parcel$export(module.exports, "assign", () => $d8e225a1859f3aa8$export$e6e34fd1f2686227, (v) => $d8e225a1859f3aa8$export$e6e34fd1f2686227 = v);
$parcel$export(module.exports, "isString", () => $d8e225a1859f3aa8$export$844ec244b1367d54, (v) => $d8e225a1859f3aa8$export$844ec244b1367d54 = v);
$parcel$export(module.exports, "has", () => $d8e225a1859f3aa8$export$a4f4bb6b1453fff5, (v) => $d8e225a1859f3aa8$export$a4f4bb6b1453fff5 = v);
$parcel$export(module.exports, "unescapeMd", () => $d8e225a1859f3aa8$export$5ccde1ea0c14bb03, (v) => $d8e225a1859f3aa8$export$5ccde1ea0c14bb03 = v);
$parcel$export(module.exports, "unescapeAll", () => $d8e225a1859f3aa8$export$db8a17c6655f7e2c, (v) => $d8e225a1859f3aa8$export$db8a17c6655f7e2c = v);
$parcel$export(module.exports, "isValidEntityCode", () => $d8e225a1859f3aa8$export$644a8f5b13b2a36d, (v) => $d8e225a1859f3aa8$export$644a8f5b13b2a36d = v);
$parcel$export(module.exports, "fromCodePoint", () => $d8e225a1859f3aa8$export$73bfc63873071f74, (v) => $d8e225a1859f3aa8$export$73bfc63873071f74 = v);
$parcel$export(module.exports, "escapeHtml", () => $d8e225a1859f3aa8$export$4cf11838cdc2a8a8, (v) => $d8e225a1859f3aa8$export$4cf11838cdc2a8a8 = v);
$parcel$export(module.exports, "arrayReplaceAt", () => $d8e225a1859f3aa8$export$f78478f71955b6bc, (v) => $d8e225a1859f3aa8$export$f78478f71955b6bc = v);
$parcel$export(module.exports, "isSpace", () => $d8e225a1859f3aa8$export$1d5ccafae59b4926, (v) => $d8e225a1859f3aa8$export$1d5ccafae59b4926 = v);
$parcel$export(module.exports, "isWhiteSpace", () => $d8e225a1859f3aa8$export$3c52dd84024ae72c, (v) => $d8e225a1859f3aa8$export$3c52dd84024ae72c = v);
$parcel$export(module.exports, "isMdAsciiPunct", () => $d8e225a1859f3aa8$export$829a0d33ae4e744, (v) => $d8e225a1859f3aa8$export$829a0d33ae4e744 = v);
$parcel$export(module.exports, "isPunctChar", () => $d8e225a1859f3aa8$export$4888a643af800fc1, (v) => $d8e225a1859f3aa8$export$4888a643af800fc1 = v);
$parcel$export(module.exports, "escapeRE", () => $d8e225a1859f3aa8$export$bc616c8f7dc20d5d, (v) => $d8e225a1859f3aa8$export$bc616c8f7dc20d5d = v);
$parcel$export(module.exports, "normalizeReference", () => $d8e225a1859f3aa8$export$20ef46802c8744b, (v) => $d8e225a1859f3aa8$export$20ef46802c8744b = v);
// Utilities
//
////////////////////////////////////////////////////////////////////////////////
// Re-export libraries commonly used in both markdown-it and its plugins,
// so plugins won't have to depend on them explicitly, which reduces their
// bundled size (e.g. a browser build).
//
var $d8e225a1859f3aa8$export$16c08b91f883959a;
var $d8e225a1859f3aa8$export$e6e34fd1f2686227;
var $d8e225a1859f3aa8$export$844ec244b1367d54;
var $d8e225a1859f3aa8$export$a4f4bb6b1453fff5;
var $d8e225a1859f3aa8$export$5ccde1ea0c14bb03;
var $d8e225a1859f3aa8$export$db8a17c6655f7e2c;
var $d8e225a1859f3aa8$export$644a8f5b13b2a36d;
var $d8e225a1859f3aa8$export$73bfc63873071f74;
// exports.replaceEntities     = replaceEntities;
var $d8e225a1859f3aa8$export$4cf11838cdc2a8a8;
var $d8e225a1859f3aa8$export$f78478f71955b6bc;
var $d8e225a1859f3aa8$export$1d5ccafae59b4926;
var $d8e225a1859f3aa8$export$3c52dd84024ae72c;
var $d8e225a1859f3aa8$export$829a0d33ae4e744;
var $d8e225a1859f3aa8$export$4888a643af800fc1;
var $d8e225a1859f3aa8$export$bc616c8f7dc20d5d;
var $d8e225a1859f3aa8$export$20ef46802c8744b;
"use strict";
function $d8e225a1859f3aa8$var$_class(obj) {
    return Object.prototype.toString.call(obj);
}
function $d8e225a1859f3aa8$var$isString(obj) {
    return $d8e225a1859f3aa8$var$_class(obj) === "[object String]";
}
var $d8e225a1859f3aa8$var$_hasOwnProperty = Object.prototype.hasOwnProperty;
function $d8e225a1859f3aa8$var$has(object, key) {
    return $d8e225a1859f3aa8$var$_hasOwnProperty.call(object, key);
}
// Merge objects
//
function $d8e225a1859f3aa8$var$assign(obj /*from1, from2, from3, ...*/ ) {
    var sources = Array.prototype.slice.call(arguments, 1);
    sources.forEach(function(source) {
        if (!source) return;
        if (typeof source !== "object") throw new TypeError(source + "must be object");
        Object.keys(source).forEach(function(key) {
            obj[key] = source[key];
        });
    });
    return obj;
}
// Remove element from array and put another array at those position.
// Useful for some operations with tokens
function $d8e225a1859f3aa8$var$arrayReplaceAt(src, pos, newElements) {
    return [].concat(src.slice(0, pos), newElements, src.slice(pos + 1));
}
////////////////////////////////////////////////////////////////////////////////
function $d8e225a1859f3aa8$var$isValidEntityCode(c) {
    /*eslint no-bitwise:0*/ // broken sequence
    if (c >= 0xD800 && c <= 0xDFFF) return false;
    // never used
    if (c >= 0xFDD0 && c <= 0xFDEF) return false;
    if ((c & 0xFFFF) === 0xFFFF || (c & 0xFFFF) === 0xFFFE) return false;
    // control codes
    if (c >= 0x00 && c <= 0x08) return false;
    if (c === 0x0B) return false;
    if (c >= 0x0E && c <= 0x1F) return false;
    if (c >= 0x7F && c <= 0x9F) return false;
    // out of range
    if (c > 0x10FFFF) return false;
    return true;
}
function $d8e225a1859f3aa8$var$fromCodePoint(c) {
    /*eslint no-bitwise:0*/ if (c > 0xffff) {
        c -= 0x10000;
        var surrogate1 = 0xd800 + (c >> 10), surrogate2 = 0xdc00 + (c & 0x3ff);
        return String.fromCharCode(surrogate1, surrogate2);
    }
    return String.fromCharCode(c);
}
var $d8e225a1859f3aa8$var$UNESCAPE_MD_RE = /\\([!"#$%&'()*+,\-.\/:;<=>?@[\\\]^_`{|}~])/g;
var $d8e225a1859f3aa8$var$ENTITY_RE = /&([a-z#][a-z0-9]{1,31});/gi;
var $d8e225a1859f3aa8$var$UNESCAPE_ALL_RE = new RegExp($d8e225a1859f3aa8$var$UNESCAPE_MD_RE.source + "|" + $d8e225a1859f3aa8$var$ENTITY_RE.source, "gi");
var $d8e225a1859f3aa8$var$DIGITAL_ENTITY_TEST_RE = /^#((?:x[a-f0-9]{1,8}|[0-9]{1,8}))/i;

var $6FYMy = parcelRequire("6FYMy");
function $d8e225a1859f3aa8$var$replaceEntityPattern(match, name) {
    var code = 0;
    if ($d8e225a1859f3aa8$var$has($6FYMy, name)) return $6FYMy[name];
    if (name.charCodeAt(0) === 0x23 /* # */  && $d8e225a1859f3aa8$var$DIGITAL_ENTITY_TEST_RE.test(name)) {
        code = name[1].toLowerCase() === "x" ? parseInt(name.slice(2), 16) : parseInt(name.slice(1), 10);
        if ($d8e225a1859f3aa8$var$isValidEntityCode(code)) return $d8e225a1859f3aa8$var$fromCodePoint(code);
    }
    return match;
}
/*function replaceEntities(str) {
  if (str.indexOf('&') < 0) { return str; }

  return str.replace(ENTITY_RE, replaceEntityPattern);
}*/ function $d8e225a1859f3aa8$var$unescapeMd(str) {
    if (str.indexOf("\\") < 0) return str;
    return str.replace($d8e225a1859f3aa8$var$UNESCAPE_MD_RE, "$1");
}
function $d8e225a1859f3aa8$var$unescapeAll(str) {
    if (str.indexOf("\\") < 0 && str.indexOf("&") < 0) return str;
    return str.replace($d8e225a1859f3aa8$var$UNESCAPE_ALL_RE, function(match, escaped, entity) {
        if (escaped) return escaped;
        return $d8e225a1859f3aa8$var$replaceEntityPattern(match, entity);
    });
}
////////////////////////////////////////////////////////////////////////////////
var $d8e225a1859f3aa8$var$HTML_ESCAPE_TEST_RE = /[&<>"]/;
var $d8e225a1859f3aa8$var$HTML_ESCAPE_REPLACE_RE = /[&<>"]/g;
var $d8e225a1859f3aa8$var$HTML_REPLACEMENTS = {
    "&": "&amp;",
    "<": "&lt;",
    ">": "&gt;",
    '"': "&quot;"
};
function $d8e225a1859f3aa8$var$replaceUnsafeChar(ch) {
    return $d8e225a1859f3aa8$var$HTML_REPLACEMENTS[ch];
}
function $d8e225a1859f3aa8$var$escapeHtml(str) {
    if ($d8e225a1859f3aa8$var$HTML_ESCAPE_TEST_RE.test(str)) return str.replace($d8e225a1859f3aa8$var$HTML_ESCAPE_REPLACE_RE, $d8e225a1859f3aa8$var$replaceUnsafeChar);
    return str;
}
////////////////////////////////////////////////////////////////////////////////
var $d8e225a1859f3aa8$var$REGEXP_ESCAPE_RE = /[.?*+^$[\]\\(){}|-]/g;
function $d8e225a1859f3aa8$var$escapeRE(str) {
    return str.replace($d8e225a1859f3aa8$var$REGEXP_ESCAPE_RE, "\\$&");
}
////////////////////////////////////////////////////////////////////////////////
function $d8e225a1859f3aa8$var$isSpace(code) {
    switch(code){
        case 0x09:
        case 0x20:
            return true;
    }
    return false;
}
// Zs (unicode class) || [\t\f\v\r\n]
function $d8e225a1859f3aa8$var$isWhiteSpace(code) {
    if (code >= 0x2000 && code <= 0x200A) return true;
    switch(code){
        case 0x09:
        case 0x0A:
        case 0x0B:
        case 0x0C:
        case 0x0D:
        case 0x20:
        case 0xA0:
        case 0x1680:
        case 0x202F:
        case 0x205F:
        case 0x3000:
            return true;
    }
    return false;
}

var $7X6km = parcelRequire("7X6km");
// Currently without astral characters support.
function $d8e225a1859f3aa8$var$isPunctChar(ch) {
    return $7X6km.test(ch);
}
// Markdown ASCII punctuation characters.
//
// !, ", #, $, %, &, ', (, ), *, +, ,, -, ., /, :, ;, <, =, >, ?, @, [, \, ], ^, _, `, {, |, }, or ~
// http://spec.commonmark.org/0.15/#ascii-punctuation-character
//
// Don't confuse with unicode punctuation !!! It lacks some chars in ascii range.
//
function $d8e225a1859f3aa8$var$isMdAsciiPunct(ch) {
    switch(ch){
        case 0x21 /* ! */ :
        case 0x22 /* " */ :
        case 0x23 /* # */ :
        case 0x24 /* $ */ :
        case 0x25 /* % */ :
        case 0x26 /* & */ :
        case 0x27 /* ' */ :
        case 0x28 /* ( */ :
        case 0x29 /* ) */ :
        case 0x2A /* * */ :
        case 0x2B /* + */ :
        case 0x2C /* , */ :
        case 0x2D /* - */ :
        case 0x2E /* . */ :
        case 0x2F /* / */ :
        case 0x3A /* : */ :
        case 0x3B /* ; */ :
        case 0x3C /* < */ :
        case 0x3D /* = */ :
        case 0x3E /* > */ :
        case 0x3F /* ? */ :
        case 0x40 /* @ */ :
        case 0x5B /* [ */ :
        case 0x5C /* \ */ :
        case 0x5D /* ] */ :
        case 0x5E /* ^ */ :
        case 0x5F /* _ */ :
        case 0x60 /* ` */ :
        case 0x7B /* { */ :
        case 0x7C /* | */ :
        case 0x7D /* } */ :
        case 0x7E /* ~ */ :
            return true;
        default:
            return false;
    }
}
// Hepler to unify [reference labels].
//
function $d8e225a1859f3aa8$var$normalizeReference(str) {
    // Trim and collapse whitespace
    //
    str = str.trim().replace(/\s+/g, " ");
    // In node v10 'ẞ'.toLowerCase() === 'Ṿ', which is presumed to be a bug
    // fixed in v12 (couldn't find any details).
    //
    // So treat this one as a special case
    // (remove this when node v10 is no longer supported).
    //
    if ("ẞ".toLowerCase() === "Ṿ") str = str.replace(/ẞ/g, "\xdf");
    // .toLowerCase().toUpperCase() should get rid of all differences
    // between letter variants.
    //
    // Simple .toLowerCase() doesn't normalize 125 code points correctly,
    // and .toUpperCase doesn't normalize 6 of them (list of exceptions:
    // İ, ϴ, ẞ, Ω, K, Å - those are already uppercased, but have differently
    // uppercased versions).
    //
    // Here's an example showing how it happens. Lets take greek letter omega:
    // uppercase U+0398 (Θ), U+03f4 (ϴ) and lowercase U+03b8 (θ), U+03d1 (ϑ)
    //
    // Unicode entries:
    // 0398;GREEK CAPITAL LETTER THETA;Lu;0;L;;;;;N;;;;03B8;
    // 03B8;GREEK SMALL LETTER THETA;Ll;0;L;;;;;N;;;0398;;0398
    // 03D1;GREEK THETA SYMBOL;Ll;0;L;<compat> 03B8;;;;N;GREEK SMALL LETTER SCRIPT THETA;;0398;;0398
    // 03F4;GREEK CAPITAL THETA SYMBOL;Lu;0;L;<compat> 0398;;;;N;;;;03B8;
    //
    // Case-insensitive comparison should treat all of them as equivalent.
    //
    // But .toLowerCase() doesn't change ϑ (it's already lowercase),
    // and .toUpperCase() doesn't change ϴ (already uppercase).
    //
    // Applying first lower then upper case normalizes any character:
    // '\u0398\u03f4\u03b8\u03d1'.toLowerCase().toUpperCase() === '\u0398\u0398\u0398\u0398'
    //
    // Note: this is equivalent to unicode case folding; unicode normalization
    // is a different step that is not required here.
    //
    // Final result should be uppercased, because it's later stored in an object
    // (this avoid a conflict with Object.prototype members,
    // most notably, `__proto__`)
    //
    return str.toLowerCase().toUpperCase();
}
$d8e225a1859f3aa8$export$16c08b91f883959a = {};

$d8e225a1859f3aa8$export$16c08b91f883959a.mdurl = (parcelRequire("e2HUE"));

$d8e225a1859f3aa8$export$16c08b91f883959a.ucmicro = (parcelRequire("7rqQE"));
$d8e225a1859f3aa8$export$e6e34fd1f2686227 = $d8e225a1859f3aa8$var$assign;
$d8e225a1859f3aa8$export$844ec244b1367d54 = $d8e225a1859f3aa8$var$isString;
$d8e225a1859f3aa8$export$a4f4bb6b1453fff5 = $d8e225a1859f3aa8$var$has;
$d8e225a1859f3aa8$export$5ccde1ea0c14bb03 = $d8e225a1859f3aa8$var$unescapeMd;
$d8e225a1859f3aa8$export$db8a17c6655f7e2c = $d8e225a1859f3aa8$var$unescapeAll;
$d8e225a1859f3aa8$export$644a8f5b13b2a36d = $d8e225a1859f3aa8$var$isValidEntityCode;
$d8e225a1859f3aa8$export$73bfc63873071f74 = $d8e225a1859f3aa8$var$fromCodePoint;
$d8e225a1859f3aa8$export$4cf11838cdc2a8a8 = $d8e225a1859f3aa8$var$escapeHtml;
$d8e225a1859f3aa8$export$f78478f71955b6bc = $d8e225a1859f3aa8$var$arrayReplaceAt;
$d8e225a1859f3aa8$export$1d5ccafae59b4926 = $d8e225a1859f3aa8$var$isSpace;
$d8e225a1859f3aa8$export$3c52dd84024ae72c = $d8e225a1859f3aa8$var$isWhiteSpace;
$d8e225a1859f3aa8$export$829a0d33ae4e744 = $d8e225a1859f3aa8$var$isMdAsciiPunct;
$d8e225a1859f3aa8$export$4888a643af800fc1 = $d8e225a1859f3aa8$var$isPunctChar;
$d8e225a1859f3aa8$export$bc616c8f7dc20d5d = $d8e225a1859f3aa8$var$escapeRE;
$d8e225a1859f3aa8$export$20ef46802c8744b = $d8e225a1859f3aa8$var$normalizeReference;

});
parcelRequire.register("6FYMy", function(module, exports) {
// HTML5 entities map: { name -> utf16string }
//
"use strict";

/*eslint quotes:0*/ module.exports = (parcelRequire("9bJ9D"));

});
parcelRequire.register("9bJ9D", function(module, exports) {
module.exports = JSON.parse('{"Aacute":"\xc1","aacute":"\xe1","Abreve":"Ă","abreve":"ă","ac":"∾","acd":"∿","acE":"∾̳","Acirc":"\xc2","acirc":"\xe2","acute":"\xb4","Acy":"А","acy":"а","AElig":"\xc6","aelig":"\xe6","af":"⁡","Afr":"\uD835\uDD04","afr":"\uD835\uDD1E","Agrave":"\xc0","agrave":"\xe0","alefsym":"ℵ","aleph":"ℵ","Alpha":"Α","alpha":"α","Amacr":"Ā","amacr":"ā","amalg":"⨿","amp":"&","AMP":"&","andand":"⩕","And":"⩓","and":"∧","andd":"⩜","andslope":"⩘","andv":"⩚","ang":"∠","ange":"⦤","angle":"∠","angmsdaa":"⦨","angmsdab":"⦩","angmsdac":"⦪","angmsdad":"⦫","angmsdae":"⦬","angmsdaf":"⦭","angmsdag":"⦮","angmsdah":"⦯","angmsd":"∡","angrt":"∟","angrtvb":"⊾","angrtvbd":"⦝","angsph":"∢","angst":"\xc5","angzarr":"⍼","Aogon":"Ą","aogon":"ą","Aopf":"\uD835\uDD38","aopf":"\uD835\uDD52","apacir":"⩯","ap":"≈","apE":"⩰","ape":"≊","apid":"≋","apos":"\'","ApplyFunction":"⁡","approx":"≈","approxeq":"≊","Aring":"\xc5","aring":"\xe5","Ascr":"\uD835\uDC9C","ascr":"\uD835\uDCB6","Assign":"≔","ast":"*","asymp":"≈","asympeq":"≍","Atilde":"\xc3","atilde":"\xe3","Auml":"\xc4","auml":"\xe4","awconint":"∳","awint":"⨑","backcong":"≌","backepsilon":"϶","backprime":"‵","backsim":"∽","backsimeq":"⋍","Backslash":"∖","Barv":"⫧","barvee":"⊽","barwed":"⌅","Barwed":"⌆","barwedge":"⌅","bbrk":"⎵","bbrktbrk":"⎶","bcong":"≌","Bcy":"Б","bcy":"б","bdquo":"„","becaus":"∵","because":"∵","Because":"∵","bemptyv":"⦰","bepsi":"϶","bernou":"ℬ","Bernoullis":"ℬ","Beta":"Β","beta":"β","beth":"ℶ","between":"≬","Bfr":"\uD835\uDD05","bfr":"\uD835\uDD1F","bigcap":"⋂","bigcirc":"◯","bigcup":"⋃","bigodot":"⨀","bigoplus":"⨁","bigotimes":"⨂","bigsqcup":"⨆","bigstar":"★","bigtriangledown":"▽","bigtriangleup":"△","biguplus":"⨄","bigvee":"⋁","bigwedge":"⋀","bkarow":"⤍","blacklozenge":"⧫","blacksquare":"▪","blacktriangle":"▴","blacktriangledown":"▾","blacktriangleleft":"◂","blacktriangleright":"▸","blank":"␣","blk12":"▒","blk14":"░","blk34":"▓","block":"█","bne":"=⃥","bnequiv":"≡⃥","bNot":"⫭","bnot":"⌐","Bopf":"\uD835\uDD39","bopf":"\uD835\uDD53","bot":"⊥","bottom":"⊥","bowtie":"⋈","boxbox":"⧉","boxdl":"┐","boxdL":"╕","boxDl":"╖","boxDL":"╗","boxdr":"┌","boxdR":"╒","boxDr":"╓","boxDR":"╔","boxh":"─","boxH":"═","boxhd":"┬","boxHd":"╤","boxhD":"╥","boxHD":"╦","boxhu":"┴","boxHu":"╧","boxhU":"╨","boxHU":"╩","boxminus":"⊟","boxplus":"⊞","boxtimes":"⊠","boxul":"┘","boxuL":"╛","boxUl":"╜","boxUL":"╝","boxur":"└","boxuR":"╘","boxUr":"╙","boxUR":"╚","boxv":"│","boxV":"║","boxvh":"┼","boxvH":"╪","boxVh":"╫","boxVH":"╬","boxvl":"┤","boxvL":"╡","boxVl":"╢","boxVL":"╣","boxvr":"├","boxvR":"╞","boxVr":"╟","boxVR":"╠","bprime":"‵","breve":"˘","Breve":"˘","brvbar":"\xa6","bscr":"\uD835\uDCB7","Bscr":"ℬ","bsemi":"⁏","bsim":"∽","bsime":"⋍","bsolb":"⧅","bsol":"\\\\","bsolhsub":"⟈","bull":"•","bullet":"•","bump":"≎","bumpE":"⪮","bumpe":"≏","Bumpeq":"≎","bumpeq":"≏","Cacute":"Ć","cacute":"ć","capand":"⩄","capbrcup":"⩉","capcap":"⩋","cap":"∩","Cap":"⋒","capcup":"⩇","capdot":"⩀","CapitalDifferentialD":"ⅅ","caps":"∩︀","caret":"⁁","caron":"ˇ","Cayleys":"ℭ","ccaps":"⩍","Ccaron":"Č","ccaron":"č","Ccedil":"\xc7","ccedil":"\xe7","Ccirc":"Ĉ","ccirc":"ĉ","Cconint":"∰","ccups":"⩌","ccupssm":"⩐","Cdot":"Ċ","cdot":"ċ","cedil":"\xb8","Cedilla":"\xb8","cemptyv":"⦲","cent":"\xa2","centerdot":"\xb7","CenterDot":"\xb7","cfr":"\uD835\uDD20","Cfr":"ℭ","CHcy":"Ч","chcy":"ч","check":"✓","checkmark":"✓","Chi":"Χ","chi":"χ","circ":"ˆ","circeq":"≗","circlearrowleft":"↺","circlearrowright":"↻","circledast":"⊛","circledcirc":"⊚","circleddash":"⊝","CircleDot":"⊙","circledR":"\xae","circledS":"Ⓢ","CircleMinus":"⊖","CirclePlus":"⊕","CircleTimes":"⊗","cir":"○","cirE":"⧃","cire":"≗","cirfnint":"⨐","cirmid":"⫯","cirscir":"⧂","ClockwiseContourIntegral":"∲","CloseCurlyDoubleQuote":"”","CloseCurlyQuote":"’","clubs":"♣","clubsuit":"♣","colon":":","Colon":"∷","Colone":"⩴","colone":"≔","coloneq":"≔","comma":",","commat":"@","comp":"∁","compfn":"∘","complement":"∁","complexes":"ℂ","cong":"≅","congdot":"⩭","Congruent":"≡","conint":"∮","Conint":"∯","ContourIntegral":"∮","copf":"\uD835\uDD54","Copf":"ℂ","coprod":"∐","Coproduct":"∐","copy":"\xa9","COPY":"\xa9","copysr":"℗","CounterClockwiseContourIntegral":"∳","crarr":"↵","cross":"✗","Cross":"⨯","Cscr":"\uD835\uDC9E","cscr":"\uD835\uDCB8","csub":"⫏","csube":"⫑","csup":"⫐","csupe":"⫒","ctdot":"⋯","cudarrl":"⤸","cudarrr":"⤵","cuepr":"⋞","cuesc":"⋟","cularr":"↶","cularrp":"⤽","cupbrcap":"⩈","cupcap":"⩆","CupCap":"≍","cup":"∪","Cup":"⋓","cupcup":"⩊","cupdot":"⊍","cupor":"⩅","cups":"∪︀","curarr":"↷","curarrm":"⤼","curlyeqprec":"⋞","curlyeqsucc":"⋟","curlyvee":"⋎","curlywedge":"⋏","curren":"\xa4","curvearrowleft":"↶","curvearrowright":"↷","cuvee":"⋎","cuwed":"⋏","cwconint":"∲","cwint":"∱","cylcty":"⌭","dagger":"†","Dagger":"‡","daleth":"ℸ","darr":"↓","Darr":"↡","dArr":"⇓","dash":"‐","Dashv":"⫤","dashv":"⊣","dbkarow":"⤏","dblac":"˝","Dcaron":"Ď","dcaron":"ď","Dcy":"Д","dcy":"д","ddagger":"‡","ddarr":"⇊","DD":"ⅅ","dd":"ⅆ","DDotrahd":"⤑","ddotseq":"⩷","deg":"\xb0","Del":"∇","Delta":"Δ","delta":"δ","demptyv":"⦱","dfisht":"⥿","Dfr":"\uD835\uDD07","dfr":"\uD835\uDD21","dHar":"⥥","dharl":"⇃","dharr":"⇂","DiacriticalAcute":"\xb4","DiacriticalDot":"˙","DiacriticalDoubleAcute":"˝","DiacriticalGrave":"`","DiacriticalTilde":"˜","diam":"⋄","diamond":"⋄","Diamond":"⋄","diamondsuit":"♦","diams":"♦","die":"\xa8","DifferentialD":"ⅆ","digamma":"ϝ","disin":"⋲","div":"\xf7","divide":"\xf7","divideontimes":"⋇","divonx":"⋇","DJcy":"Ђ","djcy":"ђ","dlcorn":"⌞","dlcrop":"⌍","dollar":"$","Dopf":"\uD835\uDD3B","dopf":"\uD835\uDD55","Dot":"\xa8","dot":"˙","DotDot":"⃜","doteq":"≐","doteqdot":"≑","DotEqual":"≐","dotminus":"∸","dotplus":"∔","dotsquare":"⊡","doublebarwedge":"⌆","DoubleContourIntegral":"∯","DoubleDot":"\xa8","DoubleDownArrow":"⇓","DoubleLeftArrow":"⇐","DoubleLeftRightArrow":"⇔","DoubleLeftTee":"⫤","DoubleLongLeftArrow":"⟸","DoubleLongLeftRightArrow":"⟺","DoubleLongRightArrow":"⟹","DoubleRightArrow":"⇒","DoubleRightTee":"⊨","DoubleUpArrow":"⇑","DoubleUpDownArrow":"⇕","DoubleVerticalBar":"∥","DownArrowBar":"⤓","downarrow":"↓","DownArrow":"↓","Downarrow":"⇓","DownArrowUpArrow":"⇵","DownBreve":"̑","downdownarrows":"⇊","downharpoonleft":"⇃","downharpoonright":"⇂","DownLeftRightVector":"⥐","DownLeftTeeVector":"⥞","DownLeftVectorBar":"⥖","DownLeftVector":"↽","DownRightTeeVector":"⥟","DownRightVectorBar":"⥗","DownRightVector":"⇁","DownTeeArrow":"↧","DownTee":"⊤","drbkarow":"⤐","drcorn":"⌟","drcrop":"⌌","Dscr":"\uD835\uDC9F","dscr":"\uD835\uDCB9","DScy":"Ѕ","dscy":"ѕ","dsol":"⧶","Dstrok":"Đ","dstrok":"đ","dtdot":"⋱","dtri":"▿","dtrif":"▾","duarr":"⇵","duhar":"⥯","dwangle":"⦦","DZcy":"Џ","dzcy":"џ","dzigrarr":"⟿","Eacute":"\xc9","eacute":"\xe9","easter":"⩮","Ecaron":"Ě","ecaron":"ě","Ecirc":"\xca","ecirc":"\xea","ecir":"≖","ecolon":"≕","Ecy":"Э","ecy":"э","eDDot":"⩷","Edot":"Ė","edot":"ė","eDot":"≑","ee":"ⅇ","efDot":"≒","Efr":"\uD835\uDD08","efr":"\uD835\uDD22","eg":"⪚","Egrave":"\xc8","egrave":"\xe8","egs":"⪖","egsdot":"⪘","el":"⪙","Element":"∈","elinters":"⏧","ell":"ℓ","els":"⪕","elsdot":"⪗","Emacr":"Ē","emacr":"ē","empty":"∅","emptyset":"∅","EmptySmallSquare":"◻","emptyv":"∅","EmptyVerySmallSquare":"▫","emsp13":" ","emsp14":" ","emsp":" ","ENG":"Ŋ","eng":"ŋ","ensp":" ","Eogon":"Ę","eogon":"ę","Eopf":"\uD835\uDD3C","eopf":"\uD835\uDD56","epar":"⋕","eparsl":"⧣","eplus":"⩱","epsi":"ε","Epsilon":"Ε","epsilon":"ε","epsiv":"ϵ","eqcirc":"≖","eqcolon":"≕","eqsim":"≂","eqslantgtr":"⪖","eqslantless":"⪕","Equal":"⩵","equals":"=","EqualTilde":"≂","equest":"≟","Equilibrium":"⇌","equiv":"≡","equivDD":"⩸","eqvparsl":"⧥","erarr":"⥱","erDot":"≓","escr":"ℯ","Escr":"ℰ","esdot":"≐","Esim":"⩳","esim":"≂","Eta":"Η","eta":"η","ETH":"\xd0","eth":"\xf0","Euml":"\xcb","euml":"\xeb","euro":"€","excl":"!","exist":"∃","Exists":"∃","expectation":"ℰ","exponentiale":"ⅇ","ExponentialE":"ⅇ","fallingdotseq":"≒","Fcy":"Ф","fcy":"ф","female":"♀","ffilig":"ﬃ","fflig":"ﬀ","ffllig":"ﬄ","Ffr":"\uD835\uDD09","ffr":"\uD835\uDD23","filig":"ﬁ","FilledSmallSquare":"◼","FilledVerySmallSquare":"▪","fjlig":"fj","flat":"♭","fllig":"ﬂ","fltns":"▱","fnof":"ƒ","Fopf":"\uD835\uDD3D","fopf":"\uD835\uDD57","forall":"∀","ForAll":"∀","fork":"⋔","forkv":"⫙","Fouriertrf":"ℱ","fpartint":"⨍","frac12":"\xbd","frac13":"⅓","frac14":"\xbc","frac15":"⅕","frac16":"⅙","frac18":"⅛","frac23":"⅔","frac25":"⅖","frac34":"\xbe","frac35":"⅗","frac38":"⅜","frac45":"⅘","frac56":"⅚","frac58":"⅝","frac78":"⅞","frasl":"⁄","frown":"⌢","fscr":"\uD835\uDCBB","Fscr":"ℱ","gacute":"ǵ","Gamma":"Γ","gamma":"γ","Gammad":"Ϝ","gammad":"ϝ","gap":"⪆","Gbreve":"Ğ","gbreve":"ğ","Gcedil":"Ģ","Gcirc":"Ĝ","gcirc":"ĝ","Gcy":"Г","gcy":"г","Gdot":"Ġ","gdot":"ġ","ge":"≥","gE":"≧","gEl":"⪌","gel":"⋛","geq":"≥","geqq":"≧","geqslant":"⩾","gescc":"⪩","ges":"⩾","gesdot":"⪀","gesdoto":"⪂","gesdotol":"⪄","gesl":"⋛︀","gesles":"⪔","Gfr":"\uD835\uDD0A","gfr":"\uD835\uDD24","gg":"≫","Gg":"⋙","ggg":"⋙","gimel":"ℷ","GJcy":"Ѓ","gjcy":"ѓ","gla":"⪥","gl":"≷","glE":"⪒","glj":"⪤","gnap":"⪊","gnapprox":"⪊","gne":"⪈","gnE":"≩","gneq":"⪈","gneqq":"≩","gnsim":"⋧","Gopf":"\uD835\uDD3E","gopf":"\uD835\uDD58","grave":"`","GreaterEqual":"≥","GreaterEqualLess":"⋛","GreaterFullEqual":"≧","GreaterGreater":"⪢","GreaterLess":"≷","GreaterSlantEqual":"⩾","GreaterTilde":"≳","Gscr":"\uD835\uDCA2","gscr":"ℊ","gsim":"≳","gsime":"⪎","gsiml":"⪐","gtcc":"⪧","gtcir":"⩺","gt":">","GT":">","Gt":"≫","gtdot":"⋗","gtlPar":"⦕","gtquest":"⩼","gtrapprox":"⪆","gtrarr":"⥸","gtrdot":"⋗","gtreqless":"⋛","gtreqqless":"⪌","gtrless":"≷","gtrsim":"≳","gvertneqq":"≩︀","gvnE":"≩︀","Hacek":"ˇ","hairsp":" ","half":"\xbd","hamilt":"ℋ","HARDcy":"Ъ","hardcy":"ъ","harrcir":"⥈","harr":"↔","hArr":"⇔","harrw":"↭","Hat":"^","hbar":"ℏ","Hcirc":"Ĥ","hcirc":"ĥ","hearts":"♥","heartsuit":"♥","hellip":"…","hercon":"⊹","hfr":"\uD835\uDD25","Hfr":"ℌ","HilbertSpace":"ℋ","hksearow":"⤥","hkswarow":"⤦","hoarr":"⇿","homtht":"∻","hookleftarrow":"↩","hookrightarrow":"↪","hopf":"\uD835\uDD59","Hopf":"ℍ","horbar":"―","HorizontalLine":"─","hscr":"\uD835\uDCBD","Hscr":"ℋ","hslash":"ℏ","Hstrok":"Ħ","hstrok":"ħ","HumpDownHump":"≎","HumpEqual":"≏","hybull":"⁃","hyphen":"‐","Iacute":"\xcd","iacute":"\xed","ic":"⁣","Icirc":"\xce","icirc":"\xee","Icy":"И","icy":"и","Idot":"İ","IEcy":"Е","iecy":"е","iexcl":"\xa1","iff":"⇔","ifr":"\uD835\uDD26","Ifr":"ℑ","Igrave":"\xcc","igrave":"\xec","ii":"ⅈ","iiiint":"⨌","iiint":"∭","iinfin":"⧜","iiota":"℩","IJlig":"Ĳ","ijlig":"ĳ","Imacr":"Ī","imacr":"ī","image":"ℑ","ImaginaryI":"ⅈ","imagline":"ℐ","imagpart":"ℑ","imath":"ı","Im":"ℑ","imof":"⊷","imped":"Ƶ","Implies":"⇒","incare":"℅","in":"∈","infin":"∞","infintie":"⧝","inodot":"ı","intcal":"⊺","int":"∫","Int":"∬","integers":"ℤ","Integral":"∫","intercal":"⊺","Intersection":"⋂","intlarhk":"⨗","intprod":"⨼","InvisibleComma":"⁣","InvisibleTimes":"⁢","IOcy":"Ё","iocy":"ё","Iogon":"Į","iogon":"į","Iopf":"\uD835\uDD40","iopf":"\uD835\uDD5A","Iota":"Ι","iota":"ι","iprod":"⨼","iquest":"\xbf","iscr":"\uD835\uDCBE","Iscr":"ℐ","isin":"∈","isindot":"⋵","isinE":"⋹","isins":"⋴","isinsv":"⋳","isinv":"∈","it":"⁢","Itilde":"Ĩ","itilde":"ĩ","Iukcy":"І","iukcy":"і","Iuml":"\xcf","iuml":"\xef","Jcirc":"Ĵ","jcirc":"ĵ","Jcy":"Й","jcy":"й","Jfr":"\uD835\uDD0D","jfr":"\uD835\uDD27","jmath":"ȷ","Jopf":"\uD835\uDD41","jopf":"\uD835\uDD5B","Jscr":"\uD835\uDCA5","jscr":"\uD835\uDCBF","Jsercy":"Ј","jsercy":"ј","Jukcy":"Є","jukcy":"є","Kappa":"Κ","kappa":"κ","kappav":"ϰ","Kcedil":"Ķ","kcedil":"ķ","Kcy":"К","kcy":"к","Kfr":"\uD835\uDD0E","kfr":"\uD835\uDD28","kgreen":"ĸ","KHcy":"Х","khcy":"х","KJcy":"Ќ","kjcy":"ќ","Kopf":"\uD835\uDD42","kopf":"\uD835\uDD5C","Kscr":"\uD835\uDCA6","kscr":"\uD835\uDCC0","lAarr":"⇚","Lacute":"Ĺ","lacute":"ĺ","laemptyv":"⦴","lagran":"ℒ","Lambda":"Λ","lambda":"λ","lang":"⟨","Lang":"⟪","langd":"⦑","langle":"⟨","lap":"⪅","Laplacetrf":"ℒ","laquo":"\xab","larrb":"⇤","larrbfs":"⤟","larr":"←","Larr":"↞","lArr":"⇐","larrfs":"⤝","larrhk":"↩","larrlp":"↫","larrpl":"⤹","larrsim":"⥳","larrtl":"↢","latail":"⤙","lAtail":"⤛","lat":"⪫","late":"⪭","lates":"⪭︀","lbarr":"⤌","lBarr":"⤎","lbbrk":"❲","lbrace":"{","lbrack":"[","lbrke":"⦋","lbrksld":"⦏","lbrkslu":"⦍","Lcaron":"Ľ","lcaron":"ľ","Lcedil":"Ļ","lcedil":"ļ","lceil":"⌈","lcub":"{","Lcy":"Л","lcy":"л","ldca":"⤶","ldquo":"“","ldquor":"„","ldrdhar":"⥧","ldrushar":"⥋","ldsh":"↲","le":"≤","lE":"≦","LeftAngleBracket":"⟨","LeftArrowBar":"⇤","leftarrow":"←","LeftArrow":"←","Leftarrow":"⇐","LeftArrowRightArrow":"⇆","leftarrowtail":"↢","LeftCeiling":"⌈","LeftDoubleBracket":"⟦","LeftDownTeeVector":"⥡","LeftDownVectorBar":"⥙","LeftDownVector":"⇃","LeftFloor":"⌊","leftharpoondown":"↽","leftharpoonup":"↼","leftleftarrows":"⇇","leftrightarrow":"↔","LeftRightArrow":"↔","Leftrightarrow":"⇔","leftrightarrows":"⇆","leftrightharpoons":"⇋","leftrightsquigarrow":"↭","LeftRightVector":"⥎","LeftTeeArrow":"↤","LeftTee":"⊣","LeftTeeVector":"⥚","leftthreetimes":"⋋","LeftTriangleBar":"⧏","LeftTriangle":"⊲","LeftTriangleEqual":"⊴","LeftUpDownVector":"⥑","LeftUpTeeVector":"⥠","LeftUpVectorBar":"⥘","LeftUpVector":"↿","LeftVectorBar":"⥒","LeftVector":"↼","lEg":"⪋","leg":"⋚","leq":"≤","leqq":"≦","leqslant":"⩽","lescc":"⪨","les":"⩽","lesdot":"⩿","lesdoto":"⪁","lesdotor":"⪃","lesg":"⋚︀","lesges":"⪓","lessapprox":"⪅","lessdot":"⋖","lesseqgtr":"⋚","lesseqqgtr":"⪋","LessEqualGreater":"⋚","LessFullEqual":"≦","LessGreater":"≶","lessgtr":"≶","LessLess":"⪡","lesssim":"≲","LessSlantEqual":"⩽","LessTilde":"≲","lfisht":"⥼","lfloor":"⌊","Lfr":"\uD835\uDD0F","lfr":"\uD835\uDD29","lg":"≶","lgE":"⪑","lHar":"⥢","lhard":"↽","lharu":"↼","lharul":"⥪","lhblk":"▄","LJcy":"Љ","ljcy":"љ","llarr":"⇇","ll":"≪","Ll":"⋘","llcorner":"⌞","Lleftarrow":"⇚","llhard":"⥫","lltri":"◺","Lmidot":"Ŀ","lmidot":"ŀ","lmoustache":"⎰","lmoust":"⎰","lnap":"⪉","lnapprox":"⪉","lne":"⪇","lnE":"≨","lneq":"⪇","lneqq":"≨","lnsim":"⋦","loang":"⟬","loarr":"⇽","lobrk":"⟦","longleftarrow":"⟵","LongLeftArrow":"⟵","Longleftarrow":"⟸","longleftrightarrow":"⟷","LongLeftRightArrow":"⟷","Longleftrightarrow":"⟺","longmapsto":"⟼","longrightarrow":"⟶","LongRightArrow":"⟶","Longrightarrow":"⟹","looparrowleft":"↫","looparrowright":"↬","lopar":"⦅","Lopf":"\uD835\uDD43","lopf":"\uD835\uDD5D","loplus":"⨭","lotimes":"⨴","lowast":"∗","lowbar":"_","LowerLeftArrow":"↙","LowerRightArrow":"↘","loz":"◊","lozenge":"◊","lozf":"⧫","lpar":"(","lparlt":"⦓","lrarr":"⇆","lrcorner":"⌟","lrhar":"⇋","lrhard":"⥭","lrm":"‎","lrtri":"⊿","lsaquo":"‹","lscr":"\uD835\uDCC1","Lscr":"ℒ","lsh":"↰","Lsh":"↰","lsim":"≲","lsime":"⪍","lsimg":"⪏","lsqb":"[","lsquo":"‘","lsquor":"‚","Lstrok":"Ł","lstrok":"ł","ltcc":"⪦","ltcir":"⩹","lt":"<","LT":"<","Lt":"≪","ltdot":"⋖","lthree":"⋋","ltimes":"⋉","ltlarr":"⥶","ltquest":"⩻","ltri":"◃","ltrie":"⊴","ltrif":"◂","ltrPar":"⦖","lurdshar":"⥊","luruhar":"⥦","lvertneqq":"≨︀","lvnE":"≨︀","macr":"\xaf","male":"♂","malt":"✠","maltese":"✠","Map":"⤅","map":"↦","mapsto":"↦","mapstodown":"↧","mapstoleft":"↤","mapstoup":"↥","marker":"▮","mcomma":"⨩","Mcy":"М","mcy":"м","mdash":"—","mDDot":"∺","measuredangle":"∡","MediumSpace":" ","Mellintrf":"ℳ","Mfr":"\uD835\uDD10","mfr":"\uD835\uDD2A","mho":"℧","micro":"\xb5","midast":"*","midcir":"⫰","mid":"∣","middot":"\xb7","minusb":"⊟","minus":"−","minusd":"∸","minusdu":"⨪","MinusPlus":"∓","mlcp":"⫛","mldr":"…","mnplus":"∓","models":"⊧","Mopf":"\uD835\uDD44","mopf":"\uD835\uDD5E","mp":"∓","mscr":"\uD835\uDCC2","Mscr":"ℳ","mstpos":"∾","Mu":"Μ","mu":"μ","multimap":"⊸","mumap":"⊸","nabla":"∇","Nacute":"Ń","nacute":"ń","nang":"∠⃒","nap":"≉","napE":"⩰̸","napid":"≋̸","napos":"ŉ","napprox":"≉","natural":"♮","naturals":"ℕ","natur":"♮","nbsp":"\xa0","nbump":"≎̸","nbumpe":"≏̸","ncap":"⩃","Ncaron":"Ň","ncaron":"ň","Ncedil":"Ņ","ncedil":"ņ","ncong":"≇","ncongdot":"⩭̸","ncup":"⩂","Ncy":"Н","ncy":"н","ndash":"–","nearhk":"⤤","nearr":"↗","neArr":"⇗","nearrow":"↗","ne":"≠","nedot":"≐̸","NegativeMediumSpace":"​","NegativeThickSpace":"​","NegativeThinSpace":"​","NegativeVeryThinSpace":"​","nequiv":"≢","nesear":"⤨","nesim":"≂̸","NestedGreaterGreater":"≫","NestedLessLess":"≪","NewLine":"\\n","nexist":"∄","nexists":"∄","Nfr":"\uD835\uDD11","nfr":"\uD835\uDD2B","ngE":"≧̸","nge":"≱","ngeq":"≱","ngeqq":"≧̸","ngeqslant":"⩾̸","nges":"⩾̸","nGg":"⋙̸","ngsim":"≵","nGt":"≫⃒","ngt":"≯","ngtr":"≯","nGtv":"≫̸","nharr":"↮","nhArr":"⇎","nhpar":"⫲","ni":"∋","nis":"⋼","nisd":"⋺","niv":"∋","NJcy":"Њ","njcy":"њ","nlarr":"↚","nlArr":"⇍","nldr":"‥","nlE":"≦̸","nle":"≰","nleftarrow":"↚","nLeftarrow":"⇍","nleftrightarrow":"↮","nLeftrightarrow":"⇎","nleq":"≰","nleqq":"≦̸","nleqslant":"⩽̸","nles":"⩽̸","nless":"≮","nLl":"⋘̸","nlsim":"≴","nLt":"≪⃒","nlt":"≮","nltri":"⋪","nltrie":"⋬","nLtv":"≪̸","nmid":"∤","NoBreak":"⁠","NonBreakingSpace":"\xa0","nopf":"\uD835\uDD5F","Nopf":"ℕ","Not":"⫬","not":"\xac","NotCongruent":"≢","NotCupCap":"≭","NotDoubleVerticalBar":"∦","NotElement":"∉","NotEqual":"≠","NotEqualTilde":"≂̸","NotExists":"∄","NotGreater":"≯","NotGreaterEqual":"≱","NotGreaterFullEqual":"≧̸","NotGreaterGreater":"≫̸","NotGreaterLess":"≹","NotGreaterSlantEqual":"⩾̸","NotGreaterTilde":"≵","NotHumpDownHump":"≎̸","NotHumpEqual":"≏̸","notin":"∉","notindot":"⋵̸","notinE":"⋹̸","notinva":"∉","notinvb":"⋷","notinvc":"⋶","NotLeftTriangleBar":"⧏̸","NotLeftTriangle":"⋪","NotLeftTriangleEqual":"⋬","NotLess":"≮","NotLessEqual":"≰","NotLessGreater":"≸","NotLessLess":"≪̸","NotLessSlantEqual":"⩽̸","NotLessTilde":"≴","NotNestedGreaterGreater":"⪢̸","NotNestedLessLess":"⪡̸","notni":"∌","notniva":"∌","notnivb":"⋾","notnivc":"⋽","NotPrecedes":"⊀","NotPrecedesEqual":"⪯̸","NotPrecedesSlantEqual":"⋠","NotReverseElement":"∌","NotRightTriangleBar":"⧐̸","NotRightTriangle":"⋫","NotRightTriangleEqual":"⋭","NotSquareSubset":"⊏̸","NotSquareSubsetEqual":"⋢","NotSquareSuperset":"⊐̸","NotSquareSupersetEqual":"⋣","NotSubset":"⊂⃒","NotSubsetEqual":"⊈","NotSucceeds":"⊁","NotSucceedsEqual":"⪰̸","NotSucceedsSlantEqual":"⋡","NotSucceedsTilde":"≿̸","NotSuperset":"⊃⃒","NotSupersetEqual":"⊉","NotTilde":"≁","NotTildeEqual":"≄","NotTildeFullEqual":"≇","NotTildeTilde":"≉","NotVerticalBar":"∤","nparallel":"∦","npar":"∦","nparsl":"⫽⃥","npart":"∂̸","npolint":"⨔","npr":"⊀","nprcue":"⋠","nprec":"⊀","npreceq":"⪯̸","npre":"⪯̸","nrarrc":"⤳̸","nrarr":"↛","nrArr":"⇏","nrarrw":"↝̸","nrightarrow":"↛","nRightarrow":"⇏","nrtri":"⋫","nrtrie":"⋭","nsc":"⊁","nsccue":"⋡","nsce":"⪰̸","Nscr":"\uD835\uDCA9","nscr":"\uD835\uDCC3","nshortmid":"∤","nshortparallel":"∦","nsim":"≁","nsime":"≄","nsimeq":"≄","nsmid":"∤","nspar":"∦","nsqsube":"⋢","nsqsupe":"⋣","nsub":"⊄","nsubE":"⫅̸","nsube":"⊈","nsubset":"⊂⃒","nsubseteq":"⊈","nsubseteqq":"⫅̸","nsucc":"⊁","nsucceq":"⪰̸","nsup":"⊅","nsupE":"⫆̸","nsupe":"⊉","nsupset":"⊃⃒","nsupseteq":"⊉","nsupseteqq":"⫆̸","ntgl":"≹","Ntilde":"\xd1","ntilde":"\xf1","ntlg":"≸","ntriangleleft":"⋪","ntrianglelefteq":"⋬","ntriangleright":"⋫","ntrianglerighteq":"⋭","Nu":"Ν","nu":"ν","num":"#","numero":"№","numsp":" ","nvap":"≍⃒","nvdash":"⊬","nvDash":"⊭","nVdash":"⊮","nVDash":"⊯","nvge":"≥⃒","nvgt":">⃒","nvHarr":"⤄","nvinfin":"⧞","nvlArr":"⤂","nvle":"≤⃒","nvlt":"<⃒","nvltrie":"⊴⃒","nvrArr":"⤃","nvrtrie":"⊵⃒","nvsim":"∼⃒","nwarhk":"⤣","nwarr":"↖","nwArr":"⇖","nwarrow":"↖","nwnear":"⤧","Oacute":"\xd3","oacute":"\xf3","oast":"⊛","Ocirc":"\xd4","ocirc":"\xf4","ocir":"⊚","Ocy":"О","ocy":"о","odash":"⊝","Odblac":"Ő","odblac":"ő","odiv":"⨸","odot":"⊙","odsold":"⦼","OElig":"Œ","oelig":"œ","ofcir":"⦿","Ofr":"\uD835\uDD12","ofr":"\uD835\uDD2C","ogon":"˛","Ograve":"\xd2","ograve":"\xf2","ogt":"⧁","ohbar":"⦵","ohm":"Ω","oint":"∮","olarr":"↺","olcir":"⦾","olcross":"⦻","oline":"‾","olt":"⧀","Omacr":"Ō","omacr":"ō","Omega":"Ω","omega":"ω","Omicron":"Ο","omicron":"ο","omid":"⦶","ominus":"⊖","Oopf":"\uD835\uDD46","oopf":"\uD835\uDD60","opar":"⦷","OpenCurlyDoubleQuote":"“","OpenCurlyQuote":"‘","operp":"⦹","oplus":"⊕","orarr":"↻","Or":"⩔","or":"∨","ord":"⩝","order":"ℴ","orderof":"ℴ","ordf":"\xaa","ordm":"\xba","origof":"⊶","oror":"⩖","orslope":"⩗","orv":"⩛","oS":"Ⓢ","Oscr":"\uD835\uDCAA","oscr":"ℴ","Oslash":"\xd8","oslash":"\xf8","osol":"⊘","Otilde":"\xd5","otilde":"\xf5","otimesas":"⨶","Otimes":"⨷","otimes":"⊗","Ouml":"\xd6","ouml":"\xf6","ovbar":"⌽","OverBar":"‾","OverBrace":"⏞","OverBracket":"⎴","OverParenthesis":"⏜","para":"\xb6","parallel":"∥","par":"∥","parsim":"⫳","parsl":"⫽","part":"∂","PartialD":"∂","Pcy":"П","pcy":"п","percnt":"%","period":".","permil":"‰","perp":"⊥","pertenk":"‱","Pfr":"\uD835\uDD13","pfr":"\uD835\uDD2D","Phi":"Φ","phi":"φ","phiv":"ϕ","phmmat":"ℳ","phone":"☎","Pi":"Π","pi":"π","pitchfork":"⋔","piv":"ϖ","planck":"ℏ","planckh":"ℎ","plankv":"ℏ","plusacir":"⨣","plusb":"⊞","pluscir":"⨢","plus":"+","plusdo":"∔","plusdu":"⨥","pluse":"⩲","PlusMinus":"\xb1","plusmn":"\xb1","plussim":"⨦","plustwo":"⨧","pm":"\xb1","Poincareplane":"ℌ","pointint":"⨕","popf":"\uD835\uDD61","Popf":"ℙ","pound":"\xa3","prap":"⪷","Pr":"⪻","pr":"≺","prcue":"≼","precapprox":"⪷","prec":"≺","preccurlyeq":"≼","Precedes":"≺","PrecedesEqual":"⪯","PrecedesSlantEqual":"≼","PrecedesTilde":"≾","preceq":"⪯","precnapprox":"⪹","precneqq":"⪵","precnsim":"⋨","pre":"⪯","prE":"⪳","precsim":"≾","prime":"′","Prime":"″","primes":"ℙ","prnap":"⪹","prnE":"⪵","prnsim":"⋨","prod":"∏","Product":"∏","profalar":"⌮","profline":"⌒","profsurf":"⌓","prop":"∝","Proportional":"∝","Proportion":"∷","propto":"∝","prsim":"≾","prurel":"⊰","Pscr":"\uD835\uDCAB","pscr":"\uD835\uDCC5","Psi":"Ψ","psi":"ψ","puncsp":" ","Qfr":"\uD835\uDD14","qfr":"\uD835\uDD2E","qint":"⨌","qopf":"\uD835\uDD62","Qopf":"ℚ","qprime":"⁗","Qscr":"\uD835\uDCAC","qscr":"\uD835\uDCC6","quaternions":"ℍ","quatint":"⨖","quest":"?","questeq":"≟","quot":"\\"","QUOT":"\\"","rAarr":"⇛","race":"∽̱","Racute":"Ŕ","racute":"ŕ","radic":"√","raemptyv":"⦳","rang":"⟩","Rang":"⟫","rangd":"⦒","range":"⦥","rangle":"⟩","raquo":"\xbb","rarrap":"⥵","rarrb":"⇥","rarrbfs":"⤠","rarrc":"⤳","rarr":"→","Rarr":"↠","rArr":"⇒","rarrfs":"⤞","rarrhk":"↪","rarrlp":"↬","rarrpl":"⥅","rarrsim":"⥴","Rarrtl":"⤖","rarrtl":"↣","rarrw":"↝","ratail":"⤚","rAtail":"⤜","ratio":"∶","rationals":"ℚ","rbarr":"⤍","rBarr":"⤏","RBarr":"⤐","rbbrk":"❳","rbrace":"}","rbrack":"]","rbrke":"⦌","rbrksld":"⦎","rbrkslu":"⦐","Rcaron":"Ř","rcaron":"ř","Rcedil":"Ŗ","rcedil":"ŗ","rceil":"⌉","rcub":"}","Rcy":"Р","rcy":"р","rdca":"⤷","rdldhar":"⥩","rdquo":"”","rdquor":"”","rdsh":"↳","real":"ℜ","realine":"ℛ","realpart":"ℜ","reals":"ℝ","Re":"ℜ","rect":"▭","reg":"\xae","REG":"\xae","ReverseElement":"∋","ReverseEquilibrium":"⇋","ReverseUpEquilibrium":"⥯","rfisht":"⥽","rfloor":"⌋","rfr":"\uD835\uDD2F","Rfr":"ℜ","rHar":"⥤","rhard":"⇁","rharu":"⇀","rharul":"⥬","Rho":"Ρ","rho":"ρ","rhov":"ϱ","RightAngleBracket":"⟩","RightArrowBar":"⇥","rightarrow":"→","RightArrow":"→","Rightarrow":"⇒","RightArrowLeftArrow":"⇄","rightarrowtail":"↣","RightCeiling":"⌉","RightDoubleBracket":"⟧","RightDownTeeVector":"⥝","RightDownVectorBar":"⥕","RightDownVector":"⇂","RightFloor":"⌋","rightharpoondown":"⇁","rightharpoonup":"⇀","rightleftarrows":"⇄","rightleftharpoons":"⇌","rightrightarrows":"⇉","rightsquigarrow":"↝","RightTeeArrow":"↦","RightTee":"⊢","RightTeeVector":"⥛","rightthreetimes":"⋌","RightTriangleBar":"⧐","RightTriangle":"⊳","RightTriangleEqual":"⊵","RightUpDownVector":"⥏","RightUpTeeVector":"⥜","RightUpVectorBar":"⥔","RightUpVector":"↾","RightVectorBar":"⥓","RightVector":"⇀","ring":"˚","risingdotseq":"≓","rlarr":"⇄","rlhar":"⇌","rlm":"‏","rmoustache":"⎱","rmoust":"⎱","rnmid":"⫮","roang":"⟭","roarr":"⇾","robrk":"⟧","ropar":"⦆","ropf":"\uD835\uDD63","Ropf":"ℝ","roplus":"⨮","rotimes":"⨵","RoundImplies":"⥰","rpar":")","rpargt":"⦔","rppolint":"⨒","rrarr":"⇉","Rrightarrow":"⇛","rsaquo":"›","rscr":"\uD835\uDCC7","Rscr":"ℛ","rsh":"↱","Rsh":"↱","rsqb":"]","rsquo":"’","rsquor":"’","rthree":"⋌","rtimes":"⋊","rtri":"▹","rtrie":"⊵","rtrif":"▸","rtriltri":"⧎","RuleDelayed":"⧴","ruluhar":"⥨","rx":"℞","Sacute":"Ś","sacute":"ś","sbquo":"‚","scap":"⪸","Scaron":"Š","scaron":"š","Sc":"⪼","sc":"≻","sccue":"≽","sce":"⪰","scE":"⪴","Scedil":"Ş","scedil":"ş","Scirc":"Ŝ","scirc":"ŝ","scnap":"⪺","scnE":"⪶","scnsim":"⋩","scpolint":"⨓","scsim":"≿","Scy":"С","scy":"с","sdotb":"⊡","sdot":"⋅","sdote":"⩦","searhk":"⤥","searr":"↘","seArr":"⇘","searrow":"↘","sect":"\xa7","semi":";","seswar":"⤩","setminus":"∖","setmn":"∖","sext":"✶","Sfr":"\uD835\uDD16","sfr":"\uD835\uDD30","sfrown":"⌢","sharp":"♯","SHCHcy":"Щ","shchcy":"щ","SHcy":"Ш","shcy":"ш","ShortDownArrow":"↓","ShortLeftArrow":"←","shortmid":"∣","shortparallel":"∥","ShortRightArrow":"→","ShortUpArrow":"↑","shy":"\xad","Sigma":"Σ","sigma":"σ","sigmaf":"ς","sigmav":"ς","sim":"∼","simdot":"⩪","sime":"≃","simeq":"≃","simg":"⪞","simgE":"⪠","siml":"⪝","simlE":"⪟","simne":"≆","simplus":"⨤","simrarr":"⥲","slarr":"←","SmallCircle":"∘","smallsetminus":"∖","smashp":"⨳","smeparsl":"⧤","smid":"∣","smile":"⌣","smt":"⪪","smte":"⪬","smtes":"⪬︀","SOFTcy":"Ь","softcy":"ь","solbar":"⌿","solb":"⧄","sol":"/","Sopf":"\uD835\uDD4A","sopf":"\uD835\uDD64","spades":"♠","spadesuit":"♠","spar":"∥","sqcap":"⊓","sqcaps":"⊓︀","sqcup":"⊔","sqcups":"⊔︀","Sqrt":"√","sqsub":"⊏","sqsube":"⊑","sqsubset":"⊏","sqsubseteq":"⊑","sqsup":"⊐","sqsupe":"⊒","sqsupset":"⊐","sqsupseteq":"⊒","square":"□","Square":"□","SquareIntersection":"⊓","SquareSubset":"⊏","SquareSubsetEqual":"⊑","SquareSuperset":"⊐","SquareSupersetEqual":"⊒","SquareUnion":"⊔","squarf":"▪","squ":"□","squf":"▪","srarr":"→","Sscr":"\uD835\uDCAE","sscr":"\uD835\uDCC8","ssetmn":"∖","ssmile":"⌣","sstarf":"⋆","Star":"⋆","star":"☆","starf":"★","straightepsilon":"ϵ","straightphi":"ϕ","strns":"\xaf","sub":"⊂","Sub":"⋐","subdot":"⪽","subE":"⫅","sube":"⊆","subedot":"⫃","submult":"⫁","subnE":"⫋","subne":"⊊","subplus":"⪿","subrarr":"⥹","subset":"⊂","Subset":"⋐","subseteq":"⊆","subseteqq":"⫅","SubsetEqual":"⊆","subsetneq":"⊊","subsetneqq":"⫋","subsim":"⫇","subsub":"⫕","subsup":"⫓","succapprox":"⪸","succ":"≻","succcurlyeq":"≽","Succeeds":"≻","SucceedsEqual":"⪰","SucceedsSlantEqual":"≽","SucceedsTilde":"≿","succeq":"⪰","succnapprox":"⪺","succneqq":"⪶","succnsim":"⋩","succsim":"≿","SuchThat":"∋","sum":"∑","Sum":"∑","sung":"♪","sup1":"\xb9","sup2":"\xb2","sup3":"\xb3","sup":"⊃","Sup":"⋑","supdot":"⪾","supdsub":"⫘","supE":"⫆","supe":"⊇","supedot":"⫄","Superset":"⊃","SupersetEqual":"⊇","suphsol":"⟉","suphsub":"⫗","suplarr":"⥻","supmult":"⫂","supnE":"⫌","supne":"⊋","supplus":"⫀","supset":"⊃","Supset":"⋑","supseteq":"⊇","supseteqq":"⫆","supsetneq":"⊋","supsetneqq":"⫌","supsim":"⫈","supsub":"⫔","supsup":"⫖","swarhk":"⤦","swarr":"↙","swArr":"⇙","swarrow":"↙","swnwar":"⤪","szlig":"\xdf","Tab":"\\t","target":"⌖","Tau":"Τ","tau":"τ","tbrk":"⎴","Tcaron":"Ť","tcaron":"ť","Tcedil":"Ţ","tcedil":"ţ","Tcy":"Т","tcy":"т","tdot":"⃛","telrec":"⌕","Tfr":"\uD835\uDD17","tfr":"\uD835\uDD31","there4":"∴","therefore":"∴","Therefore":"∴","Theta":"Θ","theta":"θ","thetasym":"ϑ","thetav":"ϑ","thickapprox":"≈","thicksim":"∼","ThickSpace":"  ","ThinSpace":" ","thinsp":" ","thkap":"≈","thksim":"∼","THORN":"\xde","thorn":"\xfe","tilde":"˜","Tilde":"∼","TildeEqual":"≃","TildeFullEqual":"≅","TildeTilde":"≈","timesbar":"⨱","timesb":"⊠","times":"\xd7","timesd":"⨰","tint":"∭","toea":"⤨","topbot":"⌶","topcir":"⫱","top":"⊤","Topf":"\uD835\uDD4B","topf":"\uD835\uDD65","topfork":"⫚","tosa":"⤩","tprime":"‴","trade":"™","TRADE":"™","triangle":"▵","triangledown":"▿","triangleleft":"◃","trianglelefteq":"⊴","triangleq":"≜","triangleright":"▹","trianglerighteq":"⊵","tridot":"◬","trie":"≜","triminus":"⨺","TripleDot":"⃛","triplus":"⨹","trisb":"⧍","tritime":"⨻","trpezium":"⏢","Tscr":"\uD835\uDCAF","tscr":"\uD835\uDCC9","TScy":"Ц","tscy":"ц","TSHcy":"Ћ","tshcy":"ћ","Tstrok":"Ŧ","tstrok":"ŧ","twixt":"≬","twoheadleftarrow":"↞","twoheadrightarrow":"↠","Uacute":"\xda","uacute":"\xfa","uarr":"↑","Uarr":"↟","uArr":"⇑","Uarrocir":"⥉","Ubrcy":"Ў","ubrcy":"ў","Ubreve":"Ŭ","ubreve":"ŭ","Ucirc":"\xdb","ucirc":"\xfb","Ucy":"У","ucy":"у","udarr":"⇅","Udblac":"Ű","udblac":"ű","udhar":"⥮","ufisht":"⥾","Ufr":"\uD835\uDD18","ufr":"\uD835\uDD32","Ugrave":"\xd9","ugrave":"\xf9","uHar":"⥣","uharl":"↿","uharr":"↾","uhblk":"▀","ulcorn":"⌜","ulcorner":"⌜","ulcrop":"⌏","ultri":"◸","Umacr":"Ū","umacr":"ū","uml":"\xa8","UnderBar":"_","UnderBrace":"⏟","UnderBracket":"⎵","UnderParenthesis":"⏝","Union":"⋃","UnionPlus":"⊎","Uogon":"Ų","uogon":"ų","Uopf":"\uD835\uDD4C","uopf":"\uD835\uDD66","UpArrowBar":"⤒","uparrow":"↑","UpArrow":"↑","Uparrow":"⇑","UpArrowDownArrow":"⇅","updownarrow":"↕","UpDownArrow":"↕","Updownarrow":"⇕","UpEquilibrium":"⥮","upharpoonleft":"↿","upharpoonright":"↾","uplus":"⊎","UpperLeftArrow":"↖","UpperRightArrow":"↗","upsi":"υ","Upsi":"ϒ","upsih":"ϒ","Upsilon":"Υ","upsilon":"υ","UpTeeArrow":"↥","UpTee":"⊥","upuparrows":"⇈","urcorn":"⌝","urcorner":"⌝","urcrop":"⌎","Uring":"Ů","uring":"ů","urtri":"◹","Uscr":"\uD835\uDCB0","uscr":"\uD835\uDCCA","utdot":"⋰","Utilde":"Ũ","utilde":"ũ","utri":"▵","utrif":"▴","uuarr":"⇈","Uuml":"\xdc","uuml":"\xfc","uwangle":"⦧","vangrt":"⦜","varepsilon":"ϵ","varkappa":"ϰ","varnothing":"∅","varphi":"ϕ","varpi":"ϖ","varpropto":"∝","varr":"↕","vArr":"⇕","varrho":"ϱ","varsigma":"ς","varsubsetneq":"⊊︀","varsubsetneqq":"⫋︀","varsupsetneq":"⊋︀","varsupsetneqq":"⫌︀","vartheta":"ϑ","vartriangleleft":"⊲","vartriangleright":"⊳","vBar":"⫨","Vbar":"⫫","vBarv":"⫩","Vcy":"В","vcy":"в","vdash":"⊢","vDash":"⊨","Vdash":"⊩","VDash":"⊫","Vdashl":"⫦","veebar":"⊻","vee":"∨","Vee":"⋁","veeeq":"≚","vellip":"⋮","verbar":"|","Verbar":"‖","vert":"|","Vert":"‖","VerticalBar":"∣","VerticalLine":"|","VerticalSeparator":"❘","VerticalTilde":"≀","VeryThinSpace":" ","Vfr":"\uD835\uDD19","vfr":"\uD835\uDD33","vltri":"⊲","vnsub":"⊂⃒","vnsup":"⊃⃒","Vopf":"\uD835\uDD4D","vopf":"\uD835\uDD67","vprop":"∝","vrtri":"⊳","Vscr":"\uD835\uDCB1","vscr":"\uD835\uDCCB","vsubnE":"⫋︀","vsubne":"⊊︀","vsupnE":"⫌︀","vsupne":"⊋︀","Vvdash":"⊪","vzigzag":"⦚","Wcirc":"Ŵ","wcirc":"ŵ","wedbar":"⩟","wedge":"∧","Wedge":"⋀","wedgeq":"≙","weierp":"℘","Wfr":"\uD835\uDD1A","wfr":"\uD835\uDD34","Wopf":"\uD835\uDD4E","wopf":"\uD835\uDD68","wp":"℘","wr":"≀","wreath":"≀","Wscr":"\uD835\uDCB2","wscr":"\uD835\uDCCC","xcap":"⋂","xcirc":"◯","xcup":"⋃","xdtri":"▽","Xfr":"\uD835\uDD1B","xfr":"\uD835\uDD35","xharr":"⟷","xhArr":"⟺","Xi":"Ξ","xi":"ξ","xlarr":"⟵","xlArr":"⟸","xmap":"⟼","xnis":"⋻","xodot":"⨀","Xopf":"\uD835\uDD4F","xopf":"\uD835\uDD69","xoplus":"⨁","xotime":"⨂","xrarr":"⟶","xrArr":"⟹","Xscr":"\uD835\uDCB3","xscr":"\uD835\uDCCD","xsqcup":"⨆","xuplus":"⨄","xutri":"△","xvee":"⋁","xwedge":"⋀","Yacute":"\xdd","yacute":"\xfd","YAcy":"Я","yacy":"я","Ycirc":"Ŷ","ycirc":"ŷ","Ycy":"Ы","ycy":"ы","yen":"\xa5","Yfr":"\uD835\uDD1C","yfr":"\uD835\uDD36","YIcy":"Ї","yicy":"ї","Yopf":"\uD835\uDD50","yopf":"\uD835\uDD6A","Yscr":"\uD835\uDCB4","yscr":"\uD835\uDCCE","YUcy":"Ю","yucy":"ю","yuml":"\xff","Yuml":"Ÿ","Zacute":"Ź","zacute":"ź","Zcaron":"Ž","zcaron":"ž","Zcy":"З","zcy":"з","Zdot":"Ż","zdot":"ż","zeetrf":"ℨ","ZeroWidthSpace":"​","Zeta":"Ζ","zeta":"ζ","zfr":"\uD835\uDD37","Zfr":"ℨ","ZHcy":"Ж","zhcy":"ж","zigrarr":"⇝","zopf":"\uD835\uDD6B","Zopf":"ℤ","Zscr":"\uD835\uDCB5","zscr":"\uD835\uDCCF","zwj":"‍","zwnj":"‌"}');

});



parcelRequire.register("6Wdbg", function(module, exports) {

$parcel$export(module.exports, "parseLinkLabel", () => $50d262453399e534$export$2a2c8612930e58d0, (v) => $50d262453399e534$export$2a2c8612930e58d0 = v);
$parcel$export(module.exports, "parseLinkDestination", () => $50d262453399e534$export$22bd24080f95f2b3, (v) => $50d262453399e534$export$22bd24080f95f2b3 = v);
$parcel$export(module.exports, "parseLinkTitle", () => $50d262453399e534$export$89650c5477a69db9, (v) => $50d262453399e534$export$89650c5477a69db9 = v);
// Just a shortcut for bulk export
var $50d262453399e534$export$2a2c8612930e58d0;
var $50d262453399e534$export$22bd24080f95f2b3;
var $50d262453399e534$export$89650c5477a69db9;
"use strict";

$50d262453399e534$export$2a2c8612930e58d0 = (parcelRequire("35R4n"));

$50d262453399e534$export$22bd24080f95f2b3 = (parcelRequire("5kJoc"));

$50d262453399e534$export$89650c5477a69db9 = (parcelRequire("oGnml"));

});
parcelRequire.register("35R4n", function(module, exports) {
// Parse link label
//
// this function assumes that first character ("[") already matches;
// returns the end of the label
//
"use strict";
module.exports = function parseLinkLabel(state, start, disableNested) {
    var level, found, marker, prevPos, labelEnd = -1, max = state.posMax, oldPos = state.pos;
    state.pos = start + 1;
    level = 1;
    while(state.pos < max){
        marker = state.src.charCodeAt(state.pos);
        if (marker === 0x5D /* ] */ ) {
            level--;
            if (level === 0) {
                found = true;
                break;
            }
        }
        prevPos = state.pos;
        state.md.inline.skipToken(state);
        if (marker === 0x5B /* [ */ ) {
            if (prevPos === state.pos - 1) // increase level if we find text `[`, which is not a part of any token
            level++;
            else if (disableNested) {
                state.pos = oldPos;
                return -1;
            }
        }
    }
    if (found) labelEnd = state.pos;
    // restore old state
    state.pos = oldPos;
    return labelEnd;
};

});

parcelRequire.register("5kJoc", function(module, exports) {
// Parse link destination
//
"use strict";

var $iCsQ9 = parcelRequire("iCsQ9");
var $3e220765d7ecf456$require$unescapeAll = $iCsQ9.unescapeAll;
module.exports = function parseLinkDestination(str, pos, max) {
    var code, level, lines = 0, start = pos, result = {
        ok: false,
        pos: 0,
        lines: 0,
        str: ""
    };
    if (str.charCodeAt(pos) === 0x3C /* < */ ) {
        pos++;
        while(pos < max){
            code = str.charCodeAt(pos);
            if (code === 0x0A /* \n */ ) return result;
            if (code === 0x3C /* < */ ) return result;
            if (code === 0x3E /* > */ ) {
                result.pos = pos + 1;
                result.str = $3e220765d7ecf456$require$unescapeAll(str.slice(start + 1, pos));
                result.ok = true;
                return result;
            }
            if (code === 0x5C /* \ */  && pos + 1 < max) {
                pos += 2;
                continue;
            }
            pos++;
        }
        // no closing '>'
        return result;
    }
    // this should be ... } else { ... branch
    level = 0;
    while(pos < max){
        code = str.charCodeAt(pos);
        if (code === 0x20) break;
        // ascii control characters
        if (code < 0x20 || code === 0x7F) break;
        if (code === 0x5C /* \ */  && pos + 1 < max) {
            if (str.charCodeAt(pos + 1) === 0x20) break;
            pos += 2;
            continue;
        }
        if (code === 0x28 /* ( */ ) {
            level++;
            if (level > 32) return result;
        }
        if (code === 0x29 /* ) */ ) {
            if (level === 0) break;
            level--;
        }
        pos++;
    }
    if (start === pos) return result;
    if (level !== 0) return result;
    result.str = $3e220765d7ecf456$require$unescapeAll(str.slice(start, pos));
    result.lines = lines;
    result.pos = pos;
    result.ok = true;
    return result;
};

});

parcelRequire.register("oGnml", function(module, exports) {
// Parse link title
//
"use strict";

var $iCsQ9 = parcelRequire("iCsQ9");
var $04a31cf3114a905e$require$unescapeAll = $iCsQ9.unescapeAll;
module.exports = function parseLinkTitle(str, pos, max) {
    var code, marker, lines = 0, start = pos, result = {
        ok: false,
        pos: 0,
        lines: 0,
        str: ""
    };
    if (pos >= max) return result;
    marker = str.charCodeAt(pos);
    if (marker !== 0x22 /* " */  && marker !== 0x27 /* ' */  && marker !== 0x28 /* ( */ ) return result;
    pos++;
    // if opening marker is "(", switch it to closing marker ")"
    if (marker === 0x28) marker = 0x29;
    while(pos < max){
        code = str.charCodeAt(pos);
        if (code === marker) {
            result.pos = pos + 1;
            result.lines = lines;
            result.str = $04a31cf3114a905e$require$unescapeAll(str.slice(start + 1, pos));
            result.ok = true;
            return result;
        } else if (code === 0x28 /* ( */  && marker === 0x29 /* ) */ ) return result;
        else if (code === 0x0A) lines++;
        else if (code === 0x5C /* \ */  && pos + 1 < max) {
            pos++;
            if (str.charCodeAt(pos) === 0x0A) lines++;
        }
        pos++;
    }
    return result;
};

});


parcelRequire.register("kgG75", function(module, exports) {
/**
 * class Renderer
 *
 * Generates HTML from parsed token stream. Each instance has independent
 * copy of rules. Those can be rewritten with ease. Also, you can add new
 * rules if you create plugin and adds new token types.
 **/ "use strict";

var $iCsQ9 = parcelRequire("iCsQ9");
var $ec15f81589e7c446$require$assign = $iCsQ9.assign;

var $iCsQ9 = parcelRequire("iCsQ9");
var $ec15f81589e7c446$require$unescapeAll = $iCsQ9.unescapeAll;

var $iCsQ9 = parcelRequire("iCsQ9");
var $ec15f81589e7c446$require$escapeHtml = $iCsQ9.escapeHtml;
////////////////////////////////////////////////////////////////////////////////
var $ec15f81589e7c446$var$default_rules = {};
$ec15f81589e7c446$var$default_rules.code_inline = function(tokens, idx, options, env, slf) {
    var token = tokens[idx];
    return "<code" + slf.renderAttrs(token) + ">" + $ec15f81589e7c446$require$escapeHtml(tokens[idx].content) + "</code>";
};
$ec15f81589e7c446$var$default_rules.code_block = function(tokens, idx, options, env, slf) {
    var token = tokens[idx];
    return "<pre" + slf.renderAttrs(token) + "><code>" + $ec15f81589e7c446$require$escapeHtml(tokens[idx].content) + "</code></pre>\n";
};
$ec15f81589e7c446$var$default_rules.fence = function(tokens, idx, options, env, slf) {
    var token = tokens[idx], info = token.info ? $ec15f81589e7c446$require$unescapeAll(token.info).trim() : "", langName = "", langAttrs = "", highlighted, i, arr, tmpAttrs, tmpToken;
    if (info) {
        arr = info.split(/(\s+)/g);
        langName = arr[0];
        langAttrs = arr.slice(2).join("");
    }
    if (options.highlight) highlighted = options.highlight(token.content, langName, langAttrs) || $ec15f81589e7c446$require$escapeHtml(token.content);
    else highlighted = $ec15f81589e7c446$require$escapeHtml(token.content);
    if (highlighted.indexOf("<pre") === 0) return highlighted + "\n";
    // If language exists, inject class gently, without modifying original token.
    // May be, one day we will add .deepClone() for token and simplify this part, but
    // now we prefer to keep things local.
    if (info) {
        i = token.attrIndex("class");
        tmpAttrs = token.attrs ? token.attrs.slice() : [];
        if (i < 0) tmpAttrs.push([
            "class",
            options.langPrefix + langName
        ]);
        else {
            tmpAttrs[i] = tmpAttrs[i].slice();
            tmpAttrs[i][1] += " " + options.langPrefix + langName;
        }
        // Fake token just to render attributes
        tmpToken = {
            attrs: tmpAttrs
        };
        return "<pre><code" + slf.renderAttrs(tmpToken) + ">" + highlighted + "</code></pre>\n";
    }
    return "<pre><code" + slf.renderAttrs(token) + ">" + highlighted + "</code></pre>\n";
};
$ec15f81589e7c446$var$default_rules.image = function(tokens, idx, options, env, slf) {
    var token = tokens[idx];
    // "alt" attr MUST be set, even if empty. Because it's mandatory and
    // should be placed on proper position for tests.
    //
    // Replace content with actual value
    token.attrs[token.attrIndex("alt")][1] = slf.renderInlineAsText(token.children, options, env);
    return slf.renderToken(tokens, idx, options);
};
$ec15f81589e7c446$var$default_rules.hardbreak = function(tokens, idx, options /*, env */ ) {
    return options.xhtmlOut ? "<br />\n" : "<br>\n";
};
$ec15f81589e7c446$var$default_rules.softbreak = function(tokens, idx, options /*, env */ ) {
    return options.breaks ? options.xhtmlOut ? "<br />\n" : "<br>\n" : "\n";
};
$ec15f81589e7c446$var$default_rules.text = function(tokens, idx /*, options, env */ ) {
    return $ec15f81589e7c446$require$escapeHtml(tokens[idx].content);
};
$ec15f81589e7c446$var$default_rules.html_block = function(tokens, idx /*, options, env */ ) {
    return tokens[idx].content;
};
$ec15f81589e7c446$var$default_rules.html_inline = function(tokens, idx /*, options, env */ ) {
    return tokens[idx].content;
};
/**
 * new Renderer()
 *
 * Creates new [[Renderer]] instance and fill [[Renderer#rules]] with defaults.
 **/ function $ec15f81589e7c446$var$Renderer() {
    /**
   * Renderer#rules -> Object
   *
   * Contains render rules for tokens. Can be updated and extended.
   *
   * ##### Example
   *
   * ```javascript
   * var md = require('markdown-it')();
   *
   * md.renderer.rules.strong_open  = function () { return '<b>'; };
   * md.renderer.rules.strong_close = function () { return '</b>'; };
   *
   * var result = md.renderInline(...);
   * ```
   *
   * Each rule is called as independent static function with fixed signature:
   *
   * ```javascript
   * function my_token_render(tokens, idx, options, env, renderer) {
   *   // ...
   *   return renderedHTML;
   * }
   * ```
   *
   * See [source code](https://github.com/markdown-it/markdown-it/blob/master/lib/renderer.js)
   * for more details and examples.
   **/ this.rules = $ec15f81589e7c446$require$assign({}, $ec15f81589e7c446$var$default_rules);
}
/**
 * Renderer.renderAttrs(token) -> String
 *
 * Render token attributes to string.
 **/ $ec15f81589e7c446$var$Renderer.prototype.renderAttrs = function renderAttrs(token) {
    var i, l, result;
    if (!token.attrs) return "";
    result = "";
    for(i = 0, l = token.attrs.length; i < l; i++)result += " " + $ec15f81589e7c446$require$escapeHtml(token.attrs[i][0]) + '="' + $ec15f81589e7c446$require$escapeHtml(token.attrs[i][1]) + '"';
    return result;
};
/**
 * Renderer.renderToken(tokens, idx, options) -> String
 * - tokens (Array): list of tokens
 * - idx (Numbed): token index to render
 * - options (Object): params of parser instance
 *
 * Default token renderer. Can be overriden by custom function
 * in [[Renderer#rules]].
 **/ $ec15f81589e7c446$var$Renderer.prototype.renderToken = function renderToken(tokens, idx, options) {
    var nextToken, result = "", needLf = false, token = tokens[idx];
    // Tight list paragraphs
    if (token.hidden) return "";
    // Insert a newline between hidden paragraph and subsequent opening
    // block-level tag.
    //
    // For example, here we should insert a newline before blockquote:
    //  - a
    //    >
    //
    if (token.block && token.nesting !== -1 && idx && tokens[idx - 1].hidden) result += "\n";
    // Add token name, e.g. `<img`
    result += (token.nesting === -1 ? "</" : "<") + token.tag;
    // Encode attributes, e.g. `<img src="foo"`
    result += this.renderAttrs(token);
    // Add a slash for self-closing tags, e.g. `<img src="foo" /`
    if (token.nesting === 0 && options.xhtmlOut) result += " /";
    // Check if we need to add a newline after this tag
    if (token.block) {
        needLf = true;
        if (token.nesting === 1) {
            if (idx + 1 < tokens.length) {
                nextToken = tokens[idx + 1];
                if (nextToken.type === "inline" || nextToken.hidden) // Block-level tag containing an inline tag.
                //
                needLf = false;
                else if (nextToken.nesting === -1 && nextToken.tag === token.tag) // Opening tag + closing tag of the same type. E.g. `<li></li>`.
                //
                needLf = false;
            }
        }
    }
    result += needLf ? ">\n" : ">";
    return result;
};
/**
 * Renderer.renderInline(tokens, options, env) -> String
 * - tokens (Array): list on block tokens to render
 * - options (Object): params of parser instance
 * - env (Object): additional data from parsed input (references, for example)
 *
 * The same as [[Renderer.render]], but for single token of `inline` type.
 **/ $ec15f81589e7c446$var$Renderer.prototype.renderInline = function(tokens, options, env) {
    var type, result = "", rules = this.rules;
    for(var i = 0, len = tokens.length; i < len; i++){
        type = tokens[i].type;
        if (typeof rules[type] !== "undefined") result += rules[type](tokens, i, options, env, this);
        else result += this.renderToken(tokens, i, options);
    }
    return result;
};
/** internal
 * Renderer.renderInlineAsText(tokens, options, env) -> String
 * - tokens (Array): list on block tokens to render
 * - options (Object): params of parser instance
 * - env (Object): additional data from parsed input (references, for example)
 *
 * Special kludge for image `alt` attributes to conform CommonMark spec.
 * Don't try to use it! Spec requires to show `alt` content with stripped markup,
 * instead of simple escaping.
 **/ $ec15f81589e7c446$var$Renderer.prototype.renderInlineAsText = function(tokens, options, env) {
    var result = "";
    for(var i = 0, len = tokens.length; i < len; i++){
        if (tokens[i].type === "text") result += tokens[i].content;
        else if (tokens[i].type === "image") result += this.renderInlineAsText(tokens[i].children, options, env);
        else if (tokens[i].type === "softbreak") result += "\n";
    }
    return result;
};
/**
 * Renderer.render(tokens, options, env) -> String
 * - tokens (Array): list on block tokens to render
 * - options (Object): params of parser instance
 * - env (Object): additional data from parsed input (references, for example)
 *
 * Takes token stream and generates HTML. Probably, you will never need to call
 * this method directly.
 **/ $ec15f81589e7c446$var$Renderer.prototype.render = function(tokens, options, env) {
    var i, len, type, result = "", rules = this.rules;
    for(i = 0, len = tokens.length; i < len; i++){
        type = tokens[i].type;
        if (type === "inline") result += this.renderInline(tokens[i].children, options, env);
        else if (typeof rules[type] !== "undefined") result += rules[tokens[i].type](tokens, i, options, env, this);
        else result += this.renderToken(tokens, i, options, env);
    }
    return result;
};
module.exports = $ec15f81589e7c446$var$Renderer;

});

parcelRequire.register("6atM6", function(module, exports) {
/** internal
 * class Core
 *
 * Top-level rules executor. Glues block/inline parsers and does intermediate
 * transformations.
 **/ "use strict";

var $a3Mkq = parcelRequire("a3Mkq");






var $47dac5e7cf96ee35$var$_rules = [
    [
        "normalize",
        (parcelRequire("6bP5l"))
    ],
    [
        "block",
        (parcelRequire("5f5nj"))
    ],
    [
        "inline",
        (parcelRequire("ddB1L"))
    ],
    [
        "linkify",
        (parcelRequire("hfDPQ"))
    ],
    [
        "replacements",
        (parcelRequire("j34M2"))
    ],
    [
        "smartquotes",
        (parcelRequire("96Qru"))
    ]
];
/**
 * new Core()
 **/ function $47dac5e7cf96ee35$var$Core() {
    /**
   * Core#ruler -> Ruler
   *
   * [[Ruler]] instance. Keep configuration of core rules.
   **/ this.ruler = new $a3Mkq();
    for(var i = 0; i < $47dac5e7cf96ee35$var$_rules.length; i++)this.ruler.push($47dac5e7cf96ee35$var$_rules[i][0], $47dac5e7cf96ee35$var$_rules[i][1]);
}
/**
 * Core.process(state)
 *
 * Executes core chain rules.
 **/ $47dac5e7cf96ee35$var$Core.prototype.process = function(state) {
    var i, l, rules;
    rules = this.ruler.getRules("");
    for(i = 0, l = rules.length; i < l; i++)rules[i](state);
};

$47dac5e7cf96ee35$var$Core.prototype.State = (parcelRequire("8dagG"));
module.exports = $47dac5e7cf96ee35$var$Core;

});
parcelRequire.register("a3Mkq", function(module, exports) {
/**
 * class Ruler
 *
 * Helper class, used by [[MarkdownIt#core]], [[MarkdownIt#block]] and
 * [[MarkdownIt#inline]] to manage sequences of functions (rules):
 *
 * - keep rules in defined order
 * - assign the name to each rule
 * - enable/disable rules
 * - add/replace rules
 * - allow assign rules to additional named chains (in the same)
 * - cacheing lists of active rules
 *
 * You will not need use this class directly until write plugins. For simple
 * rules control use [[MarkdownIt.disable]], [[MarkdownIt.enable]] and
 * [[MarkdownIt.use]].
 **/ "use strict";
/**
 * new Ruler()
 **/ function $752fac3307660e97$var$Ruler() {
    // List of added rules. Each element is:
    //
    // {
    //   name: XXX,
    //   enabled: Boolean,
    //   fn: Function(),
    //   alt: [ name2, name3 ]
    // }
    //
    this.__rules__ = [];
    // Cached rule chains.
    //
    // First level - chain name, '' for default.
    // Second level - diginal anchor for fast filtering by charcodes.
    //
    this.__cache__ = null;
}
////////////////////////////////////////////////////////////////////////////////
// Helper methods, should not be used directly
// Find rule index by name
//
$752fac3307660e97$var$Ruler.prototype.__find__ = function(name) {
    for(var i = 0; i < this.__rules__.length; i++){
        if (this.__rules__[i].name === name) return i;
    }
    return -1;
};
// Build rules lookup cache
//
$752fac3307660e97$var$Ruler.prototype.__compile__ = function() {
    var self = this;
    var chains = [
        ""
    ];
    // collect unique names
    self.__rules__.forEach(function(rule) {
        if (!rule.enabled) return;
        rule.alt.forEach(function(altName) {
            if (chains.indexOf(altName) < 0) chains.push(altName);
        });
    });
    self.__cache__ = {};
    chains.forEach(function(chain) {
        self.__cache__[chain] = [];
        self.__rules__.forEach(function(rule) {
            if (!rule.enabled) return;
            if (chain && rule.alt.indexOf(chain) < 0) return;
            self.__cache__[chain].push(rule.fn);
        });
    });
};
/**
 * Ruler.at(name, fn [, options])
 * - name (String): rule name to replace.
 * - fn (Function): new rule function.
 * - options (Object): new rule options (not mandatory).
 *
 * Replace rule by name with new function & options. Throws error if name not
 * found.
 *
 * ##### Options:
 *
 * - __alt__ - array with names of "alternate" chains.
 *
 * ##### Example
 *
 * Replace existing typographer replacement rule with new one:
 *
 * ```javascript
 * var md = require('markdown-it')();
 *
 * md.core.ruler.at('replacements', function replace(state) {
 *   //...
 * });
 * ```
 **/ $752fac3307660e97$var$Ruler.prototype.at = function(name, fn, options) {
    var index = this.__find__(name);
    var opt = options || {};
    if (index === -1) throw new Error("Parser rule not found: " + name);
    this.__rules__[index].fn = fn;
    this.__rules__[index].alt = opt.alt || [];
    this.__cache__ = null;
};
/**
 * Ruler.before(beforeName, ruleName, fn [, options])
 * - beforeName (String): new rule will be added before this one.
 * - ruleName (String): name of added rule.
 * - fn (Function): rule function.
 * - options (Object): rule options (not mandatory).
 *
 * Add new rule to chain before one with given name. See also
 * [[Ruler.after]], [[Ruler.push]].
 *
 * ##### Options:
 *
 * - __alt__ - array with names of "alternate" chains.
 *
 * ##### Example
 *
 * ```javascript
 * var md = require('markdown-it')();
 *
 * md.block.ruler.before('paragraph', 'my_rule', function replace(state) {
 *   //...
 * });
 * ```
 **/ $752fac3307660e97$var$Ruler.prototype.before = function(beforeName, ruleName, fn, options) {
    var index = this.__find__(beforeName);
    var opt = options || {};
    if (index === -1) throw new Error("Parser rule not found: " + beforeName);
    this.__rules__.splice(index, 0, {
        name: ruleName,
        enabled: true,
        fn: fn,
        alt: opt.alt || []
    });
    this.__cache__ = null;
};
/**
 * Ruler.after(afterName, ruleName, fn [, options])
 * - afterName (String): new rule will be added after this one.
 * - ruleName (String): name of added rule.
 * - fn (Function): rule function.
 * - options (Object): rule options (not mandatory).
 *
 * Add new rule to chain after one with given name. See also
 * [[Ruler.before]], [[Ruler.push]].
 *
 * ##### Options:
 *
 * - __alt__ - array with names of "alternate" chains.
 *
 * ##### Example
 *
 * ```javascript
 * var md = require('markdown-it')();
 *
 * md.inline.ruler.after('text', 'my_rule', function replace(state) {
 *   //...
 * });
 * ```
 **/ $752fac3307660e97$var$Ruler.prototype.after = function(afterName, ruleName, fn, options) {
    var index = this.__find__(afterName);
    var opt = options || {};
    if (index === -1) throw new Error("Parser rule not found: " + afterName);
    this.__rules__.splice(index + 1, 0, {
        name: ruleName,
        enabled: true,
        fn: fn,
        alt: opt.alt || []
    });
    this.__cache__ = null;
};
/**
 * Ruler.push(ruleName, fn [, options])
 * - ruleName (String): name of added rule.
 * - fn (Function): rule function.
 * - options (Object): rule options (not mandatory).
 *
 * Push new rule to the end of chain. See also
 * [[Ruler.before]], [[Ruler.after]].
 *
 * ##### Options:
 *
 * - __alt__ - array with names of "alternate" chains.
 *
 * ##### Example
 *
 * ```javascript
 * var md = require('markdown-it')();
 *
 * md.core.ruler.push('my_rule', function replace(state) {
 *   //...
 * });
 * ```
 **/ $752fac3307660e97$var$Ruler.prototype.push = function(ruleName, fn, options) {
    var opt = options || {};
    this.__rules__.push({
        name: ruleName,
        enabled: true,
        fn: fn,
        alt: opt.alt || []
    });
    this.__cache__ = null;
};
/**
 * Ruler.enable(list [, ignoreInvalid]) -> Array
 * - list (String|Array): list of rule names to enable.
 * - ignoreInvalid (Boolean): set `true` to ignore errors when rule not found.
 *
 * Enable rules with given names. If any rule name not found - throw Error.
 * Errors can be disabled by second param.
 *
 * Returns list of found rule names (if no exception happened).
 *
 * See also [[Ruler.disable]], [[Ruler.enableOnly]].
 **/ $752fac3307660e97$var$Ruler.prototype.enable = function(list, ignoreInvalid) {
    if (!Array.isArray(list)) list = [
        list
    ];
    var result = [];
    // Search by name and enable
    list.forEach(function(name) {
        var idx = this.__find__(name);
        if (idx < 0) {
            if (ignoreInvalid) return;
            throw new Error("Rules manager: invalid rule name " + name);
        }
        this.__rules__[idx].enabled = true;
        result.push(name);
    }, this);
    this.__cache__ = null;
    return result;
};
/**
 * Ruler.enableOnly(list [, ignoreInvalid])
 * - list (String|Array): list of rule names to enable (whitelist).
 * - ignoreInvalid (Boolean): set `true` to ignore errors when rule not found.
 *
 * Enable rules with given names, and disable everything else. If any rule name
 * not found - throw Error. Errors can be disabled by second param.
 *
 * See also [[Ruler.disable]], [[Ruler.enable]].
 **/ $752fac3307660e97$var$Ruler.prototype.enableOnly = function(list, ignoreInvalid) {
    if (!Array.isArray(list)) list = [
        list
    ];
    this.__rules__.forEach(function(rule) {
        rule.enabled = false;
    });
    this.enable(list, ignoreInvalid);
};
/**
 * Ruler.disable(list [, ignoreInvalid]) -> Array
 * - list (String|Array): list of rule names to disable.
 * - ignoreInvalid (Boolean): set `true` to ignore errors when rule not found.
 *
 * Disable rules with given names. If any rule name not found - throw Error.
 * Errors can be disabled by second param.
 *
 * Returns list of found rule names (if no exception happened).
 *
 * See also [[Ruler.enable]], [[Ruler.enableOnly]].
 **/ $752fac3307660e97$var$Ruler.prototype.disable = function(list, ignoreInvalid) {
    if (!Array.isArray(list)) list = [
        list
    ];
    var result = [];
    // Search by name and disable
    list.forEach(function(name) {
        var idx = this.__find__(name);
        if (idx < 0) {
            if (ignoreInvalid) return;
            throw new Error("Rules manager: invalid rule name " + name);
        }
        this.__rules__[idx].enabled = false;
        result.push(name);
    }, this);
    this.__cache__ = null;
    return result;
};
/**
 * Ruler.getRules(chainName) -> Array
 *
 * Return array of active functions (rules) for given chain name. It analyzes
 * rules configuration, compiles caches if not exists and returns result.
 *
 * Default chain name is `''` (empty string). It can't be skipped. That's
 * done intentionally, to keep signature monomorphic for high speed.
 **/ $752fac3307660e97$var$Ruler.prototype.getRules = function(chainName) {
    if (this.__cache__ === null) this.__compile__();
    // Chain can be empty, if rules disabled. But we still have to return Array.
    return this.__cache__[chainName] || [];
};
module.exports = $752fac3307660e97$var$Ruler;

});

parcelRequire.register("6bP5l", function(module, exports) {
// Normalize input string
"use strict";
// https://spec.commonmark.org/0.29/#line-ending
var $481b65975d0d9312$var$NEWLINES_RE = /\r\n?|\n/g;
var $481b65975d0d9312$var$NULL_RE = /\0/g;
module.exports = function normalize(state) {
    var str;
    // Normalize newlines
    str = state.src.replace($481b65975d0d9312$var$NEWLINES_RE, "\n");
    // Replace NULL characters
    str = str.replace($481b65975d0d9312$var$NULL_RE, "�");
    state.src = str;
};

});

parcelRequire.register("5f5nj", function(module, exports) {
"use strict";
module.exports = function block(state) {
    var token;
    if (state.inlineMode) {
        token = new state.Token("inline", "", 0);
        token.content = state.src;
        token.map = [
            0,
            1
        ];
        token.children = [];
        state.tokens.push(token);
    } else state.md.block.parse(state.src, state.md, state.env, state.tokens);
};

});

parcelRequire.register("ddB1L", function(module, exports) {
"use strict";
module.exports = function inline(state) {
    var tokens = state.tokens, tok, i, l;
    // Parse inlines
    for(i = 0, l = tokens.length; i < l; i++){
        tok = tokens[i];
        if (tok.type === "inline") state.md.inline.parse(tok.content, state.md, state.env, tok.children);
    }
};

});

parcelRequire.register("hfDPQ", function(module, exports) {
// Replace link-like texts with link nodes.
//
// Currently restricted by `md.validateLink()` to http/https/ftp
//
"use strict";

var $iCsQ9 = parcelRequire("iCsQ9");
var $c8f2bcd987daac6d$require$arrayReplaceAt = $iCsQ9.arrayReplaceAt;
function $c8f2bcd987daac6d$var$isLinkOpen(str) {
    return /^<a[>\s]/i.test(str);
}
function $c8f2bcd987daac6d$var$isLinkClose(str) {
    return /^<\/a\s*>/i.test(str);
}
module.exports = function linkify(state) {
    var i, j, l, tokens, token, currentToken, nodes, ln, text, pos, lastPos, level, htmlLinkLevel, url, fullUrl, urlText, blockTokens = state.tokens, links;
    if (!state.md.options.linkify) return;
    for(j = 0, l = blockTokens.length; j < l; j++){
        if (blockTokens[j].type !== "inline" || !state.md.linkify.pretest(blockTokens[j].content)) continue;
        tokens = blockTokens[j].children;
        htmlLinkLevel = 0;
        // We scan from the end, to keep position when new tags added.
        // Use reversed logic in links start/end match
        for(i = tokens.length - 1; i >= 0; i--){
            currentToken = tokens[i];
            // Skip content of markdown links
            if (currentToken.type === "link_close") {
                i--;
                while(tokens[i].level !== currentToken.level && tokens[i].type !== "link_open")i--;
                continue;
            }
            // Skip content of html tag links
            if (currentToken.type === "html_inline") {
                if ($c8f2bcd987daac6d$var$isLinkOpen(currentToken.content) && htmlLinkLevel > 0) htmlLinkLevel--;
                if ($c8f2bcd987daac6d$var$isLinkClose(currentToken.content)) htmlLinkLevel++;
            }
            if (htmlLinkLevel > 0) continue;
            if (currentToken.type === "text" && state.md.linkify.test(currentToken.content)) {
                text = currentToken.content;
                links = state.md.linkify.match(text);
                // Now split string to nodes
                nodes = [];
                level = currentToken.level;
                lastPos = 0;
                for(ln = 0; ln < links.length; ln++){
                    url = links[ln].url;
                    fullUrl = state.md.normalizeLink(url);
                    if (!state.md.validateLink(fullUrl)) continue;
                    urlText = links[ln].text;
                    // Linkifier might send raw hostnames like "example.com", where url
                    // starts with domain name. So we prepend http:// in those cases,
                    // and remove it afterwards.
                    //
                    if (!links[ln].schema) urlText = state.md.normalizeLinkText("http://" + urlText).replace(/^http:\/\//, "");
                    else if (links[ln].schema === "mailto:" && !/^mailto:/i.test(urlText)) urlText = state.md.normalizeLinkText("mailto:" + urlText).replace(/^mailto:/, "");
                    else urlText = state.md.normalizeLinkText(urlText);
                    pos = links[ln].index;
                    if (pos > lastPos) {
                        token = new state.Token("text", "", 0);
                        token.content = text.slice(lastPos, pos);
                        token.level = level;
                        nodes.push(token);
                    }
                    token = new state.Token("link_open", "a", 1);
                    token.attrs = [
                        [
                            "href",
                            fullUrl
                        ]
                    ];
                    token.level = level++;
                    token.markup = "linkify";
                    token.info = "auto";
                    nodes.push(token);
                    token = new state.Token("text", "", 0);
                    token.content = urlText;
                    token.level = level;
                    nodes.push(token);
                    token = new state.Token("link_close", "a", -1);
                    token.level = --level;
                    token.markup = "linkify";
                    token.info = "auto";
                    nodes.push(token);
                    lastPos = links[ln].lastIndex;
                }
                if (lastPos < text.length) {
                    token = new state.Token("text", "", 0);
                    token.content = text.slice(lastPos);
                    token.level = level;
                    nodes.push(token);
                }
                // replace current node
                blockTokens[j].children = tokens = $c8f2bcd987daac6d$require$arrayReplaceAt(tokens, i, nodes);
            }
        }
    }
};

});

parcelRequire.register("j34M2", function(module, exports) {
// Simple typographic replacements
//
// (c) (C) → ©
// (tm) (TM) → ™
// (r) (R) → ®
// +- → ±
// (p) (P) -> §
// ... → … (also ?.... → ?.., !.... → !..)
// ???????? → ???, !!!!! → !!!, `,,` → `,`
// -- → &ndash;, --- → &mdash;
//
"use strict";
// TODO:
// - fractionals 1/2, 1/4, 3/4 -> ½, ¼, ¾
// - miltiplication 2 x 4 -> 2 × 4
var $dde2001887f4a0b2$var$RARE_RE = /\+-|\.\.|\?\?\?\?|!!!!|,,|--/;
// Workaround for phantomjs - need regex without /g flag,
// or root check will fail every second time
var $dde2001887f4a0b2$var$SCOPED_ABBR_TEST_RE = /\((c|tm|r|p)\)/i;
var $dde2001887f4a0b2$var$SCOPED_ABBR_RE = /\((c|tm|r|p)\)/ig;
var $dde2001887f4a0b2$var$SCOPED_ABBR = {
    c: "\xa9",
    r: "\xae",
    p: "\xa7",
    tm: "™"
};
function $dde2001887f4a0b2$var$replaceFn(match, name) {
    return $dde2001887f4a0b2$var$SCOPED_ABBR[name.toLowerCase()];
}
function $dde2001887f4a0b2$var$replace_scoped(inlineTokens) {
    var i, token, inside_autolink = 0;
    for(i = inlineTokens.length - 1; i >= 0; i--){
        token = inlineTokens[i];
        if (token.type === "text" && !inside_autolink) token.content = token.content.replace($dde2001887f4a0b2$var$SCOPED_ABBR_RE, $dde2001887f4a0b2$var$replaceFn);
        if (token.type === "link_open" && token.info === "auto") inside_autolink--;
        if (token.type === "link_close" && token.info === "auto") inside_autolink++;
    }
}
function $dde2001887f4a0b2$var$replace_rare(inlineTokens) {
    var i, token, inside_autolink = 0;
    for(i = inlineTokens.length - 1; i >= 0; i--){
        token = inlineTokens[i];
        if (token.type === "text" && !inside_autolink) {
            if ($dde2001887f4a0b2$var$RARE_RE.test(token.content)) token.content = token.content.replace(/\+-/g, "\xb1")// .., ..., ....... -> …
            // but ?..... & !..... -> ?.. & !..
            .replace(/\.{2,}/g, "…").replace(/([?!])…/g, "$1..").replace(/([?!]){4,}/g, "$1$1$1").replace(/,{2,}/g, ",")// em-dash
            .replace(/(^|[^-])---(?=[^-]|$)/mg, "$1—")// en-dash
            .replace(/(^|\s)--(?=\s|$)/mg, "$1–").replace(/(^|[^-\s])--(?=[^-\s]|$)/mg, "$1–");
        }
        if (token.type === "link_open" && token.info === "auto") inside_autolink--;
        if (token.type === "link_close" && token.info === "auto") inside_autolink++;
    }
}
module.exports = function replace(state) {
    var blkIdx;
    if (!state.md.options.typographer) return;
    for(blkIdx = state.tokens.length - 1; blkIdx >= 0; blkIdx--){
        if (state.tokens[blkIdx].type !== "inline") continue;
        if ($dde2001887f4a0b2$var$SCOPED_ABBR_TEST_RE.test(state.tokens[blkIdx].content)) $dde2001887f4a0b2$var$replace_scoped(state.tokens[blkIdx].children);
        if ($dde2001887f4a0b2$var$RARE_RE.test(state.tokens[blkIdx].content)) $dde2001887f4a0b2$var$replace_rare(state.tokens[blkIdx].children);
    }
};

});

parcelRequire.register("96Qru", function(module, exports) {
// Convert straight quotation marks to typographic ones
//
"use strict";

var $iCsQ9 = parcelRequire("iCsQ9");
var $6a1d5a9088951759$require$isWhiteSpace = $iCsQ9.isWhiteSpace;

var $iCsQ9 = parcelRequire("iCsQ9");
var $6a1d5a9088951759$require$isPunctChar = $iCsQ9.isPunctChar;

var $iCsQ9 = parcelRequire("iCsQ9");
var $6a1d5a9088951759$require$isMdAsciiPunct = $iCsQ9.isMdAsciiPunct;
var $6a1d5a9088951759$var$QUOTE_TEST_RE = /['"]/;
var $6a1d5a9088951759$var$QUOTE_RE = /['"]/g;
var $6a1d5a9088951759$var$APOSTROPHE = "’"; /* ’ */ 
function $6a1d5a9088951759$var$replaceAt(str, index, ch) {
    return str.substr(0, index) + ch + str.substr(index + 1);
}
function $6a1d5a9088951759$var$process_inlines(tokens, state) {
    var i, token, text, t, pos, max, thisLevel, item, lastChar, nextChar, isLastPunctChar, isNextPunctChar, isLastWhiteSpace, isNextWhiteSpace, canOpen, canClose, j, isSingle, stack, openQuote, closeQuote;
    stack = [];
    for(i = 0; i < tokens.length; i++){
        token = tokens[i];
        thisLevel = tokens[i].level;
        for(j = stack.length - 1; j >= 0; j--){
            if (stack[j].level <= thisLevel) break;
        }
        stack.length = j + 1;
        if (token.type !== "text") continue;
        text = token.content;
        pos = 0;
        max = text.length;
        /*eslint no-labels:0,block-scoped-var:0*/ OUTER: while(pos < max){
            $6a1d5a9088951759$var$QUOTE_RE.lastIndex = pos;
            t = $6a1d5a9088951759$var$QUOTE_RE.exec(text);
            if (!t) break;
            canOpen = canClose = true;
            pos = t.index + 1;
            isSingle = t[0] === "'";
            // Find previous character,
            // default to space if it's the beginning of the line
            //
            lastChar = 0x20;
            if (t.index - 1 >= 0) lastChar = text.charCodeAt(t.index - 1);
            else for(j = i - 1; j >= 0; j--){
                if (tokens[j].type === "softbreak" || tokens[j].type === "hardbreak") break; // lastChar defaults to 0x20
                if (!tokens[j].content) continue; // should skip all tokens except 'text', 'html_inline' or 'code_inline'
                lastChar = tokens[j].content.charCodeAt(tokens[j].content.length - 1);
                break;
            }
            // Find next character,
            // default to space if it's the end of the line
            //
            nextChar = 0x20;
            if (pos < max) nextChar = text.charCodeAt(pos);
            else for(j = i + 1; j < tokens.length; j++){
                if (tokens[j].type === "softbreak" || tokens[j].type === "hardbreak") break; // nextChar defaults to 0x20
                if (!tokens[j].content) continue; // should skip all tokens except 'text', 'html_inline' or 'code_inline'
                nextChar = tokens[j].content.charCodeAt(0);
                break;
            }
            isLastPunctChar = $6a1d5a9088951759$require$isMdAsciiPunct(lastChar) || $6a1d5a9088951759$require$isPunctChar(String.fromCharCode(lastChar));
            isNextPunctChar = $6a1d5a9088951759$require$isMdAsciiPunct(nextChar) || $6a1d5a9088951759$require$isPunctChar(String.fromCharCode(nextChar));
            isLastWhiteSpace = $6a1d5a9088951759$require$isWhiteSpace(lastChar);
            isNextWhiteSpace = $6a1d5a9088951759$require$isWhiteSpace(nextChar);
            if (isNextWhiteSpace) canOpen = false;
            else if (isNextPunctChar) {
                if (!(isLastWhiteSpace || isLastPunctChar)) canOpen = false;
            }
            if (isLastWhiteSpace) canClose = false;
            else if (isLastPunctChar) {
                if (!(isNextWhiteSpace || isNextPunctChar)) canClose = false;
            }
            if (nextChar === 0x22 /* " */  && t[0] === '"') {
                if (lastChar >= 0x30 /* 0 */  && lastChar <= 0x39 /* 9 */ ) // special case: 1"" - count first quote as an inch
                canClose = canOpen = false;
            }
            if (canOpen && canClose) {
                // Replace quotes in the middle of punctuation sequence, but not
                // in the middle of the words, i.e.:
                //
                // 1. foo " bar " baz - not replaced
                // 2. foo-"-bar-"-baz - replaced
                // 3. foo"bar"baz     - not replaced
                //
                canOpen = isLastPunctChar;
                canClose = isNextPunctChar;
            }
            if (!canOpen && !canClose) {
                // middle of word
                if (isSingle) token.content = $6a1d5a9088951759$var$replaceAt(token.content, t.index, $6a1d5a9088951759$var$APOSTROPHE);
                continue;
            }
            if (canClose) // this could be a closing quote, rewind the stack to get a match
            for(j = stack.length - 1; j >= 0; j--){
                item = stack[j];
                if (stack[j].level < thisLevel) break;
                if (item.single === isSingle && stack[j].level === thisLevel) {
                    item = stack[j];
                    if (isSingle) {
                        openQuote = state.md.options.quotes[2];
                        closeQuote = state.md.options.quotes[3];
                    } else {
                        openQuote = state.md.options.quotes[0];
                        closeQuote = state.md.options.quotes[1];
                    }
                    // replace token.content *before* tokens[item.token].content,
                    // because, if they are pointing at the same token, replaceAt
                    // could mess up indices when quote length != 1
                    token.content = $6a1d5a9088951759$var$replaceAt(token.content, t.index, closeQuote);
                    tokens[item.token].content = $6a1d5a9088951759$var$replaceAt(tokens[item.token].content, item.pos, openQuote);
                    pos += closeQuote.length - 1;
                    if (item.token === i) pos += openQuote.length - 1;
                    text = token.content;
                    max = text.length;
                    stack.length = j;
                    continue OUTER;
                }
            }
            if (canOpen) stack.push({
                token: i,
                pos: t.index,
                single: isSingle,
                level: thisLevel
            });
            else if (canClose && isSingle) token.content = $6a1d5a9088951759$var$replaceAt(token.content, t.index, $6a1d5a9088951759$var$APOSTROPHE);
        }
    }
}
module.exports = function smartquotes(state) {
    /*eslint max-depth:0*/ var blkIdx;
    if (!state.md.options.typographer) return;
    for(blkIdx = state.tokens.length - 1; blkIdx >= 0; blkIdx--){
        if (state.tokens[blkIdx].type !== "inline" || !$6a1d5a9088951759$var$QUOTE_TEST_RE.test(state.tokens[blkIdx].content)) continue;
        $6a1d5a9088951759$var$process_inlines(state.tokens[blkIdx].children, state);
    }
};

});

parcelRequire.register("8dagG", function(module, exports) {
// Core state object
//
"use strict";

var $6rIm2 = parcelRequire("6rIm2");
function $5fa780a50fd26456$var$StateCore(src, md, env) {
    this.src = src;
    this.env = env;
    this.tokens = [];
    this.inlineMode = false;
    this.md = md; // link to parser instance
}
// re-export Token class to use in core rules
$5fa780a50fd26456$var$StateCore.prototype.Token = $6rIm2;
module.exports = $5fa780a50fd26456$var$StateCore;

});
parcelRequire.register("6rIm2", function(module, exports) {
// Token class
"use strict";
/**
 * class Token
 **/ /**
 * new Token(type, tag, nesting)
 *
 * Create new token and fill passed properties.
 **/ function $4b17ab8b04f8924c$var$Token(type, tag, nesting) {
    /**
   * Token#type -> String
   *
   * Type of the token (string, e.g. "paragraph_open")
   **/ this.type = type;
    /**
   * Token#tag -> String
   *
   * html tag name, e.g. "p"
   **/ this.tag = tag;
    /**
   * Token#attrs -> Array
   *
   * Html attributes. Format: `[ [ name1, value1 ], [ name2, value2 ] ]`
   **/ this.attrs = null;
    /**
   * Token#map -> Array
   *
   * Source map info. Format: `[ line_begin, line_end ]`
   **/ this.map = null;
    /**
   * Token#nesting -> Number
   *
   * Level change (number in {-1, 0, 1} set), where:
   *
   * -  `1` means the tag is opening
   * -  `0` means the tag is self-closing
   * - `-1` means the tag is closing
   **/ this.nesting = nesting;
    /**
   * Token#level -> Number
   *
   * nesting level, the same as `state.level`
   **/ this.level = 0;
    /**
   * Token#children -> Array
   *
   * An array of child nodes (inline and img tokens)
   **/ this.children = null;
    /**
   * Token#content -> String
   *
   * In a case of self-closing tag (code, html, fence, etc.),
   * it has contents of this tag.
   **/ this.content = "";
    /**
   * Token#markup -> String
   *
   * '*' or '_' for emphasis, fence string for fence, etc.
   **/ this.markup = "";
    /**
   * Token#info -> String
   *
   * Additional information:
   *
   * - Info string for "fence" tokens
   * - The value "auto" for autolink "link_open" and "link_close" tokens
   * - The string value of the item marker for ordered-list "list_item_open" tokens
   **/ this.info = "";
    /**
   * Token#meta -> Object
   *
   * A place for plugins to store an arbitrary data
   **/ this.meta = null;
    /**
   * Token#block -> Boolean
   *
   * True for block-level tokens, false for inline tokens.
   * Used in renderer to calculate line breaks
   **/ this.block = false;
    /**
   * Token#hidden -> Boolean
   *
   * If it's true, ignore this element when rendering. Used for tight lists
   * to hide paragraphs.
   **/ this.hidden = false;
}
/**
 * Token.attrIndex(name) -> Number
 *
 * Search attribute index by name.
 **/ $4b17ab8b04f8924c$var$Token.prototype.attrIndex = function attrIndex(name) {
    var attrs, i, len;
    if (!this.attrs) return -1;
    attrs = this.attrs;
    for(i = 0, len = attrs.length; i < len; i++){
        if (attrs[i][0] === name) return i;
    }
    return -1;
};
/**
 * Token.attrPush(attrData)
 *
 * Add `[ name, value ]` attribute to list. Init attrs if necessary
 **/ $4b17ab8b04f8924c$var$Token.prototype.attrPush = function attrPush(attrData) {
    if (this.attrs) this.attrs.push(attrData);
    else this.attrs = [
        attrData
    ];
};
/**
 * Token.attrSet(name, value)
 *
 * Set `name` attribute to `value`. Override old value if exists.
 **/ $4b17ab8b04f8924c$var$Token.prototype.attrSet = function attrSet(name, value) {
    var idx = this.attrIndex(name), attrData = [
        name,
        value
    ];
    if (idx < 0) this.attrPush(attrData);
    else this.attrs[idx] = attrData;
};
/**
 * Token.attrGet(name)
 *
 * Get the value of attribute `name`, or null if it does not exist.
 **/ $4b17ab8b04f8924c$var$Token.prototype.attrGet = function attrGet(name) {
    var idx = this.attrIndex(name), value = null;
    if (idx >= 0) value = this.attrs[idx][1];
    return value;
};
/**
 * Token.attrJoin(name, value)
 *
 * Join value to existing attribute via space. Or create new attribute if not
 * exists. Useful to operate with token classes.
 **/ $4b17ab8b04f8924c$var$Token.prototype.attrJoin = function attrJoin(name, value) {
    var idx = this.attrIndex(name);
    if (idx < 0) this.attrPush([
        name,
        value
    ]);
    else this.attrs[idx][1] = this.attrs[idx][1] + " " + value;
};
module.exports = $4b17ab8b04f8924c$var$Token;

});



parcelRequire.register("bjgBT", function(module, exports) {
/** internal
 * class ParserBlock
 *
 * Block-level tokenizer.
 **/ "use strict";

var $a3Mkq = parcelRequire("a3Mkq");











var $83be5a7b61742ff8$var$_rules = [
    // First 2 params - rule name & source. Secondary array - list of rules,
    // which can be terminated by this one.
    [
        "table",
        (parcelRequire("gzHP2")),
        [
            "paragraph",
            "reference"
        ]
    ],
    [
        "code",
        (parcelRequire("kOa4V"))
    ],
    [
        "fence",
        (parcelRequire("5thSo")),
        [
            "paragraph",
            "reference",
            "blockquote",
            "list"
        ]
    ],
    [
        "blockquote",
        (parcelRequire("7Hm5H")),
        [
            "paragraph",
            "reference",
            "blockquote",
            "list"
        ]
    ],
    [
        "hr",
        (parcelRequire("4cw9L")),
        [
            "paragraph",
            "reference",
            "blockquote",
            "list"
        ]
    ],
    [
        "list",
        (parcelRequire("7EPBS")),
        [
            "paragraph",
            "reference",
            "blockquote"
        ]
    ],
    [
        "reference",
        (parcelRequire("a0nYv"))
    ],
    [
        "html_block",
        (parcelRequire("O8JAE")),
        [
            "paragraph",
            "reference",
            "blockquote"
        ]
    ],
    [
        "heading",
        (parcelRequire("5ULm7")),
        [
            "paragraph",
            "reference",
            "blockquote"
        ]
    ],
    [
        "lheading",
        (parcelRequire("jynnW"))
    ],
    [
        "paragraph",
        (parcelRequire("amKQf"))
    ]
];
/**
 * new ParserBlock()
 **/ function $83be5a7b61742ff8$var$ParserBlock() {
    /**
   * ParserBlock#ruler -> Ruler
   *
   * [[Ruler]] instance. Keep configuration of block rules.
   **/ this.ruler = new $a3Mkq();
    for(var i = 0; i < $83be5a7b61742ff8$var$_rules.length; i++)this.ruler.push($83be5a7b61742ff8$var$_rules[i][0], $83be5a7b61742ff8$var$_rules[i][1], {
        alt: ($83be5a7b61742ff8$var$_rules[i][2] || []).slice()
    });
}
// Generate tokens for input range
//
$83be5a7b61742ff8$var$ParserBlock.prototype.tokenize = function(state, startLine, endLine) {
    var ok, i, rules = this.ruler.getRules(""), len = rules.length, line = startLine, hasEmptyLines = false, maxNesting = state.md.options.maxNesting;
    while(line < endLine){
        state.line = line = state.skipEmptyLines(line);
        if (line >= endLine) break;
        // Termination condition for nested calls.
        // Nested calls currently used for blockquotes & lists
        if (state.sCount[line] < state.blkIndent) break;
        // If nesting level exceeded - skip tail to the end. That's not ordinary
        // situation and we should not care about content.
        if (state.level >= maxNesting) {
            state.line = endLine;
            break;
        }
        // Try all possible rules.
        // On success, rule should:
        //
        // - update `state.line`
        // - update `state.tokens`
        // - return true
        for(i = 0; i < len; i++){
            ok = rules[i](state, line, endLine, false);
            if (ok) break;
        }
        // set state.tight if we had an empty line before current tag
        // i.e. latest empty line should not count
        state.tight = !hasEmptyLines;
        // paragraph might "eat" one newline after it in nested lists
        if (state.isEmpty(state.line - 1)) hasEmptyLines = true;
        line = state.line;
        if (line < endLine && state.isEmpty(line)) {
            hasEmptyLines = true;
            line++;
            state.line = line;
        }
    }
};
/**
 * ParserBlock.parse(str, md, env, outTokens)
 *
 * Process input string and push block tokens into `outTokens`
 **/ $83be5a7b61742ff8$var$ParserBlock.prototype.parse = function(src, md, env, outTokens) {
    var state;
    if (!src) return;
    state = new this.State(src, md, env, outTokens);
    this.tokenize(state, state.line, state.lineMax);
};

$83be5a7b61742ff8$var$ParserBlock.prototype.State = (parcelRequire("5Rt0u"));
module.exports = $83be5a7b61742ff8$var$ParserBlock;

});
parcelRequire.register("gzHP2", function(module, exports) {
// GFM table, https://github.github.com/gfm/#tables-extension-
"use strict";

var $iCsQ9 = parcelRequire("iCsQ9");
var $c111e868d033436c$require$isSpace = $iCsQ9.isSpace;
function $c111e868d033436c$var$getLine(state, line) {
    var pos = state.bMarks[line] + state.tShift[line], max = state.eMarks[line];
    return state.src.substr(pos, max - pos);
}
function $c111e868d033436c$var$escapedSplit(str) {
    var result = [], pos = 0, max = str.length, ch, isEscaped = false, lastPos = 0, current = "";
    ch = str.charCodeAt(pos);
    while(pos < max){
        if (ch === 0x7c /* | */ ) {
            if (!isEscaped) {
                // pipe separating cells, '|'
                result.push(current + str.substring(lastPos, pos));
                current = "";
                lastPos = pos + 1;
            } else {
                // escaped pipe, '\|'
                current += str.substring(lastPos, pos - 1);
                lastPos = pos;
            }
        }
        isEscaped = ch === 0x5c /* \ */ ;
        pos++;
        ch = str.charCodeAt(pos);
    }
    result.push(current + str.substring(lastPos));
    return result;
}
module.exports = function table(state, startLine, endLine, silent) {
    var ch, lineText, pos, i, l, nextLine, columns, columnCount, token, aligns, t, tableLines, tbodyLines, oldParentType, terminate, terminatorRules, firstCh, secondCh;
    // should have at least two lines
    if (startLine + 2 > endLine) return false;
    nextLine = startLine + 1;
    if (state.sCount[nextLine] < state.blkIndent) return false;
    // if it's indented more than 3 spaces, it should be a code block
    if (state.sCount[nextLine] - state.blkIndent >= 4) return false;
    // first character of the second line should be '|', '-', ':',
    // and no other characters are allowed but spaces;
    // basically, this is the equivalent of /^[-:|][-:|\s]*$/ regexp
    pos = state.bMarks[nextLine] + state.tShift[nextLine];
    if (pos >= state.eMarks[nextLine]) return false;
    firstCh = state.src.charCodeAt(pos++);
    if (firstCh !== 0x7C /* | */  && firstCh !== 0x2D /* - */  && firstCh !== 0x3A /* : */ ) return false;
    if (pos >= state.eMarks[nextLine]) return false;
    secondCh = state.src.charCodeAt(pos++);
    if (secondCh !== 0x7C /* | */  && secondCh !== 0x2D /* - */  && secondCh !== 0x3A /* : */  && !$c111e868d033436c$require$isSpace(secondCh)) return false;
    // if first character is '-', then second character must not be a space
    // (due to parsing ambiguity with list)
    if (firstCh === 0x2D /* - */  && $c111e868d033436c$require$isSpace(secondCh)) return false;
    while(pos < state.eMarks[nextLine]){
        ch = state.src.charCodeAt(pos);
        if (ch !== 0x7C /* | */  && ch !== 0x2D /* - */  && ch !== 0x3A /* : */  && !$c111e868d033436c$require$isSpace(ch)) return false;
        pos++;
    }
    lineText = $c111e868d033436c$var$getLine(state, startLine + 1);
    columns = lineText.split("|");
    aligns = [];
    for(i = 0; i < columns.length; i++){
        t = columns[i].trim();
        if (!t) {
            // allow empty columns before and after table, but not in between columns;
            // e.g. allow ` |---| `, disallow ` ---||--- `
            if (i === 0 || i === columns.length - 1) continue;
            else return false;
        }
        if (!/^:?-+:?$/.test(t)) return false;
        if (t.charCodeAt(t.length - 1) === 0x3A /* : */ ) aligns.push(t.charCodeAt(0) === 0x3A /* : */  ? "center" : "right");
        else if (t.charCodeAt(0) === 0x3A /* : */ ) aligns.push("left");
        else aligns.push("");
    }
    lineText = $c111e868d033436c$var$getLine(state, startLine).trim();
    if (lineText.indexOf("|") === -1) return false;
    if (state.sCount[startLine] - state.blkIndent >= 4) return false;
    columns = $c111e868d033436c$var$escapedSplit(lineText);
    if (columns.length && columns[0] === "") columns.shift();
    if (columns.length && columns[columns.length - 1] === "") columns.pop();
    // header row will define an amount of columns in the entire table,
    // and align row should be exactly the same (the rest of the rows can differ)
    columnCount = columns.length;
    if (columnCount === 0 || columnCount !== aligns.length) return false;
    if (silent) return true;
    oldParentType = state.parentType;
    state.parentType = "table";
    // use 'blockquote' lists for termination because it's
    // the most similar to tables
    terminatorRules = state.md.block.ruler.getRules("blockquote");
    token = state.push("table_open", "table", 1);
    token.map = tableLines = [
        startLine,
        0
    ];
    token = state.push("thead_open", "thead", 1);
    token.map = [
        startLine,
        startLine + 1
    ];
    token = state.push("tr_open", "tr", 1);
    token.map = [
        startLine,
        startLine + 1
    ];
    for(i = 0; i < columns.length; i++){
        token = state.push("th_open", "th", 1);
        if (aligns[i]) token.attrs = [
            [
                "style",
                "text-align:" + aligns[i]
            ]
        ];
        token = state.push("inline", "", 0);
        token.content = columns[i].trim();
        token.children = [];
        token = state.push("th_close", "th", -1);
    }
    token = state.push("tr_close", "tr", -1);
    token = state.push("thead_close", "thead", -1);
    for(nextLine = startLine + 2; nextLine < endLine; nextLine++){
        if (state.sCount[nextLine] < state.blkIndent) break;
        terminate = false;
        for(i = 0, l = terminatorRules.length; i < l; i++)if (terminatorRules[i](state, nextLine, endLine, true)) {
            terminate = true;
            break;
        }
        if (terminate) break;
        lineText = $c111e868d033436c$var$getLine(state, nextLine).trim();
        if (!lineText) break;
        if (state.sCount[nextLine] - state.blkIndent >= 4) break;
        columns = $c111e868d033436c$var$escapedSplit(lineText);
        if (columns.length && columns[0] === "") columns.shift();
        if (columns.length && columns[columns.length - 1] === "") columns.pop();
        if (nextLine === startLine + 2) {
            token = state.push("tbody_open", "tbody", 1);
            token.map = tbodyLines = [
                startLine + 2,
                0
            ];
        }
        token = state.push("tr_open", "tr", 1);
        token.map = [
            nextLine,
            nextLine + 1
        ];
        for(i = 0; i < columnCount; i++){
            token = state.push("td_open", "td", 1);
            if (aligns[i]) token.attrs = [
                [
                    "style",
                    "text-align:" + aligns[i]
                ]
            ];
            token = state.push("inline", "", 0);
            token.content = columns[i] ? columns[i].trim() : "";
            token.children = [];
            token = state.push("td_close", "td", -1);
        }
        token = state.push("tr_close", "tr", -1);
    }
    if (tbodyLines) {
        token = state.push("tbody_close", "tbody", -1);
        tbodyLines[1] = nextLine;
    }
    token = state.push("table_close", "table", -1);
    tableLines[1] = nextLine;
    state.parentType = oldParentType;
    state.line = nextLine;
    return true;
};

});

parcelRequire.register("kOa4V", function(module, exports) {
// Code block (4 spaces padded)
"use strict";
module.exports = function code(state, startLine, endLine /*, silent*/ ) {
    var nextLine, last, token;
    if (state.sCount[startLine] - state.blkIndent < 4) return false;
    last = nextLine = startLine + 1;
    while(nextLine < endLine){
        if (state.isEmpty(nextLine)) {
            nextLine++;
            continue;
        }
        if (state.sCount[nextLine] - state.blkIndent >= 4) {
            nextLine++;
            last = nextLine;
            continue;
        }
        break;
    }
    state.line = last;
    token = state.push("code_block", "code", 0);
    token.content = state.getLines(startLine, last, 4 + state.blkIndent, false) + "\n";
    token.map = [
        startLine,
        state.line
    ];
    return true;
};

});

parcelRequire.register("5thSo", function(module, exports) {
// fences (``` lang, ~~~ lang)
"use strict";
module.exports = function fence(state, startLine, endLine, silent) {
    var marker, len, params, nextLine, mem, token, markup, haveEndMarker = false, pos = state.bMarks[startLine] + state.tShift[startLine], max = state.eMarks[startLine];
    // if it's indented more than 3 spaces, it should be a code block
    if (state.sCount[startLine] - state.blkIndent >= 4) return false;
    if (pos + 3 > max) return false;
    marker = state.src.charCodeAt(pos);
    if (marker !== 0x7E /* ~ */  && marker !== 0x60 /* ` */ ) return false;
    // scan marker length
    mem = pos;
    pos = state.skipChars(pos, marker);
    len = pos - mem;
    if (len < 3) return false;
    markup = state.src.slice(mem, pos);
    params = state.src.slice(pos, max);
    if (marker === 0x60 /* ` */ ) {
        if (params.indexOf(String.fromCharCode(marker)) >= 0) return false;
    }
    // Since start is found, we can report success here in validation mode
    if (silent) return true;
    // search end of block
    nextLine = startLine;
    for(;;){
        nextLine++;
        if (nextLine >= endLine) break;
        pos = mem = state.bMarks[nextLine] + state.tShift[nextLine];
        max = state.eMarks[nextLine];
        if (pos < max && state.sCount[nextLine] < state.blkIndent) break;
        if (state.src.charCodeAt(pos) !== marker) continue;
        if (state.sCount[nextLine] - state.blkIndent >= 4) continue;
        pos = state.skipChars(pos, marker);
        // closing code fence must be at least as long as the opening one
        if (pos - mem < len) continue;
        // make sure tail has spaces only
        pos = state.skipSpaces(pos);
        if (pos < max) continue;
        haveEndMarker = true;
        break;
    }
    // If a fence has heading spaces, they should be removed from its inner block
    len = state.sCount[startLine];
    state.line = nextLine + (haveEndMarker ? 1 : 0);
    token = state.push("fence", "code", 0);
    token.info = params;
    token.content = state.getLines(startLine + 1, nextLine, len, true);
    token.markup = markup;
    token.map = [
        startLine,
        state.line
    ];
    return true;
};

});

parcelRequire.register("7Hm5H", function(module, exports) {
// Block quotes
"use strict";

var $iCsQ9 = parcelRequire("iCsQ9");
var $59adaf58b0246b84$require$isSpace = $iCsQ9.isSpace;
module.exports = function blockquote(state, startLine, endLine, silent) {
    var adjustTab, ch, i, initial, l, lastLineEmpty, lines, nextLine, offset, oldBMarks, oldBSCount, oldIndent, oldParentType, oldSCount, oldTShift, spaceAfterMarker, terminate, terminatorRules, token, isOutdented, oldLineMax = state.lineMax, pos = state.bMarks[startLine] + state.tShift[startLine], max = state.eMarks[startLine];
    // if it's indented more than 3 spaces, it should be a code block
    if (state.sCount[startLine] - state.blkIndent >= 4) return false;
    // check the block quote marker
    if (state.src.charCodeAt(pos++) !== 0x3E /* > */ ) return false;
    // we know that it's going to be a valid blockquote,
    // so no point trying to find the end of it in silent mode
    if (silent) return true;
    // set offset past spaces and ">"
    initial = offset = state.sCount[startLine] + 1;
    // skip one optional space after '>'
    if (state.src.charCodeAt(pos) === 0x20 /* space */ ) {
        // ' >   test '
        //     ^ -- position start of line here:
        pos++;
        initial++;
        offset++;
        adjustTab = false;
        spaceAfterMarker = true;
    } else if (state.src.charCodeAt(pos) === 0x09 /* tab */ ) {
        spaceAfterMarker = true;
        if ((state.bsCount[startLine] + offset) % 4 === 3) {
            // '  >\t  test '
            //       ^ -- position start of line here (tab has width===1)
            pos++;
            initial++;
            offset++;
            adjustTab = false;
        } else // ' >\t  test '
        //    ^ -- position start of line here + shift bsCount slightly
        //         to make extra space appear
        adjustTab = true;
    } else spaceAfterMarker = false;
    oldBMarks = [
        state.bMarks[startLine]
    ];
    state.bMarks[startLine] = pos;
    while(pos < max){
        ch = state.src.charCodeAt(pos);
        if ($59adaf58b0246b84$require$isSpace(ch)) {
            if (ch === 0x09) offset += 4 - (offset + state.bsCount[startLine] + (adjustTab ? 1 : 0)) % 4;
            else offset++;
        } else break;
        pos++;
    }
    oldBSCount = [
        state.bsCount[startLine]
    ];
    state.bsCount[startLine] = state.sCount[startLine] + 1 + (spaceAfterMarker ? 1 : 0);
    lastLineEmpty = pos >= max;
    oldSCount = [
        state.sCount[startLine]
    ];
    state.sCount[startLine] = offset - initial;
    oldTShift = [
        state.tShift[startLine]
    ];
    state.tShift[startLine] = pos - state.bMarks[startLine];
    terminatorRules = state.md.block.ruler.getRules("blockquote");
    oldParentType = state.parentType;
    state.parentType = "blockquote";
    // Search the end of the block
    //
    // Block ends with either:
    //  1. an empty line outside:
    //     ```
    //     > test
    //
    //     ```
    //  2. an empty line inside:
    //     ```
    //     >
    //     test
    //     ```
    //  3. another tag:
    //     ```
    //     > test
    //      - - -
    //     ```
    for(nextLine = startLine + 1; nextLine < endLine; nextLine++){
        // check if it's outdented, i.e. it's inside list item and indented
        // less than said list item:
        //
        // ```
        // 1. anything
        //    > current blockquote
        // 2. checking this line
        // ```
        isOutdented = state.sCount[nextLine] < state.blkIndent;
        pos = state.bMarks[nextLine] + state.tShift[nextLine];
        max = state.eMarks[nextLine];
        if (pos >= max) break;
        if (state.src.charCodeAt(pos++) === 0x3E /* > */  && !isOutdented) {
            // This line is inside the blockquote.
            // set offset past spaces and ">"
            initial = offset = state.sCount[nextLine] + 1;
            // skip one optional space after '>'
            if (state.src.charCodeAt(pos) === 0x20 /* space */ ) {
                // ' >   test '
                //     ^ -- position start of line here:
                pos++;
                initial++;
                offset++;
                adjustTab = false;
                spaceAfterMarker = true;
            } else if (state.src.charCodeAt(pos) === 0x09 /* tab */ ) {
                spaceAfterMarker = true;
                if ((state.bsCount[nextLine] + offset) % 4 === 3) {
                    // '  >\t  test '
                    //       ^ -- position start of line here (tab has width===1)
                    pos++;
                    initial++;
                    offset++;
                    adjustTab = false;
                } else // ' >\t  test '
                //    ^ -- position start of line here + shift bsCount slightly
                //         to make extra space appear
                adjustTab = true;
            } else spaceAfterMarker = false;
            oldBMarks.push(state.bMarks[nextLine]);
            state.bMarks[nextLine] = pos;
            while(pos < max){
                ch = state.src.charCodeAt(pos);
                if ($59adaf58b0246b84$require$isSpace(ch)) {
                    if (ch === 0x09) offset += 4 - (offset + state.bsCount[nextLine] + (adjustTab ? 1 : 0)) % 4;
                    else offset++;
                } else break;
                pos++;
            }
            lastLineEmpty = pos >= max;
            oldBSCount.push(state.bsCount[nextLine]);
            state.bsCount[nextLine] = state.sCount[nextLine] + 1 + (spaceAfterMarker ? 1 : 0);
            oldSCount.push(state.sCount[nextLine]);
            state.sCount[nextLine] = offset - initial;
            oldTShift.push(state.tShift[nextLine]);
            state.tShift[nextLine] = pos - state.bMarks[nextLine];
            continue;
        }
        // Case 2: line is not inside the blockquote, and the last line was empty.
        if (lastLineEmpty) break;
        // Case 3: another tag found.
        terminate = false;
        for(i = 0, l = terminatorRules.length; i < l; i++)if (terminatorRules[i](state, nextLine, endLine, true)) {
            terminate = true;
            break;
        }
        if (terminate) {
            // Quirk to enforce "hard termination mode" for paragraphs;
            // normally if you call `tokenize(state, startLine, nextLine)`,
            // paragraphs will look below nextLine for paragraph continuation,
            // but if blockquote is terminated by another tag, they shouldn't
            state.lineMax = nextLine;
            if (state.blkIndent !== 0) {
                // state.blkIndent was non-zero, we now set it to zero,
                // so we need to re-calculate all offsets to appear as
                // if indent wasn't changed
                oldBMarks.push(state.bMarks[nextLine]);
                oldBSCount.push(state.bsCount[nextLine]);
                oldTShift.push(state.tShift[nextLine]);
                oldSCount.push(state.sCount[nextLine]);
                state.sCount[nextLine] -= state.blkIndent;
            }
            break;
        }
        oldBMarks.push(state.bMarks[nextLine]);
        oldBSCount.push(state.bsCount[nextLine]);
        oldTShift.push(state.tShift[nextLine]);
        oldSCount.push(state.sCount[nextLine]);
        // A negative indentation means that this is a paragraph continuation
        //
        state.sCount[nextLine] = -1;
    }
    oldIndent = state.blkIndent;
    state.blkIndent = 0;
    token = state.push("blockquote_open", "blockquote", 1);
    token.markup = ">";
    token.map = lines = [
        startLine,
        0
    ];
    state.md.block.tokenize(state, startLine, nextLine);
    token = state.push("blockquote_close", "blockquote", -1);
    token.markup = ">";
    state.lineMax = oldLineMax;
    state.parentType = oldParentType;
    lines[1] = state.line;
    // Restore original tShift; this might not be necessary since the parser
    // has already been here, but just to make sure we can do that.
    for(i = 0; i < oldTShift.length; i++){
        state.bMarks[i + startLine] = oldBMarks[i];
        state.tShift[i + startLine] = oldTShift[i];
        state.sCount[i + startLine] = oldSCount[i];
        state.bsCount[i + startLine] = oldBSCount[i];
    }
    state.blkIndent = oldIndent;
    return true;
};

});

parcelRequire.register("4cw9L", function(module, exports) {
// Horizontal rule
"use strict";

var $iCsQ9 = parcelRequire("iCsQ9");
var $30f13a07b92b7b02$require$isSpace = $iCsQ9.isSpace;
module.exports = function hr(state, startLine, endLine, silent) {
    var marker, cnt, ch, token, pos = state.bMarks[startLine] + state.tShift[startLine], max = state.eMarks[startLine];
    // if it's indented more than 3 spaces, it should be a code block
    if (state.sCount[startLine] - state.blkIndent >= 4) return false;
    marker = state.src.charCodeAt(pos++);
    // Check hr marker
    if (marker !== 0x2A /* * */  && marker !== 0x2D /* - */  && marker !== 0x5F /* _ */ ) return false;
    // markers can be mixed with spaces, but there should be at least 3 of them
    cnt = 1;
    while(pos < max){
        ch = state.src.charCodeAt(pos++);
        if (ch !== marker && !$30f13a07b92b7b02$require$isSpace(ch)) return false;
        if (ch === marker) cnt++;
    }
    if (cnt < 3) return false;
    if (silent) return true;
    state.line = startLine + 1;
    token = state.push("hr", "hr", 0);
    token.map = [
        startLine,
        state.line
    ];
    token.markup = Array(cnt + 1).join(String.fromCharCode(marker));
    return true;
};

});

parcelRequire.register("7EPBS", function(module, exports) {
// Lists
"use strict";

var $iCsQ9 = parcelRequire("iCsQ9");
var $59344d7d9a14e895$require$isSpace = $iCsQ9.isSpace;
// Search `[-+*][\n ]`, returns next pos after marker on success
// or -1 on fail.
function $59344d7d9a14e895$var$skipBulletListMarker(state, startLine) {
    var marker, pos, max, ch;
    pos = state.bMarks[startLine] + state.tShift[startLine];
    max = state.eMarks[startLine];
    marker = state.src.charCodeAt(pos++);
    // Check bullet
    if (marker !== 0x2A /* * */  && marker !== 0x2D /* - */  && marker !== 0x2B /* + */ ) return -1;
    if (pos < max) {
        ch = state.src.charCodeAt(pos);
        if (!$59344d7d9a14e895$require$isSpace(ch)) // " -test " - is not a list item
        return -1;
    }
    return pos;
}
// Search `\d+[.)][\n ]`, returns next pos after marker on success
// or -1 on fail.
function $59344d7d9a14e895$var$skipOrderedListMarker(state, startLine) {
    var ch, start = state.bMarks[startLine] + state.tShift[startLine], pos = start, max = state.eMarks[startLine];
    // List marker should have at least 2 chars (digit + dot)
    if (pos + 1 >= max) return -1;
    ch = state.src.charCodeAt(pos++);
    if (ch < 0x30 /* 0 */  || ch > 0x39 /* 9 */ ) return -1;
    for(;;){
        // EOL -> fail
        if (pos >= max) return -1;
        ch = state.src.charCodeAt(pos++);
        if (ch >= 0x30 /* 0 */  && ch <= 0x39 /* 9 */ ) {
            // List marker should have no more than 9 digits
            // (prevents integer overflow in browsers)
            if (pos - start >= 10) return -1;
            continue;
        }
        // found valid marker
        if (ch === 0x29 /* ) */  || ch === 0x2e /* . */ ) break;
        return -1;
    }
    if (pos < max) {
        ch = state.src.charCodeAt(pos);
        if (!$59344d7d9a14e895$require$isSpace(ch)) // " 1.test " - is not a list item
        return -1;
    }
    return pos;
}
function $59344d7d9a14e895$var$markTightParagraphs(state, idx) {
    var i, l, level = state.level + 2;
    for(i = idx + 2, l = state.tokens.length - 2; i < l; i++)if (state.tokens[i].level === level && state.tokens[i].type === "paragraph_open") {
        state.tokens[i + 2].hidden = true;
        state.tokens[i].hidden = true;
        i += 2;
    }
}
module.exports = function list(state, startLine, endLine, silent) {
    var ch, contentStart, i, indent, indentAfterMarker, initial, isOrdered, itemLines, l, listLines, listTokIdx, markerCharCode, markerValue, max, nextLine, offset, oldListIndent, oldParentType, oldSCount, oldTShift, oldTight, pos, posAfterMarker, prevEmptyEnd, start, terminate, terminatorRules, token, isTerminatingParagraph = false, tight = true;
    // if it's indented more than 3 spaces, it should be a code block
    if (state.sCount[startLine] - state.blkIndent >= 4) return false;
    // Special case:
    //  - item 1
    //   - item 2
    //    - item 3
    //     - item 4
    //      - this one is a paragraph continuation
    if (state.listIndent >= 0 && state.sCount[startLine] - state.listIndent >= 4 && state.sCount[startLine] < state.blkIndent) return false;
    // limit conditions when list can interrupt
    // a paragraph (validation mode only)
    if (silent && state.parentType === "paragraph") // Next list item should still terminate previous list item;
    //
    // This code can fail if plugins use blkIndent as well as lists,
    // but I hope the spec gets fixed long before that happens.
    //
    {
        if (state.sCount[startLine] >= state.blkIndent) isTerminatingParagraph = true;
    }
    // Detect list type and position after marker
    if ((posAfterMarker = $59344d7d9a14e895$var$skipOrderedListMarker(state, startLine)) >= 0) {
        isOrdered = true;
        start = state.bMarks[startLine] + state.tShift[startLine];
        markerValue = Number(state.src.slice(start, posAfterMarker - 1));
        // If we're starting a new ordered list right after
        // a paragraph, it should start with 1.
        if (isTerminatingParagraph && markerValue !== 1) return false;
    } else if ((posAfterMarker = $59344d7d9a14e895$var$skipBulletListMarker(state, startLine)) >= 0) isOrdered = false;
    else return false;
    // If we're starting a new unordered list right after
    // a paragraph, first line should not be empty.
    if (isTerminatingParagraph) {
        if (state.skipSpaces(posAfterMarker) >= state.eMarks[startLine]) return false;
    }
    // We should terminate list on style change. Remember first one to compare.
    markerCharCode = state.src.charCodeAt(posAfterMarker - 1);
    // For validation mode we can terminate immediately
    if (silent) return true;
    // Start list
    listTokIdx = state.tokens.length;
    if (isOrdered) {
        token = state.push("ordered_list_open", "ol", 1);
        if (markerValue !== 1) token.attrs = [
            [
                "start",
                markerValue
            ]
        ];
    } else token = state.push("bullet_list_open", "ul", 1);
    token.map = listLines = [
        startLine,
        0
    ];
    token.markup = String.fromCharCode(markerCharCode);
    //
    // Iterate list items
    //
    nextLine = startLine;
    prevEmptyEnd = false;
    terminatorRules = state.md.block.ruler.getRules("list");
    oldParentType = state.parentType;
    state.parentType = "list";
    while(nextLine < endLine){
        pos = posAfterMarker;
        max = state.eMarks[nextLine];
        initial = offset = state.sCount[nextLine] + posAfterMarker - (state.bMarks[startLine] + state.tShift[startLine]);
        while(pos < max){
            ch = state.src.charCodeAt(pos);
            if (ch === 0x09) offset += 4 - (offset + state.bsCount[nextLine]) % 4;
            else if (ch === 0x20) offset++;
            else break;
            pos++;
        }
        contentStart = pos;
        if (contentStart >= max) // trimming space in "-    \n  3" case, indent is 1 here
        indentAfterMarker = 1;
        else indentAfterMarker = offset - initial;
        // If we have more than 4 spaces, the indent is 1
        // (the rest is just indented code block)
        if (indentAfterMarker > 4) indentAfterMarker = 1;
        // "  -  test"
        //  ^^^^^ - calculating total length of this thing
        indent = initial + indentAfterMarker;
        // Run subparser & write tokens
        token = state.push("list_item_open", "li", 1);
        token.markup = String.fromCharCode(markerCharCode);
        token.map = itemLines = [
            startLine,
            0
        ];
        if (isOrdered) token.info = state.src.slice(start, posAfterMarker - 1);
        // change current state, then restore it after parser subcall
        oldTight = state.tight;
        oldTShift = state.tShift[startLine];
        oldSCount = state.sCount[startLine];
        //  - example list
        // ^ listIndent position will be here
        //   ^ blkIndent position will be here
        //
        oldListIndent = state.listIndent;
        state.listIndent = state.blkIndent;
        state.blkIndent = indent;
        state.tight = true;
        state.tShift[startLine] = contentStart - state.bMarks[startLine];
        state.sCount[startLine] = offset;
        if (contentStart >= max && state.isEmpty(startLine + 1)) // workaround for this case
        // (list item is empty, list terminates before "foo"):
        // ~~~~~~~~
        //   -
        //
        //     foo
        // ~~~~~~~~
        state.line = Math.min(state.line + 2, endLine);
        else state.md.block.tokenize(state, startLine, endLine, true);
        // If any of list item is tight, mark list as tight
        if (!state.tight || prevEmptyEnd) tight = false;
        // Item become loose if finish with empty line,
        // but we should filter last element, because it means list finish
        prevEmptyEnd = state.line - startLine > 1 && state.isEmpty(state.line - 1);
        state.blkIndent = state.listIndent;
        state.listIndent = oldListIndent;
        state.tShift[startLine] = oldTShift;
        state.sCount[startLine] = oldSCount;
        state.tight = oldTight;
        token = state.push("list_item_close", "li", -1);
        token.markup = String.fromCharCode(markerCharCode);
        nextLine = startLine = state.line;
        itemLines[1] = nextLine;
        contentStart = state.bMarks[startLine];
        if (nextLine >= endLine) break;
        //
        // Try to check if list is terminated or continued.
        //
        if (state.sCount[nextLine] < state.blkIndent) break;
        // if it's indented more than 3 spaces, it should be a code block
        if (state.sCount[startLine] - state.blkIndent >= 4) break;
        // fail if terminating block found
        terminate = false;
        for(i = 0, l = terminatorRules.length; i < l; i++)if (terminatorRules[i](state, nextLine, endLine, true)) {
            terminate = true;
            break;
        }
        if (terminate) break;
        // fail if list has another type
        if (isOrdered) {
            posAfterMarker = $59344d7d9a14e895$var$skipOrderedListMarker(state, nextLine);
            if (posAfterMarker < 0) break;
            start = state.bMarks[nextLine] + state.tShift[nextLine];
        } else {
            posAfterMarker = $59344d7d9a14e895$var$skipBulletListMarker(state, nextLine);
            if (posAfterMarker < 0) break;
        }
        if (markerCharCode !== state.src.charCodeAt(posAfterMarker - 1)) break;
    }
    // Finalize list
    if (isOrdered) token = state.push("ordered_list_close", "ol", -1);
    else token = state.push("bullet_list_close", "ul", -1);
    token.markup = String.fromCharCode(markerCharCode);
    listLines[1] = nextLine;
    state.line = nextLine;
    state.parentType = oldParentType;
    // mark paragraphs tight if needed
    if (tight) $59344d7d9a14e895$var$markTightParagraphs(state, listTokIdx);
    return true;
};

});

parcelRequire.register("a0nYv", function(module, exports) {
"use strict";

var $iCsQ9 = parcelRequire("iCsQ9");
var $748c805ef37aaed5$require$normalizeReference = $iCsQ9.normalizeReference;

var $iCsQ9 = parcelRequire("iCsQ9");
var $748c805ef37aaed5$require$isSpace = $iCsQ9.isSpace;
module.exports = function reference(state, startLine, _endLine, silent) {
    var ch, destEndPos, destEndLineNo, endLine, href, i, l, label, labelEnd, oldParentType, res, start, str, terminate, terminatorRules, title, lines = 0, pos = state.bMarks[startLine] + state.tShift[startLine], max = state.eMarks[startLine], nextLine = startLine + 1;
    // if it's indented more than 3 spaces, it should be a code block
    if (state.sCount[startLine] - state.blkIndent >= 4) return false;
    if (state.src.charCodeAt(pos) !== 0x5B /* [ */ ) return false;
    // Simple check to quickly interrupt scan on [link](url) at the start of line.
    // Can be useful on practice: https://github.com/markdown-it/markdown-it/issues/54
    while(++pos < max)if (state.src.charCodeAt(pos) === 0x5D /* ] */  && state.src.charCodeAt(pos - 1) !== 0x5C /* \ */ ) {
        if (pos + 1 === max) return false;
        if (state.src.charCodeAt(pos + 1) !== 0x3A /* : */ ) return false;
        break;
    }
    endLine = state.lineMax;
    // jump line-by-line until empty one or EOF
    terminatorRules = state.md.block.ruler.getRules("reference");
    oldParentType = state.parentType;
    state.parentType = "reference";
    for(; nextLine < endLine && !state.isEmpty(nextLine); nextLine++){
        // this would be a code block normally, but after paragraph
        // it's considered a lazy continuation regardless of what's there
        if (state.sCount[nextLine] - state.blkIndent > 3) continue;
        // quirk for blockquotes, this line should already be checked by that rule
        if (state.sCount[nextLine] < 0) continue;
        // Some tags can terminate paragraph without empty line.
        terminate = false;
        for(i = 0, l = terminatorRules.length; i < l; i++)if (terminatorRules[i](state, nextLine, endLine, true)) {
            terminate = true;
            break;
        }
        if (terminate) break;
    }
    str = state.getLines(startLine, nextLine, state.blkIndent, false).trim();
    max = str.length;
    for(pos = 1; pos < max; pos++){
        ch = str.charCodeAt(pos);
        if (ch === 0x5B /* [ */ ) return false;
        else if (ch === 0x5D /* ] */ ) {
            labelEnd = pos;
            break;
        } else if (ch === 0x0A /* \n */ ) lines++;
        else if (ch === 0x5C /* \ */ ) {
            pos++;
            if (pos < max && str.charCodeAt(pos) === 0x0A) lines++;
        }
    }
    if (labelEnd < 0 || str.charCodeAt(labelEnd + 1) !== 0x3A /* : */ ) return false;
    // [label]:   destination   'title'
    //         ^^^ skip optional whitespace here
    for(pos = labelEnd + 2; pos < max; pos++){
        ch = str.charCodeAt(pos);
        if (ch === 0x0A) lines++;
        else if ($748c805ef37aaed5$require$isSpace(ch)) ;
        else break;
    }
    // [label]:   destination   'title'
    //            ^^^^^^^^^^^ parse this
    res = state.md.helpers.parseLinkDestination(str, pos, max);
    if (!res.ok) return false;
    href = state.md.normalizeLink(res.str);
    if (!state.md.validateLink(href)) return false;
    pos = res.pos;
    lines += res.lines;
    // save cursor state, we could require to rollback later
    destEndPos = pos;
    destEndLineNo = lines;
    // [label]:   destination   'title'
    //                       ^^^ skipping those spaces
    start = pos;
    for(; pos < max; pos++){
        ch = str.charCodeAt(pos);
        if (ch === 0x0A) lines++;
        else if ($748c805ef37aaed5$require$isSpace(ch)) ;
        else break;
    }
    // [label]:   destination   'title'
    //                          ^^^^^^^ parse this
    res = state.md.helpers.parseLinkTitle(str, pos, max);
    if (pos < max && start !== pos && res.ok) {
        title = res.str;
        pos = res.pos;
        lines += res.lines;
    } else {
        title = "";
        pos = destEndPos;
        lines = destEndLineNo;
    }
    // skip trailing spaces until the rest of the line
    while(pos < max){
        ch = str.charCodeAt(pos);
        if (!$748c805ef37aaed5$require$isSpace(ch)) break;
        pos++;
    }
    if (pos < max && str.charCodeAt(pos) !== 0x0A) {
        if (title) {
            // garbage at the end of the line after title,
            // but it could still be a valid reference if we roll back
            title = "";
            pos = destEndPos;
            lines = destEndLineNo;
            while(pos < max){
                ch = str.charCodeAt(pos);
                if (!$748c805ef37aaed5$require$isSpace(ch)) break;
                pos++;
            }
        }
    }
    if (pos < max && str.charCodeAt(pos) !== 0x0A) // garbage at the end of the line
    return false;
    label = $748c805ef37aaed5$require$normalizeReference(str.slice(1, labelEnd));
    if (!label) // CommonMark 0.20 disallows empty labels
    return false;
    // Reference can not terminate anything. This check is for safety only.
    /*istanbul ignore if*/ if (silent) return true;
    if (typeof state.env.references === "undefined") state.env.references = {};
    if (typeof state.env.references[label] === "undefined") state.env.references[label] = {
        title: title,
        href: href
    };
    state.parentType = oldParentType;
    state.line = startLine + lines + 1;
    return true;
};

});

parcelRequire.register("O8JAE", function(module, exports) {
// HTML block
"use strict";

var $hSPzk = parcelRequire("hSPzk");

var $iDMf9 = parcelRequire("iDMf9");
var $096b7214c7a97d82$require$HTML_OPEN_CLOSE_TAG_RE = $iDMf9.HTML_OPEN_CLOSE_TAG_RE;
// An array of opening and corresponding closing sequences for html tags,
// last argument defines whether it can terminate a paragraph or not
//
var $096b7214c7a97d82$var$HTML_SEQUENCES = [
    [
        /^<(script|pre|style|textarea)(?=(\s|>|$))/i,
        /<\/(script|pre|style|textarea)>/i,
        true
    ],
    [
        /^<!--/,
        /-->/,
        true
    ],
    [
        /^<\?/,
        /\?>/,
        true
    ],
    [
        /^<![A-Z]/,
        />/,
        true
    ],
    [
        /^<!\[CDATA\[/,
        /\]\]>/,
        true
    ],
    [
        new RegExp("^</?(" + $hSPzk.join("|") + ")(?=(\\s|/?>|$))", "i"),
        /^$/,
        true
    ],
    [
        new RegExp($096b7214c7a97d82$require$HTML_OPEN_CLOSE_TAG_RE.source + "\\s*$"),
        /^$/,
        false
    ]
];
module.exports = function html_block(state, startLine, endLine, silent) {
    var i, nextLine, token, lineText, pos = state.bMarks[startLine] + state.tShift[startLine], max = state.eMarks[startLine];
    // if it's indented more than 3 spaces, it should be a code block
    if (state.sCount[startLine] - state.blkIndent >= 4) return false;
    if (!state.md.options.html) return false;
    if (state.src.charCodeAt(pos) !== 0x3C /* < */ ) return false;
    lineText = state.src.slice(pos, max);
    for(i = 0; i < $096b7214c7a97d82$var$HTML_SEQUENCES.length; i++){
        if ($096b7214c7a97d82$var$HTML_SEQUENCES[i][0].test(lineText)) break;
    }
    if (i === $096b7214c7a97d82$var$HTML_SEQUENCES.length) return false;
    if (silent) // true if this sequence can be a terminator, false otherwise
    return $096b7214c7a97d82$var$HTML_SEQUENCES[i][2];
    nextLine = startLine + 1;
    // If we are here - we detected HTML block.
    // Let's roll down till block end.
    if (!$096b7214c7a97d82$var$HTML_SEQUENCES[i][1].test(lineText)) for(; nextLine < endLine; nextLine++){
        if (state.sCount[nextLine] < state.blkIndent) break;
        pos = state.bMarks[nextLine] + state.tShift[nextLine];
        max = state.eMarks[nextLine];
        lineText = state.src.slice(pos, max);
        if ($096b7214c7a97d82$var$HTML_SEQUENCES[i][1].test(lineText)) {
            if (lineText.length !== 0) nextLine++;
            break;
        }
    }
    state.line = nextLine;
    token = state.push("html_block", "", 0);
    token.map = [
        startLine,
        nextLine
    ];
    token.content = state.getLines(startLine, nextLine, state.blkIndent, true);
    return true;
};

});
parcelRequire.register("hSPzk", function(module, exports) {
// List of valid html blocks names, accorting to commonmark spec
// http://jgm.github.io/CommonMark/spec.html#html-blocks
"use strict";
module.exports = [
    "address",
    "article",
    "aside",
    "base",
    "basefont",
    "blockquote",
    "body",
    "caption",
    "center",
    "col",
    "colgroup",
    "dd",
    "details",
    "dialog",
    "dir",
    "div",
    "dl",
    "dt",
    "fieldset",
    "figcaption",
    "figure",
    "footer",
    "form",
    "frame",
    "frameset",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "head",
    "header",
    "hr",
    "html",
    "iframe",
    "legend",
    "li",
    "link",
    "main",
    "menu",
    "menuitem",
    "nav",
    "noframes",
    "ol",
    "optgroup",
    "option",
    "p",
    "param",
    "section",
    "source",
    "summary",
    "table",
    "tbody",
    "td",
    "tfoot",
    "th",
    "thead",
    "title",
    "tr",
    "track",
    "ul"
];

});

parcelRequire.register("iDMf9", function(module, exports) {

$parcel$export(module.exports, "HTML_TAG_RE", () => $d9214aa2f3bfe292$export$6db61d2c3a16e419, (v) => $d9214aa2f3bfe292$export$6db61d2c3a16e419 = v);
$parcel$export(module.exports, "HTML_OPEN_CLOSE_TAG_RE", () => $d9214aa2f3bfe292$export$cd48660d06f74639, (v) => $d9214aa2f3bfe292$export$cd48660d06f74639 = v);
// Regexps to match html elements
var $d9214aa2f3bfe292$export$6db61d2c3a16e419;
var $d9214aa2f3bfe292$export$cd48660d06f74639;
"use strict";
var $d9214aa2f3bfe292$var$attr_name = "[a-zA-Z_:][a-zA-Z0-9:._-]*";
var $d9214aa2f3bfe292$var$unquoted = "[^\"'=<>`\\x00-\\x20]+";
var $d9214aa2f3bfe292$var$single_quoted = "'[^']*'";
var $d9214aa2f3bfe292$var$double_quoted = '"[^"]*"';
var $d9214aa2f3bfe292$var$attr_value = "(?:" + $d9214aa2f3bfe292$var$unquoted + "|" + $d9214aa2f3bfe292$var$single_quoted + "|" + $d9214aa2f3bfe292$var$double_quoted + ")";
var $d9214aa2f3bfe292$var$attribute = "(?:\\s+" + $d9214aa2f3bfe292$var$attr_name + "(?:\\s*=\\s*" + $d9214aa2f3bfe292$var$attr_value + ")?)";
var $d9214aa2f3bfe292$var$open_tag = "<[A-Za-z][A-Za-z0-9\\-]*" + $d9214aa2f3bfe292$var$attribute + "*\\s*\\/?>";
var $d9214aa2f3bfe292$var$close_tag = "<\\/[A-Za-z][A-Za-z0-9\\-]*\\s*>";
var $d9214aa2f3bfe292$var$comment = "<!---->|<!--(?:-?[^>-])(?:-?[^-])*-->";
var $d9214aa2f3bfe292$var$processing = "<[?][\\s\\S]*?[?]>";
var $d9214aa2f3bfe292$var$declaration = "<![A-Z]+\\s+[^>]*>";
var $d9214aa2f3bfe292$var$cdata = "<!\\[CDATA\\[[\\s\\S]*?\\]\\]>";
var $d9214aa2f3bfe292$var$HTML_TAG_RE = new RegExp("^(?:" + $d9214aa2f3bfe292$var$open_tag + "|" + $d9214aa2f3bfe292$var$close_tag + "|" + $d9214aa2f3bfe292$var$comment + "|" + $d9214aa2f3bfe292$var$processing + "|" + $d9214aa2f3bfe292$var$declaration + "|" + $d9214aa2f3bfe292$var$cdata + ")");
var $d9214aa2f3bfe292$var$HTML_OPEN_CLOSE_TAG_RE = new RegExp("^(?:" + $d9214aa2f3bfe292$var$open_tag + "|" + $d9214aa2f3bfe292$var$close_tag + ")");
$d9214aa2f3bfe292$export$6db61d2c3a16e419 = $d9214aa2f3bfe292$var$HTML_TAG_RE;
$d9214aa2f3bfe292$export$cd48660d06f74639 = $d9214aa2f3bfe292$var$HTML_OPEN_CLOSE_TAG_RE;

});


parcelRequire.register("5ULm7", function(module, exports) {
// heading (#, ##, ...)
"use strict";

var $iCsQ9 = parcelRequire("iCsQ9");
var $44e6ea8f0fbe73c5$require$isSpace = $iCsQ9.isSpace;
module.exports = function heading(state, startLine, endLine, silent) {
    var ch, level, tmp, token, pos = state.bMarks[startLine] + state.tShift[startLine], max = state.eMarks[startLine];
    // if it's indented more than 3 spaces, it should be a code block
    if (state.sCount[startLine] - state.blkIndent >= 4) return false;
    ch = state.src.charCodeAt(pos);
    if (ch !== 0x23 /* # */  || pos >= max) return false;
    // count heading level
    level = 1;
    ch = state.src.charCodeAt(++pos);
    while(ch === 0x23 /* # */  && pos < max && level <= 6){
        level++;
        ch = state.src.charCodeAt(++pos);
    }
    if (level > 6 || pos < max && !$44e6ea8f0fbe73c5$require$isSpace(ch)) return false;
    if (silent) return true;
    // Let's cut tails like '    ###  ' from the end of string
    max = state.skipSpacesBack(max, pos);
    tmp = state.skipCharsBack(max, 0x23, pos); // #
    if (tmp > pos && $44e6ea8f0fbe73c5$require$isSpace(state.src.charCodeAt(tmp - 1))) max = tmp;
    state.line = startLine + 1;
    token = state.push("heading_open", "h" + String(level), 1);
    token.markup = "########".slice(0, level);
    token.map = [
        startLine,
        state.line
    ];
    token = state.push("inline", "", 0);
    token.content = state.src.slice(pos, max).trim();
    token.map = [
        startLine,
        state.line
    ];
    token.children = [];
    token = state.push("heading_close", "h" + String(level), -1);
    token.markup = "########".slice(0, level);
    return true;
};

});

parcelRequire.register("jynnW", function(module, exports) {
// lheading (---, ===)
"use strict";
module.exports = function lheading(state, startLine, endLine /*, silent*/ ) {
    var content, terminate, i, l, token, pos, max, level, marker, nextLine = startLine + 1, oldParentType, terminatorRules = state.md.block.ruler.getRules("paragraph");
    // if it's indented more than 3 spaces, it should be a code block
    if (state.sCount[startLine] - state.blkIndent >= 4) return false;
    oldParentType = state.parentType;
    state.parentType = "paragraph"; // use paragraph to match terminatorRules
    // jump line-by-line until empty one or EOF
    for(; nextLine < endLine && !state.isEmpty(nextLine); nextLine++){
        // this would be a code block normally, but after paragraph
        // it's considered a lazy continuation regardless of what's there
        if (state.sCount[nextLine] - state.blkIndent > 3) continue;
        //
        // Check for underline in setext header
        //
        if (state.sCount[nextLine] >= state.blkIndent) {
            pos = state.bMarks[nextLine] + state.tShift[nextLine];
            max = state.eMarks[nextLine];
            if (pos < max) {
                marker = state.src.charCodeAt(pos);
                if (marker === 0x2D /* - */  || marker === 0x3D /* = */ ) {
                    pos = state.skipChars(pos, marker);
                    pos = state.skipSpaces(pos);
                    if (pos >= max) {
                        level = marker === 0x3D /* = */  ? 1 : 2;
                        break;
                    }
                }
            }
        }
        // quirk for blockquotes, this line should already be checked by that rule
        if (state.sCount[nextLine] < 0) continue;
        // Some tags can terminate paragraph without empty line.
        terminate = false;
        for(i = 0, l = terminatorRules.length; i < l; i++)if (terminatorRules[i](state, nextLine, endLine, true)) {
            terminate = true;
            break;
        }
        if (terminate) break;
    }
    if (!level) // Didn't find valid underline
    return false;
    content = state.getLines(startLine, nextLine, state.blkIndent, false).trim();
    state.line = nextLine + 1;
    token = state.push("heading_open", "h" + String(level), 1);
    token.markup = String.fromCharCode(marker);
    token.map = [
        startLine,
        state.line
    ];
    token = state.push("inline", "", 0);
    token.content = content;
    token.map = [
        startLine,
        state.line - 1
    ];
    token.children = [];
    token = state.push("heading_close", "h" + String(level), -1);
    token.markup = String.fromCharCode(marker);
    state.parentType = oldParentType;
    return true;
};

});

parcelRequire.register("amKQf", function(module, exports) {
// Paragraph
"use strict";
module.exports = function paragraph(state, startLine /*, endLine*/ ) {
    var content, terminate, i, l, token, oldParentType, nextLine = startLine + 1, terminatorRules = state.md.block.ruler.getRules("paragraph"), endLine = state.lineMax;
    oldParentType = state.parentType;
    state.parentType = "paragraph";
    // jump line-by-line until empty one or EOF
    for(; nextLine < endLine && !state.isEmpty(nextLine); nextLine++){
        // this would be a code block normally, but after paragraph
        // it's considered a lazy continuation regardless of what's there
        if (state.sCount[nextLine] - state.blkIndent > 3) continue;
        // quirk for blockquotes, this line should already be checked by that rule
        if (state.sCount[nextLine] < 0) continue;
        // Some tags can terminate paragraph without empty line.
        terminate = false;
        for(i = 0, l = terminatorRules.length; i < l; i++)if (terminatorRules[i](state, nextLine, endLine, true)) {
            terminate = true;
            break;
        }
        if (terminate) break;
    }
    content = state.getLines(startLine, nextLine, state.blkIndent, false).trim();
    state.line = nextLine;
    token = state.push("paragraph_open", "p", 1);
    token.map = [
        startLine,
        state.line
    ];
    token = state.push("inline", "", 0);
    token.content = content;
    token.map = [
        startLine,
        state.line
    ];
    token.children = [];
    token = state.push("paragraph_close", "p", -1);
    state.parentType = oldParentType;
    return true;
};

});

parcelRequire.register("5Rt0u", function(module, exports) {
// Parser state class
"use strict";

var $6rIm2 = parcelRequire("6rIm2");

var $iCsQ9 = parcelRequire("iCsQ9");
var $44486722e0d28e3c$require$isSpace = $iCsQ9.isSpace;
function $44486722e0d28e3c$var$StateBlock(src, md, env, tokens) {
    var ch, s, start, pos, len, indent, offset, indent_found;
    this.src = src;
    // link to parser instance
    this.md = md;
    this.env = env;
    //
    // Internal state vartiables
    //
    this.tokens = tokens;
    this.bMarks = []; // line begin offsets for fast jumps
    this.eMarks = []; // line end offsets for fast jumps
    this.tShift = []; // offsets of the first non-space characters (tabs not expanded)
    this.sCount = []; // indents for each line (tabs expanded)
    // An amount of virtual spaces (tabs expanded) between beginning
    // of each line (bMarks) and real beginning of that line.
    //
    // It exists only as a hack because blockquotes override bMarks
    // losing information in the process.
    //
    // It's used only when expanding tabs, you can think about it as
    // an initial tab length, e.g. bsCount=21 applied to string `\t123`
    // means first tab should be expanded to 4-21%4 === 3 spaces.
    //
    this.bsCount = [];
    // block parser variables
    this.blkIndent = 0; // required block content indent (for example, if we are
    // inside a list, it would be positioned after list marker)
    this.line = 0; // line index in src
    this.lineMax = 0; // lines count
    this.tight = false; // loose/tight mode for lists
    this.ddIndent = -1; // indent of the current dd block (-1 if there isn't any)
    this.listIndent = -1; // indent of the current list block (-1 if there isn't any)
    // can be 'blockquote', 'list', 'root', 'paragraph' or 'reference'
    // used in lists to determine if they interrupt a paragraph
    this.parentType = "root";
    this.level = 0;
    // renderer
    this.result = "";
    // Create caches
    // Generate markers.
    s = this.src;
    indent_found = false;
    for(start = pos = indent = offset = 0, len = s.length; pos < len; pos++){
        ch = s.charCodeAt(pos);
        if (!indent_found) {
            if ($44486722e0d28e3c$require$isSpace(ch)) {
                indent++;
                if (ch === 0x09) offset += 4 - offset % 4;
                else offset++;
                continue;
            } else indent_found = true;
        }
        if (ch === 0x0A || pos === len - 1) {
            if (ch !== 0x0A) pos++;
            this.bMarks.push(start);
            this.eMarks.push(pos);
            this.tShift.push(indent);
            this.sCount.push(offset);
            this.bsCount.push(0);
            indent_found = false;
            indent = 0;
            offset = 0;
            start = pos + 1;
        }
    }
    // Push fake entry to simplify cache bounds checks
    this.bMarks.push(s.length);
    this.eMarks.push(s.length);
    this.tShift.push(0);
    this.sCount.push(0);
    this.bsCount.push(0);
    this.lineMax = this.bMarks.length - 1; // don't count last fake line
}
// Push new token to "stream".
//
$44486722e0d28e3c$var$StateBlock.prototype.push = function(type, tag, nesting) {
    var token = new $6rIm2(type, tag, nesting);
    token.block = true;
    if (nesting < 0) this.level--; // closing tag
    token.level = this.level;
    if (nesting > 0) this.level++; // opening tag
    this.tokens.push(token);
    return token;
};
$44486722e0d28e3c$var$StateBlock.prototype.isEmpty = function isEmpty(line) {
    return this.bMarks[line] + this.tShift[line] >= this.eMarks[line];
};
$44486722e0d28e3c$var$StateBlock.prototype.skipEmptyLines = function skipEmptyLines(from) {
    for(var max = this.lineMax; from < max; from++){
        if (this.bMarks[from] + this.tShift[from] < this.eMarks[from]) break;
    }
    return from;
};
// Skip spaces from given position.
$44486722e0d28e3c$var$StateBlock.prototype.skipSpaces = function skipSpaces(pos) {
    var ch;
    for(var max = this.src.length; pos < max; pos++){
        ch = this.src.charCodeAt(pos);
        if (!$44486722e0d28e3c$require$isSpace(ch)) break;
    }
    return pos;
};
// Skip spaces from given position in reverse.
$44486722e0d28e3c$var$StateBlock.prototype.skipSpacesBack = function skipSpacesBack(pos, min) {
    if (pos <= min) return pos;
    while(pos > min){
        if (!$44486722e0d28e3c$require$isSpace(this.src.charCodeAt(--pos))) return pos + 1;
    }
    return pos;
};
// Skip char codes from given position
$44486722e0d28e3c$var$StateBlock.prototype.skipChars = function skipChars(pos, code) {
    for(var max = this.src.length; pos < max; pos++){
        if (this.src.charCodeAt(pos) !== code) break;
    }
    return pos;
};
// Skip char codes reverse from given position - 1
$44486722e0d28e3c$var$StateBlock.prototype.skipCharsBack = function skipCharsBack(pos, code, min) {
    if (pos <= min) return pos;
    while(pos > min){
        if (code !== this.src.charCodeAt(--pos)) return pos + 1;
    }
    return pos;
};
// cut lines range from source.
$44486722e0d28e3c$var$StateBlock.prototype.getLines = function getLines(begin, end, indent, keepLastLF) {
    var i, lineIndent, ch, first, last, queue, lineStart, line = begin;
    if (begin >= end) return "";
    queue = new Array(end - begin);
    for(i = 0; line < end; line++, i++){
        lineIndent = 0;
        lineStart = first = this.bMarks[line];
        if (line + 1 < end || keepLastLF) // No need for bounds check because we have fake entry on tail.
        last = this.eMarks[line] + 1;
        else last = this.eMarks[line];
        while(first < last && lineIndent < indent){
            ch = this.src.charCodeAt(first);
            if ($44486722e0d28e3c$require$isSpace(ch)) {
                if (ch === 0x09) lineIndent += 4 - (lineIndent + this.bsCount[line]) % 4;
                else lineIndent++;
            } else if (first - lineStart < this.tShift[line]) // patched tShift masked characters to look like spaces (blockquotes, list markers)
            lineIndent++;
            else break;
            first++;
        }
        if (lineIndent > indent) // partially expanding tabs in code blocks, e.g '\t\tfoobar'
        // with indent=2 becomes '  \tfoobar'
        queue[i] = new Array(lineIndent - indent + 1).join(" ") + this.src.slice(first, last);
        else queue[i] = this.src.slice(first, last);
    }
    return queue.join("");
};
// re-export Token class to use in block rules
$44486722e0d28e3c$var$StateBlock.prototype.Token = $6rIm2;
module.exports = $44486722e0d28e3c$var$StateBlock;

});


parcelRequire.register("ju6pn", function(module, exports) {
/** internal
 * class ParserInline
 *
 * Tokenizes paragraph content.
 **/ "use strict";

var $a3Mkq = parcelRequire("a3Mkq");











////////////////////////////////////////////////////////////////////////////////
// Parser rules
var $e2f5ca37dd3da893$var$_rules = [
    [
        "text",
        (parcelRequire("31OJC"))
    ],
    [
        "newline",
        (parcelRequire("5Orr2"))
    ],
    [
        "escape",
        (parcelRequire("0TCAF"))
    ],
    [
        "backticks",
        (parcelRequire("7khgN"))
    ],
    [
        "strikethrough",
        (parcelRequire("eZjCP")).tokenize
    ],
    [
        "emphasis",
        (parcelRequire("kf9qS")).tokenize
    ],
    [
        "link",
        (parcelRequire("9YLGZ"))
    ],
    [
        "image",
        (parcelRequire("luARG"))
    ],
    [
        "autolink",
        (parcelRequire("hpoaw"))
    ],
    [
        "html_inline",
        (parcelRequire("8aL6Z"))
    ],
    [
        "entity",
        (parcelRequire("jkGtg"))
    ]
];




var $e2f5ca37dd3da893$var$_rules2 = [
    [
        "balance_pairs",
        (parcelRequire("9QXJb"))
    ],
    [
        "strikethrough",
        (parcelRequire("eZjCP")).postProcess
    ],
    [
        "emphasis",
        (parcelRequire("kf9qS")).postProcess
    ],
    [
        "text_collapse",
        (parcelRequire("jBgEZ"))
    ]
];
/**
 * new ParserInline()
 **/ function $e2f5ca37dd3da893$var$ParserInline() {
    var i;
    /**
   * ParserInline#ruler -> Ruler
   *
   * [[Ruler]] instance. Keep configuration of inline rules.
   **/ this.ruler = new $a3Mkq();
    for(i = 0; i < $e2f5ca37dd3da893$var$_rules.length; i++)this.ruler.push($e2f5ca37dd3da893$var$_rules[i][0], $e2f5ca37dd3da893$var$_rules[i][1]);
    /**
   * ParserInline#ruler2 -> Ruler
   *
   * [[Ruler]] instance. Second ruler used for post-processing
   * (e.g. in emphasis-like rules).
   **/ this.ruler2 = new $a3Mkq();
    for(i = 0; i < $e2f5ca37dd3da893$var$_rules2.length; i++)this.ruler2.push($e2f5ca37dd3da893$var$_rules2[i][0], $e2f5ca37dd3da893$var$_rules2[i][1]);
}
// Skip single token by running all rules in validation mode;
// returns `true` if any rule reported success
//
$e2f5ca37dd3da893$var$ParserInline.prototype.skipToken = function(state) {
    var ok, i, pos = state.pos, rules = this.ruler.getRules(""), len = rules.length, maxNesting = state.md.options.maxNesting, cache = state.cache;
    if (typeof cache[pos] !== "undefined") {
        state.pos = cache[pos];
        return;
    }
    if (state.level < maxNesting) for(i = 0; i < len; i++){
        // Increment state.level and decrement it later to limit recursion.
        // It's harmless to do here, because no tokens are created. But ideally,
        // we'd need a separate private state variable for this purpose.
        //
        state.level++;
        ok = rules[i](state, true);
        state.level--;
        if (ok) break;
    }
    else // Too much nesting, just skip until the end of the paragraph.
    //
    // NOTE: this will cause links to behave incorrectly in the following case,
    //       when an amount of `[` is exactly equal to `maxNesting + 1`:
    //
    //       [[[[[[[[[[[[[[[[[[[[[foo]()
    //
    // TODO: remove this workaround when CM standard will allow nested links
    //       (we can replace it by preventing links from being parsed in
    //       validation mode)
    //
    state.pos = state.posMax;
    if (!ok) state.pos++;
    cache[pos] = state.pos;
};
// Generate tokens for input range
//
$e2f5ca37dd3da893$var$ParserInline.prototype.tokenize = function(state) {
    var ok, i, rules = this.ruler.getRules(""), len = rules.length, end = state.posMax, maxNesting = state.md.options.maxNesting;
    while(state.pos < end){
        // Try all possible rules.
        // On success, rule should:
        //
        // - update `state.pos`
        // - update `state.tokens`
        // - return true
        if (state.level < maxNesting) for(i = 0; i < len; i++){
            ok = rules[i](state, false);
            if (ok) break;
        }
        if (ok) {
            if (state.pos >= end) break;
            continue;
        }
        state.pending += state.src[state.pos++];
    }
    if (state.pending) state.pushPending();
};
/**
 * ParserInline.parse(str, md, env, outTokens)
 *
 * Process input string and push inline tokens into `outTokens`
 **/ $e2f5ca37dd3da893$var$ParserInline.prototype.parse = function(str, md, env, outTokens) {
    var i, rules, len;
    var state = new this.State(str, md, env, outTokens);
    this.tokenize(state);
    rules = this.ruler2.getRules("");
    len = rules.length;
    for(i = 0; i < len; i++)rules[i](state);
};

$e2f5ca37dd3da893$var$ParserInline.prototype.State = (parcelRequire("cOGad"));
module.exports = $e2f5ca37dd3da893$var$ParserInline;

});
parcelRequire.register("31OJC", function(module, exports) {
// Skip text characters for text token, place those to pending buffer
// and increment current pos
"use strict";
// Rule to skip pure text
// '{}$%@~+=:' reserved for extentions
// !, ", #, $, %, &, ', (, ), *, +, ,, -, ., /, :, ;, <, =, >, ?, @, [, \, ], ^, _, `, {, |, }, or ~
// !!!! Don't confuse with "Markdown ASCII Punctuation" chars
// http://spec.commonmark.org/0.15/#ascii-punctuation-character
function $2348d1fd7a75a2c8$var$isTerminatorChar(ch) {
    switch(ch){
        case 0x0A /* \n */ :
        case 0x21 /* ! */ :
        case 0x23 /* # */ :
        case 0x24 /* $ */ :
        case 0x25 /* % */ :
        case 0x26 /* & */ :
        case 0x2A /* * */ :
        case 0x2B /* + */ :
        case 0x2D /* - */ :
        case 0x3A /* : */ :
        case 0x3C /* < */ :
        case 0x3D /* = */ :
        case 0x3E /* > */ :
        case 0x40 /* @ */ :
        case 0x5B /* [ */ :
        case 0x5C /* \ */ :
        case 0x5D /* ] */ :
        case 0x5E /* ^ */ :
        case 0x5F /* _ */ :
        case 0x60 /* ` */ :
        case 0x7B /* { */ :
        case 0x7D /* } */ :
        case 0x7E /* ~ */ :
            return true;
        default:
            return false;
    }
}
module.exports = function text(state, silent) {
    var pos = state.pos;
    while(pos < state.posMax && !$2348d1fd7a75a2c8$var$isTerminatorChar(state.src.charCodeAt(pos)))pos++;
    if (pos === state.pos) return false;
    if (!silent) state.pending += state.src.slice(state.pos, pos);
    state.pos = pos;
    return true;
}; // Alternative implementation, for memory.
 //
 // It costs 10% of performance, but allows extend terminators list, if place it
 // to `ParcerInline` property. Probably, will switch to it sometime, such
 // flexibility required.
 /*
var TERMINATOR_RE = /[\n!#$%&*+\-:<=>@[\\\]^_`{}~]/;

module.exports = function text(state, silent) {
  var pos = state.pos,
      idx = state.src.slice(pos).search(TERMINATOR_RE);

  // first char is terminator -> empty text
  if (idx === 0) { return false; }

  // no terminator -> text till end of string
  if (idx < 0) {
    if (!silent) { state.pending += state.src.slice(pos); }
    state.pos = state.src.length;
    return true;
  }

  if (!silent) { state.pending += state.src.slice(pos, pos + idx); }

  state.pos += idx;

  return true;
};*/ 

});

parcelRequire.register("5Orr2", function(module, exports) {
// Proceess '\n'
"use strict";

var $iCsQ9 = parcelRequire("iCsQ9");
var $43b6e7495c0515bf$require$isSpace = $iCsQ9.isSpace;
module.exports = function newline(state, silent) {
    var pmax, max, ws, pos = state.pos;
    if (state.src.charCodeAt(pos) !== 0x0A /* \n */ ) return false;
    pmax = state.pending.length - 1;
    max = state.posMax;
    // '  \n' -> hardbreak
    // Lookup in pending chars is bad practice! Don't copy to other rules!
    // Pending string is stored in concat mode, indexed lookups will cause
    // convertion to flat mode.
    if (!silent) {
        if (pmax >= 0 && state.pending.charCodeAt(pmax) === 0x20) {
            if (pmax >= 1 && state.pending.charCodeAt(pmax - 1) === 0x20) {
                // Find whitespaces tail of pending chars.
                ws = pmax - 1;
                while(ws >= 1 && state.pending.charCodeAt(ws - 1) === 0x20)ws--;
                state.pending = state.pending.slice(0, ws);
                state.push("hardbreak", "br", 0);
            } else {
                state.pending = state.pending.slice(0, -1);
                state.push("softbreak", "br", 0);
            }
        } else state.push("softbreak", "br", 0);
    }
    pos++;
    // skip heading spaces for next line
    while(pos < max && $43b6e7495c0515bf$require$isSpace(state.src.charCodeAt(pos)))pos++;
    state.pos = pos;
    return true;
};

});

parcelRequire.register("0TCAF", function(module, exports) {
// Process escaped chars and hardbreaks
"use strict";

var $iCsQ9 = parcelRequire("iCsQ9");
var $002b257569168e1b$require$isSpace = $iCsQ9.isSpace;
var $002b257569168e1b$var$ESCAPED = [];
for(var $002b257569168e1b$var$i = 0; $002b257569168e1b$var$i < 256; $002b257569168e1b$var$i++)$002b257569168e1b$var$ESCAPED.push(0);
"\\!\"#$%&'()*+,./:;<=>?@[]^_`{|}~-".split("").forEach(function(ch) {
    $002b257569168e1b$var$ESCAPED[ch.charCodeAt(0)] = 1;
});
module.exports = function escape(state, silent) {
    var ch, pos = state.pos, max = state.posMax;
    if (state.src.charCodeAt(pos) !== 0x5C /* \ */ ) return false;
    pos++;
    if (pos < max) {
        ch = state.src.charCodeAt(pos);
        if (ch < 256 && $002b257569168e1b$var$ESCAPED[ch] !== 0) {
            if (!silent) state.pending += state.src[pos];
            state.pos += 2;
            return true;
        }
        if (ch === 0x0A) {
            if (!silent) state.push("hardbreak", "br", 0);
            pos++;
            // skip leading whitespaces from next line
            while(pos < max){
                ch = state.src.charCodeAt(pos);
                if (!$002b257569168e1b$require$isSpace(ch)) break;
                pos++;
            }
            state.pos = pos;
            return true;
        }
    }
    if (!silent) state.pending += "\\";
    state.pos++;
    return true;
};

});

parcelRequire.register("7khgN", function(module, exports) {
// Parse backticks
"use strict";
module.exports = function backtick(state, silent) {
    var start, max, marker, token, matchStart, matchEnd, openerLength, closerLength, pos = state.pos, ch = state.src.charCodeAt(pos);
    if (ch !== 0x60 /* ` */ ) return false;
    start = pos;
    pos++;
    max = state.posMax;
    // scan marker length
    while(pos < max && state.src.charCodeAt(pos) === 0x60 /* ` */ )pos++;
    marker = state.src.slice(start, pos);
    openerLength = marker.length;
    if (state.backticksScanned && (state.backticks[openerLength] || 0) <= start) {
        if (!silent) state.pending += marker;
        state.pos += openerLength;
        return true;
    }
    matchStart = matchEnd = pos;
    // Nothing found in the cache, scan until the end of the line (or until marker is found)
    while((matchStart = state.src.indexOf("`", matchEnd)) !== -1){
        matchEnd = matchStart + 1;
        // scan marker length
        while(matchEnd < max && state.src.charCodeAt(matchEnd) === 0x60 /* ` */ )matchEnd++;
        closerLength = matchEnd - matchStart;
        if (closerLength === openerLength) {
            // Found matching closer length.
            if (!silent) {
                token = state.push("code_inline", "code", 0);
                token.markup = marker;
                token.content = state.src.slice(pos, matchStart).replace(/\n/g, " ").replace(/^ (.+) $/, "$1");
            }
            state.pos = matchEnd;
            return true;
        }
        // Some different length found, put it in cache as upper limit of where closer can be found
        state.backticks[closerLength] = matchStart;
    }
    // Scanned through the end, didn't find anything
    state.backticksScanned = true;
    if (!silent) state.pending += marker;
    state.pos += openerLength;
    return true;
};

});

parcelRequire.register("eZjCP", function(module, exports) {

$parcel$export(module.exports, "tokenize", () => $ae95fc5ef2d22635$export$660b2ee2d4fb4eff, (v) => $ae95fc5ef2d22635$export$660b2ee2d4fb4eff = v);
$parcel$export(module.exports, "postProcess", () => $ae95fc5ef2d22635$export$7b804a0e0ce836d9, (v) => $ae95fc5ef2d22635$export$7b804a0e0ce836d9 = v);
// ~~strike through~~
//
// Insert each marker as a separate text token, and add it to delimiter list
//
var $ae95fc5ef2d22635$export$660b2ee2d4fb4eff;
// Walk through delimiter list and replace text tokens with tags
//
var $ae95fc5ef2d22635$export$7b804a0e0ce836d9;
"use strict";
$ae95fc5ef2d22635$export$660b2ee2d4fb4eff = function strikethrough(state, silent) {
    var i, scanned, token, len, ch, start = state.pos, marker = state.src.charCodeAt(start);
    if (silent) return false;
    if (marker !== 0x7E /* ~ */ ) return false;
    scanned = state.scanDelims(state.pos, true);
    len = scanned.length;
    ch = String.fromCharCode(marker);
    if (len < 2) return false;
    if (len % 2) {
        token = state.push("text", "", 0);
        token.content = ch;
        len--;
    }
    for(i = 0; i < len; i += 2){
        token = state.push("text", "", 0);
        token.content = ch + ch;
        state.delimiters.push({
            marker: marker,
            length: 0,
            token: state.tokens.length - 1,
            end: -1,
            open: scanned.can_open,
            close: scanned.can_close
        });
    }
    state.pos += scanned.length;
    return true;
};
function $ae95fc5ef2d22635$var$postProcess(state, delimiters) {
    var i, j, startDelim, endDelim, token, loneMarkers = [], max = delimiters.length;
    for(i = 0; i < max; i++){
        startDelim = delimiters[i];
        if (startDelim.marker !== 0x7E /* ~ */ ) continue;
        if (startDelim.end === -1) continue;
        endDelim = delimiters[startDelim.end];
        token = state.tokens[startDelim.token];
        token.type = "s_open";
        token.tag = "s";
        token.nesting = 1;
        token.markup = "~~";
        token.content = "";
        token = state.tokens[endDelim.token];
        token.type = "s_close";
        token.tag = "s";
        token.nesting = -1;
        token.markup = "~~";
        token.content = "";
        if (state.tokens[endDelim.token - 1].type === "text" && state.tokens[endDelim.token - 1].content === "~") loneMarkers.push(endDelim.token - 1);
    }
    // If a marker sequence has an odd number of characters, it's splitted
    // like this: `~~~~~` -> `~` + `~~` + `~~`, leaving one marker at the
    // start of the sequence.
    //
    // So, we have to move all those markers after subsequent s_close tags.
    //
    while(loneMarkers.length){
        i = loneMarkers.pop();
        j = i + 1;
        while(j < state.tokens.length && state.tokens[j].type === "s_close")j++;
        j--;
        if (i !== j) {
            token = state.tokens[j];
            state.tokens[j] = state.tokens[i];
            state.tokens[i] = token;
        }
    }
}
$ae95fc5ef2d22635$export$7b804a0e0ce836d9 = function strikethrough(state) {
    var curr, tokens_meta = state.tokens_meta, max = state.tokens_meta.length;
    $ae95fc5ef2d22635$var$postProcess(state, state.delimiters);
    for(curr = 0; curr < max; curr++)if (tokens_meta[curr] && tokens_meta[curr].delimiters) $ae95fc5ef2d22635$var$postProcess(state, tokens_meta[curr].delimiters);
};

});

parcelRequire.register("kf9qS", function(module, exports) {

$parcel$export(module.exports, "tokenize", () => $ebcc8672ee901283$export$660b2ee2d4fb4eff, (v) => $ebcc8672ee901283$export$660b2ee2d4fb4eff = v);
$parcel$export(module.exports, "postProcess", () => $ebcc8672ee901283$export$7b804a0e0ce836d9, (v) => $ebcc8672ee901283$export$7b804a0e0ce836d9 = v);
// Process *this* and _that_
//
// Insert each marker as a separate text token, and add it to delimiter list
//
var $ebcc8672ee901283$export$660b2ee2d4fb4eff;
// Walk through delimiter list and replace text tokens with tags
//
var $ebcc8672ee901283$export$7b804a0e0ce836d9;
"use strict";
$ebcc8672ee901283$export$660b2ee2d4fb4eff = function emphasis(state, silent) {
    var i, scanned, token, start = state.pos, marker = state.src.charCodeAt(start);
    if (silent) return false;
    if (marker !== 0x5F /* _ */  && marker !== 0x2A /* * */ ) return false;
    scanned = state.scanDelims(state.pos, marker === 0x2A);
    for(i = 0; i < scanned.length; i++){
        token = state.push("text", "", 0);
        token.content = String.fromCharCode(marker);
        state.delimiters.push({
            // Char code of the starting marker (number).
            //
            marker: marker,
            // Total length of these series of delimiters.
            //
            length: scanned.length,
            // A position of the token this delimiter corresponds to.
            //
            token: state.tokens.length - 1,
            // If this delimiter is matched as a valid opener, `end` will be
            // equal to its position, otherwise it's `-1`.
            //
            end: -1,
            // Boolean flags that determine if this delimiter could open or close
            // an emphasis.
            //
            open: scanned.can_open,
            close: scanned.can_close
        });
    }
    state.pos += scanned.length;
    return true;
};
function $ebcc8672ee901283$var$postProcess(state, delimiters) {
    var i, startDelim, endDelim, token, ch, isStrong, max = delimiters.length;
    for(i = max - 1; i >= 0; i--){
        startDelim = delimiters[i];
        if (startDelim.marker !== 0x5F /* _ */  && startDelim.marker !== 0x2A /* * */ ) continue;
        // Process only opening markers
        if (startDelim.end === -1) continue;
        endDelim = delimiters[startDelim.end];
        // If the previous delimiter has the same marker and is adjacent to this one,
        // merge those into one strong delimiter.
        //
        // `<em><em>whatever</em></em>` -> `<strong>whatever</strong>`
        //
        isStrong = i > 0 && delimiters[i - 1].end === startDelim.end + 1 && // check that first two markers match and adjacent
        delimiters[i - 1].marker === startDelim.marker && delimiters[i - 1].token === startDelim.token - 1 && // check that last two markers are adjacent (we can safely assume they match)
        delimiters[startDelim.end + 1].token === endDelim.token + 1;
        ch = String.fromCharCode(startDelim.marker);
        token = state.tokens[startDelim.token];
        token.type = isStrong ? "strong_open" : "em_open";
        token.tag = isStrong ? "strong" : "em";
        token.nesting = 1;
        token.markup = isStrong ? ch + ch : ch;
        token.content = "";
        token = state.tokens[endDelim.token];
        token.type = isStrong ? "strong_close" : "em_close";
        token.tag = isStrong ? "strong" : "em";
        token.nesting = -1;
        token.markup = isStrong ? ch + ch : ch;
        token.content = "";
        if (isStrong) {
            state.tokens[delimiters[i - 1].token].content = "";
            state.tokens[delimiters[startDelim.end + 1].token].content = "";
            i--;
        }
    }
}
$ebcc8672ee901283$export$7b804a0e0ce836d9 = function emphasis(state) {
    var curr, tokens_meta = state.tokens_meta, max = state.tokens_meta.length;
    $ebcc8672ee901283$var$postProcess(state, state.delimiters);
    for(curr = 0; curr < max; curr++)if (tokens_meta[curr] && tokens_meta[curr].delimiters) $ebcc8672ee901283$var$postProcess(state, tokens_meta[curr].delimiters);
};

});

parcelRequire.register("9YLGZ", function(module, exports) {
// Process [link](<to> "stuff")
"use strict";

var $iCsQ9 = parcelRequire("iCsQ9");
var $743eb65a8ad58a93$require$normalizeReference = $iCsQ9.normalizeReference;

var $iCsQ9 = parcelRequire("iCsQ9");
var $743eb65a8ad58a93$require$isSpace = $iCsQ9.isSpace;
module.exports = function link(state, silent) {
    var attrs, code, label, labelEnd, labelStart, pos, res, ref, token, href = "", title = "", oldPos = state.pos, max = state.posMax, start = state.pos, parseReference = true;
    if (state.src.charCodeAt(state.pos) !== 0x5B /* [ */ ) return false;
    labelStart = state.pos + 1;
    labelEnd = state.md.helpers.parseLinkLabel(state, state.pos, true);
    // parser failed to find ']', so it's not a valid link
    if (labelEnd < 0) return false;
    pos = labelEnd + 1;
    if (pos < max && state.src.charCodeAt(pos) === 0x28 /* ( */ ) {
        //
        // Inline link
        //
        // might have found a valid shortcut link, disable reference parsing
        parseReference = false;
        // [link](  <href>  "title"  )
        //        ^^ skipping these spaces
        pos++;
        for(; pos < max; pos++){
            code = state.src.charCodeAt(pos);
            if (!$743eb65a8ad58a93$require$isSpace(code) && code !== 0x0A) break;
        }
        if (pos >= max) return false;
        // [link](  <href>  "title"  )
        //          ^^^^^^ parsing link destination
        start = pos;
        res = state.md.helpers.parseLinkDestination(state.src, pos, state.posMax);
        if (res.ok) {
            href = state.md.normalizeLink(res.str);
            if (state.md.validateLink(href)) pos = res.pos;
            else href = "";
            // [link](  <href>  "title"  )
            //                ^^ skipping these spaces
            start = pos;
            for(; pos < max; pos++){
                code = state.src.charCodeAt(pos);
                if (!$743eb65a8ad58a93$require$isSpace(code) && code !== 0x0A) break;
            }
            // [link](  <href>  "title"  )
            //                  ^^^^^^^ parsing link title
            res = state.md.helpers.parseLinkTitle(state.src, pos, state.posMax);
            if (pos < max && start !== pos && res.ok) {
                title = res.str;
                pos = res.pos;
                // [link](  <href>  "title"  )
                //                         ^^ skipping these spaces
                for(; pos < max; pos++){
                    code = state.src.charCodeAt(pos);
                    if (!$743eb65a8ad58a93$require$isSpace(code) && code !== 0x0A) break;
                }
            }
        }
        if (pos >= max || state.src.charCodeAt(pos) !== 0x29 /* ) */ ) // parsing a valid shortcut link failed, fallback to reference
        parseReference = true;
        pos++;
    }
    if (parseReference) {
        //
        // Link reference
        //
        if (typeof state.env.references === "undefined") return false;
        if (pos < max && state.src.charCodeAt(pos) === 0x5B /* [ */ ) {
            start = pos + 1;
            pos = state.md.helpers.parseLinkLabel(state, pos);
            if (pos >= 0) label = state.src.slice(start, pos++);
            else pos = labelEnd + 1;
        } else pos = labelEnd + 1;
        // covers label === '' and label === undefined
        // (collapsed reference link and shortcut reference link respectively)
        if (!label) label = state.src.slice(labelStart, labelEnd);
        ref = state.env.references[$743eb65a8ad58a93$require$normalizeReference(label)];
        if (!ref) {
            state.pos = oldPos;
            return false;
        }
        href = ref.href;
        title = ref.title;
    }
    //
    // We found the end of the link, and know for a fact it's a valid link;
    // so all that's left to do is to call tokenizer.
    //
    if (!silent) {
        state.pos = labelStart;
        state.posMax = labelEnd;
        token = state.push("link_open", "a", 1);
        token.attrs = attrs = [
            [
                "href",
                href
            ]
        ];
        if (title) attrs.push([
            "title",
            title
        ]);
        state.md.inline.tokenize(state);
        token = state.push("link_close", "a", -1);
    }
    state.pos = pos;
    state.posMax = max;
    return true;
};

});

parcelRequire.register("luARG", function(module, exports) {
// Process ![image](<src> "title")
"use strict";

var $iCsQ9 = parcelRequire("iCsQ9");
var $fa58feed6b6c37e1$require$normalizeReference = $iCsQ9.normalizeReference;

var $iCsQ9 = parcelRequire("iCsQ9");
var $fa58feed6b6c37e1$require$isSpace = $iCsQ9.isSpace;
module.exports = function image(state, silent) {
    var attrs, code, content, label, labelEnd, labelStart, pos, ref, res, title, token, tokens, start, href = "", oldPos = state.pos, max = state.posMax;
    if (state.src.charCodeAt(state.pos) !== 0x21 /* ! */ ) return false;
    if (state.src.charCodeAt(state.pos + 1) !== 0x5B /* [ */ ) return false;
    labelStart = state.pos + 2;
    labelEnd = state.md.helpers.parseLinkLabel(state, state.pos + 1, false);
    // parser failed to find ']', so it's not a valid link
    if (labelEnd < 0) return false;
    pos = labelEnd + 1;
    if (pos < max && state.src.charCodeAt(pos) === 0x28 /* ( */ ) {
        //
        // Inline link
        //
        // [link](  <href>  "title"  )
        //        ^^ skipping these spaces
        pos++;
        for(; pos < max; pos++){
            code = state.src.charCodeAt(pos);
            if (!$fa58feed6b6c37e1$require$isSpace(code) && code !== 0x0A) break;
        }
        if (pos >= max) return false;
        // [link](  <href>  "title"  )
        //          ^^^^^^ parsing link destination
        start = pos;
        res = state.md.helpers.parseLinkDestination(state.src, pos, state.posMax);
        if (res.ok) {
            href = state.md.normalizeLink(res.str);
            if (state.md.validateLink(href)) pos = res.pos;
            else href = "";
        }
        // [link](  <href>  "title"  )
        //                ^^ skipping these spaces
        start = pos;
        for(; pos < max; pos++){
            code = state.src.charCodeAt(pos);
            if (!$fa58feed6b6c37e1$require$isSpace(code) && code !== 0x0A) break;
        }
        // [link](  <href>  "title"  )
        //                  ^^^^^^^ parsing link title
        res = state.md.helpers.parseLinkTitle(state.src, pos, state.posMax);
        if (pos < max && start !== pos && res.ok) {
            title = res.str;
            pos = res.pos;
            // [link](  <href>  "title"  )
            //                         ^^ skipping these spaces
            for(; pos < max; pos++){
                code = state.src.charCodeAt(pos);
                if (!$fa58feed6b6c37e1$require$isSpace(code) && code !== 0x0A) break;
            }
        } else title = "";
        if (pos >= max || state.src.charCodeAt(pos) !== 0x29 /* ) */ ) {
            state.pos = oldPos;
            return false;
        }
        pos++;
    } else {
        //
        // Link reference
        //
        if (typeof state.env.references === "undefined") return false;
        if (pos < max && state.src.charCodeAt(pos) === 0x5B /* [ */ ) {
            start = pos + 1;
            pos = state.md.helpers.parseLinkLabel(state, pos);
            if (pos >= 0) label = state.src.slice(start, pos++);
            else pos = labelEnd + 1;
        } else pos = labelEnd + 1;
        // covers label === '' and label === undefined
        // (collapsed reference link and shortcut reference link respectively)
        if (!label) label = state.src.slice(labelStart, labelEnd);
        ref = state.env.references[$fa58feed6b6c37e1$require$normalizeReference(label)];
        if (!ref) {
            state.pos = oldPos;
            return false;
        }
        href = ref.href;
        title = ref.title;
    }
    //
    // We found the end of the link, and know for a fact it's a valid link;
    // so all that's left to do is to call tokenizer.
    //
    if (!silent) {
        content = state.src.slice(labelStart, labelEnd);
        state.md.inline.parse(content, state.md, state.env, tokens = []);
        token = state.push("image", "img", 0);
        token.attrs = attrs = [
            [
                "src",
                href
            ],
            [
                "alt",
                ""
            ]
        ];
        token.children = tokens;
        token.content = content;
        if (title) attrs.push([
            "title",
            title
        ]);
    }
    state.pos = pos;
    state.posMax = max;
    return true;
};

});

parcelRequire.register("hpoaw", function(module, exports) {
// Process autolinks '<protocol:...>'
"use strict";
/*eslint max-len:0*/ var $cac784dfe539c4db$var$EMAIL_RE = /^([a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*)$/;
var $cac784dfe539c4db$var$AUTOLINK_RE = /^([a-zA-Z][a-zA-Z0-9+.\-]{1,31}):([^<>\x00-\x20]*)$/;
module.exports = function autolink(state, silent) {
    var url, fullUrl, token, ch, start, max, pos = state.pos;
    if (state.src.charCodeAt(pos) !== 0x3C /* < */ ) return false;
    start = state.pos;
    max = state.posMax;
    for(;;){
        if (++pos >= max) return false;
        ch = state.src.charCodeAt(pos);
        if (ch === 0x3C /* < */ ) return false;
        if (ch === 0x3E /* > */ ) break;
    }
    url = state.src.slice(start + 1, pos);
    if ($cac784dfe539c4db$var$AUTOLINK_RE.test(url)) {
        fullUrl = state.md.normalizeLink(url);
        if (!state.md.validateLink(fullUrl)) return false;
        if (!silent) {
            token = state.push("link_open", "a", 1);
            token.attrs = [
                [
                    "href",
                    fullUrl
                ]
            ];
            token.markup = "autolink";
            token.info = "auto";
            token = state.push("text", "", 0);
            token.content = state.md.normalizeLinkText(url);
            token = state.push("link_close", "a", -1);
            token.markup = "autolink";
            token.info = "auto";
        }
        state.pos += url.length + 2;
        return true;
    }
    if ($cac784dfe539c4db$var$EMAIL_RE.test(url)) {
        fullUrl = state.md.normalizeLink("mailto:" + url);
        if (!state.md.validateLink(fullUrl)) return false;
        if (!silent) {
            token = state.push("link_open", "a", 1);
            token.attrs = [
                [
                    "href",
                    fullUrl
                ]
            ];
            token.markup = "autolink";
            token.info = "auto";
            token = state.push("text", "", 0);
            token.content = state.md.normalizeLinkText(url);
            token = state.push("link_close", "a", -1);
            token.markup = "autolink";
            token.info = "auto";
        }
        state.pos += url.length + 2;
        return true;
    }
    return false;
};

});

parcelRequire.register("8aL6Z", function(module, exports) {
// Process html tags
"use strict";

var $iDMf9 = parcelRequire("iDMf9");
var $5f33cd49aa9bf778$require$HTML_TAG_RE = $iDMf9.HTML_TAG_RE;
function $5f33cd49aa9bf778$var$isLetter(ch) {
    /*eslint no-bitwise:0*/ var lc = ch | 0x20; // to lower case
    return lc >= 0x61 /* a */  && lc <= 0x7a /* z */ ;
}
module.exports = function html_inline(state, silent) {
    var ch, match, max, token, pos = state.pos;
    if (!state.md.options.html) return false;
    // Check start
    max = state.posMax;
    if (state.src.charCodeAt(pos) !== 0x3C /* < */  || pos + 2 >= max) return false;
    // Quick fail on second char
    ch = state.src.charCodeAt(pos + 1);
    if (ch !== 0x21 /* ! */  && ch !== 0x3F /* ? */  && ch !== 0x2F /* / */  && !$5f33cd49aa9bf778$var$isLetter(ch)) return false;
    match = state.src.slice(pos).match($5f33cd49aa9bf778$require$HTML_TAG_RE);
    if (!match) return false;
    if (!silent) {
        token = state.push("html_inline", "", 0);
        token.content = state.src.slice(pos, pos + match[0].length);
    }
    state.pos += match[0].length;
    return true;
};

});

parcelRequire.register("jkGtg", function(module, exports) {
// Process html entity - &#123;, &#xAF;, &quot;, ...
"use strict";

var $6FYMy = parcelRequire("6FYMy");

var $iCsQ9 = parcelRequire("iCsQ9");
var $e130d470e90d33b8$require$has = $iCsQ9.has;

var $iCsQ9 = parcelRequire("iCsQ9");
var $e130d470e90d33b8$require$isValidEntityCode = $iCsQ9.isValidEntityCode;

var $iCsQ9 = parcelRequire("iCsQ9");
var $e130d470e90d33b8$require$fromCodePoint = $iCsQ9.fromCodePoint;
var $e130d470e90d33b8$var$DIGITAL_RE = /^&#((?:x[a-f0-9]{1,6}|[0-9]{1,7}));/i;
var $e130d470e90d33b8$var$NAMED_RE = /^&([a-z][a-z0-9]{1,31});/i;
module.exports = function entity(state, silent) {
    var ch, code, match, pos = state.pos, max = state.posMax;
    if (state.src.charCodeAt(pos) !== 0x26 /* & */ ) return false;
    if (pos + 1 < max) {
        ch = state.src.charCodeAt(pos + 1);
        if (ch === 0x23 /* # */ ) {
            match = state.src.slice(pos).match($e130d470e90d33b8$var$DIGITAL_RE);
            if (match) {
                if (!silent) {
                    code = match[1][0].toLowerCase() === "x" ? parseInt(match[1].slice(1), 16) : parseInt(match[1], 10);
                    state.pending += $e130d470e90d33b8$require$isValidEntityCode(code) ? $e130d470e90d33b8$require$fromCodePoint(code) : $e130d470e90d33b8$require$fromCodePoint(0xFFFD);
                }
                state.pos += match[0].length;
                return true;
            }
        } else {
            match = state.src.slice(pos).match($e130d470e90d33b8$var$NAMED_RE);
            if (match) {
                if ($e130d470e90d33b8$require$has($6FYMy, match[1])) {
                    if (!silent) state.pending += $6FYMy[match[1]];
                    state.pos += match[0].length;
                    return true;
                }
            }
        }
    }
    if (!silent) state.pending += "&";
    state.pos++;
    return true;
};

});

parcelRequire.register("9QXJb", function(module, exports) {
// For each opening emphasis-like marker find a matching closing one
//
"use strict";
function $72c74d115b41a563$var$processDelimiters(state, delimiters) {
    var closerIdx, openerIdx, closer, opener, minOpenerIdx, newMinOpenerIdx, isOddMatch, lastJump, openersBottom = {}, max = delimiters.length;
    if (!max) return;
    // headerIdx is the first delimiter of the current (where closer is) delimiter run
    var headerIdx = 0;
    var lastTokenIdx = -2; // needs any value lower than -1
    var jumps = [];
    for(closerIdx = 0; closerIdx < max; closerIdx++){
        closer = delimiters[closerIdx];
        jumps.push(0);
        // markers belong to same delimiter run if:
        //  - they have adjacent tokens
        //  - AND markers are the same
        //
        if (delimiters[headerIdx].marker !== closer.marker || lastTokenIdx !== closer.token - 1) headerIdx = closerIdx;
        lastTokenIdx = closer.token;
        // Length is only used for emphasis-specific "rule of 3",
        // if it's not defined (in strikethrough or 3rd party plugins),
        // we can default it to 0 to disable those checks.
        //
        closer.length = closer.length || 0;
        if (!closer.close) continue;
        // Previously calculated lower bounds (previous fails)
        // for each marker, each delimiter length modulo 3,
        // and for whether this closer can be an opener;
        // https://github.com/commonmark/cmark/commit/34250e12ccebdc6372b8b49c44fab57c72443460
        if (!openersBottom.hasOwnProperty(closer.marker)) openersBottom[closer.marker] = [
            -1,
            -1,
            -1,
            -1,
            -1,
            -1
        ];
        minOpenerIdx = openersBottom[closer.marker][(closer.open ? 3 : 0) + closer.length % 3];
        openerIdx = headerIdx - jumps[headerIdx] - 1;
        newMinOpenerIdx = openerIdx;
        for(; openerIdx > minOpenerIdx; openerIdx -= jumps[openerIdx] + 1){
            opener = delimiters[openerIdx];
            if (opener.marker !== closer.marker) continue;
            if (opener.open && opener.end < 0) {
                isOddMatch = false;
                // from spec:
                //
                // If one of the delimiters can both open and close emphasis, then the
                // sum of the lengths of the delimiter runs containing the opening and
                // closing delimiters must not be a multiple of 3 unless both lengths
                // are multiples of 3.
                //
                if (opener.close || closer.open) {
                    if ((opener.length + closer.length) % 3 === 0) {
                        if (opener.length % 3 !== 0 || closer.length % 3 !== 0) isOddMatch = true;
                    }
                }
                if (!isOddMatch) {
                    // If previous delimiter cannot be an opener, we can safely skip
                    // the entire sequence in future checks. This is required to make
                    // sure algorithm has linear complexity (see *_*_*_*_*_... case).
                    //
                    lastJump = openerIdx > 0 && !delimiters[openerIdx - 1].open ? jumps[openerIdx - 1] + 1 : 0;
                    jumps[closerIdx] = closerIdx - openerIdx + lastJump;
                    jumps[openerIdx] = lastJump;
                    closer.open = false;
                    opener.end = closerIdx;
                    opener.close = false;
                    newMinOpenerIdx = -1;
                    // treat next token as start of run,
                    // it optimizes skips in **<...>**a**<...>** pathological case
                    lastTokenIdx = -2;
                    break;
                }
            }
        }
        if (newMinOpenerIdx !== -1) // If match for this delimiter run failed, we want to set lower bound for
        // future lookups. This is required to make sure algorithm has linear
        // complexity.
        //
        // See details here:
        // https://github.com/commonmark/cmark/issues/178#issuecomment-270417442
        //
        openersBottom[closer.marker][(closer.open ? 3 : 0) + (closer.length || 0) % 3] = newMinOpenerIdx;
    }
}
module.exports = function link_pairs(state) {
    var curr, tokens_meta = state.tokens_meta, max = state.tokens_meta.length;
    $72c74d115b41a563$var$processDelimiters(state, state.delimiters);
    for(curr = 0; curr < max; curr++)if (tokens_meta[curr] && tokens_meta[curr].delimiters) $72c74d115b41a563$var$processDelimiters(state, tokens_meta[curr].delimiters);
};

});

parcelRequire.register("jBgEZ", function(module, exports) {
// Clean up tokens after emphasis and strikethrough postprocessing:
// merge adjacent text nodes into one and re-calculate all token levels
//
// This is necessary because initially emphasis delimiter markers (*, _, ~)
// are treated as their own separate text tokens. Then emphasis rule either
// leaves them as text (needed to merge with adjacent text) or turns them
// into opening/closing tags (which messes up levels inside).
//
"use strict";
module.exports = function text_collapse(state) {
    var curr, last, level = 0, tokens = state.tokens, max = state.tokens.length;
    for(curr = last = 0; curr < max; curr++){
        // re-calculate levels after emphasis/strikethrough turns some text nodes
        // into opening/closing tags
        if (tokens[curr].nesting < 0) level--; // closing tag
        tokens[curr].level = level;
        if (tokens[curr].nesting > 0) level++; // opening tag
        if (tokens[curr].type === "text" && curr + 1 < max && tokens[curr + 1].type === "text") // collapse two adjacent text nodes
        tokens[curr + 1].content = tokens[curr].content + tokens[curr + 1].content;
        else {
            if (curr !== last) tokens[last] = tokens[curr];
            last++;
        }
    }
    if (curr !== last) tokens.length = last;
};

});

parcelRequire.register("cOGad", function(module, exports) {
// Inline parser state
"use strict";

var $6rIm2 = parcelRequire("6rIm2");

var $iCsQ9 = parcelRequire("iCsQ9");
var $954adc6772480b3e$require$isWhiteSpace = $iCsQ9.isWhiteSpace;

var $iCsQ9 = parcelRequire("iCsQ9");
var $954adc6772480b3e$require$isPunctChar = $iCsQ9.isPunctChar;

var $iCsQ9 = parcelRequire("iCsQ9");
var $954adc6772480b3e$require$isMdAsciiPunct = $iCsQ9.isMdAsciiPunct;
function $954adc6772480b3e$var$StateInline(src, md, env, outTokens) {
    this.src = src;
    this.env = env;
    this.md = md;
    this.tokens = outTokens;
    this.tokens_meta = Array(outTokens.length);
    this.pos = 0;
    this.posMax = this.src.length;
    this.level = 0;
    this.pending = "";
    this.pendingLevel = 0;
    // Stores { start: end } pairs. Useful for backtrack
    // optimization of pairs parse (emphasis, strikes).
    this.cache = {};
    // List of emphasis-like delimiters for current tag
    this.delimiters = [];
    // Stack of delimiter lists for upper level tags
    this._prev_delimiters = [];
    // backtick length => last seen position
    this.backticks = {};
    this.backticksScanned = false;
}
// Flush pending text
//
$954adc6772480b3e$var$StateInline.prototype.pushPending = function() {
    var token = new $6rIm2("text", "", 0);
    token.content = this.pending;
    token.level = this.pendingLevel;
    this.tokens.push(token);
    this.pending = "";
    return token;
};
// Push new token to "stream".
// If pending text exists - flush it as text token
//
$954adc6772480b3e$var$StateInline.prototype.push = function(type, tag, nesting) {
    if (this.pending) this.pushPending();
    var token = new $6rIm2(type, tag, nesting);
    var token_meta = null;
    if (nesting < 0) {
        // closing tag
        this.level--;
        this.delimiters = this._prev_delimiters.pop();
    }
    token.level = this.level;
    if (nesting > 0) {
        // opening tag
        this.level++;
        this._prev_delimiters.push(this.delimiters);
        this.delimiters = [];
        token_meta = {
            delimiters: this.delimiters
        };
    }
    this.pendingLevel = this.level;
    this.tokens.push(token);
    this.tokens_meta.push(token_meta);
    return token;
};
// Scan a sequence of emphasis-like markers, and determine whether
// it can start an emphasis sequence or end an emphasis sequence.
//
//  - start - position to scan from (it should point at a valid marker);
//  - canSplitWord - determine if these markers can be found inside a word
//
$954adc6772480b3e$var$StateInline.prototype.scanDelims = function(start, canSplitWord) {
    var pos = start, lastChar, nextChar, count, can_open, can_close, isLastWhiteSpace, isLastPunctChar, isNextWhiteSpace, isNextPunctChar, left_flanking = true, right_flanking = true, max = this.posMax, marker = this.src.charCodeAt(start);
    // treat beginning of the line as a whitespace
    lastChar = start > 0 ? this.src.charCodeAt(start - 1) : 0x20;
    while(pos < max && this.src.charCodeAt(pos) === marker)pos++;
    count = pos - start;
    // treat end of the line as a whitespace
    nextChar = pos < max ? this.src.charCodeAt(pos) : 0x20;
    isLastPunctChar = $954adc6772480b3e$require$isMdAsciiPunct(lastChar) || $954adc6772480b3e$require$isPunctChar(String.fromCharCode(lastChar));
    isNextPunctChar = $954adc6772480b3e$require$isMdAsciiPunct(nextChar) || $954adc6772480b3e$require$isPunctChar(String.fromCharCode(nextChar));
    isLastWhiteSpace = $954adc6772480b3e$require$isWhiteSpace(lastChar);
    isNextWhiteSpace = $954adc6772480b3e$require$isWhiteSpace(nextChar);
    if (isNextWhiteSpace) left_flanking = false;
    else if (isNextPunctChar) {
        if (!(isLastWhiteSpace || isLastPunctChar)) left_flanking = false;
    }
    if (isLastWhiteSpace) right_flanking = false;
    else if (isLastPunctChar) {
        if (!(isNextWhiteSpace || isNextPunctChar)) right_flanking = false;
    }
    if (!canSplitWord) {
        can_open = left_flanking && (!right_flanking || isLastPunctChar);
        can_close = right_flanking && (!left_flanking || isNextPunctChar);
    } else {
        can_open = left_flanking;
        can_close = right_flanking;
    }
    return {
        can_open: can_open,
        can_close: can_close,
        length: count
    };
};
// re-export Token class to use in block rules
$954adc6772480b3e$var$StateInline.prototype.Token = $6rIm2;
module.exports = $954adc6772480b3e$var$StateInline;

});


parcelRequire.register("g1DP7", function(module, exports) {
"use strict";
////////////////////////////////////////////////////////////////////////////////
// Helpers
// Merge objects
//
function $baaba17503483954$var$assign(obj /*from1, from2, from3, ...*/ ) {
    var sources = Array.prototype.slice.call(arguments, 1);
    sources.forEach(function(source) {
        if (!source) return;
        Object.keys(source).forEach(function(key) {
            obj[key] = source[key];
        });
    });
    return obj;
}
function $baaba17503483954$var$_class(obj) {
    return Object.prototype.toString.call(obj);
}
function $baaba17503483954$var$isString(obj) {
    return $baaba17503483954$var$_class(obj) === "[object String]";
}
function $baaba17503483954$var$isObject(obj) {
    return $baaba17503483954$var$_class(obj) === "[object Object]";
}
function $baaba17503483954$var$isRegExp(obj) {
    return $baaba17503483954$var$_class(obj) === "[object RegExp]";
}
function $baaba17503483954$var$isFunction(obj) {
    return $baaba17503483954$var$_class(obj) === "[object Function]";
}
function $baaba17503483954$var$escapeRE(str) {
    return str.replace(/[.?*+^$[\]\\(){}|-]/g, "\\$&");
}
////////////////////////////////////////////////////////////////////////////////
var $baaba17503483954$var$defaultOptions = {
    fuzzyLink: true,
    fuzzyEmail: true,
    fuzzyIP: false
};
function $baaba17503483954$var$isOptionsObj(obj) {
    return Object.keys(obj || {}).reduce(function(acc, k) {
        return acc || $baaba17503483954$var$defaultOptions.hasOwnProperty(k);
    }, false);
}
var $baaba17503483954$var$defaultSchemas = {
    "http:": {
        validate: function(text, pos, self) {
            var tail = text.slice(pos);
            if (!self.re.http) // compile lazily, because "host"-containing variables can change on tlds update.
            self.re.http = new RegExp("^\\/\\/" + self.re.src_auth + self.re.src_host_port_strict + self.re.src_path, "i");
            if (self.re.http.test(tail)) return tail.match(self.re.http)[0].length;
            return 0;
        }
    },
    "https:": "http:",
    "ftp:": "http:",
    "//": {
        validate: function(text, pos, self) {
            var tail = text.slice(pos);
            if (!self.re.no_http) // compile lazily, because "host"-containing variables can change on tlds update.
            self.re.no_http = new RegExp("^" + self.re.src_auth + // Don't allow single-level domains, because of false positives like '//test'
            // with code comments
            "(?:localhost|(?:(?:" + self.re.src_domain + ")\\.)+" + self.re.src_domain_root + ")" + self.re.src_port + self.re.src_host_terminator + self.re.src_path, "i");
            if (self.re.no_http.test(tail)) {
                // should not be `://` & `///`, that protects from errors in protocol name
                if (pos >= 3 && text[pos - 3] === ":") return 0;
                if (pos >= 3 && text[pos - 3] === "/") return 0;
                return tail.match(self.re.no_http)[0].length;
            }
            return 0;
        }
    },
    "mailto:": {
        validate: function(text, pos, self) {
            var tail = text.slice(pos);
            if (!self.re.mailto) self.re.mailto = new RegExp("^" + self.re.src_email_name + "@" + self.re.src_host_strict, "i");
            if (self.re.mailto.test(tail)) return tail.match(self.re.mailto)[0].length;
            return 0;
        }
    }
};
/*eslint-disable max-len*/ // RE pattern for 2-character tlds (autogenerated by ./support/tlds_2char_gen.js)
var $baaba17503483954$var$tlds_2ch_src_re = "a[cdefgilmnoqrstuwxz]|b[abdefghijmnorstvwyz]|c[acdfghiklmnoruvwxyz]|d[ejkmoz]|e[cegrstu]|f[ijkmor]|g[abdefghilmnpqrstuwy]|h[kmnrtu]|i[delmnoqrst]|j[emop]|k[eghimnprwyz]|l[abcikrstuvy]|m[acdeghklmnopqrstuvwxyz]|n[acefgilopruz]|om|p[aefghklmnrstwy]|qa|r[eosuw]|s[abcdeghijklmnortuvxyz]|t[cdfghjklmnortvwz]|u[agksyz]|v[aceginu]|w[fs]|y[et]|z[amw]";
// DON'T try to make PRs with changes. Extend TLDs with LinkifyIt.tlds() instead
var $baaba17503483954$var$tlds_default = "biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|рф".split("|");
/*eslint-enable max-len*/ ////////////////////////////////////////////////////////////////////////////////
function $baaba17503483954$var$resetScanCache(self) {
    self.__index__ = -1;
    self.__text_cache__ = "";
}
function $baaba17503483954$var$createValidator(re) {
    return function(text, pos) {
        var tail = text.slice(pos);
        if (re.test(tail)) return tail.match(re)[0].length;
        return 0;
    };
}
function $baaba17503483954$var$createNormalizer() {
    return function(match, self) {
        self.normalize(match);
    };
}

// Schemas compiler. Build regexps.
//
function $baaba17503483954$var$compile(self) {
    // Load & clone RE patterns.
    var re = self.re = (parcelRequire("7qzF9"))(self.__opts__);
    // Define dynamic patterns
    var tlds = self.__tlds__.slice();
    self.onCompile();
    if (!self.__tlds_replaced__) tlds.push($baaba17503483954$var$tlds_2ch_src_re);
    tlds.push(re.src_xn);
    re.src_tlds = tlds.join("|");
    function untpl(tpl) {
        return tpl.replace("%TLDS%", re.src_tlds);
    }
    re.email_fuzzy = RegExp(untpl(re.tpl_email_fuzzy), "i");
    re.link_fuzzy = RegExp(untpl(re.tpl_link_fuzzy), "i");
    re.link_no_ip_fuzzy = RegExp(untpl(re.tpl_link_no_ip_fuzzy), "i");
    re.host_fuzzy_test = RegExp(untpl(re.tpl_host_fuzzy_test), "i");
    //
    // Compile each schema
    //
    var aliases = [];
    self.__compiled__ = {}; // Reset compiled data
    function schemaError(name, val) {
        throw new Error('(LinkifyIt) Invalid schema "' + name + '": ' + val);
    }
    Object.keys(self.__schemas__).forEach(function(name) {
        var val = self.__schemas__[name];
        // skip disabled methods
        if (val === null) return;
        var compiled = {
            validate: null,
            link: null
        };
        self.__compiled__[name] = compiled;
        if ($baaba17503483954$var$isObject(val)) {
            if ($baaba17503483954$var$isRegExp(val.validate)) compiled.validate = $baaba17503483954$var$createValidator(val.validate);
            else if ($baaba17503483954$var$isFunction(val.validate)) compiled.validate = val.validate;
            else schemaError(name, val);
            if ($baaba17503483954$var$isFunction(val.normalize)) compiled.normalize = val.normalize;
            else if (!val.normalize) compiled.normalize = $baaba17503483954$var$createNormalizer();
            else schemaError(name, val);
            return;
        }
        if ($baaba17503483954$var$isString(val)) {
            aliases.push(name);
            return;
        }
        schemaError(name, val);
    });
    //
    // Compile postponed aliases
    //
    aliases.forEach(function(alias) {
        if (!self.__compiled__[self.__schemas__[alias]]) // Silently fail on missed schemas to avoid errons on disable.
        // schemaError(alias, self.__schemas__[alias]);
        return;
        self.__compiled__[alias].validate = self.__compiled__[self.__schemas__[alias]].validate;
        self.__compiled__[alias].normalize = self.__compiled__[self.__schemas__[alias]].normalize;
    });
    //
    // Fake record for guessed links
    //
    self.__compiled__[""] = {
        validate: null,
        normalize: $baaba17503483954$var$createNormalizer()
    };
    //
    // Build schema condition
    //
    var slist = Object.keys(self.__compiled__).filter(function(name) {
        // Filter disabled & fake schemas
        return name.length > 0 && self.__compiled__[name];
    }).map($baaba17503483954$var$escapeRE).join("|");
    // (?!_) cause 1.5x slowdown
    self.re.schema_test = RegExp("(^|(?!_)(?:[><｜]|" + re.src_ZPCc + "))(" + slist + ")", "i");
    self.re.schema_search = RegExp("(^|(?!_)(?:[><｜]|" + re.src_ZPCc + "))(" + slist + ")", "ig");
    self.re.pretest = RegExp("(" + self.re.schema_test.source + ")|(" + self.re.host_fuzzy_test.source + ")|@", "i");
    //
    // Cleanup
    //
    $baaba17503483954$var$resetScanCache(self);
}
/**
 * class Match
 *
 * Match result. Single element of array, returned by [[LinkifyIt#match]]
 **/ function $baaba17503483954$var$Match(self, shift) {
    var start = self.__index__, end = self.__last_index__, text = self.__text_cache__.slice(start, end);
    /**
   * Match#schema -> String
   *
   * Prefix (protocol) for matched string.
   **/ this.schema = self.__schema__.toLowerCase();
    /**
   * Match#index -> Number
   *
   * First position of matched string.
   **/ this.index = start + shift;
    /**
   * Match#lastIndex -> Number
   *
   * Next position after matched string.
   **/ this.lastIndex = end + shift;
    /**
   * Match#raw -> String
   *
   * Matched string.
   **/ this.raw = text;
    /**
   * Match#text -> String
   *
   * Notmalized text of matched string.
   **/ this.text = text;
    /**
   * Match#url -> String
   *
   * Normalized url of matched string.
   **/ this.url = text;
}
function $baaba17503483954$var$createMatch(self, shift) {
    var match = new $baaba17503483954$var$Match(self, shift);
    self.__compiled__[match.schema].normalize(match, self);
    return match;
}
/**
 * class LinkifyIt
 **/ /**
 * new LinkifyIt(schemas, options)
 * - schemas (Object): Optional. Additional schemas to validate (prefix/validator)
 * - options (Object): { fuzzyLink|fuzzyEmail|fuzzyIP: true|false }
 *
 * Creates new linkifier instance with optional additional schemas.
 * Can be called without `new` keyword for convenience.
 *
 * By default understands:
 *
 * - `http(s)://...` , `ftp://...`, `mailto:...` & `//...` links
 * - "fuzzy" links and emails (example.com, foo@bar.com).
 *
 * `schemas` is an object, where each key/value describes protocol/rule:
 *
 * - __key__ - link prefix (usually, protocol name with `:` at the end, `skype:`
 *   for example). `linkify-it` makes shure that prefix is not preceeded with
 *   alphanumeric char and symbols. Only whitespaces and punctuation allowed.
 * - __value__ - rule to check tail after link prefix
 *   - _String_ - just alias to existing rule
 *   - _Object_
 *     - _validate_ - validator function (should return matched length on success),
 *       or `RegExp`.
 *     - _normalize_ - optional function to normalize text & url of matched result
 *       (for example, for @twitter mentions).
 *
 * `options`:
 *
 * - __fuzzyLink__ - recognige URL-s without `http(s):` prefix. Default `true`.
 * - __fuzzyIP__ - allow IPs in fuzzy links above. Can conflict with some texts
 *   like version numbers. Default `false`.
 * - __fuzzyEmail__ - recognize emails without `mailto:` prefix.
 *
 **/ function $baaba17503483954$var$LinkifyIt(schemas, options) {
    if (!(this instanceof $baaba17503483954$var$LinkifyIt)) return new $baaba17503483954$var$LinkifyIt(schemas, options);
    if (!options) {
        if ($baaba17503483954$var$isOptionsObj(schemas)) {
            options = schemas;
            schemas = {};
        }
    }
    this.__opts__ = $baaba17503483954$var$assign({}, $baaba17503483954$var$defaultOptions, options);
    // Cache last tested result. Used to skip repeating steps on next `match` call.
    this.__index__ = -1;
    this.__last_index__ = -1; // Next scan position
    this.__schema__ = "";
    this.__text_cache__ = "";
    this.__schemas__ = $baaba17503483954$var$assign({}, $baaba17503483954$var$defaultSchemas, schemas);
    this.__compiled__ = {};
    this.__tlds__ = $baaba17503483954$var$tlds_default;
    this.__tlds_replaced__ = false;
    this.re = {};
    $baaba17503483954$var$compile(this);
}
/** chainable
 * LinkifyIt#add(schema, definition)
 * - schema (String): rule name (fixed pattern prefix)
 * - definition (String|RegExp|Object): schema definition
 *
 * Add new rule definition. See constructor description for details.
 **/ $baaba17503483954$var$LinkifyIt.prototype.add = function add(schema, definition) {
    this.__schemas__[schema] = definition;
    $baaba17503483954$var$compile(this);
    return this;
};
/** chainable
 * LinkifyIt#set(options)
 * - options (Object): { fuzzyLink|fuzzyEmail|fuzzyIP: true|false }
 *
 * Set recognition options for links without schema.
 **/ $baaba17503483954$var$LinkifyIt.prototype.set = function set(options) {
    this.__opts__ = $baaba17503483954$var$assign(this.__opts__, options);
    return this;
};
/**
 * LinkifyIt#test(text) -> Boolean
 *
 * Searches linkifiable pattern and returns `true` on success or `false` on fail.
 **/ $baaba17503483954$var$LinkifyIt.prototype.test = function test(text) {
    // Reset scan cache
    this.__text_cache__ = text;
    this.__index__ = -1;
    if (!text.length) return false;
    var m, ml, me, len, shift, next, re, tld_pos, at_pos;
    // try to scan for link with schema - that's the most simple rule
    if (this.re.schema_test.test(text)) {
        re = this.re.schema_search;
        re.lastIndex = 0;
        while((m = re.exec(text)) !== null){
            len = this.testSchemaAt(text, m[2], re.lastIndex);
            if (len) {
                this.__schema__ = m[2];
                this.__index__ = m.index + m[1].length;
                this.__last_index__ = m.index + m[0].length + len;
                break;
            }
        }
    }
    if (this.__opts__.fuzzyLink && this.__compiled__["http:"]) {
        // guess schemaless links
        tld_pos = text.search(this.re.host_fuzzy_test);
        if (tld_pos >= 0) {
            // if tld is located after found link - no need to check fuzzy pattern
            if (this.__index__ < 0 || tld_pos < this.__index__) {
                if ((ml = text.match(this.__opts__.fuzzyIP ? this.re.link_fuzzy : this.re.link_no_ip_fuzzy)) !== null) {
                    shift = ml.index + ml[1].length;
                    if (this.__index__ < 0 || shift < this.__index__) {
                        this.__schema__ = "";
                        this.__index__ = shift;
                        this.__last_index__ = ml.index + ml[0].length;
                    }
                }
            }
        }
    }
    if (this.__opts__.fuzzyEmail && this.__compiled__["mailto:"]) {
        // guess schemaless emails
        at_pos = text.indexOf("@");
        if (at_pos >= 0) // We can't skip this check, because this cases are possible:
        // 192.168.1.1@gmail.com, my.in@example.com
        {
            if ((me = text.match(this.re.email_fuzzy)) !== null) {
                shift = me.index + me[1].length;
                next = me.index + me[0].length;
                if (this.__index__ < 0 || shift < this.__index__ || shift === this.__index__ && next > this.__last_index__) {
                    this.__schema__ = "mailto:";
                    this.__index__ = shift;
                    this.__last_index__ = next;
                }
            }
        }
    }
    return this.__index__ >= 0;
};
/**
 * LinkifyIt#pretest(text) -> Boolean
 *
 * Very quick check, that can give false positives. Returns true if link MAY BE
 * can exists. Can be used for speed optimization, when you need to check that
 * link NOT exists.
 **/ $baaba17503483954$var$LinkifyIt.prototype.pretest = function pretest(text) {
    return this.re.pretest.test(text);
};
/**
 * LinkifyIt#testSchemaAt(text, name, position) -> Number
 * - text (String): text to scan
 * - name (String): rule (schema) name
 * - position (Number): text offset to check from
 *
 * Similar to [[LinkifyIt#test]] but checks only specific protocol tail exactly
 * at given position. Returns length of found pattern (0 on fail).
 **/ $baaba17503483954$var$LinkifyIt.prototype.testSchemaAt = function testSchemaAt(text, schema, pos) {
    // If not supported schema check requested - terminate
    if (!this.__compiled__[schema.toLowerCase()]) return 0;
    return this.__compiled__[schema.toLowerCase()].validate(text, pos, this);
};
/**
 * LinkifyIt#match(text) -> Array|null
 *
 * Returns array of found link descriptions or `null` on fail. We strongly
 * recommend to use [[LinkifyIt#test]] first, for best speed.
 *
 * ##### Result match description
 *
 * - __schema__ - link schema, can be empty for fuzzy links, or `//` for
 *   protocol-neutral  links.
 * - __index__ - offset of matched text
 * - __lastIndex__ - index of next char after mathch end
 * - __raw__ - matched text
 * - __text__ - normalized text
 * - __url__ - link, generated from matched text
 **/ $baaba17503483954$var$LinkifyIt.prototype.match = function match(text) {
    var shift = 0, result = [];
    // Try to take previous element from cache, if .test() called before
    if (this.__index__ >= 0 && this.__text_cache__ === text) {
        result.push($baaba17503483954$var$createMatch(this, shift));
        shift = this.__last_index__;
    }
    // Cut head if cache was used
    var tail = shift ? text.slice(shift) : text;
    // Scan string until end reached
    while(this.test(tail)){
        result.push($baaba17503483954$var$createMatch(this, shift));
        tail = tail.slice(this.__last_index__);
        shift += this.__last_index__;
    }
    if (result.length) return result;
    return null;
};
/** chainable
 * LinkifyIt#tlds(list [, keepOld]) -> this
 * - list (Array): list of tlds
 * - keepOld (Boolean): merge with current list if `true` (`false` by default)
 *
 * Load (or merge) new tlds list. Those are user for fuzzy links (without prefix)
 * to avoid false positives. By default this algorythm used:
 *
 * - hostname with any 2-letter root zones are ok.
 * - biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|рф
 *   are ok.
 * - encoded (`xn--...`) root zones are ok.
 *
 * If list is replaced, then exact match for 2-chars root zones will be checked.
 **/ $baaba17503483954$var$LinkifyIt.prototype.tlds = function tlds(list, keepOld) {
    list = Array.isArray(list) ? list : [
        list
    ];
    if (!keepOld) {
        this.__tlds__ = list.slice();
        this.__tlds_replaced__ = true;
        $baaba17503483954$var$compile(this);
        return this;
    }
    this.__tlds__ = this.__tlds__.concat(list).sort().filter(function(el, idx, arr) {
        return el !== arr[idx - 1];
    }).reverse();
    $baaba17503483954$var$compile(this);
    return this;
};
/**
 * LinkifyIt#normalize(match)
 *
 * Default normalizer (if schema does not define it's own).
 **/ $baaba17503483954$var$LinkifyIt.prototype.normalize = function normalize(match) {
    // Do minimal possible changes by default. Need to collect feedback prior
    // to move forward https://github.com/markdown-it/linkify-it/issues/1
    if (!match.schema) match.url = "http://" + match.url;
    if (match.schema === "mailto:" && !/^mailto:/i.test(match.url)) match.url = "mailto:" + match.url;
};
/**
 * LinkifyIt#onCompile()
 *
 * Override to modify basic RegExp-s.
 **/ $baaba17503483954$var$LinkifyIt.prototype.onCompile = function onCompile() {};
module.exports = $baaba17503483954$var$LinkifyIt;

});
parcelRequire.register("7qzF9", function(module, exports) {
"use strict";




module.exports = function(opts) {
    var re = {};
    // Use direct extract instead of `regenerate` to reduse browserified size
    re.src_Any = (parcelRequire("73OXq")).source;
    re.src_Cc = (parcelRequire("c7ys3")).source;
    re.src_Z = (parcelRequire("kWxtK")).source;
    re.src_P = (parcelRequire("7X6km")).source;
    // \p{\Z\P\Cc\CF} (white spaces + control + format + punctuation)
    re.src_ZPCc = [
        re.src_Z,
        re.src_P,
        re.src_Cc
    ].join("|");
    // \p{\Z\Cc} (white spaces + control)
    re.src_ZCc = [
        re.src_Z,
        re.src_Cc
    ].join("|");
    // Experimental. List of chars, completely prohibited in links
    // because can separate it from other part of text
    var text_separators = "[><｜]";
    // All possible word characters (everything without punctuation, spaces & controls)
    // Defined via punctuation & spaces to save space
    // Should be something like \p{\L\N\S\M} (\w but without `_`)
    re.src_pseudo_letter = "(?:(?!" + text_separators + "|" + re.src_ZPCc + ")" + re.src_Any + ")";
    // The same as abothe but without [0-9]
    // var src_pseudo_letter_non_d = '(?:(?![0-9]|' + src_ZPCc + ')' + src_Any + ')';
    ////////////////////////////////////////////////////////////////////////////////
    re.src_ip4 = "(?:(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.){3}(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)";
    // Prohibit any of "@/[]()" in user/pass to avoid wrong domain fetch.
    re.src_auth = "(?:(?:(?!" + re.src_ZCc + "|[@/\\[\\]()]).)+@)?";
    re.src_port = "(?::(?:6(?:[0-4]\\d{3}|5(?:[0-4]\\d{2}|5(?:[0-2]\\d|3[0-5])))|[1-5]?\\d{1,4}))?";
    re.src_host_terminator = "(?=$|" + text_separators + "|" + re.src_ZPCc + ")(?!-|_|:\\d|\\.-|\\.(?!$|" + re.src_ZPCc + "))";
    re.src_path = "(?:[/?#](?:(?!" + re.src_ZCc + "|" + text_separators + "|[()[\\]{}.,\"'?!\\-;]).|" + "\\[(?:(?!" + re.src_ZCc + "|\\]).)*\\]|" + "\\((?:(?!" + re.src_ZCc + "|[)]).)*\\)|" + "\\{(?:(?!" + re.src_ZCc + "|[}]).)*\\}|" + '\\"(?:(?!' + re.src_ZCc + '|["]).)+\\"|' + "\\'(?:(?!" + re.src_ZCc + "|[']).)+\\'|" + "\\'(?=" + re.src_pseudo_letter + "|[-]).|" + // allow `I'm_king` if no pair found
    "\\.{2,}[a-zA-Z0-9%/&]|" + // google has many dots in "google search" links (#66, #81).
    // github has ... in commit range links,
    // Restrict to
    // - english
    // - percent-encoded
    // - parts of file path
    // - params separator
    // until more examples found.
    "\\.(?!" + re.src_ZCc + "|[.]).|" + (opts && opts["---"] ? "\\-(?!--(?:[^-]|$))(?:-*)|" // `---` => long dash, terminate
     : "\\-+|") + ",(?!" + re.src_ZCc + ").|" + // allow `,,,` in paths
    ";(?!" + re.src_ZCc + ").|" + // allow `;` if not followed by space-like char
    "\\!+(?!" + re.src_ZCc + "|[!]).|" + // allow `!!!` in paths, but not at the end
    "\\?(?!" + re.src_ZCc + "|[?])." + ")+" + "|\\/" + ")?";
    // Allow anything in markdown spec, forbid quote (") at the first position
    // because emails enclosed in quotes are far more common
    re.src_email_name = '[\\-;:&=\\+\\$,\\.a-zA-Z0-9_][\\-;:&=\\+\\$,\\"\\.a-zA-Z0-9_]*';
    re.src_xn = "xn--[a-z0-9\\-]{1,59}";
    // More to read about domain names
    // http://serverfault.com/questions/638260/
    re.src_domain_root = // Allow letters & digits (http://test1)
    "(?:" + re.src_xn + "|" + re.src_pseudo_letter + "{1,63}" + ")";
    re.src_domain = "(?:" + re.src_xn + "|" + "(?:" + re.src_pseudo_letter + ")" + "|" + "(?:" + re.src_pseudo_letter + "(?:-|" + re.src_pseudo_letter + "){0,61}" + re.src_pseudo_letter + ")" + ")";
    re.src_host = "(?:(?:(?:(?:" + re.src_domain + ")\\.)*" + re.src_domain /*_root*/  + ")" + ")";
    re.tpl_host_fuzzy = "(?:" + re.src_ip4 + "|" + "(?:(?:(?:" + re.src_domain + ")\\.)+(?:%TLDS%))" + ")";
    re.tpl_host_no_ip_fuzzy = "(?:(?:(?:" + re.src_domain + ")\\.)+(?:%TLDS%))";
    re.src_host_strict = re.src_host + re.src_host_terminator;
    re.tpl_host_fuzzy_strict = re.tpl_host_fuzzy + re.src_host_terminator;
    re.src_host_port_strict = re.src_host + re.src_port + re.src_host_terminator;
    re.tpl_host_port_fuzzy_strict = re.tpl_host_fuzzy + re.src_port + re.src_host_terminator;
    re.tpl_host_port_no_ip_fuzzy_strict = re.tpl_host_no_ip_fuzzy + re.src_port + re.src_host_terminator;
    ////////////////////////////////////////////////////////////////////////////////
    // Main rules
    // Rude test fuzzy links by host, for quick deny
    re.tpl_host_fuzzy_test = "localhost|www\\.|\\.\\d{1,3}\\.|(?:\\.(?:%TLDS%)(?:" + re.src_ZPCc + "|>|$))";
    re.tpl_email_fuzzy = "(^|" + text_separators + '|"|\\(|' + re.src_ZCc + ")" + "(" + re.src_email_name + "@" + re.tpl_host_fuzzy_strict + ")";
    re.tpl_link_fuzzy = // Fuzzy link can't be prepended with .:/\- and non punctuation.
    // but can start with > (markdown blockquote)
    "(^|(?![.:/\\-_@])(?:[$+<=>^`|｜]|" + re.src_ZPCc + "))" + "((?![$+<=>^`|｜])" + re.tpl_host_port_fuzzy_strict + re.src_path + ")";
    re.tpl_link_no_ip_fuzzy = // Fuzzy link can't be prepended with .:/\- and non punctuation.
    // but can start with > (markdown blockquote)
    "(^|(?![.:/\\-_@])(?:[$+<=>^`|｜]|" + re.src_ZPCc + "))" + "((?![$+<=>^`|｜])" + re.tpl_host_port_no_ip_fuzzy_strict + re.src_path + ")";
    return re;
};

});


parcelRequire.register("jWQte", function(module, exports) {
// markdown-it default options
"use strict";
module.exports = {
    options: {
        html: false,
        xhtmlOut: false,
        breaks: false,
        langPrefix: "language-",
        linkify: false,
        // Enable some language-neutral replacements + quotes beautification
        typographer: false,
        // Double + single quotes replacement pairs, when typographer enabled,
        // and smartquotes on. Could be either a String or an Array.
        //
        // For example, you can use '«»„“' for Russian, '„“‚‘' for German,
        // and ['«\xA0', '\xA0»', '‹\xA0', '\xA0›'] for French (including nbsp).
        quotes: "“”‘’",
        /* “”‘’ */ // Highlighter function. Should return escaped HTML,
        // or '' if the source string is not changed and should be escaped externaly.
        // If result starts with <pre... internal wrapper is skipped.
        //
        // function (/*str, lang*/) { return ''; }
        //
        highlight: null,
        maxNesting: 100 // Internal protection, recursion limit
    },
    components: {
        core: {},
        block: {},
        inline: {}
    }
};

});

parcelRequire.register("cddfz", function(module, exports) {
// "Zero" preset, with nothing enabled. Useful for manual configuring of simple
// modes. For example, to parse bold/italic only.
"use strict";
module.exports = {
    options: {
        html: false,
        xhtmlOut: false,
        breaks: false,
        langPrefix: "language-",
        linkify: false,
        // Enable some language-neutral replacements + quotes beautification
        typographer: false,
        // Double + single quotes replacement pairs, when typographer enabled,
        // and smartquotes on. Could be either a String or an Array.
        //
        // For example, you can use '«»„“' for Russian, '„“‚‘' for German,
        // and ['«\xA0', '\xA0»', '‹\xA0', '\xA0›'] for French (including nbsp).
        quotes: "“”‘’",
        /* “”‘’ */ // Highlighter function. Should return escaped HTML,
        // or '' if the source string is not changed and should be escaped externaly.
        // If result starts with <pre... internal wrapper is skipped.
        //
        // function (/*str, lang*/) { return ''; }
        //
        highlight: null,
        maxNesting: 20 // Internal protection, recursion limit
    },
    components: {
        core: {
            rules: [
                "normalize",
                "block",
                "inline"
            ]
        },
        block: {
            rules: [
                "paragraph"
            ]
        },
        inline: {
            rules: [
                "text"
            ],
            rules2: [
                "balance_pairs",
                "text_collapse"
            ]
        }
    }
};

});

parcelRequire.register("jSz5z", function(module, exports) {
// Commonmark default options
"use strict";
module.exports = {
    options: {
        html: true,
        xhtmlOut: true,
        breaks: false,
        langPrefix: "language-",
        linkify: false,
        // Enable some language-neutral replacements + quotes beautification
        typographer: false,
        // Double + single quotes replacement pairs, when typographer enabled,
        // and smartquotes on. Could be either a String or an Array.
        //
        // For example, you can use '«»„“' for Russian, '„“‚‘' for German,
        // and ['«\xA0', '\xA0»', '‹\xA0', '\xA0›'] for French (including nbsp).
        quotes: "“”‘’",
        /* “”‘’ */ // Highlighter function. Should return escaped HTML,
        // or '' if the source string is not changed and should be escaped externaly.
        // If result starts with <pre... internal wrapper is skipped.
        //
        // function (/*str, lang*/) { return ''; }
        //
        highlight: null,
        maxNesting: 20 // Internal protection, recursion limit
    },
    components: {
        core: {
            rules: [
                "normalize",
                "block",
                "inline"
            ]
        },
        block: {
            rules: [
                "blockquote",
                "code",
                "fence",
                "heading",
                "hr",
                "html_block",
                "lheading",
                "list",
                "reference",
                "paragraph"
            ]
        },
        inline: {
            rules: [
                "autolink",
                "backticks",
                "emphasis",
                "entity",
                "escape",
                "html_inline",
                "image",
                "link",
                "newline",
                "text"
            ],
            rules2: [
                "balance_pairs",
                "emphasis",
                "text_collapse"
            ]
        }
    }
};

});


parcelRequire.register("fH33H", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $3YYCj = parcelRequire("3YYCj");

var $aRRVw = parcelRequire("aRRVw");

var $dKyAo = parcelRequire("dKyAo");

var $eP61v = parcelRequire("eP61v");

var $cQlSY = parcelRequire("cQlSY");

var $9Lhzm = parcelRequire("9Lhzm");

var $fvjGB = parcelRequire("fvjGB");
function $b6cd3e90ca729bd8$var$createFormatter(options) {
    switch(options.platform){
        case "amazon-alexa":
            return new $aRRVw.AmazonAlexaSsmlFormatter(options);
        case "amazon-polly":
            return new $dKyAo.AmazonPollySsmlFormatter(options);
        case "amazon-polly-neural":
            return new $eP61v.AmazonPollyNeuralSsmlFormatter(options);
        case "google-assistant":
            return new $cQlSY.GoogleAssistantSsmlFormatter(options);
        case "samsung-bixby":
            return new $9Lhzm.SamsungBixbySsmlFormatter(options);
        case "microsoft-azure":
            return new $fvjGB.MicrosoftAzureSsmlFormatter(options);
        default:
            return new $3YYCj.TextFormatter(options);
    }
}
module.exports.createFormatter = $b6cd3e90ca729bd8$var$createFormatter;
function $b6cd3e90ca729bd8$var$createTextFormatter(options) {
    return new $3YYCj.TextFormatter(options);
}
module.exports.createTextFormatter = $b6cd3e90ca729bd8$var$createTextFormatter;

});
parcelRequire.register("3YYCj", function(module, exports) {
"use strict";
var $2e65fef487e8893c$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $kqjbn = parcelRequire("kqjbn");
var $2e65fef487e8893c$var$TextFormatter = /** @class */ function(_super) {
    $2e65fef487e8893c$var$__extends(TextFormatter, _super);
    function TextFormatter(options) {
        var _this = _super.call(this, options) || this;
        _this.options = options;
        return _this;
    }
    TextFormatter.prototype.format = function(ast) {
        var lines = this.formatFromAst(ast, []);
        var txt = lines.join("").trim();
        // replace multiple whitespace with a single space
        // tslint:disable-next-line: no-regex-spaces
        txt = txt.replace(/  +/g, " ");
        return txt;
    };
    TextFormatter.prototype.formatFromAst = function(ast, lines) {
        if (lines === void 0) lines = [];
        switch(ast.name){
            case "document":
                this.processAst(ast.children, lines);
                return lines;
            case "paragraph":
                this.processAst(ast.children, lines);
                return lines;
            case "simpleLine":
                this.processAst(ast.children, lines);
                return lines;
            case "lineEnd":
                lines.push(ast.allText);
                return lines;
            case "emptyLine":
                if (this.options.preserveEmptyLines) lines.push(ast.allText);
                return lines;
            case "plainText":
            case "plainTextSpecialChars":
            case "plainTextEmphasis":
            case "plainTextPhone":
            case "plainTextModifier":
                lines.push(ast.allText);
                return lines;
            default:
                this.processAst(ast.children, lines);
                return lines;
        }
    };
    return TextFormatter;
}($kqjbn.FormatterBase);
module.exports.TextFormatter = $2e65fef487e8893c$var$TextFormatter;

});
parcelRequire.register("kqjbn", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $ede51d9862d5ba57$var$FormatterBase = /** @class */ function() {
    function FormatterBase(options) {
        this.options = options;
        this.options = options;
    }
    // Adds each element of the array as markdown
    FormatterBase.prototype.addArray = function(ast, lines) {
        for(var _i = 0, ast_1 = ast; _i < ast_1.length; _i++){
            var child = ast_1[_i];
            this.formatFromAst(child, lines);
        }
        return lines;
    };
    FormatterBase.prototype.processAst = function(ast, lines) {
        if (ast instanceof Array) this.addArray(ast, lines);
        else this.formatFromAst(ast, lines);
    };
    return FormatterBase;
}();
module.exports.FormatterBase = $ede51d9862d5ba57$var$FormatterBase;

});


parcelRequire.register("aRRVw", function(module, exports) {
"use strict";
var $7e98af5d1e0cc35b$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $jK8qR = parcelRequire("jK8qR");
var $7e98af5d1e0cc35b$var$AmazonAlexaSsmlFormatter = /** @class */ function(_super) {
    $7e98af5d1e0cc35b$var$__extends(AmazonAlexaSsmlFormatter, _super);
    function AmazonAlexaSsmlFormatter(options) {
        var _this = _super.call(this, options) || this;
        _this.options = options;
        _this.validVoices = {
            "Ivy": "en-US",
            "Joanna": "en-US",
            "Joey": "en-US",
            "Justin": "en-US",
            "Kendra": "en-US",
            "Kimberly": "en-US",
            "Matthew": "en-US",
            "Salli": "en-US",
            "Nicole": "en-AU",
            "Russell": "en-AU",
            "Amy": "en-GB",
            "Brian": "en-GB",
            "Emma": "en-GB",
            "Aditi": "en-IN",
            "Raveena": "en-IN",
            "Hans": "de-DE",
            "Marlene": "de-DE",
            "Vicki": "de-DE",
            "Conchita": "es-ES",
            "Enrique": "es-ES",
            "Carla": "it-IT",
            "Giorgio": "it-IT",
            "Mizuki": "ja-JP",
            "Takumi": "ja-JP",
            "Celine": "fr-FR",
            "Lea": "fr-FR",
            "Mathieu": "fr-FR"
        };
        _this.validEmotionIntensity = [
            "low",
            "medium",
            "high"
        ];
        _this.modifierKeyToSsmlTagMappings.whisper = "amazon:effect";
        _this.modifierKeyToSsmlTagMappings.lang = "lang";
        _this.modifierKeyToSsmlTagMappings.voice = "voice";
        _this.modifierKeyToSsmlTagMappings.dj = "amazon:domain";
        _this.modifierKeyToSsmlTagMappings.newscaster = "amazon:domain";
        _this.modifierKeyToSsmlTagMappings.excited = "amazon:emotion";
        _this.modifierKeyToSsmlTagMappings.disappointed = "amazon:emotion";
        return _this;
    }
    // tslint:disable-next-line: max-func-body-length
    AmazonAlexaSsmlFormatter.prototype.getTextModifierObject = function(ast) {
        var textModifierObject = new $jK8qR.TagsObject(this);
        for(var index = 0; index < ast.children.length; index++){
            var child = ast.children[index];
            switch(child.name){
                case "plainText":
                case "plainTextSpecialChars":
                case "plainTextEmphasis":
                case "plainTextPhone":
                case "plainTextModifier":
                    textModifierObject["text"] = child.allText;
                    break;
                case "textModifierKeyOptionalValue":
                    var key = child.children[0].allText;
                    key = this.modifierKeyMappings[key] || key;
                    var value = child.children.length === 2 ? child.children[1].allText : "";
                    var ssmlTag = this.modifierKeyToSsmlTagMappings[key];
                    switch(key){
                        case "emphasis":
                            textModifierObject.tag(ssmlTag, {
                                level: value || "moderate"
                            });
                            break;
                        case "address":
                        case "characters":
                        case "expletive":
                        case "fraction":
                        case "interjection":
                        case "number":
                        case "ordinal":
                        case "telephone":
                        case "unit":
                            textModifierObject.tag(ssmlTag, {
                                "interpret-as": key
                            });
                            break;
                        case "date":
                            textModifierObject.tag(ssmlTag, {
                                "interpret-as": key,
                                format: value || "ymd"
                            });
                            break;
                        case "time":
                            textModifierObject.tag(ssmlTag, {
                                "interpret-as": key,
                                format: value || "hms12"
                            });
                            break;
                        case "whisper":
                            textModifierObject.tag(ssmlTag, {
                                name: "whispered"
                            });
                            break;
                        case "ipa":
                            textModifierObject.tag(ssmlTag, {
                                alphabet: key,
                                ph: value
                            });
                            break;
                        case "sub":
                            textModifierObject.tag(ssmlTag, {
                                alias: value
                            });
                            break;
                        case "volume":
                        case "rate":
                        case "pitch":
                            var attrs = {};
                            attrs[key] = value || "medium";
                            textModifierObject.tag(ssmlTag, attrs, true);
                            break;
                        case "lang":
                            textModifierObject.tag(ssmlTag, {
                                "xml:lang": value
                            });
                            break;
                        case "voice":
                            textModifierObject.voiceTag(key, value);
                            break;
                        case "excited":
                        case "disappointed":
                            var intensity = (value || "medium").toLowerCase();
                            if (this.validEmotionIntensity.includes(intensity)) {
                                textModifierObject.tag(ssmlTag, {
                                    "name": key,
                                    "intensity": intensity
                                });
                                break;
                            }
                            break;
                        default:
                    }
                    break;
            }
        }
        return textModifierObject;
    };
    // tslint:disable-next-line: max-func-body-length
    AmazonAlexaSsmlFormatter.prototype.getSectionObject = function(ast) {
        var sectionObject = new $jK8qR.TagsObject(this);
        for(var index = 0; index < ast.children.length; index++){
            var child = ast.children[index];
            if (child.name === "sectionModifierKeyOptionalValue") {
                var key = child.children[0].allText;
                var value = child.children.length === 2 ? child.children[1].allText : "";
                var ssmlTag = this.modifierKeyToSsmlTagMappings[key];
                switch(key){
                    case "lang":
                        sectionObject.tag(ssmlTag, {
                            "xml:lang": value
                        });
                        break;
                    case "voice":
                        sectionObject.voiceTag(key, value);
                        break;
                    case "dj":
                        sectionObject.tag(ssmlTag, {
                            "name": "music"
                        });
                        break;
                    case "newscaster":
                        sectionObject.tag(ssmlTag, {
                            "name": "news"
                        });
                        break;
                    case "defaults":
                        break;
                    case "excited":
                    case "disappointed":
                        var intensity = (value || "medium").toLowerCase();
                        if (this.validEmotionIntensity.includes(intensity)) {
                            sectionObject.tag(ssmlTag, {
                                "name": key,
                                "intensity": intensity
                            });
                            break;
                        }
                        break;
                    default:
                }
            }
        }
        return sectionObject;
    };
    // tslint:disable-next-line: max-func-body-length
    AmazonAlexaSsmlFormatter.prototype.formatFromAst = function(ast, lines) {
        if (lines === void 0) lines = [];
        switch(ast.name){
            case "document":
                if (this.options.includeFormatterComment) this.addComment("Converted from Speech Markdown to SSML for Amazon Alexa", lines);
                if (this.options.includeSpeakTag) return this.addSpeakTag(ast.children, true, false, null, lines);
                else {
                    this.processAst(ast.children, lines);
                    return lines;
                }
            case "paragraph":
                if (this.options.includeParagraphTag) return this.addTag("p", ast.children, true, false, null, lines);
                else {
                    this.processAst(ast.children, lines);
                    return lines;
                }
            case "shortBreak":
                var time = ast.children[0].allText;
                return this.addTagWithAttrs(lines, null, "break", {
                    time: time
                });
            case "break":
                var val = ast.children[0].allText;
                var attrs = {};
                switch(ast.children[0].children[0].name){
                    case "breakStrengthValue":
                        attrs = {
                            strength: val
                        };
                        break;
                    case "time":
                        attrs = {
                            time: val
                        };
                        break;
                }
                return this.addTagWithAttrs(lines, null, "break", attrs);
            case "shortEmphasisModerate":
                var text = ast.children[0].allText;
                return this.addTagWithAttrs(lines, text, "emphasis", {
                    level: "moderate"
                });
            case "shortEmphasisStrong":
                var text = ast.children[0].allText;
                return this.addTagWithAttrs(lines, text, "emphasis", {
                    level: "strong"
                });
            case "shortEmphasisNone":
                var text = ast.children[0].allText;
                return this.addTagWithAttrs(lines, text, "emphasis", {
                    level: "none"
                });
            case "shortEmphasisReduced":
                var text = ast.children[0].allText;
                return this.addTagWithAttrs(lines, text, "emphasis", {
                    level: "reduced"
                });
            case "textModifier":
                var tmo_1 = this.getTextModifierObject(ast);
                var tagsSortedDesc = Object.keys(tmo_1.tags).sort(function(a, b) {
                    return tmo_1.tags[b].sortId - tmo_1.tags[a].sortId;
                });
                var inner = tmo_1.text;
                for(var index = 0; index < tagsSortedDesc.length; index++){
                    var tag = tagsSortedDesc[index];
                    var attrs = tmo_1.tags[tag].attrs;
                    inner = this.getTagWithAttrs(inner, tag, attrs);
                }
                lines.push(inner);
                return lines;
            case "section":
                var so_1 = this.getSectionObject(ast);
                var tagsSortedAsc = Object.keys(so_1.tags).sort(function(a, b) {
                    return so_1.tags[a].sortId - so_1.tags[b].sortId;
                });
                this.addSectionEndTag(lines);
                this.addSectionStartTag(tagsSortedAsc, so_1, lines);
                return lines;
            case "audio":
                var url = ast.children[0].allText.replace(/&/g, "&amp;");
                return this.addTagWithAttrs(lines, null, "audio", {
                    src: url
                });
            case "simpleLine":
                this.processAst(ast.children, lines);
                return lines;
            case "lineEnd":
                lines.push(ast.allText);
                return lines;
            case "emptyLine":
                if (this.options.preserveEmptyLines) lines.push(ast.allText);
                return lines;
            case "plainText":
            case "plainTextSpecialChars":
                var text = this.options.escapeXmlSymbols ? this.escapeXmlCharacters(ast.allText) : ast.allText;
                lines.push(text);
                return lines;
            default:
                this.processAst(ast.children, lines);
                return lines;
        }
    };
    return AmazonAlexaSsmlFormatter;
}($jK8qR.SsmlFormatterBase);
module.exports.AmazonAlexaSsmlFormatter = $7e98af5d1e0cc35b$var$AmazonAlexaSsmlFormatter;

});
parcelRequire.register("jK8qR", function(module, exports) {
"use strict";
var $e5f8daace254c995$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $e5f8daace254c995$var$__assign = module.exports && module.exports.__assign || function() {
    $e5f8daace254c995$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $e5f8daace254c995$var$__assign.apply(this, arguments);
};
var $e5f8daace254c995$var$__spreadArrays = module.exports && module.exports.__spreadArrays || function() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $kqjbn = parcelRequire("kqjbn");
var $e5f8daace254c995$var$TagsObject = /** @class */ function() {
    function TagsObject(base) {
        this.base = base;
        this.tags = {};
        this.text = "";
    }
    TagsObject.prototype.tag = function(tag, attrs, augment, ssmlTagSortOrder) {
        if (augment === void 0) augment = false;
        if (ssmlTagSortOrder === void 0) ssmlTagSortOrder = this.base.ssmlTagSortOrder;
        var sortId = ssmlTagSortOrder.indexOf(tag);
        if (!this.tags[tag]) this.tags[tag] = {
            sortId: sortId,
            attrs: null
        };
        if (augment) this.tags[tag].attrs = $e5f8daace254c995$var$__assign($e5f8daace254c995$var$__assign({}, this.tags[tag].attrs), attrs);
        else this.tags[tag].attrs = attrs;
    };
    TagsObject.prototype.voiceTagNamed = function(voices, name) {
        var _this = this;
        var info = voices && voices[name];
        if (info) {
            if (typeof info !== "object") info = {
                voice: {
                    "name": name
                }
            };
            Object.keys(info).forEach(function(tag) {
                var attributes = info[tag];
                _this.tag(tag, attributes);
            });
            return true;
        }
        return false;
    };
    TagsObject.prototype.voiceTag = function(tag, value) {
        var name = this.base.sentenceCase(value || "device");
        var handled = this.voiceTagNamed(this.base.options && this.base.options.voices, name) || this.voiceTagNamed(this.base.validVoices, name);
    };
    return TagsObject;
}();
module.exports.TagsObject = $e5f8daace254c995$var$TagsObject;
var $e5f8daace254c995$var$SsmlFormatterBase = /** @class */ function(_super) {
    $e5f8daace254c995$var$__extends(SsmlFormatterBase, _super);
    function SsmlFormatterBase(options) {
        var _this = _super.call(this, options) || this;
        _this.options = options;
        _this.sectionTags = [];
        _this.modifierKeyMappings = {
            "chars": "characters",
            "cardinal": "number",
            "digits": "characters",
            "bleep": "expletive",
            "phone": "telephone",
            "vol": "volume"
        };
        _this.ssmlTagSortOrder = [
            "emphasis",
            "say-as",
            "prosody",
            "amazon:domain",
            "amazon:effect",
            "amazon:emotion",
            "voice",
            "lang",
            "sub",
            "phoneme"
        ];
        _this.modifierKeyToSsmlTagMappings = {
            "emphasis": "emphasis",
            "address": "say-as",
            "number": "say-as",
            "characters": "say-as",
            "expletive": "say-as",
            "fraction": "say-as",
            "interjection": "say-as",
            "ordinal": "say-as",
            "telephone": "say-as",
            "unit": "say-as",
            "time": "say-as",
            "date": "say-as",
            "whisper": null,
            "sub": "sub",
            "ipa": "phoneme",
            "rate": "prosody",
            "pitch": "prosody",
            "volume": "prosody",
            "drc": null,
            "timbre": null,
            "lang": null,
            "voice": null,
            "dj": null,
            "defaults": null,
            "newscaster": null,
            "excited": null,
            "disappointed": null
        };
        return _this;
    }
    SsmlFormatterBase.prototype.format = function(ast) {
        var lines = this.formatFromAst(ast, []);
        return lines.join("");
    };
    SsmlFormatterBase.prototype.addSectionStartTag = function(tagsSortedAsc, so, lines) {
        this.sectionTags = $e5f8daace254c995$var$__spreadArrays(tagsSortedAsc).reverse();
        for(var index = 0; index < tagsSortedAsc.length; index++){
            var tag = tagsSortedAsc[index];
            var attrs = so.tags[tag].attrs;
            lines.push("\n");
            lines.push(this.startTag(tag, attrs, false));
        }
    };
    SsmlFormatterBase.prototype.addSectionEndTag = function(lines) {
        if (this.sectionTags.length > 0) // add previous end tag(s)
        for(var index = 0; index < this.sectionTags.length; index++){
            var tag = this.sectionTags[index];
            lines.push(this.endTag(tag, false));
            lines.push("\n");
        }
    };
    // Adds tagged content
    SsmlFormatterBase.prototype.addTag = function(tag, ast, newLine, newLineAfterEnd, attr, lines) {
        lines.push(this.startTag(tag, attr, newLine));
        this.processAst(ast, lines);
        lines.push(this.endTag(tag, newLine));
        if (newLineAfterEnd) lines.push("\n");
        return lines;
    };
    SsmlFormatterBase.prototype.addSpeakTag = function(ast, newLine, newLineAfterEnd, attr, lines) {
        lines.push(this.startTag("speak", attr, newLine));
        this.processAst(ast, lines);
        this.addSectionEndTag(lines);
        lines.push(this.endTag("speak", newLine));
        if (newLineAfterEnd) lines.push("\n");
        return lines;
    };
    SsmlFormatterBase.prototype.addComment = function(commentText, lines) {
        lines.push("<!-- " + commentText + " -->\n");
        return lines;
    };
    // Returns the SSML for a start tag
    SsmlFormatterBase.prototype.startTag = function(tag, attr, newLine) {
        if (newLine === void 0) newLine = false;
        var attrStr = "";
        if (attr) attrStr = " " + Object.keys(attr).map(function(k) {
            return k + '="' + attr[k] + '"';
        }).join(" ");
        return "<" + tag + attrStr + ">" + (newLine ? "\n" : "");
    };
    // Returns the SSML for an end tag
    SsmlFormatterBase.prototype.endTag = function(tag, newLine) {
        if (newLine === void 0) newLine = false;
        return (newLine ? "\n" : "") + "</" + tag + ">";
    // return '</' + tag + '>';
    };
    SsmlFormatterBase.prototype.voidTag = function(tag, attr) {
        var attrStr = "";
        if (attr) attrStr = " " + Object.keys(attr).map(function(k) {
            return k + '="' + attr[k] + '"';
        }).join(" ");
        return "<" + tag + attrStr + "/>";
    };
    SsmlFormatterBase.prototype.addTagWithAttrs = function(lines, text, tag, attrs, forceEndTag) {
        if (forceEndTag === void 0) forceEndTag = false;
        if (text || forceEndTag) {
            lines.push(this.startTag(tag, attrs));
            if (text) lines.push(text);
            lines.push(this.endTag(tag, false));
        } else lines.push(this.voidTag(tag, attrs));
        return lines;
    };
    SsmlFormatterBase.prototype.getTagWithAttrs = function(text, tag, attrs) {
        var lines = [];
        if (text) {
            lines.push(this.startTag(tag, attrs));
            lines.push(text);
            lines.push(this.endTag(tag, false));
        } else lines.push(this.voidTag(tag, attrs));
        return lines.join("");
    };
    SsmlFormatterBase.prototype.sentenceCase = function(text) {
        return text.replace(/[a-z]/i, function(letter) {
            return letter.toUpperCase();
        }).trim();
    };
    SsmlFormatterBase.prototype.escapeXmlCharacters = function(unescaped) {
        // Only process once (by unescaping)
        var revPattern = Object.keys(SsmlFormatterBase.XML_UNESCAPE_MAPPING).join("|") + "]";
        var reversed = unescaped.replace(new RegExp(revPattern, "g"), function(s) {
            return SsmlFormatterBase.XML_UNESCAPE_MAPPING[s];
        });
        // Escape XML characters
        var pattern = "[" + Object.keys(SsmlFormatterBase.XML_ESCAPE_MAPPING).join("") + "]";
        var escaped = reversed.replace(new RegExp(pattern, "g"), function(s) {
            return SsmlFormatterBase.XML_ESCAPE_MAPPING[s];
        });
        // console.log([unescaped, reversed, escaped].join('\n'));
        return escaped;
    };
    SsmlFormatterBase.XML_ESCAPE_MAPPING = {
        "<": "&lt;",
        ">": "&gt;",
        "&": "&amp;",
        '"': "&quot;",
        "'": "&apos;"
    };
    SsmlFormatterBase.XML_UNESCAPE_MAPPING = function swapJSON(dictionary) {
        return Object.keys(dictionary).reduce(function(acc, key) {
            acc[dictionary[key]] = key;
            return acc;
        }, {});
    }(SsmlFormatterBase.XML_ESCAPE_MAPPING);
    return SsmlFormatterBase;
}($kqjbn.FormatterBase);
module.exports.SsmlFormatterBase = $e5f8daace254c995$var$SsmlFormatterBase;

});


parcelRequire.register("dKyAo", function(module, exports) {
"use strict";
var $a02a66456191b712$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $jK8qR = parcelRequire("jK8qR");
var $a02a66456191b712$var$AmazonPollySsmlFormatter = /** @class */ function(_super) {
    $a02a66456191b712$var$__extends(AmazonPollySsmlFormatter, _super);
    function AmazonPollySsmlFormatter(options) {
        var _this = _super.call(this, options) || this;
        _this.options = options;
        _this.modifierKeyToSsmlTagMappings.whisper = "amazon:effect";
        _this.modifierKeyToSsmlTagMappings.timbre = "amazon:effect";
        _this.modifierKeyToSsmlTagMappings.cardinal = "say-as";
        _this.modifierKeyToSsmlTagMappings.digits = "say-as";
        _this.modifierKeyToSsmlTagMappings.drc = "amazon:effect";
        _this.modifierKeyToSsmlTagMappings.lang = "lang";
        _this.modifierKeyMappings.digits = "digits";
        _this.modifierKeyMappings.cardinal = "cardinal";
        return _this;
    }
    // tslint:disable-next-line: max-func-body-length
    AmazonPollySsmlFormatter.prototype.getTextModifierObject = function(ast) {
        var textModifierObject = new $jK8qR.TagsObject(this);
        for(var index = 0; index < ast.children.length; index++){
            var child = ast.children[index];
            switch(child.name){
                case "plainText":
                case "plainTextSpecialChars":
                case "plainTextEmphasis":
                case "plainTextPhone":
                case "plainTextModifier":
                    textModifierObject["text"] = child.allText;
                    break;
                case "textModifierKeyOptionalValue":
                    var key = child.children[0].allText;
                    key = this.modifierKeyMappings[key] || key;
                    var value = child.children.length === 2 ? child.children[1].allText : "";
                    var ssmlTag = this.modifierKeyToSsmlTagMappings[key];
                    switch(key){
                        case "emphasis":
                            textModifierObject.tag(ssmlTag, {
                                level: value || "moderate"
                            });
                            break;
                        case "address":
                        case "cardinal":
                        case "characters":
                        case "digits":
                        case "expletive":
                        case "fraction":
                        case "number":
                        case "ordinal":
                        case "telephone":
                        case "unit":
                            textModifierObject.tag(ssmlTag, {
                                "interpret-as": key
                            });
                            break;
                        case "date":
                            textModifierObject.tag(ssmlTag, {
                                "interpret-as": key,
                                format: value || "ymd"
                            });
                            break;
                        case "time":
                            textModifierObject.tag(ssmlTag, {
                                "interpret-as": key,
                                format: value || "hms12"
                            });
                            break;
                        case "whisper":
                            textModifierObject.tag(ssmlTag, {
                                name: "whispered"
                            });
                            break;
                        case "ipa":
                            textModifierObject.tag(ssmlTag, {
                                alphabet: key,
                                ph: value
                            });
                            break;
                        case "sub":
                            textModifierObject.tag(ssmlTag, {
                                alias: value
                            });
                            break;
                        case "volume":
                        case "rate":
                        case "pitch":
                            var attrs = {};
                            attrs[key] = value || "medium";
                            textModifierObject.tag(ssmlTag, attrs, true);
                            break;
                        case "timbre":
                            textModifierObject.tag(ssmlTag, {
                                "vocal-tract-length": value
                            });
                            break;
                        case "lang":
                            textModifierObject.tag(ssmlTag, {
                                "xml:lang": value
                            });
                            break;
                        case "drc":
                            textModifierObject.tag(ssmlTag, {
                                "name": key
                            });
                            break;
                        case "voice":
                        case "excited":
                        case "disappointed":
                            break;
                        default:
                    }
                    break;
            }
        }
        return textModifierObject;
    };
    // tslint:disable-next-line: max-func-body-length
    AmazonPollySsmlFormatter.prototype.getSectionObject = function(ast) {
        var sectionObject = new $jK8qR.TagsObject(this);
        for(var index = 0; index < ast.children.length; index++){
            var child = ast.children[index];
            if (child.name === "sectionModifierKeyOptionalValue") {
                var key = child.children[0].allText;
                var value = child.children.length === 2 ? child.children[1].allText : "";
                var ssmlTag = this.modifierKeyToSsmlTagMappings[key];
                switch(key){
                    case "lang":
                        sectionObject.tag(ssmlTag, {
                            "xml:lang": value
                        });
                        break;
                    case "defaults":
                        break;
                    case "voice":
                    case "dj":
                    case "newscaster":
                    case "excited":
                    case "disappointed":
                        break;
                    default:
                }
            }
        }
        return sectionObject;
    };
    // tslint:disable-next-line: max-func-body-length
    AmazonPollySsmlFormatter.prototype.formatFromAst = function(ast, lines) {
        if (lines === void 0) lines = [];
        switch(ast.name){
            case "document":
                if (this.options.includeFormatterComment) this.addComment("Converted from Speech Markdown to SSML for Amazon Alexa", lines);
                if (this.options.includeSpeakTag) return this.addSpeakTag(ast.children, true, false, null, lines);
                else {
                    this.processAst(ast.children, lines);
                    return lines;
                }
            case "paragraph":
                if (this.options.includeParagraphTag) return this.addTag("p", ast.children, true, false, null, lines);
                else {
                    this.processAst(ast.children, lines);
                    return lines;
                }
            case "shortBreak":
                var time = ast.children[0].allText;
                return this.addTagWithAttrs(lines, null, "break", {
                    time: time
                });
            case "break":
                var val = ast.children[0].allText;
                var attrs = {};
                switch(ast.children[0].children[0].name){
                    case "breakStrengthValue":
                        attrs = {
                            strength: val
                        };
                        break;
                    case "time":
                        attrs = {
                            time: val
                        };
                        break;
                }
                return this.addTagWithAttrs(lines, null, "break", attrs);
            case "markTag":
                var name = ast.children[0].allText;
                return this.addTagWithAttrs(lines, null, "mark", {
                    name: name
                });
            case "shortEmphasisModerate":
                var text = ast.children[0].allText;
                return this.addTagWithAttrs(lines, text, "emphasis", {
                    level: "moderate"
                });
            case "shortEmphasisStrong":
                var text = ast.children[0].allText;
                return this.addTagWithAttrs(lines, text, "emphasis", {
                    level: "strong"
                });
            case "shortEmphasisNone":
                var text = ast.children[0].allText;
                return this.addTagWithAttrs(lines, text, "emphasis", {
                    level: "none"
                });
            case "shortEmphasisReduced":
                var text = ast.children[0].allText;
                return this.addTagWithAttrs(lines, text, "emphasis", {
                    level: "reduced"
                });
            case "textModifier":
                var tmo_1 = this.getTextModifierObject(ast);
                var tagsSortedDesc = Object.keys(tmo_1.tags).sort(function(a, b) {
                    return tmo_1.tags[b].sortId - tmo_1.tags[a].sortId;
                });
                var inner = tmo_1.text;
                for(var index = 0; index < tagsSortedDesc.length; index++){
                    var tag = tagsSortedDesc[index];
                    var attrs = tmo_1.tags[tag].attrs;
                    inner = this.getTagWithAttrs(inner, tag, attrs);
                }
                lines.push(inner);
                return lines;
            case "section":
                var so_1 = this.getSectionObject(ast);
                var tagsSortedAsc = Object.keys(so_1.tags).sort(function(a, b) {
                    return so_1.tags[a].sortId - so_1.tags[b].sortId;
                });
                this.addSectionEndTag(lines);
                this.addSectionStartTag(tagsSortedAsc, so_1, lines);
                return lines;
            case "simpleLine":
                this.processAst(ast.children, lines);
                return lines;
            case "lineEnd":
                lines.push(ast.allText);
                return lines;
            case "emptyLine":
                if (this.options.preserveEmptyLines) lines.push(ast.allText);
                return lines;
            case "plainText":
            case "plainTextSpecialChars":
                lines.push(ast.allText);
                return lines;
            default:
                this.processAst(ast.children, lines);
                return lines;
        }
    };
    return AmazonPollySsmlFormatter;
}($jK8qR.SsmlFormatterBase);
module.exports.AmazonPollySsmlFormatter = $a02a66456191b712$var$AmazonPollySsmlFormatter;

});

parcelRequire.register("eP61v", function(module, exports) {
"use strict";
var $acaa803a8691e6af$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $jK8qR = parcelRequire("jK8qR");
var $acaa803a8691e6af$var$AmazonPollyNeuralSsmlFormatter = /** @class */ function(_super) {
    $acaa803a8691e6af$var$__extends(AmazonPollyNeuralSsmlFormatter, _super);
    function AmazonPollyNeuralSsmlFormatter(options) {
        var _this = _super.call(this, options) || this;
        _this.options = options;
        _this.modifierKeyToSsmlTagMappings.cardinal = "say-as";
        _this.modifierKeyToSsmlTagMappings.digits = "say-as";
        _this.modifierKeyToSsmlTagMappings.drc = "amazon:effect";
        _this.modifierKeyToSsmlTagMappings.lang = "lang";
        _this.modifierKeyToSsmlTagMappings.newscaster = "amazon:domain";
        _this.modifierKeyMappings.digits = "digits";
        _this.modifierKeyMappings.cardinal = "cardinal";
        return _this;
    }
    // tslint:disable-next-line: max-func-body-length
    AmazonPollyNeuralSsmlFormatter.prototype.getTextModifierObject = function(ast) {
        var textModifierObject = new $jK8qR.TagsObject(this);
        for(var index = 0; index < ast.children.length; index++){
            var child = ast.children[index];
            switch(child.name){
                case "plainText":
                case "plainTextSpecialChars":
                case "plainTextEmphasis":
                case "plainTextPhone":
                case "plainTextModifier":
                    textModifierObject["text"] = child.allText;
                    break;
                case "textModifierKeyOptionalValue":
                    var key = child.children[0].allText;
                    key = this.modifierKeyMappings[key] || key;
                    var value = child.children.length === 2 ? child.children[1].allText : "";
                    var ssmlTag = this.modifierKeyToSsmlTagMappings[key];
                    switch(key){
                        case "address":
                        case "cardinal":
                        case "characters":
                        case "digits":
                        case "expletive":
                        case "fraction":
                        case "number":
                        case "ordinal":
                        case "telephone":
                        case "unit":
                            textModifierObject.tag(ssmlTag, {
                                "interpret-as": key
                            });
                            break;
                        case "date":
                            textModifierObject.tag(ssmlTag, {
                                "interpret-as": key,
                                format: value || "ymd"
                            });
                            break;
                        case "time":
                            textModifierObject.tag(ssmlTag, {
                                "interpret-as": key,
                                format: value || "hms12"
                            });
                            break;
                        case "ipa":
                            textModifierObject.tag(ssmlTag, {
                                alphabet: key,
                                ph: value
                            });
                            break;
                        case "sub":
                            textModifierObject.tag(ssmlTag, {
                                alias: value
                            });
                            break;
                        case "volume":
                        case "rate":
                            var attrs = {};
                            attrs[key] = value || "medium";
                            textModifierObject.tag(ssmlTag, attrs, true);
                            break;
                        case "lang":
                            textModifierObject.tag(ssmlTag, {
                                "xml:lang": value
                            });
                            break;
                        case "drc":
                            textModifierObject.tag(ssmlTag, {
                                "name": key
                            });
                            break;
                        // unavailable tags
                        case "excited":
                        case "disappointed":
                        case "emphasis":
                        case "interjection":
                        case "voice":
                        case "whisper":
                            break;
                        default:
                    }
                    break;
            }
        }
        return textModifierObject;
    };
    // tslint:disable-next-line: max-func-body-length
    AmazonPollyNeuralSsmlFormatter.prototype.getSectionObject = function(ast) {
        var sectionObject = new $jK8qR.TagsObject(this);
        for(var index = 0; index < ast.children.length; index++){
            var child = ast.children[index];
            if (child.name === "sectionModifierKeyOptionalValue") {
                var key = child.children[0].allText;
                var value = child.children.length === 2 ? child.children[1].allText : "";
                var ssmlTag = this.modifierKeyToSsmlTagMappings[key];
                switch(key){
                    case "lang":
                        sectionObject.tag(ssmlTag, {
                            "xml:lang": value
                        });
                        break;
                    case "newscaster":
                        sectionObject.tag(ssmlTag, {
                            "name": "news"
                        });
                        break;
                    case "defaults":
                        break;
                    case "voice":
                    case "dj":
                    case "excited":
                    case "disappointed":
                        break;
                    default:
                }
            }
        }
        return sectionObject;
    };
    // tslint:disable-next-line: max-func-body-length
    AmazonPollyNeuralSsmlFormatter.prototype.formatFromAst = function(ast, lines) {
        if (lines === void 0) lines = [];
        switch(ast.name){
            case "document":
                if (this.options.includeFormatterComment) this.addComment("Converted from Speech Markdown to SSML for Amazon Polly", lines);
                if (this.options.includeSpeakTag) return this.addSpeakTag(ast.children, true, false, null, lines);
                else {
                    this.processAst(ast.children, lines);
                    return lines;
                }
            case "paragraph":
                if (this.options.includeParagraphTag) return this.addTag("p", ast.children, true, false, null, lines);
                else {
                    this.processAst(ast.children, lines);
                    return lines;
                }
            case "shortBreak":
                var time = ast.children[0].allText;
                return this.addTagWithAttrs(lines, null, "break", {
                    time: time
                });
            case "break":
                var val = ast.children[0].allText;
                var attrs = {};
                switch(ast.children[0].children[0].name){
                    case "breakStrengthValue":
                        attrs = {
                            strength: val
                        };
                        break;
                    case "time":
                        attrs = {
                            time: val
                        };
                        break;
                }
                return this.addTagWithAttrs(lines, null, "break", attrs);
            case "markTag":
                var name = ast.children[0].allText;
                return this.addTagWithAttrs(lines, null, "mark", {
                    name: name
                });
            case "textModifier":
                var tmo_1 = this.getTextModifierObject(ast);
                var tagsSortedDesc = Object.keys(tmo_1.tags).sort(function(a, b) {
                    return tmo_1.tags[b].sortId - tmo_1.tags[a].sortId;
                });
                var inner = tmo_1.text;
                for(var index = 0; index < tagsSortedDesc.length; index++){
                    var tag = tagsSortedDesc[index];
                    var attrs = tmo_1.tags[tag].attrs;
                    inner = this.getTagWithAttrs(inner, tag, attrs);
                }
                lines.push(inner);
                return lines;
            case "section":
                var so_1 = this.getSectionObject(ast);
                var tagsSortedAsc = Object.keys(so_1.tags).sort(function(a, b) {
                    return so_1.tags[a].sortId - so_1.tags[b].sortId;
                });
                this.addSectionEndTag(lines);
                this.addSectionStartTag(tagsSortedAsc, so_1, lines);
                return lines;
            case "simpleLine":
                this.processAst(ast.children, lines);
                return lines;
            case "lineEnd":
                lines.push(ast.allText);
                return lines;
            case "emptyLine":
                if (this.options.preserveEmptyLines) lines.push(ast.allText);
                return lines;
            case "shortEmphasisModerate":
            case "shortEmphasisStrong":
            case "shortEmphasisNone":
            case "shortEmphasisReduced":
                lines.push(ast.allText.replace(/\+/g, ""));
                return lines;
            case "plainText":
            case "plainTextSpecialChars":
                lines.push(ast.allText);
                return lines;
            default:
                this.processAst(ast.children, lines);
                return lines;
        }
    };
    return AmazonPollyNeuralSsmlFormatter;
}($jK8qR.SsmlFormatterBase);
module.exports.AmazonPollyNeuralSsmlFormatter = $acaa803a8691e6af$var$AmazonPollyNeuralSsmlFormatter;

});

parcelRequire.register("cQlSY", function(module, exports) {
"use strict";
var $959b51699a023f5a$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $jK8qR = parcelRequire("jK8qR");
var $959b51699a023f5a$var$GoogleAssistantSsmlFormatter = /** @class */ function(_super) {
    $959b51699a023f5a$var$__extends(GoogleAssistantSsmlFormatter, _super);
    function GoogleAssistantSsmlFormatter(options) {
        var _this = _super.call(this, options) || this;
        _this.options = options;
        _this.validVoices = {
            "Ivy": {
                voice: {
                    gender: "female",
                    variant: 1,
                    language: "en-US"
                }
            },
            "Joanna": {
                voice: {
                    gender: "female",
                    variant: 2,
                    language: "en-US"
                }
            },
            "Joey": {
                voice: {
                    gender: "male",
                    variant: 1,
                    language: "en-US"
                }
            },
            "Justin": {
                voice: {
                    gender: "male",
                    variant: 2,
                    language: "en-US"
                }
            },
            "Kendra": {
                voice: {
                    gender: "female",
                    variant: 3,
                    language: "en-US"
                }
            },
            "Kimberly": {
                voice: {
                    gender: "female",
                    variant: 4,
                    language: "en-US"
                }
            },
            "Matthew": {
                voice: {
                    gender: "male",
                    variant: 3,
                    language: "en-US"
                }
            },
            "Salli": {
                voice: {
                    gender: "male",
                    variant: 4,
                    language: "en-US"
                }
            },
            "Nicole": {
                voice: {
                    gender: "female",
                    variant: 1,
                    language: "en-AU"
                }
            },
            "Russell": {
                voice: {
                    gender: "male",
                    variant: 1,
                    language: "en-AU"
                }
            },
            "Amy": {
                voice: {
                    gender: "female",
                    variant: 1,
                    language: "en-GB"
                }
            },
            "Brian": {
                voice: {
                    gender: "male",
                    variant: 1,
                    language: "en-GB"
                }
            },
            "Emma": {
                voice: {
                    gender: "female",
                    variant: 2,
                    language: "en-GB"
                }
            },
            "Aditi": {
                voice: {
                    gender: "female",
                    variant: 1,
                    language: "en-IN"
                }
            },
            "Raveena": {
                voice: {
                    gender: "female",
                    variant: 2,
                    language: "en-IN"
                }
            },
            "Hans": {
                voice: {
                    gender: "male",
                    variant: 1,
                    language: "de-DE"
                }
            },
            "Marlene": {
                voice: {
                    gender: "female",
                    variant: 1,
                    language: "de-DE"
                }
            },
            "Vicki": {
                voice: {
                    gender: "female",
                    variant: 2,
                    language: "de-DE"
                }
            },
            "Conchita": {
                voice: {
                    gender: "female",
                    variant: 1,
                    language: "es-ES"
                }
            },
            "Enrique": {
                voice: {
                    gender: "male",
                    variant: 1,
                    language: "es-ES"
                }
            },
            "Carla": {
                voice: {
                    gender: "female",
                    variant: 1,
                    language: "it-IT"
                }
            },
            "Giorgio": {
                voice: {
                    gender: "male",
                    variant: 1,
                    language: "it-IT"
                }
            },
            "Mizuki": {
                voice: {
                    gender: "female",
                    variant: 1,
                    language: "ja-JP"
                }
            },
            "Takumi": {
                voice: {
                    gender: "male",
                    variant: 1,
                    language: "ja-JP"
                }
            },
            "Celine": {
                voice: {
                    gender: "female",
                    variant: 1,
                    language: "fr-FR"
                }
            },
            "Lea": {
                voice: {
                    gender: "female",
                    variant: 2,
                    language: "fr-FR"
                }
            },
            "Mathieu": {
                voice: {
                    gender: "male",
                    variant: 1,
                    language: "fr-FR"
                }
            }
        };
        _this.modifierKeyToSsmlTagMappings.interjection = null;
        _this.modifierKeyToSsmlTagMappings.whisper = "prosody";
        _this.modifierKeyToSsmlTagMappings.lang = "lang";
        return _this;
    }
    // tslint:disable-next-line: max-func-body-length
    GoogleAssistantSsmlFormatter.prototype.getTextModifierObject = function(ast) {
        var textModifierObject = new $jK8qR.TagsObject(this);
        for(var index = 0; index < ast.children.length; index++){
            var child = ast.children[index];
            switch(child.name){
                case "plainText":
                case "plainTextSpecialChars":
                case "plainTextEmphasis":
                case "plainTextPhone":
                case "plainTextModifier":
                    textModifierObject["text"] = child.allText;
                    break;
                case "textModifierKeyOptionalValue":
                    var key = child.children[0].allText;
                    key = this.modifierKeyMappings[key] || key;
                    var value = child.children.length === 2 ? child.children[1].allText : "";
                    var ssmlTag = this.modifierKeyToSsmlTagMappings[key];
                    switch(key){
                        case "emphasis":
                            textModifierObject.tag(ssmlTag, {
                                level: value || "moderate"
                            });
                            break;
                        case "address":
                        case "characters":
                        case "expletive":
                        case "fraction":
                        case "number":
                        case "ordinal":
                        case "telephone":
                        case "unit":
                            textModifierObject.tag(ssmlTag, {
                                "interpret-as": key
                            });
                            break;
                        case "date":
                            textModifierObject.tag(ssmlTag, {
                                "interpret-as": key,
                                format: value || "ymd"
                            });
                            break;
                        case "time":
                            textModifierObject.tag(ssmlTag, {
                                "interpret-as": key,
                                format: value || "hms12"
                            });
                            break;
                        case "whisper":
                            textModifierObject.tag(ssmlTag, {
                                volume: "x-soft",
                                rate: "slow"
                            });
                            break;
                        case "ipa":
                            textModifierObject.tag(ssmlTag, {
                                alphabet: key,
                                ph: value
                            });
                            break;
                        case "sub":
                            textModifierObject.tag(ssmlTag, {
                                alias: value
                            });
                            break;
                        case "volume":
                        case "rate":
                        case "pitch":
                            var attrs = {};
                            attrs[key] = value || "medium";
                            textModifierObject.tag(ssmlTag, attrs, true);
                            break;
                        case "lang":
                            textModifierObject.tag(ssmlTag, {
                                "xml:lang": value
                            });
                            break;
                        case "voice":
                            textModifierObject.voiceTag(key, value);
                            break;
                        default:
                    }
                    break;
            }
        }
        return textModifierObject;
    };
    // tslint:disable-next-line: max-func-body-length
    GoogleAssistantSsmlFormatter.prototype.getSectionObject = function(ast) {
        var sectionObject = new $jK8qR.TagsObject(this);
        for(var index = 0; index < ast.children.length; index++){
            var child = ast.children[index];
            if (child.name === "sectionModifierKeyOptionalValue") {
                var key = child.children[0].allText;
                var value = child.children.length === 2 ? child.children[1].allText : "";
                var ssmlTag = this.modifierKeyToSsmlTagMappings[key];
                switch(key){
                    case "lang":
                        sectionObject.tag(ssmlTag, {
                            "xml:lang": value
                        });
                        break;
                    case "voice":
                        sectionObject.voiceTag(key, value);
                        break;
                    case "defaults":
                        break;
                    default:
                }
            }
        }
        return sectionObject;
    };
    // tslint:disable-next-line: max-func-body-length
    GoogleAssistantSsmlFormatter.prototype.formatFromAst = function(ast, lines) {
        if (lines === void 0) lines = [];
        switch(ast.name){
            case "document":
                if (this.options.includeFormatterComment) this.addComment("Converted from Speech Markdown to SSML for Google Assistant", lines);
                if (this.options.includeSpeakTag) return this.addSpeakTag(ast.children, true, false, null, lines);
                else {
                    this.processAst(ast.children, lines);
                    return lines;
                }
            case "paragraph":
                if (this.options.includeParagraphTag) return this.addTag("p", ast.children, true, false, null, lines);
                else {
                    this.processAst(ast.children, lines);
                    return lines;
                }
            case "shortBreak":
                var time = ast.children[0].allText;
                return this.addTagWithAttrs(lines, null, "break", {
                    time: time
                });
            case "break":
                var val = ast.children[0].allText;
                var attrs = {};
                switch(ast.children[0].children[0].name){
                    case "breakStrengthValue":
                        attrs = {
                            strength: val
                        };
                        break;
                    case "time":
                        attrs = {
                            time: val
                        };
                        break;
                }
                return this.addTagWithAttrs(lines, null, "break", attrs);
            case "markTag":
                var name = ast.children[0].allText;
                return this.addTagWithAttrs(lines, null, "mark", {
                    name: name
                });
            case "shortEmphasisModerate":
                var text = ast.children[0].allText;
                return this.addTagWithAttrs(lines, text, "emphasis", {
                    level: "moderate"
                });
            case "shortEmphasisStrong":
                var text = ast.children[0].allText;
                return this.addTagWithAttrs(lines, text, "emphasis", {
                    level: "strong"
                });
            case "shortEmphasisNone":
                var text = ast.children[0].allText;
                return this.addTagWithAttrs(lines, text, "emphasis", {
                    level: "none"
                });
            case "shortEmphasisReduced":
                var text = ast.children[0].allText;
                return this.addTagWithAttrs(lines, text, "emphasis", {
                    level: "reduced"
                });
            case "textModifier":
                var tmo_1 = this.getTextModifierObject(ast);
                if (tmo_1.textOnly) {
                    // Quick return if tag is not supported
                    lines.push(tmo_1.text);
                    return lines;
                }
                var tagsSortedDesc = Object.keys(tmo_1.tags).sort(function(a, b) {
                    return tmo_1.tags[b].sortId - tmo_1.tags[a].sortId;
                });
                var inner = tmo_1.text;
                for(var index = 0; index < tagsSortedDesc.length; index++){
                    var tag = tagsSortedDesc[index];
                    var attrs = tmo_1.tags[tag].attrs;
                    inner = this.getTagWithAttrs(inner, tag, attrs);
                }
                lines.push(inner);
                return lines;
            case "section":
                var so_1 = this.getSectionObject(ast);
                var tagsSortedAsc = Object.keys(so_1.tags).sort(function(a, b) {
                    return so_1.tags[a].sortId - so_1.tags[b].sortId;
                });
                this.addSectionEndTag(lines);
                this.addSectionStartTag(tagsSortedAsc, so_1, lines);
                return lines;
            case "audio":
                var url = ast.children[0].allText.replace(/&/g, "&amp;");
                return this.addTagWithAttrs(lines, null, "audio", {
                    src: url
                });
            case "simpleLine":
                this.processAst(ast.children, lines);
                return lines;
            case "lineEnd":
                lines.push(ast.allText);
                return lines;
            case "emptyLine":
                if (this.options.preserveEmptyLines) lines.push(ast.allText);
                return lines;
            case "plainText":
            case "plainTextSpecialChars":
                lines.push(ast.allText);
                return lines;
            default:
                this.processAst(ast.children, lines);
                return lines;
        }
    };
    return GoogleAssistantSsmlFormatter;
}($jK8qR.SsmlFormatterBase);
module.exports.GoogleAssistantSsmlFormatter = $959b51699a023f5a$var$GoogleAssistantSsmlFormatter;

});

parcelRequire.register("9Lhzm", function(module, exports) {
"use strict";
var $71b621b96aa8a55e$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $jK8qR = parcelRequire("jK8qR");
var $71b621b96aa8a55e$var$SamsungBixbySsmlFormatter = /** @class */ function(_super) {
    $71b621b96aa8a55e$var$__extends(SamsungBixbySsmlFormatter, _super);
    function SamsungBixbySsmlFormatter(options) {
        var _this = _super.call(this, options) || this;
        _this.options = options;
        _this.modifierKeyToSsmlTagMappings.emphasis = null;
        _this.modifierKeyToSsmlTagMappings.address = null;
        _this.modifierKeyToSsmlTagMappings.number = "say-as";
        _this.modifierKeyToSsmlTagMappings.characters = "say-as";
        _this.modifierKeyToSsmlTagMappings.expletive = null;
        _this.modifierKeyToSsmlTagMappings.fraction = "say-as";
        _this.modifierKeyToSsmlTagMappings.interjection = null;
        _this.modifierKeyToSsmlTagMappings.ordinal = "say-as";
        _this.modifierKeyToSsmlTagMappings.telephone = null;
        _this.modifierKeyToSsmlTagMappings.unit = null;
        _this.modifierKeyToSsmlTagMappings.time = null;
        _this.modifierKeyToSsmlTagMappings.date = null;
        _this.modifierKeyToSsmlTagMappings.sub = "sub";
        _this.modifierKeyToSsmlTagMappings.ipa = null;
        _this.modifierKeyToSsmlTagMappings.rate = "prosody";
        _this.modifierKeyToSsmlTagMappings.pitch = "prosody";
        _this.modifierKeyToSsmlTagMappings.volume = "prosody";
        _this.modifierKeyToSsmlTagMappings.whisper = "prosody";
        return _this;
    }
    // tslint:disable-next-line: max-func-body-length
    SamsungBixbySsmlFormatter.prototype.getTextModifierObject = function(ast) {
        var textModifierObject = new $jK8qR.TagsObject(this);
        for(var index = 0; index < ast.children.length; index++){
            var child = ast.children[index];
            switch(child.name){
                case "plainText":
                case "plainTextSpecialChars":
                case "plainTextEmphasis":
                case "plainTextPhone":
                case "plainTextModifier":
                    textModifierObject["text"] = child.allText;
                    break;
                case "textModifierKeyOptionalValue":
                    var key = child.children[0].allText;
                    key = this.modifierKeyMappings[key] || key;
                    var value = child.children.length === 2 ? child.children[1].allText : "";
                    var ssmlTag = this.modifierKeyToSsmlTagMappings[key];
                    switch(key){
                        // case 'emphasis': {
                        //   if (!textModifierObject.tags[ssmlTag]) {
                        //     textModifierObject.tags[ssmlTag] = { sortId: sortId, attrs: null };
                        //   }
                        //   textModifierObject.tags[ssmlTag].attrs = { level: value || 'moderate' };
                        //   break;
                        // }
                        // case 'address':
                        // case 'expletive':
                        // case 'telephone':
                        // case 'unit':
                        case "fraction":
                        case "ordinal":
                            textModifierObject.tag(ssmlTag, {
                                "interpret-as": key
                            });
                            break;
                        case "number":
                            textModifierObject.tag(ssmlTag, {
                                "interpret-as": "cardinal"
                            });
                            break;
                        case "characters":
                            var attrValue = "digits";
                            if (isNaN(textModifierObject.text)) attrValue = "spell-out";
                            textModifierObject.tag(ssmlTag, {
                                "interpret-as": attrValue
                            });
                            break;
                        // case 'date': {
                        //   if (!textModifierObject.tags[ssmlTag]) {
                        //     textModifierObject.tags[ssmlTag] = { sortId: sortId, attrs: null };
                        //   }
                        //   textModifierObject.tags[ssmlTag].attrs = { 'interpret-as': key, format: value || 'ymd' };
                        //   break;
                        // }
                        // case 'time': {
                        //   if (!textModifierObject.tags[ssmlTag]) {
                        //     textModifierObject.tags[ssmlTag] = { sortId: sortId, attrs: null };
                        //   }
                        //   textModifierObject.tags[ssmlTag].attrs = { 'interpret-as': key, format: value || 'hms12' };
                        //   break;
                        // }
                        case "whisper":
                            textModifierObject.tag(ssmlTag, {
                                volume: "x-soft",
                                rate: "slow"
                            });
                            break;
                        // case 'ipa': {
                        //   // Google Assistant does not support <phoneme> tag
                        //   if (!textModifierObject.tags[ssmlTag]) {
                        //     textModifierObject.tags[ssmlTag] = { sortId: sortId, attrs: null };
                        //   }
                        //   textModifierObject['textOnly'] = true;
                        //   break;
                        // }
                        case "sub":
                            textModifierObject.tag(ssmlTag, {
                                alias: value
                            });
                            break;
                        case "volume":
                        case "rate":
                        case "pitch":
                            var attrs = {};
                            attrs[key] = value || "medium";
                            textModifierObject.tag(ssmlTag, attrs, true);
                            break;
                        default:
                    }
                    break;
            }
        }
        return textModifierObject;
    };
    // tslint:disable-next-line: max-func-body-length
    SamsungBixbySsmlFormatter.prototype.formatFromAst = function(ast, lines) {
        if (lines === void 0) lines = [];
        switch(ast.name){
            case "document":
                if (this.options.includeFormatterComment) this.addComment("Converted from Speech Markdown to SSML for Samsung Bixby", lines);
                if (this.options.includeSpeakTag) return this.addSpeakTag(ast.children, true, false, null, lines);
                else {
                    this.processAst(ast.children, lines);
                    return lines;
                }
            case "paragraph":
                if (this.options.includeParagraphTag) return this.addTag("p", ast.children, true, false, null, lines);
                else {
                    this.processAst(ast.children, lines);
                    return lines;
                }
            case "shortBreak":
                var time = ast.children[0].allText;
                return this.addTagWithAttrs(lines, null, "break", {
                    time: time
                });
            case "break":
                var val = ast.children[0].allText;
                var attrs = {};
                switch(ast.children[0].children[0].name){
                    case "breakStrengthValue":
                        attrs = {
                            strength: val
                        };
                        break;
                    case "time":
                        attrs = {
                            time: val
                        };
                        break;
                }
                return this.addTagWithAttrs(lines, null, "break", attrs);
            case "shortEmphasisModerate":
            case "shortEmphasisStrong":
            case "shortEmphasisNone":
            case "shortEmphasisReduced":
                var text = ast.children[0].allText;
                if (text) lines.push(text);
                return lines;
            // case 'shortEmphasisStrong': {
            //   const text = ast.children[0].allText;
            //   return this.addTagWithAttrs(lines, text, 'emphasis', { level: 'strong' });
            // }
            // case 'shortEmphasisNone': {
            //   const text = ast.children[0].allText;
            //   return this.addTagWithAttrs(lines, text, 'emphasis', { level: 'none' });
            // }
            // case 'shortEmphasisReduced': {
            //   const text = ast.children[0].allText;
            //   return this.addTagWithAttrs(lines, text, 'emphasis', { level: 'reduced' });
            // }
            // case 'textModifier': {
            //   const tmo = this.getTextModifierObject(ast);
            //   if (tmo.textOnly) {
            //     // Quick return if tag is not supported
            //     lines.push(tmo.text)
            //     return lines
            //   }
            //   const tagsSortedDesc = Object.keys(tmo.tags).sort((a: any, b: any) => { return tmo.tags[b].sortId - tmo.tags[a].sortId });
            //   let inner = tmo.text;
            //   for (let index = 0; index < tagsSortedDesc.length; index++) {
            //     const tag = tagsSortedDesc[index];
            //     const attrs = tmo.tags[tag].attrs;
            //     inner = this.getTagWithAttrs(inner, tag, attrs);
            //   }
            //   lines.push(inner);
            //   return lines;
            // }
            case "textModifier":
                var tmo_1 = this.getTextModifierObject(ast);
                if (tmo_1.textOnly) {
                    // Quick return if tag is not supported
                    lines.push(tmo_1.text);
                    return lines;
                }
                var tagsSortedDesc = Object.keys(tmo_1.tags).sort(function(a, b) {
                    return tmo_1.tags[b].sortId - tmo_1.tags[a].sortId;
                });
                var inner = tmo_1.text;
                for(var index = 0; index < tagsSortedDesc.length; index++){
                    var tag = tagsSortedDesc[index];
                    var attrs = tmo_1.tags[tag].attrs;
                    inner = this.getTagWithAttrs(inner, tag, attrs);
                }
                lines.push(inner);
                return lines;
            case "audio":
                var url = ast.children[0].allText.replace(/&/g, "&amp;");
                return this.addTagWithAttrs(lines, null, "audio", {
                    src: url
                }, true);
            case "simpleLine":
                this.processAst(ast.children, lines);
                return lines;
            case "lineEnd":
                lines.push(ast.allText);
                return lines;
            case "emptyLine":
                if (this.options.preserveEmptyLines) lines.push(ast.allText);
                return lines;
            case "plainText":
            case "plainTextSpecialChars":
            case "plainTextEmphasis":
            case "plainTextPhone":
            case "plainTextModifier":
                lines.push(ast.allText);
                return lines;
            default:
                this.processAst(ast.children, lines);
                return lines;
        }
    };
    return SamsungBixbySsmlFormatter;
}($jK8qR.SsmlFormatterBase);
module.exports.SamsungBixbySsmlFormatter = $71b621b96aa8a55e$var$SamsungBixbySsmlFormatter;

});

parcelRequire.register("fvjGB", function(module, exports) {
"use strict";
var $b499058319e6af51$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $jK8qR = parcelRequire("jK8qR");
var $b499058319e6af51$var$MicrosoftAzureSsmlFormatter = /** @class */ function(_super) {
    $b499058319e6af51$var$__extends(MicrosoftAzureSsmlFormatter, _super);
    function MicrosoftAzureSsmlFormatter(options) {
        var _this = _super.call(this, options) || this;
        _this.options = options;
        _this.modifierKeyToSsmlTagMappings.emphasis = "emphasis";
        _this.modifierKeyToSsmlTagMappings.address = "say-as";
        _this.modifierKeyToSsmlTagMappings.number = "say-as";
        _this.modifierKeyToSsmlTagMappings.characters = "say-as";
        _this.modifierKeyToSsmlTagMappings.expletive = null;
        _this.modifierKeyToSsmlTagMappings.fraction = "say-as";
        _this.modifierKeyToSsmlTagMappings.interjection = null;
        _this.modifierKeyToSsmlTagMappings.ordinal = "say-as";
        _this.modifierKeyToSsmlTagMappings.telephone = "say-as";
        _this.modifierKeyToSsmlTagMappings.unit = null;
        _this.modifierKeyToSsmlTagMappings.time = "say-as";
        _this.modifierKeyToSsmlTagMappings.date = "say-as";
        _this.modifierKeyToSsmlTagMappings.sub = "sub";
        _this.modifierKeyToSsmlTagMappings.paragraph = "p";
        _this.modifierKeyToSsmlTagMappings.sentence = "s";
        _this.modifierKeyToSsmlTagMappings.lang = "lang";
        _this.modifierKeyToSsmlTagMappings.voice = "voice";
        // Phoneme attributes
        _this.modifierKeyToSsmlTagMappings.ipa = "phoneme";
        _this.modifierKeyToSsmlTagMappings.sapi = "phoneme";
        _this.modifierKeyToSsmlTagMappings.ups = "phoneme";
        // Prosody attributes
        _this.modifierKeyToSsmlTagMappings.pitch = "prosody";
        _this.modifierKeyToSsmlTagMappings.contour = "prosody";
        _this.modifierKeyToSsmlTagMappings.range = "prosody";
        _this.modifierKeyToSsmlTagMappings.rate = "prosody";
        _this.modifierKeyToSsmlTagMappings.volume = "prosody";
        _this.modifierKeyToSsmlTagMappings.whisper = "prosody";
        // mstts specifics
        _this.modifierKeyToSsmlTagMappings.emotion = "mstts:express-as";
        _this.ssmlTagSortOrder = [
            "voice",
            "lang",
            "p",
            "s",
            "emphasis",
            "say-as",
            "mstts:express-as",
            "prosody",
            "sub",
            "phoneme"
        ];
        return _this;
    }
    // tslint:disable-next-line: max-func-body-length
    MicrosoftAzureSsmlFormatter.prototype.getTextModifierObject = function(ast) {
        var textModifierObject = new $jK8qR.TagsObject(this);
        for(var index = 0; index < ast.children.length; index++){
            var child = ast.children[index];
            switch(child.name){
                case "plainText":
                case "plainTextSpecialChars":
                case "plainTextEmphasis":
                case "plainTextPhone":
                case "plainTextModifier":
                    textModifierObject["text"] = child.allText;
                    break;
                case "textModifierKeyOptionalValue":
                    var key = child.children[0].allText;
                    key = this.modifierKeyMappings[key] || key;
                    var value = child.children.length === 2 ? child.children[1].allText : "";
                    var ssmlTag = this.modifierKeyToSsmlTagMappings[key];
                    switch(key){
                        case "address":
                        case "fraction":
                        case "ordinal":
                        case "telephone":
                            textModifierObject.tag(ssmlTag, {
                                "interpret-as": key
                            }, false, this.ssmlTagSortOrder);
                            break;
                        case "number":
                            textModifierObject.tag(ssmlTag, {
                                "interpret-as": "cardinal"
                            }, false, this.ssmlTagSortOrder);
                            break;
                        case "characters":
                            var attrValue = "digits";
                            if (isNaN(textModifierObject.text)) attrValue = "characters";
                            textModifierObject.tag(ssmlTag, {
                                "interpret-as": attrValue
                            }, false, this.ssmlTagSortOrder);
                            break;
                        case "date":
                            textModifierObject.tag(ssmlTag, {
                                "interpret-as": key,
                                format: value || "ymd"
                            }, false, this.ssmlTagSortOrder);
                            break;
                        case "time":
                            textModifierObject.tag(ssmlTag, {
                                "interpret-as": key,
                                format: value || "hms12"
                            }, false, this.ssmlTagSortOrder);
                            break;
                        case "whisper":
                            textModifierObject.tag(ssmlTag, {
                                volume: "x-soft",
                                rate: "slow"
                            }, false, this.ssmlTagSortOrder);
                            break;
                        case "ipa":
                        case "sapi":
                        case "ups":
                            textModifierObject.tag(ssmlTag, {
                                alphabet: key,
                                ph: value
                            }, false, this.ssmlTagSortOrder);
                            break;
                        case "sub":
                            textModifierObject.tag(ssmlTag, {
                                alias: value
                            }, false, this.ssmlTagSortOrder);
                            break;
                        case "volume":
                        case "rate":
                        case "pitch":
                            var attrs = {};
                            attrs[key] = value || "medium";
                            textModifierObject.tag(ssmlTag, attrs, true, this.ssmlTagSortOrder);
                            break;
                        case "lang":
                            textModifierObject.tag(ssmlTag, {
                                "xml:lang": value
                            }, false, this.ssmlTagSortOrder);
                            break;
                        case "voice":
                            // Voice name must be as follows (case insensitive, the examples give the common writing with case) :
                            // <language>-<CULTURE>-<VoiceName> (ex: en-US-GuyNeural, en-US-JennyNeural)
                            var name = this.sentenceCase(value || "device");
                            if (name != "Device") textModifierObject.tag(ssmlTag, {
                                "name": name
                            }, false, this.ssmlTagSortOrder);
                            break;
                        case "emotion":
                            // The 'value' field can contain up to 2 data, separated by a space. Let's explode the value string
                            var attrsArray = value.split(" ");
                            var attrs = {};
                            // In order, we get 'style' first, then 'styledegree' or 'role' from the value
                            switch(attrsArray.length){
                                case 2:
                                    var parsed = parseInt(attrsArray[1]);
                                    // If the result is a number, it's the 'styledegree' attribute, either way it's the 'role' one
                                    if (isNaN(parsed)) attrs["role"] = attrsArray[1];
                                    else attrs["styledegree"] = attrsArray[1];
                                case 1:
                                    attrs["style"] = attrsArray[0];
                                    break;
                                default:
                                    break;
                            }
                            textModifierObject.tag(ssmlTag, attrs, true, this.ssmlTagSortOrder);
                            break;
                        case "emphasis":
                            textModifierObject.tag(ssmlTag, {
                                "level": value
                            }, false, this.ssmlTagSortOrder);
                            break;
                        case "paragraph":
                            textModifierObject.tag(ssmlTag, null, false, this.ssmlTagSortOrder);
                            break;
                        case "sentence":
                            textModifierObject.tag(ssmlTag, null, false, this.ssmlTagSortOrder);
                            break;
                        default:
                    }
                    break;
            }
        }
        return textModifierObject;
    };
    // tslint:disable-next-line: max-func-body-length
    MicrosoftAzureSsmlFormatter.prototype.getSectionObject = function(ast) {
        var sectionObject = new $jK8qR.TagsObject(this);
        for(var index = 0; index < ast.children.length; index++){
            var child = ast.children[index];
            if (child.name === "sectionModifierKeyOptionalValue") {
                var key = child.children[0].allText;
                var value = child.children.length === 2 ? child.children[1].allText : "";
                var ssmlTag = this.modifierKeyToSsmlTagMappings[key];
                switch(key){
                    case "voice":
                        // Voice name must be as follows (case insensitive, the examples give the common writing with case) :
                        // <language>-<CULTURE>-<VoiceName> (ex: en-US-GuyNeural, en-US-JennyNeural)
                        var name = this.sentenceCase(value || "device");
                        if (name != "Device") sectionObject.tag(ssmlTag, {
                            "name": name
                        }, false, this.ssmlTagSortOrder);
                        break;
                    case "defaults":
                        break;
                    case "emotion":
                        sectionObject.tag(ssmlTag, {
                            "style": value
                        }, false, this.ssmlTagSortOrder);
                        break;
                    default:
                }
            }
        }
        return sectionObject;
    };
    // tslint:disable-next-line: max-func-body-length
    MicrosoftAzureSsmlFormatter.prototype.formatFromAst = function(ast, lines) {
        if (lines === void 0) lines = [];
        switch(ast.name){
            case "document":
                if (this.options.includeFormatterComment) this.addComment("Converted from Speech Markdown to SSML for Microsoft Azure", lines);
                if (this.options.includeSpeakTag) return this.addSpeakTag(ast.children, true, false, null, lines);
                else {
                    this.processAst(ast.children, lines);
                    return lines;
                }
            case "paragraph":
                if (this.options.includeParagraphTag) return this.addTag("p", ast.children, true, false, null, lines);
                else {
                    this.processAst(ast.children, lines);
                    return lines;
                }
            case "shortBreak":
                var time = ast.children[0].allText;
                return this.addTagWithAttrs(lines, null, "break", {
                    time: time
                });
            case "break":
                var val = ast.children[0].allText;
                var attrs = {};
                switch(ast.children[0].children[0].name){
                    case "breakStrengthValue":
                        attrs = {
                            strength: val
                        };
                        break;
                    case "time":
                        attrs = {
                            time: val
                        };
                        break;
                }
                return this.addTagWithAttrs(lines, null, "break", attrs);
            case "silence":
                // 2 attributes, space-separated : type and value
                // type can be : Leading, Tailing or Sentenceboundary
                // value in seconds or milliseconds (ex : 1s, 200ms) less than 5 seconds
                var attrsArray = ast.children[0].allText.split(" ");
                var attrs = {
                    "type": attrsArray[0],
                    "value": attrsArray[1]
                };
                return this.addTagWithAttrs(lines, null, "mstts:silence", attrs);
            case "backgroundAudio":
                // 1 to 4 attributes, space-separated : src (mandatory), volume, fadein, fadeout
                var attrsArray = ast.children[0].allText.split(" ");
                var attrs = {};
                var attributes = [
                    "src",
                    "volume",
                    "fadein",
                    "fadeout"
                ];
                for(var i = 0; i < attrsArray.length; i++)attrs[attributes[i]] = attrsArray[i];
                return this.addTagWithAttrs(lines, null, "mstts:backgroundaudio", attrs);
            case "lexicon":
                var uri = ast.children[0].allText;
                return this.addTagWithAttrs(lines, null, "lexicon", {
                    uri: uri
                });
            case "bookmark":
                var mark = ast.children[0].allText;
                return this.addTagWithAttrs(lines, null, "bookmark", {
                    mark: mark
                });
            case "shortEmphasisModerate":
            case "shortEmphasisStrong":
            case "shortEmphasisNone":
            case "shortEmphasisReduced":
                var text = ast.children[0].allText;
                if (text) lines.push(text);
                return lines;
            case "textModifier":
                var tmo_1 = this.getTextModifierObject(ast);
                var tagsSortedDesc = Object.keys(tmo_1.tags).sort(function(a, b) {
                    return tmo_1.tags[b].sortId - tmo_1.tags[a].sortId;
                });
                var inner = tmo_1.text;
                for(var index = 0; index < tagsSortedDesc.length; index++){
                    var tag = tagsSortedDesc[index];
                    var attrs = tmo_1.tags[tag].attrs;
                    if (tag === "voice" || tag === "lang") {
                        var previousTag = index < tagsSortedDesc.length - 1 ? tagsSortedDesc[index + 1] : "";
                        inner = this.getVoiceOrLangTagWithAttrs(inner, tag, attrs, previousTag);
                    } else inner = this.getTagWithAttrs(inner, tag, attrs);
                }
                lines.push(inner);
                return lines;
            case "audio":
                var url = ast.children[0].allText.replace(/&/g, "&amp;");
                return this.addTagWithAttrs(lines, null, "audio", {
                    src: url
                }, false);
            case "simpleLine":
                this.processAst(ast.children, lines);
                return lines;
            case "lineEnd":
                lines.push(ast.allText);
                return lines;
            case "emptyLine":
                if (this.options.preserveEmptyLines) lines.push(ast.allText);
                return lines;
            case "plainText":
            case "plainTextSpecialChars":
            case "plainTextEmphasis":
            case "plainTextPhone":
            case "plainTextModifier":
                lines.push(ast.allText);
                return lines;
            case "section":
                var so_1 = this.getSectionObject(ast);
                var tagsSortedAsc = Object.keys(so_1.tags).sort(function(a, b) {
                    return so_1.tags[a].sortId - so_1.tags[b].sortId;
                });
                this.addSectionEndTag(lines);
                this.addSectionStartTag(tagsSortedAsc, so_1, lines);
                return lines;
            default:
                this.processAst(ast.children, lines);
                return lines;
        }
    };
    MicrosoftAzureSsmlFormatter.prototype.getVoiceOrLangTagWithAttrs = function(text, tag, attrs, previousTag) {
        var lines = [];
        if (text) {
            lines.push(this.startVoiceOrLangTag(tag, attrs, previousTag));
            lines.push(text);
            lines.push(this.endVoiceOrLangTag(tag, false, previousTag));
        } else lines.push(this.voidTag(tag, attrs));
        return lines.join("");
    };
    // Returns the SSML for a start tag
    MicrosoftAzureSsmlFormatter.prototype.startVoiceOrLangTag = function(tag, attr, previousTag, newLine) {
        if (newLine === void 0) newLine = false;
        var attrStr = "";
        var prefix = "";
        switch(tag){
            case "voice":
                // If a global 'voice' tag is opened at the root of the SSML file, we have to close it and re-open it every time another 'voice' tag opens
                if (this.options.globalVoiceAndLang && this.options.globalVoiceAndLang.voice) {
                    prefix = "</voice>";
                    // If there is a global lang, let's open a new tag for this lang
                    if (this.options.globalVoiceAndLang && this.options.globalVoiceAndLang.lang) prefix = "</lang>" + prefix;
                }
                break;
            case "lang":
                // If the previous tag was a 'voice' one, we use the basic behaviour
                if (!(previousTag && previousTag === "voice")) {
                    if (this.options.globalVoiceAndLang && this.options.globalVoiceAndLang.lang) prefix = "</lang>";
                }
                break;
            default:
                break;
        }
        if (attr) attrStr = " " + Object.keys(attr).map(function(k) {
            return k + '="' + attr[k] + '"';
        }).join(" ");
        return prefix + "<" + tag + attrStr + ">" + (newLine ? "\n" : "");
    };
    // Returns the SSML for an end tag
    MicrosoftAzureSsmlFormatter.prototype.endVoiceOrLangTag = function(tag, newLine, previousTag) {
        if (newLine === void 0) newLine = false;
        var suffix = "";
        switch(tag){
            case "voice":
                // If a global 'voice' tag is opened at the root of the SSML file, we have to re-open it every time another 'voice' tag ends
                if (this.options.globalVoiceAndLang && this.options.globalVoiceAndLang.voice) {
                    suffix = '<voice name="' + this.options.globalVoiceAndLang.voice + '">';
                    // If a global 'lang' tag is opened at the root of the SSML file, we have to re-open it every time a 'voice' tag ends
                    if (this.options.globalVoiceAndLang && this.options.globalVoiceAndLang.lang) suffix += '<lang xml:lang="' + this.options.globalVoiceAndLang.lang + '">';
                }
                break;
            case "lang":
                // If the previous tag was a 'voice' one, we use the basic behaviour
                if (!(previousTag && previousTag === "voice")) {
                    if (this.options.globalVoiceAndLang && this.options.globalVoiceAndLang.lang && tag === "lang") suffix = '<lang xml:lang="' + this.options.globalVoiceAndLang.lang + '">';
                }
                break;
            default:
                break;
        }
        return (newLine ? "\n" : "") + "</" + tag + ">" + suffix;
    };
    return MicrosoftAzureSsmlFormatter;
}($jK8qR.SsmlFormatterBase);
module.exports.MicrosoftAzureSsmlFormatter = $b499058319e6af51$var$MicrosoftAzureSsmlFormatter;

});


parcelRequire.register("kojeU", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStoreWithSelector", () => $ed84f9168eca01df$export$bf730a2d8bf68b42, (v) => $ed84f9168eca01df$export$bf730a2d8bf68b42 = v);
/**
 * @license React
 * use-sync-external-store-shim/with-selector.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $ed84f9168eca01df$export$bf730a2d8bf68b42;
"use strict";

var $eO7Kz = parcelRequire("eO7Kz");

var $bqHew = parcelRequire("bqHew");
function $ed84f9168eca01df$var$p(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $ed84f9168eca01df$var$q = "function" === typeof Object.is ? Object.is : $ed84f9168eca01df$var$p, $ed84f9168eca01df$var$r = $bqHew.useSyncExternalStore, $ed84f9168eca01df$var$t = $eO7Kz.useRef, $ed84f9168eca01df$var$u = $eO7Kz.useEffect, $ed84f9168eca01df$var$v = $eO7Kz.useMemo, $ed84f9168eca01df$var$w = $eO7Kz.useDebugValue;
$ed84f9168eca01df$export$bf730a2d8bf68b42 = function(a, b, e, l, g) {
    var c = $ed84f9168eca01df$var$t(null);
    if (null === c.current) {
        var f = {
            hasValue: !1,
            value: null
        };
        c.current = f;
    } else f = c.current;
    c = $ed84f9168eca01df$var$v(function() {
        function a(a) {
            if (!c) {
                c = !0;
                d = a;
                a = l(a);
                if (void 0 !== g && f.hasValue) {
                    var b = f.value;
                    if (g(b, a)) return k = b;
                }
                return k = a;
            }
            b = k;
            if ($ed84f9168eca01df$var$q(d, a)) return b;
            var e = l(a);
            if (void 0 !== g && g(b, e)) return b;
            d = a;
            return k = e;
        }
        var c = !1, d, k, m = void 0 === e ? null : e;
        return [
            function() {
                return a(b());
            },
            null === m ? void 0 : function() {
                return a(m());
            }
        ];
    }, [
        b,
        e,
        l,
        g
    ]);
    var d = $ed84f9168eca01df$var$r(a, c[0], c[1]);
    $ed84f9168eca01df$var$u(function() {
        f.hasValue = !0;
        f.value = d;
    }, [
        d
    ]);
    $ed84f9168eca01df$var$w(d);
    return d;
};

});
parcelRequire.register("bqHew", function(module, exports) {
"use strict";

module.exports = (parcelRequire("4rQ3q"));

});
parcelRequire.register("4rQ3q", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStore", () => $33d20ff05f8dd1ab$export$306c0aa65ff9ec16, (v) => $33d20ff05f8dd1ab$export$306c0aa65ff9ec16 = v);
/**
 * @license React
 * use-sync-external-store-shim.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $33d20ff05f8dd1ab$export$306c0aa65ff9ec16;
"use strict";

var $eO7Kz = parcelRequire("eO7Kz");
function $33d20ff05f8dd1ab$var$h(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $33d20ff05f8dd1ab$var$k = "function" === typeof Object.is ? Object.is : $33d20ff05f8dd1ab$var$h, $33d20ff05f8dd1ab$var$l = $eO7Kz.useState, $33d20ff05f8dd1ab$var$m = $eO7Kz.useEffect, $33d20ff05f8dd1ab$var$n = $eO7Kz.useLayoutEffect, $33d20ff05f8dd1ab$var$p = $eO7Kz.useDebugValue;
function $33d20ff05f8dd1ab$var$q(a, b) {
    var d = b(), f = $33d20ff05f8dd1ab$var$l({
        inst: {
            value: d,
            getSnapshot: b
        }
    }), c = f[0].inst, g = f[1];
    $33d20ff05f8dd1ab$var$n(function() {
        c.value = d;
        c.getSnapshot = b;
        $33d20ff05f8dd1ab$var$r(c) && g({
            inst: c
        });
    }, [
        a,
        d,
        b
    ]);
    $33d20ff05f8dd1ab$var$m(function() {
        $33d20ff05f8dd1ab$var$r(c) && g({
            inst: c
        });
        return a(function() {
            $33d20ff05f8dd1ab$var$r(c) && g({
                inst: c
            });
        });
    }, [
        a
    ]);
    $33d20ff05f8dd1ab$var$p(d);
    return d;
}
function $33d20ff05f8dd1ab$var$r(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var d = b();
        return !$33d20ff05f8dd1ab$var$k(a, d);
    } catch (f) {
        return !0;
    }
}
function $33d20ff05f8dd1ab$var$t(a, b) {
    return b();
}
var $33d20ff05f8dd1ab$var$u = "undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement ? $33d20ff05f8dd1ab$var$t : $33d20ff05f8dd1ab$var$q;
$33d20ff05f8dd1ab$export$306c0aa65ff9ec16 = void 0 !== $eO7Kz.useSyncExternalStore ? $eO7Kz.useSyncExternalStore : $33d20ff05f8dd1ab$var$u;

});



parcelRequire.register("c6BU9", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Strings = void 0;
// eslint-disable-next-line @typescript-eslint/no-extraneous-class
var $8d0372a4e7eb8cfd$var$Strings = /** @class */ function() {
    function Strings() {}
    Strings.errors = {
        unknownElementType: function(typeName) {
            return 'Unknown element type "'.concat(typeName, '". Fallback will be used if present.');
        },
        unknownActionType: function(typeName) {
            return 'Unknown action type "'.concat(typeName, '". Fallback will be used if present.');
        },
        elementTypeNotAllowed: function(typeName) {
            return 'Element type "'.concat(typeName, '" is not allowed in this context.');
        },
        actionTypeNotAllowed: function(typeName) {
            return 'Action type "'.concat(typeName, '" is not allowed in this context.');
        },
        invalidPropertyValue: function(value, propertyName) {
            return 'Invalid value "'.concat(value, '" for property "').concat(propertyName, '".');
        },
        showCardMustHaveCard: function() {
            return '"An Action.ShowCard must have its "card" property set to a valid AdaptiveCard object.';
        },
        invalidColumnWidth: function(invalidWidth) {
            return 'Invalid column width "'.concat(invalidWidth, '" - defaulting to "auto".');
        },
        invalidCardVersion: function(defaultingToVersion) {
            return 'Invalid card version. Defaulting to "'.concat(defaultingToVersion, '".');
        },
        invalidVersionString: function(versionString) {
            return 'Invalid version string "'.concat(versionString, '".');
        },
        propertyValueNotSupported: function(value, propertyName, supportedInVersion, versionUsed) {
            return 'Value "'.concat(value, '" for property "').concat(propertyName, '" is supported in version ').concat(supportedInVersion, ", but you are using version ").concat(versionUsed, ".");
        },
        propertyNotSupported: function(propertyName, supportedInVersion, versionUsed) {
            return 'Property "'.concat(propertyName, '" is supported in version ').concat(supportedInVersion, ", but you are using version ").concat(versionUsed, ".");
        },
        indexOutOfRange: function(index) {
            return "Index out of range (".concat(index, ").");
        },
        elementCannotBeUsedAsInline: function() {
            return "RichTextBlock.addInline: the specified card element cannot be used as a RichTextBlock inline.";
        },
        inlineAlreadyParented: function() {
            return "RichTextBlock.addInline: the specified inline already belongs to another RichTextBlock.";
        },
        interactivityNotAllowed: function() {
            return "Interactivity is not allowed.";
        },
        inputsMustHaveUniqueId: function() {
            return "All inputs must have a unique Id.";
        },
        choiceSetMustHaveAtLeastOneChoice: function() {
            return "An Input.ChoiceSet must have at least one choice defined.";
        },
        choiceSetChoicesMustHaveTitleAndValue: function() {
            return "All choices in an Input.ChoiceSet must have their title and value properties set.";
        },
        propertyMustBeSet: function(propertyName) {
            return 'Property "'.concat(propertyName, '" must be set.');
        },
        actionHttpHeadersMustHaveNameAndValue: function() {
            return "All headers of an Action.Http must have their name and value properties set.";
        },
        tooManyActions: function(maximumActions) {
            return "Maximum number of actions exceeded (".concat(maximumActions, ").");
        },
        tooLittleTimeDelay: function(minAutoplayDelay) {
            return "Autoplay Delay is too short (".concat(minAutoplayDelay, ").");
        },
        tooManyCarouselPages: function(maxCarouselPages) {
            return "Maximum number of Carousel pages exceeded (".concat(maxCarouselPages, ").");
        },
        invalidInitialPageIndex: function(initialPageIndex) {
            return "InitialPage for carousel is invalid (".concat(initialPageIndex, ").");
        },
        columnAlreadyBelongsToAnotherSet: function() {
            return "This column already belongs to another ColumnSet.";
        },
        invalidCardType: function() {
            return 'Invalid or missing card type. Make sure the card\'s type property is set to "AdaptiveCard".';
        },
        unsupportedCardVersion: function(version, maxSupportedVersion) {
            return "The specified card version (".concat(version, ") is not supported or still in preview. The latest released card version is ").concat(maxSupportedVersion, ".");
        },
        duplicateId: function(id) {
            return 'Duplicate Id "'.concat(id, '".');
        },
        markdownProcessingNotEnabled: function() {
            return "Markdown processing isn't enabled. Please see https://www.npmjs.com/package/adaptivecards#supporting-markdown";
        },
        processMarkdownEventRemoved: function() {
            return "The processMarkdown event has been removed. Please update your code and set onProcessMarkdown instead.";
        },
        elementAlreadyParented: function() {
            return "The element already belongs to another container.";
        },
        actionAlreadyParented: function() {
            return "The action already belongs to another element.";
        },
        elementTypeNotStandalone: function(typeName) {
            return "Elements of type ".concat(typeName, " cannot be used as standalone elements.");
        },
        invalidInputLabelWidth: function() {
            return "Invalid input label width. Defaulting to label width from host config.";
        }
    };
    Strings.magicCodeInputCard = {
        tryAgain: function() {
            return "That didn't work... let's try again.";
        },
        pleaseLogin: function() {
            return 'Please login in the popup. You will obtain a magic code. Paste that code below and select "Submit"';
        },
        enterMagicCode: function() {
            return "Enter magic code";
        },
        pleaseEnterMagicCodeYouReceived: function() {
            return "Please enter the magic code you received.";
        },
        submit: function() {
            return "Submit";
        },
        cancel: function() {
            return "Cancel";
        },
        somethingWentWrong: function() {
            return "Something went wrong. This action can't be handled.";
        },
        authenticationFailed: function() {
            return "Authentication failed.";
        }
    };
    Strings.runtime = {
        automaticRefreshPaused: function() {
            return "Automatic refresh paused.";
        },
        clckToRestartAutomaticRefresh: function() {
            return "Click to restart.";
        },
        refreshThisCard: function() {
            return "Refresh this card";
        }
    };
    Strings.hints = {
        dontUseWeightedAndStrecthedColumnsInSameSet: function() {
            return "It is not recommended to use weighted and stretched columns in the same ColumnSet, because in such a situation stretched columns will always get the minimum amount of space.";
        }
    };
    Strings.defaults = {
        inlineActionTitle: function() {
            return "Inline Action";
        },
        overflowButtonText: function() {
            return "...";
        },
        overflowButtonTooltip: function() {
            return "More options";
        },
        mediaPlayerAriaLabel: function() {
            return "Media content";
        },
        mediaPlayerPlayMedia: function() {
            return "Play media";
        },
        youTubeVideoPlayer: function() {
            return "YouTube video player";
        },
        vimeoVideoPlayer: function() {
            return "Vimeo video player";
        },
        dailymotionVideoPlayer: function() {
            return "Dailymotion video player";
        },
        carouselNavigationPreviousTooltip: function() {
            return "Previous carousel page";
        },
        carouselNavigationNextTooltip: function() {
            return "Next carousel page";
        }
    };
    return Strings;
}();
module.exports.Strings = $8d0372a4e7eb8cfd$var$Strings;

});

parcelRequire.register("kD48O", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActionRole = module.exports.CarouselInteractionEvent = module.exports.LogLevel = module.exports.RefreshMode = module.exports.TypeErrorType = module.exports.ContainerFitStatus = module.exports.ValidationEvent = module.exports.ValidationPhase = module.exports.InputLabelPosition = module.exports.InputTextStyle = module.exports.ActionIconPlacement = module.exports.FillMode = module.exports.Orientation = module.exports.ShowCardActionMode = module.exports.ImageStyle = module.exports.ActionAlignment = module.exports.VerticalAlignment = module.exports.HorizontalAlignment = module.exports.TextColor = module.exports.Spacing = module.exports.FontType = module.exports.TextWeight = module.exports.InputStyle = module.exports.TextSize = module.exports.SizeUnit = module.exports.ImageSetPresentationStyle = module.exports.ImageSize = module.exports.Size = module.exports.ActionMode = module.exports.ActionStyle = module.exports.ContainerStyle = void 0;
/*
    This should really be a string enum, e.g.

        export enum ContainerStyle {
            Default = "default",
            Emphasis = "emphasis"
        }

    However, some hosts do not use a version of TypeScript
    recent enough to understand string enums. This is
    a compatible construct that does not require using
    a more recent version of TypeScript.

    Also note the "weird" way these readonly fields are declared is to work around
    a breaking change introduced in TS 3.1 wrt d.ts generation. DO NOT CHANGE
    and adopt this syntax for all other static readonly fields.
*/ /* eslint-disable @typescript-eslint/no-extraneous-class, @typescript-eslint/naming-convention */ var $f04aa97bcdfb4e73$var$ContainerStyle = /** @class */ function() {
    function ContainerStyle() {}
    ContainerStyle.Default = "default";
    ContainerStyle.Emphasis = "emphasis";
    ContainerStyle.Accent = "accent";
    ContainerStyle.Good = "good";
    ContainerStyle.Attention = "attention";
    ContainerStyle.Warning = "warning";
    return ContainerStyle;
}();
module.exports.ContainerStyle = $f04aa97bcdfb4e73$var$ContainerStyle;
var $f04aa97bcdfb4e73$var$ActionStyle = /** @class */ function() {
    function ActionStyle() {}
    ActionStyle.Default = "default";
    ActionStyle.Positive = "positive";
    ActionStyle.Destructive = "destructive";
    return ActionStyle;
}();
module.exports.ActionStyle = $f04aa97bcdfb4e73$var$ActionStyle;
var $f04aa97bcdfb4e73$var$ActionMode = /** @class */ function() {
    function ActionMode() {}
    ActionMode.Primary = "primary";
    ActionMode.Secondary = "secondary";
    return ActionMode;
}();
module.exports.ActionMode = $f04aa97bcdfb4e73$var$ActionMode;
/* eslint-enable @typescript-eslint/no-extraneous-class, @typescript-eslint/naming-convention */ var $f04aa97bcdfb4e73$var$Size;
(function(Size) {
    Size[Size["Auto"] = 0] = "Auto";
    Size[Size["Stretch"] = 1] = "Stretch";
    Size[Size["Small"] = 2] = "Small";
    Size[Size["Medium"] = 3] = "Medium";
    Size[Size["Large"] = 4] = "Large";
})($f04aa97bcdfb4e73$var$Size = module.exports.Size || (module.exports.Size = {}));
var $f04aa97bcdfb4e73$var$ImageSize;
(function(ImageSize) {
    ImageSize[ImageSize["Small"] = 0] = "Small";
    ImageSize[ImageSize["Medium"] = 1] = "Medium";
    ImageSize[ImageSize["Large"] = 2] = "Large";
})($f04aa97bcdfb4e73$var$ImageSize = module.exports.ImageSize || (module.exports.ImageSize = {}));
var $f04aa97bcdfb4e73$var$ImageSetPresentationStyle;
(function(ImageSetPresentationStyle) {
    ImageSetPresentationStyle[ImageSetPresentationStyle["Default"] = 0] = "Default";
    ImageSetPresentationStyle[ImageSetPresentationStyle["Stacked"] = 1] = "Stacked";
})($f04aa97bcdfb4e73$var$ImageSetPresentationStyle = module.exports.ImageSetPresentationStyle || (module.exports.ImageSetPresentationStyle = {}));
var $f04aa97bcdfb4e73$var$SizeUnit;
(function(SizeUnit) {
    SizeUnit[SizeUnit["Weight"] = 0] = "Weight";
    SizeUnit[SizeUnit["Pixel"] = 1] = "Pixel";
})($f04aa97bcdfb4e73$var$SizeUnit = module.exports.SizeUnit || (module.exports.SizeUnit = {}));
var $f04aa97bcdfb4e73$var$TextSize;
(function(TextSize) {
    TextSize[TextSize["Small"] = 0] = "Small";
    TextSize[TextSize["Default"] = 1] = "Default";
    TextSize[TextSize["Medium"] = 2] = "Medium";
    TextSize[TextSize["Large"] = 3] = "Large";
    TextSize[TextSize["ExtraLarge"] = 4] = "ExtraLarge";
})($f04aa97bcdfb4e73$var$TextSize = module.exports.TextSize || (module.exports.TextSize = {}));
var $f04aa97bcdfb4e73$var$InputStyle;
(function(InputStyle) {
    InputStyle[InputStyle["RevealOnHover"] = 0] = "RevealOnHover";
    InputStyle[InputStyle["Default"] = 1] = "Default";
})($f04aa97bcdfb4e73$var$InputStyle = module.exports.InputStyle || (module.exports.InputStyle = {}));
var $f04aa97bcdfb4e73$var$TextWeight;
(function(TextWeight) {
    TextWeight[TextWeight["Lighter"] = 0] = "Lighter";
    TextWeight[TextWeight["Default"] = 1] = "Default";
    TextWeight[TextWeight["Bolder"] = 2] = "Bolder";
})($f04aa97bcdfb4e73$var$TextWeight = module.exports.TextWeight || (module.exports.TextWeight = {}));
var $f04aa97bcdfb4e73$var$FontType;
(function(FontType) {
    FontType[FontType["Default"] = 0] = "Default";
    FontType[FontType["Monospace"] = 1] = "Monospace";
})($f04aa97bcdfb4e73$var$FontType = module.exports.FontType || (module.exports.FontType = {}));
var $f04aa97bcdfb4e73$var$Spacing;
(function(Spacing) {
    Spacing[Spacing["None"] = 0] = "None";
    Spacing[Spacing["Small"] = 1] = "Small";
    Spacing[Spacing["Default"] = 2] = "Default";
    Spacing[Spacing["Medium"] = 3] = "Medium";
    Spacing[Spacing["Large"] = 4] = "Large";
    Spacing[Spacing["ExtraLarge"] = 5] = "ExtraLarge";
    Spacing[Spacing["Padding"] = 6] = "Padding";
})($f04aa97bcdfb4e73$var$Spacing = module.exports.Spacing || (module.exports.Spacing = {}));
var $f04aa97bcdfb4e73$var$TextColor;
(function(TextColor) {
    TextColor[TextColor["Default"] = 0] = "Default";
    TextColor[TextColor["Dark"] = 1] = "Dark";
    TextColor[TextColor["Light"] = 2] = "Light";
    TextColor[TextColor["Accent"] = 3] = "Accent";
    TextColor[TextColor["Good"] = 4] = "Good";
    TextColor[TextColor["Warning"] = 5] = "Warning";
    TextColor[TextColor["Attention"] = 6] = "Attention";
})($f04aa97bcdfb4e73$var$TextColor = module.exports.TextColor || (module.exports.TextColor = {}));
var $f04aa97bcdfb4e73$var$HorizontalAlignment;
(function(HorizontalAlignment) {
    HorizontalAlignment[HorizontalAlignment["Left"] = 0] = "Left";
    HorizontalAlignment[HorizontalAlignment["Center"] = 1] = "Center";
    HorizontalAlignment[HorizontalAlignment["Right"] = 2] = "Right";
})($f04aa97bcdfb4e73$var$HorizontalAlignment = module.exports.HorizontalAlignment || (module.exports.HorizontalAlignment = {}));
var $f04aa97bcdfb4e73$var$VerticalAlignment;
(function(VerticalAlignment) {
    VerticalAlignment[VerticalAlignment["Top"] = 0] = "Top";
    VerticalAlignment[VerticalAlignment["Center"] = 1] = "Center";
    VerticalAlignment[VerticalAlignment["Bottom"] = 2] = "Bottom";
})($f04aa97bcdfb4e73$var$VerticalAlignment = module.exports.VerticalAlignment || (module.exports.VerticalAlignment = {}));
var $f04aa97bcdfb4e73$var$ActionAlignment;
(function(ActionAlignment) {
    ActionAlignment[ActionAlignment["Left"] = 0] = "Left";
    ActionAlignment[ActionAlignment["Center"] = 1] = "Center";
    ActionAlignment[ActionAlignment["Right"] = 2] = "Right";
    ActionAlignment[ActionAlignment["Stretch"] = 3] = "Stretch";
})($f04aa97bcdfb4e73$var$ActionAlignment = module.exports.ActionAlignment || (module.exports.ActionAlignment = {}));
var $f04aa97bcdfb4e73$var$ImageStyle;
(function(ImageStyle) {
    ImageStyle[ImageStyle["Default"] = 0] = "Default";
    ImageStyle[ImageStyle["Person"] = 1] = "Person";
})($f04aa97bcdfb4e73$var$ImageStyle = module.exports.ImageStyle || (module.exports.ImageStyle = {}));
var $f04aa97bcdfb4e73$var$ShowCardActionMode;
(function(ShowCardActionMode) {
    ShowCardActionMode[ShowCardActionMode["Inline"] = 0] = "Inline";
    ShowCardActionMode[ShowCardActionMode["Popup"] = 1] = "Popup";
})($f04aa97bcdfb4e73$var$ShowCardActionMode = module.exports.ShowCardActionMode || (module.exports.ShowCardActionMode = {}));
var $f04aa97bcdfb4e73$var$Orientation;
(function(Orientation) {
    Orientation[Orientation["Horizontal"] = 0] = "Horizontal";
    Orientation[Orientation["Vertical"] = 1] = "Vertical";
})($f04aa97bcdfb4e73$var$Orientation = module.exports.Orientation || (module.exports.Orientation = {}));
var $f04aa97bcdfb4e73$var$FillMode;
(function(FillMode) {
    FillMode[FillMode["Cover"] = 0] = "Cover";
    FillMode[FillMode["RepeatHorizontally"] = 1] = "RepeatHorizontally";
    FillMode[FillMode["RepeatVertically"] = 2] = "RepeatVertically";
    FillMode[FillMode["Repeat"] = 3] = "Repeat";
})($f04aa97bcdfb4e73$var$FillMode = module.exports.FillMode || (module.exports.FillMode = {}));
var $f04aa97bcdfb4e73$var$ActionIconPlacement;
(function(ActionIconPlacement) {
    ActionIconPlacement[ActionIconPlacement["LeftOfTitle"] = 0] = "LeftOfTitle";
    ActionIconPlacement[ActionIconPlacement["AboveTitle"] = 1] = "AboveTitle";
})($f04aa97bcdfb4e73$var$ActionIconPlacement = module.exports.ActionIconPlacement || (module.exports.ActionIconPlacement = {}));
var $f04aa97bcdfb4e73$var$InputTextStyle;
(function(InputTextStyle) {
    InputTextStyle[InputTextStyle["Text"] = 0] = "Text";
    InputTextStyle[InputTextStyle["Tel"] = 1] = "Tel";
    InputTextStyle[InputTextStyle["Url"] = 2] = "Url";
    InputTextStyle[InputTextStyle["Email"] = 3] = "Email";
    InputTextStyle[InputTextStyle["Password"] = 4] = "Password";
})($f04aa97bcdfb4e73$var$InputTextStyle = module.exports.InputTextStyle || (module.exports.InputTextStyle = {}));
var $f04aa97bcdfb4e73$var$InputLabelPosition;
(function(InputLabelPosition) {
    InputLabelPosition[InputLabelPosition["Inline"] = 0] = "Inline";
    InputLabelPosition[InputLabelPosition["Above"] = 1] = "Above";
})($f04aa97bcdfb4e73$var$InputLabelPosition = module.exports.InputLabelPosition || (module.exports.InputLabelPosition = {}));
var $f04aa97bcdfb4e73$var$ValidationPhase;
(function(ValidationPhase) {
    ValidationPhase[ValidationPhase["Parse"] = 0] = "Parse";
    ValidationPhase[ValidationPhase["ToJSON"] = 1] = "ToJSON";
    ValidationPhase[ValidationPhase["Validation"] = 2] = "Validation";
})($f04aa97bcdfb4e73$var$ValidationPhase = module.exports.ValidationPhase || (module.exports.ValidationPhase = {}));
var $f04aa97bcdfb4e73$var$ValidationEvent;
(function(ValidationEvent) {
    ValidationEvent[ValidationEvent["Hint"] = 0] = "Hint";
    ValidationEvent[ValidationEvent["ActionTypeNotAllowed"] = 1] = "ActionTypeNotAllowed";
    ValidationEvent[ValidationEvent["CollectionCantBeEmpty"] = 2] = "CollectionCantBeEmpty";
    ValidationEvent[ValidationEvent["Deprecated"] = 3] = "Deprecated";
    ValidationEvent[ValidationEvent["ElementTypeNotAllowed"] = 4] = "ElementTypeNotAllowed";
    ValidationEvent[ValidationEvent["InteractivityNotAllowed"] = 5] = "InteractivityNotAllowed";
    ValidationEvent[ValidationEvent["InvalidPropertyValue"] = 6] = "InvalidPropertyValue";
    ValidationEvent[ValidationEvent["MissingCardType"] = 7] = "MissingCardType";
    ValidationEvent[ValidationEvent["PropertyCantBeNull"] = 8] = "PropertyCantBeNull";
    ValidationEvent[ValidationEvent["TooManyActions"] = 9] = "TooManyActions";
    ValidationEvent[ValidationEvent["UnknownActionType"] = 10] = "UnknownActionType";
    ValidationEvent[ValidationEvent["UnknownElementType"] = 11] = "UnknownElementType";
    ValidationEvent[ValidationEvent["UnsupportedCardVersion"] = 12] = "UnsupportedCardVersion";
    ValidationEvent[ValidationEvent["DuplicateId"] = 13] = "DuplicateId";
    ValidationEvent[ValidationEvent["UnsupportedProperty"] = 14] = "UnsupportedProperty";
    ValidationEvent[ValidationEvent["RequiredInputsShouldHaveLabel"] = 15] = "RequiredInputsShouldHaveLabel";
    ValidationEvent[ValidationEvent["RequiredInputsShouldHaveErrorMessage"] = 16] = "RequiredInputsShouldHaveErrorMessage";
    ValidationEvent[ValidationEvent["Other"] = 17] = "Other";
})($f04aa97bcdfb4e73$var$ValidationEvent = module.exports.ValidationEvent || (module.exports.ValidationEvent = {}));
var $f04aa97bcdfb4e73$var$ContainerFitStatus;
(function(ContainerFitStatus) {
    ContainerFitStatus[ContainerFitStatus["FullyInContainer"] = 0] = "FullyInContainer";
    ContainerFitStatus[ContainerFitStatus["Overflowing"] = 1] = "Overflowing";
    ContainerFitStatus[ContainerFitStatus["FullyOutOfContainer"] = 2] = "FullyOutOfContainer";
})($f04aa97bcdfb4e73$var$ContainerFitStatus = module.exports.ContainerFitStatus || (module.exports.ContainerFitStatus = {}));
var $f04aa97bcdfb4e73$var$TypeErrorType;
(function(TypeErrorType) {
    TypeErrorType[TypeErrorType["UnknownType"] = 0] = "UnknownType";
    TypeErrorType[TypeErrorType["ForbiddenType"] = 1] = "ForbiddenType";
})($f04aa97bcdfb4e73$var$TypeErrorType = module.exports.TypeErrorType || (module.exports.TypeErrorType = {}));
var $f04aa97bcdfb4e73$var$RefreshMode;
(function(RefreshMode) {
    RefreshMode[RefreshMode["Disabled"] = 0] = "Disabled";
    RefreshMode[RefreshMode["Manual"] = 1] = "Manual";
    RefreshMode[RefreshMode["Automatic"] = 2] = "Automatic";
})($f04aa97bcdfb4e73$var$RefreshMode = module.exports.RefreshMode || (module.exports.RefreshMode = {}));
var $f04aa97bcdfb4e73$var$LogLevel;
(function(LogLevel) {
    LogLevel[LogLevel["Info"] = 0] = "Info";
    LogLevel[LogLevel["Warning"] = 1] = "Warning";
    LogLevel[LogLevel["Error"] = 2] = "Error";
})($f04aa97bcdfb4e73$var$LogLevel = module.exports.LogLevel || (module.exports.LogLevel = {}));
var $f04aa97bcdfb4e73$var$CarouselInteractionEvent;
(function(CarouselInteractionEvent) {
    CarouselInteractionEvent[CarouselInteractionEvent["NavigationNext"] = 0] = "NavigationNext";
    CarouselInteractionEvent[CarouselInteractionEvent["NavigationPrevious"] = 1] = "NavigationPrevious";
    CarouselInteractionEvent[CarouselInteractionEvent["Pagination"] = 2] = "Pagination";
    CarouselInteractionEvent[CarouselInteractionEvent["Autoplay"] = 3] = "Autoplay";
})($f04aa97bcdfb4e73$var$CarouselInteractionEvent = module.exports.CarouselInteractionEvent || (module.exports.CarouselInteractionEvent = {}));
var $f04aa97bcdfb4e73$var$ActionRole;
(function(ActionRole) {
    ActionRole[ActionRole["Button"] = 0] = "Button";
    ActionRole[ActionRole["Link"] = 1] = "Link";
    ActionRole[ActionRole["Tab"] = 2] = "Tab";
    ActionRole[ActionRole["Menu"] = 3] = "Menu";
    ActionRole[ActionRole["MenuItem"] = 4] = "MenuItem";
})($f04aa97bcdfb4e73$var$ActionRole = module.exports.ActionRole || (module.exports.ActionRole = {}));

});

parcelRequire.register("8Lw6d", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.UUID = module.exports.SizeAndUnit = module.exports.PaddingDefinition = module.exports.SpacingDefinition = module.exports.StringWithSubstitutions = module.exports.ContentTypes = module.exports.GlobalSettings = void 0;

var $kD48O = parcelRequire("kD48O");
// eslint-disable-next-line @typescript-eslint/no-extraneous-class
var $661b9cc67bdbd6a3$var$GlobalSettings = /** @class */ function() {
    function GlobalSettings() {}
    GlobalSettings.useAdvancedTextBlockTruncation = true;
    GlobalSettings.useAdvancedCardBottomTruncation = false;
    GlobalSettings.useMarkdownInRadioButtonAndCheckbox = true;
    GlobalSettings.allowMarkForTextHighlighting = false;
    GlobalSettings.alwaysBleedSeparators = false;
    GlobalSettings.enableFullJsonRoundTrip = false;
    GlobalSettings.displayInputValidationErrors = true;
    GlobalSettings.allowPreProcessingPropertyValues = false;
    GlobalSettings.setTabIndexAtCardRoot = true;
    GlobalSettings.enableFallback = true;
    GlobalSettings.useWebkitLineClamp = true;
    GlobalSettings.allowMoreThanMaxActionsInOverflowMenu = false;
    GlobalSettings.removePaddingFromContainersWithBackgroundImage = false;
    GlobalSettings.resetInputsDirtyStateAfterActionExecution = true;
    GlobalSettings.applets = {
        logEnabled: true,
        logLevel: $kD48O.LogLevel.Error,
        maximumRetryAttempts: 3,
        defaultTimeBetweenRetryAttempts: 3000,
        authPromptWidth: 400,
        authPromptHeight: 600,
        refresh: {
            mode: $kD48O.RefreshMode.Manual,
            timeBetweenAutomaticRefreshes: 3000,
            maximumConsecutiveAutomaticRefreshes: 3,
            allowManualRefreshesAfterAutomaticRefreshes: true
        }
    };
    return GlobalSettings;
}();
module.exports.GlobalSettings = $661b9cc67bdbd6a3$var$GlobalSettings;
module.exports.ContentTypes = {
    applicationJson: "application/json",
    applicationXWwwFormUrlencoded: "application/x-www-form-urlencoded"
};
var $661b9cc67bdbd6a3$var$StringWithSubstitutions = /** @class */ function() {
    function StringWithSubstitutions() {
        this._isProcessed = false;
    }
    StringWithSubstitutions.prototype.getReferencedInputs = function(inputs, referencedInputs) {
        if (!referencedInputs) throw new Error("The referencedInputs parameter cannot be null.");
        if (this._original) for(var _i = 0, inputs_1 = inputs; _i < inputs_1.length; _i++){
            var input = inputs_1[_i];
            var matches = new RegExp("\\{{2}(" + input.id + ").value\\}{2}", "gi").exec(this._original);
            if (matches != null && input.id) referencedInputs[input.id] = input;
        }
    };
    StringWithSubstitutions.prototype.substituteInputValues = function(inputs, contentType) {
        this._processed = this._original;
        if (this._original) {
            var regEx = /\{{2}([a-z0-9_$@]+).value\}{2}/gi;
            var matches = void 0;
            while((matches = regEx.exec(this._original)) !== null && this._processed)for(var _i = 0, _a = Object.keys(inputs); _i < _a.length; _i++){
                var key = _a[_i];
                if (key.toLowerCase() === matches[1].toLowerCase()) {
                    var matchedInput = inputs[key];
                    var valueForReplace = "";
                    if (matchedInput.value) valueForReplace = matchedInput.value;
                    if (contentType === module.exports.ContentTypes.applicationJson) {
                        valueForReplace = JSON.stringify(valueForReplace);
                        valueForReplace = valueForReplace.slice(1, -1);
                    } else if (contentType === module.exports.ContentTypes.applicationXWwwFormUrlencoded) valueForReplace = encodeURIComponent(valueForReplace);
                    this._processed = this._processed.replace(matches[0], valueForReplace);
                    break;
                }
            }
        }
        this._isProcessed = true;
    };
    StringWithSubstitutions.prototype.getOriginal = function() {
        return this._original;
    };
    StringWithSubstitutions.prototype.get = function() {
        if (!this._isProcessed) return this._original;
        else return this._processed;
    };
    StringWithSubstitutions.prototype.set = function(value) {
        this._original = value;
        this._isProcessed = false;
    };
    return StringWithSubstitutions;
}();
module.exports.StringWithSubstitutions = $661b9cc67bdbd6a3$var$StringWithSubstitutions;
var $661b9cc67bdbd6a3$var$SpacingDefinition = /** @class */ function() {
    function SpacingDefinition(top, right, bottom, left) {
        if (top === void 0) top = 0;
        if (right === void 0) right = 0;
        if (bottom === void 0) bottom = 0;
        if (left === void 0) left = 0;
        this.left = 0;
        this.top = 0;
        this.right = 0;
        this.bottom = 0;
        this.top = top;
        this.right = right;
        this.bottom = bottom;
        this.left = left;
    }
    return SpacingDefinition;
}();
module.exports.SpacingDefinition = $661b9cc67bdbd6a3$var$SpacingDefinition;
var $661b9cc67bdbd6a3$var$PaddingDefinition = /** @class */ function() {
    function PaddingDefinition(top, right, bottom, left) {
        if (top === void 0) top = $kD48O.Spacing.None;
        if (right === void 0) right = $kD48O.Spacing.None;
        if (bottom === void 0) bottom = $kD48O.Spacing.None;
        if (left === void 0) left = $kD48O.Spacing.None;
        this.top = $kD48O.Spacing.None;
        this.right = $kD48O.Spacing.None;
        this.bottom = $kD48O.Spacing.None;
        this.left = $kD48O.Spacing.None;
        this.top = top;
        this.right = right;
        this.bottom = bottom;
        this.left = left;
    }
    return PaddingDefinition;
}();
module.exports.PaddingDefinition = $661b9cc67bdbd6a3$var$PaddingDefinition;
var $661b9cc67bdbd6a3$var$SizeAndUnit = /** @class */ function() {
    function SizeAndUnit(physicalSize, unit) {
        this.physicalSize = physicalSize;
        this.unit = unit;
    }
    SizeAndUnit.parse = function(input, requireUnitSpecifier) {
        if (requireUnitSpecifier === void 0) requireUnitSpecifier = false;
        var result = new SizeAndUnit(0, $kD48O.SizeUnit.Weight);
        if (typeof input === "number") {
            result.physicalSize = input;
            return result;
        } else if (typeof input === "string") {
            var regExp = /^([0-9]+)(px|\*)?$/g;
            var matches = regExp.exec(input);
            var expectedMatchCount = requireUnitSpecifier ? 3 : 2;
            if (matches && matches.length >= expectedMatchCount) {
                result.physicalSize = parseInt(matches[1]);
                if (matches.length === 3) {
                    if (matches[2] === "px") result.unit = $kD48O.SizeUnit.Pixel;
                }
                return result;
            }
        }
        throw new Error("Invalid size: " + input);
    };
    return SizeAndUnit;
}();
module.exports.SizeAndUnit = $661b9cc67bdbd6a3$var$SizeAndUnit;
/**
 * Fast UUID generator, RFC4122 version 4 compliant.
 * @author Jeff Ward (jcward.com).
 * @license MIT license
 * @link http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/21963136#21963136
 **/ /* eslint-disable @typescript-eslint/no-extraneous-class, @typescript-eslint/naming-convention, no-bitwise */ var $661b9cc67bdbd6a3$var$UUID = /** @class */ function() {
    function UUID() {}
    UUID.generate = function() {
        var d0 = Math.random() * 0xffffffff | 0;
        var d1 = Math.random() * 0xffffffff | 0;
        var d2 = Math.random() * 0xffffffff | 0;
        var d3 = Math.random() * 0xffffffff | 0;
        return UUID.lut[d0 & 0xff] + UUID.lut[d0 >> 8 & 0xff] + UUID.lut[d0 >> 16 & 0xff] + UUID.lut[d0 >> 24 & 0xff] + "-" + UUID.lut[d1 & 0xff] + UUID.lut[d1 >> 8 & 0xff] + "-" + UUID.lut[d1 >> 16 & 0x0f | 0x40] + UUID.lut[d1 >> 24 & 0xff] + "-" + UUID.lut[d2 & 0x3f | 0x80] + UUID.lut[d2 >> 8 & 0xff] + "-" + UUID.lut[d2 >> 16 & 0xff] + UUID.lut[d2 >> 24 & 0xff] + UUID.lut[d3 & 0xff] + UUID.lut[d3 >> 8 & 0xff] + UUID.lut[d3 >> 16 & 0xff] + UUID.lut[d3 >> 24 & 0xff];
    };
    UUID.initialize = function() {
        for(var i = 0; i < 256; i++)UUID.lut[i] = (i < 16 ? "0" : "") + i.toString(16);
    };
    UUID.lut = [];
    return UUID;
}();
module.exports.UUID = $661b9cc67bdbd6a3$var$UUID;
$661b9cc67bdbd6a3$var$UUID.initialize(); /* eslint-enable @typescript-eslint/no-extraneous-class, @typescript-eslint/naming-convention, no-bitwise */ 

});

parcelRequire.register("8QA0A", function(module, exports) {
"use strict";
var $670f1c93586d957c$var$_a;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.debounce = module.exports.addCancelSelectActionEventHandler = module.exports.clearElementChildren = module.exports.getScrollY = module.exports.getScrollX = module.exports.getFitStatus = module.exports.truncate = module.exports.truncateText = module.exports.stringToCssColor = module.exports.parseEnum = module.exports.getEnumValueByName = module.exports.parseBool = module.exports.parseNumber = module.exports.parseString = module.exports.appendChild = module.exports.generateUniqueId = module.exports.isMobileOS = module.exports.isInternetExplorer = void 0;

var $kD48O = parcelRequire("kD48O");

var $8Lw6d = parcelRequire("8Lw6d");
function $670f1c93586d957c$var$isInternetExplorer() {
    // The documentMode property only exists in IE
    return window.document.documentMode !== undefined;
}
module.exports.isInternetExplorer = $670f1c93586d957c$var$isInternetExplorer;
function $670f1c93586d957c$var$isMobileOS() {
    var userAgent = window.navigator.userAgent;
    return !!userAgent.match(/Android/i) || !!userAgent.match(/iPad/i) || !!userAgent.match(/iPhone/i);
}
module.exports.isMobileOS = $670f1c93586d957c$var$isMobileOS;
/**
 * Generate a UUID prepended with "__ac-"
 */ function $670f1c93586d957c$var$generateUniqueId() {
    return "__ac-" + $8Lw6d.UUID.generate();
}
module.exports.generateUniqueId = $670f1c93586d957c$var$generateUniqueId;
function $670f1c93586d957c$var$appendChild(node, child) {
    if (child) node.appendChild(child);
}
module.exports.appendChild = $670f1c93586d957c$var$appendChild;
function $670f1c93586d957c$var$parseString(obj, defaultValue) {
    return typeof obj === "string" ? obj : defaultValue;
}
module.exports.parseString = $670f1c93586d957c$var$parseString;
function $670f1c93586d957c$var$parseNumber(obj, defaultValue) {
    return typeof obj === "number" ? obj : defaultValue;
}
module.exports.parseNumber = $670f1c93586d957c$var$parseNumber;
function $670f1c93586d957c$var$parseBool(value, defaultValue) {
    if (typeof value === "boolean") return value;
    else if (typeof value === "string") switch(value.toLowerCase()){
        case "true":
            return true;
        case "false":
            return false;
        default:
            return defaultValue;
    }
    return defaultValue;
}
module.exports.parseBool = $670f1c93586d957c$var$parseBool;
function $670f1c93586d957c$var$getEnumValueByName(enumType, name) {
    // eslint-disable-next-line guard-for-in
    for(var key in enumType){
        var keyAsNumber = parseInt(key, 10);
        if (keyAsNumber >= 0) {
            var value = enumType[key];
            if (value && typeof value === "string" && value.toLowerCase() === name.toLowerCase()) return keyAsNumber;
        }
    }
    return undefined;
}
module.exports.getEnumValueByName = $670f1c93586d957c$var$getEnumValueByName;
function $670f1c93586d957c$var$parseEnum(enumType, name, defaultValue) {
    if (!name) return defaultValue;
    var enumValue = $670f1c93586d957c$var$getEnumValueByName(enumType, name);
    return enumValue !== undefined ? enumValue : defaultValue;
}
module.exports.parseEnum = $670f1c93586d957c$var$parseEnum;
function $670f1c93586d957c$var$stringToCssColor(color) {
    if (color) {
        var regEx = /#([0-9A-F]{2})([0-9A-F]{2})([0-9A-F]{2})([0-9A-F]{2})?/gi;
        var matches = regEx.exec(color);
        if (matches && matches[4]) {
            var a = parseInt(matches[1], 16) / 255;
            var r = parseInt(matches[2], 16);
            var g = parseInt(matches[3], 16);
            var b = parseInt(matches[4], 16);
            return "rgba(" + r + "," + g + "," + b + "," + a + ")";
        }
    }
    return color;
}
module.exports.stringToCssColor = $670f1c93586d957c$var$stringToCssColor;
function $670f1c93586d957c$var$truncateWorker(element, maxHeight, fullText, truncateAt, lineHeight) {
    var fits = function() {
        // Allow a one pixel overflow to account for rounding differences
        // between browsers
        return maxHeight - element.scrollHeight >= -1;
    };
    if (fits()) return;
    var breakableIndices = $670f1c93586d957c$var$findBreakableIndices(fullText);
    var lo = 0;
    var hi = breakableIndices.length;
    var bestBreakIdx = 0;
    // Do a binary search for the longest string that fits
    while(lo < hi){
        var mid = Math.floor((lo + hi) / 2);
        truncateAt(fullText, breakableIndices[mid]);
        if (fits()) {
            bestBreakIdx = breakableIndices[mid];
            lo = mid + 1;
        } else hi = mid;
    }
    truncateAt(fullText, bestBreakIdx);
    // If we have extra room, try to expand the string letter by letter
    // (covers the case where we have to break in the middle of a long word)
    if (lineHeight && maxHeight - element.scrollHeight >= lineHeight - 1.0) {
        var idx = $670f1c93586d957c$var$findNextCharacter(fullText, bestBreakIdx);
        while(idx < fullText.length){
            truncateAt(fullText, idx);
            if (fits()) {
                bestBreakIdx = idx;
                idx = $670f1c93586d957c$var$findNextCharacter(fullText, idx);
            } else break;
        }
        truncateAt(fullText, bestBreakIdx);
    }
}
function $670f1c93586d957c$var$truncateText(element, maxHeight, lineHeight) {
    $670f1c93586d957c$var$truncateWorker(element, maxHeight, element.innerText, function(text, idx) {
        element.innerText = text.substring(0, idx) + "...";
    }, lineHeight);
}
module.exports.truncateText = $670f1c93586d957c$var$truncateText;
/**
 * {@link truncate} has been deprecated and is no longer in use internally. This policy passes
 * content through as it always has, which is _supposed_ to be dealing with text only (see {@link
 * TextBlock.truncateIfSupported}), but had a bug where it might actually pass through an element
 * for which innerHTML yielded actual HTML (since fixed).
 */ var $670f1c93586d957c$var$ttDeprecatedPolicy = typeof window === "undefined" ? undefined : ($670f1c93586d957c$var$_a = window.trustedTypes) === null || $670f1c93586d957c$var$_a === void 0 ? void 0 : $670f1c93586d957c$var$_a.createPolicy("adaptivecards#deprecatedExportedFunctionPolicy", {
    createHTML: function(value) {
        return value;
    }
});
/** @deprecated Use {@link truncateText} instead. */ function $670f1c93586d957c$var$truncate(element, maxHeight, lineHeight) {
    $670f1c93586d957c$var$truncateWorker(element, maxHeight, element.innerHTML, function(text, idx) {
        var _a;
        var truncatedString = text.substring(0, idx) + "...";
        var truncatedHTML = (_a = $670f1c93586d957c$var$ttDeprecatedPolicy === null || $670f1c93586d957c$var$ttDeprecatedPolicy === void 0 ? void 0 : $670f1c93586d957c$var$ttDeprecatedPolicy.createHTML(truncatedString)) !== null && _a !== void 0 ? _a : truncatedString;
        element.innerHTML = truncatedHTML;
    }, lineHeight);
}
module.exports.truncate = $670f1c93586d957c$var$truncate;
function $670f1c93586d957c$var$findBreakableIndices(html) {
    var results = [];
    var idx = $670f1c93586d957c$var$findNextCharacter(html, -1);
    while(idx < html.length){
        if (html[idx] === " ") results.push(idx);
        idx = $670f1c93586d957c$var$findNextCharacter(html, idx);
    }
    return results;
}
function $670f1c93586d957c$var$findNextCharacter(html, currIdx) {
    currIdx += 1;
    // If we found the start of an HTML tag, keep advancing until we get
    // past it, so we don't end up truncating in the middle of the tag
    while(currIdx < html.length && html[currIdx] === "<"){
        while(currIdx < html.length && html[currIdx++] !== ">")continue;
    }
    return currIdx;
}
function $670f1c93586d957c$var$getFitStatus(element, containerEnd) {
    var start = element.offsetTop;
    var end = start + element.clientHeight;
    if (end <= containerEnd) return $kD48O.ContainerFitStatus.FullyInContainer;
    else if (start < containerEnd) return $kD48O.ContainerFitStatus.Overflowing;
    else return $kD48O.ContainerFitStatus.FullyOutOfContainer;
}
module.exports.getFitStatus = $670f1c93586d957c$var$getFitStatus;
function $670f1c93586d957c$var$getScrollX() {
    return window.pageXOffset;
}
module.exports.getScrollX = $670f1c93586d957c$var$getScrollX;
function $670f1c93586d957c$var$getScrollY() {
    return window.pageYOffset;
}
module.exports.getScrollY = $670f1c93586d957c$var$getScrollY;
function $670f1c93586d957c$var$clearElementChildren(element) {
    while(element.firstChild)element.removeChild(element.firstChild);
}
module.exports.clearElementChildren = $670f1c93586d957c$var$clearElementChildren;
function $670f1c93586d957c$var$addCancelSelectActionEventHandler(element) {
    element.onclick = function(e) {
        e.preventDefault();
        e.cancelBubble = true;
    };
}
module.exports.addCancelSelectActionEventHandler = $670f1c93586d957c$var$addCancelSelectActionEventHandler;
function $670f1c93586d957c$var$debounce(fn, delay) {
    var timer;
    function debouncedFn() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        if (timer) clearTimeout(timer);
        timer = setTimeout(function() {
            fn.apply(void 0, args);
        }, delay);
    }
    return debouncedFn;
}
module.exports.debounce = $670f1c93586d957c$var$debounce;

});

parcelRequire.register("eZfTX", function(module, exports) {
"use strict";
var $ae9318e98d14417a$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SerializableObject = module.exports.property = module.exports.SerializableObjectSchema = module.exports.CustomProperty = module.exports.SerializableObjectCollectionProperty = module.exports.SerializableObjectProperty = module.exports.EnumProperty = module.exports.ValueSetProperty = module.exports.StringArrayProperty = module.exports.PixelSizeProperty = module.exports.NumProperty = module.exports.BoolProperty = module.exports.StringProperty = module.exports.PropertyDefinition = module.exports.BaseSerializationContext = module.exports.isVersionLessOrEqual = module.exports.Versions = module.exports.Version = void 0;

var $8Lw6d = parcelRequire("8Lw6d");

var $8QA0A = parcelRequire("8QA0A");

var $kD48O = parcelRequire("kD48O");

var $c6BU9 = parcelRequire("c6BU9");
var $ae9318e98d14417a$var$Version = /** @class */ function() {
    function Version(major, minor, label) {
        if (major === void 0) major = 1;
        if (minor === void 0) minor = 1;
        this._isValid = true;
        this._major = major;
        this._minor = minor;
        this._label = label;
    }
    Version.parse = function(versionString, context) {
        if (!versionString) return undefined;
        var result = new Version();
        result._versionString = versionString;
        var regEx = /(\d+).(\d+)/gi;
        var matches = regEx.exec(versionString);
        if (matches != null && matches.length === 3) {
            result._major = parseInt(matches[1]);
            result._minor = parseInt(matches[2]);
        } else result._isValid = false;
        if (!result._isValid) context.logParseEvent(undefined, $kD48O.ValidationEvent.InvalidPropertyValue, $c6BU9.Strings.errors.invalidVersionString(result._versionString));
        return result;
    };
    Version.prototype.toString = function() {
        return !this._isValid ? this._versionString : this._major + "." + this._minor;
    };
    Version.prototype.toJSON = function() {
        return this.toString();
    };
    Version.prototype.compareTo = function(otherVersion) {
        if (!this.isValid || !otherVersion.isValid) throw new Error("Cannot compare invalid version.");
        if (this.major > otherVersion.major) return 1;
        else if (this.major < otherVersion.major) return -1;
        else if (this.minor > otherVersion.minor) return 1;
        else if (this.minor < otherVersion.minor) return -1;
        return 0;
    };
    Object.defineProperty(Version.prototype, "label", {
        get: function() {
            return this._label ? this._label : this.toString();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Version.prototype, "major", {
        get: function() {
            return this._major;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Version.prototype, "minor", {
        get: function() {
            return this._minor;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Version.prototype, "isValid", {
        get: function() {
            return this._isValid;
        },
        enumerable: false,
        configurable: true
    });
    return Version;
}();
module.exports.Version = $ae9318e98d14417a$var$Version;
// eslint-disable-next-line @typescript-eslint/no-extraneous-class
var $ae9318e98d14417a$var$Versions = /** @class */ function() {
    function Versions() {}
    /* eslint-enable @typescript-eslint/naming-convention */ Versions.getAllDeclaredVersions = function() {
        var ctor = Versions;
        var properties = [];
        for(var propertyName in ctor){
            if (propertyName.match(/^v[0-9_]*$/)) // filter latest
            try {
                var propertyValue = ctor[propertyName];
                if (propertyValue instanceof $ae9318e98d14417a$var$Version) properties.push(propertyValue);
            } catch (_a) {
            // If a property happens to have a getter function and
            // it throws an exception, we need to catch it here
            }
        }
        return properties.sort(function(v1, v2) {
            return v1.compareTo(v2);
        });
    };
    /* eslint-disable @typescript-eslint/naming-convention */ Versions.v1_0 = new $ae9318e98d14417a$var$Version(1, 0);
    Versions.v1_1 = new $ae9318e98d14417a$var$Version(1, 1);
    Versions.v1_2 = new $ae9318e98d14417a$var$Version(1, 2);
    Versions.v1_3 = new $ae9318e98d14417a$var$Version(1, 3);
    Versions.v1_4 = new $ae9318e98d14417a$var$Version(1, 4);
    Versions.v1_5 = new $ae9318e98d14417a$var$Version(1, 5);
    // If preview tag is added/removed from any version,
    // don't forget to update .ac-schema-version-1-?::after too in adaptivecards-site\themes\adaptivecards\source\css\style.css
    Versions.v1_6 = new $ae9318e98d14417a$var$Version(1, 6, "1.6 Preview");
    Versions.latest = Versions.v1_5;
    return Versions;
}();
module.exports.Versions = $ae9318e98d14417a$var$Versions;
function $ae9318e98d14417a$var$isVersionLessOrEqual(version, targetVersion) {
    if (version instanceof $ae9318e98d14417a$var$Version) {
        if (targetVersion instanceof $ae9318e98d14417a$var$Version) return targetVersion.compareTo(version) >= 0;
        else // Target version is *
        return true;
    } else // Version is *
    return true;
}
module.exports.isVersionLessOrEqual = $ae9318e98d14417a$var$isVersionLessOrEqual;
var $ae9318e98d14417a$var$BaseSerializationContext = /** @class */ function() {
    function BaseSerializationContext(targetVersion) {
        if (targetVersion === void 0) targetVersion = $ae9318e98d14417a$var$Versions.latest;
        this._validationEvents = [];
        this.targetVersion = targetVersion;
    }
    BaseSerializationContext.prototype.isTemplateString = function(value) {
        if (typeof value === "string") return value.startsWith("${");
        else return false;
    };
    BaseSerializationContext.prototype.tryDeleteValue = function(target, propertyName) {
        if (!$8Lw6d.GlobalSettings.enableFullJsonRoundTrip) delete target[propertyName];
    };
    BaseSerializationContext.prototype.tryDeleteDefaultValue = function(target, propertyName) {
        if (!$8Lw6d.GlobalSettings.enableFullJsonRoundTrip || !this.isTemplateString(target[propertyName])) delete target[propertyName];
    };
    BaseSerializationContext.prototype.serializeValue = function(target, propertyName, propertyValue, defaultValue, forceDeleteIfNullOrDefault) {
        if (defaultValue === void 0) defaultValue = undefined;
        if (forceDeleteIfNullOrDefault === void 0) forceDeleteIfNullOrDefault = false;
        if (propertyValue === null || propertyValue === undefined) {
            if (!$8Lw6d.GlobalSettings.enableFullJsonRoundTrip || forceDeleteIfNullOrDefault) delete target[propertyName];
        } else if (propertyValue === defaultValue) {
            if (!$8Lw6d.GlobalSettings.enableFullJsonRoundTrip || forceDeleteIfNullOrDefault || !this.isTemplateString(target[propertyName])) delete target[propertyName];
        } else target[propertyName] = propertyValue;
    };
    BaseSerializationContext.prototype.serializeString = function(target, propertyName, propertyValue, defaultValue) {
        if (propertyValue === null || propertyValue === undefined) this.tryDeleteValue(target, propertyName);
        else if (propertyValue === defaultValue) this.tryDeleteDefaultValue(target, propertyName);
        else target[propertyName] = propertyValue;
    };
    BaseSerializationContext.prototype.serializeBool = function(target, propertyName, propertyValue, defaultValue) {
        if (propertyValue === null || propertyValue === undefined) this.tryDeleteValue(target, propertyName);
        else if (propertyValue === defaultValue) this.tryDeleteDefaultValue(target, propertyName);
        else target[propertyName] = propertyValue;
    };
    BaseSerializationContext.prototype.serializeNumber = function(target, propertyName, propertyValue, defaultValue) {
        if (propertyValue === null || propertyValue === undefined || isNaN(propertyValue)) this.tryDeleteValue(target, propertyName);
        else if (propertyValue === defaultValue) this.tryDeleteDefaultValue(target, propertyName);
        else target[propertyName] = propertyValue;
    };
    BaseSerializationContext.prototype.serializeEnum = function(enumType, target, propertyName, propertyValue, defaultValue) {
        if (defaultValue === void 0) defaultValue = undefined;
        if (propertyValue === null || propertyValue === undefined) this.tryDeleteValue(target, propertyName);
        else if (propertyValue === defaultValue) this.tryDeleteDefaultValue(target, propertyName);
        else target[propertyName] = enumType[propertyValue];
    };
    BaseSerializationContext.prototype.serializeArray = function(target, propertyName, propertyValue) {
        var items = [];
        if (propertyValue) for(var _i = 0, propertyValue_1 = propertyValue; _i < propertyValue_1.length; _i++){
            var item = propertyValue_1[_i];
            var serializedItem = undefined;
            if (item instanceof $ae9318e98d14417a$var$SerializableObject) serializedItem = item.toJSON(this);
            else if (item.toJSON) serializedItem = item.toJSON();
            else serializedItem = item;
            if (serializedItem !== undefined) items.push(serializedItem);
        }
        if (items.length === 0) {
            if (target.hasOwnProperty(propertyName) && Array.isArray(target[propertyName])) delete target[propertyName];
        } else this.serializeValue(target, propertyName, items);
    };
    BaseSerializationContext.prototype.clearEvents = function() {
        this._validationEvents = [];
    };
    BaseSerializationContext.prototype.logEvent = function(source, phase, event, message) {
        this._validationEvents.push({
            source: source,
            phase: phase,
            event: event,
            message: message
        });
    };
    BaseSerializationContext.prototype.logParseEvent = function(source, event, message) {
        this.logEvent(source, $kD48O.ValidationPhase.Parse, event, message);
    };
    BaseSerializationContext.prototype.getEventAt = function(index) {
        return this._validationEvents[index];
    };
    Object.defineProperty(BaseSerializationContext.prototype, "eventCount", {
        get: function() {
            return this._validationEvents.length;
        },
        enumerable: false,
        configurable: true
    });
    return BaseSerializationContext;
}();
module.exports.BaseSerializationContext = $ae9318e98d14417a$var$BaseSerializationContext;
var $ae9318e98d14417a$var$SimpleSerializationContext = /** @class */ function(_super) {
    $ae9318e98d14417a$var$__extends(SimpleSerializationContext, _super);
    function SimpleSerializationContext() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return SimpleSerializationContext;
}($ae9318e98d14417a$var$BaseSerializationContext);
var $ae9318e98d14417a$var$PropertyDefinition = /** @class */ function() {
    function PropertyDefinition(targetVersion, name, defaultValue, onGetInitialValue) {
        this.targetVersion = targetVersion;
        this.name = name;
        this.defaultValue = defaultValue;
        this.onGetInitialValue = onGetInitialValue;
        this.isSerializationEnabled = true;
        this.sequentialNumber = PropertyDefinition._sequentialNumber;
        PropertyDefinition._sequentialNumber++;
    }
    PropertyDefinition.prototype.getInternalName = function() {
        return this.name;
    };
    PropertyDefinition.prototype.parse = function(sender, source, context) {
        return source[this.name];
    };
    PropertyDefinition.prototype.toJSON = function(sender, target, value, context) {
        context.serializeValue(target, this.name, value, this.defaultValue);
    };
    PropertyDefinition._sequentialNumber = 0;
    return PropertyDefinition;
}();
module.exports.PropertyDefinition = $ae9318e98d14417a$var$PropertyDefinition;
var $ae9318e98d14417a$var$StringProperty = /** @class */ function(_super) {
    $ae9318e98d14417a$var$__extends(StringProperty, _super);
    function StringProperty(targetVersion, name, treatEmptyAsUndefined, regEx, defaultValue, onGetInitialValue) {
        if (treatEmptyAsUndefined === void 0) treatEmptyAsUndefined = true;
        var _this = _super.call(this, targetVersion, name, defaultValue, onGetInitialValue) || this;
        _this.targetVersion = targetVersion;
        _this.name = name;
        _this.treatEmptyAsUndefined = treatEmptyAsUndefined;
        _this.regEx = regEx;
        _this.defaultValue = defaultValue;
        _this.onGetInitialValue = onGetInitialValue;
        return _this;
    }
    StringProperty.prototype.parse = function(sender, source, context) {
        var parsedValue = $8QA0A.parseString(source[this.name], this.defaultValue);
        var isUndefined = parsedValue === undefined || parsedValue === "" && this.treatEmptyAsUndefined;
        if (!isUndefined && this.regEx !== undefined) {
            var matches = this.regEx.exec(parsedValue);
            if (!matches) {
                context.logParseEvent(sender, $kD48O.ValidationEvent.InvalidPropertyValue, $c6BU9.Strings.errors.invalidPropertyValue(parsedValue, this.name));
                return undefined;
            }
        }
        return parsedValue;
    };
    StringProperty.prototype.toJSON = function(sender, target, value, context) {
        context.serializeString(target, this.name, value === "" && this.treatEmptyAsUndefined ? undefined : value, this.defaultValue);
    };
    return StringProperty;
}($ae9318e98d14417a$var$PropertyDefinition);
module.exports.StringProperty = $ae9318e98d14417a$var$StringProperty;
var $ae9318e98d14417a$var$BoolProperty = /** @class */ function(_super) {
    $ae9318e98d14417a$var$__extends(BoolProperty, _super);
    function BoolProperty(targetVersion, name, defaultValue, onGetInitialValue) {
        var _this = _super.call(this, targetVersion, name, defaultValue, onGetInitialValue) || this;
        _this.targetVersion = targetVersion;
        _this.name = name;
        _this.defaultValue = defaultValue;
        _this.onGetInitialValue = onGetInitialValue;
        return _this;
    }
    BoolProperty.prototype.parse = function(sender, source, context) {
        return $8QA0A.parseBool(source[this.name], this.defaultValue);
    };
    BoolProperty.prototype.toJSON = function(sender, target, value, context) {
        context.serializeBool(target, this.name, value, this.defaultValue);
    };
    return BoolProperty;
}($ae9318e98d14417a$var$PropertyDefinition);
module.exports.BoolProperty = $ae9318e98d14417a$var$BoolProperty;
var $ae9318e98d14417a$var$NumProperty = /** @class */ function(_super) {
    $ae9318e98d14417a$var$__extends(NumProperty, _super);
    function NumProperty(targetVersion, name, defaultValue, onGetInitialValue) {
        var _this = _super.call(this, targetVersion, name, defaultValue, onGetInitialValue) || this;
        _this.targetVersion = targetVersion;
        _this.name = name;
        _this.defaultValue = defaultValue;
        _this.onGetInitialValue = onGetInitialValue;
        return _this;
    }
    NumProperty.prototype.parse = function(sender, source, context) {
        return $8QA0A.parseNumber(source[this.name], this.defaultValue);
    };
    NumProperty.prototype.toJSON = function(sender, target, value, context) {
        context.serializeNumber(target, this.name, value, this.defaultValue);
    };
    return NumProperty;
}($ae9318e98d14417a$var$PropertyDefinition);
module.exports.NumProperty = $ae9318e98d14417a$var$NumProperty;
var $ae9318e98d14417a$var$PixelSizeProperty = /** @class */ function(_super) {
    $ae9318e98d14417a$var$__extends(PixelSizeProperty, _super);
    function PixelSizeProperty() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PixelSizeProperty.prototype.parse = function(sender, source, context) {
        var result = undefined;
        var value = source[this.name];
        if (typeof value === "string") {
            var isValid = false;
            try {
                var size = $8Lw6d.SizeAndUnit.parse(value, true);
                if (size.unit === $kD48O.SizeUnit.Pixel) {
                    result = size.physicalSize;
                    isValid = true;
                }
            } catch (_a) {
            // Do nothing. A parse error is emitted below
            }
            if (!isValid) context.logParseEvent(sender, $kD48O.ValidationEvent.InvalidPropertyValue, $c6BU9.Strings.errors.invalidPropertyValue(source[this.name], this.name));
        }
        return result;
    };
    PixelSizeProperty.prototype.toJSON = function(sender, target, value, context) {
        context.serializeValue(target, this.name, typeof value === "number" && !isNaN(value) ? value + "px" : undefined);
    };
    return PixelSizeProperty;
}($ae9318e98d14417a$var$PropertyDefinition);
module.exports.PixelSizeProperty = $ae9318e98d14417a$var$PixelSizeProperty;
var $ae9318e98d14417a$var$StringArrayProperty = /** @class */ function(_super) {
    $ae9318e98d14417a$var$__extends(StringArrayProperty, _super);
    function StringArrayProperty(targetVersion, name, defaultValue, onGetInitialValue) {
        var _this = _super.call(this, targetVersion, name, defaultValue, onGetInitialValue) || this;
        _this.targetVersion = targetVersion;
        _this.name = name;
        _this.defaultValue = defaultValue;
        _this.onGetInitialValue = onGetInitialValue;
        return _this;
    }
    StringArrayProperty.prototype.parse = function(sender, source, context) {
        var sourceValue = source[this.name];
        if (sourceValue === undefined || !Array.isArray(sourceValue)) return this.defaultValue;
        var result = [];
        for(var _i = 0, sourceValue_1 = sourceValue; _i < sourceValue_1.length; _i++){
            var value = sourceValue_1[_i];
            if (typeof value === "string") result.push(value);
            else context.logParseEvent(sender, $kD48O.ValidationEvent.InvalidPropertyValue, 'Invalid array value "'.concat(JSON.stringify(value), '" of type "').concat(typeof value, '" ignored for "').concat(this.name, '".'));
        }
        return result;
    };
    StringArrayProperty.prototype.toJSON = function(sender, target, value, context) {
        context.serializeArray(target, this.name, value);
    };
    return StringArrayProperty;
}($ae9318e98d14417a$var$PropertyDefinition);
module.exports.StringArrayProperty = $ae9318e98d14417a$var$StringArrayProperty;
var $ae9318e98d14417a$var$ValueSetProperty = /** @class */ function(_super) {
    $ae9318e98d14417a$var$__extends(ValueSetProperty, _super);
    function ValueSetProperty(targetVersion, name, values, defaultValue, onGetInitialValue) {
        var _this = _super.call(this, targetVersion, name, defaultValue, onGetInitialValue) || this;
        _this.targetVersion = targetVersion;
        _this.name = name;
        _this.values = values;
        _this.defaultValue = defaultValue;
        _this.onGetInitialValue = onGetInitialValue;
        return _this;
    }
    ValueSetProperty.prototype.isValidValue = function(value, context) {
        for(var _i = 0, _a = this.values; _i < _a.length; _i++){
            var versionedValue = _a[_i];
            if (value.toLowerCase() === versionedValue.value.toLowerCase()) {
                var targetVersion = versionedValue.targetVersion ? versionedValue.targetVersion : this.targetVersion;
                return targetVersion.compareTo(context.targetVersion) <= 0;
            }
        }
        return false;
    };
    ValueSetProperty.prototype.parse = function(sender, source, context) {
        var sourceValue = source[this.name];
        if (sourceValue === undefined) return this.defaultValue;
        if (typeof sourceValue === "string") for(var _i = 0, _a = this.values; _i < _a.length; _i++){
            var versionedValue = _a[_i];
            if (sourceValue.toLowerCase() === versionedValue.value.toLowerCase()) {
                var targetVersion = versionedValue.targetVersion ? versionedValue.targetVersion : this.targetVersion;
                if (targetVersion.compareTo(context.targetVersion) <= 0) return versionedValue.value;
                else {
                    context.logParseEvent(sender, $kD48O.ValidationEvent.InvalidPropertyValue, $c6BU9.Strings.errors.propertyValueNotSupported(sourceValue, this.name, targetVersion.toString(), context.targetVersion.toString()));
                    return this.defaultValue;
                }
            }
        }
        context.logParseEvent(sender, $kD48O.ValidationEvent.InvalidPropertyValue, $c6BU9.Strings.errors.invalidPropertyValue(sourceValue, this.name));
        return this.defaultValue;
    };
    ValueSetProperty.prototype.toJSON = function(sender, target, value, context) {
        var invalidValue = false;
        if (value !== undefined) {
            invalidValue = true;
            for(var _i = 0, _a = this.values; _i < _a.length; _i++){
                var versionedValue = _a[_i];
                if (versionedValue.value === value) {
                    var targetVersion = versionedValue.targetVersion ? versionedValue.targetVersion : this.targetVersion;
                    if (targetVersion.compareTo(context.targetVersion) <= 0) {
                        invalidValue = false;
                        break;
                    } else context.logEvent(sender, $kD48O.ValidationPhase.ToJSON, $kD48O.ValidationEvent.InvalidPropertyValue, $c6BU9.Strings.errors.propertyValueNotSupported(value, this.name, targetVersion.toString(), context.targetVersion.toString()));
                }
            }
        }
        if (!invalidValue) context.serializeValue(target, this.name, value, this.defaultValue, true);
    };
    return ValueSetProperty;
}($ae9318e98d14417a$var$PropertyDefinition);
module.exports.ValueSetProperty = $ae9318e98d14417a$var$ValueSetProperty;
var $ae9318e98d14417a$var$EnumProperty = /** @class */ function(_super) {
    $ae9318e98d14417a$var$__extends(EnumProperty, _super);
    function EnumProperty(targetVersion, name, enumType, defaultValue, values, onGetInitialValue) {
        var _this = _super.call(this, targetVersion, name, defaultValue, onGetInitialValue) || this;
        _this.targetVersion = targetVersion;
        _this.name = name;
        _this.enumType = enumType;
        _this.defaultValue = defaultValue;
        _this.onGetInitialValue = onGetInitialValue;
        _this._values = [];
        if (!values) // eslint-disable-next-line guard-for-in
        for(var key in enumType){
            var keyAsNumber = parseInt(key, 10);
            if (keyAsNumber >= 0) _this._values.push({
                value: keyAsNumber
            });
        }
        else _this._values = values;
        return _this;
    }
    EnumProperty.prototype.parse = function(sender, source, context) {
        var sourceValue = source[this.name];
        if (typeof sourceValue !== "string") return this.defaultValue;
        var enumValue = $8QA0A.getEnumValueByName(this.enumType, sourceValue);
        if (enumValue !== undefined) for(var _i = 0, _a = this.values; _i < _a.length; _i++){
            var versionedValue = _a[_i];
            if (versionedValue.value === enumValue) {
                var targetVersion = versionedValue.targetVersion ? versionedValue.targetVersion : this.targetVersion;
                if (targetVersion.compareTo(context.targetVersion) <= 0) return enumValue;
                else {
                    context.logParseEvent(sender, $kD48O.ValidationEvent.InvalidPropertyValue, $c6BU9.Strings.errors.propertyValueNotSupported(sourceValue, this.name, targetVersion.toString(), context.targetVersion.toString()));
                    return this.defaultValue;
                }
            }
        }
        context.logParseEvent(sender, $kD48O.ValidationEvent.InvalidPropertyValue, $c6BU9.Strings.errors.invalidPropertyValue(sourceValue, this.name));
        return this.defaultValue;
    };
    EnumProperty.prototype.toJSON = function(sender, target, value, context) {
        var invalidValue = false;
        if (value !== undefined) {
            invalidValue = true;
            for(var _i = 0, _a = this.values; _i < _a.length; _i++){
                var versionedValue = _a[_i];
                if (versionedValue.value === value) {
                    var targetVersion = versionedValue.targetVersion ? versionedValue.targetVersion : this.targetVersion;
                    if (targetVersion.compareTo(context.targetVersion) <= 0) {
                        invalidValue = false;
                        break;
                    } else context.logEvent(sender, $kD48O.ValidationPhase.ToJSON, $kD48O.ValidationEvent.InvalidPropertyValue, $c6BU9.Strings.errors.invalidPropertyValue(value, this.name));
                }
            }
        }
        if (!invalidValue) context.serializeEnum(this.enumType, target, this.name, value, this.defaultValue);
    };
    Object.defineProperty(EnumProperty.prototype, "values", {
        get: function() {
            return this._values;
        },
        enumerable: false,
        configurable: true
    });
    return EnumProperty;
}($ae9318e98d14417a$var$PropertyDefinition);
module.exports.EnumProperty = $ae9318e98d14417a$var$EnumProperty;
var $ae9318e98d14417a$var$SerializableObjectProperty = /** @class */ function(_super) {
    $ae9318e98d14417a$var$__extends(SerializableObjectProperty, _super);
    function SerializableObjectProperty(targetVersion, name, objectType, nullable, defaultValue) {
        if (nullable === void 0) nullable = false;
        var _this = _super.call(this, targetVersion, name, defaultValue, function(sender) {
            return _this.nullable ? undefined : new _this.objectType();
        }) || this;
        _this.targetVersion = targetVersion;
        _this.name = name;
        _this.objectType = objectType;
        _this.nullable = nullable;
        return _this;
    }
    SerializableObjectProperty.prototype.parse = function(sender, source, context) {
        var sourceValue = source[this.name];
        if (sourceValue === undefined) return this.onGetInitialValue ? this.onGetInitialValue(sender) : this.defaultValue;
        var result = new this.objectType();
        result.parse(sourceValue, context);
        return result;
    };
    SerializableObjectProperty.prototype.toJSON = function(sender, target, value, context) {
        var serializedValue = undefined;
        if (value !== undefined && !value.hasAllDefaultValues()) serializedValue = value.toJSON(context);
        if (typeof serializedValue === "object" && Object.keys(serializedValue).length === 0) serializedValue = undefined;
        context.serializeValue(target, this.name, serializedValue, this.defaultValue, true);
    };
    return SerializableObjectProperty;
}($ae9318e98d14417a$var$PropertyDefinition);
module.exports.SerializableObjectProperty = $ae9318e98d14417a$var$SerializableObjectProperty;
var $ae9318e98d14417a$var$SerializableObjectCollectionProperty = /** @class */ function(_super) {
    $ae9318e98d14417a$var$__extends(SerializableObjectCollectionProperty, _super);
    function SerializableObjectCollectionProperty(targetVersion, name, objectType, onItemAdded) {
        var _this = _super.call(this, targetVersion, name, undefined, function(sender) {
            return [];
        }) || this;
        _this.targetVersion = targetVersion;
        _this.name = name;
        _this.objectType = objectType;
        _this.onItemAdded = onItemAdded;
        return _this;
    }
    SerializableObjectCollectionProperty.prototype.parse = function(sender, source, context) {
        var result = [];
        var sourceCollection = source[this.name];
        if (Array.isArray(sourceCollection)) for(var _i = 0, sourceCollection_1 = sourceCollection; _i < sourceCollection_1.length; _i++){
            var sourceItem = sourceCollection_1[_i];
            var item = new this.objectType();
            item.parse(sourceItem, context);
            result.push(item);
            if (this.onItemAdded) this.onItemAdded(sender, item);
        }
        return result.length > 0 ? result : this.onGetInitialValue ? this.onGetInitialValue(sender) : undefined;
    };
    SerializableObjectCollectionProperty.prototype.toJSON = function(sender, target, value, context) {
        context.serializeArray(target, this.name, value);
    };
    return SerializableObjectCollectionProperty;
}($ae9318e98d14417a$var$PropertyDefinition);
module.exports.SerializableObjectCollectionProperty = $ae9318e98d14417a$var$SerializableObjectCollectionProperty;
var $ae9318e98d14417a$var$CustomProperty = /** @class */ function(_super) {
    $ae9318e98d14417a$var$__extends(CustomProperty, _super);
    function CustomProperty(targetVersion, name, onParse, onToJSON, defaultValue, onGetInitialValue) {
        var _this = _super.call(this, targetVersion, name, defaultValue, onGetInitialValue) || this;
        _this.targetVersion = targetVersion;
        _this.name = name;
        _this.onParse = onParse;
        _this.onToJSON = onToJSON;
        _this.defaultValue = defaultValue;
        _this.onGetInitialValue = onGetInitialValue;
        if (!_this.onParse) throw new Error("CustomPropertyDefinition instances must have an onParse handler.");
        if (!_this.onToJSON) throw new Error("CustomPropertyDefinition instances must have an onToJSON handler.");
        return _this;
    }
    CustomProperty.prototype.parse = function(sender, source, context) {
        return this.onParse(sender, this, source, context);
    };
    CustomProperty.prototype.toJSON = function(sender, target, value, context) {
        this.onToJSON(sender, this, target, value, context);
    };
    return CustomProperty;
}($ae9318e98d14417a$var$PropertyDefinition);
module.exports.CustomProperty = $ae9318e98d14417a$var$CustomProperty;
var $ae9318e98d14417a$var$SerializableObjectSchema = /** @class */ function() {
    function SerializableObjectSchema() {
        this._properties = [];
    }
    SerializableObjectSchema.prototype.indexOf = function(prop) {
        for(var i = 0; i < this._properties.length; i++){
            if (this._properties[i] === prop) return i;
        }
        return -1;
    };
    SerializableObjectSchema.prototype.add = function() {
        var properties = [];
        for(var _i = 0; _i < arguments.length; _i++)properties[_i] = arguments[_i];
        for(var _a = 0, properties_1 = properties; _a < properties_1.length; _a++){
            var prop = properties_1[_a];
            if (this.indexOf(prop) === -1) this._properties.push(prop);
        }
    };
    SerializableObjectSchema.prototype.remove = function() {
        var properties = [];
        for(var _i = 0; _i < arguments.length; _i++)properties[_i] = arguments[_i];
        for(var _a = 0, properties_2 = properties; _a < properties_2.length; _a++){
            var prop = properties_2[_a];
            while(true){
                var index = this.indexOf(prop);
                if (index >= 0) this._properties.splice(index, 1);
                else break;
            }
        }
    };
    SerializableObjectSchema.prototype.getItemAt = function(index) {
        return this._properties[index];
    };
    SerializableObjectSchema.prototype.getCount = function() {
        return this._properties.length;
    };
    return SerializableObjectSchema;
}();
module.exports.SerializableObjectSchema = $ae9318e98d14417a$var$SerializableObjectSchema;
// This is a decorator function, used to map SerializableObject descendant class members to
// schema properties
function $ae9318e98d14417a$var$property(prop) {
    return function(target, propertyKey) {
        var descriptor = Object.getOwnPropertyDescriptor(target, propertyKey) || {};
        if (!descriptor.get && !descriptor.set) {
            descriptor.get = function() {
                return this.getValue(prop);
            };
            descriptor.set = function(value) {
                this.setValue(prop, value);
            };
            Object.defineProperty(target, propertyKey, descriptor);
        }
    };
}
module.exports.property = $ae9318e98d14417a$var$property;
var $ae9318e98d14417a$var$SerializableObject = /** @class */ function() {
    function SerializableObject() {
        this._propertyBag = {};
        this._rawProperties = {};
        this.maxVersion = SerializableObject.defaultMaxVersion;
        var s = this.getSchema();
        for(var i = 0; i < s.getCount(); i++){
            var prop = s.getItemAt(i);
            if (prop.onGetInitialValue) this.setValue(prop, prop.onGetInitialValue(this));
        }
    }
    SerializableObject.prototype.getDefaultSerializationContext = function() {
        return new $ae9318e98d14417a$var$SimpleSerializationContext();
    };
    SerializableObject.prototype.populateSchema = function(schema) {
        var ctor = this.constructor;
        var properties = [];
        // eslint-disable-next-line guard-for-in
        for(var propertyName in ctor)try {
            var propertyValue = ctor[propertyName];
            if (propertyValue instanceof $ae9318e98d14417a$var$PropertyDefinition) properties.push(propertyValue);
        } catch (_a) {
        // If a property happens to have a getter function and
        // it throws an exception, we need to catch it here
        }
        if (properties.length > 0) {
            var sortedProperties = properties.sort(function(p1, p2) {
                if (p1.sequentialNumber > p2.sequentialNumber) return 1;
                else if (p1.sequentialNumber < p2.sequentialNumber) return -1;
                return 0;
            });
            schema.add.apply(schema, sortedProperties);
        }
        if (SerializableObject.onRegisterCustomProperties) SerializableObject.onRegisterCustomProperties(this, schema);
    };
    SerializableObject.prototype.getValue = function(prop) {
        return this._propertyBag.hasOwnProperty(prop.getInternalName()) ? this._propertyBag[prop.getInternalName()] : prop.defaultValue;
    };
    SerializableObject.prototype.setValue = function(prop, value) {
        if (value === undefined || value === null) delete this._propertyBag[prop.getInternalName()];
        else this._propertyBag[prop.getInternalName()] = value;
    };
    SerializableObject.prototype.internalParse = function(source, context) {
        this._propertyBag = {};
        this._rawProperties = $8Lw6d.GlobalSettings.enableFullJsonRoundTrip ? source ? source : {} : {};
        if (source) {
            var s = this.getSchema();
            for(var i = 0; i < s.getCount(); i++){
                var prop = s.getItemAt(i);
                if (prop.isSerializationEnabled) {
                    var propertyValue = prop.onGetInitialValue ? prop.onGetInitialValue(this) : undefined;
                    if (source.hasOwnProperty(prop.name)) {
                        if (prop.targetVersion.compareTo(context.targetVersion) <= 0) propertyValue = prop.parse(this, source, context);
                        else context.logParseEvent(this, $kD48O.ValidationEvent.UnsupportedProperty, $c6BU9.Strings.errors.propertyNotSupported(prop.name, prop.targetVersion.toString(), context.targetVersion.toString()));
                    }
                    this.setValue(prop, propertyValue);
                }
            }
        } else this.resetDefaultValues();
    };
    SerializableObject.prototype.internalToJSON = function(target, context) {
        var s = this.getSchema();
        var serializedProperties = [];
        for(var i = 0; i < s.getCount(); i++){
            var prop = s.getItemAt(i);
            // Avoid serializing the same property multiple times. This is necessary
            // because some property definitions map to the same underlying schema
            // property
            if (prop.isSerializationEnabled && prop.targetVersion.compareTo(context.targetVersion) <= 0 && serializedProperties.indexOf(prop.name) === -1) {
                prop.toJSON(this, target, this.getValue(prop), context);
                serializedProperties.push(prop.name);
            }
        }
    };
    SerializableObject.prototype.shouldSerialize = function(_context) {
        return true;
    };
    SerializableObject.prototype.parse = function(source, context) {
        this.internalParse(source, context ? context : new $ae9318e98d14417a$var$SimpleSerializationContext());
    };
    SerializableObject.prototype.toJSON = function(context) {
        var effectiveContext;
        if (context && context instanceof $ae9318e98d14417a$var$BaseSerializationContext) effectiveContext = context;
        else {
            effectiveContext = this.getDefaultSerializationContext();
            effectiveContext.toJSONOriginalParam = context;
        }
        if (this.shouldSerialize(effectiveContext)) {
            var result = void 0;
            if ($8Lw6d.GlobalSettings.enableFullJsonRoundTrip && this._rawProperties && typeof this._rawProperties === "object") result = this._rawProperties;
            else result = {};
            this.internalToJSON(result, effectiveContext);
            return result;
        } else return undefined;
    };
    SerializableObject.prototype.hasDefaultValue = function(prop) {
        return this.getValue(prop) === prop.defaultValue;
    };
    SerializableObject.prototype.hasAllDefaultValues = function() {
        var s = this.getSchema();
        for(var i = 0; i < s.getCount(); i++){
            var prop = s.getItemAt(i);
            if (!this.hasDefaultValue(prop)) return false;
        }
        return true;
    };
    SerializableObject.prototype.resetDefaultValues = function() {
        var s = this.getSchema();
        for(var i = 0; i < s.getCount(); i++){
            var prop = s.getItemAt(i);
            this.setValue(prop, prop.defaultValue);
        }
    };
    SerializableObject.prototype.setCustomProperty = function(name, value) {
        var shouldDeleteProperty = typeof value === "string" && !value || value === undefined || value === null;
        if (shouldDeleteProperty) delete this._rawProperties[name];
        else this._rawProperties[name] = value;
    };
    SerializableObject.prototype.getCustomProperty = function(name) {
        return this._rawProperties[name];
    };
    SerializableObject.prototype.getSchema = function() {
        var schema = SerializableObject._schemaCache[this.getSchemaKey()];
        if (!schema) {
            schema = new $ae9318e98d14417a$var$SerializableObjectSchema();
            this.populateSchema(schema);
            SerializableObject._schemaCache[this.getSchemaKey()] = schema;
        }
        return schema;
    };
    SerializableObject.defaultMaxVersion = $ae9318e98d14417a$var$Versions.latest;
    SerializableObject._schemaCache = {};
    return SerializableObject;
}();
module.exports.SerializableObject = $ae9318e98d14417a$var$SerializableObject;

});

parcelRequire.register("KzWne", function(module, exports) {
"use strict";
var $08c02d076db31f6e$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.HostCapabilities = void 0;

var $eZfTX = parcelRequire("eZfTX");
var $08c02d076db31f6e$var$HostCapabilities = /** @class */ function(_super) {
    $08c02d076db31f6e$var$__extends(HostCapabilities, _super);
    function HostCapabilities() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._capabilities = {};
        return _this;
    }
    HostCapabilities.prototype.getSchemaKey = function() {
        return "HostCapabilities";
    };
    HostCapabilities.prototype.internalParse = function(source, context) {
        _super.prototype.internalParse.call(this, source, context);
        if (source) // eslint-disable-next-line guard-for-in
        for(var name_1 in source){
            var jsonVersion = source[name_1];
            if (typeof jsonVersion === "string") {
                if (jsonVersion === "*") this.addCapability(name_1, "*");
                else {
                    var version = $eZfTX.Version.parse(jsonVersion, context);
                    if (version === null || version === void 0 ? void 0 : version.isValid) this.addCapability(name_1, version);
                }
            }
        }
    };
    HostCapabilities.prototype.internalToJSON = function(target, context) {
        _super.prototype.internalToJSON.call(this, target, context);
        // eslint-disable-next-line guard-for-in
        for(var key in this._capabilities)target[key] = this._capabilities[key];
    };
    HostCapabilities.prototype.addCapability = function(name, version) {
        this._capabilities[name] = version;
    };
    HostCapabilities.prototype.removeCapability = function(name) {
        delete this._capabilities[name];
    };
    HostCapabilities.prototype.clear = function() {
        this._capabilities = {};
    };
    HostCapabilities.prototype.hasCapability = function(name, version) {
        if (this._capabilities.hasOwnProperty(name)) {
            if (version === "*" || this._capabilities[name] === "*") return true;
            return version.compareTo(this._capabilities[name]) <= 0;
        }
        return false;
    };
    HostCapabilities.prototype.areAllMet = function(hostCapabilities) {
        for(var capabilityName in this._capabilities){
            if (!hostCapabilities.hasCapability(capabilityName, this._capabilities[capabilityName])) return false;
        }
        return true;
    };
    return HostCapabilities;
}($eZfTX.SerializableObject);
module.exports.HostCapabilities = $08c02d076db31f6e$var$HostCapabilities;

});

parcelRequire.register("lHSNo", function(module, exports) {
"use strict";
var $fcd81e67f3fb9457$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.defaultHostConfig = module.exports.HostConfig = module.exports.CarouselConfig = module.exports.FontTypeSet = module.exports.FontTypeDefinition = module.exports.ContainerStyleSet = module.exports.ContainerStyleDefinition = module.exports.ColorSetDefinition = module.exports.ActionsConfig = module.exports.ShowCardActionConfig = module.exports.FactSetConfig = module.exports.FactTitleDefinition = module.exports.FactTextDefinition = module.exports.InputConfig = module.exports.InputLabelConfig = module.exports.RequiredInputLabelTextDefinition = module.exports.TextBlockConfig = module.exports.TextStyleSet = module.exports.TextStyleDefinition = module.exports.BaseTextDefinition = module.exports.TableConfig = module.exports.MediaConfig = module.exports.ImageSetConfig = module.exports.AdaptiveCardConfig = module.exports.TextColorDefinition = module.exports.ColorDefinition = void 0;

var $kD48O = parcelRequire("kD48O");

var $8QA0A = parcelRequire("8QA0A");

var $8Lw6d = parcelRequire("8Lw6d");

var $KzWne = parcelRequire("KzWne");
function $fcd81e67f3fb9457$var$parseHostConfigEnum(targetEnum, value, defaultValue) {
    if (typeof value === "string") {
        var parsedValue = $8QA0A.parseEnum(targetEnum, value, defaultValue);
        return parsedValue !== undefined ? parsedValue : defaultValue;
    } else if (typeof value === "number") return value;
    else return defaultValue;
}
var $fcd81e67f3fb9457$var$ColorDefinition = /** @class */ function() {
    function ColorDefinition(defaultColor, subtleColor) {
        this.default = "#000000";
        this.subtle = "#666666";
        if (defaultColor) this.default = defaultColor;
        if (subtleColor) this.subtle = subtleColor;
    }
    ColorDefinition.prototype.parse = function(obj) {
        if (obj) {
            this.default = obj["default"] || this.default;
            this.subtle = obj["subtle"] || this.subtle;
        }
    };
    return ColorDefinition;
}();
module.exports.ColorDefinition = $fcd81e67f3fb9457$var$ColorDefinition;
var $fcd81e67f3fb9457$var$TextColorDefinition = /** @class */ function(_super) {
    $fcd81e67f3fb9457$var$__extends(TextColorDefinition, _super);
    function TextColorDefinition() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.highlightColors = new $fcd81e67f3fb9457$var$ColorDefinition("#22000000", "#11000000");
        return _this;
    }
    TextColorDefinition.prototype.parse = function(obj) {
        _super.prototype.parse.call(this, obj);
        if (obj) this.highlightColors.parse(obj["highlightColors"]);
    };
    return TextColorDefinition;
}($fcd81e67f3fb9457$var$ColorDefinition);
module.exports.TextColorDefinition = $fcd81e67f3fb9457$var$TextColorDefinition;
var $fcd81e67f3fb9457$var$AdaptiveCardConfig = /** @class */ function() {
    function AdaptiveCardConfig(obj) {
        this.allowCustomStyle = false;
        if (obj) this.allowCustomStyle = obj["allowCustomStyle"] || this.allowCustomStyle;
    }
    return AdaptiveCardConfig;
}();
module.exports.AdaptiveCardConfig = $fcd81e67f3fb9457$var$AdaptiveCardConfig;
var $fcd81e67f3fb9457$var$ImageSetConfig = /** @class */ function() {
    function ImageSetConfig(obj) {
        this.imageSize = $kD48O.Size.Medium;
        this.maxImageHeight = 100;
        if (obj) {
            this.imageSize = obj["imageSize"] != null ? obj["imageSize"] : this.imageSize;
            this.maxImageHeight = $8QA0A.parseNumber(obj["maxImageHeight"], 100);
        }
    }
    ImageSetConfig.prototype.toJSON = function() {
        return {
            imageSize: $kD48O.Size[this.imageSize],
            maxImageHeight: this.maxImageHeight
        };
    };
    return ImageSetConfig;
}();
module.exports.ImageSetConfig = $fcd81e67f3fb9457$var$ImageSetConfig;
var $fcd81e67f3fb9457$var$MediaConfig = /** @class */ function() {
    function MediaConfig(obj) {
        this.allowInlinePlayback = true;
        if (obj) {
            this.defaultPoster = obj["defaultPoster"];
            this.allowInlinePlayback = obj["allowInlinePlayback"] || this.allowInlinePlayback;
        }
    }
    MediaConfig.prototype.toJSON = function() {
        return {
            defaultPoster: this.defaultPoster,
            allowInlinePlayback: this.allowInlinePlayback
        };
    };
    return MediaConfig;
}();
module.exports.MediaConfig = $fcd81e67f3fb9457$var$MediaConfig;
var $fcd81e67f3fb9457$var$TableConfig = /** @class */ function() {
    function TableConfig(obj) {
        this.cellSpacing = 8;
        if (obj) this.cellSpacing = obj.cellSpacing && typeof obj.cellSpacing === "number" ? obj.cellSpacing : this.cellSpacing;
    }
    TableConfig.prototype.toJSON = function() {
        return {
            cellSpacing: this.cellSpacing
        };
    };
    return TableConfig;
}();
module.exports.TableConfig = $fcd81e67f3fb9457$var$TableConfig;
var $fcd81e67f3fb9457$var$BaseTextDefinition = /** @class */ function() {
    function BaseTextDefinition(obj) {
        this.size = $kD48O.TextSize.Default;
        this.color = $kD48O.TextColor.Default;
        this.isSubtle = false;
        this.weight = $kD48O.TextWeight.Default;
        this.parse(obj);
    }
    BaseTextDefinition.prototype.parse = function(obj) {
        if (obj) {
            this.size = $fcd81e67f3fb9457$var$parseHostConfigEnum($kD48O.TextSize, obj["size"], this.size);
            this.color = $fcd81e67f3fb9457$var$parseHostConfigEnum($kD48O.TextColor, obj["color"], this.color);
            this.isSubtle = obj.isSubtle !== undefined && typeof obj.isSubtle === "boolean" ? obj.isSubtle : this.isSubtle;
            this.weight = $fcd81e67f3fb9457$var$parseHostConfigEnum($kD48O.TextWeight, obj["weight"], this.getDefaultWeight());
        }
    };
    BaseTextDefinition.prototype.getDefaultWeight = function() {
        return $kD48O.TextWeight.Default;
    };
    BaseTextDefinition.prototype.toJSON = function() {
        return {
            size: $kD48O.TextSize[this.size],
            color: $kD48O.TextColor[this.color],
            isSubtle: this.isSubtle,
            weight: $kD48O.TextWeight[this.weight]
        };
    };
    return BaseTextDefinition;
}();
module.exports.BaseTextDefinition = $fcd81e67f3fb9457$var$BaseTextDefinition;
var $fcd81e67f3fb9457$var$TextStyleDefinition = /** @class */ function(_super) {
    $fcd81e67f3fb9457$var$__extends(TextStyleDefinition, _super);
    function TextStyleDefinition() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.fontType = $kD48O.FontType.Default;
        return _this;
    }
    TextStyleDefinition.prototype.parse = function(obj) {
        _super.prototype.parse.call(this, obj);
        if (obj) this.fontType = $fcd81e67f3fb9457$var$parseHostConfigEnum($kD48O.FontType, obj.fontType, this.fontType);
    };
    return TextStyleDefinition;
}($fcd81e67f3fb9457$var$BaseTextDefinition);
module.exports.TextStyleDefinition = $fcd81e67f3fb9457$var$TextStyleDefinition;
var $fcd81e67f3fb9457$var$TextStyleSet = /** @class */ function() {
    function TextStyleSet(obj) {
        this.default = new $fcd81e67f3fb9457$var$TextStyleDefinition();
        this.heading = new $fcd81e67f3fb9457$var$TextStyleDefinition({
            size: "Large",
            weight: "Bolder"
        });
        this.columnHeader = new $fcd81e67f3fb9457$var$TextStyleDefinition({
            weight: "Bolder"
        });
        if (obj) {
            this.heading.parse(obj.heading);
            this.columnHeader.parse(obj.columnHeader);
        }
    }
    TextStyleSet.prototype.getStyleByName = function(name) {
        switch(name.toLowerCase()){
            case "heading":
                return this.heading;
            case "columnHeader":
                return this.columnHeader;
            default:
                return this.default;
        }
    };
    return TextStyleSet;
}();
module.exports.TextStyleSet = $fcd81e67f3fb9457$var$TextStyleSet;
var $fcd81e67f3fb9457$var$TextBlockConfig = /** @class */ function() {
    function TextBlockConfig(obj) {
        if (obj) this.headingLevel = $8QA0A.parseNumber(obj.headingLevel);
    }
    return TextBlockConfig;
}();
module.exports.TextBlockConfig = $fcd81e67f3fb9457$var$TextBlockConfig;
var $fcd81e67f3fb9457$var$RequiredInputLabelTextDefinition = /** @class */ function(_super) {
    $fcd81e67f3fb9457$var$__extends(RequiredInputLabelTextDefinition, _super);
    function RequiredInputLabelTextDefinition() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.suffix = " *";
        _this.suffixColor = $kD48O.TextColor.Attention;
        return _this;
    }
    RequiredInputLabelTextDefinition.prototype.parse = function(obj) {
        _super.prototype.parse.call(this, obj);
        if (obj) {
            this.suffix = obj["suffix"] || this.suffix;
            this.suffixColor = $fcd81e67f3fb9457$var$parseHostConfigEnum($kD48O.TextColor, obj["suffixColor"], this.suffixColor);
        }
    };
    RequiredInputLabelTextDefinition.prototype.toJSON = function() {
        var result = _super.prototype.toJSON.call(this);
        result["suffix"] = this.suffix;
        result["suffixColor"] = $kD48O.TextColor[this.suffixColor];
        return result;
    };
    return RequiredInputLabelTextDefinition;
}($fcd81e67f3fb9457$var$BaseTextDefinition);
module.exports.RequiredInputLabelTextDefinition = $fcd81e67f3fb9457$var$RequiredInputLabelTextDefinition;
var $fcd81e67f3fb9457$var$InputLabelConfig = /** @class */ function() {
    function InputLabelConfig(obj) {
        this.inputSpacing = $kD48O.Spacing.Small;
        this.width = 30;
        this.requiredInputs = new $fcd81e67f3fb9457$var$RequiredInputLabelTextDefinition();
        this.optionalInputs = new $fcd81e67f3fb9457$var$BaseTextDefinition();
        if (obj) {
            this.inputSpacing = $fcd81e67f3fb9457$var$parseHostConfigEnum($kD48O.Spacing, obj["inputSpacing"], this.inputSpacing);
            this.requiredInputs = new $fcd81e67f3fb9457$var$RequiredInputLabelTextDefinition(obj["requiredInputs"]);
            this.optionalInputs = new $fcd81e67f3fb9457$var$BaseTextDefinition(obj["optionalInputs"]);
            this.width = obj["width"] != null ? obj["width"] : this.width;
        }
    }
    return InputLabelConfig;
}();
module.exports.InputLabelConfig = $fcd81e67f3fb9457$var$InputLabelConfig;
var $fcd81e67f3fb9457$var$InputConfig = /** @class */ function() {
    function InputConfig(obj) {
        this.label = new $fcd81e67f3fb9457$var$InputLabelConfig();
        this.errorMessage = new $fcd81e67f3fb9457$var$BaseTextDefinition({
            color: $kD48O.TextColor.Attention
        });
        this.debounceTimeInMilliSeconds = 0;
        this.allowRevealOnHoverStyle = false;
        if (obj) {
            this.label = new $fcd81e67f3fb9457$var$InputLabelConfig(obj["label"]);
            this.errorMessage = new $fcd81e67f3fb9457$var$BaseTextDefinition(obj["errorMessage"]);
            this.allowRevealOnHoverStyle = obj["allowRevealOnHoverStyle"] || this.allowRevealOnHoverStyle;
            this.debounceTimeInMilliSeconds = obj.debounceTimeInMilliSeconds;
        }
    }
    return InputConfig;
}();
module.exports.InputConfig = $fcd81e67f3fb9457$var$InputConfig;
var $fcd81e67f3fb9457$var$FactTextDefinition = /** @class */ function(_super) {
    $fcd81e67f3fb9457$var$__extends(FactTextDefinition, _super);
    function FactTextDefinition() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.wrap = true;
        return _this;
    }
    FactTextDefinition.prototype.parse = function(obj) {
        _super.prototype.parse.call(this, obj);
        if (obj) this.wrap = obj["wrap"] != null ? obj["wrap"] : this.wrap;
    };
    FactTextDefinition.prototype.toJSON = function() {
        var result = _super.prototype.toJSON.call(this);
        result["wrap"] = this.wrap;
        return result;
    };
    return FactTextDefinition;
}($fcd81e67f3fb9457$var$BaseTextDefinition);
module.exports.FactTextDefinition = $fcd81e67f3fb9457$var$FactTextDefinition;
var $fcd81e67f3fb9457$var$FactTitleDefinition = /** @class */ function(_super) {
    $fcd81e67f3fb9457$var$__extends(FactTitleDefinition, _super);
    function FactTitleDefinition(obj) {
        var _this = _super.call(this, obj) || this;
        _this.maxWidth = 150;
        _this.weight = $kD48O.TextWeight.Bolder;
        if (obj) {
            _this.maxWidth = obj["maxWidth"] != null ? obj["maxWidth"] : _this.maxWidth;
            _this.weight = $fcd81e67f3fb9457$var$parseHostConfigEnum($kD48O.TextWeight, obj["weight"], $kD48O.TextWeight.Bolder);
        }
        return _this;
    }
    FactTitleDefinition.prototype.getDefaultWeight = function() {
        return $kD48O.TextWeight.Bolder;
    };
    return FactTitleDefinition;
}($fcd81e67f3fb9457$var$FactTextDefinition);
module.exports.FactTitleDefinition = $fcd81e67f3fb9457$var$FactTitleDefinition;
var $fcd81e67f3fb9457$var$FactSetConfig = /** @class */ function() {
    function FactSetConfig(obj) {
        this.title = new $fcd81e67f3fb9457$var$FactTitleDefinition();
        this.value = new $fcd81e67f3fb9457$var$FactTextDefinition();
        this.spacing = 10;
        if (obj) {
            this.title = new $fcd81e67f3fb9457$var$FactTitleDefinition(obj["title"]);
            this.value = new $fcd81e67f3fb9457$var$FactTextDefinition(obj["value"]);
            this.spacing = obj.spacing && obj.spacing != null ? obj.spacing && obj.spacing : this.spacing;
        }
    }
    return FactSetConfig;
}();
module.exports.FactSetConfig = $fcd81e67f3fb9457$var$FactSetConfig;
var $fcd81e67f3fb9457$var$ShowCardActionConfig = /** @class */ function() {
    function ShowCardActionConfig(obj) {
        this.actionMode = $kD48O.ShowCardActionMode.Inline;
        this.inlineTopMargin = 16;
        this.style = $kD48O.ContainerStyle.Emphasis;
        if (obj) {
            this.actionMode = $fcd81e67f3fb9457$var$parseHostConfigEnum($kD48O.ShowCardActionMode, obj["actionMode"], $kD48O.ShowCardActionMode.Inline);
            this.inlineTopMargin = obj["inlineTopMargin"] != null ? obj["inlineTopMargin"] : this.inlineTopMargin;
            this.style = obj["style"] && typeof obj["style"] === "string" ? obj["style"] : $kD48O.ContainerStyle.Emphasis;
        }
    }
    ShowCardActionConfig.prototype.toJSON = function() {
        return {
            actionMode: $kD48O.ShowCardActionMode[this.actionMode],
            inlineTopMargin: this.inlineTopMargin,
            style: this.style
        };
    };
    return ShowCardActionConfig;
}();
module.exports.ShowCardActionConfig = $fcd81e67f3fb9457$var$ShowCardActionConfig;
var $fcd81e67f3fb9457$var$ActionsConfig = /** @class */ function() {
    function ActionsConfig(obj) {
        this.maxActions = 5;
        this.spacing = $kD48O.Spacing.Default;
        this.buttonSpacing = 20;
        this.showCard = new $fcd81e67f3fb9457$var$ShowCardActionConfig();
        this.preExpandSingleShowCardAction = false;
        this.actionsOrientation = $kD48O.Orientation.Horizontal;
        this.actionAlignment = $kD48O.ActionAlignment.Left;
        this.iconPlacement = $kD48O.ActionIconPlacement.LeftOfTitle;
        this.allowTitleToWrap = false;
        this.iconSize = 16;
        if (obj) {
            this.maxActions = obj["maxActions"] != null ? obj["maxActions"] : this.maxActions;
            this.spacing = $fcd81e67f3fb9457$var$parseHostConfigEnum($kD48O.Spacing, obj.spacing && obj.spacing, $kD48O.Spacing.Default);
            this.buttonSpacing = obj["buttonSpacing"] != null ? obj["buttonSpacing"] : this.buttonSpacing;
            this.showCard = new $fcd81e67f3fb9457$var$ShowCardActionConfig(obj["showCard"]);
            this.preExpandSingleShowCardAction = $8QA0A.parseBool(obj["preExpandSingleShowCardAction"], false);
            this.actionsOrientation = $fcd81e67f3fb9457$var$parseHostConfigEnum($kD48O.Orientation, obj["actionsOrientation"], $kD48O.Orientation.Horizontal);
            this.actionAlignment = $fcd81e67f3fb9457$var$parseHostConfigEnum($kD48O.ActionAlignment, obj["actionAlignment"], $kD48O.ActionAlignment.Left);
            this.iconPlacement = $fcd81e67f3fb9457$var$parseHostConfigEnum($kD48O.ActionIconPlacement, obj["iconPlacement"], $kD48O.ActionIconPlacement.LeftOfTitle);
            this.allowTitleToWrap = obj["allowTitleToWrap"] != null ? obj["allowTitleToWrap"] : this.allowTitleToWrap;
            try {
                var sizeAndUnit = $8Lw6d.SizeAndUnit.parse(obj["iconSize"]);
                if (sizeAndUnit.unit === $kD48O.SizeUnit.Pixel) this.iconSize = sizeAndUnit.physicalSize;
            } catch (e) {
            // Swallow this, keep default icon size
            }
        }
    }
    ActionsConfig.prototype.toJSON = function() {
        return {
            maxActions: this.maxActions,
            spacing: $kD48O.Spacing[this.spacing],
            buttonSpacing: this.buttonSpacing,
            showCard: this.showCard,
            preExpandSingleShowCardAction: this.preExpandSingleShowCardAction,
            actionsOrientation: $kD48O.Orientation[this.actionsOrientation],
            actionAlignment: $kD48O.ActionAlignment[this.actionAlignment]
        };
    };
    return ActionsConfig;
}();
module.exports.ActionsConfig = $fcd81e67f3fb9457$var$ActionsConfig;
var $fcd81e67f3fb9457$var$ColorSetDefinition = /** @class */ function() {
    function ColorSetDefinition(obj) {
        this.default = new $fcd81e67f3fb9457$var$TextColorDefinition();
        this.dark = new $fcd81e67f3fb9457$var$TextColorDefinition();
        this.light = new $fcd81e67f3fb9457$var$TextColorDefinition();
        this.accent = new $fcd81e67f3fb9457$var$TextColorDefinition();
        this.good = new $fcd81e67f3fb9457$var$TextColorDefinition();
        this.warning = new $fcd81e67f3fb9457$var$TextColorDefinition();
        this.attention = new $fcd81e67f3fb9457$var$TextColorDefinition();
        this.parse(obj);
    }
    ColorSetDefinition.prototype.parseSingleColor = function(obj, propertyName) {
        if (obj) this[propertyName].parse(obj[propertyName]);
    };
    ColorSetDefinition.prototype.parse = function(obj) {
        if (obj) {
            this.parseSingleColor(obj, "default");
            this.parseSingleColor(obj, "dark");
            this.parseSingleColor(obj, "light");
            this.parseSingleColor(obj, "accent");
            this.parseSingleColor(obj, "good");
            this.parseSingleColor(obj, "warning");
            this.parseSingleColor(obj, "attention");
        }
    };
    return ColorSetDefinition;
}();
module.exports.ColorSetDefinition = $fcd81e67f3fb9457$var$ColorSetDefinition;
var $fcd81e67f3fb9457$var$ContainerStyleDefinition = /** @class */ function() {
    function ContainerStyleDefinition(obj) {
        this.foregroundColors = new $fcd81e67f3fb9457$var$ColorSetDefinition({
            "default": {
                default: "#333333",
                subtle: "#EE333333"
            },
            "dark": {
                default: "#000000",
                subtle: "#66000000"
            },
            "light": {
                default: "#FFFFFF",
                subtle: "#33000000"
            },
            "accent": {
                default: "#2E89FC",
                subtle: "#882E89FC"
            },
            "good": {
                default: "#028A02",
                subtle: "#DD027502"
            },
            "warning": {
                default: "#E69500",
                subtle: "#DDE69500"
            },
            "attention": {
                default: "#CC3300",
                subtle: "#DDCC3300"
            }
        });
        this.parse(obj);
    }
    ContainerStyleDefinition.prototype.parse = function(obj) {
        if (obj) {
            this.backgroundColor = obj["backgroundColor"];
            this.foregroundColors.parse(obj["foregroundColors"]);
            this.highlightBackgroundColor = obj["highlightBackgroundColor"];
            this.highlightForegroundColor = obj["highlightForegroundColor"];
            this.borderColor = obj["borderColor"];
        }
    };
    Object.defineProperty(ContainerStyleDefinition.prototype, "isBuiltIn", {
        get: function() {
            return false;
        },
        enumerable: false,
        configurable: true
    });
    return ContainerStyleDefinition;
}();
module.exports.ContainerStyleDefinition = $fcd81e67f3fb9457$var$ContainerStyleDefinition;
var $fcd81e67f3fb9457$var$BuiltInContainerStyleDefinition = /** @class */ function(_super) {
    $fcd81e67f3fb9457$var$__extends(BuiltInContainerStyleDefinition, _super);
    function BuiltInContainerStyleDefinition() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(BuiltInContainerStyleDefinition.prototype, "isBuiltIn", {
        get: function() {
            return true;
        },
        enumerable: false,
        configurable: true
    });
    return BuiltInContainerStyleDefinition;
}($fcd81e67f3fb9457$var$ContainerStyleDefinition);
var $fcd81e67f3fb9457$var$ContainerStyleSet = /** @class */ function() {
    function ContainerStyleSet(obj) {
        this._allStyles = {};
        this._allStyles[$kD48O.ContainerStyle.Default] = new $fcd81e67f3fb9457$var$BuiltInContainerStyleDefinition();
        this._allStyles[$kD48O.ContainerStyle.Emphasis] = new $fcd81e67f3fb9457$var$BuiltInContainerStyleDefinition();
        this._allStyles[$kD48O.ContainerStyle.Accent] = new $fcd81e67f3fb9457$var$BuiltInContainerStyleDefinition();
        this._allStyles[$kD48O.ContainerStyle.Good] = new $fcd81e67f3fb9457$var$BuiltInContainerStyleDefinition();
        this._allStyles[$kD48O.ContainerStyle.Attention] = new $fcd81e67f3fb9457$var$BuiltInContainerStyleDefinition();
        this._allStyles[$kD48O.ContainerStyle.Warning] = new $fcd81e67f3fb9457$var$BuiltInContainerStyleDefinition();
        if (obj) {
            this._allStyles[$kD48O.ContainerStyle.Default].parse(obj[$kD48O.ContainerStyle.Default]);
            this._allStyles[$kD48O.ContainerStyle.Emphasis].parse(obj[$kD48O.ContainerStyle.Emphasis]);
            this._allStyles[$kD48O.ContainerStyle.Accent].parse(obj[$kD48O.ContainerStyle.Accent]);
            this._allStyles[$kD48O.ContainerStyle.Good].parse(obj[$kD48O.ContainerStyle.Good]);
            this._allStyles[$kD48O.ContainerStyle.Attention].parse(obj[$kD48O.ContainerStyle.Attention]);
            this._allStyles[$kD48O.ContainerStyle.Warning].parse(obj[$kD48O.ContainerStyle.Warning]);
            var customStyleArray = obj["customStyles"];
            if (customStyleArray && Array.isArray(customStyleArray)) for(var _i = 0, customStyleArray_1 = customStyleArray; _i < customStyleArray_1.length; _i++){
                var customStyle = customStyleArray_1[_i];
                if (customStyle) {
                    var styleName = customStyle["name"];
                    if (styleName && typeof styleName === "string") {
                        if (this._allStyles.hasOwnProperty(styleName)) this._allStyles[styleName].parse(customStyle["style"]);
                        else this._allStyles[styleName] = new $fcd81e67f3fb9457$var$ContainerStyleDefinition(customStyle["style"]);
                    }
                }
            }
        }
    }
    ContainerStyleSet.prototype.toJSON = function() {
        var _this = this;
        var customStyleArray = [];
        Object.keys(this._allStyles).forEach(function(key) {
            if (!_this._allStyles[key].isBuiltIn) customStyleArray.push({
                name: key,
                style: _this._allStyles[key]
            });
        });
        var result = {
            default: this.default,
            emphasis: this.emphasis
        };
        if (customStyleArray.length > 0) result.customStyles = customStyleArray;
        return result;
    };
    ContainerStyleSet.prototype.getStyleByName = function(name, defaultValue) {
        if (name && this._allStyles.hasOwnProperty(name)) return this._allStyles[name];
        else return defaultValue ? defaultValue : this._allStyles[$kD48O.ContainerStyle.Default];
    };
    Object.defineProperty(ContainerStyleSet.prototype, "default", {
        get: function() {
            return this._allStyles[$kD48O.ContainerStyle.Default];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ContainerStyleSet.prototype, "emphasis", {
        get: function() {
            return this._allStyles[$kD48O.ContainerStyle.Emphasis];
        },
        enumerable: false,
        configurable: true
    });
    return ContainerStyleSet;
}();
module.exports.ContainerStyleSet = $fcd81e67f3fb9457$var$ContainerStyleSet;
var $fcd81e67f3fb9457$var$FontTypeDefinition = /** @class */ function() {
    function FontTypeDefinition(fontFamily) {
        this.fontFamily = "Segoe UI,Segoe,Segoe WP,Helvetica Neue,Helvetica,sans-serif";
        this.fontSizes = {
            small: 12,
            default: 14,
            medium: 17,
            large: 21,
            extraLarge: 26
        };
        this.fontWeights = {
            lighter: 200,
            default: 400,
            bolder: 600
        };
        if (fontFamily) this.fontFamily = fontFamily;
    }
    FontTypeDefinition.prototype.parse = function(obj) {
        this.fontFamily = obj["fontFamily"] || this.fontFamily;
        this.fontSizes = {
            small: obj.fontSizes && obj.fontSizes["small"] || this.fontSizes.small,
            default: obj.fontSizes && obj.fontSizes["default"] || this.fontSizes.default,
            medium: obj.fontSizes && obj.fontSizes["medium"] || this.fontSizes.medium,
            large: obj.fontSizes && obj.fontSizes["large"] || this.fontSizes.large,
            extraLarge: obj.fontSizes && obj.fontSizes["extraLarge"] || this.fontSizes.extraLarge
        };
        this.fontWeights = {
            lighter: obj.fontWeights && obj.fontWeights["lighter"] || this.fontWeights.lighter,
            default: obj.fontWeights && obj.fontWeights["default"] || this.fontWeights.default,
            bolder: obj.fontWeights && obj.fontWeights["bolder"] || this.fontWeights.bolder
        };
    };
    FontTypeDefinition.monospace = new FontTypeDefinition("'Courier New', Courier, monospace");
    return FontTypeDefinition;
}();
module.exports.FontTypeDefinition = $fcd81e67f3fb9457$var$FontTypeDefinition;
var $fcd81e67f3fb9457$var$FontTypeSet = /** @class */ function() {
    function FontTypeSet(obj) {
        this.default = new $fcd81e67f3fb9457$var$FontTypeDefinition();
        this.monospace = new $fcd81e67f3fb9457$var$FontTypeDefinition("'Courier New', Courier, monospace");
        if (obj) {
            this.default.parse(obj["default"]);
            this.monospace.parse(obj["monospace"]);
        }
    }
    FontTypeSet.prototype.getStyleDefinition = function(style) {
        switch(style){
            case $kD48O.FontType.Monospace:
                return this.monospace;
            case $kD48O.FontType.Default:
            default:
                return this.default;
        }
    };
    return FontTypeSet;
}();
module.exports.FontTypeSet = $fcd81e67f3fb9457$var$FontTypeSet;
var $fcd81e67f3fb9457$var$CarouselConfig = /** @class */ function() {
    function CarouselConfig(obj) {
        this.maxCarouselPages = 10;
        this.minAutoplayDelay = 5000.0;
        if (obj) {
            this.maxCarouselPages = obj["maxCarouselPages"] != null ? obj["maxCarouselPages"] : this.maxCarouselPages;
            this.minAutoplayDelay = obj["minAutoplayDelay"] != null ? obj["minAutoplayDelay"] : this.minAutoplayDelay;
        }
    }
    CarouselConfig.prototype.toJSON = function() {
        return {
            maxCarouselPages: this.maxCarouselPages,
            minAutoplayDelay: this.minAutoplayDelay
        };
    };
    return CarouselConfig;
}();
module.exports.CarouselConfig = $fcd81e67f3fb9457$var$CarouselConfig;
var $fcd81e67f3fb9457$var$HostConfig = /** @class */ function() {
    function HostConfig(obj) {
        this.hostCapabilities = new $KzWne.HostCapabilities();
        this.choiceSetInputValueSeparator = ",";
        this.supportsInteractivity = true;
        this.spacing = {
            small: 3,
            default: 8,
            medium: 20,
            large: 30,
            extraLarge: 40,
            padding: 15
        };
        this.separator = {
            lineThickness: 1,
            lineColor: "#EEEEEE"
        };
        this.imageSizes = {
            small: 40,
            medium: 80,
            large: 160
        };
        this.containerStyles = new $fcd81e67f3fb9457$var$ContainerStyleSet();
        this.inputs = new $fcd81e67f3fb9457$var$InputConfig();
        this.actions = new $fcd81e67f3fb9457$var$ActionsConfig();
        this.adaptiveCard = new $fcd81e67f3fb9457$var$AdaptiveCardConfig();
        this.imageSet = new $fcd81e67f3fb9457$var$ImageSetConfig();
        this.media = new $fcd81e67f3fb9457$var$MediaConfig();
        this.factSet = new $fcd81e67f3fb9457$var$FactSetConfig();
        this.table = new $fcd81e67f3fb9457$var$TableConfig();
        this.textStyles = new $fcd81e67f3fb9457$var$TextStyleSet();
        this.textBlock = new $fcd81e67f3fb9457$var$TextBlockConfig();
        this.carousel = new $fcd81e67f3fb9457$var$CarouselConfig();
        this.alwaysAllowBleed = false;
        if (obj) {
            if (typeof obj === "string" || obj instanceof String) obj = JSON.parse(obj);
            this.choiceSetInputValueSeparator = obj && typeof obj["choiceSetInputValueSeparator"] === "string" ? obj["choiceSetInputValueSeparator"] : this.choiceSetInputValueSeparator;
            this.supportsInteractivity = obj && typeof obj["supportsInteractivity"] === "boolean" ? obj["supportsInteractivity"] : this.supportsInteractivity;
            this._legacyFontType = new $fcd81e67f3fb9457$var$FontTypeDefinition();
            this._legacyFontType.parse(obj);
            if (obj.fontTypes) this.fontTypes = new $fcd81e67f3fb9457$var$FontTypeSet(obj.fontTypes);
            if (obj.lineHeights) this.lineHeights = {
                small: obj.lineHeights["small"],
                default: obj.lineHeights["default"],
                medium: obj.lineHeights["medium"],
                large: obj.lineHeights["large"],
                extraLarge: obj.lineHeights["extraLarge"]
            };
            this.imageSizes = {
                small: obj.imageSizes && obj.imageSizes["small"] || this.imageSizes.small,
                medium: obj.imageSizes && obj.imageSizes["medium"] || this.imageSizes.medium,
                large: obj.imageSizes && obj.imageSizes["large"] || this.imageSizes.large
            };
            this.containerStyles = new $fcd81e67f3fb9457$var$ContainerStyleSet(obj["containerStyles"]);
            this.spacing = {
                small: obj.spacing && obj.spacing["small"] || this.spacing.small,
                default: obj.spacing && obj.spacing["default"] || this.spacing.default,
                medium: obj.spacing && obj.spacing["medium"] || this.spacing.medium,
                large: obj.spacing && obj.spacing["large"] || this.spacing.large,
                extraLarge: obj.spacing && obj.spacing["extraLarge"] || this.spacing.extraLarge,
                padding: obj.spacing && obj.spacing["padding"] || this.spacing.padding
            };
            this.separator = {
                lineThickness: obj.separator && obj.separator["lineThickness"] || this.separator.lineThickness,
                lineColor: obj.separator && obj.separator["lineColor"] || this.separator.lineColor
            };
            this.inputs = new $fcd81e67f3fb9457$var$InputConfig(obj.inputs || this.inputs);
            this.actions = new $fcd81e67f3fb9457$var$ActionsConfig(obj.actions || this.actions);
            this.adaptiveCard = new $fcd81e67f3fb9457$var$AdaptiveCardConfig(obj.adaptiveCard || this.adaptiveCard);
            this.imageSet = new $fcd81e67f3fb9457$var$ImageSetConfig(obj["imageSet"]);
            this.factSet = new $fcd81e67f3fb9457$var$FactSetConfig(obj["factSet"]);
            this.textStyles = new $fcd81e67f3fb9457$var$TextStyleSet(obj["textStyles"]);
            this.textBlock = new $fcd81e67f3fb9457$var$TextBlockConfig(obj["textBlock"]);
            this.carousel = new $fcd81e67f3fb9457$var$CarouselConfig(obj["carousel"]);
        }
    }
    HostConfig.prototype.getFontTypeDefinition = function(style) {
        if (this.fontTypes) return this.fontTypes.getStyleDefinition(style);
        else return style === $kD48O.FontType.Monospace ? $fcd81e67f3fb9457$var$FontTypeDefinition.monospace : this._legacyFontType;
    };
    HostConfig.prototype.getEffectiveSpacing = function(spacing) {
        switch(spacing){
            case $kD48O.Spacing.Small:
                return this.spacing.small;
            case $kD48O.Spacing.Default:
                return this.spacing.default;
            case $kD48O.Spacing.Medium:
                return this.spacing.medium;
            case $kD48O.Spacing.Large:
                return this.spacing.large;
            case $kD48O.Spacing.ExtraLarge:
                return this.spacing.extraLarge;
            case $kD48O.Spacing.Padding:
                return this.spacing.padding;
            default:
                return 0;
        }
    };
    HostConfig.prototype.paddingDefinitionToSpacingDefinition = function(paddingDefinition) {
        return new $8Lw6d.SpacingDefinition(this.getEffectiveSpacing(paddingDefinition.top), this.getEffectiveSpacing(paddingDefinition.right), this.getEffectiveSpacing(paddingDefinition.bottom), this.getEffectiveSpacing(paddingDefinition.left));
    };
    HostConfig.prototype.makeCssClassNames = function() {
        var classNames = [];
        for(var _i = 0; _i < arguments.length; _i++)classNames[_i] = arguments[_i];
        var result = [];
        for(var _a = 0, classNames_1 = classNames; _a < classNames_1.length; _a++){
            var className = classNames_1[_a];
            result.push((this.cssClassNamePrefix ? this.cssClassNamePrefix + "-" : "") + className);
        }
        return result;
    };
    HostConfig.prototype.makeCssClassName = function() {
        var classNames = [];
        for(var _i = 0; _i < arguments.length; _i++)classNames[_i] = arguments[_i];
        var result = this.makeCssClassNames.apply(this, classNames).join(" ");
        return result ? result : "";
    };
    Object.defineProperty(HostConfig.prototype, "fontFamily", {
        get: function() {
            return this._legacyFontType.fontFamily;
        },
        set: function(value) {
            this._legacyFontType.fontFamily = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(HostConfig.prototype, "fontSizes", {
        get: function() {
            return this._legacyFontType.fontSizes;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(HostConfig.prototype, "fontWeights", {
        get: function() {
            return this._legacyFontType.fontWeights;
        },
        enumerable: false,
        configurable: true
    });
    return HostConfig;
}();
module.exports.HostConfig = $fcd81e67f3fb9457$var$HostConfig;
// eslint-disable-next-line @typescript-eslint/naming-convention
module.exports.defaultHostConfig = new $fcd81e67f3fb9457$var$HostConfig({
    supportsInteractivity: true,
    spacing: {
        small: 10,
        default: 20,
        medium: 30,
        large: 40,
        extraLarge: 50,
        padding: 20
    },
    separator: {
        lineThickness: 1,
        lineColor: "#EEEEEE"
    },
    fontTypes: {
        default: {
            fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
            fontSizes: {
                small: 12,
                default: 14,
                medium: 17,
                large: 21,
                extraLarge: 26
            },
            fontWeights: {
                lighter: 200,
                default: 400,
                bolder: 600
            }
        },
        monospace: {
            fontFamily: "'Courier New', Courier, monospace",
            fontSizes: {
                small: 12,
                default: 14,
                medium: 17,
                large: 21,
                extraLarge: 26
            },
            fontWeights: {
                lighter: 200,
                default: 400,
                bolder: 600
            }
        }
    },
    imageSizes: {
        small: 40,
        medium: 80,
        large: 160
    },
    containerStyles: {
        default: {
            backgroundColor: "#FFFFFF",
            foregroundColors: {
                default: {
                    default: "#333333",
                    subtle: "#EE333333"
                },
                dark: {
                    default: "#000000",
                    subtle: "#66000000"
                },
                light: {
                    default: "#FFFFFF",
                    subtle: "#33000000"
                },
                accent: {
                    default: "#2E89FC",
                    subtle: "#882E89FC"
                },
                attention: {
                    default: "#cc3300",
                    subtle: "#DDcc3300"
                },
                good: {
                    default: "#028A02",
                    subtle: "#DD027502"
                },
                warning: {
                    default: "#e69500",
                    subtle: "#DDe69500"
                }
            }
        },
        emphasis: {
            backgroundColor: "#08000000",
            foregroundColors: {
                default: {
                    default: "#333333",
                    subtle: "#EE333333"
                },
                dark: {
                    default: "#000000",
                    subtle: "#66000000"
                },
                light: {
                    default: "#FFFFFF",
                    subtle: "#33000000"
                },
                accent: {
                    default: "#2E89FC",
                    subtle: "#882E89FC"
                },
                attention: {
                    default: "#cc3300",
                    subtle: "#DDcc3300"
                },
                good: {
                    default: "#028A02",
                    subtle: "#DD027502"
                },
                warning: {
                    default: "#e69500",
                    subtle: "#DDe69500"
                }
            }
        },
        accent: {
            backgroundColor: "#C7DEF9",
            foregroundColors: {
                default: {
                    default: "#333333",
                    subtle: "#EE333333"
                },
                dark: {
                    default: "#000000",
                    subtle: "#66000000"
                },
                light: {
                    default: "#FFFFFF",
                    subtle: "#33000000"
                },
                accent: {
                    default: "#2E89FC",
                    subtle: "#882E89FC"
                },
                attention: {
                    default: "#cc3300",
                    subtle: "#DDcc3300"
                },
                good: {
                    default: "#028A02",
                    subtle: "#DD027502"
                },
                warning: {
                    default: "#e69500",
                    subtle: "#DDe69500"
                }
            }
        },
        good: {
            backgroundColor: "#CCFFCC",
            foregroundColors: {
                default: {
                    default: "#333333",
                    subtle: "#EE333333"
                },
                dark: {
                    default: "#000000",
                    subtle: "#66000000"
                },
                light: {
                    default: "#FFFFFF",
                    subtle: "#33000000"
                },
                accent: {
                    default: "#2E89FC",
                    subtle: "#882E89FC"
                },
                attention: {
                    default: "#cc3300",
                    subtle: "#DDcc3300"
                },
                good: {
                    default: "#028A02",
                    subtle: "#DD027502"
                },
                warning: {
                    default: "#e69500",
                    subtle: "#DDe69500"
                }
            }
        },
        attention: {
            backgroundColor: "#FFC5B2",
            foregroundColors: {
                default: {
                    default: "#333333",
                    subtle: "#EE333333"
                },
                dark: {
                    default: "#000000",
                    subtle: "#66000000"
                },
                light: {
                    default: "#FFFFFF",
                    subtle: "#33000000"
                },
                accent: {
                    default: "#2E89FC",
                    subtle: "#882E89FC"
                },
                attention: {
                    default: "#cc3300",
                    subtle: "#DDcc3300"
                },
                good: {
                    default: "#028A02",
                    subtle: "#DD027502"
                },
                warning: {
                    default: "#e69500",
                    subtle: "#DDe69500"
                }
            }
        },
        warning: {
            backgroundColor: "#FFE2B2",
            foregroundColors: {
                default: {
                    default: "#333333",
                    subtle: "#EE333333"
                },
                dark: {
                    default: "#000000",
                    subtle: "#66000000"
                },
                light: {
                    default: "#FFFFFF",
                    subtle: "#33000000"
                },
                accent: {
                    default: "#2E89FC",
                    subtle: "#882E89FC"
                },
                attention: {
                    default: "#cc3300",
                    subtle: "#DDcc3300"
                },
                good: {
                    default: "#028A02",
                    subtle: "#DD027502"
                },
                warning: {
                    default: "#e69500",
                    subtle: "#DDe69500"
                }
            }
        }
    },
    inputs: {
        label: {
            requiredInputs: {
                weight: $kD48O.TextWeight.Bolder,
                suffix: " *",
                suffixColor: $kD48O.TextColor.Attention
            },
            optionalInputs: {
                weight: $kD48O.TextWeight.Bolder
            }
        },
        errorMessage: {
            color: $kD48O.TextColor.Attention,
            weight: $kD48O.TextWeight.Bolder
        },
        debounceTimeInMilliSeconds: 250
    },
    actions: {
        maxActions: 5,
        spacing: $kD48O.Spacing.Default,
        buttonSpacing: 10,
        showCard: {
            actionMode: $kD48O.ShowCardActionMode.Inline,
            inlineTopMargin: 16
        },
        actionsOrientation: $kD48O.Orientation.Horizontal,
        actionAlignment: $kD48O.ActionAlignment.Left
    },
    adaptiveCard: {
        allowCustomStyle: false
    },
    imageSet: {
        imageSize: $kD48O.Size.Medium,
        maxImageHeight: 100
    },
    factSet: {
        title: {
            color: $kD48O.TextColor.Default,
            size: $kD48O.TextSize.Default,
            isSubtle: false,
            weight: $kD48O.TextWeight.Bolder,
            wrap: true,
            maxWidth: 150
        },
        value: {
            color: $kD48O.TextColor.Default,
            size: $kD48O.TextSize.Default,
            isSubtle: false,
            weight: $kD48O.TextWeight.Default,
            wrap: true
        },
        spacing: 10
    },
    carousel: {
        maxCarouselPages: 10,
        minAutoplayDuration: 5000
    }
});

});

parcelRequire.register("hfx8W", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.GlobalRegistry = module.exports.CardObjectRegistry = void 0;

var $eZfTX = parcelRequire("eZfTX");
var $c8ed8bf5154acf50$var$CardObjectRegistry = /** @class */ function() {
    function CardObjectRegistry() {
        this._items = {};
    }
    CardObjectRegistry.prototype.findByName = function(typeName) {
        return this._items.hasOwnProperty(typeName) ? this._items[typeName] : undefined;
    };
    CardObjectRegistry.prototype.clear = function() {
        this._items = {};
    };
    CardObjectRegistry.prototype.copyTo = function(target) {
        var keys = Object.keys(this._items);
        for(var _i = 0, keys_1 = keys; _i < keys_1.length; _i++){
            var key = keys_1[_i];
            var typeRegistration = this._items[key];
            target.register(typeRegistration.typeName, typeRegistration.objectType, typeRegistration.schemaVersion);
        }
    };
    CardObjectRegistry.prototype.register = function(typeName, objectType, schemaVersion) {
        if (schemaVersion === void 0) schemaVersion = $eZfTX.Versions.v1_0;
        var registrationInfo = this.findByName(typeName);
        if (registrationInfo !== undefined) registrationInfo.objectType = objectType;
        else registrationInfo = {
            typeName: typeName,
            objectType: objectType,
            schemaVersion: schemaVersion
        };
        this._items[typeName] = registrationInfo;
    };
    CardObjectRegistry.prototype.unregister = function(typeName) {
        delete this._items[typeName];
    };
    CardObjectRegistry.prototype.createInstance = function(typeName, targetVersion) {
        var registrationInfo = this.findByName(typeName);
        return registrationInfo && registrationInfo.schemaVersion.compareTo(targetVersion) <= 0 ? new registrationInfo.objectType() : undefined;
    };
    CardObjectRegistry.prototype.getItemCount = function() {
        return Object.keys(this._items).length;
    };
    CardObjectRegistry.prototype.getItemAt = function(index) {
        var _this = this;
        return Object.keys(this._items).map(function(e) {
            return _this._items[e];
        })[index];
    };
    return CardObjectRegistry;
}();
module.exports.CardObjectRegistry = $c8ed8bf5154acf50$var$CardObjectRegistry;
// eslint-disable-next-line @typescript-eslint/no-extraneous-class
var $c8ed8bf5154acf50$var$GlobalRegistry = /** @class */ function() {
    function GlobalRegistry() {}
    GlobalRegistry.populateWithDefaultElements = function(registry) {
        registry.clear();
        GlobalRegistry.defaultElements.copyTo(registry);
    };
    GlobalRegistry.populateWithDefaultActions = function(registry) {
        registry.clear();
        GlobalRegistry.defaultActions.copyTo(registry);
    };
    Object.defineProperty(GlobalRegistry, "elements", {
        get: function() {
            if (!GlobalRegistry._elements) {
                GlobalRegistry._elements = new $c8ed8bf5154acf50$var$CardObjectRegistry();
                GlobalRegistry.populateWithDefaultElements(GlobalRegistry._elements);
            }
            return GlobalRegistry._elements;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(GlobalRegistry, "actions", {
        get: function() {
            if (!GlobalRegistry._actions) {
                GlobalRegistry._actions = new $c8ed8bf5154acf50$var$CardObjectRegistry();
                GlobalRegistry.populateWithDefaultActions(GlobalRegistry._actions);
            }
            return GlobalRegistry._actions;
        },
        enumerable: false,
        configurable: true
    });
    GlobalRegistry.reset = function() {
        GlobalRegistry._elements = undefined;
        GlobalRegistry._actions = undefined;
    };
    GlobalRegistry.defaultElements = new $c8ed8bf5154acf50$var$CardObjectRegistry();
    GlobalRegistry.defaultActions = new $c8ed8bf5154acf50$var$CardObjectRegistry();
    return GlobalRegistry;
}();
module.exports.GlobalRegistry = $c8ed8bf5154acf50$var$GlobalRegistry;

});

parcelRequire.register("01FSm", function(module, exports) {
"use strict";
var $005093c8d75c6d2e$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $005093c8d75c6d2e$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CardObject = module.exports.ValidationResults = void 0;

var $kD48O = parcelRequire("kD48O");

var $c6BU9 = parcelRequire("c6BU9");

var $8Lw6d = parcelRequire("8Lw6d");

var $KzWne = parcelRequire("KzWne");

var $eZfTX = parcelRequire("eZfTX");
var $005093c8d75c6d2e$var$ValidationResults = /** @class */ function() {
    function ValidationResults() {
        this.allIds = {};
        this.validationEvents = [];
    }
    ValidationResults.prototype.addFailure = function(cardObject, event, message) {
        this.validationEvents.push({
            phase: $kD48O.ValidationPhase.Validation,
            source: cardObject,
            event: event,
            message: message
        });
    };
    return ValidationResults;
}();
module.exports.ValidationResults = $005093c8d75c6d2e$var$ValidationResults;
var $005093c8d75c6d2e$var$CardObject = /** @class */ function(_super) {
    $005093c8d75c6d2e$var$__extends(CardObject, _super);
    function CardObject() {
        //#region Schema
        var _this = _super !== null && _super.apply(this, arguments) || this;
        //#endregion
        _this._shouldFallback = false;
        return _this;
    }
    CardObject.prototype.getSchemaKey = function() {
        return this.getJsonTypeName();
    };
    Object.defineProperty(CardObject.prototype, "requires", {
        get: function() {
            return this.getValue(CardObject.requiresProperty);
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Checks if this CardObject contains the given DOM Node.
     * @param node The DOM Node to look for.
     * @returns `true` if the DOM Node was found, `false` otherwise.
     */ CardObject.prototype.contains = function(node) {
        if (this._renderedElement) return this._renderedElement.contains(node);
        return false;
    };
    CardObject.prototype.preProcessPropertyValue = function(prop, propertyValue) {
        var value = propertyValue === undefined ? this.getValue(prop) : propertyValue;
        if ($8Lw6d.GlobalSettings.allowPreProcessingPropertyValues) {
            // eslint-disable-next-line @typescript-eslint/no-this-alias
            var currentObject = this;
            while(currentObject && !currentObject.onPreProcessPropertyValue)currentObject = currentObject.parent;
            if (currentObject && currentObject.onPreProcessPropertyValue) return currentObject.onPreProcessPropertyValue(this, prop, value);
        }
        return value;
    };
    CardObject.prototype.setParent = function(value) {
        this._parent = value;
    };
    CardObject.prototype.setShouldFallback = function(value) {
        this._shouldFallback = value;
    };
    CardObject.prototype.shouldFallback = function() {
        return this._shouldFallback || !this.requires.areAllMet(this.hostConfig.hostCapabilities);
    };
    CardObject.prototype.getRootObject = function() {
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        var currentObject = this;
        while(currentObject.parent)currentObject = currentObject.parent;
        return currentObject;
    };
    CardObject.prototype.internalValidateProperties = function(context) {
        if (this.id) {
            if (context.allIds.hasOwnProperty(this.id)) {
                if (context.allIds[this.id] === 1) context.addFailure(this, $kD48O.ValidationEvent.DuplicateId, $c6BU9.Strings.errors.duplicateId(this.id));
                context.allIds[this.id] += 1;
            } else context.allIds[this.id] = 1;
        }
    };
    CardObject.prototype.validateProperties = function() {
        var result = new $005093c8d75c6d2e$var$ValidationResults();
        this.internalValidateProperties(result);
        return result;
    };
    /**
     * Recursively searches this CardObject and any children to find the
     * innermost CardObject that owns the given DOM Node.
     *
     * @param node The DOM Node to look for.
     *
     * @returns The owner of the given DOM Node, or `undefined` if no owner was found.
     */ CardObject.prototype.findDOMNodeOwner = function(node) {
        // default implementation for CardObjects with no associated children
        return this.contains(node) ? this : undefined;
    };
    CardObject.prototype.releaseDOMResources = function() {
    // Do nothing in base implementation
    };
    Object.defineProperty(CardObject.prototype, "parent", {
        get: function() {
            return this._parent;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CardObject.prototype, "renderedElement", {
        get: function() {
            return this._renderedElement;
        },
        enumerable: false,
        configurable: true
    });
    CardObject.typeNameProperty = new $eZfTX.StringProperty($eZfTX.Versions.v1_0, "type", undefined, undefined, undefined, function(sender) {
        return sender.getJsonTypeName();
    });
    CardObject.idProperty = new $eZfTX.StringProperty($eZfTX.Versions.v1_0, "id");
    CardObject.requiresProperty = new $eZfTX.SerializableObjectProperty($eZfTX.Versions.v1_2, "requires", $KzWne.HostCapabilities, false, new $KzWne.HostCapabilities());
    $005093c8d75c6d2e$var$__decorate([
        (0, $eZfTX.property)(CardObject.idProperty)
    ], CardObject.prototype, "id", void 0);
    $005093c8d75c6d2e$var$__decorate([
        (0, $eZfTX.property)(CardObject.requiresProperty)
    ], CardObject.prototype, "requires", null);
    return CardObject;
}($eZfTX.SerializableObject);
module.exports.CardObject = $005093c8d75c6d2e$var$CardObject;

});

parcelRequire.register("eDhMr", function(module, exports) {
"use strict";
var $aa728000c38af56f$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $aa728000c38af56f$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $aa728000c38af56f$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $aa728000c38af56f$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.BackgroundImage = module.exports.ContainerBase = module.exports.StylableCardElementContainer = module.exports.ContainerStyleProperty = module.exports.ActionSet = module.exports.ShowCardAction = module.exports.HttpAction = module.exports.HttpHeader = module.exports.ToggleVisibilityAction = module.exports.OpenUrlAction = module.exports.DataQuery = module.exports.ExecuteAction = module.exports.UniversalAction = module.exports.SubmitAction = module.exports.SubmitActionBase = module.exports.Action = module.exports.TimeInput = module.exports.TimeProperty = module.exports.DateInput = module.exports.NumberInput = module.exports.FilteredChoiceSet = module.exports.ChoiceSetInput = module.exports.ChoiceSetInputDataQuery = module.exports.Choice = module.exports.ToggleInput = module.exports.TextInput = module.exports.Input = module.exports.Media = module.exports.YouTubePlayer = module.exports.DailymotionPlayer = module.exports.VimeoPlayer = module.exports.IFrameMediaMediaPlayer = module.exports.CustomMediaPlayer = module.exports.HTML5MediaPlayer = module.exports.MediaPlayer = module.exports.MediaSource = module.exports.CaptionSource = module.exports.ContentSource = module.exports.ImageSet = module.exports.CardElementContainer = module.exports.Image = module.exports.FactSet = module.exports.Fact = module.exports.RichTextBlock = module.exports.TextRun = module.exports.TextBlock = module.exports.BaseTextBlock = module.exports.ActionProperty = module.exports.CardElement = module.exports.renderSeparation = void 0;
module.exports.SerializationContext = module.exports.AdaptiveCard = module.exports.Authentication = module.exports.TokenExchangeResource = module.exports.AuthCardButton = module.exports.RefreshDefinition = module.exports.RefreshActionProperty = module.exports.ContainerWithActions = module.exports.ColumnSet = module.exports.Column = module.exports.Container = void 0;

var $kD48O = parcelRequire("kD48O");

var $8Lw6d = parcelRequire("8Lw6d");

var $8QA0A = parcelRequire("8QA0A");

var $lHSNo = parcelRequire("lHSNo");

var $hmlc3 = parcelRequire("hmlc3");

var $01FSm = parcelRequire("01FSm");

var $eZfTX = parcelRequire("eZfTX");

var $hfx8W = parcelRequire("hfx8W");

var $c6BU9 = parcelRequire("c6BU9");

var $HYaTY = parcelRequire("HYaTY");
function $aa728000c38af56f$var$clearElement(element) {
    var _a, _b;
    var trustedHtml = typeof window === "undefined" ? "" : (_b = (_a = window.trustedTypes) === null || _a === void 0 ? void 0 : _a.emptyHTML) !== null && _b !== void 0 ? _b : "";
    element.innerHTML = trustedHtml;
}
function $aa728000c38af56f$var$renderSeparation(hostConfig, separationDefinition, orientation) {
    if (separationDefinition.spacing > 0 || separationDefinition.lineThickness && separationDefinition.lineThickness > 0) {
        var separator = document.createElement("div");
        separator.className = hostConfig.makeCssClassName("ac-" + (orientation === $kD48O.Orientation.Horizontal ? "horizontal" : "vertical") + "-separator");
        separator.setAttribute("aria-hidden", "true");
        var color = separationDefinition.lineColor ? $8QA0A.stringToCssColor(separationDefinition.lineColor) : "";
        if (orientation === $kD48O.Orientation.Horizontal) {
            if (separationDefinition.lineThickness) {
                separator.style.paddingTop = separationDefinition.spacing / 2 + "px";
                separator.style.marginBottom = separationDefinition.spacing / 2 + "px";
                separator.style.borderBottom = separationDefinition.lineThickness + "px solid " + color;
            } else separator.style.height = separationDefinition.spacing + "px";
        } else if (separationDefinition.lineThickness) {
            separator.style.paddingLeft = separationDefinition.spacing / 2 + "px";
            separator.style.marginRight = separationDefinition.spacing / 2 + "px";
            separator.style.borderRight = separationDefinition.lineThickness + "px solid " + color;
        } else separator.style.width = separationDefinition.spacing + "px";
        separator.style.overflow = "hidden";
        separator.style.flex = "0 0 auto";
        return separator;
    } else return undefined;
}
module.exports.renderSeparation = $aa728000c38af56f$var$renderSeparation;
var $aa728000c38af56f$var$CardElement = /** @class */ function(_super) {
    $aa728000c38af56f$var$__extends(CardElement, _super);
    function CardElement() {
        //#region Schema
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._truncatedDueToOverflow = false;
        return _this;
    }
    Object.defineProperty(CardElement.prototype, "lang", {
        get: function() {
            var lang = this.getValue(CardElement.langProperty);
            if (lang) return lang;
            else {
                if (this.parent) return this.parent.lang;
                else return undefined;
            }
        },
        set: function(value) {
            this.setValue(CardElement.langProperty, value);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CardElement.prototype, "isVisible", {
        get: function() {
            return this.getValue(CardElement.isVisibleProperty);
        },
        set: function(value) {
            // If the element is going to be hidden, reset any changes that were due
            // to overflow truncation (this ensures that if the element is later
            // un-hidden it has the right content)
            if ($8Lw6d.GlobalSettings.useAdvancedCardBottomTruncation && !value) this.undoOverflowTruncation();
            if (this.isVisible !== value) {
                this.setValue(CardElement.isVisibleProperty, value);
                this.updateRenderedElementVisibility();
                if (this._renderedElement) $aa728000c38af56f$var$raiseElementVisibilityChangedEvent(this);
            }
            if (this._renderedElement) this._renderedElement.setAttribute("aria-expanded", value.toString());
        },
        enumerable: false,
        configurable: true
    });
    CardElement.prototype.internalRenderSeparator = function() {
        var renderedSeparator = $aa728000c38af56f$var$renderSeparation(this.hostConfig, {
            spacing: this.hostConfig.getEffectiveSpacing(this.spacing),
            lineThickness: this.separator ? this.hostConfig.separator.lineThickness : undefined,
            lineColor: this.separator ? this.hostConfig.separator.lineColor : undefined
        }, this.separatorOrientation);
        if ($8Lw6d.GlobalSettings.alwaysBleedSeparators && renderedSeparator && this.separatorOrientation === $kD48O.Orientation.Horizontal) {
            // Adjust separator's margins if the option to always bleed separators is turned on
            var parentContainer = this.getParentContainer();
            if (parentContainer && parentContainer.getEffectivePadding()) {
                var parentPhysicalPadding = this.hostConfig.paddingDefinitionToSpacingDefinition(parentContainer.getEffectivePadding());
                renderedSeparator.style.marginLeft = "-" + parentPhysicalPadding.left + "px";
                renderedSeparator.style.marginRight = "-" + parentPhysicalPadding.right + "px";
            }
        }
        return renderedSeparator;
    };
    CardElement.prototype.updateRenderedElementVisibility = function() {
        var displayMode = this.isDesignMode() || this.isVisible ? this._defaultRenderedElementDisplayMode : "none";
        if (this._renderedElement) {
            if (displayMode) this._renderedElement.style.display = displayMode;
            else this._renderedElement.style.removeProperty("display");
        }
        if (this._separatorElement) {
            if (this.parent && this.parent.isFirstElement(this)) this._separatorElement.style.display = "none";
            else if (displayMode) this._separatorElement.style.display = displayMode;
            else this._separatorElement.style.removeProperty("display");
        }
    };
    CardElement.prototype.hideElementDueToOverflow = function() {
        if (this._renderedElement && this.isVisible) {
            this._renderedElement.style.visibility = "hidden";
            this.isVisible = false;
            $aa728000c38af56f$var$raiseElementVisibilityChangedEvent(this, false);
        }
    };
    CardElement.prototype.showElementHiddenDueToOverflow = function() {
        if (this._renderedElement && !this.isVisible) {
            this._renderedElement.style.removeProperty("visibility");
            this.isVisible = true;
            $aa728000c38af56f$var$raiseElementVisibilityChangedEvent(this, false);
        }
    };
    // Marked private to emulate internal access
    CardElement.prototype.handleOverflow = function(maxHeight) {
        if (this.isVisible || this.isHiddenDueToOverflow()) {
            var handled = this.truncateOverflow(maxHeight);
            // Even if we were unable to truncate the element to fit this time,
            // it still could have been previously truncated
            this._truncatedDueToOverflow = handled || this._truncatedDueToOverflow;
            if (!handled) this.hideElementDueToOverflow();
            else if (handled && !this.isVisible) this.showElementHiddenDueToOverflow();
        }
    };
    // Marked private to emulate internal access
    CardElement.prototype.resetOverflow = function() {
        var sizeChanged = false;
        if (this._truncatedDueToOverflow) {
            this.undoOverflowTruncation();
            this._truncatedDueToOverflow = false;
            sizeChanged = true;
        }
        if (this.isHiddenDueToOverflow()) this.showElementHiddenDueToOverflow();
        return sizeChanged;
    };
    CardElement.prototype.getDefaultSerializationContext = function() {
        return new $aa728000c38af56f$var$SerializationContext();
    };
    CardElement.prototype.createPlaceholderElement = function() {
        var styleDefinition = this.getEffectiveStyleDefinition();
        var foregroundCssColor = $8QA0A.stringToCssColor(styleDefinition.foregroundColors.default.subtle);
        var element = document.createElement("div");
        element.style.border = "1px dashed " + foregroundCssColor;
        element.style.padding = "4px";
        element.style.minHeight = "32px";
        element.style.fontSize = "10px";
        if (foregroundCssColor) element.style.color = foregroundCssColor;
        element.innerText = "Empty " + this.getJsonTypeName();
        return element;
    };
    CardElement.prototype.adjustRenderedElementSize = function(renderedElement) {
        if (this.height === "auto") renderedElement.style.flex = "0 0 auto";
        else renderedElement.style.flex = "1 1 auto";
    };
    /*
     * Called when mouse enters or leaves the card.
     * Inputs elements need to update their visual state in such events like showing or hiding borders etc.
     * It calls Input.updateVisualState(eventType) for all inputs.
     * This method on input (updateVisualState) is supposed to be called from card level on mouse events.
     */ CardElement.prototype.updateInputsVisualState = function(hover) {
        var allInputs = this.getAllInputs();
        var inputEventType = !!hover ? $aa728000c38af56f$var$InputEventType.MouseEnterOnCard : $aa728000c38af56f$var$InputEventType.MouseLeaveOnCard;
        allInputs.forEach(function(input) {
            return input.updateVisualState(inputEventType);
        });
    };
    CardElement.prototype.isDisplayed = function() {
        return this._renderedElement !== undefined && this.isVisible && this._renderedElement.offsetHeight > 0;
    };
    CardElement.prototype.overrideInternalRender = function() {
        return this.internalRender();
    };
    CardElement.prototype.applyPadding = function() {
        if (this.separatorElement && this.separatorOrientation === $kD48O.Orientation.Horizontal) {
            if ($8Lw6d.GlobalSettings.alwaysBleedSeparators && !this.isBleeding()) {
                var padding = new $8Lw6d.PaddingDefinition();
                this.getImmediateSurroundingPadding(padding);
                var physicalPadding = this.hostConfig.paddingDefinitionToSpacingDefinition(padding);
                this.separatorElement.style.marginLeft = "-" + physicalPadding.left + "px";
                this.separatorElement.style.marginRight = "-" + physicalPadding.right + "px";
            } else {
                this.separatorElement.style.marginRight = "0";
                this.separatorElement.style.marginLeft = "0";
            }
        }
    };
    /*
     * Called when this element overflows the bottom of the card.
     * maxHeight will be the amount of space still available on the card (0 if
     * the element is fully off the card).
     */ CardElement.prototype.truncateOverflow = function(_maxHeight) {
        // Child implementations should return true if the element handled
        // the truncation request such that its content fits within maxHeight,
        // false if the element should fall back to being hidden
        return false;
    };
    /*
     * This should reverse any changes performed in truncateOverflow().
     */ CardElement.prototype.undoOverflowTruncation = function() {
        return;
    };
    CardElement.prototype.getDefaultPadding = function() {
        return new $8Lw6d.PaddingDefinition();
    };
    CardElement.prototype.getHasBackground = function(ignoreBackgroundImages) {
        if (ignoreBackgroundImages === void 0) ignoreBackgroundImages = false;
        return false;
    };
    CardElement.prototype.getHasBorder = function() {
        return false;
    };
    CardElement.prototype.getPadding = function() {
        return this._padding;
    };
    CardElement.prototype.setPadding = function(value) {
        this._padding = value;
    };
    CardElement.prototype.shouldSerialize = function(context) {
        return context.elementRegistry.findByName(this.getJsonTypeName()) !== undefined;
    };
    Object.defineProperty(CardElement.prototype, "useDefaultSizing", {
        get: function() {
            return true;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CardElement.prototype, "separatorOrientation", {
        get: function() {
            return $kD48O.Orientation.Horizontal;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CardElement.prototype, "defaultStyle", {
        get: function() {
            return $kD48O.ContainerStyle.Default;
        },
        enumerable: false,
        configurable: true
    });
    CardElement.prototype.parse = function(source, context) {
        _super.prototype.parse.call(this, source, context ? context : new $aa728000c38af56f$var$SerializationContext());
    };
    CardElement.prototype.asString = function() {
        return "";
    };
    CardElement.prototype.isBleeding = function() {
        return false;
    };
    CardElement.prototype.getEffectiveStyle = function() {
        if (this.parent) return this.parent.getEffectiveStyle();
        return this.defaultStyle;
    };
    CardElement.prototype.getEffectiveStyleDefinition = function() {
        return this.hostConfig.containerStyles.getStyleByName(this.getEffectiveStyle());
    };
    CardElement.prototype.getEffectiveTextStyleDefinition = function() {
        if (this.parent) return this.parent.getEffectiveTextStyleDefinition();
        return this.hostConfig.textStyles.default;
    };
    CardElement.prototype.getForbiddenActionTypes = function() {
        return [];
    };
    CardElement.prototype.getImmediateSurroundingPadding = function(result, processTop, processRight, processBottom, processLeft) {
        if (processTop === void 0) processTop = true;
        if (processRight === void 0) processRight = true;
        if (processBottom === void 0) processBottom = true;
        if (processLeft === void 0) processLeft = true;
        if (this.parent) {
            var doProcessTop = processTop && this.parent.isTopElement(this);
            var doProcessRight = processRight && this.parent.isRightMostElement(this);
            var doProcessBottom = processBottom && this.parent.isBottomElement(this);
            var doProcessLeft = processLeft && this.parent.isLeftMostElement(this);
            var effectivePadding = this.parent.getEffectivePadding();
            if (effectivePadding) {
                if (doProcessTop && effectivePadding.top !== $kD48O.Spacing.None) {
                    result.top = effectivePadding.top;
                    doProcessTop = false;
                }
                if (doProcessRight && effectivePadding.right !== $kD48O.Spacing.None) {
                    result.right = effectivePadding.right;
                    doProcessRight = false;
                }
                if (doProcessBottom && effectivePadding.bottom !== $kD48O.Spacing.None) {
                    result.bottom = effectivePadding.bottom;
                    doProcessBottom = false;
                }
                if (doProcessLeft && effectivePadding.left !== $kD48O.Spacing.None) {
                    result.left = effectivePadding.left;
                    doProcessLeft = false;
                }
            }
            if (doProcessTop || doProcessRight || doProcessBottom || doProcessLeft) this.parent.getImmediateSurroundingPadding(result, doProcessTop, doProcessRight, doProcessBottom, doProcessLeft);
        }
    };
    CardElement.prototype.getActionCount = function() {
        return 0;
    };
    CardElement.prototype.getActionAt = function(index) {
        throw new Error($c6BU9.Strings.errors.indexOutOfRange(index));
    };
    CardElement.prototype.indexOfAction = function(action) {
        for(var i = 0; i < this.getActionCount(); i++){
            if (this.getActionAt(i) === action) return i;
        }
        return -1;
    };
    CardElement.prototype.remove = function() {
        if (this.parent && this.parent instanceof $aa728000c38af56f$var$CardElementContainer) return this.parent.removeItem(this);
        return false;
    };
    CardElement.prototype.render = function() {
        this._renderedElement = this.overrideInternalRender();
        this._separatorElement = this.internalRenderSeparator();
        if (this._renderedElement) {
            if (this.id) this._renderedElement.id = this.id;
            if (this.customCssSelector) this._renderedElement.classList.add(this.customCssSelector);
            this._renderedElement.style.boxSizing = "border-box";
            this._defaultRenderedElementDisplayMode = this._renderedElement.style.display ? this._renderedElement.style.display : undefined;
            this.adjustRenderedElementSize(this._renderedElement);
            this.updateLayout(false);
        } else if (this.isDesignMode()) this._renderedElement = this.createPlaceholderElement();
        return this._renderedElement;
    };
    CardElement.prototype.updateLayout = function(_processChildren) {
        if (_processChildren === void 0) _processChildren = true;
        this.updateRenderedElementVisibility();
        this.applyPadding();
    };
    CardElement.prototype.updateActionsEnabledState = function() {
        var allActions = this.getRootElement().getAllActions();
        for(var _i = 0, allActions_1 = allActions; _i < allActions_1.length; _i++){
            var action = allActions_1[_i];
            action.updateEnabledState();
        }
    };
    CardElement.prototype.indexOf = function(_cardElement) {
        return -1;
    };
    CardElement.prototype.isDesignMode = function() {
        var rootElement = this.getRootElement();
        return rootElement instanceof $aa728000c38af56f$var$AdaptiveCard && rootElement.designMode;
    };
    CardElement.prototype.isFirstElement = function(_element) {
        return true;
    };
    CardElement.prototype.isLastElement = function(_element) {
        return true;
    };
    CardElement.prototype.isAtTheVeryLeft = function() {
        return this.parent ? this.parent.isLeftMostElement(this) && this.parent.isAtTheVeryLeft() : true;
    };
    CardElement.prototype.isAtTheVeryRight = function() {
        return this.parent ? this.parent.isRightMostElement(this) && this.parent.isAtTheVeryRight() : true;
    };
    CardElement.prototype.isAtTheVeryTop = function() {
        return this.parent ? this.parent.isFirstElement(this) && this.parent.isAtTheVeryTop() : true;
    };
    CardElement.prototype.isAtTheVeryBottom = function() {
        return this.parent ? this.parent.isLastElement(this) && this.parent.isAtTheVeryBottom() : true;
    };
    CardElement.prototype.isBleedingAtTop = function() {
        return false;
    };
    CardElement.prototype.isBleedingAtBottom = function() {
        return false;
    };
    CardElement.prototype.isLeftMostElement = function(_element) {
        return true;
    };
    CardElement.prototype.isRightMostElement = function(_element) {
        return true;
    };
    CardElement.prototype.isTopElement = function(element) {
        return this.isFirstElement(element);
    };
    CardElement.prototype.isBottomElement = function(element) {
        return this.isLastElement(element);
    };
    CardElement.prototype.isHiddenDueToOverflow = function() {
        return this._renderedElement !== undefined && this._renderedElement.style.visibility === "hidden";
    };
    CardElement.prototype.getRootElement = function() {
        return this.getRootObject();
    };
    CardElement.prototype.getParentContainer = function() {
        var currentElement = this.parent;
        while(currentElement){
            if (currentElement instanceof $aa728000c38af56f$var$Container) return currentElement;
            currentElement = currentElement.parent;
        }
        return undefined;
    };
    CardElement.prototype.getAllInputs = function(processActions) {
        if (processActions === void 0) processActions = true;
        return [];
    };
    CardElement.prototype.getAllActions = function() {
        var result = [];
        for(var i = 0; i < this.getActionCount(); i++){
            var action = this.getActionAt(i);
            if (action) result.push(action);
        }
        return result;
    };
    CardElement.prototype.getResourceInformation = function() {
        return [];
    };
    CardElement.prototype.getElementById = function(id) {
        return this.id === id ? this : undefined;
    };
    CardElement.prototype.getActionById = function(_id) {
        return undefined;
    };
    CardElement.prototype.getElementByIdFromAction = function(id) {
        var result = undefined;
        for(var i = 0; i < this.getActionCount(); i++){
            var action = this.getActionAt(i);
            if (action instanceof $aa728000c38af56f$var$ShowCardAction) {
                result = action.card.getElementById(id);
                if (result) break;
            }
        }
        return result;
    };
    CardElement.prototype.getEffectivePadding = function() {
        var padding = this.getPadding();
        return padding ? padding : this.getDefaultPadding();
    };
    CardElement.prototype.getEffectiveHorizontalAlignment = function() {
        if (this.horizontalAlignment !== undefined) return this.horizontalAlignment;
        if (this.parent) return this.parent.getEffectiveHorizontalAlignment();
        return $kD48O.HorizontalAlignment.Left;
    };
    Object.defineProperty(CardElement.prototype, "hostConfig", {
        get: function() {
            if (this._hostConfig) return this._hostConfig;
            else {
                if (this.parent) return this.parent.hostConfig;
                else return $lHSNo.defaultHostConfig;
            }
        },
        set: function(value) {
            this._hostConfig = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CardElement.prototype, "index", {
        get: function() {
            if (this.parent) return this.parent.indexOf(this);
            else return 0;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CardElement.prototype, "isInteractive", {
        get: function() {
            return false;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CardElement.prototype, "isStandalone", {
        get: function() {
            return true;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CardElement.prototype, "isInline", {
        get: function() {
            return false;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CardElement.prototype, "hasVisibleSeparator", {
        get: function() {
            if (this.parent && this.separatorElement) return !this.parent.isFirstElement(this) && (this.isVisible || this.isDesignMode());
            else return false;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CardElement.prototype, "separatorElement", {
        get: function() {
            return this._separatorElement;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CardElement.prototype, "parent", {
        get: function() {
            return this._parent;
        },
        enumerable: false,
        configurable: true
    });
    CardElement.langProperty = new $eZfTX.StringProperty($eZfTX.Versions.v1_1, "lang", true, /^[a-z]{2,3}$/gi);
    CardElement.isVisibleProperty = new $eZfTX.BoolProperty($eZfTX.Versions.v1_2, "isVisible", true);
    CardElement.separatorProperty = new $eZfTX.BoolProperty($eZfTX.Versions.v1_0, "separator", false);
    CardElement.heightProperty = new $eZfTX.ValueSetProperty($eZfTX.Versions.v1_1, "height", [
        {
            value: "auto"
        },
        {
            value: "stretch"
        }
    ], "auto");
    CardElement.horizontalAlignmentProperty = new $eZfTX.EnumProperty($eZfTX.Versions.v1_0, "horizontalAlignment", $kD48O.HorizontalAlignment);
    CardElement.spacingProperty = new $eZfTX.EnumProperty($eZfTX.Versions.v1_0, "spacing", $kD48O.Spacing, $kD48O.Spacing.Default);
    $aa728000c38af56f$var$__decorate([
        (0, $eZfTX.property)(CardElement.horizontalAlignmentProperty)
    ], CardElement.prototype, "horizontalAlignment", void 0);
    $aa728000c38af56f$var$__decorate([
        (0, $eZfTX.property)(CardElement.spacingProperty)
    ], CardElement.prototype, "spacing", void 0);
    $aa728000c38af56f$var$__decorate([
        (0, $eZfTX.property)(CardElement.separatorProperty)
    ], CardElement.prototype, "separator", void 0);
    $aa728000c38af56f$var$__decorate([
        (0, $eZfTX.property)(CardElement.heightProperty)
    ], CardElement.prototype, "height", void 0);
    $aa728000c38af56f$var$__decorate([
        (0, $eZfTX.property)(CardElement.langProperty)
    ], CardElement.prototype, "lang", null);
    $aa728000c38af56f$var$__decorate([
        (0, $eZfTX.property)(CardElement.isVisibleProperty)
    ], CardElement.prototype, "isVisible", null);
    return CardElement;
}($01FSm.CardObject);
module.exports.CardElement = $aa728000c38af56f$var$CardElement;
var $aa728000c38af56f$var$ActionProperty = /** @class */ function(_super) {
    $aa728000c38af56f$var$__extends(ActionProperty, _super);
    function ActionProperty(targetVersion, name, forbiddenActionTypes) {
        if (forbiddenActionTypes === void 0) forbiddenActionTypes = [];
        var _this = _super.call(this, targetVersion, name, undefined) || this;
        _this.targetVersion = targetVersion;
        _this.name = name;
        _this.forbiddenActionTypes = forbiddenActionTypes;
        return _this;
    }
    ActionProperty.prototype.parse = function(sender, source, context) {
        var parent = sender;
        return context.parseAction(parent, source[this.name], this.forbiddenActionTypes, parent.isDesignMode());
    };
    ActionProperty.prototype.toJSON = function(sender, target, value, context) {
        context.serializeValue(target, this.name, value ? value.toJSON(context) : undefined, undefined, true);
    };
    return ActionProperty;
}($eZfTX.PropertyDefinition);
module.exports.ActionProperty = $aa728000c38af56f$var$ActionProperty;
var $aa728000c38af56f$var$BaseTextBlock = /** @class */ function(_super) {
    $aa728000c38af56f$var$__extends(BaseTextBlock, _super);
    function BaseTextBlock(text) {
        var _this = _super.call(this) || this;
        _this.ariaHidden = false;
        if (text) _this.text = text;
        return _this;
    }
    BaseTextBlock.prototype.populateSchema = function(schema) {
        _super.prototype.populateSchema.call(this, schema);
        // selectAction is declared on BaseTextBlock but is only exposed on TextRun,
        // so the property is removed from the BaseTextBlock schema.
        schema.remove(BaseTextBlock.selectActionProperty);
    };
    Object.defineProperty(BaseTextBlock.prototype, "text", {
        get: function() {
            return this.getValue(BaseTextBlock.textProperty);
        },
        set: function(value) {
            this.setText(value);
        },
        enumerable: false,
        configurable: true
    });
    //#endregion
    BaseTextBlock.prototype.getFontSize = function(fontType) {
        switch(this.effectiveSize){
            case $kD48O.TextSize.Small:
                return fontType.fontSizes.small;
            case $kD48O.TextSize.Medium:
                return fontType.fontSizes.medium;
            case $kD48O.TextSize.Large:
                return fontType.fontSizes.large;
            case $kD48O.TextSize.ExtraLarge:
                return fontType.fontSizes.extraLarge;
            default:
                return fontType.fontSizes.default;
        }
    };
    BaseTextBlock.prototype.getColorDefinition = function(colorSet, color) {
        switch(color){
            case $kD48O.TextColor.Accent:
                return colorSet.accent;
            case $kD48O.TextColor.Dark:
                return colorSet.dark;
            case $kD48O.TextColor.Light:
                return colorSet.light;
            case $kD48O.TextColor.Good:
                return colorSet.good;
            case $kD48O.TextColor.Warning:
                return colorSet.warning;
            case $kD48O.TextColor.Attention:
                return colorSet.attention;
            default:
                return colorSet.default;
        }
    };
    BaseTextBlock.prototype.setText = function(value) {
        this.setValue(BaseTextBlock.textProperty, value);
    };
    BaseTextBlock.prototype.init = function(textDefinition) {
        this.size = textDefinition.size;
        this.weight = textDefinition.weight;
        this.color = textDefinition.color;
        this.isSubtle = textDefinition.isSubtle;
    };
    BaseTextBlock.prototype.asString = function() {
        return this.text;
    };
    BaseTextBlock.prototype.applyStylesTo = function(targetElement) {
        var fontType = this.hostConfig.getFontTypeDefinition(this.effectiveFontType);
        if (fontType.fontFamily) targetElement.style.fontFamily = fontType.fontFamily;
        var fontSize;
        switch(this.effectiveSize){
            case $kD48O.TextSize.Small:
                fontSize = fontType.fontSizes.small;
                break;
            case $kD48O.TextSize.Medium:
                fontSize = fontType.fontSizes.medium;
                break;
            case $kD48O.TextSize.Large:
                fontSize = fontType.fontSizes.large;
                break;
            case $kD48O.TextSize.ExtraLarge:
                fontSize = fontType.fontSizes.extraLarge;
                break;
            default:
                fontSize = fontType.fontSizes.default;
                break;
        }
        targetElement.style.fontSize = fontSize + "px";
        var colorDefinition = this.getColorDefinition(this.getEffectiveStyleDefinition().foregroundColors, this.effectiveColor);
        var targetColor = $8QA0A.stringToCssColor(this.effectiveIsSubtle ? colorDefinition.subtle : colorDefinition.default);
        if (targetColor) targetElement.style.color = targetColor;
        var fontWeight;
        switch(this.effectiveWeight){
            case $kD48O.TextWeight.Lighter:
                fontWeight = fontType.fontWeights.lighter;
                break;
            case $kD48O.TextWeight.Bolder:
                fontWeight = fontType.fontWeights.bolder;
                break;
            default:
                fontWeight = fontType.fontWeights.default;
                break;
        }
        targetElement.style.fontWeight = fontWeight.toString();
        if (this.ariaHidden) targetElement.setAttribute("aria-hidden", "true");
    };
    BaseTextBlock.prototype.getAllActions = function() {
        var result = _super.prototype.getAllActions.call(this);
        if (this.selectAction) result.push(this.selectAction);
        return result;
    };
    Object.defineProperty(BaseTextBlock.prototype, "effectiveColor", {
        get: function() {
            return this.color !== undefined ? this.color : this.getEffectiveTextStyleDefinition().color;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BaseTextBlock.prototype, "effectiveFontType", {
        get: function() {
            return this.fontType !== undefined ? this.fontType : this.getEffectiveTextStyleDefinition().fontType;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BaseTextBlock.prototype, "effectiveIsSubtle", {
        get: function() {
            return this.isSubtle !== undefined ? this.isSubtle : this.getEffectiveTextStyleDefinition().isSubtle;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BaseTextBlock.prototype, "effectiveSize", {
        get: function() {
            return this.size !== undefined ? this.size : this.getEffectiveTextStyleDefinition().size;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BaseTextBlock.prototype, "effectiveWeight", {
        get: function() {
            return this.weight !== undefined ? this.weight : this.getEffectiveTextStyleDefinition().weight;
        },
        enumerable: false,
        configurable: true
    });
    //#region Schema
    BaseTextBlock.textProperty = new $eZfTX.StringProperty($eZfTX.Versions.v1_0, "text", true);
    BaseTextBlock.sizeProperty = new $eZfTX.EnumProperty($eZfTX.Versions.v1_0, "size", $kD48O.TextSize);
    BaseTextBlock.weightProperty = new $eZfTX.EnumProperty($eZfTX.Versions.v1_0, "weight", $kD48O.TextWeight);
    BaseTextBlock.colorProperty = new $eZfTX.EnumProperty($eZfTX.Versions.v1_0, "color", $kD48O.TextColor);
    BaseTextBlock.isSubtleProperty = new $eZfTX.BoolProperty($eZfTX.Versions.v1_0, "isSubtle");
    BaseTextBlock.fontTypeProperty = new $eZfTX.EnumProperty($eZfTX.Versions.v1_2, "fontType", $kD48O.FontType);
    BaseTextBlock.selectActionProperty = new $aa728000c38af56f$var$ActionProperty($eZfTX.Versions.v1_1, "selectAction", [
        "Action.ShowCard"
    ]);
    $aa728000c38af56f$var$__decorate([
        (0, $eZfTX.property)(BaseTextBlock.sizeProperty)
    ], BaseTextBlock.prototype, "size", void 0);
    $aa728000c38af56f$var$__decorate([
        (0, $eZfTX.property)(BaseTextBlock.weightProperty)
    ], BaseTextBlock.prototype, "weight", void 0);
    $aa728000c38af56f$var$__decorate([
        (0, $eZfTX.property)(BaseTextBlock.colorProperty)
    ], BaseTextBlock.prototype, "color", void 0);
    $aa728000c38af56f$var$__decorate([
        (0, $eZfTX.property)(BaseTextBlock.fontTypeProperty)
    ], BaseTextBlock.prototype, "fontType", void 0);
    $aa728000c38af56f$var$__decorate([
        (0, $eZfTX.property)(BaseTextBlock.isSubtleProperty)
    ], BaseTextBlock.prototype, "isSubtle", void 0);
    $aa728000c38af56f$var$__decorate([
        (0, $eZfTX.property)(BaseTextBlock.textProperty)
    ], BaseTextBlock.prototype, "text", null);
    $aa728000c38af56f$var$__decorate([
        (0, $eZfTX.property)(BaseTextBlock.selectActionProperty)
    ], BaseTextBlock.prototype, "selectAction", void 0);
    return BaseTextBlock;
}($aa728000c38af56f$var$CardElement);
module.exports.BaseTextBlock = $aa728000c38af56f$var$BaseTextBlock;
var $aa728000c38af56f$var$TextBlock = /** @class */ function(_super) {
    $aa728000c38af56f$var$__extends(TextBlock, _super);
    function TextBlock() {
        //#region Schema
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.wrap = false;
        _this._treatAsPlainText = true;
        _this.useMarkdown = true;
        return _this;
    }
    TextBlock.prototype.restoreOriginalContent = function() {
        var _a, _b;
        if (this.renderedElement !== undefined) {
            if (this.maxLines && this.maxLines > 0) this.renderedElement.style.maxHeight = this._computedLineHeight * this.maxLines + "px";
            var originalHtml = (_b = (_a = TextBlock._ttRoundtripPolicy) === null || _a === void 0 ? void 0 : _a.createHTML(this._originalInnerHtml)) !== null && _b !== void 0 ? _b : this._originalInnerHtml;
            this.renderedElement.innerHTML = originalHtml;
        }
    };
    TextBlock.prototype.truncateIfSupported = function(maxHeight) {
        if (this.renderedElement !== undefined) {
            // For now, only truncate TextBlocks that contain just a single
            // paragraph -- since the maxLines calculation doesn't take into
            // account Markdown lists
            var children = this.renderedElement.children;
            var isTextOnly = !children.length;
            var truncationSupported = isTextOnly || children.length === 1 && children[0].tagName.toLowerCase() === "p" && !children[0].children.length;
            if (truncationSupported) {
                var element = isTextOnly ? this.renderedElement : children[0];
                $8QA0A.truncateText(element, maxHeight, this._computedLineHeight);
                return true;
            }
        }
        return false;
    };
    TextBlock.prototype.setText = function(value) {
        _super.prototype.setText.call(this, value);
        this._processedText = undefined;
    };
    TextBlock.prototype.internalRender = function() {
        var _this = this;
        var _a, _b;
        this._processedText = undefined;
        if (this.text) {
            var preProcessedText = this.preProcessPropertyValue($aa728000c38af56f$var$BaseTextBlock.textProperty);
            var hostConfig = this.hostConfig;
            var element = void 0;
            if (this.forElementId) {
                var labelElement = document.createElement("label");
                labelElement.htmlFor = this.forElementId;
                element = labelElement;
            } else element = document.createElement("div");
            element.classList.add(hostConfig.makeCssClassName("ac-textBlock"));
            element.style.overflow = "hidden";
            this.applyStylesTo(element);
            if (this.style === "heading") {
                element.setAttribute("role", "heading");
                var headingLevel = this.hostConfig.textBlock.headingLevel;
                if (headingLevel !== undefined && headingLevel > 0) element.setAttribute("aria-level", headingLevel.toString());
            }
            if (this.selectAction && hostConfig.supportsInteractivity) {
                element.onclick = function(e) {
                    if (_this.selectAction && _this.selectAction.isEffectivelyEnabled()) {
                        e.preventDefault();
                        e.cancelBubble = true;
                        _this.selectAction.execute();
                    }
                };
                this.selectAction.setupElementForAccessibility(element);
                if (this.selectAction.isEffectivelyEnabled()) element.classList.add(hostConfig.makeCssClassName("ac-selectable"));
            }
            if (!this._processedText) {
                this._treatAsPlainText = true;
                var formattedText = $hmlc3.formatText(this.lang, preProcessedText);
                if (this.useMarkdown && formattedText) {
                    if ($8Lw6d.GlobalSettings.allowMarkForTextHighlighting) formattedText = formattedText.replace(/<mark>/g, "===").replace(/<\/mark>/g, "/==/");
                    var markdownProcessingResult = $aa728000c38af56f$var$AdaptiveCard.applyMarkdown(formattedText);
                    if (markdownProcessingResult.didProcess && markdownProcessingResult.outputHtml) {
                        this._processedText = markdownProcessingResult.outputHtml;
                        this._treatAsPlainText = false;
                        // Only process <mark> tag if markdown processing was applied because
                        // markdown processing is also responsible for sanitizing the input string
                        if ($8Lw6d.GlobalSettings.allowMarkForTextHighlighting && this._processedText) {
                            var markStyle = "";
                            var effectiveStyle = this.getEffectiveStyleDefinition();
                            if (effectiveStyle.highlightBackgroundColor) markStyle += "background-color: " + effectiveStyle.highlightBackgroundColor + ";";
                            if (effectiveStyle.highlightForegroundColor) markStyle += "color: " + effectiveStyle.highlightForegroundColor + ";";
                            if (markStyle) markStyle = 'style="' + markStyle + '"';
                            this._processedText = this._processedText.replace(/===/g, "<mark " + markStyle + ">").replace(/\/==\//g, "</mark>");
                        }
                    } else {
                        this._processedText = formattedText;
                        this._treatAsPlainText = true;
                    }
                } else {
                    this._processedText = formattedText;
                    this._treatAsPlainText = true;
                }
            }
            if (!this._processedText) this._processedText = "";
            if (this._treatAsPlainText) element.innerText = this._processedText;
            else {
                var processedHtml = (_b = (_a = TextBlock._ttMarkdownPolicy) === null || _a === void 0 ? void 0 : _a.createHTML(this._processedText)) !== null && _b !== void 0 ? _b : this._processedText;
                element.innerHTML = processedHtml;
            }
            if (element.firstElementChild instanceof HTMLElement) {
                var firstElementChild = element.firstElementChild;
                firstElementChild.style.marginTop = "0px";
                firstElementChild.style.width = "100%";
                if (!this.wrap) {
                    firstElementChild.style.overflow = "hidden";
                    firstElementChild.style.textOverflow = "ellipsis";
                }
            }
            if (element.lastElementChild instanceof HTMLElement) element.lastElementChild.style.marginBottom = "0px";
            var anchors = element.getElementsByTagName("a");
            var _loop_1 = function(anchor) {
                anchor.classList.add(hostConfig.makeCssClassName("ac-anchor"));
                anchor.target = "_blank";
                anchor.onclick = function(e) {
                    if ($aa728000c38af56f$var$raiseAnchorClickedEvent(_this, anchor, e)) {
                        e.preventDefault();
                        e.cancelBubble = true;
                    }
                };
                anchor.oncontextmenu = function(e) {
                    if ($aa728000c38af56f$var$raiseAnchorClickedEvent(_this, anchor, e)) {
                        e.preventDefault();
                        e.cancelBubble = true;
                        return false;
                    }
                    return true;
                };
            };
            for(var _i = 0, _c = Array.from(anchors); _i < _c.length; _i++){
                var anchor = _c[_i];
                _loop_1(anchor);
            }
            if (this.wrap) {
                element.style.wordWrap = "break-word";
                if (this.maxLines && this.maxLines > 0) {
                    element.style.overflow = "hidden";
                    if ($8QA0A.isInternetExplorer() || !$8Lw6d.GlobalSettings.useWebkitLineClamp) element.style.maxHeight = this._computedLineHeight * this.maxLines + "px";
                    else {
                        // While non standard, --webkit-line-clamp works in every browser (except IE)
                        // and is a great solution to support the maxLines feature with ellipsis
                        // truncation. With --webkit-line-clamp there is need to use explicit line heights
                        element.style.removeProperty("line-height");
                        element.style.display = "-webkit-box";
                        element.style.webkitBoxOrient = "vertical";
                        element.style.webkitLineClamp = this.maxLines.toString();
                    }
                }
            } else {
                element.style.whiteSpace = "nowrap";
                element.style.textOverflow = "ellipsis";
            }
            if ($8Lw6d.GlobalSettings.useAdvancedTextBlockTruncation || $8Lw6d.GlobalSettings.useAdvancedCardBottomTruncation) this._originalInnerHtml = element.innerHTML;
            return element;
        } else return undefined;
    };
    TextBlock.prototype.truncateOverflow = function(maxHeight) {
        if (maxHeight >= this._computedLineHeight) return this.truncateIfSupported(maxHeight);
        return false;
    };
    TextBlock.prototype.undoOverflowTruncation = function() {
        this.restoreOriginalContent();
        if ($8Lw6d.GlobalSettings.useAdvancedTextBlockTruncation && this.maxLines) {
            var maxHeight = this._computedLineHeight * this.maxLines;
            this.truncateIfSupported(maxHeight);
        }
    };
    TextBlock.prototype.applyStylesTo = function(targetElement) {
        _super.prototype.applyStylesTo.call(this, targetElement);
        switch(this.getEffectiveHorizontalAlignment()){
            case $kD48O.HorizontalAlignment.Center:
                targetElement.style.textAlign = "center";
                break;
            case $kD48O.HorizontalAlignment.Right:
                targetElement.style.textAlign = "end";
                break;
            default:
                targetElement.style.textAlign = "start";
                break;
        }
        var lineHeights = this.hostConfig.lineHeights;
        if (lineHeights) switch(this.effectiveSize){
            case $kD48O.TextSize.Small:
                this._computedLineHeight = lineHeights.small;
                break;
            case $kD48O.TextSize.Medium:
                this._computedLineHeight = lineHeights.medium;
                break;
            case $kD48O.TextSize.Large:
                this._computedLineHeight = lineHeights.large;
                break;
            case $kD48O.TextSize.ExtraLarge:
                this._computedLineHeight = lineHeights.extraLarge;
                break;
            default:
                this._computedLineHeight = lineHeights.default;
                break;
        }
        else // Looks like 1.33 is the magic number to compute line-height
        // from font size.
        this._computedLineHeight = this.getFontSize(this.hostConfig.getFontTypeDefinition(this.effectiveFontType)) * 1.33;
        targetElement.style.lineHeight = this._computedLineHeight + "px";
    };
    TextBlock.prototype.getJsonTypeName = function() {
        return "TextBlock";
    };
    TextBlock.prototype.getEffectiveTextStyleDefinition = function() {
        if (this.style) return this.hostConfig.textStyles.getStyleByName(this.style);
        return _super.prototype.getEffectiveTextStyleDefinition.call(this);
    };
    TextBlock.prototype.updateLayout = function(processChildren) {
        if (processChildren === void 0) processChildren = false;
        _super.prototype.updateLayout.call(this, processChildren);
        if ($8Lw6d.GlobalSettings.useAdvancedTextBlockTruncation && this.maxLines && this.isDisplayed()) {
            // Reset the element's innerHTML in case the available room for
            // content has increased
            this.restoreOriginalContent();
            this.truncateIfSupported(this._computedLineHeight * this.maxLines);
        }
    };
    var _a, _b;
    TextBlock.wrapProperty = new $eZfTX.BoolProperty($eZfTX.Versions.v1_0, "wrap", false);
    TextBlock.maxLinesProperty = new $eZfTX.NumProperty($eZfTX.Versions.v1_0, "maxLines");
    TextBlock.styleProperty = new $eZfTX.ValueSetProperty($eZfTX.Versions.v1_5, "style", [
        {
            value: "default"
        },
        {
            value: "columnHeader"
        },
        {
            value: "heading"
        }
    ]);
    // Markdown processing is handled outside of Adaptive Cards. It's up to the host to ensure that markdown is safely
    // processed.
    TextBlock._ttMarkdownPolicy = typeof window === "undefined" ? undefined : (_a = window.trustedTypes) === null || _a === void 0 ? void 0 : _a.createPolicy("adaptivecards#markdownPassthroughPolicy", {
        createHTML: function(value) {
            return value;
        }
    });
    // When "advanced" truncation is enabled (see GlobalSettings.useAdvancedCardBottomTruncation and
    // GlobalSettings.useAdvancedTextBlockTruncation), we store the original pre-truncation content in
    // _originalInnerHtml so that we can restore/recalculate truncation later if space availability has changed (see
    // TextBlock.restoreOriginalContent())
    TextBlock._ttRoundtripPolicy = typeof window === "undefined" ? undefined : (_b = window.trustedTypes) === null || _b === void 0 ? void 0 : _b.createPolicy("adaptivecards#restoreContentsPolicy", {
        createHTML: function(value) {
            return value;
        }
    });
    $aa728000c38af56f$var$__decorate([
        (0, $eZfTX.property)(TextBlock.wrapProperty)
    ], TextBlock.prototype, "wrap", void 0);
    $aa728000c38af56f$var$__decorate([
        (0, $eZfTX.property)(TextBlock.maxLinesProperty)
    ], TextBlock.prototype, "maxLines", void 0);
    $aa728000c38af56f$var$__decorate([
        (0, $eZfTX.property)(TextBlock.styleProperty)
    ], TextBlock.prototype, "style", void 0);
    return TextBlock;
}($aa728000c38af56f$var$BaseTextBlock);
module.exports.TextBlock = $aa728000c38af56f$var$TextBlock;
var $aa728000c38af56f$var$TextRun = /** @class */ function(_super) {
    $aa728000c38af56f$var$__extends(TextRun, _super);
    function TextRun() {
        //#region Schema
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.italic = false;
        _this.strikethrough = false;
        _this.highlight = false;
        _this.underline = false;
        return _this;
    }
    TextRun.prototype.populateSchema = function(schema) {
        _super.prototype.populateSchema.call(this, schema);
        schema.add($aa728000c38af56f$var$BaseTextBlock.selectActionProperty);
    };
    //#endregion
    TextRun.prototype.internalRender = function() {
        var _this = this;
        if (this.text) {
            var preProcessedText = this.preProcessPropertyValue($aa728000c38af56f$var$BaseTextBlock.textProperty);
            var hostConfig = this.hostConfig;
            var formattedText = $hmlc3.formatText(this.lang, preProcessedText);
            if (!formattedText) formattedText = "";
            var element = document.createElement("span");
            element.classList.add(hostConfig.makeCssClassName("ac-textRun"));
            this.applyStylesTo(element);
            if (this.selectAction && hostConfig.supportsInteractivity) {
                var anchor = document.createElement("a");
                anchor.classList.add(hostConfig.makeCssClassName("ac-anchor"));
                var href = this.selectAction.getHref();
                anchor.href = href ? href : "";
                anchor.target = "_blank";
                anchor.onclick = function(e) {
                    if (_this.selectAction && _this.selectAction.isEffectivelyEnabled()) {
                        e.preventDefault();
                        e.cancelBubble = true;
                        _this.selectAction.execute();
                    }
                };
                this.selectAction.setupElementForAccessibility(anchor);
                anchor.innerText = formattedText;
                element.appendChild(anchor);
            } else element.innerText = formattedText;
            return element;
        } else return undefined;
    };
    TextRun.prototype.applyStylesTo = function(targetElement) {
        _super.prototype.applyStylesTo.call(this, targetElement);
        if (this.italic) targetElement.style.fontStyle = "italic";
        if (this.strikethrough) targetElement.style.textDecoration = "line-through";
        if (this.highlight) {
            var colorDefinition = this.getColorDefinition(this.getEffectiveStyleDefinition().foregroundColors, this.effectiveColor);
            var backgroundColor = $8QA0A.stringToCssColor(this.effectiveIsSubtle ? colorDefinition.highlightColors.subtle : colorDefinition.highlightColors.default);
            if (backgroundColor) targetElement.style.backgroundColor = backgroundColor;
        }
        if (this.underline) targetElement.style.textDecoration = "underline";
    };
    TextRun.prototype.getJsonTypeName = function() {
        return "TextRun";
    };
    Object.defineProperty(TextRun.prototype, "isStandalone", {
        get: function() {
            return false;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TextRun.prototype, "isInline", {
        get: function() {
            return true;
        },
        enumerable: false,
        configurable: true
    });
    TextRun.italicProperty = new $eZfTX.BoolProperty($eZfTX.Versions.v1_2, "italic", false);
    TextRun.strikethroughProperty = new $eZfTX.BoolProperty($eZfTX.Versions.v1_2, "strikethrough", false);
    TextRun.highlightProperty = new $eZfTX.BoolProperty($eZfTX.Versions.v1_2, "highlight", false);
    TextRun.underlineProperty = new $eZfTX.BoolProperty($eZfTX.Versions.v1_3, "underline", false);
    $aa728000c38af56f$var$__decorate([
        (0, $eZfTX.property)(TextRun.italicProperty)
    ], TextRun.prototype, "italic", void 0);
    $aa728000c38af56f$var$__decorate([
        (0, $eZfTX.property)(TextRun.strikethroughProperty)
    ], TextRun.prototype, "strikethrough", void 0);
    $aa728000c38af56f$var$__decorate([
        (0, $eZfTX.property)(TextRun.highlightProperty)
    ], TextRun.prototype, "highlight", void 0);
    $aa728000c38af56f$var$__decorate([
        (0, $eZfTX.property)(TextRun.underlineProperty)
    ], TextRun.prototype, "underline", void 0);
    return TextRun;
}($aa728000c38af56f$var$BaseTextBlock);
module.exports.TextRun = $aa728000c38af56f$var$TextRun;
var $aa728000c38af56f$var$RichTextBlock = /** @class */ function(_super) {
    $aa728000c38af56f$var$__extends(RichTextBlock, _super);
    function RichTextBlock() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._inlines = [];
        return _this;
    }
    RichTextBlock.prototype.internalAddInline = function(inline, forceAdd) {
        if (forceAdd === void 0) forceAdd = false;
        if (!inline.isInline) throw new Error($c6BU9.Strings.errors.elementCannotBeUsedAsInline());
        var doAdd = inline.parent === undefined || forceAdd;
        if (!doAdd && inline.parent !== this) throw new Error($c6BU9.Strings.errors.inlineAlreadyParented());
        else {
            inline.setParent(this);
            this._inlines.push(inline);
        }
    };
    RichTextBlock.prototype.internalParse = function(source, context) {
        _super.prototype.internalParse.call(this, source, context);
        this._inlines = [];
        if (Array.isArray(source["inlines"])) for(var _i = 0, _a = source["inlines"]; _i < _a.length; _i++){
            var jsonInline = _a[_i];
            var inline = void 0;
            if (typeof jsonInline === "string") {
                var textRun = new $aa728000c38af56f$var$TextRun();
                textRun.text = jsonInline;
                inline = textRun;
            } else // No fallback for inlines in 1.2
            inline = context.parseElement(this, jsonInline, [], false);
            if (inline) this.internalAddInline(inline, true);
        }
    };
    RichTextBlock.prototype.internalToJSON = function(target, context) {
        _super.prototype.internalToJSON.call(this, target, context);
        if (this._inlines.length > 0) {
            var jsonInlines = [];
            for(var _i = 0, _a = this._inlines; _i < _a.length; _i++){
                var inline = _a[_i];
                jsonInlines.push(inline.toJSON(context));
            }
            context.serializeValue(target, "inlines", jsonInlines);
        }
    };
    RichTextBlock.prototype.internalRender = function() {
        if (this._inlines.length > 0) {
            var element = void 0;
            if (this.forElementId) {
                var labelElement = document.createElement("label");
                labelElement.htmlFor = this.forElementId;
                element = labelElement;
            } else element = document.createElement("div");
            element.className = this.hostConfig.makeCssClassName("ac-richTextBlock");
            switch(this.getEffectiveHorizontalAlignment()){
                case $kD48O.HorizontalAlignment.Center:
                    element.style.textAlign = "center";
                    break;
                case $kD48O.HorizontalAlignment.Right:
                    element.style.textAlign = "end";
                    break;
                default:
                    element.style.textAlign = "start";
                    break;
            }
            var renderedInlines = 0;
            for(var _i = 0, _a = this._inlines; _i < _a.length; _i++){
                var inline = _a[_i];
                var renderedInline = inline.render();
                if (renderedInline) {
                    element.appendChild(renderedInline);
                    renderedInlines++;
                }
            }
            if (renderedInlines > 0) return element;
        }
        return undefined;
    };
    RichTextBlock.prototype.asString = function() {
        var result = "";
        for(var _i = 0, _a = this._inlines; _i < _a.length; _i++){
            var inline = _a[_i];
            result += inline.asString();
        }
        return result;
    };
    RichTextBlock.prototype.getJsonTypeName = function() {
        return "RichTextBlock";
    };
    RichTextBlock.prototype.getInlineCount = function() {
        return this._inlines.length;
    };
    RichTextBlock.prototype.getInlineAt = function(index) {
        if (index >= 0 && index < this._inlines.length) return this._inlines[index];
        else throw new Error($c6BU9.Strings.errors.indexOutOfRange(index));
    };
    RichTextBlock.prototype.addInline = function(inline) {
        if (typeof inline === "string") this.internalAddInline(new $aa728000c38af56f$var$TextRun(inline));
        else this.internalAddInline(inline);
    };
    RichTextBlock.prototype.removeInline = function(inline) {
        var index = this._inlines.indexOf(inline);
        if (index >= 0) {
            this._inlines[index].setParent(undefined);
            this._inlines.splice(index, 1);
            return true;
        }
        return false;
    };
    return RichTextBlock;
}($aa728000c38af56f$var$CardElement);
module.exports.RichTextBlock = $aa728000c38af56f$var$RichTextBlock;
var $aa728000c38af56f$var$Fact = /** @class */ function(_super) {
    $aa728000c38af56f$var$__extends(Fact, _super);
    function Fact(name, value) {
        var _this = _super.call(this) || this;
        _this.name = name;
        _this.value = value;
        return _this;
    }
    //#endregion
    Fact.prototype.getSchemaKey = function() {
        return "Fact";
    };
    //#region Schema
    Fact.titleProperty = new $eZfTX.StringProperty($eZfTX.Versions.v1_0, "title");
    Fact.valueProperty = new $eZfTX.StringProperty($eZfTX.Versions.v1_0, "value");
    $aa728000c38af56f$var$__decorate([
        (0, $eZfTX.property)(Fact.titleProperty)
    ], Fact.prototype, "name", void 0);
    $aa728000c38af56f$var$__decorate([
        (0, $eZfTX.property)(Fact.valueProperty)
    ], Fact.prototype, "value", void 0);
    return Fact;
}($eZfTX.SerializableObject);
module.exports.Fact = $aa728000c38af56f$var$Fact;
var $aa728000c38af56f$var$FactSet = /** @class */ function(_super) {
    $aa728000c38af56f$var$__extends(FactSet, _super);
    function FactSet() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(FactSet.prototype, "useDefaultSizing", {
        //#endregion
        get: function() {
            return false;
        },
        enumerable: false,
        configurable: true
    });
    FactSet.prototype.internalRender = function() {
        var element = undefined;
        var hostConfig = this.hostConfig;
        if (this.facts.length > 0) {
            element = document.createElement("table");
            element.style.borderWidth = "0px";
            element.style.borderSpacing = "0px";
            element.style.borderStyle = "none";
            element.style.borderCollapse = "collapse";
            element.style.display = "block";
            element.style.overflow = "hidden";
            element.classList.add(hostConfig.makeCssClassName("ac-factset"));
            element.setAttribute("role", "presentation");
            for(var i = 0; i < this.facts.length; i++){
                var trElement = document.createElement("tr");
                if (i > 0) trElement.style.marginTop = hostConfig.factSet.spacing + "px";
                // Title column
                var tdElement = document.createElement("td");
                tdElement.style.padding = "0";
                tdElement.classList.add(hostConfig.makeCssClassName("ac-fact-title"));
                if (hostConfig.factSet.title.maxWidth) tdElement.style.maxWidth = hostConfig.factSet.title.maxWidth + "px";
                tdElement.style.verticalAlign = "top";
                var textBlock = new $aa728000c38af56f$var$TextBlock();
                textBlock.setParent(this);
                textBlock.text = !this.facts[i].name && this.isDesignMode() ? "Title" : this.facts[i].name;
                textBlock.size = hostConfig.factSet.title.size;
                textBlock.color = hostConfig.factSet.title.color;
                textBlock.isSubtle = hostConfig.factSet.title.isSubtle;
                textBlock.weight = hostConfig.factSet.title.weight;
                textBlock.wrap = hostConfig.factSet.title.wrap;
                textBlock.spacing = $kD48O.Spacing.None;
                $8QA0A.appendChild(tdElement, textBlock.render());
                $8QA0A.appendChild(trElement, tdElement);
                // Spacer column
                tdElement = document.createElement("td");
                tdElement.style.width = "10px";
                $8QA0A.appendChild(trElement, tdElement);
                // Value column
                tdElement = document.createElement("td");
                tdElement.style.padding = "0";
                tdElement.style.verticalAlign = "top";
                tdElement.classList.add(hostConfig.makeCssClassName("ac-fact-value"));
                textBlock = new $aa728000c38af56f$var$TextBlock();
                textBlock.setParent(this);
                textBlock.text = this.facts[i].value;
                textBlock.size = hostConfig.factSet.value.size;
                textBlock.color = hostConfig.factSet.value.color;
                textBlock.isSubtle = hostConfig.factSet.value.isSubtle;
                textBlock.weight = hostConfig.factSet.value.weight;
                textBlock.wrap = hostConfig.factSet.value.wrap;
                textBlock.spacing = $kD48O.Spacing.None;
                $8QA0A.appendChild(tdElement, textBlock.render());
                $8QA0A.appendChild(trElement, tdElement);
                $8QA0A.appendChild(element, trElement);
            }
        }
        return element;
    };
    FactSet.prototype.getJsonTypeName = function() {
        return "FactSet";
    };
    //#region Schema
    FactSet.factsProperty = new $eZfTX.SerializableObjectCollectionProperty($eZfTX.Versions.v1_0, "facts", $aa728000c38af56f$var$Fact);
    $aa728000c38af56f$var$__decorate([
        (0, $eZfTX.property)(FactSet.factsProperty)
    ], FactSet.prototype, "facts", void 0);
    return FactSet;
}($aa728000c38af56f$var$CardElement);
module.exports.FactSet = $aa728000c38af56f$var$FactSet;
var $aa728000c38af56f$var$ImageDimensionProperty = /** @class */ function(_super) {
    $aa728000c38af56f$var$__extends(ImageDimensionProperty, _super);
    function ImageDimensionProperty(targetVersion, name, internalName, fallbackProperty) {
        var _this = _super.call(this, targetVersion, name) || this;
        _this.targetVersion = targetVersion;
        _this.name = name;
        _this.internalName = internalName;
        _this.fallbackProperty = fallbackProperty;
        return _this;
    }
    ImageDimensionProperty.prototype.getInternalName = function() {
        return this.internalName;
    };
    ImageDimensionProperty.prototype.parse = function(sender, source, context) {
        var result = undefined;
        var sourceValue = source[this.name];
        if (sourceValue === undefined) return this.defaultValue;
        var isValid = false;
        if (typeof sourceValue === "string") {
            try {
                var size = $8Lw6d.SizeAndUnit.parse(sourceValue, true);
                if (size.unit === $kD48O.SizeUnit.Pixel) {
                    result = size.physicalSize;
                    isValid = true;
                }
            } catch (_a) {
            // Swallow the exception
            }
            // If the source value isn't valid per this property definition,
            // check its validity per the fallback property, if specified
            if (!isValid && this.fallbackProperty) isValid = this.fallbackProperty.isValidValue(sourceValue, context);
        }
        if (!isValid) context.logParseEvent(sender, $kD48O.ValidationEvent.InvalidPropertyValue, $c6BU9.Strings.errors.invalidPropertyValue(sourceValue, this.name));
        return result;
    };
    ImageDimensionProperty.prototype.toJSON = function(sender, target, value, context) {
        context.serializeValue(target, this.name, typeof value === "number" && !isNaN(value) ? value + "px" : undefined);
    };
    return ImageDimensionProperty;
}($eZfTX.PropertyDefinition);
var $aa728000c38af56f$var$Image = /** @class */ function(_super) {
    $aa728000c38af56f$var$__extends(Image, _super);
    function Image() {
        //#region Schema
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.size = $kD48O.Size.Auto;
        _this.style = $kD48O.ImageStyle.Default;
        return _this;
    }
    Image.prototype.populateSchema = function(schema) {
        _super.prototype.populateSchema.call(this, schema);
        schema.remove($aa728000c38af56f$var$CardElement.heightProperty);
    };
    //#endregion
    Image.prototype.applySize = function(element) {
        if (this.pixelWidth || this.pixelHeight) {
            if (this.pixelWidth) element.style.width = this.pixelWidth + "px";
            if (this.pixelHeight) element.style.height = this.pixelHeight + "px";
        } else if (this.maxHeight) {
            // If the image is constrained in height, we set its height property and
            // auto and stretch are ignored (default to medium). THis is necessary for
            // ImageSet which uses a maximum image height as opposed to the cards width
            // as a constraining dimension
            switch(this.size){
                case $kD48O.Size.Small:
                    element.style.height = this.hostConfig.imageSizes.small + "px";
                    break;
                case $kD48O.Size.Large:
                    element.style.height = this.hostConfig.imageSizes.large + "px";
                    break;
                default:
                    element.style.height = this.hostConfig.imageSizes.medium + "px";
                    break;
            }
            element.style.maxHeight = this.maxHeight + "px";
        } else {
            switch(this.size){
                case $kD48O.Size.Stretch:
                    element.style.width = "100%";
                    break;
                case $kD48O.Size.Auto:
                    element.style.maxWidth = "100%";
                    break;
                case $kD48O.Size.Small:
                    element.style.width = this.hostConfig.imageSizes.small + "px";
                    break;
                case $kD48O.Size.Large:
                    element.style.width = this.hostConfig.imageSizes.large + "px";
                    break;
                case $kD48O.Size.Medium:
                    element.style.width = this.hostConfig.imageSizes.medium + "px";
                    break;
            }
            element.style.maxHeight = "100%";
        }
    };
    Object.defineProperty(Image.prototype, "useDefaultSizing", {
        get: function() {
            return false;
        },
        enumerable: false,
        configurable: true
    });
    Image.prototype.internalRender = function() {
        var _this = this;
        var element = undefined;
        if (this.url) {
            element = document.createElement("div");
            element.style.display = "flex";
            element.style.alignItems = "flex-start";
            // Cache hostConfig to avoid walking the parent hierarchy multiple times
            var hostConfig = this.hostConfig;
            switch(this.getEffectiveHorizontalAlignment()){
                case $kD48O.HorizontalAlignment.Center:
                    element.style.justifyContent = "center";
                    break;
                case $kD48O.HorizontalAlignment.Right:
                    element.style.justifyContent = "flex-end";
                    break;
                default:
                    element.style.justifyContent = "flex-start";
                    break;
            }
            var imageElement = document.createElement("img");
            this.renderedImageElement = imageElement;
            imageElement.onload = function(_e) {
                $aa728000c38af56f$var$raiseImageLoadedEvent(_this);
            };
            imageElement.onerror = function(_e) {
                if (_this.renderedElement) {
                    var card = _this.getRootElement();
                    $aa728000c38af56f$var$clearElement(_this.renderedElement);
                    if (card && card.designMode) {
                        var errorElement = document.createElement("div");
                        errorElement.style.display = "flex";
                        errorElement.style.alignItems = "center";
                        errorElement.style.justifyContent = "center";
                        errorElement.style.backgroundColor = "#EEEEEE";
                        errorElement.style.color = "black";
                        errorElement.innerText = ":-(";
                        errorElement.style.padding = "10px";
                        _this.applySize(errorElement);
                        _this.renderedElement.appendChild(errorElement);
                    }
                }
                $aa728000c38af56f$var$raiseImageLoadedEvent(_this);
            };
            imageElement.style.minWidth = "0";
            imageElement.classList.add(hostConfig.makeCssClassName("ac-image"));
            if (this.selectAction && hostConfig.supportsInteractivity) {
                imageElement.onkeypress = function(e) {
                    if (_this.selectAction && _this.selectAction.isEffectivelyEnabled() && (e.code === "Enter" || e.code === "Space")) {
                        // enter or space pressed
                        e.preventDefault();
                        e.cancelBubble = true;
                        _this.selectAction.execute();
                    }
                };
                imageElement.onclick = function(e) {
                    if (_this.selectAction && _this.selectAction.isEffectivelyEnabled()) {
                        e.preventDefault();
                        e.cancelBubble = true;
                        _this.selectAction.execute();
                    }
                };
                this.selectAction.setupElementForAccessibility(imageElement);
                if (this.selectAction.isEffectivelyEnabled()) imageElement.classList.add(hostConfig.makeCssClassName("ac-selectable"));
            }
            this.applySize(imageElement);
            if (this.style === $kD48O.ImageStyle.Person) {
                imageElement.style.borderRadius = "50%";
                imageElement.style.backgroundPosition = "50% 50%";
                imageElement.style.backgroundRepeat = "no-repeat";
            }
            var backgroundColor = $8QA0A.stringToCssColor(this.backgroundColor);
            if (backgroundColor) imageElement.style.backgroundColor = backgroundColor;
            this.setImageSource(imageElement);
            var altTextProperty = this.preProcessPropertyValue(Image.altTextProperty);
            if (altTextProperty) imageElement.alt = altTextProperty;
            element.appendChild(imageElement);
        }
        return element;
    };
    Image.prototype.getJsonTypeName = function() {
        return "Image";
    };
    Image.prototype.getAllActions = function() {
        var result = _super.prototype.getAllActions.call(this);
        if (this.selectAction) result.push(this.selectAction);
        return result;
    };
    Image.prototype.getActionById = function(id) {
        var result = _super.prototype.getActionById.call(this, id);
        if (!result && this.selectAction) result = this.selectAction.getActionById(id);
        return result;
    };
    Image.prototype.getResourceInformation = function() {
        return this.url ? [
            {
                url: this.url,
                mimeType: "image"
            }
        ] : [];
    };
    Image.prototype.setImageSource = function(imageElement) {
        var imageForceLoader = new $aa728000c38af56f$var$ImageForceLoader(this.forceLoad, this.url);
        imageForceLoader.configureImage(this);
        imageElement.src = this.preProcessPropertyValue(Image.urlProperty);
        imageForceLoader.resetImage(this);
    };
    Image.urlProperty = new $eZfTX.StringProperty($eZfTX.Versions.v1_0, "url");
    Image.altTextProperty = new $eZfTX.StringProperty($eZfTX.Versions.v1_0, "altText");
    Image.backgroundColorProperty = new $eZfTX.StringProperty($eZfTX.Versions.v1_1, "backgroundColor");
    Image.styleProperty = new $eZfTX.EnumProperty($eZfTX.Versions.v1_0, "style", $kD48O.ImageStyle, $kD48O.ImageStyle.Default);
    Image.sizeProperty = new $eZfTX.EnumProperty($eZfTX.Versions.v1_0, "size", $kD48O.Size, $kD48O.Size.Auto);
    Image.pixelWidthProperty = new $aa728000c38af56f$var$ImageDimensionProperty($eZfTX.Versions.v1_1, "width", "pixelWidth");
    Image.pixelHeightProperty = new $aa728000c38af56f$var$ImageDimensionProperty($eZfTX.Versions.v1_1, "height", "pixelHeight", $aa728000c38af56f$var$CardElement.heightProperty);
    Image.selectActionProperty = new $aa728000c38af56f$var$ActionProperty($eZfTX.Versions.v1_1, "selectAction", [
        "Action.ShowCard"
    ]);
    Image.shouldForceLoadProperty = new $eZfTX.BoolProperty($eZfTX.Versions.v1_6, "forceLoad", false);
    $aa728000c38af56f$var$__decorate([
        (0, $eZfTX.property)(Image.urlProperty)
    ], Image.prototype, "url", void 0);
    $aa728000c38af56f$var$__decorate([
        (0, $eZfTX.property)(Image.altTextProperty)
    ], Image.prototype, "altText", void 0);
    $aa728000c38af56f$var$__decorate([
        (0, $eZfTX.property)(Image.backgroundColorProperty)
    ], Image.prototype, "backgroundColor", void 0);
    $aa728000c38af56f$var$__decorate([
        (0, $eZfTX.property)(Image.sizeProperty)
    ], Image.prototype, "size", void 0);
    $aa728000c38af56f$var$__decorate([
        (0, $eZfTX.property)(Image.styleProperty)
    ], Image.prototype, "style", void 0);
    $aa728000c38af56f$var$__decorate([
        (0, $eZfTX.property)(Image.pixelWidthProperty)
    ], Image.prototype, "pixelWidth", void 0);
    $aa728000c38af56f$var$__decorate([
        (0, $eZfTX.property)(Image.pixelHeightProperty)
    ], Image.prototype, "pixelHeight", void 0);
    $aa728000c38af56f$var$__decorate([
        (0, $eZfTX.property)(Image.selectActionProperty)
    ], Image.prototype, "selectAction", void 0);
    $aa728000c38af56f$var$__decorate([
        (0, $eZfTX.property)(Image.shouldForceLoadProperty)
    ], Image.prototype, "forceLoad", void 0);
    return Image;
}($aa728000c38af56f$var$CardElement);
module.exports.Image = $aa728000c38af56f$var$Image;
// configures Image element to fetch a new image data from url source instead of relying on cache
// currently rudimentary refreshing scheme is used
// by attaching unique query string to url, we bypass the cache usage
var $aa728000c38af56f$var$ImageForceLoader = /** @class */ function() {
    function ImageForceLoader(doForceLoad, url) {
        this.doForceLoad = doForceLoad;
        this.url = url;
        if (url && url.length && doForceLoad) {
            // we can do better by appending unique key such as uuid instead of epoch
            // however the current usage is for front-end ui and networking,  
            // since ui is running in single main thread, this is sufficient mechanism
            // without needing to depend on external library for our small use cases.
            this.uniqueHash = "?" + Date.now();
            this.urlWithForceLoadOption = url + this.uniqueHash;
        }
    }
    ImageForceLoader.prototype.configureImage = function(image) {
        if (this.urlWithForceLoadOption && this.urlWithForceLoadOption.length) image.url = this.urlWithForceLoadOption;
    };
    ImageForceLoader.prototype.resetImage = function(image) {
        image.url = this.url;
    };
    return ImageForceLoader;
}();
var $aa728000c38af56f$var$CardElementContainer = /** @class */ function(_super) {
    $aa728000c38af56f$var$__extends(CardElementContainer, _super);
    function CardElementContainer() {
        //#region Schema
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.allowVerticalOverflow = false;
        return _this;
    }
    CardElementContainer.prototype.populateSchema = function(schema) {
        _super.prototype.populateSchema.call(this, schema);
        if (!this.isSelectable) schema.remove(CardElementContainer.selectActionProperty);
    };
    //#endregion
    CardElementContainer.prototype.isElementAllowed = function(element) {
        return this.hostConfig.supportsInteractivity || !element.isInteractive;
    };
    CardElementContainer.prototype.applyPadding = function() {
        _super.prototype.applyPadding.call(this);
        if (!this.renderedElement) return;
        var physicalPadding = new $8Lw6d.SpacingDefinition();
        if (this.getEffectivePadding()) physicalPadding = this.hostConfig.paddingDefinitionToSpacingDefinition(this.getEffectivePadding());
        this.renderedElement.style.paddingTop = physicalPadding.top + "px";
        this.renderedElement.style.paddingRight = physicalPadding.right + "px";
        this.renderedElement.style.paddingBottom = physicalPadding.bottom + "px";
        this.renderedElement.style.paddingLeft = physicalPadding.left + "px";
        this.renderedElement.style.marginRight = "0";
        this.renderedElement.style.marginLeft = "0";
    };
    Object.defineProperty(CardElementContainer.prototype, "isSelectable", {
        get: function() {
            return false;
        },
        enumerable: false,
        configurable: true
    });
    CardElementContainer.prototype.forbiddenChildElements = function() {
        return [];
    };
    CardElementContainer.prototype.releaseDOMResources = function() {
        _super.prototype.releaseDOMResources.call(this);
        for(var i = 0; i < this.getItemCount(); i++)this.getItemAt(i).releaseDOMResources();
    };
    CardElementContainer.prototype.internalValidateProperties = function(context) {
        _super.prototype.internalValidateProperties.call(this, context);
        for(var i = 0; i < this.getItemCount(); i++){
            var item = this.getItemAt(i);
            if (!this.hostConfig.supportsInteractivity && item.isInteractive) context.addFailure(this, $kD48O.ValidationEvent.InteractivityNotAllowed, $c6BU9.Strings.errors.interactivityNotAllowed());
            if (!this.isElementAllowed(item)) context.addFailure(this, $kD48O.ValidationEvent.InteractivityNotAllowed, $c6BU9.Strings.errors.elementTypeNotAllowed(item.getJsonTypeName()));
            item.internalValidateProperties(context);
        }
        if (this._selectAction) this._selectAction.internalValidateProperties(context);
    };
    CardElementContainer.prototype.render = function() {
        var _this = this;
        var element = _super.prototype.render.call(this);
        if (element) {
            var hostConfig = this.hostConfig;
            if (this.allowVerticalOverflow) {
                element.style.overflowX = "hidden";
                element.style.overflowY = "auto";
            }
            if (element && this.isSelectable && this._selectAction && hostConfig.supportsInteractivity) {
                element.onclick = function(e) {
                    if (_this._selectAction && _this._selectAction.isEffectivelyEnabled()) {
                        e.preventDefault();
                        e.cancelBubble = true;
                        _this._selectAction.execute();
                    }
                };
                element.onkeypress = function(e) {
                    if (_this._selectAction && _this._selectAction.isEffectivelyEnabled() && (e.code === "Enter" || e.code === "Space")) {
                        // Enter or space pressed
                        e.preventDefault();
                        e.cancelBubble = true;
                        _this._selectAction.execute();
                    }
                };
                this._selectAction.setupElementForAccessibility(element);
                if (this._selectAction.isEffectivelyEnabled()) element.classList.add(hostConfig.makeCssClassName("ac-selectable"));
            }
        }
        return element;
    };
    CardElementContainer.prototype.updateLayout = function(processChildren) {
        if (processChildren === void 0) processChildren = true;
        _super.prototype.updateLayout.call(this, processChildren);
        if (processChildren) for(var i = 0; i < this.getItemCount(); i++)this.getItemAt(i).updateLayout();
    };
    CardElementContainer.prototype.getAllInputs = function(processActions) {
        if (processActions === void 0) processActions = true;
        var result = [];
        for(var i = 0; i < this.getItemCount(); i++)result.push.apply(result, this.getItemAt(i).getAllInputs(processActions));
        return result;
    };
    CardElementContainer.prototype.getAllActions = function() {
        var result = _super.prototype.getAllActions.call(this);
        for(var i = 0; i < this.getItemCount(); i++)result.push.apply(result, this.getItemAt(i).getAllActions());
        if (this._selectAction) result.push(this._selectAction);
        return result;
    };
    CardElementContainer.prototype.getResourceInformation = function() {
        var result = [];
        for(var i = 0; i < this.getItemCount(); i++)result.push.apply(result, this.getItemAt(i).getResourceInformation());
        return result;
    };
    CardElementContainer.prototype.getElementById = function(id) {
        var result = _super.prototype.getElementById.call(this, id);
        if (!result) for(var i = 0; i < this.getItemCount(); i++){
            result = this.getItemAt(i).getElementById(id);
            if (result) break;
        }
        return result;
    };
    /**
     * @inheritdoc
     */ CardElementContainer.prototype.findDOMNodeOwner = function(node) {
        var _a;
        var target = undefined;
        for(var i = 0; i < this.getItemCount(); i++){
            // recur through child elements
            target = this.getItemAt(i).findDOMNodeOwner(node);
            if (target) return target;
        }
        // If not found in children, check the actions
        for(var i = 0; i < this.getActionCount(); i++){
            target = (_a = this.getActionAt(i)) === null || _a === void 0 ? void 0 : _a.findDOMNodeOwner(node);
            if (target) return target;
        }
        // if not found in children or actions, defer to parent implementation
        return _super.prototype.findDOMNodeOwner.call(this, node);
    };
    CardElementContainer.selectActionProperty = new $aa728000c38af56f$var$ActionProperty($eZfTX.Versions.v1_1, "selectAction", [
        "Action.ShowCard"
    ]);
    $aa728000c38af56f$var$__decorate([
        (0, $eZfTX.property)(CardElementContainer.selectActionProperty)
    ], CardElementContainer.prototype, "_selectAction", void 0);
    return CardElementContainer;
}($aa728000c38af56f$var$CardElement);
module.exports.CardElementContainer = $aa728000c38af56f$var$CardElementContainer;
var $aa728000c38af56f$var$ImageSet = /** @class */ function(_super) {
    $aa728000c38af56f$var$__extends(ImageSet, _super);
    function ImageSet() {
        //#region Schema
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._images = [];
        _this.imageSize = $kD48O.ImageSize.Medium;
        _this.presentationStyle = $kD48O.ImageSetPresentationStyle.Default;
        _this.pixelOffset = 0;
        return _this;
    }
    //#endregion
    ImageSet.prototype.internalRender = function() {
        var element = undefined;
        if (this._images.length > 0) {
            element = document.createElement("div");
            element.style.display = "flex";
            element.style.flexWrap = "wrap";
            for(var _i = 0, _a = this._images; _i < _a.length; _i++){
                var image = _a[_i];
                switch(this.imageSize){
                    case $kD48O.ImageSize.Small:
                        image.size = $kD48O.Size.Small;
                        break;
                    case $kD48O.ImageSize.Large:
                        image.size = $kD48O.Size.Large;
                        break;
                    default:
                        image.size = $kD48O.Size.Medium;
                        break;
                }
                image.maxHeight = this.hostConfig.imageSet.maxImageHeight;
                var renderedImage = image.render();
                if (renderedImage) {
                    renderedImage.style.display = "inline-flex";
                    renderedImage.style.margin = "0px";
                    if (this.presentationStyle == $kD48O.ImageSetPresentationStyle.Default) renderedImage.style.marginRight = "10px";
                    $8QA0A.appendChild(element, renderedImage);
                }
            }
            if (this.presentationStyle == $kD48O.ImageSetPresentationStyle.Stacked) this.applyStackedPresentationStyle();
        }
        return element;
    };
    ImageSet.prototype.applyStackedPresentationStyle = function() {
        if (this._images[0].renderedImageElement) {
            var dimension = $aa728000c38af56f$var$StackedImageConfigurator.parseNumericPixelDimension(this._images[0].renderedImageElement.style.height);
            var bgColor = this.getEffectiveBackgroundColor();
            if (dimension) {
                var stackedImageConfigurator = new $aa728000c38af56f$var$StackedImageConfigurator(this.pixelOffset, dimension, bgColor);
                stackedImageConfigurator.configureImagesArrayAsStackedLayout(this._images);
            }
        }
    };
    ImageSet.prototype.getEffectiveBackgroundColor = function() {
        var parentContainer = this.getParentContainer();
        var style = parentContainer === null || parentContainer === void 0 ? void 0 : parentContainer.getEffectiveStyle();
        var styleDefinition = this.hostConfig.containerStyles.getStyleByName(style, this.hostConfig.containerStyles.getStyleByName(this.defaultStyle));
        return $8QA0A.stringToCssColor(styleDefinition.backgroundColor);
    };
    ImageSet.prototype.getItemCount = function() {
        return this._images.length;
    };
    ImageSet.prototype.getItemAt = function(index) {
        return this._images[index];
    };
    ImageSet.prototype.getFirstVisibleRenderedItem = function() {
        return this._images && this._images.length > 0 ? this._images[0] : undefined;
    };
    ImageSet.prototype.getLastVisibleRenderedItem = function() {
        return this._images && this._images.length > 0 ? this._images[this._images.length - 1] : undefined;
    };
    ImageSet.prototype.removeItem = function(item) {
        if (item instanceof $aa728000c38af56f$var$Image) {
            var itemIndex = this._images.indexOf(item);
            if (itemIndex >= 0) {
                this._images.splice(itemIndex, 1);
                item.setParent(undefined);
                this.updateLayout();
                return true;
            }
        }
        return false;
    };
    ImageSet.prototype.getJsonTypeName = function() {
        return "ImageSet";
    };
    ImageSet.prototype.addImage = function(image) {
        if (!image.parent) {
            this._images.push(image);
            image.setParent(this);
        } else throw new Error("This image already belongs to another ImageSet");
    };
    ImageSet.prototype.indexOf = function(cardElement) {
        return cardElement instanceof $aa728000c38af56f$var$Image ? this._images.indexOf(cardElement) : -1;
    };
    ImageSet.imagesProperty = new $eZfTX.SerializableObjectCollectionProperty($eZfTX.Versions.v1_0, "images", $aa728000c38af56f$var$Image, function(sender, item) {
        item.setParent(sender);
    });
    ImageSet.imageSizeProperty = new $eZfTX.EnumProperty($eZfTX.Versions.v1_0, "imageSize", $kD48O.ImageSize, $kD48O.ImageSize.Medium);
    ImageSet.imagePresentationStyle = new $eZfTX.EnumProperty($eZfTX.Versions.v1_6, "style", $kD48O.ImageSetPresentationStyle, $kD48O.ImageSetPresentationStyle.Default);
    ImageSet.pixelOffset = new $eZfTX.NumProperty($eZfTX.Versions.v1_6, "offset", 0, undefined);
    $aa728000c38af56f$var$__decorate([
        (0, $eZfTX.property)(ImageSet.imagesProperty)
    ], ImageSet.prototype, "_images", void 0);
    $aa728000c38af56f$var$__decorate([
        (0, $eZfTX.property)(ImageSet.imageSizeProperty)
    ], ImageSet.prototype, "imageSize", void 0);
    $aa728000c38af56f$var$__decorate([
        (0, $eZfTX.property)(ImageSet.imagePresentationStyle)
    ], ImageSet.prototype, "presentationStyle", void 0);
    $aa728000c38af56f$var$__decorate([
        (0, $eZfTX.property)(ImageSet.pixelOffset)
    ], ImageSet.prototype, "pixelOffset", void 0);
    return ImageSet;
}($aa728000c38af56f$var$CardElementContainer);
module.exports.ImageSet = $aa728000c38af56f$var$ImageSet;
var $aa728000c38af56f$var$StackedImageConfigurator = /** @class */ function() {
    function StackedImageConfigurator(offset, dimension, style) {
        this.sign45 = 0.7071;
        this.maxImageCounts = 2;
        this.offset = 0;
        this.normalizationConstant = 0;
        this.border = 5;
        this.dimension = 0;
        this.dimension = dimension;
        this.normalizationConstant = (dimension * this.sign45 - 0.5 * dimension) * 2;
        // offset determines how far images are placed from each other
        // at zero, images are separated only by the border
        // there is no restriction on how far they are apart in positive values, their actual
        // positioning is limited by maximum size imposed by Image renderer
        // a negative value can decrease upto the diameter of the image since a value less than the diameter
        // put the images past each other, and the use of such value is not reasonable request
        // users should change image positions in such case.
        this.offset = this.sign45 * (Math.max(offset, -dimension) - this.normalizationConstant);
        this.style = style ? style : "";
    }
    StackedImageConfigurator.prototype.moveImageRight = function(element) {
        element.style.marginLeft = this.offset + "px";
    };
    StackedImageConfigurator.prototype.moveImageUp = function(element) {
        element.style.marginBottom = this.offset + this.dimension + "px";
    };
    StackedImageConfigurator.prototype.moveImageDown = function(element) {
        element.style.marginTop = this.offset + this.dimension + "px";
    };
    StackedImageConfigurator.prototype.makeImageRound = function(element) {
        element.style.borderRadius = "50%";
        element.style.backgroundPosition = "50% 50%";
        element.style.backgroundRepeat = "no-repeat";
    };
    StackedImageConfigurator.prototype.applyBorder = function(element) {
        element.style.height = this.dimension + this.border * 2 + "px";
        element.style.border = this.border + "px" + " solid " + this.style;
    };
    StackedImageConfigurator.prototype.configureImageForBottomLeft = function(element) {
        this.moveImageDown(element);
        this.makeImageRound(element);
        this.applyBorder(element);
        element.style.zIndex = "2";
    };
    StackedImageConfigurator.prototype.configureImageForTopRight = function(element) {
        this.moveImageUp(element);
        this.moveImageRight(element);
        this.makeImageRound(element);
        element.style.zIndex = "1";
    };
    // stacked layout is applied when there are two images in ImageSet,
    // first image in the ImageSet is put bottom left of ImageSet,
    // second image is placed top right diagonally to the first image at 45 angle
    // first image is placed over the second image should the overlap to occur.
    StackedImageConfigurator.prototype.configureImagesArrayAsStackedLayout = function(elements) {
        if (elements.length == 1) {
            if (elements[0].renderedImageElement) this.makeImageRound(elements[0].renderedImageElement);
        } else if (elements.length <= this.maxImageCounts) {
            if (elements[0].renderedImageElement && elements[1].renderedImageElement) {
                this.configureImageForBottomLeft(elements[0].renderedImageElement);
                this.configureImageForTopRight(elements[1].renderedImageElement);
            }
        }
    };
    StackedImageConfigurator.parseNumericPixelDimension = function(dimension) {
        if ((dimension === null || dimension === void 0 ? void 0 : dimension.substring(dimension.length - 2)) == "px") return parseInt(dimension.substring(0, dimension.length - 2));
        return undefined;
    };
    return StackedImageConfigurator;
}();
var $aa728000c38af56f$var$ContentSource = /** @class */ function(_super) {
    $aa728000c38af56f$var$__extends(ContentSource, _super);
    //#endregion
    function ContentSource(url, mimeType) {
        var _this = _super.call(this) || this;
        _this.url = url;
        _this.mimeType = mimeType;
        return _this;
    }
    ContentSource.prototype.isValid = function() {
        return this.mimeType && this.url ? true : false;
    };
    //#region Schema
    ContentSource.mimeTypeProperty = new $eZfTX.StringProperty($eZfTX.Versions.v1_1, "mimeType");
    ContentSource.urlProperty = new $eZfTX.StringProperty($eZfTX.Versions.v1_1, "url");
    $aa728000c38af56f$var$__decorate([
        (0, $eZfTX.property)(ContentSource.mimeTypeProperty)
    ], ContentSource.prototype, "mimeType", void 0);
    $aa728000c38af56f$var$__decorate([
        (0, $eZfTX.property)(ContentSource.urlProperty)
    ], ContentSource.prototype, "url", void 0);
    return ContentSource;
}($eZfTX.SerializableObject);
module.exports.ContentSource = $aa728000c38af56f$var$ContentSource;
var $aa728000c38af56f$var$CaptionSource = /** @class */ function(_super) {
    $aa728000c38af56f$var$__extends(CaptionSource, _super);
    //#endregion
    function CaptionSource(url, mimeType, label) {
        var _this = _super.call(this, url, mimeType) || this;
        _this.label = label;
        return _this;
    }
    CaptionSource.prototype.getSchemaKey = function() {
        return "CaptionSource";
    };
    CaptionSource.prototype.render = function() {
        var result = undefined;
        if (this.isValid()) {
            result = document.createElement("track");
            result.src = this.url;
            result.kind = "captions";
            result.label = this.label;
        }
        return result;
    };
    //#region Schema
    CaptionSource.labelProperty = new $eZfTX.StringProperty($eZfTX.Versions.v1_6, "label");
    $aa728000c38af56f$var$__decorate([
        (0, $eZfTX.property)(CaptionSource.labelProperty)
    ], CaptionSource.prototype, "label", void 0);
    return CaptionSource;
}($aa728000c38af56f$var$ContentSource);
module.exports.CaptionSource = $aa728000c38af56f$var$CaptionSource;
var $aa728000c38af56f$var$MediaSource = /** @class */ function(_super) {
    $aa728000c38af56f$var$__extends(MediaSource, _super);
    function MediaSource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MediaSource.prototype.getSchemaKey = function() {
        return "MediaSource";
    };
    MediaSource.prototype.render = function() {
        var result = undefined;
        if (this.isValid()) {
            result = document.createElement("source");
            result.src = this.url;
            result.type = this.mimeType;
        }
        return result;
    };
    return MediaSource;
}($aa728000c38af56f$var$ContentSource);
module.exports.MediaSource = $aa728000c38af56f$var$MediaSource;
var $aa728000c38af56f$var$MediaPlayer = /** @class */ function() {
    function MediaPlayer() {}
    MediaPlayer.prototype.play = function() {
    // Do nothing in base implementation
    };
    Object.defineProperty(MediaPlayer.prototype, "posterUrl", {
        get: function() {
            return this._posterUrl;
        },
        set: function(value) {
            this._posterUrl = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MediaPlayer.prototype, "selectedMediaType", {
        get: function() {
            return undefined;
        },
        enumerable: false,
        configurable: true
    });
    return MediaPlayer;
}();
module.exports.MediaPlayer = $aa728000c38af56f$var$MediaPlayer;
var $aa728000c38af56f$var$HTML5MediaPlayer = /** @class */ function(_super) {
    $aa728000c38af56f$var$__extends(HTML5MediaPlayer, _super);
    function HTML5MediaPlayer(owner) {
        var _this = _super.call(this) || this;
        _this.owner = owner;
        _this._selectedSources = [];
        _this._captionSources = [];
        _this.processSources();
        return _this;
    }
    HTML5MediaPlayer.prototype.processSources = function() {
        var _a;
        this._selectedSources = [];
        this._captionSources = [];
        this._selectedMediaType = undefined;
        for(var _i = 0, _b = this.owner.sources; _i < _b.length; _i++){
            var source = _b[_i];
            var mimeComponents = source.mimeType ? source.mimeType.split("/") : [];
            if (mimeComponents.length === 2) {
                if (!this._selectedMediaType) {
                    var index = HTML5MediaPlayer.supportedMediaTypes.indexOf(mimeComponents[0]);
                    if (index >= 0) this._selectedMediaType = HTML5MediaPlayer.supportedMediaTypes[index];
                }
                if (mimeComponents[0] === this._selectedMediaType) this._selectedSources.push(source);
            }
        }
        (_a = this._captionSources).push.apply(_a, this.owner.captionSources);
    };
    HTML5MediaPlayer.prototype.canPlay = function() {
        return this._selectedSources.length > 0;
    };
    HTML5MediaPlayer.prototype.fetchVideoDetails = function() {
        return $aa728000c38af56f$var$__awaiter(this, void 0, void 0, function() {
            return $aa728000c38af56f$var$__generator(this, function(_a) {
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    HTML5MediaPlayer.prototype.render = function() {
        if (this._selectedMediaType === "video") this._mediaElement = document.createElement("video");
        else this._mediaElement = document.createElement("audio");
        this._mediaElement.setAttribute("aria-label", this.owner.altText ? this.owner.altText : $c6BU9.Strings.defaults.mediaPlayerAriaLabel());
        this._mediaElement.setAttribute("webkit-playsinline", "");
        this._mediaElement.setAttribute("playsinline", "");
        // We enable crossorigin for cases where the caption file has a different domain than
        // the video file. If the caption file lives in a different domain than the video file
        // and crossorigin is not set, then the caption file will fail to load.
        this._mediaElement.setAttribute("crossorigin", "");
        this._mediaElement.autoplay = true;
        this._mediaElement.controls = true;
        if ($8QA0A.isMobileOS()) this._mediaElement.muted = true;
        this._mediaElement.preload = "none";
        this._mediaElement.style.width = "100%";
        for(var _i = 0, _a = this.owner.sources; _i < _a.length; _i++){
            var source = _a[_i];
            var renderedSource = source.render();
            $8QA0A.appendChild(this._mediaElement, renderedSource);
        }
        for(var _b = 0, _c = this.owner.captionSources; _b < _c.length; _b++){
            var captionSource = _c[_b];
            if (captionSource.mimeType == "vtt") {
                var renderedCaptionSource = captionSource.render();
                $8QA0A.appendChild(this._mediaElement, renderedCaptionSource);
            }
        }
        return this._mediaElement;
    };
    HTML5MediaPlayer.prototype.play = function() {
        if (this._mediaElement) this._mediaElement.play();
    };
    Object.defineProperty(HTML5MediaPlayer.prototype, "selectedMediaType", {
        get: function() {
            return this._selectedMediaType;
        },
        enumerable: false,
        configurable: true
    });
    HTML5MediaPlayer.supportedMediaTypes = [
        "audio",
        "video"
    ];
    return HTML5MediaPlayer;
}($aa728000c38af56f$var$MediaPlayer);
module.exports.HTML5MediaPlayer = $aa728000c38af56f$var$HTML5MediaPlayer;
var $aa728000c38af56f$var$CustomMediaPlayer = /** @class */ function(_super) {
    $aa728000c38af56f$var$__extends(CustomMediaPlayer, _super);
    function CustomMediaPlayer(matches) {
        return _super.call(this) || this;
    }
    return CustomMediaPlayer;
}($aa728000c38af56f$var$MediaPlayer);
module.exports.CustomMediaPlayer = $aa728000c38af56f$var$CustomMediaPlayer;
var $aa728000c38af56f$var$IFrameMediaMediaPlayer = /** @class */ function(_super) {
    $aa728000c38af56f$var$__extends(IFrameMediaMediaPlayer, _super);
    function IFrameMediaMediaPlayer(matches, iFrameTitle) {
        var _this = _super.call(this, matches) || this;
        _this.iFrameTitle = iFrameTitle;
        if (matches.length >= 2) _this._videoId = matches[1];
        return _this;
    }
    IFrameMediaMediaPlayer.prototype.canPlay = function() {
        return this._videoId !== undefined;
    };
    IFrameMediaMediaPlayer.prototype.render = function() {
        var container = document.createElement("div");
        container.style.position = "relative";
        container.style.width = "100%";
        container.style.height = "0";
        container.style.paddingBottom = "56.25%";
        var iFrame = document.createElement("iframe");
        iFrame.style.position = "absolute";
        iFrame.style.top = "0";
        iFrame.style.left = "0";
        iFrame.style.width = "100%";
        iFrame.style.height = "100%";
        iFrame.src = this.getEmbedVideoUrl();
        iFrame.frameBorder = "0";
        if (this.iFrameTitle) iFrame.title = this.iFrameTitle;
        iFrame.allow = "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture";
        iFrame.allowFullscreen = true;
        container.appendChild(iFrame);
        return container;
    };
    Object.defineProperty(IFrameMediaMediaPlayer.prototype, "videoId", {
        get: function() {
            return this._videoId;
        },
        enumerable: false,
        configurable: true
    });
    return IFrameMediaMediaPlayer;
}($aa728000c38af56f$var$CustomMediaPlayer);
module.exports.IFrameMediaMediaPlayer = $aa728000c38af56f$var$IFrameMediaMediaPlayer;
var $aa728000c38af56f$var$VimeoPlayer = /** @class */ function(_super) {
    $aa728000c38af56f$var$__extends(VimeoPlayer, _super);
    function VimeoPlayer() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    VimeoPlayer.prototype.fetchVideoDetails = function() {
        return $aa728000c38af56f$var$__awaiter(this, void 0, void 0, function() {
            var oEmbedUrl, response, json;
            return $aa728000c38af56f$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        oEmbedUrl = "https://vimeo.com/api/oembed.json?url=".concat(this.getEmbedVideoUrl());
                        return [
                            4 /*yield*/ ,
                            fetch(oEmbedUrl)
                        ];
                    case 1:
                        response = _a.sent();
                        if (!response.ok) return [
                            3 /*break*/ ,
                            3
                        ];
                        return [
                            4 /*yield*/ ,
                            response.json()
                        ];
                    case 2:
                        json = _a.sent();
                        this.posterUrl = json["thumbnail_url"];
                        _a.label = 3;
                    case 3:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    VimeoPlayer.prototype.getEmbedVideoUrl = function() {
        return "https://player.vimeo.com/video/".concat(this.videoId, "?autoplay=1");
    };
    return VimeoPlayer;
}($aa728000c38af56f$var$IFrameMediaMediaPlayer);
module.exports.VimeoPlayer = $aa728000c38af56f$var$VimeoPlayer;
var $aa728000c38af56f$var$DailymotionPlayer = /** @class */ function(_super) {
    $aa728000c38af56f$var$__extends(DailymotionPlayer, _super);
    function DailymotionPlayer() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DailymotionPlayer.prototype.fetchVideoDetails = function() {
        return $aa728000c38af56f$var$__awaiter(this, void 0, void 0, function() {
            var apiUrl, response, json;
            return $aa728000c38af56f$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        apiUrl = "https://api.dailymotion.com/video/".concat(this.videoId, "?fields=thumbnail_720_url");
                        return [
                            4 /*yield*/ ,
                            fetch(apiUrl)
                        ];
                    case 1:
                        response = _a.sent();
                        if (!response.ok) return [
                            3 /*break*/ ,
                            3
                        ];
                        return [
                            4 /*yield*/ ,
                            response.json()
                        ];
                    case 2:
                        json = _a.sent();
                        this.posterUrl = json["thumbnail_720_url"];
                        _a.label = 3;
                    case 3:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    DailymotionPlayer.prototype.getEmbedVideoUrl = function() {
        return "https://www.dailymotion.com/embed/video/".concat(this.videoId, "?autoplay=1");
    };
    return DailymotionPlayer;
}($aa728000c38af56f$var$IFrameMediaMediaPlayer);
module.exports.DailymotionPlayer = $aa728000c38af56f$var$DailymotionPlayer;
var $aa728000c38af56f$var$YouTubePlayer = /** @class */ function(_super) {
    $aa728000c38af56f$var$__extends(YouTubePlayer, _super);
    function YouTubePlayer(matches, iFrameTitle) {
        var _this = _super.call(this, matches, iFrameTitle) || this;
        _this.iFrameTitle = iFrameTitle;
        if (matches.length >= 3 && matches[2] !== undefined) _this._startTimeIndex = parseInt(matches[2]);
        return _this;
    }
    YouTubePlayer.prototype.fetchVideoDetails = function() {
        return $aa728000c38af56f$var$__awaiter(this, void 0, void 0, function() {
            return $aa728000c38af56f$var$__generator(this, function(_a) {
                this.posterUrl = this.videoId ? "https://img.youtube.com/vi/".concat(this.videoId, "/maxresdefault.jpg") : undefined;
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    YouTubePlayer.prototype.getEmbedVideoUrl = function() {
        var url = "https://www.youtube.com/embed/".concat(this.videoId, "?autoplay=1");
        if (this._startTimeIndex !== undefined) url += "&start=".concat(this._startTimeIndex);
        return url;
    };
    return YouTubePlayer;
}($aa728000c38af56f$var$IFrameMediaMediaPlayer);
module.exports.YouTubePlayer = $aa728000c38af56f$var$YouTubePlayer;
var $aa728000c38af56f$var$Media = /** @class */ function(_super) {
    $aa728000c38af56f$var$__extends(Media, _super);
    function Media() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.sources = [];
        _this.captionSources = [];
        return _this;
    }
    Media.prototype.createMediaPlayer = function() {
        for(var _i = 0, _a = Media.customMediaPlayers; _i < _a.length; _i++){
            var provider = _a[_i];
            for(var _b = 0, _c = this.sources; _b < _c.length; _b++){
                var source = _c[_b];
                if (source.url) for(var _d = 0, _f = provider.urlPatterns; _d < _f.length; _d++){
                    var pattern = _f[_d];
                    var matches = pattern.exec(source.url);
                    if (matches !== null) return provider.createMediaPlayer(matches);
                }
            }
        }
        return new $aa728000c38af56f$var$HTML5MediaPlayer(this);
    };
    Media.prototype.handlePlayButtonInvoke = function(event) {
        if (this.hostConfig.media.allowInlinePlayback) {
            event.preventDefault();
            event.cancelBubble = true;
            if (this.renderedElement) {
                var mediaPlayerElement = this._mediaPlayer.render();
                $aa728000c38af56f$var$clearElement(this.renderedElement);
                this.renderedElement.appendChild(mediaPlayerElement);
                this._mediaPlayer.play();
                mediaPlayerElement.focus();
            }
        } else if (Media.onPlay) {
            event.preventDefault();
            event.cancelBubble = true;
            Media.onPlay(this);
        }
    };
    Media.prototype.displayPoster = function() {
        return $aa728000c38af56f$var$__awaiter(this, void 0, void 0, function() {
            var playButtonArrowWidth, playButtonArrowHeight, posterRootElement_1, posterUrl, posterImageElement_1, playButtonOuterElement, playButtonInnerElement, playButtonContainer;
            var _this = this;
            return $aa728000c38af56f$var$__generator(this, function(_a) {
                if (this.renderedElement) {
                    playButtonArrowWidth = 12;
                    playButtonArrowHeight = 15;
                    posterRootElement_1 = document.createElement("div");
                    posterRootElement_1.className = this.hostConfig.makeCssClassName("ac-media-poster");
                    posterRootElement_1.setAttribute("role", "contentinfo");
                    posterRootElement_1.setAttribute("aria-label", this.altText ? this.altText : $c6BU9.Strings.defaults.mediaPlayerAriaLabel());
                    posterRootElement_1.style.position = "relative";
                    posterRootElement_1.style.display = "flex";
                    posterUrl = this.poster ? this.poster : this._mediaPlayer.posterUrl;
                    if (!posterUrl) posterUrl = this.hostConfig.media.defaultPoster;
                    if (posterUrl) {
                        posterImageElement_1 = document.createElement("img");
                        posterImageElement_1.style.width = "100%";
                        posterImageElement_1.style.height = "100%";
                        posterImageElement_1.setAttribute("role", "presentation");
                        posterImageElement_1.onerror = function(_e) {
                            if (posterImageElement_1.parentNode) posterImageElement_1.parentNode.removeChild(posterImageElement_1);
                            posterRootElement_1.classList.add("empty");
                            posterRootElement_1.style.minHeight = "150px";
                        };
                        posterImageElement_1.src = posterUrl;
                        posterRootElement_1.appendChild(posterImageElement_1);
                    } else {
                        posterRootElement_1.classList.add("empty");
                        posterRootElement_1.style.minHeight = "150px";
                    }
                    if (this.hostConfig.supportsInteractivity && this._mediaPlayer.canPlay()) {
                        playButtonOuterElement = document.createElement("div");
                        playButtonOuterElement.tabIndex = 0;
                        playButtonOuterElement.setAttribute("role", "button");
                        playButtonOuterElement.setAttribute("aria-label", $c6BU9.Strings.defaults.mediaPlayerPlayMedia());
                        playButtonOuterElement.className = this.hostConfig.makeCssClassName("ac-media-playButton");
                        playButtonOuterElement.style.display = "flex";
                        playButtonOuterElement.style.alignItems = "center";
                        playButtonOuterElement.style.justifyContent = "center";
                        playButtonOuterElement.onclick = function(e) {
                            _this.handlePlayButtonInvoke(e);
                        };
                        playButtonOuterElement.onkeypress = function(e) {
                            if (e.code === "Enter" || e.code === "Space") // space or enter
                            _this.handlePlayButtonInvoke(e);
                        };
                        playButtonInnerElement = document.createElement("div");
                        playButtonInnerElement.className = this.hostConfig.makeCssClassName("ac-media-playButton-arrow");
                        playButtonInnerElement.style.width = playButtonArrowWidth + "px";
                        playButtonInnerElement.style.height = playButtonArrowHeight + "px";
                        playButtonInnerElement.style.borderTopWidth = playButtonArrowHeight / 2 + "px";
                        playButtonInnerElement.style.borderBottomWidth = playButtonArrowHeight / 2 + "px";
                        playButtonInnerElement.style.borderLeftWidth = playButtonArrowWidth + "px";
                        playButtonInnerElement.style.borderRightWidth = "0";
                        playButtonInnerElement.style.borderStyle = "solid";
                        playButtonInnerElement.style.borderTopColor = "transparent";
                        playButtonInnerElement.style.borderRightColor = "transparent";
                        playButtonInnerElement.style.borderBottomColor = "transparent";
                        playButtonInnerElement.style.transform = "translate(" + playButtonArrowWidth / 10 + "px,0px)";
                        playButtonOuterElement.appendChild(playButtonInnerElement);
                        playButtonContainer = document.createElement("div");
                        playButtonContainer.style.position = "absolute";
                        playButtonContainer.style.left = "0";
                        playButtonContainer.style.top = "0";
                        playButtonContainer.style.width = "100%";
                        playButtonContainer.style.height = "100%";
                        playButtonContainer.style.display = "flex";
                        playButtonContainer.style.justifyContent = "center";
                        playButtonContainer.style.alignItems = "center";
                        playButtonContainer.appendChild(playButtonOuterElement);
                        posterRootElement_1.appendChild(playButtonContainer);
                    }
                    $aa728000c38af56f$var$clearElement(this.renderedElement);
                    this.renderedElement.appendChild(posterRootElement_1);
                }
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    Media.prototype.internalRender = function() {
        var element = document.createElement("div");
        element.className = this.hostConfig.makeCssClassName("ac-media");
        return element;
    };
    Media.prototype.render = function() {
        var _this = this;
        var result = _super.prototype.render.call(this);
        if (result) {
            this._mediaPlayer = this.createMediaPlayer();
            this._mediaPlayer.fetchVideoDetails().then(function() {
                return _this.displayPoster();
            });
        }
        return result;
    };
    Media.prototype.releaseDOMResources = function() {
        _super.prototype.releaseDOMResources.call(this);
        this.displayPoster();
    };
    Media.prototype.getJsonTypeName = function() {
        return "Media";
    };
    Media.prototype.getResourceInformation = function() {
        var result = [];
        if (this._mediaPlayer) {
            var posterUrl = this.poster ? this.poster : this.hostConfig.media.defaultPoster;
            if (posterUrl) result.push({
                url: posterUrl,
                mimeType: "image"
            });
        }
        for(var _i = 0, _a = this.sources; _i < _a.length; _i++){
            var mediaSource = _a[_i];
            if (mediaSource.isValid()) result.push({
                /* eslint-disable @typescript-eslint/no-unnecessary-type-assertion -- `mediaSource.url` is of type `string | undefined`, but is validated by `isValid()` call */ url: mediaSource.url,
                mimeType: mediaSource.mimeType
            });
        }
        for(var _b = 0, _c = this.captionSources; _b < _c.length; _b++){
            var captionSource = _c[_b];
            if (captionSource.isValid()) result.push({
                /* eslint-disable @typescript-eslint/no-unnecessary-type-assertion -- `captionSource.url` is of type `string | undefined`, but is validated by `isValid()` call */ url: captionSource.url,
                mimeType: captionSource.mimeType
            });
        }
        return result;
    };
    Object.defineProperty(Media.prototype, "selectedMediaType", {
        get: function() {
            return this._mediaPlayer.selectedMediaType;
        },
        enumerable: false,
        configurable: true
    });
    Media.customMediaPlayers = [
        {
            urlPatterns: [
                /^(?:https?:\/\/)?(?:www.)?youtube.com\/watch\?(?=.*v=([\w\d-_]+))(?=(?:.*t=(\d+))?).*/gi,
                /^(?:https?:\/\/)?youtu.be\/([\w\d-_]+)(?:\?t=(\d+))?/gi
            ],
            createMediaPlayer: function(matches) {
                return new $aa728000c38af56f$var$YouTubePlayer(matches, $c6BU9.Strings.defaults.youTubeVideoPlayer());
            }
        },
        {
            urlPatterns: [
                /^(?:https?:\/\/)?vimeo.com\/([\w\d-_]+).*/gi
            ],
            createMediaPlayer: function(matches) {
                return new $aa728000c38af56f$var$VimeoPlayer(matches, $c6BU9.Strings.defaults.vimeoVideoPlayer());
            }
        },
        {
            urlPatterns: [
                /^(?:https?:\/\/)?(?:www.)?dailymotion.com\/video\/([\w\d-_]+).*/gi
            ],
            createMediaPlayer: function(matches) {
                return new $aa728000c38af56f$var$DailymotionPlayer(matches, $c6BU9.Strings.defaults.dailymotionVideoPlayer());
            }
        }
    ];
    //#region Schema
    Media.sourcesProperty = new $eZfTX.SerializableObjectCollectionProperty($eZfTX.Versions.v1_1, "sources", $aa728000c38af56f$var$MediaSource);
    Media.captionSourcesProperty = new $eZfTX.SerializableObjectCollectionProperty($eZfTX.Versions.v1_6, "captionSources", $aa728000c38af56f$var$CaptionSource);
    Media.posterProperty = new $eZfTX.StringProperty($eZfTX.Versions.v1_1, "poster");
    Media.altTextProperty = new $eZfTX.StringProperty($eZfTX.Versions.v1_1, "altText");
    $aa728000c38af56f$var$__decorate([
        (0, $eZfTX.property)(Media.sourcesProperty)
    ], Media.prototype, "sources", void 0);
    $aa728000c38af56f$var$__decorate([
        (0, $eZfTX.property)(Media.captionSourcesProperty)
    ], Media.prototype, "captionSources", void 0);
    $aa728000c38af56f$var$__decorate([
        (0, $eZfTX.property)(Media.posterProperty)
    ], Media.prototype, "poster", void 0);
    $aa728000c38af56f$var$__decorate([
        (0, $eZfTX.property)(Media.altTextProperty)
    ], Media.prototype, "altText", void 0);
    return Media;
}($aa728000c38af56f$var$CardElement);
module.exports.Media = $aa728000c38af56f$var$Media;
var $aa728000c38af56f$var$InputEventType;
(function(InputEventType) {
    InputEventType[InputEventType["InitialRender"] = 0] = "InitialRender";
    InputEventType[InputEventType["MouseEnterOnCard"] = 1] = "MouseEnterOnCard";
    InputEventType[InputEventType["MouseLeaveOnCard"] = 2] = "MouseLeaveOnCard";
    InputEventType[InputEventType["FocusLeave"] = 3] = "FocusLeave";
})($aa728000c38af56f$var$InputEventType || ($aa728000c38af56f$var$InputEventType = {}));
var $aa728000c38af56f$var$Input = /** @class */ function(_super) {
    $aa728000c38af56f$var$__extends(Input, _super);
    function Input() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.inputStyle = $kD48O.InputStyle.Default;
        return _this;
    }
    Input.prototype.getAllLabelIds = function() {
        var labelIds = [];
        if (this.labelledBy) labelIds.push(this.labelledBy);
        if (this._renderedLabelElement) labelIds.push(this._renderedLabelElement.id);
        if (this._renderedErrorMessageElement) labelIds.push(this._renderedErrorMessageElement.id);
        return labelIds;
    };
    Input.prototype.updateInputControlAriaLabelledBy = function() {
        if (this._renderedInputControlElement) {
            var labelIds = this.getAllLabelIds();
            if (labelIds.length > 0) this._renderedInputControlElement.setAttribute("aria-labelledby", labelIds.join(" "));
            else this._renderedInputControlElement.removeAttribute("aria-labelledby");
        }
    };
    Object.defineProperty(Input.prototype, "isNullable", {
        get: function() {
            return true;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Input.prototype, "renderedInputControlElement", {
        get: function() {
            return this._renderedInputControlElement;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Input.prototype, "inputControlContainerElement", {
        get: function() {
            return this._inputControlContainerElement;
        },
        enumerable: false,
        configurable: true
    });
    Input.prototype.overrideInternalRender = function() {
        var _this = this;
        var hostConfig = this.hostConfig;
        this._outerContainerElement = document.createElement("div");
        this._outerContainerElement.style.display = "flex";
        if (this.labelPosition === $kD48O.InputLabelPosition.Inline) this._outerContainerElement.style.flexDirection = "row";
        else this._outerContainerElement.style.flexDirection = "column";
        var renderedInputControlId = $8QA0A.generateUniqueId();
        if (this.label) {
            var labelRichTextBlock = new $aa728000c38af56f$var$RichTextBlock();
            labelRichTextBlock.setParent(this);
            labelRichTextBlock.forElementId = renderedInputControlId;
            var labelInline = new $aa728000c38af56f$var$TextRun(this.label);
            labelRichTextBlock.addInline(labelInline);
            if (this.isRequired) {
                labelInline.init(hostConfig.inputs.label.requiredInputs);
                var isRequiredCueInline = new $aa728000c38af56f$var$TextRun(hostConfig.inputs.label.requiredInputs.suffix);
                isRequiredCueInline.color = hostConfig.inputs.label.requiredInputs.suffixColor;
                isRequiredCueInline.ariaHidden = true;
                labelRichTextBlock.addInline(isRequiredCueInline);
            } else labelInline.init(hostConfig.inputs.label.optionalInputs);
            this._renderedLabelElement = labelRichTextBlock.render();
            if (this._renderedLabelElement) {
                this._renderedLabelElement.id = $8QA0A.generateUniqueId();
                if (this.labelPosition === $kD48O.InputLabelPosition.Inline) // For inline label position: label should be in center of the div and no extra spacing needed
                this._renderedLabelElement.style.alignSelf = "center";
                else this._renderedLabelElement.style.marginBottom = hostConfig.getEffectiveSpacing(hostConfig.inputs.label.inputSpacing) + "px";
                this._outerContainerElement.appendChild(this._renderedLabelElement);
            }
        }
        this._inputControlContainerElement = document.createElement("div");
        this._inputControlContainerElement.className = hostConfig.makeCssClassName("ac-input-container");
        this._inputControlContainerElement.style.display = "flex";
        if (this.height === "stretch") {
            this._inputControlContainerElement.style.alignItems = "stretch";
            this._inputControlContainerElement.style.flex = "1 1 auto";
        }
        this._renderedInputControlElement = this.internalRender();
        if (this._renderedInputControlElement) {
            this._renderedInputControlElement.id = renderedInputControlId;
            this._renderedInputControlElement.style.minWidth = "0px";
            if (this.isNullable && this.isRequired) {
                this._renderedInputControlElement.setAttribute("aria-required", "true");
                this._renderedInputControlElement.classList.add(hostConfig.makeCssClassName("ac-input-required"));
            }
            this._inputControlContainerElement.appendChild(this._renderedInputControlElement);
            this._outerContainerElement.appendChild(this._inputControlContainerElement);
            if (this._renderedLabelElement && this.labelPosition === $kD48O.InputLabelPosition.Inline) {
                if (!this.labelWidth) {
                    var defaultLabelWidth = hostConfig.inputs.label.width;
                    this._renderedLabelElement.style.width = defaultLabelWidth.toString() + "%";
                    this._inputControlContainerElement.style.width = 100 - defaultLabelWidth + "%";
                } else if (this.labelWidth.unit == $kD48O.SizeUnit.Weight) {
                    var labelWidthInPercent = this.labelWidth.physicalSize;
                    this._renderedLabelElement.style.width = labelWidthInPercent.toString() + "%";
                    this._inputControlContainerElement.style.width = (100 - labelWidthInPercent).toString() + "%";
                } else if (this.labelWidth.unit == $kD48O.SizeUnit.Pixel) {
                    var labelWidthInPixel = this.labelWidth.physicalSize;
                    this._renderedLabelElement.style.width = labelWidthInPixel.toString() + "px";
                }
            }
            this.updateVisualState($aa728000c38af56f$var$InputEventType.InitialRender);
            if (this._renderedInputControlElement) this._renderedInputControlElement.onblur = function(ev) {
                _this.updateVisualState($aa728000c38af56f$var$InputEventType.FocusLeave);
            };
            this.updateInputControlAriaLabelledBy();
            return this._outerContainerElement;
        }
        this.resetDirtyState();
        return undefined;
    };
    Input.prototype.valueChanged = function() {
        this.getRootElement().updateActionsEnabledState();
        if (this.isValid()) this.resetValidationFailureCue();
        if (this.onValueChanged) this.onValueChanged(this);
        $aa728000c38af56f$var$raiseInputValueChangedEvent(this);
    };
    Input.prototype.resetValidationFailureCue = function() {
        if (this.renderedInputControlElement) {
            this.renderedInputControlElement.classList.remove(this.hostConfig.makeCssClassName("ac-input-validation-failed"));
            this.updateInputControlAriaLabelledBy();
            if (this._renderedErrorMessageElement) {
                this._outerContainerElement.removeChild(this._renderedErrorMessageElement);
                this._renderedErrorMessageElement = undefined;
            }
        }
    };
    Input.prototype.showValidationErrorMessage = function() {
        if (this.renderedElement && this.errorMessage && $8Lw6d.GlobalSettings.displayInputValidationErrors) {
            var errorMessageTextBlock = new $aa728000c38af56f$var$TextBlock();
            errorMessageTextBlock.setParent(this);
            errorMessageTextBlock.text = this.errorMessage;
            errorMessageTextBlock.wrap = true;
            errorMessageTextBlock.init(this.hostConfig.inputs.errorMessage);
            this._renderedErrorMessageElement = errorMessageTextBlock.render();
            if (this._renderedErrorMessageElement) {
                this._renderedErrorMessageElement.id = $8QA0A.generateUniqueId();
                this._outerContainerElement.appendChild(this._renderedErrorMessageElement);
                this.updateInputControlAriaLabelledBy();
            }
        }
    };
    Object.defineProperty(Input.prototype, "allowRevealOnHoverStyle", {
        get: function() {
            return this.hostConfig.inputs && this.hostConfig.inputs.allowRevealOnHoverStyle;
        },
        enumerable: false,
        configurable: true
    });
    Input.prototype.shouldHideInputAdornersForRevealOnHover = function(input, eventType) {
        // show/hide input adorners (date picker, time picker, select dropdown picker) with inputStyle RevealOnHover
        // 1. intial render of card: hide input adorners
        // 2. mouse hover on the card: show input adorners
        // 3. mouse hover outside the card: hide input adorners unless input is still in focus state
        // 4. input loses focus: hide the input adorners unless mouse is still hovering on the card
        // check if input still has the focus
        var isInputInFocus = input === document.activeElement;
        // check if mouse is still on the card
        var inputHoverClassName = this.hostConfig.makeCssClassName("ac-inputStyle-revealOnHover-onhover");
        var isMouseOverCard = input.classList.contains(inputHoverClassName);
        var hideInputAdorners = eventType === $aa728000c38af56f$var$InputEventType.InitialRender || eventType === $aa728000c38af56f$var$InputEventType.FocusLeave && !isMouseOverCard || eventType === $aa728000c38af56f$var$InputEventType.MouseLeaveOnCard && !isInputInFocus;
        return hideInputAdorners;
    };
    Input.prototype.updateVisualState = function(eventType) {
        if (!this.allowRevealOnHoverStyle || !this._renderedInputControlElement || this.inputStyle !== $kD48O.InputStyle.RevealOnHover) return;
        if (eventType === $aa728000c38af56f$var$InputEventType.InitialRender) // on initial render, we will show input fields as read only view
        this._renderedInputControlElement.classList.add(this.hostConfig.makeCssClassName("ac-inputStyle-revealOnHover-onrender"));
        else if (eventType === $aa728000c38af56f$var$InputEventType.MouseEnterOnCard) // on hover on the card, we will reveal the inputs by showing borders etc
        // ac-inputStyle-revealOnHover-onhover class is also used to identify if mouse is hovering on the card
        this._renderedInputControlElement.classList.add(this.hostConfig.makeCssClassName("ac-inputStyle-revealOnHover-onhover"));
        else if (eventType === $aa728000c38af56f$var$InputEventType.MouseLeaveOnCard) this._renderedInputControlElement.classList.remove(this.hostConfig.makeCssClassName("ac-inputStyle-revealOnHover-onhover"));
    };
    Input.prototype.focus = function() {
        if (this._renderedInputControlElement) this._renderedInputControlElement.focus();
    };
    Input.prototype.isValid = function() {
        return true;
    };
    Input.prototype.isDirty = function() {
        return this.value !== this._oldValue;
    };
    Input.prototype.resetDirtyState = function() {
        this._oldValue = this.value;
    };
    Input.prototype.internalValidateProperties = function(context) {
        _super.prototype.internalValidateProperties.call(this, context);
        if (!this.id) context.addFailure(this, $kD48O.ValidationEvent.PropertyCantBeNull, $c6BU9.Strings.errors.inputsMustHaveUniqueId());
        if (this.isRequired) {
            if (!this.label) context.addFailure(this, $kD48O.ValidationEvent.RequiredInputsShouldHaveLabel, "Required inputs should have a label");
            if (!this.errorMessage) context.addFailure(this, $kD48O.ValidationEvent.RequiredInputsShouldHaveErrorMessage, "Required inputs should have an error message");
        }
    };
    Input.prototype.validateValue = function() {
        this.resetValidationFailureCue();
        var result = this.isRequired ? this.isSet() && this.isValid() : this.isValid();
        if (!result && this.renderedInputControlElement) {
            this.renderedInputControlElement.classList.add(this.hostConfig.makeCssClassName("ac-input-validation-failed"));
            this.showValidationErrorMessage();
        }
        return result;
    };
    Input.prototype.getAllInputs = function(processActions) {
        if (processActions === void 0) processActions = true;
        return [
            this
        ];
    };
    Input.prototype.render = function() {
        var result = _super.prototype.render.call(this);
        this.resetDirtyState();
        return result;
    };
    Object.defineProperty(Input.prototype, "isInteractive", {
        get: function() {
            return true;
        },
        enumerable: false,
        configurable: true
    });
    //#region Schema
    Input.labelProperty = new $eZfTX.StringProperty($eZfTX.Versions.v1_3, "label", true);
    Input.isRequiredProperty = new $eZfTX.BoolProperty($eZfTX.Versions.v1_3, "isRequired", false);
    Input.errorMessageProperty = new $eZfTX.StringProperty($eZfTX.Versions.v1_3, "errorMessage", true);
    Input.inputStyleProperty = new $eZfTX.EnumProperty($eZfTX.Versions.v1_6, "inputStyle", $kD48O.InputStyle, $kD48O.InputStyle.Default, [
        {
            value: $kD48O.InputStyle.RevealOnHover
        },
        {
            value: $kD48O.InputStyle.Default
        }
    ]);
    Input.labelWidthProperty = new $eZfTX.CustomProperty($eZfTX.Versions.v1_6, "labelWidth", function(sender, prop, source, context) {
        var result = prop.defaultValue;
        var value = source[prop.name];
        var invalidLabelWidth = false;
        if (typeof value === "number" && !isNaN(value)) {
            result = new $8Lw6d.SizeAndUnit(value, $kD48O.SizeUnit.Weight);
            if (result.physicalSize < 0 || result.physicalSize > 100) invalidLabelWidth = true;
        } else if (typeof value === "string") try {
            result = $8Lw6d.SizeAndUnit.parse(value);
        } catch (e) {
            invalidLabelWidth = true;
        }
        else invalidLabelWidth = true;
        if (invalidLabelWidth) {
            context.logParseEvent(sender, $kD48O.ValidationEvent.InvalidPropertyValue, $c6BU9.Strings.errors.invalidInputLabelWidth());
            result = undefined;
        }
        return result;
    }, function(sender, property, target, value, context) {
        if (value instanceof $8Lw6d.SizeAndUnit) {
            if (value.unit === $kD48O.SizeUnit.Pixel) context.serializeValue(target, "labelWidth", value.physicalSize + "px");
            else context.serializeNumber(target, "labelWidth", value.physicalSize);
        }
    }, undefined);
    Input.labelPositionProperty = new $eZfTX.EnumProperty($eZfTX.Versions.v1_6, "labelPosition", $kD48O.InputLabelPosition, $kD48O.InputLabelPosition.Above, [
        {
            value: $kD48O.InputLabelPosition.Inline
        },
        {
            value: $kD48O.InputLabelPosition.Above
        }
    ]);
    $aa728000c38af56f$var$__decorate([
        (0, $eZfTX.property)(Input.labelProperty)
    ], Input.prototype, "label", void 0);
    $aa728000c38af56f$var$__decorate([
        (0, $eZfTX.property)(Input.isRequiredProperty)
    ], Input.prototype, "isRequired", void 0);
    $aa728000c38af56f$var$__decorate([
        (0, $eZfTX.property)(Input.errorMessageProperty)
    ], Input.prototype, "errorMessage", void 0);
    $aa728000c38af56f$var$__decorate([
        (0, $eZfTX.property)(Input.inputStyleProperty)
    ], Input.prototype, "inputStyle", void 0);
    $aa728000c38af56f$var$__decorate([
        (0, $eZfTX.property)(Input.labelWidthProperty)
    ], Input.prototype, "labelWidth", void 0);
    $aa728000c38af56f$var$__decorate([
        (0, $eZfTX.property)(Input.labelPositionProperty)
    ], Input.prototype, "labelPosition", void 0);
    return Input;
}($aa728000c38af56f$var$CardElement);
module.exports.Input = $aa728000c38af56f$var$Input;
var $aa728000c38af56f$var$TextInput = /** @class */ function(_super) {
    $aa728000c38af56f$var$__extends(TextInput, _super);
    function TextInput() {
        //#region Schema
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.isMultiline = false;
        _this.style = $kD48O.InputTextStyle.Text;
        return _this;
    }
    //#endregion
    TextInput.prototype.setupInput = function(input) {
        var _this = this;
        input.style.flex = "1 1 auto";
        input.tabIndex = this.isDesignMode() ? -1 : 0;
        if (this.placeholder) {
            input.placeholder = this.placeholder;
            input.setAttribute("aria-label", this.placeholder);
        }
        if (this.defaultValue) input.value = this.defaultValue;
        if (this.maxLength && this.maxLength > 0) input.maxLength = this.maxLength;
        input.oninput = function() {
            _this.valueChanged();
        };
        input.onkeypress = function(e) {
            // Ctrl+Enter pressed
            if (e.ctrlKey && e.code === "Enter" && _this.inlineAction && _this.inlineAction.isEffectivelyEnabled()) _this.inlineAction.execute();
        };
    };
    TextInput.prototype.internalRender = function() {
        var result;
        if (this.isMultiline && this.style !== $kD48O.InputTextStyle.Password) {
            result = document.createElement("textarea");
            result.className = this.hostConfig.makeCssClassName("ac-input", "ac-textInput", "ac-multiline");
            if (this.height === "stretch") result.style.height = "initial";
        } else {
            result = document.createElement("input");
            result.className = this.hostConfig.makeCssClassName("ac-input", "ac-textInput");
            result.type = $kD48O.InputTextStyle[this.style].toLowerCase();
        }
        this.setupInput(result);
        return result;
    };
    TextInput.prototype.overrideInternalRender = function() {
        var _this = this;
        var renderedInputControl = _super.prototype.overrideInternalRender.call(this);
        if (this.inlineAction) {
            var button_1 = document.createElement("button");
            button_1.className = this.hostConfig.makeCssClassName(this.inlineAction.isEffectivelyEnabled() ? "ac-inlineActionButton" : "ac-inlineActionButton-disabled");
            button_1.onclick = function(e) {
                if (_this.inlineAction && _this.inlineAction.isEffectivelyEnabled()) {
                    e.preventDefault();
                    e.cancelBubble = true;
                    _this.inlineAction.execute();
                }
            };
            if (this.inlineAction.iconUrl) {
                button_1.classList.add("iconOnly");
                var icon_1 = document.createElement("img");
                icon_1.style.height = "100%";
                icon_1.setAttribute("role", "presentation");
                // The below trick is necessary as a workaround in Chrome where the icon is initially displayed
                // at its native size then resized to 100% of the button's height. This cfreates an unpleasant
                // flicker. On top of that, Chrome's flex implementation fails to prperly re-layout the button
                // after the image has loaded and been gicven its final size. The below trick also fixes that.
                icon_1.style.display = "none";
                icon_1.onload = function() {
                    icon_1.style.removeProperty("display");
                };
                icon_1.onerror = function() {
                    button_1.removeChild(icon_1);
                    button_1.classList.remove("iconOnly");
                    button_1.classList.add("textOnly");
                    button_1.textContent = _this.inlineAction && _this.inlineAction.title ? _this.inlineAction.title : $c6BU9.Strings.defaults.inlineActionTitle();
                };
                icon_1.src = this.inlineAction.iconUrl;
                button_1.appendChild(icon_1);
                button_1.title = this.inlineAction.title ? this.inlineAction.title : $c6BU9.Strings.defaults.inlineActionTitle();
            } else {
                button_1.classList.add("textOnly");
                button_1.textContent = this.inlineAction.title ? this.inlineAction.title : $c6BU9.Strings.defaults.inlineActionTitle();
            }
            this.inlineAction.setupElementForAccessibility(button_1, true);
            button_1.style.marginLeft = "8px";
            this.inputControlContainerElement.appendChild(button_1);
        }
        return renderedInputControl;
    };
    TextInput.prototype.updateVisualState = function(eventType) {
        if (!this.allowRevealOnHoverStyle) return;
        if (!(this.inlineAction || this.isMultiline)) _super.prototype.updateVisualState.call(this, eventType);
    };
    TextInput.prototype.getJsonTypeName = function() {
        return "Input.Text";
    };
    TextInput.prototype.getAllActions = function() {
        var result = _super.prototype.getAllActions.call(this);
        if (this.inlineAction) result.push(this.inlineAction);
        return result;
    };
    TextInput.prototype.getActionById = function(id) {
        var result = _super.prototype.getActionById.call(this, id);
        if (!result && this.inlineAction) result = this.inlineAction.getActionById(id);
        return result;
    };
    TextInput.prototype.isSet = function() {
        return this.value ? true : false;
    };
    TextInput.prototype.isValid = function() {
        if (!this.value) return true;
        if (this.regex) return new RegExp(this.regex, "g").test(this.value);
        return true;
    };
    Object.defineProperty(TextInput.prototype, "value", {
        get: function() {
            if (this.renderedInputControlElement) {
                if (this.isMultiline) return this.renderedInputControlElement.value;
                else return this.renderedInputControlElement.value;
            } else return undefined;
        },
        enumerable: false,
        configurable: true
    });
    TextInput.valueProperty = new $eZfTX.StringProperty($eZfTX.Versions.v1_0, "value");
    TextInput.maxLengthProperty = new $eZfTX.NumProperty($eZfTX.Versions.v1_0, "maxLength");
    TextInput.isMultilineProperty = new $eZfTX.BoolProperty($eZfTX.Versions.v1_0, "isMultiline", false);
    TextInput.placeholderProperty = new $eZfTX.StringProperty($eZfTX.Versions.v1_0, "placeholder");
    TextInput.styleProperty = new $eZfTX.EnumProperty($eZfTX.Versions.v1_0, "style", $kD48O.InputTextStyle, $kD48O.InputTextStyle.Text, [
        {
            value: $kD48O.InputTextStyle.Text
        },
        {
            value: $kD48O.InputTextStyle.Tel
        },
        {
            value: $kD48O.InputTextStyle.Url
        },
        {
            value: $kD48O.InputTextStyle.Email
        },
        {
            value: $kD48O.InputTextStyle.Password,
            targetVersion: $eZfTX.Versions.v1_5
        }
    ]);
    TextInput.inlineActionProperty = new $aa728000c38af56f$var$ActionProperty($eZfTX.Versions.v1_0, "inlineAction", [
        "Action.ShowCard"
    ]);
    TextInput.regexProperty = new $eZfTX.StringProperty($eZfTX.Versions.v1_3, "regex", true);
    $aa728000c38af56f$var$__decorate([
        (0, $eZfTX.property)(TextInput.valueProperty)
    ], TextInput.prototype, "defaultValue", void 0);
    $aa728000c38af56f$var$__decorate([
        (0, $eZfTX.property)(TextInput.maxLengthProperty)
    ], TextInput.prototype, "maxLength", void 0);
    $aa728000c38af56f$var$__decorate([
        (0, $eZfTX.property)(TextInput.isMultilineProperty)
    ], TextInput.prototype, "isMultiline", void 0);
    $aa728000c38af56f$var$__decorate([
        (0, $eZfTX.property)(TextInput.placeholderProperty)
    ], TextInput.prototype, "placeholder", void 0);
    $aa728000c38af56f$var$__decorate([
        (0, $eZfTX.property)(TextInput.styleProperty)
    ], TextInput.prototype, "style", void 0);
    $aa728000c38af56f$var$__decorate([
        (0, $eZfTX.property)(TextInput.inlineActionProperty)
    ], TextInput.prototype, "inlineAction", void 0);
    $aa728000c38af56f$var$__decorate([
        (0, $eZfTX.property)(TextInput.regexProperty)
    ], TextInput.prototype, "regex", void 0);
    return TextInput;
}($aa728000c38af56f$var$Input);
module.exports.TextInput = $aa728000c38af56f$var$TextInput;
var $aa728000c38af56f$var$ToggleInput = /** @class */ function(_super) {
    $aa728000c38af56f$var$__extends(ToggleInput, _super);
    function ToggleInput() {
        //#region Schema
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.valueOn = "true";
        _this.valueOff = "false";
        _this.wrap = false;
        return _this;
    }
    ToggleInput.prototype.updateInputControlAriaLabelledBy = function() {
        if (this._checkboxInputElement) {
            var joinedLabelIds = this.getAllLabelIds().join(" ");
            if (this._checkboxInputLabelElement && this._checkboxInputLabelElement.id) joinedLabelIds += " " + this._checkboxInputLabelElement.id;
            if (joinedLabelIds) this._checkboxInputElement.setAttribute("aria-labelledby", joinedLabelIds);
            else this._checkboxInputElement.removeAttribute("aria-labelledby");
        }
    };
    ToggleInput.prototype.internalRender = function() {
        var _this = this;
        var element = document.createElement("div");
        element.className = this.hostConfig.makeCssClassName("ac-input", "ac-toggleInput");
        element.style.width = "100%";
        element.style.display = "flex";
        element.style.alignItems = "center";
        this._checkboxInputElement = document.createElement("input");
        this._checkboxInputElement.id = $8QA0A.generateUniqueId();
        this._checkboxInputElement.type = "checkbox";
        this._checkboxInputElement.style.display = "inline-block";
        this._checkboxInputElement.style.verticalAlign = "middle";
        this._checkboxInputElement.style.margin = "0";
        this._checkboxInputElement.style.flex = "0 0 auto";
        if (this.title) this._checkboxInputElement.setAttribute("aria-label", this.title);
        if (this.isRequired) this._checkboxInputElement.setAttribute("aria-required", "true");
        this._checkboxInputElement.tabIndex = this.isDesignMode() ? -1 : 0;
        if (this.defaultValue === this.valueOn) this._checkboxInputElement.checked = true;
        this._oldCheckboxValue = this._checkboxInputElement.checked;
        this._checkboxInputElement.onchange = function() {
            _this.valueChanged();
        };
        $8QA0A.appendChild(element, this._checkboxInputElement);
        if (this.title || this.isDesignMode()) {
            var label = new $aa728000c38af56f$var$TextBlock();
            label.setParent(this);
            label.forElementId = this._checkboxInputElement.id;
            label.hostConfig = this.hostConfig;
            label.text = !this.title ? this.getJsonTypeName() : this.title;
            label.useMarkdown = $8Lw6d.GlobalSettings.useMarkdownInRadioButtonAndCheckbox;
            label.wrap = this.wrap;
            this._checkboxInputLabelElement = label.render();
            if (this._checkboxInputLabelElement) {
                this._checkboxInputLabelElement.id = $8QA0A.generateUniqueId();
                this._checkboxInputLabelElement.style.display = "inline-block";
                this._checkboxInputLabelElement.style.flex = "1 1 auto";
                this._checkboxInputLabelElement.style.marginLeft = "6px";
                this._checkboxInputLabelElement.style.verticalAlign = "middle";
                var spacerElement = document.createElement("div");
                spacerElement.style.width = "6px";
                $8QA0A.appendChild(element, spacerElement);
                $8QA0A.appendChild(element, this._checkboxInputLabelElement);
            }
        }
        return element;
    };
    Object.defineProperty(ToggleInput.prototype, "isNullable", {
        get: function() {
            return false;
        },
        enumerable: false,
        configurable: true
    });
    ToggleInput.prototype.updateVisualState = function(eventType) {};
    ToggleInput.prototype.getJsonTypeName = function() {
        return "Input.Toggle";
    };
    ToggleInput.prototype.focus = function() {
        if (this._checkboxInputElement) this._checkboxInputElement.focus();
    };
    ToggleInput.prototype.isSet = function() {
        if (this.isRequired) return this.value === this.valueOn;
        return this.value ? true : false;
    };
    ToggleInput.prototype.isDirty = function() {
        return this._checkboxInputElement ? this._checkboxInputElement.checked !== this._oldCheckboxValue : false;
    };
    Object.defineProperty(ToggleInput.prototype, "value", {
        get: function() {
            if (this._checkboxInputElement) return this._checkboxInputElement.checked ? this.valueOn : this.valueOff;
            else return undefined;
        },
        enumerable: false,
        configurable: true
    });
    ToggleInput.valueProperty = new $eZfTX.StringProperty($eZfTX.Versions.v1_0, "value");
    ToggleInput.titleProperty = new $eZfTX.StringProperty($eZfTX.Versions.v1_0, "title");
    ToggleInput.valueOnProperty = new $eZfTX.StringProperty($eZfTX.Versions.v1_0, "valueOn", true, undefined, "true", function(sender) {
        return "true";
    });
    ToggleInput.valueOffProperty = new $eZfTX.StringProperty($eZfTX.Versions.v1_0, "valueOff", true, undefined, "false", function(sender) {
        return "false";
    });
    ToggleInput.wrapProperty = new $eZfTX.BoolProperty($eZfTX.Versions.v1_2, "wrap", false);
    $aa728000c38af56f$var$__decorate([
        (0, $eZfTX.property)(ToggleInput.valueProperty)
    ], ToggleInput.prototype, "defaultValue", void 0);
    $aa728000c38af56f$var$__decorate([
        (0, $eZfTX.property)(ToggleInput.titleProperty)
    ], ToggleInput.prototype, "title", void 0);
    $aa728000c38af56f$var$__decorate([
        (0, $eZfTX.property)(ToggleInput.valueOnProperty)
    ], ToggleInput.prototype, "valueOn", void 0);
    $aa728000c38af56f$var$__decorate([
        (0, $eZfTX.property)(ToggleInput.valueOffProperty)
    ], ToggleInput.prototype, "valueOff", void 0);
    $aa728000c38af56f$var$__decorate([
        (0, $eZfTX.property)(ToggleInput.wrapProperty)
    ], ToggleInput.prototype, "wrap", void 0);
    return ToggleInput;
}($aa728000c38af56f$var$Input);
module.exports.ToggleInput = $aa728000c38af56f$var$ToggleInput;
var $aa728000c38af56f$var$Choice = /** @class */ function(_super) {
    $aa728000c38af56f$var$__extends(Choice, _super);
    function Choice(title, value) {
        var _this = _super.call(this) || this;
        _this.title = title;
        _this.value = value;
        return _this;
    }
    //#endregion
    Choice.prototype.getSchemaKey = function() {
        return "Choice";
    };
    //#region Schema
    Choice.titleProperty = new $eZfTX.StringProperty($eZfTX.Versions.v1_0, "title");
    Choice.valueProperty = new $eZfTX.StringProperty($eZfTX.Versions.v1_0, "value");
    $aa728000c38af56f$var$__decorate([
        (0, $eZfTX.property)(Choice.titleProperty)
    ], Choice.prototype, "title", void 0);
    $aa728000c38af56f$var$__decorate([
        (0, $eZfTX.property)(Choice.valueProperty)
    ], Choice.prototype, "value", void 0);
    return Choice;
}($eZfTX.SerializableObject);
module.exports.Choice = $aa728000c38af56f$var$Choice;
/**
 * DataQuery class is declared later in the file and derives from subsequent base classes
 * Hence, it cannot be used in ChoiceSetInput.
 * Refactor is needed to separate elements and actions in separate files.
 */ var $aa728000c38af56f$var$ChoiceSetInputDataQuery = /** @class */ function(_super) {
    $aa728000c38af56f$var$__extends(ChoiceSetInputDataQuery, _super);
    function ChoiceSetInputDataQuery() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    //#endregion
    ChoiceSetInputDataQuery.prototype.getSchemaKey = function() {
        return "choices.data";
    };
    //#region Schema
    ChoiceSetInputDataQuery.typeProperty = new $eZfTX.StringProperty($eZfTX.Versions.v1_6, "type", true, new RegExp("^Data.Query$"));
    ChoiceSetInputDataQuery.datasetProperty = new $eZfTX.StringProperty($eZfTX.Versions.v1_6, "dataset");
    $aa728000c38af56f$var$__decorate([
        (0, $eZfTX.property)(ChoiceSetInputDataQuery.typeProperty)
    ], ChoiceSetInputDataQuery.prototype, "type", void 0);
    $aa728000c38af56f$var$__decorate([
        (0, $eZfTX.property)(ChoiceSetInputDataQuery.datasetProperty)
    ], ChoiceSetInputDataQuery.prototype, "dataset", void 0);
    return ChoiceSetInputDataQuery;
}($eZfTX.SerializableObject);
module.exports.ChoiceSetInputDataQuery = $aa728000c38af56f$var$ChoiceSetInputDataQuery;
var $aa728000c38af56f$var$ChoiceSetInput = /** @class */ function(_super) {
    $aa728000c38af56f$var$__extends(ChoiceSetInput, _super);
    function ChoiceSetInput() {
        //#region Schema
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.isMultiSelect = false;
        _this.wrap = false;
        _this.choices = [];
        return _this;
    }
    Object.defineProperty(ChoiceSetInput.prototype, "isCompact", {
        get: function() {
            return !this.style || this.style === "compact";
        },
        set: function(value) {
            this.style = value ? undefined : "expanded";
        },
        enumerable: false,
        configurable: true
    });
    ChoiceSetInput.getUniqueCategoryName = function() {
        var uniqueCategoryName = "__ac-category" + ChoiceSetInput._uniqueCategoryCounter;
        ChoiceSetInput._uniqueCategoryCounter++;
        return uniqueCategoryName;
    };
    ChoiceSetInput.prototype.isDynamicTypeahead = function() {
        return !!this.choicesData && !!this.choicesData.dataset && this.choicesData.type === "Data.Query";
    };
    ChoiceSetInput.prototype.renderChoices = function(fetchedChoices) {
        var _a;
        (_a = this._filteredChoiceSet) === null || _a === void 0 || _a.processResponse(fetchedChoices);
    };
    ChoiceSetInput.prototype.showLoadingIndicator = function() {
        var _a;
        (_a = this._filteredChoiceSet) === null || _a === void 0 || _a.showLoadingIndicator();
    };
    ChoiceSetInput.prototype.removeLoadingIndicator = function() {
        var _a;
        (_a = this._filteredChoiceSet) === null || _a === void 0 || _a.removeLoadingIndicator();
    };
    ChoiceSetInput.prototype.showErrorIndicator = function(error) {
        var _a;
        (_a = this._filteredChoiceSet) === null || _a === void 0 || _a.showErrorIndicator(error);
    };
    ChoiceSetInput.prototype.createPlaceholderOptionWhenValueDoesNotExist = function() {
        if (!this.value) {
            var placeholderOption = document.createElement("option");
            placeholderOption.selected = true;
            placeholderOption.disabled = true;
            placeholderOption.hidden = true;
            placeholderOption.value = "";
            if (this.placeholder) placeholderOption.text = this.placeholder;
            return placeholderOption;
        }
        return undefined;
    };
    // Make sure `aria-current` is applied to the currently-selected item
    ChoiceSetInput.prototype.internalApplyAriaCurrent = function() {
        if (this._selectElement) {
            var options = this._selectElement.options;
            if (options) for(var _i = 0, _a = Array.from(options); _i < _a.length; _i++){
                var option = _a[_i];
                if (option.selected) option.setAttribute("aria-current", "true");
                else option.removeAttribute("aria-current");
            }
        }
    };
    ChoiceSetInput.prototype.renderCompoundInput = function(cssClassName, type, defaultValues) {
        var _this = this;
        var element = document.createElement("div");
        element.className = this.hostConfig.makeCssClassName("ac-input", cssClassName);
        element.style.width = "100%";
        element.tabIndex = this.isDesignMode() ? -1 : 0;
        this._toggleInputs = [];
        this._labels = [];
        for(var _i = 0, _a = this.choices; _i < _a.length; _i++){
            var choice = _a[_i];
            var input = document.createElement("input");
            input.id = $8QA0A.generateUniqueId();
            input.type = type;
            input.style.margin = "0";
            input.style.display = "inline-block";
            input.style.verticalAlign = "middle";
            input.style.flex = "0 0 auto";
            input.name = this.id ? this.id : this._uniqueCategoryName;
            if (this.isRequired) input.setAttribute("aria-required", "true");
            input.tabIndex = this.isDesignMode() ? -1 : 0;
            if (choice.value) input.value = choice.value;
            if (choice.title) input.setAttribute("aria-label", choice.title);
            if (defaultValues && choice.value) {
                if (defaultValues.indexOf(choice.value) >= 0) input.checked = true;
            }
            input.onchange = function() {
                _this.valueChanged();
            };
            this._toggleInputs.push(input);
            var compoundInput = document.createElement("div");
            compoundInput.style.display = "flex";
            compoundInput.style.alignItems = "center";
            $8QA0A.appendChild(compoundInput, input);
            var label = new $aa728000c38af56f$var$TextBlock();
            label.setParent(this);
            label.forElementId = input.id;
            label.hostConfig = this.hostConfig;
            label.text = choice.title ? choice.title : "Choice " + this._toggleInputs.length;
            label.useMarkdown = $8Lw6d.GlobalSettings.useMarkdownInRadioButtonAndCheckbox;
            label.wrap = this.wrap;
            var labelElement = label.render();
            this._labels.push(labelElement);
            if (labelElement) {
                labelElement.id = $8QA0A.generateUniqueId();
                labelElement.style.display = "inline-block";
                labelElement.style.flex = "1 1 auto";
                labelElement.style.marginLeft = "6px";
                labelElement.style.verticalAlign = "middle";
                var spacerElement = document.createElement("div");
                spacerElement.style.width = "6px";
                $8QA0A.appendChild(compoundInput, spacerElement);
                $8QA0A.appendChild(compoundInput, labelElement);
            }
            $8QA0A.appendChild(element, compoundInput);
        }
        return element;
    };
    ChoiceSetInput.prototype.updateInputControlAriaLabelledBy = function() {
        if ((this.isMultiSelect || this.style === "expanded") && this._toggleInputs && this._labels) {
            var labelIds = this.getAllLabelIds();
            for(var i = 0; i < this._toggleInputs.length; i++){
                var joinedLabelIds = labelIds.join(" ");
                var label = this._labels[i];
                if (label && label.id) joinedLabelIds += " " + label.id;
                if (joinedLabelIds) this._toggleInputs[i].setAttribute("aria-labelledby", joinedLabelIds);
                else this._toggleInputs[i].removeAttribute("aria-labelledby");
            }
        } else _super.prototype.updateInputControlAriaLabelledBy.call(this);
    };
    ChoiceSetInput.prototype.internalRender = function() {
        var _this = this;
        this._uniqueCategoryName = ChoiceSetInput.getUniqueCategoryName();
        if (this.isDynamicTypeahead()) {
            var filteredChoiceSet_1 = new $aa728000c38af56f$var$FilteredChoiceSet(ChoiceSetInput._uniqueCategoryCounter, this.choices, this.hostConfig);
            filteredChoiceSet_1.render();
            if (filteredChoiceSet_1.textInput) {
                this._textInput = filteredChoiceSet_1.textInput;
                if (this.defaultValue) this._textInput.value = this.defaultValue;
                if (this.placeholder && !this._textInput.value) {
                    this._textInput.placeholder = this.placeholder;
                    this._textInput.setAttribute("aria-label", this.placeholder);
                }
                this._textInput.tabIndex = this.isDesignMode() ? -1 : 0;
                var onInputChangeEventHandler = $8QA0A.debounce(function() {
                    filteredChoiceSet_1.processStaticChoices();
                    _this.valueChanged();
                    if (_this._textInput) {
                        // Remove aria-label when value is not empty so narration software doesn't
                        // read the placeholder
                        if (_this.value) {
                            _this._textInput.removeAttribute("placeholder");
                            _this._textInput.removeAttribute("aria-label");
                        } else if (_this.placeholder) {
                            _this._textInput.placeholder = _this.placeholder;
                            _this._textInput.setAttribute("aria-label", _this.placeholder);
                        }
                    }
                }, this.hostConfig.inputs.debounceTimeInMilliSeconds);
                this._textInput.onclick = onInputChangeEventHandler;
                this._textInput.oninput = onInputChangeEventHandler;
            }
            filteredChoiceSet_1.parent = this;
            this._filteredChoiceSet = filteredChoiceSet_1;
            return filteredChoiceSet_1.renderedElement;
        } else if (this.isMultiSelect) // Render as a list of toggle inputs
        return this.renderCompoundInput("ac-choiceSetInput-multiSelect", "checkbox", this.defaultValue ? this.defaultValue.split(this.hostConfig.choiceSetInputValueSeparator) : undefined);
        else {
            if (this.style === "expanded") // Render as a series of radio buttons
            return this.renderCompoundInput("ac-choiceSetInput-expanded", "radio", this.defaultValue ? [
                this.defaultValue
            ] : undefined);
            else if (this.style === "filtered") {
                // Render as a text input coupled with a datalist
                var inputContainer = document.createElement("div");
                inputContainer.style.width = "100%";
                this._textInput = document.createElement("input");
                this._textInput.className = this.hostConfig.makeCssClassName("ac-input", "ac-multichoiceInput", "ac-choiceSetInput-filtered");
                this._textInput.type = "text";
                this._textInput.style.width = "100%";
                this._textInput.oninput = function() {
                    _this.valueChanged();
                    if (_this._textInput) {
                        // Remove aria-label when value is not empty so narration software doesn't
                        // read the placeholder
                        if (_this.value) {
                            _this._textInput.removeAttribute("placeholder");
                            _this._textInput.removeAttribute("aria-label");
                        } else if (_this.placeholder) {
                            _this._textInput.placeholder = _this.placeholder;
                            _this._textInput.setAttribute("aria-label", _this.placeholder);
                        }
                    }
                };
                if (this.defaultValue) this._textInput.value = this.defaultValue;
                if (this.placeholder && !this._textInput.value) {
                    this._textInput.placeholder = this.placeholder;
                    this._textInput.setAttribute("aria-label", this.placeholder);
                }
                this._textInput.tabIndex = this.isDesignMode() ? -1 : 0;
                var dataList = document.createElement("datalist");
                dataList.id = $8QA0A.generateUniqueId();
                for(var _i = 0, _a = this.choices; _i < _a.length; _i++){
                    var choice = _a[_i];
                    var option = document.createElement("option");
                    // To fix https://stackoverflow.com/questions/29882361/show-datalist-labels-but-submit-the-actual-value
                    // value is mapped to choice.title other than choice.value
                    if (choice.title) {
                        option.value = choice.title;
                        option.setAttribute("aria-label", choice.title);
                    }
                    option.tabIndex = this.isDesignMode() ? -1 : 0;
                    dataList.appendChild(option);
                }
                this._textInput.setAttribute("list", dataList.id);
                inputContainer.append(this._textInput, dataList);
                return inputContainer;
            } else {
                // Render as a combo box
                this._selectElement = document.createElement("select");
                this._selectElement.className = this.hostConfig.makeCssClassName("ac-input", "ac-multichoiceInput", "ac-choiceSetInput-compact");
                this._selectElement.style.width = "100%";
                this._selectElement.tabIndex = this.isDesignMode() ? -1 : 0;
                var placeholderOption = this.createPlaceholderOptionWhenValueDoesNotExist();
                $8QA0A.appendChild(this._selectElement, placeholderOption);
                for(var _b = 0, _c = this.choices; _b < _c.length; _b++){
                    var choice = _c[_b];
                    var option = document.createElement("option");
                    option.value = choice.value;
                    if (choice.title) {
                        option.text = choice.title;
                        option.setAttribute("aria-label", choice.title);
                    }
                    option.tabIndex = this.isDesignMode() ? -1 : 0;
                    if (choice.value === this.defaultValue) option.selected = true;
                    $8QA0A.appendChild(this._selectElement, option);
                }
                this._selectElement.onchange = function() {
                    _this.internalApplyAriaCurrent();
                    _this.valueChanged();
                };
                this.internalApplyAriaCurrent();
                return this._selectElement;
            }
        }
    };
    ChoiceSetInput.prototype.updateVisualState = function(eventType) {
        if (!this.allowRevealOnHoverStyle) return;
        if (!this.isMultiSelect && this.isCompact) {
            _super.prototype.updateVisualState.call(this, eventType);
            if (this._selectElement && this.inputStyle === $kD48O.InputStyle.RevealOnHover) {
                var hideDropDownPicker = this.shouldHideInputAdornersForRevealOnHover(this._selectElement, eventType);
                if (hideDropDownPicker) {
                    this._selectElement.style.appearance = "none";
                    this._selectElement.classList.remove(this.hostConfig.makeCssClassName("ac-inputStyle-revealOnHover-onfocus"));
                } else {
                    this._selectElement.style.appearance = "auto";
                    this._selectElement.classList.add(this.hostConfig.makeCssClassName("ac-inputStyle-revealOnHover-onfocus"));
                }
            }
        }
    };
    ChoiceSetInput.prototype.getJsonTypeName = function() {
        return "Input.ChoiceSet";
    };
    ChoiceSetInput.prototype.focus = function() {
        if (this._toggleInputs && (this.isMultiSelect || this.style === "expanded")) {
            if (this._toggleInputs.length > 0) this._toggleInputs[0].focus();
        } else if (this._textInput) this._textInput.focus();
        else _super.prototype.focus.call(this);
    };
    ChoiceSetInput.prototype.internalValidateProperties = function(context) {
        _super.prototype.internalValidateProperties.call(this, context);
        if (this.choices.length === 0) context.addFailure(this, $kD48O.ValidationEvent.CollectionCantBeEmpty, $c6BU9.Strings.errors.choiceSetMustHaveAtLeastOneChoice());
        for(var _i = 0, _a = this.choices; _i < _a.length; _i++){
            var choice = _a[_i];
            if (!choice.title || !choice.value) context.addFailure(this, $kD48O.ValidationEvent.PropertyCantBeNull, $c6BU9.Strings.errors.choiceSetChoicesMustHaveTitleAndValue());
        }
    };
    ChoiceSetInput.prototype.isSet = function() {
        return this.value ? true : false;
    };
    ChoiceSetInput.prototype.isValid = function() {
        if (this._textInput) {
            if (this.value === "" || this.value === this.placeholder) return true;
            for(var _i = 0, _a = this.choices; _i < _a.length; _i++){
                var choice = _a[_i];
                if (this.value === choice.value) return true;
            }
            if (this.dynamicChoices) for(var _b = 0, _c = this.dynamicChoices; _b < _c.length; _b++){
                var choice = _c[_b];
                if (this.value === choice) return true;
            }
            return false;
        }
        return _super.prototype.isValid.call(this);
    };
    Object.defineProperty(ChoiceSetInput.prototype, "value", {
        get: function() {
            if (!this.isMultiSelect) {
                if (this._selectElement) return this._selectElement.selectedIndex > 0 ? this._selectElement.value : undefined;
                else if (this._textInput) {
                    for(var _i = 0, _a = this.choices; _i < _a.length; _i++){
                        var choice = _a[_i];
                        if (choice.title && this._textInput.value === choice.title) return choice.value;
                    }
                    return this._textInput.value;
                } else if (this._toggleInputs && this._toggleInputs.length > 0) for(var _b = 0, _c = this._toggleInputs; _b < _c.length; _b++){
                    var toggleInput = _c[_b];
                    if (toggleInput.checked) return toggleInput.value;
                }
                return undefined;
            } else {
                if (!this._toggleInputs || this._toggleInputs.length === 0) return undefined;
                var result = "";
                for(var _d = 0, _f = this._toggleInputs; _d < _f.length; _d++){
                    var toggleInput = _f[_d];
                    if (toggleInput.checked) {
                        if (result !== "") result += this.hostConfig.choiceSetInputValueSeparator;
                        result += toggleInput.value;
                    }
                }
                return result ? result : undefined;
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ChoiceSetInput.prototype, "dynamicChoices", {
        get: function() {
            var _a;
            return (_a = this._filteredChoiceSet) === null || _a === void 0 ? void 0 : _a.dynamicChoices;
        },
        enumerable: false,
        configurable: true
    });
    ChoiceSetInput.valueProperty = new $eZfTX.StringProperty($eZfTX.Versions.v1_0, "value");
    ChoiceSetInput.choicesProperty = new $eZfTX.SerializableObjectCollectionProperty($eZfTX.Versions.v1_0, "choices", $aa728000c38af56f$var$Choice);
    ChoiceSetInput.choicesDataProperty = new $eZfTX.SerializableObjectProperty($eZfTX.Versions.v1_6, "choices.data", $aa728000c38af56f$var$ChoiceSetInputDataQuery);
    ChoiceSetInput.styleProperty = new $eZfTX.ValueSetProperty($eZfTX.Versions.v1_0, "style", [
        {
            value: "compact"
        },
        {
            value: "expanded"
        },
        {
            value: "filtered",
            targetVersion: $eZfTX.Versions.v1_5
        }
    ], "compact");
    ChoiceSetInput.isMultiSelectProperty = new $eZfTX.BoolProperty($eZfTX.Versions.v1_0, "isMultiSelect", false);
    ChoiceSetInput.placeholderProperty = new $eZfTX.StringProperty($eZfTX.Versions.v1_0, "placeholder");
    ChoiceSetInput.wrapProperty = new $eZfTX.BoolProperty($eZfTX.Versions.v1_2, "wrap", false);
    //#endregion
    ChoiceSetInput._uniqueCategoryCounter = 0;
    $aa728000c38af56f$var$__decorate([
        (0, $eZfTX.property)(ChoiceSetInput.valueProperty)
    ], ChoiceSetInput.prototype, "defaultValue", void 0);
    $aa728000c38af56f$var$__decorate([
        (0, $eZfTX.property)(ChoiceSetInput.styleProperty)
    ], ChoiceSetInput.prototype, "style", void 0);
    $aa728000c38af56f$var$__decorate([
        (0, $eZfTX.property)(ChoiceSetInput.isMultiSelectProperty)
    ], ChoiceSetInput.prototype, "isMultiSelect", void 0);
    $aa728000c38af56f$var$__decorate([
        (0, $eZfTX.property)(ChoiceSetInput.placeholderProperty)
    ], ChoiceSetInput.prototype, "placeholder", void 0);
    $aa728000c38af56f$var$__decorate([
        (0, $eZfTX.property)(ChoiceSetInput.wrapProperty)
    ], ChoiceSetInput.prototype, "wrap", void 0);
    $aa728000c38af56f$var$__decorate([
        (0, $eZfTX.property)(ChoiceSetInput.choicesProperty)
    ], ChoiceSetInput.prototype, "choices", void 0);
    $aa728000c38af56f$var$__decorate([
        (0, $eZfTX.property)(ChoiceSetInput.choicesDataProperty)
    ], ChoiceSetInput.prototype, "choicesData", void 0);
    return ChoiceSetInput;
}($aa728000c38af56f$var$Input);
module.exports.ChoiceSetInput = $aa728000c38af56f$var$ChoiceSetInput;
var $aa728000c38af56f$var$FilteredChoiceSet = /** @class */ function() {
    function FilteredChoiceSet(choiceSetId, choices, hostConfig) {
        this._choiceSetId = choiceSetId;
        this._choices = choices;
        this._dynamicChoices = [];
        this._visibleChoiceCount = 0;
        this._hostConfig = hostConfig;
    }
    FilteredChoiceSet.prototype.render = function() {
        var _this = this;
        var choiceSetContainer = document.createElement("div");
        choiceSetContainer.style.position = "relative";
        choiceSetContainer.style.width = "100%";
        this._textInput = document.createElement("input");
        this._textInput.className = this.hostConfig.makeCssClassName("ac-input", "ac-multichoiceInput", "ac-choiceSetInput-filtered");
        this._textInput.type = "text";
        this._textInput.style.width = "100%";
        this._textInput.onkeydown = function(event) {
            if (event.key === "ArrowDown") _this.focusChoice(0);
        };
        this._dropdown = document.createElement("div");
        this._dropdown.style.display = "none";
        this._dropdown.className = this.hostConfig.makeCssClassName("ac-input", "ac-multichoiceInput", "ac-choiceSetInput-filtered-dropdown");
        choiceSetContainer.append(this._textInput, this._dropdown);
        document.onclick = function(event) {
            if (_this._dropdown) {
                var child = _this._dropdown.firstChild;
                while(child && event.target !== child)child = child.nextSibling;
                // Dropdown closes if user clicks outside the choiceset.
                if (child || !(event.target === _this._textInput)) _this._dropdown.style.display = "none";
            }
        };
        this._renderedElement = choiceSetContainer;
    };
    FilteredChoiceSet.prototype.createChoice = function(value, filter, id) {
        var _this = this;
        var choice = document.createElement("span");
        choice.className = this.hostConfig.makeCssClassName("ac-input", "ac-choiceSetInput-choice");
        choice.id = "ac-choiceSetInput-".concat(this._choiceSetId, "-choice-").concat(id);
        choice.innerHTML = value.replace(filter, "<b>".concat(filter, "</b>"));
        choice.tabIndex = -1;
        choice.addEventListener("focusin", function() {
            choice.classList.add("focused");
        });
        choice.addEventListener("focusout", function() {
            choice.classList.remove("focused");
        });
        choice.onclick = function() {
            if (_this._textInput) _this._textInput.value = choice.innerText;
            if (_this._dropdown) _this._dropdown.style.display = "none";
        };
        choice.onkeydown = function(event) {
            if (event.key === "ArrowDown") _this.focusChoice(id + 1);
            else if (event.key === "ArrowUp") _this.focusChoice(id - 1);
            else if (event.key === "Enter") choice.click();
        };
        choice.onmouseover = function() {
            _this.focusChoice(id);
        };
        return choice;
    };
    FilteredChoiceSet.prototype.focusChoice = function(id) {
        var choice = document.getElementById("ac-choiceSetInput-".concat(this._choiceSetId, "-choice-").concat(id));
        if (choice) choice.focus();
        else if (this._textInput) {
            this._textInput.focus();
            var textLength = this._textInput.value.length;
            this._textInput.setSelectionRange(textLength, textLength);
        }
    };
    FilteredChoiceSet.prototype.filterChoices = function(isDynamic) {
        var _a, _b;
        var filter = (_a = this._textInput) === null || _a === void 0 ? void 0 : _a.value.toLowerCase();
        if (filter) {
            var choices = isDynamic ? this._dynamicChoices : this._choices;
            for(var _i = 0, choices_1 = choices; _i < choices_1.length; _i++){
                var choice = choices_1[_i];
                if (choice.title) {
                    var matchIndex = choice.title.toLowerCase().indexOf(filter);
                    if (matchIndex !== -1) {
                        var matchedText = choice.title.substring(matchIndex, matchIndex + filter.length);
                        var choiceContainer = this.createChoice(choice.title, matchedText, this._visibleChoiceCount++);
                        (_b = this._dropdown) === null || _b === void 0 || _b.appendChild(choiceContainer);
                    }
                }
            }
        }
    };
    FilteredChoiceSet.prototype.getStatusIndicator = function(error) {
        if (error) {
            if (!this._errorIndicator) {
                var errorIndicator = document.createElement("div");
                errorIndicator.className = this.hostConfig.makeCssClassName("ac-input", "ac-choiceSetInput-statusIndicator", "ac-choiceSetInput-errorIndicator");
                this._errorIndicator = errorIndicator;
            }
            this._errorIndicator.innerText = error;
            return this._errorIndicator;
        } else {
            if (!this._loadingIndicator) {
                var loadingIndicator = document.createElement("div");
                loadingIndicator.className = this.hostConfig.makeCssClassName("ac-input", "ac-choiceSetInput-statusIndicator");
                this._loadingIndicator = loadingIndicator;
            }
            this._loadingIndicator.innerText = this._visibleChoiceCount === 0 ? "Loading..." : "Loading more...";
            return this._loadingIndicator;
        }
    };
    FilteredChoiceSet.prototype.resetDropdown = function() {
        this._dynamicChoices = [];
        if (this._dropdown) {
            $8QA0A.clearElementChildren(this._dropdown);
            this._visibleChoiceCount = 0;
        }
    };
    FilteredChoiceSet.prototype.showDropdown = function() {
        var _a;
        if ((_a = this._dropdown) === null || _a === void 0 ? void 0 : _a.hasChildNodes) this._dropdown.style.display = "block";
    };
    FilteredChoiceSet.prototype.processStaticChoices = function() {
        this.resetDropdown();
        this.filterChoices();
        this.showDropdown();
    };
    FilteredChoiceSet.prototype.processResponse = function(fetchedChoices) {
        this._dynamicChoices = fetchedChoices;
        this.filterChoices(true);
        if (this._visibleChoiceCount === 0) this.showErrorIndicator("No results found.");
    };
    FilteredChoiceSet.prototype.showLoadingIndicator = function() {
        var _a;
        var loadingIndicator = this.getStatusIndicator();
        (_a = this._dropdown) === null || _a === void 0 || _a.appendChild(loadingIndicator);
        this.showDropdown();
    };
    FilteredChoiceSet.prototype.removeLoadingIndicator = function() {
        var _a, _b;
        if (this._loadingIndicator && ((_a = this._dropdown) === null || _a === void 0 ? void 0 : _a.contains(this._loadingIndicator))) (_b = this._dropdown) === null || _b === void 0 || _b.removeChild(this._loadingIndicator);
    };
    FilteredChoiceSet.prototype.showErrorIndicator = function(error) {
        var _a;
        this.removeLoadingIndicator();
        var errorIndicator = this.getStatusIndicator(error);
        (_a = this._dropdown) === null || _a === void 0 || _a.appendChild(errorIndicator);
    };
    Object.defineProperty(FilteredChoiceSet.prototype, "dynamicChoices", {
        get: function() {
            var _a;
            return (_a = this._dynamicChoices) === null || _a === void 0 ? void 0 : _a.map(function(choice) {
                return choice.title;
            });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FilteredChoiceSet.prototype, "hostConfig", {
        get: function() {
            if (this._hostConfig) return this._hostConfig;
            else {
                if (this.parent) return this.parent.hostConfig;
                else return $lHSNo.defaultHostConfig;
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FilteredChoiceSet.prototype, "parent", {
        get: function() {
            return this._parent;
        },
        set: function(value) {
            this._parent = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FilteredChoiceSet.prototype, "renderedElement", {
        get: function() {
            return this._renderedElement;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FilteredChoiceSet.prototype, "textInput", {
        get: function() {
            return this._textInput;
        },
        enumerable: false,
        configurable: true
    });
    return FilteredChoiceSet;
}();
module.exports.FilteredChoiceSet = $aa728000c38af56f$var$FilteredChoiceSet;
var $aa728000c38af56f$var$NumberInput = /** @class */ function(_super) {
    $aa728000c38af56f$var$__extends(NumberInput, _super);
    function NumberInput() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    NumberInput.prototype.internalRender = function() {
        var _this = this;
        this._numberInputElement = document.createElement("input");
        this._numberInputElement.setAttribute("type", "number");
        if (this.min !== undefined) this._numberInputElement.setAttribute("min", this.min.toString());
        if (this.max !== undefined) this._numberInputElement.setAttribute("max", this.max.toString());
        this._numberInputElement.className = this.hostConfig.makeCssClassName("ac-input", "ac-numberInput");
        this._numberInputElement.style.width = "100%";
        this._numberInputElement.tabIndex = this.isDesignMode() ? -1 : 0;
        if (this.defaultValue !== undefined) this._numberInputElement.valueAsNumber = this.defaultValue;
        if (this.placeholder) {
            this._numberInputElement.placeholder = this.placeholder;
            this._numberInputElement.setAttribute("aria-label", this.placeholder);
        }
        this._numberInputElement.oninput = function() {
            _this.valueChanged();
        };
        return this._numberInputElement;
    };
    NumberInput.prototype.getJsonTypeName = function() {
        return "Input.Number";
    };
    NumberInput.prototype.isSet = function() {
        return this.value !== undefined && !isNaN(this.value);
    };
    NumberInput.prototype.isValid = function() {
        if (this.value === undefined) return !this.isRequired;
        var result = true;
        if (this.min !== undefined) result = result && this.value >= this.min;
        if (this.max !== undefined) result = result && this.value <= this.max;
        return result;
    };
    Object.defineProperty(NumberInput.prototype, "value", {
        get: function() {
            return this._numberInputElement ? this._numberInputElement.valueAsNumber : undefined;
        },
        set: function(value) {
            if (value && this._numberInputElement) this._numberInputElement.value = value.toString();
        },
        enumerable: false,
        configurable: true
    });
    //#region Schema
    NumberInput.valueProperty = new $eZfTX.NumProperty($eZfTX.Versions.v1_0, "value");
    NumberInput.placeholderProperty = new $eZfTX.StringProperty($eZfTX.Versions.v1_0, "placeholder");
    NumberInput.minProperty = new $eZfTX.NumProperty($eZfTX.Versions.v1_0, "min");
    NumberInput.maxProperty = new $eZfTX.NumProperty($eZfTX.Versions.v1_0, "max");
    $aa728000c38af56f$var$__decorate([
        (0, $eZfTX.property)(NumberInput.valueProperty)
    ], NumberInput.prototype, "defaultValue", void 0);
    $aa728000c38af56f$var$__decorate([
        (0, $eZfTX.property)(NumberInput.minProperty)
    ], NumberInput.prototype, "min", void 0);
    $aa728000c38af56f$var$__decorate([
        (0, $eZfTX.property)(NumberInput.maxProperty)
    ], NumberInput.prototype, "max", void 0);
    $aa728000c38af56f$var$__decorate([
        (0, $eZfTX.property)(NumberInput.placeholderProperty)
    ], NumberInput.prototype, "placeholder", void 0);
    return NumberInput;
}($aa728000c38af56f$var$Input);
module.exports.NumberInput = $aa728000c38af56f$var$NumberInput;
var $aa728000c38af56f$var$DateInput = /** @class */ function(_super) {
    $aa728000c38af56f$var$__extends(DateInput, _super);
    function DateInput() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DateInput.prototype.internalRender = function() {
        var _this = this;
        this._dateInputElement = document.createElement("input");
        this._dateInputElement.setAttribute("type", "date");
        if (this.min) this._dateInputElement.setAttribute("min", this.min);
        if (this.max) this._dateInputElement.setAttribute("max", this.max);
        if (this.placeholder) {
            this._dateInputElement.placeholder = this.placeholder;
            this._dateInputElement.setAttribute("aria-label", this.placeholder);
        }
        this._dateInputElement.tabIndex = this.isDesignMode() ? -1 : 0;
        this._dateInputElement.className = this.hostConfig.makeCssClassName("ac-input", "ac-dateInput");
        this._dateInputElement.style.width = "100%";
        this._dateInputElement.oninput = function() {
            _this.valueChanged();
        };
        if (this.defaultValue) this._dateInputElement.value = this.defaultValue;
        return this._dateInputElement;
    };
    DateInput.prototype.updateVisualState = function(eventType) {
        if (!this.allowRevealOnHoverStyle) return;
        _super.prototype.updateVisualState.call(this, eventType);
        if (this._dateInputElement && this.inputStyle === $kD48O.InputStyle.RevealOnHover) {
            var hideDatePicker = this.shouldHideInputAdornersForRevealOnHover(this._dateInputElement, eventType);
            if (hideDatePicker) this._dateInputElement.classList.remove(this.hostConfig.makeCssClassName("ac-inputStyle-revealOnHover-onfocus"));
            else this._dateInputElement.classList.add(this.hostConfig.makeCssClassName("ac-inputStyle-revealOnHover-onfocus"));
            $aa728000c38af56f$var$updateInputAdornersVisibility(this._dateInputElement, hideDatePicker /*hide*/ );
        }
    };
    DateInput.prototype.getJsonTypeName = function() {
        return "Input.Date";
    };
    DateInput.prototype.isSet = function() {
        return this.value ? true : false;
    };
    DateInput.prototype.isValid = function() {
        if (!this.value) return !this.isRequired;
        var valueAsDate = new Date(this.value);
        var result = true;
        if (this.min) {
            var minDate = new Date(this.min);
            result = result && valueAsDate >= minDate;
        }
        if (this.max) {
            var maxDate = new Date(this.max);
            result = result && valueAsDate <= maxDate;
        }
        return result;
    };
    Object.defineProperty(DateInput.prototype, "value", {
        get: function() {
            return this._dateInputElement ? this._dateInputElement.value : undefined;
        },
        enumerable: false,
        configurable: true
    });
    //#region Schema
    DateInput.valueProperty = new $eZfTX.StringProperty($eZfTX.Versions.v1_0, "value");
    DateInput.placeholderProperty = new $eZfTX.StringProperty($eZfTX.Versions.v1_0, "placeholder");
    DateInput.minProperty = new $eZfTX.StringProperty($eZfTX.Versions.v1_0, "min");
    DateInput.maxProperty = new $eZfTX.StringProperty($eZfTX.Versions.v1_0, "max");
    $aa728000c38af56f$var$__decorate([
        (0, $eZfTX.property)(DateInput.valueProperty)
    ], DateInput.prototype, "defaultValue", void 0);
    $aa728000c38af56f$var$__decorate([
        (0, $eZfTX.property)(DateInput.minProperty)
    ], DateInput.prototype, "min", void 0);
    $aa728000c38af56f$var$__decorate([
        (0, $eZfTX.property)(DateInput.maxProperty)
    ], DateInput.prototype, "max", void 0);
    $aa728000c38af56f$var$__decorate([
        (0, $eZfTX.property)(DateInput.placeholderProperty)
    ], DateInput.prototype, "placeholder", void 0);
    return DateInput;
}($aa728000c38af56f$var$Input);
module.exports.DateInput = $aa728000c38af56f$var$DateInput;
var $aa728000c38af56f$var$TimeProperty = /** @class */ function(_super) {
    $aa728000c38af56f$var$__extends(TimeProperty, _super);
    function TimeProperty(targetVersion, name) {
        var _this = _super.call(this, targetVersion, name, function(sender, prop, source, context) {
            var value = source[prop.name];
            if (typeof value === "string" && value && /^[0-9]{2}:[0-9]{2}$/.test(value)) return value;
            return undefined;
        }, function(sender, prop, target, value, context) {
            context.serializeValue(target, prop.name, value);
        }) || this;
        _this.targetVersion = targetVersion;
        _this.name = name;
        return _this;
    }
    return TimeProperty;
}($eZfTX.CustomProperty);
module.exports.TimeProperty = $aa728000c38af56f$var$TimeProperty;
var $aa728000c38af56f$var$TimeInput = /** @class */ function(_super) {
    $aa728000c38af56f$var$__extends(TimeInput, _super);
    function TimeInput() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TimeInput.convertTimeStringToDate = function(timeString) {
        return new Date("1973-09-04T" + timeString + ":00Z");
    };
    TimeInput.prototype.internalRender = function() {
        var _this = this;
        this._timeInputElement = document.createElement("input");
        this._timeInputElement.setAttribute("type", "time");
        if (this.min) this._timeInputElement.setAttribute("min", this.min);
        if (this.max) this._timeInputElement.setAttribute("max", this.max);
        this._timeInputElement.className = this.hostConfig.makeCssClassName("ac-input", "ac-timeInput");
        this._timeInputElement.style.width = "100%";
        this._timeInputElement.oninput = function() {
            _this.valueChanged();
        };
        if (this.placeholder) {
            this._timeInputElement.placeholder = this.placeholder;
            this._timeInputElement.setAttribute("aria-label", this.placeholder);
        }
        this._timeInputElement.tabIndex = this.isDesignMode() ? -1 : 0;
        if (this.defaultValue) this._timeInputElement.value = this.defaultValue;
        return this._timeInputElement;
    };
    TimeInput.prototype.updateVisualState = function(eventType) {
        if (!this.allowRevealOnHoverStyle) return;
        _super.prototype.updateVisualState.call(this, eventType);
        if (this._timeInputElement && this.inputStyle === $kD48O.InputStyle.RevealOnHover) {
            var hideTimePicker = this.shouldHideInputAdornersForRevealOnHover(this._timeInputElement, eventType);
            if (hideTimePicker) this._timeInputElement.classList.remove(this.hostConfig.makeCssClassName("ac-inputStyle-revealOnHover-onfocus"));
            else this._timeInputElement.classList.add(this.hostConfig.makeCssClassName("ac-inputStyle-revealOnHover-onfocus"));
            $aa728000c38af56f$var$updateInputAdornersVisibility(this._timeInputElement, hideTimePicker /*hide*/ );
        }
    };
    TimeInput.prototype.getJsonTypeName = function() {
        return "Input.Time";
    };
    TimeInput.prototype.isSet = function() {
        return this.value ? true : false;
    };
    TimeInput.prototype.isValid = function() {
        if (!this.value) return !this.isRequired;
        var valueAsDate = TimeInput.convertTimeStringToDate(this.value);
        var result = true;
        if (this.min) {
            var minDate = TimeInput.convertTimeStringToDate(this.min);
            result = result && valueAsDate >= minDate;
        }
        if (this.max) {
            var maxDate = TimeInput.convertTimeStringToDate(this.max);
            result = result && valueAsDate <= maxDate;
        }
        return result;
    };
    Object.defineProperty(TimeInput.prototype, "value", {
        get: function() {
            return this._timeInputElement ? this._timeInputElement.value : undefined;
        },
        enumerable: false,
        configurable: true
    });
    //#region Schema
    TimeInput.valueProperty = new $aa728000c38af56f$var$TimeProperty($eZfTX.Versions.v1_0, "value");
    TimeInput.placeholderProperty = new $eZfTX.StringProperty($eZfTX.Versions.v1_0, "placeholder");
    TimeInput.minProperty = new $aa728000c38af56f$var$TimeProperty($eZfTX.Versions.v1_0, "min");
    TimeInput.maxProperty = new $aa728000c38af56f$var$TimeProperty($eZfTX.Versions.v1_0, "max");
    $aa728000c38af56f$var$__decorate([
        (0, $eZfTX.property)(TimeInput.valueProperty)
    ], TimeInput.prototype, "defaultValue", void 0);
    $aa728000c38af56f$var$__decorate([
        (0, $eZfTX.property)(TimeInput.minProperty)
    ], TimeInput.prototype, "min", void 0);
    $aa728000c38af56f$var$__decorate([
        (0, $eZfTX.property)(TimeInput.maxProperty)
    ], TimeInput.prototype, "max", void 0);
    $aa728000c38af56f$var$__decorate([
        (0, $eZfTX.property)(TimeInput.placeholderProperty)
    ], TimeInput.prototype, "placeholder", void 0);
    return TimeInput;
}($aa728000c38af56f$var$Input);
module.exports.TimeInput = $aa728000c38af56f$var$TimeInput;
var $aa728000c38af56f$var$Action = /** @class */ function(_super) {
    $aa728000c38af56f$var$__extends(Action, _super);
    function Action() {
        //#region Schema
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.style = $kD48O.ActionStyle.Default;
        _this.mode = $kD48O.ActionMode.Primary;
        _this._state = 0 /* Normal */ ;
        _this._isFocusable = true;
        return _this;
    }
    //#endregion
    Action.prototype.renderButtonContent = function() {
        if (this.renderedElement) {
            // Cache hostConfig for perf
            var hostConfig = this.hostConfig;
            var titleElement = document.createElement("div");
            titleElement.style.overflow = "hidden";
            titleElement.style.textOverflow = "ellipsis";
            if (!(hostConfig.actions.iconPlacement === $kD48O.ActionIconPlacement.AboveTitle || hostConfig.actions.allowTitleToWrap)) titleElement.style.whiteSpace = "nowrap";
            if (this.title) titleElement.innerText = this.title;
            if (!this.iconUrl) {
                this.renderedElement.classList.add("noIcon");
                this.renderedElement.appendChild(titleElement);
            } else {
                var iconElement = document.createElement("img");
                iconElement.src = this.iconUrl;
                iconElement.style.width = hostConfig.actions.iconSize + "px";
                iconElement.style.height = hostConfig.actions.iconSize + "px";
                iconElement.style.flex = "0 0 auto";
                if (hostConfig.actions.iconPlacement === $kD48O.ActionIconPlacement.AboveTitle) {
                    this.renderedElement.classList.add("iconAbove");
                    this.renderedElement.style.flexDirection = "column";
                    if (this.title) iconElement.style.marginBottom = "6px";
                } else {
                    this.renderedElement.classList.add("iconLeft");
                    iconElement.style.maxHeight = "100%";
                    if (this.title) iconElement.style.marginRight = "6px";
                }
                this.renderedElement.appendChild(iconElement);
                this.renderedElement.appendChild(titleElement);
            }
        }
    };
    Action.prototype.getParentContainer = function() {
        if (this.parent instanceof $aa728000c38af56f$var$Container) return this.parent;
        return this.parent ? this.parent.getParentContainer() : undefined;
    };
    Action.prototype.isDesignMode = function() {
        var rootElement = this.getRootObject();
        return rootElement instanceof $aa728000c38af56f$var$CardElement && rootElement.isDesignMode();
    };
    Action.prototype.updateCssClasses = function() {
        var _a, _b;
        if (this.parent && this.renderedElement) {
            var hostConfig = this.parent.hostConfig;
            this.renderedElement.className = hostConfig.makeCssClassName(this.isEffectivelyEnabled() ? "ac-pushButton" : "ac-pushButton-disabled");
            var parentContainer = this.getParentContainer();
            if (parentContainer) {
                var parentContainerStyle = parentContainer.getEffectiveStyle();
                if (parentContainerStyle) this.renderedElement.classList.add("style-" + parentContainerStyle);
            }
            this.renderedElement.tabIndex = !this.isDesignMode() && this.isFocusable ? 0 : -1;
            switch(this._state){
                case 0 /* Normal */ :
                    break;
                case 1 /* Expanded */ :
                    this.renderedElement.classList.add(hostConfig.makeCssClassName("expanded"));
                    break;
                case 2 /* Subdued */ :
                    this.renderedElement.classList.add(hostConfig.makeCssClassName("subdued"));
                    break;
            }
            if (this.style && this.isEffectivelyEnabled()) {
                if (this.style === $kD48O.ActionStyle.Positive) (_a = this.renderedElement.classList).add.apply(_a, hostConfig.makeCssClassNames("primary", "style-positive"));
                else (_b = this.renderedElement.classList).add.apply(_b, hostConfig.makeCssClassNames("style-" + this.style.toLowerCase()));
            }
        }
    };
    Action.prototype.getDefaultSerializationContext = function() {
        return new $aa728000c38af56f$var$SerializationContext();
    };
    Action.prototype.internalGetReferencedInputs = function() {
        return {};
    };
    Action.prototype.internalPrepareForExecution = function(_inputs) {
    // Do nothing in base implementation
    };
    Action.prototype.internalValidateInputs = function(referencedInputs) {
        var result = [];
        if (referencedInputs) for(var _i = 0, _a = Object.keys(referencedInputs); _i < _a.length; _i++){
            var key = _a[_i];
            var input = referencedInputs[key];
            if (!input.validateValue()) result.push(input);
        }
        return result;
    };
    Action.prototype.shouldSerialize = function(context) {
        return context.actionRegistry.findByName(this.getJsonTypeName()) !== undefined;
    };
    Action.prototype.raiseExecuteActionEvent = function() {
        if (this.onExecute) this.onExecute(this);
        $aa728000c38af56f$var$raiseExecuteActionEvent(this);
    };
    Action.prototype.internalAfterExecute = function() {
        var rootObject = this.getRootObject();
        if (rootObject instanceof $aa728000c38af56f$var$CardElement) rootObject.updateActionsEnabledState();
    };
    Action.prototype.getHref = function() {
        return "";
    };
    Action.prototype.getAriaRole = function() {
        var ariaRole = this.getAriaRoleFromEnum();
        return ariaRole !== null && ariaRole !== void 0 ? ariaRole : "button";
    };
    Action.prototype.getAriaRoleFromEnum = function() {
        switch(this.role){
            case $kD48O.ActionRole.Button:
                return "button";
            case $kD48O.ActionRole.Link:
                return "link";
            case $kD48O.ActionRole.Menu:
                return "menu";
            case $kD48O.ActionRole.MenuItem:
                return "menuitem";
            case $kD48O.ActionRole.Tab:
                return "tab";
            default:
                return undefined;
        }
    };
    Action.prototype.setupElementForAccessibility = function(element, promoteTooltipToLabel) {
        if (promoteTooltipToLabel === void 0) promoteTooltipToLabel = false;
        element.tabIndex = this.isEffectivelyEnabled() && !this.isDesignMode() ? 0 : -1;
        element.setAttribute("role", this.getAriaRole());
        if (element instanceof HTMLButtonElement) element.disabled = !this.isEffectivelyEnabled();
        if (!this.isEffectivelyEnabled()) element.setAttribute("aria-disabled", "true");
        else {
            element.removeAttribute("aria-disabled");
            element.classList.add(this.hostConfig.makeCssClassName("ac-selectable"));
        }
        if (this.title) {
            element.setAttribute("aria-label", this.title);
            element.title = this.title;
        } else {
            element.removeAttribute("aria-label");
            element.removeAttribute("title");
        }
        if (this.tooltip) {
            if (promoteTooltipToLabel && !this.title) element.setAttribute("aria-label", this.tooltip);
            element.title = this.tooltip;
        }
    };
    Action.prototype.parse = function(source, context) {
        return _super.prototype.parse.call(this, source, context ? context : new $aa728000c38af56f$var$SerializationContext());
    };
    Action.prototype.render = function() {
        var _this = this;
        var buttonElement = document.createElement("button");
        buttonElement.type = "button";
        buttonElement.style.display = "flex";
        buttonElement.style.alignItems = "center";
        buttonElement.style.justifyContent = "center";
        buttonElement.onclick = function(e) {
            if (_this.isEffectivelyEnabled()) {
                e.preventDefault();
                e.cancelBubble = true;
                _this.execute();
            }
        };
        this._renderedElement = buttonElement;
        this.renderButtonContent();
        this.updateCssClasses();
        this.setupElementForAccessibility(buttonElement);
    };
    Action.prototype.execute = function() {
        if (this._actionCollection) this._actionCollection.actionExecuted(this);
        this.raiseExecuteActionEvent();
        this.internalAfterExecute();
    };
    Action.prototype.prepareForExecution = function() {
        var referencedInputs = this.getReferencedInputs();
        var invalidInputs = this.internalValidateInputs(referencedInputs);
        if (invalidInputs.length > 0) {
            invalidInputs[0].focus();
            return false;
        }
        this.internalPrepareForExecution(referencedInputs);
        return true;
    };
    Action.prototype.remove = function() {
        if (this._actionCollection) return this._actionCollection.removeAction(this);
        return false;
    };
    Action.prototype.getAllInputs = function(processActions) {
        if (processActions === void 0) processActions = true;
        return [];
    };
    Action.prototype.getAllActions = function() {
        return [
            this
        ];
    };
    Action.prototype.getResourceInformation = function() {
        return this.iconUrl ? [
            {
                url: this.iconUrl,
                mimeType: "image"
            }
        ] : [];
    };
    Action.prototype.getActionById = function(id) {
        return this.id === id ? this : undefined;
    };
    Action.prototype.getReferencedInputs = function() {
        return this.internalGetReferencedInputs();
    };
    /**
     * Validates the inputs associated with this action.
     *
     * @returns A list of inputs that failed validation, or an empty array if no input failed validation.
     */ Action.prototype.validateInputs = function() {
        return this.internalValidateInputs(this.getReferencedInputs());
    };
    Action.prototype.updateEnabledState = function() {
    // Do nothing in base implementation
    };
    Action.prototype.isEffectivelyEnabled = function() {
        return this.isEnabled;
    };
    Object.defineProperty(Action.prototype, "isPrimary", {
        get: function() {
            return this.style === $kD48O.ActionStyle.Positive;
        },
        set: function(value) {
            if (value) this.style = $kD48O.ActionStyle.Positive;
            else if (this.style === $kD48O.ActionStyle.Positive) this.style = $kD48O.ActionStyle.Default;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Action.prototype, "hostConfig", {
        get: function() {
            return this.parent ? this.parent.hostConfig : $lHSNo.defaultHostConfig;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Action.prototype, "parent", {
        get: function() {
            return this._parent;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Action.prototype, "state", {
        get: function() {
            return this._state;
        },
        set: function(value) {
            if (this._state !== value) {
                this._state = value;
                this.updateCssClasses();
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Action.prototype, "isFocusable", {
        get: function() {
            return this._isFocusable;
        },
        set: function(value) {
            if (this._isFocusable !== value) {
                this._isFocusable = value;
                this.updateCssClasses();
            }
        },
        enumerable: false,
        configurable: true
    });
    Action.titleProperty = new $eZfTX.StringProperty($eZfTX.Versions.v1_0, "title");
    Action.iconUrlProperty = new $eZfTX.StringProperty($eZfTX.Versions.v1_1, "iconUrl");
    Action.styleProperty = new $eZfTX.ValueSetProperty($eZfTX.Versions.v1_2, "style", [
        {
            value: $kD48O.ActionStyle.Default
        },
        {
            value: $kD48O.ActionStyle.Positive
        },
        {
            value: $kD48O.ActionStyle.Destructive
        }
    ], $kD48O.ActionStyle.Default);
    Action.modeProperty = new $eZfTX.ValueSetProperty($eZfTX.Versions.v1_5, "mode", [
        {
            value: $kD48O.ActionMode.Primary
        },
        {
            value: $kD48O.ActionMode.Secondary
        }
    ], $kD48O.ActionMode.Primary);
    Action.tooltipProperty = new $eZfTX.StringProperty($eZfTX.Versions.v1_5, "tooltip");
    Action.isEnabledProperty = new $eZfTX.BoolProperty($eZfTX.Versions.v1_5, "isEnabled", true);
    Action.roleProperty = new $eZfTX.EnumProperty($eZfTX.Versions.v1_6, "role", $kD48O.ActionRole);
    $aa728000c38af56f$var$__decorate([
        (0, $eZfTX.property)(Action.titleProperty)
    ], Action.prototype, "title", void 0);
    $aa728000c38af56f$var$__decorate([
        (0, $eZfTX.property)(Action.iconUrlProperty)
    ], Action.prototype, "iconUrl", void 0);
    $aa728000c38af56f$var$__decorate([
        (0, $eZfTX.property)(Action.styleProperty)
    ], Action.prototype, "style", void 0);
    $aa728000c38af56f$var$__decorate([
        (0, $eZfTX.property)(Action.modeProperty)
    ], Action.prototype, "mode", void 0);
    $aa728000c38af56f$var$__decorate([
        (0, $eZfTX.property)(Action.tooltipProperty)
    ], Action.prototype, "tooltip", void 0);
    $aa728000c38af56f$var$__decorate([
        (0, $eZfTX.property)(Action.isEnabledProperty)
    ], Action.prototype, "isEnabled", void 0);
    $aa728000c38af56f$var$__decorate([
        (0, $eZfTX.property)(Action.roleProperty)
    ], Action.prototype, "role", void 0);
    return Action;
}($01FSm.CardObject);
module.exports.Action = $aa728000c38af56f$var$Action;
var $aa728000c38af56f$var$SubmitActionBase = /** @class */ function(_super) {
    $aa728000c38af56f$var$__extends(SubmitActionBase, _super);
    function SubmitActionBase() {
        //#region Schema
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.disabledUnlessAssociatedInputsChange = false;
        //#endregion
        _this._isPrepared = false;
        _this._areReferencedInputsDirty = false;
        return _this;
    }
    SubmitActionBase.prototype.internalGetReferencedInputs = function() {
        var result = {};
        if (this.associatedInputs !== "none") {
            var current = this.parent;
            var inputs = [];
            while(current){
                inputs.push.apply(inputs, current.getAllInputs(false));
                current = current.parent;
            }
            for(var _i = 0, inputs_1 = inputs; _i < inputs_1.length; _i++){
                var input = inputs_1[_i];
                if (input.id) result[input.id] = input;
            }
        }
        return result;
    };
    SubmitActionBase.prototype.internalPrepareForExecution = function(inputs) {
        if (this._originalData) this._processedData = JSON.parse(JSON.stringify(this._originalData));
        else this._processedData = {};
        if (this._processedData && inputs) for(var _i = 0, _a = Object.keys(inputs); _i < _a.length; _i++){
            var key = _a[_i];
            var input = inputs[key];
            if (input.id && input.isSet()) this._processedData[input.id] = typeof input.value === "string" ? input.value : input.value.toString();
        }
        this._isPrepared = true;
    };
    SubmitActionBase.prototype.internalAfterExecute = function() {
        if ($8Lw6d.GlobalSettings.resetInputsDirtyStateAfterActionExecution) this.resetReferencedInputsDirtyState();
    };
    SubmitActionBase.prototype.resetReferencedInputsDirtyState = function() {
        var referencedInputs = this.getReferencedInputs();
        this._areReferencedInputsDirty = false;
        if (referencedInputs) for(var _i = 0, _a = Object.keys(referencedInputs); _i < _a.length; _i++){
            var key = _a[_i];
            var input = referencedInputs[key];
            input.resetDirtyState();
        }
    };
    SubmitActionBase.prototype.updateEnabledState = function() {
        this._areReferencedInputsDirty = false;
        var referencedInputs = this.getReferencedInputs();
        if (referencedInputs) for(var _i = 0, _a = Object.keys(referencedInputs); _i < _a.length; _i++){
            var key = _a[_i];
            var input = referencedInputs[key];
            if (input.isDirty()) {
                this._areReferencedInputsDirty = true;
                break;
            }
        }
        this.updateCssClasses();
        if (this._renderedElement) this.setupElementForAccessibility(this._renderedElement);
    };
    SubmitActionBase.prototype.isEffectivelyEnabled = function() {
        var result = _super.prototype.isEffectivelyEnabled.call(this);
        return this.disabledUnlessAssociatedInputsChange ? result && this._areReferencedInputsDirty : result;
    };
    Object.defineProperty(SubmitActionBase.prototype, "data", {
        get: function() {
            return this._isPrepared ? this._processedData : this._originalData;
        },
        set: function(value) {
            this._originalData = value;
            this._isPrepared = false;
        },
        enumerable: false,
        configurable: true
    });
    SubmitActionBase.dataProperty = new $eZfTX.PropertyDefinition($eZfTX.Versions.v1_0, "data");
    SubmitActionBase.associatedInputsProperty = new $eZfTX.CustomProperty($eZfTX.Versions.v1_3, "associatedInputs", function(sender, prop, source, context) {
        var value = source[prop.name];
        if (value !== undefined && typeof value === "string") return value.toLowerCase() === "none" ? "none" : "auto";
        return undefined;
    }, function(sender, prop, target, value, context) {
        context.serializeValue(target, prop.name, value);
    });
    SubmitActionBase.disabledUnlessAssociatedInputsChangeProperty = new $eZfTX.BoolProperty($eZfTX.Versions.v1_6, "disabledUnlessAssociatedInputsChange", false);
    $aa728000c38af56f$var$__decorate([
        (0, $eZfTX.property)(SubmitActionBase.dataProperty)
    ], SubmitActionBase.prototype, "_originalData", void 0);
    $aa728000c38af56f$var$__decorate([
        (0, $eZfTX.property)(SubmitActionBase.associatedInputsProperty)
    ], SubmitActionBase.prototype, "associatedInputs", void 0);
    $aa728000c38af56f$var$__decorate([
        (0, $eZfTX.property)(SubmitActionBase.disabledUnlessAssociatedInputsChangeProperty)
    ], SubmitActionBase.prototype, "disabledUnlessAssociatedInputsChange", void 0);
    return SubmitActionBase;
}($aa728000c38af56f$var$Action);
module.exports.SubmitActionBase = $aa728000c38af56f$var$SubmitActionBase;
var $aa728000c38af56f$var$SubmitAction = /** @class */ function(_super) {
    $aa728000c38af56f$var$__extends(SubmitAction, _super);
    function SubmitAction() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SubmitAction.prototype.getJsonTypeName = function() {
        return SubmitAction.JsonTypeName;
    };
    // Note the "weird" way this field is declared is to work around a breaking
    // change introduced in TS 3.1 wrt d.ts generation. DO NOT CHANGE
    SubmitAction.JsonTypeName = "Action.Submit";
    return SubmitAction;
}($aa728000c38af56f$var$SubmitActionBase);
module.exports.SubmitAction = $aa728000c38af56f$var$SubmitAction;
var $aa728000c38af56f$var$UniversalAction = /** @class */ function(_super) {
    $aa728000c38af56f$var$__extends(UniversalAction, _super);
    function UniversalAction() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return UniversalAction;
}($aa728000c38af56f$var$SubmitActionBase);
module.exports.UniversalAction = $aa728000c38af56f$var$UniversalAction;
var $aa728000c38af56f$var$ExecuteAction = /** @class */ function(_super) {
    $aa728000c38af56f$var$__extends(ExecuteAction, _super);
    function ExecuteAction() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    //#endregion
    ExecuteAction.prototype.getJsonTypeName = function() {
        return ExecuteAction.JsonTypeName;
    };
    // Note the "weird" way this field is declared is to work around a breaking
    // change introduced in TS 3.1 wrt d.ts generation. DO NOT CHANGE
    ExecuteAction.JsonTypeName = "Action.Execute";
    //#region Schema
    ExecuteAction.verbProperty = new $eZfTX.StringProperty($eZfTX.Versions.v1_4, "verb");
    $aa728000c38af56f$var$__decorate([
        (0, $eZfTX.property)(ExecuteAction.verbProperty)
    ], ExecuteAction.prototype, "verb", void 0);
    return ExecuteAction;
}($aa728000c38af56f$var$UniversalAction);
module.exports.ExecuteAction = $aa728000c38af56f$var$ExecuteAction;
var $aa728000c38af56f$var$DataQuery = /** @class */ function(_super) {
    $aa728000c38af56f$var$__extends(DataQuery, _super);
    function DataQuery() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    //#endregion
    DataQuery.prototype.getJsonTypeName = function() {
        return DataQuery.JsonTypeName;
    };
    Object.defineProperty(DataQuery.prototype, "isStandalone", {
        get: function() {
            return false;
        },
        enumerable: false,
        configurable: true
    });
    // Note the "weird" way this field is declared is to work around a breaking
    // change introduced in TS 3.1 wrt d.ts generation. DO NOT CHANGE
    DataQuery.JsonTypeName = "Data.Query";
    //#region Schema
    DataQuery.datasetProperty = new $eZfTX.StringProperty($eZfTX.Versions.v1_6, "dataset");
    DataQuery.filterProperty = new $eZfTX.StringProperty($eZfTX.Versions.v1_6, "filter");
    $aa728000c38af56f$var$__decorate([
        (0, $eZfTX.property)(DataQuery.datasetProperty)
    ], DataQuery.prototype, "dataset", void 0);
    $aa728000c38af56f$var$__decorate([
        (0, $eZfTX.property)(DataQuery.filterProperty)
    ], DataQuery.prototype, "filter", void 0);
    return DataQuery;
}($aa728000c38af56f$var$UniversalAction);
module.exports.DataQuery = $aa728000c38af56f$var$DataQuery;
var $aa728000c38af56f$var$OpenUrlAction = /** @class */ function(_super) {
    $aa728000c38af56f$var$__extends(OpenUrlAction, _super);
    function OpenUrlAction() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    OpenUrlAction.prototype.getJsonTypeName = function() {
        return OpenUrlAction.JsonTypeName;
    };
    OpenUrlAction.prototype.getAriaRole = function() {
        var ariaRole = this.getAriaRoleFromEnum();
        return ariaRole !== null && ariaRole !== void 0 ? ariaRole : "link";
    };
    OpenUrlAction.prototype.internalValidateProperties = function(context) {
        _super.prototype.internalValidateProperties.call(this, context);
        if (!this.url) context.addFailure(this, $kD48O.ValidationEvent.PropertyCantBeNull, $c6BU9.Strings.errors.propertyMustBeSet("url"));
    };
    OpenUrlAction.prototype.getHref = function() {
        return this.url;
    };
    //#region Schema
    OpenUrlAction.urlProperty = new $eZfTX.StringProperty($eZfTX.Versions.v1_0, "url");
    //#endregion
    // Note the "weird" way this field is declared is to work around a breaking
    // change introduced in TS 3.1 wrt d.ts generation. DO NOT CHANGE
    OpenUrlAction.JsonTypeName = "Action.OpenUrl";
    $aa728000c38af56f$var$__decorate([
        (0, $eZfTX.property)(OpenUrlAction.urlProperty)
    ], OpenUrlAction.prototype, "url", void 0);
    return OpenUrlAction;
}($aa728000c38af56f$var$Action);
module.exports.OpenUrlAction = $aa728000c38af56f$var$OpenUrlAction;
var $aa728000c38af56f$var$ToggleVisibilityAction = /** @class */ function(_super) {
    $aa728000c38af56f$var$__extends(ToggleVisibilityAction, _super);
    function ToggleVisibilityAction() {
        //#region Schema
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.targetElements = {};
        return _this;
    }
    ToggleVisibilityAction.prototype.updateAriaControlsAttribute = function() {
        // apply aria labels to make it clear which elements this action will toggle
        if (this.targetElements) {
            var elementIds = Object.keys(this.targetElements);
            if (this._renderedElement) {
                if (elementIds.length > 0) this._renderedElement.setAttribute("aria-controls", elementIds.join(" "));
                else this._renderedElement.removeAttribute("aria-controls");
            }
        }
    };
    ToggleVisibilityAction.prototype.internalValidateProperties = function(context) {
        _super.prototype.internalValidateProperties.call(this, context);
        if (!this.targetElements) context.addFailure(this, $kD48O.ValidationEvent.PropertyCantBeNull, $c6BU9.Strings.errors.propertyMustBeSet("targetElements"));
    };
    ToggleVisibilityAction.prototype.getJsonTypeName = function() {
        return ToggleVisibilityAction.JsonTypeName;
    };
    ToggleVisibilityAction.prototype.render = function() {
        _super.prototype.render.call(this);
        this.updateAriaControlsAttribute();
    };
    ToggleVisibilityAction.prototype.execute = function() {
        _super.prototype.execute.call(this);
        if (this.parent) for(var _i = 0, _a = Object.keys(this.targetElements); _i < _a.length; _i++){
            var elementId = _a[_i];
            var targetElement = this.parent.getRootElement().getElementById(elementId);
            if (targetElement) {
                if (typeof this.targetElements[elementId] === "boolean") targetElement.isVisible = this.targetElements[elementId];
                else targetElement.isVisible = !targetElement.isVisible;
            }
        }
    };
    ToggleVisibilityAction.prototype.addTargetElement = function(elementId, isVisible) {
        if (isVisible === void 0) isVisible = undefined;
        this.targetElements[elementId] = isVisible;
        this.updateAriaControlsAttribute();
    };
    ToggleVisibilityAction.prototype.removeTargetElement = function(elementId) {
        delete this.targetElements[elementId];
        this.updateAriaControlsAttribute();
    };
    ToggleVisibilityAction.targetElementsProperty = new $eZfTX.CustomProperty($eZfTX.Versions.v1_2, "targetElements", function(sender, prop, source, context) {
        var result = {};
        if (Array.isArray(source[prop.name])) for(var _i = 0, _a = source[prop.name]; _i < _a.length; _i++){
            var item = _a[_i];
            if (typeof item === "string") result[item] = undefined;
            else if (typeof item === "object") {
                var elementId = item["elementId"];
                if (typeof elementId === "string") result[elementId] = $8QA0A.parseBool(item["isVisible"]);
            }
        }
        return result;
    }, function(sender, prop, target, value, context) {
        var targetElements = [];
        for(var _i = 0, _a = Object.keys(value); _i < _a.length; _i++){
            var id = _a[_i];
            if (typeof value[id] === "boolean") targetElements.push({
                elementId: id,
                isVisible: value[id]
            });
            else targetElements.push(id);
        }
        context.serializeArray(target, prop.name, targetElements);
    }, {}, function(sender) {
        return {};
    });
    //#endregion
    // Note the "weird" way this field is declared is to work around a breaking
    // change introduced in TS 3.1 wrt d.ts generation. DO NOT CHANGE
    ToggleVisibilityAction.JsonTypeName = "Action.ToggleVisibility";
    $aa728000c38af56f$var$__decorate([
        (0, $eZfTX.property)(ToggleVisibilityAction.targetElementsProperty)
    ], ToggleVisibilityAction.prototype, "targetElements", void 0);
    return ToggleVisibilityAction;
}($aa728000c38af56f$var$Action);
module.exports.ToggleVisibilityAction = $aa728000c38af56f$var$ToggleVisibilityAction;
var $aa728000c38af56f$var$StringWithSubstitutionProperty = /** @class */ function(_super) {
    $aa728000c38af56f$var$__extends(StringWithSubstitutionProperty, _super);
    function StringWithSubstitutionProperty(targetVersion, name) {
        var _this = _super.call(this, targetVersion, name, undefined, function() {
            return new $8Lw6d.StringWithSubstitutions();
        }) || this;
        _this.targetVersion = targetVersion;
        _this.name = name;
        return _this;
    }
    StringWithSubstitutionProperty.prototype.parse = function(sender, source, context) {
        var result = new $8Lw6d.StringWithSubstitutions();
        result.set($8QA0A.parseString(source[this.name]));
        return result;
    };
    StringWithSubstitutionProperty.prototype.toJSON = function(sender, target, value, context) {
        context.serializeValue(target, this.name, value.getOriginal());
    };
    return StringWithSubstitutionProperty;
}($eZfTX.PropertyDefinition);
var $aa728000c38af56f$var$HttpHeader = /** @class */ function(_super) {
    $aa728000c38af56f$var$__extends(HttpHeader, _super);
    //#endregion
    function HttpHeader(name, value) {
        if (name === void 0) name = "";
        if (value === void 0) value = "";
        var _this = _super.call(this) || this;
        _this.name = name;
        _this.value = value;
        return _this;
    }
    HttpHeader.prototype.getSchemaKey = function() {
        return "HttpHeader";
    };
    HttpHeader.prototype.getReferencedInputs = function(inputs, referencedInputs) {
        this._value.getReferencedInputs(inputs, referencedInputs);
    };
    HttpHeader.prototype.prepareForExecution = function(inputs) {
        this._value.substituteInputValues(inputs, $8Lw6d.ContentTypes.applicationXWwwFormUrlencoded);
    };
    Object.defineProperty(HttpHeader.prototype, "value", {
        get: function() {
            return this._value.get();
        },
        set: function(newValue) {
            this._value.set(newValue);
        },
        enumerable: false,
        configurable: true
    });
    //#region Schema
    HttpHeader.nameProperty = new $eZfTX.StringProperty($eZfTX.Versions.v1_0, "name");
    HttpHeader.valueProperty = new $aa728000c38af56f$var$StringWithSubstitutionProperty($eZfTX.Versions.v1_0, "value");
    $aa728000c38af56f$var$__decorate([
        (0, $eZfTX.property)(HttpHeader.nameProperty)
    ], HttpHeader.prototype, "name", void 0);
    $aa728000c38af56f$var$__decorate([
        (0, $eZfTX.property)(HttpHeader.valueProperty)
    ], HttpHeader.prototype, "_value", void 0);
    return HttpHeader;
}($eZfTX.SerializableObject);
module.exports.HttpHeader = $aa728000c38af56f$var$HttpHeader;
var $aa728000c38af56f$var$HttpAction = /** @class */ function(_super) {
    $aa728000c38af56f$var$__extends(HttpAction, _super);
    function HttpAction() {
        //#region Schema
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._ignoreInputValidation = false;
        return _this;
    }
    HttpAction.prototype.internalGetReferencedInputs = function() {
        var allInputs = this.parent ? this.parent.getRootElement().getAllInputs() : [];
        var result = {};
        this._url.getReferencedInputs(allInputs, result);
        for(var _i = 0, _a = this.headers; _i < _a.length; _i++){
            var header = _a[_i];
            header.getReferencedInputs(allInputs, result);
        }
        this._body.getReferencedInputs(allInputs, result);
        return result;
    };
    HttpAction.prototype.internalPrepareForExecution = function(inputs) {
        if (inputs) {
            this._url.substituteInputValues(inputs, $8Lw6d.ContentTypes.applicationXWwwFormUrlencoded);
            var contentType = $8Lw6d.ContentTypes.applicationJson;
            for(var _i = 0, _a = this.headers; _i < _a.length; _i++){
                var header = _a[_i];
                header.prepareForExecution(inputs);
                if (header.name && header.name.toLowerCase() === "content-type") contentType = header.value;
            }
            this._body.substituteInputValues(inputs, contentType);
        }
    };
    HttpAction.prototype.getJsonTypeName = function() {
        return HttpAction.JsonTypeName;
    };
    HttpAction.prototype.internalValidateProperties = function(context) {
        _super.prototype.internalValidateProperties.call(this, context);
        if (!this.url) context.addFailure(this, $kD48O.ValidationEvent.PropertyCantBeNull, $c6BU9.Strings.errors.propertyMustBeSet("url"));
        if (this.headers.length > 0) for(var _i = 0, _a = this.headers; _i < _a.length; _i++){
            var header = _a[_i];
            if (!header.name) context.addFailure(this, $kD48O.ValidationEvent.PropertyCantBeNull, $c6BU9.Strings.errors.actionHttpHeadersMustHaveNameAndValue());
        }
    };
    Object.defineProperty(HttpAction.prototype, "ignoreInputValidation", {
        get: function() {
            return this._ignoreInputValidation;
        },
        set: function(value) {
            this._ignoreInputValidation = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(HttpAction.prototype, "url", {
        get: function() {
            return this._url.get();
        },
        set: function(value) {
            this._url.set(value);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(HttpAction.prototype, "body", {
        get: function() {
            return this._body.get();
        },
        set: function(value) {
            this._body.set(value);
        },
        enumerable: false,
        configurable: true
    });
    HttpAction.urlProperty = new $aa728000c38af56f$var$StringWithSubstitutionProperty($eZfTX.Versions.v1_0, "url");
    HttpAction.bodyProperty = new $aa728000c38af56f$var$StringWithSubstitutionProperty($eZfTX.Versions.v1_0, "body");
    HttpAction.methodProperty = new $eZfTX.StringProperty($eZfTX.Versions.v1_0, "method");
    HttpAction.headersProperty = new $eZfTX.SerializableObjectCollectionProperty($eZfTX.Versions.v1_0, "headers", $aa728000c38af56f$var$HttpHeader);
    HttpAction.ignoreInputValidationProperty = new $eZfTX.BoolProperty($eZfTX.Versions.v1_3, "ignoreInputValidation", false);
    //#endregion
    // Note the "weird" way this field is declared is to work around a breaking
    // change introduced in TS 3.1 wrt d.ts generation. DO NOT CHANGE
    HttpAction.JsonTypeName = "Action.Http";
    $aa728000c38af56f$var$__decorate([
        (0, $eZfTX.property)(HttpAction.urlProperty)
    ], HttpAction.prototype, "_url", void 0);
    $aa728000c38af56f$var$__decorate([
        (0, $eZfTX.property)(HttpAction.bodyProperty)
    ], HttpAction.prototype, "_body", void 0);
    $aa728000c38af56f$var$__decorate([
        (0, $eZfTX.property)(HttpAction.methodProperty)
    ], HttpAction.prototype, "method", void 0);
    $aa728000c38af56f$var$__decorate([
        (0, $eZfTX.property)(HttpAction.headersProperty)
    ], HttpAction.prototype, "headers", void 0);
    $aa728000c38af56f$var$__decorate([
        (0, $eZfTX.property)(HttpAction.ignoreInputValidationProperty)
    ], HttpAction.prototype, "_ignoreInputValidation", void 0);
    return HttpAction;
}($aa728000c38af56f$var$Action);
module.exports.HttpAction = $aa728000c38af56f$var$HttpAction;
var $aa728000c38af56f$var$ShowCardAction = /** @class */ function(_super) {
    $aa728000c38af56f$var$__extends(ShowCardAction, _super);
    function ShowCardAction() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.card = new $aa728000c38af56f$var$InlineAdaptiveCard();
        return _this;
    }
    ShowCardAction.prototype.updateCssClasses = function() {
        _super.prototype.updateCssClasses.call(this);
        if (this.renderedElement) {
            var effectiveHostConfig = this.parent ? this.parent.hostConfig : $lHSNo.defaultHostConfig;
            this.renderedElement.classList.add(effectiveHostConfig.makeCssClassName("expandable"));
            this.renderedElement.setAttribute("aria-expanded", (this.state === 1 /* Expanded */ ).toString());
        }
    };
    ShowCardAction.prototype.internalParse = function(source, context) {
        _super.prototype.internalParse.call(this, source, context);
        var jsonCard = source["card"];
        if (jsonCard) this.card.parse(jsonCard, context);
        else context.logParseEvent(this, $kD48O.ValidationEvent.PropertyCantBeNull, $c6BU9.Strings.errors.showCardMustHaveCard());
    };
    ShowCardAction.prototype.internalToJSON = function(target, context) {
        _super.prototype.internalToJSON.call(this, target, context);
        if (this.card) context.serializeValue(target, "card", this.card.toJSON(context));
    };
    ShowCardAction.prototype.raiseExecuteActionEvent = function() {
        if (this.hostConfig.actions.showCard.actionMode === $kD48O.ShowCardActionMode.Popup) // Only raise the event in Popup mode.
        _super.prototype.raiseExecuteActionEvent.call(this);
    };
    ShowCardAction.prototype.releaseDOMResources = function() {
        _super.prototype.releaseDOMResources.call(this);
        this.card.releaseDOMResources();
    };
    ShowCardAction.prototype.getJsonTypeName = function() {
        return ShowCardAction.JsonTypeName;
    };
    ShowCardAction.prototype.internalValidateProperties = function(context) {
        _super.prototype.internalValidateProperties.call(this, context);
        this.card.internalValidateProperties(context);
    };
    ShowCardAction.prototype.setParent = function(value) {
        _super.prototype.setParent.call(this, value);
        this.card.setParent(value);
    };
    ShowCardAction.prototype.getAllInputs = function(processActions) {
        if (processActions === void 0) processActions = true;
        return this.card.getAllInputs(processActions);
    };
    ShowCardAction.prototype.getAllActions = function() {
        var result = _super.prototype.getAllActions.call(this);
        result.push.apply(result, this.card.getAllActions());
        return result;
    };
    ShowCardAction.prototype.getResourceInformation = function() {
        var result = _super.prototype.getResourceInformation.call(this);
        result.push.apply(result, this.card.getResourceInformation());
        return result;
    };
    ShowCardAction.prototype.getActionById = function(id) {
        var result = _super.prototype.getActionById.call(this, id);
        if (!result) result = this.card.getActionById(id);
        return result;
    };
    // Note the "weird" way this field is declared is to work around a breaking
    // change introduced in TS 3.1 wrt d.ts generation. DO NOT CHANGE
    ShowCardAction.JsonTypeName = "Action.ShowCard";
    return ShowCardAction;
}($aa728000c38af56f$var$Action);
module.exports.ShowCardAction = $aa728000c38af56f$var$ShowCardAction;
var $aa728000c38af56f$var$OverflowAction = /** @class */ function(_super) {
    $aa728000c38af56f$var$__extends(OverflowAction, _super);
    function OverflowAction(actions) {
        var _this = _super.call(this) || this;
        _this._actions = actions;
        _this.title = $c6BU9.Strings.defaults.overflowButtonText();
        _this.tooltip = $c6BU9.Strings.defaults.overflowButtonTooltip();
        return _this;
    }
    OverflowAction.prototype.getActions = function() {
        return this._actions;
    };
    OverflowAction.prototype.getAllActions = function() {
        var result = _super.prototype.getAllActions.call(this);
        result.push.apply(result, this._actions);
        return result;
    };
    OverflowAction.prototype.getJsonTypeName = function() {
        return $aa728000c38af56f$var$ShowCardAction.JsonTypeName;
    };
    OverflowAction.prototype.execute = function() {
        var _this = this;
        var _a;
        var shouldDisplayPopupMenu = !$aa728000c38af56f$var$raiseDisplayOverflowActionMenuEvent(this, this.renderedElement);
        if (shouldDisplayPopupMenu && this.renderedElement) {
            var contextMenu_1 = new $HYaTY.PopupMenu();
            contextMenu_1.hostConfig = this.hostConfig;
            var _loop_2 = function(i) {
                var menuItem = new $HYaTY.MenuItem(i.toString(), (_a = this_1._actions[i].title) !== null && _a !== void 0 ? _a : "");
                menuItem.isEnabled = this_1._actions[i].isEnabled;
                menuItem.onClick = function() {
                    var actionToExecute = _this._actions[i];
                    contextMenu_1.closePopup(false);
                    if (actionToExecute.isEnabled) actionToExecute.execute();
                };
                contextMenu_1.items.add(menuItem);
            };
            var this_1 = this;
            for(var i = 0; i < this._actions.length; i++)_loop_2(i);
            contextMenu_1.onClose = function() {
                var _a;
                (_a = _this.renderedElement) === null || _a === void 0 || _a.setAttribute("aria-expanded", "false");
            };
            this.renderedElement.setAttribute("aria-expanded", "true");
            contextMenu_1.popup(this.renderedElement);
        }
    };
    OverflowAction.prototype.setupElementForAccessibility = function(element, promoteTooltipToLabel) {
        if (promoteTooltipToLabel === void 0) promoteTooltipToLabel = false;
        _super.prototype.setupElementForAccessibility.call(this, element, promoteTooltipToLabel);
        element.setAttribute("aria-label", $c6BU9.Strings.defaults.overflowButtonTooltip());
        element.setAttribute("aria-expanded", "false");
    };
    OverflowAction.JsonTypeName = "Action.Overflow";
    return OverflowAction;
}($aa728000c38af56f$var$Action);
var $aa728000c38af56f$var$ActionCollection = /** @class */ function() {
    function ActionCollection(owner) {
        this._items = [];
        this._renderedActions = [];
        this._owner = owner;
    }
    ActionCollection.prototype.isActionAllowed = function(action) {
        var forbiddenTypes = this._owner.getForbiddenActionTypes();
        if (forbiddenTypes) for(var _i = 0, forbiddenTypes_1 = forbiddenTypes; _i < forbiddenTypes_1.length; _i++){
            var forbiddenType = forbiddenTypes_1[_i];
            if (action.constructor === forbiddenType) return false;
        }
        return true;
    };
    ActionCollection.prototype.refreshContainer = function() {
        $aa728000c38af56f$var$clearElement(this._actionCardContainer);
        if (!this._actionCard) {
            this._actionCardContainer.style.marginTop = "0px";
            return;
        }
        this._actionCardContainer.style.marginTop = this.renderedActionCount > 0 ? this._owner.hostConfig.actions.showCard.inlineTopMargin + "px" : "0px";
        var padding = this._owner.getEffectivePadding();
        this._owner.getImmediateSurroundingPadding(padding);
        var physicalPadding = this._owner.hostConfig.paddingDefinitionToSpacingDefinition(padding);
        if (this._actionCard) {
            this._actionCard.style.paddingLeft = physicalPadding.left + "px";
            this._actionCard.style.paddingRight = physicalPadding.right + "px";
            this._actionCard.style.marginLeft = "-" + physicalPadding.left + "px";
            this._actionCard.style.marginRight = "-" + physicalPadding.right + "px";
            if (physicalPadding.bottom !== 0 && !this._owner.isDesignMode()) {
                this._actionCard.style.paddingBottom = physicalPadding.bottom + "px";
                this._actionCard.style.marginBottom = "-" + physicalPadding.bottom + "px";
            }
            $8QA0A.appendChild(this._actionCardContainer, this._actionCard);
        }
    };
    ActionCollection.prototype.layoutChanged = function() {
        this._owner.getRootElement().updateLayout();
    };
    ActionCollection.prototype.showActionCard = function(action, suppressStyle, raiseEvent) {
        if (suppressStyle === void 0) suppressStyle = false;
        if (raiseEvent === void 0) raiseEvent = true;
        action.card.suppressStyle = suppressStyle;
        // Always re-render a ShowCard action in design mode; reuse already rendered ShowCard (if available) otherwise
        var renderedCard = action.card.renderedElement && !this._owner.isDesignMode() ? action.card.renderedElement : action.card.render();
        this._actionCard = renderedCard;
        this._expandedAction = action;
        this.refreshContainer();
        if (raiseEvent) {
            this.layoutChanged();
            $aa728000c38af56f$var$raiseInlineCardExpandedEvent(action, true);
        }
    };
    ActionCollection.prototype.collapseExpandedAction = function() {
        for(var _i = 0, _a = this._renderedActions; _i < _a.length; _i++){
            var action = _a[_i];
            action.state = 0 /* Normal */ ;
        }
        var previouslyExpandedAction = this._expandedAction;
        this._expandedAction = undefined;
        this._actionCard = undefined;
        this.refreshContainer();
        if (previouslyExpandedAction) {
            this.layoutChanged();
            $aa728000c38af56f$var$raiseInlineCardExpandedEvent(previouslyExpandedAction, false);
        }
    };
    ActionCollection.prototype.expandShowCardAction = function(action, raiseEvent) {
        var _this = this;
        var afterSelectedAction = false;
        for(var _i = 0, _a = this._renderedActions; _i < _a.length; _i++){
            var renderedAction = _a[_i];
            // Remove actions after selected action from tabOrder if the actions are oriented horizontally, to skip focus directly to expanded card
            if (this._owner.hostConfig.actions.actionsOrientation == $kD48O.Orientation.Horizontal && afterSelectedAction) renderedAction.isFocusable = false;
            if (renderedAction !== action) renderedAction.state = 2 /* Subdued */ ;
            else {
                renderedAction.state = 1 /* Expanded */ ;
                afterSelectedAction = true;
                if (renderedAction.renderedElement) renderedAction.renderedElement.onblur = function(_e) {
                    for(var _i = 0, _a = _this._renderedActions; _i < _a.length; _i++){
                        var ra = _a[_i];
                        ra.isFocusable = true;
                    }
                };
            }
        }
        this.showActionCard(action, !(this._owner.isAtTheVeryLeft() && this._owner.isAtTheVeryRight()), raiseEvent);
    };
    ActionCollection.prototype.releaseDOMResources = function() {
        for(var _i = 0, _a = this._renderedActions; _i < _a.length; _i++){
            var action = _a[_i];
            action.releaseDOMResources();
        }
    };
    ActionCollection.prototype.actionExecuted = function(action) {
        if (!(action instanceof $aa728000c38af56f$var$ShowCardAction)) this.collapseExpandedAction();
        else {
            if (action === this._expandedAction) this.collapseExpandedAction();
            else if (this._owner.hostConfig.actions.showCard.actionMode === $kD48O.ShowCardActionMode.Inline) this.expandShowCardAction(action, true);
        }
    };
    ActionCollection.prototype.parse = function(source, context) {
        this.clear();
        if (Array.isArray(source)) for(var _i = 0, source_1 = source; _i < source_1.length; _i++){
            var jsonAction = source_1[_i];
            var forbiddenActions = [];
            // If the action owner is a ContainerWithActions, we should check for forbidden actions
            if (this._owner instanceof $aa728000c38af56f$var$ContainerWithActions) forbiddenActions = this._owner.getForbiddenActionNames();
            var action = context.parseAction(this._owner, jsonAction, forbiddenActions, !this._owner.isDesignMode());
            if (action) this.addAction(action);
        }
    };
    ActionCollection.prototype.toJSON = function(target, propertyName, context) {
        context.serializeArray(target, propertyName, this._items);
    };
    ActionCollection.prototype.getActionAt = function(id) {
        return this._items[id];
    };
    ActionCollection.prototype.getActionCount = function() {
        return this._items.length;
    };
    ActionCollection.prototype.getActionById = function(id) {
        var result = undefined;
        for(var _i = 0, _a = this._items; _i < _a.length; _i++){
            var item = _a[_i];
            result = item.getActionById(id);
            if (result) break;
        }
        return result;
    };
    ActionCollection.prototype.validateProperties = function(context) {
        if (this._owner.hostConfig.actions.maxActions && this._items.length > this._owner.hostConfig.actions.maxActions) context.addFailure(this._owner, $kD48O.ValidationEvent.TooManyActions, $c6BU9.Strings.errors.tooManyActions(this._owner.hostConfig.actions.maxActions));
        if (this._items.length > 0 && !this._owner.hostConfig.supportsInteractivity) context.addFailure(this._owner, $kD48O.ValidationEvent.InteractivityNotAllowed, $c6BU9.Strings.errors.interactivityNotAllowed());
        for(var _i = 0, _a = this._items; _i < _a.length; _i++){
            var item = _a[_i];
            if (!this.isActionAllowed(item)) context.addFailure(this._owner, $kD48O.ValidationEvent.ActionTypeNotAllowed, $c6BU9.Strings.errors.actionTypeNotAllowed(item.getJsonTypeName()));
            item.internalValidateProperties(context);
        }
    };
    ActionCollection.prototype.render = function(orientation) {
        // Cache hostConfig for better perf
        var hostConfig = this._owner.hostConfig;
        if (!hostConfig.supportsInteractivity) return undefined;
        var element = document.createElement("div");
        var maxActions = hostConfig.actions.maxActions ? Math.min(hostConfig.actions.maxActions, this._items.length) : this._items.length;
        this._actionCardContainer = document.createElement("div");
        this._renderedActions = [];
        if (hostConfig.actions.preExpandSingleShowCardAction && maxActions === 1 && this._items[0] instanceof $aa728000c38af56f$var$ShowCardAction && this.isActionAllowed(this._items[0])) {
            this.showActionCard(this._items[0], true);
            this._renderedActions.push(this._items[0]);
        } else {
            var buttonStrip = document.createElement("div");
            buttonStrip.className = hostConfig.makeCssClassName("ac-actionSet");
            buttonStrip.style.display = "flex";
            if (orientation === $kD48O.Orientation.Horizontal) {
                buttonStrip.style.flexDirection = "row";
                if (this._owner.horizontalAlignment && hostConfig.actions.actionAlignment !== $kD48O.ActionAlignment.Stretch) switch(this._owner.horizontalAlignment){
                    case $kD48O.HorizontalAlignment.Center:
                        buttonStrip.style.justifyContent = "center";
                        break;
                    case $kD48O.HorizontalAlignment.Right:
                        buttonStrip.style.justifyContent = "flex-end";
                        break;
                    default:
                        buttonStrip.style.justifyContent = "flex-start";
                        break;
                }
                else switch(hostConfig.actions.actionAlignment){
                    case $kD48O.ActionAlignment.Center:
                        buttonStrip.style.justifyContent = "center";
                        break;
                    case $kD48O.ActionAlignment.Right:
                        buttonStrip.style.justifyContent = "flex-end";
                        break;
                    default:
                        buttonStrip.style.justifyContent = "flex-start";
                        break;
                }
            } else {
                buttonStrip.style.flexDirection = "column";
                if (this._owner.horizontalAlignment && hostConfig.actions.actionAlignment !== $kD48O.ActionAlignment.Stretch) switch(this._owner.horizontalAlignment){
                    case $kD48O.HorizontalAlignment.Center:
                        buttonStrip.style.alignItems = "center";
                        break;
                    case $kD48O.HorizontalAlignment.Right:
                        buttonStrip.style.alignItems = "flex-end";
                        break;
                    default:
                        buttonStrip.style.alignItems = "flex-start";
                        break;
                }
                else switch(hostConfig.actions.actionAlignment){
                    case $kD48O.ActionAlignment.Center:
                        buttonStrip.style.alignItems = "center";
                        break;
                    case $kD48O.ActionAlignment.Right:
                        buttonStrip.style.alignItems = "flex-end";
                        break;
                    case $kD48O.ActionAlignment.Stretch:
                        buttonStrip.style.alignItems = "stretch";
                        break;
                    default:
                        buttonStrip.style.alignItems = "flex-start";
                        break;
                }
            }
            var allowedActions = this._items.filter(this.isActionAllowed.bind(this));
            var primaryActions_1 = [];
            var secondaryActions_1 = [];
            if (!this._owner.isDesignMode()) {
                allowedActions.forEach(function(action) {
                    return action.mode === $kD48O.ActionMode.Secondary ? secondaryActions_1.push(action) : primaryActions_1.push(action);
                });
                // If primaryActions.length > maxActions, extra actions are moved to overflow
                var overflowPrimaryActions = primaryActions_1.splice(hostConfig.actions.maxActions);
                if ($8Lw6d.GlobalSettings.allowMoreThanMaxActionsInOverflowMenu) secondaryActions_1.push.apply(secondaryActions_1, overflowPrimaryActions);
                var shouldRenderOverflowActionButton = true;
                if (secondaryActions_1.length > 0) {
                    if (!this._overflowAction) {
                        this._overflowAction = new $aa728000c38af56f$var$OverflowAction(secondaryActions_1);
                        this._overflowAction.setParent(this._owner);
                        this._overflowAction["_actionCollection"] = this;
                    }
                    var isRootAction = this._owner instanceof $aa728000c38af56f$var$AdaptiveCard && !this._owner.parent;
                    shouldRenderOverflowActionButton = !$aa728000c38af56f$var$raiseRenderOverflowActionsEvent(this._overflowAction, isRootAction);
                }
                if (this._overflowAction && shouldRenderOverflowActionButton) primaryActions_1.push(this._overflowAction);
            } else primaryActions_1 = allowedActions;
            for(var i = 0; i < primaryActions_1.length; i++){
                var action = primaryActions_1[i];
                action.render();
                if (action.renderedElement) {
                    if (hostConfig.actions.actionsOrientation === $kD48O.Orientation.Horizontal && hostConfig.actions.actionAlignment === $kD48O.ActionAlignment.Stretch) action.renderedElement.style.flex = "0 1 100%";
                    else action.renderedElement.style.flex = "0 1 auto";
                    buttonStrip.appendChild(action.renderedElement);
                    this._renderedActions.push(action);
                    if (i < primaryActions_1.length - 1 && hostConfig.actions.buttonSpacing > 0) {
                        var spacer = document.createElement("div");
                        if (orientation === $kD48O.Orientation.Horizontal) {
                            spacer.style.flex = "0 0 auto";
                            spacer.style.width = hostConfig.actions.buttonSpacing + "px";
                        } else spacer.style.height = hostConfig.actions.buttonSpacing + "px";
                        $8QA0A.appendChild(buttonStrip, spacer);
                    }
                }
            }
            var buttonStripContainer = document.createElement("div");
            buttonStripContainer.style.overflow = "hidden";
            buttonStripContainer.appendChild(buttonStrip);
            $8QA0A.appendChild(element, buttonStripContainer);
        }
        $8QA0A.appendChild(element, this._actionCardContainer);
        for(var _i = 0, _a = this._renderedActions; _i < _a.length; _i++){
            var renderedAction = _a[_i];
            if (renderedAction.state === 1 /* Expanded */ ) {
                this.expandShowCardAction(renderedAction, false);
                break;
            }
        }
        return this._renderedActions.length > 0 ? element : undefined;
    };
    ActionCollection.prototype.addAction = function(action) {
        if (!action) throw new Error("The action parameter cannot be null.");
        if ((!action.parent || action.parent === this._owner) && this._items.indexOf(action) < 0) {
            this._items.push(action);
            if (!action.parent) action.setParent(this._owner);
            action["_actionCollection"] = this;
        } else throw new Error($c6BU9.Strings.errors.actionAlreadyParented());
    };
    ActionCollection.prototype.removeAction = function(action) {
        if (this.expandedAction && this._expandedAction === action) this.collapseExpandedAction();
        var actionIndex = this._items.indexOf(action);
        if (actionIndex >= 0) {
            this._items.splice(actionIndex, 1);
            action.setParent(undefined);
            action["_actionCollection"] = undefined;
            for(var i = 0; i < this._renderedActions.length; i++)if (this._renderedActions[i] === action) {
                this._renderedActions.splice(i, 1);
                break;
            }
            return true;
        }
        return false;
    };
    ActionCollection.prototype.clear = function() {
        this._items = [];
        this._renderedActions = [];
        this._expandedAction = undefined;
    };
    ActionCollection.prototype.getAllInputs = function(processActions) {
        if (processActions === void 0) processActions = true;
        var result = [];
        if (processActions) for(var _i = 0, _a = this._items; _i < _a.length; _i++){
            var action = _a[_i];
            result.push.apply(result, action.getAllInputs());
        }
        return result;
    };
    ActionCollection.prototype.getResourceInformation = function() {
        var result = [];
        for(var _i = 0, _a = this._items; _i < _a.length; _i++){
            var action = _a[_i];
            result.push.apply(result, action.getResourceInformation());
        }
        return result;
    };
    Object.defineProperty(ActionCollection.prototype, "renderedActionCount", {
        get: function() {
            return this._renderedActions.length;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ActionCollection.prototype, "expandedAction", {
        get: function() {
            return this._expandedAction;
        },
        enumerable: false,
        configurable: true
    });
    return ActionCollection;
}();
var $aa728000c38af56f$var$ActionSet = /** @class */ function(_super) {
    $aa728000c38af56f$var$__extends(ActionSet, _super);
    function ActionSet() {
        var _this = _super.call(this) || this;
        _this._actionCollection = new $aa728000c38af56f$var$ActionCollection(_this);
        return _this;
    }
    ActionSet.prototype.internalParse = function(source, context) {
        _super.prototype.internalParse.call(this, source, context);
        this._actionCollection.parse(source["actions"], context);
    };
    ActionSet.prototype.internalToJSON = function(target, context) {
        _super.prototype.internalToJSON.call(this, target, context);
        this._actionCollection.toJSON(target, "actions", context);
    };
    ActionSet.prototype.internalRender = function() {
        return this._actionCollection.render(this.orientation !== undefined ? this.orientation : this.hostConfig.actions.actionsOrientation);
    };
    ActionSet.prototype.releaseDOMResources = function() {
        _super.prototype.releaseDOMResources.call(this);
        this._actionCollection.releaseDOMResources();
    };
    ActionSet.prototype.isBleedingAtBottom = function() {
        if (this._actionCollection.renderedActionCount === 0) return _super.prototype.isBleedingAtBottom.call(this);
        else {
            if (this._actionCollection.getActionCount() === 1) return this._actionCollection.expandedAction !== undefined && !this.hostConfig.actions.preExpandSingleShowCardAction;
            else return this._actionCollection.expandedAction !== undefined;
        }
    };
    ActionSet.prototype.getJsonTypeName = function() {
        return "ActionSet";
    };
    ActionSet.prototype.getActionCount = function() {
        return this._actionCollection.getActionCount();
    };
    ActionSet.prototype.getActionAt = function(index) {
        if (index >= 0 && index < this.getActionCount()) return this._actionCollection.getActionAt(index);
        else return _super.prototype.getActionAt.call(this, index);
    };
    ActionSet.prototype.getActionById = function(id) {
        var result = this._actionCollection.getActionById(id);
        return result ? result : _super.prototype.getActionById.call(this, id);
    };
    ActionSet.prototype.getAllActions = function() {
        var result = _super.prototype.getAllActions.call(this);
        for(var i = 0; i < this.getActionCount(); i++){
            var action = this.getActionAt(i);
            if (action) result.push(action);
        }
        return result;
    };
    ActionSet.prototype.internalValidateProperties = function(context) {
        _super.prototype.internalValidateProperties.call(this, context);
        this._actionCollection.validateProperties(context);
    };
    ActionSet.prototype.addAction = function(action) {
        this._actionCollection.addAction(action);
    };
    ActionSet.prototype.getAllInputs = function(processActions) {
        if (processActions === void 0) processActions = true;
        return processActions ? this._actionCollection.getAllInputs() : [];
    };
    ActionSet.prototype.getResourceInformation = function() {
        return this._actionCollection.getResourceInformation();
    };
    /**
     * @inheritdoc
     */ ActionSet.prototype.findDOMNodeOwner = function(node) {
        var target = undefined;
        for(var i = 0; i < this.getActionCount(); i++){
            var action = this.getActionAt(i);
            if (action) {
                // recur through each Action
                target = action.findDOMNodeOwner(node);
                if (target) return target;
            }
        }
        // if not found in any Action, defer to parent implementation
        return _super.prototype.findDOMNodeOwner.call(this, node);
    };
    ActionSet.prototype.getElementById = function(id) {
        var result = _super.prototype.getElementById.call(this, id);
        if (!result) result = this.getElementByIdFromAction(id);
        return result;
    };
    Object.defineProperty(ActionSet.prototype, "isInteractive", {
        get: function() {
            return true;
        },
        enumerable: false,
        configurable: true
    });
    //#region Schema
    ActionSet.orientationProperty = new $eZfTX.EnumProperty($eZfTX.Versions.v1_1, "orientation", $kD48O.Orientation);
    $aa728000c38af56f$var$__decorate([
        (0, $eZfTX.property)(ActionSet.orientationProperty)
    ], ActionSet.prototype, "orientation", void 0);
    return ActionSet;
}($aa728000c38af56f$var$CardElement);
module.exports.ActionSet = $aa728000c38af56f$var$ActionSet;
var $aa728000c38af56f$var$ContainerStyleProperty = /** @class */ function(_super) {
    $aa728000c38af56f$var$__extends(ContainerStyleProperty, _super);
    function ContainerStyleProperty(targetVersion, name, defaultValue, onGetInitialValue) {
        var _this = _super.call(this, targetVersion, name, [
            {
                value: $kD48O.ContainerStyle.Default
            },
            {
                value: $kD48O.ContainerStyle.Emphasis
            },
            {
                targetVersion: $eZfTX.Versions.v1_2,
                value: $kD48O.ContainerStyle.Accent
            },
            {
                targetVersion: $eZfTX.Versions.v1_2,
                value: $kD48O.ContainerStyle.Good
            },
            {
                targetVersion: $eZfTX.Versions.v1_2,
                value: $kD48O.ContainerStyle.Attention
            },
            {
                targetVersion: $eZfTX.Versions.v1_2,
                value: $kD48O.ContainerStyle.Warning
            }
        ], defaultValue, onGetInitialValue) || this;
        _this.targetVersion = targetVersion;
        _this.name = name;
        _this.defaultValue = defaultValue;
        _this.onGetInitialValue = onGetInitialValue;
        return _this;
    }
    return ContainerStyleProperty;
}($eZfTX.ValueSetProperty);
module.exports.ContainerStyleProperty = $aa728000c38af56f$var$ContainerStyleProperty;
var $aa728000c38af56f$var$StylableCardElementContainer = /** @class */ function(_super) {
    $aa728000c38af56f$var$__extends(StylableCardElementContainer, _super);
    function StylableCardElementContainer() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(StylableCardElementContainer.prototype, "style", {
        get: function() {
            if (this.allowCustomStyle) {
                var style = this.getValue(StylableCardElementContainer.styleProperty);
                if (style && this.hostConfig.containerStyles.getStyleByName(style)) return style;
            }
            return undefined;
        },
        set: function(value) {
            this.setValue(StylableCardElementContainer.styleProperty, value);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StylableCardElementContainer.prototype, "allowCustomStyle", {
        //#endregion
        get: function() {
            return true;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StylableCardElementContainer.prototype, "hasExplicitStyle", {
        get: function() {
            return this.getValue(StylableCardElementContainer.styleProperty) !== undefined;
        },
        enumerable: false,
        configurable: true
    });
    StylableCardElementContainer.prototype.applyBorder = function() {
    // No border in base implementation
    };
    StylableCardElementContainer.prototype.applyBackground = function() {
        if (this.renderedElement) {
            var styleDefinition = this.hostConfig.containerStyles.getStyleByName(this.style, this.hostConfig.containerStyles.getStyleByName(this.defaultStyle));
            if (styleDefinition.backgroundColor) {
                var bgColor = $8QA0A.stringToCssColor(styleDefinition.backgroundColor);
                if (bgColor) this.renderedElement.style.backgroundColor = bgColor;
            }
        }
    };
    StylableCardElementContainer.prototype.applyPadding = function() {
        _super.prototype.applyPadding.call(this);
        if (!this.renderedElement) return;
        var physicalPadding = new $8Lw6d.SpacingDefinition();
        if (this.getEffectivePadding()) physicalPadding = this.hostConfig.paddingDefinitionToSpacingDefinition(this.getEffectivePadding());
        this.renderedElement.style.paddingTop = physicalPadding.top + "px";
        this.renderedElement.style.paddingRight = physicalPadding.right + "px";
        this.renderedElement.style.paddingBottom = physicalPadding.bottom + "px";
        this.renderedElement.style.paddingLeft = physicalPadding.left + "px";
        if (this.isBleeding()) {
            // Bleed into the first parent that does have padding
            var padding = new $8Lw6d.PaddingDefinition();
            this.getImmediateSurroundingPadding(padding);
            var surroundingPadding = this.hostConfig.paddingDefinitionToSpacingDefinition(padding);
            this.renderedElement.style.marginRight = "-" + surroundingPadding.right + "px";
            this.renderedElement.style.marginLeft = "-" + surroundingPadding.left + "px";
            if (!this.isDesignMode()) {
                this.renderedElement.style.marginTop = "-" + surroundingPadding.top + "px";
                this.renderedElement.style.marginBottom = "-" + surroundingPadding.bottom + "px";
            }
            if (this.separatorElement && this.separatorOrientation === $kD48O.Orientation.Horizontal) {
                this.separatorElement.style.marginLeft = "-" + surroundingPadding.left + "px";
                this.separatorElement.style.marginRight = "-" + surroundingPadding.right + "px";
            }
        } else {
            this.renderedElement.style.marginRight = "0";
            this.renderedElement.style.marginLeft = "0";
            this.renderedElement.style.marginTop = "0";
            this.renderedElement.style.marginBottom = "0";
            if (this.separatorElement && this.separatorOrientation === $kD48O.Orientation.Horizontal) {
                this.separatorElement.style.marginRight = "0";
                this.separatorElement.style.marginLeft = "0";
            }
        }
    };
    StylableCardElementContainer.prototype.getHasBackground = function(ignoreBackgroundImages) {
        if (ignoreBackgroundImages === void 0) ignoreBackgroundImages = false;
        var currentElement = this.parent;
        while(currentElement){
            var currentElementHasBackgroundImage = false;
            if (ignoreBackgroundImages) currentElementHasBackgroundImage = false;
            else currentElementHasBackgroundImage = currentElement instanceof $aa728000c38af56f$var$Container ? currentElement.backgroundImage.isValid() : false;
            if (currentElement instanceof StylableCardElementContainer) {
                if (this.hasExplicitStyle && (currentElement.getEffectiveStyle() !== this.getEffectiveStyle() || currentElementHasBackgroundImage)) return true;
            }
            currentElement = currentElement.parent;
        }
        return false;
    };
    StylableCardElementContainer.prototype.getDefaultPadding = function() {
        return this.getHasBackground() || this.getHasBorder() ? new $8Lw6d.PaddingDefinition($kD48O.Spacing.Padding, $kD48O.Spacing.Padding, $kD48O.Spacing.Padding, $kD48O.Spacing.Padding) : _super.prototype.getDefaultPadding.call(this);
    };
    StylableCardElementContainer.prototype.internalValidateProperties = function(context) {
        _super.prototype.internalValidateProperties.call(this, context);
        var explicitStyle = this.getValue(StylableCardElementContainer.styleProperty);
        if (explicitStyle !== undefined) {
            var styleDefinition = this.hostConfig.containerStyles.getStyleByName(explicitStyle);
            if (!styleDefinition) context.addFailure(this, $kD48O.ValidationEvent.InvalidPropertyValue, $c6BU9.Strings.errors.invalidPropertyValue(explicitStyle, "style"));
        }
    };
    StylableCardElementContainer.prototype.render = function() {
        var renderedElement = _super.prototype.render.call(this);
        if (renderedElement && this.getHasBackground()) this.applyBackground();
        this.applyBorder();
        return renderedElement;
    };
    StylableCardElementContainer.prototype.getEffectiveStyle = function() {
        var effectiveStyle = this.style;
        return effectiveStyle ? effectiveStyle : _super.prototype.getEffectiveStyle.call(this);
    };
    //#region Schema
    StylableCardElementContainer.styleProperty = new $aa728000c38af56f$var$ContainerStyleProperty($eZfTX.Versions.v1_0, "style");
    $aa728000c38af56f$var$__decorate([
        (0, $eZfTX.property)(StylableCardElementContainer.styleProperty)
    ], StylableCardElementContainer.prototype, "style", null);
    return StylableCardElementContainer;
}($aa728000c38af56f$var$CardElementContainer);
module.exports.StylableCardElementContainer = $aa728000c38af56f$var$StylableCardElementContainer;
var $aa728000c38af56f$var$ContainerBase = /** @class */ function(_super) {
    $aa728000c38af56f$var$__extends(ContainerBase, _super);
    function ContainerBase() {
        //#region Schema
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._bleed = false;
        return _this;
    }
    //#endregion
    ContainerBase.prototype.adjustRenderedElementSize = function(renderedElement) {
        _super.prototype.adjustRenderedElementSize.call(this, renderedElement);
        if (this.minPixelHeight) renderedElement.style.minHeight = this.minPixelHeight + "px";
    };
    ContainerBase.prototype.getHasExpandedAction = function() {
        return false;
    };
    ContainerBase.prototype.getBleed = function() {
        return this._bleed;
    };
    ContainerBase.prototype.setBleed = function(value) {
        this._bleed = value;
    };
    Object.defineProperty(ContainerBase.prototype, "renderedActionCount", {
        get: function() {
            return 0;
        },
        enumerable: false,
        configurable: true
    });
    ContainerBase.prototype.isBleeding = function() {
        return (this.getHasBackground() || this.hostConfig.alwaysAllowBleed) && this.getBleed();
    };
    ContainerBase.bleedProperty = new $eZfTX.BoolProperty($eZfTX.Versions.v1_2, "bleed", false);
    ContainerBase.minHeightProperty = new $eZfTX.PixelSizeProperty($eZfTX.Versions.v1_2, "minHeight");
    $aa728000c38af56f$var$__decorate([
        (0, $eZfTX.property)(ContainerBase.bleedProperty)
    ], ContainerBase.prototype, "_bleed", void 0);
    $aa728000c38af56f$var$__decorate([
        (0, $eZfTX.property)(ContainerBase.minHeightProperty)
    ], ContainerBase.prototype, "minPixelHeight", void 0);
    return ContainerBase;
}($aa728000c38af56f$var$StylableCardElementContainer);
module.exports.ContainerBase = $aa728000c38af56f$var$ContainerBase;
var $aa728000c38af56f$var$BackgroundImage = /** @class */ function(_super) {
    $aa728000c38af56f$var$__extends(BackgroundImage, _super);
    function BackgroundImage() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    //#endregion
    BackgroundImage.prototype.getSchemaKey = function() {
        return "BackgroundImage";
    };
    BackgroundImage.prototype.internalParse = function(source, context) {
        if (typeof source === "string") {
            this.resetDefaultValues();
            this.url = source;
        } else return _super.prototype.internalParse.call(this, source, context);
    };
    BackgroundImage.prototype.apply = function(element) {
        if (this.url && element.renderedElement) {
            element.renderedElement.style.backgroundImage = "url('" + element.preProcessPropertyValue(BackgroundImage.urlProperty, this.url) + "')";
            switch(this.fillMode){
                case $kD48O.FillMode.Repeat:
                    element.renderedElement.style.backgroundRepeat = "repeat";
                    break;
                case $kD48O.FillMode.RepeatHorizontally:
                    element.renderedElement.style.backgroundRepeat = "repeat-x";
                    break;
                case $kD48O.FillMode.RepeatVertically:
                    element.renderedElement.style.backgroundRepeat = "repeat-y";
                    break;
                case $kD48O.FillMode.Cover:
                default:
                    element.renderedElement.style.backgroundRepeat = "no-repeat";
                    element.renderedElement.style.backgroundSize = "cover";
                    break;
            }
            switch(this.horizontalAlignment){
                case $kD48O.HorizontalAlignment.Left:
                    break;
                case $kD48O.HorizontalAlignment.Center:
                    element.renderedElement.style.backgroundPositionX = "center";
                    break;
                case $kD48O.HorizontalAlignment.Right:
                    element.renderedElement.style.backgroundPositionX = "right";
                    break;
            }
            switch(this.verticalAlignment){
                case $kD48O.VerticalAlignment.Top:
                    break;
                case $kD48O.VerticalAlignment.Center:
                    element.renderedElement.style.backgroundPositionY = "center";
                    break;
                case $kD48O.VerticalAlignment.Bottom:
                    element.renderedElement.style.backgroundPositionY = "bottom";
                    break;
            }
        }
    };
    BackgroundImage.prototype.isValid = function() {
        return this.url ? true : false;
    };
    //#region Schema
    BackgroundImage.urlProperty = new $eZfTX.StringProperty($eZfTX.Versions.v1_0, "url");
    BackgroundImage.fillModeProperty = new $eZfTX.EnumProperty($eZfTX.Versions.v1_2, "fillMode", $kD48O.FillMode, $kD48O.FillMode.Cover);
    BackgroundImage.horizontalAlignmentProperty = new $eZfTX.EnumProperty($eZfTX.Versions.v1_2, "horizontalAlignment", $kD48O.HorizontalAlignment, $kD48O.HorizontalAlignment.Left);
    BackgroundImage.verticalAlignmentProperty = new $eZfTX.EnumProperty($eZfTX.Versions.v1_2, "verticalAlignment", $kD48O.VerticalAlignment, $kD48O.VerticalAlignment.Top);
    $aa728000c38af56f$var$__decorate([
        (0, $eZfTX.property)(BackgroundImage.urlProperty)
    ], BackgroundImage.prototype, "url", void 0);
    $aa728000c38af56f$var$__decorate([
        (0, $eZfTX.property)(BackgroundImage.fillModeProperty)
    ], BackgroundImage.prototype, "fillMode", void 0);
    $aa728000c38af56f$var$__decorate([
        (0, $eZfTX.property)(BackgroundImage.horizontalAlignmentProperty)
    ], BackgroundImage.prototype, "horizontalAlignment", void 0);
    $aa728000c38af56f$var$__decorate([
        (0, $eZfTX.property)(BackgroundImage.verticalAlignmentProperty)
    ], BackgroundImage.prototype, "verticalAlignment", void 0);
    return BackgroundImage;
}($eZfTX.SerializableObject);
module.exports.BackgroundImage = $aa728000c38af56f$var$BackgroundImage;
var $aa728000c38af56f$var$Container = /** @class */ function(_super) {
    $aa728000c38af56f$var$__extends(Container, _super);
    function Container() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        //#endregion
        _this._items = [];
        _this._renderedItems = [];
        return _this;
    }
    Object.defineProperty(Container.prototype, "backgroundImage", {
        get: function() {
            return this.getValue(Container.backgroundImageProperty);
        },
        enumerable: false,
        configurable: true
    });
    Container.prototype.insertItemAt = function(item, index, forceInsert) {
        if (!item.parent || forceInsert) {
            if (item.isStandalone) {
                if (index < 0 || index >= this._items.length) this._items.push(item);
                else this._items.splice(index, 0, item);
                item.setParent(this);
            } else throw new Error($c6BU9.Strings.errors.elementTypeNotStandalone(item.getJsonTypeName()));
        } else throw new Error($c6BU9.Strings.errors.elementAlreadyParented());
    };
    Container.prototype.getItemsCollectionPropertyName = function() {
        return "items";
    };
    Container.prototype.applyBackground = function() {
        if (this.backgroundImage.isValid() && this.renderedElement) this.backgroundImage.apply(this);
        _super.prototype.applyBackground.call(this);
    };
    Container.prototype.applyRTL = function(element) {
        if (this.rtl !== undefined) element.dir = this.rtl ? "rtl" : "ltr";
    };
    Container.prototype.internalRender = function() {
        this._renderedItems = [];
        // Cache hostConfig to avoid walking the parent hierarchy several times
        var hostConfig = this.hostConfig;
        var element = document.createElement("div");
        this.applyRTL(element);
        element.classList.add(hostConfig.makeCssClassName("ac-container"));
        element.style.display = "flex";
        element.style.flexDirection = "column";
        if ($8Lw6d.GlobalSettings.useAdvancedCardBottomTruncation) // Forces the container to be at least as tall as its content.
        //
        // Fixes a quirk in Chrome where, for nested flex elements, the
        // inner element's height would never exceed the outer element's
        // height. This caused overflow truncation to break -- containers
        // would always be measured as not overflowing, since their heights
        // were constrained by their parents as opposed to truly reflecting
        // the height of their content.
        //
        // See the "Browser Rendering Notes" section of this answer:
        // https://stackoverflow.com/questions/36247140/why-doesnt-flex-item-shrink-past-content-size
        element.style.minHeight = "-webkit-min-content";
        switch(this.getEffectiveVerticalContentAlignment()){
            case $kD48O.VerticalAlignment.Center:
                element.style.justifyContent = "center";
                break;
            case $kD48O.VerticalAlignment.Bottom:
                element.style.justifyContent = "flex-end";
                break;
            default:
                element.style.justifyContent = "flex-start";
                break;
        }
        if (this._items.length > 0) for(var _i = 0, _a = this._items; _i < _a.length; _i++){
            var item = _a[_i];
            var renderedItem = this.isElementAllowed(item) ? item.render() : undefined;
            if (renderedItem) {
                if (this._renderedItems.length > 0 && item.separatorElement) {
                    item.separatorElement.style.flex = "0 0 auto";
                    $8QA0A.appendChild(element, item.separatorElement);
                }
                $8QA0A.appendChild(element, renderedItem);
                this._renderedItems.push(item);
            }
        }
        else if (this.isDesignMode()) {
            var placeholderElement = this.createPlaceholderElement();
            placeholderElement.style.width = "100%";
            placeholderElement.style.height = "100%";
            element.appendChild(placeholderElement);
        }
        return element;
    };
    Container.prototype.truncateOverflow = function(maxHeight) {
        if (this.renderedElement) {
            // Add 1 to account for rounding differences between browsers
            var boundary_1 = this.renderedElement.offsetTop + maxHeight + 1;
            var handleElement_1 = function(cardElement) {
                var elt = cardElement.renderedElement;
                if (elt) switch($8QA0A.getFitStatus(elt, boundary_1)){
                    case $kD48O.ContainerFitStatus.FullyInContainer:
                        var sizeChanged = cardElement["resetOverflow"]();
                        // If the element's size changed after resetting content,
                        // we have to check if it still fits fully in the card
                        if (sizeChanged) handleElement_1(cardElement);
                        break;
                    case $kD48O.ContainerFitStatus.Overflowing:
                        var containerMaxHeight = boundary_1 - elt.offsetTop;
                        cardElement["handleOverflow"](containerMaxHeight);
                        break;
                    case $kD48O.ContainerFitStatus.FullyOutOfContainer:
                        cardElement["handleOverflow"](0);
                        break;
                }
            };
            for(var _i = 0, _a = this._items; _i < _a.length; _i++){
                var item = _a[_i];
                handleElement_1(item);
            }
            return true;
        }
        return false;
    };
    Container.prototype.undoOverflowTruncation = function() {
        for(var _i = 0, _a = this._items; _i < _a.length; _i++){
            var item = _a[_i];
            item["resetOverflow"]();
        }
    };
    Container.prototype.getHasBackground = function(ignoreBackgroundImages) {
        if (ignoreBackgroundImages === void 0) ignoreBackgroundImages = false;
        var result = ignoreBackgroundImages ? false : this.backgroundImage.isValid();
        return result || _super.prototype.getHasBackground.call(this, ignoreBackgroundImages);
    };
    Container.prototype.internalParse = function(source, context) {
        _super.prototype.internalParse.call(this, source, context);
        this.clear();
        this.setShouldFallback(false);
        var jsonItems = source[this.getItemsCollectionPropertyName()];
        if (Array.isArray(jsonItems)) for(var _i = 0, jsonItems_1 = jsonItems; _i < jsonItems_1.length; _i++){
            var item = jsonItems_1[_i];
            var element = context.parseElement(this, item, this.forbiddenChildElements(), !this.isDesignMode());
            if (element) this.insertItemAt(element, -1, true);
        }
    };
    Container.prototype.internalToJSON = function(target, context) {
        _super.prototype.internalToJSON.call(this, target, context);
        var collectionPropertyName = this.getItemsCollectionPropertyName();
        context.serializeArray(target, collectionPropertyName, this._items);
    };
    Object.defineProperty(Container.prototype, "isSelectable", {
        get: function() {
            return true;
        },
        enumerable: false,
        configurable: true
    });
    Container.prototype.getEffectivePadding = function() {
        if ($8Lw6d.GlobalSettings.removePaddingFromContainersWithBackgroundImage && !this.getHasBackground(true)) return new $8Lw6d.PaddingDefinition();
        return _super.prototype.getEffectivePadding.call(this);
    };
    Container.prototype.getEffectiveVerticalContentAlignment = function() {
        if (this.verticalContentAlignment !== undefined) return this.verticalContentAlignment;
        var parentContainer = this.getParentContainer();
        return parentContainer ? parentContainer.getEffectiveVerticalContentAlignment() : $kD48O.VerticalAlignment.Top;
    };
    Container.prototype.getItemCount = function() {
        return this._items.length;
    };
    Container.prototype.getItemAt = function(index) {
        return this._items[index];
    };
    Container.prototype.getFirstVisibleRenderedItem = function() {
        if (this.renderedElement && this._renderedItems && this._renderedItems.length > 0) for(var _i = 0, _a = this._renderedItems; _i < _a.length; _i++){
            var item = _a[_i];
            if (item.isVisible) return item;
        }
        return undefined;
    };
    Container.prototype.getLastVisibleRenderedItem = function() {
        if (this.renderedElement && this._renderedItems && this._renderedItems.length > 0) for(var i = this._renderedItems.length - 1; i >= 0; i--){
            if (this._renderedItems[i].isVisible) return this._renderedItems[i];
        }
        return undefined;
    };
    Container.prototype.getJsonTypeName = function() {
        return "Container";
    };
    Container.prototype.isFirstElement = function(element) {
        var designMode = this.isDesignMode();
        for(var _i = 0, _a = this._items; _i < _a.length; _i++){
            var item = _a[_i];
            if (item.isVisible || designMode) return item === element;
        }
        return false;
    };
    Container.prototype.isLastElement = function(element) {
        var designMode = this.isDesignMode();
        for(var i = this._items.length - 1; i >= 0; i--){
            if (this._items[i].isVisible || designMode) return this._items[i] === element;
        }
        return false;
    };
    Container.prototype.isRtl = function() {
        if (this.rtl !== undefined) return this.rtl;
        else {
            var parentContainer = this.getParentContainer();
            return parentContainer ? parentContainer.isRtl() : false;
        }
    };
    Container.prototype.isBleedingAtTop = function() {
        var firstRenderedItem = this.getFirstVisibleRenderedItem();
        return this.isBleeding() || (firstRenderedItem ? firstRenderedItem.isBleedingAtTop() : false);
    };
    Container.prototype.isBleedingAtBottom = function() {
        var lastRenderedItem = this.getLastVisibleRenderedItem();
        return this.isBleeding() || (lastRenderedItem ? lastRenderedItem.isBleedingAtBottom() && lastRenderedItem.getEffectiveStyle() === this.getEffectiveStyle() : false);
    };
    Container.prototype.indexOf = function(cardElement) {
        return this._items.indexOf(cardElement);
    };
    Container.prototype.addItem = function(item) {
        this.insertItemAt(item, -1, false);
    };
    Container.prototype.insertItemBefore = function(item, insertBefore) {
        this.insertItemAt(item, this._items.indexOf(insertBefore), false);
    };
    Container.prototype.insertItemAfter = function(item, insertAfter) {
        this.insertItemAt(item, this._items.indexOf(insertAfter) + 1, false);
    };
    Container.prototype.removeItem = function(item) {
        var itemIndex = this._items.indexOf(item);
        if (itemIndex >= 0) {
            this._items.splice(itemIndex, 1);
            item.setParent(undefined);
            this.updateLayout();
            return true;
        }
        return false;
    };
    Container.prototype.clear = function() {
        this._items = [];
        this._renderedItems = [];
    };
    Container.prototype.getResourceInformation = function() {
        var result = _super.prototype.getResourceInformation.call(this);
        if (this.backgroundImage.isValid()) result.push({
            // eslint-disable-next-line @typescript-eslint/no-unnecessary-type-assertion -- validated by `isValid()`
            url: this.backgroundImage.url,
            mimeType: "image"
        });
        return result;
    };
    Container.prototype.getActionById = function(id) {
        var result = _super.prototype.getActionById.call(this, id);
        if (!result) {
            if (this.selectAction) result = this.selectAction.getActionById(id);
            if (!result) for(var _i = 0, _a = this._items; _i < _a.length; _i++){
                var item = _a[_i];
                result = item.getActionById(id);
                if (result) break;
            }
        }
        return result;
    };
    Object.defineProperty(Container.prototype, "padding", {
        get: function() {
            return this.getPadding();
        },
        set: function(value) {
            this.setPadding(value);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Container.prototype, "selectAction", {
        get: function() {
            return this._selectAction;
        },
        set: function(value) {
            this._selectAction = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Container.prototype, "bleed", {
        get: function() {
            return this.getBleed();
        },
        set: function(value) {
            this.setBleed(value);
        },
        enumerable: false,
        configurable: true
    });
    //#region Schema
    Container.backgroundImageProperty = new $eZfTX.SerializableObjectProperty($eZfTX.Versions.v1_0, "backgroundImage", $aa728000c38af56f$var$BackgroundImage);
    Container.verticalContentAlignmentProperty = new $eZfTX.EnumProperty($eZfTX.Versions.v1_1, "verticalContentAlignment", $kD48O.VerticalAlignment);
    Container.rtlProperty = new $eZfTX.BoolProperty($eZfTX.Versions.v1_0, "rtl");
    $aa728000c38af56f$var$__decorate([
        (0, $eZfTX.property)(Container.backgroundImageProperty)
    ], Container.prototype, "backgroundImage", null);
    $aa728000c38af56f$var$__decorate([
        (0, $eZfTX.property)(Container.verticalContentAlignmentProperty)
    ], Container.prototype, "verticalContentAlignment", void 0);
    $aa728000c38af56f$var$__decorate([
        (0, $eZfTX.property)(Container.rtlProperty)
    ], Container.prototype, "rtl", void 0);
    return Container;
}($aa728000c38af56f$var$ContainerBase);
module.exports.Container = $aa728000c38af56f$var$Container;
var $aa728000c38af56f$var$Column = /** @class */ function(_super) {
    $aa728000c38af56f$var$__extends(Column, _super);
    function Column(width) {
        if (width === void 0) width = "stretch";
        var _this = _super.call(this) || this;
        _this.width = "stretch";
        //#endregion
        _this._computedWeight = 0;
        _this.width = width;
        return _this;
    }
    Column.prototype.adjustRenderedElementSize = function(renderedElement) {
        var minDesignTimeColumnHeight = 20;
        if (this.isDesignMode()) {
            renderedElement.style.minWidth = "20px";
            renderedElement.style.minHeight = (!this.minPixelHeight ? minDesignTimeColumnHeight : Math.max(this.minPixelHeight, minDesignTimeColumnHeight)) + "px";
        } else {
            renderedElement.style.minWidth = "0";
            if (this.minPixelHeight) renderedElement.style.minHeight = this.minPixelHeight + "px";
        }
        if (this.width === "auto") renderedElement.style.flex = "0 1 auto";
        else if (this.width === "stretch") renderedElement.style.flex = "1 1 50px";
        else if (this.width instanceof $8Lw6d.SizeAndUnit) {
            if (this.width.unit === $kD48O.SizeUnit.Pixel) {
                renderedElement.style.flex = "0 0 auto";
                renderedElement.style.width = this.width.physicalSize + "px";
            } else renderedElement.style.flex = "1 1 " + (this._computedWeight > 0 ? this._computedWeight : this.width.physicalSize) + "%";
        }
    };
    Column.prototype.shouldSerialize = function(_context) {
        return true;
    };
    Object.defineProperty(Column.prototype, "separatorOrientation", {
        get: function() {
            return $kD48O.Orientation.Vertical;
        },
        enumerable: false,
        configurable: true
    });
    Column.prototype.getJsonTypeName = function() {
        return "Column";
    };
    Object.defineProperty(Column.prototype, "hasVisibleSeparator", {
        get: function() {
            if (this.parent && this.parent instanceof $aa728000c38af56f$var$ColumnSet) return this.separatorElement !== undefined && !this.parent.isLeftMostElement(this);
            else return false;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Column.prototype, "isStandalone", {
        get: function() {
            return false;
        },
        enumerable: false,
        configurable: true
    });
    //#region Schema
    Column.widthProperty = new $eZfTX.CustomProperty($eZfTX.Versions.v1_0, "width", function(sender, prop, source, context) {
        var result = prop.defaultValue;
        var value = source[prop.name];
        var invalidWidth = false;
        if (typeof value === "number" && !isNaN(value)) result = new $8Lw6d.SizeAndUnit(value, $kD48O.SizeUnit.Weight);
        else if (value === "auto" || value === "stretch") result = value;
        else if (typeof value === "string") try {
            result = $8Lw6d.SizeAndUnit.parse(value);
            if (result.unit === $kD48O.SizeUnit.Pixel && prop.targetVersion.compareTo(context.targetVersion) > 0) invalidWidth = true;
        } catch (e) {
            invalidWidth = true;
        }
        else invalidWidth = true;
        if (invalidWidth) {
            context.logParseEvent(sender, $kD48O.ValidationEvent.InvalidPropertyValue, $c6BU9.Strings.errors.invalidColumnWidth(value));
            result = "auto";
        }
        return result;
    }, function(sender, property, target, value, context) {
        if (value instanceof $8Lw6d.SizeAndUnit) {
            if (value.unit === $kD48O.SizeUnit.Pixel) context.serializeValue(target, "width", value.physicalSize + "px");
            else context.serializeNumber(target, "width", value.physicalSize);
        } else context.serializeValue(target, "width", value);
    }, "stretch");
    $aa728000c38af56f$var$__decorate([
        (0, $eZfTX.property)(Column.widthProperty)
    ], Column.prototype, "width", void 0);
    return Column;
}($aa728000c38af56f$var$Container);
module.exports.Column = $aa728000c38af56f$var$Column;
var $aa728000c38af56f$var$ColumnSet = /** @class */ function(_super) {
    $aa728000c38af56f$var$__extends(ColumnSet, _super);
    function ColumnSet() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._columns = [];
        return _this;
    }
    ColumnSet.prototype.createColumnInstance = function(source, context) {
        return context.parseCardObject(this, source, [], !this.isDesignMode(), function(typeName) {
            return !typeName || typeName === "Column" ? new $aa728000c38af56f$var$Column() : undefined;
        }, function(typeName, _errorType) {
            context.logParseEvent(undefined, $kD48O.ValidationEvent.ElementTypeNotAllowed, $c6BU9.Strings.errors.elementTypeNotAllowed(typeName));
        });
    };
    ColumnSet.prototype.internalRender = function() {
        this._renderedColumns = [];
        if (this._columns.length > 0) {
            // Cache hostConfig to avoid walking the parent hierarchy several times
            var hostConfig = this.hostConfig;
            var element = document.createElement("div");
            element.className = hostConfig.makeCssClassName("ac-columnSet");
            element.style.display = "flex";
            if ($8Lw6d.GlobalSettings.useAdvancedCardBottomTruncation) // See comment in Container.internalRender()
            element.style.minHeight = "-webkit-min-content";
            switch(this.getEffectiveHorizontalAlignment()){
                case $kD48O.HorizontalAlignment.Center:
                    element.style.justifyContent = "center";
                    break;
                case $kD48O.HorizontalAlignment.Right:
                    element.style.justifyContent = "flex-end";
                    break;
                default:
                    element.style.justifyContent = "flex-start";
                    break;
            }
            var totalWeight = 0;
            for(var _i = 0, _a = this._columns; _i < _a.length; _i++){
                var column = _a[_i];
                if (column.width instanceof $8Lw6d.SizeAndUnit && column.width.unit === $kD48O.SizeUnit.Weight) totalWeight += column.width.physicalSize;
            }
            for(var _b = 0, _c = this._columns; _b < _c.length; _b++){
                var column = _c[_b];
                if (column.width instanceof $8Lw6d.SizeAndUnit && column.width.unit === $kD48O.SizeUnit.Weight && totalWeight > 0) {
                    var computedWeight = 100 / totalWeight * column.width.physicalSize;
                    // Best way to emulate "internal" access I know of
                    column["_computedWeight"] = computedWeight;
                }
                var renderedColumn = column.render();
                if (renderedColumn) {
                    if (this._renderedColumns.length > 0 && column.separatorElement) {
                        column.separatorElement.style.flex = "0 0 auto";
                        $8QA0A.appendChild(element, column.separatorElement);
                    }
                    $8QA0A.appendChild(element, renderedColumn);
                    this._renderedColumns.push(column);
                }
            }
            return this._renderedColumns.length > 0 ? element : undefined;
        } else return undefined;
    };
    ColumnSet.prototype.truncateOverflow = function(maxHeight) {
        for(var _i = 0, _a = this._columns; _i < _a.length; _i++){
            var column = _a[_i];
            column["handleOverflow"](maxHeight);
        }
        return true;
    };
    ColumnSet.prototype.undoOverflowTruncation = function() {
        for(var _i = 0, _a = this._columns; _i < _a.length; _i++){
            var column = _a[_i];
            column["resetOverflow"]();
        }
    };
    Object.defineProperty(ColumnSet.prototype, "isSelectable", {
        get: function() {
            return true;
        },
        enumerable: false,
        configurable: true
    });
    ColumnSet.prototype.internalParse = function(source, context) {
        _super.prototype.internalParse.call(this, source, context);
        this._columns = [];
        this._renderedColumns = [];
        var jsonColumns = source["columns"];
        if (Array.isArray(jsonColumns)) for(var _i = 0, jsonColumns_1 = jsonColumns; _i < jsonColumns_1.length; _i++){
            var item = jsonColumns_1[_i];
            var column = this.createColumnInstance(item, context);
            if (column) this._columns.push(column);
        }
    };
    ColumnSet.prototype.internalToJSON = function(target, context) {
        _super.prototype.internalToJSON.call(this, target, context);
        context.serializeArray(target, "columns", this._columns);
    };
    ColumnSet.prototype.isFirstElement = function(element) {
        for(var _i = 0, _a = this._columns; _i < _a.length; _i++){
            var column = _a[_i];
            if (column.isVisible) return column === element;
        }
        return false;
    };
    ColumnSet.prototype.isBleedingAtTop = function() {
        if (this.isBleeding()) return true;
        if (this._renderedColumns && this._renderedColumns.length > 0) for(var _i = 0, _a = this._columns; _i < _a.length; _i++){
            var column = _a[_i];
            if (column.isBleedingAtTop()) return true;
        }
        return false;
    };
    ColumnSet.prototype.isBleedingAtBottom = function() {
        if (this.isBleeding()) return true;
        if (this._renderedColumns && this._renderedColumns.length > 0) for(var _i = 0, _a = this._columns; _i < _a.length; _i++){
            var column = _a[_i];
            if (column.isBleedingAtBottom()) return true;
        }
        return false;
    };
    ColumnSet.prototype.getItemCount = function() {
        return this._columns.length;
    };
    ColumnSet.prototype.getFirstVisibleRenderedItem = function() {
        if (this.renderedElement && this._renderedColumns && this._renderedColumns.length > 0) return this._renderedColumns[0];
        else return undefined;
    };
    ColumnSet.prototype.getLastVisibleRenderedItem = function() {
        if (this.renderedElement && this._renderedColumns && this._renderedColumns.length > 0) return this._renderedColumns[this._renderedColumns.length - 1];
        else return undefined;
    };
    ColumnSet.prototype.getColumnAt = function(index) {
        return this._columns[index];
    };
    ColumnSet.prototype.getItemAt = function(index) {
        return this.getColumnAt(index);
    };
    ColumnSet.prototype.getJsonTypeName = function() {
        return "ColumnSet";
    };
    ColumnSet.prototype.internalValidateProperties = function(context) {
        _super.prototype.internalValidateProperties.call(this, context);
        var weightedColumns = 0;
        var stretchedColumns = 0;
        for(var _i = 0, _a = this._columns; _i < _a.length; _i++){
            var column = _a[_i];
            if (typeof column.width === "number") weightedColumns++;
            else if (column.width === "stretch") stretchedColumns++;
        }
        if (weightedColumns > 0 && stretchedColumns > 0) context.addFailure(this, $kD48O.ValidationEvent.Hint, $c6BU9.Strings.hints.dontUseWeightedAndStrecthedColumnsInSameSet());
    };
    ColumnSet.prototype.addColumn = function(column) {
        if (!column.parent) {
            this._columns.push(column);
            column.setParent(this);
        } else throw new Error($c6BU9.Strings.errors.columnAlreadyBelongsToAnotherSet());
    };
    ColumnSet.prototype.removeItem = function(item) {
        if (item instanceof $aa728000c38af56f$var$Column) {
            var itemIndex = this._columns.indexOf(item);
            if (itemIndex >= 0) {
                this._columns.splice(itemIndex, 1);
                item.setParent(undefined);
                this.updateLayout();
                return true;
            }
        }
        return false;
    };
    ColumnSet.prototype.indexOf = function(cardElement) {
        return cardElement instanceof $aa728000c38af56f$var$Column ? this._columns.indexOf(cardElement) : -1;
    };
    ColumnSet.prototype.isLeftMostElement = function(element) {
        return this._columns.indexOf(element) === 0;
    };
    ColumnSet.prototype.isRightMostElement = function(element) {
        return this._columns.indexOf(element) === this._columns.length - 1;
    };
    ColumnSet.prototype.isTopElement = function(element) {
        return this._columns.indexOf(element) >= 0;
    };
    ColumnSet.prototype.isBottomElement = function(element) {
        return this._columns.indexOf(element) >= 0;
    };
    ColumnSet.prototype.getActionById = function(id) {
        var result = undefined;
        for(var _i = 0, _a = this._columns; _i < _a.length; _i++){
            var column = _a[_i];
            result = column.getActionById(id);
            if (result) break;
        }
        return result;
    };
    Object.defineProperty(ColumnSet.prototype, "bleed", {
        get: function() {
            return this.getBleed();
        },
        set: function(value) {
            this.setBleed(value);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ColumnSet.prototype, "padding", {
        get: function() {
            return this.getPadding();
        },
        set: function(value) {
            this.setPadding(value);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ColumnSet.prototype, "selectAction", {
        get: function() {
            return this._selectAction;
        },
        set: function(value) {
            this._selectAction = value;
        },
        enumerable: false,
        configurable: true
    });
    return ColumnSet;
}($aa728000c38af56f$var$ContainerBase);
module.exports.ColumnSet = $aa728000c38af56f$var$ColumnSet;
function $aa728000c38af56f$var$raiseImageLoadedEvent(image) {
    var card = image.getRootElement();
    var onImageLoadedHandler = card && card.onImageLoaded ? card.onImageLoaded : $aa728000c38af56f$var$AdaptiveCard.onImageLoaded;
    if (onImageLoadedHandler) onImageLoadedHandler(image);
}
function $aa728000c38af56f$var$raiseAnchorClickedEvent(element, anchor, ev) {
    var card = element.getRootElement();
    var onAnchorClickedHandler = card && card.onAnchorClicked ? card.onAnchorClicked : $aa728000c38af56f$var$AdaptiveCard.onAnchorClicked;
    return onAnchorClickedHandler !== undefined ? onAnchorClickedHandler(element, anchor, ev) : false;
}
function $aa728000c38af56f$var$raiseExecuteActionEvent(action) {
    var card = action.parent ? action.parent.getRootElement() : undefined;
    var onExecuteActionHandler = card && card.onExecuteAction ? card.onExecuteAction : $aa728000c38af56f$var$AdaptiveCard.onExecuteAction;
    if (action.prepareForExecution() && onExecuteActionHandler) onExecuteActionHandler(action);
}
function $aa728000c38af56f$var$raiseInlineCardExpandedEvent(action, isExpanded) {
    var card = action.parent ? action.parent.getRootElement() : undefined;
    var onInlineCardExpandedHandler = card && card.onInlineCardExpanded ? card.onInlineCardExpanded : $aa728000c38af56f$var$AdaptiveCard.onInlineCardExpanded;
    if (onInlineCardExpandedHandler) onInlineCardExpandedHandler(action, isExpanded);
}
function $aa728000c38af56f$var$raiseInputValueChangedEvent(input) {
    var card = input.getRootElement();
    var onInputValueChangedHandler = card && card.onInputValueChanged ? card.onInputValueChanged : $aa728000c38af56f$var$AdaptiveCard.onInputValueChanged;
    if (onInputValueChangedHandler) onInputValueChangedHandler(input);
}
function $aa728000c38af56f$var$raiseElementVisibilityChangedEvent(element, shouldUpdateLayout) {
    if (shouldUpdateLayout === void 0) shouldUpdateLayout = true;
    var rootElement = element.getRootElement();
    if (shouldUpdateLayout) rootElement.updateLayout();
    var card = rootElement;
    var onElementVisibilityChangedHandler = card && card.onElementVisibilityChanged ? card.onElementVisibilityChanged : $aa728000c38af56f$var$AdaptiveCard.onElementVisibilityChanged;
    if (onElementVisibilityChangedHandler !== undefined) onElementVisibilityChangedHandler(element);
}
function $aa728000c38af56f$var$updateInputAdornersVisibility(input, hide) {
    if (!!hide) {
        // hides the time/date picker icon
        input.readOnly = true;
        // hides the cross button icon
        input.required = true;
    } else {
        // shows the time/date picker icon
        input.readOnly = false;
        // shows the cross button icon
        input.required = false;
    }
}
/**
 * @returns return false to continue with default context menu; return true to skip SDK default context menu
 */ function $aa728000c38af56f$var$raiseDisplayOverflowActionMenuEvent(action, target) {
    var card = action.parent ? action.parent.getRootElement() : undefined;
    var onDisplayOverflowActionMenuHandler = card && card.onDisplayOverflowActionMenu ? card.onDisplayOverflowActionMenu : $aa728000c38af56f$var$AdaptiveCard.onDisplayOverflowActionMenu;
    return onDisplayOverflowActionMenuHandler !== undefined ? onDisplayOverflowActionMenuHandler(action.getActions(), target) : false;
}
/**
 * @returns return false to continue with default action button; return true to skip SDK default action button
 */ function $aa728000c38af56f$var$raiseRenderOverflowActionsEvent(action, isAtRootLevelActions) {
    var card = action.parent ? action.parent.getRootElement() : undefined;
    var onRenderOverflowActionsHandler = card && card.onRenderOverflowActions ? card.onRenderOverflowActions : $aa728000c38af56f$var$AdaptiveCard.onRenderOverflowActions;
    return onRenderOverflowActionsHandler !== undefined ? onRenderOverflowActionsHandler(action.getActions(), isAtRootLevelActions) : false;
}
var $aa728000c38af56f$var$ContainerWithActions = /** @class */ function(_super) {
    $aa728000c38af56f$var$__extends(ContainerWithActions, _super);
    function ContainerWithActions() {
        var _this = _super.call(this) || this;
        _this._actionCollection = new $aa728000c38af56f$var$ActionCollection(_this);
        return _this;
    }
    ContainerWithActions.prototype.internalParse = function(source, context) {
        _super.prototype.internalParse.call(this, source, context);
        this.parseActions(source, context);
    };
    ContainerWithActions.prototype.parseActions = function(source, context) {
        this._actionCollection.parse(source["actions"], context);
    };
    ContainerWithActions.prototype.internalToJSON = function(target, context) {
        _super.prototype.internalToJSON.call(this, target, context);
        this._actionCollection.toJSON(target, "actions", context);
    };
    ContainerWithActions.prototype.internalRender = function() {
        var element = _super.prototype.internalRender.call(this);
        if (element) {
            var renderedActions = this._actionCollection.render(this.hostConfig.actions.actionsOrientation);
            if (renderedActions) {
                $8QA0A.appendChild(element, $aa728000c38af56f$var$renderSeparation(this.hostConfig, {
                    spacing: this.hostConfig.getEffectiveSpacing(this.hostConfig.actions.spacing)
                }, $kD48O.Orientation.Horizontal));
                $8QA0A.appendChild(element, renderedActions);
            }
            if (this.renderIfEmpty) return element;
            else return element.children.length > 0 ? element : undefined;
        } else return undefined;
    };
    ContainerWithActions.prototype.getHasExpandedAction = function() {
        if (this.renderedActionCount === 0) return false;
        else if (this.renderedActionCount === 1) return this._actionCollection.expandedAction !== undefined && !this.hostConfig.actions.preExpandSingleShowCardAction;
        else return this._actionCollection.expandedAction !== undefined;
    };
    Object.defineProperty(ContainerWithActions.prototype, "renderedActionCount", {
        get: function() {
            return this._actionCollection.renderedActionCount;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ContainerWithActions.prototype, "renderIfEmpty", {
        get: function() {
            return false;
        },
        enumerable: false,
        configurable: true
    });
    ContainerWithActions.prototype.releaseDOMResources = function() {
        _super.prototype.releaseDOMResources.call(this);
        this._actionCollection.releaseDOMResources();
    };
    ContainerWithActions.prototype.getActionCount = function() {
        return this._actionCollection.getActionCount();
    };
    ContainerWithActions.prototype.getActionAt = function(index) {
        if (index >= 0 && index < this.getActionCount()) return this._actionCollection.getActionAt(index);
        else return _super.prototype.getActionAt.call(this, index);
    };
    ContainerWithActions.prototype.getActionById = function(id) {
        var result = this._actionCollection.getActionById(id);
        return result ? result : _super.prototype.getActionById.call(this, id);
    };
    ContainerWithActions.prototype.internalValidateProperties = function(context) {
        _super.prototype.internalValidateProperties.call(this, context);
        if (this._actionCollection) this._actionCollection.validateProperties(context);
    };
    ContainerWithActions.prototype.isLastElement = function(element) {
        return _super.prototype.isLastElement.call(this, element) && this._actionCollection.getActionCount() === 0;
    };
    ContainerWithActions.prototype.addAction = function(action) {
        this._actionCollection.addAction(action);
    };
    ContainerWithActions.prototype.clear = function() {
        _super.prototype.clear.call(this);
        this._actionCollection.clear();
    };
    ContainerWithActions.prototype.getAllInputs = function(processActions) {
        if (processActions === void 0) processActions = true;
        var result = _super.prototype.getAllInputs.call(this, processActions);
        if (processActions) result.push.apply(result, this._actionCollection.getAllInputs(processActions));
        return result;
    };
    ContainerWithActions.prototype.getResourceInformation = function() {
        var result = _super.prototype.getResourceInformation.call(this);
        result.push.apply(result, this._actionCollection.getResourceInformation());
        return result;
    };
    ContainerWithActions.prototype.isBleedingAtBottom = function() {
        if (this._actionCollection.renderedActionCount === 0) return _super.prototype.isBleedingAtBottom.call(this);
        else {
            if (this._actionCollection.getActionCount() === 1) return this._actionCollection.expandedAction !== undefined && !this.hostConfig.actions.preExpandSingleShowCardAction;
            else return this._actionCollection.expandedAction !== undefined;
        }
    };
    ContainerWithActions.prototype.getForbiddenActionNames = function() {
        return [];
    };
    ContainerWithActions.prototype.getElementById = function(id) {
        var result = _super.prototype.getElementById.call(this, id);
        if (!result) result = this.getElementByIdFromAction(id);
        return result;
    };
    Object.defineProperty(ContainerWithActions.prototype, "isStandalone", {
        get: function() {
            return false;
        },
        enumerable: false,
        configurable: true
    });
    return ContainerWithActions;
}($aa728000c38af56f$var$Container);
module.exports.ContainerWithActions = $aa728000c38af56f$var$ContainerWithActions;
var $aa728000c38af56f$var$RefreshActionProperty = /** @class */ function(_super) {
    $aa728000c38af56f$var$__extends(RefreshActionProperty, _super);
    function RefreshActionProperty(targetVersion, name) {
        var _this = _super.call(this, targetVersion, name, undefined) || this;
        _this.targetVersion = targetVersion;
        _this.name = name;
        return _this;
    }
    RefreshActionProperty.prototype.parse = function(sender, source, context) {
        var action = context.parseAction(sender.parent, source[this.name], [], false);
        if (action !== undefined) {
            if (action instanceof $aa728000c38af56f$var$ExecuteAction) return action;
            context.logParseEvent(sender, $kD48O.ValidationEvent.ActionTypeNotAllowed, $c6BU9.Strings.errors.actionTypeNotAllowed(action.getJsonTypeName()));
        }
        context.logParseEvent(sender, $kD48O.ValidationEvent.PropertyCantBeNull, $c6BU9.Strings.errors.propertyMustBeSet("action"));
        return undefined;
    };
    RefreshActionProperty.prototype.toJSON = function(sender, target, value, context) {
        context.serializeValue(target, this.name, value ? value.toJSON(context) : undefined, undefined, true);
    };
    return RefreshActionProperty;
}($eZfTX.PropertyDefinition);
module.exports.RefreshActionProperty = $aa728000c38af56f$var$RefreshActionProperty;
var $aa728000c38af56f$var$RefreshDefinition = /** @class */ function(_super) {
    $aa728000c38af56f$var$__extends(RefreshDefinition, _super);
    function RefreshDefinition() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(RefreshDefinition.prototype, "action", {
        get: function() {
            return this.getValue(RefreshDefinition.actionProperty);
        },
        set: function(value) {
            this.setValue(RefreshDefinition.actionProperty, value);
            if (value) value.setParent(this.parent);
        },
        enumerable: false,
        configurable: true
    });
    RefreshDefinition.prototype.getSchemaKey = function() {
        return "RefreshDefinition";
    };
    //#region Schema
    RefreshDefinition.actionProperty = new $aa728000c38af56f$var$RefreshActionProperty($eZfTX.Versions.v1_4, "action");
    RefreshDefinition.userIdsProperty = new $eZfTX.StringArrayProperty($eZfTX.Versions.v1_4, "userIds");
    $aa728000c38af56f$var$__decorate([
        (0, $eZfTX.property)(RefreshDefinition.actionProperty)
    ], RefreshDefinition.prototype, "action", null);
    $aa728000c38af56f$var$__decorate([
        (0, $eZfTX.property)(RefreshDefinition.userIdsProperty)
    ], RefreshDefinition.prototype, "userIds", void 0);
    return RefreshDefinition;
}($eZfTX.SerializableObject);
module.exports.RefreshDefinition = $aa728000c38af56f$var$RefreshDefinition;
var $aa728000c38af56f$var$AuthCardButton = /** @class */ function(_super) {
    $aa728000c38af56f$var$__extends(AuthCardButton, _super);
    function AuthCardButton() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AuthCardButton.prototype.getSchemaKey = function() {
        return "AuthCardButton";
    };
    //#region Schema
    AuthCardButton.typeProperty = new $eZfTX.StringProperty($eZfTX.Versions.v1_4, "type");
    AuthCardButton.titleProperty = new $eZfTX.StringProperty($eZfTX.Versions.v1_4, "title");
    AuthCardButton.imageProperty = new $eZfTX.StringProperty($eZfTX.Versions.v1_4, "image");
    AuthCardButton.valueProperty = new $eZfTX.StringProperty($eZfTX.Versions.v1_4, "value");
    $aa728000c38af56f$var$__decorate([
        (0, $eZfTX.property)(AuthCardButton.typeProperty)
    ], AuthCardButton.prototype, "type", void 0);
    $aa728000c38af56f$var$__decorate([
        (0, $eZfTX.property)(AuthCardButton.titleProperty)
    ], AuthCardButton.prototype, "title", void 0);
    $aa728000c38af56f$var$__decorate([
        (0, $eZfTX.property)(AuthCardButton.imageProperty)
    ], AuthCardButton.prototype, "image", void 0);
    $aa728000c38af56f$var$__decorate([
        (0, $eZfTX.property)(AuthCardButton.valueProperty)
    ], AuthCardButton.prototype, "value", void 0);
    return AuthCardButton;
}($eZfTX.SerializableObject);
module.exports.AuthCardButton = $aa728000c38af56f$var$AuthCardButton;
var $aa728000c38af56f$var$TokenExchangeResource = /** @class */ function(_super) {
    $aa728000c38af56f$var$__extends(TokenExchangeResource, _super);
    function TokenExchangeResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TokenExchangeResource.prototype.getSchemaKey = function() {
        return "TokenExchangeResource";
    };
    //#region Schema
    TokenExchangeResource.idProperty = new $eZfTX.StringProperty($eZfTX.Versions.v1_4, "id");
    TokenExchangeResource.uriProperty = new $eZfTX.StringProperty($eZfTX.Versions.v1_4, "uri");
    TokenExchangeResource.providerIdProperty = new $eZfTX.StringProperty($eZfTX.Versions.v1_4, "providerId");
    $aa728000c38af56f$var$__decorate([
        (0, $eZfTX.property)(TokenExchangeResource.idProperty)
    ], TokenExchangeResource.prototype, "id", void 0);
    $aa728000c38af56f$var$__decorate([
        (0, $eZfTX.property)(TokenExchangeResource.uriProperty)
    ], TokenExchangeResource.prototype, "uri", void 0);
    $aa728000c38af56f$var$__decorate([
        (0, $eZfTX.property)(TokenExchangeResource.providerIdProperty)
    ], TokenExchangeResource.prototype, "providerId", void 0);
    return TokenExchangeResource;
}($eZfTX.SerializableObject);
module.exports.TokenExchangeResource = $aa728000c38af56f$var$TokenExchangeResource;
var $aa728000c38af56f$var$Authentication = /** @class */ function(_super) {
    $aa728000c38af56f$var$__extends(Authentication, _super);
    function Authentication() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Authentication.prototype.getSchemaKey = function() {
        return "Authentication";
    };
    //#region Schema
    Authentication.textProperty = new $eZfTX.StringProperty($eZfTX.Versions.v1_4, "text");
    Authentication.connectionNameProperty = new $eZfTX.StringProperty($eZfTX.Versions.v1_4, "connectionName");
    Authentication.buttonsProperty = new $eZfTX.SerializableObjectCollectionProperty($eZfTX.Versions.v1_4, "buttons", $aa728000c38af56f$var$AuthCardButton);
    Authentication.tokenExchangeResourceProperty = new $eZfTX.SerializableObjectProperty($eZfTX.Versions.v1_4, "tokenExchangeResource", $aa728000c38af56f$var$TokenExchangeResource, true);
    $aa728000c38af56f$var$__decorate([
        (0, $eZfTX.property)(Authentication.textProperty)
    ], Authentication.prototype, "text", void 0);
    $aa728000c38af56f$var$__decorate([
        (0, $eZfTX.property)(Authentication.connectionNameProperty)
    ], Authentication.prototype, "connectionName", void 0);
    $aa728000c38af56f$var$__decorate([
        (0, $eZfTX.property)(Authentication.buttonsProperty)
    ], Authentication.prototype, "buttons", void 0);
    $aa728000c38af56f$var$__decorate([
        (0, $eZfTX.property)(Authentication.tokenExchangeResourceProperty)
    ], Authentication.prototype, "tokenExchangeResource", void 0);
    return Authentication;
}($eZfTX.SerializableObject);
module.exports.Authentication = $aa728000c38af56f$var$Authentication;
// @dynamic
var $aa728000c38af56f$var$AdaptiveCard = /** @class */ function(_super) {
    $aa728000c38af56f$var$__extends(AdaptiveCard, _super);
    function AdaptiveCard() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.designMode = false;
        return _this;
    }
    Object.defineProperty(AdaptiveCard.prototype, "refresh", {
        get: function() {
            return this.getValue(AdaptiveCard.refreshProperty);
        },
        set: function(value) {
            this.setValue(AdaptiveCard.refreshProperty, value);
            if (value) value.parent = this;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AdaptiveCard, "processMarkdown", {
        get: function() {
            throw new Error($c6BU9.Strings.errors.processMarkdownEventRemoved());
        },
        // eslint-disable-next-line @typescript-eslint/naming-convention
        set: function(_value) {
            throw new Error($c6BU9.Strings.errors.processMarkdownEventRemoved());
        },
        enumerable: false,
        configurable: true
    });
    AdaptiveCard.applyMarkdown = function(text) {
        var result = {
            didProcess: false
        };
        if (AdaptiveCard.onProcessMarkdown) AdaptiveCard.onProcessMarkdown(text, result);
        else if (window.markdownit) {
            // Check for markdownit
            var markdownIt = window.markdownit;
            result.outputHtml = markdownIt().render(text);
            result.didProcess = true;
        } else if (!AdaptiveCard._haveWarnedAboutNoMarkdownProcessing) {
            // eslint-disable-next-line no-console
            console.warn($c6BU9.Strings.errors.markdownProcessingNotEnabled);
            AdaptiveCard._haveWarnedAboutNoMarkdownProcessing = true;
        }
        return result;
    };
    AdaptiveCard.prototype.isVersionSupported = function() {
        if (this.bypassVersionCheck) return true;
        else {
            var unsupportedVersion = !this.version || !this.version.isValid || this.maxVersion.major < this.version.major || this.maxVersion.major === this.version.major && this.maxVersion.minor < this.version.minor;
            return !unsupportedVersion;
        }
    };
    AdaptiveCard.prototype.getDefaultSerializationContext = function() {
        return new $aa728000c38af56f$var$SerializationContext(this.version);
    };
    AdaptiveCard.prototype.getItemsCollectionPropertyName = function() {
        return "body";
    };
    AdaptiveCard.prototype.internalParse = function(source, context) {
        this._fallbackCard = undefined;
        var fallbackElement = context.parseElement(undefined, source["fallback"], this.forbiddenChildElements(), !this.isDesignMode());
        if (fallbackElement) {
            this._fallbackCard = new AdaptiveCard();
            this._fallbackCard.addItem(fallbackElement);
        }
        _super.prototype.internalParse.call(this, source, context);
    };
    AdaptiveCard.prototype.internalToJSON = function(target, context) {
        this.setValue(AdaptiveCard.versionProperty, context.targetVersion);
        _super.prototype.internalToJSON.call(this, target, context);
    };
    AdaptiveCard.prototype.internalRender = function() {
        var renderedElement = _super.prototype.internalRender.call(this);
        if ($8Lw6d.GlobalSettings.useAdvancedCardBottomTruncation && renderedElement) // Unlike containers, the root card element should be allowed to
        // be shorter than its content (otherwise the overflow truncation
        // logic would never get triggered)
        renderedElement.style.removeProperty("minHeight");
        return renderedElement;
    };
    AdaptiveCard.prototype.getHasBackground = function(ignoreBackgroundImages) {
        if (ignoreBackgroundImages === void 0) ignoreBackgroundImages = false;
        return true;
    };
    AdaptiveCard.prototype.getDefaultPadding = function() {
        return new $8Lw6d.PaddingDefinition($kD48O.Spacing.Padding, $kD48O.Spacing.Padding, $kD48O.Spacing.Padding, $kD48O.Spacing.Padding);
    };
    AdaptiveCard.prototype.shouldSerialize = function(_context) {
        return true;
    };
    Object.defineProperty(AdaptiveCard.prototype, "renderIfEmpty", {
        get: function() {
            return true;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AdaptiveCard.prototype, "bypassVersionCheck", {
        get: function() {
            return false;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AdaptiveCard.prototype, "allowCustomStyle", {
        get: function() {
            return this.hostConfig.adaptiveCard && this.hostConfig.adaptiveCard.allowCustomStyle;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AdaptiveCard.prototype, "hasBackground", {
        get: function() {
            return true;
        },
        enumerable: false,
        configurable: true
    });
    AdaptiveCard.prototype.getJsonTypeName = function() {
        return "AdaptiveCard";
    };
    AdaptiveCard.prototype.internalValidateProperties = function(context) {
        _super.prototype.internalValidateProperties.call(this, context);
        if (this.getValue($aa728000c38af56f$var$CardElement.typeNameProperty) !== "AdaptiveCard") context.addFailure(this, $kD48O.ValidationEvent.MissingCardType, $c6BU9.Strings.errors.invalidCardType());
        if (!this.bypassVersionCheck && !this.version) context.addFailure(this, $kD48O.ValidationEvent.PropertyCantBeNull, $c6BU9.Strings.errors.propertyMustBeSet("version"));
        else if (!this.isVersionSupported()) context.addFailure(this, $kD48O.ValidationEvent.UnsupportedCardVersion, $c6BU9.Strings.errors.unsupportedCardVersion(this.version.toString(), this.maxVersion.toString()));
    };
    AdaptiveCard.prototype.render = function(target) {
        var _this = this;
        var renderedCard;
        if (this.shouldFallback() && this._fallbackCard) {
            this._fallbackCard.hostConfig = this.hostConfig;
            renderedCard = this._fallbackCard.render();
        } else {
            renderedCard = _super.prototype.render.call(this);
            if (renderedCard) {
                renderedCard.classList.add(this.hostConfig.makeCssClassName("ac-adaptiveCard"));
                // Having a tabIndex on the root container for a card can mess up accessibility in some scenarios.
                // However, we've shipped this behavior before, and so can't just turn it off in a point release. For
                // now, to unblock accessibility scenarios for our customers, we've got an option to turn it off. In a
                // future release, we should strongly consider flipping the default such that we *don't* emit a tabIndex
                // by default.
                if ($8Lw6d.GlobalSettings.setTabIndexAtCardRoot) renderedCard.tabIndex = 0;
                if (this.speak) renderedCard.setAttribute("aria-label", this.speak);
                renderedCard.onmouseenter = function(ev) {
                    _this.updateInputsVisualState(true);
                };
                renderedCard.onmouseleave = function(ev) {
                    _this.updateInputsVisualState(false);
                };
                this.getRootElement().updateActionsEnabledState();
            }
        }
        if (target) {
            $8QA0A.appendChild(target, renderedCard);
            this.updateLayout();
        }
        return renderedCard;
    };
    AdaptiveCard.prototype.updateLayout = function(processChildren) {
        if (processChildren === void 0) processChildren = true;
        _super.prototype.updateLayout.call(this, processChildren);
        if ($8Lw6d.GlobalSettings.useAdvancedCardBottomTruncation && this.isDisplayed()) {
            var padding = this.hostConfig.getEffectiveSpacing($kD48O.Spacing.Default);
            // eslint-disable-next-line @typescript-eslint/no-unnecessary-type-assertion
            this["handleOverflow"](this.renderedElement.offsetHeight - padding);
        }
    };
    AdaptiveCard.prototype.shouldFallback = function() {
        return _super.prototype.shouldFallback.call(this) || !this.isVersionSupported();
    };
    Object.defineProperty(AdaptiveCard.prototype, "hasVisibleSeparator", {
        get: function() {
            return false;
        },
        enumerable: false,
        configurable: true
    });
    AdaptiveCard.schemaUrl = "http://adaptivecards.io/schemas/adaptive-card.json";
    //#region Schema
    // eslint-disable-next-line @typescript-eslint/naming-convention
    AdaptiveCard.$schemaProperty = new $eZfTX.CustomProperty($eZfTX.Versions.v1_0, "$schema", function(sender, property, source, context) {
        return AdaptiveCard.schemaUrl;
    }, function(sender, prop, target, value, context) {
        context.serializeValue(target, prop.name, AdaptiveCard.schemaUrl);
    });
    AdaptiveCard.versionProperty = new $eZfTX.CustomProperty($eZfTX.Versions.v1_0, "version", function(sender, prop, source, context) {
        var version = $eZfTX.Version.parse(source[prop.name], context);
        if (version === undefined) {
            version = $eZfTX.Versions.latest;
            context.logParseEvent(sender, $kD48O.ValidationEvent.InvalidPropertyValue, $c6BU9.Strings.errors.invalidCardVersion(version.toString()));
        }
        return version;
    }, function(sender, prop, target, value, context) {
        if (value !== undefined) context.serializeValue(target, prop.name, value.toString());
    }, $eZfTX.Versions.v1_0);
    AdaptiveCard.fallbackTextProperty = new $eZfTX.StringProperty($eZfTX.Versions.v1_0, "fallbackText");
    AdaptiveCard.speakProperty = new $eZfTX.StringProperty($eZfTX.Versions.v1_0, "speak");
    AdaptiveCard.refreshProperty = new $eZfTX.SerializableObjectProperty($eZfTX.Versions.v1_4, "refresh", $aa728000c38af56f$var$RefreshDefinition, true);
    AdaptiveCard.authenticationProperty = new $eZfTX.SerializableObjectProperty($eZfTX.Versions.v1_4, "authentication", $aa728000c38af56f$var$Authentication, true);
    //#endregion
    AdaptiveCard._haveWarnedAboutNoMarkdownProcessing = false;
    $aa728000c38af56f$var$__decorate([
        (0, $eZfTX.property)(AdaptiveCard.versionProperty)
    ], AdaptiveCard.prototype, "version", void 0);
    $aa728000c38af56f$var$__decorate([
        (0, $eZfTX.property)(AdaptiveCard.fallbackTextProperty)
    ], AdaptiveCard.prototype, "fallbackText", void 0);
    $aa728000c38af56f$var$__decorate([
        (0, $eZfTX.property)(AdaptiveCard.speakProperty)
    ], AdaptiveCard.prototype, "speak", void 0);
    $aa728000c38af56f$var$__decorate([
        (0, $eZfTX.property)(AdaptiveCard.refreshProperty)
    ], AdaptiveCard.prototype, "refresh", null);
    $aa728000c38af56f$var$__decorate([
        (0, $eZfTX.property)(AdaptiveCard.authenticationProperty)
    ], AdaptiveCard.prototype, "authentication", void 0);
    return AdaptiveCard;
}($aa728000c38af56f$var$ContainerWithActions);
module.exports.AdaptiveCard = $aa728000c38af56f$var$AdaptiveCard;
var $aa728000c38af56f$var$InlineAdaptiveCard = /** @class */ function(_super) {
    $aa728000c38af56f$var$__extends(InlineAdaptiveCard, _super);
    function InlineAdaptiveCard() {
        //#region Schema
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.suppressStyle = false;
        return _this;
    }
    InlineAdaptiveCard.prototype.getSchemaKey = function() {
        return "InlineAdaptiveCard";
    };
    InlineAdaptiveCard.prototype.populateSchema = function(schema) {
        _super.prototype.populateSchema.call(this, schema);
        schema.remove($aa728000c38af56f$var$AdaptiveCard.$schemaProperty, $aa728000c38af56f$var$AdaptiveCard.versionProperty);
    };
    //#endregion
    InlineAdaptiveCard.prototype.getDefaultPadding = function() {
        return new $8Lw6d.PaddingDefinition(this.suppressStyle ? $kD48O.Spacing.None : $kD48O.Spacing.Padding, $kD48O.Spacing.Padding, this.suppressStyle ? $kD48O.Spacing.None : $kD48O.Spacing.Padding, $kD48O.Spacing.Padding);
    };
    Object.defineProperty(InlineAdaptiveCard.prototype, "bypassVersionCheck", {
        get: function() {
            return true;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InlineAdaptiveCard.prototype, "defaultStyle", {
        get: function() {
            if (this.suppressStyle) return $kD48O.ContainerStyle.Default;
            else return this.hostConfig.actions.showCard.style ? this.hostConfig.actions.showCard.style : $kD48O.ContainerStyle.Emphasis;
        },
        enumerable: false,
        configurable: true
    });
    InlineAdaptiveCard.prototype.render = function(target) {
        var renderedCard = _super.prototype.render.call(this, target);
        if (renderedCard) {
            renderedCard.setAttribute("aria-live", "polite");
            renderedCard.removeAttribute("tabindex");
        }
        return renderedCard;
    };
    return InlineAdaptiveCard;
}($aa728000c38af56f$var$AdaptiveCard);
var $aa728000c38af56f$var$SerializationContext = /** @class */ function(_super) {
    $aa728000c38af56f$var$__extends(SerializationContext, _super);
    function SerializationContext() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._forbiddenTypes = new Set();
        return _this;
    }
    SerializationContext.prototype.internalParseCardObject = function(parent, source, forbiddenTypes, allowFallback, createInstanceCallback, logParseEvent) {
        var _this = this;
        var result = undefined;
        if (source && typeof source === "object") {
            var oldForbiddenTypes_1 = new Set();
            this._forbiddenTypes.forEach(function(type) {
                oldForbiddenTypes_1.add(type);
            });
            forbiddenTypes.forEach(function(type) {
                _this._forbiddenTypes.add(type);
            });
            var typeName = $8QA0A.parseString(source["type"]);
            if (typeName && this._forbiddenTypes.has(typeName)) logParseEvent(typeName, $kD48O.TypeErrorType.ForbiddenType);
            else {
                var tryToFallback = false;
                result = createInstanceCallback(typeName);
                if (!result) {
                    tryToFallback = $8Lw6d.GlobalSettings.enableFallback && allowFallback;
                    logParseEvent(typeName, $kD48O.TypeErrorType.UnknownType);
                } else {
                    result.setParent(parent);
                    result.parse(source, this);
                    tryToFallback = $8Lw6d.GlobalSettings.enableFallback && allowFallback && result.shouldFallback();
                }
                if (tryToFallback) {
                    var fallback = source["fallback"];
                    if (!fallback && parent) parent.setShouldFallback(true);
                    if (typeof fallback === "string" && fallback.toLowerCase() === "drop") result = undefined;
                    else if (typeof fallback === "object") result = this.internalParseCardObject(parent, fallback, forbiddenTypes, true, createInstanceCallback, logParseEvent);
                }
            }
            this._forbiddenTypes = oldForbiddenTypes_1;
        }
        return result;
    };
    SerializationContext.prototype.cardObjectParsed = function(o, source) {
        if (o instanceof $aa728000c38af56f$var$Action && this.onParseAction) this.onParseAction(o, source, this);
        else if (o instanceof $aa728000c38af56f$var$CardElement && this.onParseElement) this.onParseElement(o, source, this);
    };
    SerializationContext.prototype.shouldSerialize = function(o) {
        if (o instanceof $aa728000c38af56f$var$Action) return this.actionRegistry.findByName(o.getJsonTypeName()) !== undefined;
        else if (o instanceof $aa728000c38af56f$var$CardElement) return this.elementRegistry.findByName(o.getJsonTypeName()) !== undefined;
        else return true;
    };
    SerializationContext.prototype.parseCardObject = function(parent, source, forbiddenTypeNames, allowFallback, createInstanceCallback, logParseEvent) {
        var forbiddenTypes = new Set(forbiddenTypeNames);
        var result = this.internalParseCardObject(parent, source, forbiddenTypes, allowFallback, createInstanceCallback, logParseEvent);
        if (result !== undefined) this.cardObjectParsed(result, source);
        return result;
    };
    SerializationContext.prototype.parseElement = function(parent, source, forbiddenTypes, allowFallback) {
        var _this = this;
        return this.parseCardObject(parent, source, forbiddenTypes, allowFallback, function(typeName) {
            return _this.elementRegistry.createInstance(typeName, _this.targetVersion);
        }, function(typeName, errorType) {
            if (errorType === $kD48O.TypeErrorType.UnknownType) _this.logParseEvent(undefined, $kD48O.ValidationEvent.UnknownElementType, $c6BU9.Strings.errors.unknownElementType(typeName));
            else _this.logParseEvent(undefined, $kD48O.ValidationEvent.ElementTypeNotAllowed, $c6BU9.Strings.errors.elementTypeNotAllowed(typeName));
        });
    };
    SerializationContext.prototype.parseAction = function(parent, source, forbiddenActionTypes, allowFallback) {
        var _this = this;
        return this.parseCardObject(parent, source, forbiddenActionTypes, allowFallback, function(typeName) {
            return _this.actionRegistry.createInstance(typeName, _this.targetVersion);
        }, function(typeName, errorType) {
            if (errorType === $kD48O.TypeErrorType.UnknownType) _this.logParseEvent(undefined, $kD48O.ValidationEvent.UnknownActionType, $c6BU9.Strings.errors.unknownActionType(typeName));
            else _this.logParseEvent(undefined, $kD48O.ValidationEvent.ActionTypeNotAllowed, $c6BU9.Strings.errors.actionTypeNotAllowed(typeName));
        });
    };
    Object.defineProperty(SerializationContext.prototype, "elementRegistry", {
        get: function() {
            var _a;
            return (_a = this._elementRegistry) !== null && _a !== void 0 ? _a : $hfx8W.GlobalRegistry.elements;
        },
        enumerable: false,
        configurable: true
    });
    // Not using a property setter here because the setter should accept "undefined"
    // whereas the getter should never return undefined.
    SerializationContext.prototype.setElementRegistry = function(value) {
        this._elementRegistry = value;
    };
    Object.defineProperty(SerializationContext.prototype, "actionRegistry", {
        get: function() {
            var _a;
            return (_a = this._actionRegistry) !== null && _a !== void 0 ? _a : $hfx8W.GlobalRegistry.actions;
        },
        enumerable: false,
        configurable: true
    });
    // Not using a property setter here because the setter should accept "undefined"
    // whereas the getter should never return undefined.
    SerializationContext.prototype.setActionRegistry = function(value) {
        this._actionRegistry = value;
    };
    return SerializationContext;
}($eZfTX.BaseSerializationContext);
module.exports.SerializationContext = $aa728000c38af56f$var$SerializationContext;
$hfx8W.GlobalRegistry.defaultElements.register("Container", $aa728000c38af56f$var$Container);
$hfx8W.GlobalRegistry.defaultElements.register("TextBlock", $aa728000c38af56f$var$TextBlock);
$hfx8W.GlobalRegistry.defaultElements.register("RichTextBlock", $aa728000c38af56f$var$RichTextBlock, $eZfTX.Versions.v1_2);
$hfx8W.GlobalRegistry.defaultElements.register("TextRun", $aa728000c38af56f$var$TextRun, $eZfTX.Versions.v1_2);
$hfx8W.GlobalRegistry.defaultElements.register("Image", $aa728000c38af56f$var$Image);
$hfx8W.GlobalRegistry.defaultElements.register("ImageSet", $aa728000c38af56f$var$ImageSet);
$hfx8W.GlobalRegistry.defaultElements.register("Media", $aa728000c38af56f$var$Media, $eZfTX.Versions.v1_1);
$hfx8W.GlobalRegistry.defaultElements.register("FactSet", $aa728000c38af56f$var$FactSet);
$hfx8W.GlobalRegistry.defaultElements.register("ColumnSet", $aa728000c38af56f$var$ColumnSet);
$hfx8W.GlobalRegistry.defaultElements.register("ActionSet", $aa728000c38af56f$var$ActionSet, $eZfTX.Versions.v1_2);
$hfx8W.GlobalRegistry.defaultElements.register("Input.Text", $aa728000c38af56f$var$TextInput);
$hfx8W.GlobalRegistry.defaultElements.register("Input.Date", $aa728000c38af56f$var$DateInput);
$hfx8W.GlobalRegistry.defaultElements.register("Input.Time", $aa728000c38af56f$var$TimeInput);
$hfx8W.GlobalRegistry.defaultElements.register("Input.Number", $aa728000c38af56f$var$NumberInput);
$hfx8W.GlobalRegistry.defaultElements.register("Input.ChoiceSet", $aa728000c38af56f$var$ChoiceSetInput);
$hfx8W.GlobalRegistry.defaultElements.register("Input.Toggle", $aa728000c38af56f$var$ToggleInput);
$hfx8W.GlobalRegistry.defaultActions.register($aa728000c38af56f$var$OpenUrlAction.JsonTypeName, $aa728000c38af56f$var$OpenUrlAction);
$hfx8W.GlobalRegistry.defaultActions.register($aa728000c38af56f$var$SubmitAction.JsonTypeName, $aa728000c38af56f$var$SubmitAction);
$hfx8W.GlobalRegistry.defaultActions.register($aa728000c38af56f$var$ShowCardAction.JsonTypeName, $aa728000c38af56f$var$ShowCardAction);
$hfx8W.GlobalRegistry.defaultActions.register($aa728000c38af56f$var$ToggleVisibilityAction.JsonTypeName, $aa728000c38af56f$var$ToggleVisibilityAction, $eZfTX.Versions.v1_2);
$hfx8W.GlobalRegistry.defaultActions.register($aa728000c38af56f$var$ExecuteAction.JsonTypeName, $aa728000c38af56f$var$ExecuteAction, $eZfTX.Versions.v1_4);

});
parcelRequire.register("hmlc3", function(module, exports) {
"use strict";
var $ca34ee4b15fe1b80$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.formatText = void 0;
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.
var $ca34ee4b15fe1b80$var$AbstractTextFormatter = /** @class */ function() {
    function AbstractTextFormatter(regularExpression) {
        this._regularExpression = regularExpression;
    }
    AbstractTextFormatter.prototype.format = function(lang, input) {
        var matches;
        if (input) {
            var result = input;
            while((matches = this._regularExpression.exec(input)) != null)result = result.replace(matches[0], this.internalFormat(lang, matches));
            return result;
        } else return input;
    };
    return AbstractTextFormatter;
}();
var $ca34ee4b15fe1b80$var$DateFormatter = /** @class */ function(_super) {
    $ca34ee4b15fe1b80$var$__extends(DateFormatter, _super);
    function DateFormatter() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DateFormatter.prototype.internalFormat = function(lang, matches) {
        var date = new Date(Date.parse(matches[1]));
        var format = matches[2] !== undefined ? matches[2].toLowerCase() : "compact";
        if (format !== "compact") return date.toLocaleDateString(lang, {
            day: "numeric",
            weekday: format,
            month: format,
            year: "numeric"
        });
        else return date.toLocaleDateString();
    };
    return DateFormatter;
}($ca34ee4b15fe1b80$var$AbstractTextFormatter);
var $ca34ee4b15fe1b80$var$TimeFormatter = /** @class */ function(_super) {
    $ca34ee4b15fe1b80$var$__extends(TimeFormatter, _super);
    function TimeFormatter() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TimeFormatter.prototype.internalFormat = function(lang, matches) {
        var date = new Date(Date.parse(matches[1]));
        return date.toLocaleTimeString(lang, {
            hour: "numeric",
            minute: "2-digit"
        });
    };
    return TimeFormatter;
}($ca34ee4b15fe1b80$var$AbstractTextFormatter);
function $ca34ee4b15fe1b80$var$formatText(lang, text) {
    var formatters = [
        new $ca34ee4b15fe1b80$var$DateFormatter(/\{{2}DATE\((\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:Z|(?:(?:-|\+)\d{2}:\d{2})))(?:, ?(COMPACT|LONG|SHORT))?\)\}{2}/g),
        new $ca34ee4b15fe1b80$var$TimeFormatter(/\{{2}TIME\((\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:Z|(?:(?:-|\+)\d{2}:\d{2})))\)\}{2}/g)
    ];
    var result = text;
    for(var _i = 0, formatters_1 = formatters; _i < formatters_1.length; _i++){
        var formatter = formatters_1[_i];
        result = formatter.format(lang, result);
    }
    return result;
}
module.exports.formatText = $ca34ee4b15fe1b80$var$formatText;

});

parcelRequire.register("HYaTY", function(module, exports) {
"use strict";
var $0842b1bc4c939660$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $0842b1bc4c939660$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) $0842b1bc4c939660$var$__createBinding(exports, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

// Copyright (C) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.
$0842b1bc4c939660$var$__exportStar((parcelRequire("31OKw")), module.exports);

$0842b1bc4c939660$var$__exportStar((parcelRequire("cy4Bt")), module.exports);

});
parcelRequire.register("31OKw", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MenuItem = void 0;

var $lHSNo = parcelRequire("lHSNo");

var $1FkCe = parcelRequire("1FkCe");
var $2348d4dceecb84e4$var$MenuItem = /** @class */ function() {
    function MenuItem(key, value) {
        this._isEnabled = true;
        this.key = key;
        this._value = value;
    }
    MenuItem.prototype.click = function() {
        if (this.isEnabled && this.onClick) this.onClick(this);
    };
    MenuItem.prototype.updateCssClasses = function() {
        if (this._element) {
            var effectiveHostConfig = this._hostConfig ? this._hostConfig : $lHSNo.defaultHostConfig;
            this._element.className = effectiveHostConfig.makeCssClassName("ac-ctrl");
            this._element.classList.add(effectiveHostConfig.makeCssClassName(this.isEnabled ? "ac-ctrl-dropdown-item" : "ac-ctrl-dropdown-item-disabled"));
            if (!this.isEnabled) this._element.classList.add(effectiveHostConfig.makeCssClassName("ac-disabled"));
        }
    };
    MenuItem.prototype.toString = function() {
        return this.value;
    };
    MenuItem.prototype.render = function(hostConfig) {
        var _this = this;
        this._hostConfig = hostConfig;
        if (!this._element) {
            this._element = document.createElement("span");
            this._element.innerText = this.value;
            this._element.setAttribute("role", "menuitem");
            if (!this.isEnabled) this._element.setAttribute("aria-disabled", "true");
            this._element.setAttribute("aria-current", "false");
            this._element.onmouseup = function(_e) {
                _this.click();
            };
            this._element.onkeydown = function(e) {
                if (e.key === $1FkCe.Constants.keys.enter) {
                    e.cancelBubble = true;
                    _this.click();
                }
            };
            this.updateCssClasses();
        }
        return this._element;
    };
    Object.defineProperty(MenuItem.prototype, "value", {
        get: function() {
            return this._value;
        },
        set: function(newValue) {
            this._value = newValue;
            if (this._element) this._element.innerText = newValue;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MenuItem.prototype, "isEnabled", {
        get: function() {
            return this._isEnabled;
        },
        set: function(value) {
            if (this._isEnabled !== value) {
                this._isEnabled = value;
                this.updateCssClasses();
            }
        },
        enumerable: false,
        configurable: true
    });
    return MenuItem;
}();
module.exports.MenuItem = $2348d4dceecb84e4$var$MenuItem;

});
parcelRequire.register("1FkCe", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Constants = void 0;
// eslint-disable-next-line @typescript-eslint/no-extraneous-class
var $13699c9e6dc72380$var$Constants = /** @class */ function() {
    function Constants() {}
    Constants.keys = {
        tab: "Tab",
        enter: "Enter",
        escape: "Escape",
        space: " ",
        up: "ArrowUp",
        down: "ArrowDown",
        delete: "Delete"
    };
    return Constants;
}();
module.exports.Constants = $13699c9e6dc72380$var$Constants;

});


parcelRequire.register("cy4Bt", function(module, exports) {
"use strict";
var $922c3b217d02ba7c$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PopupMenu = void 0;

var $1FkCe = parcelRequire("1FkCe");

var $jRZeV = parcelRequire("jRZeV");

var $djzkk = parcelRequire("djzkk");
var $922c3b217d02ba7c$var$PopupMenu = /** @class */ function(_super) {
    $922c3b217d02ba7c$var$__extends(PopupMenu, _super);
    function PopupMenu() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._items = new $jRZeV.Collection();
        _this._renderedItems = [];
        _this._selectedIndex = -1;
        return _this;
    }
    PopupMenu.prototype.renderContent = function() {
        var element = document.createElement("div");
        element.className = this.hostConfig.makeCssClassName("ac-ctrl ac-popup");
        element.setAttribute("role", "listbox");
        for(var i = 0; i < this._items.length; i++){
            var renderedItem = this._items.get(i).render(this.hostConfig);
            renderedItem.tabIndex = 0;
            element.appendChild(renderedItem);
            if (i === this.selectedIndex) renderedItem.focus();
            this._renderedItems.push(renderedItem);
        }
        return element;
    };
    PopupMenu.prototype.keyDown = function(e) {
        _super.prototype.keyDown.call(this, e);
        var selectedItemIndex = this._selectedIndex;
        switch(e.key){
            case $1FkCe.Constants.keys.tab:
                this.closePopup(true);
                break;
            /*
            case Constants.keys.enter:
                if (this.selectedIndex >= 0) {
                    this.selectedIndex = this.selectedIndex;

                    this.close();
                }

                break;
            */ case $1FkCe.Constants.keys.up:
                if (selectedItemIndex <= 0) selectedItemIndex = this._renderedItems.length - 1;
                else {
                    selectedItemIndex--;
                    if (selectedItemIndex < 0) selectedItemIndex = this._renderedItems.length - 1;
                }
                this.selectedIndex = selectedItemIndex;
                e.cancelBubble = true;
                break;
            case $1FkCe.Constants.keys.down:
                if (selectedItemIndex < 0) selectedItemIndex = 0;
                else {
                    selectedItemIndex++;
                    if (selectedItemIndex >= this._renderedItems.length) selectedItemIndex = 0;
                }
                this.selectedIndex = selectedItemIndex;
                e.cancelBubble = true;
                break;
        }
    };
    Object.defineProperty(PopupMenu.prototype, "items", {
        get: function() {
            return this._items;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PopupMenu.prototype, "selectedIndex", {
        get: function() {
            return this._selectedIndex;
        },
        set: function(index) {
            if (index >= 0 && index < this._renderedItems.length) {
                this._renderedItems[index].focus();
                this._selectedIndex = index;
            }
        },
        enumerable: false,
        configurable: true
    });
    return PopupMenu;
}($djzkk.PopupControl);
module.exports.PopupMenu = $922c3b217d02ba7c$var$PopupMenu;

});
parcelRequire.register("jRZeV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Collection = void 0;
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.
var $e772787f4fabeae9$var$Collection = /** @class */ function() {
    function Collection() {
        this._items = [];
    }
    Collection.prototype.get = function(index) {
        return this._items[index];
    };
    Collection.prototype.add = function(item) {
        this._items.push(item);
        if (this.onItemAdded) this.onItemAdded(item);
    };
    Collection.prototype.remove = function(item) {
        var i = this._items.indexOf(item);
        if (i >= 0) {
            this._items = this._items.splice(i, 1);
            if (this.onItemRemoved) this.onItemRemoved(item);
        }
    };
    Collection.prototype.indexOf = function(item) {
        return this._items.indexOf(item);
    };
    Object.defineProperty(Collection.prototype, "length", {
        get: function() {
            return this._items.length;
        },
        enumerable: false,
        configurable: true
    });
    return Collection;
}();
module.exports.Collection = $e772787f4fabeae9$var$Collection;

});

parcelRequire.register("djzkk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PopupControl = void 0;

var $1FkCe = parcelRequire("1FkCe");

var $8QA0A = parcelRequire("8QA0A");

var $lHSNo = parcelRequire("lHSNo");
var $9b1873ded60739d8$var$PopupControl = /** @class */ function() {
    function PopupControl() {
        this._isOpen = false;
    }
    PopupControl.prototype.keyDown = function(e) {
        switch(e.key){
            case $1FkCe.Constants.keys.escape:
                this.closePopup(true);
                break;
        }
    };
    PopupControl.prototype.render = function(_rootElementBounds) {
        var _this = this;
        var element = document.createElement("div");
        element.tabIndex = 0;
        element.className = this.hostConfig.makeCssClassName("ac-ctrl", "ac-ctrl-popup-container");
        element.setAttribute("role", "dialog");
        element.setAttribute("aria-modal", "true");
        element.onkeydown = function(e) {
            _this.keyDown(e);
            return !e.cancelBubble;
        };
        element.appendChild(this.renderContent());
        return element;
    };
    PopupControl.prototype.focus = function() {
        if (this._popupElement) this._popupElement.firstElementChild.focus();
    };
    PopupControl.prototype.popup = function(rootElement) {
        var _a, _b, _c, _d, _f;
        var _this = this;
        if (!this._isOpen) {
            this._overlayElement = document.createElement("div");
            this._overlayElement.className = this.hostConfig.makeCssClassName("ac-ctrl-overlay");
            this._overlayElement.tabIndex = 0;
            this._overlayElement.style.width = document.documentElement.scrollWidth + "px";
            this._overlayElement.style.height = document.documentElement.scrollHeight + "px";
            this._overlayElement.onfocus = function(_e) {
                _this.closePopup(true);
            };
            document.body.appendChild(this._overlayElement);
            var rootElementBounds = rootElement.getBoundingClientRect();
            this._popupElement = this.render(rootElementBounds);
            (_a = this._popupElement.classList).remove.apply(_a, this.hostConfig.makeCssClassNames("ac-ctrl-slide", "ac-ctrl-slideLeftToRight", "ac-ctrl-slideRightToLeft", "ac-ctrl-slideTopToBottom", "ac-ctrl-slideRightToLeft"));
            window.addEventListener("resize", function(_e) {
                _this.closePopup(true);
            });
            var rootElementLabel = rootElement.getAttribute("aria-label");
            if (rootElementLabel) this._popupElement.setAttribute("aria-label", rootElementLabel);
            this._overlayElement.appendChild(this._popupElement);
            var popupElementBounds = this._popupElement.getBoundingClientRect();
            var availableSpaceBelow = window.innerHeight - rootElementBounds.bottom;
            var availableSpaceAbove = rootElementBounds.top;
            var availableSpaceRight = window.innerWidth - rootElementBounds.right;
            var availableSpaceLeft = rootElementBounds.left;
            var left = rootElementBounds.left + $8QA0A.getScrollX();
            var top_1;
            if (availableSpaceAbove < popupElementBounds.height && availableSpaceBelow < popupElementBounds.height) {
                // Not enough space above or below root element
                var actualPopupHeight = Math.min(popupElementBounds.height, window.innerHeight);
                this._popupElement.style.maxHeight = actualPopupHeight + "px";
                if (actualPopupHeight < popupElementBounds.height) top_1 = $8QA0A.getScrollY();
                else top_1 = $8QA0A.getScrollY() + rootElementBounds.top + (rootElementBounds.height - actualPopupHeight) / 2;
                if (availableSpaceLeft < popupElementBounds.width && availableSpaceRight < popupElementBounds.width) {
                    // Not enough space left or right of root element
                    var actualPopupWidth = Math.min(popupElementBounds.width, window.innerWidth);
                    this._popupElement.style.maxWidth = actualPopupWidth + "px";
                    if (actualPopupWidth < popupElementBounds.width) left = $8QA0A.getScrollX();
                    else left = $8QA0A.getScrollX() + rootElementBounds.left + (rootElementBounds.width - actualPopupWidth) / 2;
                } else // Enough space on the left or right of the root element
                if (availableSpaceRight >= popupElementBounds.width) {
                    left = $8QA0A.getScrollX() + rootElementBounds.right;
                    (_b = this._popupElement.classList).add.apply(_b, this.hostConfig.makeCssClassNames("ac-ctrl-slide", "ac-ctrl-slideLeftToRight"));
                } else {
                    left = $8QA0A.getScrollX() + rootElementBounds.left - popupElementBounds.width;
                    (_c = this._popupElement.classList).add.apply(_c, this.hostConfig.makeCssClassNames("ac-ctrl-slide", "ac-ctrl-slideRightToLeft"));
                }
            } else {
                // Enough space above or below root element
                if (availableSpaceBelow >= popupElementBounds.height) {
                    top_1 = $8QA0A.getScrollY() + rootElementBounds.bottom;
                    (_d = this._popupElement.classList).add.apply(_d, this.hostConfig.makeCssClassNames("ac-ctrl-slide", "ac-ctrl-slideTopToBottom"));
                } else {
                    top_1 = $8QA0A.getScrollY() + rootElementBounds.top - popupElementBounds.height;
                    (_f = this._popupElement.classList).add.apply(_f, this.hostConfig.makeCssClassNames("ac-ctrl-slide", "ac-ctrl-slideBottomToTop"));
                }
                if (availableSpaceRight < popupElementBounds.width) left = $8QA0A.getScrollX() + rootElementBounds.right - popupElementBounds.width;
            }
            this._popupElement.style.left = left + "px";
            this._popupElement.style.top = top_1 + "px";
            this._popupElement.focus();
            this._isOpen = true;
        }
    };
    PopupControl.prototype.closePopup = function(wasCancelled) {
        if (this._isOpen) {
            document.body.removeChild(this._overlayElement);
            this._isOpen = false;
            if (this.onClose) this.onClose(this, wasCancelled);
        }
    };
    Object.defineProperty(PopupControl.prototype, "hostConfig", {
        get: function() {
            return this._hostConfig ? this._hostConfig : $lHSNo.defaultHostConfig;
        },
        set: function(value) {
            this._hostConfig = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PopupControl.prototype, "isOpen", {
        get: function() {
            return this._isOpen;
        },
        enumerable: false,
        configurable: true
    });
    return PopupControl;
}();
module.exports.PopupControl = $9b1873ded60739d8$var$PopupControl;

});




parcelRequire.register("2d7mp", function(module, exports) {
"use strict";
var $19c28146713faa0a$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $19c28146713faa0a$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $19c28146713faa0a$var$__spreadArray = module.exports && module.exports.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CarouselEvent = module.exports.Carousel = module.exports.CarouselPage = void 0;

var $eDhMr = parcelRequire("eDhMr");

var $kD48O = parcelRequire("kD48O");

var $eZfTX = parcelRequire("eZfTX");

var $hfx8W = parcelRequire("hfx8W");

var $kD48O = parcelRequire("kD48O");

var $c6BU9 = parcelRequire("c6BU9");
parcelRequire("inAoA");
var $eRV5Q = parcelRequire("eRV5Q");
var $fBOh1 = parcelRequire("fBOh1");
var $5pCsG = parcelRequire("5pCsG");
var $kIOmg = parcelRequire("kIOmg");
var $778og = parcelRequire("778og");
var $dHlcP = parcelRequire("dHlcP");
var $cxcfk = parcelRequire("cxcfk");
var $9TKxu = parcelRequire("9TKxu");

var $8QA0A = parcelRequire("8QA0A");

var $8Lw6d = parcelRequire("8Lw6d");
// Note: to function correctly, consumers need to have CSS from swiper/css, swiper/css/pagination, and
// swiper/css/navigation
var $19c28146713faa0a$var$CarouselPage = /** @class */ function(_super) {
    $19c28146713faa0a$var$__extends(CarouselPage, _super);
    function CarouselPage() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    //#region Schema
    CarouselPage.prototype.populateSchema = function(schema) {
        _super.prototype.populateSchema.call(this, schema);
        // `style`, `bleed`, `isVisible` are not supported in CarouselPage
        schema.remove($eDhMr.Container.styleProperty);
        schema.remove($eDhMr.Container.bleedProperty);
        schema.remove($eDhMr.Container.isVisibleProperty);
    };
    //#endregion
    CarouselPage.prototype.internalRender = function() {
        var carouselSlide = document.createElement("div");
        carouselSlide.className = this.hostConfig.makeCssClassName("swiper-slide");
        // `isRtl()` will set the correct value of rtl by reading the value from the parents
        this.rtl = this.isRtl();
        var renderedElement = _super.prototype.internalRender.call(this);
        $8QA0A.appendChild(carouselSlide, renderedElement);
        return carouselSlide;
    };
    CarouselPage.prototype.getForbiddenActionTypes = function() {
        return [
            $eDhMr.ShowCardAction,
            $eDhMr.ToggleVisibilityAction
        ];
    };
    CarouselPage.prototype.getForbiddenChildElements = function() {
        return this.forbiddenChildElements();
    };
    CarouselPage.prototype.forbiddenChildElements = function() {
        return $19c28146713faa0a$var$__spreadArray([
            $eDhMr.ToggleVisibilityAction.JsonTypeName,
            $eDhMr.ShowCardAction.JsonTypeName,
            "Media",
            "ActionSet",
            "Input.Text",
            "Input.Date",
            "Input.Time",
            "Input.Number",
            "Input.ChoiceSet",
            "Input.Toggle",
            "Carousel"
        ], _super.prototype.forbiddenChildElements.call(this), true);
    };
    CarouselPage.prototype.internalParse = function(source, context) {
        _super.prototype.internalParse.call(this, source, context);
        this.setShouldFallback(false);
    };
    CarouselPage.prototype.shouldSerialize = function(_context) {
        return true;
    };
    CarouselPage.prototype.getJsonTypeName = function() {
        return "CarouselPage";
    };
    Object.defineProperty(CarouselPage.prototype, "isStandalone", {
        get: function() {
            return false;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CarouselPage.prototype, "hasVisibleSeparator", {
        get: function() {
            return false;
        },
        enumerable: false,
        configurable: true
    });
    return CarouselPage;
}($eDhMr.Container);
module.exports.CarouselPage = $19c28146713faa0a$var$CarouselPage;
var $19c28146713faa0a$var$Carousel = /** @class */ function(_super) {
    $19c28146713faa0a$var$__extends(Carousel, _super);
    function Carousel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.carouselLoop = true;
        _this.carouselOrientation = $kD48O.Orientation.Horizontal;
        _this._pages = [];
        _this._currentIndex = 0;
        _this._previousEventType = $kD48O.CarouselInteractionEvent.Pagination;
        return _this;
    }
    //#region Schema
    Carousel.prototype.populateSchema = function(schema) {
        _super.prototype.populateSchema.call(this, schema);
        // `style`, `bleed`, `isVisible` are not supported in Carousel
        schema.remove($eDhMr.Container.styleProperty);
        schema.remove($eDhMr.Container.bleedProperty);
        schema.remove($eDhMr.Container.isVisibleProperty);
    };
    Object.defineProperty(Carousel.prototype, "timer", {
        get: function() {
            var timer = this.getValue(Carousel.timerProperty);
            if (timer && timer < this.hostConfig.carousel.minAutoplayDelay) {
                console.warn($c6BU9.Strings.errors.tooLittleTimeDelay);
                timer = this.hostConfig.carousel.minAutoplayDelay;
            }
            return timer;
        },
        set: function(value) {
            if (value && value < this.hostConfig.carousel.minAutoplayDelay) {
                console.warn($c6BU9.Strings.errors.tooLittleTimeDelay);
                this.setValue(Carousel.timerProperty, this.hostConfig.carousel.minAutoplayDelay);
            } else this.setValue(Carousel.timerProperty, value);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Carousel.prototype, "initialPageIndex", {
        get: function() {
            return this.getValue(Carousel.initialPageProperty);
        },
        set: function(value) {
            if (this.isValidParsedPageIndex(value)) this.setValue(Carousel.initialPageProperty, value);
            else {
                console.warn($c6BU9.Strings.errors.invalidInitialPageIndex(value));
                this.setValue(Carousel.initialPageProperty, 0);
            }
        },
        enumerable: false,
        configurable: true
    });
    Carousel.prototype.isValidParsedPageIndex = function(index) {
        return this._pages ? this.isValidPageIndex(index, this._pages.length) : false;
    };
    Carousel.prototype.isValidRenderedPageIndex = function(index) {
        return this._renderedPages ? this.isValidPageIndex(index, this._renderedPages.length) : false;
    };
    Carousel.prototype.isValidPageIndex = function(index, collectionSize) {
        return collectionSize > 0 && 0 <= index && index < collectionSize;
    };
    Object.defineProperty(Carousel.prototype, "previousEventType", {
        //#endregion
        get: function() {
            return this._previousEventType;
        },
        set: function(eventType) {
            this._previousEventType = eventType;
        },
        enumerable: false,
        configurable: true
    });
    // Question: Why do we place this on the Carousel instead of the CarouselPage?
    Carousel.prototype.forbiddenChildElements = function() {
        return $19c28146713faa0a$var$__spreadArray([
            $eDhMr.ToggleVisibilityAction.JsonTypeName,
            $eDhMr.ShowCardAction.JsonTypeName,
            "Media",
            "ActionSet",
            "Input.Text",
            "Input.Date",
            "Input.Time",
            "Input.Number",
            "Input.ChoiceSet",
            "Input.Toggle"
        ], _super.prototype.forbiddenChildElements.call(this), true);
    };
    Carousel.prototype.adjustRenderedElementSize = function(renderedElement) {
        _super.prototype.adjustRenderedElementSize.call(this, renderedElement);
        if (this.height == "stretch" && this._containerForAdorners !== undefined) this._containerForAdorners.style.height = "100%";
        // Assign the explicit height to carouselPageContainer if given
        if (this.carouselHeight) this._carouselPageContainer.style.height = this.carouselHeight + "px";
    };
    Carousel.prototype.getJsonTypeName = function() {
        return "Carousel";
    };
    Carousel.prototype.getItemCount = function() {
        return this._pages.length;
    };
    Carousel.prototype.getItemAt = function(index) {
        return this._pages[index];
    };
    Carousel.prototype.addPage = function(page) {
        this._pages.push(page);
        page.setParent(this);
    };
    Carousel.prototype.removeItem = function(item) {
        if (item instanceof $19c28146713faa0a$var$CarouselPage) {
            var itemIndex = this._pages.indexOf(item);
            if (itemIndex >= 0) {
                this._pages.splice(itemIndex, 1);
                item.setParent(undefined);
                this.updateLayout();
                return true;
            }
        }
        return false;
    };
    Carousel.prototype.getFirstVisibleRenderedItem = function() {
        var _a;
        if (this.renderedElement && ((_a = this._renderedPages) === null || _a === void 0 ? void 0 : _a.length) > 0) return this._renderedPages[0];
        else return undefined;
    };
    Carousel.prototype.getLastVisibleRenderedItem = function() {
        var _a;
        if (this.renderedElement && ((_a = this._renderedPages) === null || _a === void 0 ? void 0 : _a.length) > 0) return this._renderedPages[this._renderedPages.length - 1];
        else return undefined;
    };
    Object.defineProperty(Carousel.prototype, "currentPageId", {
        get: function() {
            var _a, _b;
            if ((_b = (_a = this._carousel) === null || _a === void 0 ? void 0 : _a.slides) === null || _b === void 0 ? void 0 : _b.length) {
                var activeSlide = this._carousel.slides[this._carousel.activeIndex];
                return activeSlide.id;
            }
            return undefined;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Carousel.prototype, "currentPageIndex", {
        get: function() {
            var _a;
            return (_a = this._carousel) === null || _a === void 0 ? void 0 : _a.realIndex;
        },
        enumerable: false,
        configurable: true
    });
    Carousel.prototype.internalParse = function(source, context) {
        _super.prototype.internalParse.call(this, source, context);
        this._pages = [];
        var jsonPages = source["pages"];
        if (Array.isArray(jsonPages)) for(var _i = 0, jsonPages_1 = jsonPages; _i < jsonPages_1.length; _i++){
            var item = jsonPages_1[_i];
            var page = this.createCarouselPageInstance(item, context);
            if (page) this._pages.push(page);
        }
        // everything is parsed do validate on initial page index
        this.validateParsing(context);
    };
    Carousel.prototype.validateParsing = function(context) {
        if (!this.isValidParsedPageIndex(this.initialPageIndex)) context.logParseEvent(this, $kD48O.ValidationEvent.InvalidPropertyValue, $c6BU9.Strings.errors.invalidInitialPageIndex(this.initialPageIndex));
    };
    Carousel.prototype.internalToJSON = function(target, context) {
        _super.prototype.internalToJSON.call(this, target, context);
        context.serializeArray(target, "pages", this._pages);
    };
    Carousel.prototype.internalRender = function() {
        var _a;
        this._renderedPages = [];
        if (this._pages.length <= 0) return undefined;
        this.validateOrientationProperties();
        var cardLevelContainer = document.createElement("div");
        cardLevelContainer.className = this.hostConfig.makeCssClassName("ac-carousel-card-level-container");
        var carouselContainer = document.createElement("div");
        carouselContainer.className = this.hostConfig.makeCssClassName("swiper", "ac-carousel");
        this._carouselPageContainer = carouselContainer;
        var containerForAdorners = document.createElement("div");
        containerForAdorners.className = this.hostConfig.makeCssClassName("ac-carousel-container");
        this._containerForAdorners = containerForAdorners;
        cardLevelContainer.appendChild(containerForAdorners);
        var navigationContainer = document.createElement("div");
        navigationContainer.className = this.hostConfig.makeCssClassName("ac-carousel-navigation");
        containerForAdorners.appendChild(navigationContainer);
        var carouselWrapper = document.createElement("div");
        carouselWrapper.className = this.hostConfig.makeCssClassName("swiper-wrapper", "ac-carousel-card-container");
        carouselWrapper.style.display = "flex";
        switch(this.getEffectiveVerticalContentAlignment()){
            case $kD48O.VerticalAlignment.Top:
                carouselWrapper.style.alignItems = "flex-start";
                break;
            case $kD48O.VerticalAlignment.Bottom:
                carouselWrapper.style.alignItems = "flex-end";
                break;
            default:
                carouselWrapper.style.alignItems = "center";
                break;
        }
        if ($8Lw6d.GlobalSettings.useAdvancedCardBottomTruncation) // Forces the container to be at least as tall as its content.
        //
        // Fixes a quirk in Chrome where, for nested flex elements, the
        // inner element's height would never exceed the outer element's
        // height. This caused overflow truncation to break -- containers
        // would always be measured as not overflowing, since their heights
        // were constrained by their parents as opposed to truly reflecting
        // the height of their content.
        //
        // See the "Browser Rendering Notes" section of this answer:
        // https://stackoverflow.com/questions/36247140/why-doesnt-flex-item-shrink-past-content-size
        carouselWrapper.style.minHeight = "-webkit-min-content";
        var prevElementDiv = document.createElement("div");
        prevElementDiv.className = this.hostConfig.makeCssClassName("swiper-button-prev");
        var nextElementDiv = document.createElement("div");
        nextElementDiv.className = this.hostConfig.makeCssClassName("swiper-button-next");
        if (this.carouselOrientation === $kD48O.Orientation.Horizontal) this.updateCssForHorizontalCarousel(prevElementDiv, nextElementDiv);
        else this.updateCssForVerticalCarousel(navigationContainer, prevElementDiv, nextElementDiv);
        var pagination = document.createElement("div");
        pagination.className = this.hostConfig.makeCssClassName("swiper-pagination", "ac-carousel-pagination");
        navigationContainer.appendChild(prevElementDiv);
        $8QA0A.addCancelSelectActionEventHandler(prevElementDiv);
        navigationContainer.appendChild(pagination);
        $8QA0A.addCancelSelectActionEventHandler(pagination);
        navigationContainer.appendChild(nextElementDiv);
        $8QA0A.addCancelSelectActionEventHandler(nextElementDiv);
        if (this.isDesignMode()) {
            // If we are in design mode, we need to ensure these elements are in front of the peers
            prevElementDiv.style.zIndex = "20";
            nextElementDiv.style.zIndex = "20";
            pagination.style.zIndex = "20";
        }
        var requestedNumberOfPages = Math.min(this._pages.length, this.hostConfig.carousel.maxCarouselPages);
        if (this._pages.length > this.hostConfig.carousel.maxCarouselPages) console.warn($c6BU9.Strings.errors.tooManyCarouselPages);
        if (this._pages.length > 0) for(var i = 0; i < requestedNumberOfPages; i++){
            var page = this._pages[i];
            var renderedItem = this.isElementAllowed(page) ? page.render() : undefined;
            renderedItem === null || renderedItem === void 0 || renderedItem.classList.add("ac-carousel-page");
            (_a = renderedItem === null || renderedItem === void 0 ? void 0 : renderedItem.children[0]) === null || _a === void 0 || _a.classList.add("ac-carousel-page-container");
            if (renderedItem) {
                $8QA0A.appendChild(carouselWrapper, renderedItem);
                this._renderedPages.push(page);
            }
        }
        carouselContainer.appendChild(carouselWrapper);
        carouselContainer.tabIndex = this.isDesignMode() ? -1 : 0;
        containerForAdorners.appendChild(carouselContainer);
        // `isRtl()` will set the correct value of rtl by reading the value from the parents
        this.rtl = this.isRtl();
        this.applyRTL(pagination);
        if (!this.isDesignMode()) {
            if (this.isValidRenderedPageIndex(this.initialPageIndex)) this._currentIndex = this.initialPageIndex;
            else {
                console.warn($c6BU9.Strings.errors.invalidInitialPageIndex(this.initialPageIndex));
                this._currentIndex = 0;
            }
        }
        this.initializeCarouselControl(carouselContainer, nextElementDiv, prevElementDiv, pagination, this.rtl);
        return this._renderedPages.length > 0 ? cardLevelContainer : undefined;
    };
    Carousel.prototype.applyRTL = function(pagination) {
        _super.prototype.applyRTL.call(this, this._carouselPageContainer);
        if (this.rtl) pagination.classList.add(this.hostConfig.makeCssClassName("ac-carousel-pagination-rtl"));
    };
    Carousel.prototype.validateOrientationProperties = function() {
        if (!this.carouselHeight) this.carouselOrientation = $kD48O.Orientation.Horizontal;
    };
    Carousel.prototype.updateCssForHorizontalCarousel = function(prevElementDiv, nextElementDiv) {
        prevElementDiv.classList.add(this.hostConfig.makeCssClassName("ac-carousel-left"));
        nextElementDiv.classList.add(this.hostConfig.makeCssClassName("ac-carousel-right"));
    };
    Carousel.prototype.updateCssForVerticalCarousel = function(navigationContainer, prevElementDiv, nextElementDiv) {
        this._containerForAdorners.classList.add(this.hostConfig.makeCssClassName("ac-carousel-container-vertical"));
        navigationContainer.classList.add(this.hostConfig.makeCssClassName("ac-carousel-navigation-vertical"));
        prevElementDiv.classList.add(this.hostConfig.makeCssClassName("ac-carousel-up"));
        nextElementDiv.classList.add(this.hostConfig.makeCssClassName("ac-carousel-down"));
    };
    Carousel.prototype.initializeCarouselControl = function(carouselContainer, nextElement, prevElement, paginationElement, rtl) {
        var _this = this;
        var _a, _b, _c;
        var nextElementAdjustedForRtl = rtl === undefined || !rtl ? nextElement : prevElement;
        var prevElementAdjustedForRtl = rtl === undefined || !rtl ? prevElement : nextElement;
        var prevElementAdjustedForOrientation = $kD48O.Orientation.Horizontal === this.carouselOrientation ? prevElementAdjustedForRtl : prevElement;
        var nextElementAdjustedForOrientation = $kD48O.Orientation.Horizontal === this.carouselOrientation ? nextElementAdjustedForRtl : nextElement;
        var swiperOptions = {
            loop: !this.isDesignMode() && this.carouselLoop,
            modules: [
                $eRV5Q.default,
                $fBOh1.default,
                $5pCsG.default,
                $kIOmg.default,
                $778og.default,
                $dHlcP.default
            ],
            pagination: {
                el: paginationElement,
                clickable: true
            },
            navigation: {
                prevEl: prevElementAdjustedForOrientation,
                nextEl: nextElementAdjustedForOrientation
            },
            a11y: {
                enabled: true
            },
            keyboard: {
                enabled: false,
                onlyInViewport: true
            },
            direction: this.carouselOrientation === $kD48O.Orientation.Horizontal ? "horizontal" : "vertical",
            resizeObserver: false,
            initialSlide: this._currentIndex
        };
        if (this.timer && !this.isDesignMode()) {
            (_a = swiperOptions.modules) === null || _a === void 0 || _a.push($cxcfk.default);
            swiperOptions.autoplay = {
                delay: this.timer,
                pauseOnMouseEnter: true
            };
        }
        var carousel = new $9TKxu.default(carouselContainer, swiperOptions);
        // While the 'pauseOnMouseEnter' option should resume autoplay on
        // mouse exit it doesn't do it, so adding custom events to handle it
        carouselContainer.addEventListener("mouseenter", function(_event) {
            var _a;
            (_a = carousel.autoplay) === null || _a === void 0 || _a.stop();
        });
        carouselContainer.addEventListener("mouseleave", function(_event) {
            var _a;
            (_a = carousel.autoplay) === null || _a === void 0 || _a.start();
        });
        carousel.on("navigationNext", function(swiper) {
            _this.raiseCarouselEvent($kD48O.CarouselInteractionEvent.NavigationNext);
        });
        carousel.on("navigationPrev", function(swiper) {
            _this.raiseCarouselEvent($kD48O.CarouselInteractionEvent.NavigationPrevious);
        });
        carousel.on("slideChangeTransitionEnd", function(swiper) {
            _this.currentIndex = swiper.realIndex;
            _this.raiseCarouselEvent($kD48O.CarouselInteractionEvent.Pagination);
        });
        carousel.on("autoplay", function() {
            _this.raiseCarouselEvent($kD48O.CarouselInteractionEvent.Autoplay);
        });
        carousel.on("paginationRender", function(swiper, paginationEl) {
            swiper.pagination.bullets.forEach(function(bullet, index) {
                bullet.addEventListener("keypress", function(event) {
                    if (event.key == "Enter") {
                        event.preventDefault();
                        swiper.slideTo(index + 1);
                    }
                });
            });
        });
        carousel.on("destroy", function() {
            _this.destroyResizeObserver();
        });
        prevElement.title = (_b = prevElement.ariaLabel) !== null && _b !== void 0 ? _b : $c6BU9.Strings.defaults.carouselNavigationPreviousTooltip();
        nextElement.title = (_c = nextElement.ariaLabel) !== null && _c !== void 0 ? _c : $c6BU9.Strings.defaults.carouselNavigationNextTooltip();
        this._carousel = carousel;
        this.createResizeObserver();
    };
    Carousel.prototype.createCarouselPageInstance = function(source, context) {
        return context.parseCardObject(this, source, this.forbiddenChildElements(), !this.isDesignMode(), function(typeName) {
            return !typeName || typeName === "CarouselPage" ? new $19c28146713faa0a$var$CarouselPage() : undefined;
        }, function(typeName, _errorType) {
            context.logParseEvent(undefined, $kD48O.ValidationEvent.ElementTypeNotAllowed, $c6BU9.Strings.errors.elementTypeNotAllowed(typeName));
        });
    };
    Carousel.prototype.slideTo = function(index) {
        var _a;
        (_a = this._carousel) === null || _a === void 0 || _a.slideTo(index);
    };
    Object.defineProperty(Carousel.prototype, "carouselPageContainer", {
        get: function() {
            return this._carouselPageContainer;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Carousel.prototype, "currentIndex", {
        get: function() {
            return this._currentIndex;
        },
        set: function(currentIndex) {
            this._currentIndex = currentIndex;
        },
        enumerable: false,
        configurable: true
    });
    Carousel.prototype.createCarouselEvent = function(type) {
        var currentPageId;
        if (this.currentPageIndex != undefined) currentPageId = this.getItemAt(this.currentPageIndex).id;
        return new $19c28146713faa0a$var$CarouselEvent(type, this.id, currentPageId, this.currentPageIndex);
    };
    Carousel.prototype.raiseCarouselEvent = function(eventType) {
        var card = this.parent ? this.parent.getRootElement() : undefined;
        var onCarouselEventHandler = card && card.onCarouselEvent ? card.onCarouselEvent : $eDhMr.AdaptiveCard.onCarouselEvent;
        // pagination event is triggered on slide transition end event 
        if (onCarouselEventHandler && eventType == $kD48O.CarouselInteractionEvent.Pagination) // returns the event type that causes slide transition
        onCarouselEventHandler(this.createCarouselEvent(this.previousEventType));
        this.previousEventType = eventType;
    };
    /// Swiper version 8 added requestAnimationFrame() call in its resize observer code
    /// The new call causes flickering issue,
    /// We've copied resize observer code from Swiper version 7 with some modifications
    Carousel.prototype.createResizeObserver = function() {
        var _this = this;
        var _a;
        if (!this.checkIfCarouselInValidStateForResizeEvent()) return;
        this._observer = new ResizeObserver(function(entries) {
            var _a, _b, _c, _d;
            var width = (_a = _this._carousel) === null || _a === void 0 ? void 0 : _a.width;
            var height = (_b = _this._carousel) === null || _b === void 0 ? void 0 : _b.height;
            var newWidth = width;
            var newHeight = height;
            entries.forEach(function(_a) {
                var _b;
                var contentBoxSize = _a.contentBoxSize, contentRect = _a.contentRect, target = _a.target;
                if (target && target !== ((_b = _this._carousel) === null || _b === void 0 ? void 0 : _b.el)) return;
                newWidth = contentRect ? contentRect.width : (contentBoxSize[0] || contentBoxSize).inlineSize;
                newHeight = contentRect ? contentRect.height : (contentBoxSize[0] || contentBoxSize).blockSize;
            });
            if (newWidth !== width || newHeight !== height) {
                if (_this.checkIfCarouselInValidStateForResizeEvent()) {
                    (_c = _this._carousel) === null || _c === void 0 || _c.emit("beforeResize");
                    (_d = _this._carousel) === null || _d === void 0 || _d.emit("resize");
                }
            }
        });
        this._observer.observe((_a = this._carousel) === null || _a === void 0 ? void 0 : _a.el);
    };
    Carousel.prototype.destroyResizeObserver = function() {
        var _a;
        if (this._observer && this._observer.unobserve && ((_a = this._carousel) === null || _a === void 0 ? void 0 : _a.el)) {
            this._observer.unobserve(this._carousel.el);
            this._observer = null;
        }
    };
    Carousel.prototype.checkIfCarouselInValidStateForResizeEvent = function() {
        return this._carousel && !this._carousel.destroyed;
    };
    Carousel.timerProperty = new $eZfTX.NumProperty($eZfTX.Versions.v1_6, "timer", undefined);
    Carousel.initialPageProperty = new $eZfTX.NumProperty($eZfTX.Versions.v1_6, "initialPage", 0);
    Carousel.loopProperty = new $eZfTX.BoolProperty($eZfTX.Versions.v1_6, "loop", true);
    Carousel.orientationProperty = new $eZfTX.EnumProperty($eZfTX.Versions.v1_6, "orientation", $kD48O.Orientation, $kD48O.Orientation.Horizontal);
    Carousel.carouselHeightProperty = new $eZfTX.PixelSizeProperty($eZfTX.Versions.v1_6, "heightInPixels");
    $19c28146713faa0a$var$__decorate([
        (0, $eZfTX.property)(Carousel.timerProperty)
    ], Carousel.prototype, "timer", null);
    $19c28146713faa0a$var$__decorate([
        (0, $eZfTX.property)(Carousel.initialPageProperty)
    ], Carousel.prototype, "initialPageIndex", null);
    $19c28146713faa0a$var$__decorate([
        (0, $eZfTX.property)(Carousel.loopProperty)
    ], Carousel.prototype, "carouselLoop", void 0);
    $19c28146713faa0a$var$__decorate([
        (0, $eZfTX.property)(Carousel.orientationProperty)
    ], Carousel.prototype, "carouselOrientation", void 0);
    $19c28146713faa0a$var$__decorate([
        (0, $eZfTX.property)(Carousel.carouselHeightProperty)
    ], Carousel.prototype, "carouselHeight", void 0);
    return Carousel;
}($eDhMr.Container);
module.exports.Carousel = $19c28146713faa0a$var$Carousel;
var $19c28146713faa0a$var$CarouselEvent = /** @class */ function() {
    function CarouselEvent(type, carouselId, activeCarouselPageId, activeCarouselPageIndex) {
        this.type = type;
        this.carouselId = carouselId;
        this.activeCarouselPageId = activeCarouselPageId;
        this.activeCarouselPageIndex = activeCarouselPageIndex;
    }
    return CarouselEvent;
}();
module.exports.CarouselEvent = $19c28146713faa0a$var$CarouselEvent;
$hfx8W.GlobalRegistry.defaultElements.register("Carousel", $19c28146713faa0a$var$Carousel, $eZfTX.Versions.v1_6);

});
parcelRequire.register("inAoA", function(module, exports) {

$parcel$export(module.exports, "Swiper", () => (parcelRequire("9TKxu")).default);
$parcel$export(module.exports, "Keyboard", () => (parcelRequire("dHlcP")).default);
$parcel$export(module.exports, "Navigation", () => (parcelRequire("eRV5Q")).default);
$parcel$export(module.exports, "Pagination", () => (parcelRequire("fBOh1")).default);
$parcel$export(module.exports, "Scrollbar", () => (parcelRequire("5pCsG")).default);
$parcel$export(module.exports, "A11y", () => (parcelRequire("kIOmg")).default);
$parcel$export(module.exports, "History", () => (parcelRequire("778og")).default);
$parcel$export(module.exports, "Autoplay", () => (parcelRequire("cxcfk")).default);
/**
 * Swiper 8.4.7
 * Most modern mobile touch slider and framework with hardware accelerated transitions
 * https://swiperjs.com
 *
 * Copyright 2014-2023 Vladimir Kharlampidi
 *
 * Released under the MIT License
 *
 * Released on: January 30, 2023
 */ 
var $9TKxu = parcelRequire("9TKxu");

var $fId9e = parcelRequire("fId9e");

var $dHlcP = parcelRequire("dHlcP");

var $aCJAI = parcelRequire("aCJAI");

var $eRV5Q = parcelRequire("eRV5Q");

var $fBOh1 = parcelRequire("fBOh1");

var $5pCsG = parcelRequire("5pCsG");

var $1sqY9 = parcelRequire("1sqY9");

var $hPoyj = parcelRequire("hPoyj");

var $4WSxm = parcelRequire("4WSxm");

var $1YbIn = parcelRequire("1YbIn");

var $kIOmg = parcelRequire("kIOmg");

var $778og = parcelRequire("778og");

var $hrgiv = parcelRequire("hrgiv");

var $cxcfk = parcelRequire("cxcfk");

var $b5YZm = parcelRequire("b5YZm");

var $4k2DK = parcelRequire("4k2DK");

var $2DgAz = parcelRequire("2DgAz");

var $bknU5 = parcelRequire("bknU5");

var $akUfl = parcelRequire("akUfl");

var $j75JS = parcelRequire("j75JS");

var $iOZIt = parcelRequire("iOZIt");

var $3XwHK = parcelRequire("3XwHK");

var $bybK9 = parcelRequire("bybK9");

var $hc3BZ = parcelRequire("hc3BZ");

});
parcelRequire.register("9TKxu", function(module, exports) {

$parcel$export(module.exports, "default", () => $734d59d4ad01df26$export$2e2bcd8739ae039);
/* eslint no-param-reassign: "off" */ 
var $bkUxr = parcelRequire("bkUxr");

var $92tgL = parcelRequire("92tgL");

var $2y7Cr = parcelRequire("2y7Cr");

var $fSK3l = parcelRequire("fSK3l");

var $8QIbd = parcelRequire("8QIbd");

var $a6CQr = parcelRequire("a6CQr");

var $bObVi = parcelRequire("bObVi");

var $eJ5qv = parcelRequire("eJ5qv");

var $e5xSM = parcelRequire("e5xSM");

var $gAQxj = parcelRequire("gAQxj");

var $3QIGr = parcelRequire("3QIGr");

var $cOPtx = parcelRequire("cOPtx");

var $73AvW = parcelRequire("73AvW");

var $6hBLv = parcelRequire("6hBLv");

var $eITfw = parcelRequire("eITfw");

var $iYp6P = parcelRequire("iYp6P");

var $bDrt1 = parcelRequire("bDrt1");

var $kikIC = parcelRequire("kikIC");

var $doLnc = parcelRequire("doLnc");

var $eA7DM = parcelRequire("eA7DM");

var $gAai8 = parcelRequire("gAai8");

var $1roBl = parcelRequire("1roBl");
const $734d59d4ad01df26$var$prototypes = {
    eventsEmitter: $e5xSM.default,
    update: $gAQxj.default,
    translate: $3QIGr.default,
    transition: $cOPtx.default,
    slide: $73AvW.default,
    loop: $6hBLv.default,
    grabCursor: $eITfw.default,
    events: $iYp6P.default,
    breakpoints: $bDrt1.default,
    checkOverflow: $eA7DM.default,
    classes: $kikIC.default,
    images: $doLnc.default
};
const $734d59d4ad01df26$var$extendedDefaults = {};
class $734d59d4ad01df26$var$Swiper {
    constructor(...args){
        let el;
        let params;
        if (args.length === 1 && args[0].constructor && Object.prototype.toString.call(args[0]).slice(8, -1) === "Object") params = args[0];
        else [el, params] = args;
        if (!params) params = {};
        params = (0, $2y7Cr.extend)({}, params);
        if (el && !params.el) params.el = el;
        if (params.el && (0, $92tgL.default)(params.el).length > 1) {
            const swipers = [];
            (0, $92tgL.default)(params.el).each((containerEl)=>{
                const newParams = (0, $2y7Cr.extend)({}, params, {
                    el: containerEl
                });
                swipers.push(new $734d59d4ad01df26$var$Swiper(newParams));
            }); // eslint-disable-next-line no-constructor-return
            return swipers;
        } // Swiper Instance
        const swiper = this;
        swiper.__swiper__ = true;
        swiper.support = (0, $fSK3l.getSupport)();
        swiper.device = (0, $8QIbd.getDevice)({
            userAgent: params.userAgent
        });
        swiper.browser = (0, $a6CQr.getBrowser)();
        swiper.eventsListeners = {};
        swiper.eventsAnyListeners = [];
        swiper.modules = [
            ...swiper.__modules__
        ];
        if (params.modules && Array.isArray(params.modules)) swiper.modules.push(...params.modules);
        const allModulesParams = {};
        swiper.modules.forEach((mod)=>{
            mod({
                swiper: swiper,
                extendParams: (0, $1roBl.default)(params, allModulesParams),
                on: swiper.on.bind(swiper),
                once: swiper.once.bind(swiper),
                off: swiper.off.bind(swiper),
                emit: swiper.emit.bind(swiper)
            });
        }); // Extend defaults with modules params
        const swiperParams = (0, $2y7Cr.extend)({}, (0, $gAai8.default), allModulesParams); // Extend defaults with passed params
        swiper.params = (0, $2y7Cr.extend)({}, swiperParams, $734d59d4ad01df26$var$extendedDefaults, params);
        swiper.originalParams = (0, $2y7Cr.extend)({}, swiper.params);
        swiper.passedParams = (0, $2y7Cr.extend)({}, params); // add event listeners
        if (swiper.params && swiper.params.on) Object.keys(swiper.params.on).forEach((eventName)=>{
            swiper.on(eventName, swiper.params.on[eventName]);
        });
        if (swiper.params && swiper.params.onAny) swiper.onAny(swiper.params.onAny);
         // Save Dom lib
        swiper.$ = (0, $92tgL.default); // Extend Swiper
        Object.assign(swiper, {
            enabled: swiper.params.enabled,
            el: el,
            // Classes
            classNames: [],
            // Slides
            slides: (0, $92tgL.default)(),
            slidesGrid: [],
            snapGrid: [],
            slidesSizesGrid: [],
            // isDirection
            isHorizontal () {
                return swiper.params.direction === "horizontal";
            },
            isVertical () {
                return swiper.params.direction === "vertical";
            },
            // Indexes
            activeIndex: 0,
            realIndex: 0,
            //
            isBeginning: true,
            isEnd: false,
            // Props
            translate: 0,
            previousTranslate: 0,
            progress: 0,
            velocity: 0,
            animating: false,
            // Locks
            allowSlideNext: swiper.params.allowSlideNext,
            allowSlidePrev: swiper.params.allowSlidePrev,
            // Touch Events
            touchEvents: function touchEvents() {
                const touch = [
                    "touchstart",
                    "touchmove",
                    "touchend",
                    "touchcancel"
                ];
                const desktop = [
                    "pointerdown",
                    "pointermove",
                    "pointerup"
                ];
                swiper.touchEventsTouch = {
                    start: touch[0],
                    move: touch[1],
                    end: touch[2],
                    cancel: touch[3]
                };
                swiper.touchEventsDesktop = {
                    start: desktop[0],
                    move: desktop[1],
                    end: desktop[2]
                };
                return swiper.support.touch || !swiper.params.simulateTouch ? swiper.touchEventsTouch : swiper.touchEventsDesktop;
            }(),
            touchEventsData: {
                isTouched: undefined,
                isMoved: undefined,
                allowTouchCallbacks: undefined,
                touchStartTime: undefined,
                isScrolling: undefined,
                currentTranslate: undefined,
                startTranslate: undefined,
                allowThresholdMove: undefined,
                // Form elements to match
                focusableElements: swiper.params.focusableElements,
                // Last click time
                lastClickTime: (0, $2y7Cr.now)(),
                clickTimeout: undefined,
                // Velocities
                velocities: [],
                allowMomentumBounce: undefined,
                isTouchEvent: undefined,
                startMoving: undefined
            },
            // Clicks
            allowClick: true,
            // Touches
            allowTouchMove: swiper.params.allowTouchMove,
            touches: {
                startX: 0,
                startY: 0,
                currentX: 0,
                currentY: 0,
                diff: 0
            },
            // Images
            imagesToLoad: [],
            imagesLoaded: 0
        });
        swiper.emit("_swiper"); // Init
        if (swiper.params.init) swiper.init();
         // Return app instance
        // eslint-disable-next-line no-constructor-return
        return swiper;
    }
    enable() {
        const swiper = this;
        if (swiper.enabled) return;
        swiper.enabled = true;
        if (swiper.params.grabCursor) swiper.setGrabCursor();
        swiper.emit("enable");
    }
    disable() {
        const swiper = this;
        if (!swiper.enabled) return;
        swiper.enabled = false;
        if (swiper.params.grabCursor) swiper.unsetGrabCursor();
        swiper.emit("disable");
    }
    setProgress(progress, speed) {
        const swiper = this;
        progress = Math.min(Math.max(progress, 0), 1);
        const min = swiper.minTranslate();
        const max = swiper.maxTranslate();
        const current = (max - min) * progress + min;
        swiper.translateTo(current, typeof speed === "undefined" ? 0 : speed);
        swiper.updateActiveIndex();
        swiper.updateSlidesClasses();
    }
    emitContainerClasses() {
        const swiper = this;
        if (!swiper.params._emitClasses || !swiper.el) return;
        const cls = swiper.el.className.split(" ").filter((className)=>{
            return className.indexOf("swiper") === 0 || className.indexOf(swiper.params.containerModifierClass) === 0;
        });
        swiper.emit("_containerClasses", cls.join(" "));
    }
    getSlideClasses(slideEl) {
        const swiper = this;
        if (swiper.destroyed) return "";
        return slideEl.className.split(" ").filter((className)=>{
            return className.indexOf("swiper-slide") === 0 || className.indexOf(swiper.params.slideClass) === 0;
        }).join(" ");
    }
    emitSlidesClasses() {
        const swiper = this;
        if (!swiper.params._emitClasses || !swiper.el) return;
        const updates = [];
        swiper.slides.each((slideEl)=>{
            const classNames = swiper.getSlideClasses(slideEl);
            updates.push({
                slideEl: slideEl,
                classNames: classNames
            });
            swiper.emit("_slideClass", slideEl, classNames);
        });
        swiper.emit("_slideClasses", updates);
    }
    slidesPerViewDynamic(view = "current", exact = false) {
        const swiper = this;
        const { params: params, slides: slides, slidesGrid: slidesGrid, slidesSizesGrid: slidesSizesGrid, size: swiperSize, activeIndex: activeIndex } = swiper;
        let spv = 1;
        if (params.centeredSlides) {
            let slideSize = slides[activeIndex].swiperSlideSize;
            let breakLoop;
            for(let i = activeIndex + 1; i < slides.length; i += 1)if (slides[i] && !breakLoop) {
                slideSize += slides[i].swiperSlideSize;
                spv += 1;
                if (slideSize > swiperSize) breakLoop = true;
            }
            for(let i = activeIndex - 1; i >= 0; i -= 1)if (slides[i] && !breakLoop) {
                slideSize += slides[i].swiperSlideSize;
                spv += 1;
                if (slideSize > swiperSize) breakLoop = true;
            }
        } else {
            // eslint-disable-next-line
            if (view === "current") for(let i = activeIndex + 1; i < slides.length; i += 1){
                const slideInView = exact ? slidesGrid[i] + slidesSizesGrid[i] - slidesGrid[activeIndex] < swiperSize : slidesGrid[i] - slidesGrid[activeIndex] < swiperSize;
                if (slideInView) spv += 1;
            }
            else // previous
            for(let i = activeIndex - 1; i >= 0; i -= 1){
                const slideInView = slidesGrid[activeIndex] - slidesGrid[i] < swiperSize;
                if (slideInView) spv += 1;
            }
        }
        return spv;
    }
    update() {
        const swiper = this;
        if (!swiper || swiper.destroyed) return;
        const { snapGrid: snapGrid, params: params } = swiper; // Breakpoints
        if (params.breakpoints) swiper.setBreakpoint();
        swiper.updateSize();
        swiper.updateSlides();
        swiper.updateProgress();
        swiper.updateSlidesClasses();
        function setTranslate() {
            const translateValue = swiper.rtlTranslate ? swiper.translate * -1 : swiper.translate;
            const newTranslate = Math.min(Math.max(translateValue, swiper.maxTranslate()), swiper.minTranslate());
            swiper.setTranslate(newTranslate);
            swiper.updateActiveIndex();
            swiper.updateSlidesClasses();
        }
        let translated;
        if (swiper.params.freeMode && swiper.params.freeMode.enabled) {
            setTranslate();
            if (swiper.params.autoHeight) swiper.updateAutoHeight();
        } else {
            if ((swiper.params.slidesPerView === "auto" || swiper.params.slidesPerView > 1) && swiper.isEnd && !swiper.params.centeredSlides) translated = swiper.slideTo(swiper.slides.length - 1, 0, false, true);
            else translated = swiper.slideTo(swiper.activeIndex, 0, false, true);
            if (!translated) setTranslate();
        }
        if (params.watchOverflow && snapGrid !== swiper.snapGrid) swiper.checkOverflow();
        swiper.emit("update");
    }
    changeDirection(newDirection, needUpdate = true) {
        const swiper = this;
        const currentDirection = swiper.params.direction;
        if (!newDirection) // eslint-disable-next-line
        newDirection = currentDirection === "horizontal" ? "vertical" : "horizontal";
        if (newDirection === currentDirection || newDirection !== "horizontal" && newDirection !== "vertical") return swiper;
        swiper.$el.removeClass(`${swiper.params.containerModifierClass}${currentDirection}`).addClass(`${swiper.params.containerModifierClass}${newDirection}`);
        swiper.emitContainerClasses();
        swiper.params.direction = newDirection;
        swiper.slides.each((slideEl)=>{
            if (newDirection === "vertical") slideEl.style.width = "";
            else slideEl.style.height = "";
        });
        swiper.emit("changeDirection");
        if (needUpdate) swiper.update();
        return swiper;
    }
    changeLanguageDirection(direction) {
        const swiper = this;
        if (swiper.rtl && direction === "rtl" || !swiper.rtl && direction === "ltr") return;
        swiper.rtl = direction === "rtl";
        swiper.rtlTranslate = swiper.params.direction === "horizontal" && swiper.rtl;
        if (swiper.rtl) {
            swiper.$el.addClass(`${swiper.params.containerModifierClass}rtl`);
            swiper.el.dir = "rtl";
        } else {
            swiper.$el.removeClass(`${swiper.params.containerModifierClass}rtl`);
            swiper.el.dir = "ltr";
        }
        swiper.update();
    }
    mount(el) {
        const swiper = this;
        if (swiper.mounted) return true; // Find el
        const $el = (0, $92tgL.default)(el || swiper.params.el);
        el = $el[0];
        if (!el) return false;
        el.swiper = swiper;
        const getWrapperSelector = ()=>{
            return `.${(swiper.params.wrapperClass || "").trim().split(" ").join(".")}`;
        };
        const getWrapper = ()=>{
            if (el && el.shadowRoot && el.shadowRoot.querySelector) {
                const res = (0, $92tgL.default)(el.shadowRoot.querySelector(getWrapperSelector())); // Children needs to return slot items
                res.children = (options)=>$el.children(options);
                return res;
            }
            if (!$el.children) return (0, $92tgL.default)($el).children(getWrapperSelector());
            return $el.children(getWrapperSelector());
        }; // Find Wrapper
        let $wrapperEl = getWrapper();
        if ($wrapperEl.length === 0 && swiper.params.createElements) {
            const document = (0, $bkUxr.getDocument)();
            const wrapper = document.createElement("div");
            $wrapperEl = (0, $92tgL.default)(wrapper);
            wrapper.className = swiper.params.wrapperClass;
            $el.append(wrapper);
            $el.children(`.${swiper.params.slideClass}`).each((slideEl)=>{
                $wrapperEl.append(slideEl);
            });
        }
        Object.assign(swiper, {
            $el: $el,
            el: el,
            $wrapperEl: $wrapperEl,
            wrapperEl: $wrapperEl[0],
            mounted: true,
            // RTL
            rtl: el.dir.toLowerCase() === "rtl" || $el.css("direction") === "rtl",
            rtlTranslate: swiper.params.direction === "horizontal" && (el.dir.toLowerCase() === "rtl" || $el.css("direction") === "rtl"),
            wrongRTL: $wrapperEl.css("display") === "-webkit-box"
        });
        return true;
    }
    init(el) {
        const swiper = this;
        if (swiper.initialized) return swiper;
        const mounted = swiper.mount(el);
        if (mounted === false) return swiper;
        swiper.emit("beforeInit"); // Set breakpoint
        if (swiper.params.breakpoints) swiper.setBreakpoint();
         // Add Classes
        swiper.addClasses(); // Create loop
        if (swiper.params.loop) swiper.loopCreate();
         // Update size
        swiper.updateSize(); // Update slides
        swiper.updateSlides();
        if (swiper.params.watchOverflow) swiper.checkOverflow();
         // Set Grab Cursor
        if (swiper.params.grabCursor && swiper.enabled) swiper.setGrabCursor();
        if (swiper.params.preloadImages) swiper.preloadImages();
         // Slide To Initial Slide
        if (swiper.params.loop) swiper.slideTo(swiper.params.initialSlide + swiper.loopedSlides, 0, swiper.params.runCallbacksOnInit, false, true);
        else swiper.slideTo(swiper.params.initialSlide, 0, swiper.params.runCallbacksOnInit, false, true);
         // Attach events
        swiper.attachEvents(); // Init Flag
        swiper.initialized = true; // Emit
        swiper.emit("init");
        swiper.emit("afterInit");
        return swiper;
    }
    destroy(deleteInstance = true, cleanStyles = true) {
        const swiper = this;
        const { params: params, $el: $el, $wrapperEl: $wrapperEl, slides: slides } = swiper;
        if (typeof swiper.params === "undefined" || swiper.destroyed) return null;
        swiper.emit("beforeDestroy"); // Init Flag
        swiper.initialized = false; // Detach events
        swiper.detachEvents(); // Destroy loop
        if (params.loop) swiper.loopDestroy();
         // Cleanup styles
        if (cleanStyles) {
            swiper.removeClasses();
            $el.removeAttr("style");
            $wrapperEl.removeAttr("style");
            if (slides && slides.length) slides.removeClass([
                params.slideVisibleClass,
                params.slideActiveClass,
                params.slideNextClass,
                params.slidePrevClass
            ].join(" ")).removeAttr("style").removeAttr("data-swiper-slide-index");
        }
        swiper.emit("destroy"); // Detach emitter events
        Object.keys(swiper.eventsListeners).forEach((eventName)=>{
            swiper.off(eventName);
        });
        if (deleteInstance !== false) {
            swiper.$el[0].swiper = null;
            (0, $2y7Cr.deleteProps)(swiper);
        }
        swiper.destroyed = true;
        return null;
    }
    static extendDefaults(newDefaults) {
        (0, $2y7Cr.extend)($734d59d4ad01df26$var$extendedDefaults, newDefaults);
    }
    static get extendedDefaults() {
        return $734d59d4ad01df26$var$extendedDefaults;
    }
    static get defaults() {
        return 0, $gAai8.default;
    }
    static installModule(mod) {
        if (!$734d59d4ad01df26$var$Swiper.prototype.__modules__) $734d59d4ad01df26$var$Swiper.prototype.__modules__ = [];
        const modules = $734d59d4ad01df26$var$Swiper.prototype.__modules__;
        if (typeof mod === "function" && modules.indexOf(mod) < 0) modules.push(mod);
    }
    static use(module) {
        if (Array.isArray(module)) {
            module.forEach((m)=>$734d59d4ad01df26$var$Swiper.installModule(m));
            return $734d59d4ad01df26$var$Swiper;
        }
        $734d59d4ad01df26$var$Swiper.installModule(module);
        return $734d59d4ad01df26$var$Swiper;
    }
}
Object.keys($734d59d4ad01df26$var$prototypes).forEach((prototypeGroup)=>{
    Object.keys($734d59d4ad01df26$var$prototypes[prototypeGroup]).forEach((protoMethod)=>{
        $734d59d4ad01df26$var$Swiper.prototype[protoMethod] = $734d59d4ad01df26$var$prototypes[prototypeGroup][protoMethod];
    });
});
$734d59d4ad01df26$var$Swiper.use([
    (0, $bObVi.default),
    (0, $eJ5qv.default)
]);
var $734d59d4ad01df26$export$2e2bcd8739ae039 = $734d59d4ad01df26$var$Swiper;

});
parcelRequire.register("bkUxr", function(module, exports) {

$parcel$export(module.exports, "getDocument", () => $840d6b5338c52e5d$export$f65ca476c09acec0);
$parcel$export(module.exports, "getWindow", () => $840d6b5338c52e5d$export$38b2d434cce3ea22);
/**
 * SSR Window 4.0.2
 * Better handling for window object in SSR environment
 * https://github.com/nolimits4web/ssr-window
 *
 * Copyright 2021, Vladimir Kharlampidi
 *
 * Licensed under MIT
 *
 * Released on: December 13, 2021
 */ /* eslint-disable no-param-reassign */ function $840d6b5338c52e5d$var$isObject(obj) {
    return obj !== null && typeof obj === "object" && "constructor" in obj && obj.constructor === Object;
}
function $840d6b5338c52e5d$export$8b58be045bf06082(target = {}, src = {}) {
    Object.keys(src).forEach((key)=>{
        if (typeof target[key] === "undefined") target[key] = src[key];
        else if ($840d6b5338c52e5d$var$isObject(src[key]) && $840d6b5338c52e5d$var$isObject(target[key]) && Object.keys(src[key]).length > 0) $840d6b5338c52e5d$export$8b58be045bf06082(target[key], src[key]);
    });
}
const $840d6b5338c52e5d$export$3fdcb9b4d81368d8 = {
    body: {},
    addEventListener () {},
    removeEventListener () {},
    activeElement: {
        blur () {},
        nodeName: ""
    },
    querySelector () {
        return null;
    },
    querySelectorAll () {
        return [];
    },
    getElementById () {
        return null;
    },
    createEvent () {
        return {
            initEvent () {}
        };
    },
    createElement () {
        return {
            children: [],
            childNodes: [],
            style: {},
            setAttribute () {},
            getElementsByTagName () {
                return [];
            }
        };
    },
    createElementNS () {
        return {};
    },
    importNode () {
        return null;
    },
    location: {
        hash: "",
        host: "",
        hostname: "",
        href: "",
        origin: "",
        pathname: "",
        protocol: "",
        search: ""
    }
};
function $840d6b5338c52e5d$export$f65ca476c09acec0() {
    const doc = typeof document !== "undefined" ? document : {};
    $840d6b5338c52e5d$export$8b58be045bf06082(doc, $840d6b5338c52e5d$export$3fdcb9b4d81368d8);
    return doc;
}
const $840d6b5338c52e5d$export$8582633f185c62bb = {
    document: $840d6b5338c52e5d$export$3fdcb9b4d81368d8,
    navigator: {
        userAgent: ""
    },
    location: {
        hash: "",
        host: "",
        hostname: "",
        href: "",
        origin: "",
        pathname: "",
        protocol: "",
        search: ""
    },
    history: {
        replaceState () {},
        pushState () {},
        go () {},
        back () {}
    },
    CustomEvent: function CustomEvent() {
        return this;
    },
    addEventListener () {},
    removeEventListener () {},
    getComputedStyle () {
        return {
            getPropertyValue () {
                return "";
            }
        };
    },
    Image () {},
    Date () {},
    screen: {},
    setTimeout () {},
    clearTimeout () {},
    matchMedia () {
        return {};
    },
    requestAnimationFrame (callback) {
        if (typeof setTimeout === "undefined") {
            callback();
            return null;
        }
        return setTimeout(callback, 0);
    },
    cancelAnimationFrame (id) {
        if (typeof setTimeout === "undefined") return;
        clearTimeout(id);
    }
};
function $840d6b5338c52e5d$export$38b2d434cce3ea22() {
    const win = typeof window !== "undefined" ? window : {};
    $840d6b5338c52e5d$export$8b58be045bf06082(win, $840d6b5338c52e5d$export$8582633f185c62bb);
    return win;
}

});

parcelRequire.register("92tgL", function(module, exports) {

$parcel$export(module.exports, "default", () => $694b0143c0ad1085$export$2e2bcd8739ae039);

var $cwHM8 = parcelRequire("cwHM8");
const $694b0143c0ad1085$var$Methods = {
    addClass: $cwHM8.addClass,
    removeClass: $cwHM8.removeClass,
    hasClass: $cwHM8.hasClass,
    toggleClass: $cwHM8.toggleClass,
    attr: $cwHM8.attr,
    removeAttr: $cwHM8.removeAttr,
    transform: $cwHM8.transform,
    transition: $cwHM8.transition,
    on: $cwHM8.on,
    off: $cwHM8.off,
    trigger: $cwHM8.trigger,
    transitionEnd: $cwHM8.transitionEnd,
    outerWidth: $cwHM8.outerWidth,
    outerHeight: $cwHM8.outerHeight,
    styles: $cwHM8.styles,
    offset: $cwHM8.offset,
    css: $cwHM8.css,
    each: $cwHM8.each,
    html: $cwHM8.html,
    text: $cwHM8.text,
    is: $cwHM8.is,
    index: $cwHM8.index,
    eq: $cwHM8.eq,
    append: $cwHM8.append,
    prepend: $cwHM8.prepend,
    next: $cwHM8.next,
    nextAll: $cwHM8.nextAll,
    prev: $cwHM8.prev,
    prevAll: $cwHM8.prevAll,
    parent: $cwHM8.parent,
    parents: $cwHM8.parents,
    closest: $cwHM8.closest,
    find: $cwHM8.find,
    children: $cwHM8.children,
    filter: $cwHM8.filter,
    remove: $cwHM8.remove
};
Object.keys($694b0143c0ad1085$var$Methods).forEach((methodName)=>{
    Object.defineProperty((0, $cwHM8.$).fn, methodName, {
        value: $694b0143c0ad1085$var$Methods[methodName],
        writable: true
    });
});
var $694b0143c0ad1085$export$2e2bcd8739ae039 = (0, $cwHM8.$);

});
parcelRequire.register("cwHM8", function(module, exports) {

$parcel$export(module.exports, "$", () => $91ea6e17575ae7f4$export$3d8c2f653ac9d0b9);
$parcel$export(module.exports, "addClass", () => $91ea6e17575ae7f4$export$d2cf6cd1dc7067d3);
$parcel$export(module.exports, "removeClass", () => $91ea6e17575ae7f4$export$c2255604a80b4506);
$parcel$export(module.exports, "toggleClass", () => $91ea6e17575ae7f4$export$4a80062ca50b57c7);
$parcel$export(module.exports, "hasClass", () => $91ea6e17575ae7f4$export$4ea3d958472af68f);
$parcel$export(module.exports, "attr", () => $91ea6e17575ae7f4$export$7aabe8b3a840d2fd);
$parcel$export(module.exports, "removeAttr", () => $91ea6e17575ae7f4$export$842f2b51efdcb631);
$parcel$export(module.exports, "transform", () => $91ea6e17575ae7f4$export$51186ad6e864892a);
$parcel$export(module.exports, "transition", () => $91ea6e17575ae7f4$export$66bb15e2994e6a26);
$parcel$export(module.exports, "on", () => $91ea6e17575ae7f4$export$af631764ddc44097);
$parcel$export(module.exports, "off", () => $91ea6e17575ae7f4$export$8c8705df4a2dcec9);
$parcel$export(module.exports, "trigger", () => $91ea6e17575ae7f4$export$e614dc9140f7ae71);
$parcel$export(module.exports, "transitionEnd", () => $91ea6e17575ae7f4$export$358dc01d65cad417);
$parcel$export(module.exports, "outerWidth", () => $91ea6e17575ae7f4$export$e823f88e4111159a);
$parcel$export(module.exports, "outerHeight", () => $91ea6e17575ae7f4$export$fc5b8aac72846d1e);
$parcel$export(module.exports, "offset", () => $91ea6e17575ae7f4$export$cc800923e997bb8);
$parcel$export(module.exports, "styles", () => $91ea6e17575ae7f4$export$9dd6ff9ea0189349);
$parcel$export(module.exports, "css", () => $91ea6e17575ae7f4$export$dbf350e5966cf602);
$parcel$export(module.exports, "each", () => $91ea6e17575ae7f4$export$79b2f7037acddd43);
$parcel$export(module.exports, "filter", () => $91ea6e17575ae7f4$export$3dea766d36a8935f);
$parcel$export(module.exports, "html", () => $91ea6e17575ae7f4$export$c0bb0b647f701bb5);
$parcel$export(module.exports, "text", () => $91ea6e17575ae7f4$export$6f093cfa640b7166);
$parcel$export(module.exports, "is", () => $91ea6e17575ae7f4$export$226b3eccf92c9ed9);
$parcel$export(module.exports, "index", () => $91ea6e17575ae7f4$export$b610b8812bbcded9);
$parcel$export(module.exports, "eq", () => $91ea6e17575ae7f4$export$9663ddc1cf085b32);
$parcel$export(module.exports, "append", () => $91ea6e17575ae7f4$export$10d8903dec122b9d);
$parcel$export(module.exports, "prepend", () => $91ea6e17575ae7f4$export$68159836694e22c1);
$parcel$export(module.exports, "next", () => $91ea6e17575ae7f4$export$48cfd1e771a65c4f);
$parcel$export(module.exports, "nextAll", () => $91ea6e17575ae7f4$export$3cd99760d81ede63);
$parcel$export(module.exports, "prev", () => $91ea6e17575ae7f4$export$232faf9add678146);
$parcel$export(module.exports, "prevAll", () => $91ea6e17575ae7f4$export$5a01ccd45552d0b4);
$parcel$export(module.exports, "parent", () => $91ea6e17575ae7f4$export$91124bb58bc04465);
$parcel$export(module.exports, "parents", () => $91ea6e17575ae7f4$export$7901f6cd558b9a93);
$parcel$export(module.exports, "closest", () => $91ea6e17575ae7f4$export$ff7f7c97cdce86e);
$parcel$export(module.exports, "find", () => $91ea6e17575ae7f4$export$71aa6c912b956294);
$parcel$export(module.exports, "children", () => $91ea6e17575ae7f4$export$bacb5cc5a11aef16);
$parcel$export(module.exports, "remove", () => $91ea6e17575ae7f4$export$cd7f480d6b8286c3);
/**
 * Dom7 4.0.6
 * Minimalistic JavaScript library for DOM manipulation, with a jQuery-compatible API
 * https://framework7.io/docs/dom7.html
 *
 * Copyright 2023, Vladimir Kharlampidi
 *
 * Licensed under MIT
 *
 * Released on: February 2, 2023
 */ 
var $bkUxr = parcelRequire("bkUxr");
/* eslint-disable no-proto */ function $91ea6e17575ae7f4$var$makeReactive(obj) {
    const proto = obj.__proto__;
    Object.defineProperty(obj, "__proto__", {
        get () {
            return proto;
        },
        set (value) {
            proto.__proto__ = value;
        }
    });
}
class $91ea6e17575ae7f4$var$Dom7 extends Array {
    constructor(items){
        if (typeof items === "number") super(items);
        else {
            super(...items || []);
            $91ea6e17575ae7f4$var$makeReactive(this);
        }
    }
}
function $91ea6e17575ae7f4$var$arrayFlat(arr = []) {
    const res = [];
    arr.forEach((el)=>{
        if (Array.isArray(el)) res.push(...$91ea6e17575ae7f4$var$arrayFlat(el));
        else res.push(el);
    });
    return res;
}
function $91ea6e17575ae7f4$var$arrayFilter(arr, callback) {
    return Array.prototype.filter.call(arr, callback);
}
function $91ea6e17575ae7f4$var$arrayUnique(arr) {
    const uniqueArray = [];
    for(let i = 0; i < arr.length; i += 1)if (uniqueArray.indexOf(arr[i]) === -1) uniqueArray.push(arr[i]);
    return uniqueArray;
}
function $91ea6e17575ae7f4$var$toCamelCase(string) {
    return string.toLowerCase().replace(/-(.)/g, (match, group)=>group.toUpperCase());
}
// eslint-disable-next-line
function $91ea6e17575ae7f4$var$qsa(selector, context) {
    if (typeof selector !== "string") return [
        selector
    ];
    const a = [];
    const res = context.querySelectorAll(selector);
    for(let i = 0; i < res.length; i += 1)a.push(res[i]);
    return a;
}
function $91ea6e17575ae7f4$export$3d8c2f653ac9d0b9(selector, context) {
    const window = (0, $bkUxr.getWindow)();
    const document = (0, $bkUxr.getDocument)();
    let arr = [];
    if (!context && selector instanceof $91ea6e17575ae7f4$var$Dom7) return selector;
    if (!selector) return new $91ea6e17575ae7f4$var$Dom7(arr);
    if (typeof selector === "string") {
        const html = selector.trim();
        if (html.indexOf("<") >= 0 && html.indexOf(">") >= 0) {
            let toCreate = "div";
            if (html.indexOf("<li") === 0) toCreate = "ul";
            if (html.indexOf("<tr") === 0) toCreate = "tbody";
            if (html.indexOf("<td") === 0 || html.indexOf("<th") === 0) toCreate = "tr";
            if (html.indexOf("<tbody") === 0) toCreate = "table";
            if (html.indexOf("<option") === 0) toCreate = "select";
            const tempParent = document.createElement(toCreate);
            tempParent.innerHTML = html;
            for(let i = 0; i < tempParent.childNodes.length; i += 1)arr.push(tempParent.childNodes[i]);
        } else arr = $91ea6e17575ae7f4$var$qsa(selector.trim(), context || document);
         // arr = qsa(selector, document);
    } else if (selector.nodeType || selector === window || selector === document) arr.push(selector);
    else if (Array.isArray(selector)) {
        if (selector instanceof $91ea6e17575ae7f4$var$Dom7) return selector;
        arr = selector;
    }
    return new $91ea6e17575ae7f4$var$Dom7($91ea6e17575ae7f4$var$arrayUnique(arr));
}
$91ea6e17575ae7f4$export$3d8c2f653ac9d0b9.fn = $91ea6e17575ae7f4$var$Dom7.prototype;
// eslint-disable-next-line
function $91ea6e17575ae7f4$export$d2cf6cd1dc7067d3(...classes) {
    const classNames = $91ea6e17575ae7f4$var$arrayFlat(classes.map((c)=>c.split(" ")));
    this.forEach((el)=>{
        el.classList.add(...classNames);
    });
    return this;
}
function $91ea6e17575ae7f4$export$c2255604a80b4506(...classes) {
    const classNames = $91ea6e17575ae7f4$var$arrayFlat(classes.map((c)=>c.split(" ")));
    this.forEach((el)=>{
        el.classList.remove(...classNames);
    });
    return this;
}
function $91ea6e17575ae7f4$export$4a80062ca50b57c7(...classes) {
    const classNames = $91ea6e17575ae7f4$var$arrayFlat(classes.map((c)=>c.split(" ")));
    this.forEach((el)=>{
        classNames.forEach((className)=>{
            el.classList.toggle(className);
        });
    });
}
function $91ea6e17575ae7f4$export$4ea3d958472af68f(...classes) {
    const classNames = $91ea6e17575ae7f4$var$arrayFlat(classes.map((c)=>c.split(" ")));
    return $91ea6e17575ae7f4$var$arrayFilter(this, (el)=>{
        return classNames.filter((className)=>el.classList.contains(className)).length > 0;
    }).length > 0;
}
function $91ea6e17575ae7f4$export$7aabe8b3a840d2fd(attrs, value) {
    if (arguments.length === 1 && typeof attrs === "string") {
        // Get attr
        if (this[0]) return this[0].getAttribute(attrs);
        return undefined;
    } // Set attrs
    for(let i = 0; i < this.length; i += 1){
        if (arguments.length === 2) // String
        this[i].setAttribute(attrs, value);
        else // Object
        for(const attrName in attrs){
            this[i][attrName] = attrs[attrName];
            this[i].setAttribute(attrName, attrs[attrName]);
        }
    }
    return this;
}
function $91ea6e17575ae7f4$export$842f2b51efdcb631(attr) {
    for(let i = 0; i < this.length; i += 1)this[i].removeAttribute(attr);
    return this;
}
function $91ea6e17575ae7f4$export$977f3f6a9323c0f6(props, value) {
    if (arguments.length === 1 && typeof props === "string") {
        // Get prop
        if (this[0]) return this[0][props];
    } else {
        // Set props
        for(let i = 0; i < this.length; i += 1){
            if (arguments.length === 2) // String
            this[i][props] = value;
            else // Object
            for(const propName in props)this[i][propName] = props[propName];
        }
        return this;
    }
    return this;
}
function $91ea6e17575ae7f4$export$4051a07651545597(key, value) {
    let el;
    if (typeof value === "undefined") {
        el = this[0];
        if (!el) return undefined; // Get value
        if (el.dom7ElementDataStorage && key in el.dom7ElementDataStorage) return el.dom7ElementDataStorage[key];
        const dataKey = el.getAttribute(`data-${key}`);
        if (dataKey) return dataKey;
        return undefined;
    } // Set value
    for(let i = 0; i < this.length; i += 1){
        el = this[i];
        if (!el.dom7ElementDataStorage) el.dom7ElementDataStorage = {};
        el.dom7ElementDataStorage[key] = value;
    }
    return this;
}
function $91ea6e17575ae7f4$export$33f1b464f736cf21(key) {
    for(let i = 0; i < this.length; i += 1){
        const el = this[i];
        if (el.dom7ElementDataStorage && el.dom7ElementDataStorage[key]) {
            el.dom7ElementDataStorage[key] = null;
            delete el.dom7ElementDataStorage[key];
        }
    }
}
function $91ea6e17575ae7f4$export$ff416b0d33795a06() {
    const el = this[0];
    if (!el) return undefined;
    const dataset = {}; // eslint-disable-line
    if (el.dataset) for(const dataKey in el.dataset)dataset[dataKey] = el.dataset[dataKey];
    else for(let i = 0; i < el.attributes.length; i += 1){
        const attr = el.attributes[i];
        if (attr.name.indexOf("data-") >= 0) dataset[$91ea6e17575ae7f4$var$toCamelCase(attr.name.split("data-")[1])] = attr.value;
    }
    for(const key in dataset){
        if (dataset[key] === "false") dataset[key] = false;
        else if (dataset[key] === "true") dataset[key] = true;
        else if (parseFloat(dataset[key]) === dataset[key] * 1) dataset[key] *= 1;
    }
    return dataset;
}
function $91ea6e17575ae7f4$export$b02c28252f48c6ac(value) {
    if (typeof value === "undefined") {
        // get value
        const el = this[0];
        if (!el) return undefined;
        if (el.multiple && el.nodeName.toLowerCase() === "select") {
            const values = [];
            for(let i = 0; i < el.selectedOptions.length; i += 1)values.push(el.selectedOptions[i].value);
            return values;
        }
        return el.value;
    } // set value
    for(let i = 0; i < this.length; i += 1){
        const el = this[i];
        if (Array.isArray(value) && el.multiple && el.nodeName.toLowerCase() === "select") for(let j = 0; j < el.options.length; j += 1)el.options[j].selected = value.indexOf(el.options[j].value) >= 0;
        else el.value = value;
    }
    return this;
}
function $91ea6e17575ae7f4$export$2ab9a8f9f1186f14(value) {
    return this.val(value);
}
function $91ea6e17575ae7f4$export$51186ad6e864892a(transform) {
    for(let i = 0; i < this.length; i += 1)this[i].style.transform = transform;
    return this;
}
function $91ea6e17575ae7f4$export$66bb15e2994e6a26(duration) {
    for(let i = 0; i < this.length; i += 1)this[i].style.transitionDuration = typeof duration !== "string" ? `${duration}ms` : duration;
    return this;
}
function $91ea6e17575ae7f4$export$af631764ddc44097(...args) {
    let [eventType, targetSelector, listener, capture] = args;
    if (typeof args[1] === "function") {
        [eventType, listener, capture] = args;
        targetSelector = undefined;
    }
    if (!capture) capture = false;
    function handleLiveEvent(e) {
        const target = e.target;
        if (!target) return;
        const eventData = e.target.dom7EventData || [];
        if (eventData.indexOf(e) < 0) eventData.unshift(e);
        if ($91ea6e17575ae7f4$export$3d8c2f653ac9d0b9(target).is(targetSelector)) listener.apply(target, eventData);
        else {
            const parents = $91ea6e17575ae7f4$export$3d8c2f653ac9d0b9(target).parents(); // eslint-disable-line
            for(let k = 0; k < parents.length; k += 1)if ($91ea6e17575ae7f4$export$3d8c2f653ac9d0b9(parents[k]).is(targetSelector)) listener.apply(parents[k], eventData);
        }
    }
    function handleEvent(e) {
        const eventData = e && e.target ? e.target.dom7EventData || [] : [];
        if (eventData.indexOf(e) < 0) eventData.unshift(e);
        listener.apply(this, eventData);
    }
    const events = eventType.split(" ");
    let j;
    for(let i = 0; i < this.length; i += 1){
        const el = this[i];
        if (!targetSelector) for(j = 0; j < events.length; j += 1){
            const event = events[j];
            if (!el.dom7Listeners) el.dom7Listeners = {};
            if (!el.dom7Listeners[event]) el.dom7Listeners[event] = [];
            el.dom7Listeners[event].push({
                listener: listener,
                proxyListener: handleEvent
            });
            el.addEventListener(event, handleEvent, capture);
        }
        else // Live events
        for(j = 0; j < events.length; j += 1){
            const event = events[j];
            if (!el.dom7LiveListeners) el.dom7LiveListeners = {};
            if (!el.dom7LiveListeners[event]) el.dom7LiveListeners[event] = [];
            el.dom7LiveListeners[event].push({
                listener: listener,
                proxyListener: handleLiveEvent
            });
            el.addEventListener(event, handleLiveEvent, capture);
        }
    }
    return this;
}
function $91ea6e17575ae7f4$export$8c8705df4a2dcec9(...args) {
    let [eventType, targetSelector, listener, capture] = args;
    if (typeof args[1] === "function") {
        [eventType, listener, capture] = args;
        targetSelector = undefined;
    }
    if (!capture) capture = false;
    const events = eventType.split(" ");
    for(let i = 0; i < events.length; i += 1){
        const event = events[i];
        for(let j = 0; j < this.length; j += 1){
            const el = this[j];
            let handlers;
            if (!targetSelector && el.dom7Listeners) handlers = el.dom7Listeners[event];
            else if (targetSelector && el.dom7LiveListeners) handlers = el.dom7LiveListeners[event];
            if (handlers && handlers.length) for(let k = handlers.length - 1; k >= 0; k -= 1){
                const handler = handlers[k];
                if (listener && handler.listener === listener) {
                    el.removeEventListener(event, handler.proxyListener, capture);
                    handlers.splice(k, 1);
                } else if (listener && handler.listener && handler.listener.dom7proxy && handler.listener.dom7proxy === listener) {
                    el.removeEventListener(event, handler.proxyListener, capture);
                    handlers.splice(k, 1);
                } else if (!listener) {
                    el.removeEventListener(event, handler.proxyListener, capture);
                    handlers.splice(k, 1);
                }
            }
        }
    }
    return this;
}
function $91ea6e17575ae7f4$export$d2de3aaeafa91619(...args) {
    const dom = this;
    let [eventName, targetSelector, listener, capture] = args;
    if (typeof args[1] === "function") {
        [eventName, listener, capture] = args;
        targetSelector = undefined;
    }
    function onceHandler(...eventArgs) {
        listener.apply(this, eventArgs);
        dom.off(eventName, targetSelector, onceHandler, capture);
        if (onceHandler.dom7proxy) delete onceHandler.dom7proxy;
    }
    onceHandler.dom7proxy = listener;
    return dom.on(eventName, targetSelector, onceHandler, capture);
}
function $91ea6e17575ae7f4$export$e614dc9140f7ae71(...args) {
    const window = (0, $bkUxr.getWindow)();
    const events = args[0].split(" ");
    const eventData = args[1];
    for(let i = 0; i < events.length; i += 1){
        const event = events[i];
        for(let j = 0; j < this.length; j += 1){
            const el = this[j];
            if (window.CustomEvent) {
                const evt = new window.CustomEvent(event, {
                    detail: eventData,
                    bubbles: true,
                    cancelable: true
                });
                el.dom7EventData = args.filter((data, dataIndex)=>dataIndex > 0);
                el.dispatchEvent(evt);
                el.dom7EventData = [];
                delete el.dom7EventData;
            }
        }
    }
    return this;
}
function $91ea6e17575ae7f4$export$1f5f3fbd0c021f73(callback) {
    const dom = this;
    function fireCallBack(e) {
        if (e.target !== this) return;
        callback.call(this, e);
        dom.off("transitionstart", fireCallBack);
    }
    if (callback) dom.on("transitionstart", fireCallBack);
    return this;
}
function $91ea6e17575ae7f4$export$358dc01d65cad417(callback) {
    const dom = this;
    function fireCallBack(e) {
        if (e.target !== this) return;
        callback.call(this, e);
        dom.off("transitionend", fireCallBack);
    }
    if (callback) dom.on("transitionend", fireCallBack);
    return this;
}
function $91ea6e17575ae7f4$export$70f051812b89bf32(callback) {
    const dom = this;
    function fireCallBack(e) {
        if (e.target !== this) return;
        callback.call(this, e);
        dom.off("animationend", fireCallBack);
    }
    if (callback) dom.on("animationend", fireCallBack);
    return this;
}
function $91ea6e17575ae7f4$export$7e3df82ee760448c() {
    const window = (0, $bkUxr.getWindow)();
    if (this[0] === window) return window.innerWidth;
    if (this.length > 0) return parseFloat(this.css("width"));
    return null;
}
function $91ea6e17575ae7f4$export$e823f88e4111159a(includeMargins) {
    if (this.length > 0) {
        if (includeMargins) {
            const styles = this.styles();
            return this[0].offsetWidth + parseFloat(styles.getPropertyValue("margin-right")) + parseFloat(styles.getPropertyValue("margin-left"));
        }
        return this[0].offsetWidth;
    }
    return null;
}
function $91ea6e17575ae7f4$export$ac607276a8fe9f0a() {
    const window = (0, $bkUxr.getWindow)();
    if (this[0] === window) return window.innerHeight;
    if (this.length > 0) return parseFloat(this.css("height"));
    return null;
}
function $91ea6e17575ae7f4$export$fc5b8aac72846d1e(includeMargins) {
    if (this.length > 0) {
        if (includeMargins) {
            const styles = this.styles();
            return this[0].offsetHeight + parseFloat(styles.getPropertyValue("margin-top")) + parseFloat(styles.getPropertyValue("margin-bottom"));
        }
        return this[0].offsetHeight;
    }
    return null;
}
function $91ea6e17575ae7f4$export$cc800923e997bb8() {
    if (this.length > 0) {
        const window = (0, $bkUxr.getWindow)();
        const document = (0, $bkUxr.getDocument)();
        const el = this[0];
        const box = el.getBoundingClientRect();
        const body = document.body;
        const clientTop = el.clientTop || body.clientTop || 0;
        const clientLeft = el.clientLeft || body.clientLeft || 0;
        const scrollTop = el === window ? window.scrollY : el.scrollTop;
        const scrollLeft = el === window ? window.scrollX : el.scrollLeft;
        return {
            top: box.top + scrollTop - clientTop,
            left: box.left + scrollLeft - clientLeft
        };
    }
    return null;
}
function $91ea6e17575ae7f4$export$fe8985bb6374093c() {
    for(let i = 0; i < this.length; i += 1)this[i].style.display = "none";
    return this;
}
function $91ea6e17575ae7f4$export$57bf213be019eeb0() {
    const window = (0, $bkUxr.getWindow)();
    for(let i = 0; i < this.length; i += 1){
        const el = this[i];
        if (el.style.display === "none") el.style.display = "";
        if (window.getComputedStyle(el, null).getPropertyValue("display") === "none") // Still not visible
        el.style.display = "block";
    }
    return this;
}
function $91ea6e17575ae7f4$export$9dd6ff9ea0189349() {
    const window = (0, $bkUxr.getWindow)();
    if (this[0]) return window.getComputedStyle(this[0], null);
    return {};
}
function $91ea6e17575ae7f4$export$dbf350e5966cf602(props, value) {
    const window = (0, $bkUxr.getWindow)();
    let i;
    if (arguments.length === 1) {
        if (typeof props === "string") {
            // .css('width')
            if (this[0]) return window.getComputedStyle(this[0], null).getPropertyValue(props);
        } else {
            // .css({ width: '100px' })
            for(i = 0; i < this.length; i += 1)for(const prop in props)this[i].style[prop] = props[prop];
            return this;
        }
    }
    if (arguments.length === 2 && typeof props === "string") {
        // .css('width', '100px')
        for(i = 0; i < this.length; i += 1)this[i].style[props] = value;
        return this;
    }
    return this;
}
function $91ea6e17575ae7f4$export$79b2f7037acddd43(callback) {
    if (!callback) return this;
    this.forEach((el, index)=>{
        callback.apply(el, [
            el,
            index
        ]);
    });
    return this;
}
function $91ea6e17575ae7f4$export$3dea766d36a8935f(callback) {
    const result = $91ea6e17575ae7f4$var$arrayFilter(this, callback);
    return $91ea6e17575ae7f4$export$3d8c2f653ac9d0b9(result);
}
function $91ea6e17575ae7f4$export$c0bb0b647f701bb5(html) {
    if (typeof html === "undefined") return this[0] ? this[0].innerHTML : null;
    for(let i = 0; i < this.length; i += 1)this[i].innerHTML = html;
    return this;
}
function $91ea6e17575ae7f4$export$6f093cfa640b7166(text) {
    if (typeof text === "undefined") return this[0] ? this[0].textContent.trim() : null;
    for(let i = 0; i < this.length; i += 1)this[i].textContent = text;
    return this;
}
function $91ea6e17575ae7f4$export$226b3eccf92c9ed9(selector) {
    const window = (0, $bkUxr.getWindow)();
    const document = (0, $bkUxr.getDocument)();
    const el = this[0];
    let compareWith;
    let i;
    if (!el || typeof selector === "undefined") return false;
    if (typeof selector === "string") {
        if (el.matches) return el.matches(selector);
        if (el.webkitMatchesSelector) return el.webkitMatchesSelector(selector);
        if (el.msMatchesSelector) return el.msMatchesSelector(selector);
        compareWith = $91ea6e17575ae7f4$export$3d8c2f653ac9d0b9(selector);
        for(i = 0; i < compareWith.length; i += 1){
            if (compareWith[i] === el) return true;
        }
        return false;
    }
    if (selector === document) return el === document;
    if (selector === window) return el === window;
    if (selector.nodeType || selector instanceof $91ea6e17575ae7f4$var$Dom7) {
        compareWith = selector.nodeType ? [
            selector
        ] : selector;
        for(i = 0; i < compareWith.length; i += 1){
            if (compareWith[i] === el) return true;
        }
        return false;
    }
    return false;
}
function $91ea6e17575ae7f4$export$b610b8812bbcded9() {
    let child = this[0];
    let i;
    if (child) {
        i = 0; // eslint-disable-next-line
        while((child = child.previousSibling) !== null)if (child.nodeType === 1) i += 1;
        return i;
    }
    return undefined;
}
function $91ea6e17575ae7f4$export$9663ddc1cf085b32(index) {
    if (typeof index === "undefined") return this;
    const length = this.length;
    if (index > length - 1) return $91ea6e17575ae7f4$export$3d8c2f653ac9d0b9([]);
    if (index < 0) {
        const returnIndex = length + index;
        if (returnIndex < 0) return $91ea6e17575ae7f4$export$3d8c2f653ac9d0b9([]);
        return $91ea6e17575ae7f4$export$3d8c2f653ac9d0b9([
            this[returnIndex]
        ]);
    }
    return $91ea6e17575ae7f4$export$3d8c2f653ac9d0b9([
        this[index]
    ]);
}
function $91ea6e17575ae7f4$export$10d8903dec122b9d(...els) {
    let newChild;
    const document = (0, $bkUxr.getDocument)();
    for(let k = 0; k < els.length; k += 1){
        newChild = els[k];
        for(let i = 0; i < this.length; i += 1){
            if (typeof newChild === "string") {
                const tempDiv = document.createElement("div");
                tempDiv.innerHTML = newChild;
                while(tempDiv.firstChild)this[i].appendChild(tempDiv.firstChild);
            } else if (newChild instanceof $91ea6e17575ae7f4$var$Dom7) for(let j = 0; j < newChild.length; j += 1)this[i].appendChild(newChild[j]);
            else this[i].appendChild(newChild);
        }
    }
    return this;
}
function $91ea6e17575ae7f4$export$9ceefe31f12a3778(parent) {
    $91ea6e17575ae7f4$export$3d8c2f653ac9d0b9(parent).append(this);
    return this;
}
function $91ea6e17575ae7f4$export$68159836694e22c1(newChild) {
    const document = (0, $bkUxr.getDocument)();
    let i;
    let j;
    for(i = 0; i < this.length; i += 1){
        if (typeof newChild === "string") {
            const tempDiv = document.createElement("div");
            tempDiv.innerHTML = newChild;
            for(j = tempDiv.childNodes.length - 1; j >= 0; j -= 1)this[i].insertBefore(tempDiv.childNodes[j], this[i].childNodes[0]);
        } else if (newChild instanceof $91ea6e17575ae7f4$var$Dom7) for(j = 0; j < newChild.length; j += 1)this[i].insertBefore(newChild[j], this[i].childNodes[0]);
        else this[i].insertBefore(newChild, this[i].childNodes[0]);
    }
    return this;
}
function $91ea6e17575ae7f4$export$44da2b52169043ea(parent) {
    $91ea6e17575ae7f4$export$3d8c2f653ac9d0b9(parent).prepend(this);
    return this;
}
function $91ea6e17575ae7f4$export$86b68c7dbeb53c22(selector) {
    const before = $91ea6e17575ae7f4$export$3d8c2f653ac9d0b9(selector);
    for(let i = 0; i < this.length; i += 1){
        if (before.length === 1) before[0].parentNode.insertBefore(this[i], before[0]);
        else if (before.length > 1) for(let j = 0; j < before.length; j += 1)before[j].parentNode.insertBefore(this[i].cloneNode(true), before[j]);
    }
}
function $91ea6e17575ae7f4$export$c4f94c8b3850a5a9(selector) {
    const after = $91ea6e17575ae7f4$export$3d8c2f653ac9d0b9(selector);
    for(let i = 0; i < this.length; i += 1){
        if (after.length === 1) after[0].parentNode.insertBefore(this[i], after[0].nextSibling);
        else if (after.length > 1) for(let j = 0; j < after.length; j += 1)after[j].parentNode.insertBefore(this[i].cloneNode(true), after[j].nextSibling);
    }
}
function $91ea6e17575ae7f4$export$48cfd1e771a65c4f(selector) {
    if (this.length > 0) {
        if (selector) {
            if (this[0].nextElementSibling && $91ea6e17575ae7f4$export$3d8c2f653ac9d0b9(this[0].nextElementSibling).is(selector)) return $91ea6e17575ae7f4$export$3d8c2f653ac9d0b9([
                this[0].nextElementSibling
            ]);
            return $91ea6e17575ae7f4$export$3d8c2f653ac9d0b9([]);
        }
        if (this[0].nextElementSibling) return $91ea6e17575ae7f4$export$3d8c2f653ac9d0b9([
            this[0].nextElementSibling
        ]);
        return $91ea6e17575ae7f4$export$3d8c2f653ac9d0b9([]);
    }
    return $91ea6e17575ae7f4$export$3d8c2f653ac9d0b9([]);
}
function $91ea6e17575ae7f4$export$3cd99760d81ede63(selector) {
    const nextEls = [];
    let el = this[0];
    if (!el) return $91ea6e17575ae7f4$export$3d8c2f653ac9d0b9([]);
    while(el.nextElementSibling){
        const next = el.nextElementSibling; // eslint-disable-line
        if (selector) {
            if ($91ea6e17575ae7f4$export$3d8c2f653ac9d0b9(next).is(selector)) nextEls.push(next);
        } else nextEls.push(next);
        el = next;
    }
    return $91ea6e17575ae7f4$export$3d8c2f653ac9d0b9(nextEls);
}
function $91ea6e17575ae7f4$export$232faf9add678146(selector) {
    if (this.length > 0) {
        const el = this[0];
        if (selector) {
            if (el.previousElementSibling && $91ea6e17575ae7f4$export$3d8c2f653ac9d0b9(el.previousElementSibling).is(selector)) return $91ea6e17575ae7f4$export$3d8c2f653ac9d0b9([
                el.previousElementSibling
            ]);
            return $91ea6e17575ae7f4$export$3d8c2f653ac9d0b9([]);
        }
        if (el.previousElementSibling) return $91ea6e17575ae7f4$export$3d8c2f653ac9d0b9([
            el.previousElementSibling
        ]);
        return $91ea6e17575ae7f4$export$3d8c2f653ac9d0b9([]);
    }
    return $91ea6e17575ae7f4$export$3d8c2f653ac9d0b9([]);
}
function $91ea6e17575ae7f4$export$5a01ccd45552d0b4(selector) {
    const prevEls = [];
    let el = this[0];
    if (!el) return $91ea6e17575ae7f4$export$3d8c2f653ac9d0b9([]);
    while(el.previousElementSibling){
        const prev = el.previousElementSibling; // eslint-disable-line
        if (selector) {
            if ($91ea6e17575ae7f4$export$3d8c2f653ac9d0b9(prev).is(selector)) prevEls.push(prev);
        } else prevEls.push(prev);
        el = prev;
    }
    return $91ea6e17575ae7f4$export$3d8c2f653ac9d0b9(prevEls);
}
function $91ea6e17575ae7f4$export$9866dd70b0dcd4c3(selector) {
    return this.nextAll(selector).add(this.prevAll(selector));
}
function $91ea6e17575ae7f4$export$91124bb58bc04465(selector) {
    const parents = []; // eslint-disable-line
    for(let i = 0; i < this.length; i += 1)if (this[i].parentNode !== null) {
        if (selector) {
            if ($91ea6e17575ae7f4$export$3d8c2f653ac9d0b9(this[i].parentNode).is(selector)) parents.push(this[i].parentNode);
        } else parents.push(this[i].parentNode);
    }
    return $91ea6e17575ae7f4$export$3d8c2f653ac9d0b9(parents);
}
function $91ea6e17575ae7f4$export$7901f6cd558b9a93(selector) {
    const parents = []; // eslint-disable-line
    for(let i = 0; i < this.length; i += 1){
        let parent = this[i].parentNode; // eslint-disable-line
        while(parent){
            if (selector) {
                if ($91ea6e17575ae7f4$export$3d8c2f653ac9d0b9(parent).is(selector)) parents.push(parent);
            } else parents.push(parent);
            parent = parent.parentNode;
        }
    }
    return $91ea6e17575ae7f4$export$3d8c2f653ac9d0b9(parents);
}
function $91ea6e17575ae7f4$export$ff7f7c97cdce86e(selector) {
    let closest = this; // eslint-disable-line
    if (typeof selector === "undefined") return $91ea6e17575ae7f4$export$3d8c2f653ac9d0b9([]);
    if (!closest.is(selector)) closest = closest.parents(selector).eq(0);
    return closest;
}
function $91ea6e17575ae7f4$export$71aa6c912b956294(selector) {
    const foundElements = [];
    for(let i = 0; i < this.length; i += 1){
        const found = this[i].querySelectorAll(selector);
        for(let j = 0; j < found.length; j += 1)foundElements.push(found[j]);
    }
    return $91ea6e17575ae7f4$export$3d8c2f653ac9d0b9(foundElements);
}
function $91ea6e17575ae7f4$export$bacb5cc5a11aef16(selector) {
    const children = []; // eslint-disable-line
    for(let i = 0; i < this.length; i += 1){
        const childNodes = this[i].children;
        for(let j = 0; j < childNodes.length; j += 1)if (!selector || $91ea6e17575ae7f4$export$3d8c2f653ac9d0b9(childNodes[j]).is(selector)) children.push(childNodes[j]);
    }
    return $91ea6e17575ae7f4$export$3d8c2f653ac9d0b9(children);
}
function $91ea6e17575ae7f4$export$cd7f480d6b8286c3() {
    for(let i = 0; i < this.length; i += 1)if (this[i].parentNode) this[i].parentNode.removeChild(this[i]);
    return this;
}
function $91ea6e17575ae7f4$export$3f780019ff766da6() {
    return this.remove();
}
function $91ea6e17575ae7f4$export$e16d8520af44a096(...els) {
    const dom = this;
    let i;
    let j;
    for(i = 0; i < els.length; i += 1){
        const toAdd = $91ea6e17575ae7f4$export$3d8c2f653ac9d0b9(els[i]);
        for(j = 0; j < toAdd.length; j += 1)dom.push(toAdd[j]);
    }
    return dom;
}
function $91ea6e17575ae7f4$export$6e22c362a0406a2c() {
    for(let i = 0; i < this.length; i += 1){
        const el = this[i];
        if (el.nodeType === 1) {
            for(let j = 0; j < el.childNodes.length; j += 1)if (el.childNodes[j].parentNode) el.childNodes[j].parentNode.removeChild(el.childNodes[j]);
            el.textContent = "";
        }
    }
    return this;
}
// eslint-disable-next-line
function $91ea6e17575ae7f4$export$3f99968195accfaf(...args) {
    const window = (0, $bkUxr.getWindow)();
    let [left, top, duration, easing, callback] = args;
    if (args.length === 4 && typeof easing === "function") {
        callback = easing;
        [left, top, duration, callback, easing] = args;
    }
    if (typeof easing === "undefined") easing = "swing";
    return this.each(function animate() {
        const el = this;
        let currentTop;
        let currentLeft;
        let maxTop;
        let maxLeft;
        let newTop;
        let newLeft;
        let scrollTop; // eslint-disable-line
        let scrollLeft; // eslint-disable-line
        let animateTop = top > 0 || top === 0;
        let animateLeft = left > 0 || left === 0;
        if (typeof easing === "undefined") easing = "swing";
        if (animateTop) {
            currentTop = el.scrollTop;
            if (!duration) el.scrollTop = top;
        }
        if (animateLeft) {
            currentLeft = el.scrollLeft;
            if (!duration) el.scrollLeft = left;
        }
        if (!duration) return;
        if (animateTop) {
            maxTop = el.scrollHeight - el.offsetHeight;
            newTop = Math.max(Math.min(top, maxTop), 0);
        }
        if (animateLeft) {
            maxLeft = el.scrollWidth - el.offsetWidth;
            newLeft = Math.max(Math.min(left, maxLeft), 0);
        }
        let startTime = null;
        if (animateTop && newTop === currentTop) animateTop = false;
        if (animateLeft && newLeft === currentLeft) animateLeft = false;
        function render(time = new Date().getTime()) {
            if (startTime === null) startTime = time;
            const progress = Math.max(Math.min((time - startTime) / duration, 1), 0);
            const easeProgress = easing === "linear" ? progress : 0.5 - Math.cos(progress * Math.PI) / 2;
            let done;
            if (animateTop) scrollTop = currentTop + easeProgress * (newTop - currentTop);
            if (animateLeft) scrollLeft = currentLeft + easeProgress * (newLeft - currentLeft);
            if (animateTop && newTop > currentTop && scrollTop >= newTop) {
                el.scrollTop = newTop;
                done = true;
            }
            if (animateTop && newTop < currentTop && scrollTop <= newTop) {
                el.scrollTop = newTop;
                done = true;
            }
            if (animateLeft && newLeft > currentLeft && scrollLeft >= newLeft) {
                el.scrollLeft = newLeft;
                done = true;
            }
            if (animateLeft && newLeft < currentLeft && scrollLeft <= newLeft) {
                el.scrollLeft = newLeft;
                done = true;
            }
            if (done) {
                if (callback) callback();
                return;
            }
            if (animateTop) el.scrollTop = scrollTop;
            if (animateLeft) el.scrollLeft = scrollLeft;
            window.requestAnimationFrame(render);
        }
        window.requestAnimationFrame(render);
    });
} // scrollTop(top, duration, easing, callback) {
function $91ea6e17575ae7f4$export$3e0c8fa3b5e4b3b9(...args) {
    let [top, duration, easing, callback] = args;
    if (args.length === 3 && typeof easing === "function") [top, duration, callback, easing] = args;
    const dom = this;
    if (typeof top === "undefined") {
        if (dom.length > 0) return dom[0].scrollTop;
        return null;
    }
    return dom.scrollTo(undefined, top, duration, easing, callback);
}
function $91ea6e17575ae7f4$export$6eddf9bc7f2b7d80(...args) {
    let [left, duration, easing, callback] = args;
    if (args.length === 3 && typeof easing === "function") [left, duration, callback, easing] = args;
    const dom = this;
    if (typeof left === "undefined") {
        if (dom.length > 0) return dom[0].scrollLeft;
        return null;
    }
    return dom.scrollTo(left, undefined, duration, easing, callback);
}
// eslint-disable-next-line
function $91ea6e17575ae7f4$export$e3607ec2d7a891c4(initialProps, initialParams) {
    const window = (0, $bkUxr.getWindow)();
    const els = this;
    const a = {
        props: Object.assign({}, initialProps),
        params: Object.assign({
            duration: 300,
            easing: "swing" // or 'linear'
        }, initialParams),
        elements: els,
        animating: false,
        que: [],
        easingProgress (easing, progress) {
            if (easing === "swing") return 0.5 - Math.cos(progress * Math.PI) / 2;
            if (typeof easing === "function") return easing(progress);
            return progress;
        },
        stop () {
            if (a.frameId) window.cancelAnimationFrame(a.frameId);
            a.animating = false;
            a.elements.each((el)=>{
                const element = el;
                delete element.dom7AnimateInstance;
            });
            a.que = [];
        },
        done (complete) {
            a.animating = false;
            a.elements.each((el)=>{
                const element = el;
                delete element.dom7AnimateInstance;
            });
            if (complete) complete(els);
            if (a.que.length > 0) {
                const que = a.que.shift();
                a.animate(que[0], que[1]);
            }
        },
        animate (props, params) {
            if (a.animating) {
                a.que.push([
                    props,
                    params
                ]);
                return a;
            }
            const elements = []; // Define & Cache Initials & Units
            a.elements.each((el, index)=>{
                let initialFullValue;
                let initialValue;
                let unit;
                let finalValue;
                let finalFullValue;
                if (!el.dom7AnimateInstance) a.elements[index].dom7AnimateInstance = a;
                elements[index] = {
                    container: el
                };
                Object.keys(props).forEach((prop)=>{
                    initialFullValue = window.getComputedStyle(el, null).getPropertyValue(prop).replace(",", ".");
                    initialValue = parseFloat(initialFullValue);
                    unit = initialFullValue.replace(initialValue, "");
                    finalValue = parseFloat(props[prop]);
                    finalFullValue = props[prop] + unit;
                    elements[index][prop] = {
                        initialFullValue: initialFullValue,
                        initialValue: initialValue,
                        unit: unit,
                        finalValue: finalValue,
                        finalFullValue: finalFullValue,
                        currentValue: initialValue
                    };
                });
            });
            let startTime = null;
            let time;
            let elementsDone = 0;
            let propsDone = 0;
            let done;
            let began = false;
            a.animating = true;
            function render() {
                time = new Date().getTime();
                let progress;
                let easeProgress; // let el;
                if (!began) {
                    began = true;
                    if (params.begin) params.begin(els);
                }
                if (startTime === null) startTime = time;
                if (params.progress) // eslint-disable-next-line
                params.progress(els, Math.max(Math.min((time - startTime) / params.duration, 1), 0), startTime + params.duration - time < 0 ? 0 : startTime + params.duration - time, startTime);
                elements.forEach((element)=>{
                    const el = element;
                    if (done || el.done) return;
                    Object.keys(props).forEach((prop)=>{
                        if (done || el.done) return;
                        progress = Math.max(Math.min((time - startTime) / params.duration, 1), 0);
                        easeProgress = a.easingProgress(params.easing, progress);
                        const { initialValue: initialValue, finalValue: finalValue, unit: unit } = el[prop];
                        el[prop].currentValue = initialValue + easeProgress * (finalValue - initialValue);
                        const currentValue = el[prop].currentValue;
                        if (finalValue > initialValue && currentValue >= finalValue || finalValue < initialValue && currentValue <= finalValue) {
                            el.container.style[prop] = finalValue + unit;
                            propsDone += 1;
                            if (propsDone === Object.keys(props).length) {
                                el.done = true;
                                elementsDone += 1;
                            }
                            if (elementsDone === elements.length) done = true;
                        }
                        if (done) {
                            a.done(params.complete);
                            return;
                        }
                        el.container.style[prop] = currentValue + unit;
                    });
                });
                if (done) return; // Then call
                a.frameId = window.requestAnimationFrame(render);
            }
            a.frameId = window.requestAnimationFrame(render);
            return a;
        }
    };
    if (a.elements.length === 0) return els;
    let animateInstance;
    for(let i = 0; i < a.elements.length; i += 1)if (a.elements[i].dom7AnimateInstance) animateInstance = a.elements[i].dom7AnimateInstance;
    else a.elements[i].dom7AnimateInstance = a;
    if (!animateInstance) animateInstance = a;
    if (initialProps === "stop") animateInstance.stop();
    else animateInstance.animate(a.props, a.params);
    return els;
}
function $91ea6e17575ae7f4$export$fa6813432f753b0d() {
    const els = this;
    for(let i = 0; i < els.length; i += 1)if (els[i].dom7AnimateInstance) els[i].dom7AnimateInstance.stop();
}
const $91ea6e17575ae7f4$var$noTrigger = "resize scroll".split(" ");
function $91ea6e17575ae7f4$var$shortcut(name) {
    function eventHandler(...args) {
        if (typeof args[0] === "undefined") {
            for(let i = 0; i < this.length; i += 1)if ($91ea6e17575ae7f4$var$noTrigger.indexOf(name) < 0) {
                if (name in this[i]) this[i][name]();
                else $91ea6e17575ae7f4$export$3d8c2f653ac9d0b9(this[i]).trigger(name);
            }
            return this;
        }
        return this.on(name, ...args);
    }
    return eventHandler;
}
const $91ea6e17575ae7f4$export$64ef1bee2b9504c1 = $91ea6e17575ae7f4$var$shortcut("click");
const $91ea6e17575ae7f4$export$2cc7ff91bcacba5e = $91ea6e17575ae7f4$var$shortcut("blur");
const $91ea6e17575ae7f4$export$d7ddd398f22d79ef = $91ea6e17575ae7f4$var$shortcut("focus");
const $91ea6e17575ae7f4$export$e7fa4ea7f1bfcb53 = $91ea6e17575ae7f4$var$shortcut("focusin");
const $91ea6e17575ae7f4$export$d0dc5134b51e78ad = $91ea6e17575ae7f4$var$shortcut("focusout");
const $91ea6e17575ae7f4$export$d26052c770f81a55 = $91ea6e17575ae7f4$var$shortcut("keyup");
const $91ea6e17575ae7f4$export$e65a0c4970da3025 = $91ea6e17575ae7f4$var$shortcut("keydown");
const $91ea6e17575ae7f4$export$563caf6ae76a8875 = $91ea6e17575ae7f4$var$shortcut("keypress");
const $91ea6e17575ae7f4$export$853c27de4ce0f746 = $91ea6e17575ae7f4$var$shortcut("submit");
const $91ea6e17575ae7f4$export$d8a7b8f475ec0161 = $91ea6e17575ae7f4$var$shortcut("change");
const $91ea6e17575ae7f4$export$8b0cb8993e7a9391 = $91ea6e17575ae7f4$var$shortcut("mousedown");
const $91ea6e17575ae7f4$export$6d0a9e0f4f73830a = $91ea6e17575ae7f4$var$shortcut("mousemove");
const $91ea6e17575ae7f4$export$c367b5bd9b361db9 = $91ea6e17575ae7f4$var$shortcut("mouseup");
const $91ea6e17575ae7f4$export$474cd8abd87e2f89 = $91ea6e17575ae7f4$var$shortcut("mouseenter");
const $91ea6e17575ae7f4$export$996a190879e3098b = $91ea6e17575ae7f4$var$shortcut("mouseleave");
const $91ea6e17575ae7f4$export$c3a736a37c400eb8 = $91ea6e17575ae7f4$var$shortcut("mouseout");
const $91ea6e17575ae7f4$export$41b161f130dc7f9 = $91ea6e17575ae7f4$var$shortcut("mouseover");
const $91ea6e17575ae7f4$export$9f22968b38117503 = $91ea6e17575ae7f4$var$shortcut("touchstart");
const $91ea6e17575ae7f4$export$3c6ab5207a63e8f7 = $91ea6e17575ae7f4$var$shortcut("touchend");
const $91ea6e17575ae7f4$export$3086217c4efdbcc9 = $91ea6e17575ae7f4$var$shortcut("touchmove");
const $91ea6e17575ae7f4$export$4380c87abf28fdf = $91ea6e17575ae7f4$var$shortcut("resize");
const $91ea6e17575ae7f4$export$209876d7b1ac8f3 = $91ea6e17575ae7f4$var$shortcut("scroll");
var $91ea6e17575ae7f4$export$2e2bcd8739ae039 = $91ea6e17575ae7f4$export$3d8c2f653ac9d0b9;

});


parcelRequire.register("2y7Cr", function(module, exports) {

$parcel$export(module.exports, "deleteProps", () => $1db4aabdafdd3c5d$export$8694e5c03a4df8e6);
$parcel$export(module.exports, "nextTick", () => $1db4aabdafdd3c5d$export$bdd553fddd433dcb);
$parcel$export(module.exports, "now", () => $1db4aabdafdd3c5d$export$461939dd4422153);
$parcel$export(module.exports, "getTranslate", () => $1db4aabdafdd3c5d$export$5ec402b7fcf74398);
$parcel$export(module.exports, "isObject", () => $1db4aabdafdd3c5d$export$a6cdc56e425d0d0a);
$parcel$export(module.exports, "extend", () => $1db4aabdafdd3c5d$export$8b58be045bf06082);
$parcel$export(module.exports, "setCSSProperty", () => $1db4aabdafdd3c5d$export$a607267f322101fd);
$parcel$export(module.exports, "animateCSSModeScroll", () => $1db4aabdafdd3c5d$export$a5dd2b4b1a116d6d);

var $bkUxr = parcelRequire("bkUxr");
function $1db4aabdafdd3c5d$export$8694e5c03a4df8e6(obj) {
    const object = obj;
    Object.keys(object).forEach((key)=>{
        try {
            object[key] = null;
        } catch (e) {}
        try {
            delete object[key];
        } catch (e) {}
    });
}
function $1db4aabdafdd3c5d$export$bdd553fddd433dcb(callback, delay = 0) {
    return setTimeout(callback, delay);
}
function $1db4aabdafdd3c5d$export$461939dd4422153() {
    return Date.now();
}
function $1db4aabdafdd3c5d$export$3735103072e4a80(el) {
    const window1 = (0, $bkUxr.getWindow)();
    let style;
    if (window1.getComputedStyle) style = window1.getComputedStyle(el, null);
    if (!style && el.currentStyle) style = el.currentStyle;
    if (!style) style = el.style;
    return style;
}
function $1db4aabdafdd3c5d$export$5ec402b7fcf74398(el, axis = "x") {
    const window1 = (0, $bkUxr.getWindow)();
    let matrix;
    let curTransform;
    let transformMatrix;
    const curStyle = $1db4aabdafdd3c5d$export$3735103072e4a80(el, null);
    if (window1.WebKitCSSMatrix) {
        curTransform = curStyle.transform || curStyle.webkitTransform;
        if (curTransform.split(",").length > 6) curTransform = curTransform.split(", ").map((a)=>a.replace(",", ".")).join(", ");
         // Some old versions of Webkit choke when 'none' is passed; pass
        // empty string instead in this case
        transformMatrix = new window1.WebKitCSSMatrix(curTransform === "none" ? "" : curTransform);
    } else {
        transformMatrix = curStyle.MozTransform || curStyle.OTransform || curStyle.MsTransform || curStyle.msTransform || curStyle.transform || curStyle.getPropertyValue("transform").replace("translate(", "matrix(1, 0, 0, 1,");
        matrix = transformMatrix.toString().split(",");
    }
    if (axis === "x") {
        // Latest Chrome and webkits Fix
        if (window1.WebKitCSSMatrix) curTransform = transformMatrix.m41; // Crazy IE10 Matrix
        else if (matrix.length === 16) curTransform = parseFloat(matrix[12]); // Normal Browsers
        else curTransform = parseFloat(matrix[4]);
    }
    if (axis === "y") {
        // Latest Chrome and webkits Fix
        if (window1.WebKitCSSMatrix) curTransform = transformMatrix.m42; // Crazy IE10 Matrix
        else if (matrix.length === 16) curTransform = parseFloat(matrix[13]); // Normal Browsers
        else curTransform = parseFloat(matrix[5]);
    }
    return curTransform || 0;
}
function $1db4aabdafdd3c5d$export$a6cdc56e425d0d0a(o) {
    return typeof o === "object" && o !== null && o.constructor && Object.prototype.toString.call(o).slice(8, -1) === "Object";
}
function $1db4aabdafdd3c5d$var$isNode(node) {
    // eslint-disable-next-line
    if (typeof window !== "undefined" && typeof window.HTMLElement !== "undefined") return node instanceof HTMLElement;
    return node && (node.nodeType === 1 || node.nodeType === 11);
}
function $1db4aabdafdd3c5d$export$8b58be045bf06082(...args) {
    const to = Object(args[0]);
    const noExtend = [
        "__proto__",
        "constructor",
        "prototype"
    ];
    for(let i = 1; i < args.length; i += 1){
        const nextSource = args[i];
        if (nextSource !== undefined && nextSource !== null && !$1db4aabdafdd3c5d$var$isNode(nextSource)) {
            const keysArray = Object.keys(Object(nextSource)).filter((key)=>noExtend.indexOf(key) < 0);
            for(let nextIndex = 0, len = keysArray.length; nextIndex < len; nextIndex += 1){
                const nextKey = keysArray[nextIndex];
                const desc = Object.getOwnPropertyDescriptor(nextSource, nextKey);
                if (desc !== undefined && desc.enumerable) {
                    if ($1db4aabdafdd3c5d$export$a6cdc56e425d0d0a(to[nextKey]) && $1db4aabdafdd3c5d$export$a6cdc56e425d0d0a(nextSource[nextKey])) {
                        if (nextSource[nextKey].__swiper__) to[nextKey] = nextSource[nextKey];
                        else $1db4aabdafdd3c5d$export$8b58be045bf06082(to[nextKey], nextSource[nextKey]);
                    } else if (!$1db4aabdafdd3c5d$export$a6cdc56e425d0d0a(to[nextKey]) && $1db4aabdafdd3c5d$export$a6cdc56e425d0d0a(nextSource[nextKey])) {
                        to[nextKey] = {};
                        if (nextSource[nextKey].__swiper__) to[nextKey] = nextSource[nextKey];
                        else $1db4aabdafdd3c5d$export$8b58be045bf06082(to[nextKey], nextSource[nextKey]);
                    } else to[nextKey] = nextSource[nextKey];
                }
            }
        }
    }
    return to;
}
function $1db4aabdafdd3c5d$export$a607267f322101fd(el, varName, varValue) {
    el.style.setProperty(varName, varValue);
}
function $1db4aabdafdd3c5d$export$a5dd2b4b1a116d6d({ swiper: swiper, targetPosition: targetPosition, side: side }) {
    const window1 = (0, $bkUxr.getWindow)();
    const startPosition = -swiper.translate;
    let startTime = null;
    let time;
    const duration = swiper.params.speed;
    swiper.wrapperEl.style.scrollSnapType = "none";
    window1.cancelAnimationFrame(swiper.cssModeFrameID);
    const dir = targetPosition > startPosition ? "next" : "prev";
    const isOutOfBound = (current, target)=>{
        return dir === "next" && current >= target || dir === "prev" && current <= target;
    };
    const animate = ()=>{
        time = new Date().getTime();
        if (startTime === null) startTime = time;
        const progress = Math.max(Math.min((time - startTime) / duration, 1), 0);
        const easeProgress = 0.5 - Math.cos(progress * Math.PI) / 2;
        let currentPosition = startPosition + easeProgress * (targetPosition - startPosition);
        if (isOutOfBound(currentPosition, targetPosition)) currentPosition = targetPosition;
        swiper.wrapperEl.scrollTo({
            [side]: currentPosition
        });
        if (isOutOfBound(currentPosition, targetPosition)) {
            swiper.wrapperEl.style.overflow = "hidden";
            swiper.wrapperEl.style.scrollSnapType = "";
            setTimeout(()=>{
                swiper.wrapperEl.style.overflow = "";
                swiper.wrapperEl.scrollTo({
                    [side]: currentPosition
                });
            });
            window1.cancelAnimationFrame(swiper.cssModeFrameID);
            return;
        }
        swiper.cssModeFrameID = window1.requestAnimationFrame(animate);
    };
    animate();
}

});

parcelRequire.register("fSK3l", function(module, exports) {

$parcel$export(module.exports, "getSupport", () => $b8ff9f53ed97c54e$export$d61c7b85ff180578);

var $bkUxr = parcelRequire("bkUxr");
let $b8ff9f53ed97c54e$var$support;
function $b8ff9f53ed97c54e$var$calcSupport() {
    const window = (0, $bkUxr.getWindow)();
    const document = (0, $bkUxr.getDocument)();
    return {
        smoothScroll: document.documentElement && "scrollBehavior" in document.documentElement.style,
        touch: !!("ontouchstart" in window || window.DocumentTouch && document instanceof window.DocumentTouch),
        passiveListener: function checkPassiveListener() {
            let supportsPassive = false;
            try {
                const opts = Object.defineProperty({}, "passive", {
                    // eslint-disable-next-line
                    get () {
                        supportsPassive = true;
                    }
                });
                window.addEventListener("testPassiveListener", null, opts);
            } catch (e) {}
            return supportsPassive;
        }(),
        gestures: function checkGestures() {
            return "ongesturestart" in window;
        }()
    };
}
function $b8ff9f53ed97c54e$export$d61c7b85ff180578() {
    if (!$b8ff9f53ed97c54e$var$support) $b8ff9f53ed97c54e$var$support = $b8ff9f53ed97c54e$var$calcSupport();
    return $b8ff9f53ed97c54e$var$support;
}

});

parcelRequire.register("8QIbd", function(module, exports) {

$parcel$export(module.exports, "getDevice", () => $6715734198f1bced$export$30c823bc834d6ab4);

var $bkUxr = parcelRequire("bkUxr");

var $fSK3l = parcelRequire("fSK3l");
let $6715734198f1bced$var$deviceCached;
function $6715734198f1bced$var$calcDevice({ userAgent: userAgent } = {}) {
    const support = (0, $fSK3l.getSupport)();
    const window = (0, $bkUxr.getWindow)();
    const platform = window.navigator.platform;
    const ua = userAgent || window.navigator.userAgent;
    const device = {
        ios: false,
        android: false
    };
    const screenWidth = window.screen.width;
    const screenHeight = window.screen.height;
    const android = ua.match(/(Android);?[\s\/]+([\d.]+)?/); // eslint-disable-line
    let ipad = ua.match(/(iPad).*OS\s([\d_]+)/);
    const ipod = ua.match(/(iPod)(.*OS\s([\d_]+))?/);
    const iphone = !ipad && ua.match(/(iPhone\sOS|iOS)\s([\d_]+)/);
    const windows = platform === "Win32";
    let macos = platform === "MacIntel"; // iPadOs 13 fix
    const iPadScreens = [
        "1024x1366",
        "1366x1024",
        "834x1194",
        "1194x834",
        "834x1112",
        "1112x834",
        "768x1024",
        "1024x768",
        "820x1180",
        "1180x820",
        "810x1080",
        "1080x810"
    ];
    if (!ipad && macos && support.touch && iPadScreens.indexOf(`${screenWidth}x${screenHeight}`) >= 0) {
        ipad = ua.match(/(Version)\/([\d.]+)/);
        if (!ipad) ipad = [
            0,
            1,
            "13_0_0"
        ];
        macos = false;
    } // Android
    if (android && !windows) {
        device.os = "android";
        device.android = true;
    }
    if (ipad || iphone || ipod) {
        device.os = "ios";
        device.ios = true;
    } // Export object
    return device;
}
function $6715734198f1bced$export$30c823bc834d6ab4(overrides = {}) {
    if (!$6715734198f1bced$var$deviceCached) $6715734198f1bced$var$deviceCached = $6715734198f1bced$var$calcDevice(overrides);
    return $6715734198f1bced$var$deviceCached;
}

});

parcelRequire.register("a6CQr", function(module, exports) {

$parcel$export(module.exports, "getBrowser", () => $75b898b248f7a725$export$89e15fc796a4a429);

var $bkUxr = parcelRequire("bkUxr");
let $75b898b248f7a725$var$browser;
function $75b898b248f7a725$var$calcBrowser() {
    const window = (0, $bkUxr.getWindow)();
    function isSafari() {
        const ua = window.navigator.userAgent.toLowerCase();
        return ua.indexOf("safari") >= 0 && ua.indexOf("chrome") < 0 && ua.indexOf("android") < 0;
    }
    return {
        isSafari: isSafari(),
        isWebView: /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(window.navigator.userAgent)
    };
}
function $75b898b248f7a725$export$89e15fc796a4a429() {
    if (!$75b898b248f7a725$var$browser) $75b898b248f7a725$var$browser = $75b898b248f7a725$var$calcBrowser();
    return $75b898b248f7a725$var$browser;
}

});

parcelRequire.register("bObVi", function(module, exports) {

$parcel$export(module.exports, "default", () => $898d9ce9d5c96f84$export$2e2bcd8739ae039);

var $bkUxr = parcelRequire("bkUxr");
function $898d9ce9d5c96f84$export$2e2bcd8739ae039({ swiper: swiper, on: on, emit: emit }) {
    const window = (0, $bkUxr.getWindow)();
    let observer = null;
    let animationFrame = null;
    const resizeHandler = ()=>{
        if (!swiper || swiper.destroyed || !swiper.initialized) return;
        emit("beforeResize");
        emit("resize");
    };
    const createObserver = ()=>{
        if (!swiper || swiper.destroyed || !swiper.initialized) return;
        observer = new ResizeObserver((entries)=>{
            animationFrame = window.requestAnimationFrame(()=>{
                const { width: width, height: height } = swiper;
                let newWidth = width;
                let newHeight = height;
                entries.forEach(({ contentBoxSize: contentBoxSize, contentRect: contentRect, target: target })=>{
                    if (target && target !== swiper.el) return;
                    newWidth = contentRect ? contentRect.width : (contentBoxSize[0] || contentBoxSize).inlineSize;
                    newHeight = contentRect ? contentRect.height : (contentBoxSize[0] || contentBoxSize).blockSize;
                });
                if (newWidth !== width || newHeight !== height) resizeHandler();
            });
        });
        observer.observe(swiper.el);
    };
    const removeObserver = ()=>{
        if (animationFrame) window.cancelAnimationFrame(animationFrame);
        if (observer && observer.unobserve && swiper.el) {
            observer.unobserve(swiper.el);
            observer = null;
        }
    };
    const orientationChangeHandler = ()=>{
        if (!swiper || swiper.destroyed || !swiper.initialized) return;
        emit("orientationchange");
    };
    on("init", ()=>{
        if (swiper.params.resizeObserver && typeof window.ResizeObserver !== "undefined") {
            createObserver();
            return;
        }
        window.addEventListener("resize", resizeHandler);
        window.addEventListener("orientationchange", orientationChangeHandler);
    });
    on("destroy", ()=>{
        removeObserver();
        window.removeEventListener("resize", resizeHandler);
        window.removeEventListener("orientationchange", orientationChangeHandler);
    });
}

});

parcelRequire.register("eJ5qv", function(module, exports) {

$parcel$export(module.exports, "default", () => $ab897a40c5a083fd$export$2e2bcd8739ae039);

var $bkUxr = parcelRequire("bkUxr");
function $ab897a40c5a083fd$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on, emit: emit }) {
    const observers = [];
    const window = (0, $bkUxr.getWindow)();
    const attach = (target, options = {})=>{
        const ObserverFunc = window.MutationObserver || window.WebkitMutationObserver;
        const observer = new ObserverFunc((mutations)=>{
            // The observerUpdate event should only be triggered
            // once despite the number of mutations.  Additional
            // triggers are redundant and are very costly
            if (mutations.length === 1) {
                emit("observerUpdate", mutations[0]);
                return;
            }
            const observerUpdate = function observerUpdate() {
                emit("observerUpdate", mutations[0]);
            };
            if (window.requestAnimationFrame) window.requestAnimationFrame(observerUpdate);
            else window.setTimeout(observerUpdate, 0);
        });
        observer.observe(target, {
            attributes: typeof options.attributes === "undefined" ? true : options.attributes,
            childList: typeof options.childList === "undefined" ? true : options.childList,
            characterData: typeof options.characterData === "undefined" ? true : options.characterData
        });
        observers.push(observer);
    };
    const init = ()=>{
        if (!swiper.params.observer) return;
        if (swiper.params.observeParents) {
            const containerParents = swiper.$el.parents();
            for(let i = 0; i < containerParents.length; i += 1)attach(containerParents[i]);
        } // Observe container
        attach(swiper.$el[0], {
            childList: swiper.params.observeSlideChildren
        }); // Observe wrapper
        attach(swiper.$wrapperEl[0], {
            attributes: false
        });
    };
    const destroy = ()=>{
        observers.forEach((observer)=>{
            observer.disconnect();
        });
        observers.splice(0, observers.length);
    };
    extendParams({
        observer: false,
        observeParents: false,
        observeSlideChildren: false
    });
    on("init", init);
    on("destroy", destroy);
}

});

parcelRequire.register("e5xSM", function(module, exports) {

$parcel$export(module.exports, "default", () => $a41bd0b430e61869$export$2e2bcd8739ae039);
/* eslint-disable no-underscore-dangle */ var $a41bd0b430e61869$export$2e2bcd8739ae039 = {
    on (events, handler, priority) {
        const self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (typeof handler !== "function") return self;
        const method = priority ? "unshift" : "push";
        events.split(" ").forEach((event)=>{
            if (!self.eventsListeners[event]) self.eventsListeners[event] = [];
            self.eventsListeners[event][method](handler);
        });
        return self;
    },
    once (events, handler, priority) {
        const self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (typeof handler !== "function") return self;
        function onceHandler(...args) {
            self.off(events, onceHandler);
            if (onceHandler.__emitterProxy) delete onceHandler.__emitterProxy;
            handler.apply(self, args);
        }
        onceHandler.__emitterProxy = handler;
        return self.on(events, onceHandler, priority);
    },
    onAny (handler, priority) {
        const self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (typeof handler !== "function") return self;
        const method = priority ? "unshift" : "push";
        if (self.eventsAnyListeners.indexOf(handler) < 0) self.eventsAnyListeners[method](handler);
        return self;
    },
    offAny (handler) {
        const self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (!self.eventsAnyListeners) return self;
        const index = self.eventsAnyListeners.indexOf(handler);
        if (index >= 0) self.eventsAnyListeners.splice(index, 1);
        return self;
    },
    off (events, handler) {
        const self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (!self.eventsListeners) return self;
        events.split(" ").forEach((event)=>{
            if (typeof handler === "undefined") self.eventsListeners[event] = [];
            else if (self.eventsListeners[event]) self.eventsListeners[event].forEach((eventHandler, index)=>{
                if (eventHandler === handler || eventHandler.__emitterProxy && eventHandler.__emitterProxy === handler) self.eventsListeners[event].splice(index, 1);
            });
        });
        return self;
    },
    emit (...args) {
        const self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (!self.eventsListeners) return self;
        let events;
        let data;
        let context;
        if (typeof args[0] === "string" || Array.isArray(args[0])) {
            events = args[0];
            data = args.slice(1, args.length);
            context = self;
        } else {
            events = args[0].events;
            data = args[0].data;
            context = args[0].context || self;
        }
        data.unshift(context);
        const eventsArray = Array.isArray(events) ? events : events.split(" ");
        eventsArray.forEach((event)=>{
            if (self.eventsAnyListeners && self.eventsAnyListeners.length) self.eventsAnyListeners.forEach((eventHandler)=>{
                eventHandler.apply(context, [
                    event,
                    ...data
                ]);
            });
            if (self.eventsListeners && self.eventsListeners[event]) self.eventsListeners[event].forEach((eventHandler)=>{
                eventHandler.apply(context, data);
            });
        });
        return self;
    }
};

});

parcelRequire.register("gAQxj", function(module, exports) {

$parcel$export(module.exports, "default", () => $c148c2c27a10eb97$export$2e2bcd8739ae039);

var $a316E = parcelRequire("a316E");

var $gdfy7 = parcelRequire("gdfy7");

var $ff7ak = parcelRequire("ff7ak");

var $1RSkr = parcelRequire("1RSkr");

var $keMFf = parcelRequire("keMFf");

var $34e5X = parcelRequire("34e5X");

var $iX3QZ = parcelRequire("iX3QZ");

var $3SoHi = parcelRequire("3SoHi");

var $cLKXh = parcelRequire("cLKXh");
var $c148c2c27a10eb97$export$2e2bcd8739ae039 = {
    updateSize: $a316E.default,
    updateSlides: $gdfy7.default,
    updateAutoHeight: $ff7ak.default,
    updateSlidesOffset: $1RSkr.default,
    updateSlidesProgress: $keMFf.default,
    updateProgress: $34e5X.default,
    updateSlidesClasses: $iX3QZ.default,
    updateActiveIndex: $3SoHi.default,
    updateClickedSlide: $cLKXh.default
};

});
parcelRequire.register("a316E", function(module, exports) {

$parcel$export(module.exports, "default", () => $750b0ae65bbce00c$export$2e2bcd8739ae039);
function $750b0ae65bbce00c$export$2e2bcd8739ae039() {
    const swiper = this;
    let width;
    let height;
    const $el = swiper.$el;
    if (typeof swiper.params.width !== "undefined" && swiper.params.width !== null) width = swiper.params.width;
    else width = $el[0].clientWidth;
    if (typeof swiper.params.height !== "undefined" && swiper.params.height !== null) height = swiper.params.height;
    else height = $el[0].clientHeight;
    if (width === 0 && swiper.isHorizontal() || height === 0 && swiper.isVertical()) return;
     // Subtract paddings
    width = width - parseInt($el.css("padding-left") || 0, 10) - parseInt($el.css("padding-right") || 0, 10);
    height = height - parseInt($el.css("padding-top") || 0, 10) - parseInt($el.css("padding-bottom") || 0, 10);
    if (Number.isNaN(width)) width = 0;
    if (Number.isNaN(height)) height = 0;
    Object.assign(swiper, {
        width: width,
        height: height,
        size: swiper.isHorizontal() ? width : height
    });
}

});

parcelRequire.register("gdfy7", function(module, exports) {

$parcel$export(module.exports, "default", () => $bcd9ec028724918f$export$2e2bcd8739ae039);

var $2y7Cr = parcelRequire("2y7Cr");
function $bcd9ec028724918f$export$2e2bcd8739ae039() {
    const swiper = this;
    function getDirectionLabel(property) {
        if (swiper.isHorizontal()) return property;
         // prettier-ignore
        return ({
            "width": "height",
            "margin-top": "margin-left",
            "margin-bottom ": "margin-right",
            "margin-left": "margin-top",
            "margin-right": "margin-bottom",
            "padding-left": "padding-top",
            "padding-right": "padding-bottom",
            "marginRight": "marginBottom"
        })[property];
    }
    function getDirectionPropertyValue(node, label) {
        return parseFloat(node.getPropertyValue(getDirectionLabel(label)) || 0);
    }
    const params = swiper.params;
    const { $wrapperEl: $wrapperEl, size: swiperSize, rtlTranslate: rtl, wrongRTL: wrongRTL } = swiper;
    const isVirtual = swiper.virtual && params.virtual.enabled;
    const previousSlidesLength = isVirtual ? swiper.virtual.slides.length : swiper.slides.length;
    const slides = $wrapperEl.children(`.${swiper.params.slideClass}`);
    const slidesLength = isVirtual ? swiper.virtual.slides.length : slides.length;
    let snapGrid = [];
    const slidesGrid = [];
    const slidesSizesGrid = [];
    let offsetBefore = params.slidesOffsetBefore;
    if (typeof offsetBefore === "function") offsetBefore = params.slidesOffsetBefore.call(swiper);
    let offsetAfter = params.slidesOffsetAfter;
    if (typeof offsetAfter === "function") offsetAfter = params.slidesOffsetAfter.call(swiper);
    const previousSnapGridLength = swiper.snapGrid.length;
    const previousSlidesGridLength = swiper.slidesGrid.length;
    let spaceBetween = params.spaceBetween;
    let slidePosition = -offsetBefore;
    let prevSlideSize = 0;
    let index = 0;
    if (typeof swiperSize === "undefined") return;
    if (typeof spaceBetween === "string" && spaceBetween.indexOf("%") >= 0) spaceBetween = parseFloat(spaceBetween.replace("%", "")) / 100 * swiperSize;
    swiper.virtualSize = -spaceBetween; // reset margins
    if (rtl) slides.css({
        marginLeft: "",
        marginBottom: "",
        marginTop: ""
    });
    else slides.css({
        marginRight: "",
        marginBottom: "",
        marginTop: ""
    }); // reset cssMode offsets
    if (params.centeredSlides && params.cssMode) {
        (0, $2y7Cr.setCSSProperty)(swiper.wrapperEl, "--swiper-centered-offset-before", "");
        (0, $2y7Cr.setCSSProperty)(swiper.wrapperEl, "--swiper-centered-offset-after", "");
    }
    const gridEnabled = params.grid && params.grid.rows > 1 && swiper.grid;
    if (gridEnabled) swiper.grid.initSlides(slidesLength);
     // Calc slides
    let slideSize;
    const shouldResetSlideSize = params.slidesPerView === "auto" && params.breakpoints && Object.keys(params.breakpoints).filter((key)=>{
        return typeof params.breakpoints[key].slidesPerView !== "undefined";
    }).length > 0;
    for(let i = 0; i < slidesLength; i += 1){
        slideSize = 0;
        const slide = slides.eq(i);
        if (gridEnabled) swiper.grid.updateSlide(i, slide, slidesLength, getDirectionLabel);
        if (slide.css("display") === "none") continue; // eslint-disable-line
        if (params.slidesPerView === "auto") {
            if (shouldResetSlideSize) slides[i].style[getDirectionLabel("width")] = ``;
            const slideStyles = getComputedStyle(slide[0]);
            const currentTransform = slide[0].style.transform;
            const currentWebKitTransform = slide[0].style.webkitTransform;
            if (currentTransform) slide[0].style.transform = "none";
            if (currentWebKitTransform) slide[0].style.webkitTransform = "none";
            if (params.roundLengths) slideSize = swiper.isHorizontal() ? slide.outerWidth(true) : slide.outerHeight(true);
            else {
                // eslint-disable-next-line
                const width = getDirectionPropertyValue(slideStyles, "width");
                const paddingLeft = getDirectionPropertyValue(slideStyles, "padding-left");
                const paddingRight = getDirectionPropertyValue(slideStyles, "padding-right");
                const marginLeft = getDirectionPropertyValue(slideStyles, "margin-left");
                const marginRight = getDirectionPropertyValue(slideStyles, "margin-right");
                const boxSizing = slideStyles.getPropertyValue("box-sizing");
                if (boxSizing && boxSizing === "border-box") slideSize = width + marginLeft + marginRight;
                else {
                    const { clientWidth: clientWidth, offsetWidth: offsetWidth } = slide[0];
                    slideSize = width + paddingLeft + paddingRight + marginLeft + marginRight + (offsetWidth - clientWidth);
                }
            }
            if (currentTransform) slide[0].style.transform = currentTransform;
            if (currentWebKitTransform) slide[0].style.webkitTransform = currentWebKitTransform;
            if (params.roundLengths) slideSize = Math.floor(slideSize);
        } else {
            slideSize = (swiperSize - (params.slidesPerView - 1) * spaceBetween) / params.slidesPerView;
            if (params.roundLengths) slideSize = Math.floor(slideSize);
            if (slides[i]) slides[i].style[getDirectionLabel("width")] = `${slideSize}px`;
        }
        if (slides[i]) slides[i].swiperSlideSize = slideSize;
        slidesSizesGrid.push(slideSize);
        if (params.centeredSlides) {
            slidePosition = slidePosition + slideSize / 2 + prevSlideSize / 2 + spaceBetween;
            if (prevSlideSize === 0 && i !== 0) slidePosition = slidePosition - swiperSize / 2 - spaceBetween;
            if (i === 0) slidePosition = slidePosition - swiperSize / 2 - spaceBetween;
            if (Math.abs(slidePosition) < 0.001) slidePosition = 0;
            if (params.roundLengths) slidePosition = Math.floor(slidePosition);
            if (index % params.slidesPerGroup === 0) snapGrid.push(slidePosition);
            slidesGrid.push(slidePosition);
        } else {
            if (params.roundLengths) slidePosition = Math.floor(slidePosition);
            if ((index - Math.min(swiper.params.slidesPerGroupSkip, index)) % swiper.params.slidesPerGroup === 0) snapGrid.push(slidePosition);
            slidesGrid.push(slidePosition);
            slidePosition = slidePosition + slideSize + spaceBetween;
        }
        swiper.virtualSize += slideSize + spaceBetween;
        prevSlideSize = slideSize;
        index += 1;
    }
    swiper.virtualSize = Math.max(swiper.virtualSize, swiperSize) + offsetAfter;
    if (rtl && wrongRTL && (params.effect === "slide" || params.effect === "coverflow")) $wrapperEl.css({
        width: `${swiper.virtualSize + params.spaceBetween}px`
    });
    if (params.setWrapperSize) $wrapperEl.css({
        [getDirectionLabel("width")]: `${swiper.virtualSize + params.spaceBetween}px`
    });
    if (gridEnabled) swiper.grid.updateWrapperSize(slideSize, snapGrid, getDirectionLabel);
     // Remove last grid elements depending on width
    if (!params.centeredSlides) {
        const newSlidesGrid = [];
        for(let i = 0; i < snapGrid.length; i += 1){
            let slidesGridItem = snapGrid[i];
            if (params.roundLengths) slidesGridItem = Math.floor(slidesGridItem);
            if (snapGrid[i] <= swiper.virtualSize - swiperSize) newSlidesGrid.push(slidesGridItem);
        }
        snapGrid = newSlidesGrid;
        if (Math.floor(swiper.virtualSize - swiperSize) - Math.floor(snapGrid[snapGrid.length - 1]) > 1) snapGrid.push(swiper.virtualSize - swiperSize);
    }
    if (snapGrid.length === 0) snapGrid = [
        0
    ];
    if (params.spaceBetween !== 0) {
        const key = swiper.isHorizontal() && rtl ? "marginLeft" : getDirectionLabel("marginRight");
        slides.filter((_, slideIndex)=>{
            if (!params.cssMode) return true;
            if (slideIndex === slides.length - 1) return false;
            return true;
        }).css({
            [key]: `${spaceBetween}px`
        });
    }
    if (params.centeredSlides && params.centeredSlidesBounds) {
        let allSlidesSize = 0;
        slidesSizesGrid.forEach((slideSizeValue)=>{
            allSlidesSize += slideSizeValue + (params.spaceBetween ? params.spaceBetween : 0);
        });
        allSlidesSize -= params.spaceBetween;
        const maxSnap = allSlidesSize - swiperSize;
        snapGrid = snapGrid.map((snap)=>{
            if (snap < 0) return -offsetBefore;
            if (snap > maxSnap) return maxSnap + offsetAfter;
            return snap;
        });
    }
    if (params.centerInsufficientSlides) {
        let allSlidesSize = 0;
        slidesSizesGrid.forEach((slideSizeValue)=>{
            allSlidesSize += slideSizeValue + (params.spaceBetween ? params.spaceBetween : 0);
        });
        allSlidesSize -= params.spaceBetween;
        if (allSlidesSize < swiperSize) {
            const allSlidesOffset = (swiperSize - allSlidesSize) / 2;
            snapGrid.forEach((snap, snapIndex)=>{
                snapGrid[snapIndex] = snap - allSlidesOffset;
            });
            slidesGrid.forEach((snap, snapIndex)=>{
                slidesGrid[snapIndex] = snap + allSlidesOffset;
            });
        }
    }
    Object.assign(swiper, {
        slides: slides,
        snapGrid: snapGrid,
        slidesGrid: slidesGrid,
        slidesSizesGrid: slidesSizesGrid
    });
    if (params.centeredSlides && params.cssMode && !params.centeredSlidesBounds) {
        (0, $2y7Cr.setCSSProperty)(swiper.wrapperEl, "--swiper-centered-offset-before", `${-snapGrid[0]}px`);
        (0, $2y7Cr.setCSSProperty)(swiper.wrapperEl, "--swiper-centered-offset-after", `${swiper.size / 2 - slidesSizesGrid[slidesSizesGrid.length - 1] / 2}px`);
        const addToSnapGrid = -swiper.snapGrid[0];
        const addToSlidesGrid = -swiper.slidesGrid[0];
        swiper.snapGrid = swiper.snapGrid.map((v)=>v + addToSnapGrid);
        swiper.slidesGrid = swiper.slidesGrid.map((v)=>v + addToSlidesGrid);
    }
    if (slidesLength !== previousSlidesLength) swiper.emit("slidesLengthChange");
    if (snapGrid.length !== previousSnapGridLength) {
        if (swiper.params.watchOverflow) swiper.checkOverflow();
        swiper.emit("snapGridLengthChange");
    }
    if (slidesGrid.length !== previousSlidesGridLength) swiper.emit("slidesGridLengthChange");
    if (params.watchSlidesProgress) swiper.updateSlidesOffset();
    if (!isVirtual && !params.cssMode && (params.effect === "slide" || params.effect === "fade")) {
        const backFaceHiddenClass = `${params.containerModifierClass}backface-hidden`;
        const hasClassBackfaceClassAdded = swiper.$el.hasClass(backFaceHiddenClass);
        if (slidesLength <= params.maxBackfaceHiddenSlides) {
            if (!hasClassBackfaceClassAdded) swiper.$el.addClass(backFaceHiddenClass);
        } else if (hasClassBackfaceClassAdded) swiper.$el.removeClass(backFaceHiddenClass);
    }
}

});

parcelRequire.register("ff7ak", function(module, exports) {

$parcel$export(module.exports, "default", () => $b18dd0af33e8e1ce$export$2e2bcd8739ae039);

var $92tgL = parcelRequire("92tgL");
function $b18dd0af33e8e1ce$export$2e2bcd8739ae039(speed) {
    const swiper = this;
    const activeSlides = [];
    const isVirtual = swiper.virtual && swiper.params.virtual.enabled;
    let newHeight = 0;
    let i;
    if (typeof speed === "number") swiper.setTransition(speed);
    else if (speed === true) swiper.setTransition(swiper.params.speed);
    const getSlideByIndex = (index)=>{
        if (isVirtual) return swiper.slides.filter((el)=>parseInt(el.getAttribute("data-swiper-slide-index"), 10) === index)[0];
        return swiper.slides.eq(index)[0];
    }; // Find slides currently in view
    if (swiper.params.slidesPerView !== "auto" && swiper.params.slidesPerView > 1) {
        if (swiper.params.centeredSlides) (swiper.visibleSlides || (0, $92tgL.default)([])).each((slide)=>{
            activeSlides.push(slide);
        });
        else for(i = 0; i < Math.ceil(swiper.params.slidesPerView); i += 1){
            const index = swiper.activeIndex + i;
            if (index > swiper.slides.length && !isVirtual) break;
            activeSlides.push(getSlideByIndex(index));
        }
    } else activeSlides.push(getSlideByIndex(swiper.activeIndex));
     // Find new height from highest slide in view
    for(i = 0; i < activeSlides.length; i += 1)if (typeof activeSlides[i] !== "undefined") {
        const height = activeSlides[i].offsetHeight;
        newHeight = height > newHeight ? height : newHeight;
    }
     // Update Height
    if (newHeight || newHeight === 0) swiper.$wrapperEl.css("height", `${newHeight}px`);
}

});

parcelRequire.register("1RSkr", function(module, exports) {

$parcel$export(module.exports, "default", () => $15c4e23ff8fbfb8d$export$2e2bcd8739ae039);
function $15c4e23ff8fbfb8d$export$2e2bcd8739ae039() {
    const swiper = this;
    const slides = swiper.slides;
    for(let i = 0; i < slides.length; i += 1)slides[i].swiperSlideOffset = swiper.isHorizontal() ? slides[i].offsetLeft : slides[i].offsetTop;
}

});

parcelRequire.register("keMFf", function(module, exports) {

$parcel$export(module.exports, "default", () => $ebbadd2a1ddf87dc$export$2e2bcd8739ae039);

var $92tgL = parcelRequire("92tgL");
function $ebbadd2a1ddf87dc$export$2e2bcd8739ae039(translate = this && this.translate || 0) {
    const swiper = this;
    const params = swiper.params;
    const { slides: slides, rtlTranslate: rtl, snapGrid: snapGrid } = swiper;
    if (slides.length === 0) return;
    if (typeof slides[0].swiperSlideOffset === "undefined") swiper.updateSlidesOffset();
    let offsetCenter = -translate;
    if (rtl) offsetCenter = translate; // Visible Slides
    slides.removeClass(params.slideVisibleClass);
    swiper.visibleSlidesIndexes = [];
    swiper.visibleSlides = [];
    for(let i = 0; i < slides.length; i += 1){
        const slide = slides[i];
        let slideOffset = slide.swiperSlideOffset;
        if (params.cssMode && params.centeredSlides) slideOffset -= slides[0].swiperSlideOffset;
        const slideProgress = (offsetCenter + (params.centeredSlides ? swiper.minTranslate() : 0) - slideOffset) / (slide.swiperSlideSize + params.spaceBetween);
        const originalSlideProgress = (offsetCenter - snapGrid[0] + (params.centeredSlides ? swiper.minTranslate() : 0) - slideOffset) / (slide.swiperSlideSize + params.spaceBetween);
        const slideBefore = -(offsetCenter - slideOffset);
        const slideAfter = slideBefore + swiper.slidesSizesGrid[i];
        const isVisible = slideBefore >= 0 && slideBefore < swiper.size - 1 || slideAfter > 1 && slideAfter <= swiper.size || slideBefore <= 0 && slideAfter >= swiper.size;
        if (isVisible) {
            swiper.visibleSlides.push(slide);
            swiper.visibleSlidesIndexes.push(i);
            slides.eq(i).addClass(params.slideVisibleClass);
        }
        slide.progress = rtl ? -slideProgress : slideProgress;
        slide.originalProgress = rtl ? -originalSlideProgress : originalSlideProgress;
    }
    swiper.visibleSlides = (0, $92tgL.default)(swiper.visibleSlides);
}

});

parcelRequire.register("34e5X", function(module, exports) {

$parcel$export(module.exports, "default", () => $23bcadd58bb82863$export$2e2bcd8739ae039);
function $23bcadd58bb82863$export$2e2bcd8739ae039(translate) {
    const swiper = this;
    if (typeof translate === "undefined") {
        const multiplier = swiper.rtlTranslate ? -1 : 1; // eslint-disable-next-line
        translate = swiper && swiper.translate && swiper.translate * multiplier || 0;
    }
    const params = swiper.params;
    const translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
    let { progress: progress, isBeginning: isBeginning, isEnd: isEnd } = swiper;
    const wasBeginning = isBeginning;
    const wasEnd = isEnd;
    if (translatesDiff === 0) {
        progress = 0;
        isBeginning = true;
        isEnd = true;
    } else {
        progress = (translate - swiper.minTranslate()) / translatesDiff;
        isBeginning = progress <= 0;
        isEnd = progress >= 1;
    }
    Object.assign(swiper, {
        progress: progress,
        isBeginning: isBeginning,
        isEnd: isEnd
    });
    if (params.watchSlidesProgress || params.centeredSlides && params.autoHeight) swiper.updateSlidesProgress(translate);
    if (isBeginning && !wasBeginning) swiper.emit("reachBeginning toEdge");
    if (isEnd && !wasEnd) swiper.emit("reachEnd toEdge");
    if (wasBeginning && !isBeginning || wasEnd && !isEnd) swiper.emit("fromEdge");
    swiper.emit("progress", progress);
}

});

parcelRequire.register("iX3QZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $dcc0b9f2de6804dd$export$2e2bcd8739ae039);
function $dcc0b9f2de6804dd$export$2e2bcd8739ae039() {
    const swiper = this;
    const { slides: slides, params: params, $wrapperEl: $wrapperEl, activeIndex: activeIndex, realIndex: realIndex } = swiper;
    const isVirtual = swiper.virtual && params.virtual.enabled;
    slides.removeClass(`${params.slideActiveClass} ${params.slideNextClass} ${params.slidePrevClass} ${params.slideDuplicateActiveClass} ${params.slideDuplicateNextClass} ${params.slideDuplicatePrevClass}`);
    let activeSlide;
    if (isVirtual) activeSlide = swiper.$wrapperEl.find(`.${params.slideClass}[data-swiper-slide-index="${activeIndex}"]`);
    else activeSlide = slides.eq(activeIndex);
     // Active classes
    activeSlide.addClass(params.slideActiveClass);
    if (params.loop) {
        // Duplicate to all looped slides
        if (activeSlide.hasClass(params.slideDuplicateClass)) $wrapperEl.children(`.${params.slideClass}:not(.${params.slideDuplicateClass})[data-swiper-slide-index="${realIndex}"]`).addClass(params.slideDuplicateActiveClass);
        else $wrapperEl.children(`.${params.slideClass}.${params.slideDuplicateClass}[data-swiper-slide-index="${realIndex}"]`).addClass(params.slideDuplicateActiveClass);
    } // Next Slide
    let nextSlide = activeSlide.nextAll(`.${params.slideClass}`).eq(0).addClass(params.slideNextClass);
    if (params.loop && nextSlide.length === 0) {
        nextSlide = slides.eq(0);
        nextSlide.addClass(params.slideNextClass);
    } // Prev Slide
    let prevSlide = activeSlide.prevAll(`.${params.slideClass}`).eq(0).addClass(params.slidePrevClass);
    if (params.loop && prevSlide.length === 0) {
        prevSlide = slides.eq(-1);
        prevSlide.addClass(params.slidePrevClass);
    }
    if (params.loop) {
        // Duplicate to all looped slides
        if (nextSlide.hasClass(params.slideDuplicateClass)) $wrapperEl.children(`.${params.slideClass}:not(.${params.slideDuplicateClass})[data-swiper-slide-index="${nextSlide.attr("data-swiper-slide-index")}"]`).addClass(params.slideDuplicateNextClass);
        else $wrapperEl.children(`.${params.slideClass}.${params.slideDuplicateClass}[data-swiper-slide-index="${nextSlide.attr("data-swiper-slide-index")}"]`).addClass(params.slideDuplicateNextClass);
        if (prevSlide.hasClass(params.slideDuplicateClass)) $wrapperEl.children(`.${params.slideClass}:not(.${params.slideDuplicateClass})[data-swiper-slide-index="${prevSlide.attr("data-swiper-slide-index")}"]`).addClass(params.slideDuplicatePrevClass);
        else $wrapperEl.children(`.${params.slideClass}.${params.slideDuplicateClass}[data-swiper-slide-index="${prevSlide.attr("data-swiper-slide-index")}"]`).addClass(params.slideDuplicatePrevClass);
    }
    swiper.emitSlidesClasses();
}

});

parcelRequire.register("3SoHi", function(module, exports) {

$parcel$export(module.exports, "default", () => $2d29929e04754698$export$2e2bcd8739ae039);
function $2d29929e04754698$export$2e2bcd8739ae039(newActiveIndex) {
    const swiper = this;
    const translate = swiper.rtlTranslate ? swiper.translate : -swiper.translate;
    const { slidesGrid: slidesGrid, snapGrid: snapGrid, params: params, activeIndex: previousIndex, realIndex: previousRealIndex, snapIndex: previousSnapIndex } = swiper;
    let activeIndex = newActiveIndex;
    let snapIndex;
    if (typeof activeIndex === "undefined") {
        for(let i = 0; i < slidesGrid.length; i += 1){
            if (typeof slidesGrid[i + 1] !== "undefined") {
                if (translate >= slidesGrid[i] && translate < slidesGrid[i + 1] - (slidesGrid[i + 1] - slidesGrid[i]) / 2) activeIndex = i;
                else if (translate >= slidesGrid[i] && translate < slidesGrid[i + 1]) activeIndex = i + 1;
            } else if (translate >= slidesGrid[i]) activeIndex = i;
        } // Normalize slideIndex
        if (params.normalizeSlideIndex) {
            if (activeIndex < 0 || typeof activeIndex === "undefined") activeIndex = 0;
        }
    }
    if (snapGrid.indexOf(translate) >= 0) snapIndex = snapGrid.indexOf(translate);
    else {
        const skip = Math.min(params.slidesPerGroupSkip, activeIndex);
        snapIndex = skip + Math.floor((activeIndex - skip) / params.slidesPerGroup);
    }
    if (snapIndex >= snapGrid.length) snapIndex = snapGrid.length - 1;
    if (activeIndex === previousIndex) {
        if (snapIndex !== previousSnapIndex) {
            swiper.snapIndex = snapIndex;
            swiper.emit("snapIndexChange");
        }
        return;
    } // Get real index
    const realIndex = parseInt(swiper.slides.eq(activeIndex).attr("data-swiper-slide-index") || activeIndex, 10);
    Object.assign(swiper, {
        snapIndex: snapIndex,
        realIndex: realIndex,
        previousIndex: previousIndex,
        activeIndex: activeIndex
    });
    swiper.emit("activeIndexChange");
    swiper.emit("snapIndexChange");
    if (previousRealIndex !== realIndex) swiper.emit("realIndexChange");
    if (swiper.initialized || swiper.params.runCallbacksOnInit) swiper.emit("slideChange");
}

});

parcelRequire.register("cLKXh", function(module, exports) {

$parcel$export(module.exports, "default", () => $94be4c259f3f2a02$export$2e2bcd8739ae039);

var $92tgL = parcelRequire("92tgL");
function $94be4c259f3f2a02$export$2e2bcd8739ae039(e) {
    const swiper = this;
    const params = swiper.params;
    const slide = (0, $92tgL.default)(e).closest(`.${params.slideClass}`)[0];
    let slideFound = false;
    let slideIndex;
    if (slide) {
        for(let i = 0; i < swiper.slides.length; i += 1)if (swiper.slides[i] === slide) {
            slideFound = true;
            slideIndex = i;
            break;
        }
    }
    if (slide && slideFound) {
        swiper.clickedSlide = slide;
        if (swiper.virtual && swiper.params.virtual.enabled) swiper.clickedIndex = parseInt((0, $92tgL.default)(slide).attr("data-swiper-slide-index"), 10);
        else swiper.clickedIndex = slideIndex;
    } else {
        swiper.clickedSlide = undefined;
        swiper.clickedIndex = undefined;
        return;
    }
    if (params.slideToClickedSlide && swiper.clickedIndex !== undefined && swiper.clickedIndex !== swiper.activeIndex) swiper.slideToClickedSlide();
}

});


parcelRequire.register("3QIGr", function(module, exports) {

$parcel$export(module.exports, "default", () => $2cd8e3a6ed2d1311$export$2e2bcd8739ae039);

var $fi7H0 = parcelRequire("fi7H0");

var $x4HBO = parcelRequire("x4HBO");

var $hpJuw = parcelRequire("hpJuw");

var $3lcH3 = parcelRequire("3lcH3");

var $4hJs8 = parcelRequire("4hJs8");
var $2cd8e3a6ed2d1311$export$2e2bcd8739ae039 = {
    getTranslate: $fi7H0.default,
    setTranslate: $x4HBO.default,
    minTranslate: $hpJuw.default,
    maxTranslate: $3lcH3.default,
    translateTo: $4hJs8.default
};

});
parcelRequire.register("fi7H0", function(module, exports) {

$parcel$export(module.exports, "default", () => $b21e81080557acef$export$2e2bcd8739ae039);

var $2y7Cr = parcelRequire("2y7Cr");
function $b21e81080557acef$export$2e2bcd8739ae039(axis = this.isHorizontal() ? "x" : "y") {
    const swiper = this;
    const { params: params, rtlTranslate: rtl, translate: translate, $wrapperEl: $wrapperEl } = swiper;
    if (params.virtualTranslate) return rtl ? -translate : translate;
    if (params.cssMode) return translate;
    let currentTranslate = (0, $2y7Cr.getTranslate)($wrapperEl[0], axis);
    if (rtl) currentTranslate = -currentTranslate;
    return currentTranslate || 0;
}

});

parcelRequire.register("x4HBO", function(module, exports) {

$parcel$export(module.exports, "default", () => $0636baf97af6f21b$export$2e2bcd8739ae039);
function $0636baf97af6f21b$export$2e2bcd8739ae039(translate, byController) {
    const swiper = this;
    const { rtlTranslate: rtl, params: params, $wrapperEl: $wrapperEl, wrapperEl: wrapperEl, progress: progress } = swiper;
    let x = 0;
    let y = 0;
    const z = 0;
    if (swiper.isHorizontal()) x = rtl ? -translate : translate;
    else y = translate;
    if (params.roundLengths) {
        x = Math.floor(x);
        y = Math.floor(y);
    }
    if (params.cssMode) wrapperEl[swiper.isHorizontal() ? "scrollLeft" : "scrollTop"] = swiper.isHorizontal() ? -x : -y;
    else if (!params.virtualTranslate) $wrapperEl.transform(`translate3d(${x}px, ${y}px, ${z}px)`);
    swiper.previousTranslate = swiper.translate;
    swiper.translate = swiper.isHorizontal() ? x : y; // Check if we need to update progress
    let newProgress;
    const translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
    if (translatesDiff === 0) newProgress = 0;
    else newProgress = (translate - swiper.minTranslate()) / translatesDiff;
    if (newProgress !== progress) swiper.updateProgress(translate);
    swiper.emit("setTranslate", swiper.translate, byController);
}

});

parcelRequire.register("hpJuw", function(module, exports) {

$parcel$export(module.exports, "default", () => $cad80f12f3af2662$export$2e2bcd8739ae039);
function $cad80f12f3af2662$export$2e2bcd8739ae039() {
    return -this.snapGrid[0];
}

});

parcelRequire.register("3lcH3", function(module, exports) {

$parcel$export(module.exports, "default", () => $26ed2de5fdd74c1d$export$2e2bcd8739ae039);
function $26ed2de5fdd74c1d$export$2e2bcd8739ae039() {
    return -this.snapGrid[this.snapGrid.length - 1];
}

});

parcelRequire.register("4hJs8", function(module, exports) {

$parcel$export(module.exports, "default", () => $31ec01ed9203b1ae$export$2e2bcd8739ae039);

var $2y7Cr = parcelRequire("2y7Cr");
function $31ec01ed9203b1ae$export$2e2bcd8739ae039(translate = 0, speed = this.params.speed, runCallbacks = true, translateBounds = true, internal) {
    const swiper = this;
    const { params: params, wrapperEl: wrapperEl } = swiper;
    if (swiper.animating && params.preventInteractionOnTransition) return false;
    const minTranslate = swiper.minTranslate();
    const maxTranslate = swiper.maxTranslate();
    let newTranslate;
    if (translateBounds && translate > minTranslate) newTranslate = minTranslate;
    else if (translateBounds && translate < maxTranslate) newTranslate = maxTranslate;
    else newTranslate = translate; // Update progress
    swiper.updateProgress(newTranslate);
    if (params.cssMode) {
        const isH = swiper.isHorizontal();
        if (speed === 0) wrapperEl[isH ? "scrollLeft" : "scrollTop"] = -newTranslate;
        else {
            if (!swiper.support.smoothScroll) {
                (0, $2y7Cr.animateCSSModeScroll)({
                    swiper: swiper,
                    targetPosition: -newTranslate,
                    side: isH ? "left" : "top"
                });
                return true;
            }
            wrapperEl.scrollTo({
                [isH ? "left" : "top"]: -newTranslate,
                behavior: "smooth"
            });
        }
        return true;
    }
    if (speed === 0) {
        swiper.setTransition(0);
        swiper.setTranslate(newTranslate);
        if (runCallbacks) {
            swiper.emit("beforeTransitionStart", speed, internal);
            swiper.emit("transitionEnd");
        }
    } else {
        swiper.setTransition(speed);
        swiper.setTranslate(newTranslate);
        if (runCallbacks) {
            swiper.emit("beforeTransitionStart", speed, internal);
            swiper.emit("transitionStart");
        }
        if (!swiper.animating) {
            swiper.animating = true;
            if (!swiper.onTranslateToWrapperTransitionEnd) swiper.onTranslateToWrapperTransitionEnd = function transitionEnd(e) {
                if (!swiper || swiper.destroyed) return;
                if (e.target !== this) return;
                swiper.$wrapperEl[0].removeEventListener("transitionend", swiper.onTranslateToWrapperTransitionEnd);
                swiper.$wrapperEl[0].removeEventListener("webkitTransitionEnd", swiper.onTranslateToWrapperTransitionEnd);
                swiper.onTranslateToWrapperTransitionEnd = null;
                delete swiper.onTranslateToWrapperTransitionEnd;
                if (runCallbacks) swiper.emit("transitionEnd");
            };
            swiper.$wrapperEl[0].addEventListener("transitionend", swiper.onTranslateToWrapperTransitionEnd);
            swiper.$wrapperEl[0].addEventListener("webkitTransitionEnd", swiper.onTranslateToWrapperTransitionEnd);
        }
    }
    return true;
}

});


parcelRequire.register("cOPtx", function(module, exports) {

$parcel$export(module.exports, "default", () => $9552158222bf3f45$export$2e2bcd8739ae039);

var $8YS0i = parcelRequire("8YS0i");

var $awIxB = parcelRequire("awIxB");

var $2XjeQ = parcelRequire("2XjeQ");
var $9552158222bf3f45$export$2e2bcd8739ae039 = {
    setTransition: $8YS0i.default,
    transitionStart: $awIxB.default,
    transitionEnd: $2XjeQ.default
};

});
parcelRequire.register("8YS0i", function(module, exports) {

$parcel$export(module.exports, "default", () => $689dd159eb97c694$export$2e2bcd8739ae039);
function $689dd159eb97c694$export$2e2bcd8739ae039(duration, byController) {
    const swiper = this;
    if (!swiper.params.cssMode) swiper.$wrapperEl.transition(duration);
    swiper.emit("setTransition", duration, byController);
}

});

parcelRequire.register("awIxB", function(module, exports) {

$parcel$export(module.exports, "default", () => $7a9f716f326a538e$export$2e2bcd8739ae039);

var $irzL7 = parcelRequire("irzL7");
function $7a9f716f326a538e$export$2e2bcd8739ae039(runCallbacks = true, direction) {
    const swiper = this;
    const { params: params } = swiper;
    if (params.cssMode) return;
    if (params.autoHeight) swiper.updateAutoHeight();
    (0, $irzL7.default)({
        swiper: swiper,
        runCallbacks: runCallbacks,
        direction: direction,
        step: "Start"
    });
}

});
parcelRequire.register("irzL7", function(module, exports) {

$parcel$export(module.exports, "default", () => $d6d67ca0051f8cb7$export$2e2bcd8739ae039);
function $d6d67ca0051f8cb7$export$2e2bcd8739ae039({ swiper: swiper, runCallbacks: runCallbacks, direction: direction, step: step }) {
    const { activeIndex: activeIndex, previousIndex: previousIndex } = swiper;
    let dir = direction;
    if (!dir) {
        if (activeIndex > previousIndex) dir = "next";
        else if (activeIndex < previousIndex) dir = "prev";
        else dir = "reset";
    }
    swiper.emit(`transition${step}`);
    if (runCallbacks && activeIndex !== previousIndex) {
        if (dir === "reset") {
            swiper.emit(`slideResetTransition${step}`);
            return;
        }
        swiper.emit(`slideChangeTransition${step}`);
        if (dir === "next") swiper.emit(`slideNextTransition${step}`);
        else swiper.emit(`slidePrevTransition${step}`);
    }
}

});


parcelRequire.register("2XjeQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $227003cb50c32050$export$2e2bcd8739ae039);

var $irzL7 = parcelRequire("irzL7");
function $227003cb50c32050$export$2e2bcd8739ae039(runCallbacks = true, direction) {
    const swiper = this;
    const { params: params } = swiper;
    swiper.animating = false;
    if (params.cssMode) return;
    swiper.setTransition(0);
    (0, $irzL7.default)({
        swiper: swiper,
        runCallbacks: runCallbacks,
        direction: direction,
        step: "End"
    });
}

});


parcelRequire.register("73AvW", function(module, exports) {

$parcel$export(module.exports, "default", () => $52352328fd0924bb$export$2e2bcd8739ae039);

var $iwGXP = parcelRequire("iwGXP");

var $8U1x0 = parcelRequire("8U1x0");

var $c1PWR = parcelRequire("c1PWR");

var $ba8MR = parcelRequire("ba8MR");

var $hLpkz = parcelRequire("hLpkz");

var $91kPl = parcelRequire("91kPl");

var $kEcDq = parcelRequire("kEcDq");
var $52352328fd0924bb$export$2e2bcd8739ae039 = {
    slideTo: $iwGXP.default,
    slideToLoop: $8U1x0.default,
    slideNext: $c1PWR.default,
    slidePrev: $ba8MR.default,
    slideReset: $hLpkz.default,
    slideToClosest: $91kPl.default,
    slideToClickedSlide: $kEcDq.default
};

});
parcelRequire.register("iwGXP", function(module, exports) {

$parcel$export(module.exports, "default", () => $d7cc8ae1cc6df8d1$export$2e2bcd8739ae039);

var $2y7Cr = parcelRequire("2y7Cr");
function $d7cc8ae1cc6df8d1$export$2e2bcd8739ae039(index = 0, speed = this.params.speed, runCallbacks = true, internal, initial) {
    if (typeof index !== "number" && typeof index !== "string") throw new Error(`The 'index' argument cannot have type other than 'number' or 'string'. [${typeof index}] given.`);
    if (typeof index === "string") {
        /**
     * The `index` argument converted from `string` to `number`.
     * @type {number}
     */ const indexAsNumber = parseInt(index, 10);
        /**
     * Determines whether the `index` argument is a valid `number`
     * after being converted from the `string` type.
     * @type {boolean}
     */ const isValidNumber = isFinite(indexAsNumber);
        if (!isValidNumber) throw new Error(`The passed-in 'index' (string) couldn't be converted to 'number'. [${index}] given.`);
         // Knowing that the converted `index` is a valid number,
        // we can update the original argument's value.
        index = indexAsNumber;
    }
    const swiper = this;
    let slideIndex = index;
    if (slideIndex < 0) slideIndex = 0;
    const { params: params, snapGrid: snapGrid, slidesGrid: slidesGrid, previousIndex: previousIndex, activeIndex: activeIndex, rtlTranslate: rtl, wrapperEl: wrapperEl, enabled: enabled } = swiper;
    if (swiper.animating && params.preventInteractionOnTransition || !enabled && !internal && !initial) return false;
    const skip = Math.min(swiper.params.slidesPerGroupSkip, slideIndex);
    let snapIndex = skip + Math.floor((slideIndex - skip) / swiper.params.slidesPerGroup);
    if (snapIndex >= snapGrid.length) snapIndex = snapGrid.length - 1;
    const translate = -snapGrid[snapIndex]; // Normalize slideIndex
    if (params.normalizeSlideIndex) for(let i = 0; i < slidesGrid.length; i += 1){
        const normalizedTranslate = -Math.floor(translate * 100);
        const normalizedGrid = Math.floor(slidesGrid[i] * 100);
        const normalizedGridNext = Math.floor(slidesGrid[i + 1] * 100);
        if (typeof slidesGrid[i + 1] !== "undefined") {
            if (normalizedTranslate >= normalizedGrid && normalizedTranslate < normalizedGridNext - (normalizedGridNext - normalizedGrid) / 2) slideIndex = i;
            else if (normalizedTranslate >= normalizedGrid && normalizedTranslate < normalizedGridNext) slideIndex = i + 1;
        } else if (normalizedTranslate >= normalizedGrid) slideIndex = i;
    }
     // Directions locks
    if (swiper.initialized && slideIndex !== activeIndex) {
        if (!swiper.allowSlideNext && translate < swiper.translate && translate < swiper.minTranslate()) return false;
        if (!swiper.allowSlidePrev && translate > swiper.translate && translate > swiper.maxTranslate()) {
            if ((activeIndex || 0) !== slideIndex) return false;
        }
    }
    if (slideIndex !== (previousIndex || 0) && runCallbacks) swiper.emit("beforeSlideChangeStart");
     // Update progress
    swiper.updateProgress(translate);
    let direction;
    if (slideIndex > activeIndex) direction = "next";
    else if (slideIndex < activeIndex) direction = "prev";
    else direction = "reset"; // Update Index
    if (rtl && -translate === swiper.translate || !rtl && translate === swiper.translate) {
        swiper.updateActiveIndex(slideIndex); // Update Height
        if (params.autoHeight) swiper.updateAutoHeight();
        swiper.updateSlidesClasses();
        if (params.effect !== "slide") swiper.setTranslate(translate);
        if (direction !== "reset") {
            swiper.transitionStart(runCallbacks, direction);
            swiper.transitionEnd(runCallbacks, direction);
        }
        return false;
    }
    if (params.cssMode) {
        const isH = swiper.isHorizontal();
        const t = rtl ? translate : -translate;
        if (speed === 0) {
            const isVirtual = swiper.virtual && swiper.params.virtual.enabled;
            if (isVirtual) {
                swiper.wrapperEl.style.scrollSnapType = "none";
                swiper._immediateVirtual = true;
            }
            wrapperEl[isH ? "scrollLeft" : "scrollTop"] = t;
            if (isVirtual) requestAnimationFrame(()=>{
                swiper.wrapperEl.style.scrollSnapType = "";
                swiper._swiperImmediateVirtual = false;
            });
        } else {
            if (!swiper.support.smoothScroll) {
                (0, $2y7Cr.animateCSSModeScroll)({
                    swiper: swiper,
                    targetPosition: t,
                    side: isH ? "left" : "top"
                });
                return true;
            }
            wrapperEl.scrollTo({
                [isH ? "left" : "top"]: t,
                behavior: "smooth"
            });
        }
        return true;
    }
    swiper.setTransition(speed);
    swiper.setTranslate(translate);
    swiper.updateActiveIndex(slideIndex);
    swiper.updateSlidesClasses();
    swiper.emit("beforeTransitionStart", speed, internal);
    swiper.transitionStart(runCallbacks, direction);
    if (speed === 0) swiper.transitionEnd(runCallbacks, direction);
    else if (!swiper.animating) {
        swiper.animating = true;
        if (!swiper.onSlideToWrapperTransitionEnd) swiper.onSlideToWrapperTransitionEnd = function transitionEnd(e) {
            if (!swiper || swiper.destroyed) return;
            if (e.target !== this) return;
            swiper.$wrapperEl[0].removeEventListener("transitionend", swiper.onSlideToWrapperTransitionEnd);
            swiper.$wrapperEl[0].removeEventListener("webkitTransitionEnd", swiper.onSlideToWrapperTransitionEnd);
            swiper.onSlideToWrapperTransitionEnd = null;
            delete swiper.onSlideToWrapperTransitionEnd;
            swiper.transitionEnd(runCallbacks, direction);
        };
        swiper.$wrapperEl[0].addEventListener("transitionend", swiper.onSlideToWrapperTransitionEnd);
        swiper.$wrapperEl[0].addEventListener("webkitTransitionEnd", swiper.onSlideToWrapperTransitionEnd);
    }
    return true;
}

});

parcelRequire.register("8U1x0", function(module, exports) {

$parcel$export(module.exports, "default", () => $67b4bdc30ac1762e$export$2e2bcd8739ae039);
function $67b4bdc30ac1762e$export$2e2bcd8739ae039(index = 0, speed = this.params.speed, runCallbacks = true, internal) {
    if (typeof index === "string") {
        /**
     * The `index` argument converted from `string` to `number`.
     * @type {number}
     */ const indexAsNumber = parseInt(index, 10);
        /**
     * Determines whether the `index` argument is a valid `number`
     * after being converted from the `string` type.
     * @type {boolean}
     */ const isValidNumber = isFinite(indexAsNumber);
        if (!isValidNumber) throw new Error(`The passed-in 'index' (string) couldn't be converted to 'number'. [${index}] given.`);
         // Knowing that the converted `index` is a valid number,
        // we can update the original argument's value.
        index = indexAsNumber;
    }
    const swiper = this;
    let newIndex = index;
    if (swiper.params.loop) newIndex += swiper.loopedSlides;
    return swiper.slideTo(newIndex, speed, runCallbacks, internal);
}

});

parcelRequire.register("c1PWR", function(module, exports) {

$parcel$export(module.exports, "default", () => $8c1ddfe8100b0bd1$export$2e2bcd8739ae039);
/* eslint no-unused-vars: "off" */ function $8c1ddfe8100b0bd1$export$2e2bcd8739ae039(speed = this.params.speed, runCallbacks = true, internal) {
    const swiper = this;
    const { animating: animating, enabled: enabled, params: params } = swiper;
    if (!enabled) return swiper;
    let perGroup = params.slidesPerGroup;
    if (params.slidesPerView === "auto" && params.slidesPerGroup === 1 && params.slidesPerGroupAuto) perGroup = Math.max(swiper.slidesPerViewDynamic("current", true), 1);
    const increment = swiper.activeIndex < params.slidesPerGroupSkip ? 1 : perGroup;
    if (params.loop) {
        if (animating && params.loopPreventsSlide) return false;
        swiper.loopFix(); // eslint-disable-next-line
        swiper._clientLeft = swiper.$wrapperEl[0].clientLeft;
    }
    if (params.rewind && swiper.isEnd) return swiper.slideTo(0, speed, runCallbacks, internal);
    return swiper.slideTo(swiper.activeIndex + increment, speed, runCallbacks, internal);
}

});

parcelRequire.register("ba8MR", function(module, exports) {

$parcel$export(module.exports, "default", () => $820771d5772ba078$export$2e2bcd8739ae039);
/* eslint no-unused-vars: "off" */ function $820771d5772ba078$export$2e2bcd8739ae039(speed = this.params.speed, runCallbacks = true, internal) {
    const swiper = this;
    const { params: params, animating: animating, snapGrid: snapGrid, slidesGrid: slidesGrid, rtlTranslate: rtlTranslate, enabled: enabled } = swiper;
    if (!enabled) return swiper;
    if (params.loop) {
        if (animating && params.loopPreventsSlide) return false;
        swiper.loopFix(); // eslint-disable-next-line
        swiper._clientLeft = swiper.$wrapperEl[0].clientLeft;
    }
    const translate = rtlTranslate ? swiper.translate : -swiper.translate;
    function normalize(val) {
        if (val < 0) return -Math.floor(Math.abs(val));
        return Math.floor(val);
    }
    const normalizedTranslate = normalize(translate);
    const normalizedSnapGrid = snapGrid.map((val)=>normalize(val));
    let prevSnap = snapGrid[normalizedSnapGrid.indexOf(normalizedTranslate) - 1];
    if (typeof prevSnap === "undefined" && params.cssMode) {
        let prevSnapIndex;
        snapGrid.forEach((snap, snapIndex)=>{
            if (normalizedTranslate >= snap) // prevSnap = snap;
            prevSnapIndex = snapIndex;
        });
        if (typeof prevSnapIndex !== "undefined") prevSnap = snapGrid[prevSnapIndex > 0 ? prevSnapIndex - 1 : prevSnapIndex];
    }
    let prevIndex = 0;
    if (typeof prevSnap !== "undefined") {
        prevIndex = slidesGrid.indexOf(prevSnap);
        if (prevIndex < 0) prevIndex = swiper.activeIndex - 1;
        if (params.slidesPerView === "auto" && params.slidesPerGroup === 1 && params.slidesPerGroupAuto) {
            prevIndex = prevIndex - swiper.slidesPerViewDynamic("previous", true) + 1;
            prevIndex = Math.max(prevIndex, 0);
        }
    }
    if (params.rewind && swiper.isBeginning) {
        const lastIndex = swiper.params.virtual && swiper.params.virtual.enabled && swiper.virtual ? swiper.virtual.slides.length - 1 : swiper.slides.length - 1;
        return swiper.slideTo(lastIndex, speed, runCallbacks, internal);
    }
    return swiper.slideTo(prevIndex, speed, runCallbacks, internal);
}

});

parcelRequire.register("hLpkz", function(module, exports) {

$parcel$export(module.exports, "default", () => $ceea7998bb8b1c2b$export$2e2bcd8739ae039);
/* eslint no-unused-vars: "off" */ function $ceea7998bb8b1c2b$export$2e2bcd8739ae039(speed = this.params.speed, runCallbacks = true, internal) {
    const swiper = this;
    return swiper.slideTo(swiper.activeIndex, speed, runCallbacks, internal);
}

});

parcelRequire.register("91kPl", function(module, exports) {

$parcel$export(module.exports, "default", () => $69145cded8496435$export$2e2bcd8739ae039);
/* eslint no-unused-vars: "off" */ function $69145cded8496435$export$2e2bcd8739ae039(speed = this.params.speed, runCallbacks = true, internal, threshold = 0.5) {
    const swiper = this;
    let index = swiper.activeIndex;
    const skip = Math.min(swiper.params.slidesPerGroupSkip, index);
    const snapIndex = skip + Math.floor((index - skip) / swiper.params.slidesPerGroup);
    const translate = swiper.rtlTranslate ? swiper.translate : -swiper.translate;
    if (translate >= swiper.snapGrid[snapIndex]) {
        // The current translate is on or after the current snap index, so the choice
        // is between the current index and the one after it.
        const currentSnap = swiper.snapGrid[snapIndex];
        const nextSnap = swiper.snapGrid[snapIndex + 1];
        if (translate - currentSnap > (nextSnap - currentSnap) * threshold) index += swiper.params.slidesPerGroup;
    } else {
        // The current translate is before the current snap index, so the choice
        // is between the current index and the one before it.
        const prevSnap = swiper.snapGrid[snapIndex - 1];
        const currentSnap = swiper.snapGrid[snapIndex];
        if (translate - prevSnap <= (currentSnap - prevSnap) * threshold) index -= swiper.params.slidesPerGroup;
    }
    index = Math.max(index, 0);
    index = Math.min(index, swiper.slidesGrid.length - 1);
    return swiper.slideTo(index, speed, runCallbacks, internal);
}

});

parcelRequire.register("kEcDq", function(module, exports) {

$parcel$export(module.exports, "default", () => $f0815818693cfc75$export$2e2bcd8739ae039);

var $92tgL = parcelRequire("92tgL");

var $2y7Cr = parcelRequire("2y7Cr");
function $f0815818693cfc75$export$2e2bcd8739ae039() {
    const swiper = this;
    const { params: params, $wrapperEl: $wrapperEl } = swiper;
    const slidesPerView = params.slidesPerView === "auto" ? swiper.slidesPerViewDynamic() : params.slidesPerView;
    let slideToIndex = swiper.clickedIndex;
    let realIndex;
    if (params.loop) {
        if (swiper.animating) return;
        realIndex = parseInt((0, $92tgL.default)(swiper.clickedSlide).attr("data-swiper-slide-index"), 10);
        if (params.centeredSlides) {
            if (slideToIndex < swiper.loopedSlides - slidesPerView / 2 || slideToIndex > swiper.slides.length - swiper.loopedSlides + slidesPerView / 2) {
                swiper.loopFix();
                slideToIndex = $wrapperEl.children(`.${params.slideClass}[data-swiper-slide-index="${realIndex}"]:not(.${params.slideDuplicateClass})`).eq(0).index();
                (0, $2y7Cr.nextTick)(()=>{
                    swiper.slideTo(slideToIndex);
                });
            } else swiper.slideTo(slideToIndex);
        } else if (slideToIndex > swiper.slides.length - slidesPerView) {
            swiper.loopFix();
            slideToIndex = $wrapperEl.children(`.${params.slideClass}[data-swiper-slide-index="${realIndex}"]:not(.${params.slideDuplicateClass})`).eq(0).index();
            (0, $2y7Cr.nextTick)(()=>{
                swiper.slideTo(slideToIndex);
            });
        } else swiper.slideTo(slideToIndex);
    } else swiper.slideTo(slideToIndex);
}

});


parcelRequire.register("6hBLv", function(module, exports) {

$parcel$export(module.exports, "default", () => $49319ffe14a7e069$export$2e2bcd8739ae039);

var $Jpvcj = parcelRequire("Jpvcj");

var $7c57x = parcelRequire("7c57x");

var $2JTwh = parcelRequire("2JTwh");
var $49319ffe14a7e069$export$2e2bcd8739ae039 = {
    loopCreate: $Jpvcj.default,
    loopFix: $7c57x.default,
    loopDestroy: $2JTwh.default
};

});
parcelRequire.register("Jpvcj", function(module, exports) {

$parcel$export(module.exports, "default", () => $0887fc4965788d97$export$2e2bcd8739ae039);

var $bkUxr = parcelRequire("bkUxr");

var $92tgL = parcelRequire("92tgL");
function $0887fc4965788d97$export$2e2bcd8739ae039() {
    const swiper = this;
    const document = (0, $bkUxr.getDocument)();
    const { params: params, $wrapperEl: $wrapperEl } = swiper; // Remove duplicated slides
    const $selector = $wrapperEl.children().length > 0 ? (0, $92tgL.default)($wrapperEl.children()[0].parentNode) : $wrapperEl;
    $selector.children(`.${params.slideClass}.${params.slideDuplicateClass}`).remove();
    let slides = $selector.children(`.${params.slideClass}`);
    if (params.loopFillGroupWithBlank) {
        const blankSlidesNum = params.slidesPerGroup - slides.length % params.slidesPerGroup;
        if (blankSlidesNum !== params.slidesPerGroup) {
            for(let i = 0; i < blankSlidesNum; i += 1){
                const blankNode = (0, $92tgL.default)(document.createElement("div")).addClass(`${params.slideClass} ${params.slideBlankClass}`);
                $selector.append(blankNode);
            }
            slides = $selector.children(`.${params.slideClass}`);
        }
    }
    if (params.slidesPerView === "auto" && !params.loopedSlides) params.loopedSlides = slides.length;
    swiper.loopedSlides = Math.ceil(parseFloat(params.loopedSlides || params.slidesPerView, 10));
    swiper.loopedSlides += params.loopAdditionalSlides;
    if (swiper.loopedSlides > slides.length && swiper.params.loopedSlidesLimit) swiper.loopedSlides = slides.length;
    const prependSlides = [];
    const appendSlides = [];
    slides.each((el, index)=>{
        const slide = (0, $92tgL.default)(el);
        slide.attr("data-swiper-slide-index", index);
    });
    for(let i = 0; i < swiper.loopedSlides; i += 1){
        const index = i - Math.floor(i / slides.length) * slides.length;
        appendSlides.push(slides.eq(index)[0]);
        prependSlides.unshift(slides.eq(slides.length - index - 1)[0]);
    }
    for(let i = 0; i < appendSlides.length; i += 1)$selector.append((0, $92tgL.default)(appendSlides[i].cloneNode(true)).addClass(params.slideDuplicateClass));
    for(let i = prependSlides.length - 1; i >= 0; i -= 1)$selector.prepend((0, $92tgL.default)(prependSlides[i].cloneNode(true)).addClass(params.slideDuplicateClass));
}

});

parcelRequire.register("7c57x", function(module, exports) {

$parcel$export(module.exports, "default", () => $53cda0424c5770b8$export$2e2bcd8739ae039);
function $53cda0424c5770b8$export$2e2bcd8739ae039() {
    const swiper = this;
    swiper.emit("beforeLoopFix");
    const { activeIndex: activeIndex, slides: slides, loopedSlides: loopedSlides, allowSlidePrev: allowSlidePrev, allowSlideNext: allowSlideNext, snapGrid: snapGrid, rtlTranslate: rtl } = swiper;
    let newIndex;
    swiper.allowSlidePrev = true;
    swiper.allowSlideNext = true;
    const snapTranslate = -snapGrid[activeIndex];
    const diff = snapTranslate - swiper.getTranslate(); // Fix For Negative Oversliding
    if (activeIndex < loopedSlides) {
        newIndex = slides.length - loopedSlides * 3 + activeIndex;
        newIndex += loopedSlides;
        const slideChanged = swiper.slideTo(newIndex, 0, false, true);
        if (slideChanged && diff !== 0) swiper.setTranslate((rtl ? -swiper.translate : swiper.translate) - diff);
    } else if (activeIndex >= slides.length - loopedSlides) {
        // Fix For Positive Oversliding
        newIndex = -slides.length + activeIndex + loopedSlides;
        newIndex += loopedSlides;
        const slideChanged = swiper.slideTo(newIndex, 0, false, true);
        if (slideChanged && diff !== 0) swiper.setTranslate((rtl ? -swiper.translate : swiper.translate) - diff);
    }
    swiper.allowSlidePrev = allowSlidePrev;
    swiper.allowSlideNext = allowSlideNext;
    swiper.emit("loopFix");
}

});

parcelRequire.register("2JTwh", function(module, exports) {

$parcel$export(module.exports, "default", () => $1fead9c728d7b3f3$export$2e2bcd8739ae039);
function $1fead9c728d7b3f3$export$2e2bcd8739ae039() {
    const swiper = this;
    const { $wrapperEl: $wrapperEl, params: params, slides: slides } = swiper;
    $wrapperEl.children(`.${params.slideClass}.${params.slideDuplicateClass},.${params.slideClass}.${params.slideBlankClass}`).remove();
    slides.removeAttr("data-swiper-slide-index");
}

});


parcelRequire.register("eITfw", function(module, exports) {

$parcel$export(module.exports, "default", () => $ab8008213857c227$export$2e2bcd8739ae039);

var $7JS2Y = parcelRequire("7JS2Y");

var $aeP4F = parcelRequire("aeP4F");
var $ab8008213857c227$export$2e2bcd8739ae039 = {
    setGrabCursor: $7JS2Y.default,
    unsetGrabCursor: $aeP4F.default
};

});
parcelRequire.register("7JS2Y", function(module, exports) {

$parcel$export(module.exports, "default", () => $5a26a8f3dbcd8122$export$2e2bcd8739ae039);
function $5a26a8f3dbcd8122$export$2e2bcd8739ae039(moving) {
    const swiper = this;
    if (swiper.support.touch || !swiper.params.simulateTouch || swiper.params.watchOverflow && swiper.isLocked || swiper.params.cssMode) return;
    const el = swiper.params.touchEventsTarget === "container" ? swiper.el : swiper.wrapperEl;
    el.style.cursor = "move";
    el.style.cursor = moving ? "grabbing" : "grab";
}

});

parcelRequire.register("aeP4F", function(module, exports) {

$parcel$export(module.exports, "default", () => $7742d477c04dfaa2$export$2e2bcd8739ae039);
function $7742d477c04dfaa2$export$2e2bcd8739ae039() {
    const swiper = this;
    if (swiper.support.touch || swiper.params.watchOverflow && swiper.isLocked || swiper.params.cssMode) return;
    swiper[swiper.params.touchEventsTarget === "container" ? "el" : "wrapperEl"].style.cursor = "";
}

});


parcelRequire.register("iYp6P", function(module, exports) {

$parcel$export(module.exports, "default", () => $dd014ec224a48da7$export$2e2bcd8739ae039);

var $bkUxr = parcelRequire("bkUxr");

var $jw5hn = parcelRequire("jw5hn");

var $1GkR6 = parcelRequire("1GkR6");

var $5seSy = parcelRequire("5seSy");

var $kCltm = parcelRequire("kCltm");

var $46WK2 = parcelRequire("46WK2");

var $94egs = parcelRequire("94egs");
let $dd014ec224a48da7$var$dummyEventAttached = false;
function $dd014ec224a48da7$var$dummyEventListener() {}
const $dd014ec224a48da7$var$events = (swiper, method)=>{
    const document = (0, $bkUxr.getDocument)();
    const { params: params, touchEvents: touchEvents, el: el, wrapperEl: wrapperEl, device: device, support: support } = swiper;
    const capture = !!params.nested;
    const domMethod = method === "on" ? "addEventListener" : "removeEventListener";
    const swiperMethod = method; // Touch Events
    if (!support.touch) {
        el[domMethod](touchEvents.start, swiper.onTouchStart, false);
        document[domMethod](touchEvents.move, swiper.onTouchMove, capture);
        document[domMethod](touchEvents.end, swiper.onTouchEnd, false);
    } else {
        const passiveListener = touchEvents.start === "touchstart" && support.passiveListener && params.passiveListeners ? {
            passive: true,
            capture: false
        } : false;
        el[domMethod](touchEvents.start, swiper.onTouchStart, passiveListener);
        el[domMethod](touchEvents.move, swiper.onTouchMove, support.passiveListener ? {
            passive: false,
            capture: capture
        } : capture);
        el[domMethod](touchEvents.end, swiper.onTouchEnd, passiveListener);
        if (touchEvents.cancel) el[domMethod](touchEvents.cancel, swiper.onTouchEnd, passiveListener);
    } // Prevent Links Clicks
    if (params.preventClicks || params.preventClicksPropagation) el[domMethod]("click", swiper.onClick, true);
    if (params.cssMode) wrapperEl[domMethod]("scroll", swiper.onScroll);
     // Resize handler
    if (params.updateOnWindowResize) swiper[swiperMethod](device.ios || device.android ? "resize orientationchange observerUpdate" : "resize observerUpdate", (0, $kCltm.default), true);
    else swiper[swiperMethod]("observerUpdate", (0, $kCltm.default), true);
};
function $dd014ec224a48da7$var$attachEvents() {
    const swiper = this;
    const document = (0, $bkUxr.getDocument)();
    const { params: params, support: support } = swiper;
    swiper.onTouchStart = (0, $jw5hn.default).bind(swiper);
    swiper.onTouchMove = (0, $1GkR6.default).bind(swiper);
    swiper.onTouchEnd = (0, $5seSy.default).bind(swiper);
    if (params.cssMode) swiper.onScroll = (0, $94egs.default).bind(swiper);
    swiper.onClick = (0, $46WK2.default).bind(swiper);
    if (support.touch && !$dd014ec224a48da7$var$dummyEventAttached) {
        document.addEventListener("touchstart", $dd014ec224a48da7$var$dummyEventListener);
        $dd014ec224a48da7$var$dummyEventAttached = true;
    }
    $dd014ec224a48da7$var$events(swiper, "on");
}
function $dd014ec224a48da7$var$detachEvents() {
    const swiper = this;
    $dd014ec224a48da7$var$events(swiper, "off");
}
var $dd014ec224a48da7$export$2e2bcd8739ae039 = {
    attachEvents: $dd014ec224a48da7$var$attachEvents,
    detachEvents: $dd014ec224a48da7$var$detachEvents
};

});
parcelRequire.register("jw5hn", function(module, exports) {

$parcel$export(module.exports, "default", () => $e35519d39744b0a2$export$2e2bcd8739ae039);

var $bkUxr = parcelRequire("bkUxr");

var $92tgL = parcelRequire("92tgL");

var $2y7Cr = parcelRequire("2y7Cr");
function $e35519d39744b0a2$var$closestElement(selector, base = this) {
    function __closestFrom(el) {
        if (!el || el === (0, $bkUxr.getDocument)() || el === (0, $bkUxr.getWindow)()) return null;
        if (el.assignedSlot) el = el.assignedSlot;
        const found = el.closest(selector);
        if (!found && !el.getRootNode) return null;
        return found || __closestFrom(el.getRootNode().host);
    }
    return __closestFrom(base);
}
function $e35519d39744b0a2$export$2e2bcd8739ae039(event) {
    const swiper = this;
    const document = (0, $bkUxr.getDocument)();
    const window = (0, $bkUxr.getWindow)();
    const data = swiper.touchEventsData;
    const { params: params, touches: touches, enabled: enabled } = swiper;
    if (!enabled) return;
    if (swiper.animating && params.preventInteractionOnTransition) return;
    if (!swiper.animating && params.cssMode && params.loop) swiper.loopFix();
    let e = event;
    if (e.originalEvent) e = e.originalEvent;
    let $targetEl = (0, $92tgL.default)(e.target);
    if (params.touchEventsTarget === "wrapper") {
        if (!$targetEl.closest(swiper.wrapperEl).length) return;
    }
    data.isTouchEvent = e.type === "touchstart";
    if (!data.isTouchEvent && "which" in e && e.which === 3) return;
    if (!data.isTouchEvent && "button" in e && e.button > 0) return;
    if (data.isTouched && data.isMoved) return; // change target el for shadow root component
    const swipingClassHasValue = !!params.noSwipingClass && params.noSwipingClass !== ""; // eslint-disable-next-line
    const eventPath = event.composedPath ? event.composedPath() : event.path;
    if (swipingClassHasValue && e.target && e.target.shadowRoot && eventPath) $targetEl = (0, $92tgL.default)(eventPath[0]);
    const noSwipingSelector = params.noSwipingSelector ? params.noSwipingSelector : `.${params.noSwipingClass}`;
    const isTargetShadow = !!(e.target && e.target.shadowRoot); // use closestElement for shadow root element to get the actual closest for nested shadow root element
    if (params.noSwiping && (isTargetShadow ? $e35519d39744b0a2$var$closestElement(noSwipingSelector, $targetEl[0]) : $targetEl.closest(noSwipingSelector)[0])) {
        swiper.allowClick = true;
        return;
    }
    if (params.swipeHandler) {
        if (!$targetEl.closest(params.swipeHandler)[0]) return;
    }
    touches.currentX = e.type === "touchstart" ? e.targetTouches[0].pageX : e.pageX;
    touches.currentY = e.type === "touchstart" ? e.targetTouches[0].pageY : e.pageY;
    const startX = touches.currentX;
    const startY = touches.currentY; // Do NOT start if iOS edge swipe is detected. Otherwise iOS app cannot swipe-to-go-back anymore
    const edgeSwipeDetection = params.edgeSwipeDetection || params.iOSEdgeSwipeDetection;
    const edgeSwipeThreshold = params.edgeSwipeThreshold || params.iOSEdgeSwipeThreshold;
    if (edgeSwipeDetection && (startX <= edgeSwipeThreshold || startX >= window.innerWidth - edgeSwipeThreshold)) {
        if (edgeSwipeDetection === "prevent") event.preventDefault();
        else return;
    }
    Object.assign(data, {
        isTouched: true,
        isMoved: false,
        allowTouchCallbacks: true,
        isScrolling: undefined,
        startMoving: undefined
    });
    touches.startX = startX;
    touches.startY = startY;
    data.touchStartTime = (0, $2y7Cr.now)();
    swiper.allowClick = true;
    swiper.updateSize();
    swiper.swipeDirection = undefined;
    if (params.threshold > 0) data.allowThresholdMove = false;
    if (e.type !== "touchstart") {
        let preventDefault = true;
        if ($targetEl.is(data.focusableElements)) {
            preventDefault = false;
            if ($targetEl[0].nodeName === "SELECT") data.isTouched = false;
        }
        if (document.activeElement && (0, $92tgL.default)(document.activeElement).is(data.focusableElements) && document.activeElement !== $targetEl[0]) document.activeElement.blur();
        const shouldPreventDefault = preventDefault && swiper.allowTouchMove && params.touchStartPreventDefault;
        if ((params.touchStartForcePreventDefault || shouldPreventDefault) && !$targetEl[0].isContentEditable) e.preventDefault();
    }
    if (swiper.params.freeMode && swiper.params.freeMode.enabled && swiper.freeMode && swiper.animating && !params.cssMode) swiper.freeMode.onTouchStart();
    swiper.emit("touchStart", e);
}

});

parcelRequire.register("1GkR6", function(module, exports) {

$parcel$export(module.exports, "default", () => $1399e424bde70bf9$export$2e2bcd8739ae039);

var $bkUxr = parcelRequire("bkUxr");

var $92tgL = parcelRequire("92tgL");

var $2y7Cr = parcelRequire("2y7Cr");
function $1399e424bde70bf9$export$2e2bcd8739ae039(event) {
    const document = (0, $bkUxr.getDocument)();
    const swiper = this;
    const data = swiper.touchEventsData;
    const { params: params, touches: touches, rtlTranslate: rtl, enabled: enabled } = swiper;
    if (!enabled) return;
    let e = event;
    if (e.originalEvent) e = e.originalEvent;
    if (!data.isTouched) {
        if (data.startMoving && data.isScrolling) swiper.emit("touchMoveOpposite", e);
        return;
    }
    if (data.isTouchEvent && e.type !== "touchmove") return;
    const targetTouch = e.type === "touchmove" && e.targetTouches && (e.targetTouches[0] || e.changedTouches[0]);
    const pageX = e.type === "touchmove" ? targetTouch.pageX : e.pageX;
    const pageY = e.type === "touchmove" ? targetTouch.pageY : e.pageY;
    if (e.preventedByNestedSwiper) {
        touches.startX = pageX;
        touches.startY = pageY;
        return;
    }
    if (!swiper.allowTouchMove) {
        if (!(0, $92tgL.default)(e.target).is(data.focusableElements)) swiper.allowClick = false;
        if (data.isTouched) {
            Object.assign(touches, {
                startX: pageX,
                startY: pageY,
                currentX: pageX,
                currentY: pageY
            });
            data.touchStartTime = (0, $2y7Cr.now)();
        }
        return;
    }
    if (data.isTouchEvent && params.touchReleaseOnEdges && !params.loop) {
        if (swiper.isVertical()) // Vertical
        {
            if (pageY < touches.startY && swiper.translate <= swiper.maxTranslate() || pageY > touches.startY && swiper.translate >= swiper.minTranslate()) {
                data.isTouched = false;
                data.isMoved = false;
                return;
            }
        } else if (pageX < touches.startX && swiper.translate <= swiper.maxTranslate() || pageX > touches.startX && swiper.translate >= swiper.minTranslate()) return;
    }
    if (data.isTouchEvent && document.activeElement) {
        if (e.target === document.activeElement && (0, $92tgL.default)(e.target).is(data.focusableElements)) {
            data.isMoved = true;
            swiper.allowClick = false;
            return;
        }
    }
    if (data.allowTouchCallbacks) swiper.emit("touchMove", e);
    if (e.targetTouches && e.targetTouches.length > 1) return;
    touches.currentX = pageX;
    touches.currentY = pageY;
    const diffX = touches.currentX - touches.startX;
    const diffY = touches.currentY - touches.startY;
    if (swiper.params.threshold && Math.sqrt(diffX ** 2 + diffY ** 2) < swiper.params.threshold) return;
    if (typeof data.isScrolling === "undefined") {
        let touchAngle;
        if (swiper.isHorizontal() && touches.currentY === touches.startY || swiper.isVertical() && touches.currentX === touches.startX) data.isScrolling = false;
        else // eslint-disable-next-line
        if (diffX * diffX + diffY * diffY >= 25) {
            touchAngle = Math.atan2(Math.abs(diffY), Math.abs(diffX)) * 180 / Math.PI;
            data.isScrolling = swiper.isHorizontal() ? touchAngle > params.touchAngle : 90 - touchAngle > params.touchAngle;
        }
    }
    if (data.isScrolling) swiper.emit("touchMoveOpposite", e);
    if (typeof data.startMoving === "undefined") {
        if (touches.currentX !== touches.startX || touches.currentY !== touches.startY) data.startMoving = true;
    }
    if (data.isScrolling) {
        data.isTouched = false;
        return;
    }
    if (!data.startMoving) return;
    swiper.allowClick = false;
    if (!params.cssMode && e.cancelable) e.preventDefault();
    if (params.touchMoveStopPropagation && !params.nested) e.stopPropagation();
    if (!data.isMoved) {
        if (params.loop && !params.cssMode) swiper.loopFix();
        data.startTranslate = swiper.getTranslate();
        swiper.setTransition(0);
        if (swiper.animating) swiper.$wrapperEl.trigger("webkitTransitionEnd transitionend");
        data.allowMomentumBounce = false; // Grab Cursor
        if (params.grabCursor && (swiper.allowSlideNext === true || swiper.allowSlidePrev === true)) swiper.setGrabCursor(true);
        swiper.emit("sliderFirstMove", e);
    }
    swiper.emit("sliderMove", e);
    data.isMoved = true;
    let diff = swiper.isHorizontal() ? diffX : diffY;
    touches.diff = diff;
    diff *= params.touchRatio;
    if (rtl) diff = -diff;
    swiper.swipeDirection = diff > 0 ? "prev" : "next";
    data.currentTranslate = diff + data.startTranslate;
    let disableParentSwiper = true;
    let resistanceRatio = params.resistanceRatio;
    if (params.touchReleaseOnEdges) resistanceRatio = 0;
    if (diff > 0 && data.currentTranslate > swiper.minTranslate()) {
        disableParentSwiper = false;
        if (params.resistance) data.currentTranslate = swiper.minTranslate() - 1 + (-swiper.minTranslate() + data.startTranslate + diff) ** resistanceRatio;
    } else if (diff < 0 && data.currentTranslate < swiper.maxTranslate()) {
        disableParentSwiper = false;
        if (params.resistance) data.currentTranslate = swiper.maxTranslate() + 1 - (swiper.maxTranslate() - data.startTranslate - diff) ** resistanceRatio;
    }
    if (disableParentSwiper) e.preventedByNestedSwiper = true;
     // Directions locks
    if (!swiper.allowSlideNext && swiper.swipeDirection === "next" && data.currentTranslate < data.startTranslate) data.currentTranslate = data.startTranslate;
    if (!swiper.allowSlidePrev && swiper.swipeDirection === "prev" && data.currentTranslate > data.startTranslate) data.currentTranslate = data.startTranslate;
    if (!swiper.allowSlidePrev && !swiper.allowSlideNext) data.currentTranslate = data.startTranslate;
     // Threshold
    if (params.threshold > 0) {
        if (Math.abs(diff) > params.threshold || data.allowThresholdMove) {
            if (!data.allowThresholdMove) {
                data.allowThresholdMove = true;
                touches.startX = touches.currentX;
                touches.startY = touches.currentY;
                data.currentTranslate = data.startTranslate;
                touches.diff = swiper.isHorizontal() ? touches.currentX - touches.startX : touches.currentY - touches.startY;
                return;
            }
        } else {
            data.currentTranslate = data.startTranslate;
            return;
        }
    }
    if (!params.followFinger || params.cssMode) return; // Update active index in free mode
    if (params.freeMode && params.freeMode.enabled && swiper.freeMode || params.watchSlidesProgress) {
        swiper.updateActiveIndex();
        swiper.updateSlidesClasses();
    }
    if (swiper.params.freeMode && params.freeMode.enabled && swiper.freeMode) swiper.freeMode.onTouchMove();
     // Update progress
    swiper.updateProgress(data.currentTranslate); // Update translate
    swiper.setTranslate(data.currentTranslate);
}

});

parcelRequire.register("5seSy", function(module, exports) {

$parcel$export(module.exports, "default", () => $3f8b1beae2c02b61$export$2e2bcd8739ae039);

var $2y7Cr = parcelRequire("2y7Cr");
function $3f8b1beae2c02b61$export$2e2bcd8739ae039(event) {
    const swiper = this;
    const data = swiper.touchEventsData;
    const { params: params, touches: touches, rtlTranslate: rtl, slidesGrid: slidesGrid, enabled: enabled } = swiper;
    if (!enabled) return;
    let e = event;
    if (e.originalEvent) e = e.originalEvent;
    if (data.allowTouchCallbacks) swiper.emit("touchEnd", e);
    data.allowTouchCallbacks = false;
    if (!data.isTouched) {
        if (data.isMoved && params.grabCursor) swiper.setGrabCursor(false);
        data.isMoved = false;
        data.startMoving = false;
        return;
    } // Return Grab Cursor
    if (params.grabCursor && data.isMoved && data.isTouched && (swiper.allowSlideNext === true || swiper.allowSlidePrev === true)) swiper.setGrabCursor(false);
     // Time diff
    const touchEndTime = (0, $2y7Cr.now)();
    const timeDiff = touchEndTime - data.touchStartTime; // Tap, doubleTap, Click
    if (swiper.allowClick) {
        const pathTree = e.path || e.composedPath && e.composedPath();
        swiper.updateClickedSlide(pathTree && pathTree[0] || e.target);
        swiper.emit("tap click", e);
        if (timeDiff < 300 && touchEndTime - data.lastClickTime < 300) swiper.emit("doubleTap doubleClick", e);
    }
    data.lastClickTime = (0, $2y7Cr.now)();
    (0, $2y7Cr.nextTick)(()=>{
        if (!swiper.destroyed) swiper.allowClick = true;
    });
    if (!data.isTouched || !data.isMoved || !swiper.swipeDirection || touches.diff === 0 || data.currentTranslate === data.startTranslate) {
        data.isTouched = false;
        data.isMoved = false;
        data.startMoving = false;
        return;
    }
    data.isTouched = false;
    data.isMoved = false;
    data.startMoving = false;
    let currentPos;
    if (params.followFinger) currentPos = rtl ? swiper.translate : -swiper.translate;
    else currentPos = -data.currentTranslate;
    if (params.cssMode) return;
    if (swiper.params.freeMode && params.freeMode.enabled) {
        swiper.freeMode.onTouchEnd({
            currentPos: currentPos
        });
        return;
    } // Find current slide
    let stopIndex = 0;
    let groupSize = swiper.slidesSizesGrid[0];
    for(let i = 0; i < slidesGrid.length; i += i < params.slidesPerGroupSkip ? 1 : params.slidesPerGroup){
        const increment = i < params.slidesPerGroupSkip - 1 ? 1 : params.slidesPerGroup;
        if (typeof slidesGrid[i + increment] !== "undefined") {
            if (currentPos >= slidesGrid[i] && currentPos < slidesGrid[i + increment]) {
                stopIndex = i;
                groupSize = slidesGrid[i + increment] - slidesGrid[i];
            }
        } else if (currentPos >= slidesGrid[i]) {
            stopIndex = i;
            groupSize = slidesGrid[slidesGrid.length - 1] - slidesGrid[slidesGrid.length - 2];
        }
    }
    let rewindFirstIndex = null;
    let rewindLastIndex = null;
    if (params.rewind) {
        if (swiper.isBeginning) rewindLastIndex = swiper.params.virtual && swiper.params.virtual.enabled && swiper.virtual ? swiper.virtual.slides.length - 1 : swiper.slides.length - 1;
        else if (swiper.isEnd) rewindFirstIndex = 0;
    } // Find current slide size
    const ratio = (currentPos - slidesGrid[stopIndex]) / groupSize;
    const increment = stopIndex < params.slidesPerGroupSkip - 1 ? 1 : params.slidesPerGroup;
    if (timeDiff > params.longSwipesMs) {
        // Long touches
        if (!params.longSwipes) {
            swiper.slideTo(swiper.activeIndex);
            return;
        }
        if (swiper.swipeDirection === "next") {
            if (ratio >= params.longSwipesRatio) swiper.slideTo(params.rewind && swiper.isEnd ? rewindFirstIndex : stopIndex + increment);
            else swiper.slideTo(stopIndex);
        }
        if (swiper.swipeDirection === "prev") {
            if (ratio > 1 - params.longSwipesRatio) swiper.slideTo(stopIndex + increment);
            else if (rewindLastIndex !== null && ratio < 0 && Math.abs(ratio) > params.longSwipesRatio) swiper.slideTo(rewindLastIndex);
            else swiper.slideTo(stopIndex);
        }
    } else {
        // Short swipes
        if (!params.shortSwipes) {
            swiper.slideTo(swiper.activeIndex);
            return;
        }
        const isNavButtonTarget = swiper.navigation && (e.target === swiper.navigation.nextEl || e.target === swiper.navigation.prevEl);
        if (!isNavButtonTarget) {
            if (swiper.swipeDirection === "next") swiper.slideTo(rewindFirstIndex !== null ? rewindFirstIndex : stopIndex + increment);
            if (swiper.swipeDirection === "prev") swiper.slideTo(rewindLastIndex !== null ? rewindLastIndex : stopIndex);
        } else if (e.target === swiper.navigation.nextEl) swiper.slideTo(stopIndex + increment);
        else swiper.slideTo(stopIndex);
    }
}

});

parcelRequire.register("kCltm", function(module, exports) {

$parcel$export(module.exports, "default", () => $f028033fc4481a60$export$2e2bcd8739ae039);
function $f028033fc4481a60$export$2e2bcd8739ae039() {
    const swiper = this;
    const { params: params, el: el } = swiper;
    if (el && el.offsetWidth === 0) return; // Breakpoints
    if (params.breakpoints) swiper.setBreakpoint();
     // Save locks
    const { allowSlideNext: allowSlideNext, allowSlidePrev: allowSlidePrev, snapGrid: snapGrid } = swiper; // Disable locks on resize
    swiper.allowSlideNext = true;
    swiper.allowSlidePrev = true;
    swiper.updateSize();
    swiper.updateSlides();
    swiper.updateSlidesClasses();
    if ((params.slidesPerView === "auto" || params.slidesPerView > 1) && swiper.isEnd && !swiper.isBeginning && !swiper.params.centeredSlides) swiper.slideTo(swiper.slides.length - 1, 0, false, true);
    else swiper.slideTo(swiper.activeIndex, 0, false, true);
    if (swiper.autoplay && swiper.autoplay.running && swiper.autoplay.paused) swiper.autoplay.run();
     // Return locks after resize
    swiper.allowSlidePrev = allowSlidePrev;
    swiper.allowSlideNext = allowSlideNext;
    if (swiper.params.watchOverflow && snapGrid !== swiper.snapGrid) swiper.checkOverflow();
}

});

parcelRequire.register("46WK2", function(module, exports) {

$parcel$export(module.exports, "default", () => $2fe549d5bdc39ef4$export$2e2bcd8739ae039);
function $2fe549d5bdc39ef4$export$2e2bcd8739ae039(e) {
    const swiper = this;
    if (!swiper.enabled) return;
    if (!swiper.allowClick) {
        if (swiper.params.preventClicks) e.preventDefault();
        if (swiper.params.preventClicksPropagation && swiper.animating) {
            e.stopPropagation();
            e.stopImmediatePropagation();
        }
    }
}

});

parcelRequire.register("94egs", function(module, exports) {

$parcel$export(module.exports, "default", () => $699f8d6a6947f636$export$2e2bcd8739ae039);
function $699f8d6a6947f636$export$2e2bcd8739ae039() {
    const swiper = this;
    const { wrapperEl: wrapperEl, rtlTranslate: rtlTranslate, enabled: enabled } = swiper;
    if (!enabled) return;
    swiper.previousTranslate = swiper.translate;
    if (swiper.isHorizontal()) swiper.translate = -wrapperEl.scrollLeft;
    else swiper.translate = -wrapperEl.scrollTop;
     // eslint-disable-next-line
    if (swiper.translate === 0) swiper.translate = 0;
    swiper.updateActiveIndex();
    swiper.updateSlidesClasses();
    let newProgress;
    const translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
    if (translatesDiff === 0) newProgress = 0;
    else newProgress = (swiper.translate - swiper.minTranslate()) / translatesDiff;
    if (newProgress !== swiper.progress) swiper.updateProgress(rtlTranslate ? -swiper.translate : swiper.translate);
    swiper.emit("setTranslate", swiper.translate, false);
}

});


parcelRequire.register("bDrt1", function(module, exports) {

$parcel$export(module.exports, "default", () => $8788a4a41437b5f6$export$2e2bcd8739ae039);

var $kWIXH = parcelRequire("kWIXH");

var $wEqEY = parcelRequire("wEqEY");
var $8788a4a41437b5f6$export$2e2bcd8739ae039 = {
    setBreakpoint: $kWIXH.default,
    getBreakpoint: $wEqEY.default
};

});
parcelRequire.register("kWIXH", function(module, exports) {

$parcel$export(module.exports, "default", () => $f3fc19ecdbdf937e$export$2e2bcd8739ae039);

var $2y7Cr = parcelRequire("2y7Cr");
const $f3fc19ecdbdf937e$var$isGridEnabled = (swiper, params)=>{
    return swiper.grid && params.grid && params.grid.rows > 1;
};
function $f3fc19ecdbdf937e$export$2e2bcd8739ae039() {
    const swiper = this;
    const { activeIndex: activeIndex, initialized: initialized, loopedSlides: loopedSlides = 0, params: params, $el: $el } = swiper;
    const breakpoints = params.breakpoints;
    if (!breakpoints || breakpoints && Object.keys(breakpoints).length === 0) return; // Get breakpoint for window width and update parameters
    const breakpoint = swiper.getBreakpoint(breakpoints, swiper.params.breakpointsBase, swiper.el);
    if (!breakpoint || swiper.currentBreakpoint === breakpoint) return;
    const breakpointOnlyParams = breakpoint in breakpoints ? breakpoints[breakpoint] : undefined;
    const breakpointParams = breakpointOnlyParams || swiper.originalParams;
    const wasMultiRow = $f3fc19ecdbdf937e$var$isGridEnabled(swiper, params);
    const isMultiRow = $f3fc19ecdbdf937e$var$isGridEnabled(swiper, breakpointParams);
    const wasEnabled = params.enabled;
    if (wasMultiRow && !isMultiRow) {
        $el.removeClass(`${params.containerModifierClass}grid ${params.containerModifierClass}grid-column`);
        swiper.emitContainerClasses();
    } else if (!wasMultiRow && isMultiRow) {
        $el.addClass(`${params.containerModifierClass}grid`);
        if (breakpointParams.grid.fill && breakpointParams.grid.fill === "column" || !breakpointParams.grid.fill && params.grid.fill === "column") $el.addClass(`${params.containerModifierClass}grid-column`);
        swiper.emitContainerClasses();
    } // Toggle navigation, pagination, scrollbar
    [
        "navigation",
        "pagination",
        "scrollbar"
    ].forEach((prop)=>{
        const wasModuleEnabled = params[prop] && params[prop].enabled;
        const isModuleEnabled = breakpointParams[prop] && breakpointParams[prop].enabled;
        if (wasModuleEnabled && !isModuleEnabled) swiper[prop].disable();
        if (!wasModuleEnabled && isModuleEnabled) swiper[prop].enable();
    });
    const directionChanged = breakpointParams.direction && breakpointParams.direction !== params.direction;
    const needsReLoop = params.loop && (breakpointParams.slidesPerView !== params.slidesPerView || directionChanged);
    if (directionChanged && initialized) swiper.changeDirection();
    (0, $2y7Cr.extend)(swiper.params, breakpointParams);
    const isEnabled = swiper.params.enabled;
    Object.assign(swiper, {
        allowTouchMove: swiper.params.allowTouchMove,
        allowSlideNext: swiper.params.allowSlideNext,
        allowSlidePrev: swiper.params.allowSlidePrev
    });
    if (wasEnabled && !isEnabled) swiper.disable();
    else if (!wasEnabled && isEnabled) swiper.enable();
    swiper.currentBreakpoint = breakpoint;
    swiper.emit("_beforeBreakpoint", breakpointParams);
    if (needsReLoop && initialized) {
        swiper.loopDestroy();
        swiper.loopCreate();
        swiper.updateSlides();
        swiper.slideTo(activeIndex - loopedSlides + swiper.loopedSlides, 0, false);
    }
    swiper.emit("breakpoint", breakpointParams);
}

});

parcelRequire.register("wEqEY", function(module, exports) {

$parcel$export(module.exports, "default", () => $062259a179ce3c78$export$2e2bcd8739ae039);

var $bkUxr = parcelRequire("bkUxr");
function $062259a179ce3c78$export$2e2bcd8739ae039(breakpoints, base = "window", containerEl) {
    if (!breakpoints || base === "container" && !containerEl) return undefined;
    let breakpoint = false;
    const window = (0, $bkUxr.getWindow)();
    const currentHeight = base === "window" ? window.innerHeight : containerEl.clientHeight;
    const points = Object.keys(breakpoints).map((point)=>{
        if (typeof point === "string" && point.indexOf("@") === 0) {
            const minRatio = parseFloat(point.substr(1));
            const value = currentHeight * minRatio;
            return {
                value: value,
                point: point
            };
        }
        return {
            value: point,
            point: point
        };
    });
    points.sort((a, b)=>parseInt(a.value, 10) - parseInt(b.value, 10));
    for(let i = 0; i < points.length; i += 1){
        const { point: point, value: value } = points[i];
        if (base === "window") {
            if (window.matchMedia(`(min-width: ${value}px)`).matches) breakpoint = point;
        } else if (value <= containerEl.clientWidth) breakpoint = point;
    }
    return breakpoint || "max";
}

});


parcelRequire.register("kikIC", function(module, exports) {

$parcel$export(module.exports, "default", () => $ec658f5d357fbf38$export$2e2bcd8739ae039);

var $1j0hx = parcelRequire("1j0hx");

var $itdcS = parcelRequire("itdcS");
var $ec658f5d357fbf38$export$2e2bcd8739ae039 = {
    addClasses: $1j0hx.default,
    removeClasses: $itdcS.default
};

});
parcelRequire.register("1j0hx", function(module, exports) {

$parcel$export(module.exports, "default", () => $0f37c8c7f37735fb$export$2e2bcd8739ae039);
function $0f37c8c7f37735fb$var$prepareClasses(entries, prefix) {
    const resultClasses = [];
    entries.forEach((item)=>{
        if (typeof item === "object") Object.keys(item).forEach((classNames)=>{
            if (item[classNames]) resultClasses.push(prefix + classNames);
        });
        else if (typeof item === "string") resultClasses.push(prefix + item);
    });
    return resultClasses;
}
function $0f37c8c7f37735fb$export$2e2bcd8739ae039() {
    const swiper = this;
    const { classNames: classNames, params: params, rtl: rtl, $el: $el, device: device, support: support } = swiper; // prettier-ignore
    const suffixes = $0f37c8c7f37735fb$var$prepareClasses([
        "initialized",
        params.direction,
        {
            "pointer-events": !support.touch
        },
        {
            "free-mode": swiper.params.freeMode && params.freeMode.enabled
        },
        {
            "autoheight": params.autoHeight
        },
        {
            "rtl": rtl
        },
        {
            "grid": params.grid && params.grid.rows > 1
        },
        {
            "grid-column": params.grid && params.grid.rows > 1 && params.grid.fill === "column"
        },
        {
            "android": device.android
        },
        {
            "ios": device.ios
        },
        {
            "css-mode": params.cssMode
        },
        {
            "centered": params.cssMode && params.centeredSlides
        },
        {
            "watch-progress": params.watchSlidesProgress
        }
    ], params.containerModifierClass);
    classNames.push(...suffixes);
    $el.addClass([
        ...classNames
    ].join(" "));
    swiper.emitContainerClasses();
}

});

parcelRequire.register("itdcS", function(module, exports) {

$parcel$export(module.exports, "default", () => $d7252dfcea1b791d$export$2e2bcd8739ae039);
function $d7252dfcea1b791d$export$2e2bcd8739ae039() {
    const swiper = this;
    const { $el: $el, classNames: classNames } = swiper;
    $el.removeClass(classNames.join(" "));
    swiper.emitContainerClasses();
}

});


parcelRequire.register("doLnc", function(module, exports) {

$parcel$export(module.exports, "default", () => $9c124398fcb336ef$export$2e2bcd8739ae039);

var $jNRPl = parcelRequire("jNRPl");

var $iJYxn = parcelRequire("iJYxn");
var $9c124398fcb336ef$export$2e2bcd8739ae039 = {
    loadImage: $jNRPl.default,
    preloadImages: $iJYxn.default
};

});
parcelRequire.register("jNRPl", function(module, exports) {

$parcel$export(module.exports, "default", () => $e6ac58d944f6f3e9$export$2e2bcd8739ae039);

var $bkUxr = parcelRequire("bkUxr");

var $92tgL = parcelRequire("92tgL");
function $e6ac58d944f6f3e9$export$2e2bcd8739ae039(imageEl, src, srcset, sizes, checkForComplete, callback) {
    const window = (0, $bkUxr.getWindow)();
    let image;
    function onReady() {
        if (callback) callback();
    }
    const isPicture = (0, $92tgL.default)(imageEl).parent("picture")[0];
    if (!isPicture && (!imageEl.complete || !checkForComplete)) {
        if (src) {
            image = new window.Image();
            image.onload = onReady;
            image.onerror = onReady;
            if (sizes) image.sizes = sizes;
            if (srcset) image.srcset = srcset;
            if (src) image.src = src;
        } else onReady();
    } else // image already loaded...
    onReady();
}

});

parcelRequire.register("iJYxn", function(module, exports) {

$parcel$export(module.exports, "default", () => $da4b636b670a348e$export$2e2bcd8739ae039);
function $da4b636b670a348e$export$2e2bcd8739ae039() {
    const swiper = this;
    swiper.imagesToLoad = swiper.$el.find("img");
    function onReady() {
        if (typeof swiper === "undefined" || swiper === null || !swiper || swiper.destroyed) return;
        if (swiper.imagesLoaded !== undefined) swiper.imagesLoaded += 1;
        if (swiper.imagesLoaded === swiper.imagesToLoad.length) {
            if (swiper.params.updateOnImagesReady) swiper.update();
            swiper.emit("imagesReady");
        }
    }
    for(let i = 0; i < swiper.imagesToLoad.length; i += 1){
        const imageEl = swiper.imagesToLoad[i];
        swiper.loadImage(imageEl, imageEl.currentSrc || imageEl.getAttribute("src"), imageEl.srcset || imageEl.getAttribute("srcset"), imageEl.sizes || imageEl.getAttribute("sizes"), true, onReady);
    }
}

});


parcelRequire.register("eA7DM", function(module, exports) {

$parcel$export(module.exports, "default", () => $a9da5abe9e8acf34$export$2e2bcd8739ae039);
function $a9da5abe9e8acf34$var$checkOverflow() {
    const swiper = this;
    const { isLocked: wasLocked, params: params } = swiper;
    const { slidesOffsetBefore: slidesOffsetBefore } = params;
    if (slidesOffsetBefore) {
        const lastSlideIndex = swiper.slides.length - 1;
        const lastSlideRightEdge = swiper.slidesGrid[lastSlideIndex] + swiper.slidesSizesGrid[lastSlideIndex] + slidesOffsetBefore * 2;
        swiper.isLocked = swiper.size > lastSlideRightEdge;
    } else swiper.isLocked = swiper.snapGrid.length === 1;
    if (params.allowSlideNext === true) swiper.allowSlideNext = !swiper.isLocked;
    if (params.allowSlidePrev === true) swiper.allowSlidePrev = !swiper.isLocked;
    if (wasLocked && wasLocked !== swiper.isLocked) swiper.isEnd = false;
    if (wasLocked !== swiper.isLocked) swiper.emit(swiper.isLocked ? "lock" : "unlock");
}
var $a9da5abe9e8acf34$export$2e2bcd8739ae039 = {
    checkOverflow: $a9da5abe9e8acf34$var$checkOverflow
};

});

parcelRequire.register("gAai8", function(module, exports) {

$parcel$export(module.exports, "default", () => $c127fdcf3d4560f8$export$2e2bcd8739ae039);
var $c127fdcf3d4560f8$export$2e2bcd8739ae039 = {
    init: true,
    direction: "horizontal",
    touchEventsTarget: "wrapper",
    initialSlide: 0,
    speed: 300,
    cssMode: false,
    updateOnWindowResize: true,
    resizeObserver: true,
    nested: false,
    createElements: false,
    enabled: true,
    focusableElements: "input, select, option, textarea, button, video, label",
    // Overrides
    width: null,
    height: null,
    //
    preventInteractionOnTransition: false,
    // ssr
    userAgent: null,
    url: null,
    // To support iOS's swipe-to-go-back gesture (when being used in-app).
    edgeSwipeDetection: false,
    edgeSwipeThreshold: 20,
    // Autoheight
    autoHeight: false,
    // Set wrapper width
    setWrapperSize: false,
    // Virtual Translate
    virtualTranslate: false,
    // Effects
    effect: "slide",
    // 'slide' or 'fade' or 'cube' or 'coverflow' or 'flip'
    // Breakpoints
    breakpoints: undefined,
    breakpointsBase: "window",
    // Slides grid
    spaceBetween: 0,
    slidesPerView: 1,
    slidesPerGroup: 1,
    slidesPerGroupSkip: 0,
    slidesPerGroupAuto: false,
    centeredSlides: false,
    centeredSlidesBounds: false,
    slidesOffsetBefore: 0,
    // in px
    slidesOffsetAfter: 0,
    // in px
    normalizeSlideIndex: true,
    centerInsufficientSlides: false,
    // Disable swiper and hide navigation when container not overflow
    watchOverflow: true,
    // Round length
    roundLengths: false,
    // Touches
    touchRatio: 1,
    touchAngle: 45,
    simulateTouch: true,
    shortSwipes: true,
    longSwipes: true,
    longSwipesRatio: 0.5,
    longSwipesMs: 300,
    followFinger: true,
    allowTouchMove: true,
    threshold: 0,
    touchMoveStopPropagation: false,
    touchStartPreventDefault: true,
    touchStartForcePreventDefault: false,
    touchReleaseOnEdges: false,
    // Unique Navigation Elements
    uniqueNavElements: true,
    // Resistance
    resistance: true,
    resistanceRatio: 0.85,
    // Progress
    watchSlidesProgress: false,
    // Cursor
    grabCursor: false,
    // Clicks
    preventClicks: true,
    preventClicksPropagation: true,
    slideToClickedSlide: false,
    // Images
    preloadImages: true,
    updateOnImagesReady: true,
    // loop
    loop: false,
    loopAdditionalSlides: 0,
    loopedSlides: null,
    loopedSlidesLimit: true,
    loopFillGroupWithBlank: false,
    loopPreventsSlide: true,
    // rewind
    rewind: false,
    // Swiping/no swiping
    allowSlidePrev: true,
    allowSlideNext: true,
    swipeHandler: null,
    // '.swipe-handler',
    noSwiping: true,
    noSwipingClass: "swiper-no-swiping",
    noSwipingSelector: null,
    // Passive Listeners
    passiveListeners: true,
    maxBackfaceHiddenSlides: 10,
    // NS
    containerModifierClass: "swiper-",
    // NEW
    slideClass: "swiper-slide",
    slideBlankClass: "swiper-slide-invisible-blank",
    slideActiveClass: "swiper-slide-active",
    slideDuplicateActiveClass: "swiper-slide-duplicate-active",
    slideVisibleClass: "swiper-slide-visible",
    slideDuplicateClass: "swiper-slide-duplicate",
    slideNextClass: "swiper-slide-next",
    slideDuplicateNextClass: "swiper-slide-duplicate-next",
    slidePrevClass: "swiper-slide-prev",
    slideDuplicatePrevClass: "swiper-slide-duplicate-prev",
    wrapperClass: "swiper-wrapper",
    // Callbacks
    runCallbacksOnInit: true,
    // Internals
    _emitClasses: false
};

});

parcelRequire.register("1roBl", function(module, exports) {

$parcel$export(module.exports, "default", () => $10cb6564c94b3af2$export$2e2bcd8739ae039);

var $2y7Cr = parcelRequire("2y7Cr");
function $10cb6564c94b3af2$export$2e2bcd8739ae039(params, allModulesParams) {
    return function extendParams(obj = {}) {
        const moduleParamName = Object.keys(obj)[0];
        const moduleParams = obj[moduleParamName];
        if (typeof moduleParams !== "object" || moduleParams === null) {
            (0, $2y7Cr.extend)(allModulesParams, obj);
            return;
        }
        if ([
            "navigation",
            "pagination",
            "scrollbar"
        ].indexOf(moduleParamName) >= 0 && params[moduleParamName] === true) params[moduleParamName] = {
            auto: true
        };
        if (!(moduleParamName in params && "enabled" in moduleParams)) {
            (0, $2y7Cr.extend)(allModulesParams, obj);
            return;
        }
        if (params[moduleParamName] === true) params[moduleParamName] = {
            enabled: true
        };
        if (typeof params[moduleParamName] === "object" && !("enabled" in params[moduleParamName])) params[moduleParamName].enabled = true;
        if (!params[moduleParamName]) params[moduleParamName] = {
            enabled: false
        };
        (0, $2y7Cr.extend)(allModulesParams, obj);
    };
}

});


parcelRequire.register("fId9e", function(module, exports) {

var $92tgL = parcelRequire("92tgL");

var $2y7Cr = parcelRequire("2y7Cr");
function $b70529fc757428c3$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on, emit: emit }) {
    extendParams({
        virtual: {
            enabled: false,
            slides: [],
            cache: true,
            renderSlide: null,
            renderExternal: null,
            renderExternalUpdate: true,
            addSlidesBefore: 0,
            addSlidesAfter: 0
        }
    });
    let cssModeTimeout;
    swiper.virtual = {
        cache: {},
        from: undefined,
        to: undefined,
        slides: [],
        offset: 0,
        slidesGrid: []
    };
    function renderSlide(slide, index) {
        const params = swiper.params.virtual;
        if (params.cache && swiper.virtual.cache[index]) return swiper.virtual.cache[index];
        const $slideEl = params.renderSlide ? (0, $92tgL.default)(params.renderSlide.call(swiper, slide, index)) : (0, $92tgL.default)(`<div class="${swiper.params.slideClass}" data-swiper-slide-index="${index}">${slide}</div>`);
        if (!$slideEl.attr("data-swiper-slide-index")) $slideEl.attr("data-swiper-slide-index", index);
        if (params.cache) swiper.virtual.cache[index] = $slideEl;
        return $slideEl;
    }
    function update(force) {
        const { slidesPerView: slidesPerView, slidesPerGroup: slidesPerGroup, centeredSlides: centeredSlides } = swiper.params;
        const { addSlidesBefore: addSlidesBefore, addSlidesAfter: addSlidesAfter } = swiper.params.virtual;
        const { from: previousFrom, to: previousTo, slides: slides, slidesGrid: previousSlidesGrid, offset: previousOffset } = swiper.virtual;
        if (!swiper.params.cssMode) swiper.updateActiveIndex();
        const activeIndex = swiper.activeIndex || 0;
        let offsetProp;
        if (swiper.rtlTranslate) offsetProp = "right";
        else offsetProp = swiper.isHorizontal() ? "left" : "top";
        let slidesAfter;
        let slidesBefore;
        if (centeredSlides) {
            slidesAfter = Math.floor(slidesPerView / 2) + slidesPerGroup + addSlidesAfter;
            slidesBefore = Math.floor(slidesPerView / 2) + slidesPerGroup + addSlidesBefore;
        } else {
            slidesAfter = slidesPerView + (slidesPerGroup - 1) + addSlidesAfter;
            slidesBefore = slidesPerGroup + addSlidesBefore;
        }
        const from = Math.max((activeIndex || 0) - slidesBefore, 0);
        const to = Math.min((activeIndex || 0) + slidesAfter, slides.length - 1);
        const offset = (swiper.slidesGrid[from] || 0) - (swiper.slidesGrid[0] || 0);
        Object.assign(swiper.virtual, {
            from: from,
            to: to,
            offset: offset,
            slidesGrid: swiper.slidesGrid
        });
        function onRendered() {
            swiper.updateSlides();
            swiper.updateProgress();
            swiper.updateSlidesClasses();
            if (swiper.lazy && swiper.params.lazy.enabled) swiper.lazy.load();
            emit("virtualUpdate");
        }
        if (previousFrom === from && previousTo === to && !force) {
            if (swiper.slidesGrid !== previousSlidesGrid && offset !== previousOffset) swiper.slides.css(offsetProp, `${offset}px`);
            swiper.updateProgress();
            emit("virtualUpdate");
            return;
        }
        if (swiper.params.virtual.renderExternal) {
            swiper.params.virtual.renderExternal.call(swiper, {
                offset: offset,
                from: from,
                to: to,
                slides: function getSlides() {
                    const slidesToRender = [];
                    for(let i = from; i <= to; i += 1)slidesToRender.push(slides[i]);
                    return slidesToRender;
                }()
            });
            if (swiper.params.virtual.renderExternalUpdate) onRendered();
            else emit("virtualUpdate");
            return;
        }
        const prependIndexes = [];
        const appendIndexes = [];
        if (force) swiper.$wrapperEl.find(`.${swiper.params.slideClass}`).remove();
        else {
            for(let i = previousFrom; i <= previousTo; i += 1)if (i < from || i > to) swiper.$wrapperEl.find(`.${swiper.params.slideClass}[data-swiper-slide-index="${i}"]`).remove();
        }
        for(let i = 0; i < slides.length; i += 1)if (i >= from && i <= to) {
            if (typeof previousTo === "undefined" || force) appendIndexes.push(i);
            else {
                if (i > previousTo) appendIndexes.push(i);
                if (i < previousFrom) prependIndexes.push(i);
            }
        }
        appendIndexes.forEach((index)=>{
            swiper.$wrapperEl.append(renderSlide(slides[index], index));
        });
        prependIndexes.sort((a, b)=>b - a).forEach((index)=>{
            swiper.$wrapperEl.prepend(renderSlide(slides[index], index));
        });
        swiper.$wrapperEl.children(".swiper-slide").css(offsetProp, `${offset}px`);
        onRendered();
    }
    function appendSlide(slides) {
        if (typeof slides === "object" && "length" in slides) {
            for(let i = 0; i < slides.length; i += 1)if (slides[i]) swiper.virtual.slides.push(slides[i]);
        } else swiper.virtual.slides.push(slides);
        update(true);
    }
    function prependSlide(slides) {
        const activeIndex = swiper.activeIndex;
        let newActiveIndex = activeIndex + 1;
        let numberOfNewSlides = 1;
        if (Array.isArray(slides)) {
            for(let i = 0; i < slides.length; i += 1)if (slides[i]) swiper.virtual.slides.unshift(slides[i]);
            newActiveIndex = activeIndex + slides.length;
            numberOfNewSlides = slides.length;
        } else swiper.virtual.slides.unshift(slides);
        if (swiper.params.virtual.cache) {
            const cache = swiper.virtual.cache;
            const newCache = {};
            Object.keys(cache).forEach((cachedIndex)=>{
                const $cachedEl = cache[cachedIndex];
                const cachedElIndex = $cachedEl.attr("data-swiper-slide-index");
                if (cachedElIndex) $cachedEl.attr("data-swiper-slide-index", parseInt(cachedElIndex, 10) + numberOfNewSlides);
                newCache[parseInt(cachedIndex, 10) + numberOfNewSlides] = $cachedEl;
            });
            swiper.virtual.cache = newCache;
        }
        update(true);
        swiper.slideTo(newActiveIndex, 0);
    }
    function removeSlide(slidesIndexes) {
        if (typeof slidesIndexes === "undefined" || slidesIndexes === null) return;
        let activeIndex = swiper.activeIndex;
        if (Array.isArray(slidesIndexes)) for(let i = slidesIndexes.length - 1; i >= 0; i -= 1){
            swiper.virtual.slides.splice(slidesIndexes[i], 1);
            if (swiper.params.virtual.cache) delete swiper.virtual.cache[slidesIndexes[i]];
            if (slidesIndexes[i] < activeIndex) activeIndex -= 1;
            activeIndex = Math.max(activeIndex, 0);
        }
        else {
            swiper.virtual.slides.splice(slidesIndexes, 1);
            if (swiper.params.virtual.cache) delete swiper.virtual.cache[slidesIndexes];
            if (slidesIndexes < activeIndex) activeIndex -= 1;
            activeIndex = Math.max(activeIndex, 0);
        }
        update(true);
        swiper.slideTo(activeIndex, 0);
    }
    function removeAllSlides() {
        swiper.virtual.slides = [];
        if (swiper.params.virtual.cache) swiper.virtual.cache = {};
        update(true);
        swiper.slideTo(0, 0);
    }
    on("beforeInit", ()=>{
        if (!swiper.params.virtual.enabled) return;
        swiper.virtual.slides = swiper.params.virtual.slides;
        swiper.classNames.push(`${swiper.params.containerModifierClass}virtual`);
        swiper.params.watchSlidesProgress = true;
        swiper.originalParams.watchSlidesProgress = true;
        if (!swiper.params.initialSlide) update();
    });
    on("setTranslate", ()=>{
        if (!swiper.params.virtual.enabled) return;
        if (swiper.params.cssMode && !swiper._immediateVirtual) {
            clearTimeout(cssModeTimeout);
            cssModeTimeout = setTimeout(()=>{
                update();
            }, 100);
        } else update();
    });
    on("init update resize", ()=>{
        if (!swiper.params.virtual.enabled) return;
        if (swiper.params.cssMode) (0, $2y7Cr.setCSSProperty)(swiper.wrapperEl, "--swiper-virtual-size", `${swiper.virtualSize}px`);
    });
    Object.assign(swiper.virtual, {
        appendSlide: appendSlide,
        prependSlide: prependSlide,
        removeSlide: removeSlide,
        removeAllSlides: removeAllSlides,
        update: update
    });
}

});

parcelRequire.register("dHlcP", function(module, exports) {

$parcel$export(module.exports, "default", () => $9f8fbd971b031f45$export$2e2bcd8739ae039);
/* eslint-disable consistent-return */ 
var $bkUxr = parcelRequire("bkUxr");

var $92tgL = parcelRequire("92tgL");
function $9f8fbd971b031f45$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on, emit: emit }) {
    const document = (0, $bkUxr.getDocument)();
    const window = (0, $bkUxr.getWindow)();
    swiper.keyboard = {
        enabled: false
    };
    extendParams({
        keyboard: {
            enabled: false,
            onlyInViewport: true,
            pageUpDown: true
        }
    });
    function handle(event) {
        if (!swiper.enabled) return;
        const { rtlTranslate: rtl } = swiper;
        let e = event;
        if (e.originalEvent) e = e.originalEvent; // jquery fix
        const kc = e.keyCode || e.charCode;
        const pageUpDown = swiper.params.keyboard.pageUpDown;
        const isPageUp = pageUpDown && kc === 33;
        const isPageDown = pageUpDown && kc === 34;
        const isArrowLeft = kc === 37;
        const isArrowRight = kc === 39;
        const isArrowUp = kc === 38;
        const isArrowDown = kc === 40; // Directions locks
        if (!swiper.allowSlideNext && (swiper.isHorizontal() && isArrowRight || swiper.isVertical() && isArrowDown || isPageDown)) return false;
        if (!swiper.allowSlidePrev && (swiper.isHorizontal() && isArrowLeft || swiper.isVertical() && isArrowUp || isPageUp)) return false;
        if (e.shiftKey || e.altKey || e.ctrlKey || e.metaKey) return undefined;
        if (document.activeElement && document.activeElement.nodeName && (document.activeElement.nodeName.toLowerCase() === "input" || document.activeElement.nodeName.toLowerCase() === "textarea")) return undefined;
        if (swiper.params.keyboard.onlyInViewport && (isPageUp || isPageDown || isArrowLeft || isArrowRight || isArrowUp || isArrowDown)) {
            let inView = false; // Check that swiper should be inside of visible area of window
            if (swiper.$el.parents(`.${swiper.params.slideClass}`).length > 0 && swiper.$el.parents(`.${swiper.params.slideActiveClass}`).length === 0) return undefined;
            const $el = swiper.$el;
            const swiperWidth = $el[0].clientWidth;
            const swiperHeight = $el[0].clientHeight;
            const windowWidth = window.innerWidth;
            const windowHeight = window.innerHeight;
            const swiperOffset = swiper.$el.offset();
            if (rtl) swiperOffset.left -= swiper.$el[0].scrollLeft;
            const swiperCoord = [
                [
                    swiperOffset.left,
                    swiperOffset.top
                ],
                [
                    swiperOffset.left + swiperWidth,
                    swiperOffset.top
                ],
                [
                    swiperOffset.left,
                    swiperOffset.top + swiperHeight
                ],
                [
                    swiperOffset.left + swiperWidth,
                    swiperOffset.top + swiperHeight
                ]
            ];
            for(let i = 0; i < swiperCoord.length; i += 1){
                const point = swiperCoord[i];
                if (point[0] >= 0 && point[0] <= windowWidth && point[1] >= 0 && point[1] <= windowHeight) {
                    if (point[0] === 0 && point[1] === 0) continue; // eslint-disable-line
                    inView = true;
                }
            }
            if (!inView) return undefined;
        }
        if (swiper.isHorizontal()) {
            if (isPageUp || isPageDown || isArrowLeft || isArrowRight) {
                if (e.preventDefault) e.preventDefault();
                else e.returnValue = false;
            }
            if ((isPageDown || isArrowRight) && !rtl || (isPageUp || isArrowLeft) && rtl) swiper.slideNext();
            if ((isPageUp || isArrowLeft) && !rtl || (isPageDown || isArrowRight) && rtl) swiper.slidePrev();
        } else {
            if (isPageUp || isPageDown || isArrowUp || isArrowDown) {
                if (e.preventDefault) e.preventDefault();
                else e.returnValue = false;
            }
            if (isPageDown || isArrowDown) swiper.slideNext();
            if (isPageUp || isArrowUp) swiper.slidePrev();
        }
        emit("keyPress", kc);
        return undefined;
    }
    function enable() {
        if (swiper.keyboard.enabled) return;
        (0, $92tgL.default)(document).on("keydown", handle);
        swiper.keyboard.enabled = true;
    }
    function disable() {
        if (!swiper.keyboard.enabled) return;
        (0, $92tgL.default)(document).off("keydown", handle);
        swiper.keyboard.enabled = false;
    }
    on("init", ()=>{
        if (swiper.params.keyboard.enabled) enable();
    });
    on("destroy", ()=>{
        if (swiper.keyboard.enabled) disable();
    });
    Object.assign(swiper.keyboard, {
        enable: enable,
        disable: disable
    });
}

});

parcelRequire.register("aCJAI", function(module, exports) {
/* eslint-disable consistent-return */ 
var $bkUxr = parcelRequire("bkUxr");

var $92tgL = parcelRequire("92tgL");

var $2y7Cr = parcelRequire("2y7Cr");
function $7bc0d17814145e90$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on, emit: emit }) {
    const window = (0, $bkUxr.getWindow)();
    extendParams({
        mousewheel: {
            enabled: false,
            releaseOnEdges: false,
            invert: false,
            forceToAxis: false,
            sensitivity: 1,
            eventsTarget: "container",
            thresholdDelta: null,
            thresholdTime: null
        }
    });
    swiper.mousewheel = {
        enabled: false
    };
    let timeout;
    let lastScrollTime = (0, $2y7Cr.now)();
    let lastEventBeforeSnap;
    const recentWheelEvents = [];
    function normalize(e) {
        // Reasonable defaults
        const PIXEL_STEP = 10;
        const LINE_HEIGHT = 40;
        const PAGE_HEIGHT = 800;
        let sX = 0;
        let sY = 0; // spinX, spinY
        let pX = 0;
        let pY = 0; // pixelX, pixelY
        // Legacy
        if ("detail" in e) sY = e.detail;
        if ("wheelDelta" in e) sY = -e.wheelDelta / 120;
        if ("wheelDeltaY" in e) sY = -e.wheelDeltaY / 120;
        if ("wheelDeltaX" in e) sX = -e.wheelDeltaX / 120;
         // side scrolling on FF with DOMMouseScroll
        if ("axis" in e && e.axis === e.HORIZONTAL_AXIS) {
            sX = sY;
            sY = 0;
        }
        pX = sX * PIXEL_STEP;
        pY = sY * PIXEL_STEP;
        if ("deltaY" in e) pY = e.deltaY;
        if ("deltaX" in e) pX = e.deltaX;
        if (e.shiftKey && !pX) {
            // if user scrolls with shift he wants horizontal scroll
            pX = pY;
            pY = 0;
        }
        if ((pX || pY) && e.deltaMode) {
            if (e.deltaMode === 1) {
                // delta in LINE units
                pX *= LINE_HEIGHT;
                pY *= LINE_HEIGHT;
            } else {
                // delta in PAGE units
                pX *= PAGE_HEIGHT;
                pY *= PAGE_HEIGHT;
            }
        } // Fall-back if spin cannot be determined
        if (pX && !sX) sX = pX < 1 ? -1 : 1;
        if (pY && !sY) sY = pY < 1 ? -1 : 1;
        return {
            spinX: sX,
            spinY: sY,
            pixelX: pX,
            pixelY: pY
        };
    }
    function handleMouseEnter() {
        if (!swiper.enabled) return;
        swiper.mouseEntered = true;
    }
    function handleMouseLeave() {
        if (!swiper.enabled) return;
        swiper.mouseEntered = false;
    }
    function animateSlider(newEvent) {
        if (swiper.params.mousewheel.thresholdDelta && newEvent.delta < swiper.params.mousewheel.thresholdDelta) // Prevent if delta of wheel scroll delta is below configured threshold
        return false;
        if (swiper.params.mousewheel.thresholdTime && (0, $2y7Cr.now)() - lastScrollTime < swiper.params.mousewheel.thresholdTime) // Prevent if time between scrolls is below configured threshold
        return false;
         // If the movement is NOT big enough and
        // if the last time the user scrolled was too close to the current one (avoid continuously triggering the slider):
        //   Don't go any further (avoid insignificant scroll movement).
        if (newEvent.delta >= 6 && (0, $2y7Cr.now)() - lastScrollTime < 60) // Return false as a default
        return true;
         // If user is scrolling towards the end:
        //   If the slider hasn't hit the latest slide or
        //   if the slider is a loop and
        //   if the slider isn't moving right now:
        //     Go to next slide and
        //     emit a scroll event.
        // Else (the user is scrolling towards the beginning) and
        // if the slider hasn't hit the first slide or
        // if the slider is a loop and
        // if the slider isn't moving right now:
        //   Go to prev slide and
        //   emit a scroll event.
        if (newEvent.direction < 0) {
            if ((!swiper.isEnd || swiper.params.loop) && !swiper.animating) {
                swiper.slideNext();
                emit("scroll", newEvent.raw);
            }
        } else if ((!swiper.isBeginning || swiper.params.loop) && !swiper.animating) {
            swiper.slidePrev();
            emit("scroll", newEvent.raw);
        } // If you got here is because an animation has been triggered so store the current time
        lastScrollTime = new window.Date().getTime(); // Return false as a default
        return false;
    }
    function releaseScroll(newEvent) {
        const params = swiper.params.mousewheel;
        if (newEvent.direction < 0) {
            if (swiper.isEnd && !swiper.params.loop && params.releaseOnEdges) // Return true to animate scroll on edges
            return true;
        } else if (swiper.isBeginning && !swiper.params.loop && params.releaseOnEdges) // Return true to animate scroll on edges
        return true;
        return false;
    }
    function handle(event1) {
        let e = event1;
        let disableParentSwiper = true;
        if (!swiper.enabled) return;
        const params = swiper.params.mousewheel;
        if (swiper.params.cssMode) e.preventDefault();
        let target = swiper.$el;
        if (swiper.params.mousewheel.eventsTarget !== "container") target = (0, $92tgL.default)(swiper.params.mousewheel.eventsTarget);
        if (!swiper.mouseEntered && !target[0].contains(e.target) && !params.releaseOnEdges) return true;
        if (e.originalEvent) e = e.originalEvent; // jquery fix
        let delta = 0;
        const rtlFactor = swiper.rtlTranslate ? -1 : 1;
        const data = normalize(e);
        if (params.forceToAxis) {
            if (swiper.isHorizontal()) {
                if (Math.abs(data.pixelX) > Math.abs(data.pixelY)) delta = -data.pixelX * rtlFactor;
                else return true;
            } else if (Math.abs(data.pixelY) > Math.abs(data.pixelX)) delta = -data.pixelY;
            else return true;
        } else delta = Math.abs(data.pixelX) > Math.abs(data.pixelY) ? -data.pixelX * rtlFactor : -data.pixelY;
        if (delta === 0) return true;
        if (params.invert) delta = -delta; // Get the scroll positions
        let positions = swiper.getTranslate() + delta * params.sensitivity;
        if (positions >= swiper.minTranslate()) positions = swiper.minTranslate();
        if (positions <= swiper.maxTranslate()) positions = swiper.maxTranslate(); // When loop is true:
        //     the disableParentSwiper will be true.
        // When loop is false:
        //     if the scroll positions is not on edge,
        //     then the disableParentSwiper will be true.
        //     if the scroll on edge positions,
        //     then the disableParentSwiper will be false.
        disableParentSwiper = swiper.params.loop ? true : !(positions === swiper.minTranslate() || positions === swiper.maxTranslate());
        if (disableParentSwiper && swiper.params.nested) e.stopPropagation();
        if (!swiper.params.freeMode || !swiper.params.freeMode.enabled) {
            // Register the new event in a variable which stores the relevant data
            const newEvent = {
                time: (0, $2y7Cr.now)(),
                delta: Math.abs(delta),
                direction: Math.sign(delta),
                raw: event1
            }; // Keep the most recent events
            if (recentWheelEvents.length >= 2) recentWheelEvents.shift(); // only store the last N events
            const prevEvent = recentWheelEvents.length ? recentWheelEvents[recentWheelEvents.length - 1] : undefined;
            recentWheelEvents.push(newEvent); // If there is at least one previous recorded event:
            //   If direction has changed or
            //   if the scroll is quicker than the previous one:
            //     Animate the slider.
            // Else (this is the first time the wheel is moved):
            //     Animate the slider.
            if (prevEvent) {
                if (newEvent.direction !== prevEvent.direction || newEvent.delta > prevEvent.delta || newEvent.time > prevEvent.time + 150) animateSlider(newEvent);
            } else animateSlider(newEvent);
             // If it's time to release the scroll:
            //   Return now so you don't hit the preventDefault.
            if (releaseScroll(newEvent)) return true;
        } else {
            // Freemode or scrollContainer:
            // If we recently snapped after a momentum scroll, then ignore wheel events
            // to give time for the deceleration to finish. Stop ignoring after 500 msecs
            // or if it's a new scroll (larger delta or inverse sign as last event before
            // an end-of-momentum snap).
            const newEvent = {
                time: (0, $2y7Cr.now)(),
                delta: Math.abs(delta),
                direction: Math.sign(delta)
            };
            const ignoreWheelEvents = lastEventBeforeSnap && newEvent.time < lastEventBeforeSnap.time + 500 && newEvent.delta <= lastEventBeforeSnap.delta && newEvent.direction === lastEventBeforeSnap.direction;
            if (!ignoreWheelEvents) {
                lastEventBeforeSnap = undefined;
                if (swiper.params.loop) swiper.loopFix();
                let position = swiper.getTranslate() + delta * params.sensitivity;
                const wasBeginning = swiper.isBeginning;
                const wasEnd = swiper.isEnd;
                if (position >= swiper.minTranslate()) position = swiper.minTranslate();
                if (position <= swiper.maxTranslate()) position = swiper.maxTranslate();
                swiper.setTransition(0);
                swiper.setTranslate(position);
                swiper.updateProgress();
                swiper.updateActiveIndex();
                swiper.updateSlidesClasses();
                if (!wasBeginning && swiper.isBeginning || !wasEnd && swiper.isEnd) swiper.updateSlidesClasses();
                if (swiper.params.freeMode.sticky) {
                    // When wheel scrolling starts with sticky (aka snap) enabled, then detect
                    // the end of a momentum scroll by storing recent (N=15?) wheel events.
                    // 1. do all N events have decreasing or same (absolute value) delta?
                    // 2. did all N events arrive in the last M (M=500?) msecs?
                    // 3. does the earliest event have an (absolute value) delta that's
                    //    at least P (P=1?) larger than the most recent event's delta?
                    // 4. does the latest event have a delta that's smaller than Q (Q=6?) pixels?
                    // If 1-4 are "yes" then we're near the end of a momentum scroll deceleration.
                    // Snap immediately and ignore remaining wheel events in this scroll.
                    // See comment above for "remaining wheel events in this scroll" determination.
                    // If 1-4 aren't satisfied, then wait to snap until 500ms after the last event.
                    clearTimeout(timeout);
                    timeout = undefined;
                    if (recentWheelEvents.length >= 15) recentWheelEvents.shift(); // only store the last N events
                    const prevEvent = recentWheelEvents.length ? recentWheelEvents[recentWheelEvents.length - 1] : undefined;
                    const firstEvent = recentWheelEvents[0];
                    recentWheelEvents.push(newEvent);
                    if (prevEvent && (newEvent.delta > prevEvent.delta || newEvent.direction !== prevEvent.direction)) // Increasing or reverse-sign delta means the user started scrolling again. Clear the wheel event log.
                    recentWheelEvents.splice(0);
                    else if (recentWheelEvents.length >= 15 && newEvent.time - firstEvent.time < 500 && firstEvent.delta - newEvent.delta >= 1 && newEvent.delta <= 6) {
                        // We're at the end of the deceleration of a momentum scroll, so there's no need
                        // to wait for more events. Snap ASAP on the next tick.
                        // Also, because there's some remaining momentum we'll bias the snap in the
                        // direction of the ongoing scroll because it's better UX for the scroll to snap
                        // in the same direction as the scroll instead of reversing to snap.  Therefore,
                        // if it's already scrolled more than 20% in the current direction, keep going.
                        const snapToThreshold = delta > 0 ? 0.8 : 0.2;
                        lastEventBeforeSnap = newEvent;
                        recentWheelEvents.splice(0);
                        timeout = (0, $2y7Cr.nextTick)(()=>{
                            swiper.slideToClosest(swiper.params.speed, true, undefined, snapToThreshold);
                        }, 0); // no delay; move on next tick
                    }
                    if (!timeout) // if we get here, then we haven't detected the end of a momentum scroll, so
                    // we'll consider a scroll "complete" when there haven't been any wheel events
                    // for 500ms.
                    timeout = (0, $2y7Cr.nextTick)(()=>{
                        const snapToThreshold = 0.5;
                        lastEventBeforeSnap = newEvent;
                        recentWheelEvents.splice(0);
                        swiper.slideToClosest(swiper.params.speed, true, undefined, snapToThreshold);
                    }, 500);
                } // Emit event
                if (!ignoreWheelEvents) emit("scroll", e); // Stop autoplay
                if (swiper.params.autoplay && swiper.params.autoplayDisableOnInteraction) swiper.autoplay.stop(); // Return page scroll on edge positions
                if (position === swiper.minTranslate() || position === swiper.maxTranslate()) return true;
            }
        }
        if (e.preventDefault) e.preventDefault();
        else e.returnValue = false;
        return false;
    }
    function events(method) {
        let target = swiper.$el;
        if (swiper.params.mousewheel.eventsTarget !== "container") target = (0, $92tgL.default)(swiper.params.mousewheel.eventsTarget);
        target[method]("mouseenter", handleMouseEnter);
        target[method]("mouseleave", handleMouseLeave);
        target[method]("wheel", handle);
    }
    function enable() {
        if (swiper.params.cssMode) {
            swiper.wrapperEl.removeEventListener("wheel", handle);
            return true;
        }
        if (swiper.mousewheel.enabled) return false;
        events("on");
        swiper.mousewheel.enabled = true;
        return true;
    }
    function disable() {
        if (swiper.params.cssMode) {
            swiper.wrapperEl.addEventListener(event, handle);
            return true;
        }
        if (!swiper.mousewheel.enabled) return false;
        events("off");
        swiper.mousewheel.enabled = false;
        return true;
    }
    on("init", ()=>{
        if (!swiper.params.mousewheel.enabled && swiper.params.cssMode) disable();
        if (swiper.params.mousewheel.enabled) enable();
    });
    on("destroy", ()=>{
        if (swiper.params.cssMode) enable();
        if (swiper.mousewheel.enabled) disable();
    });
    Object.assign(swiper.mousewheel, {
        enable: enable,
        disable: disable
    });
}

});

parcelRequire.register("eRV5Q", function(module, exports) {

$parcel$export(module.exports, "default", () => $ad324d77250bdb18$export$2e2bcd8739ae039);

var $al50b = parcelRequire("al50b");

var $92tgL = parcelRequire("92tgL");
function $ad324d77250bdb18$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on, emit: emit }) {
    extendParams({
        navigation: {
            nextEl: null,
            prevEl: null,
            hideOnClick: false,
            disabledClass: "swiper-button-disabled",
            hiddenClass: "swiper-button-hidden",
            lockClass: "swiper-button-lock",
            navigationDisabledClass: "swiper-navigation-disabled"
        }
    });
    swiper.navigation = {
        nextEl: null,
        $nextEl: null,
        prevEl: null,
        $prevEl: null
    };
    function getEl(el) {
        let $el;
        if (el) {
            $el = (0, $92tgL.default)(el);
            if (swiper.params.uniqueNavElements && typeof el === "string" && $el.length > 1 && swiper.$el.find(el).length === 1) $el = swiper.$el.find(el);
        }
        return $el;
    }
    function toggleEl($el, disabled) {
        const params = swiper.params.navigation;
        if ($el && $el.length > 0) {
            $el[disabled ? "addClass" : "removeClass"](params.disabledClass);
            if ($el[0] && $el[0].tagName === "BUTTON") $el[0].disabled = disabled;
            if (swiper.params.watchOverflow && swiper.enabled) $el[swiper.isLocked ? "addClass" : "removeClass"](params.lockClass);
        }
    }
    function update() {
        // Update Navigation Buttons
        if (swiper.params.loop) return;
        const { $nextEl: $nextEl, $prevEl: $prevEl } = swiper.navigation;
        toggleEl($prevEl, swiper.isBeginning && !swiper.params.rewind);
        toggleEl($nextEl, swiper.isEnd && !swiper.params.rewind);
    }
    function onPrevClick(e) {
        e.preventDefault();
        if (swiper.isBeginning && !swiper.params.loop && !swiper.params.rewind) return;
        swiper.slidePrev();
        emit("navigationPrev");
    }
    function onNextClick(e) {
        e.preventDefault();
        if (swiper.isEnd && !swiper.params.loop && !swiper.params.rewind) return;
        swiper.slideNext();
        emit("navigationNext");
    }
    function init() {
        const params = swiper.params.navigation;
        swiper.params.navigation = (0, $al50b.default)(swiper, swiper.originalParams.navigation, swiper.params.navigation, {
            nextEl: "swiper-button-next",
            prevEl: "swiper-button-prev"
        });
        if (!(params.nextEl || params.prevEl)) return;
        const $nextEl = getEl(params.nextEl);
        const $prevEl = getEl(params.prevEl);
        if ($nextEl && $nextEl.length > 0) $nextEl.on("click", onNextClick);
        if ($prevEl && $prevEl.length > 0) $prevEl.on("click", onPrevClick);
        Object.assign(swiper.navigation, {
            $nextEl: $nextEl,
            nextEl: $nextEl && $nextEl[0],
            $prevEl: $prevEl,
            prevEl: $prevEl && $prevEl[0]
        });
        if (!swiper.enabled) {
            if ($nextEl) $nextEl.addClass(params.lockClass);
            if ($prevEl) $prevEl.addClass(params.lockClass);
        }
    }
    function destroy() {
        const { $nextEl: $nextEl, $prevEl: $prevEl } = swiper.navigation;
        if ($nextEl && $nextEl.length) {
            $nextEl.off("click", onNextClick);
            $nextEl.removeClass(swiper.params.navigation.disabledClass);
        }
        if ($prevEl && $prevEl.length) {
            $prevEl.off("click", onPrevClick);
            $prevEl.removeClass(swiper.params.navigation.disabledClass);
        }
    }
    on("init", ()=>{
        if (swiper.params.navigation.enabled === false) // eslint-disable-next-line
        disable();
        else {
            init();
            update();
        }
    });
    on("toEdge fromEdge lock unlock", ()=>{
        update();
    });
    on("destroy", ()=>{
        destroy();
    });
    on("enable disable", ()=>{
        const { $nextEl: $nextEl, $prevEl: $prevEl } = swiper.navigation;
        if ($nextEl) $nextEl[swiper.enabled ? "removeClass" : "addClass"](swiper.params.navigation.lockClass);
        if ($prevEl) $prevEl[swiper.enabled ? "removeClass" : "addClass"](swiper.params.navigation.lockClass);
    });
    on("click", (_s, e)=>{
        const { $nextEl: $nextEl, $prevEl: $prevEl } = swiper.navigation;
        const targetEl = e.target;
        if (swiper.params.navigation.hideOnClick && !(0, $92tgL.default)(targetEl).is($prevEl) && !(0, $92tgL.default)(targetEl).is($nextEl)) {
            if (swiper.pagination && swiper.params.pagination && swiper.params.pagination.clickable && (swiper.pagination.el === targetEl || swiper.pagination.el.contains(targetEl))) return;
            let isHidden;
            if ($nextEl) isHidden = $nextEl.hasClass(swiper.params.navigation.hiddenClass);
            else if ($prevEl) isHidden = $prevEl.hasClass(swiper.params.navigation.hiddenClass);
            if (isHidden === true) emit("navigationShow");
            else emit("navigationHide");
            if ($nextEl) $nextEl.toggleClass(swiper.params.navigation.hiddenClass);
            if ($prevEl) $prevEl.toggleClass(swiper.params.navigation.hiddenClass);
        }
    });
    const enable = ()=>{
        swiper.$el.removeClass(swiper.params.navigation.navigationDisabledClass);
        init();
        update();
    };
    const disable = ()=>{
        swiper.$el.addClass(swiper.params.navigation.navigationDisabledClass);
        destroy();
    };
    Object.assign(swiper.navigation, {
        enable: enable,
        disable: disable,
        update: update,
        init: init,
        destroy: destroy
    });
}

});
parcelRequire.register("al50b", function(module, exports) {

$parcel$export(module.exports, "default", () => $786fbed38f308381$export$2e2bcd8739ae039);

var $bkUxr = parcelRequire("bkUxr");
function $786fbed38f308381$export$2e2bcd8739ae039(swiper, originalParams, params, checkProps) {
    const document = (0, $bkUxr.getDocument)();
    if (swiper.params.createElements) Object.keys(checkProps).forEach((key)=>{
        if (!params[key] && params.auto === true) {
            let element = swiper.$el.children(`.${checkProps[key]}`)[0];
            if (!element) {
                element = document.createElement("div");
                element.className = checkProps[key];
                swiper.$el.append(element);
            }
            params[key] = element;
            originalParams[key] = element;
        }
    });
    return params;
}

});


parcelRequire.register("fBOh1", function(module, exports) {

$parcel$export(module.exports, "default", () => $b5d14f012fc02b4f$export$2e2bcd8739ae039);

var $92tgL = parcelRequire("92tgL");

var $gfE23 = parcelRequire("gfE23");

var $al50b = parcelRequire("al50b");
function $b5d14f012fc02b4f$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on, emit: emit }) {
    const pfx = "swiper-pagination";
    extendParams({
        pagination: {
            el: null,
            bulletElement: "span",
            clickable: false,
            hideOnClick: false,
            renderBullet: null,
            renderProgressbar: null,
            renderFraction: null,
            renderCustom: null,
            progressbarOpposite: false,
            type: "bullets",
            // 'bullets' or 'progressbar' or 'fraction' or 'custom'
            dynamicBullets: false,
            dynamicMainBullets: 1,
            formatFractionCurrent: (number)=>number,
            formatFractionTotal: (number)=>number,
            bulletClass: `${pfx}-bullet`,
            bulletActiveClass: `${pfx}-bullet-active`,
            modifierClass: `${pfx}-`,
            currentClass: `${pfx}-current`,
            totalClass: `${pfx}-total`,
            hiddenClass: `${pfx}-hidden`,
            progressbarFillClass: `${pfx}-progressbar-fill`,
            progressbarOppositeClass: `${pfx}-progressbar-opposite`,
            clickableClass: `${pfx}-clickable`,
            lockClass: `${pfx}-lock`,
            horizontalClass: `${pfx}-horizontal`,
            verticalClass: `${pfx}-vertical`,
            paginationDisabledClass: `${pfx}-disabled`
        }
    });
    swiper.pagination = {
        el: null,
        $el: null,
        bullets: []
    };
    let bulletSize;
    let dynamicBulletIndex = 0;
    function isPaginationDisabled() {
        return !swiper.params.pagination.el || !swiper.pagination.el || !swiper.pagination.$el || swiper.pagination.$el.length === 0;
    }
    function setSideBullets($bulletEl, position) {
        const { bulletActiveClass: bulletActiveClass } = swiper.params.pagination;
        $bulletEl[position]().addClass(`${bulletActiveClass}-${position}`)[position]().addClass(`${bulletActiveClass}-${position}-${position}`);
    }
    function update() {
        // Render || Update Pagination bullets/items
        const rtl = swiper.rtl;
        const params = swiper.params.pagination;
        if (isPaginationDisabled()) return;
        const slidesLength = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.slides.length : swiper.slides.length;
        const $el = swiper.pagination.$el; // Current/Total
        let current;
        const total = swiper.params.loop ? Math.ceil((slidesLength - swiper.loopedSlides * 2) / swiper.params.slidesPerGroup) : swiper.snapGrid.length;
        if (swiper.params.loop) {
            current = Math.ceil((swiper.activeIndex - swiper.loopedSlides) / swiper.params.slidesPerGroup);
            if (current > slidesLength - 1 - swiper.loopedSlides * 2) current -= slidesLength - swiper.loopedSlides * 2;
            if (current > total - 1) current -= total;
            if (current < 0 && swiper.params.paginationType !== "bullets") current = total + current;
        } else if (typeof swiper.snapIndex !== "undefined") current = swiper.snapIndex;
        else current = swiper.activeIndex || 0;
         // Types
        if (params.type === "bullets" && swiper.pagination.bullets && swiper.pagination.bullets.length > 0) {
            const bullets = swiper.pagination.bullets;
            let firstIndex;
            let lastIndex;
            let midIndex;
            if (params.dynamicBullets) {
                bulletSize = bullets.eq(0)[swiper.isHorizontal() ? "outerWidth" : "outerHeight"](true);
                $el.css(swiper.isHorizontal() ? "width" : "height", `${bulletSize * (params.dynamicMainBullets + 4)}px`);
                if (params.dynamicMainBullets > 1 && swiper.previousIndex !== undefined) {
                    dynamicBulletIndex += current - (swiper.previousIndex - swiper.loopedSlides || 0);
                    if (dynamicBulletIndex > params.dynamicMainBullets - 1) dynamicBulletIndex = params.dynamicMainBullets - 1;
                    else if (dynamicBulletIndex < 0) dynamicBulletIndex = 0;
                }
                firstIndex = Math.max(current - dynamicBulletIndex, 0);
                lastIndex = firstIndex + (Math.min(bullets.length, params.dynamicMainBullets) - 1);
                midIndex = (lastIndex + firstIndex) / 2;
            }
            bullets.removeClass([
                "",
                "-next",
                "-next-next",
                "-prev",
                "-prev-prev",
                "-main"
            ].map((suffix)=>`${params.bulletActiveClass}${suffix}`).join(" "));
            if ($el.length > 1) bullets.each((bullet)=>{
                const $bullet = (0, $92tgL.default)(bullet);
                const bulletIndex = $bullet.index();
                if (bulletIndex === current) $bullet.addClass(params.bulletActiveClass);
                if (params.dynamicBullets) {
                    if (bulletIndex >= firstIndex && bulletIndex <= lastIndex) $bullet.addClass(`${params.bulletActiveClass}-main`);
                    if (bulletIndex === firstIndex) setSideBullets($bullet, "prev");
                    if (bulletIndex === lastIndex) setSideBullets($bullet, "next");
                }
            });
            else {
                const $bullet = bullets.eq(current);
                const bulletIndex = $bullet.index();
                $bullet.addClass(params.bulletActiveClass);
                if (params.dynamicBullets) {
                    const $firstDisplayedBullet = bullets.eq(firstIndex);
                    const $lastDisplayedBullet = bullets.eq(lastIndex);
                    for(let i = firstIndex; i <= lastIndex; i += 1)bullets.eq(i).addClass(`${params.bulletActiveClass}-main`);
                    if (swiper.params.loop) {
                        if (bulletIndex >= bullets.length) {
                            for(let i = params.dynamicMainBullets; i >= 0; i -= 1)bullets.eq(bullets.length - i).addClass(`${params.bulletActiveClass}-main`);
                            bullets.eq(bullets.length - params.dynamicMainBullets - 1).addClass(`${params.bulletActiveClass}-prev`);
                        } else {
                            setSideBullets($firstDisplayedBullet, "prev");
                            setSideBullets($lastDisplayedBullet, "next");
                        }
                    } else {
                        setSideBullets($firstDisplayedBullet, "prev");
                        setSideBullets($lastDisplayedBullet, "next");
                    }
                }
            }
            if (params.dynamicBullets) {
                const dynamicBulletsLength = Math.min(bullets.length, params.dynamicMainBullets + 4);
                const bulletsOffset = (bulletSize * dynamicBulletsLength - bulletSize) / 2 - midIndex * bulletSize;
                const offsetProp = rtl ? "right" : "left";
                bullets.css(swiper.isHorizontal() ? offsetProp : "top", `${bulletsOffset}px`);
            }
        }
        if (params.type === "fraction") {
            $el.find((0, $gfE23.default)(params.currentClass)).text(params.formatFractionCurrent(current + 1));
            $el.find((0, $gfE23.default)(params.totalClass)).text(params.formatFractionTotal(total));
        }
        if (params.type === "progressbar") {
            let progressbarDirection;
            if (params.progressbarOpposite) progressbarDirection = swiper.isHorizontal() ? "vertical" : "horizontal";
            else progressbarDirection = swiper.isHorizontal() ? "horizontal" : "vertical";
            const scale = (current + 1) / total;
            let scaleX = 1;
            let scaleY = 1;
            if (progressbarDirection === "horizontal") scaleX = scale;
            else scaleY = scale;
            $el.find((0, $gfE23.default)(params.progressbarFillClass)).transform(`translate3d(0,0,0) scaleX(${scaleX}) scaleY(${scaleY})`).transition(swiper.params.speed);
        }
        if (params.type === "custom" && params.renderCustom) {
            $el.html(params.renderCustom(swiper, current + 1, total));
            emit("paginationRender", $el[0]);
        } else emit("paginationUpdate", $el[0]);
        if (swiper.params.watchOverflow && swiper.enabled) $el[swiper.isLocked ? "addClass" : "removeClass"](params.lockClass);
    }
    function render() {
        // Render Container
        const params = swiper.params.pagination;
        if (isPaginationDisabled()) return;
        const slidesLength = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.slides.length : swiper.slides.length;
        const $el = swiper.pagination.$el;
        let paginationHTML = "";
        if (params.type === "bullets") {
            let numberOfBullets = swiper.params.loop ? Math.ceil((slidesLength - swiper.loopedSlides * 2) / swiper.params.slidesPerGroup) : swiper.snapGrid.length;
            if (swiper.params.freeMode && swiper.params.freeMode.enabled && !swiper.params.loop && numberOfBullets > slidesLength) numberOfBullets = slidesLength;
            for(let i = 0; i < numberOfBullets; i += 1)if (params.renderBullet) paginationHTML += params.renderBullet.call(swiper, i, params.bulletClass);
            else paginationHTML += `<${params.bulletElement} class="${params.bulletClass}"></${params.bulletElement}>`;
            $el.html(paginationHTML);
            swiper.pagination.bullets = $el.find((0, $gfE23.default)(params.bulletClass));
        }
        if (params.type === "fraction") {
            if (params.renderFraction) paginationHTML = params.renderFraction.call(swiper, params.currentClass, params.totalClass);
            else paginationHTML = `<span class="${params.currentClass}"></span>` + " / " + `<span class="${params.totalClass}"></span>`;
            $el.html(paginationHTML);
        }
        if (params.type === "progressbar") {
            if (params.renderProgressbar) paginationHTML = params.renderProgressbar.call(swiper, params.progressbarFillClass);
            else paginationHTML = `<span class="${params.progressbarFillClass}"></span>`;
            $el.html(paginationHTML);
        }
        if (params.type !== "custom") emit("paginationRender", swiper.pagination.$el[0]);
    }
    function init() {
        swiper.params.pagination = (0, $al50b.default)(swiper, swiper.originalParams.pagination, swiper.params.pagination, {
            el: "swiper-pagination"
        });
        const params = swiper.params.pagination;
        if (!params.el) return;
        let $el = (0, $92tgL.default)(params.el);
        if ($el.length === 0) return;
        if (swiper.params.uniqueNavElements && typeof params.el === "string" && $el.length > 1) {
            $el = swiper.$el.find(params.el); // check if it belongs to another nested Swiper
            if ($el.length > 1) $el = $el.filter((el)=>{
                if ((0, $92tgL.default)(el).parents(".swiper")[0] !== swiper.el) return false;
                return true;
            });
        }
        if (params.type === "bullets" && params.clickable) $el.addClass(params.clickableClass);
        $el.addClass(params.modifierClass + params.type);
        $el.addClass(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);
        if (params.type === "bullets" && params.dynamicBullets) {
            $el.addClass(`${params.modifierClass}${params.type}-dynamic`);
            dynamicBulletIndex = 0;
            if (params.dynamicMainBullets < 1) params.dynamicMainBullets = 1;
        }
        if (params.type === "progressbar" && params.progressbarOpposite) $el.addClass(params.progressbarOppositeClass);
        if (params.clickable) $el.on("click", (0, $gfE23.default)(params.bulletClass), function onClick(e) {
            e.preventDefault();
            let index = (0, $92tgL.default)(this).index() * swiper.params.slidesPerGroup;
            if (swiper.params.loop) index += swiper.loopedSlides;
            swiper.slideTo(index);
        });
        Object.assign(swiper.pagination, {
            $el: $el,
            el: $el[0]
        });
        if (!swiper.enabled) $el.addClass(params.lockClass);
    }
    function destroy() {
        const params = swiper.params.pagination;
        if (isPaginationDisabled()) return;
        const $el = swiper.pagination.$el;
        $el.removeClass(params.hiddenClass);
        $el.removeClass(params.modifierClass + params.type);
        $el.removeClass(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);
        if (swiper.pagination.bullets && swiper.pagination.bullets.removeClass) swiper.pagination.bullets.removeClass(params.bulletActiveClass);
        if (params.clickable) $el.off("click", (0, $gfE23.default)(params.bulletClass));
    }
    on("init", ()=>{
        if (swiper.params.pagination.enabled === false) // eslint-disable-next-line
        disable();
        else {
            init();
            render();
            update();
        }
    });
    on("activeIndexChange", ()=>{
        if (swiper.params.loop) update();
        else if (typeof swiper.snapIndex === "undefined") update();
    });
    on("snapIndexChange", ()=>{
        if (!swiper.params.loop) update();
    });
    on("slidesLengthChange", ()=>{
        if (swiper.params.loop) {
            render();
            update();
        }
    });
    on("snapGridLengthChange", ()=>{
        if (!swiper.params.loop) {
            render();
            update();
        }
    });
    on("destroy", ()=>{
        destroy();
    });
    on("enable disable", ()=>{
        const { $el: $el } = swiper.pagination;
        if ($el) $el[swiper.enabled ? "removeClass" : "addClass"](swiper.params.pagination.lockClass);
    });
    on("lock unlock", ()=>{
        update();
    });
    on("click", (_s, e)=>{
        const targetEl = e.target;
        const { $el: $el } = swiper.pagination;
        if (swiper.params.pagination.el && swiper.params.pagination.hideOnClick && $el && $el.length > 0 && !(0, $92tgL.default)(targetEl).hasClass(swiper.params.pagination.bulletClass)) {
            if (swiper.navigation && (swiper.navigation.nextEl && targetEl === swiper.navigation.nextEl || swiper.navigation.prevEl && targetEl === swiper.navigation.prevEl)) return;
            const isHidden = $el.hasClass(swiper.params.pagination.hiddenClass);
            if (isHidden === true) emit("paginationShow");
            else emit("paginationHide");
            $el.toggleClass(swiper.params.pagination.hiddenClass);
        }
    });
    const enable = ()=>{
        swiper.$el.removeClass(swiper.params.pagination.paginationDisabledClass);
        if (swiper.pagination.$el) swiper.pagination.$el.removeClass(swiper.params.pagination.paginationDisabledClass);
        init();
        render();
        update();
    };
    const disable = ()=>{
        swiper.$el.addClass(swiper.params.pagination.paginationDisabledClass);
        if (swiper.pagination.$el) swiper.pagination.$el.addClass(swiper.params.pagination.paginationDisabledClass);
        destroy();
    };
    Object.assign(swiper.pagination, {
        enable: enable,
        disable: disable,
        render: render,
        update: update,
        init: init,
        destroy: destroy
    });
}

});
parcelRequire.register("gfE23", function(module, exports) {

$parcel$export(module.exports, "default", () => $bd4d1995ac19a6aa$export$2e2bcd8739ae039);
function $bd4d1995ac19a6aa$export$2e2bcd8739ae039(classes = "") {
    return `.${classes.trim().replace(/([\.:!\/])/g, "\\$1") // eslint-disable-line
    .replace(/ /g, ".")}`;
}

});


parcelRequire.register("5pCsG", function(module, exports) {

$parcel$export(module.exports, "default", () => $3f0d1f3fce23e33f$export$2e2bcd8739ae039);

var $bkUxr = parcelRequire("bkUxr");

var $92tgL = parcelRequire("92tgL");

var $2y7Cr = parcelRequire("2y7Cr");

var $al50b = parcelRequire("al50b");
function $3f0d1f3fce23e33f$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on, emit: emit }) {
    const document = (0, $bkUxr.getDocument)();
    let isTouched = false;
    let timeout = null;
    let dragTimeout = null;
    let dragStartPos;
    let dragSize;
    let trackSize;
    let divider;
    extendParams({
        scrollbar: {
            el: null,
            dragSize: "auto",
            hide: false,
            draggable: false,
            snapOnRelease: true,
            lockClass: "swiper-scrollbar-lock",
            dragClass: "swiper-scrollbar-drag",
            scrollbarDisabledClass: "swiper-scrollbar-disabled",
            horizontalClass: `swiper-scrollbar-horizontal`,
            verticalClass: `swiper-scrollbar-vertical`
        }
    });
    swiper.scrollbar = {
        el: null,
        dragEl: null,
        $el: null,
        $dragEl: null
    };
    function setTranslate() {
        if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
        const { scrollbar: scrollbar, rtlTranslate: rtl, progress: progress } = swiper;
        const { $dragEl: $dragEl, $el: $el } = scrollbar;
        const params = swiper.params.scrollbar;
        let newSize = dragSize;
        let newPos = (trackSize - dragSize) * progress;
        if (rtl) {
            newPos = -newPos;
            if (newPos > 0) {
                newSize = dragSize - newPos;
                newPos = 0;
            } else if (-newPos + dragSize > trackSize) newSize = trackSize + newPos;
        } else if (newPos < 0) {
            newSize = dragSize + newPos;
            newPos = 0;
        } else if (newPos + dragSize > trackSize) newSize = trackSize - newPos;
        if (swiper.isHorizontal()) {
            $dragEl.transform(`translate3d(${newPos}px, 0, 0)`);
            $dragEl[0].style.width = `${newSize}px`;
        } else {
            $dragEl.transform(`translate3d(0px, ${newPos}px, 0)`);
            $dragEl[0].style.height = `${newSize}px`;
        }
        if (params.hide) {
            clearTimeout(timeout);
            $el[0].style.opacity = 1;
            timeout = setTimeout(()=>{
                $el[0].style.opacity = 0;
                $el.transition(400);
            }, 1000);
        }
    }
    function setTransition(duration) {
        if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
        swiper.scrollbar.$dragEl.transition(duration);
    }
    function updateSize() {
        if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
        const { scrollbar: scrollbar } = swiper;
        const { $dragEl: $dragEl, $el: $el } = scrollbar;
        $dragEl[0].style.width = "";
        $dragEl[0].style.height = "";
        trackSize = swiper.isHorizontal() ? $el[0].offsetWidth : $el[0].offsetHeight;
        divider = swiper.size / (swiper.virtualSize + swiper.params.slidesOffsetBefore - (swiper.params.centeredSlides ? swiper.snapGrid[0] : 0));
        if (swiper.params.scrollbar.dragSize === "auto") dragSize = trackSize * divider;
        else dragSize = parseInt(swiper.params.scrollbar.dragSize, 10);
        if (swiper.isHorizontal()) $dragEl[0].style.width = `${dragSize}px`;
        else $dragEl[0].style.height = `${dragSize}px`;
        if (divider >= 1) $el[0].style.display = "none";
        else $el[0].style.display = "";
        if (swiper.params.scrollbar.hide) $el[0].style.opacity = 0;
        if (swiper.params.watchOverflow && swiper.enabled) scrollbar.$el[swiper.isLocked ? "addClass" : "removeClass"](swiper.params.scrollbar.lockClass);
    }
    function getPointerPosition(e) {
        if (swiper.isHorizontal()) return e.type === "touchstart" || e.type === "touchmove" ? e.targetTouches[0].clientX : e.clientX;
        return e.type === "touchstart" || e.type === "touchmove" ? e.targetTouches[0].clientY : e.clientY;
    }
    function setDragPosition(e) {
        const { scrollbar: scrollbar, rtlTranslate: rtl } = swiper;
        const { $el: $el } = scrollbar;
        let positionRatio;
        positionRatio = (getPointerPosition(e) - $el.offset()[swiper.isHorizontal() ? "left" : "top"] - (dragStartPos !== null ? dragStartPos : dragSize / 2)) / (trackSize - dragSize);
        positionRatio = Math.max(Math.min(positionRatio, 1), 0);
        if (rtl) positionRatio = 1 - positionRatio;
        const position = swiper.minTranslate() + (swiper.maxTranslate() - swiper.minTranslate()) * positionRatio;
        swiper.updateProgress(position);
        swiper.setTranslate(position);
        swiper.updateActiveIndex();
        swiper.updateSlidesClasses();
    }
    function onDragStart(e) {
        const params = swiper.params.scrollbar;
        const { scrollbar: scrollbar, $wrapperEl: $wrapperEl } = swiper;
        const { $el: $el, $dragEl: $dragEl } = scrollbar;
        isTouched = true;
        dragStartPos = e.target === $dragEl[0] || e.target === $dragEl ? getPointerPosition(e) - e.target.getBoundingClientRect()[swiper.isHorizontal() ? "left" : "top"] : null;
        e.preventDefault();
        e.stopPropagation();
        $wrapperEl.transition(100);
        $dragEl.transition(100);
        setDragPosition(e);
        clearTimeout(dragTimeout);
        $el.transition(0);
        if (params.hide) $el.css("opacity", 1);
        if (swiper.params.cssMode) swiper.$wrapperEl.css("scroll-snap-type", "none");
        emit("scrollbarDragStart", e);
    }
    function onDragMove(e) {
        const { scrollbar: scrollbar, $wrapperEl: $wrapperEl } = swiper;
        const { $el: $el, $dragEl: $dragEl } = scrollbar;
        if (!isTouched) return;
        if (e.preventDefault) e.preventDefault();
        else e.returnValue = false;
        setDragPosition(e);
        $wrapperEl.transition(0);
        $el.transition(0);
        $dragEl.transition(0);
        emit("scrollbarDragMove", e);
    }
    function onDragEnd(e) {
        const params = swiper.params.scrollbar;
        const { scrollbar: scrollbar, $wrapperEl: $wrapperEl } = swiper;
        const { $el: $el } = scrollbar;
        if (!isTouched) return;
        isTouched = false;
        if (swiper.params.cssMode) {
            swiper.$wrapperEl.css("scroll-snap-type", "");
            $wrapperEl.transition("");
        }
        if (params.hide) {
            clearTimeout(dragTimeout);
            dragTimeout = (0, $2y7Cr.nextTick)(()=>{
                $el.css("opacity", 0);
                $el.transition(400);
            }, 1000);
        }
        emit("scrollbarDragEnd", e);
        if (params.snapOnRelease) swiper.slideToClosest();
    }
    function events(method) {
        const { scrollbar: scrollbar, touchEventsTouch: touchEventsTouch, touchEventsDesktop: touchEventsDesktop, params: params, support: support } = swiper;
        const $el = scrollbar.$el;
        if (!$el) return;
        const target = $el[0];
        const activeListener = support.passiveListener && params.passiveListeners ? {
            passive: false,
            capture: false
        } : false;
        const passiveListener = support.passiveListener && params.passiveListeners ? {
            passive: true,
            capture: false
        } : false;
        if (!target) return;
        const eventMethod = method === "on" ? "addEventListener" : "removeEventListener";
        if (!support.touch) {
            target[eventMethod](touchEventsDesktop.start, onDragStart, activeListener);
            document[eventMethod](touchEventsDesktop.move, onDragMove, activeListener);
            document[eventMethod](touchEventsDesktop.end, onDragEnd, passiveListener);
        } else {
            target[eventMethod](touchEventsTouch.start, onDragStart, activeListener);
            target[eventMethod](touchEventsTouch.move, onDragMove, activeListener);
            target[eventMethod](touchEventsTouch.end, onDragEnd, passiveListener);
        }
    }
    function enableDraggable() {
        if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
        events("on");
    }
    function disableDraggable() {
        if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
        events("off");
    }
    function init() {
        const { scrollbar: scrollbar, $el: $swiperEl } = swiper;
        swiper.params.scrollbar = (0, $al50b.default)(swiper, swiper.originalParams.scrollbar, swiper.params.scrollbar, {
            el: "swiper-scrollbar"
        });
        const params = swiper.params.scrollbar;
        if (!params.el) return;
        let $el = (0, $92tgL.default)(params.el);
        if (swiper.params.uniqueNavElements && typeof params.el === "string" && $el.length > 1 && $swiperEl.find(params.el).length === 1) $el = $swiperEl.find(params.el);
        $el.addClass(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);
        let $dragEl = $el.find(`.${swiper.params.scrollbar.dragClass}`);
        if ($dragEl.length === 0) {
            $dragEl = (0, $92tgL.default)(`<div class="${swiper.params.scrollbar.dragClass}"></div>`);
            $el.append($dragEl);
        }
        Object.assign(scrollbar, {
            $el: $el,
            el: $el[0],
            $dragEl: $dragEl,
            dragEl: $dragEl[0]
        });
        if (params.draggable) enableDraggable();
        if ($el) $el[swiper.enabled ? "removeClass" : "addClass"](swiper.params.scrollbar.lockClass);
    }
    function destroy() {
        const params = swiper.params.scrollbar;
        const $el = swiper.scrollbar.$el;
        if ($el) $el.removeClass(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);
        disableDraggable();
    }
    on("init", ()=>{
        if (swiper.params.scrollbar.enabled === false) // eslint-disable-next-line
        disable();
        else {
            init();
            updateSize();
            setTranslate();
        }
    });
    on("update resize observerUpdate lock unlock", ()=>{
        updateSize();
    });
    on("setTranslate", ()=>{
        setTranslate();
    });
    on("setTransition", (_s, duration)=>{
        setTransition(duration);
    });
    on("enable disable", ()=>{
        const { $el: $el } = swiper.scrollbar;
        if ($el) $el[swiper.enabled ? "removeClass" : "addClass"](swiper.params.scrollbar.lockClass);
    });
    on("destroy", ()=>{
        destroy();
    });
    const enable = ()=>{
        swiper.$el.removeClass(swiper.params.scrollbar.scrollbarDisabledClass);
        if (swiper.scrollbar.$el) swiper.scrollbar.$el.removeClass(swiper.params.scrollbar.scrollbarDisabledClass);
        init();
        updateSize();
        setTranslate();
    };
    const disable = ()=>{
        swiper.$el.addClass(swiper.params.scrollbar.scrollbarDisabledClass);
        if (swiper.scrollbar.$el) swiper.scrollbar.$el.addClass(swiper.params.scrollbar.scrollbarDisabledClass);
        destroy();
    };
    Object.assign(swiper.scrollbar, {
        enable: enable,
        disable: disable,
        updateSize: updateSize,
        setTranslate: setTranslate,
        init: init,
        destroy: destroy
    });
}

});

parcelRequire.register("1sqY9", function(module, exports) {

var $92tgL = parcelRequire("92tgL");
function $10fd5378a381f780$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on }) {
    extendParams({
        parallax: {
            enabled: false
        }
    });
    const setTransform = (el, progress)=>{
        const { rtl: rtl } = swiper;
        const $el = (0, $92tgL.default)(el);
        const rtlFactor = rtl ? -1 : 1;
        const p = $el.attr("data-swiper-parallax") || "0";
        let x = $el.attr("data-swiper-parallax-x");
        let y = $el.attr("data-swiper-parallax-y");
        const scale = $el.attr("data-swiper-parallax-scale");
        const opacity = $el.attr("data-swiper-parallax-opacity");
        if (x || y) {
            x = x || "0";
            y = y || "0";
        } else if (swiper.isHorizontal()) {
            x = p;
            y = "0";
        } else {
            y = p;
            x = "0";
        }
        if (x.indexOf("%") >= 0) x = `${parseInt(x, 10) * progress * rtlFactor}%`;
        else x = `${x * progress * rtlFactor}px`;
        if (y.indexOf("%") >= 0) y = `${parseInt(y, 10) * progress}%`;
        else y = `${y * progress}px`;
        if (typeof opacity !== "undefined" && opacity !== null) {
            const currentOpacity = opacity - (opacity - 1) * (1 - Math.abs(progress));
            $el[0].style.opacity = currentOpacity;
        }
        if (typeof scale === "undefined" || scale === null) $el.transform(`translate3d(${x}, ${y}, 0px)`);
        else {
            const currentScale = scale - (scale - 1) * (1 - Math.abs(progress));
            $el.transform(`translate3d(${x}, ${y}, 0px) scale(${currentScale})`);
        }
    };
    const setTranslate = ()=>{
        const { $el: $el, slides: slides, progress: progress, snapGrid: snapGrid } = swiper;
        $el.children("[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]").each((el)=>{
            setTransform(el, progress);
        });
        slides.each((slideEl, slideIndex)=>{
            let slideProgress = slideEl.progress;
            if (swiper.params.slidesPerGroup > 1 && swiper.params.slidesPerView !== "auto") slideProgress += Math.ceil(slideIndex / 2) - progress * (snapGrid.length - 1);
            slideProgress = Math.min(Math.max(slideProgress, -1), 1);
            (0, $92tgL.default)(slideEl).find("[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]").each((el)=>{
                setTransform(el, slideProgress);
            });
        });
    };
    const setTransition = (duration = swiper.params.speed)=>{
        const { $el: $el } = swiper;
        $el.find("[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]").each((parallaxEl)=>{
            const $parallaxEl = (0, $92tgL.default)(parallaxEl);
            let parallaxDuration = parseInt($parallaxEl.attr("data-swiper-parallax-duration"), 10) || duration;
            if (duration === 0) parallaxDuration = 0;
            $parallaxEl.transition(parallaxDuration);
        });
    };
    on("beforeInit", ()=>{
        if (!swiper.params.parallax.enabled) return;
        swiper.params.watchSlidesProgress = true;
        swiper.originalParams.watchSlidesProgress = true;
    });
    on("init", ()=>{
        if (!swiper.params.parallax.enabled) return;
        setTranslate();
    });
    on("setTranslate", ()=>{
        if (!swiper.params.parallax.enabled) return;
        setTranslate();
    });
    on("setTransition", (_swiper, duration)=>{
        if (!swiper.params.parallax.enabled) return;
        setTransition(duration);
    });
}

});

parcelRequire.register("hPoyj", function(module, exports) {

var $bkUxr = parcelRequire("bkUxr");

var $92tgL = parcelRequire("92tgL");

var $2y7Cr = parcelRequire("2y7Cr");
function $cfaa3eae584a0de4$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on, emit: emit }) {
    const window = (0, $bkUxr.getWindow)();
    extendParams({
        zoom: {
            enabled: false,
            maxRatio: 3,
            minRatio: 1,
            toggle: true,
            containerClass: "swiper-zoom-container",
            zoomedSlideClass: "swiper-slide-zoomed"
        }
    });
    swiper.zoom = {
        enabled: false
    };
    let currentScale = 1;
    let isScaling = false;
    let gesturesEnabled;
    let fakeGestureTouched;
    let fakeGestureMoved;
    const gesture = {
        $slideEl: undefined,
        slideWidth: undefined,
        slideHeight: undefined,
        $imageEl: undefined,
        $imageWrapEl: undefined,
        maxRatio: 3
    };
    const image = {
        isTouched: undefined,
        isMoved: undefined,
        currentX: undefined,
        currentY: undefined,
        minX: undefined,
        minY: undefined,
        maxX: undefined,
        maxY: undefined,
        width: undefined,
        height: undefined,
        startX: undefined,
        startY: undefined,
        touchesStart: {},
        touchesCurrent: {}
    };
    const velocity = {
        x: undefined,
        y: undefined,
        prevPositionX: undefined,
        prevPositionY: undefined,
        prevTime: undefined
    };
    let scale = 1;
    Object.defineProperty(swiper.zoom, "scale", {
        get () {
            return scale;
        },
        set (value) {
            if (scale !== value) {
                const imageEl = gesture.$imageEl ? gesture.$imageEl[0] : undefined;
                const slideEl = gesture.$slideEl ? gesture.$slideEl[0] : undefined;
                emit("zoomChange", value, imageEl, slideEl);
            }
            scale = value;
        }
    });
    function getDistanceBetweenTouches(e) {
        if (e.targetTouches.length < 2) return 1;
        const x1 = e.targetTouches[0].pageX;
        const y1 = e.targetTouches[0].pageY;
        const x2 = e.targetTouches[1].pageX;
        const y2 = e.targetTouches[1].pageY;
        const distance = Math.sqrt((x2 - x1) ** 2 + (y2 - y1) ** 2);
        return distance;
    } // Events
    function onGestureStart(e) {
        const support = swiper.support;
        const params = swiper.params.zoom;
        fakeGestureTouched = false;
        fakeGestureMoved = false;
        if (!support.gestures) {
            if (e.type !== "touchstart" || e.type === "touchstart" && e.targetTouches.length < 2) return;
            fakeGestureTouched = true;
            gesture.scaleStart = getDistanceBetweenTouches(e);
        }
        if (!gesture.$slideEl || !gesture.$slideEl.length) {
            gesture.$slideEl = (0, $92tgL.default)(e.target).closest(`.${swiper.params.slideClass}`);
            if (gesture.$slideEl.length === 0) gesture.$slideEl = swiper.slides.eq(swiper.activeIndex);
            gesture.$imageEl = gesture.$slideEl.find(`.${params.containerClass}`).eq(0).find("picture, img, svg, canvas, .swiper-zoom-target").eq(0);
            gesture.$imageWrapEl = gesture.$imageEl.parent(`.${params.containerClass}`);
            gesture.maxRatio = gesture.$imageWrapEl.attr("data-swiper-zoom") || params.maxRatio;
            if (gesture.$imageWrapEl.length === 0) {
                gesture.$imageEl = undefined;
                return;
            }
        }
        if (gesture.$imageEl) gesture.$imageEl.transition(0);
        isScaling = true;
    }
    function onGestureChange(e) {
        const support = swiper.support;
        const params = swiper.params.zoom;
        const zoom = swiper.zoom;
        if (!support.gestures) {
            if (e.type !== "touchmove" || e.type === "touchmove" && e.targetTouches.length < 2) return;
            fakeGestureMoved = true;
            gesture.scaleMove = getDistanceBetweenTouches(e);
        }
        if (!gesture.$imageEl || gesture.$imageEl.length === 0) {
            if (e.type === "gesturechange") onGestureStart(e);
            return;
        }
        if (support.gestures) zoom.scale = e.scale * currentScale;
        else zoom.scale = gesture.scaleMove / gesture.scaleStart * currentScale;
        if (zoom.scale > gesture.maxRatio) zoom.scale = gesture.maxRatio - 1 + (zoom.scale - gesture.maxRatio + 1) ** 0.5;
        if (zoom.scale < params.minRatio) zoom.scale = params.minRatio + 1 - (params.minRatio - zoom.scale + 1) ** 0.5;
        gesture.$imageEl.transform(`translate3d(0,0,0) scale(${zoom.scale})`);
    }
    function onGestureEnd(e) {
        const device = swiper.device;
        const support = swiper.support;
        const params = swiper.params.zoom;
        const zoom = swiper.zoom;
        if (!support.gestures) {
            if (!fakeGestureTouched || !fakeGestureMoved) return;
            if (e.type !== "touchend" || e.type === "touchend" && e.changedTouches.length < 2 && !device.android) return;
            fakeGestureTouched = false;
            fakeGestureMoved = false;
        }
        if (!gesture.$imageEl || gesture.$imageEl.length === 0) return;
        zoom.scale = Math.max(Math.min(zoom.scale, gesture.maxRatio), params.minRatio);
        gesture.$imageEl.transition(swiper.params.speed).transform(`translate3d(0,0,0) scale(${zoom.scale})`);
        currentScale = zoom.scale;
        isScaling = false;
        if (zoom.scale === 1) gesture.$slideEl = undefined;
    }
    function onTouchStart(e) {
        const device = swiper.device;
        if (!gesture.$imageEl || gesture.$imageEl.length === 0) return;
        if (image.isTouched) return;
        if (device.android && e.cancelable) e.preventDefault();
        image.isTouched = true;
        image.touchesStart.x = e.type === "touchstart" ? e.targetTouches[0].pageX : e.pageX;
        image.touchesStart.y = e.type === "touchstart" ? e.targetTouches[0].pageY : e.pageY;
    }
    function onTouchMove(e) {
        const zoom = swiper.zoom;
        if (!gesture.$imageEl || gesture.$imageEl.length === 0) return;
        swiper.allowClick = false;
        if (!image.isTouched || !gesture.$slideEl) return;
        if (!image.isMoved) {
            image.width = gesture.$imageEl[0].offsetWidth;
            image.height = gesture.$imageEl[0].offsetHeight;
            image.startX = (0, $2y7Cr.getTranslate)(gesture.$imageWrapEl[0], "x") || 0;
            image.startY = (0, $2y7Cr.getTranslate)(gesture.$imageWrapEl[0], "y") || 0;
            gesture.slideWidth = gesture.$slideEl[0].offsetWidth;
            gesture.slideHeight = gesture.$slideEl[0].offsetHeight;
            gesture.$imageWrapEl.transition(0);
        } // Define if we need image drag
        const scaledWidth = image.width * zoom.scale;
        const scaledHeight = image.height * zoom.scale;
        if (scaledWidth < gesture.slideWidth && scaledHeight < gesture.slideHeight) return;
        image.minX = Math.min(gesture.slideWidth / 2 - scaledWidth / 2, 0);
        image.maxX = -image.minX;
        image.minY = Math.min(gesture.slideHeight / 2 - scaledHeight / 2, 0);
        image.maxY = -image.minY;
        image.touchesCurrent.x = e.type === "touchmove" ? e.targetTouches[0].pageX : e.pageX;
        image.touchesCurrent.y = e.type === "touchmove" ? e.targetTouches[0].pageY : e.pageY;
        if (!image.isMoved && !isScaling) {
            if (swiper.isHorizontal() && (Math.floor(image.minX) === Math.floor(image.startX) && image.touchesCurrent.x < image.touchesStart.x || Math.floor(image.maxX) === Math.floor(image.startX) && image.touchesCurrent.x > image.touchesStart.x)) {
                image.isTouched = false;
                return;
            }
            if (!swiper.isHorizontal() && (Math.floor(image.minY) === Math.floor(image.startY) && image.touchesCurrent.y < image.touchesStart.y || Math.floor(image.maxY) === Math.floor(image.startY) && image.touchesCurrent.y > image.touchesStart.y)) {
                image.isTouched = false;
                return;
            }
        }
        if (e.cancelable) e.preventDefault();
        e.stopPropagation();
        image.isMoved = true;
        image.currentX = image.touchesCurrent.x - image.touchesStart.x + image.startX;
        image.currentY = image.touchesCurrent.y - image.touchesStart.y + image.startY;
        if (image.currentX < image.minX) image.currentX = image.minX + 1 - (image.minX - image.currentX + 1) ** 0.8;
        if (image.currentX > image.maxX) image.currentX = image.maxX - 1 + (image.currentX - image.maxX + 1) ** 0.8;
        if (image.currentY < image.minY) image.currentY = image.minY + 1 - (image.minY - image.currentY + 1) ** 0.8;
        if (image.currentY > image.maxY) image.currentY = image.maxY - 1 + (image.currentY - image.maxY + 1) ** 0.8;
         // Velocity
        if (!velocity.prevPositionX) velocity.prevPositionX = image.touchesCurrent.x;
        if (!velocity.prevPositionY) velocity.prevPositionY = image.touchesCurrent.y;
        if (!velocity.prevTime) velocity.prevTime = Date.now();
        velocity.x = (image.touchesCurrent.x - velocity.prevPositionX) / (Date.now() - velocity.prevTime) / 2;
        velocity.y = (image.touchesCurrent.y - velocity.prevPositionY) / (Date.now() - velocity.prevTime) / 2;
        if (Math.abs(image.touchesCurrent.x - velocity.prevPositionX) < 2) velocity.x = 0;
        if (Math.abs(image.touchesCurrent.y - velocity.prevPositionY) < 2) velocity.y = 0;
        velocity.prevPositionX = image.touchesCurrent.x;
        velocity.prevPositionY = image.touchesCurrent.y;
        velocity.prevTime = Date.now();
        gesture.$imageWrapEl.transform(`translate3d(${image.currentX}px, ${image.currentY}px,0)`);
    }
    function onTouchEnd() {
        const zoom = swiper.zoom;
        if (!gesture.$imageEl || gesture.$imageEl.length === 0) return;
        if (!image.isTouched || !image.isMoved) {
            image.isTouched = false;
            image.isMoved = false;
            return;
        }
        image.isTouched = false;
        image.isMoved = false;
        let momentumDurationX = 300;
        let momentumDurationY = 300;
        const momentumDistanceX = velocity.x * momentumDurationX;
        const newPositionX = image.currentX + momentumDistanceX;
        const momentumDistanceY = velocity.y * momentumDurationY;
        const newPositionY = image.currentY + momentumDistanceY; // Fix duration
        if (velocity.x !== 0) momentumDurationX = Math.abs((newPositionX - image.currentX) / velocity.x);
        if (velocity.y !== 0) momentumDurationY = Math.abs((newPositionY - image.currentY) / velocity.y);
        const momentumDuration = Math.max(momentumDurationX, momentumDurationY);
        image.currentX = newPositionX;
        image.currentY = newPositionY; // Define if we need image drag
        const scaledWidth = image.width * zoom.scale;
        const scaledHeight = image.height * zoom.scale;
        image.minX = Math.min(gesture.slideWidth / 2 - scaledWidth / 2, 0);
        image.maxX = -image.minX;
        image.minY = Math.min(gesture.slideHeight / 2 - scaledHeight / 2, 0);
        image.maxY = -image.minY;
        image.currentX = Math.max(Math.min(image.currentX, image.maxX), image.minX);
        image.currentY = Math.max(Math.min(image.currentY, image.maxY), image.minY);
        gesture.$imageWrapEl.transition(momentumDuration).transform(`translate3d(${image.currentX}px, ${image.currentY}px,0)`);
    }
    function onTransitionEnd() {
        const zoom = swiper.zoom;
        if (gesture.$slideEl && swiper.previousIndex !== swiper.activeIndex) {
            if (gesture.$imageEl) gesture.$imageEl.transform("translate3d(0,0,0) scale(1)");
            if (gesture.$imageWrapEl) gesture.$imageWrapEl.transform("translate3d(0,0,0)");
            zoom.scale = 1;
            currentScale = 1;
            gesture.$slideEl = undefined;
            gesture.$imageEl = undefined;
            gesture.$imageWrapEl = undefined;
        }
    }
    function zoomIn(e) {
        const zoom = swiper.zoom;
        const params = swiper.params.zoom;
        if (!gesture.$slideEl) {
            if (e && e.target) gesture.$slideEl = (0, $92tgL.default)(e.target).closest(`.${swiper.params.slideClass}`);
            if (!gesture.$slideEl) {
                if (swiper.params.virtual && swiper.params.virtual.enabled && swiper.virtual) gesture.$slideEl = swiper.$wrapperEl.children(`.${swiper.params.slideActiveClass}`);
                else gesture.$slideEl = swiper.slides.eq(swiper.activeIndex);
            }
            gesture.$imageEl = gesture.$slideEl.find(`.${params.containerClass}`).eq(0).find("picture, img, svg, canvas, .swiper-zoom-target").eq(0);
            gesture.$imageWrapEl = gesture.$imageEl.parent(`.${params.containerClass}`);
        }
        if (!gesture.$imageEl || gesture.$imageEl.length === 0 || !gesture.$imageWrapEl || gesture.$imageWrapEl.length === 0) return;
        if (swiper.params.cssMode) {
            swiper.wrapperEl.style.overflow = "hidden";
            swiper.wrapperEl.style.touchAction = "none";
        }
        gesture.$slideEl.addClass(`${params.zoomedSlideClass}`);
        let touchX;
        let touchY;
        let offsetX;
        let offsetY;
        let diffX;
        let diffY;
        let translateX;
        let translateY;
        let imageWidth;
        let imageHeight;
        let scaledWidth;
        let scaledHeight;
        let translateMinX;
        let translateMinY;
        let translateMaxX;
        let translateMaxY;
        let slideWidth;
        let slideHeight;
        if (typeof image.touchesStart.x === "undefined" && e) {
            touchX = e.type === "touchend" ? e.changedTouches[0].pageX : e.pageX;
            touchY = e.type === "touchend" ? e.changedTouches[0].pageY : e.pageY;
        } else {
            touchX = image.touchesStart.x;
            touchY = image.touchesStart.y;
        }
        zoom.scale = gesture.$imageWrapEl.attr("data-swiper-zoom") || params.maxRatio;
        currentScale = gesture.$imageWrapEl.attr("data-swiper-zoom") || params.maxRatio;
        if (e) {
            slideWidth = gesture.$slideEl[0].offsetWidth;
            slideHeight = gesture.$slideEl[0].offsetHeight;
            offsetX = gesture.$slideEl.offset().left + window.scrollX;
            offsetY = gesture.$slideEl.offset().top + window.scrollY;
            diffX = offsetX + slideWidth / 2 - touchX;
            diffY = offsetY + slideHeight / 2 - touchY;
            imageWidth = gesture.$imageEl[0].offsetWidth;
            imageHeight = gesture.$imageEl[0].offsetHeight;
            scaledWidth = imageWidth * zoom.scale;
            scaledHeight = imageHeight * zoom.scale;
            translateMinX = Math.min(slideWidth / 2 - scaledWidth / 2, 0);
            translateMinY = Math.min(slideHeight / 2 - scaledHeight / 2, 0);
            translateMaxX = -translateMinX;
            translateMaxY = -translateMinY;
            translateX = diffX * zoom.scale;
            translateY = diffY * zoom.scale;
            if (translateX < translateMinX) translateX = translateMinX;
            if (translateX > translateMaxX) translateX = translateMaxX;
            if (translateY < translateMinY) translateY = translateMinY;
            if (translateY > translateMaxY) translateY = translateMaxY;
        } else {
            translateX = 0;
            translateY = 0;
        }
        gesture.$imageWrapEl.transition(300).transform(`translate3d(${translateX}px, ${translateY}px,0)`);
        gesture.$imageEl.transition(300).transform(`translate3d(0,0,0) scale(${zoom.scale})`);
    }
    function zoomOut() {
        const zoom = swiper.zoom;
        const params = swiper.params.zoom;
        if (!gesture.$slideEl) {
            if (swiper.params.virtual && swiper.params.virtual.enabled && swiper.virtual) gesture.$slideEl = swiper.$wrapperEl.children(`.${swiper.params.slideActiveClass}`);
            else gesture.$slideEl = swiper.slides.eq(swiper.activeIndex);
            gesture.$imageEl = gesture.$slideEl.find(`.${params.containerClass}`).eq(0).find("picture, img, svg, canvas, .swiper-zoom-target").eq(0);
            gesture.$imageWrapEl = gesture.$imageEl.parent(`.${params.containerClass}`);
        }
        if (!gesture.$imageEl || gesture.$imageEl.length === 0 || !gesture.$imageWrapEl || gesture.$imageWrapEl.length === 0) return;
        if (swiper.params.cssMode) {
            swiper.wrapperEl.style.overflow = "";
            swiper.wrapperEl.style.touchAction = "";
        }
        zoom.scale = 1;
        currentScale = 1;
        gesture.$imageWrapEl.transition(300).transform("translate3d(0,0,0)");
        gesture.$imageEl.transition(300).transform("translate3d(0,0,0) scale(1)");
        gesture.$slideEl.removeClass(`${params.zoomedSlideClass}`);
        gesture.$slideEl = undefined;
    } // Toggle Zoom
    function zoomToggle(e) {
        const zoom = swiper.zoom;
        if (zoom.scale && zoom.scale !== 1) // Zoom Out
        zoomOut();
        else // Zoom In
        zoomIn(e);
    }
    function getListeners() {
        const support = swiper.support;
        const passiveListener = swiper.touchEvents.start === "touchstart" && support.passiveListener && swiper.params.passiveListeners ? {
            passive: true,
            capture: false
        } : false;
        const activeListenerWithCapture = support.passiveListener ? {
            passive: false,
            capture: true
        } : true;
        return {
            passiveListener: passiveListener,
            activeListenerWithCapture: activeListenerWithCapture
        };
    }
    function getSlideSelector() {
        return `.${swiper.params.slideClass}`;
    }
    function toggleGestures(method) {
        const { passiveListener: passiveListener } = getListeners();
        const slideSelector = getSlideSelector();
        swiper.$wrapperEl[method]("gesturestart", slideSelector, onGestureStart, passiveListener);
        swiper.$wrapperEl[method]("gesturechange", slideSelector, onGestureChange, passiveListener);
        swiper.$wrapperEl[method]("gestureend", slideSelector, onGestureEnd, passiveListener);
    }
    function enableGestures() {
        if (gesturesEnabled) return;
        gesturesEnabled = true;
        toggleGestures("on");
    }
    function disableGestures() {
        if (!gesturesEnabled) return;
        gesturesEnabled = false;
        toggleGestures("off");
    } // Attach/Detach Events
    function enable() {
        const zoom = swiper.zoom;
        if (zoom.enabled) return;
        zoom.enabled = true;
        const support = swiper.support;
        const { passiveListener: passiveListener, activeListenerWithCapture: activeListenerWithCapture } = getListeners();
        const slideSelector = getSlideSelector(); // Scale image
        if (support.gestures) {
            swiper.$wrapperEl.on(swiper.touchEvents.start, enableGestures, passiveListener);
            swiper.$wrapperEl.on(swiper.touchEvents.end, disableGestures, passiveListener);
        } else if (swiper.touchEvents.start === "touchstart") {
            swiper.$wrapperEl.on(swiper.touchEvents.start, slideSelector, onGestureStart, passiveListener);
            swiper.$wrapperEl.on(swiper.touchEvents.move, slideSelector, onGestureChange, activeListenerWithCapture);
            swiper.$wrapperEl.on(swiper.touchEvents.end, slideSelector, onGestureEnd, passiveListener);
            if (swiper.touchEvents.cancel) swiper.$wrapperEl.on(swiper.touchEvents.cancel, slideSelector, onGestureEnd, passiveListener);
        } // Move image
        swiper.$wrapperEl.on(swiper.touchEvents.move, `.${swiper.params.zoom.containerClass}`, onTouchMove, activeListenerWithCapture);
    }
    function disable() {
        const zoom = swiper.zoom;
        if (!zoom.enabled) return;
        const support = swiper.support;
        zoom.enabled = false;
        const { passiveListener: passiveListener, activeListenerWithCapture: activeListenerWithCapture } = getListeners();
        const slideSelector = getSlideSelector(); // Scale image
        if (support.gestures) {
            swiper.$wrapperEl.off(swiper.touchEvents.start, enableGestures, passiveListener);
            swiper.$wrapperEl.off(swiper.touchEvents.end, disableGestures, passiveListener);
        } else if (swiper.touchEvents.start === "touchstart") {
            swiper.$wrapperEl.off(swiper.touchEvents.start, slideSelector, onGestureStart, passiveListener);
            swiper.$wrapperEl.off(swiper.touchEvents.move, slideSelector, onGestureChange, activeListenerWithCapture);
            swiper.$wrapperEl.off(swiper.touchEvents.end, slideSelector, onGestureEnd, passiveListener);
            if (swiper.touchEvents.cancel) swiper.$wrapperEl.off(swiper.touchEvents.cancel, slideSelector, onGestureEnd, passiveListener);
        } // Move image
        swiper.$wrapperEl.off(swiper.touchEvents.move, `.${swiper.params.zoom.containerClass}`, onTouchMove, activeListenerWithCapture);
    }
    on("init", ()=>{
        if (swiper.params.zoom.enabled) enable();
    });
    on("destroy", ()=>{
        disable();
    });
    on("touchStart", (_s, e)=>{
        if (!swiper.zoom.enabled) return;
        onTouchStart(e);
    });
    on("touchEnd", (_s, e)=>{
        if (!swiper.zoom.enabled) return;
        onTouchEnd(e);
    });
    on("doubleTap", (_s, e)=>{
        if (!swiper.animating && swiper.params.zoom.enabled && swiper.zoom.enabled && swiper.params.zoom.toggle) zoomToggle(e);
    });
    on("transitionEnd", ()=>{
        if (swiper.zoom.enabled && swiper.params.zoom.enabled) onTransitionEnd();
    });
    on("slideChange", ()=>{
        if (swiper.zoom.enabled && swiper.params.zoom.enabled && swiper.params.cssMode) onTransitionEnd();
    });
    Object.assign(swiper.zoom, {
        enable: enable,
        disable: disable,
        in: zoomIn,
        out: zoomOut,
        toggle: zoomToggle
    });
}

});

parcelRequire.register("4WSxm", function(module, exports) {

var $bkUxr = parcelRequire("bkUxr");

var $92tgL = parcelRequire("92tgL");
function $39a6e225d3985140$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on, emit: emit }) {
    extendParams({
        lazy: {
            checkInView: false,
            enabled: false,
            loadPrevNext: false,
            loadPrevNextAmount: 1,
            loadOnTransitionStart: false,
            scrollingElement: "",
            elementClass: "swiper-lazy",
            loadingClass: "swiper-lazy-loading",
            loadedClass: "swiper-lazy-loaded",
            preloaderClass: "swiper-lazy-preloader"
        }
    });
    swiper.lazy = {};
    let scrollHandlerAttached = false;
    let initialImageLoaded = false;
    function loadInSlide(index, loadInDuplicate = true) {
        const params = swiper.params.lazy;
        if (typeof index === "undefined") return;
        if (swiper.slides.length === 0) return;
        const isVirtual = swiper.virtual && swiper.params.virtual.enabled;
        const $slideEl = isVirtual ? swiper.$wrapperEl.children(`.${swiper.params.slideClass}[data-swiper-slide-index="${index}"]`) : swiper.slides.eq(index);
        const $images = $slideEl.find(`.${params.elementClass}:not(.${params.loadedClass}):not(.${params.loadingClass})`);
        if ($slideEl.hasClass(params.elementClass) && !$slideEl.hasClass(params.loadedClass) && !$slideEl.hasClass(params.loadingClass)) $images.push($slideEl[0]);
        if ($images.length === 0) return;
        $images.each((imageEl)=>{
            const $imageEl = (0, $92tgL.default)(imageEl);
            $imageEl.addClass(params.loadingClass);
            const background = $imageEl.attr("data-background");
            const src = $imageEl.attr("data-src");
            const srcset = $imageEl.attr("data-srcset");
            const sizes = $imageEl.attr("data-sizes");
            const $pictureEl = $imageEl.parent("picture");
            swiper.loadImage($imageEl[0], src || background, srcset, sizes, false, ()=>{
                if (typeof swiper === "undefined" || swiper === null || !swiper || swiper && !swiper.params || swiper.destroyed) return;
                if (background) {
                    $imageEl.css("background-image", `url("${background}")`);
                    $imageEl.removeAttr("data-background");
                } else {
                    if (srcset) {
                        $imageEl.attr("srcset", srcset);
                        $imageEl.removeAttr("data-srcset");
                    }
                    if (sizes) {
                        $imageEl.attr("sizes", sizes);
                        $imageEl.removeAttr("data-sizes");
                    }
                    if ($pictureEl.length) $pictureEl.children("source").each((sourceEl)=>{
                        const $source = (0, $92tgL.default)(sourceEl);
                        if ($source.attr("data-srcset")) {
                            $source.attr("srcset", $source.attr("data-srcset"));
                            $source.removeAttr("data-srcset");
                        }
                    });
                    if (src) {
                        $imageEl.attr("src", src);
                        $imageEl.removeAttr("data-src");
                    }
                }
                $imageEl.addClass(params.loadedClass).removeClass(params.loadingClass);
                $slideEl.find(`.${params.preloaderClass}`).remove();
                if (swiper.params.loop && loadInDuplicate) {
                    const slideOriginalIndex = $slideEl.attr("data-swiper-slide-index");
                    if ($slideEl.hasClass(swiper.params.slideDuplicateClass)) {
                        const originalSlide = swiper.$wrapperEl.children(`[data-swiper-slide-index="${slideOriginalIndex}"]:not(.${swiper.params.slideDuplicateClass})`);
                        loadInSlide(originalSlide.index(), false);
                    } else {
                        const duplicatedSlide = swiper.$wrapperEl.children(`.${swiper.params.slideDuplicateClass}[data-swiper-slide-index="${slideOriginalIndex}"]`);
                        loadInSlide(duplicatedSlide.index(), false);
                    }
                }
                emit("lazyImageReady", $slideEl[0], $imageEl[0]);
                if (swiper.params.autoHeight) swiper.updateAutoHeight();
            });
            emit("lazyImageLoad", $slideEl[0], $imageEl[0]);
        });
    }
    function load() {
        const { $wrapperEl: $wrapperEl, params: swiperParams, slides: slides, activeIndex: activeIndex } = swiper;
        const isVirtual = swiper.virtual && swiperParams.virtual.enabled;
        const params = swiperParams.lazy;
        let slidesPerView = swiperParams.slidesPerView;
        if (slidesPerView === "auto") slidesPerView = 0;
        function slideExist(index) {
            if (isVirtual) {
                if ($wrapperEl.children(`.${swiperParams.slideClass}[data-swiper-slide-index="${index}"]`).length) return true;
            } else if (slides[index]) return true;
            return false;
        }
        function slideIndex(slideEl) {
            if (isVirtual) return (0, $92tgL.default)(slideEl).attr("data-swiper-slide-index");
            return (0, $92tgL.default)(slideEl).index();
        }
        if (!initialImageLoaded) initialImageLoaded = true;
        if (swiper.params.watchSlidesProgress) $wrapperEl.children(`.${swiperParams.slideVisibleClass}`).each((slideEl)=>{
            const index = isVirtual ? (0, $92tgL.default)(slideEl).attr("data-swiper-slide-index") : (0, $92tgL.default)(slideEl).index();
            loadInSlide(index);
        });
        else if (slidesPerView > 1) {
            for(let i = activeIndex; i < activeIndex + slidesPerView; i += 1)if (slideExist(i)) loadInSlide(i);
        } else loadInSlide(activeIndex);
        if (params.loadPrevNext) {
            if (slidesPerView > 1 || params.loadPrevNextAmount && params.loadPrevNextAmount > 1) {
                const amount = params.loadPrevNextAmount;
                const spv = Math.ceil(slidesPerView);
                const maxIndex = Math.min(activeIndex + spv + Math.max(amount, spv), slides.length);
                const minIndex = Math.max(activeIndex - Math.max(spv, amount), 0); // Next Slides
                for(let i = activeIndex + spv; i < maxIndex; i += 1)if (slideExist(i)) loadInSlide(i);
                 // Prev Slides
                for(let i = minIndex; i < activeIndex; i += 1)if (slideExist(i)) loadInSlide(i);
            } else {
                const nextSlide = $wrapperEl.children(`.${swiperParams.slideNextClass}`);
                if (nextSlide.length > 0) loadInSlide(slideIndex(nextSlide));
                const prevSlide = $wrapperEl.children(`.${swiperParams.slidePrevClass}`);
                if (prevSlide.length > 0) loadInSlide(slideIndex(prevSlide));
            }
        }
    }
    function checkInViewOnLoad() {
        const window = (0, $bkUxr.getWindow)();
        if (!swiper || swiper.destroyed) return;
        const $scrollElement = swiper.params.lazy.scrollingElement ? (0, $92tgL.default)(swiper.params.lazy.scrollingElement) : (0, $92tgL.default)(window);
        const isWindow = $scrollElement[0] === window;
        const scrollElementWidth = isWindow ? window.innerWidth : $scrollElement[0].offsetWidth;
        const scrollElementHeight = isWindow ? window.innerHeight : $scrollElement[0].offsetHeight;
        const swiperOffset = swiper.$el.offset();
        const { rtlTranslate: rtl } = swiper;
        let inView = false;
        if (rtl) swiperOffset.left -= swiper.$el[0].scrollLeft;
        const swiperCoord = [
            [
                swiperOffset.left,
                swiperOffset.top
            ],
            [
                swiperOffset.left + swiper.width,
                swiperOffset.top
            ],
            [
                swiperOffset.left,
                swiperOffset.top + swiper.height
            ],
            [
                swiperOffset.left + swiper.width,
                swiperOffset.top + swiper.height
            ]
        ];
        for(let i = 0; i < swiperCoord.length; i += 1){
            const point = swiperCoord[i];
            if (point[0] >= 0 && point[0] <= scrollElementWidth && point[1] >= 0 && point[1] <= scrollElementHeight) {
                if (point[0] === 0 && point[1] === 0) continue; // eslint-disable-line
                inView = true;
            }
        }
        const passiveListener = swiper.touchEvents.start === "touchstart" && swiper.support.passiveListener && swiper.params.passiveListeners ? {
            passive: true,
            capture: false
        } : false;
        if (inView) {
            load();
            $scrollElement.off("scroll", checkInViewOnLoad, passiveListener);
        } else if (!scrollHandlerAttached) {
            scrollHandlerAttached = true;
            $scrollElement.on("scroll", checkInViewOnLoad, passiveListener);
        }
    }
    on("beforeInit", ()=>{
        if (swiper.params.lazy.enabled && swiper.params.preloadImages) swiper.params.preloadImages = false;
    });
    on("init", ()=>{
        if (swiper.params.lazy.enabled) {
            if (swiper.params.lazy.checkInView) checkInViewOnLoad();
            else load();
        }
    });
    on("scroll", ()=>{
        if (swiper.params.freeMode && swiper.params.freeMode.enabled && !swiper.params.freeMode.sticky) load();
    });
    on("scrollbarDragMove resize _freeModeNoMomentumRelease", ()=>{
        if (swiper.params.lazy.enabled) {
            if (swiper.params.lazy.checkInView) checkInViewOnLoad();
            else load();
        }
    });
    on("transitionStart", ()=>{
        if (swiper.params.lazy.enabled) {
            if (swiper.params.lazy.loadOnTransitionStart || !swiper.params.lazy.loadOnTransitionStart && !initialImageLoaded) {
                if (swiper.params.lazy.checkInView) checkInViewOnLoad();
                else load();
            }
        }
    });
    on("transitionEnd", ()=>{
        if (swiper.params.lazy.enabled && !swiper.params.lazy.loadOnTransitionStart) {
            if (swiper.params.lazy.checkInView) checkInViewOnLoad();
            else load();
        }
    });
    on("slideChange", ()=>{
        const { lazy: lazy, cssMode: cssMode, watchSlidesProgress: watchSlidesProgress, touchReleaseOnEdges: touchReleaseOnEdges, resistanceRatio: resistanceRatio } = swiper.params;
        if (lazy.enabled && (cssMode || watchSlidesProgress && (touchReleaseOnEdges || resistanceRatio === 0))) load();
    });
    on("destroy", ()=>{
        if (!swiper.$el) return;
        swiper.$el.find(`.${swiper.params.lazy.loadingClass}`).removeClass(swiper.params.lazy.loadingClass);
    });
    Object.assign(swiper.lazy, {
        load: load,
        loadInSlide: loadInSlide
    });
}

});

parcelRequire.register("1YbIn", function(module, exports) {
/* eslint no-bitwise: ["error", { "allow": [">>"] }] */ 
var $2y7Cr = parcelRequire("2y7Cr");
function $16f47b5cad29f371$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on }) {
    extendParams({
        controller: {
            control: undefined,
            inverse: false,
            by: "slide" // or 'container'
        }
    });
    swiper.controller = {
        control: undefined
    };
    function LinearSpline(x, y) {
        const binarySearch = function search() {
            let maxIndex;
            let minIndex;
            let guess;
            return (array, val)=>{
                minIndex = -1;
                maxIndex = array.length;
                while(maxIndex - minIndex > 1){
                    guess = maxIndex + minIndex >> 1;
                    if (array[guess] <= val) minIndex = guess;
                    else maxIndex = guess;
                }
                return maxIndex;
            };
        }();
        this.x = x;
        this.y = y;
        this.lastIndex = x.length - 1; // Given an x value (x2), return the expected y2 value:
        // (x1,y1) is the known point before given value,
        // (x3,y3) is the known point after given value.
        let i1;
        let i3;
        this.interpolate = function interpolate(x2) {
            if (!x2) return 0; // Get the indexes of x1 and x3 (the array indexes before and after given x2):
            i3 = binarySearch(this.x, x2);
            i1 = i3 - 1; // We have our indexes i1 & i3, so we can calculate already:
            // y2 := ((x2−x1) × (y3−y1)) ÷ (x3−x1) + y1
            return (x2 - this.x[i1]) * (this.y[i3] - this.y[i1]) / (this.x[i3] - this.x[i1]) + this.y[i1];
        };
        return this;
    } // xxx: for now i will just save one spline function to to
    function getInterpolateFunction(c) {
        if (!swiper.controller.spline) swiper.controller.spline = swiper.params.loop ? new LinearSpline(swiper.slidesGrid, c.slidesGrid) : new LinearSpline(swiper.snapGrid, c.snapGrid);
    }
    function setTranslate(_t, byController) {
        const controlled = swiper.controller.control;
        let multiplier;
        let controlledTranslate;
        const Swiper = swiper.constructor;
        function setControlledTranslate(c) {
            // this will create an Interpolate function based on the snapGrids
            // x is the Grid of the scrolled scroller and y will be the controlled scroller
            // it makes sense to create this only once and recall it for the interpolation
            // the function does a lot of value caching for performance
            const translate = swiper.rtlTranslate ? -swiper.translate : swiper.translate;
            if (swiper.params.controller.by === "slide") {
                getInterpolateFunction(c); // i am not sure why the values have to be multiplicated this way, tried to invert the snapGrid
                // but it did not work out
                controlledTranslate = -swiper.controller.spline.interpolate(-translate);
            }
            if (!controlledTranslate || swiper.params.controller.by === "container") {
                multiplier = (c.maxTranslate() - c.minTranslate()) / (swiper.maxTranslate() - swiper.minTranslate());
                controlledTranslate = (translate - swiper.minTranslate()) * multiplier + c.minTranslate();
            }
            if (swiper.params.controller.inverse) controlledTranslate = c.maxTranslate() - controlledTranslate;
            c.updateProgress(controlledTranslate);
            c.setTranslate(controlledTranslate, swiper);
            c.updateActiveIndex();
            c.updateSlidesClasses();
        }
        if (Array.isArray(controlled)) {
            for(let i = 0; i < controlled.length; i += 1)if (controlled[i] !== byController && controlled[i] instanceof Swiper) setControlledTranslate(controlled[i]);
        } else if (controlled instanceof Swiper && byController !== controlled) setControlledTranslate(controlled);
    }
    function setTransition(duration, byController) {
        const Swiper = swiper.constructor;
        const controlled = swiper.controller.control;
        let i;
        function setControlledTransition(c) {
            c.setTransition(duration, swiper);
            if (duration !== 0) {
                c.transitionStart();
                if (c.params.autoHeight) (0, $2y7Cr.nextTick)(()=>{
                    c.updateAutoHeight();
                });
                c.$wrapperEl.transitionEnd(()=>{
                    if (!controlled) return;
                    if (c.params.loop && swiper.params.controller.by === "slide") c.loopFix();
                    c.transitionEnd();
                });
            }
        }
        if (Array.isArray(controlled)) {
            for(i = 0; i < controlled.length; i += 1)if (controlled[i] !== byController && controlled[i] instanceof Swiper) setControlledTransition(controlled[i]);
        } else if (controlled instanceof Swiper && byController !== controlled) setControlledTransition(controlled);
    }
    function removeSpline() {
        if (!swiper.controller.control) return;
        if (swiper.controller.spline) {
            swiper.controller.spline = undefined;
            delete swiper.controller.spline;
        }
    }
    on("beforeInit", ()=>{
        swiper.controller.control = swiper.params.controller.control;
    });
    on("update", ()=>{
        removeSpline();
    });
    on("resize", ()=>{
        removeSpline();
    });
    on("observerUpdate", ()=>{
        removeSpline();
    });
    on("setTranslate", (_s, translate, byController)=>{
        if (!swiper.controller.control) return;
        swiper.controller.setTranslate(translate, byController);
    });
    on("setTransition", (_s, duration, byController)=>{
        if (!swiper.controller.control) return;
        swiper.controller.setTransition(duration, byController);
    });
    Object.assign(swiper.controller, {
        setTranslate: setTranslate,
        setTransition: setTransition
    });
}

});

parcelRequire.register("kIOmg", function(module, exports) {

$parcel$export(module.exports, "default", () => $f15efac8505bc062$export$2e2bcd8739ae039);

var $gfE23 = parcelRequire("gfE23");

var $92tgL = parcelRequire("92tgL");
function $f15efac8505bc062$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on }) {
    extendParams({
        a11y: {
            enabled: true,
            notificationClass: "swiper-notification",
            prevSlideMessage: "Previous slide",
            nextSlideMessage: "Next slide",
            firstSlideMessage: "This is the first slide",
            lastSlideMessage: "This is the last slide",
            paginationBulletMessage: "Go to slide {{index}}",
            slideLabelMessage: "{{index}} / {{slidesLength}}",
            containerMessage: null,
            containerRoleDescriptionMessage: null,
            itemRoleDescriptionMessage: null,
            slideRole: "group",
            id: null
        }
    });
    swiper.a11y = {
        clicked: false
    };
    let liveRegion = null;
    function notify(message) {
        const notification = liveRegion;
        if (notification.length === 0) return;
        notification.html("");
        notification.html(message);
    }
    function getRandomNumber(size = 16) {
        const randomChar = ()=>Math.round(16 * Math.random()).toString(16);
        return "x".repeat(size).replace(/x/g, randomChar);
    }
    function makeElFocusable($el) {
        $el.attr("tabIndex", "0");
    }
    function makeElNotFocusable($el) {
        $el.attr("tabIndex", "-1");
    }
    function addElRole($el, role) {
        $el.attr("role", role);
    }
    function addElRoleDescription($el, description) {
        $el.attr("aria-roledescription", description);
    }
    function addElControls($el, controls) {
        $el.attr("aria-controls", controls);
    }
    function addElLabel($el, label) {
        $el.attr("aria-label", label);
    }
    function addElId($el, id) {
        $el.attr("id", id);
    }
    function addElLive($el, live) {
        $el.attr("aria-live", live);
    }
    function disableEl($el) {
        $el.attr("aria-disabled", true);
    }
    function enableEl($el) {
        $el.attr("aria-disabled", false);
    }
    function onEnterOrSpaceKey(e) {
        if (e.keyCode !== 13 && e.keyCode !== 32) return;
        const params = swiper.params.a11y;
        const $targetEl = (0, $92tgL.default)(e.target);
        if (swiper.navigation && swiper.navigation.$nextEl && $targetEl.is(swiper.navigation.$nextEl)) {
            if (!(swiper.isEnd && !swiper.params.loop)) swiper.slideNext();
            if (swiper.isEnd) notify(params.lastSlideMessage);
            else notify(params.nextSlideMessage);
        }
        if (swiper.navigation && swiper.navigation.$prevEl && $targetEl.is(swiper.navigation.$prevEl)) {
            if (!(swiper.isBeginning && !swiper.params.loop)) swiper.slidePrev();
            if (swiper.isBeginning) notify(params.firstSlideMessage);
            else notify(params.prevSlideMessage);
        }
        if (swiper.pagination && $targetEl.is((0, $gfE23.default)(swiper.params.pagination.bulletClass))) $targetEl[0].click();
    }
    function updateNavigation() {
        if (swiper.params.loop || swiper.params.rewind || !swiper.navigation) return;
        const { $nextEl: $nextEl, $prevEl: $prevEl } = swiper.navigation;
        if ($prevEl && $prevEl.length > 0) {
            if (swiper.isBeginning) {
                disableEl($prevEl);
                makeElNotFocusable($prevEl);
            } else {
                enableEl($prevEl);
                makeElFocusable($prevEl);
            }
        }
        if ($nextEl && $nextEl.length > 0) {
            if (swiper.isEnd) {
                disableEl($nextEl);
                makeElNotFocusable($nextEl);
            } else {
                enableEl($nextEl);
                makeElFocusable($nextEl);
            }
        }
    }
    function hasPagination() {
        return swiper.pagination && swiper.pagination.bullets && swiper.pagination.bullets.length;
    }
    function hasClickablePagination() {
        return hasPagination() && swiper.params.pagination.clickable;
    }
    function updatePagination() {
        const params = swiper.params.a11y;
        if (!hasPagination()) return;
        swiper.pagination.bullets.each((bulletEl)=>{
            const $bulletEl = (0, $92tgL.default)(bulletEl);
            if (swiper.params.pagination.clickable) {
                makeElFocusable($bulletEl);
                if (!swiper.params.pagination.renderBullet) {
                    addElRole($bulletEl, "button");
                    addElLabel($bulletEl, params.paginationBulletMessage.replace(/\{\{index\}\}/, $bulletEl.index() + 1));
                }
            }
            if ($bulletEl.is(`.${swiper.params.pagination.bulletActiveClass}`)) $bulletEl.attr("aria-current", "true");
            else $bulletEl.removeAttr("aria-current");
        });
    }
    const initNavEl = ($el, wrapperId, message)=>{
        makeElFocusable($el);
        if ($el[0].tagName !== "BUTTON") {
            addElRole($el, "button");
            $el.on("keydown", onEnterOrSpaceKey);
        }
        addElLabel($el, message);
        addElControls($el, wrapperId);
    };
    const handlePointerDown = ()=>{
        swiper.a11y.clicked = true;
    };
    const handlePointerUp = ()=>{
        requestAnimationFrame(()=>{
            requestAnimationFrame(()=>{
                if (!swiper.destroyed) swiper.a11y.clicked = false;
            });
        });
    };
    const handleFocus = (e)=>{
        if (swiper.a11y.clicked) return;
        const slideEl = e.target.closest(`.${swiper.params.slideClass}`);
        if (!slideEl || !swiper.slides.includes(slideEl)) return;
        const isActive = swiper.slides.indexOf(slideEl) === swiper.activeIndex;
        const isVisible = swiper.params.watchSlidesProgress && swiper.visibleSlides && swiper.visibleSlides.includes(slideEl);
        if (isActive || isVisible) return;
        if (e.sourceCapabilities && e.sourceCapabilities.firesTouchEvents) return;
        if (swiper.isHorizontal()) swiper.el.scrollLeft = 0;
        else swiper.el.scrollTop = 0;
        swiper.slideTo(swiper.slides.indexOf(slideEl), 0);
    };
    const initSlides = ()=>{
        const params = swiper.params.a11y;
        if (params.itemRoleDescriptionMessage) addElRoleDescription((0, $92tgL.default)(swiper.slides), params.itemRoleDescriptionMessage);
        if (params.slideRole) addElRole((0, $92tgL.default)(swiper.slides), params.slideRole);
        const slidesLength = swiper.params.loop ? swiper.slides.filter((el)=>!el.classList.contains(swiper.params.slideDuplicateClass)).length : swiper.slides.length;
        if (params.slideLabelMessage) swiper.slides.each((slideEl, index)=>{
            const $slideEl = (0, $92tgL.default)(slideEl);
            const slideIndex = swiper.params.loop ? parseInt($slideEl.attr("data-swiper-slide-index"), 10) : index;
            const ariaLabelMessage = params.slideLabelMessage.replace(/\{\{index\}\}/, slideIndex + 1).replace(/\{\{slidesLength\}\}/, slidesLength);
            addElLabel($slideEl, ariaLabelMessage);
        });
    };
    const init = ()=>{
        const params = swiper.params.a11y;
        swiper.$el.append(liveRegion); // Container
        const $containerEl = swiper.$el;
        if (params.containerRoleDescriptionMessage) addElRoleDescription($containerEl, params.containerRoleDescriptionMessage);
        if (params.containerMessage) addElLabel($containerEl, params.containerMessage);
         // Wrapper
        const $wrapperEl = swiper.$wrapperEl;
        const wrapperId = params.id || $wrapperEl.attr("id") || `swiper-wrapper-${getRandomNumber(16)}`;
        const live = swiper.params.autoplay && swiper.params.autoplay.enabled ? "off" : "polite";
        addElId($wrapperEl, wrapperId);
        addElLive($wrapperEl, live); // Slide
        initSlides(); // Navigation
        let $nextEl;
        let $prevEl;
        if (swiper.navigation && swiper.navigation.$nextEl) $nextEl = swiper.navigation.$nextEl;
        if (swiper.navigation && swiper.navigation.$prevEl) $prevEl = swiper.navigation.$prevEl;
        if ($nextEl && $nextEl.length) initNavEl($nextEl, wrapperId, params.nextSlideMessage);
        if ($prevEl && $prevEl.length) initNavEl($prevEl, wrapperId, params.prevSlideMessage);
         // Pagination
        if (hasClickablePagination()) swiper.pagination.$el.on("keydown", (0, $gfE23.default)(swiper.params.pagination.bulletClass), onEnterOrSpaceKey);
         // Tab focus
        swiper.$el.on("focus", handleFocus, true);
        swiper.$el.on("pointerdown", handlePointerDown, true);
        swiper.$el.on("pointerup", handlePointerUp, true);
    };
    function destroy() {
        if (liveRegion && liveRegion.length > 0) liveRegion.remove();
        let $nextEl;
        let $prevEl;
        if (swiper.navigation && swiper.navigation.$nextEl) $nextEl = swiper.navigation.$nextEl;
        if (swiper.navigation && swiper.navigation.$prevEl) $prevEl = swiper.navigation.$prevEl;
        if ($nextEl) $nextEl.off("keydown", onEnterOrSpaceKey);
        if ($prevEl) $prevEl.off("keydown", onEnterOrSpaceKey);
         // Pagination
        if (hasClickablePagination()) swiper.pagination.$el.off("keydown", (0, $gfE23.default)(swiper.params.pagination.bulletClass), onEnterOrSpaceKey);
         // Tab focus
        swiper.$el.off("focus", handleFocus, true);
        swiper.$el.off("pointerdown", handlePointerDown, true);
        swiper.$el.off("pointerup", handlePointerUp, true);
    }
    on("beforeInit", ()=>{
        liveRegion = (0, $92tgL.default)(`<span class="${swiper.params.a11y.notificationClass}" aria-live="assertive" aria-atomic="true"></span>`);
    });
    on("afterInit", ()=>{
        if (!swiper.params.a11y.enabled) return;
        init();
    });
    on("slidesLengthChange snapGridLengthChange slidesGridLengthChange", ()=>{
        if (!swiper.params.a11y.enabled) return;
        initSlides();
    });
    on("fromEdge toEdge afterInit lock unlock", ()=>{
        if (!swiper.params.a11y.enabled) return;
        updateNavigation();
    });
    on("paginationUpdate", ()=>{
        if (!swiper.params.a11y.enabled) return;
        updatePagination();
    });
    on("destroy", ()=>{
        if (!swiper.params.a11y.enabled) return;
        destroy();
    });
}

});

parcelRequire.register("778og", function(module, exports) {

$parcel$export(module.exports, "default", () => $52dfb1fdf9cb24cb$export$2e2bcd8739ae039);

var $bkUxr = parcelRequire("bkUxr");
function $52dfb1fdf9cb24cb$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on }) {
    extendParams({
        history: {
            enabled: false,
            root: "",
            replaceState: false,
            key: "slides",
            keepQuery: false
        }
    });
    let initialized = false;
    let paths = {};
    const slugify = (text)=>{
        return text.toString().replace(/\s+/g, "-").replace(/[^\w-]+/g, "").replace(/--+/g, "-").replace(/^-+/, "").replace(/-+$/, "");
    };
    const getPathValues = (urlOverride)=>{
        const window = (0, $bkUxr.getWindow)();
        let location;
        if (urlOverride) location = new URL(urlOverride);
        else location = window.location;
        const pathArray = location.pathname.slice(1).split("/").filter((part)=>part !== "");
        const total = pathArray.length;
        const key = pathArray[total - 2];
        const value = pathArray[total - 1];
        return {
            key: key,
            value: value
        };
    };
    const setHistory = (key, index)=>{
        const window = (0, $bkUxr.getWindow)();
        if (!initialized || !swiper.params.history.enabled) return;
        let location;
        if (swiper.params.url) location = new URL(swiper.params.url);
        else location = window.location;
        const slide = swiper.slides.eq(index);
        let value = slugify(slide.attr("data-history"));
        if (swiper.params.history.root.length > 0) {
            let root = swiper.params.history.root;
            if (root[root.length - 1] === "/") root = root.slice(0, root.length - 1);
            value = `${root}/${key}/${value}`;
        } else if (!location.pathname.includes(key)) value = `${key}/${value}`;
        if (swiper.params.history.keepQuery) value += location.search;
        const currentState = window.history.state;
        if (currentState && currentState.value === value) return;
        if (swiper.params.history.replaceState) window.history.replaceState({
            value: value
        }, null, value);
        else window.history.pushState({
            value: value
        }, null, value);
    };
    const scrollToSlide = (speed, value, runCallbacks)=>{
        if (value) for(let i = 0, length = swiper.slides.length; i < length; i += 1){
            const slide = swiper.slides.eq(i);
            const slideHistory = slugify(slide.attr("data-history"));
            if (slideHistory === value && !slide.hasClass(swiper.params.slideDuplicateClass)) {
                const index = slide.index();
                swiper.slideTo(index, speed, runCallbacks);
            }
        }
        else swiper.slideTo(0, speed, runCallbacks);
    };
    const setHistoryPopState = ()=>{
        paths = getPathValues(swiper.params.url);
        scrollToSlide(swiper.params.speed, paths.value, false);
    };
    const init = ()=>{
        const window = (0, $bkUxr.getWindow)();
        if (!swiper.params.history) return;
        if (!window.history || !window.history.pushState) {
            swiper.params.history.enabled = false;
            swiper.params.hashNavigation.enabled = true;
            return;
        }
        initialized = true;
        paths = getPathValues(swiper.params.url);
        if (!paths.key && !paths.value) return;
        scrollToSlide(0, paths.value, swiper.params.runCallbacksOnInit);
        if (!swiper.params.history.replaceState) window.addEventListener("popstate", setHistoryPopState);
    };
    const destroy = ()=>{
        const window = (0, $bkUxr.getWindow)();
        if (!swiper.params.history.replaceState) window.removeEventListener("popstate", setHistoryPopState);
    };
    on("init", ()=>{
        if (swiper.params.history.enabled) init();
    });
    on("destroy", ()=>{
        if (swiper.params.history.enabled) destroy();
    });
    on("transitionEnd _freeModeNoMomentumRelease", ()=>{
        if (initialized) setHistory(swiper.params.history.key, swiper.activeIndex);
    });
    on("slideChange", ()=>{
        if (initialized && swiper.params.cssMode) setHistory(swiper.params.history.key, swiper.activeIndex);
    });
}

});

parcelRequire.register("hrgiv", function(module, exports) {

var $bkUxr = parcelRequire("bkUxr");

var $92tgL = parcelRequire("92tgL");
function $cb21999dc6860cfb$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, emit: emit, on: on }) {
    let initialized = false;
    const document = (0, $bkUxr.getDocument)();
    const window = (0, $bkUxr.getWindow)();
    extendParams({
        hashNavigation: {
            enabled: false,
            replaceState: false,
            watchState: false
        }
    });
    const onHashChange = ()=>{
        emit("hashChange");
        const newHash = document.location.hash.replace("#", "");
        const activeSlideHash = swiper.slides.eq(swiper.activeIndex).attr("data-hash");
        if (newHash !== activeSlideHash) {
            const newIndex = swiper.$wrapperEl.children(`.${swiper.params.slideClass}[data-hash="${newHash}"]`).index();
            if (typeof newIndex === "undefined") return;
            swiper.slideTo(newIndex);
        }
    };
    const setHash = ()=>{
        if (!initialized || !swiper.params.hashNavigation.enabled) return;
        if (swiper.params.hashNavigation.replaceState && window.history && window.history.replaceState) {
            window.history.replaceState(null, null, `#${swiper.slides.eq(swiper.activeIndex).attr("data-hash")}` || "");
            emit("hashSet");
        } else {
            const slide = swiper.slides.eq(swiper.activeIndex);
            const hash = slide.attr("data-hash") || slide.attr("data-history");
            document.location.hash = hash || "";
            emit("hashSet");
        }
    };
    const init = ()=>{
        if (!swiper.params.hashNavigation.enabled || swiper.params.history && swiper.params.history.enabled) return;
        initialized = true;
        const hash = document.location.hash.replace("#", "");
        if (hash) {
            const speed = 0;
            for(let i = 0, length = swiper.slides.length; i < length; i += 1){
                const slide = swiper.slides.eq(i);
                const slideHash = slide.attr("data-hash") || slide.attr("data-history");
                if (slideHash === hash && !slide.hasClass(swiper.params.slideDuplicateClass)) {
                    const index = slide.index();
                    swiper.slideTo(index, speed, swiper.params.runCallbacksOnInit, true);
                }
            }
        }
        if (swiper.params.hashNavigation.watchState) (0, $92tgL.default)(window).on("hashchange", onHashChange);
    };
    const destroy = ()=>{
        if (swiper.params.hashNavigation.watchState) (0, $92tgL.default)(window).off("hashchange", onHashChange);
    };
    on("init", ()=>{
        if (swiper.params.hashNavigation.enabled) init();
    });
    on("destroy", ()=>{
        if (swiper.params.hashNavigation.enabled) destroy();
    });
    on("transitionEnd _freeModeNoMomentumRelease", ()=>{
        if (initialized) setHash();
    });
    on("slideChange", ()=>{
        if (initialized && swiper.params.cssMode) setHash();
    });
}

});

parcelRequire.register("cxcfk", function(module, exports) {

$parcel$export(module.exports, "default", () => $920210f6afa05e69$export$2e2bcd8739ae039);
/* eslint no-underscore-dangle: "off" */ /* eslint no-use-before-define: "off" */ 
var $bkUxr = parcelRequire("bkUxr");

var $2y7Cr = parcelRequire("2y7Cr");
function $920210f6afa05e69$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on, emit: emit }) {
    let timeout;
    swiper.autoplay = {
        running: false,
        paused: false
    };
    extendParams({
        autoplay: {
            enabled: false,
            delay: 3000,
            waitForTransition: true,
            disableOnInteraction: true,
            stopOnLastSlide: false,
            reverseDirection: false,
            pauseOnMouseEnter: false
        }
    });
    function run() {
        if (!swiper.size) {
            swiper.autoplay.running = false;
            swiper.autoplay.paused = false;
            return;
        }
        const $activeSlideEl = swiper.slides.eq(swiper.activeIndex);
        let delay = swiper.params.autoplay.delay;
        if ($activeSlideEl.attr("data-swiper-autoplay")) delay = $activeSlideEl.attr("data-swiper-autoplay") || swiper.params.autoplay.delay;
        clearTimeout(timeout);
        timeout = (0, $2y7Cr.nextTick)(()=>{
            let autoplayResult;
            if (swiper.params.autoplay.reverseDirection) {
                if (swiper.params.loop) {
                    swiper.loopFix();
                    autoplayResult = swiper.slidePrev(swiper.params.speed, true, true);
                    emit("autoplay");
                } else if (!swiper.isBeginning) {
                    autoplayResult = swiper.slidePrev(swiper.params.speed, true, true);
                    emit("autoplay");
                } else if (!swiper.params.autoplay.stopOnLastSlide) {
                    autoplayResult = swiper.slideTo(swiper.slides.length - 1, swiper.params.speed, true, true);
                    emit("autoplay");
                } else stop();
            } else if (swiper.params.loop) {
                swiper.loopFix();
                autoplayResult = swiper.slideNext(swiper.params.speed, true, true);
                emit("autoplay");
            } else if (!swiper.isEnd) {
                autoplayResult = swiper.slideNext(swiper.params.speed, true, true);
                emit("autoplay");
            } else if (!swiper.params.autoplay.stopOnLastSlide) {
                autoplayResult = swiper.slideTo(0, swiper.params.speed, true, true);
                emit("autoplay");
            } else stop();
            if (swiper.params.cssMode && swiper.autoplay.running) run();
            else if (autoplayResult === false) run();
        }, delay);
    }
    function start() {
        if (typeof timeout !== "undefined") return false;
        if (swiper.autoplay.running) return false;
        swiper.autoplay.running = true;
        emit("autoplayStart");
        run();
        return true;
    }
    function stop() {
        if (!swiper.autoplay.running) return false;
        if (typeof timeout === "undefined") return false;
        if (timeout) {
            clearTimeout(timeout);
            timeout = undefined;
        }
        swiper.autoplay.running = false;
        emit("autoplayStop");
        return true;
    }
    function pause(speed) {
        if (!swiper.autoplay.running) return;
        if (swiper.autoplay.paused) return;
        if (timeout) clearTimeout(timeout);
        swiper.autoplay.paused = true;
        if (speed === 0 || !swiper.params.autoplay.waitForTransition) {
            swiper.autoplay.paused = false;
            run();
        } else [
            "transitionend",
            "webkitTransitionEnd"
        ].forEach((event)=>{
            swiper.$wrapperEl[0].addEventListener(event, onTransitionEnd);
        });
    }
    function onVisibilityChange() {
        const document = (0, $bkUxr.getDocument)();
        if (document.visibilityState === "hidden" && swiper.autoplay.running) pause();
        if (document.visibilityState === "visible" && swiper.autoplay.paused) {
            run();
            swiper.autoplay.paused = false;
        }
    }
    function onTransitionEnd(e) {
        if (!swiper || swiper.destroyed || !swiper.$wrapperEl) return;
        if (e.target !== swiper.$wrapperEl[0]) return;
        [
            "transitionend",
            "webkitTransitionEnd"
        ].forEach((event)=>{
            swiper.$wrapperEl[0].removeEventListener(event, onTransitionEnd);
        });
        swiper.autoplay.paused = false;
        if (!swiper.autoplay.running) stop();
        else run();
    }
    function onMouseEnter() {
        if (swiper.params.autoplay.disableOnInteraction) stop();
        else {
            emit("autoplayPause");
            pause();
        }
        [
            "transitionend",
            "webkitTransitionEnd"
        ].forEach((event)=>{
            swiper.$wrapperEl[0].removeEventListener(event, onTransitionEnd);
        });
    }
    function onMouseLeave() {
        if (swiper.params.autoplay.disableOnInteraction) return;
        swiper.autoplay.paused = false;
        emit("autoplayResume");
        run();
    }
    function attachMouseEvents() {
        if (swiper.params.autoplay.pauseOnMouseEnter) {
            swiper.$el.on("mouseenter", onMouseEnter);
            swiper.$el.on("mouseleave", onMouseLeave);
        }
    }
    function detachMouseEvents() {
        swiper.$el.off("mouseenter", onMouseEnter);
        swiper.$el.off("mouseleave", onMouseLeave);
    }
    on("init", ()=>{
        if (swiper.params.autoplay.enabled) {
            start();
            const document = (0, $bkUxr.getDocument)();
            document.addEventListener("visibilitychange", onVisibilityChange);
            attachMouseEvents();
        }
    });
    on("beforeTransitionStart", (_s, speed, internal)=>{
        if (swiper.autoplay.running) {
            if (internal || !swiper.params.autoplay.disableOnInteraction) swiper.autoplay.pause(speed);
            else stop();
        }
    });
    on("sliderFirstMove", ()=>{
        if (swiper.autoplay.running) {
            if (swiper.params.autoplay.disableOnInteraction) stop();
            else pause();
        }
    });
    on("touchEnd", ()=>{
        if (swiper.params.cssMode && swiper.autoplay.paused && !swiper.params.autoplay.disableOnInteraction) run();
    });
    on("destroy", ()=>{
        detachMouseEvents();
        if (swiper.autoplay.running) stop();
        const document = (0, $bkUxr.getDocument)();
        document.removeEventListener("visibilitychange", onVisibilityChange);
    });
    Object.assign(swiper.autoplay, {
        pause: pause,
        run: run,
        start: start,
        stop: stop
    });
}

});

parcelRequire.register("b5YZm", function(module, exports) {

var $2y7Cr = parcelRequire("2y7Cr");

var $92tgL = parcelRequire("92tgL");
function $813f786b91d05d2c$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on }) {
    extendParams({
        thumbs: {
            swiper: null,
            multipleActiveThumbs: true,
            autoScrollOffset: 0,
            slideThumbActiveClass: "swiper-slide-thumb-active",
            thumbsContainerClass: "swiper-thumbs"
        }
    });
    let initialized = false;
    let swiperCreated = false;
    swiper.thumbs = {
        swiper: null
    };
    function onThumbClick() {
        const thumbsSwiper = swiper.thumbs.swiper;
        if (!thumbsSwiper || thumbsSwiper.destroyed) return;
        const clickedIndex = thumbsSwiper.clickedIndex;
        const clickedSlide = thumbsSwiper.clickedSlide;
        if (clickedSlide && (0, $92tgL.default)(clickedSlide).hasClass(swiper.params.thumbs.slideThumbActiveClass)) return;
        if (typeof clickedIndex === "undefined" || clickedIndex === null) return;
        let slideToIndex;
        if (thumbsSwiper.params.loop) slideToIndex = parseInt((0, $92tgL.default)(thumbsSwiper.clickedSlide).attr("data-swiper-slide-index"), 10);
        else slideToIndex = clickedIndex;
        if (swiper.params.loop) {
            let currentIndex = swiper.activeIndex;
            if (swiper.slides.eq(currentIndex).hasClass(swiper.params.slideDuplicateClass)) {
                swiper.loopFix(); // eslint-disable-next-line
                swiper._clientLeft = swiper.$wrapperEl[0].clientLeft;
                currentIndex = swiper.activeIndex;
            }
            const prevIndex = swiper.slides.eq(currentIndex).prevAll(`[data-swiper-slide-index="${slideToIndex}"]`).eq(0).index();
            const nextIndex = swiper.slides.eq(currentIndex).nextAll(`[data-swiper-slide-index="${slideToIndex}"]`).eq(0).index();
            if (typeof prevIndex === "undefined") slideToIndex = nextIndex;
            else if (typeof nextIndex === "undefined") slideToIndex = prevIndex;
            else if (nextIndex - currentIndex < currentIndex - prevIndex) slideToIndex = nextIndex;
            else slideToIndex = prevIndex;
        }
        swiper.slideTo(slideToIndex);
    }
    function init() {
        const { thumbs: thumbsParams } = swiper.params;
        if (initialized) return false;
        initialized = true;
        const SwiperClass = swiper.constructor;
        if (thumbsParams.swiper instanceof SwiperClass) {
            swiper.thumbs.swiper = thumbsParams.swiper;
            Object.assign(swiper.thumbs.swiper.originalParams, {
                watchSlidesProgress: true,
                slideToClickedSlide: false
            });
            Object.assign(swiper.thumbs.swiper.params, {
                watchSlidesProgress: true,
                slideToClickedSlide: false
            });
        } else if ((0, $2y7Cr.isObject)(thumbsParams.swiper)) {
            const thumbsSwiperParams = Object.assign({}, thumbsParams.swiper);
            Object.assign(thumbsSwiperParams, {
                watchSlidesProgress: true,
                slideToClickedSlide: false
            });
            swiper.thumbs.swiper = new SwiperClass(thumbsSwiperParams);
            swiperCreated = true;
        }
        swiper.thumbs.swiper.$el.addClass(swiper.params.thumbs.thumbsContainerClass);
        swiper.thumbs.swiper.on("tap", onThumbClick);
        return true;
    }
    function update(initial) {
        const thumbsSwiper = swiper.thumbs.swiper;
        if (!thumbsSwiper || thumbsSwiper.destroyed) return;
        const slidesPerView = thumbsSwiper.params.slidesPerView === "auto" ? thumbsSwiper.slidesPerViewDynamic() : thumbsSwiper.params.slidesPerView; // Activate thumbs
        let thumbsToActivate = 1;
        const thumbActiveClass = swiper.params.thumbs.slideThumbActiveClass;
        if (swiper.params.slidesPerView > 1 && !swiper.params.centeredSlides) thumbsToActivate = swiper.params.slidesPerView;
        if (!swiper.params.thumbs.multipleActiveThumbs) thumbsToActivate = 1;
        thumbsToActivate = Math.floor(thumbsToActivate);
        thumbsSwiper.slides.removeClass(thumbActiveClass);
        if (thumbsSwiper.params.loop || thumbsSwiper.params.virtual && thumbsSwiper.params.virtual.enabled) for(let i = 0; i < thumbsToActivate; i += 1)thumbsSwiper.$wrapperEl.children(`[data-swiper-slide-index="${swiper.realIndex + i}"]`).addClass(thumbActiveClass);
        else for(let i = 0; i < thumbsToActivate; i += 1)thumbsSwiper.slides.eq(swiper.realIndex + i).addClass(thumbActiveClass);
        const autoScrollOffset = swiper.params.thumbs.autoScrollOffset;
        const useOffset = autoScrollOffset && !thumbsSwiper.params.loop;
        if (swiper.realIndex !== thumbsSwiper.realIndex || useOffset) {
            let currentThumbsIndex = thumbsSwiper.activeIndex;
            let newThumbsIndex;
            let direction;
            if (thumbsSwiper.params.loop) {
                if (thumbsSwiper.slides.eq(currentThumbsIndex).hasClass(thumbsSwiper.params.slideDuplicateClass)) {
                    thumbsSwiper.loopFix(); // eslint-disable-next-line
                    thumbsSwiper._clientLeft = thumbsSwiper.$wrapperEl[0].clientLeft;
                    currentThumbsIndex = thumbsSwiper.activeIndex;
                } // Find actual thumbs index to slide to
                const prevThumbsIndex = thumbsSwiper.slides.eq(currentThumbsIndex).prevAll(`[data-swiper-slide-index="${swiper.realIndex}"]`).eq(0).index();
                const nextThumbsIndex = thumbsSwiper.slides.eq(currentThumbsIndex).nextAll(`[data-swiper-slide-index="${swiper.realIndex}"]`).eq(0).index();
                if (typeof prevThumbsIndex === "undefined") newThumbsIndex = nextThumbsIndex;
                else if (typeof nextThumbsIndex === "undefined") newThumbsIndex = prevThumbsIndex;
                else if (nextThumbsIndex - currentThumbsIndex === currentThumbsIndex - prevThumbsIndex) newThumbsIndex = thumbsSwiper.params.slidesPerGroup > 1 ? nextThumbsIndex : currentThumbsIndex;
                else if (nextThumbsIndex - currentThumbsIndex < currentThumbsIndex - prevThumbsIndex) newThumbsIndex = nextThumbsIndex;
                else newThumbsIndex = prevThumbsIndex;
                direction = swiper.activeIndex > swiper.previousIndex ? "next" : "prev";
            } else {
                newThumbsIndex = swiper.realIndex;
                direction = newThumbsIndex > swiper.previousIndex ? "next" : "prev";
            }
            if (useOffset) newThumbsIndex += direction === "next" ? autoScrollOffset : -1 * autoScrollOffset;
            if (thumbsSwiper.visibleSlidesIndexes && thumbsSwiper.visibleSlidesIndexes.indexOf(newThumbsIndex) < 0) {
                if (thumbsSwiper.params.centeredSlides) {
                    if (newThumbsIndex > currentThumbsIndex) newThumbsIndex = newThumbsIndex - Math.floor(slidesPerView / 2) + 1;
                    else newThumbsIndex = newThumbsIndex + Math.floor(slidesPerView / 2) - 1;
                } else newThumbsIndex > currentThumbsIndex && thumbsSwiper.params.slidesPerGroup;
                thumbsSwiper.slideTo(newThumbsIndex, initial ? 0 : undefined);
            }
        }
    }
    on("beforeInit", ()=>{
        const { thumbs: thumbs } = swiper.params;
        if (!thumbs || !thumbs.swiper) return;
        init();
        update(true);
    });
    on("slideChange update resize observerUpdate", ()=>{
        update();
    });
    on("setTransition", (_s, duration)=>{
        const thumbsSwiper = swiper.thumbs.swiper;
        if (!thumbsSwiper || thumbsSwiper.destroyed) return;
        thumbsSwiper.setTransition(duration);
    });
    on("beforeDestroy", ()=>{
        const thumbsSwiper = swiper.thumbs.swiper;
        if (!thumbsSwiper || thumbsSwiper.destroyed) return;
        if (swiperCreated) thumbsSwiper.destroy();
    });
    Object.assign(swiper.thumbs, {
        init: init,
        update: update
    });
}

});

parcelRequire.register("4k2DK", function(module, exports) {

var $2y7Cr = parcelRequire("2y7Cr");
function $325b13f6602208e5$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, emit: emit, once: once }) {
    extendParams({
        freeMode: {
            enabled: false,
            momentum: true,
            momentumRatio: 1,
            momentumBounce: true,
            momentumBounceRatio: 1,
            momentumVelocityRatio: 1,
            sticky: false,
            minimumVelocity: 0.02
        }
    });
    function onTouchStart() {
        const translate = swiper.getTranslate();
        swiper.setTranslate(translate);
        swiper.setTransition(0);
        swiper.touchEventsData.velocities.length = 0;
        swiper.freeMode.onTouchEnd({
            currentPos: swiper.rtl ? swiper.translate : -swiper.translate
        });
    }
    function onTouchMove() {
        const { touchEventsData: data, touches: touches } = swiper; // Velocity
        if (data.velocities.length === 0) data.velocities.push({
            position: touches[swiper.isHorizontal() ? "startX" : "startY"],
            time: data.touchStartTime
        });
        data.velocities.push({
            position: touches[swiper.isHorizontal() ? "currentX" : "currentY"],
            time: (0, $2y7Cr.now)()
        });
    }
    function onTouchEnd({ currentPos: currentPos }) {
        const { params: params, $wrapperEl: $wrapperEl, rtlTranslate: rtl, snapGrid: snapGrid, touchEventsData: data } = swiper; // Time diff
        const touchEndTime = (0, $2y7Cr.now)();
        const timeDiff = touchEndTime - data.touchStartTime;
        if (currentPos < -swiper.minTranslate()) {
            swiper.slideTo(swiper.activeIndex);
            return;
        }
        if (currentPos > -swiper.maxTranslate()) {
            if (swiper.slides.length < snapGrid.length) swiper.slideTo(snapGrid.length - 1);
            else swiper.slideTo(swiper.slides.length - 1);
            return;
        }
        if (params.freeMode.momentum) {
            if (data.velocities.length > 1) {
                const lastMoveEvent = data.velocities.pop();
                const velocityEvent = data.velocities.pop();
                const distance = lastMoveEvent.position - velocityEvent.position;
                const time = lastMoveEvent.time - velocityEvent.time;
                swiper.velocity = distance / time;
                swiper.velocity /= 2;
                if (Math.abs(swiper.velocity) < params.freeMode.minimumVelocity) swiper.velocity = 0;
                 // this implies that the user stopped moving a finger then released.
                // There would be no events with distance zero, so the last event is stale.
                if (time > 150 || (0, $2y7Cr.now)() - lastMoveEvent.time > 300) swiper.velocity = 0;
            } else swiper.velocity = 0;
            swiper.velocity *= params.freeMode.momentumVelocityRatio;
            data.velocities.length = 0;
            let momentumDuration = 1000 * params.freeMode.momentumRatio;
            const momentumDistance = swiper.velocity * momentumDuration;
            let newPosition = swiper.translate + momentumDistance;
            if (rtl) newPosition = -newPosition;
            let doBounce = false;
            let afterBouncePosition;
            const bounceAmount = Math.abs(swiper.velocity) * 20 * params.freeMode.momentumBounceRatio;
            let needsLoopFix;
            if (newPosition < swiper.maxTranslate()) {
                if (params.freeMode.momentumBounce) {
                    if (newPosition + swiper.maxTranslate() < -bounceAmount) newPosition = swiper.maxTranslate() - bounceAmount;
                    afterBouncePosition = swiper.maxTranslate();
                    doBounce = true;
                    data.allowMomentumBounce = true;
                } else newPosition = swiper.maxTranslate();
                if (params.loop && params.centeredSlides) needsLoopFix = true;
            } else if (newPosition > swiper.minTranslate()) {
                if (params.freeMode.momentumBounce) {
                    if (newPosition - swiper.minTranslate() > bounceAmount) newPosition = swiper.minTranslate() + bounceAmount;
                    afterBouncePosition = swiper.minTranslate();
                    doBounce = true;
                    data.allowMomentumBounce = true;
                } else newPosition = swiper.minTranslate();
                if (params.loop && params.centeredSlides) needsLoopFix = true;
            } else if (params.freeMode.sticky) {
                let nextSlide;
                for(let j = 0; j < snapGrid.length; j += 1)if (snapGrid[j] > -newPosition) {
                    nextSlide = j;
                    break;
                }
                if (Math.abs(snapGrid[nextSlide] - newPosition) < Math.abs(snapGrid[nextSlide - 1] - newPosition) || swiper.swipeDirection === "next") newPosition = snapGrid[nextSlide];
                else newPosition = snapGrid[nextSlide - 1];
                newPosition = -newPosition;
            }
            if (needsLoopFix) once("transitionEnd", ()=>{
                swiper.loopFix();
            });
             // Fix duration
            if (swiper.velocity !== 0) {
                if (rtl) momentumDuration = Math.abs((-newPosition - swiper.translate) / swiper.velocity);
                else momentumDuration = Math.abs((newPosition - swiper.translate) / swiper.velocity);
                if (params.freeMode.sticky) {
                    // If freeMode.sticky is active and the user ends a swipe with a slow-velocity
                    // event, then durations can be 20+ seconds to slide one (or zero!) slides.
                    // It's easy to see this when simulating touch with mouse events. To fix this,
                    // limit single-slide swipes to the default slide duration. This also has the
                    // nice side effect of matching slide speed if the user stopped moving before
                    // lifting finger or mouse vs. moving slowly before lifting the finger/mouse.
                    // For faster swipes, also apply limits (albeit higher ones).
                    const moveDistance = Math.abs((rtl ? -newPosition : newPosition) - swiper.translate);
                    const currentSlideSize = swiper.slidesSizesGrid[swiper.activeIndex];
                    if (moveDistance < currentSlideSize) momentumDuration = params.speed;
                    else if (moveDistance < 2 * currentSlideSize) momentumDuration = params.speed * 1.5;
                    else momentumDuration = params.speed * 2.5;
                }
            } else if (params.freeMode.sticky) {
                swiper.slideToClosest();
                return;
            }
            if (params.freeMode.momentumBounce && doBounce) {
                swiper.updateProgress(afterBouncePosition);
                swiper.setTransition(momentumDuration);
                swiper.setTranslate(newPosition);
                swiper.transitionStart(true, swiper.swipeDirection);
                swiper.animating = true;
                $wrapperEl.transitionEnd(()=>{
                    if (!swiper || swiper.destroyed || !data.allowMomentumBounce) return;
                    emit("momentumBounce");
                    swiper.setTransition(params.speed);
                    setTimeout(()=>{
                        swiper.setTranslate(afterBouncePosition);
                        $wrapperEl.transitionEnd(()=>{
                            if (!swiper || swiper.destroyed) return;
                            swiper.transitionEnd();
                        });
                    }, 0);
                });
            } else if (swiper.velocity) {
                emit("_freeModeNoMomentumRelease");
                swiper.updateProgress(newPosition);
                swiper.setTransition(momentumDuration);
                swiper.setTranslate(newPosition);
                swiper.transitionStart(true, swiper.swipeDirection);
                if (!swiper.animating) {
                    swiper.animating = true;
                    $wrapperEl.transitionEnd(()=>{
                        if (!swiper || swiper.destroyed) return;
                        swiper.transitionEnd();
                    });
                }
            } else swiper.updateProgress(newPosition);
            swiper.updateActiveIndex();
            swiper.updateSlidesClasses();
        } else if (params.freeMode.sticky) {
            swiper.slideToClosest();
            return;
        } else if (params.freeMode) emit("_freeModeNoMomentumRelease");
        if (!params.freeMode.momentum || timeDiff >= params.longSwipesMs) {
            swiper.updateProgress();
            swiper.updateActiveIndex();
            swiper.updateSlidesClasses();
        }
    }
    Object.assign(swiper, {
        freeMode: {
            onTouchStart: onTouchStart,
            onTouchMove: onTouchMove,
            onTouchEnd: onTouchEnd
        }
    });
}

});

parcelRequire.register("2DgAz", function(module, exports) {
function $1eac177c4db08f51$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams }) {
    extendParams({
        grid: {
            rows: 1,
            fill: "column"
        }
    });
    let slidesNumberEvenToRows;
    let slidesPerRow;
    let numFullColumns;
    const initSlides = (slidesLength)=>{
        const { slidesPerView: slidesPerView } = swiper.params;
        const { rows: rows, fill: fill } = swiper.params.grid;
        slidesPerRow = slidesNumberEvenToRows / rows;
        numFullColumns = Math.floor(slidesLength / rows);
        if (Math.floor(slidesLength / rows) === slidesLength / rows) slidesNumberEvenToRows = slidesLength;
        else slidesNumberEvenToRows = Math.ceil(slidesLength / rows) * rows;
        if (slidesPerView !== "auto" && fill === "row") slidesNumberEvenToRows = Math.max(slidesNumberEvenToRows, slidesPerView * rows);
    };
    const updateSlide = (i, slide, slidesLength, getDirectionLabel)=>{
        const { slidesPerGroup: slidesPerGroup, spaceBetween: spaceBetween } = swiper.params;
        const { rows: rows, fill: fill } = swiper.params.grid; // Set slides order
        let newSlideOrderIndex;
        let column;
        let row;
        if (fill === "row" && slidesPerGroup > 1) {
            const groupIndex = Math.floor(i / (slidesPerGroup * rows));
            const slideIndexInGroup = i - rows * slidesPerGroup * groupIndex;
            const columnsInGroup = groupIndex === 0 ? slidesPerGroup : Math.min(Math.ceil((slidesLength - groupIndex * rows * slidesPerGroup) / rows), slidesPerGroup);
            row = Math.floor(slideIndexInGroup / columnsInGroup);
            column = slideIndexInGroup - row * columnsInGroup + groupIndex * slidesPerGroup;
            newSlideOrderIndex = column + row * slidesNumberEvenToRows / rows;
            slide.css({
                "-webkit-order": newSlideOrderIndex,
                order: newSlideOrderIndex
            });
        } else if (fill === "column") {
            column = Math.floor(i / rows);
            row = i - column * rows;
            if (column > numFullColumns || column === numFullColumns && row === rows - 1) {
                row += 1;
                if (row >= rows) {
                    row = 0;
                    column += 1;
                }
            }
        } else {
            row = Math.floor(i / slidesPerRow);
            column = i - row * slidesPerRow;
        }
        slide.css(getDirectionLabel("margin-top"), row !== 0 ? spaceBetween && `${spaceBetween}px` : "");
    };
    const updateWrapperSize = (slideSize, snapGrid, getDirectionLabel)=>{
        const { spaceBetween: spaceBetween, centeredSlides: centeredSlides, roundLengths: roundLengths } = swiper.params;
        const { rows: rows } = swiper.params.grid;
        swiper.virtualSize = (slideSize + spaceBetween) * slidesNumberEvenToRows;
        swiper.virtualSize = Math.ceil(swiper.virtualSize / rows) - spaceBetween;
        swiper.$wrapperEl.css({
            [getDirectionLabel("width")]: `${swiper.virtualSize + spaceBetween}px`
        });
        if (centeredSlides) {
            snapGrid.splice(0, snapGrid.length);
            const newSlidesGrid = [];
            for(let i = 0; i < snapGrid.length; i += 1){
                let slidesGridItem = snapGrid[i];
                if (roundLengths) slidesGridItem = Math.floor(slidesGridItem);
                if (snapGrid[i] < swiper.virtualSize + snapGrid[0]) newSlidesGrid.push(slidesGridItem);
            }
            snapGrid.push(...newSlidesGrid);
        }
    };
    swiper.grid = {
        initSlides: initSlides,
        updateSlide: updateSlide,
        updateWrapperSize: updateWrapperSize
    };
}

});

parcelRequire.register("bknU5", function(module, exports) {

var $8hfb2 = parcelRequire("8hfb2");

var $kLErj = parcelRequire("kLErj");

var $83sFc = parcelRequire("83sFc");

var $44FQ1 = parcelRequire("44FQ1");

var $dkpnW = parcelRequire("dkpnW");
function $83f41abbe05a46dc$export$2e2bcd8739ae039({ swiper: swiper }) {
    Object.assign(swiper, {
        appendSlide: (0, $8hfb2.default).bind(swiper),
        prependSlide: (0, $kLErj.default).bind(swiper),
        addSlide: (0, $83sFc.default).bind(swiper),
        removeSlide: (0, $44FQ1.default).bind(swiper),
        removeAllSlides: (0, $dkpnW.default).bind(swiper)
    });
}

});
parcelRequire.register("8hfb2", function(module, exports) {

$parcel$export(module.exports, "default", () => $018e1fba55491c95$export$2e2bcd8739ae039);
function $018e1fba55491c95$export$2e2bcd8739ae039(slides) {
    const swiper = this;
    const { $wrapperEl: $wrapperEl, params: params } = swiper;
    if (params.loop) swiper.loopDestroy();
    if (typeof slides === "object" && "length" in slides) {
        for(let i = 0; i < slides.length; i += 1)if (slides[i]) $wrapperEl.append(slides[i]);
    } else $wrapperEl.append(slides);
    if (params.loop) swiper.loopCreate();
    if (!params.observer) swiper.update();
}

});

parcelRequire.register("kLErj", function(module, exports) {

$parcel$export(module.exports, "default", () => $f1e790dd9beba468$export$2e2bcd8739ae039);
function $f1e790dd9beba468$export$2e2bcd8739ae039(slides) {
    const swiper = this;
    const { params: params, $wrapperEl: $wrapperEl, activeIndex: activeIndex } = swiper;
    if (params.loop) swiper.loopDestroy();
    let newActiveIndex = activeIndex + 1;
    if (typeof slides === "object" && "length" in slides) {
        for(let i = 0; i < slides.length; i += 1)if (slides[i]) $wrapperEl.prepend(slides[i]);
        newActiveIndex = activeIndex + slides.length;
    } else $wrapperEl.prepend(slides);
    if (params.loop) swiper.loopCreate();
    if (!params.observer) swiper.update();
    swiper.slideTo(newActiveIndex, 0, false);
}

});

parcelRequire.register("83sFc", function(module, exports) {

$parcel$export(module.exports, "default", () => $5dd4d68476f48cd2$export$2e2bcd8739ae039);
function $5dd4d68476f48cd2$export$2e2bcd8739ae039(index, slides) {
    const swiper = this;
    const { $wrapperEl: $wrapperEl, params: params, activeIndex: activeIndex } = swiper;
    let activeIndexBuffer = activeIndex;
    if (params.loop) {
        activeIndexBuffer -= swiper.loopedSlides;
        swiper.loopDestroy();
        swiper.slides = $wrapperEl.children(`.${params.slideClass}`);
    }
    const baseLength = swiper.slides.length;
    if (index <= 0) {
        swiper.prependSlide(slides);
        return;
    }
    if (index >= baseLength) {
        swiper.appendSlide(slides);
        return;
    }
    let newActiveIndex = activeIndexBuffer > index ? activeIndexBuffer + 1 : activeIndexBuffer;
    const slidesBuffer = [];
    for(let i = baseLength - 1; i >= index; i -= 1){
        const currentSlide = swiper.slides.eq(i);
        currentSlide.remove();
        slidesBuffer.unshift(currentSlide);
    }
    if (typeof slides === "object" && "length" in slides) {
        for(let i = 0; i < slides.length; i += 1)if (slides[i]) $wrapperEl.append(slides[i]);
        newActiveIndex = activeIndexBuffer > index ? activeIndexBuffer + slides.length : activeIndexBuffer;
    } else $wrapperEl.append(slides);
    for(let i = 0; i < slidesBuffer.length; i += 1)$wrapperEl.append(slidesBuffer[i]);
    if (params.loop) swiper.loopCreate();
    if (!params.observer) swiper.update();
    if (params.loop) swiper.slideTo(newActiveIndex + swiper.loopedSlides, 0, false);
    else swiper.slideTo(newActiveIndex, 0, false);
}

});

parcelRequire.register("44FQ1", function(module, exports) {

$parcel$export(module.exports, "default", () => $2f77fd4d464f46b9$export$2e2bcd8739ae039);
function $2f77fd4d464f46b9$export$2e2bcd8739ae039(slidesIndexes) {
    const swiper = this;
    const { params: params, $wrapperEl: $wrapperEl, activeIndex: activeIndex } = swiper;
    let activeIndexBuffer = activeIndex;
    if (params.loop) {
        activeIndexBuffer -= swiper.loopedSlides;
        swiper.loopDestroy();
        swiper.slides = $wrapperEl.children(`.${params.slideClass}`);
    }
    let newActiveIndex = activeIndexBuffer;
    let indexToRemove;
    if (typeof slidesIndexes === "object" && "length" in slidesIndexes) {
        for(let i = 0; i < slidesIndexes.length; i += 1){
            indexToRemove = slidesIndexes[i];
            if (swiper.slides[indexToRemove]) swiper.slides.eq(indexToRemove).remove();
            if (indexToRemove < newActiveIndex) newActiveIndex -= 1;
        }
        newActiveIndex = Math.max(newActiveIndex, 0);
    } else {
        indexToRemove = slidesIndexes;
        if (swiper.slides[indexToRemove]) swiper.slides.eq(indexToRemove).remove();
        if (indexToRemove < newActiveIndex) newActiveIndex -= 1;
        newActiveIndex = Math.max(newActiveIndex, 0);
    }
    if (params.loop) swiper.loopCreate();
    if (!params.observer) swiper.update();
    if (params.loop) swiper.slideTo(newActiveIndex + swiper.loopedSlides, 0, false);
    else swiper.slideTo(newActiveIndex, 0, false);
}

});

parcelRequire.register("dkpnW", function(module, exports) {

$parcel$export(module.exports, "default", () => $9b40d595d8d45c73$export$2e2bcd8739ae039);
function $9b40d595d8d45c73$export$2e2bcd8739ae039() {
    const swiper = this;
    const slidesIndexes = [];
    for(let i = 0; i < swiper.slides.length; i += 1)slidesIndexes.push(i);
    swiper.removeSlide(slidesIndexes);
}

});


parcelRequire.register("akUfl", function(module, exports) {

var $bE5GA = parcelRequire("bE5GA");

var $g8tGM = parcelRequire("g8tGM");

var $4a9Du = parcelRequire("4a9Du");
function $7867670c08bdf7d3$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on }) {
    extendParams({
        fadeEffect: {
            crossFade: false,
            transformEl: null
        }
    });
    const setTranslate = ()=>{
        const { slides: slides } = swiper;
        const params = swiper.params.fadeEffect;
        for(let i = 0; i < slides.length; i += 1){
            const $slideEl = swiper.slides.eq(i);
            const offset = $slideEl[0].swiperSlideOffset;
            let tx = -offset;
            if (!swiper.params.virtualTranslate) tx -= swiper.translate;
            let ty = 0;
            if (!swiper.isHorizontal()) {
                ty = tx;
                tx = 0;
            }
            const slideOpacity = swiper.params.fadeEffect.crossFade ? Math.max(1 - Math.abs($slideEl[0].progress), 0) : 1 + Math.min(Math.max($slideEl[0].progress, -1), 0);
            const $targetEl = (0, $g8tGM.default)(params, $slideEl);
            $targetEl.css({
                opacity: slideOpacity
            }).transform(`translate3d(${tx}px, ${ty}px, 0px)`);
        }
    };
    const setTransition = (duration)=>{
        const { transformEl: transformEl } = swiper.params.fadeEffect;
        const $transitionElements = transformEl ? swiper.slides.find(transformEl) : swiper.slides;
        $transitionElements.transition(duration);
        (0, $4a9Du.default)({
            swiper: swiper,
            duration: duration,
            transformEl: transformEl,
            allSlides: true
        });
    };
    (0, $bE5GA.default)({
        effect: "fade",
        swiper: swiper,
        on: on,
        setTranslate: setTranslate,
        setTransition: setTransition,
        overwriteParams: ()=>({
                slidesPerView: 1,
                slidesPerGroup: 1,
                watchSlidesProgress: true,
                spaceBetween: 0,
                virtualTranslate: !swiper.params.cssMode
            })
    });
}

});
parcelRequire.register("bE5GA", function(module, exports) {

$parcel$export(module.exports, "default", () => $87a7d73b72dcd5e0$export$2e2bcd8739ae039);
function $87a7d73b72dcd5e0$export$2e2bcd8739ae039(params) {
    const { effect: effect, swiper: swiper, on: on, setTranslate: setTranslate, setTransition: setTransition, overwriteParams: overwriteParams, perspective: perspective, recreateShadows: recreateShadows, getEffectParams: getEffectParams } = params;
    on("beforeInit", ()=>{
        if (swiper.params.effect !== effect) return;
        swiper.classNames.push(`${swiper.params.containerModifierClass}${effect}`);
        if (perspective && perspective()) swiper.classNames.push(`${swiper.params.containerModifierClass}3d`);
        const overwriteParamsResult = overwriteParams ? overwriteParams() : {};
        Object.assign(swiper.params, overwriteParamsResult);
        Object.assign(swiper.originalParams, overwriteParamsResult);
    });
    on("setTranslate", ()=>{
        if (swiper.params.effect !== effect) return;
        setTranslate();
    });
    on("setTransition", (_s, duration)=>{
        if (swiper.params.effect !== effect) return;
        setTransition(duration);
    });
    on("transitionEnd", ()=>{
        if (swiper.params.effect !== effect) return;
        if (recreateShadows) {
            if (!getEffectParams || !getEffectParams().slideShadows) return; // remove shadows
            swiper.slides.each((slideEl)=>{
                const $slideEl = swiper.$(slideEl);
                $slideEl.find(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").remove();
            }); // create new one
            recreateShadows();
        }
    });
    let requireUpdateOnVirtual;
    on("virtualUpdate", ()=>{
        if (swiper.params.effect !== effect) return;
        if (!swiper.slides.length) requireUpdateOnVirtual = true;
        requestAnimationFrame(()=>{
            if (requireUpdateOnVirtual && swiper.slides && swiper.slides.length) {
                setTranslate();
                requireUpdateOnVirtual = false;
            }
        });
    });
}

});

parcelRequire.register("g8tGM", function(module, exports) {

$parcel$export(module.exports, "default", () => $bbf46c564f666a3e$export$2e2bcd8739ae039);
function $bbf46c564f666a3e$export$2e2bcd8739ae039(effectParams, $slideEl) {
    if (effectParams.transformEl) return $slideEl.find(effectParams.transformEl).css({
        "backface-visibility": "hidden",
        "-webkit-backface-visibility": "hidden"
    });
    return $slideEl;
}

});

parcelRequire.register("4a9Du", function(module, exports) {

$parcel$export(module.exports, "default", () => $307f92150e1648b0$export$2e2bcd8739ae039);
function $307f92150e1648b0$export$2e2bcd8739ae039({ swiper: swiper, duration: duration, transformEl: transformEl, allSlides: allSlides }) {
    const { slides: slides, activeIndex: activeIndex, $wrapperEl: $wrapperEl } = swiper;
    if (swiper.params.virtualTranslate && duration !== 0) {
        let eventTriggered = false;
        let $transitionEndTarget;
        if (allSlides) $transitionEndTarget = transformEl ? slides.find(transformEl) : slides;
        else $transitionEndTarget = transformEl ? slides.eq(activeIndex).find(transformEl) : slides.eq(activeIndex);
        $transitionEndTarget.transitionEnd(()=>{
            if (eventTriggered) return;
            if (!swiper || swiper.destroyed) return;
            eventTriggered = true;
            swiper.animating = false;
            const triggerEvents = [
                "webkitTransitionEnd",
                "transitionend"
            ];
            for(let i = 0; i < triggerEvents.length; i += 1)$wrapperEl.trigger(triggerEvents[i]);
        });
    }
}

});


parcelRequire.register("j75JS", function(module, exports) {

var $92tgL = parcelRequire("92tgL");

var $bE5GA = parcelRequire("bE5GA");
function $dea31f66b6ff27dc$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on }) {
    extendParams({
        cubeEffect: {
            slideShadows: true,
            shadow: true,
            shadowOffset: 20,
            shadowScale: 0.94
        }
    });
    const createSlideShadows = ($slideEl, progress, isHorizontal)=>{
        let shadowBefore = isHorizontal ? $slideEl.find(".swiper-slide-shadow-left") : $slideEl.find(".swiper-slide-shadow-top");
        let shadowAfter = isHorizontal ? $slideEl.find(".swiper-slide-shadow-right") : $slideEl.find(".swiper-slide-shadow-bottom");
        if (shadowBefore.length === 0) {
            shadowBefore = (0, $92tgL.default)(`<div class="swiper-slide-shadow-${isHorizontal ? "left" : "top"}"></div>`);
            $slideEl.append(shadowBefore);
        }
        if (shadowAfter.length === 0) {
            shadowAfter = (0, $92tgL.default)(`<div class="swiper-slide-shadow-${isHorizontal ? "right" : "bottom"}"></div>`);
            $slideEl.append(shadowAfter);
        }
        if (shadowBefore.length) shadowBefore[0].style.opacity = Math.max(-progress, 0);
        if (shadowAfter.length) shadowAfter[0].style.opacity = Math.max(progress, 0);
    };
    const recreateShadows = ()=>{
        // create new ones
        const isHorizontal = swiper.isHorizontal();
        swiper.slides.each((slideEl)=>{
            const progress = Math.max(Math.min(slideEl.progress, 1), -1);
            createSlideShadows((0, $92tgL.default)(slideEl), progress, isHorizontal);
        });
    };
    const setTranslate = ()=>{
        const { $el: $el, $wrapperEl: $wrapperEl, slides: slides, width: swiperWidth, height: swiperHeight, rtlTranslate: rtl, size: swiperSize, browser: browser } = swiper;
        const params = swiper.params.cubeEffect;
        const isHorizontal = swiper.isHorizontal();
        const isVirtual = swiper.virtual && swiper.params.virtual.enabled;
        let wrapperRotate = 0;
        let $cubeShadowEl;
        if (params.shadow) {
            if (isHorizontal) {
                $cubeShadowEl = $wrapperEl.find(".swiper-cube-shadow");
                if ($cubeShadowEl.length === 0) {
                    $cubeShadowEl = (0, $92tgL.default)('<div class="swiper-cube-shadow"></div>');
                    $wrapperEl.append($cubeShadowEl);
                }
                $cubeShadowEl.css({
                    height: `${swiperWidth}px`
                });
            } else {
                $cubeShadowEl = $el.find(".swiper-cube-shadow");
                if ($cubeShadowEl.length === 0) {
                    $cubeShadowEl = (0, $92tgL.default)('<div class="swiper-cube-shadow"></div>');
                    $el.append($cubeShadowEl);
                }
            }
        }
        for(let i = 0; i < slides.length; i += 1){
            const $slideEl = slides.eq(i);
            let slideIndex = i;
            if (isVirtual) slideIndex = parseInt($slideEl.attr("data-swiper-slide-index"), 10);
            let slideAngle = slideIndex * 90;
            let round = Math.floor(slideAngle / 360);
            if (rtl) {
                slideAngle = -slideAngle;
                round = Math.floor(-slideAngle / 360);
            }
            const progress = Math.max(Math.min($slideEl[0].progress, 1), -1);
            let tx = 0;
            let ty = 0;
            let tz = 0;
            if (slideIndex % 4 === 0) {
                tx = -round * 4 * swiperSize;
                tz = 0;
            } else if ((slideIndex - 1) % 4 === 0) {
                tx = 0;
                tz = -round * 4 * swiperSize;
            } else if ((slideIndex - 2) % 4 === 0) {
                tx = swiperSize + round * 4 * swiperSize;
                tz = swiperSize;
            } else if ((slideIndex - 3) % 4 === 0) {
                tx = -swiperSize;
                tz = 3 * swiperSize + swiperSize * 4 * round;
            }
            if (rtl) tx = -tx;
            if (!isHorizontal) {
                ty = tx;
                tx = 0;
            }
            const transform = `rotateX(${isHorizontal ? 0 : -slideAngle}deg) rotateY(${isHorizontal ? slideAngle : 0}deg) translate3d(${tx}px, ${ty}px, ${tz}px)`;
            if (progress <= 1 && progress > -1) {
                wrapperRotate = slideIndex * 90 + progress * 90;
                if (rtl) wrapperRotate = -slideIndex * 90 - progress * 90;
            }
            $slideEl.transform(transform);
            if (params.slideShadows) createSlideShadows($slideEl, progress, isHorizontal);
        }
        $wrapperEl.css({
            "-webkit-transform-origin": `50% 50% -${swiperSize / 2}px`,
            "transform-origin": `50% 50% -${swiperSize / 2}px`
        });
        if (params.shadow) {
            if (isHorizontal) $cubeShadowEl.transform(`translate3d(0px, ${swiperWidth / 2 + params.shadowOffset}px, ${-swiperWidth / 2}px) rotateX(90deg) rotateZ(0deg) scale(${params.shadowScale})`);
            else {
                const shadowAngle = Math.abs(wrapperRotate) - Math.floor(Math.abs(wrapperRotate) / 90) * 90;
                const multiplier = 1.5 - (Math.sin(shadowAngle * 2 * Math.PI / 360) / 2 + Math.cos(shadowAngle * 2 * Math.PI / 360) / 2);
                const scale1 = params.shadowScale;
                const scale2 = params.shadowScale / multiplier;
                const offset = params.shadowOffset;
                $cubeShadowEl.transform(`scale3d(${scale1}, 1, ${scale2}) translate3d(0px, ${swiperHeight / 2 + offset}px, ${-swiperHeight / 2 / scale2}px) rotateX(-90deg)`);
            }
        }
        const zFactor = browser.isSafari || browser.isWebView ? -swiperSize / 2 : 0;
        $wrapperEl.transform(`translate3d(0px,0,${zFactor}px) rotateX(${swiper.isHorizontal() ? 0 : wrapperRotate}deg) rotateY(${swiper.isHorizontal() ? -wrapperRotate : 0}deg)`);
        $wrapperEl[0].style.setProperty("--swiper-cube-translate-z", `${zFactor}px`);
    };
    const setTransition = (duration)=>{
        const { $el: $el, slides: slides } = swiper;
        slides.transition(duration).find(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").transition(duration);
        if (swiper.params.cubeEffect.shadow && !swiper.isHorizontal()) $el.find(".swiper-cube-shadow").transition(duration);
    };
    (0, $bE5GA.default)({
        effect: "cube",
        swiper: swiper,
        on: on,
        setTranslate: setTranslate,
        setTransition: setTransition,
        recreateShadows: recreateShadows,
        getEffectParams: ()=>swiper.params.cubeEffect,
        perspective: ()=>true,
        overwriteParams: ()=>({
                slidesPerView: 1,
                slidesPerGroup: 1,
                watchSlidesProgress: true,
                resistanceRatio: 0,
                spaceBetween: 0,
                centeredSlides: false,
                virtualTranslate: true
            })
    });
}

});

parcelRequire.register("iOZIt", function(module, exports) {

var $92tgL = parcelRequire("92tgL");

var $dUAVu = parcelRequire("dUAVu");

var $bE5GA = parcelRequire("bE5GA");

var $g8tGM = parcelRequire("g8tGM");

var $4a9Du = parcelRequire("4a9Du");
function $db3cc51b0eedb106$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on }) {
    extendParams({
        flipEffect: {
            slideShadows: true,
            limitRotation: true,
            transformEl: null
        }
    });
    const createSlideShadows = ($slideEl, progress, params)=>{
        let shadowBefore = swiper.isHorizontal() ? $slideEl.find(".swiper-slide-shadow-left") : $slideEl.find(".swiper-slide-shadow-top");
        let shadowAfter = swiper.isHorizontal() ? $slideEl.find(".swiper-slide-shadow-right") : $slideEl.find(".swiper-slide-shadow-bottom");
        if (shadowBefore.length === 0) shadowBefore = (0, $dUAVu.default)(params, $slideEl, swiper.isHorizontal() ? "left" : "top");
        if (shadowAfter.length === 0) shadowAfter = (0, $dUAVu.default)(params, $slideEl, swiper.isHorizontal() ? "right" : "bottom");
        if (shadowBefore.length) shadowBefore[0].style.opacity = Math.max(-progress, 0);
        if (shadowAfter.length) shadowAfter[0].style.opacity = Math.max(progress, 0);
    };
    const recreateShadows = ()=>{
        // Set shadows
        const params = swiper.params.flipEffect;
        swiper.slides.each((slideEl)=>{
            const $slideEl = (0, $92tgL.default)(slideEl);
            let progress = $slideEl[0].progress;
            if (swiper.params.flipEffect.limitRotation) progress = Math.max(Math.min(slideEl.progress, 1), -1);
            createSlideShadows($slideEl, progress, params);
        });
    };
    const setTranslate = ()=>{
        const { slides: slides, rtlTranslate: rtl } = swiper;
        const params = swiper.params.flipEffect;
        for(let i = 0; i < slides.length; i += 1){
            const $slideEl = slides.eq(i);
            let progress = $slideEl[0].progress;
            if (swiper.params.flipEffect.limitRotation) progress = Math.max(Math.min($slideEl[0].progress, 1), -1);
            const offset = $slideEl[0].swiperSlideOffset;
            const rotate = -180 * progress;
            let rotateY = rotate;
            let rotateX = 0;
            let tx = swiper.params.cssMode ? -offset - swiper.translate : -offset;
            let ty = 0;
            if (!swiper.isHorizontal()) {
                ty = tx;
                tx = 0;
                rotateX = -rotateY;
                rotateY = 0;
            } else if (rtl) rotateY = -rotateY;
            $slideEl[0].style.zIndex = -Math.abs(Math.round(progress)) + slides.length;
            if (params.slideShadows) createSlideShadows($slideEl, progress, params);
            const transform = `translate3d(${tx}px, ${ty}px, 0px) rotateX(${rotateX}deg) rotateY(${rotateY}deg)`;
            const $targetEl = (0, $g8tGM.default)(params, $slideEl);
            $targetEl.transform(transform);
        }
    };
    const setTransition = (duration)=>{
        const { transformEl: transformEl } = swiper.params.flipEffect;
        const $transitionElements = transformEl ? swiper.slides.find(transformEl) : swiper.slides;
        $transitionElements.transition(duration).find(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").transition(duration);
        (0, $4a9Du.default)({
            swiper: swiper,
            duration: duration,
            transformEl: transformEl
        });
    };
    (0, $bE5GA.default)({
        effect: "flip",
        swiper: swiper,
        on: on,
        setTranslate: setTranslate,
        setTransition: setTransition,
        recreateShadows: recreateShadows,
        getEffectParams: ()=>swiper.params.flipEffect,
        perspective: ()=>true,
        overwriteParams: ()=>({
                slidesPerView: 1,
                slidesPerGroup: 1,
                watchSlidesProgress: true,
                spaceBetween: 0,
                virtualTranslate: !swiper.params.cssMode
            })
    });
}

});
parcelRequire.register("dUAVu", function(module, exports) {

$parcel$export(module.exports, "default", () => $a20d261a06d7cdc9$export$2e2bcd8739ae039);

var $92tgL = parcelRequire("92tgL");
function $a20d261a06d7cdc9$export$2e2bcd8739ae039(params, $slideEl, side) {
    const shadowClass = `swiper-slide-shadow${side ? `-${side}` : ""}`;
    const $shadowContainer = params.transformEl ? $slideEl.find(params.transformEl) : $slideEl;
    let $shadowEl = $shadowContainer.children(`.${shadowClass}`);
    if (!$shadowEl.length) {
        $shadowEl = (0, $92tgL.default)(`<div class="swiper-slide-shadow${side ? `-${side}` : ""}"></div>`);
        $shadowContainer.append($shadowEl);
    }
    return $shadowEl;
}

});


parcelRequire.register("3XwHK", function(module, exports) {

var $dUAVu = parcelRequire("dUAVu");

var $bE5GA = parcelRequire("bE5GA");

var $g8tGM = parcelRequire("g8tGM");
function $2e20403a5d5bfba5$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on }) {
    extendParams({
        coverflowEffect: {
            rotate: 50,
            stretch: 0,
            depth: 100,
            scale: 1,
            modifier: 1,
            slideShadows: true,
            transformEl: null
        }
    });
    const setTranslate = ()=>{
        const { width: swiperWidth, height: swiperHeight, slides: slides, slidesSizesGrid: slidesSizesGrid } = swiper;
        const params = swiper.params.coverflowEffect;
        const isHorizontal = swiper.isHorizontal();
        const transform = swiper.translate;
        const center = isHorizontal ? -transform + swiperWidth / 2 : -transform + swiperHeight / 2;
        const rotate = isHorizontal ? params.rotate : -params.rotate;
        const translate = params.depth; // Each slide offset from center
        for(let i = 0, length = slides.length; i < length; i += 1){
            const $slideEl = slides.eq(i);
            const slideSize = slidesSizesGrid[i];
            const slideOffset = $slideEl[0].swiperSlideOffset;
            const centerOffset = (center - slideOffset - slideSize / 2) / slideSize;
            const offsetMultiplier = typeof params.modifier === "function" ? params.modifier(centerOffset) : centerOffset * params.modifier;
            let rotateY = isHorizontal ? rotate * offsetMultiplier : 0;
            let rotateX = isHorizontal ? 0 : rotate * offsetMultiplier; // var rotateZ = 0
            let translateZ = -translate * Math.abs(offsetMultiplier);
            let stretch = params.stretch; // Allow percentage to make a relative stretch for responsive sliders
            if (typeof stretch === "string" && stretch.indexOf("%") !== -1) stretch = parseFloat(params.stretch) / 100 * slideSize;
            let translateY = isHorizontal ? 0 : stretch * offsetMultiplier;
            let translateX = isHorizontal ? stretch * offsetMultiplier : 0;
            let scale = 1 - (1 - params.scale) * Math.abs(offsetMultiplier); // Fix for ultra small values
            if (Math.abs(translateX) < 0.001) translateX = 0;
            if (Math.abs(translateY) < 0.001) translateY = 0;
            if (Math.abs(translateZ) < 0.001) translateZ = 0;
            if (Math.abs(rotateY) < 0.001) rotateY = 0;
            if (Math.abs(rotateX) < 0.001) rotateX = 0;
            if (Math.abs(scale) < 0.001) scale = 0;
            const slideTransform = `translate3d(${translateX}px,${translateY}px,${translateZ}px)  rotateX(${rotateX}deg) rotateY(${rotateY}deg) scale(${scale})`;
            const $targetEl = (0, $g8tGM.default)(params, $slideEl);
            $targetEl.transform(slideTransform);
            $slideEl[0].style.zIndex = -Math.abs(Math.round(offsetMultiplier)) + 1;
            if (params.slideShadows) {
                // Set shadows
                let $shadowBeforeEl = isHorizontal ? $slideEl.find(".swiper-slide-shadow-left") : $slideEl.find(".swiper-slide-shadow-top");
                let $shadowAfterEl = isHorizontal ? $slideEl.find(".swiper-slide-shadow-right") : $slideEl.find(".swiper-slide-shadow-bottom");
                if ($shadowBeforeEl.length === 0) $shadowBeforeEl = (0, $dUAVu.default)(params, $slideEl, isHorizontal ? "left" : "top");
                if ($shadowAfterEl.length === 0) $shadowAfterEl = (0, $dUAVu.default)(params, $slideEl, isHorizontal ? "right" : "bottom");
                if ($shadowBeforeEl.length) $shadowBeforeEl[0].style.opacity = offsetMultiplier > 0 ? offsetMultiplier : 0;
                if ($shadowAfterEl.length) $shadowAfterEl[0].style.opacity = -offsetMultiplier > 0 ? -offsetMultiplier : 0;
            }
        }
    };
    const setTransition = (duration)=>{
        const { transformEl: transformEl } = swiper.params.coverflowEffect;
        const $transitionElements = transformEl ? swiper.slides.find(transformEl) : swiper.slides;
        $transitionElements.transition(duration).find(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").transition(duration);
    };
    (0, $bE5GA.default)({
        effect: "coverflow",
        swiper: swiper,
        on: on,
        setTranslate: setTranslate,
        setTransition: setTransition,
        perspective: ()=>true,
        overwriteParams: ()=>({
                watchSlidesProgress: true
            })
    });
}

});

parcelRequire.register("bybK9", function(module, exports) {

var $dUAVu = parcelRequire("dUAVu");

var $bE5GA = parcelRequire("bE5GA");

var $g8tGM = parcelRequire("g8tGM");

var $4a9Du = parcelRequire("4a9Du");
function $868bfaaaa471eaaf$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on }) {
    extendParams({
        creativeEffect: {
            transformEl: null,
            limitProgress: 1,
            shadowPerProgress: false,
            progressMultiplier: 1,
            perspective: true,
            prev: {
                translate: [
                    0,
                    0,
                    0
                ],
                rotate: [
                    0,
                    0,
                    0
                ],
                opacity: 1,
                scale: 1
            },
            next: {
                translate: [
                    0,
                    0,
                    0
                ],
                rotate: [
                    0,
                    0,
                    0
                ],
                opacity: 1,
                scale: 1
            }
        }
    });
    const getTranslateValue = (value)=>{
        if (typeof value === "string") return value;
        return `${value}px`;
    };
    const setTranslate = ()=>{
        const { slides: slides, $wrapperEl: $wrapperEl, slidesSizesGrid: slidesSizesGrid } = swiper;
        const params = swiper.params.creativeEffect;
        const { progressMultiplier: multiplier } = params;
        const isCenteredSlides = swiper.params.centeredSlides;
        if (isCenteredSlides) {
            const margin = slidesSizesGrid[0] / 2 - swiper.params.slidesOffsetBefore || 0;
            $wrapperEl.transform(`translateX(calc(50% - ${margin}px))`);
        }
        for(let i = 0; i < slides.length; i += 1){
            const $slideEl = slides.eq(i);
            const slideProgress = $slideEl[0].progress;
            const progress = Math.min(Math.max($slideEl[0].progress, -params.limitProgress), params.limitProgress);
            let originalProgress = progress;
            if (!isCenteredSlides) originalProgress = Math.min(Math.max($slideEl[0].originalProgress, -params.limitProgress), params.limitProgress);
            const offset = $slideEl[0].swiperSlideOffset;
            const t = [
                swiper.params.cssMode ? -offset - swiper.translate : -offset,
                0,
                0
            ];
            const r = [
                0,
                0,
                0
            ];
            let custom = false;
            if (!swiper.isHorizontal()) {
                t[1] = t[0];
                t[0] = 0;
            }
            let data = {
                translate: [
                    0,
                    0,
                    0
                ],
                rotate: [
                    0,
                    0,
                    0
                ],
                scale: 1,
                opacity: 1
            };
            if (progress < 0) {
                data = params.next;
                custom = true;
            } else if (progress > 0) {
                data = params.prev;
                custom = true;
            } // set translate
            t.forEach((value, index)=>{
                t[index] = `calc(${value}px + (${getTranslateValue(data.translate[index])} * ${Math.abs(progress * multiplier)}))`;
            }); // set rotates
            r.forEach((value, index)=>{
                r[index] = data.rotate[index] * Math.abs(progress * multiplier);
            });
            $slideEl[0].style.zIndex = -Math.abs(Math.round(slideProgress)) + slides.length;
            const translateString = t.join(", ");
            const rotateString = `rotateX(${r[0]}deg) rotateY(${r[1]}deg) rotateZ(${r[2]}deg)`;
            const scaleString = originalProgress < 0 ? `scale(${1 + (1 - data.scale) * originalProgress * multiplier})` : `scale(${1 - (1 - data.scale) * originalProgress * multiplier})`;
            const opacityString = originalProgress < 0 ? 1 + (1 - data.opacity) * originalProgress * multiplier : 1 - (1 - data.opacity) * originalProgress * multiplier;
            const transform = `translate3d(${translateString}) ${rotateString} ${scaleString}`; // Set shadows
            if (custom && data.shadow || !custom) {
                let $shadowEl = $slideEl.children(".swiper-slide-shadow");
                if ($shadowEl.length === 0 && data.shadow) $shadowEl = (0, $dUAVu.default)(params, $slideEl);
                if ($shadowEl.length) {
                    const shadowOpacity = params.shadowPerProgress ? progress * (1 / params.limitProgress) : progress;
                    $shadowEl[0].style.opacity = Math.min(Math.max(Math.abs(shadowOpacity), 0), 1);
                }
            }
            const $targetEl = (0, $g8tGM.default)(params, $slideEl);
            $targetEl.transform(transform).css({
                opacity: opacityString
            });
            if (data.origin) $targetEl.css("transform-origin", data.origin);
        }
    };
    const setTransition = (duration)=>{
        const { transformEl: transformEl } = swiper.params.creativeEffect;
        const $transitionElements = transformEl ? swiper.slides.find(transformEl) : swiper.slides;
        $transitionElements.transition(duration).find(".swiper-slide-shadow").transition(duration);
        (0, $4a9Du.default)({
            swiper: swiper,
            duration: duration,
            transformEl: transformEl,
            allSlides: true
        });
    };
    (0, $bE5GA.default)({
        effect: "creative",
        swiper: swiper,
        on: on,
        setTranslate: setTranslate,
        setTransition: setTransition,
        perspective: ()=>swiper.params.creativeEffect.perspective,
        overwriteParams: ()=>({
                watchSlidesProgress: true,
                virtualTranslate: !swiper.params.cssMode
            })
    });
}

});

parcelRequire.register("hc3BZ", function(module, exports) {

var $dUAVu = parcelRequire("dUAVu");

var $bE5GA = parcelRequire("bE5GA");

var $g8tGM = parcelRequire("g8tGM");

var $4a9Du = parcelRequire("4a9Du");
function $c8465be37266f95f$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on }) {
    extendParams({
        cardsEffect: {
            slideShadows: true,
            transformEl: null,
            rotate: true,
            perSlideRotate: 2,
            perSlideOffset: 8
        }
    });
    const setTranslate = ()=>{
        const { slides: slides, activeIndex: activeIndex } = swiper;
        const params = swiper.params.cardsEffect;
        const { startTranslate: startTranslate, isTouched: isTouched } = swiper.touchEventsData;
        const currentTranslate = swiper.translate;
        for(let i = 0; i < slides.length; i += 1){
            const $slideEl = slides.eq(i);
            const slideProgress = $slideEl[0].progress;
            const progress = Math.min(Math.max(slideProgress, -4), 4);
            let offset = $slideEl[0].swiperSlideOffset;
            if (swiper.params.centeredSlides && !swiper.params.cssMode) swiper.$wrapperEl.transform(`translateX(${swiper.minTranslate()}px)`);
            if (swiper.params.centeredSlides && swiper.params.cssMode) offset -= slides[0].swiperSlideOffset;
            let tX = swiper.params.cssMode ? -offset - swiper.translate : -offset;
            let tY = 0;
            const tZ = -100 * Math.abs(progress);
            let scale = 1;
            let rotate = -params.perSlideRotate * progress;
            let tXAdd = params.perSlideOffset - Math.abs(progress) * 0.75;
            const slideIndex = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.from + i : i;
            const isSwipeToNext = (slideIndex === activeIndex || slideIndex === activeIndex - 1) && progress > 0 && progress < 1 && (isTouched || swiper.params.cssMode) && currentTranslate < startTranslate;
            const isSwipeToPrev = (slideIndex === activeIndex || slideIndex === activeIndex + 1) && progress < 0 && progress > -1 && (isTouched || swiper.params.cssMode) && currentTranslate > startTranslate;
            if (isSwipeToNext || isSwipeToPrev) {
                const subProgress = (1 - Math.abs((Math.abs(progress) - 0.5) / 0.5)) ** 0.5;
                rotate += -28 * progress * subProgress;
                scale += -0.5 * subProgress;
                tXAdd += 96 * subProgress;
                tY = `${-25 * subProgress * Math.abs(progress)}%`;
            }
            if (progress < 0) // next
            tX = `calc(${tX}px + (${tXAdd * Math.abs(progress)}%))`;
            else if (progress > 0) // prev
            tX = `calc(${tX}px + (-${tXAdd * Math.abs(progress)}%))`;
            else tX = `${tX}px`;
            if (!swiper.isHorizontal()) {
                const prevY = tY;
                tY = tX;
                tX = prevY;
            }
            const scaleString = progress < 0 ? `${1 + (1 - scale) * progress}` : `${1 - (1 - scale) * progress}`;
            const transform = `
        translate3d(${tX}, ${tY}, ${tZ}px)
        rotateZ(${params.rotate ? rotate : 0}deg)
        scale(${scaleString})
      `;
            if (params.slideShadows) {
                // Set shadows
                let $shadowEl = $slideEl.find(".swiper-slide-shadow");
                if ($shadowEl.length === 0) $shadowEl = (0, $dUAVu.default)(params, $slideEl);
                if ($shadowEl.length) $shadowEl[0].style.opacity = Math.min(Math.max((Math.abs(progress) - 0.5) / 0.5, 0), 1);
            }
            $slideEl[0].style.zIndex = -Math.abs(Math.round(slideProgress)) + slides.length;
            const $targetEl = (0, $g8tGM.default)(params, $slideEl);
            $targetEl.transform(transform);
        }
    };
    const setTransition = (duration)=>{
        const { transformEl: transformEl } = swiper.params.cardsEffect;
        const $transitionElements = transformEl ? swiper.slides.find(transformEl) : swiper.slides;
        $transitionElements.transition(duration).find(".swiper-slide-shadow").transition(duration);
        (0, $4a9Du.default)({
            swiper: swiper,
            duration: duration,
            transformEl: transformEl
        });
    };
    (0, $bE5GA.default)({
        effect: "cards",
        swiper: swiper,
        on: on,
        setTranslate: setTranslate,
        setTransition: setTransition,
        perspective: ()=>true,
        overwriteParams: ()=>({
                watchSlidesProgress: true,
                virtualTranslate: !swiper.params.cssMode
            })
    });
}

});



parcelRequire.register("6u2EN", function(module, exports) {
"use strict";
var $4b879b108ee573b3$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $4b879b108ee573b3$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Table = module.exports.TableRow = module.exports.TableCell = module.exports.StylableContainer = module.exports.TableColumnDefinition = void 0;

var $eDhMr = parcelRequire("eDhMr");

var $kD48O = parcelRequire("kD48O");

var $hfx8W = parcelRequire("hfx8W");

var $eZfTX = parcelRequire("eZfTX");

var $8Lw6d = parcelRequire("8Lw6d");

var $c6BU9 = parcelRequire("c6BU9");

var $8QA0A = parcelRequire("8QA0A");
var $4b879b108ee573b3$var$TableColumnDefinition = /** @class */ function(_super) {
    $4b879b108ee573b3$var$__extends(TableColumnDefinition, _super);
    function TableColumnDefinition() {
        //#region Schema
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.width = new $8Lw6d.SizeAndUnit(1, $kD48O.SizeUnit.Weight);
        return _this;
    }
    TableColumnDefinition.prototype.getSchemaKey = function() {
        return "ColumnDefinition";
    };
    TableColumnDefinition.horizontalCellContentAlignmentProperty = new $eZfTX.EnumProperty($eZfTX.Versions.v1_5, "horizontalCellContentAlignment", $kD48O.HorizontalAlignment);
    TableColumnDefinition.verticalCellContentAlignmentProperty = new $eZfTX.EnumProperty($eZfTX.Versions.v1_5, "verticalCellContentAlignment", $kD48O.VerticalAlignment);
    TableColumnDefinition.widthProperty = new $eZfTX.CustomProperty($eZfTX.Versions.v1_5, "width", function(sender, prop, source, context) {
        var result = prop.defaultValue;
        var value = source[prop.name];
        var invalidWidth = false;
        if (typeof value === "number" && !isNaN(value)) result = new $8Lw6d.SizeAndUnit(value, $kD48O.SizeUnit.Weight);
        else if (typeof value === "string") try {
            result = $8Lw6d.SizeAndUnit.parse(value);
        } catch (e) {
            invalidWidth = true;
        }
        else invalidWidth = true;
        if (invalidWidth) context.logParseEvent(sender, $kD48O.ValidationEvent.InvalidPropertyValue, $c6BU9.Strings.errors.invalidColumnWidth(value));
        return result;
    }, function(sender, property, target, value, context) {
        if (value.unit === $kD48O.SizeUnit.Pixel) context.serializeValue(target, "width", value.physicalSize + "px");
        else context.serializeNumber(target, "width", value.physicalSize);
    }, new $8Lw6d.SizeAndUnit(1, $kD48O.SizeUnit.Weight));
    $4b879b108ee573b3$var$__decorate([
        (0, $eZfTX.property)(TableColumnDefinition.horizontalCellContentAlignmentProperty)
    ], TableColumnDefinition.prototype, "horizontalCellContentAlignment", void 0);
    $4b879b108ee573b3$var$__decorate([
        (0, $eZfTX.property)(TableColumnDefinition.verticalCellContentAlignmentProperty)
    ], TableColumnDefinition.prototype, "verticalCellContentAlignment", void 0);
    $4b879b108ee573b3$var$__decorate([
        (0, $eZfTX.property)(TableColumnDefinition.widthProperty)
    ], TableColumnDefinition.prototype, "width", void 0);
    return TableColumnDefinition;
}($eZfTX.SerializableObject);
module.exports.TableColumnDefinition = $4b879b108ee573b3$var$TableColumnDefinition;
var $4b879b108ee573b3$var$StylableContainer = /** @class */ function(_super) {
    $4b879b108ee573b3$var$__extends(StylableContainer, _super);
    function StylableContainer() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._items = [];
        return _this;
    }
    StylableContainer.prototype.parseItem = function(source, context) {
        var _this = this;
        return context.parseCardObject(this, source, [], !this.isDesignMode(), function(typeName) {
            return _this.createItemInstance(typeName);
        }, function(typeName, _errorType) {
            context.logParseEvent(undefined, $kD48O.ValidationEvent.ElementTypeNotAllowed, $c6BU9.Strings.errors.elementTypeNotAllowed(typeName));
        });
    };
    StylableContainer.prototype.internalAddItem = function(item) {
        if (!item.parent) {
            this._items.push(item);
            item.setParent(this);
        } else throw new Error($c6BU9.Strings.errors.elementAlreadyParented());
    };
    StylableContainer.prototype.internalRemoveItem = function(item) {
        var itemIndex = this._items.indexOf(item);
        if (itemIndex >= 0) {
            this._items.splice(itemIndex, 1);
            item.setParent(undefined);
            this.updateLayout();
            return true;
        }
        return false;
    };
    StylableContainer.prototype.internalIndexOf = function(item) {
        return this._items.indexOf(item);
    };
    StylableContainer.prototype.internalParse = function(source, context) {
        _super.prototype.internalParse.call(this, source, context);
        this._items = [];
        var items = source[this.getCollectionPropertyName()];
        if (Array.isArray(items)) for(var _i = 0, items_1 = items; _i < items_1.length; _i++){
            var item = items_1[_i];
            var instance = this.parseItem(item, context);
            if (instance) this._items.push(instance);
        }
    };
    StylableContainer.prototype.internalToJSON = function(target, context) {
        _super.prototype.internalToJSON.call(this, target, context);
        context.serializeArray(target, this.getCollectionPropertyName(), this._items);
    };
    StylableContainer.prototype.removeItem = function(item) {
        return this.internalRemoveItem(item);
    };
    StylableContainer.prototype.getItemCount = function() {
        return this._items.length;
    };
    StylableContainer.prototype.getItemAt = function(index) {
        return this._items[index];
    };
    StylableContainer.prototype.getFirstVisibleRenderedItem = function() {
        return this.getItemCount() > 0 ? this.getItemAt(0) : undefined;
    };
    StylableContainer.prototype.getLastVisibleRenderedItem = function() {
        return this.getItemCount() > 0 ? this.getItemAt(this.getItemCount() - 1) : undefined;
    };
    return StylableContainer;
}($eDhMr.StylableCardElementContainer);
module.exports.StylableContainer = $4b879b108ee573b3$var$StylableContainer;
var $4b879b108ee573b3$var$TableCell = /** @class */ function(_super) {
    $4b879b108ee573b3$var$__extends(TableCell, _super);
    function TableCell() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._columnIndex = -1;
        _this._cellType = "data";
        return _this;
    }
    TableCell.prototype.getHasBorder = function() {
        return this.parentRow.parentTable.showGridLines;
    };
    TableCell.prototype.applyBorder = function() {
        if (this.renderedElement && this.getHasBorder()) {
            var styleDefinition = this.hostConfig.containerStyles.getStyleByName(this.parentRow.parentTable.gridStyle);
            if (styleDefinition.borderColor) {
                var borderColor = (0, $8QA0A.stringToCssColor)(styleDefinition.borderColor);
                if (borderColor) {
                    this.renderedElement.style.borderRight = "1px solid " + borderColor;
                    this.renderedElement.style.borderBottom = "1px solid " + borderColor;
                }
            }
        }
    };
    TableCell.prototype.getDefaultPadding = function() {
        return this.getHasBackground() || this.getHasBorder() ? new $8Lw6d.PaddingDefinition($kD48O.Spacing.Small, $kD48O.Spacing.Small, $kD48O.Spacing.Small, $kD48O.Spacing.Small) : _super.prototype.getDefaultPadding.call(this);
    };
    TableCell.prototype.internalRender = function() {
        var cellElement = _super.prototype.internalRender.call(this);
        if (cellElement) {
            cellElement.setAttribute("role", this.cellType === "data" ? "cell" : "columnheader");
            cellElement.style.minWidth = "0";
            if (this.cellType === "header") cellElement.setAttribute("scope", "col");
        }
        return cellElement;
    };
    TableCell.prototype.shouldSerialize = function(_context) {
        return true;
    };
    TableCell.prototype.getJsonTypeName = function() {
        return "TableCell";
    };
    TableCell.prototype.getEffectiveTextStyleDefinition = function() {
        if (this.cellType === "header") return this.hostConfig.textStyles.columnHeader;
        return _super.prototype.getEffectiveTextStyleDefinition.call(this);
    };
    TableCell.prototype.getEffectiveHorizontalAlignment = function() {
        if (this.horizontalAlignment !== undefined) return this.horizontalAlignment;
        if (this.parentRow.horizontalCellContentAlignment !== undefined) return this.parentRow.horizontalCellContentAlignment;
        if (this.columnIndex >= 0) {
            var horizontalAlignment = this.parentRow.parentTable.getColumnAt(this.columnIndex).horizontalCellContentAlignment;
            if (horizontalAlignment !== undefined) return horizontalAlignment;
        }
        if (this.parentRow.parentTable.horizontalCellContentAlignment !== undefined) return this.parentRow.parentTable.horizontalCellContentAlignment;
        return _super.prototype.getEffectiveHorizontalAlignment.call(this);
    };
    TableCell.prototype.getEffectiveVerticalContentAlignment = function() {
        if (this.verticalContentAlignment !== undefined) return this.verticalContentAlignment;
        if (this.parentRow.verticalCellContentAlignment !== undefined) return this.parentRow.verticalCellContentAlignment;
        if (this.columnIndex >= 0) {
            var verticalAlignment = this.parentRow.parentTable.getColumnAt(this.columnIndex).verticalCellContentAlignment;
            if (verticalAlignment !== undefined) return verticalAlignment;
        }
        if (this.parentRow.parentTable.verticalCellContentAlignment !== undefined) return this.parentRow.parentTable.verticalCellContentAlignment;
        return _super.prototype.getEffectiveVerticalContentAlignment.call(this);
    };
    Object.defineProperty(TableCell.prototype, "columnIndex", {
        get: function() {
            return this._columnIndex;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TableCell.prototype, "cellType", {
        get: function() {
            return this._cellType;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TableCell.prototype, "parentRow", {
        get: function() {
            return this.parent;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TableCell.prototype, "isStandalone", {
        get: function() {
            return false;
        },
        enumerable: false,
        configurable: true
    });
    return TableCell;
}($eDhMr.Container);
module.exports.TableCell = $4b879b108ee573b3$var$TableCell;
var $4b879b108ee573b3$var$TableRow = /** @class */ function(_super) {
    $4b879b108ee573b3$var$__extends(TableRow, _super);
    function TableRow() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    //#endregion
    TableRow.prototype.getDefaultPadding = function() {
        return new $8Lw6d.PaddingDefinition($kD48O.Spacing.None, $kD48O.Spacing.None, $kD48O.Spacing.None, $kD48O.Spacing.None);
    };
    TableRow.prototype.applyBackground = function() {
        if (this.renderedElement) {
            var styleDefinition = this.hostConfig.containerStyles.getStyleByName(this.style, this.hostConfig.containerStyles.getStyleByName(this.defaultStyle));
            if (styleDefinition.backgroundColor) {
                var bgColor = (0, $8QA0A.stringToCssColor)(styleDefinition.backgroundColor);
                if (bgColor) this.renderedElement.style.backgroundColor = bgColor;
            }
        }
    };
    TableRow.prototype.getCollectionPropertyName = function() {
        return "cells";
    };
    TableRow.prototype.createItemInstance = function(typeName) {
        return !typeName || typeName === "TableCell" ? new $4b879b108ee573b3$var$TableCell() : undefined;
    };
    TableRow.prototype.internalRender = function() {
        var isFirstRow = this.getIsFirstRow();
        var cellSpacing = this.hostConfig.table.cellSpacing;
        var rowElement = document.createElement("div");
        rowElement.setAttribute("role", "row");
        rowElement.style.display = "flex";
        rowElement.style.flexDirection = "row";
        for(var i = 0; i < Math.min(this.getItemCount(), this.parentTable.getColumnCount()); i++){
            var cell = this.getItemAt(i);
            // Cheating a bit in order to keep cellType read-only
            cell["_columnIndex"] = i;
            cell["_cellType"] = this.parentTable.firstRowAsHeaders && isFirstRow ? "header" : "data";
            var renderedCell = cell.render();
            if (renderedCell) {
                var column = this.parentTable.getColumnAt(i);
                if (column.computedWidth.unit === $kD48O.SizeUnit.Pixel) renderedCell.style.flex = "0 0 " + column.computedWidth.physicalSize + "px";
                else renderedCell.style.flex = "1 1 " + column.computedWidth.physicalSize + "%";
                if (i > 0 && !this.parentTable.showGridLines && cellSpacing > 0) renderedCell.style.marginLeft = cellSpacing + "px";
                rowElement.appendChild(renderedCell);
            }
        }
        return rowElement.children.length > 0 ? rowElement : undefined;
    };
    TableRow.prototype.shouldSerialize = function(_context) {
        return true;
    };
    TableRow.prototype.addCell = function(cell) {
        this.internalAddItem(cell);
    };
    TableRow.prototype.removeCellAt = function(columnIndex) {
        if (columnIndex >= 0 && columnIndex < this.getItemCount()) return this.removeItem(this.getItemAt(columnIndex));
        return false;
    };
    TableRow.prototype.indexOf = function(cardElement) {
        return cardElement instanceof $4b879b108ee573b3$var$TableCell ? this.internalIndexOf(cardElement) : -1;
    };
    TableRow.prototype.ensureHasEnoughCells = function(cellCount) {
        while(this.getItemCount() < cellCount)this.addCell(new $4b879b108ee573b3$var$TableCell());
    };
    TableRow.prototype.getJsonTypeName = function() {
        return "TableRow";
    };
    TableRow.prototype.getIsFirstRow = function() {
        return this.parentTable.getItemAt(0) === this;
    };
    Object.defineProperty(TableRow.prototype, "parentTable", {
        get: function() {
            return this.parent;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TableRow.prototype, "isStandalone", {
        get: function() {
            return false;
        },
        enumerable: false,
        configurable: true
    });
    //#region Schema
    TableRow.styleProperty = new $eDhMr.ContainerStyleProperty($eZfTX.Versions.v1_5, "style");
    TableRow.horizontalCellContentAlignmentProperty = new $eZfTX.EnumProperty($eZfTX.Versions.v1_5, "horizontalCellContentAlignment", $kD48O.HorizontalAlignment);
    TableRow.verticalCellContentAlignmentProperty = new $eZfTX.EnumProperty($eZfTX.Versions.v1_5, "verticalCellContentAlignment", $kD48O.VerticalAlignment);
    $4b879b108ee573b3$var$__decorate([
        (0, $eZfTX.property)(TableRow.horizontalCellContentAlignmentProperty)
    ], TableRow.prototype, "horizontalCellContentAlignment", void 0);
    $4b879b108ee573b3$var$__decorate([
        (0, $eZfTX.property)(TableRow.verticalCellContentAlignmentProperty)
    ], TableRow.prototype, "verticalCellContentAlignment", void 0);
    return TableRow;
}($4b879b108ee573b3$var$StylableContainer);
module.exports.TableRow = $4b879b108ee573b3$var$TableRow;
var $4b879b108ee573b3$var$Table = /** @class */ function(_super) {
    $4b879b108ee573b3$var$__extends(Table, _super);
    function Table() {
        //#region Schema
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._columns = [];
        _this.firstRowAsHeaders = true;
        _this.showGridLines = true;
        return _this;
    }
    Object.defineProperty(Table.prototype, "gridStyle", {
        get: function() {
            var style = this.getValue(Table.gridStyleProperty);
            if (style && this.hostConfig.containerStyles.getStyleByName(style)) return style;
            return undefined;
        },
        set: function(value) {
            this.setValue(Table.gridStyleProperty, value);
        },
        enumerable: false,
        configurable: true
    });
    //#endregion
    Table.prototype.ensureRowsHaveEnoughCells = function() {
        for(var i = 0; i < this.getItemCount(); i++)this.getItemAt(i).ensureHasEnoughCells(this.getColumnCount());
    };
    Table.prototype.removeCellsFromColumn = function(columnIndex) {
        for(var i = 0; i < this.getItemCount(); i++)this.getItemAt(i).removeCellAt(columnIndex);
    };
    Table.prototype.getCollectionPropertyName = function() {
        return "rows";
    };
    Table.prototype.createItemInstance = function(typeName) {
        return !typeName || typeName === "TableRow" ? new $4b879b108ee573b3$var$TableRow() : undefined;
    };
    Table.prototype.internalParse = function(source, context) {
        _super.prototype.internalParse.call(this, source, context);
        this.ensureRowsHaveEnoughCells();
    };
    Table.prototype.internalRender = function() {
        if (this.getItemCount() > 0) {
            var totalWeights = 0;
            for(var _i = 0, _a = this._columns; _i < _a.length; _i++){
                var column = _a[_i];
                if (column.width.unit === $kD48O.SizeUnit.Weight) totalWeights += column.width.physicalSize;
            }
            for(var _b = 0, _c = this._columns; _b < _c.length; _b++){
                var column = _c[_b];
                if (column.width.unit === $kD48O.SizeUnit.Pixel) column.computedWidth = new $8Lw6d.SizeAndUnit(column.width.physicalSize, $kD48O.SizeUnit.Pixel);
                else column.computedWidth = new $8Lw6d.SizeAndUnit(100 / totalWeights * column.width.physicalSize, $kD48O.SizeUnit.Weight);
            }
            var tableElement = document.createElement("div");
            tableElement.setAttribute("role", "table");
            tableElement.style.display = "flex";
            tableElement.style.flexDirection = "column";
            if (this.showGridLines) {
                var styleDefinition = this.hostConfig.containerStyles.getStyleByName(this.gridStyle);
                if (styleDefinition.borderColor) {
                    var borderColor = (0, $8QA0A.stringToCssColor)(styleDefinition.borderColor);
                    if (borderColor) {
                        tableElement.style.borderTop = "1px solid " + borderColor;
                        tableElement.style.borderLeft = "1px solid " + borderColor;
                    }
                }
            }
            var cellSpacing = this.hostConfig.table.cellSpacing;
            for(var i = 0; i < this.getItemCount(); i++){
                var renderedRow = this.getItemAt(i).render();
                if (renderedRow) {
                    if (i > 0 && !this.showGridLines && cellSpacing > 0) {
                        var separatorRow = document.createElement("div");
                        separatorRow.setAttribute("aria-hidden", "true");
                        separatorRow.style.height = cellSpacing + "px";
                        tableElement.appendChild(separatorRow);
                    }
                    tableElement.appendChild(renderedRow);
                }
            }
            return tableElement;
        }
        return undefined;
    };
    Table.prototype.addColumn = function(column) {
        this._columns.push(column);
        this.ensureRowsHaveEnoughCells();
    };
    Table.prototype.removeColumn = function(column) {
        var index = this._columns.indexOf(column);
        if (index >= 0) {
            this.removeCellsFromColumn(index);
            this._columns.splice(index, 1);
        }
    };
    Table.prototype.getColumnCount = function() {
        return this._columns.length;
    };
    Table.prototype.getColumnAt = function(index) {
        return this._columns[index];
    };
    Table.prototype.addRow = function(row) {
        this.internalAddItem(row);
        row.ensureHasEnoughCells(this.getColumnCount());
    };
    Table.prototype.indexOf = function(cardElement) {
        return cardElement instanceof $4b879b108ee573b3$var$TableRow ? this.internalIndexOf(cardElement) : -1;
    };
    Table.prototype.getJsonTypeName = function() {
        return "Table";
    };
    Table._columnsProperty = new $eZfTX.SerializableObjectCollectionProperty($eZfTX.Versions.v1_5, "columns", $4b879b108ee573b3$var$TableColumnDefinition);
    Table.firstRowAsHeadersProperty = new $eZfTX.BoolProperty($eZfTX.Versions.v1_5, "firstRowAsHeaders", true);
    Table.showGridLinesProperty = new $eZfTX.BoolProperty($eZfTX.Versions.v1_5, "showGridLines", true);
    Table.gridStyleProperty = new $eDhMr.ContainerStyleProperty($eZfTX.Versions.v1_5, "gridStyle");
    Table.horizontalCellContentAlignmentProperty = new $eZfTX.EnumProperty($eZfTX.Versions.v1_5, "horizontalCellContentAlignment", $kD48O.HorizontalAlignment);
    Table.verticalCellContentAlignmentProperty = new $eZfTX.EnumProperty($eZfTX.Versions.v1_5, "verticalCellContentAlignment", $kD48O.VerticalAlignment);
    $4b879b108ee573b3$var$__decorate([
        (0, $eZfTX.property)(Table._columnsProperty)
    ], Table.prototype, "_columns", void 0);
    $4b879b108ee573b3$var$__decorate([
        (0, $eZfTX.property)(Table.firstRowAsHeadersProperty)
    ], Table.prototype, "firstRowAsHeaders", void 0);
    $4b879b108ee573b3$var$__decorate([
        (0, $eZfTX.property)(Table.showGridLinesProperty)
    ], Table.prototype, "showGridLines", void 0);
    $4b879b108ee573b3$var$__decorate([
        (0, $eZfTX.property)(Table.gridStyleProperty)
    ], Table.prototype, "gridStyle", null);
    $4b879b108ee573b3$var$__decorate([
        (0, $eZfTX.property)(Table.horizontalCellContentAlignmentProperty)
    ], Table.prototype, "horizontalCellContentAlignment", void 0);
    $4b879b108ee573b3$var$__decorate([
        (0, $eZfTX.property)(Table.verticalCellContentAlignmentProperty)
    ], Table.prototype, "verticalCellContentAlignment", void 0);
    return Table;
}($4b879b108ee573b3$var$StylableContainer);
module.exports.Table = $4b879b108ee573b3$var$Table;
$hfx8W.GlobalRegistry.defaultElements.register("Table", $4b879b108ee573b3$var$Table, $eZfTX.Versions.v1_5);

});

parcelRequire.register("gOrNK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ChannelAdapter = void 0;
var $0328a08af51b263a$var$ChannelAdapter = /** @class */ function() {
    function ChannelAdapter() {}
    return ChannelAdapter;
}();
module.exports.ChannelAdapter = $0328a08af51b263a$var$ChannelAdapter;

});

parcelRequire.register("kIKLf", function(module, exports) {
"use strict";
var $03e4956d42ca4784$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LoginRequestResponse = module.exports.ErrorResponse = module.exports.SuccessResponse = module.exports.ActivityResponse = module.exports.ActivityRequestError = module.exports.ActivityRequestTrigger = void 0;
var $03e4956d42ca4784$var$ActivityRequestTrigger;
(function(ActivityRequestTrigger) {
    ActivityRequestTrigger["Automatic"] = "automatic";
    ActivityRequestTrigger["Manual"] = "manual";
})($03e4956d42ca4784$var$ActivityRequestTrigger = module.exports.ActivityRequestTrigger || (module.exports.ActivityRequestTrigger = {}));
var $03e4956d42ca4784$var$ActivityRequestError = /** @class */ function() {
    function ActivityRequestError(code, message) {
        this.code = code;
        this.message = message;
    }
    return ActivityRequestError;
}();
module.exports.ActivityRequestError = $03e4956d42ca4784$var$ActivityRequestError;
var $03e4956d42ca4784$var$ActivityResponse = /** @class */ function() {
    function ActivityResponse(request) {
        this.request = request;
    }
    return ActivityResponse;
}();
module.exports.ActivityResponse = $03e4956d42ca4784$var$ActivityResponse;
var $03e4956d42ca4784$var$SuccessResponse = /** @class */ function(_super) {
    $03e4956d42ca4784$var$__extends(SuccessResponse, _super);
    function SuccessResponse(request, rawContent) {
        var _this = _super.call(this, request) || this;
        _this.request = request;
        _this.rawContent = rawContent;
        return _this;
    }
    return SuccessResponse;
}($03e4956d42ca4784$var$ActivityResponse);
module.exports.SuccessResponse = $03e4956d42ca4784$var$SuccessResponse;
var $03e4956d42ca4784$var$ErrorResponse = /** @class */ function(_super) {
    $03e4956d42ca4784$var$__extends(ErrorResponse, _super);
    function ErrorResponse(request, error) {
        var _this = _super.call(this, request) || this;
        _this.request = request;
        _this.error = error;
        return _this;
    }
    return ErrorResponse;
}($03e4956d42ca4784$var$ActivityResponse);
module.exports.ErrorResponse = $03e4956d42ca4784$var$ErrorResponse;
var $03e4956d42ca4784$var$LoginRequestResponse = /** @class */ function(_super) {
    $03e4956d42ca4784$var$__extends(LoginRequestResponse, _super);
    function LoginRequestResponse(request, auth) {
        var _this = _super.call(this, request) || this;
        _this.request = request;
        _this._auth = auth;
        for(var _i = 0, _a = _this._auth.buttons; _i < _a.length; _i++){
            var button = _a[_i];
            if (button.type === "signin" && button.value !== undefined) try {
                new URL(button.value);
                _this.signinButton = button;
                break;
            } catch (e) {
            // Ignore parsing error
            }
        }
        return _this;
    }
    Object.defineProperty(LoginRequestResponse.prototype, "tokenExchangeResource", {
        get: function() {
            return this._auth.tokenExchangeResource;
        },
        enumerable: false,
        configurable: true
    });
    return LoginRequestResponse;
}($03e4956d42ca4784$var$ActivityResponse);
module.exports.LoginRequestResponse = $03e4956d42ca4784$var$LoginRequestResponse;

});

parcelRequire.register("4f7Lw", function(module, exports) {
"use strict";
var $316e9632be8fed40$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $316e9632be8fed40$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.AdaptiveApplet = void 0;

var $kD48O = parcelRequire("kD48O");

var $8QA0A = parcelRequire("8QA0A");

var $8Lw6d = parcelRequire("8Lw6d");

var $kIKLf = parcelRequire("kIKLf");

var $c6BU9 = parcelRequire("c6BU9");

var $eDhMr = parcelRequire("eDhMr");

var $eZfTX = parcelRequire("eZfTX");
function $316e9632be8fed40$var$logEvent(level, message) {
    var optionalParams = [];
    for(var _i = 2; _i < arguments.length; _i++)optionalParams[_i - 2] = arguments[_i];
    if ($8Lw6d.GlobalSettings.applets.logEnabled) {
        if ($8Lw6d.GlobalSettings.applets.onLogEvent) $8Lw6d.GlobalSettings.applets.onLogEvent(level, message, optionalParams);
        else /* eslint-disable no-console */ switch(level){
            case $kD48O.LogLevel.Warning:
                console.warn(message, optionalParams);
                break;
            case $kD48O.LogLevel.Error:
                console.error(message, optionalParams);
                break;
            default:
                console.log(message, optionalParams);
                break;
        }
    }
}
var $316e9632be8fed40$var$ActivityRequest = /** @class */ function() {
    function ActivityRequest(action, trigger, consecutiveActions) {
        this.action = action;
        this.trigger = trigger;
        this.consecutiveActions = consecutiveActions;
        this.attemptNumber = 0;
    }
    // eslint-disable-next-line @typescript-eslint/require-await
    ActivityRequest.prototype.retryAsync = function() {
        return $316e9632be8fed40$var$__awaiter(this, void 0, void 0, function() {
            return $316e9632be8fed40$var$__generator(this, function(_a) {
                if (this.onSend) this.onSend(this);
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    return ActivityRequest;
}();
var $316e9632be8fed40$var$AdaptiveApplet = /** @class */ function() {
    function AdaptiveApplet() {
        this._allowAutomaticCardUpdate = false;
        this.renderedElement = document.createElement("div");
        this.renderedElement.className = "aaf-cardHost";
        this.renderedElement.style.position = "relative";
        this.renderedElement.style.display = "flex";
        this.renderedElement.style.flexDirection = "column";
        this._cardHostElement = document.createElement("div");
        this._refreshButtonHostElement = document.createElement("div");
        this._refreshButtonHostElement.className = "aaf-refreshButtonHost";
        this._refreshButtonHostElement.style.display = "none";
        this.renderedElement.appendChild(this._cardHostElement);
        this.renderedElement.appendChild(this._refreshButtonHostElement);
    }
    AdaptiveApplet.prototype.displayCard = function(card) {
        if (card.renderedElement) {
            $8QA0A.clearElementChildren(this._cardHostElement);
            this._refreshButtonHostElement.style.display = "none";
            this._cardHostElement.appendChild(card.renderedElement);
        } else throw new Error("displayCard: undefined card.");
    };
    AdaptiveApplet.prototype.showManualRefreshButton = function(refreshAction) {
        var _this = this;
        var displayBuiltInManualRefreshButton = this.onShowManualRefreshButton ? this.onShowManualRefreshButton(this) : true;
        if (displayBuiltInManualRefreshButton) {
            this._refreshButtonHostElement.style.display = "none";
            var renderedRefreshButton = undefined;
            if (this.onRenderManualRefreshButton) renderedRefreshButton = this.onRenderManualRefreshButton(this);
            else {
                var message = $c6BU9.Strings.runtime.refreshThisCard();
                if ($8Lw6d.GlobalSettings.applets.refresh.mode === $kD48O.RefreshMode.Automatic) {
                    var autoRefreshPausedMessage = $c6BU9.Strings.runtime.automaticRefreshPaused();
                    if (autoRefreshPausedMessage[autoRefreshPausedMessage.length - 1] !== " ") autoRefreshPausedMessage += " ";
                    message = $c6BU9.Strings.runtime.clckToRestartAutomaticRefresh();
                }
                var cardPayload = {
                    type: "AdaptiveCard",
                    version: "1.2",
                    body: [
                        {
                            type: "RichTextBlock",
                            horizontalAlignment: "right",
                            inlines: [
                                {
                                    type: "TextRun",
                                    text: message,
                                    selectAction: {
                                        type: "Action.Submit",
                                        id: "refreshCard"
                                    }
                                }
                            ]
                        }
                    ]
                };
                var card = new $eDhMr.AdaptiveCard();
                card.parse(cardPayload, new $eDhMr.SerializationContext($eZfTX.Versions.v1_2));
                card.onExecuteAction = function(action) {
                    if (action.id === "refreshCard") {
                        $8QA0A.clearElementChildren(_this._refreshButtonHostElement);
                        _this.internalExecuteAction(refreshAction, $kIKLf.ActivityRequestTrigger.Automatic, 0);
                    }
                };
                renderedRefreshButton = card.render();
            }
            if (renderedRefreshButton) {
                $8QA0A.clearElementChildren(this._refreshButtonHostElement);
                this._refreshButtonHostElement.appendChild(renderedRefreshButton);
                this._refreshButtonHostElement.style.removeProperty("display");
            }
        }
    };
    AdaptiveApplet.prototype.createActivityRequest = function(action, trigger, consecutiveActions) {
        var _this = this;
        if (this.card) {
            var request_1 = new $316e9632be8fed40$var$ActivityRequest(action, trigger, consecutiveActions);
            request_1.onSend = function(sender) {
                sender.attemptNumber++;
                _this.internalSendActivityRequestAsync(request_1);
            };
            var cancel = this.onPrepareActivityRequest ? !this.onPrepareActivityRequest(this, request_1, action) : false;
            return cancel ? undefined : request_1;
        } else throw new Error("createActivityRequest: no card has been set.");
    };
    AdaptiveApplet.prototype.createMagicCodeInputCard = function(attemptNumber) {
        var payload = {
            type: "AdaptiveCard",
            version: "1.0",
            body: [
                {
                    type: "TextBlock",
                    color: "attention",
                    text: attemptNumber === 1 ? undefined : "That didn't work... let's try again.",
                    wrap: true,
                    horizontalAlignment: "center"
                },
                {
                    type: "TextBlock",
                    text: 'Please login in the popup. You will obtain a magic code. Paste that code below and select "Submit"',
                    wrap: true,
                    horizontalAlignment: "center"
                },
                {
                    type: "Input.Text",
                    id: "magicCode",
                    placeholder: "Enter magic code"
                },
                {
                    type: "ActionSet",
                    horizontalAlignment: "center",
                    actions: [
                        {
                            type: "Action.Submit",
                            id: AdaptiveApplet._submitMagicCodeActionId,
                            title: "Submit"
                        },
                        {
                            type: "Action.Submit",
                            id: AdaptiveApplet._cancelMagicCodeAuthActionId,
                            title: "Cancel"
                        }
                    ]
                }
            ]
        };
        var card = new $eDhMr.AdaptiveCard();
        card.parse(payload);
        return card;
    };
    AdaptiveApplet.prototype.cancelAutomaticRefresh = function() {
        if (this._allowAutomaticCardUpdate) $316e9632be8fed40$var$logEvent($kD48O.LogLevel.Warning, "Automatic card refresh has been cancelled as a result of the user interacting with the card.");
        this._allowAutomaticCardUpdate = false;
    };
    AdaptiveApplet.prototype.createSerializationContext = function() {
        return this.onCreateSerializationContext ? this.onCreateSerializationContext(this) : new $eDhMr.SerializationContext();
    };
    AdaptiveApplet.prototype.internalSetCard = function(payload, consecutiveActions) {
        var _this = this;
        if (typeof payload === "object" && payload["type"] === "AdaptiveCard") this._cardPayload = payload;
        if (this._cardPayload) try {
            var card = new $eDhMr.AdaptiveCard();
            if (this.hostConfig) card.hostConfig = this.hostConfig;
            var serializationContext = this.createSerializationContext();
            card.parse(this._cardPayload, serializationContext);
            var doChangeCard = this.onCardChanging ? this.onCardChanging(this, this._cardPayload) : true;
            if (doChangeCard) {
                this._card = card;
                if (this._card.authentication && this._card.authentication.tokenExchangeResource && this.onPrefetchSSOToken) this.onPrefetchSSOToken(this, this._card.authentication.tokenExchangeResource);
                this._card.onExecuteAction = function(action) {
                    // If the user takes an action, cancel any pending automatic refresh
                    _this.cancelAutomaticRefresh();
                    _this.internalExecuteAction(action, $kIKLf.ActivityRequestTrigger.Manual, 0);
                };
                this._card.onInputValueChanged = function(input) {
                    var _a;
                    // If the user modifies an input, cancel any pending automatic refresh
                    _this.cancelAutomaticRefresh();
                    if (input instanceof $eDhMr.ChoiceSetInput && input.isDynamicTypeahead() && input.value) {
                        var dataQueryAction = new $eDhMr.DataQuery();
                        dataQueryAction.filter = input.value;
                        dataQueryAction.dataset = ((_a = input.choicesData) === null || _a === void 0 ? void 0 : _a.dataset) || "";
                        _this._choiceSet = input;
                        _this.internalExecuteAction(dataQueryAction, $kIKLf.ActivityRequestTrigger.Manual, 0 // consecutiveActions
                        );
                    }
                };
                this._card.render();
                if (this._card.renderedElement) {
                    this.displayCard(this._card);
                    if (this.onCardChanged) this.onCardChanged(this);
                    if (this._card.refresh) {
                        if ($8Lw6d.GlobalSettings.applets.refresh.mode === $kD48O.RefreshMode.Automatic && consecutiveActions < $8Lw6d.GlobalSettings.applets.refresh.maximumConsecutiveAutomaticRefreshes) {
                            if ($8Lw6d.GlobalSettings.applets.refresh.timeBetweenAutomaticRefreshes <= 0) {
                                $316e9632be8fed40$var$logEvent($kD48O.LogLevel.Info, "Triggering automatic card refresh number " + (consecutiveActions + 1));
                                this.internalExecuteAction(this._card.refresh.action, $kIKLf.ActivityRequestTrigger.Automatic, consecutiveActions + 1);
                            } else {
                                $316e9632be8fed40$var$logEvent($kD48O.LogLevel.Info, "Scheduling automatic card refresh number " + (consecutiveActions + 1) + " in " + $8Lw6d.GlobalSettings.applets.refresh.timeBetweenAutomaticRefreshes + "ms");
                                var action_1 = this._card.refresh.action;
                                this._allowAutomaticCardUpdate = true;
                                window.setTimeout(function() {
                                    if (_this._allowAutomaticCardUpdate) _this.internalExecuteAction(action_1, $kIKLf.ActivityRequestTrigger.Automatic, consecutiveActions + 1);
                                }, $8Lw6d.GlobalSettings.applets.refresh.timeBetweenAutomaticRefreshes);
                            }
                        } else if ($8Lw6d.GlobalSettings.applets.refresh.mode !== $kD48O.RefreshMode.Disabled) {
                            if (consecutiveActions > 0) $316e9632be8fed40$var$logEvent($kD48O.LogLevel.Warning, "Stopping automatic refreshes after " + consecutiveActions + " consecutive refreshes.");
                            else $316e9632be8fed40$var$logEvent($kD48O.LogLevel.Warning, "The card has a refresh section, but automatic refreshes are disabled.");
                            if ($8Lw6d.GlobalSettings.applets.refresh.allowManualRefreshesAfterAutomaticRefreshes || $8Lw6d.GlobalSettings.applets.refresh.mode === $kD48O.RefreshMode.Manual) {
                                $316e9632be8fed40$var$logEvent($kD48O.LogLevel.Info, "Showing manual refresh button.");
                                this.showManualRefreshButton(this._card.refresh.action);
                            }
                        }
                    }
                }
            }
        } catch (error) {
            // Ignore all errors
            $316e9632be8fed40$var$logEvent($kD48O.LogLevel.Error, "setCard: " + error);
        }
    };
    AdaptiveApplet.prototype.internalExecuteAction = function(action, trigger, consecutiveActions) {
        if (action instanceof $eDhMr.UniversalAction) {
            if (this.channelAdapter) {
                var request = this.createActivityRequest(action, trigger, consecutiveActions);
                if (request) request.retryAsync();
            } else throw new Error("internalExecuteAction: No channel adapter set.");
        }
        if (this.onAction) this.onAction(this, action);
    };
    AdaptiveApplet.prototype.createProgressOverlay = function(request) {
        if (!this._progressOverlay) {
            if (this.onCreateProgressOverlay) this._progressOverlay = this.onCreateProgressOverlay(this, request);
            else {
                this._progressOverlay = document.createElement("div");
                this._progressOverlay.className = "aaf-progress-overlay";
                var spinner = document.createElement("div");
                spinner.className = "aaf-spinner";
                spinner.style.width = "28px";
                spinner.style.height = "28px";
                this._progressOverlay.appendChild(spinner);
            }
        }
        return this._progressOverlay;
    };
    AdaptiveApplet.prototype.removeProgressOverlay = function(request) {
        if (this.onRemoveProgressOverlay) this.onRemoveProgressOverlay(this, request);
        if (this._progressOverlay !== undefined) {
            this.renderedElement.removeChild(this._progressOverlay);
            this._progressOverlay = undefined;
        }
    };
    AdaptiveApplet.prototype.activityRequestSucceeded = function(response, parsedContent) {
        if (this.onActivityRequestSucceeded) this.onActivityRequestSucceeded(this, response, parsedContent);
    };
    AdaptiveApplet.prototype.activityRequestFailed = function(response) {
        return this.onActivityRequestFailed ? this.onActivityRequestFailed(this, response) : $8Lw6d.GlobalSettings.applets.defaultTimeBetweenRetryAttempts;
    };
    AdaptiveApplet.prototype.showAuthCodeInputDialog = function(request) {
        var _this = this;
        var showBuiltInAuthCodeInputCard = this.onShowAuthCodeInputDialog ? this.onShowAuthCodeInputDialog(this, request) : true;
        if (showBuiltInAuthCodeInputCard) {
            var authCodeInputCard = this.createMagicCodeInputCard(request.attemptNumber);
            authCodeInputCard.render();
            authCodeInputCard.onExecuteAction = function(submitMagicCodeAction) {
                if (_this.card && submitMagicCodeAction instanceof $eDhMr.SubmitAction) switch(submitMagicCodeAction.id){
                    case AdaptiveApplet._submitMagicCodeActionId:
                        var authCode = undefined;
                        if (submitMagicCodeAction.data && typeof submitMagicCodeAction.data["magicCode"] === "string") authCode = submitMagicCodeAction.data["magicCode"];
                        if (authCode) {
                            _this.displayCard(_this.card);
                            request.authCode = authCode;
                            request.retryAsync();
                        } else alert("Please enter the magic code you received.");
                        break;
                    case AdaptiveApplet._cancelMagicCodeAuthActionId:
                        $316e9632be8fed40$var$logEvent($kD48O.LogLevel.Warning, "Authentication cancelled by user.");
                        _this.displayCard(_this.card);
                        break;
                    default:
                        $316e9632be8fed40$var$logEvent($kD48O.LogLevel.Error, "Unexpected action taken from magic code input card (id = " + submitMagicCodeAction.id + ")");
                        alert($c6BU9.Strings.magicCodeInputCard.somethingWentWrong());
                        break;
                }
            };
            this.displayCard(authCodeInputCard);
        }
    };
    AdaptiveApplet.prototype.internalSendActivityRequestAsync = function(request) {
        return $316e9632be8fed40$var$__awaiter(this, void 0, void 0, function() {
            var action;
            return $316e9632be8fed40$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!this.channelAdapter) throw new Error("internalSendActivityRequestAsync: channelAdapter is not set.");
                        action = request.action;
                        if (!(action instanceof $eDhMr.ExecuteAction)) return [
                            3 /*break*/ ,
                            2
                        ];
                        return [
                            4 /*yield*/ ,
                            this.internalSendExecuteRequestAsync(request)
                        ];
                    case 1:
                        _a.sent();
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 2:
                        if (!(action instanceof $eDhMr.DataQuery)) return [
                            3 /*break*/ ,
                            4
                        ];
                        return [
                            4 /*yield*/ ,
                            this.internalSendDataQueryRequestAsync(request)
                        ];
                    case 3:
                        _a.sent();
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 4:
                        throw new Error("internalSendActivityRequestAsync: Unhandled Action Type");
                    case 5:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    AdaptiveApplet.prototype.internalSendExecuteRequestAsync = function(request) {
        return $316e9632be8fed40$var$__awaiter(this, void 0, void 0, function() {
            var overlay, done, _loop_1, this_1, state_1;
            return $316e9632be8fed40$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!this.channelAdapter) throw new Error("internalSendExecuteRequestAsync: channelAdapter is not set.");
                        overlay = this.createProgressOverlay(request);
                        if (overlay !== undefined) this.renderedElement.appendChild(overlay);
                        done = false;
                        _loop_1 = function() {
                            var response, error_1, parsedContent, retryIn_1, attemptOAuth, left, top_1;
                            return $316e9632be8fed40$var$__generator(this, function(_b) {
                                switch(_b.label){
                                    case 0:
                                        response = undefined;
                                        if (request.attemptNumber === 1) $316e9632be8fed40$var$logEvent($kD48O.LogLevel.Info, "Sending activity request to channel (attempt " + request.attemptNumber + ")");
                                        else $316e9632be8fed40$var$logEvent($kD48O.LogLevel.Info, "Re-sending activity request to channel (attempt " + request.attemptNumber + ")");
                                        _b.label = 1;
                                    case 1:
                                        _b.trys.push([
                                            1,
                                            3,
                                            ,
                                            4
                                        ]);
                                        return [
                                            4 /*yield*/ ,
                                            this_1.channelAdapter.sendRequestAsync(request)
                                        ];
                                    case 2:
                                        response = _b.sent();
                                        return [
                                            3 /*break*/ ,
                                            4
                                        ];
                                    case 3:
                                        error_1 = _b.sent();
                                        $316e9632be8fed40$var$logEvent($kD48O.LogLevel.Error, "Activity request failed: " + error_1);
                                        this_1.removeProgressOverlay(request);
                                        done = true;
                                        return [
                                            3 /*break*/ ,
                                            4
                                        ];
                                    case 4:
                                        if (!response) return [
                                            3 /*break*/ ,
                                            10
                                        ];
                                        if (!(response instanceof $kIKLf.SuccessResponse)) return [
                                            3 /*break*/ ,
                                            5
                                        ];
                                        this_1.removeProgressOverlay(request);
                                        if (response.rawContent === undefined) throw new Error("internalSendActivityRequestAsync: Action.Execute result is undefined");
                                        parsedContent = response.rawContent;
                                        try {
                                            parsedContent = JSON.parse(response.rawContent);
                                        } catch (_c) {
                                        // Leave parseContent as is
                                        }
                                        if (typeof parsedContent === "string") {
                                            $316e9632be8fed40$var$logEvent($kD48O.LogLevel.Info, "The activity request returned a string after " + request.attemptNumber + " attempt(s).");
                                            this_1.activityRequestSucceeded(response, parsedContent);
                                        } else if (typeof parsedContent === "object" && parsedContent["type"] === "AdaptiveCard") {
                                            $316e9632be8fed40$var$logEvent($kD48O.LogLevel.Info, "The activity request returned an Adaptive Card after " + request.attemptNumber + " attempt(s).");
                                            this_1.internalSetCard(parsedContent, request.consecutiveActions);
                                            this_1.activityRequestSucceeded(response, this_1.card);
                                        } else throw new Error("internalSendActivityRequestAsync: Action.Execute result is of unsupported type (" + typeof response.rawContent + ")");
                                        done = true;
                                        return [
                                            3 /*break*/ ,
                                            10
                                        ];
                                    case 5:
                                        if (!(response instanceof $kIKLf.ErrorResponse)) return [
                                            3 /*break*/ ,
                                            9
                                        ];
                                        retryIn_1 = this_1.activityRequestFailed(response);
                                        if (!(retryIn_1 >= 0 && request.attemptNumber < $8Lw6d.GlobalSettings.applets.maximumRetryAttempts)) return [
                                            3 /*break*/ ,
                                            7
                                        ];
                                        $316e9632be8fed40$var$logEvent($kD48O.LogLevel.Warning, "Activity request failed: ".concat(response.error.message, ". Retrying in ").concat(retryIn_1, "ms"));
                                        request.attemptNumber++;
                                        return [
                                            4 /*yield*/ ,
                                            new Promise(function(resolve, _reject) {
                                                window.setTimeout(function() {
                                                    resolve();
                                                }, retryIn_1);
                                            })
                                        ];
                                    case 6:
                                        _b.sent();
                                        return [
                                            3 /*break*/ ,
                                            8
                                        ];
                                    case 7:
                                        $316e9632be8fed40$var$logEvent($kD48O.LogLevel.Error, "Activity request failed: ".concat(response.error.message, ". Giving up after ").concat(request.attemptNumber, " attempt(s)"));
                                        this_1.removeProgressOverlay(request);
                                        done = true;
                                        _b.label = 8;
                                    case 8:
                                        return [
                                            3 /*break*/ ,
                                            10
                                        ];
                                    case 9:
                                        if (response instanceof $kIKLf.LoginRequestResponse) {
                                            $316e9632be8fed40$var$logEvent($kD48O.LogLevel.Info, "The activity request returned a LoginRequestResponse after " + request.attemptNumber + " attempt(s).");
                                            if (request.attemptNumber <= $8Lw6d.GlobalSettings.applets.maximumRetryAttempts) {
                                                attemptOAuth = true;
                                                if (response.tokenExchangeResource && this_1.onSSOTokenNeeded) // Attempt to use SSO. The host will return true if it can handle SSO, in which case
                                                // we bypass OAuth
                                                attemptOAuth = !this_1.onSSOTokenNeeded(this_1, request, response.tokenExchangeResource);
                                                if (attemptOAuth) {
                                                    // Attempt to use OAuth
                                                    this_1.removeProgressOverlay(request);
                                                    if (response.signinButton === undefined) throw new Error("internalSendActivityRequestAsync: the login request doesn't contain a valid signin URL.");
                                                    $316e9632be8fed40$var$logEvent($kD48O.LogLevel.Info, "Login required at " + response.signinButton.value);
                                                    if (this_1.onShowSigninPrompt) // Bypass the built-in auth prompt if the host app handles it
                                                    this_1.onShowSigninPrompt(this_1, request, response.signinButton);
                                                    else {
                                                        this_1.showAuthCodeInputDialog(request);
                                                        left = window.screenX + (window.outerWidth - $8Lw6d.GlobalSettings.applets.authPromptWidth) / 2;
                                                        top_1 = window.screenY + (window.outerHeight - $8Lw6d.GlobalSettings.applets.authPromptHeight) / 2;
                                                        window.open(response.signinButton.value, response.signinButton.title ? response.signinButton.title : "Sign in", "width=".concat($8Lw6d.GlobalSettings.applets.authPromptWidth, ",height=").concat($8Lw6d.GlobalSettings.applets.authPromptHeight, ",left=").concat(left, ",top=").concat(top_1));
                                                    }
                                                }
                                            } else {
                                                $316e9632be8fed40$var$logEvent($kD48O.LogLevel.Error, "Authentication failed. Giving up after " + request.attemptNumber + " attempt(s)");
                                                alert($c6BU9.Strings.magicCodeInputCard.authenticationFailed());
                                            }
                                            return [
                                                2 /*return*/ ,
                                                "break"
                                            ];
                                        } else throw new Error("Unhandled response type: " + JSON.stringify(response));
                                        _b.label = 10;
                                    case 10:
                                        return [
                                            2 /*return*/ 
                                        ];
                                }
                            });
                        };
                        this_1 = this;
                        _a.label = 1;
                    case 1:
                        if (!!done) return [
                            3 /*break*/ ,
                            3
                        ];
                        return [
                            5 /*yield**/ ,
                            _loop_1()
                        ];
                    case 2:
                        state_1 = _a.sent();
                        if (state_1 === "break") return [
                            3 /*break*/ ,
                            3
                        ];
                        return [
                            3 /*break*/ ,
                            1
                        ];
                    case 3:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    AdaptiveApplet.prototype.internalSendDataQueryRequestAsync = function(request) {
        return $316e9632be8fed40$var$__awaiter(this, void 0, void 0, function() {
            var response, error_2, rawResponse, parsedResponse;
            return $316e9632be8fed40$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!this.channelAdapter) throw new Error("internalSendDataQueryRequestAsync: channel adapter not set");
                        if (!this._choiceSet) return [
                            3 /*break*/ ,
                            5
                        ];
                        this._choiceSet.showLoadingIndicator();
                        response = undefined;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4 /*yield*/ ,
                            this.channelAdapter.sendRequestAsync(request)
                        ];
                    case 2:
                        response = _a.sent();
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 3:
                        error_2 = _a.sent();
                        $316e9632be8fed40$var$logEvent($kD48O.LogLevel.Error, "Activity request failed: " + error_2);
                        this._choiceSet.showErrorIndicator("Unable to load");
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 4:
                        this._choiceSet.removeLoadingIndicator();
                        if (response) {
                            if (response instanceof $kIKLf.SuccessResponse) {
                                rawResponse = response.rawContent;
                                if (rawResponse) {
                                    parsedResponse = rawResponse;
                                    try {
                                        parsedResponse = JSON.parse(parsedResponse);
                                    } catch (error) {
                                        throw new Error("Cannot parse response object: " + rawResponse);
                                    }
                                    if (typeof parsedResponse === "object") {
                                        this._choiceSet.renderChoices(parsedResponse);
                                        this.activityRequestSucceeded(response, parsedResponse);
                                    } else throw new Error("internalSendDataQueryRequestAsync: Data.Query result is of unsupported type (" + typeof rawResponse + ")");
                                }
                            } else if (response instanceof $kIKLf.ErrorResponse) {
                                this._choiceSet.showErrorIndicator("Error loading results.");
                                $316e9632be8fed40$var$logEvent($kD48O.LogLevel.Error, "Activity request failed: ".concat(response.error.message, "."));
                                this.activityRequestFailed(response);
                            } else {
                                this._choiceSet.showErrorIndicator("Unable to load");
                                throw new Error("Unhandled response type: " + JSON.stringify(response));
                            }
                        }
                        _a.label = 5;
                    case 5:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    AdaptiveApplet.prototype.refreshCard = function() {
        if (this._card && this._card.refresh) this.internalExecuteAction(this._card.refresh.action, $kIKLf.ActivityRequestTrigger.Manual, 0);
    };
    AdaptiveApplet.prototype.setCard = function(payload) {
        this.internalSetCard(payload, 0);
    };
    Object.defineProperty(AdaptiveApplet.prototype, "card", {
        get: function() {
            return this._card;
        },
        enumerable: false,
        configurable: true
    });
    AdaptiveApplet._submitMagicCodeActionId = "submitMagicCode";
    AdaptiveApplet._cancelMagicCodeAuthActionId = "cancelMagicCodeAuth";
    return AdaptiveApplet;
}();
module.exports.AdaptiveApplet = $316e9632be8fed40$var$AdaptiveApplet;

});

parcelRequire.register("yQrA7", function(module, exports) {

$parcel$export(module.exports, "ContextConsumer", () => $068bdb5970d22032$export$a7c73072b1a182ae, (v) => $068bdb5970d22032$export$a7c73072b1a182ae = v);
$parcel$export(module.exports, "ContextProvider", () => $068bdb5970d22032$export$9f27bc3417b4524d, (v) => $068bdb5970d22032$export$9f27bc3417b4524d = v);
$parcel$export(module.exports, "Element", () => $068bdb5970d22032$export$db77ccec0bb4ccac, (v) => $068bdb5970d22032$export$db77ccec0bb4ccac = v);
$parcel$export(module.exports, "ForwardRef", () => $068bdb5970d22032$export$8392c0c9d3dcbd35, (v) => $068bdb5970d22032$export$8392c0c9d3dcbd35 = v);
$parcel$export(module.exports, "Fragment", () => $068bdb5970d22032$export$ffb0004e005737fa, (v) => $068bdb5970d22032$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Lazy", () => $068bdb5970d22032$export$b624eff549462981, (v) => $068bdb5970d22032$export$b624eff549462981 = v);
$parcel$export(module.exports, "Memo", () => $068bdb5970d22032$export$7897aa7841a5380c, (v) => $068bdb5970d22032$export$7897aa7841a5380c = v);
$parcel$export(module.exports, "Portal", () => $068bdb5970d22032$export$602eac185826482c, (v) => $068bdb5970d22032$export$602eac185826482c = v);
$parcel$export(module.exports, "Profiler", () => $068bdb5970d22032$export$e2c29f18771995cb, (v) => $068bdb5970d22032$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "StrictMode", () => $068bdb5970d22032$export$5f8d39834fd61797, (v) => $068bdb5970d22032$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $068bdb5970d22032$export$74bf444e3cd11ea5, (v) => $068bdb5970d22032$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "SuspenseList", () => $068bdb5970d22032$export$998bcd577473dd93, (v) => $068bdb5970d22032$export$998bcd577473dd93 = v);
$parcel$export(module.exports, "isAsyncMode", () => $068bdb5970d22032$export$92387174baf9b227, (v) => $068bdb5970d22032$export$92387174baf9b227 = v);
$parcel$export(module.exports, "isConcurrentMode", () => $068bdb5970d22032$export$ec112efeb987d9c6, (v) => $068bdb5970d22032$export$ec112efeb987d9c6 = v);
$parcel$export(module.exports, "isContextConsumer", () => $068bdb5970d22032$export$b706b080d889d2c9, (v) => $068bdb5970d22032$export$b706b080d889d2c9 = v);
$parcel$export(module.exports, "isContextProvider", () => $068bdb5970d22032$export$5be5a87408f70ddc, (v) => $068bdb5970d22032$export$5be5a87408f70ddc = v);
$parcel$export(module.exports, "isElement", () => $068bdb5970d22032$export$45a5e7f76e0caa8d, (v) => $068bdb5970d22032$export$45a5e7f76e0caa8d = v);
$parcel$export(module.exports, "isForwardRef", () => $068bdb5970d22032$export$455c2e768291efa6, (v) => $068bdb5970d22032$export$455c2e768291efa6 = v);
$parcel$export(module.exports, "isFragment", () => $068bdb5970d22032$export$9522e17588c12572, (v) => $068bdb5970d22032$export$9522e17588c12572 = v);
$parcel$export(module.exports, "isLazy", () => $068bdb5970d22032$export$2110ac352bb060b9, (v) => $068bdb5970d22032$export$2110ac352bb060b9 = v);
$parcel$export(module.exports, "isMemo", () => $068bdb5970d22032$export$56885ab8b9c456ab, (v) => $068bdb5970d22032$export$56885ab8b9c456ab = v);
$parcel$export(module.exports, "isPortal", () => $068bdb5970d22032$export$d927fcb6adf8f9de, (v) => $068bdb5970d22032$export$d927fcb6adf8f9de = v);
$parcel$export(module.exports, "isProfiler", () => $068bdb5970d22032$export$b82d16f27459e05a, (v) => $068bdb5970d22032$export$b82d16f27459e05a = v);
$parcel$export(module.exports, "isStrictMode", () => $068bdb5970d22032$export$522c17b4f5e123e8, (v) => $068bdb5970d22032$export$522c17b4f5e123e8 = v);
$parcel$export(module.exports, "isSuspense", () => $068bdb5970d22032$export$1aabd8a0274ecfd6, (v) => $068bdb5970d22032$export$1aabd8a0274ecfd6 = v);
$parcel$export(module.exports, "isSuspenseList", () => $068bdb5970d22032$export$3d6c20d97e46b957, (v) => $068bdb5970d22032$export$3d6c20d97e46b957 = v);
$parcel$export(module.exports, "isValidElementType", () => $068bdb5970d22032$export$9b621391a187a31a, (v) => $068bdb5970d22032$export$9b621391a187a31a = v);
$parcel$export(module.exports, "typeOf", () => $068bdb5970d22032$export$f5bbd400c2f4426f, (v) => $068bdb5970d22032$export$f5bbd400c2f4426f = v);
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $068bdb5970d22032$export$a7c73072b1a182ae;
var $068bdb5970d22032$export$9f27bc3417b4524d;
var $068bdb5970d22032$export$db77ccec0bb4ccac;
var $068bdb5970d22032$export$8392c0c9d3dcbd35;
var $068bdb5970d22032$export$ffb0004e005737fa;
var $068bdb5970d22032$export$b624eff549462981;
var $068bdb5970d22032$export$7897aa7841a5380c;
var $068bdb5970d22032$export$602eac185826482c;
var $068bdb5970d22032$export$e2c29f18771995cb;
var $068bdb5970d22032$export$5f8d39834fd61797;
var $068bdb5970d22032$export$74bf444e3cd11ea5;
var $068bdb5970d22032$export$998bcd577473dd93;
var $068bdb5970d22032$export$92387174baf9b227;
var $068bdb5970d22032$export$ec112efeb987d9c6;
var $068bdb5970d22032$export$b706b080d889d2c9;
var $068bdb5970d22032$export$5be5a87408f70ddc;
var $068bdb5970d22032$export$45a5e7f76e0caa8d;
var $068bdb5970d22032$export$455c2e768291efa6;
var $068bdb5970d22032$export$9522e17588c12572;
var $068bdb5970d22032$export$2110ac352bb060b9;
var $068bdb5970d22032$export$56885ab8b9c456ab;
var $068bdb5970d22032$export$d927fcb6adf8f9de;
var $068bdb5970d22032$export$b82d16f27459e05a;
var $068bdb5970d22032$export$522c17b4f5e123e8;
var $068bdb5970d22032$export$1aabd8a0274ecfd6;
var $068bdb5970d22032$export$3d6c20d97e46b957;
var $068bdb5970d22032$export$9b621391a187a31a;
var $068bdb5970d22032$export$f5bbd400c2f4426f;
"use strict";
var $068bdb5970d22032$var$b = Symbol.for("react.element"), $068bdb5970d22032$var$c = Symbol.for("react.portal"), $068bdb5970d22032$var$d = Symbol.for("react.fragment"), $068bdb5970d22032$var$e = Symbol.for("react.strict_mode"), $068bdb5970d22032$var$f = Symbol.for("react.profiler"), $068bdb5970d22032$var$g = Symbol.for("react.provider"), $068bdb5970d22032$var$h = Symbol.for("react.context"), $068bdb5970d22032$var$k = Symbol.for("react.server_context"), $068bdb5970d22032$var$l = Symbol.for("react.forward_ref"), $068bdb5970d22032$var$m = Symbol.for("react.suspense"), $068bdb5970d22032$var$n = Symbol.for("react.suspense_list"), $068bdb5970d22032$var$p = Symbol.for("react.memo"), $068bdb5970d22032$var$q = Symbol.for("react.lazy"), $068bdb5970d22032$var$t = Symbol.for("react.offscreen"), $068bdb5970d22032$var$u;
$068bdb5970d22032$var$u = Symbol.for("react.module.reference");
function $068bdb5970d22032$var$v(a) {
    if ("object" === typeof a && null !== a) {
        var r = a.$$typeof;
        switch(r){
            case $068bdb5970d22032$var$b:
                switch(a = a.type, a){
                    case $068bdb5970d22032$var$d:
                    case $068bdb5970d22032$var$f:
                    case $068bdb5970d22032$var$e:
                    case $068bdb5970d22032$var$m:
                    case $068bdb5970d22032$var$n:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $068bdb5970d22032$var$k:
                            case $068bdb5970d22032$var$h:
                            case $068bdb5970d22032$var$l:
                            case $068bdb5970d22032$var$q:
                            case $068bdb5970d22032$var$p:
                            case $068bdb5970d22032$var$g:
                                return a;
                            default:
                                return r;
                        }
                }
            case $068bdb5970d22032$var$c:
                return r;
        }
    }
}
$068bdb5970d22032$export$a7c73072b1a182ae = $068bdb5970d22032$var$h;
$068bdb5970d22032$export$9f27bc3417b4524d = $068bdb5970d22032$var$g;
$068bdb5970d22032$export$db77ccec0bb4ccac = $068bdb5970d22032$var$b;
$068bdb5970d22032$export$8392c0c9d3dcbd35 = $068bdb5970d22032$var$l;
$068bdb5970d22032$export$ffb0004e005737fa = $068bdb5970d22032$var$d;
$068bdb5970d22032$export$b624eff549462981 = $068bdb5970d22032$var$q;
$068bdb5970d22032$export$7897aa7841a5380c = $068bdb5970d22032$var$p;
$068bdb5970d22032$export$602eac185826482c = $068bdb5970d22032$var$c;
$068bdb5970d22032$export$e2c29f18771995cb = $068bdb5970d22032$var$f;
$068bdb5970d22032$export$5f8d39834fd61797 = $068bdb5970d22032$var$e;
$068bdb5970d22032$export$74bf444e3cd11ea5 = $068bdb5970d22032$var$m;
$068bdb5970d22032$export$998bcd577473dd93 = $068bdb5970d22032$var$n;
$068bdb5970d22032$export$92387174baf9b227 = function() {
    return !1;
};
$068bdb5970d22032$export$ec112efeb987d9c6 = function() {
    return !1;
};
$068bdb5970d22032$export$b706b080d889d2c9 = function(a) {
    return $068bdb5970d22032$var$v(a) === $068bdb5970d22032$var$h;
};
$068bdb5970d22032$export$5be5a87408f70ddc = function(a) {
    return $068bdb5970d22032$var$v(a) === $068bdb5970d22032$var$g;
};
$068bdb5970d22032$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $068bdb5970d22032$var$b;
};
$068bdb5970d22032$export$455c2e768291efa6 = function(a) {
    return $068bdb5970d22032$var$v(a) === $068bdb5970d22032$var$l;
};
$068bdb5970d22032$export$9522e17588c12572 = function(a) {
    return $068bdb5970d22032$var$v(a) === $068bdb5970d22032$var$d;
};
$068bdb5970d22032$export$2110ac352bb060b9 = function(a) {
    return $068bdb5970d22032$var$v(a) === $068bdb5970d22032$var$q;
};
$068bdb5970d22032$export$56885ab8b9c456ab = function(a) {
    return $068bdb5970d22032$var$v(a) === $068bdb5970d22032$var$p;
};
$068bdb5970d22032$export$d927fcb6adf8f9de = function(a) {
    return $068bdb5970d22032$var$v(a) === $068bdb5970d22032$var$c;
};
$068bdb5970d22032$export$b82d16f27459e05a = function(a) {
    return $068bdb5970d22032$var$v(a) === $068bdb5970d22032$var$f;
};
$068bdb5970d22032$export$522c17b4f5e123e8 = function(a) {
    return $068bdb5970d22032$var$v(a) === $068bdb5970d22032$var$e;
};
$068bdb5970d22032$export$1aabd8a0274ecfd6 = function(a) {
    return $068bdb5970d22032$var$v(a) === $068bdb5970d22032$var$m;
};
$068bdb5970d22032$export$3d6c20d97e46b957 = function(a) {
    return $068bdb5970d22032$var$v(a) === $068bdb5970d22032$var$n;
};
$068bdb5970d22032$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $068bdb5970d22032$var$d || a === $068bdb5970d22032$var$f || a === $068bdb5970d22032$var$e || a === $068bdb5970d22032$var$m || a === $068bdb5970d22032$var$n || a === $068bdb5970d22032$var$t || "object" === typeof a && null !== a && (a.$$typeof === $068bdb5970d22032$var$q || a.$$typeof === $068bdb5970d22032$var$p || a.$$typeof === $068bdb5970d22032$var$g || a.$$typeof === $068bdb5970d22032$var$h || a.$$typeof === $068bdb5970d22032$var$l || a.$$typeof === $068bdb5970d22032$var$u || void 0 !== a.getModuleId) ? !0 : !1;
};
$068bdb5970d22032$export$f5bbd400c2f4426f = $068bdb5970d22032$var$v;

});

parcelRequire.register("l7gGd", function(module, exports) {

$parcel$export(module.exports, "Player", () => Player);

var $eO7Kz = parcelRequire("eO7Kz");
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ var extendStatics = function(t1, e1) {
    return (extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(t1, e1) {
        t1.__proto__ = e1;
    } || function(t1, e1) {
        for(var r1 in e1)Object.prototype.hasOwnProperty.call(e1, r1) && (t1[r1] = e1[r1]);
    })(t1, e1);
};
function __extends(t1, e1) {
    if ("function" != typeof e1 && null !== e1) throw new TypeError("Class extends value " + String(e1) + " is not a constructor or null");
    function r1() {
        this.constructor = t1;
    }
    extendStatics(t1, e1), t1.prototype = null === e1 ? Object.create(e1) : (r1.prototype = e1.prototype, new r1);
}
var __assign = function() {
    return (__assign = Object.assign || function(t1) {
        for(var e1, r1 = 1, i1 = arguments.length; r1 < i1; r1++)for(var a1 in e1 = arguments[r1])Object.prototype.hasOwnProperty.call(e1, a1) && (t1[a1] = e1[a1]);
        return t1;
    }).apply(this, arguments);
};
function __rest(t1, e1) {
    var r1 = {};
    for(var i1 in t1)Object.prototype.hasOwnProperty.call(t1, i1) && e1.indexOf(i1) < 0 && (r1[i1] = t1[i1]);
    if (null != t1 && "function" == typeof Object.getOwnPropertySymbols) {
        var a1 = 0;
        for(i1 = Object.getOwnPropertySymbols(t1); a1 < i1.length; a1++)e1.indexOf(i1[a1]) < 0 && Object.prototype.propertyIsEnumerable.call(t1, i1[a1]) && (r1[i1[a1]] = t1[i1[a1]]);
    }
    return r1;
}
function __decorate(t1, e1, r1, i1) {
    var a1, s1 = arguments.length, n1 = s1 < 3 ? e1 : null === i1 ? i1 = Object.getOwnPropertyDescriptor(e1, r1) : i1;
    if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) n1 = Reflect.decorate(t1, e1, r1, i1);
    else for(var o1 = t1.length - 1; o1 >= 0; o1--)(a1 = t1[o1]) && (n1 = (s1 < 3 ? a1(n1) : s1 > 3 ? a1(e1, r1, n1) : a1(e1, r1)) || n1);
    return s1 > 3 && n1 && Object.defineProperty(e1, r1, n1), n1;
}
function __param(t1, e1) {
    return function(r1, i1) {
        e1(r1, i1, t1);
    };
}
function __metadata(t1, e1) {
    if ("object" == typeof Reflect && "function" == typeof Reflect.metadata) return Reflect.metadata(t1, e1);
}
function __awaiter(t1, e1, r1, i1) {
    return new (r1 || (r1 = Promise))(function(a1, s1) {
        function n1(t1) {
            try {
                h1(i1.next(t1));
            } catch (t1) {
                s1(t1);
            }
        }
        function o1(t1) {
            try {
                h1(i1.throw(t1));
            } catch (t1) {
                s1(t1);
            }
        }
        function h1(t1) {
            var e1;
            t1.done ? a1(t1.value) : (e1 = t1.value, e1 instanceof r1 ? e1 : new r1(function(t1) {
                t1(e1);
            })).then(n1, o1);
        }
        h1((i1 = i1.apply(t1, e1 || [])).next());
    });
}
function __generator(t1, e1) {
    var r1, i1, a1, s1, n1 = {
        label: 0,
        sent: function() {
            if (1 & a1[0]) throw a1[1];
            return a1[1];
        },
        trys: [],
        ops: []
    };
    return s1 = {
        next: o1(0),
        throw: o1(1),
        return: o1(2)
    }, "function" == typeof Symbol && (s1[Symbol.iterator] = function() {
        return this;
    }), s1;
    function o1(s1) {
        return function(o1) {
            return function(s1) {
                if (r1) throw new TypeError("Generator is already executing.");
                for(; n1;)try {
                    if (r1 = 1, i1 && (a1 = 2 & s1[0] ? i1.return : s1[0] ? i1.throw || ((a1 = i1.return) && a1.call(i1), 0) : i1.next) && !(a1 = a1.call(i1, s1[1])).done) return a1;
                    switch(i1 = 0, a1 && (s1 = [
                        2 & s1[0],
                        a1.value
                    ]), s1[0]){
                        case 0:
                        case 1:
                            a1 = s1;
                            break;
                        case 4:
                            return n1.label++, {
                                value: s1[1],
                                done: !1
                            };
                        case 5:
                            n1.label++, i1 = s1[1], s1 = [
                                0
                            ];
                            continue;
                        case 7:
                            s1 = n1.ops.pop(), n1.trys.pop();
                            continue;
                        default:
                            if (!(a1 = n1.trys, (a1 = a1.length > 0 && a1[a1.length - 1]) || 6 !== s1[0] && 2 !== s1[0])) {
                                n1 = 0;
                                continue;
                            }
                            if (3 === s1[0] && (!a1 || s1[1] > a1[0] && s1[1] < a1[3])) {
                                n1.label = s1[1];
                                break;
                            }
                            if (6 === s1[0] && n1.label < a1[1]) {
                                n1.label = a1[1], a1 = s1;
                                break;
                            }
                            if (a1 && n1.label < a1[2]) {
                                n1.label = a1[2], n1.ops.push(s1);
                                break;
                            }
                            a1[2] && n1.ops.pop(), n1.trys.pop();
                            continue;
                    }
                    s1 = e1.call(t1, n1);
                } catch (t1) {
                    s1 = [
                        6,
                        t1
                    ], i1 = 0;
                } finally{
                    r1 = a1 = 0;
                }
                if (5 & s1[0]) throw s1[1];
                return {
                    value: s1[0] ? s1[1] : void 0,
                    done: !0
                };
            }([
                s1,
                o1
            ]);
        };
    }
}
var __createBinding = Object.create ? function(t1, e1, r1, i1) {
    void 0 === i1 && (i1 = r1), Object.defineProperty(t1, i1, {
        enumerable: !0,
        get: function() {
            return e1[r1];
        }
    });
} : function(t1, e1, r1, i1) {
    void 0 === i1 && (i1 = r1), t1[i1] = e1[r1];
};
function __exportStar(t1, e1) {
    for(var r1 in t1)"default" === r1 || Object.prototype.hasOwnProperty.call(e1, r1) || __createBinding(e1, t1, r1);
}
function __values(t1) {
    var e1 = "function" == typeof Symbol && Symbol.iterator, r1 = e1 && t1[e1], i1 = 0;
    if (r1) return r1.call(t1);
    if (t1 && "number" == typeof t1.length) return {
        next: function() {
            return t1 && i1 >= t1.length && (t1 = void 0), {
                value: t1 && t1[i1++],
                done: !t1
            };
        }
    };
    throw new TypeError(e1 ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __read(t1, e1) {
    var r1 = "function" == typeof Symbol && t1[Symbol.iterator];
    if (!r1) return t1;
    var i1, a1, s1 = r1.call(t1), n1 = [];
    try {
        for(; (void 0 === e1 || e1-- > 0) && !(i1 = s1.next()).done;)n1.push(i1.value);
    } catch (t1) {
        a1 = {
            error: t1
        };
    } finally{
        try {
            i1 && !i1.done && (r1 = s1.return) && r1.call(s1);
        } finally{
            if (a1) throw a1.error;
        }
    }
    return n1;
}
function __spread() {
    for(var t1 = [], e1 = 0; e1 < arguments.length; e1++)t1 = t1.concat(__read(arguments[e1]));
    return t1;
}
function __spreadArrays() {
    for(var t1 = 0, e1 = 0, r1 = arguments.length; e1 < r1; e1++)t1 += arguments[e1].length;
    var i1 = Array(t1), a1 = 0;
    for(e1 = 0; e1 < r1; e1++)for(var s1 = arguments[e1], n1 = 0, o1 = s1.length; n1 < o1; n1++, a1++)i1[a1] = s1[n1];
    return i1;
}
function __spreadArray(t1, e1, r1) {
    if (r1 || 2 === arguments.length) for(var i1, a1 = 0, s1 = e1.length; a1 < s1; a1++)!i1 && a1 in e1 || (i1 || (i1 = Array.prototype.slice.call(e1, 0, a1)), i1[a1] = e1[a1]);
    return t1.concat(i1 || Array.prototype.slice.call(e1));
}
function __await(t1) {
    return this instanceof __await ? (this.v = t1, this) : new __await(t1);
}
function __asyncGenerator(t1, e1, r1) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var i1, a1 = r1.apply(t1, e1 || []), s1 = [];
    return i1 = {}, n1("next"), n1("throw"), n1("return"), i1[Symbol.asyncIterator] = function() {
        return this;
    }, i1;
    function n1(t1) {
        a1[t1] && (i1[t1] = function(e1) {
            return new Promise(function(r1, i1) {
                s1.push([
                    t1,
                    e1,
                    r1,
                    i1
                ]) > 1 || o1(t1, e1);
            });
        });
    }
    function o1(t1, e1) {
        try {
            (r1 = a1[t1](e1)).value instanceof __await ? Promise.resolve(r1.value.v).then(h1, l1) : p1(s1[0][2], r1);
        } catch (t1) {
            p1(s1[0][3], t1);
        }
        var r1;
    }
    function h1(t1) {
        o1("next", t1);
    }
    function l1(t1) {
        o1("throw", t1);
    }
    function p1(t1, e1) {
        t1(e1), s1.shift(), s1.length && o1(s1[0][0], s1[0][1]);
    }
}
function __asyncDelegator(t1) {
    var e1, r1;
    return e1 = {}, i1("next"), i1("throw", function(t1) {
        throw t1;
    }), i1("return"), e1[Symbol.iterator] = function() {
        return this;
    }, e1;
    function i1(i1, a1) {
        e1[i1] = t1[i1] ? function(e1) {
            return (r1 = !r1) ? {
                value: __await(t1[i1](e1)),
                done: "return" === i1
            } : a1 ? a1(e1) : e1;
        } : a1;
    }
}
function __asyncValues(t1) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var e1, r1 = t1[Symbol.asyncIterator];
    return r1 ? r1.call(t1) : (t1 = "function" == typeof __values ? __values(t1) : t1[Symbol.iterator](), e1 = {}, i1("next"), i1("throw"), i1("return"), e1[Symbol.asyncIterator] = function() {
        return this;
    }, e1);
    function i1(r1) {
        e1[r1] = t1[r1] && function(e1) {
            return new Promise(function(i1, a1) {
                (function(t1, e1, r1, i1) {
                    Promise.resolve(i1).then(function(e1) {
                        t1({
                            value: e1,
                            done: r1
                        });
                    }, e1);
                })(i1, a1, (e1 = t1[r1](e1)).done, e1.value);
            });
        };
    }
}
function __makeTemplateObject(t1, e1) {
    return Object.defineProperty ? Object.defineProperty(t1, "raw", {
        value: e1
    }) : t1.raw = e1, t1;
}
var __setModuleDefault = Object.create ? function(t1, e1) {
    Object.defineProperty(t1, "default", {
        enumerable: !0,
        value: e1
    });
} : function(t1, e1) {
    t1.default = e1;
};
function __importStar(t1) {
    if (t1 && t1.__esModule) return t1;
    var e1 = {};
    if (null != t1) for(var r1 in t1)"default" !== r1 && Object.prototype.hasOwnProperty.call(t1, r1) && __createBinding(e1, t1, r1);
    return __setModuleDefault(e1, t1), e1;
}
function __importDefault(t1) {
    return t1 && t1.__esModule ? t1 : {
        default: t1
    };
}
function __classPrivateFieldGet(t1, e1, r1, i1) {
    if ("a" === r1 && !i1) throw new TypeError("Private accessor was defined without a getter");
    if ("function" == typeof e1 ? t1 !== e1 || !i1 : !e1.has(t1)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return "m" === r1 ? i1 : "a" === r1 ? i1.call(t1) : i1 ? i1.value : e1.get(t1);
}
function __classPrivateFieldSet(t1, e1, r1, i1, a1) {
    if ("m" === i1) throw new TypeError("Private method is not writable");
    if ("a" === i1 && !a1) throw new TypeError("Private accessor was defined without a setter");
    if ("function" == typeof e1 ? t1 !== e1 || !a1 : !e1.has(t1)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return "a" === i1 ? a1.call(t1, r1) : a1 ? a1.value = r1 : e1.set(t1, r1), r1;
}
var commonjsGlobal = "undefined" != typeof globalThis ? globalThis : "undefined" != typeof window ? window : "undefined" != typeof $parcel$global ? $parcel$global : "undefined" != typeof self ? self : {};
function unwrapExports(t1) {
    return t1 && t1.__esModule && Object.prototype.hasOwnProperty.call(t1, "default") ? t1.default : t1;
}
function createCommonjsModule(t1, e1) {
    return t1(e1 = {
        exports: {}
    }, e1.exports), e1.exports;
}
function getCjsExportFromNamespace(t1) {
    return t1 && t1.default || t1;
}
function commonjsRequire() {
    throw new Error("Dynamic requires are not currently supported by @rollup/plugin-commonjs");
}
var lottie = createCommonjsModule(function(module, exports) {
    "undefined" != typeof navigator && function(t1, e1) {
        module.exports = e1();
    }(0, function() {
        var svgNS = "http://www.w3.org/2000/svg", locationHref = "", _useWebWorker = !1, initialDefaultFrame = -999999, setWebWorker = function(t1) {
            _useWebWorker = !!t1;
        }, getWebWorker = function() {
            return _useWebWorker;
        }, setLocationHref = function(t1) {
            locationHref = t1;
        }, getLocationHref = function() {
            return locationHref;
        };
        function createTag(t1) {
            return document.createElement(t1);
        }
        function extendPrototype(t1, e1) {
            var r1, i1, a1 = t1.length;
            for(r1 = 0; r1 < a1; r1 += 1)for(var s1 in i1 = t1[r1].prototype)Object.prototype.hasOwnProperty.call(i1, s1) && (e1.prototype[s1] = i1[s1]);
        }
        function getDescriptor(t1, e1) {
            return Object.getOwnPropertyDescriptor(t1, e1);
        }
        function createProxyFunction(t1) {
            function e1() {}
            return e1.prototype = t1, e1;
        }
        var audioControllerFactory = function() {
            function t1(t1) {
                this.audios = [], this.audioFactory = t1, this._volume = 1, this._isMuted = !1;
            }
            return t1.prototype = {
                addAudio: function(t1) {
                    this.audios.push(t1);
                },
                pause: function() {
                    var t1, e1 = this.audios.length;
                    for(t1 = 0; t1 < e1; t1 += 1)this.audios[t1].pause();
                },
                resume: function() {
                    var t1, e1 = this.audios.length;
                    for(t1 = 0; t1 < e1; t1 += 1)this.audios[t1].resume();
                },
                setRate: function(t1) {
                    var e1, r1 = this.audios.length;
                    for(e1 = 0; e1 < r1; e1 += 1)this.audios[e1].setRate(t1);
                },
                createAudio: function(t1) {
                    return this.audioFactory ? this.audioFactory(t1) : window.Howl ? new window.Howl({
                        src: [
                            t1
                        ]
                    }) : {
                        isPlaying: !1,
                        play: function() {
                            this.isPlaying = !0;
                        },
                        seek: function() {
                            this.isPlaying = !1;
                        },
                        playing: function() {},
                        rate: function() {},
                        setVolume: function() {}
                    };
                },
                setAudioFactory: function(t1) {
                    this.audioFactory = t1;
                },
                setVolume: function(t1) {
                    this._volume = t1, this._updateVolume();
                },
                mute: function() {
                    this._isMuted = !0, this._updateVolume();
                },
                unmute: function() {
                    this._isMuted = !1, this._updateVolume();
                },
                getVolume: function() {
                    return this._volume;
                },
                _updateVolume: function() {
                    var t1, e1 = this.audios.length;
                    for(t1 = 0; t1 < e1; t1 += 1)this.audios[t1].volume(this._volume * (this._isMuted ? 0 : 1));
                }
            }, function() {
                return new t1;
            };
        }(), createTypedArray = function() {
            function t1(t1, e1) {
                var r1, i1 = 0, a1 = [];
                switch(t1){
                    case "int16":
                    case "uint8c":
                        r1 = 1;
                        break;
                    default:
                        r1 = 1.1;
                }
                for(i1 = 0; i1 < e1; i1 += 1)a1.push(r1);
                return a1;
            }
            return "function" == typeof Uint8ClampedArray && "function" == typeof Float32Array ? function(e1, r1) {
                return "float32" === e1 ? new Float32Array(r1) : "int16" === e1 ? new Int16Array(r1) : "uint8c" === e1 ? new Uint8ClampedArray(r1) : t1(e1, r1);
            } : t1;
        }();
        function createSizedArray(t1) {
            return Array.apply(null, {
                length: t1
            });
        }
        function _typeof$6(t1) {
            return (_typeof$6 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t1) {
                return typeof t1;
            } : function(t1) {
                return t1 && "function" == typeof Symbol && t1.constructor === Symbol && t1 !== Symbol.prototype ? "symbol" : typeof t1;
            })(t1);
        }
        var subframeEnabled = !0, expressionsPlugin = null, expressionsInterfaces = null, idPrefix$1 = "", isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent), _shouldRoundValues = !1, bmPow = Math.pow, bmSqrt = Math.sqrt, bmFloor = Math.floor, bmMax = Math.max, bmMin = Math.min, BMMath = {};
        function ProjectInterface$1() {
            return {};
        }
        !function() {
            var t1, e1 = [
                "abs",
                "acos",
                "acosh",
                "asin",
                "asinh",
                "atan",
                "atanh",
                "atan2",
                "ceil",
                "cbrt",
                "expm1",
                "clz32",
                "cos",
                "cosh",
                "exp",
                "floor",
                "fround",
                "hypot",
                "imul",
                "log",
                "log1p",
                "log2",
                "log10",
                "max",
                "min",
                "pow",
                "random",
                "round",
                "sign",
                "sin",
                "sinh",
                "sqrt",
                "tan",
                "tanh",
                "trunc",
                "E",
                "LN10",
                "LN2",
                "LOG10E",
                "LOG2E",
                "PI",
                "SQRT1_2",
                "SQRT2"
            ], r1 = e1.length;
            for(t1 = 0; t1 < r1; t1 += 1)BMMath[e1[t1]] = Math[e1[t1]];
        }(), BMMath.random = Math.random, BMMath.abs = function(t1) {
            if ("object" === _typeof$6(t1) && t1.length) {
                var e1, r1 = createSizedArray(t1.length), i1 = t1.length;
                for(e1 = 0; e1 < i1; e1 += 1)r1[e1] = Math.abs(t1[e1]);
                return r1;
            }
            return Math.abs(t1);
        };
        var defaultCurveSegments = 150, degToRads = Math.PI / 180, roundCorner = .5519;
        function roundValues(t1) {
            _shouldRoundValues = !!t1;
        }
        function bmRnd(t1) {
            return _shouldRoundValues ? Math.round(t1) : t1;
        }
        function styleDiv(t1) {
            t1.style.position = "absolute", t1.style.top = 0, t1.style.left = 0, t1.style.display = "block", t1.style.transformOrigin = "0 0", t1.style.webkitTransformOrigin = "0 0", t1.style.backfaceVisibility = "visible", t1.style.webkitBackfaceVisibility = "visible", t1.style.transformStyle = "preserve-3d", t1.style.webkitTransformStyle = "preserve-3d", t1.style.mozTransformStyle = "preserve-3d";
        }
        function BMEnterFrameEvent(t1, e1, r1, i1) {
            this.type = t1, this.currentTime = e1, this.totalTime = r1, this.direction = i1 < 0 ? -1 : 1;
        }
        function BMCompleteEvent(t1, e1) {
            this.type = t1, this.direction = e1 < 0 ? -1 : 1;
        }
        function BMCompleteLoopEvent(t1, e1, r1, i1) {
            this.type = t1, this.currentLoop = r1, this.totalLoops = e1, this.direction = i1 < 0 ? -1 : 1;
        }
        function BMSegmentStartEvent(t1, e1, r1) {
            this.type = t1, this.firstFrame = e1, this.totalFrames = r1;
        }
        function BMDestroyEvent(t1, e1) {
            this.type = t1, this.target = e1;
        }
        function BMRenderFrameErrorEvent(t1, e1) {
            this.type = "renderFrameError", this.nativeError = t1, this.currentTime = e1;
        }
        function BMConfigErrorEvent(t1) {
            this.type = "configError", this.nativeError = t1;
        }
        function BMAnimationConfigErrorEvent(t1, e1) {
            this.type = t1, this.nativeError = e1;
        }
        var createElementID = (_count = 0, function() {
            return idPrefix$1 + "__lottie_element_" + (_count += 1);
        }), _count;
        function HSVtoRGB(t1, e1, r1) {
            var i1, a1, s1, n1, o1, h1, l1, p1;
            switch(h1 = r1 * (1 - e1), l1 = r1 * (1 - (o1 = 6 * t1 - (n1 = Math.floor(6 * t1))) * e1), p1 = r1 * (1 - (1 - o1) * e1), n1 % 6){
                case 0:
                    i1 = r1, a1 = p1, s1 = h1;
                    break;
                case 1:
                    i1 = l1, a1 = r1, s1 = h1;
                    break;
                case 2:
                    i1 = h1, a1 = r1, s1 = p1;
                    break;
                case 3:
                    i1 = h1, a1 = l1, s1 = r1;
                    break;
                case 4:
                    i1 = p1, a1 = h1, s1 = r1;
                    break;
                case 5:
                    i1 = r1, a1 = h1, s1 = l1;
            }
            return [
                i1,
                a1,
                s1
            ];
        }
        function RGBtoHSV(t1, e1, r1) {
            var i1, a1 = Math.max(t1, e1, r1), s1 = Math.min(t1, e1, r1), n1 = a1 - s1, o1 = 0 === a1 ? 0 : n1 / a1, h1 = a1 / 255;
            switch(a1){
                case s1:
                    i1 = 0;
                    break;
                case t1:
                    i1 = e1 - r1 + n1 * (e1 < r1 ? 6 : 0), i1 /= 6 * n1;
                    break;
                case e1:
                    i1 = r1 - t1 + 2 * n1, i1 /= 6 * n1;
                    break;
                case r1:
                    i1 = t1 - e1 + 4 * n1, i1 /= 6 * n1;
            }
            return [
                i1,
                o1,
                h1
            ];
        }
        function addSaturationToRGB(t1, e1) {
            var r1 = RGBtoHSV(255 * t1[0], 255 * t1[1], 255 * t1[2]);
            return r1[1] += e1, r1[1] > 1 ? r1[1] = 1 : r1[1] <= 0 && (r1[1] = 0), HSVtoRGB(r1[0], r1[1], r1[2]);
        }
        function addBrightnessToRGB(t1, e1) {
            var r1 = RGBtoHSV(255 * t1[0], 255 * t1[1], 255 * t1[2]);
            return r1[2] += e1, r1[2] > 1 ? r1[2] = 1 : r1[2] < 0 && (r1[2] = 0), HSVtoRGB(r1[0], r1[1], r1[2]);
        }
        function addHueToRGB(t1, e1) {
            var r1 = RGBtoHSV(255 * t1[0], 255 * t1[1], 255 * t1[2]);
            return r1[0] += e1 / 360, r1[0] > 1 ? r1[0] -= 1 : r1[0] < 0 && (r1[0] += 1), HSVtoRGB(r1[0], r1[1], r1[2]);
        }
        var rgbToHex = function() {
            var t1, e1, r1 = [];
            for(t1 = 0; t1 < 256; t1 += 1)e1 = t1.toString(16), r1[t1] = 1 === e1.length ? "0" + e1 : e1;
            return function(t1, e1, i1) {
                return t1 < 0 && (t1 = 0), e1 < 0 && (e1 = 0), i1 < 0 && (i1 = 0), "#" + r1[t1] + r1[e1] + r1[i1];
            };
        }(), setSubframeEnabled = function(t1) {
            subframeEnabled = !!t1;
        }, getSubframeEnabled = function() {
            return subframeEnabled;
        }, setExpressionsPlugin = function(t1) {
            expressionsPlugin = t1;
        }, getExpressionsPlugin = function() {
            return expressionsPlugin;
        }, setExpressionInterfaces = function(t1) {
            expressionsInterfaces = t1;
        }, getExpressionInterfaces = function() {
            return expressionsInterfaces;
        }, setDefaultCurveSegments = function(t1) {
            defaultCurveSegments = t1;
        }, getDefaultCurveSegments = function() {
            return defaultCurveSegments;
        }, setIdPrefix = function(t1) {
            idPrefix$1 = t1;
        }, getIdPrefix = function() {
            return idPrefix$1;
        };
        function createNS(t1) {
            return document.createElementNS(svgNS, t1);
        }
        function _typeof$5(t1) {
            return (_typeof$5 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t1) {
                return typeof t1;
            } : function(t1) {
                return t1 && "function" == typeof Symbol && t1.constructor === Symbol && t1 !== Symbol.prototype ? "symbol" : typeof t1;
            })(t1);
        }
        var dataManager = function() {
            var t1, e1, r1 = 1, i1 = [], a1 = {
                onmessage: function() {},
                postMessage: function(e1) {
                    t1({
                        data: e1
                    });
                }
            }, s1 = {
                postMessage: function(t1) {
                    a1.onmessage({
                        data: t1
                    });
                }
            };
            function n1() {
                e1 || ((e1 = function(e1) {
                    if (window.Worker && window.Blob && getWebWorker()) {
                        var r1 = new Blob([
                            "var _workerSelf = self; self.onmessage = ",
                            e1.toString()
                        ], {
                            type: "text/javascript"
                        }), i1 = URL.createObjectURL(r1);
                        return new Worker(i1);
                    }
                    return t1 = e1, a1;
                }(function(t1) {
                    if (s1.dataManager || (s1.dataManager = function() {
                        function t1(a1, s1) {
                            var n1, o1, h1, l1, p1, c1, m1 = a1.length;
                            for(o1 = 0; o1 < m1; o1 += 1)if ("ks" in (n1 = a1[o1]) && !n1.completed) {
                                if (n1.completed = !0, n1.hasMask) {
                                    var d1 = n1.masksProperties;
                                    for(l1 = d1.length, h1 = 0; h1 < l1; h1 += 1)if (d1[h1].pt.k.i) i1(d1[h1].pt.k);
                                    else for(c1 = d1[h1].pt.k.length, p1 = 0; p1 < c1; p1 += 1)d1[h1].pt.k[p1].s && i1(d1[h1].pt.k[p1].s[0]), d1[h1].pt.k[p1].e && i1(d1[h1].pt.k[p1].e[0]);
                                }
                                0 === n1.ty ? (n1.layers = e1(n1.refId, s1), t1(n1.layers, s1)) : 4 === n1.ty ? r1(n1.shapes) : 5 === n1.ty && f1(n1);
                            }
                        }
                        function e1(t1, e1) {
                            var r1 = function(t1, e1) {
                                for(var r1 = 0, i1 = e1.length; r1 < i1;){
                                    if (e1[r1].id === t1) return e1[r1];
                                    r1 += 1;
                                }
                                return null;
                            }(t1, e1);
                            return r1 ? r1.layers.__used ? JSON.parse(JSON.stringify(r1.layers)) : (r1.layers.__used = !0, r1.layers) : null;
                        }
                        function r1(t1) {
                            var e1, a1, s1;
                            for(e1 = t1.length - 1; e1 >= 0; e1 -= 1)if ("sh" === t1[e1].ty) {
                                if (t1[e1].ks.k.i) i1(t1[e1].ks.k);
                                else for(s1 = t1[e1].ks.k.length, a1 = 0; a1 < s1; a1 += 1)t1[e1].ks.k[a1].s && i1(t1[e1].ks.k[a1].s[0]), t1[e1].ks.k[a1].e && i1(t1[e1].ks.k[a1].e[0]);
                            } else "gr" === t1[e1].ty && r1(t1[e1].it);
                        }
                        function i1(t1) {
                            var e1, r1 = t1.i.length;
                            for(e1 = 0; e1 < r1; e1 += 1)t1.i[e1][0] += t1.v[e1][0], t1.i[e1][1] += t1.v[e1][1], t1.o[e1][0] += t1.v[e1][0], t1.o[e1][1] += t1.v[e1][1];
                        }
                        function a1(t1, e1) {
                            var r1 = e1 ? e1.split(".") : [
                                100,
                                100,
                                100
                            ];
                            return t1[0] > r1[0] || !(r1[0] > t1[0]) && (t1[1] > r1[1] || !(r1[1] > t1[1]) && (t1[2] > r1[2] || !(r1[2] > t1[2]) && null));
                        }
                        var s1, n1 = function() {
                            var t1 = [
                                4,
                                4,
                                14
                            ];
                            function e1(t1) {
                                var e1, r1, i1, a1 = t1.length;
                                for(e1 = 0; e1 < a1; e1 += 1)5 === t1[e1].ty && (r1 = t1[e1], i1 = void 0, i1 = r1.t.d, r1.t.d = {
                                    k: [
                                        {
                                            s: i1,
                                            t: 0
                                        }
                                    ]
                                });
                            }
                            return function(r1) {
                                if (a1(t1, r1.v) && (e1(r1.layers), r1.assets)) {
                                    var i1, s1 = r1.assets.length;
                                    for(i1 = 0; i1 < s1; i1 += 1)r1.assets[i1].layers && e1(r1.assets[i1].layers);
                                }
                            };
                        }(), o1 = (s1 = [
                            4,
                            7,
                            99
                        ], function(t1) {
                            if (t1.chars && !a1(s1, t1.v)) {
                                var e1, i1 = t1.chars.length;
                                for(e1 = 0; e1 < i1; e1 += 1){
                                    var n1 = t1.chars[e1];
                                    n1.data && n1.data.shapes && (r1(n1.data.shapes), n1.data.ip = 0, n1.data.op = 99999, n1.data.st = 0, n1.data.sr = 1, n1.data.ks = {
                                        p: {
                                            k: [
                                                0,
                                                0
                                            ],
                                            a: 0
                                        },
                                        s: {
                                            k: [
                                                100,
                                                100
                                            ],
                                            a: 0
                                        },
                                        a: {
                                            k: [
                                                0,
                                                0
                                            ],
                                            a: 0
                                        },
                                        r: {
                                            k: 0,
                                            a: 0
                                        },
                                        o: {
                                            k: 100,
                                            a: 0
                                        }
                                    }, t1.chars[e1].t || (n1.data.shapes.push({
                                        ty: "no"
                                    }), n1.data.shapes[0].it.push({
                                        p: {
                                            k: [
                                                0,
                                                0
                                            ],
                                            a: 0
                                        },
                                        s: {
                                            k: [
                                                100,
                                                100
                                            ],
                                            a: 0
                                        },
                                        a: {
                                            k: [
                                                0,
                                                0
                                            ],
                                            a: 0
                                        },
                                        r: {
                                            k: 0,
                                            a: 0
                                        },
                                        o: {
                                            k: 100,
                                            a: 0
                                        },
                                        sk: {
                                            k: 0,
                                            a: 0
                                        },
                                        sa: {
                                            k: 0,
                                            a: 0
                                        },
                                        ty: "tr"
                                    })));
                                }
                            }
                        }), h1 = function() {
                            var t1 = [
                                5,
                                7,
                                15
                            ];
                            function e1(t1) {
                                var e1, r1, i1, a1 = t1.length;
                                for(e1 = 0; e1 < a1; e1 += 1)5 === t1[e1].ty && (r1 = t1[e1], i1 = void 0, "number" == typeof (i1 = r1.t.p).a && (i1.a = {
                                    a: 0,
                                    k: i1.a
                                }), "number" == typeof i1.p && (i1.p = {
                                    a: 0,
                                    k: i1.p
                                }), "number" == typeof i1.r && (i1.r = {
                                    a: 0,
                                    k: i1.r
                                }));
                            }
                            return function(r1) {
                                if (a1(t1, r1.v) && (e1(r1.layers), r1.assets)) {
                                    var i1, s1 = r1.assets.length;
                                    for(i1 = 0; i1 < s1; i1 += 1)r1.assets[i1].layers && e1(r1.assets[i1].layers);
                                }
                            };
                        }(), l1 = function() {
                            var t1 = [
                                4,
                                1,
                                9
                            ];
                            function e1(t1) {
                                var r1, i1, a1, s1 = t1.length;
                                for(r1 = 0; r1 < s1; r1 += 1)if ("gr" === t1[r1].ty) e1(t1[r1].it);
                                else if ("fl" === t1[r1].ty || "st" === t1[r1].ty) {
                                    if (t1[r1].c.k && t1[r1].c.k[0].i) for(a1 = t1[r1].c.k.length, i1 = 0; i1 < a1; i1 += 1)t1[r1].c.k[i1].s && (t1[r1].c.k[i1].s[0] /= 255, t1[r1].c.k[i1].s[1] /= 255, t1[r1].c.k[i1].s[2] /= 255, t1[r1].c.k[i1].s[3] /= 255), t1[r1].c.k[i1].e && (t1[r1].c.k[i1].e[0] /= 255, t1[r1].c.k[i1].e[1] /= 255, t1[r1].c.k[i1].e[2] /= 255, t1[r1].c.k[i1].e[3] /= 255);
                                    else t1[r1].c.k[0] /= 255, t1[r1].c.k[1] /= 255, t1[r1].c.k[2] /= 255, t1[r1].c.k[3] /= 255;
                                }
                            }
                            function r1(t1) {
                                var r1, i1 = t1.length;
                                for(r1 = 0; r1 < i1; r1 += 1)4 === t1[r1].ty && e1(t1[r1].shapes);
                            }
                            return function(e1) {
                                if (a1(t1, e1.v) && (r1(e1.layers), e1.assets)) {
                                    var i1, s1 = e1.assets.length;
                                    for(i1 = 0; i1 < s1; i1 += 1)e1.assets[i1].layers && r1(e1.assets[i1].layers);
                                }
                            };
                        }(), p1 = function() {
                            var t1 = [
                                4,
                                4,
                                18
                            ];
                            function e1(t1) {
                                var r1, i1, a1;
                                for(r1 = t1.length - 1; r1 >= 0; r1 -= 1)if ("sh" === t1[r1].ty) {
                                    if (t1[r1].ks.k.i) t1[r1].ks.k.c = t1[r1].closed;
                                    else for(a1 = t1[r1].ks.k.length, i1 = 0; i1 < a1; i1 += 1)t1[r1].ks.k[i1].s && (t1[r1].ks.k[i1].s[0].c = t1[r1].closed), t1[r1].ks.k[i1].e && (t1[r1].ks.k[i1].e[0].c = t1[r1].closed);
                                } else "gr" === t1[r1].ty && e1(t1[r1].it);
                            }
                            function r1(t1) {
                                var r1, i1, a1, s1, n1, o1, h1 = t1.length;
                                for(i1 = 0; i1 < h1; i1 += 1){
                                    if ((r1 = t1[i1]).hasMask) {
                                        var l1 = r1.masksProperties;
                                        for(s1 = l1.length, a1 = 0; a1 < s1; a1 += 1)if (l1[a1].pt.k.i) l1[a1].pt.k.c = l1[a1].cl;
                                        else for(o1 = l1[a1].pt.k.length, n1 = 0; n1 < o1; n1 += 1)l1[a1].pt.k[n1].s && (l1[a1].pt.k[n1].s[0].c = l1[a1].cl), l1[a1].pt.k[n1].e && (l1[a1].pt.k[n1].e[0].c = l1[a1].cl);
                                    }
                                    4 === r1.ty && e1(r1.shapes);
                                }
                            }
                            return function(e1) {
                                if (a1(t1, e1.v) && (r1(e1.layers), e1.assets)) {
                                    var i1, s1 = e1.assets.length;
                                    for(i1 = 0; i1 < s1; i1 += 1)e1.assets[i1].layers && r1(e1.assets[i1].layers);
                                }
                            };
                        }();
                        function f1(t1) {
                            0 === t1.t.a.length && t1.t.p;
                        }
                        var c1 = {
                            completeData: function(r1) {
                                r1.__complete || (l1(r1), n1(r1), o1(r1), h1(r1), p1(r1), t1(r1.layers, r1.assets), function(r1, i1) {
                                    if (r1) {
                                        var a1 = 0, s1 = r1.length;
                                        for(a1 = 0; a1 < s1; a1 += 1)1 === r1[a1].t && (r1[a1].data.layers = e1(r1[a1].data.refId, i1), t1(r1[a1].data.layers, i1));
                                    }
                                }(r1.chars, r1.assets), r1.__complete = !0);
                            }
                        };
                        return c1.checkColors = l1, c1.checkChars = o1, c1.checkPathProperties = h1, c1.checkShapes = p1, c1.completeLayers = t1, c1;
                    }()), s1.assetLoader || (s1.assetLoader = function() {
                        function t1(t1) {
                            var e1 = t1.getResponseHeader("content-type");
                            return e1 && "json" === t1.responseType && -1 !== e1.indexOf("json") || t1.response && "object" === _typeof$5(t1.response) ? t1.response : t1.response && "string" == typeof t1.response ? JSON.parse(t1.response) : t1.responseText ? JSON.parse(t1.responseText) : null;
                        }
                        return {
                            load: function(e1, r1, i1, a1) {
                                var s1, n1 = new XMLHttpRequest;
                                try {
                                    n1.responseType = "json";
                                } catch (t1) {}
                                n1.onreadystatechange = function() {
                                    if (4 === n1.readyState) {
                                        if (200 === n1.status) s1 = t1(n1), i1(s1);
                                        else try {
                                            s1 = t1(n1), i1(s1);
                                        } catch (t1) {
                                            a1 && a1(t1);
                                        }
                                    }
                                };
                                try {
                                    n1.open([
                                        "G",
                                        "E",
                                        "T"
                                    ].join(""), e1, !0);
                                } catch (t1) {
                                    n1.open([
                                        "G",
                                        "E",
                                        "T"
                                    ].join(""), r1 + "/" + e1, !0);
                                }
                                n1.send();
                            }
                        };
                    }()), "loadAnimation" === t1.data.type) s1.assetLoader.load(t1.data.path, t1.data.fullPath, function(e1) {
                        s1.dataManager.completeData(e1), s1.postMessage({
                            id: t1.data.id,
                            payload: e1,
                            status: "success"
                        });
                    }, function() {
                        s1.postMessage({
                            id: t1.data.id,
                            status: "error"
                        });
                    });
                    else if ("complete" === t1.data.type) {
                        var e1 = t1.data.animation;
                        s1.dataManager.completeData(e1), s1.postMessage({
                            id: t1.data.id,
                            payload: e1,
                            status: "success"
                        });
                    } else "loadData" === t1.data.type && s1.assetLoader.load(t1.data.path, t1.data.fullPath, function(e1) {
                        s1.postMessage({
                            id: t1.data.id,
                            payload: e1,
                            status: "success"
                        });
                    }, function() {
                        s1.postMessage({
                            id: t1.data.id,
                            status: "error"
                        });
                    });
                })).onmessage = function(t1) {
                    var e1 = t1.data, r1 = e1.id, a1 = i1[r1];
                    i1[r1] = null, "success" === e1.status ? a1.onComplete(e1.payload) : a1.onError && a1.onError();
                });
            }
            function o1(t1, e1) {
                var a1 = "processId_" + (r1 += 1);
                return i1[a1] = {
                    onComplete: t1,
                    onError: e1
                }, a1;
            }
            return {
                loadAnimation: function(t1, r1, i1) {
                    n1();
                    var a1 = o1(r1, i1);
                    e1.postMessage({
                        type: "loadAnimation",
                        path: t1,
                        fullPath: window.location.origin + window.location.pathname,
                        id: a1
                    });
                },
                loadData: function(t1, r1, i1) {
                    n1();
                    var a1 = o1(r1, i1);
                    e1.postMessage({
                        type: "loadData",
                        path: t1,
                        fullPath: window.location.origin + window.location.pathname,
                        id: a1
                    });
                },
                completeAnimation: function(t1, r1, i1) {
                    n1();
                    var a1 = o1(r1, i1);
                    e1.postMessage({
                        type: "complete",
                        animation: t1,
                        id: a1
                    });
                }
            };
        }(), ImagePreloader = function() {
            var t1 = function() {
                var t1 = createTag("canvas");
                t1.width = 1, t1.height = 1;
                var e1 = t1.getContext("2d");
                return e1.fillStyle = "rgba(0,0,0,0)", e1.fillRect(0, 0, 1, 1), t1;
            }();
            function e1() {
                this.loadedAssets += 1, this.loadedAssets === this.totalImages && this.loadedFootagesCount === this.totalFootages && this.imagesLoadedCb && this.imagesLoadedCb(null);
            }
            function r1() {
                this.loadedFootagesCount += 1, this.loadedAssets === this.totalImages && this.loadedFootagesCount === this.totalFootages && this.imagesLoadedCb && this.imagesLoadedCb(null);
            }
            function i1(t1, e1, r1) {
                var i1 = "";
                if (t1.e) i1 = t1.p;
                else if (e1) {
                    var a1 = t1.p;
                    -1 !== a1.indexOf("images/") && (a1 = a1.split("/")[1]), i1 = e1 + a1;
                } else i1 = r1, i1 += t1.u ? t1.u : "", i1 += t1.p;
                return i1;
            }
            function a1(t1) {
                var e1 = 0, r1 = setInterval((function() {
                    (t1.getBBox().width || e1 > 500) && (this._imageLoaded(), clearInterval(r1)), e1 += 1;
                }).bind(this), 50);
            }
            function s1(t1) {
                var e1 = {
                    assetData: t1
                }, r1 = i1(t1, this.assetsPath, this.path);
                return dataManager.loadData(r1, (function(t1) {
                    e1.img = t1, this._footageLoaded();
                }).bind(this), (function() {
                    e1.img = {}, this._footageLoaded();
                }).bind(this)), e1;
            }
            function n1() {
                this._imageLoaded = e1.bind(this), this._footageLoaded = r1.bind(this), this.testImageLoaded = a1.bind(this), this.createFootageData = s1.bind(this), this.assetsPath = "", this.path = "", this.totalImages = 0, this.totalFootages = 0, this.loadedAssets = 0, this.loadedFootagesCount = 0, this.imagesLoadedCb = null, this.images = [];
            }
            return n1.prototype = {
                loadAssets: function(t1, e1) {
                    var r1;
                    this.imagesLoadedCb = e1;
                    var i1 = t1.length;
                    for(r1 = 0; r1 < i1; r1 += 1)t1[r1].layers || (t1[r1].t && "seq" !== t1[r1].t ? 3 === t1[r1].t && (this.totalFootages += 1, this.images.push(this.createFootageData(t1[r1]))) : (this.totalImages += 1, this.images.push(this._createImageData(t1[r1]))));
                },
                setAssetsPath: function(t1) {
                    this.assetsPath = t1 || "";
                },
                setPath: function(t1) {
                    this.path = t1 || "";
                },
                loadedImages: function() {
                    return this.totalImages === this.loadedAssets;
                },
                loadedFootages: function() {
                    return this.totalFootages === this.loadedFootagesCount;
                },
                destroy: function() {
                    this.imagesLoadedCb = null, this.images.length = 0;
                },
                getAsset: function(t1) {
                    for(var e1 = 0, r1 = this.images.length; e1 < r1;){
                        if (this.images[e1].assetData === t1) return this.images[e1].img;
                        e1 += 1;
                    }
                    return null;
                },
                createImgData: function(e1) {
                    var r1 = i1(e1, this.assetsPath, this.path), a1 = createTag("img");
                    a1.crossOrigin = "anonymous", a1.addEventListener("load", this._imageLoaded, !1), a1.addEventListener("error", (function() {
                        s1.img = t1, this._imageLoaded();
                    }).bind(this), !1), a1.src = r1;
                    var s1 = {
                        img: a1,
                        assetData: e1
                    };
                    return s1;
                },
                createImageData: function(e1) {
                    var r1 = i1(e1, this.assetsPath, this.path), a1 = createNS("image");
                    isSafari ? this.testImageLoaded(a1) : a1.addEventListener("load", this._imageLoaded, !1), a1.addEventListener("error", (function() {
                        s1.img = t1, this._imageLoaded();
                    }).bind(this), !1), a1.setAttributeNS("http://www.w3.org/1999/xlink", "href", r1), this._elementHelper.append ? this._elementHelper.append(a1) : this._elementHelper.appendChild(a1);
                    var s1 = {
                        img: a1,
                        assetData: e1
                    };
                    return s1;
                },
                imageLoaded: e1,
                footageLoaded: r1,
                setCacheType: function(t1, e1) {
                    "svg" === t1 ? (this._elementHelper = e1, this._createImageData = this.createImageData.bind(this)) : this._createImageData = this.createImgData.bind(this);
                }
            }, n1;
        }();
        function BaseEvent() {}
        BaseEvent.prototype = {
            triggerEvent: function(t1, e1) {
                if (this._cbs[t1]) for(var r1 = this._cbs[t1], i1 = 0; i1 < r1.length; i1 += 1)r1[i1](e1);
            },
            addEventListener: function(t1, e1) {
                return this._cbs[t1] || (this._cbs[t1] = []), this._cbs[t1].push(e1), (function() {
                    this.removeEventListener(t1, e1);
                }).bind(this);
            },
            removeEventListener: function(t1, e1) {
                if (e1) {
                    if (this._cbs[t1]) {
                        for(var r1 = 0, i1 = this._cbs[t1].length; r1 < i1;)this._cbs[t1][r1] === e1 && (this._cbs[t1].splice(r1, 1), r1 -= 1, i1 -= 1), r1 += 1;
                        this._cbs[t1].length || (this._cbs[t1] = null);
                    }
                } else this._cbs[t1] = null;
            }
        };
        var markerParser = function() {
            function t1(t1) {
                for(var e1, r1 = t1.split("\r\n"), i1 = {}, a1 = 0, s1 = 0; s1 < r1.length; s1 += 1)2 === (e1 = r1[s1].split(":")).length && (i1[e1[0]] = e1[1].trim(), a1 += 1);
                if (0 === a1) throw new Error;
                return i1;
            }
            return function(e1) {
                for(var r1 = [], i1 = 0; i1 < e1.length; i1 += 1){
                    var a1 = e1[i1], s1 = {
                        time: a1.tm,
                        duration: a1.dr
                    };
                    try {
                        s1.payload = JSON.parse(e1[i1].cm);
                    } catch (r1) {
                        try {
                            s1.payload = t1(e1[i1].cm);
                        } catch (t1) {
                            s1.payload = {
                                name: e1[i1].cm
                            };
                        }
                    }
                    r1.push(s1);
                }
                return r1;
            };
        }(), ProjectInterface = function() {
            function t1(t1) {
                this.compositions.push(t1);
            }
            return function() {
                function e1(t1) {
                    for(var e1 = 0, r1 = this.compositions.length; e1 < r1;){
                        if (this.compositions[e1].data && this.compositions[e1].data.nm === t1) return this.compositions[e1].prepareFrame && this.compositions[e1].data.xt && this.compositions[e1].prepareFrame(this.currentFrame), this.compositions[e1].compInterface;
                        e1 += 1;
                    }
                    return null;
                }
                return e1.compositions = [], e1.currentFrame = 0, e1.registerComposition = t1, e1;
            };
        }(), renderers = {}, registerRenderer = function(t1, e1) {
            renderers[t1] = e1;
        };
        function getRenderer(t1) {
            return renderers[t1];
        }
        function _typeof$4(t1) {
            return (_typeof$4 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t1) {
                return typeof t1;
            } : function(t1) {
                return t1 && "function" == typeof Symbol && t1.constructor === Symbol && t1 !== Symbol.prototype ? "symbol" : typeof t1;
            })(t1);
        }
        var AnimationItem = function() {
            this._cbs = [], this.name = "", this.path = "", this.isLoaded = !1, this.currentFrame = 0, this.currentRawFrame = 0, this.firstFrame = 0, this.totalFrames = 0, this.frameRate = 0, this.frameMult = 0, this.playSpeed = 1, this.playDirection = 1, this.playCount = 0, this.animationData = {}, this.assets = [], this.isPaused = !0, this.autoplay = !1, this.loop = !0, this.renderer = null, this.animationID = createElementID(), this.assetsPath = "", this.timeCompleted = 0, this.segmentPos = 0, this.isSubframeEnabled = getSubframeEnabled(), this.segments = [], this._idle = !0, this._completedLoop = !1, this.projectInterface = ProjectInterface(), this.imagePreloader = new ImagePreloader, this.audioController = audioControllerFactory(), this.markers = [], this.configAnimation = this.configAnimation.bind(this), this.onSetupError = this.onSetupError.bind(this), this.onSegmentComplete = this.onSegmentComplete.bind(this), this.drawnFrameEvent = new BMEnterFrameEvent("drawnFrame", 0, 0, 0);
        };
        extendPrototype([
            BaseEvent
        ], AnimationItem), AnimationItem.prototype.setParams = function(t1) {
            (t1.wrapper || t1.container) && (this.wrapper = t1.wrapper || t1.container);
            var e1 = "svg";
            t1.animType ? e1 = t1.animType : t1.renderer && (e1 = t1.renderer);
            var r1 = getRenderer(e1);
            this.renderer = new r1(this, t1.rendererSettings), this.imagePreloader.setCacheType(e1, this.renderer.globalData.defs), this.renderer.setProjectInterface(this.projectInterface), this.animType = e1, "" === t1.loop || null === t1.loop || void 0 === t1.loop || !0 === t1.loop ? this.loop = !0 : !1 === t1.loop ? this.loop = !1 : this.loop = parseInt(t1.loop, 10), this.autoplay = !("autoplay" in t1) || t1.autoplay, this.name = t1.name ? t1.name : "", this.autoloadSegments = !Object.prototype.hasOwnProperty.call(t1, "autoloadSegments") || t1.autoloadSegments, this.assetsPath = t1.assetsPath, this.initialSegment = t1.initialSegment, t1.audioFactory && this.audioController.setAudioFactory(t1.audioFactory), t1.animationData ? this.setupAnimation(t1.animationData) : t1.path && (-1 !== t1.path.lastIndexOf("\\") ? this.path = t1.path.substr(0, t1.path.lastIndexOf("\\") + 1) : this.path = t1.path.substr(0, t1.path.lastIndexOf("/") + 1), this.fileName = t1.path.substr(t1.path.lastIndexOf("/") + 1), this.fileName = this.fileName.substr(0, this.fileName.lastIndexOf(".json")), dataManager.loadAnimation(t1.path, this.configAnimation, this.onSetupError));
        }, AnimationItem.prototype.onSetupError = function() {
            this.trigger("data_failed");
        }, AnimationItem.prototype.setupAnimation = function(t1) {
            dataManager.completeAnimation(t1, this.configAnimation);
        }, AnimationItem.prototype.setData = function(t1, e1) {
            e1 && "object" !== _typeof$4(e1) && (e1 = JSON.parse(e1));
            var r1 = {
                wrapper: t1,
                animationData: e1
            }, i1 = t1.attributes;
            r1.path = i1.getNamedItem("data-animation-path") ? i1.getNamedItem("data-animation-path").value : i1.getNamedItem("data-bm-path") ? i1.getNamedItem("data-bm-path").value : i1.getNamedItem("bm-path") ? i1.getNamedItem("bm-path").value : "", r1.animType = i1.getNamedItem("data-anim-type") ? i1.getNamedItem("data-anim-type").value : i1.getNamedItem("data-bm-type") ? i1.getNamedItem("data-bm-type").value : i1.getNamedItem("bm-type") ? i1.getNamedItem("bm-type").value : i1.getNamedItem("data-bm-renderer") ? i1.getNamedItem("data-bm-renderer").value : i1.getNamedItem("bm-renderer") ? i1.getNamedItem("bm-renderer").value : "canvas";
            var a1 = i1.getNamedItem("data-anim-loop") ? i1.getNamedItem("data-anim-loop").value : i1.getNamedItem("data-bm-loop") ? i1.getNamedItem("data-bm-loop").value : i1.getNamedItem("bm-loop") ? i1.getNamedItem("bm-loop").value : "";
            "false" === a1 ? r1.loop = !1 : "true" === a1 ? r1.loop = !0 : "" !== a1 && (r1.loop = parseInt(a1, 10));
            var s1 = i1.getNamedItem("data-anim-autoplay") ? i1.getNamedItem("data-anim-autoplay").value : i1.getNamedItem("data-bm-autoplay") ? i1.getNamedItem("data-bm-autoplay").value : !i1.getNamedItem("bm-autoplay") || i1.getNamedItem("bm-autoplay").value;
            r1.autoplay = "false" !== s1, r1.name = i1.getNamedItem("data-name") ? i1.getNamedItem("data-name").value : i1.getNamedItem("data-bm-name") ? i1.getNamedItem("data-bm-name").value : i1.getNamedItem("bm-name") ? i1.getNamedItem("bm-name").value : "", "false" === (i1.getNamedItem("data-anim-prerender") ? i1.getNamedItem("data-anim-prerender").value : i1.getNamedItem("data-bm-prerender") ? i1.getNamedItem("data-bm-prerender").value : i1.getNamedItem("bm-prerender") ? i1.getNamedItem("bm-prerender").value : "") && (r1.prerender = !1), this.setParams(r1);
        }, AnimationItem.prototype.includeLayers = function(t1) {
            t1.op > this.animationData.op && (this.animationData.op = t1.op, this.totalFrames = Math.floor(t1.op - this.animationData.ip));
            var e1, r1, i1 = this.animationData.layers, a1 = i1.length, s1 = t1.layers, n1 = s1.length;
            for(r1 = 0; r1 < n1; r1 += 1)for(e1 = 0; e1 < a1;){
                if (i1[e1].id === s1[r1].id) {
                    i1[e1] = s1[r1];
                    break;
                }
                e1 += 1;
            }
            if ((t1.chars || t1.fonts) && (this.renderer.globalData.fontManager.addChars(t1.chars), this.renderer.globalData.fontManager.addFonts(t1.fonts, this.renderer.globalData.defs)), t1.assets) for(a1 = t1.assets.length, e1 = 0; e1 < a1; e1 += 1)this.animationData.assets.push(t1.assets[e1]);
            this.animationData.__complete = !1, dataManager.completeAnimation(this.animationData, this.onSegmentComplete);
        }, AnimationItem.prototype.onSegmentComplete = function(t1) {
            this.animationData = t1;
            var e1 = getExpressionsPlugin();
            e1 && e1.initExpressions(this), this.loadNextSegment();
        }, AnimationItem.prototype.loadNextSegment = function() {
            var t1 = this.animationData.segments;
            if (!t1 || 0 === t1.length || !this.autoloadSegments) return this.trigger("data_ready"), void (this.timeCompleted = this.totalFrames);
            var e1 = t1.shift();
            this.timeCompleted = e1.time * this.frameRate;
            var r1 = this.path + this.fileName + "_" + this.segmentPos + ".json";
            this.segmentPos += 1, dataManager.loadData(r1, this.includeLayers.bind(this), (function() {
                this.trigger("data_failed");
            }).bind(this));
        }, AnimationItem.prototype.loadSegments = function() {
            this.animationData.segments || (this.timeCompleted = this.totalFrames), this.loadNextSegment();
        }, AnimationItem.prototype.imagesLoaded = function() {
            this.trigger("loaded_images"), this.checkLoaded();
        }, AnimationItem.prototype.preloadImages = function() {
            this.imagePreloader.setAssetsPath(this.assetsPath), this.imagePreloader.setPath(this.path), this.imagePreloader.loadAssets(this.animationData.assets, this.imagesLoaded.bind(this));
        }, AnimationItem.prototype.configAnimation = function(t1) {
            if (this.renderer) try {
                this.animationData = t1, this.initialSegment ? (this.totalFrames = Math.floor(this.initialSegment[1] - this.initialSegment[0]), this.firstFrame = Math.round(this.initialSegment[0])) : (this.totalFrames = Math.floor(this.animationData.op - this.animationData.ip), this.firstFrame = Math.round(this.animationData.ip)), this.renderer.configAnimation(t1), t1.assets || (t1.assets = []), this.assets = this.animationData.assets, this.frameRate = this.animationData.fr, this.frameMult = this.animationData.fr / 1e3, this.renderer.searchExtraCompositions(t1.assets), this.markers = markerParser(t1.markers || []), this.trigger("config_ready"), this.preloadImages(), this.loadSegments(), this.updaFrameModifier(), this.waitForFontsLoaded(), this.isPaused && this.audioController.pause();
            } catch (t1) {
                this.triggerConfigError(t1);
            }
        }, AnimationItem.prototype.waitForFontsLoaded = function() {
            this.renderer && (this.renderer.globalData.fontManager.isLoaded ? this.checkLoaded() : setTimeout(this.waitForFontsLoaded.bind(this), 20));
        }, AnimationItem.prototype.checkLoaded = function() {
            if (!this.isLoaded && this.renderer.globalData.fontManager.isLoaded && (this.imagePreloader.loadedImages() || "canvas" !== this.renderer.rendererType) && this.imagePreloader.loadedFootages()) {
                this.isLoaded = !0;
                var t1 = getExpressionsPlugin();
                t1 && t1.initExpressions(this), this.renderer.initItems(), setTimeout((function() {
                    this.trigger("DOMLoaded");
                }).bind(this), 0), this.gotoFrame(), this.autoplay && this.play();
            }
        }, AnimationItem.prototype.resize = function(t1, e1) {
            var r1 = "number" == typeof t1 ? t1 : void 0, i1 = "number" == typeof e1 ? e1 : void 0;
            this.renderer.updateContainerSize(r1, i1);
        }, AnimationItem.prototype.setSubframe = function(t1) {
            this.isSubframeEnabled = !!t1;
        }, AnimationItem.prototype.gotoFrame = function() {
            this.currentFrame = this.isSubframeEnabled ? this.currentRawFrame : ~~this.currentRawFrame, this.timeCompleted !== this.totalFrames && this.currentFrame > this.timeCompleted && (this.currentFrame = this.timeCompleted), this.trigger("enterFrame"), this.renderFrame(), this.trigger("drawnFrame");
        }, AnimationItem.prototype.renderFrame = function() {
            if (!1 !== this.isLoaded && this.renderer) try {
                this.renderer.renderFrame(this.currentFrame + this.firstFrame);
            } catch (t1) {
                this.triggerRenderFrameError(t1);
            }
        }, AnimationItem.prototype.play = function(t1) {
            t1 && this.name !== t1 || !0 === this.isPaused && (this.isPaused = !1, this.trigger("_pause"), this.audioController.resume(), this._idle && (this._idle = !1, this.trigger("_active")));
        }, AnimationItem.prototype.pause = function(t1) {
            t1 && this.name !== t1 || !1 === this.isPaused && (this.isPaused = !0, this.trigger("_play"), this._idle = !0, this.trigger("_idle"), this.audioController.pause());
        }, AnimationItem.prototype.togglePause = function(t1) {
            t1 && this.name !== t1 || (!0 === this.isPaused ? this.play() : this.pause());
        }, AnimationItem.prototype.stop = function(t1) {
            t1 && this.name !== t1 || (this.pause(), this.playCount = 0, this._completedLoop = !1, this.setCurrentRawFrameValue(0));
        }, AnimationItem.prototype.getMarkerData = function(t1) {
            for(var e1, r1 = 0; r1 < this.markers.length; r1 += 1)if ((e1 = this.markers[r1]).payload && e1.payload.name === t1) return e1;
            return null;
        }, AnimationItem.prototype.goToAndStop = function(t1, e1, r1) {
            if (!r1 || this.name === r1) {
                var i1 = Number(t1);
                if (isNaN(i1)) {
                    var a1 = this.getMarkerData(t1);
                    a1 && this.goToAndStop(a1.time, !0);
                } else e1 ? this.setCurrentRawFrameValue(t1) : this.setCurrentRawFrameValue(t1 * this.frameModifier);
                this.pause();
            }
        }, AnimationItem.prototype.goToAndPlay = function(t1, e1, r1) {
            if (!r1 || this.name === r1) {
                var i1 = Number(t1);
                if (isNaN(i1)) {
                    var a1 = this.getMarkerData(t1);
                    a1 && (a1.duration ? this.playSegments([
                        a1.time,
                        a1.time + a1.duration
                    ], !0) : this.goToAndStop(a1.time, !0));
                } else this.goToAndStop(i1, e1, r1);
                this.play();
            }
        }, AnimationItem.prototype.advanceTime = function(t1) {
            if (!0 !== this.isPaused && !1 !== this.isLoaded) {
                var e1 = this.currentRawFrame + t1 * this.frameModifier, r1 = !1;
                e1 >= this.totalFrames - 1 && this.frameModifier > 0 ? this.loop && this.playCount !== this.loop ? e1 >= this.totalFrames ? (this.playCount += 1, this.checkSegments(e1 % this.totalFrames) || (this.setCurrentRawFrameValue(e1 % this.totalFrames), this._completedLoop = !0, this.trigger("loopComplete"))) : this.setCurrentRawFrameValue(e1) : this.checkSegments(e1 > this.totalFrames ? e1 % this.totalFrames : 0) || (r1 = !0, e1 = this.totalFrames - 1) : e1 < 0 ? this.checkSegments(e1 % this.totalFrames) || (!this.loop || this.playCount-- <= 0 && !0 !== this.loop ? (r1 = !0, e1 = 0) : (this.setCurrentRawFrameValue(this.totalFrames + e1 % this.totalFrames), this._completedLoop ? this.trigger("loopComplete") : this._completedLoop = !0)) : this.setCurrentRawFrameValue(e1), r1 && (this.setCurrentRawFrameValue(e1), this.pause(), this.trigger("complete"));
            }
        }, AnimationItem.prototype.adjustSegment = function(t1, e1) {
            this.playCount = 0, t1[1] < t1[0] ? (this.frameModifier > 0 && (this.playSpeed < 0 ? this.setSpeed(-this.playSpeed) : this.setDirection(-1)), this.totalFrames = t1[0] - t1[1], this.timeCompleted = this.totalFrames, this.firstFrame = t1[1], this.setCurrentRawFrameValue(this.totalFrames - .001 - e1)) : t1[1] > t1[0] && (this.frameModifier < 0 && (this.playSpeed < 0 ? this.setSpeed(-this.playSpeed) : this.setDirection(1)), this.totalFrames = t1[1] - t1[0], this.timeCompleted = this.totalFrames, this.firstFrame = t1[0], this.setCurrentRawFrameValue(.001 + e1)), this.trigger("segmentStart");
        }, AnimationItem.prototype.setSegment = function(t1, e1) {
            var r1 = -1;
            this.isPaused && (this.currentRawFrame + this.firstFrame < t1 ? r1 = t1 : this.currentRawFrame + this.firstFrame > e1 && (r1 = e1 - t1)), this.firstFrame = t1, this.totalFrames = e1 - t1, this.timeCompleted = this.totalFrames, -1 !== r1 && this.goToAndStop(r1, !0);
        }, AnimationItem.prototype.playSegments = function(t1, e1) {
            if (e1 && (this.segments.length = 0), "object" === _typeof$4(t1[0])) {
                var r1, i1 = t1.length;
                for(r1 = 0; r1 < i1; r1 += 1)this.segments.push(t1[r1]);
            } else this.segments.push(t1);
            this.segments.length && e1 && this.adjustSegment(this.segments.shift(), 0), this.isPaused && this.play();
        }, AnimationItem.prototype.resetSegments = function(t1) {
            this.segments.length = 0, this.segments.push([
                this.animationData.ip,
                this.animationData.op
            ]), t1 && this.checkSegments(0);
        }, AnimationItem.prototype.checkSegments = function(t1) {
            return !!this.segments.length && (this.adjustSegment(this.segments.shift(), t1), !0);
        }, AnimationItem.prototype.destroy = function(t1) {
            t1 && this.name !== t1 || !this.renderer || (this.renderer.destroy(), this.imagePreloader.destroy(), this.trigger("destroy"), this._cbs = null, this.onEnterFrame = null, this.onLoopComplete = null, this.onComplete = null, this.onSegmentStart = null, this.onDestroy = null, this.renderer = null, this.renderer = null, this.imagePreloader = null, this.projectInterface = null);
        }, AnimationItem.prototype.setCurrentRawFrameValue = function(t1) {
            this.currentRawFrame = t1, this.gotoFrame();
        }, AnimationItem.prototype.setSpeed = function(t1) {
            this.playSpeed = t1, this.updaFrameModifier();
        }, AnimationItem.prototype.setDirection = function(t1) {
            this.playDirection = t1 < 0 ? -1 : 1, this.updaFrameModifier();
        }, AnimationItem.prototype.setLoop = function(t1) {
            this.loop = t1;
        }, AnimationItem.prototype.setVolume = function(t1, e1) {
            e1 && this.name !== e1 || this.audioController.setVolume(t1);
        }, AnimationItem.prototype.getVolume = function() {
            return this.audioController.getVolume();
        }, AnimationItem.prototype.mute = function(t1) {
            t1 && this.name !== t1 || this.audioController.mute();
        }, AnimationItem.prototype.unmute = function(t1) {
            t1 && this.name !== t1 || this.audioController.unmute();
        }, AnimationItem.prototype.updaFrameModifier = function() {
            this.frameModifier = this.frameMult * this.playSpeed * this.playDirection, this.audioController.setRate(this.playSpeed * this.playDirection);
        }, AnimationItem.prototype.getPath = function() {
            return this.path;
        }, AnimationItem.prototype.getAssetsPath = function(t1) {
            var e1 = "";
            if (t1.e) e1 = t1.p;
            else if (this.assetsPath) {
                var r1 = t1.p;
                -1 !== r1.indexOf("images/") && (r1 = r1.split("/")[1]), e1 = this.assetsPath + r1;
            } else e1 = this.path, e1 += t1.u ? t1.u : "", e1 += t1.p;
            return e1;
        }, AnimationItem.prototype.getAssetData = function(t1) {
            for(var e1 = 0, r1 = this.assets.length; e1 < r1;){
                if (t1 === this.assets[e1].id) return this.assets[e1];
                e1 += 1;
            }
            return null;
        }, AnimationItem.prototype.hide = function() {
            this.renderer.hide();
        }, AnimationItem.prototype.show = function() {
            this.renderer.show();
        }, AnimationItem.prototype.getDuration = function(t1) {
            return t1 ? this.totalFrames : this.totalFrames / this.frameRate;
        }, AnimationItem.prototype.updateDocumentData = function(t1, e1, r1) {
            try {
                this.renderer.getElementByPath(t1).updateDocumentData(e1, r1);
            } catch (t1) {}
        }, AnimationItem.prototype.trigger = function(t1) {
            if (this._cbs && this._cbs[t1]) switch(t1){
                case "enterFrame":
                    this.triggerEvent(t1, new BMEnterFrameEvent(t1, this.currentFrame, this.totalFrames, this.frameModifier));
                    break;
                case "drawnFrame":
                    this.drawnFrameEvent.currentTime = this.currentFrame, this.drawnFrameEvent.totalTime = this.totalFrames, this.drawnFrameEvent.direction = this.frameModifier, this.triggerEvent(t1, this.drawnFrameEvent);
                    break;
                case "loopComplete":
                    this.triggerEvent(t1, new BMCompleteLoopEvent(t1, this.loop, this.playCount, this.frameMult));
                    break;
                case "complete":
                    this.triggerEvent(t1, new BMCompleteEvent(t1, this.frameMult));
                    break;
                case "segmentStart":
                    this.triggerEvent(t1, new BMSegmentStartEvent(t1, this.firstFrame, this.totalFrames));
                    break;
                case "destroy":
                    this.triggerEvent(t1, new BMDestroyEvent(t1, this));
                    break;
                default:
                    this.triggerEvent(t1);
            }
            "enterFrame" === t1 && this.onEnterFrame && this.onEnterFrame.call(this, new BMEnterFrameEvent(t1, this.currentFrame, this.totalFrames, this.frameMult)), "loopComplete" === t1 && this.onLoopComplete && this.onLoopComplete.call(this, new BMCompleteLoopEvent(t1, this.loop, this.playCount, this.frameMult)), "complete" === t1 && this.onComplete && this.onComplete.call(this, new BMCompleteEvent(t1, this.frameMult)), "segmentStart" === t1 && this.onSegmentStart && this.onSegmentStart.call(this, new BMSegmentStartEvent(t1, this.firstFrame, this.totalFrames)), "destroy" === t1 && this.onDestroy && this.onDestroy.call(this, new BMDestroyEvent(t1, this));
        }, AnimationItem.prototype.triggerRenderFrameError = function(t1) {
            var e1 = new BMRenderFrameErrorEvent(t1, this.currentFrame);
            this.triggerEvent("error", e1), this.onError && this.onError.call(this, e1);
        }, AnimationItem.prototype.triggerConfigError = function(t1) {
            var e1 = new BMConfigErrorEvent(t1, this.currentFrame);
            this.triggerEvent("error", e1), this.onError && this.onError.call(this, e1);
        };
        var animationManager = function() {
            var t1 = {}, e1 = [], r1 = 0, i1 = 0, a1 = 0, s1 = !0, n1 = !1;
            function o1(t1) {
                for(var r1 = 0, a1 = t1.target; r1 < i1;)e1[r1].animation === a1 && (e1.splice(r1, 1), r1 -= 1, i1 -= 1, a1.isPaused || p1()), r1 += 1;
            }
            function h1(t1, r1) {
                if (!t1) return null;
                for(var a1 = 0; a1 < i1;){
                    if (e1[a1].elem === t1 && null !== e1[a1].elem) return e1[a1].animation;
                    a1 += 1;
                }
                var s1 = new AnimationItem;
                return f1(s1, t1), s1.setData(t1, r1), s1;
            }
            function l1() {
                a1 += 1, d1();
            }
            function p1() {
                a1 -= 1;
            }
            function f1(t1, r1) {
                t1.addEventListener("destroy", o1), t1.addEventListener("_active", l1), t1.addEventListener("_idle", p1), e1.push({
                    elem: r1,
                    animation: t1
                }), i1 += 1;
            }
            function c1(t1) {
                var o1, h1 = t1 - r1;
                for(o1 = 0; o1 < i1; o1 += 1)e1[o1].animation.advanceTime(h1);
                r1 = t1, a1 && !n1 ? window.requestAnimationFrame(c1) : s1 = !0;
            }
            function m1(t1) {
                r1 = t1, window.requestAnimationFrame(c1);
            }
            function d1() {
                !n1 && a1 && s1 && (window.requestAnimationFrame(m1), s1 = !1);
            }
            return t1.registerAnimation = h1, t1.loadAnimation = function(t1) {
                var e1 = new AnimationItem;
                return f1(e1, null), e1.setParams(t1), e1;
            }, t1.setSpeed = function(t1, r1) {
                var a1;
                for(a1 = 0; a1 < i1; a1 += 1)e1[a1].animation.setSpeed(t1, r1);
            }, t1.setDirection = function(t1, r1) {
                var a1;
                for(a1 = 0; a1 < i1; a1 += 1)e1[a1].animation.setDirection(t1, r1);
            }, t1.play = function(t1) {
                var r1;
                for(r1 = 0; r1 < i1; r1 += 1)e1[r1].animation.play(t1);
            }, t1.pause = function(t1) {
                var r1;
                for(r1 = 0; r1 < i1; r1 += 1)e1[r1].animation.pause(t1);
            }, t1.stop = function(t1) {
                var r1;
                for(r1 = 0; r1 < i1; r1 += 1)e1[r1].animation.stop(t1);
            }, t1.togglePause = function(t1) {
                var r1;
                for(r1 = 0; r1 < i1; r1 += 1)e1[r1].animation.togglePause(t1);
            }, t1.searchAnimations = function(t1, e1, r1) {
                var i1, a1 = [].concat([].slice.call(document.getElementsByClassName("lottie")), [].slice.call(document.getElementsByClassName("bodymovin"))), s1 = a1.length;
                for(i1 = 0; i1 < s1; i1 += 1)r1 && a1[i1].setAttribute("data-bm-type", r1), h1(a1[i1], t1);
                if (e1 && 0 === s1) {
                    r1 || (r1 = "svg");
                    var n1 = document.getElementsByTagName("body")[0];
                    n1.innerText = "";
                    var o1 = createTag("div");
                    o1.style.width = "100%", o1.style.height = "100%", o1.setAttribute("data-bm-type", r1), n1.appendChild(o1), h1(o1, t1);
                }
            }, t1.resize = function() {
                var t1;
                for(t1 = 0; t1 < i1; t1 += 1)e1[t1].animation.resize();
            }, t1.goToAndStop = function(t1, r1, a1) {
                var s1;
                for(s1 = 0; s1 < i1; s1 += 1)e1[s1].animation.goToAndStop(t1, r1, a1);
            }, t1.destroy = function(t1) {
                var r1;
                for(r1 = i1 - 1; r1 >= 0; r1 -= 1)e1[r1].animation.destroy(t1);
            }, t1.freeze = function() {
                n1 = !0;
            }, t1.unfreeze = function() {
                n1 = !1, d1();
            }, t1.setVolume = function(t1, r1) {
                var a1;
                for(a1 = 0; a1 < i1; a1 += 1)e1[a1].animation.setVolume(t1, r1);
            }, t1.mute = function(t1) {
                var r1;
                for(r1 = 0; r1 < i1; r1 += 1)e1[r1].animation.mute(t1);
            }, t1.unmute = function(t1) {
                var r1;
                for(r1 = 0; r1 < i1; r1 += 1)e1[r1].animation.unmute(t1);
            }, t1.getRegisteredAnimations = function() {
                var t1, r1 = e1.length, i1 = [];
                for(t1 = 0; t1 < r1; t1 += 1)i1.push(e1[t1].animation);
                return i1;
            }, t1;
        }(), BezierFactory = function() {
            var t1 = {
                getBezierEasing: function(t1, r1, i1, a1, s1) {
                    var n1 = s1 || ("bez_" + t1 + "_" + r1 + "_" + i1 + "_" + a1).replace(/\./g, "p");
                    if (e1[n1]) return e1[n1];
                    var o1 = new h1([
                        t1,
                        r1,
                        i1,
                        a1
                    ]);
                    return e1[n1] = o1, o1;
                }
            }, e1 = {};
            var r1 = "function" == typeof Float32Array;
            function i1(t1, e1) {
                return 1 - 3 * e1 + 3 * t1;
            }
            function a1(t1, e1) {
                return 3 * e1 - 6 * t1;
            }
            function s1(t1) {
                return 3 * t1;
            }
            function n1(t1, e1, r1) {
                return ((i1(e1, r1) * t1 + a1(e1, r1)) * t1 + s1(e1)) * t1;
            }
            function o1(t1, e1, r1) {
                return 3 * i1(e1, r1) * t1 * t1 + 2 * a1(e1, r1) * t1 + s1(e1);
            }
            function h1(t1) {
                this._p = t1, this._mSampleValues = r1 ? new Float32Array(11) : new Array(11), this._precomputed = !1, this.get = this.get.bind(this);
            }
            return h1.prototype = {
                get: function(t1) {
                    var e1 = this._p[0], r1 = this._p[1], i1 = this._p[2], a1 = this._p[3];
                    return this._precomputed || this._precompute(), e1 === r1 && i1 === a1 ? t1 : 0 === t1 ? 0 : 1 === t1 ? 1 : n1(this._getTForX(t1), r1, a1);
                },
                _precompute: function() {
                    var t1 = this._p[0], e1 = this._p[1], r1 = this._p[2], i1 = this._p[3];
                    this._precomputed = !0, t1 === e1 && r1 === i1 || this._calcSampleValues();
                },
                _calcSampleValues: function() {
                    for(var t1 = this._p[0], e1 = this._p[2], r1 = 0; r1 < 11; ++r1)this._mSampleValues[r1] = n1(.1 * r1, t1, e1);
                },
                _getTForX: function(t1) {
                    for(var e1 = this._p[0], r1 = this._p[2], i1 = this._mSampleValues, a1 = 0, s1 = 1; 10 !== s1 && i1[s1] <= t1; ++s1)a1 += .1;
                    var h1 = a1 + .1 * ((t1 - i1[--s1]) / (i1[s1 + 1] - i1[s1])), l1 = o1(h1, e1, r1);
                    return l1 >= .001 ? function(t1, e1, r1, i1) {
                        for(var a1 = 0; a1 < 4; ++a1){
                            var s1 = o1(e1, r1, i1);
                            if (0 === s1) return e1;
                            e1 -= (n1(e1, r1, i1) - t1) / s1;
                        }
                        return e1;
                    }(t1, h1, e1, r1) : 0 === l1 ? h1 : function(t1, e1, r1, i1, a1) {
                        var s1, o1, h1 = 0;
                        do (s1 = n1(o1 = e1 + (r1 - e1) / 2, i1, a1) - t1) > 0 ? r1 = o1 : e1 = o1;
                        while (Math.abs(s1) > 1e-7 && ++h1 < 10);
                        return o1;
                    }(t1, a1, a1 + .1, e1, r1);
                }
            }, t1;
        }(), pooling = {
            double: function(t1) {
                return t1.concat(createSizedArray(t1.length));
            }
        }, poolFactory = function(t1, e1, r1) {
            var i1 = 0, a1 = t1, s1 = createSizedArray(a1);
            return {
                newElement: function() {
                    return i1 ? s1[i1 -= 1] : e1();
                },
                release: function(t1) {
                    i1 === a1 && (s1 = pooling.double(s1), a1 *= 2), r1 && r1(t1), s1[i1] = t1, i1 += 1;
                }
            };
        }, bezierLengthPool = poolFactory(8, function() {
            return {
                addedLength: 0,
                percents: createTypedArray("float32", getDefaultCurveSegments()),
                lengths: createTypedArray("float32", getDefaultCurveSegments())
            };
        }), segmentsLengthPool = poolFactory(8, function() {
            return {
                lengths: [],
                totalLength: 0
            };
        }, function(t1) {
            var e1, r1 = t1.lengths.length;
            for(e1 = 0; e1 < r1; e1 += 1)bezierLengthPool.release(t1.lengths[e1]);
            t1.lengths.length = 0;
        });
        function bezFunction() {
            var t1 = Math;
            function e1(t1, e1, r1, i1, a1, s1) {
                var n1 = t1 * i1 + e1 * a1 + r1 * s1 - a1 * i1 - s1 * t1 - r1 * e1;
                return n1 > -0.001 && n1 < .001;
            }
            var r1 = function(t1, e1, r1, i1) {
                var a1, s1, n1, o1, h1, l1, p1 = getDefaultCurveSegments(), f1 = 0, c1 = [], m1 = [], d1 = bezierLengthPool.newElement();
                for(n1 = r1.length, a1 = 0; a1 < p1; a1 += 1){
                    for(h1 = a1 / (p1 - 1), l1 = 0, s1 = 0; s1 < n1; s1 += 1)o1 = bmPow(1 - h1, 3) * t1[s1] + 3 * bmPow(1 - h1, 2) * h1 * r1[s1] + 3 * (1 - h1) * bmPow(h1, 2) * i1[s1] + bmPow(h1, 3) * e1[s1], c1[s1] = o1, null !== m1[s1] && (l1 += bmPow(c1[s1] - m1[s1], 2)), m1[s1] = c1[s1];
                    l1 && (f1 += l1 = bmSqrt(l1)), d1.percents[a1] = h1, d1.lengths[a1] = f1;
                }
                return d1.addedLength = f1, d1;
            };
            function i1(t1) {
                this.segmentLength = 0, this.points = new Array(t1);
            }
            function a1(t1, e1) {
                this.partialLength = t1, this.point = e1;
            }
            var s1, n1 = (s1 = {}, function(t1, r1, n1, o1) {
                var h1 = (t1[0] + "_" + t1[1] + "_" + r1[0] + "_" + r1[1] + "_" + n1[0] + "_" + n1[1] + "_" + o1[0] + "_" + o1[1]).replace(/\./g, "p");
                if (!s1[h1]) {
                    var l1, p1, f1, c1, m1, d1, u1, y1 = getDefaultCurveSegments(), g1 = 0, v1 = null;
                    2 === t1.length && (t1[0] !== r1[0] || t1[1] !== r1[1]) && e1(t1[0], t1[1], r1[0], r1[1], t1[0] + n1[0], t1[1] + n1[1]) && e1(t1[0], t1[1], r1[0], r1[1], r1[0] + o1[0], r1[1] + o1[1]) && (y1 = 2);
                    var b1 = new i1(y1);
                    for(f1 = n1.length, l1 = 0; l1 < y1; l1 += 1){
                        for(u1 = createSizedArray(f1), m1 = l1 / (y1 - 1), d1 = 0, p1 = 0; p1 < f1; p1 += 1)c1 = bmPow(1 - m1, 3) * t1[p1] + 3 * bmPow(1 - m1, 2) * m1 * (t1[p1] + n1[p1]) + 3 * (1 - m1) * bmPow(m1, 2) * (r1[p1] + o1[p1]) + bmPow(m1, 3) * r1[p1], u1[p1] = c1, null !== v1 && (d1 += bmPow(u1[p1] - v1[p1], 2));
                        g1 += d1 = bmSqrt(d1), b1.points[l1] = new a1(d1, u1), v1 = u1;
                    }
                    b1.segmentLength = g1, s1[h1] = b1;
                }
                return s1[h1];
            });
            function o1(t1, e1) {
                var r1 = e1.percents, i1 = e1.lengths, a1 = r1.length, s1 = bmFloor((a1 - 1) * t1), n1 = t1 * e1.addedLength, o1 = 0;
                if (s1 === a1 - 1 || 0 === s1 || n1 === i1[s1]) return r1[s1];
                for(var h1 = i1[s1] > n1 ? -1 : 1, l1 = !0; l1;)if (i1[s1] <= n1 && i1[s1 + 1] > n1 ? (o1 = (n1 - i1[s1]) / (i1[s1 + 1] - i1[s1]), l1 = !1) : s1 += h1, s1 < 0 || s1 >= a1 - 1) {
                    if (s1 === a1 - 1) return r1[s1];
                    l1 = !1;
                }
                return r1[s1] + (r1[s1 + 1] - r1[s1]) * o1;
            }
            var h1 = createTypedArray("float32", 8);
            return {
                getSegmentsLength: function(t1) {
                    var e1, i1 = segmentsLengthPool.newElement(), a1 = t1.c, s1 = t1.v, n1 = t1.o, o1 = t1.i, h1 = t1._length, l1 = i1.lengths, p1 = 0;
                    for(e1 = 0; e1 < h1 - 1; e1 += 1)l1[e1] = r1(s1[e1], s1[e1 + 1], n1[e1], o1[e1 + 1]), p1 += l1[e1].addedLength;
                    return a1 && h1 && (l1[e1] = r1(s1[e1], s1[0], n1[e1], o1[0]), p1 += l1[e1].addedLength), i1.totalLength = p1, i1;
                },
                getNewSegment: function(e1, r1, i1, a1, s1, n1, l1) {
                    s1 < 0 ? s1 = 0 : s1 > 1 && (s1 = 1);
                    var p1, f1 = o1(s1, l1), c1 = o1(n1 = n1 > 1 ? 1 : n1, l1), m1 = e1.length, d1 = 1 - f1, u1 = 1 - c1, y1 = d1 * d1 * d1, g1 = f1 * d1 * d1 * 3, v1 = f1 * f1 * d1 * 3, b1 = f1 * f1 * f1, x1 = d1 * d1 * u1, P1 = f1 * d1 * u1 + d1 * f1 * u1 + d1 * d1 * c1, E1 = f1 * f1 * u1 + d1 * f1 * c1 + f1 * d1 * c1, S1 = f1 * f1 * c1, C1 = d1 * u1 * u1, _1 = f1 * u1 * u1 + d1 * c1 * u1 + d1 * u1 * c1, A1 = f1 * c1 * u1 + d1 * c1 * c1 + f1 * u1 * c1, k1 = f1 * c1 * c1, w1 = u1 * u1 * u1, T1 = c1 * u1 * u1 + u1 * c1 * u1 + u1 * u1 * c1, M1 = c1 * c1 * u1 + u1 * c1 * c1 + c1 * u1 * c1, D1 = c1 * c1 * c1;
                    for(p1 = 0; p1 < m1; p1 += 1)h1[4 * p1] = t1.round(1e3 * (y1 * e1[p1] + g1 * i1[p1] + v1 * a1[p1] + b1 * r1[p1])) / 1e3, h1[4 * p1 + 1] = t1.round(1e3 * (x1 * e1[p1] + P1 * i1[p1] + E1 * a1[p1] + S1 * r1[p1])) / 1e3, h1[4 * p1 + 2] = t1.round(1e3 * (C1 * e1[p1] + _1 * i1[p1] + A1 * a1[p1] + k1 * r1[p1])) / 1e3, h1[4 * p1 + 3] = t1.round(1e3 * (w1 * e1[p1] + T1 * i1[p1] + M1 * a1[p1] + D1 * r1[p1])) / 1e3;
                    return h1;
                },
                getPointInSegment: function(e1, r1, i1, a1, s1, n1) {
                    var h1 = o1(s1, n1), l1 = 1 - h1;
                    return [
                        t1.round(1e3 * (l1 * l1 * l1 * e1[0] + (h1 * l1 * l1 + l1 * h1 * l1 + l1 * l1 * h1) * i1[0] + (h1 * h1 * l1 + l1 * h1 * h1 + h1 * l1 * h1) * a1[0] + h1 * h1 * h1 * r1[0])) / 1e3,
                        t1.round(1e3 * (l1 * l1 * l1 * e1[1] + (h1 * l1 * l1 + l1 * h1 * l1 + l1 * l1 * h1) * i1[1] + (h1 * h1 * l1 + l1 * h1 * h1 + h1 * l1 * h1) * a1[1] + h1 * h1 * h1 * r1[1])) / 1e3
                    ];
                },
                buildBezierData: n1,
                pointOnLine2D: e1,
                pointOnLine3D: function(r1, i1, a1, s1, n1, o1, h1, l1, p1) {
                    if (0 === a1 && 0 === o1 && 0 === p1) return e1(r1, i1, s1, n1, h1, l1);
                    var f1, c1 = t1.sqrt(t1.pow(s1 - r1, 2) + t1.pow(n1 - i1, 2) + t1.pow(o1 - a1, 2)), m1 = t1.sqrt(t1.pow(h1 - r1, 2) + t1.pow(l1 - i1, 2) + t1.pow(p1 - a1, 2)), d1 = t1.sqrt(t1.pow(h1 - s1, 2) + t1.pow(l1 - n1, 2) + t1.pow(p1 - o1, 2));
                    return (f1 = c1 > m1 ? c1 > d1 ? c1 - m1 - d1 : d1 - m1 - c1 : d1 > m1 ? d1 - m1 - c1 : m1 - c1 - d1) > -0.0001 && f1 < 1e-4;
                }
            };
        }
        var bez = bezFunction(), PropertyFactory = function() {
            var t1 = initialDefaultFrame, e1 = Math.abs;
            function r1(t1, e1) {
                var r1, a1 = this.offsetTime;
                "multidimensional" === this.propType && (r1 = createTypedArray("float32", this.pv.length));
                for(var s1, n1, o1, h1, l1, p1, f1, c1, m1, d1 = e1.lastIndex, u1 = d1, y1 = this.keyframes.length - 1, g1 = !0; g1;){
                    if (s1 = this.keyframes[u1], n1 = this.keyframes[u1 + 1], u1 === y1 - 1 && t1 >= n1.t - a1) {
                        s1.h && (s1 = n1), d1 = 0;
                        break;
                    }
                    if (n1.t - a1 > t1) {
                        d1 = u1;
                        break;
                    }
                    u1 < y1 - 1 ? u1 += 1 : (d1 = 0, g1 = !1);
                }
                o1 = this.keyframesMetadata[u1] || {};
                var v1, b1 = n1.t - a1, x1 = s1.t - a1;
                if (s1.to) {
                    o1.bezierData || (o1.bezierData = bez.buildBezierData(s1.s, n1.s || s1.e, s1.to, s1.ti));
                    var P1 = o1.bezierData;
                    if (t1 >= b1 || t1 < x1) {
                        var E1 = t1 >= b1 ? P1.points.length - 1 : 0;
                        for(l1 = P1.points[E1].point.length, h1 = 0; h1 < l1; h1 += 1)r1[h1] = P1.points[E1].point[h1];
                    } else {
                        o1.__fnct ? m1 = o1.__fnct : (m1 = BezierFactory.getBezierEasing(s1.o.x, s1.o.y, s1.i.x, s1.i.y, s1.n).get, o1.__fnct = m1), p1 = m1((t1 - x1) / (b1 - x1));
                        var S1, C1 = P1.segmentLength * p1, _1 = e1.lastFrame < t1 && e1._lastKeyframeIndex === u1 ? e1._lastAddedLength : 0;
                        for(c1 = e1.lastFrame < t1 && e1._lastKeyframeIndex === u1 ? e1._lastPoint : 0, g1 = !0, f1 = P1.points.length; g1;){
                            if (_1 += P1.points[c1].partialLength, 0 === C1 || 0 === p1 || c1 === P1.points.length - 1) {
                                for(l1 = P1.points[c1].point.length, h1 = 0; h1 < l1; h1 += 1)r1[h1] = P1.points[c1].point[h1];
                                break;
                            }
                            if (C1 >= _1 && C1 < _1 + P1.points[c1 + 1].partialLength) {
                                for(S1 = (C1 - _1) / P1.points[c1 + 1].partialLength, l1 = P1.points[c1].point.length, h1 = 0; h1 < l1; h1 += 1)r1[h1] = P1.points[c1].point[h1] + (P1.points[c1 + 1].point[h1] - P1.points[c1].point[h1]) * S1;
                                break;
                            }
                            c1 < f1 - 1 ? c1 += 1 : g1 = !1;
                        }
                        e1._lastPoint = c1, e1._lastAddedLength = _1 - P1.points[c1].partialLength, e1._lastKeyframeIndex = u1;
                    }
                } else {
                    var A1, k1, w1, T1, M1;
                    if (y1 = s1.s.length, v1 = n1.s || s1.e, this.sh && 1 !== s1.h) {
                        if (t1 >= b1) r1[0] = v1[0], r1[1] = v1[1], r1[2] = v1[2];
                        else if (t1 <= x1) r1[0] = s1.s[0], r1[1] = s1.s[1], r1[2] = s1.s[2];
                        else !function(t1, e1) {
                            var r1 = e1[0], i1 = e1[1], a1 = e1[2], s1 = e1[3], n1 = Math.atan2(2 * i1 * s1 - 2 * r1 * a1, 1 - 2 * i1 * i1 - 2 * a1 * a1), o1 = Math.asin(2 * r1 * i1 + 2 * a1 * s1), h1 = Math.atan2(2 * r1 * s1 - 2 * i1 * a1, 1 - 2 * r1 * r1 - 2 * a1 * a1);
                            t1[0] = n1 / degToRads, t1[1] = o1 / degToRads, t1[2] = h1 / degToRads;
                        }(r1, function(t1, e1, r1) {
                            var i1, a1, s1, n1, o1, h1 = [], l1 = t1[0], p1 = t1[1], f1 = t1[2], c1 = t1[3], m1 = e1[0], d1 = e1[1], u1 = e1[2], y1 = e1[3];
                            (a1 = l1 * m1 + p1 * d1 + f1 * u1 + c1 * y1) < 0 && (a1 = -a1, m1 = -m1, d1 = -d1, u1 = -u1, y1 = -y1);
                            1 - a1 > 1e-6 ? (i1 = Math.acos(a1), s1 = Math.sin(i1), n1 = Math.sin((1 - r1) * i1) / s1, o1 = Math.sin(r1 * i1) / s1) : (n1 = 1 - r1, o1 = r1);
                            return h1[0] = n1 * l1 + o1 * m1, h1[1] = n1 * p1 + o1 * d1, h1[2] = n1 * f1 + o1 * u1, h1[3] = n1 * c1 + o1 * y1, h1;
                        }(i1(s1.s), i1(v1), (t1 - x1) / (b1 - x1)));
                    } else for(u1 = 0; u1 < y1; u1 += 1)1 !== s1.h && (t1 >= b1 ? p1 = 1 : t1 < x1 ? p1 = 0 : (s1.o.x.constructor === Array ? (o1.__fnct || (o1.__fnct = []), o1.__fnct[u1] ? m1 = o1.__fnct[u1] : (A1 = void 0 === s1.o.x[u1] ? s1.o.x[0] : s1.o.x[u1], k1 = void 0 === s1.o.y[u1] ? s1.o.y[0] : s1.o.y[u1], w1 = void 0 === s1.i.x[u1] ? s1.i.x[0] : s1.i.x[u1], T1 = void 0 === s1.i.y[u1] ? s1.i.y[0] : s1.i.y[u1], m1 = BezierFactory.getBezierEasing(A1, k1, w1, T1).get, o1.__fnct[u1] = m1)) : o1.__fnct ? m1 = o1.__fnct : (A1 = s1.o.x, k1 = s1.o.y, w1 = s1.i.x, T1 = s1.i.y, m1 = BezierFactory.getBezierEasing(A1, k1, w1, T1).get, s1.keyframeMetadata = m1), p1 = m1((t1 - x1) / (b1 - x1)))), v1 = n1.s || s1.e, M1 = 1 === s1.h ? s1.s[u1] : s1.s[u1] + (v1[u1] - s1.s[u1]) * p1, "multidimensional" === this.propType ? r1[u1] = M1 : r1 = M1;
                }
                return e1.lastIndex = d1, r1;
            }
            function i1(t1) {
                var e1 = t1[0] * degToRads, r1 = t1[1] * degToRads, i1 = t1[2] * degToRads, a1 = Math.cos(e1 / 2), s1 = Math.cos(r1 / 2), n1 = Math.cos(i1 / 2), o1 = Math.sin(e1 / 2), h1 = Math.sin(r1 / 2), l1 = Math.sin(i1 / 2);
                return [
                    o1 * h1 * n1 + a1 * s1 * l1,
                    o1 * s1 * n1 + a1 * h1 * l1,
                    a1 * h1 * n1 - o1 * s1 * l1,
                    a1 * s1 * n1 - o1 * h1 * l1
                ];
            }
            function a1() {
                var e1 = this.comp.renderedFrame - this.offsetTime, r1 = this.keyframes[0].t - this.offsetTime, i1 = this.keyframes[this.keyframes.length - 1].t - this.offsetTime;
                if (!(e1 === this._caching.lastFrame || this._caching.lastFrame !== t1 && (this._caching.lastFrame >= i1 && e1 >= i1 || this._caching.lastFrame < r1 && e1 < r1))) {
                    this._caching.lastFrame >= e1 && (this._caching._lastKeyframeIndex = -1, this._caching.lastIndex = 0);
                    var a1 = this.interpolateValue(e1, this._caching);
                    this.pv = a1;
                }
                return this._caching.lastFrame = e1, this.pv;
            }
            function s1(t1) {
                var r1;
                if ("unidimensional" === this.propType) r1 = t1 * this.mult, e1(this.v - r1) > 1e-5 && (this.v = r1, this._mdf = !0);
                else for(var i1 = 0, a1 = this.v.length; i1 < a1;)r1 = t1[i1] * this.mult, e1(this.v[i1] - r1) > 1e-5 && (this.v[i1] = r1, this._mdf = !0), i1 += 1;
            }
            function n1() {
                if (this.elem.globalData.frameId !== this.frameId && this.effectsSequence.length) {
                    if (this.lock) this.setVValue(this.pv);
                    else {
                        var t1;
                        this.lock = !0, this._mdf = this._isFirstFrame;
                        var e1 = this.effectsSequence.length, r1 = this.kf ? this.pv : this.data.k;
                        for(t1 = 0; t1 < e1; t1 += 1)r1 = this.effectsSequence[t1](r1);
                        this.setVValue(r1), this._isFirstFrame = !1, this.lock = !1, this.frameId = this.elem.globalData.frameId;
                    }
                }
            }
            function o1(t1) {
                this.effectsSequence.push(t1), this.container.addDynamicProperty(this);
            }
            function h1(t1, e1, r1, i1) {
                this.propType = "unidimensional", this.mult = r1 || 1, this.data = e1, this.v = r1 ? e1.k * r1 : e1.k, this.pv = e1.k, this._mdf = !1, this.elem = t1, this.container = i1, this.comp = t1.comp, this.k = !1, this.kf = !1, this.vel = 0, this.effectsSequence = [], this._isFirstFrame = !0, this.getValue = n1, this.setVValue = s1, this.addEffect = o1;
            }
            function l1(t1, e1, r1, i1) {
                var a1;
                this.propType = "multidimensional", this.mult = r1 || 1, this.data = e1, this._mdf = !1, this.elem = t1, this.container = i1, this.comp = t1.comp, this.k = !1, this.kf = !1, this.frameId = -1;
                var h1 = e1.k.length;
                for(this.v = createTypedArray("float32", h1), this.pv = createTypedArray("float32", h1), this.vel = createTypedArray("float32", h1), a1 = 0; a1 < h1; a1 += 1)this.v[a1] = e1.k[a1] * this.mult, this.pv[a1] = e1.k[a1];
                this._isFirstFrame = !0, this.effectsSequence = [], this.getValue = n1, this.setVValue = s1, this.addEffect = o1;
            }
            function p1(e1, i1, h1, l1) {
                this.propType = "unidimensional", this.keyframes = i1.k, this.keyframesMetadata = [], this.offsetTime = e1.data.st, this.frameId = -1, this._caching = {
                    lastFrame: t1,
                    lastIndex: 0,
                    value: 0,
                    _lastKeyframeIndex: -1
                }, this.k = !0, this.kf = !0, this.data = i1, this.mult = h1 || 1, this.elem = e1, this.container = l1, this.comp = e1.comp, this.v = t1, this.pv = t1, this._isFirstFrame = !0, this.getValue = n1, this.setVValue = s1, this.interpolateValue = r1, this.effectsSequence = [
                    a1.bind(this)
                ], this.addEffect = o1;
            }
            function f1(e1, i1, h1, l1) {
                var p1;
                this.propType = "multidimensional";
                var f1, c1, m1, d1, u1 = i1.k.length;
                for(p1 = 0; p1 < u1 - 1; p1 += 1)i1.k[p1].to && i1.k[p1].s && i1.k[p1 + 1] && i1.k[p1 + 1].s && (f1 = i1.k[p1].s, c1 = i1.k[p1 + 1].s, m1 = i1.k[p1].to, d1 = i1.k[p1].ti, (2 === f1.length && (f1[0] !== c1[0] || f1[1] !== c1[1]) && bez.pointOnLine2D(f1[0], f1[1], c1[0], c1[1], f1[0] + m1[0], f1[1] + m1[1]) && bez.pointOnLine2D(f1[0], f1[1], c1[0], c1[1], c1[0] + d1[0], c1[1] + d1[1]) || 3 === f1.length && (f1[0] !== c1[0] || f1[1] !== c1[1] || f1[2] !== c1[2]) && bez.pointOnLine3D(f1[0], f1[1], f1[2], c1[0], c1[1], c1[2], f1[0] + m1[0], f1[1] + m1[1], f1[2] + m1[2]) && bez.pointOnLine3D(f1[0], f1[1], f1[2], c1[0], c1[1], c1[2], c1[0] + d1[0], c1[1] + d1[1], c1[2] + d1[2])) && (i1.k[p1].to = null, i1.k[p1].ti = null), f1[0] === c1[0] && f1[1] === c1[1] && 0 === m1[0] && 0 === m1[1] && 0 === d1[0] && 0 === d1[1] && (2 === f1.length || f1[2] === c1[2] && 0 === m1[2] && 0 === d1[2]) && (i1.k[p1].to = null, i1.k[p1].ti = null));
                this.effectsSequence = [
                    a1.bind(this)
                ], this.data = i1, this.keyframes = i1.k, this.keyframesMetadata = [], this.offsetTime = e1.data.st, this.k = !0, this.kf = !0, this._isFirstFrame = !0, this.mult = h1 || 1, this.elem = e1, this.container = l1, this.comp = e1.comp, this.getValue = n1, this.setVValue = s1, this.interpolateValue = r1, this.frameId = -1;
                var y1 = i1.k[0].s.length;
                for(this.v = createTypedArray("float32", y1), this.pv = createTypedArray("float32", y1), p1 = 0; p1 < y1; p1 += 1)this.v[p1] = t1, this.pv[p1] = t1;
                this._caching = {
                    lastFrame: t1,
                    lastIndex: 0,
                    value: createTypedArray("float32", y1)
                }, this.addEffect = o1;
            }
            return {
                getProp: function(t1, e1, r1, i1, a1) {
                    var s1;
                    if (e1.k.length) {
                        if ("number" == typeof e1.k[0]) s1 = new l1(t1, e1, i1, a1);
                        else switch(r1){
                            case 0:
                                s1 = new p1(t1, e1, i1, a1);
                                break;
                            case 1:
                                s1 = new f1(t1, e1, i1, a1);
                        }
                    } else s1 = new h1(t1, e1, i1, a1);
                    return s1.effectsSequence.length && a1.addDynamicProperty(s1), s1;
                }
            };
        }();
        function DynamicPropertyContainer() {}
        DynamicPropertyContainer.prototype = {
            addDynamicProperty: function(t1) {
                -1 === this.dynamicProperties.indexOf(t1) && (this.dynamicProperties.push(t1), this.container.addDynamicProperty(this), this._isAnimated = !0);
            },
            iterateDynamicProperties: function() {
                var t1;
                this._mdf = !1;
                var e1 = this.dynamicProperties.length;
                for(t1 = 0; t1 < e1; t1 += 1)this.dynamicProperties[t1].getValue(), this.dynamicProperties[t1]._mdf && (this._mdf = !0);
            },
            initDynamicPropertyContainer: function(t1) {
                this.container = t1, this.dynamicProperties = [], this._mdf = !1, this._isAnimated = !1;
            }
        };
        var pointPool = poolFactory(8, function() {
            return createTypedArray("float32", 2);
        });
        function ShapePath() {
            this.c = !1, this._length = 0, this._maxLength = 8, this.v = createSizedArray(this._maxLength), this.o = createSizedArray(this._maxLength), this.i = createSizedArray(this._maxLength);
        }
        ShapePath.prototype.setPathData = function(t1, e1) {
            this.c = t1, this.setLength(e1);
            for(var r1 = 0; r1 < e1;)this.v[r1] = pointPool.newElement(), this.o[r1] = pointPool.newElement(), this.i[r1] = pointPool.newElement(), r1 += 1;
        }, ShapePath.prototype.setLength = function(t1) {
            for(; this._maxLength < t1;)this.doubleArrayLength();
            this._length = t1;
        }, ShapePath.prototype.doubleArrayLength = function() {
            this.v = this.v.concat(createSizedArray(this._maxLength)), this.i = this.i.concat(createSizedArray(this._maxLength)), this.o = this.o.concat(createSizedArray(this._maxLength)), this._maxLength *= 2;
        }, ShapePath.prototype.setXYAt = function(t1, e1, r1, i1, a1) {
            var s1;
            switch(this._length = Math.max(this._length, i1 + 1), this._length >= this._maxLength && this.doubleArrayLength(), r1){
                case "v":
                    s1 = this.v;
                    break;
                case "i":
                    s1 = this.i;
                    break;
                case "o":
                    s1 = this.o;
                    break;
                default:
                    s1 = [];
            }
            (!s1[i1] || s1[i1] && !a1) && (s1[i1] = pointPool.newElement()), s1[i1][0] = t1, s1[i1][1] = e1;
        }, ShapePath.prototype.setTripleAt = function(t1, e1, r1, i1, a1, s1, n1, o1) {
            this.setXYAt(t1, e1, "v", n1, o1), this.setXYAt(r1, i1, "o", n1, o1), this.setXYAt(a1, s1, "i", n1, o1);
        }, ShapePath.prototype.reverse = function() {
            var t1 = new ShapePath;
            t1.setPathData(this.c, this._length);
            var e1 = this.v, r1 = this.o, i1 = this.i, a1 = 0;
            this.c && (t1.setTripleAt(e1[0][0], e1[0][1], i1[0][0], i1[0][1], r1[0][0], r1[0][1], 0, !1), a1 = 1);
            var s1, n1 = this._length - 1, o1 = this._length;
            for(s1 = a1; s1 < o1; s1 += 1)t1.setTripleAt(e1[n1][0], e1[n1][1], i1[n1][0], i1[n1][1], r1[n1][0], r1[n1][1], s1, !1), n1 -= 1;
            return t1;
        }, ShapePath.prototype.length = function() {
            return this._length;
        };
        var shapePool = (factory = poolFactory(4, function() {
            return new ShapePath;
        }, function(t1) {
            var e1, r1 = t1._length;
            for(e1 = 0; e1 < r1; e1 += 1)pointPool.release(t1.v[e1]), pointPool.release(t1.i[e1]), pointPool.release(t1.o[e1]), t1.v[e1] = null, t1.i[e1] = null, t1.o[e1] = null;
            t1._length = 0, t1.c = !1;
        }), factory.clone = function(t1) {
            var e1, r1 = factory.newElement(), i1 = void 0 === t1._length ? t1.v.length : t1._length;
            for(r1.setLength(i1), r1.c = t1.c, e1 = 0; e1 < i1; e1 += 1)r1.setTripleAt(t1.v[e1][0], t1.v[e1][1], t1.o[e1][0], t1.o[e1][1], t1.i[e1][0], t1.i[e1][1], e1);
            return r1;
        }, factory), factory;
        function ShapeCollection() {
            this._length = 0, this._maxLength = 4, this.shapes = createSizedArray(this._maxLength);
        }
        ShapeCollection.prototype.addShape = function(t1) {
            this._length === this._maxLength && (this.shapes = this.shapes.concat(createSizedArray(this._maxLength)), this._maxLength *= 2), this.shapes[this._length] = t1, this._length += 1;
        }, ShapeCollection.prototype.releaseShapes = function() {
            var t1;
            for(t1 = 0; t1 < this._length; t1 += 1)shapePool.release(this.shapes[t1]);
            this._length = 0;
        };
        var shapeCollectionPool = (ob = {
            newShapeCollection: function() {
                return _length ? pool[_length -= 1] : new ShapeCollection;
            },
            release: function(t1) {
                var e1, r1 = t1._length;
                for(e1 = 0; e1 < r1; e1 += 1)shapePool.release(t1.shapes[e1]);
                t1._length = 0, _length === _maxLength && (pool = pooling.double(pool), _maxLength *= 2), pool[_length] = t1, _length += 1;
            }
        }, _length = 0, _maxLength = 4, pool = createSizedArray(_maxLength), ob), ob, _length, _maxLength, pool, ShapePropertyFactory = function() {
            function t1(t1, e1, r1) {
                var i1, a1, s1, n1, o1, h1, l1, p1, f1, c1 = r1.lastIndex, m1 = this.keyframes;
                if (t1 < m1[0].t - this.offsetTime) i1 = m1[0].s[0], s1 = !0, c1 = 0;
                else if (t1 >= m1[m1.length - 1].t - this.offsetTime) i1 = m1[m1.length - 1].s ? m1[m1.length - 1].s[0] : m1[m1.length - 2].e[0], s1 = !0;
                else {
                    for(var d1, u1, y1, g1 = c1, v1 = m1.length - 1, b1 = !0; b1 && (d1 = m1[g1], !((u1 = m1[g1 + 1]).t - this.offsetTime > t1));)g1 < v1 - 1 ? g1 += 1 : b1 = !1;
                    if (y1 = this.keyframesMetadata[g1] || {}, c1 = g1, !(s1 = 1 === d1.h)) {
                        if (t1 >= u1.t - this.offsetTime) p1 = 1;
                        else if (t1 < d1.t - this.offsetTime) p1 = 0;
                        else {
                            var x1;
                            y1.__fnct ? x1 = y1.__fnct : (x1 = BezierFactory.getBezierEasing(d1.o.x, d1.o.y, d1.i.x, d1.i.y).get, y1.__fnct = x1), p1 = x1((t1 - (d1.t - this.offsetTime)) / (u1.t - this.offsetTime - (d1.t - this.offsetTime)));
                        }
                        a1 = u1.s ? u1.s[0] : d1.e[0];
                    }
                    i1 = d1.s[0];
                }
                for(h1 = e1._length, l1 = i1.i[0].length, r1.lastIndex = c1, n1 = 0; n1 < h1; n1 += 1)for(o1 = 0; o1 < l1; o1 += 1)f1 = s1 ? i1.i[n1][o1] : i1.i[n1][o1] + (a1.i[n1][o1] - i1.i[n1][o1]) * p1, e1.i[n1][o1] = f1, f1 = s1 ? i1.o[n1][o1] : i1.o[n1][o1] + (a1.o[n1][o1] - i1.o[n1][o1]) * p1, e1.o[n1][o1] = f1, f1 = s1 ? i1.v[n1][o1] : i1.v[n1][o1] + (a1.v[n1][o1] - i1.v[n1][o1]) * p1, e1.v[n1][o1] = f1;
            }
            function e1() {
                var t1 = this.comp.renderedFrame - this.offsetTime, e1 = this.keyframes[0].t - this.offsetTime, r1 = this.keyframes[this.keyframes.length - 1].t - this.offsetTime, i1 = this._caching.lastFrame;
                return -999999 !== i1 && (i1 < e1 && t1 < e1 || i1 > r1 && t1 > r1) || (this._caching.lastIndex = i1 < t1 ? this._caching.lastIndex : 0, this.interpolateShape(t1, this.pv, this._caching)), this._caching.lastFrame = t1, this.pv;
            }
            function r1() {
                this.paths = this.localShapeCollection;
            }
            function i1(t1) {
                (function(t1, e1) {
                    if (t1._length !== e1._length || t1.c !== e1.c) return !1;
                    var r1, i1 = t1._length;
                    for(r1 = 0; r1 < i1; r1 += 1)if (t1.v[r1][0] !== e1.v[r1][0] || t1.v[r1][1] !== e1.v[r1][1] || t1.o[r1][0] !== e1.o[r1][0] || t1.o[r1][1] !== e1.o[r1][1] || t1.i[r1][0] !== e1.i[r1][0] || t1.i[r1][1] !== e1.i[r1][1]) return !1;
                    return !0;
                })(this.v, t1) || (this.v = shapePool.clone(t1), this.localShapeCollection.releaseShapes(), this.localShapeCollection.addShape(this.v), this._mdf = !0, this.paths = this.localShapeCollection);
            }
            function a1() {
                if (this.elem.globalData.frameId !== this.frameId) {
                    if (this.effectsSequence.length) {
                        if (this.lock) this.setVValue(this.pv);
                        else {
                            var t1, e1;
                            this.lock = !0, this._mdf = !1, t1 = this.kf ? this.pv : this.data.ks ? this.data.ks.k : this.data.pt.k;
                            var r1 = this.effectsSequence.length;
                            for(e1 = 0; e1 < r1; e1 += 1)t1 = this.effectsSequence[e1](t1);
                            this.setVValue(t1), this.lock = !1, this.frameId = this.elem.globalData.frameId;
                        }
                    } else this._mdf = !1;
                }
            }
            function s1(t1, e1, i1) {
                this.propType = "shape", this.comp = t1.comp, this.container = t1, this.elem = t1, this.data = e1, this.k = !1, this.kf = !1, this._mdf = !1;
                var a1 = 3 === i1 ? e1.pt.k : e1.ks.k;
                this.v = shapePool.clone(a1), this.pv = shapePool.clone(this.v), this.localShapeCollection = shapeCollectionPool.newShapeCollection(), this.paths = this.localShapeCollection, this.paths.addShape(this.v), this.reset = r1, this.effectsSequence = [];
            }
            function n1(t1) {
                this.effectsSequence.push(t1), this.container.addDynamicProperty(this);
            }
            function o1(t1, i1, a1) {
                this.propType = "shape", this.comp = t1.comp, this.elem = t1, this.container = t1, this.offsetTime = t1.data.st, this.keyframes = 3 === a1 ? i1.pt.k : i1.ks.k, this.keyframesMetadata = [], this.k = !0, this.kf = !0;
                var s1 = this.keyframes[0].s[0].i.length;
                this.v = shapePool.newElement(), this.v.setPathData(this.keyframes[0].s[0].c, s1), this.pv = shapePool.clone(this.v), this.localShapeCollection = shapeCollectionPool.newShapeCollection(), this.paths = this.localShapeCollection, this.paths.addShape(this.v), this.lastFrame = -999999, this.reset = r1, this._caching = {
                    lastFrame: -999999,
                    lastIndex: 0
                }, this.effectsSequence = [
                    e1.bind(this)
                ];
            }
            s1.prototype.interpolateShape = t1, s1.prototype.getValue = a1, s1.prototype.setVValue = i1, s1.prototype.addEffect = n1, o1.prototype.getValue = a1, o1.prototype.interpolateShape = t1, o1.prototype.setVValue = i1, o1.prototype.addEffect = n1;
            var h1 = function() {
                var t1 = roundCorner;
                function e1(t1, e1) {
                    this.v = shapePool.newElement(), this.v.setPathData(!0, 4), this.localShapeCollection = shapeCollectionPool.newShapeCollection(), this.paths = this.localShapeCollection, this.localShapeCollection.addShape(this.v), this.d = e1.d, this.elem = t1, this.comp = t1.comp, this.frameId = -1, this.initDynamicPropertyContainer(t1), this.p = PropertyFactory.getProp(t1, e1.p, 1, 0, this), this.s = PropertyFactory.getProp(t1, e1.s, 1, 0, this), this.dynamicProperties.length ? this.k = !0 : (this.k = !1, this.convertEllToPath());
                }
                return e1.prototype = {
                    reset: r1,
                    getValue: function() {
                        this.elem.globalData.frameId !== this.frameId && (this.frameId = this.elem.globalData.frameId, this.iterateDynamicProperties(), this._mdf && this.convertEllToPath());
                    },
                    convertEllToPath: function() {
                        var e1 = this.p.v[0], r1 = this.p.v[1], i1 = this.s.v[0] / 2, a1 = this.s.v[1] / 2, s1 = 3 !== this.d, n1 = this.v;
                        n1.v[0][0] = e1, n1.v[0][1] = r1 - a1, n1.v[1][0] = s1 ? e1 + i1 : e1 - i1, n1.v[1][1] = r1, n1.v[2][0] = e1, n1.v[2][1] = r1 + a1, n1.v[3][0] = s1 ? e1 - i1 : e1 + i1, n1.v[3][1] = r1, n1.i[0][0] = s1 ? e1 - i1 * t1 : e1 + i1 * t1, n1.i[0][1] = r1 - a1, n1.i[1][0] = s1 ? e1 + i1 : e1 - i1, n1.i[1][1] = r1 - a1 * t1, n1.i[2][0] = s1 ? e1 + i1 * t1 : e1 - i1 * t1, n1.i[2][1] = r1 + a1, n1.i[3][0] = s1 ? e1 - i1 : e1 + i1, n1.i[3][1] = r1 + a1 * t1, n1.o[0][0] = s1 ? e1 + i1 * t1 : e1 - i1 * t1, n1.o[0][1] = r1 - a1, n1.o[1][0] = s1 ? e1 + i1 : e1 - i1, n1.o[1][1] = r1 + a1 * t1, n1.o[2][0] = s1 ? e1 - i1 * t1 : e1 + i1 * t1, n1.o[2][1] = r1 + a1, n1.o[3][0] = s1 ? e1 - i1 : e1 + i1, n1.o[3][1] = r1 - a1 * t1;
                    }
                }, extendPrototype([
                    DynamicPropertyContainer
                ], e1), e1;
            }(), l1 = function() {
                function t1(t1, e1) {
                    this.v = shapePool.newElement(), this.v.setPathData(!0, 0), this.elem = t1, this.comp = t1.comp, this.data = e1, this.frameId = -1, this.d = e1.d, this.initDynamicPropertyContainer(t1), 1 === e1.sy ? (this.ir = PropertyFactory.getProp(t1, e1.ir, 0, 0, this), this.is = PropertyFactory.getProp(t1, e1.is, 0, .01, this), this.convertToPath = this.convertStarToPath) : this.convertToPath = this.convertPolygonToPath, this.pt = PropertyFactory.getProp(t1, e1.pt, 0, 0, this), this.p = PropertyFactory.getProp(t1, e1.p, 1, 0, this), this.r = PropertyFactory.getProp(t1, e1.r, 0, degToRads, this), this.or = PropertyFactory.getProp(t1, e1.or, 0, 0, this), this.os = PropertyFactory.getProp(t1, e1.os, 0, .01, this), this.localShapeCollection = shapeCollectionPool.newShapeCollection(), this.localShapeCollection.addShape(this.v), this.paths = this.localShapeCollection, this.dynamicProperties.length ? this.k = !0 : (this.k = !1, this.convertToPath());
                }
                return t1.prototype = {
                    reset: r1,
                    getValue: function() {
                        this.elem.globalData.frameId !== this.frameId && (this.frameId = this.elem.globalData.frameId, this.iterateDynamicProperties(), this._mdf && this.convertToPath());
                    },
                    convertStarToPath: function() {
                        var t1, e1, r1, i1, a1 = 2 * Math.floor(this.pt.v), s1 = 2 * Math.PI / a1, n1 = !0, o1 = this.or.v, h1 = this.ir.v, l1 = this.os.v, p1 = this.is.v, f1 = 2 * Math.PI * o1 / (2 * a1), c1 = 2 * Math.PI * h1 / (2 * a1), m1 = -Math.PI / 2;
                        m1 += this.r.v;
                        var d1 = 3 === this.data.d ? -1 : 1;
                        for(this.v._length = 0, t1 = 0; t1 < a1; t1 += 1){
                            r1 = n1 ? l1 : p1, i1 = n1 ? f1 : c1;
                            var u1 = (e1 = n1 ? o1 : h1) * Math.cos(m1), y1 = e1 * Math.sin(m1), g1 = 0 === u1 && 0 === y1 ? 0 : y1 / Math.sqrt(u1 * u1 + y1 * y1), v1 = 0 === u1 && 0 === y1 ? 0 : -u1 / Math.sqrt(u1 * u1 + y1 * y1);
                            u1 += +this.p.v[0], y1 += +this.p.v[1], this.v.setTripleAt(u1, y1, u1 - g1 * i1 * r1 * d1, y1 - v1 * i1 * r1 * d1, u1 + g1 * i1 * r1 * d1, y1 + v1 * i1 * r1 * d1, t1, !0), n1 = !n1, m1 += s1 * d1;
                        }
                    },
                    convertPolygonToPath: function() {
                        var t1, e1 = Math.floor(this.pt.v), r1 = 2 * Math.PI / e1, i1 = this.or.v, a1 = this.os.v, s1 = 2 * Math.PI * i1 / (4 * e1), n1 = .5 * -Math.PI, o1 = 3 === this.data.d ? -1 : 1;
                        for(n1 += this.r.v, this.v._length = 0, t1 = 0; t1 < e1; t1 += 1){
                            var h1 = i1 * Math.cos(n1), l1 = i1 * Math.sin(n1), p1 = 0 === h1 && 0 === l1 ? 0 : l1 / Math.sqrt(h1 * h1 + l1 * l1), f1 = 0 === h1 && 0 === l1 ? 0 : -h1 / Math.sqrt(h1 * h1 + l1 * l1);
                            h1 += +this.p.v[0], l1 += +this.p.v[1], this.v.setTripleAt(h1, l1, h1 - p1 * s1 * a1 * o1, l1 - f1 * s1 * a1 * o1, h1 + p1 * s1 * a1 * o1, l1 + f1 * s1 * a1 * o1, t1, !0), n1 += r1 * o1;
                        }
                        this.paths.length = 0, this.paths[0] = this.v;
                    }
                }, extendPrototype([
                    DynamicPropertyContainer
                ], t1), t1;
            }(), p1 = function() {
                function t1(t1, e1) {
                    this.v = shapePool.newElement(), this.v.c = !0, this.localShapeCollection = shapeCollectionPool.newShapeCollection(), this.localShapeCollection.addShape(this.v), this.paths = this.localShapeCollection, this.elem = t1, this.comp = t1.comp, this.frameId = -1, this.d = e1.d, this.initDynamicPropertyContainer(t1), this.p = PropertyFactory.getProp(t1, e1.p, 1, 0, this), this.s = PropertyFactory.getProp(t1, e1.s, 1, 0, this), this.r = PropertyFactory.getProp(t1, e1.r, 0, 0, this), this.dynamicProperties.length ? this.k = !0 : (this.k = !1, this.convertRectToPath());
                }
                return t1.prototype = {
                    convertRectToPath: function() {
                        var t1 = this.p.v[0], e1 = this.p.v[1], r1 = this.s.v[0] / 2, i1 = this.s.v[1] / 2, a1 = bmMin(r1, i1, this.r.v), s1 = a1 * (1 - roundCorner);
                        this.v._length = 0, 2 === this.d || 1 === this.d ? (this.v.setTripleAt(t1 + r1, e1 - i1 + a1, t1 + r1, e1 - i1 + a1, t1 + r1, e1 - i1 + s1, 0, !0), this.v.setTripleAt(t1 + r1, e1 + i1 - a1, t1 + r1, e1 + i1 - s1, t1 + r1, e1 + i1 - a1, 1, !0), 0 !== a1 ? (this.v.setTripleAt(t1 + r1 - a1, e1 + i1, t1 + r1 - a1, e1 + i1, t1 + r1 - s1, e1 + i1, 2, !0), this.v.setTripleAt(t1 - r1 + a1, e1 + i1, t1 - r1 + s1, e1 + i1, t1 - r1 + a1, e1 + i1, 3, !0), this.v.setTripleAt(t1 - r1, e1 + i1 - a1, t1 - r1, e1 + i1 - a1, t1 - r1, e1 + i1 - s1, 4, !0), this.v.setTripleAt(t1 - r1, e1 - i1 + a1, t1 - r1, e1 - i1 + s1, t1 - r1, e1 - i1 + a1, 5, !0), this.v.setTripleAt(t1 - r1 + a1, e1 - i1, t1 - r1 + a1, e1 - i1, t1 - r1 + s1, e1 - i1, 6, !0), this.v.setTripleAt(t1 + r1 - a1, e1 - i1, t1 + r1 - s1, e1 - i1, t1 + r1 - a1, e1 - i1, 7, !0)) : (this.v.setTripleAt(t1 - r1, e1 + i1, t1 - r1 + s1, e1 + i1, t1 - r1, e1 + i1, 2), this.v.setTripleAt(t1 - r1, e1 - i1, t1 - r1, e1 - i1 + s1, t1 - r1, e1 - i1, 3))) : (this.v.setTripleAt(t1 + r1, e1 - i1 + a1, t1 + r1, e1 - i1 + s1, t1 + r1, e1 - i1 + a1, 0, !0), 0 !== a1 ? (this.v.setTripleAt(t1 + r1 - a1, e1 - i1, t1 + r1 - a1, e1 - i1, t1 + r1 - s1, e1 - i1, 1, !0), this.v.setTripleAt(t1 - r1 + a1, e1 - i1, t1 - r1 + s1, e1 - i1, t1 - r1 + a1, e1 - i1, 2, !0), this.v.setTripleAt(t1 - r1, e1 - i1 + a1, t1 - r1, e1 - i1 + a1, t1 - r1, e1 - i1 + s1, 3, !0), this.v.setTripleAt(t1 - r1, e1 + i1 - a1, t1 - r1, e1 + i1 - s1, t1 - r1, e1 + i1 - a1, 4, !0), this.v.setTripleAt(t1 - r1 + a1, e1 + i1, t1 - r1 + a1, e1 + i1, t1 - r1 + s1, e1 + i1, 5, !0), this.v.setTripleAt(t1 + r1 - a1, e1 + i1, t1 + r1 - s1, e1 + i1, t1 + r1 - a1, e1 + i1, 6, !0), this.v.setTripleAt(t1 + r1, e1 + i1 - a1, t1 + r1, e1 + i1 - a1, t1 + r1, e1 + i1 - s1, 7, !0)) : (this.v.setTripleAt(t1 - r1, e1 - i1, t1 - r1 + s1, e1 - i1, t1 - r1, e1 - i1, 1, !0), this.v.setTripleAt(t1 - r1, e1 + i1, t1 - r1, e1 + i1 - s1, t1 - r1, e1 + i1, 2, !0), this.v.setTripleAt(t1 + r1, e1 + i1, t1 + r1 - s1, e1 + i1, t1 + r1, e1 + i1, 3, !0)));
                    },
                    getValue: function() {
                        this.elem.globalData.frameId !== this.frameId && (this.frameId = this.elem.globalData.frameId, this.iterateDynamicProperties(), this._mdf && this.convertRectToPath());
                    },
                    reset: r1
                }, extendPrototype([
                    DynamicPropertyContainer
                ], t1), t1;
            }();
            var f1 = {
                getShapeProp: function(t1, e1, r1) {
                    var i1;
                    return 3 === r1 || 4 === r1 ? i1 = (3 === r1 ? e1.pt : e1.ks).k.length ? new o1(t1, e1, r1) : new s1(t1, e1, r1) : 5 === r1 ? i1 = new p1(t1, e1) : 6 === r1 ? i1 = new h1(t1, e1) : 7 === r1 && (i1 = new l1(t1, e1)), i1.k && t1.addDynamicProperty(i1), i1;
                },
                getConstructorFunction: function() {
                    return s1;
                },
                getKeyframedConstructorFunction: function() {
                    return o1;
                }
            };
            return f1;
        }(), Matrix = function() {
            var t1 = Math.cos, e1 = Math.sin, r1 = Math.tan, i1 = Math.round;
            function a1() {
                return this.props[0] = 1, this.props[1] = 0, this.props[2] = 0, this.props[3] = 0, this.props[4] = 0, this.props[5] = 1, this.props[6] = 0, this.props[7] = 0, this.props[8] = 0, this.props[9] = 0, this.props[10] = 1, this.props[11] = 0, this.props[12] = 0, this.props[13] = 0, this.props[14] = 0, this.props[15] = 1, this;
            }
            function s1(r1) {
                if (0 === r1) return this;
                var i1 = t1(r1), a1 = e1(r1);
                return this._t(i1, -a1, 0, 0, a1, i1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
            }
            function n1(r1) {
                if (0 === r1) return this;
                var i1 = t1(r1), a1 = e1(r1);
                return this._t(1, 0, 0, 0, 0, i1, -a1, 0, 0, a1, i1, 0, 0, 0, 0, 1);
            }
            function o1(r1) {
                if (0 === r1) return this;
                var i1 = t1(r1), a1 = e1(r1);
                return this._t(i1, 0, a1, 0, 0, 1, 0, 0, -a1, 0, i1, 0, 0, 0, 0, 1);
            }
            function h1(r1) {
                if (0 === r1) return this;
                var i1 = t1(r1), a1 = e1(r1);
                return this._t(i1, -a1, 0, 0, a1, i1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
            }
            function l1(t1, e1) {
                return this._t(1, e1, t1, 1, 0, 0);
            }
            function p1(t1, e1) {
                return this.shear(r1(t1), r1(e1));
            }
            function f1(i1, a1) {
                var s1 = t1(a1), n1 = e1(a1);
                return this._t(s1, n1, 0, 0, -n1, s1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1)._t(1, 0, 0, 0, r1(i1), 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1)._t(s1, -n1, 0, 0, n1, s1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
            }
            function c1(t1, e1, r1) {
                return r1 || 0 === r1 || (r1 = 1), 1 === t1 && 1 === e1 && 1 === r1 ? this : this._t(t1, 0, 0, 0, 0, e1, 0, 0, 0, 0, r1, 0, 0, 0, 0, 1);
            }
            function m1(t1, e1, r1, i1, a1, s1, n1, o1, h1, l1, p1, f1, c1, m1, d1, u1) {
                return this.props[0] = t1, this.props[1] = e1, this.props[2] = r1, this.props[3] = i1, this.props[4] = a1, this.props[5] = s1, this.props[6] = n1, this.props[7] = o1, this.props[8] = h1, this.props[9] = l1, this.props[10] = p1, this.props[11] = f1, this.props[12] = c1, this.props[13] = m1, this.props[14] = d1, this.props[15] = u1, this;
            }
            function d1(t1, e1, r1) {
                return r1 = r1 || 0, 0 !== t1 || 0 !== e1 || 0 !== r1 ? this._t(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, t1, e1, r1, 1) : this;
            }
            function u1(t1, e1, r1, i1, a1, s1, n1, o1, h1, l1, p1, f1, c1, m1, d1, u1) {
                var y1 = this.props;
                if (1 === t1 && 0 === e1 && 0 === r1 && 0 === i1 && 0 === a1 && 1 === s1 && 0 === n1 && 0 === o1 && 0 === h1 && 0 === l1 && 1 === p1 && 0 === f1) return y1[12] = y1[12] * t1 + y1[15] * c1, y1[13] = y1[13] * s1 + y1[15] * m1, y1[14] = y1[14] * p1 + y1[15] * d1, y1[15] *= u1, this._identityCalculated = !1, this;
                var g1 = y1[0], v1 = y1[1], b1 = y1[2], x1 = y1[3], P1 = y1[4], E1 = y1[5], S1 = y1[6], C1 = y1[7], _1 = y1[8], A1 = y1[9], k1 = y1[10], w1 = y1[11], T1 = y1[12], M1 = y1[13], D1 = y1[14], F1 = y1[15];
                return y1[0] = g1 * t1 + v1 * a1 + b1 * h1 + x1 * c1, y1[1] = g1 * e1 + v1 * s1 + b1 * l1 + x1 * m1, y1[2] = g1 * r1 + v1 * n1 + b1 * p1 + x1 * d1, y1[3] = g1 * i1 + v1 * o1 + b1 * f1 + x1 * u1, y1[4] = P1 * t1 + E1 * a1 + S1 * h1 + C1 * c1, y1[5] = P1 * e1 + E1 * s1 + S1 * l1 + C1 * m1, y1[6] = P1 * r1 + E1 * n1 + S1 * p1 + C1 * d1, y1[7] = P1 * i1 + E1 * o1 + S1 * f1 + C1 * u1, y1[8] = _1 * t1 + A1 * a1 + k1 * h1 + w1 * c1, y1[9] = _1 * e1 + A1 * s1 + k1 * l1 + w1 * m1, y1[10] = _1 * r1 + A1 * n1 + k1 * p1 + w1 * d1, y1[11] = _1 * i1 + A1 * o1 + k1 * f1 + w1 * u1, y1[12] = T1 * t1 + M1 * a1 + D1 * h1 + F1 * c1, y1[13] = T1 * e1 + M1 * s1 + D1 * l1 + F1 * m1, y1[14] = T1 * r1 + M1 * n1 + D1 * p1 + F1 * d1, y1[15] = T1 * i1 + M1 * o1 + D1 * f1 + F1 * u1, this._identityCalculated = !1, this;
            }
            function y1() {
                return this._identityCalculated || (this._identity = !(1 !== this.props[0] || 0 !== this.props[1] || 0 !== this.props[2] || 0 !== this.props[3] || 0 !== this.props[4] || 1 !== this.props[5] || 0 !== this.props[6] || 0 !== this.props[7] || 0 !== this.props[8] || 0 !== this.props[9] || 1 !== this.props[10] || 0 !== this.props[11] || 0 !== this.props[12] || 0 !== this.props[13] || 0 !== this.props[14] || 1 !== this.props[15]), this._identityCalculated = !0), this._identity;
            }
            function g1(t1) {
                for(var e1 = 0; e1 < 16;){
                    if (t1.props[e1] !== this.props[e1]) return !1;
                    e1 += 1;
                }
                return !0;
            }
            function v1(t1) {
                var e1;
                for(e1 = 0; e1 < 16; e1 += 1)t1.props[e1] = this.props[e1];
                return t1;
            }
            function b1(t1) {
                var e1;
                for(e1 = 0; e1 < 16; e1 += 1)this.props[e1] = t1[e1];
            }
            function x1(t1, e1, r1) {
                return {
                    x: t1 * this.props[0] + e1 * this.props[4] + r1 * this.props[8] + this.props[12],
                    y: t1 * this.props[1] + e1 * this.props[5] + r1 * this.props[9] + this.props[13],
                    z: t1 * this.props[2] + e1 * this.props[6] + r1 * this.props[10] + this.props[14]
                };
            }
            function P1(t1, e1, r1) {
                return t1 * this.props[0] + e1 * this.props[4] + r1 * this.props[8] + this.props[12];
            }
            function E1(t1, e1, r1) {
                return t1 * this.props[1] + e1 * this.props[5] + r1 * this.props[9] + this.props[13];
            }
            function S1(t1, e1, r1) {
                return t1 * this.props[2] + e1 * this.props[6] + r1 * this.props[10] + this.props[14];
            }
            function C1() {
                var t1 = this.props[0] * this.props[5] - this.props[1] * this.props[4], e1 = this.props[5] / t1, r1 = -this.props[1] / t1, i1 = -this.props[4] / t1, a1 = this.props[0] / t1, s1 = (this.props[4] * this.props[13] - this.props[5] * this.props[12]) / t1, n1 = -(this.props[0] * this.props[13] - this.props[1] * this.props[12]) / t1, o1 = new Matrix;
                return o1.props[0] = e1, o1.props[1] = r1, o1.props[4] = i1, o1.props[5] = a1, o1.props[12] = s1, o1.props[13] = n1, o1;
            }
            function _1(t1) {
                return this.getInverseMatrix().applyToPointArray(t1[0], t1[1], t1[2] || 0);
            }
            function A1(t1) {
                var e1, r1 = t1.length, i1 = [];
                for(e1 = 0; e1 < r1; e1 += 1)i1[e1] = _1(t1[e1]);
                return i1;
            }
            function k1(t1, e1, r1) {
                var i1 = createTypedArray("float32", 6);
                if (this.isIdentity()) i1[0] = t1[0], i1[1] = t1[1], i1[2] = e1[0], i1[3] = e1[1], i1[4] = r1[0], i1[5] = r1[1];
                else {
                    var a1 = this.props[0], s1 = this.props[1], n1 = this.props[4], o1 = this.props[5], h1 = this.props[12], l1 = this.props[13];
                    i1[0] = t1[0] * a1 + t1[1] * n1 + h1, i1[1] = t1[0] * s1 + t1[1] * o1 + l1, i1[2] = e1[0] * a1 + e1[1] * n1 + h1, i1[3] = e1[0] * s1 + e1[1] * o1 + l1, i1[4] = r1[0] * a1 + r1[1] * n1 + h1, i1[5] = r1[0] * s1 + r1[1] * o1 + l1;
                }
                return i1;
            }
            function w1(t1, e1, r1) {
                return this.isIdentity() ? [
                    t1,
                    e1,
                    r1
                ] : [
                    t1 * this.props[0] + e1 * this.props[4] + r1 * this.props[8] + this.props[12],
                    t1 * this.props[1] + e1 * this.props[5] + r1 * this.props[9] + this.props[13],
                    t1 * this.props[2] + e1 * this.props[6] + r1 * this.props[10] + this.props[14]
                ];
            }
            function T1(t1, e1) {
                if (this.isIdentity()) return t1 + "," + e1;
                var r1 = this.props;
                return Math.round(100 * (t1 * r1[0] + e1 * r1[4] + r1[12])) / 100 + "," + Math.round(100 * (t1 * r1[1] + e1 * r1[5] + r1[13])) / 100;
            }
            function M1() {
                for(var t1 = 0, e1 = this.props, r1 = "matrix3d("; t1 < 16;)r1 += i1(1e4 * e1[t1]) / 1e4, r1 += 15 === t1 ? ")" : ",", t1 += 1;
                return r1;
            }
            function D1(t1) {
                return t1 < 1e-6 && t1 > 0 || t1 > -0.000001 && t1 < 0 ? i1(1e4 * t1) / 1e4 : t1;
            }
            function F1() {
                var t1 = this.props;
                return "matrix(" + D1(t1[0]) + "," + D1(t1[1]) + "," + D1(t1[4]) + "," + D1(t1[5]) + "," + D1(t1[12]) + "," + D1(t1[13]) + ")";
            }
            return function() {
                this.reset = a1, this.rotate = s1, this.rotateX = n1, this.rotateY = o1, this.rotateZ = h1, this.skew = p1, this.skewFromAxis = f1, this.shear = l1, this.scale = c1, this.setTransform = m1, this.translate = d1, this.transform = u1, this.applyToPoint = x1, this.applyToX = P1, this.applyToY = E1, this.applyToZ = S1, this.applyToPointArray = w1, this.applyToTriplePoints = k1, this.applyToPointStringified = T1, this.toCSS = M1, this.to2dCSS = F1, this.clone = v1, this.cloneFromProps = b1, this.equals = g1, this.inversePoints = A1, this.inversePoint = _1, this.getInverseMatrix = C1, this._t = this.transform, this.isIdentity = y1, this._identity = !0, this._identityCalculated = !1, this.props = createTypedArray("float32", 16), this.reset();
            };
        }();
        function _typeof$3(t1) {
            return (_typeof$3 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t1) {
                return typeof t1;
            } : function(t1) {
                return t1 && "function" == typeof Symbol && t1.constructor === Symbol && t1 !== Symbol.prototype ? "symbol" : typeof t1;
            })(t1);
        }
        var lottie = {}, standalone = "__[STANDALONE]__", animationData = "__[ANIMATIONDATA]__", renderer = "";
        function setLocation(t1) {
            setLocationHref(t1);
        }
        function searchAnimations() {
            !0 === standalone ? animationManager.searchAnimations(animationData, standalone, renderer) : animationManager.searchAnimations();
        }
        function setSubframeRendering(t1) {
            setSubframeEnabled(t1);
        }
        function setPrefix(t1) {
            setIdPrefix(t1);
        }
        function loadAnimation(t1) {
            return !0 === standalone && (t1.animationData = JSON.parse(animationData)), animationManager.loadAnimation(t1);
        }
        function setQuality(t1) {
            if ("string" == typeof t1) switch(t1){
                case "high":
                    setDefaultCurveSegments(200);
                    break;
                default:
                case "medium":
                    setDefaultCurveSegments(50);
                    break;
                case "low":
                    setDefaultCurveSegments(10);
            }
            else !isNaN(t1) && t1 > 1 && setDefaultCurveSegments(t1);
            getDefaultCurveSegments() >= 50 ? roundValues(!1) : roundValues(!0);
        }
        function inBrowser() {
            return "undefined" != typeof navigator;
        }
        function installPlugin(t1, e1) {
            "expressions" === t1 && setExpressionsPlugin(e1);
        }
        function getFactory(t1) {
            switch(t1){
                case "propertyFactory":
                    return PropertyFactory;
                case "shapePropertyFactory":
                    return ShapePropertyFactory;
                case "matrix":
                    return Matrix;
                default:
                    return null;
            }
        }
        function checkReady() {
            "complete" === document.readyState && (clearInterval(readyStateCheckInterval), searchAnimations());
        }
        function getQueryVariable(t1) {
            for(var e1 = queryString.split("&"), r1 = 0; r1 < e1.length; r1 += 1){
                var i1 = e1[r1].split("=");
                if (decodeURIComponent(i1[0]) == t1) return decodeURIComponent(i1[1]);
            }
            return null;
        }
        lottie.play = animationManager.play, lottie.pause = animationManager.pause, lottie.setLocationHref = setLocation, lottie.togglePause = animationManager.togglePause, lottie.setSpeed = animationManager.setSpeed, lottie.setDirection = animationManager.setDirection, lottie.stop = animationManager.stop, lottie.searchAnimations = searchAnimations, lottie.registerAnimation = animationManager.registerAnimation, lottie.loadAnimation = loadAnimation, lottie.setSubframeRendering = setSubframeRendering, lottie.resize = animationManager.resize, lottie.goToAndStop = animationManager.goToAndStop, lottie.destroy = animationManager.destroy, lottie.setQuality = setQuality, lottie.inBrowser = inBrowser, lottie.installPlugin = installPlugin, lottie.freeze = animationManager.freeze, lottie.unfreeze = animationManager.unfreeze, lottie.setVolume = animationManager.setVolume, lottie.mute = animationManager.mute, lottie.unmute = animationManager.unmute, lottie.getRegisteredAnimations = animationManager.getRegisteredAnimations, lottie.useWebWorker = setWebWorker, lottie.setIDPrefix = setPrefix, lottie.__getFactory = getFactory, lottie.version = "5.10.2";
        var queryString = "";
        if (standalone) {
            var scripts = document.getElementsByTagName("script"), index = scripts.length - 1, myScript = scripts[index] || {
                src: ""
            };
            queryString = myScript.src ? myScript.src.replace(/^[^\?]+\??/, "") : "", renderer = getQueryVariable("renderer");
        }
        var readyStateCheckInterval = setInterval(checkReady, 100);
        try {
            "object" !== _typeof$3(exports) && (window.bodymovin = lottie);
        } catch (t) {}
        var ShapeModifiers = function() {
            var t1 = {}, e1 = {};
            return t1.registerModifier = function(t1, r1) {
                e1[t1] || (e1[t1] = r1);
            }, t1.getModifier = function(t1, r1, i1) {
                return new e1[t1](r1, i1);
            }, t1;
        }();
        function ShapeModifier() {}
        function TrimModifier() {}
        function PuckerAndBloatModifier() {}
        ShapeModifier.prototype.initModifierProperties = function() {}, ShapeModifier.prototype.addShapeToModifier = function() {}, ShapeModifier.prototype.addShape = function(t1) {
            if (!this.closed) {
                t1.sh.container.addDynamicProperty(t1.sh);
                var e1 = {
                    shape: t1.sh,
                    data: t1,
                    localShapeCollection: shapeCollectionPool.newShapeCollection()
                };
                this.shapes.push(e1), this.addShapeToModifier(e1), this._isAnimated && t1.setAsAnimated();
            }
        }, ShapeModifier.prototype.init = function(t1, e1) {
            this.shapes = [], this.elem = t1, this.initDynamicPropertyContainer(t1), this.initModifierProperties(t1, e1), this.frameId = initialDefaultFrame, this.closed = !1, this.k = !1, this.dynamicProperties.length ? this.k = !0 : this.getValue(!0);
        }, ShapeModifier.prototype.processKeys = function() {
            this.elem.globalData.frameId !== this.frameId && (this.frameId = this.elem.globalData.frameId, this.iterateDynamicProperties());
        }, extendPrototype([
            DynamicPropertyContainer
        ], ShapeModifier), extendPrototype([
            ShapeModifier
        ], TrimModifier), TrimModifier.prototype.initModifierProperties = function(t1, e1) {
            this.s = PropertyFactory.getProp(t1, e1.s, 0, .01, this), this.e = PropertyFactory.getProp(t1, e1.e, 0, .01, this), this.o = PropertyFactory.getProp(t1, e1.o, 0, 0, this), this.sValue = 0, this.eValue = 0, this.getValue = this.processKeys, this.m = e1.m, this._isAnimated = !!this.s.effectsSequence.length || !!this.e.effectsSequence.length || !!this.o.effectsSequence.length;
        }, TrimModifier.prototype.addShapeToModifier = function(t1) {
            t1.pathsData = [];
        }, TrimModifier.prototype.calculateShapeEdges = function(t1, e1, r1, i1, a1) {
            var s1 = [];
            e1 <= 1 ? s1.push({
                s: t1,
                e: e1
            }) : t1 >= 1 ? s1.push({
                s: t1 - 1,
                e: e1 - 1
            }) : (s1.push({
                s: t1,
                e: 1
            }), s1.push({
                s: 0,
                e: e1 - 1
            }));
            var n1, o1, h1 = [], l1 = s1.length;
            for(n1 = 0; n1 < l1; n1 += 1){
                var p1, f1;
                if (!((o1 = s1[n1]).e * a1 < i1 || o1.s * a1 > i1 + r1)) p1 = o1.s * a1 <= i1 ? 0 : (o1.s * a1 - i1) / r1, f1 = o1.e * a1 >= i1 + r1 ? 1 : (o1.e * a1 - i1) / r1, h1.push([
                    p1,
                    f1
                ]);
            }
            return h1.length || h1.push([
                0,
                0
            ]), h1;
        }, TrimModifier.prototype.releasePathsData = function(t1) {
            var e1, r1 = t1.length;
            for(e1 = 0; e1 < r1; e1 += 1)segmentsLengthPool.release(t1[e1]);
            return t1.length = 0, t1;
        }, TrimModifier.prototype.processShapes = function(t1) {
            var e1, r1, i1, a1;
            if (this._mdf || t1) {
                var s1 = this.o.v % 360 / 360;
                if (s1 < 0 && (s1 += 1), (e1 = this.s.v > 1 ? 1 + s1 : this.s.v < 0 ? 0 + s1 : this.s.v + s1) > (r1 = this.e.v > 1 ? 1 + s1 : this.e.v < 0 ? 0 + s1 : this.e.v + s1)) {
                    var n1 = e1;
                    e1 = r1, r1 = n1;
                }
                e1 = 1e-4 * Math.round(1e4 * e1), r1 = 1e-4 * Math.round(1e4 * r1), this.sValue = e1, this.eValue = r1;
            } else e1 = this.sValue, r1 = this.eValue;
            var o1, h1, l1, p1, f1, c1 = this.shapes.length, m1 = 0;
            if (r1 === e1) for(a1 = 0; a1 < c1; a1 += 1)this.shapes[a1].localShapeCollection.releaseShapes(), this.shapes[a1].shape._mdf = !0, this.shapes[a1].shape.paths = this.shapes[a1].localShapeCollection, this._mdf && (this.shapes[a1].pathsData.length = 0);
            else if (1 === r1 && 0 === e1 || 0 === r1 && 1 === e1) {
                if (this._mdf) for(a1 = 0; a1 < c1; a1 += 1)this.shapes[a1].pathsData.length = 0, this.shapes[a1].shape._mdf = !0;
            } else {
                var d1, u1, y1 = [];
                for(a1 = 0; a1 < c1; a1 += 1)if ((d1 = this.shapes[a1]).shape._mdf || this._mdf || t1 || 2 === this.m) {
                    if (h1 = (i1 = d1.shape.paths)._length, f1 = 0, !d1.shape._mdf && d1.pathsData.length) f1 = d1.totalShapeLength;
                    else {
                        for(l1 = this.releasePathsData(d1.pathsData), o1 = 0; o1 < h1; o1 += 1)p1 = bez.getSegmentsLength(i1.shapes[o1]), l1.push(p1), f1 += p1.totalLength;
                        d1.totalShapeLength = f1, d1.pathsData = l1;
                    }
                    m1 += f1, d1.shape._mdf = !0;
                } else d1.shape.paths = d1.localShapeCollection;
                var g1, v1 = e1, b1 = r1, x1 = 0;
                for(a1 = c1 - 1; a1 >= 0; a1 -= 1)if ((d1 = this.shapes[a1]).shape._mdf) {
                    for((u1 = d1.localShapeCollection).releaseShapes(), 2 === this.m && c1 > 1 ? (g1 = this.calculateShapeEdges(e1, r1, d1.totalShapeLength, x1, m1), x1 += d1.totalShapeLength) : g1 = [
                        [
                            v1,
                            b1
                        ]
                    ], h1 = g1.length, o1 = 0; o1 < h1; o1 += 1){
                        v1 = g1[o1][0], b1 = g1[o1][1], y1.length = 0, b1 <= 1 ? y1.push({
                            s: d1.totalShapeLength * v1,
                            e: d1.totalShapeLength * b1
                        }) : v1 >= 1 ? y1.push({
                            s: d1.totalShapeLength * (v1 - 1),
                            e: d1.totalShapeLength * (b1 - 1)
                        }) : (y1.push({
                            s: d1.totalShapeLength * v1,
                            e: d1.totalShapeLength
                        }), y1.push({
                            s: 0,
                            e: d1.totalShapeLength * (b1 - 1)
                        }));
                        var P1 = this.addShapes(d1, y1[0]);
                        if (y1[0].s !== y1[0].e) {
                            if (y1.length > 1) {
                                if (d1.shape.paths.shapes[d1.shape.paths._length - 1].c) {
                                    var E1 = P1.pop();
                                    this.addPaths(P1, u1), P1 = this.addShapes(d1, y1[1], E1);
                                } else this.addPaths(P1, u1), P1 = this.addShapes(d1, y1[1]);
                            }
                            this.addPaths(P1, u1);
                        }
                    }
                    d1.shape.paths = u1;
                }
            }
        }, TrimModifier.prototype.addPaths = function(t1, e1) {
            var r1, i1 = t1.length;
            for(r1 = 0; r1 < i1; r1 += 1)e1.addShape(t1[r1]);
        }, TrimModifier.prototype.addSegment = function(t1, e1, r1, i1, a1, s1, n1) {
            a1.setXYAt(e1[0], e1[1], "o", s1), a1.setXYAt(r1[0], r1[1], "i", s1 + 1), n1 && a1.setXYAt(t1[0], t1[1], "v", s1), a1.setXYAt(i1[0], i1[1], "v", s1 + 1);
        }, TrimModifier.prototype.addSegmentFromArray = function(t1, e1, r1, i1) {
            e1.setXYAt(t1[1], t1[5], "o", r1), e1.setXYAt(t1[2], t1[6], "i", r1 + 1), i1 && e1.setXYAt(t1[0], t1[4], "v", r1), e1.setXYAt(t1[3], t1[7], "v", r1 + 1);
        }, TrimModifier.prototype.addShapes = function(t1, e1, r1) {
            var i1, a1, s1, n1, o1, h1, l1, p1, f1 = t1.pathsData, c1 = t1.shape.paths.shapes, m1 = t1.shape.paths._length, d1 = 0, u1 = [], y1 = !0;
            for(r1 ? (o1 = r1._length, p1 = r1._length) : (r1 = shapePool.newElement(), o1 = 0, p1 = 0), u1.push(r1), i1 = 0; i1 < m1; i1 += 1){
                for(h1 = f1[i1].lengths, r1.c = c1[i1].c, s1 = c1[i1].c ? h1.length : h1.length + 1, a1 = 1; a1 < s1; a1 += 1)if (d1 + (n1 = h1[a1 - 1]).addedLength < e1.s) d1 += n1.addedLength, r1.c = !1;
                else {
                    if (d1 > e1.e) {
                        r1.c = !1;
                        break;
                    }
                    e1.s <= d1 && e1.e >= d1 + n1.addedLength ? (this.addSegment(c1[i1].v[a1 - 1], c1[i1].o[a1 - 1], c1[i1].i[a1], c1[i1].v[a1], r1, o1, y1), y1 = !1) : (l1 = bez.getNewSegment(c1[i1].v[a1 - 1], c1[i1].v[a1], c1[i1].o[a1 - 1], c1[i1].i[a1], (e1.s - d1) / n1.addedLength, (e1.e - d1) / n1.addedLength, h1[a1 - 1]), this.addSegmentFromArray(l1, r1, o1, y1), y1 = !1, r1.c = !1), d1 += n1.addedLength, o1 += 1;
                }
                if (c1[i1].c && h1.length) {
                    if (n1 = h1[a1 - 1], d1 <= e1.e) {
                        var g1 = h1[a1 - 1].addedLength;
                        e1.s <= d1 && e1.e >= d1 + g1 ? (this.addSegment(c1[i1].v[a1 - 1], c1[i1].o[a1 - 1], c1[i1].i[0], c1[i1].v[0], r1, o1, y1), y1 = !1) : (l1 = bez.getNewSegment(c1[i1].v[a1 - 1], c1[i1].v[0], c1[i1].o[a1 - 1], c1[i1].i[0], (e1.s - d1) / g1, (e1.e - d1) / g1, h1[a1 - 1]), this.addSegmentFromArray(l1, r1, o1, y1), y1 = !1, r1.c = !1);
                    } else r1.c = !1;
                    d1 += n1.addedLength, o1 += 1;
                }
                if (r1._length && (r1.setXYAt(r1.v[p1][0], r1.v[p1][1], "i", p1), r1.setXYAt(r1.v[r1._length - 1][0], r1.v[r1._length - 1][1], "o", r1._length - 1)), d1 > e1.e) break;
                i1 < m1 - 1 && (r1 = shapePool.newElement(), y1 = !0, u1.push(r1), o1 = 0);
            }
            return u1;
        }, extendPrototype([
            ShapeModifier
        ], PuckerAndBloatModifier), PuckerAndBloatModifier.prototype.initModifierProperties = function(t1, e1) {
            this.getValue = this.processKeys, this.amount = PropertyFactory.getProp(t1, e1.a, 0, null, this), this._isAnimated = !!this.amount.effectsSequence.length;
        }, PuckerAndBloatModifier.prototype.processPath = function(t1, e1) {
            var r1 = e1 / 100, i1 = [
                0,
                0
            ], a1 = t1._length, s1 = 0;
            for(s1 = 0; s1 < a1; s1 += 1)i1[0] += t1.v[s1][0], i1[1] += t1.v[s1][1];
            i1[0] /= a1, i1[1] /= a1;
            var n1, o1, h1, l1, p1, f1, c1 = shapePool.newElement();
            for(c1.c = t1.c, s1 = 0; s1 < a1; s1 += 1)n1 = t1.v[s1][0] + (i1[0] - t1.v[s1][0]) * r1, o1 = t1.v[s1][1] + (i1[1] - t1.v[s1][1]) * r1, h1 = t1.o[s1][0] + (i1[0] - t1.o[s1][0]) * -r1, l1 = t1.o[s1][1] + (i1[1] - t1.o[s1][1]) * -r1, p1 = t1.i[s1][0] + (i1[0] - t1.i[s1][0]) * -r1, f1 = t1.i[s1][1] + (i1[1] - t1.i[s1][1]) * -r1, c1.setTripleAt(n1, o1, h1, l1, p1, f1, s1);
            return c1;
        }, PuckerAndBloatModifier.prototype.processShapes = function(t1) {
            var e1, r1, i1, a1, s1, n1, o1 = this.shapes.length, h1 = this.amount.v;
            if (0 !== h1) for(r1 = 0; r1 < o1; r1 += 1){
                if (n1 = (s1 = this.shapes[r1]).localShapeCollection, s1.shape._mdf || this._mdf || t1) for(n1.releaseShapes(), s1.shape._mdf = !0, e1 = s1.shape.paths.shapes, a1 = s1.shape.paths._length, i1 = 0; i1 < a1; i1 += 1)n1.addShape(this.processPath(e1[i1], h1));
                s1.shape.paths = s1.localShapeCollection;
            }
            this.dynamicProperties.length || (this._mdf = !1);
        };
        var TransformPropertyFactory = function() {
            var t1 = [
                0,
                0
            ];
            function e1(t1, e1, r1) {
                if (this.elem = t1, this.frameId = -1, this.propType = "transform", this.data = e1, this.v = new Matrix, this.pre = new Matrix, this.appliedTransformations = 0, this.initDynamicPropertyContainer(r1 || t1), e1.p && e1.p.s ? (this.px = PropertyFactory.getProp(t1, e1.p.x, 0, 0, this), this.py = PropertyFactory.getProp(t1, e1.p.y, 0, 0, this), e1.p.z && (this.pz = PropertyFactory.getProp(t1, e1.p.z, 0, 0, this))) : this.p = PropertyFactory.getProp(t1, e1.p || {
                    k: [
                        0,
                        0,
                        0
                    ]
                }, 1, 0, this), e1.rx) {
                    if (this.rx = PropertyFactory.getProp(t1, e1.rx, 0, degToRads, this), this.ry = PropertyFactory.getProp(t1, e1.ry, 0, degToRads, this), this.rz = PropertyFactory.getProp(t1, e1.rz, 0, degToRads, this), e1.or.k[0].ti) {
                        var i1, a1 = e1.or.k.length;
                        for(i1 = 0; i1 < a1; i1 += 1)e1.or.k[i1].to = null, e1.or.k[i1].ti = null;
                    }
                    this.or = PropertyFactory.getProp(t1, e1.or, 1, degToRads, this), this.or.sh = !0;
                } else this.r = PropertyFactory.getProp(t1, e1.r || {
                    k: 0
                }, 0, degToRads, this);
                e1.sk && (this.sk = PropertyFactory.getProp(t1, e1.sk, 0, degToRads, this), this.sa = PropertyFactory.getProp(t1, e1.sa, 0, degToRads, this)), this.a = PropertyFactory.getProp(t1, e1.a || {
                    k: [
                        0,
                        0,
                        0
                    ]
                }, 1, 0, this), this.s = PropertyFactory.getProp(t1, e1.s || {
                    k: [
                        100,
                        100,
                        100
                    ]
                }, 1, .01, this), e1.o ? this.o = PropertyFactory.getProp(t1, e1.o, 0, .01, t1) : this.o = {
                    _mdf: !1,
                    v: 1
                }, this._isDirty = !0, this.dynamicProperties.length || this.getValue(!0);
            }
            return e1.prototype = {
                applyToMatrix: function(t1) {
                    var e1 = this._mdf;
                    this.iterateDynamicProperties(), this._mdf = this._mdf || e1, this.a && t1.translate(-this.a.v[0], -this.a.v[1], this.a.v[2]), this.s && t1.scale(this.s.v[0], this.s.v[1], this.s.v[2]), this.sk && t1.skewFromAxis(-this.sk.v, this.sa.v), this.r ? t1.rotate(-this.r.v) : t1.rotateZ(-this.rz.v).rotateY(this.ry.v).rotateX(this.rx.v).rotateZ(-this.or.v[2]).rotateY(this.or.v[1]).rotateX(this.or.v[0]), this.data.p.s ? this.data.p.z ? t1.translate(this.px.v, this.py.v, -this.pz.v) : t1.translate(this.px.v, this.py.v, 0) : t1.translate(this.p.v[0], this.p.v[1], -this.p.v[2]);
                },
                getValue: function(e1) {
                    if (this.elem.globalData.frameId !== this.frameId) {
                        if (this._isDirty && (this.precalculateMatrix(), this._isDirty = !1), this.iterateDynamicProperties(), this._mdf || e1) {
                            var r1;
                            if (this.v.cloneFromProps(this.pre.props), this.appliedTransformations < 1 && this.v.translate(-this.a.v[0], -this.a.v[1], this.a.v[2]), this.appliedTransformations < 2 && this.v.scale(this.s.v[0], this.s.v[1], this.s.v[2]), this.sk && this.appliedTransformations < 3 && this.v.skewFromAxis(-this.sk.v, this.sa.v), this.r && this.appliedTransformations < 4 ? this.v.rotate(-this.r.v) : !this.r && this.appliedTransformations < 4 && this.v.rotateZ(-this.rz.v).rotateY(this.ry.v).rotateX(this.rx.v).rotateZ(-this.or.v[2]).rotateY(this.or.v[1]).rotateX(this.or.v[0]), this.autoOriented) {
                                var i1, a1;
                                if (r1 = this.elem.globalData.frameRate, this.p && this.p.keyframes && this.p.getValueAtTime) this.p._caching.lastFrame + this.p.offsetTime <= this.p.keyframes[0].t ? (i1 = this.p.getValueAtTime((this.p.keyframes[0].t + .01) / r1, 0), a1 = this.p.getValueAtTime(this.p.keyframes[0].t / r1, 0)) : this.p._caching.lastFrame + this.p.offsetTime >= this.p.keyframes[this.p.keyframes.length - 1].t ? (i1 = this.p.getValueAtTime(this.p.keyframes[this.p.keyframes.length - 1].t / r1, 0), a1 = this.p.getValueAtTime((this.p.keyframes[this.p.keyframes.length - 1].t - .05) / r1, 0)) : (i1 = this.p.pv, a1 = this.p.getValueAtTime((this.p._caching.lastFrame + this.p.offsetTime - .01) / r1, this.p.offsetTime));
                                else if (this.px && this.px.keyframes && this.py.keyframes && this.px.getValueAtTime && this.py.getValueAtTime) {
                                    i1 = [], a1 = [];
                                    var s1 = this.px, n1 = this.py;
                                    s1._caching.lastFrame + s1.offsetTime <= s1.keyframes[0].t ? (i1[0] = s1.getValueAtTime((s1.keyframes[0].t + .01) / r1, 0), i1[1] = n1.getValueAtTime((n1.keyframes[0].t + .01) / r1, 0), a1[0] = s1.getValueAtTime(s1.keyframes[0].t / r1, 0), a1[1] = n1.getValueAtTime(n1.keyframes[0].t / r1, 0)) : s1._caching.lastFrame + s1.offsetTime >= s1.keyframes[s1.keyframes.length - 1].t ? (i1[0] = s1.getValueAtTime(s1.keyframes[s1.keyframes.length - 1].t / r1, 0), i1[1] = n1.getValueAtTime(n1.keyframes[n1.keyframes.length - 1].t / r1, 0), a1[0] = s1.getValueAtTime((s1.keyframes[s1.keyframes.length - 1].t - .01) / r1, 0), a1[1] = n1.getValueAtTime((n1.keyframes[n1.keyframes.length - 1].t - .01) / r1, 0)) : (i1 = [
                                        s1.pv,
                                        n1.pv
                                    ], a1[0] = s1.getValueAtTime((s1._caching.lastFrame + s1.offsetTime - .01) / r1, s1.offsetTime), a1[1] = n1.getValueAtTime((n1._caching.lastFrame + n1.offsetTime - .01) / r1, n1.offsetTime));
                                } else i1 = a1 = t1;
                                this.v.rotate(-Math.atan2(i1[1] - a1[1], i1[0] - a1[0]));
                            }
                            this.data.p && this.data.p.s ? this.data.p.z ? this.v.translate(this.px.v, this.py.v, -this.pz.v) : this.v.translate(this.px.v, this.py.v, 0) : this.v.translate(this.p.v[0], this.p.v[1], -this.p.v[2]);
                        }
                        this.frameId = this.elem.globalData.frameId;
                    }
                },
                precalculateMatrix: function() {
                    if (!this.a.k && (this.pre.translate(-this.a.v[0], -this.a.v[1], this.a.v[2]), this.appliedTransformations = 1, !this.s.effectsSequence.length)) {
                        if (this.pre.scale(this.s.v[0], this.s.v[1], this.s.v[2]), this.appliedTransformations = 2, this.sk) {
                            if (this.sk.effectsSequence.length || this.sa.effectsSequence.length) return;
                            this.pre.skewFromAxis(-this.sk.v, this.sa.v), this.appliedTransformations = 3;
                        }
                        this.r ? this.r.effectsSequence.length || (this.pre.rotate(-this.r.v), this.appliedTransformations = 4) : this.rz.effectsSequence.length || this.ry.effectsSequence.length || this.rx.effectsSequence.length || this.or.effectsSequence.length || (this.pre.rotateZ(-this.rz.v).rotateY(this.ry.v).rotateX(this.rx.v).rotateZ(-this.or.v[2]).rotateY(this.or.v[1]).rotateX(this.or.v[0]), this.appliedTransformations = 4);
                    }
                },
                autoOrient: function() {}
            }, extendPrototype([
                DynamicPropertyContainer
            ], e1), e1.prototype.addDynamicProperty = function(t1) {
                this._addDynamicProperty(t1), this.elem.addDynamicProperty(t1), this._isDirty = !0;
            }, e1.prototype._addDynamicProperty = DynamicPropertyContainer.prototype.addDynamicProperty, {
                getTransformProperty: function(t1, r1, i1) {
                    return new e1(t1, r1, i1);
                }
            };
        }();
        function RepeaterModifier() {}
        function RoundCornersModifier() {}
        function floatEqual(t1, e1) {
            return 1e5 * Math.abs(t1 - e1) <= Math.min(Math.abs(t1), Math.abs(e1));
        }
        function floatZero(t1) {
            return Math.abs(t1) <= 1e-5;
        }
        function lerp(t1, e1, r1) {
            return t1 * (1 - r1) + e1 * r1;
        }
        function lerpPoint(t1, e1, r1) {
            return [
                lerp(t1[0], e1[0], r1),
                lerp(t1[1], e1[1], r1)
            ];
        }
        function quadRoots(t1, e1, r1) {
            if (0 === t1) return [];
            var i1 = e1 * e1 - 4 * t1 * r1;
            if (i1 < 0) return [];
            var a1 = -e1 / (2 * t1);
            if (0 === i1) return [
                a1
            ];
            var s1 = Math.sqrt(i1) / (2 * t1);
            return [
                a1 - s1,
                a1 + s1
            ];
        }
        function polynomialCoefficients(t1, e1, r1, i1) {
            return [
                3 * e1 - t1 - 3 * r1 + i1,
                3 * t1 - 6 * e1 + 3 * r1,
                -3 * t1 + 3 * e1,
                t1
            ];
        }
        function singlePoint(t1) {
            return new PolynomialBezier(t1, t1, t1, t1, !1);
        }
        function PolynomialBezier(t1, e1, r1, i1, a1) {
            a1 && pointEqual(t1, e1) && (e1 = lerpPoint(t1, i1, 1 / 3)), a1 && pointEqual(r1, i1) && (r1 = lerpPoint(t1, i1, 2 / 3));
            var s1 = polynomialCoefficients(t1[0], e1[0], r1[0], i1[0]), n1 = polynomialCoefficients(t1[1], e1[1], r1[1], i1[1]);
            this.a = [
                s1[0],
                n1[0]
            ], this.b = [
                s1[1],
                n1[1]
            ], this.c = [
                s1[2],
                n1[2]
            ], this.d = [
                s1[3],
                n1[3]
            ], this.points = [
                t1,
                e1,
                r1,
                i1
            ];
        }
        function extrema(t1, e1) {
            var r1 = t1.points[0][e1], i1 = t1.points[t1.points.length - 1][e1];
            if (r1 > i1) {
                var a1 = i1;
                i1 = r1, r1 = a1;
            }
            for(var s1 = quadRoots(3 * t1.a[e1], 2 * t1.b[e1], t1.c[e1]), n1 = 0; n1 < s1.length; n1 += 1)if (s1[n1] > 0 && s1[n1] < 1) {
                var o1 = t1.point(s1[n1])[e1];
                o1 < r1 ? r1 = o1 : o1 > i1 && (i1 = o1);
            }
            return {
                min: r1,
                max: i1
            };
        }
        function intersectData(t1, e1, r1) {
            var i1 = t1.boundingBox();
            return {
                cx: i1.cx,
                cy: i1.cy,
                width: i1.width,
                height: i1.height,
                bez: t1,
                t: (e1 + r1) / 2,
                t1: e1,
                t2: r1
            };
        }
        function splitData(t1) {
            var e1 = t1.bez.split(.5);
            return [
                intersectData(e1[0], t1.t1, t1.t),
                intersectData(e1[1], t1.t, t1.t2)
            ];
        }
        function boxIntersect(t1, e1) {
            return 2 * Math.abs(t1.cx - e1.cx) < t1.width + e1.width && 2 * Math.abs(t1.cy - e1.cy) < t1.height + e1.height;
        }
        function intersectsImpl(t1, e1, r1, i1, a1, s1) {
            if (boxIntersect(t1, e1)) {
                if (r1 >= s1 || t1.width <= i1 && t1.height <= i1 && e1.width <= i1 && e1.height <= i1) a1.push([
                    t1.t,
                    e1.t
                ]);
                else {
                    var n1 = splitData(t1), o1 = splitData(e1);
                    intersectsImpl(n1[0], o1[0], r1 + 1, i1, a1, s1), intersectsImpl(n1[0], o1[1], r1 + 1, i1, a1, s1), intersectsImpl(n1[1], o1[0], r1 + 1, i1, a1, s1), intersectsImpl(n1[1], o1[1], r1 + 1, i1, a1, s1);
                }
            }
        }
        function crossProduct(t1, e1) {
            return [
                t1[1] * e1[2] - t1[2] * e1[1],
                t1[2] * e1[0] - t1[0] * e1[2],
                t1[0] * e1[1] - t1[1] * e1[0]
            ];
        }
        function lineIntersection(t1, e1, r1, i1) {
            var a1 = [
                t1[0],
                t1[1],
                1
            ], s1 = [
                e1[0],
                e1[1],
                1
            ], n1 = [
                r1[0],
                r1[1],
                1
            ], o1 = [
                i1[0],
                i1[1],
                1
            ], h1 = crossProduct(crossProduct(a1, s1), crossProduct(n1, o1));
            return floatZero(h1[2]) ? null : [
                h1[0] / h1[2],
                h1[1] / h1[2]
            ];
        }
        function polarOffset(t1, e1, r1) {
            return [
                t1[0] + Math.cos(e1) * r1,
                t1[1] - Math.sin(e1) * r1
            ];
        }
        function pointDistance(t1, e1) {
            return Math.hypot(t1[0] - e1[0], t1[1] - e1[1]);
        }
        function pointEqual(t1, e1) {
            return floatEqual(t1[0], e1[0]) && floatEqual(t1[1], e1[1]);
        }
        function ZigZagModifier() {}
        function setPoint(t1, e1, r1, i1, a1, s1, n1) {
            var o1 = r1 - Math.PI / 2, h1 = r1 + Math.PI / 2, l1 = e1[0] + Math.cos(r1) * i1 * a1, p1 = e1[1] - Math.sin(r1) * i1 * a1;
            t1.setTripleAt(l1, p1, l1 + Math.cos(o1) * s1, p1 - Math.sin(o1) * s1, l1 + Math.cos(h1) * n1, p1 - Math.sin(h1) * n1, t1.length());
        }
        function getPerpendicularVector(t1, e1) {
            var r1 = [
                e1[0] - t1[0],
                e1[1] - t1[1]
            ], i1 = .5 * -Math.PI;
            return [
                Math.cos(i1) * r1[0] - Math.sin(i1) * r1[1],
                Math.sin(i1) * r1[0] + Math.cos(i1) * r1[1]
            ];
        }
        function getProjectingAngle(t1, e1) {
            var r1 = 0 === e1 ? t1.length() - 1 : e1 - 1, i1 = (e1 + 1) % t1.length(), a1 = getPerpendicularVector(t1.v[r1], t1.v[i1]);
            return Math.atan2(0, 1) - Math.atan2(a1[1], a1[0]);
        }
        function zigZagCorner(t1, e1, r1, i1, a1, s1, n1) {
            var o1 = getProjectingAngle(e1, r1), h1 = e1.v[r1 % e1._length], l1 = e1.v[0 === r1 ? e1._length - 1 : r1 - 1], p1 = e1.v[(r1 + 1) % e1._length], f1 = 2 === s1 ? Math.sqrt(Math.pow(h1[0] - l1[0], 2) + Math.pow(h1[1] - l1[1], 2)) : 0, c1 = 2 === s1 ? Math.sqrt(Math.pow(h1[0] - p1[0], 2) + Math.pow(h1[1] - p1[1], 2)) : 0;
            setPoint(t1, e1.v[r1 % e1._length], o1, n1, i1, c1 / (2 * (a1 + 1)), f1 / (2 * (a1 + 1)), s1);
        }
        function zigZagSegment(t1, e1, r1, i1, a1, s1) {
            for(var n1 = 0; n1 < i1; n1 += 1){
                var o1 = (n1 + 1) / (i1 + 1), h1 = 2 === a1 ? Math.sqrt(Math.pow(e1.points[3][0] - e1.points[0][0], 2) + Math.pow(e1.points[3][1] - e1.points[0][1], 2)) : 0, l1 = e1.normalAngle(o1);
                setPoint(t1, e1.point(o1), l1, s1, r1, h1 / (2 * (i1 + 1)), h1 / (2 * (i1 + 1)), a1), s1 = -s1;
            }
            return s1;
        }
        function linearOffset(t1, e1, r1) {
            var i1 = Math.atan2(e1[0] - t1[0], e1[1] - t1[1]);
            return [
                polarOffset(t1, i1, r1),
                polarOffset(e1, i1, r1)
            ];
        }
        function offsetSegment(t1, e1) {
            var r1, i1, a1, s1, n1, o1, h1;
            r1 = (h1 = linearOffset(t1.points[0], t1.points[1], e1))[0], i1 = h1[1], a1 = (h1 = linearOffset(t1.points[1], t1.points[2], e1))[0], s1 = h1[1], n1 = (h1 = linearOffset(t1.points[2], t1.points[3], e1))[0], o1 = h1[1];
            var l1 = lineIntersection(r1, i1, a1, s1);
            null === l1 && (l1 = i1);
            var p1 = lineIntersection(n1, o1, a1, s1);
            return null === p1 && (p1 = n1), new PolynomialBezier(r1, l1, p1, o1);
        }
        function joinLines(t1, e1, r1, i1, a1) {
            var s1 = e1.points[3], n1 = r1.points[0];
            if (3 === i1) return s1;
            if (pointEqual(s1, n1)) return s1;
            if (2 === i1) {
                var o1 = -e1.tangentAngle(1), h1 = -r1.tangentAngle(0) + Math.PI, l1 = lineIntersection(s1, polarOffset(s1, o1 + Math.PI / 2, 100), n1, polarOffset(n1, o1 + Math.PI / 2, 100)), p1 = l1 ? pointDistance(l1, s1) : pointDistance(s1, n1) / 2, f1 = polarOffset(s1, o1, 2 * p1 * roundCorner);
                return t1.setXYAt(f1[0], f1[1], "o", t1.length() - 1), f1 = polarOffset(n1, h1, 2 * p1 * roundCorner), t1.setTripleAt(n1[0], n1[1], n1[0], n1[1], f1[0], f1[1], t1.length()), n1;
            }
            var c1 = lineIntersection(pointEqual(s1, e1.points[2]) ? e1.points[0] : e1.points[2], s1, n1, pointEqual(n1, r1.points[1]) ? r1.points[3] : r1.points[1]);
            return c1 && pointDistance(c1, s1) < a1 ? (t1.setTripleAt(c1[0], c1[1], c1[0], c1[1], c1[0], c1[1], t1.length()), c1) : s1;
        }
        function getIntersection(t1, e1) {
            var r1 = t1.intersections(e1);
            return r1.length && floatEqual(r1[0][0], 1) && r1.shift(), r1.length ? r1[0] : null;
        }
        function pruneSegmentIntersection(t1, e1) {
            var r1 = t1.slice(), i1 = e1.slice(), a1 = getIntersection(t1[t1.length - 1], e1[0]);
            return a1 && (r1[t1.length - 1] = t1[t1.length - 1].split(a1[0])[0], i1[0] = e1[0].split(a1[1])[1]), t1.length > 1 && e1.length > 1 && (a1 = getIntersection(t1[0], e1[e1.length - 1])) ? [
                [
                    t1[0].split(a1[0])[0]
                ],
                [
                    e1[e1.length - 1].split(a1[1])[1]
                ]
            ] : [
                r1,
                i1
            ];
        }
        function pruneIntersections(t1) {
            for(var e1, r1 = 1; r1 < t1.length; r1 += 1)e1 = pruneSegmentIntersection(t1[r1 - 1], t1[r1]), t1[r1 - 1] = e1[0], t1[r1] = e1[1];
            return t1.length > 1 && (e1 = pruneSegmentIntersection(t1[t1.length - 1], t1[0]), t1[t1.length - 1] = e1[0], t1[0] = e1[1]), t1;
        }
        function offsetSegmentSplit(t1, e1) {
            var r1, i1, a1, s1, n1 = t1.inflectionPoints();
            if (0 === n1.length) return [
                offsetSegment(t1, e1)
            ];
            if (1 === n1.length || floatEqual(n1[1], 1)) return r1 = (a1 = t1.split(n1[0]))[0], i1 = a1[1], [
                offsetSegment(r1, e1),
                offsetSegment(i1, e1)
            ];
            r1 = (a1 = t1.split(n1[0]))[0];
            var o1 = (n1[1] - n1[0]) / (1 - n1[0]);
            return s1 = (a1 = a1[1].split(o1))[0], i1 = a1[1], [
                offsetSegment(r1, e1),
                offsetSegment(s1, e1),
                offsetSegment(i1, e1)
            ];
        }
        function OffsetPathModifier() {}
        function getFontProperties(t1) {
            for(var e1 = t1.fStyle ? t1.fStyle.split(" ") : [], r1 = "normal", i1 = "normal", a1 = e1.length, s1 = 0; s1 < a1; s1 += 1)switch(e1[s1].toLowerCase()){
                case "italic":
                    i1 = "italic";
                    break;
                case "bold":
                    r1 = "700";
                    break;
                case "black":
                    r1 = "900";
                    break;
                case "medium":
                    r1 = "500";
                    break;
                case "regular":
                case "normal":
                    r1 = "400";
                    break;
                case "light":
                case "thin":
                    r1 = "200";
            }
            return {
                style: i1,
                weight: t1.fWeight || r1
            };
        }
        extendPrototype([
            ShapeModifier
        ], RepeaterModifier), RepeaterModifier.prototype.initModifierProperties = function(t1, e1) {
            this.getValue = this.processKeys, this.c = PropertyFactory.getProp(t1, e1.c, 0, null, this), this.o = PropertyFactory.getProp(t1, e1.o, 0, null, this), this.tr = TransformPropertyFactory.getTransformProperty(t1, e1.tr, this), this.so = PropertyFactory.getProp(t1, e1.tr.so, 0, .01, this), this.eo = PropertyFactory.getProp(t1, e1.tr.eo, 0, .01, this), this.data = e1, this.dynamicProperties.length || this.getValue(!0), this._isAnimated = !!this.dynamicProperties.length, this.pMatrix = new Matrix, this.rMatrix = new Matrix, this.sMatrix = new Matrix, this.tMatrix = new Matrix, this.matrix = new Matrix;
        }, RepeaterModifier.prototype.applyTransforms = function(t1, e1, r1, i1, a1, s1) {
            var n1 = s1 ? -1 : 1, o1 = i1.s.v[0] + (1 - i1.s.v[0]) * (1 - a1), h1 = i1.s.v[1] + (1 - i1.s.v[1]) * (1 - a1);
            t1.translate(i1.p.v[0] * n1 * a1, i1.p.v[1] * n1 * a1, i1.p.v[2]), e1.translate(-i1.a.v[0], -i1.a.v[1], i1.a.v[2]), e1.rotate(-i1.r.v * n1 * a1), e1.translate(i1.a.v[0], i1.a.v[1], i1.a.v[2]), r1.translate(-i1.a.v[0], -i1.a.v[1], i1.a.v[2]), r1.scale(s1 ? 1 / o1 : o1, s1 ? 1 / h1 : h1), r1.translate(i1.a.v[0], i1.a.v[1], i1.a.v[2]);
        }, RepeaterModifier.prototype.init = function(t1, e1, r1, i1) {
            for(this.elem = t1, this.arr = e1, this.pos = r1, this.elemsData = i1, this._currentCopies = 0, this._elements = [], this._groups = [], this.frameId = -1, this.initDynamicPropertyContainer(t1), this.initModifierProperties(t1, e1[r1]); r1 > 0;)r1 -= 1, this._elements.unshift(e1[r1]);
            this.dynamicProperties.length ? this.k = !0 : this.getValue(!0);
        }, RepeaterModifier.prototype.resetElements = function(t1) {
            var e1, r1 = t1.length;
            for(e1 = 0; e1 < r1; e1 += 1)t1[e1]._processed = !1, "gr" === t1[e1].ty && this.resetElements(t1[e1].it);
        }, RepeaterModifier.prototype.cloneElements = function(t1) {
            var e1 = JSON.parse(JSON.stringify(t1));
            return this.resetElements(e1), e1;
        }, RepeaterModifier.prototype.changeGroupRender = function(t1, e1) {
            var r1, i1 = t1.length;
            for(r1 = 0; r1 < i1; r1 += 1)t1[r1]._render = e1, "gr" === t1[r1].ty && this.changeGroupRender(t1[r1].it, e1);
        }, RepeaterModifier.prototype.processShapes = function(t1) {
            var e1, r1, i1, a1, s1, n1 = !1;
            if (this._mdf || t1) {
                var o1, h1 = Math.ceil(this.c.v);
                if (this._groups.length < h1) {
                    for(; this._groups.length < h1;){
                        var l1 = {
                            it: this.cloneElements(this._elements),
                            ty: "gr"
                        };
                        l1.it.push({
                            a: {
                                a: 0,
                                ix: 1,
                                k: [
                                    0,
                                    0
                                ]
                            },
                            nm: "Transform",
                            o: {
                                a: 0,
                                ix: 7,
                                k: 100
                            },
                            p: {
                                a: 0,
                                ix: 2,
                                k: [
                                    0,
                                    0
                                ]
                            },
                            r: {
                                a: 1,
                                ix: 6,
                                k: [
                                    {
                                        s: 0,
                                        e: 0,
                                        t: 0
                                    },
                                    {
                                        s: 0,
                                        e: 0,
                                        t: 1
                                    }
                                ]
                            },
                            s: {
                                a: 0,
                                ix: 3,
                                k: [
                                    100,
                                    100
                                ]
                            },
                            sa: {
                                a: 0,
                                ix: 5,
                                k: 0
                            },
                            sk: {
                                a: 0,
                                ix: 4,
                                k: 0
                            },
                            ty: "tr"
                        }), this.arr.splice(0, 0, l1), this._groups.splice(0, 0, l1), this._currentCopies += 1;
                    }
                    this.elem.reloadShapes(), n1 = !0;
                }
                for(s1 = 0, i1 = 0; i1 <= this._groups.length - 1; i1 += 1){
                    if (o1 = s1 < h1, this._groups[i1]._render = o1, this.changeGroupRender(this._groups[i1].it, o1), !o1) {
                        var p1 = this.elemsData[i1].it, f1 = p1[p1.length - 1];
                        0 !== f1.transform.op.v ? (f1.transform.op._mdf = !0, f1.transform.op.v = 0) : f1.transform.op._mdf = !1;
                    }
                    s1 += 1;
                }
                this._currentCopies = h1;
                var c1 = this.o.v, m1 = c1 % 1, d1 = c1 > 0 ? Math.floor(c1) : Math.ceil(c1), u1 = this.pMatrix.props, y1 = this.rMatrix.props, g1 = this.sMatrix.props;
                this.pMatrix.reset(), this.rMatrix.reset(), this.sMatrix.reset(), this.tMatrix.reset(), this.matrix.reset();
                var v1, b1, x1 = 0;
                if (c1 > 0) {
                    for(; x1 < d1;)this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, 1, !1), x1 += 1;
                    m1 && (this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, m1, !1), x1 += m1);
                } else if (c1 < 0) {
                    for(; x1 > d1;)this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, 1, !0), x1 -= 1;
                    m1 && (this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, -m1, !0), x1 -= m1);
                }
                for(i1 = 1 === this.data.m ? 0 : this._currentCopies - 1, a1 = 1 === this.data.m ? 1 : -1, s1 = this._currentCopies; s1;){
                    if (b1 = (r1 = (e1 = this.elemsData[i1].it)[e1.length - 1].transform.mProps.v.props).length, e1[e1.length - 1].transform.mProps._mdf = !0, e1[e1.length - 1].transform.op._mdf = !0, e1[e1.length - 1].transform.op.v = 1 === this._currentCopies ? this.so.v : this.so.v + (this.eo.v - this.so.v) * (i1 / (this._currentCopies - 1)), 0 !== x1) {
                        for((0 !== i1 && 1 === a1 || i1 !== this._currentCopies - 1 && -1 === a1) && this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, 1, !1), this.matrix.transform(y1[0], y1[1], y1[2], y1[3], y1[4], y1[5], y1[6], y1[7], y1[8], y1[9], y1[10], y1[11], y1[12], y1[13], y1[14], y1[15]), this.matrix.transform(g1[0], g1[1], g1[2], g1[3], g1[4], g1[5], g1[6], g1[7], g1[8], g1[9], g1[10], g1[11], g1[12], g1[13], g1[14], g1[15]), this.matrix.transform(u1[0], u1[1], u1[2], u1[3], u1[4], u1[5], u1[6], u1[7], u1[8], u1[9], u1[10], u1[11], u1[12], u1[13], u1[14], u1[15]), v1 = 0; v1 < b1; v1 += 1)r1[v1] = this.matrix.props[v1];
                        this.matrix.reset();
                    } else for(this.matrix.reset(), v1 = 0; v1 < b1; v1 += 1)r1[v1] = this.matrix.props[v1];
                    x1 += 1, s1 -= 1, i1 += a1;
                }
            } else for(s1 = this._currentCopies, i1 = 0, a1 = 1; s1;)r1 = (e1 = this.elemsData[i1].it)[e1.length - 1].transform.mProps.v.props, e1[e1.length - 1].transform.mProps._mdf = !1, e1[e1.length - 1].transform.op._mdf = !1, s1 -= 1, i1 += a1;
            return n1;
        }, RepeaterModifier.prototype.addShape = function() {}, extendPrototype([
            ShapeModifier
        ], RoundCornersModifier), RoundCornersModifier.prototype.initModifierProperties = function(t1, e1) {
            this.getValue = this.processKeys, this.rd = PropertyFactory.getProp(t1, e1.r, 0, null, this), this._isAnimated = !!this.rd.effectsSequence.length;
        }, RoundCornersModifier.prototype.processPath = function(t1, e1) {
            var r1, i1 = shapePool.newElement();
            i1.c = t1.c;
            var a1, s1, n1, o1, h1, l1, p1, f1, c1, m1, d1, u1, y1 = t1._length, g1 = 0;
            for(r1 = 0; r1 < y1; r1 += 1)a1 = t1.v[r1], n1 = t1.o[r1], s1 = t1.i[r1], a1[0] === n1[0] && a1[1] === n1[1] && a1[0] === s1[0] && a1[1] === s1[1] ? 0 !== r1 && r1 !== y1 - 1 || t1.c ? (o1 = 0 === r1 ? t1.v[y1 - 1] : t1.v[r1 - 1], l1 = (h1 = Math.sqrt(Math.pow(a1[0] - o1[0], 2) + Math.pow(a1[1] - o1[1], 2))) ? Math.min(h1 / 2, e1) / h1 : 0, p1 = d1 = a1[0] + (o1[0] - a1[0]) * l1, f1 = u1 = a1[1] - (a1[1] - o1[1]) * l1, c1 = p1 - (p1 - a1[0]) * roundCorner, m1 = f1 - (f1 - a1[1]) * roundCorner, i1.setTripleAt(p1, f1, c1, m1, d1, u1, g1), g1 += 1, o1 = r1 === y1 - 1 ? t1.v[0] : t1.v[r1 + 1], l1 = (h1 = Math.sqrt(Math.pow(a1[0] - o1[0], 2) + Math.pow(a1[1] - o1[1], 2))) ? Math.min(h1 / 2, e1) / h1 : 0, p1 = c1 = a1[0] + (o1[0] - a1[0]) * l1, f1 = m1 = a1[1] + (o1[1] - a1[1]) * l1, d1 = p1 - (p1 - a1[0]) * roundCorner, u1 = f1 - (f1 - a1[1]) * roundCorner, i1.setTripleAt(p1, f1, c1, m1, d1, u1, g1), g1 += 1) : (i1.setTripleAt(a1[0], a1[1], n1[0], n1[1], s1[0], s1[1], g1), g1 += 1) : (i1.setTripleAt(t1.v[r1][0], t1.v[r1][1], t1.o[r1][0], t1.o[r1][1], t1.i[r1][0], t1.i[r1][1], g1), g1 += 1);
            return i1;
        }, RoundCornersModifier.prototype.processShapes = function(t1) {
            var e1, r1, i1, a1, s1, n1, o1 = this.shapes.length, h1 = this.rd.v;
            if (0 !== h1) for(r1 = 0; r1 < o1; r1 += 1){
                if (n1 = (s1 = this.shapes[r1]).localShapeCollection, s1.shape._mdf || this._mdf || t1) for(n1.releaseShapes(), s1.shape._mdf = !0, e1 = s1.shape.paths.shapes, a1 = s1.shape.paths._length, i1 = 0; i1 < a1; i1 += 1)n1.addShape(this.processPath(e1[i1], h1));
                s1.shape.paths = s1.localShapeCollection;
            }
            this.dynamicProperties.length || (this._mdf = !1);
        }, PolynomialBezier.prototype.point = function(t1) {
            return [
                ((this.a[0] * t1 + this.b[0]) * t1 + this.c[0]) * t1 + this.d[0],
                ((this.a[1] * t1 + this.b[1]) * t1 + this.c[1]) * t1 + this.d[1]
            ];
        }, PolynomialBezier.prototype.derivative = function(t1) {
            return [
                (3 * t1 * this.a[0] + 2 * this.b[0]) * t1 + this.c[0],
                (3 * t1 * this.a[1] + 2 * this.b[1]) * t1 + this.c[1]
            ];
        }, PolynomialBezier.prototype.tangentAngle = function(t1) {
            var e1 = this.derivative(t1);
            return Math.atan2(e1[1], e1[0]);
        }, PolynomialBezier.prototype.normalAngle = function(t1) {
            var e1 = this.derivative(t1);
            return Math.atan2(e1[0], e1[1]);
        }, PolynomialBezier.prototype.inflectionPoints = function() {
            var t1 = this.a[1] * this.b[0] - this.a[0] * this.b[1];
            if (floatZero(t1)) return [];
            var e1 = -0.5 * (this.a[1] * this.c[0] - this.a[0] * this.c[1]) / t1, r1 = e1 * e1 - 1 / 3 * (this.b[1] * this.c[0] - this.b[0] * this.c[1]) / t1;
            if (r1 < 0) return [];
            var i1 = Math.sqrt(r1);
            return floatZero(i1) ? i1 > 0 && i1 < 1 ? [
                e1
            ] : [] : [
                e1 - i1,
                e1 + i1
            ].filter(function(t1) {
                return t1 > 0 && t1 < 1;
            });
        }, PolynomialBezier.prototype.split = function(t1) {
            if (t1 <= 0) return [
                singlePoint(this.points[0]),
                this
            ];
            if (t1 >= 1) return [
                this,
                singlePoint(this.points[this.points.length - 1])
            ];
            var e1 = lerpPoint(this.points[0], this.points[1], t1), r1 = lerpPoint(this.points[1], this.points[2], t1), i1 = lerpPoint(this.points[2], this.points[3], t1), a1 = lerpPoint(e1, r1, t1), s1 = lerpPoint(r1, i1, t1), n1 = lerpPoint(a1, s1, t1);
            return [
                new PolynomialBezier(this.points[0], e1, a1, n1, !0),
                new PolynomialBezier(n1, s1, i1, this.points[3], !0)
            ];
        }, PolynomialBezier.prototype.bounds = function() {
            return {
                x: extrema(this, 0),
                y: extrema(this, 1)
            };
        }, PolynomialBezier.prototype.boundingBox = function() {
            var t1 = this.bounds();
            return {
                left: t1.x.min,
                right: t1.x.max,
                top: t1.y.min,
                bottom: t1.y.max,
                width: t1.x.max - t1.x.min,
                height: t1.y.max - t1.y.min,
                cx: (t1.x.max + t1.x.min) / 2,
                cy: (t1.y.max + t1.y.min) / 2
            };
        }, PolynomialBezier.prototype.intersections = function(t1, e1, r1) {
            void 0 === e1 && (e1 = 2), void 0 === r1 && (r1 = 7);
            var i1 = [];
            return intersectsImpl(intersectData(this, 0, 1), intersectData(t1, 0, 1), 0, e1, i1, r1), i1;
        }, PolynomialBezier.shapeSegment = function(t1, e1) {
            var r1 = (e1 + 1) % t1.length();
            return new PolynomialBezier(t1.v[e1], t1.o[e1], t1.i[r1], t1.v[r1], !0);
        }, PolynomialBezier.shapeSegmentInverted = function(t1, e1) {
            var r1 = (e1 + 1) % t1.length();
            return new PolynomialBezier(t1.v[r1], t1.i[r1], t1.o[e1], t1.v[e1], !0);
        }, extendPrototype([
            ShapeModifier
        ], ZigZagModifier), ZigZagModifier.prototype.initModifierProperties = function(t1, e1) {
            this.getValue = this.processKeys, this.amplitude = PropertyFactory.getProp(t1, e1.s, 0, null, this), this.frequency = PropertyFactory.getProp(t1, e1.r, 0, null, this), this.pointsType = PropertyFactory.getProp(t1, e1.pt, 0, null, this), this._isAnimated = 0 !== this.amplitude.effectsSequence.length || 0 !== this.frequency.effectsSequence.length || 0 !== this.pointsType.effectsSequence.length;
        }, ZigZagModifier.prototype.processPath = function(t1, e1, r1, i1) {
            var a1 = t1._length, s1 = shapePool.newElement();
            if (s1.c = t1.c, t1.c || (a1 -= 1), 0 === a1) return s1;
            var n1 = -1, o1 = PolynomialBezier.shapeSegment(t1, 0);
            zigZagCorner(s1, t1, 0, e1, r1, i1, n1);
            for(var h1 = 0; h1 < a1; h1 += 1)n1 = zigZagSegment(s1, o1, e1, r1, i1, -n1), o1 = h1 !== a1 - 1 || t1.c ? PolynomialBezier.shapeSegment(t1, (h1 + 1) % a1) : null, zigZagCorner(s1, t1, h1 + 1, e1, r1, i1, n1);
            return s1;
        }, ZigZagModifier.prototype.processShapes = function(t1) {
            var e1, r1, i1, a1, s1, n1, o1 = this.shapes.length, h1 = this.amplitude.v, l1 = Math.max(0, Math.round(this.frequency.v)), p1 = this.pointsType.v;
            if (0 !== h1) for(r1 = 0; r1 < o1; r1 += 1){
                if (n1 = (s1 = this.shapes[r1]).localShapeCollection, s1.shape._mdf || this._mdf || t1) for(n1.releaseShapes(), s1.shape._mdf = !0, e1 = s1.shape.paths.shapes, a1 = s1.shape.paths._length, i1 = 0; i1 < a1; i1 += 1)n1.addShape(this.processPath(e1[i1], h1, l1, p1));
                s1.shape.paths = s1.localShapeCollection;
            }
            this.dynamicProperties.length || (this._mdf = !1);
        }, extendPrototype([
            ShapeModifier
        ], OffsetPathModifier), OffsetPathModifier.prototype.initModifierProperties = function(t1, e1) {
            this.getValue = this.processKeys, this.amount = PropertyFactory.getProp(t1, e1.a, 0, null, this), this.miterLimit = PropertyFactory.getProp(t1, e1.ml, 0, null, this), this.lineJoin = e1.lj, this._isAnimated = 0 !== this.amount.effectsSequence.length;
        }, OffsetPathModifier.prototype.processPath = function(t1, e1, r1, i1) {
            var a1 = shapePool.newElement();
            a1.c = t1.c;
            var s1, n1, o1, h1 = t1.length();
            t1.c || (h1 -= 1);
            var l1 = [];
            for(s1 = 0; s1 < h1; s1 += 1)o1 = PolynomialBezier.shapeSegment(t1, s1), l1.push(offsetSegmentSplit(o1, e1));
            if (!t1.c) for(s1 = h1 - 1; s1 >= 0; s1 -= 1)o1 = PolynomialBezier.shapeSegmentInverted(t1, s1), l1.push(offsetSegmentSplit(o1, e1));
            l1 = pruneIntersections(l1);
            var p1 = null, f1 = null;
            for(s1 = 0; s1 < l1.length; s1 += 1){
                var c1 = l1[s1];
                for(f1 && (p1 = joinLines(a1, f1, c1[0], r1, i1)), f1 = c1[c1.length - 1], n1 = 0; n1 < c1.length; n1 += 1)o1 = c1[n1], p1 && pointEqual(o1.points[0], p1) ? a1.setXYAt(o1.points[1][0], o1.points[1][1], "o", a1.length() - 1) : a1.setTripleAt(o1.points[0][0], o1.points[0][1], o1.points[1][0], o1.points[1][1], o1.points[0][0], o1.points[0][1], a1.length()), a1.setTripleAt(o1.points[3][0], o1.points[3][1], o1.points[3][0], o1.points[3][1], o1.points[2][0], o1.points[2][1], a1.length()), p1 = o1.points[3];
            }
            return l1.length && joinLines(a1, f1, l1[0][0], r1, i1), a1;
        }, OffsetPathModifier.prototype.processShapes = function(t1) {
            var e1, r1, i1, a1, s1, n1, o1 = this.shapes.length, h1 = this.amount.v, l1 = this.miterLimit.v, p1 = this.lineJoin;
            if (0 !== h1) for(r1 = 0; r1 < o1; r1 += 1){
                if (n1 = (s1 = this.shapes[r1]).localShapeCollection, s1.shape._mdf || this._mdf || t1) for(n1.releaseShapes(), s1.shape._mdf = !0, e1 = s1.shape.paths.shapes, a1 = s1.shape.paths._length, i1 = 0; i1 < a1; i1 += 1)n1.addShape(this.processPath(e1[i1], h1, p1, l1));
                s1.shape.paths = s1.localShapeCollection;
            }
            this.dynamicProperties.length || (this._mdf = !1);
        };
        var FontManager = function() {
            var t1 = {
                w: 0,
                size: 0,
                shapes: [],
                data: {
                    shapes: []
                }
            }, e1 = [];
            e1 = e1.concat([
                2304,
                2305,
                2306,
                2307,
                2362,
                2363,
                2364,
                2364,
                2366,
                2367,
                2368,
                2369,
                2370,
                2371,
                2372,
                2373,
                2374,
                2375,
                2376,
                2377,
                2378,
                2379,
                2380,
                2381,
                2382,
                2383,
                2387,
                2388,
                2389,
                2390,
                2391,
                2402,
                2403
            ]);
            var r1 = [
                "d83cdffb",
                "d83cdffc",
                "d83cdffd",
                "d83cdffe",
                "d83cdfff"
            ], i1 = [
                65039,
                8205
            ];
            function a1(t1, e1) {
                var r1 = createTag("span");
                r1.setAttribute("aria-hidden", !0), r1.style.fontFamily = e1;
                var i1 = createTag("span");
                i1.innerText = "giItT1WQy@!-/#", r1.style.position = "absolute", r1.style.left = "-10000px", r1.style.top = "-10000px", r1.style.fontSize = "300px", r1.style.fontVariant = "normal", r1.style.fontStyle = "normal", r1.style.fontWeight = "normal", r1.style.letterSpacing = "0", r1.appendChild(i1), document.body.appendChild(r1);
                var a1 = i1.offsetWidth;
                return i1.style.fontFamily = function(t1) {
                    var e1, r1 = t1.split(","), i1 = r1.length, a1 = [];
                    for(e1 = 0; e1 < i1; e1 += 1)"sans-serif" !== r1[e1] && "monospace" !== r1[e1] && a1.push(r1[e1]);
                    return a1.join(",");
                }(t1) + ", " + e1, {
                    node: i1,
                    w: a1,
                    parent: r1
                };
            }
            function s1(t1, e1) {
                var r1, i1 = document.body && e1 ? "svg" : "canvas", a1 = getFontProperties(t1);
                if ("svg" === i1) {
                    var s1 = createNS("text");
                    s1.style.fontSize = "100px", s1.setAttribute("font-family", t1.fFamily), s1.setAttribute("font-style", a1.style), s1.setAttribute("font-weight", a1.weight), s1.textContent = "1", t1.fClass ? (s1.style.fontFamily = "inherit", s1.setAttribute("class", t1.fClass)) : s1.style.fontFamily = t1.fFamily, e1.appendChild(s1), r1 = s1;
                } else {
                    var n1 = new OffscreenCanvas(500, 500).getContext("2d");
                    n1.font = a1.style + " " + a1.weight + " 100px " + t1.fFamily, r1 = n1;
                }
                return {
                    measureText: function(t1) {
                        return "svg" === i1 ? (r1.textContent = t1, r1.getComputedTextLength()) : r1.measureText(t1).width;
                    }
                };
            }
            var n1 = function() {
                this.fonts = [], this.chars = null, this.typekitLoaded = 0, this.isLoaded = !1, this._warned = !1, this.initTime = Date.now(), this.setIsLoadedBinded = this.setIsLoaded.bind(this), this.checkLoadedFontsBinded = this.checkLoadedFonts.bind(this);
            };
            return n1.isModifier = function(t1, e1) {
                var i1 = t1.toString(16) + e1.toString(16);
                return -1 !== r1.indexOf(i1);
            }, n1.isZeroWidthJoiner = function(t1, e1) {
                return e1 ? t1 === i1[0] && e1 === i1[1] : t1 === i1[1];
            }, n1.isCombinedCharacter = function(t1) {
                return -1 !== e1.indexOf(t1);
            }, n1.prototype = {
                addChars: function(t1) {
                    if (t1) {
                        var e1;
                        this.chars || (this.chars = []);
                        var r1, i1, a1 = t1.length, s1 = this.chars.length;
                        for(e1 = 0; e1 < a1; e1 += 1){
                            for(r1 = 0, i1 = !1; r1 < s1;)this.chars[r1].style === t1[e1].style && this.chars[r1].fFamily === t1[e1].fFamily && this.chars[r1].ch === t1[e1].ch && (i1 = !0), r1 += 1;
                            i1 || (this.chars.push(t1[e1]), s1 += 1);
                        }
                    }
                },
                addFonts: function(t1, e1) {
                    if (t1) {
                        if (this.chars) return this.isLoaded = !0, void (this.fonts = t1.list);
                        if (!document.body) return this.isLoaded = !0, t1.list.forEach(function(t1) {
                            t1.helper = s1(t1), t1.cache = {};
                        }), void (this.fonts = t1.list);
                        var r1, i1 = t1.list, n1 = i1.length, o1 = n1;
                        for(r1 = 0; r1 < n1; r1 += 1){
                            var h1, l1, p1 = !0;
                            if (i1[r1].loaded = !1, i1[r1].monoCase = a1(i1[r1].fFamily, "monospace"), i1[r1].sansCase = a1(i1[r1].fFamily, "sans-serif"), i1[r1].fPath) {
                                if ("p" === i1[r1].fOrigin || 3 === i1[r1].origin) {
                                    if ((h1 = document.querySelectorAll('style[f-forigin="p"][f-family="' + i1[r1].fFamily + '"], style[f-origin="3"][f-family="' + i1[r1].fFamily + '"]')).length > 0 && (p1 = !1), p1) {
                                        var f1 = createTag("style");
                                        f1.setAttribute("f-forigin", i1[r1].fOrigin), f1.setAttribute("f-origin", i1[r1].origin), f1.setAttribute("f-family", i1[r1].fFamily), f1.type = "text/css", f1.innerText = "@font-face {font-family: " + i1[r1].fFamily + "; font-style: normal; src: url('" + i1[r1].fPath + "');}", e1.appendChild(f1);
                                    }
                                } else if ("g" === i1[r1].fOrigin || 1 === i1[r1].origin) {
                                    for(h1 = document.querySelectorAll('link[f-forigin="g"], link[f-origin="1"]'), l1 = 0; l1 < h1.length; l1 += 1)-1 !== h1[l1].href.indexOf(i1[r1].fPath) && (p1 = !1);
                                    if (p1) {
                                        var c1 = createTag("link");
                                        c1.setAttribute("f-forigin", i1[r1].fOrigin), c1.setAttribute("f-origin", i1[r1].origin), c1.type = "text/css", c1.rel = "stylesheet", c1.href = i1[r1].fPath, document.body.appendChild(c1);
                                    }
                                } else if ("t" === i1[r1].fOrigin || 2 === i1[r1].origin) {
                                    for(h1 = document.querySelectorAll('script[f-forigin="t"], script[f-origin="2"]'), l1 = 0; l1 < h1.length; l1 += 1)i1[r1].fPath === h1[l1].src && (p1 = !1);
                                    if (p1) {
                                        var m1 = createTag("link");
                                        m1.setAttribute("f-forigin", i1[r1].fOrigin), m1.setAttribute("f-origin", i1[r1].origin), m1.setAttribute("rel", "stylesheet"), m1.setAttribute("href", i1[r1].fPath), e1.appendChild(m1);
                                    }
                                }
                            } else i1[r1].loaded = !0, o1 -= 1;
                            i1[r1].helper = s1(i1[r1], e1), i1[r1].cache = {}, this.fonts.push(i1[r1]);
                        }
                        0 === o1 ? this.isLoaded = !0 : setTimeout(this.checkLoadedFonts.bind(this), 100);
                    } else this.isLoaded = !0;
                },
                getCharData: function(e1, r1, i1) {
                    for(var a1 = 0, s1 = this.chars.length; a1 < s1;){
                        if (this.chars[a1].ch === e1 && this.chars[a1].style === r1 && this.chars[a1].fFamily === i1) return this.chars[a1];
                        a1 += 1;
                    }
                    return ("string" == typeof e1 && 13 !== e1.charCodeAt(0) || !e1) && console && console.warn && !this._warned && (this._warned = !0), t1;
                },
                getFontByName: function(t1) {
                    for(var e1 = 0, r1 = this.fonts.length; e1 < r1;){
                        if (this.fonts[e1].fName === t1) return this.fonts[e1];
                        e1 += 1;
                    }
                    return this.fonts[0];
                },
                measureText: function(t1, e1, r1) {
                    var i1 = this.getFontByName(e1), a1 = t1.charCodeAt(0);
                    if (!i1.cache[a1 + 1]) {
                        var s1 = i1.helper;
                        if (" " === t1) {
                            var n1 = s1.measureText("|" + t1 + "|"), o1 = s1.measureText("||");
                            i1.cache[a1 + 1] = (n1 - o1) / 100;
                        } else i1.cache[a1 + 1] = s1.measureText(t1) / 100;
                    }
                    return i1.cache[a1 + 1] * r1;
                },
                checkLoadedFonts: function() {
                    var t1, e1, r1, i1 = this.fonts.length, a1 = i1;
                    for(t1 = 0; t1 < i1; t1 += 1)this.fonts[t1].loaded ? a1 -= 1 : "n" === this.fonts[t1].fOrigin || 0 === this.fonts[t1].origin ? this.fonts[t1].loaded = !0 : (e1 = this.fonts[t1].monoCase.node, r1 = this.fonts[t1].monoCase.w, e1.offsetWidth !== r1 ? (a1 -= 1, this.fonts[t1].loaded = !0) : (e1 = this.fonts[t1].sansCase.node, r1 = this.fonts[t1].sansCase.w, e1.offsetWidth !== r1 && (a1 -= 1, this.fonts[t1].loaded = !0)), this.fonts[t1].loaded && (this.fonts[t1].sansCase.parent.parentNode.removeChild(this.fonts[t1].sansCase.parent), this.fonts[t1].monoCase.parent.parentNode.removeChild(this.fonts[t1].monoCase.parent)));
                    0 !== a1 && Date.now() - this.initTime < 5e3 ? setTimeout(this.checkLoadedFontsBinded, 20) : setTimeout(this.setIsLoadedBinded, 10);
                },
                setIsLoaded: function() {
                    this.isLoaded = !0;
                }
            }, n1;
        }();
        function RenderableElement() {}
        RenderableElement.prototype = {
            initRenderable: function() {
                this.isInRange = !1, this.hidden = !1, this.isTransparent = !1, this.renderableComponents = [];
            },
            addRenderableComponent: function(t1) {
                -1 === this.renderableComponents.indexOf(t1) && this.renderableComponents.push(t1);
            },
            removeRenderableComponent: function(t1) {
                -1 !== this.renderableComponents.indexOf(t1) && this.renderableComponents.splice(this.renderableComponents.indexOf(t1), 1);
            },
            prepareRenderableFrame: function(t1) {
                this.checkLayerLimits(t1);
            },
            checkTransparency: function() {
                this.finalTransform.mProp.o.v <= 0 ? !this.isTransparent && this.globalData.renderConfig.hideOnTransparent && (this.isTransparent = !0, this.hide()) : this.isTransparent && (this.isTransparent = !1, this.show());
            },
            checkLayerLimits: function(t1) {
                this.data.ip - this.data.st <= t1 && this.data.op - this.data.st > t1 ? !0 !== this.isInRange && (this.globalData._mdf = !0, this._mdf = !0, this.isInRange = !0, this.show()) : !1 !== this.isInRange && (this.globalData._mdf = !0, this.isInRange = !1, this.hide());
            },
            renderRenderable: function() {
                var t1, e1 = this.renderableComponents.length;
                for(t1 = 0; t1 < e1; t1 += 1)this.renderableComponents[t1].renderFrame(this._isFirstFrame);
            },
            sourceRectAtTime: function() {
                return {
                    top: 0,
                    left: 0,
                    width: 100,
                    height: 100
                };
            },
            getLayerSize: function() {
                return 5 === this.data.ty ? {
                    w: this.data.textData.width,
                    h: this.data.textData.height
                } : {
                    w: this.data.width,
                    h: this.data.height
                };
            }
        };
        var getBlendMode = (blendModeEnums = {
            0: "source-over",
            1: "multiply",
            2: "screen",
            3: "overlay",
            4: "darken",
            5: "lighten",
            6: "color-dodge",
            7: "color-burn",
            8: "hard-light",
            9: "soft-light",
            10: "difference",
            11: "exclusion",
            12: "hue",
            13: "saturation",
            14: "color",
            15: "luminosity"
        }, function(t1) {
            return blendModeEnums[t1] || "";
        }), blendModeEnums;
        function SliderEffect(t1, e1, r1) {
            this.p = PropertyFactory.getProp(e1, t1.v, 0, 0, r1);
        }
        function AngleEffect(t1, e1, r1) {
            this.p = PropertyFactory.getProp(e1, t1.v, 0, 0, r1);
        }
        function ColorEffect(t1, e1, r1) {
            this.p = PropertyFactory.getProp(e1, t1.v, 1, 0, r1);
        }
        function PointEffect(t1, e1, r1) {
            this.p = PropertyFactory.getProp(e1, t1.v, 1, 0, r1);
        }
        function LayerIndexEffect(t1, e1, r1) {
            this.p = PropertyFactory.getProp(e1, t1.v, 0, 0, r1);
        }
        function MaskIndexEffect(t1, e1, r1) {
            this.p = PropertyFactory.getProp(e1, t1.v, 0, 0, r1);
        }
        function CheckboxEffect(t1, e1, r1) {
            this.p = PropertyFactory.getProp(e1, t1.v, 0, 0, r1);
        }
        function NoValueEffect() {
            this.p = {};
        }
        function EffectsManager(t1, e1) {
            var r1, i1 = t1.ef || [];
            this.effectElements = [];
            var a1, s1 = i1.length;
            for(r1 = 0; r1 < s1; r1 += 1)a1 = new GroupEffect(i1[r1], e1), this.effectElements.push(a1);
        }
        function GroupEffect(t1, e1) {
            this.init(t1, e1);
        }
        function BaseElement() {}
        function FrameElement() {}
        function FootageElement(t1, e1, r1) {
            this.initFrame(), this.initRenderable(), this.assetData = e1.getAssetData(t1.refId), this.footageData = e1.imageLoader.getAsset(this.assetData), this.initBaseData(t1, e1, r1);
        }
        function AudioElement(t1, e1, r1) {
            this.initFrame(), this.initRenderable(), this.assetData = e1.getAssetData(t1.refId), this.initBaseData(t1, e1, r1), this._isPlaying = !1, this._canPlay = !1;
            var i1 = this.globalData.getAssetsPath(this.assetData);
            this.audio = this.globalData.audioController.createAudio(i1), this._currentTime = 0, this.globalData.audioController.addAudio(this), this._volumeMultiplier = 1, this._volume = 1, this._previousVolume = null, this.tm = t1.tm ? PropertyFactory.getProp(this, t1.tm, 0, e1.frameRate, this) : {
                _placeholder: !0
            }, this.lv = PropertyFactory.getProp(this, t1.au && t1.au.lv ? t1.au.lv : {
                k: [
                    100
                ]
            }, 1, .01, this);
        }
        function BaseRenderer() {}
        function TransformElement() {}
        function MaskElement(t1, e1, r1) {
            this.data = t1, this.element = e1, this.globalData = r1, this.storedData = [], this.masksProperties = this.data.masksProperties || [], this.maskElement = null;
            var i1, a1, s1 = this.globalData.defs, n1 = this.masksProperties ? this.masksProperties.length : 0;
            this.viewData = createSizedArray(n1), this.solidPath = "";
            var o1, h1, l1, p1, f1, c1, m1 = this.masksProperties, d1 = 0, u1 = [], y1 = createElementID(), g1 = "clipPath", v1 = "clip-path";
            for(i1 = 0; i1 < n1; i1 += 1)if (("a" !== m1[i1].mode && "n" !== m1[i1].mode || m1[i1].inv || 100 !== m1[i1].o.k || m1[i1].o.x) && (g1 = "mask", v1 = "mask"), "s" !== m1[i1].mode && "i" !== m1[i1].mode || 0 !== d1 ? l1 = null : ((l1 = createNS("rect")).setAttribute("fill", "#ffffff"), l1.setAttribute("width", this.element.comp.data.w || 0), l1.setAttribute("height", this.element.comp.data.h || 0), u1.push(l1)), a1 = createNS("path"), "n" === m1[i1].mode) this.viewData[i1] = {
                op: PropertyFactory.getProp(this.element, m1[i1].o, 0, .01, this.element),
                prop: ShapePropertyFactory.getShapeProp(this.element, m1[i1], 3),
                elem: a1,
                lastPath: ""
            }, s1.appendChild(a1);
            else {
                var b1;
                if (d1 += 1, a1.setAttribute("fill", "s" === m1[i1].mode ? "#000000" : "#ffffff"), a1.setAttribute("clip-rule", "nonzero"), 0 !== m1[i1].x.k ? (g1 = "mask", v1 = "mask", c1 = PropertyFactory.getProp(this.element, m1[i1].x, 0, null, this.element), b1 = createElementID(), (p1 = createNS("filter")).setAttribute("id", b1), (f1 = createNS("feMorphology")).setAttribute("operator", "erode"), f1.setAttribute("in", "SourceGraphic"), f1.setAttribute("radius", "0"), p1.appendChild(f1), s1.appendChild(p1), a1.setAttribute("stroke", "s" === m1[i1].mode ? "#000000" : "#ffffff")) : (f1 = null, c1 = null), this.storedData[i1] = {
                    elem: a1,
                    x: c1,
                    expan: f1,
                    lastPath: "",
                    lastOperator: "",
                    filterId: b1,
                    lastRadius: 0
                }, "i" === m1[i1].mode) {
                    h1 = u1.length;
                    var x1 = createNS("g");
                    for(o1 = 0; o1 < h1; o1 += 1)x1.appendChild(u1[o1]);
                    var P1 = createNS("mask");
                    P1.setAttribute("mask-type", "alpha"), P1.setAttribute("id", y1 + "_" + d1), P1.appendChild(a1), s1.appendChild(P1), x1.setAttribute("mask", "url(" + getLocationHref() + "#" + y1 + "_" + d1 + ")"), u1.length = 0, u1.push(x1);
                } else u1.push(a1);
                m1[i1].inv && !this.solidPath && (this.solidPath = this.createLayerSolidPath()), this.viewData[i1] = {
                    elem: a1,
                    lastPath: "",
                    op: PropertyFactory.getProp(this.element, m1[i1].o, 0, .01, this.element),
                    prop: ShapePropertyFactory.getShapeProp(this.element, m1[i1], 3),
                    invRect: l1
                }, this.viewData[i1].prop.k || this.drawPath(m1[i1], this.viewData[i1].prop.v, this.viewData[i1]);
            }
            for(this.maskElement = createNS(g1), n1 = u1.length, i1 = 0; i1 < n1; i1 += 1)this.maskElement.appendChild(u1[i1]);
            d1 > 0 && (this.maskElement.setAttribute("id", y1), this.element.maskedElement.setAttribute(v1, "url(" + getLocationHref() + "#" + y1 + ")"), s1.appendChild(this.maskElement)), this.viewData.length && this.element.addRenderableComponent(this);
        }
        extendPrototype([
            DynamicPropertyContainer
        ], GroupEffect), GroupEffect.prototype.getValue = GroupEffect.prototype.iterateDynamicProperties, GroupEffect.prototype.init = function(t1, e1) {
            var r1;
            this.data = t1, this.effectElements = [], this.initDynamicPropertyContainer(e1);
            var i1, a1 = this.data.ef.length, s1 = this.data.ef;
            for(r1 = 0; r1 < a1; r1 += 1){
                switch(i1 = null, s1[r1].ty){
                    case 0:
                        i1 = new SliderEffect(s1[r1], e1, this);
                        break;
                    case 1:
                        i1 = new AngleEffect(s1[r1], e1, this);
                        break;
                    case 2:
                        i1 = new ColorEffect(s1[r1], e1, this);
                        break;
                    case 3:
                        i1 = new PointEffect(s1[r1], e1, this);
                        break;
                    case 4:
                    case 7:
                        i1 = new CheckboxEffect(s1[r1], e1, this);
                        break;
                    case 10:
                        i1 = new LayerIndexEffect(s1[r1], e1, this);
                        break;
                    case 11:
                        i1 = new MaskIndexEffect(s1[r1], e1, this);
                        break;
                    case 5:
                        i1 = new EffectsManager(s1[r1], e1, this);
                        break;
                    default:
                        i1 = new NoValueEffect(s1[r1], e1, this);
                }
                i1 && this.effectElements.push(i1);
            }
        }, BaseElement.prototype = {
            checkMasks: function() {
                if (!this.data.hasMask) return !1;
                for(var t1 = 0, e1 = this.data.masksProperties.length; t1 < e1;){
                    if ("n" !== this.data.masksProperties[t1].mode && !1 !== this.data.masksProperties[t1].cl) return !0;
                    t1 += 1;
                }
                return !1;
            },
            initExpressions: function() {
                var t1 = getExpressionInterfaces();
                if (t1) {
                    var e1 = t1("layer"), r1 = t1("effects"), i1 = t1("shape"), a1 = t1("text"), s1 = t1("comp");
                    this.layerInterface = e1(this), this.data.hasMask && this.maskManager && this.layerInterface.registerMaskInterface(this.maskManager);
                    var n1 = r1.createEffectsInterface(this, this.layerInterface);
                    this.layerInterface.registerEffectsInterface(n1), 0 === this.data.ty || this.data.xt ? this.compInterface = s1(this) : 4 === this.data.ty ? (this.layerInterface.shapeInterface = i1(this.shapesData, this.itemsData, this.layerInterface), this.layerInterface.content = this.layerInterface.shapeInterface) : 5 === this.data.ty && (this.layerInterface.textInterface = a1(this), this.layerInterface.text = this.layerInterface.textInterface);
                }
            },
            setBlendMode: function() {
                var t1 = getBlendMode(this.data.bm);
                (this.baseElement || this.layerElement).style["mix-blend-mode"] = t1;
            },
            initBaseData: function(t1, e1, r1) {
                this.globalData = e1, this.comp = r1, this.data = t1, this.layerId = createElementID(), this.data.sr || (this.data.sr = 1), this.effectsManager = new EffectsManager(this.data, this, this.dynamicProperties);
            },
            getType: function() {
                return this.type;
            },
            sourceRectAtTime: function() {}
        }, FrameElement.prototype = {
            initFrame: function() {
                this._isFirstFrame = !1, this.dynamicProperties = [], this._mdf = !1;
            },
            prepareProperties: function(t1, e1) {
                var r1, i1 = this.dynamicProperties.length;
                for(r1 = 0; r1 < i1; r1 += 1)(e1 || this._isParent && "transform" === this.dynamicProperties[r1].propType) && (this.dynamicProperties[r1].getValue(), this.dynamicProperties[r1]._mdf && (this.globalData._mdf = !0, this._mdf = !0));
            },
            addDynamicProperty: function(t1) {
                -1 === this.dynamicProperties.indexOf(t1) && this.dynamicProperties.push(t1);
            }
        }, FootageElement.prototype.prepareFrame = function() {}, extendPrototype([
            RenderableElement,
            BaseElement,
            FrameElement
        ], FootageElement), FootageElement.prototype.getBaseElement = function() {
            return null;
        }, FootageElement.prototype.renderFrame = function() {}, FootageElement.prototype.destroy = function() {}, FootageElement.prototype.initExpressions = function() {
            var t1 = getExpressionInterfaces();
            if (t1) {
                var e1 = t1("footage");
                this.layerInterface = e1(this);
            }
        }, FootageElement.prototype.getFootageData = function() {
            return this.footageData;
        }, AudioElement.prototype.prepareFrame = function(t1) {
            if (this.prepareRenderableFrame(t1, !0), this.prepareProperties(t1, !0), this.tm._placeholder) this._currentTime = t1 / this.data.sr;
            else {
                var e1 = this.tm.v;
                this._currentTime = e1;
            }
            this._volume = this.lv.v[0];
            var r1 = this._volume * this._volumeMultiplier;
            this._previousVolume !== r1 && (this._previousVolume = r1, this.audio.volume(r1));
        }, extendPrototype([
            RenderableElement,
            BaseElement,
            FrameElement
        ], AudioElement), AudioElement.prototype.renderFrame = function() {
            this.isInRange && this._canPlay && (this._isPlaying ? (!this.audio.playing() || Math.abs(this._currentTime / this.globalData.frameRate - this.audio.seek()) > .1) && this.audio.seek(this._currentTime / this.globalData.frameRate) : (this.audio.play(), this.audio.seek(this._currentTime / this.globalData.frameRate), this._isPlaying = !0));
        }, AudioElement.prototype.show = function() {}, AudioElement.prototype.hide = function() {
            this.audio.pause(), this._isPlaying = !1;
        }, AudioElement.prototype.pause = function() {
            this.audio.pause(), this._isPlaying = !1, this._canPlay = !1;
        }, AudioElement.prototype.resume = function() {
            this._canPlay = !0;
        }, AudioElement.prototype.setRate = function(t1) {
            this.audio.rate(t1);
        }, AudioElement.prototype.volume = function(t1) {
            this._volumeMultiplier = t1, this._previousVolume = t1 * this._volume, this.audio.volume(this._previousVolume);
        }, AudioElement.prototype.getBaseElement = function() {
            return null;
        }, AudioElement.prototype.destroy = function() {}, AudioElement.prototype.sourceRectAtTime = function() {}, AudioElement.prototype.initExpressions = function() {}, BaseRenderer.prototype.checkLayers = function(t1) {
            var e1, r1, i1 = this.layers.length;
            for(this.completeLayers = !0, e1 = i1 - 1; e1 >= 0; e1 -= 1)this.elements[e1] || (r1 = this.layers[e1]).ip - r1.st <= t1 - this.layers[e1].st && r1.op - r1.st > t1 - this.layers[e1].st && this.buildItem(e1), this.completeLayers = !!this.elements[e1] && this.completeLayers;
            this.checkPendingElements();
        }, BaseRenderer.prototype.createItem = function(t1) {
            switch(t1.ty){
                case 2:
                    return this.createImage(t1);
                case 0:
                    return this.createComp(t1);
                case 1:
                    return this.createSolid(t1);
                case 3:
                    return this.createNull(t1);
                case 4:
                    return this.createShape(t1);
                case 5:
                    return this.createText(t1);
                case 6:
                    return this.createAudio(t1);
                case 13:
                    return this.createCamera(t1);
                case 15:
                    return this.createFootage(t1);
                default:
                    return this.createNull(t1);
            }
        }, BaseRenderer.prototype.createCamera = function() {
            throw new Error("You're using a 3d camera. Try the html renderer.");
        }, BaseRenderer.prototype.createAudio = function(t1) {
            return new AudioElement(t1, this.globalData, this);
        }, BaseRenderer.prototype.createFootage = function(t1) {
            return new FootageElement(t1, this.globalData, this);
        }, BaseRenderer.prototype.buildAllItems = function() {
            var t1, e1 = this.layers.length;
            for(t1 = 0; t1 < e1; t1 += 1)this.buildItem(t1);
            this.checkPendingElements();
        }, BaseRenderer.prototype.includeLayers = function(t1) {
            var e1;
            this.completeLayers = !1;
            var r1, i1 = t1.length, a1 = this.layers.length;
            for(e1 = 0; e1 < i1; e1 += 1)for(r1 = 0; r1 < a1;){
                if (this.layers[r1].id === t1[e1].id) {
                    this.layers[r1] = t1[e1];
                    break;
                }
                r1 += 1;
            }
        }, BaseRenderer.prototype.setProjectInterface = function(t1) {
            this.globalData.projectInterface = t1;
        }, BaseRenderer.prototype.initItems = function() {
            this.globalData.progressiveLoad || this.buildAllItems();
        }, BaseRenderer.prototype.buildElementParenting = function(t1, e1, r1) {
            for(var i1 = this.elements, a1 = this.layers, s1 = 0, n1 = a1.length; s1 < n1;)a1[s1].ind == e1 && (i1[s1] && !0 !== i1[s1] ? (r1.push(i1[s1]), i1[s1].setAsParent(), void 0 !== a1[s1].parent ? this.buildElementParenting(t1, a1[s1].parent, r1) : t1.setHierarchy(r1)) : (this.buildItem(s1), this.addPendingElement(t1))), s1 += 1;
        }, BaseRenderer.prototype.addPendingElement = function(t1) {
            this.pendingElements.push(t1);
        }, BaseRenderer.prototype.searchExtraCompositions = function(t1) {
            var e1, r1 = t1.length;
            for(e1 = 0; e1 < r1; e1 += 1)if (t1[e1].xt) {
                var i1 = this.createComp(t1[e1]);
                i1.initExpressions(), this.globalData.projectInterface.registerComposition(i1);
            }
        }, BaseRenderer.prototype.getElementById = function(t1) {
            var e1, r1 = this.elements.length;
            for(e1 = 0; e1 < r1; e1 += 1)if (this.elements[e1].data.ind === t1) return this.elements[e1];
            return null;
        }, BaseRenderer.prototype.getElementByPath = function(t1) {
            var e1, r1 = t1.shift();
            if ("number" == typeof r1) e1 = this.elements[r1];
            else {
                var i1, a1 = this.elements.length;
                for(i1 = 0; i1 < a1; i1 += 1)if (this.elements[i1].data.nm === r1) {
                    e1 = this.elements[i1];
                    break;
                }
            }
            return 0 === t1.length ? e1 : e1.getElementByPath(t1);
        }, BaseRenderer.prototype.setupGlobalData = function(t1, e1) {
            this.globalData.fontManager = new FontManager, this.globalData.fontManager.addChars(t1.chars), this.globalData.fontManager.addFonts(t1.fonts, e1), this.globalData.getAssetData = this.animationItem.getAssetData.bind(this.animationItem), this.globalData.getAssetsPath = this.animationItem.getAssetsPath.bind(this.animationItem), this.globalData.imageLoader = this.animationItem.imagePreloader, this.globalData.audioController = this.animationItem.audioController, this.globalData.frameId = 0, this.globalData.frameRate = t1.fr, this.globalData.nm = t1.nm, this.globalData.compSize = {
                w: t1.w,
                h: t1.h
            };
        }, TransformElement.prototype = {
            initTransform: function() {
                this.finalTransform = {
                    mProp: this.data.ks ? TransformPropertyFactory.getTransformProperty(this, this.data.ks, this) : {
                        o: 0
                    },
                    _matMdf: !1,
                    _opMdf: !1,
                    mat: new Matrix
                }, this.data.ao && (this.finalTransform.mProp.autoOriented = !0), this.data.ty;
            },
            renderTransform: function() {
                if (this.finalTransform._opMdf = this.finalTransform.mProp.o._mdf || this._isFirstFrame, this.finalTransform._matMdf = this.finalTransform.mProp._mdf || this._isFirstFrame, this.hierarchy) {
                    var t1, e1 = this.finalTransform.mat, r1 = 0, i1 = this.hierarchy.length;
                    if (!this.finalTransform._matMdf) for(; r1 < i1;){
                        if (this.hierarchy[r1].finalTransform.mProp._mdf) {
                            this.finalTransform._matMdf = !0;
                            break;
                        }
                        r1 += 1;
                    }
                    if (this.finalTransform._matMdf) for(t1 = this.finalTransform.mProp.v.props, e1.cloneFromProps(t1), r1 = 0; r1 < i1; r1 += 1)t1 = this.hierarchy[r1].finalTransform.mProp.v.props, e1.transform(t1[0], t1[1], t1[2], t1[3], t1[4], t1[5], t1[6], t1[7], t1[8], t1[9], t1[10], t1[11], t1[12], t1[13], t1[14], t1[15]);
                }
            },
            globalToLocal: function(t1) {
                var e1 = [];
                e1.push(this.finalTransform);
                for(var r1, i1 = !0, a1 = this.comp; i1;)a1.finalTransform ? (a1.data.hasMask && e1.splice(0, 0, a1.finalTransform), a1 = a1.comp) : i1 = !1;
                var s1, n1 = e1.length;
                for(r1 = 0; r1 < n1; r1 += 1)s1 = e1[r1].mat.applyToPointArray(0, 0, 0), t1 = [
                    t1[0] - s1[0],
                    t1[1] - s1[1],
                    0
                ];
                return t1;
            },
            mHelper: new Matrix
        }, MaskElement.prototype.getMaskProperty = function(t1) {
            return this.viewData[t1].prop;
        }, MaskElement.prototype.renderFrame = function(t1) {
            var e1, r1 = this.element.finalTransform.mat, i1 = this.masksProperties.length;
            for(e1 = 0; e1 < i1; e1 += 1)if ((this.viewData[e1].prop._mdf || t1) && this.drawPath(this.masksProperties[e1], this.viewData[e1].prop.v, this.viewData[e1]), (this.viewData[e1].op._mdf || t1) && this.viewData[e1].elem.setAttribute("fill-opacity", this.viewData[e1].op.v), "n" !== this.masksProperties[e1].mode && (this.viewData[e1].invRect && (this.element.finalTransform.mProp._mdf || t1) && this.viewData[e1].invRect.setAttribute("transform", r1.getInverseMatrix().to2dCSS()), this.storedData[e1].x && (this.storedData[e1].x._mdf || t1))) {
                var a1 = this.storedData[e1].expan;
                this.storedData[e1].x.v < 0 ? ("erode" !== this.storedData[e1].lastOperator && (this.storedData[e1].lastOperator = "erode", this.storedData[e1].elem.setAttribute("filter", "url(" + getLocationHref() + "#" + this.storedData[e1].filterId + ")")), a1.setAttribute("radius", -this.storedData[e1].x.v)) : ("dilate" !== this.storedData[e1].lastOperator && (this.storedData[e1].lastOperator = "dilate", this.storedData[e1].elem.setAttribute("filter", null)), this.storedData[e1].elem.setAttribute("stroke-width", 2 * this.storedData[e1].x.v));
            }
        }, MaskElement.prototype.getMaskelement = function() {
            return this.maskElement;
        }, MaskElement.prototype.createLayerSolidPath = function() {
            var t1 = "M0,0 ";
            return t1 += " h" + this.globalData.compSize.w, t1 += " v" + this.globalData.compSize.h, t1 += " h-" + this.globalData.compSize.w, t1 += " v-" + this.globalData.compSize.h + " ";
        }, MaskElement.prototype.drawPath = function(t1, e1, r1) {
            var i1, a1, s1 = " M" + e1.v[0][0] + "," + e1.v[0][1];
            for(a1 = e1._length, i1 = 1; i1 < a1; i1 += 1)s1 += " C" + e1.o[i1 - 1][0] + "," + e1.o[i1 - 1][1] + " " + e1.i[i1][0] + "," + e1.i[i1][1] + " " + e1.v[i1][0] + "," + e1.v[i1][1];
            if (e1.c && a1 > 1 && (s1 += " C" + e1.o[i1 - 1][0] + "," + e1.o[i1 - 1][1] + " " + e1.i[0][0] + "," + e1.i[0][1] + " " + e1.v[0][0] + "," + e1.v[0][1]), r1.lastPath !== s1) {
                var n1 = "";
                r1.elem && (e1.c && (n1 = t1.inv ? this.solidPath + s1 : s1), r1.elem.setAttribute("d", n1)), r1.lastPath = s1;
            }
        }, MaskElement.prototype.destroy = function() {
            this.element = null, this.globalData = null, this.maskElement = null, this.data = null, this.masksProperties = null;
        };
        var filtersFactory = function() {
            var t1 = {};
            return t1.createFilter = function(t1, e1) {
                var r1 = createNS("filter");
                r1.setAttribute("id", t1), !0 !== e1 && (r1.setAttribute("filterUnits", "objectBoundingBox"), r1.setAttribute("x", "0%"), r1.setAttribute("y", "0%"), r1.setAttribute("width", "100%"), r1.setAttribute("height", "100%"));
                return r1;
            }, t1.createAlphaToLuminanceFilter = function() {
                var t1 = createNS("feColorMatrix");
                return t1.setAttribute("type", "matrix"), t1.setAttribute("color-interpolation-filters", "sRGB"), t1.setAttribute("values", "0 0 0 1 0  0 0 0 1 0  0 0 0 1 0  0 0 0 1 1"), t1;
            }, t1;
        }(), featureSupport = function() {
            var t1 = {
                maskType: !0,
                svgLumaHidden: !0,
                offscreenCanvas: "undefined" != typeof OffscreenCanvas
            };
            return (/MSIE 10/i.test(navigator.userAgent) || /MSIE 9/i.test(navigator.userAgent) || /rv:11.0/i.test(navigator.userAgent) || /Edge\/\d./i.test(navigator.userAgent)) && (t1.maskType = !1), /firefox/i.test(navigator.userAgent) && (t1.svgLumaHidden = !1), t1;
        }(), registeredEffects = {}, idPrefix = "filter_result_";
        function SVGEffects(t1) {
            var e1, r1, i1 = "SourceGraphic", a1 = t1.data.ef ? t1.data.ef.length : 0, s1 = createElementID(), n1 = filtersFactory.createFilter(s1, !0), o1 = 0;
            for(this.filters = [], e1 = 0; e1 < a1; e1 += 1){
                r1 = null;
                var h1 = t1.data.ef[e1].ty;
                if (registeredEffects[h1]) r1 = new registeredEffects[h1].effect(n1, t1.effectsManager.effectElements[e1], t1, idPrefix + o1, i1), i1 = idPrefix + o1, registeredEffects[h1].countsAsEffect && (o1 += 1);
                r1 && this.filters.push(r1);
            }
            o1 && (t1.globalData.defs.appendChild(n1), t1.layerElement.setAttribute("filter", "url(" + getLocationHref() + "#" + s1 + ")")), this.filters.length && t1.addRenderableComponent(this);
        }
        function registerEffect(t1, e1, r1) {
            registeredEffects[t1] = {
                effect: e1,
                countsAsEffect: r1
            };
        }
        function SVGBaseElement() {}
        function HierarchyElement() {}
        function RenderableDOMElement() {}
        function IImageElement(t1, e1, r1) {
            this.assetData = e1.getAssetData(t1.refId), this.initElement(t1, e1, r1), this.sourceRect = {
                top: 0,
                left: 0,
                width: this.assetData.w,
                height: this.assetData.h
            };
        }
        function ProcessedElement(t1, e1) {
            this.elem = t1, this.pos = e1;
        }
        function IShapeElement() {}
        SVGEffects.prototype.renderFrame = function(t1) {
            var e1, r1 = this.filters.length;
            for(e1 = 0; e1 < r1; e1 += 1)this.filters[e1].renderFrame(t1);
        }, SVGBaseElement.prototype = {
            initRendererElement: function() {
                this.layerElement = createNS("g");
            },
            createContainerElements: function() {
                this.matteElement = createNS("g"), this.transformedElement = this.layerElement, this.maskedElement = this.layerElement, this._sizeChanged = !1;
                var t1 = null;
                if (this.data.td) {
                    this.matteMasks = {};
                    var e1 = createNS("g");
                    e1.setAttribute("id", this.layerId), e1.appendChild(this.layerElement), t1 = e1, this.globalData.defs.appendChild(e1);
                } else this.data.tt ? (this.matteElement.appendChild(this.layerElement), t1 = this.matteElement, this.baseElement = this.matteElement) : this.baseElement = this.layerElement;
                if (this.data.ln && this.layerElement.setAttribute("id", this.data.ln), this.data.cl && this.layerElement.setAttribute("class", this.data.cl), 0 === this.data.ty && !this.data.hd) {
                    var r1 = createNS("clipPath"), i1 = createNS("path");
                    i1.setAttribute("d", "M0,0 L" + this.data.w + ",0 L" + this.data.w + "," + this.data.h + " L0," + this.data.h + "z");
                    var a1 = createElementID();
                    if (r1.setAttribute("id", a1), r1.appendChild(i1), this.globalData.defs.appendChild(r1), this.checkMasks()) {
                        var s1 = createNS("g");
                        s1.setAttribute("clip-path", "url(" + getLocationHref() + "#" + a1 + ")"), s1.appendChild(this.layerElement), this.transformedElement = s1, t1 ? t1.appendChild(this.transformedElement) : this.baseElement = this.transformedElement;
                    } else this.layerElement.setAttribute("clip-path", "url(" + getLocationHref() + "#" + a1 + ")");
                }
                0 !== this.data.bm && this.setBlendMode();
            },
            renderElement: function() {
                this.finalTransform._matMdf && this.transformedElement.setAttribute("transform", this.finalTransform.mat.to2dCSS()), this.finalTransform._opMdf && this.transformedElement.setAttribute("opacity", this.finalTransform.mProp.o.v);
            },
            destroyBaseElement: function() {
                this.layerElement = null, this.matteElement = null, this.maskManager.destroy();
            },
            getBaseElement: function() {
                return this.data.hd ? null : this.baseElement;
            },
            createRenderableComponents: function() {
                this.maskManager = new MaskElement(this.data, this, this.globalData), this.renderableEffectsManager = new SVGEffects(this);
            },
            getMatte: function(t1) {
                if (this.matteMasks || (this.matteMasks = {}), !this.matteMasks[t1]) {
                    var e1, r1, i1, a1, s1 = this.layerId + "_" + t1;
                    if (1 === t1 || 3 === t1) {
                        var n1 = createNS("mask");
                        n1.setAttribute("id", s1), n1.setAttribute("mask-type", 3 === t1 ? "luminance" : "alpha"), (i1 = createNS("use")).setAttributeNS("http://www.w3.org/1999/xlink", "href", "#" + this.layerId), n1.appendChild(i1), this.globalData.defs.appendChild(n1), featureSupport.maskType || 1 !== t1 || (n1.setAttribute("mask-type", "luminance"), e1 = createElementID(), r1 = filtersFactory.createFilter(e1), this.globalData.defs.appendChild(r1), r1.appendChild(filtersFactory.createAlphaToLuminanceFilter()), (a1 = createNS("g")).appendChild(i1), n1.appendChild(a1), a1.setAttribute("filter", "url(" + getLocationHref() + "#" + e1 + ")"));
                    } else if (2 === t1) {
                        var o1 = createNS("mask");
                        o1.setAttribute("id", s1), o1.setAttribute("mask-type", "alpha");
                        var h1 = createNS("g");
                        o1.appendChild(h1), e1 = createElementID(), r1 = filtersFactory.createFilter(e1);
                        var l1 = createNS("feComponentTransfer");
                        l1.setAttribute("in", "SourceGraphic"), r1.appendChild(l1);
                        var p1 = createNS("feFuncA");
                        p1.setAttribute("type", "table"), p1.setAttribute("tableValues", "1.0 0.0"), l1.appendChild(p1), this.globalData.defs.appendChild(r1);
                        var f1 = createNS("rect");
                        f1.setAttribute("width", this.comp.data.w), f1.setAttribute("height", this.comp.data.h), f1.setAttribute("x", "0"), f1.setAttribute("y", "0"), f1.setAttribute("fill", "#ffffff"), f1.setAttribute("opacity", "0"), h1.setAttribute("filter", "url(" + getLocationHref() + "#" + e1 + ")"), h1.appendChild(f1), (i1 = createNS("use")).setAttributeNS("http://www.w3.org/1999/xlink", "href", "#" + this.layerId), h1.appendChild(i1), featureSupport.maskType || (o1.setAttribute("mask-type", "luminance"), r1.appendChild(filtersFactory.createAlphaToLuminanceFilter()), a1 = createNS("g"), h1.appendChild(f1), a1.appendChild(this.layerElement), h1.appendChild(a1)), this.globalData.defs.appendChild(o1);
                    }
                    this.matteMasks[t1] = s1;
                }
                return this.matteMasks[t1];
            },
            setMatte: function(t1) {
                this.matteElement && this.matteElement.setAttribute("mask", "url(" + getLocationHref() + "#" + t1 + ")");
            }
        }, HierarchyElement.prototype = {
            initHierarchy: function() {
                this.hierarchy = [], this._isParent = !1, this.checkParenting();
            },
            setHierarchy: function(t1) {
                this.hierarchy = t1;
            },
            setAsParent: function() {
                this._isParent = !0;
            },
            checkParenting: function() {
                void 0 !== this.data.parent && this.comp.buildElementParenting(this, this.data.parent, []);
            }
        }, extendPrototype([
            RenderableElement,
            createProxyFunction({
                initElement: function(t1, e1, r1) {
                    this.initFrame(), this.initBaseData(t1, e1, r1), this.initTransform(t1, e1, r1), this.initHierarchy(), this.initRenderable(), this.initRendererElement(), this.createContainerElements(), this.createRenderableComponents(), this.createContent(), this.hide();
                },
                hide: function() {
                    this.hidden || this.isInRange && !this.isTransparent || ((this.baseElement || this.layerElement).style.display = "none", this.hidden = !0);
                },
                show: function() {
                    this.isInRange && !this.isTransparent && (this.data.hd || ((this.baseElement || this.layerElement).style.display = "block"), this.hidden = !1, this._isFirstFrame = !0);
                },
                renderFrame: function() {
                    this.data.hd || this.hidden || (this.renderTransform(), this.renderRenderable(), this.renderElement(), this.renderInnerContent(), this._isFirstFrame && (this._isFirstFrame = !1));
                },
                renderInnerContent: function() {},
                prepareFrame: function(t1) {
                    this._mdf = !1, this.prepareRenderableFrame(t1), this.prepareProperties(t1, this.isInRange), this.checkTransparency();
                },
                destroy: function() {
                    this.innerElem = null, this.destroyBaseElement();
                }
            })
        ], RenderableDOMElement), extendPrototype([
            BaseElement,
            TransformElement,
            SVGBaseElement,
            HierarchyElement,
            FrameElement,
            RenderableDOMElement
        ], IImageElement), IImageElement.prototype.createContent = function() {
            var t1 = this.globalData.getAssetsPath(this.assetData);
            this.innerElem = createNS("image"), this.innerElem.setAttribute("width", this.assetData.w + "px"), this.innerElem.setAttribute("height", this.assetData.h + "px"), this.innerElem.setAttribute("preserveAspectRatio", this.assetData.pr || this.globalData.renderConfig.imagePreserveAspectRatio), this.innerElem.setAttributeNS("http://www.w3.org/1999/xlink", "href", t1), this.layerElement.appendChild(this.innerElem);
        }, IImageElement.prototype.sourceRectAtTime = function() {
            return this.sourceRect;
        }, IShapeElement.prototype = {
            addShapeToModifiers: function(t1) {
                var e1, r1 = this.shapeModifiers.length;
                for(e1 = 0; e1 < r1; e1 += 1)this.shapeModifiers[e1].addShape(t1);
            },
            isShapeInAnimatedModifiers: function(t1) {
                for(var e1 = this.shapeModifiers.length; 0 < e1;)if (this.shapeModifiers[0].isAnimatedWithShape(t1)) return !0;
                return !1;
            },
            renderModifiers: function() {
                if (this.shapeModifiers.length) {
                    var t1, e1 = this.shapes.length;
                    for(t1 = 0; t1 < e1; t1 += 1)this.shapes[t1].sh.reset();
                    for(t1 = (e1 = this.shapeModifiers.length) - 1; t1 >= 0 && !this.shapeModifiers[t1].processShapes(this._isFirstFrame); t1 -= 1);
                }
            },
            searchProcessedElement: function(t1) {
                for(var e1 = this.processedElements, r1 = 0, i1 = e1.length; r1 < i1;){
                    if (e1[r1].elem === t1) return e1[r1].pos;
                    r1 += 1;
                }
                return 0;
            },
            addProcessedElement: function(t1, e1) {
                for(var r1 = this.processedElements, i1 = r1.length; i1;)if (r1[i1 -= 1].elem === t1) return void (r1[i1].pos = e1);
                r1.push(new ProcessedElement(t1, e1));
            },
            prepareFrame: function(t1) {
                this.prepareRenderableFrame(t1), this.prepareProperties(t1, this.isInRange);
            }
        };
        var lineCapEnum = {
            1: "butt",
            2: "round",
            3: "square"
        }, lineJoinEnum = {
            1: "miter",
            2: "round",
            3: "bevel"
        };
        function SVGShapeData(t1, e1, r1) {
            this.caches = [], this.styles = [], this.transformers = t1, this.lStr = "", this.sh = r1, this.lvl = e1, this._isAnimated = !!r1.k;
            for(var i1 = 0, a1 = t1.length; i1 < a1;){
                if (t1[i1].mProps.dynamicProperties.length) {
                    this._isAnimated = !0;
                    break;
                }
                i1 += 1;
            }
        }
        function SVGStyleData(t1, e1) {
            this.data = t1, this.type = t1.ty, this.d = "", this.lvl = e1, this._mdf = !1, this.closed = !0 === t1.hd, this.pElem = createNS("path"), this.msElem = null;
        }
        function DashProperty(t1, e1, r1, i1) {
            var a1;
            this.elem = t1, this.frameId = -1, this.dataProps = createSizedArray(e1.length), this.renderer = r1, this.k = !1, this.dashStr = "", this.dashArray = createTypedArray("float32", e1.length ? e1.length - 1 : 0), this.dashoffset = createTypedArray("float32", 1), this.initDynamicPropertyContainer(i1);
            var s1, n1 = e1.length || 0;
            for(a1 = 0; a1 < n1; a1 += 1)s1 = PropertyFactory.getProp(t1, e1[a1].v, 0, 0, this), this.k = s1.k || this.k, this.dataProps[a1] = {
                n: e1[a1].n,
                p: s1
            };
            this.k || this.getValue(!0), this._isAnimated = this.k;
        }
        function SVGStrokeStyleData(t1, e1, r1) {
            this.initDynamicPropertyContainer(t1), this.getValue = this.iterateDynamicProperties, this.o = PropertyFactory.getProp(t1, e1.o, 0, .01, this), this.w = PropertyFactory.getProp(t1, e1.w, 0, null, this), this.d = new DashProperty(t1, e1.d || {}, "svg", this), this.c = PropertyFactory.getProp(t1, e1.c, 1, 255, this), this.style = r1, this._isAnimated = !!this._isAnimated;
        }
        function SVGFillStyleData(t1, e1, r1) {
            this.initDynamicPropertyContainer(t1), this.getValue = this.iterateDynamicProperties, this.o = PropertyFactory.getProp(t1, e1.o, 0, .01, this), this.c = PropertyFactory.getProp(t1, e1.c, 1, 255, this), this.style = r1;
        }
        function SVGNoStyleData(t1, e1, r1) {
            this.initDynamicPropertyContainer(t1), this.getValue = this.iterateDynamicProperties, this.style = r1;
        }
        function GradientProperty(t1, e1, r1) {
            this.data = e1, this.c = createTypedArray("uint8c", 4 * e1.p);
            var i1 = e1.k.k[0].s ? e1.k.k[0].s.length - 4 * e1.p : e1.k.k.length - 4 * e1.p;
            this.o = createTypedArray("float32", i1), this._cmdf = !1, this._omdf = !1, this._collapsable = this.checkCollapsable(), this._hasOpacity = i1, this.initDynamicPropertyContainer(r1), this.prop = PropertyFactory.getProp(t1, e1.k, 1, null, this), this.k = this.prop.k, this.getValue(!0);
        }
        function SVGGradientFillStyleData(t1, e1, r1) {
            this.initDynamicPropertyContainer(t1), this.getValue = this.iterateDynamicProperties, this.initGradientData(t1, e1, r1);
        }
        function SVGGradientStrokeStyleData(t1, e1, r1) {
            this.initDynamicPropertyContainer(t1), this.getValue = this.iterateDynamicProperties, this.w = PropertyFactory.getProp(t1, e1.w, 0, null, this), this.d = new DashProperty(t1, e1.d || {}, "svg", this), this.initGradientData(t1, e1, r1), this._isAnimated = !!this._isAnimated;
        }
        function ShapeGroupData() {
            this.it = [], this.prevViewData = [], this.gr = createNS("g");
        }
        function SVGTransformData(t1, e1, r1) {
            this.transform = {
                mProps: t1,
                op: e1,
                container: r1
            }, this.elements = [], this._isAnimated = this.transform.mProps.dynamicProperties.length || this.transform.op.effectsSequence.length;
        }
        SVGShapeData.prototype.setAsAnimated = function() {
            this._isAnimated = !0;
        }, SVGStyleData.prototype.reset = function() {
            this.d = "", this._mdf = !1;
        }, DashProperty.prototype.getValue = function(t1) {
            if ((this.elem.globalData.frameId !== this.frameId || t1) && (this.frameId = this.elem.globalData.frameId, this.iterateDynamicProperties(), this._mdf = this._mdf || t1, this._mdf)) {
                var e1 = 0, r1 = this.dataProps.length;
                for("svg" === this.renderer && (this.dashStr = ""), e1 = 0; e1 < r1; e1 += 1)"o" !== this.dataProps[e1].n ? "svg" === this.renderer ? this.dashStr += " " + this.dataProps[e1].p.v : this.dashArray[e1] = this.dataProps[e1].p.v : this.dashoffset[0] = this.dataProps[e1].p.v;
            }
        }, extendPrototype([
            DynamicPropertyContainer
        ], DashProperty), extendPrototype([
            DynamicPropertyContainer
        ], SVGStrokeStyleData), extendPrototype([
            DynamicPropertyContainer
        ], SVGFillStyleData), extendPrototype([
            DynamicPropertyContainer
        ], SVGNoStyleData), GradientProperty.prototype.comparePoints = function(t1, e1) {
            for(var r1 = 0, i1 = this.o.length / 2; r1 < i1;){
                if (Math.abs(t1[4 * r1] - t1[4 * e1 + 2 * r1]) > .01) return !1;
                r1 += 1;
            }
            return !0;
        }, GradientProperty.prototype.checkCollapsable = function() {
            if (this.o.length / 2 != this.c.length / 4) return !1;
            if (this.data.k.k[0].s) for(var t1 = 0, e1 = this.data.k.k.length; t1 < e1;){
                if (!this.comparePoints(this.data.k.k[t1].s, this.data.p)) return !1;
                t1 += 1;
            }
            else if (!this.comparePoints(this.data.k.k, this.data.p)) return !1;
            return !0;
        }, GradientProperty.prototype.getValue = function(t1) {
            if (this.prop.getValue(), this._mdf = !1, this._cmdf = !1, this._omdf = !1, this.prop._mdf || t1) {
                var e1, r1, i1, a1 = 4 * this.data.p;
                for(e1 = 0; e1 < a1; e1 += 1)r1 = e1 % 4 == 0 ? 100 : 255, i1 = Math.round(this.prop.v[e1] * r1), this.c[e1] !== i1 && (this.c[e1] = i1, this._cmdf = !t1);
                if (this.o.length) for(a1 = this.prop.v.length, e1 = 4 * this.data.p; e1 < a1; e1 += 1)r1 = e1 % 2 == 0 ? 100 : 1, i1 = e1 % 2 == 0 ? Math.round(100 * this.prop.v[e1]) : this.prop.v[e1], this.o[e1 - 4 * this.data.p] !== i1 && (this.o[e1 - 4 * this.data.p] = i1, this._omdf = !t1);
                this._mdf = !t1;
            }
        }, extendPrototype([
            DynamicPropertyContainer
        ], GradientProperty), SVGGradientFillStyleData.prototype.initGradientData = function(t1, e1, r1) {
            this.o = PropertyFactory.getProp(t1, e1.o, 0, .01, this), this.s = PropertyFactory.getProp(t1, e1.s, 1, null, this), this.e = PropertyFactory.getProp(t1, e1.e, 1, null, this), this.h = PropertyFactory.getProp(t1, e1.h || {
                k: 0
            }, 0, .01, this), this.a = PropertyFactory.getProp(t1, e1.a || {
                k: 0
            }, 0, degToRads, this), this.g = new GradientProperty(t1, e1.g, this), this.style = r1, this.stops = [], this.setGradientData(r1.pElem, e1), this.setGradientOpacity(e1, r1), this._isAnimated = !!this._isAnimated;
        }, SVGGradientFillStyleData.prototype.setGradientData = function(t1, e1) {
            var r1 = createElementID(), i1 = createNS(1 === e1.t ? "linearGradient" : "radialGradient");
            i1.setAttribute("id", r1), i1.setAttribute("spreadMethod", "pad"), i1.setAttribute("gradientUnits", "userSpaceOnUse");
            var a1, s1, n1, o1 = [];
            for(n1 = 4 * e1.g.p, s1 = 0; s1 < n1; s1 += 4)a1 = createNS("stop"), i1.appendChild(a1), o1.push(a1);
            t1.setAttribute("gf" === e1.ty ? "fill" : "stroke", "url(" + getLocationHref() + "#" + r1 + ")"), this.gf = i1, this.cst = o1;
        }, SVGGradientFillStyleData.prototype.setGradientOpacity = function(t1, e1) {
            if (this.g._hasOpacity && !this.g._collapsable) {
                var r1, i1, a1, s1 = createNS("mask"), n1 = createNS("path");
                s1.appendChild(n1);
                var o1 = createElementID(), h1 = createElementID();
                s1.setAttribute("id", h1);
                var l1 = createNS(1 === t1.t ? "linearGradient" : "radialGradient");
                l1.setAttribute("id", o1), l1.setAttribute("spreadMethod", "pad"), l1.setAttribute("gradientUnits", "userSpaceOnUse"), a1 = t1.g.k.k[0].s ? t1.g.k.k[0].s.length : t1.g.k.k.length;
                var p1 = this.stops;
                for(i1 = 4 * t1.g.p; i1 < a1; i1 += 2)(r1 = createNS("stop")).setAttribute("stop-color", "rgb(255,255,255)"), l1.appendChild(r1), p1.push(r1);
                n1.setAttribute("gf" === t1.ty ? "fill" : "stroke", "url(" + getLocationHref() + "#" + o1 + ")"), "gs" === t1.ty && (n1.setAttribute("stroke-linecap", lineCapEnum[t1.lc || 2]), n1.setAttribute("stroke-linejoin", lineJoinEnum[t1.lj || 2]), 1 === t1.lj && n1.setAttribute("stroke-miterlimit", t1.ml)), this.of = l1, this.ms = s1, this.ost = p1, this.maskId = h1, e1.msElem = n1;
            }
        }, extendPrototype([
            DynamicPropertyContainer
        ], SVGGradientFillStyleData), extendPrototype([
            SVGGradientFillStyleData,
            DynamicPropertyContainer
        ], SVGGradientStrokeStyleData);
        var buildShapeString = function(t1, e1, r1, i1) {
            if (0 === e1) return "";
            var a1, s1 = t1.o, n1 = t1.i, o1 = t1.v, h1 = " M" + i1.applyToPointStringified(o1[0][0], o1[0][1]);
            for(a1 = 1; a1 < e1; a1 += 1)h1 += " C" + i1.applyToPointStringified(s1[a1 - 1][0], s1[a1 - 1][1]) + " " + i1.applyToPointStringified(n1[a1][0], n1[a1][1]) + " " + i1.applyToPointStringified(o1[a1][0], o1[a1][1]);
            return r1 && e1 && (h1 += " C" + i1.applyToPointStringified(s1[a1 - 1][0], s1[a1 - 1][1]) + " " + i1.applyToPointStringified(n1[0][0], n1[0][1]) + " " + i1.applyToPointStringified(o1[0][0], o1[0][1]), h1 += "z"), h1;
        }, SVGElementsRenderer = function() {
            var t1 = new Matrix, e1 = new Matrix;
            function r1(t1, e1, r1) {
                (r1 || e1.transform.op._mdf) && e1.transform.container.setAttribute("opacity", e1.transform.op.v), (r1 || e1.transform.mProps._mdf) && e1.transform.container.setAttribute("transform", e1.transform.mProps.v.to2dCSS());
            }
            function i1() {}
            function a1(r1, i1, a1) {
                var s1, n1, o1, h1, l1, p1, f1, c1, m1, d1, u1, y1 = i1.styles.length, g1 = i1.lvl;
                for(p1 = 0; p1 < y1; p1 += 1){
                    if (h1 = i1.sh._mdf || a1, i1.styles[p1].lvl < g1) {
                        for(c1 = e1.reset(), d1 = g1 - i1.styles[p1].lvl, u1 = i1.transformers.length - 1; !h1 && d1 > 0;)h1 = i1.transformers[u1].mProps._mdf || h1, d1 -= 1, u1 -= 1;
                        if (h1) for(d1 = g1 - i1.styles[p1].lvl, u1 = i1.transformers.length - 1; d1 > 0;)m1 = i1.transformers[u1].mProps.v.props, c1.transform(m1[0], m1[1], m1[2], m1[3], m1[4], m1[5], m1[6], m1[7], m1[8], m1[9], m1[10], m1[11], m1[12], m1[13], m1[14], m1[15]), d1 -= 1, u1 -= 1;
                    } else c1 = t1;
                    if (n1 = (f1 = i1.sh.paths)._length, h1) {
                        for(o1 = "", s1 = 0; s1 < n1; s1 += 1)(l1 = f1.shapes[s1]) && l1._length && (o1 += buildShapeString(l1, l1._length, l1.c, c1));
                        i1.caches[p1] = o1;
                    } else o1 = i1.caches[p1];
                    i1.styles[p1].d += !0 === r1.hd ? "" : o1, i1.styles[p1]._mdf = h1 || i1.styles[p1]._mdf;
                }
            }
            function s1(t1, e1, r1) {
                var i1 = e1.style;
                (e1.c._mdf || r1) && i1.pElem.setAttribute("fill", "rgb(" + bmFloor(e1.c.v[0]) + "," + bmFloor(e1.c.v[1]) + "," + bmFloor(e1.c.v[2]) + ")"), (e1.o._mdf || r1) && i1.pElem.setAttribute("fill-opacity", e1.o.v);
            }
            function n1(t1, e1, r1) {
                o1(t1, e1, r1), h1(t1, e1, r1);
            }
            function o1(t1, e1, r1) {
                var i1, a1, s1, n1, o1, h1 = e1.gf, l1 = e1.g._hasOpacity, p1 = e1.s.v, f1 = e1.e.v;
                if (e1.o._mdf || r1) {
                    var c1 = "gf" === t1.ty ? "fill-opacity" : "stroke-opacity";
                    e1.style.pElem.setAttribute(c1, e1.o.v);
                }
                if (e1.s._mdf || r1) {
                    var m1 = 1 === t1.t ? "x1" : "cx", d1 = "x1" === m1 ? "y1" : "cy";
                    h1.setAttribute(m1, p1[0]), h1.setAttribute(d1, p1[1]), l1 && !e1.g._collapsable && (e1.of.setAttribute(m1, p1[0]), e1.of.setAttribute(d1, p1[1]));
                }
                if (e1.g._cmdf || r1) {
                    i1 = e1.cst;
                    var u1 = e1.g.c;
                    for(s1 = i1.length, a1 = 0; a1 < s1; a1 += 1)(n1 = i1[a1]).setAttribute("offset", u1[4 * a1] + "%"), n1.setAttribute("stop-color", "rgb(" + u1[4 * a1 + 1] + "," + u1[4 * a1 + 2] + "," + u1[4 * a1 + 3] + ")");
                }
                if (l1 && (e1.g._omdf || r1)) {
                    var y1 = e1.g.o;
                    for(s1 = (i1 = e1.g._collapsable ? e1.cst : e1.ost).length, a1 = 0; a1 < s1; a1 += 1)n1 = i1[a1], e1.g._collapsable || n1.setAttribute("offset", y1[2 * a1] + "%"), n1.setAttribute("stop-opacity", y1[2 * a1 + 1]);
                }
                if (1 === t1.t) (e1.e._mdf || r1) && (h1.setAttribute("x2", f1[0]), h1.setAttribute("y2", f1[1]), l1 && !e1.g._collapsable && (e1.of.setAttribute("x2", f1[0]), e1.of.setAttribute("y2", f1[1])));
                else if ((e1.s._mdf || e1.e._mdf || r1) && (o1 = Math.sqrt(Math.pow(p1[0] - f1[0], 2) + Math.pow(p1[1] - f1[1], 2)), h1.setAttribute("r", o1), l1 && !e1.g._collapsable && e1.of.setAttribute("r", o1)), e1.e._mdf || e1.h._mdf || e1.a._mdf || r1) {
                    o1 || (o1 = Math.sqrt(Math.pow(p1[0] - f1[0], 2) + Math.pow(p1[1] - f1[1], 2)));
                    var g1 = Math.atan2(f1[1] - p1[1], f1[0] - p1[0]), v1 = e1.h.v;
                    v1 >= 1 ? v1 = .99 : v1 <= -1 && (v1 = -0.99);
                    var b1 = o1 * v1, x1 = Math.cos(g1 + e1.a.v) * b1 + p1[0], P1 = Math.sin(g1 + e1.a.v) * b1 + p1[1];
                    h1.setAttribute("fx", x1), h1.setAttribute("fy", P1), l1 && !e1.g._collapsable && (e1.of.setAttribute("fx", x1), e1.of.setAttribute("fy", P1));
                }
            }
            function h1(t1, e1, r1) {
                var i1 = e1.style, a1 = e1.d;
                a1 && (a1._mdf || r1) && a1.dashStr && (i1.pElem.setAttribute("stroke-dasharray", a1.dashStr), i1.pElem.setAttribute("stroke-dashoffset", a1.dashoffset[0])), e1.c && (e1.c._mdf || r1) && i1.pElem.setAttribute("stroke", "rgb(" + bmFloor(e1.c.v[0]) + "," + bmFloor(e1.c.v[1]) + "," + bmFloor(e1.c.v[2]) + ")"), (e1.o._mdf || r1) && i1.pElem.setAttribute("stroke-opacity", e1.o.v), (e1.w._mdf || r1) && (i1.pElem.setAttribute("stroke-width", e1.w.v), i1.msElem && i1.msElem.setAttribute("stroke-width", e1.w.v));
            }
            return {
                createRenderFunction: function(t1) {
                    switch(t1.ty){
                        case "fl":
                            return s1;
                        case "gf":
                            return o1;
                        case "gs":
                            return n1;
                        case "st":
                            return h1;
                        case "sh":
                        case "el":
                        case "rc":
                        case "sr":
                            return a1;
                        case "tr":
                            return r1;
                        case "no":
                            return i1;
                        default:
                            return null;
                    }
                }
            };
        }();
        function SVGShapeElement(t1, e1, r1) {
            this.shapes = [], this.shapesData = t1.shapes, this.stylesList = [], this.shapeModifiers = [], this.itemsData = [], this.processedElements = [], this.animatedContents = [], this.initElement(t1, e1, r1), this.prevViewData = [];
        }
        function LetterProps(t1, e1, r1, i1, a1, s1) {
            this.o = t1, this.sw = e1, this.sc = r1, this.fc = i1, this.m = a1, this.p = s1, this._mdf = {
                o: !0,
                sw: !!e1,
                sc: !!r1,
                fc: !!i1,
                m: !0,
                p: !0
            };
        }
        function TextProperty(t1, e1) {
            this._frameId = initialDefaultFrame, this.pv = "", this.v = "", this.kf = !1, this._isFirstFrame = !0, this._mdf = !1, this.data = e1, this.elem = t1, this.comp = this.elem.comp, this.keysIndex = 0, this.canResize = !1, this.minimumFontSize = 1, this.effectsSequence = [], this.currentData = {
                ascent: 0,
                boxWidth: this.defaultBoxWidth,
                f: "",
                fStyle: "",
                fWeight: "",
                fc: "",
                j: "",
                justifyOffset: "",
                l: [],
                lh: 0,
                lineWidths: [],
                ls: "",
                of: "",
                s: "",
                sc: "",
                sw: 0,
                t: 0,
                tr: 0,
                sz: 0,
                ps: null,
                fillColorAnim: !1,
                strokeColorAnim: !1,
                strokeWidthAnim: !1,
                yOffset: 0,
                finalSize: 0,
                finalText: [],
                finalLineHeight: 0,
                __complete: !1
            }, this.copyData(this.currentData, this.data.d.k[0].s), this.searchProperty() || this.completeTextData(this.currentData);
        }
        extendPrototype([
            BaseElement,
            TransformElement,
            SVGBaseElement,
            IShapeElement,
            HierarchyElement,
            FrameElement,
            RenderableDOMElement
        ], SVGShapeElement), SVGShapeElement.prototype.initSecondaryElement = function() {}, SVGShapeElement.prototype.identityMatrix = new Matrix, SVGShapeElement.prototype.buildExpressionInterface = function() {}, SVGShapeElement.prototype.createContent = function() {
            this.searchShapes(this.shapesData, this.itemsData, this.prevViewData, this.layerElement, 0, [], !0), this.filterUniqueShapes();
        }, SVGShapeElement.prototype.filterUniqueShapes = function() {
            var t1, e1, r1, i1, a1 = this.shapes.length, s1 = this.stylesList.length, n1 = [], o1 = !1;
            for(r1 = 0; r1 < s1; r1 += 1){
                for(i1 = this.stylesList[r1], o1 = !1, n1.length = 0, t1 = 0; t1 < a1; t1 += 1)-1 !== (e1 = this.shapes[t1]).styles.indexOf(i1) && (n1.push(e1), o1 = e1._isAnimated || o1);
                n1.length > 1 && o1 && this.setShapesAsAnimated(n1);
            }
        }, SVGShapeElement.prototype.setShapesAsAnimated = function(t1) {
            var e1, r1 = t1.length;
            for(e1 = 0; e1 < r1; e1 += 1)t1[e1].setAsAnimated();
        }, SVGShapeElement.prototype.createStyleElement = function(t1, e1) {
            var r1, i1 = new SVGStyleData(t1, e1), a1 = i1.pElem;
            if ("st" === t1.ty) r1 = new SVGStrokeStyleData(this, t1, i1);
            else if ("fl" === t1.ty) r1 = new SVGFillStyleData(this, t1, i1);
            else if ("gf" === t1.ty || "gs" === t1.ty) r1 = new ("gf" === t1.ty ? SVGGradientFillStyleData : SVGGradientStrokeStyleData)(this, t1, i1), this.globalData.defs.appendChild(r1.gf), r1.maskId && (this.globalData.defs.appendChild(r1.ms), this.globalData.defs.appendChild(r1.of), a1.setAttribute("mask", "url(" + getLocationHref() + "#" + r1.maskId + ")"));
            else "no" === t1.ty && (r1 = new SVGNoStyleData(this, t1, i1));
            return "st" !== t1.ty && "gs" !== t1.ty || (a1.setAttribute("stroke-linecap", lineCapEnum[t1.lc || 2]), a1.setAttribute("stroke-linejoin", lineJoinEnum[t1.lj || 2]), a1.setAttribute("fill-opacity", "0"), 1 === t1.lj && a1.setAttribute("stroke-miterlimit", t1.ml)), 2 === t1.r && a1.setAttribute("fill-rule", "evenodd"), t1.ln && a1.setAttribute("id", t1.ln), t1.cl && a1.setAttribute("class", t1.cl), t1.bm && (a1.style["mix-blend-mode"] = getBlendMode(t1.bm)), this.stylesList.push(i1), this.addToAnimatedContents(t1, r1), r1;
        }, SVGShapeElement.prototype.createGroupElement = function(t1) {
            var e1 = new ShapeGroupData;
            return t1.ln && e1.gr.setAttribute("id", t1.ln), t1.cl && e1.gr.setAttribute("class", t1.cl), t1.bm && (e1.gr.style["mix-blend-mode"] = getBlendMode(t1.bm)), e1;
        }, SVGShapeElement.prototype.createTransformElement = function(t1, e1) {
            var r1 = TransformPropertyFactory.getTransformProperty(this, t1, this), i1 = new SVGTransformData(r1, r1.o, e1);
            return this.addToAnimatedContents(t1, i1), i1;
        }, SVGShapeElement.prototype.createShapeElement = function(t1, e1, r1) {
            var i1 = 4;
            "rc" === t1.ty ? i1 = 5 : "el" === t1.ty ? i1 = 6 : "sr" === t1.ty && (i1 = 7);
            var a1 = new SVGShapeData(e1, r1, ShapePropertyFactory.getShapeProp(this, t1, i1, this));
            return this.shapes.push(a1), this.addShapeToModifiers(a1), this.addToAnimatedContents(t1, a1), a1;
        }, SVGShapeElement.prototype.addToAnimatedContents = function(t1, e1) {
            for(var r1 = 0, i1 = this.animatedContents.length; r1 < i1;){
                if (this.animatedContents[r1].element === e1) return;
                r1 += 1;
            }
            this.animatedContents.push({
                fn: SVGElementsRenderer.createRenderFunction(t1),
                element: e1,
                data: t1
            });
        }, SVGShapeElement.prototype.setElementStyles = function(t1) {
            var e1, r1 = t1.styles, i1 = this.stylesList.length;
            for(e1 = 0; e1 < i1; e1 += 1)this.stylesList[e1].closed || r1.push(this.stylesList[e1]);
        }, SVGShapeElement.prototype.reloadShapes = function() {
            var t1;
            this._isFirstFrame = !0;
            var e1 = this.itemsData.length;
            for(t1 = 0; t1 < e1; t1 += 1)this.prevViewData[t1] = this.itemsData[t1];
            for(this.searchShapes(this.shapesData, this.itemsData, this.prevViewData, this.layerElement, 0, [], !0), this.filterUniqueShapes(), e1 = this.dynamicProperties.length, t1 = 0; t1 < e1; t1 += 1)this.dynamicProperties[t1].getValue();
            this.renderModifiers();
        }, SVGShapeElement.prototype.searchShapes = function(t1, e1, r1, i1, a1, s1, n1) {
            var o1, h1, l1, p1, f1, c1, m1 = [].concat(s1), d1 = t1.length - 1, u1 = [], y1 = [];
            for(o1 = d1; o1 >= 0; o1 -= 1){
                if ((c1 = this.searchProcessedElement(t1[o1])) ? e1[o1] = r1[c1 - 1] : t1[o1]._render = n1, "fl" === t1[o1].ty || "st" === t1[o1].ty || "gf" === t1[o1].ty || "gs" === t1[o1].ty || "no" === t1[o1].ty) c1 ? e1[o1].style.closed = !1 : e1[o1] = this.createStyleElement(t1[o1], a1), t1[o1]._render && e1[o1].style.pElem.parentNode !== i1 && i1.appendChild(e1[o1].style.pElem), u1.push(e1[o1].style);
                else if ("gr" === t1[o1].ty) {
                    if (c1) for(l1 = e1[o1].it.length, h1 = 0; h1 < l1; h1 += 1)e1[o1].prevViewData[h1] = e1[o1].it[h1];
                    else e1[o1] = this.createGroupElement(t1[o1]);
                    this.searchShapes(t1[o1].it, e1[o1].it, e1[o1].prevViewData, e1[o1].gr, a1 + 1, m1, n1), t1[o1]._render && e1[o1].gr.parentNode !== i1 && i1.appendChild(e1[o1].gr);
                } else "tr" === t1[o1].ty ? (c1 || (e1[o1] = this.createTransformElement(t1[o1], i1)), p1 = e1[o1].transform, m1.push(p1)) : "sh" === t1[o1].ty || "rc" === t1[o1].ty || "el" === t1[o1].ty || "sr" === t1[o1].ty ? (c1 || (e1[o1] = this.createShapeElement(t1[o1], m1, a1)), this.setElementStyles(e1[o1])) : "tm" === t1[o1].ty || "rd" === t1[o1].ty || "ms" === t1[o1].ty || "pb" === t1[o1].ty || "zz" === t1[o1].ty || "op" === t1[o1].ty ? (c1 ? (f1 = e1[o1]).closed = !1 : ((f1 = ShapeModifiers.getModifier(t1[o1].ty)).init(this, t1[o1]), e1[o1] = f1, this.shapeModifiers.push(f1)), y1.push(f1)) : "rp" === t1[o1].ty && (c1 ? (f1 = e1[o1]).closed = !0 : (f1 = ShapeModifiers.getModifier(t1[o1].ty), e1[o1] = f1, f1.init(this, t1, o1, e1), this.shapeModifiers.push(f1), n1 = !1), y1.push(f1));
                this.addProcessedElement(t1[o1], o1 + 1);
            }
            for(d1 = u1.length, o1 = 0; o1 < d1; o1 += 1)u1[o1].closed = !0;
            for(d1 = y1.length, o1 = 0; o1 < d1; o1 += 1)y1[o1].closed = !0;
        }, SVGShapeElement.prototype.renderInnerContent = function() {
            var t1;
            this.renderModifiers();
            var e1 = this.stylesList.length;
            for(t1 = 0; t1 < e1; t1 += 1)this.stylesList[t1].reset();
            for(this.renderShape(), t1 = 0; t1 < e1; t1 += 1)(this.stylesList[t1]._mdf || this._isFirstFrame) && (this.stylesList[t1].msElem && (this.stylesList[t1].msElem.setAttribute("d", this.stylesList[t1].d), this.stylesList[t1].d = "M0 0" + this.stylesList[t1].d), this.stylesList[t1].pElem.setAttribute("d", this.stylesList[t1].d || "M0 0"));
        }, SVGShapeElement.prototype.renderShape = function() {
            var t1, e1, r1 = this.animatedContents.length;
            for(t1 = 0; t1 < r1; t1 += 1)e1 = this.animatedContents[t1], (this._isFirstFrame || e1.element._isAnimated) && !0 !== e1.data && e1.fn(e1.data, e1.element, this._isFirstFrame);
        }, SVGShapeElement.prototype.destroy = function() {
            this.destroyBaseElement(), this.shapesData = null, this.itemsData = null;
        }, LetterProps.prototype.update = function(t1, e1, r1, i1, a1, s1) {
            this._mdf.o = !1, this._mdf.sw = !1, this._mdf.sc = !1, this._mdf.fc = !1, this._mdf.m = !1, this._mdf.p = !1;
            var n1 = !1;
            return this.o !== t1 && (this.o = t1, this._mdf.o = !0, n1 = !0), this.sw !== e1 && (this.sw = e1, this._mdf.sw = !0, n1 = !0), this.sc !== r1 && (this.sc = r1, this._mdf.sc = !0, n1 = !0), this.fc !== i1 && (this.fc = i1, this._mdf.fc = !0, n1 = !0), this.m !== a1 && (this.m = a1, this._mdf.m = !0, n1 = !0), !s1.length || this.p[0] === s1[0] && this.p[1] === s1[1] && this.p[4] === s1[4] && this.p[5] === s1[5] && this.p[12] === s1[12] && this.p[13] === s1[13] || (this.p = s1, this._mdf.p = !0, n1 = !0), n1;
        }, TextProperty.prototype.defaultBoxWidth = [
            0,
            0
        ], TextProperty.prototype.copyData = function(t1, e1) {
            for(var r1 in e1)Object.prototype.hasOwnProperty.call(e1, r1) && (t1[r1] = e1[r1]);
            return t1;
        }, TextProperty.prototype.setCurrentData = function(t1) {
            t1.__complete || this.completeTextData(t1), this.currentData = t1, this.currentData.boxWidth = this.currentData.boxWidth || this.defaultBoxWidth, this._mdf = !0;
        }, TextProperty.prototype.searchProperty = function() {
            return this.searchKeyframes();
        }, TextProperty.prototype.searchKeyframes = function() {
            return this.kf = this.data.d.k.length > 1, this.kf && this.addEffect(this.getKeyframeValue.bind(this)), this.kf;
        }, TextProperty.prototype.addEffect = function(t1) {
            this.effectsSequence.push(t1), this.elem.addDynamicProperty(this);
        }, TextProperty.prototype.getValue = function(t1) {
            if (this.elem.globalData.frameId !== this.frameId && this.effectsSequence.length || t1) {
                this.currentData.t = this.data.d.k[this.keysIndex].s.t;
                var e1 = this.currentData, r1 = this.keysIndex;
                if (this.lock) this.setCurrentData(this.currentData);
                else {
                    var i1;
                    this.lock = !0, this._mdf = !1;
                    var a1 = this.effectsSequence.length, s1 = t1 || this.data.d.k[this.keysIndex].s;
                    for(i1 = 0; i1 < a1; i1 += 1)s1 = r1 !== this.keysIndex ? this.effectsSequence[i1](s1, s1.t) : this.effectsSequence[i1](this.currentData, s1.t);
                    e1 !== s1 && this.setCurrentData(s1), this.v = this.currentData, this.pv = this.v, this.lock = !1, this.frameId = this.elem.globalData.frameId;
                }
            }
        }, TextProperty.prototype.getKeyframeValue = function() {
            for(var t1 = this.data.d.k, e1 = this.elem.comp.renderedFrame, r1 = 0, i1 = t1.length; r1 <= i1 - 1 && !(r1 === i1 - 1 || t1[r1 + 1].t > e1);)r1 += 1;
            return this.keysIndex !== r1 && (this.keysIndex = r1), this.data.d.k[this.keysIndex].s;
        }, TextProperty.prototype.buildFinalText = function(t1) {
            for(var e1, r1, i1 = [], a1 = 0, s1 = t1.length, n1 = !1; a1 < s1;)e1 = t1.charCodeAt(a1), FontManager.isCombinedCharacter(e1) ? i1[i1.length - 1] += t1.charAt(a1) : e1 >= 55296 && e1 <= 56319 ? (r1 = t1.charCodeAt(a1 + 1)) >= 56320 && r1 <= 57343 ? (n1 || FontManager.isModifier(e1, r1) ? (i1[i1.length - 1] += t1.substr(a1, 2), n1 = !1) : i1.push(t1.substr(a1, 2)), a1 += 1) : i1.push(t1.charAt(a1)) : e1 > 56319 ? (r1 = t1.charCodeAt(a1 + 1), FontManager.isZeroWidthJoiner(e1, r1) ? (n1 = !0, i1[i1.length - 1] += t1.substr(a1, 2), a1 += 1) : i1.push(t1.charAt(a1))) : FontManager.isZeroWidthJoiner(e1) ? (i1[i1.length - 1] += t1.charAt(a1), n1 = !0) : i1.push(t1.charAt(a1)), a1 += 1;
            return i1;
        }, TextProperty.prototype.completeTextData = function(t1) {
            t1.__complete = !0;
            var e1, r1, i1, a1, s1, n1, o1, h1 = this.elem.globalData.fontManager, l1 = this.data, p1 = [], f1 = 0, c1 = l1.m.g, m1 = 0, d1 = 0, u1 = 0, y1 = [], g1 = 0, v1 = 0, b1 = h1.getFontByName(t1.f), x1 = 0, P1 = getFontProperties(b1);
            t1.fWeight = P1.weight, t1.fStyle = P1.style, t1.finalSize = t1.s, t1.finalText = this.buildFinalText(t1.t), r1 = t1.finalText.length, t1.finalLineHeight = t1.lh;
            var E1, S1 = t1.tr / 1e3 * t1.finalSize;
            if (t1.sz) for(var C1, _1, A1 = !0, k1 = t1.sz[0], w1 = t1.sz[1]; A1;){
                C1 = 0, g1 = 0, r1 = (_1 = this.buildFinalText(t1.t)).length, S1 = t1.tr / 1e3 * t1.finalSize;
                var T1 = -1;
                for(e1 = 0; e1 < r1; e1 += 1)E1 = _1[e1].charCodeAt(0), i1 = !1, " " === _1[e1] ? T1 = e1 : 13 !== E1 && 3 !== E1 || (g1 = 0, i1 = !0, C1 += t1.finalLineHeight || 1.2 * t1.finalSize), h1.chars ? (o1 = h1.getCharData(_1[e1], b1.fStyle, b1.fFamily), x1 = i1 ? 0 : o1.w * t1.finalSize / 100) : x1 = h1.measureText(_1[e1], t1.f, t1.finalSize), g1 + x1 > k1 && " " !== _1[e1] ? (-1 === T1 ? r1 += 1 : e1 = T1, C1 += t1.finalLineHeight || 1.2 * t1.finalSize, _1.splice(e1, T1 === e1 ? 1 : 0, "\r"), T1 = -1, g1 = 0) : (g1 += x1, g1 += S1);
                C1 += b1.ascent * t1.finalSize / 100, this.canResize && t1.finalSize > this.minimumFontSize && w1 < C1 ? (t1.finalSize -= 1, t1.finalLineHeight = t1.finalSize * t1.lh / t1.s) : (t1.finalText = _1, r1 = t1.finalText.length, A1 = !1);
            }
            g1 = -S1, x1 = 0;
            var M1, D1 = 0;
            for(e1 = 0; e1 < r1; e1 += 1)if (i1 = !1, 13 === (E1 = (M1 = t1.finalText[e1]).charCodeAt(0)) || 3 === E1 ? (D1 = 0, y1.push(g1), v1 = g1 > v1 ? g1 : v1, g1 = -2 * S1, a1 = "", i1 = !0, u1 += 1) : a1 = M1, h1.chars ? (o1 = h1.getCharData(M1, b1.fStyle, h1.getFontByName(t1.f).fFamily), x1 = i1 ? 0 : o1.w * t1.finalSize / 100) : x1 = h1.measureText(a1, t1.f, t1.finalSize), " " === M1 ? D1 += x1 + S1 : (g1 += x1 + S1 + D1, D1 = 0), p1.push({
                l: x1,
                an: x1,
                add: m1,
                n: i1,
                anIndexes: [],
                val: a1,
                line: u1,
                animatorJustifyOffset: 0
            }), 2 == c1) {
                if (m1 += x1, "" === a1 || " " === a1 || e1 === r1 - 1) {
                    for("" !== a1 && " " !== a1 || (m1 -= x1); d1 <= e1;)p1[d1].an = m1, p1[d1].ind = f1, p1[d1].extra = x1, d1 += 1;
                    f1 += 1, m1 = 0;
                }
            } else if (3 == c1) {
                if (m1 += x1, "" === a1 || e1 === r1 - 1) {
                    for("" === a1 && (m1 -= x1); d1 <= e1;)p1[d1].an = m1, p1[d1].ind = f1, p1[d1].extra = x1, d1 += 1;
                    m1 = 0, f1 += 1;
                }
            } else p1[f1].ind = f1, p1[f1].extra = 0, f1 += 1;
            if (t1.l = p1, v1 = g1 > v1 ? g1 : v1, y1.push(g1), t1.sz) t1.boxWidth = t1.sz[0], t1.justifyOffset = 0;
            else switch(t1.boxWidth = v1, t1.j){
                case 1:
                    t1.justifyOffset = -t1.boxWidth;
                    break;
                case 2:
                    t1.justifyOffset = -t1.boxWidth / 2;
                    break;
                default:
                    t1.justifyOffset = 0;
            }
            t1.lineWidths = y1;
            var F1, I1, R1, B1, V1 = l1.a;
            n1 = V1.length;
            var L1 = [];
            for(s1 = 0; s1 < n1; s1 += 1){
                for((F1 = V1[s1]).a.sc && (t1.strokeColorAnim = !0), F1.a.sw && (t1.strokeWidthAnim = !0), (F1.a.fc || F1.a.fh || F1.a.fs || F1.a.fb) && (t1.fillColorAnim = !0), B1 = 0, R1 = F1.s.b, e1 = 0; e1 < r1; e1 += 1)(I1 = p1[e1]).anIndexes[s1] = B1, (1 == R1 && "" !== I1.val || 2 == R1 && "" !== I1.val && " " !== I1.val || 3 == R1 && (I1.n || " " == I1.val || e1 == r1 - 1) || 4 == R1 && (I1.n || e1 == r1 - 1)) && (1 === F1.s.rn && L1.push(B1), B1 += 1);
                l1.a[s1].s.totalChars = B1;
                var z1, G1 = -1;
                if (1 === F1.s.rn) for(e1 = 0; e1 < r1; e1 += 1)G1 != (I1 = p1[e1]).anIndexes[s1] && (G1 = I1.anIndexes[s1], z1 = L1.splice(Math.floor(Math.random() * L1.length), 1)[0]), I1.anIndexes[s1] = z1;
            }
            t1.yOffset = t1.finalLineHeight || 1.2 * t1.finalSize, t1.ls = t1.ls || 0, t1.ascent = b1.ascent * t1.finalSize / 100;
        }, TextProperty.prototype.updateDocumentData = function(t1, e1) {
            e1 = void 0 === e1 ? this.keysIndex : e1;
            var r1 = this.copyData({}, this.data.d.k[e1].s);
            r1 = this.copyData(r1, t1), this.data.d.k[e1].s = r1, this.recalculate(e1), this.elem.addDynamicProperty(this);
        }, TextProperty.prototype.recalculate = function(t1) {
            var e1 = this.data.d.k[t1].s;
            e1.__complete = !1, this.keysIndex = 0, this._isFirstFrame = !0, this.getValue(e1);
        }, TextProperty.prototype.canResizeFont = function(t1) {
            this.canResize = t1, this.recalculate(this.keysIndex), this.elem.addDynamicProperty(this);
        }, TextProperty.prototype.setMinimumFontSize = function(t1) {
            this.minimumFontSize = Math.floor(t1) || 1, this.recalculate(this.keysIndex), this.elem.addDynamicProperty(this);
        };
        var TextSelectorProp = function() {
            var t1 = Math.max, e1 = Math.min, r1 = Math.floor;
            function i1(t1, e1) {
                this._currentTextLength = -1, this.k = !1, this.data = e1, this.elem = t1, this.comp = t1.comp, this.finalS = 0, this.finalE = 0, this.initDynamicPropertyContainer(t1), this.s = PropertyFactory.getProp(t1, e1.s || {
                    k: 0
                }, 0, 0, this), this.e = "e" in e1 ? PropertyFactory.getProp(t1, e1.e, 0, 0, this) : {
                    v: 100
                }, this.o = PropertyFactory.getProp(t1, e1.o || {
                    k: 0
                }, 0, 0, this), this.xe = PropertyFactory.getProp(t1, e1.xe || {
                    k: 0
                }, 0, 0, this), this.ne = PropertyFactory.getProp(t1, e1.ne || {
                    k: 0
                }, 0, 0, this), this.sm = PropertyFactory.getProp(t1, e1.sm || {
                    k: 100
                }, 0, 0, this), this.a = PropertyFactory.getProp(t1, e1.a, 0, .01, this), this.dynamicProperties.length || this.getValue();
            }
            return i1.prototype = {
                getMult: function(i1) {
                    this._currentTextLength !== this.elem.textProperty.currentData.l.length && this.getValue();
                    var a1 = 0, s1 = 0, n1 = 1, o1 = 1;
                    this.ne.v > 0 ? a1 = this.ne.v / 100 : s1 = -this.ne.v / 100, this.xe.v > 0 ? n1 = 1 - this.xe.v / 100 : o1 = 1 + this.xe.v / 100;
                    var h1 = BezierFactory.getBezierEasing(a1, s1, n1, o1).get, l1 = 0, p1 = this.finalS, f1 = this.finalE, c1 = this.data.sh;
                    if (2 === c1) l1 = h1(l1 = f1 === p1 ? i1 >= f1 ? 1 : 0 : t1(0, e1(.5 / (f1 - p1) + (i1 - p1) / (f1 - p1), 1)));
                    else if (3 === c1) l1 = h1(l1 = f1 === p1 ? i1 >= f1 ? 0 : 1 : 1 - t1(0, e1(.5 / (f1 - p1) + (i1 - p1) / (f1 - p1), 1)));
                    else if (4 === c1) f1 === p1 ? l1 = 0 : (l1 = t1(0, e1(.5 / (f1 - p1) + (i1 - p1) / (f1 - p1), 1))) < .5 ? l1 *= 2 : l1 = 1 - 2 * (l1 - .5), l1 = h1(l1);
                    else if (5 === c1) {
                        if (f1 === p1) l1 = 0;
                        else {
                            var m1 = f1 - p1, d1 = -m1 / 2 + (i1 = e1(t1(0, i1 + .5 - p1), f1 - p1)), u1 = m1 / 2;
                            l1 = Math.sqrt(1 - d1 * d1 / (u1 * u1));
                        }
                        l1 = h1(l1);
                    } else 6 === c1 ? (f1 === p1 ? l1 = 0 : (i1 = e1(t1(0, i1 + .5 - p1), f1 - p1), l1 = (1 + Math.cos(Math.PI + 2 * Math.PI * i1 / (f1 - p1))) / 2), l1 = h1(l1)) : (i1 >= r1(p1) && (l1 = t1(0, e1(i1 - p1 < 0 ? e1(f1, 1) - (p1 - i1) : f1 - i1, 1))), l1 = h1(l1));
                    if (100 !== this.sm.v) {
                        var y1 = .01 * this.sm.v;
                        0 === y1 && (y1 = 1e-8);
                        var g1 = .5 - .5 * y1;
                        l1 < g1 ? l1 = 0 : (l1 = (l1 - g1) / y1) > 1 && (l1 = 1);
                    }
                    return l1 * this.a.v;
                },
                getValue: function(t1) {
                    this.iterateDynamicProperties(), this._mdf = t1 || this._mdf, this._currentTextLength = this.elem.textProperty.currentData.l.length || 0, t1 && 2 === this.data.r && (this.e.v = this._currentTextLength);
                    var e1 = 2 === this.data.r ? 1 : 100 / this.data.totalChars, r1 = this.o.v / e1, i1 = this.s.v / e1 + r1, a1 = this.e.v / e1 + r1;
                    if (i1 > a1) {
                        var s1 = i1;
                        i1 = a1, a1 = s1;
                    }
                    this.finalS = i1, this.finalE = a1;
                }
            }, extendPrototype([
                DynamicPropertyContainer
            ], i1), {
                getTextSelectorProp: function(t1, e1, r1) {
                    return new i1(t1, e1, r1);
                }
            };
        }();
        function TextAnimatorDataProperty(t1, e1, r1) {
            var i1 = {
                propType: !1
            }, a1 = PropertyFactory.getProp, s1 = e1.a;
            this.a = {
                r: s1.r ? a1(t1, s1.r, 0, degToRads, r1) : i1,
                rx: s1.rx ? a1(t1, s1.rx, 0, degToRads, r1) : i1,
                ry: s1.ry ? a1(t1, s1.ry, 0, degToRads, r1) : i1,
                sk: s1.sk ? a1(t1, s1.sk, 0, degToRads, r1) : i1,
                sa: s1.sa ? a1(t1, s1.sa, 0, degToRads, r1) : i1,
                s: s1.s ? a1(t1, s1.s, 1, .01, r1) : i1,
                a: s1.a ? a1(t1, s1.a, 1, 0, r1) : i1,
                o: s1.o ? a1(t1, s1.o, 0, .01, r1) : i1,
                p: s1.p ? a1(t1, s1.p, 1, 0, r1) : i1,
                sw: s1.sw ? a1(t1, s1.sw, 0, 0, r1) : i1,
                sc: s1.sc ? a1(t1, s1.sc, 1, 0, r1) : i1,
                fc: s1.fc ? a1(t1, s1.fc, 1, 0, r1) : i1,
                fh: s1.fh ? a1(t1, s1.fh, 0, 0, r1) : i1,
                fs: s1.fs ? a1(t1, s1.fs, 0, .01, r1) : i1,
                fb: s1.fb ? a1(t1, s1.fb, 0, .01, r1) : i1,
                t: s1.t ? a1(t1, s1.t, 0, 0, r1) : i1
            }, this.s = TextSelectorProp.getTextSelectorProp(t1, e1.s, r1), this.s.t = e1.s.t;
        }
        function TextAnimatorProperty(t1, e1, r1) {
            this._isFirstFrame = !0, this._hasMaskedPath = !1, this._frameId = -1, this._textData = t1, this._renderType = e1, this._elem = r1, this._animatorsData = createSizedArray(this._textData.a.length), this._pathData = {}, this._moreOptions = {
                alignment: {}
            }, this.renderedLetters = [], this.lettersChangedFlag = !1, this.initDynamicPropertyContainer(r1);
        }
        function ITextElement() {}
        TextAnimatorProperty.prototype.searchProperties = function() {
            var t1, e1, r1 = this._textData.a.length, i1 = PropertyFactory.getProp;
            for(t1 = 0; t1 < r1; t1 += 1)e1 = this._textData.a[t1], this._animatorsData[t1] = new TextAnimatorDataProperty(this._elem, e1, this);
            this._textData.p && "m" in this._textData.p ? (this._pathData = {
                a: i1(this._elem, this._textData.p.a, 0, 0, this),
                f: i1(this._elem, this._textData.p.f, 0, 0, this),
                l: i1(this._elem, this._textData.p.l, 0, 0, this),
                r: i1(this._elem, this._textData.p.r, 0, 0, this),
                p: i1(this._elem, this._textData.p.p, 0, 0, this),
                m: this._elem.maskManager.getMaskProperty(this._textData.p.m)
            }, this._hasMaskedPath = !0) : this._hasMaskedPath = !1, this._moreOptions.alignment = i1(this._elem, this._textData.m.a, 1, 0, this);
        }, TextAnimatorProperty.prototype.getMeasures = function(t1, e1) {
            if (this.lettersChangedFlag = e1, this._mdf || this._isFirstFrame || e1 || this._hasMaskedPath && this._pathData.m._mdf) {
                this._isFirstFrame = !1;
                var r1, i1, a1, s1, n1, o1, h1, l1, p1, f1, c1, m1, d1, u1, y1, g1, v1, b1, x1, P1 = this._moreOptions.alignment.v, E1 = this._animatorsData, S1 = this._textData, C1 = this.mHelper, _1 = this._renderType, A1 = this.renderedLetters.length, k1 = t1.l;
                if (this._hasMaskedPath) {
                    if (x1 = this._pathData.m, !this._pathData.n || this._pathData._mdf) {
                        var w1, T1 = x1.v;
                        for(this._pathData.r.v && (T1 = T1.reverse()), n1 = {
                            tLength: 0,
                            segments: []
                        }, s1 = T1._length - 1, g1 = 0, a1 = 0; a1 < s1; a1 += 1)w1 = bez.buildBezierData(T1.v[a1], T1.v[a1 + 1], [
                            T1.o[a1][0] - T1.v[a1][0],
                            T1.o[a1][1] - T1.v[a1][1]
                        ], [
                            T1.i[a1 + 1][0] - T1.v[a1 + 1][0],
                            T1.i[a1 + 1][1] - T1.v[a1 + 1][1]
                        ]), n1.tLength += w1.segmentLength, n1.segments.push(w1), g1 += w1.segmentLength;
                        a1 = s1, x1.v.c && (w1 = bez.buildBezierData(T1.v[a1], T1.v[0], [
                            T1.o[a1][0] - T1.v[a1][0],
                            T1.o[a1][1] - T1.v[a1][1]
                        ], [
                            T1.i[0][0] - T1.v[0][0],
                            T1.i[0][1] - T1.v[0][1]
                        ]), n1.tLength += w1.segmentLength, n1.segments.push(w1), g1 += w1.segmentLength), this._pathData.pi = n1;
                    }
                    if (n1 = this._pathData.pi, o1 = this._pathData.f.v, c1 = 0, f1 = 1, l1 = 0, p1 = !0, u1 = n1.segments, o1 < 0 && x1.v.c) for(n1.tLength < Math.abs(o1) && (o1 = -Math.abs(o1) % n1.tLength), f1 = (d1 = u1[c1 = u1.length - 1].points).length - 1; o1 < 0;)o1 += d1[f1].partialLength, (f1 -= 1) < 0 && (f1 = (d1 = u1[c1 -= 1].points).length - 1);
                    m1 = (d1 = u1[c1].points)[f1 - 1], y1 = (h1 = d1[f1]).partialLength;
                }
                s1 = k1.length, r1 = 0, i1 = 0;
                var M1, D1, F1, I1, R1, B1 = 1.2 * t1.finalSize * .714, V1 = !0;
                F1 = E1.length;
                var L1, z1, G1, O1, N1, H1, j1, q1, W1, $1, Y1, X1, Z1 = -1, K1 = o1, J1 = c1, U1 = f1, Q1 = -1, tt1 = "", et1 = this.defaultPropsArray;
                if (2 === t1.j || 1 === t1.j) {
                    var rt1 = 0, it1 = 0, at1 = 2 === t1.j ? -0.5 : -1, st1 = 0, nt1 = !0;
                    for(a1 = 0; a1 < s1; a1 += 1)if (k1[a1].n) {
                        for(rt1 && (rt1 += it1); st1 < a1;)k1[st1].animatorJustifyOffset = rt1, st1 += 1;
                        rt1 = 0, nt1 = !0;
                    } else {
                        for(D1 = 0; D1 < F1; D1 += 1)(M1 = E1[D1].a).t.propType && (nt1 && 2 === t1.j && (it1 += M1.t.v * at1), (R1 = E1[D1].s.getMult(k1[a1].anIndexes[D1], S1.a[D1].s.totalChars)).length ? rt1 += M1.t.v * R1[0] * at1 : rt1 += M1.t.v * R1 * at1);
                        nt1 = !1;
                    }
                    for(rt1 && (rt1 += it1); st1 < a1;)k1[st1].animatorJustifyOffset = rt1, st1 += 1;
                }
                for(a1 = 0; a1 < s1; a1 += 1){
                    if (C1.reset(), O1 = 1, k1[a1].n) r1 = 0, i1 += t1.yOffset, i1 += V1 ? 1 : 0, o1 = K1, V1 = !1, this._hasMaskedPath && (f1 = U1, m1 = (d1 = u1[c1 = J1].points)[f1 - 1], y1 = (h1 = d1[f1]).partialLength, l1 = 0), tt1 = "", Y1 = "", W1 = "", X1 = "", et1 = this.defaultPropsArray;
                    else {
                        if (this._hasMaskedPath) {
                            if (Q1 !== k1[a1].line) {
                                switch(t1.j){
                                    case 1:
                                        o1 += g1 - t1.lineWidths[k1[a1].line];
                                        break;
                                    case 2:
                                        o1 += (g1 - t1.lineWidths[k1[a1].line]) / 2;
                                }
                                Q1 = k1[a1].line;
                            }
                            Z1 !== k1[a1].ind && (k1[Z1] && (o1 += k1[Z1].extra), o1 += k1[a1].an / 2, Z1 = k1[a1].ind), o1 += P1[0] * k1[a1].an * .005;
                            var ot1 = 0;
                            for(D1 = 0; D1 < F1; D1 += 1)(M1 = E1[D1].a).p.propType && ((R1 = E1[D1].s.getMult(k1[a1].anIndexes[D1], S1.a[D1].s.totalChars)).length ? ot1 += M1.p.v[0] * R1[0] : ot1 += M1.p.v[0] * R1), M1.a.propType && ((R1 = E1[D1].s.getMult(k1[a1].anIndexes[D1], S1.a[D1].s.totalChars)).length ? ot1 += M1.a.v[0] * R1[0] : ot1 += M1.a.v[0] * R1);
                            for(p1 = !0, this._pathData.a.v && (o1 = .5 * k1[0].an + (g1 - this._pathData.f.v - .5 * k1[0].an - .5 * k1[k1.length - 1].an) * Z1 / (s1 - 1), o1 += this._pathData.f.v); p1;)l1 + y1 >= o1 + ot1 || !d1 ? (v1 = (o1 + ot1 - l1) / h1.partialLength, z1 = m1.point[0] + (h1.point[0] - m1.point[0]) * v1, G1 = m1.point[1] + (h1.point[1] - m1.point[1]) * v1, C1.translate(-P1[0] * k1[a1].an * .005, -P1[1] * B1 * .01), p1 = !1) : d1 && (l1 += h1.partialLength, (f1 += 1) >= d1.length && (f1 = 0, u1[c1 += 1] ? d1 = u1[c1].points : x1.v.c ? (f1 = 0, d1 = u1[c1 = 0].points) : (l1 -= h1.partialLength, d1 = null)), d1 && (m1 = h1, y1 = (h1 = d1[f1]).partialLength));
                            L1 = k1[a1].an / 2 - k1[a1].add, C1.translate(-L1, 0, 0);
                        } else L1 = k1[a1].an / 2 - k1[a1].add, C1.translate(-L1, 0, 0), C1.translate(-P1[0] * k1[a1].an * .005, -P1[1] * B1 * .01, 0);
                        for(D1 = 0; D1 < F1; D1 += 1)(M1 = E1[D1].a).t.propType && (R1 = E1[D1].s.getMult(k1[a1].anIndexes[D1], S1.a[D1].s.totalChars), 0 === r1 && 0 === t1.j || (this._hasMaskedPath ? R1.length ? o1 += M1.t.v * R1[0] : o1 += M1.t.v * R1 : R1.length ? r1 += M1.t.v * R1[0] : r1 += M1.t.v * R1));
                        for(t1.strokeWidthAnim && (H1 = t1.sw || 0), t1.strokeColorAnim && (N1 = t1.sc ? [
                            t1.sc[0],
                            t1.sc[1],
                            t1.sc[2]
                        ] : [
                            0,
                            0,
                            0
                        ]), t1.fillColorAnim && t1.fc && (j1 = [
                            t1.fc[0],
                            t1.fc[1],
                            t1.fc[2]
                        ]), D1 = 0; D1 < F1; D1 += 1)(M1 = E1[D1].a).a.propType && ((R1 = E1[D1].s.getMult(k1[a1].anIndexes[D1], S1.a[D1].s.totalChars)).length ? C1.translate(-M1.a.v[0] * R1[0], -M1.a.v[1] * R1[1], M1.a.v[2] * R1[2]) : C1.translate(-M1.a.v[0] * R1, -M1.a.v[1] * R1, M1.a.v[2] * R1));
                        for(D1 = 0; D1 < F1; D1 += 1)(M1 = E1[D1].a).s.propType && ((R1 = E1[D1].s.getMult(k1[a1].anIndexes[D1], S1.a[D1].s.totalChars)).length ? C1.scale(1 + (M1.s.v[0] - 1) * R1[0], 1 + (M1.s.v[1] - 1) * R1[1], 1) : C1.scale(1 + (M1.s.v[0] - 1) * R1, 1 + (M1.s.v[1] - 1) * R1, 1));
                        for(D1 = 0; D1 < F1; D1 += 1){
                            if (M1 = E1[D1].a, R1 = E1[D1].s.getMult(k1[a1].anIndexes[D1], S1.a[D1].s.totalChars), M1.sk.propType && (R1.length ? C1.skewFromAxis(-M1.sk.v * R1[0], M1.sa.v * R1[1]) : C1.skewFromAxis(-M1.sk.v * R1, M1.sa.v * R1)), M1.r.propType && (R1.length ? C1.rotateZ(-M1.r.v * R1[2]) : C1.rotateZ(-M1.r.v * R1)), M1.ry.propType && (R1.length ? C1.rotateY(M1.ry.v * R1[1]) : C1.rotateY(M1.ry.v * R1)), M1.rx.propType && (R1.length ? C1.rotateX(M1.rx.v * R1[0]) : C1.rotateX(M1.rx.v * R1)), M1.o.propType && (R1.length ? O1 += (M1.o.v * R1[0] - O1) * R1[0] : O1 += (M1.o.v * R1 - O1) * R1), t1.strokeWidthAnim && M1.sw.propType && (R1.length ? H1 += M1.sw.v * R1[0] : H1 += M1.sw.v * R1), t1.strokeColorAnim && M1.sc.propType) for(q1 = 0; q1 < 3; q1 += 1)R1.length ? N1[q1] += (M1.sc.v[q1] - N1[q1]) * R1[0] : N1[q1] += (M1.sc.v[q1] - N1[q1]) * R1;
                            if (t1.fillColorAnim && t1.fc) {
                                if (M1.fc.propType) for(q1 = 0; q1 < 3; q1 += 1)R1.length ? j1[q1] += (M1.fc.v[q1] - j1[q1]) * R1[0] : j1[q1] += (M1.fc.v[q1] - j1[q1]) * R1;
                                M1.fh.propType && (j1 = R1.length ? addHueToRGB(j1, M1.fh.v * R1[0]) : addHueToRGB(j1, M1.fh.v * R1)), M1.fs.propType && (j1 = R1.length ? addSaturationToRGB(j1, M1.fs.v * R1[0]) : addSaturationToRGB(j1, M1.fs.v * R1)), M1.fb.propType && (j1 = R1.length ? addBrightnessToRGB(j1, M1.fb.v * R1[0]) : addBrightnessToRGB(j1, M1.fb.v * R1));
                            }
                        }
                        for(D1 = 0; D1 < F1; D1 += 1)(M1 = E1[D1].a).p.propType && (R1 = E1[D1].s.getMult(k1[a1].anIndexes[D1], S1.a[D1].s.totalChars), this._hasMaskedPath ? R1.length ? C1.translate(0, M1.p.v[1] * R1[0], -M1.p.v[2] * R1[1]) : C1.translate(0, M1.p.v[1] * R1, -M1.p.v[2] * R1) : R1.length ? C1.translate(M1.p.v[0] * R1[0], M1.p.v[1] * R1[1], -M1.p.v[2] * R1[2]) : C1.translate(M1.p.v[0] * R1, M1.p.v[1] * R1, -M1.p.v[2] * R1));
                        if (t1.strokeWidthAnim && (W1 = H1 < 0 ? 0 : H1), t1.strokeColorAnim && ($1 = "rgb(" + Math.round(255 * N1[0]) + "," + Math.round(255 * N1[1]) + "," + Math.round(255 * N1[2]) + ")"), t1.fillColorAnim && t1.fc && (Y1 = "rgb(" + Math.round(255 * j1[0]) + "," + Math.round(255 * j1[1]) + "," + Math.round(255 * j1[2]) + ")"), this._hasMaskedPath) {
                            if (C1.translate(0, -t1.ls), C1.translate(0, P1[1] * B1 * .01 + i1, 0), this._pathData.p.v) {
                                b1 = (h1.point[1] - m1.point[1]) / (h1.point[0] - m1.point[0]);
                                var ht1 = 180 * Math.atan(b1) / Math.PI;
                                h1.point[0] < m1.point[0] && (ht1 += 180), C1.rotate(-ht1 * Math.PI / 180);
                            }
                            C1.translate(z1, G1, 0), o1 -= P1[0] * k1[a1].an * .005, k1[a1 + 1] && Z1 !== k1[a1 + 1].ind && (o1 += k1[a1].an / 2, o1 += .001 * t1.tr * t1.finalSize);
                        } else {
                            switch(C1.translate(r1, i1, 0), t1.ps && C1.translate(t1.ps[0], t1.ps[1] + t1.ascent, 0), t1.j){
                                case 1:
                                    C1.translate(k1[a1].animatorJustifyOffset + t1.justifyOffset + (t1.boxWidth - t1.lineWidths[k1[a1].line]), 0, 0);
                                    break;
                                case 2:
                                    C1.translate(k1[a1].animatorJustifyOffset + t1.justifyOffset + (t1.boxWidth - t1.lineWidths[k1[a1].line]) / 2, 0, 0);
                            }
                            C1.translate(0, -t1.ls), C1.translate(L1, 0, 0), C1.translate(P1[0] * k1[a1].an * .005, P1[1] * B1 * .01, 0), r1 += k1[a1].l + .001 * t1.tr * t1.finalSize;
                        }
                        "html" === _1 ? tt1 = C1.toCSS() : "svg" === _1 ? tt1 = C1.to2dCSS() : et1 = [
                            C1.props[0],
                            C1.props[1],
                            C1.props[2],
                            C1.props[3],
                            C1.props[4],
                            C1.props[5],
                            C1.props[6],
                            C1.props[7],
                            C1.props[8],
                            C1.props[9],
                            C1.props[10],
                            C1.props[11],
                            C1.props[12],
                            C1.props[13],
                            C1.props[14],
                            C1.props[15]
                        ], X1 = O1;
                    }
                    A1 <= a1 ? (I1 = new LetterProps(X1, W1, $1, Y1, tt1, et1), this.renderedLetters.push(I1), A1 += 1, this.lettersChangedFlag = !0) : (I1 = this.renderedLetters[a1], this.lettersChangedFlag = I1.update(X1, W1, $1, Y1, tt1, et1) || this.lettersChangedFlag);
                }
            }
        }, TextAnimatorProperty.prototype.getValue = function() {
            this._elem.globalData.frameId !== this._frameId && (this._frameId = this._elem.globalData.frameId, this.iterateDynamicProperties());
        }, TextAnimatorProperty.prototype.mHelper = new Matrix, TextAnimatorProperty.prototype.defaultPropsArray = [], extendPrototype([
            DynamicPropertyContainer
        ], TextAnimatorProperty), ITextElement.prototype.initElement = function(t1, e1, r1) {
            this.lettersChangedFlag = !0, this.initFrame(), this.initBaseData(t1, e1, r1), this.textProperty = new TextProperty(this, t1.t, this.dynamicProperties), this.textAnimator = new TextAnimatorProperty(t1.t, this.renderType, this), this.initTransform(t1, e1, r1), this.initHierarchy(), this.initRenderable(), this.initRendererElement(), this.createContainerElements(), this.createRenderableComponents(), this.createContent(), this.hide(), this.textAnimator.searchProperties(this.dynamicProperties);
        }, ITextElement.prototype.prepareFrame = function(t1) {
            this._mdf = !1, this.prepareRenderableFrame(t1), this.prepareProperties(t1, this.isInRange), (this.textProperty._mdf || this.textProperty._isFirstFrame) && (this.buildNewText(), this.textProperty._isFirstFrame = !1, this.textProperty._mdf = !1);
        }, ITextElement.prototype.createPathShape = function(t1, e1) {
            var r1, i1, a1 = e1.length, s1 = "";
            for(r1 = 0; r1 < a1; r1 += 1)"sh" === e1[r1].ty && (i1 = e1[r1].ks.k, s1 += buildShapeString(i1, i1.i.length, !0, t1));
            return s1;
        }, ITextElement.prototype.updateDocumentData = function(t1, e1) {
            this.textProperty.updateDocumentData(t1, e1);
        }, ITextElement.prototype.canResizeFont = function(t1) {
            this.textProperty.canResizeFont(t1);
        }, ITextElement.prototype.setMinimumFontSize = function(t1) {
            this.textProperty.setMinimumFontSize(t1);
        }, ITextElement.prototype.applyTextPropertiesToMatrix = function(t1, e1, r1, i1, a1) {
            switch(t1.ps && e1.translate(t1.ps[0], t1.ps[1] + t1.ascent, 0), e1.translate(0, -t1.ls, 0), t1.j){
                case 1:
                    e1.translate(t1.justifyOffset + (t1.boxWidth - t1.lineWidths[r1]), 0, 0);
                    break;
                case 2:
                    e1.translate(t1.justifyOffset + (t1.boxWidth - t1.lineWidths[r1]) / 2, 0, 0);
            }
            e1.translate(i1, a1, 0);
        }, ITextElement.prototype.buildColor = function(t1) {
            return "rgb(" + Math.round(255 * t1[0]) + "," + Math.round(255 * t1[1]) + "," + Math.round(255 * t1[2]) + ")";
        }, ITextElement.prototype.emptyProp = new LetterProps, ITextElement.prototype.destroy = function() {};
        var emptyShapeData = {
            shapes: []
        };
        function SVGTextLottieElement(t1, e1, r1) {
            this.textSpans = [], this.renderType = "svg", this.initElement(t1, e1, r1);
        }
        function ISolidElement(t1, e1, r1) {
            this.initElement(t1, e1, r1);
        }
        function NullElement(t1, e1, r1) {
            this.initFrame(), this.initBaseData(t1, e1, r1), this.initFrame(), this.initTransform(t1, e1, r1), this.initHierarchy();
        }
        function SVGRendererBase() {}
        function ICompElement() {}
        function SVGCompElement(t1, e1, r1) {
            this.layers = t1.layers, this.supports3d = !0, this.completeLayers = !1, this.pendingElements = [], this.elements = this.layers ? createSizedArray(this.layers.length) : [], this.initElement(t1, e1, r1), this.tm = t1.tm ? PropertyFactory.getProp(this, t1.tm, 0, e1.frameRate, this) : {
                _placeholder: !0
            };
        }
        function SVGRenderer(t1, e1) {
            this.animationItem = t1, this.layers = null, this.renderedFrame = -1, this.svgElement = createNS("svg");
            var r1 = "";
            if (e1 && e1.title) {
                var i1 = createNS("title"), a1 = createElementID();
                i1.setAttribute("id", a1), i1.textContent = e1.title, this.svgElement.appendChild(i1), r1 += a1;
            }
            if (e1 && e1.description) {
                var s1 = createNS("desc"), n1 = createElementID();
                s1.setAttribute("id", n1), s1.textContent = e1.description, this.svgElement.appendChild(s1), r1 += " " + n1;
            }
            r1 && this.svgElement.setAttribute("aria-labelledby", r1);
            var o1 = createNS("defs");
            this.svgElement.appendChild(o1);
            var h1 = createNS("g");
            this.svgElement.appendChild(h1), this.layerElement = h1, this.renderConfig = {
                preserveAspectRatio: e1 && e1.preserveAspectRatio || "xMidYMid meet",
                imagePreserveAspectRatio: e1 && e1.imagePreserveAspectRatio || "xMidYMid slice",
                contentVisibility: e1 && e1.contentVisibility || "visible",
                progressiveLoad: e1 && e1.progressiveLoad || !1,
                hideOnTransparent: !(e1 && !1 === e1.hideOnTransparent),
                viewBoxOnly: e1 && e1.viewBoxOnly || !1,
                viewBoxSize: e1 && e1.viewBoxSize || !1,
                className: e1 && e1.className || "",
                id: e1 && e1.id || "",
                focusable: e1 && e1.focusable,
                filterSize: {
                    width: e1 && e1.filterSize && e1.filterSize.width || "100%",
                    height: e1 && e1.filterSize && e1.filterSize.height || "100%",
                    x: e1 && e1.filterSize && e1.filterSize.x || "0%",
                    y: e1 && e1.filterSize && e1.filterSize.y || "0%"
                },
                width: e1 && e1.width,
                height: e1 && e1.height,
                runExpressions: !e1 || void 0 === e1.runExpressions || e1.runExpressions
            }, this.globalData = {
                _mdf: !1,
                frameNum: -1,
                defs: o1,
                renderConfig: this.renderConfig
            }, this.elements = [], this.pendingElements = [], this.destroyed = !1, this.rendererType = "svg";
        }
        function CVContextData() {
            var t1;
            this.saved = [], this.cArrPos = 0, this.cTr = new Matrix, this.cO = 1;
            for(this.savedOp = createTypedArray("float32", 15), t1 = 0; t1 < 15; t1 += 1)this.saved[t1] = createTypedArray("float32", 16);
            this._length = 15;
        }
        function ShapeTransformManager() {
            this.sequences = {}, this.sequenceList = [], this.transform_key_count = 0;
        }
        extendPrototype([
            BaseElement,
            TransformElement,
            SVGBaseElement,
            HierarchyElement,
            FrameElement,
            RenderableDOMElement,
            ITextElement
        ], SVGTextLottieElement), SVGTextLottieElement.prototype.createContent = function() {
            this.data.singleShape && !this.globalData.fontManager.chars && (this.textContainer = createNS("text"));
        }, SVGTextLottieElement.prototype.buildTextContents = function(t1) {
            for(var e1 = 0, r1 = t1.length, i1 = [], a1 = ""; e1 < r1;)t1[e1] === String.fromCharCode(13) || t1[e1] === String.fromCharCode(3) ? (i1.push(a1), a1 = "") : a1 += t1[e1], e1 += 1;
            return i1.push(a1), i1;
        }, SVGTextLottieElement.prototype.buildShapeData = function(t1, e1) {
            if (t1.shapes && t1.shapes.length) {
                var r1 = t1.shapes[0];
                if (r1.it) {
                    var i1 = r1.it[r1.it.length - 1];
                    i1.s && (i1.s.k[0] = e1, i1.s.k[1] = e1);
                }
            }
            return t1;
        }, SVGTextLottieElement.prototype.buildNewText = function() {
            var t1, e1;
            this.addDynamicProperty(this);
            var r1 = this.textProperty.currentData;
            this.renderedLetters = createSizedArray(r1 ? r1.l.length : 0), r1.fc ? this.layerElement.setAttribute("fill", this.buildColor(r1.fc)) : this.layerElement.setAttribute("fill", "rgba(0,0,0,0)"), r1.sc && (this.layerElement.setAttribute("stroke", this.buildColor(r1.sc)), this.layerElement.setAttribute("stroke-width", r1.sw)), this.layerElement.setAttribute("font-size", r1.finalSize);
            var i1 = this.globalData.fontManager.getFontByName(r1.f);
            if (i1.fClass) this.layerElement.setAttribute("class", i1.fClass);
            else {
                this.layerElement.setAttribute("font-family", i1.fFamily);
                var a1 = r1.fWeight, s1 = r1.fStyle;
                this.layerElement.setAttribute("font-style", s1), this.layerElement.setAttribute("font-weight", a1);
            }
            this.layerElement.setAttribute("aria-label", r1.t);
            var n1, o1 = r1.l || [], h1 = !!this.globalData.fontManager.chars;
            e1 = o1.length;
            var l1 = this.mHelper, p1 = this.data.singleShape, f1 = 0, c1 = 0, m1 = !0, d1 = .001 * r1.tr * r1.finalSize;
            if (!p1 || h1 || r1.sz) {
                var u1, y1 = this.textSpans.length;
                for(t1 = 0; t1 < e1; t1 += 1){
                    if (this.textSpans[t1] || (this.textSpans[t1] = {
                        span: null,
                        childSpan: null,
                        glyph: null
                    }), !h1 || !p1 || 0 === t1) {
                        if (n1 = y1 > t1 ? this.textSpans[t1].span : createNS(h1 ? "g" : "text"), y1 <= t1) {
                            if (n1.setAttribute("stroke-linecap", "butt"), n1.setAttribute("stroke-linejoin", "round"), n1.setAttribute("stroke-miterlimit", "4"), this.textSpans[t1].span = n1, h1) {
                                var g1 = createNS("g");
                                n1.appendChild(g1), this.textSpans[t1].childSpan = g1;
                            }
                            this.textSpans[t1].span = n1, this.layerElement.appendChild(n1);
                        }
                        n1.style.display = "inherit";
                    }
                    if (l1.reset(), p1 && (o1[t1].n && (f1 = -d1, c1 += r1.yOffset, c1 += m1 ? 1 : 0, m1 = !1), this.applyTextPropertiesToMatrix(r1, l1, o1[t1].line, f1, c1), f1 += o1[t1].l || 0, f1 += d1), h1) {
                        var v1;
                        if (1 === (u1 = this.globalData.fontManager.getCharData(r1.finalText[t1], i1.fStyle, this.globalData.fontManager.getFontByName(r1.f).fFamily)).t) v1 = new SVGCompElement(u1.data, this.globalData, this);
                        else {
                            var b1 = emptyShapeData;
                            u1.data && u1.data.shapes && (b1 = this.buildShapeData(u1.data, r1.finalSize)), v1 = new SVGShapeElement(b1, this.globalData, this);
                        }
                        if (this.textSpans[t1].glyph) {
                            var x1 = this.textSpans[t1].glyph;
                            this.textSpans[t1].childSpan.removeChild(x1.layerElement), x1.destroy();
                        }
                        this.textSpans[t1].glyph = v1, v1._debug = !0, v1.prepareFrame(0), v1.renderFrame(), this.textSpans[t1].childSpan.appendChild(v1.layerElement), 1 === u1.t && this.textSpans[t1].childSpan.setAttribute("transform", "scale(" + r1.finalSize / 100 + "," + r1.finalSize / 100 + ")");
                    } else p1 && n1.setAttribute("transform", "translate(" + l1.props[12] + "," + l1.props[13] + ")"), n1.textContent = o1[t1].val, n1.setAttributeNS("http://www.w3.org/XML/1998/namespace", "xml:space", "preserve");
                }
                p1 && n1 && n1.setAttribute("d", "");
            } else {
                var P1 = this.textContainer, E1 = "start";
                switch(r1.j){
                    case 1:
                        E1 = "end";
                        break;
                    case 2:
                        E1 = "middle";
                        break;
                    default:
                        E1 = "start";
                }
                P1.setAttribute("text-anchor", E1), P1.setAttribute("letter-spacing", d1);
                var S1 = this.buildTextContents(r1.finalText);
                for(e1 = S1.length, c1 = r1.ps ? r1.ps[1] + r1.ascent : 0, t1 = 0; t1 < e1; t1 += 1)(n1 = this.textSpans[t1].span || createNS("tspan")).textContent = S1[t1], n1.setAttribute("x", 0), n1.setAttribute("y", c1), n1.style.display = "inherit", P1.appendChild(n1), this.textSpans[t1] || (this.textSpans[t1] = {
                    span: null,
                    glyph: null
                }), this.textSpans[t1].span = n1, c1 += r1.finalLineHeight;
                this.layerElement.appendChild(P1);
            }
            for(; t1 < this.textSpans.length;)this.textSpans[t1].span.style.display = "none", t1 += 1;
            this._sizeChanged = !0;
        }, SVGTextLottieElement.prototype.sourceRectAtTime = function() {
            if (this.prepareFrame(this.comp.renderedFrame - this.data.st), this.renderInnerContent(), this._sizeChanged) {
                this._sizeChanged = !1;
                var t1 = this.layerElement.getBBox();
                this.bbox = {
                    top: t1.y,
                    left: t1.x,
                    width: t1.width,
                    height: t1.height
                };
            }
            return this.bbox;
        }, SVGTextLottieElement.prototype.getValue = function() {
            var t1, e1, r1 = this.textSpans.length;
            for(this.renderedFrame = this.comp.renderedFrame, t1 = 0; t1 < r1; t1 += 1)(e1 = this.textSpans[t1].glyph) && (e1.prepareFrame(this.comp.renderedFrame - this.data.st), e1._mdf && (this._mdf = !0));
        }, SVGTextLottieElement.prototype.renderInnerContent = function() {
            if ((!this.data.singleShape || this._mdf) && (this.textAnimator.getMeasures(this.textProperty.currentData, this.lettersChangedFlag), this.lettersChangedFlag || this.textAnimator.lettersChangedFlag)) {
                var t1, e1;
                this._sizeChanged = !0;
                var r1, i1, a1, s1 = this.textAnimator.renderedLetters, n1 = this.textProperty.currentData.l;
                for(e1 = n1.length, t1 = 0; t1 < e1; t1 += 1)n1[t1].n || (r1 = s1[t1], i1 = this.textSpans[t1].span, (a1 = this.textSpans[t1].glyph) && a1.renderFrame(), r1._mdf.m && i1.setAttribute("transform", r1.m), r1._mdf.o && i1.setAttribute("opacity", r1.o), r1._mdf.sw && i1.setAttribute("stroke-width", r1.sw), r1._mdf.sc && i1.setAttribute("stroke", r1.sc), r1._mdf.fc && i1.setAttribute("fill", r1.fc));
            }
        }, extendPrototype([
            IImageElement
        ], ISolidElement), ISolidElement.prototype.createContent = function() {
            var t1 = createNS("rect");
            t1.setAttribute("width", this.data.sw), t1.setAttribute("height", this.data.sh), t1.setAttribute("fill", this.data.sc), this.layerElement.appendChild(t1);
        }, NullElement.prototype.prepareFrame = function(t1) {
            this.prepareProperties(t1, !0);
        }, NullElement.prototype.renderFrame = function() {}, NullElement.prototype.getBaseElement = function() {
            return null;
        }, NullElement.prototype.destroy = function() {}, NullElement.prototype.sourceRectAtTime = function() {}, NullElement.prototype.hide = function() {}, extendPrototype([
            BaseElement,
            TransformElement,
            HierarchyElement,
            FrameElement
        ], NullElement), extendPrototype([
            BaseRenderer
        ], SVGRendererBase), SVGRendererBase.prototype.createNull = function(t1) {
            return new NullElement(t1, this.globalData, this);
        }, SVGRendererBase.prototype.createShape = function(t1) {
            return new SVGShapeElement(t1, this.globalData, this);
        }, SVGRendererBase.prototype.createText = function(t1) {
            return new SVGTextLottieElement(t1, this.globalData, this);
        }, SVGRendererBase.prototype.createImage = function(t1) {
            return new IImageElement(t1, this.globalData, this);
        }, SVGRendererBase.prototype.createSolid = function(t1) {
            return new ISolidElement(t1, this.globalData, this);
        }, SVGRendererBase.prototype.configAnimation = function(t1) {
            this.svgElement.setAttribute("xmlns", "http://www.w3.org/2000/svg"), this.svgElement.setAttribute("xmlns:xlink", "http://www.w3.org/1999/xlink"), this.renderConfig.viewBoxSize ? this.svgElement.setAttribute("viewBox", this.renderConfig.viewBoxSize) : this.svgElement.setAttribute("viewBox", "0 0 " + t1.w + " " + t1.h), this.renderConfig.viewBoxOnly || (this.svgElement.setAttribute("width", t1.w), this.svgElement.setAttribute("height", t1.h), this.svgElement.style.width = "100%", this.svgElement.style.height = "100%", this.svgElement.style.transform = "translate3d(0,0,0)", this.svgElement.style.contentVisibility = this.renderConfig.contentVisibility), this.renderConfig.width && this.svgElement.setAttribute("width", this.renderConfig.width), this.renderConfig.height && this.svgElement.setAttribute("height", this.renderConfig.height), this.renderConfig.className && this.svgElement.setAttribute("class", this.renderConfig.className), this.renderConfig.id && this.svgElement.setAttribute("id", this.renderConfig.id), void 0 !== this.renderConfig.focusable && this.svgElement.setAttribute("focusable", this.renderConfig.focusable), this.svgElement.setAttribute("preserveAspectRatio", this.renderConfig.preserveAspectRatio), this.animationItem.wrapper.appendChild(this.svgElement);
            var e1 = this.globalData.defs;
            this.setupGlobalData(t1, e1), this.globalData.progressiveLoad = this.renderConfig.progressiveLoad, this.data = t1;
            var r1 = createNS("clipPath"), i1 = createNS("rect");
            i1.setAttribute("width", t1.w), i1.setAttribute("height", t1.h), i1.setAttribute("x", 0), i1.setAttribute("y", 0);
            var a1 = createElementID();
            r1.setAttribute("id", a1), r1.appendChild(i1), this.layerElement.setAttribute("clip-path", "url(" + getLocationHref() + "#" + a1 + ")"), e1.appendChild(r1), this.layers = t1.layers, this.elements = createSizedArray(t1.layers.length);
        }, SVGRendererBase.prototype.destroy = function() {
            var t1;
            this.animationItem.wrapper && (this.animationItem.wrapper.innerText = ""), this.layerElement = null, this.globalData.defs = null;
            var e1 = this.layers ? this.layers.length : 0;
            for(t1 = 0; t1 < e1; t1 += 1)this.elements[t1] && this.elements[t1].destroy();
            this.elements.length = 0, this.destroyed = !0, this.animationItem = null;
        }, SVGRendererBase.prototype.updateContainerSize = function() {}, SVGRendererBase.prototype.findIndexByInd = function(t1) {
            var e1 = 0, r1 = this.layers.length;
            for(e1 = 0; e1 < r1; e1 += 1)if (this.layers[e1].ind === t1) return e1;
            return -1;
        }, SVGRendererBase.prototype.buildItem = function(t1) {
            var e1 = this.elements;
            if (!e1[t1] && 99 !== this.layers[t1].ty) {
                e1[t1] = !0;
                var r1 = this.createItem(this.layers[t1]);
                if (e1[t1] = r1, getExpressionsPlugin() && (0 === this.layers[t1].ty && this.globalData.projectInterface.registerComposition(r1), r1.initExpressions()), this.appendElementInPos(r1, t1), this.layers[t1].tt) {
                    var i1 = "tp" in this.layers[t1] ? this.findIndexByInd(this.layers[t1].tp) : t1 - 1;
                    if (-1 === i1) return;
                    if (this.elements[i1] && !0 !== this.elements[i1]) {
                        var a1 = e1[i1].getMatte(this.layers[t1].tt);
                        r1.setMatte(a1);
                    } else this.buildItem(i1), this.addPendingElement(r1);
                }
            }
        }, SVGRendererBase.prototype.checkPendingElements = function() {
            for(; this.pendingElements.length;){
                var t1 = this.pendingElements.pop();
                if (t1.checkParenting(), t1.data.tt) for(var e1 = 0, r1 = this.elements.length; e1 < r1;){
                    if (this.elements[e1] === t1) {
                        var i1 = "tp" in t1.data ? this.findIndexByInd(t1.data.tp) : e1 - 1, a1 = this.elements[i1].getMatte(this.layers[e1].tt);
                        t1.setMatte(a1);
                        break;
                    }
                    e1 += 1;
                }
            }
        }, SVGRendererBase.prototype.renderFrame = function(t1) {
            if (this.renderedFrame !== t1 && !this.destroyed) {
                var e1;
                null === t1 ? t1 = this.renderedFrame : this.renderedFrame = t1, this.globalData.frameNum = t1, this.globalData.frameId += 1, this.globalData.projectInterface.currentFrame = t1, this.globalData._mdf = !1;
                var r1 = this.layers.length;
                for(this.completeLayers || this.checkLayers(t1), e1 = r1 - 1; e1 >= 0; e1 -= 1)(this.completeLayers || this.elements[e1]) && this.elements[e1].prepareFrame(t1 - this.layers[e1].st);
                if (this.globalData._mdf) for(e1 = 0; e1 < r1; e1 += 1)(this.completeLayers || this.elements[e1]) && this.elements[e1].renderFrame();
            }
        }, SVGRendererBase.prototype.appendElementInPos = function(t1, e1) {
            var r1 = t1.getBaseElement();
            if (r1) {
                for(var i1, a1 = 0; a1 < e1;)this.elements[a1] && !0 !== this.elements[a1] && this.elements[a1].getBaseElement() && (i1 = this.elements[a1].getBaseElement()), a1 += 1;
                i1 ? this.layerElement.insertBefore(r1, i1) : this.layerElement.appendChild(r1);
            }
        }, SVGRendererBase.prototype.hide = function() {
            this.layerElement.style.display = "none";
        }, SVGRendererBase.prototype.show = function() {
            this.layerElement.style.display = "block";
        }, extendPrototype([
            BaseElement,
            TransformElement,
            HierarchyElement,
            FrameElement,
            RenderableDOMElement
        ], ICompElement), ICompElement.prototype.initElement = function(t1, e1, r1) {
            this.initFrame(), this.initBaseData(t1, e1, r1), this.initTransform(t1, e1, r1), this.initRenderable(), this.initHierarchy(), this.initRendererElement(), this.createContainerElements(), this.createRenderableComponents(), !this.data.xt && e1.progressiveLoad || this.buildAllItems(), this.hide();
        }, ICompElement.prototype.prepareFrame = function(t1) {
            if (this._mdf = !1, this.prepareRenderableFrame(t1), this.prepareProperties(t1, this.isInRange), this.isInRange || this.data.xt) {
                if (this.tm._placeholder) this.renderedFrame = t1 / this.data.sr;
                else {
                    var e1 = this.tm.v;
                    e1 === this.data.op && (e1 = this.data.op - 1), this.renderedFrame = e1;
                }
                var r1, i1 = this.elements.length;
                for(this.completeLayers || this.checkLayers(this.renderedFrame), r1 = i1 - 1; r1 >= 0; r1 -= 1)(this.completeLayers || this.elements[r1]) && (this.elements[r1].prepareFrame(this.renderedFrame - this.layers[r1].st), this.elements[r1]._mdf && (this._mdf = !0));
            }
        }, ICompElement.prototype.renderInnerContent = function() {
            var t1, e1 = this.layers.length;
            for(t1 = 0; t1 < e1; t1 += 1)(this.completeLayers || this.elements[t1]) && this.elements[t1].renderFrame();
        }, ICompElement.prototype.setElements = function(t1) {
            this.elements = t1;
        }, ICompElement.prototype.getElements = function() {
            return this.elements;
        }, ICompElement.prototype.destroyElements = function() {
            var t1, e1 = this.layers.length;
            for(t1 = 0; t1 < e1; t1 += 1)this.elements[t1] && this.elements[t1].destroy();
        }, ICompElement.prototype.destroy = function() {
            this.destroyElements(), this.destroyBaseElement();
        }, extendPrototype([
            SVGRendererBase,
            ICompElement,
            SVGBaseElement
        ], SVGCompElement), SVGCompElement.prototype.createComp = function(t1) {
            return new SVGCompElement(t1, this.globalData, this);
        }, extendPrototype([
            SVGRendererBase
        ], SVGRenderer), SVGRenderer.prototype.createComp = function(t1) {
            return new SVGCompElement(t1, this.globalData, this);
        }, CVContextData.prototype.duplicate = function() {
            var t1 = 2 * this._length, e1 = this.savedOp;
            this.savedOp = createTypedArray("float32", t1), this.savedOp.set(e1);
            var r1 = 0;
            for(r1 = this._length; r1 < t1; r1 += 1)this.saved[r1] = createTypedArray("float32", 16);
            this._length = t1;
        }, CVContextData.prototype.reset = function() {
            this.cArrPos = 0, this.cTr.reset(), this.cO = 1;
        }, CVContextData.prototype.popTransform = function() {
            var t1, e1 = this.saved[this.cArrPos], r1 = this.cTr.props;
            for(t1 = 0; t1 < 16; t1 += 1)r1[t1] = e1[t1];
            return e1;
        }, CVContextData.prototype.popOpacity = function() {
            var t1 = this.savedOp[this.cArrPos];
            return this.cO = t1, t1;
        }, CVContextData.prototype.pop = function() {
            return this.cArrPos -= 1, {
                transform: this.popTransform(),
                opacity: this.popOpacity()
            };
        }, CVContextData.prototype.push = function() {
            var t1, e1 = this.cTr.props;
            this._length <= this.cArrPos && this.duplicate();
            var r1 = this.saved[this.cArrPos];
            for(t1 = 0; t1 < 16; t1 += 1)r1[t1] = e1[t1];
            this.savedOp[this.cArrPos] = this.cO, this.cArrPos += 1;
        }, CVContextData.prototype.getTransform = function() {
            return this.cTr;
        }, CVContextData.prototype.getOpacity = function() {
            return this.cO;
        }, CVContextData.prototype.setOpacity = function(t1) {
            this.cO = t1;
        }, ShapeTransformManager.prototype = {
            addTransformSequence: function(t1) {
                var e1, r1 = t1.length, i1 = "_";
                for(e1 = 0; e1 < r1; e1 += 1)i1 += t1[e1].transform.key + "_";
                var a1 = this.sequences[i1];
                return a1 || (a1 = {
                    transforms: [].concat(t1),
                    finalTransform: new Matrix,
                    _mdf: !1
                }, this.sequences[i1] = a1, this.sequenceList.push(a1)), a1;
            },
            processSequence: function(t1, e1) {
                for(var r1, i1 = 0, a1 = t1.transforms.length, s1 = e1; i1 < a1 && !e1;){
                    if (t1.transforms[i1].transform.mProps._mdf) {
                        s1 = !0;
                        break;
                    }
                    i1 += 1;
                }
                if (s1) for(t1.finalTransform.reset(), i1 = a1 - 1; i1 >= 0; i1 -= 1)r1 = t1.transforms[i1].transform.mProps.v.props, t1.finalTransform.transform(r1[0], r1[1], r1[2], r1[3], r1[4], r1[5], r1[6], r1[7], r1[8], r1[9], r1[10], r1[11], r1[12], r1[13], r1[14], r1[15]);
                t1._mdf = s1;
            },
            processSequences: function(t1) {
                var e1, r1 = this.sequenceList.length;
                for(e1 = 0; e1 < r1; e1 += 1)this.processSequence(this.sequenceList[e1], t1);
            },
            getNewKey: function() {
                return this.transform_key_count += 1, "_" + this.transform_key_count;
            }
        };
        var lumaLoader = function() {
            var t1 = "__lottie_element_luma_buffer", e1 = null, r1 = null, i1 = null;
            function a1() {
                var a1, s1, n1;
                e1 || (a1 = createNS("svg"), s1 = createNS("filter"), n1 = createNS("feColorMatrix"), s1.setAttribute("id", t1), n1.setAttribute("type", "matrix"), n1.setAttribute("color-interpolation-filters", "sRGB"), n1.setAttribute("values", "0.3, 0.3, 0.3, 0, 0, 0.3, 0.3, 0.3, 0, 0, 0.3, 0.3, 0.3, 0, 0, 0.3, 0.3, 0.3, 0, 0"), s1.appendChild(n1), a1.appendChild(s1), a1.setAttribute("id", t1 + "_svg"), featureSupport.svgLumaHidden && (a1.style.display = "none"), i1 = a1, document.body.appendChild(i1), e1 = createTag("canvas"), (r1 = e1.getContext("2d")).filter = "url(#" + t1 + ")", r1.fillStyle = "rgba(0,0,0,0)", r1.fillRect(0, 0, 1, 1));
            }
            return {
                load: a1,
                get: function(i1) {
                    return e1 || a1(), e1.width = i1.width, e1.height = i1.height, r1.filter = "url(#" + t1 + ")", e1;
                }
            };
        };
        function createCanvas(t1, e1) {
            if (featureSupport.offscreenCanvas) return new OffscreenCanvas(t1, e1);
            var r1 = createTag("canvas");
            return r1.width = t1, r1.height = e1, r1;
        }
        var assetLoader = {
            loadLumaCanvas: lumaLoader.load,
            getLumaCanvas: lumaLoader.get,
            createCanvas: createCanvas
        };
        function CVEffects() {}
        function CVMaskElement(t1, e1) {
            var r1;
            this.data = t1, this.element = e1, this.masksProperties = this.data.masksProperties || [], this.viewData = createSizedArray(this.masksProperties.length);
            var i1 = this.masksProperties.length, a1 = !1;
            for(r1 = 0; r1 < i1; r1 += 1)"n" !== this.masksProperties[r1].mode && (a1 = !0), this.viewData[r1] = ShapePropertyFactory.getShapeProp(this.element, this.masksProperties[r1], 3);
            this.hasMasks = a1, a1 && this.element.addRenderableComponent(this);
        }
        function CVBaseElement() {}
        CVEffects.prototype.renderFrame = function() {}, CVMaskElement.prototype.renderFrame = function() {
            if (this.hasMasks) {
                var t1, e1, r1, i1, a1 = this.element.finalTransform.mat, s1 = this.element.canvasContext, n1 = this.masksProperties.length;
                for(s1.beginPath(), t1 = 0; t1 < n1; t1 += 1)if ("n" !== this.masksProperties[t1].mode) {
                    var o1;
                    this.masksProperties[t1].inv && (s1.moveTo(0, 0), s1.lineTo(this.element.globalData.compSize.w, 0), s1.lineTo(this.element.globalData.compSize.w, this.element.globalData.compSize.h), s1.lineTo(0, this.element.globalData.compSize.h), s1.lineTo(0, 0)), i1 = this.viewData[t1].v, e1 = a1.applyToPointArray(i1.v[0][0], i1.v[0][1], 0), s1.moveTo(e1[0], e1[1]);
                    var h1 = i1._length;
                    for(o1 = 1; o1 < h1; o1 += 1)r1 = a1.applyToTriplePoints(i1.o[o1 - 1], i1.i[o1], i1.v[o1]), s1.bezierCurveTo(r1[0], r1[1], r1[2], r1[3], r1[4], r1[5]);
                    r1 = a1.applyToTriplePoints(i1.o[o1 - 1], i1.i[0], i1.v[0]), s1.bezierCurveTo(r1[0], r1[1], r1[2], r1[3], r1[4], r1[5]);
                }
                this.element.globalData.renderer.save(!0), s1.clip();
            }
        }, CVMaskElement.prototype.getMaskProperty = MaskElement.prototype.getMaskProperty, CVMaskElement.prototype.destroy = function() {
            this.element = null;
        };
        var operationsMap = {
            1: "source-in",
            2: "source-out",
            3: "source-in",
            4: "source-out"
        };
        function CVShapeData(t1, e1, r1, i1) {
            this.styledShapes = [], this.tr = [
                0,
                0,
                0,
                0,
                0,
                0
            ];
            var a1, s1 = 4;
            "rc" === e1.ty ? s1 = 5 : "el" === e1.ty ? s1 = 6 : "sr" === e1.ty && (s1 = 7), this.sh = ShapePropertyFactory.getShapeProp(t1, e1, s1, t1);
            var n1, o1 = r1.length;
            for(a1 = 0; a1 < o1; a1 += 1)r1[a1].closed || (n1 = {
                transforms: i1.addTransformSequence(r1[a1].transforms),
                trNodes: []
            }, this.styledShapes.push(n1), r1[a1].elements.push(n1));
        }
        function CVShapeElement(t1, e1, r1) {
            this.shapes = [], this.shapesData = t1.shapes, this.stylesList = [], this.itemsData = [], this.prevViewData = [], this.shapeModifiers = [], this.processedElements = [], this.transformsManager = new ShapeTransformManager, this.initElement(t1, e1, r1);
        }
        function CVTextElement(t1, e1, r1) {
            this.textSpans = [], this.yOffset = 0, this.fillColorAnim = !1, this.strokeColorAnim = !1, this.strokeWidthAnim = !1, this.stroke = !1, this.fill = !1, this.justifyOffset = 0, this.currentRender = null, this.renderType = "canvas", this.values = {
                fill: "rgba(0,0,0,0)",
                stroke: "rgba(0,0,0,0)",
                sWidth: 0,
                fValue: ""
            }, this.initElement(t1, e1, r1);
        }
        function CVImageElement(t1, e1, r1) {
            this.assetData = e1.getAssetData(t1.refId), this.img = e1.imageLoader.getAsset(this.assetData), this.initElement(t1, e1, r1);
        }
        function CVSolidElement(t1, e1, r1) {
            this.initElement(t1, e1, r1);
        }
        function CanvasRendererBase(t1, e1) {
            this.animationItem = t1, this.renderConfig = {
                clearCanvas: !e1 || void 0 === e1.clearCanvas || e1.clearCanvas,
                context: e1 && e1.context || null,
                progressiveLoad: e1 && e1.progressiveLoad || !1,
                preserveAspectRatio: e1 && e1.preserveAspectRatio || "xMidYMid meet",
                imagePreserveAspectRatio: e1 && e1.imagePreserveAspectRatio || "xMidYMid slice",
                contentVisibility: e1 && e1.contentVisibility || "visible",
                className: e1 && e1.className || "",
                id: e1 && e1.id || ""
            }, this.renderConfig.dpr = e1 && e1.dpr || 1, this.animationItem.wrapper && (this.renderConfig.dpr = e1 && e1.dpr || window.devicePixelRatio || 1), this.renderedFrame = -1, this.globalData = {
                frameNum: -1,
                _mdf: !1,
                renderConfig: this.renderConfig,
                currentGlobalAlpha: -1
            }, this.contextData = new CVContextData, this.elements = [], this.pendingElements = [], this.transformMat = new Matrix, this.completeLayers = !1, this.rendererType = "canvas";
        }
        function CVCompElement(t1, e1, r1) {
            this.completeLayers = !1, this.layers = t1.layers, this.pendingElements = [], this.elements = createSizedArray(this.layers.length), this.initElement(t1, e1, r1), this.tm = t1.tm ? PropertyFactory.getProp(this, t1.tm, 0, e1.frameRate, this) : {
                _placeholder: !0
            };
        }
        function CanvasRenderer(t1, e1) {
            this.animationItem = t1, this.renderConfig = {
                clearCanvas: !e1 || void 0 === e1.clearCanvas || e1.clearCanvas,
                context: e1 && e1.context || null,
                progressiveLoad: e1 && e1.progressiveLoad || !1,
                preserveAspectRatio: e1 && e1.preserveAspectRatio || "xMidYMid meet",
                imagePreserveAspectRatio: e1 && e1.imagePreserveAspectRatio || "xMidYMid slice",
                contentVisibility: e1 && e1.contentVisibility || "visible",
                className: e1 && e1.className || "",
                id: e1 && e1.id || "",
                runExpressions: !e1 || void 0 === e1.runExpressions || e1.runExpressions
            }, this.renderConfig.dpr = e1 && e1.dpr || 1, this.animationItem.wrapper && (this.renderConfig.dpr = e1 && e1.dpr || window.devicePixelRatio || 1), this.renderedFrame = -1, this.globalData = {
                frameNum: -1,
                _mdf: !1,
                renderConfig: this.renderConfig,
                currentGlobalAlpha: -1
            }, this.contextData = new CVContextData, this.elements = [], this.pendingElements = [], this.transformMat = new Matrix, this.completeLayers = !1, this.rendererType = "canvas";
        }
        function HBaseElement() {}
        function HSolidElement(t1, e1, r1) {
            this.initElement(t1, e1, r1);
        }
        function HShapeElement(t1, e1, r1) {
            this.shapes = [], this.shapesData = t1.shapes, this.stylesList = [], this.shapeModifiers = [], this.itemsData = [], this.processedElements = [], this.animatedContents = [], this.shapesContainer = createNS("g"), this.initElement(t1, e1, r1), this.prevViewData = [], this.currentBBox = {
                x: 999999,
                y: -999999,
                h: 0,
                w: 0
            };
        }
        function HTextElement(t1, e1, r1) {
            this.textSpans = [], this.textPaths = [], this.currentBBox = {
                x: 999999,
                y: -999999,
                h: 0,
                w: 0
            }, this.renderType = "svg", this.isMasked = !1, this.initElement(t1, e1, r1);
        }
        function HCameraElement(t1, e1, r1) {
            this.initFrame(), this.initBaseData(t1, e1, r1), this.initHierarchy();
            var i1 = PropertyFactory.getProp;
            if (this.pe = i1(this, t1.pe, 0, 0, this), t1.ks.p.s ? (this.px = i1(this, t1.ks.p.x, 1, 0, this), this.py = i1(this, t1.ks.p.y, 1, 0, this), this.pz = i1(this, t1.ks.p.z, 1, 0, this)) : this.p = i1(this, t1.ks.p, 1, 0, this), t1.ks.a && (this.a = i1(this, t1.ks.a, 1, 0, this)), t1.ks.or.k.length && t1.ks.or.k[0].to) {
                var a1, s1 = t1.ks.or.k.length;
                for(a1 = 0; a1 < s1; a1 += 1)t1.ks.or.k[a1].to = null, t1.ks.or.k[a1].ti = null;
            }
            this.or = i1(this, t1.ks.or, 1, degToRads, this), this.or.sh = !0, this.rx = i1(this, t1.ks.rx, 0, degToRads, this), this.ry = i1(this, t1.ks.ry, 0, degToRads, this), this.rz = i1(this, t1.ks.rz, 0, degToRads, this), this.mat = new Matrix, this._prevMat = new Matrix, this._isFirstFrame = !0, this.finalTransform = {
                mProp: this
            };
        }
        function HImageElement(t1, e1, r1) {
            this.assetData = e1.getAssetData(t1.refId), this.initElement(t1, e1, r1);
        }
        function HybridRendererBase(t1, e1) {
            this.animationItem = t1, this.layers = null, this.renderedFrame = -1, this.renderConfig = {
                className: e1 && e1.className || "",
                imagePreserveAspectRatio: e1 && e1.imagePreserveAspectRatio || "xMidYMid slice",
                hideOnTransparent: !(e1 && !1 === e1.hideOnTransparent),
                filterSize: {
                    width: e1 && e1.filterSize && e1.filterSize.width || "400%",
                    height: e1 && e1.filterSize && e1.filterSize.height || "400%",
                    x: e1 && e1.filterSize && e1.filterSize.x || "-100%",
                    y: e1 && e1.filterSize && e1.filterSize.y || "-100%"
                }
            }, this.globalData = {
                _mdf: !1,
                frameNum: -1,
                renderConfig: this.renderConfig
            }, this.pendingElements = [], this.elements = [], this.threeDElements = [], this.destroyed = !1, this.camera = null, this.supports3d = !0, this.rendererType = "html";
        }
        function HCompElement(t1, e1, r1) {
            this.layers = t1.layers, this.supports3d = !t1.hasMask, this.completeLayers = !1, this.pendingElements = [], this.elements = this.layers ? createSizedArray(this.layers.length) : [], this.initElement(t1, e1, r1), this.tm = t1.tm ? PropertyFactory.getProp(this, t1.tm, 0, e1.frameRate, this) : {
                _placeholder: !0
            };
        }
        function HybridRenderer(t1, e1) {
            this.animationItem = t1, this.layers = null, this.renderedFrame = -1, this.renderConfig = {
                className: e1 && e1.className || "",
                imagePreserveAspectRatio: e1 && e1.imagePreserveAspectRatio || "xMidYMid slice",
                hideOnTransparent: !(e1 && !1 === e1.hideOnTransparent),
                filterSize: {
                    width: e1 && e1.filterSize && e1.filterSize.width || "400%",
                    height: e1 && e1.filterSize && e1.filterSize.height || "400%",
                    x: e1 && e1.filterSize && e1.filterSize.x || "-100%",
                    y: e1 && e1.filterSize && e1.filterSize.y || "-100%"
                },
                runExpressions: !e1 || void 0 === e1.runExpressions || e1.runExpressions
            }, this.globalData = {
                _mdf: !1,
                frameNum: -1,
                renderConfig: this.renderConfig
            }, this.pendingElements = [], this.elements = [], this.threeDElements = [], this.destroyed = !1, this.camera = null, this.supports3d = !0, this.rendererType = "html";
        }
        CVBaseElement.prototype = {
            createElements: function() {},
            initRendererElement: function() {},
            createContainerElements: function() {
                if (this.data.tt >= 1) {
                    this.buffers = [];
                    var t1 = this.globalData.canvasContext, e1 = assetLoader.createCanvas(t1.canvas.width, t1.canvas.height);
                    this.buffers.push(e1);
                    var r1 = assetLoader.createCanvas(t1.canvas.width, t1.canvas.height);
                    this.buffers.push(r1), this.data.tt >= 3 && !document._isProxy && assetLoader.loadLumaCanvas();
                }
                this.canvasContext = this.globalData.canvasContext, this.transformCanvas = this.globalData.transformCanvas, this.renderableEffectsManager = new CVEffects(this);
            },
            createContent: function() {},
            setBlendMode: function() {
                var t1 = this.globalData;
                if (t1.blendMode !== this.data.bm) {
                    t1.blendMode = this.data.bm;
                    var e1 = getBlendMode(this.data.bm);
                    t1.canvasContext.globalCompositeOperation = e1;
                }
            },
            createRenderableComponents: function() {
                this.maskManager = new CVMaskElement(this.data, this);
            },
            hideElement: function() {
                this.hidden || this.isInRange && !this.isTransparent || (this.hidden = !0);
            },
            showElement: function() {
                this.isInRange && !this.isTransparent && (this.hidden = !1, this._isFirstFrame = !0, this.maskManager._isFirstFrame = !0);
            },
            clearCanvas: function(t1) {
                t1.clearRect(this.transformCanvas.tx, this.transformCanvas.ty, this.transformCanvas.w * this.transformCanvas.sx, this.transformCanvas.h * this.transformCanvas.sy);
            },
            prepareLayer: function() {
                if (this.data.tt >= 1) {
                    var t1 = this.buffers[0].getContext("2d");
                    this.clearCanvas(t1), t1.drawImage(this.canvasContext.canvas, 0, 0), this.currentTransform = this.canvasContext.getTransform(), this.canvasContext.setTransform(1, 0, 0, 1, 0, 0), this.clearCanvas(this.canvasContext), this.canvasContext.setTransform(this.currentTransform);
                }
            },
            exitLayer: function() {
                if (this.data.tt >= 1) {
                    var t1 = this.buffers[1], e1 = t1.getContext("2d");
                    if (this.clearCanvas(e1), e1.drawImage(this.canvasContext.canvas, 0, 0), this.canvasContext.setTransform(1, 0, 0, 1, 0, 0), this.clearCanvas(this.canvasContext), this.canvasContext.setTransform(this.currentTransform), this.comp.getElementById("tp" in this.data ? this.data.tp : this.data.ind - 1).renderFrame(!0), this.canvasContext.setTransform(1, 0, 0, 1, 0, 0), this.data.tt >= 3 && !document._isProxy) {
                        var r1 = assetLoader.getLumaCanvas(this.canvasContext.canvas);
                        r1.getContext("2d").drawImage(this.canvasContext.canvas, 0, 0), this.clearCanvas(this.canvasContext), this.canvasContext.drawImage(r1, 0, 0);
                    }
                    this.canvasContext.globalCompositeOperation = operationsMap[this.data.tt], this.canvasContext.drawImage(t1, 0, 0), this.canvasContext.globalCompositeOperation = "destination-over", this.canvasContext.drawImage(this.buffers[0], 0, 0), this.canvasContext.setTransform(this.currentTransform), this.canvasContext.globalCompositeOperation = "source-over";
                }
            },
            renderFrame: function(t1) {
                if (!this.hidden && !this.data.hd && (1 !== this.data.td || t1)) {
                    this.renderTransform(), this.renderRenderable(), this.setBlendMode();
                    var e1 = 0 === this.data.ty;
                    this.prepareLayer(), this.globalData.renderer.save(e1), this.globalData.renderer.ctxTransform(this.finalTransform.mat.props), this.globalData.renderer.ctxOpacity(this.finalTransform.mProp.o.v), this.renderInnerContent(), this.globalData.renderer.restore(e1), this.exitLayer(), this.maskManager.hasMasks && this.globalData.renderer.restore(!0), this._isFirstFrame && (this._isFirstFrame = !1);
                }
            },
            destroy: function() {
                this.canvasContext = null, this.data = null, this.globalData = null, this.maskManager.destroy();
            },
            mHelper: new Matrix
        }, CVBaseElement.prototype.hide = CVBaseElement.prototype.hideElement, CVBaseElement.prototype.show = CVBaseElement.prototype.showElement, CVShapeData.prototype.setAsAnimated = SVGShapeData.prototype.setAsAnimated, extendPrototype([
            BaseElement,
            TransformElement,
            CVBaseElement,
            IShapeElement,
            HierarchyElement,
            FrameElement,
            RenderableElement
        ], CVShapeElement), CVShapeElement.prototype.initElement = RenderableDOMElement.prototype.initElement, CVShapeElement.prototype.transformHelper = {
            opacity: 1,
            _opMdf: !1
        }, CVShapeElement.prototype.dashResetter = [], CVShapeElement.prototype.createContent = function() {
            this.searchShapes(this.shapesData, this.itemsData, this.prevViewData, !0, []);
        }, CVShapeElement.prototype.createStyleElement = function(t1, e1) {
            var r1 = {
                data: t1,
                type: t1.ty,
                preTransforms: this.transformsManager.addTransformSequence(e1),
                transforms: [],
                elements: [],
                closed: !0 === t1.hd
            }, i1 = {};
            if ("fl" === t1.ty || "st" === t1.ty ? (i1.c = PropertyFactory.getProp(this, t1.c, 1, 255, this), i1.c.k || (r1.co = "rgb(" + bmFloor(i1.c.v[0]) + "," + bmFloor(i1.c.v[1]) + "," + bmFloor(i1.c.v[2]) + ")")) : "gf" !== t1.ty && "gs" !== t1.ty || (i1.s = PropertyFactory.getProp(this, t1.s, 1, null, this), i1.e = PropertyFactory.getProp(this, t1.e, 1, null, this), i1.h = PropertyFactory.getProp(this, t1.h || {
                k: 0
            }, 0, .01, this), i1.a = PropertyFactory.getProp(this, t1.a || {
                k: 0
            }, 0, degToRads, this), i1.g = new GradientProperty(this, t1.g, this)), i1.o = PropertyFactory.getProp(this, t1.o, 0, .01, this), "st" === t1.ty || "gs" === t1.ty) {
                if (r1.lc = lineCapEnum[t1.lc || 2], r1.lj = lineJoinEnum[t1.lj || 2], 1 == t1.lj && (r1.ml = t1.ml), i1.w = PropertyFactory.getProp(this, t1.w, 0, null, this), i1.w.k || (r1.wi = i1.w.v), t1.d) {
                    var a1 = new DashProperty(this, t1.d, "canvas", this);
                    i1.d = a1, i1.d.k || (r1.da = i1.d.dashArray, r1.do = i1.d.dashoffset[0]);
                }
            } else r1.r = 2 === t1.r ? "evenodd" : "nonzero";
            return this.stylesList.push(r1), i1.style = r1, i1;
        }, CVShapeElement.prototype.createGroupElement = function() {
            return {
                it: [],
                prevViewData: []
            };
        }, CVShapeElement.prototype.createTransformElement = function(t1) {
            return {
                transform: {
                    opacity: 1,
                    _opMdf: !1,
                    key: this.transformsManager.getNewKey(),
                    op: PropertyFactory.getProp(this, t1.o, 0, .01, this),
                    mProps: TransformPropertyFactory.getTransformProperty(this, t1, this)
                }
            };
        }, CVShapeElement.prototype.createShapeElement = function(t1) {
            var e1 = new CVShapeData(this, t1, this.stylesList, this.transformsManager);
            return this.shapes.push(e1), this.addShapeToModifiers(e1), e1;
        }, CVShapeElement.prototype.reloadShapes = function() {
            var t1;
            this._isFirstFrame = !0;
            var e1 = this.itemsData.length;
            for(t1 = 0; t1 < e1; t1 += 1)this.prevViewData[t1] = this.itemsData[t1];
            for(this.searchShapes(this.shapesData, this.itemsData, this.prevViewData, !0, []), e1 = this.dynamicProperties.length, t1 = 0; t1 < e1; t1 += 1)this.dynamicProperties[t1].getValue();
            this.renderModifiers(), this.transformsManager.processSequences(this._isFirstFrame);
        }, CVShapeElement.prototype.addTransformToStyleList = function(t1) {
            var e1, r1 = this.stylesList.length;
            for(e1 = 0; e1 < r1; e1 += 1)this.stylesList[e1].closed || this.stylesList[e1].transforms.push(t1);
        }, CVShapeElement.prototype.removeTransformFromStyleList = function() {
            var t1, e1 = this.stylesList.length;
            for(t1 = 0; t1 < e1; t1 += 1)this.stylesList[t1].closed || this.stylesList[t1].transforms.pop();
        }, CVShapeElement.prototype.closeStyles = function(t1) {
            var e1, r1 = t1.length;
            for(e1 = 0; e1 < r1; e1 += 1)t1[e1].closed = !0;
        }, CVShapeElement.prototype.searchShapes = function(t1, e1, r1, i1, a1) {
            var s1, n1, o1, h1, l1, p1, f1 = t1.length - 1, c1 = [], m1 = [], d1 = [].concat(a1);
            for(s1 = f1; s1 >= 0; s1 -= 1){
                if ((h1 = this.searchProcessedElement(t1[s1])) ? e1[s1] = r1[h1 - 1] : t1[s1]._shouldRender = i1, "fl" === t1[s1].ty || "st" === t1[s1].ty || "gf" === t1[s1].ty || "gs" === t1[s1].ty) h1 ? e1[s1].style.closed = !1 : e1[s1] = this.createStyleElement(t1[s1], d1), c1.push(e1[s1].style);
                else if ("gr" === t1[s1].ty) {
                    if (h1) for(o1 = e1[s1].it.length, n1 = 0; n1 < o1; n1 += 1)e1[s1].prevViewData[n1] = e1[s1].it[n1];
                    else e1[s1] = this.createGroupElement(t1[s1]);
                    this.searchShapes(t1[s1].it, e1[s1].it, e1[s1].prevViewData, i1, d1);
                } else "tr" === t1[s1].ty ? (h1 || (p1 = this.createTransformElement(t1[s1]), e1[s1] = p1), d1.push(e1[s1]), this.addTransformToStyleList(e1[s1])) : "sh" === t1[s1].ty || "rc" === t1[s1].ty || "el" === t1[s1].ty || "sr" === t1[s1].ty ? h1 || (e1[s1] = this.createShapeElement(t1[s1])) : "tm" === t1[s1].ty || "rd" === t1[s1].ty || "pb" === t1[s1].ty || "zz" === t1[s1].ty || "op" === t1[s1].ty ? (h1 ? (l1 = e1[s1]).closed = !1 : ((l1 = ShapeModifiers.getModifier(t1[s1].ty)).init(this, t1[s1]), e1[s1] = l1, this.shapeModifiers.push(l1)), m1.push(l1)) : "rp" === t1[s1].ty && (h1 ? (l1 = e1[s1]).closed = !0 : (l1 = ShapeModifiers.getModifier(t1[s1].ty), e1[s1] = l1, l1.init(this, t1, s1, e1), this.shapeModifiers.push(l1), i1 = !1), m1.push(l1));
                this.addProcessedElement(t1[s1], s1 + 1);
            }
            for(this.removeTransformFromStyleList(), this.closeStyles(c1), f1 = m1.length, s1 = 0; s1 < f1; s1 += 1)m1[s1].closed = !0;
        }, CVShapeElement.prototype.renderInnerContent = function() {
            this.transformHelper.opacity = 1, this.transformHelper._opMdf = !1, this.renderModifiers(), this.transformsManager.processSequences(this._isFirstFrame), this.renderShape(this.transformHelper, this.shapesData, this.itemsData, !0);
        }, CVShapeElement.prototype.renderShapeTransform = function(t1, e1) {
            (t1._opMdf || e1.op._mdf || this._isFirstFrame) && (e1.opacity = t1.opacity, e1.opacity *= e1.op.v, e1._opMdf = !0);
        }, CVShapeElement.prototype.drawLayer = function() {
            var t1, e1, r1, i1, a1, s1, n1, o1, h1, l1 = this.stylesList.length, p1 = this.globalData.renderer, f1 = this.globalData.canvasContext;
            for(t1 = 0; t1 < l1; t1 += 1)if (("st" !== (o1 = (h1 = this.stylesList[t1]).type) && "gs" !== o1 || 0 !== h1.wi) && h1.data._shouldRender && 0 !== h1.coOp && 0 !== this.globalData.currentGlobalAlpha) {
                for(p1.save(), s1 = h1.elements, "st" === o1 || "gs" === o1 ? (f1.strokeStyle = "st" === o1 ? h1.co : h1.grd, f1.lineWidth = h1.wi, f1.lineCap = h1.lc, f1.lineJoin = h1.lj, f1.miterLimit = h1.ml || 0) : f1.fillStyle = "fl" === o1 ? h1.co : h1.grd, p1.ctxOpacity(h1.coOp), "st" !== o1 && "gs" !== o1 && f1.beginPath(), p1.ctxTransform(h1.preTransforms.finalTransform.props), r1 = s1.length, e1 = 0; e1 < r1; e1 += 1){
                    for("st" !== o1 && "gs" !== o1 || (f1.beginPath(), h1.da && (f1.setLineDash(h1.da), f1.lineDashOffset = h1.do)), a1 = (n1 = s1[e1].trNodes).length, i1 = 0; i1 < a1; i1 += 1)"m" === n1[i1].t ? f1.moveTo(n1[i1].p[0], n1[i1].p[1]) : "c" === n1[i1].t ? f1.bezierCurveTo(n1[i1].pts[0], n1[i1].pts[1], n1[i1].pts[2], n1[i1].pts[3], n1[i1].pts[4], n1[i1].pts[5]) : f1.closePath();
                    "st" !== o1 && "gs" !== o1 || (f1.stroke(), h1.da && f1.setLineDash(this.dashResetter));
                }
                "st" !== o1 && "gs" !== o1 && f1.fill(h1.r), p1.restore();
            }
        }, CVShapeElement.prototype.renderShape = function(t1, e1, r1, i1) {
            var a1, s1;
            for(s1 = t1, a1 = e1.length - 1; a1 >= 0; a1 -= 1)"tr" === e1[a1].ty ? (s1 = r1[a1].transform, this.renderShapeTransform(t1, s1)) : "sh" === e1[a1].ty || "el" === e1[a1].ty || "rc" === e1[a1].ty || "sr" === e1[a1].ty ? this.renderPath(e1[a1], r1[a1]) : "fl" === e1[a1].ty ? this.renderFill(e1[a1], r1[a1], s1) : "st" === e1[a1].ty ? this.renderStroke(e1[a1], r1[a1], s1) : "gf" === e1[a1].ty || "gs" === e1[a1].ty ? this.renderGradientFill(e1[a1], r1[a1], s1) : "gr" === e1[a1].ty ? this.renderShape(s1, e1[a1].it, r1[a1].it) : e1[a1].ty;
            i1 && this.drawLayer();
        }, CVShapeElement.prototype.renderStyledShape = function(t1, e1) {
            if (this._isFirstFrame || e1._mdf || t1.transforms._mdf) {
                var r1, i1, a1, s1 = t1.trNodes, n1 = e1.paths, o1 = n1._length;
                s1.length = 0;
                var h1 = t1.transforms.finalTransform;
                for(a1 = 0; a1 < o1; a1 += 1){
                    var l1 = n1.shapes[a1];
                    if (l1 && l1.v) {
                        for(i1 = l1._length, r1 = 1; r1 < i1; r1 += 1)1 === r1 && s1.push({
                            t: "m",
                            p: h1.applyToPointArray(l1.v[0][0], l1.v[0][1], 0)
                        }), s1.push({
                            t: "c",
                            pts: h1.applyToTriplePoints(l1.o[r1 - 1], l1.i[r1], l1.v[r1])
                        });
                        1 === i1 && s1.push({
                            t: "m",
                            p: h1.applyToPointArray(l1.v[0][0], l1.v[0][1], 0)
                        }), l1.c && i1 && (s1.push({
                            t: "c",
                            pts: h1.applyToTriplePoints(l1.o[r1 - 1], l1.i[0], l1.v[0])
                        }), s1.push({
                            t: "z"
                        }));
                    }
                }
                t1.trNodes = s1;
            }
        }, CVShapeElement.prototype.renderPath = function(t1, e1) {
            if (!0 !== t1.hd && t1._shouldRender) {
                var r1, i1 = e1.styledShapes.length;
                for(r1 = 0; r1 < i1; r1 += 1)this.renderStyledShape(e1.styledShapes[r1], e1.sh);
            }
        }, CVShapeElement.prototype.renderFill = function(t1, e1, r1) {
            var i1 = e1.style;
            (e1.c._mdf || this._isFirstFrame) && (i1.co = "rgb(" + bmFloor(e1.c.v[0]) + "," + bmFloor(e1.c.v[1]) + "," + bmFloor(e1.c.v[2]) + ")"), (e1.o._mdf || r1._opMdf || this._isFirstFrame) && (i1.coOp = e1.o.v * r1.opacity);
        }, CVShapeElement.prototype.renderGradientFill = function(t1, e1, r1) {
            var i1, a1 = e1.style;
            if (!a1.grd || e1.g._mdf || e1.s._mdf || e1.e._mdf || 1 !== t1.t && (e1.h._mdf || e1.a._mdf)) {
                var s1, n1 = this.globalData.canvasContext, o1 = e1.s.v, h1 = e1.e.v;
                if (1 === t1.t) i1 = n1.createLinearGradient(o1[0], o1[1], h1[0], h1[1]);
                else {
                    var l1 = Math.sqrt(Math.pow(o1[0] - h1[0], 2) + Math.pow(o1[1] - h1[1], 2)), p1 = Math.atan2(h1[1] - o1[1], h1[0] - o1[0]), f1 = e1.h.v;
                    f1 >= 1 ? f1 = .99 : f1 <= -1 && (f1 = -0.99);
                    var c1 = l1 * f1, m1 = Math.cos(p1 + e1.a.v) * c1 + o1[0], d1 = Math.sin(p1 + e1.a.v) * c1 + o1[1];
                    i1 = n1.createRadialGradient(m1, d1, 0, o1[0], o1[1], l1);
                }
                var u1 = t1.g.p, y1 = e1.g.c, g1 = 1;
                for(s1 = 0; s1 < u1; s1 += 1)e1.g._hasOpacity && e1.g._collapsable && (g1 = e1.g.o[2 * s1 + 1]), i1.addColorStop(y1[4 * s1] / 100, "rgba(" + y1[4 * s1 + 1] + "," + y1[4 * s1 + 2] + "," + y1[4 * s1 + 3] + "," + g1 + ")");
                a1.grd = i1;
            }
            a1.coOp = e1.o.v * r1.opacity;
        }, CVShapeElement.prototype.renderStroke = function(t1, e1, r1) {
            var i1 = e1.style, a1 = e1.d;
            a1 && (a1._mdf || this._isFirstFrame) && (i1.da = a1.dashArray, i1.do = a1.dashoffset[0]), (e1.c._mdf || this._isFirstFrame) && (i1.co = "rgb(" + bmFloor(e1.c.v[0]) + "," + bmFloor(e1.c.v[1]) + "," + bmFloor(e1.c.v[2]) + ")"), (e1.o._mdf || r1._opMdf || this._isFirstFrame) && (i1.coOp = e1.o.v * r1.opacity), (e1.w._mdf || this._isFirstFrame) && (i1.wi = e1.w.v);
        }, CVShapeElement.prototype.destroy = function() {
            this.shapesData = null, this.globalData = null, this.canvasContext = null, this.stylesList.length = 0, this.itemsData.length = 0;
        }, extendPrototype([
            BaseElement,
            TransformElement,
            CVBaseElement,
            HierarchyElement,
            FrameElement,
            RenderableElement,
            ITextElement
        ], CVTextElement), CVTextElement.prototype.tHelper = createTag("canvas").getContext("2d"), CVTextElement.prototype.buildNewText = function() {
            var t1 = this.textProperty.currentData;
            this.renderedLetters = createSizedArray(t1.l ? t1.l.length : 0);
            var e1 = !1;
            t1.fc ? (e1 = !0, this.values.fill = this.buildColor(t1.fc)) : this.values.fill = "rgba(0,0,0,0)", this.fill = e1;
            var r1 = !1;
            t1.sc && (r1 = !0, this.values.stroke = this.buildColor(t1.sc), this.values.sWidth = t1.sw);
            var i1, a1, s1, n1, o1, h1, l1, p1, f1, c1, m1, d1, u1 = this.globalData.fontManager.getFontByName(t1.f), y1 = t1.l, g1 = this.mHelper;
            this.stroke = r1, this.values.fValue = t1.finalSize + "px " + this.globalData.fontManager.getFontByName(t1.f).fFamily, a1 = t1.finalText.length;
            var v1 = this.data.singleShape, b1 = .001 * t1.tr * t1.finalSize, x1 = 0, P1 = 0, E1 = !0, S1 = 0;
            for(i1 = 0; i1 < a1; i1 += 1){
                n1 = (s1 = this.globalData.fontManager.getCharData(t1.finalText[i1], u1.fStyle, this.globalData.fontManager.getFontByName(t1.f).fFamily)) && s1.data || {}, g1.reset(), v1 && y1[i1].n && (x1 = -b1, P1 += t1.yOffset, P1 += E1 ? 1 : 0, E1 = !1), f1 = (l1 = n1.shapes ? n1.shapes[0].it : []).length, g1.scale(t1.finalSize / 100, t1.finalSize / 100), v1 && this.applyTextPropertiesToMatrix(t1, g1, y1[i1].line, x1, P1), m1 = createSizedArray(f1 - 1);
                var C1 = 0;
                for(p1 = 0; p1 < f1; p1 += 1)if ("sh" === l1[p1].ty) {
                    for(h1 = l1[p1].ks.k.i.length, c1 = l1[p1].ks.k, d1 = [], o1 = 1; o1 < h1; o1 += 1)1 === o1 && d1.push(g1.applyToX(c1.v[0][0], c1.v[0][1], 0), g1.applyToY(c1.v[0][0], c1.v[0][1], 0)), d1.push(g1.applyToX(c1.o[o1 - 1][0], c1.o[o1 - 1][1], 0), g1.applyToY(c1.o[o1 - 1][0], c1.o[o1 - 1][1], 0), g1.applyToX(c1.i[o1][0], c1.i[o1][1], 0), g1.applyToY(c1.i[o1][0], c1.i[o1][1], 0), g1.applyToX(c1.v[o1][0], c1.v[o1][1], 0), g1.applyToY(c1.v[o1][0], c1.v[o1][1], 0));
                    d1.push(g1.applyToX(c1.o[o1 - 1][0], c1.o[o1 - 1][1], 0), g1.applyToY(c1.o[o1 - 1][0], c1.o[o1 - 1][1], 0), g1.applyToX(c1.i[0][0], c1.i[0][1], 0), g1.applyToY(c1.i[0][0], c1.i[0][1], 0), g1.applyToX(c1.v[0][0], c1.v[0][1], 0), g1.applyToY(c1.v[0][0], c1.v[0][1], 0)), m1[C1] = d1, C1 += 1;
                }
                v1 && (x1 += y1[i1].l, x1 += b1), this.textSpans[S1] ? this.textSpans[S1].elem = m1 : this.textSpans[S1] = {
                    elem: m1
                }, S1 += 1;
            }
        }, CVTextElement.prototype.renderInnerContent = function() {
            var t1, e1, r1, i1, a1, s1, n1 = this.canvasContext;
            n1.font = this.values.fValue, n1.lineCap = "butt", n1.lineJoin = "miter", n1.miterLimit = 4, this.data.singleShape || this.textAnimator.getMeasures(this.textProperty.currentData, this.lettersChangedFlag);
            var o1, h1 = this.textAnimator.renderedLetters, l1 = this.textProperty.currentData.l;
            e1 = l1.length;
            var p1, f1, c1 = null, m1 = null, d1 = null;
            for(t1 = 0; t1 < e1; t1 += 1)if (!l1[t1].n) {
                if ((o1 = h1[t1]) && (this.globalData.renderer.save(), this.globalData.renderer.ctxTransform(o1.p), this.globalData.renderer.ctxOpacity(o1.o)), this.fill) {
                    for(o1 && o1.fc ? c1 !== o1.fc && (c1 = o1.fc, n1.fillStyle = o1.fc) : c1 !== this.values.fill && (c1 = this.values.fill, n1.fillStyle = this.values.fill), i1 = (p1 = this.textSpans[t1].elem).length, this.globalData.canvasContext.beginPath(), r1 = 0; r1 < i1; r1 += 1)for(s1 = (f1 = p1[r1]).length, this.globalData.canvasContext.moveTo(f1[0], f1[1]), a1 = 2; a1 < s1; a1 += 6)this.globalData.canvasContext.bezierCurveTo(f1[a1], f1[a1 + 1], f1[a1 + 2], f1[a1 + 3], f1[a1 + 4], f1[a1 + 5]);
                    this.globalData.canvasContext.closePath(), this.globalData.canvasContext.fill();
                }
                if (this.stroke) {
                    for(o1 && o1.sw ? d1 !== o1.sw && (d1 = o1.sw, n1.lineWidth = o1.sw) : d1 !== this.values.sWidth && (d1 = this.values.sWidth, n1.lineWidth = this.values.sWidth), o1 && o1.sc ? m1 !== o1.sc && (m1 = o1.sc, n1.strokeStyle = o1.sc) : m1 !== this.values.stroke && (m1 = this.values.stroke, n1.strokeStyle = this.values.stroke), i1 = (p1 = this.textSpans[t1].elem).length, this.globalData.canvasContext.beginPath(), r1 = 0; r1 < i1; r1 += 1)for(s1 = (f1 = p1[r1]).length, this.globalData.canvasContext.moveTo(f1[0], f1[1]), a1 = 2; a1 < s1; a1 += 6)this.globalData.canvasContext.bezierCurveTo(f1[a1], f1[a1 + 1], f1[a1 + 2], f1[a1 + 3], f1[a1 + 4], f1[a1 + 5]);
                    this.globalData.canvasContext.closePath(), this.globalData.canvasContext.stroke();
                }
                o1 && this.globalData.renderer.restore();
            }
        }, extendPrototype([
            BaseElement,
            TransformElement,
            CVBaseElement,
            HierarchyElement,
            FrameElement,
            RenderableElement
        ], CVImageElement), CVImageElement.prototype.initElement = SVGShapeElement.prototype.initElement, CVImageElement.prototype.prepareFrame = IImageElement.prototype.prepareFrame, CVImageElement.prototype.createContent = function() {
            if (this.img.width && (this.assetData.w !== this.img.width || this.assetData.h !== this.img.height)) {
                var t1 = createTag("canvas");
                t1.width = this.assetData.w, t1.height = this.assetData.h;
                var e1, r1, i1 = t1.getContext("2d"), a1 = this.img.width, s1 = this.img.height, n1 = a1 / s1, o1 = this.assetData.w / this.assetData.h, h1 = this.assetData.pr || this.globalData.renderConfig.imagePreserveAspectRatio;
                n1 > o1 && "xMidYMid slice" === h1 || n1 < o1 && "xMidYMid slice" !== h1 ? e1 = (r1 = s1) * o1 : r1 = (e1 = a1) / o1, i1.drawImage(this.img, (a1 - e1) / 2, (s1 - r1) / 2, e1, r1, 0, 0, this.assetData.w, this.assetData.h), this.img = t1;
            }
        }, CVImageElement.prototype.renderInnerContent = function() {
            this.canvasContext.drawImage(this.img, 0, 0);
        }, CVImageElement.prototype.destroy = function() {
            this.img = null;
        }, extendPrototype([
            BaseElement,
            TransformElement,
            CVBaseElement,
            HierarchyElement,
            FrameElement,
            RenderableElement
        ], CVSolidElement), CVSolidElement.prototype.initElement = SVGShapeElement.prototype.initElement, CVSolidElement.prototype.prepareFrame = IImageElement.prototype.prepareFrame, CVSolidElement.prototype.renderInnerContent = function() {
            var t1 = this.canvasContext;
            t1.fillStyle = this.data.sc, t1.fillRect(0, 0, this.data.sw, this.data.sh);
        }, extendPrototype([
            BaseRenderer
        ], CanvasRendererBase), CanvasRendererBase.prototype.createShape = function(t1) {
            return new CVShapeElement(t1, this.globalData, this);
        }, CanvasRendererBase.prototype.createText = function(t1) {
            return new CVTextElement(t1, this.globalData, this);
        }, CanvasRendererBase.prototype.createImage = function(t1) {
            return new CVImageElement(t1, this.globalData, this);
        }, CanvasRendererBase.prototype.createSolid = function(t1) {
            return new CVSolidElement(t1, this.globalData, this);
        }, CanvasRendererBase.prototype.createNull = SVGRenderer.prototype.createNull, CanvasRendererBase.prototype.ctxTransform = function(t1) {
            if (1 !== t1[0] || 0 !== t1[1] || 0 !== t1[4] || 1 !== t1[5] || 0 !== t1[12] || 0 !== t1[13]) {
                if (this.renderConfig.clearCanvas) {
                    this.transformMat.cloneFromProps(t1);
                    var e1 = this.contextData.getTransform(), r1 = e1.props;
                    this.transformMat.transform(r1[0], r1[1], r1[2], r1[3], r1[4], r1[5], r1[6], r1[7], r1[8], r1[9], r1[10], r1[11], r1[12], r1[13], r1[14], r1[15]), e1.cloneFromProps(this.transformMat.props);
                    var i1 = e1.props;
                    this.canvasContext.setTransform(i1[0], i1[1], i1[4], i1[5], i1[12], i1[13]);
                } else this.canvasContext.transform(t1[0], t1[1], t1[4], t1[5], t1[12], t1[13]);
            }
        }, CanvasRendererBase.prototype.ctxOpacity = function(t1) {
            var e1 = this.contextData.getOpacity();
            if (!this.renderConfig.clearCanvas) return this.canvasContext.globalAlpha *= t1 < 0 ? 0 : t1, void (this.globalData.currentGlobalAlpha = e1);
            e1 *= t1 < 0 ? 0 : t1, this.contextData.setOpacity(e1), this.globalData.currentGlobalAlpha !== e1 && (this.canvasContext.globalAlpha = e1, this.globalData.currentGlobalAlpha = e1);
        }, CanvasRendererBase.prototype.reset = function() {
            this.renderConfig.clearCanvas ? this.contextData.reset() : this.canvasContext.restore();
        }, CanvasRendererBase.prototype.save = function(t1) {
            this.renderConfig.clearCanvas ? (t1 && this.canvasContext.save(), this.contextData.push()) : this.canvasContext.save();
        }, CanvasRendererBase.prototype.restore = function(t1) {
            if (this.renderConfig.clearCanvas) {
                t1 && (this.canvasContext.restore(), this.globalData.blendMode = "source-over");
                var e1 = this.contextData.pop(), r1 = e1.transform, i1 = e1.opacity;
                this.canvasContext.setTransform(r1[0], r1[1], r1[4], r1[5], r1[12], r1[13]), this.globalData.currentGlobalAlpha !== i1 && (this.canvasContext.globalAlpha = i1, this.globalData.currentGlobalAlpha = i1);
            } else this.canvasContext.restore();
        }, CanvasRendererBase.prototype.configAnimation = function(t1) {
            if (this.animationItem.wrapper) {
                this.animationItem.container = createTag("canvas");
                var e1 = this.animationItem.container.style;
                e1.width = "100%", e1.height = "100%";
                var r1 = "0px 0px 0px";
                e1.transformOrigin = r1, e1.mozTransformOrigin = r1, e1.webkitTransformOrigin = r1, e1["-webkit-transform"] = r1, e1.contentVisibility = this.renderConfig.contentVisibility, this.animationItem.wrapper.appendChild(this.animationItem.container), this.canvasContext = this.animationItem.container.getContext("2d"), this.renderConfig.className && this.animationItem.container.setAttribute("class", this.renderConfig.className), this.renderConfig.id && this.animationItem.container.setAttribute("id", this.renderConfig.id);
            } else this.canvasContext = this.renderConfig.context;
            this.data = t1, this.layers = t1.layers, this.transformCanvas = {
                w: t1.w,
                h: t1.h,
                sx: 0,
                sy: 0,
                tx: 0,
                ty: 0
            }, this.setupGlobalData(t1, document.body), this.globalData.canvasContext = this.canvasContext, this.globalData.renderer = this, this.globalData.isDashed = !1, this.globalData.progressiveLoad = this.renderConfig.progressiveLoad, this.globalData.transformCanvas = this.transformCanvas, this.elements = createSizedArray(t1.layers.length), this.updateContainerSize();
        }, CanvasRendererBase.prototype.updateContainerSize = function(t1, e1) {
            var r1, i1, a1, s1;
            if (this.reset(), t1 ? (r1 = t1, i1 = e1, this.canvasContext.canvas.width = r1, this.canvasContext.canvas.height = i1) : (this.animationItem.wrapper && this.animationItem.container ? (r1 = this.animationItem.wrapper.offsetWidth, i1 = this.animationItem.wrapper.offsetHeight) : (r1 = this.canvasContext.canvas.width, i1 = this.canvasContext.canvas.height), this.canvasContext.canvas.width = r1 * this.renderConfig.dpr, this.canvasContext.canvas.height = i1 * this.renderConfig.dpr), -1 !== this.renderConfig.preserveAspectRatio.indexOf("meet") || -1 !== this.renderConfig.preserveAspectRatio.indexOf("slice")) {
                var n1 = this.renderConfig.preserveAspectRatio.split(" "), o1 = n1[1] || "meet", h1 = n1[0] || "xMidYMid", l1 = h1.substr(0, 4), p1 = h1.substr(4);
                a1 = r1 / i1, (s1 = this.transformCanvas.w / this.transformCanvas.h) > a1 && "meet" === o1 || s1 < a1 && "slice" === o1 ? (this.transformCanvas.sx = r1 / (this.transformCanvas.w / this.renderConfig.dpr), this.transformCanvas.sy = r1 / (this.transformCanvas.w / this.renderConfig.dpr)) : (this.transformCanvas.sx = i1 / (this.transformCanvas.h / this.renderConfig.dpr), this.transformCanvas.sy = i1 / (this.transformCanvas.h / this.renderConfig.dpr)), this.transformCanvas.tx = "xMid" === l1 && (s1 < a1 && "meet" === o1 || s1 > a1 && "slice" === o1) ? (r1 - this.transformCanvas.w * (i1 / this.transformCanvas.h)) / 2 * this.renderConfig.dpr : "xMax" === l1 && (s1 < a1 && "meet" === o1 || s1 > a1 && "slice" === o1) ? (r1 - this.transformCanvas.w * (i1 / this.transformCanvas.h)) * this.renderConfig.dpr : 0, this.transformCanvas.ty = "YMid" === p1 && (s1 > a1 && "meet" === o1 || s1 < a1 && "slice" === o1) ? (i1 - this.transformCanvas.h * (r1 / this.transformCanvas.w)) / 2 * this.renderConfig.dpr : "YMax" === p1 && (s1 > a1 && "meet" === o1 || s1 < a1 && "slice" === o1) ? (i1 - this.transformCanvas.h * (r1 / this.transformCanvas.w)) * this.renderConfig.dpr : 0;
            } else "none" === this.renderConfig.preserveAspectRatio ? (this.transformCanvas.sx = r1 / (this.transformCanvas.w / this.renderConfig.dpr), this.transformCanvas.sy = i1 / (this.transformCanvas.h / this.renderConfig.dpr), this.transformCanvas.tx = 0, this.transformCanvas.ty = 0) : (this.transformCanvas.sx = this.renderConfig.dpr, this.transformCanvas.sy = this.renderConfig.dpr, this.transformCanvas.tx = 0, this.transformCanvas.ty = 0);
            this.transformCanvas.props = [
                this.transformCanvas.sx,
                0,
                0,
                0,
                0,
                this.transformCanvas.sy,
                0,
                0,
                0,
                0,
                1,
                0,
                this.transformCanvas.tx,
                this.transformCanvas.ty,
                0,
                1
            ], this.ctxTransform(this.transformCanvas.props), this.canvasContext.beginPath(), this.canvasContext.rect(0, 0, this.transformCanvas.w, this.transformCanvas.h), this.canvasContext.closePath(), this.canvasContext.clip(), this.renderFrame(this.renderedFrame, !0);
        }, CanvasRendererBase.prototype.destroy = function() {
            var t1;
            for(this.renderConfig.clearCanvas && this.animationItem.wrapper && (this.animationItem.wrapper.innerText = ""), t1 = (this.layers ? this.layers.length : 0) - 1; t1 >= 0; t1 -= 1)this.elements[t1] && this.elements[t1].destroy();
            this.elements.length = 0, this.globalData.canvasContext = null, this.animationItem.container = null, this.destroyed = !0;
        }, CanvasRendererBase.prototype.renderFrame = function(t1, e1) {
            if ((this.renderedFrame !== t1 || !0 !== this.renderConfig.clearCanvas || e1) && !this.destroyed && -1 !== t1) {
                var r1;
                this.renderedFrame = t1, this.globalData.frameNum = t1 - this.animationItem._isFirstFrame, this.globalData.frameId += 1, this.globalData._mdf = !this.renderConfig.clearCanvas || e1, this.globalData.projectInterface.currentFrame = t1;
                var i1 = this.layers.length;
                for(this.completeLayers || this.checkLayers(t1), r1 = 0; r1 < i1; r1 += 1)(this.completeLayers || this.elements[r1]) && this.elements[r1].prepareFrame(t1 - this.layers[r1].st);
                if (this.globalData._mdf) {
                    for(!0 === this.renderConfig.clearCanvas ? this.canvasContext.clearRect(0, 0, this.transformCanvas.w, this.transformCanvas.h) : this.save(), r1 = i1 - 1; r1 >= 0; r1 -= 1)(this.completeLayers || this.elements[r1]) && this.elements[r1].renderFrame();
                    !0 !== this.renderConfig.clearCanvas && this.restore();
                }
            }
        }, CanvasRendererBase.prototype.buildItem = function(t1) {
            var e1 = this.elements;
            if (!e1[t1] && 99 !== this.layers[t1].ty) {
                var r1 = this.createItem(this.layers[t1], this, this.globalData);
                e1[t1] = r1, r1.initExpressions();
            }
        }, CanvasRendererBase.prototype.checkPendingElements = function() {
            for(; this.pendingElements.length;)this.pendingElements.pop().checkParenting();
        }, CanvasRendererBase.prototype.hide = function() {
            this.animationItem.container.style.display = "none";
        }, CanvasRendererBase.prototype.show = function() {
            this.animationItem.container.style.display = "block";
        }, extendPrototype([
            CanvasRendererBase,
            ICompElement,
            CVBaseElement
        ], CVCompElement), CVCompElement.prototype.renderInnerContent = function() {
            var t1, e1 = this.canvasContext;
            for(e1.beginPath(), e1.moveTo(0, 0), e1.lineTo(this.data.w, 0), e1.lineTo(this.data.w, this.data.h), e1.lineTo(0, this.data.h), e1.lineTo(0, 0), e1.clip(), t1 = this.layers.length - 1; t1 >= 0; t1 -= 1)(this.completeLayers || this.elements[t1]) && this.elements[t1].renderFrame();
        }, CVCompElement.prototype.destroy = function() {
            var t1;
            for(t1 = this.layers.length - 1; t1 >= 0; t1 -= 1)this.elements[t1] && this.elements[t1].destroy();
            this.layers = null, this.elements = null;
        }, CVCompElement.prototype.createComp = function(t1) {
            return new CVCompElement(t1, this.globalData, this);
        }, extendPrototype([
            CanvasRendererBase
        ], CanvasRenderer), CanvasRenderer.prototype.createComp = function(t1) {
            return new CVCompElement(t1, this.globalData, this);
        }, HBaseElement.prototype = {
            checkBlendMode: function() {},
            initRendererElement: function() {
                this.baseElement = createTag(this.data.tg || "div"), this.data.hasMask ? (this.svgElement = createNS("svg"), this.layerElement = createNS("g"), this.maskedElement = this.layerElement, this.svgElement.appendChild(this.layerElement), this.baseElement.appendChild(this.svgElement)) : this.layerElement = this.baseElement, styleDiv(this.baseElement);
            },
            createContainerElements: function() {
                this.renderableEffectsManager = new CVEffects(this), this.transformedElement = this.baseElement, this.maskedElement = this.layerElement, this.data.ln && this.layerElement.setAttribute("id", this.data.ln), this.data.cl && this.layerElement.setAttribute("class", this.data.cl), 0 !== this.data.bm && this.setBlendMode();
            },
            renderElement: function() {
                var t1 = this.transformedElement ? this.transformedElement.style : {};
                if (this.finalTransform._matMdf) {
                    var e1 = this.finalTransform.mat.toCSS();
                    t1.transform = e1, t1.webkitTransform = e1;
                }
                this.finalTransform._opMdf && (t1.opacity = this.finalTransform.mProp.o.v);
            },
            renderFrame: function() {
                this.data.hd || this.hidden || (this.renderTransform(), this.renderRenderable(), this.renderElement(), this.renderInnerContent(), this._isFirstFrame && (this._isFirstFrame = !1));
            },
            destroy: function() {
                this.layerElement = null, this.transformedElement = null, this.matteElement && (this.matteElement = null), this.maskManager && (this.maskManager.destroy(), this.maskManager = null);
            },
            createRenderableComponents: function() {
                this.maskManager = new MaskElement(this.data, this, this.globalData);
            },
            addEffects: function() {},
            setMatte: function() {}
        }, HBaseElement.prototype.getBaseElement = SVGBaseElement.prototype.getBaseElement, HBaseElement.prototype.destroyBaseElement = HBaseElement.prototype.destroy, HBaseElement.prototype.buildElementParenting = BaseRenderer.prototype.buildElementParenting, extendPrototype([
            BaseElement,
            TransformElement,
            HBaseElement,
            HierarchyElement,
            FrameElement,
            RenderableDOMElement
        ], HSolidElement), HSolidElement.prototype.createContent = function() {
            var t1;
            this.data.hasMask ? ((t1 = createNS("rect")).setAttribute("width", this.data.sw), t1.setAttribute("height", this.data.sh), t1.setAttribute("fill", this.data.sc), this.svgElement.setAttribute("width", this.data.sw), this.svgElement.setAttribute("height", this.data.sh)) : ((t1 = createTag("div")).style.width = this.data.sw + "px", t1.style.height = this.data.sh + "px", t1.style.backgroundColor = this.data.sc), this.layerElement.appendChild(t1);
        }, extendPrototype([
            BaseElement,
            TransformElement,
            HSolidElement,
            SVGShapeElement,
            HBaseElement,
            HierarchyElement,
            FrameElement,
            RenderableElement
        ], HShapeElement), HShapeElement.prototype._renderShapeFrame = HShapeElement.prototype.renderInnerContent, HShapeElement.prototype.createContent = function() {
            var t1;
            if (this.baseElement.style.fontSize = 0, this.data.hasMask) this.layerElement.appendChild(this.shapesContainer), t1 = this.svgElement;
            else {
                t1 = createNS("svg");
                var e1 = this.comp.data ? this.comp.data : this.globalData.compSize;
                t1.setAttribute("width", e1.w), t1.setAttribute("height", e1.h), t1.appendChild(this.shapesContainer), this.layerElement.appendChild(t1);
            }
            this.searchShapes(this.shapesData, this.itemsData, this.prevViewData, this.shapesContainer, 0, [], !0), this.filterUniqueShapes(), this.shapeCont = t1;
        }, HShapeElement.prototype.getTransformedPoint = function(t1, e1) {
            var r1, i1 = t1.length;
            for(r1 = 0; r1 < i1; r1 += 1)e1 = t1[r1].mProps.v.applyToPointArray(e1[0], e1[1], 0);
            return e1;
        }, HShapeElement.prototype.calculateShapeBoundingBox = function(t1, e1) {
            var r1, i1, a1, s1, n1, o1 = t1.sh.v, h1 = t1.transformers, l1 = o1._length;
            if (!(l1 <= 1)) {
                for(r1 = 0; r1 < l1 - 1; r1 += 1)i1 = this.getTransformedPoint(h1, o1.v[r1]), a1 = this.getTransformedPoint(h1, o1.o[r1]), s1 = this.getTransformedPoint(h1, o1.i[r1 + 1]), n1 = this.getTransformedPoint(h1, o1.v[r1 + 1]), this.checkBounds(i1, a1, s1, n1, e1);
                o1.c && (i1 = this.getTransformedPoint(h1, o1.v[r1]), a1 = this.getTransformedPoint(h1, o1.o[r1]), s1 = this.getTransformedPoint(h1, o1.i[0]), n1 = this.getTransformedPoint(h1, o1.v[0]), this.checkBounds(i1, a1, s1, n1, e1));
            }
        }, HShapeElement.prototype.checkBounds = function(t1, e1, r1, i1, a1) {
            this.getBoundsOfCurve(t1, e1, r1, i1);
            var s1 = this.shapeBoundingBox;
            a1.x = bmMin(s1.left, a1.x), a1.xMax = bmMax(s1.right, a1.xMax), a1.y = bmMin(s1.top, a1.y), a1.yMax = bmMax(s1.bottom, a1.yMax);
        }, HShapeElement.prototype.shapeBoundingBox = {
            left: 0,
            right: 0,
            top: 0,
            bottom: 0
        }, HShapeElement.prototype.tempBoundingBox = {
            x: 0,
            xMax: 0,
            y: 0,
            yMax: 0,
            width: 0,
            height: 0
        }, HShapeElement.prototype.getBoundsOfCurve = function(t1, e1, r1, i1) {
            for(var a1, s1, n1, o1, h1, l1, p1, f1 = [
                [
                    t1[0],
                    i1[0]
                ],
                [
                    t1[1],
                    i1[1]
                ]
            ], c1 = 0; c1 < 2; ++c1)s1 = 6 * t1[c1] - 12 * e1[c1] + 6 * r1[c1], a1 = -3 * t1[c1] + 9 * e1[c1] - 9 * r1[c1] + 3 * i1[c1], n1 = 3 * e1[c1] - 3 * t1[c1], s1 |= 0, n1 |= 0, 0 === (a1 |= 0) && 0 === s1 || (0 === a1 ? (o1 = -n1 / s1) > 0 && o1 < 1 && f1[c1].push(this.calculateF(o1, t1, e1, r1, i1, c1)) : (h1 = s1 * s1 - 4 * n1 * a1) >= 0 && ((l1 = (-s1 + bmSqrt(h1)) / (2 * a1)) > 0 && l1 < 1 && f1[c1].push(this.calculateF(l1, t1, e1, r1, i1, c1)), (p1 = (-s1 - bmSqrt(h1)) / (2 * a1)) > 0 && p1 < 1 && f1[c1].push(this.calculateF(p1, t1, e1, r1, i1, c1))));
            this.shapeBoundingBox.left = bmMin.apply(null, f1[0]), this.shapeBoundingBox.top = bmMin.apply(null, f1[1]), this.shapeBoundingBox.right = bmMax.apply(null, f1[0]), this.shapeBoundingBox.bottom = bmMax.apply(null, f1[1]);
        }, HShapeElement.prototype.calculateF = function(t1, e1, r1, i1, a1, s1) {
            return bmPow(1 - t1, 3) * e1[s1] + 3 * bmPow(1 - t1, 2) * t1 * r1[s1] + 3 * (1 - t1) * bmPow(t1, 2) * i1[s1] + bmPow(t1, 3) * a1[s1];
        }, HShapeElement.prototype.calculateBoundingBox = function(t1, e1) {
            var r1, i1 = t1.length;
            for(r1 = 0; r1 < i1; r1 += 1)t1[r1] && t1[r1].sh ? this.calculateShapeBoundingBox(t1[r1], e1) : t1[r1] && t1[r1].it ? this.calculateBoundingBox(t1[r1].it, e1) : t1[r1] && t1[r1].style && t1[r1].w && this.expandStrokeBoundingBox(t1[r1].w, e1);
        }, HShapeElement.prototype.expandStrokeBoundingBox = function(t1, e1) {
            var r1 = 0;
            if (t1.keyframes) {
                for(var i1 = 0; i1 < t1.keyframes.length; i1 += 1){
                    var a1 = t1.keyframes[i1].s;
                    a1 > r1 && (r1 = a1);
                }
                r1 *= t1.mult;
            } else r1 = t1.v * t1.mult;
            e1.x -= r1, e1.xMax += r1, e1.y -= r1, e1.yMax += r1;
        }, HShapeElement.prototype.currentBoxContains = function(t1) {
            return this.currentBBox.x <= t1.x && this.currentBBox.y <= t1.y && this.currentBBox.width + this.currentBBox.x >= t1.x + t1.width && this.currentBBox.height + this.currentBBox.y >= t1.y + t1.height;
        }, HShapeElement.prototype.renderInnerContent = function() {
            if (this._renderShapeFrame(), !this.hidden && (this._isFirstFrame || this._mdf)) {
                var t1 = this.tempBoundingBox, e1 = 999999;
                if (t1.x = e1, t1.xMax = -e1, t1.y = e1, t1.yMax = -e1, this.calculateBoundingBox(this.itemsData, t1), t1.width = t1.xMax < t1.x ? 0 : t1.xMax - t1.x, t1.height = t1.yMax < t1.y ? 0 : t1.yMax - t1.y, this.currentBoxContains(t1)) return;
                var r1 = !1;
                if (this.currentBBox.w !== t1.width && (this.currentBBox.w = t1.width, this.shapeCont.setAttribute("width", t1.width), r1 = !0), this.currentBBox.h !== t1.height && (this.currentBBox.h = t1.height, this.shapeCont.setAttribute("height", t1.height), r1 = !0), r1 || this.currentBBox.x !== t1.x || this.currentBBox.y !== t1.y) {
                    this.currentBBox.w = t1.width, this.currentBBox.h = t1.height, this.currentBBox.x = t1.x, this.currentBBox.y = t1.y, this.shapeCont.setAttribute("viewBox", this.currentBBox.x + " " + this.currentBBox.y + " " + this.currentBBox.w + " " + this.currentBBox.h);
                    var i1 = this.shapeCont.style, a1 = "translate(" + this.currentBBox.x + "px," + this.currentBBox.y + "px)";
                    i1.transform = a1, i1.webkitTransform = a1;
                }
            }
        }, extendPrototype([
            BaseElement,
            TransformElement,
            HBaseElement,
            HierarchyElement,
            FrameElement,
            RenderableDOMElement,
            ITextElement
        ], HTextElement), HTextElement.prototype.createContent = function() {
            if (this.isMasked = this.checkMasks(), this.isMasked) {
                this.renderType = "svg", this.compW = this.comp.data.w, this.compH = this.comp.data.h, this.svgElement.setAttribute("width", this.compW), this.svgElement.setAttribute("height", this.compH);
                var t1 = createNS("g");
                this.maskedElement.appendChild(t1), this.innerElem = t1;
            } else this.renderType = "html", this.innerElem = this.layerElement;
            this.checkParenting();
        }, HTextElement.prototype.buildNewText = function() {
            var t1 = this.textProperty.currentData;
            this.renderedLetters = createSizedArray(t1.l ? t1.l.length : 0);
            var e1 = this.innerElem.style, r1 = t1.fc ? this.buildColor(t1.fc) : "rgba(0,0,0,0)";
            e1.fill = r1, e1.color = r1, t1.sc && (e1.stroke = this.buildColor(t1.sc), e1.strokeWidth = t1.sw + "px");
            var i1, a1, s1 = this.globalData.fontManager.getFontByName(t1.f);
            if (!this.globalData.fontManager.chars) {
                if (e1.fontSize = t1.finalSize + "px", e1.lineHeight = t1.finalSize + "px", s1.fClass) this.innerElem.className = s1.fClass;
                else {
                    e1.fontFamily = s1.fFamily;
                    var n1 = t1.fWeight, o1 = t1.fStyle;
                    e1.fontStyle = o1, e1.fontWeight = n1;
                }
            }
            var h1, l1, p1, f1 = t1.l;
            a1 = f1.length;
            var c1, m1 = this.mHelper, d1 = "", u1 = 0;
            for(i1 = 0; i1 < a1; i1 += 1){
                if (this.globalData.fontManager.chars ? (this.textPaths[u1] ? h1 = this.textPaths[u1] : ((h1 = createNS("path")).setAttribute("stroke-linecap", lineCapEnum[1]), h1.setAttribute("stroke-linejoin", lineJoinEnum[2]), h1.setAttribute("stroke-miterlimit", "4")), this.isMasked || (this.textSpans[u1] ? p1 = (l1 = this.textSpans[u1]).children[0] : ((l1 = createTag("div")).style.lineHeight = 0, (p1 = createNS("svg")).appendChild(h1), styleDiv(l1)))) : this.isMasked ? h1 = this.textPaths[u1] ? this.textPaths[u1] : createNS("text") : this.textSpans[u1] ? (l1 = this.textSpans[u1], h1 = this.textPaths[u1]) : (styleDiv(l1 = createTag("span")), styleDiv(h1 = createTag("span")), l1.appendChild(h1)), this.globalData.fontManager.chars) {
                    var y1, g1 = this.globalData.fontManager.getCharData(t1.finalText[i1], s1.fStyle, this.globalData.fontManager.getFontByName(t1.f).fFamily);
                    if (y1 = g1 ? g1.data : null, m1.reset(), y1 && y1.shapes && y1.shapes.length && (c1 = y1.shapes[0].it, m1.scale(t1.finalSize / 100, t1.finalSize / 100), d1 = this.createPathShape(m1, c1), h1.setAttribute("d", d1)), this.isMasked) this.innerElem.appendChild(h1);
                    else {
                        if (this.innerElem.appendChild(l1), y1 && y1.shapes) {
                            document.body.appendChild(p1);
                            var v1 = p1.getBBox();
                            p1.setAttribute("width", v1.width + 2), p1.setAttribute("height", v1.height + 2), p1.setAttribute("viewBox", v1.x - 1 + " " + (v1.y - 1) + " " + (v1.width + 2) + " " + (v1.height + 2));
                            var b1 = p1.style, x1 = "translate(" + (v1.x - 1) + "px," + (v1.y - 1) + "px)";
                            b1.transform = x1, b1.webkitTransform = x1, f1[i1].yOffset = v1.y - 1;
                        } else p1.setAttribute("width", 1), p1.setAttribute("height", 1);
                        l1.appendChild(p1);
                    }
                } else if (h1.textContent = f1[i1].val, h1.setAttributeNS("http://www.w3.org/XML/1998/namespace", "xml:space", "preserve"), this.isMasked) this.innerElem.appendChild(h1);
                else {
                    this.innerElem.appendChild(l1);
                    var P1 = h1.style, E1 = "translate3d(0," + -t1.finalSize / 1.2 + "px,0)";
                    P1.transform = E1, P1.webkitTransform = E1;
                }
                this.isMasked ? this.textSpans[u1] = h1 : this.textSpans[u1] = l1, this.textSpans[u1].style.display = "block", this.textPaths[u1] = h1, u1 += 1;
            }
            for(; u1 < this.textSpans.length;)this.textSpans[u1].style.display = "none", u1 += 1;
        }, HTextElement.prototype.renderInnerContent = function() {
            var t1;
            if (this.data.singleShape) {
                if (!this._isFirstFrame && !this.lettersChangedFlag) return;
                if (this.isMasked && this.finalTransform._matMdf) {
                    this.svgElement.setAttribute("viewBox", -this.finalTransform.mProp.p.v[0] + " " + -this.finalTransform.mProp.p.v[1] + " " + this.compW + " " + this.compH), t1 = this.svgElement.style;
                    var e1 = "translate(" + -this.finalTransform.mProp.p.v[0] + "px," + -this.finalTransform.mProp.p.v[1] + "px)";
                    t1.transform = e1, t1.webkitTransform = e1;
                }
            }
            if (this.textAnimator.getMeasures(this.textProperty.currentData, this.lettersChangedFlag), this.lettersChangedFlag || this.textAnimator.lettersChangedFlag) {
                var r1, i1, a1, s1, n1, o1 = 0, h1 = this.textAnimator.renderedLetters, l1 = this.textProperty.currentData.l;
                for(i1 = l1.length, r1 = 0; r1 < i1; r1 += 1)l1[r1].n ? o1 += 1 : (s1 = this.textSpans[r1], n1 = this.textPaths[r1], a1 = h1[o1], o1 += 1, a1._mdf.m && (this.isMasked ? s1.setAttribute("transform", a1.m) : (s1.style.webkitTransform = a1.m, s1.style.transform = a1.m)), s1.style.opacity = a1.o, a1.sw && a1._mdf.sw && n1.setAttribute("stroke-width", a1.sw), a1.sc && a1._mdf.sc && n1.setAttribute("stroke", a1.sc), a1.fc && a1._mdf.fc && (n1.setAttribute("fill", a1.fc), n1.style.color = a1.fc));
                if (this.innerElem.getBBox && !this.hidden && (this._isFirstFrame || this._mdf)) {
                    var p1 = this.innerElem.getBBox();
                    this.currentBBox.w !== p1.width && (this.currentBBox.w = p1.width, this.svgElement.setAttribute("width", p1.width)), this.currentBBox.h !== p1.height && (this.currentBBox.h = p1.height, this.svgElement.setAttribute("height", p1.height));
                    if (this.currentBBox.w !== p1.width + 2 || this.currentBBox.h !== p1.height + 2 || this.currentBBox.x !== p1.x - 1 || this.currentBBox.y !== p1.y - 1) {
                        this.currentBBox.w = p1.width + 2, this.currentBBox.h = p1.height + 2, this.currentBBox.x = p1.x - 1, this.currentBBox.y = p1.y - 1, this.svgElement.setAttribute("viewBox", this.currentBBox.x + " " + this.currentBBox.y + " " + this.currentBBox.w + " " + this.currentBBox.h), t1 = this.svgElement.style;
                        var f1 = "translate(" + this.currentBBox.x + "px," + this.currentBBox.y + "px)";
                        t1.transform = f1, t1.webkitTransform = f1;
                    }
                }
            }
        }, extendPrototype([
            BaseElement,
            FrameElement,
            HierarchyElement
        ], HCameraElement), HCameraElement.prototype.setup = function() {
            var t1, e1, r1, i1, a1 = this.comp.threeDElements.length;
            for(t1 = 0; t1 < a1; t1 += 1)if ("3d" === (e1 = this.comp.threeDElements[t1]).type) {
                r1 = e1.perspectiveElem.style, i1 = e1.container.style;
                var s1 = this.pe.v + "px", n1 = "matrix3d(1,0,0,0,0,1,0,0,0,0,1,0,0,0,0,1)";
                r1.perspective = s1, r1.webkitPerspective = s1, i1.transformOrigin = "0px 0px 0px", i1.mozTransformOrigin = "0px 0px 0px", i1.webkitTransformOrigin = "0px 0px 0px", r1.transform = n1, r1.webkitTransform = n1;
            }
        }, HCameraElement.prototype.createElements = function() {}, HCameraElement.prototype.hide = function() {}, HCameraElement.prototype.renderFrame = function() {
            var t1, e1, r1 = this._isFirstFrame;
            if (this.hierarchy) for(e1 = this.hierarchy.length, t1 = 0; t1 < e1; t1 += 1)r1 = this.hierarchy[t1].finalTransform.mProp._mdf || r1;
            if (r1 || this.pe._mdf || this.p && this.p._mdf || this.px && (this.px._mdf || this.py._mdf || this.pz._mdf) || this.rx._mdf || this.ry._mdf || this.rz._mdf || this.or._mdf || this.a && this.a._mdf) {
                if (this.mat.reset(), this.hierarchy) for(t1 = e1 = this.hierarchy.length - 1; t1 >= 0; t1 -= 1){
                    var i1 = this.hierarchy[t1].finalTransform.mProp;
                    this.mat.translate(-i1.p.v[0], -i1.p.v[1], i1.p.v[2]), this.mat.rotateX(-i1.or.v[0]).rotateY(-i1.or.v[1]).rotateZ(i1.or.v[2]), this.mat.rotateX(-i1.rx.v).rotateY(-i1.ry.v).rotateZ(i1.rz.v), this.mat.scale(1 / i1.s.v[0], 1 / i1.s.v[1], 1 / i1.s.v[2]), this.mat.translate(i1.a.v[0], i1.a.v[1], i1.a.v[2]);
                }
                if (this.p ? this.mat.translate(-this.p.v[0], -this.p.v[1], this.p.v[2]) : this.mat.translate(-this.px.v, -this.py.v, this.pz.v), this.a) {
                    var a1;
                    a1 = this.p ? [
                        this.p.v[0] - this.a.v[0],
                        this.p.v[1] - this.a.v[1],
                        this.p.v[2] - this.a.v[2]
                    ] : [
                        this.px.v - this.a.v[0],
                        this.py.v - this.a.v[1],
                        this.pz.v - this.a.v[2]
                    ];
                    var s1 = Math.sqrt(Math.pow(a1[0], 2) + Math.pow(a1[1], 2) + Math.pow(a1[2], 2)), n1 = [
                        a1[0] / s1,
                        a1[1] / s1,
                        a1[2] / s1
                    ], o1 = Math.sqrt(n1[2] * n1[2] + n1[0] * n1[0]), h1 = Math.atan2(n1[1], o1), l1 = Math.atan2(n1[0], -n1[2]);
                    this.mat.rotateY(l1).rotateX(-h1);
                }
                this.mat.rotateX(-this.rx.v).rotateY(-this.ry.v).rotateZ(this.rz.v), this.mat.rotateX(-this.or.v[0]).rotateY(-this.or.v[1]).rotateZ(this.or.v[2]), this.mat.translate(this.globalData.compSize.w / 2, this.globalData.compSize.h / 2, 0), this.mat.translate(0, 0, this.pe.v);
                var p1 = !this._prevMat.equals(this.mat);
                if ((p1 || this.pe._mdf) && this.comp.threeDElements) {
                    var f1, c1, m1;
                    for(e1 = this.comp.threeDElements.length, t1 = 0; t1 < e1; t1 += 1)if ("3d" === (f1 = this.comp.threeDElements[t1]).type) {
                        if (p1) {
                            var d1 = this.mat.toCSS();
                            (m1 = f1.container.style).transform = d1, m1.webkitTransform = d1;
                        }
                        this.pe._mdf && ((c1 = f1.perspectiveElem.style).perspective = this.pe.v + "px", c1.webkitPerspective = this.pe.v + "px");
                    }
                    this.mat.clone(this._prevMat);
                }
            }
            this._isFirstFrame = !1;
        }, HCameraElement.prototype.prepareFrame = function(t1) {
            this.prepareProperties(t1, !0);
        }, HCameraElement.prototype.destroy = function() {}, HCameraElement.prototype.getBaseElement = function() {
            return null;
        }, extendPrototype([
            BaseElement,
            TransformElement,
            HBaseElement,
            HSolidElement,
            HierarchyElement,
            FrameElement,
            RenderableElement
        ], HImageElement), HImageElement.prototype.createContent = function() {
            var t1 = this.globalData.getAssetsPath(this.assetData), e1 = new Image;
            this.data.hasMask ? (this.imageElem = createNS("image"), this.imageElem.setAttribute("width", this.assetData.w + "px"), this.imageElem.setAttribute("height", this.assetData.h + "px"), this.imageElem.setAttributeNS("http://www.w3.org/1999/xlink", "href", t1), this.layerElement.appendChild(this.imageElem), this.baseElement.setAttribute("width", this.assetData.w), this.baseElement.setAttribute("height", this.assetData.h)) : this.layerElement.appendChild(e1), e1.crossOrigin = "anonymous", e1.src = t1, this.data.ln && this.baseElement.setAttribute("id", this.data.ln);
        }, extendPrototype([
            BaseRenderer
        ], HybridRendererBase), HybridRendererBase.prototype.buildItem = SVGRenderer.prototype.buildItem, HybridRendererBase.prototype.checkPendingElements = function() {
            for(; this.pendingElements.length;)this.pendingElements.pop().checkParenting();
        }, HybridRendererBase.prototype.appendElementInPos = function(t1, e1) {
            var r1 = t1.getBaseElement();
            if (r1) {
                var i1 = this.layers[e1];
                if (i1.ddd && this.supports3d) this.addTo3dContainer(r1, e1);
                else if (this.threeDElements) this.addTo3dContainer(r1, e1);
                else {
                    for(var a1, s1, n1 = 0; n1 < e1;)this.elements[n1] && !0 !== this.elements[n1] && this.elements[n1].getBaseElement && (s1 = this.elements[n1], a1 = (this.layers[n1].ddd ? this.getThreeDContainerByPos(n1) : s1.getBaseElement()) || a1), n1 += 1;
                    a1 ? i1.ddd && this.supports3d || this.layerElement.insertBefore(r1, a1) : i1.ddd && this.supports3d || this.layerElement.appendChild(r1);
                }
            }
        }, HybridRendererBase.prototype.createShape = function(t1) {
            return this.supports3d ? new HShapeElement(t1, this.globalData, this) : new SVGShapeElement(t1, this.globalData, this);
        }, HybridRendererBase.prototype.createText = function(t1) {
            return this.supports3d ? new HTextElement(t1, this.globalData, this) : new SVGTextLottieElement(t1, this.globalData, this);
        }, HybridRendererBase.prototype.createCamera = function(t1) {
            return this.camera = new HCameraElement(t1, this.globalData, this), this.camera;
        }, HybridRendererBase.prototype.createImage = function(t1) {
            return this.supports3d ? new HImageElement(t1, this.globalData, this) : new IImageElement(t1, this.globalData, this);
        }, HybridRendererBase.prototype.createSolid = function(t1) {
            return this.supports3d ? new HSolidElement(t1, this.globalData, this) : new ISolidElement(t1, this.globalData, this);
        }, HybridRendererBase.prototype.createNull = SVGRenderer.prototype.createNull, HybridRendererBase.prototype.getThreeDContainerByPos = function(t1) {
            for(var e1 = 0, r1 = this.threeDElements.length; e1 < r1;){
                if (this.threeDElements[e1].startPos <= t1 && this.threeDElements[e1].endPos >= t1) return this.threeDElements[e1].perspectiveElem;
                e1 += 1;
            }
            return null;
        }, HybridRendererBase.prototype.createThreeDContainer = function(t1, e1) {
            var r1, i1, a1 = createTag("div");
            styleDiv(a1);
            var s1 = createTag("div");
            if (styleDiv(s1), "3d" === e1) {
                (r1 = a1.style).width = this.globalData.compSize.w + "px", r1.height = this.globalData.compSize.h + "px";
                r1.webkitTransformOrigin = "50% 50%", r1.mozTransformOrigin = "50% 50%", r1.transformOrigin = "50% 50%";
                var n1 = "matrix3d(1,0,0,0,0,1,0,0,0,0,1,0,0,0,0,1)";
                (i1 = s1.style).transform = n1, i1.webkitTransform = n1;
            }
            a1.appendChild(s1);
            var o1 = {
                container: s1,
                perspectiveElem: a1,
                startPos: t1,
                endPos: t1,
                type: e1
            };
            return this.threeDElements.push(o1), o1;
        }, HybridRendererBase.prototype.build3dContainers = function() {
            var t1, e1, r1 = this.layers.length, i1 = "";
            for(t1 = 0; t1 < r1; t1 += 1)this.layers[t1].ddd && 3 !== this.layers[t1].ty ? ("3d" !== i1 && (i1 = "3d", e1 = this.createThreeDContainer(t1, "3d")), e1.endPos = Math.max(e1.endPos, t1)) : ("2d" !== i1 && (i1 = "2d", e1 = this.createThreeDContainer(t1, "2d")), e1.endPos = Math.max(e1.endPos, t1));
            for(t1 = (r1 = this.threeDElements.length) - 1; t1 >= 0; t1 -= 1)this.resizerElem.appendChild(this.threeDElements[t1].perspectiveElem);
        }, HybridRendererBase.prototype.addTo3dContainer = function(t1, e1) {
            for(var r1 = 0, i1 = this.threeDElements.length; r1 < i1;){
                if (e1 <= this.threeDElements[r1].endPos) {
                    for(var a1, s1 = this.threeDElements[r1].startPos; s1 < e1;)this.elements[s1] && this.elements[s1].getBaseElement && (a1 = this.elements[s1].getBaseElement()), s1 += 1;
                    a1 ? this.threeDElements[r1].container.insertBefore(t1, a1) : this.threeDElements[r1].container.appendChild(t1);
                    break;
                }
                r1 += 1;
            }
        }, HybridRendererBase.prototype.configAnimation = function(t1) {
            var e1 = createTag("div"), r1 = this.animationItem.wrapper, i1 = e1.style;
            i1.width = t1.w + "px", i1.height = t1.h + "px", this.resizerElem = e1, styleDiv(e1), i1.transformStyle = "flat", i1.mozTransformStyle = "flat", i1.webkitTransformStyle = "flat", this.renderConfig.className && e1.setAttribute("class", this.renderConfig.className), r1.appendChild(e1), i1.overflow = "hidden";
            var a1 = createNS("svg");
            a1.setAttribute("width", "1"), a1.setAttribute("height", "1"), styleDiv(a1), this.resizerElem.appendChild(a1);
            var s1 = createNS("defs");
            a1.appendChild(s1), this.data = t1, this.setupGlobalData(t1, a1), this.globalData.defs = s1, this.layers = t1.layers, this.layerElement = this.resizerElem, this.build3dContainers(), this.updateContainerSize();
        }, HybridRendererBase.prototype.destroy = function() {
            var t1;
            this.animationItem.wrapper && (this.animationItem.wrapper.innerText = ""), this.animationItem.container = null, this.globalData.defs = null;
            var e1 = this.layers ? this.layers.length : 0;
            for(t1 = 0; t1 < e1; t1 += 1)this.elements[t1].destroy();
            this.elements.length = 0, this.destroyed = !0, this.animationItem = null;
        }, HybridRendererBase.prototype.updateContainerSize = function() {
            var t1, e1, r1, i1, a1 = this.animationItem.wrapper.offsetWidth, s1 = this.animationItem.wrapper.offsetHeight, n1 = a1 / s1;
            this.globalData.compSize.w / this.globalData.compSize.h > n1 ? (t1 = a1 / this.globalData.compSize.w, e1 = a1 / this.globalData.compSize.w, r1 = 0, i1 = (s1 - this.globalData.compSize.h * (a1 / this.globalData.compSize.w)) / 2) : (t1 = s1 / this.globalData.compSize.h, e1 = s1 / this.globalData.compSize.h, r1 = (a1 - this.globalData.compSize.w * (s1 / this.globalData.compSize.h)) / 2, i1 = 0);
            var o1 = this.resizerElem.style;
            o1.webkitTransform = "matrix3d(" + t1 + ",0,0,0,0," + e1 + ",0,0,0,0,1,0," + r1 + "," + i1 + ",0,1)", o1.transform = o1.webkitTransform;
        }, HybridRendererBase.prototype.renderFrame = SVGRenderer.prototype.renderFrame, HybridRendererBase.prototype.hide = function() {
            this.resizerElem.style.display = "none";
        }, HybridRendererBase.prototype.show = function() {
            this.resizerElem.style.display = "block";
        }, HybridRendererBase.prototype.initItems = function() {
            if (this.buildAllItems(), this.camera) this.camera.setup();
            else {
                var t1, e1 = this.globalData.compSize.w, r1 = this.globalData.compSize.h, i1 = this.threeDElements.length;
                for(t1 = 0; t1 < i1; t1 += 1){
                    var a1 = this.threeDElements[t1].perspectiveElem.style;
                    a1.webkitPerspective = Math.sqrt(Math.pow(e1, 2) + Math.pow(r1, 2)) + "px", a1.perspective = a1.webkitPerspective;
                }
            }
        }, HybridRendererBase.prototype.searchExtraCompositions = function(t1) {
            var e1, r1 = t1.length, i1 = createTag("div");
            for(e1 = 0; e1 < r1; e1 += 1)if (t1[e1].xt) {
                var a1 = this.createComp(t1[e1], i1, this.globalData.comp, null);
                a1.initExpressions(), this.globalData.projectInterface.registerComposition(a1);
            }
        }, extendPrototype([
            HybridRendererBase,
            ICompElement,
            HBaseElement
        ], HCompElement), HCompElement.prototype._createBaseContainerElements = HCompElement.prototype.createContainerElements, HCompElement.prototype.createContainerElements = function() {
            this._createBaseContainerElements(), this.data.hasMask ? (this.svgElement.setAttribute("width", this.data.w), this.svgElement.setAttribute("height", this.data.h), this.transformedElement = this.baseElement) : this.transformedElement = this.layerElement;
        }, HCompElement.prototype.addTo3dContainer = function(t1, e1) {
            for(var r1, i1 = 0; i1 < e1;)this.elements[i1] && this.elements[i1].getBaseElement && (r1 = this.elements[i1].getBaseElement()), i1 += 1;
            r1 ? this.layerElement.insertBefore(t1, r1) : this.layerElement.appendChild(t1);
        }, HCompElement.prototype.createComp = function(t1) {
            return this.supports3d ? new HCompElement(t1, this.globalData, this) : new SVGCompElement(t1, this.globalData, this);
        }, extendPrototype([
            HybridRendererBase
        ], HybridRenderer), HybridRenderer.prototype.createComp = function(t1) {
            return this.supports3d ? new HCompElement(t1, this.globalData, this) : new SVGCompElement(t1, this.globalData, this);
        };
        var CompExpressionInterface = function(t1) {
            function e1(e1) {
                for(var r1 = 0, i1 = t1.layers.length; r1 < i1;){
                    if (t1.layers[r1].nm === e1 || t1.layers[r1].ind === e1) return t1.elements[r1].layerInterface;
                    r1 += 1;
                }
                return null;
            }
            return Object.defineProperty(e1, "_name", {
                value: t1.data.nm
            }), e1.layer = e1, e1.pixelAspect = 1, e1.height = t1.data.h || t1.globalData.compSize.h, e1.width = t1.data.w || t1.globalData.compSize.w, e1.pixelAspect = 1, e1.frameDuration = 1 / t1.globalData.frameRate, e1.displayStartTime = 0, e1.numLayers = t1.layers.length, e1;
        }, Expressions = function() {
            var t1 = {};
            return t1.initExpressions = function(t1) {
                var e1 = 0, r1 = [];
                t1.renderer.compInterface = CompExpressionInterface(t1.renderer), t1.renderer.globalData.projectInterface.registerComposition(t1.renderer), t1.renderer.globalData.pushExpression = function() {
                    e1 += 1;
                }, t1.renderer.globalData.popExpression = function() {
                    0 === (e1 -= 1) && function() {
                        var t1, e1 = r1.length;
                        for(t1 = 0; t1 < e1; t1 += 1)r1[t1].release();
                        r1.length = 0;
                    }();
                }, t1.renderer.globalData.registerExpressionProperty = function(t1) {
                    -1 === r1.indexOf(t1) && r1.push(t1);
                };
            }, t1;
        }(), MaskManagerInterface = function() {
            function t1(t1, e1) {
                this._mask = t1, this._data = e1;
            }
            Object.defineProperty(t1.prototype, "maskPath", {
                get: function() {
                    return this._mask.prop.k && this._mask.prop.getValue(), this._mask.prop;
                }
            }), Object.defineProperty(t1.prototype, "maskOpacity", {
                get: function() {
                    return this._mask.op.k && this._mask.op.getValue(), 100 * this._mask.op.v;
                }
            });
            return function(e1) {
                var r1, i1 = createSizedArray(e1.viewData.length), a1 = e1.viewData.length;
                for(r1 = 0; r1 < a1; r1 += 1)i1[r1] = new t1(e1.viewData[r1], e1.masksProperties[r1]);
                return function(t1) {
                    for(r1 = 0; r1 < a1;){
                        if (e1.masksProperties[r1].nm === t1) return i1[r1];
                        r1 += 1;
                    }
                    return null;
                };
            };
        }(), ExpressionPropertyInterface = function() {
            var t1 = {
                pv: 0,
                v: 0,
                mult: 1
            }, e1 = {
                pv: [
                    0,
                    0,
                    0
                ],
                v: [
                    0,
                    0,
                    0
                ],
                mult: 1
            };
            function r1(t1, e1, r1) {
                Object.defineProperty(t1, "velocity", {
                    get: function() {
                        return e1.getVelocityAtTime(e1.comp.currentFrame);
                    }
                }), t1.numKeys = e1.keyframes ? e1.keyframes.length : 0, t1.key = function(i1) {
                    if (!t1.numKeys) return 0;
                    var a1 = "";
                    a1 = "s" in e1.keyframes[i1 - 1] ? e1.keyframes[i1 - 1].s : "e" in e1.keyframes[i1 - 2] ? e1.keyframes[i1 - 2].e : e1.keyframes[i1 - 2].s;
                    var s1 = "unidimensional" === r1 ? new Number(a1) : Object.assign({}, a1);
                    return s1.time = e1.keyframes[i1 - 1].t / e1.elem.comp.globalData.frameRate, s1.value = "unidimensional" === r1 ? a1[0] : a1, s1;
                }, t1.valueAtTime = e1.getValueAtTime, t1.speedAtTime = e1.getSpeedAtTime, t1.velocityAtTime = e1.getVelocityAtTime, t1.propertyGroup = e1.propertyGroup;
            }
            function i1() {
                return t1;
            }
            return function(a1) {
                return a1 ? "unidimensional" === a1.propType ? function(e1) {
                    e1 && "pv" in e1 || (e1 = t1);
                    var i1 = 1 / e1.mult, a1 = e1.pv * i1, s1 = new Number(a1);
                    return s1.value = a1, r1(s1, e1, "unidimensional"), function() {
                        return e1.k && e1.getValue(), a1 = e1.v * i1, s1.value !== a1 && ((s1 = new Number(a1)).value = a1, r1(s1, e1, "unidimensional")), s1;
                    };
                }(a1) : function(t1) {
                    t1 && "pv" in t1 || (t1 = e1);
                    var i1 = 1 / t1.mult, a1 = t1.data && t1.data.l || t1.pv.length, s1 = createTypedArray("float32", a1), n1 = createTypedArray("float32", a1);
                    return s1.value = n1, r1(s1, t1, "multidimensional"), function() {
                        t1.k && t1.getValue();
                        for(var e1 = 0; e1 < a1; e1 += 1)n1[e1] = t1.v[e1] * i1, s1[e1] = n1[e1];
                        return s1;
                    };
                }(a1) : i1;
            };
        }(), TransformExpressionInterface = function(t1) {
            function e1(t1) {
                switch(t1){
                    case "scale":
                    case "Scale":
                    case "ADBE Scale":
                    case 6:
                        return e1.scale;
                    case "rotation":
                    case "Rotation":
                    case "ADBE Rotation":
                    case "ADBE Rotate Z":
                    case 10:
                        return e1.rotation;
                    case "ADBE Rotate X":
                        return e1.xRotation;
                    case "ADBE Rotate Y":
                        return e1.yRotation;
                    case "position":
                    case "Position":
                    case "ADBE Position":
                    case 2:
                        return e1.position;
                    case "ADBE Position_0":
                        return e1.xPosition;
                    case "ADBE Position_1":
                        return e1.yPosition;
                    case "ADBE Position_2":
                        return e1.zPosition;
                    case "anchorPoint":
                    case "AnchorPoint":
                    case "Anchor Point":
                    case "ADBE AnchorPoint":
                    case 1:
                        return e1.anchorPoint;
                    case "opacity":
                    case "Opacity":
                    case 11:
                        return e1.opacity;
                    default:
                        return null;
                }
            }
            var r1, i1, a1, s1;
            return Object.defineProperty(e1, "rotation", {
                get: ExpressionPropertyInterface(t1.r || t1.rz)
            }), Object.defineProperty(e1, "zRotation", {
                get: ExpressionPropertyInterface(t1.rz || t1.r)
            }), Object.defineProperty(e1, "xRotation", {
                get: ExpressionPropertyInterface(t1.rx)
            }), Object.defineProperty(e1, "yRotation", {
                get: ExpressionPropertyInterface(t1.ry)
            }), Object.defineProperty(e1, "scale", {
                get: ExpressionPropertyInterface(t1.s)
            }), t1.p ? s1 = ExpressionPropertyInterface(t1.p) : (r1 = ExpressionPropertyInterface(t1.px), i1 = ExpressionPropertyInterface(t1.py), t1.pz && (a1 = ExpressionPropertyInterface(t1.pz))), Object.defineProperty(e1, "position", {
                get: function() {
                    return t1.p ? s1() : [
                        r1(),
                        i1(),
                        a1 ? a1() : 0
                    ];
                }
            }), Object.defineProperty(e1, "xPosition", {
                get: ExpressionPropertyInterface(t1.px)
            }), Object.defineProperty(e1, "yPosition", {
                get: ExpressionPropertyInterface(t1.py)
            }), Object.defineProperty(e1, "zPosition", {
                get: ExpressionPropertyInterface(t1.pz)
            }), Object.defineProperty(e1, "anchorPoint", {
                get: ExpressionPropertyInterface(t1.a)
            }), Object.defineProperty(e1, "opacity", {
                get: ExpressionPropertyInterface(t1.o)
            }), Object.defineProperty(e1, "skew", {
                get: ExpressionPropertyInterface(t1.sk)
            }), Object.defineProperty(e1, "skewAxis", {
                get: ExpressionPropertyInterface(t1.sa)
            }), Object.defineProperty(e1, "orientation", {
                get: ExpressionPropertyInterface(t1.or)
            }), e1;
        }, LayerExpressionInterface = function() {
            function t1(t1) {
                var e1 = new Matrix;
                void 0 !== t1 ? this._elem.finalTransform.mProp.getValueAtTime(t1).clone(e1) : this._elem.finalTransform.mProp.applyToMatrix(e1);
                return e1;
            }
            function e1(t1, e1) {
                var r1 = this.getMatrix(e1);
                return r1.props[12] = 0, r1.props[13] = 0, r1.props[14] = 0, this.applyPoint(r1, t1);
            }
            function r1(t1, e1) {
                var r1 = this.getMatrix(e1);
                return this.applyPoint(r1, t1);
            }
            function i1(t1, e1) {
                var r1 = this.getMatrix(e1);
                return r1.props[12] = 0, r1.props[13] = 0, r1.props[14] = 0, this.invertPoint(r1, t1);
            }
            function a1(t1, e1) {
                var r1 = this.getMatrix(e1);
                return this.invertPoint(r1, t1);
            }
            function s1(t1, e1) {
                if (this._elem.hierarchy && this._elem.hierarchy.length) {
                    var r1, i1 = this._elem.hierarchy.length;
                    for(r1 = 0; r1 < i1; r1 += 1)this._elem.hierarchy[r1].finalTransform.mProp.applyToMatrix(t1);
                }
                return t1.applyToPointArray(e1[0], e1[1], e1[2] || 0);
            }
            function n1(t1, e1) {
                if (this._elem.hierarchy && this._elem.hierarchy.length) {
                    var r1, i1 = this._elem.hierarchy.length;
                    for(r1 = 0; r1 < i1; r1 += 1)this._elem.hierarchy[r1].finalTransform.mProp.applyToMatrix(t1);
                }
                return t1.inversePoint(e1);
            }
            function o1(t1) {
                var e1 = new Matrix;
                if (e1.reset(), this._elem.finalTransform.mProp.applyToMatrix(e1), this._elem.hierarchy && this._elem.hierarchy.length) {
                    var r1, i1 = this._elem.hierarchy.length;
                    for(r1 = 0; r1 < i1; r1 += 1)this._elem.hierarchy[r1].finalTransform.mProp.applyToMatrix(e1);
                    return e1.inversePoint(t1);
                }
                return e1.inversePoint(t1);
            }
            function h1() {
                return [
                    1,
                    1,
                    1,
                    1
                ];
            }
            return function(l1) {
                var p1;
                function f1(t1) {
                    switch(t1){
                        case "ADBE Root Vectors Group":
                        case "Contents":
                        case 2:
                            return f1.shapeInterface;
                        case 1:
                        case 6:
                        case "Transform":
                        case "transform":
                        case "ADBE Transform Group":
                            return p1;
                        case 4:
                        case "ADBE Effect Parade":
                        case "effects":
                        case "Effects":
                            return f1.effect;
                        case "ADBE Text Properties":
                            return f1.textInterface;
                        default:
                            return null;
                    }
                }
                f1.getMatrix = t1, f1.invertPoint = n1, f1.applyPoint = s1, f1.toWorld = r1, f1.toWorldVec = e1, f1.fromWorld = a1, f1.fromWorldVec = i1, f1.toComp = r1, f1.fromComp = o1, f1.sampleImage = h1, f1.sourceRectAtTime = l1.sourceRectAtTime.bind(l1), f1._elem = l1;
                var c1 = getDescriptor(p1 = TransformExpressionInterface(l1.finalTransform.mProp), "anchorPoint");
                return Object.defineProperties(f1, {
                    hasParent: {
                        get: function() {
                            return l1.hierarchy.length;
                        }
                    },
                    parent: {
                        get: function() {
                            return l1.hierarchy[0].layerInterface;
                        }
                    },
                    rotation: getDescriptor(p1, "rotation"),
                    scale: getDescriptor(p1, "scale"),
                    position: getDescriptor(p1, "position"),
                    opacity: getDescriptor(p1, "opacity"),
                    anchorPoint: c1,
                    anchor_point: c1,
                    transform: {
                        get: function() {
                            return p1;
                        }
                    },
                    active: {
                        get: function() {
                            return l1.isInRange;
                        }
                    }
                }), f1.startTime = l1.data.st, f1.index = l1.data.ind, f1.source = l1.data.refId, f1.height = 0 === l1.data.ty ? l1.data.h : 100, f1.width = 0 === l1.data.ty ? l1.data.w : 100, f1.inPoint = l1.data.ip / l1.comp.globalData.frameRate, f1.outPoint = l1.data.op / l1.comp.globalData.frameRate, f1._name = l1.data.nm, f1.registerMaskInterface = function(t1) {
                    f1.mask = new MaskManagerInterface(t1, l1);
                }, f1.registerEffectsInterface = function(t1) {
                    f1.effect = t1;
                }, f1;
            };
        }(), propertyGroupFactory = function(t1, e1) {
            return function(r1) {
                return (r1 = void 0 === r1 ? 1 : r1) <= 0 ? t1 : e1(r1 - 1);
            };
        }, PropertyInterface = function(t1, e1) {
            var r1 = {
                _name: t1
            };
            return function(t1) {
                return (t1 = void 0 === t1 ? 1 : t1) <= 0 ? r1 : e1(t1 - 1);
            };
        }, EffectsExpressionInterface = function() {
            function t1(r1, i1, a1, s1) {
                function n1(t1) {
                    for(var e1 = r1.ef, i1 = 0, a1 = e1.length; i1 < a1;){
                        if (t1 === e1[i1].nm || t1 === e1[i1].mn || t1 === e1[i1].ix) return 5 === e1[i1].ty ? l1[i1] : l1[i1]();
                        i1 += 1;
                    }
                    throw new Error;
                }
                var o1, h1 = propertyGroupFactory(n1, a1), l1 = [], p1 = r1.ef.length;
                for(o1 = 0; o1 < p1; o1 += 1)5 === r1.ef[o1].ty ? l1.push(t1(r1.ef[o1], i1.effectElements[o1], i1.effectElements[o1].propertyGroup, s1)) : l1.push(e1(i1.effectElements[o1], r1.ef[o1].ty, s1, h1));
                return "ADBE Color Control" === r1.mn && Object.defineProperty(n1, "color", {
                    get: function() {
                        return l1[0]();
                    }
                }), Object.defineProperties(n1, {
                    numProperties: {
                        get: function() {
                            return r1.np;
                        }
                    },
                    _name: {
                        value: r1.nm
                    },
                    propertyGroup: {
                        value: h1
                    }
                }), n1.enabled = 0 !== r1.en, n1.active = n1.enabled, n1;
            }
            function e1(t1, e1, r1, i1) {
                var a1 = ExpressionPropertyInterface(t1.p);
                return t1.p.setGroupProperty && t1.p.setGroupProperty(PropertyInterface("", i1)), function() {
                    return 10 === e1 ? r1.comp.compInterface(t1.p.v) : a1();
                };
            }
            return {
                createEffectsInterface: function(e1, r1) {
                    if (e1.effectsManager) {
                        var i1, a1 = [], s1 = e1.data.ef, n1 = e1.effectsManager.effectElements.length;
                        for(i1 = 0; i1 < n1; i1 += 1)a1.push(t1(s1[i1], e1.effectsManager.effectElements[i1], r1, e1));
                        var o1 = e1.data.ef || [], h1 = function(t1) {
                            for(i1 = 0, n1 = o1.length; i1 < n1;){
                                if (t1 === o1[i1].nm || t1 === o1[i1].mn || t1 === o1[i1].ix) return a1[i1];
                                i1 += 1;
                            }
                            return null;
                        };
                        return Object.defineProperty(h1, "numProperties", {
                            get: function() {
                                return o1.length;
                            }
                        }), h1;
                    }
                    return null;
                }
            };
        }(), ShapePathInterface = function(t1, e1, r1) {
            var i1 = e1.sh;
            function a1(t1) {
                return "Shape" === t1 || "shape" === t1 || "Path" === t1 || "path" === t1 || "ADBE Vector Shape" === t1 || 2 === t1 ? a1.path : null;
            }
            var s1 = propertyGroupFactory(a1, r1);
            return i1.setGroupProperty(PropertyInterface("Path", s1)), Object.defineProperties(a1, {
                path: {
                    get: function() {
                        return i1.k && i1.getValue(), i1;
                    }
                },
                shape: {
                    get: function() {
                        return i1.k && i1.getValue(), i1;
                    }
                },
                _name: {
                    value: t1.nm
                },
                ix: {
                    value: t1.ix
                },
                propertyIndex: {
                    value: t1.ix
                },
                mn: {
                    value: t1.mn
                },
                propertyGroup: {
                    value: r1
                }
            }), a1;
        }, ShapeExpressionInterface = function() {
            function t1(t1, o1, m1) {
                var d1, u1 = [], y1 = t1 ? t1.length : 0;
                for(d1 = 0; d1 < y1; d1 += 1)"gr" === t1[d1].ty ? u1.push(e1(t1[d1], o1[d1], m1)) : "fl" === t1[d1].ty ? u1.push(r1(t1[d1], o1[d1], m1)) : "st" === t1[d1].ty ? u1.push(s1(t1[d1], o1[d1], m1)) : "tm" === t1[d1].ty ? u1.push(n1(t1[d1], o1[d1], m1)) : "tr" === t1[d1].ty || ("el" === t1[d1].ty ? u1.push(h1(t1[d1], o1[d1], m1)) : "sr" === t1[d1].ty ? u1.push(l1(t1[d1], o1[d1], m1)) : "sh" === t1[d1].ty ? u1.push(ShapePathInterface(t1[d1], o1[d1], m1)) : "rc" === t1[d1].ty ? u1.push(p1(t1[d1], o1[d1], m1)) : "rd" === t1[d1].ty ? u1.push(f1(t1[d1], o1[d1], m1)) : "rp" === t1[d1].ty ? u1.push(c1(t1[d1], o1[d1], m1)) : "gf" === t1[d1].ty ? u1.push(i1(t1[d1], o1[d1], m1)) : u1.push(a1(t1[d1], o1[d1])));
                return u1;
            }
            function e1(e1, r1, i1) {
                var a1 = function(t1) {
                    switch(t1){
                        case "ADBE Vectors Group":
                        case "Contents":
                        case 2:
                            return a1.content;
                        default:
                            return a1.transform;
                    }
                };
                a1.propertyGroup = propertyGroupFactory(a1, i1);
                var s1 = function(e1, r1, i1) {
                    var a1, s1 = function(t1) {
                        for(var e1 = 0, r1 = a1.length; e1 < r1;){
                            if (a1[e1]._name === t1 || a1[e1].mn === t1 || a1[e1].propertyIndex === t1 || a1[e1].ix === t1 || a1[e1].ind === t1) return a1[e1];
                            e1 += 1;
                        }
                        return "number" == typeof t1 ? a1[t1 - 1] : null;
                    };
                    s1.propertyGroup = propertyGroupFactory(s1, i1), a1 = t1(e1.it, r1.it, s1.propertyGroup), s1.numProperties = a1.length;
                    var n1 = o1(e1.it[e1.it.length - 1], r1.it[r1.it.length - 1], s1.propertyGroup);
                    return s1.transform = n1, s1.propertyIndex = e1.cix, s1._name = e1.nm, s1;
                }(e1, r1, a1.propertyGroup), n1 = o1(e1.it[e1.it.length - 1], r1.it[r1.it.length - 1], a1.propertyGroup);
                return a1.content = s1, a1.transform = n1, Object.defineProperty(a1, "_name", {
                    get: function() {
                        return e1.nm;
                    }
                }), a1.numProperties = e1.np, a1.propertyIndex = e1.ix, a1.nm = e1.nm, a1.mn = e1.mn, a1;
            }
            function r1(t1, e1, r1) {
                function i1(t1) {
                    return "Color" === t1 || "color" === t1 ? i1.color : "Opacity" === t1 || "opacity" === t1 ? i1.opacity : null;
                }
                return Object.defineProperties(i1, {
                    color: {
                        get: ExpressionPropertyInterface(e1.c)
                    },
                    opacity: {
                        get: ExpressionPropertyInterface(e1.o)
                    },
                    _name: {
                        value: t1.nm
                    },
                    mn: {
                        value: t1.mn
                    }
                }), e1.c.setGroupProperty(PropertyInterface("Color", r1)), e1.o.setGroupProperty(PropertyInterface("Opacity", r1)), i1;
            }
            function i1(t1, e1, r1) {
                function i1(t1) {
                    return "Start Point" === t1 || "start point" === t1 ? i1.startPoint : "End Point" === t1 || "end point" === t1 ? i1.endPoint : "Opacity" === t1 || "opacity" === t1 ? i1.opacity : null;
                }
                return Object.defineProperties(i1, {
                    startPoint: {
                        get: ExpressionPropertyInterface(e1.s)
                    },
                    endPoint: {
                        get: ExpressionPropertyInterface(e1.e)
                    },
                    opacity: {
                        get: ExpressionPropertyInterface(e1.o)
                    },
                    type: {
                        get: function() {
                            return "a";
                        }
                    },
                    _name: {
                        value: t1.nm
                    },
                    mn: {
                        value: t1.mn
                    }
                }), e1.s.setGroupProperty(PropertyInterface("Start Point", r1)), e1.e.setGroupProperty(PropertyInterface("End Point", r1)), e1.o.setGroupProperty(PropertyInterface("Opacity", r1)), i1;
            }
            function a1() {
                return function() {
                    return null;
                };
            }
            function s1(t1, e1, r1) {
                var i1, a1 = propertyGroupFactory(l1, r1), s1 = propertyGroupFactory(h1, a1);
                function n1(r1) {
                    Object.defineProperty(h1, t1.d[r1].nm, {
                        get: ExpressionPropertyInterface(e1.d.dataProps[r1].p)
                    });
                }
                var o1 = t1.d ? t1.d.length : 0, h1 = {};
                for(i1 = 0; i1 < o1; i1 += 1)n1(i1), e1.d.dataProps[i1].p.setGroupProperty(s1);
                function l1(t1) {
                    return "Color" === t1 || "color" === t1 ? l1.color : "Opacity" === t1 || "opacity" === t1 ? l1.opacity : "Stroke Width" === t1 || "stroke width" === t1 ? l1.strokeWidth : null;
                }
                return Object.defineProperties(l1, {
                    color: {
                        get: ExpressionPropertyInterface(e1.c)
                    },
                    opacity: {
                        get: ExpressionPropertyInterface(e1.o)
                    },
                    strokeWidth: {
                        get: ExpressionPropertyInterface(e1.w)
                    },
                    dash: {
                        get: function() {
                            return h1;
                        }
                    },
                    _name: {
                        value: t1.nm
                    },
                    mn: {
                        value: t1.mn
                    }
                }), e1.c.setGroupProperty(PropertyInterface("Color", a1)), e1.o.setGroupProperty(PropertyInterface("Opacity", a1)), e1.w.setGroupProperty(PropertyInterface("Stroke Width", a1)), l1;
            }
            function n1(t1, e1, r1) {
                function i1(e1) {
                    return e1 === t1.e.ix || "End" === e1 || "end" === e1 ? i1.end : e1 === t1.s.ix ? i1.start : e1 === t1.o.ix ? i1.offset : null;
                }
                var a1 = propertyGroupFactory(i1, r1);
                return i1.propertyIndex = t1.ix, e1.s.setGroupProperty(PropertyInterface("Start", a1)), e1.e.setGroupProperty(PropertyInterface("End", a1)), e1.o.setGroupProperty(PropertyInterface("Offset", a1)), i1.propertyIndex = t1.ix, i1.propertyGroup = r1, Object.defineProperties(i1, {
                    start: {
                        get: ExpressionPropertyInterface(e1.s)
                    },
                    end: {
                        get: ExpressionPropertyInterface(e1.e)
                    },
                    offset: {
                        get: ExpressionPropertyInterface(e1.o)
                    },
                    _name: {
                        value: t1.nm
                    }
                }), i1.mn = t1.mn, i1;
            }
            function o1(t1, e1, r1) {
                function i1(e1) {
                    return t1.a.ix === e1 || "Anchor Point" === e1 ? i1.anchorPoint : t1.o.ix === e1 || "Opacity" === e1 ? i1.opacity : t1.p.ix === e1 || "Position" === e1 ? i1.position : t1.r.ix === e1 || "Rotation" === e1 || "ADBE Vector Rotation" === e1 ? i1.rotation : t1.s.ix === e1 || "Scale" === e1 ? i1.scale : t1.sk && t1.sk.ix === e1 || "Skew" === e1 ? i1.skew : t1.sa && t1.sa.ix === e1 || "Skew Axis" === e1 ? i1.skewAxis : null;
                }
                var a1 = propertyGroupFactory(i1, r1);
                return e1.transform.mProps.o.setGroupProperty(PropertyInterface("Opacity", a1)), e1.transform.mProps.p.setGroupProperty(PropertyInterface("Position", a1)), e1.transform.mProps.a.setGroupProperty(PropertyInterface("Anchor Point", a1)), e1.transform.mProps.s.setGroupProperty(PropertyInterface("Scale", a1)), e1.transform.mProps.r.setGroupProperty(PropertyInterface("Rotation", a1)), e1.transform.mProps.sk && (e1.transform.mProps.sk.setGroupProperty(PropertyInterface("Skew", a1)), e1.transform.mProps.sa.setGroupProperty(PropertyInterface("Skew Angle", a1))), e1.transform.op.setGroupProperty(PropertyInterface("Opacity", a1)), Object.defineProperties(i1, {
                    opacity: {
                        get: ExpressionPropertyInterface(e1.transform.mProps.o)
                    },
                    position: {
                        get: ExpressionPropertyInterface(e1.transform.mProps.p)
                    },
                    anchorPoint: {
                        get: ExpressionPropertyInterface(e1.transform.mProps.a)
                    },
                    scale: {
                        get: ExpressionPropertyInterface(e1.transform.mProps.s)
                    },
                    rotation: {
                        get: ExpressionPropertyInterface(e1.transform.mProps.r)
                    },
                    skew: {
                        get: ExpressionPropertyInterface(e1.transform.mProps.sk)
                    },
                    skewAxis: {
                        get: ExpressionPropertyInterface(e1.transform.mProps.sa)
                    },
                    _name: {
                        value: t1.nm
                    }
                }), i1.ty = "tr", i1.mn = t1.mn, i1.propertyGroup = r1, i1;
            }
            function h1(t1, e1, r1) {
                function i1(e1) {
                    return t1.p.ix === e1 ? i1.position : t1.s.ix === e1 ? i1.size : null;
                }
                var a1 = propertyGroupFactory(i1, r1);
                i1.propertyIndex = t1.ix;
                var s1 = "tm" === e1.sh.ty ? e1.sh.prop : e1.sh;
                return s1.s.setGroupProperty(PropertyInterface("Size", a1)), s1.p.setGroupProperty(PropertyInterface("Position", a1)), Object.defineProperties(i1, {
                    size: {
                        get: ExpressionPropertyInterface(s1.s)
                    },
                    position: {
                        get: ExpressionPropertyInterface(s1.p)
                    },
                    _name: {
                        value: t1.nm
                    }
                }), i1.mn = t1.mn, i1;
            }
            function l1(t1, e1, r1) {
                function i1(e1) {
                    return t1.p.ix === e1 ? i1.position : t1.r.ix === e1 ? i1.rotation : t1.pt.ix === e1 ? i1.points : t1.or.ix === e1 || "ADBE Vector Star Outer Radius" === e1 ? i1.outerRadius : t1.os.ix === e1 ? i1.outerRoundness : !t1.ir || t1.ir.ix !== e1 && "ADBE Vector Star Inner Radius" !== e1 ? t1.is && t1.is.ix === e1 ? i1.innerRoundness : null : i1.innerRadius;
                }
                var a1 = propertyGroupFactory(i1, r1), s1 = "tm" === e1.sh.ty ? e1.sh.prop : e1.sh;
                return i1.propertyIndex = t1.ix, s1.or.setGroupProperty(PropertyInterface("Outer Radius", a1)), s1.os.setGroupProperty(PropertyInterface("Outer Roundness", a1)), s1.pt.setGroupProperty(PropertyInterface("Points", a1)), s1.p.setGroupProperty(PropertyInterface("Position", a1)), s1.r.setGroupProperty(PropertyInterface("Rotation", a1)), t1.ir && (s1.ir.setGroupProperty(PropertyInterface("Inner Radius", a1)), s1.is.setGroupProperty(PropertyInterface("Inner Roundness", a1))), Object.defineProperties(i1, {
                    position: {
                        get: ExpressionPropertyInterface(s1.p)
                    },
                    rotation: {
                        get: ExpressionPropertyInterface(s1.r)
                    },
                    points: {
                        get: ExpressionPropertyInterface(s1.pt)
                    },
                    outerRadius: {
                        get: ExpressionPropertyInterface(s1.or)
                    },
                    outerRoundness: {
                        get: ExpressionPropertyInterface(s1.os)
                    },
                    innerRadius: {
                        get: ExpressionPropertyInterface(s1.ir)
                    },
                    innerRoundness: {
                        get: ExpressionPropertyInterface(s1.is)
                    },
                    _name: {
                        value: t1.nm
                    }
                }), i1.mn = t1.mn, i1;
            }
            function p1(t1, e1, r1) {
                function i1(e1) {
                    return t1.p.ix === e1 ? i1.position : t1.r.ix === e1 ? i1.roundness : t1.s.ix === e1 || "Size" === e1 || "ADBE Vector Rect Size" === e1 ? i1.size : null;
                }
                var a1 = propertyGroupFactory(i1, r1), s1 = "tm" === e1.sh.ty ? e1.sh.prop : e1.sh;
                return i1.propertyIndex = t1.ix, s1.p.setGroupProperty(PropertyInterface("Position", a1)), s1.s.setGroupProperty(PropertyInterface("Size", a1)), s1.r.setGroupProperty(PropertyInterface("Rotation", a1)), Object.defineProperties(i1, {
                    position: {
                        get: ExpressionPropertyInterface(s1.p)
                    },
                    roundness: {
                        get: ExpressionPropertyInterface(s1.r)
                    },
                    size: {
                        get: ExpressionPropertyInterface(s1.s)
                    },
                    _name: {
                        value: t1.nm
                    }
                }), i1.mn = t1.mn, i1;
            }
            function f1(t1, e1, r1) {
                function i1(e1) {
                    return t1.r.ix === e1 || "Round Corners 1" === e1 ? i1.radius : null;
                }
                var a1 = propertyGroupFactory(i1, r1), s1 = e1;
                return i1.propertyIndex = t1.ix, s1.rd.setGroupProperty(PropertyInterface("Radius", a1)), Object.defineProperties(i1, {
                    radius: {
                        get: ExpressionPropertyInterface(s1.rd)
                    },
                    _name: {
                        value: t1.nm
                    }
                }), i1.mn = t1.mn, i1;
            }
            function c1(t1, e1, r1) {
                function i1(e1) {
                    return t1.c.ix === e1 || "Copies" === e1 ? i1.copies : t1.o.ix === e1 || "Offset" === e1 ? i1.offset : null;
                }
                var a1 = propertyGroupFactory(i1, r1), s1 = e1;
                return i1.propertyIndex = t1.ix, s1.c.setGroupProperty(PropertyInterface("Copies", a1)), s1.o.setGroupProperty(PropertyInterface("Offset", a1)), Object.defineProperties(i1, {
                    copies: {
                        get: ExpressionPropertyInterface(s1.c)
                    },
                    offset: {
                        get: ExpressionPropertyInterface(s1.o)
                    },
                    _name: {
                        value: t1.nm
                    }
                }), i1.mn = t1.mn, i1;
            }
            return function(e1, r1, i1) {
                var a1;
                function s1(t1) {
                    if ("number" == typeof t1) return 0 === (t1 = void 0 === t1 ? 1 : t1) ? i1 : a1[t1 - 1];
                    for(var e1 = 0, r1 = a1.length; e1 < r1;){
                        if (a1[e1]._name === t1) return a1[e1];
                        e1 += 1;
                    }
                    return null;
                }
                return s1.propertyGroup = propertyGroupFactory(s1, function() {
                    return i1;
                }), a1 = t1(e1, r1, s1.propertyGroup), s1.numProperties = a1.length, s1._name = "Contents", s1;
            };
        }(), TextExpressionInterface = function(t1) {
            var e1, r1;
            function i1(t1) {
                switch(t1){
                    case "ADBE Text Document":
                        return i1.sourceText;
                    default:
                        return null;
                }
            }
            return Object.defineProperty(i1, "sourceText", {
                get: function() {
                    t1.textProperty.getValue();
                    var i1 = t1.textProperty.currentData.t;
                    return i1 !== e1 && (e1 = t1.textProperty.currentData.t, (r1 = new String(i1)).value = i1 || new String(i1), Object.defineProperty(r1, "style", {
                        get: function() {
                            return {
                                fillColor: t1.textProperty.currentData.fc
                            };
                        }
                    })), r1;
                }
            }), i1;
        };
        function _typeof$2(t1) {
            return (_typeof$2 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t1) {
                return typeof t1;
            } : function(t1) {
                return t1 && "function" == typeof Symbol && t1.constructor === Symbol && t1 !== Symbol.prototype ? "symbol" : typeof t1;
            })(t1);
        }
        var FootageInterface = (dataInterfaceFactory = function(t1) {
            function e1(t1) {
                return "Outline" === t1 ? e1.outlineInterface() : null;
            }
            return e1._name = "Outline", e1.outlineInterface = function(t1) {
                var e1 = "", r1 = t1.getFootageData();
                function i1(t1) {
                    if (r1[t1]) return e1 = t1, "object" === _typeof$2(r1 = r1[t1]) ? i1 : r1;
                    var a1 = t1.indexOf(e1);
                    if (-1 !== a1) {
                        var s1 = parseInt(t1.substr(a1 + e1.length), 10);
                        return "object" === _typeof$2(r1 = r1[s1]) ? i1 : r1;
                    }
                    return "";
                }
                return function() {
                    return e1 = "", r1 = t1.getFootageData(), i1;
                };
            }(t1), e1;
        }, function(t1) {
            function e1(t1) {
                return "Data" === t1 ? e1.dataInterface : null;
            }
            return e1._name = "Data", e1.dataInterface = dataInterfaceFactory(t1), e1;
        }), dataInterfaceFactory, interfaces = {
            layer: LayerExpressionInterface,
            effects: EffectsExpressionInterface,
            comp: CompExpressionInterface,
            shape: ShapeExpressionInterface,
            text: TextExpressionInterface,
            footage: FootageInterface
        };
        function getInterface(t1) {
            return interfaces[t1] || null;
        }
        function _typeof$1(t1) {
            return (_typeof$1 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t1) {
                return typeof t1;
            } : function(t1) {
                return t1 && "function" == typeof Symbol && t1.constructor === Symbol && t1 !== Symbol.prototype ? "symbol" : typeof t1;
            })(t1);
        }
        function seedRandom(t1, e1) {
            var r1 = this, i1 = e1.pow(256, 6), a1 = e1.pow(2, 52), s1 = 2 * a1;
            function n1(t1) {
                var e1, r1 = t1.length, i1 = this, a1 = 0, s1 = i1.i = i1.j = 0, n1 = i1.S = [];
                for(r1 || (t1 = [
                    r1++
                ]); a1 < 256;)n1[a1] = a1++;
                for(a1 = 0; a1 < 256; a1++)n1[a1] = n1[s1 = 255 & s1 + t1[a1 % r1] + (e1 = n1[a1])], n1[s1] = e1;
                i1.g = function(t1) {
                    for(var e1, r1 = 0, a1 = i1.i, s1 = i1.j, n1 = i1.S; t1--;)e1 = n1[a1 = 255 & a1 + 1], r1 = 256 * r1 + n1[255 & (n1[a1] = n1[s1 = 255 & s1 + e1]) + (n1[s1] = e1)];
                    return i1.i = a1, i1.j = s1, r1;
                };
            }
            function o1(t1, e1) {
                return e1.i = t1.i, e1.j = t1.j, e1.S = t1.S.slice(), e1;
            }
            function h1(t1, e1) {
                for(var r1, i1 = t1 + "", a1 = 0; a1 < i1.length;)e1[255 & a1] = 255 & (r1 ^= 19 * e1[255 & a1]) + i1.charCodeAt(a1++);
                return l1(e1);
            }
            function l1(t1) {
                return String.fromCharCode.apply(0, t1);
            }
            e1.seedrandom = function(p1, f1, c1) {
                var m1 = [], d1 = h1(function t1(e1, r1) {
                    var i1, a1 = [], s1 = _typeof$1(e1);
                    if (r1 && "object" == s1) for(i1 in e1)try {
                        a1.push(t1(e1[i1], r1 - 1));
                    } catch (t1) {}
                    return a1.length ? a1 : "string" == s1 ? e1 : e1 + "\x00";
                }((f1 = !0 === f1 ? {
                    entropy: !0
                } : f1 || {}).entropy ? [
                    p1,
                    l1(t1)
                ] : null === p1 ? function() {
                    try {
                        var e1 = new Uint8Array(256);
                        return (r1.crypto || r1.msCrypto).getRandomValues(e1), l1(e1);
                    } catch (e1) {
                        var i1 = r1.navigator, a1 = i1 && i1.plugins;
                        return [
                            +new Date,
                            r1,
                            a1,
                            r1.screen,
                            l1(t1)
                        ];
                    }
                }() : p1, 3), m1), u1 = new n1(m1), y1 = function() {
                    for(var t1 = u1.g(6), e1 = i1, r1 = 0; t1 < a1;)t1 = 256 * (t1 + r1), e1 *= 256, r1 = u1.g(1);
                    for(; t1 >= s1;)t1 /= 2, e1 /= 2, r1 >>>= 1;
                    return (t1 + r1) / e1;
                };
                return y1.int32 = function() {
                    return 0 | u1.g(4);
                }, y1.quick = function() {
                    return u1.g(4) / 4294967296;
                }, y1.double = y1, h1(l1(u1.S), t1), (f1.pass || c1 || function(t1, r1, i1, a1) {
                    return a1 && (a1.S && o1(a1, u1), t1.state = function() {
                        return o1(u1, {});
                    }), i1 ? (e1.random = t1, r1) : t1;
                })(y1, d1, "global" in f1 ? f1.global : this == e1, f1.state);
            }, h1(e1.random(), t1);
        }
        function initialize$2(t1) {
            seedRandom([], t1);
        }
        var propTypes = {
            SHAPE: "shape"
        };
        function _typeof(t1) {
            return (_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t1) {
                return typeof t1;
            } : function(t1) {
                return t1 && "function" == typeof Symbol && t1.constructor === Symbol && t1 !== Symbol.prototype ? "symbol" : typeof t1;
            })(t1);
        }
        var ExpressionManager = function() {
            var ob = {}, Math = BMMath, window = null, document = null, XMLHttpRequest = null, fetch = null, frames = null;
            function $bm_isInstanceOfArray(t1) {
                return t1.constructor === Array || t1.constructor === Float32Array;
            }
            function isNumerable(t1, e1) {
                return "number" === t1 || "boolean" === t1 || "string" === t1 || e1 instanceof Number;
            }
            function $bm_neg(t1) {
                var e1 = _typeof(t1);
                if ("number" === e1 || "boolean" === e1 || t1 instanceof Number) return -t1;
                if ($bm_isInstanceOfArray(t1)) {
                    var r1, i1 = t1.length, a1 = [];
                    for(r1 = 0; r1 < i1; r1 += 1)a1[r1] = -t1[r1];
                    return a1;
                }
                return t1.propType ? t1.v : -t1;
            }
            initialize$2(BMMath);
            var easeInBez = BezierFactory.getBezierEasing(.333, 0, .833, .833, "easeIn").get, easeOutBez = BezierFactory.getBezierEasing(.167, .167, .667, 1, "easeOut").get, easeInOutBez = BezierFactory.getBezierEasing(.33, 0, .667, 1, "easeInOut").get;
            function sum(t1, e1) {
                var r1 = _typeof(t1), i1 = _typeof(e1);
                if ("string" === r1 || "string" === i1) return t1 + e1;
                if (isNumerable(r1, t1) && isNumerable(i1, e1)) return t1 + e1;
                if ($bm_isInstanceOfArray(t1) && isNumerable(i1, e1)) return (t1 = t1.slice(0))[0] += e1, t1;
                if (isNumerable(r1, t1) && $bm_isInstanceOfArray(e1)) return (e1 = e1.slice(0))[0] = t1 + e1[0], e1;
                if ($bm_isInstanceOfArray(t1) && $bm_isInstanceOfArray(e1)) {
                    for(var a1 = 0, s1 = t1.length, n1 = e1.length, o1 = []; a1 < s1 || a1 < n1;)("number" == typeof t1[a1] || t1[a1] instanceof Number) && ("number" == typeof e1[a1] || e1[a1] instanceof Number) ? o1[a1] = t1[a1] + e1[a1] : o1[a1] = void 0 === e1[a1] ? t1[a1] : t1[a1] || e1[a1], a1 += 1;
                    return o1;
                }
                return 0;
            }
            var add = sum;
            function sub(t1, e1) {
                var r1 = _typeof(t1), i1 = _typeof(e1);
                if (isNumerable(r1, t1) && isNumerable(i1, e1)) return "string" === r1 && (t1 = parseInt(t1, 10)), "string" === i1 && (e1 = parseInt(e1, 10)), t1 - e1;
                if ($bm_isInstanceOfArray(t1) && isNumerable(i1, e1)) return (t1 = t1.slice(0))[0] -= e1, t1;
                if (isNumerable(r1, t1) && $bm_isInstanceOfArray(e1)) return (e1 = e1.slice(0))[0] = t1 - e1[0], e1;
                if ($bm_isInstanceOfArray(t1) && $bm_isInstanceOfArray(e1)) {
                    for(var a1 = 0, s1 = t1.length, n1 = e1.length, o1 = []; a1 < s1 || a1 < n1;)("number" == typeof t1[a1] || t1[a1] instanceof Number) && ("number" == typeof e1[a1] || e1[a1] instanceof Number) ? o1[a1] = t1[a1] - e1[a1] : o1[a1] = void 0 === e1[a1] ? t1[a1] : t1[a1] || e1[a1], a1 += 1;
                    return o1;
                }
                return 0;
            }
            function mul(t1, e1) {
                var r1, i1, a1, s1 = _typeof(t1), n1 = _typeof(e1);
                if (isNumerable(s1, t1) && isNumerable(n1, e1)) return t1 * e1;
                if ($bm_isInstanceOfArray(t1) && isNumerable(n1, e1)) {
                    for(a1 = t1.length, r1 = createTypedArray("float32", a1), i1 = 0; i1 < a1; i1 += 1)r1[i1] = t1[i1] * e1;
                    return r1;
                }
                if (isNumerable(s1, t1) && $bm_isInstanceOfArray(e1)) {
                    for(a1 = e1.length, r1 = createTypedArray("float32", a1), i1 = 0; i1 < a1; i1 += 1)r1[i1] = t1 * e1[i1];
                    return r1;
                }
                return 0;
            }
            function div(t1, e1) {
                var r1, i1, a1, s1 = _typeof(t1), n1 = _typeof(e1);
                if (isNumerable(s1, t1) && isNumerable(n1, e1)) return t1 / e1;
                if ($bm_isInstanceOfArray(t1) && isNumerable(n1, e1)) {
                    for(a1 = t1.length, r1 = createTypedArray("float32", a1), i1 = 0; i1 < a1; i1 += 1)r1[i1] = t1[i1] / e1;
                    return r1;
                }
                if (isNumerable(s1, t1) && $bm_isInstanceOfArray(e1)) {
                    for(a1 = e1.length, r1 = createTypedArray("float32", a1), i1 = 0; i1 < a1; i1 += 1)r1[i1] = t1 / e1[i1];
                    return r1;
                }
                return 0;
            }
            function mod(t1, e1) {
                return "string" == typeof t1 && (t1 = parseInt(t1, 10)), "string" == typeof e1 && (e1 = parseInt(e1, 10)), t1 % e1;
            }
            var $bm_sum = sum, $bm_sub = sub, $bm_mul = mul, $bm_div = div, $bm_mod = mod;
            function clamp(t1, e1, r1) {
                if (e1 > r1) {
                    var i1 = r1;
                    r1 = e1, e1 = i1;
                }
                return Math.min(Math.max(t1, e1), r1);
            }
            function radiansToDegrees(t1) {
                return t1 / degToRads;
            }
            var radians_to_degrees = radiansToDegrees;
            function degreesToRadians(t1) {
                return t1 * degToRads;
            }
            var degrees_to_radians = radiansToDegrees, helperLengthArray = [
                0,
                0,
                0,
                0,
                0,
                0
            ];
            function length(t1, e1) {
                if ("number" == typeof t1 || t1 instanceof Number) return e1 = e1 || 0, Math.abs(t1 - e1);
                var r1;
                e1 || (e1 = helperLengthArray);
                var i1 = Math.min(t1.length, e1.length), a1 = 0;
                for(r1 = 0; r1 < i1; r1 += 1)a1 += Math.pow(e1[r1] - t1[r1], 2);
                return Math.sqrt(a1);
            }
            function normalize(t1) {
                return div(t1, length(t1));
            }
            function rgbToHsl(t1) {
                var e1, r1, i1 = t1[0], a1 = t1[1], s1 = t1[2], n1 = Math.max(i1, a1, s1), o1 = Math.min(i1, a1, s1), h1 = (n1 + o1) / 2;
                if (n1 === o1) e1 = 0, r1 = 0;
                else {
                    var l1 = n1 - o1;
                    switch(r1 = h1 > .5 ? l1 / (2 - n1 - o1) : l1 / (n1 + o1), n1){
                        case i1:
                            e1 = (a1 - s1) / l1 + (a1 < s1 ? 6 : 0);
                            break;
                        case a1:
                            e1 = (s1 - i1) / l1 + 2;
                            break;
                        case s1:
                            e1 = (i1 - a1) / l1 + 4;
                    }
                    e1 /= 6;
                }
                return [
                    e1,
                    r1,
                    h1,
                    t1[3]
                ];
            }
            function hue2rgb(t1, e1, r1) {
                return r1 < 0 && (r1 += 1), r1 > 1 && (r1 -= 1), r1 < 1 / 6 ? t1 + 6 * (e1 - t1) * r1 : r1 < .5 ? e1 : r1 < 2 / 3 ? t1 + (e1 - t1) * (2 / 3 - r1) * 6 : t1;
            }
            function hslToRgb(t1) {
                var e1, r1, i1, a1 = t1[0], s1 = t1[1], n1 = t1[2];
                if (0 === s1) e1 = n1, i1 = n1, r1 = n1;
                else {
                    var o1 = n1 < .5 ? n1 * (1 + s1) : n1 + s1 - n1 * s1, h1 = 2 * n1 - o1;
                    e1 = hue2rgb(h1, o1, a1 + 1 / 3), r1 = hue2rgb(h1, o1, a1), i1 = hue2rgb(h1, o1, a1 - 1 / 3);
                }
                return [
                    e1,
                    r1,
                    i1,
                    t1[3]
                ];
            }
            function linear(t1, e1, r1, i1, a1) {
                if (void 0 !== i1 && void 0 !== a1 || (i1 = e1, a1 = r1, e1 = 0, r1 = 1), r1 < e1) {
                    var s1 = r1;
                    r1 = e1, e1 = s1;
                }
                if (t1 <= e1) return i1;
                if (t1 >= r1) return a1;
                var n1, o1 = r1 === e1 ? 0 : (t1 - e1) / (r1 - e1);
                if (!i1.length) return i1 + (a1 - i1) * o1;
                var h1 = i1.length, l1 = createTypedArray("float32", h1);
                for(n1 = 0; n1 < h1; n1 += 1)l1[n1] = i1[n1] + (a1[n1] - i1[n1]) * o1;
                return l1;
            }
            function random(t1, e1) {
                if (void 0 === e1 && (void 0 === t1 ? (t1 = 0, e1 = 1) : (e1 = t1, t1 = void 0)), e1.length) {
                    var r1, i1 = e1.length;
                    t1 || (t1 = createTypedArray("float32", i1));
                    var a1 = createTypedArray("float32", i1), s1 = BMMath.random();
                    for(r1 = 0; r1 < i1; r1 += 1)a1[r1] = t1[r1] + s1 * (e1[r1] - t1[r1]);
                    return a1;
                }
                return void 0 === t1 && (t1 = 0), t1 + BMMath.random() * (e1 - t1);
            }
            function createPath(t1, e1, r1, i1) {
                var a1, s1 = t1.length, n1 = shapePool.newElement();
                n1.setPathData(!!i1, s1);
                var o1, h1, l1 = [
                    0,
                    0
                ];
                for(a1 = 0; a1 < s1; a1 += 1)o1 = e1 && e1[a1] ? e1[a1] : l1, h1 = r1 && r1[a1] ? r1[a1] : l1, n1.setTripleAt(t1[a1][0], t1[a1][1], h1[0] + t1[a1][0], h1[1] + t1[a1][1], o1[0] + t1[a1][0], o1[1] + t1[a1][1], a1, !0);
                return n1;
            }
            function initiateExpression(elem, data, property) {
                function noOp(t1) {
                    return t1;
                }
                if (!elem.globalData.renderConfig.runExpressions) return noOp;
                var val = data.x, needsVelocity = /velocity(?![\w\d])/.test(val), _needsRandom = -1 !== val.indexOf("random"), elemType = elem.data.ty, transform, $bm_transform, content, effect, thisProperty = property;
                thisProperty.valueAtTime = thisProperty.getValueAtTime, Object.defineProperty(thisProperty, "value", {
                    get: function() {
                        return thisProperty.v;
                    }
                }), elem.comp.frameDuration = 1 / elem.comp.globalData.frameRate, elem.comp.displayStartTime = 0;
                var inPoint = elem.data.ip / elem.comp.globalData.frameRate, outPoint = elem.data.op / elem.comp.globalData.frameRate, width = elem.data.sw ? elem.data.sw : 0, height = elem.data.sh ? elem.data.sh : 0, name = elem.data.nm, loopIn, loop_in, loopOut, loop_out, smooth, toWorld, fromWorld, fromComp, toComp, fromCompToSurface, position, rotation, anchorPoint, scale, thisLayer, thisComp, mask, valueAtTime, velocityAtTime, scoped_bm_rt, expression_function = eval("[function _expression_function(){" + val + ";scoped_bm_rt=$bm_rt}]")[0], numKeys = property.kf ? data.k.length : 0, active = !this.data || !0 !== this.data.hd, wiggle = (function(t1, e1) {
                    var r1, i1, a1 = this.pv.length ? this.pv.length : 1, s1 = createTypedArray("float32", a1);
                    var n1 = Math.floor(5 * time);
                    for(r1 = 0, i1 = 0; r1 < n1;){
                        for(i1 = 0; i1 < a1; i1 += 1)s1[i1] += -e1 + 2 * e1 * BMMath.random();
                        r1 += 1;
                    }
                    var o1 = 5 * time, h1 = o1 - Math.floor(o1), l1 = createTypedArray("float32", a1);
                    if (a1 > 1) {
                        for(i1 = 0; i1 < a1; i1 += 1)l1[i1] = this.pv[i1] + s1[i1] + (-e1 + 2 * e1 * BMMath.random()) * h1;
                        return l1;
                    }
                    return this.pv + s1[0] + (-e1 + 2 * e1 * BMMath.random()) * h1;
                }).bind(this);
                function loopInDuration(t1, e1) {
                    return loopIn(t1, e1, !0);
                }
                function loopOutDuration(t1, e1) {
                    return loopOut(t1, e1, !0);
                }
                thisProperty.loopIn && (loopIn = thisProperty.loopIn.bind(thisProperty), loop_in = loopIn), thisProperty.loopOut && (loopOut = thisProperty.loopOut.bind(thisProperty), loop_out = loopOut), thisProperty.smooth && (smooth = thisProperty.smooth.bind(thisProperty)), this.getValueAtTime && (valueAtTime = this.getValueAtTime.bind(this)), this.getVelocityAtTime && (velocityAtTime = this.getVelocityAtTime.bind(this));
                var comp = elem.comp.globalData.projectInterface.bind(elem.comp.globalData.projectInterface), time, velocity, value, text, textIndex, textTotal, selectorValue;
                function lookAt(t1, e1) {
                    var r1 = [
                        e1[0] - t1[0],
                        e1[1] - t1[1],
                        e1[2] - t1[2]
                    ], i1 = Math.atan2(r1[0], Math.sqrt(r1[1] * r1[1] + r1[2] * r1[2])) / degToRads;
                    return [
                        -Math.atan2(r1[1], r1[2]) / degToRads,
                        i1,
                        0
                    ];
                }
                function easeOut(t1, e1, r1, i1, a1) {
                    return applyEase(easeOutBez, t1, e1, r1, i1, a1);
                }
                function easeIn(t1, e1, r1, i1, a1) {
                    return applyEase(easeInBez, t1, e1, r1, i1, a1);
                }
                function ease(t1, e1, r1, i1, a1) {
                    return applyEase(easeInOutBez, t1, e1, r1, i1, a1);
                }
                function applyEase(t1, e1, r1, i1, a1, s1) {
                    void 0 === a1 ? (a1 = r1, s1 = i1) : e1 = (e1 - r1) / (i1 - r1), e1 > 1 ? e1 = 1 : e1 < 0 && (e1 = 0);
                    var n1 = t1(e1);
                    if ($bm_isInstanceOfArray(a1)) {
                        var o1, h1 = a1.length, l1 = createTypedArray("float32", h1);
                        for(o1 = 0; o1 < h1; o1 += 1)l1[o1] = (s1[o1] - a1[o1]) * n1 + a1[o1];
                        return l1;
                    }
                    return (s1 - a1) * n1 + a1;
                }
                function nearestKey(t1) {
                    var e1, r1, i1, a1 = data.k.length;
                    if (data.k.length && "number" != typeof data.k[0]) {
                        if (r1 = -1, (t1 *= elem.comp.globalData.frameRate) < data.k[0].t) r1 = 1, i1 = data.k[0].t;
                        else {
                            for(e1 = 0; e1 < a1 - 1; e1 += 1){
                                if (t1 === data.k[e1].t) {
                                    r1 = e1 + 1, i1 = data.k[e1].t;
                                    break;
                                }
                                if (t1 > data.k[e1].t && t1 < data.k[e1 + 1].t) {
                                    t1 - data.k[e1].t > data.k[e1 + 1].t - t1 ? (r1 = e1 + 2, i1 = data.k[e1 + 1].t) : (r1 = e1 + 1, i1 = data.k[e1].t);
                                    break;
                                }
                            }
                            -1 === r1 && (r1 = e1 + 1, i1 = data.k[e1].t);
                        }
                    } else r1 = 0, i1 = 0;
                    var s1 = {};
                    return s1.index = r1, s1.time = i1 / elem.comp.globalData.frameRate, s1;
                }
                function key(t1) {
                    var e1, r1, i1;
                    if (!data.k.length || "number" == typeof data.k[0]) throw new Error("The property has no keyframe at index " + t1);
                    t1 -= 1, e1 = {
                        time: data.k[t1].t / elem.comp.globalData.frameRate,
                        value: []
                    };
                    var a1 = Object.prototype.hasOwnProperty.call(data.k[t1], "s") ? data.k[t1].s : data.k[t1 - 1].e;
                    for(i1 = a1.length, r1 = 0; r1 < i1; r1 += 1)e1[r1] = a1[r1], e1.value[r1] = a1[r1];
                    return e1;
                }
                function framesToTime(t1, e1) {
                    return e1 || (e1 = elem.comp.globalData.frameRate), t1 / e1;
                }
                function timeToFrames(t1, e1) {
                    return t1 || 0 === t1 || (t1 = time), e1 || (e1 = elem.comp.globalData.frameRate), t1 * e1;
                }
                function seedRandom(t1) {
                    BMMath.seedrandom(randSeed + t1);
                }
                function sourceRectAtTime() {
                    return elem.sourceRectAtTime();
                }
                function substring(t1, e1) {
                    return "string" == typeof value ? void 0 === e1 ? value.substring(t1) : value.substring(t1, e1) : "";
                }
                function substr(t1, e1) {
                    return "string" == typeof value ? void 0 === e1 ? value.substr(t1) : value.substr(t1, e1) : "";
                }
                function posterizeTime(t1) {
                    time = 0 === t1 ? 0 : Math.floor(time * t1) / t1, value = valueAtTime(time);
                }
                var index = elem.data.ind, hasParent = !(!elem.hierarchy || !elem.hierarchy.length), parent, randSeed = Math.floor(1e6 * Math.random()), globalData = elem.globalData;
                function executeExpression(t1) {
                    return value = t1, this.frameExpressionId === elem.globalData.frameId && "textSelector" !== this.propType ? value : ("textSelector" === this.propType && (textIndex = this.textIndex, textTotal = this.textTotal, selectorValue = this.selectorValue), thisLayer || (text = elem.layerInterface.text, thisLayer = elem.layerInterface, thisComp = elem.comp.compInterface, toWorld = thisLayer.toWorld.bind(thisLayer), fromWorld = thisLayer.fromWorld.bind(thisLayer), fromComp = thisLayer.fromComp.bind(thisLayer), toComp = thisLayer.toComp.bind(thisLayer), mask = thisLayer.mask ? thisLayer.mask.bind(thisLayer) : null, fromCompToSurface = fromComp), transform || (transform = elem.layerInterface("ADBE Transform Group"), $bm_transform = transform, transform && (anchorPoint = transform.anchorPoint)), 4 !== elemType || content || (content = thisLayer("ADBE Root Vectors Group")), effect || (effect = thisLayer(4)), (hasParent = !(!elem.hierarchy || !elem.hierarchy.length)) && !parent && (parent = elem.hierarchy[0].layerInterface), time = this.comp.renderedFrame / this.comp.globalData.frameRate, _needsRandom && seedRandom(randSeed + time), needsVelocity && (velocity = velocityAtTime(time)), expression_function(), this.frameExpressionId = elem.globalData.frameId, scoped_bm_rt = scoped_bm_rt.propType === propTypes.SHAPE ? scoped_bm_rt.v : scoped_bm_rt);
                }
                return executeExpression.__preventDeadCodeRemoval = [
                    $bm_transform,
                    anchorPoint,
                    time,
                    velocity,
                    inPoint,
                    outPoint,
                    width,
                    height,
                    name,
                    loop_in,
                    loop_out,
                    smooth,
                    toComp,
                    fromCompToSurface,
                    toWorld,
                    fromWorld,
                    mask,
                    position,
                    rotation,
                    scale,
                    thisComp,
                    numKeys,
                    active,
                    wiggle,
                    loopInDuration,
                    loopOutDuration,
                    comp,
                    lookAt,
                    easeOut,
                    easeIn,
                    ease,
                    nearestKey,
                    key,
                    text,
                    textIndex,
                    textTotal,
                    selectorValue,
                    framesToTime,
                    timeToFrames,
                    sourceRectAtTime,
                    substring,
                    substr,
                    posterizeTime,
                    index,
                    globalData
                ], executeExpression;
            }
            return ob.initiateExpression = initiateExpression, ob.__preventDeadCodeRemoval = [
                window,
                document,
                XMLHttpRequest,
                fetch,
                frames,
                $bm_neg,
                add,
                $bm_sum,
                $bm_sub,
                $bm_mul,
                $bm_div,
                $bm_mod,
                clamp,
                radians_to_degrees,
                degreesToRadians,
                degrees_to_radians,
                normalize,
                rgbToHsl,
                hslToRgb,
                linear,
                random,
                createPath
            ], ob;
        }(), expressionHelpers = {
            searchExpressions: function(t1, e1, r1) {
                e1.x && (r1.k = !0, r1.x = !0, r1.initiateExpression = ExpressionManager.initiateExpression, r1.effectsSequence.push(r1.initiateExpression(t1, e1, r1).bind(r1)));
            },
            getSpeedAtTime: function(t1) {
                var e1 = this.getValueAtTime(t1), r1 = this.getValueAtTime(t1 + -0.01), i1 = 0;
                if (e1.length) {
                    var a1;
                    for(a1 = 0; a1 < e1.length; a1 += 1)i1 += Math.pow(r1[a1] - e1[a1], 2);
                    i1 = 100 * Math.sqrt(i1);
                } else i1 = 0;
                return i1;
            },
            getVelocityAtTime: function(t1) {
                if (void 0 !== this.vel) return this.vel;
                var e1, r1, i1 = this.getValueAtTime(t1), a1 = this.getValueAtTime(t1 + -0.001);
                if (i1.length) for(e1 = createTypedArray("float32", i1.length), r1 = 0; r1 < i1.length; r1 += 1)e1[r1] = (a1[r1] - i1[r1]) / -0.001;
                else e1 = (a1 - i1) / -0.001;
                return e1;
            },
            getValueAtTime: function(t1) {
                return t1 *= this.elem.globalData.frameRate, (t1 -= this.offsetTime) !== this._cachingAtTime.lastFrame && (this._cachingAtTime.lastIndex = this._cachingAtTime.lastFrame < t1 ? this._cachingAtTime.lastIndex : 0, this._cachingAtTime.value = this.interpolateValue(t1, this._cachingAtTime), this._cachingAtTime.lastFrame = t1), this._cachingAtTime.value;
            },
            getStaticValueAtTime: function() {
                return this.pv;
            },
            setGroupProperty: function(t1) {
                this.propertyGroup = t1;
            }
        };
        function addPropertyDecorator() {
            function t1(t1, e1, r1) {
                if (!this.k || !this.keyframes) return this.pv;
                t1 = t1 ? t1.toLowerCase() : "";
                var i1, a1, s1, n1, o1, h1 = this.comp.renderedFrame, l1 = this.keyframes, p1 = l1[l1.length - 1].t;
                if (h1 <= p1) return this.pv;
                if (r1 ? a1 = p1 - (i1 = e1 ? Math.abs(p1 - this.elem.comp.globalData.frameRate * e1) : Math.max(0, p1 - this.elem.data.ip)) : ((!e1 || e1 > l1.length - 1) && (e1 = l1.length - 1), i1 = p1 - (a1 = l1[l1.length - 1 - e1].t)), "pingpong" === t1) {
                    if (Math.floor((h1 - a1) / i1) % 2 != 0) return this.getValueAtTime((i1 - (h1 - a1) % i1 + a1) / this.comp.globalData.frameRate, 0);
                } else {
                    if ("offset" === t1) {
                        var f1 = this.getValueAtTime(a1 / this.comp.globalData.frameRate, 0), c1 = this.getValueAtTime(p1 / this.comp.globalData.frameRate, 0), m1 = this.getValueAtTime(((h1 - a1) % i1 + a1) / this.comp.globalData.frameRate, 0), d1 = Math.floor((h1 - a1) / i1);
                        if (this.pv.length) {
                            for(n1 = (o1 = new Array(f1.length)).length, s1 = 0; s1 < n1; s1 += 1)o1[s1] = (c1[s1] - f1[s1]) * d1 + m1[s1];
                            return o1;
                        }
                        return (c1 - f1) * d1 + m1;
                    }
                    if ("continue" === t1) {
                        var u1 = this.getValueAtTime(p1 / this.comp.globalData.frameRate, 0), y1 = this.getValueAtTime((p1 - .001) / this.comp.globalData.frameRate, 0);
                        if (this.pv.length) {
                            for(n1 = (o1 = new Array(u1.length)).length, s1 = 0; s1 < n1; s1 += 1)o1[s1] = u1[s1] + (u1[s1] - y1[s1]) * ((h1 - p1) / this.comp.globalData.frameRate) / 5e-4;
                            return o1;
                        }
                        return u1 + (h1 - p1) / .001 * (u1 - y1);
                    }
                }
                return this.getValueAtTime(((h1 - a1) % i1 + a1) / this.comp.globalData.frameRate, 0);
            }
            function e1(t1, e1, r1) {
                if (!this.k) return this.pv;
                t1 = t1 ? t1.toLowerCase() : "";
                var i1, a1, s1, n1, o1, h1 = this.comp.renderedFrame, l1 = this.keyframes, p1 = l1[0].t;
                if (h1 >= p1) return this.pv;
                if (r1 ? a1 = p1 + (i1 = e1 ? Math.abs(this.elem.comp.globalData.frameRate * e1) : Math.max(0, this.elem.data.op - p1)) : ((!e1 || e1 > l1.length - 1) && (e1 = l1.length - 1), i1 = (a1 = l1[e1].t) - p1), "pingpong" === t1) {
                    if (Math.floor((p1 - h1) / i1) % 2 == 0) return this.getValueAtTime(((p1 - h1) % i1 + p1) / this.comp.globalData.frameRate, 0);
                } else {
                    if ("offset" === t1) {
                        var f1 = this.getValueAtTime(p1 / this.comp.globalData.frameRate, 0), c1 = this.getValueAtTime(a1 / this.comp.globalData.frameRate, 0), m1 = this.getValueAtTime((i1 - (p1 - h1) % i1 + p1) / this.comp.globalData.frameRate, 0), d1 = Math.floor((p1 - h1) / i1) + 1;
                        if (this.pv.length) {
                            for(n1 = (o1 = new Array(f1.length)).length, s1 = 0; s1 < n1; s1 += 1)o1[s1] = m1[s1] - (c1[s1] - f1[s1]) * d1;
                            return o1;
                        }
                        return m1 - (c1 - f1) * d1;
                    }
                    if ("continue" === t1) {
                        var u1 = this.getValueAtTime(p1 / this.comp.globalData.frameRate, 0), y1 = this.getValueAtTime((p1 + .001) / this.comp.globalData.frameRate, 0);
                        if (this.pv.length) {
                            for(n1 = (o1 = new Array(u1.length)).length, s1 = 0; s1 < n1; s1 += 1)o1[s1] = u1[s1] + (u1[s1] - y1[s1]) * (p1 - h1) / .001;
                            return o1;
                        }
                        return u1 + (u1 - y1) * (p1 - h1) / .001;
                    }
                }
                return this.getValueAtTime((i1 - ((p1 - h1) % i1 + p1)) / this.comp.globalData.frameRate, 0);
            }
            function r1(t1, e1) {
                if (!this.k) return this.pv;
                if (t1 = .5 * (t1 || .4), (e1 = Math.floor(e1 || 5)) <= 1) return this.pv;
                var r1, i1, a1 = this.comp.renderedFrame / this.comp.globalData.frameRate, s1 = a1 - t1, n1 = e1 > 1 ? (a1 + t1 - s1) / (e1 - 1) : 1, o1 = 0, h1 = 0;
                for(r1 = this.pv.length ? createTypedArray("float32", this.pv.length) : 0; o1 < e1;){
                    if (i1 = this.getValueAtTime(s1 + o1 * n1), this.pv.length) for(h1 = 0; h1 < this.pv.length; h1 += 1)r1[h1] += i1[h1];
                    else r1 += i1;
                    o1 += 1;
                }
                if (this.pv.length) for(h1 = 0; h1 < this.pv.length; h1 += 1)r1[h1] /= e1;
                else r1 /= e1;
                return r1;
            }
            function i1(t1) {
                this._transformCachingAtTime || (this._transformCachingAtTime = {
                    v: new Matrix
                });
                var e1 = this._transformCachingAtTime.v;
                if (e1.cloneFromProps(this.pre.props), this.appliedTransformations < 1) {
                    var r1 = this.a.getValueAtTime(t1);
                    e1.translate(-r1[0] * this.a.mult, -r1[1] * this.a.mult, r1[2] * this.a.mult);
                }
                if (this.appliedTransformations < 2) {
                    var i1 = this.s.getValueAtTime(t1);
                    e1.scale(i1[0] * this.s.mult, i1[1] * this.s.mult, i1[2] * this.s.mult);
                }
                if (this.sk && this.appliedTransformations < 3) {
                    var a1 = this.sk.getValueAtTime(t1), s1 = this.sa.getValueAtTime(t1);
                    e1.skewFromAxis(-a1 * this.sk.mult, s1 * this.sa.mult);
                }
                if (this.r && this.appliedTransformations < 4) {
                    var n1 = this.r.getValueAtTime(t1);
                    e1.rotate(-n1 * this.r.mult);
                } else if (!this.r && this.appliedTransformations < 4) {
                    var o1 = this.rz.getValueAtTime(t1), h1 = this.ry.getValueAtTime(t1), l1 = this.rx.getValueAtTime(t1), p1 = this.or.getValueAtTime(t1);
                    e1.rotateZ(-o1 * this.rz.mult).rotateY(h1 * this.ry.mult).rotateX(l1 * this.rx.mult).rotateZ(-p1[2] * this.or.mult).rotateY(p1[1] * this.or.mult).rotateX(p1[0] * this.or.mult);
                }
                if (this.data.p && this.data.p.s) {
                    var f1 = this.px.getValueAtTime(t1), c1 = this.py.getValueAtTime(t1);
                    if (this.data.p.z) {
                        var m1 = this.pz.getValueAtTime(t1);
                        e1.translate(f1 * this.px.mult, c1 * this.py.mult, -m1 * this.pz.mult);
                    } else e1.translate(f1 * this.px.mult, c1 * this.py.mult, 0);
                } else {
                    var d1 = this.p.getValueAtTime(t1);
                    e1.translate(d1[0] * this.p.mult, d1[1] * this.p.mult, -d1[2] * this.p.mult);
                }
                return e1;
            }
            function a1() {
                return this.v.clone(new Matrix);
            }
            var s1 = TransformPropertyFactory.getTransformProperty;
            TransformPropertyFactory.getTransformProperty = function(t1, e1, r1) {
                var n1 = s1(t1, e1, r1);
                return n1.dynamicProperties.length ? n1.getValueAtTime = i1.bind(n1) : n1.getValueAtTime = a1.bind(n1), n1.setGroupProperty = expressionHelpers.setGroupProperty, n1;
            };
            var n1 = PropertyFactory.getProp;
            PropertyFactory.getProp = function(i1, a1, s1, o1, h1) {
                var l1 = n1(i1, a1, s1, o1, h1);
                l1.kf ? l1.getValueAtTime = expressionHelpers.getValueAtTime.bind(l1) : l1.getValueAtTime = expressionHelpers.getStaticValueAtTime.bind(l1), l1.setGroupProperty = expressionHelpers.setGroupProperty, l1.loopOut = t1, l1.loopIn = e1, l1.smooth = r1, l1.getVelocityAtTime = expressionHelpers.getVelocityAtTime.bind(l1), l1.getSpeedAtTime = expressionHelpers.getSpeedAtTime.bind(l1), l1.numKeys = 1 === a1.a ? a1.k.length : 0, l1.propertyIndex = a1.ix;
                var p1 = 0;
                return 0 !== s1 && (p1 = createTypedArray("float32", 1 === a1.a ? a1.k[0].s.length : a1.k.length)), l1._cachingAtTime = {
                    lastFrame: initialDefaultFrame,
                    lastIndex: 0,
                    value: p1
                }, expressionHelpers.searchExpressions(i1, a1, l1), l1.k && h1.addDynamicProperty(l1), l1;
            };
            var o1 = ShapePropertyFactory.getConstructorFunction(), h1 = ShapePropertyFactory.getKeyframedConstructorFunction();
            function l1() {}
            l1.prototype = {
                vertices: function(t1, e1) {
                    this.k && this.getValue();
                    var r1, i1 = this.v;
                    void 0 !== e1 && (i1 = this.getValueAtTime(e1, 0));
                    var a1 = i1._length, s1 = i1[t1], n1 = i1.v, o1 = createSizedArray(a1);
                    for(r1 = 0; r1 < a1; r1 += 1)o1[r1] = "i" === t1 || "o" === t1 ? [
                        s1[r1][0] - n1[r1][0],
                        s1[r1][1] - n1[r1][1]
                    ] : [
                        s1[r1][0],
                        s1[r1][1]
                    ];
                    return o1;
                },
                points: function(t1) {
                    return this.vertices("v", t1);
                },
                inTangents: function(t1) {
                    return this.vertices("i", t1);
                },
                outTangents: function(t1) {
                    return this.vertices("o", t1);
                },
                isClosed: function() {
                    return this.v.c;
                },
                pointOnPath: function(t1, e1) {
                    var r1 = this.v;
                    void 0 !== e1 && (r1 = this.getValueAtTime(e1, 0)), this._segmentsLength || (this._segmentsLength = bez.getSegmentsLength(r1));
                    for(var i1, a1 = this._segmentsLength, s1 = a1.lengths, n1 = a1.totalLength * t1, o1 = 0, h1 = s1.length, l1 = 0; o1 < h1;){
                        if (l1 + s1[o1].addedLength > n1) {
                            var p1 = o1, f1 = r1.c && o1 === h1 - 1 ? 0 : o1 + 1, c1 = (n1 - l1) / s1[o1].addedLength;
                            i1 = bez.getPointInSegment(r1.v[p1], r1.v[f1], r1.o[p1], r1.i[f1], c1, s1[o1]);
                            break;
                        }
                        l1 += s1[o1].addedLength, o1 += 1;
                    }
                    return i1 || (i1 = r1.c ? [
                        r1.v[0][0],
                        r1.v[0][1]
                    ] : [
                        r1.v[r1._length - 1][0],
                        r1.v[r1._length - 1][1]
                    ]), i1;
                },
                vectorOnPath: function(t1, e1, r1) {
                    1 == t1 ? t1 = this.v.c : 0 == t1 && (t1 = .999);
                    var i1 = this.pointOnPath(t1, e1), a1 = this.pointOnPath(t1 + .001, e1), s1 = a1[0] - i1[0], n1 = a1[1] - i1[1], o1 = Math.sqrt(Math.pow(s1, 2) + Math.pow(n1, 2));
                    return 0 === o1 ? [
                        0,
                        0
                    ] : "tangent" === r1 ? [
                        s1 / o1,
                        n1 / o1
                    ] : [
                        -n1 / o1,
                        s1 / o1
                    ];
                },
                tangentOnPath: function(t1, e1) {
                    return this.vectorOnPath(t1, e1, "tangent");
                },
                normalOnPath: function(t1, e1) {
                    return this.vectorOnPath(t1, e1, "normal");
                },
                setGroupProperty: expressionHelpers.setGroupProperty,
                getValueAtTime: expressionHelpers.getStaticValueAtTime
            }, extendPrototype([
                l1
            ], o1), extendPrototype([
                l1
            ], h1), h1.prototype.getValueAtTime = function(t1) {
                return this._cachingAtTime || (this._cachingAtTime = {
                    shapeValue: shapePool.clone(this.pv),
                    lastIndex: 0,
                    lastTime: initialDefaultFrame
                }), t1 *= this.elem.globalData.frameRate, (t1 -= this.offsetTime) !== this._cachingAtTime.lastTime && (this._cachingAtTime.lastIndex = this._cachingAtTime.lastTime < t1 ? this._caching.lastIndex : 0, this._cachingAtTime.lastTime = t1, this.interpolateShape(t1, this._cachingAtTime.shapeValue, this._cachingAtTime)), this._cachingAtTime.shapeValue;
            }, h1.prototype.initiateExpression = ExpressionManager.initiateExpression;
            var p1 = ShapePropertyFactory.getShapeProp;
            ShapePropertyFactory.getShapeProp = function(t1, e1, r1, i1, a1) {
                var s1 = p1(t1, e1, r1, i1, a1);
                return s1.propertyIndex = e1.ix, s1.lock = !1, 3 === r1 ? expressionHelpers.searchExpressions(t1, e1.pt, s1) : 4 === r1 && expressionHelpers.searchExpressions(t1, e1.ks, s1), s1.k && t1.addDynamicProperty(s1), s1;
            };
        }
        function initialize$1() {
            addPropertyDecorator();
        }
        function addDecorator() {
            TextProperty.prototype.getExpressionValue = function(t1, e1) {
                var r1 = this.calculateExpression(e1);
                if (t1.t !== r1) {
                    var i1 = {};
                    return this.copyData(i1, t1), i1.t = r1.toString(), i1.__complete = !1, i1;
                }
                return t1;
            }, TextProperty.prototype.searchProperty = function() {
                var t1 = this.searchKeyframes(), e1 = this.searchExpressions();
                return this.kf = t1 || e1, this.kf;
            }, TextProperty.prototype.searchExpressions = function() {
                return this.data.d.x ? (this.calculateExpression = ExpressionManager.initiateExpression.bind(this)(this.elem, this.data.d, this), this.addEffect(this.getExpressionValue.bind(this)), !0) : null;
            };
        }
        function initialize() {
            addDecorator();
        }
        function SVGComposableEffect() {}
        SVGComposableEffect.prototype = {
            createMergeNode: function(t1, e1) {
                var r1, i1, a1 = createNS("feMerge");
                for(a1.setAttribute("result", t1), i1 = 0; i1 < e1.length; i1 += 1)(r1 = createNS("feMergeNode")).setAttribute("in", e1[i1]), a1.appendChild(r1), a1.appendChild(r1);
                return a1;
            }
        };
        var linearFilterValue = "0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0 0 0";
        function SVGTintFilter(t1, e1, r1, i1, a1) {
            this.filterManager = e1;
            var s1 = createNS("feColorMatrix");
            s1.setAttribute("type", "matrix"), s1.setAttribute("color-interpolation-filters", "linearRGB"), s1.setAttribute("values", linearFilterValue + " 1 0"), this.linearFilter = s1, s1.setAttribute("result", i1 + "_tint_1"), t1.appendChild(s1), (s1 = createNS("feColorMatrix")).setAttribute("type", "matrix"), s1.setAttribute("color-interpolation-filters", "sRGB"), s1.setAttribute("values", "1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0"), s1.setAttribute("result", i1 + "_tint_2"), t1.appendChild(s1), this.matrixFilter = s1;
            var n1 = this.createMergeNode(i1, [
                a1,
                i1 + "_tint_1",
                i1 + "_tint_2"
            ]);
            t1.appendChild(n1);
        }
        function SVGFillFilter(t1, e1, r1, i1) {
            this.filterManager = e1;
            var a1 = createNS("feColorMatrix");
            a1.setAttribute("type", "matrix"), a1.setAttribute("color-interpolation-filters", "sRGB"), a1.setAttribute("values", "1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0"), a1.setAttribute("result", i1), t1.appendChild(a1), this.matrixFilter = a1;
        }
        function SVGStrokeEffect(t1, e1, r1) {
            this.initialized = !1, this.filterManager = e1, this.elem = r1, this.paths = [];
        }
        function SVGTritoneFilter(t1, e1, r1, i1) {
            this.filterManager = e1;
            var a1 = createNS("feColorMatrix");
            a1.setAttribute("type", "matrix"), a1.setAttribute("color-interpolation-filters", "linearRGB"), a1.setAttribute("values", "0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0 0 0 1 0"), t1.appendChild(a1);
            var s1 = createNS("feComponentTransfer");
            s1.setAttribute("color-interpolation-filters", "sRGB"), s1.setAttribute("result", i1), this.matrixFilter = s1;
            var n1 = createNS("feFuncR");
            n1.setAttribute("type", "table"), s1.appendChild(n1), this.feFuncR = n1;
            var o1 = createNS("feFuncG");
            o1.setAttribute("type", "table"), s1.appendChild(o1), this.feFuncG = o1;
            var h1 = createNS("feFuncB");
            h1.setAttribute("type", "table"), s1.appendChild(h1), this.feFuncB = h1, t1.appendChild(s1);
        }
        function SVGProLevelsFilter(t1, e1, r1, i1) {
            this.filterManager = e1;
            var a1 = this.filterManager.effectElements, s1 = createNS("feComponentTransfer");
            (a1[10].p.k || 0 !== a1[10].p.v || a1[11].p.k || 1 !== a1[11].p.v || a1[12].p.k || 1 !== a1[12].p.v || a1[13].p.k || 0 !== a1[13].p.v || a1[14].p.k || 1 !== a1[14].p.v) && (this.feFuncR = this.createFeFunc("feFuncR", s1)), (a1[17].p.k || 0 !== a1[17].p.v || a1[18].p.k || 1 !== a1[18].p.v || a1[19].p.k || 1 !== a1[19].p.v || a1[20].p.k || 0 !== a1[20].p.v || a1[21].p.k || 1 !== a1[21].p.v) && (this.feFuncG = this.createFeFunc("feFuncG", s1)), (a1[24].p.k || 0 !== a1[24].p.v || a1[25].p.k || 1 !== a1[25].p.v || a1[26].p.k || 1 !== a1[26].p.v || a1[27].p.k || 0 !== a1[27].p.v || a1[28].p.k || 1 !== a1[28].p.v) && (this.feFuncB = this.createFeFunc("feFuncB", s1)), (a1[31].p.k || 0 !== a1[31].p.v || a1[32].p.k || 1 !== a1[32].p.v || a1[33].p.k || 1 !== a1[33].p.v || a1[34].p.k || 0 !== a1[34].p.v || a1[35].p.k || 1 !== a1[35].p.v) && (this.feFuncA = this.createFeFunc("feFuncA", s1)), (this.feFuncR || this.feFuncG || this.feFuncB || this.feFuncA) && (s1.setAttribute("color-interpolation-filters", "sRGB"), t1.appendChild(s1)), (a1[3].p.k || 0 !== a1[3].p.v || a1[4].p.k || 1 !== a1[4].p.v || a1[5].p.k || 1 !== a1[5].p.v || a1[6].p.k || 0 !== a1[6].p.v || a1[7].p.k || 1 !== a1[7].p.v) && ((s1 = createNS("feComponentTransfer")).setAttribute("color-interpolation-filters", "sRGB"), s1.setAttribute("result", i1), t1.appendChild(s1), this.feFuncRComposed = this.createFeFunc("feFuncR", s1), this.feFuncGComposed = this.createFeFunc("feFuncG", s1), this.feFuncBComposed = this.createFeFunc("feFuncB", s1));
        }
        function SVGDropShadowEffect(t1, e1, r1, i1, a1) {
            var s1 = e1.container.globalData.renderConfig.filterSize, n1 = e1.data.fs || s1;
            t1.setAttribute("x", n1.x || s1.x), t1.setAttribute("y", n1.y || s1.y), t1.setAttribute("width", n1.width || s1.width), t1.setAttribute("height", n1.height || s1.height), this.filterManager = e1;
            var o1 = createNS("feGaussianBlur");
            o1.setAttribute("in", "SourceAlpha"), o1.setAttribute("result", i1 + "_drop_shadow_1"), o1.setAttribute("stdDeviation", "0"), this.feGaussianBlur = o1, t1.appendChild(o1);
            var h1 = createNS("feOffset");
            h1.setAttribute("dx", "25"), h1.setAttribute("dy", "0"), h1.setAttribute("in", i1 + "_drop_shadow_1"), h1.setAttribute("result", i1 + "_drop_shadow_2"), this.feOffset = h1, t1.appendChild(h1);
            var l1 = createNS("feFlood");
            l1.setAttribute("flood-color", "#00ff00"), l1.setAttribute("flood-opacity", "1"), l1.setAttribute("result", i1 + "_drop_shadow_3"), this.feFlood = l1, t1.appendChild(l1);
            var p1 = createNS("feComposite");
            p1.setAttribute("in", i1 + "_drop_shadow_3"), p1.setAttribute("in2", i1 + "_drop_shadow_2"), p1.setAttribute("operator", "in"), p1.setAttribute("result", i1 + "_drop_shadow_4"), t1.appendChild(p1);
            var f1 = this.createMergeNode(i1, [
                i1 + "_drop_shadow_4",
                a1
            ]);
            t1.appendChild(f1);
        }
        extendPrototype([
            SVGComposableEffect
        ], SVGTintFilter), SVGTintFilter.prototype.renderFrame = function(t1) {
            if (t1 || this.filterManager._mdf) {
                var e1 = this.filterManager.effectElements[0].p.v, r1 = this.filterManager.effectElements[1].p.v, i1 = this.filterManager.effectElements[2].p.v / 100;
                this.linearFilter.setAttribute("values", linearFilterValue + " " + i1 + " 0"), this.matrixFilter.setAttribute("values", r1[0] - e1[0] + " 0 0 0 " + e1[0] + " " + (r1[1] - e1[1]) + " 0 0 0 " + e1[1] + " " + (r1[2] - e1[2]) + " 0 0 0 " + e1[2] + " 0 0 0 1 0");
            }
        }, SVGFillFilter.prototype.renderFrame = function(t1) {
            if (t1 || this.filterManager._mdf) {
                var e1 = this.filterManager.effectElements[2].p.v, r1 = this.filterManager.effectElements[6].p.v;
                this.matrixFilter.setAttribute("values", "0 0 0 0 " + e1[0] + " 0 0 0 0 " + e1[1] + " 0 0 0 0 " + e1[2] + " 0 0 0 " + r1 + " 0");
            }
        }, SVGStrokeEffect.prototype.initialize = function() {
            var t1, e1, r1, i1, a1 = this.elem.layerElement.children || this.elem.layerElement.childNodes;
            for(1 === this.filterManager.effectElements[1].p.v ? (i1 = this.elem.maskManager.masksProperties.length, r1 = 0) : i1 = (r1 = this.filterManager.effectElements[0].p.v - 1) + 1, (e1 = createNS("g")).setAttribute("fill", "none"), e1.setAttribute("stroke-linecap", "round"), e1.setAttribute("stroke-dashoffset", 1); r1 < i1; r1 += 1)t1 = createNS("path"), e1.appendChild(t1), this.paths.push({
                p: t1,
                m: r1
            });
            if (3 === this.filterManager.effectElements[10].p.v) {
                var s1 = createNS("mask"), n1 = createElementID();
                s1.setAttribute("id", n1), s1.setAttribute("mask-type", "alpha"), s1.appendChild(e1), this.elem.globalData.defs.appendChild(s1);
                var o1 = createNS("g");
                for(o1.setAttribute("mask", "url(" + getLocationHref() + "#" + n1 + ")"); a1[0];)o1.appendChild(a1[0]);
                this.elem.layerElement.appendChild(o1), this.masker = s1, e1.setAttribute("stroke", "#fff");
            } else if (1 === this.filterManager.effectElements[10].p.v || 2 === this.filterManager.effectElements[10].p.v) {
                if (2 === this.filterManager.effectElements[10].p.v) for(a1 = this.elem.layerElement.children || this.elem.layerElement.childNodes; a1.length;)this.elem.layerElement.removeChild(a1[0]);
                this.elem.layerElement.appendChild(e1), this.elem.layerElement.removeAttribute("mask"), e1.setAttribute("stroke", "#fff");
            }
            this.initialized = !0, this.pathMasker = e1;
        }, SVGStrokeEffect.prototype.renderFrame = function(t1) {
            var e1;
            this.initialized || this.initialize();
            var r1, i1, a1 = this.paths.length;
            for(e1 = 0; e1 < a1; e1 += 1)if (-1 !== this.paths[e1].m && (r1 = this.elem.maskManager.viewData[this.paths[e1].m], i1 = this.paths[e1].p, (t1 || this.filterManager._mdf || r1.prop._mdf) && i1.setAttribute("d", r1.lastPath), t1 || this.filterManager.effectElements[9].p._mdf || this.filterManager.effectElements[4].p._mdf || this.filterManager.effectElements[7].p._mdf || this.filterManager.effectElements[8].p._mdf || r1.prop._mdf)) {
                var s1;
                if (0 !== this.filterManager.effectElements[7].p.v || 100 !== this.filterManager.effectElements[8].p.v) {
                    var n1 = .01 * Math.min(this.filterManager.effectElements[7].p.v, this.filterManager.effectElements[8].p.v), o1 = .01 * Math.max(this.filterManager.effectElements[7].p.v, this.filterManager.effectElements[8].p.v), h1 = i1.getTotalLength();
                    s1 = "0 0 0 " + h1 * n1 + " ";
                    var l1, p1 = h1 * (o1 - n1), f1 = 1 + 2 * this.filterManager.effectElements[4].p.v * this.filterManager.effectElements[9].p.v * .01, c1 = Math.floor(p1 / f1);
                    for(l1 = 0; l1 < c1; l1 += 1)s1 += "1 " + 2 * this.filterManager.effectElements[4].p.v * this.filterManager.effectElements[9].p.v * .01 + " ";
                    s1 += "0 " + 10 * h1 + " 0 0";
                } else s1 = "1 " + 2 * this.filterManager.effectElements[4].p.v * this.filterManager.effectElements[9].p.v * .01;
                i1.setAttribute("stroke-dasharray", s1);
            }
            if ((t1 || this.filterManager.effectElements[4].p._mdf) && this.pathMasker.setAttribute("stroke-width", 2 * this.filterManager.effectElements[4].p.v), (t1 || this.filterManager.effectElements[6].p._mdf) && this.pathMasker.setAttribute("opacity", this.filterManager.effectElements[6].p.v), (1 === this.filterManager.effectElements[10].p.v || 2 === this.filterManager.effectElements[10].p.v) && (t1 || this.filterManager.effectElements[3].p._mdf)) {
                var m1 = this.filterManager.effectElements[3].p.v;
                this.pathMasker.setAttribute("stroke", "rgb(" + bmFloor(255 * m1[0]) + "," + bmFloor(255 * m1[1]) + "," + bmFloor(255 * m1[2]) + ")");
            }
        }, SVGTritoneFilter.prototype.renderFrame = function(t1) {
            if (t1 || this.filterManager._mdf) {
                var e1 = this.filterManager.effectElements[0].p.v, r1 = this.filterManager.effectElements[1].p.v, i1 = this.filterManager.effectElements[2].p.v, a1 = i1[0] + " " + r1[0] + " " + e1[0], s1 = i1[1] + " " + r1[1] + " " + e1[1], n1 = i1[2] + " " + r1[2] + " " + e1[2];
                this.feFuncR.setAttribute("tableValues", a1), this.feFuncG.setAttribute("tableValues", s1), this.feFuncB.setAttribute("tableValues", n1);
            }
        }, SVGProLevelsFilter.prototype.createFeFunc = function(t1, e1) {
            var r1 = createNS(t1);
            return r1.setAttribute("type", "table"), e1.appendChild(r1), r1;
        }, SVGProLevelsFilter.prototype.getTableValue = function(t1, e1, r1, i1, a1) {
            for(var s1, n1, o1 = 0, h1 = Math.min(t1, e1), l1 = Math.max(t1, e1), p1 = Array.call(null, {
                length: 256
            }), f1 = 0, c1 = a1 - i1, m1 = e1 - t1; o1 <= 256;)n1 = (s1 = o1 / 256) <= h1 ? m1 < 0 ? a1 : i1 : s1 >= l1 ? m1 < 0 ? i1 : a1 : i1 + c1 * Math.pow((s1 - t1) / m1, 1 / r1), p1[f1] = n1, f1 += 1, o1 += 256 / 255;
            return p1.join(" ");
        }, SVGProLevelsFilter.prototype.renderFrame = function(t1) {
            if (t1 || this.filterManager._mdf) {
                var e1, r1 = this.filterManager.effectElements;
                this.feFuncRComposed && (t1 || r1[3].p._mdf || r1[4].p._mdf || r1[5].p._mdf || r1[6].p._mdf || r1[7].p._mdf) && (e1 = this.getTableValue(r1[3].p.v, r1[4].p.v, r1[5].p.v, r1[6].p.v, r1[7].p.v), this.feFuncRComposed.setAttribute("tableValues", e1), this.feFuncGComposed.setAttribute("tableValues", e1), this.feFuncBComposed.setAttribute("tableValues", e1)), this.feFuncR && (t1 || r1[10].p._mdf || r1[11].p._mdf || r1[12].p._mdf || r1[13].p._mdf || r1[14].p._mdf) && (e1 = this.getTableValue(r1[10].p.v, r1[11].p.v, r1[12].p.v, r1[13].p.v, r1[14].p.v), this.feFuncR.setAttribute("tableValues", e1)), this.feFuncG && (t1 || r1[17].p._mdf || r1[18].p._mdf || r1[19].p._mdf || r1[20].p._mdf || r1[21].p._mdf) && (e1 = this.getTableValue(r1[17].p.v, r1[18].p.v, r1[19].p.v, r1[20].p.v, r1[21].p.v), this.feFuncG.setAttribute("tableValues", e1)), this.feFuncB && (t1 || r1[24].p._mdf || r1[25].p._mdf || r1[26].p._mdf || r1[27].p._mdf || r1[28].p._mdf) && (e1 = this.getTableValue(r1[24].p.v, r1[25].p.v, r1[26].p.v, r1[27].p.v, r1[28].p.v), this.feFuncB.setAttribute("tableValues", e1)), this.feFuncA && (t1 || r1[31].p._mdf || r1[32].p._mdf || r1[33].p._mdf || r1[34].p._mdf || r1[35].p._mdf) && (e1 = this.getTableValue(r1[31].p.v, r1[32].p.v, r1[33].p.v, r1[34].p.v, r1[35].p.v), this.feFuncA.setAttribute("tableValues", e1));
            }
        }, extendPrototype([
            SVGComposableEffect
        ], SVGDropShadowEffect), SVGDropShadowEffect.prototype.renderFrame = function(t1) {
            if (t1 || this.filterManager._mdf) {
                if ((t1 || this.filterManager.effectElements[4].p._mdf) && this.feGaussianBlur.setAttribute("stdDeviation", this.filterManager.effectElements[4].p.v / 4), t1 || this.filterManager.effectElements[0].p._mdf) {
                    var e1 = this.filterManager.effectElements[0].p.v;
                    this.feFlood.setAttribute("flood-color", rgbToHex(Math.round(255 * e1[0]), Math.round(255 * e1[1]), Math.round(255 * e1[2])));
                }
                if ((t1 || this.filterManager.effectElements[1].p._mdf) && this.feFlood.setAttribute("flood-opacity", this.filterManager.effectElements[1].p.v / 255), t1 || this.filterManager.effectElements[2].p._mdf || this.filterManager.effectElements[3].p._mdf) {
                    var r1 = this.filterManager.effectElements[3].p.v, i1 = (this.filterManager.effectElements[2].p.v - 90) * degToRads, a1 = r1 * Math.cos(i1), s1 = r1 * Math.sin(i1);
                    this.feOffset.setAttribute("dx", a1), this.feOffset.setAttribute("dy", s1);
                }
            }
        };
        var _svgMatteSymbols = [];
        function SVGMatte3Effect(t1, e1, r1) {
            this.initialized = !1, this.filterManager = e1, this.filterElem = t1, this.elem = r1, r1.matteElement = createNS("g"), r1.matteElement.appendChild(r1.layerElement), r1.matteElement.appendChild(r1.transformedElement), r1.baseElement = r1.matteElement;
        }
        function SVGGaussianBlurEffect(t1, e1, r1, i1) {
            t1.setAttribute("x", "-100%"), t1.setAttribute("y", "-100%"), t1.setAttribute("width", "300%"), t1.setAttribute("height", "300%"), this.filterManager = e1;
            var a1 = createNS("feGaussianBlur");
            a1.setAttribute("result", i1), t1.appendChild(a1), this.feGaussianBlur = a1;
        }
        return SVGMatte3Effect.prototype.findSymbol = function(t1) {
            for(var e1 = 0, r1 = _svgMatteSymbols.length; e1 < r1;){
                if (_svgMatteSymbols[e1] === t1) return _svgMatteSymbols[e1];
                e1 += 1;
            }
            return null;
        }, SVGMatte3Effect.prototype.replaceInParent = function(t1, e1) {
            var r1 = t1.layerElement.parentNode;
            if (r1) {
                for(var i1, a1 = r1.children, s1 = 0, n1 = a1.length; s1 < n1 && a1[s1] !== t1.layerElement;)s1 += 1;
                s1 <= n1 - 2 && (i1 = a1[s1 + 1]);
                var o1 = createNS("use");
                o1.setAttribute("href", "#" + e1), i1 ? r1.insertBefore(o1, i1) : r1.appendChild(o1);
            }
        }, SVGMatte3Effect.prototype.setElementAsMask = function(t1, e1) {
            if (!this.findSymbol(e1)) {
                var r1 = createElementID(), i1 = createNS("mask");
                i1.setAttribute("id", e1.layerId), i1.setAttribute("mask-type", "alpha"), _svgMatteSymbols.push(e1);
                var a1 = t1.globalData.defs;
                a1.appendChild(i1);
                var s1 = createNS("symbol");
                s1.setAttribute("id", r1), this.replaceInParent(e1, r1), s1.appendChild(e1.layerElement), a1.appendChild(s1);
                var n1 = createNS("use");
                n1.setAttribute("href", "#" + r1), i1.appendChild(n1), e1.data.hd = !1, e1.show();
            }
            t1.setMatte(e1.layerId);
        }, SVGMatte3Effect.prototype.initialize = function() {
            for(var t1 = this.filterManager.effectElements[0].p.v, e1 = this.elem.comp.elements, r1 = 0, i1 = e1.length; r1 < i1;)e1[r1] && e1[r1].data.ind === t1 && this.setElementAsMask(this.elem, e1[r1]), r1 += 1;
            this.initialized = !0;
        }, SVGMatte3Effect.prototype.renderFrame = function() {
            this.initialized || this.initialize();
        }, SVGGaussianBlurEffect.prototype.renderFrame = function(t1) {
            if (t1 || this.filterManager._mdf) {
                var e1 = .3 * this.filterManager.effectElements[0].p.v, r1 = this.filterManager.effectElements[1].p.v, i1 = 3 == r1 ? 0 : e1, a1 = 2 == r1 ? 0 : e1;
                this.feGaussianBlur.setAttribute("stdDeviation", i1 + " " + a1);
                var s1 = 1 == this.filterManager.effectElements[2].p.v ? "wrap" : "duplicate";
                this.feGaussianBlur.setAttribute("edgeMode", s1);
            }
        }, registerRenderer("canvas", CanvasRenderer), registerRenderer("html", HybridRenderer), registerRenderer("svg", SVGRenderer), ShapeModifiers.registerModifier("tm", TrimModifier), ShapeModifiers.registerModifier("pb", PuckerAndBloatModifier), ShapeModifiers.registerModifier("rp", RepeaterModifier), ShapeModifiers.registerModifier("rd", RoundCornersModifier), ShapeModifiers.registerModifier("zz", ZigZagModifier), ShapeModifiers.registerModifier("op", OffsetPathModifier), setExpressionsPlugin(Expressions), setExpressionInterfaces(getInterface), initialize$1(), initialize(), registerEffect(20, SVGTintFilter, !0), registerEffect(21, SVGFillFilter, !0), registerEffect(22, SVGStrokeEffect, !1), registerEffect(23, SVGTritoneFilter, !0), registerEffect(24, SVGProLevelsFilter, !0), registerEffect(25, SVGDropShadowEffect, !0), registerEffect(28, SVGMatte3Effect, !1), registerEffect(29, SVGGaussianBlurEffect, !0), lottie;
    });
}), REACT_LOTTIE_PLAYER_VERSION = "3.5.3", LOTTIE_WEB_VERSION = "^5.10.2", PlayerState, PlayerEvent;
function parseSrc(t1) {
    if ("object" == typeof t1) return t1;
    try {
        return JSON.parse(t1);
    } catch (t1) {}
    try {
        return new URL(t1).toString();
    } catch (t1) {}
    return t1;
}
!function(t1) {
    t1.Loading = "loading", t1.Playing = "playing", t1.Paused = "paused", t1.Stopped = "stopped", t1.Frozen = "frozen", t1.Error = "error";
}(PlayerState || (PlayerState = {})), function(t1) {
    t1.Load = "load", t1.InstanceSaved = "instanceSaved", t1.Error = "error", t1.Ready = "ready", t1.Play = "play", t1.Pause = "pause", t1.Stop = "stop", t1.Freeze = "freeze", t1.Loop = "loop", t1.Complete = "complete", t1.Frame = "frame";
}(PlayerEvent || (PlayerEvent = {}));
var defaultOptions = {
    clearCanvas: !1,
    hideOnTransparent: !0,
    progressiveLoad: !0
}, Player = function(t1) {
    function e1(e1) {
        var r1 = t1.call(this, e1) || this;
        return r1.container = null, r1.unmounted = !1, r1.handleBgChange = function(t1) {
            r1.setState({
                background: t1
            });
        }, r1.triggerDownload = function(t1, e1) {
            var r1 = document.createElement("a");
            r1.href = t1, r1.download = e1, document.body.appendChild(r1), r1.click(), document.body.removeChild(r1);
        }, r1.snapshot = function(t1) {
            var e1;
            void 0 === t1 && (t1 = !0);
            var i1 = r1.props.id ? r1.props.id : "lottie", a1 = document.getElementById(i1);
            if ("svg" === r1.props.renderer) {
                if (a1) {
                    var s1 = a1.querySelector("svg");
                    if (s1) {
                        var n1 = (new XMLSerializer).serializeToString(s1);
                        e1 = "data:image/svg+xml;charset=utf-8," + encodeURIComponent(n1);
                    }
                }
                t1 && r1.triggerDownload(e1, "snapshot.svg");
            } else if ("canvas" === r1.props.renderer) {
                if (a1) {
                    var o1 = a1.querySelector("canvas");
                    o1 && (e1 = o1.toDataURL("image/png"));
                }
                t1 && r1.triggerDownload(e1, "snapshot.png");
            }
            return e1;
        }, "undefined" != typeof window && (window.lottie = lottie), r1.state = {
            animationData: null,
            background: "transparent",
            containerRef: $eO7Kz.createRef(),
            debug: !0,
            instance: null,
            playerState: PlayerState.Loading,
            seeker: 0
        }, r1;
    }
    return __extends(e1, t1), e1.getDerivedStateFromProps = function(t1, e1) {
        return __awaiter(this, void 0, void 0, function() {
            return __generator(this, function(r1) {
                return t1.background !== e1.background ? [
                    2,
                    {
                        background: t1.background
                    }
                ] : [
                    2,
                    null
                ];
            });
        });
    }, e1.prototype.getVersions = function() {
        return {
            lottieWebVersion: LOTTIE_WEB_VERSION,
            lottiePlayerVersion: REACT_LOTTIE_PLAYER_VERSION
        };
    }, e1.prototype.componentDidMount = function() {
        return __awaiter(this, void 0, void 0, function() {
            return __generator(this, function(t1) {
                switch(t1.label){
                    case 0:
                        return this.unmounted ? [
                            3,
                            2
                        ] : [
                            4,
                            this.createLottie()
                        ];
                    case 1:
                        t1.sent(), t1.label = 2;
                    case 2:
                        return [
                            2
                        ];
                }
            });
        });
    }, e1.prototype.componentWillUnmount = function() {
        this.unmounted = !0, this.state.instance && this.state.instance.destroy();
    }, e1.prototype.componentDidUpdate = function(t1) {
        return __awaiter(this, void 0, void 0, function() {
            return __generator(this, function(e1) {
                switch(e1.label){
                    case 0:
                        return this.props.src === t1.src ? [
                            3,
                            2
                        ] : (this.state.instance && this.state.instance.destroy(), [
                            4,
                            this.createLottie()
                        ]);
                    case 1:
                        e1.sent(), e1.label = 2;
                    case 2:
                        return [
                            2
                        ];
                }
            });
        });
    }, e1.prototype.render = function() {
        var t1 = this, e1 = this.props, r1 = e1.children, i1 = e1.loop, a1 = e1.style, s1 = e1.onBackgroundChange, n1 = e1.className, o1 = this.state, h1 = o1.animationData, l1 = o1.instance, p1 = o1.playerState, f1 = o1.seeker, c1 = o1.debug, m1 = o1.background;
        return $eO7Kz.createElement("div", {
            className: "lf-player-container"
        }, this.state.playerState === PlayerState.Error ? $eO7Kz.createElement("div", {
            className: "lf-error"
        }, $eO7Kz.createElement("span", {
            "aria-label": "error-symbol",
            role: "img"
        }, "⚠️")) : $eO7Kz.createElement("div", {
            id: this.props.id ? this.props.id : "lottie",
            ref: function(e1) {
                return t1.container = e1;
            },
            style: __assign({
                background: m1,
                margin: "0 auto",
                outline: "none",
                overflow: "hidden"
            }, a1),
            className: n1
        }), $eO7Kz.Children.map(r1, function(e1) {
            return $eO7Kz.isValidElement(e1) ? $eO7Kz.cloneElement(e1, {
                animationData: h1,
                background: m1,
                debug: c1,
                instance: l1,
                loop: i1,
                pause: function() {
                    return t1.pause();
                },
                play: function() {
                    return t1.play();
                },
                playerState: p1,
                seeker: f1,
                setBackground: function(e1) {
                    t1.setState({
                        background: e1
                    }), "function" == typeof s1 && s1(e1);
                },
                setSeeker: function(e1, r1) {
                    return t1.setSeeker(e1, r1);
                },
                stop: function() {
                    return t1.stop();
                },
                toggleDebug: function() {
                    return t1.toggleDebug();
                },
                setLoop: function(e1) {
                    return t1.setLoop(e1);
                },
                colorChangedEvent: function(e1) {
                    t1.handleBgChange(e1);
                },
                snapshot: function() {
                    t1.snapshot();
                }
            }) : null;
        }));
    }, e1.prototype.toggleDebug = function() {
        this.setState({
            debug: !this.state.debug
        });
    }, e1.prototype.createLottie = function() {
        return __awaiter(this, void 0, void 0, function() {
            var t1, e1, r1, i1, a1, s1, n1, o1, h1, l1, p1, f1, c1, m1, d1 = this;
            return __generator(this, function(u1) {
                switch(u1.label){
                    case 0:
                        if (t1 = this.props, e1 = t1.autoplay, r1 = t1.direction, i1 = t1.loop, a1 = t1.lottieRef, s1 = t1.renderer, n1 = t1.speed, o1 = t1.src, h1 = t1.background, l1 = t1.rendererSettings, p1 = t1.hover, f1 = this.state.instance, !o1 || !this.container) return [
                            2
                        ];
                        u1.label = 1;
                    case 1:
                        return u1.trys.push([
                            1,
                            5,
                            ,
                            6
                        ]), "string" != typeof (c1 = parseSrc(o1)) ? [
                            3,
                            4
                        ] : [
                            4,
                            fetch(c1).catch(function() {
                                throw d1.setState({
                                    playerState: PlayerState.Error
                                }), d1.triggerEvent(PlayerEvent.Error), new Error("@LottieFiles/lottie-react: Animation data could not be fetched.");
                            })
                        ];
                    case 2:
                        return [
                            4,
                            u1.sent().json().catch(function() {
                                throw d1.setState({
                                    playerState: PlayerState.Error
                                }), d1.triggerEvent(PlayerEvent.Error), new Error("@LottieFiles/lottie-react: Animation data could not be fetched.");
                            })
                        ];
                    case 3:
                        c1 = u1.sent(), u1.label = 4;
                    case 4:
                        return f1 && f1.destroy(), m1 = lottie.loadAnimation({
                            rendererSettings: l1 || defaultOptions,
                            animationData: c1,
                            autoplay: e1 || !1,
                            container: this.container,
                            loop: i1 || !1,
                            renderer: s1
                        }), n1 && m1.setSpeed(n1), this.setState({
                            animationData: c1
                        }), this.setState({
                            instance: m1
                        }, function() {
                            d1.triggerEvent(PlayerEvent.InstanceSaved), "function" == typeof a1 && a1(m1), e1 && d1.play();
                        }), m1.addEventListener("enterFrame", function() {
                            d1.triggerEvent(PlayerEvent.Frame), d1.setState({
                                seeker: Math.floor(m1.currentFrame)
                            });
                        }), m1.addEventListener("DOMLoaded", function() {
                            d1.triggerEvent(PlayerEvent.Load);
                        }), m1.addEventListener("data_ready", function() {
                            d1.triggerEvent(PlayerEvent.Ready);
                        }), m1.addEventListener("data_failed", function() {
                            d1.setState({
                                playerState: PlayerState.Error
                            }), d1.triggerEvent(PlayerEvent.Error);
                        }), m1.addEventListener("loopComplete", function() {
                            d1.triggerEvent(PlayerEvent.Loop);
                        }), m1.addEventListener("complete", function() {
                            d1.triggerEvent(PlayerEvent.Complete), d1.setState({
                                playerState: PlayerState.Paused
                            }), d1.props.keepLastFrame && !d1.props.loop || d1.setSeeker(0);
                        }), this.container && (this.container.addEventListener("mouseenter", function() {
                            p1 && d1.state.playerState !== PlayerState.Playing && (d1.props.keepLastFrame && d1.stop(), d1.play());
                        }), this.container.addEventListener("mouseleave", function() {
                            p1 && d1.state.playerState === PlayerState.Playing && d1.stop();
                        })), n1 && this.setPlayerSpeed(n1), r1 && this.setPlayerDirection(r1), h1 && this.setState({
                            background: h1
                        }), [
                            3,
                            6
                        ];
                    case 5:
                        return u1.sent(), this.setState({
                            playerState: PlayerState.Error
                        }), this.triggerEvent(PlayerEvent.Error), [
                            3,
                            6
                        ];
                    case 6:
                        return [
                            2
                        ];
                }
            });
        });
    }, e1.prototype.play = function() {
        var t1 = this.state.instance;
        t1 && (this.triggerEvent(PlayerEvent.Play), t1.play(), this.setState({
            playerState: PlayerState.Playing
        }));
    }, e1.prototype.pause = function() {
        var t1 = this.state.instance;
        t1 && (this.triggerEvent(PlayerEvent.Pause), t1.pause(), this.setState({
            playerState: PlayerState.Paused
        }));
    }, e1.prototype.stop = function() {
        var t1 = this.state.instance;
        t1 && (this.triggerEvent(PlayerEvent.Stop), t1.stop(), this.setState({
            playerState: PlayerState.Stopped
        }));
    }, e1.prototype.setPlayerSpeed = function(t1) {
        var e1 = this.state.instance;
        e1 && e1.setSpeed(t1);
    }, e1.prototype.setPlayerDirection = function(t1) {
        var e1 = this.state.instance;
        e1 && e1.setDirection(t1);
    }, e1.prototype.setSeeker = function(t1, e1) {
        void 0 === e1 && (e1 = !1);
        var r1 = this.state, i1 = r1.instance, a1 = r1.playerState;
        i1 && (e1 && a1 === PlayerState.Playing ? i1.goToAndPlay(t1, !0) : (i1.goToAndStop(t1, !0), this.triggerEvent(PlayerEvent.Pause), this.setState({
            playerState: PlayerState.Paused
        })));
    }, e1.prototype.setLoop = function(t1) {
        var e1 = this.state.instance;
        e1 && (e1.loop = t1, this.setState({
            instance: e1
        }));
    }, e1.prototype.triggerEvent = function(t1) {
        var e1 = this.props.onEvent;
        e1 && e1(t1);
    }, e1.defaultProps = {
        loop: !1
    }, e1;
}($eO7Kz.Component);
function styleInject(t1, e1) {
    void 0 === e1 && (e1 = {});
    var r1 = e1.insertAt;
    if (t1 && "undefined" != typeof document) {
        var i1 = document.head || document.getElementsByTagName("head")[0], a1 = document.createElement("style");
        a1.type = "text/css", "top" === r1 && i1.firstChild ? i1.insertBefore(a1, i1.firstChild) : i1.appendChild(a1), a1.styleSheet ? a1.styleSheet.cssText = t1 : a1.appendChild(document.createTextNode(t1));
    }
}
var css_248z = ".lf-progress {\n  -webkit-appearance: none;\n  -moz-apperance: none;\n  width: 100%;\n  /* margin: 0 10px; */\n  height: 4px;\n  border-radius: 3px;\n  cursor: pointer;\n}\n.lf-progress:focus {\n  outline: none;\n  border: none;\n}\n.lf-progress::-moz-range-track {\n  cursor: pointer;\n  background: none;\n  border: none;\n  outline: none;\n}\n.lf-progress::-webkit-slider-thumb {\n  -webkit-appearance: none !important;\n  height: 13px;\n  width: 13px;\n  border: 0;\n  border-radius: 50%;\n  background: #0fccce;\n  cursor: pointer;\n}\n.lf-progress::-moz-range-thumb {\n  -moz-appearance: none !important;\n  height: 13px;\n  width: 13px;\n  border: 0;\n  border-radius: 50%;\n  background: #0fccce;\n  cursor: pointer;\n}\n.lf-progress::-ms-track {\n  width: 100%;\n  height: 3px;\n  cursor: pointer;\n  background: transparent;\n  border-color: transparent;\n  color: transparent;\n}\n.lf-progress::-ms-fill-lower {\n  background: #ccc;\n  border-radius: 3px;\n}\n.lf-progress::-ms-fill-upper {\n  background: #ccc;\n  border-radius: 3px;\n}\n.lf-progress::-ms-thumb {\n  border: 0;\n  height: 15px;\n  width: 15px;\n  border-radius: 50%;\n  background: #0fccce;\n  cursor: pointer;\n}\n.lf-progress:focus::-ms-fill-lower {\n  background: #ccc;\n}\n.lf-progress:focus::-ms-fill-upper {\n  background: #ccc;\n}\n.lf-player-container :focus {\n  outline: 0;\n}\n.lf-popover {\n  position: relative;\n}\n\n.lf-popover-content {\n  display: inline-block;\n  position: absolute;\n  opacity: 1;\n  visibility: visible;\n  transform: translate(0, -10px);\n  box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.26);\n  transition: all 0.3s cubic-bezier(0.75, -0.02, 0.2, 0.97);\n}\n\n.lf-popover-content.hidden {\n  opacity: 0;\n  visibility: hidden;\n  transform: translate(0, 0px);\n}\n\n.lf-player-btn-container {\n  display: flex;\n  align-items: center;\n}\n.lf-player-btn {\n  cursor: pointer;\n  fill: #999;\n  width: 14px;\n}\n\n.lf-player-btn.active {\n  fill: #555;\n}\n\n.lf-popover {\n  position: relative;\n}\n\n.lf-popover-content {\n  display: inline-block;\n  position: absolute;\n  background-color: #ffffff;\n  opacity: 1;\n\n  transform: translate(0, -10px);\n  box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.26);\n  transition: all 0.3s cubic-bezier(0.75, -0.02, 0.2, 0.97);\n  padding: 10px;\n}\n\n.lf-popover-content.hidden {\n  opacity: 0;\n  visibility: hidden;\n  transform: translate(0, 0px);\n}\n\n.lf-arrow {\n  position: absolute;\n  z-index: -1;\n  content: '';\n  bottom: -9px;\n  border-style: solid;\n  border-width: 10px 10px 0px 10px;\n}\n\n.lf-left-align,\n.lf-left-align .lfarrow {\n  left: 0;\n  right: unset;\n}\n\n.lf-right-align,\n.lf-right-align .lf-arrow {\n  right: 0;\n  left: unset;\n}\n\n.lf-text-input {\n  border: 1px #ccc solid;\n  border-radius: 5px;\n  padding: 3px;\n  width: 60px;\n  margin: 0;\n}\n\n.lf-color-picker {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  height: 90px;\n}\n\n.lf-color-selectors {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n}\n\n.lf-color-component {\n  display: flex;\n  flex-direction: row;\n  font-size: 12px;\n  align-items: center;\n  justify-content: center;\n}\n\n.lf-color-component strong {\n  width: 40px;\n}\n\n.lf-color-component input[type='range'] {\n  margin: 0 0 0 10px;\n}\n\n.lf-color-component input[type='number'] {\n  width: 50px;\n  margin: 0 0 0 10px;\n}\n\n.lf-color-preview {\n  font-size: 12px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: space-between;\n  padding-left: 5px;\n}\n\n.lf-preview {\n  height: 60px;\n  width: 60px;\n}\n\n.lf-popover-snapshot {\n  width: 150px;\n}\n.lf-popover-snapshot h5 {\n  margin: 5px 0 10px 0;\n  font-size: 0.75rem;\n}\n.lf-popover-snapshot a {\n  display: block;\n  text-decoration: none;\n}\n.lf-popover-snapshot a:before {\n  content: '⥼';\n  margin-right: 5px;\n}\n.lf-popover-snapshot .lf-note {\n  display: block;\n  margin-top: 10px;\n  color: #999;\n}\n.lf-player-controls > div {\n  margin-right: 5px;\n  margin-left: 5px;\n}\n.lf-player-controls > div:first-child {\n  margin-left: 0px;\n}\n.lf-player-controls > div:last-child {\n  margin-right: 0px;\n}\n", stylesheet = ".lf-progress {\n  -webkit-appearance: none;\n  -moz-apperance: none;\n  width: 100%;\n  /* margin: 0 10px; */\n  height: 4px;\n  border-radius: 3px;\n  cursor: pointer;\n}\n.lf-progress:focus {\n  outline: none;\n  border: none;\n}\n.lf-progress::-moz-range-track {\n  cursor: pointer;\n  background: none;\n  border: none;\n  outline: none;\n}\n.lf-progress::-webkit-slider-thumb {\n  -webkit-appearance: none !important;\n  height: 13px;\n  width: 13px;\n  border: 0;\n  border-radius: 50%;\n  background: #0fccce;\n  cursor: pointer;\n}\n.lf-progress::-moz-range-thumb {\n  -moz-appearance: none !important;\n  height: 13px;\n  width: 13px;\n  border: 0;\n  border-radius: 50%;\n  background: #0fccce;\n  cursor: pointer;\n}\n.lf-progress::-ms-track {\n  width: 100%;\n  height: 3px;\n  cursor: pointer;\n  background: transparent;\n  border-color: transparent;\n  color: transparent;\n}\n.lf-progress::-ms-fill-lower {\n  background: #ccc;\n  border-radius: 3px;\n}\n.lf-progress::-ms-fill-upper {\n  background: #ccc;\n  border-radius: 3px;\n}\n.lf-progress::-ms-thumb {\n  border: 0;\n  height: 15px;\n  width: 15px;\n  border-radius: 50%;\n  background: #0fccce;\n  cursor: pointer;\n}\n.lf-progress:focus::-ms-fill-lower {\n  background: #ccc;\n}\n.lf-progress:focus::-ms-fill-upper {\n  background: #ccc;\n}\n.lf-player-container :focus {\n  outline: 0;\n}\n.lf-popover {\n  position: relative;\n}\n\n.lf-popover-content {\n  display: inline-block;\n  position: absolute;\n  opacity: 1;\n  visibility: visible;\n  transform: translate(0, -10px);\n  box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.26);\n  transition: all 0.3s cubic-bezier(0.75, -0.02, 0.2, 0.97);\n}\n\n.lf-popover-content.hidden {\n  opacity: 0;\n  visibility: hidden;\n  transform: translate(0, 0px);\n}\n\n.lf-player-btn-container {\n  display: flex;\n  align-items: center;\n}\n.lf-player-btn {\n  cursor: pointer;\n  fill: #999;\n  width: 14px;\n}\n\n.lf-player-btn.active {\n  fill: #555;\n}\n\n.lf-popover {\n  position: relative;\n}\n\n.lf-popover-content {\n  display: inline-block;\n  position: absolute;\n  background-color: #ffffff;\n  opacity: 1;\n\n  transform: translate(0, -10px);\n  box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.26);\n  transition: all 0.3s cubic-bezier(0.75, -0.02, 0.2, 0.97);\n  padding: 10px;\n}\n\n.lf-popover-content.hidden {\n  opacity: 0;\n  visibility: hidden;\n  transform: translate(0, 0px);\n}\n\n.lf-arrow {\n  position: absolute;\n  z-index: -1;\n  content: '';\n  bottom: -9px;\n  border-style: solid;\n  border-width: 10px 10px 0px 10px;\n}\n\n.lf-left-align,\n.lf-left-align .lfarrow {\n  left: 0;\n  right: unset;\n}\n\n.lf-right-align,\n.lf-right-align .lf-arrow {\n  right: 0;\n  left: unset;\n}\n\n.lf-text-input {\n  border: 1px #ccc solid;\n  border-radius: 5px;\n  padding: 3px;\n  width: 60px;\n  margin: 0;\n}\n\n.lf-color-picker {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  height: 90px;\n}\n\n.lf-color-selectors {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n}\n\n.lf-color-component {\n  display: flex;\n  flex-direction: row;\n  font-size: 12px;\n  align-items: center;\n  justify-content: center;\n}\n\n.lf-color-component strong {\n  width: 40px;\n}\n\n.lf-color-component input[type='range'] {\n  margin: 0 0 0 10px;\n}\n\n.lf-color-component input[type='number'] {\n  width: 50px;\n  margin: 0 0 0 10px;\n}\n\n.lf-color-preview {\n  font-size: 12px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: space-between;\n  padding-left: 5px;\n}\n\n.lf-preview {\n  height: 60px;\n  width: 60px;\n}\n\n.lf-popover-snapshot {\n  width: 150px;\n}\n.lf-popover-snapshot h5 {\n  margin: 5px 0 10px 0;\n  font-size: 0.75rem;\n}\n.lf-popover-snapshot a {\n  display: block;\n  text-decoration: none;\n}\n.lf-popover-snapshot a:before {\n  content: '⥼';\n  margin-right: 5px;\n}\n.lf-popover-snapshot .lf-note {\n  display: block;\n  margin-top: 10px;\n  color: #999;\n}\n.lf-player-controls > div {\n  margin-right: 5px;\n  margin-left: 5px;\n}\n.lf-player-controls > div:first-child {\n  margin-left: 0px;\n}\n.lf-player-controls > div:last-child {\n  margin-right: 0px;\n}\n";
styleInject(css_248z);
var ColorPicker = function(t1) {
    function e1() {
        var e1 = null !== t1 && t1.apply(this, arguments) || this;
        return e1.state = {
            red: 0,
            green: 0,
            blue: 0,
            rgba: null,
            hex: "#000000",
            colorComponents: []
        }, e1.handleChange = function(t1, r1) {
            if ("r" === t1) {
                var i1 = "#" + (256 | r1).toString(16).slice(1) + (256 | e1.state.green).toString(16).slice(1) + (256 | e1.state.blue).toString(16).slice(1);
                e1.setState({
                    hex: i1
                });
            } else if ("g" === t1) {
                i1 = "#" + (256 | e1.state.red).toString(16).slice(1) + (256 | r1).toString(16).slice(1) + (256 | e1.state.blue).toString(16).slice(1);
                e1.setState({
                    hex: i1
                });
            } else if ("b" === t1) {
                i1 = "#" + (256 | e1.state.red).toString(16).slice(1) + (256 | e1.state.green).toString(16).slice(1) + (256 | r1).toString(16).slice(1);
                e1.setState({
                    hex: i1
                });
            }
        }, e1.parseColor = function(t1) {
            var r1;
            if ("string" == typeof t1) {
                if ("#" === t1[0]) {
                    var i1 = 4 === t1.length ? [
                        t1.slice(1, 2),
                        t1.slice(2, 3),
                        t1.slice(3, 4)
                    ].map(function(t1) {
                        return parseInt("" + t1 + t1, 16);
                    }) : [
                        t1.slice(1, 3),
                        t1.slice(3, 5),
                        t1.slice(5, 7)
                    ].map(function(t1) {
                        return parseInt(t1, 16);
                    });
                    e1.setState({
                        colorComponents: i1
                    });
                } else if (t1.startsWith("rgb")) void 0 !== (i1 = null === (r1 = t1.match(/\d+/g)) || void 0 === r1 ? void 0 : r1.map(function(t1) {
                    return parseInt(t1);
                })) && e1.setState({
                    colorComponents: i1
                });
                e1.state.colorComponents.length && (e1.setState({
                    red: e1.state.colorComponents[0]
                }), e1.setState({
                    green: e1.state.colorComponents[1]
                }), e1.setState({
                    blue: e1.state.colorComponents[2]
                }));
            }
        }, e1;
    }
    return __extends(e1, t1), e1.prototype.componentDidUpdate = function(t1, e1) {
        return this.props.colorChangedEvent && this.state.hex !== e1.hex && this.props.colorChangedEvent(this.state.hex), !0;
    }, e1.prototype.render = function() {
        var t1 = this;
        return $eO7Kz.createElement("div", {
            className: "lf-color-picker"
        }, $eO7Kz.createElement("div", {
            className: "lf-color-selectors"
        }, $eO7Kz.createElement("div", {
            className: "lf-color-component"
        }, $eO7Kz.createElement("strong", null, "Red"), $eO7Kz.createElement("input", {
            type: "range",
            min: "0",
            max: "255",
            value: this.state.red,
            onChange: function(e1) {
                t1.setState({
                    red: e1.target.value
                }), t1.handleChange("r", e1.target.value);
            }
        }), $eO7Kz.createElement("input", {
            className: "lf-text-input",
            type: "number",
            min: "0",
            max: "255",
            value: this.state.red,
            onChange: function(e1) {
                t1.setState({
                    red: e1.target.value
                }), t1.handleChange("r", e1.target.value);
            }
        })), $eO7Kz.createElement("div", {
            className: "lf-color-component"
        }, $eO7Kz.createElement("strong", null, "Green"), $eO7Kz.createElement("input", {
            type: "range",
            min: "0",
            max: "255",
            value: this.state.green,
            onChange: function(e1) {
                t1.setState({
                    green: e1.target.value
                }), t1.handleChange("g", e1.target.value);
            }
        }), $eO7Kz.createElement("input", {
            className: "lf-text-input",
            type: "number",
            min: "0",
            max: "255",
            value: this.state.green,
            onChange: function(e1) {
                t1.setState({
                    green: e1.target.value
                }), t1.handleChange("g", e1.target.value);
            }
        })), $eO7Kz.createElement("div", {
            className: "lf-color-component"
        }, $eO7Kz.createElement("strong", null, "Blue"), $eO7Kz.createElement("input", {
            type: "range",
            min: "0",
            max: "255",
            value: this.state.blue,
            onChange: function(e1) {
                t1.setState({
                    blue: e1.target.value
                }), t1.handleChange("b", e1.target.value);
            }
        }), $eO7Kz.createElement("input", {
            className: "lf-text-input",
            type: "number",
            min: "0",
            max: "255",
            value: this.state.blue,
            onChange: function(e1) {
                t1.setState({
                    blue: e1.target.value
                }), t1.handleChange("b", e1.target.value);
            }
        }))), $eO7Kz.createElement("div", {
            className: "lf-color-preview"
        }, $eO7Kz.createElement("div", {
            className: "lf-preview",
            style: {
                background: "rgb(" + this.state.red + ", " + this.state.green + ", " + this.state.blue + ")"
            }
        }), $eO7Kz.createElement("div", null, $eO7Kz.createElement("input", {
            className: "lf-text-input",
            type: "text",
            value: this.state.hex,
            onChange: function(e1) {
                t1.setState({
                    hex: e1.target.value
                }), t1.parseColor(e1.target.value);
            }
        }))));
    }, e1;
}($eO7Kz.Component), Popover = function(t1) {
    var e1 = t1.children, r1 = t1.icon, i1 = (0, $eO7Kz.useState)(null), a1 = i1[0], s1 = i1[1], n1 = (0, $eO7Kz.useState)(null), o1 = n1[0], h1 = n1[1], l1 = (0, $eO7Kz.useState)(null), p1 = l1[0], f1 = l1[1], c1 = (0, $eO7Kz.useState)(!1), m1 = c1[0], d1 = c1[1];
    (0, $eO7Kz.useEffect)(function() {
        if (a1 && o1) {
            var t1 = a1.getBoundingClientRect(), e1 = o1.getBoundingClientRect(), r1 = t1.left + e1.width > window.innerWidth ? -1 : 0;
            f1(r1);
        }
    }, [
        p1,
        o1,
        a1
    ]);
    return $eO7Kz.createElement("div", {
        className: "lf-popover",
        onMouseOver: function() {
            d1(!0);
        },
        onMouseLeave: function() {
            d1(!1);
        },
        ref: function(t1) {
            s1(t1);
        }
    }, $eO7Kz.createElement("div", {
        className: " lf-player-btn"
    }, r1), $eO7Kz.createElement("div", {
        className: "lf-popover-content",
        ref: function(t1) {
            h1(t1);
        },
        style: {
            bottom: "22px",
            right: "0px",
            zIndex: 2,
            visibility: m1 ? "visible" : "hidden"
        }
    }, e1));
}, Seeker = function(t1) {
    function e1(e1) {
        var r1 = t1.call(this, e1) || this;
        return r1.inputRef = $eO7Kz.createRef(), r1.handleChange = function() {
            return function(t1) {
                var e1 = t1.target.value, i1 = Math.floor(e1 / 100 * r1.props.max);
                r1.props.onChange(i1);
            };
        }, r1.state = {
            value: 0
        }, r1;
    }
    return __extends(e1, t1), e1.prototype.render = function() {
        var t1 = this.props.value / this.props.max * 100, e1 = {
            backgroundImage: "-webkit-gradient(linear, left top, right top, color-stop(" + t1 + "%, rgba(15, 204, 206, 0.4)), color-stop(" + t1 + "%, #DAE1E7))"
        }, r1 = {
            position: "absolute",
            left: 0,
            marginTop: "8px",
            width: "20px",
            display: "block",
            border: "0px",
            backgroundColor: this.props.darkTheme ? "#505050" : "rgb(218, 225, 231)",
            color: this.props.darkTheme ? "#B9B9B9" : "#555",
            padding: "2px",
            textAlign: "center",
            borderRadius: "3px",
            fontSize: "8px",
            fontWeight: "bold"
        }, i1 = {
            position: "absolute",
            right: 0,
            marginTop: "8px",
            width: "20px",
            display: "block",
            border: "0px",
            backgroundColor: this.props.darkTheme ? "#505050" : "rgb(218, 225, 231)",
            color: this.props.darkTheme ? "#B9B9B9" : "#555",
            padding: "2px",
            textAlign: "center",
            borderRadius: "3px",
            fontSize: "8px",
            fontWeight: "bold"
        };
        return $eO7Kz.createElement("div", {
            style: {
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                width: "100%",
                marginRight: "5px",
                marginLeft: "5px",
                position: "relative"
            }
        }, $eO7Kz.createElement("input", {
            ref: this.inputRef,
            id: "track",
            className: "lf-progress",
            name: "progress",
            "aria-label": "progress",
            type: "range",
            min: "0",
            max: "100",
            step: "0.1",
            value: t1,
            onInput: this.handleChange(),
            onChange: this.handleChange(),
            style: e1
        }), this.props.showLabels && $eO7Kz.createElement("div", {
            style: {
                display: "flex",
                justifyContent: "space-between"
            }
        }, $eO7Kz.createElement("div", {
            style: r1
        }, this.props.min), $eO7Kz.createElement("div", {
            style: i1
        }, this.props.max)));
    }, e1;
}($eO7Kz.Component), ControlButtonStyle = {
    display: "inline-flex",
    cursor: "pointer"
}, Controls = function(t1) {
    function e1(e1) {
        var r1 = t1.call(this, e1) || this;
        return r1.state = {
            activeFrame: 0,
            mouseDown: !1
        }, r1;
    }
    return __extends(e1, t1), e1.prototype.render = function() {
        var t1 = this, e1 = this.props, r1 = e1.instance, i1 = e1.playerState, a1 = e1.seeker, s1 = e1.setLoop, n1 = e1.setSeeker, o1 = e1.play, h1 = e1.pause, l1 = e1.stop, p1 = e1.visible, f1 = e1.buttons;
        if (!r1) return null;
        if (!p1) return null;
        var c1 = !f1 || f1.includes("play"), m1 = !f1 || f1.includes("stop"), d1 = !f1 || f1.includes("repeat"), u1 = !f1 || f1.includes("frame"), y1 = !f1 || f1.includes("background"), g1 = !f1 || f1.includes("snapshot"), v1 = {
            width: 14,
            height: 14,
            viewBox: "0 0 24 24"
        }, b1 = Math.round(r1.currentFrame);
        return $eO7Kz.createElement("div", {
            className: "lf-player-controls",
            style: {
                display: "flex",
                justifyContent: "space-between",
                height: "60px",
                alignItems: "center",
                backgroundColor: this.props.transparentTheme ? "transparent" : this.props.darkTheme ? "#3C3C3C" : "#ffffff",
                paddingLeft: "10px",
                paddingRight: "10px"
            }
        }, c1 && $eO7Kz.createElement("div", {
            role: "button",
            "aria-label": i1 === PlayerState.Playing ? PlayerEvent.Pause : PlayerEvent.Play,
            tabIndex: 0,
            onClick: function() {
                i1 === PlayerState.Playing ? "function" == typeof h1 && h1() : "function" == typeof o1 && o1();
            },
            onKeyDown: function() {
                i1 === PlayerState.Playing ? "function" == typeof h1 && h1() : "function" == typeof o1 && o1();
            },
            className: "lf-player-btn",
            style: ControlButtonStyle
        }, i1 === PlayerState.Playing ? $eO7Kz.createElement("svg", __assign({}, v1), $eO7Kz.createElement("rect", {
            height: "22.9",
            rx: "1.9",
            width: "7.6",
            x: "14",
            y: ".5"
        }), $eO7Kz.createElement("rect", {
            height: "22.9",
            rx: "1.9",
            width: "7.6",
            x: "2",
            y: ".5"
        })) : $eO7Kz.createElement("svg", __assign({}, v1), $eO7Kz.createElement("path", {
            d: "M2 3.4C2 1.9 3.5 1 4.8 1.8l16.5 9.6c1.2.7 1.2 2.5 0 3.2L4.8 24.2C3.5 25 2 24.1 2 22.6V3.4z"
        }))), m1 && $eO7Kz.createElement("div", {
            tabIndex: 0,
            role: "button",
            "aria-label": PlayerEvent.Stop,
            onClick: function() {
                return l1 && l1();
            },
            onKeyDown: function() {
                return l1 && l1();
            },
            className: i1 === PlayerState.Stopped ? "lf-player-btn active" : "lf-player-btn",
            style: ControlButtonStyle
        }, $eO7Kz.createElement("svg", __assign({}, v1), $eO7Kz.createElement("path", {
            d: "M2 3.667A1.67 1.67 0 0 1 3.667 2h16.666A1.67 1.67 0 0 1 22 3.667v16.666A1.67 1.67 0 0 1 20.333\n            22H3.667A1.67 1.67 0 0 1 2 20.333z"
        }))), $eO7Kz.createElement(Seeker, {
            min: 0,
            step: 1,
            max: r1 ? r1.totalFrames : 1,
            value: a1 || 0,
            onChange: function(e1) {
                n1 && t1.setState({
                    activeFrame: e1
                }, function() {
                    n1(e1, !1);
                });
            },
            onChangeEnd: function(e1) {
                n1 && t1.setState({
                    activeFrame: e1
                }, function() {
                    n1(e1, !1);
                });
            },
            showLabels: this.props.showLabels,
            darkTheme: this.props.darkTheme
        }), u1 && $eO7Kz.createElement("div", {
            role: "button",
            className: "lf-player-btn-container"
        }, $eO7Kz.createElement("input", {
            style: {
                outline: "none",
                border: this.props.darkTheme ? "1px #505050 solid" : "1px #ccc solid",
                borderRadius: "3px",
                width: "40px",
                textAlign: "center",
                backgroundColor: this.props.darkTheme ? "#505050" : "#ffffff",
                color: this.props.darkTheme ? "#B9B9B9" : "#999",
                fontSize: "0.7rem",
                padding: "0",
                fontFamily: "inherit"
            },
            type: "text",
            value: b1,
            readOnly: !0
        })), d1 && $eO7Kz.createElement("div", {
            role: "button",
            "aria-label": PlayerEvent.Loop,
            tabIndex: 0,
            onClick: function() {
                r1 && s1 && s1(!r1.loop);
            },
            onKeyDown: function() {
                r1 && s1 && s1(!r1.loop);
            },
            className: r1.loop ? "lf-player-btn active" : "lf-player-btn",
            style: ControlButtonStyle
        }, $eO7Kz.createElement("svg", __assign({}, v1), $eO7Kz.createElement("path", {
            d: "M12.5 16.8137h-.13v1.8939h4.9696c3.6455 0 6.6113-2.9658 6.6113-6.6116\n            0-3.64549-2.9658-6.61131-6.6113-6.61131-.5231 0-.947.42391-.947.94696 0 .52304.4239.94696.947.94696 2.6011 0\n            4.7174 2.11634 4.7174 4.71739 0 2.6014-2.1166 4.7177-4.7174 4.7177H12.5zM13.6025\n            5.61469v-.13H7.48137C3.83582 5.48469.87 8.45051.87 12.096c0 3.6509 3.17269 6.6117 6.81304 6.6117.52304 0\n            .94696-.424.94696-.947 0-.5231-.42392-.947-.94696-.947-2.60804 0-4.91907-2.1231-4.91907-4.7176 0-2.60115\n            2.11634-4.71744 4.7174-4.71744h6.12113V5.61469z",
            stroke: "#8795A1",
            strokeWidth: ".26"
        }), $eO7Kz.createElement("path", {
            d: "M11.1482\n            2.20355h0l-.001-.00116c-.3412-.40061-.9405-.44558-1.33668-.0996h-.00001c-.39526.34519-.43936.94795-.09898\n            1.34767l2.51487 3.03683-2.51894 3.06468c-.33872.40088-.29282 1.00363.10347\n            1.34723l.08517-.0982-.08517.0982c.17853.1549.39807.2308.61647.2308.2671 0 .5328-.114.72-.3347h0l.0011-.0014\n            3.0435-3.68655.0006-.00068c.3035-.35872.3025-.88754-.0019-1.24526l-3.0425-3.65786zM13.9453\n            21.7965h0l.001.0011c.3413.4006.9407.4456 1.337.0996h0c.3953-.3452.4395-.9479.099-1.3477l-2.5154-3.0368\n            2.5195-3.0647c.3388-.4008.2929-1.0036-.1035-1.3472l-.0852.0982.0852-.0982c-.1786-.1549-.3981-.2308-.6166-.2308-.2671\n            0-.5329.114-.7202.3347h0l-.0011.0014-3.0442\n            3.6865c-.0001.0003-.0003.0005-.0005.0007-.3036.3587-.3027.8876.0019 1.2453l3.0431 3.6579z",
            fill: "#8795A1",
            stroke: "#8795A1",
            strokeWidth: ".26"
        }))), y1 && $eO7Kz.createElement(Popover, {
            icon: $eO7Kz.createElement("svg", __assign({}, v1), $eO7Kz.createElement("path", {
                d: "M12 3.1L6.1 8.6a7.6 7.6 0 00-2.2 4 7.2 7.2 0 00.4 4.4 7.9 7.9 0 003 3.5 8.7 8.7 0 004.7 1.3c1.6 0\n            3.2-.5 4.6-1.3s2.4-2 3-3.5a7.2 7.2 0 00.5-4.5 7.6 7.6 0 00-2.2-4L12 3.2zM12 0l7.5 7a9.8 9.8 0 013 5.1\n            9.3 9.3 0 01-.6 5.8c-.9 1.8-2.2 3.3-4 4.4A11.2 11.2 0 0112 24a11.2 11.2 0\n            01-6-1.7c-1.7-1-3-2.6-3.9-4.4a9.3 9.3 0 01-.6-5.8c.4-2 1.5-3.7 3-5L12 0zM6 14h12c0 1.5-.7 3-1.8 4s-2.6\n            1.6-4.2 1.6S9 19 7.8 18s-1.7-2.5-1.7-4z"
            }))
        }, $eO7Kz.createElement("div", {
            slot: "content",
            className: "lf-popover popover-background"
        }, $eO7Kz.createElement(ColorPicker, {
            colorChangedEvent: this.props.colorChangedEvent
        }))), g1 && $eO7Kz.createElement(Popover, {
            icon: $eO7Kz.createElement("svg", __assign({}, v1), $eO7Kz.createElement("path", {
                clipRule: "evenodd",
                d: "M0 3.01A2.983 2.983 0 012.983.027H16.99a2.983 2.983 0 012.983 2.983v14.008a2.982 2.982 0 01-2.983\n              2.983H2.983A2.983 2.983 0 010 17.018zm2.983-.941a.941.941 0 00-.942.94v14.01c0\n              .52.422.94.942.94H16.99a.94.94 0 00.941-.94V3.008a.941.941 0 00-.94-.94H2.981z",
                fillRule: "evenodd"
            }), $eO7Kz.createElement("path", {
                d: "M12.229 7.945l-2.07 4.598-2.586-2.605-2.414 2.758v2.146h9.656V11.93z"
            }), $eO7Kz.createElement("circle", {
                cx: "7.444",
                cy: "6.513",
                r: "2.032"
            }), $eO7Kz.createElement("path", {
                d: "M9.561 23.916h11.25a2.929 2.929 0 002.926-2.927V9.954a1.06 1.06 0 10-2.122 0v11.035a.805.805 0\n              01-.803.804H9.562a1.061 1.061 0 100 2.123z",
                stroke: "#8795a1",
                strokeWidth: ".215"
            }))
        }, $eO7Kz.createElement("div", {
            slot: "content",
            className: "lf-popover lf-popover-snapshot",
            onWheel: function(t1) {
                n1 && n1(b1 + (t1.deltaY > 0 ? -1 : 1), !1);
            }
        }, $eO7Kz.createElement("h5", null, "Frame ", b1), $eO7Kz.createElement("div", {
            style: {
                cursor: "pointer",
                color: "#0FCCCE"
            },
            onClick: this.props.snapshot
        }, "Download SVG"), $eO7Kz.createElement("div", {
            style: {
                cursor: "pointer",
                color: "#0FCCCE"
            },
            onClick: this.props.snapshot
        }, "Download PNG"), $eO7Kz.createElement("i", {
            className: "lf-note"
        }, "Scroll with mousewheel to find exact frame"))));
    }, e1;
}($eO7Kz.Component);

});

parcelRequire.register("0ITDg", function(module, exports) {
function $0022d3abc92a7cf2$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
module.exports = $0022d3abc92a7cf2$var$_defineProperty, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRequire.register("hj0W0", function(module, exports) {
"use strict";

var $cAvdA = parcelRequire("cAvdA");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "createSpeechRecognitionPonyfillFromRecognizer", {
    enumerable: true,
    get: function get() {
        return $c994ef9aa391b27d$var$_createSpeechRecognitionPonyfill.createSpeechRecognitionPonyfillFromRecognizer;
    }
});
module.exports.default = void 0;

var $c994ef9aa391b27d$var$_createSpeechRecognitionPonyfill = $c994ef9aa391b27d$var$_interopRequireWildcard((parcelRequire("4SH9i")));
function $c994ef9aa391b27d$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($c994ef9aa391b27d$var$_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $c994ef9aa391b27d$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || $cAvdA(obj) !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $c994ef9aa391b27d$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
var $c994ef9aa391b27d$var$_default = $c994ef9aa391b27d$var$_createSpeechRecognitionPonyfill.default;
module.exports.default = $c994ef9aa391b27d$var$_default;

});
parcelRequire.register("cAvdA", function(module, exports) {
function $92a1101f9ad3db39$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return module.exports = $92a1101f9ad3db39$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $92a1101f9ad3db39$var$_typeof(obj);
}
module.exports = $92a1101f9ad3db39$var$_typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRequire.register("4SH9i", function(module, exports) {
"use strict";

var $clWYw = parcelRequire("clWYw");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.createSpeechRecognitionPonyfillFromRecognizer = $38ddad0c42145681$var$createSpeechRecognitionPonyfillFromRecognizer;
module.exports.default = void 0;

var $38ddad0c42145681$var$_regenerator = $clWYw((parcelRequire("ilkkY")));

var $38ddad0c42145681$var$_toConsumableArray2 = $clWYw((parcelRequire("aUVii")));

var $38ddad0c42145681$var$_defineProperty2 = $clWYw((parcelRequire("0ITDg")));

var $38ddad0c42145681$var$_asyncToGenerator2 = $clWYw((parcelRequire("f4cyQ")));

var $38ddad0c42145681$var$_createClass2 = $clWYw((parcelRequire("kkabb")));

var $38ddad0c42145681$var$_classCallCheck2 = $clWYw((parcelRequire("kFs3a")));

var $38ddad0c42145681$var$_inherits2 = $clWYw((parcelRequire("edsvT")));

var $38ddad0c42145681$var$_possibleConstructorReturn2 = $clWYw((parcelRequire("lKMYv")));

var $38ddad0c42145681$var$_getPrototypeOf2 = $clWYw((parcelRequire("iXZmE")));

var $bgEWP = parcelRequire("bgEWP");

var $38ddad0c42145681$var$_cognitiveServiceEventResultToWebSpeechRecognitionResultList = $clWYw((parcelRequire("auhfT")));

var $38ddad0c42145681$var$_createPromiseQueue = $clWYw((parcelRequire("kBJXM")));

var $38ddad0c42145681$var$_patchOptions2 = $clWYw((parcelRequire("240sx")));

var $38ddad0c42145681$var$_SpeechGrammarList = $clWYw((parcelRequire("1BJRz")));

var $38ddad0c42145681$var$_SpeechSDK = $clWYw((parcelRequire("gLWFf")));
function $38ddad0c42145681$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $38ddad0c42145681$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $38ddad0c42145681$var$ownKeys(Object(source), !0).forEach(function(key) {
            (0, $38ddad0c42145681$var$_defineProperty2.default)(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $38ddad0c42145681$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $38ddad0c42145681$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $38ddad0c42145681$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, $38ddad0c42145681$var$_getPrototypeOf2.default)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $38ddad0c42145681$var$_getPrototypeOf2.default)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $38ddad0c42145681$var$_possibleConstructorReturn2.default)(this, result);
    };
}
function $38ddad0c42145681$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
// https://docs.microsoft.com/en-us/javascript/api/microsoft-cognitiveservices-speech-sdk/speechconfig?view=azure-node-latest#outputformat
// {
//   "RecognitionStatus": "Success",
//   "Offset": 900000,
//   "Duration": 49000000,
//   "NBest": [
//     {
//       "Confidence": 0.738919,
//       "Lexical": "second",
//       "ITN": "second",
//       "MaskedITN": "second",
//       "Display": "Second."
//     }
//   ]
// }
// {
//   "RecognitionStatus": "InitialSilenceTimeout",
//   "Offset": 50000000,
//   "Duration": 0
// }
var $38ddad0c42145681$var$AudioConfig = $38ddad0c42145681$var$_SpeechSDK.default.AudioConfig, $38ddad0c42145681$var$OutputFormat = $38ddad0c42145681$var$_SpeechSDK.default.OutputFormat, $38ddad0c42145681$var$ResultReason = $38ddad0c42145681$var$_SpeechSDK.default.ResultReason, $38ddad0c42145681$var$SpeechConfig = $38ddad0c42145681$var$_SpeechSDK.default.SpeechConfig, $38ddad0c42145681$var$SpeechRecognizer = $38ddad0c42145681$var$_SpeechSDK.default.SpeechRecognizer;
function $38ddad0c42145681$var$serializeRecognitionResult(_ref) {
    var duration = _ref.duration, errorDetails = _ref.errorDetails, json = _ref.json, offset = _ref.offset, properties = _ref.properties, reason = _ref.reason, resultId = _ref.resultId, text = _ref.text;
    return {
        duration: duration,
        errorDetails: errorDetails,
        json: JSON.parse(json),
        offset: offset,
        properties: properties,
        reason: reason,
        resultId: resultId,
        text: text
    };
}
function $38ddad0c42145681$var$averageAmplitude(arrayBuffer) {
    var array = new Int16Array(arrayBuffer);
    return [].reduce.call(array, function(averageAmplitude, amplitude) {
        return averageAmplitude + Math.abs(amplitude);
    }, 0) / array.length;
}
function $38ddad0c42145681$var$cognitiveServicesAsyncToPromise(fn) {
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return new Promise(function(resolve, reject) {
            return fn.apply(void 0, args.concat([
                resolve,
                reject
            ]));
        });
    };
}
var $38ddad0c42145681$var$SpeechRecognitionEvent = /*#__PURE__*/ function(_Event) {
    (0, $38ddad0c42145681$var$_inherits2.default)(SpeechRecognitionEvent, _Event);
    var _super = $38ddad0c42145681$var$_createSuper(SpeechRecognitionEvent);
    function SpeechRecognitionEvent(type) {
        var _this;
        var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {}, data = _ref2.data, emma = _ref2.emma, interpretation = _ref2.interpretation, resultIndex = _ref2.resultIndex, results = _ref2.results;
        (0, $38ddad0c42145681$var$_classCallCheck2.default)(this, SpeechRecognitionEvent);
        _this = _super.call(this, type);
        _this.data = data;
        _this.emma = emma;
        _this.interpretation = interpretation;
        _this.resultIndex = resultIndex;
        _this.results = results;
        return _this;
    }
    return (0, $38ddad0c42145681$var$_createClass2.default)(SpeechRecognitionEvent);
}($bgEWP.Event);
function $38ddad0c42145681$var$prepareAudioConfig(audioConfig) {
    var originalAttach = audioConfig.attach;
    var boundOriginalAttach = audioConfig.attach.bind(audioConfig);
    var firstChunk;
    var muted; // We modify "attach" function and detect when audible chunk is read.
    // We will only modify "attach" function once.
    audioConfig.attach = /*#__PURE__*/ (0, $38ddad0c42145681$var$_asyncToGenerator2.default)(/*#__PURE__*/ $38ddad0c42145681$var$_regenerator.default.mark(function _callee2() {
        var reader;
        return $38ddad0c42145681$var$_regenerator.default.wrap(function _callee2$(_context2) {
            while(true)switch(_context2.prev = _context2.next){
                case 0:
                    _context2.next = 2;
                    return boundOriginalAttach();
                case 2:
                    reader = _context2.sent;
                    return _context2.abrupt("return", $38ddad0c42145681$var$_objectSpread($38ddad0c42145681$var$_objectSpread({}, reader), {}, {
                        read: function() {
                            var _read = (0, $38ddad0c42145681$var$_asyncToGenerator2.default)(/*#__PURE__*/ $38ddad0c42145681$var$_regenerator.default.mark(function _callee() {
                                var chunk;
                                return $38ddad0c42145681$var$_regenerator.default.wrap(function _callee$(_context) {
                                    while(true)switch(_context.prev = _context.next){
                                        case 0:
                                            _context.next = 2;
                                            return reader.read();
                                        case 2:
                                            chunk = _context.sent;
                                            // The magic number 150 is measured by:
                                            // 1. Set microphone volume to 0
                                            // 2. Observe the amplitude (100-110) for the first few chunks
                                            //    (There is a short static caught when turning on the microphone)
                                            // 3. Set the number a bit higher than the observation
                                            if (!firstChunk && $38ddad0c42145681$var$averageAmplitude(chunk.buffer) > 150) {
                                                audioConfig.events.onEvent({
                                                    name: "FirstAudibleChunk"
                                                });
                                                firstChunk = true;
                                            }
                                            if (!muted) {
                                                _context.next = 6;
                                                break;
                                            }
                                            return _context.abrupt("return", {
                                                buffer: new ArrayBuffer(0),
                                                isEnd: true,
                                                timeReceived: Date.now()
                                            });
                                        case 6:
                                            return _context.abrupt("return", chunk);
                                        case 7:
                                        case "end":
                                            return _context.stop();
                                    }
                                }, _callee);
                            }));
                            function read() {
                                return _read.apply(this, arguments);
                            }
                            return read;
                        }()
                    }));
                case 4:
                case "end":
                    return _context2.stop();
            }
        }, _callee2);
    }));
    return {
        audioConfig: audioConfig,
        pause: function pause() {
            muted = true;
        },
        unprepare: function unprepare() {
            audioConfig.attach = originalAttach;
        }
    };
}
function $38ddad0c42145681$var$createSpeechRecognitionPonyfillFromRecognizer(_ref4) {
    var createRecognizer = _ref4.createRecognizer, enableTelemetry = _ref4.enableTelemetry, looseEvents = _ref4.looseEvents, referenceGrammars = _ref4.referenceGrammars, textNormalization = _ref4.textNormalization;
    // If enableTelemetry is set to null or non-boolean, we will default to true.
    $38ddad0c42145681$var$SpeechRecognizer.enableTelemetry(enableTelemetry !== false);
    var SpeechRecognition = /*#__PURE__*/ function(_EventTarget) {
        (0, $38ddad0c42145681$var$_inherits2.default)(SpeechRecognition, _EventTarget);
        var _super2 = $38ddad0c42145681$var$_createSuper(SpeechRecognition);
        function SpeechRecognition() {
            var _this2;
            (0, $38ddad0c42145681$var$_classCallCheck2.default)(this, SpeechRecognition);
            _this2 = _super2.call(this);
            _this2._continuous = false;
            _this2._interimResults = false;
            _this2._lang = typeof window !== "undefined" ? window.document.documentElement.getAttribute("lang") || window.navigator.language : "en-US";
            _this2._grammars = new $38ddad0c42145681$var$_SpeechGrammarList.default();
            _this2._maxAlternatives = 1;
            return _this2;
        }
        (0, $38ddad0c42145681$var$_createClass2.default)(SpeechRecognition, [
            {
                key: "emitCognitiveServices",
                value: function emitCognitiveServices(type, event) {
                    this.dispatchEvent(new $38ddad0c42145681$var$SpeechRecognitionEvent("cognitiveservices", {
                        data: $38ddad0c42145681$var$_objectSpread($38ddad0c42145681$var$_objectSpread({}, event), {}, {
                            type: type
                        })
                    }));
                }
            },
            {
                key: "continuous",
                get: function get() {
                    return this._continuous;
                },
                set: function set(value) {
                    this._continuous = value;
                }
            },
            {
                key: "grammars",
                get: function get() {
                    return this._grammars;
                },
                set: function set(value) {
                    if (value instanceof $38ddad0c42145681$var$_SpeechGrammarList.default) this._grammars = value;
                    else throw new Error("The provided value is not of type 'SpeechGrammarList'");
                }
            },
            {
                key: "interimResults",
                get: function get() {
                    return this._interimResults;
                },
                set: function set(value) {
                    this._interimResults = value;
                }
            },
            {
                key: "maxAlternatives",
                get: function get() {
                    return this._maxAlternatives;
                },
                set: function set(value) {
                    this._maxAlternatives = value;
                }
            },
            {
                key: "lang",
                get: function get() {
                    return this._lang;
                },
                set: function set(value) {
                    this._lang = value;
                }
            },
            {
                key: "onaudioend",
                get: function get() {
                    return (0, $bgEWP.getEventAttributeValue)(this, "audioend");
                },
                set: function set(value) {
                    (0, $bgEWP.setEventAttributeValue)(this, "audioend", value);
                }
            },
            {
                key: "onaudiostart",
                get: function get() {
                    return (0, $bgEWP.getEventAttributeValue)(this, "audiostart");
                },
                set: function set(value) {
                    (0, $bgEWP.setEventAttributeValue)(this, "audiostart", value);
                }
            },
            {
                key: "oncognitiveservices",
                get: function get() {
                    return (0, $bgEWP.getEventAttributeValue)(this, "cognitiveservices");
                },
                set: function set(value) {
                    (0, $bgEWP.setEventAttributeValue)(this, "cognitiveservices", value);
                }
            },
            {
                key: "onend",
                get: function get() {
                    return (0, $bgEWP.getEventAttributeValue)(this, "end");
                },
                set: function set(value) {
                    (0, $bgEWP.setEventAttributeValue)(this, "end", value);
                }
            },
            {
                key: "onerror",
                get: function get() {
                    return (0, $bgEWP.getEventAttributeValue)(this, "error");
                },
                set: function set(value) {
                    (0, $bgEWP.setEventAttributeValue)(this, "error", value);
                }
            },
            {
                key: "onresult",
                get: function get() {
                    return (0, $bgEWP.getEventAttributeValue)(this, "result");
                },
                set: function set(value) {
                    (0, $bgEWP.setEventAttributeValue)(this, "result", value);
                }
            },
            {
                key: "onsoundend",
                get: function get() {
                    return (0, $bgEWP.getEventAttributeValue)(this, "soundend");
                },
                set: function set(value) {
                    (0, $bgEWP.setEventAttributeValue)(this, "soundend", value);
                }
            },
            {
                key: "onsoundstart",
                get: function get() {
                    return (0, $bgEWP.getEventAttributeValue)(this, "soundstart");
                },
                set: function set(value) {
                    (0, $bgEWP.setEventAttributeValue)(this, "soundstart", value);
                }
            },
            {
                key: "onspeechend",
                get: function get() {
                    return (0, $bgEWP.getEventAttributeValue)(this, "speechend");
                },
                set: function set(value) {
                    (0, $bgEWP.setEventAttributeValue)(this, "speechend", value);
                }
            },
            {
                key: "onspeechstart",
                get: function get() {
                    return (0, $bgEWP.getEventAttributeValue)(this, "speechstart");
                },
                set: function set(value) {
                    (0, $bgEWP.setEventAttributeValue)(this, "speechstart", value);
                }
            },
            {
                key: "onstart",
                get: function get() {
                    return (0, $bgEWP.getEventAttributeValue)(this, "start");
                },
                set: function set(value) {
                    (0, $bgEWP.setEventAttributeValue)(this, "start", value);
                }
            },
            {
                key: "start",
                value: function start() {
                    var _this3 = this;
                    this._startOnce().catch(function(err) {
                        _this3.dispatchEvent(new ErrorEvent("error", {
                            error: err,
                            message: err && (err.stack || err.message)
                        }));
                    });
                }
            },
            {
                key: "_startOnce",
                value: function() {
                    var _startOnce2 = (0, $38ddad0c42145681$var$_asyncToGenerator2.default)(/*#__PURE__*/ $38ddad0c42145681$var$_regenerator.default.mark(function _callee3() {
                        var _this4 = this;
                        var recognizer, _prepareAudioConfig, pause, unprepare, queue, soundStarted, speechStarted, stopping, _recognizer$audioConf, detachAudioConfigEvent, phrases, dynamicGrammar, audioStarted, finalEvent, finalizedResults, _loop, loop, _ret;
                        return $38ddad0c42145681$var$_regenerator.default.wrap(function _callee3$(_context4) {
                            while(true)switch(_context4.prev = _context4.next){
                                case 0:
                                    _context4.next = 2;
                                    return createRecognizer(this.lang);
                                case 2:
                                    recognizer = _context4.sent;
                                    _prepareAudioConfig = $38ddad0c42145681$var$prepareAudioConfig(recognizer.audioConfig), pause = _prepareAudioConfig.pause, unprepare = _prepareAudioConfig.unprepare;
                                    _context4.prev = 4;
                                    queue = (0, $38ddad0c42145681$var$_createPromiseQueue.default)();
                                    _recognizer$audioConf = recognizer.audioConfig.events.attach(function(event) {
                                        var name = event.name;
                                        if (name === "AudioSourceReadyEvent") queue.push({
                                            audioSourceReady: {}
                                        });
                                        else if (name === "AudioSourceOffEvent") queue.push({
                                            audioSourceOff: {}
                                        });
                                        else if (name === "FirstAudibleChunk") queue.push({
                                            firstAudibleChunk: {}
                                        });
                                    }), detachAudioConfigEvent = _recognizer$audioConf.detach;
                                    recognizer.canceled = function(_, _ref5) {
                                        var errorDetails = _ref5.errorDetails, offset = _ref5.offset, reason = _ref5.reason, sessionId = _ref5.sessionId;
                                        queue.push({
                                            canceled: {
                                                errorDetails: errorDetails,
                                                offset: offset,
                                                reason: reason,
                                                sessionId: sessionId
                                            }
                                        });
                                    };
                                    recognizer.recognized = function(_, _ref6) {
                                        var offset = _ref6.offset, result = _ref6.result, sessionId = _ref6.sessionId;
                                        queue.push({
                                            recognized: {
                                                offset: offset,
                                                result: $38ddad0c42145681$var$serializeRecognitionResult(result),
                                                sessionId: sessionId
                                            }
                                        });
                                    };
                                    recognizer.recognizing = function(_, _ref7) {
                                        var offset = _ref7.offset, result = _ref7.result, sessionId = _ref7.sessionId;
                                        queue.push({
                                            recognizing: {
                                                offset: offset,
                                                result: $38ddad0c42145681$var$serializeRecognitionResult(result),
                                                sessionId: sessionId
                                            }
                                        });
                                    };
                                    recognizer.sessionStarted = function(_, _ref8) {
                                        var sessionId = _ref8.sessionId;
                                        queue.push({
                                            sessionStarted: {
                                                sessionId: sessionId
                                            }
                                        });
                                    };
                                    recognizer.sessionStopped = function(_, _ref9) {
                                        var sessionId = _ref9.sessionId;
                                        // "sessionStopped" is never fired, probably because we are using startContinuousRecognitionAsync instead of recognizeOnceAsync.
                                        queue.push({
                                            sessionStopped: {
                                                sessionId: sessionId
                                            }
                                        });
                                    };
                                    recognizer.speechStartDetected = function(_, _ref10) {
                                        var offset = _ref10.offset, sessionId = _ref10.sessionId;
                                        queue.push({
                                            speechStartDetected: {
                                                offset: offset,
                                                sessionId: sessionId
                                            }
                                        });
                                    };
                                    recognizer.speechEndDetected = function(_, _ref11) {
                                        var sessionId = _ref11.sessionId;
                                        // "speechEndDetected" is never fired, probably because we are using startContinuousRecognitionAsync instead of recognizeOnceAsync.
                                        // Update: "speechEndDetected" is fired for DLSpeech.listenOnceAsync()
                                        queue.push({
                                            speechEndDetected: {
                                                sessionId: sessionId
                                            }
                                        });
                                    };
                                    phrases = this.grammars.phrases; // HACK: We are using the internal of SpeechRecognizer because they did not expose it
                                    dynamicGrammar = recognizer.privReco.dynamicGrammar;
                                    referenceGrammars && referenceGrammars.length && dynamicGrammar.addReferenceGrammar(referenceGrammars);
                                    phrases && phrases.length && dynamicGrammar.addPhrase(phrases);
                                    _context4.next = 20;
                                    return $38ddad0c42145681$var$cognitiveServicesAsyncToPromise(recognizer.startContinuousRecognitionAsync.bind(recognizer))();
                                case 20:
                                    if (recognizer.stopContinuousRecognitionAsync) {
                                        this.abort = function() {
                                            return queue.push({
                                                abort: {}
                                            });
                                        };
                                        this.stop = function() {
                                            return queue.push({
                                                stop: {}
                                            });
                                        };
                                    } else this.abort = this.stop = undefined;
                                    finalizedResults = [];
                                    _loop = /*#__PURE__*/ $38ddad0c42145681$var$_regenerator.default.mark(function _loop(loop) {
                                        var event, abort, audioSourceOff, audioSourceReady, canceled, firstAudibleChunk, recognized, recognizing, stop, errorMessage, result, recognizable;
                                        return $38ddad0c42145681$var$_regenerator.default.wrap(function _loop$(_context3) {
                                            while(true)switch(_context3.prev = _context3.next){
                                                case 0:
                                                    _context3.next = 2;
                                                    return queue.shift();
                                                case 2:
                                                    event = _context3.sent;
                                                    abort = event.abort, audioSourceOff = event.audioSourceOff, audioSourceReady = event.audioSourceReady, canceled = event.canceled, firstAudibleChunk = event.firstAudibleChunk, recognized = event.recognized, recognizing = event.recognizing, stop = event.stop; // We are emitting event "cognitiveservices" for debugging purpose.
                                                    Object.keys(event).forEach(function(name) {
                                                        return _this4.emitCognitiveServices(name, event[name]);
                                                    });
                                                    errorMessage = canceled && canceled.errorDetails;
                                                    if (!/Permission[\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]denied/.test(errorMessage || "")) {
                                                        _context3.next = 9;
                                                        break;
                                                    }
                                                    // If microphone is not allowed, we should not emit "start" event.
                                                    finalEvent = {
                                                        error: "not-allowed",
                                                        type: "error"
                                                    };
                                                    return _context3.abrupt("return", "break");
                                                case 9:
                                                    if (!loop) _this4.dispatchEvent(new $38ddad0c42145681$var$SpeechRecognitionEvent("start"));
                                                    if (!errorMessage) {
                                                        _context3.next = 15;
                                                        break;
                                                    }
                                                    if (/1006/.test(errorMessage)) {
                                                        if (!audioStarted) {
                                                            _this4.dispatchEvent(new $38ddad0c42145681$var$SpeechRecognitionEvent("audiostart"));
                                                            _this4.dispatchEvent(new $38ddad0c42145681$var$SpeechRecognitionEvent("audioend"));
                                                        }
                                                        finalEvent = {
                                                            error: "network",
                                                            type: "error"
                                                        };
                                                    } else finalEvent = {
                                                        error: "unknown",
                                                        type: "error"
                                                    };
                                                    return _context3.abrupt("return", "break");
                                                case 15:
                                                    if (!(abort || stop)) {
                                                        _context3.next = 22;
                                                        break;
                                                    }
                                                    if (abort) {
                                                        finalEvent = {
                                                            error: "aborted",
                                                            type: "error"
                                                        }; // If we are aborting, we will ignore lingering recognizing/recognized events. But if we are stopping, we need them.
                                                        stopping = "abort";
                                                    } else {
                                                        // When we pause, we will send { isEnd: true }, Speech Services will send us "recognized" event.
                                                        pause();
                                                        stopping = "stop";
                                                    } // Abort should not be dispatched without support of "stopContinuousRecognitionAsync".
                                                    // But for defensive purpose, we make sure "stopContinuousRecognitionAsync" is available before we can call.
                                                    if (!(abort && recognizer.stopContinuousRecognitionAsync)) {
                                                        _context3.next = 20;
                                                        break;
                                                    }
                                                    _context3.next = 20;
                                                    return $38ddad0c42145681$var$cognitiveServicesAsyncToPromise(recognizer.stopContinuousRecognitionAsync.bind(recognizer))();
                                                case 20:
                                                    _context3.next = 61;
                                                    break;
                                                case 22:
                                                    if (!audioSourceReady) {
                                                        _context3.next = 27;
                                                        break;
                                                    }
                                                    _this4.dispatchEvent(new $38ddad0c42145681$var$SpeechRecognitionEvent("audiostart"));
                                                    audioStarted = true;
                                                    _context3.next = 61;
                                                    break;
                                                case 27:
                                                    if (!firstAudibleChunk) {
                                                        _context3.next = 32;
                                                        break;
                                                    }
                                                    _this4.dispatchEvent(new $38ddad0c42145681$var$SpeechRecognitionEvent("soundstart"));
                                                    soundStarted = true;
                                                    _context3.next = 61;
                                                    break;
                                                case 32:
                                                    if (!audioSourceOff) {
                                                        _context3.next = 40;
                                                        break;
                                                    }
                                                    // Looks like we don't need this line and all the tests are still working.
                                                    // Guessing probably stopping is already truthy.
                                                    // stopping = true;
                                                    speechStarted && _this4.dispatchEvent(new $38ddad0c42145681$var$SpeechRecognitionEvent("speechend"));
                                                    soundStarted && _this4.dispatchEvent(new $38ddad0c42145681$var$SpeechRecognitionEvent("soundend"));
                                                    audioStarted && _this4.dispatchEvent(new $38ddad0c42145681$var$SpeechRecognitionEvent("audioend"));
                                                    audioStarted = soundStarted = speechStarted = false;
                                                    return _context3.abrupt("return", "break");
                                                case 40:
                                                    if (!(stopping !== "abort")) {
                                                        _context3.next = 61;
                                                        break;
                                                    }
                                                    if (!(recognized && recognized.result && recognized.result.reason === $38ddad0c42145681$var$ResultReason.NoMatch)) {
                                                        _context3.next = 45;
                                                        break;
                                                    }
                                                    finalEvent = {
                                                        error: "no-speech",
                                                        type: "error"
                                                    };
                                                    _context3.next = 61;
                                                    break;
                                                case 45:
                                                    if (!(recognized || recognizing)) {
                                                        _context3.next = 61;
                                                        break;
                                                    }
                                                    if (!audioStarted) {
                                                        // Unconfirmed prevention of quirks
                                                        _this4.dispatchEvent(new $38ddad0c42145681$var$SpeechRecognitionEvent("audiostart"));
                                                        audioStarted = true;
                                                    }
                                                    if (!soundStarted) {
                                                        _this4.dispatchEvent(new $38ddad0c42145681$var$SpeechRecognitionEvent("soundstart"));
                                                        soundStarted = true;
                                                    }
                                                    if (!speechStarted) {
                                                        _this4.dispatchEvent(new $38ddad0c42145681$var$SpeechRecognitionEvent("speechstart"));
                                                        speechStarted = true;
                                                    }
                                                    if (!recognized) {
                                                        _context3.next = 60;
                                                        break;
                                                    }
                                                    result = (0, $38ddad0c42145681$var$_cognitiveServiceEventResultToWebSpeechRecognitionResultList.default)(recognized.result, {
                                                        maxAlternatives: _this4.maxAlternatives,
                                                        textNormalization: textNormalization
                                                    });
                                                    recognizable = !!result[0].transcript;
                                                    if (recognizable) {
                                                        finalizedResults = [].concat((0, $38ddad0c42145681$var$_toConsumableArray2.default)(finalizedResults), [
                                                            result
                                                        ]);
                                                        _this4.continuous && _this4.dispatchEvent(new $38ddad0c42145681$var$SpeechRecognitionEvent("result", {
                                                            results: finalizedResults
                                                        }));
                                                    } // If it is continuous, we just sent the finalized results. So we don't need to send it again after "audioend" event.
                                                    if (_this4.continuous && recognizable) finalEvent = null;
                                                    else finalEvent = {
                                                        results: finalizedResults,
                                                        type: "result"
                                                    };
                                                    if (!(!_this4.continuous && recognizer.stopContinuousRecognitionAsync)) {
                                                        _context3.next = 57;
                                                        break;
                                                    }
                                                    _context3.next = 57;
                                                    return $38ddad0c42145681$var$cognitiveServicesAsyncToPromise(recognizer.stopContinuousRecognitionAsync.bind(recognizer))();
                                                case 57:
                                                    // If event order can be loosened, we can send the recognized event as soon as we receive it.
                                                    // 1. If it is not recognizable (no-speech), we should send an "error" event just before "end" event. We will not loosen "error" events.
                                                    if (looseEvents && finalEvent && recognizable) {
                                                        _this4.dispatchEvent(new $38ddad0c42145681$var$SpeechRecognitionEvent(finalEvent.type, finalEvent));
                                                        finalEvent = null;
                                                    }
                                                    _context3.next = 61;
                                                    break;
                                                case 60:
                                                    if (recognizing) _this4.interimResults && _this4.dispatchEvent(new $38ddad0c42145681$var$SpeechRecognitionEvent("result", {
                                                        results: [].concat((0, $38ddad0c42145681$var$_toConsumableArray2.default)(finalizedResults), [
                                                            (0, $38ddad0c42145681$var$_cognitiveServiceEventResultToWebSpeechRecognitionResultList.default)(recognizing.result, {
                                                                maxAlternatives: _this4.maxAlternatives,
                                                                textNormalization: textNormalization
                                                            })
                                                        ])
                                                    }));
                                                case 61:
                                                case "end":
                                                    return _context3.stop();
                                            }
                                        }, _loop);
                                    });
                                    loop = 0;
                                case 24:
                                    if (!(!stopping || audioStarted)) {
                                        _context4.next = 32;
                                        break;
                                    }
                                    return _context4.delegateYield(_loop(loop), "t0", 26);
                                case 26:
                                    _ret = _context4.t0;
                                    if (!(_ret === "break")) {
                                        _context4.next = 29;
                                        break;
                                    }
                                    return _context4.abrupt("break", 32);
                                case 29:
                                    loop++;
                                    _context4.next = 24;
                                    break;
                                case 32:
                                    if (speechStarted) this.dispatchEvent(new $38ddad0c42145681$var$SpeechRecognitionEvent("speechend"));
                                    if (soundStarted) this.dispatchEvent(new $38ddad0c42145681$var$SpeechRecognitionEvent("soundend"));
                                    if (audioStarted) this.dispatchEvent(new $38ddad0c42145681$var$SpeechRecognitionEvent("audioend"));
                                    if (finalEvent) {
                                        if (finalEvent.type === "result" && !finalEvent.results.length) finalEvent = {
                                            error: "no-speech",
                                            type: "error"
                                        };
                                        if (finalEvent.type === "error") this.dispatchEvent(new ErrorEvent("error", finalEvent));
                                        else this.dispatchEvent(new $38ddad0c42145681$var$SpeechRecognitionEvent(finalEvent.type, finalEvent));
                                    } // Even though there is no "start" event emitted, we will still emit "end" event
                                    // This is mainly for "microphone blocked" story.
                                    this.dispatchEvent(new $38ddad0c42145681$var$SpeechRecognitionEvent("end"));
                                    detachAudioConfigEvent();
                                    _context4.next = 44;
                                    break;
                                case 40:
                                    _context4.prev = 40;
                                    _context4.t1 = _context4["catch"](4);
                                    // Logging out the erorr because Speech SDK would fail silently.
                                    console.error(_context4.t1);
                                    throw _context4.t1;
                                case 44:
                                    _context4.prev = 44;
                                    unprepare();
                                    recognizer.dispose();
                                    return _context4.finish(44);
                                case 48:
                                case "end":
                                    return _context4.stop();
                            }
                        }, _callee3, this, [
                            [
                                4,
                                40,
                                44,
                                48
                            ]
                        ]);
                    }));
                    function _startOnce() {
                        return _startOnce2.apply(this, arguments);
                    }
                    return _startOnce;
                }()
            }
        ]);
        return SpeechRecognition;
    }($bgEWP.EventTarget);
    return {
        SpeechGrammarList: $38ddad0c42145681$var$_SpeechGrammarList.default,
        SpeechRecognition: SpeechRecognition,
        SpeechRecognitionEvent: $38ddad0c42145681$var$SpeechRecognitionEvent
    };
}
var $38ddad0c42145681$var$_default = function _default(options) {
    var _patchOptions = (0, $38ddad0c42145681$var$_patchOptions2.default)(options), _patchOptions$audioCo = _patchOptions.audioConfig, audioConfig = _patchOptions$audioCo === void 0 ? $38ddad0c42145681$var$AudioConfig.fromDefaultMicrophoneInput() : _patchOptions$audioCo, _patchOptions$enableT = _patchOptions.enableTelemetry, enableTelemetry = _patchOptions$enableT === void 0 ? true : _patchOptions$enableT, fetchCredentials = _patchOptions.fetchCredentials, looseEvents = _patchOptions.looseEvents, referenceGrammars = _patchOptions.referenceGrammars, speechRecognitionEndpointId = _patchOptions.speechRecognitionEndpointId, _patchOptions$textNor = _patchOptions.textNormalization, textNormalization = _patchOptions$textNor === void 0 ? "display" : _patchOptions$textNor;
    if (!audioConfig && (!window.navigator.mediaDevices || !window.navigator.mediaDevices.getUserMedia)) {
        console.warn("web-speech-cognitive-services: This browser does not support WebRTC and it will not work with Cognitive Services Speech Services.");
        return {};
    }
    var createRecognizer = /*#__PURE__*/ function() {
        var _ref12 = (0, $38ddad0c42145681$var$_asyncToGenerator2.default)(/*#__PURE__*/ $38ddad0c42145681$var$_regenerator.default.mark(function _callee4(lang) {
            var _yield$fetchCredentia, authorizationToken, region, speechRecognitionHostname, subscriptionKey, speechConfig, host;
            return $38ddad0c42145681$var$_regenerator.default.wrap(function _callee4$(_context5) {
                while(true)switch(_context5.prev = _context5.next){
                    case 0:
                        _context5.next = 2;
                        return fetchCredentials();
                    case 2:
                        _yield$fetchCredentia = _context5.sent;
                        authorizationToken = _yield$fetchCredentia.authorizationToken;
                        region = _yield$fetchCredentia.region;
                        speechRecognitionHostname = _yield$fetchCredentia.speechRecognitionHostname;
                        subscriptionKey = _yield$fetchCredentia.subscriptionKey;
                        if (speechRecognitionHostname) {
                            host = {
                                hostname: speechRecognitionHostname,
                                port: 443,
                                protocol: "wss:"
                            };
                            if (authorizationToken) {
                                speechConfig = $38ddad0c42145681$var$SpeechConfig.fromHost(host);
                                speechConfig.authorizationToken = authorizationToken;
                            } else speechConfig = $38ddad0c42145681$var$SpeechConfig.fromHost(host, subscriptionKey);
                        } else speechConfig = authorizationToken ? $38ddad0c42145681$var$SpeechConfig.fromAuthorizationToken(authorizationToken, region) : $38ddad0c42145681$var$SpeechConfig.fromSubscription(subscriptionKey, region);
                        if (speechRecognitionEndpointId) speechConfig.endpointId = speechRecognitionEndpointId;
                        speechConfig.outputFormat = $38ddad0c42145681$var$OutputFormat.Detailed;
                        speechConfig.speechRecognitionLanguage = lang || "en-US";
                        return _context5.abrupt("return", new $38ddad0c42145681$var$SpeechRecognizer(speechConfig, audioConfig));
                    case 12:
                    case "end":
                        return _context5.stop();
                }
            }, _callee4);
        }));
        return function createRecognizer(_x) {
            return _ref12.apply(this, arguments);
        };
    }();
    return $38ddad0c42145681$var$createSpeechRecognitionPonyfillFromRecognizer({
        audioConfig: audioConfig,
        createRecognizer: createRecognizer,
        enableTelemetry: enableTelemetry,
        looseEvents: looseEvents,
        referenceGrammars: referenceGrammars,
        textNormalization: textNormalization
    });
};
module.exports.default = $38ddad0c42145681$var$_default;

});
parcelRequire.register("clWYw", function(module, exports) {
function $8fe531714db3b5d6$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
module.exports = $8fe531714db3b5d6$var$_interopRequireDefault, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRequire.register("ilkkY", function(module, exports) {
// TODO(Babel 8): Remove this file.

var $d5a9f6be54373074$var$runtime = (parcelRequire("cat9d"))();
module.exports = $d5a9f6be54373074$var$runtime;
// Copied from https://github.com/facebook/regenerator/blob/main/packages/runtime/runtime.js#L736=
try {
    regeneratorRuntime = $d5a9f6be54373074$var$runtime;
} catch (accidentalStrictMode) {
    if (typeof globalThis === "object") globalThis.regeneratorRuntime = $d5a9f6be54373074$var$runtime;
    else Function("r", "regeneratorRuntime = r")($d5a9f6be54373074$var$runtime);
}

});
parcelRequire.register("cat9d", function(module, exports) {

var $cAvdA = parcelRequire("cAvdA");
var $8dbd0758f29448dc$var$_typeof = $cAvdA.default;
function $8dbd0758f29448dc$var$_regeneratorRuntime() {
    "use strict";
    /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ module.exports = $8dbd0758f29448dc$var$_regeneratorRuntime = function _regeneratorRuntime() {
        return exports;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports;
    var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
    function define(obj, key, value) {
        return Object.defineProperty(obj, key, {
            value: value,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }), obj[key];
    }
    try {
        define({}, "");
    } catch (err) {
        define = function define(obj, key, value) {
            return obj[key] = value;
        };
    }
    function wrap(innerFn, outerFn, self, tryLocsList) {
        var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []);
        return generator._invoke = function(innerFn, self, context) {
            var state = "suspendedStart";
            return function(method, arg) {
                if ("executing" === state) throw new Error("Generator is already running");
                if ("completed" === state) {
                    if ("throw" === method) throw arg;
                    return doneResult();
                }
                for(context.method = method, context.arg = arg;;){
                    var delegate = context.delegate;
                    if (delegate) {
                        var delegateResult = maybeInvokeDelegate(delegate, context);
                        if (delegateResult) {
                            if (delegateResult === ContinueSentinel) continue;
                            return delegateResult;
                        }
                    }
                    if ("next" === context.method) context.sent = context._sent = context.arg;
                    else if ("throw" === context.method) {
                        if ("suspendedStart" === state) throw state = "completed", context.arg;
                        context.dispatchException(context.arg);
                    } else "return" === context.method && context.abrupt("return", context.arg);
                    state = "executing";
                    var record = tryCatch(innerFn, self, context);
                    if ("normal" === record.type) {
                        if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue;
                        return {
                            value: record.arg,
                            done: context.done
                        };
                    }
                    "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg);
                }
            };
        }(innerFn, self, context), generator;
    }
    function tryCatch(fn, obj, arg) {
        try {
            return {
                type: "normal",
                arg: fn.call(obj, arg)
            };
        } catch (err) {
            return {
                type: "throw",
                arg: err
            };
        }
    }
    exports.wrap = wrap;
    var ContinueSentinel = {};
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    var IteratorPrototype = {};
    define(IteratorPrototype, iteratorSymbol, function() {
        return this;
    });
    var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([])));
    NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype);
    var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
    function defineIteratorMethods(prototype) {
        [
            "next",
            "throw",
            "return"
        ].forEach(function(method) {
            define(prototype, method, function(arg) {
                return this._invoke(method, arg);
            });
        });
    }
    function AsyncIterator(generator, PromiseImpl) {
        function invoke(method, arg, resolve, reject) {
            var record = tryCatch(generator[method], generator, arg);
            if ("throw" !== record.type) {
                var result = record.arg, value = result.value;
                return value && "object" == $8dbd0758f29448dc$var$_typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function(value) {
                    invoke("next", value, resolve, reject);
                }, function(err) {
                    invoke("throw", err, resolve, reject);
                }) : PromiseImpl.resolve(value).then(function(unwrapped) {
                    result.value = unwrapped, resolve(result);
                }, function(error) {
                    return invoke("throw", error, resolve, reject);
                });
            }
            reject(record.arg);
        }
        var previousPromise;
        this._invoke = function(method, arg) {
            function callInvokeWithMethodAndArg() {
                return new PromiseImpl(function(resolve, reject) {
                    invoke(method, arg, resolve, reject);
                });
            }
            return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
        };
    }
    function maybeInvokeDelegate(delegate, context) {
        var method = delegate.iterator[context.method];
        if (undefined === method) {
            if (context.delegate = null, "throw" === context.method) {
                if (delegate.iterator["return"] && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel;
                context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method");
            }
            return ContinueSentinel;
        }
        var record = tryCatch(method, delegate.iterator, context.arg);
        if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel;
        var info = record.arg;
        return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel);
    }
    function pushTryEntry(locs) {
        var entry = {
            tryLoc: locs[0]
        };
        1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry);
    }
    function resetTryEntry(entry) {
        var record = entry.completion || {};
        record.type = "normal", delete record.arg, entry.completion = record;
    }
    function Context(tryLocsList) {
        this.tryEntries = [
            {
                tryLoc: "root"
            }
        ], tryLocsList.forEach(pushTryEntry, this), this.reset(!0);
    }
    function values(iterable) {
        if (iterable) {
            var iteratorMethod = iterable[iteratorSymbol];
            if (iteratorMethod) return iteratorMethod.call(iterable);
            if ("function" == typeof iterable.next) return iterable;
            if (!isNaN(iterable.length)) {
                var i = -1, next = function next() {
                    for(; ++i < iterable.length;){
                        if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next;
                    }
                    return next.value = undefined, next.done = !0, next;
                };
                return next.next = next;
            }
        }
        return {
            next: doneResult
        };
    }
    function doneResult() {
        return {
            value: undefined,
            done: !0
        };
    }
    return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function(genFun) {
        var ctor = "function" == typeof genFun && genFun.constructor;
        return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name));
    }, exports.mark = function(genFun) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun;
    }, exports.awrap = function(arg) {
        return {
            __await: arg
        };
    }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function() {
        return this;
    }), exports.AsyncIterator = AsyncIterator, exports.async = function(innerFn, outerFn, self, tryLocsList, PromiseImpl) {
        void 0 === PromiseImpl && (PromiseImpl = Promise);
        var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
        return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function(result) {
            return result.done ? result.value : iter.next();
        });
    }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function() {
        return this;
    }), define(Gp, "toString", function() {
        return "[object Generator]";
    }), exports.keys = function(object) {
        var keys = [];
        for(var key in object)keys.push(key);
        return keys.reverse(), function next() {
            for(; keys.length;){
                var key = keys.pop();
                if (key in object) return next.value = key, next.done = !1, next;
            }
            return next.done = !0, next;
        };
    }, exports.values = values, Context.prototype = {
        constructor: Context,
        reset: function reset(skipTempReset) {
            if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for(var name in this)"t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined);
        },
        stop: function stop() {
            this.done = !0;
            var rootRecord = this.tryEntries[0].completion;
            if ("throw" === rootRecord.type) throw rootRecord.arg;
            return this.rval;
        },
        dispatchException: function dispatchException(exception) {
            if (this.done) throw exception;
            var context = this;
            function handle(loc, caught) {
                return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught;
            }
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i], record = entry.completion;
                if ("root" === entry.tryLoc) return handle("end");
                if (entry.tryLoc <= this.prev) {
                    var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc");
                    if (hasCatch && hasFinally) {
                        if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
                        if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
                    } else if (hasCatch) {
                        if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
                    } else {
                        if (!hasFinally) throw new Error("try statement without catch or finally");
                        if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
                    }
                }
            }
        },
        abrupt: function abrupt(type, arg) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
                    var finallyEntry = entry;
                    break;
                }
            }
            finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null);
            var record = finallyEntry ? finallyEntry.completion : {};
            return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record);
        },
        complete: function complete(record, afterLoc) {
            if ("throw" === record.type) throw record.arg;
            return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel;
        },
        finish: function finish(finallyLoc) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel;
            }
        },
        "catch": function _catch(tryLoc) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.tryLoc === tryLoc) {
                    var record = entry.completion;
                    if ("throw" === record.type) {
                        var thrown = record.arg;
                        resetTryEntry(entry);
                    }
                    return thrown;
                }
            }
            throw new Error("illegal catch attempt");
        },
        delegateYield: function delegateYield(iterable, resultName, nextLoc) {
            return this.delegate = {
                iterator: values(iterable),
                resultName: resultName,
                nextLoc: nextLoc
            }, "next" === this.method && (this.arg = undefined), ContinueSentinel;
        }
    }, exports;
}
module.exports = $8dbd0758f29448dc$var$_regeneratorRuntime, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRequire.register("aUVii", function(module, exports) {

var $75PRO = parcelRequire("75PRO");

var $iPn0o = parcelRequire("iPn0o");

var $8HNVU = parcelRequire("8HNVU");

var $9CjCR = parcelRequire("9CjCR");
function $7f2b93c5c11faac1$var$_toConsumableArray(arr) {
    return $75PRO(arr) || $iPn0o(arr) || $8HNVU(arr) || $9CjCR();
}
module.exports = $7f2b93c5c11faac1$var$_toConsumableArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRequire.register("75PRO", function(module, exports) {

var $9bHui = parcelRequire("9bHui");
function $52a13bb4fd4acecb$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $9bHui(arr);
}
module.exports = $52a13bb4fd4acecb$var$_arrayWithoutHoles, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRequire.register("9bHui", function(module, exports) {
function $6b06dfe3cd14a517$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
module.exports = $6b06dfe3cd14a517$var$_arrayLikeToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRequire.register("iPn0o", function(module, exports) {
function $db4ed5ca47cb06a6$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
module.exports = $db4ed5ca47cb06a6$var$_iterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRequire.register("8HNVU", function(module, exports) {

var $9bHui = parcelRequire("9bHui");
function $6569128cff00286d$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $9bHui(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $9bHui(o, minLen);
}
module.exports = $6569128cff00286d$var$_unsupportedIterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRequire.register("9CjCR", function(module, exports) {
function $7006e2f0b423795a$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
module.exports = $7006e2f0b423795a$var$_nonIterableSpread, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRequire.register("f4cyQ", function(module, exports) {
function $af80f91832f8fa43$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) resolve(value);
    else Promise.resolve(value).then(_next, _throw);
}
function $af80f91832f8fa43$var$_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                $af80f91832f8fa43$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                $af80f91832f8fa43$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
module.exports = $af80f91832f8fa43$var$_asyncToGenerator, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRequire.register("kkabb", function(module, exports) {
function $ecbd92540766e551$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $ecbd92540766e551$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $ecbd92540766e551$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $ecbd92540766e551$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
module.exports = $ecbd92540766e551$var$_createClass, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRequire.register("kFs3a", function(module, exports) {
function $f0bd6528dac8f4fb$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
module.exports = $f0bd6528dac8f4fb$var$_classCallCheck, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRequire.register("edsvT", function(module, exports) {

var $bX6UU = parcelRequire("bX6UU");
function $a59865bd2d9621a1$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $bX6UU(subClass, superClass);
}
module.exports = $a59865bd2d9621a1$var$_inherits, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRequire.register("bX6UU", function(module, exports) {
function $8b3a91f692af0c44$var$_setPrototypeOf(o, p) {
    module.exports = $8b3a91f692af0c44$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports;
    return $8b3a91f692af0c44$var$_setPrototypeOf(o, p);
}
module.exports = $8b3a91f692af0c44$var$_setPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRequire.register("lKMYv", function(module, exports) {

var $cAvdA = parcelRequire("cAvdA");
var $fd63e243507768e1$var$_typeof = $cAvdA.default;

var $ejHgJ = parcelRequire("ejHgJ");
function $fd63e243507768e1$var$_possibleConstructorReturn(self, call) {
    if (call && ($fd63e243507768e1$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $ejHgJ(self);
}
module.exports = $fd63e243507768e1$var$_possibleConstructorReturn, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRequire.register("ejHgJ", function(module, exports) {
function $a6c4675a1a59ba69$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
module.exports = $a6c4675a1a59ba69$var$_assertThisInitialized, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRequire.register("iXZmE", function(module, exports) {
function $dced565afad3977d$var$_getPrototypeOf(o) {
    module.exports = $dced565afad3977d$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    }, module.exports.__esModule = true, module.exports["default"] = module.exports;
    return $dced565afad3977d$var$_getPrototypeOf(o);
}
module.exports = $dced565afad3977d$var$_getPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRequire.register("auhfT", function(module, exports) {
"use strict";

var $clWYw = parcelRequire("clWYw");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $7a2a17458d0aab7c$var$_default;

var $7a2a17458d0aab7c$var$_arrayToMap = $clWYw((parcelRequire("eaysH")));

var $7a2a17458d0aab7c$var$_SpeechSDK = $clWYw((parcelRequire("gLWFf")));
var $7a2a17458d0aab7c$var$_SpeechSDK$ResultReas = $7a2a17458d0aab7c$var$_SpeechSDK.default.ResultReason, $7a2a17458d0aab7c$var$RecognizingSpeech = $7a2a17458d0aab7c$var$_SpeechSDK$ResultReas.RecognizingSpeech, $7a2a17458d0aab7c$var$RecognizedSpeech = $7a2a17458d0aab7c$var$_SpeechSDK$ResultReas.RecognizedSpeech;
function $7a2a17458d0aab7c$var$_default(result) {
    var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {}, _ref$maxAlternatives = _ref.maxAlternatives, maxAlternatives = _ref$maxAlternatives === void 0 ? Infinity : _ref$maxAlternatives, _ref$textNormalizatio = _ref.textNormalization, textNormalization = _ref$textNormalizatio === void 0 ? "display" : _ref$textNormalizatio;
    if (result.reason === $7a2a17458d0aab7c$var$RecognizingSpeech || result.reason === $7a2a17458d0aab7c$var$RecognizedSpeech && !result.json.NBest) {
        var resultList = [
            {
                confidence: 0.5,
                transcript: result.text
            }
        ];
        if (result.reason === $7a2a17458d0aab7c$var$RecognizedSpeech) resultList.isFinal = true;
        return resultList;
    } else if (result.reason === $7a2a17458d0aab7c$var$RecognizedSpeech) {
        var _resultList = (0, $7a2a17458d0aab7c$var$_arrayToMap.default)((result.json.NBest || []).slice(0, maxAlternatives).map(function(_ref2) {
            var confidence = _ref2.Confidence, display = _ref2.Display, itn = _ref2.ITN, lexical = _ref2.Lexical, maskedITN = _ref2.MaskedITN;
            return {
                confidence: confidence,
                transcript: textNormalization === "itn" ? itn : textNormalization === "lexical" ? lexical : textNormalization === "maskeditn" ? maskedITN : display
            };
        }), {
            isFinal: true
        });
        return _resultList;
    }
    return [];
}

});
parcelRequire.register("eaysH", function(module, exports) {
"use strict";

var $clWYw = parcelRequire("clWYw");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $a50cbb4bddb3e216$var$_default;

var $a50cbb4bddb3e216$var$_defineProperty2 = $clWYw((parcelRequire("0ITDg")));
function $a50cbb4bddb3e216$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $a50cbb4bddb3e216$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $a50cbb4bddb3e216$var$ownKeys(Object(source), !0).forEach(function(key) {
            (0, $a50cbb4bddb3e216$var$_defineProperty2.default)(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $a50cbb4bddb3e216$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $a50cbb4bddb3e216$var$_default(array, extras) {
    var map = $a50cbb4bddb3e216$var$_objectSpread($a50cbb4bddb3e216$var$_objectSpread($a50cbb4bddb3e216$var$_objectSpread({}, [].reduce.call(array, function(map, value, index) {
        map[index] = value;
        return map;
    }, {})), extras), {}, (0, $a50cbb4bddb3e216$var$_defineProperty2.default)({
        length: array.length
    }, Symbol.iterator, function() {
        return [].slice.call(map)[Symbol.iterator]();
    }));
    return map;
}

});

parcelRequire.register("gLWFf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3r0D2 = parcelRequire("3r0D2");
// We are only importing what we need.
var $c35e8aa0946826d4$var$_default = {
    AudioConfig: $3r0D2.AudioConfig,
    OutputFormat: $3r0D2.OutputFormat,
    ResultReason: $3r0D2.ResultReason,
    SpeechConfig: $3r0D2.SpeechConfig,
    SpeechRecognizer: $3r0D2.SpeechRecognizer,
    SpeechSynthesizer: $3r0D2.SpeechSynthesizer
};
module.exports.default = $c35e8aa0946826d4$var$_default;

});
parcelRequire.register("3r0D2", function(module, exports) {
"use strict";
var $2804618f9324c33e$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $2804618f9324c33e$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) $2804618f9324c33e$var$__createBinding(exports, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $j1V0D = parcelRequire("j1V0D");

var $em8BD = parcelRequire("em8BD");
// Common.Storage.SetLocalStorage(new Common.Browser.LocalStorage());
// Common.Storage.SetSessionStorage(new Common.Browser.SessionStorage());
$em8BD.Events.instance.attachConsoleListener(new $j1V0D.ConsoleLoggingListener());

// Speech SDK API
$2804618f9324c33e$var$__exportStar((parcelRequire("hM4QX")), module.exports);

});
parcelRequire.register("j1V0D", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
var $ddaa55262865d54f$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $ddaa55262865d54f$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) $ddaa55262865d54f$var$__createBinding(exports, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$ddaa55262865d54f$var$__exportStar((parcelRequire("850yu")), module.exports);

$ddaa55262865d54f$var$__exportStar((parcelRequire("6PmIW")), module.exports);

$ddaa55262865d54f$var$__exportStar((parcelRequire("6sE7a")), module.exports);

$ddaa55262865d54f$var$__exportStar((parcelRequire("f07mb")), module.exports);

$ddaa55262865d54f$var$__exportStar((parcelRequire("aY3vd")), module.exports);

$ddaa55262865d54f$var$__exportStar((parcelRequire("djMwj")), module.exports);

$ddaa55262865d54f$var$__exportStar((parcelRequire("i7W09")), module.exports);

$ddaa55262865d54f$var$__exportStar((parcelRequire("cPF2y")), module.exports);

$ddaa55262865d54f$var$__exportStar((parcelRequire("hk1SB")), module.exports);

$ddaa55262865d54f$var$__exportStar((parcelRequire("bnWMI")), module.exports);

$ddaa55262865d54f$var$__exportStar((parcelRequire("e6mtZ")), module.exports);

});
parcelRequire.register("850yu", function(module, exports) {
"use strict";
/* eslint-disable @typescript-eslint/no-unsafe-assignment */ // Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
var $5e1f38a20ab66ba8$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $5e1f38a20ab66ba8$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $5e1f38a20ab66ba8$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.hasOwnProperty.call(mod, k)) $5e1f38a20ab66ba8$var$__createBinding(result, mod, k);
    }
    $5e1f38a20ab66ba8$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ConsoleLoggingListener = void 0;

var $5e1f38a20ab66ba8$var$fs = $5e1f38a20ab66ba8$var$__importStar((parcelRequire("gR5sk")));

var $kYr7L = parcelRequire("kYr7L");

var $gBGZx = parcelRequire("gBGZx");
var $5e1f38a20ab66ba8$var$ConsoleLoggingListener = /** @class */ function() {
    function ConsoleLoggingListener(logLevelFilter) {
        if (logLevelFilter === void 0) logLevelFilter = $kYr7L.LogLevel.None;
        this.privLogPath = undefined;
        this.privEnableConsoleOutput = true;
        this.privLogLevelFilter = logLevelFilter;
    }
    Object.defineProperty(ConsoleLoggingListener.prototype, "logPath", {
        set: function(path) {
            $gBGZx.Contracts.throwIfNullOrUndefined($5e1f38a20ab66ba8$var$fs.openSync, "\nFile System access not available");
            this.privLogPath = path;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ConsoleLoggingListener.prototype, "enableConsoleOutput", {
        set: function(enableOutput) {
            this.privEnableConsoleOutput = enableOutput;
        },
        enumerable: false,
        configurable: true
    });
    ConsoleLoggingListener.prototype.onEvent = function(event) {
        if (event.eventType >= this.privLogLevelFilter) {
            var log = this.toString(event);
            if (!!this.privLogPath) $5e1f38a20ab66ba8$var$fs.writeFileSync(this.privLogPath, log + "\n", {
                flag: "a+"
            });
            if (this.privEnableConsoleOutput) switch(event.eventType){
                case $kYr7L.LogLevel.Debug:
                    // eslint-disable-next-line no-console
                    console.debug(log);
                    break;
                case $kYr7L.LogLevel.Info:
                    // eslint-disable-next-line no-console
                    console.info(log);
                    break;
                case $kYr7L.LogLevel.Warning:
                    // eslint-disable-next-line no-console
                    console.warn(log);
                    break;
                case $kYr7L.LogLevel.Error:
                    // eslint-disable-next-line no-console
                    console.error(log);
                    break;
                default:
                    // eslint-disable-next-line no-console
                    console.log(log);
                    break;
            }
        }
    };
    ConsoleLoggingListener.prototype.toString = function(event) {
        var logFragments = [
            "" + event.eventTime,
            "" + event.name
        ];
        var e = event;
        for(var prop in e)if (prop && event.hasOwnProperty(prop) && prop !== "eventTime" && prop !== "eventType" && prop !== "eventId" && prop !== "name" && prop !== "constructor") {
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            var value = e[prop];
            var valueToLog = "<NULL>";
            if (value !== undefined && value !== null) {
                if (typeof value === "number" || typeof value === "string") valueToLog = value.toString();
                else valueToLog = JSON.stringify(value);
            }
            logFragments.push(prop + ": " + valueToLog);
        }
        return logFragments.join(" | ");
    };
    return ConsoleLoggingListener;
}();
module.exports.ConsoleLoggingListener = $5e1f38a20ab66ba8$var$ConsoleLoggingListener;

});
parcelRequire.register("kYr7L", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LogLevel = void 0;

var $em8BD = parcelRequire("em8BD");
Object.defineProperty(module.exports, "LogLevel", {
    enumerable: true,
    get: function() {
        return $em8BD.EventType;
    }
});

});
parcelRequire.register("em8BD", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
var $a739cbbb3b45cdb2$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $a739cbbb3b45cdb2$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) $a739cbbb3b45cdb2$var$__createBinding(exports, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$a739cbbb3b45cdb2$var$__exportStar((parcelRequire("2Zlej")), module.exports);

$a739cbbb3b45cdb2$var$__exportStar((parcelRequire("d2cEb")), module.exports);

$a739cbbb3b45cdb2$var$__exportStar((parcelRequire("4miFb")), module.exports);

$a739cbbb3b45cdb2$var$__exportStar((parcelRequire("7XuPC")), module.exports);

$a739cbbb3b45cdb2$var$__exportStar((parcelRequire("45Mdb")), module.exports);

$a739cbbb3b45cdb2$var$__exportStar((parcelRequire("gLGSp")), module.exports);

$a739cbbb3b45cdb2$var$__exportStar((parcelRequire("3XP4p")), module.exports);

$a739cbbb3b45cdb2$var$__exportStar((parcelRequire("glQyF")), module.exports);

$a739cbbb3b45cdb2$var$__exportStar((parcelRequire("byGxt")), module.exports);

$a739cbbb3b45cdb2$var$__exportStar((parcelRequire("alsvL")), module.exports);

$a739cbbb3b45cdb2$var$__exportStar((parcelRequire("ktHu6")), module.exports);

$a739cbbb3b45cdb2$var$__exportStar((parcelRequire("3o5CG")), module.exports);

$a739cbbb3b45cdb2$var$__exportStar((parcelRequire("bKZEO")), module.exports);

$a739cbbb3b45cdb2$var$__exportStar((parcelRequire("hBbDf")), module.exports);

$a739cbbb3b45cdb2$var$__exportStar((parcelRequire("9OI2u")), module.exports);

$a739cbbb3b45cdb2$var$__exportStar((parcelRequire("9GQGu")), module.exports);

$a739cbbb3b45cdb2$var$__exportStar((parcelRequire("e8OAG")), module.exports);

$a739cbbb3b45cdb2$var$__exportStar((parcelRequire("1fS66")), module.exports);

$a739cbbb3b45cdb2$var$__exportStar((parcelRequire("aAFov")), module.exports);

$a739cbbb3b45cdb2$var$__exportStar((parcelRequire("49Gwe")), module.exports);

$a739cbbb3b45cdb2$var$__exportStar((parcelRequire("bxo0O")), module.exports);

$a739cbbb3b45cdb2$var$__exportStar((parcelRequire("kSfYh")), module.exports);

$a739cbbb3b45cdb2$var$__exportStar((parcelRequire("cS9Qr")), module.exports);

$a739cbbb3b45cdb2$var$__exportStar((parcelRequire("b3ZaI")), module.exports);

$a739cbbb3b45cdb2$var$__exportStar((parcelRequire("b7UWU")), module.exports);

$a739cbbb3b45cdb2$var$__exportStar((parcelRequire("cTC89")), module.exports);

var $jLUJe = parcelRequire("jLUJe");
Object.defineProperty(module.exports, "TranslationStatus", {
    enumerable: true,
    get: function() {
        return $jLUJe.TranslationStatus;
    }
});

$a739cbbb3b45cdb2$var$__exportStar((parcelRequire("3fguM")), module.exports);

$a739cbbb3b45cdb2$var$__exportStar((parcelRequire("fS9nl")), module.exports);

$a739cbbb3b45cdb2$var$__exportStar((parcelRequire("keosm")), module.exports);

$a739cbbb3b45cdb2$var$__exportStar((parcelRequire("bWDhv")), module.exports);

$a739cbbb3b45cdb2$var$__exportStar((parcelRequire("koGHd")), module.exports);

});
parcelRequire.register("2Zlej", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
var $22d1bf1649912eb2$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.AudioStreamNodeErrorEvent = module.exports.AudioStreamNodeDetachedEvent = module.exports.AudioStreamNodeAttachedEvent = module.exports.AudioStreamNodeAttachingEvent = module.exports.AudioStreamNodeEvent = module.exports.AudioSourceErrorEvent = module.exports.AudioSourceOffEvent = module.exports.AudioSourceReadyEvent = module.exports.AudioSourceInitializingEvent = module.exports.AudioSourceEvent = void 0;

var $bxo0O = parcelRequire("bxo0O");
var $22d1bf1649912eb2$var$AudioSourceEvent = /** @class */ function(_super) {
    $22d1bf1649912eb2$var$__extends(AudioSourceEvent, _super);
    function AudioSourceEvent(eventName, audioSourceId, eventType) {
        if (eventType === void 0) eventType = $bxo0O.EventType.Info;
        var _this = _super.call(this, eventName, eventType) || this;
        _this.privAudioSourceId = audioSourceId;
        return _this;
    }
    Object.defineProperty(AudioSourceEvent.prototype, "audioSourceId", {
        get: function() {
            return this.privAudioSourceId;
        },
        enumerable: false,
        configurable: true
    });
    return AudioSourceEvent;
}($bxo0O.PlatformEvent);
module.exports.AudioSourceEvent = $22d1bf1649912eb2$var$AudioSourceEvent;
var $22d1bf1649912eb2$var$AudioSourceInitializingEvent = /** @class */ function(_super) {
    $22d1bf1649912eb2$var$__extends(AudioSourceInitializingEvent, _super);
    function AudioSourceInitializingEvent(audioSourceId) {
        return _super.call(this, "AudioSourceInitializingEvent", audioSourceId) || this;
    }
    return AudioSourceInitializingEvent;
}($22d1bf1649912eb2$var$AudioSourceEvent);
module.exports.AudioSourceInitializingEvent = $22d1bf1649912eb2$var$AudioSourceInitializingEvent;
var $22d1bf1649912eb2$var$AudioSourceReadyEvent = /** @class */ function(_super) {
    $22d1bf1649912eb2$var$__extends(AudioSourceReadyEvent, _super);
    function AudioSourceReadyEvent(audioSourceId) {
        return _super.call(this, "AudioSourceReadyEvent", audioSourceId) || this;
    }
    return AudioSourceReadyEvent;
}($22d1bf1649912eb2$var$AudioSourceEvent);
module.exports.AudioSourceReadyEvent = $22d1bf1649912eb2$var$AudioSourceReadyEvent;
var $22d1bf1649912eb2$var$AudioSourceOffEvent = /** @class */ function(_super) {
    $22d1bf1649912eb2$var$__extends(AudioSourceOffEvent, _super);
    function AudioSourceOffEvent(audioSourceId) {
        return _super.call(this, "AudioSourceOffEvent", audioSourceId) || this;
    }
    return AudioSourceOffEvent;
}($22d1bf1649912eb2$var$AudioSourceEvent);
module.exports.AudioSourceOffEvent = $22d1bf1649912eb2$var$AudioSourceOffEvent;
var $22d1bf1649912eb2$var$AudioSourceErrorEvent = /** @class */ function(_super) {
    $22d1bf1649912eb2$var$__extends(AudioSourceErrorEvent, _super);
    function AudioSourceErrorEvent(audioSourceId, error) {
        var _this = _super.call(this, "AudioSourceErrorEvent", audioSourceId, $bxo0O.EventType.Error) || this;
        _this.privError = error;
        return _this;
    }
    Object.defineProperty(AudioSourceErrorEvent.prototype, "error", {
        get: function() {
            return this.privError;
        },
        enumerable: false,
        configurable: true
    });
    return AudioSourceErrorEvent;
}($22d1bf1649912eb2$var$AudioSourceEvent);
module.exports.AudioSourceErrorEvent = $22d1bf1649912eb2$var$AudioSourceErrorEvent;
var $22d1bf1649912eb2$var$AudioStreamNodeEvent = /** @class */ function(_super) {
    $22d1bf1649912eb2$var$__extends(AudioStreamNodeEvent, _super);
    function AudioStreamNodeEvent(eventName, audioSourceId, audioNodeId) {
        var _this = _super.call(this, eventName, audioSourceId) || this;
        _this.privAudioNodeId = audioNodeId;
        return _this;
    }
    Object.defineProperty(AudioStreamNodeEvent.prototype, "audioNodeId", {
        get: function() {
            return this.privAudioNodeId;
        },
        enumerable: false,
        configurable: true
    });
    return AudioStreamNodeEvent;
}($22d1bf1649912eb2$var$AudioSourceEvent);
module.exports.AudioStreamNodeEvent = $22d1bf1649912eb2$var$AudioStreamNodeEvent;
var $22d1bf1649912eb2$var$AudioStreamNodeAttachingEvent = /** @class */ function(_super) {
    $22d1bf1649912eb2$var$__extends(AudioStreamNodeAttachingEvent, _super);
    function AudioStreamNodeAttachingEvent(audioSourceId, audioNodeId) {
        return _super.call(this, "AudioStreamNodeAttachingEvent", audioSourceId, audioNodeId) || this;
    }
    return AudioStreamNodeAttachingEvent;
}($22d1bf1649912eb2$var$AudioStreamNodeEvent);
module.exports.AudioStreamNodeAttachingEvent = $22d1bf1649912eb2$var$AudioStreamNodeAttachingEvent;
var $22d1bf1649912eb2$var$AudioStreamNodeAttachedEvent = /** @class */ function(_super) {
    $22d1bf1649912eb2$var$__extends(AudioStreamNodeAttachedEvent, _super);
    function AudioStreamNodeAttachedEvent(audioSourceId, audioNodeId) {
        return _super.call(this, "AudioStreamNodeAttachedEvent", audioSourceId, audioNodeId) || this;
    }
    return AudioStreamNodeAttachedEvent;
}($22d1bf1649912eb2$var$AudioStreamNodeEvent);
module.exports.AudioStreamNodeAttachedEvent = $22d1bf1649912eb2$var$AudioStreamNodeAttachedEvent;
var $22d1bf1649912eb2$var$AudioStreamNodeDetachedEvent = /** @class */ function(_super) {
    $22d1bf1649912eb2$var$__extends(AudioStreamNodeDetachedEvent, _super);
    function AudioStreamNodeDetachedEvent(audioSourceId, audioNodeId) {
        return _super.call(this, "AudioStreamNodeDetachedEvent", audioSourceId, audioNodeId) || this;
    }
    return AudioStreamNodeDetachedEvent;
}($22d1bf1649912eb2$var$AudioStreamNodeEvent);
module.exports.AudioStreamNodeDetachedEvent = $22d1bf1649912eb2$var$AudioStreamNodeDetachedEvent;
var $22d1bf1649912eb2$var$AudioStreamNodeErrorEvent = /** @class */ function(_super) {
    $22d1bf1649912eb2$var$__extends(AudioStreamNodeErrorEvent, _super);
    function AudioStreamNodeErrorEvent(audioSourceId, audioNodeId, error) {
        var _this = _super.call(this, "AudioStreamNodeErrorEvent", audioSourceId, audioNodeId) || this;
        _this.privError = error;
        return _this;
    }
    Object.defineProperty(AudioStreamNodeErrorEvent.prototype, "error", {
        get: function() {
            return this.privError;
        },
        enumerable: false,
        configurable: true
    });
    return AudioStreamNodeErrorEvent;
}($22d1bf1649912eb2$var$AudioStreamNodeEvent);
module.exports.AudioStreamNodeErrorEvent = $22d1bf1649912eb2$var$AudioStreamNodeErrorEvent;

});
parcelRequire.register("bxo0O", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PlatformEvent = module.exports.EventType = void 0;

var $alsvL = parcelRequire("alsvL");
var $866567150cfead04$var$EventType;
(function(EventType) {
    EventType[EventType["Debug"] = 0] = "Debug";
    EventType[EventType["Info"] = 1] = "Info";
    EventType[EventType["Warning"] = 2] = "Warning";
    EventType[EventType["Error"] = 3] = "Error";
    EventType[EventType["None"] = 4] = "None";
})($866567150cfead04$var$EventType = module.exports.EventType || (module.exports.EventType = {}));
var $866567150cfead04$var$PlatformEvent = /** @class */ function() {
    function PlatformEvent(eventName, eventType) {
        this.privName = eventName;
        this.privEventId = $alsvL.createNoDashGuid();
        this.privEventTime = new Date().toISOString();
        this.privEventType = eventType;
        this.privMetadata = {};
    }
    Object.defineProperty(PlatformEvent.prototype, "name", {
        get: function() {
            return this.privName;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PlatformEvent.prototype, "eventId", {
        get: function() {
            return this.privEventId;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PlatformEvent.prototype, "eventTime", {
        get: function() {
            return this.privEventTime;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PlatformEvent.prototype, "eventType", {
        get: function() {
            return this.privEventType;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PlatformEvent.prototype, "metadata", {
        get: function() {
            return this.privMetadata;
        },
        enumerable: false,
        configurable: true
    });
    return PlatformEvent;
}();
module.exports.PlatformEvent = $866567150cfead04$var$PlatformEvent;

});
parcelRequire.register("alsvL", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.createNoDashGuid = module.exports.createGuid = void 0;

var $02MKj = parcelRequire("02MKj");
var $7881fb4fbdeac6f0$var$createGuid = function() {
    return $02MKj.default();
};
module.exports.createGuid = $7881fb4fbdeac6f0$var$createGuid;
var $7881fb4fbdeac6f0$var$createNoDashGuid = function() {
    return $7881fb4fbdeac6f0$var$createGuid().replace(new RegExp("-", "g"), "").toUpperCase();
};
module.exports.createNoDashGuid = $7881fb4fbdeac6f0$var$createNoDashGuid;

});
parcelRequire.register("02MKj", function(module, exports) {

$parcel$export(module.exports, "default", () => $0085fffaec5d42ea$export$2e2bcd8739ae039);

var $dNcCo = parcelRequire("dNcCo");

var $elWzI = parcelRequire("elWzI");

var $7vjIs = parcelRequire("7vjIs");
function $0085fffaec5d42ea$var$v4(options, buf, offset) {
    if ((0, $dNcCo.default).randomUUID && !buf && !options) return (0, $dNcCo.default).randomUUID();
    options = options || {};
    const rnds = options.random || (options.rng || (0, $elWzI.default))(); // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80; // Copy bytes to buffer, if provided
    if (buf) {
        offset = offset || 0;
        for(let i = 0; i < 16; ++i)buf[offset + i] = rnds[i];
        return buf;
    }
    return (0, $7vjIs.unsafeStringify)(rnds);
}
var $0085fffaec5d42ea$export$2e2bcd8739ae039 = $0085fffaec5d42ea$var$v4;

});
parcelRequire.register("dNcCo", function(module, exports) {

$parcel$export(module.exports, "default", () => $a0a9a3af24049777$export$2e2bcd8739ae039);
const $a0a9a3af24049777$var$randomUUID = typeof crypto !== "undefined" && crypto.randomUUID && crypto.randomUUID.bind(crypto);
var $a0a9a3af24049777$export$2e2bcd8739ae039 = {
    randomUUID: $a0a9a3af24049777$var$randomUUID
};

});

parcelRequire.register("elWzI", function(module, exports) {

$parcel$export(module.exports, "default", () => $a73076a9b9e20d64$export$2e2bcd8739ae039);
// Unique ID creation requires a high quality random # generator. In the browser we therefore
// require the crypto API and do not support built-in fallback to lower quality random number
// generators (like Math.random()).
let $a73076a9b9e20d64$var$getRandomValues;
const $a73076a9b9e20d64$var$rnds8 = new Uint8Array(16);
function $a73076a9b9e20d64$export$2e2bcd8739ae039() {
    // lazy load so that environments that need to polyfill have a chance to do so
    if (!$a73076a9b9e20d64$var$getRandomValues) {
        // getRandomValues needs to be invoked in a context where "this" is a Crypto implementation.
        $a73076a9b9e20d64$var$getRandomValues = typeof crypto !== "undefined" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto);
        if (!$a73076a9b9e20d64$var$getRandomValues) throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
    }
    return $a73076a9b9e20d64$var$getRandomValues($a73076a9b9e20d64$var$rnds8);
}

});

parcelRequire.register("7vjIs", function(module, exports) {

$parcel$export(module.exports, "unsafeStringify", () => $0168f277115bb08e$export$8fb373d660548968);

var $cb4wt = parcelRequire("cb4wt");
/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */ const $0168f277115bb08e$var$byteToHex = [];
for(let i = 0; i < 256; ++i)$0168f277115bb08e$var$byteToHex.push((i + 0x100).toString(16).slice(1));
function $0168f277115bb08e$export$8fb373d660548968(arr, offset = 0) {
    // Note: Be careful editing this code!  It's been tuned for performance
    // and works in ways you may not expect. See https://github.com/uuidjs/uuid/pull/434
    return ($0168f277115bb08e$var$byteToHex[arr[offset + 0]] + $0168f277115bb08e$var$byteToHex[arr[offset + 1]] + $0168f277115bb08e$var$byteToHex[arr[offset + 2]] + $0168f277115bb08e$var$byteToHex[arr[offset + 3]] + "-" + $0168f277115bb08e$var$byteToHex[arr[offset + 4]] + $0168f277115bb08e$var$byteToHex[arr[offset + 5]] + "-" + $0168f277115bb08e$var$byteToHex[arr[offset + 6]] + $0168f277115bb08e$var$byteToHex[arr[offset + 7]] + "-" + $0168f277115bb08e$var$byteToHex[arr[offset + 8]] + $0168f277115bb08e$var$byteToHex[arr[offset + 9]] + "-" + $0168f277115bb08e$var$byteToHex[arr[offset + 10]] + $0168f277115bb08e$var$byteToHex[arr[offset + 11]] + $0168f277115bb08e$var$byteToHex[arr[offset + 12]] + $0168f277115bb08e$var$byteToHex[arr[offset + 13]] + $0168f277115bb08e$var$byteToHex[arr[offset + 14]] + $0168f277115bb08e$var$byteToHex[arr[offset + 15]]).toLowerCase();
}
function $0168f277115bb08e$var$stringify(arr, offset = 0) {
    const uuid = $0168f277115bb08e$export$8fb373d660548968(arr, offset); // Consistency check for valid UUID.  If this throws, it's likely due to one
    // of the following:
    // - One or more input array values don't map to a hex octet (leading to
    // "undefined" in the uuid)
    // - Invalid input values for the RFC `version` or `variant` fields
    if (!(0, $cb4wt.default)(uuid)) throw TypeError("Stringified UUID is invalid");
    return uuid;
}
var $0168f277115bb08e$export$2e2bcd8739ae039 = $0168f277115bb08e$var$stringify;

});
parcelRequire.register("cb4wt", function(module, exports) {

$parcel$export(module.exports, "default", () => $8dda0542ddcc0a84$export$2e2bcd8739ae039);

var $ffqyO = parcelRequire("ffqyO");
function $8dda0542ddcc0a84$var$validate(uuid) {
    return typeof uuid === "string" && (0, $ffqyO.default).test(uuid);
}
var $8dda0542ddcc0a84$export$2e2bcd8739ae039 = $8dda0542ddcc0a84$var$validate;

});
parcelRequire.register("ffqyO", function(module, exports) {

$parcel$export(module.exports, "default", () => $b19cdc1441096ca7$export$2e2bcd8739ae039);
var $b19cdc1441096ca7$export$2e2bcd8739ae039 = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;

});







parcelRequire.register("d2cEb", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
var $97d545b8619e6e40$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ConnectionMessageSentEvent = module.exports.ConnectionMessageReceivedEvent = module.exports.ConnectionEstablishErrorEvent = module.exports.ConnectionErrorEvent = module.exports.ConnectionClosedEvent = module.exports.ConnectionEstablishedEvent = module.exports.ConnectionStartEvent = module.exports.ConnectionEvent = module.exports.ServiceEvent = void 0;

var $bxo0O = parcelRequire("bxo0O");
var $97d545b8619e6e40$var$ServiceEvent = /** @class */ function(_super) {
    $97d545b8619e6e40$var$__extends(ServiceEvent, _super);
    function ServiceEvent(eventName, jsonstring, eventType) {
        if (eventType === void 0) eventType = $bxo0O.EventType.Info;
        var _this = _super.call(this, eventName, eventType) || this;
        _this.privJsonResult = jsonstring;
        return _this;
    }
    Object.defineProperty(ServiceEvent.prototype, "jsonString", {
        get: function() {
            return this.privJsonResult;
        },
        enumerable: false,
        configurable: true
    });
    return ServiceEvent;
}($bxo0O.PlatformEvent);
module.exports.ServiceEvent = $97d545b8619e6e40$var$ServiceEvent;
var $97d545b8619e6e40$var$ConnectionEvent = /** @class */ function(_super) {
    $97d545b8619e6e40$var$__extends(ConnectionEvent, _super);
    function ConnectionEvent(eventName, connectionId, eventType) {
        if (eventType === void 0) eventType = $bxo0O.EventType.Info;
        var _this = _super.call(this, eventName, eventType) || this;
        _this.privConnectionId = connectionId;
        return _this;
    }
    Object.defineProperty(ConnectionEvent.prototype, "connectionId", {
        get: function() {
            return this.privConnectionId;
        },
        enumerable: false,
        configurable: true
    });
    return ConnectionEvent;
}($bxo0O.PlatformEvent);
module.exports.ConnectionEvent = $97d545b8619e6e40$var$ConnectionEvent;
var $97d545b8619e6e40$var$ConnectionStartEvent = /** @class */ function(_super) {
    $97d545b8619e6e40$var$__extends(ConnectionStartEvent, _super);
    function ConnectionStartEvent(connectionId, uri, headers) {
        var _this = _super.call(this, "ConnectionStartEvent", connectionId) || this;
        _this.privUri = uri;
        _this.privHeaders = headers;
        return _this;
    }
    Object.defineProperty(ConnectionStartEvent.prototype, "uri", {
        get: function() {
            return this.privUri;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ConnectionStartEvent.prototype, "headers", {
        get: function() {
            return this.privHeaders;
        },
        enumerable: false,
        configurable: true
    });
    return ConnectionStartEvent;
}($97d545b8619e6e40$var$ConnectionEvent);
module.exports.ConnectionStartEvent = $97d545b8619e6e40$var$ConnectionStartEvent;
var $97d545b8619e6e40$var$ConnectionEstablishedEvent = /** @class */ function(_super) {
    $97d545b8619e6e40$var$__extends(ConnectionEstablishedEvent, _super);
    function ConnectionEstablishedEvent(connectionId) {
        return _super.call(this, "ConnectionEstablishedEvent", connectionId) || this;
    }
    return ConnectionEstablishedEvent;
}($97d545b8619e6e40$var$ConnectionEvent);
module.exports.ConnectionEstablishedEvent = $97d545b8619e6e40$var$ConnectionEstablishedEvent;
var $97d545b8619e6e40$var$ConnectionClosedEvent = /** @class */ function(_super) {
    $97d545b8619e6e40$var$__extends(ConnectionClosedEvent, _super);
    function ConnectionClosedEvent(connectionId, statusCode, reason) {
        var _this = _super.call(this, "ConnectionClosedEvent", connectionId, $bxo0O.EventType.Debug) || this;
        _this.privReason = reason;
        _this.privStatusCode = statusCode;
        return _this;
    }
    Object.defineProperty(ConnectionClosedEvent.prototype, "reason", {
        get: function() {
            return this.privReason;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ConnectionClosedEvent.prototype, "statusCode", {
        get: function() {
            return this.privStatusCode;
        },
        enumerable: false,
        configurable: true
    });
    return ConnectionClosedEvent;
}($97d545b8619e6e40$var$ConnectionEvent);
module.exports.ConnectionClosedEvent = $97d545b8619e6e40$var$ConnectionClosedEvent;
var $97d545b8619e6e40$var$ConnectionErrorEvent = /** @class */ function(_super) {
    $97d545b8619e6e40$var$__extends(ConnectionErrorEvent, _super);
    function ConnectionErrorEvent(connectionId, message, type) {
        var _this = _super.call(this, "ConnectionErrorEvent", connectionId, $bxo0O.EventType.Debug) || this;
        _this.privMessage = message;
        _this.privType = type;
        return _this;
    }
    Object.defineProperty(ConnectionErrorEvent.prototype, "message", {
        get: function() {
            return this.privMessage;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ConnectionErrorEvent.prototype, "type", {
        get: function() {
            return this.privType;
        },
        enumerable: false,
        configurable: true
    });
    return ConnectionErrorEvent;
}($97d545b8619e6e40$var$ConnectionEvent);
module.exports.ConnectionErrorEvent = $97d545b8619e6e40$var$ConnectionErrorEvent;
var $97d545b8619e6e40$var$ConnectionEstablishErrorEvent = /** @class */ function(_super) {
    $97d545b8619e6e40$var$__extends(ConnectionEstablishErrorEvent, _super);
    function ConnectionEstablishErrorEvent(connectionId, statuscode, reason) {
        var _this = _super.call(this, "ConnectionEstablishErrorEvent", connectionId, $bxo0O.EventType.Error) || this;
        _this.privStatusCode = statuscode;
        _this.privReason = reason;
        return _this;
    }
    Object.defineProperty(ConnectionEstablishErrorEvent.prototype, "reason", {
        get: function() {
            return this.privReason;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ConnectionEstablishErrorEvent.prototype, "statusCode", {
        get: function() {
            return this.privStatusCode;
        },
        enumerable: false,
        configurable: true
    });
    return ConnectionEstablishErrorEvent;
}($97d545b8619e6e40$var$ConnectionEvent);
module.exports.ConnectionEstablishErrorEvent = $97d545b8619e6e40$var$ConnectionEstablishErrorEvent;
var $97d545b8619e6e40$var$ConnectionMessageReceivedEvent = /** @class */ function(_super) {
    $97d545b8619e6e40$var$__extends(ConnectionMessageReceivedEvent, _super);
    function ConnectionMessageReceivedEvent(connectionId, networkReceivedTimeISO, message) {
        var _this = _super.call(this, "ConnectionMessageReceivedEvent", connectionId) || this;
        _this.privNetworkReceivedTime = networkReceivedTimeISO;
        _this.privMessage = message;
        return _this;
    }
    Object.defineProperty(ConnectionMessageReceivedEvent.prototype, "networkReceivedTime", {
        get: function() {
            return this.privNetworkReceivedTime;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ConnectionMessageReceivedEvent.prototype, "message", {
        get: function() {
            return this.privMessage;
        },
        enumerable: false,
        configurable: true
    });
    return ConnectionMessageReceivedEvent;
}($97d545b8619e6e40$var$ConnectionEvent);
module.exports.ConnectionMessageReceivedEvent = $97d545b8619e6e40$var$ConnectionMessageReceivedEvent;
var $97d545b8619e6e40$var$ConnectionMessageSentEvent = /** @class */ function(_super) {
    $97d545b8619e6e40$var$__extends(ConnectionMessageSentEvent, _super);
    function ConnectionMessageSentEvent(connectionId, networkSentTimeISO, message) {
        var _this = _super.call(this, "ConnectionMessageSentEvent", connectionId) || this;
        _this.privNetworkSentTime = networkSentTimeISO;
        _this.privMessage = message;
        return _this;
    }
    Object.defineProperty(ConnectionMessageSentEvent.prototype, "networkSentTime", {
        get: function() {
            return this.privNetworkSentTime;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ConnectionMessageSentEvent.prototype, "message", {
        get: function() {
            return this.privMessage;
        },
        enumerable: false,
        configurable: true
    });
    return ConnectionMessageSentEvent;
}($97d545b8619e6e40$var$ConnectionEvent);
module.exports.ConnectionMessageSentEvent = $97d545b8619e6e40$var$ConnectionMessageSentEvent;

});

parcelRequire.register("4miFb", function(module, exports) {
"use strict";
/* eslint-disable @typescript-eslint/no-unsafe-return */ // Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ConnectionMessage = module.exports.MessageType = void 0;

var $3XP4p = parcelRequire("3XP4p");

var $alsvL = parcelRequire("alsvL");
var $32c7b19db82b6aed$var$MessageType;
(function(MessageType) {
    MessageType[MessageType["Text"] = 0] = "Text";
    MessageType[MessageType["Binary"] = 1] = "Binary";
})($32c7b19db82b6aed$var$MessageType = module.exports.MessageType || (module.exports.MessageType = {}));
var $32c7b19db82b6aed$var$ConnectionMessage = /** @class */ function() {
    function ConnectionMessage(messageType, body, headers, id) {
        this.privBody = null;
        if (messageType === $32c7b19db82b6aed$var$MessageType.Text && body && !(typeof body === "string")) throw new $3XP4p.InvalidOperationError("Payload must be a string");
        if (messageType === $32c7b19db82b6aed$var$MessageType.Binary && body && !(body instanceof ArrayBuffer)) throw new $3XP4p.InvalidOperationError("Payload must be ArrayBuffer");
        this.privMessageType = messageType;
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        this.privBody = body;
        this.privHeaders = headers ? headers : {};
        this.privId = id ? id : $alsvL.createNoDashGuid();
        switch(this.messageType){
            case $32c7b19db82b6aed$var$MessageType.Binary:
                this.privSize = this.binaryBody !== null ? this.binaryBody.byteLength : 0;
                break;
            case $32c7b19db82b6aed$var$MessageType.Text:
                this.privSize = this.textBody.length;
        }
    }
    Object.defineProperty(ConnectionMessage.prototype, "messageType", {
        get: function() {
            return this.privMessageType;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ConnectionMessage.prototype, "headers", {
        get: function() {
            return this.privHeaders;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ConnectionMessage.prototype, "body", {
        get: function() {
            return this.privBody;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ConnectionMessage.prototype, "textBody", {
        get: function() {
            if (this.privMessageType === $32c7b19db82b6aed$var$MessageType.Binary) throw new $3XP4p.InvalidOperationError("Not supported for binary message");
            return this.privBody;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ConnectionMessage.prototype, "binaryBody", {
        get: function() {
            if (this.privMessageType === $32c7b19db82b6aed$var$MessageType.Text) throw new $3XP4p.InvalidOperationError("Not supported for text message");
            return this.privBody;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ConnectionMessage.prototype, "id", {
        get: function() {
            return this.privId;
        },
        enumerable: false,
        configurable: true
    });
    return ConnectionMessage;
}();
module.exports.ConnectionMessage = $32c7b19db82b6aed$var$ConnectionMessage;

});
parcelRequire.register("3XP4p", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
var $2e2e7f443370c579$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ObjectDisposedError = module.exports.InvalidOperationError = module.exports.ArgumentNullError = void 0;
/* eslint-disable max-classes-per-file */ /**
 * The error that is thrown when an argument passed in is null.
 *
 * @export
 * @class ArgumentNullError
 * @extends {Error}
 */ var $2e2e7f443370c579$var$ArgumentNullError = /** @class */ function(_super) {
    $2e2e7f443370c579$var$__extends(ArgumentNullError, _super);
    /**
     * Creates an instance of ArgumentNullError.
     *
     * @param {string} argumentName - Name of the argument that is null
     *
     * @memberOf ArgumentNullError
     */ function ArgumentNullError(argumentName) {
        var _this = _super.call(this, argumentName) || this;
        _this.name = "ArgumentNull";
        _this.message = argumentName;
        return _this;
    }
    return ArgumentNullError;
}(Error);
module.exports.ArgumentNullError = $2e2e7f443370c579$var$ArgumentNullError;
/**
 * The error that is thrown when an invalid operation is performed in the code.
 *
 * @export
 * @class InvalidOperationError
 * @extends {Error}
 */ var $2e2e7f443370c579$var$InvalidOperationError = /** @class */ function(_super) {
    $2e2e7f443370c579$var$__extends(InvalidOperationError, _super);
    /**
     * Creates an instance of InvalidOperationError.
     *
     * @param {string} error - The error
     *
     * @memberOf InvalidOperationError
     */ function InvalidOperationError(error) {
        var _this = _super.call(this, error) || this;
        _this.name = "InvalidOperation";
        _this.message = error;
        return _this;
    }
    return InvalidOperationError;
}(Error);
module.exports.InvalidOperationError = $2e2e7f443370c579$var$InvalidOperationError;
/**
 * The error that is thrown when an object is disposed.
 *
 * @export
 * @class ObjectDisposedError
 * @extends {Error}
 */ var $2e2e7f443370c579$var$ObjectDisposedError = /** @class */ function(_super) {
    $2e2e7f443370c579$var$__extends(ObjectDisposedError, _super);
    /**
     * Creates an instance of ObjectDisposedError.
     *
     * @param {string} objectName - The object that is disposed
     * @param {string} error - The error
     *
     * @memberOf ObjectDisposedError
     */ function ObjectDisposedError(objectName, error) {
        var _this = _super.call(this, error) || this;
        _this.name = objectName + "ObjectDisposed";
        _this.message = error;
        return _this;
    }
    return ObjectDisposedError;
}(Error);
module.exports.ObjectDisposedError = $2e2e7f443370c579$var$ObjectDisposedError;

});


parcelRequire.register("7XuPC", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ConnectionOpenResponse = void 0;
var $5cb5f59613663672$var$ConnectionOpenResponse = /** @class */ function() {
    function ConnectionOpenResponse(statusCode, reason) {
        this.privStatusCode = statusCode;
        this.privReason = reason;
    }
    Object.defineProperty(ConnectionOpenResponse.prototype, "statusCode", {
        get: function() {
            return this.privStatusCode;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ConnectionOpenResponse.prototype, "reason", {
        get: function() {
            return this.privReason;
        },
        enumerable: false,
        configurable: true
    });
    return ConnectionOpenResponse;
}();
module.exports.ConnectionOpenResponse = $5cb5f59613663672$var$ConnectionOpenResponse;

});

parcelRequire.register("45Mdb", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DeferralMap = void 0;
/**
 * The error that is thrown when an argument passed in is null.
 *
 * @export
 * @class DefferalMap
 */ var $2fad06de631eb18a$var$DeferralMap = /** @class */ function() {
    function DeferralMap() {
        this.privMap = {};
    }
    DeferralMap.prototype.add = function(id, deferral) {
        this.privMap[id] = deferral;
    };
    DeferralMap.prototype.getId = function(id) {
        return this.privMap[id];
    };
    DeferralMap.prototype.complete = function(id, result) {
        try {
            this.privMap[id].resolve(result);
        } catch (error) {
            this.privMap[id].reject(error);
        } finally{
            this.privMap[id] = undefined;
        }
    };
    return DeferralMap;
}();
module.exports.DeferralMap = $2fad06de631eb18a$var$DeferralMap;

});

parcelRequire.register("gLGSp", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
var $c3524b8828c34bda$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SendingAgentContextMessageEvent = module.exports.DialogEvent = void 0;

var $bxo0O = parcelRequire("bxo0O");
var $c3524b8828c34bda$var$DialogEvent = /** @class */ function(_super) {
    $c3524b8828c34bda$var$__extends(DialogEvent, _super);
    function DialogEvent(eventName, eventType) {
        if (eventType === void 0) eventType = $bxo0O.EventType.Info;
        return _super.call(this, eventName, eventType) || this;
    }
    return DialogEvent;
}($bxo0O.PlatformEvent);
module.exports.DialogEvent = $c3524b8828c34bda$var$DialogEvent;
var $c3524b8828c34bda$var$SendingAgentContextMessageEvent = /** @class */ function(_super) {
    $c3524b8828c34bda$var$__extends(SendingAgentContextMessageEvent, _super);
    function SendingAgentContextMessageEvent(agentConfig) {
        var _this = _super.call(this, "SendingAgentContextMessageEvent") || this;
        _this.privAgentConfig = agentConfig;
        return _this;
    }
    Object.defineProperty(SendingAgentContextMessageEvent.prototype, "agentConfig", {
        get: function() {
            return this.privAgentConfig;
        },
        enumerable: false,
        configurable: true
    });
    return SendingAgentContextMessageEvent;
}($c3524b8828c34bda$var$DialogEvent);
module.exports.SendingAgentContextMessageEvent = $c3524b8828c34bda$var$SendingAgentContextMessageEvent;

});

parcelRequire.register("glQyF", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Events = void 0;

var $3XP4p = parcelRequire("3XP4p");

var $byGxt = parcelRequire("byGxt");
var $be776075196b8860$var$Events = /** @class */ function() {
    function Events() {}
    Events.setEventSource = function(eventSource) {
        if (!eventSource) throw new $3XP4p.ArgumentNullError("eventSource");
        Events.privInstance = eventSource;
    };
    Object.defineProperty(Events, "instance", {
        get: function() {
            return Events.privInstance;
        },
        enumerable: false,
        configurable: true
    });
    Events.privInstance = new $byGxt.EventSource();
    return Events;
}();
module.exports.Events = $be776075196b8860$var$Events;

});
parcelRequire.register("byGxt", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.EventSource = void 0;

var $3XP4p = parcelRequire("3XP4p");

var $alsvL = parcelRequire("alsvL");
var $86a3de0aea8f8d84$var$EventSource = /** @class */ function() {
    function EventSource(metadata) {
        this.privEventListeners = {};
        this.privIsDisposed = false;
        this.privConsoleListener = undefined;
        this.privMetadata = metadata;
    }
    EventSource.prototype.onEvent = function(event) {
        if (this.isDisposed()) throw new $3XP4p.ObjectDisposedError("EventSource");
        if (this.metadata) {
            for(var paramName in this.metadata)if (paramName) {
                if (event.metadata) {
                    if (!event.metadata[paramName]) event.metadata[paramName] = this.metadata[paramName];
                }
            }
        }
        for(var eventId in this.privEventListeners)if (eventId && this.privEventListeners[eventId]) this.privEventListeners[eventId](event);
    };
    EventSource.prototype.attach = function(onEventCallback) {
        var _this = this;
        var id = $alsvL.createNoDashGuid();
        this.privEventListeners[id] = onEventCallback;
        return {
            detach: function() {
                delete _this.privEventListeners[id];
                return Promise.resolve();
            }
        };
    };
    EventSource.prototype.attachListener = function(listener) {
        return this.attach(function(e) {
            return listener.onEvent(e);
        });
    };
    EventSource.prototype.attachConsoleListener = function(listener) {
        if (!!this.privConsoleListener) this.privConsoleListener.detach(); // Detach implementation for eventListeners is synchronous
        this.privConsoleListener = this.attach(function(e) {
            return listener.onEvent(e);
        });
        return this.privConsoleListener;
    };
    EventSource.prototype.isDisposed = function() {
        return this.privIsDisposed;
    };
    EventSource.prototype.dispose = function() {
        this.privEventListeners = null;
        this.privIsDisposed = true;
    };
    Object.defineProperty(EventSource.prototype, "metadata", {
        get: function() {
            return this.privMetadata;
        },
        enumerable: false,
        configurable: true
    });
    return EventSource;
}();
module.exports.EventSource = $86a3de0aea8f8d84$var$EventSource;

});


parcelRequire.register("ktHu6", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRequire.register("3o5CG", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ConnectionState = void 0;
var $2777f999f88e6008$var$ConnectionState;
(function(ConnectionState) {
    ConnectionState[ConnectionState["None"] = 0] = "None";
    ConnectionState[ConnectionState["Connected"] = 1] = "Connected";
    ConnectionState[ConnectionState["Connecting"] = 2] = "Connecting";
    ConnectionState[ConnectionState["Disconnected"] = 3] = "Disconnected";
})($2777f999f88e6008$var$ConnectionState = module.exports.ConnectionState || (module.exports.ConnectionState = {}));

});

parcelRequire.register("bKZEO", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRequire.register("hBbDf", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRequire.register("9OI2u", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRequire.register("9GQGu", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRequire.register("e8OAG", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRequire.register("1fS66", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRequire.register("aAFov", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRequire.register("49Gwe", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.List = void 0;

var $3XP4p = parcelRequire("3XP4p");
var $3068fc075f3c7479$var$List = /** @class */ function() {
    function List(list) {
        this.privSubscriptionIdCounter = 0;
        this.privAddSubscriptions = {};
        this.privRemoveSubscriptions = {};
        this.privDisposedSubscriptions = {};
        this.privDisposeReason = null;
        this.privList = [];
        // copy the list rather than taking as is.
        if (list) for(var _i = 0, list_1 = list; _i < list_1.length; _i++){
            var item = list_1[_i];
            this.privList.push(item);
        }
    }
    List.prototype.get = function(itemIndex) {
        this.throwIfDisposed();
        return this.privList[itemIndex];
    };
    List.prototype.first = function() {
        return this.get(0);
    };
    List.prototype.last = function() {
        return this.get(this.length() - 1);
    };
    List.prototype.add = function(item) {
        this.throwIfDisposed();
        this.insertAt(this.privList.length, item);
    };
    List.prototype.insertAt = function(index, item) {
        this.throwIfDisposed();
        if (index === 0) this.privList.unshift(item);
        else if (index === this.privList.length) this.privList.push(item);
        else this.privList.splice(index, 0, item);
        this.triggerSubscriptions(this.privAddSubscriptions);
    };
    List.prototype.removeFirst = function() {
        this.throwIfDisposed();
        return this.removeAt(0);
    };
    List.prototype.removeLast = function() {
        this.throwIfDisposed();
        return this.removeAt(this.length() - 1);
    };
    List.prototype.removeAt = function(index) {
        this.throwIfDisposed();
        return this.remove(index, 1)[0];
    };
    List.prototype.remove = function(index, count) {
        this.throwIfDisposed();
        var removedElements = this.privList.splice(index, count);
        this.triggerSubscriptions(this.privRemoveSubscriptions);
        return removedElements;
    };
    List.prototype.clear = function() {
        this.throwIfDisposed();
        this.remove(0, this.length());
    };
    List.prototype.length = function() {
        this.throwIfDisposed();
        return this.privList.length;
    };
    List.prototype.onAdded = function(addedCallback) {
        var _this = this;
        this.throwIfDisposed();
        var subscriptionId = this.privSubscriptionIdCounter++;
        this.privAddSubscriptions[subscriptionId] = addedCallback;
        return {
            detach: function() {
                delete _this.privAddSubscriptions[subscriptionId];
                return Promise.resolve();
            }
        };
    };
    List.prototype.onRemoved = function(removedCallback) {
        var _this = this;
        this.throwIfDisposed();
        var subscriptionId = this.privSubscriptionIdCounter++;
        this.privRemoveSubscriptions[subscriptionId] = removedCallback;
        return {
            detach: function() {
                delete _this.privRemoveSubscriptions[subscriptionId];
                return Promise.resolve();
            }
        };
    };
    List.prototype.onDisposed = function(disposedCallback) {
        var _this = this;
        this.throwIfDisposed();
        var subscriptionId = this.privSubscriptionIdCounter++;
        this.privDisposedSubscriptions[subscriptionId] = disposedCallback;
        return {
            detach: function() {
                delete _this.privDisposedSubscriptions[subscriptionId];
                return Promise.resolve();
            }
        };
    };
    List.prototype.join = function(seperator) {
        this.throwIfDisposed();
        return this.privList.join(seperator);
    };
    List.prototype.toArray = function() {
        var cloneCopy = Array();
        this.privList.forEach(function(val) {
            cloneCopy.push(val);
        });
        return cloneCopy;
    };
    List.prototype.any = function(callback) {
        this.throwIfDisposed();
        if (callback) return this.where(callback).length() > 0;
        else return this.length() > 0;
    };
    List.prototype.all = function(callback) {
        this.throwIfDisposed();
        return this.where(callback).length() === this.length();
    };
    List.prototype.forEach = function(callback) {
        this.throwIfDisposed();
        for(var i = 0; i < this.length(); i++)callback(this.privList[i], i);
    };
    List.prototype.select = function(callback) {
        this.throwIfDisposed();
        var selectList = [];
        for(var i = 0; i < this.privList.length; i++)selectList.push(callback(this.privList[i], i));
        return new List(selectList);
    };
    List.prototype.where = function(callback) {
        this.throwIfDisposed();
        var filteredList = new List();
        for(var i = 0; i < this.privList.length; i++)if (callback(this.privList[i], i)) filteredList.add(this.privList[i]);
        return filteredList;
    };
    List.prototype.orderBy = function(compareFn) {
        this.throwIfDisposed();
        var clonedArray = this.toArray();
        var orderedArray = clonedArray.sort(compareFn);
        return new List(orderedArray);
    };
    List.prototype.orderByDesc = function(compareFn) {
        this.throwIfDisposed();
        return this.orderBy(function(a, b) {
            return compareFn(b, a);
        });
    };
    List.prototype.clone = function() {
        this.throwIfDisposed();
        return new List(this.toArray());
    };
    List.prototype.concat = function(list) {
        this.throwIfDisposed();
        return new List(this.privList.concat(list.toArray()));
    };
    List.prototype.concatArray = function(array) {
        this.throwIfDisposed();
        return new List(this.privList.concat(array));
    };
    List.prototype.isDisposed = function() {
        return this.privList == null;
    };
    List.prototype.dispose = function(reason) {
        if (!this.isDisposed()) {
            this.privDisposeReason = reason;
            this.privList = null;
            this.privAddSubscriptions = null;
            this.privRemoveSubscriptions = null;
            this.triggerSubscriptions(this.privDisposedSubscriptions);
        }
    };
    List.prototype.throwIfDisposed = function() {
        if (this.isDisposed()) throw new $3XP4p.ObjectDisposedError("List", this.privDisposeReason);
    };
    List.prototype.triggerSubscriptions = function(subscriptions) {
        if (subscriptions) {
            for(var subscriptionId in subscriptions)if (subscriptionId) subscriptions[subscriptionId]();
        }
    };
    return List;
}();
module.exports.List = $3068fc075f3c7479$var$List;

});

parcelRequire.register("kSfYh", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.marshalPromiseToCallbacks = module.exports.Sink = module.exports.Deferred = module.exports.PromiseResultEventSource = module.exports.PromiseResult = module.exports.PromiseState = void 0;
/* eslint-disable max-classes-per-file, @typescript-eslint/typedef */ var $f3253d5c56a67f1e$var$PromiseState;
(function(PromiseState) {
    PromiseState[PromiseState["None"] = 0] = "None";
    PromiseState[PromiseState["Resolved"] = 1] = "Resolved";
    PromiseState[PromiseState["Rejected"] = 2] = "Rejected";
})($f3253d5c56a67f1e$var$PromiseState = module.exports.PromiseState || (module.exports.PromiseState = {}));
var $f3253d5c56a67f1e$var$PromiseResult = /** @class */ function() {
    function PromiseResult(promiseResultEventSource) {
        var _this = this;
        this.throwIfError = function() {
            if (_this.isError) throw _this.error;
        };
        promiseResultEventSource.on(function(result) {
            if (!_this.privIsCompleted) {
                _this.privIsCompleted = true;
                _this.privIsError = false;
                _this.privResult = result;
            }
        }, function(error) {
            if (!_this.privIsCompleted) {
                _this.privIsCompleted = true;
                _this.privIsError = true;
                _this.privError = error;
            }
        });
    }
    Object.defineProperty(PromiseResult.prototype, "isCompleted", {
        get: function() {
            return this.privIsCompleted;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PromiseResult.prototype, "isError", {
        get: function() {
            return this.privIsError;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PromiseResult.prototype, "error", {
        get: function() {
            return this.privError;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PromiseResult.prototype, "result", {
        get: function() {
            return this.privResult;
        },
        enumerable: false,
        configurable: true
    });
    return PromiseResult;
}();
module.exports.PromiseResult = $f3253d5c56a67f1e$var$PromiseResult;
var $f3253d5c56a67f1e$var$PromiseResultEventSource = /** @class */ function() {
    function PromiseResultEventSource() {
        var _this = this;
        this.setResult = function(result) {
            _this.privOnSetResult(result);
        };
        this.setError = function(error) {
            _this.privOnSetError(error);
        };
        this.on = function(onSetResult, onSetError) {
            _this.privOnSetResult = onSetResult;
            _this.privOnSetError = onSetError;
        };
    }
    return PromiseResultEventSource;
}();
module.exports.PromiseResultEventSource = $f3253d5c56a67f1e$var$PromiseResultEventSource;
var $f3253d5c56a67f1e$var$Deferred = /** @class */ function() {
    function Deferred() {
        var _this = this;
        this.resolve = function(result) {
            _this.privResolve(result);
            return _this;
        };
        this.reject = function(error) {
            _this.privReject(error);
            return _this;
        };
        // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
        this.privPromise = new Promise(function(resolve, reject) {
            _this.privResolve = resolve;
            _this.privReject = reject;
        });
    }
    Object.defineProperty(Deferred.prototype, "promise", {
        get: function() {
            return this.privPromise;
        },
        enumerable: false,
        configurable: true
    });
    return Deferred;
}();
module.exports.Deferred = $f3253d5c56a67f1e$var$Deferred;
var $f3253d5c56a67f1e$var$Sink = /** @class */ function() {
    function Sink() {
        this.privState = $f3253d5c56a67f1e$var$PromiseState.None;
        this.privPromiseResult = null;
        this.privPromiseResultEvents = null;
        this.privSuccessHandlers = [];
        this.privErrorHandlers = [];
        this.privPromiseResultEvents = new $f3253d5c56a67f1e$var$PromiseResultEventSource();
        this.privPromiseResult = new $f3253d5c56a67f1e$var$PromiseResult(this.privPromiseResultEvents);
    }
    Object.defineProperty(Sink.prototype, "state", {
        get: function() {
            return this.privState;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Sink.prototype, "result", {
        get: function() {
            return this.privPromiseResult;
        },
        enumerable: false,
        configurable: true
    });
    Sink.prototype.resolve = function(result) {
        if (this.privState !== $f3253d5c56a67f1e$var$PromiseState.None) throw new Error("'Cannot resolve a completed promise'");
        this.privState = $f3253d5c56a67f1e$var$PromiseState.Resolved;
        this.privPromiseResultEvents.setResult(result);
        for(var i = 0; i < this.privSuccessHandlers.length; i++)this.executeSuccessCallback(result, this.privSuccessHandlers[i], this.privErrorHandlers[i]);
        this.detachHandlers();
    };
    Sink.prototype.reject = function(error) {
        if (this.privState !== $f3253d5c56a67f1e$var$PromiseState.None) throw new Error("'Cannot reject a completed promise'");
        this.privState = $f3253d5c56a67f1e$var$PromiseState.Rejected;
        this.privPromiseResultEvents.setError(error);
        for(var _i = 0, _a = this.privErrorHandlers; _i < _a.length; _i++){
            var errorHandler = _a[_i];
            this.executeErrorCallback(error, errorHandler);
        }
        this.detachHandlers();
    };
    Sink.prototype.on = function(successCallback, errorCallback) {
        if (successCallback == null) // eslint-disable-next-line @typescript-eslint/no-empty-function
        successCallback = function() {};
        if (this.privState === $f3253d5c56a67f1e$var$PromiseState.None) {
            this.privSuccessHandlers.push(successCallback);
            this.privErrorHandlers.push(errorCallback);
        } else {
            if (this.privState === $f3253d5c56a67f1e$var$PromiseState.Resolved) this.executeSuccessCallback(this.privPromiseResult.result, successCallback, errorCallback);
            else if (this.privState === $f3253d5c56a67f1e$var$PromiseState.Rejected) this.executeErrorCallback(this.privPromiseResult.error, errorCallback);
            this.detachHandlers();
        }
    };
    Sink.prototype.executeSuccessCallback = function(result, successCallback, errorCallback) {
        try {
            successCallback(result);
        } catch (e) {
            this.executeErrorCallback("'Unhandled callback error: " + e + "'", errorCallback);
        }
    };
    Sink.prototype.executeErrorCallback = function(error, errorCallback) {
        if (errorCallback) try {
            errorCallback(error);
        } catch (e) {
            throw new Error("'Unhandled callback error: " + e + ". InnerError: " + error + "'");
        }
        else throw new Error("'Unhandled error: " + error + "'");
    };
    Sink.prototype.detachHandlers = function() {
        this.privErrorHandlers = [];
        this.privSuccessHandlers = [];
    };
    return Sink;
}();
module.exports.Sink = $f3253d5c56a67f1e$var$Sink;
// eslint-disable-next-line prefer-arrow/prefer-arrow-functions
function $f3253d5c56a67f1e$var$marshalPromiseToCallbacks(promise, cb, err) {
    promise.then(function(val) {
        try {
            if (!!cb) cb(val);
        } catch (error) {
            if (!!err) try {
                if (error instanceof Error) {
                    var typedError = error;
                    err(typedError.name + ": " + typedError.message);
                } else err(error);
            // eslint-disable-next-line no-empty
            } catch (error) {}
        }
    }, function(error) {
        if (!!err) try {
            if (error instanceof Error) {
                var typedError = error;
                err(typedError.name + ": " + typedError.message);
            } else err(error);
        // eslint-disable-next-line no-empty
        } catch (error) {}
    });
}
module.exports.marshalPromiseToCallbacks = $f3253d5c56a67f1e$var$marshalPromiseToCallbacks;

});

parcelRequire.register("cS9Qr", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
var $95f22a265f364c32$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $95f22a265f364c32$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Queue = void 0;

var $3XP4p = parcelRequire("3XP4p");

var $49Gwe = parcelRequire("49Gwe");

var $kSfYh = parcelRequire("kSfYh");
var $95f22a265f364c32$var$SubscriberType;
(function(SubscriberType) {
    SubscriberType[SubscriberType["Dequeue"] = 0] = "Dequeue";
    SubscriberType[SubscriberType["Peek"] = 1] = "Peek";
})($95f22a265f364c32$var$SubscriberType || ($95f22a265f364c32$var$SubscriberType = {}));
var $95f22a265f364c32$var$Queue = /** @class */ function() {
    function Queue(list) {
        var _this = this;
        this.privPromiseStore = new $49Gwe.List();
        this.privIsDrainInProgress = false;
        this.privIsDisposing = false;
        this.privDisposeReason = null;
        this.privList = list ? list : new $49Gwe.List();
        this.privDetachables = [];
        this.privSubscribers = new $49Gwe.List();
        this.privDetachables.push(this.privList.onAdded(function() {
            return _this.drain();
        }));
    }
    Queue.prototype.enqueue = function(item) {
        this.throwIfDispose();
        this.enqueueFromPromise(new Promise(function(resolve) {
            return resolve(item);
        }));
    };
    Queue.prototype.enqueueFromPromise = function(promise) {
        var _this = this;
        this.throwIfDispose();
        promise.then(function(val) {
            _this.privList.add(val);
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        }, function() {});
    };
    Queue.prototype.dequeue = function() {
        this.throwIfDispose();
        var deferredSubscriber = new $kSfYh.Deferred();
        if (this.privSubscribers) {
            this.privSubscribers.add({
                deferral: deferredSubscriber,
                type: $95f22a265f364c32$var$SubscriberType.Dequeue
            });
            this.drain();
        }
        return deferredSubscriber.promise;
    };
    Queue.prototype.peek = function() {
        this.throwIfDispose();
        var deferredSubscriber = new $kSfYh.Deferred();
        var subs = this.privSubscribers;
        if (subs) {
            this.privSubscribers.add({
                deferral: deferredSubscriber,
                type: $95f22a265f364c32$var$SubscriberType.Peek
            });
            this.drain();
        }
        return deferredSubscriber.promise;
    };
    Queue.prototype.length = function() {
        this.throwIfDispose();
        return this.privList.length();
    };
    Queue.prototype.isDisposed = function() {
        return this.privSubscribers == null;
    };
    Queue.prototype.drainAndDispose = function(pendingItemProcessor, reason) {
        return $95f22a265f364c32$var$__awaiter(this, void 0, void 0, function() {
            var subs, subscriber, _i, _a, detachable, promiseArray_1;
            var _this = this;
            return $95f22a265f364c32$var$__generator(this, function(_b) {
                switch(_b.label){
                    case 0:
                        if (!(!this.isDisposed() && !this.privIsDisposing)) return [
                            3 /*break*/ ,
                            5
                        ];
                        this.privDisposeReason = reason;
                        this.privIsDisposing = true;
                        subs = this.privSubscribers;
                        if (subs) {
                            while(subs.length() > 0){
                                subscriber = subs.removeFirst();
                                // TODO: this needs work (Resolve(null) instead?).
                                subscriber.deferral.resolve(undefined);
                            // subscriber.deferral.reject("Disposed");
                            }
                            // note: this block assumes cooperative multitasking, i.e.,
                            // between the if-statement and the assignment there are no
                            // thread switches.
                            // Reason is that between the initial const = this.; and this
                            // point there is the derral.resolve() operation that might have
                            // caused recursive calls to the Queue, especially, calling
                            // Dispose() on the queue alredy (which would reset the var
                            // here to null!).
                            // That should generally hold true for javascript...
                            if (this.privSubscribers === subs) this.privSubscribers = subs;
                        }
                        _i = 0, _a = this.privDetachables;
                        _b.label = 1;
                    case 1:
                        if (!(_i < _a.length)) return [
                            3 /*break*/ ,
                            4
                        ];
                        detachable = _a[_i];
                        return [
                            4 /*yield*/ ,
                            detachable.detach()
                        ];
                    case 2:
                        _b.sent();
                        _b.label = 3;
                    case 3:
                        _i++;
                        return [
                            3 /*break*/ ,
                            1
                        ];
                    case 4:
                        if (this.privPromiseStore.length() > 0 && pendingItemProcessor) {
                            promiseArray_1 = [];
                            this.privPromiseStore.toArray().forEach(function(wrapper) {
                                promiseArray_1.push(wrapper);
                            });
                            return [
                                2 /*return*/ ,
                                Promise.all(promiseArray_1).finally(function() {
                                    _this.privSubscribers = null;
                                    _this.privList.forEach(function(item) {
                                        pendingItemProcessor(item);
                                    });
                                    _this.privList = null;
                                    return;
                                }).then()
                            ];
                        } else {
                            this.privSubscribers = null;
                            this.privList = null;
                        }
                        _b.label = 5;
                    case 5:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    Queue.prototype.dispose = function(reason) {
        return $95f22a265f364c32$var$__awaiter(this, void 0, void 0, function() {
            return $95f22a265f364c32$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.drainAndDispose(null, reason)
                        ];
                    case 1:
                        _a.sent();
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    Queue.prototype.drain = function() {
        if (!this.privIsDrainInProgress && !this.privIsDisposing) {
            this.privIsDrainInProgress = true;
            var subs = this.privSubscribers;
            var lists = this.privList;
            if (subs && lists) {
                while(lists.length() > 0 && subs.length() > 0 && !this.privIsDisposing){
                    var subscriber = subs.removeFirst();
                    if (subscriber.type === $95f22a265f364c32$var$SubscriberType.Peek) subscriber.deferral.resolve(lists.first());
                    else {
                        var dequeuedItem = lists.removeFirst();
                        subscriber.deferral.resolve(dequeuedItem);
                    }
                }
                // note: this block assumes cooperative multitasking, i.e.,
                // between the if-statement and the assignment there are no
                // thread switches.
                // Reason is that between the initial const = this.; and this
                // point there is the derral.resolve() operation that might have
                // caused recursive calls to the Queue, especially, calling
                // Dispose() on the queue alredy (which would reset the var
                // here to null!).
                // That should generally hold true for javascript...
                if (this.privSubscribers === subs) this.privSubscribers = subs;
                // note: this block assumes cooperative multitasking, i.e.,
                // between the if-statement and the assignment there are no
                // thread switches.
                // Reason is that between the initial const = this.; and this
                // point there is the derral.resolve() operation that might have
                // caused recursive calls to the Queue, especially, calling
                // Dispose() on the queue alredy (which would reset the var
                // here to null!).
                // That should generally hold true for javascript...
                if (this.privList === lists) this.privList = lists;
            }
            this.privIsDrainInProgress = false;
        }
    };
    Queue.prototype.throwIfDispose = function() {
        if (this.isDisposed()) {
            if (this.privDisposeReason) throw new $3XP4p.InvalidOperationError(this.privDisposeReason);
            throw new $3XP4p.ObjectDisposedError("Queue");
        } else if (this.privIsDisposing) throw new $3XP4p.InvalidOperationError("Queue disposing");
    };
    return Queue;
}();
module.exports.Queue = $95f22a265f364c32$var$Queue;

});

parcelRequire.register("b3ZaI", function(module, exports) {
"use strict";
/* eslint-disable @typescript-eslint/no-unsafe-assignment */ // Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RawWebsocketMessage = void 0;

var $4miFb = parcelRequire("4miFb");

var $3XP4p = parcelRequire("3XP4p");

var $alsvL = parcelRequire("alsvL");
var $80df6cfae401b78f$var$RawWebsocketMessage = /** @class */ function() {
    function RawWebsocketMessage(messageType, payload, id) {
        this.privPayload = null;
        if (!payload) throw new $3XP4p.ArgumentNullError("payload");
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        if (messageType === $4miFb.MessageType.Binary && payload.__proto__.constructor.name !== "ArrayBuffer") throw new $3XP4p.InvalidOperationError("Payload must be ArrayBuffer");
        if (messageType === $4miFb.MessageType.Text && !(typeof payload === "string")) throw new $3XP4p.InvalidOperationError("Payload must be a string");
        this.privMessageType = messageType;
        this.privPayload = payload;
        this.privId = id ? id : $alsvL.createNoDashGuid();
    }
    Object.defineProperty(RawWebsocketMessage.prototype, "messageType", {
        get: function() {
            return this.privMessageType;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(RawWebsocketMessage.prototype, "payload", {
        get: function() {
            // eslint-disable-next-line @typescript-eslint/no-unsafe-return
            return this.privPayload;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(RawWebsocketMessage.prototype, "textContent", {
        get: function() {
            if (this.privMessageType === $4miFb.MessageType.Binary) throw new $3XP4p.InvalidOperationError("Not supported for binary message");
            return this.privPayload;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(RawWebsocketMessage.prototype, "binaryContent", {
        get: function() {
            if (this.privMessageType === $4miFb.MessageType.Text) throw new $3XP4p.InvalidOperationError("Not supported for text message");
            return this.privPayload;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(RawWebsocketMessage.prototype, "id", {
        get: function() {
            return this.privId;
        },
        enumerable: false,
        configurable: true
    });
    return RawWebsocketMessage;
}();
module.exports.RawWebsocketMessage = $80df6cfae401b78f$var$RawWebsocketMessage;

});

parcelRequire.register("b7UWU", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RiffPcmEncoder = void 0;
var $819c86116f696138$var$RiffPcmEncoder = /** @class */ function() {
    function RiffPcmEncoder(actualSampleRate, desiredSampleRate) {
        this.privActualSampleRate = actualSampleRate;
        this.privDesiredSampleRate = desiredSampleRate;
    }
    RiffPcmEncoder.prototype.encode = function(actualAudioFrame) {
        var audioFrame = this.downSampleAudioFrame(actualAudioFrame, this.privActualSampleRate, this.privDesiredSampleRate);
        if (!audioFrame) return null;
        var audioLength = audioFrame.length * 2;
        var buffer = new ArrayBuffer(audioLength);
        var view = new DataView(buffer);
        this.floatTo16BitPCM(view, 0, audioFrame);
        return buffer;
    };
    RiffPcmEncoder.prototype.setString = function(view, offset, str) {
        for(var i = 0; i < str.length; i++)view.setUint8(offset + i, str.charCodeAt(i));
    };
    RiffPcmEncoder.prototype.floatTo16BitPCM = function(view, offset, input) {
        for(var i = 0; i < input.length; i++, offset += 2){
            var s = Math.max(-1, Math.min(1, input[i]));
            view.setInt16(offset, s < 0 ? s * 0x8000 : s * 0x7FFF, true);
        }
    };
    RiffPcmEncoder.prototype.downSampleAudioFrame = function(srcFrame, srcRate, dstRate) {
        if (!srcFrame) return null;
        if (dstRate === srcRate || dstRate > srcRate) return srcFrame;
        var ratio = srcRate / dstRate;
        var dstLength = Math.round(srcFrame.length / ratio);
        var dstFrame = new Float32Array(dstLength);
        var srcOffset = 0;
        var dstOffset = 0;
        while(dstOffset < dstLength){
            var nextSrcOffset = Math.round((dstOffset + 1) * ratio);
            var accum = 0;
            var count = 0;
            while(srcOffset < nextSrcOffset && srcOffset < srcFrame.length){
                accum += srcFrame[srcOffset++];
                count++;
            }
            dstFrame[dstOffset++] = accum / count;
        }
        return dstFrame;
    };
    return RiffPcmEncoder;
}();
module.exports.RiffPcmEncoder = $819c86116f696138$var$RiffPcmEncoder;

});

parcelRequire.register("cTC89", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
var $96383303470be519$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $96383303470be519$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Stream = void 0;

var $3XP4p = parcelRequire("3XP4p");

var $alsvL = parcelRequire("alsvL");

var $cS9Qr = parcelRequire("cS9Qr");
var $96383303470be519$var$Stream = /** @class */ function() {
    function Stream(streamId) {
        this.privIsWriteEnded = false;
        this.privIsReadEnded = false;
        this.privId = streamId ? streamId : $alsvL.createNoDashGuid();
        this.privReaderQueue = new $cS9Qr.Queue();
    }
    Object.defineProperty(Stream.prototype, "isClosed", {
        get: function() {
            return this.privIsWriteEnded;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Stream.prototype, "isReadEnded", {
        get: function() {
            return this.privIsReadEnded;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Stream.prototype, "id", {
        get: function() {
            return this.privId;
        },
        enumerable: false,
        configurable: true
    });
    Stream.prototype.close = function() {
        if (!this.privIsWriteEnded) {
            this.writeStreamChunk({
                buffer: null,
                isEnd: true,
                timeReceived: Date.now()
            });
            this.privIsWriteEnded = true;
        }
    };
    Stream.prototype.writeStreamChunk = function(streamChunk) {
        this.throwIfClosed();
        if (!this.privReaderQueue.isDisposed()) try {
            this.privReaderQueue.enqueue(streamChunk);
        } catch (e) {
        // Do nothing
        }
    };
    Stream.prototype.read = function() {
        var _this = this;
        if (this.privIsReadEnded) throw new $3XP4p.InvalidOperationError("Stream read has already finished");
        return this.privReaderQueue.dequeue().then(function(streamChunk) {
            return $96383303470be519$var$__awaiter(_this, void 0, void 0, function() {
                return $96383303470be519$var$__generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            if (!(streamChunk === undefined || streamChunk.isEnd)) return [
                                3 /*break*/ ,
                                2
                            ];
                            return [
                                4 /*yield*/ ,
                                this.privReaderQueue.dispose("End of stream reached")
                            ];
                        case 1:
                            _a.sent();
                            _a.label = 2;
                        case 2:
                            return [
                                2 /*return*/ ,
                                streamChunk
                            ];
                    }
                });
            });
        });
    };
    Stream.prototype.readEnded = function() {
        if (!this.privIsReadEnded) {
            this.privIsReadEnded = true;
            this.privReaderQueue = new $cS9Qr.Queue();
        }
    };
    Stream.prototype.throwIfClosed = function() {
        if (this.privIsWriteEnded) throw new $3XP4p.InvalidOperationError("Stream closed");
    };
    return Stream;
}();
module.exports.Stream = $96383303470be519$var$Stream;

});

parcelRequire.register("jLUJe", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TranslationStatus = void 0;
/**
 * Defines translation status.
 * @class TranslationStatus
 */ var $e64e69317f295f90$var$TranslationStatus;
(function(TranslationStatus) {
    /**
     * @member TranslationStatus.Success
     */ TranslationStatus[TranslationStatus["Success"] = 0] = "Success";
    /**
     * @member TranslationStatus.Error
     */ TranslationStatus[TranslationStatus["Error"] = 1] = "Error";
})($e64e69317f295f90$var$TranslationStatus = module.exports.TranslationStatus || (module.exports.TranslationStatus = {}));

});

parcelRequire.register("3fguM", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
var $25cf91767d70628e$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ChunkedArrayBufferStream = void 0;

var $em8BD = parcelRequire("em8BD");
var $25cf91767d70628e$var$ChunkedArrayBufferStream = /** @class */ function(_super) {
    $25cf91767d70628e$var$__extends(ChunkedArrayBufferStream, _super);
    function ChunkedArrayBufferStream(targetChunkSize, streamId) {
        var _this = _super.call(this, streamId) || this;
        _this.privTargetChunkSize = targetChunkSize;
        _this.privNextBufferReadyBytes = 0;
        return _this;
    }
    ChunkedArrayBufferStream.prototype.writeStreamChunk = function(chunk) {
        // No pending write, and the buffer is the right size so write it.
        if (chunk.isEnd || 0 === this.privNextBufferReadyBytes && chunk.buffer.byteLength === this.privTargetChunkSize) {
            _super.prototype.writeStreamChunk.call(this, chunk);
            return;
        }
        var bytesCopiedFromBuffer = 0;
        while(bytesCopiedFromBuffer < chunk.buffer.byteLength){
            // Fill the next buffer.
            if (undefined === this.privNextBufferToWrite) {
                this.privNextBufferToWrite = new ArrayBuffer(this.privTargetChunkSize);
                this.privNextBufferStartTime = chunk.timeReceived;
            }
            // Find out how many bytes we can copy into the read buffer.
            var bytesToCopy = Math.min(chunk.buffer.byteLength - bytesCopiedFromBuffer, this.privTargetChunkSize - this.privNextBufferReadyBytes);
            var targetView = new Uint8Array(this.privNextBufferToWrite);
            var sourceView = new Uint8Array(chunk.buffer.slice(bytesCopiedFromBuffer, bytesToCopy + bytesCopiedFromBuffer));
            targetView.set(sourceView, this.privNextBufferReadyBytes);
            this.privNextBufferReadyBytes += bytesToCopy;
            bytesCopiedFromBuffer += bytesToCopy;
            // Are we ready to write?
            if (this.privNextBufferReadyBytes === this.privTargetChunkSize) {
                _super.prototype.writeStreamChunk.call(this, {
                    buffer: this.privNextBufferToWrite,
                    isEnd: false,
                    timeReceived: this.privNextBufferStartTime
                });
                this.privNextBufferReadyBytes = 0;
                this.privNextBufferToWrite = undefined;
            }
        }
    };
    ChunkedArrayBufferStream.prototype.close = function() {
        // Send whatever is pending, then close the base class.
        if (0 !== this.privNextBufferReadyBytes && !this.isClosed) _super.prototype.writeStreamChunk.call(this, {
            buffer: this.privNextBufferToWrite.slice(0, this.privNextBufferReadyBytes),
            isEnd: false,
            timeReceived: this.privNextBufferStartTime
        });
        _super.prototype.close.call(this);
    };
    return ChunkedArrayBufferStream;
}($em8BD.Stream);
module.exports.ChunkedArrayBufferStream = $25cf91767d70628e$var$ChunkedArrayBufferStream;

});

parcelRequire.register("fS9nl", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRequire.register("keosm", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Timeout = void 0;
var $eba815f85540976d$var$Timeout = /** @class */ function() {
    function Timeout() {}
    Timeout.load = function() {
        // Prefilling the Maps with a function indexed by zero is necessary to be compliant with the specification.
        var scheduledTimeoutFunctions = new Map([
            [
                0,
                function() {}
            ]
        ]); // eslint-disable-line @typescript-eslint/no-empty-function
        var unhandledRequests = new Map();
        // eslint-disable-next-line
        var workerScript = '!function(e){var t={};function n(r){if(t[r])return t[r].exports;var o=t[r]={i:r,l:!1,exports:{}};return e[r].call(o.exports,o,o.exports,n),o.l=!0,o.exports}n.m=e,n.c=t,n.d=function(e,t,r){n.o(e,t)||Object.defineProperty(e,t,{enumerable:!0,get:r})},n.r=function(e){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(e,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(e,"__esModule",{value:!0})},n.t=function(e,t){if(1&t&&(e=n(e)),8&t)return e;if(4&t&&"object"==typeof e&&e&&e.__esModule)return e;var r=Object.create(null);if(n.r(r),Object.defineProperty(r,"default",{enumerable:!0,value:e}),2&t&&"string"!=typeof e)for(var o in e)n.d(r,o,function(t){return e[t]}.bind(null,o));return r},n.n=function(e){var t=e&&e.__esModule?function(){return e.default}:function(){return e};return n.d(t,"a",t),t},n.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},n.p="",n(n.s=14)}([function(e,t,n){"use strict";n.d(t,"a",(function(){return i})),n.d(t,"b",(function(){return u})),n.d(t,"c",(function(){return a})),n.d(t,"d",(function(){return d}));const r=new Map,o=new Map,i=e=>{const t=r.get(e);if(void 0===t)throw new Error(\'There is no interval scheduled with the given id "\'.concat(e,\'".\'));clearTimeout(t),r.delete(e)},u=e=>{const t=o.get(e);if(void 0===t)throw new Error(\'There is no timeout scheduled with the given id "\'.concat(e,\'".\'));clearTimeout(t),o.delete(e)},f=(e,t)=>{let n,r;if("performance"in self){const o=performance.now();n=o,r=e-Math.max(0,o-t)}else n=Date.now(),r=e;return{expected:n+r,remainingDelay:r}},c=(e,t,n,r)=>{const o="performance"in self?performance.now():Date.now();o>n?postMessage({id:null,method:"call",params:{timerId:t}}):e.set(t,setTimeout(c,n-o,e,t,n))},a=(e,t,n)=>{const{expected:o,remainingDelay:i}=f(e,n);r.set(t,setTimeout(c,i,r,t,o))},d=(e,t,n)=>{const{expected:r,remainingDelay:i}=f(e,n);o.set(t,setTimeout(c,i,o,t,r))}},function(e,t,n){"use strict";n.r(t);var r=n(2);for(var o in r)"default"!==o&&function(e){n.d(t,e,(function(){return r[e]}))}(o);var i=n(3);for(var o in i)"default"!==o&&function(e){n.d(t,e,(function(){return i[e]}))}(o);var u=n(4);for(var o in u)"default"!==o&&function(e){n.d(t,e,(function(){return u[e]}))}(o);var f=n(5);for(var o in f)"default"!==o&&function(e){n.d(t,e,(function(){return f[e]}))}(o);var c=n(6);for(var o in c)"default"!==o&&function(e){n.d(t,e,(function(){return c[e]}))}(o);var a=n(7);for(var o in a)"default"!==o&&function(e){n.d(t,e,(function(){return a[e]}))}(o);var d=n(8);for(var o in d)"default"!==o&&function(e){n.d(t,e,(function(){return d[e]}))}(o);var s=n(9);for(var o in s)"default"!==o&&function(e){n.d(t,e,(function(){return s[e]}))}(o)},function(e,t){},function(e,t){},function(e,t){},function(e,t){},function(e,t){},function(e,t){},function(e,t){},function(e,t){},function(e,t,n){"use strict";n.r(t);var r=n(11);for(var o in r)"default"!==o&&function(e){n.d(t,e,(function(){return r[e]}))}(o);var i=n(12);for(var o in i)"default"!==o&&function(e){n.d(t,e,(function(){return i[e]}))}(o);var u=n(13);for(var o in u)"default"!==o&&function(e){n.d(t,e,(function(){return u[e]}))}(o)},function(e,t){},function(e,t){},function(e,t){},function(e,t,n){"use strict";n.r(t);var r=n(0),o=n(1);for(var i in o)"default"!==i&&function(e){n.d(t,e,(function(){return o[e]}))}(i);var u=n(10);for(var i in u)"default"!==i&&function(e){n.d(t,e,(function(){return u[e]}))}(i);addEventListener("message",({data:e})=>{try{if("clear"===e.method){const{id:t,params:{timerId:n}}=e;Object(r.b)(n),postMessage({error:null,id:t})}else{if("set"!==e.method)throw new Error(\'The given method "\'.concat(e.method,\'" is not supported\'));{const{params:{delay:t,now:n,timerId:o}}=e;Object(r.d)(t,o,n)}}}catch(t){postMessage({error:{message:t.message},id:e.id,result:null})}})}]);';
        var workerUrl = "data:text/javascript;base64," + btoa(workerScript);
        var worker = new Worker(workerUrl);
        worker.addEventListener("message", function(_a) {
            var data = _a.data;
            if (Timeout.isCallNotification(data)) {
                var timerId = data.params.timerId;
                var idOrFunc = scheduledTimeoutFunctions.get(timerId);
                if (typeof idOrFunc === "number") {
                    var unhandledTimerId = unhandledRequests.get(idOrFunc);
                    if (unhandledTimerId === undefined || unhandledTimerId !== timerId) throw new Error("The timer is in an undefined state.");
                } else if (typeof idOrFunc !== "undefined") {
                    idOrFunc();
                    // A timeout can be safely deleted because it is only called once.
                    scheduledTimeoutFunctions.delete(timerId);
                } else throw new Error("The timer is in an undefined state.");
            } else if (Timeout.isClearResponse(data)) {
                var id = data.id;
                var unhandledTimerId = unhandledRequests.get(id);
                if (unhandledTimerId === undefined) throw new Error("The timer is in an undefined state.");
                unhandledRequests.delete(id);
                scheduledTimeoutFunctions.delete(unhandledTimerId);
            } else {
                var message = data.error.message;
                throw new Error(message);
            }
        });
        var clearTimeout = function(timerId) {
            var id = Math.random();
            unhandledRequests.set(id, timerId);
            scheduledTimeoutFunctions.set(timerId, id);
            worker.postMessage({
                id: id,
                method: "clear",
                params: {
                    timerId: timerId
                }
            });
        };
        var setTimeout = function(func, delay) {
            var timerId = Math.random();
            scheduledTimeoutFunctions.set(timerId, func);
            worker.postMessage({
                id: null,
                method: "set",
                params: {
                    delay: delay,
                    now: performance.now(),
                    timerId: timerId
                }
            });
            return timerId;
        };
        return {
            clearTimeout: clearTimeout,
            setTimeout: setTimeout
        };
    };
    Timeout.loadWorkerTimers = function() {
        return function() {
            if (Timeout.workerTimers !== null) return Timeout.workerTimers;
            Timeout.workerTimers = Timeout.load();
            return Timeout.workerTimers;
        };
    };
    Timeout.isCallNotification = function(message) {
        return message.method !== undefined && message.method === "call";
    };
    Timeout.isClearResponse = function(message) {
        return message.error === null && typeof message.id === "number";
    };
    Timeout.workerTimers = null;
    Timeout.clearTimeout = function(timerId) {
        return Timeout.timers().clearTimeout(timerId);
    };
    Timeout.setTimeout = function(func, delay) {
        return Timeout.timers().setTimeout(func, delay);
    };
    Timeout.timers = Timeout.loadWorkerTimers();
    return Timeout;
}();
module.exports.Timeout = $eba815f85540976d$var$Timeout;

});

parcelRequire.register("bWDhv", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
var $8b2394f789ba136a$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.OCSPCacheUpdateErrorEvent = module.exports.OCSPResponseRetrievedEvent = module.exports.OCSPCacheFetchErrorEvent = module.exports.OCSPVerificationFailedEvent = module.exports.OCSPCacheHitEvent = module.exports.OCSPCacheEntryNeedsRefreshEvent = module.exports.OCSPCacheEntryExpiredEvent = module.exports.OCSPWSUpgradeStartedEvent = module.exports.OCSPStapleReceivedEvent = module.exports.OCSPCacheUpdateCompleteEvent = module.exports.OCSPDiskCacheStoreEvent = module.exports.OCSPMemoryCacheStoreEvent = module.exports.OCSPCacheUpdateNeededEvent = module.exports.OCSPDiskCacheHitEvent = module.exports.OCSPCacheMissEvent = module.exports.OCSPMemoryCacheHitEvent = module.exports.OCSPEvent = void 0;

var $bxo0O = parcelRequire("bxo0O");
var $8b2394f789ba136a$var$OCSPEvent = /** @class */ function(_super) {
    $8b2394f789ba136a$var$__extends(OCSPEvent, _super);
    function OCSPEvent(eventName, eventType, signature) {
        var _this = _super.call(this, eventName, eventType) || this;
        _this.privSignature = signature;
        return _this;
    }
    return OCSPEvent;
}($bxo0O.PlatformEvent);
module.exports.OCSPEvent = $8b2394f789ba136a$var$OCSPEvent;
var $8b2394f789ba136a$var$OCSPMemoryCacheHitEvent = /** @class */ function(_super) {
    $8b2394f789ba136a$var$__extends(OCSPMemoryCacheHitEvent, _super);
    function OCSPMemoryCacheHitEvent(signature) {
        return _super.call(this, "OCSPMemoryCacheHitEvent", $bxo0O.EventType.Debug, signature) || this;
    }
    return OCSPMemoryCacheHitEvent;
}($8b2394f789ba136a$var$OCSPEvent);
module.exports.OCSPMemoryCacheHitEvent = $8b2394f789ba136a$var$OCSPMemoryCacheHitEvent;
var $8b2394f789ba136a$var$OCSPCacheMissEvent = /** @class */ function(_super) {
    $8b2394f789ba136a$var$__extends(OCSPCacheMissEvent, _super);
    function OCSPCacheMissEvent(signature) {
        return _super.call(this, "OCSPCacheMissEvent", $bxo0O.EventType.Debug, signature) || this;
    }
    return OCSPCacheMissEvent;
}($8b2394f789ba136a$var$OCSPEvent);
module.exports.OCSPCacheMissEvent = $8b2394f789ba136a$var$OCSPCacheMissEvent;
var $8b2394f789ba136a$var$OCSPDiskCacheHitEvent = /** @class */ function(_super) {
    $8b2394f789ba136a$var$__extends(OCSPDiskCacheHitEvent, _super);
    function OCSPDiskCacheHitEvent(signature) {
        return _super.call(this, "OCSPDiskCacheHitEvent", $bxo0O.EventType.Debug, signature) || this;
    }
    return OCSPDiskCacheHitEvent;
}($8b2394f789ba136a$var$OCSPEvent);
module.exports.OCSPDiskCacheHitEvent = $8b2394f789ba136a$var$OCSPDiskCacheHitEvent;
var $8b2394f789ba136a$var$OCSPCacheUpdateNeededEvent = /** @class */ function(_super) {
    $8b2394f789ba136a$var$__extends(OCSPCacheUpdateNeededEvent, _super);
    function OCSPCacheUpdateNeededEvent(signature) {
        return _super.call(this, "OCSPCacheUpdateNeededEvent", $bxo0O.EventType.Debug, signature) || this;
    }
    return OCSPCacheUpdateNeededEvent;
}($8b2394f789ba136a$var$OCSPEvent);
module.exports.OCSPCacheUpdateNeededEvent = $8b2394f789ba136a$var$OCSPCacheUpdateNeededEvent;
var $8b2394f789ba136a$var$OCSPMemoryCacheStoreEvent = /** @class */ function(_super) {
    $8b2394f789ba136a$var$__extends(OCSPMemoryCacheStoreEvent, _super);
    function OCSPMemoryCacheStoreEvent(signature) {
        return _super.call(this, "OCSPMemoryCacheStoreEvent", $bxo0O.EventType.Debug, signature) || this;
    }
    return OCSPMemoryCacheStoreEvent;
}($8b2394f789ba136a$var$OCSPEvent);
module.exports.OCSPMemoryCacheStoreEvent = $8b2394f789ba136a$var$OCSPMemoryCacheStoreEvent;
var $8b2394f789ba136a$var$OCSPDiskCacheStoreEvent = /** @class */ function(_super) {
    $8b2394f789ba136a$var$__extends(OCSPDiskCacheStoreEvent, _super);
    function OCSPDiskCacheStoreEvent(signature) {
        return _super.call(this, "OCSPDiskCacheStoreEvent", $bxo0O.EventType.Debug, signature) || this;
    }
    return OCSPDiskCacheStoreEvent;
}($8b2394f789ba136a$var$OCSPEvent);
module.exports.OCSPDiskCacheStoreEvent = $8b2394f789ba136a$var$OCSPDiskCacheStoreEvent;
var $8b2394f789ba136a$var$OCSPCacheUpdateCompleteEvent = /** @class */ function(_super) {
    $8b2394f789ba136a$var$__extends(OCSPCacheUpdateCompleteEvent, _super);
    function OCSPCacheUpdateCompleteEvent(signature) {
        return _super.call(this, "OCSPCacheUpdateCompleteEvent", $bxo0O.EventType.Debug, signature) || this;
    }
    return OCSPCacheUpdateCompleteEvent;
}($8b2394f789ba136a$var$OCSPEvent);
module.exports.OCSPCacheUpdateCompleteEvent = $8b2394f789ba136a$var$OCSPCacheUpdateCompleteEvent;
var $8b2394f789ba136a$var$OCSPStapleReceivedEvent = /** @class */ function(_super) {
    $8b2394f789ba136a$var$__extends(OCSPStapleReceivedEvent, _super);
    function OCSPStapleReceivedEvent() {
        return _super.call(this, "OCSPStapleReceivedEvent", $bxo0O.EventType.Debug, "") || this;
    }
    return OCSPStapleReceivedEvent;
}($8b2394f789ba136a$var$OCSPEvent);
module.exports.OCSPStapleReceivedEvent = $8b2394f789ba136a$var$OCSPStapleReceivedEvent;
var $8b2394f789ba136a$var$OCSPWSUpgradeStartedEvent = /** @class */ function(_super) {
    $8b2394f789ba136a$var$__extends(OCSPWSUpgradeStartedEvent, _super);
    function OCSPWSUpgradeStartedEvent(serialNumber) {
        return _super.call(this, "OCSPWSUpgradeStartedEvent", $bxo0O.EventType.Debug, serialNumber) || this;
    }
    return OCSPWSUpgradeStartedEvent;
}($8b2394f789ba136a$var$OCSPEvent);
module.exports.OCSPWSUpgradeStartedEvent = $8b2394f789ba136a$var$OCSPWSUpgradeStartedEvent;
var $8b2394f789ba136a$var$OCSPCacheEntryExpiredEvent = /** @class */ function(_super) {
    $8b2394f789ba136a$var$__extends(OCSPCacheEntryExpiredEvent, _super);
    function OCSPCacheEntryExpiredEvent(serialNumber, expireTime) {
        var _this = _super.call(this, "OCSPCacheEntryExpiredEvent", $bxo0O.EventType.Debug, serialNumber) || this;
        _this.privExpireTime = expireTime;
        return _this;
    }
    return OCSPCacheEntryExpiredEvent;
}($8b2394f789ba136a$var$OCSPEvent);
module.exports.OCSPCacheEntryExpiredEvent = $8b2394f789ba136a$var$OCSPCacheEntryExpiredEvent;
var $8b2394f789ba136a$var$OCSPCacheEntryNeedsRefreshEvent = /** @class */ function(_super) {
    $8b2394f789ba136a$var$__extends(OCSPCacheEntryNeedsRefreshEvent, _super);
    function OCSPCacheEntryNeedsRefreshEvent(serialNumber, startTime, expireTime) {
        var _this = _super.call(this, "OCSPCacheEntryNeedsRefreshEvent", $bxo0O.EventType.Debug, serialNumber) || this;
        _this.privExpireTime = expireTime;
        _this.privStartTime = startTime;
        return _this;
    }
    return OCSPCacheEntryNeedsRefreshEvent;
}($8b2394f789ba136a$var$OCSPEvent);
module.exports.OCSPCacheEntryNeedsRefreshEvent = $8b2394f789ba136a$var$OCSPCacheEntryNeedsRefreshEvent;
var $8b2394f789ba136a$var$OCSPCacheHitEvent = /** @class */ function(_super) {
    $8b2394f789ba136a$var$__extends(OCSPCacheHitEvent, _super);
    function OCSPCacheHitEvent(serialNumber, startTime, expireTime) {
        var _this = _super.call(this, "OCSPCacheHitEvent", $bxo0O.EventType.Debug, serialNumber) || this;
        _this.privExpireTime = expireTime;
        _this.privExpireTimeString = new Date(expireTime).toLocaleDateString();
        _this.privStartTime = startTime;
        _this.privStartTimeString = new Date(startTime).toLocaleTimeString();
        return _this;
    }
    return OCSPCacheHitEvent;
}($8b2394f789ba136a$var$OCSPEvent);
module.exports.OCSPCacheHitEvent = $8b2394f789ba136a$var$OCSPCacheHitEvent;
var $8b2394f789ba136a$var$OCSPVerificationFailedEvent = /** @class */ function(_super) {
    $8b2394f789ba136a$var$__extends(OCSPVerificationFailedEvent, _super);
    function OCSPVerificationFailedEvent(serialNumber, error) {
        var _this = _super.call(this, "OCSPVerificationFailedEvent", $bxo0O.EventType.Debug, serialNumber) || this;
        _this.privError = error;
        return _this;
    }
    return OCSPVerificationFailedEvent;
}($8b2394f789ba136a$var$OCSPEvent);
module.exports.OCSPVerificationFailedEvent = $8b2394f789ba136a$var$OCSPVerificationFailedEvent;
var $8b2394f789ba136a$var$OCSPCacheFetchErrorEvent = /** @class */ function(_super) {
    $8b2394f789ba136a$var$__extends(OCSPCacheFetchErrorEvent, _super);
    function OCSPCacheFetchErrorEvent(serialNumber, error) {
        var _this = _super.call(this, "OCSPCacheFetchErrorEvent", $bxo0O.EventType.Debug, serialNumber) || this;
        _this.privError = error;
        return _this;
    }
    return OCSPCacheFetchErrorEvent;
}($8b2394f789ba136a$var$OCSPEvent);
module.exports.OCSPCacheFetchErrorEvent = $8b2394f789ba136a$var$OCSPCacheFetchErrorEvent;
var $8b2394f789ba136a$var$OCSPResponseRetrievedEvent = /** @class */ function(_super) {
    $8b2394f789ba136a$var$__extends(OCSPResponseRetrievedEvent, _super);
    function OCSPResponseRetrievedEvent(serialNumber) {
        return _super.call(this, "OCSPResponseRetrievedEvent", $bxo0O.EventType.Debug, serialNumber) || this;
    }
    return OCSPResponseRetrievedEvent;
}($8b2394f789ba136a$var$OCSPEvent);
module.exports.OCSPResponseRetrievedEvent = $8b2394f789ba136a$var$OCSPResponseRetrievedEvent;
var $8b2394f789ba136a$var$OCSPCacheUpdateErrorEvent = /** @class */ function(_super) {
    $8b2394f789ba136a$var$__extends(OCSPCacheUpdateErrorEvent, _super);
    function OCSPCacheUpdateErrorEvent(serialNumber, error) {
        var _this = _super.call(this, "OCSPCacheUpdateErrorEvent", $bxo0O.EventType.Debug, serialNumber) || this;
        _this.privError = error;
        return _this;
    }
    return OCSPCacheUpdateErrorEvent;
}($8b2394f789ba136a$var$OCSPEvent);
module.exports.OCSPCacheUpdateErrorEvent = $8b2394f789ba136a$var$OCSPCacheUpdateErrorEvent;

});

parcelRequire.register("koGHd", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
var $ed972b18d67f70cf$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.BackgroundEvent = void 0;

var $em8BD = parcelRequire("em8BD");
var $ed972b18d67f70cf$var$BackgroundEvent = /** @class */ function(_super) {
    $ed972b18d67f70cf$var$__extends(BackgroundEvent, _super);
    function BackgroundEvent(error) {
        var _this = _super.call(this, "BackgroundEvent", $em8BD.EventType.Error) || this;
        _this.privError = error;
        return _this;
    }
    Object.defineProperty(BackgroundEvent.prototype, "error", {
        get: function() {
            return this.privError;
        },
        enumerable: false,
        configurable: true
    });
    return BackgroundEvent;
}($em8BD.PlatformEvent);
module.exports.BackgroundEvent = $ed972b18d67f70cf$var$BackgroundEvent;

});



parcelRequire.register("gBGZx", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Contracts = void 0;
/**
 * @class Contracts
 * @private
 */ var $c17173404872822c$var$Contracts = /** @class */ function() {
    function Contracts() {}
    Contracts.throwIfNullOrUndefined = function(param, name) {
        if (param === undefined || param === null) throw new Error("throwIfNullOrUndefined:" + name);
    };
    Contracts.throwIfNull = function(param, name) {
        if (param === null) throw new Error("throwIfNull:" + name);
    };
    Contracts.throwIfNullOrWhitespace = function(param, name) {
        Contracts.throwIfNullOrUndefined(param, name);
        if (("" + param).trim().length < 1) throw new Error("throwIfNullOrWhitespace:" + name);
    };
    Contracts.throwIfNullOrTooLong = function(param, name, maxLength) {
        Contracts.throwIfNullOrUndefined(param, name);
        if (("" + param).length > maxLength) throw new Error("throwIfNullOrTooLong:" + name + " (more than " + maxLength.toString() + " characters)");
    };
    Contracts.throwIfNullOrTooShort = function(param, name, minLength) {
        Contracts.throwIfNullOrUndefined(param, name);
        if (("" + param).length < minLength) throw new Error("throwIfNullOrTooShort:" + name + " (less than " + minLength.toString() + " characters)");
    };
    Contracts.throwIfDisposed = function(isDisposed) {
        if (isDisposed) throw new Error("the object is already disposed");
    };
    Contracts.throwIfArrayEmptyOrWhitespace = function(array, name) {
        Contracts.throwIfNullOrUndefined(array, name);
        if (array.length === 0) throw new Error("throwIfArrayEmptyOrWhitespace:" + name);
        for(var _i = 0, array_1 = array; _i < array_1.length; _i++){
            var item = array_1[_i];
            Contracts.throwIfNullOrWhitespace(item, name);
        }
    };
    Contracts.throwIfFileDoesNotExist = function(param, name) {
        Contracts.throwIfNullOrWhitespace(param, name);
    // TODO check for file existence.
    };
    Contracts.throwIfNotUndefined = function(param, name) {
        if (param !== undefined) throw new Error("throwIfNotUndefined:" + name);
    };
    return Contracts;
}();
module.exports.Contracts = $c17173404872822c$var$Contracts;

});


parcelRequire.register("6PmIW", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRequire.register("6sE7a", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
var $4b4479812e6ce174$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $4b4479812e6ce174$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MicAudioSource = module.exports.AudioWorkletSourceURLPropertyName = void 0;

var $dEkJU = parcelRequire("dEkJU");

var $em8BD = parcelRequire("em8BD");

var $kQmaR = parcelRequire("kQmaR");
module.exports.AudioWorkletSourceURLPropertyName = "MICROPHONE-WorkletSourceUrl";
var $4b4479812e6ce174$var$MicAudioSource = /** @class */ function() {
    function MicAudioSource(privRecorder, deviceId, audioSourceId, mediaStream) {
        this.privRecorder = privRecorder;
        this.deviceId = deviceId;
        this.privStreams = {};
        this.privOutputChunkSize = MicAudioSource.AUDIOFORMAT.avgBytesPerSec / 10;
        this.privId = audioSourceId ? audioSourceId : $em8BD.createNoDashGuid();
        this.privEvents = new $em8BD.EventSource();
        this.privMediaStream = mediaStream || null;
        this.privIsClosing = false;
    }
    Object.defineProperty(MicAudioSource.prototype, "format", {
        get: function() {
            return Promise.resolve(MicAudioSource.AUDIOFORMAT);
        },
        enumerable: false,
        configurable: true
    });
    MicAudioSource.prototype.turnOn = function() {
        var _this = this;
        if (this.privInitializeDeferral) return this.privInitializeDeferral.promise;
        this.privInitializeDeferral = new $em8BD.Deferred();
        try {
            this.createAudioContext();
        } catch (error) {
            if (error instanceof Error) {
                var typedError = error;
                this.privInitializeDeferral.reject(typedError.name + ": " + typedError.message);
            } else this.privInitializeDeferral.reject(error);
            return this.privInitializeDeferral.promise;
        }
        var nav = window.navigator;
        var getUserMedia = // eslint-disable-next-line
        nav.getUserMedia || nav.webkitGetUserMedia || nav.mozGetUserMedia || nav.msGetUserMedia;
        if (!!nav.mediaDevices) getUserMedia = function(constraints, successCallback, errorCallback) {
            nav.mediaDevices.getUserMedia(constraints).then(successCallback).catch(errorCallback);
        };
        if (!getUserMedia) {
            var errorMsg = "Browser does not support getUserMedia.";
            this.privInitializeDeferral.reject(errorMsg);
            this.onEvent(new $em8BD.AudioSourceErrorEvent(errorMsg, "")); // mic initialized error - no streamid at this point
        } else {
            var next = function() {
                _this.onEvent(new $em8BD.AudioSourceInitializingEvent(_this.privId)); // no stream id
                if (_this.privMediaStream && _this.privMediaStream.active) {
                    _this.onEvent(new $em8BD.AudioSourceReadyEvent(_this.privId));
                    _this.privInitializeDeferral.resolve();
                } else getUserMedia({
                    audio: _this.deviceId ? {
                        deviceId: _this.deviceId
                    } : true,
                    video: false
                }, function(mediaStream) {
                    _this.privMediaStream = mediaStream;
                    _this.onEvent(new $em8BD.AudioSourceReadyEvent(_this.privId));
                    _this.privInitializeDeferral.resolve();
                }, function(error) {
                    var errorMsg = "Error occurred during microphone initialization: " + error;
                    _this.privInitializeDeferral.reject(errorMsg);
                    _this.onEvent(new $em8BD.AudioSourceErrorEvent(_this.privId, errorMsg));
                });
            };
            if (this.privContext.state === "suspended") // NOTE: On iOS, the Web Audio API requires sounds to be triggered from an explicit user action.
            // https://github.com/WebAudio/web-audio-api/issues/790
            this.privContext.resume().then(next).catch(function(reason) {
                _this.privInitializeDeferral.reject("Failed to initialize audio context: " + reason);
            });
            else next();
        }
        return this.privInitializeDeferral.promise;
    };
    MicAudioSource.prototype.id = function() {
        return this.privId;
    };
    MicAudioSource.prototype.attach = function(audioNodeId) {
        var _this = this;
        this.onEvent(new $em8BD.AudioStreamNodeAttachingEvent(this.privId, audioNodeId));
        return this.listen(audioNodeId).then(function(stream) {
            _this.onEvent(new $em8BD.AudioStreamNodeAttachedEvent(_this.privId, audioNodeId));
            return {
                detach: function() {
                    return $4b4479812e6ce174$var$__awaiter(_this, void 0, void 0, function() {
                        return $4b4479812e6ce174$var$__generator(this, function(_a) {
                            stream.readEnded();
                            delete this.privStreams[audioNodeId];
                            this.onEvent(new $em8BD.AudioStreamNodeDetachedEvent(this.privId, audioNodeId));
                            return [
                                2 /*return*/ ,
                                this.turnOff()
                            ];
                        });
                    });
                },
                id: function() {
                    return audioNodeId;
                },
                read: function() {
                    return stream.read();
                }
            };
        });
    };
    MicAudioSource.prototype.detach = function(audioNodeId) {
        if (audioNodeId && this.privStreams[audioNodeId]) {
            this.privStreams[audioNodeId].close();
            delete this.privStreams[audioNodeId];
            this.onEvent(new $em8BD.AudioStreamNodeDetachedEvent(this.privId, audioNodeId));
        }
    };
    MicAudioSource.prototype.turnOff = function() {
        return $4b4479812e6ce174$var$__awaiter(this, void 0, void 0, function() {
            var streamId, stream;
            return $4b4479812e6ce174$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        for(streamId in this.privStreams)if (streamId) {
                            stream = this.privStreams[streamId];
                            if (stream) stream.close();
                        }
                        this.onEvent(new $em8BD.AudioSourceOffEvent(this.privId)); // no stream now
                        if (!this.privInitializeDeferral) return [
                            3 /*break*/ ,
                            2
                        ];
                        // Correctly handle when browser forces mic off before turnOn() completes
                        // eslint-disable-next-line @typescript-eslint/await-thenable
                        return [
                            4 /*yield*/ ,
                            this.privInitializeDeferral
                        ];
                    case 1:
                        // Correctly handle when browser forces mic off before turnOn() completes
                        // eslint-disable-next-line @typescript-eslint/await-thenable
                        _a.sent();
                        this.privInitializeDeferral = null;
                        _a.label = 2;
                    case 2:
                        return [
                            4 /*yield*/ ,
                            this.destroyAudioContext()
                        ];
                    case 3:
                        _a.sent();
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    Object.defineProperty(MicAudioSource.prototype, "events", {
        get: function() {
            return this.privEvents;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MicAudioSource.prototype, "deviceInfo", {
        get: function() {
            return this.getMicrophoneLabel().then(function(label) {
                return {
                    bitspersample: MicAudioSource.AUDIOFORMAT.bitsPerSample,
                    channelcount: MicAudioSource.AUDIOFORMAT.channels,
                    connectivity: $dEkJU.connectivity.Unknown,
                    manufacturer: "Speech SDK",
                    model: label,
                    samplerate: MicAudioSource.AUDIOFORMAT.samplesPerSec,
                    type: $dEkJU.type.Microphones
                };
            });
        },
        enumerable: false,
        configurable: true
    });
    MicAudioSource.prototype.setProperty = function(name, value) {
        if (name === module.exports.AudioWorkletSourceURLPropertyName) this.privRecorder.setWorkletUrl(value);
        else throw new Error("Property '" + name + "' is not supported on Microphone.");
    };
    MicAudioSource.prototype.getMicrophoneLabel = function() {
        var _this = this;
        var defaultMicrophoneName = "microphone";
        // If we did this already, return the value.
        if (this.privMicrophoneLabel !== undefined) return Promise.resolve(this.privMicrophoneLabel);
        // If the stream isn't currently running, we can't query devices because security.
        if (this.privMediaStream === undefined || !this.privMediaStream.active) return Promise.resolve(defaultMicrophoneName);
        // Setup a default
        this.privMicrophoneLabel = defaultMicrophoneName;
        // Get the id of the device running the audio track.
        var microphoneDeviceId = this.privMediaStream.getTracks()[0].getSettings().deviceId;
        // If the browser doesn't support getting the device ID, set a default and return.
        if (undefined === microphoneDeviceId) return Promise.resolve(this.privMicrophoneLabel);
        var deferred = new $em8BD.Deferred();
        // Enumerate the media devices.
        navigator.mediaDevices.enumerateDevices().then(function(devices) {
            for(var _i = 0, devices_1 = devices; _i < devices_1.length; _i++){
                var device = devices_1[_i];
                if (device.deviceId === microphoneDeviceId) {
                    // Found the device
                    _this.privMicrophoneLabel = device.label;
                    break;
                }
            }
            deferred.resolve(_this.privMicrophoneLabel);
        }, function() {
            return deferred.resolve(_this.privMicrophoneLabel);
        });
        return deferred.promise;
    };
    MicAudioSource.prototype.listen = function(audioNodeId) {
        return $4b4479812e6ce174$var$__awaiter(this, void 0, void 0, function() {
            var stream, result;
            return $4b4479812e6ce174$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.turnOn()
                        ];
                    case 1:
                        _a.sent();
                        stream = new $em8BD.ChunkedArrayBufferStream(this.privOutputChunkSize, audioNodeId);
                        this.privStreams[audioNodeId] = stream;
                        try {
                            this.privRecorder.record(this.privContext, this.privMediaStream, stream);
                        } catch (error) {
                            this.onEvent(new $em8BD.AudioStreamNodeErrorEvent(this.privId, audioNodeId, error));
                            throw error;
                        }
                        result = stream;
                        return [
                            2 /*return*/ ,
                            result
                        ];
                }
            });
        });
    };
    MicAudioSource.prototype.onEvent = function(event) {
        this.privEvents.onEvent(event);
        $em8BD.Events.instance.onEvent(event);
    };
    MicAudioSource.prototype.createAudioContext = function() {
        if (!!this.privContext) return;
        this.privContext = $kQmaR.AudioStreamFormatImpl.getAudioContext(MicAudioSource.AUDIOFORMAT.samplesPerSec);
    };
    MicAudioSource.prototype.destroyAudioContext = function() {
        return $4b4479812e6ce174$var$__awaiter(this, void 0, void 0, function() {
            var hasClose;
            return $4b4479812e6ce174$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!this.privContext) return [
                            2 /*return*/ 
                        ];
                        this.privRecorder.releaseMediaResources(this.privContext);
                        hasClose = false;
                        if ("close" in this.privContext) hasClose = true;
                        if (!hasClose) return [
                            3 /*break*/ ,
                            3
                        ];
                        if (!!this.privIsClosing) return [
                            3 /*break*/ ,
                            2
                        ];
                        // The audio context close may take enough time that the close is called twice
                        this.privIsClosing = true;
                        return [
                            4 /*yield*/ ,
                            this.privContext.close()
                        ];
                    case 1:
                        _a.sent();
                        this.privContext = null;
                        this.privIsClosing = false;
                        _a.label = 2;
                    case 2:
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 3:
                        if (!(null !== this.privContext && this.privContext.state === "running")) return [
                            3 /*break*/ ,
                            5
                        ];
                        // Suspend actually takes a callback, but analogous to the
                        // resume method, it'll be only fired if suspend is called
                        // in a direct response to a user action. The later is not always
                        // the case, as TurnOff is also called, when we receive an
                        // end-of-speech message from the service. So, doing a best effort
                        // fire-and-forget here.
                        return [
                            4 /*yield*/ ,
                            this.privContext.suspend()
                        ];
                    case 4:
                        // Suspend actually takes a callback, but analogous to the
                        // resume method, it'll be only fired if suspend is called
                        // in a direct response to a user action. The later is not always
                        // the case, as TurnOff is also called, when we receive an
                        // end-of-speech message from the service. So, doing a best effort
                        // fire-and-forget here.
                        _a.sent();
                        _a.label = 5;
                    case 5:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    MicAudioSource.AUDIOFORMAT = $kQmaR.AudioStreamFormat.getDefaultInputFormat();
    return MicAudioSource;
}();
module.exports.MicAudioSource = $4b4479812e6ce174$var$MicAudioSource;

});
parcelRequire.register("dEkJU", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
var $9eff1932fe9a2cc4$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $9eff1932fe9a2cc4$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) $9eff1932fe9a2cc4$var$__createBinding(exports, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.AutoDetectSourceLanguagesOpenRangeOptionName = module.exports.ForceDictationPropertyName = module.exports.ServicePropertiesPropertyName = module.exports.CancellationErrorCodePropertyName = module.exports.OutputFormatPropertyName = void 0;

// Make sure not to export internal modules.
//
$9eff1932fe9a2cc4$var$__exportStar((parcelRequire("4Py7l")), module.exports);

$9eff1932fe9a2cc4$var$__exportStar((parcelRequire("flHHa")), module.exports);

$9eff1932fe9a2cc4$var$__exportStar((parcelRequire("9wh3N")), module.exports);

$9eff1932fe9a2cc4$var$__exportStar((parcelRequire("5ysVi")), module.exports);

$9eff1932fe9a2cc4$var$__exportStar((parcelRequire("1bIv5")), module.exports);

$9eff1932fe9a2cc4$var$__exportStar((parcelRequire("cZNh2")), module.exports);

$9eff1932fe9a2cc4$var$__exportStar((parcelRequire("kz9bS")), module.exports);

$9eff1932fe9a2cc4$var$__exportStar((parcelRequire("7AiNN")), module.exports);

$9eff1932fe9a2cc4$var$__exportStar((parcelRequire("2bNJW")), module.exports);

$9eff1932fe9a2cc4$var$__exportStar((parcelRequire("363o5")), module.exports);

$9eff1932fe9a2cc4$var$__exportStar((parcelRequire("4OrXM")), module.exports);

$9eff1932fe9a2cc4$var$__exportStar((parcelRequire("lVvRc")), module.exports);

$9eff1932fe9a2cc4$var$__exportStar((parcelRequire("1R4VX")), module.exports);

$9eff1932fe9a2cc4$var$__exportStar((parcelRequire("jq15o")), module.exports);

$9eff1932fe9a2cc4$var$__exportStar((parcelRequire("girFR")), module.exports);

$9eff1932fe9a2cc4$var$__exportStar((parcelRequire("dd1J6")), module.exports);

$9eff1932fe9a2cc4$var$__exportStar((parcelRequire("b7WAi")), module.exports);

$9eff1932fe9a2cc4$var$__exportStar((parcelRequire("e2VQs")), module.exports);

$9eff1932fe9a2cc4$var$__exportStar((parcelRequire("doCmo")), module.exports);

$9eff1932fe9a2cc4$var$__exportStar((parcelRequire("3toTM")), module.exports);

$9eff1932fe9a2cc4$var$__exportStar((parcelRequire("jPLEJ")), module.exports);

$9eff1932fe9a2cc4$var$__exportStar((parcelRequire("iTk4h")), module.exports);

$9eff1932fe9a2cc4$var$__exportStar((parcelRequire("cuU1Q")), module.exports);

$9eff1932fe9a2cc4$var$__exportStar((parcelRequire("04nij")), module.exports);

$9eff1932fe9a2cc4$var$__exportStar((parcelRequire("briX4")), module.exports);

$9eff1932fe9a2cc4$var$__exportStar((parcelRequire("gTTo4")), module.exports);

$9eff1932fe9a2cc4$var$__exportStar((parcelRequire("aXg6y")), module.exports);

$9eff1932fe9a2cc4$var$__exportStar((parcelRequire("hLQpx")), module.exports);

$9eff1932fe9a2cc4$var$__exportStar((parcelRequire("kxLan")), module.exports);

$9eff1932fe9a2cc4$var$__exportStar((parcelRequire("izLqs")), module.exports);

$9eff1932fe9a2cc4$var$__exportStar((parcelRequire("f1uss")), module.exports);

$9eff1932fe9a2cc4$var$__exportStar((parcelRequire("bM30t")), module.exports);

$9eff1932fe9a2cc4$var$__exportStar((parcelRequire("1yT3h")), module.exports);

$9eff1932fe9a2cc4$var$__exportStar((parcelRequire("4FBPA")), module.exports);

$9eff1932fe9a2cc4$var$__exportStar((parcelRequire("80tNO")), module.exports);

$9eff1932fe9a2cc4$var$__exportStar((parcelRequire("8hJpO")), module.exports);

$9eff1932fe9a2cc4$var$__exportStar((parcelRequire("kg5wZ")), module.exports);

$9eff1932fe9a2cc4$var$__exportStar((parcelRequire("ge38q")), module.exports);

$9eff1932fe9a2cc4$var$__exportStar((parcelRequire("gKf87")), module.exports);

$9eff1932fe9a2cc4$var$__exportStar((parcelRequire("7HXJA")), module.exports);

$9eff1932fe9a2cc4$var$__exportStar((parcelRequire("if2Mn")), module.exports);

$9eff1932fe9a2cc4$var$__exportStar((parcelRequire("3SSAZ")), module.exports);

$9eff1932fe9a2cc4$var$__exportStar((parcelRequire("5UJWy")), module.exports);

$9eff1932fe9a2cc4$var$__exportStar((parcelRequire("gilPA")), module.exports);

$9eff1932fe9a2cc4$var$__exportStar((parcelRequire("3l6i6")), module.exports);

$9eff1932fe9a2cc4$var$__exportStar((parcelRequire("9A8d8")), module.exports);

$9eff1932fe9a2cc4$var$__exportStar((parcelRequire("7EOsZ")), module.exports);

$9eff1932fe9a2cc4$var$__exportStar((parcelRequire("3AJQx")), module.exports);

$9eff1932fe9a2cc4$var$__exportStar((parcelRequire("ezBrJ")), module.exports);

$9eff1932fe9a2cc4$var$__exportStar((parcelRequire("lTxWZ")), module.exports);
module.exports.OutputFormatPropertyName = "OutputFormat";
module.exports.CancellationErrorCodePropertyName = "CancellationErrorCode";
module.exports.ServicePropertiesPropertyName = "ServiceProperties";
module.exports.ForceDictationPropertyName = "ForceDictation";
module.exports.AutoDetectSourceLanguagesOpenRangeOptionName = "OpenRange";

});
parcelRequire.register("4Py7l", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CognitiveSubscriptionKeyAuthentication = void 0;

var $em8BD = parcelRequire("em8BD");

var $btbfh = parcelRequire("btbfh");

var $9wh3N = parcelRequire("9wh3N");
/**
 * @class
 */ var $384663dd155f2b06$var$CognitiveSubscriptionKeyAuthentication = /** @class */ function() {
    /**
     * Creates and initializes an instance of the CognitiveSubscriptionKeyAuthentication class.
     * @constructor
     * @param {string} subscriptionKey - The subscription key
     */ function CognitiveSubscriptionKeyAuthentication(subscriptionKey) {
        if (!subscriptionKey) throw new $em8BD.ArgumentNullError("subscriptionKey");
        this.privAuthInfo = new $9wh3N.AuthInfo($btbfh.HeaderNames.AuthKey, subscriptionKey);
    }
    /**
     * Fetches the subscription key.
     * @member
     * @function
     * @public
     * @param {string} authFetchEventId - The id to fetch.
     */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
    CognitiveSubscriptionKeyAuthentication.prototype.fetch = function(authFetchEventId) {
        return Promise.resolve(this.privAuthInfo);
    };
    /**
     * Fetches the subscription key.
     * @member
     * @function
     * @public
     * @param {string} authFetchEventId - The id to fetch.
     */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
    CognitiveSubscriptionKeyAuthentication.prototype.fetchOnExpiry = function(authFetchEventId) {
        return Promise.resolve(this.privAuthInfo);
    };
    return CognitiveSubscriptionKeyAuthentication;
}();
module.exports.CognitiveSubscriptionKeyAuthentication = $384663dd155f2b06$var$CognitiveSubscriptionKeyAuthentication;

});
parcelRequire.register("btbfh", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.HeaderNames = void 0;
var $859b20400e4af183$var$HeaderNames = /** @class */ function() {
    function HeaderNames() {}
    HeaderNames.AuthKey = "Ocp-Apim-Subscription-Key";
    HeaderNames.Authorization = "Authorization";
    HeaderNames.SpIDAuthKey = "Apim-Subscription-Id";
    HeaderNames.ConnectionId = "X-ConnectionId";
    HeaderNames.ContentType = "Content-Type";
    HeaderNames.CustomCommandsAppId = "X-CommandsAppId";
    HeaderNames.Path = "Path";
    HeaderNames.RequestId = "X-RequestId";
    HeaderNames.RequestStreamId = "X-StreamId";
    HeaderNames.RequestTimestamp = "X-Timestamp";
    return HeaderNames;
}();
module.exports.HeaderNames = $859b20400e4af183$var$HeaderNames;

});

parcelRequire.register("9wh3N", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.AuthInfo = void 0;
var $6ee4560725e3aa48$var$AuthInfo = /** @class */ function() {
    function AuthInfo(headerName, token) {
        this.privHeaderName = headerName;
        this.privToken = token;
    }
    Object.defineProperty(AuthInfo.prototype, "headerName", {
        get: function() {
            return this.privHeaderName;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AuthInfo.prototype, "token", {
        get: function() {
            return this.privToken;
        },
        enumerable: false,
        configurable: true
    });
    return AuthInfo;
}();
module.exports.AuthInfo = $6ee4560725e3aa48$var$AuthInfo;

});


parcelRequire.register("flHHa", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CognitiveTokenAuthentication = void 0;

var $em8BD = parcelRequire("em8BD");

var $9wh3N = parcelRequire("9wh3N");

var $btbfh = parcelRequire("btbfh");
var $b2cab6233f552447$var$CognitiveTokenAuthentication = /** @class */ function() {
    function CognitiveTokenAuthentication(fetchCallback, fetchOnExpiryCallback) {
        if (!fetchCallback) throw new $em8BD.ArgumentNullError("fetchCallback");
        if (!fetchOnExpiryCallback) throw new $em8BD.ArgumentNullError("fetchOnExpiryCallback");
        this.privFetchCallback = fetchCallback;
        this.privFetchOnExpiryCallback = fetchOnExpiryCallback;
    }
    CognitiveTokenAuthentication.prototype.fetch = function(authFetchEventId) {
        return this.privFetchCallback(authFetchEventId).then(function(token) {
            return new $9wh3N.AuthInfo($btbfh.HeaderNames.Authorization, token === undefined ? undefined : CognitiveTokenAuthentication.privTokenPrefix + token);
        });
    };
    CognitiveTokenAuthentication.prototype.fetchOnExpiry = function(authFetchEventId) {
        return this.privFetchOnExpiryCallback(authFetchEventId).then(function(token) {
            return new $9wh3N.AuthInfo($btbfh.HeaderNames.Authorization, token === undefined ? undefined : CognitiveTokenAuthentication.privTokenPrefix + token);
        });
    };
    CognitiveTokenAuthentication.privTokenPrefix = "bearer ";
    return CognitiveTokenAuthentication;
}();
module.exports.CognitiveTokenAuthentication = $b2cab6233f552447$var$CognitiveTokenAuthentication;

});

parcelRequire.register("5ysVi", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRequire.register("1bIv5", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRequire.register("cZNh2", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
var $9761674e901eb7e8$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.IntentConnectionFactory = void 0;

var $j1V0D = parcelRequire("j1V0D");

var $hM4QX = parcelRequire("hM4QX");

var $hGMva = parcelRequire("hGMva");

var $dEkJU = parcelRequire("dEkJU");

var $btbfh = parcelRequire("btbfh");
var $9761674e901eb7e8$var$IntentConnectionFactory = /** @class */ function(_super) {
    $9761674e901eb7e8$var$__extends(IntentConnectionFactory, _super);
    function IntentConnectionFactory() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    IntentConnectionFactory.prototype.create = function(config, authInfo, connectionId) {
        var endpoint = config.parameters.getProperty($hM4QX.PropertyId.SpeechServiceConnection_Endpoint);
        if (!endpoint) {
            var region = config.parameters.getProperty($hM4QX.PropertyId.SpeechServiceConnection_IntentRegion);
            var hostSuffix = $hGMva.ConnectionFactoryBase.getHostSuffix(region);
            var host = config.parameters.getProperty($hM4QX.PropertyId.SpeechServiceConnection_Host, "wss://" + region + ".sr.speech" + hostSuffix);
            endpoint = host + "/speech/recognition/interactive/cognitiveservices/v1";
        }
        var queryParams = {
            format: "simple",
            language: config.parameters.getProperty($hM4QX.PropertyId.SpeechServiceConnection_RecoLanguage)
        };
        this.setCommonUrlParams(config, queryParams, endpoint);
        var headers = {};
        if (authInfo.token !== undefined && authInfo.token !== "") headers[authInfo.headerName] = authInfo.token;
        headers[$btbfh.HeaderNames.ConnectionId] = connectionId;
        config.parameters.setProperty($hM4QX.PropertyId.SpeechServiceConnection_Url, endpoint);
        var enableCompression = config.parameters.getProperty("SPEECH-EnableWebsocketCompression", "false") === "true";
        return new $j1V0D.WebsocketConnection(endpoint, queryParams, headers, new $dEkJU.WebsocketMessageFormatter(), $j1V0D.ProxyInfo.fromRecognizerConfig(config), enableCompression, connectionId);
    };
    IntentConnectionFactory.prototype.getSpeechRegionFromIntentRegion = function(intentRegion) {
        switch(intentRegion){
            case "West US":
            case "US West":
            case "westus":
                return "uswest";
            case "West US 2":
            case "US West 2":
            case "westus2":
                return "uswest2";
            case "South Central US":
            case "US South Central":
            case "southcentralus":
                return "ussouthcentral";
            case "West Central US":
            case "US West Central":
            case "westcentralus":
                return "uswestcentral";
            case "East US":
            case "US East":
            case "eastus":
                return "useast";
            case "East US 2":
            case "US East 2":
            case "eastus2":
                return "useast2";
            case "West Europe":
            case "Europe West":
            case "westeurope":
                return "europewest";
            case "North Europe":
            case "Europe North":
            case "northeurope":
                return "europenorth";
            case "Brazil South":
            case "South Brazil":
            case "southbrazil":
                return "brazilsouth";
            case "Australia East":
            case "East Australia":
            case "eastaustralia":
                return "australiaeast";
            case "Southeast Asia":
            case "Asia Southeast":
            case "southeastasia":
                return "asiasoutheast";
            case "East Asia":
            case "Asia East":
            case "eastasia":
                return "asiaeast";
            default:
                return intentRegion;
        }
    };
    return IntentConnectionFactory;
}($hGMva.ConnectionFactoryBase);
module.exports.IntentConnectionFactory = $9761674e901eb7e8$var$IntentConnectionFactory;

});
parcelRequire.register("hM4QX", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $dSeiF = parcelRequire("dSeiF");
Object.defineProperty(module.exports, "AudioConfig", {
    enumerable: true,
    get: function() {
        return $dSeiF.AudioConfig;
    }
});

var $kQmaR = parcelRequire("kQmaR");
Object.defineProperty(module.exports, "AudioStreamFormat", {
    enumerable: true,
    get: function() {
        return $kQmaR.AudioStreamFormat;
    }
});
Object.defineProperty(module.exports, "AudioFormatTag", {
    enumerable: true,
    get: function() {
        return $kQmaR.AudioFormatTag;
    }
});

var $hEE25 = parcelRequire("hEE25");
Object.defineProperty(module.exports, "AudioInputStream", {
    enumerable: true,
    get: function() {
        return $hEE25.AudioInputStream;
    }
});
Object.defineProperty(module.exports, "PullAudioInputStream", {
    enumerable: true,
    get: function() {
        return $hEE25.PullAudioInputStream;
    }
});
Object.defineProperty(module.exports, "PushAudioInputStream", {
    enumerable: true,
    get: function() {
        return $hEE25.PushAudioInputStream;
    }
});

var $aBCur = parcelRequire("aBCur");
Object.defineProperty(module.exports, "AudioOutputStream", {
    enumerable: true,
    get: function() {
        return $aBCur.AudioOutputStream;
    }
});
Object.defineProperty(module.exports, "PullAudioOutputStream", {
    enumerable: true,
    get: function() {
        return $aBCur.PullAudioOutputStream;
    }
});
Object.defineProperty(module.exports, "PushAudioOutputStream", {
    enumerable: true,
    get: function() {
        return $aBCur.PushAudioOutputStream;
    }
});

var $IfD4S = parcelRequire("IfD4S");
Object.defineProperty(module.exports, "CancellationReason", {
    enumerable: true,
    get: function() {
        return $IfD4S.CancellationReason;
    }
});

var $LBUiN = parcelRequire("LBUiN");
Object.defineProperty(module.exports, "PullAudioInputStreamCallback", {
    enumerable: true,
    get: function() {
        return $LBUiN.PullAudioInputStreamCallback;
    }
});

var $bonmI = parcelRequire("bonmI");
Object.defineProperty(module.exports, "PushAudioOutputStreamCallback", {
    enumerable: true,
    get: function() {
        return $bonmI.PushAudioOutputStreamCallback;
    }
});

var $9vsgp = parcelRequire("9vsgp");
Object.defineProperty(module.exports, "KeywordRecognitionModel", {
    enumerable: true,
    get: function() {
        return $9vsgp.KeywordRecognitionModel;
    }
});

var $9x63P = parcelRequire("9x63P");
Object.defineProperty(module.exports, "SessionEventArgs", {
    enumerable: true,
    get: function() {
        return $9x63P.SessionEventArgs;
    }
});

var $1ideR = parcelRequire("1ideR");
Object.defineProperty(module.exports, "RecognitionEventArgs", {
    enumerable: true,
    get: function() {
        return $1ideR.RecognitionEventArgs;
    }
});

var $ckS1Y = parcelRequire("ckS1Y");
Object.defineProperty(module.exports, "OutputFormat", {
    enumerable: true,
    get: function() {
        return $ckS1Y.OutputFormat;
    }
});

var $1tJst = parcelRequire("1tJst");
Object.defineProperty(module.exports, "IntentRecognitionEventArgs", {
    enumerable: true,
    get: function() {
        return $1tJst.IntentRecognitionEventArgs;
    }
});

var $b3knn = parcelRequire("b3knn");
Object.defineProperty(module.exports, "RecognitionResult", {
    enumerable: true,
    get: function() {
        return $b3knn.RecognitionResult;
    }
});

var $1p4s1 = parcelRequire("1p4s1");
Object.defineProperty(module.exports, "SpeechRecognitionResult", {
    enumerable: true,
    get: function() {
        return $1p4s1.SpeechRecognitionResult;
    }
});

var $bKK6x = parcelRequire("bKK6x");
Object.defineProperty(module.exports, "IntentRecognitionResult", {
    enumerable: true,
    get: function() {
        return $bKK6x.IntentRecognitionResult;
    }
});

var $aTDd7 = parcelRequire("aTDd7");
Object.defineProperty(module.exports, "LanguageUnderstandingModel", {
    enumerable: true,
    get: function() {
        return $aTDd7.LanguageUnderstandingModel;
    }
});

var $fbvsc = parcelRequire("fbvsc");
Object.defineProperty(module.exports, "SpeechRecognitionEventArgs", {
    enumerable: true,
    get: function() {
        return $fbvsc.SpeechRecognitionEventArgs;
    }
});
Object.defineProperty(module.exports, "ConversationTranscriptionEventArgs", {
    enumerable: true,
    get: function() {
        return $fbvsc.ConversationTranscriptionEventArgs;
    }
});

var $b471r = parcelRequire("b471r");
Object.defineProperty(module.exports, "SpeechRecognitionCanceledEventArgs", {
    enumerable: true,
    get: function() {
        return $b471r.SpeechRecognitionCanceledEventArgs;
    }
});

var $c4iTO = parcelRequire("c4iTO");
Object.defineProperty(module.exports, "TranslationRecognitionEventArgs", {
    enumerable: true,
    get: function() {
        return $c4iTO.TranslationRecognitionEventArgs;
    }
});

var $aQlJv = parcelRequire("aQlJv");
Object.defineProperty(module.exports, "TranslationSynthesisEventArgs", {
    enumerable: true,
    get: function() {
        return $aQlJv.TranslationSynthesisEventArgs;
    }
});

var $kYmQY = parcelRequire("kYmQY");
Object.defineProperty(module.exports, "TranslationRecognitionResult", {
    enumerable: true,
    get: function() {
        return $kYmQY.TranslationRecognitionResult;
    }
});

var $9ny4h = parcelRequire("9ny4h");
Object.defineProperty(module.exports, "TranslationSynthesisResult", {
    enumerable: true,
    get: function() {
        return $9ny4h.TranslationSynthesisResult;
    }
});

var $5AfIy = parcelRequire("5AfIy");
Object.defineProperty(module.exports, "ResultReason", {
    enumerable: true,
    get: function() {
        return $5AfIy.ResultReason;
    }
});

var $69QpD = parcelRequire("69QpD");
Object.defineProperty(module.exports, "SpeechConfig", {
    enumerable: true,
    get: function() {
        return $69QpD.SpeechConfig;
    }
});
Object.defineProperty(module.exports, "SpeechConfigImpl", {
    enumerable: true,
    get: function() {
        return $69QpD.SpeechConfigImpl;
    }
});

var $eC1yh = parcelRequire("eC1yh");
Object.defineProperty(module.exports, "SpeechTranslationConfig", {
    enumerable: true,
    get: function() {
        return $eC1yh.SpeechTranslationConfig;
    }
});
Object.defineProperty(module.exports, "SpeechTranslationConfigImpl", {
    enumerable: true,
    get: function() {
        return $eC1yh.SpeechTranslationConfigImpl;
    }
});

var $i2Xql = parcelRequire("i2Xql");
Object.defineProperty(module.exports, "PropertyCollection", {
    enumerable: true,
    get: function() {
        return $i2Xql.PropertyCollection;
    }
});

var $8TH7f = parcelRequire("8TH7f");
Object.defineProperty(module.exports, "PropertyId", {
    enumerable: true,
    get: function() {
        return $8TH7f.PropertyId;
    }
});

var $KKCGx = parcelRequire("KKCGx");
Object.defineProperty(module.exports, "Recognizer", {
    enumerable: true,
    get: function() {
        return $KKCGx.Recognizer;
    }
});

var $42zO9 = parcelRequire("42zO9");
Object.defineProperty(module.exports, "SpeechRecognizer", {
    enumerable: true,
    get: function() {
        return $42zO9.SpeechRecognizer;
    }
});

var $2wjgv = parcelRequire("2wjgv");
Object.defineProperty(module.exports, "IntentRecognizer", {
    enumerable: true,
    get: function() {
        return $2wjgv.IntentRecognizer;
    }
});

var $hN0ZH = parcelRequire("hN0ZH");
Object.defineProperty(module.exports, "VoiceProfileType", {
    enumerable: true,
    get: function() {
        return $hN0ZH.VoiceProfileType;
    }
});

var $8Cnfw = parcelRequire("8Cnfw");
Object.defineProperty(module.exports, "TranslationRecognizer", {
    enumerable: true,
    get: function() {
        return $8Cnfw.TranslationRecognizer;
    }
});

var $b12ZL = parcelRequire("b12ZL");
Object.defineProperty(module.exports, "Translations", {
    enumerable: true,
    get: function() {
        return $b12ZL.Translations;
    }
});

var $6ILle = parcelRequire("6ILle");
Object.defineProperty(module.exports, "NoMatchReason", {
    enumerable: true,
    get: function() {
        return $6ILle.NoMatchReason;
    }
});

var $4pHMu = parcelRequire("4pHMu");
Object.defineProperty(module.exports, "NoMatchDetails", {
    enumerable: true,
    get: function() {
        return $4pHMu.NoMatchDetails;
    }
});

var $iqPNR = parcelRequire("iqPNR");
Object.defineProperty(module.exports, "TranslationRecognitionCanceledEventArgs", {
    enumerable: true,
    get: function() {
        return $iqPNR.TranslationRecognitionCanceledEventArgs;
    }
});

var $elLCc = parcelRequire("elLCc");
Object.defineProperty(module.exports, "IntentRecognitionCanceledEventArgs", {
    enumerable: true,
    get: function() {
        return $elLCc.IntentRecognitionCanceledEventArgs;
    }
});

var $6zUYZ = parcelRequire("6zUYZ");
Object.defineProperty(module.exports, "CancellationDetailsBase", {
    enumerable: true,
    get: function() {
        return $6zUYZ.CancellationDetailsBase;
    }
});

var $74VkW = parcelRequire("74VkW");
Object.defineProperty(module.exports, "CancellationDetails", {
    enumerable: true,
    get: function() {
        return $74VkW.CancellationDetails;
    }
});

var $tD9yJ = parcelRequire("tD9yJ");
Object.defineProperty(module.exports, "CancellationErrorCode", {
    enumerable: true,
    get: function() {
        return $tD9yJ.CancellationErrorCode;
    }
});

var $kjHv9 = parcelRequire("kjHv9");
Object.defineProperty(module.exports, "ConnectionEventArgs", {
    enumerable: true,
    get: function() {
        return $kjHv9.ConnectionEventArgs;
    }
});

var $cTeh8 = parcelRequire("cTeh8");
Object.defineProperty(module.exports, "ServiceEventArgs", {
    enumerable: true,
    get: function() {
        return $cTeh8.ServiceEventArgs;
    }
});

var $0Yrfd = parcelRequire("0Yrfd");
Object.defineProperty(module.exports, "Connection", {
    enumerable: true,
    get: function() {
        return $0Yrfd.Connection;
    }
});

var $6gTLx = parcelRequire("6gTLx");
Object.defineProperty(module.exports, "PhraseListGrammar", {
    enumerable: true,
    get: function() {
        return $6gTLx.PhraseListGrammar;
    }
});

var $7mmFy = parcelRequire("7mmFy");
Object.defineProperty(module.exports, "DialogServiceConfig", {
    enumerable: true,
    get: function() {
        return $7mmFy.DialogServiceConfig;
    }
});

var $48y7u = parcelRequire("48y7u");
Object.defineProperty(module.exports, "BotFrameworkConfig", {
    enumerable: true,
    get: function() {
        return $48y7u.BotFrameworkConfig;
    }
});

var $5X2ZB = parcelRequire("5X2ZB");
Object.defineProperty(module.exports, "CustomCommandsConfig", {
    enumerable: true,
    get: function() {
        return $5X2ZB.CustomCommandsConfig;
    }
});

var $2Jdvk = parcelRequire("2Jdvk");
Object.defineProperty(module.exports, "DialogServiceConnector", {
    enumerable: true,
    get: function() {
        return $2Jdvk.DialogServiceConnector;
    }
});

var $9gBpC = parcelRequire("9gBpC");
Object.defineProperty(module.exports, "ActivityReceivedEventArgs", {
    enumerable: true,
    get: function() {
        return $9gBpC.ActivityReceivedEventArgs;
    }
});

var $bZGg5 = parcelRequire("bZGg5");
Object.defineProperty(module.exports, "TurnStatusReceivedEventArgs", {
    enumerable: true,
    get: function() {
        return $bZGg5.TurnStatusReceivedEventArgs;
    }
});

var $kG8Gw = parcelRequire("kG8Gw");
Object.defineProperty(module.exports, "ServicePropertyChannel", {
    enumerable: true,
    get: function() {
        return $kG8Gw.ServicePropertyChannel;
    }
});

var $9eMRA = parcelRequire("9eMRA");
Object.defineProperty(module.exports, "ProfanityOption", {
    enumerable: true,
    get: function() {
        return $9eMRA.ProfanityOption;
    }
});

var $k48LU = parcelRequire("k48LU");
Object.defineProperty(module.exports, "BaseAudioPlayer", {
    enumerable: true,
    get: function() {
        return $k48LU.BaseAudioPlayer;
    }
});

var $4yKJG = parcelRequire("4yKJG");
Object.defineProperty(module.exports, "ConnectionMessageEventArgs", {
    enumerable: true,
    get: function() {
        return $4yKJG.ConnectionMessageEventArgs;
    }
});

var $3z8sc = parcelRequire("3z8sc");
Object.defineProperty(module.exports, "ConnectionMessage", {
    enumerable: true,
    get: function() {
        return $3z8sc.ConnectionMessage;
    }
});

var $9By7J = parcelRequire("9By7J");
Object.defineProperty(module.exports, "VoiceProfile", {
    enumerable: true,
    get: function() {
        return $9By7J.VoiceProfile;
    }
});

var $7WNJy = parcelRequire("7WNJy");
Object.defineProperty(module.exports, "VoiceProfileEnrollmentResult", {
    enumerable: true,
    get: function() {
        return $7WNJy.VoiceProfileEnrollmentResult;
    }
});
Object.defineProperty(module.exports, "VoiceProfileEnrollmentCancellationDetails", {
    enumerable: true,
    get: function() {
        return $7WNJy.VoiceProfileEnrollmentCancellationDetails;
    }
});

var $4qwZJ = parcelRequire("4qwZJ");
Object.defineProperty(module.exports, "VoiceProfileResult", {
    enumerable: true,
    get: function() {
        return $4qwZJ.VoiceProfileResult;
    }
});
Object.defineProperty(module.exports, "VoiceProfileCancellationDetails", {
    enumerable: true,
    get: function() {
        return $4qwZJ.VoiceProfileCancellationDetails;
    }
});

var $jjrBQ = parcelRequire("jjrBQ");
Object.defineProperty(module.exports, "VoiceProfilePhraseResult", {
    enumerable: true,
    get: function() {
        return $jjrBQ.VoiceProfilePhraseResult;
    }
});

var $eBxhK = parcelRequire("eBxhK");
Object.defineProperty(module.exports, "VoiceProfileClient", {
    enumerable: true,
    get: function() {
        return $eBxhK.VoiceProfileClient;
    }
});

var $1miKD = parcelRequire("1miKD");
Object.defineProperty(module.exports, "SpeakerRecognizer", {
    enumerable: true,
    get: function() {
        return $1miKD.SpeakerRecognizer;
    }
});

var $adVUs = parcelRequire("adVUs");
Object.defineProperty(module.exports, "SpeakerIdentificationModel", {
    enumerable: true,
    get: function() {
        return $adVUs.SpeakerIdentificationModel;
    }
});

var $asCMT = parcelRequire("asCMT");
Object.defineProperty(module.exports, "SpeakerVerificationModel", {
    enumerable: true,
    get: function() {
        return $asCMT.SpeakerVerificationModel;
    }
});

var $dg3Jy = parcelRequire("dg3Jy");
Object.defineProperty(module.exports, "AutoDetectSourceLanguageConfig", {
    enumerable: true,
    get: function() {
        return $dg3Jy.AutoDetectSourceLanguageConfig;
    }
});

var $l9vJq = parcelRequire("l9vJq");
Object.defineProperty(module.exports, "AutoDetectSourceLanguageResult", {
    enumerable: true,
    get: function() {
        return $l9vJq.AutoDetectSourceLanguageResult;
    }
});

var $gEoih = parcelRequire("gEoih");
Object.defineProperty(module.exports, "SourceLanguageConfig", {
    enumerable: true,
    get: function() {
        return $gEoih.SourceLanguageConfig;
    }
});

var $eQcct = parcelRequire("eQcct");
Object.defineProperty(module.exports, "SpeakerRecognitionResult", {
    enumerable: true,
    get: function() {
        return $eQcct.SpeakerRecognitionResult;
    }
});
Object.defineProperty(module.exports, "SpeakerRecognitionResultType", {
    enumerable: true,
    get: function() {
        return $eQcct.SpeakerRecognitionResultType;
    }
});
Object.defineProperty(module.exports, "SpeakerRecognitionCancellationDetails", {
    enumerable: true,
    get: function() {
        return $eQcct.SpeakerRecognitionCancellationDetails;
    }
});

var $a9O70 = parcelRequire("a9O70");
Object.defineProperty(module.exports, "Conversation", {
    enumerable: true,
    get: function() {
        return $a9O70.Conversation;
    }
});
Object.defineProperty(module.exports, "ConversationExpirationEventArgs", {
    enumerable: true,
    get: function() {
        return $a9O70.ConversationExpirationEventArgs;
    }
});
Object.defineProperty(module.exports, "ConversationParticipantsChangedEventArgs", {
    enumerable: true,
    get: function() {
        return $a9O70.ConversationParticipantsChangedEventArgs;
    }
});
Object.defineProperty(module.exports, "ConversationTranslationCanceledEventArgs", {
    enumerable: true,
    get: function() {
        return $a9O70.ConversationTranslationCanceledEventArgs;
    }
});
Object.defineProperty(module.exports, "ConversationTranslationEventArgs", {
    enumerable: true,
    get: function() {
        return $a9O70.ConversationTranslationEventArgs;
    }
});
Object.defineProperty(module.exports, "ConversationTranslationResult", {
    enumerable: true,
    get: function() {
        return $a9O70.ConversationTranslationResult;
    }
});
Object.defineProperty(module.exports, "ConversationTranslator", {
    enumerable: true,
    get: function() {
        return $a9O70.ConversationTranslator;
    }
});
Object.defineProperty(module.exports, "ConversationTranscriber", {
    enumerable: true,
    get: function() {
        return $a9O70.ConversationTranscriber;
    }
});
Object.defineProperty(module.exports, "Participant", {
    enumerable: true,
    get: function() {
        return $a9O70.Participant;
    }
});
Object.defineProperty(module.exports, "ParticipantChangedReason", {
    enumerable: true,
    get: function() {
        return $a9O70.ParticipantChangedReason;
    }
});
Object.defineProperty(module.exports, "User", {
    enumerable: true,
    get: function() {
        return $a9O70.User;
    }
});

var $bvGqq = parcelRequire("bvGqq");
Object.defineProperty(module.exports, "SpeechSynthesisOutputFormat", {
    enumerable: true,
    get: function() {
        return $bvGqq.SpeechSynthesisOutputFormat;
    }
});

var $8v54X = parcelRequire("8v54X");
Object.defineProperty(module.exports, "SpeechSynthesizer", {
    enumerable: true,
    get: function() {
        return $8v54X.SpeechSynthesizer;
    }
});

var $brZgy = parcelRequire("brZgy");
Object.defineProperty(module.exports, "SynthesisResult", {
    enumerable: true,
    get: function() {
        return $brZgy.SynthesisResult;
    }
});

var $ijvif = parcelRequire("ijvif");
Object.defineProperty(module.exports, "SpeechSynthesisResult", {
    enumerable: true,
    get: function() {
        return $ijvif.SpeechSynthesisResult;
    }
});

var $bAXfe = parcelRequire("bAXfe");
Object.defineProperty(module.exports, "SpeechSynthesisEventArgs", {
    enumerable: true,
    get: function() {
        return $bAXfe.SpeechSynthesisEventArgs;
    }
});

var $yArfV = parcelRequire("yArfV");
Object.defineProperty(module.exports, "SpeechSynthesisWordBoundaryEventArgs", {
    enumerable: true,
    get: function() {
        return $yArfV.SpeechSynthesisWordBoundaryEventArgs;
    }
});

var $jBQ4L = parcelRequire("jBQ4L");
Object.defineProperty(module.exports, "SpeechSynthesisBookmarkEventArgs", {
    enumerable: true,
    get: function() {
        return $jBQ4L.SpeechSynthesisBookmarkEventArgs;
    }
});

var $c40Gm = parcelRequire("c40Gm");
Object.defineProperty(module.exports, "SpeechSynthesisVisemeEventArgs", {
    enumerable: true,
    get: function() {
        return $c40Gm.SpeechSynthesisVisemeEventArgs;
    }
});

var $5Y2xz = parcelRequire("5Y2xz");
Object.defineProperty(module.exports, "SpeechSynthesisBoundaryType", {
    enumerable: true,
    get: function() {
        return $5Y2xz.SpeechSynthesisBoundaryType;
    }
});

var $9HGHW = parcelRequire("9HGHW");
Object.defineProperty(module.exports, "SynthesisVoicesResult", {
    enumerable: true,
    get: function() {
        return $9HGHW.SynthesisVoicesResult;
    }
});

var $aomNU = parcelRequire("aomNU");
Object.defineProperty(module.exports, "VoiceInfo", {
    enumerable: true,
    get: function() {
        return $aomNU.VoiceInfo;
    }
});

var $dKDy8 = parcelRequire("dKDy8");
Object.defineProperty(module.exports, "SpeakerAudioDestination", {
    enumerable: true,
    get: function() {
        return $dKDy8.SpeakerAudioDestination;
    }
});

var $jjUPK = parcelRequire("jjUPK");
Object.defineProperty(module.exports, "ConversationTranscriptionCanceledEventArgs", {
    enumerable: true,
    get: function() {
        return $jjUPK.ConversationTranscriptionCanceledEventArgs;
    }
});

var $1yr2l = parcelRequire("1yr2l");
Object.defineProperty(module.exports, "PronunciationAssessmentGradingSystem", {
    enumerable: true,
    get: function() {
        return $1yr2l.PronunciationAssessmentGradingSystem;
    }
});

var $lqGfe = parcelRequire("lqGfe");
Object.defineProperty(module.exports, "PronunciationAssessmentGranularity", {
    enumerable: true,
    get: function() {
        return $lqGfe.PronunciationAssessmentGranularity;
    }
});

var $cyCZy = parcelRequire("cyCZy");
Object.defineProperty(module.exports, "PronunciationAssessmentConfig", {
    enumerable: true,
    get: function() {
        return $cyCZy.PronunciationAssessmentConfig;
    }
});

var $5MDwd = parcelRequire("5MDwd");
Object.defineProperty(module.exports, "PronunciationAssessmentResult", {
    enumerable: true,
    get: function() {
        return $5MDwd.PronunciationAssessmentResult;
    }
});

var $lf3Sn = parcelRequire("lf3Sn");
Object.defineProperty(module.exports, "LanguageIdMode", {
    enumerable: true,
    get: function() {
        return $lf3Sn.LanguageIdMode;
    }
});

var $39i8h = parcelRequire("39i8h");
Object.defineProperty(module.exports, "Diagnostics", {
    enumerable: true,
    get: function() {
        return $39i8h.Diagnostics;
    }
});

var $kYr7L = parcelRequire("kYr7L");
Object.defineProperty(module.exports, "LogLevel", {
    enumerable: true,
    get: function() {
        return $kYr7L.LogLevel;
    }
});

});
parcelRequire.register("dSeiF", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
var $a19b693b0646cd94$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.AudioOutputConfigImpl = module.exports.AudioConfigImpl = module.exports.AudioConfig = void 0;

var $j1V0D = parcelRequire("j1V0D");

var $gBGZx = parcelRequire("gBGZx");

var $hM4QX = parcelRequire("hM4QX");

var $2ZQip = parcelRequire("2ZQip");

var $hEE25 = parcelRequire("hEE25");

var $aBCur = parcelRequire("aBCur");
/**
 * Represents audio input configuration used for specifying what type of input to use (microphone, file, stream).
 * @class AudioConfig
 * Updated in version 1.11.0
 */ var $a19b693b0646cd94$var$AudioConfig = /** @class */ function() {
    function AudioConfig() {}
    /**
     * Creates an AudioConfig object representing the default microphone on the system.
     * @member AudioConfig.fromDefaultMicrophoneInput
     * @function
     * @public
     * @returns {AudioConfig} The audio input configuration being created.
     */ AudioConfig.fromDefaultMicrophoneInput = function() {
        var pcmRecorder = new $j1V0D.PcmRecorder(true);
        return new $a19b693b0646cd94$var$AudioConfigImpl(new $j1V0D.MicAudioSource(pcmRecorder));
    };
    /**
     * Creates an AudioConfig object representing a microphone with the specified device ID.
     * @member AudioConfig.fromMicrophoneInput
     * @function
     * @public
     * @param {string | undefined} deviceId - Specifies the device ID of the microphone to be used.
     * Default microphone is used the value is omitted.
     * @returns {AudioConfig} The audio input configuration being created.
     */ AudioConfig.fromMicrophoneInput = function(deviceId) {
        var pcmRecorder = new $j1V0D.PcmRecorder(true);
        return new $a19b693b0646cd94$var$AudioConfigImpl(new $j1V0D.MicAudioSource(pcmRecorder, deviceId));
    };
    /**
     * Creates an AudioConfig object representing the specified file.
     * @member AudioConfig.fromWavFileInput
     * @function
     * @public
     * @param {File} fileName - Specifies the audio input file. Currently, only WAV / PCM is supported.
     * @returns {AudioConfig} The audio input configuration being created.
     */ AudioConfig.fromWavFileInput = function(file, name) {
        if (name === void 0) name = "unnamedBuffer.wav";
        return new $a19b693b0646cd94$var$AudioConfigImpl(new $j1V0D.FileAudioSource(file, name));
    };
    /**
     * Creates an AudioConfig object representing the specified stream.
     * @member AudioConfig.fromStreamInput
     * @function
     * @public
     * @param {AudioInputStream | PullAudioInputStreamCallback | MediaStream} audioStream - Specifies the custom audio input
     * stream. Currently, only WAV / PCM is supported.
     * @returns {AudioConfig} The audio input configuration being created.
     */ AudioConfig.fromStreamInput = function(audioStream) {
        if (audioStream instanceof $hM4QX.PullAudioInputStreamCallback) return new $a19b693b0646cd94$var$AudioConfigImpl(new $hEE25.PullAudioInputStreamImpl(audioStream));
        if (audioStream instanceof $hM4QX.AudioInputStream) return new $a19b693b0646cd94$var$AudioConfigImpl(audioStream);
        if (typeof MediaStream !== "undefined" && audioStream instanceof MediaStream) {
            var pcmRecorder = new $j1V0D.PcmRecorder(false);
            return new $a19b693b0646cd94$var$AudioConfigImpl(new $j1V0D.MicAudioSource(pcmRecorder, null, null, audioStream));
        }
        throw new Error("Not Supported Type");
    };
    /**
     * Creates an AudioConfig object representing the default speaker.
     * @member AudioConfig.fromDefaultSpeakerOutput
     * @function
     * @public
     * @returns {AudioConfig} The audio output configuration being created.
     * Added in version 1.11.0
     */ AudioConfig.fromDefaultSpeakerOutput = function() {
        return new $a19b693b0646cd94$var$AudioOutputConfigImpl(new $hM4QX.SpeakerAudioDestination());
    };
    /**
     * Creates an AudioConfig object representing the custom IPlayer object.
     * You can use the IPlayer object to control pause, resume, etc.
     * @member AudioConfig.fromSpeakerOutput
     * @function
     * @public
     * @param {IPlayer} player - the IPlayer object for playback.
     * @returns {AudioConfig} The audio output configuration being created.
     * Added in version 1.12.0
     */ AudioConfig.fromSpeakerOutput = function(player) {
        if (player === undefined) return AudioConfig.fromDefaultSpeakerOutput();
        if (player instanceof $hM4QX.SpeakerAudioDestination) return new $a19b693b0646cd94$var$AudioOutputConfigImpl(player);
        throw new Error("Not Supported Type");
    };
    /**
     * Creates an AudioConfig object representing a specified output audio file
     * @member AudioConfig.fromAudioFileOutput
     * @function
     * @public
     * @param {PathLike} filename - the filename of the output audio file
     * @returns {AudioConfig} The audio output configuration being created.
     * Added in version 1.11.0
     */ AudioConfig.fromAudioFileOutput = function(filename) {
        return new $a19b693b0646cd94$var$AudioOutputConfigImpl(new $2ZQip.AudioFileWriter(filename));
    };
    /**
     * Creates an AudioConfig object representing a specified audio output stream
     * @member AudioConfig.fromStreamOutput
     * @function
     * @public
     * @param {AudioOutputStream | PushAudioOutputStreamCallback} audioStream - Specifies the custom audio output
     * stream.
     * @returns {AudioConfig} The audio output configuration being created.
     * Added in version 1.11.0
     */ AudioConfig.fromStreamOutput = function(audioStream) {
        if (audioStream instanceof $hM4QX.PushAudioOutputStreamCallback) return new $a19b693b0646cd94$var$AudioOutputConfigImpl(new $aBCur.PushAudioOutputStreamImpl(audioStream));
        if (audioStream instanceof $hM4QX.PushAudioOutputStream) return new $a19b693b0646cd94$var$AudioOutputConfigImpl(audioStream);
        if (audioStream instanceof $hM4QX.PullAudioOutputStream) return new $a19b693b0646cd94$var$AudioOutputConfigImpl(audioStream);
        throw new Error("Not Supported Type");
    };
    return AudioConfig;
}();
module.exports.AudioConfig = $a19b693b0646cd94$var$AudioConfig;
/**
 * Represents audio input stream used for custom audio input configurations.
 * @private
 * @class AudioConfigImpl
 */ var $a19b693b0646cd94$var$AudioConfigImpl = /** @class */ function(_super) {
    $a19b693b0646cd94$var$__extends(AudioConfigImpl, _super);
    /**
     * Creates and initializes an instance of this class.
     * @constructor
     * @param {IAudioSource} source - An audio source.
     */ function AudioConfigImpl(source) {
        var _this = _super.call(this) || this;
        _this.privSource = source;
        return _this;
    }
    Object.defineProperty(AudioConfigImpl.prototype, "format", {
        /**
         * Format information for the audio
         */ get: function() {
            return this.privSource.format;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * @member AudioConfigImpl.prototype.close
     * @function
     * @public
     */ AudioConfigImpl.prototype.close = function(cb, err) {
        this.privSource.turnOff().then(function() {
            if (!!cb) cb();
        }, function(error) {
            if (!!err) err(error);
        });
    };
    /**
     * @member AudioConfigImpl.prototype.id
     * @function
     * @public
     */ AudioConfigImpl.prototype.id = function() {
        return this.privSource.id();
    };
    /**
     * @member AudioConfigImpl.prototype.turnOn
     * @function
     * @public
     * @returns {Promise<void>} A promise.
     */ AudioConfigImpl.prototype.turnOn = function() {
        return this.privSource.turnOn();
    };
    /**
     * @member AudioConfigImpl.prototype.attach
     * @function
     * @public
     * @param {string} audioNodeId - The audio node id.
     * @returns {Promise<IAudioStreamNode>} A promise.
     */ AudioConfigImpl.prototype.attach = function(audioNodeId) {
        return this.privSource.attach(audioNodeId);
    };
    /**
     * @member AudioConfigImpl.prototype.detach
     * @function
     * @public
     * @param {string} audioNodeId - The audio node id.
     */ AudioConfigImpl.prototype.detach = function(audioNodeId) {
        return this.privSource.detach(audioNodeId);
    };
    /**
     * @member AudioConfigImpl.prototype.turnOff
     * @function
     * @public
     * @returns {Promise<void>} A promise.
     */ AudioConfigImpl.prototype.turnOff = function() {
        return this.privSource.turnOff();
    };
    Object.defineProperty(AudioConfigImpl.prototype, "events", {
        /**
         * @member AudioConfigImpl.prototype.events
         * @function
         * @public
         * @returns {EventSource<AudioSourceEvent>} An event source for audio events.
         */ get: function() {
            return this.privSource.events;
        },
        enumerable: false,
        configurable: true
    });
    AudioConfigImpl.prototype.setProperty = function(name, value) {
        $gBGZx.Contracts.throwIfNull(value, "value");
        if (undefined !== this.privSource.setProperty) this.privSource.setProperty(name, value);
        else throw new Error("This AudioConfig instance does not support setting properties.");
    };
    AudioConfigImpl.prototype.getProperty = function(name, def) {
        if (undefined !== this.privSource.getProperty) return this.privSource.getProperty(name, def);
        else throw new Error("This AudioConfig instance does not support getting properties.");
        return def;
    };
    Object.defineProperty(AudioConfigImpl.prototype, "deviceInfo", {
        get: function() {
            return this.privSource.deviceInfo;
        },
        enumerable: false,
        configurable: true
    });
    return AudioConfigImpl;
}($a19b693b0646cd94$var$AudioConfig);
module.exports.AudioConfigImpl = $a19b693b0646cd94$var$AudioConfigImpl;
var $a19b693b0646cd94$var$AudioOutputConfigImpl = /** @class */ function(_super) {
    $a19b693b0646cd94$var$__extends(AudioOutputConfigImpl, _super);
    /**
     * Creates and initializes an instance of this class.
     * @constructor
     * @param {IAudioDestination} destination - An audio destination.
     */ function AudioOutputConfigImpl(destination) {
        var _this = _super.call(this) || this;
        _this.privDestination = destination;
        return _this;
    }
    Object.defineProperty(AudioOutputConfigImpl.prototype, "format", {
        set: function(format) {
            this.privDestination.format = format;
        },
        enumerable: false,
        configurable: true
    });
    AudioOutputConfigImpl.prototype.write = function(buffer) {
        this.privDestination.write(buffer);
    };
    AudioOutputConfigImpl.prototype.close = function() {
        this.privDestination.close();
    };
    AudioOutputConfigImpl.prototype.id = function() {
        return this.privDestination.id();
    };
    AudioOutputConfigImpl.prototype.setProperty = function() {
        throw new Error("This AudioConfig instance does not support setting properties.");
    };
    AudioOutputConfigImpl.prototype.getProperty = function() {
        throw new Error("This AudioConfig instance does not support getting properties.");
    };
    return AudioOutputConfigImpl;
}($a19b693b0646cd94$var$AudioConfig);
module.exports.AudioOutputConfigImpl = $a19b693b0646cd94$var$AudioOutputConfigImpl;

});
parcelRequire.register("2ZQip", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
var $22e9d827d120bb8b$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $22e9d827d120bb8b$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $22e9d827d120bb8b$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.hasOwnProperty.call(mod, k)) $22e9d827d120bb8b$var$__createBinding(result, mod, k);
    }
    $22e9d827d120bb8b$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.AudioFileWriter = void 0;

var $22e9d827d120bb8b$var$fs = $22e9d827d120bb8b$var$__importStar((parcelRequire("gR5sk")));

var $gBGZx = parcelRequire("gBGZx");
var $22e9d827d120bb8b$var$AudioFileWriter = /** @class */ function() {
    function AudioFileWriter(filename) {
        $gBGZx.Contracts.throwIfNullOrUndefined($22e9d827d120bb8b$var$fs.openSync, "\nFile System access not available, please use Push or PullAudioOutputStream");
        this.privFd = $22e9d827d120bb8b$var$fs.openSync(filename, "w");
    }
    Object.defineProperty(AudioFileWriter.prototype, "format", {
        set: function(format) {
            $gBGZx.Contracts.throwIfNotUndefined(this.privAudioFormat, "format is already set");
            this.privAudioFormat = format;
            var headerOffset = 0;
            if (this.privAudioFormat.hasHeader) headerOffset = this.privAudioFormat.header.byteLength;
            if (this.privFd !== undefined) this.privWriteStream = $22e9d827d120bb8b$var$fs.createWriteStream("", {
                fd: this.privFd,
                start: headerOffset,
                autoClose: false
            });
        },
        enumerable: false,
        configurable: true
    });
    AudioFileWriter.prototype.write = function(buffer) {
        $gBGZx.Contracts.throwIfNullOrUndefined(this.privAudioFormat, "must set format before writing.");
        if (this.privWriteStream !== undefined) this.privWriteStream.write(new Uint8Array(buffer.slice(0)));
    };
    AudioFileWriter.prototype.close = function() {
        var _this = this;
        if (this.privFd !== undefined) {
            this.privWriteStream.on("finish", function() {
                if (_this.privAudioFormat.hasHeader) {
                    _this.privAudioFormat.updateHeader(_this.privWriteStream.bytesWritten);
                    $22e9d827d120bb8b$var$fs.writeSync(_this.privFd, new Int8Array(_this.privAudioFormat.header), 0, _this.privAudioFormat.header.byteLength, 0);
                }
                $22e9d827d120bb8b$var$fs.closeSync(_this.privFd);
                _this.privFd = undefined;
            });
            this.privWriteStream.end();
        }
    };
    AudioFileWriter.prototype.id = function() {
        return this.privId;
    };
    return AudioFileWriter;
}();
module.exports.AudioFileWriter = $22e9d827d120bb8b$var$AudioFileWriter;

});

parcelRequire.register("hEE25", function(module, exports) {

var $cBXue = parcelRequire("cBXue");
var $03511dd5bba47c19$require$Buffer = $cBXue.Buffer;
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
var $03511dd5bba47c19$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $03511dd5bba47c19$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $03511dd5bba47c19$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PullAudioInputStreamImpl = module.exports.PullAudioInputStream = module.exports.PushAudioInputStreamImpl = module.exports.PushAudioInputStream = module.exports.AudioInputStream = void 0;

var $dEkJU = parcelRequire("dEkJU");

var $em8BD = parcelRequire("em8BD");

var $alsvL = parcelRequire("alsvL");

var $hM4QX = parcelRequire("hM4QX");

var $kQmaR = parcelRequire("kQmaR");
/**
 * Represents audio input stream used for custom audio input configurations.
 * @class AudioInputStream
 */ var $03511dd5bba47c19$var$AudioInputStream = /** @class */ function() {
    /**
     * Creates and initializes an instance.
     * @constructor
     */ function AudioInputStream() {
        return;
    }
    /**
     * Creates a memory backed PushAudioInputStream with the specified audio format.
     * @member AudioInputStream.createPushStream
     * @function
     * @public
     * @param {AudioStreamFormat} format - The audio data format in which audio will be
     * written to the push audio stream's write() method (Required if format is not 16 kHz 16bit mono PCM).
     * @returns {PushAudioInputStream} The audio input stream being created.
     */ AudioInputStream.createPushStream = function(format) {
        return $03511dd5bba47c19$var$PushAudioInputStream.create(format);
    };
    /**
     * Creates a PullAudioInputStream that delegates to the specified callback interface for read()
     * and close() methods.
     * @member AudioInputStream.createPullStream
     * @function
     * @public
     * @param {PullAudioInputStreamCallback} callback - The custom audio input object, derived from
     * PullAudioInputStreamCallback
     * @param {AudioStreamFormat} format - The audio data format in which audio will be returned from
     * the callback's read() method (Required if format is not 16 kHz 16bit mono PCM).
     * @returns {PullAudioInputStream} The audio input stream being created.
     */ AudioInputStream.createPullStream = function(callback, format) {
        return $03511dd5bba47c19$var$PullAudioInputStream.create(callback, format);
    // throw new Error("Oops");
    };
    return AudioInputStream;
}();
module.exports.AudioInputStream = $03511dd5bba47c19$var$AudioInputStream;
/**
 * Represents memory backed push audio input stream used for custom audio input configurations.
 * @class PushAudioInputStream
 */ var $03511dd5bba47c19$var$PushAudioInputStream = /** @class */ function(_super) {
    $03511dd5bba47c19$var$__extends(PushAudioInputStream, _super);
    function PushAudioInputStream() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Creates a memory backed PushAudioInputStream with the specified audio format.
     * @member PushAudioInputStream.create
     * @function
     * @public
     * @param {AudioStreamFormat} format - The audio data format in which audio will be written to the
     * push audio stream's write() method (Required if format is not 16 kHz 16bit mono PCM).
     * @returns {PushAudioInputStream} The push audio input stream being created.
     */ PushAudioInputStream.create = function(format) {
        return new $03511dd5bba47c19$var$PushAudioInputStreamImpl(format);
    };
    return PushAudioInputStream;
}($03511dd5bba47c19$var$AudioInputStream);
module.exports.PushAudioInputStream = $03511dd5bba47c19$var$PushAudioInputStream;
/**
 * Represents memory backed push audio input stream used for custom audio input configurations.
 * @private
 * @class PushAudioInputStreamImpl
 */ var $03511dd5bba47c19$var$PushAudioInputStreamImpl = /** @class */ function(_super) {
    $03511dd5bba47c19$var$__extends(PushAudioInputStreamImpl, _super);
    /**
     * Creates and initalizes an instance with the given values.
     * @constructor
     * @param {AudioStreamFormat} format - The audio stream format.
     */ function PushAudioInputStreamImpl(format) {
        var _this = _super.call(this) || this;
        if (format === undefined) _this.privFormat = $kQmaR.AudioStreamFormatImpl.getDefaultInputFormat();
        else _this.privFormat = format;
        _this.privEvents = new $em8BD.EventSource();
        _this.privId = $alsvL.createNoDashGuid();
        _this.privStream = new $em8BD.ChunkedArrayBufferStream(_this.privFormat.avgBytesPerSec / 10);
        return _this;
    }
    Object.defineProperty(PushAudioInputStreamImpl.prototype, "format", {
        /**
         * Format information for the audio
         */ get: function() {
            return Promise.resolve(this.privFormat);
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Writes the audio data specified by making an internal copy of the data.
     * @member PushAudioInputStreamImpl.prototype.write
     * @function
     * @public
     * @param {ArrayBuffer} dataBuffer - The audio buffer of which this function will make a copy.
     */ PushAudioInputStreamImpl.prototype.write = function(dataBuffer) {
        this.privStream.writeStreamChunk({
            buffer: dataBuffer,
            isEnd: false,
            timeReceived: Date.now()
        });
    };
    /**
     * Closes the stream.
     * @member PushAudioInputStreamImpl.prototype.close
     * @function
     * @public
     */ PushAudioInputStreamImpl.prototype.close = function() {
        this.privStream.close();
    };
    PushAudioInputStreamImpl.prototype.id = function() {
        return this.privId;
    };
    PushAudioInputStreamImpl.prototype.turnOn = function() {
        this.onEvent(new $em8BD.AudioSourceInitializingEvent(this.privId)); // no stream id
        this.onEvent(new $em8BD.AudioSourceReadyEvent(this.privId));
        return;
    };
    PushAudioInputStreamImpl.prototype.attach = function(audioNodeId) {
        return $03511dd5bba47c19$var$__awaiter(this, void 0, void 0, function() {
            var stream;
            var _this = this;
            return $03511dd5bba47c19$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        this.onEvent(new $em8BD.AudioStreamNodeAttachingEvent(this.privId, audioNodeId));
                        return [
                            4 /*yield*/ ,
                            this.turnOn()
                        ];
                    case 1:
                        _a.sent();
                        stream = this.privStream;
                        this.onEvent(new $em8BD.AudioStreamNodeAttachedEvent(this.privId, audioNodeId));
                        return [
                            2 /*return*/ ,
                            {
                                detach: function() {
                                    return $03511dd5bba47c19$var$__awaiter(_this, void 0, void 0, function() {
                                        return $03511dd5bba47c19$var$__generator(this, function(_a) {
                                            this.onEvent(new $em8BD.AudioStreamNodeDetachedEvent(this.privId, audioNodeId));
                                            return [
                                                2 /*return*/ ,
                                                this.turnOff()
                                            ];
                                        });
                                    });
                                },
                                id: function() {
                                    return audioNodeId;
                                },
                                read: function() {
                                    return stream.read();
                                }
                            }
                        ];
                }
            });
        });
    };
    PushAudioInputStreamImpl.prototype.detach = function(audioNodeId) {
        this.onEvent(new $em8BD.AudioStreamNodeDetachedEvent(this.privId, audioNodeId));
    };
    PushAudioInputStreamImpl.prototype.turnOff = function() {
        return;
    };
    Object.defineProperty(PushAudioInputStreamImpl.prototype, "events", {
        get: function() {
            return this.privEvents;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PushAudioInputStreamImpl.prototype, "deviceInfo", {
        get: function() {
            return Promise.resolve({
                bitspersample: this.privFormat.bitsPerSample,
                channelcount: this.privFormat.channels,
                connectivity: $dEkJU.connectivity.Unknown,
                manufacturer: "Speech SDK",
                model: "PushStream",
                samplerate: this.privFormat.samplesPerSec,
                type: $dEkJU.type.Stream
            });
        },
        enumerable: false,
        configurable: true
    });
    PushAudioInputStreamImpl.prototype.onEvent = function(event) {
        this.privEvents.onEvent(event);
        $em8BD.Events.instance.onEvent(event);
    };
    PushAudioInputStreamImpl.prototype.toBuffer = function(arrayBuffer) {
        var buf = $03511dd5bba47c19$require$Buffer.alloc(arrayBuffer.byteLength);
        var view = new Uint8Array(arrayBuffer);
        for(var i = 0; i < buf.length; ++i)buf[i] = view[i];
        return buf;
    };
    return PushAudioInputStreamImpl;
}($03511dd5bba47c19$var$PushAudioInputStream);
module.exports.PushAudioInputStreamImpl = $03511dd5bba47c19$var$PushAudioInputStreamImpl;
/*
 * Represents audio input stream used for custom audio input configurations.
 * @class PullAudioInputStream
 */ var $03511dd5bba47c19$var$PullAudioInputStream = /** @class */ function(_super) {
    $03511dd5bba47c19$var$__extends(PullAudioInputStream, _super);
    /**
     * Creates and initializes and instance.
     * @constructor
     */ function PullAudioInputStream() {
        return _super.call(this) || this;
    }
    /**
     * Creates a PullAudioInputStream that delegates to the specified callback interface for
     * read() and close() methods, using the default format (16 kHz 16bit mono PCM).
     * @member PullAudioInputStream.create
     * @function
     * @public
     * @param {PullAudioInputStreamCallback} callback - The custom audio input object,
     * derived from PullAudioInputStreamCustomCallback
     * @param {AudioStreamFormat} format - The audio data format in which audio will be
     * returned from the callback's read() method (Required if format is not 16 kHz 16bit mono PCM).
     * @returns {PullAudioInputStream} The push audio input stream being created.
     */ PullAudioInputStream.create = function(callback, format) {
        return new $03511dd5bba47c19$var$PullAudioInputStreamImpl(callback, format);
    };
    return PullAudioInputStream;
}($03511dd5bba47c19$var$AudioInputStream);
module.exports.PullAudioInputStream = $03511dd5bba47c19$var$PullAudioInputStream;
/**
 * Represents audio input stream used for custom audio input configurations.
 * @private
 * @class PullAudioInputStreamImpl
 */ var $03511dd5bba47c19$var$PullAudioInputStreamImpl = /** @class */ function(_super) {
    $03511dd5bba47c19$var$__extends(PullAudioInputStreamImpl, _super);
    /**
     * Creates a PullAudioInputStream that delegates to the specified callback interface for
     * read() and close() methods, using the default format (16 kHz 16bit mono PCM).
     * @constructor
     * @param {PullAudioInputStreamCallback} callback - The custom audio input object,
     * derived from PullAudioInputStreamCustomCallback
     * @param {AudioStreamFormat} format - The audio data format in which audio will be
     * returned from the callback's read() method (Required if format is not 16 kHz 16bit mono PCM).
     */ function PullAudioInputStreamImpl(callback, format) {
        var _this = _super.call(this) || this;
        if (undefined === format) _this.privFormat = $hM4QX.AudioStreamFormat.getDefaultInputFormat();
        else _this.privFormat = format;
        _this.privEvents = new $em8BD.EventSource();
        _this.privId = $alsvL.createNoDashGuid();
        _this.privCallback = callback;
        _this.privIsClosed = false;
        _this.privBufferSize = _this.privFormat.avgBytesPerSec / 10;
        return _this;
    }
    Object.defineProperty(PullAudioInputStreamImpl.prototype, "format", {
        /**
         * Format information for the audio
         */ get: function() {
            return Promise.resolve(this.privFormat);
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Closes the stream.
     * @member PullAudioInputStreamImpl.prototype.close
     * @function
     * @public
     */ PullAudioInputStreamImpl.prototype.close = function() {
        this.privIsClosed = true;
        this.privCallback.close();
    };
    PullAudioInputStreamImpl.prototype.id = function() {
        return this.privId;
    };
    PullAudioInputStreamImpl.prototype.turnOn = function() {
        this.onEvent(new $em8BD.AudioSourceInitializingEvent(this.privId)); // no stream id
        this.onEvent(new $em8BD.AudioSourceReadyEvent(this.privId));
        return;
    };
    PullAudioInputStreamImpl.prototype.attach = function(audioNodeId) {
        return $03511dd5bba47c19$var$__awaiter(this, void 0, void 0, function() {
            var _this = this;
            return $03511dd5bba47c19$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        this.onEvent(new $em8BD.AudioStreamNodeAttachingEvent(this.privId, audioNodeId));
                        return [
                            4 /*yield*/ ,
                            this.turnOn()
                        ];
                    case 1:
                        _a.sent();
                        this.onEvent(new $em8BD.AudioStreamNodeAttachedEvent(this.privId, audioNodeId));
                        return [
                            2 /*return*/ ,
                            {
                                detach: function() {
                                    _this.privCallback.close();
                                    _this.onEvent(new $em8BD.AudioStreamNodeDetachedEvent(_this.privId, audioNodeId));
                                    return _this.turnOff();
                                },
                                id: function() {
                                    return audioNodeId;
                                },
                                read: function() {
                                    var totalBytes = 0;
                                    var transmitBuff;
                                    // Until we have the minimum number of bytes to send in a transmission, keep asking for more.
                                    while(totalBytes < _this.privBufferSize){
                                        // Sizing the read buffer to the delta between the perfect size and what's left means we won't ever get too much
                                        // data back.
                                        var readBuff = new ArrayBuffer(_this.privBufferSize - totalBytes);
                                        var pulledBytes = _this.privCallback.read(readBuff);
                                        // If there is no return buffer yet defined, set the return buffer to the that was just populated.
                                        // This was, if we have enough data there's no copy penalty, but if we don't we have a buffer that's the
                                        // preferred size allocated.
                                        if (undefined === transmitBuff) transmitBuff = readBuff;
                                        else {
                                            // Not the first bite at the apple, so fill the return buffer with the data we got back.
                                            var intView = new Int8Array(transmitBuff);
                                            intView.set(new Int8Array(readBuff), totalBytes);
                                        }
                                        // If there are no bytes to read, just break out and be done.
                                        if (0 === pulledBytes) break;
                                        totalBytes += pulledBytes;
                                    }
                                    return Promise.resolve({
                                        buffer: transmitBuff.slice(0, totalBytes),
                                        isEnd: _this.privIsClosed || totalBytes === 0,
                                        timeReceived: Date.now()
                                    });
                                }
                            }
                        ];
                }
            });
        });
    };
    PullAudioInputStreamImpl.prototype.detach = function(audioNodeId) {
        this.onEvent(new $em8BD.AudioStreamNodeDetachedEvent(this.privId, audioNodeId));
    };
    PullAudioInputStreamImpl.prototype.turnOff = function() {
        return;
    };
    Object.defineProperty(PullAudioInputStreamImpl.prototype, "events", {
        get: function() {
            return this.privEvents;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PullAudioInputStreamImpl.prototype, "deviceInfo", {
        get: function() {
            return Promise.resolve({
                bitspersample: this.privFormat.bitsPerSample,
                channelcount: this.privFormat.channels,
                connectivity: $dEkJU.connectivity.Unknown,
                manufacturer: "Speech SDK",
                model: "PullStream",
                samplerate: this.privFormat.samplesPerSec,
                type: $dEkJU.type.Stream
            });
        },
        enumerable: false,
        configurable: true
    });
    PullAudioInputStreamImpl.prototype.onEvent = function(event) {
        this.privEvents.onEvent(event);
        $em8BD.Events.instance.onEvent(event);
    };
    return PullAudioInputStreamImpl;
}($03511dd5bba47c19$var$PullAudioInputStream);
module.exports.PullAudioInputStreamImpl = $03511dd5bba47c19$var$PullAudioInputStreamImpl;

});
parcelRequire.register("kQmaR", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
var $f2c9dd4ad50dada8$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.AudioStreamFormatImpl = module.exports.AudioStreamFormat = module.exports.AudioFormatTag = void 0;
// eslint-disable-next-line max-classes-per-file
var $f2c9dd4ad50dada8$var$AudioFormatTag;
(function(AudioFormatTag) {
    AudioFormatTag[AudioFormatTag["PCM"] = 1] = "PCM";
    AudioFormatTag[AudioFormatTag["MuLaw"] = 2] = "MuLaw";
    AudioFormatTag[AudioFormatTag["Siren"] = 3] = "Siren";
    AudioFormatTag[AudioFormatTag["MP3"] = 4] = "MP3";
    AudioFormatTag[AudioFormatTag["SILKSkype"] = 5] = "SILKSkype";
    AudioFormatTag[AudioFormatTag["OGG_OPUS"] = 6] = "OGG_OPUS";
    AudioFormatTag[AudioFormatTag["WEBM_OPUS"] = 7] = "WEBM_OPUS";
    AudioFormatTag[AudioFormatTag["ALaw"] = 8] = "ALaw";
    AudioFormatTag[AudioFormatTag["FLAC"] = 9] = "FLAC";
    AudioFormatTag[AudioFormatTag["OPUS"] = 10] = "OPUS";
})($f2c9dd4ad50dada8$var$AudioFormatTag = module.exports.AudioFormatTag || (module.exports.AudioFormatTag = {}));
/**
 * Represents audio stream format used for custom audio input configurations.
 * @class AudioStreamFormat
 */ var $f2c9dd4ad50dada8$var$AudioStreamFormat = /** @class */ function() {
    function AudioStreamFormat() {}
    /**
     * Creates an audio stream format object representing the default audio stream
     * format (16KHz 16bit mono PCM).
     * @member AudioStreamFormat.getDefaultInputFormat
     * @function
     * @public
     * @returns {AudioStreamFormat} The audio stream format being created.
     */ AudioStreamFormat.getDefaultInputFormat = function() {
        return $f2c9dd4ad50dada8$var$AudioStreamFormatImpl.getDefaultInputFormat();
    };
    /**
     * Creates an audio stream format object with the specified format characteristics.
     * @member AudioStreamFormat.getWaveFormat
     * @function
     * @public
     * @param {number} samplesPerSecond - Sample rate, in samples per second (Hertz).
     * @param {number} bitsPerSample - Bits per sample, typically 16.
     * @param {number} channels - Number of channels in the waveform-audio data. Monaural data
     * uses one channel and stereo data uses two channels.
     * @param {AudioFormatTag} format - Audio format (PCM, alaw or mulaw).
     * @returns {AudioStreamFormat} The audio stream format being created.
     */ AudioStreamFormat.getWaveFormat = function(samplesPerSecond, bitsPerSample, channels, format) {
        return new $f2c9dd4ad50dada8$var$AudioStreamFormatImpl(samplesPerSecond, bitsPerSample, channels, format);
    };
    /**
     * Creates an audio stream format object with the specified pcm waveformat characteristics.
     * @member AudioStreamFormat.getWaveFormatPCM
     * @function
     * @public
     * @param {number} samplesPerSecond - Sample rate, in samples per second (Hertz).
     * @param {number} bitsPerSample - Bits per sample, typically 16.
     * @param {number} channels - Number of channels in the waveform-audio data. Monaural data
     * uses one channel and stereo data uses two channels.
     * @returns {AudioStreamFormat} The audio stream format being created.
     */ AudioStreamFormat.getWaveFormatPCM = function(samplesPerSecond, bitsPerSample, channels) {
        return new $f2c9dd4ad50dada8$var$AudioStreamFormatImpl(samplesPerSecond, bitsPerSample, channels);
    };
    return AudioStreamFormat;
}();
module.exports.AudioStreamFormat = $f2c9dd4ad50dada8$var$AudioStreamFormat;
/**
 * @private
 * @class AudioStreamFormatImpl
 */ var $f2c9dd4ad50dada8$var$AudioStreamFormatImpl = /** @class */ function(_super) {
    $f2c9dd4ad50dada8$var$__extends(AudioStreamFormatImpl, _super);
    /**
     * Creates an instance with the given values.
     * @constructor
     * @param {number} samplesPerSec - Samples per second.
     * @param {number} bitsPerSample - Bits per sample.
     * @param {number} channels - Number of channels.
     * @param {AudioFormatTag} format - Audio format (PCM, alaw or mulaw).
     */ function AudioStreamFormatImpl(samplesPerSec, bitsPerSample, channels, format) {
        if (samplesPerSec === void 0) samplesPerSec = 16000;
        if (bitsPerSample === void 0) bitsPerSample = 16;
        if (channels === void 0) channels = 1;
        if (format === void 0) format = $f2c9dd4ad50dada8$var$AudioFormatTag.PCM;
        var _this = _super.call(this) || this;
        var isWavFormat = true;
        /* 1 for PCM; 6 for alaw; 7 for mulaw */ switch(format){
            case $f2c9dd4ad50dada8$var$AudioFormatTag.PCM:
                _this.formatTag = 1;
                break;
            case $f2c9dd4ad50dada8$var$AudioFormatTag.ALaw:
                _this.formatTag = 6;
                break;
            case $f2c9dd4ad50dada8$var$AudioFormatTag.MuLaw:
                _this.formatTag = 7;
                break;
            default:
                isWavFormat = false;
        }
        _this.bitsPerSample = bitsPerSample;
        _this.samplesPerSec = samplesPerSec;
        _this.channels = channels;
        _this.avgBytesPerSec = _this.samplesPerSec * _this.channels * (_this.bitsPerSample / 8);
        _this.blockAlign = _this.channels * Math.max(_this.bitsPerSample, 8);
        if (isWavFormat) {
            _this.privHeader = new ArrayBuffer(44);
            // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DataView
            var view = new DataView(_this.privHeader);
            /* RIFF identifier */ _this.setString(view, 0, "RIFF");
            /* file length */ view.setUint32(4, 0, true);
            /* RIFF type & Format */ _this.setString(view, 8, "WAVEfmt ");
            /* format chunk length */ view.setUint32(16, 16, true);
            /* audio format */ view.setUint16(20, _this.formatTag, true);
            /* channel count */ view.setUint16(22, _this.channels, true);
            /* sample rate */ view.setUint32(24, _this.samplesPerSec, true);
            /* byte rate (sample rate * block align) */ view.setUint32(28, _this.avgBytesPerSec, true);
            /* block align (channel count * bytes per sample) */ view.setUint16(32, _this.channels * (_this.bitsPerSample / 8), true);
            /* bits per sample */ view.setUint16(34, _this.bitsPerSample, true);
            /* data chunk identifier */ _this.setString(view, 36, "data");
            /* data chunk length */ view.setUint32(40, 0, true);
        }
        return _this;
    }
    /**
     * Retrieves the default input format.
     * @member AudioStreamFormatImpl.getDefaultInputFormat
     * @function
     * @public
     * @returns {AudioStreamFormatImpl} The default input format.
     */ AudioStreamFormatImpl.getDefaultInputFormat = function() {
        return new AudioStreamFormatImpl();
    };
    /**
     * Creates an audio context appropriate to current browser
     * @member AudioStreamFormatImpl.getAudioContext
     * @function
     * @public
     * @returns {AudioContext} An audio context instance
     */ /* eslint-disable */ AudioStreamFormatImpl.getAudioContext = function(sampleRate) {
        // Workaround for Speech SDK bug in Safari.
        var AudioContext = window.AudioContext // our preferred impl
         || window.webkitAudioContext // fallback, mostly when on Safari
         || false; // could not find.
        // https://developer.mozilla.org/en-US/docs/Web/API/AudioContext
        if (!!AudioContext) {
            if (sampleRate !== undefined && navigator.mediaDevices.getSupportedConstraints().sampleRate) return new AudioContext({
                sampleRate: sampleRate
            });
            else return new AudioContext();
        } else throw new Error("Browser does not support Web Audio API (AudioContext is not available).");
    };
    /* eslint-enable */ /**
     * Closes the configuration object.
     * @member AudioStreamFormatImpl.prototype.close
     * @function
     * @public
     */ AudioStreamFormatImpl.prototype.close = function() {
        return;
    };
    Object.defineProperty(AudioStreamFormatImpl.prototype, "header", {
        get: function() {
            return this.privHeader;
        },
        enumerable: false,
        configurable: true
    });
    AudioStreamFormatImpl.prototype.setString = function(view, offset, str) {
        for(var i = 0; i < str.length; i++)view.setUint8(offset + i, str.charCodeAt(i));
    };
    return AudioStreamFormatImpl;
}($f2c9dd4ad50dada8$var$AudioStreamFormat);
module.exports.AudioStreamFormatImpl = $f2c9dd4ad50dada8$var$AudioStreamFormatImpl;

});


parcelRequire.register("aBCur", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
var $7b8b376b95780e12$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $7b8b376b95780e12$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $7b8b376b95780e12$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PushAudioOutputStreamImpl = module.exports.PushAudioOutputStream = module.exports.PullAudioOutputStreamImpl = module.exports.PullAudioOutputStream = module.exports.AudioOutputStream = void 0;

var $em8BD = parcelRequire("em8BD");

var $gBGZx = parcelRequire("gBGZx");

var $lxQ5z = parcelRequire("lxQ5z");
/**
 * Represents audio output stream used for custom audio output configurations.
 * @class AudioOutputStream
 */ var $7b8b376b95780e12$var$AudioOutputStream = /** @class */ function() {
    /**
     * Creates and initializes an instance.
     * @constructor
     */ function AudioOutputStream() {
        return;
    }
    /**
     * Creates a memory backed PullAudioOutputStream with the specified audio format.
     * @member AudioOutputStream.createPullStream
     * @function
     * @public
     * @returns {PullAudioOutputStream} The audio output stream being created.
     */ AudioOutputStream.createPullStream = function() {
        return $7b8b376b95780e12$var$PullAudioOutputStream.create();
    };
    return AudioOutputStream;
}();
module.exports.AudioOutputStream = $7b8b376b95780e12$var$AudioOutputStream;
/**
 * Represents memory backed push audio output stream used for custom audio output configurations.
 * @class PullAudioOutputStream
 */ var $7b8b376b95780e12$var$PullAudioOutputStream = /** @class */ function(_super) {
    $7b8b376b95780e12$var$__extends(PullAudioOutputStream, _super);
    function PullAudioOutputStream() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Creates a memory backed PullAudioOutputStream with the specified audio format.
     * @member PullAudioOutputStream.create
     * @function
     * @public
     * @returns {PullAudioOutputStream} The push audio output stream being created.
     */ PullAudioOutputStream.create = function() {
        return new $7b8b376b95780e12$var$PullAudioOutputStreamImpl();
    };
    return PullAudioOutputStream;
}($7b8b376b95780e12$var$AudioOutputStream);
module.exports.PullAudioOutputStream = $7b8b376b95780e12$var$PullAudioOutputStream;
/**
 * Represents memory backed push audio output stream used for custom audio output configurations.
 * @private
 * @class PullAudioOutputStreamImpl
 */ var $7b8b376b95780e12$var$PullAudioOutputStreamImpl = /** @class */ function(_super) {
    $7b8b376b95780e12$var$__extends(PullAudioOutputStreamImpl, _super);
    /**
     * Creates and initializes an instance with the given values.
     * @constructor
     */ function PullAudioOutputStreamImpl() {
        var _this = _super.call(this) || this;
        _this.privId = $em8BD.createNoDashGuid();
        _this.privStream = new $em8BD.Stream();
        return _this;
    }
    Object.defineProperty(PullAudioOutputStreamImpl.prototype, "format", {
        /**
         * Format information for the audio
         */ get: function() {
            return this.privFormat;
        },
        /**
         * Sets the format information to the stream. For internal use only.
         * @param {AudioStreamFormat} format - the format to be set.
         */ set: function(format) {
            if (format === undefined || format === null) this.privFormat = $lxQ5z.AudioOutputFormatImpl.getDefaultOutputFormat();
            this.privFormat = format;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PullAudioOutputStreamImpl.prototype, "isClosed", {
        /**
         * Checks if the stream is closed
         * @member PullAudioOutputStreamImpl.prototype.isClosed
         * @property
         * @public
         */ get: function() {
            return this.privStream.isClosed;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Gets the id of the stream
     * @member PullAudioOutputStreamImpl.prototype.id
     * @property
     * @public
     */ PullAudioOutputStreamImpl.prototype.id = function() {
        return this.privId;
    };
    /**
     * Reads audio data from the internal buffer.
     * @member PullAudioOutputStreamImpl.prototype.read
     * @function
     * @public
     * @param {ArrayBuffer} dataBuffer - An ArrayBuffer to store the read data.
     * @returns {Promise<number>} - Audio buffer length has been read.
     */ PullAudioOutputStreamImpl.prototype.read = function(dataBuffer) {
        return $7b8b376b95780e12$var$__awaiter(this, void 0, void 0, function() {
            var intView, totalBytes, chunk, tmpBuffer;
            return $7b8b376b95780e12$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        intView = new Int8Array(dataBuffer);
                        totalBytes = 0;
                        if (this.privLastChunkView !== undefined) {
                            if (this.privLastChunkView.length > dataBuffer.byteLength) {
                                intView.set(this.privLastChunkView.slice(0, dataBuffer.byteLength));
                                this.privLastChunkView = this.privLastChunkView.slice(dataBuffer.byteLength);
                                return [
                                    2 /*return*/ ,
                                    Promise.resolve(dataBuffer.byteLength)
                                ];
                            }
                            intView.set(this.privLastChunkView);
                            totalBytes = this.privLastChunkView.length;
                            this.privLastChunkView = undefined;
                        }
                        _a.label = 1;
                    case 1:
                        if (!(totalBytes < dataBuffer.byteLength && !this.privStream.isReadEnded)) return [
                            3 /*break*/ ,
                            3
                        ];
                        return [
                            4 /*yield*/ ,
                            this.privStream.read()
                        ];
                    case 2:
                        chunk = _a.sent();
                        if (chunk !== undefined && !chunk.isEnd) {
                            tmpBuffer = void 0;
                            if (chunk.buffer.byteLength > dataBuffer.byteLength - totalBytes) {
                                tmpBuffer = chunk.buffer.slice(0, dataBuffer.byteLength - totalBytes);
                                this.privLastChunkView = new Int8Array(chunk.buffer.slice(dataBuffer.byteLength - totalBytes));
                            } else tmpBuffer = chunk.buffer;
                            intView.set(new Int8Array(tmpBuffer), totalBytes);
                            totalBytes += tmpBuffer.byteLength;
                        } else this.privStream.readEnded();
                        return [
                            3 /*break*/ ,
                            1
                        ];
                    case 3:
                        return [
                            2 /*return*/ ,
                            totalBytes
                        ];
                }
            });
        });
    };
    /**
     * Writes the audio data specified by making an internal copy of the data.
     * @member PullAudioOutputStreamImpl.prototype.write
     * @function
     * @public
     * @param {ArrayBuffer} dataBuffer - The audio buffer of which this function will make a copy.
     */ PullAudioOutputStreamImpl.prototype.write = function(dataBuffer) {
        $gBGZx.Contracts.throwIfNullOrUndefined(this.privStream, "must set format before writing");
        this.privStream.writeStreamChunk({
            buffer: dataBuffer,
            isEnd: false,
            timeReceived: Date.now()
        });
    };
    /**
     * Closes the stream.
     * @member PullAudioOutputStreamImpl.prototype.close
     * @function
     * @public
     */ PullAudioOutputStreamImpl.prototype.close = function() {
        this.privStream.close();
    };
    return PullAudioOutputStreamImpl;
}($7b8b376b95780e12$var$PullAudioOutputStream);
module.exports.PullAudioOutputStreamImpl = $7b8b376b95780e12$var$PullAudioOutputStreamImpl;
/*
 * Represents audio output stream used for custom audio output configurations.
 * @class PushAudioOutputStream
 */ var $7b8b376b95780e12$var$PushAudioOutputStream = /** @class */ function(_super) {
    $7b8b376b95780e12$var$__extends(PushAudioOutputStream, _super);
    /**
     * Creates and initializes and instance.
     * @constructor
     */ function PushAudioOutputStream() {
        return _super.call(this) || this;
    }
    /**
     * Creates a PushAudioOutputStream that delegates to the specified callback interface for
     * write() and close() methods.
     * @member PushAudioOutputStream.create
     * @function
     * @public
     * @param {PushAudioOutputStreamCallback} callback - The custom audio output object,
     * derived from PushAudioOutputStreamCallback
     * @returns {PushAudioOutputStream} The push audio output stream being created.
     */ PushAudioOutputStream.create = function(callback) {
        return new $7b8b376b95780e12$var$PushAudioOutputStreamImpl(callback);
    };
    return PushAudioOutputStream;
}($7b8b376b95780e12$var$AudioOutputStream);
module.exports.PushAudioOutputStream = $7b8b376b95780e12$var$PushAudioOutputStream;
/**
 * Represents audio output stream used for custom audio output configurations.
 * @private
 * @class PushAudioOutputStreamImpl
 */ var $7b8b376b95780e12$var$PushAudioOutputStreamImpl = /** @class */ function(_super) {
    $7b8b376b95780e12$var$__extends(PushAudioOutputStreamImpl, _super);
    /**
     * Creates a PushAudioOutputStream that delegates to the specified callback interface for
     * read() and close() methods.
     * @constructor
     * @param {PushAudioOutputStreamCallback} callback - The custom audio output object,
     * derived from PushAudioOutputStreamCallback
     */ function PushAudioOutputStreamImpl(callback) {
        var _this = _super.call(this) || this;
        _this.privId = $em8BD.createNoDashGuid();
        _this.privCallback = callback;
        return _this;
    }
    Object.defineProperty(PushAudioOutputStreamImpl.prototype, "format", {
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        set: function(format) {},
        enumerable: false,
        configurable: true
    });
    PushAudioOutputStreamImpl.prototype.write = function(buffer) {
        if (!!this.privCallback.write) this.privCallback.write(buffer);
    };
    PushAudioOutputStreamImpl.prototype.close = function() {
        if (!!this.privCallback.close) this.privCallback.close();
    };
    PushAudioOutputStreamImpl.prototype.id = function() {
        return this.privId;
    };
    return PushAudioOutputStreamImpl;
}($7b8b376b95780e12$var$PushAudioOutputStream);
module.exports.PushAudioOutputStreamImpl = $7b8b376b95780e12$var$PushAudioOutputStreamImpl;

});
parcelRequire.register("lxQ5z", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
var $faf515c8a12267d6$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $faf515c8a12267d6$var$_a;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.AudioOutputFormatImpl = void 0;

var $bvGqq = parcelRequire("bvGqq");

var $kQmaR = parcelRequire("kQmaR");
/**
 * @private
 * @class AudioOutputFormatImpl
 * Updated in version 1.17.0
 */ // eslint-disable-next-line max-classes-per-file
var $faf515c8a12267d6$var$AudioOutputFormatImpl = /** @class */ function(_super) {
    $faf515c8a12267d6$var$__extends(AudioOutputFormatImpl, _super);
    /**
     * Creates an instance with the given values.
     * @constructor
     * @param formatTag
     * @param {number} channels - Number of channels.
     * @param {number} samplesPerSec - Samples per second.
     * @param {number} avgBytesPerSec - Average bytes per second.
     * @param {number} blockAlign - Block alignment.
     * @param {number} bitsPerSample - Bits per sample.
     * @param {string} audioFormatString - Audio format string
     * @param {string} requestAudioFormatString - Audio format string sent to service.
     * @param {boolean} hasHeader - If the format has header or not.
     */ function AudioOutputFormatImpl(formatTag, channels, samplesPerSec, avgBytesPerSec, blockAlign, bitsPerSample, audioFormatString, requestAudioFormatString, hasHeader) {
        var _this = _super.call(this, samplesPerSec, bitsPerSample, channels, formatTag) || this;
        _this.formatTag = formatTag;
        _this.avgBytesPerSec = avgBytesPerSec;
        _this.blockAlign = blockAlign;
        _this.priAudioFormatString = audioFormatString;
        _this.priRequestAudioFormatString = requestAudioFormatString;
        _this.priHasHeader = hasHeader;
        return _this;
    }
    AudioOutputFormatImpl.fromSpeechSynthesisOutputFormat = function(speechSynthesisOutputFormat) {
        if (speechSynthesisOutputFormat === undefined) return AudioOutputFormatImpl.getDefaultOutputFormat();
        return AudioOutputFormatImpl.fromSpeechSynthesisOutputFormatString(AudioOutputFormatImpl.SpeechSynthesisOutputFormatToString[speechSynthesisOutputFormat]);
    };
    AudioOutputFormatImpl.fromSpeechSynthesisOutputFormatString = function(speechSynthesisOutputFormatString) {
        switch(speechSynthesisOutputFormatString){
            case "raw-8khz-8bit-mono-mulaw":
                return new AudioOutputFormatImpl($kQmaR.AudioFormatTag.MuLaw, 1, 8000, 8000, 1, 8, speechSynthesisOutputFormatString, speechSynthesisOutputFormatString, false);
            case "riff-16khz-16kbps-mono-siren":
                return new AudioOutputFormatImpl($kQmaR.AudioFormatTag.Siren, 1, 16000, 2000, 40, 0, speechSynthesisOutputFormatString, "audio-16khz-16kbps-mono-siren", true);
            case "audio-16khz-16kbps-mono-siren":
                return new AudioOutputFormatImpl($kQmaR.AudioFormatTag.Siren, 1, 16000, 2000, 40, 0, speechSynthesisOutputFormatString, speechSynthesisOutputFormatString, false);
            case "audio-16khz-32kbitrate-mono-mp3":
                return new AudioOutputFormatImpl($kQmaR.AudioFormatTag.MP3, 1, 16000, 4096, 2, 16, speechSynthesisOutputFormatString, speechSynthesisOutputFormatString, false);
            case "audio-16khz-128kbitrate-mono-mp3":
                return new AudioOutputFormatImpl($kQmaR.AudioFormatTag.MP3, 1, 16000, 16384, 2, 16, speechSynthesisOutputFormatString, speechSynthesisOutputFormatString, false);
            case "audio-16khz-64kbitrate-mono-mp3":
                return new AudioOutputFormatImpl($kQmaR.AudioFormatTag.MP3, 1, 16000, 8192, 2, 16, speechSynthesisOutputFormatString, speechSynthesisOutputFormatString, false);
            case "audio-24khz-48kbitrate-mono-mp3":
                return new AudioOutputFormatImpl($kQmaR.AudioFormatTag.MP3, 1, 24000, 6144, 2, 16, speechSynthesisOutputFormatString, speechSynthesisOutputFormatString, false);
            case "audio-24khz-96kbitrate-mono-mp3":
                return new AudioOutputFormatImpl($kQmaR.AudioFormatTag.MP3, 1, 24000, 12288, 2, 16, speechSynthesisOutputFormatString, speechSynthesisOutputFormatString, false);
            case "audio-24khz-160kbitrate-mono-mp3":
                return new AudioOutputFormatImpl($kQmaR.AudioFormatTag.MP3, 1, 24000, 20480, 2, 16, speechSynthesisOutputFormatString, speechSynthesisOutputFormatString, false);
            case "raw-16khz-16bit-mono-truesilk":
                return new AudioOutputFormatImpl($kQmaR.AudioFormatTag.SILKSkype, 1, 16000, 32000, 2, 16, speechSynthesisOutputFormatString, speechSynthesisOutputFormatString, false);
            case "riff-8khz-16bit-mono-pcm":
                return new AudioOutputFormatImpl($kQmaR.AudioFormatTag.PCM, 1, 8000, 16000, 2, 16, speechSynthesisOutputFormatString, "raw-8khz-16bit-mono-pcm", true);
            case "riff-24khz-16bit-mono-pcm":
                return new AudioOutputFormatImpl($kQmaR.AudioFormatTag.PCM, 1, 24000, 48000, 2, 16, speechSynthesisOutputFormatString, "raw-24khz-16bit-mono-pcm", true);
            case "riff-8khz-8bit-mono-mulaw":
                return new AudioOutputFormatImpl($kQmaR.AudioFormatTag.MuLaw, 1, 8000, 8000, 1, 8, speechSynthesisOutputFormatString, "raw-8khz-8bit-mono-mulaw", true);
            case "raw-16khz-16bit-mono-pcm":
                return new AudioOutputFormatImpl($kQmaR.AudioFormatTag.PCM, 1, 16000, 32000, 2, 16, speechSynthesisOutputFormatString, "raw-16khz-16bit-mono-pcm", false);
            case "raw-24khz-16bit-mono-pcm":
                return new AudioOutputFormatImpl($kQmaR.AudioFormatTag.PCM, 1, 24000, 48000, 2, 16, speechSynthesisOutputFormatString, "raw-24khz-16bit-mono-pcm", false);
            case "raw-8khz-16bit-mono-pcm":
                return new AudioOutputFormatImpl($kQmaR.AudioFormatTag.PCM, 1, 8000, 16000, 2, 16, speechSynthesisOutputFormatString, "raw-8khz-16bit-mono-pcm", false);
            case "ogg-16khz-16bit-mono-opus":
                return new AudioOutputFormatImpl($kQmaR.AudioFormatTag.OGG_OPUS, 1, 16000, 8192, 2, 16, speechSynthesisOutputFormatString, speechSynthesisOutputFormatString, false);
            case "ogg-24khz-16bit-mono-opus":
                return new AudioOutputFormatImpl($kQmaR.AudioFormatTag.OGG_OPUS, 1, 24000, 8192, 2, 16, speechSynthesisOutputFormatString, speechSynthesisOutputFormatString, false);
            case "raw-48khz-16bit-mono-pcm":
                return new AudioOutputFormatImpl($kQmaR.AudioFormatTag.PCM, 1, 48000, 96000, 2, 16, speechSynthesisOutputFormatString, "raw-48khz-16bit-mono-pcm", false);
            case "riff-48khz-16bit-mono-pcm":
                return new AudioOutputFormatImpl($kQmaR.AudioFormatTag.PCM, 1, 48000, 96000, 2, 16, speechSynthesisOutputFormatString, "raw-48khz-16bit-mono-pcm", true);
            case "audio-48khz-96kbitrate-mono-mp3":
                return new AudioOutputFormatImpl($kQmaR.AudioFormatTag.MP3, 1, 48000, 12288, 2, 16, speechSynthesisOutputFormatString, speechSynthesisOutputFormatString, false);
            case "audio-48khz-192kbitrate-mono-mp3":
                return new AudioOutputFormatImpl($kQmaR.AudioFormatTag.MP3, 1, 48000, 24576, 2, 16, speechSynthesisOutputFormatString, speechSynthesisOutputFormatString, false);
            case "ogg-48khz-16bit-mono-opus":
                return new AudioOutputFormatImpl($kQmaR.AudioFormatTag.OGG_OPUS, 1, 48000, 12000, 2, 16, speechSynthesisOutputFormatString, speechSynthesisOutputFormatString, false);
            case "webm-16khz-16bit-mono-opus":
                return new AudioOutputFormatImpl($kQmaR.AudioFormatTag.WEBM_OPUS, 1, 16000, 4000, 2, 16, speechSynthesisOutputFormatString, speechSynthesisOutputFormatString, false);
            case "webm-24khz-16bit-mono-opus":
                return new AudioOutputFormatImpl($kQmaR.AudioFormatTag.WEBM_OPUS, 1, 24000, 6000, 2, 16, speechSynthesisOutputFormatString, speechSynthesisOutputFormatString, false);
            case "webm-24khz-16bit-24kbps-mono-opus":
                return new AudioOutputFormatImpl($kQmaR.AudioFormatTag.WEBM_OPUS, 1, 24000, 3000, 2, 16, speechSynthesisOutputFormatString, speechSynthesisOutputFormatString, false);
            case "audio-16khz-16bit-32kbps-mono-opus":
                return new AudioOutputFormatImpl($kQmaR.AudioFormatTag.OPUS, 1, 16000, 4000, 2, 16, speechSynthesisOutputFormatString, speechSynthesisOutputFormatString, false);
            case "audio-24khz-16bit-48kbps-mono-opus":
                return new AudioOutputFormatImpl($kQmaR.AudioFormatTag.OPUS, 1, 24000, 6000, 2, 16, speechSynthesisOutputFormatString, speechSynthesisOutputFormatString, false);
            case "audio-24khz-16bit-24kbps-mono-opus":
                return new AudioOutputFormatImpl($kQmaR.AudioFormatTag.OPUS, 1, 24000, 3000, 2, 16, speechSynthesisOutputFormatString, speechSynthesisOutputFormatString, false);
            case "audio-24khz-16bit-mono-flac":
                return new AudioOutputFormatImpl($kQmaR.AudioFormatTag.FLAC, 1, 24000, 24000, 2, 16, speechSynthesisOutputFormatString, speechSynthesisOutputFormatString, false);
            case "audio-48khz-16bit-mono-flac":
                return new AudioOutputFormatImpl($kQmaR.AudioFormatTag.FLAC, 1, 48000, 30000, 2, 16, speechSynthesisOutputFormatString, speechSynthesisOutputFormatString, false);
            case "raw-24khz-16bit-mono-truesilk":
                return new AudioOutputFormatImpl($kQmaR.AudioFormatTag.SILKSkype, 1, 24000, 48000, 2, 16, speechSynthesisOutputFormatString, speechSynthesisOutputFormatString, false);
            case "raw-8khz-8bit-mono-alaw":
                return new AudioOutputFormatImpl($kQmaR.AudioFormatTag.ALaw, 1, 8000, 8000, 1, 8, speechSynthesisOutputFormatString, speechSynthesisOutputFormatString, false);
            case "riff-8khz-8bit-mono-alaw":
                return new AudioOutputFormatImpl($kQmaR.AudioFormatTag.ALaw, 1, 8000, 8000, 1, 8, speechSynthesisOutputFormatString, "raw-8khz-8bit-mono-alaw", true);
            case "raw-22050hz-16bit-mono-pcm":
                return new AudioOutputFormatImpl($kQmaR.AudioFormatTag.PCM, 1, 22050, 44100, 2, 16, speechSynthesisOutputFormatString, speechSynthesisOutputFormatString, false);
            case "riff-22050hz-16bit-mono-pcm":
                return new AudioOutputFormatImpl($kQmaR.AudioFormatTag.PCM, 1, 22050, 44100, 2, 16, speechSynthesisOutputFormatString, "raw-22050hz-16bit-mono-pcm", true);
            case "raw-44100hz-16bit-mono-pcm":
                return new AudioOutputFormatImpl($kQmaR.AudioFormatTag.PCM, 1, 44100, 88200, 2, 16, speechSynthesisOutputFormatString, speechSynthesisOutputFormatString, false);
            case "riff-44100hz-16bit-mono-pcm":
                return new AudioOutputFormatImpl($kQmaR.AudioFormatTag.PCM, 1, 44100, 88200, 2, 16, speechSynthesisOutputFormatString, "raw-44100hz-16bit-mono-pcm", true);
            case "riff-16khz-16bit-mono-pcm":
            default:
                return new AudioOutputFormatImpl($kQmaR.AudioFormatTag.PCM, 1, 16000, 32000, 2, 16, "riff-16khz-16bit-mono-pcm", "raw-16khz-16bit-mono-pcm", true);
        }
    };
    AudioOutputFormatImpl.getDefaultOutputFormat = function() {
        return AudioOutputFormatImpl.fromSpeechSynthesisOutputFormatString(typeof window !== "undefined" ? "audio-24khz-48kbitrate-mono-mp3" : "riff-16khz-16bit-mono-pcm");
    };
    Object.defineProperty(AudioOutputFormatImpl.prototype, "hasHeader", {
        /**
         * Specifies if this audio output format has a header
         * @boolean AudioOutputFormatImpl.prototype.hasHeader
         * @function
         * @public
         */ get: function() {
            return this.priHasHeader;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AudioOutputFormatImpl.prototype, "header", {
        /**
         * Specifies the header of this format
         * @ArrayBuffer AudioOutputFormatImpl.prototype.header
         * @function
         * @public
         */ get: function() {
            if (this.hasHeader) return this.privHeader;
            return undefined;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Updates the header based on the audio length
     * @member AudioOutputFormatImpl.updateHeader
     * @function
     * @public
     * @param {number} audioLength - the audio length
     */ AudioOutputFormatImpl.prototype.updateHeader = function(audioLength) {
        if (this.priHasHeader) {
            var view = new DataView(this.privHeader);
            view.setUint32(4, audioLength + this.privHeader.byteLength - 8, true);
            view.setUint32(40, audioLength, true);
        }
    };
    Object.defineProperty(AudioOutputFormatImpl.prototype, "requestAudioFormatString", {
        /**
         * Specifies the audio format string to be sent to the service
         * @string AudioOutputFormatImpl.prototype.requestAudioFormatString
         * @function
         * @public
         */ get: function() {
            return this.priRequestAudioFormatString;
        },
        enumerable: false,
        configurable: true
    });
    AudioOutputFormatImpl.SpeechSynthesisOutputFormatToString = ($faf515c8a12267d6$var$_a = {}, $faf515c8a12267d6$var$_a[$bvGqq.SpeechSynthesisOutputFormat.Raw8Khz8BitMonoMULaw] = "raw-8khz-8bit-mono-mulaw", $faf515c8a12267d6$var$_a[$bvGqq.SpeechSynthesisOutputFormat.Riff16Khz16KbpsMonoSiren] = "riff-16khz-16kbps-mono-siren", $faf515c8a12267d6$var$_a[$bvGqq.SpeechSynthesisOutputFormat.Audio16Khz16KbpsMonoSiren] = "audio-16khz-16kbps-mono-siren", $faf515c8a12267d6$var$_a[$bvGqq.SpeechSynthesisOutputFormat.Audio16Khz32KBitRateMonoMp3] = "audio-16khz-32kbitrate-mono-mp3", $faf515c8a12267d6$var$_a[$bvGqq.SpeechSynthesisOutputFormat.Audio16Khz128KBitRateMonoMp3] = "audio-16khz-128kbitrate-mono-mp3", $faf515c8a12267d6$var$_a[$bvGqq.SpeechSynthesisOutputFormat.Audio16Khz64KBitRateMonoMp3] = "audio-16khz-64kbitrate-mono-mp3", $faf515c8a12267d6$var$_a[$bvGqq.SpeechSynthesisOutputFormat.Audio24Khz48KBitRateMonoMp3] = "audio-24khz-48kbitrate-mono-mp3", $faf515c8a12267d6$var$_a[$bvGqq.SpeechSynthesisOutputFormat.Audio24Khz96KBitRateMonoMp3] = "audio-24khz-96kbitrate-mono-mp3", $faf515c8a12267d6$var$_a[$bvGqq.SpeechSynthesisOutputFormat.Audio24Khz160KBitRateMonoMp3] = "audio-24khz-160kbitrate-mono-mp3", $faf515c8a12267d6$var$_a[$bvGqq.SpeechSynthesisOutputFormat.Raw16Khz16BitMonoTrueSilk] = "raw-16khz-16bit-mono-truesilk", $faf515c8a12267d6$var$_a[$bvGqq.SpeechSynthesisOutputFormat.Riff16Khz16BitMonoPcm] = "riff-16khz-16bit-mono-pcm", $faf515c8a12267d6$var$_a[$bvGqq.SpeechSynthesisOutputFormat.Riff8Khz16BitMonoPcm] = "riff-8khz-16bit-mono-pcm", $faf515c8a12267d6$var$_a[$bvGqq.SpeechSynthesisOutputFormat.Riff24Khz16BitMonoPcm] = "riff-24khz-16bit-mono-pcm", $faf515c8a12267d6$var$_a[$bvGqq.SpeechSynthesisOutputFormat.Riff8Khz8BitMonoMULaw] = "riff-8khz-8bit-mono-mulaw", $faf515c8a12267d6$var$_a[$bvGqq.SpeechSynthesisOutputFormat.Raw16Khz16BitMonoPcm] = "raw-16khz-16bit-mono-pcm", $faf515c8a12267d6$var$_a[$bvGqq.SpeechSynthesisOutputFormat.Raw24Khz16BitMonoPcm] = "raw-24khz-16bit-mono-pcm", $faf515c8a12267d6$var$_a[$bvGqq.SpeechSynthesisOutputFormat.Raw8Khz16BitMonoPcm] = "raw-8khz-16bit-mono-pcm", $faf515c8a12267d6$var$_a[$bvGqq.SpeechSynthesisOutputFormat.Ogg16Khz16BitMonoOpus] = "ogg-16khz-16bit-mono-opus", $faf515c8a12267d6$var$_a[$bvGqq.SpeechSynthesisOutputFormat.Ogg24Khz16BitMonoOpus] = "ogg-24khz-16bit-mono-opus", $faf515c8a12267d6$var$_a[$bvGqq.SpeechSynthesisOutputFormat.Raw48Khz16BitMonoPcm] = "raw-48khz-16bit-mono-pcm", $faf515c8a12267d6$var$_a[$bvGqq.SpeechSynthesisOutputFormat.Riff48Khz16BitMonoPcm] = "riff-48khz-16bit-mono-pcm", $faf515c8a12267d6$var$_a[$bvGqq.SpeechSynthesisOutputFormat.Audio48Khz96KBitRateMonoMp3] = "audio-48khz-96kbitrate-mono-mp3", $faf515c8a12267d6$var$_a[$bvGqq.SpeechSynthesisOutputFormat.Audio48Khz192KBitRateMonoMp3] = "audio-48khz-192kbitrate-mono-mp3", $faf515c8a12267d6$var$_a[$bvGqq.SpeechSynthesisOutputFormat.Ogg48Khz16BitMonoOpus] = "ogg-48khz-16bit-mono-opus", $faf515c8a12267d6$var$_a[$bvGqq.SpeechSynthesisOutputFormat.Webm16Khz16BitMonoOpus] = "webm-16khz-16bit-mono-opus", $faf515c8a12267d6$var$_a[$bvGqq.SpeechSynthesisOutputFormat.Webm24Khz16BitMonoOpus] = "webm-24khz-16bit-mono-opus", $faf515c8a12267d6$var$_a[$bvGqq.SpeechSynthesisOutputFormat.Webm24Khz16Bit24KbpsMonoOpus] = "webm-24khz-16bit-24kbps-mono-opus", $faf515c8a12267d6$var$_a[$bvGqq.SpeechSynthesisOutputFormat.Raw24Khz16BitMonoTrueSilk] = "raw-24khz-16bit-mono-truesilk", $faf515c8a12267d6$var$_a[$bvGqq.SpeechSynthesisOutputFormat.Raw8Khz8BitMonoALaw] = "raw-8khz-8bit-mono-alaw", $faf515c8a12267d6$var$_a[$bvGqq.SpeechSynthesisOutputFormat.Riff8Khz8BitMonoALaw] = "riff-8khz-8bit-mono-alaw", $faf515c8a12267d6$var$_a[$bvGqq.SpeechSynthesisOutputFormat.Audio16Khz16Bit32KbpsMonoOpus] = "audio-16khz-16bit-32kbps-mono-opus", $faf515c8a12267d6$var$_a[$bvGqq.SpeechSynthesisOutputFormat.Audio24Khz16Bit48KbpsMonoOpus] = "audio-24khz-16bit-48kbps-mono-opus", $faf515c8a12267d6$var$_a[$bvGqq.SpeechSynthesisOutputFormat.Audio24Khz16Bit24KbpsMonoOpus] = "audio-24khz-16bit-24kbps-mono-opus", $faf515c8a12267d6$var$_a[$bvGqq.SpeechSynthesisOutputFormat.Raw22050Hz16BitMonoPcm] = "raw-22050hz-16bit-mono-pcm", $faf515c8a12267d6$var$_a[$bvGqq.SpeechSynthesisOutputFormat.Riff22050Hz16BitMonoPcm] = "riff-22050hz-16bit-mono-pcm", $faf515c8a12267d6$var$_a[$bvGqq.SpeechSynthesisOutputFormat.Raw44100Hz16BitMonoPcm] = "raw-44100hz-16bit-mono-pcm", $faf515c8a12267d6$var$_a[$bvGqq.SpeechSynthesisOutputFormat.Riff44100Hz16BitMonoPcm] = "riff-44100hz-16bit-mono-pcm", $faf515c8a12267d6$var$_a);
    return AudioOutputFormatImpl;
}($kQmaR.AudioStreamFormatImpl);
module.exports.AudioOutputFormatImpl = $faf515c8a12267d6$var$AudioOutputFormatImpl;

});
parcelRequire.register("bvGqq", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SpeechSynthesisOutputFormat = void 0;
/**
 * Define speech synthesis audio output formats.
 * @enum SpeechSynthesisOutputFormat
 * Updated in version 1.17.0
 */ var $86137fb37612948e$var$SpeechSynthesisOutputFormat;
(function(SpeechSynthesisOutputFormat) {
    /**
     * raw-8khz-8bit-mono-mulaw
     * @member SpeechSynthesisOutputFormat.Raw8Khz8BitMonoMULaw,
     */ SpeechSynthesisOutputFormat[SpeechSynthesisOutputFormat["Raw8Khz8BitMonoMULaw"] = 0] = "Raw8Khz8BitMonoMULaw";
    /**
     * riff-16khz-16kbps-mono-siren
     * @note Unsupported by the service. Do not use this value.
     * @member SpeechSynthesisOutputFormat.Riff16Khz16KbpsMonoSiren
     */ SpeechSynthesisOutputFormat[SpeechSynthesisOutputFormat["Riff16Khz16KbpsMonoSiren"] = 1] = "Riff16Khz16KbpsMonoSiren";
    /**
     * audio-16khz-16kbps-mono-siren
     * @note Unsupported by the service. Do not use this value.
     * @member SpeechSynthesisOutputFormat.Audio16Khz16KbpsMonoSiren
     */ SpeechSynthesisOutputFormat[SpeechSynthesisOutputFormat["Audio16Khz16KbpsMonoSiren"] = 2] = "Audio16Khz16KbpsMonoSiren";
    /**
     * audio-16khz-32kbitrate-mono-mp3
     * @member SpeechSynthesisOutputFormat.Audio16Khz32KBitRateMonoMp3
     */ SpeechSynthesisOutputFormat[SpeechSynthesisOutputFormat["Audio16Khz32KBitRateMonoMp3"] = 3] = "Audio16Khz32KBitRateMonoMp3";
    /**
     * audio-16khz-128kbitrate-mono-mp3
     * @member SpeechSynthesisOutputFormat.Audio16Khz128KBitRateMonoMp3
     */ SpeechSynthesisOutputFormat[SpeechSynthesisOutputFormat["Audio16Khz128KBitRateMonoMp3"] = 4] = "Audio16Khz128KBitRateMonoMp3";
    /**
     * audio-16khz-64kbitrate-mono-mp3
     * @member SpeechSynthesisOutputFormat.Audio16Khz64KBitRateMonoMp3
     */ SpeechSynthesisOutputFormat[SpeechSynthesisOutputFormat["Audio16Khz64KBitRateMonoMp3"] = 5] = "Audio16Khz64KBitRateMonoMp3";
    /**
     * audio-24khz-48kbitrate-mono-mp3
     * @member SpeechSynthesisOutputFormat.Audio24Khz48KBitRateMonoMp3
     */ SpeechSynthesisOutputFormat[SpeechSynthesisOutputFormat["Audio24Khz48KBitRateMonoMp3"] = 6] = "Audio24Khz48KBitRateMonoMp3";
    /**
     * audio-24khz-96kbitrate-mono-mp3
     * @member SpeechSynthesisOutputFormat.Audio24Khz96KBitRateMonoMp3
     */ SpeechSynthesisOutputFormat[SpeechSynthesisOutputFormat["Audio24Khz96KBitRateMonoMp3"] = 7] = "Audio24Khz96KBitRateMonoMp3";
    /**
     * audio-24khz-160kbitrate-mono-mp3
     * @member SpeechSynthesisOutputFormat.Audio24Khz160KBitRateMonoMp3
     */ SpeechSynthesisOutputFormat[SpeechSynthesisOutputFormat["Audio24Khz160KBitRateMonoMp3"] = 8] = "Audio24Khz160KBitRateMonoMp3";
    /**
     * raw-16khz-16bit-mono-truesilk
     * @member SpeechSynthesisOutputFormat.Raw16Khz16BitMonoTrueSilk
     */ SpeechSynthesisOutputFormat[SpeechSynthesisOutputFormat["Raw16Khz16BitMonoTrueSilk"] = 9] = "Raw16Khz16BitMonoTrueSilk";
    /**
     * riff-16khz-16bit-mono-pcm
     * @member SpeechSynthesisOutputFormat.Riff16Khz16BitMonoPcm
     */ SpeechSynthesisOutputFormat[SpeechSynthesisOutputFormat["Riff16Khz16BitMonoPcm"] = 10] = "Riff16Khz16BitMonoPcm";
    /**
     * riff-8khz-16bit-mono-pcm
     * @member SpeechSynthesisOutputFormat.Riff8Khz16BitMonoPcm
     */ SpeechSynthesisOutputFormat[SpeechSynthesisOutputFormat["Riff8Khz16BitMonoPcm"] = 11] = "Riff8Khz16BitMonoPcm";
    /**
     * riff-24khz-16bit-mono-pcm
     * @member SpeechSynthesisOutputFormat.Riff24Khz16BitMonoPcm
     */ SpeechSynthesisOutputFormat[SpeechSynthesisOutputFormat["Riff24Khz16BitMonoPcm"] = 12] = "Riff24Khz16BitMonoPcm";
    /**
     * riff-8khz-8bit-mono-mulaw
     * @member SpeechSynthesisOutputFormat.Riff8Khz8BitMonoMULaw
     */ SpeechSynthesisOutputFormat[SpeechSynthesisOutputFormat["Riff8Khz8BitMonoMULaw"] = 13] = "Riff8Khz8BitMonoMULaw";
    /**
     * raw-16khz-16bit-mono-pcm
     * @member SpeechSynthesisOutputFormat.Raw16Khz16BitMonoPcm
     */ SpeechSynthesisOutputFormat[SpeechSynthesisOutputFormat["Raw16Khz16BitMonoPcm"] = 14] = "Raw16Khz16BitMonoPcm";
    /**
     * raw-24khz-16bit-mono-pcm
     * @member SpeechSynthesisOutputFormat.Raw24Khz16BitMonoPcm
     */ SpeechSynthesisOutputFormat[SpeechSynthesisOutputFormat["Raw24Khz16BitMonoPcm"] = 15] = "Raw24Khz16BitMonoPcm";
    /**
     * raw-8khz-16bit-mono-pcm
     * @member SpeechSynthesisOutputFormat.Raw8Khz16BitMonoPcm
     */ SpeechSynthesisOutputFormat[SpeechSynthesisOutputFormat["Raw8Khz16BitMonoPcm"] = 16] = "Raw8Khz16BitMonoPcm";
    /**
     * ogg-16khz-16bit-mono-opus
     * @member SpeechSynthesisOutputFormat.Ogg16Khz16BitMonoOpus
     */ SpeechSynthesisOutputFormat[SpeechSynthesisOutputFormat["Ogg16Khz16BitMonoOpus"] = 17] = "Ogg16Khz16BitMonoOpus";
    /**
     * ogg-24khz-16bit-mono-opus
     * @member SpeechSynthesisOutputFormat.Ogg24Khz16BitMonoOpus
     */ SpeechSynthesisOutputFormat[SpeechSynthesisOutputFormat["Ogg24Khz16BitMonoOpus"] = 18] = "Ogg24Khz16BitMonoOpus";
    /**
     * raw-48khz-16bit-mono-pcm
     * @member SpeechSynthesisOutputFormat.Raw48Khz16BitMonoPcm
     */ SpeechSynthesisOutputFormat[SpeechSynthesisOutputFormat["Raw48Khz16BitMonoPcm"] = 19] = "Raw48Khz16BitMonoPcm";
    /**
     * riff-48khz-16bit-mono-pcm
     * @member SpeechSynthesisOutputFormat.Riff48Khz16BitMonoPcm
     */ SpeechSynthesisOutputFormat[SpeechSynthesisOutputFormat["Riff48Khz16BitMonoPcm"] = 20] = "Riff48Khz16BitMonoPcm";
    /**
     * audio-48khz-96kbitrate-mono-mp3
     * @member SpeechSynthesisOutputFormat.Audio48Khz96KBitRateMonoMp3
     */ SpeechSynthesisOutputFormat[SpeechSynthesisOutputFormat["Audio48Khz96KBitRateMonoMp3"] = 21] = "Audio48Khz96KBitRateMonoMp3";
    /**
     * audio-48khz-192kbitrate-mono-mp3
     * @member SpeechSynthesisOutputFormat.Audio48Khz192KBitRateMonoMp3
     */ SpeechSynthesisOutputFormat[SpeechSynthesisOutputFormat["Audio48Khz192KBitRateMonoMp3"] = 22] = "Audio48Khz192KBitRateMonoMp3";
    /**
     * ogg-48khz-16bit-mono-opus
     * Added in version 1.16.0
     * @member SpeechSynthesisOutputFormat.Ogg48Khz16BitMonoOpus
     */ SpeechSynthesisOutputFormat[SpeechSynthesisOutputFormat["Ogg48Khz16BitMonoOpus"] = 23] = "Ogg48Khz16BitMonoOpus";
    /**
     * webm-16khz-16bit-mono-opus
     * Added in version 1.16.0
     * @member SpeechSynthesisOutputFormat.Webm16Khz16BitMonoOpus
     */ SpeechSynthesisOutputFormat[SpeechSynthesisOutputFormat["Webm16Khz16BitMonoOpus"] = 24] = "Webm16Khz16BitMonoOpus";
    /**
     * webm-24khz-16bit-mono-opus
     * Added in version 1.16.0
     * @member SpeechSynthesisOutputFormat.Webm24Khz16BitMonoOpus
     */ SpeechSynthesisOutputFormat[SpeechSynthesisOutputFormat["Webm24Khz16BitMonoOpus"] = 25] = "Webm24Khz16BitMonoOpus";
    /**
     * raw-24khz-16bit-mono-truesilk
     * Added in version 1.17.0
     * @member SpeechSynthesisOutputFormat.Raw24Khz16BitMonoTrueSilk
     */ SpeechSynthesisOutputFormat[SpeechSynthesisOutputFormat["Raw24Khz16BitMonoTrueSilk"] = 26] = "Raw24Khz16BitMonoTrueSilk";
    /**
     * raw-8khz-8bit-mono-alaw
     * Added in version 1.17.0
     * @member SpeechSynthesisOutputFormat.Raw8Khz8BitMonoALaw
     */ SpeechSynthesisOutputFormat[SpeechSynthesisOutputFormat["Raw8Khz8BitMonoALaw"] = 27] = "Raw8Khz8BitMonoALaw";
    /**
     * riff-8khz-8bit-mono-alaw
     * Added in version 1.17.0
     * @member SpeechSynthesisOutputFormat.Riff8Khz8BitMonoALaw
     */ SpeechSynthesisOutputFormat[SpeechSynthesisOutputFormat["Riff8Khz8BitMonoALaw"] = 28] = "Riff8Khz8BitMonoALaw";
    /**
     * webm-24khz-16bit-24kbps-mono-opus
     * Audio compressed by OPUS codec in a webm container, with bitrate of 24kbps, optimized for IoT scenario.
     * Added in version 1.19.0
     * @member SpeechSynthesisOutputFormat.Webm24Khz16Bit24KbpsMonoOpus
     */ SpeechSynthesisOutputFormat[SpeechSynthesisOutputFormat["Webm24Khz16Bit24KbpsMonoOpus"] = 29] = "Webm24Khz16Bit24KbpsMonoOpus";
    /**
     * audio-16khz-16bit-32kbps-mono-opus
     * Audio compressed by OPUS codec without container, with bitrate of 32kbps.
     * Added in version 1.20.0
     * @member SpeechSynthesisOutputFormat.Audio16Khz16Bit32KbpsMonoOpus
     */ SpeechSynthesisOutputFormat[SpeechSynthesisOutputFormat["Audio16Khz16Bit32KbpsMonoOpus"] = 30] = "Audio16Khz16Bit32KbpsMonoOpus";
    /**
     * audio-24khz-16bit-48kbps-mono-opus
     * Audio compressed by OPUS codec without container, with bitrate of 48kbps.
     * Added in version 1.20.0
     * @member SpeechSynthesisOutputFormat.Audio24Khz16Bit48KbpsMonoOpus
     */ SpeechSynthesisOutputFormat[SpeechSynthesisOutputFormat["Audio24Khz16Bit48KbpsMonoOpus"] = 31] = "Audio24Khz16Bit48KbpsMonoOpus";
    /**
     * audio-24khz-16bit-24kbps-mono-opus
     * Audio compressed by OPUS codec without container, with bitrate of 24kbps.
     * Added in version 1.20.0
     * @member SpeechSynthesisOutputFormat.Audio24Khz16Bit24KbpsMonoOpus
     */ SpeechSynthesisOutputFormat[SpeechSynthesisOutputFormat["Audio24Khz16Bit24KbpsMonoOpus"] = 32] = "Audio24Khz16Bit24KbpsMonoOpus";
    /**
     * raw-22050hz-16bit-mono-pcm
     * Raw PCM audio at 22050Hz sampling rate and 16-bit depth.
     * Added in version 1.22.0
     * @member SpeechSynthesisOutputFormat.Raw22050Hz16BitMonoPcm
     */ SpeechSynthesisOutputFormat[SpeechSynthesisOutputFormat["Raw22050Hz16BitMonoPcm"] = 33] = "Raw22050Hz16BitMonoPcm";
    /**
     * riff-22050hz-16bit-mono-pcm
     * PCM audio at 22050Hz sampling rate and 16-bit depth, with RIFF header.
     * Added in version 1.22.0
     * @member SpeechSynthesisOutputFormat.Riff22050Hz16BitMonoPcm
     */ SpeechSynthesisOutputFormat[SpeechSynthesisOutputFormat["Riff22050Hz16BitMonoPcm"] = 34] = "Riff22050Hz16BitMonoPcm";
    /**
     * raw-44100hz-16bit-mono-pcm
     * Raw PCM audio at 44100Hz sampling rate and 16-bit depth.
     * Added in version 1.22.0
     * @member SpeechSynthesisOutputFormat.Raw44100Hz16BitMonoPcm
     */ SpeechSynthesisOutputFormat[SpeechSynthesisOutputFormat["Raw44100Hz16BitMonoPcm"] = 35] = "Raw44100Hz16BitMonoPcm";
    /**
     * riff-44100hz-16bit-mono-pcm
     * PCM audio at 44100Hz sampling rate and 16-bit depth, with RIFF header.
     * Added in version 1.22.0
     * @member SpeechSynthesisOutputFormat.Riff44100Hz16BitMonoPcm
     */ SpeechSynthesisOutputFormat[SpeechSynthesisOutputFormat["Riff44100Hz16BitMonoPcm"] = 36] = "Riff44100Hz16BitMonoPcm";
})($86137fb37612948e$var$SpeechSynthesisOutputFormat = module.exports.SpeechSynthesisOutputFormat || (module.exports.SpeechSynthesisOutputFormat = {}));

});




parcelRequire.register("IfD4S", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CancellationReason = void 0;
/**
 * Defines the possible reasons a recognition result might be canceled.
 * @class CancellationReason
 */ var $08503bd383cbef49$var$CancellationReason;
(function(CancellationReason) {
    /**
     * Indicates that an error occurred during speech recognition.
     * @member CancellationReason.Error
     */ CancellationReason[CancellationReason["Error"] = 0] = "Error";
    /**
     * Indicates that the end of the audio stream was reached.
     * @member CancellationReason.EndOfStream
     */ CancellationReason[CancellationReason["EndOfStream"] = 1] = "EndOfStream";
})($08503bd383cbef49$var$CancellationReason = module.exports.CancellationReason || (module.exports.CancellationReason = {}));

});

parcelRequire.register("LBUiN", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PullAudioInputStreamCallback = void 0;
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
/**
 * An abstract base class that defines callback methods (read() and close()) for
 * custom audio input streams).
 * @class PullAudioInputStreamCallback
 */ var $08f1cb761e1c7799$var$PullAudioInputStreamCallback = /** @class */ function() {
    function PullAudioInputStreamCallback() {}
    return PullAudioInputStreamCallback;
}();
module.exports.PullAudioInputStreamCallback = $08f1cb761e1c7799$var$PullAudioInputStreamCallback;

});

parcelRequire.register("bonmI", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PushAudioOutputStreamCallback = void 0;
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
/**
 * An abstract base class that defines callback methods (write() and close()) for
 * custom audio output streams).
 * @class PushAudioOutputStreamCallback
 */ var $84b40f77669872f3$var$PushAudioOutputStreamCallback = /** @class */ function() {
    function PushAudioOutputStreamCallback() {}
    return PushAudioOutputStreamCallback;
}();
module.exports.PushAudioOutputStreamCallback = $84b40f77669872f3$var$PushAudioOutputStreamCallback;

});

parcelRequire.register("9vsgp", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.KeywordRecognitionModel = void 0;

var $gBGZx = parcelRequire("gBGZx");
/**
 * Represents a keyword recognition model for recognizing when
 * the user says a keyword to initiate further speech recognition.
 * @class KeywordRecognitionModel
 */ var $6ebceee15929cc77$var$KeywordRecognitionModel = /** @class */ function() {
    /**
     * Create and initializes a new instance.
     * @constructor
     */ function KeywordRecognitionModel() {
        this.privDisposed = false;
        return;
    }
    /**
     * Creates a keyword recognition model using the specified filename.
     * @member KeywordRecognitionModel.fromFile
     * @function
     * @public
     * @param {string} fileName - A string that represents file name for the keyword recognition model.
     * Note, the file can point to a zip file in which case the model
     * will be extracted from the zip.
     * @returns {KeywordRecognitionModel} The keyword recognition model being created.
     */ KeywordRecognitionModel.fromFile = function(fileName) {
        $gBGZx.Contracts.throwIfFileDoesNotExist(fileName, "fileName");
        throw new Error("Not yet implemented.");
    };
    /**
     * Creates a keyword recognition model using the specified filename.
     * @member KeywordRecognitionModel.fromStream
     * @function
     * @public
     * @param {string} file - A File that represents file for the keyword recognition model.
     * Note, the file can point to a zip file in which case the model will be extracted from the zip.
     * @returns {KeywordRecognitionModel} The keyword recognition model being created.
     */ KeywordRecognitionModel.fromStream = function(file) {
        $gBGZx.Contracts.throwIfNull(file, "file");
        throw new Error("Not yet implemented.");
    };
    /**
     * Dispose of associated resources.
     * @member KeywordRecognitionModel.prototype.close
     * @function
     * @public
     */ KeywordRecognitionModel.prototype.close = function() {
        if (this.privDisposed) return;
        this.privDisposed = true;
    };
    return KeywordRecognitionModel;
}();
module.exports.KeywordRecognitionModel = $6ebceee15929cc77$var$KeywordRecognitionModel;

});

parcelRequire.register("9x63P", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SessionEventArgs = void 0;
/**
 * Defines content for session events like SessionStarted/Stopped, SoundStarted/Stopped.
 * @class SessionEventArgs
 */ var $6f0be5aa786ff42d$var$SessionEventArgs = /** @class */ function() {
    /**
     * Creates and initializes an instance of this class.
     * @constructor
     * @param {string} sessionId - The session id.
     */ function SessionEventArgs(sessionId) {
        this.privSessionId = sessionId;
    }
    Object.defineProperty(SessionEventArgs.prototype, "sessionId", {
        /**
         * Represents the session identifier.
         * @member SessionEventArgs.prototype.sessionId
         * @function
         * @public
         * @returns {string} Represents the session identifier.
         */ get: function() {
            return this.privSessionId;
        },
        enumerable: false,
        configurable: true
    });
    return SessionEventArgs;
}();
module.exports.SessionEventArgs = $6f0be5aa786ff42d$var$SessionEventArgs;

});

parcelRequire.register("1ideR", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
var $0f11bdd41a364da0$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RecognitionEventArgs = void 0;

var $hM4QX = parcelRequire("hM4QX");
/**
 * Defines payload for session events like Speech Start/End Detected
 * @class
 */ var $0f11bdd41a364da0$var$RecognitionEventArgs = /** @class */ function(_super) {
    $0f11bdd41a364da0$var$__extends(RecognitionEventArgs, _super);
    /**
     * Creates and initializes an instance of this class.
     * @constructor
     * @param {number} offset - The offset.
     * @param {string} sessionId - The session id.
     */ function RecognitionEventArgs(offset, sessionId) {
        var _this = _super.call(this, sessionId) || this;
        _this.privOffset = offset;
        return _this;
    }
    Object.defineProperty(RecognitionEventArgs.prototype, "offset", {
        /**
         * Represents the message offset
         * @member RecognitionEventArgs.prototype.offset
         * @function
         * @public
         */ get: function() {
            return this.privOffset;
        },
        enumerable: false,
        configurable: true
    });
    return RecognitionEventArgs;
}($hM4QX.SessionEventArgs);
module.exports.RecognitionEventArgs = $0f11bdd41a364da0$var$RecognitionEventArgs;

});

parcelRequire.register("ckS1Y", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.OutputFormat = void 0;
/**
 * Define Speech Recognizer output formats.
 * @class OutputFormat
 */ var $8fb143b28b0f414f$var$OutputFormat;
(function(OutputFormat) {
    /**
     * @member OutputFormat.Simple
     */ OutputFormat[OutputFormat["Simple"] = 0] = "Simple";
    /**
     * @member OutputFormat.Detailed
     */ OutputFormat[OutputFormat["Detailed"] = 1] = "Detailed";
})($8fb143b28b0f414f$var$OutputFormat = module.exports.OutputFormat || (module.exports.OutputFormat = {}));

});

parcelRequire.register("1tJst", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
var $113bc2eed7a9aaa9$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.IntentRecognitionEventArgs = void 0;

var $hM4QX = parcelRequire("hM4QX");
/**
 * Intent recognition result event arguments.
 * @class
 */ var $113bc2eed7a9aaa9$var$IntentRecognitionEventArgs = /** @class */ function(_super) {
    $113bc2eed7a9aaa9$var$__extends(IntentRecognitionEventArgs, _super);
    /**
     * Creates and initializes an instance of this class.
     * @constructor
     * @param result - The result of the intent recognition.
     * @param offset - The offset.
     * @param sessionId - The session id.
     */ function IntentRecognitionEventArgs(result, offset, sessionId) {
        var _this = _super.call(this, offset, sessionId) || this;
        _this.privResult = result;
        return _this;
    }
    Object.defineProperty(IntentRecognitionEventArgs.prototype, "result", {
        /**
         * Represents the intent recognition result.
         * @member IntentRecognitionEventArgs.prototype.result
         * @function
         * @public
         * @returns {IntentRecognitionResult} Represents the intent recognition result.
         */ get: function() {
            return this.privResult;
        },
        enumerable: false,
        configurable: true
    });
    return IntentRecognitionEventArgs;
}($hM4QX.RecognitionEventArgs);
module.exports.IntentRecognitionEventArgs = $113bc2eed7a9aaa9$var$IntentRecognitionEventArgs;

});

parcelRequire.register("b3knn", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RecognitionResult = void 0;
/**
 * Defines result of speech recognition.
 * @class RecognitionResult
 */ var $80bfc7c954b38e13$var$RecognitionResult = /** @class */ function() {
    /**
     * Creates and initializes an instance of this class.
     * @constructor
     * @param {string} resultId - The result id.
     * @param {ResultReason} reason - The reason.
     * @param {string} text - The recognized text.
     * @param {number} duration - The duration.
     * @param {number} offset - The offset into the stream.
     * @param {string} language - Primary Language detected, if provided.
     * @param {string} languageDetectionConfidence - Primary Language confidence ("Unknown," "Low," "Medium," "High"...), if provided.
     * @param {string} errorDetails - Error details, if provided.
     * @param {string} json - Additional Json, if provided.
     * @param {PropertyCollection} properties - Additional properties, if provided.
     */ function RecognitionResult(resultId, reason, text, duration, offset, language, languageDetectionConfidence, errorDetails, json, properties) {
        this.privResultId = resultId;
        this.privReason = reason;
        this.privText = text;
        this.privDuration = duration;
        this.privOffset = offset;
        this.privLanguage = language;
        this.privLanguageDetectionConfidence = languageDetectionConfidence;
        this.privErrorDetails = errorDetails;
        this.privJson = json;
        this.privProperties = properties;
    }
    Object.defineProperty(RecognitionResult.prototype, "resultId", {
        /**
         * Specifies the result identifier.
         * @member RecognitionResult.prototype.resultId
         * @function
         * @public
         * @returns {string} Specifies the result identifier.
         */ get: function() {
            return this.privResultId;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(RecognitionResult.prototype, "reason", {
        /**
         * Specifies status of the result.
         * @member RecognitionResult.prototype.reason
         * @function
         * @public
         * @returns {ResultReason} Specifies status of the result.
         */ get: function() {
            return this.privReason;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(RecognitionResult.prototype, "text", {
        /**
         * Presents the recognized text in the result.
         * @member RecognitionResult.prototype.text
         * @function
         * @public
         * @returns {string} Presents the recognized text in the result.
         */ get: function() {
            return this.privText;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(RecognitionResult.prototype, "duration", {
        /**
         * Duration of recognized speech in 100 nano second increments.
         * @member RecognitionResult.prototype.duration
         * @function
         * @public
         * @returns {number} Duration of recognized speech in 100 nano second increments.
         */ get: function() {
            return this.privDuration;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(RecognitionResult.prototype, "offset", {
        /**
         * Offset of recognized speech in 100 nano second increments.
         * @member RecognitionResult.prototype.offset
         * @function
         * @public
         * @returns {number} Offset of recognized speech in 100 nano second increments.
         */ get: function() {
            return this.privOffset;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(RecognitionResult.prototype, "language", {
        /**
         * Primary Language detected.
         * @member RecognitionResult.prototype.language
         * @function
         * @public
         * @returns {string} language detected.
         */ get: function() {
            return this.privLanguage;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(RecognitionResult.prototype, "languageDetectionConfidence", {
        /**
         * Primary Language detection confidence (Unknown, Low, Medium, High).
         * @member RecognitionResult.prototype.languageDetectionConfidence
         * @function
         * @public
         * @returns {string} detection confidence strength.
         */ get: function() {
            return this.privLanguageDetectionConfidence;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(RecognitionResult.prototype, "errorDetails", {
        /**
         * In case of an unsuccessful recognition, provides details of the occurred error.
         * @member RecognitionResult.prototype.errorDetails
         * @function
         * @public
         * @returns {string} a brief description of an error.
         */ get: function() {
            return this.privErrorDetails;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(RecognitionResult.prototype, "json", {
        /**
         * A string containing Json serialized recognition result as it was received from the service.
         * @member RecognitionResult.prototype.json
         * @function
         * @private
         * @returns {string} Json serialized representation of the result.
         */ get: function() {
            return this.privJson;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(RecognitionResult.prototype, "properties", {
        /**
         * The set of properties exposed in the result.
         * @member RecognitionResult.prototype.properties
         * @function
         * @public
         * @returns {PropertyCollection} The set of properties exposed in the result.
         */ get: function() {
            return this.privProperties;
        },
        enumerable: false,
        configurable: true
    });
    return RecognitionResult;
}();
module.exports.RecognitionResult = $80bfc7c954b38e13$var$RecognitionResult;

});

parcelRequire.register("1p4s1", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
var $105b941e6d08c3df$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SpeechRecognitionResult = void 0;

var $hM4QX = parcelRequire("hM4QX");
/**
 * Defines result of speech recognition.
 * @class SpeechRecognitionResult
 */ var $105b941e6d08c3df$var$SpeechRecognitionResult = /** @class */ function(_super) {
    $105b941e6d08c3df$var$__extends(SpeechRecognitionResult, _super);
    /**
     * Creates and initializes an instance of this class.
     * @constructor
     * @public
     * @param {string} resultId - The result id.
     * @param {ResultReason} reason - The reason.
     * @param {string} text - The recognized text.
     * @param {number} duration - The duration.
     * @param {number} offset - The offset into the stream.
     * @param {string} language - Primary Language detected, if provided.
     * @param {string} languageDetectionConfidence - Primary Language confidence ("Unknown," "Low," "Medium," "High"...), if provided.
     * @param {string} speakerId - speaker id for conversation transcription, if provided.
     * @param {string} errorDetails - Error details, if provided.
     * @param {string} json - Additional Json, if provided.
     * @param {PropertyCollection} properties - Additional properties, if provided.
     */ function SpeechRecognitionResult(resultId, reason, text, duration, offset, language, languageDetectionConfidence, speakerId, errorDetails, json, properties) {
        var _this = _super.call(this, resultId, reason, text, duration, offset, language, languageDetectionConfidence, errorDetails, json, properties) || this;
        _this.privSpeakerId = speakerId;
        return _this;
    }
    Object.defineProperty(SpeechRecognitionResult.prototype, "speakerId", {
        /**
         * speaker id from conversation transcription/id scenarios
         * @member SpeechRecognitionResult.prototype.speakerId
         * @function
         * @public
         * @returns {string} id of speaker in given result
         */ get: function() {
            return this.privSpeakerId;
        },
        enumerable: false,
        configurable: true
    });
    return SpeechRecognitionResult;
}($hM4QX.RecognitionResult);
module.exports.SpeechRecognitionResult = $105b941e6d08c3df$var$SpeechRecognitionResult;

});

parcelRequire.register("bKK6x", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
var $88e7c0fe7076bd6c$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.IntentRecognitionResult = void 0;

var $hM4QX = parcelRequire("hM4QX");
/**
 * Intent recognition result.
 * @class
 */ var $88e7c0fe7076bd6c$var$IntentRecognitionResult = /** @class */ function(_super) {
    $88e7c0fe7076bd6c$var$__extends(IntentRecognitionResult, _super);
    /**
     * Creates and initializes an instance of this class.
     * @constructor
     * @param intentId - The intent id.
     * @param resultId - The result id.
     * @param reason - The reason.
     * @param text - The recognized text.
     * @param duration - The duration.
     * @param offset - The offset into the stream.
     * @param language - Primary Language detected, if provided.
     * @param languageDetectionConfidence - Primary Language confidence ("Unknown," "Low," "Medium," "High"...), if provided.
     * @param errorDetails - Error details, if provided.
     * @param json - Additional Json, if provided.
     * @param properties - Additional properties, if provided.
     */ function IntentRecognitionResult(intentId, resultId, reason, text, duration, offset, language, languageDetectionConfidence, errorDetails, json, properties) {
        var _this = _super.call(this, resultId, reason, text, duration, offset, language, languageDetectionConfidence, undefined, errorDetails, json, properties) || this;
        _this.privIntentId = intentId;
        return _this;
    }
    Object.defineProperty(IntentRecognitionResult.prototype, "intentId", {
        /**
         * A String that represents the intent identifier being recognized.
         * @member IntentRecognitionResult.prototype.intentId
         * @function
         * @public
         * @returns {string} A String that represents the intent identifier being recognized.
         */ get: function() {
            return this.privIntentId;
        },
        enumerable: false,
        configurable: true
    });
    return IntentRecognitionResult;
}($hM4QX.SpeechRecognitionResult);
module.exports.IntentRecognitionResult = $88e7c0fe7076bd6c$var$IntentRecognitionResult;

});

parcelRequire.register("aTDd7", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
var $7eed74d5096b764e$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LanguageUnderstandingModelImpl = module.exports.LanguageUnderstandingModel = void 0;

var $gBGZx = parcelRequire("gBGZx");
/**
 * Language understanding model
 * @class LanguageUnderstandingModel
 */ var $7eed74d5096b764e$var$LanguageUnderstandingModel = /** @class */ function() {
    /**
     * Creates and initializes a new instance
     * @constructor
     */ function LanguageUnderstandingModel() {
        return;
    }
    /**
     * Creates an language understanding model using the specified endpoint.
     * @member LanguageUnderstandingModel.fromEndpoint
     * @function
     * @public
     * @param {URL} uri - A String that represents the endpoint of the language understanding model.
     * @returns {LanguageUnderstandingModel} The language understanding model being created.
     */ LanguageUnderstandingModel.fromEndpoint = function(uri) {
        $gBGZx.Contracts.throwIfNull(uri, "uri");
        $gBGZx.Contracts.throwIfNullOrWhitespace(uri.hostname, "uri");
        var langModelImp = new $7eed74d5096b764e$var$LanguageUnderstandingModelImpl();
        // Need to extract the app ID from the URL.
        // URL is in the format: https://<region>.api.cognitive.microsoft.com/luis/v2.0/apps/<Guid>?subscription-key=<key>&timezoneOffset=-360
        // Start tearing the string apart.
        // region can be extracted from the host name.
        var firstDot = uri.host.indexOf(".");
        if (-1 === firstDot) throw new Error("Could not determine region from endpoint");
        langModelImp.region = uri.host.substr(0, firstDot);
        // Now the app ID.
        var lastSegment = uri.pathname.lastIndexOf("/") + 1;
        if (-1 === lastSegment) throw new Error("Could not determine appId from endpoint");
        langModelImp.appId = uri.pathname.substr(lastSegment);
        // And finally the key.
        langModelImp.subscriptionKey = uri.searchParams.get("subscription-key");
        if (undefined === langModelImp.subscriptionKey) throw new Error("Could not determine subscription key from endpoint");
        return langModelImp;
    };
    /**
     * Creates an language understanding model using the application id of Language Understanding service.
     * @member LanguageUnderstandingModel.fromAppId
     * @function
     * @public
     * @param {string} appId - A String that represents the application id of Language Understanding service.
     * @returns {LanguageUnderstandingModel} The language understanding model being created.
     */ LanguageUnderstandingModel.fromAppId = function(appId) {
        $gBGZx.Contracts.throwIfNullOrWhitespace(appId, "appId");
        var langModelImp = new $7eed74d5096b764e$var$LanguageUnderstandingModelImpl();
        langModelImp.appId = appId;
        return langModelImp;
    };
    /**
     * Creates a language understanding model using hostname, subscription key and application
     * id of Language Understanding service.
     * @member LanguageUnderstandingModel.fromSubscription
     * @function
     * @public
     * @param {string} subscriptionKey - A String that represents the subscription key of
     * Language Understanding service.
     * @param {string} appId - A String that represents the application id of Language
     * Understanding service.
     * @param {LanguageUnderstandingModel} region - A String that represents the region
     * of the Language Understanding service (see the <a href="https://aka.ms/csspeech/region">region page</a>).
     * @returns {LanguageUnderstandingModel} The language understanding model being created.
     */ LanguageUnderstandingModel.fromSubscription = function(subscriptionKey, appId, region) {
        $gBGZx.Contracts.throwIfNullOrWhitespace(subscriptionKey, "subscriptionKey");
        $gBGZx.Contracts.throwIfNullOrWhitespace(appId, "appId");
        $gBGZx.Contracts.throwIfNullOrWhitespace(region, "region");
        var langModelImp = new $7eed74d5096b764e$var$LanguageUnderstandingModelImpl();
        langModelImp.appId = appId;
        langModelImp.region = region;
        langModelImp.subscriptionKey = subscriptionKey;
        return langModelImp;
    };
    return LanguageUnderstandingModel;
}();
module.exports.LanguageUnderstandingModel = $7eed74d5096b764e$var$LanguageUnderstandingModel;
/**
 * @private
 * @class LanguageUnderstandingModelImpl
 */ var $7eed74d5096b764e$var$LanguageUnderstandingModelImpl = /** @class */ function(_super) {
    $7eed74d5096b764e$var$__extends(LanguageUnderstandingModelImpl, _super);
    function LanguageUnderstandingModelImpl() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return LanguageUnderstandingModelImpl;
}($7eed74d5096b764e$var$LanguageUnderstandingModel);
module.exports.LanguageUnderstandingModelImpl = $7eed74d5096b764e$var$LanguageUnderstandingModelImpl;

});

parcelRequire.register("fbvsc", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
var $b0e0482ac70ff919$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ConversationTranscriptionEventArgs = module.exports.SpeechRecognitionEventArgs = void 0;

var $hM4QX = parcelRequire("hM4QX");
/**
 * Defines contents of speech recognizing/recognized event.
 * @class SpeechRecognitionEventArgs
 */ var $b0e0482ac70ff919$var$SpeechRecognitionEventArgs = /** @class */ function(_super) {
    $b0e0482ac70ff919$var$__extends(SpeechRecognitionEventArgs, _super);
    /**
     * Creates and initializes an instance of this class.
     * @constructor
     * @param {SpeechRecognitionResult} result - The speech recognition result.
     * @param {number} offset - The offset.
     * @param {string} sessionId - The session id.
     */ function SpeechRecognitionEventArgs(result, offset, sessionId) {
        var _this = _super.call(this, offset, sessionId) || this;
        _this.privResult = result;
        return _this;
    }
    Object.defineProperty(SpeechRecognitionEventArgs.prototype, "result", {
        /**
         * Specifies the recognition result.
         * @member SpeechRecognitionEventArgs.prototype.result
         * @function
         * @public
         * @returns {SpeechRecognitionResult} the recognition result.
         */ get: function() {
            return this.privResult;
        },
        enumerable: false,
        configurable: true
    });
    return SpeechRecognitionEventArgs;
}($hM4QX.RecognitionEventArgs);
module.exports.SpeechRecognitionEventArgs = $b0e0482ac70ff919$var$SpeechRecognitionEventArgs;
/**
 * Defines contents of conversation transcribed/transcribing event.
 * @class ConversationTranscriptionEventArgs
 */ var $b0e0482ac70ff919$var$ConversationTranscriptionEventArgs = /** @class */ function(_super) {
    $b0e0482ac70ff919$var$__extends(ConversationTranscriptionEventArgs, _super);
    function ConversationTranscriptionEventArgs() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return ConversationTranscriptionEventArgs;
}($b0e0482ac70ff919$var$SpeechRecognitionEventArgs);
module.exports.ConversationTranscriptionEventArgs = $b0e0482ac70ff919$var$ConversationTranscriptionEventArgs;

});

parcelRequire.register("b471r", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
var $80e583e7aedd5948$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SpeechRecognitionCanceledEventArgs = void 0;

var $bUeFN = parcelRequire("bUeFN");
var $80e583e7aedd5948$var$SpeechRecognitionCanceledEventArgs = /** @class */ function(_super) {
    $80e583e7aedd5948$var$__extends(SpeechRecognitionCanceledEventArgs, _super);
    function SpeechRecognitionCanceledEventArgs() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return SpeechRecognitionCanceledEventArgs;
}($bUeFN.CancellationEventArgsBase);
module.exports.SpeechRecognitionCanceledEventArgs = $80e583e7aedd5948$var$SpeechRecognitionCanceledEventArgs;

});
parcelRequire.register("bUeFN", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
var $8ab04e6f298409e7$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CancellationEventArgsBase = void 0;

var $hM4QX = parcelRequire("hM4QX");
/**
 * Defines content of a CancellationEvent.
 * @class CancellationEventArgsBase
 */ var $8ab04e6f298409e7$var$CancellationEventArgsBase = /** @class */ function(_super) {
    $8ab04e6f298409e7$var$__extends(CancellationEventArgsBase, _super);
    /**
     * Creates and initializes an instance of this class.
     * @constructor
     * @param {CancellationReason} reason - The cancellation reason.
     * @param {string} errorDetails - Error details, if provided.
     * @param {number} offset - The offset.
     * @param {string} sessionId - The session id.
     */ function CancellationEventArgsBase(reason, errorDetails, errorCode, offset, sessionId) {
        var _this = _super.call(this, offset, sessionId) || this;
        _this.privReason = reason;
        _this.privErrorDetails = errorDetails;
        _this.privErrorCode = errorCode;
        return _this;
    }
    Object.defineProperty(CancellationEventArgsBase.prototype, "reason", {
        /**
         * The reason the recognition was canceled.
         * @member CancellationEventArgsBase.prototype.reason
         * @function
         * @public
         * @returns {CancellationReason} Specifies the reason canceled.
         */ get: function() {
            return this.privReason;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CancellationEventArgsBase.prototype, "errorCode", {
        /**
         * The error code in case of an unsuccessful operation.
         * @return An error code that represents the error reason.
         */ get: function() {
            return this.privErrorCode;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CancellationEventArgsBase.prototype, "errorDetails", {
        /**
         * In case of an unsuccessful operation, provides details of the occurred error.
         * @member CancellationEventArgsBase.prototype.errorDetails
         * @function
         * @public
         * @returns {string} A String that represents the error details.
         */ get: function() {
            return this.privErrorDetails;
        },
        enumerable: false,
        configurable: true
    });
    return CancellationEventArgsBase;
}($hM4QX.RecognitionEventArgs);
module.exports.CancellationEventArgsBase = $8ab04e6f298409e7$var$CancellationEventArgsBase;

});


parcelRequire.register("c4iTO", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
var $8c9484b8be7d0ea6$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TranslationRecognitionEventArgs = void 0;

var $hM4QX = parcelRequire("hM4QX");
/**
 * Translation text result event arguments.
 * @class TranslationRecognitionEventArgs
 */ var $8c9484b8be7d0ea6$var$TranslationRecognitionEventArgs = /** @class */ function(_super) {
    $8c9484b8be7d0ea6$var$__extends(TranslationRecognitionEventArgs, _super);
    /**
     * Creates and initializes an instance of this class.
     * @constructor
     * @param {TranslationRecognitionResult} result - The translation recognition result.
     * @param {number} offset - The offset.
     * @param {string} sessionId - The session id.
     */ function TranslationRecognitionEventArgs(result, offset, sessionId) {
        var _this = _super.call(this, offset, sessionId) || this;
        _this.privResult = result;
        return _this;
    }
    Object.defineProperty(TranslationRecognitionEventArgs.prototype, "result", {
        /**
         * Specifies the recognition result.
         * @member TranslationRecognitionEventArgs.prototype.result
         * @function
         * @public
         * @returns {TranslationRecognitionResult} the recognition result.
         */ get: function() {
            return this.privResult;
        },
        enumerable: false,
        configurable: true
    });
    return TranslationRecognitionEventArgs;
}($hM4QX.RecognitionEventArgs);
module.exports.TranslationRecognitionEventArgs = $8c9484b8be7d0ea6$var$TranslationRecognitionEventArgs;

});

parcelRequire.register("aQlJv", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
var $7e4f9e724be4b9a3$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TranslationSynthesisEventArgs = void 0;

var $hM4QX = parcelRequire("hM4QX");
/**
 * Translation Synthesis event arguments
 * @class TranslationSynthesisEventArgs
 */ var $7e4f9e724be4b9a3$var$TranslationSynthesisEventArgs = /** @class */ function(_super) {
    $7e4f9e724be4b9a3$var$__extends(TranslationSynthesisEventArgs, _super);
    /**
     * Creates and initializes an instance of this class.
     * @constructor
     * @param {TranslationSynthesisResult} result - The translation synthesis result.
     * @param {string} sessionId - The session id.
     */ function TranslationSynthesisEventArgs(result, sessionId) {
        var _this = _super.call(this, sessionId) || this;
        _this.privResult = result;
        return _this;
    }
    Object.defineProperty(TranslationSynthesisEventArgs.prototype, "result", {
        /**
         * Specifies the translation synthesis result.
         * @member TranslationSynthesisEventArgs.prototype.result
         * @function
         * @public
         * @returns {TranslationSynthesisResult} Specifies the translation synthesis result.
         */ get: function() {
            return this.privResult;
        },
        enumerable: false,
        configurable: true
    });
    return TranslationSynthesisEventArgs;
}($hM4QX.SessionEventArgs);
module.exports.TranslationSynthesisEventArgs = $7e4f9e724be4b9a3$var$TranslationSynthesisEventArgs;

});

parcelRequire.register("kYmQY", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
var $f44b236e2e526eac$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TranslationRecognitionResult = void 0;

var $hM4QX = parcelRequire("hM4QX");
/**
 * Translation text result.
 * @class TranslationRecognitionResult
 */ var $f44b236e2e526eac$var$TranslationRecognitionResult = /** @class */ function(_super) {
    $f44b236e2e526eac$var$__extends(TranslationRecognitionResult, _super);
    /**
     * Creates and initializes an instance of this class.
     * @constructor
     * @param {Translations} translations - The translations.
     * @param {string} resultId - The result id.
     * @param {ResultReason} reason - The reason.
     * @param {string} text - The recognized text.
     * @param {number} duration - The duration.
     * @param {number} offset - The offset into the stream.
     * @param {string} language - Primary Language detected, if provided.
     * @param {string} languageDetectionConfidence - Primary Language confidence ("Unknown," "Low," "Medium," "High"...), if provided.
     * @param {string} errorDetails - Error details, if provided.
     * @param {string} json - Additional Json, if provided.
     * @param {PropertyCollection} properties - Additional properties, if provided.
     */ function TranslationRecognitionResult(translations, resultId, reason, text, duration, offset, language, languageDetectionConfidence, errorDetails, json, properties) {
        var _this = _super.call(this, resultId, reason, text, duration, offset, language, languageDetectionConfidence, undefined, errorDetails, json, properties) || this;
        _this.privTranslations = translations;
        return _this;
    }
    TranslationRecognitionResult.fromSpeechRecognitionResult = function(result) {
        return new TranslationRecognitionResult(undefined, result.resultId, result.reason, result.text, result.duration, result.offset, result.language, result.languageDetectionConfidence, result.errorDetails, result.json, result.properties);
    };
    Object.defineProperty(TranslationRecognitionResult.prototype, "translations", {
        /**
         * Presents the translation results. Each item in the dictionary represents
         * a translation result in one of target languages, where the key is the name
         * of the target language, in BCP-47 format, and the value is the translation
         * text in the specified language.
         * @member TranslationRecognitionResult.prototype.translations
         * @function
         * @public
         * @returns {Translations} the current translation map that holds all translations requested.
         */ get: function() {
            return this.privTranslations;
        },
        enumerable: false,
        configurable: true
    });
    return TranslationRecognitionResult;
}($hM4QX.SpeechRecognitionResult);
module.exports.TranslationRecognitionResult = $f44b236e2e526eac$var$TranslationRecognitionResult;

});

parcelRequire.register("9ny4h", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TranslationSynthesisResult = void 0;
/**
 * Defines translation synthesis result, i.e. the voice output of the translated
 * text in the target language.
 * @class TranslationSynthesisResult
 */ var $6d40b03d570113a8$var$TranslationSynthesisResult = /** @class */ function() {
    /**
     * Creates and initializes an instance of this class.
     * @constructor
     * @param {ResultReason} reason - The synthesis reason.
     * @param {ArrayBuffer} audio - The audio data.
     */ function TranslationSynthesisResult(reason, audio) {
        this.privReason = reason;
        this.privAudio = audio;
    }
    Object.defineProperty(TranslationSynthesisResult.prototype, "audio", {
        /**
         * Translated text in the target language.
         * @member TranslationSynthesisResult.prototype.audio
         * @function
         * @public
         * @returns {ArrayBuffer} Translated audio in the target language.
         */ get: function() {
            return this.privAudio;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TranslationSynthesisResult.prototype, "reason", {
        /**
         * The synthesis status.
         * @member TranslationSynthesisResult.prototype.reason
         * @function
         * @public
         * @returns {ResultReason} The synthesis status.
         */ get: function() {
            return this.privReason;
        },
        enumerable: false,
        configurable: true
    });
    return TranslationSynthesisResult;
}();
module.exports.TranslationSynthesisResult = $6d40b03d570113a8$var$TranslationSynthesisResult;

});

parcelRequire.register("5AfIy", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ResultReason = void 0;
/**
 * Defines the possible reasons a recognition result might be generated.
 * @class ResultReason
 */ var $410c81c06a340257$var$ResultReason;
(function(ResultReason) {
    /**
     * Indicates speech could not be recognized. More details
     * can be found in the NoMatchDetails object.
     * @member ResultReason.NoMatch
     */ ResultReason[ResultReason["NoMatch"] = 0] = "NoMatch";
    /**
     * Indicates that the recognition was canceled. More details
     * can be found using the CancellationDetails object.
     * @member ResultReason.Canceled
     */ ResultReason[ResultReason["Canceled"] = 1] = "Canceled";
    /**
     * Indicates the speech result contains hypothesis text.
     * @member ResultReason.RecognizedSpeech
     */ ResultReason[ResultReason["RecognizingSpeech"] = 2] = "RecognizingSpeech";
    /**
     * Indicates the speech result contains final text that has been recognized.
     * Speech Recognition is now complete for this phrase.
     * @member ResultReason.RecognizedSpeech
     */ ResultReason[ResultReason["RecognizedSpeech"] = 3] = "RecognizedSpeech";
    /**
     * Indicates the speech result contains a finalized acceptance of a provided keyword.
     * Speech recognition will continue unless otherwise configured.
     * @member ResultReason.RecognizedKeyword
     */ ResultReason[ResultReason["RecognizedKeyword"] = 4] = "RecognizedKeyword";
    /**
     * Indicates the intent result contains hypothesis text and intent.
     * @member ResultReason.RecognizingIntent
     */ ResultReason[ResultReason["RecognizingIntent"] = 5] = "RecognizingIntent";
    /**
     * Indicates the intent result contains final text and intent.
     * Speech Recognition and Intent determination are now complete for this phrase.
     * @member ResultReason.RecognizedIntent
     */ ResultReason[ResultReason["RecognizedIntent"] = 6] = "RecognizedIntent";
    /**
     * Indicates the translation result contains hypothesis text and its translation(s).
     * @member ResultReason.TranslatingSpeech
     */ ResultReason[ResultReason["TranslatingSpeech"] = 7] = "TranslatingSpeech";
    /**
     * Indicates the translation result contains final text and corresponding translation(s).
     * Speech Recognition and Translation are now complete for this phrase.
     * @member ResultReason.TranslatedSpeech
     */ ResultReason[ResultReason["TranslatedSpeech"] = 8] = "TranslatedSpeech";
    /**
     * Indicates the synthesized audio result contains a non-zero amount of audio data
     * @member ResultReason.SynthesizingAudio
     */ ResultReason[ResultReason["SynthesizingAudio"] = 9] = "SynthesizingAudio";
    /**
     * Indicates the synthesized audio is now complete for this phrase.
     * @member ResultReason.SynthesizingAudioCompleted
     */ ResultReason[ResultReason["SynthesizingAudioCompleted"] = 10] = "SynthesizingAudioCompleted";
    /**
     * Indicates the speech synthesis is now started
     * @member ResultReason.SynthesizingAudioStarted
     */ ResultReason[ResultReason["SynthesizingAudioStarted"] = 11] = "SynthesizingAudioStarted";
    /**
     * Indicates the voice profile is being enrolled and customers need to send more audio to create a voice profile.
     * @member ResultReason.EnrollingVoiceProfile
     */ ResultReason[ResultReason["EnrollingVoiceProfile"] = 12] = "EnrollingVoiceProfile";
    /**
     * Indicates the voice profile has been enrolled.
     * @member ResultReason.EnrolledVoiceProfile
     */ ResultReason[ResultReason["EnrolledVoiceProfile"] = 13] = "EnrolledVoiceProfile";
    /**
     * Indicates successful identification of some speakers.
     * @member ResultReason.RecognizedSpeakers
     */ ResultReason[ResultReason["RecognizedSpeakers"] = 14] = "RecognizedSpeakers";
    /**
     * Indicates successfully verified one speaker.
     * @member ResultReason.RecognizedSpeaker
     */ ResultReason[ResultReason["RecognizedSpeaker"] = 15] = "RecognizedSpeaker";
    /**
     * Indicates a voice profile has been reset successfully.
     * @member ResultReason.ResetVoiceProfile
     */ ResultReason[ResultReason["ResetVoiceProfile"] = 16] = "ResetVoiceProfile";
    /**
     * Indicates a voice profile has been deleted successfully.
     * @member ResultReason.DeletedVoiceProfile
     */ ResultReason[ResultReason["DeletedVoiceProfile"] = 17] = "DeletedVoiceProfile";
    /**
     * Indicates synthesis voices list has been successfully retrieved.
     * @member ResultReason.VoicesListRetrieved
     */ ResultReason[ResultReason["VoicesListRetrieved"] = 18] = "VoicesListRetrieved";
})($410c81c06a340257$var$ResultReason = module.exports.ResultReason || (module.exports.ResultReason = {}));

});

parcelRequire.register("69QpD", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
/* eslint-disable max-classes-per-file */ var $47bc3d5a350c1623$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SpeechConfigImpl = module.exports.SpeechConfig = void 0;

var $dEkJU = parcelRequire("dEkJU");

var $gBGZx = parcelRequire("gBGZx");

var $hM4QX = parcelRequire("hM4QX");
/**
 * Speech configuration.
 * @class SpeechConfig
 */ var $47bc3d5a350c1623$var$SpeechConfig = /** @class */ function() {
    /**
     * Creates and initializes an instance.
     * @constructor
     */ function SpeechConfig() {
        return;
    }
    /**
     * Static instance of SpeechConfig returned by passing subscriptionKey and service region.
     * Note: Please use your LanguageUnderstanding subscription key in case you want to use the Intent recognizer.
     * @member SpeechConfig.fromSubscription
     * @function
     * @public
     * @param {string} subscriptionKey - The subscription key.
     * @param {string} region - The region name (see the <a href="https://aka.ms/csspeech/region">region page</a>).
     * @returns {SpeechConfig} The speech factory
     */ SpeechConfig.fromSubscription = function(subscriptionKey, region) {
        $gBGZx.Contracts.throwIfNullOrWhitespace(subscriptionKey, "subscriptionKey");
        $gBGZx.Contracts.throwIfNullOrWhitespace(region, "region");
        var speechImpl = new $47bc3d5a350c1623$var$SpeechConfigImpl();
        speechImpl.setProperty($hM4QX.PropertyId.SpeechServiceConnection_Region, region);
        speechImpl.setProperty($hM4QX.PropertyId.SpeechServiceConnection_IntentRegion, region);
        speechImpl.setProperty($hM4QX.PropertyId.SpeechServiceConnection_Key, subscriptionKey);
        return speechImpl;
    };
    /**
     * Creates an instance of the speech config with specified endpoint and subscription key.
     * This method is intended only for users who use a non-standard service endpoint or parameters.
     * Note: Please use your LanguageUnderstanding subscription key in case you want to use the Intent recognizer.
     * Note: The query parameters specified in the endpoint URL are not changed, even if they are set by any other APIs.
     * For example, if language is defined in the uri as query parameter "language=de-DE", and also set by
     * SpeechConfig.speechRecognitionLanguage = "en-US", the language setting in uri takes precedence,
     * and the effective language is "de-DE". Only the parameters that are not specified in the
     * endpoint URL can be set by other APIs.
     * Note: To use authorization token with fromEndpoint, pass an empty string to the subscriptionKey in the
     * fromEndpoint method, and then set authorizationToken="token" on the created SpeechConfig instance to
     * use the authorization token.
     * @member SpeechConfig.fromEndpoint
     * @function
     * @public
     * @param {URL} endpoint - The service endpoint to connect to.
     * @param {string} subscriptionKey - The subscription key. If a subscription key is not specified, an authorization token must be set.
     * @returns {SpeechConfig} A speech factory instance.
     */ SpeechConfig.fromEndpoint = function(endpoint, subscriptionKey) {
        $gBGZx.Contracts.throwIfNull(endpoint, "endpoint");
        var speechImpl = new $47bc3d5a350c1623$var$SpeechConfigImpl();
        speechImpl.setProperty($hM4QX.PropertyId.SpeechServiceConnection_Endpoint, endpoint.href);
        if (undefined !== subscriptionKey) speechImpl.setProperty($hM4QX.PropertyId.SpeechServiceConnection_Key, subscriptionKey);
        return speechImpl;
    };
    /**
     * Creates an instance of the speech config with specified host and subscription key.
     * This method is intended only for users who use a non-default service host. Standard resource path will be assumed.
     * For services with a non-standard resource path or no path at all, use fromEndpoint instead.
     * Note: Query parameters are not allowed in the host URI and must be set by other APIs.
     * Note: To use an authorization token with fromHost, use fromHost(URL),
     * and then set the AuthorizationToken property on the created SpeechConfig instance.
     * Note: Added in version 1.9.0.
     * @member SpeechConfig.fromHost
     * @function
     * @public
     * @param {URL} host - The service endpoint to connect to. Format is "protocol://host:port" where ":port" is optional.
     * @param {string} subscriptionKey - The subscription key. If a subscription key is not specified, an authorization token must be set.
     * @returns {SpeechConfig} A speech factory instance.
     */ SpeechConfig.fromHost = function(hostName, subscriptionKey) {
        $gBGZx.Contracts.throwIfNull(hostName, "hostName");
        var speechImpl = new $47bc3d5a350c1623$var$SpeechConfigImpl();
        speechImpl.setProperty($hM4QX.PropertyId.SpeechServiceConnection_Host, hostName.protocol + "//" + hostName.hostname + (hostName.port === "" ? "" : ":" + hostName.port));
        if (undefined !== subscriptionKey) speechImpl.setProperty($hM4QX.PropertyId.SpeechServiceConnection_Key, subscriptionKey);
        return speechImpl;
    };
    /**
     * Creates an instance of the speech factory with specified initial authorization token and region.
     * Note: The caller needs to ensure that the authorization token is valid. Before the authorization token
     * expires, the caller needs to refresh it by calling this setter with a new valid token.
     * Note: Please use a token derived from your LanguageUnderstanding subscription key in case you want
     * to use the Intent recognizer. As configuration values are copied when creating a new recognizer,
     * the new token value will not apply to recognizers that have already been created. For recognizers
     * that have been created before, you need to set authorization token of the corresponding recognizer
     * to refresh the token. Otherwise, the recognizers will encounter errors during recognition.
     * @member SpeechConfig.fromAuthorizationToken
     * @function
     * @public
     * @param {string} authorizationToken - The initial authorization token.
     * @param {string} region - The region name (see the <a href="https://aka.ms/csspeech/region">region page</a>).
     * @returns {SpeechConfig} A speech factory instance.
     */ SpeechConfig.fromAuthorizationToken = function(authorizationToken, region) {
        $gBGZx.Contracts.throwIfNull(authorizationToken, "authorizationToken");
        $gBGZx.Contracts.throwIfNullOrWhitespace(region, "region");
        var speechImpl = new $47bc3d5a350c1623$var$SpeechConfigImpl();
        speechImpl.setProperty($hM4QX.PropertyId.SpeechServiceConnection_Region, region);
        speechImpl.setProperty($hM4QX.PropertyId.SpeechServiceConnection_IntentRegion, region);
        speechImpl.authorizationToken = authorizationToken;
        return speechImpl;
    };
    /**
     * Closes the configuration.
     * @member SpeechConfig.prototype.close
     * @function
     * @public
     */ // eslint-disable-next-line @typescript-eslint/no-empty-function
    SpeechConfig.prototype.close = function() {};
    return SpeechConfig;
}();
module.exports.SpeechConfig = $47bc3d5a350c1623$var$SpeechConfig;
/**
 * @public
 * @class SpeechConfigImpl
 */ var $47bc3d5a350c1623$var$SpeechConfigImpl = /** @class */ function(_super) {
    $47bc3d5a350c1623$var$__extends(SpeechConfigImpl, _super);
    function SpeechConfigImpl() {
        var _this = _super.call(this) || this;
        _this.privProperties = new $hM4QX.PropertyCollection();
        _this.speechRecognitionLanguage = "en-US"; // Should we have a default?
        _this.outputFormat = $hM4QX.OutputFormat.Simple;
        return _this;
    }
    Object.defineProperty(SpeechConfigImpl.prototype, "properties", {
        get: function() {
            return this.privProperties;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SpeechConfigImpl.prototype, "endPoint", {
        get: function() {
            return new URL(this.privProperties.getProperty($hM4QX.PropertyId.SpeechServiceConnection_Endpoint));
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SpeechConfigImpl.prototype, "subscriptionKey", {
        get: function() {
            return this.privProperties.getProperty($hM4QX.PropertyId.SpeechServiceConnection_Key);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SpeechConfigImpl.prototype, "region", {
        get: function() {
            return this.privProperties.getProperty($hM4QX.PropertyId.SpeechServiceConnection_Region);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SpeechConfigImpl.prototype, "authorizationToken", {
        get: function() {
            return this.privProperties.getProperty($hM4QX.PropertyId.SpeechServiceAuthorization_Token);
        },
        set: function(value) {
            this.privProperties.setProperty($hM4QX.PropertyId.SpeechServiceAuthorization_Token, value);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SpeechConfigImpl.prototype, "speechRecognitionLanguage", {
        get: function() {
            return this.privProperties.getProperty($hM4QX.PropertyId.SpeechServiceConnection_RecoLanguage);
        },
        set: function(value) {
            this.privProperties.setProperty($hM4QX.PropertyId.SpeechServiceConnection_RecoLanguage, value);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SpeechConfigImpl.prototype, "autoDetectSourceLanguages", {
        get: function() {
            return this.privProperties.getProperty($hM4QX.PropertyId.SpeechServiceConnection_AutoDetectSourceLanguages);
        },
        set: function(value) {
            this.privProperties.setProperty($hM4QX.PropertyId.SpeechServiceConnection_AutoDetectSourceLanguages, value);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SpeechConfigImpl.prototype, "outputFormat", {
        get: function() {
            return $hM4QX.OutputFormat[this.privProperties.getProperty($dEkJU.OutputFormatPropertyName, undefined)];
        },
        set: function(value) {
            this.privProperties.setProperty($dEkJU.OutputFormatPropertyName, $hM4QX.OutputFormat[value]);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SpeechConfigImpl.prototype, "endpointId", {
        get: function() {
            return this.privProperties.getProperty($hM4QX.PropertyId.SpeechServiceConnection_EndpointId);
        },
        set: function(value) {
            this.privProperties.setProperty($hM4QX.PropertyId.SpeechServiceConnection_EndpointId, value);
        },
        enumerable: false,
        configurable: true
    });
    SpeechConfigImpl.prototype.setProperty = function(name, value) {
        $gBGZx.Contracts.throwIfNull(value, "value");
        this.privProperties.setProperty(name, value);
    };
    SpeechConfigImpl.prototype.getProperty = function(name, def) {
        return this.privProperties.getProperty(name, def);
    };
    SpeechConfigImpl.prototype.setProxy = function(proxyHostName, proxyPort, proxyUserName, proxyPassword) {
        this.setProperty($hM4QX.PropertyId[$hM4QX.PropertyId.SpeechServiceConnection_ProxyHostName], proxyHostName);
        this.setProperty($hM4QX.PropertyId[$hM4QX.PropertyId.SpeechServiceConnection_ProxyPort], proxyPort);
        this.setProperty($hM4QX.PropertyId[$hM4QX.PropertyId.SpeechServiceConnection_ProxyUserName], proxyUserName);
        this.setProperty($hM4QX.PropertyId[$hM4QX.PropertyId.SpeechServiceConnection_ProxyPassword], proxyPassword);
    };
    SpeechConfigImpl.prototype.setServiceProperty = function(name, value) {
        var currentProperties = JSON.parse(this.privProperties.getProperty($dEkJU.ServicePropertiesPropertyName, "{}"));
        currentProperties[name] = value;
        this.privProperties.setProperty($dEkJU.ServicePropertiesPropertyName, JSON.stringify(currentProperties));
    };
    SpeechConfigImpl.prototype.setProfanity = function(profanity) {
        this.privProperties.setProperty($hM4QX.PropertyId.SpeechServiceResponse_ProfanityOption, $hM4QX.ProfanityOption[profanity]);
    };
    SpeechConfigImpl.prototype.enableAudioLogging = function() {
        this.privProperties.setProperty($hM4QX.PropertyId.SpeechServiceConnection_EnableAudioLogging, "true");
    };
    SpeechConfigImpl.prototype.requestWordLevelTimestamps = function() {
        this.privProperties.setProperty($hM4QX.PropertyId.SpeechServiceResponse_RequestWordLevelTimestamps, "true");
    };
    SpeechConfigImpl.prototype.enableDictation = function() {
        this.privProperties.setProperty($dEkJU.ForceDictationPropertyName, "true");
    };
    SpeechConfigImpl.prototype.clone = function() {
        var ret = new SpeechConfigImpl();
        ret.privProperties = this.privProperties.clone();
        return ret;
    };
    Object.defineProperty(SpeechConfigImpl.prototype, "speechSynthesisLanguage", {
        get: function() {
            return this.privProperties.getProperty($hM4QX.PropertyId.SpeechServiceConnection_SynthLanguage);
        },
        set: function(language) {
            this.privProperties.setProperty($hM4QX.PropertyId.SpeechServiceConnection_SynthLanguage, language);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SpeechConfigImpl.prototype, "speechSynthesisVoiceName", {
        get: function() {
            return this.privProperties.getProperty($hM4QX.PropertyId.SpeechServiceConnection_SynthVoice);
        },
        set: function(voice) {
            this.privProperties.setProperty($hM4QX.PropertyId.SpeechServiceConnection_SynthVoice, voice);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SpeechConfigImpl.prototype, "speechSynthesisOutputFormat", {
        get: function() {
            return $hM4QX.SpeechSynthesisOutputFormat[this.privProperties.getProperty($hM4QX.PropertyId.SpeechServiceConnection_SynthOutputFormat, undefined)];
        },
        set: function(format) {
            this.privProperties.setProperty($hM4QX.PropertyId.SpeechServiceConnection_SynthOutputFormat, $hM4QX.SpeechSynthesisOutputFormat[format]);
        },
        enumerable: false,
        configurable: true
    });
    return SpeechConfigImpl;
}($47bc3d5a350c1623$var$SpeechConfig);
module.exports.SpeechConfigImpl = $47bc3d5a350c1623$var$SpeechConfigImpl;

});

parcelRequire.register("eC1yh", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
var $aa35d17cd1019f60$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SpeechTranslationConfigImpl = module.exports.SpeechTranslationConfig = void 0;

var $dEkJU = parcelRequire("dEkJU");

var $gBGZx = parcelRequire("gBGZx");

var $hM4QX = parcelRequire("hM4QX");
/**
 * Speech translation configuration.
 * @class SpeechTranslationConfig
 */ var $aa35d17cd1019f60$var$SpeechTranslationConfig = /** @class */ function(_super) {
    $aa35d17cd1019f60$var$__extends(SpeechTranslationConfig, _super);
    /**
     * Creates an instance of recognizer config.
     */ function SpeechTranslationConfig() {
        return _super.call(this) || this;
    }
    /**
     * Static instance of SpeechTranslationConfig returned by passing a subscription key and service region.
     * @member SpeechTranslationConfig.fromSubscription
     * @function
     * @public
     * @param {string} subscriptionKey - The subscription key.
     * @param {string} region - The region name (see the <a href="https://aka.ms/csspeech/region">region page</a>).
     * @returns {SpeechTranslationConfig} The speech translation config.
     */ SpeechTranslationConfig.fromSubscription = function(subscriptionKey, region) {
        $gBGZx.Contracts.throwIfNullOrWhitespace(subscriptionKey, "subscriptionKey");
        $gBGZx.Contracts.throwIfNullOrWhitespace(region, "region");
        var ret = new $aa35d17cd1019f60$var$SpeechTranslationConfigImpl();
        ret.properties.setProperty($hM4QX.PropertyId.SpeechServiceConnection_Key, subscriptionKey);
        ret.properties.setProperty($hM4QX.PropertyId.SpeechServiceConnection_Region, region);
        return ret;
    };
    /**
     * Static instance of SpeechTranslationConfig returned by passing authorization token and service region.
     * Note: The caller needs to ensure that the authorization token is valid. Before the authorization token
     * expires, the caller needs to refresh it by setting the property authorizationToken with a new
     * valid token. Otherwise, all the recognizers created by this SpeechTranslationConfig instance
     * will encounter errors during recognition.
     * As configuration values are copied when creating a new recognizer, the new token value will not apply
     * to recognizers that have already been created.
     * For recognizers that have been created before, you need to set authorization token of the corresponding recognizer
     * to refresh the token. Otherwise, the recognizers will encounter errors during recognition.
     * @member SpeechTranslationConfig.fromAuthorizationToken
     * @function
     * @public
     * @param {string} authorizationToken - The authorization token.
     * @param {string} region - The region name (see the <a href="https://aka.ms/csspeech/region">region page</a>).
     * @returns {SpeechTranslationConfig} The speech translation config.
     */ SpeechTranslationConfig.fromAuthorizationToken = function(authorizationToken, region) {
        $gBGZx.Contracts.throwIfNullOrWhitespace(authorizationToken, "authorizationToken");
        $gBGZx.Contracts.throwIfNullOrWhitespace(region, "region");
        var ret = new $aa35d17cd1019f60$var$SpeechTranslationConfigImpl();
        ret.properties.setProperty($hM4QX.PropertyId.SpeechServiceAuthorization_Token, authorizationToken);
        ret.properties.setProperty($hM4QX.PropertyId.SpeechServiceConnection_Region, region);
        return ret;
    };
    /**
     * Creates an instance of the speech config with specified host and subscription key.
     * This method is intended only for users who use a non-default service host. Standard resource path will be assumed.
     * For services with a non-standard resource path or no path at all, use fromEndpoint instead.
     * Note: Query parameters are not allowed in the host URI and must be set by other APIs.
     * Note: To use an authorization token with fromHost, use fromHost(URL),
     * and then set the AuthorizationToken property on the created SpeechConfig instance.
     * Note: Added in version 1.9.0.
     * @member SpeechConfig.fromHost
     * @function
     * @public
     * @param {URL} host - The service endpoint to connect to. Format is "protocol://host:port" where ":port" is optional.
     * @param {string} subscriptionKey - The subscription key. If a subscription key is not specified, an authorization token must be set.
     * @returns {SpeechConfig} A speech factory instance.
     */ SpeechTranslationConfig.fromHost = function(hostName, subscriptionKey) {
        $gBGZx.Contracts.throwIfNull(hostName, "hostName");
        var speechImpl = new $aa35d17cd1019f60$var$SpeechTranslationConfigImpl();
        speechImpl.setProperty($hM4QX.PropertyId.SpeechServiceConnection_Host, hostName.protocol + "//" + hostName.hostname + (hostName.port === "" ? "" : ":" + hostName.port));
        if (undefined !== subscriptionKey) speechImpl.setProperty($hM4QX.PropertyId.SpeechServiceConnection_Key, subscriptionKey);
        return speechImpl;
    };
    /**
     * Creates an instance of the speech translation config with specified endpoint and subscription key.
     * This method is intended only for users who use a non-standard service endpoint or paramters.
     * Note: The query properties specified in the endpoint URL are not changed, even if they are
     * set by any other APIs. For example, if language is defined in the uri as query parameter
     * "language=de-DE", and also set by the speechRecognitionLanguage property, the language
     * setting in uri takes precedence, and the effective language is "de-DE".
     * Only the properties that are not specified in the endpoint URL can be set by other APIs.
     * Note: To use authorization token with fromEndpoint, pass an empty string to the subscriptionKey in the
     * fromEndpoint method, and then set authorizationToken="token" on the created SpeechConfig instance to
     * use the authorization token.
     * @member SpeechTranslationConfig.fromEndpoint
     * @function
     * @public
     * @param {URL} endpoint - The service endpoint to connect to.
     * @param {string} subscriptionKey - The subscription key.
     * @returns {SpeechTranslationConfig} A speech config instance.
     */ SpeechTranslationConfig.fromEndpoint = function(endpoint, subscriptionKey) {
        $gBGZx.Contracts.throwIfNull(endpoint, "endpoint");
        $gBGZx.Contracts.throwIfNull(subscriptionKey, "subscriptionKey");
        var ret = new $aa35d17cd1019f60$var$SpeechTranslationConfigImpl();
        ret.properties.setProperty($hM4QX.PropertyId.SpeechServiceConnection_Endpoint, endpoint.href);
        ret.properties.setProperty($hM4QX.PropertyId.SpeechServiceConnection_Key, subscriptionKey);
        return ret;
    };
    return SpeechTranslationConfig;
}($hM4QX.SpeechConfig);
module.exports.SpeechTranslationConfig = $aa35d17cd1019f60$var$SpeechTranslationConfig;
/**
 * @private
 * @class SpeechTranslationConfigImpl
 */ var $aa35d17cd1019f60$var$SpeechTranslationConfigImpl = /** @class */ function(_super) {
    $aa35d17cd1019f60$var$__extends(SpeechTranslationConfigImpl, _super);
    function SpeechTranslationConfigImpl() {
        var _this = _super.call(this) || this;
        _this.privSpeechProperties = new $hM4QX.PropertyCollection();
        _this.outputFormat = $hM4QX.OutputFormat.Simple;
        return _this;
    }
    Object.defineProperty(SpeechTranslationConfigImpl.prototype, "authorizationToken", {
        /**
         * Gets/Sets the authorization token.
         * If this is set, subscription key is ignored.
         * User needs to make sure the provided authorization token is valid and not expired.
         * @member SpeechTranslationConfigImpl.prototype.authorizationToken
         * @function
         * @public
         * @param {string} value - The authorization token.
         */ set: function(value) {
            $gBGZx.Contracts.throwIfNullOrWhitespace(value, "value");
            this.privSpeechProperties.setProperty($hM4QX.PropertyId.SpeechServiceAuthorization_Token, value);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SpeechTranslationConfigImpl.prototype, "speechRecognitionLanguage", {
        /**
         * Gets the speech recognition language.
         * @member SpeechTranslationConfigImpl.prototype.speechRecognitionLanguage
         * @function
         * @public
         * @return {string} The speechRecognitionLanguage.
         */ get: function() {
            return this.privSpeechProperties.getProperty($hM4QX.PropertyId[$hM4QX.PropertyId.SpeechServiceConnection_RecoLanguage]);
        },
        /**
         * Sets the speech recognition language.
         * @member SpeechTranslationConfigImpl.prototype.speechRecognitionLanguage
         * @function
         * @public
         * @param {string} value - The authorization token.
         */ set: function(value) {
            $gBGZx.Contracts.throwIfNullOrWhitespace(value, "value");
            this.privSpeechProperties.setProperty($hM4QX.PropertyId.SpeechServiceConnection_RecoLanguage, value);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SpeechTranslationConfigImpl.prototype, "subscriptionKey", {
        /**
         * @member SpeechTranslationConfigImpl.prototype.subscriptionKey
         * @function
         * @public
         */ get: function() {
            return this.privSpeechProperties.getProperty($hM4QX.PropertyId[$hM4QX.PropertyId.SpeechServiceConnection_Key]);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SpeechTranslationConfigImpl.prototype, "outputFormat", {
        /**
         * Gets the output format
         * @member SpeechTranslationConfigImpl.prototype.outputFormat
         * @function
         * @public
         */ get: function() {
            // eslint-disable-next-line
            return $hM4QX.OutputFormat[this.privSpeechProperties.getProperty($dEkJU.OutputFormatPropertyName, undefined)];
        },
        /**
         * Gets/Sets the output format
         * @member SpeechTranslationConfigImpl.prototype.outputFormat
         * @function
         * @public
         */ set: function(value) {
            this.privSpeechProperties.setProperty($dEkJU.OutputFormatPropertyName, $hM4QX.OutputFormat[value]);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SpeechTranslationConfigImpl.prototype, "endpointId", {
        /**
         * Gets the endpoint id.
         * @member SpeechTranslationConfigImpl.prototype.endpointId
         * @function
         * @public
         */ get: function() {
            return this.privSpeechProperties.getProperty($hM4QX.PropertyId.SpeechServiceConnection_EndpointId);
        },
        /**
         * Gets/Sets the endpoint id.
         * @member SpeechTranslationConfigImpl.prototype.endpointId
         * @function
         * @public
         */ set: function(value) {
            this.privSpeechProperties.setProperty($hM4QX.PropertyId.SpeechServiceConnection_EndpointId, value);
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Add a (text) target language to translate into.
     * @member SpeechTranslationConfigImpl.prototype.addTargetLanguage
     * @function
     * @public
     * @param {string} value - The language such as de-DE
     */ SpeechTranslationConfigImpl.prototype.addTargetLanguage = function(value) {
        $gBGZx.Contracts.throwIfNullOrWhitespace(value, "value");
        var languages = this.targetLanguages;
        languages.push(value);
        this.privSpeechProperties.setProperty($hM4QX.PropertyId.SpeechServiceConnection_TranslationToLanguages, languages.join(","));
    };
    Object.defineProperty(SpeechTranslationConfigImpl.prototype, "targetLanguages", {
        /**
         * Gets the (text) target language to translate into.
         * @member SpeechTranslationConfigImpl.prototype.targetLanguages
         * @function
         * @public
         * @param {string} value - The language such as de-DE
         */ get: function() {
            if (this.privSpeechProperties.getProperty($hM4QX.PropertyId.SpeechServiceConnection_TranslationToLanguages, undefined) !== undefined) return this.privSpeechProperties.getProperty($hM4QX.PropertyId.SpeechServiceConnection_TranslationToLanguages).split(",");
            else return [];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SpeechTranslationConfigImpl.prototype, "voiceName", {
        /**
         * Gets the voice name.
         * @member SpeechTranslationConfigImpl.prototype.voiceName
         * @function
         * @public
         */ get: function() {
            return this.getProperty($hM4QX.PropertyId[$hM4QX.PropertyId.SpeechServiceConnection_TranslationVoice]);
        },
        /**
         * Gets/Sets the voice of the translated language, enable voice synthesis output.
         * @member SpeechTranslationConfigImpl.prototype.voiceName
         * @function
         * @public
         * @param {string} value - The name of the voice.
         */ set: function(value) {
            $gBGZx.Contracts.throwIfNullOrWhitespace(value, "value");
            this.privSpeechProperties.setProperty($hM4QX.PropertyId.SpeechServiceConnection_TranslationVoice, value);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SpeechTranslationConfigImpl.prototype, "region", {
        /**
         * Provides the region.
         * @member SpeechTranslationConfigImpl.prototype.region
         * @function
         * @public
         * @returns {string} The region.
         */ get: function() {
            return this.privSpeechProperties.getProperty($hM4QX.PropertyId.SpeechServiceConnection_Region);
        },
        enumerable: false,
        configurable: true
    });
    SpeechTranslationConfigImpl.prototype.setProxy = function(proxyHostName, proxyPort, proxyUserName, proxyPassword) {
        this.setProperty($hM4QX.PropertyId[$hM4QX.PropertyId.SpeechServiceConnection_ProxyHostName], proxyHostName);
        this.setProperty($hM4QX.PropertyId[$hM4QX.PropertyId.SpeechServiceConnection_ProxyPort], proxyPort);
        this.setProperty($hM4QX.PropertyId[$hM4QX.PropertyId.SpeechServiceConnection_ProxyUserName], proxyUserName);
        this.setProperty($hM4QX.PropertyId[$hM4QX.PropertyId.SpeechServiceConnection_ProxyPassword], proxyPassword);
    };
    /**
     * Gets an arbitrary property value.
     * @member SpeechTranslationConfigImpl.prototype.getProperty
     * @function
     * @public
     * @param {string} name - The name of the property.
     * @param {string} def - The default value of the property in case it is not set.
     * @returns {string} The value of the property.
     */ SpeechTranslationConfigImpl.prototype.getProperty = function(name, def) {
        return this.privSpeechProperties.getProperty(name, def);
    };
    /**
     * Gets/Sets an arbitrary property value.
     * @member SpeechTranslationConfigImpl.prototype.setProperty
     * @function
     * @public
     * @param {string | PropertyId} name - The name of the property to set.
     * @param {string} value - The value of the property.
     */ SpeechTranslationConfigImpl.prototype.setProperty = function(name, value) {
        this.privSpeechProperties.setProperty(name, value);
    };
    Object.defineProperty(SpeechTranslationConfigImpl.prototype, "properties", {
        /**
         * Provides access to custom properties.
         * @member SpeechTranslationConfigImpl.prototype.properties
         * @function
         * @public
         * @returns {PropertyCollection} The properties.
         */ get: function() {
            return this.privSpeechProperties;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Dispose of associated resources.
     * @member SpeechTranslationConfigImpl.prototype.close
     * @function
     * @public
     */ SpeechTranslationConfigImpl.prototype.close = function() {
        return;
    };
    SpeechTranslationConfigImpl.prototype.setServiceProperty = function(name, value) {
        var currentProperties = JSON.parse(this.privSpeechProperties.getProperty($dEkJU.ServicePropertiesPropertyName, "{}"));
        currentProperties[name] = value;
        this.privSpeechProperties.setProperty($dEkJU.ServicePropertiesPropertyName, JSON.stringify(currentProperties));
    };
    SpeechTranslationConfigImpl.prototype.setProfanity = function(profanity) {
        this.privSpeechProperties.setProperty($hM4QX.PropertyId.SpeechServiceResponse_ProfanityOption, $hM4QX.ProfanityOption[profanity]);
    };
    SpeechTranslationConfigImpl.prototype.enableAudioLogging = function() {
        this.privSpeechProperties.setProperty($hM4QX.PropertyId.SpeechServiceConnection_EnableAudioLogging, "true");
    };
    SpeechTranslationConfigImpl.prototype.requestWordLevelTimestamps = function() {
        this.privSpeechProperties.setProperty($hM4QX.PropertyId.SpeechServiceResponse_RequestWordLevelTimestamps, "true");
    };
    SpeechTranslationConfigImpl.prototype.enableDictation = function() {
        this.privSpeechProperties.setProperty($dEkJU.ForceDictationPropertyName, "true");
    };
    Object.defineProperty(SpeechTranslationConfigImpl.prototype, "speechSynthesisLanguage", {
        get: function() {
            return this.privSpeechProperties.getProperty($hM4QX.PropertyId.SpeechServiceConnection_SynthLanguage);
        },
        set: function(language) {
            this.privSpeechProperties.setProperty($hM4QX.PropertyId.SpeechServiceConnection_SynthLanguage, language);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SpeechTranslationConfigImpl.prototype, "speechSynthesisVoiceName", {
        get: function() {
            return this.privSpeechProperties.getProperty($hM4QX.PropertyId.SpeechServiceConnection_SynthVoice);
        },
        set: function(voice) {
            this.privSpeechProperties.setProperty($hM4QX.PropertyId.SpeechServiceConnection_SynthVoice, voice);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SpeechTranslationConfigImpl.prototype, "speechSynthesisOutputFormat", {
        get: function() {
            // eslint-disable-next-line
            return $hM4QX.SpeechSynthesisOutputFormat[this.privSpeechProperties.getProperty($hM4QX.PropertyId.SpeechServiceConnection_SynthOutputFormat, undefined)];
        },
        set: function(format) {
            this.privSpeechProperties.setProperty($hM4QX.PropertyId.SpeechServiceConnection_SynthOutputFormat, $hM4QX.SpeechSynthesisOutputFormat[format]);
        },
        enumerable: false,
        configurable: true
    });
    return SpeechTranslationConfigImpl;
}($aa35d17cd1019f60$var$SpeechTranslationConfig);
module.exports.SpeechTranslationConfigImpl = $aa35d17cd1019f60$var$SpeechTranslationConfigImpl;

});

parcelRequire.register("i2Xql", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PropertyCollection = void 0;

var $hM4QX = parcelRequire("hM4QX");
/**
 * Represents collection of properties and their values.
 * @class PropertyCollection
 */ var $d23682428da81649$var$PropertyCollection = /** @class */ function() {
    function PropertyCollection() {
        this.privKeys = [];
        this.privValues = [];
    }
    /**
     * Returns the property value in type String.
     * Currently only String, int and bool are allowed.
     * If the name is not available, the specified defaultValue is returned.
     * @member PropertyCollection.prototype.getProperty
     * @function
     * @public
     * @param {string} key - The parameter name.
     * @param {string | number | boolean} def - The default value which is returned if the parameter
     * is not available in the collection.
     * @returns {string} value of the parameter.
     */ PropertyCollection.prototype.getProperty = function(key, def) {
        var keyToUse;
        if (typeof key === "string") keyToUse = key;
        else keyToUse = $hM4QX.PropertyId[key];
        for(var n = 0; n < this.privKeys.length; n++){
            if (this.privKeys[n] === keyToUse) return this.privValues[n];
        }
        if (def === undefined) return undefined;
        return String(def);
    };
    /**
     * Sets the String value of the parameter specified by name.
     * @member PropertyCollection.prototype.setProperty
     * @function
     * @public
     * @param {string} key - The parameter name.
     * @param {string} value - The value of the parameter.
     */ PropertyCollection.prototype.setProperty = function(key, value) {
        var keyToUse;
        if (typeof key === "string") keyToUse = key;
        else keyToUse = $hM4QX.PropertyId[key];
        for(var n = 0; n < this.privKeys.length; n++)if (this.privKeys[n] === keyToUse) {
            this.privValues[n] = value;
            return;
        }
        this.privKeys.push(keyToUse);
        this.privValues.push(value);
    };
    /**
     * Clones the collection.
     * @member PropertyCollection.prototype.clone
     * @function
     * @public
     * @returns {PropertyCollection} A copy of the collection.
     */ PropertyCollection.prototype.clone = function() {
        var clonedMap = new PropertyCollection();
        for(var n = 0; n < this.privKeys.length; n++){
            clonedMap.privKeys.push(this.privKeys[n]);
            clonedMap.privValues.push(this.privValues[n]);
        }
        return clonedMap;
    };
    /**
     * Merges this set of properties into another, no overwrites.
     * @member PropertyCollection.prototype.mergeTo
     * @function
     * @public
     * @param {PropertyCollection}  destinationCollection - The collection to merge into.
     */ PropertyCollection.prototype.mergeTo = function(destinationCollection) {
        var _this = this;
        this.privKeys.forEach(function(key) {
            if (destinationCollection.getProperty(key, undefined) === undefined) {
                var value = _this.getProperty(key);
                destinationCollection.setProperty(key, value);
            }
        });
    };
    Object.defineProperty(PropertyCollection.prototype, "keys", {
        /**
         * Get the keys in Property Collection.
         * @member PropertyCollection.prototype.keys
         * @function
         * @public
         * @returns {string []} Keys in the collection.
         */ get: function() {
            return this.privKeys;
        },
        enumerable: false,
        configurable: true
    });
    return PropertyCollection;
}();
module.exports.PropertyCollection = $d23682428da81649$var$PropertyCollection;

});

parcelRequire.register("8TH7f", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PropertyId = void 0;
/**
 * Defines speech property ids.
 * @class PropertyId
 */ var $67a4e7b2f06feb5a$var$PropertyId;
(function(PropertyId) {
    /**
     * The Cognitive Services Speech Service subscription Key. If you are using an intent recognizer, you need to
     * specify the LUIS endpoint key for your particular LUIS app. Under normal circumstances, you shouldn't
     * have to use this property directly.
     * Instead, use [[SpeechConfig.fromSubscription]].
     * @member PropertyId.SpeechServiceConnection_Key
     */ PropertyId[PropertyId["SpeechServiceConnection_Key"] = 0] = "SpeechServiceConnection_Key";
    /**
     * The Cognitive Services Speech Service endpoint (url). Under normal circumstances, you shouldn't
     * have to use this property directly.
     * Instead, use [[SpeechConfig.fromEndpoint]].
     * NOTE: This endpoint is not the same as the endpoint used to obtain an access token.
     * @member PropertyId.SpeechServiceConnection_Endpoint
     */ PropertyId[PropertyId["SpeechServiceConnection_Endpoint"] = 1] = "SpeechServiceConnection_Endpoint";
    /**
     * The Cognitive Services Speech Service region. Under normal circumstances, you shouldn't have to
     * use this property directly.
     * Instead, use [[SpeechConfig.fromSubscription]], [[SpeechConfig.fromEndpoint]], [[SpeechConfig.fromAuthorizationToken]].
     * @member PropertyId.SpeechServiceConnection_Region
     */ PropertyId[PropertyId["SpeechServiceConnection_Region"] = 2] = "SpeechServiceConnection_Region";
    /**
     * The Cognitive Services Speech Service authorization token (aka access token). Under normal circumstances,
     * you shouldn't have to use this property directly.
     * Instead, use [[SpeechConfig.fromAuthorizationToken]], [[SpeechRecognizer.authorizationToken]],
     * [[IntentRecognizer.authorizationToken]], [[TranslationRecognizer.authorizationToken]], [[SpeakerRecognizer.authorizationToken]].
     * @member PropertyId.SpeechServiceAuthorization_Token
     */ PropertyId[PropertyId["SpeechServiceAuthorization_Token"] = 3] = "SpeechServiceAuthorization_Token";
    /**
     * The Cognitive Services Speech Service authorization type. Currently unused.
     * @member PropertyId.SpeechServiceAuthorization_Type
     */ PropertyId[PropertyId["SpeechServiceAuthorization_Type"] = 4] = "SpeechServiceAuthorization_Type";
    /**
     * The Cognitive Services Speech Service endpoint id. Under normal circumstances, you shouldn't
     * have to use this property directly.
     * Instead, use [[SpeechConfig.endpointId]].
     * NOTE: The endpoint id is available in the Speech Portal, listed under Endpoint Details.
     * @member PropertyId.SpeechServiceConnection_EndpointId
     */ PropertyId[PropertyId["SpeechServiceConnection_EndpointId"] = 5] = "SpeechServiceConnection_EndpointId";
    /**
     * The list of comma separated languages (BCP-47 format) used as target translation languages. Under normal circumstances,
     * you shouldn't have to use this property directly.
     * Instead use [[SpeechTranslationConfig.addTargetLanguage]],
     * [[SpeechTranslationConfig.targetLanguages]], [[TranslationRecognizer.targetLanguages]].
     * @member PropertyId.SpeechServiceConnection_TranslationToLanguages
     */ PropertyId[PropertyId["SpeechServiceConnection_TranslationToLanguages"] = 6] = "SpeechServiceConnection_TranslationToLanguages";
    /**
     * The name of the Cognitive Service Text to Speech Service Voice. Under normal circumstances, you shouldn't have to use this
     * property directly.
     * Instead, use [[SpeechTranslationConfig.voiceName]].
     * NOTE: Valid voice names can be found <a href="https://aka.ms/csspeech/voicenames">here</a>.
     * @member PropertyId.SpeechServiceConnection_TranslationVoice
     */ PropertyId[PropertyId["SpeechServiceConnection_TranslationVoice"] = 7] = "SpeechServiceConnection_TranslationVoice";
    /**
     * Translation features.
     * @member PropertyId.SpeechServiceConnection_TranslationFeatures
     */ PropertyId[PropertyId["SpeechServiceConnection_TranslationFeatures"] = 8] = "SpeechServiceConnection_TranslationFeatures";
    /**
     * The Language Understanding Service Region. Under normal circumstances, you shouldn't have to use this property directly.
     * Instead, use [[LanguageUnderstandingModel]].
     * @member PropertyId.SpeechServiceConnection_IntentRegion
     */ PropertyId[PropertyId["SpeechServiceConnection_IntentRegion"] = 9] = "SpeechServiceConnection_IntentRegion";
    /**
     * The host name of the proxy server used to connect to the Cognitive Services Speech Service. Only relevant in Node.js environments.
     * You shouldn't have to use this property directly.
     * Instead use <see cref="SpeechConfig.SetProxy(string,int,string,string)"/>.
     * Added in version 1.4.0.
     */ PropertyId[PropertyId["SpeechServiceConnection_ProxyHostName"] = 10] = "SpeechServiceConnection_ProxyHostName";
    /**
     * The port of the proxy server used to connect to the Cognitive Services Speech Service. Only relevant in Node.js environments.
     * You shouldn't have to use this property directly.
     * Instead use <see cref="SpeechConfig.SetProxy(string,int,string,string)"/>.
     * Added in version 1.4.0.
     */ PropertyId[PropertyId["SpeechServiceConnection_ProxyPort"] = 11] = "SpeechServiceConnection_ProxyPort";
    /**
     * The user name of the proxy server used to connect to the Cognitive Services Speech Service. Only relevant in Node.js environments.
     * You shouldn't have to use this property directly.
     * Instead use <see cref="SpeechConfig.SetProxy(string,int,string,string)"/>.
     * Added in version 1.4.0.
     */ PropertyId[PropertyId["SpeechServiceConnection_ProxyUserName"] = 12] = "SpeechServiceConnection_ProxyUserName";
    /**
     * The password of the proxy server used to connect to the Cognitive Services Speech Service. Only relevant in Node.js environments.
     * You shouldn't have to use this property directly.
     * Instead use <see cref="SpeechConfig.SetProxy(string,int,string,string)"/>.
     * Added in version 1.4.0.
     */ PropertyId[PropertyId["SpeechServiceConnection_ProxyPassword"] = 13] = "SpeechServiceConnection_ProxyPassword";
    /**
     * The Cognitive Services Speech Service recognition Mode. Can be "INTERACTIVE", "CONVERSATION", "DICTATION".
     * This property is intended to be read-only. The SDK is using it internally.
     * @member PropertyId.SpeechServiceConnection_RecoMode
     */ PropertyId[PropertyId["SpeechServiceConnection_RecoMode"] = 14] = "SpeechServiceConnection_RecoMode";
    /**
     * The spoken language to be recognized (in BCP-47 format). Under normal circumstances, you shouldn't have to use this property
     * directly.
     * Instead, use [[SpeechConfig.speechRecognitionLanguage]].
     * @member PropertyId.SpeechServiceConnection_RecoLanguage
     */ PropertyId[PropertyId["SpeechServiceConnection_RecoLanguage"] = 15] = "SpeechServiceConnection_RecoLanguage";
    /**
     * The session id. This id is a universally unique identifier (aka UUID) representing a specific binding of an audio input stream
     * and the underlying speech recognition instance to which it is bound. Under normal circumstances, you shouldn't have to use this
     * property directly.
     * Instead use [[SessionEventArgs.sessionId]].
     * @member PropertyId.Speech_SessionId
     */ PropertyId[PropertyId["Speech_SessionId"] = 16] = "Speech_SessionId";
    /**
     * The spoken language to be synthesized (e.g. en-US)
     * @member PropertyId.SpeechServiceConnection_SynthLanguage
     */ PropertyId[PropertyId["SpeechServiceConnection_SynthLanguage"] = 17] = "SpeechServiceConnection_SynthLanguage";
    /**
     * The name of the TTS voice to be used for speech synthesis
     * @member PropertyId.SpeechServiceConnection_SynthVoice
     */ PropertyId[PropertyId["SpeechServiceConnection_SynthVoice"] = 18] = "SpeechServiceConnection_SynthVoice";
    /**
     * The string to specify TTS output audio format
     * @member PropertyId.SpeechServiceConnection_SynthOutputFormat
     */ PropertyId[PropertyId["SpeechServiceConnection_SynthOutputFormat"] = 19] = "SpeechServiceConnection_SynthOutputFormat";
    /**
     * The list of comma separated languages used as possible source languages
     * Added in version 1.13.0
     * @member PropertyId.SpeechServiceConnection_AutoDetectSourceLanguages
     */ PropertyId[PropertyId["SpeechServiceConnection_AutoDetectSourceLanguages"] = 20] = "SpeechServiceConnection_AutoDetectSourceLanguages";
    /**
     * The requested Cognitive Services Speech Service response output format (simple or detailed). Under normal circumstances, you shouldn't have
     * to use this property directly.
     * Instead use [[SpeechConfig.outputFormat]].
     * @member PropertyId.SpeechServiceResponse_RequestDetailedResultTrueFalse
     */ PropertyId[PropertyId["SpeechServiceResponse_RequestDetailedResultTrueFalse"] = 21] = "SpeechServiceResponse_RequestDetailedResultTrueFalse";
    /**
     * The requested Cognitive Services Speech Service response output profanity level. Currently unused.
     * @member PropertyId.SpeechServiceResponse_RequestProfanityFilterTrueFalse
     */ PropertyId[PropertyId["SpeechServiceResponse_RequestProfanityFilterTrueFalse"] = 22] = "SpeechServiceResponse_RequestProfanityFilterTrueFalse";
    /**
     * The Cognitive Services Speech Service response output (in JSON format). This property is available on recognition result objects only.
     * @member PropertyId.SpeechServiceResponse_JsonResult
     */ PropertyId[PropertyId["SpeechServiceResponse_JsonResult"] = 23] = "SpeechServiceResponse_JsonResult";
    /**
     * The Cognitive Services Speech Service error details (in JSON format). Under normal circumstances, you shouldn't have to
     * use this property directly. Instead use [[CancellationDetails.errorDetails]].
     * @member PropertyId.SpeechServiceResponse_JsonErrorDetails
     */ PropertyId[PropertyId["SpeechServiceResponse_JsonErrorDetails"] = 24] = "SpeechServiceResponse_JsonErrorDetails";
    /**
     * The cancellation reason. Currently unused.
     * @member PropertyId.CancellationDetails_Reason
     */ PropertyId[PropertyId["CancellationDetails_Reason"] = 25] = "CancellationDetails_Reason";
    /**
     * The cancellation text. Currently unused.
     * @member PropertyId.CancellationDetails_ReasonText
     */ PropertyId[PropertyId["CancellationDetails_ReasonText"] = 26] = "CancellationDetails_ReasonText";
    /**
     * The Cancellation detailed text. Currently unused.
     * @member PropertyId.CancellationDetails_ReasonDetailedText
     */ PropertyId[PropertyId["CancellationDetails_ReasonDetailedText"] = 27] = "CancellationDetails_ReasonDetailedText";
    /**
     * The Language Understanding Service response output (in JSON format). Available via [[IntentRecognitionResult]]
     * @member PropertyId.LanguageUnderstandingServiceResponse_JsonResult
     */ PropertyId[PropertyId["LanguageUnderstandingServiceResponse_JsonResult"] = 28] = "LanguageUnderstandingServiceResponse_JsonResult";
    /**
     * The URL string built from speech configuration.
     * This property is intended to be read-only. The SDK is using it internally.
     * NOTE: Added in version 1.7.0.
     */ PropertyId[PropertyId["SpeechServiceConnection_Url"] = 29] = "SpeechServiceConnection_Url";
    /**
     * The initial silence timeout value (in milliseconds) used by the service.
     * Added in version 1.7.0
     */ PropertyId[PropertyId["SpeechServiceConnection_InitialSilenceTimeoutMs"] = 30] = "SpeechServiceConnection_InitialSilenceTimeoutMs";
    /**
     * The end silence timeout value (in milliseconds) used by the service.
     * Added in version 1.7.0
     */ PropertyId[PropertyId["SpeechServiceConnection_EndSilenceTimeoutMs"] = 31] = "SpeechServiceConnection_EndSilenceTimeoutMs";
    /**
     * A duration of detected silence, measured in milliseconds, after which speech-to-text will determine a spoken
     * phrase has ended and generate a final Recognized result. Configuring this timeout may be helpful in situations
     * where spoken input is significantly faster or slower than usual and default segmentation behavior consistently
     * yields results that are too long or too short. Segmentation timeout values that are inappropriately high or low
     * can negatively affect speech-to-text accuracy; this property should be carefully configured and the resulting
     * behavior should be thoroughly validated as intended.
     *
     * For more information about timeout configuration that includes discussion of default behaviors, please visit
     * https://aka.ms/csspeech/timeouts.
     *
     * Added in version 1.21.0.
     */ PropertyId[PropertyId["Speech_SegmentationSilenceTimeoutMs"] = 32] = "Speech_SegmentationSilenceTimeoutMs";
    /**
     * A boolean value specifying whether audio logging is enabled in the service or not.
     * Audio and content logs are stored either in Microsoft-owned storage, or in your own storage account linked
     * to your Cognitive Services subscription (Bring Your Own Storage (BYOS) enabled Speech resource).
     * The logs will be removed after 30 days.
     * Added in version 1.7.0
     */ PropertyId[PropertyId["SpeechServiceConnection_EnableAudioLogging"] = 33] = "SpeechServiceConnection_EnableAudioLogging";
    /**
     * The speech service connection language identifier mode.
     * Can be "AtStart" (the default), or "Continuous". See Language
     * Identification document https://aka.ms/speech/lid?pivots=programming-language-javascript
     * for more details.
     * Added in 1.25.0
     **/ PropertyId[PropertyId["SpeechServiceConnection_LanguageIdMode"] = 34] = "SpeechServiceConnection_LanguageIdMode";
    /**
     * A string value representing the desired endpoint version to target for Speech Recognition.
     * Added in version 1.21.0
     */ PropertyId[PropertyId["SpeechServiceConnection_RecognitionEndpointVersion"] = 35] = "SpeechServiceConnection_RecognitionEndpointVersion";
    /**
    /**
     * A string value the current speaker recognition scenario/mode (TextIndependentIdentification, etc.).
     * Added in version 1.23.0
     */ PropertyId[PropertyId["SpeechServiceConnection_SpeakerIdMode"] = 36] = "SpeechServiceConnection_SpeakerIdMode";
    /**
     * The requested Cognitive Services Speech Service response output profanity setting.
     * Allowed values are "masked", "removed", and "raw".
     * Added in version 1.7.0.
     */ PropertyId[PropertyId["SpeechServiceResponse_ProfanityOption"] = 37] = "SpeechServiceResponse_ProfanityOption";
    /**
     * A string value specifying which post processing option should be used by service.
     * Allowed values are "TrueText".
     * Added in version 1.7.0
     */ PropertyId[PropertyId["SpeechServiceResponse_PostProcessingOption"] = 38] = "SpeechServiceResponse_PostProcessingOption";
    /**
     * A boolean value specifying whether to include word-level timestamps in the response result.
     * Added in version 1.7.0
     */ PropertyId[PropertyId["SpeechServiceResponse_RequestWordLevelTimestamps"] = 39] = "SpeechServiceResponse_RequestWordLevelTimestamps";
    /**
     * The number of times a word has to be in partial results to be returned.
     * Added in version 1.7.0
     */ PropertyId[PropertyId["SpeechServiceResponse_StablePartialResultThreshold"] = 40] = "SpeechServiceResponse_StablePartialResultThreshold";
    /**
     * A string value specifying the output format option in the response result. Internal use only.
     * Added in version 1.7.0.
     */ PropertyId[PropertyId["SpeechServiceResponse_OutputFormatOption"] = 41] = "SpeechServiceResponse_OutputFormatOption";
    /**
     * A boolean value to request for stabilizing translation partial results by omitting words in the end.
     * Added in version 1.7.0.
     */ PropertyId[PropertyId["SpeechServiceResponse_TranslationRequestStablePartialResult"] = 42] = "SpeechServiceResponse_TranslationRequestStablePartialResult";
    /**
     * A boolean value specifying whether to request WordBoundary events.
     * @member PropertyId.SpeechServiceResponse_RequestWordBoundary
     * Added in version 1.21.0.
     */ PropertyId[PropertyId["SpeechServiceResponse_RequestWordBoundary"] = 43] = "SpeechServiceResponse_RequestWordBoundary";
    /**
     * A boolean value specifying whether to request punctuation boundary in WordBoundary Events. Default is true.
     * @member PropertyId.SpeechServiceResponse_RequestPunctuationBoundary
     * Added in version 1.21.0.
     */ PropertyId[PropertyId["SpeechServiceResponse_RequestPunctuationBoundary"] = 44] = "SpeechServiceResponse_RequestPunctuationBoundary";
    /**
     * A boolean value specifying whether to request sentence boundary in WordBoundary Events. Default is false.
     * @member PropertyId.SpeechServiceResponse_RequestSentenceBoundary
     * Added in version 1.21.0.
     */ PropertyId[PropertyId["SpeechServiceResponse_RequestSentenceBoundary"] = 45] = "SpeechServiceResponse_RequestSentenceBoundary";
    /**
     * Identifier used to connect to the backend service.
     * @member PropertyId.Conversation_ApplicationId
     */ PropertyId[PropertyId["Conversation_ApplicationId"] = 46] = "Conversation_ApplicationId";
    /**
     * Type of dialog backend to connect to.
     * @member PropertyId.Conversation_DialogType
     */ PropertyId[PropertyId["Conversation_DialogType"] = 47] = "Conversation_DialogType";
    /**
     * Silence timeout for listening
     * @member PropertyId.Conversation_Initial_Silence_Timeout
     */ PropertyId[PropertyId["Conversation_Initial_Silence_Timeout"] = 48] = "Conversation_Initial_Silence_Timeout";
    /**
     * From Id to add to speech recognition activities.
     * @member PropertyId.Conversation_From_Id
     */ PropertyId[PropertyId["Conversation_From_Id"] = 49] = "Conversation_From_Id";
    /**
     * ConversationId for the session.
     * @member PropertyId.Conversation_Conversation_Id
     */ PropertyId[PropertyId["Conversation_Conversation_Id"] = 50] = "Conversation_Conversation_Id";
    /**
     * Comma separated list of custom voice deployment ids.
     * @member PropertyId.Conversation_Custom_Voice_Deployment_Ids
     */ PropertyId[PropertyId["Conversation_Custom_Voice_Deployment_Ids"] = 51] = "Conversation_Custom_Voice_Deployment_Ids";
    /**
     * Speech activity template, stamp properties from the template on the activity generated by the service for speech.
     * @member PropertyId.Conversation_Speech_Activity_Template
     * Added in version 1.10.0.
     */ PropertyId[PropertyId["Conversation_Speech_Activity_Template"] = 52] = "Conversation_Speech_Activity_Template";
    /**
     * Enables or disables the receipt of turn status messages as obtained on the turnStatusReceived event.
     * @member PropertyId.Conversation_Request_Bot_Status_Messages
     * Added in version 1.15.0.
     */ PropertyId[PropertyId["Conversation_Request_Bot_Status_Messages"] = 53] = "Conversation_Request_Bot_Status_Messages";
    /**
     * Specifies the connection ID to be provided in the Agent configuration message, e.g. a Direct Line token for
     * channel authentication.
     * Added in version 1.15.1.
     */ PropertyId[PropertyId["Conversation_Agent_Connection_Id"] = 54] = "Conversation_Agent_Connection_Id";
    /**
     * The Cognitive Services Speech Service host (url). Under normal circumstances, you shouldn't have to use this property directly.
     * Instead, use [[SpeechConfig.fromHost]].
     */ PropertyId[PropertyId["SpeechServiceConnection_Host"] = 55] = "SpeechServiceConnection_Host";
    /**
     * Set the host for service calls to the Conversation Translator REST management and websocket calls.
     */ PropertyId[PropertyId["ConversationTranslator_Host"] = 56] = "ConversationTranslator_Host";
    /**
     * Optionally set the the host's display name.
     * Used when joining a conversation.
     */ PropertyId[PropertyId["ConversationTranslator_Name"] = 57] = "ConversationTranslator_Name";
    /**
     * Optionally set a value for the X-CorrelationId request header.
     * Used for troubleshooting errors in the server logs. It should be a valid guid.
     */ PropertyId[PropertyId["ConversationTranslator_CorrelationId"] = 58] = "ConversationTranslator_CorrelationId";
    /**
     * Set the conversation token to be sent to the speech service. This enables the
     * service to service call from the speech service to the Conversation Translator service for relaying
     * recognitions. For internal use.
     */ PropertyId[PropertyId["ConversationTranslator_Token"] = 59] = "ConversationTranslator_Token";
    /**
     * The reference text of the audio for pronunciation evaluation.
     * For this and the following pronunciation assessment parameters, see
     * https://docs.microsoft.com/azure/cognitive-services/speech-service/rest-speech-to-text#pronunciation-assessment-parameters for details.
     * Under normal circumstances, you shouldn't have to use this property directly.
     * Added in version 1.15.0
     */ PropertyId[PropertyId["PronunciationAssessment_ReferenceText"] = 60] = "PronunciationAssessment_ReferenceText";
    /**
     * The point system for pronunciation score calibration (FivePoint or HundredMark).
     * Under normal circumstances, you shouldn't have to use this property directly.
     * Added in version 1.15.0
     */ PropertyId[PropertyId["PronunciationAssessment_GradingSystem"] = 61] = "PronunciationAssessment_GradingSystem";
    /**
     * The pronunciation evaluation granularity (Phoneme, Word, or FullText).
     * Under normal circumstances, you shouldn't have to use this property directly.
     * Added in version 1.15.0
     */ PropertyId[PropertyId["PronunciationAssessment_Granularity"] = 62] = "PronunciationAssessment_Granularity";
    /**
     * Defines if enable miscue calculation.
     * With this enabled, the pronounced words will be compared to the reference text,
     * and will be marked with omission/insertion based on the comparison. The default setting is False.
     * Under normal circumstances, you shouldn't have to use this property directly.
     * Added in version 1.15.0
     */ PropertyId[PropertyId["PronunciationAssessment_EnableMiscue"] = 63] = "PronunciationAssessment_EnableMiscue";
    /**
     * The json string of pronunciation assessment parameters
     * Under normal circumstances, you shouldn't have to use this property directly.
     * Added in version 1.15.0
     */ PropertyId[PropertyId["PronunciationAssessment_Json"] = 64] = "PronunciationAssessment_Json";
    /**
     * Pronunciation assessment parameters.
     * This property is intended to be read-only. The SDK is using it internally.
     * Added in version 1.15.0
     */ PropertyId[PropertyId["PronunciationAssessment_Params"] = 65] = "PronunciationAssessment_Params";
    /**
     * Version of Speaker Recognition API to use.
     * Added in version 1.18.0
     */ PropertyId[PropertyId["SpeakerRecognition_Api_Version"] = 66] = "SpeakerRecognition_Api_Version";
})($67a4e7b2f06feb5a$var$PropertyId = module.exports.PropertyId || (module.exports.PropertyId = {}));

});

parcelRequire.register("KKCGx", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
var $08c87656e79ac028$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $08c87656e79ac028$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Recognizer = void 0;

var $dEkJU = parcelRequire("dEkJU");

var $em8BD = parcelRequire("em8BD");

var $gBGZx = parcelRequire("gBGZx");

var $hM4QX = parcelRequire("hM4QX");
/**
 * Defines the base class Recognizer which mainly contains common event handlers.
 * @class Recognizer
 */ var $08c87656e79ac028$var$Recognizer = /** @class */ function() {
    /**
     * Creates and initializes an instance of a Recognizer
     * @constructor
     * @param {AudioConfig} audioInput - An optional audio input stream associated with the recognizer
     */ function Recognizer(audioConfig, properties, connectionFactory) {
        this.audioConfig = audioConfig !== undefined ? audioConfig : $hM4QX.AudioConfig.fromDefaultMicrophoneInput();
        this.privDisposed = false;
        this.privProperties = properties.clone();
        this.privConnectionFactory = connectionFactory;
        this.implCommonRecognizerSetup();
    }
    /**
     * Dispose of associated resources.
     * @member Recognizer.prototype.close
     * @function
     * @public
     */ Recognizer.prototype.close = function(cb, errorCb) {
        $gBGZx.Contracts.throwIfDisposed(this.privDisposed);
        $em8BD.marshalPromiseToCallbacks(this.dispose(true), cb, errorCb);
    };
    Object.defineProperty(Recognizer.prototype, "internalData", {
        /**
         * @Internal
         * Internal data member to support fromRecognizer* pattern methods on other classes.
         * Do not use externally, object returned will change without warning or notice.
         */ get: function() {
            return this.privReco;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * This method performs cleanup of resources.
     * The Boolean parameter disposing indicates whether the method is called
     * from Dispose (if disposing is true) or from the finalizer (if disposing is false).
     * Derived classes should override this method to dispose resource if needed.
     * @member Recognizer.prototype.dispose
     * @function
     * @public
     * @param {boolean} disposing - Flag to request disposal.
     */ Recognizer.prototype.dispose = function(disposing) {
        return $08c87656e79ac028$var$__awaiter(this, void 0, void 0, function() {
            return $08c87656e79ac028$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (this.privDisposed) return [
                            2 /*return*/ 
                        ];
                        this.privDisposed = true;
                        if (!disposing) return [
                            3 /*break*/ ,
                            3
                        ];
                        if (!this.privReco) return [
                            3 /*break*/ ,
                            3
                        ];
                        return [
                            4 /*yield*/ ,
                            this.privReco.audioSource.turnOff()
                        ];
                    case 1:
                        _a.sent();
                        return [
                            4 /*yield*/ ,
                            this.privReco.dispose()
                        ];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    Object.defineProperty(Recognizer, "telemetryEnabled", {
        /**
         * This method returns the current state of the telemetry setting.
         * @member Recognizer.prototype.telemetryEnabled
         * @function
         * @public
         * @returns true if the telemetry is enabled, false otherwise.
         */ get: function() {
            return $dEkJU.ServiceRecognizerBase.telemetryDataEnabled;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * This method globally enables or disables telemetry.
     * @member Recognizer.prototype.enableTelemetry
     * @function
     * @public
     * @param enabled - Global setting for telemetry collection.
     * If set to true, telemetry information like microphone errors,
     * recognition errors are collected and sent to Microsoft.
     * If set to false, no telemetry is sent to Microsoft.
     */ Recognizer.enableTelemetry = function(enabled) {
        $dEkJU.ServiceRecognizerBase.telemetryDataEnabled = enabled;
    };
    // Does the generic recognizer setup that is common across all recognizer types.
    Recognizer.prototype.implCommonRecognizerSetup = function() {
        var osPlatform = typeof window !== "undefined" ? "Browser" : "Node";
        var osName = "unknown";
        var osVersion = "unknown";
        if (typeof navigator !== "undefined") {
            osPlatform = osPlatform + "/" + navigator.platform;
            osName = navigator.userAgent;
            osVersion = navigator.appVersion;
        }
        var recognizerConfig = this.createRecognizerConfig(new $dEkJU.SpeechServiceConfig(new $dEkJU.Context(new $dEkJU.OS(osPlatform, osName, osVersion))));
        this.privReco = this.createServiceRecognizer(Recognizer.getAuthFromProperties(this.privProperties), this.privConnectionFactory, this.audioConfig, recognizerConfig);
    };
    Recognizer.prototype.recognizeOnceAsyncImpl = function(recognitionMode) {
        return $08c87656e79ac028$var$__awaiter(this, void 0, void 0, function() {
            var ret, result;
            return $08c87656e79ac028$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        $gBGZx.Contracts.throwIfDisposed(this.privDisposed);
                        ret = new $em8BD.Deferred();
                        return [
                            4 /*yield*/ ,
                            this.implRecognizerStop()
                        ];
                    case 1:
                        _a.sent();
                        return [
                            4 /*yield*/ ,
                            this.privReco.recognize(recognitionMode, ret.resolve, ret.reject)
                        ];
                    case 2:
                        _a.sent();
                        return [
                            4 /*yield*/ ,
                            ret.promise
                        ];
                    case 3:
                        result = _a.sent();
                        return [
                            4 /*yield*/ ,
                            this.implRecognizerStop()
                        ];
                    case 4:
                        _a.sent();
                        return [
                            2 /*return*/ ,
                            result
                        ];
                }
            });
        });
    };
    Recognizer.prototype.startContinuousRecognitionAsyncImpl = function(recognitionMode) {
        return $08c87656e79ac028$var$__awaiter(this, void 0, void 0, function() {
            return $08c87656e79ac028$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        $gBGZx.Contracts.throwIfDisposed(this.privDisposed);
                        return [
                            4 /*yield*/ ,
                            this.implRecognizerStop()
                        ];
                    case 1:
                        _a.sent();
                        return [
                            4 /*yield*/ ,
                            this.privReco.recognize(recognitionMode, undefined, undefined)
                        ];
                    case 2:
                        _a.sent();
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    Recognizer.prototype.stopContinuousRecognitionAsyncImpl = function() {
        return $08c87656e79ac028$var$__awaiter(this, void 0, void 0, function() {
            return $08c87656e79ac028$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        $gBGZx.Contracts.throwIfDisposed(this.privDisposed);
                        return [
                            4 /*yield*/ ,
                            this.implRecognizerStop()
                        ];
                    case 1:
                        _a.sent();
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    Recognizer.prototype.implRecognizerStop = function() {
        return $08c87656e79ac028$var$__awaiter(this, void 0, void 0, function() {
            return $08c87656e79ac028$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!this.privReco) return [
                            3 /*break*/ ,
                            2
                        ];
                        return [
                            4 /*yield*/ ,
                            this.privReco.stopRecognizing()
                        ];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    Recognizer.getAuthFromProperties = function(properties) {
        var subscriptionKey = properties.getProperty($hM4QX.PropertyId.SpeechServiceConnection_Key, undefined);
        var authentication = subscriptionKey && subscriptionKey !== "" ? new $dEkJU.CognitiveSubscriptionKeyAuthentication(subscriptionKey) : new $dEkJU.CognitiveTokenAuthentication(function() {
            var authorizationToken = properties.getProperty($hM4QX.PropertyId.SpeechServiceAuthorization_Token, undefined);
            return Promise.resolve(authorizationToken);
        }, function() {
            var authorizationToken = properties.getProperty($hM4QX.PropertyId.SpeechServiceAuthorization_Token, undefined);
            return Promise.resolve(authorizationToken);
        });
        return authentication;
    };
    return Recognizer;
}();
module.exports.Recognizer = $08c87656e79ac028$var$Recognizer;

});

parcelRequire.register("42zO9", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
var $2f132002fce74bca$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $2f132002fce74bca$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $2f132002fce74bca$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SpeechRecognizer = void 0;

var $dEkJU = parcelRequire("dEkJU");

var $em8BD = parcelRequire("em8BD");

var $gBGZx = parcelRequire("gBGZx");

var $hM4QX = parcelRequire("hM4QX");
/**
 * Performs speech recognition from microphone, file, or other audio input streams, and gets transcribed text as result.
 * @class SpeechRecognizer
 */ var $2f132002fce74bca$var$SpeechRecognizer = /** @class */ function(_super) {
    $2f132002fce74bca$var$__extends(SpeechRecognizer, _super);
    /**
     * SpeechRecognizer constructor.
     * @constructor
     * @param {SpeechConfig} speechConfig - an set of initial properties for this recognizer
     * @param {AudioConfig} audioConfig - An optional audio configuration associated with the recognizer
     */ function SpeechRecognizer(speechConfig, audioConfig) {
        var _this = this;
        var speechConfigImpl = speechConfig;
        $gBGZx.Contracts.throwIfNull(speechConfigImpl, "speechConfig");
        $gBGZx.Contracts.throwIfNullOrWhitespace(speechConfigImpl.properties.getProperty($hM4QX.PropertyId.SpeechServiceConnection_RecoLanguage), $hM4QX.PropertyId[$hM4QX.PropertyId.SpeechServiceConnection_RecoLanguage]);
        _this = _super.call(this, audioConfig, speechConfigImpl.properties, new $dEkJU.SpeechConnectionFactory()) || this;
        _this.privDisposedRecognizer = false;
        return _this;
    }
    /**
     * SpeechRecognizer constructor.
     * @constructor
     * @param {SpeechConfig} speechConfig - an set of initial properties for this recognizer
     * @param {AutoDetectSourceLanguageConfig} autoDetectSourceLanguageConfig - An source language detection configuration associated with the recognizer
     * @param {AudioConfig} audioConfig - An optional audio configuration associated with the recognizer
     */ SpeechRecognizer.FromConfig = function(speechConfig, autoDetectSourceLanguageConfig, audioConfig) {
        var speechConfigImpl = speechConfig;
        autoDetectSourceLanguageConfig.properties.mergeTo(speechConfigImpl.properties);
        var recognizer = new SpeechRecognizer(speechConfig, audioConfig);
        return recognizer;
    };
    Object.defineProperty(SpeechRecognizer.prototype, "endpointId", {
        /**
         * Gets the endpoint id of a customized speech model that is used for speech recognition.
         * @member SpeechRecognizer.prototype.endpointId
         * @function
         * @public
         * @returns {string} the endpoint id of a customized speech model that is used for speech recognition.
         */ get: function() {
            $gBGZx.Contracts.throwIfDisposed(this.privDisposedRecognizer);
            return this.properties.getProperty($hM4QX.PropertyId.SpeechServiceConnection_EndpointId, "00000000-0000-0000-0000-000000000000");
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SpeechRecognizer.prototype, "authorizationToken", {
        /**
         * Gets the authorization token used to communicate with the service.
         * @member SpeechRecognizer.prototype.authorizationToken
         * @function
         * @public
         * @returns {string} Authorization token.
         */ get: function() {
            return this.properties.getProperty($hM4QX.PropertyId.SpeechServiceAuthorization_Token);
        },
        /**
         * Gets/Sets the authorization token used to communicate with the service.
         * @member SpeechRecognizer.prototype.authorizationToken
         * @function
         * @public
         * @param {string} token - Authorization token.
         */ set: function(token) {
            $gBGZx.Contracts.throwIfNullOrWhitespace(token, "token");
            this.properties.setProperty($hM4QX.PropertyId.SpeechServiceAuthorization_Token, token);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SpeechRecognizer.prototype, "speechRecognitionLanguage", {
        /**
         * Gets the spoken language of recognition.
         * @member SpeechRecognizer.prototype.speechRecognitionLanguage
         * @function
         * @public
         * @returns {string} The spoken language of recognition.
         */ get: function() {
            $gBGZx.Contracts.throwIfDisposed(this.privDisposedRecognizer);
            return this.properties.getProperty($hM4QX.PropertyId.SpeechServiceConnection_RecoLanguage);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SpeechRecognizer.prototype, "outputFormat", {
        /**
         * Gets the output format of recognition.
         * @member SpeechRecognizer.prototype.outputFormat
         * @function
         * @public
         * @returns {OutputFormat} The output format of recognition.
         */ get: function() {
            $gBGZx.Contracts.throwIfDisposed(this.privDisposedRecognizer);
            if (this.properties.getProperty($dEkJU.OutputFormatPropertyName, $hM4QX.OutputFormat[$hM4QX.OutputFormat.Simple]) === $hM4QX.OutputFormat[$hM4QX.OutputFormat.Simple]) return $hM4QX.OutputFormat.Simple;
            else return $hM4QX.OutputFormat.Detailed;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SpeechRecognizer.prototype, "properties", {
        /**
         * The collection of properties and their values defined for this SpeechRecognizer.
         * @member SpeechRecognizer.prototype.properties
         * @function
         * @public
         * @returns {PropertyCollection} The collection of properties and their values defined for this SpeechRecognizer.
         */ get: function() {
            return this.privProperties;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Starts speech recognition, and stops after the first utterance is recognized.
     * The task returns the recognition text as result.
     * Note: RecognizeOnceAsync() returns when the first utterance has been recognized,
     * so it is suitable only for single shot recognition
     * like command or query. For long-running recognition, use StartContinuousRecognitionAsync() instead.
     * @member SpeechRecognizer.prototype.recognizeOnceAsync
     * @function
     * @public
     * @param cb - Callback that received the SpeechRecognitionResult.
     * @param err - Callback invoked in case of an error.
     */ SpeechRecognizer.prototype.recognizeOnceAsync = function(cb, err) {
        $em8BD.marshalPromiseToCallbacks(this.recognizeOnceAsyncImpl($dEkJU.RecognitionMode.Interactive), cb, err);
    };
    /**
     * Starts speech recognition, until stopContinuousRecognitionAsync() is called.
     * User must subscribe to events to receive recognition results.
     * @member SpeechRecognizer.prototype.startContinuousRecognitionAsync
     * @function
     * @public
     * @param cb - Callback invoked once the recognition has started.
     * @param err - Callback invoked in case of an error.
     */ SpeechRecognizer.prototype.startContinuousRecognitionAsync = function(cb, err) {
        $em8BD.marshalPromiseToCallbacks(this.startContinuousRecognitionAsyncImpl($dEkJU.RecognitionMode.Conversation), cb, err);
    };
    /**
     * Stops continuous speech recognition.
     * @member SpeechRecognizer.prototype.stopContinuousRecognitionAsync
     * @function
     * @public
     * @param cb - Callback invoked once the recognition has stopped.
     * @param err - Callback invoked in case of an error.
     */ SpeechRecognizer.prototype.stopContinuousRecognitionAsync = function(cb, err) {
        $em8BD.marshalPromiseToCallbacks(this.stopContinuousRecognitionAsyncImpl(), cb, err);
    };
    /**
     * Starts speech recognition with keyword spotting, until
     * stopKeywordRecognitionAsync() is called.
     * User must subscribe to events to receive recognition results.
     * Note: Key word spotting functionality is only available on the
     * Speech Devices SDK. This functionality is currently not included in the SDK itself.
     * @member SpeechRecognizer.prototype.startKeywordRecognitionAsync
     * @function
     * @public
     * @param {KeywordRecognitionModel} model The keyword recognition model that
     * specifies the keyword to be recognized.
     * @param cb - Callback invoked once the recognition has started.
     * @param err - Callback invoked in case of an error.
     */ SpeechRecognizer.prototype.startKeywordRecognitionAsync = function(model, cb, err) {
        $gBGZx.Contracts.throwIfNull(model, "model");
        if (!!err) err("Not yet implemented.");
    };
    /**
     * Stops continuous speech recognition.
     * Note: Key word spotting functionality is only available on the
     * Speech Devices SDK. This functionality is currently not included in the SDK itself.
     * @member SpeechRecognizer.prototype.stopKeywordRecognitionAsync
     * @function
     * @public
     * @param cb - Callback invoked once the recognition has stopped.
     * @param err - Callback invoked in case of an error.
     */ SpeechRecognizer.prototype.stopKeywordRecognitionAsync = function(cb) {
        if (!!cb) cb();
    };
    /**
     * closes all external resources held by an instance of this class.
     * @member SpeechRecognizer.prototype.close
     * @function
     * @public
     */ SpeechRecognizer.prototype.close = function(cb, errorCb) {
        $gBGZx.Contracts.throwIfDisposed(this.privDisposedRecognizer);
        $em8BD.marshalPromiseToCallbacks(this.dispose(true), cb, errorCb);
    };
    /**
     * Disposes any resources held by the object.
     * @member SpeechRecognizer.prototype.dispose
     * @function
     * @public
     * @param {boolean} disposing - true if disposing the object.
     */ SpeechRecognizer.prototype.dispose = function(disposing) {
        return $2f132002fce74bca$var$__awaiter(this, void 0, void 0, function() {
            return $2f132002fce74bca$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (this.privDisposedRecognizer) return [
                            2 /*return*/ 
                        ];
                        if (!disposing) return [
                            3 /*break*/ ,
                            2
                        ];
                        this.privDisposedRecognizer = true;
                        return [
                            4 /*yield*/ ,
                            this.implRecognizerStop()
                        ];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        return [
                            4 /*yield*/ ,
                            _super.prototype.dispose.call(this, disposing)
                        ];
                    case 3:
                        _a.sent();
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    SpeechRecognizer.prototype.createRecognizerConfig = function(speechConfig) {
        return new $dEkJU.RecognizerConfig(speechConfig, this.privProperties);
    };
    SpeechRecognizer.prototype.createServiceRecognizer = function(authentication, connectionFactory, audioConfig, recognizerConfig) {
        var configImpl = audioConfig;
        return new $dEkJU.SpeechServiceRecognizer(authentication, connectionFactory, configImpl, recognizerConfig, this);
    };
    return SpeechRecognizer;
}($hM4QX.Recognizer);
module.exports.SpeechRecognizer = $2f132002fce74bca$var$SpeechRecognizer;

});

parcelRequire.register("2wjgv", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
var $1d5d839ca68a4a3b$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $1d5d839ca68a4a3b$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $1d5d839ca68a4a3b$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.IntentRecognizer = void 0;

var $dEkJU = parcelRequire("dEkJU");

var $em8BD = parcelRequire("em8BD");

var $gBGZx = parcelRequire("gBGZx");

var $hM4QX = parcelRequire("hM4QX");
/**
 * Intent recognizer.
 * @class
 */ var $1d5d839ca68a4a3b$var$IntentRecognizer = /** @class */ function(_super) {
    $1d5d839ca68a4a3b$var$__extends(IntentRecognizer, _super);
    /**
     * Initializes an instance of the IntentRecognizer.
     * @constructor
     * @param {SpeechConfig} speechConfig - The set of configuration properties.
     * @param {AudioConfig} audioConfig - An optional audio input config associated with the recognizer
     */ function IntentRecognizer(speechConfig, audioConfig) {
        var _this = this;
        $gBGZx.Contracts.throwIfNullOrUndefined(speechConfig, "speechConfig");
        var configImpl = speechConfig;
        $gBGZx.Contracts.throwIfNullOrUndefined(configImpl, "speechConfig");
        _this = _super.call(this, audioConfig, configImpl.properties, new $dEkJU.IntentConnectionFactory()) || this;
        _this.privAddedIntents = [];
        _this.privAddedLmIntents = {};
        _this.privDisposedIntentRecognizer = false;
        _this.privProperties = configImpl.properties;
        $gBGZx.Contracts.throwIfNullOrWhitespace(_this.properties.getProperty($hM4QX.PropertyId.SpeechServiceConnection_RecoLanguage), $hM4QX.PropertyId[$hM4QX.PropertyId.SpeechServiceConnection_RecoLanguage]);
        return _this;
    }
    Object.defineProperty(IntentRecognizer.prototype, "speechRecognitionLanguage", {
        /**
         * Gets the spoken language of recognition.
         * @member IntentRecognizer.prototype.speechRecognitionLanguage
         * @function
         * @public
         * @returns {string} the spoken language of recognition.
         */ get: function() {
            $gBGZx.Contracts.throwIfDisposed(this.privDisposedIntentRecognizer);
            return this.properties.getProperty($hM4QX.PropertyId.SpeechServiceConnection_RecoLanguage);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IntentRecognizer.prototype, "authorizationToken", {
        /**
         * Gets the authorization token used to communicate with the service.
         * @member IntentRecognizer.prototype.authorizationToken
         * @function
         * @public
         * @returns {string} Authorization token.
         */ get: function() {
            return this.properties.getProperty($hM4QX.PropertyId.SpeechServiceAuthorization_Token);
        },
        /**
         * Gets/Sets the authorization token used to communicate with the service.
         * Note: Please use a token derived from your LanguageUnderstanding subscription key for the Intent recognizer.
         * @member IntentRecognizer.prototype.authorizationToken
         * @function
         * @public
         * @param {string} value - Authorization token.
         */ set: function(value) {
            this.properties.setProperty($hM4QX.PropertyId.SpeechServiceAuthorization_Token, value);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IntentRecognizer.prototype, "properties", {
        /**
         * The collection of properties and their values defined for this IntentRecognizer.
         * @member IntentRecognizer.prototype.properties
         * @function
         * @public
         * @returns {PropertyCollection} The collection of properties and their
         * values defined for this IntentRecognizer.
         */ get: function() {
            return this.privProperties;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Starts intent recognition, and stops after the first utterance is recognized.
     * The task returns the recognition text and intent as result.
     * Note: RecognizeOnceAsync() returns when the first utterance has been recognized,
     * so it is suitable only for single shot recognition like command or query.
     * For long-running recognition, use StartContinuousRecognitionAsync() instead.
     * @member IntentRecognizer.prototype.recognizeOnceAsync
     * @function
     * @public
     * @param cb - Callback that received the recognition has finished with an IntentRecognitionResult.
     * @param err - Callback invoked in case of an error.
     */ IntentRecognizer.prototype.recognizeOnceAsync = function(cb, err) {
        $gBGZx.Contracts.throwIfDisposed(this.privDisposedIntentRecognizer);
        if (Object.keys(this.privAddedLmIntents).length !== 0 || undefined !== this.privUmbrellaIntent) {
            var context = this.buildSpeechContext();
            this.privReco.speechContext.setSection("intent", context.Intent);
            this.privReco.dynamicGrammar.addReferenceGrammar(context.ReferenceGrammars);
            var intentReco = this.privReco;
            intentReco.setIntents(this.privAddedLmIntents, this.privUmbrellaIntent);
        }
        $em8BD.marshalPromiseToCallbacks(this.recognizeOnceAsyncImpl($dEkJU.RecognitionMode.Interactive), cb, err);
    };
    /**
     * Starts speech recognition, until stopContinuousRecognitionAsync() is called.
     * User must subscribe to events to receive recognition results.
     * @member IntentRecognizer.prototype.startContinuousRecognitionAsync
     * @function
     * @public
     * @param cb - Callback invoked once the recognition has started.
     * @param err - Callback invoked in case of an error.
     */ IntentRecognizer.prototype.startContinuousRecognitionAsync = function(cb, err) {
        if (Object.keys(this.privAddedLmIntents).length !== 0 || undefined !== this.privUmbrellaIntent) {
            var context = this.buildSpeechContext();
            this.privReco.speechContext.setSection("intent", context.Intent);
            this.privReco.dynamicGrammar.addReferenceGrammar(context.ReferenceGrammars);
            var intentReco = this.privReco;
            intentReco.setIntents(this.privAddedLmIntents, this.privUmbrellaIntent);
        }
        $em8BD.marshalPromiseToCallbacks(this.startContinuousRecognitionAsyncImpl($dEkJU.RecognitionMode.Conversation), cb, err);
    };
    /**
     * Stops continuous intent recognition.
     * @member IntentRecognizer.prototype.stopContinuousRecognitionAsync
     * @function
     * @public
     * @param cb - Callback invoked once the recognition has stopped.
     * @param err - Callback invoked in case of an error.
     */ IntentRecognizer.prototype.stopContinuousRecognitionAsync = function(cb, err) {
        $em8BD.marshalPromiseToCallbacks(this.stopContinuousRecognitionAsyncImpl(), cb, err);
    };
    /**
     * Starts speech recognition with keyword spotting, until stopKeywordRecognitionAsync() is called.
     * User must subscribe to events to receive recognition results.
     * Note: Key word spotting functionality is only available on the Speech Devices SDK.
     * This functionality is currently not included in the SDK itself.
     * @member IntentRecognizer.prototype.startKeywordRecognitionAsync
     * @function
     * @public
     * @param {KeywordRecognitionModel} model - The keyword recognition model that specifies the keyword to be recognized.
     * @param cb - Callback invoked once the recognition has started.
     * @param err - Callback invoked in case of an error.
     */ IntentRecognizer.prototype.startKeywordRecognitionAsync = function(model, cb, err) {
        $gBGZx.Contracts.throwIfNull(model, "model");
        if (!!err) err("Not yet implemented.");
    };
    /**
     * Stops continuous speech recognition.
     * Note: Key word spotting functionality is only available on the Speech Devices SDK.
     * This functionality is currently not included in the SDK itself.
     * @member IntentRecognizer.prototype.stopKeywordRecognitionAsync
     * @function
     * @public
     * @param cb - Callback invoked once the recognition has stopped.
     * @param err - Callback invoked in case of an error.
     */ IntentRecognizer.prototype.stopKeywordRecognitionAsync = function(cb, err) {
        if (!!cb) try {
            cb();
        } catch (e) {
            if (!!err) err(e);
        }
    };
    /**
     * Adds a phrase that should be recognized as intent.
     * @member IntentRecognizer.prototype.addIntent
     * @function
     * @public
     * @param {string} intentId - A String that represents the identifier of the intent to be recognized.
     * @param {string} phrase - A String that specifies the phrase representing the intent.
     */ IntentRecognizer.prototype.addIntent = function(simplePhrase, intentId) {
        $gBGZx.Contracts.throwIfDisposed(this.privDisposedIntentRecognizer);
        $gBGZx.Contracts.throwIfNullOrWhitespace(intentId, "intentId");
        $gBGZx.Contracts.throwIfNullOrWhitespace(simplePhrase, "simplePhrase");
        this.privAddedIntents.push([
            intentId,
            simplePhrase
        ]);
    };
    /**
     * Adds an intent from Language Understanding service for recognition.
     * @member IntentRecognizer.prototype.addIntentWithLanguageModel
     * @function
     * @public
     * @param {string} intentId - A String that represents the identifier of the intent
     * to be recognized. Ignored if intentName is empty.
     * @param {string} model - The intent model from Language Understanding service.
     * @param {string} intentName - The intent name defined in the intent model. If it
     * is empty, all intent names defined in the model will be added.
     */ IntentRecognizer.prototype.addIntentWithLanguageModel = function(intentId, model, intentName) {
        $gBGZx.Contracts.throwIfDisposed(this.privDisposedIntentRecognizer);
        $gBGZx.Contracts.throwIfNullOrWhitespace(intentId, "intentId");
        $gBGZx.Contracts.throwIfNull(model, "model");
        var modelImpl = model;
        $gBGZx.Contracts.throwIfNullOrWhitespace(modelImpl.appId, "model.appId");
        this.privAddedLmIntents[intentId] = new $dEkJU.AddedLmIntent(modelImpl, intentName);
    };
    /**
     * @summary Adds all intents from the specified Language Understanding Model.
     * @member IntentRecognizer.prototype.addAllIntents
     * @function
     * @public
     * @function
     * @public
     * @param {LanguageUnderstandingModel} model - The language understanding model containing the intents.
     * @param {string} intentId - A custom id String to be returned in the IntentRecognitionResult's getIntentId() method.
     */ IntentRecognizer.prototype.addAllIntents = function(model, intentId) {
        $gBGZx.Contracts.throwIfNull(model, "model");
        var modelImpl = model;
        $gBGZx.Contracts.throwIfNullOrWhitespace(modelImpl.appId, "model.appId");
        this.privUmbrellaIntent = new $dEkJU.AddedLmIntent(modelImpl, intentId);
    };
    /**
     * closes all external resources held by an instance of this class.
     * @member IntentRecognizer.prototype.close
     * @function
     * @public
     */ IntentRecognizer.prototype.close = function(cb, errorCb) {
        $gBGZx.Contracts.throwIfDisposed(this.privDisposedIntentRecognizer);
        $em8BD.marshalPromiseToCallbacks(this.dispose(true), cb, errorCb);
    };
    IntentRecognizer.prototype.createRecognizerConfig = function(speechConfig) {
        return new $dEkJU.RecognizerConfig(speechConfig, this.privProperties);
    };
    IntentRecognizer.prototype.createServiceRecognizer = function(authentication, connectionFactory, audioConfig, recognizerConfig) {
        var audioImpl = audioConfig;
        return new $dEkJU.IntentServiceRecognizer(authentication, connectionFactory, audioImpl, recognizerConfig, this);
    };
    IntentRecognizer.prototype.dispose = function(disposing) {
        return $1d5d839ca68a4a3b$var$__awaiter(this, void 0, void 0, function() {
            return $1d5d839ca68a4a3b$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (this.privDisposedIntentRecognizer) return [
                            2 /*return*/ 
                        ];
                        if (!disposing) return [
                            3 /*break*/ ,
                            2
                        ];
                        this.privDisposedIntentRecognizer = true;
                        return [
                            4 /*yield*/ ,
                            _super.prototype.dispose.call(this, disposing)
                        ];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    IntentRecognizer.prototype.buildSpeechContext = function() {
        var appId;
        var region;
        var subscriptionKey;
        var refGrammers = [];
        if (undefined !== this.privUmbrellaIntent) {
            appId = this.privUmbrellaIntent.modelImpl.appId;
            region = this.privUmbrellaIntent.modelImpl.region;
            subscriptionKey = this.privUmbrellaIntent.modelImpl.subscriptionKey;
        }
        // Build the reference grammer array.
        for(var _i = 0, _a = Object.keys(this.privAddedLmIntents); _i < _a.length; _i++){
            var intentId = _a[_i];
            var addedLmIntent = this.privAddedLmIntents[intentId];
            // validate all the same model, region, and key...
            if (appId === undefined) appId = addedLmIntent.modelImpl.appId;
            else {
                if (appId !== addedLmIntent.modelImpl.appId) throw new Error("Intents must all be from the same LUIS model");
            }
            if (region === undefined) region = addedLmIntent.modelImpl.region;
            else {
                if (region !== addedLmIntent.modelImpl.region) throw new Error("Intents must all be from the same LUIS model in a single region");
            }
            if (subscriptionKey === undefined) subscriptionKey = addedLmIntent.modelImpl.subscriptionKey;
            else {
                if (subscriptionKey !== addedLmIntent.modelImpl.subscriptionKey) throw new Error("Intents must all use the same subscription key");
            }
            var grammer = "luis/" + appId + "-PRODUCTION#" + intentId;
            refGrammers.push(grammer);
        }
        return {
            Intent: {
                id: appId,
                key: subscriptionKey === undefined ? this.privProperties.getProperty($hM4QX.PropertyId[$hM4QX.PropertyId.SpeechServiceConnection_Key]) : subscriptionKey,
                provider: "LUIS"
            },
            ReferenceGrammars: undefined === this.privUmbrellaIntent ? refGrammers : [
                "luis/" + appId + "-PRODUCTION"
            ]
        };
    };
    return IntentRecognizer;
}($hM4QX.Recognizer);
module.exports.IntentRecognizer = $1d5d839ca68a4a3b$var$IntentRecognizer;

});

parcelRequire.register("hN0ZH", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.VoiceProfileType = void 0;
/**
 * Output format
 * @class VoiceProfileType
 */ var $cf37c8a9e5662f5b$var$VoiceProfileType;
(function(VoiceProfileType) {
    /**
     * Text independent speaker identification
     * @member VoiceProfileType.TextIndependentIdentification
     */ VoiceProfileType[VoiceProfileType["TextIndependentIdentification"] = 0] = "TextIndependentIdentification";
    /**
     * Text dependent speaker verification
     * @member VoiceProfileType.TextDependentVerification
     */ VoiceProfileType[VoiceProfileType["TextDependentVerification"] = 1] = "TextDependentVerification";
    /**
     * Text independent speaker verification
     * @member VoiceProfileType.TextIndependentVerification
     */ VoiceProfileType[VoiceProfileType["TextIndependentVerification"] = 2] = "TextIndependentVerification";
})($cf37c8a9e5662f5b$var$VoiceProfileType = module.exports.VoiceProfileType || (module.exports.VoiceProfileType = {}));

});

parcelRequire.register("8Cnfw", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
var $6463e833b35cb743$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $6463e833b35cb743$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $6463e833b35cb743$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TranslationRecognizer = void 0;

var $dEkJU = parcelRequire("dEkJU");

var $em8BD = parcelRequire("em8BD");

var $0Yrfd = parcelRequire("0Yrfd");

var $gBGZx = parcelRequire("gBGZx");

var $hM4QX = parcelRequire("hM4QX");
/**
 * Translation recognizer
 * @class TranslationRecognizer
 */ var $6463e833b35cb743$var$TranslationRecognizer = /** @class */ function(_super) {
    $6463e833b35cb743$var$__extends(TranslationRecognizer, _super);
    /**
     * Initializes an instance of the TranslationRecognizer.
     * @constructor
     * @param {SpeechTranslationConfig} speechConfig - Set of properties to configure this recognizer.
     * @param {AudioConfig} audioConfig - An optional audio config associated with the recognizer
     * @param {IConnectionFactory} connectionFactory - An optional connection factory to use to generate the endpoint URIs, headers to set, etc...
     */ function TranslationRecognizer(speechConfig, audioConfig, connectionFactory) {
        var _this = this;
        var configImpl = speechConfig;
        $gBGZx.Contracts.throwIfNull(configImpl, "speechConfig");
        _this = _super.call(this, audioConfig, configImpl.properties, connectionFactory || new $dEkJU.TranslationConnectionFactory()) || this;
        _this.privDisposedTranslationRecognizer = false;
        if (_this.properties.getProperty($hM4QX.PropertyId.SpeechServiceConnection_TranslationVoice, undefined) !== undefined) $gBGZx.Contracts.throwIfNullOrWhitespace(_this.properties.getProperty($hM4QX.PropertyId.SpeechServiceConnection_TranslationVoice), $hM4QX.PropertyId[$hM4QX.PropertyId.SpeechServiceConnection_TranslationVoice]);
        $gBGZx.Contracts.throwIfNullOrWhitespace(_this.properties.getProperty($hM4QX.PropertyId.SpeechServiceConnection_TranslationToLanguages), $hM4QX.PropertyId[$hM4QX.PropertyId.SpeechServiceConnection_TranslationToLanguages]);
        $gBGZx.Contracts.throwIfNullOrWhitespace(_this.properties.getProperty($hM4QX.PropertyId.SpeechServiceConnection_RecoLanguage), $hM4QX.PropertyId[$hM4QX.PropertyId.SpeechServiceConnection_RecoLanguage]);
        return _this;
    }
    /**
     * TranslationRecognizer constructor.
     * @constructor
     * @param {SpeechTranslationConfig} speechTranslationConfig - an set of initial properties for this recognizer
     * @param {AutoDetectSourceLanguageConfig} autoDetectSourceLanguageConfig - An source language detection configuration associated with the recognizer
     * @param {AudioConfig} audioConfig - An optional audio configuration associated with the recognizer
     */ TranslationRecognizer.FromConfig = function(speechTranslationConfig, autoDetectSourceLanguageConfig, audioConfig) {
        var speechTranslationConfigImpl = speechTranslationConfig;
        autoDetectSourceLanguageConfig.properties.mergeTo(speechTranslationConfigImpl.properties);
        return new TranslationRecognizer(speechTranslationConfig, audioConfig);
    };
    Object.defineProperty(TranslationRecognizer.prototype, "speechRecognitionLanguage", {
        /**
         * Gets the language name that was set when the recognizer was created.
         * @member TranslationRecognizer.prototype.speechRecognitionLanguage
         * @function
         * @public
         * @returns {string} Gets the language name that was set when the recognizer was created.
         */ get: function() {
            $gBGZx.Contracts.throwIfDisposed(this.privDisposedTranslationRecognizer);
            return this.properties.getProperty($hM4QX.PropertyId.SpeechServiceConnection_RecoLanguage);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TranslationRecognizer.prototype, "targetLanguages", {
        /**
         * Gets target languages for translation that were set when the recognizer was created.
         * The language is specified in BCP-47 format. The translation will provide translated text for each of language.
         * @member TranslationRecognizer.prototype.targetLanguages
         * @function
         * @public
         * @returns {string[]} Gets target languages for translation that were set when the recognizer was created.
         */ get: function() {
            $gBGZx.Contracts.throwIfDisposed(this.privDisposedTranslationRecognizer);
            return this.properties.getProperty($hM4QX.PropertyId.SpeechServiceConnection_TranslationToLanguages).split(",");
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TranslationRecognizer.prototype, "voiceName", {
        /**
         * Gets the name of output voice.
         * @member TranslationRecognizer.prototype.voiceName
         * @function
         * @public
         * @returns {string} the name of output voice.
         */ get: function() {
            $gBGZx.Contracts.throwIfDisposed(this.privDisposedTranslationRecognizer);
            return this.properties.getProperty($hM4QX.PropertyId.SpeechServiceConnection_TranslationVoice, undefined);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TranslationRecognizer.prototype, "properties", {
        /**
         * The collection of properties and their values defined for this TranslationRecognizer.
         * @member TranslationRecognizer.prototype.properties
         * @function
         * @public
         * @returns {PropertyCollection} The collection of properties and their values defined for this TranslationRecognizer.
         */ get: function() {
            return this.privProperties;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TranslationRecognizer.prototype, "authorizationToken", {
        /**
         * Gets the authorization token used to communicate with the service.
         * @member TranslationRecognizer.prototype.authorizationToken
         * @function
         * @public
         * @returns {string} Authorization token.
         */ get: function() {
            return this.properties.getProperty($hM4QX.PropertyId.SpeechServiceAuthorization_Token);
        },
        /**
         * Gets/Sets the authorization token used to communicate with the service.
         * @member TranslationRecognizer.prototype.authorizationToken
         * @function
         * @public
         * @param {string} value - Authorization token.
         */ set: function(value) {
            this.properties.setProperty($hM4QX.PropertyId.SpeechServiceAuthorization_Token, value);
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Starts recognition and translation, and stops after the first utterance is recognized.
     * The task returns the translation text as result.
     * Note: recognizeOnceAsync returns when the first utterance has been recognized, so it is suitable only
     * for single shot recognition like command or query. For long-running recognition,
     * use startContinuousRecognitionAsync() instead.
     * @member TranslationRecognizer.prototype.recognizeOnceAsync
     * @function
     * @public
     * @param cb - Callback that received the result when the translation has completed.
     * @param err - Callback invoked in case of an error.
     */ TranslationRecognizer.prototype.recognizeOnceAsync = function(cb, err) {
        $gBGZx.Contracts.throwIfDisposed(this.privDisposedTranslationRecognizer);
        $em8BD.marshalPromiseToCallbacks(this.recognizeOnceAsyncImpl($dEkJU.RecognitionMode.Conversation), cb, err);
    };
    /**
     * Starts recognition and translation, until stopContinuousRecognitionAsync() is called.
     * User must subscribe to events to receive translation results.
     * @member TranslationRecognizer.prototype.startContinuousRecognitionAsync
     * @function
     * @public
     * @param cb - Callback that received the translation has started.
     * @param err - Callback invoked in case of an error.
     */ TranslationRecognizer.prototype.startContinuousRecognitionAsync = function(cb, err) {
        $em8BD.marshalPromiseToCallbacks(this.startContinuousRecognitionAsyncImpl($dEkJU.RecognitionMode.Conversation), cb, err);
    };
    /**
     * Stops continuous recognition and translation.
     * @member TranslationRecognizer.prototype.stopContinuousRecognitionAsync
     * @function
     * @public
     * @param cb - Callback that received the translation has stopped.
     * @param err - Callback invoked in case of an error.
     */ TranslationRecognizer.prototype.stopContinuousRecognitionAsync = function(cb, err) {
        $em8BD.marshalPromiseToCallbacks(this.stopContinuousRecognitionAsyncImpl(), cb, err);
    };
    /**
     * dynamically remove a language from list of target language
     * (can be used while recognition is ongoing)
     * @member TranslationRecognizer.prototype.removeTargetLanguage
     * @function
     * @param lang - language to be removed
     * @public
     */ TranslationRecognizer.prototype.removeTargetLanguage = function(lang) {
        $gBGZx.Contracts.throwIfNullOrUndefined(lang, "language to be removed");
        if (this.properties.getProperty($hM4QX.PropertyId.SpeechServiceConnection_TranslationToLanguages, undefined) !== undefined) {
            var languages = this.properties.getProperty($hM4QX.PropertyId.SpeechServiceConnection_TranslationToLanguages).split(",");
            var index = languages.indexOf(lang);
            if (index > -1) {
                languages.splice(index, 1);
                this.properties.setProperty($hM4QX.PropertyId.SpeechServiceConnection_TranslationToLanguages, languages.join(","));
                this.updateLanguages(languages);
            }
        }
    };
    /**
     * dynamically add a language to list of target language
     * (can be used while recognition is ongoing)
     * @member TranslationRecognizer.prototype.addTargetLanguage
     * @function
     * @param lang - language to be added
     * @public
     */ TranslationRecognizer.prototype.addTargetLanguage = function(lang) {
        $gBGZx.Contracts.throwIfNullOrUndefined(lang, "language to be added");
        var languages = [];
        if (this.properties.getProperty($hM4QX.PropertyId.SpeechServiceConnection_TranslationToLanguages, undefined) !== undefined) {
            languages = this.properties.getProperty($hM4QX.PropertyId.SpeechServiceConnection_TranslationToLanguages).split(",");
            if (!languages.includes(lang)) {
                languages.push(lang);
                this.properties.setProperty($hM4QX.PropertyId.SpeechServiceConnection_TranslationToLanguages, languages.join(","));
            }
        } else {
            this.properties.setProperty($hM4QX.PropertyId.SpeechServiceConnection_TranslationToLanguages, lang);
            languages = [
                lang
            ];
        }
        this.updateLanguages(languages);
    };
    /**
     * closes all external resources held by an instance of this class.
     * @member TranslationRecognizer.prototype.close
     * @function
     * @public
     */ TranslationRecognizer.prototype.close = function(cb, errorCb) {
        $gBGZx.Contracts.throwIfDisposed(this.privDisposedTranslationRecognizer);
        $em8BD.marshalPromiseToCallbacks(this.dispose(true), cb, errorCb);
    };
    /**
     * handles ConnectionEstablishedEvent for conversation translation scenarios.
     * @member TranslationRecognizer.prototype.onConnection
     * @function
     * @public
     */ // eslint-disable-next-line @typescript-eslint/no-empty-function
    TranslationRecognizer.prototype.onConnection = function() {};
    /**
     * handles disconnection events for conversation translation scenarios.
     * @member TranslationRecognizer.prototype.onDisconnection
     * @function
     * @public
     */ // eslint-disable-next-line @typescript-eslint/no-empty-function
    TranslationRecognizer.prototype.onDisconnection = function() {
        return $6463e833b35cb743$var$__awaiter(this, void 0, void 0, function() {
            return $6463e833b35cb743$var$__generator(this, function(_a) {
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    TranslationRecognizer.prototype.dispose = function(disposing) {
        return $6463e833b35cb743$var$__awaiter(this, void 0, void 0, function() {
            return $6463e833b35cb743$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (this.privDisposedTranslationRecognizer) return [
                            2 /*return*/ 
                        ];
                        this.privDisposedTranslationRecognizer = true;
                        if (!disposing) return [
                            3 /*break*/ ,
                            3
                        ];
                        return [
                            4 /*yield*/ ,
                            this.implRecognizerStop()
                        ];
                    case 1:
                        _a.sent();
                        return [
                            4 /*yield*/ ,
                            _super.prototype.dispose.call(this, disposing)
                        ];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    TranslationRecognizer.prototype.createRecognizerConfig = function(speechConfig) {
        return new $dEkJU.RecognizerConfig(speechConfig, this.privProperties);
    };
    TranslationRecognizer.prototype.createServiceRecognizer = function(authentication, connectionFactory, audioConfig, recognizerConfig) {
        var configImpl = audioConfig;
        return new $dEkJU.TranslationServiceRecognizer(authentication, connectionFactory, configImpl, recognizerConfig, this);
    };
    TranslationRecognizer.prototype.updateLanguages = function(languages) {
        var conn = $0Yrfd.Connection.fromRecognizer(this);
        if (!!conn) {
            conn.setMessageProperty("speech.context", "translationcontext", {
                to: languages
            });
            conn.sendMessageAsync("event", JSON.stringify({
                id: "translation",
                name: "updateLanguage",
                to: languages
            }));
        }
    };
    return TranslationRecognizer;
}($hM4QX.Recognizer);
module.exports.TranslationRecognizer = $6463e833b35cb743$var$TranslationRecognizer;

});
parcelRequire.register("0Yrfd", function(module, exports) {
"use strict";
//
// Copyright (c) Microsoft. All rights reserved.
// Licensed under the MIT license. See LICENSE.md file in the project root for full license information.
//
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Connection = void 0;

var $dEkJU = parcelRequire("dEkJU");

var $em8BD = parcelRequire("em8BD");

var $3z8sc = parcelRequire("3z8sc");

var $gBGZx = parcelRequire("gBGZx");

var $hM4QX = parcelRequire("hM4QX");
/**
 * Connection is a proxy class for managing connection to the speech service of the specified Recognizer.
 * By default, a Recognizer autonomously manages connection to service when needed.
 * The Connection class provides additional methods for users to explicitly open or close a connection and
 * to subscribe to connection status changes.
 * The use of Connection is optional, and mainly for scenarios where fine tuning of application
 * behavior based on connection status is needed. Users can optionally call Open() to manually set up a connection
 * in advance before starting recognition on the Recognizer associated with this Connection.
 * If the Recognizer needs to connect or disconnect to service, it will
 * setup or shutdown the connection independently. In this case the Connection will be notified by change of connection
 * status via Connected/Disconnected events.
 * Added in version 1.2.1.
 */ var $002ee203a2dd12e4$var$Connection = /** @class */ function() {
    function Connection() {}
    /**
     * Gets the Connection instance from the specified recognizer.
     * @param recognizer The recognizer associated with the connection.
     * @return The Connection instance of the recognizer.
     */ Connection.fromRecognizer = function(recognizer) {
        var recoBase = recognizer.internalData;
        var ret = new Connection();
        ret.privInternalData = recoBase;
        ret.setupEvents();
        return ret;
    };
    /**
     * Gets the Connection instance from the specified synthesizer.
     * @param synthesizer The synthesizer associated with the connection.
     * @return The Connection instance of the synthesizer.
     */ Connection.fromSynthesizer = function(synthesizer) {
        var synthBase = synthesizer.internalData;
        var ret = new Connection();
        ret.privInternalData = synthBase;
        ret.setupEvents();
        return ret;
    };
    /**
     * Starts to set up connection to the service.
     * Users can optionally call openConnection() to manually set up a connection in advance before starting recognition on the
     * Recognizer associated with this Connection. After starting recognition, calling Open() will have no effect
     *
     * Note: On return, the connection might not be ready yet. Please subscribe to the Connected event to
     * be notified when the connection is established.
     */ Connection.prototype.openConnection = function(cb, err) {
        $em8BD.marshalPromiseToCallbacks(this.privInternalData.connect(), cb, err);
    };
    /**
     * Closes the connection the service.
     * Users can optionally call closeConnection() to manually shutdown the connection of the associated Recognizer.
     *
     * If closeConnection() is called during recognition, recognition will fail and cancel with an error.
     */ Connection.prototype.closeConnection = function(cb, err) {
        if (this.privInternalData instanceof $dEkJU.SynthesisAdapterBase) throw new Error("Disconnecting a synthesizer's connection is currently not supported");
        else $em8BD.marshalPromiseToCallbacks(this.privInternalData.disconnect(), cb, err);
    };
    /**
     * Appends a parameter in a message to service.
     * Added in version 1.12.1.
     * @param path The path of the network message.
     * @param propertyName Name of the property
     * @param propertyValue Value of the property. This is a json string.
     */ Connection.prototype.setMessageProperty = function(path, propertyName, propertyValue) {
        $gBGZx.Contracts.throwIfNullOrWhitespace(propertyName, "propertyName");
        if (this.privInternalData instanceof $dEkJU.ServiceRecognizerBase) {
            if (path.toLowerCase() !== "speech.context") throw new Error("Only speech.context message property sets are currently supported for recognizer");
            else this.privInternalData.speechContext.setSection(propertyName, propertyValue);
        } else if (this.privInternalData instanceof $dEkJU.SynthesisAdapterBase) {
            if (path.toLowerCase() !== "synthesis.context") throw new Error("Only synthesis.context message property sets are currently supported for synthesizer");
            else this.privInternalData.synthesisContext.setSection(propertyName, propertyValue);
        }
    };
    /**
     * Sends a message to the speech service.
     * Added in version 1.13.0.
     * @param path The WebSocket path of the message
     * @param payload The payload of the message. This is a json string or a ArrayBuffer.
     * @param success A callback to indicate success.
     * @param error A callback to indicate an error.
     */ Connection.prototype.sendMessageAsync = function(path, payload, success, error) {
        $em8BD.marshalPromiseToCallbacks(this.privInternalData.sendNetworkMessage(path, payload), success, error);
    };
    /**
     * Dispose of associated resources.
     */ Connection.prototype.close = function() {
    /* eslint-disable no-empty */ };
    Connection.prototype.setupEvents = function() {
        var _this = this;
        this.privEventListener = this.privInternalData.connectionEvents.attach(function(connectionEvent) {
            if (connectionEvent.name === "ConnectionEstablishedEvent") {
                if (!!_this.connected) _this.connected(new $hM4QX.ConnectionEventArgs(connectionEvent.connectionId));
            } else if (connectionEvent.name === "ConnectionClosedEvent") {
                if (!!_this.disconnected) _this.disconnected(new $hM4QX.ConnectionEventArgs(connectionEvent.connectionId));
            } else if (connectionEvent.name === "ConnectionMessageSentEvent") {
                if (!!_this.messageSent) _this.messageSent(new $hM4QX.ConnectionMessageEventArgs(new $3z8sc.ConnectionMessageImpl(connectionEvent.message)));
            } else if (connectionEvent.name === "ConnectionMessageReceivedEvent") {
                if (!!_this.messageReceived) _this.messageReceived(new $hM4QX.ConnectionMessageEventArgs(new $3z8sc.ConnectionMessageImpl(connectionEvent.message)));
            }
        });
        this.privServiceEventListener = this.privInternalData.serviceEvents.attach(function(e) {
            if (!!_this.receivedServiceMessage) _this.receivedServiceMessage(new $hM4QX.ServiceEventArgs(e.jsonString, e.name));
        });
    };
    return Connection;
}();
module.exports.Connection = $002ee203a2dd12e4$var$Connection;

});
parcelRequire.register("3z8sc", function(module, exports) {
"use strict";
//
// Copyright (c) Microsoft. All rights reserved.
// Licensed under the MIT license. See LICENSE.md file in the project root for full license information.
//
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ConnectionMessageImpl = module.exports.ConnectionMessage = void 0;

var $btbfh = parcelRequire("btbfh");

var $em8BD = parcelRequire("em8BD");

var $i2Xql = parcelRequire("i2Xql");

var $8TH7f = parcelRequire("8TH7f");
/**
 * ConnectionMessage represents implementation specific messages sent to and received from
 * the speech service. These messages are provided for debugging purposes and should not
 * be used for production use cases with the Azure Cognitive Services Speech Service.
 * Messages sent to and received from the Speech Service are subject to change without
 * notice. This includes message contents, headers, payloads, ordering, etc.
 * Added in version 1.11.0.
 */ var $298b32be8cc53706$var$ConnectionMessage = /** @class */ function() {
    function ConnectionMessage() {}
    return ConnectionMessage;
}();
module.exports.ConnectionMessage = $298b32be8cc53706$var$ConnectionMessage;
var $298b32be8cc53706$var$ConnectionMessageImpl = /** @class */ function() {
    function ConnectionMessageImpl(message) {
        var _this = this;
        this.privConnectionMessage = message;
        this.privProperties = new $i2Xql.PropertyCollection();
        if (!!this.privConnectionMessage.headers[$btbfh.HeaderNames.ConnectionId]) this.privProperties.setProperty($8TH7f.PropertyId.Speech_SessionId, this.privConnectionMessage.headers[$btbfh.HeaderNames.ConnectionId]);
        Object.keys(this.privConnectionMessage.headers).forEach(function(header) {
            _this.privProperties.setProperty(header, _this.privConnectionMessage.headers[header]);
        });
    }
    Object.defineProperty(ConnectionMessageImpl.prototype, "path", {
        /**
         * The message path.
         */ get: function() {
            return this.privConnectionMessage.headers[Object.keys(this.privConnectionMessage.headers).find(function(key) {
                return key.toLowerCase() === "path".toLowerCase();
            })];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ConnectionMessageImpl.prototype, "isTextMessage", {
        /**
         * Checks to see if the ConnectionMessage is a text message.
         * See also IsBinaryMessage().
         */ get: function() {
            return this.privConnectionMessage.messageType === $em8BD.MessageType.Text;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ConnectionMessageImpl.prototype, "isBinaryMessage", {
        /**
         * Checks to see if the ConnectionMessage is a binary message.
         * See also GetBinaryMessage().
         */ get: function() {
            return this.privConnectionMessage.messageType === $em8BD.MessageType.Binary;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ConnectionMessageImpl.prototype, "TextMessage", {
        /**
         * Gets the text message payload. Typically the text message content-type is
         * application/json. To determine other content-types use
         * Properties.GetProperty("Content-Type").
         */ get: function() {
            return this.privConnectionMessage.textBody;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ConnectionMessageImpl.prototype, "binaryMessage", {
        /**
         * Gets the binary message payload.
         */ get: function() {
            return this.privConnectionMessage.binaryBody;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ConnectionMessageImpl.prototype, "properties", {
        /**
         * A collection of properties and their values defined for this <see cref="ConnectionMessage"/>.
         * Message headers can be accessed via this collection (e.g. "Content-Type").
         */ get: function() {
            return this.privProperties;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Returns a string that represents the connection message.
     */ ConnectionMessageImpl.prototype.toString = function() {
        return "";
    };
    return ConnectionMessageImpl;
}();
module.exports.ConnectionMessageImpl = $298b32be8cc53706$var$ConnectionMessageImpl;

});



parcelRequire.register("b12ZL", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Translations = void 0;

var $hM4QX = parcelRequire("hM4QX");
/**
 * Represents collection of parameters and their values.
 * @class Translations
 */ var $80521c77e9b59381$var$Translations = /** @class */ function() {
    function Translations() {
        // Use an PropertyCollection internally, just wrapping it to hide the | enum syntax it has.
        this.privMap = new $hM4QX.PropertyCollection();
    }
    Object.defineProperty(Translations.prototype, "languages", {
        /**
         * Get the languages in the object in a String array.
         * @member Translations.prototype.languages
         * @function
         * @public
         * @returns {string[]} languages in translations object.
         */ get: function() {
            return this.privMap.keys;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Returns the parameter value in type String. The parameter must have the same type as String.
     * Currently only String, int and bool are allowed.
     * If the name is not available, the specified defaultValue is returned.
     * @member Translations.prototype.get
     * @function
     * @public
     * @param {string} key - The parameter name.
     * @param {string} def - The default value which is returned if the parameter is not available in the collection.
     * @returns {string} value of the parameter.
     */ Translations.prototype.get = function(key, def) {
        return this.privMap.getProperty(key, def);
    };
    /**
     * Sets the String value of the parameter specified by name.
     * @member Translations.prototype.set
     * @function
     * @public
     * @param {string} key - The parameter name.
     * @param {string} value - The value of the parameter.
     */ Translations.prototype.set = function(key, value) {
        this.privMap.setProperty(key, value);
    };
    return Translations;
}();
module.exports.Translations = $80521c77e9b59381$var$Translations;

});

parcelRequire.register("6ILle", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.NoMatchReason = void 0;
/**
 * Defines the possible reasons a recognition result might not be recognized.
 * @class NoMatchReason
 */ var $4e4b9324d1746879$var$NoMatchReason;
(function(NoMatchReason) {
    /**
     * Indicates that speech was detected, but not recognized.
     * @member NoMatchReason.NotRecognized
     */ NoMatchReason[NoMatchReason["NotRecognized"] = 0] = "NotRecognized";
    /**
     * Indicates that the start of the audio stream contained only silence,
     * and the service timed out waiting for speech.
     * @member NoMatchReason.InitialSilenceTimeout
     */ NoMatchReason[NoMatchReason["InitialSilenceTimeout"] = 1] = "InitialSilenceTimeout";
    /**
     * Indicates that the start of the audio stream contained only noise,
     * and the service timed out waiting for speech.
     * @member NoMatchReason.InitialBabbleTimeout
     */ NoMatchReason[NoMatchReason["InitialBabbleTimeout"] = 2] = "InitialBabbleTimeout";
})($4e4b9324d1746879$var$NoMatchReason = module.exports.NoMatchReason || (module.exports.NoMatchReason = {}));

});

parcelRequire.register("4pHMu", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.NoMatchDetails = void 0;

var $dEkJU = parcelRequire("dEkJU");

var $hM4QX = parcelRequire("hM4QX");
/**
 * Contains detailed information for NoMatch recognition results.
 * @class NoMatchDetails
 */ var $336b753b6fd2c351$var$NoMatchDetails = /** @class */ function() {
    /**
     * Creates and initializes an instance of this class.
     * @constructor
     * @param {NoMatchReason} reason - The no-match reason.
     */ function NoMatchDetails(reason) {
        this.privReason = reason;
    }
    /**
     * Creates an instance of NoMatchDetails object for the NoMatch SpeechRecognitionResults.
     * @member NoMatchDetails.fromResult
     * @function
     * @public
     * @param {SpeechRecognitionResult | IntentRecognitionResult | TranslationRecognitionResult}
     * result - The recognition result that was not recognized.
     * @returns {NoMatchDetails} The no match details object being created.
     */ NoMatchDetails.fromResult = function(result) {
        var simpleSpeech = $dEkJU.SimpleSpeechPhrase.fromJSON(result.json);
        var reason = $hM4QX.NoMatchReason.NotRecognized;
        switch(simpleSpeech.RecognitionStatus){
            case $dEkJU.RecognitionStatus.BabbleTimeout:
                reason = $hM4QX.NoMatchReason.InitialBabbleTimeout;
                break;
            case $dEkJU.RecognitionStatus.InitialSilenceTimeout:
                reason = $hM4QX.NoMatchReason.InitialSilenceTimeout;
                break;
            default:
                reason = $hM4QX.NoMatchReason.NotRecognized;
                break;
        }
        return new NoMatchDetails(reason);
    };
    Object.defineProperty(NoMatchDetails.prototype, "reason", {
        /**
         * The reason the recognition was canceled.
         * @member NoMatchDetails.prototype.reason
         * @function
         * @public
         * @returns {NoMatchReason} Specifies the reason canceled.
         */ get: function() {
            return this.privReason;
        },
        enumerable: false,
        configurable: true
    });
    return NoMatchDetails;
}();
module.exports.NoMatchDetails = $336b753b6fd2c351$var$NoMatchDetails;

});

parcelRequire.register("iqPNR", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TranslationRecognitionCanceledEventArgs = void 0;
/**
 * Define payload of speech recognition canceled result events.
 * @class TranslationRecognitionCanceledEventArgs
 */ var $d6b2d6be2a3b2689$var$TranslationRecognitionCanceledEventArgs = /** @class */ function() {
    /**
     * Creates and initializes an instance of this class.
     * @constructor
     * @param {string} sessionid - The session id.
     * @param {CancellationReason} cancellationReason - The cancellation reason.
     * @param {string} errorDetails - Error details, if provided.
     * @param {TranslationRecognitionResult} result - The result.
     */ function TranslationRecognitionCanceledEventArgs(sessionid, cancellationReason, errorDetails, errorCode, result) {
        this.privCancelReason = cancellationReason;
        this.privErrorDetails = errorDetails;
        this.privResult = result;
        this.privSessionId = sessionid;
        this.privErrorCode = errorCode;
    }
    Object.defineProperty(TranslationRecognitionCanceledEventArgs.prototype, "result", {
        /**
         * Specifies the recognition result.
         * @member TranslationRecognitionCanceledEventArgs.prototype.result
         * @function
         * @public
         * @returns {TranslationRecognitionResult} the recognition result.
         */ get: function() {
            return this.privResult;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TranslationRecognitionCanceledEventArgs.prototype, "sessionId", {
        /**
         * Specifies the session identifier.
         * @member TranslationRecognitionCanceledEventArgs.prototype.sessionId
         * @function
         * @public
         * @returns {string} the session identifier.
         */ get: function() {
            return this.privSessionId;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TranslationRecognitionCanceledEventArgs.prototype, "reason", {
        /**
         * The reason the recognition was canceled.
         * @member TranslationRecognitionCanceledEventArgs.prototype.reason
         * @function
         * @public
         * @returns {CancellationReason} Specifies the reason canceled.
         */ get: function() {
            return this.privCancelReason;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TranslationRecognitionCanceledEventArgs.prototype, "errorCode", {
        /**
         * The error code in case of an unsuccessful recognition.
         * Added in version 1.1.0.
         * @return An error code that represents the error reason.
         */ get: function() {
            return this.privErrorCode;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TranslationRecognitionCanceledEventArgs.prototype, "errorDetails", {
        /**
         * In case of an unsuccessful recognition, provides details of the occurred error.
         * @member TranslationRecognitionCanceledEventArgs.prototype.errorDetails
         * @function
         * @public
         * @returns {string} A String that represents the error details.
         */ get: function() {
            return this.privErrorDetails;
        },
        enumerable: false,
        configurable: true
    });
    return TranslationRecognitionCanceledEventArgs;
}();
module.exports.TranslationRecognitionCanceledEventArgs = $d6b2d6be2a3b2689$var$TranslationRecognitionCanceledEventArgs;

});

parcelRequire.register("elLCc", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
var $a727f63ddf69a5db$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.IntentRecognitionCanceledEventArgs = void 0;

var $hM4QX = parcelRequire("hM4QX");
/**
 * Define payload of intent recognition canceled result events.
 * @class IntentRecognitionCanceledEventArgs
 */ var $a727f63ddf69a5db$var$IntentRecognitionCanceledEventArgs = /** @class */ function(_super) {
    $a727f63ddf69a5db$var$__extends(IntentRecognitionCanceledEventArgs, _super);
    /**
     * Creates and initializes an instance of this class.
     * @constructor
     * @param {CancellationReason} result - The result of the intent recognition.
     * @param {string} offset - The offset.
     * @param {IntentRecognitionResult} sessionId - The session id.
     */ function IntentRecognitionCanceledEventArgs(reason, errorDetails, errorCode, result, offset, sessionId) {
        var _this = _super.call(this, result, offset, sessionId) || this;
        _this.privReason = reason;
        _this.privErrorDetails = errorDetails;
        _this.privErrorCode = errorCode;
        return _this;
    }
    Object.defineProperty(IntentRecognitionCanceledEventArgs.prototype, "reason", {
        /**
         * The reason the recognition was canceled.
         * @member IntentRecognitionCanceledEventArgs.prototype.reason
         * @function
         * @public
         * @returns {CancellationReason} Specifies the reason canceled.
         */ get: function() {
            return this.privReason;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IntentRecognitionCanceledEventArgs.prototype, "errorCode", {
        /**
         * The error code in case of an unsuccessful recognition.
         * Added in version 1.1.0.
         * @return An error code that represents the error reason.
         */ get: function() {
            return this.privErrorCode;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IntentRecognitionCanceledEventArgs.prototype, "errorDetails", {
        /**
         * In case of an unsuccessful recognition, provides details of the occurred error.
         * @member IntentRecognitionCanceledEventArgs.prototype.errorDetails
         * @function
         * @public
         * @returns {string} A String that represents the error details.
         */ get: function() {
            return this.privErrorDetails;
        },
        enumerable: false,
        configurable: true
    });
    return IntentRecognitionCanceledEventArgs;
}($hM4QX.IntentRecognitionEventArgs);
module.exports.IntentRecognitionCanceledEventArgs = $a727f63ddf69a5db$var$IntentRecognitionCanceledEventArgs;

});

parcelRequire.register("6zUYZ", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CancellationDetailsBase = void 0;
/**
 * Contains detailed information about why a result was canceled.
 * @class CancellationDetailsBase
 */ var $4ca23689071bbfe2$var$CancellationDetailsBase = /** @class */ function() {
    /**
     * Creates and initializes an instance of this class.
     * @constructor
     * @param {CancellationReason} reason - The cancellation reason.
     * @param {string} errorDetails - The error details, if provided.
     */ function CancellationDetailsBase(reason, errorDetails, errorCode) {
        this.privReason = reason;
        this.privErrorDetails = errorDetails;
        this.privErrorCode = errorCode;
    }
    Object.defineProperty(CancellationDetailsBase.prototype, "reason", {
        /**
         * The reason the recognition was canceled.
         * @member CancellationDetailsBase.prototype.reason
         * @function
         * @public
         * @returns {CancellationReason} Specifies the reason canceled.
         */ get: function() {
            return this.privReason;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CancellationDetailsBase.prototype, "errorDetails", {
        /**
         * In case of an unsuccessful recognition, provides details of the occurred error.
         * @member CancellationDetailsBase.prototype.errorDetails
         * @function
         * @public
         * @returns {string} A String that represents the error details.
         */ get: function() {
            return this.privErrorDetails;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CancellationDetailsBase.prototype, "ErrorCode", {
        /**
         * The error code in case of an unsuccessful recognition.
         * Added in version 1.1.0.
         * @return An error code that represents the error reason.
         */ get: function() {
            return this.privErrorCode;
        },
        enumerable: false,
        configurable: true
    });
    return CancellationDetailsBase;
}();
module.exports.CancellationDetailsBase = $4ca23689071bbfe2$var$CancellationDetailsBase;

});

parcelRequire.register("74VkW", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
var $52756200dc58d74b$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CancellationDetails = void 0;

var $dEkJU = parcelRequire("dEkJU");

var $6zUYZ = parcelRequire("6zUYZ");

var $hM4QX = parcelRequire("hM4QX");
/**
 * Contains detailed information about why a result was canceled.
 * @class CancellationDetails
 */ var $52756200dc58d74b$var$CancellationDetails = /** @class */ function(_super) {
    $52756200dc58d74b$var$__extends(CancellationDetails, _super);
    function CancellationDetails(reason, errorDetails, errorCode) {
        return _super.call(this, reason, errorDetails, errorCode) || this;
    }
    /**
     * Creates an instance of CancellationDetails object for the canceled RecognitionResult.
     * @member CancellationDetails.fromResult
     * @function
     * @public
     * @param {RecognitionResult | SpeechSynthesisResult} result - The result that was canceled.
     * @returns {CancellationDetails} The cancellation details object being created.
     */ CancellationDetails.fromResult = function(result) {
        var reason = $hM4QX.CancellationReason.Error;
        var errorCode = $hM4QX.CancellationErrorCode.NoError;
        if (result instanceof $hM4QX.RecognitionResult && !!result.json) {
            var simpleSpeech = $dEkJU.SimpleSpeechPhrase.fromJSON(result.json);
            reason = $dEkJU.EnumTranslation.implTranslateCancelResult(simpleSpeech.RecognitionStatus);
        }
        if (!!result.properties) errorCode = $hM4QX.CancellationErrorCode[result.properties.getProperty($dEkJU.CancellationErrorCodePropertyName, $hM4QX.CancellationErrorCode[$hM4QX.CancellationErrorCode.NoError])];
        return new CancellationDetails(reason, result.errorDetails || $dEkJU.EnumTranslation.implTranslateErrorDetails(errorCode), errorCode);
    };
    return CancellationDetails;
}($6zUYZ.CancellationDetailsBase);
module.exports.CancellationDetails = $52756200dc58d74b$var$CancellationDetails;

});

parcelRequire.register("tD9yJ", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CancellationErrorCode = void 0;
/**
 * Defines error code in case that CancellationReason is Error.
 * Added in version 1.1.0.
 */ var $0591148df37b9ca6$var$CancellationErrorCode;
(function(CancellationErrorCode) {
    /**
     * Indicates that no error occurred during speech recognition.
     */ CancellationErrorCode[CancellationErrorCode["NoError"] = 0] = "NoError";
    /**
     * Indicates an authentication error.
     */ CancellationErrorCode[CancellationErrorCode["AuthenticationFailure"] = 1] = "AuthenticationFailure";
    /**
     * Indicates that one or more recognition parameters are invalid.
     */ CancellationErrorCode[CancellationErrorCode["BadRequestParameters"] = 2] = "BadRequestParameters";
    /**
     * Indicates that the number of parallel requests exceeded the number of allowed
     * concurrent transcriptions for the subscription.
     */ CancellationErrorCode[CancellationErrorCode["TooManyRequests"] = 3] = "TooManyRequests";
    /**
     * Indicates a connection error.
     */ CancellationErrorCode[CancellationErrorCode["ConnectionFailure"] = 4] = "ConnectionFailure";
    /**
     * Indicates a time-out error when waiting for response from service.
     */ CancellationErrorCode[CancellationErrorCode["ServiceTimeout"] = 5] = "ServiceTimeout";
    /**
     * Indicates that an error is returned by the service.
     */ CancellationErrorCode[CancellationErrorCode["ServiceError"] = 6] = "ServiceError";
    /**
     * Indicates an unexpected runtime error.
     */ CancellationErrorCode[CancellationErrorCode["RuntimeError"] = 7] = "RuntimeError";
    /**
     * Indicates an quota overrun on existing key.
     */ CancellationErrorCode[CancellationErrorCode["Forbidden"] = 8] = "Forbidden";
})($0591148df37b9ca6$var$CancellationErrorCode = module.exports.CancellationErrorCode || (module.exports.CancellationErrorCode = {}));

});

parcelRequire.register("kjHv9", function(module, exports) {
"use strict";
//
// Copyright (c) Microsoft. All rights reserved.
// Licensed under the MIT license. See LICENSE.md file in the project root for full license information.
//
var $eca7537af086ff06$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ConnectionEventArgs = void 0;

var $hM4QX = parcelRequire("hM4QX");
/**
 * Defines payload for connection events like Connected/Disconnected.
 * Added in version 1.2.0
 */ var $eca7537af086ff06$var$ConnectionEventArgs = /** @class */ function(_super) {
    $eca7537af086ff06$var$__extends(ConnectionEventArgs, _super);
    function ConnectionEventArgs() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return ConnectionEventArgs;
}($hM4QX.SessionEventArgs);
module.exports.ConnectionEventArgs = $eca7537af086ff06$var$ConnectionEventArgs;

});

parcelRequire.register("cTeh8", function(module, exports) {
"use strict";
//
// Copyright (c) Microsoft. All rights reserved.
// Licensed under the MIT license. See LICENSE.md file in the project root for full license information.
//
var $9625b1e06f98ae0e$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ServiceEventArgs = void 0;

var $hM4QX = parcelRequire("hM4QX");
/**
 * Defines payload for any Service message event
 * Added in version 1.9.0
 */ var $9625b1e06f98ae0e$var$ServiceEventArgs = /** @class */ function(_super) {
    $9625b1e06f98ae0e$var$__extends(ServiceEventArgs, _super);
    /**
     * Creates and initializes an instance of this class.
     * @constructor
     * @param {string} json - json payload of the USP message.
     */ function ServiceEventArgs(json, name, sessionId) {
        var _this = _super.call(this, sessionId) || this;
        _this.privJsonResult = json;
        _this.privEventName = name;
        return _this;
    }
    Object.defineProperty(ServiceEventArgs.prototype, "jsonString", {
        get: function() {
            return this.privJsonResult;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ServiceEventArgs.prototype, "eventName", {
        get: function() {
            return this.privEventName;
        },
        enumerable: false,
        configurable: true
    });
    return ServiceEventArgs;
}($hM4QX.SessionEventArgs);
module.exports.ServiceEventArgs = $9625b1e06f98ae0e$var$ServiceEventArgs;

});

parcelRequire.register("6gTLx", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PhraseListGrammar = void 0;
/**
 * Allows additions of new phrases to improve speech recognition.
 *
 * Phrases added to the recognizer are effective at the start of the next recognition, or the next time the SpeechSDK must reconnect
 * to the speech service.
 */ var $490f7ea07dd1f00d$var$PhraseListGrammar = /** @class */ function() {
    function PhraseListGrammar(recogBase) {
        this.privGrammerBuilder = recogBase.dynamicGrammar;
    }
    /**
     * Creates a PhraseListGrammar from a given speech recognizer. Will accept any recognizer that derives from @class Recognizer.
     * @param recognizer The recognizer to add phrase lists to.
     */ PhraseListGrammar.fromRecognizer = function(recognizer) {
        var recoBase = recognizer.internalData;
        return new PhraseListGrammar(recoBase);
    };
    /**
     * Adds a single phrase to the current recognizer.
     * @param phrase Phrase to add.
     */ PhraseListGrammar.prototype.addPhrase = function(phrase) {
        this.privGrammerBuilder.addPhrase(phrase);
    };
    /**
     * Adds multiple phrases to the current recognizer.
     * @param phrases Array of phrases to add.
     */ PhraseListGrammar.prototype.addPhrases = function(phrases) {
        this.privGrammerBuilder.addPhrase(phrases);
    };
    /**
     * Clears all phrases added to the current recognizer.
     */ PhraseListGrammar.prototype.clear = function() {
        this.privGrammerBuilder.clearPhrases();
    };
    return PhraseListGrammar;
}();
module.exports.PhraseListGrammar = $490f7ea07dd1f00d$var$PhraseListGrammar;

});

parcelRequire.register("7mmFy", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
var $55bc2c1e1328272a$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DialogServiceConfigImpl = module.exports.DialogServiceConfig = void 0;

var $gBGZx = parcelRequire("gBGZx");

var $hM4QX = parcelRequire("hM4QX");
/**
 * Class that defines base configurations for dialog service connector
 * @class DialogServiceConfig
 */ var $55bc2c1e1328272a$var$DialogServiceConfig = /** @class */ function() {
    /**
     * Creates an instance of DialogService config.
     * @constructor
     */ function DialogServiceConfig() {
        return;
    }
    Object.defineProperty(DialogServiceConfig.prototype, "applicationId", {
        /**
         * Sets the corresponding backend application identifier.
         * @member DialogServiceConfig.prototype.Conversation_ApplicationId
         * @function
         * @public
         * @param {string} value - The application identifier to set.
         */ // eslint-disable-next-line @typescript-eslint/no-empty-function
        set: function(value) {},
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DialogServiceConfig, "DialogTypes", {
        get: function() {
            return {
                BotFramework: "bot_framework",
                CustomCommands: "custom_commands"
            };
        },
        enumerable: false,
        configurable: true
    });
    return DialogServiceConfig;
}();
module.exports.DialogServiceConfig = $55bc2c1e1328272a$var$DialogServiceConfig;
/**
 * Dialog Service configuration.
 * @class DialogServiceConfigImpl
 */ var $55bc2c1e1328272a$var$DialogServiceConfigImpl = /** @class */ function(_super) {
    $55bc2c1e1328272a$var$__extends(DialogServiceConfigImpl, _super);
    /**
     * Creates an instance of dialogService config.
     */ function DialogServiceConfigImpl() {
        var _this = _super.call(this) || this;
        _this.privSpeechConfig = new $hM4QX.SpeechConfigImpl();
        return _this;
    }
    Object.defineProperty(DialogServiceConfigImpl.prototype, "properties", {
        /**
         * Provides access to custom properties.
         * @member DialogServiceConfigImpl.prototype.properties
         * @function
         * @public
         * @returns {PropertyCollection} The properties.
         */ get: function() {
            return this.privSpeechConfig.properties;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DialogServiceConfigImpl.prototype, "speechRecognitionLanguage", {
        /**
         * Gets the speech recognition language.
         * @member DialogServiceConfigImpl.prototype.speechRecognitionLanguage
         * @function
         * @public
         */ get: function() {
            return this.privSpeechConfig.speechRecognitionLanguage;
        },
        /**
         * Sets the speech recognition language.
         * @member DialogServiceConfigImpl.prototype.speechRecognitionLanguage
         * @function
         * @public
         * @param {string} value - The language to set.
         */ set: function(value) {
            $gBGZx.Contracts.throwIfNullOrWhitespace(value, "value");
            this.privSpeechConfig.speechRecognitionLanguage = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DialogServiceConfigImpl.prototype, "outputFormat", {
        get: function() {
            return this.privSpeechConfig.outputFormat;
        },
        set: function(value) {
            this.privSpeechConfig.outputFormat = value;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Sets a named property as value
     * @member DialogServiceConfigImpl.prototype.setProperty
     * @function
     * @public
     * @param {PropertyId | string} name - The property to set.
     * @param {string} value - The value.
     */ DialogServiceConfigImpl.prototype.setProperty = function(name, value) {
        this.privSpeechConfig.setProperty(name, value);
    };
    /**
     * Sets a named property as value
     * @member DialogServiceConfigImpl.prototype.getProperty
     * @function
     * @public
     * @param {PropertyId | string} name - The property to get.
     * @param {string} def - The default value to return in case the property is not known.
     * @returns {string} The current value, or provided default, of the given property.
     */ DialogServiceConfigImpl.prototype.getProperty = function(name, def) {
        return this.privSpeechConfig.getProperty(name);
    };
    /**
     * Sets the proxy configuration.
     * Only relevant in Node.js environments.
     * Added in version 1.4.0.
     * @param proxyHostName The host name of the proxy server, without the protocol scheme (http://)
     * @param proxyPort The port number of the proxy server.
     * @param proxyUserName The user name of the proxy server.
     * @param proxyPassword The password of the proxy server.
     */ DialogServiceConfigImpl.prototype.setProxy = function(proxyHostName, proxyPort, proxyUserName, proxyPassword) {
        this.setProperty($hM4QX.PropertyId.SpeechServiceConnection_ProxyHostName, proxyHostName);
        this.setProperty($hM4QX.PropertyId.SpeechServiceConnection_ProxyPort, "" + proxyPort);
        if (proxyUserName) this.setProperty($hM4QX.PropertyId.SpeechServiceConnection_ProxyUserName, proxyUserName);
        if (proxyPassword) this.setProperty($hM4QX.PropertyId.SpeechServiceConnection_ProxyPassword, proxyPassword);
    };
    DialogServiceConfigImpl.prototype.setServiceProperty = function(name, value, channel) {
        this.privSpeechConfig.setServiceProperty(name, value);
    };
    /**
     * Dispose of associated resources.
     * @member DialogServiceConfigImpl.prototype.close
     * @function
     * @public
     */ DialogServiceConfigImpl.prototype.close = function() {
        return;
    };
    return DialogServiceConfigImpl;
}($55bc2c1e1328272a$var$DialogServiceConfig);
module.exports.DialogServiceConfigImpl = $55bc2c1e1328272a$var$DialogServiceConfigImpl;

});

parcelRequire.register("48y7u", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
var $303260402a6a94d8$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.BotFrameworkConfig = void 0;

var $gBGZx = parcelRequire("gBGZx");

var $7mmFy = parcelRequire("7mmFy");

var $hM4QX = parcelRequire("hM4QX");
/**
 * Class that defines configurations for the dialog service connector object for using a Bot Framework backend.
 * @class BotFrameworkConfig
 */ var $303260402a6a94d8$var$BotFrameworkConfig = /** @class */ function(_super) {
    $303260402a6a94d8$var$__extends(BotFrameworkConfig, _super);
    /**
     * Creates an instance of BotFrameworkConfig.
     */ function BotFrameworkConfig() {
        return _super.call(this) || this;
    }
    /**
     * Creates a bot framework configuration instance with the provided subscription information.
     * @member BotFrameworkConfig.fromSubscription
     * @function
     * @public
     * @param subscription Subscription key associated with the bot
     * @param region The region name (see the <a href="https://aka.ms/csspeech/region">region page</a>).
     * @param botId Optional. Identifier for using a specific bot within an Azure resource group. Equivalent to the
     * resource name.
     * @returns {BotFrameworkConfig} A new bot framework configuration instance.
     */ BotFrameworkConfig.fromSubscription = function(subscription, region, botId) {
        $gBGZx.Contracts.throwIfNullOrWhitespace(subscription, "subscription");
        $gBGZx.Contracts.throwIfNullOrWhitespace(region, "region");
        var botFrameworkConfig = new $7mmFy.DialogServiceConfigImpl();
        botFrameworkConfig.setProperty($hM4QX.PropertyId.Conversation_DialogType, $7mmFy.DialogServiceConfig.DialogTypes.BotFramework);
        botFrameworkConfig.setProperty($hM4QX.PropertyId.SpeechServiceConnection_Key, subscription);
        botFrameworkConfig.setProperty($hM4QX.PropertyId.SpeechServiceConnection_Region, region);
        if (botId) botFrameworkConfig.setProperty($hM4QX.PropertyId.Conversation_ApplicationId, botId);
        return botFrameworkConfig;
    };
    /**
     * Creates a bot framework configuration instance for the specified authorization token and region.
     * Note: The caller must ensure that an authorization token is valid. Before an authorization token expires, the
     * caller must refresh it by setting the authorizationToken property on the corresponding
     * DialogServiceConnector instance created with this config. The contents of configuration objects are copied
     * when connectors are created, so setting authorizationToken on a DialogServiceConnector will not update the
     * original configuration's authorization token. Create a new configuration instance or set the
     * SpeechServiceAuthorization_Token property to update an existing instance if it will be used to create
     * further DialogServiceConnectors.
     * @member BotFrameworkConfig.fromAuthorizationToken
     * @function
     * @public
     * @param authorizationToken The authorization token associated with the bot
     * @param region The region name (see the <a href="https://aka.ms/csspeech/region">region page</a>).
     * @param botId Optional. Identifier for using a specific bot within an Azure resource group. Equivalent to the
     * resource name.
     * @returns {BotFrameworkConfig} A new bot framework configuration instance.
     */ BotFrameworkConfig.fromAuthorizationToken = function(authorizationToken, region, botId) {
        $gBGZx.Contracts.throwIfNullOrWhitespace(authorizationToken, "authorizationToken");
        $gBGZx.Contracts.throwIfNullOrWhitespace(region, "region");
        var botFrameworkConfig = new $7mmFy.DialogServiceConfigImpl();
        botFrameworkConfig.setProperty($hM4QX.PropertyId.Conversation_DialogType, $7mmFy.DialogServiceConfig.DialogTypes.BotFramework);
        botFrameworkConfig.setProperty($hM4QX.PropertyId.SpeechServiceAuthorization_Token, authorizationToken);
        botFrameworkConfig.setProperty($hM4QX.PropertyId.SpeechServiceConnection_Region, region);
        if (botId) botFrameworkConfig.setProperty($hM4QX.PropertyId.Conversation_ApplicationId, botId);
        return botFrameworkConfig;
    };
    /**
     * Creates an instance of a BotFrameworkConfig.
     * This method is intended only for users who use a non-default service host. The standard resource path will be
     * assumed. For services with a non-standard resource path or no path at all, use fromEndpoint instead.
     * Note: Query parameters are not allowed in the host URI and must be set by other APIs.
     * Note: To use an authorization token with fromHost, use fromHost(URL) and then set the AuthorizationToken
     * property on the created BotFrameworkConfig instance.
     * Note: Added in version 1.15.0.
     * @member BotFrameworkConfig.fromHost
     * @function
     * @public
     * @param {URL | string} host - If a URL is provided, the fully-qualified host with protocol (e.g.
     * wss://your.host.com:1234) will be used. If a string is provided, it will be embedded in
     * wss://{host}.convai.speech.azure.us.
     * @param {string} subscriptionKey - The subscription key. If a subscription key is not specified, an authorization
     * token must be set.
     * @param botId Optional. Identifier for using a specific bot within an Azure resource group. Equivalent to the
     * resource name.
     * @returns {BotFrameworkConfig} A new bot framework configuration instance.
     */ BotFrameworkConfig.fromHost = function(host, subscriptionKey, botId) {
        $gBGZx.Contracts.throwIfNullOrUndefined(host, "host");
        var resolvedHost = host instanceof URL ? host : new URL("wss://" + host + ".convai.speech.azure.us");
        $gBGZx.Contracts.throwIfNullOrUndefined(resolvedHost, "resolvedHost");
        var botFrameworkConfig = new $7mmFy.DialogServiceConfigImpl();
        botFrameworkConfig.setProperty($hM4QX.PropertyId.Conversation_DialogType, $7mmFy.DialogServiceConfig.DialogTypes.BotFramework);
        botFrameworkConfig.setProperty($hM4QX.PropertyId.SpeechServiceConnection_Host, resolvedHost.toString());
        if (undefined !== subscriptionKey) botFrameworkConfig.setProperty($hM4QX.PropertyId.SpeechServiceConnection_Key, subscriptionKey);
        return botFrameworkConfig;
    };
    /**
     * Creates an instance of a BotFrameworkConfig.
     * This method is intended only for users who use a non-standard service endpoint or parameters.
     * Note: The query parameters specified in the endpoint URL are not changed, even if they are set by any other APIs.
     * Note: To use authorization token with fromEndpoint, pass an empty string to the subscriptionKey in the
     * fromEndpoint method, and then set authorizationToken="token" on the created BotFrameworkConfig instance to
     * use the authorization token.
     * Note: Added in version 1.15.0.
     * @member BotFrameworkConfig.fromEndpoint
     * @function
     * @public
     * @param {URL} endpoint - The service endpoint to connect to.
     * @param {string} subscriptionKey - The subscription key. If a subscription key is not specified, an authorization
     * token must be set.
     * @returns {BotFrameworkConfig} - A new bot framework configuration instance using the provided endpoint.
     */ BotFrameworkConfig.fromEndpoint = function(endpoint, subscriptionKey) {
        $gBGZx.Contracts.throwIfNull(endpoint, "endpoint");
        var botFrameworkConfig = new $7mmFy.DialogServiceConfigImpl();
        botFrameworkConfig.setProperty($hM4QX.PropertyId.Conversation_DialogType, $7mmFy.DialogServiceConfig.DialogTypes.BotFramework);
        botFrameworkConfig.setProperty($hM4QX.PropertyId.SpeechServiceConnection_Endpoint, endpoint.toString());
        if (undefined !== subscriptionKey) botFrameworkConfig.setProperty($hM4QX.PropertyId.SpeechServiceConnection_Key, subscriptionKey);
        return botFrameworkConfig;
    };
    return BotFrameworkConfig;
}($7mmFy.DialogServiceConfigImpl);
module.exports.BotFrameworkConfig = $303260402a6a94d8$var$BotFrameworkConfig;

});

parcelRequire.register("5X2ZB", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
var $4554c8b295c2c72c$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CustomCommandsConfig = void 0;

var $gBGZx = parcelRequire("gBGZx");

var $7mmFy = parcelRequire("7mmFy");

var $hM4QX = parcelRequire("hM4QX");
/**
 * Class that defines configurations for the dialog service connector object for using a CustomCommands backend.
 * @class CustomCommandsConfig
 */ var $4554c8b295c2c72c$var$CustomCommandsConfig = /** @class */ function(_super) {
    $4554c8b295c2c72c$var$__extends(CustomCommandsConfig, _super);
    /**
     * Creates an instance of CustomCommandsConfig.
     */ function CustomCommandsConfig() {
        return _super.call(this) || this;
    }
    /**
     * Creates an instance of the bot framework config with the specified subscription and region.
     * @member CustomCommandsConfig.fromSubscription
     * @function
     * @public
     * @param applicationId Speech Commands application id.
     * @param subscription Subscription key associated with the bot
     * @param region The region name (see the <a href="https://aka.ms/csspeech/region">region page</a>).
     * @returns {CustomCommandsConfig} A new bot framework config.
     */ CustomCommandsConfig.fromSubscription = function(applicationId, subscription, region) {
        $gBGZx.Contracts.throwIfNullOrWhitespace(applicationId, "applicationId");
        $gBGZx.Contracts.throwIfNullOrWhitespace(subscription, "subscription");
        $gBGZx.Contracts.throwIfNullOrWhitespace(region, "region");
        var customCommandsConfig = new $7mmFy.DialogServiceConfigImpl();
        customCommandsConfig.setProperty($hM4QX.PropertyId.Conversation_DialogType, $7mmFy.DialogServiceConfig.DialogTypes.CustomCommands);
        customCommandsConfig.setProperty($hM4QX.PropertyId.Conversation_ApplicationId, applicationId);
        customCommandsConfig.setProperty($hM4QX.PropertyId.SpeechServiceConnection_Key, subscription);
        customCommandsConfig.setProperty($hM4QX.PropertyId.SpeechServiceConnection_Region, region);
        return customCommandsConfig;
    };
    /**
     * Creates an instance of the bot framework config with the specified Speech Commands application id, authorization token and region.
     * Note: The caller needs to ensure that the authorization token is valid. Before the authorization token
     * expires, the caller needs to refresh it by calling this setter with a new valid token.
     * As configuration values are copied when creating a new recognizer, the new token value will not apply to recognizers that have already been created.
     * For recognizers that have been created before, you need to set authorization token of the corresponding recognizer
     * to refresh the token. Otherwise, the recognizers will encounter errors during recognition.
     * @member CustomCommandsConfig.fromAuthorizationToken
     * @function
     * @public
     * @param applicationId Speech Commands application id.
     * @param authorizationToken The authorization token associated with the application.
     * @param region The region name (see the <a href="https://aka.ms/csspeech/region">region page</a>).
     * @returns {CustomCommandsConfig} A new speech commands config.
     */ CustomCommandsConfig.fromAuthorizationToken = function(applicationId, authorizationToken, region) {
        $gBGZx.Contracts.throwIfNullOrWhitespace(applicationId, "applicationId");
        $gBGZx.Contracts.throwIfNullOrWhitespace(authorizationToken, "authorizationToken");
        $gBGZx.Contracts.throwIfNullOrWhitespace(region, "region");
        var customCommandsConfig = new $7mmFy.DialogServiceConfigImpl();
        customCommandsConfig.setProperty($hM4QX.PropertyId.Conversation_DialogType, $7mmFy.DialogServiceConfig.DialogTypes.CustomCommands);
        customCommandsConfig.setProperty($hM4QX.PropertyId.Conversation_ApplicationId, applicationId);
        customCommandsConfig.setProperty($hM4QX.PropertyId.SpeechServiceAuthorization_Token, authorizationToken);
        customCommandsConfig.setProperty($hM4QX.PropertyId.SpeechServiceConnection_Region, region);
        return customCommandsConfig;
    };
    Object.defineProperty(CustomCommandsConfig.prototype, "applicationId", {
        /**
         * Gets the corresponding backend application identifier.
         * @member CustomCommandsConfig.prototype.Conversation_ApplicationId
         * @function
         * @public
         * @param {string} value - The application identifier to get.
         */ get: function() {
            return this.getProperty($hM4QX.PropertyId.Conversation_ApplicationId);
        },
        /**
         * Sets the corresponding backend application identifier.
         * @member CustomCommandsConfig.prototype.Conversation_ApplicationId
         * @function
         * @public
         * @param {string} value - The application identifier to set.
         */ set: function(value) {
            $gBGZx.Contracts.throwIfNullOrWhitespace(value, "value");
            this.setProperty($hM4QX.PropertyId.Conversation_ApplicationId, value);
        },
        enumerable: false,
        configurable: true
    });
    return CustomCommandsConfig;
}($7mmFy.DialogServiceConfigImpl);
module.exports.CustomCommandsConfig = $4554c8b295c2c72c$var$CustomCommandsConfig;

});

parcelRequire.register("2Jdvk", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
var $1fca4268a6204cfb$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $1fca4268a6204cfb$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $1fca4268a6204cfb$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DialogServiceConnector = void 0;

var $4f4pe = parcelRequire("4f4pe");

var $dEkJU = parcelRequire("dEkJU");

var $em8BD = parcelRequire("em8BD");

var $gBGZx = parcelRequire("gBGZx");

var $hM4QX = parcelRequire("hM4QX");

var $8TH7f = parcelRequire("8TH7f");
/**
 * Dialog Service Connector
 * @class DialogServiceConnector
 */ var $1fca4268a6204cfb$var$DialogServiceConnector = /** @class */ function(_super) {
    $1fca4268a6204cfb$var$__extends(DialogServiceConnector, _super);
    /**
     * Initializes an instance of the DialogServiceConnector.
     * @constructor
     * @param {DialogServiceConfig} dialogConfig - Set of properties to configure this recognizer.
     * @param {AudioConfig} audioConfig - An optional audio config associated with the recognizer
     */ function DialogServiceConnector(dialogConfig, audioConfig) {
        var _this = this;
        var dialogServiceConfigImpl = dialogConfig;
        $gBGZx.Contracts.throwIfNull(dialogConfig, "dialogConfig");
        _this = _super.call(this, audioConfig, dialogServiceConfigImpl.properties, new $4f4pe.DialogConnectionFactory()) || this;
        _this.isTurnComplete = true;
        _this.privIsDisposed = false;
        _this.privProperties = dialogServiceConfigImpl.properties.clone();
        var agentConfig = _this.buildAgentConfig();
        _this.privReco.agentConfig.set(agentConfig);
        return _this;
    }
    /**
     * Starts a connection to the service.
     * Users can optionally call connect() to manually set up a connection in advance, before starting interactions.
     *
     * Note: On return, the connection might not be ready yet. Please subscribe to the Connected event to
     * be notified when the connection is established.
     * @member DialogServiceConnector.prototype.connect
     * @function
     * @public
     */ DialogServiceConnector.prototype.connect = function(cb, err) {
        $em8BD.marshalPromiseToCallbacks(this.privReco.connect(), cb, err);
    };
    /**
     * Closes the connection the service.
     * Users can optionally call disconnect() to manually shutdown the connection of the associated DialogServiceConnector.
     *
     * If disconnect() is called during a recognition, recognition will fail and cancel with an error.
     */ DialogServiceConnector.prototype.disconnect = function(cb, err) {
        $em8BD.marshalPromiseToCallbacks(this.privReco.disconnect(), cb, err);
    };
    Object.defineProperty(DialogServiceConnector.prototype, "authorizationToken", {
        /**
         * Gets the authorization token used to communicate with the service.
         * @member DialogServiceConnector.prototype.authorizationToken
         * @function
         * @public
         * @returns {string} Authorization token.
         */ get: function() {
            return this.properties.getProperty($8TH7f.PropertyId.SpeechServiceAuthorization_Token);
        },
        /**
         * Sets the authorization token used to communicate with the service.
         * @member DialogServiceConnector.prototype.authorizationToken
         * @function
         * @public
         * @param {string} token - Authorization token.
         */ set: function(token) {
            $gBGZx.Contracts.throwIfNullOrWhitespace(token, "token");
            this.properties.setProperty($8TH7f.PropertyId.SpeechServiceAuthorization_Token, token);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DialogServiceConnector.prototype, "properties", {
        /**
         * The collection of properties and their values defined for this DialogServiceConnector.
         * @member DialogServiceConnector.prototype.properties
         * @function
         * @public
         * @returns {PropertyCollection} The collection of properties and their values defined for this DialogServiceConnector.
         */ get: function() {
            return this.privProperties;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DialogServiceConnector.prototype, "speechActivityTemplate", {
        /** Gets the template for the activity generated by service from speech.
         * Properties from the template will be stamped on the generated activity.
         * It can be empty
         */ get: function() {
            return this.properties.getProperty($8TH7f.PropertyId.Conversation_Speech_Activity_Template);
        },
        /** Sets the template for the activity generated by service from speech.
         * Properties from the template will be stamped on the generated activity.
         * It can be null or empty.
         * Note: it has to be a valid Json object.
         */ set: function(speechActivityTemplate) {
            this.properties.setProperty($8TH7f.PropertyId.Conversation_Speech_Activity_Template, speechActivityTemplate);
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Starts recognition and stops after the first utterance is recognized.
     * @member DialogServiceConnector.prototype.listenOnceAsync
     * @function
     * @public
     * @param cb - Callback that received the result when the reco has completed.
     * @param err - Callback invoked in case of an error.
     */ DialogServiceConnector.prototype.listenOnceAsync = function(cb, err) {
        var _this = this;
        if (this.isTurnComplete) {
            $gBGZx.Contracts.throwIfDisposed(this.privIsDisposed);
            var callbackHolder = function() {
                return $1fca4268a6204cfb$var$__awaiter(_this, void 0, void 0, function() {
                    var ret, e;
                    return $1fca4268a6204cfb$var$__generator(this, function(_a) {
                        switch(_a.label){
                            case 0:
                                return [
                                    4 /*yield*/ ,
                                    this.privReco.connect()
                                ];
                            case 1:
                                _a.sent();
                                return [
                                    4 /*yield*/ ,
                                    this.implRecognizerStop()
                                ];
                            case 2:
                                _a.sent();
                                this.isTurnComplete = false;
                                ret = new $em8BD.Deferred();
                                return [
                                    4 /*yield*/ ,
                                    this.privReco.recognize($dEkJU.RecognitionMode.Conversation, ret.resolve, ret.reject)
                                ];
                            case 3:
                                _a.sent();
                                return [
                                    4 /*yield*/ ,
                                    ret.promise
                                ];
                            case 4:
                                e = _a.sent();
                                return [
                                    4 /*yield*/ ,
                                    this.implRecognizerStop()
                                ];
                            case 5:
                                _a.sent();
                                return [
                                    2 /*return*/ ,
                                    e
                                ];
                        }
                    });
                });
            };
            var retPromise = callbackHolder();
            retPromise.catch(function() {
                // Destroy the recognizer.
                // We've done all we can here.
                // eslint-disable-next-line @typescript-eslint/no-empty-function
                _this.dispose(true).catch(function() {});
            });
            $em8BD.marshalPromiseToCallbacks(retPromise.finally(function() {
                _this.isTurnComplete = true;
            }), cb, err);
        }
    };
    DialogServiceConnector.prototype.sendActivityAsync = function(activity, cb, errCb) {
        $em8BD.marshalPromiseToCallbacks(this.privReco.sendMessage(activity), cb, errCb);
    };
    /**
     * closes all external resources held by an instance of this class.
     * @member DialogServiceConnector.prototype.close
     * @function
     * @public
     */ DialogServiceConnector.prototype.close = function(cb, err) {
        $gBGZx.Contracts.throwIfDisposed(this.privIsDisposed);
        $em8BD.marshalPromiseToCallbacks(this.dispose(true), cb, err);
    };
    DialogServiceConnector.prototype.dispose = function(disposing) {
        return $1fca4268a6204cfb$var$__awaiter(this, void 0, void 0, function() {
            return $1fca4268a6204cfb$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (this.privIsDisposed) return [
                            2 /*return*/ 
                        ];
                        if (!disposing) return [
                            3 /*break*/ ,
                            3
                        ];
                        this.privIsDisposed = true;
                        return [
                            4 /*yield*/ ,
                            this.implRecognizerStop()
                        ];
                    case 1:
                        _a.sent();
                        return [
                            4 /*yield*/ ,
                            _super.prototype.dispose.call(this, disposing)
                        ];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    DialogServiceConnector.prototype.createRecognizerConfig = function(speechConfig) {
        return new $dEkJU.RecognizerConfig(speechConfig, this.privProperties);
    };
    DialogServiceConnector.prototype.createServiceRecognizer = function(authentication, connectionFactory, audioConfig, recognizerConfig) {
        var audioSource = audioConfig;
        return new $dEkJU.DialogServiceAdapter(authentication, connectionFactory, audioSource, recognizerConfig, this);
    };
    DialogServiceConnector.prototype.buildAgentConfig = function() {
        var communicationType = this.properties.getProperty("Conversation_Communication_Type", "Default");
        return {
            botInfo: {
                commType: communicationType,
                commandsCulture: undefined,
                connectionId: this.properties.getProperty($8TH7f.PropertyId.Conversation_Agent_Connection_Id),
                conversationId: this.properties.getProperty($8TH7f.PropertyId.Conversation_Conversation_Id, undefined),
                fromId: this.properties.getProperty($8TH7f.PropertyId.Conversation_From_Id, undefined),
                ttsAudioFormat: this.properties.getProperty($8TH7f.PropertyId.SpeechServiceConnection_SynthOutputFormat, undefined)
            },
            version: 0.2
        };
    };
    return DialogServiceConnector;
}($hM4QX.Recognizer);
module.exports.DialogServiceConnector = $1fca4268a6204cfb$var$DialogServiceConnector;

});
parcelRequire.register("4f4pe", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
var $316bfb16dba0db6e$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DialogConnectionFactory = void 0;

var $j1V0D = parcelRequire("j1V0D");

var $dEkJU = parcelRequire("dEkJU");

var $hM4QX = parcelRequire("hM4QX");

var $hGMva = parcelRequire("hGMva");

var $dEkJU = parcelRequire("dEkJU");

var $btbfh = parcelRequire("btbfh");

var $QhYc2 = parcelRequire("QhYc2");
var $316bfb16dba0db6e$var$DialogConnectionFactory = /** @class */ function(_super) {
    $316bfb16dba0db6e$var$__extends(DialogConnectionFactory, _super);
    function DialogConnectionFactory() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DialogConnectionFactory.prototype.create = function(config, authInfo, connectionId) {
        var applicationId = config.parameters.getProperty($hM4QX.PropertyId.Conversation_ApplicationId, "");
        var dialogType = config.parameters.getProperty($hM4QX.PropertyId.Conversation_DialogType);
        var region = config.parameters.getProperty($hM4QX.PropertyId.SpeechServiceConnection_Region);
        var language = config.parameters.getProperty($hM4QX.PropertyId.SpeechServiceConnection_RecoLanguage, "en-US");
        var requestTurnStatus = config.parameters.getProperty($hM4QX.PropertyId.Conversation_Request_Bot_Status_Messages, "true");
        var queryParams = {};
        queryParams[$btbfh.HeaderNames.ConnectionId] = connectionId;
        queryParams[$QhYc2.QueryParameterNames.Format] = config.parameters.getProperty($dEkJU.OutputFormatPropertyName, $hM4QX.OutputFormat[$hM4QX.OutputFormat.Simple]).toLowerCase();
        queryParams[$QhYc2.QueryParameterNames.Language] = language;
        queryParams[$QhYc2.QueryParameterNames.RequestBotStatusMessages] = requestTurnStatus;
        if (applicationId) {
            queryParams[$QhYc2.QueryParameterNames.BotId] = applicationId;
            if (dialogType === $hM4QX.DialogServiceConfig.DialogTypes.CustomCommands) queryParams[$btbfh.HeaderNames.CustomCommandsAppId] = applicationId;
        }
        var resourceInfix = dialogType === $hM4QX.DialogServiceConfig.DialogTypes.CustomCommands ? "commands/" : "";
        var version = dialogType === $hM4QX.DialogServiceConfig.DialogTypes.CustomCommands ? "v1" : dialogType === $hM4QX.DialogServiceConfig.DialogTypes.BotFramework ? "v3" : "v0";
        var headers = {};
        if (authInfo.token != null && authInfo.token !== "") headers[authInfo.headerName] = authInfo.token;
        // The URL used for connection is chosen in a priority order of specification:
        //  1. If a custom endpoint is provided, that URL is used verbatim.
        //  2. If a custom host is provided (e.g. "wss://my.custom.endpoint.com:1123"), a URL is constructed from it.
        //  3. If no custom connection details are provided, a URL is constructed from default values.
        var endpoint = config.parameters.getProperty($hM4QX.PropertyId.SpeechServiceConnection_Endpoint, "");
        if (!endpoint) {
            var hostSuffix = $hGMva.ConnectionFactoryBase.getHostSuffix(region);
            var host = config.parameters.getProperty($hM4QX.PropertyId.SpeechServiceConnection_Host, "wss://" + region + "." + DialogConnectionFactory.BaseUrl + hostSuffix);
            var standardizedHost = host.endsWith("/") ? host : host + "/";
            endpoint = "" + standardizedHost + resourceInfix + DialogConnectionFactory.ApiKey + "/" + version;
        }
        this.setCommonUrlParams(config, queryParams, endpoint);
        var enableCompression = config.parameters.getProperty("SPEECH-EnableWebsocketCompression", "false") === "true";
        return new $j1V0D.WebsocketConnection(endpoint, queryParams, headers, new $dEkJU.WebsocketMessageFormatter(), $j1V0D.ProxyInfo.fromRecognizerConfig(config), enableCompression, connectionId);
    };
    DialogConnectionFactory.ApiKey = "api";
    DialogConnectionFactory.BaseUrl = "convai.speech";
    return DialogConnectionFactory;
}($hGMva.ConnectionFactoryBase);
module.exports.DialogConnectionFactory = $316bfb16dba0db6e$var$DialogConnectionFactory;

});
parcelRequire.register("hGMva", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ConnectionFactoryBase = void 0;

var $dEkJU = parcelRequire("dEkJU");

var $hM4QX = parcelRequire("hM4QX");

var $QhYc2 = parcelRequire("QhYc2");
var $ce0bfb5cd0909910$var$ConnectionFactoryBase = /** @class */ function() {
    function ConnectionFactoryBase() {}
    ConnectionFactoryBase.getHostSuffix = function(region) {
        if (!!region) {
            if (region.toLowerCase().startsWith("china")) return ".azure.cn";
            if (region.toLowerCase().startsWith("usgov")) return ".azure.us";
        }
        return ".microsoft.com";
    };
    ConnectionFactoryBase.prototype.setCommonUrlParams = function(config, queryParams, endpoint) {
        var _this = this;
        var propertyIdToParameterMap = new Map([
            [
                $hM4QX.PropertyId.Speech_SegmentationSilenceTimeoutMs,
                $QhYc2.QueryParameterNames.SegmentationSilenceTimeoutMs
            ],
            [
                $hM4QX.PropertyId.SpeechServiceConnection_EnableAudioLogging,
                $QhYc2.QueryParameterNames.EnableAudioLogging
            ],
            [
                $hM4QX.PropertyId.SpeechServiceConnection_EndSilenceTimeoutMs,
                $QhYc2.QueryParameterNames.EndSilenceTimeoutMs
            ],
            [
                $hM4QX.PropertyId.SpeechServiceConnection_InitialSilenceTimeoutMs,
                $QhYc2.QueryParameterNames.InitialSilenceTimeoutMs
            ],
            [
                $hM4QX.PropertyId.SpeechServiceResponse_PostProcessingOption,
                $QhYc2.QueryParameterNames.Postprocessing
            ],
            [
                $hM4QX.PropertyId.SpeechServiceResponse_ProfanityOption,
                $QhYc2.QueryParameterNames.Profanity
            ],
            [
                $hM4QX.PropertyId.SpeechServiceResponse_RequestWordLevelTimestamps,
                $QhYc2.QueryParameterNames.EnableWordLevelTimestamps
            ],
            [
                $hM4QX.PropertyId.SpeechServiceResponse_StablePartialResultThreshold,
                $QhYc2.QueryParameterNames.StableIntermediateThreshold
            ]
        ]);
        propertyIdToParameterMap.forEach(function(parameterName, propertyId) {
            _this.setUrlParameter(propertyId, parameterName, config, queryParams, endpoint);
        });
        var serviceProperties = JSON.parse(config.parameters.getProperty($dEkJU.ServicePropertiesPropertyName, "{}"));
        Object.keys(serviceProperties).forEach(function(value) {
            queryParams[value] = serviceProperties[value];
        });
    };
    ConnectionFactoryBase.prototype.setUrlParameter = function(propId, parameterName, config, queryParams, endpoint) {
        var value = config.parameters.getProperty(propId, undefined);
        // FIXME: The .search() check will incorrectly match parameter name anywhere in the string
        //        including e.g. the path portion, or even as a substring of other query parameters
        if (value && (!endpoint || endpoint.search(parameterName) === -1)) queryParams[parameterName] = value.toLocaleLowerCase();
    };
    return ConnectionFactoryBase;
}();
module.exports.ConnectionFactoryBase = $ce0bfb5cd0909910$var$ConnectionFactoryBase;

});
parcelRequire.register("QhYc2", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.QueryParameterNames = void 0;
var $09d2cbe216214860$var$QueryParameterNames = /** @class */ function() {
    function QueryParameterNames() {}
    QueryParameterNames.BotId = "botid";
    QueryParameterNames.CustomSpeechDeploymentId = "cid";
    QueryParameterNames.CustomVoiceDeploymentId = "deploymentId";
    QueryParameterNames.EnableAudioLogging = "storeAudio";
    QueryParameterNames.EnableLanguageId = "lidEnabled";
    QueryParameterNames.EnableWordLevelTimestamps = "wordLevelTimestamps";
    QueryParameterNames.EndSilenceTimeoutMs = "endSilenceTimeoutMs";
    QueryParameterNames.SegmentationSilenceTimeoutMs = "segmentationSilenceTimeoutMs";
    QueryParameterNames.Format = "format";
    QueryParameterNames.InitialSilenceTimeoutMs = "initialSilenceTimeoutMs";
    QueryParameterNames.Language = "language";
    QueryParameterNames.Profanity = "profanity";
    QueryParameterNames.RequestBotStatusMessages = "enableBotMessageStatus";
    QueryParameterNames.StableIntermediateThreshold = "stableIntermediateThreshold";
    QueryParameterNames.StableTranslation = "stableTranslation";
    QueryParameterNames.TestHooks = "testhooks";
    QueryParameterNames.Postprocessing = "postprocessing";
    QueryParameterNames.CtsMeetingId = "meetingId";
    QueryParameterNames.CtsDeviceId = "deviceId";
    QueryParameterNames.CtsIsParticipant = "isParticipant";
    return QueryParameterNames;
}();
module.exports.QueryParameterNames = $09d2cbe216214860$var$QueryParameterNames;

});




parcelRequire.register("9gBpC", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActivityReceivedEventArgs = void 0;
/**
 * Defines contents of received message/events.
 * @class ActivityReceivedEventArgs
 */ var $6bf2a0f1479584f3$var$ActivityReceivedEventArgs = /** @class */ function() {
    /**
     * Creates and initializes an instance of this class.
     * @constructor
     * @param {any} activity - The activity..
     */ function ActivityReceivedEventArgs(activity, audioStream) {
        this.privActivity = activity;
        this.privAudioStream = audioStream;
    }
    Object.defineProperty(ActivityReceivedEventArgs.prototype, "activity", {
        /**
         * Gets the received activity
         * @member ActivityReceivedEventArgs.prototype.activity
         * @function
         * @public
         * @returns {any} the received activity.
         */ get: function() {
            return this.privActivity;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ActivityReceivedEventArgs.prototype, "audioStream", {
        get: function() {
            return this.privAudioStream;
        },
        enumerable: false,
        configurable: true
    });
    return ActivityReceivedEventArgs;
}();
module.exports.ActivityReceivedEventArgs = $6bf2a0f1479584f3$var$ActivityReceivedEventArgs;

});

parcelRequire.register("bZGg5", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TurnStatusReceivedEventArgs = void 0;

var $df4iv = parcelRequire("df4iv");
/**
 * Defines contents of received message/events.
 * @class TurnStatusReceivedEventArgs
 */ var $8bb62bdf2607a31e$var$TurnStatusReceivedEventArgs = /** @class */ function() {
    /**
     * Creates and initializes an instance of this class.
     * @constructor
     * @param {string} turnStatus - The JSON-encoded turn status message.
     */ function TurnStatusReceivedEventArgs(turnStatus) {
        this.privTurnStatus = $df4iv.TurnStatusResponsePayload.fromJSON(turnStatus);
    }
    Object.defineProperty(TurnStatusReceivedEventArgs.prototype, "interactionId", {
        /**
         * Gets the interaction identifier associated with this turn status event.
         * @member TurnStatusReceivedEventArgs.prototype.interactionId
         * @function
         * @public
         * @returns {any} the received interaction id.
         */ get: function() {
            return this.privTurnStatus.interactionId;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TurnStatusReceivedEventArgs.prototype, "conversationId", {
        /**
         * Gets the conversation identifier associated with this turn status event.
         * @member TurnStatusReceivedEventArgs.prototype.conversationId
         * @function
         * @public
         * @returns {any} the received conversation id.
         */ get: function() {
            return this.privTurnStatus.conversationId;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TurnStatusReceivedEventArgs.prototype, "statusCode", {
        /**
         * Gets the received turn status code.
         * @member TurnStatusReceivedEventArgs.prototype.statusCode
         * @function
         * @public
         * @returns {number} the received turn status.
         */ get: function() {
            return this.privTurnStatus.statusCode; // eslint-disable-line @typescript-eslint/no-unsafe-return
        },
        enumerable: false,
        configurable: true
    });
    return TurnStatusReceivedEventArgs;
}();
module.exports.TurnStatusReceivedEventArgs = $8bb62bdf2607a31e$var$TurnStatusReceivedEventArgs;

});
parcelRequire.register("df4iv", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TurnStatusResponsePayload = void 0;
var $9a40027944a186e7$var$TurnStatusResponsePayload = /** @class */ function() {
    function TurnStatusResponsePayload(json) {
        this.privMessageStatusResponse = JSON.parse(json);
    }
    TurnStatusResponsePayload.fromJSON = function(json) {
        return new TurnStatusResponsePayload(json);
    };
    Object.defineProperty(TurnStatusResponsePayload.prototype, "interactionId", {
        get: function() {
            return this.privMessageStatusResponse.interactionId;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TurnStatusResponsePayload.prototype, "conversationId", {
        get: function() {
            return this.privMessageStatusResponse.conversationId;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TurnStatusResponsePayload.prototype, "statusCode", {
        get: function() {
            // Payloads may contain a limited set of textual representations or a numeric status
            // code. The textual values are here converted into numeric ones.
            switch(this.privMessageStatusResponse.statusCode){
                case "Success":
                    return 200;
                case "Failed":
                    return 400;
                case "TimedOut":
                    return 429;
                default:
                    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
                    return this.privMessageStatusResponse.statusCode;
            }
        },
        enumerable: false,
        configurable: true
    });
    return TurnStatusResponsePayload;
}();
module.exports.TurnStatusResponsePayload = $9a40027944a186e7$var$TurnStatusResponsePayload;

});


parcelRequire.register("kG8Gw", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ServicePropertyChannel = void 0;
/**
 * Defines channels used to pass property settings to service.
 * Added in version 1.7.0.
 */ var $f0de7785d557db06$var$ServicePropertyChannel;
(function(ServicePropertyChannel) {
    /**
     * Uses URI query parameter to pass property settings to service.
     */ ServicePropertyChannel[ServicePropertyChannel["UriQueryParameter"] = 0] = "UriQueryParameter";
})($f0de7785d557db06$var$ServicePropertyChannel = module.exports.ServicePropertyChannel || (module.exports.ServicePropertyChannel = {}));

});

parcelRequire.register("9eMRA", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ProfanityOption = void 0;
/**
 * Profanity option.
 * Added in version 1.7.0.
 */ var $6b9b531b9a12aa75$var$ProfanityOption;
(function(ProfanityOption) {
    ProfanityOption[ProfanityOption["Masked"] = 0] = "Masked";
    ProfanityOption[ProfanityOption["Removed"] = 1] = "Removed";
    ProfanityOption[ProfanityOption["Raw"] = 2] = "Raw";
})($6b9b531b9a12aa75$var$ProfanityOption = module.exports.ProfanityOption || (module.exports.ProfanityOption = {}));

});

parcelRequire.register("k48LU", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
var $e9bafc413ecedab6$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $e9bafc413ecedab6$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.BaseAudioPlayer = void 0;

var $3XP4p = parcelRequire("3XP4p");

var $hM4QX = parcelRequire("hM4QX");

var $kQmaR = parcelRequire("kQmaR");
/**
 * Base audio player class
 * TODO: Plays only PCM for now.
 * @class
 */ var $e9bafc413ecedab6$var$BaseAudioPlayer = /** @class */ function() {
    /**
     * Creates and initializes an instance of this class.
     * @constructor
     * @param {AudioStreamFormat} audioFormat audio stream format recognized by the player.
     */ function BaseAudioPlayer(audioFormat) {
        this.audioContext = null;
        this.gainNode = null;
        this.autoUpdateBufferTimer = 0;
        if (audioFormat === undefined) audioFormat = $hM4QX.AudioStreamFormat.getDefaultInputFormat();
        this.init(audioFormat);
    }
    /**
     * play Audio sample
     * @param newAudioData audio data to be played.
     */ BaseAudioPlayer.prototype.playAudioSample = function(newAudioData, cb, err) {
        try {
            this.ensureInitializedContext();
            var audioData = this.formatAudioData(newAudioData);
            var newSamplesData = new Float32Array(this.samples.length + audioData.length);
            newSamplesData.set(this.samples, 0);
            newSamplesData.set(audioData, this.samples.length);
            this.samples = newSamplesData;
            if (!!cb) cb();
        } catch (e) {
            if (!!err) err(e);
        }
    };
    /**
     * stops audio and clears the buffers
     */ BaseAudioPlayer.prototype.stopAudio = function(cb, err) {
        if (this.audioContext !== null) {
            this.samples = new Float32Array();
            // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
            clearInterval(this.autoUpdateBufferTimer);
            this.audioContext.close().then(function() {
                if (!!cb) cb();
            }, function(error) {
                if (!!err) err(error);
            });
            this.audioContext = null;
        }
    };
    BaseAudioPlayer.prototype.init = function(audioFormat) {
        this.audioFormat = audioFormat;
        this.samples = new Float32Array();
    };
    BaseAudioPlayer.prototype.ensureInitializedContext = function() {
        var _this = this;
        if (this.audioContext === null) {
            this.createAudioContext();
            var timerPeriod = 200;
            this.autoUpdateBufferTimer = setInterval(function() {
                _this.updateAudioBuffer();
            }, timerPeriod);
        }
    };
    BaseAudioPlayer.prototype.createAudioContext = function() {
        // new ((window as any).AudioContext || (window as any).webkitAudioContext)();
        this.audioContext = $kQmaR.AudioStreamFormatImpl.getAudioContext();
        // TODO: Various examples shows this gain node, it does not seem to be needed unless we plan
        // to control the volume, not likely
        this.gainNode = this.audioContext.createGain();
        this.gainNode.gain.value = 1;
        this.gainNode.connect(this.audioContext.destination);
        this.startTime = this.audioContext.currentTime;
    };
    BaseAudioPlayer.prototype.formatAudioData = function(audioData) {
        switch(this.audioFormat.bitsPerSample){
            case 8:
                return this.formatArrayBuffer(new Int8Array(audioData), 128);
            case 16:
                return this.formatArrayBuffer(new Int16Array(audioData), 32768);
            case 32:
                return this.formatArrayBuffer(new Int32Array(audioData), 2147483648);
            default:
                throw new $3XP4p.InvalidOperationError("Only WAVE_FORMAT_PCM (8/16/32 bps) format supported at this time");
        }
    };
    BaseAudioPlayer.prototype.formatArrayBuffer = function(audioData, maxValue) {
        var float32Data = new Float32Array(audioData.length);
        for(var i = 0; i < audioData.length; i++)float32Data[i] = audioData[i] / maxValue;
        return float32Data;
    };
    BaseAudioPlayer.prototype.updateAudioBuffer = function() {
        if (this.samples.length === 0) return;
        var channelCount = this.audioFormat.channels;
        var bufferSource = this.audioContext.createBufferSource();
        var frameCount = this.samples.length / channelCount;
        var audioBuffer = this.audioContext.createBuffer(channelCount, frameCount, this.audioFormat.samplesPerSec);
        // TODO: Should we do the conversion in the pushAudioSample instead?
        for(var channel = 0; channel < channelCount; channel++){
            // Fill in individual channel data
            var channelOffset = channel;
            var audioData = audioBuffer.getChannelData(channel);
            for(var i = 0; i < this.samples.length; i++, channelOffset += channelCount)audioData[i] = this.samples[channelOffset];
        }
        if (this.startTime < this.audioContext.currentTime) this.startTime = this.audioContext.currentTime;
        bufferSource.buffer = audioBuffer;
        bufferSource.connect(this.gainNode);
        bufferSource.start(this.startTime);
        // Make sure we play the next sample after the current one.
        this.startTime += audioBuffer.duration;
        // Clear the samples for the next pushed data.
        this.samples = new Float32Array();
    };
    BaseAudioPlayer.prototype.playAudio = function(audioData) {
        return $e9bafc413ecedab6$var$__awaiter(this, void 0, void 0, function() {
            var source, destination;
            return $e9bafc413ecedab6$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (this.audioContext === null) this.createAudioContext();
                        source = this.audioContext.createBufferSource();
                        destination = this.audioContext.destination;
                        return [
                            4 /*yield*/ ,
                            this.audioContext.decodeAudioData(audioData, function(newBuffer) {
                                source.buffer = newBuffer;
                                source.connect(destination);
                                source.start(0);
                            })
                        ];
                    case 1:
                        _a.sent();
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    return BaseAudioPlayer;
}();
module.exports.BaseAudioPlayer = $e9bafc413ecedab6$var$BaseAudioPlayer;

});

parcelRequire.register("4yKJG", function(module, exports) {
"use strict";
//
// Copyright (c) Microsoft. All rights reserved.
// Licensed under the MIT license. See LICENSE.md file in the project root for full license information.
//
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ConnectionMessageEventArgs = void 0;
var $351e972661773446$var$ConnectionMessageEventArgs = /** @class */ function() {
    function ConnectionMessageEventArgs(message) {
        this.privConnectionMessage = message;
    }
    Object.defineProperty(ConnectionMessageEventArgs.prototype, "message", {
        /**
         * Gets the <see cref="ConnectionMessage"/> associated with this <see cref="ConnectionMessageEventArgs"/>.
         */ get: function() {
            return this.privConnectionMessage;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Returns a string that represents the connection message event.
     */ ConnectionMessageEventArgs.prototype.toString = function() {
        return "Message: " + this.privConnectionMessage.toString();
    };
    return ConnectionMessageEventArgs;
}();
module.exports.ConnectionMessageEventArgs = $351e972661773446$var$ConnectionMessageEventArgs;

});

parcelRequire.register("9By7J", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.VoiceProfile = void 0;
/**
 * Defines Voice Profile class for Speaker Recognition
 * @class VoiceProfile
 */ var $6fe20a047882c34d$var$VoiceProfile = /** @class */ function() {
    /**
     * Creates and initializes an instance of this class.
     * @constructor
     * @param {string} profileId - profileId of this Voice Profile.
     * @param {VoiceProfileType} profileType - profileType of this Voice Profile.
     */ function VoiceProfile(profileId, profileType) {
        this.privId = profileId;
        this.privProfileType = profileType;
    }
    Object.defineProperty(VoiceProfile.prototype, "profileId", {
        /**
         * profileId of this Voice Profile instance
         * @member VoiceProfile.prototype.profileId
         * @function
         * @public
         * @returns {string} profileId of this Voice Profile instance.
         */ get: function() {
            return this.privId;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(VoiceProfile.prototype, "profileType", {
        /**
         * profileType of this Voice Profile instance
         * @member VoiceProfile.prototype.profileType
         * @function
         * @public
         * @returns {VoiceProfileType} profile type of this Voice Profile instance.
         */ get: function() {
            return this.privProfileType;
        },
        enumerable: false,
        configurable: true
    });
    return VoiceProfile;
}();
module.exports.VoiceProfile = $6fe20a047882c34d$var$VoiceProfile;

});

parcelRequire.register("7WNJy", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
var $5c94874770ab2501$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.VoiceProfileEnrollmentCancellationDetails = module.exports.VoiceProfileEnrollmentResult = void 0;

var $dEkJU = parcelRequire("dEkJU");

var $hM4QX = parcelRequire("hM4QX");
/**
 * Output format
 * @class VoiceProfileEnrollmentResult
 */ var $5c94874770ab2501$var$VoiceProfileEnrollmentResult = /** @class */ function() {
    function VoiceProfileEnrollmentResult(reason, json, statusText) {
        this.privReason = reason;
        this.privProperties = new $hM4QX.PropertyCollection();
        if (this.privReason !== $hM4QX.ResultReason.Canceled) {
            if (!!json) {
                this.privDetails = JSON.parse(json);
                if (this.privDetails.enrollmentStatus.toLowerCase() === "enrolling") this.privReason = $hM4QX.ResultReason.EnrollingVoiceProfile;
            }
        } else {
            this.privErrorDetails = statusText;
            this.privProperties.setProperty($dEkJU.CancellationErrorCodePropertyName, $hM4QX.CancellationErrorCode[$hM4QX.CancellationErrorCode.ServiceError]);
        }
    }
    Object.defineProperty(VoiceProfileEnrollmentResult.prototype, "reason", {
        get: function() {
            return this.privReason;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(VoiceProfileEnrollmentResult.prototype, "enrollmentsCount", {
        get: function() {
            return this.privDetails.enrollmentsCount;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(VoiceProfileEnrollmentResult.prototype, "enrollmentsLength", {
        get: function() {
            return this.privDetails.enrollmentsLength;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(VoiceProfileEnrollmentResult.prototype, "properties", {
        get: function() {
            return this.privProperties;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(VoiceProfileEnrollmentResult.prototype, "enrollmentResultDetails", {
        get: function() {
            return this.privDetails;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(VoiceProfileEnrollmentResult.prototype, "errorDetails", {
        get: function() {
            return this.privErrorDetails;
        },
        enumerable: false,
        configurable: true
    });
    VoiceProfileEnrollmentResult.FromIdentificationProfileList = function(json) {
        var results = [];
        for(var _i = 0, _a = json.value; _i < _a.length; _i++){
            var item = _a[_i];
            var reason = item.enrollmentStatus.toLowerCase() === "enrolling" ? $hM4QX.ResultReason.EnrollingVoiceProfile : item.enrollmentStatus.toLowerCase() === "enrolled" ? $hM4QX.ResultReason.EnrolledVoiceProfile : $hM4QX.ResultReason.Canceled;
            var result = new VoiceProfileEnrollmentResult(reason, null, null);
            result.privDetails = this.getIdentificationDetails(item);
            results.push(result);
        }
        return results;
    };
    VoiceProfileEnrollmentResult.FromVerificationProfileList = function(json) {
        var results = [];
        for(var _i = 0, _a = json.value; _i < _a.length; _i++){
            var item = _a[_i];
            var reason = item.enrollmentStatus.toLowerCase() === "enrolling" ? $hM4QX.ResultReason.EnrollingVoiceProfile : item.enrollmentStatus.toLowerCase() === "enrolled" ? $hM4QX.ResultReason.EnrolledVoiceProfile : $hM4QX.ResultReason.Canceled;
            var result = new VoiceProfileEnrollmentResult(reason, null, null);
            result.privDetails = this.getVerificationDetails(item);
            results.push(result);
        }
        return results;
    };
    VoiceProfileEnrollmentResult.getIdentificationDetails = function(json) {
        return {
            audioLength: json.audioLength ? parseFloat(json.audioLength) : 0,
            audioSpeechLength: json.audioSpeechLength ? parseFloat(json.audioSpeechLength) : 0,
            enrollmentStatus: json.enrollmentStatus,
            enrollmentsCount: json.enrollmentsCount || 0,
            enrollmentsLength: json.enrollmentsLength ? parseFloat(json.enrollmentsLength) : 0,
            enrollmentsSpeechLength: json.enrollmentsSpeechLength ? parseFloat(json.enrollmentsSpeechLength) : 0,
            profileId: json.profileId || json.identificationProfileId,
            remainingEnrollmentsSpeechLength: json.remainingEnrollmentsSpeechLength ? parseFloat(json.remainingEnrollmentsSpeechLength) : 0
        };
    };
    VoiceProfileEnrollmentResult.getVerificationDetails = function(json) {
        return {
            audioLength: json.audioLength ? parseFloat(json.audioLength) : 0,
            audioSpeechLength: json.audioSpeechLength ? parseFloat(json.audioSpeechLength) : 0,
            enrollmentStatus: json.enrollmentStatus,
            enrollmentsCount: json.enrollmentsCount,
            enrollmentsLength: json.enrollmentsLength ? parseFloat(json.enrollmentsLength) : 0,
            enrollmentsSpeechLength: json.enrollmentsSpeechLength ? parseFloat(json.enrollmentsSpeechLength) : 0,
            profileId: json.profileId || json.verificationProfileId,
            remainingEnrollmentsCount: json.remainingEnrollments || json.remainingEnrollmentsCount,
            remainingEnrollmentsSpeechLength: json.remainingEnrollmentsSpeechLength ? parseFloat(json.remainingEnrollmentsSpeechLength) : 0
        };
    };
    return VoiceProfileEnrollmentResult;
}();
module.exports.VoiceProfileEnrollmentResult = $5c94874770ab2501$var$VoiceProfileEnrollmentResult;
/**
 * @class VoiceProfileEnrollmentCancellationDetails
 */ var $5c94874770ab2501$var$VoiceProfileEnrollmentCancellationDetails = /** @class */ function(_super) {
    $5c94874770ab2501$var$__extends(VoiceProfileEnrollmentCancellationDetails, _super);
    function VoiceProfileEnrollmentCancellationDetails(reason, errorDetails, errorCode) {
        return _super.call(this, reason, errorDetails, errorCode) || this;
    }
    /**
     * Creates an instance of VoiceProfileEnrollmentCancellationDetails object for the canceled VoiceProfileEnrollmentResult.
     * @member VoiceProfileEnrollmentCancellationDetails.fromResult
     * @function
     * @public
     * @param {VoiceProfileEnrollmentResult} result - The result that was canceled.
     * @returns {VoiceProfileEnrollmentCancellationDetails} The cancellation details object being created.
     */ VoiceProfileEnrollmentCancellationDetails.fromResult = function(result) {
        var reason = $hM4QX.CancellationReason.Error;
        var errorCode = $hM4QX.CancellationErrorCode.NoError;
        if (!!result.properties) errorCode = $hM4QX.CancellationErrorCode[result.properties.getProperty($dEkJU.CancellationErrorCodePropertyName, $hM4QX.CancellationErrorCode[$hM4QX.CancellationErrorCode.NoError])]; //eslint-disable-line
        return new VoiceProfileEnrollmentCancellationDetails(reason, result.errorDetails, errorCode);
    };
    return VoiceProfileEnrollmentCancellationDetails;
}($hM4QX.CancellationDetailsBase);
module.exports.VoiceProfileEnrollmentCancellationDetails = $5c94874770ab2501$var$VoiceProfileEnrollmentCancellationDetails;

});

parcelRequire.register("4qwZJ", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
var $33932f35740068f4$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.VoiceProfileCancellationDetails = module.exports.VoiceProfileResult = void 0;

var $dEkJU = parcelRequire("dEkJU");

var $gBGZx = parcelRequire("gBGZx");

var $hM4QX = parcelRequire("hM4QX");
/**
 * Output format
 * @class VoiceProfileResult
 */ var $33932f35740068f4$var$VoiceProfileResult = /** @class */ function() {
    function VoiceProfileResult(reason, statusText) {
        this.privReason = reason;
        this.privProperties = new $hM4QX.PropertyCollection();
        if (reason === $hM4QX.ResultReason.Canceled) {
            $gBGZx.Contracts.throwIfNullOrUndefined(statusText, "statusText");
            this.privErrorDetails = statusText;
            this.privProperties.setProperty($dEkJU.CancellationErrorCodePropertyName, $hM4QX.CancellationErrorCode[$hM4QX.CancellationErrorCode.ServiceError]);
        }
    }
    Object.defineProperty(VoiceProfileResult.prototype, "reason", {
        get: function() {
            return this.privReason;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(VoiceProfileResult.prototype, "properties", {
        get: function() {
            return this.privProperties;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(VoiceProfileResult.prototype, "errorDetails", {
        get: function() {
            return this.privErrorDetails;
        },
        enumerable: false,
        configurable: true
    });
    return VoiceProfileResult;
}();
module.exports.VoiceProfileResult = $33932f35740068f4$var$VoiceProfileResult;
/**
 * @class VoiceProfileCancellationDetails
 */ var $33932f35740068f4$var$VoiceProfileCancellationDetails = /** @class */ function(_super) {
    $33932f35740068f4$var$__extends(VoiceProfileCancellationDetails, _super);
    function VoiceProfileCancellationDetails(reason, errorDetails, errorCode) {
        return _super.call(this, reason, errorDetails, errorCode) || this;
    }
    /**
     * Creates an instance of VoiceProfileCancellationDetails object for the canceled VoiceProfileResult.
     * @member VoiceProfileCancellationDetails.fromResult
     * @function
     * @public
     * @param {VoiceProfileResult} result - The result that was canceled.
     * @returns {VoiceProfileCancellationDetails} The cancellation details object being created.
     */ VoiceProfileCancellationDetails.fromResult = function(result) {
        var reason = $hM4QX.CancellationReason.Error;
        var errorCode = $hM4QX.CancellationErrorCode.NoError;
        if (!!result.properties) errorCode = $hM4QX.CancellationErrorCode[result.properties.getProperty($dEkJU.CancellationErrorCodePropertyName, $hM4QX.CancellationErrorCode[$hM4QX.CancellationErrorCode.NoError])]; //eslint-disable-line
        return new VoiceProfileCancellationDetails(reason, result.errorDetails, errorCode);
    };
    return VoiceProfileCancellationDetails;
}($hM4QX.CancellationDetailsBase);
module.exports.VoiceProfileCancellationDetails = $33932f35740068f4$var$VoiceProfileCancellationDetails;

});

parcelRequire.register("jjrBQ", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
var $e0f53555f98922e0$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.VoiceProfilePhraseResult = void 0;

var $gBGZx = parcelRequire("gBGZx");

var $hM4QX = parcelRequire("hM4QX");
/**
 * Output format
 * @class VoiceProfilePhraseResult
 */ var $e0f53555f98922e0$var$VoiceProfilePhraseResult = /** @class */ function(_super) {
    $e0f53555f98922e0$var$__extends(VoiceProfilePhraseResult, _super);
    function VoiceProfilePhraseResult(reason, statusText, type, phraseArray) {
        var _this = _super.call(this, reason, statusText) || this;
        _this.privPhrases = [];
        $gBGZx.Contracts.throwIfNullOrUndefined(phraseArray, "phrase array");
        _this.privType = type;
        if (!!phraseArray && !!phraseArray[0]) _this.privPhrases = phraseArray;
        return _this;
    }
    Object.defineProperty(VoiceProfilePhraseResult.prototype, "phrases", {
        get: function() {
            return this.privPhrases;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(VoiceProfilePhraseResult.prototype, "type", {
        get: function() {
            return this.privType;
        },
        enumerable: false,
        configurable: true
    });
    return VoiceProfilePhraseResult;
}($hM4QX.VoiceProfileResult);
module.exports.VoiceProfilePhraseResult = $e0f53555f98922e0$var$VoiceProfilePhraseResult;

});

parcelRequire.register("eBxhK", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
var $aa1e57287ec64db0$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $aa1e57287ec64db0$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $aa1e57287ec64db0$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.VoiceProfileClient = void 0;

var $dEkJU = parcelRequire("dEkJU");

var $dSeiF = parcelRequire("dSeiF");

var $gBGZx = parcelRequire("gBGZx");

var $hM4QX = parcelRequire("hM4QX");
/**
 * Defines VoiceProfileClient class for Speaker Recognition
 * Handles operations from user for Voice Profile operations (e.g. createProfile, deleteProfile)
 * @class VoiceProfileClient
 */ var $aa1e57287ec64db0$var$VoiceProfileClient = /** @class */ function(_super) {
    $aa1e57287ec64db0$var$__extends(VoiceProfileClient, _super);
    /**
     * VoiceProfileClient constructor.
     * @constructor
     * @param {SpeechConfig} speechConfig - An set of initial properties for this synthesizer (authentication key, region, &c)
     */ function VoiceProfileClient(speechConfig) {
        var _this = this;
        $gBGZx.Contracts.throwIfNullOrUndefined(speechConfig, "speechConfig");
        var speechConfigImpl = speechConfig;
        $gBGZx.Contracts.throwIfNull(speechConfigImpl, "speechConfig");
        _this = _super.call(this, $dSeiF.AudioConfig.fromStreamInput($hM4QX.AudioInputStream.createPushStream()), speechConfigImpl.properties, new $dEkJU.VoiceProfileConnectionFactory()) || this;
        _this.privProperties = speechConfigImpl.properties.clone();
        _this.privVoiceAdapter = _this.privReco;
        _this.privDisposedVoiceAdapter = false;
        return _this;
    }
    Object.defineProperty(VoiceProfileClient.prototype, "properties", {
        /**
         * The collection of properties and their values defined for this VoiceProfileClient.
         * @member VoiceProfileClient.prototype.properties
         * @function
         * @public
         * @returns {PropertyCollection} The collection of properties and their values defined for this VoiceProfileClient.
         */ get: function() {
            return this.privProperties;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(VoiceProfileClient.prototype, "authorizationToken", {
        /**
         * Gets the authorization token used to communicate with the service.
         * @member VoiceProfileClient.prototype.authorizationToken
         * @function
         * @public
         * @returns {string} Authorization token.
         */ get: function() {
            return this.properties.getProperty($hM4QX.PropertyId.SpeechServiceAuthorization_Token);
        },
        /**
         * Gets/Sets the authorization token used to communicate with the service.
         * @member VoiceProfileClient.prototype.authorizationToken
         * @function
         * @public
         * @param {string} token - Authorization token.
         */ set: function(token) {
            $gBGZx.Contracts.throwIfNullOrWhitespace(token, "token");
            this.properties.setProperty($hM4QX.PropertyId.SpeechServiceAuthorization_Token, token);
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Create a speaker recognition voice profile
     * @member VoiceProfileClient.prototype.createProfileAsync
     * @function
     * @public
     * @async
     * @param {VoiceProfileType} profileType Type of Voice Profile to be created
     * @param {string} lang Language string (locale) for Voice Profile
     * @return {Promise<VoiceProfile>} - Promise of a VoiceProfile.
     */ VoiceProfileClient.prototype.createProfileAsync = function(profileType, lang) {
        return $aa1e57287ec64db0$var$__awaiter(this, void 0, void 0, function() {
            var profileIds;
            return $aa1e57287ec64db0$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.privVoiceAdapter.createProfile(profileType, lang)
                        ];
                    case 1:
                        profileIds = _a.sent();
                        return [
                            2 /*return*/ ,
                            new $hM4QX.VoiceProfile(profileIds[0], profileType)
                        ];
                }
            });
        });
    };
    /**
     * Get current information of a voice profile
     * @member VoiceProfileClient.prototype.retrieveEnrollmentResultAsync
     * @function
     * @public
     * @async
     * @param {VoiceProfile} profile Voice Profile to retrieve info for
     * @return {Promise<VoiceProfileEnrollmentResult>} - Promise of a VoiceProfileEnrollmentResult.
     */ VoiceProfileClient.prototype.retrieveEnrollmentResultAsync = function(profile) {
        return $aa1e57287ec64db0$var$__awaiter(this, void 0, void 0, function() {
            return $aa1e57287ec64db0$var$__generator(this, function(_a) {
                return [
                    2 /*return*/ ,
                    this.privVoiceAdapter.retrieveEnrollmentResult(profile)
                ];
            });
        });
    };
    /**
     * Get all voice profiles on account with given voice profile type
     * @member VoiceProfileClient.prototype.getAllProfilesAsync
     * @function
     * @public
     * @async
     * @param {VoiceProfileType} profileType profile type (identification/verification) for which to list profiles
     * @return {Promise<VoiceProfileEnrollmentResult[]>} - Promise of an array of VoiceProfileEnrollmentResults.
     */ VoiceProfileClient.prototype.getAllProfilesAsync = function(profileType) {
        return $aa1e57287ec64db0$var$__awaiter(this, void 0, void 0, function() {
            return $aa1e57287ec64db0$var$__generator(this, function(_a) {
                return [
                    2 /*return*/ ,
                    this.privVoiceAdapter.getAllProfiles(profileType)
                ];
            });
        });
    };
    /**
     * Get valid authorization phrases for voice profile enrollment
     * @member VoiceProfileClient.prototype.getActivationPhrasesAsync
     * @function
     * @public
     * @async
     * @param {VoiceProfileType} profileType Profile Type to get activation phrases for
     * @param {string} lang Language string (locale) for Voice Profile
     */ VoiceProfileClient.prototype.getActivationPhrasesAsync = function(profileType, lang) {
        return $aa1e57287ec64db0$var$__awaiter(this, void 0, void 0, function() {
            return $aa1e57287ec64db0$var$__generator(this, function(_a) {
                return [
                    2 /*return*/ ,
                    this.privVoiceAdapter.getActivationPhrases(profileType, lang)
                ];
            });
        });
    };
    /**
     * Create a speaker recognition voice profile
     * @member VoiceProfileClient.prototype.enrollProfileAsync
     * @function
     * @public
     * @async
     * @param {VoiceProfile} profile Voice Profile to create enrollment for
     * @param {AudioConfig} audioConfig source info from which to create enrollment
     * @return {Promise<VoiceProfileEnrollmentResult>} - Promise of a VoiceProfileEnrollmentResult.
     */ VoiceProfileClient.prototype.enrollProfileAsync = function(profile, audioConfig) {
        return $aa1e57287ec64db0$var$__awaiter(this, void 0, void 0, function() {
            var configImpl;
            return $aa1e57287ec64db0$var$__generator(this, function(_a) {
                configImpl = audioConfig;
                $gBGZx.Contracts.throwIfNullOrUndefined(configImpl, "audioConfig");
                this.audioConfig = audioConfig;
                this.privVoiceAdapter.SpeakerAudioSource = configImpl;
                return [
                    2 /*return*/ ,
                    this.privVoiceAdapter.enrollProfile(profile)
                ];
            });
        });
    };
    /**
     * Delete a speaker recognition voice profile
     * @member VoiceProfileClient.prototype.deleteProfileAsync
     * @function
     * @public
     * @async
     * @param {VoiceProfile} profile Voice Profile to be deleted
     * @return {Promise<VoiceProfileResult>} - Promise of a VoiceProfileResult.
     */ VoiceProfileClient.prototype.deleteProfileAsync = function(profile) {
        return $aa1e57287ec64db0$var$__awaiter(this, void 0, void 0, function() {
            return $aa1e57287ec64db0$var$__generator(this, function(_a) {
                return [
                    2 /*return*/ ,
                    this.privVoiceAdapter.deleteProfile(profile)
                ];
            });
        });
    };
    /**
     * Remove all enrollments for a speaker recognition voice profile
     * @member VoiceProfileClient.prototype.resetProfileAsync
     * @function
     * @public
     * @async
     * @param {VoiceProfile} profile Voice Profile to be reset
     * @return {Promise<VoiceProfileResult>} - Promise of a VoiceProfileResult.
     */ VoiceProfileClient.prototype.resetProfileAsync = function(profile) {
        return $aa1e57287ec64db0$var$__awaiter(this, void 0, void 0, function() {
            return $aa1e57287ec64db0$var$__generator(this, function(_a) {
                return [
                    2 /*return*/ ,
                    this.privVoiceAdapter.resetProfile(profile)
                ];
            });
        });
    };
    /**
     * Clean up object and close underlying connection
     * @member VoiceProfileClient.prototype.close
     * @function
     * @async
     * @public
     */ VoiceProfileClient.prototype.close = function() {
        return $aa1e57287ec64db0$var$__awaiter(this, void 0, void 0, function() {
            return $aa1e57287ec64db0$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.dispose(true)
                        ];
                    case 1:
                        _a.sent();
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    VoiceProfileClient.prototype.createServiceRecognizer = function(authentication, connectionFactory, audioConfig, recognizerConfig) {
        var audioImpl = audioConfig;
        return new $dEkJU.VoiceServiceRecognizer(authentication, connectionFactory, audioImpl, recognizerConfig, this);
    };
    VoiceProfileClient.prototype.dispose = function(disposing) {
        return $aa1e57287ec64db0$var$__awaiter(this, void 0, void 0, function() {
            return $aa1e57287ec64db0$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (this.privDisposedVoiceAdapter) return [
                            2 /*return*/ 
                        ];
                        this.privDisposedVoiceAdapter = true;
                        if (!disposing) return [
                            3 /*break*/ ,
                            2
                        ];
                        return [
                            4 /*yield*/ ,
                            _super.prototype.dispose.call(this, disposing)
                        ];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    VoiceProfileClient.prototype.createRecognizerConfig = function(speechConfig) {
        return new $dEkJU.RecognizerConfig(speechConfig, this.properties);
    };
    VoiceProfileClient.prototype.getResult = function(result, successReason) {
        var response = new $hM4QX.VoiceProfileResult(result.ok ? successReason : $hM4QX.ResultReason.Canceled, result.statusText);
        return response;
    };
    return VoiceProfileClient;
}($hM4QX.Recognizer);
module.exports.VoiceProfileClient = $aa1e57287ec64db0$var$VoiceProfileClient;

});

parcelRequire.register("1miKD", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
var $0fd6641f4a8f3df9$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $0fd6641f4a8f3df9$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $0fd6641f4a8f3df9$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SpeakerRecognizer = void 0;

var $dEkJU = parcelRequire("dEkJU");

var $gBGZx = parcelRequire("gBGZx");

var $hM4QX = parcelRequire("hM4QX");
/**
 * Defines SpeakerRecognizer class for Speaker Recognition
 * Handles operations from user for Voice Profile operations (e.g. createProfile, deleteProfile)
 * @class SpeakerRecognizer
 */ var $0fd6641f4a8f3df9$var$SpeakerRecognizer = /** @class */ function(_super) {
    $0fd6641f4a8f3df9$var$__extends(SpeakerRecognizer, _super);
    /**
     * Initializes an instance of the SpeakerRecognizer.
     * @constructor
     * @param {SpeechConfig} speechConfig - The set of configuration properties.
     * @param {AudioConfig} audioConfig - An optional audio input config associated with the recognizer
     */ function SpeakerRecognizer(speechConfig, audioConfig) {
        var _this = this;
        $gBGZx.Contracts.throwIfNullOrUndefined(speechConfig, "speechConfig");
        var configImpl = speechConfig;
        $gBGZx.Contracts.throwIfNullOrUndefined(configImpl, "speechConfig");
        _this = _super.call(this, audioConfig, configImpl.properties, new $dEkJU.SpeakerRecognitionConnectionFactory()) || this;
        _this.privAudioConfigImpl = audioConfig;
        $gBGZx.Contracts.throwIfNull(_this.privAudioConfigImpl, "audioConfig");
        _this.privDisposedSpeakerRecognizer = false;
        _this.privProperties = configImpl.properties;
        return _this;
    }
    Object.defineProperty(SpeakerRecognizer.prototype, "authorizationToken", {
        /**
         * Gets the authorization token used to communicate with the service.
         * @member SpeakerRecognizer.prototype.authorizationToken
         * @function
         * @public
         * @returns {string} Authorization token.
         */ get: function() {
            return this.properties.getProperty($hM4QX.PropertyId.SpeechServiceAuthorization_Token);
        },
        /**
         * Gets/Sets the authorization token used to communicate with the service.
         * @member SpeakerRecognizer.prototype.authorizationToken
         * @function
         * @public
         * @param {string} token - Authorization token.
         */ set: function(token) {
            $gBGZx.Contracts.throwIfNullOrWhitespace(token, "token");
            this.properties.setProperty($hM4QX.PropertyId.SpeechServiceAuthorization_Token, token);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SpeakerRecognizer.prototype, "properties", {
        /**
         * The collection of properties and their values defined for this SpeakerRecognizer.
         * @member SpeakerRecognizer.prototype.properties
         * @function
         * @public
         * @returns {PropertyCollection} The collection of properties and their values defined for this SpeakerRecognizer.
         */ get: function() {
            return this.privProperties;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Get recognition result for model using given audio
     * @member SpeakerRecognizer.prototype.recognizeOnceAsync
     * @function
     * @public
     * @async
     * @param {SpeakerIdentificationModel | SpeakerVerificationModel} model Model containing Voice Profiles to be identified
     * @param cb - Callback invoked once result is returned.
     * @param err - Callback invoked in case of an error.
     */ SpeakerRecognizer.prototype.recognizeOnceAsync = function(model) {
        return $0fd6641f4a8f3df9$var$__awaiter(this, void 0, void 0, function() {
            return $0fd6641f4a8f3df9$var$__generator(this, function(_a) {
                $gBGZx.Contracts.throwIfDisposed(this.privDisposedSpeakerRecognizer);
                return [
                    2 /*return*/ ,
                    this.recognizeSpeakerOnceAsyncImpl(model)
                ];
            });
        });
    };
    /**
     * Included for compatibility
     * @member SpeakerRecognizer.prototype.close
     * @function
     * @public
     * @async
     */ SpeakerRecognizer.prototype.close = function() {
        return $0fd6641f4a8f3df9$var$__awaiter(this, void 0, void 0, function() {
            return $0fd6641f4a8f3df9$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        $gBGZx.Contracts.throwIfDisposed(this.privDisposedSpeakerRecognizer);
                        return [
                            4 /*yield*/ ,
                            this.dispose(true)
                        ];
                    case 1:
                        _a.sent();
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    SpeakerRecognizer.prototype.recognizeSpeakerOnceAsyncImpl = function(model) {
        return $0fd6641f4a8f3df9$var$__awaiter(this, void 0, void 0, function() {
            var result;
            return $0fd6641f4a8f3df9$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        $gBGZx.Contracts.throwIfDisposed(this.privDisposedSpeakerRecognizer);
                        return [
                            4 /*yield*/ ,
                            this.implRecognizerStop()
                        ];
                    case 1:
                        _a.sent();
                        return [
                            4 /*yield*/ ,
                            this.privReco.recognizeSpeaker(model)
                        ];
                    case 2:
                        result = _a.sent();
                        return [
                            4 /*yield*/ ,
                            this.implRecognizerStop()
                        ];
                    case 3:
                        _a.sent();
                        return [
                            2 /*return*/ ,
                            result
                        ];
                }
            });
        });
    };
    SpeakerRecognizer.prototype.implRecognizerStop = function() {
        return $0fd6641f4a8f3df9$var$__awaiter(this, void 0, void 0, function() {
            return $0fd6641f4a8f3df9$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!this.privReco) return [
                            3 /*break*/ ,
                            2
                        ];
                        return [
                            4 /*yield*/ ,
                            this.privReco.stopRecognizing()
                        ];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    SpeakerRecognizer.prototype.createRecognizerConfig = function(speechConfig) {
        return new $dEkJU.RecognizerConfig(speechConfig, this.privProperties);
    };
    SpeakerRecognizer.prototype.createServiceRecognizer = function(authentication, connectionFactory, audioConfig, recognizerConfig) {
        var audioImpl = audioConfig;
        return new $dEkJU.SpeakerServiceRecognizer(authentication, connectionFactory, audioImpl, recognizerConfig, this);
    };
    SpeakerRecognizer.prototype.dispose = function(disposing) {
        return $0fd6641f4a8f3df9$var$__awaiter(this, void 0, void 0, function() {
            return $0fd6641f4a8f3df9$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (this.privDisposedSpeakerRecognizer) return [
                            2 /*return*/ 
                        ];
                        if (!disposing) return [
                            3 /*break*/ ,
                            2
                        ];
                        this.privDisposedSpeakerRecognizer = true;
                        return [
                            4 /*yield*/ ,
                            _super.prototype.dispose.call(this, disposing)
                        ];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    return SpeakerRecognizer;
}($hM4QX.Recognizer);
module.exports.SpeakerRecognizer = $0fd6641f4a8f3df9$var$SpeakerRecognizer;

});

parcelRequire.register("adVUs", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SpeakerIdentificationModel = void 0;

var $gBGZx = parcelRequire("gBGZx");

var $hM4QX = parcelRequire("hM4QX");
/**
 * Defines SpeakerIdentificationModel class for Speaker Recognition
 * Model contains a set of profiles against which to identify speaker(s)
 * @class SpeakerIdentificationModel
 */ var $771809e8be4396b1$var$SpeakerIdentificationModel = /** @class */ function() {
    function SpeakerIdentificationModel(profiles) {
        this.privVoiceProfiles = [];
        this.privProfileIds = [];
        $gBGZx.Contracts.throwIfNullOrUndefined(profiles, "VoiceProfiles");
        if (profiles.length === 0) throw new Error("Empty Voice Profiles array");
        for(var _i = 0, profiles_1 = profiles; _i < profiles_1.length; _i++){
            var profile = profiles_1[_i];
            if (profile.profileType !== $hM4QX.VoiceProfileType.TextIndependentIdentification) throw new Error("Identification model can only be created from Identification profile: " + profile.profileId);
            this.privVoiceProfiles.push(profile);
            this.privProfileIds.push(profile.profileId);
        }
    }
    SpeakerIdentificationModel.fromProfiles = function(profiles) {
        return new SpeakerIdentificationModel(profiles);
    };
    Object.defineProperty(SpeakerIdentificationModel.prototype, "voiceProfileIds", {
        get: function() {
            return this.privProfileIds.join(",");
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SpeakerIdentificationModel.prototype, "profileIds", {
        get: function() {
            return this.privProfileIds;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SpeakerIdentificationModel.prototype, "scenario", {
        get: function() {
            return "TextIndependentIdentification";
        },
        enumerable: false,
        configurable: true
    });
    return SpeakerIdentificationModel;
}();
module.exports.SpeakerIdentificationModel = $771809e8be4396b1$var$SpeakerIdentificationModel;

});

parcelRequire.register("asCMT", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SpeakerVerificationModel = void 0;

var $gBGZx = parcelRequire("gBGZx");

var $hM4QX = parcelRequire("hM4QX");
/**
 * Defines SpeakerVerificationModel class for Speaker Recognition
 * Model contains a profile against which to verify a speaker
 * @class SpeakerVerificationModel
 */ var $79da9b557b4b6602$var$SpeakerVerificationModel = /** @class */ function() {
    function SpeakerVerificationModel(profile) {
        $gBGZx.Contracts.throwIfNullOrUndefined(profile, "VoiceProfile");
        if (profile.profileType === $hM4QX.VoiceProfileType.TextIndependentIdentification) throw new Error("Verification model cannot be created from Identification profile");
        this.privVoiceProfile = profile;
    }
    SpeakerVerificationModel.fromProfile = function(profile) {
        return new SpeakerVerificationModel(profile);
    };
    Object.defineProperty(SpeakerVerificationModel.prototype, "voiceProfile", {
        get: function() {
            return this.privVoiceProfile;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SpeakerVerificationModel.prototype, "profileIds", {
        get: function() {
            return [
                this.voiceProfile.profileId
            ];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SpeakerVerificationModel.prototype, "scenario", {
        get: function() {
            if (this.voiceProfile.profileType === $hM4QX.VoiceProfileType.TextDependentVerification) return "TextDependentVerification";
            else return "TextIndependentVerification";
        },
        enumerable: false,
        configurable: true
    });
    return SpeakerVerificationModel;
}();
module.exports.SpeakerVerificationModel = $79da9b557b4b6602$var$SpeakerVerificationModel;

});

parcelRequire.register("dg3Jy", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.AutoDetectSourceLanguageConfig = void 0;

var $dEkJU = parcelRequire("dEkJU");

var $gBGZx = parcelRequire("gBGZx");

var $hM4QX = parcelRequire("hM4QX");

var $lf3Sn = parcelRequire("lf3Sn");
/**
 * Language auto detect configuration.
 * @class AutoDetectSourceLanguageConfig
 * Added in version 1.13.0.
 */ var $9a6faa73e1bcbfb2$var$AutoDetectSourceLanguageConfig = /** @class */ function() {
    function AutoDetectSourceLanguageConfig() {
        this.privProperties = new $hM4QX.PropertyCollection();
        this.privProperties.setProperty($hM4QX.PropertyId.SpeechServiceConnection_LanguageIdMode, "AtStart");
        this.privLanguageIdMode = $lf3Sn.LanguageIdMode.AtStart;
    }
    /**
     * @member AutoDetectSourceLanguageConfig.fromOpenRange
     * @function
     * @public
     * Only [[SpeechSynthesizer]] supports source language auto detection from open range,
     * for [[Recognizer]], please use AutoDetectSourceLanguageConfig with specific source languages.
     * @return {AutoDetectSourceLanguageConfig} Instance of AutoDetectSourceLanguageConfig
     * @summary Creates an instance of the AutoDetectSourceLanguageConfig with open range.
     */ AutoDetectSourceLanguageConfig.fromOpenRange = function() {
        var config = new AutoDetectSourceLanguageConfig();
        config.properties.setProperty($hM4QX.PropertyId.SpeechServiceConnection_AutoDetectSourceLanguages, $dEkJU.AutoDetectSourceLanguagesOpenRangeOptionName);
        return config;
    };
    /**
     * @member AutoDetectSourceLanguageConfig.fromLanguages
     * @function
     * @public
     * @param {string[]} languages Comma-separated string of languages (eg. "en-US,fr-FR") to populate properties of config.
     * @return {AutoDetectSourceLanguageConfig} Instance of AutoDetectSourceLanguageConfig
     * @summary Creates an instance of the AutoDetectSourceLanguageConfig with given languages.
     */ AutoDetectSourceLanguageConfig.fromLanguages = function(languages) {
        $gBGZx.Contracts.throwIfArrayEmptyOrWhitespace(languages, "languages");
        var config = new AutoDetectSourceLanguageConfig();
        config.properties.setProperty($hM4QX.PropertyId.SpeechServiceConnection_AutoDetectSourceLanguages, languages.join());
        return config;
    };
    /**
     * @member AutoDetectSourceLanguageConfig.fromSourceLanguageConfigs
     * @function
     * @public
     * @param {SourceLanguageConfig[]} configs SourceLanguageConfigs to populate properties of config.
     * @return {AutoDetectSourceLanguageConfig} Instance of AutoDetectSourceLanguageConfig
     * @summary Creates an instance of the AutoDetectSourceLanguageConfig with given SourceLanguageConfigs.
     */ AutoDetectSourceLanguageConfig.fromSourceLanguageConfigs = function(configs) {
        if (configs.length < 1) throw new Error("Expected non-empty SourceLanguageConfig array.");
        var autoConfig = new AutoDetectSourceLanguageConfig();
        var langs = [];
        configs.forEach(function(config) {
            langs.push(config.language);
            if (config.endpointId !== undefined && config.endpointId !== "") {
                var customProperty = config.language + $hM4QX.PropertyId.SpeechServiceConnection_EndpointId.toString();
                autoConfig.properties.setProperty(customProperty, config.endpointId);
            }
        });
        autoConfig.properties.setProperty($hM4QX.PropertyId.SpeechServiceConnection_AutoDetectSourceLanguages, langs.join());
        return autoConfig;
    };
    Object.defineProperty(AutoDetectSourceLanguageConfig.prototype, "properties", {
        /**
         * @member AutoDetectSourceLanguageConfig.prototype.properties
         * @function
         * @public
         * @return {PropertyCollection} Properties of the config.
         * @summary Gets an auto detected language config properties
         */ get: function() {
            return this.privProperties;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AutoDetectSourceLanguageConfig.prototype, "mode", {
        /**
         * @member AutoDetectSourceLanguageConfig.prototype.mode
         * @function
         * @public
         * @param {LanguageIdMode} mode LID mode desired.
         * @summary Sets LID operation to desired mode
         */ set: function(mode) {
            if (mode === $lf3Sn.LanguageIdMode.Continuous) {
                this.privProperties.setProperty($hM4QX.PropertyId.SpeechServiceConnection_RecognitionEndpointVersion, "2");
                this.privProperties.setProperty($hM4QX.PropertyId.SpeechServiceConnection_LanguageIdMode, "Continuous");
            } else {
                this.privProperties.setProperty($hM4QX.PropertyId.SpeechServiceConnection_RecognitionEndpointVersion, "1");
                this.privProperties.setProperty($hM4QX.PropertyId.SpeechServiceConnection_LanguageIdMode, "AtStart");
            }
            this.privLanguageIdMode = mode;
        },
        enumerable: false,
        configurable: true
    });
    return AutoDetectSourceLanguageConfig;
}();
module.exports.AutoDetectSourceLanguageConfig = $9a6faa73e1bcbfb2$var$AutoDetectSourceLanguageConfig;

});
parcelRequire.register("lf3Sn", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LanguageIdMode = void 0;
/**
 * Language Identification mode
 * @class LanguageIdMode
 */ var $f76e016933c6702e$var$LanguageIdMode;
(function(LanguageIdMode) {
    /**
     * Detect language at audio start
     * @member LanguageIdMode.AtStart
     */ LanguageIdMode[LanguageIdMode["AtStart"] = 0] = "AtStart";
    /**
     * Continuously detect language
     * @member LanguageIdMode.Continuous
     */ LanguageIdMode[LanguageIdMode["Continuous"] = 1] = "Continuous";
})($f76e016933c6702e$var$LanguageIdMode = module.exports.LanguageIdMode || (module.exports.LanguageIdMode = {}));

});


parcelRequire.register("l9vJq", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.AutoDetectSourceLanguageResult = void 0;

var $gBGZx = parcelRequire("gBGZx");
/**
 * Output format
 * @class AutoDetectSourceLanguageResult
 */ var $f6630d7cb811d998$var$AutoDetectSourceLanguageResult = /** @class */ function() {
    function AutoDetectSourceLanguageResult(language, languageDetectionConfidence) {
        $gBGZx.Contracts.throwIfNullOrUndefined(language, "language");
        $gBGZx.Contracts.throwIfNullOrUndefined(languageDetectionConfidence, "languageDetectionConfidence");
        this.privLanguage = language;
        this.privLanguageDetectionConfidence = languageDetectionConfidence;
    }
    /**
     * Creates an instance of AutoDetectSourceLanguageResult object from a SpeechRecognitionResult instance.
     * @member AutoDetectSourceLanguageResult.fromResult
     * @function
     * @public
     * @param {SpeechRecognitionResult} result - The recognition result.
     * @returns {AutoDetectSourceLanguageResult} AutoDetectSourceLanguageResult object being created.
     */ AutoDetectSourceLanguageResult.fromResult = function(result) {
        return new AutoDetectSourceLanguageResult(result.language, result.languageDetectionConfidence);
    };
    Object.defineProperty(AutoDetectSourceLanguageResult.prototype, "language", {
        get: function() {
            return this.privLanguage;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AutoDetectSourceLanguageResult.prototype, "languageDetectionConfidence", {
        get: function() {
            return this.privLanguageDetectionConfidence;
        },
        enumerable: false,
        configurable: true
    });
    return AutoDetectSourceLanguageResult;
}();
module.exports.AutoDetectSourceLanguageResult = $f6630d7cb811d998$var$AutoDetectSourceLanguageResult;

});

parcelRequire.register("gEoih", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SourceLanguageConfig = void 0;

var $gBGZx = parcelRequire("gBGZx");
/**
 * Source Language configuration.
 * @class SourceLanguageConfig
 */ var $c1f33a0261a5e04e$var$SourceLanguageConfig = /** @class */ function() {
    function SourceLanguageConfig(language, endpointId) {
        $gBGZx.Contracts.throwIfNullOrUndefined(language, "language");
        this.privLanguage = language;
        this.privEndpointId = endpointId;
    }
    /**
     * @member SourceLanguageConfig.fromLanguage
     * @function
     * @public
     * @param {string} language language (eg. "en-US") value of config.
     * @param {string?} endpointId endpointId of model bound to given language of config.
     * @return {SourceLanguageConfig} Instance of SourceLanguageConfig
     * @summary Creates an instance of the SourceLanguageConfig with the given language and optional endpointId.
     * Added in version 1.13.0.
     */ SourceLanguageConfig.fromLanguage = function(language, endpointId) {
        return new SourceLanguageConfig(language, endpointId);
    };
    Object.defineProperty(SourceLanguageConfig.prototype, "language", {
        get: function() {
            return this.privLanguage;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SourceLanguageConfig.prototype, "endpointId", {
        get: function() {
            return this.privEndpointId;
        },
        enumerable: false,
        configurable: true
    });
    return SourceLanguageConfig;
}();
module.exports.SourceLanguageConfig = $c1f33a0261a5e04e$var$SourceLanguageConfig;

});

parcelRequire.register("eQcct", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
var $acdf62b92c0c5e3a$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SpeakerRecognitionCancellationDetails = module.exports.SpeakerRecognitionResult = module.exports.SpeakerRecognitionResultType = void 0;

var $dEkJU = parcelRequire("dEkJU");

var $hM4QX = parcelRequire("hM4QX");
var $acdf62b92c0c5e3a$var$SpeakerRecognitionResultType;
(function(SpeakerRecognitionResultType) {
    SpeakerRecognitionResultType[SpeakerRecognitionResultType["Verify"] = 0] = "Verify";
    SpeakerRecognitionResultType[SpeakerRecognitionResultType["Identify"] = 1] = "Identify";
})($acdf62b92c0c5e3a$var$SpeakerRecognitionResultType = module.exports.SpeakerRecognitionResultType || (module.exports.SpeakerRecognitionResultType = {}));
/**
 * Output format
 * @class SpeakerRecognitionResult
 */ var $acdf62b92c0c5e3a$var$SpeakerRecognitionResult = /** @class */ function() {
    function SpeakerRecognitionResult(response, resultReason, cancellationErrorCode, errorDetails) {
        if (resultReason === void 0) resultReason = $hM4QX.ResultReason.RecognizedSpeaker;
        if (cancellationErrorCode === void 0) cancellationErrorCode = $hM4QX.CancellationErrorCode.NoError;
        if (errorDetails === void 0) errorDetails = "";
        this.privProperties = new $hM4QX.PropertyCollection();
        var resultType = response.scenario === "TextIndependentIdentification" ? $acdf62b92c0c5e3a$var$SpeakerRecognitionResultType.Identify : $acdf62b92c0c5e3a$var$SpeakerRecognitionResultType.Verify;
        this.privReason = resultReason;
        if (this.privReason !== $hM4QX.ResultReason.Canceled) {
            if (resultType === $acdf62b92c0c5e3a$var$SpeakerRecognitionResultType.Identify) {
                this.privProfileId = response.identificationResult.identifiedProfile.profileId;
                this.privScore = response.identificationResult.identifiedProfile.score;
                this.privReason = $hM4QX.ResultReason.RecognizedSpeakers;
            } else {
                this.privScore = response.verificationResult.score;
                if (response.verificationResult.recognitionResult.toLowerCase() !== "accept") this.privReason = $hM4QX.ResultReason.NoMatch;
                if (response.verificationResult.profileId !== undefined && response.verificationResult.profileId !== "") this.privProfileId = response.verificationResult.profileId;
            }
        } else {
            this.privErrorDetails = errorDetails;
            this.privProperties.setProperty($dEkJU.CancellationErrorCodePropertyName, $hM4QX.CancellationErrorCode[cancellationErrorCode]);
        }
        this.privProperties.setProperty($hM4QX.PropertyId.SpeechServiceResponse_JsonResult, JSON.stringify(response));
    }
    Object.defineProperty(SpeakerRecognitionResult.prototype, "properties", {
        get: function() {
            return this.privProperties;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SpeakerRecognitionResult.prototype, "reason", {
        get: function() {
            return this.privReason;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SpeakerRecognitionResult.prototype, "profileId", {
        get: function() {
            return this.privProfileId;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SpeakerRecognitionResult.prototype, "errorDetails", {
        get: function() {
            return this.privErrorDetails;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SpeakerRecognitionResult.prototype, "score", {
        get: function() {
            return this.privScore;
        },
        enumerable: false,
        configurable: true
    });
    return SpeakerRecognitionResult;
}();
module.exports.SpeakerRecognitionResult = $acdf62b92c0c5e3a$var$SpeakerRecognitionResult;
/**
 * @class SpeakerRecognitionCancellationDetails
 */ var $acdf62b92c0c5e3a$var$SpeakerRecognitionCancellationDetails = /** @class */ function(_super) {
    $acdf62b92c0c5e3a$var$__extends(SpeakerRecognitionCancellationDetails, _super);
    function SpeakerRecognitionCancellationDetails(reason, errorDetails, errorCode) {
        return _super.call(this, reason, errorDetails, errorCode) || this;
    }
    /**
     * Creates an instance of SpeakerRecognitionCancellationDetails object for the canceled SpeakerRecognitionResult
     * @member SpeakerRecognitionCancellationDetails.fromResult
     * @function
     * @public
     * @param {SpeakerRecognitionResult} result - The result that was canceled.
     * @returns {SpeakerRecognitionCancellationDetails} The cancellation details object being created.
     */ SpeakerRecognitionCancellationDetails.fromResult = function(result) {
        var reason = $hM4QX.CancellationReason.Error;
        var errorCode = $hM4QX.CancellationErrorCode.NoError;
        if (!!result.properties) errorCode = $hM4QX.CancellationErrorCode[result.properties.getProperty($dEkJU.CancellationErrorCodePropertyName, $hM4QX.CancellationErrorCode[$hM4QX.CancellationErrorCode.NoError])];
        return new SpeakerRecognitionCancellationDetails(reason, result.errorDetails, errorCode);
    };
    return SpeakerRecognitionCancellationDetails;
}($hM4QX.CancellationDetailsBase);
module.exports.SpeakerRecognitionCancellationDetails = $acdf62b92c0c5e3a$var$SpeakerRecognitionCancellationDetails;

});

parcelRequire.register("a9O70", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
// Multi-device Conversation is a Preview feature.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $k54oi = parcelRequire("k54oi");
Object.defineProperty(module.exports, "Conversation", {
    enumerable: true,
    get: function() {
        return $k54oi.Conversation;
    }
});
Object.defineProperty(module.exports, "ConversationImpl", {
    enumerable: true,
    get: function() {
        return $k54oi.ConversationImpl;
    }
});

var $lc5wu = parcelRequire("lc5wu");
Object.defineProperty(module.exports, "ConversationCommon", {
    enumerable: true,
    get: function() {
        return $lc5wu.ConversationCommon;
    }
});

var $22tM4 = parcelRequire("22tM4");
Object.defineProperty(module.exports, "ConversationExpirationEventArgs", {
    enumerable: true,
    get: function() {
        return $22tM4.ConversationExpirationEventArgs;
    }
});

var $eLehy = parcelRequire("eLehy");
Object.defineProperty(module.exports, "ConversationParticipantsChangedEventArgs", {
    enumerable: true,
    get: function() {
        return $eLehy.ConversationParticipantsChangedEventArgs;
    }
});

var $2dbDg = parcelRequire("2dbDg");
Object.defineProperty(module.exports, "ConversationTranslationCanceledEventArgs", {
    enumerable: true,
    get: function() {
        return $2dbDg.ConversationTranslationCanceledEventArgs;
    }
});

var $1mfN5 = parcelRequire("1mfN5");
Object.defineProperty(module.exports, "ConversationTranslationEventArgs", {
    enumerable: true,
    get: function() {
        return $1mfN5.ConversationTranslationEventArgs;
    }
});

var $1k8xi = parcelRequire("1k8xi");
Object.defineProperty(module.exports, "ConversationTranslationResult", {
    enumerable: true,
    get: function() {
        return $1k8xi.ConversationTranslationResult;
    }
});

var $ipwIr = parcelRequire("ipwIr");
Object.defineProperty(module.exports, "ConversationTranslator", {
    enumerable: true,
    get: function() {
        return $ipwIr.ConversationTranslator;
    }
});

var $4D0NF = parcelRequire("4D0NF");
Object.defineProperty(module.exports, "ConversationTranscriber", {
    enumerable: true,
    get: function() {
        return $4D0NF.ConversationTranscriber;
    }
});

var $dHLFU = parcelRequire("dHLFU");
Object.defineProperty(module.exports, "Participant", {
    enumerable: true,
    get: function() {
        return $dHLFU.Participant;
    }
});
Object.defineProperty(module.exports, "User", {
    enumerable: true,
    get: function() {
        return $dHLFU.User;
    }
});

var $hCN1B = parcelRequire("hCN1B");
Object.defineProperty(module.exports, "ParticipantChangedReason", {
    enumerable: true,
    get: function() {
        return $hCN1B.ParticipantChangedReason;
    }
});

});
parcelRequire.register("k54oi", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
// Multi-device Conversation is a Preview feature.
var $e9e7ae32d054fa76$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $e9e7ae32d054fa76$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $e9e7ae32d054fa76$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $e9e7ae32d054fa76$var$__spreadArrays = module.exports && module.exports.__spreadArrays || function() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ConversationImpl = module.exports.Conversation = void 0;

var $dEkJU = parcelRequire("dEkJU");

var $em8BD = parcelRequire("em8BD");

var $gBGZx = parcelRequire("gBGZx");

var $hM4QX = parcelRequire("hM4QX");
var $e9e7ae32d054fa76$var$Conversation = /** @class */ function() {
    function Conversation() {
        return;
    }
    /**
     * Create a conversation
     * @param speechConfig
     * @param cb
     * @param err
     */ Conversation.createConversationAsync = function(speechConfig, arg2, arg3, arg4) {
        var _this = this;
        $gBGZx.Contracts.throwIfNullOrUndefined(speechConfig, $dEkJU.ConversationConnectionConfig.restErrors.invalidArgs.replace("{arg}", "config"));
        $gBGZx.Contracts.throwIfNullOrUndefined(speechConfig.region, $dEkJU.ConversationConnectionConfig.restErrors.invalidArgs.replace("{arg}", "SpeechServiceConnection_Region"));
        if (!speechConfig.subscriptionKey && !speechConfig.getProperty($hM4QX.PropertyId[$hM4QX.PropertyId.SpeechServiceAuthorization_Token])) $gBGZx.Contracts.throwIfNullOrUndefined(speechConfig.subscriptionKey, $dEkJU.ConversationConnectionConfig.restErrors.invalidArgs.replace("{arg}", "SpeechServiceConnection_Key"));
        var conversationImpl;
        var cb;
        var err;
        if (typeof arg2 === "string") {
            conversationImpl = new $e9e7ae32d054fa76$var$ConversationImpl(speechConfig, arg2);
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            $em8BD.marshalPromiseToCallbacks(function() {
                return $e9e7ae32d054fa76$var$__awaiter(_this, void 0, void 0, function() {
                    return $e9e7ae32d054fa76$var$__generator(this, function(_a) {
                        return [
                            2 /*return*/ 
                        ];
                    });
                });
            }(), arg3, arg4);
        } else {
            conversationImpl = new $e9e7ae32d054fa76$var$ConversationImpl(speechConfig);
            cb = arg2;
            err = arg3;
            conversationImpl.createConversationAsync(function() {
                if (!!cb) cb();
            }, function(error) {
                if (!!err) err(error);
            });
        }
        return conversationImpl;
    };
    return Conversation;
}();
module.exports.Conversation = $e9e7ae32d054fa76$var$Conversation;
var $e9e7ae32d054fa76$var$ConversationImpl = /** @class */ function(_super) {
    $e9e7ae32d054fa76$var$__extends(ConversationImpl, _super);
    /**
     * Create a conversation impl
     * @param speechConfig
     * @param {string} id - optional conversationId
     */ function ConversationImpl(speechConfig, id) {
        var _this = _super.call(this) || this;
        _this.privErrors = $dEkJU.ConversationConnectionConfig.restErrors;
        /** websocket callbacks */ /* eslint-disable @typescript-eslint/typedef */ _this.onConnected = function(e) {
            var _a;
            _this.privIsConnected = true;
            try {
                if (!!((_a = _this.privConversationTranslator) === null || _a === void 0 ? void 0 : _a.sessionStarted)) _this.privConversationTranslator.sessionStarted(_this.privConversationTranslator, e);
            } catch (e) {
            //
            }
        };
        _this.onDisconnected = function(e) {
            var _a;
            try {
                if (!!((_a = _this.privConversationTranslator) === null || _a === void 0 ? void 0 : _a.sessionStopped)) _this.privConversationTranslator.sessionStopped(_this.privConversationTranslator, e);
            } catch (e) {
            //
            } finally{
                _this.close(false);
            }
        };
        _this.onCanceled = function(r, e) {
            var _a;
            try {
                if (!!((_a = _this.privConversationTranslator) === null || _a === void 0 ? void 0 : _a.canceled)) _this.privConversationTranslator.canceled(_this.privConversationTranslator, e);
            } catch (e) {
            //
            }
        };
        _this.onParticipantUpdateCommandReceived = function(r, e) {
            try {
                var updatedParticipant = _this.privParticipants.getParticipant(e.id);
                if (updatedParticipant !== undefined) {
                    switch(e.key){
                        case $dEkJU.ConversationTranslatorCommandTypes.changeNickname:
                            updatedParticipant.displayName = e.value;
                            break;
                        case $dEkJU.ConversationTranslatorCommandTypes.setUseTTS:
                            updatedParticipant.isUsingTts = e.value;
                            break;
                        case $dEkJU.ConversationTranslatorCommandTypes.setProfanityFiltering:
                            updatedParticipant.profanity = e.value;
                            break;
                        case $dEkJU.ConversationTranslatorCommandTypes.setMute:
                            updatedParticipant.isMuted = e.value;
                            break;
                        case $dEkJU.ConversationTranslatorCommandTypes.setTranslateToLanguages:
                            updatedParticipant.translateToLanguages = e.value;
                            break;
                    }
                    _this.privParticipants.addOrUpdateParticipant(updatedParticipant);
                    if (!!_this.privConversationTranslator) _this.privConversationTranslator.participantsChanged(_this.privConversationTranslator, new $hM4QX.ConversationParticipantsChangedEventArgs($hM4QX.ParticipantChangedReason.Updated, [
                        _this.toParticipant(updatedParticipant)
                    ], e.sessionId));
                }
            } catch (e) {
            //
            }
        };
        _this.onLockRoomCommandReceived = function() {
        // TODO
        };
        _this.onMuteAllCommandReceived = function(r, e) {
            try {
                _this.privParticipants.participants.forEach(function(p) {
                    return p.isMuted = p.isHost ? false : e.isMuted;
                });
                if (!!_this.privConversationTranslator) _this.privConversationTranslator.participantsChanged(_this.privConversationTranslator, new $hM4QX.ConversationParticipantsChangedEventArgs($hM4QX.ParticipantChangedReason.Updated, _this.toParticipants(false), e.sessionId));
            } catch (e) {
            //
            }
        };
        _this.onParticipantJoinCommandReceived = function(r, e) {
            try {
                var newParticipant = _this.privParticipants.addOrUpdateParticipant(e.participant);
                if (newParticipant !== undefined) {
                    if (!!_this.privConversationTranslator) _this.privConversationTranslator.participantsChanged(_this.privConversationTranslator, new $hM4QX.ConversationParticipantsChangedEventArgs($hM4QX.ParticipantChangedReason.JoinedConversation, [
                        _this.toParticipant(newParticipant)
                    ], e.sessionId));
                }
            } catch (e) {
            //
            }
        };
        _this.onParticipantLeaveCommandReceived = function(r, e) {
            try {
                var ejectedParticipant = _this.privParticipants.getParticipant(e.participant.id);
                if (ejectedParticipant !== undefined) {
                    // remove the participant from the internal participants list
                    _this.privParticipants.deleteParticipant(e.participant.id);
                    if (!!_this.privConversationTranslator) // notify subscribers that the participant has left the conversation
                    _this.privConversationTranslator.participantsChanged(_this.privConversationTranslator, new $hM4QX.ConversationParticipantsChangedEventArgs($hM4QX.ParticipantChangedReason.LeftConversation, [
                        _this.toParticipant(ejectedParticipant)
                    ], e.sessionId));
                }
            } catch (e) {
            //
            }
        };
        _this.onTranslationReceived = function(r, e) {
            try {
                switch(e.command){
                    case $dEkJU.ConversationTranslatorMessageTypes.final:
                        if (!!_this.privConversationTranslator) _this.privConversationTranslator.transcribed(_this.privConversationTranslator, new $hM4QX.ConversationTranslationEventArgs(e.payload, undefined, e.sessionId));
                        break;
                    case $dEkJU.ConversationTranslatorMessageTypes.partial:
                        if (!!_this.privConversationTranslator) _this.privConversationTranslator.transcribing(_this.privConversationTranslator, new $hM4QX.ConversationTranslationEventArgs(e.payload, undefined, e.sessionId));
                        break;
                    case $dEkJU.ConversationTranslatorMessageTypes.instantMessage:
                        if (!!_this.privConversationTranslator) _this.privConversationTranslator.textMessageReceived(_this.privConversationTranslator, new $hM4QX.ConversationTranslationEventArgs(e.payload, undefined, e.sessionId));
                        break;
                }
            } catch (e) {
            //
            }
        };
        _this.onParticipantsListReceived = function(r, e) {
            var _a;
            try {
                // check if the session token needs to be updated
                if (e.sessionToken !== undefined && e.sessionToken !== null) _this.privRoom.token = e.sessionToken;
                // save the participants
                _this.privParticipants.participants = $e9e7ae32d054fa76$var$__spreadArrays(e.participants);
                // enable the conversation
                if (_this.privParticipants.me !== undefined) _this.privIsReady = true;
                if (!!_this.privConversationTranslator) _this.privConversationTranslator.participantsChanged(_this.privConversationTranslator, new $hM4QX.ConversationParticipantsChangedEventArgs($hM4QX.ParticipantChangedReason.JoinedConversation, _this.toParticipants(true), e.sessionId));
                // if this is the host, update the nickname if needed
                if (_this.me.isHost) {
                    var nickname = (_a = _this.privConversationTranslator) === null || _a === void 0 ? void 0 : _a.properties.getProperty($hM4QX.PropertyId.ConversationTranslator_Name);
                    if (nickname !== undefined && nickname.length > 0 && nickname !== _this.me.displayName) // issue a change nickname request
                    _this.changeNicknameAsync(nickname);
                }
            } catch (e) {
            //
            }
        };
        _this.onConversationExpiration = function(r, e) {
            try {
                if (!!_this.privConversationTranslator) _this.privConversationTranslator.conversationExpiration(_this.privConversationTranslator, e);
            } catch (e) {
            //
            }
        };
        _this.privIsConnected = false;
        _this.privIsDisposed = false;
        _this.privConversationId = "";
        _this.privProperties = new $hM4QX.PropertyCollection();
        _this.privManager = new $dEkJU.ConversationManager();
        // check the speech language
        var language = speechConfig.getProperty($hM4QX.PropertyId[$hM4QX.PropertyId.SpeechServiceConnection_RecoLanguage]);
        if (!language) speechConfig.setProperty($hM4QX.PropertyId[$hM4QX.PropertyId.SpeechServiceConnection_RecoLanguage], $dEkJU.ConversationConnectionConfig.defaultLanguageCode);
        _this.privLanguage = speechConfig.getProperty($hM4QX.PropertyId[$hM4QX.PropertyId.SpeechServiceConnection_RecoLanguage]);
        if (!id) {
            // check the target language(s)
            if (speechConfig.targetLanguages.length === 0) speechConfig.addTargetLanguage(_this.privLanguage);
            // check the profanity setting: speech and conversationTranslator should be in sync
            var profanity = speechConfig.getProperty($hM4QX.PropertyId[$hM4QX.PropertyId.SpeechServiceResponse_ProfanityOption]);
            if (!profanity) speechConfig.setProfanity($hM4QX.ProfanityOption.Masked);
            // check the nickname: it should pass this regex: ^\w+([\s-][\w\(\)]+)*$"
            // TODO: specify the regex required. Nicknames must be unique or get the duplicate nickname error
            // TODO: check what the max length is and if a truncation is required or if the service handles it without an error
            var hostNickname = speechConfig.getProperty($hM4QX.PropertyId[$hM4QX.PropertyId.ConversationTranslator_Name]);
            if (hostNickname === undefined || hostNickname === null) hostNickname = "Host";
            $gBGZx.Contracts.throwIfNullOrTooLong(hostNickname, "nickname", 50);
            $gBGZx.Contracts.throwIfNullOrTooShort(hostNickname, "nickname", 2);
            speechConfig.setProperty($hM4QX.PropertyId[$hM4QX.PropertyId.ConversationTranslator_Name], hostNickname);
        } else _this.privConversationId = id;
        // save the speech config for future usage
        _this.privConfig = speechConfig;
        // save the config properties
        var configImpl = speechConfig;
        $gBGZx.Contracts.throwIfNull(configImpl, "speechConfig");
        _this.privProperties = configImpl.properties.clone();
        _this.privIsConnected = false;
        _this.privParticipants = new $dEkJU.InternalParticipants();
        _this.privIsReady = false;
        _this.privTextMessageMaxLength = 1000;
        return _this;
    }
    Object.defineProperty(ConversationImpl.prototype, "room", {
        // get the internal data about a conversation
        get: function() {
            return this.privRoom;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ConversationImpl.prototype, "connection", {
        // get the wrapper for connecting to the websockets
        get: function() {
            return this.privConversationRecognizer; // this.privConnection;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ConversationImpl.prototype, "config", {
        // get the config
        get: function() {
            return this.privConfig;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ConversationImpl.prototype, "conversationId", {
        // get the conversation Id
        get: function() {
            return this.privRoom ? this.privRoom.roomId : this.privConversationId;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ConversationImpl.prototype, "properties", {
        // get the properties
        get: function() {
            return this.privProperties;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ConversationImpl.prototype, "speechRecognitionLanguage", {
        // get the speech language
        get: function() {
            return this.privLanguage;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ConversationImpl.prototype, "isMutedByHost", {
        get: function() {
            var _a, _b;
            return ((_a = this.privParticipants.me) === null || _a === void 0 ? void 0 : _a.isHost) ? false : (_b = this.privParticipants.me) === null || _b === void 0 ? void 0 : _b.isMuted;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ConversationImpl.prototype, "isConnected", {
        get: function() {
            return this.privIsConnected && this.privIsReady;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ConversationImpl.prototype, "participants", {
        get: function() {
            return this.toParticipants(true);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ConversationImpl.prototype, "me", {
        get: function() {
            return this.toParticipant(this.privParticipants.me);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ConversationImpl.prototype, "host", {
        get: function() {
            return this.toParticipant(this.privParticipants.host);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ConversationImpl.prototype, "transcriberRecognizer", {
        get: function() {
            return this.privTranscriberRecognizer;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ConversationImpl.prototype, "conversationInfo", {
        get: function() {
            var convId = this.conversationId;
            var p = this.participants.map(function(part) {
                return {
                    id: part.id,
                    preferredLanguage: part.preferredLanguage,
                    voice: part.voice
                };
            });
            var props = {};
            for(var _i = 0, _a = $dEkJU.ConversationConnectionConfig.transcriptionEventKeys; _i < _a.length; _i++){
                var key = _a[_i];
                var val = this.properties.getProperty(key, "");
                if (val !== "") props[key] = val;
            }
            var info = {
                id: convId,
                participants: p,
                conversationProperties: props
            };
            return info;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ConversationImpl.prototype, "canSend", {
        get: function() {
            var _a;
            return this.privIsConnected && !((_a = this.privParticipants.me) === null || _a === void 0 ? void 0 : _a.isMuted);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ConversationImpl.prototype, "canSendAsHost", {
        get: function() {
            var _a;
            return this.privIsConnected && ((_a = this.privParticipants.me) === null || _a === void 0 ? void 0 : _a.isHost);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ConversationImpl.prototype, "authorizationToken", {
        // get / set the speech auth token
        // eslint-disable-next-line @typescript-eslint/member-ordering
        get: function() {
            return this.privToken;
        },
        set: function(value) {
            $gBGZx.Contracts.throwIfNullOrWhitespace(value, "authorizationToken");
            this.privToken = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ConversationImpl.prototype, "conversationTranslator", {
        set: function(conversationTranslator) {
            this.privConversationTranslator = conversationTranslator;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Create a new conversation as Host
     * @param cb
     * @param err
     */ ConversationImpl.prototype.createConversationAsync = function(cb, err) {
        var _this = this;
        try {
            if (!!this.privConversationRecognizer) this.handleError(new Error(this.privErrors.permissionDeniedStart), err);
            this.privManager.createOrJoin(this.privProperties, undefined, function(room) {
                if (!room) _this.handleError(new Error(_this.privErrors.permissionDeniedConnect), err);
                _this.privRoom = room;
                _this.handleCallback(cb, err);
            }, function(error) {
                _this.handleError(error, err);
            });
        } catch (error) {
            this.handleError(error, err);
        }
    };
    /**
     * Starts a new conversation as host.
     * @param cb
     * @param err
     */ ConversationImpl.prototype.startConversationAsync = function(cb, err) {
        var _this = this;
        try {
            // check if there is already a recognizer
            if (!!this.privConversationRecognizer) this.handleError(new Error(this.privErrors.permissionDeniedStart), err);
            // check if there is conversation data available
            $gBGZx.Contracts.throwIfNullOrUndefined(this.privRoom, this.privErrors.permissionDeniedConnect);
            // connect to the conversation websocket
            this.privParticipants.meId = this.privRoom.participantId;
            this.privConversationRecognizer = $dEkJU.ConversationRecognizerFactory.fromConfig(this, this.privConfig);
            // Because ConversationTranslator manually sets up and manages the connection, Conversation
            // has to forward serviceRecognizer connection events that usually get passed automatically
            this.privConversationRecognizer.connected = this.onConnected;
            this.privConversationRecognizer.disconnected = this.onDisconnected;
            this.privConversationRecognizer.canceled = this.onCanceled;
            this.privConversationRecognizer.participantUpdateCommandReceived = this.onParticipantUpdateCommandReceived;
            this.privConversationRecognizer.lockRoomCommandReceived = this.onLockRoomCommandReceived;
            this.privConversationRecognizer.muteAllCommandReceived = this.onMuteAllCommandReceived;
            this.privConversationRecognizer.participantJoinCommandReceived = this.onParticipantJoinCommandReceived;
            this.privConversationRecognizer.participantLeaveCommandReceived = this.onParticipantLeaveCommandReceived;
            this.privConversationRecognizer.translationReceived = this.onTranslationReceived;
            this.privConversationRecognizer.participantsListReceived = this.onParticipantsListReceived;
            this.privConversationRecognizer.conversationExpiration = this.onConversationExpiration;
            this.privConversationRecognizer.connect(this.privRoom.token, function() {
                _this.handleCallback(cb, err);
            }, function(error) {
                _this.handleError(error, err);
            });
        } catch (error) {
            this.handleError(error, err);
        }
    };
    /**
     * Join a conversation as a participant.
     * @param { IParticipant } participant - participant to add
     * @param cb
     * @param err
     */ ConversationImpl.prototype.addParticipantAsync = function(participant, cb, err) {
        $gBGZx.Contracts.throwIfNullOrUndefined(participant, "Participant");
        $em8BD.marshalPromiseToCallbacks(this.addParticipantImplAsync(participant), cb, err);
    };
    /**
     * Join a conversation as a participant.
     * @param conversation
     * @param nickname
     * @param lang
     * @param cb
     * @param err
     */ ConversationImpl.prototype.joinConversationAsync = function(conversationId, nickname, lang, cb, err) {
        var _this = this;
        try {
            // TODO
            // if (!!this.privConversationRecognizer) {
            //     throw new Error(this.privErrors.permissionDeniedStart);
            // }
            $gBGZx.Contracts.throwIfNullOrWhitespace(conversationId, this.privErrors.invalidArgs.replace("{arg}", "conversationId"));
            $gBGZx.Contracts.throwIfNullOrWhitespace(nickname, this.privErrors.invalidArgs.replace("{arg}", "nickname"));
            $gBGZx.Contracts.throwIfNullOrWhitespace(lang, this.privErrors.invalidArgs.replace("{arg}", "language"));
            // join the conversation
            this.privManager.createOrJoin(this.privProperties, conversationId, function(room) {
                $gBGZx.Contracts.throwIfNullOrUndefined(room, _this.privErrors.permissionDeniedConnect);
                _this.privRoom = room;
                _this.privConfig.authorizationToken = room.cognitiveSpeechAuthToken;
                // join callback
                if (!!cb) cb(room.cognitiveSpeechAuthToken);
            }, function(error) {
                _this.handleError(error, err);
            });
        } catch (error) {
            this.handleError(error, err);
        }
    };
    /**
     * Deletes a conversation
     * @param cb
     * @param err
     */ ConversationImpl.prototype.deleteConversationAsync = function(cb, err) {
        $em8BD.marshalPromiseToCallbacks(this.deleteConversationImplAsync(), cb, err);
    };
    ConversationImpl.prototype.deleteConversationImplAsync = function() {
        return $e9e7ae32d054fa76$var$__awaiter(this, void 0, void 0, function() {
            return $e9e7ae32d054fa76$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        $gBGZx.Contracts.throwIfNullOrUndefined(this.privProperties, this.privErrors.permissionDeniedConnect);
                        $gBGZx.Contracts.throwIfNullOrWhitespace(this.privRoom.token, this.privErrors.permissionDeniedConnect);
                        return [
                            4 /*yield*/ ,
                            this.privManager.leave(this.privProperties, this.privRoom.token)
                        ];
                    case 1:
                        _a.sent();
                        this.dispose();
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * Issues a request to close the client websockets
     * @param cb
     * @param err
     */ ConversationImpl.prototype.endConversationAsync = function(cb, err) {
        $em8BD.marshalPromiseToCallbacks(this.endConversationImplAsync(), cb, err);
    };
    ConversationImpl.prototype.endConversationImplAsync = function() {
        return this.close(true);
    };
    /**
     * Issues a request to lock the conversation
     * @param cb
     * @param err
     */ ConversationImpl.prototype.lockConversationAsync = function(cb, err) {
        var _this = this;
        try {
            $gBGZx.Contracts.throwIfDisposed(this.privIsDisposed);
            $gBGZx.Contracts.throwIfDisposed(this.privConversationRecognizer.isDisposed());
            $gBGZx.Contracts.throwIfNullOrUndefined(this.privRoom, this.privErrors.permissionDeniedSend);
            if (!this.canSendAsHost) this.handleError(new Error(this.privErrors.permissionDeniedConversation.replace("{command}", "lock")), err);
            if (!!this.privConversationRecognizer) this.privConversationRecognizer.sendRequest(this.getLockCommand(true), function() {
                _this.handleCallback(cb, err);
            }, function(error) {
                _this.handleError(error, err);
            });
        } catch (error) {
            this.handleError(error, err);
        }
    };
    /**
     * Issues a request to mute the conversation
     * @param cb
     * @param err
     */ ConversationImpl.prototype.muteAllParticipantsAsync = function(cb, err) {
        var _this = this;
        try {
            $gBGZx.Contracts.throwIfDisposed(this.privIsDisposed);
            $gBGZx.Contracts.throwIfDisposed(this.privConversationRecognizer.isDisposed());
            $gBGZx.Contracts.throwIfNullOrUndefined(this.privConversationRecognizer, this.privErrors.permissionDeniedSend);
            $gBGZx.Contracts.throwIfNullOrUndefined(this.privRoom, this.privErrors.permissionDeniedSend);
            // check the user's permissions
            if (!this.canSendAsHost) this.handleError(new Error(this.privErrors.permissionDeniedConversation.replace("{command}", "mute")), err);
            if (!!this.privConversationRecognizer) this.privConversationRecognizer.sendRequest(this.getMuteAllCommand(true), function() {
                _this.handleCallback(cb, err);
            }, function(error) {
                _this.handleError(error, err);
            });
        } catch (error) {
            this.handleError(error, err);
        }
    };
    /**
     * Issues a request to mute a participant in the conversation
     * @param userId
     * @param cb
     * @param err
     */ ConversationImpl.prototype.muteParticipantAsync = function(userId, cb, err) {
        var _this = this;
        try {
            $gBGZx.Contracts.throwIfDisposed(this.privIsDisposed);
            $gBGZx.Contracts.throwIfDisposed(this.privConversationRecognizer.isDisposed());
            $gBGZx.Contracts.throwIfNullOrWhitespace(userId, this.privErrors.invalidArgs.replace("{arg}", "userId"));
            $gBGZx.Contracts.throwIfNullOrUndefined(this.privRoom, this.privErrors.permissionDeniedSend);
            // check the connection is open (host + participant can perform the mute command)
            if (!this.canSend) this.handleError(new Error(this.privErrors.permissionDeniedSend), err);
            // if not host, check the participant is not muting another participant
            if (!this.me.isHost && this.me.id !== userId) this.handleError(new Error(this.privErrors.permissionDeniedParticipant.replace("{command}", "mute")), err);
            // check the user exists
            var exists = this.privParticipants.getParticipantIndex(userId);
            if (exists === -1) this.handleError(new Error(this.privErrors.invalidParticipantRequest), err);
            if (!!this.privConversationRecognizer) this.privConversationRecognizer.sendRequest(this.getMuteCommand(userId, true), function() {
                _this.handleCallback(cb, err);
            }, function(error) {
                _this.handleError(error, err);
            });
        } catch (error) {
            this.handleError(error, err);
        }
    };
    /**
     * Issues a request to remove a participant from the conversation
     * @param userId
     * @param cb
     * @param err
     */ ConversationImpl.prototype.removeParticipantAsync = function(userId, cb, err) {
        var _this = this;
        try {
            $gBGZx.Contracts.throwIfDisposed(this.privIsDisposed);
            if (!!this.privTranscriberRecognizer && userId.hasOwnProperty("id")) // Assume this is a transcription participant
            $em8BD.marshalPromiseToCallbacks(this.removeParticipantImplAsync(userId), cb, err);
            else {
                $gBGZx.Contracts.throwIfDisposed(this.privConversationRecognizer.isDisposed());
                $gBGZx.Contracts.throwIfNullOrUndefined(this.privRoom, this.privErrors.permissionDeniedSend);
                if (!this.canSendAsHost) this.handleError(new Error(this.privErrors.permissionDeniedParticipant.replace("{command}", "remove")), err);
                var participantId_1 = "";
                if (typeof userId === "string") participantId_1 = userId;
                else if (userId.hasOwnProperty("id")) {
                    var participant = userId;
                    participantId_1 = participant.id;
                } else if (userId.hasOwnProperty("userId")) {
                    var user = userId;
                    participantId_1 = user.userId;
                }
                $gBGZx.Contracts.throwIfNullOrWhitespace(participantId_1, this.privErrors.invalidArgs.replace("{arg}", "userId"));
                // check the participant exists
                var index = this.participants.findIndex(function(p) {
                    return p.id === participantId_1;
                });
                if (index === -1) this.handleError(new Error(this.privErrors.invalidParticipantRequest), err);
                if (!!this.privConversationRecognizer) this.privConversationRecognizer.sendRequest(this.getEjectCommand(participantId_1), function() {
                    _this.handleCallback(cb, err);
                }, function(error) {
                    _this.handleError(error, err);
                });
            }
        } catch (error) {
            this.handleError(error, err);
        }
    };
    /**
     * Issues a request to unlock the conversation
     * @param cb
     * @param err
     */ ConversationImpl.prototype.unlockConversationAsync = function(cb, err) {
        var _this = this;
        try {
            $gBGZx.Contracts.throwIfDisposed(this.privIsDisposed);
            $gBGZx.Contracts.throwIfDisposed(this.privConversationRecognizer.isDisposed());
            $gBGZx.Contracts.throwIfNullOrUndefined(this.privRoom, this.privErrors.permissionDeniedSend);
            if (!this.canSendAsHost) this.handleError(new Error(this.privErrors.permissionDeniedConversation.replace("{command}", "unlock")), err);
            if (!!this.privConversationRecognizer) this.privConversationRecognizer.sendRequest(this.getLockCommand(false), function() {
                _this.handleCallback(cb, err);
            }, function(error) {
                _this.handleError(error, err);
            });
        } catch (error) {
            this.handleError(error, err);
        }
    };
    /**
     * Issues a request to unmute all participants in the conversation
     * @param cb
     * @param err
     */ ConversationImpl.prototype.unmuteAllParticipantsAsync = function(cb, err) {
        var _this = this;
        try {
            $gBGZx.Contracts.throwIfDisposed(this.privIsDisposed);
            $gBGZx.Contracts.throwIfDisposed(this.privConversationRecognizer.isDisposed());
            $gBGZx.Contracts.throwIfNullOrUndefined(this.privRoom, this.privErrors.permissionDeniedSend);
            if (!this.canSendAsHost) this.handleError(new Error(this.privErrors.permissionDeniedConversation.replace("{command}", "unmute all")), err);
            if (!!this.privConversationRecognizer) this.privConversationRecognizer.sendRequest(this.getMuteAllCommand(false), function() {
                _this.handleCallback(cb, err);
            }, function(error) {
                _this.handleError(error, err);
            });
        } catch (error) {
            this.handleError(error, err);
        }
    };
    /**
     * Issues a request to unmute a participant in the conversation
     * @param userId
     * @param cb
     * @param err
     */ ConversationImpl.prototype.unmuteParticipantAsync = function(userId, cb, err) {
        var _this = this;
        try {
            $gBGZx.Contracts.throwIfDisposed(this.privIsDisposed);
            $gBGZx.Contracts.throwIfDisposed(this.privConversationRecognizer.isDisposed());
            $gBGZx.Contracts.throwIfNullOrWhitespace(userId, this.privErrors.invalidArgs.replace("{arg}", "userId"));
            $gBGZx.Contracts.throwIfNullOrUndefined(this.privRoom, this.privErrors.permissionDeniedSend);
            // check the connection is open (host + participant can perform the mute command)
            if (!this.canSend) this.handleError(new Error(this.privErrors.permissionDeniedSend), err);
            // if not host, check the participant is not muting another participant
            if (!this.me.isHost && this.me.id !== userId) this.handleError(new Error(this.privErrors.permissionDeniedParticipant.replace("{command}", "mute")), err);
            // check the user exists
            var exists = this.privParticipants.getParticipantIndex(userId);
            if (exists === -1) this.handleError(new Error(this.privErrors.invalidParticipantRequest), err);
            if (!!this.privConversationRecognizer) this.privConversationRecognizer.sendRequest(this.getMuteCommand(userId, false), function() {
                _this.handleCallback(cb, err);
            }, function(error) {
                _this.handleError(error, err);
            });
        } catch (error) {
            this.handleError(error, err);
        }
    };
    /**
     * Send a text message
     * @param message
     * @param cb
     * @param err
     */ ConversationImpl.prototype.sendTextMessageAsync = function(message, cb, err) {
        var _this = this;
        try {
            $gBGZx.Contracts.throwIfDisposed(this.privIsDisposed);
            $gBGZx.Contracts.throwIfDisposed(this.privConversationRecognizer.isDisposed());
            $gBGZx.Contracts.throwIfNullOrWhitespace(message, this.privErrors.invalidArgs.replace("{arg}", "message"));
            $gBGZx.Contracts.throwIfNullOrUndefined(this.privRoom, this.privErrors.permissionDeniedSend);
            if (!this.canSend) this.handleError(new Error(this.privErrors.permissionDeniedSend), err);
            // TODO: is a max length check required?
            if (message.length > this.privTextMessageMaxLength) this.handleError(new Error(this.privErrors.invalidArgs.replace("{arg}", "message length")), err);
            if (!!this.privConversationRecognizer) this.privConversationRecognizer.sendRequest(this.getMessageCommand(message), function() {
                _this.handleCallback(cb, err);
            }, function(error) {
                _this.handleError(error, err);
            });
        } catch (error) {
            this.handleError(error, err);
        }
    };
    /**
     * Set translated to languages
     * @param {string[]} languages - languages to translate to
     * @param cb
     * @param err
     */ ConversationImpl.prototype.setTranslatedLanguagesAsync = function(languages, cb, err) {
        var _this = this;
        try {
            $gBGZx.Contracts.throwIfDisposed(this.privIsDisposed);
            $gBGZx.Contracts.throwIfDisposed(this.privConversationRecognizer.isDisposed());
            $gBGZx.Contracts.throwIfArrayEmptyOrWhitespace(languages, this.privErrors.invalidArgs.replace("{arg}", "languages"));
            $gBGZx.Contracts.throwIfNullOrUndefined(this.privRoom, this.privErrors.permissionDeniedSend);
            if (!this.canSend) this.handleError(new Error(this.privErrors.permissionDeniedSend), err);
            if (!!this.privConversationRecognizer) this.privConversationRecognizer.sendRequest(this.getSetTranslateToLanguagesCommand(languages), function() {
                _this.handleCallback(cb, err);
            }, function(error) {
                _this.handleError(error, err);
            });
        } catch (error) {
            this.handleError(error, err);
        }
    };
    /**
     * Change nickname
     * @param {string} nickname - new nickname for the room
     * @param cb
     * @param err
     */ ConversationImpl.prototype.changeNicknameAsync = function(nickname, cb, err) {
        var _this = this;
        try {
            $gBGZx.Contracts.throwIfDisposed(this.privIsDisposed);
            $gBGZx.Contracts.throwIfDisposed(this.privConversationRecognizer.isDisposed());
            $gBGZx.Contracts.throwIfNullOrWhitespace(nickname, this.privErrors.invalidArgs.replace("{arg}", "nickname"));
            $gBGZx.Contracts.throwIfNullOrUndefined(this.privRoom, this.privErrors.permissionDeniedSend);
            if (!this.canSend) this.handleError(new Error(this.privErrors.permissionDeniedSend), err);
            if (!!this.privConversationRecognizer) this.privConversationRecognizer.sendRequest(this.getChangeNicknameCommand(nickname), function() {
                _this.handleCallback(cb, err);
            }, function(error) {
                _this.handleError(error, err);
            });
        } catch (error) {
            this.handleError(error, err);
        }
    };
    ConversationImpl.prototype.isDisposed = function() {
        return this.privIsDisposed;
    };
    ConversationImpl.prototype.dispose = function() {
        if (this.isDisposed) return;
        this.privIsDisposed = true;
        if (!!this.config) this.config.close();
        this.privConfig = undefined;
        this.privLanguage = undefined;
        this.privProperties = undefined;
        this.privRoom = undefined;
        this.privToken = undefined;
        this.privManager = undefined;
        this.privIsConnected = false;
        this.privIsReady = false;
        this.privParticipants = undefined;
    };
    ConversationImpl.prototype.connectTranscriberRecognizer = function(recognizer) {
        return $e9e7ae32d054fa76$var$__awaiter(this, void 0, void 0, function() {
            return $e9e7ae32d054fa76$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!!!this.privTranscriberRecognizer) return [
                            3 /*break*/ ,
                            2
                        ];
                        return [
                            4 /*yield*/ ,
                            this.privTranscriberRecognizer.close()
                        ];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        return [
                            4 /*yield*/ ,
                            recognizer.enforceAudioGating()
                        ];
                    case 3:
                        _a.sent();
                        this.privTranscriberRecognizer = recognizer;
                        this.privTranscriberRecognizer.conversation = this;
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    ConversationImpl.prototype.getKeepAlive = function() {
        var nickname = !!this.me ? this.me.displayName : "default_nickname";
        return JSON.stringify({
            id: "0",
            nickname: nickname,
            participantId: this.privRoom.participantId,
            roomId: this.privRoom.roomId,
            type: $dEkJU.ConversationTranslatorMessageTypes.keepAlive
        });
    };
    /* eslint-enable @typescript-eslint/typedef */ ConversationImpl.prototype.addParticipantImplAsync = function(participant) {
        var newParticipant = this.privParticipants.addOrUpdateParticipant(participant);
        if (newParticipant !== undefined) {
            if (!!this.privTranscriberRecognizer) {
                var conversationInfo = this.conversationInfo;
                conversationInfo.participants = [
                    participant
                ];
                return this.privTranscriberRecognizer.pushConversationEvent(conversationInfo, "join");
            }
        }
    };
    ConversationImpl.prototype.removeParticipantImplAsync = function(participant) {
        this.privParticipants.deleteParticipant(participant.id);
        var conversationInfo = this.conversationInfo;
        conversationInfo.participants = [
            participant
        ];
        return this.privTranscriberRecognizer.pushConversationEvent(conversationInfo, "leave");
    };
    ConversationImpl.prototype.close = function(dispose) {
        var _a;
        return $e9e7ae32d054fa76$var$__awaiter(this, void 0, void 0, function() {
            var e_1;
            return $e9e7ae32d054fa76$var$__generator(this, function(_b) {
                switch(_b.label){
                    case 0:
                        _b.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        this.privIsConnected = false;
                        return [
                            4 /*yield*/ ,
                            (_a = this.privConversationRecognizer) === null || _a === void 0 ? void 0 : _a.close()
                        ];
                    case 1:
                        _b.sent();
                        this.privConversationRecognizer = undefined;
                        if (!!this.privConversationTranslator) this.privConversationTranslator.dispose();
                        return [
                            3 /*break*/ ,
                            3
                        ];
                    case 2:
                        e_1 = _b.sent();
                        // ignore error
                        throw e_1;
                    case 3:
                        if (dispose) this.dispose();
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /** Helpers */ ConversationImpl.prototype.handleCallback = function(cb, err) {
        if (!!cb) {
            try {
                cb();
            } catch (e) {
                if (!!err) err(e);
            }
            cb = undefined;
        }
    };
    ConversationImpl.prototype.handleError = function(error, err) {
        if (!!err) {
            if (error instanceof Error) {
                var typedError = error;
                err(typedError.name + ": " + typedError.message);
            } else err(error);
        }
    };
    /** Participant Helpers */ ConversationImpl.prototype.toParticipants = function(includeHost) {
        var _this = this;
        var participants = this.privParticipants.participants.map(function(p) {
            return _this.toParticipant(p);
        });
        if (!includeHost) return participants.filter(function(p) {
            return p.isHost === false;
        });
        else return participants;
    };
    ConversationImpl.prototype.toParticipant = function(p) {
        return new $hM4QX.Participant(p.id, p.avatar, p.displayName, p.isHost, p.isMuted, p.isUsingTts, p.preferredLanguage, p.voice);
    };
    ConversationImpl.prototype.getMuteAllCommand = function(isMuted) {
        $gBGZx.Contracts.throwIfNullOrWhitespace(this.privRoom.roomId, "conversationId");
        $gBGZx.Contracts.throwIfNullOrWhitespace(this.privRoom.participantId, "participantId");
        return JSON.stringify({
            command: $dEkJU.ConversationTranslatorCommandTypes.setMuteAll,
            participantId: this.privRoom.participantId,
            roomid: this.privRoom.roomId,
            type: $dEkJU.ConversationTranslatorMessageTypes.participantCommand,
            value: isMuted
        });
    };
    ConversationImpl.prototype.getMuteCommand = function(participantId, isMuted) {
        $gBGZx.Contracts.throwIfNullOrWhitespace(this.privRoom.roomId, "conversationId");
        $gBGZx.Contracts.throwIfNullOrWhitespace(participantId, "participantId");
        return JSON.stringify({
            command: $dEkJU.ConversationTranslatorCommandTypes.setMute,
            // eslint-disable-next-line object-shorthand
            participantId: participantId,
            roomid: this.privRoom.roomId,
            type: $dEkJU.ConversationTranslatorMessageTypes.participantCommand,
            value: isMuted
        });
    };
    ConversationImpl.prototype.getLockCommand = function(isLocked) {
        $gBGZx.Contracts.throwIfNullOrWhitespace(this.privRoom.roomId, "conversationId");
        $gBGZx.Contracts.throwIfNullOrWhitespace(this.privRoom.participantId, "participantId");
        return JSON.stringify({
            command: $dEkJU.ConversationTranslatorCommandTypes.setLockState,
            participantId: this.privRoom.participantId,
            roomid: this.privRoom.roomId,
            type: $dEkJU.ConversationTranslatorMessageTypes.participantCommand,
            value: isLocked
        });
    };
    ConversationImpl.prototype.getEjectCommand = function(participantId) {
        $gBGZx.Contracts.throwIfNullOrWhitespace(this.privRoom.roomId, "conversationId");
        $gBGZx.Contracts.throwIfNullOrWhitespace(participantId, "participantId");
        return JSON.stringify({
            command: $dEkJU.ConversationTranslatorCommandTypes.ejectParticipant,
            // eslint-disable-next-line object-shorthand
            participantId: participantId,
            roomid: this.privRoom.roomId,
            type: $dEkJU.ConversationTranslatorMessageTypes.participantCommand
        });
    };
    ConversationImpl.prototype.getSetTranslateToLanguagesCommand = function(languages) {
        $gBGZx.Contracts.throwIfNullOrWhitespace(this.privRoom.roomId, "conversationId");
        $gBGZx.Contracts.throwIfNullOrWhitespace(this.privRoom.participantId, "participantId");
        return JSON.stringify({
            command: $dEkJU.ConversationTranslatorCommandTypes.setTranslateToLanguages,
            participantId: this.privRoom.participantId,
            roomid: this.privRoom.roomId,
            type: $dEkJU.ConversationTranslatorMessageTypes.participantCommand,
            value: languages
        });
    };
    ConversationImpl.prototype.getChangeNicknameCommand = function(nickname) {
        $gBGZx.Contracts.throwIfNullOrWhitespace(this.privRoom.roomId, "conversationId");
        $gBGZx.Contracts.throwIfNullOrWhitespace(nickname, "nickname");
        $gBGZx.Contracts.throwIfNullOrWhitespace(this.privRoom.participantId, "participantId");
        return JSON.stringify({
            command: $dEkJU.ConversationTranslatorCommandTypes.changeNickname,
            nickname: nickname,
            participantId: this.privRoom.participantId,
            roomid: this.privRoom.roomId,
            type: $dEkJU.ConversationTranslatorMessageTypes.participantCommand,
            value: nickname
        });
    };
    ConversationImpl.prototype.getMessageCommand = function(message) {
        $gBGZx.Contracts.throwIfNullOrWhitespace(this.privRoom.roomId, "conversationId");
        $gBGZx.Contracts.throwIfNullOrWhitespace(this.privRoom.participantId, "participantId");
        $gBGZx.Contracts.throwIfNullOrWhitespace(message, "message");
        return JSON.stringify({
            participantId: this.privRoom.participantId,
            roomId: this.privRoom.roomId,
            text: message,
            type: $dEkJU.ConversationTranslatorMessageTypes.instantMessage
        });
    };
    return ConversationImpl;
}($e9e7ae32d054fa76$var$Conversation);
module.exports.ConversationImpl = $e9e7ae32d054fa76$var$ConversationImpl;

});

parcelRequire.register("lc5wu", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ConversationCommon = void 0;
var $f6df00be8f098bff$var$ConversationCommon = /** @class */ function() {
    function ConversationCommon(audioConfig) {
        this.privAudioConfig = audioConfig;
    }
    ConversationCommon.prototype.handleCallback = function(cb, err) {
        if (!!cb) {
            try {
                cb();
            } catch (e) {
                if (!!err) err(e);
            }
            cb = undefined;
        }
    };
    ConversationCommon.prototype.handleError = function(error, err) {
        if (!!err) {
            if (error instanceof Error) {
                var typedError = error;
                err(typedError.name + ": " + typedError.message);
            } else err(error);
        }
    };
    return ConversationCommon;
}();
module.exports.ConversationCommon = $f6df00be8f098bff$var$ConversationCommon;

});

parcelRequire.register("22tM4", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
// Multi-device Conversation is a Preview feature.
var $17c2dd3b35ce9fc4$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ConversationExpirationEventArgs = void 0;

var $hM4QX = parcelRequire("hM4QX");
var $17c2dd3b35ce9fc4$var$ConversationExpirationEventArgs = /** @class */ function(_super) {
    $17c2dd3b35ce9fc4$var$__extends(ConversationExpirationEventArgs, _super);
    function ConversationExpirationEventArgs(expirationTime, sessionId) {
        var _this = _super.call(this, sessionId) || this;
        _this.privExpirationTime = expirationTime;
        return _this;
    }
    Object.defineProperty(ConversationExpirationEventArgs.prototype, "expirationTime", {
        /** How much longer until the conversation expires (in minutes). */ get: function() {
            return this.privExpirationTime;
        },
        enumerable: false,
        configurable: true
    });
    return ConversationExpirationEventArgs;
}($hM4QX.SessionEventArgs);
module.exports.ConversationExpirationEventArgs = $17c2dd3b35ce9fc4$var$ConversationExpirationEventArgs;

});

parcelRequire.register("eLehy", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
// Multi-device Conversation is a Preview feature.
var $02c5f1afd41ed869$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ConversationParticipantsChangedEventArgs = void 0;

var $hM4QX = parcelRequire("hM4QX");
var $02c5f1afd41ed869$var$ConversationParticipantsChangedEventArgs = /** @class */ function(_super) {
    $02c5f1afd41ed869$var$__extends(ConversationParticipantsChangedEventArgs, _super);
    function ConversationParticipantsChangedEventArgs(reason, participants, sessionId) {
        var _this = _super.call(this, sessionId) || this;
        _this.privReason = reason;
        _this.privParticipant = participants;
        return _this;
    }
    Object.defineProperty(ConversationParticipantsChangedEventArgs.prototype, "reason", {
        get: function() {
            return this.privReason;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ConversationParticipantsChangedEventArgs.prototype, "participants", {
        get: function() {
            return this.privParticipant;
        },
        enumerable: false,
        configurable: true
    });
    return ConversationParticipantsChangedEventArgs;
}($hM4QX.SessionEventArgs);
module.exports.ConversationParticipantsChangedEventArgs = $02c5f1afd41ed869$var$ConversationParticipantsChangedEventArgs;

});

parcelRequire.register("2dbDg", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
// Multi-device Conversation is a Preview feature.
var $19c5d19e6a929909$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ConversationTranslationCanceledEventArgs = void 0;

var $bUeFN = parcelRequire("bUeFN");
var $19c5d19e6a929909$var$ConversationTranslationCanceledEventArgs = /** @class */ function(_super) {
    $19c5d19e6a929909$var$__extends(ConversationTranslationCanceledEventArgs, _super);
    function ConversationTranslationCanceledEventArgs() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return ConversationTranslationCanceledEventArgs;
}($bUeFN.CancellationEventArgsBase);
module.exports.ConversationTranslationCanceledEventArgs = $19c5d19e6a929909$var$ConversationTranslationCanceledEventArgs;

});

parcelRequire.register("1mfN5", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
// Multi-device Conversation is a Preview feature.
var $0fd4183c2a52a304$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ConversationTranslationEventArgs = void 0;

var $hM4QX = parcelRequire("hM4QX");
var $0fd4183c2a52a304$var$ConversationTranslationEventArgs = /** @class */ function(_super) {
    $0fd4183c2a52a304$var$__extends(ConversationTranslationEventArgs, _super);
    /**
     * Creates and initializes an instance of this class.
     * @constructor
     * @param {ConversationTranslationResult} result - The translation recognition result.
     * @param {number} offset - The offset.
     * @param {string} sessionId - The session id.
     */ function ConversationTranslationEventArgs(result, offset, sessionId) {
        var _this = _super.call(this, offset, sessionId) || this;
        _this.privResult = result;
        return _this;
    }
    Object.defineProperty(ConversationTranslationEventArgs.prototype, "result", {
        /**
         * Specifies the recognition result.
         * @returns {ConversationTranslationResult} the recognition result.
         */ get: function() {
            return this.privResult;
        },
        enumerable: false,
        configurable: true
    });
    return ConversationTranslationEventArgs;
}($hM4QX.RecognitionEventArgs);
module.exports.ConversationTranslationEventArgs = $0fd4183c2a52a304$var$ConversationTranslationEventArgs;

});

parcelRequire.register("1k8xi", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
// Multi-device Conversation is a Preview feature.
var $0f6e47ca0775faea$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ConversationTranslationResult = void 0;

var $kYmQY = parcelRequire("kYmQY");
var $0f6e47ca0775faea$var$ConversationTranslationResult = /** @class */ function(_super) {
    $0f6e47ca0775faea$var$__extends(ConversationTranslationResult, _super);
    function ConversationTranslationResult(participantId, translations, originalLanguage, resultId, reason, text, duration, offset, errorDetails, json, properties) {
        var _this = _super.call(this, translations, resultId, reason, text, duration, offset, undefined, undefined, errorDetails, json, properties) || this;
        _this.privId = participantId;
        _this.privOrigLang = originalLanguage;
        return _this;
    }
    Object.defineProperty(ConversationTranslationResult.prototype, "participantId", {
        /**
         * The unique identifier for the participant this result is for.
         */ get: function() {
            return this.privId;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ConversationTranslationResult.prototype, "originalLang", {
        /**
         * The original language this result was in.
         */ get: function() {
            return this.privOrigLang;
        },
        enumerable: false,
        configurable: true
    });
    return ConversationTranslationResult;
}($kYmQY.TranslationRecognitionResult);
module.exports.ConversationTranslationResult = $0f6e47ca0775faea$var$ConversationTranslationResult;

});

parcelRequire.register("ipwIr", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
// Multi-device Conversation is a Preview feature.
var $d673f07cf072f222$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $d673f07cf072f222$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $d673f07cf072f222$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ConversationTranslator = module.exports.SpeechState = void 0;

var $dEkJU = parcelRequire("dEkJU");

var $8lgAQ = parcelRequire("8lgAQ");

var $em8BD = parcelRequire("em8BD");

var $gBGZx = parcelRequire("gBGZx");

var $hM4QX = parcelRequire("hM4QX");

var $k54oi = parcelRequire("k54oi");

var $a9O70 = parcelRequire("a9O70");
var $d673f07cf072f222$var$SpeechState;
(function(SpeechState) {
    SpeechState[SpeechState["Inactive"] = 0] = "Inactive";
    SpeechState[SpeechState["Connecting"] = 1] = "Connecting";
    SpeechState[SpeechState["Connected"] = 2] = "Connected";
})($d673f07cf072f222$var$SpeechState = module.exports.SpeechState || (module.exports.SpeechState = {}));
// child class of TranslationRecognizer meant only for use with ConversationTranslator
var $d673f07cf072f222$var$ConversationTranslationRecognizer = /** @class */ function(_super) {
    $d673f07cf072f222$var$__extends(ConversationTranslationRecognizer, _super);
    function ConversationTranslationRecognizer(speechConfig, audioConfig, translator, convGetter) {
        var _this = _super.call(this, speechConfig, audioConfig, new $8lgAQ.ConversationTranslatorConnectionFactory(convGetter)) || this;
        _this.privSpeechState = $d673f07cf072f222$var$SpeechState.Inactive;
        if (!!translator) {
            _this.privTranslator = translator;
            _this.sessionStarted = function() {
                _this.privSpeechState = $d673f07cf072f222$var$SpeechState.Connected;
            };
            _this.sessionStopped = function() {
                _this.privSpeechState = $d673f07cf072f222$var$SpeechState.Inactive;
            };
            _this.recognizing = function(tr, e) {
                if (!!_this.privTranslator.recognizing) _this.privTranslator.recognizing(_this.privTranslator, e);
            };
            // eslint-disable-next-line @typescript-eslint/no-misused-promises
            _this.recognized = function(tr, e) {
                return $d673f07cf072f222$var$__awaiter(_this, void 0, void 0, function() {
                    var _a;
                    return $d673f07cf072f222$var$__generator(this, function(_b) {
                        switch(_b.label){
                            case 0:
                                if (!((_a = e.result) === null || _a === void 0 ? void 0 : _a.errorDetails)) return [
                                    3 /*break*/ ,
                                    2
                                ];
                                return [
                                    4 /*yield*/ ,
                                    this.cancelSpeech()
                                ];
                            case 1:
                                _b.sent();
                                // TODO: format the error message contained in 'errorDetails'
                                this.fireCancelEvent(e.result.errorDetails);
                                return [
                                    3 /*break*/ ,
                                    3
                                ];
                            case 2:
                                if (!!this.privTranslator.recognized) this.privTranslator.recognized(this.privTranslator, e);
                                _b.label = 3;
                            case 3:
                                return [
                                    2 /*return*/ 
                                ];
                        }
                    });
                });
            };
            // eslint-disable-next-line @typescript-eslint/no-misused-promises
            _this.canceled = function() {
                return $d673f07cf072f222$var$__awaiter(_this, void 0, void 0, function() {
                    var error_1;
                    return $d673f07cf072f222$var$__generator(this, function(_a) {
                        switch(_a.label){
                            case 0:
                                if (!(this.privSpeechState !== $d673f07cf072f222$var$SpeechState.Inactive)) return [
                                    3 /*break*/ ,
                                    4
                                ];
                                _a.label = 1;
                            case 1:
                                _a.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                return [
                                    4 /*yield*/ ,
                                    this.cancelSpeech()
                                ];
                            case 2:
                                _a.sent();
                                return [
                                    3 /*break*/ ,
                                    4
                                ];
                            case 3:
                                error_1 = _a.sent();
                                this.privSpeechState = $d673f07cf072f222$var$SpeechState.Inactive;
                                return [
                                    3 /*break*/ ,
                                    4
                                ];
                            case 4:
                                return [
                                    2 /*return*/ 
                                ];
                        }
                    });
                });
            };
        }
        return _this;
    }
    Object.defineProperty(ConversationTranslationRecognizer.prototype, "state", {
        get: function() {
            return this.privSpeechState;
        },
        set: function(newState) {
            this.privSpeechState = newState;
        },
        enumerable: false,
        configurable: true
    });
    ConversationTranslationRecognizer.prototype.onConnection = function() {
        this.privSpeechState = $d673f07cf072f222$var$SpeechState.Connected;
    };
    ConversationTranslationRecognizer.prototype.onDisconnection = function() {
        return $d673f07cf072f222$var$__awaiter(this, void 0, void 0, function() {
            return $d673f07cf072f222$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        this.privSpeechState = $d673f07cf072f222$var$SpeechState.Inactive;
                        return [
                            4 /*yield*/ ,
                            this.cancelSpeech()
                        ];
                    case 1:
                        _a.sent();
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * Fire a cancel event
     * @param error
     */ ConversationTranslationRecognizer.prototype.fireCancelEvent = function(error) {
        try {
            if (!!this.privTranslator.canceled) {
                var cancelEvent = new $a9O70.ConversationTranslationCanceledEventArgs($hM4QX.CancellationReason.Error, error, $hM4QX.CancellationErrorCode.RuntimeError);
                this.privTranslator.canceled(this.privTranslator, cancelEvent);
            }
        } catch (e) {
        //
        }
    };
    ConversationTranslationRecognizer.prototype.cancelSpeech = function() {
        var _a;
        return $d673f07cf072f222$var$__awaiter(this, void 0, void 0, function() {
            var e_1;
            return $d673f07cf072f222$var$__generator(this, function(_b) {
                switch(_b.label){
                    case 0:
                        _b.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        this.stopContinuousRecognitionAsync();
                        return [
                            4 /*yield*/ ,
                            (_a = this.privReco) === null || _a === void 0 ? void 0 : _a.disconnect()
                        ];
                    case 1:
                        _b.sent();
                        this.privSpeechState = $d673f07cf072f222$var$SpeechState.Inactive;
                        return [
                            3 /*break*/ ,
                            3
                        ];
                    case 2:
                        e_1 = _b.sent();
                        return [
                            3 /*break*/ ,
                            3
                        ];
                    case 3:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    return ConversationTranslationRecognizer;
}($hM4QX.TranslationRecognizer);
/**
 * Join, leave or connect to a conversation.
 */ var $d673f07cf072f222$var$ConversationTranslator = /** @class */ function(_super) {
    $d673f07cf072f222$var$__extends(ConversationTranslator, _super);
    function ConversationTranslator(audioConfig) {
        var _this = _super.call(this, audioConfig) || this;
        _this.privErrors = $dEkJU.ConversationConnectionConfig.restErrors;
        _this.privIsDisposed = false;
        _this.privIsSpeaking = false;
        _this.privPlaceholderKey = "abcdefghijklmnopqrstuvwxyz012345";
        _this.privPlaceholderRegion = "westus";
        _this.privProperties = new $hM4QX.PropertyCollection();
        return _this;
    }
    Object.defineProperty(ConversationTranslator.prototype, "properties", {
        get: function() {
            return this.privProperties;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ConversationTranslator.prototype, "speechRecognitionLanguage", {
        get: function() {
            return this.privSpeechRecognitionLanguage;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ConversationTranslator.prototype, "participants", {
        get: function() {
            var _a;
            return (_a = this.privConversation) === null || _a === void 0 ? void 0 : _a.participants;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ConversationTranslator.prototype, "canSpeak", {
        get: function() {
            // is there a Conversation websocket available and has the Recognizer been set up
            if (!this.privConversation.isConnected || !this.privCTRecognizer) return false;
            // is the user already speaking
            if (this.privIsSpeaking || this.privCTRecognizer.state === $d673f07cf072f222$var$SpeechState.Connected || this.privCTRecognizer.state === $d673f07cf072f222$var$SpeechState.Connecting) return false;
            // is the user muted
            if (this.privConversation.isMutedByHost) return false;
            return true;
        },
        enumerable: false,
        configurable: true
    });
    ConversationTranslator.prototype.setServiceProperty = function(name, value) {
        var currentProperties = JSON.parse(this.privProperties.getProperty($dEkJU.ServicePropertiesPropertyName, "{}"));
        currentProperties[name] = value;
        this.privProperties.setProperty($dEkJU.ServicePropertiesPropertyName, JSON.stringify(currentProperties));
    };
    ConversationTranslator.prototype.joinConversationAsync = function(conversation, nickname, param1, param2, param3) {
        var _this = this;
        try {
            if (typeof conversation === "string") {
                $gBGZx.Contracts.throwIfNullOrUndefined(conversation, this.privErrors.invalidArgs.replace("{arg}", "conversation id"));
                $gBGZx.Contracts.throwIfNullOrWhitespace(nickname, this.privErrors.invalidArgs.replace("{arg}", "nickname"));
                if (!!this.privConversation) this.handleError(new Error(this.privErrors.permissionDeniedStart), param3);
                var lang = param1;
                if (lang === undefined || lang === null || lang === "") lang = $dEkJU.ConversationConnectionConfig.defaultLanguageCode;
                // create a placeholder config
                this.privSpeechTranslationConfig = $hM4QX.SpeechTranslationConfig.fromSubscription(this.privPlaceholderKey, this.privPlaceholderRegion);
                this.privSpeechTranslationConfig.setProfanity($hM4QX.ProfanityOption.Masked);
                this.privSpeechTranslationConfig.addTargetLanguage(lang);
                this.privSpeechTranslationConfig.setProperty($hM4QX.PropertyId[$hM4QX.PropertyId.SpeechServiceConnection_RecoLanguage], lang);
                this.privSpeechTranslationConfig.setProperty($hM4QX.PropertyId[$hM4QX.PropertyId.ConversationTranslator_Name], nickname);
                var propertyIdsToCopy = [
                    $hM4QX.PropertyId.SpeechServiceConnection_Host,
                    $hM4QX.PropertyId.ConversationTranslator_Host,
                    $hM4QX.PropertyId.SpeechServiceConnection_Endpoint,
                    $hM4QX.PropertyId.SpeechServiceConnection_ProxyHostName,
                    $hM4QX.PropertyId.SpeechServiceConnection_ProxyPassword,
                    $hM4QX.PropertyId.SpeechServiceConnection_ProxyPort,
                    $hM4QX.PropertyId.SpeechServiceConnection_ProxyUserName,
                    "ConversationTranslator_MultiChannelAudio",
                    "ConversationTranslator_Region"
                ];
                for(var _i = 0, propertyIdsToCopy_1 = propertyIdsToCopy; _i < propertyIdsToCopy_1.length; _i++){
                    var prop = propertyIdsToCopy_1[_i];
                    var value = this.privProperties.getProperty(prop);
                    if (value) {
                        var key = typeof prop === "string" ? prop : $hM4QX.PropertyId[prop];
                        this.privSpeechTranslationConfig.setProperty(key, value);
                    }
                }
                var currentProperties = JSON.parse(this.privProperties.getProperty($dEkJU.ServicePropertiesPropertyName, "{}"));
                for(var _a = 0, _b = Object.keys(currentProperties); _a < _b.length; _a++){
                    var prop = _b[_a];
                    this.privSpeechTranslationConfig.setServiceProperty(prop, currentProperties[prop], $hM4QX.ServicePropertyChannel.UriQueryParameter);
                }
                // join the conversation
                this.privConversation = new $k54oi.ConversationImpl(this.privSpeechTranslationConfig);
                this.privConversation.conversationTranslator = this;
                this.privConversation.joinConversationAsync(conversation, nickname, lang, function(result) {
                    if (!result) _this.handleError(new Error(_this.privErrors.permissionDeniedConnect), param3);
                    _this.privSpeechTranslationConfig.authorizationToken = result;
                    _this.privConversation.room.isHost = false;
                    // connect to the ws
                    _this.privConversation.startConversationAsync(function() {
                        _this.handleCallback(param2, param3);
                    }, function(error) {
                        _this.handleError(error, param3);
                    });
                }, function(error) {
                    _this.handleError(error, param3);
                });
            } else if (typeof conversation === "object") {
                $gBGZx.Contracts.throwIfNullOrUndefined(conversation, this.privErrors.invalidArgs.replace("{arg}", "conversation id"));
                $gBGZx.Contracts.throwIfNullOrWhitespace(nickname, this.privErrors.invalidArgs.replace("{arg}", "nickname"));
                // save the nickname
                this.privProperties.setProperty($hM4QX.PropertyId.ConversationTranslator_Name, nickname);
                // ref the conversation object
                this.privConversation = conversation;
                // ref the conversation translator object
                this.privConversation.conversationTranslator = this;
                this.privConversation.room.isHost = true;
                $gBGZx.Contracts.throwIfNullOrUndefined(this.privConversation, this.privErrors.permissionDeniedConnect);
                $gBGZx.Contracts.throwIfNullOrUndefined(this.privConversation.room.token, this.privErrors.permissionDeniedConnect);
                this.privSpeechTranslationConfig = conversation.config;
                this.handleCallback(param1, param2);
            } else this.handleError(new Error(this.privErrors.invalidArgs.replace("{arg}", "invalid conversation type")), param2);
        } catch (error) {
            this.handleError(error, typeof param1 === "string" ? param3 : param2);
        }
    };
    /**
     * Leave the conversation
     * @param cb
     * @param err
     */ ConversationTranslator.prototype.leaveConversationAsync = function(cb, err) {
        var _this = this;
        $em8BD.marshalPromiseToCallbacks(function() {
            return $d673f07cf072f222$var$__awaiter(_this, void 0, void 0, function() {
                return $d673f07cf072f222$var$__generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            // stop the speech websocket
                            return [
                                4 /*yield*/ ,
                                this.cancelSpeech()
                            ];
                        case 1:
                            // stop the speech websocket
                            _a.sent();
                            // stop the websocket
                            return [
                                4 /*yield*/ ,
                                this.privConversation.endConversationImplAsync()
                            ];
                        case 2:
                            // stop the websocket
                            _a.sent();
                            // https delete request
                            return [
                                4 /*yield*/ ,
                                this.privConversation.deleteConversationImplAsync()
                            ];
                        case 3:
                            // https delete request
                            _a.sent();
                            this.dispose();
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        }(), cb, err);
    };
    /**
     * Send a text message
     * @param message
     * @param cb
     * @param err
     */ ConversationTranslator.prototype.sendTextMessageAsync = function(message, cb, err) {
        try {
            $gBGZx.Contracts.throwIfNullOrUndefined(this.privConversation, this.privErrors.permissionDeniedSend);
            $gBGZx.Contracts.throwIfNullOrWhitespace(message, this.privErrors.invalidArgs.replace("{arg}", message));
            this.privConversation.sendTextMessageAsync(message, cb, err);
        } catch (error) {
            this.handleError(error, err);
        }
    };
    /**
     * Start speaking
     * @param cb
     * @param err
     */ ConversationTranslator.prototype.startTranscribingAsync = function(cb, err) {
        var _this = this;
        $em8BD.marshalPromiseToCallbacks(function() {
            return $d673f07cf072f222$var$__awaiter(_this, void 0, void 0, function() {
                var error_2;
                return $d673f07cf072f222$var$__generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            _a.trys.push([
                                0,
                                4,
                                ,
                                6
                            ]);
                            $gBGZx.Contracts.throwIfNullOrUndefined(this.privConversation, this.privErrors.permissionDeniedSend);
                            $gBGZx.Contracts.throwIfNullOrUndefined(this.privConversation.room.token, this.privErrors.permissionDeniedConnect);
                            if (!(this.privCTRecognizer === undefined)) return [
                                3 /*break*/ ,
                                2
                            ];
                            return [
                                4 /*yield*/ ,
                                this.connectTranslatorRecognizer()
                            ];
                        case 1:
                            _a.sent();
                            _a.label = 2;
                        case 2:
                            $gBGZx.Contracts.throwIfNullOrUndefined(this.privCTRecognizer, this.privErrors.permissionDeniedSend);
                            if (!this.canSpeak) this.handleError(new Error(this.privErrors.permissionDeniedSend), err);
                            return [
                                4 /*yield*/ ,
                                this.startContinuousRecognition()
                            ];
                        case 3:
                            _a.sent();
                            this.privIsSpeaking = true;
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case 4:
                            error_2 = _a.sent();
                            this.privIsSpeaking = false;
                            return [
                                4 /*yield*/ ,
                                this.cancelSpeech()
                            ];
                        case 5:
                            _a.sent();
                            throw error_2;
                        case 6:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        }(), cb, err);
    };
    /**
     * Stop speaking
     * @param cb
     * @param err
     */ ConversationTranslator.prototype.stopTranscribingAsync = function(cb, err) {
        var _this = this;
        $em8BD.marshalPromiseToCallbacks(function() {
            return $d673f07cf072f222$var$__awaiter(_this, void 0, void 0, function() {
                var error_3;
                var _this = this;
                return $d673f07cf072f222$var$__generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            _a.trys.push([
                                0,
                                4,
                                ,
                                6
                            ]);
                            if (!!this.privIsSpeaking) return [
                                3 /*break*/ ,
                                2
                            ];
                            // stop speech
                            return [
                                4 /*yield*/ ,
                                this.cancelSpeech()
                            ];
                        case 1:
                            // stop speech
                            _a.sent();
                            return [
                                2 /*return*/ 
                            ];
                        case 2:
                            // stop the recognition but leave the websocket open
                            this.privIsSpeaking = false;
                            return [
                                4 /*yield*/ ,
                                new Promise(function(resolve, reject) {
                                    _this.privCTRecognizer.stopContinuousRecognitionAsync(resolve, reject);
                                })
                            ];
                        case 3:
                            _a.sent();
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case 4:
                            error_3 = _a.sent();
                            return [
                                4 /*yield*/ ,
                                this.cancelSpeech()
                            ];
                        case 5:
                            _a.sent();
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case 6:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        }(), cb, err);
    };
    ConversationTranslator.prototype.isDisposed = function() {
        return this.privIsDisposed;
    };
    ConversationTranslator.prototype.dispose = function(reason, success, err) {
        var _this = this;
        $em8BD.marshalPromiseToCallbacks(function() {
            return $d673f07cf072f222$var$__awaiter(_this, void 0, void 0, function() {
                return $d673f07cf072f222$var$__generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            if (this.isDisposed && !this.privIsSpeaking) return [
                                2 /*return*/ 
                            ];
                            return [
                                4 /*yield*/ ,
                                this.cancelSpeech()
                            ];
                        case 1:
                            _a.sent();
                            this.privIsDisposed = true;
                            this.privSpeechTranslationConfig.close();
                            this.privSpeechRecognitionLanguage = undefined;
                            this.privProperties = undefined;
                            this.privAudioConfig = undefined;
                            this.privSpeechTranslationConfig = undefined;
                            this.privConversation.dispose();
                            this.privConversation = undefined;
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        }(), success, err);
    };
    /**
     * Cancel the speech websocket
     */ ConversationTranslator.prototype.cancelSpeech = function() {
        var _a;
        return $d673f07cf072f222$var$__awaiter(this, void 0, void 0, function() {
            var e_2;
            return $d673f07cf072f222$var$__generator(this, function(_b) {
                switch(_b.label){
                    case 0:
                        _b.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        this.privIsSpeaking = false;
                        return [
                            4 /*yield*/ ,
                            (_a = this.privCTRecognizer) === null || _a === void 0 ? void 0 : _a.onDisconnection()
                        ];
                    case 1:
                        _b.sent();
                        this.privCTRecognizer = undefined;
                        return [
                            3 /*break*/ ,
                            3
                        ];
                    case 2:
                        e_2 = _b.sent();
                        return [
                            3 /*break*/ ,
                            3
                        ];
                    case 3:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * Connect to the speech translation recognizer.
     * Currently there is no language validation performed before sending the SpeechLanguage code to the service.
     * If it's an invalid language the raw error will be: 'Error during WebSocket handshake: Unexpected response code: 400'
     * e.g. pass in 'fr' instead of 'fr-FR', or a text-only language 'cy'
     */ ConversationTranslator.prototype.connectTranslatorRecognizer = function() {
        return $d673f07cf072f222$var$__awaiter(this, void 0, void 0, function() {
            var convGetter, error_4;
            var _this = this;
            return $d673f07cf072f222$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        _a.trys.push([
                            0,
                            1,
                            ,
                            3
                        ]);
                        if (this.privAudioConfig === undefined) this.privAudioConfig = $hM4QX.AudioConfig.fromDefaultMicrophoneInput();
                        // clear the temp subscription key if it's a participant joining
                        if (this.privSpeechTranslationConfig.getProperty($hM4QX.PropertyId[$hM4QX.PropertyId.SpeechServiceConnection_Key]) === this.privPlaceholderKey) this.privSpeechTranslationConfig.setProperty($hM4QX.PropertyId[$hM4QX.PropertyId.SpeechServiceConnection_Key], "");
                        convGetter = function() {
                            return _this.privConversation;
                        };
                        this.privCTRecognizer = new $d673f07cf072f222$var$ConversationTranslationRecognizer(this.privSpeechTranslationConfig, this.privAudioConfig, this, convGetter);
                        return [
                            3 /*break*/ ,
                            3
                        ];
                    case 1:
                        error_4 = _a.sent();
                        return [
                            4 /*yield*/ ,
                            this.cancelSpeech()
                        ];
                    case 2:
                        _a.sent();
                        throw error_4;
                    case 3:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * Handle the start speaking request
     */ ConversationTranslator.prototype.startContinuousRecognition = function() {
        var _this = this;
        return new Promise(function(resolve, reject) {
            _this.privCTRecognizer.startContinuousRecognitionAsync(resolve, reject);
        });
    };
    return ConversationTranslator;
}($a9O70.ConversationCommon);
module.exports.ConversationTranslator = $d673f07cf072f222$var$ConversationTranslator;

});
parcelRequire.register("8lgAQ", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
var $612d27fc36b37c0b$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ConversationTranslatorConnectionFactory = void 0;

var $j1V0D = parcelRequire("j1V0D");

var $yizou = parcelRequire("yizou");

var $gBGZx = parcelRequire("gBGZx");

var $hM4QX = parcelRequire("hM4QX");

var $btbfh = parcelRequire("btbfh");

var $QhYc2 = parcelRequire("QhYc2");

var $hGMva = parcelRequire("hGMva");

var $dEkJU = parcelRequire("dEkJU");
/**
 * Connection factory for the conversation translator. Handles connecting to the regular translator endpoint,
 * as well as the virtual microphone array transcription endpoint
 */ var $612d27fc36b37c0b$var$ConversationTranslatorConnectionFactory = /** @class */ function(_super) {
    $612d27fc36b37c0b$var$__extends(ConversationTranslatorConnectionFactory, _super);
    function ConversationTranslatorConnectionFactory(convGetter) {
        var _this = _super.call(this) || this;
        $gBGZx.Contracts.throwIfNullOrUndefined(convGetter, "convGetter");
        _this.privConvGetter = convGetter;
        return _this;
    }
    ConversationTranslatorConnectionFactory.prototype.create = function(config, authInfo, connectionId) {
        var isVirtMicArrayEndpoint = config.parameters.getProperty("ConversationTranslator_MultiChannelAudio", "").toUpperCase() === "TRUE";
        var convInfo = this.privConvGetter().room;
        var region = convInfo.cognitiveSpeechRegion || config.parameters.getProperty($hM4QX.PropertyId.SpeechServiceConnection_Region, "");
        var replacementValues = {
            hostSuffix: $hGMva.ConnectionFactoryBase.getHostSuffix(region),
            path: ConversationTranslatorConnectionFactory.CTS_VIRT_MIC_PATH,
            region: encodeURIComponent(region)
        };
        replacementValues[$QhYc2.QueryParameterNames.Language] = encodeURIComponent(config.parameters.getProperty($hM4QX.PropertyId.SpeechServiceConnection_RecoLanguage, ""));
        replacementValues[$QhYc2.QueryParameterNames.CtsMeetingId] = encodeURIComponent(convInfo.roomId);
        replacementValues[$QhYc2.QueryParameterNames.CtsDeviceId] = encodeURIComponent(convInfo.participantId);
        replacementValues[$QhYc2.QueryParameterNames.CtsIsParticipant] = convInfo.isHost ? "" : "&" + $QhYc2.QueryParameterNames.CtsIsParticipant;
        var endpointUrl = "";
        var queryParams = {};
        var headers = {};
        if (isVirtMicArrayEndpoint) {
            // connecting to the conversation transcription virtual microphone array endpoint
            endpointUrl = config.parameters.getProperty($hM4QX.PropertyId.SpeechServiceConnection_Endpoint);
            if (!endpointUrl) {
                var hostName = config.parameters.getProperty($hM4QX.PropertyId.SpeechServiceConnection_Host, "transcribe.{region}.cts.speech{hostSuffix}");
                endpointUrl = "wss://" + hostName + "{path}";
            }
            // because the region can change during a session, we support being passed a format string which we can then
            // replace with the correct information.
            endpointUrl = $yizou.StringUtils.formatString(endpointUrl, replacementValues);
            var parsedUrl_1 = new URL(endpointUrl);
            parsedUrl_1.searchParams.forEach(function(val, key) {
                queryParams[key] = val;
            });
            var connFactory = new $dEkJU.TranscriberConnectionFactory();
            connFactory.setQueryParams(queryParams, config, endpointUrl);
            // Some query parameters are required for the CTS endpoint, let's explicity set them here
            queryParams[$QhYc2.QueryParameterNames.CtsMeetingId] = replacementValues[$QhYc2.QueryParameterNames.CtsMeetingId];
            queryParams[$QhYc2.QueryParameterNames.CtsDeviceId] = replacementValues[$QhYc2.QueryParameterNames.CtsDeviceId];
            if (!convInfo.isHost) queryParams[$QhYc2.QueryParameterNames.CtsIsParticipant] = ""; // this doesn't have a value so set to an empty string
            if (!($QhYc2.QueryParameterNames.Format in queryParams)) queryParams[$QhYc2.QueryParameterNames.Format] = "simple";
            parsedUrl_1.searchParams.forEach(function(val, key) {
                parsedUrl_1.searchParams.set(key, queryParams[key]);
                delete queryParams[key];
            });
            endpointUrl = parsedUrl_1.toString();
        } else {
            // connecting to regular translation endpoint
            var connFactory = new $dEkJU.TranslationConnectionFactory();
            endpointUrl = connFactory.getEndpointUrl(config, true);
            endpointUrl = $yizou.StringUtils.formatString(endpointUrl, replacementValues);
            connFactory.setQueryParams(queryParams, config, endpointUrl);
        }
        headers[$btbfh.HeaderNames.ConnectionId] = connectionId;
        headers[$j1V0D.RestConfigBase.configParams.token] = convInfo.token;
        if (authInfo.token) headers[authInfo.headerName] = authInfo.token;
        var enableCompression = config.parameters.getProperty("SPEECH-EnableWebsocketCompression", "").toUpperCase() === "TRUE";
        return new $j1V0D.WebsocketConnection(endpointUrl, queryParams, headers, new $dEkJU.WebsocketMessageFormatter(), $j1V0D.ProxyInfo.fromRecognizerConfig(config), enableCompression, connectionId);
    };
    ConversationTranslatorConnectionFactory.CTS_VIRT_MIC_PATH = "/speech/recognition/dynamicaudio";
    return ConversationTranslatorConnectionFactory;
}($hGMva.ConnectionFactoryBase);
module.exports.ConversationTranslatorConnectionFactory = $612d27fc36b37c0b$var$ConversationTranslatorConnectionFactory;

});
parcelRequire.register("yizou", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StringUtils = void 0;
/**
 * String helper functions
 */ var $067194ae02975de0$var$StringUtils = /** @class */ function() {
    function StringUtils() {}
    /**
     * Formats a string by replacing the named {keys} in the string with the values contained in the replacement dictionary.
     * @param format The format string that contains the parts to replace surrounded by {}. For example: "wss://{region}.cts.speech.microsoft.com".
     * If your string needs to contain a { or } you can use the {{ and }} escape sequences respectively.
     * @param replacements The dictionary of replacements. If a replacement is not found, it is replaced with an empty string
     * @returns The formatted string. If you pass in a null or undefined format string, an empty string will be returned
     */ StringUtils.formatString = function(format, replacements) {
        if (!format) return "";
        if (!replacements) return format;
        var formatted = "";
        var key = "";
        var appendToFormatted = function(str) {
            formatted += str;
        };
        var appendToKey = function(str) {
            key += str;
        };
        var appendFunc = appendToFormatted;
        for(var i = 0; i < format.length; i++){
            var c = format[i];
            var next = i + 1 < format.length ? format[i + 1] : "";
            switch(c){
                case "{":
                    if (next === "{") {
                        appendFunc("{");
                        i++;
                    } else appendFunc = appendToKey;
                    break;
                case "}":
                    if (next === "}") {
                        appendFunc("}");
                        i++;
                    } else {
                        if (replacements.hasOwnProperty(key)) formatted += replacements[key];
                        appendFunc = appendToFormatted;
                        key = "";
                    }
                    break;
                default:
                    appendFunc(c);
                    break;
            }
        }
        return formatted;
    };
    return StringUtils;
}();
module.exports.StringUtils = $067194ae02975de0$var$StringUtils;

});



parcelRequire.register("4D0NF", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
var $35eb6ccd588eedb8$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $35eb6ccd588eedb8$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ConversationTranscriber = void 0;

var $dEkJU = parcelRequire("dEkJU");

var $em8BD = parcelRequire("em8BD");

var $gBGZx = parcelRequire("gBGZx");

var $hM4QX = parcelRequire("hM4QX");
var $35eb6ccd588eedb8$var$ConversationTranscriber = /** @class */ function() {
    /**
     * ConversationTranscriber constructor.
     * @constructor
     * @param {AudioConfig} audioConfig - An optional audio configuration associated with the recognizer
     */ function ConversationTranscriber(audioConfig) {
        this.privAudioConfig = audioConfig;
        this.privProperties = new $hM4QX.PropertyCollection();
        this.privRecognizer = undefined;
        this.privDisposedRecognizer = false;
    }
    Object.defineProperty(ConversationTranscriber.prototype, "speechRecognitionLanguage", {
        /**
         * Gets the spoken language of recognition.
         * @member ConversationTranscriber.prototype.speechRecognitionLanguage
         * @function
         * @public
         * @returns {string} The spoken language of recognition.
         */ get: function() {
            $gBGZx.Contracts.throwIfDisposed(this.privDisposedRecognizer);
            return this.properties.getProperty($hM4QX.PropertyId.SpeechServiceConnection_RecoLanguage);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ConversationTranscriber.prototype, "properties", {
        /**
         * The collection of properties and their values defined for this ConversationTranscriber.
         * @member ConversationTranscriber.prototype.properties
         * @function
         * @public
         * @returns {PropertyCollection} The collection of properties and their values defined for this ConversationTranscriber.
         */ get: function() {
            return this.privProperties;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ConversationTranscriber.prototype, "internalData", {
        /**
         * @Internal
         * Internal data member to support fromRecognizer* pattern methods on other classes.
         * Do not use externally, object returned will change without warning or notice.
         */ get: function() {
            return this.privRecognizer.internalData;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ConversationTranscriber.prototype, "connection", {
        /**
         * @Deprecated
         * @Obsolete
         * Please use the Connection.fromRecognizer pattern to obtain a connection object
         */ get: function() {
            return $hM4QX.Connection.fromRecognizer(this.privRecognizer);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ConversationTranscriber.prototype, "authorizationToken", {
        /**
         * Gets the authorization token used to communicate with the service.
         * @member ConversationTranscriber.prototype.authorizationToken
         * @function
         * @public
         * @returns {string} Authorization token.
         */ get: function() {
            return this.properties.getProperty($hM4QX.PropertyId.SpeechServiceAuthorization_Token);
        },
        /**
         * Gets/Sets the authorization token used to communicate with the service.
         * @member ConversationTranscriber.prototype.authorizationToken
         * @function
         * @public
         * @param {string} token - Authorization token.
         */ set: function(token) {
            $gBGZx.Contracts.throwIfNullOrWhitespace(token, "token");
            this.properties.setProperty($hM4QX.PropertyId.SpeechServiceAuthorization_Token, token);
        },
        enumerable: false,
        configurable: true
    });
    /**
     * @param {Conversation} conversation - conversation to be recognized
     */ ConversationTranscriber.prototype.joinConversationAsync = function(conversation, cb, err) {
        var conversationImpl = conversation;
        $gBGZx.Contracts.throwIfNullOrUndefined(conversationImpl, "Conversation");
        // ref the conversation object
        // create recognizer and subscribe to recognizer events
        this.privRecognizer = new $dEkJU.TranscriberRecognizer(conversation.config, this.privAudioConfig);
        $gBGZx.Contracts.throwIfNullOrUndefined(this.privRecognizer, "Recognizer");
        this.privRecognizer.connectCallbacks(this);
        $em8BD.marshalPromiseToCallbacks(conversationImpl.connectTranscriberRecognizer(this.privRecognizer), cb, err);
    };
    /**
     * Starts conversation transcription, until stopTranscribingAsync() is called.
     * User must subscribe to events to receive transcription results.
     * @member ConversationTranscriber.prototype.startTranscribingAsync
     * @function
     * @public
     * @param cb - Callback invoked once the transcription has started.
     * @param err - Callback invoked in case of an error.
     */ ConversationTranscriber.prototype.startTranscribingAsync = function(cb, err) {
        this.privRecognizer.startContinuousRecognitionAsync(cb, err);
    };
    /**
     * Starts conversation transcription, until stopTranscribingAsync() is called.
     * User must subscribe to events to receive transcription results.
     * @member ConversationTranscriber.prototype.stopTranscribingAsync
     * @function
     * @public
     * @param cb - Callback invoked once the transcription has started.
     * @param err - Callback invoked in case of an error.
     */ ConversationTranscriber.prototype.stopTranscribingAsync = function(cb, err) {
        this.privRecognizer.stopContinuousRecognitionAsync(cb, err);
    };
    /**
     * Leave the current conversation. After this is called, you will no longer receive any events.
     */ ConversationTranscriber.prototype.leaveConversationAsync = function(cb, err) {
        var _this = this;
        this.privRecognizer.disconnectCallbacks();
        // eslint-disable-next-line
        $em8BD.marshalPromiseToCallbacks(function() {
            return $35eb6ccd588eedb8$var$__awaiter(_this, void 0, void 0, function() {
                return $35eb6ccd588eedb8$var$__generator(this, function(_a) {
                    return [
                        2 /*return*/ 
                    ];
                });
            });
        }(), cb, err);
    };
    /**
     * closes all external resources held by an instance of this class.
     * @member ConversationTranscriber.prototype.close
     * @function
     * @public
     */ ConversationTranscriber.prototype.close = function(cb, errorCb) {
        $gBGZx.Contracts.throwIfDisposed(this.privDisposedRecognizer);
        $em8BD.marshalPromiseToCallbacks(this.dispose(true), cb, errorCb);
    };
    /**
     * Disposes any resources held by the object.
     * @member ConversationTranscriber.prototype.dispose
     * @function
     * @public
     * @param {boolean} disposing - true if disposing the object.
     */ ConversationTranscriber.prototype.dispose = function(disposing) {
        return $35eb6ccd588eedb8$var$__awaiter(this, void 0, void 0, function() {
            return $35eb6ccd588eedb8$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (this.privDisposedRecognizer) return [
                            2 /*return*/ 
                        ];
                        if (!!!this.privRecognizer) return [
                            3 /*break*/ ,
                            2
                        ];
                        return [
                            4 /*yield*/ ,
                            this.privRecognizer.close()
                        ];
                    case 1:
                        _a.sent();
                        this.privRecognizer = undefined;
                        _a.label = 2;
                    case 2:
                        if (disposing) this.privDisposedRecognizer = true;
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    return ConversationTranscriber;
}();
module.exports.ConversationTranscriber = $35eb6ccd588eedb8$var$ConversationTranscriber;

});

parcelRequire.register("dHLFU", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
// Multi-device Conversation is a Preview feature.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Participant = module.exports.User = void 0;

var $hM4QX = parcelRequire("hM4QX");
var $9fa445c6d0495a2b$var$User = /** @class */ function() {
    function User(userId) {
        this.privUserId = userId;
    }
    Object.defineProperty(User.prototype, "userId", {
        get: function() {
            return this.privUserId;
        },
        enumerable: false,
        configurable: true
    });
    return User;
}();
module.exports.User = $9fa445c6d0495a2b$var$User;
var $9fa445c6d0495a2b$var$Participant = /** @class */ function() {
    function Participant(id, avatar, displayName, isHost, isMuted, isUsingTts, preferredLanguage, voice) {
        this.privId = id;
        this.privAvatar = avatar;
        this.privDisplayName = displayName;
        this.privIsHost = isHost;
        this.privIsMuted = isMuted;
        this.privIsUsingTts = isUsingTts;
        this.privPreferredLanguage = preferredLanguage;
        this.privVoice = voice;
        this.privProperties = new $hM4QX.PropertyCollection();
    }
    Object.defineProperty(Participant.prototype, "avatar", {
        get: function() {
            return this.privAvatar;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Participant.prototype, "displayName", {
        get: function() {
            return this.privDisplayName;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Participant.prototype, "id", {
        get: function() {
            return this.privId;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Participant.prototype, "preferredLanguage", {
        get: function() {
            return this.privPreferredLanguage;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Participant.prototype, "isHost", {
        get: function() {
            return this.privIsHost;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Participant.prototype, "isMuted", {
        get: function() {
            return this.privIsMuted;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Participant.prototype, "isUsingTts", {
        get: function() {
            return this.privIsUsingTts;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Participant.prototype, "voice", {
        get: function() {
            return this.privVoice;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Participant.prototype, "properties", {
        get: function() {
            return this.privProperties;
        },
        enumerable: false,
        configurable: true
    });
    Participant.From = function(id, language, voice) {
        return new Participant(id, "", id, false, false, false, language, voice);
    };
    return Participant;
}();
module.exports.Participant = $9fa445c6d0495a2b$var$Participant;

});

parcelRequire.register("hCN1B", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
// Multi-device Conversation is a Preview feature.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ParticipantChangedReason = void 0;
var $cd4c0399a3090c50$var$ParticipantChangedReason;
(function(ParticipantChangedReason) {
    /** Participant has joined the conversation. */ ParticipantChangedReason[ParticipantChangedReason["JoinedConversation"] = 0] = "JoinedConversation";
    /** Participant has left the conversation. This could be voluntary, or involuntary
     * (e.g. they are experiencing networking issues).
     */ ParticipantChangedReason[ParticipantChangedReason["LeftConversation"] = 1] = "LeftConversation";
    /** The participants' state has changed (e.g. they became muted, changed their nickname). */ ParticipantChangedReason[ParticipantChangedReason["Updated"] = 2] = "Updated";
})($cd4c0399a3090c50$var$ParticipantChangedReason = module.exports.ParticipantChangedReason || (module.exports.ParticipantChangedReason = {}));

});


parcelRequire.register("8v54X", function(module, exports) {
"use strict";
/* eslint-disable @typescript-eslint/no-empty-function */ // Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
var $6305288f301d1cd7$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $6305288f301d1cd7$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SynthesisRequest = module.exports.SpeechSynthesizer = void 0;

var $dEkJU = parcelRequire("dEkJU");

var $em8BD = parcelRequire("em8BD");

var $2ZQip = parcelRequire("2ZQip");

var $lxQ5z = parcelRequire("lxQ5z");

var $aBCur = parcelRequire("aBCur");

var $gBGZx = parcelRequire("gBGZx");

var $hM4QX = parcelRequire("hM4QX");
/**
 * Defines the class SpeechSynthesizer for text to speech.
 * Updated in version 1.16.0
 * @class SpeechSynthesizer
 */ var $6305288f301d1cd7$var$SpeechSynthesizer = /** @class */ function() {
    /**
     * SpeechSynthesizer constructor.
     * @constructor
     * @param {SpeechConfig} speechConfig - An set of initial properties for this synthesizer.
     * @param {AudioConfig} audioConfig - An optional audio configuration associated with the synthesizer.
     */ function SpeechSynthesizer(speechConfig, audioConfig) {
        var speechConfigImpl = speechConfig;
        $gBGZx.Contracts.throwIfNull(speechConfigImpl, "speechConfig");
        if (audioConfig !== null) {
            if (audioConfig === undefined) this.audioConfig = typeof window === "undefined" ? undefined : $hM4QX.AudioConfig.fromDefaultSpeakerOutput();
            else this.audioConfig = audioConfig;
        }
        this.privProperties = speechConfigImpl.properties.clone();
        this.privDisposed = false;
        this.privSynthesizing = false;
        this.privConnectionFactory = new $dEkJU.SpeechSynthesisConnectionFactory();
        this.synthesisRequestQueue = new $em8BD.Queue();
        this.implCommonSynthesizeSetup();
    }
    Object.defineProperty(SpeechSynthesizer.prototype, "authorizationToken", {
        /**
         * Gets the authorization token used to communicate with the service.
         * @member SpeechSynthesizer.prototype.authorizationToken
         * @function
         * @public
         * @returns {string} Authorization token.
         */ get: function() {
            return this.properties.getProperty($hM4QX.PropertyId.SpeechServiceAuthorization_Token);
        },
        /**
         * Gets/Sets the authorization token used to communicate with the service.
         * @member SpeechSynthesizer.prototype.authorizationToken
         * @function
         * @public
         * @param {string} token - Authorization token.
         */ set: function(token) {
            $gBGZx.Contracts.throwIfNullOrWhitespace(token, "token");
            this.properties.setProperty($hM4QX.PropertyId.SpeechServiceAuthorization_Token, token);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SpeechSynthesizer.prototype, "properties", {
        /**
         * The collection of properties and their values defined for this SpeechSynthesizer.
         * @member SpeechSynthesizer.prototype.properties
         * @function
         * @public
         * @returns {PropertyCollection} The collection of properties and their values defined for this SpeechSynthesizer.
         */ get: function() {
            return this.privProperties;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SpeechSynthesizer.prototype, "autoDetectSourceLanguage", {
        /**
         * Indicates if auto detect source language is enabled
         * @member SpeechSynthesizer.prototype.properties
         * @function
         * @public
         * @returns {boolean} if auto detect source language is enabled
         */ get: function() {
            return this.properties.getProperty($hM4QX.PropertyId.SpeechServiceConnection_AutoDetectSourceLanguages) === $dEkJU.AutoDetectSourceLanguagesOpenRangeOptionName;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * SpeechSynthesizer constructor.
     * @constructor
     * @param {SpeechConfig} speechConfig - an set of initial properties for this synthesizer
     * @param {AutoDetectSourceLanguageConfig} autoDetectSourceLanguageConfig - An source language detection configuration associated with the synthesizer
     * @param {AudioConfig} audioConfig - An optional audio configuration associated with the synthesizer
     */ SpeechSynthesizer.FromConfig = function(speechConfig, autoDetectSourceLanguageConfig, audioConfig) {
        var speechConfigImpl = speechConfig;
        autoDetectSourceLanguageConfig.properties.mergeTo(speechConfigImpl.properties);
        return new SpeechSynthesizer(speechConfig, audioConfig);
    };
    SpeechSynthesizer.prototype.buildSsml = function(text) {
        var _a;
        var languageToDefaultVoice = (_a = {}, _a["af-ZA"] = "af-ZA-AdriNeural", _a["am-ET"] = "am-ET-AmehaNeural", _a["ar-AE"] = "ar-AE-FatimaNeural", _a["ar-BH"] = "ar-BH-AliNeural", _a["ar-DZ"] = "ar-DZ-AminaNeural", _a["ar-EG"] = "ar-EG-SalmaNeural", _a["ar-IQ"] = "ar-IQ-BasselNeural", _a["ar-JO"] = "ar-JO-SanaNeural", _a["ar-KW"] = "ar-KW-FahedNeural", _a["ar-LY"] = "ar-LY-ImanNeural", _a["ar-MA"] = "ar-MA-JamalNeural", _a["ar-QA"] = "ar-QA-AmalNeural", _a["ar-SA"] = "ar-SA-HamedNeural", _a["ar-SY"] = "ar-SY-AmanyNeural", _a["ar-TN"] = "ar-TN-HediNeural", _a["ar-YE"] = "ar-YE-MaryamNeural", _a["bg-BG"] = "bg-BG-BorislavNeural", _a["bn-BD"] = "bn-BD-NabanitaNeural", _a["bn-IN"] = "bn-IN-BashkarNeural", _a["ca-ES"] = "ca-ES-JoanaNeural", _a["cs-CZ"] = "cs-CZ-AntoninNeural", _a["cy-GB"] = "cy-GB-AledNeural", _a["da-DK"] = "da-DK-ChristelNeural", _a["de-AT"] = "de-AT-IngridNeural", _a["de-CH"] = "de-CH-JanNeural", _a["de-DE"] = "de-DE-KatjaNeural", _a["el-GR"] = "el-GR-AthinaNeural", _a["en-AU"] = "en-AU-NatashaNeural", _a["en-CA"] = "en-CA-ClaraNeural", _a["en-GB"] = "en-GB-LibbyNeural", _a["en-HK"] = "en-HK-SamNeural", _a["en-IE"] = "en-IE-ConnorNeural", _a["en-IN"] = "en-IN-NeerjaNeural", _a["en-KE"] = "en-KE-AsiliaNeural", _a["en-NG"] = "en-NG-AbeoNeural", _a["en-NZ"] = "en-NZ-MitchellNeural", _a["en-PH"] = "en-PH-JamesNeural", _a["en-SG"] = "en-SG-LunaNeural", _a["en-TZ"] = "en-TZ-ElimuNeural", _a["en-US"] = "en-US-JennyNeural", _a["en-ZA"] = "en-ZA-LeahNeural", _a["es-AR"] = "es-AR-ElenaNeural", _a["es-BO"] = "es-BO-MarceloNeural", _a["es-CL"] = "es-CL-CatalinaNeural", _a["es-CO"] = "es-CO-GonzaloNeural", _a["es-CR"] = "es-CR-JuanNeural", _a["es-CU"] = "es-CU-BelkysNeural", _a["es-DO"] = "es-DO-EmilioNeural", _a["es-EC"] = "es-EC-AndreaNeural", _a["es-ES"] = "es-ES-AlvaroNeural", _a["es-GQ"] = "es-GQ-JavierNeural", _a["es-GT"] = "es-GT-AndresNeural", _a["es-HN"] = "es-HN-CarlosNeural", _a["es-MX"] = "es-MX-DaliaNeural", _a["es-NI"] = "es-NI-FedericoNeural", _a["es-PA"] = "es-PA-MargaritaNeural", _a["es-PE"] = "es-PE-AlexNeural", _a["es-PR"] = "es-PR-KarinaNeural", _a["es-PY"] = "es-PY-MarioNeural", _a["es-SV"] = "es-SV-LorenaNeural", _a["es-US"] = "es-US-AlonsoNeural", _a["es-UY"] = "es-UY-MateoNeural", _a["es-VE"] = "es-VE-PaolaNeural", _a["et-EE"] = "et-EE-AnuNeural", _a["fa-IR"] = "fa-IR-DilaraNeural", _a["fi-FI"] = "fi-FI-SelmaNeural", _a["fil-PH"] = "fil-PH-AngeloNeural", _a["fr-BE"] = "fr-BE-CharlineNeural", _a["fr-CA"] = "fr-CA-SylvieNeural", _a["fr-CH"] = "fr-CH-ArianeNeural", _a["fr-FR"] = "fr-FR-DeniseNeural", _a["ga-IE"] = "ga-IE-ColmNeural", _a["gl-ES"] = "gl-ES-RoiNeural", _a["gu-IN"] = "gu-IN-DhwaniNeural", _a["he-IL"] = "he-IL-AvriNeural", _a["hi-IN"] = "hi-IN-MadhurNeural", _a["hr-HR"] = "hr-HR-GabrijelaNeural", _a["hu-HU"] = "hu-HU-NoemiNeural", _a["id-ID"] = "id-ID-ArdiNeural", _a["is-IS"] = "is-IS-GudrunNeural", _a["it-IT"] = "it-IT-IsabellaNeural", _a["ja-JP"] = "ja-JP-NanamiNeural", _a["jv-ID"] = "jv-ID-DimasNeural", _a["kk-KZ"] = "kk-KZ-AigulNeural", _a["km-KH"] = "km-KH-PisethNeural", _a["kn-IN"] = "kn-IN-GaganNeural", _a["ko-KR"] = "ko-KR-SunHiNeural", _a["lo-LA"] = "lo-LA-ChanthavongNeural", _a["lt-LT"] = "lt-LT-LeonasNeural", _a["lv-LV"] = "lv-LV-EveritaNeural", _a["mk-MK"] = "mk-MK-AleksandarNeural", _a["ml-IN"] = "ml-IN-MidhunNeural", _a["mr-IN"] = "mr-IN-AarohiNeural", _a["ms-MY"] = "ms-MY-OsmanNeural", _a["mt-MT"] = "mt-MT-GraceNeural", _a["my-MM"] = "my-MM-NilarNeural", _a["nb-NO"] = "nb-NO-PernilleNeural", _a["nl-BE"] = "nl-BE-ArnaudNeural", _a["nl-NL"] = "nl-NL-ColetteNeural", _a["pl-PL"] = "pl-PL-AgnieszkaNeural", _a["ps-AF"] = "ps-AF-GulNawazNeural", _a["pt-BR"] = "pt-BR-FranciscaNeural", _a["pt-PT"] = "pt-PT-DuarteNeural", _a["ro-RO"] = "ro-RO-AlinaNeural", _a["ru-RU"] = "ru-RU-SvetlanaNeural", _a["si-LK"] = "si-LK-SameeraNeural", _a["sk-SK"] = "sk-SK-LukasNeural", _a["sl-SI"] = "sl-SI-PetraNeural", _a["so-SO"] = "so-SO-MuuseNeural", _a["sr-RS"] = "sr-RS-NicholasNeural", _a["su-ID"] = "su-ID-JajangNeural", _a["sv-SE"] = "sv-SE-SofieNeural", _a["sw-KE"] = "sw-KE-RafikiNeural", _a["sw-TZ"] = "sw-TZ-DaudiNeural", _a["ta-IN"] = "ta-IN-PallaviNeural", _a["ta-LK"] = "ta-LK-KumarNeural", _a["ta-SG"] = "ta-SG-AnbuNeural", _a["te-IN"] = "te-IN-MohanNeural", _a["th-TH"] = "th-TH-PremwadeeNeural", _a["tr-TR"] = "tr-TR-AhmetNeural", _a["uk-UA"] = "uk-UA-OstapNeural", _a["ur-IN"] = "ur-IN-GulNeural", _a["ur-PK"] = "ur-PK-AsadNeural", _a["uz-UZ"] = "uz-UZ-MadinaNeural", _a["vi-VN"] = "vi-VN-HoaiMyNeural", _a["zh-CN"] = "zh-CN-XiaoxiaoNeural", _a["zh-HK"] = "zh-HK-HiuMaanNeural", _a["zh-TW"] = "zh-TW-HsiaoChenNeural", _a["zu-ZA"] = "zu-ZA-ThandoNeural", _a);
        var language = this.properties.getProperty($hM4QX.PropertyId.SpeechServiceConnection_SynthLanguage, "en-US");
        var voice = this.properties.getProperty($hM4QX.PropertyId.SpeechServiceConnection_SynthVoice, "");
        var ssml = SpeechSynthesizer.XMLEncode(text);
        if (this.autoDetectSourceLanguage) language = "en-US";
        else voice = voice || languageToDefaultVoice[language];
        if (voice) ssml = "<voice name='" + voice + "'>" + ssml + "</voice>";
        ssml = "<speak version='1.0' xmlns='http://www.w3.org/2001/10/synthesis' xmlns:mstts='http://www.w3.org/2001/mstts' xmlns:emo='http://www.w3.org/2009/10/emotionml' xml:lang='" + language + "'>" + ssml + "</speak>";
        return ssml;
    };
    /**
     * Executes speech synthesis on plain text.
     * The task returns the synthesis result.
     * @member SpeechSynthesizer.prototype.speakTextAsync
     * @function
     * @public
     * @param text - Text to be synthesized.
     * @param cb - Callback that received the SpeechSynthesisResult.
     * @param err - Callback invoked in case of an error.
     * @param stream - AudioOutputStream to receive the synthesized audio.
     */ SpeechSynthesizer.prototype.speakTextAsync = function(text, cb, err, stream) {
        this.speakImpl(text, false, cb, err, stream);
    };
    /**
     * Executes speech synthesis on SSML.
     * The task returns the synthesis result.
     * @member SpeechSynthesizer.prototype.speakSsmlAsync
     * @function
     * @public
     * @param ssml - SSML to be synthesized.
     * @param cb - Callback that received the SpeechSynthesisResult.
     * @param err - Callback invoked in case of an error.
     * @param stream - AudioOutputStream to receive the synthesized audio.
     */ SpeechSynthesizer.prototype.speakSsmlAsync = function(ssml, cb, err, stream) {
        this.speakImpl(ssml, true, cb, err, stream);
    };
    /**
     * Get list of synthesis voices available.
     * The task returns the synthesis voice result.
     * @member SpeechSynthesizer.prototype.getVoicesAsync
     * @function
     * @async
     * @public
     * @param locale - Locale of voices in BCP-47 format; if left empty, get all available voices.
     * @return {Promise<SynthesisVoicesResult>} - Promise of a SynthesisVoicesResult.
     */ SpeechSynthesizer.prototype.getVoicesAsync = function(locale) {
        if (locale === void 0) locale = "";
        return $6305288f301d1cd7$var$__awaiter(this, void 0, void 0, function() {
            return $6305288f301d1cd7$var$__generator(this, function(_a) {
                return [
                    2 /*return*/ ,
                    this.getVoices(locale)
                ];
            });
        });
    };
    /**
     * Dispose of associated resources.
     * @member SpeechSynthesizer.prototype.close
     * @function
     * @public
     */ SpeechSynthesizer.prototype.close = function(cb, err) {
        $gBGZx.Contracts.throwIfDisposed(this.privDisposed);
        $em8BD.marshalPromiseToCallbacks(this.dispose(true), cb, err);
    };
    Object.defineProperty(SpeechSynthesizer.prototype, "internalData", {
        /**
         * @Internal
         * Do not use externally, object returned will change without warning or notice.
         */ get: function() {
            return this.privAdapter;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * This method performs cleanup of resources.
     * The Boolean parameter disposing indicates whether the method is called
     * from Dispose (if disposing is true) or from the finalizer (if disposing is false).
     * Derived classes should override this method to dispose resource if needed.
     * @member SpeechSynthesizer.prototype.dispose
     * @function
     * @public
     * @param {boolean} disposing - Flag to request disposal.
     */ SpeechSynthesizer.prototype.dispose = function(disposing) {
        return $6305288f301d1cd7$var$__awaiter(this, void 0, void 0, function() {
            return $6305288f301d1cd7$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (this.privDisposed) return [
                            2 /*return*/ 
                        ];
                        if (!disposing) return [
                            3 /*break*/ ,
                            2
                        ];
                        if (!this.privAdapter) return [
                            3 /*break*/ ,
                            2
                        ];
                        return [
                            4 /*yield*/ ,
                            this.privAdapter.dispose()
                        ];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        this.privDisposed = true;
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    //
    // ################################################################################################################
    // IMPLEMENTATION.
    // Move to independent class
    // ################################################################################################################
    //
    SpeechSynthesizer.prototype.createSynthesizerConfig = function(speechConfig) {
        return new $dEkJU.SynthesizerConfig(speechConfig, this.privProperties);
    };
    // Creates the synthesis adapter
    SpeechSynthesizer.prototype.createSynthesisAdapter = function(authentication, connectionFactory, audioConfig, synthesizerConfig) {
        return new $dEkJU.SynthesisAdapterBase(authentication, connectionFactory, synthesizerConfig, this, this.audioConfig);
    };
    SpeechSynthesizer.prototype.implCommonSynthesizeSetup = function() {
        var _this = this;
        var osPlatform = typeof window !== "undefined" ? "Browser" : "Node";
        var osName = "unknown";
        var osVersion = "unknown";
        if (typeof navigator !== "undefined") {
            osPlatform = osPlatform + "/" + navigator.platform;
            osName = navigator.userAgent;
            osVersion = navigator.appVersion;
        }
        var synthesizerConfig = this.createSynthesizerConfig(new $dEkJU.SpeechServiceConfig(new $dEkJU.Context(new $dEkJU.OS(osPlatform, osName, osVersion))));
        var subscriptionKey = this.privProperties.getProperty($hM4QX.PropertyId.SpeechServiceConnection_Key, undefined);
        var authentication = subscriptionKey && subscriptionKey !== "" ? new $dEkJU.CognitiveSubscriptionKeyAuthentication(subscriptionKey) : new $dEkJU.CognitiveTokenAuthentication(function() {
            var authorizationToken = _this.privProperties.getProperty($hM4QX.PropertyId.SpeechServiceAuthorization_Token, undefined);
            return Promise.resolve(authorizationToken);
        }, function() {
            var authorizationToken = _this.privProperties.getProperty($hM4QX.PropertyId.SpeechServiceAuthorization_Token, undefined);
            return Promise.resolve(authorizationToken);
        });
        this.privAdapter = this.createSynthesisAdapter(authentication, this.privConnectionFactory, this.audioConfig, synthesizerConfig);
        this.privAdapter.audioOutputFormat = $lxQ5z.AudioOutputFormatImpl.fromSpeechSynthesisOutputFormat($hM4QX.SpeechSynthesisOutputFormat[this.properties.getProperty($hM4QX.PropertyId.SpeechServiceConnection_SynthOutputFormat, undefined)]);
        this.privRestAdapter = new $dEkJU.SynthesisRestAdapter(synthesizerConfig, authentication);
    };
    SpeechSynthesizer.prototype.speakImpl = function(text, IsSsml, cb, err, dataStream) {
        var _this = this;
        try {
            $gBGZx.Contracts.throwIfDisposed(this.privDisposed);
            var requestId = $em8BD.createNoDashGuid();
            var audioDestination = void 0;
            if (dataStream instanceof $hM4QX.PushAudioOutputStreamCallback) audioDestination = new $aBCur.PushAudioOutputStreamImpl(dataStream);
            else if (dataStream instanceof $hM4QX.PullAudioOutputStream) audioDestination = dataStream;
            else if (dataStream !== undefined) audioDestination = new $2ZQip.AudioFileWriter(dataStream);
            else audioDestination = undefined;
            this.synthesisRequestQueue.enqueue(new $6305288f301d1cd7$var$SynthesisRequest(requestId, text, IsSsml, function(e) {
                _this.privSynthesizing = false;
                if (!!cb) try {
                    cb(e);
                } catch (e) {
                    if (!!err) err(e);
                }
                cb = undefined;
                /* eslint-disable no-empty */ _this.adapterSpeak().catch(function() {});
            }, function(e) {
                if (!!err) err(e);
            }, audioDestination));
            /* eslint-disable no-empty-function */ this.adapterSpeak().catch(function() {});
        } catch (error) {
            if (!!err) {
                if (error instanceof Error) {
                    var typedError = error;
                    err(typedError.name + ": " + typedError.message);
                } else err(error);
            }
            // Destroy the synthesizer.
            /* eslint-disable no-empty */ this.dispose(true).catch(function() {});
        }
    };
    SpeechSynthesizer.prototype.getVoices = function(locale) {
        return $6305288f301d1cd7$var$__awaiter(this, void 0, void 0, function() {
            var requestId, response, json;
            return $6305288f301d1cd7$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        requestId = $em8BD.createNoDashGuid();
                        return [
                            4 /*yield*/ ,
                            this.privRestAdapter.getVoicesList(requestId)
                        ];
                    case 1:
                        response = _a.sent();
                        if (response.ok && Array.isArray(response.json)) {
                            json = response.json;
                            if (!!locale && locale.length > 0) json = json.filter(function(item) {
                                return !!item.Locale && item.Locale.toLowerCase() === locale.toLowerCase();
                            });
                            return [
                                2 /*return*/ ,
                                new $hM4QX.SynthesisVoicesResult(requestId, json, undefined)
                            ];
                        } else return [
                            2 /*return*/ ,
                            new $hM4QX.SynthesisVoicesResult(requestId, undefined, "Error: " + response.status + ": " + response.statusText)
                        ];
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    SpeechSynthesizer.prototype.adapterSpeak = function() {
        return $6305288f301d1cd7$var$__awaiter(this, void 0, void 0, function() {
            var request;
            return $6305288f301d1cd7$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!(!this.privDisposed && !this.privSynthesizing)) return [
                            3 /*break*/ ,
                            2
                        ];
                        this.privSynthesizing = true;
                        return [
                            4 /*yield*/ ,
                            this.synthesisRequestQueue.dequeue()
                        ];
                    case 1:
                        request = _a.sent();
                        return [
                            2 /*return*/ ,
                            this.privAdapter.Speak(request.text, request.isSSML, request.requestId, request.cb, request.err, request.dataStream)
                        ];
                    case 2:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    SpeechSynthesizer.XMLEncode = function(text) {
        return text.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&apos;");
    };
    return SpeechSynthesizer;
}();
module.exports.SpeechSynthesizer = $6305288f301d1cd7$var$SpeechSynthesizer;
var $6305288f301d1cd7$var$SynthesisRequest = /** @class */ function() {
    function SynthesisRequest(requestId, text, isSSML, cb, err, dataStream) {
        this.requestId = requestId;
        this.text = text;
        this.isSSML = isSSML;
        this.cb = cb;
        this.err = err;
        this.dataStream = dataStream;
    }
    return SynthesisRequest;
}();
module.exports.SynthesisRequest = $6305288f301d1cd7$var$SynthesisRequest;

});

parcelRequire.register("brZgy", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SynthesisResult = void 0;
/**
 * Base class for synthesis results
 * @class SynthesisResult
 * Added in version 1.20.0
 */ var $8561bd79c62b85b3$var$SynthesisResult = /** @class */ function() {
    /**
     * Creates and initializes an instance of this class.
     * @constructor
     * @param {string} resultId - The result id.
     * @param {ResultReason} reason - The reason.
     * @param {string} errorDetails - Error details, if provided.
     * @param {PropertyCollection} properties - Additional properties, if provided.
     */ function SynthesisResult(resultId, reason, errorDetails, properties) {
        this.privResultId = resultId;
        this.privReason = reason;
        this.privErrorDetails = errorDetails;
        this.privProperties = properties;
    }
    Object.defineProperty(SynthesisResult.prototype, "resultId", {
        /**
         * Specifies the result identifier.
         * @member SynthesisResult.prototype.resultId
         * @function
         * @public
         * @returns {string} Specifies the result identifier.
         */ get: function() {
            return this.privResultId;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SynthesisResult.prototype, "reason", {
        /**
         * Specifies status of the result.
         * @member SynthesisResult.prototype.reason
         * @function
         * @public
         * @returns {ResultReason} Specifies status of the result.
         */ get: function() {
            return this.privReason;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SynthesisResult.prototype, "errorDetails", {
        /**
         * In case of an unsuccessful synthesis, provides details of the occurred error.
         * @member SynthesisResult.prototype.errorDetails
         * @function
         * @public
         * @returns {string} a brief description of an error.
         */ get: function() {
            return this.privErrorDetails;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SynthesisResult.prototype, "properties", {
        /**
         * The set of properties exposed in the result.
         * @member SynthesisResult.prototype.properties
         * @function
         * @public
         * @returns {PropertyCollection} The set of properties exposed in the result.
         */ get: function() {
            return this.privProperties;
        },
        enumerable: false,
        configurable: true
    });
    return SynthesisResult;
}();
module.exports.SynthesisResult = $8561bd79c62b85b3$var$SynthesisResult;

});

parcelRequire.register("ijvif", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
var $d552468d3170d465$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SpeechSynthesisResult = void 0;

var $hM4QX = parcelRequire("hM4QX");
/**
 * Defines result of speech synthesis.
 * @class SpeechSynthesisResult
 * Added in version 1.11.0
 */ var $d552468d3170d465$var$SpeechSynthesisResult = /** @class */ function(_super) {
    $d552468d3170d465$var$__extends(SpeechSynthesisResult, _super);
    /**
     * Creates and initializes an instance of this class.
     * @constructor
     * @param {string} resultId - The result id.
     * @param {ResultReason} reason - The reason.
     * @param {ArrayBuffer} audioData - The synthesized audio binary.
     * @param {string} errorDetails - Error details, if provided.
     * @param {PropertyCollection} properties - Additional properties, if provided.
     * @param {number} audioDuration - The audio duration.
     */ function SpeechSynthesisResult(resultId, reason, audioData, errorDetails, properties, audioDuration) {
        var _this = _super.call(this, resultId, reason, errorDetails, properties) || this;
        _this.privAudioData = audioData;
        _this.privAudioDuration = audioDuration;
        return _this;
    }
    Object.defineProperty(SpeechSynthesisResult.prototype, "audioData", {
        /**
         * The synthesized audio data
         * @member SpeechSynthesisResult.prototype.audioData
         * @function
         * @public
         * @returns {ArrayBuffer} The synthesized audio data.
         */ get: function() {
            return this.privAudioData;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SpeechSynthesisResult.prototype, "audioDuration", {
        /**
         * The time duration of synthesized audio, in ticks (100 nanoseconds).
         * @member SpeechSynthesisResult.prototype.audioDuration
         * @function
         * @public
         * @returns {number} The time duration of synthesized audio.
         */ get: function() {
            return this.privAudioDuration;
        },
        enumerable: false,
        configurable: true
    });
    return SpeechSynthesisResult;
}($hM4QX.SynthesisResult);
module.exports.SpeechSynthesisResult = $d552468d3170d465$var$SpeechSynthesisResult;

});

parcelRequire.register("bAXfe", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SpeechSynthesisEventArgs = void 0;
/**
 * Defines contents of speech synthesis events.
 * @class SpeechSynthesisEventArgs
 * Added in version 1.11.0
 */ var $871103467b334497$var$SpeechSynthesisEventArgs = /** @class */ function() {
    /**
     * Creates and initializes an instance of this class.
     * @constructor
     * @param {SpeechSynthesisResult} result - The speech synthesis result.
     */ function SpeechSynthesisEventArgs(result) {
        this.privResult = result;
    }
    Object.defineProperty(SpeechSynthesisEventArgs.prototype, "result", {
        /**
         * Specifies the synthesis result.
         * @member SpeechSynthesisEventArgs.prototype.result
         * @function
         * @public
         * @returns {SpeechSynthesisResult} the synthesis result.
         */ get: function() {
            return this.privResult;
        },
        enumerable: false,
        configurable: true
    });
    return SpeechSynthesisEventArgs;
}();
module.exports.SpeechSynthesisEventArgs = $871103467b334497$var$SpeechSynthesisEventArgs;

});

parcelRequire.register("yArfV", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SpeechSynthesisWordBoundaryEventArgs = void 0;
/**
 * Defines contents of speech synthesis word boundary event.
 * @class SpeechSynthesisWordBoundaryEventArgs
 * Added in version 1.11.0
 */ var $067f710a3d6dea0f$var$SpeechSynthesisWordBoundaryEventArgs = /** @class */ function() {
    /**
     * Creates and initializes an instance of this class.
     * @constructor
     * @param {number} audioOffset - The audio offset.
     * @param {number} duration - The audio duration.
     * @param {string} text - The text.
     * @param {number} wordLength - The length of the word.
     * @param {number} textOffset - The text offset.
     * @param {SpeechSynthesisBoundaryType} boundaryType - The boundary type
     */ function SpeechSynthesisWordBoundaryEventArgs(audioOffset, duration, text, wordLength, textOffset, boundaryType) {
        this.privAudioOffset = audioOffset;
        this.privDuration = duration;
        this.privText = text;
        this.privWordLength = wordLength;
        this.privTextOffset = textOffset;
        this.privBoundaryType = boundaryType;
    }
    Object.defineProperty(SpeechSynthesisWordBoundaryEventArgs.prototype, "audioOffset", {
        /**
         * Specifies the audio offset.
         * @member SpeechSynthesisWordBoundaryEventArgs.prototype.audioOffset
         * @function
         * @public
         * @returns {number} the audio offset.
         */ get: function() {
            return this.privAudioOffset;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SpeechSynthesisWordBoundaryEventArgs.prototype, "duration", {
        /**
         * Specifies the duration, in ticks (100 nanoseconds).
         * @member SpeechSynthesisWordBoundaryEventArgs.prototype.duration
         * @function
         * @public
         * @returns {number} Duration in 100 nanosecond increments.
         */ get: function() {
            return this.privDuration;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SpeechSynthesisWordBoundaryEventArgs.prototype, "text", {
        /**
         * Specifies the text of the word boundary event.
         * @member SpeechSynthesisWordBoundaryEventArgs.prototype.text
         * @function
         * @public
         * @returns {string} the text.
         */ get: function() {
            return this.privText;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SpeechSynthesisWordBoundaryEventArgs.prototype, "wordLength", {
        /**
         * Specifies the word length
         * @member SpeechSynthesisWordBoundaryEventArgs.prototype.wordLength
         * @function
         * @public
         * @returns {number} the word length
         */ get: function() {
            return this.privWordLength;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SpeechSynthesisWordBoundaryEventArgs.prototype, "textOffset", {
        /**
         * Specifies the text offset.
         * @member SpeechSynthesisWordBoundaryEventArgs.prototype.textOffset
         * @function
         * @public
         * @returns {number} the text offset.
         */ get: function() {
            return this.privTextOffset;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SpeechSynthesisWordBoundaryEventArgs.prototype, "boundaryType", {
        /**
         * Specifies the boundary type.
         * @member SpeechSynthesisWordBoundaryEventArgs.prototype.boundaryType
         * @function
         * @public
         * @returns {SpeechSynthesisBoundaryType} the boundary type.
         */ get: function() {
            return this.privBoundaryType;
        },
        enumerable: false,
        configurable: true
    });
    return SpeechSynthesisWordBoundaryEventArgs;
}();
module.exports.SpeechSynthesisWordBoundaryEventArgs = $067f710a3d6dea0f$var$SpeechSynthesisWordBoundaryEventArgs;

});

parcelRequire.register("jBQ4L", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SpeechSynthesisBookmarkEventArgs = void 0;
/**
 * Defines contents of speech synthesis bookmark event.
 * @class SpeechSynthesisBookmarkEventArgs
 * Added in version 1.16.0
 */ var $e469de387661a005$var$SpeechSynthesisBookmarkEventArgs = /** @class */ function() {
    /**
     * Creates and initializes an instance of this class.
     * @constructor
     * @param {number} audioOffset - The audio offset.
     * @param {string} text - The bookmark text.
     */ function SpeechSynthesisBookmarkEventArgs(audioOffset, text) {
        this.privAudioOffset = audioOffset;
        this.privText = text;
    }
    Object.defineProperty(SpeechSynthesisBookmarkEventArgs.prototype, "audioOffset", {
        /**
         * Specifies the audio offset.
         * @member SpeechSynthesisBookmarkEventArgs.prototype.audioOffset
         * @function
         * @public
         * @returns {number} the audio offset.
         */ get: function() {
            return this.privAudioOffset;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SpeechSynthesisBookmarkEventArgs.prototype, "text", {
        /**
         * Specifies the bookmark.
         * @member SpeechSynthesisBookmarkEventArgs.prototype.text
         * @function
         * @public
         * @returns {string} the bookmark text.
         */ get: function() {
            return this.privText;
        },
        enumerable: false,
        configurable: true
    });
    return SpeechSynthesisBookmarkEventArgs;
}();
module.exports.SpeechSynthesisBookmarkEventArgs = $e469de387661a005$var$SpeechSynthesisBookmarkEventArgs;

});

parcelRequire.register("c40Gm", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SpeechSynthesisVisemeEventArgs = void 0;
/**
 * Defines contents of speech synthesis viseme event.
 * @class SpeechSynthesisVisemeEventArgs
 * Added in version 1.16.0
 */ var $8c86633dc4383822$var$SpeechSynthesisVisemeEventArgs = /** @class */ function() {
    /**
     * Creates and initializes an instance of this class.
     * @constructor
     * @param {number} audioOffset - The audio offset.
     * @param {number} visemeId - The viseme ID.
     * @param {string} animation - The animation, could be in svg or other format.
     */ function SpeechSynthesisVisemeEventArgs(audioOffset, visemeId, animation) {
        this.privAudioOffset = audioOffset;
        this.privVisemeId = visemeId;
        this.privAnimation = animation;
    }
    Object.defineProperty(SpeechSynthesisVisemeEventArgs.prototype, "audioOffset", {
        /**
         * Specifies the audio offset.
         * @member SpeechSynthesisVisemeEventArgs.prototype.audioOffset
         * @function
         * @public
         * @returns {number} the audio offset.
         */ get: function() {
            return this.privAudioOffset;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SpeechSynthesisVisemeEventArgs.prototype, "visemeId", {
        /**
         * Specifies the viseme ID.
         * @member SpeechSynthesisVisemeEventArgs.prototype.visemeId
         * @function
         * @public
         * @returns {number} the viseme ID.
         */ get: function() {
            return this.privVisemeId;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SpeechSynthesisVisemeEventArgs.prototype, "animation", {
        /**
         * Specifies the animation.
         * @member SpeechSynthesisVisemeEventArgs.prototype.animation
         * @function
         * @public
         * @returns {string} the animation, could be in svg or other format.
         */ get: function() {
            return this.privAnimation;
        },
        enumerable: false,
        configurable: true
    });
    return SpeechSynthesisVisemeEventArgs;
}();
module.exports.SpeechSynthesisVisemeEventArgs = $8c86633dc4383822$var$SpeechSynthesisVisemeEventArgs;

});

parcelRequire.register("5Y2xz", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SpeechSynthesisBoundaryType = void 0;
/**
 * Defines the boundary type of speech synthesis boundary event.
 * @class SpeechSynthesisBoundaryType
 * Added in version 1.21.0
 */ var $458486d11aca66e0$var$SpeechSynthesisBoundaryType;
(function(SpeechSynthesisBoundaryType) {
    /**
     * Indicates the boundary text is a word.
     * @member SpeechSynthesisBoundaryType.Word
     */ SpeechSynthesisBoundaryType["Word"] = "WordBoundary";
    /**
     * Indicates the boundary text is a punctuation.
     * @member SpeechSynthesisBoundaryType.Punctuation
     */ SpeechSynthesisBoundaryType["Punctuation"] = "PunctuationBoundary";
    /**
     * Indicates the boundary text is a sentence.
     * @member SpeechSynthesisBoundaryType.Sentence
     */ SpeechSynthesisBoundaryType["Sentence"] = "SentenceBoundary";
})($458486d11aca66e0$var$SpeechSynthesisBoundaryType = module.exports.SpeechSynthesisBoundaryType || (module.exports.SpeechSynthesisBoundaryType = {}));

});

parcelRequire.register("9HGHW", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
var $7109420cb54c3086$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SynthesisVoicesResult = void 0;

var $hM4QX = parcelRequire("hM4QX");
/**
 * Defines result of speech synthesis.
 * @class SynthesisVoicesResult
 * Added in version 1.20.0
 */ var $7109420cb54c3086$var$SynthesisVoicesResult = /** @class */ function(_super) {
    $7109420cb54c3086$var$__extends(SynthesisVoicesResult, _super);
    /**
     * Creates and initializes an instance of this class.
     * @constructor
     * @param requestId - result id for request.
     * @param json - json payload from endpoint.
     */ function SynthesisVoicesResult(requestId, json, errorDetails) {
        var _this = this;
        if (Array.isArray(json)) {
            _this = _super.call(this, requestId, $hM4QX.ResultReason.VoicesListRetrieved, undefined, new $hM4QX.PropertyCollection()) || this;
            _this.privVoices = [];
            for(var _i = 0, json_1 = json; _i < json_1.length; _i++){
                var item = json_1[_i];
                _this.privVoices.push(new $hM4QX.VoiceInfo(item));
            }
        } else _this = _super.call(this, requestId, $hM4QX.ResultReason.Canceled, errorDetails ? errorDetails : "Error information unavailable", new $hM4QX.PropertyCollection()) || this;
        return _this;
    }
    Object.defineProperty(SynthesisVoicesResult.prototype, "voices", {
        /**
         * The list of voices
         * @member SynthesisVoicesResult.prototype.voices
         * @function
         * @public
         * @returns {VoiceInfo[]} List of synthesized voices.
         */ get: function() {
            return this.privVoices;
        },
        enumerable: false,
        configurable: true
    });
    return SynthesisVoicesResult;
}($hM4QX.SynthesisResult);
module.exports.SynthesisVoicesResult = $7109420cb54c3086$var$SynthesisVoicesResult;

});

parcelRequire.register("aomNU", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.VoiceInfo = module.exports.SynthesisVoiceType = module.exports.SynthesisVoiceGender = void 0;
/**
 * Defines the gender of synthesis voices.
 * Added in version 1.20.0.
 */ var $790dd5aeb6b85663$var$SynthesisVoiceGender;
(function(SynthesisVoiceGender) {
    /** Gender unknown */ SynthesisVoiceGender[SynthesisVoiceGender["Unknown"] = 0] = "Unknown";
    /** Female voice */ SynthesisVoiceGender[SynthesisVoiceGender["Female"] = 1] = "Female";
    /** Male voice */ SynthesisVoiceGender[SynthesisVoiceGender["Male"] = 2] = "Male";
})($790dd5aeb6b85663$var$SynthesisVoiceGender = module.exports.SynthesisVoiceGender || (module.exports.SynthesisVoiceGender = {}));
var $790dd5aeb6b85663$var$SynthesisVoiceType;
(function(SynthesisVoiceType) {
    SynthesisVoiceType[SynthesisVoiceType["OnlineNeural"] = 1] = "OnlineNeural";
    SynthesisVoiceType[SynthesisVoiceType["OnlineStandard"] = 2] = "OnlineStandard";
    SynthesisVoiceType[SynthesisVoiceType["OfflineNeural"] = 3] = "OfflineNeural";
    SynthesisVoiceType[SynthesisVoiceType["OfflineStandard"] = 4] = "OfflineStandard";
})($790dd5aeb6b85663$var$SynthesisVoiceType = module.exports.SynthesisVoiceType || (module.exports.SynthesisVoiceType = {}));
/**
 * Information about Speech Synthesis voice
 * Added in version 1.20.0.
 * @class VoiceInfo
 */ var $790dd5aeb6b85663$var$VoiceInfo = /** @class */ function() {
    function VoiceInfo(json) {
        this.privStyleList = [];
        this.privVoicePath = "";
        if (!!json) {
            this.privName = json.Name;
            this.privLocale = json.Locale;
            this.privShortName = json.ShortName;
            this.privLocaleName = json.LocaleName;
            this.privLocalName = json.LocalName;
            this.privVoiceType = json.VoiceType.endsWith("Standard") ? $790dd5aeb6b85663$var$SynthesisVoiceType.OnlineStandard : $790dd5aeb6b85663$var$SynthesisVoiceType.OnlineNeural;
            this.privGender = json.Gender === "Male" ? $790dd5aeb6b85663$var$SynthesisVoiceGender.Male : json.Gender === "Female" ? $790dd5aeb6b85663$var$SynthesisVoiceGender.Female : $790dd5aeb6b85663$var$SynthesisVoiceGender.Unknown;
            if (!!json.StyleList && Array.isArray(json.StyleList)) for(var _i = 0, _a = json.StyleList; _i < _a.length; _i++){
                var style = _a[_i];
                this.privStyleList.push(style);
            }
        }
    }
    Object.defineProperty(VoiceInfo.prototype, "name", {
        get: function() {
            return this.privName;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(VoiceInfo.prototype, "locale", {
        get: function() {
            return this.privLocale;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(VoiceInfo.prototype, "shortName", {
        get: function() {
            return this.privShortName;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(VoiceInfo.prototype, "localName", {
        get: function() {
            return this.privLocalName;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(VoiceInfo.prototype, "localeName", {
        get: function() {
            return this.privLocaleName;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(VoiceInfo.prototype, "gender", {
        get: function() {
            return this.privGender;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(VoiceInfo.prototype, "voiceType", {
        get: function() {
            return this.privVoiceType;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(VoiceInfo.prototype, "styleList", {
        get: function() {
            return this.privStyleList;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(VoiceInfo.prototype, "voicePath", {
        get: function() {
            return this.privVoicePath;
        },
        enumerable: false,
        configurable: true
    });
    return VoiceInfo;
}();
module.exports.VoiceInfo = $790dd5aeb6b85663$var$VoiceInfo;

});

parcelRequire.register("dKDy8", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
var $a02e3ff09da1f5c2$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $a02e3ff09da1f5c2$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $a02e3ff09da1f5c2$var$_a;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SpeakerAudioDestination = void 0;

var $dEkJU = parcelRequire("dEkJU");

var $em8BD = parcelRequire("em8BD");

var $aBCur = parcelRequire("aBCur");

var $kQmaR = parcelRequire("kQmaR");
var $a02e3ff09da1f5c2$var$MediaDurationPlaceholderSeconds = 1800;
var $a02e3ff09da1f5c2$var$AudioFormatToMimeType = ($a02e3ff09da1f5c2$var$_a = {}, $a02e3ff09da1f5c2$var$_a[$kQmaR.AudioFormatTag.PCM] = "audio/wav", $a02e3ff09da1f5c2$var$_a[$kQmaR.AudioFormatTag.MuLaw] = "audio/x-wav", $a02e3ff09da1f5c2$var$_a[$kQmaR.AudioFormatTag.MP3] = "audio/mpeg", $a02e3ff09da1f5c2$var$_a[$kQmaR.AudioFormatTag.OGG_OPUS] = "audio/ogg", $a02e3ff09da1f5c2$var$_a[$kQmaR.AudioFormatTag.WEBM_OPUS] = "audio/webm; codecs=opus", $a02e3ff09da1f5c2$var$_a[$kQmaR.AudioFormatTag.ALaw] = "audio/x-wav", $a02e3ff09da1f5c2$var$_a[$kQmaR.AudioFormatTag.FLAC] = "audio/flac", $a02e3ff09da1f5c2$var$_a);
/**
 * Represents the speaker playback audio destination, which only works in browser.
 * Note: the SDK will try to use <a href="https://www.w3.org/TR/media-source/">Media Source Extensions</a> to play audio.
 * Mp3 format has better supports on Microsoft Edge, Chrome and Safari (desktop), so, it's better to specify mp3 format for playback.
 * @class SpeakerAudioDestination
 * Updated in version 1.17.0
 */ var $a02e3ff09da1f5c2$var$SpeakerAudioDestination = /** @class */ function() {
    function SpeakerAudioDestination(audioDestinationId) {
        this.privPlaybackStarted = false;
        this.privAppendingToBuffer = false;
        this.privMediaSourceOpened = false;
        this.privBytesReceived = 0;
        this.privId = audioDestinationId ? audioDestinationId : $em8BD.createNoDashGuid();
        this.privIsPaused = false;
        this.privIsClosed = false;
    }
    SpeakerAudioDestination.prototype.id = function() {
        return this.privId;
    };
    SpeakerAudioDestination.prototype.write = function(buffer, cb, err) {
        if (this.privAudioBuffer !== undefined) {
            this.privAudioBuffer.push(buffer);
            this.updateSourceBuffer().then(function() {
                if (!!cb) cb();
            }, function(error) {
                if (!!err) err(error);
            });
        } else if (this.privAudioOutputStream !== undefined) {
            this.privAudioOutputStream.write(buffer);
            this.privBytesReceived += buffer.byteLength;
        }
    };
    SpeakerAudioDestination.prototype.close = function(cb, err) {
        var _this = this;
        this.privIsClosed = true;
        if (this.privSourceBuffer !== undefined) this.handleSourceBufferUpdateEnd().then(function() {
            if (!!cb) cb();
        }, function(error) {
            if (!!err) err(error);
        });
        else if (this.privAudioOutputStream !== undefined && typeof window !== "undefined") {
            if ((this.privFormat.formatTag === $kQmaR.AudioFormatTag.PCM || this.privFormat.formatTag === $kQmaR.AudioFormatTag.MuLaw || this.privFormat.formatTag === $kQmaR.AudioFormatTag.ALaw) && this.privFormat.hasHeader === false) {
                // eslint-disable-next-line no-console
                console.warn("Play back is not supported for raw PCM, mulaw or alaw format without header.");
                if (!!this.onAudioEnd) this.onAudioEnd(this);
            } else {
                var receivedAudio_1 = new ArrayBuffer(this.privBytesReceived);
                this.privAudioOutputStream.read(receivedAudio_1).then(function() {
                    receivedAudio_1 = $dEkJU.SynthesisAdapterBase.addHeader(receivedAudio_1, _this.privFormat);
                    var audioBlob = new Blob([
                        receivedAudio_1
                    ], {
                        type: $a02e3ff09da1f5c2$var$AudioFormatToMimeType[_this.privFormat.formatTag]
                    });
                    _this.privAudio.src = window.URL.createObjectURL(audioBlob);
                    _this.notifyPlayback().then(function() {
                        if (!!cb) cb();
                    }, function(error) {
                        if (!!err) err(error);
                    });
                }, function(error) {
                    if (!!err) err(error);
                });
            }
        } else // unsupported format, call onAudioEnd directly.
        if (!!this.onAudioEnd) this.onAudioEnd(this);
    };
    Object.defineProperty(SpeakerAudioDestination.prototype, "format", {
        set: function(format) {
            var _this = this;
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            if (typeof AudioContext !== "undefined" || typeof window !== "undefined" && typeof window.webkitAudioContext !== "undefined") {
                this.privFormat = format;
                var mimeType_1 = $a02e3ff09da1f5c2$var$AudioFormatToMimeType[this.privFormat.formatTag];
                if (mimeType_1 === undefined) // eslint-disable-next-line no-console
                console.warn("Unknown mimeType for format " + $kQmaR.AudioFormatTag[this.privFormat.formatTag] + "; playback is not supported.");
                else if (typeof MediaSource !== "undefined" && MediaSource.isTypeSupported(mimeType_1)) {
                    this.privAudio = new Audio();
                    this.privAudioBuffer = [];
                    this.privMediaSource = new MediaSource();
                    this.privAudio.src = URL.createObjectURL(this.privMediaSource);
                    this.privAudio.load();
                    this.privMediaSource.onsourceopen = function() {
                        _this.privMediaSourceOpened = true;
                        _this.privMediaSource.duration = $a02e3ff09da1f5c2$var$MediaDurationPlaceholderSeconds;
                        _this.privSourceBuffer = _this.privMediaSource.addSourceBuffer(mimeType_1);
                        _this.privSourceBuffer.onupdate = function() {
                            _this.updateSourceBuffer().catch(function(reason) {
                                $em8BD.Events.instance.onEvent(new $em8BD.BackgroundEvent(reason));
                            });
                        };
                        _this.privSourceBuffer.onupdateend = function() {
                            _this.handleSourceBufferUpdateEnd().catch(function(reason) {
                                $em8BD.Events.instance.onEvent(new $em8BD.BackgroundEvent(reason));
                            });
                        };
                        _this.privSourceBuffer.onupdatestart = function() {
                            _this.privAppendingToBuffer = false;
                        };
                    };
                    this.updateSourceBuffer().catch(function(reason) {
                        $em8BD.Events.instance.onEvent(new $em8BD.BackgroundEvent(reason));
                    });
                } else {
                    // eslint-disable-next-line no-console
                    console.warn("Format " + $kQmaR.AudioFormatTag[this.privFormat.formatTag] + " could not be played by MSE, streaming playback is not enabled.");
                    this.privAudioOutputStream = new $aBCur.PullAudioOutputStreamImpl();
                    this.privAudioOutputStream.format = this.privFormat;
                    this.privAudio = new Audio();
                }
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SpeakerAudioDestination.prototype, "volume", {
        get: function() {
            var _a, _b;
            return (_b = (_a = this.privAudio) === null || _a === void 0 ? void 0 : _a.volume) !== null && _b !== void 0 ? _b : -1;
        },
        set: function(volume) {
            if (!!this.privAudio) this.privAudio.volume = volume;
        },
        enumerable: false,
        configurable: true
    });
    SpeakerAudioDestination.prototype.mute = function() {
        if (!!this.privAudio) this.privAudio.muted = true;
    };
    SpeakerAudioDestination.prototype.unmute = function() {
        if (!!this.privAudio) this.privAudio.muted = false;
    };
    Object.defineProperty(SpeakerAudioDestination.prototype, "isClosed", {
        get: function() {
            return this.privIsClosed;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SpeakerAudioDestination.prototype, "currentTime", {
        get: function() {
            if (this.privAudio !== undefined) return this.privAudio.currentTime;
            return -1;
        },
        enumerable: false,
        configurable: true
    });
    SpeakerAudioDestination.prototype.pause = function() {
        if (!this.privIsPaused && this.privAudio !== undefined) {
            this.privAudio.pause();
            this.privIsPaused = true;
        }
    };
    SpeakerAudioDestination.prototype.resume = function(cb, err) {
        if (this.privIsPaused && this.privAudio !== undefined) {
            this.privAudio.play().then(function() {
                if (!!cb) cb();
            }, function(error) {
                if (!!err) err(error);
            });
            this.privIsPaused = false;
        }
    };
    Object.defineProperty(SpeakerAudioDestination.prototype, "internalAudio", {
        get: function() {
            return this.privAudio;
        },
        enumerable: false,
        configurable: true
    });
    SpeakerAudioDestination.prototype.updateSourceBuffer = function() {
        return $a02e3ff09da1f5c2$var$__awaiter(this, void 0, void 0, function() {
            var binary;
            return $a02e3ff09da1f5c2$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!(this.privAudioBuffer !== undefined && this.privAudioBuffer.length > 0 && this.sourceBufferAvailable())) return [
                            3 /*break*/ ,
                            2
                        ];
                        this.privAppendingToBuffer = true;
                        binary = this.privAudioBuffer.shift();
                        try {
                            this.privSourceBuffer.appendBuffer(binary);
                        } catch (error) {
                            this.privAudioBuffer.unshift(binary);
                            // eslint-disable-next-line no-console
                            console.log("buffer filled, pausing addition of binaries until space is made");
                            return [
                                2 /*return*/ 
                            ];
                        }
                        return [
                            4 /*yield*/ ,
                            this.notifyPlayback()
                        ];
                    case 1:
                        _a.sent();
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 2:
                        if (!this.canEndStream()) return [
                            3 /*break*/ ,
                            4
                        ];
                        return [
                            4 /*yield*/ ,
                            this.handleSourceBufferUpdateEnd()
                        ];
                    case 3:
                        _a.sent();
                        _a.label = 4;
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    SpeakerAudioDestination.prototype.handleSourceBufferUpdateEnd = function() {
        return $a02e3ff09da1f5c2$var$__awaiter(this, void 0, void 0, function() {
            return $a02e3ff09da1f5c2$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!(this.canEndStream() && this.sourceBufferAvailable())) return [
                            3 /*break*/ ,
                            2
                        ];
                        this.privMediaSource.endOfStream();
                        return [
                            4 /*yield*/ ,
                            this.notifyPlayback()
                        ];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    SpeakerAudioDestination.prototype.notifyPlayback = function() {
        return $a02e3ff09da1f5c2$var$__awaiter(this, void 0, void 0, function() {
            var _this = this;
            return $a02e3ff09da1f5c2$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!(!this.privPlaybackStarted && this.privAudio !== undefined)) return [
                            3 /*break*/ ,
                            2
                        ];
                        this.privPlaybackStarted = true;
                        if (!!this.onAudioStart) this.onAudioStart(this);
                        this.privAudio.onended = function() {
                            if (!!_this.onAudioEnd) _this.onAudioEnd(_this);
                        };
                        if (!!this.privIsPaused) return [
                            3 /*break*/ ,
                            2
                        ];
                        return [
                            4 /*yield*/ ,
                            this.privAudio.play()
                        ];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    SpeakerAudioDestination.prototype.canEndStream = function() {
        return this.isClosed && this.privSourceBuffer !== undefined && this.privAudioBuffer.length === 0 && this.privMediaSourceOpened && !this.privAppendingToBuffer && this.privMediaSource.readyState === "open";
    };
    SpeakerAudioDestination.prototype.sourceBufferAvailable = function() {
        return this.privSourceBuffer !== undefined && !this.privSourceBuffer.updating;
    };
    return SpeakerAudioDestination;
}();
module.exports.SpeakerAudioDestination = $a02e3ff09da1f5c2$var$SpeakerAudioDestination;

});

parcelRequire.register("jjUPK", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
var $e10be0a81f9db66c$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ConversationTranscriptionCanceledEventArgs = void 0;

var $bUeFN = parcelRequire("bUeFN");
/**
 * Defines content of a RecognitionErrorEvent.
 * @class ConversationTranscriptionCanceledEventArgs
 */ var $e10be0a81f9db66c$var$ConversationTranscriptionCanceledEventArgs = /** @class */ function(_super) {
    $e10be0a81f9db66c$var$__extends(ConversationTranscriptionCanceledEventArgs, _super);
    function ConversationTranscriptionCanceledEventArgs() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return ConversationTranscriptionCanceledEventArgs;
}($bUeFN.CancellationEventArgsBase);
module.exports.ConversationTranscriptionCanceledEventArgs = $e10be0a81f9db66c$var$ConversationTranscriptionCanceledEventArgs;

});

parcelRequire.register("1yr2l", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PronunciationAssessmentGradingSystem = void 0;
/**
 * Defines the point system for pronunciation score calibration; default value is FivePoint.
 * Added in version 1.15.0
 * @class PronunciationAssessmentGradingSystem
 */ var $121df061e103830c$var$PronunciationAssessmentGradingSystem;
(function(PronunciationAssessmentGradingSystem) {
    /**
     * Five point calibration
     * @member PronunciationAssessmentGradingSystem.FivePoint
     */ PronunciationAssessmentGradingSystem[PronunciationAssessmentGradingSystem["FivePoint"] = 1] = "FivePoint";
    /**
     * Hundred mark
     * @member PronunciationAssessmentGradingSystem.HundredMark
     */ PronunciationAssessmentGradingSystem[PronunciationAssessmentGradingSystem["HundredMark"] = 2] = "HundredMark";
})($121df061e103830c$var$PronunciationAssessmentGradingSystem = module.exports.PronunciationAssessmentGradingSystem || (module.exports.PronunciationAssessmentGradingSystem = {}));

});

parcelRequire.register("lqGfe", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PronunciationAssessmentGranularity = void 0;
/**
 * Defines the pronunciation evaluation granularity; default value is Phoneme.
 * Added in version 1.15.0
 * @class PronunciationAssessmentGranularity
 */ var $f99ccb9b1baa5c1b$var$PronunciationAssessmentGranularity;
(function(PronunciationAssessmentGranularity) {
    /**
     * Shows the score on the full text, word and phoneme level
     * @member PronunciationAssessmentGranularity.Phoneme
     */ PronunciationAssessmentGranularity[PronunciationAssessmentGranularity["Phoneme"] = 1] = "Phoneme";
    /**
     * Shows the score on the full text and word level
     * @member PronunciationAssessmentGranularity.Word
     */ PronunciationAssessmentGranularity[PronunciationAssessmentGranularity["Word"] = 2] = "Word";
    /**
     * Shows the score on the full text level only
     * @member PronunciationAssessmentGranularity.FullText
     */ PronunciationAssessmentGranularity[PronunciationAssessmentGranularity["FullText"] = 3] = "FullText";
})($f99ccb9b1baa5c1b$var$PronunciationAssessmentGranularity = module.exports.PronunciationAssessmentGranularity || (module.exports.PronunciationAssessmentGranularity = {}));

});

parcelRequire.register("cyCZy", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PronunciationAssessmentConfig = void 0;

var $gBGZx = parcelRequire("gBGZx");

var $hM4QX = parcelRequire("hM4QX");
/**
 * Pronunciation assessment configuration.
 * @class PronunciationAssessmentConfig
 * Added in version 1.15.0.
 */ var $9246e7f8ec9f18fc$var$PronunciationAssessmentConfig = /** @class */ function() {
    /**
     * PronunciationAssessmentConfig constructor.
     * @constructor
     * @param {string} referenceText
     * @param gradingSystem
     * @param granularity
     * @param enableMiscue
     */ function PronunciationAssessmentConfig(referenceText, gradingSystem, granularity, enableMiscue) {
        if (gradingSystem === void 0) gradingSystem = $hM4QX.PronunciationAssessmentGradingSystem.FivePoint;
        if (granularity === void 0) granularity = $hM4QX.PronunciationAssessmentGranularity.Phoneme;
        if (enableMiscue === void 0) enableMiscue = false;
        $gBGZx.Contracts.throwIfNullOrUndefined(referenceText, "referenceText");
        this.privProperties = new $hM4QX.PropertyCollection();
        this.privProperties.setProperty($hM4QX.PropertyId.PronunciationAssessment_ReferenceText, referenceText);
        this.privProperties.setProperty($hM4QX.PropertyId.PronunciationAssessment_GradingSystem, $hM4QX.PronunciationAssessmentGradingSystem[gradingSystem]);
        this.privProperties.setProperty($hM4QX.PropertyId.PronunciationAssessment_Granularity, $hM4QX.PronunciationAssessmentGranularity[granularity]);
        this.privProperties.setProperty($hM4QX.PropertyId.PronunciationAssessment_EnableMiscue, String(enableMiscue));
    }
    /**
     * @member PronunciationAssessmentConfig.fromJSON
     * @function
     * @public
     * @param {string} json The json string containing the pronunciation assessment parameters.
     * @return {PronunciationAssessmentConfig} Instance of PronunciationAssessmentConfig
     * @summary Creates an instance of the PronunciationAssessmentConfig from json.
     */ PronunciationAssessmentConfig.fromJSON = function(json) {
        $gBGZx.Contracts.throwIfNullOrUndefined(json, "json");
        var config = new PronunciationAssessmentConfig("");
        config.privProperties = new $hM4QX.PropertyCollection();
        config.properties.setProperty($hM4QX.PropertyId.PronunciationAssessment_Json, json);
        return config;
    };
    PronunciationAssessmentConfig.prototype.toJSON = function() {
        this.updateJson();
        return this.privProperties.getProperty($hM4QX.PropertyId.PronunciationAssessment_Params);
    };
    PronunciationAssessmentConfig.prototype.applyTo = function(recognizer) {
        this.updateJson();
        var recoBase = recognizer.internalData;
        recoBase.speechContext.setPronunciationAssessmentParams(this.properties.getProperty($hM4QX.PropertyId.PronunciationAssessment_Params));
    };
    Object.defineProperty(PronunciationAssessmentConfig.prototype, "referenceText", {
        /**
         * Gets the reference text.
         * @member PronunciationAssessmentConfig.prototype.referenceText
         * @function
         * @public
         * @returns {string} Reference text.
         */ get: function() {
            return this.properties.getProperty($hM4QX.PropertyId.PronunciationAssessment_ReferenceText);
        },
        /**
         * Gets/Sets the reference text.
         * @member PronunciationAssessmentConfig.prototype.referenceText
         * @function
         * @public
         * @param {string} referenceText - Reference text.
         */ set: function(referenceText) {
            $gBGZx.Contracts.throwIfNullOrWhitespace(referenceText, "referenceText");
            this.properties.setProperty($hM4QX.PropertyId.PronunciationAssessment_ReferenceText, referenceText);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PronunciationAssessmentConfig.prototype, "phonemeAlphabet", {
        /**
         * Sets the phoneme alphabet.
         * The valid values are "SAPI" (default) and "IPA".
         * Added in version 1.20.0
         * @member PronunciationAssessmentConfig.prototype.phonemeAlphabet
         * @function
         * @public
         * @param {string} phonemeAlphabet - Phoneme alphabet.
         */ set: function(phonemeAlphabet) {
            $gBGZx.Contracts.throwIfNullOrWhitespace(phonemeAlphabet, "phonemeAlphabet");
            this.privPhonemeAlphabet = phonemeAlphabet;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PronunciationAssessmentConfig.prototype, "enableMiscue", {
        /**
         * Gets the boolean enableMiscue property.
         * Added in version 1.26.0
         * @member PronunciationAssessmentConfig.prototype.enableMiscue
         * @function
         * @public
         * @return {boolean} enableMiscue - enable miscue.
         */ get: function() {
            var enableMiscueString = this.properties.getProperty($hM4QX.PropertyId.PronunciationAssessment_EnableMiscue, "false");
            return enableMiscueString.toLowerCase() === "true";
        },
        /**
         * Sets the boolean enableMiscue property.
         * Added in version 1.26.0
         * @member PronunciationAssessmentConfig.prototype.enableMiscue
         * @function
         * @public
         * @param {boolean} enableMiscue - enable miscue.
         */ set: function(enableMiscue) {
            var enableMiscueString = enableMiscue ? "true" : "false";
            this.properties.setProperty($hM4QX.PropertyId.PronunciationAssessment_EnableMiscue, enableMiscueString);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PronunciationAssessmentConfig.prototype, "nbestPhonemeCount", {
        /**
         * Sets the nbest phoneme count
         * Added in version 1.20.0
         * @member PronunciationAssessmentConfig.prototype.nbestPhonemeCount
         * @function
         * @public
         * @param {number} nbestPhonemeCount - NBest phoneme count.
         */ set: function(nbestPhonemeCount) {
            this.privNBestPhonemeCount = nbestPhonemeCount;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PronunciationAssessmentConfig.prototype, "properties", {
        /**
         * @member PronunciationAssessmentConfig.prototype.properties
         * @function
         * @public
         * @return {PropertyCollection} Properties of the config.
         * @summary Gets a pronunciation assessment config properties
         */ get: function() {
            return this.privProperties;
        },
        enumerable: false,
        configurable: true
    });
    PronunciationAssessmentConfig.prototype.updateJson = function() {
        var jsonString = this.privProperties.getProperty($hM4QX.PropertyId.PronunciationAssessment_Json, "{}");
        var paramsJson = JSON.parse(jsonString);
        var referenceText = this.privProperties.getProperty($hM4QX.PropertyId.PronunciationAssessment_ReferenceText);
        if (referenceText) paramsJson.referenceText = referenceText;
        var gradingSystem = this.privProperties.getProperty($hM4QX.PropertyId.PronunciationAssessment_GradingSystem);
        if (gradingSystem) paramsJson.gradingSystem = gradingSystem;
        var granularity = this.privProperties.getProperty($hM4QX.PropertyId.PronunciationAssessment_Granularity);
        if (granularity) paramsJson.granularity = granularity;
        if (this.privPhonemeAlphabet) paramsJson.phonemeAlphabet = this.privPhonemeAlphabet;
        if (this.privNBestPhonemeCount) paramsJson.nbestPhonemeCount = this.privNBestPhonemeCount;
        // always set dimension to Comprehensive
        paramsJson.dimension = "Comprehensive";
        paramsJson.enableMiscue = this.enableMiscue;
        this.privProperties.setProperty($hM4QX.PropertyId.PronunciationAssessment_Params, JSON.stringify(paramsJson));
    };
    return PronunciationAssessmentConfig;
}();
module.exports.PronunciationAssessmentConfig = $9246e7f8ec9f18fc$var$PronunciationAssessmentConfig;

});

parcelRequire.register("5MDwd", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PronunciationAssessmentResult = void 0;

var $gBGZx = parcelRequire("gBGZx");

var $hM4QX = parcelRequire("hM4QX");
/**
 * Pronunciation assessment results.
 * @class PronunciationAssessmentResult
 * Added in version 1.15.0.
 */ var $43601708cf5c7f68$var$PronunciationAssessmentResult = /** @class */ function() {
    function PronunciationAssessmentResult(jsonString) {
        var j = JSON.parse(jsonString);
        $gBGZx.Contracts.throwIfNullOrUndefined(j.NBest[0], "NBest");
        this.privPronJson = j.NBest[0];
    }
    /**
     * @member PronunciationAssessmentResult.fromResult
     * @function
     * @public
     * @param {RecognitionResult} result The recognition result.
     * @return {PronunciationAssessmentConfig} Instance of PronunciationAssessmentConfig
     * @summary Creates an instance of the PronunciationAssessmentResult from recognition result.
     */ PronunciationAssessmentResult.fromResult = function(result) {
        $gBGZx.Contracts.throwIfNullOrUndefined(result, "result");
        var json = result.properties.getProperty($hM4QX.PropertyId.SpeechServiceResponse_JsonResult);
        $gBGZx.Contracts.throwIfNullOrUndefined(json, "json");
        return new PronunciationAssessmentResult(json);
    };
    Object.defineProperty(PronunciationAssessmentResult.prototype, "detailResult", {
        /**
         * Gets the detail result of pronunciation assessment.
         * @member PronunciationAssessmentConfig.prototype.detailResult
         * @function
         * @public
         * @returns {DetailResult} detail result.
         */ get: function() {
            return this.privPronJson;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PronunciationAssessmentResult.prototype, "accuracyScore", {
        /**
         * The score indicating the pronunciation accuracy of the given speech, which indicates
         * how closely the phonemes match a native speaker's pronunciation.
         * @member PronunciationAssessmentResult.prototype.accuracyScore
         * @function
         * @public
         * @returns {number} Accuracy score.
         */ get: function() {
            return this.detailResult.PronunciationAssessment.AccuracyScore;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PronunciationAssessmentResult.prototype, "pronunciationScore", {
        /**
         * The overall score indicating the pronunciation quality of the given speech.
         * This is calculated from AccuracyScore, FluencyScore and CompletenessScore with weight.
         * @member PronunciationAssessmentResult.prototype.pronunciationScore
         * @function
         * @public
         * @returns {number} Pronunciation score.
         */ get: function() {
            return this.detailResult.PronunciationAssessment.PronScore;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PronunciationAssessmentResult.prototype, "completenessScore", {
        /**
         * The score indicating the completeness of the given speech by calculating the ratio of pronounced words towards entire input.
         * @member PronunciationAssessmentResult.prototype.completenessScore
         * @function
         * @public
         * @returns {number} Completeness score.
         */ get: function() {
            return this.detailResult.PronunciationAssessment.CompletenessScore;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PronunciationAssessmentResult.prototype, "fluencyScore", {
        /**
         * The score indicating the fluency of the given speech.
         * @member PronunciationAssessmentResult.prototype.fluencyScore
         * @function
         * @public
         * @returns {number} Fluency score.
         */ get: function() {
            return this.detailResult.PronunciationAssessment.FluencyScore;
        },
        enumerable: false,
        configurable: true
    });
    return PronunciationAssessmentResult;
}();
module.exports.PronunciationAssessmentResult = $43601708cf5c7f68$var$PronunciationAssessmentResult;

});

parcelRequire.register("39i8h", function(module, exports) {
"use strict";
//
// Copyright (c) Microsoft. All rights reserved.
// Licensed under the MIT license. See LICENSE.md file in the project root for full license information.
//
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Diagnostics = void 0;

var $j1V0D = parcelRequire("j1V0D");

var $em8BD = parcelRequire("em8BD");
/**
 * Defines diagnostics API for managing console output
 * Added in version 1.21.0
 */ var $24b04721d8c23d13$var$Diagnostics = /** @class */ function() {
    function Diagnostics() {}
    Diagnostics.SetLoggingLevel = function(logLevel) {
        this.privListener = new $j1V0D.ConsoleLoggingListener(logLevel);
        $em8BD.Events.instance.attachConsoleListener(this.privListener);
    };
    Diagnostics.StartConsoleOutput = function() {
        if (!!this.privListener) this.privListener.enableConsoleOutput = true;
    };
    Diagnostics.StopConsoleOutput = function() {
        if (!!this.privListener) this.privListener.enableConsoleOutput = false;
    };
    Diagnostics.SetLogOutputPath = function(path) {
        if (typeof window === "undefined") {
            if (!!this.privListener) this.privListener.logPath = path;
        } else throw new Error("File system logging not available in browser.");
    };
    Diagnostics.privListener = undefined;
    return Diagnostics;
}();
module.exports.Diagnostics = $24b04721d8c23d13$var$Diagnostics;

});



parcelRequire.register("kz9bS", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
var $ef8e349501e37116$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.VoiceProfileConnectionFactory = module.exports.SpeakerRecognitionConnectionFactory = void 0;

var $j1V0D = parcelRequire("j1V0D");

var $hM4QX = parcelRequire("hM4QX");

var $hGMva = parcelRequire("hGMva");

var $dEkJU = parcelRequire("dEkJU");

var $btbfh = parcelRequire("btbfh");
var $ef8e349501e37116$var$SpeakerRecognitionConnectionFactoryBase = /** @class */ function(_super) {
    $ef8e349501e37116$var$__extends(SpeakerRecognitionConnectionFactoryBase, _super);
    function SpeakerRecognitionConnectionFactoryBase() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SpeakerRecognitionConnectionFactoryBase.prototype.create = function(config, authInfo, endpointPath, connectionId) {
        var endpoint = config.parameters.getProperty($hM4QX.PropertyId.SpeechServiceConnection_Endpoint);
        if (!endpoint) {
            var region = config.parameters.getProperty($hM4QX.PropertyId.SpeechServiceConnection_Region);
            var hostSuffix = $hGMva.ConnectionFactoryBase.getHostSuffix(region);
            var host = config.parameters.getProperty($hM4QX.PropertyId.SpeechServiceConnection_Host, "wss://" + region + ".spr-frontend.speech" + hostSuffix);
            var scenario = config.parameters.getProperty($hM4QX.PropertyId.SpeechServiceConnection_SpeakerIdMode, "TextIndependentIdentification");
            endpoint = host + "/speaker/ws/" + this.scenarioToPath(scenario) + "/" + endpointPath;
        }
        var queryParams = {
            format: "simple",
            language: config.parameters.getProperty($hM4QX.PropertyId.SpeechServiceConnection_RecoLanguage)
        };
        this.setCommonUrlParams(config, queryParams, endpoint);
        var headers = {};
        if (authInfo.token !== undefined && authInfo.token !== "") headers[authInfo.headerName] = authInfo.token;
        headers[$btbfh.HeaderNames.ConnectionId] = connectionId;
        headers[$btbfh.HeaderNames.SpIDAuthKey] = config.parameters.getProperty($hM4QX.PropertyId.SpeechServiceConnection_Key);
        config.parameters.setProperty($hM4QX.PropertyId.SpeechServiceConnection_Url, endpoint);
        var enableCompression = config.parameters.getProperty("SPEECH-EnableWebsocketCompression", "false") === "true";
        return new $j1V0D.WebsocketConnection(endpoint, queryParams, headers, new $dEkJU.WebsocketMessageFormatter(), $j1V0D.ProxyInfo.fromRecognizerConfig(config), enableCompression, connectionId);
    };
    SpeakerRecognitionConnectionFactoryBase.prototype.scenarioToPath = function(mode) {
        switch(mode){
            case "TextIndependentVerification":
            case "2":
                return "verification/text-independent";
            case "TextDependentVerification":
            case "1":
                return "verification/text-dependent";
            default:
                return "identification/text-independent";
        }
    };
    return SpeakerRecognitionConnectionFactoryBase;
}($hGMva.ConnectionFactoryBase);
var $ef8e349501e37116$var$SpeakerRecognitionConnectionFactory = /** @class */ function(_super) {
    $ef8e349501e37116$var$__extends(SpeakerRecognitionConnectionFactory, _super);
    function SpeakerRecognitionConnectionFactory() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SpeakerRecognitionConnectionFactory.prototype.create = function(config, authInfo, connectionId) {
        return _super.prototype.create.call(this, config, authInfo, "recognition", connectionId);
    };
    return SpeakerRecognitionConnectionFactory;
}($ef8e349501e37116$var$SpeakerRecognitionConnectionFactoryBase);
module.exports.SpeakerRecognitionConnectionFactory = $ef8e349501e37116$var$SpeakerRecognitionConnectionFactory;
var $ef8e349501e37116$var$VoiceProfileConnectionFactory = /** @class */ function(_super) {
    $ef8e349501e37116$var$__extends(VoiceProfileConnectionFactory, _super);
    function VoiceProfileConnectionFactory() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    VoiceProfileConnectionFactory.prototype.create = function(config, authInfo, connectionId) {
        return _super.prototype.create.call(this, config, authInfo, "profile", connectionId);
    };
    return VoiceProfileConnectionFactory;
}($ef8e349501e37116$var$SpeakerRecognitionConnectionFactoryBase);
module.exports.VoiceProfileConnectionFactory = $ef8e349501e37116$var$VoiceProfileConnectionFactory;

});

parcelRequire.register("7AiNN", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
/* eslint-disable max-classes-per-file */ var $585a7ae8436ad0ee$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RecognitionEndedEvent = module.exports.RecognitionCompletionStatus = module.exports.RecognitionStartedEvent = module.exports.ConnectingToServiceEvent = module.exports.ListeningStartedEvent = module.exports.RecognitionTriggeredEvent = module.exports.SpeechRecognitionEvent = void 0;

var $em8BD = parcelRequire("em8BD");
var $585a7ae8436ad0ee$var$SpeechRecognitionEvent = /** @class */ function(_super) {
    $585a7ae8436ad0ee$var$__extends(SpeechRecognitionEvent, _super);
    function SpeechRecognitionEvent(eventName, requestId, sessionId, eventType) {
        if (eventType === void 0) eventType = $em8BD.EventType.Info;
        var _this = _super.call(this, eventName, eventType) || this;
        _this.privRequestId = requestId;
        _this.privSessionId = sessionId;
        return _this;
    }
    Object.defineProperty(SpeechRecognitionEvent.prototype, "requestId", {
        get: function() {
            return this.privRequestId;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SpeechRecognitionEvent.prototype, "sessionId", {
        get: function() {
            return this.privSessionId;
        },
        enumerable: false,
        configurable: true
    });
    return SpeechRecognitionEvent;
}($em8BD.PlatformEvent);
module.exports.SpeechRecognitionEvent = $585a7ae8436ad0ee$var$SpeechRecognitionEvent;
var $585a7ae8436ad0ee$var$RecognitionTriggeredEvent = /** @class */ function(_super) {
    $585a7ae8436ad0ee$var$__extends(RecognitionTriggeredEvent, _super);
    function RecognitionTriggeredEvent(requestId, sessionId, audioSourceId, audioNodeId) {
        var _this = _super.call(this, "RecognitionTriggeredEvent", requestId, sessionId) || this;
        _this.privAudioSourceId = audioSourceId;
        _this.privAudioNodeId = audioNodeId;
        return _this;
    }
    Object.defineProperty(RecognitionTriggeredEvent.prototype, "audioSourceId", {
        get: function() {
            return this.privAudioSourceId;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(RecognitionTriggeredEvent.prototype, "audioNodeId", {
        get: function() {
            return this.privAudioNodeId;
        },
        enumerable: false,
        configurable: true
    });
    return RecognitionTriggeredEvent;
}($585a7ae8436ad0ee$var$SpeechRecognitionEvent);
module.exports.RecognitionTriggeredEvent = $585a7ae8436ad0ee$var$RecognitionTriggeredEvent;
var $585a7ae8436ad0ee$var$ListeningStartedEvent = /** @class */ function(_super) {
    $585a7ae8436ad0ee$var$__extends(ListeningStartedEvent, _super);
    function ListeningStartedEvent(requestId, sessionId, audioSourceId, audioNodeId) {
        var _this = _super.call(this, "ListeningStartedEvent", requestId, sessionId) || this;
        _this.privAudioSourceId = audioSourceId;
        _this.privAudioNodeId = audioNodeId;
        return _this;
    }
    Object.defineProperty(ListeningStartedEvent.prototype, "audioSourceId", {
        get: function() {
            return this.privAudioSourceId;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ListeningStartedEvent.prototype, "audioNodeId", {
        get: function() {
            return this.privAudioNodeId;
        },
        enumerable: false,
        configurable: true
    });
    return ListeningStartedEvent;
}($585a7ae8436ad0ee$var$SpeechRecognitionEvent);
module.exports.ListeningStartedEvent = $585a7ae8436ad0ee$var$ListeningStartedEvent;
var $585a7ae8436ad0ee$var$ConnectingToServiceEvent = /** @class */ function(_super) {
    $585a7ae8436ad0ee$var$__extends(ConnectingToServiceEvent, _super);
    function ConnectingToServiceEvent(requestId, authFetchEventid, sessionId) {
        var _this = _super.call(this, "ConnectingToServiceEvent", requestId, sessionId) || this;
        _this.privAuthFetchEventid = authFetchEventid;
        return _this;
    }
    Object.defineProperty(ConnectingToServiceEvent.prototype, "authFetchEventid", {
        get: function() {
            return this.privAuthFetchEventid;
        },
        enumerable: false,
        configurable: true
    });
    return ConnectingToServiceEvent;
}($585a7ae8436ad0ee$var$SpeechRecognitionEvent);
module.exports.ConnectingToServiceEvent = $585a7ae8436ad0ee$var$ConnectingToServiceEvent;
var $585a7ae8436ad0ee$var$RecognitionStartedEvent = /** @class */ function(_super) {
    $585a7ae8436ad0ee$var$__extends(RecognitionStartedEvent, _super);
    function RecognitionStartedEvent(requestId, audioSourceId, audioNodeId, authFetchEventId, sessionId) {
        var _this = _super.call(this, "RecognitionStartedEvent", requestId, sessionId) || this;
        _this.privAudioSourceId = audioSourceId;
        _this.privAudioNodeId = audioNodeId;
        _this.privAuthFetchEventId = authFetchEventId;
        return _this;
    }
    Object.defineProperty(RecognitionStartedEvent.prototype, "audioSourceId", {
        get: function() {
            return this.privAudioSourceId;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(RecognitionStartedEvent.prototype, "audioNodeId", {
        get: function() {
            return this.privAudioNodeId;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(RecognitionStartedEvent.prototype, "authFetchEventId", {
        get: function() {
            return this.privAuthFetchEventId;
        },
        enumerable: false,
        configurable: true
    });
    return RecognitionStartedEvent;
}($585a7ae8436ad0ee$var$SpeechRecognitionEvent);
module.exports.RecognitionStartedEvent = $585a7ae8436ad0ee$var$RecognitionStartedEvent;
var $585a7ae8436ad0ee$var$RecognitionCompletionStatus;
(function(RecognitionCompletionStatus) {
    RecognitionCompletionStatus[RecognitionCompletionStatus["Success"] = 0] = "Success";
    RecognitionCompletionStatus[RecognitionCompletionStatus["AudioSourceError"] = 1] = "AudioSourceError";
    RecognitionCompletionStatus[RecognitionCompletionStatus["AudioSourceTimeout"] = 2] = "AudioSourceTimeout";
    RecognitionCompletionStatus[RecognitionCompletionStatus["AuthTokenFetchError"] = 3] = "AuthTokenFetchError";
    RecognitionCompletionStatus[RecognitionCompletionStatus["AuthTokenFetchTimeout"] = 4] = "AuthTokenFetchTimeout";
    RecognitionCompletionStatus[RecognitionCompletionStatus["UnAuthorized"] = 5] = "UnAuthorized";
    RecognitionCompletionStatus[RecognitionCompletionStatus["ConnectTimeout"] = 6] = "ConnectTimeout";
    RecognitionCompletionStatus[RecognitionCompletionStatus["ConnectError"] = 7] = "ConnectError";
    RecognitionCompletionStatus[RecognitionCompletionStatus["ClientRecognitionActivityTimeout"] = 8] = "ClientRecognitionActivityTimeout";
    RecognitionCompletionStatus[RecognitionCompletionStatus["UnknownError"] = 9] = "UnknownError";
})($585a7ae8436ad0ee$var$RecognitionCompletionStatus = module.exports.RecognitionCompletionStatus || (module.exports.RecognitionCompletionStatus = {}));
var $585a7ae8436ad0ee$var$RecognitionEndedEvent = /** @class */ function(_super) {
    $585a7ae8436ad0ee$var$__extends(RecognitionEndedEvent, _super);
    function RecognitionEndedEvent(requestId, audioSourceId, audioNodeId, authFetchEventId, sessionId, serviceTag, status, error) {
        var _this = _super.call(this, "RecognitionEndedEvent", requestId, sessionId, status === $585a7ae8436ad0ee$var$RecognitionCompletionStatus.Success ? $em8BD.EventType.Info : $em8BD.EventType.Error) || this;
        _this.privAudioSourceId = audioSourceId;
        _this.privAudioNodeId = audioNodeId;
        _this.privAuthFetchEventId = authFetchEventId;
        _this.privStatus = status;
        _this.privError = error;
        _this.privServiceTag = serviceTag;
        return _this;
    }
    Object.defineProperty(RecognitionEndedEvent.prototype, "audioSourceId", {
        get: function() {
            return this.privAudioSourceId;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(RecognitionEndedEvent.prototype, "audioNodeId", {
        get: function() {
            return this.privAudioNodeId;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(RecognitionEndedEvent.prototype, "authFetchEventId", {
        get: function() {
            return this.privAuthFetchEventId;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(RecognitionEndedEvent.prototype, "serviceTag", {
        get: function() {
            return this.privServiceTag;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(RecognitionEndedEvent.prototype, "status", {
        get: function() {
            return this.privStatus;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(RecognitionEndedEvent.prototype, "error", {
        get: function() {
            return this.privError;
        },
        enumerable: false,
        configurable: true
    });
    return RecognitionEndedEvent;
}($585a7ae8436ad0ee$var$SpeechRecognitionEvent);
module.exports.RecognitionEndedEvent = $585a7ae8436ad0ee$var$RecognitionEndedEvent;

});

parcelRequire.register("2bNJW", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
var $19833130d38670f8$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $19833130d38670f8$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ServiceRecognizerBase = void 0;

var $j1V0D = parcelRequire("j1V0D");

var $em8BD = parcelRequire("em8BD");

var $hM4QX = parcelRequire("hM4QX");

var $dEkJU = parcelRequire("dEkJU");

var $bhJcv = parcelRequire("bhJcv");
var $19833130d38670f8$var$ServiceRecognizerBase = /** @class */ function() {
    function ServiceRecognizerBase(authentication, connectionFactory, audioSource, recognizerConfig, recognizer) {
        var _this = this;
        // A promise for a configured connection.
        // Do not consume directly, call fetchConnection instead.
        this.privConnectionConfigurationPromise = undefined;
        // A promise for a connection, but one that has not had the speech context sent yet.
        // Do not consume directly, call fetchConnection instead.
        this.privConnectionPromise = undefined;
        this.privSetTimeout = setTimeout;
        this.privIsLiveAudio = false;
        this.recognizeOverride = undefined;
        this.recognizeSpeaker = undefined;
        this.disconnectOverride = undefined;
        this.receiveMessageOverride = undefined;
        this.sendPrePayloadJSONOverride = undefined;
        this.postConnectImplOverride = undefined;
        this.configConnectionOverride = undefined;
        this.handleSpeechPhraseMessage = undefined;
        this.handleSpeechHypothesisMessage = undefined;
        if (!authentication) throw new $em8BD.ArgumentNullError("authentication");
        if (!connectionFactory) throw new $em8BD.ArgumentNullError("connectionFactory");
        if (!audioSource) throw new $em8BD.ArgumentNullError("audioSource");
        if (!recognizerConfig) throw new $em8BD.ArgumentNullError("recognizerConfig");
        this.privMustReportEndOfStream = false;
        this.privAuthentication = authentication;
        this.privConnectionFactory = connectionFactory;
        this.privAudioSource = audioSource;
        this.privRecognizerConfig = recognizerConfig;
        this.privIsDisposed = false;
        this.privRecognizer = recognizer;
        this.privRequestSession = new $dEkJU.RequestSession(this.privAudioSource.id());
        this.privConnectionEvents = new $em8BD.EventSource();
        this.privServiceEvents = new $em8BD.EventSource();
        this.privDynamicGrammar = new $dEkJU.DynamicGrammarBuilder();
        this.privSpeechContext = new $dEkJU.SpeechContext(this.privDynamicGrammar);
        this.privAgentConfig = new $dEkJU.AgentConfig();
        if (typeof Blob !== "undefined" && typeof Worker !== "undefined") this.privSetTimeout = $em8BD.Timeout.setTimeout;
        this.connectionEvents.attach(function(connectionEvent) {
            if (connectionEvent.name === "ConnectionClosedEvent") {
                var connectionClosedEvent = connectionEvent;
                if (connectionClosedEvent.statusCode === 1003 || connectionClosedEvent.statusCode === 1007 || connectionClosedEvent.statusCode === 1002 || connectionClosedEvent.statusCode === 4000 || _this.privRequestSession.numConnectionAttempts > _this.privRecognizerConfig.maxRetryCount) _this.cancelRecognitionLocal($hM4QX.CancellationReason.Error, connectionClosedEvent.statusCode === 1007 ? $hM4QX.CancellationErrorCode.BadRequestParameters : $hM4QX.CancellationErrorCode.ConnectionFailure, connectionClosedEvent.reason + " websocket error code: " + connectionClosedEvent.statusCode);
            }
        });
        var phraseDetection = {};
        if (recognizerConfig.autoDetectSourceLanguages !== undefined) {
            var sourceLanguages = recognizerConfig.autoDetectSourceLanguages.split(",");
            var speechContextLidMode = void 0;
            if (recognizerConfig.languageIdMode === "Continuous") speechContextLidMode = "DetectContinuous";
            else speechContextLidMode = "DetectAtAudioStart";
            this.privSpeechContext.setSection("languageId", {
                Priority: "PrioritizeLatency",
                languages: sourceLanguages,
                mode: speechContextLidMode,
                onSuccess: {
                    action: "Recognize"
                },
                onUnknown: {
                    action: "None"
                }
            });
            this.privSpeechContext.setSection("phraseOutput", {
                interimResults: {
                    resultType: "Auto"
                },
                phraseResults: {
                    resultType: "Always"
                }
            });
            var customModels = recognizerConfig.sourceLanguageModels;
            if (customModels !== undefined) {
                phraseDetection.customModels = customModels;
                phraseDetection.onInterim = {
                    action: "None"
                };
                phraseDetection.onSuccess = {
                    action: "None"
                };
            }
        }
        var isEmpty = function(obj) {
            // eslint-disable-next-line guard-for-in, brace-style
            for(var x in obj)return false;
            return true;
        };
        if (!isEmpty(phraseDetection)) this.privSpeechContext.setSection("phraseDetection", phraseDetection);
    }
    ServiceRecognizerBase.prototype.setSpeechSegmentationTimeout = function() {
        var speechSegmentationTimeout = this.privRecognizerConfig.parameters.getProperty($hM4QX.PropertyId.Speech_SegmentationSilenceTimeoutMs, undefined);
        if (speechSegmentationTimeout !== undefined) {
            var mode = this.recognitionMode === $dEkJU.RecognitionMode.Conversation ? "CONVERSATION" : this.recognitionMode === $dEkJU.RecognitionMode.Dictation ? "DICTATION" : "INTERACTIVE";
            var segmentationSilenceTimeoutMs = parseInt(speechSegmentationTimeout, 10);
            var phraseDetection = this.privSpeechContext.getSection("phraseDetection");
            phraseDetection.mode = mode;
            phraseDetection[mode] = {
                segmentation: {
                    mode: "Custom",
                    segmentationSilenceTimeoutMs: segmentationSilenceTimeoutMs
                }
            };
            this.privSpeechContext.setSection("phraseDetection", phraseDetection);
        }
    };
    Object.defineProperty(ServiceRecognizerBase.prototype, "audioSource", {
        get: function() {
            return this.privAudioSource;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ServiceRecognizerBase.prototype, "speechContext", {
        get: function() {
            return this.privSpeechContext;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ServiceRecognizerBase.prototype, "dynamicGrammar", {
        get: function() {
            return this.privDynamicGrammar;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ServiceRecognizerBase.prototype, "agentConfig", {
        get: function() {
            return this.privAgentConfig;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ServiceRecognizerBase.prototype, "conversationTranslatorToken", {
        set: function(token) {
            this.privRecognizerConfig.parameters.setProperty($hM4QX.PropertyId.ConversationTranslator_Token, token);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ServiceRecognizerBase.prototype, "voiceProfileType", {
        set: function(type) {
            this.privRecognizerConfig.parameters.setProperty($hM4QX.PropertyId.SpeechServiceConnection_SpeakerIdMode, type);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ServiceRecognizerBase.prototype, "authentication", {
        set: function(auth) {
            this.privAuthentication = this.authentication;
        },
        enumerable: false,
        configurable: true
    });
    ServiceRecognizerBase.prototype.isDisposed = function() {
        return this.privIsDisposed;
    };
    ServiceRecognizerBase.prototype.dispose = function(reason) {
        return $19833130d38670f8$var$__awaiter(this, void 0, void 0, function() {
            var connection, error_1;
            return $19833130d38670f8$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        this.privIsDisposed = true;
                        if (!(this.privConnectionConfigurationPromise !== undefined)) return [
                            3 /*break*/ ,
                            5
                        ];
                        _a.label = 1;
                    case 1:
                        _a.trys.push([
                            1,
                            4,
                            ,
                            5
                        ]);
                        return [
                            4 /*yield*/ ,
                            this.privConnectionConfigurationPromise
                        ];
                    case 2:
                        connection = _a.sent();
                        return [
                            4 /*yield*/ ,
                            connection.dispose(reason)
                        ];
                    case 3:
                        _a.sent();
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 4:
                        error_1 = _a.sent();
                        // The connection is in a bad state. But we're trying to kill it, so...
                        return [
                            2 /*return*/ 
                        ];
                    case 5:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    Object.defineProperty(ServiceRecognizerBase.prototype, "connectionEvents", {
        get: function() {
            return this.privConnectionEvents;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ServiceRecognizerBase.prototype, "serviceEvents", {
        get: function() {
            return this.privServiceEvents;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ServiceRecognizerBase.prototype, "recognitionMode", {
        get: function() {
            return this.privRecognizerConfig.recognitionMode;
        },
        enumerable: false,
        configurable: true
    });
    ServiceRecognizerBase.prototype.recognize = function(recoMode, successCallback, errorCallBack) {
        return $19833130d38670f8$var$__awaiter(this, void 0, void 0, function() {
            var conPromise, audioNode, audioStreamNode, format, deviceInfo, error_2, error_3, sessionStartEventArgs, audioSendPromise;
            var _this = this;
            return $19833130d38670f8$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!(this.recognizeOverride !== undefined)) return [
                            3 /*break*/ ,
                            2
                        ];
                        return [
                            4 /*yield*/ ,
                            this.recognizeOverride(recoMode, successCallback, errorCallBack)
                        ];
                    case 1:
                        _a.sent();
                        return [
                            2 /*return*/ 
                        ];
                    case 2:
                        // Clear the existing configuration promise to force a re-transmission of config and context.
                        this.privConnectionConfigurationPromise = undefined;
                        this.privRecognizerConfig.recognitionMode = recoMode;
                        this.setSpeechSegmentationTimeout();
                        this.privSuccessCallback = successCallback;
                        this.privErrorCallback = errorCallBack;
                        this.privRequestSession.startNewRecognition();
                        this.privRequestSession.listenForServiceTelemetry(this.privAudioSource.events);
                        conPromise = this.connectImpl();
                        _a.label = 3;
                    case 3:
                        _a.trys.push([
                            3,
                            8,
                            ,
                            10
                        ]);
                        return [
                            4 /*yield*/ ,
                            this.audioSource.attach(this.privRequestSession.audioNodeId)
                        ];
                    case 4:
                        audioStreamNode = _a.sent();
                        return [
                            4 /*yield*/ ,
                            this.audioSource.format
                        ];
                    case 5:
                        format = _a.sent();
                        return [
                            4 /*yield*/ ,
                            this.audioSource.deviceInfo
                        ];
                    case 6:
                        deviceInfo = _a.sent();
                        this.privIsLiveAudio = deviceInfo.type && deviceInfo.type === $dEkJU.type.Microphones;
                        audioNode = new $j1V0D.ReplayableAudioNode(audioStreamNode, format.avgBytesPerSec);
                        return [
                            4 /*yield*/ ,
                            this.privRequestSession.onAudioSourceAttachCompleted(audioNode, false)
                        ];
                    case 7:
                        _a.sent();
                        this.privRecognizerConfig.SpeechServiceConfig.Context.audio = {
                            source: deviceInfo
                        };
                        return [
                            3 /*break*/ ,
                            10
                        ];
                    case 8:
                        error_2 = _a.sent();
                        return [
                            4 /*yield*/ ,
                            this.privRequestSession.onStopRecognizing()
                        ];
                    case 9:
                        _a.sent();
                        throw error_2;
                    case 10:
                        _a.trys.push([
                            10,
                            12,
                            ,
                            14
                        ]);
                        return [
                            4 /*yield*/ ,
                            conPromise
                        ];
                    case 11:
                        _a.sent();
                        return [
                            3 /*break*/ ,
                            14
                        ];
                    case 12:
                        error_3 = _a.sent();
                        return [
                            4 /*yield*/ ,
                            this.cancelRecognitionLocal($hM4QX.CancellationReason.Error, $hM4QX.CancellationErrorCode.ConnectionFailure, error_3)
                        ];
                    case 13:
                        _a.sent();
                        return [
                            2 /*return*/ 
                        ];
                    case 14:
                        sessionStartEventArgs = new $hM4QX.SessionEventArgs(this.privRequestSession.sessionId);
                        if (!!this.privRecognizer.sessionStarted) this.privRecognizer.sessionStarted(this.privRecognizer, sessionStartEventArgs);
                        this.receiveMessage();
                        audioSendPromise = this.sendAudio(audioNode);
                        audioSendPromise.catch(function(error) {
                            return $19833130d38670f8$var$__awaiter(_this, void 0, void 0, function() {
                                return $19833130d38670f8$var$__generator(this, function(_a) {
                                    switch(_a.label){
                                        case 0:
                                            return [
                                                4 /*yield*/ ,
                                                this.cancelRecognitionLocal($hM4QX.CancellationReason.Error, $hM4QX.CancellationErrorCode.RuntimeError, error)
                                            ];
                                        case 1:
                                            _a.sent();
                                            return [
                                                2 /*return*/ 
                                            ];
                                    }
                                });
                            });
                        });
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    ServiceRecognizerBase.prototype.stopRecognizing = function() {
        return $19833130d38670f8$var$__awaiter(this, void 0, void 0, function() {
            return $19833130d38670f8$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!this.privRequestSession.isRecognizing) return [
                            3 /*break*/ ,
                            8
                        ];
                        _a.label = 1;
                    case 1:
                        _a.trys.push([
                            1,
                            ,
                            6,
                            8
                        ]);
                        return [
                            4 /*yield*/ ,
                            this.audioSource.turnOff()
                        ];
                    case 2:
                        _a.sent();
                        return [
                            4 /*yield*/ ,
                            this.sendFinalAudio()
                        ];
                    case 3:
                        _a.sent();
                        return [
                            4 /*yield*/ ,
                            this.privRequestSession.onStopRecognizing()
                        ];
                    case 4:
                        _a.sent();
                        return [
                            4 /*yield*/ ,
                            this.privRequestSession.turnCompletionPromise
                        ];
                    case 5:
                        _a.sent();
                        return [
                            3 /*break*/ ,
                            8
                        ];
                    case 6:
                        return [
                            4 /*yield*/ ,
                            this.privRequestSession.dispose()
                        ];
                    case 7:
                        _a.sent();
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 8:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    ServiceRecognizerBase.prototype.connect = function() {
        return $19833130d38670f8$var$__awaiter(this, void 0, void 0, function() {
            return $19833130d38670f8$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.connectImpl()
                        ];
                    case 1:
                        _a.sent();
                        return [
                            2 /*return*/ ,
                            Promise.resolve()
                        ];
                }
            });
        });
    };
    ServiceRecognizerBase.prototype.connectAsync = function(cb, err) {
        this.connectImpl().then(function() {
            try {
                if (!!cb) cb();
            } catch (e) {
                if (!!err) err(e);
            }
        }, function(reason) {
            try {
                if (!!err) err(reason);
            /* eslint-disable no-empty */ } catch (error) {}
        });
    };
    ServiceRecognizerBase.prototype.disconnect = function() {
        return $19833130d38670f8$var$__awaiter(this, void 0, void 0, function() {
            var error_4;
            return $19833130d38670f8$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.cancelRecognitionLocal($hM4QX.CancellationReason.Error, $hM4QX.CancellationErrorCode.NoError, "Disconnecting")
                        ];
                    case 1:
                        _a.sent();
                        if (!(this.disconnectOverride !== undefined)) return [
                            3 /*break*/ ,
                            3
                        ];
                        return [
                            4 /*yield*/ ,
                            this.disconnectOverride()
                        ];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3:
                        if (!(this.privConnectionPromise !== undefined)) return [
                            3 /*break*/ ,
                            8
                        ];
                        _a.label = 4;
                    case 4:
                        _a.trys.push([
                            4,
                            7,
                            ,
                            8
                        ]);
                        return [
                            4 /*yield*/ ,
                            this.privConnectionPromise
                        ];
                    case 5:
                        return [
                            4 /*yield*/ ,
                            _a.sent().dispose()
                        ];
                    case 6:
                        _a.sent();
                        return [
                            3 /*break*/ ,
                            8
                        ];
                    case 7:
                        error_4 = _a.sent();
                        return [
                            3 /*break*/ ,
                            8
                        ];
                    case 8:
                        this.privConnectionPromise = undefined;
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    ServiceRecognizerBase.prototype.sendMessage = function(message) {
        return;
    };
    ServiceRecognizerBase.prototype.sendNetworkMessage = function(path, payload) {
        return $19833130d38670f8$var$__awaiter(this, void 0, void 0, function() {
            var type, contentType, connection;
            return $19833130d38670f8$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        type = typeof payload === "string" ? $em8BD.MessageType.Text : $em8BD.MessageType.Binary;
                        contentType = typeof payload === "string" ? "application/json" : "";
                        return [
                            4 /*yield*/ ,
                            this.fetchConnection()
                        ];
                    case 1:
                        connection = _a.sent();
                        return [
                            2 /*return*/ ,
                            connection.send(new $bhJcv.SpeechConnectionMessage(type, path, this.privRequestSession.requestId, contentType, payload))
                        ];
                }
            });
        });
    };
    Object.defineProperty(ServiceRecognizerBase.prototype, "activityTemplate", {
        get: function() {
            return this.privActivityTemplate;
        },
        set: function(messagePayload) {
            this.privActivityTemplate = messagePayload;
        },
        enumerable: false,
        configurable: true
    });
    ServiceRecognizerBase.prototype.sendTelemetryData = function() {
        return $19833130d38670f8$var$__awaiter(this, void 0, void 0, function() {
            var telemetryData, connection;
            return $19833130d38670f8$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        telemetryData = this.privRequestSession.getTelemetry();
                        if (ServiceRecognizerBase.telemetryDataEnabled !== true || this.privIsDisposed || null === telemetryData) return [
                            2 /*return*/ 
                        ];
                        if (!!ServiceRecognizerBase.telemetryData) try {
                            ServiceRecognizerBase.telemetryData(telemetryData);
                        /* eslint-disable no-empty */ } catch (_b) {}
                        return [
                            4 /*yield*/ ,
                            this.fetchConnection()
                        ];
                    case 1:
                        connection = _a.sent();
                        return [
                            4 /*yield*/ ,
                            connection.send(new $bhJcv.SpeechConnectionMessage($em8BD.MessageType.Text, "telemetry", this.privRequestSession.requestId, "application/json", telemetryData))
                        ];
                    case 2:
                        _a.sent();
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    // Cancels recognition.
    ServiceRecognizerBase.prototype.cancelRecognitionLocal = function(cancellationReason, errorCode, error) {
        return $19833130d38670f8$var$__awaiter(this, void 0, void 0, function() {
            return $19833130d38670f8$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!!!this.privRequestSession.isRecognizing) return [
                            3 /*break*/ ,
                            2
                        ];
                        return [
                            4 /*yield*/ ,
                            this.privRequestSession.onStopRecognizing()
                        ];
                    case 1:
                        _a.sent();
                        this.cancelRecognition(this.privRequestSession.sessionId, this.privRequestSession.requestId, cancellationReason, errorCode, error);
                        _a.label = 2;
                    case 2:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    ServiceRecognizerBase.prototype.receiveMessage = function() {
        return $19833130d38670f8$var$__awaiter(this, void 0, void 0, function() {
            var connection, message, connectionMessage, _a, speechStartDetected, speechStartEventArgs, json, speechStopDetected, speechStopEventArgs, sessionStopEventArgs, error_5;
            return $19833130d38670f8$var$__generator(this, function(_b) {
                switch(_b.label){
                    case 0:
                        _b.trys.push([
                            0,
                            18,
                            ,
                            19
                        ]);
                        if (this.privIsDisposed) // We're done.
                        return [
                            2 /*return*/ 
                        ];
                        return [
                            4 /*yield*/ ,
                            this.fetchConnection()
                        ];
                    case 1:
                        connection = _b.sent();
                        return [
                            4 /*yield*/ ,
                            connection.read()
                        ];
                    case 2:
                        message = _b.sent();
                        if (this.receiveMessageOverride !== undefined) return [
                            2 /*return*/ ,
                            this.receiveMessageOverride()
                        ];
                        // indicates we are draining the queue and it came with no message;
                        if (!message) {
                            if (!this.privRequestSession.isRecognizing) return [
                                2 /*return*/ 
                            ];
                            else return [
                                2 /*return*/ ,
                                this.receiveMessage()
                            ];
                        }
                        this.privServiceHasSentMessage = true;
                        connectionMessage = $bhJcv.SpeechConnectionMessage.fromConnectionMessage(message);
                        if (!(connectionMessage.requestId.toLowerCase() === this.privRequestSession.requestId.toLowerCase())) return [
                            3 /*break*/ ,
                            17
                        ];
                        _a = connectionMessage.path.toLowerCase();
                        switch(_a){
                            case "turn.start":
                                return [
                                    3 /*break*/ ,
                                    3
                                ];
                            case "speech.startdetected":
                                return [
                                    3 /*break*/ ,
                                    4
                                ];
                            case "speech.enddetected":
                                return [
                                    3 /*break*/ ,
                                    5
                                ];
                            case "turn.end":
                                return [
                                    3 /*break*/ ,
                                    6
                                ];
                        }
                        return [
                            3 /*break*/ ,
                            15
                        ];
                    case 3:
                        this.privMustReportEndOfStream = true;
                        this.privRequestSession.onServiceTurnStartResponse();
                        return [
                            3 /*break*/ ,
                            17
                        ];
                    case 4:
                        speechStartDetected = $dEkJU.SpeechDetected.fromJSON(connectionMessage.textBody);
                        speechStartEventArgs = new $hM4QX.RecognitionEventArgs(speechStartDetected.Offset, this.privRequestSession.sessionId);
                        if (!!this.privRecognizer.speechStartDetected) this.privRecognizer.speechStartDetected(this.privRecognizer, speechStartEventArgs);
                        return [
                            3 /*break*/ ,
                            17
                        ];
                    case 5:
                        json = void 0;
                        if (connectionMessage.textBody.length > 0) json = connectionMessage.textBody;
                        else // If the request was empty, the JSON returned is empty.
                        json = "{ Offset: 0 }";
                        speechStopDetected = $dEkJU.SpeechDetected.fromJSON(json);
                        speechStopEventArgs = new $hM4QX.RecognitionEventArgs(speechStopDetected.Offset + this.privRequestSession.currentTurnAudioOffset, this.privRequestSession.sessionId);
                        if (!!this.privRecognizer.speechEndDetected) this.privRecognizer.speechEndDetected(this.privRecognizer, speechStopEventArgs);
                        return [
                            3 /*break*/ ,
                            17
                        ];
                    case 6:
                        return [
                            4 /*yield*/ ,
                            this.sendTelemetryData()
                        ];
                    case 7:
                        _b.sent();
                        if (!(this.privRequestSession.isSpeechEnded && this.privMustReportEndOfStream)) return [
                            3 /*break*/ ,
                            9
                        ];
                        this.privMustReportEndOfStream = false;
                        return [
                            4 /*yield*/ ,
                            this.cancelRecognitionLocal($hM4QX.CancellationReason.EndOfStream, $hM4QX.CancellationErrorCode.NoError, undefined)
                        ];
                    case 8:
                        _b.sent();
                        _b.label = 9;
                    case 9:
                        sessionStopEventArgs = new $hM4QX.SessionEventArgs(this.privRequestSession.sessionId);
                        return [
                            4 /*yield*/ ,
                            this.privRequestSession.onServiceTurnEndResponse(this.privRecognizerConfig.isContinuousRecognition)
                        ];
                    case 10:
                        _b.sent();
                        if (!(!this.privRecognizerConfig.isContinuousRecognition || this.privRequestSession.isSpeechEnded || !this.privRequestSession.isRecognizing)) return [
                            3 /*break*/ ,
                            11
                        ];
                        if (!!this.privRecognizer.sessionStopped) this.privRecognizer.sessionStopped(this.privRecognizer, sessionStopEventArgs);
                        return [
                            2 /*return*/ 
                        ];
                    case 11:
                        return [
                            4 /*yield*/ ,
                            this.fetchConnection()
                        ];
                    case 12:
                        connection = _b.sent();
                        return [
                            4 /*yield*/ ,
                            this.sendPrePayloadJSON(connection)
                        ];
                    case 13:
                        _b.sent();
                        _b.label = 14;
                    case 14:
                        return [
                            3 /*break*/ ,
                            17
                        ];
                    case 15:
                        return [
                            4 /*yield*/ ,
                            this.processTypeSpecificMessages(connectionMessage)
                        ];
                    case 16:
                        if (!_b.sent()) // here are some messages that the derived class has not processed, dispatch them to connect class
                        {
                            if (!!this.privServiceEvents) this.serviceEvents.onEvent(new $em8BD.ServiceEvent(connectionMessage.path.toLowerCase(), connectionMessage.textBody));
                        }
                        _b.label = 17;
                    case 17:
                        return [
                            2 /*return*/ ,
                            this.receiveMessage()
                        ];
                    case 18:
                        error_5 = _b.sent();
                        return [
                            2 /*return*/ ,
                            null
                        ];
                    case 19:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    ServiceRecognizerBase.prototype.sendSpeechContext = function(connection, generateNewRequestId) {
        var speechContextJson = this.speechContext.toJSON();
        if (generateNewRequestId) this.privRequestSession.onSpeechContext();
        if (speechContextJson) return connection.send(new $bhJcv.SpeechConnectionMessage($em8BD.MessageType.Text, "speech.context", this.privRequestSession.requestId, "application/json", speechContextJson));
        return;
    };
    ServiceRecognizerBase.prototype.noOp = function() {
        // operation not supported
        return;
    };
    // Encapsulated for derived service recognizers that need to send additional JSON
    ServiceRecognizerBase.prototype.sendPrePayloadJSON = function(connection, generateNewRequestId) {
        if (generateNewRequestId === void 0) generateNewRequestId = true;
        return $19833130d38670f8$var$__awaiter(this, void 0, void 0, function() {
            return $19833130d38670f8$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (this.sendPrePayloadJSONOverride !== undefined) return [
                            2 /*return*/ ,
                            this.sendPrePayloadJSONOverride(connection)
                        ];
                        return [
                            4 /*yield*/ ,
                            this.sendSpeechContext(connection, generateNewRequestId)
                        ];
                    case 1:
                        _a.sent();
                        return [
                            4 /*yield*/ ,
                            this.sendWaveHeader(connection)
                        ];
                    case 2:
                        _a.sent();
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    ServiceRecognizerBase.prototype.sendWaveHeader = function(connection) {
        return $19833130d38670f8$var$__awaiter(this, void 0, void 0, function() {
            var format;
            return $19833130d38670f8$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.audioSource.format
                        ];
                    case 1:
                        format = _a.sent();
                        // this.writeBufferToConsole(format.header);
                        return [
                            2 /*return*/ ,
                            connection.send(new $bhJcv.SpeechConnectionMessage($em8BD.MessageType.Binary, "audio", this.privRequestSession.requestId, "audio/x-wav", format.header))
                        ];
                }
            });
        });
    };
    // Establishes a websocket connection to the end point.
    ServiceRecognizerBase.prototype.connectImpl = function() {
        var _this = this;
        if (this.privConnectionPromise !== undefined) return this.privConnectionPromise.then(function(connection) {
            if (connection.state() === $em8BD.ConnectionState.Disconnected) {
                _this.privConnectionId = null;
                _this.privConnectionPromise = undefined;
                _this.privServiceHasSentMessage = false;
                return _this.connectImpl();
            }
            return _this.privConnectionPromise;
        }, function() {
            _this.privConnectionId = null;
            _this.privConnectionPromise = undefined;
            _this.privServiceHasSentMessage = false;
            return _this.connectImpl();
        });
        this.privConnectionPromise = this.retryableConnect();
        // Attach an empty handler to allow the promise to run in the background while
        // other startup events happen. It'll eventually be awaited on.
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        this.privConnectionPromise.catch(function() {});
        if (this.postConnectImplOverride !== undefined) return this.postConnectImplOverride(this.privConnectionPromise);
        return this.privConnectionPromise;
    };
    ServiceRecognizerBase.prototype.sendSpeechServiceConfig = function(connection, requestSession, SpeechServiceConfigJson) {
        requestSession.onSpeechContext();
        // filter out anything that is not required for the service to work.
        if (ServiceRecognizerBase.telemetryDataEnabled !== true) {
            var withTelemetry = JSON.parse(SpeechServiceConfigJson);
            var replacement = {
                context: {
                    system: withTelemetry.context.system
                }
            };
            SpeechServiceConfigJson = JSON.stringify(replacement);
        }
        if (this.privRecognizerConfig.parameters.getProperty("f0f5debc-f8c9-4892-ac4b-90a7ab359fd2", "false").toLowerCase() === "true") {
            var json = JSON.parse(SpeechServiceConfigJson);
            json.context.DisableReferenceChannel = "True";
            json.context.MicSpec = "1_0_0";
            SpeechServiceConfigJson = JSON.stringify(json);
        }
        if (SpeechServiceConfigJson) return connection.send(new $bhJcv.SpeechConnectionMessage($em8BD.MessageType.Text, "speech.config", requestSession.requestId, "application/json", SpeechServiceConfigJson));
        return;
    };
    ServiceRecognizerBase.prototype.fetchConnection = function() {
        return $19833130d38670f8$var$__awaiter(this, void 0, void 0, function() {
            var _this = this;
            return $19833130d38670f8$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (this.privConnectionConfigurationPromise !== undefined) return [
                            2 /*return*/ ,
                            this.privConnectionConfigurationPromise.then(function(connection) {
                                if (connection.state() === $em8BD.ConnectionState.Disconnected) {
                                    _this.privConnectionId = null;
                                    _this.privConnectionConfigurationPromise = undefined;
                                    _this.privServiceHasSentMessage = false;
                                    return _this.fetchConnection();
                                }
                                return _this.privConnectionConfigurationPromise;
                            }, function() {
                                _this.privConnectionId = null;
                                _this.privConnectionConfigurationPromise = undefined;
                                _this.privServiceHasSentMessage = false;
                                return _this.fetchConnection();
                            })
                        ];
                        this.privConnectionConfigurationPromise = this.configureConnection();
                        return [
                            4 /*yield*/ ,
                            this.privConnectionConfigurationPromise
                        ];
                    case 1:
                        return [
                            2 /*return*/ ,
                            _a.sent()
                        ];
                }
            });
        });
    };
    ServiceRecognizerBase.prototype.sendAudio = function(audioStreamNode) {
        return $19833130d38670f8$var$__awaiter(this, void 0, void 0, function() {
            var audioFormat, nextSendTime, fastLaneSizeMs, maxSendUnthrottledBytes, startRecogNumber, readAndUploadCycle;
            var _this = this;
            return $19833130d38670f8$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.audioSource.format
                        ];
                    case 1:
                        audioFormat = _a.sent();
                        nextSendTime = Date.now();
                        fastLaneSizeMs = this.privRecognizerConfig.parameters.getProperty("SPEECH-TransmitLengthBeforThrottleMs", "5000");
                        maxSendUnthrottledBytes = audioFormat.avgBytesPerSec / 1000 * parseInt(fastLaneSizeMs, 10);
                        startRecogNumber = this.privRequestSession.recogNumber;
                        readAndUploadCycle = function() {
                            return $19833130d38670f8$var$__awaiter(_this, void 0, void 0, function() {
                                var connection, audioStreamChunk, payload, sendDelay;
                                var _this = this;
                                return $19833130d38670f8$var$__generator(this, function(_a) {
                                    switch(_a.label){
                                        case 0:
                                            if (!(!this.privIsDisposed && !this.privRequestSession.isSpeechEnded && this.privRequestSession.isRecognizing && this.privRequestSession.recogNumber === startRecogNumber)) return [
                                                3 /*break*/ ,
                                                5
                                            ];
                                            return [
                                                4 /*yield*/ ,
                                                this.fetchConnection()
                                            ];
                                        case 1:
                                            connection = _a.sent();
                                            return [
                                                4 /*yield*/ ,
                                                audioStreamNode.read()
                                            ];
                                        case 2:
                                            audioStreamChunk = _a.sent();
                                            // we have a new audio chunk to upload.
                                            if (this.privRequestSession.isSpeechEnded) // If service already recognized audio end then don't send any more audio
                                            return [
                                                2 /*return*/ 
                                            ];
                                            payload = void 0;
                                            sendDelay = void 0;
                                            if (!audioStreamChunk || audioStreamChunk.isEnd) {
                                                payload = null;
                                                sendDelay = 0;
                                            } else {
                                                payload = audioStreamChunk.buffer;
                                                this.privRequestSession.onAudioSent(payload.byteLength);
                                                if (maxSendUnthrottledBytes >= this.privRequestSession.bytesSent) sendDelay = 0;
                                                else sendDelay = Math.max(0, nextSendTime - Date.now());
                                            }
                                            if (!(0 !== sendDelay)) return [
                                                3 /*break*/ ,
                                                4
                                            ];
                                            return [
                                                4 /*yield*/ ,
                                                this.delay(sendDelay)
                                            ];
                                        case 3:
                                            _a.sent();
                                            _a.label = 4;
                                        case 4:
                                            if (payload !== null) nextSendTime = Date.now() + payload.byteLength * 1000 / (audioFormat.avgBytesPerSec * 2);
                                            // Are we still alive?
                                            if (!this.privIsDisposed && !this.privRequestSession.isSpeechEnded && this.privRequestSession.isRecognizing && this.privRequestSession.recogNumber === startRecogNumber) {
                                                connection.send(new $bhJcv.SpeechConnectionMessage($em8BD.MessageType.Binary, "audio", this.privRequestSession.requestId, null, payload)).catch(function() {
                                                    // eslint-disable-next-line @typescript-eslint/no-empty-function
                                                    _this.privRequestSession.onServiceTurnEndResponse(_this.privRecognizerConfig.isContinuousRecognition).catch(function() {});
                                                });
                                                if (!(audioStreamChunk === null || audioStreamChunk === void 0 ? void 0 : audioStreamChunk.isEnd)) // this.writeBufferToConsole(payload);
                                                // Regardless of success or failure, schedule the next upload.
                                                // If the underlying connection was broken, the next cycle will
                                                // get a new connection and re-transmit missing audio automatically.
                                                return [
                                                    2 /*return*/ ,
                                                    readAndUploadCycle()
                                                ];
                                                else // the audio stream has been closed, no need to schedule next
                                                // read-upload cycle.
                                                if (!this.privIsLiveAudio) this.privRequestSession.onSpeechEnded();
                                            }
                                            _a.label = 5;
                                        case 5:
                                            return [
                                                2 /*return*/ 
                                            ];
                                    }
                                });
                            });
                        };
                        return [
                            2 /*return*/ ,
                            readAndUploadCycle()
                        ];
                }
            });
        });
    };
    ServiceRecognizerBase.prototype.retryableConnect = function() {
        return $19833130d38670f8$var$__awaiter(this, void 0, void 0, function() {
            var isUnAuthorized, sessionId, lastStatusCode, lastReason, authPromise, auth, connection, response;
            var _this = this;
            return $19833130d38670f8$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        isUnAuthorized = false;
                        this.privAuthFetchEventId = $em8BD.createNoDashGuid();
                        sessionId = this.privRequestSession.sessionId;
                        this.privConnectionId = sessionId !== undefined ? sessionId : $em8BD.createNoDashGuid();
                        this.privRequestSession.onPreConnectionStart(this.privAuthFetchEventId, this.privConnectionId);
                        lastStatusCode = 0;
                        lastReason = "";
                        _a.label = 1;
                    case 1:
                        if (!(this.privRequestSession.numConnectionAttempts <= this.privRecognizerConfig.maxRetryCount)) return [
                            3 /*break*/ ,
                            8
                        ];
                        authPromise = isUnAuthorized ? this.privAuthentication.fetchOnExpiry(this.privAuthFetchEventId) : this.privAuthentication.fetch(this.privAuthFetchEventId);
                        return [
                            4 /*yield*/ ,
                            authPromise
                        ];
                    case 2:
                        auth = _a.sent();
                        return [
                            4 /*yield*/ ,
                            this.privRequestSession.onAuthCompleted(false)
                        ];
                    case 3:
                        _a.sent();
                        connection = this.privConnectionFactory.create(this.privRecognizerConfig, auth, this.privConnectionId);
                        // Attach the telemetry handlers.
                        this.privRequestSession.listenForServiceTelemetry(connection.events);
                        // Attach to the underlying event. No need to hold onto the detach pointers as in the event the connection goes away,
                        // it'll stop sending events.
                        connection.events.attach(function(event) {
                            _this.connectionEvents.onEvent(event);
                        });
                        return [
                            4 /*yield*/ ,
                            connection.open()
                        ];
                    case 4:
                        response = _a.sent();
                        if (!(response.statusCode === 200)) return [
                            3 /*break*/ ,
                            6
                        ];
                        return [
                            4 /*yield*/ ,
                            this.privRequestSession.onConnectionEstablishCompleted(response.statusCode)
                        ];
                    case 5:
                        _a.sent();
                        return [
                            2 /*return*/ ,
                            Promise.resolve(connection)
                        ];
                    case 6:
                        if (response.statusCode === 1006) isUnAuthorized = true;
                        _a.label = 7;
                    case 7:
                        lastStatusCode = response.statusCode;
                        lastReason = response.reason;
                        this.privRequestSession.onRetryConnection();
                        return [
                            3 /*break*/ ,
                            1
                        ];
                    case 8:
                        return [
                            4 /*yield*/ ,
                            this.privRequestSession.onConnectionEstablishCompleted(lastStatusCode, lastReason)
                        ];
                    case 9:
                        _a.sent();
                        return [
                            2 /*return*/ ,
                            Promise.reject("Unable to contact server. StatusCode: " + lastStatusCode + ", " + this.privRecognizerConfig.parameters.getProperty($hM4QX.PropertyId.SpeechServiceConnection_Endpoint) + " Reason: " + lastReason)
                        ];
                }
            });
        });
    };
    ServiceRecognizerBase.prototype.delay = function(delayMs) {
        var _this = this;
        return new Promise(function(resolve) {
            return _this.privSetTimeout(resolve, delayMs);
        });
    };
    ServiceRecognizerBase.prototype.writeBufferToConsole = function(buffer) {
        var out = "Buffer Size: ";
        if (null === buffer) out += "null";
        else {
            var readView = new Uint8Array(buffer);
            out += buffer.byteLength + "\r\n";
            for(var i = 0; i < buffer.byteLength; i++){
                out += readView[i].toString(16).padStart(2, "0") + " ";
                if ((i + 1) % 16 === 0) {
                    // eslint-disable-next-line no-console
                    console.info(out);
                    out = "";
                }
            }
        }
        // eslint-disable-next-line no-console
        console.info(out);
    };
    ServiceRecognizerBase.prototype.sendFinalAudio = function() {
        return $19833130d38670f8$var$__awaiter(this, void 0, void 0, function() {
            var connection;
            return $19833130d38670f8$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.fetchConnection()
                        ];
                    case 1:
                        connection = _a.sent();
                        return [
                            4 /*yield*/ ,
                            connection.send(new $bhJcv.SpeechConnectionMessage($em8BD.MessageType.Binary, "audio", this.privRequestSession.requestId, null, null))
                        ];
                    case 2:
                        _a.sent();
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    // Takes an established websocket connection to the endpoint and sends speech configuration information.
    ServiceRecognizerBase.prototype.configureConnection = function() {
        return $19833130d38670f8$var$__awaiter(this, void 0, void 0, function() {
            var connection;
            return $19833130d38670f8$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.connectImpl()
                        ];
                    case 1:
                        connection = _a.sent();
                        if (this.configConnectionOverride !== undefined) return [
                            2 /*return*/ ,
                            this.configConnectionOverride(connection)
                        ];
                        return [
                            4 /*yield*/ ,
                            this.sendSpeechServiceConfig(connection, this.privRequestSession, this.privRecognizerConfig.SpeechServiceConfig.serialize())
                        ];
                    case 2:
                        _a.sent();
                        return [
                            4 /*yield*/ ,
                            this.sendPrePayloadJSON(connection, false)
                        ];
                    case 3:
                        _a.sent();
                        return [
                            2 /*return*/ ,
                            connection
                        ];
                }
            });
        });
    };
    ServiceRecognizerBase.telemetryDataEnabled = true;
    return ServiceRecognizerBase;
}();
module.exports.ServiceRecognizerBase = $19833130d38670f8$var$ServiceRecognizerBase;

});
parcelRequire.register("bhJcv", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
var $8374582b7b497603$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SpeechConnectionMessage = void 0;

var $em8BD = parcelRequire("em8BD");

var $btbfh = parcelRequire("btbfh");
var $8374582b7b497603$var$SpeechConnectionMessage = /** @class */ function(_super) {
    $8374582b7b497603$var$__extends(SpeechConnectionMessage, _super);
    function SpeechConnectionMessage(messageType, path, requestId, contentType, body, streamId, additionalHeaders, id) {
        var _this = this;
        if (!path) throw new $em8BD.ArgumentNullError("path");
        if (!requestId) throw new $em8BD.ArgumentNullError("requestId");
        var headers = {};
        headers[$btbfh.HeaderNames.Path] = path;
        headers[$btbfh.HeaderNames.RequestId] = requestId;
        headers[$btbfh.HeaderNames.RequestTimestamp] = new Date().toISOString();
        if (contentType) headers[$btbfh.HeaderNames.ContentType] = contentType;
        if (streamId) headers[$btbfh.HeaderNames.RequestStreamId] = streamId;
        if (additionalHeaders) {
            for(var headerName in additionalHeaders)if (headerName) headers[headerName] = additionalHeaders[headerName];
        }
        if (id) _this = _super.call(this, messageType, body, headers, id) || this;
        else _this = _super.call(this, messageType, body, headers) || this;
        _this.privPath = path;
        _this.privRequestId = requestId;
        _this.privContentType = contentType;
        _this.privStreamId = streamId;
        _this.privAdditionalHeaders = additionalHeaders;
        return _this;
    }
    Object.defineProperty(SpeechConnectionMessage.prototype, "path", {
        get: function() {
            return this.privPath;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SpeechConnectionMessage.prototype, "requestId", {
        get: function() {
            return this.privRequestId;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SpeechConnectionMessage.prototype, "contentType", {
        get: function() {
            return this.privContentType;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SpeechConnectionMessage.prototype, "streamId", {
        get: function() {
            return this.privStreamId;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SpeechConnectionMessage.prototype, "additionalHeaders", {
        get: function() {
            return this.privAdditionalHeaders;
        },
        enumerable: false,
        configurable: true
    });
    SpeechConnectionMessage.fromConnectionMessage = function(message) {
        var path = null;
        var requestId = null;
        var contentType = null;
        // let requestTimestamp = null;
        var streamId = null;
        var additionalHeaders = {};
        if (message.headers) {
            for(var headerName in message.headers)if (headerName) {
                if (headerName.toLowerCase() === $btbfh.HeaderNames.Path.toLowerCase()) path = message.headers[headerName];
                else if (headerName.toLowerCase() === $btbfh.HeaderNames.RequestId.toLowerCase()) requestId = message.headers[headerName];
                else if (headerName.toLowerCase() === $btbfh.HeaderNames.ContentType.toLowerCase()) contentType = message.headers[headerName];
                else if (headerName.toLowerCase() === $btbfh.HeaderNames.RequestStreamId.toLowerCase()) streamId = message.headers[headerName];
                else additionalHeaders[headerName] = message.headers[headerName];
            }
        }
        return new SpeechConnectionMessage(message.messageType, path, requestId, contentType, message.body, streamId, additionalHeaders, message.id);
    };
    return SpeechConnectionMessage;
}($em8BD.ConnectionMessage);
module.exports.SpeechConnectionMessage = $8374582b7b497603$var$SpeechConnectionMessage;

});


parcelRequire.register("363o5", function(module, exports) {
"use strict";
var $24148f4d2b7fc829$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $24148f4d2b7fc829$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $24148f4d2b7fc829$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ConversationServiceRecognizer = void 0;

var $hM4QX = parcelRequire("hM4QX");

var $dEkJU = parcelRequire("dEkJU");
var $24148f4d2b7fc829$var$ConversationServiceRecognizer = /** @class */ function(_super) {
    $24148f4d2b7fc829$var$__extends(ConversationServiceRecognizer, _super);
    function ConversationServiceRecognizer(authentication, connectionFactory, audioSource, recognizerConfig, recognizer) {
        var _this = _super.call(this, authentication, connectionFactory, audioSource, recognizerConfig, recognizer) || this;
        _this.handleSpeechPhraseMessage = function(textBody) {
            return $24148f4d2b7fc829$var$__awaiter(_this, void 0, void 0, function() {
                return $24148f4d2b7fc829$var$__generator(this, function(_a) {
                    return [
                        2 /*return*/ ,
                        this.handleSpeechPhrase(textBody)
                    ];
                });
            });
        };
        _this.handleSpeechHypothesisMessage = function(textBody) {
            return _this.handleSpeechHypothesis(textBody);
        };
        return _this;
    }
    ConversationServiceRecognizer.prototype.processTypeSpecificMessages = function(connectionMessage) {
        return;
    };
    ConversationServiceRecognizer.prototype.handleRecognizedCallback = function(result, offset, sessionId) {
        return;
    };
    ConversationServiceRecognizer.prototype.handleRecognizingCallback = function(result, duration, sessionId) {
        return;
    };
    ConversationServiceRecognizer.prototype.processSpeechMessages = function(connectionMessage) {
        return $24148f4d2b7fc829$var$__awaiter(this, void 0, void 0, function() {
            var processed, _a;
            return $24148f4d2b7fc829$var$__generator(this, function(_b) {
                switch(_b.label){
                    case 0:
                        processed = false;
                        _a = connectionMessage.path.toLowerCase();
                        switch(_a){
                            case "speech.hypothesis":
                                return [
                                    3 /*break*/ ,
                                    1
                                ];
                            case "speech.fragment":
                                return [
                                    3 /*break*/ ,
                                    1
                                ];
                            case "speech.phrase":
                                return [
                                    3 /*break*/ ,
                                    2
                                ];
                        }
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 1:
                        if (!!this.handleSpeechHypothesisMessage) this.handleSpeechHypothesisMessage(connectionMessage.textBody);
                        processed = true;
                        return [
                            3 /*break*/ ,
                            6
                        ];
                    case 2:
                        if (!!!this.handleSpeechPhraseMessage) return [
                            3 /*break*/ ,
                            4
                        ];
                        return [
                            4 /*yield*/ ,
                            this.handleSpeechPhraseMessage(connectionMessage.textBody)
                        ];
                    case 3:
                        _b.sent();
                        _b.label = 4;
                    case 4:
                        processed = true;
                        return [
                            3 /*break*/ ,
                            6
                        ];
                    case 5:
                        return [
                            3 /*break*/ ,
                            6
                        ];
                    case 6:
                        return [
                            2 /*return*/ ,
                            processed
                        ];
                }
            });
        });
    };
    ConversationServiceRecognizer.prototype.cancelRecognition = function(sessionId, requestId, cancellationReason, errorCode, error) {};
    ConversationServiceRecognizer.prototype.handleSpeechPhrase = function(textBody) {
        return $24148f4d2b7fc829$var$__awaiter(this, void 0, void 0, function() {
            var simple, resultReason, result, resultProps, simpleOffset, offset, cancelReason, cancellationErrorCode, detailed, totalOffset, offsetCorrectedJson;
            return $24148f4d2b7fc829$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        simple = $dEkJU.SimpleSpeechPhrase.fromJSON(textBody);
                        resultReason = $dEkJU.EnumTranslation.implTranslateRecognitionResult(simple.RecognitionStatus);
                        resultProps = new $hM4QX.PropertyCollection();
                        resultProps.setProperty($hM4QX.PropertyId.SpeechServiceResponse_JsonResult, textBody);
                        simpleOffset = simple.Offset + this.privRequestSession.currentTurnAudioOffset;
                        offset = simpleOffset;
                        this.privRequestSession.onPhraseRecognized(this.privRequestSession.currentTurnAudioOffset + simple.Offset + simple.Duration);
                        if (!($hM4QX.ResultReason.Canceled === resultReason)) return [
                            3 /*break*/ ,
                            2
                        ];
                        cancelReason = $dEkJU.EnumTranslation.implTranslateCancelResult(simple.RecognitionStatus);
                        cancellationErrorCode = $dEkJU.EnumTranslation.implTranslateCancelErrorCode(simple.RecognitionStatus);
                        return [
                            4 /*yield*/ ,
                            this.cancelRecognitionLocal(cancelReason, cancellationErrorCode, $dEkJU.EnumTranslation.implTranslateErrorDetails(cancellationErrorCode))
                        ];
                    case 1:
                        _a.sent();
                        return [
                            3 /*break*/ ,
                            3
                        ];
                    case 2:
                        if (!(this.privRequestSession.isSpeechEnded && resultReason === $hM4QX.ResultReason.NoMatch && simple.RecognitionStatus !== $dEkJU.RecognitionStatus.InitialSilenceTimeout)) {
                            if (this.privRecognizerConfig.parameters.getProperty($dEkJU.OutputFormatPropertyName) === $hM4QX.OutputFormat[$hM4QX.OutputFormat.Simple]) result = new $hM4QX.SpeechRecognitionResult(this.privRequestSession.requestId, resultReason, simple.DisplayText, simple.Duration, simpleOffset, simple.Language, simple.LanguageDetectionConfidence, simple.SpeakerId, undefined, textBody, resultProps);
                            else {
                                detailed = $dEkJU.DetailedSpeechPhrase.fromJSON(textBody);
                                totalOffset = detailed.Offset + this.privRequestSession.currentTurnAudioOffset;
                                offsetCorrectedJson = detailed.getJsonWithCorrectedOffsets(totalOffset);
                                result = new $hM4QX.SpeechRecognitionResult(this.privRequestSession.requestId, resultReason, detailed.Text, detailed.Duration, totalOffset, detailed.Language, detailed.LanguageDetectionConfidence, detailed.SpeakerId, undefined, offsetCorrectedJson, resultProps);
                                offset = result.offset;
                            }
                            this.handleRecognizedCallback(result, offset, this.privRequestSession.sessionId);
                        }
                        _a.label = 3;
                    case 3:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    ConversationServiceRecognizer.prototype.handleSpeechHypothesis = function(textBody) {
        var hypothesis = $dEkJU.SpeechHypothesis.fromJSON(textBody);
        var offset = hypothesis.Offset + this.privRequestSession.currentTurnAudioOffset;
        var resultProps = new $hM4QX.PropertyCollection();
        resultProps.setProperty($hM4QX.PropertyId.SpeechServiceResponse_JsonResult, textBody);
        var result = new $hM4QX.SpeechRecognitionResult(this.privRequestSession.requestId, $hM4QX.ResultReason.RecognizingSpeech, hypothesis.Text, hypothesis.Duration, offset, hypothesis.Language, hypothesis.LanguageDetectionConfidence, hypothesis.SpeakerId, undefined, textBody, resultProps);
        this.privRequestSession.onHypothesis(offset);
        this.handleRecognizingCallback(result, hypothesis.Duration, this.privRequestSession.sessionId);
    };
    return ConversationServiceRecognizer;
}($dEkJU.ServiceRecognizerBase);
module.exports.ConversationServiceRecognizer = $24148f4d2b7fc829$var$ConversationServiceRecognizer;

});

parcelRequire.register("4OrXM", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.type = module.exports.connectivity = module.exports.Device = module.exports.OS = module.exports.System = module.exports.Context = module.exports.SpeechServiceConfig = module.exports.RecognizerConfig = module.exports.SpeechResultFormat = module.exports.RecognitionMode = void 0;

var $hM4QX = parcelRequire("hM4QX");
var $381185d70a12db21$var$RecognitionMode;
(function(RecognitionMode) {
    RecognitionMode[RecognitionMode["Interactive"] = 0] = "Interactive";
    RecognitionMode[RecognitionMode["Conversation"] = 1] = "Conversation";
    RecognitionMode[RecognitionMode["Dictation"] = 2] = "Dictation";
})($381185d70a12db21$var$RecognitionMode = module.exports.RecognitionMode || (module.exports.RecognitionMode = {}));
var $381185d70a12db21$var$SpeechResultFormat;
(function(SpeechResultFormat) {
    SpeechResultFormat[SpeechResultFormat["Simple"] = 0] = "Simple";
    SpeechResultFormat[SpeechResultFormat["Detailed"] = 1] = "Detailed";
})($381185d70a12db21$var$SpeechResultFormat = module.exports.SpeechResultFormat || (module.exports.SpeechResultFormat = {}));
var $381185d70a12db21$var$RecognizerConfig = /** @class */ function() {
    function RecognizerConfig(speechServiceConfig, parameters) {
        this.privSpeechServiceConfig = speechServiceConfig ? speechServiceConfig : new $381185d70a12db21$var$SpeechServiceConfig(new $381185d70a12db21$var$Context(null));
        this.privParameters = parameters;
        this.privMaxRetryCount = parseInt(parameters.getProperty("SPEECH-Error-MaxRetryCount", "4"), 10);
        this.privLanguageIdMode = parameters.getProperty($hM4QX.PropertyId.SpeechServiceConnection_LanguageIdMode, undefined);
    }
    Object.defineProperty(RecognizerConfig.prototype, "parameters", {
        get: function() {
            return this.privParameters;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(RecognizerConfig.prototype, "recognitionMode", {
        get: function() {
            return this.privRecognitionMode;
        },
        set: function(value) {
            this.privRecognitionMode = value;
            this.privRecognitionActivityTimeout = value === $381185d70a12db21$var$RecognitionMode.Interactive ? 8000 : 25000;
            this.privSpeechServiceConfig.Recognition = $381185d70a12db21$var$RecognitionMode[value];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(RecognizerConfig.prototype, "SpeechServiceConfig", {
        get: function() {
            return this.privSpeechServiceConfig;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(RecognizerConfig.prototype, "recognitionActivityTimeout", {
        get: function() {
            return this.privRecognitionActivityTimeout;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(RecognizerConfig.prototype, "isContinuousRecognition", {
        get: function() {
            return this.privRecognitionMode !== $381185d70a12db21$var$RecognitionMode.Interactive;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(RecognizerConfig.prototype, "languageIdMode", {
        get: function() {
            return this.privLanguageIdMode;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(RecognizerConfig.prototype, "autoDetectSourceLanguages", {
        get: function() {
            return this.parameters.getProperty($hM4QX.PropertyId.SpeechServiceConnection_AutoDetectSourceLanguages, undefined);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(RecognizerConfig.prototype, "recognitionEndpointVersion", {
        get: function() {
            return this.parameters.getProperty($hM4QX.PropertyId.SpeechServiceConnection_RecognitionEndpointVersion, undefined);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(RecognizerConfig.prototype, "sourceLanguageModels", {
        get: function() {
            var models = [];
            var modelsExist = false;
            if (this.autoDetectSourceLanguages !== undefined) for(var _i = 0, _a = this.autoDetectSourceLanguages.split(","); _i < _a.length; _i++){
                var language = _a[_i];
                var customProperty = language + $hM4QX.PropertyId.SpeechServiceConnection_EndpointId.toString();
                var modelId = this.parameters.getProperty(customProperty, undefined);
                if (modelId !== undefined) {
                    models.push({
                        language: language,
                        endpoint: modelId
                    });
                    modelsExist = true;
                } else models.push({
                    language: language,
                    endpoint: ""
                });
            }
            return modelsExist ? models : undefined;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(RecognizerConfig.prototype, "maxRetryCount", {
        get: function() {
            return this.privMaxRetryCount;
        },
        enumerable: false,
        configurable: true
    });
    return RecognizerConfig;
}();
module.exports.RecognizerConfig = $381185d70a12db21$var$RecognizerConfig;
// The config is serialized and sent as the Speech.Config
var $381185d70a12db21$var$SpeechServiceConfig = /** @class */ function() {
    function SpeechServiceConfig(context) {
        this.context = context;
    }
    SpeechServiceConfig.prototype.serialize = function() {
        return JSON.stringify(this, function(key, value) {
            if (value && typeof value === "object") {
                var replacement = {};
                for(var k in value)if (Object.hasOwnProperty.call(value, k)) // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
                replacement[k && k.charAt(0).toLowerCase() + k.substring(1)] = value[k];
                return replacement;
            }
            return value;
        });
    };
    Object.defineProperty(SpeechServiceConfig.prototype, "Context", {
        get: function() {
            return this.context;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SpeechServiceConfig.prototype, "Recognition", {
        get: function() {
            return this.recognition;
        },
        set: function(value) {
            this.recognition = value.toLowerCase();
        },
        enumerable: false,
        configurable: true
    });
    return SpeechServiceConfig;
}();
module.exports.SpeechServiceConfig = $381185d70a12db21$var$SpeechServiceConfig;
var $381185d70a12db21$var$Context = /** @class */ function() {
    function Context(os) {
        this.system = new $381185d70a12db21$var$System();
        this.os = os;
    }
    return Context;
}();
module.exports.Context = $381185d70a12db21$var$Context;
var $381185d70a12db21$var$System = /** @class */ function() {
    function System() {
        // Note: below will be patched for official builds.
        var SPEECHSDK_CLIENTSDK_VERSION = "1.29.0";
        this.name = "SpeechSDK";
        this.version = SPEECHSDK_CLIENTSDK_VERSION;
        this.build = "JavaScript";
        this.lang = "JavaScript";
    }
    return System;
}();
module.exports.System = $381185d70a12db21$var$System;
var $381185d70a12db21$var$OS = /** @class */ function() {
    function OS(platform, name, version) {
        this.platform = platform;
        this.name = name;
        this.version = version;
    }
    return OS;
}();
module.exports.OS = $381185d70a12db21$var$OS;
var $381185d70a12db21$var$Device = /** @class */ function() {
    function Device(manufacturer, model, version) {
        this.manufacturer = manufacturer;
        this.model = model;
        this.version = version;
    }
    return Device;
}();
module.exports.Device = $381185d70a12db21$var$Device;
var $381185d70a12db21$var$connectivity;
(function(connectivity) {
    connectivity["Bluetooth"] = "Bluetooth";
    connectivity["Wired"] = "Wired";
    connectivity["WiFi"] = "WiFi";
    connectivity["Cellular"] = "Cellular";
    connectivity["InBuilt"] = "InBuilt";
    connectivity["Unknown"] = "Unknown";
})($381185d70a12db21$var$connectivity = module.exports.connectivity || (module.exports.connectivity = {}));
var $381185d70a12db21$var$type;
(function(type) {
    type["Phone"] = "Phone";
    type["Speaker"] = "Speaker";
    type["Car"] = "Car";
    type["Headset"] = "Headset";
    type["Thermostat"] = "Thermostat";
    type["Microphones"] = "Microphones";
    type["Deskphone"] = "Deskphone";
    type["RemoteControl"] = "RemoteControl";
    type["Unknown"] = "Unknown";
    type["File"] = "File";
    type["Stream"] = "Stream";
})($381185d70a12db21$var$type = module.exports.type || (module.exports.type = {}));

});

parcelRequire.register("lVvRc", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRequire.register("1R4VX", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.WebsocketMessageFormatter = void 0;

var $em8BD = parcelRequire("em8BD");
var $159e916d1023f2c1$var$CRLF = "\r\n";
var $159e916d1023f2c1$var$WebsocketMessageFormatter = /** @class */ function() {
    function WebsocketMessageFormatter() {}
    WebsocketMessageFormatter.prototype.toConnectionMessage = function(message) {
        var deferral = new $em8BD.Deferred();
        try {
            if (message.messageType === $em8BD.MessageType.Text) {
                var textMessage = message.textContent;
                var headers = {};
                var body = null;
                if (textMessage) {
                    var headerBodySplit = textMessage.split("\r\n\r\n");
                    if (headerBodySplit && headerBodySplit.length > 0) {
                        headers = this.parseHeaders(headerBodySplit[0]);
                        if (headerBodySplit.length > 1) body = headerBodySplit[1];
                    }
                }
                deferral.resolve(new $em8BD.ConnectionMessage(message.messageType, body, headers, message.id));
            } else if (message.messageType === $em8BD.MessageType.Binary) {
                var binaryMessage = message.binaryContent;
                var headers = {};
                var body = null;
                if (!binaryMessage || binaryMessage.byteLength < 2) throw new Error("Invalid binary message format. Header length missing.");
                var dataView = new DataView(binaryMessage);
                var headerLength = dataView.getInt16(0);
                if (binaryMessage.byteLength < headerLength + 2) throw new Error("Invalid binary message format. Header content missing.");
                var headersString = "";
                for(var i = 0; i < headerLength; i++)headersString += String.fromCharCode(dataView.getInt8(i + 2));
                headers = this.parseHeaders(headersString);
                if (binaryMessage.byteLength > headerLength + 2) body = binaryMessage.slice(2 + headerLength);
                deferral.resolve(new $em8BD.ConnectionMessage(message.messageType, body, headers, message.id));
            }
        } catch (e) {
            deferral.reject("Error formatting the message. Error: " + e);
        }
        return deferral.promise;
    };
    WebsocketMessageFormatter.prototype.fromConnectionMessage = function(message) {
        var deferral = new $em8BD.Deferred();
        try {
            if (message.messageType === $em8BD.MessageType.Text) {
                var payload = "" + this.makeHeaders(message) + $159e916d1023f2c1$var$CRLF + (message.textBody ? message.textBody : "");
                deferral.resolve(new $em8BD.RawWebsocketMessage($em8BD.MessageType.Text, payload, message.id));
            } else if (message.messageType === $em8BD.MessageType.Binary) {
                var headersString = this.makeHeaders(message);
                var content = message.binaryBody;
                var headerBuffer = this.stringToArrayBuffer(headersString);
                var headerInt8Array = new Int8Array(headerBuffer);
                var headerLength = headerInt8Array.byteLength;
                var payloadInt8Array = new Int8Array(2 + headerLength + (content ? content.byteLength : 0));
                payloadInt8Array[0] = headerLength >> 8 & 0xff;
                payloadInt8Array[1] = headerLength & 0xff;
                payloadInt8Array.set(headerInt8Array, 2);
                if (content) {
                    var bodyInt8Array = new Int8Array(content);
                    payloadInt8Array.set(bodyInt8Array, 2 + headerLength);
                }
                var payload = payloadInt8Array.buffer;
                deferral.resolve(new $em8BD.RawWebsocketMessage($em8BD.MessageType.Binary, payload, message.id));
            }
        } catch (e) {
            deferral.reject("Error formatting the message. " + e);
        }
        return deferral.promise;
    };
    WebsocketMessageFormatter.prototype.makeHeaders = function(message) {
        var headersString = "";
        if (message.headers) {
            for(var header in message.headers)if (header) headersString += header + ": " + message.headers[header] + $159e916d1023f2c1$var$CRLF;
        }
        return headersString;
    };
    WebsocketMessageFormatter.prototype.parseHeaders = function(headersString) {
        var headers = {};
        if (headersString) {
            var headerMatches = headersString.match(/[^\r\n]+/g);
            if (headers) for(var _i = 0, headerMatches_1 = headerMatches; _i < headerMatches_1.length; _i++){
                var header = headerMatches_1[_i];
                if (header) {
                    var separatorIndex = header.indexOf(":");
                    var headerName = separatorIndex > 0 ? header.substr(0, separatorIndex).trim().toLowerCase() : header;
                    var headerValue = separatorIndex > 0 && header.length > separatorIndex + 1 ? header.substr(separatorIndex + 1).trim() : "";
                    headers[headerName] = headerValue;
                }
            }
        }
        return headers;
    };
    WebsocketMessageFormatter.prototype.stringToArrayBuffer = function(str) {
        var buffer = new ArrayBuffer(str.length);
        var view = new DataView(buffer);
        for(var i = 0; i < str.length; i++)view.setUint8(i, str.charCodeAt(i));
        return buffer;
    };
    return WebsocketMessageFormatter;
}();
module.exports.WebsocketMessageFormatter = $159e916d1023f2c1$var$WebsocketMessageFormatter;

});

parcelRequire.register("jq15o", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
var $e23149ac59a27f7d$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SpeechConnectionFactory = void 0;

var $j1V0D = parcelRequire("j1V0D");

var $dEkJU = parcelRequire("dEkJU");

var $hM4QX = parcelRequire("hM4QX");

var $hGMva = parcelRequire("hGMva");

var $dEkJU = parcelRequire("dEkJU");

var $btbfh = parcelRequire("btbfh");

var $QhYc2 = parcelRequire("QhYc2");
var $e23149ac59a27f7d$var$SpeechConnectionFactory = /** @class */ function(_super) {
    $e23149ac59a27f7d$var$__extends(SpeechConnectionFactory, _super);
    function SpeechConnectionFactory() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.interactiveRelativeUri = "/speech/recognition/interactive/cognitiveservices/v1";
        _this.conversationRelativeUri = "/speech/recognition/conversation/cognitiveservices/v1";
        _this.dictationRelativeUri = "/speech/recognition/dictation/cognitiveservices/v1";
        _this.universalUri = "/speech/universal/v";
        return _this;
    }
    SpeechConnectionFactory.prototype.create = function(config, authInfo, connectionId) {
        var endpoint = config.parameters.getProperty($hM4QX.PropertyId.SpeechServiceConnection_Endpoint, undefined);
        var region = config.parameters.getProperty($hM4QX.PropertyId.SpeechServiceConnection_Region, undefined);
        var hostSuffix = $hGMva.ConnectionFactoryBase.getHostSuffix(region);
        var host = config.parameters.getProperty($hM4QX.PropertyId.SpeechServiceConnection_Host, "wss://" + region + ".stt.speech" + hostSuffix);
        var queryParams = {};
        var endpointId = config.parameters.getProperty($hM4QX.PropertyId.SpeechServiceConnection_EndpointId, undefined);
        var language = config.parameters.getProperty($hM4QX.PropertyId.SpeechServiceConnection_RecoLanguage, undefined);
        if (endpointId) {
            if (!endpoint || endpoint.search($QhYc2.QueryParameterNames.CustomSpeechDeploymentId) === -1) queryParams[$QhYc2.QueryParameterNames.CustomSpeechDeploymentId] = endpointId;
        } else if (language) {
            if (!endpoint || endpoint.search($QhYc2.QueryParameterNames.Language) === -1) queryParams[$QhYc2.QueryParameterNames.Language] = language;
        }
        if (!endpoint || endpoint.search($QhYc2.QueryParameterNames.Format) === -1) queryParams[$QhYc2.QueryParameterNames.Format] = config.parameters.getProperty($dEkJU.OutputFormatPropertyName, $hM4QX.OutputFormat[$hM4QX.OutputFormat.Simple]).toLowerCase();
        if (config.autoDetectSourceLanguages !== undefined) queryParams[$QhYc2.QueryParameterNames.EnableLanguageId] = "true";
        this.setCommonUrlParams(config, queryParams, endpoint);
        if (!endpoint) switch(config.recognitionMode){
            case $dEkJU.RecognitionMode.Conversation:
                if (config.parameters.getProperty($dEkJU.ForceDictationPropertyName, "false") === "true") endpoint = host + this.dictationRelativeUri;
                else if (config.recognitionEndpointVersion !== undefined && parseInt(config.recognitionEndpointVersion, 10) > 1) endpoint = "" + host + this.universalUri + config.recognitionEndpointVersion;
                else endpoint = host + this.conversationRelativeUri;
                break;
            case $dEkJU.RecognitionMode.Dictation:
                endpoint = host + this.dictationRelativeUri;
                break;
            default:
                if (config.recognitionEndpointVersion !== undefined && parseInt(config.recognitionEndpointVersion, 10) > 1) endpoint = "" + host + this.universalUri + config.recognitionEndpointVersion;
                else endpoint = host + this.interactiveRelativeUri; // default is interactive
                break;
        }
        var headers = {};
        if (authInfo.token !== undefined && authInfo.token !== "") headers[authInfo.headerName] = authInfo.token;
        headers[$btbfh.HeaderNames.ConnectionId] = connectionId;
        var enableCompression = config.parameters.getProperty("SPEECH-EnableWebsocketCompression", "false") === "true";
        var webSocketConnection = new $j1V0D.WebsocketConnection(endpoint, queryParams, headers, new $dEkJU.WebsocketMessageFormatter(), $j1V0D.ProxyInfo.fromRecognizerConfig(config), enableCompression, connectionId);
        // Set the value of SpeechServiceConnection_Url to webSocketConnection.uri (and not to `endpoint`), since this value is the final
        // URI that was used to make the connection (including query parameters).
        var uri = webSocketConnection.uri;
        config.parameters.setProperty($hM4QX.PropertyId.SpeechServiceConnection_Url, uri);
        return webSocketConnection;
    };
    return SpeechConnectionFactory;
}($hGMva.ConnectionFactoryBase);
module.exports.SpeechConnectionFactory = $e23149ac59a27f7d$var$SpeechConnectionFactory;

});

parcelRequire.register("girFR", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
var $bdd3cb51579605df$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TranscriberConnectionFactory = void 0;

var $j1V0D = parcelRequire("j1V0D");

var $hM4QX = parcelRequire("hM4QX");

var $hGMva = parcelRequire("hGMva");

var $dEkJU = parcelRequire("dEkJU");

var $btbfh = parcelRequire("btbfh");

var $QhYc2 = parcelRequire("QhYc2");
var $bdd3cb51579605df$var$TranscriberConnectionFactory = /** @class */ function(_super) {
    $bdd3cb51579605df$var$__extends(TranscriberConnectionFactory, _super);
    function TranscriberConnectionFactory() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.multiaudioRelativeUri = "/speech/recognition/multiaudio";
        return _this;
    }
    TranscriberConnectionFactory.prototype.create = function(config, authInfo, connectionId) {
        var endpoint = config.parameters.getProperty($hM4QX.PropertyId.SpeechServiceConnection_Endpoint, undefined);
        var region = config.parameters.getProperty($hM4QX.PropertyId.SpeechServiceConnection_Region, "centralus");
        var hostSuffix = $hGMva.ConnectionFactoryBase.getHostSuffix(region);
        var hostDefault = "wss://transcribe." + region + ".cts.speech" + hostSuffix + this.multiaudioRelativeUri;
        var host = config.parameters.getProperty($hM4QX.PropertyId.SpeechServiceConnection_Host, hostDefault);
        var queryParams = {};
        this.setQueryParams(queryParams, config, endpoint);
        if (!endpoint) endpoint = host;
        var headers = {};
        if (authInfo.token !== undefined && authInfo.token !== "") headers[authInfo.headerName] = authInfo.token;
        headers[$btbfh.HeaderNames.ConnectionId] = connectionId;
        config.parameters.setProperty($hM4QX.PropertyId.SpeechServiceConnection_Url, endpoint);
        var enableCompression = config.parameters.getProperty("SPEECH-EnableWebsocketCompression", "false") === "true";
        return new $j1V0D.WebsocketConnection(endpoint, queryParams, headers, new $dEkJU.WebsocketMessageFormatter(), $j1V0D.ProxyInfo.fromRecognizerConfig(config), enableCompression, connectionId);
    };
    TranscriberConnectionFactory.prototype.setQueryParams = function(queryParams, config, endpointUrl) {
        var endpointId = config.parameters.getProperty($hM4QX.PropertyId.SpeechServiceConnection_EndpointId, undefined);
        var language = config.parameters.getProperty($hM4QX.PropertyId.SpeechServiceConnection_RecoLanguage, undefined);
        if (endpointId && !($QhYc2.QueryParameterNames.CustomSpeechDeploymentId in queryParams)) queryParams[$QhYc2.QueryParameterNames.CustomSpeechDeploymentId] = endpointId;
        if (language && !($QhYc2.QueryParameterNames.Language in queryParams)) queryParams[$QhYc2.QueryParameterNames.Language] = language;
        var wordLevelTimings = config.parameters.getProperty($hM4QX.PropertyId.SpeechServiceResponse_RequestWordLevelTimestamps, "false").toLowerCase() === "true";
        var detailed = config.parameters.getProperty($dEkJU.OutputFormatPropertyName, $hM4QX.OutputFormat[$hM4QX.OutputFormat.Simple]) !== $hM4QX.OutputFormat[$hM4QX.OutputFormat.Simple];
        if (wordLevelTimings || detailed) queryParams[$QhYc2.QueryParameterNames.Format] = $hM4QX.OutputFormat[$hM4QX.OutputFormat.Detailed].toLowerCase();
        this.setCommonUrlParams(config, queryParams, endpointUrl);
    };
    return TranscriberConnectionFactory;
}($hGMva.ConnectionFactoryBase);
module.exports.TranscriberConnectionFactory = $bdd3cb51579605df$var$TranscriberConnectionFactory;

});

parcelRequire.register("dd1J6", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
var $99ddd41c6ca95ef6$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TranslationConnectionFactory = void 0;

var $j1V0D = parcelRequire("j1V0D");

var $yizou = parcelRequire("yizou");

var $hM4QX = parcelRequire("hM4QX");

var $hGMva = parcelRequire("hGMva");

var $dEkJU = parcelRequire("dEkJU");

var $btbfh = parcelRequire("btbfh");

var $QhYc2 = parcelRequire("QhYc2");
var $99ddd41c6ca95ef6$var$TranslationConnectionFactory = /** @class */ function(_super) {
    $99ddd41c6ca95ef6$var$__extends(TranslationConnectionFactory, _super);
    function TranslationConnectionFactory() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TranslationConnectionFactory.prototype.create = function(config, authInfo, connectionId) {
        var endpoint = this.getEndpointUrl(config);
        var queryParams = {};
        if (config.autoDetectSourceLanguages !== undefined) queryParams[$QhYc2.QueryParameterNames.EnableLanguageId] = "true";
        this.setQueryParams(queryParams, config, endpoint);
        var headers = {};
        if (authInfo.token !== undefined && authInfo.token !== "") headers[authInfo.headerName] = authInfo.token;
        headers[$btbfh.HeaderNames.ConnectionId] = connectionId;
        config.parameters.setProperty($hM4QX.PropertyId.SpeechServiceConnection_Url, endpoint);
        var enableCompression = config.parameters.getProperty("SPEECH-EnableWebsocketCompression", "false") === "true";
        return new $j1V0D.WebsocketConnection(endpoint, queryParams, headers, new $dEkJU.WebsocketMessageFormatter(), $j1V0D.ProxyInfo.fromRecognizerConfig(config), enableCompression, connectionId);
    };
    TranslationConnectionFactory.prototype.getEndpointUrl = function(config, returnRegionPlaceholder) {
        var region = config.parameters.getProperty($hM4QX.PropertyId.SpeechServiceConnection_Region);
        var hostSuffix = $hGMva.ConnectionFactoryBase.getHostSuffix(region);
        var endpointUrl = config.parameters.getProperty($hM4QX.PropertyId.SpeechServiceConnection_Endpoint, undefined);
        if (!endpointUrl) {
            if (config.autoDetectSourceLanguages !== undefined) {
                var host = config.parameters.getProperty($hM4QX.PropertyId.SpeechServiceConnection_Host, "wss://{region}.stt.speech" + hostSuffix);
                endpointUrl = host + "/speech/universal/v2";
            } else {
                var host = config.parameters.getProperty($hM4QX.PropertyId.SpeechServiceConnection_Host, "wss://{region}.s2s.speech" + hostSuffix);
                endpointUrl = host + "/speech/translation/cognitiveservices/v1";
            }
        }
        if (returnRegionPlaceholder === true) return endpointUrl;
        return $yizou.StringUtils.formatString(endpointUrl, {
            region: region
        });
    };
    TranslationConnectionFactory.prototype.setQueryParams = function(queryParams, config, endpointUrl) {
        queryParams.from = config.parameters.getProperty($hM4QX.PropertyId.SpeechServiceConnection_RecoLanguage);
        queryParams.to = config.parameters.getProperty($hM4QX.PropertyId.SpeechServiceConnection_TranslationToLanguages);
        this.setCommonUrlParams(config, queryParams, endpointUrl);
        this.setUrlParameter($hM4QX.PropertyId.SpeechServiceResponse_TranslationRequestStablePartialResult, $QhYc2.QueryParameterNames.StableTranslation, config, queryParams, endpointUrl);
        var translationVoice = config.parameters.getProperty($hM4QX.PropertyId.SpeechServiceConnection_TranslationVoice, undefined);
        if (translationVoice !== undefined) {
            queryParams.voice = translationVoice;
            queryParams.features = "texttospeech";
        }
    };
    return TranslationConnectionFactory;
}($hGMva.ConnectionFactoryBase);
module.exports.TranslationConnectionFactory = $99ddd41c6ca95ef6$var$TranslationConnectionFactory;

});

parcelRequire.register("b7WAi", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SpeechSynthesisConnectionFactory = void 0;

var $j1V0D = parcelRequire("j1V0D");

var $hM4QX = parcelRequire("hM4QX");

var $hGMva = parcelRequire("hGMva");

var $dEkJU = parcelRequire("dEkJU");

var $btbfh = parcelRequire("btbfh");

var $QhYc2 = parcelRequire("QhYc2");
var $819dcac7d82c0826$var$SpeechSynthesisConnectionFactory = /** @class */ function() {
    function SpeechSynthesisConnectionFactory() {
        this.synthesisUri = "/cognitiveservices/websocket/v1";
    }
    SpeechSynthesisConnectionFactory.prototype.create = function(config, authInfo, connectionId) {
        var endpoint = config.parameters.getProperty($hM4QX.PropertyId.SpeechServiceConnection_Endpoint, undefined);
        var region = config.parameters.getProperty($hM4QX.PropertyId.SpeechServiceConnection_Region, undefined);
        var hostSuffix = $hGMva.ConnectionFactoryBase.getHostSuffix(region);
        var endpointId = config.parameters.getProperty($hM4QX.PropertyId.SpeechServiceConnection_EndpointId, undefined);
        var hostPrefix = endpointId === undefined ? "tts" : "voice";
        var host = config.parameters.getProperty($hM4QX.PropertyId.SpeechServiceConnection_Host, "wss://" + region + "." + hostPrefix + ".speech" + hostSuffix);
        var queryParams = {};
        if (!endpoint) endpoint = host + this.synthesisUri;
        var headers = {};
        if (authInfo.token !== undefined && authInfo.token !== "") headers[authInfo.headerName] = authInfo.token;
        headers[$btbfh.HeaderNames.ConnectionId] = connectionId;
        if (endpointId !== undefined) headers[$QhYc2.QueryParameterNames.CustomVoiceDeploymentId] = endpointId;
        config.parameters.setProperty($hM4QX.PropertyId.SpeechServiceConnection_Url, endpoint);
        var enableCompression = config.parameters.getProperty("SPEECH-EnableWebsocketCompression", "false") === "true";
        return new $j1V0D.WebsocketConnection(endpoint, queryParams, headers, new $dEkJU.WebsocketMessageFormatter(), $j1V0D.ProxyInfo.fromParameters(config.parameters), enableCompression, connectionId);
    };
    return SpeechSynthesisConnectionFactory;
}();
module.exports.SpeechSynthesisConnectionFactory = $819dcac7d82c0826$var$SpeechSynthesisConnectionFactory;

});

parcelRequire.register("e2VQs", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.EnumTranslation = void 0;

var $hM4QX = parcelRequire("hM4QX");

var $dEkJU = parcelRequire("dEkJU");
var $a39e1f6eb262b511$var$EnumTranslation = /** @class */ function() {
    function EnumTranslation() {}
    EnumTranslation.implTranslateRecognitionResult = function(recognitionStatus) {
        var reason = $hM4QX.ResultReason.Canceled;
        switch(recognitionStatus){
            case $dEkJU.RecognitionStatus.Success:
                reason = $hM4QX.ResultReason.RecognizedSpeech;
                break;
            case $dEkJU.RecognitionStatus.NoMatch:
            case $dEkJU.RecognitionStatus.InitialSilenceTimeout:
            case $dEkJU.RecognitionStatus.BabbleTimeout:
            case $dEkJU.RecognitionStatus.EndOfDictation:
                reason = $hM4QX.ResultReason.NoMatch;
                break;
            case $dEkJU.RecognitionStatus.Error:
            case $dEkJU.RecognitionStatus.BadRequest:
            case $dEkJU.RecognitionStatus.Forbidden:
            default:
                reason = $hM4QX.ResultReason.Canceled;
                break;
        }
        return reason;
    };
    EnumTranslation.implTranslateCancelResult = function(recognitionStatus) {
        var reason = $hM4QX.CancellationReason.EndOfStream;
        switch(recognitionStatus){
            case $dEkJU.RecognitionStatus.Success:
            case $dEkJU.RecognitionStatus.EndOfDictation:
            case $dEkJU.RecognitionStatus.NoMatch:
                reason = $hM4QX.CancellationReason.EndOfStream;
                break;
            case $dEkJU.RecognitionStatus.InitialSilenceTimeout:
            case $dEkJU.RecognitionStatus.BabbleTimeout:
            case $dEkJU.RecognitionStatus.Error:
            case $dEkJU.RecognitionStatus.BadRequest:
            case $dEkJU.RecognitionStatus.Forbidden:
            default:
                reason = $hM4QX.CancellationReason.Error;
                break;
        }
        return reason;
    };
    EnumTranslation.implTranslateCancelErrorCode = function(recognitionStatus) {
        var reason = $hM4QX.CancellationErrorCode.NoError;
        switch(recognitionStatus){
            case $dEkJU.RecognitionStatus.Error:
                reason = $hM4QX.CancellationErrorCode.ServiceError;
                break;
            case $dEkJU.RecognitionStatus.TooManyRequests:
                reason = $hM4QX.CancellationErrorCode.TooManyRequests;
                break;
            case $dEkJU.RecognitionStatus.BadRequest:
                reason = $hM4QX.CancellationErrorCode.BadRequestParameters;
                break;
            case $dEkJU.RecognitionStatus.Forbidden:
                reason = $hM4QX.CancellationErrorCode.Forbidden;
                break;
            default:
                reason = $hM4QX.CancellationErrorCode.NoError;
                break;
        }
        return reason;
    };
    EnumTranslation.implTranslateErrorDetails = function(cancellationErrorCode) {
        var errorDetails = "The speech service encountered an internal error and could not continue.";
        switch(cancellationErrorCode){
            case $hM4QX.CancellationErrorCode.Forbidden:
                errorDetails = "The recognizer is using a free subscription that ran out of quota.";
                break;
            case $hM4QX.CancellationErrorCode.BadRequestParameters:
                errorDetails = "Invalid parameter or unsupported audio format in the request.";
                break;
            case $hM4QX.CancellationErrorCode.TooManyRequests:
                errorDetails = "The number of parallel requests exceeded the number of allowed concurrent transcriptions.";
                break;
            default:
                break;
        }
        return errorDetails;
    };
    return EnumTranslation;
}();
module.exports.EnumTranslation = $a39e1f6eb262b511$var$EnumTranslation;

});

parcelRequire.register("doCmo", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RecognitionStatus = module.exports.SynthesisStatus = void 0;
/**
 * @class SynthesisStatus
 * @private
 */ var $9c0b45c4a056a71f$var$SynthesisStatus;
(function(SynthesisStatus) {
    /**
     * The response contains valid audio data.
     * @member SynthesisStatus.Success
     */ SynthesisStatus[SynthesisStatus["Success"] = 0] = "Success";
    /**
     * Indicates the end of audio data. No valid audio data is included in the message.
     * @member SynthesisStatus.SynthesisEnd
     */ SynthesisStatus[SynthesisStatus["SynthesisEnd"] = 1] = "SynthesisEnd";
    /**
     * Indicates an error occurred during synthesis data processing.
     * @member SynthesisStatus.Error
     */ SynthesisStatus[SynthesisStatus["Error"] = 2] = "Error";
})($9c0b45c4a056a71f$var$SynthesisStatus = module.exports.SynthesisStatus || (module.exports.SynthesisStatus = {}));
var $9c0b45c4a056a71f$var$RecognitionStatus;
(function(RecognitionStatus) {
    RecognitionStatus[RecognitionStatus["Success"] = 0] = "Success";
    RecognitionStatus[RecognitionStatus["NoMatch"] = 1] = "NoMatch";
    RecognitionStatus[RecognitionStatus["InitialSilenceTimeout"] = 2] = "InitialSilenceTimeout";
    RecognitionStatus[RecognitionStatus["BabbleTimeout"] = 3] = "BabbleTimeout";
    RecognitionStatus[RecognitionStatus["Error"] = 4] = "Error";
    RecognitionStatus[RecognitionStatus["EndOfDictation"] = 5] = "EndOfDictation";
    RecognitionStatus[RecognitionStatus["TooManyRequests"] = 6] = "TooManyRequests";
    RecognitionStatus[RecognitionStatus["BadRequest"] = 7] = "BadRequest";
    RecognitionStatus[RecognitionStatus["Forbidden"] = 8] = "Forbidden";
})($9c0b45c4a056a71f$var$RecognitionStatus = module.exports.RecognitionStatus || (module.exports.RecognitionStatus = {}));

});

parcelRequire.register("3toTM", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TranslationSynthesisEnd = void 0;

var $dEkJU = parcelRequire("dEkJU");
var $287764e436858757$var$TranslationSynthesisEnd = /** @class */ function() {
    function TranslationSynthesisEnd(json) {
        this.privSynthesisEnd = JSON.parse(json);
        if (!!this.privSynthesisEnd.SynthesisStatus) this.privSynthesisEnd.SynthesisStatus = $dEkJU.SynthesisStatus[this.privSynthesisEnd.SynthesisStatus];
        if (!!this.privSynthesisEnd.Status) this.privSynthesisEnd.SynthesisStatus = $dEkJU.SynthesisStatus[this.privSynthesisEnd.Status];
    }
    TranslationSynthesisEnd.fromJSON = function(json) {
        return new TranslationSynthesisEnd(json);
    };
    Object.defineProperty(TranslationSynthesisEnd.prototype, "SynthesisStatus", {
        get: function() {
            return this.privSynthesisEnd.SynthesisStatus;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TranslationSynthesisEnd.prototype, "FailureReason", {
        get: function() {
            return this.privSynthesisEnd.FailureReason;
        },
        enumerable: false,
        configurable: true
    });
    return TranslationSynthesisEnd;
}();
module.exports.TranslationSynthesisEnd = $287764e436858757$var$TranslationSynthesisEnd;

});

parcelRequire.register("jPLEJ", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TranslationHypothesis = void 0;

var $jLUJe = parcelRequire("jLUJe");
var $e707bf3998d5cee1$var$TranslationHypothesis = /** @class */ function() {
    function TranslationHypothesis(json) {
        this.privTranslationHypothesis = JSON.parse(json);
        this.privTranslationHypothesis.Translation.TranslationStatus = $jLUJe.TranslationStatus[this.privTranslationHypothesis.Translation.TranslationStatus];
    }
    TranslationHypothesis.fromJSON = function(json) {
        return new TranslationHypothesis(json);
    };
    Object.defineProperty(TranslationHypothesis.prototype, "Duration", {
        get: function() {
            return this.privTranslationHypothesis.Duration;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TranslationHypothesis.prototype, "Offset", {
        get: function() {
            return this.privTranslationHypothesis.Offset;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TranslationHypothesis.prototype, "Text", {
        get: function() {
            return this.privTranslationHypothesis.Text;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TranslationHypothesis.prototype, "Translation", {
        get: function() {
            return this.privTranslationHypothesis.Translation;
        },
        enumerable: false,
        configurable: true
    });
    return TranslationHypothesis;
}();
module.exports.TranslationHypothesis = $e707bf3998d5cee1$var$TranslationHypothesis;

});

parcelRequire.register("iTk4h", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TranslationPhrase = void 0;

var $gBGZx = parcelRequire("gBGZx");

var $dEkJU = parcelRequire("dEkJU");

var $jLUJe = parcelRequire("jLUJe");
var $dc0cee2881cfbfa5$var$TranslationPhrase = /** @class */ function() {
    function TranslationPhrase(phrase) {
        this.privTranslationPhrase = phrase;
        this.privTranslationPhrase.RecognitionStatus = $dEkJU.RecognitionStatus[this.privTranslationPhrase.RecognitionStatus];
        if (this.privTranslationPhrase.Translation !== undefined) this.privTranslationPhrase.Translation.TranslationStatus = $jLUJe.TranslationStatus[this.privTranslationPhrase.Translation.TranslationStatus];
    }
    TranslationPhrase.fromJSON = function(json) {
        return new TranslationPhrase(JSON.parse(json));
    };
    TranslationPhrase.fromTranslationResponse = function(translationResponse) {
        $gBGZx.Contracts.throwIfNullOrUndefined(translationResponse, "translationResponse");
        var phrase = translationResponse.SpeechPhrase;
        translationResponse.SpeechPhrase = undefined;
        phrase.Translation = translationResponse;
        phrase.Text = phrase.DisplayText;
        return new TranslationPhrase(phrase);
    };
    Object.defineProperty(TranslationPhrase.prototype, "RecognitionStatus", {
        get: function() {
            return this.privTranslationPhrase.RecognitionStatus;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TranslationPhrase.prototype, "Offset", {
        get: function() {
            return this.privTranslationPhrase.Offset;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TranslationPhrase.prototype, "Duration", {
        get: function() {
            return this.privTranslationPhrase.Duration;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TranslationPhrase.prototype, "Text", {
        get: function() {
            return this.privTranslationPhrase.Text;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TranslationPhrase.prototype, "Language", {
        get: function() {
            var _a;
            return (_a = this.privTranslationPhrase.PrimaryLanguage) === null || _a === void 0 ? void 0 : _a.Language;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TranslationPhrase.prototype, "Confidence", {
        get: function() {
            var _a;
            return (_a = this.privTranslationPhrase.PrimaryLanguage) === null || _a === void 0 ? void 0 : _a.Confidence;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TranslationPhrase.prototype, "Translation", {
        get: function() {
            return this.privTranslationPhrase.Translation;
        },
        enumerable: false,
        configurable: true
    });
    return TranslationPhrase;
}();
module.exports.TranslationPhrase = $dc0cee2881cfbfa5$var$TranslationPhrase;

});

parcelRequire.register("cuU1Q", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
var $9193bf8bd4ea824a$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $9193bf8bd4ea824a$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $9193bf8bd4ea824a$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TranslationServiceRecognizer = void 0;

var $em8BD = parcelRequire("em8BD");

var $hM4QX = parcelRequire("hM4QX");

var $dEkJU = parcelRequire("dEkJU");
// eslint-disable-next-line max-classes-per-file
var $9193bf8bd4ea824a$var$TranslationServiceRecognizer = /** @class */ function(_super) {
    $9193bf8bd4ea824a$var$__extends(TranslationServiceRecognizer, _super);
    function TranslationServiceRecognizer(authentication, connectionFactory, audioSource, recognizerConfig, translationRecognizer) {
        var _this = _super.call(this, authentication, connectionFactory, audioSource, recognizerConfig, translationRecognizer) || this;
        _this.privTranslationRecognizer = translationRecognizer;
        _this.connectionEvents.attach(function(connectionEvent) {
            if (connectionEvent.name === "ConnectionEstablishedEvent") _this.privTranslationRecognizer.onConnection();
            else if (connectionEvent.name === "ConnectionClosedEvent") _this.privTranslationRecognizer.onDisconnection();
        });
        return _this;
    }
    TranslationServiceRecognizer.prototype.processTypeSpecificMessages = function(connectionMessage) {
        return $9193bf8bd4ea824a$var$__awaiter(this, void 0, void 0, function() {
            var resultProps, processed, handleTranslationPhrase, _a, result, phrase, synthEnd, result_1, retEvent, canceledResult;
            var _this = this;
            return $9193bf8bd4ea824a$var$__generator(this, function(_b) {
                switch(_b.label){
                    case 0:
                        resultProps = new $hM4QX.PropertyCollection();
                        return [
                            4 /*yield*/ ,
                            this.processSpeechMessages(connectionMessage)
                        ];
                    case 1:
                        processed = _b.sent();
                        if (processed) return [
                            2 /*return*/ ,
                            true
                        ];
                        handleTranslationPhrase = function(translatedPhrase) {
                            return $9193bf8bd4ea824a$var$__awaiter(_this, void 0, void 0, function() {
                                var result, reason, result, cancelReason, cancellationErrorCode, ev;
                                return $9193bf8bd4ea824a$var$__generator(this, function(_a) {
                                    switch(_a.label){
                                        case 0:
                                            this.privRequestSession.onPhraseRecognized(this.privRequestSession.currentTurnAudioOffset + translatedPhrase.Offset + translatedPhrase.Duration);
                                            if (!(translatedPhrase.RecognitionStatus === $dEkJU.RecognitionStatus.Success)) return [
                                                3 /*break*/ ,
                                                1
                                            ];
                                            result = this.fireEventForResult(translatedPhrase, resultProps);
                                            if (!!this.privTranslationRecognizer.recognized) try {
                                                this.privTranslationRecognizer.recognized(this.privTranslationRecognizer, result);
                                            /* eslint-disable no-empty */ } catch (error) {
                                            // Not going to let errors in the event handler
                                            // trip things up.
                                            }
                                            // report result to promise.
                                            if (!!this.privSuccessCallback) {
                                                try {
                                                    this.privSuccessCallback(result.result);
                                                } catch (e) {
                                                    if (!!this.privErrorCallback) this.privErrorCallback(e);
                                                }
                                                // Only invoke the call back once.
                                                // and if it's successful don't invoke the
                                                // error after that.
                                                this.privSuccessCallback = undefined;
                                                this.privErrorCallback = undefined;
                                            }
                                            return [
                                                3 /*break*/ ,
                                                5
                                            ];
                                        case 1:
                                            reason = $dEkJU.EnumTranslation.implTranslateRecognitionResult(translatedPhrase.RecognitionStatus);
                                            result = new $hM4QX.TranslationRecognitionResult(undefined, this.privRequestSession.requestId, reason, translatedPhrase.Text, translatedPhrase.Duration, this.privRequestSession.currentTurnAudioOffset + translatedPhrase.Offset, translatedPhrase.Language, translatedPhrase.Confidence, undefined, connectionMessage.textBody, resultProps);
                                            if (!(reason === $hM4QX.ResultReason.Canceled)) return [
                                                3 /*break*/ ,
                                                3
                                            ];
                                            cancelReason = $dEkJU.EnumTranslation.implTranslateCancelResult(translatedPhrase.RecognitionStatus);
                                            cancellationErrorCode = $dEkJU.EnumTranslation.implTranslateCancelErrorCode(translatedPhrase.RecognitionStatus);
                                            return [
                                                4 /*yield*/ ,
                                                this.cancelRecognitionLocal(cancelReason, cancellationErrorCode, $dEkJU.EnumTranslation.implTranslateErrorDetails(cancellationErrorCode))
                                            ];
                                        case 2:
                                            _a.sent();
                                            return [
                                                3 /*break*/ ,
                                                4
                                            ];
                                        case 3:
                                            if (!(this.privRequestSession.isSpeechEnded && reason === $hM4QX.ResultReason.NoMatch && translatedPhrase.RecognitionStatus !== $dEkJU.RecognitionStatus.InitialSilenceTimeout)) {
                                                ev = new $hM4QX.TranslationRecognitionEventArgs(result, result.offset, this.privRequestSession.sessionId);
                                                if (!!this.privTranslationRecognizer.recognized) try {
                                                    this.privTranslationRecognizer.recognized(this.privTranslationRecognizer, ev);
                                                /* eslint-disable no-empty */ } catch (error) {
                                                // Not going to let errors in the event handler
                                                // trip things up.
                                                }
                                            }
                                            // report result to promise.
                                            if (!!this.privSuccessCallback) {
                                                try {
                                                    this.privSuccessCallback(result);
                                                } catch (e) {
                                                    if (!!this.privErrorCallback) this.privErrorCallback(e);
                                                }
                                                // Only invoke the call back once.
                                                // and if it's successful don't invoke the
                                                // error after that.
                                                this.privSuccessCallback = undefined;
                                                this.privErrorCallback = undefined;
                                            }
                                            _a.label = 4;
                                        case 4:
                                            processed = true;
                                            _a.label = 5;
                                        case 5:
                                            return [
                                                2 /*return*/ 
                                            ];
                                    }
                                });
                            });
                        };
                        if (connectionMessage.messageType === $em8BD.MessageType.Text) resultProps.setProperty($hM4QX.PropertyId.SpeechServiceResponse_JsonResult, connectionMessage.textBody);
                        _a = connectionMessage.path.toLowerCase();
                        switch(_a){
                            case "translation.hypothesis":
                                return [
                                    3 /*break*/ ,
                                    2
                                ];
                            case "translation.response":
                                return [
                                    3 /*break*/ ,
                                    3
                                ];
                            case "translation.phrase":
                                return [
                                    3 /*break*/ ,
                                    6
                                ];
                            case "translation.synthesis":
                                return [
                                    3 /*break*/ ,
                                    8
                                ];
                            case "audio.end":
                                return [
                                    3 /*break*/ ,
                                    9
                                ];
                            case "translation.synthesis.end":
                                return [
                                    3 /*break*/ ,
                                    9
                                ];
                        }
                        return [
                            3 /*break*/ ,
                            10
                        ];
                    case 2:
                        result = this.fireEventForResult($dEkJU.TranslationHypothesis.fromJSON(connectionMessage.textBody), resultProps);
                        this.privRequestSession.onHypothesis(this.privRequestSession.currentTurnAudioOffset + result.offset);
                        if (!!this.privTranslationRecognizer.recognizing) try {
                            this.privTranslationRecognizer.recognizing(this.privTranslationRecognizer, result);
                        /* eslint-disable no-empty */ } catch (error) {
                        // Not going to let errors in the event handler
                        // trip things up.
                        }
                        processed = true;
                        return [
                            3 /*break*/ ,
                            11
                        ];
                    case 3:
                        phrase = JSON.parse(connectionMessage.textBody);
                        if (!!!phrase.SpeechPhrase) return [
                            3 /*break*/ ,
                            5
                        ];
                        return [
                            4 /*yield*/ ,
                            handleTranslationPhrase($dEkJU.TranslationPhrase.fromTranslationResponse(phrase))
                        ];
                    case 4:
                        _b.sent();
                        _b.label = 5;
                    case 5:
                        return [
                            3 /*break*/ ,
                            11
                        ];
                    case 6:
                        return [
                            4 /*yield*/ ,
                            handleTranslationPhrase($dEkJU.TranslationPhrase.fromJSON(connectionMessage.textBody))
                        ];
                    case 7:
                        _b.sent();
                        return [
                            3 /*break*/ ,
                            11
                        ];
                    case 8:
                        this.sendSynthesisAudio(connectionMessage.binaryBody, this.privRequestSession.sessionId);
                        processed = true;
                        return [
                            3 /*break*/ ,
                            11
                        ];
                    case 9:
                        synthEnd = $dEkJU.TranslationSynthesisEnd.fromJSON(connectionMessage.textBody);
                        switch(synthEnd.SynthesisStatus){
                            case $dEkJU.SynthesisStatus.Error:
                                if (!!this.privTranslationRecognizer.synthesizing) {
                                    result_1 = new $hM4QX.TranslationSynthesisResult($hM4QX.ResultReason.Canceled, undefined);
                                    retEvent = new $hM4QX.TranslationSynthesisEventArgs(result_1, this.privRequestSession.sessionId);
                                    try {
                                        this.privTranslationRecognizer.synthesizing(this.privTranslationRecognizer, retEvent);
                                    /* eslint-disable no-empty */ } catch (error) {
                                    // Not going to let errors in the event handler
                                    // trip things up.
                                    }
                                }
                                if (!!this.privTranslationRecognizer.canceled) {
                                    canceledResult = new $hM4QX.TranslationRecognitionCanceledEventArgs(this.privRequestSession.sessionId, $hM4QX.CancellationReason.Error, synthEnd.FailureReason, $hM4QX.CancellationErrorCode.ServiceError, null);
                                    try {
                                        this.privTranslationRecognizer.canceled(this.privTranslationRecognizer, canceledResult);
                                    /* eslint-disable no-empty */ } catch (error) {
                                    // Not going to let errors in the event handler
                                    // trip things up.
                                    }
                                }
                                break;
                            case $dEkJU.SynthesisStatus.Success:
                                this.sendSynthesisAudio(undefined, this.privRequestSession.sessionId);
                                break;
                            default:
                                break;
                        }
                        processed = true;
                        return [
                            3 /*break*/ ,
                            11
                        ];
                    case 10:
                        return [
                            3 /*break*/ ,
                            11
                        ];
                    case 11:
                        return [
                            2 /*return*/ ,
                            processed
                        ];
                }
            });
        });
    };
    // Cancels recognition.
    TranslationServiceRecognizer.prototype.cancelRecognition = function(sessionId, requestId, cancellationReason, errorCode, error) {
        var properties = new $hM4QX.PropertyCollection();
        properties.setProperty($dEkJU.CancellationErrorCodePropertyName, $hM4QX.CancellationErrorCode[errorCode]);
        if (!!this.privTranslationRecognizer.canceled) {
            var cancelEvent = new $hM4QX.TranslationRecognitionCanceledEventArgs(sessionId, cancellationReason, error, errorCode, undefined);
            try {
                this.privTranslationRecognizer.canceled(this.privTranslationRecognizer, cancelEvent);
            /* eslint-disable no-empty */ } catch (_a) {}
        }
        if (!!this.privSuccessCallback) {
            var result = new $hM4QX.TranslationRecognitionResult(undefined, requestId, $hM4QX.ResultReason.Canceled, undefined, undefined, undefined, undefined, undefined, error, undefined, properties);
            try {
                this.privSuccessCallback(result);
                /* eslint-disable no-empty */ this.privSuccessCallback = undefined;
            } catch (_b) {}
        }
    };
    TranslationServiceRecognizer.prototype.handleRecognizingCallback = function(result, duration, sessionId) {
        try {
            var ev = new $hM4QX.TranslationRecognitionEventArgs($hM4QX.TranslationRecognitionResult.fromSpeechRecognitionResult(result), duration, sessionId);
            this.privTranslationRecognizer.recognizing(this.privTranslationRecognizer, ev);
        /* eslint-disable no-empty */ } catch (error) {
        // Not going to let errors in the event handler
        // trip things up.
        }
    };
    TranslationServiceRecognizer.prototype.handleRecognizedCallback = function(result, offset, sessionId) {
        try {
            var ev = new $hM4QX.TranslationRecognitionEventArgs($hM4QX.TranslationRecognitionResult.fromSpeechRecognitionResult(result), offset, sessionId);
            this.privTranslationRecognizer.recognized(this.privTranslationRecognizer, ev);
        } catch (error) {
        // Not going to let errors in the event handler
        // trip things up.
        }
    };
    TranslationServiceRecognizer.prototype.fireEventForResult = function(serviceResult, properties) {
        var translations;
        if (undefined !== serviceResult.Translation.Translations) {
            translations = new $hM4QX.Translations();
            for(var _i = 0, _a = serviceResult.Translation.Translations; _i < _a.length; _i++){
                var translation = _a[_i];
                translations.set(translation.Language, translation.Text || translation.DisplayText);
            }
        }
        var resultReason;
        var language;
        var confidence;
        if (serviceResult instanceof $dEkJU.TranslationPhrase) {
            if (!!serviceResult.Translation && serviceResult.Translation.TranslationStatus === $em8BD.TranslationStatus.Success) resultReason = $hM4QX.ResultReason.TranslatedSpeech;
            else resultReason = $hM4QX.ResultReason.RecognizedSpeech;
            language = serviceResult.Language;
            confidence = serviceResult.Confidence;
        } else resultReason = $hM4QX.ResultReason.TranslatingSpeech;
        var offset = serviceResult.Offset + this.privRequestSession.currentTurnAudioOffset;
        var result = new $hM4QX.TranslationRecognitionResult(translations, this.privRequestSession.requestId, resultReason, serviceResult.Text, serviceResult.Duration, offset, language, confidence, serviceResult.Translation.FailureReason, JSON.stringify(serviceResult), properties);
        var ev = new $hM4QX.TranslationRecognitionEventArgs(result, offset, this.privRequestSession.sessionId);
        return ev;
    };
    TranslationServiceRecognizer.prototype.sendSynthesisAudio = function(audio, sessionId) {
        var reason = undefined === audio ? $hM4QX.ResultReason.SynthesizingAudioCompleted : $hM4QX.ResultReason.SynthesizingAudio;
        var result = new $hM4QX.TranslationSynthesisResult(reason, audio);
        var retEvent = new $hM4QX.TranslationSynthesisEventArgs(result, sessionId);
        if (!!this.privTranslationRecognizer.synthesizing) try {
            this.privTranslationRecognizer.synthesizing(this.privTranslationRecognizer, retEvent);
        /* eslint-disable no-empty */ } catch (error) {
        // Not going to let errors in the event handler
        // trip things up.
        }
    };
    return TranslationServiceRecognizer;
}($dEkJU.ConversationServiceRecognizer);
module.exports.TranslationServiceRecognizer = $9193bf8bd4ea824a$var$TranslationServiceRecognizer;

});

parcelRequire.register("04nij", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SpeechDetected = void 0;
var $00d2719d45be76f5$var$SpeechDetected = /** @class */ function() {
    function SpeechDetected(json) {
        this.privSpeechStartDetected = JSON.parse(json);
    }
    SpeechDetected.fromJSON = function(json) {
        return new SpeechDetected(json);
    };
    Object.defineProperty(SpeechDetected.prototype, "Offset", {
        get: function() {
            return this.privSpeechStartDetected.Offset;
        },
        enumerable: false,
        configurable: true
    });
    return SpeechDetected;
}();
module.exports.SpeechDetected = $00d2719d45be76f5$var$SpeechDetected;

});

parcelRequire.register("briX4", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SpeechHypothesis = void 0;
var $8540eabf3c24ac61$var$SpeechHypothesis = /** @class */ function() {
    function SpeechHypothesis(json) {
        this.privSpeechHypothesis = JSON.parse(json);
    }
    SpeechHypothesis.fromJSON = function(json) {
        return new SpeechHypothesis(json);
    };
    Object.defineProperty(SpeechHypothesis.prototype, "Text", {
        get: function() {
            return this.privSpeechHypothesis.Text;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SpeechHypothesis.prototype, "Offset", {
        get: function() {
            return this.privSpeechHypothesis.Offset;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SpeechHypothesis.prototype, "Duration", {
        get: function() {
            return this.privSpeechHypothesis.Duration;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SpeechHypothesis.prototype, "Language", {
        get: function() {
            return this.privSpeechHypothesis.PrimaryLanguage === undefined ? undefined : this.privSpeechHypothesis.PrimaryLanguage.Language;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SpeechHypothesis.prototype, "LanguageDetectionConfidence", {
        get: function() {
            return this.privSpeechHypothesis.PrimaryLanguage === undefined ? undefined : this.privSpeechHypothesis.PrimaryLanguage.Confidence;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SpeechHypothesis.prototype, "SpeakerId", {
        get: function() {
            return this.privSpeechHypothesis.SpeakerId;
        },
        enumerable: false,
        configurable: true
    });
    return SpeechHypothesis;
}();
module.exports.SpeechHypothesis = $8540eabf3c24ac61$var$SpeechHypothesis;

});

parcelRequire.register("gTTo4", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SpeechKeyword = void 0;
var $c4dcbf2a6c12d87e$var$SpeechKeyword = /** @class */ function() {
    function SpeechKeyword(json) {
        this.privSpeechKeyword = JSON.parse(json);
    }
    SpeechKeyword.fromJSON = function(json) {
        return new SpeechKeyword(json);
    };
    Object.defineProperty(SpeechKeyword.prototype, "Status", {
        get: function() {
            return this.privSpeechKeyword.Status;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SpeechKeyword.prototype, "Text", {
        get: function() {
            return this.privSpeechKeyword.Text;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SpeechKeyword.prototype, "Offset", {
        get: function() {
            return this.privSpeechKeyword.Offset;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SpeechKeyword.prototype, "Duration", {
        get: function() {
            return this.privSpeechKeyword.Duration;
        },
        enumerable: false,
        configurable: true
    });
    return SpeechKeyword;
}();
module.exports.SpeechKeyword = $c4dcbf2a6c12d87e$var$SpeechKeyword;

});

parcelRequire.register("aXg6y", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
var $7f9be827e753f630$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $7f9be827e753f630$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $7f9be827e753f630$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SpeechServiceRecognizer = void 0;

var $hM4QX = parcelRequire("hM4QX");

var $dEkJU = parcelRequire("dEkJU");
// eslint-disable-next-line max-classes-per-file
var $7f9be827e753f630$var$SpeechServiceRecognizer = /** @class */ function(_super) {
    $7f9be827e753f630$var$__extends(SpeechServiceRecognizer, _super);
    function SpeechServiceRecognizer(authentication, connectionFactory, audioSource, recognizerConfig, speechRecognizer) {
        var _this = _super.call(this, authentication, connectionFactory, audioSource, recognizerConfig, speechRecognizer) || this;
        _this.privSpeechRecognizer = speechRecognizer;
        return _this;
    }
    SpeechServiceRecognizer.prototype.processTypeSpecificMessages = function(connectionMessage) {
        return $7f9be827e753f630$var$__awaiter(this, void 0, void 0, function() {
            var result, resultProps, processed, _a, hypothesis, offset, ev, simple, resultReason, cancelReason, cancellationErrorCode, detailed, totalOffset, offsetCorrectedJson, event_1;
            return $7f9be827e753f630$var$__generator(this, function(_b) {
                switch(_b.label){
                    case 0:
                        resultProps = new $hM4QX.PropertyCollection();
                        resultProps.setProperty($hM4QX.PropertyId.SpeechServiceResponse_JsonResult, connectionMessage.textBody);
                        processed = false;
                        _a = connectionMessage.path.toLowerCase();
                        switch(_a){
                            case "speech.hypothesis":
                                return [
                                    3 /*break*/ ,
                                    1
                                ];
                            case "speech.fragment":
                                return [
                                    3 /*break*/ ,
                                    1
                                ];
                            case "speech.phrase":
                                return [
                                    3 /*break*/ ,
                                    2
                                ];
                        }
                        return [
                            3 /*break*/ ,
                            6
                        ];
                    case 1:
                        hypothesis = $dEkJU.SpeechHypothesis.fromJSON(connectionMessage.textBody);
                        offset = hypothesis.Offset + this.privRequestSession.currentTurnAudioOffset;
                        result = new $hM4QX.SpeechRecognitionResult(this.privRequestSession.requestId, $hM4QX.ResultReason.RecognizingSpeech, hypothesis.Text, hypothesis.Duration, offset, hypothesis.Language, hypothesis.LanguageDetectionConfidence, undefined, undefined, connectionMessage.textBody, resultProps);
                        this.privRequestSession.onHypothesis(offset);
                        ev = new $hM4QX.SpeechRecognitionEventArgs(result, hypothesis.Duration, this.privRequestSession.sessionId);
                        if (!!this.privSpeechRecognizer.recognizing) try {
                            this.privSpeechRecognizer.recognizing(this.privSpeechRecognizer, ev);
                        /* eslint-disable no-empty */ } catch (error) {
                        // Not going to let errors in the event handler
                        // trip things up.
                        }
                        processed = true;
                        return [
                            3 /*break*/ ,
                            7
                        ];
                    case 2:
                        simple = $dEkJU.SimpleSpeechPhrase.fromJSON(connectionMessage.textBody);
                        resultReason = $dEkJU.EnumTranslation.implTranslateRecognitionResult(simple.RecognitionStatus);
                        this.privRequestSession.onPhraseRecognized(this.privRequestSession.currentTurnAudioOffset + simple.Offset + simple.Duration);
                        if (!($hM4QX.ResultReason.Canceled === resultReason)) return [
                            3 /*break*/ ,
                            4
                        ];
                        cancelReason = $dEkJU.EnumTranslation.implTranslateCancelResult(simple.RecognitionStatus);
                        cancellationErrorCode = $dEkJU.EnumTranslation.implTranslateCancelErrorCode(simple.RecognitionStatus);
                        return [
                            4 /*yield*/ ,
                            this.cancelRecognitionLocal(cancelReason, cancellationErrorCode, $dEkJU.EnumTranslation.implTranslateErrorDetails(cancellationErrorCode))
                        ];
                    case 3:
                        _b.sent();
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 4:
                        if (!(this.privRequestSession.isSpeechEnded && resultReason === $hM4QX.ResultReason.NoMatch && simple.RecognitionStatus !== $dEkJU.RecognitionStatus.InitialSilenceTimeout)) {
                            if (this.privRecognizerConfig.parameters.getProperty($dEkJU.OutputFormatPropertyName) === $hM4QX.OutputFormat[$hM4QX.OutputFormat.Simple]) result = new $hM4QX.SpeechRecognitionResult(this.privRequestSession.requestId, resultReason, simple.DisplayText, simple.Duration, simple.Offset + this.privRequestSession.currentTurnAudioOffset, simple.Language, simple.LanguageDetectionConfidence, undefined, undefined, connectionMessage.textBody, resultProps);
                            else {
                                detailed = $dEkJU.DetailedSpeechPhrase.fromJSON(connectionMessage.textBody);
                                totalOffset = detailed.Offset + this.privRequestSession.currentTurnAudioOffset;
                                offsetCorrectedJson = detailed.getJsonWithCorrectedOffsets(totalOffset);
                                result = new $hM4QX.SpeechRecognitionResult(this.privRequestSession.requestId, resultReason, detailed.RecognitionStatus === $dEkJU.RecognitionStatus.Success ? detailed.NBest[0].Display : undefined, detailed.Duration, totalOffset, detailed.Language, detailed.LanguageDetectionConfidence, undefined, undefined, offsetCorrectedJson, resultProps);
                            }
                            event_1 = new $hM4QX.SpeechRecognitionEventArgs(result, result.offset, this.privRequestSession.sessionId);
                            if (!!this.privSpeechRecognizer.recognized) try {
                                this.privSpeechRecognizer.recognized(this.privSpeechRecognizer, event_1);
                            /* eslint-disable no-empty */ } catch (error) {
                            // Not going to let errors in the event handler
                            // trip things up.
                            }
                        }
                        if (!!this.privSuccessCallback) {
                            try {
                                this.privSuccessCallback(result);
                            } catch (e) {
                                if (!!this.privErrorCallback) this.privErrorCallback(e);
                            }
                            // Only invoke the call back once.
                            // and if it's successful don't invoke the
                            // error after that.
                            this.privSuccessCallback = undefined;
                            this.privErrorCallback = undefined;
                        }
                        _b.label = 5;
                    case 5:
                        processed = true;
                        return [
                            3 /*break*/ ,
                            7
                        ];
                    case 6:
                        return [
                            3 /*break*/ ,
                            7
                        ];
                    case 7:
                        return [
                            2 /*return*/ ,
                            processed
                        ];
                }
            });
        });
    };
    // Cancels recognition.
    SpeechServiceRecognizer.prototype.cancelRecognition = function(sessionId, requestId, cancellationReason, errorCode, error) {
        var properties = new $hM4QX.PropertyCollection();
        properties.setProperty($dEkJU.CancellationErrorCodePropertyName, $hM4QX.CancellationErrorCode[errorCode]);
        if (!!this.privSpeechRecognizer.canceled) {
            var cancelEvent = new $hM4QX.SpeechRecognitionCanceledEventArgs(cancellationReason, error, errorCode, undefined, sessionId);
            try {
                this.privSpeechRecognizer.canceled(this.privSpeechRecognizer, cancelEvent);
            /* eslint-disable no-empty */ } catch (_a) {}
        }
        if (!!this.privSuccessCallback) {
            var result = new $hM4QX.SpeechRecognitionResult(requestId, $hM4QX.ResultReason.Canceled, undefined, undefined, undefined, undefined, undefined, undefined, error, undefined, properties);
            try {
                this.privSuccessCallback(result);
                this.privSuccessCallback = undefined;
            /* eslint-disable no-empty */ } catch (_b) {}
        }
    };
    return SpeechServiceRecognizer;
}($dEkJU.ServiceRecognizerBase);
module.exports.SpeechServiceRecognizer = $7f9be827e753f630$var$SpeechServiceRecognizer;

});

parcelRequire.register("hLQpx", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
var $ceff7b2c4c8c076f$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $ceff7b2c4c8c076f$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $ceff7b2c4c8c076f$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TranscriptionServiceRecognizer = void 0;

var $em8BD = parcelRequire("em8BD");

var $hM4QX = parcelRequire("hM4QX");

var $dEkJU = parcelRequire("dEkJU");

var $bhJcv = parcelRequire("bhJcv");
// eslint-disable-next-line max-classes-per-file
var $ceff7b2c4c8c076f$var$TranscriptionServiceRecognizer = /** @class */ function(_super) {
    $ceff7b2c4c8c076f$var$__extends(TranscriptionServiceRecognizer, _super);
    function TranscriptionServiceRecognizer(authentication, connectionFactory, audioSource, recognizerConfig, transcriber) {
        var _this = _super.call(this, authentication, connectionFactory, audioSource, recognizerConfig, transcriber) || this;
        _this.privTranscriberRecognizer = transcriber;
        _this.sendPrePayloadJSONOverride = function(connection) {
            return _this.sendTranscriptionStartJSON(connection);
        };
        if (_this.privRecognizerConfig.parameters.getProperty($hM4QX.PropertyId.SpeechServiceResponse_RequestWordLevelTimestamps) === "true") _this.privSpeechContext.setWordLevelTimings();
        return _this;
    }
    TranscriptionServiceRecognizer.prototype.sendSpeechEventAsync = function(info, command) {
        return $ceff7b2c4c8c076f$var$__awaiter(this, void 0, void 0, function() {
            var connection;
            return $ceff7b2c4c8c076f$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!!!this.privRequestSession.isRecognizing) return [
                            3 /*break*/ ,
                            3
                        ];
                        return [
                            4 /*yield*/ ,
                            this.fetchConnection()
                        ];
                    case 1:
                        connection = _a.sent();
                        return [
                            4 /*yield*/ ,
                            this.sendSpeechEvent(connection, this.createSpeechEventPayload(info, command))
                        ];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    TranscriptionServiceRecognizer.prototype.processTypeSpecificMessages = function(connectionMessage) {
        return this.processSpeechMessages(connectionMessage);
    };
    TranscriptionServiceRecognizer.prototype.handleRecognizedCallback = function(result, offset, sessionId) {
        try {
            var event_1 = new $hM4QX.SpeechRecognitionEventArgs(result, offset, sessionId);
            this.privTranscriberRecognizer.recognized(this.privTranscriberRecognizer, event_1);
            if (!!this.privSuccessCallback) {
                try {
                    this.privSuccessCallback(result);
                } catch (e) {
                    if (!!this.privErrorCallback) this.privErrorCallback(e);
                }
                // Only invoke the call back once.
                // and if it's successful don't invoke the
                // error after that.
                this.privSuccessCallback = undefined;
                this.privErrorCallback = undefined;
            }
        /* eslint-disable no-empty */ } catch (error) {
        // Not going to let errors in the event handler
        // trip things up.
        }
    };
    TranscriptionServiceRecognizer.prototype.handleRecognizingCallback = function(result, duration, sessionId) {
        try {
            var ev = new $hM4QX.SpeechRecognitionEventArgs(result, duration, sessionId);
            this.privTranscriberRecognizer.recognizing(this.privTranscriberRecognizer, ev);
        /* eslint-disable no-empty */ } catch (error) {
        // Not going to let errors in the event handler
        // trip things up.
        }
    };
    // Cancels recognition.
    TranscriptionServiceRecognizer.prototype.cancelRecognition = function(sessionId, requestId, cancellationReason, errorCode, error) {
        var properties = new $hM4QX.PropertyCollection();
        properties.setProperty($dEkJU.CancellationErrorCodePropertyName, $hM4QX.CancellationErrorCode[errorCode]);
        if (!!this.privTranscriberRecognizer.canceled) {
            var cancelEvent = new $hM4QX.ConversationTranscriptionCanceledEventArgs(cancellationReason, error, errorCode, undefined, sessionId);
            try {
                this.privTranscriberRecognizer.canceled(this.privTranscriberRecognizer, cancelEvent);
            /* eslint-disable no-empty */ } catch (_a) {}
        }
        if (!!this.privSuccessCallback) {
            var result = new $hM4QX.SpeechRecognitionResult(requestId, $hM4QX.ResultReason.Canceled, undefined, undefined, undefined, undefined, undefined, undefined, error, undefined, properties);
            try {
                this.privSuccessCallback(result);
                this.privSuccessCallback = undefined;
            /* eslint-disable no-empty */ } catch (_b) {}
        }
    };
    // Encapsulated for derived service recognizers that need to send additional JSON
    TranscriptionServiceRecognizer.prototype.sendTranscriptionStartJSON = function(connection) {
        return $ceff7b2c4c8c076f$var$__awaiter(this, void 0, void 0, function() {
            var info, payload;
            return $ceff7b2c4c8c076f$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.sendSpeechContext(connection, true)
                        ];
                    case 1:
                        _a.sent();
                        info = this.privTranscriberRecognizer.getConversationInfo();
                        payload = this.createSpeechEventPayload(info, "start");
                        return [
                            4 /*yield*/ ,
                            this.sendSpeechEvent(connection, payload)
                        ];
                    case 2:
                        _a.sent();
                        return [
                            4 /*yield*/ ,
                            this.sendWaveHeader(connection)
                        ];
                    case 3:
                        _a.sent();
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    TranscriptionServiceRecognizer.prototype.sendSpeechEvent = function(connection, payload) {
        var speechEventJson = JSON.stringify(payload);
        if (speechEventJson) return connection.send(new $bhJcv.SpeechConnectionMessage($em8BD.MessageType.Text, "speech.event", this.privRequestSession.requestId, "application/json", speechEventJson));
        return;
    };
    TranscriptionServiceRecognizer.prototype.createSpeechEventPayload = function(info, command) {
        var eventDict = {
            id: "meeting",
            name: command,
            meeting: info.conversationProperties
        };
        eventDict.meeting.id = info.id;
        eventDict.meeting.attendees = info.participants;
        eventDict.meeting.record = info.conversationProperties.audiorecording === "on" ? "true" : "false";
        return eventDict;
    };
    return TranscriptionServiceRecognizer;
}($dEkJU.ConversationServiceRecognizer);
module.exports.TranscriptionServiceRecognizer = $ceff7b2c4c8c076f$var$TranscriptionServiceRecognizer;

});

parcelRequire.register("kxLan", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DetailedSpeechPhrase = void 0;

var $dEkJU = parcelRequire("dEkJU");
var $ef4b79f2d4cbb39b$var$DetailedSpeechPhrase = /** @class */ function() {
    function DetailedSpeechPhrase(json) {
        this.privDetailedSpeechPhrase = JSON.parse(json);
        this.privDetailedSpeechPhrase.RecognitionStatus = $dEkJU.RecognitionStatus[this.privDetailedSpeechPhrase.RecognitionStatus];
    }
    DetailedSpeechPhrase.fromJSON = function(json) {
        return new DetailedSpeechPhrase(json);
    };
    DetailedSpeechPhrase.prototype.getJsonWithCorrectedOffsets = function(baseOffset) {
        if (!!this.privDetailedSpeechPhrase.NBest) {
            var firstWordOffset = void 0;
            for(var _i = 0, _a = this.privDetailedSpeechPhrase.NBest; _i < _a.length; _i++){
                var phrase = _a[_i];
                if (!!phrase.Words && !!phrase.Words[0]) {
                    firstWordOffset = phrase.Words[0].Offset;
                    break;
                }
            }
            if (!!firstWordOffset && firstWordOffset < baseOffset) {
                var offset = baseOffset - firstWordOffset;
                for(var _b = 0, _c = this.privDetailedSpeechPhrase.NBest; _b < _c.length; _b++){
                    var details = _c[_b];
                    if (!!details.Words) for(var _d = 0, _e = details.Words; _d < _e.length; _d++){
                        var word = _e[_d];
                        word.Offset += offset;
                    }
                    if (!!details.DisplayWords) for(var _f = 0, _g = details.DisplayWords; _f < _g.length; _f++){
                        var word = _g[_f];
                        word.Offset += offset;
                    }
                }
            }
        }
        return JSON.stringify(this.privDetailedSpeechPhrase);
    };
    Object.defineProperty(DetailedSpeechPhrase.prototype, "RecognitionStatus", {
        get: function() {
            return this.privDetailedSpeechPhrase.RecognitionStatus;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DetailedSpeechPhrase.prototype, "NBest", {
        get: function() {
            return this.privDetailedSpeechPhrase.NBest;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DetailedSpeechPhrase.prototype, "Duration", {
        get: function() {
            return this.privDetailedSpeechPhrase.Duration;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DetailedSpeechPhrase.prototype, "Offset", {
        get: function() {
            return this.privDetailedSpeechPhrase.Offset;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DetailedSpeechPhrase.prototype, "Language", {
        get: function() {
            return this.privDetailedSpeechPhrase.PrimaryLanguage === undefined ? undefined : this.privDetailedSpeechPhrase.PrimaryLanguage.Language;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DetailedSpeechPhrase.prototype, "LanguageDetectionConfidence", {
        get: function() {
            return this.privDetailedSpeechPhrase.PrimaryLanguage === undefined ? undefined : this.privDetailedSpeechPhrase.PrimaryLanguage.Confidence;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DetailedSpeechPhrase.prototype, "Text", {
        get: function() {
            if (!!this.privDetailedSpeechPhrase.NBest && this.privDetailedSpeechPhrase.NBest[0]) return this.privDetailedSpeechPhrase.NBest[0].Display || this.privDetailedSpeechPhrase.NBest[0].DisplayText;
            return this.privDetailedSpeechPhrase.DisplayText;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DetailedSpeechPhrase.prototype, "SpeakerId", {
        get: function() {
            return this.privDetailedSpeechPhrase.SpeakerId;
        },
        enumerable: false,
        configurable: true
    });
    return DetailedSpeechPhrase;
}();
module.exports.DetailedSpeechPhrase = $ef4b79f2d4cbb39b$var$DetailedSpeechPhrase;

});

parcelRequire.register("izLqs", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SimpleSpeechPhrase = void 0;

var $dEkJU = parcelRequire("dEkJU");
var $d86048a9f57ea80b$var$SimpleSpeechPhrase = /** @class */ function() {
    function SimpleSpeechPhrase(json) {
        this.privSimpleSpeechPhrase = JSON.parse(json);
        this.privSimpleSpeechPhrase.RecognitionStatus = $dEkJU.RecognitionStatus[this.privSimpleSpeechPhrase.RecognitionStatus];
    }
    SimpleSpeechPhrase.fromJSON = function(json) {
        return new SimpleSpeechPhrase(json);
    };
    Object.defineProperty(SimpleSpeechPhrase.prototype, "RecognitionStatus", {
        get: function() {
            return this.privSimpleSpeechPhrase.RecognitionStatus;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SimpleSpeechPhrase.prototype, "DisplayText", {
        get: function() {
            return this.privSimpleSpeechPhrase.DisplayText;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SimpleSpeechPhrase.prototype, "Offset", {
        get: function() {
            return this.privSimpleSpeechPhrase.Offset;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SimpleSpeechPhrase.prototype, "Duration", {
        get: function() {
            return this.privSimpleSpeechPhrase.Duration;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SimpleSpeechPhrase.prototype, "Language", {
        get: function() {
            return this.privSimpleSpeechPhrase.PrimaryLanguage === undefined ? undefined : this.privSimpleSpeechPhrase.PrimaryLanguage.Language;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SimpleSpeechPhrase.prototype, "LanguageDetectionConfidence", {
        get: function() {
            return this.privSimpleSpeechPhrase.PrimaryLanguage === undefined ? undefined : this.privSimpleSpeechPhrase.PrimaryLanguage.Confidence;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SimpleSpeechPhrase.prototype, "SpeakerId", {
        get: function() {
            return this.privSimpleSpeechPhrase.SpeakerId;
        },
        enumerable: false,
        configurable: true
    });
    return SimpleSpeechPhrase;
}();
module.exports.SimpleSpeechPhrase = $d86048a9f57ea80b$var$SimpleSpeechPhrase;

});

parcelRequire.register("f1uss", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.AddedLmIntent = void 0;
/**
 * @class AddedLmIntent
 */ // eslint-disable-next-line max-classes-per-file
var $aefe93546ab721c3$var$AddedLmIntent = /** @class */ function() {
    /**
     * Creates and initializes an instance of this class.
     * @constructor
     * @param modelImpl - The model.
     * @param intentName - The intent name.
     */ function AddedLmIntent(modelImpl, intentName) {
        this.modelImpl = modelImpl;
        this.intentName = intentName;
    }
    return AddedLmIntent;
}();
module.exports.AddedLmIntent = $aefe93546ab721c3$var$AddedLmIntent;

});

parcelRequire.register("bM30t", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
var $8926827761f551a4$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.IntentServiceRecognizer = void 0;

var $em8BD = parcelRequire("em8BD");

var $hM4QX = parcelRequire("hM4QX");

var $dEkJU = parcelRequire("dEkJU");
// eslint-disable-next-line max-classes-per-file
var $8926827761f551a4$var$IntentServiceRecognizer = /** @class */ function(_super) {
    $8926827761f551a4$var$__extends(IntentServiceRecognizer, _super);
    function IntentServiceRecognizer(authentication, connectionFactory, audioSource, recognizerConfig, recognizer) {
        var _this = _super.call(this, authentication, connectionFactory, audioSource, recognizerConfig, recognizer) || this;
        _this.privIntentRecognizer = recognizer;
        _this.privIntentDataSent = false;
        return _this;
    }
    IntentServiceRecognizer.prototype.setIntents = function(addedIntents, umbrellaIntent) {
        this.privAddedLmIntents = addedIntents;
        this.privUmbrellaIntent = umbrellaIntent;
        this.privIntentDataSent = true;
    };
    IntentServiceRecognizer.prototype.processTypeSpecificMessages = function(connectionMessage) {
        var _this = this;
        var result;
        var ev;
        var processed = false;
        var resultProps = new $hM4QX.PropertyCollection();
        if (connectionMessage.messageType === $em8BD.MessageType.Text) resultProps.setProperty($hM4QX.PropertyId.SpeechServiceResponse_JsonResult, connectionMessage.textBody);
        switch(connectionMessage.path.toLowerCase()){
            case "speech.hypothesis":
                var speechHypothesis = $dEkJU.SpeechHypothesis.fromJSON(connectionMessage.textBody);
                result = new $hM4QX.IntentRecognitionResult(undefined, this.privRequestSession.requestId, $hM4QX.ResultReason.RecognizingIntent, speechHypothesis.Text, speechHypothesis.Duration, speechHypothesis.Offset + this.privRequestSession.currentTurnAudioOffset, speechHypothesis.Language, speechHypothesis.LanguageDetectionConfidence, undefined, connectionMessage.textBody, resultProps);
                this.privRequestSession.onHypothesis(result.offset);
                ev = new $hM4QX.IntentRecognitionEventArgs(result, speechHypothesis.Offset + this.privRequestSession.currentTurnAudioOffset, this.privRequestSession.sessionId);
                if (!!this.privIntentRecognizer.recognizing) try {
                    this.privIntentRecognizer.recognizing(this.privIntentRecognizer, ev);
                /* eslint-disable no-empty */ } catch (error) {
                // Not going to let errors in the event handler
                // trip things up.
                }
                processed = true;
                break;
            case "speech.phrase":
                var simple = $dEkJU.SimpleSpeechPhrase.fromJSON(connectionMessage.textBody);
                result = new $hM4QX.IntentRecognitionResult(undefined, this.privRequestSession.requestId, $dEkJU.EnumTranslation.implTranslateRecognitionResult(simple.RecognitionStatus), simple.DisplayText, simple.Duration, simple.Offset + this.privRequestSession.currentTurnAudioOffset, simple.Language, simple.LanguageDetectionConfidence, undefined, connectionMessage.textBody, resultProps);
                ev = new $hM4QX.IntentRecognitionEventArgs(result, result.offset, this.privRequestSession.sessionId);
                var sendEvent = function() {
                    if (!!_this.privIntentRecognizer.recognized) try {
                        _this.privIntentRecognizer.recognized(_this.privIntentRecognizer, ev);
                    /* eslint-disable no-empty */ } catch (error) {
                    // Not going to let errors in the event handler
                    // trip things up.
                    }
                    // report result to promise.
                    if (!!_this.privSuccessCallback) {
                        try {
                            _this.privSuccessCallback(result);
                        } catch (e) {
                            if (!!_this.privErrorCallback) _this.privErrorCallback(e);
                        }
                        // Only invoke the call back once.
                        // and if it's successful don't invoke the
                        // error after that.
                        _this.privSuccessCallback = undefined;
                        _this.privErrorCallback = undefined;
                    }
                };
                // If intent data was sent, the terminal result for this recognizer is an intent being found.
                // If no intent data was sent, the terminal event is speech recognition being successful.
                if (false === this.privIntentDataSent || $hM4QX.ResultReason.NoMatch === ev.result.reason) {
                    // Advance the buffers.
                    this.privRequestSession.onPhraseRecognized(ev.offset + ev.result.duration);
                    sendEvent();
                } else // Squirrel away the args, when the response event arrives it will build upon them
                // and then return
                this.privPendingIntentArgs = ev;
                processed = true;
                break;
            case "response":
                // Response from LUIS
                ev = this.privPendingIntentArgs;
                this.privPendingIntentArgs = undefined;
                if (undefined === ev) {
                    if ("" === connectionMessage.textBody) // This condition happens if there is nothing but silence in the
                    // audio sent to the service.
                    return;
                    // Odd... Not sure this can happen
                    ev = new $hM4QX.IntentRecognitionEventArgs(new $hM4QX.IntentRecognitionResult(), 0, this.privRequestSession.sessionId);
                }
                var intentResponse = $dEkJU.IntentResponse.fromJSON(connectionMessage.textBody);
                // If LUIS didn't return anything, send the existing event, else
                // modify it to show the match.
                // See if the intent found is in the list of intents asked for.
                if (null !== intentResponse && !!intentResponse.topScoringIntent && !!intentResponse.topScoringIntent.intent) {
                    var addedIntent = this.privAddedLmIntents[intentResponse.topScoringIntent.intent];
                    if (this.privUmbrellaIntent !== undefined) addedIntent = this.privUmbrellaIntent;
                    if (!!addedIntent) {
                        var intentId = addedIntent === undefined || addedIntent.intentName === undefined ? intentResponse.topScoringIntent.intent : addedIntent.intentName;
                        var reason = ev.result.reason;
                        if (undefined !== intentId) reason = $hM4QX.ResultReason.RecognizedIntent;
                        // make sure, properties is set.
                        var properties = undefined !== ev.result.properties ? ev.result.properties : new $hM4QX.PropertyCollection();
                        properties.setProperty($hM4QX.PropertyId.LanguageUnderstandingServiceResponse_JsonResult, connectionMessage.textBody);
                        ev = new $hM4QX.IntentRecognitionEventArgs(new $hM4QX.IntentRecognitionResult(intentId, ev.result.resultId, reason, ev.result.text, ev.result.duration, ev.result.offset, undefined, undefined, ev.result.errorDetails, ev.result.json, properties), ev.offset, ev.sessionId);
                    }
                }
                this.privRequestSession.onPhraseRecognized(ev.offset + ev.result.duration);
                if (!!this.privIntentRecognizer.recognized) try {
                    this.privIntentRecognizer.recognized(this.privIntentRecognizer, ev);
                /* eslint-disable no-empty */ } catch (error) {
                // Not going to let errors in the event handler
                // trip things up.
                }
                // report result to promise.
                if (!!this.privSuccessCallback) {
                    try {
                        this.privSuccessCallback(ev.result);
                    } catch (e) {
                        if (!!this.privErrorCallback) this.privErrorCallback(e);
                    }
                    // Only invoke the call back once.
                    // and if it's successful don't invoke the
                    // error after that.
                    this.privSuccessCallback = undefined;
                    this.privErrorCallback = undefined;
                }
                processed = true;
                break;
            default:
                break;
        }
        var defferal = new $em8BD.Deferred();
        defferal.resolve(processed);
        return defferal.promise;
    };
    // Cancels recognition.
    IntentServiceRecognizer.prototype.cancelRecognition = function(sessionId, requestId, cancellationReason, errorCode, error) {
        var properties = new $hM4QX.PropertyCollection();
        properties.setProperty($dEkJU.CancellationErrorCodePropertyName, $hM4QX.CancellationErrorCode[errorCode]);
        if (!!this.privIntentRecognizer.canceled) {
            var cancelEvent = new $hM4QX.IntentRecognitionCanceledEventArgs(cancellationReason, error, errorCode, undefined, undefined, sessionId);
            try {
                this.privIntentRecognizer.canceled(this.privIntentRecognizer, cancelEvent);
            /* eslint-disable no-empty */ } catch (_a) {}
        }
        if (!!this.privSuccessCallback) {
            var result = new $hM4QX.IntentRecognitionResult(undefined, requestId, $hM4QX.ResultReason.Canceled, undefined, undefined, undefined, undefined, undefined, error, undefined, properties);
            try {
                this.privSuccessCallback(result);
                this.privSuccessCallback = undefined;
            /* eslint-disable no-empty */ } catch (_b) {}
        }
    };
    return IntentServiceRecognizer;
}($dEkJU.ServiceRecognizerBase);
module.exports.IntentServiceRecognizer = $8926827761f551a4$var$IntentServiceRecognizer;

});

parcelRequire.register("1yT3h", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
// response
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.IntentResponse = void 0;
var $1233ab999c70a03b$var$IntentResponse = /** @class */ function() {
    function IntentResponse(json) {
        if (json === "") this.privIntentResponse = {};
        else this.privIntentResponse = JSON.parse(json);
    }
    IntentResponse.fromJSON = function(json) {
        return new IntentResponse(json);
    };
    Object.defineProperty(IntentResponse.prototype, "query", {
        get: function() {
            return this.privIntentResponse.query;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IntentResponse.prototype, "topScoringIntent", {
        get: function() {
            return this.privIntentResponse.topScoringIntent;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IntentResponse.prototype, "entities", {
        get: function() {
            return this.privIntentResponse.entities;
        },
        enumerable: false,
        configurable: true
    });
    return IntentResponse;
}();
module.exports.IntentResponse = $1233ab999c70a03b$var$IntentResponse;

});

parcelRequire.register("4FBPA", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
/* eslint-disable max-classes-per-file */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRequire.register("80tNO", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
var $5d4570eec09609cc$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $5d4570eec09609cc$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RequestSession = void 0;

var $em8BD = parcelRequire("em8BD");

var $7AiNN = parcelRequire("7AiNN");

var $hW9Ty = parcelRequire("hW9Ty");
var $5d4570eec09609cc$var$RequestSession = /** @class */ function() {
    function RequestSession(audioSourceId) {
        this.privIsDisposed = false;
        this.privDetachables = new Array();
        this.privIsAudioNodeDetached = false;
        this.privIsRecognizing = false;
        this.privIsSpeechEnded = false;
        this.privTurnStartAudioOffset = 0;
        this.privLastRecoOffset = 0;
        this.privHypothesisReceived = false;
        this.privBytesSent = 0;
        this.privRecogNumber = 0;
        this.privInTurn = false;
        this.privConnectionAttempts = 0;
        this.privAudioSourceId = audioSourceId;
        this.privRequestId = $em8BD.createNoDashGuid();
        this.privAudioNodeId = $em8BD.createNoDashGuid();
        this.privTurnDeferral = new $em8BD.Deferred();
        // We're not in a turn, so resolve.
        this.privTurnDeferral.resolve();
    }
    Object.defineProperty(RequestSession.prototype, "sessionId", {
        get: function() {
            return this.privSessionId;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(RequestSession.prototype, "requestId", {
        get: function() {
            return this.privRequestId;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(RequestSession.prototype, "audioNodeId", {
        get: function() {
            return this.privAudioNodeId;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(RequestSession.prototype, "turnCompletionPromise", {
        get: function() {
            return this.privTurnDeferral.promise;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(RequestSession.prototype, "isSpeechEnded", {
        get: function() {
            return this.privIsSpeechEnded;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(RequestSession.prototype, "isRecognizing", {
        get: function() {
            return this.privIsRecognizing;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(RequestSession.prototype, "currentTurnAudioOffset", {
        get: function() {
            return this.privTurnStartAudioOffset;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(RequestSession.prototype, "recogNumber", {
        get: function() {
            return this.privRecogNumber;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(RequestSession.prototype, "numConnectionAttempts", {
        get: function() {
            return this.privConnectionAttempts;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(RequestSession.prototype, "bytesSent", {
        // The number of bytes sent for the current connection.
        // Counter is reset to 0 each time a connection is established.
        get: function() {
            return this.privBytesSent;
        },
        enumerable: false,
        configurable: true
    });
    RequestSession.prototype.listenForServiceTelemetry = function(eventSource) {
        if (!!this.privServiceTelemetryListener) this.privDetachables.push(eventSource.attachListener(this.privServiceTelemetryListener));
    };
    RequestSession.prototype.startNewRecognition = function() {
        this.privIsSpeechEnded = false;
        this.privIsRecognizing = true;
        this.privTurnStartAudioOffset = 0;
        this.privLastRecoOffset = 0;
        this.privRecogNumber++;
        this.privServiceTelemetryListener = new $hW9Ty.ServiceTelemetryListener(this.privRequestId, this.privAudioSourceId, this.privAudioNodeId);
        this.onEvent(new $7AiNN.RecognitionTriggeredEvent(this.requestId, this.privSessionId, this.privAudioSourceId, this.privAudioNodeId));
    };
    RequestSession.prototype.onAudioSourceAttachCompleted = function(audioNode, isError) {
        return $5d4570eec09609cc$var$__awaiter(this, void 0, void 0, function() {
            return $5d4570eec09609cc$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        this.privAudioNode = audioNode;
                        this.privIsAudioNodeDetached = false;
                        if (!isError) return [
                            3 /*break*/ ,
                            2
                        ];
                        return [
                            4 /*yield*/ ,
                            this.onComplete()
                        ];
                    case 1:
                        _a.sent();
                        return [
                            3 /*break*/ ,
                            3
                        ];
                    case 2:
                        this.onEvent(new $7AiNN.ListeningStartedEvent(this.privRequestId, this.privSessionId, this.privAudioSourceId, this.privAudioNodeId));
                        _a.label = 3;
                    case 3:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    RequestSession.prototype.onPreConnectionStart = function(authFetchEventId, connectionId) {
        this.privAuthFetchEventId = authFetchEventId;
        this.privSessionId = connectionId;
        this.onEvent(new $7AiNN.ConnectingToServiceEvent(this.privRequestId, this.privAuthFetchEventId, this.privSessionId));
    };
    RequestSession.prototype.onAuthCompleted = function(isError) {
        return $5d4570eec09609cc$var$__awaiter(this, void 0, void 0, function() {
            return $5d4570eec09609cc$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!isError) return [
                            3 /*break*/ ,
                            2
                        ];
                        return [
                            4 /*yield*/ ,
                            this.onComplete()
                        ];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    RequestSession.prototype.onConnectionEstablishCompleted = function(statusCode, reason) {
        return $5d4570eec09609cc$var$__awaiter(this, void 0, void 0, function() {
            return $5d4570eec09609cc$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!(statusCode === 200)) return [
                            3 /*break*/ ,
                            1
                        ];
                        this.onEvent(new $7AiNN.RecognitionStartedEvent(this.requestId, this.privAudioSourceId, this.privAudioNodeId, this.privAuthFetchEventId, this.privSessionId));
                        if (!!this.privAudioNode) this.privAudioNode.replay();
                        this.privTurnStartAudioOffset = this.privLastRecoOffset;
                        this.privBytesSent = 0;
                        return [
                            2 /*return*/ 
                        ];
                    case 1:
                        if (!(statusCode === 403)) return [
                            3 /*break*/ ,
                            3
                        ];
                        return [
                            4 /*yield*/ ,
                            this.onComplete()
                        ];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    RequestSession.prototype.onServiceTurnEndResponse = function(continuousRecognition) {
        return $5d4570eec09609cc$var$__awaiter(this, void 0, void 0, function() {
            return $5d4570eec09609cc$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        this.privTurnDeferral.resolve();
                        if (!(!continuousRecognition || this.isSpeechEnded)) return [
                            3 /*break*/ ,
                            2
                        ];
                        return [
                            4 /*yield*/ ,
                            this.onComplete()
                        ];
                    case 1:
                        _a.sent();
                        this.privInTurn = false;
                        return [
                            3 /*break*/ ,
                            3
                        ];
                    case 2:
                        // Start a new request set.
                        this.privTurnStartAudioOffset = this.privLastRecoOffset;
                        this.privAudioNode.replay();
                        _a.label = 3;
                    case 3:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    RequestSession.prototype.onSpeechContext = function() {
        this.privRequestId = $em8BD.createNoDashGuid();
    };
    RequestSession.prototype.onServiceTurnStartResponse = function() {
        if (!!this.privTurnDeferral && !!this.privInTurn) {
            // What? How are we starting a turn with another not done?
            this.privTurnDeferral.reject("Another turn started before current completed.");
            // Avoid UnhandledPromiseRejection if privTurnDeferral is not being awaited
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            this.privTurnDeferral.promise.then().catch(function() {});
        }
        this.privInTurn = true;
        this.privTurnDeferral = new $em8BD.Deferred();
    };
    RequestSession.prototype.onHypothesis = function(offset) {
        if (!this.privHypothesisReceived) {
            this.privHypothesisReceived = true;
            this.privServiceTelemetryListener.hypothesisReceived(this.privAudioNode.findTimeAtOffset(offset));
        }
    };
    RequestSession.prototype.onPhraseRecognized = function(offset) {
        this.privServiceTelemetryListener.phraseReceived(this.privAudioNode.findTimeAtOffset(offset));
        this.onServiceRecognized(offset);
    };
    RequestSession.prototype.onServiceRecognized = function(offset) {
        this.privLastRecoOffset = offset;
        this.privHypothesisReceived = false;
        this.privAudioNode.shrinkBuffers(offset);
        this.privConnectionAttempts = 0;
    };
    RequestSession.prototype.onAudioSent = function(bytesSent) {
        this.privBytesSent += bytesSent;
    };
    RequestSession.prototype.onRetryConnection = function() {
        this.privConnectionAttempts++;
    };
    RequestSession.prototype.dispose = function() {
        return $5d4570eec09609cc$var$__awaiter(this, void 0, void 0, function() {
            var _i, _a, detachable;
            return $5d4570eec09609cc$var$__generator(this, function(_b) {
                switch(_b.label){
                    case 0:
                        if (!!this.privIsDisposed) return [
                            3 /*break*/ ,
                            5
                        ];
                        // we should have completed by now. If we did not its an unknown error.
                        this.privIsDisposed = true;
                        _i = 0, _a = this.privDetachables;
                        _b.label = 1;
                    case 1:
                        if (!(_i < _a.length)) return [
                            3 /*break*/ ,
                            4
                        ];
                        detachable = _a[_i];
                        return [
                            4 /*yield*/ ,
                            detachable.detach()
                        ];
                    case 2:
                        _b.sent();
                        _b.label = 3;
                    case 3:
                        _i++;
                        return [
                            3 /*break*/ ,
                            1
                        ];
                    case 4:
                        if (!!this.privServiceTelemetryListener) this.privServiceTelemetryListener.dispose();
                        this.privIsRecognizing = false;
                        _b.label = 5;
                    case 5:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    RequestSession.prototype.getTelemetry = function() {
        if (this.privServiceTelemetryListener.hasTelemetry) return this.privServiceTelemetryListener.getTelemetry();
        else return null;
    };
    RequestSession.prototype.onStopRecognizing = function() {
        return $5d4570eec09609cc$var$__awaiter(this, void 0, void 0, function() {
            return $5d4570eec09609cc$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.onComplete()
                        ];
                    case 1:
                        _a.sent();
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    // Should be called with the audioNode for this session has indicated that it is out of speech.
    RequestSession.prototype.onSpeechEnded = function() {
        this.privIsSpeechEnded = true;
    };
    RequestSession.prototype.onEvent = function(event) {
        if (!!this.privServiceTelemetryListener) this.privServiceTelemetryListener.onEvent(event);
        $em8BD.Events.instance.onEvent(event);
    };
    RequestSession.prototype.onComplete = function() {
        return $5d4570eec09609cc$var$__awaiter(this, void 0, void 0, function() {
            return $5d4570eec09609cc$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!!!this.privIsRecognizing) return [
                            3 /*break*/ ,
                            2
                        ];
                        this.privIsRecognizing = false;
                        return [
                            4 /*yield*/ ,
                            this.detachAudioNode()
                        ];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    RequestSession.prototype.detachAudioNode = function() {
        return $5d4570eec09609cc$var$__awaiter(this, void 0, void 0, function() {
            return $5d4570eec09609cc$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!!this.privIsAudioNodeDetached) return [
                            3 /*break*/ ,
                            2
                        ];
                        this.privIsAudioNodeDetached = true;
                        if (!this.privAudioNode) return [
                            3 /*break*/ ,
                            2
                        ];
                        return [
                            4 /*yield*/ ,
                            this.privAudioNode.detach()
                        ];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    return RequestSession;
}();
module.exports.RequestSession = $5d4570eec09609cc$var$RequestSession;

});
parcelRequire.register("hW9Ty", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ServiceTelemetryListener = void 0;

var $em8BD = parcelRequire("em8BD");

var $7AiNN = parcelRequire("7AiNN");
var $d0ef876bd678bbf2$var$ServiceTelemetryListener = /** @class */ function() {
    function ServiceTelemetryListener(requestId, audioSourceId, audioNodeId) {
        this.privIsDisposed = false;
        this.privListeningTriggerMetric = null;
        this.privMicMetric = null;
        this.privConnectionEstablishMetric = null;
        this.privRequestId = requestId;
        this.privAudioSourceId = audioSourceId;
        this.privAudioNodeId = audioNodeId;
        this.privReceivedMessages = {};
        this.privPhraseLatencies = [];
        this.privHypothesisLatencies = [];
    }
    ServiceTelemetryListener.prototype.phraseReceived = function(audioReceivedTime) {
        if (audioReceivedTime > 0) this.privPhraseLatencies.push(Date.now() - audioReceivedTime);
    };
    ServiceTelemetryListener.prototype.hypothesisReceived = function(audioReceivedTime) {
        if (audioReceivedTime > 0) this.privHypothesisLatencies.push(Date.now() - audioReceivedTime);
    };
    ServiceTelemetryListener.prototype.onEvent = function(e) {
        if (this.privIsDisposed) return;
        if (e instanceof $7AiNN.RecognitionTriggeredEvent && e.requestId === this.privRequestId) this.privListeningTriggerMetric = {
            End: e.eventTime,
            Name: "ListeningTrigger",
            Start: e.eventTime
        };
        if (e instanceof $em8BD.AudioStreamNodeAttachingEvent && e.audioSourceId === this.privAudioSourceId && e.audioNodeId === this.privAudioNodeId) this.privMicStartTime = e.eventTime;
        if (e instanceof $em8BD.AudioStreamNodeAttachedEvent && e.audioSourceId === this.privAudioSourceId && e.audioNodeId === this.privAudioNodeId) this.privMicStartTime = e.eventTime;
        if (e instanceof $em8BD.AudioSourceErrorEvent && e.audioSourceId === this.privAudioSourceId) {
            if (!this.privMicMetric) this.privMicMetric = {
                End: e.eventTime,
                Error: e.error,
                Name: "Microphone",
                Start: this.privMicStartTime
            };
        }
        if (e instanceof $em8BD.AudioStreamNodeErrorEvent && e.audioSourceId === this.privAudioSourceId && e.audioNodeId === this.privAudioNodeId) {
            if (!this.privMicMetric) this.privMicMetric = {
                End: e.eventTime,
                Error: e.error,
                Name: "Microphone",
                Start: this.privMicStartTime
            };
        }
        if (e instanceof $em8BD.AudioStreamNodeDetachedEvent && e.audioSourceId === this.privAudioSourceId && e.audioNodeId === this.privAudioNodeId) {
            if (!this.privMicMetric) this.privMicMetric = {
                End: e.eventTime,
                Name: "Microphone",
                Start: this.privMicStartTime
            };
        }
        if (e instanceof $7AiNN.ConnectingToServiceEvent && e.requestId === this.privRequestId) this.privConnectionId = e.sessionId;
        if (e instanceof $em8BD.ConnectionStartEvent && e.connectionId === this.privConnectionId) this.privConnectionStartTime = e.eventTime;
        if (e instanceof $em8BD.ConnectionEstablishedEvent && e.connectionId === this.privConnectionId) {
            if (!this.privConnectionEstablishMetric) this.privConnectionEstablishMetric = {
                End: e.eventTime,
                Id: this.privConnectionId,
                Name: "Connection",
                Start: this.privConnectionStartTime
            };
        }
        if (e instanceof $em8BD.ConnectionEstablishErrorEvent && e.connectionId === this.privConnectionId) {
            if (!this.privConnectionEstablishMetric) this.privConnectionEstablishMetric = {
                End: e.eventTime,
                Error: this.getConnectionError(e.statusCode),
                Id: this.privConnectionId,
                Name: "Connection",
                Start: this.privConnectionStartTime
            };
        }
        if (e instanceof $em8BD.ConnectionMessageReceivedEvent && e.connectionId === this.privConnectionId) {
            if (e.message && e.message.headers && e.message.headers.path) {
                if (!this.privReceivedMessages[e.message.headers.path]) this.privReceivedMessages[e.message.headers.path] = new Array();
                var maxMessagesToSend = 50;
                if (this.privReceivedMessages[e.message.headers.path].length < maxMessagesToSend) this.privReceivedMessages[e.message.headers.path].push(e.networkReceivedTime);
            }
        }
    };
    ServiceTelemetryListener.prototype.getTelemetry = function() {
        var metrics = new Array();
        if (this.privListeningTriggerMetric) metrics.push(this.privListeningTriggerMetric);
        if (this.privMicMetric) metrics.push(this.privMicMetric);
        if (this.privConnectionEstablishMetric) metrics.push(this.privConnectionEstablishMetric);
        if (this.privPhraseLatencies.length > 0) metrics.push({
            PhraseLatencyMs: this.privPhraseLatencies
        });
        if (this.privHypothesisLatencies.length > 0) metrics.push({
            FirstHypothesisLatencyMs: this.privHypothesisLatencies
        });
        var telemetry = {
            Metrics: metrics,
            ReceivedMessages: this.privReceivedMessages
        };
        var json = JSON.stringify(telemetry);
        // We dont want to send the same telemetry again. So clean those out.
        this.privReceivedMessages = {};
        this.privListeningTriggerMetric = null;
        this.privMicMetric = null;
        this.privConnectionEstablishMetric = null;
        this.privPhraseLatencies = [];
        this.privHypothesisLatencies = [];
        return json;
    };
    Object.defineProperty(ServiceTelemetryListener.prototype, "hasTelemetry", {
        // Determines if there are any telemetry events to send to the service.
        get: function() {
            return Object.keys(this.privReceivedMessages).length !== 0 || this.privListeningTriggerMetric !== null || this.privMicMetric !== null || this.privConnectionEstablishMetric !== null || this.privPhraseLatencies.length !== 0 || this.privHypothesisLatencies.length !== 0;
        },
        enumerable: false,
        configurable: true
    });
    ServiceTelemetryListener.prototype.dispose = function() {
        this.privIsDisposed = true;
    };
    ServiceTelemetryListener.prototype.getConnectionError = function(statusCode) {
        /*
        -- Websocket status codes --
        NormalClosure = 1000,
        EndpointUnavailable = 1001,
        ProtocolError = 1002,
        InvalidMessageType = 1003,
        Empty = 1005,
        InvalidPayloadData = 1007,
        PolicyViolation = 1008,
        MessageTooBig = 1009,
        MandatoryExtension = 1010,
        InternalServerError = 1011
        */ switch(statusCode){
            case 400:
            case 1002:
            case 1003:
            case 1005:
            case 1007:
            case 1008:
            case 1009:
                return "BadRequest";
            case 401:
                return "Unauthorized";
            case 403:
                return "Forbidden";
            case 503:
            case 1001:
                return "ServerUnavailable";
            case 500:
            case 1011:
                return "ServerError";
            case 408:
            case 504:
                return "Timeout";
            default:
                return "statuscode:" + statusCode.toString();
        }
    };
    return ServiceTelemetryListener;
}();
module.exports.ServiceTelemetryListener = $d0ef876bd678bbf2$var$ServiceTelemetryListener;

});


parcelRequire.register("8hJpO", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SpeechContext = void 0;
/**
 * Represents the JSON used in the speech.context message sent to the speech service.
 * The dynamic grammar is always refreshed from the encapsulated dynamic grammar object.
 */ var $608323ccfd09d624$var$SpeechContext = /** @class */ function() {
    function SpeechContext(dynamicGrammar) {
        this.privContext = {};
        this.privDynamicGrammar = dynamicGrammar;
    }
    /**
     * Gets a section of the speech.context object.
     * @param sectionName Name of the section to get.
     * @return string or Context JSON serializable object that represents the value.
     */ SpeechContext.prototype.getSection = function(sectionName) {
        return this.privContext[sectionName] || {};
    };
    /**
     * Adds a section to the speech.context object.
     * @param sectionName Name of the section to add.
     * @param value JSON serializable object that represents the value.
     */ SpeechContext.prototype.setSection = function(sectionName, value) {
        this.privContext[sectionName] = value;
    };
    /**
     * @Internal
     * This is only used by pronunciation assessment config.
     * Do not use externally, object returned will change without warning or notice.
     */ SpeechContext.prototype.setPronunciationAssessmentParams = function(params) {
        if (this.privContext.phraseDetection === undefined) this.privContext.phraseDetection = {
            enrichment: {
                pronunciationAssessment: {}
            }
        };
        this.privContext.phraseDetection.enrichment.pronunciationAssessment = JSON.parse(params);
        this.setWordLevelTimings();
        this.privContext.phraseOutput.detailed.options.push("PronunciationAssessment");
        if (this.privContext.phraseOutput.detailed.options.indexOf("SNR") === -1) this.privContext.phraseOutput.detailed.options.push("SNR");
    };
    SpeechContext.prototype.setWordLevelTimings = function() {
        if (this.privContext.phraseOutput === undefined) this.privContext.phraseOutput = {
            detailed: {
                options: []
            },
            format: {}
        };
        if (this.privContext.phraseOutput.detailed === undefined) this.privContext.phraseOutput.detailed = {
            options: []
        };
        this.privContext.phraseOutput.format = "Detailed";
        if (this.privContext.phraseOutput.detailed.options.indexOf("WordTimings") === -1) this.privContext.phraseOutput.detailed.options.push("WordTimings");
    };
    SpeechContext.prototype.toJSON = function() {
        var dgi = this.privDynamicGrammar.generateGrammarObject();
        this.setSection("dgi", dgi);
        var ret = JSON.stringify(this.privContext);
        return ret;
    };
    return SpeechContext;
}();
module.exports.SpeechContext = $608323ccfd09d624$var$SpeechContext;

});

parcelRequire.register("kg5wZ", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DynamicGrammarBuilder = void 0;
/**
 * Responsible for building the object to be sent to the speech service to support dynamic grammars.
 * @class DynamicGrammarBuilder
 */ var $ebf9979bd09f9831$var$DynamicGrammarBuilder = /** @class */ function() {
    function DynamicGrammarBuilder() {}
    // Adds one more reference phrases to the dynamic grammar to send.
    // All added phrases are generic phrases.
    DynamicGrammarBuilder.prototype.addPhrase = function(phrase) {
        if (!this.privPhrases) this.privPhrases = [];
        if (phrase instanceof Array) this.privPhrases = this.privPhrases.concat(phrase);
        else this.privPhrases.push(phrase);
    };
    // Clears all phrases stored in the current object.
    DynamicGrammarBuilder.prototype.clearPhrases = function() {
        this.privPhrases = undefined;
    };
    // Adds one or more reference grammars to the current grammar.
    DynamicGrammarBuilder.prototype.addReferenceGrammar = function(grammar) {
        if (!this.privGrammars) this.privGrammars = [];
        if (grammar instanceof Array) this.privGrammars = this.privGrammars.concat(grammar);
        else this.privGrammars.push(grammar);
    };
    // clears all grammars stored on the recognizer.
    DynamicGrammarBuilder.prototype.clearGrammars = function() {
        this.privGrammars = undefined;
    };
    // Generates an object that represents the dynamic grammar used by the Speech Service.
    // This is done by building an object with the correct layout based on the phrases and reference grammars added to this instance
    // of a DynamicGrammarBuilder
    DynamicGrammarBuilder.prototype.generateGrammarObject = function() {
        if (this.privGrammars === undefined && this.privPhrases === undefined) return undefined;
        var retObj = {};
        retObj.ReferenceGrammars = this.privGrammars;
        if (undefined !== this.privPhrases && 0 !== this.privPhrases.length) {
            var retPhrases_1 = [];
            this.privPhrases.forEach(function(value) {
                retPhrases_1.push({
                    Text: value
                });
            });
            retObj.Groups = [
                {
                    Type: "Generic",
                    Items: retPhrases_1
                }
            ];
        }
        return retObj;
    };
    return DynamicGrammarBuilder;
}();
module.exports.DynamicGrammarBuilder = $ebf9979bd09f9831$var$DynamicGrammarBuilder;

});

parcelRequire.register("ge38q", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRequire.register("gKf87", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
var $c30cadbcbc140a6f$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $c30cadbcbc140a6f$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $c30cadbcbc140a6f$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DialogServiceAdapter = void 0;

var $j1V0D = parcelRequire("j1V0D");

var $gLGSp = parcelRequire("gLGSp");

var $em8BD = parcelRequire("em8BD");

var $lxQ5z = parcelRequire("lxQ5z");

var $hM4QX = parcelRequire("hM4QX");

var $d6xGi = parcelRequire("d6xGi");

var $dEkJU = parcelRequire("dEkJU");

var $7K8Ys = parcelRequire("7K8Ys");

var $bhJcv = parcelRequire("bhJcv");
var $c30cadbcbc140a6f$var$DialogServiceAdapter = /** @class */ function(_super) {
    $c30cadbcbc140a6f$var$__extends(DialogServiceAdapter, _super);
    function DialogServiceAdapter(authentication, connectionFactory, audioSource, recognizerConfig, dialogServiceConnector) {
        var _this = _super.call(this, authentication, connectionFactory, audioSource, recognizerConfig, dialogServiceConnector) || this;
        _this.privEvents = new $em8BD.EventSource();
        _this.privDialogServiceConnector = dialogServiceConnector;
        _this.receiveMessageOverride = function() {
            return _this.receiveDialogMessageOverride();
        };
        _this.privTurnStateManager = new $d6xGi.DialogServiceTurnStateManager();
        _this.recognizeOverride = function(recoMode, successCallback, errorCallback) {
            return _this.listenOnce(recoMode, successCallback, errorCallback);
        };
        _this.postConnectImplOverride = function(connection) {
            return _this.dialogConnectImpl(connection);
        };
        _this.configConnectionOverride = function(connection) {
            return _this.configConnection(connection);
        };
        _this.disconnectOverride = function() {
            return _this.privDisconnect();
        };
        _this.privDialogAudioSource = audioSource;
        _this.agentConfigSent = false;
        _this.privLastResult = null;
        _this.connectionEvents.attach(function(connectionEvent) {
            if (connectionEvent.name === "ConnectionClosedEvent") _this.terminateMessageLoop = true;
        });
        return _this;
    }
    DialogServiceAdapter.prototype.sendMessage = function(message) {
        return $c30cadbcbc140a6f$var$__awaiter(this, void 0, void 0, function() {
            var interactionGuid, requestId, agentMessage, agentMessageJson, connection;
            return $c30cadbcbc140a6f$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        interactionGuid = $em8BD.createGuid();
                        requestId = $em8BD.createNoDashGuid();
                        agentMessage = {
                            context: {
                                interactionId: interactionGuid
                            },
                            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
                            messagePayload: JSON.parse(message),
                            version: 0.5
                        };
                        agentMessageJson = JSON.stringify(agentMessage);
                        return [
                            4 /*yield*/ ,
                            this.fetchConnection()
                        ];
                    case 1:
                        connection = _a.sent();
                        return [
                            4 /*yield*/ ,
                            connection.send(new $bhJcv.SpeechConnectionMessage($em8BD.MessageType.Text, "agent", requestId, "application/json", agentMessageJson))
                        ];
                    case 2:
                        _a.sent();
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    DialogServiceAdapter.prototype.privDisconnect = function() {
        return $c30cadbcbc140a6f$var$__awaiter(this, void 0, void 0, function() {
            return $c30cadbcbc140a6f$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.cancelRecognition(this.privRequestSession.sessionId, this.privRequestSession.requestId, $hM4QX.CancellationReason.Error, $hM4QX.CancellationErrorCode.NoError, "Disconnecting")
                        ];
                    case 1:
                        _a.sent();
                        this.terminateMessageLoop = true;
                        this.agentConfigSent = false;
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    DialogServiceAdapter.prototype.processTypeSpecificMessages = function(connectionMessage) {
        var resultProps = new $hM4QX.PropertyCollection();
        if (connectionMessage.messageType === $em8BD.MessageType.Text) resultProps.setProperty($hM4QX.PropertyId.SpeechServiceResponse_JsonResult, connectionMessage.textBody);
        var result;
        var processed;
        switch(connectionMessage.path.toLowerCase()){
            case "speech.phrase":
                var speechPhrase = $dEkJU.SimpleSpeechPhrase.fromJSON(connectionMessage.textBody);
                this.privRequestSession.onPhraseRecognized(this.privRequestSession.currentTurnAudioOffset + speechPhrase.Offset + speechPhrase.Duration);
                if (speechPhrase.RecognitionStatus !== $dEkJU.RecognitionStatus.TooManyRequests && speechPhrase.RecognitionStatus !== $dEkJU.RecognitionStatus.Error) {
                    var args = this.fireEventForResult(speechPhrase, resultProps);
                    this.privLastResult = args.result;
                    if (!!this.privDialogServiceConnector.recognized) try {
                        this.privDialogServiceConnector.recognized(this.privDialogServiceConnector, args);
                    /* eslint-disable no-empty */ } catch (error) {
                    // Not going to let errors in the event handler
                    // trip things up.
                    }
                }
                processed = true;
                break;
            case "speech.hypothesis":
                var hypothesis = $dEkJU.SpeechHypothesis.fromJSON(connectionMessage.textBody);
                var offset = hypothesis.Offset + this.privRequestSession.currentTurnAudioOffset;
                result = new $hM4QX.SpeechRecognitionResult(this.privRequestSession.requestId, $hM4QX.ResultReason.RecognizingSpeech, hypothesis.Text, hypothesis.Duration, offset, hypothesis.Language, hypothesis.LanguageDetectionConfidence, undefined, undefined, connectionMessage.textBody, resultProps);
                this.privRequestSession.onHypothesis(offset);
                var ev = new $hM4QX.SpeechRecognitionEventArgs(result, hypothesis.Duration, this.privRequestSession.sessionId);
                if (!!this.privDialogServiceConnector.recognizing) try {
                    this.privDialogServiceConnector.recognizing(this.privDialogServiceConnector, ev);
                /* eslint-disable no-empty */ } catch (error) {
                // Not going to let errors in the event handler
                // trip things up.
                }
                processed = true;
                break;
            case "speech.keyword":
                var keyword = $dEkJU.SpeechKeyword.fromJSON(connectionMessage.textBody);
                result = new $hM4QX.SpeechRecognitionResult(this.privRequestSession.requestId, keyword.Status === "Accepted" ? $hM4QX.ResultReason.RecognizedKeyword : $hM4QX.ResultReason.NoMatch, keyword.Text, keyword.Duration, keyword.Offset, undefined, undefined, undefined, undefined, connectionMessage.textBody, resultProps);
                if (keyword.Status !== "Accepted") this.privLastResult = result;
                var event_1 = new $hM4QX.SpeechRecognitionEventArgs(result, result.duration, result.resultId);
                if (!!this.privDialogServiceConnector.recognized) try {
                    this.privDialogServiceConnector.recognized(this.privDialogServiceConnector, event_1);
                /* eslint-disable no-empty */ } catch (error) {
                // Not going to let errors in the event handler
                // trip things up.
                }
                processed = true;
                break;
            case "audio":
                var audioRequestId = connectionMessage.requestId.toUpperCase();
                var turn = this.privTurnStateManager.GetTurn(audioRequestId);
                try {
                    // Empty binary message signals end of stream.
                    if (!connectionMessage.binaryBody) turn.endAudioStream();
                    else turn.audioStream.write(connectionMessage.binaryBody);
                } catch (error) {
                // Not going to let errors in the event handler
                // trip things up.
                }
                processed = true;
                break;
            case "response":
                this.handleResponseMessage(connectionMessage);
                processed = true;
                break;
            default:
                break;
        }
        var defferal = new $em8BD.Deferred();
        defferal.resolve(processed);
        return defferal.promise;
    };
    // Cancels recognition.
    DialogServiceAdapter.prototype.cancelRecognition = function(sessionId, requestId, cancellationReason, errorCode, error) {
        return $c30cadbcbc140a6f$var$__awaiter(this, void 0, void 0, function() {
            var properties, cancelEvent, result;
            return $c30cadbcbc140a6f$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        this.terminateMessageLoop = true;
                        if (!!!this.privRequestSession.isRecognizing) return [
                            3 /*break*/ ,
                            2
                        ];
                        return [
                            4 /*yield*/ ,
                            this.privRequestSession.onStopRecognizing()
                        ];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        if (!!this.privDialogServiceConnector.canceled) {
                            properties = new $hM4QX.PropertyCollection();
                            properties.setProperty($dEkJU.CancellationErrorCodePropertyName, $hM4QX.CancellationErrorCode[errorCode]);
                            cancelEvent = new $hM4QX.SpeechRecognitionCanceledEventArgs(cancellationReason, error, errorCode, undefined, sessionId);
                            try {
                                this.privDialogServiceConnector.canceled(this.privDialogServiceConnector, cancelEvent);
                            /* eslint-disable no-empty */ } catch (_b) {}
                            if (!!this.privSuccessCallback) {
                                result = new $hM4QX.SpeechRecognitionResult(undefined, $hM4QX.ResultReason.Canceled, undefined, undefined, undefined, undefined, undefined, undefined, error, undefined, properties);
                                try {
                                    this.privSuccessCallback(result);
                                    this.privSuccessCallback = undefined;
                                /* eslint-disable no-empty */ } catch (_c) {}
                            }
                        }
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    DialogServiceAdapter.prototype.listenOnce = function(recoMode, successCallback, errorCallback) {
        return $c30cadbcbc140a6f$var$__awaiter(this, void 0, void 0, function() {
            var conPromise, preAudioPromise, node, format, deviceInfo, audioNode, error_1, sessionStartEventArgs, audioSendPromise;
            var _this = this;
            return $c30cadbcbc140a6f$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        this.privRecognizerConfig.recognitionMode = recoMode;
                        this.privSuccessCallback = successCallback;
                        this.privErrorCallback = errorCallback;
                        this.privRequestSession.startNewRecognition();
                        this.privRequestSession.listenForServiceTelemetry(this.privDialogAudioSource.events);
                        this.privRecognizerConfig.parameters.setProperty($hM4QX.PropertyId.Speech_SessionId, this.privRequestSession.sessionId);
                        conPromise = this.connectImpl();
                        preAudioPromise = this.sendPreAudioMessages();
                        return [
                            4 /*yield*/ ,
                            this.privDialogAudioSource.attach(this.privRequestSession.audioNodeId)
                        ];
                    case 1:
                        node = _a.sent();
                        return [
                            4 /*yield*/ ,
                            this.privDialogAudioSource.format
                        ];
                    case 2:
                        format = _a.sent();
                        return [
                            4 /*yield*/ ,
                            this.privDialogAudioSource.deviceInfo
                        ];
                    case 3:
                        deviceInfo = _a.sent();
                        audioNode = new $j1V0D.ReplayableAudioNode(node, format.avgBytesPerSec);
                        return [
                            4 /*yield*/ ,
                            this.privRequestSession.onAudioSourceAttachCompleted(audioNode, false)
                        ];
                    case 4:
                        _a.sent();
                        this.privRecognizerConfig.SpeechServiceConfig.Context.audio = {
                            source: deviceInfo
                        };
                        _a.label = 5;
                    case 5:
                        _a.trys.push([
                            5,
                            8,
                            ,
                            10
                        ]);
                        return [
                            4 /*yield*/ ,
                            conPromise
                        ];
                    case 6:
                        _a.sent();
                        return [
                            4 /*yield*/ ,
                            preAudioPromise
                        ];
                    case 7:
                        _a.sent();
                        return [
                            3 /*break*/ ,
                            10
                        ];
                    case 8:
                        error_1 = _a.sent();
                        return [
                            4 /*yield*/ ,
                            this.cancelRecognition(this.privRequestSession.sessionId, this.privRequestSession.requestId, $hM4QX.CancellationReason.Error, $hM4QX.CancellationErrorCode.ConnectionFailure, error_1)
                        ];
                    case 9:
                        _a.sent();
                        return [
                            2 /*return*/ ,
                            Promise.resolve()
                        ];
                    case 10:
                        sessionStartEventArgs = new $hM4QX.SessionEventArgs(this.privRequestSession.sessionId);
                        if (!!this.privRecognizer.sessionStarted) this.privRecognizer.sessionStarted(this.privRecognizer, sessionStartEventArgs);
                        audioSendPromise = this.sendAudio(audioNode);
                        // /* eslint-disable no-empty */
                        audioSendPromise.then(function() {}, function(error) {
                            return $c30cadbcbc140a6f$var$__awaiter(_this, void 0, void 0, function() {
                                return $c30cadbcbc140a6f$var$__generator(this, function(_a) {
                                    switch(_a.label){
                                        case 0:
                                            return [
                                                4 /*yield*/ ,
                                                this.cancelRecognition(this.privRequestSession.sessionId, this.privRequestSession.requestId, $hM4QX.CancellationReason.Error, $hM4QX.CancellationErrorCode.RuntimeError, error)
                                            ];
                                        case 1:
                                            _a.sent();
                                            return [
                                                2 /*return*/ 
                                            ];
                                    }
                                });
                            });
                        });
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    // Establishes a websocket connection to the end point.
    DialogServiceAdapter.prototype.dialogConnectImpl = function(connection) {
        this.privConnectionLoop = this.startMessageLoop();
        return connection;
    };
    DialogServiceAdapter.prototype.receiveDialogMessageOverride = function() {
        var _this = this;
        // we won't rely on the cascading promises of the connection since we want to continually be available to receive messages
        var communicationCustodian = new $em8BD.Deferred();
        var loop = function() {
            return $c30cadbcbc140a6f$var$__awaiter(_this, void 0, void 0, function() {
                var isDisposed, terminateMessageLoop, connection, message, connectionMessage, _a, turnRequestId, audioSessionReqId, speechStartDetected, speechStartEventArgs, json, speechStopDetected, speechStopEventArgs, turnEndRequestId, audioSessionReqId, sessionStopEventArgs, processed, e_1, ret, error_2;
                return $c30cadbcbc140a6f$var$__generator(this, function(_b) {
                    switch(_b.label){
                        case 0:
                            _b.trys.push([
                                0,
                                14,
                                ,
                                15
                            ]);
                            isDisposed = this.isDisposed();
                            terminateMessageLoop = !this.isDisposed() && this.terminateMessageLoop;
                            if (isDisposed || terminateMessageLoop) {
                                // We're done.
                                communicationCustodian.resolve(undefined);
                                return [
                                    2 /*return*/ 
                                ];
                            }
                            return [
                                4 /*yield*/ ,
                                this.fetchConnection()
                            ];
                        case 1:
                            connection = _b.sent();
                            return [
                                4 /*yield*/ ,
                                connection.read()
                            ];
                        case 2:
                            message = _b.sent();
                            if (!message) return [
                                2 /*return*/ ,
                                loop()
                            ];
                            connectionMessage = $bhJcv.SpeechConnectionMessage.fromConnectionMessage(message);
                            _a = connectionMessage.path.toLowerCase();
                            switch(_a){
                                case "turn.start":
                                    return [
                                        3 /*break*/ ,
                                        3
                                    ];
                                case "speech.startdetected":
                                    return [
                                        3 /*break*/ ,
                                        4
                                    ];
                                case "speech.enddetected":
                                    return [
                                        3 /*break*/ ,
                                        5
                                    ];
                                case "turn.end":
                                    return [
                                        3 /*break*/ ,
                                        6
                                    ];
                            }
                            return [
                                3 /*break*/ ,
                                10
                            ];
                        case 3:
                            turnRequestId = connectionMessage.requestId.toUpperCase();
                            audioSessionReqId = this.privRequestSession.requestId.toUpperCase();
                            // turn started by the service
                            if (turnRequestId !== audioSessionReqId) this.privTurnStateManager.StartTurn(turnRequestId);
                            else this.privRequestSession.onServiceTurnStartResponse();
                            return [
                                3 /*break*/ ,
                                13
                            ];
                        case 4:
                            speechStartDetected = $dEkJU.SpeechDetected.fromJSON(connectionMessage.textBody);
                            speechStartEventArgs = new $hM4QX.RecognitionEventArgs(speechStartDetected.Offset, this.privRequestSession.sessionId);
                            if (!!this.privRecognizer.speechStartDetected) this.privRecognizer.speechStartDetected(this.privRecognizer, speechStartEventArgs);
                            return [
                                3 /*break*/ ,
                                13
                            ];
                        case 5:
                            json = void 0;
                            if (connectionMessage.textBody.length > 0) json = connectionMessage.textBody;
                            else // If the request was empty, the JSON returned is empty.
                            json = "{ Offset: 0 }";
                            speechStopDetected = $dEkJU.SpeechDetected.fromJSON(json);
                            this.privRequestSession.onServiceRecognized(speechStopDetected.Offset + this.privRequestSession.currentTurnAudioOffset);
                            speechStopEventArgs = new $hM4QX.RecognitionEventArgs(speechStopDetected.Offset + this.privRequestSession.currentTurnAudioOffset, this.privRequestSession.sessionId);
                            if (!!this.privRecognizer.speechEndDetected) this.privRecognizer.speechEndDetected(this.privRecognizer, speechStopEventArgs);
                            return [
                                3 /*break*/ ,
                                13
                            ];
                        case 6:
                            turnEndRequestId = connectionMessage.requestId.toUpperCase();
                            audioSessionReqId = this.privRequestSession.requestId.toUpperCase();
                            if (!(turnEndRequestId !== audioSessionReqId)) return [
                                3 /*break*/ ,
                                7
                            ];
                            this.privTurnStateManager.CompleteTurn(turnEndRequestId);
                            return [
                                3 /*break*/ ,
                                9
                            ];
                        case 7:
                            sessionStopEventArgs = new $hM4QX.SessionEventArgs(this.privRequestSession.sessionId);
                            return [
                                4 /*yield*/ ,
                                this.privRequestSession.onServiceTurnEndResponse(false)
                            ];
                        case 8:
                            _b.sent();
                            if (!this.privRecognizerConfig.isContinuousRecognition || this.privRequestSession.isSpeechEnded || !this.privRequestSession.isRecognizing) {
                                if (!!this.privRecognizer.sessionStopped) this.privRecognizer.sessionStopped(this.privRecognizer, sessionStopEventArgs);
                            }
                            // report result to promise.
                            if (!!this.privSuccessCallback && this.privLastResult) {
                                try {
                                    this.privSuccessCallback(this.privLastResult);
                                    this.privLastResult = null;
                                } catch (e) {
                                    if (!!this.privErrorCallback) this.privErrorCallback(e);
                                }
                                // Only invoke the call back once.
                                // and if it's successful don't invoke the
                                // error after that.
                                this.privSuccessCallback = undefined;
                                this.privErrorCallback = undefined;
                            }
                            _b.label = 9;
                        case 9:
                            return [
                                3 /*break*/ ,
                                13
                            ];
                        case 10:
                            _b.trys.push([
                                10,
                                12,
                                ,
                                13
                            ]);
                            return [
                                4 /*yield*/ ,
                                this.processTypeSpecificMessages(connectionMessage)
                            ];
                        case 11:
                            processed = _b.sent();
                            if (!processed) {
                                if (!!this.serviceEvents) this.serviceEvents.onEvent(new $em8BD.ServiceEvent(connectionMessage.path.toLowerCase(), connectionMessage.textBody));
                            }
                            return [
                                3 /*break*/ ,
                                13
                            ];
                        case 12:
                            e_1 = _b.sent();
                            return [
                                3 /*break*/ ,
                                13
                            ];
                        case 13:
                            ret = loop();
                            return [
                                2 /*return*/ ,
                                ret
                            ];
                        case 14:
                            error_2 = _b.sent();
                            this.terminateMessageLoop = true;
                            communicationCustodian.resolve();
                            return [
                                3 /*break*/ ,
                                15
                            ];
                        case 15:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        loop().catch(function(reason) {
            $em8BD.Events.instance.onEvent(new $em8BD.BackgroundEvent(reason));
        });
        return communicationCustodian.promise;
    };
    DialogServiceAdapter.prototype.startMessageLoop = function() {
        return $c30cadbcbc140a6f$var$__awaiter(this, void 0, void 0, function() {
            var error_3;
            return $c30cadbcbc140a6f$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        this.terminateMessageLoop = false;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([
                            1,
                            3,
                            ,
                            5
                        ]);
                        return [
                            4 /*yield*/ ,
                            this.receiveDialogMessageOverride()
                        ];
                    case 2:
                        _a.sent();
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 3:
                        error_3 = _a.sent();
                        return [
                            4 /*yield*/ ,
                            this.cancelRecognition(this.privRequestSession.sessionId, this.privRequestSession.requestId, $hM4QX.CancellationReason.Error, $hM4QX.CancellationErrorCode.RuntimeError, error_3)
                        ];
                    case 4:
                        _a.sent();
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 5:
                        return [
                            2 /*return*/ ,
                            Promise.resolve()
                        ];
                }
            });
        });
    };
    // Takes an established websocket connection to the endpoint and sends speech configuration information.
    DialogServiceAdapter.prototype.configConnection = function(connection) {
        return $c30cadbcbc140a6f$var$__awaiter(this, void 0, void 0, function() {
            return $c30cadbcbc140a6f$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (this.terminateMessageLoop) {
                            this.terminateMessageLoop = false;
                            return [
                                2 /*return*/ ,
                                Promise.reject("Connection to service terminated.")
                            ];
                        }
                        return [
                            4 /*yield*/ ,
                            this.sendSpeechServiceConfig(connection, this.privRequestSession, this.privRecognizerConfig.SpeechServiceConfig.serialize())
                        ];
                    case 1:
                        _a.sent();
                        return [
                            4 /*yield*/ ,
                            this.sendAgentConfig(connection)
                        ];
                    case 2:
                        _a.sent();
                        return [
                            2 /*return*/ ,
                            connection
                        ];
                }
            });
        });
    };
    DialogServiceAdapter.prototype.sendPreAudioMessages = function() {
        return $c30cadbcbc140a6f$var$__awaiter(this, void 0, void 0, function() {
            var connection;
            return $c30cadbcbc140a6f$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.fetchConnection()
                        ];
                    case 1:
                        connection = _a.sent();
                        this.addKeywordContextData();
                        return [
                            4 /*yield*/ ,
                            this.sendSpeechContext(connection, true)
                        ];
                    case 2:
                        _a.sent();
                        return [
                            4 /*yield*/ ,
                            this.sendAgentContext(connection)
                        ];
                    case 3:
                        _a.sent();
                        return [
                            4 /*yield*/ ,
                            this.sendWaveHeader(connection)
                        ];
                    case 4:
                        _a.sent();
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    DialogServiceAdapter.prototype.sendAgentConfig = function(connection) {
        if (this.agentConfig && !this.agentConfigSent) {
            if (this.privRecognizerConfig.parameters.getProperty($hM4QX.PropertyId.Conversation_DialogType) === $hM4QX.DialogServiceConfig.DialogTypes.CustomCommands) {
                var config = this.agentConfig.get();
                config.botInfo.commandsCulture = this.privRecognizerConfig.parameters.getProperty($hM4QX.PropertyId.SpeechServiceConnection_RecoLanguage, "en-us");
                this.agentConfig.set(config);
            }
            this.onEvent(new $gLGSp.SendingAgentContextMessageEvent(this.agentConfig));
            var agentConfigJson = this.agentConfig.toJsonString();
            // guard against sending this multiple times on one connection
            this.agentConfigSent = true;
            return connection.send(new $bhJcv.SpeechConnectionMessage($em8BD.MessageType.Text, "agent.config", this.privRequestSession.requestId, "application/json", agentConfigJson));
        }
        return;
    };
    DialogServiceAdapter.prototype.sendAgentContext = function(connection) {
        var guid = $em8BD.createGuid();
        var speechActivityTemplate = this.privDialogServiceConnector.properties.getProperty($hM4QX.PropertyId.Conversation_Speech_Activity_Template);
        var agentContext = {
            channelData: "",
            context: {
                interactionId: guid
            },
            messagePayload: speechActivityTemplate,
            version: 0.5
        };
        var agentContextJson = JSON.stringify(agentContext);
        return connection.send(new $bhJcv.SpeechConnectionMessage($em8BD.MessageType.Text, "speech.agent.context", this.privRequestSession.requestId, "application/json", agentContextJson));
    };
    DialogServiceAdapter.prototype.fireEventForResult = function(serviceResult, properties) {
        var resultReason = $dEkJU.EnumTranslation.implTranslateRecognitionResult(serviceResult.RecognitionStatus);
        var offset = serviceResult.Offset + this.privRequestSession.currentTurnAudioOffset;
        var result = new $hM4QX.SpeechRecognitionResult(this.privRequestSession.requestId, resultReason, serviceResult.DisplayText, serviceResult.Duration, offset, serviceResult.Language, serviceResult.LanguageDetectionConfidence, undefined, undefined, JSON.stringify(serviceResult), properties);
        var ev = new $hM4QX.SpeechRecognitionEventArgs(result, offset, this.privRequestSession.sessionId);
        return ev;
    };
    DialogServiceAdapter.prototype.handleResponseMessage = function(responseMessage) {
        // "response" messages can contain either "message" (activity) or "MessageStatus" data. Fire the appropriate
        // event according to the message type that's specified.
        var responsePayload = JSON.parse(responseMessage.textBody);
        switch(responsePayload.messageType.toLowerCase()){
            case "message":
                var responseRequestId = responseMessage.requestId.toUpperCase();
                var activityPayload = $7K8Ys.ActivityPayloadResponse.fromJSON(responseMessage.textBody);
                var turn = this.privTurnStateManager.GetTurn(responseRequestId);
                // update the conversation Id
                if (activityPayload.conversationId) {
                    var updateAgentConfig = this.agentConfig.get();
                    updateAgentConfig.botInfo.conversationId = activityPayload.conversationId;
                    this.agentConfig.set(updateAgentConfig);
                }
                var pullAudioOutputStream = turn.processActivityPayload(activityPayload, $lxQ5z.AudioOutputFormatImpl.fromSpeechSynthesisOutputFormatString(this.privDialogServiceConnector.properties.getProperty($hM4QX.PropertyId.SpeechServiceConnection_SynthOutputFormat, undefined)));
                var activity = new $hM4QX.ActivityReceivedEventArgs(activityPayload.messagePayload, pullAudioOutputStream);
                if (!!this.privDialogServiceConnector.activityReceived) try {
                    this.privDialogServiceConnector.activityReceived(this.privDialogServiceConnector, activity);
                /* eslint-disable-next-line no-empty */ } catch (error) {
                // Not going to let errors in the event handler
                // trip things up.
                }
                break;
            case "messagestatus":
                if (!!this.privDialogServiceConnector.turnStatusReceived) try {
                    this.privDialogServiceConnector.turnStatusReceived(this.privDialogServiceConnector, new $hM4QX.TurnStatusReceivedEventArgs(responseMessage.textBody));
                /* eslint-disable-next-line no-empty */ } catch (error) {
                // Not going to let errors in the event handler
                // trip things up.
                }
                break;
            default:
                $em8BD.Events.instance.onEvent(new $em8BD.BackgroundEvent("Unexpected response of type " + responsePayload.messageType + ". Ignoring."));
                break;
        }
    };
    DialogServiceAdapter.prototype.onEvent = function(event) {
        this.privEvents.onEvent(event);
        $em8BD.Events.instance.onEvent(event);
    };
    DialogServiceAdapter.prototype.addKeywordContextData = function() {
        var keywordPropertyValue = this.privRecognizerConfig.parameters.getProperty("SPEECH-KeywordsToDetect");
        if (keywordPropertyValue === undefined) return;
        var keywordOffsetPropertyValue = this.privRecognizerConfig.parameters.getProperty("SPEECH-KeywordsToDetect-Offsets");
        var keywordDurationPropertyValue = this.privRecognizerConfig.parameters.getProperty("SPEECH-KeywordsToDetect-Durations");
        var keywords = keywordPropertyValue.split(";");
        var keywordOffsets = keywordOffsetPropertyValue === undefined ? [] : keywordOffsetPropertyValue.split(";");
        var keywordDurations = keywordDurationPropertyValue === undefined ? [] : keywordDurationPropertyValue.split(";");
        var keywordDefinitionArray = [];
        for(var i = 0; i < keywords.length; i++){
            var definition = {};
            definition.text = keywords[i];
            if (i < keywordOffsets.length) definition.offset = Number(keywordOffsets[i]);
            if (i < keywordDurations.length) definition.duration = Number(keywordDurations[i]);
            keywordDefinitionArray.push(definition);
        }
        this.speechContext.setSection("invocationSource", "VoiceActivationWithKeyword");
        this.speechContext.setSection("keywordDetection", [
            {
                clientDetectedKeywords: keywordDefinitionArray,
                onReject: {
                    action: "EndOfTurn"
                },
                type: "startTrigger"
            }
        ]);
    };
    return DialogServiceAdapter;
}($dEkJU.ServiceRecognizerBase);
module.exports.DialogServiceAdapter = $c30cadbcbc140a6f$var$DialogServiceAdapter;

});
parcelRequire.register("d6xGi", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DialogServiceTurnStateManager = void 0;

var $3XP4p = parcelRequire("3XP4p");

var $cIBsu = parcelRequire("cIBsu");
var $98a5f64597394e22$var$DialogServiceTurnStateManager = /** @class */ function() {
    function DialogServiceTurnStateManager() {
        this.privTurnMap = new Map();
        return;
    }
    DialogServiceTurnStateManager.prototype.StartTurn = function(id) {
        if (this.privTurnMap.has(id)) throw new $3XP4p.InvalidOperationError("Service error: There is already a turn with id:" + id);
        var turnState = new $cIBsu.DialogServiceTurnState(this, id);
        this.privTurnMap.set(id, turnState);
        return this.privTurnMap.get(id);
    };
    DialogServiceTurnStateManager.prototype.GetTurn = function(id) {
        return this.privTurnMap.get(id);
    };
    DialogServiceTurnStateManager.prototype.CompleteTurn = function(id) {
        if (!this.privTurnMap.has(id)) throw new $3XP4p.InvalidOperationError("Service error: Received turn end for an unknown turn id:" + id);
        var turnState = this.privTurnMap.get(id);
        turnState.complete();
        this.privTurnMap.delete(id);
        return turnState;
    };
    return DialogServiceTurnStateManager;
}();
module.exports.DialogServiceTurnStateManager = $98a5f64597394e22$var$DialogServiceTurnStateManager;

});
parcelRequire.register("cIBsu", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DialogServiceTurnState = void 0;

var $lxQ5z = parcelRequire("lxQ5z");

var $aBCur = parcelRequire("aBCur");

var $7K8Ys = parcelRequire("7K8Ys");
var $9426a6980d05fcd0$var$DialogServiceTurnState = /** @class */ function() {
    function DialogServiceTurnState(manager, requestId) {
        this.privRequestId = requestId;
        this.privIsCompleted = false;
        this.privAudioStream = null;
        this.privTurnManager = manager;
        this.resetTurnEndTimeout();
    }
    Object.defineProperty(DialogServiceTurnState.prototype, "audioStream", {
        get: function() {
            // Called when is needed to stream.
            this.resetTurnEndTimeout();
            return this.privAudioStream;
        },
        enumerable: false,
        configurable: true
    });
    DialogServiceTurnState.prototype.processActivityPayload = function(payload, audioFormat) {
        if (payload.messageDataStreamType === $7K8Ys.MessageDataStreamType.TextToSpeechAudio) {
            this.privAudioStream = $aBCur.AudioOutputStream.createPullStream();
            this.privAudioStream.format = audioFormat !== undefined ? audioFormat : $lxQ5z.AudioOutputFormatImpl.getDefaultOutputFormat();
        }
        return this.privAudioStream;
    };
    DialogServiceTurnState.prototype.endAudioStream = function() {
        if (this.privAudioStream !== null && !this.privAudioStream.isClosed) this.privAudioStream.close();
    };
    DialogServiceTurnState.prototype.complete = function() {
        if (this.privTimeoutToken !== undefined) // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
        clearTimeout(this.privTimeoutToken);
        this.endAudioStream();
    };
    DialogServiceTurnState.prototype.resetTurnEndTimeout = function() {
        var _this = this;
        if (this.privTimeoutToken !== undefined) // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
        clearTimeout(this.privTimeoutToken);
        this.privTimeoutToken = setTimeout(function() {
            _this.privTurnManager.CompleteTurn(_this.privRequestId);
            return;
        }, 2000);
    };
    return DialogServiceTurnState;
}();
module.exports.DialogServiceTurnState = $9426a6980d05fcd0$var$DialogServiceTurnState;

});
parcelRequire.register("7K8Ys", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
// response
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MessageDataStreamType = module.exports.ActivityPayloadResponse = void 0;
var $5a33ca6108f12dd5$var$ActivityPayloadResponse = /** @class */ function() {
    function ActivityPayloadResponse(json) {
        this.privActivityResponse = JSON.parse(json);
    }
    ActivityPayloadResponse.fromJSON = function(json) {
        return new ActivityPayloadResponse(json);
    };
    Object.defineProperty(ActivityPayloadResponse.prototype, "conversationId", {
        get: function() {
            return this.privActivityResponse.conversationId;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ActivityPayloadResponse.prototype, "messageDataStreamType", {
        get: function() {
            return this.privActivityResponse.messageDataStreamType;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ActivityPayloadResponse.prototype, "messagePayload", {
        get: function() {
            return this.privActivityResponse.messagePayload;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ActivityPayloadResponse.prototype, "version", {
        get: function() {
            return this.privActivityResponse.version;
        },
        enumerable: false,
        configurable: true
    });
    return ActivityPayloadResponse;
}();
module.exports.ActivityPayloadResponse = $5a33ca6108f12dd5$var$ActivityPayloadResponse;
var $5a33ca6108f12dd5$var$MessageDataStreamType;
(function(MessageDataStreamType) {
    MessageDataStreamType[MessageDataStreamType["None"] = 0] = "None";
    MessageDataStreamType[MessageDataStreamType["TextToSpeechAudio"] = 1] = "TextToSpeechAudio";
})($5a33ca6108f12dd5$var$MessageDataStreamType = module.exports.MessageDataStreamType || (module.exports.MessageDataStreamType = {}));

});




parcelRequire.register("7HXJA", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.AgentConfig = void 0;
/**
 * Represents the JSON used in the agent.config message sent to the speech service.
 */ var $59cae283e5836f03$var$AgentConfig = /** @class */ function() {
    function AgentConfig() {}
    AgentConfig.prototype.toJsonString = function() {
        return JSON.stringify(this.iPrivConfig);
    };
    AgentConfig.prototype.get = function() {
        return this.iPrivConfig;
    };
    /**
     * Setter for the agent.config object.
     * @param value a JSON serializable object.
     */ AgentConfig.prototype.set = function(value) {
        this.iPrivConfig = value;
    };
    return AgentConfig;
}();
module.exports.AgentConfig = $59cae283e5836f03$var$AgentConfig;

});

parcelRequire.register("if2Mn", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $69H8j = parcelRequire("69H8j");
Object.defineProperty(module.exports, "ConversationManager", {
    enumerable: true,
    get: function() {
        return $69H8j.ConversationManager;
    }
});

var $9v4Of = parcelRequire("9v4Of");
Object.defineProperty(module.exports, "ConversationConnectionConfig", {
    enumerable: true,
    get: function() {
        return $9v4Of.ConversationConnectionConfig;
    }
});

var $gq7j5 = parcelRequire("gq7j5");
Object.defineProperty(module.exports, "ConversationRecognizerFactory", {
    enumerable: true,
    get: function() {
        return $gq7j5.ConversationRecognizerFactory;
    }
});

var $DiRch = parcelRequire("DiRch");
Object.defineProperty(module.exports, "TranscriberRecognizer", {
    enumerable: true,
    get: function() {
        return $DiRch.TranscriberRecognizer;
    }
});

var $35r7p = parcelRequire("35r7p");
Object.defineProperty(module.exports, "ConversationReceivedTranslationEventArgs", {
    enumerable: true,
    get: function() {
        return $35r7p.ConversationReceivedTranslationEventArgs;
    }
});
Object.defineProperty(module.exports, "LockRoomEventArgs", {
    enumerable: true,
    get: function() {
        return $35r7p.LockRoomEventArgs;
    }
});
Object.defineProperty(module.exports, "MuteAllEventArgs", {
    enumerable: true,
    get: function() {
        return $35r7p.MuteAllEventArgs;
    }
});
Object.defineProperty(module.exports, "ParticipantAttributeEventArgs", {
    enumerable: true,
    get: function() {
        return $35r7p.ParticipantAttributeEventArgs;
    }
});
Object.defineProperty(module.exports, "ParticipantEventArgs", {
    enumerable: true,
    get: function() {
        return $35r7p.ParticipantEventArgs;
    }
});
Object.defineProperty(module.exports, "ParticipantsListEventArgs", {
    enumerable: true,
    get: function() {
        return $35r7p.ParticipantsListEventArgs;
    }
});

var $kWIMy = parcelRequire("kWIMy");
Object.defineProperty(module.exports, "ConversationTranslatorCommandTypes", {
    enumerable: true,
    get: function() {
        return $kWIMy.ConversationTranslatorCommandTypes;
    }
});
Object.defineProperty(module.exports, "ConversationTranslatorMessageTypes", {
    enumerable: true,
    get: function() {
        return $kWIMy.ConversationTranslatorMessageTypes;
    }
});
Object.defineProperty(module.exports, "InternalParticipants", {
    enumerable: true,
    get: function() {
        return $kWIMy.InternalParticipants;
    }
});

});
parcelRequire.register("69H8j", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ConversationManager = void 0;

var $j1V0D = parcelRequire("j1V0D");

var $gBGZx = parcelRequire("gBGZx");

var $hM4QX = parcelRequire("hM4QX");

var $9v4Of = parcelRequire("9v4Of");
var $47b50aa6b9cf022f$var$ConversationManager = /** @class */ function() {
    function ConversationManager() {
        //
        this.privRequestParams = $9v4Of.ConversationConnectionConfig.configParams;
        this.privErrors = $9v4Of.ConversationConnectionConfig.restErrors;
        this.privHost = $9v4Of.ConversationConnectionConfig.host;
        this.privApiVersion = $9v4Of.ConversationConnectionConfig.apiVersion;
        this.privRestPath = $9v4Of.ConversationConnectionConfig.restPath;
        this.privRestAdapter = new $j1V0D.RestMessageAdapter({});
    }
    /**
     * Make a POST request to the Conversation Manager service endpoint to create or join a conversation.
     * @param args
     * @param conversationCode
     * @param callback
     * @param errorCallback
     */ ConversationManager.prototype.createOrJoin = function(args, conversationCode, cb, err) {
        var _this = this;
        try {
            $gBGZx.Contracts.throwIfNullOrUndefined(args, "args");
            var languageCode = args.getProperty($hM4QX.PropertyId.SpeechServiceConnection_RecoLanguage, $9v4Of.ConversationConnectionConfig.defaultLanguageCode);
            var nickname = args.getProperty($hM4QX.PropertyId.ConversationTranslator_Name, "conversation_host");
            var endpointHost = args.getProperty($hM4QX.PropertyId.ConversationTranslator_Host, this.privHost);
            var correlationId = args.getProperty($hM4QX.PropertyId.ConversationTranslator_CorrelationId);
            var subscriptionKey = args.getProperty($hM4QX.PropertyId.SpeechServiceConnection_Key);
            var subscriptionRegion = args.getProperty($hM4QX.PropertyId.SpeechServiceConnection_Region);
            var authToken = args.getProperty($hM4QX.PropertyId.SpeechServiceAuthorization_Token);
            $gBGZx.Contracts.throwIfNullOrWhitespace(languageCode, "languageCode");
            $gBGZx.Contracts.throwIfNullOrWhitespace(nickname, "nickname");
            $gBGZx.Contracts.throwIfNullOrWhitespace(endpointHost, "endpointHost");
            var queryParams = {};
            queryParams[this.privRequestParams.apiVersion] = this.privApiVersion;
            queryParams[this.privRequestParams.languageCode] = languageCode;
            queryParams[this.privRequestParams.nickname] = nickname;
            var headers = {};
            if (correlationId) headers[this.privRequestParams.correlationId] = correlationId;
            headers[this.privRequestParams.clientAppId] = $9v4Of.ConversationConnectionConfig.clientAppId;
            if (conversationCode !== undefined) queryParams[this.privRequestParams.roomId] = conversationCode;
            else {
                $gBGZx.Contracts.throwIfNullOrUndefined(subscriptionRegion, this.privErrors.authInvalidSubscriptionRegion);
                headers[this.privRequestParams.subscriptionRegion] = subscriptionRegion;
                if (subscriptionKey) headers[this.privRequestParams.subscriptionKey] = subscriptionKey;
                else if (authToken) headers[this.privRequestParams.authorization] = "Bearer " + authToken;
                else $gBGZx.Contracts.throwIfNullOrUndefined(subscriptionKey, this.privErrors.authInvalidSubscriptionKey);
            }
            var config = {};
            config.headers = headers;
            this.privRestAdapter.options = config;
            var endpoint = "https://" + endpointHost + this.privRestPath;
            // TODO: support a proxy and certificate validation
            this.privRestAdapter.request($j1V0D.RestRequestType.Post, endpoint, queryParams, null).then(function(response) {
                var requestId = $j1V0D.RestMessageAdapter.extractHeaderValue(_this.privRequestParams.requestId, response.headers);
                if (!response.ok) {
                    if (!!err) {
                        // get the error
                        var errorMessage = _this.privErrors.invalidCreateJoinConversationResponse.replace("{status}", response.status.toString());
                        var errMessageRaw = void 0;
                        try {
                            errMessageRaw = JSON.parse(response.data);
                            errorMessage += " [" + errMessageRaw.error.code + ": " + errMessageRaw.error.message + "]";
                        } catch (e) {
                            errorMessage += " [" + response.data + "]";
                        }
                        if (requestId) errorMessage += " " + requestId;
                        err(errorMessage);
                    }
                    return;
                }
                var conversation = JSON.parse(response.data);
                if (conversation) conversation.requestId = requestId;
                if (!!cb) {
                    try {
                        cb(conversation);
                    } catch (e) {
                        if (!!err) err(e);
                    }
                    cb = undefined;
                }
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            }).catch(function() {});
        } catch (error) {
            if (!!err) {
                if (error instanceof Error) {
                    var typedError = error;
                    err(typedError.name + ": " + typedError.message);
                } else err(error);
            }
        }
    };
    /**
     * Make a DELETE request to the Conversation Manager service endpoint to leave the conversation.
     * @param args
     * @param sessionToken
     * @param callback
     */ ConversationManager.prototype.leave = function(args, sessionToken) {
        var _this = this;
        return new Promise(function(resolve, reject) {
            try {
                $gBGZx.Contracts.throwIfNullOrUndefined(args, _this.privErrors.invalidArgs.replace("{arg}", "config"));
                $gBGZx.Contracts.throwIfNullOrWhitespace(sessionToken, _this.privErrors.invalidArgs.replace("{arg}", "token"));
                var endpointHost = args.getProperty($hM4QX.PropertyId.ConversationTranslator_Host, _this.privHost);
                var correlationId = args.getProperty($hM4QX.PropertyId.ConversationTranslator_CorrelationId);
                var queryParams = {};
                queryParams[_this.privRequestParams.apiVersion] = _this.privApiVersion;
                queryParams[_this.privRequestParams.sessionToken] = sessionToken;
                var headers = {};
                if (correlationId) headers[_this.privRequestParams.correlationId] = correlationId;
                var config = {};
                config.headers = headers;
                _this.privRestAdapter.options = config;
                var endpoint = "https://" + endpointHost + _this.privRestPath;
                // TODO: support a proxy and certificate validation
                _this.privRestAdapter.request($j1V0D.RestRequestType.Delete, endpoint, queryParams, null).then(function(response) {
                    response.ok;
                    resolve();
                // eslint-disable-next-line @typescript-eslint/no-empty-function
                }).catch(function() {});
            } catch (error) {
                if (error instanceof Error) {
                    var typedError = error;
                    reject(typedError.name + ": " + typedError.message);
                } else reject(error);
            }
        });
    };
    return ConversationManager;
}();
module.exports.ConversationManager = $47b50aa6b9cf022f$var$ConversationManager;

});
parcelRequire.register("9v4Of", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
var $6eaabd5c9a38dc9b$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ConversationConnectionConfig = void 0;

var $e6mtZ = parcelRequire("e6mtZ");
var $6eaabd5c9a38dc9b$var$ConversationConnectionConfig = /** @class */ function(_super) {
    $6eaabd5c9a38dc9b$var$__extends(ConversationConnectionConfig, _super);
    function ConversationConnectionConfig() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(ConversationConnectionConfig, "host", {
        get: function() {
            return ConversationConnectionConfig.privHost;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ConversationConnectionConfig, "apiVersion", {
        get: function() {
            return ConversationConnectionConfig.privApiVersion;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ConversationConnectionConfig, "clientAppId", {
        get: function() {
            return ConversationConnectionConfig.privClientAppId;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ConversationConnectionConfig, "defaultLanguageCode", {
        get: function() {
            return ConversationConnectionConfig.privDefaultLanguageCode;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ConversationConnectionConfig, "restPath", {
        get: function() {
            return ConversationConnectionConfig.privRestPath;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ConversationConnectionConfig, "webSocketPath", {
        get: function() {
            return ConversationConnectionConfig.privWebSocketPath;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ConversationConnectionConfig, "transcriptionEventKeys", {
        get: function() {
            return ConversationConnectionConfig.privTranscriptionEventKeys;
        },
        enumerable: false,
        configurable: true
    });
    ConversationConnectionConfig.privHost = "dev.microsofttranslator.com";
    ConversationConnectionConfig.privRestPath = "/capito/room";
    ConversationConnectionConfig.privApiVersion = "2.0";
    ConversationConnectionConfig.privDefaultLanguageCode = "en-US";
    ConversationConnectionConfig.privClientAppId = "FC539C22-1767-4F1F-84BC-B4D811114F15";
    ConversationConnectionConfig.privWebSocketPath = "/capito/translate";
    ConversationConnectionConfig.privTranscriptionEventKeys = [
        "iCalUid",
        "callId",
        "organizer",
        "FLAC",
        "MTUri",
        "DifferentiateGuestSpeakers",
        "audiorecording",
        "Threadid",
        "OrganizerMri",
        "OrganizerTenantId",
        "UserToken"
    ];
    return ConversationConnectionConfig;
}($e6mtZ.RestConfigBase);
module.exports.ConversationConnectionConfig = $6eaabd5c9a38dc9b$var$ConversationConnectionConfig;

});
parcelRequire.register("e6mtZ", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RestConfigBase = void 0;
var $a44310d20e4db102$var$RestConfigBase = /** @class */ function() {
    function RestConfigBase() {}
    Object.defineProperty(RestConfigBase, "requestOptions", {
        get: function() {
            return RestConfigBase.privDefaultRequestOptions;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(RestConfigBase, "configParams", {
        get: function() {
            return RestConfigBase.privDefaultParams;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(RestConfigBase, "restErrors", {
        get: function() {
            return RestConfigBase.privRestErrors;
        },
        enumerable: false,
        configurable: true
    });
    RestConfigBase.privDefaultRequestOptions = {
        headers: {
            Accept: "application/json"
        },
        ignoreCache: false,
        timeout: 10000
    };
    RestConfigBase.privRestErrors = {
        authInvalidSubscriptionKey: "You must specify either an authentication token to use, or a Cognitive Speech subscription key.",
        authInvalidSubscriptionRegion: "You must specify the Cognitive Speech region to use.",
        invalidArgs: "Required input not found: {arg}.",
        invalidCreateJoinConversationResponse: "Creating/Joining conversation failed with HTTP {status}.",
        invalidParticipantRequest: "The requested participant was not found.",
        permissionDeniedConnect: "Required credentials not found.",
        permissionDeniedConversation: "Invalid operation: only the host can {command} the conversation.",
        permissionDeniedParticipant: "Invalid operation: only the host can {command} a participant.",
        permissionDeniedSend: "Invalid operation: the conversation is not in a connected state.",
        permissionDeniedStart: "Invalid operation: there is already an active conversation."
    };
    RestConfigBase.privDefaultParams = {
        apiVersion: "api-version",
        authorization: "Authorization",
        clientAppId: "X-ClientAppId",
        contentTypeKey: "Content-Type",
        correlationId: "X-CorrelationId",
        languageCode: "language",
        nickname: "nickname",
        profanity: "profanity",
        requestId: "X-RequestId",
        roomId: "roomid",
        sessionToken: "token",
        subscriptionKey: "Ocp-Apim-Subscription-Key",
        subscriptionRegion: "Ocp-Apim-Subscription-Region",
        token: "X-CapitoToken"
    };
    return RestConfigBase;
}();
module.exports.RestConfigBase = $a44310d20e4db102$var$RestConfigBase;

});



parcelRequire.register("gq7j5", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
var $bf44be07a6fa708b$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $bf44be07a6fa708b$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $bf44be07a6fa708b$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ConversationTranslatorRecognizer = module.exports.ConversationRecognizerFactory = void 0;

var $dEkJU = parcelRequire("dEkJU");

var $em8BD = parcelRequire("em8BD");

var $gBGZx = parcelRequire("gBGZx");

var $hM4QX = parcelRequire("hM4QX");

var $8L6gn = parcelRequire("8L6gn");

var $1K6Ss = parcelRequire("1K6Ss");
var $bf44be07a6fa708b$var$ConversationRecognizerFactory = /** @class */ function() {
    function ConversationRecognizerFactory() {}
    ConversationRecognizerFactory.fromConfig = function(conversation, speechConfig, audioConfig) {
        return new $bf44be07a6fa708b$var$ConversationTranslatorRecognizer(conversation, speechConfig, audioConfig);
    };
    return ConversationRecognizerFactory;
}();
module.exports.ConversationRecognizerFactory = $bf44be07a6fa708b$var$ConversationRecognizerFactory;
/**
 * Sends messages to the Conversation Translator websocket and listens for incoming events containing websocket messages.
 * Based off the recognizers in the SDK folder.
 */ var $bf44be07a6fa708b$var$ConversationTranslatorRecognizer = /** @class */ function(_super) {
    $bf44be07a6fa708b$var$__extends(ConversationTranslatorRecognizer, _super);
    function ConversationTranslatorRecognizer(conversation, speechConfig, audioConfig) {
        var _this = this;
        var serviceConfigImpl = speechConfig;
        $gBGZx.Contracts.throwIfNull(serviceConfigImpl, "speechConfig");
        var conversationImpl = conversation;
        $gBGZx.Contracts.throwIfNull(conversationImpl, "conversationImpl");
        _this = _super.call(this, audioConfig, serviceConfigImpl.properties, new $8L6gn.ConversationConnectionFactory()) || this;
        _this.privConversation = conversationImpl;
        _this.privIsDisposed = false;
        _this.privProperties = serviceConfigImpl.properties.clone();
        _this.privConnection = $hM4QX.Connection.fromRecognizer(_this);
        _this.privSetTimeout = typeof Blob !== "undefined" && typeof Worker !== "undefined" ? $em8BD.Timeout.setTimeout : setTimeout;
        _this.privClearTimeout = typeof Blob !== "undefined" && typeof Worker !== "undefined" ? $em8BD.Timeout.clearTimeout : clearTimeout;
        return _this;
    }
    Object.defineProperty(ConversationTranslatorRecognizer.prototype, "connected", {
        set: function(cb) {
            this.privConnection.connected = cb;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ConversationTranslatorRecognizer.prototype, "disconnected", {
        set: function(cb) {
            this.privConnection.disconnected = cb;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ConversationTranslatorRecognizer.prototype, "speechRecognitionLanguage", {
        /**
         * Return the speech language used by the recognizer
         */ get: function() {
            return this.privSpeechRecognitionLanguage;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ConversationTranslatorRecognizer.prototype, "properties", {
        /**
         * Return the properties for the recognizer
         */ get: function() {
            return this.privProperties;
        },
        enumerable: false,
        configurable: true
    });
    ConversationTranslatorRecognizer.prototype.isDisposed = function() {
        return this.privIsDisposed;
    };
    /**
     * Connect to the recognizer
     * @param token
     */ ConversationTranslatorRecognizer.prototype.connect = function(token, cb, err) {
        try {
            $gBGZx.Contracts.throwIfDisposed(this.privIsDisposed);
            $gBGZx.Contracts.throwIfNullOrWhitespace(token, "token");
            this.privReco.conversationTranslatorToken = token;
            this.resetConversationTimeout();
            this.privReco.connectAsync(cb, err);
        } catch (error) {
            if (!!err) {
                if (error instanceof Error) {
                    var typedError = error;
                    err(typedError.name + ": " + typedError.message);
                } else err(error);
            }
        }
    };
    /**
     * Disconnect from the recognizer
     */ ConversationTranslatorRecognizer.prototype.disconnect = function(cb, err) {
        try {
            $gBGZx.Contracts.throwIfDisposed(this.privIsDisposed);
            if (this.privTimeoutToken !== undefined) // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
            this.privClearTimeout(this.privTimeoutToken);
            this.privReco.disconnect().then(function() {
                if (!!cb) cb();
            }, function(error) {
                if (!!err) err(error);
            });
        } catch (error) {
            if (!!err) {
                if (error instanceof Error) {
                    var typedError = error;
                    err(typedError.name + ": " + typedError.message);
                } else err(error);
            }
            // Destroy the recognizer.
            this.dispose(true).catch(function(reason) {
                $em8BD.Events.instance.onEvent(new $em8BD.BackgroundEvent(reason));
            });
        }
    };
    /**
     * Send the mute all participants command to the websocket
     * @param conversationId
     * @param participantId
     * @param isMuted
     */ ConversationTranslatorRecognizer.prototype.sendRequest = function(command, cb, err) {
        try {
            $gBGZx.Contracts.throwIfDisposed(this.privIsDisposed);
            this.sendMessage(command, cb, err);
        } catch (error) {
            if (!!err) {
                if (error instanceof Error) {
                    var typedError = error;
                    err(typedError.name + ": " + typedError.message);
                } else err(error);
            }
            // Destroy the recognizer.
            this.dispose(true).catch(function(reason) {
                $em8BD.Events.instance.onEvent(new $em8BD.BackgroundEvent(reason));
            });
        }
    };
    /**
     * Close and dispose the recognizer
     */ ConversationTranslatorRecognizer.prototype.close = function() {
        return $bf44be07a6fa708b$var$__awaiter(this, void 0, void 0, function() {
            return $bf44be07a6fa708b$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!!this.privIsDisposed) return [
                            3 /*break*/ ,
                            2
                        ];
                        if (!!this.privConnection) {
                            this.privConnection.closeConnection();
                            this.privConnection.close();
                        }
                        this.privConnection = undefined;
                        return [
                            4 /*yield*/ ,
                            this.dispose(true)
                        ];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * Dispose the recognizer
     * @param disposing
     */ ConversationTranslatorRecognizer.prototype.dispose = function(disposing) {
        return $bf44be07a6fa708b$var$__awaiter(this, void 0, void 0, function() {
            return $bf44be07a6fa708b$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (this.privIsDisposed) return [
                            2 /*return*/ 
                        ];
                        if (!disposing) return [
                            3 /*break*/ ,
                            2
                        ];
                        if (this.privTimeoutToken !== undefined) // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
                        this.privClearTimeout(this.privTimeoutToken);
                        this.privIsDisposed = true;
                        if (!!this.privConnection) {
                            this.privConnection.closeConnection();
                            this.privConnection.close();
                            this.privConnection = undefined;
                        }
                        return [
                            4 /*yield*/ ,
                            _super.prototype.dispose.call(this, disposing)
                        ];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * Create the config for the recognizer
     * @param speechConfig
     */ ConversationTranslatorRecognizer.prototype.createRecognizerConfig = function(speechConfig) {
        return new $dEkJU.RecognizerConfig(speechConfig, this.privProperties);
    };
    /**
     * Create the service recognizer.
     * The audio source is redundnant here but is required by the implementation.
     * @param authentication
     * @param connectionFactory
     * @param audioConfig
     * @param recognizerConfig
     */ ConversationTranslatorRecognizer.prototype.createServiceRecognizer = function(authentication, connectionFactory, audioConfig, recognizerConfig) {
        var audioSource = audioConfig;
        return new $1K6Ss.ConversationServiceAdapter(authentication, connectionFactory, audioSource, recognizerConfig, this);
    };
    ConversationTranslatorRecognizer.prototype.sendMessage = function(msg, cb, err) {
        var withAsync = this.privReco;
        var PromiseToEmptyCallback = function(promise, cb, err) {
            if (promise !== undefined) promise.then(function() {
                try {
                    if (!!cb) cb();
                } catch (e) {
                    if (!!err) err("'Unhandled error on promise callback: " + e + "'");
                }
            }, function(reason) {
                try {
                    if (!!err) err(reason);
                // eslint-disable-next-line no-empty
                } catch (error) {}
            });
            else if (!!err) err("Null promise");
        };
        PromiseToEmptyCallback(withAsync.sendMessageAsync(msg), cb, err);
        this.resetConversationTimeout();
    };
    ConversationTranslatorRecognizer.prototype.resetConversationTimeout = function() {
        var _this = this;
        if (this.privTimeoutToken !== undefined) // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
        this.privClearTimeout(this.privTimeoutToken);
        this.privTimeoutToken = this.privSetTimeout(function() {
            _this.sendRequest(_this.privConversation.getKeepAlive());
        }, 60000);
    };
    return ConversationTranslatorRecognizer;
}($hM4QX.Recognizer);
module.exports.ConversationTranslatorRecognizer = $bf44be07a6fa708b$var$ConversationTranslatorRecognizer;

});
parcelRequire.register("8L6gn", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
var $01a5488d6f4dc10e$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ConversationConnectionFactory = void 0;

var $j1V0D = parcelRequire("j1V0D");

var $em8BD = parcelRequire("em8BD");

var $gBGZx = parcelRequire("gBGZx");

var $hM4QX = parcelRequire("hM4QX");

var $hGMva = parcelRequire("hGMva");

var $9v4Of = parcelRequire("9v4Of");

var $UEUk7 = parcelRequire("UEUk7");
/**
 * Create a connection to the Conversation Translator websocket for sending instant messages and commands, and for receiving translated messages.
 * The conversation must already have been started or joined.
 */ var $01a5488d6f4dc10e$var$ConversationConnectionFactory = /** @class */ function(_super) {
    $01a5488d6f4dc10e$var$__extends(ConversationConnectionFactory, _super);
    function ConversationConnectionFactory() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ConversationConnectionFactory.prototype.create = function(config, authInfo, connectionId) {
        var endpointHost = config.parameters.getProperty($hM4QX.PropertyId.ConversationTranslator_Host, $9v4Of.ConversationConnectionConfig.host);
        var correlationId = config.parameters.getProperty($hM4QX.PropertyId.ConversationTranslator_CorrelationId, $em8BD.createGuid());
        var endpoint = "wss://" + endpointHost + $9v4Of.ConversationConnectionConfig.webSocketPath;
        var token = config.parameters.getProperty($hM4QX.PropertyId.ConversationTranslator_Token, undefined);
        $gBGZx.Contracts.throwIfNullOrUndefined(token, "token");
        var queryParams = {};
        queryParams[$9v4Of.ConversationConnectionConfig.configParams.apiVersion] = $9v4Of.ConversationConnectionConfig.apiVersion;
        queryParams[$9v4Of.ConversationConnectionConfig.configParams.token] = token;
        queryParams[$9v4Of.ConversationConnectionConfig.configParams.correlationId] = correlationId;
        var enableCompression = config.parameters.getProperty("SPEECH-EnableWebsocketCompression", "false") === "true";
        return new $j1V0D.WebsocketConnection(endpoint, queryParams, {}, new $UEUk7.ConversationWebsocketMessageFormatter(), $j1V0D.ProxyInfo.fromRecognizerConfig(config), enableCompression, connectionId);
    };
    return ConversationConnectionFactory;
}($hGMva.ConnectionFactoryBase);
module.exports.ConversationConnectionFactory = $01a5488d6f4dc10e$var$ConversationConnectionFactory;

});
parcelRequire.register("UEUk7", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ConversationWebsocketMessageFormatter = void 0;

var $em8BD = parcelRequire("em8BD");

var $6mekw = parcelRequire("6mekw");
/**
 * Based off WebsocketMessageFormatter. The messages for Conversation Translator have some variations from the Speech messages.
 */ var $0aa4f67191224755$var$ConversationWebsocketMessageFormatter = /** @class */ function() {
    function ConversationWebsocketMessageFormatter() {}
    /**
     * Format incoming messages: text (speech partial/final, IM) or binary (tts)
     */ ConversationWebsocketMessageFormatter.prototype.toConnectionMessage = function(message) {
        var deferral = new $em8BD.Deferred();
        try {
            if (message.messageType === $em8BD.MessageType.Text) {
                var incomingMessage = new $6mekw.ConversationConnectionMessage(message.messageType, message.textContent, {}, message.id);
                deferral.resolve(incomingMessage);
            } else if (message.messageType === $em8BD.MessageType.Binary) deferral.resolve(new $6mekw.ConversationConnectionMessage(message.messageType, message.binaryContent, undefined, message.id));
        } catch (e) {
            deferral.reject("Error formatting the message. Error: " + e);
        }
        return deferral.promise;
    };
    /**
     * Format outgoing messages: text (commands or IM)
     */ ConversationWebsocketMessageFormatter.prototype.fromConnectionMessage = function(message) {
        var deferral = new $em8BD.Deferred();
        try {
            if (message.messageType === $em8BD.MessageType.Text) {
                var payload = "" + (message.textBody ? message.textBody : "");
                deferral.resolve(new $em8BD.RawWebsocketMessage($em8BD.MessageType.Text, payload, message.id));
            }
        } catch (e) {
            deferral.reject("Error formatting the message. " + e);
        }
        return deferral.promise;
    };
    return ConversationWebsocketMessageFormatter;
}();
module.exports.ConversationWebsocketMessageFormatter = $0aa4f67191224755$var$ConversationWebsocketMessageFormatter;

});
parcelRequire.register("6mekw", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
var $4a0fe9cce6e9cc89$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ConversationConnectionMessage = void 0;

var $em8BD = parcelRequire("em8BD");
var $4a0fe9cce6e9cc89$var$ConversationConnectionMessage = /** @class */ function(_super) {
    $4a0fe9cce6e9cc89$var$__extends(ConversationConnectionMessage, _super);
    function ConversationConnectionMessage(messageType, body, headers, id) {
        var _this = _super.call(this, messageType, body, headers, id) || this;
        var json = JSON.parse(_this.textBody);
        if (json.type !== undefined) _this.privConversationMessageType = json.type;
        return _this;
    }
    Object.defineProperty(ConversationConnectionMessage.prototype, "conversationMessageType", {
        get: function() {
            return this.privConversationMessageType;
        },
        enumerable: false,
        configurable: true
    });
    return ConversationConnectionMessage;
}($em8BD.ConnectionMessage);
module.exports.ConversationConnectionMessage = $4a0fe9cce6e9cc89$var$ConversationConnectionMessage;

});



parcelRequire.register("1K6Ss", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
var $144f6c0222fcef93$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $144f6c0222fcef93$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $144f6c0222fcef93$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ConversationServiceAdapter = void 0;

var $em8BD = parcelRequire("em8BD");

var $hM4QX = parcelRequire("hM4QX");

var $dEkJU = parcelRequire("dEkJU");

var $6mekw = parcelRequire("6mekw");

var $jmLsD = parcelRequire("jmLsD");

var $35r7p = parcelRequire("35r7p");

var $kWIMy = parcelRequire("kWIMy");

var $eIcxa = parcelRequire("eIcxa");
/**
 * The service adapter handles sending and receiving messages to the Conversation Translator websocket.
 */ var $144f6c0222fcef93$var$ConversationServiceAdapter = /** @class */ function(_super) {
    $144f6c0222fcef93$var$__extends(ConversationServiceAdapter, _super);
    function ConversationServiceAdapter(authentication, connectionFactory, audioSource, recognizerConfig, conversationServiceConnector) {
        var _this = _super.call(this, authentication, connectionFactory, audioSource, recognizerConfig, conversationServiceConnector) || this;
        _this.privConnectionConfigPromise = undefined;
        _this.privLastPartialUtteranceId = "";
        _this.privConversationServiceConnector = conversationServiceConnector;
        _this.privConversationAuthentication = authentication;
        _this.receiveMessageOverride = function() {
            return _this.receiveConversationMessageOverride();
        };
        _this.recognizeOverride = function() {
            return _this.noOp();
        };
        _this.postConnectImplOverride = function(connection) {
            return _this.conversationConnectImpl(connection);
        };
        _this.configConnectionOverride = function() {
            return _this.configConnection();
        };
        _this.disconnectOverride = function() {
            return _this.privDisconnect();
        };
        _this.privConversationRequestSession = new $jmLsD.ConversationRequestSession($em8BD.createNoDashGuid());
        _this.privConversationConnectionFactory = connectionFactory;
        _this.privConversationIsDisposed = false;
        return _this;
    }
    ConversationServiceAdapter.prototype.isDisposed = function() {
        return _super.prototype.isDisposed.call(this) || this.privConversationIsDisposed;
    };
    ConversationServiceAdapter.prototype.dispose = function(reason) {
        return $144f6c0222fcef93$var$__awaiter(this, void 0, void 0, function() {
            var connection;
            return $144f6c0222fcef93$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        this.privConversationIsDisposed = true;
                        if (!(this.privConnectionConfigPromise !== undefined)) return [
                            3 /*break*/ ,
                            3
                        ];
                        return [
                            4 /*yield*/ ,
                            this.privConnectionConfigPromise
                        ];
                    case 1:
                        connection = _a.sent();
                        return [
                            4 /*yield*/ ,
                            connection.dispose(reason)
                        ];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3:
                        return [
                            4 /*yield*/ ,
                            _super.prototype.dispose.call(this, reason)
                        ];
                    case 4:
                        _a.sent();
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    ConversationServiceAdapter.prototype.sendMessage = function(message) {
        return $144f6c0222fcef93$var$__awaiter(this, void 0, void 0, function() {
            var connection;
            return $144f6c0222fcef93$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.fetchConnection()
                        ];
                    case 1:
                        connection = _a.sent();
                        return [
                            2 /*return*/ ,
                            connection.send(new $6mekw.ConversationConnectionMessage($em8BD.MessageType.Text, message))
                        ];
                }
            });
        });
    };
    ConversationServiceAdapter.prototype.sendMessageAsync = function(message) {
        return $144f6c0222fcef93$var$__awaiter(this, void 0, void 0, function() {
            var connection;
            return $144f6c0222fcef93$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.fetchConnection()
                        ];
                    case 1:
                        connection = _a.sent();
                        return [
                            4 /*yield*/ ,
                            connection.send(new $6mekw.ConversationConnectionMessage($em8BD.MessageType.Text, message))
                        ];
                    case 2:
                        _a.sent();
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    ConversationServiceAdapter.prototype.privDisconnect = function() {
        if (this.terminateMessageLoop) return;
        this.cancelRecognition(this.privConversationRequestSession.sessionId, this.privConversationRequestSession.requestId, $hM4QX.CancellationReason.Error, $hM4QX.CancellationErrorCode.NoError, "Disconnecting");
        this.terminateMessageLoop = true;
        return Promise.resolve();
    };
    // eslint-disable-next-line @typescript-eslint/require-await
    ConversationServiceAdapter.prototype.processTypeSpecificMessages = function() {
        return $144f6c0222fcef93$var$__awaiter(this, void 0, void 0, function() {
            return $144f6c0222fcef93$var$__generator(this, function(_a) {
                return [
                    2 /*return*/ ,
                    true
                ];
            });
        });
    };
    // Cancels recognition.
    ConversationServiceAdapter.prototype.cancelRecognition = function(sessionId, requestId, cancellationReason, errorCode, error) {
        this.terminateMessageLoop = true;
        var cancelEvent = new $hM4QX.ConversationTranslationCanceledEventArgs(cancellationReason, error, errorCode, undefined, sessionId);
        try {
            if (!!this.privConversationServiceConnector.canceled) this.privConversationServiceConnector.canceled(this.privConversationServiceConnector, cancelEvent);
        } catch (_a) {
        // continue on error
        }
    };
    /**
     * Establishes a websocket connection to the end point.
     */ ConversationServiceAdapter.prototype.conversationConnectImpl = function(connection) {
        return $144f6c0222fcef93$var$__awaiter(this, void 0, void 0, function() {
            return $144f6c0222fcef93$var$__generator(this, function(_a) {
                this.privConnectionLoop = this.startMessageLoop();
                return [
                    2 /*return*/ ,
                    connection
                ];
            });
        });
    };
    /**
     * Process incoming websocket messages
     */ ConversationServiceAdapter.prototype.receiveConversationMessageOverride = function() {
        return $144f6c0222fcef93$var$__awaiter(this, void 0, void 0, function() {
            var communicationCustodian, connection, message, sessionId, sendFinal, commandPayload_1, participantsPayload, participantsResult, joinParticipantPayload, joiningParticipant, leavingParticipant, disconnectParticipant, token, speechPayload, speechResult, textPayload, textResult, e_1;
            return $144f6c0222fcef93$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (this.isDisposed() || this.terminateMessageLoop) return [
                            2 /*return*/ ,
                            Promise.resolve()
                        ];
                        communicationCustodian = new $em8BD.Deferred();
                        _a.label = 1;
                    case 1:
                        _a.trys.push([
                            1,
                            4,
                            ,
                            5
                        ]);
                        return [
                            4 /*yield*/ ,
                            this.fetchConnection()
                        ];
                    case 2:
                        connection = _a.sent();
                        return [
                            4 /*yield*/ ,
                            connection.read()
                        ];
                    case 3:
                        message = _a.sent();
                        if (this.isDisposed() || this.terminateMessageLoop) {
                            // We're done.
                            communicationCustodian.resolve();
                            return [
                                2 /*return*/ ,
                                Promise.resolve()
                            ];
                        }
                        if (!message) return [
                            2 /*return*/ ,
                            this.receiveConversationMessageOverride()
                        ];
                        sessionId = this.privConversationRequestSession.sessionId;
                        sendFinal = false;
                        try {
                            switch(message.conversationMessageType.toLowerCase()){
                                case "info":
                                case "participant_command":
                                case "command":
                                    commandPayload_1 = $eIcxa.CommandResponsePayload.fromJSON(message.textBody);
                                    switch(commandPayload_1.command.toLowerCase()){
                                        /**
                                         * 'ParticpantList' is the first message sent to the user after the websocket connection has opened.
                                         * The consuming client must wait for this message to arrive
                                         * before starting to send their own data.
                                         */ case "participantlist":
                                            participantsPayload = $eIcxa.ParticipantsListPayloadResponse.fromJSON(message.textBody);
                                            participantsResult = participantsPayload.participants.map(function(p) {
                                                var participant = {
                                                    avatar: p.avatar,
                                                    displayName: p.nickname,
                                                    id: p.participantId,
                                                    isHost: p.ishost,
                                                    isMuted: p.ismuted,
                                                    isUsingTts: p.usetts,
                                                    preferredLanguage: p.locale
                                                };
                                                return participant;
                                            });
                                            if (!!this.privConversationServiceConnector.participantsListReceived) this.privConversationServiceConnector.participantsListReceived(this.privConversationServiceConnector, new $35r7p.ParticipantsListEventArgs(participantsPayload.roomid, participantsPayload.token, participantsPayload.translateTo, participantsPayload.profanityFilter, participantsPayload.roomProfanityFilter, participantsPayload.roomLocked, participantsPayload.muteAll, participantsResult, sessionId));
                                            break;
                                        /**
                                         * 'SetTranslateToLanguages' represents the list of languages being used in the Conversation by all users(?).
                                         * This is sent at the start of the Conversation
                                         */ case "settranslatetolanguages":
                                            if (!!this.privConversationServiceConnector.participantUpdateCommandReceived) this.privConversationServiceConnector.participantUpdateCommandReceived(this.privConversationServiceConnector, new $35r7p.ParticipantAttributeEventArgs(commandPayload_1.participantId, $kWIMy.ConversationTranslatorCommandTypes.setTranslateToLanguages, commandPayload_1.value, sessionId));
                                            break;
                                        /**
                                         * 'SetProfanityFiltering' lets the client set the level of profanity filtering.
                                         * If sent by the participant the setting will effect only their own profanity level.
                                         * If sent by the host, the setting will effect all participants including the host.
                                         * Note: the profanity filters differ from Speech Service (?): 'marked', 'raw', 'removed', 'tagged'
                                         */ case "setprofanityfiltering":
                                            if (!!this.privConversationServiceConnector.participantUpdateCommandReceived) this.privConversationServiceConnector.participantUpdateCommandReceived(this.privConversationServiceConnector, new $35r7p.ParticipantAttributeEventArgs(commandPayload_1.participantId, $kWIMy.ConversationTranslatorCommandTypes.setProfanityFiltering, commandPayload_1.value, sessionId));
                                            break;
                                        /**
                                         * 'SetMute' is sent if the participant has been muted by the host.
                                         * Check the 'participantId' to determine if the current user has been muted.
                                         */ case "setmute":
                                            if (!!this.privConversationServiceConnector.participantUpdateCommandReceived) this.privConversationServiceConnector.participantUpdateCommandReceived(this.privConversationServiceConnector, new $35r7p.ParticipantAttributeEventArgs(commandPayload_1.participantId, $kWIMy.ConversationTranslatorCommandTypes.setMute, commandPayload_1.value, sessionId));
                                            break;
                                        /**
                                         * 'SetMuteAll' is sent if the Conversation has been muted by the host.
                                         */ case "setmuteall":
                                            if (!!this.privConversationServiceConnector.muteAllCommandReceived) this.privConversationServiceConnector.muteAllCommandReceived(this.privConversationServiceConnector, new $35r7p.MuteAllEventArgs(commandPayload_1.value, sessionId));
                                            break;
                                        /**
                                         * 'RoomExpirationWarning' is sent towards the end of the Conversation session to give a timeout warning.
                                         */ case "roomexpirationwarning":
                                            if (!!this.privConversationServiceConnector.conversationExpiration) this.privConversationServiceConnector.conversationExpiration(this.privConversationServiceConnector, new $hM4QX.ConversationExpirationEventArgs(commandPayload_1.value, this.privConversationRequestSession.sessionId));
                                            break;
                                        /**
                                         * 'SetUseTts' is sent as a confirmation if the user requests TTS to be turned on or off.
                                         */ case "setusetts":
                                            if (!!this.privConversationServiceConnector.participantUpdateCommandReceived) this.privConversationServiceConnector.participantUpdateCommandReceived(this.privConversationServiceConnector, new $35r7p.ParticipantAttributeEventArgs(commandPayload_1.participantId, $kWIMy.ConversationTranslatorCommandTypes.setUseTTS, commandPayload_1.value, sessionId));
                                            break;
                                        /**
                                         * 'SetLockState' is set if the host has locked or unlocked the Conversation.
                                         */ case "setlockstate":
                                            if (!!this.privConversationServiceConnector.lockRoomCommandReceived) this.privConversationServiceConnector.lockRoomCommandReceived(this.privConversationServiceConnector, new $35r7p.LockRoomEventArgs(commandPayload_1.value, sessionId));
                                            break;
                                        /**
                                         * 'ChangeNickname' is received if a user changes their display name.
                                         * Any cached particpiants list should be updated to reflect the display name.
                                         */ case "changenickname":
                                            if (!!this.privConversationServiceConnector.participantUpdateCommandReceived) this.privConversationServiceConnector.participantUpdateCommandReceived(this.privConversationServiceConnector, new $35r7p.ParticipantAttributeEventArgs(commandPayload_1.participantId, $kWIMy.ConversationTranslatorCommandTypes.changeNickname, commandPayload_1.nickname, sessionId));
                                            break;
                                        /**
                                         * 'JoinSession' is sent when a user joins the Conversation.
                                         */ case "joinsession":
                                            joinParticipantPayload = $eIcxa.ParticipantPayloadResponse.fromJSON(message.textBody);
                                            joiningParticipant = {
                                                avatar: joinParticipantPayload.avatar,
                                                displayName: joinParticipantPayload.nickname,
                                                id: joinParticipantPayload.participantId,
                                                isHost: joinParticipantPayload.ishost,
                                                isMuted: joinParticipantPayload.ismuted,
                                                isUsingTts: joinParticipantPayload.usetts,
                                                preferredLanguage: joinParticipantPayload.locale
                                            };
                                            if (!!this.privConversationServiceConnector.participantJoinCommandReceived) this.privConversationServiceConnector.participantJoinCommandReceived(this.privConversationServiceConnector, new $35r7p.ParticipantEventArgs(joiningParticipant, sessionId));
                                            break;
                                        /**
                                         * 'LeaveSession' is sent when a user leaves the Conversation'.
                                         */ case "leavesession":
                                            leavingParticipant = {
                                                id: commandPayload_1.participantId
                                            };
                                            if (!!this.privConversationServiceConnector.participantLeaveCommandReceived) this.privConversationServiceConnector.participantLeaveCommandReceived(this.privConversationServiceConnector, new $35r7p.ParticipantEventArgs(leavingParticipant, sessionId));
                                            break;
                                        /**
                                         * 'DisconnectSession' is sent when a user is disconnected from the session (e.g. network problem).
                                         * Check the 'ParticipantId' to check whether the message is for the current user.
                                         */ case "disconnectsession":
                                            disconnectParticipant = {
                                                id: commandPayload_1.participantId
                                            };
                                            break;
                                        case "token":
                                            token = new $dEkJU.CognitiveTokenAuthentication(function() {
                                                var authorizationToken = commandPayload_1.token;
                                                return Promise.resolve(authorizationToken);
                                            }, function() {
                                                var authorizationToken = commandPayload_1.token;
                                                return Promise.resolve(authorizationToken);
                                            });
                                            this.authentication = token;
                                            break;
                                        /**
                                         * Message not recognized.
                                         */ default:
                                            break;
                                    }
                                    break;
                                /**
                                 * 'partial' (or 'hypothesis') represents a unfinalized speech message.
                                 */ case "partial":
                                /**
                                 * 'final' (or 'phrase') represents a finalized speech message.
                                 */ case "final":
                                    speechPayload = $eIcxa.SpeechResponsePayload.fromJSON(message.textBody);
                                    speechResult = new $hM4QX.ConversationTranslationResult(speechPayload.participantId, this.getTranslations(speechPayload.translations), speechPayload.language, undefined, undefined, speechPayload.recognition, undefined, undefined, message.textBody, undefined);
                                    if (speechPayload.isFinal) {
                                        // check the length, sometimes empty finals are returned
                                        if (speechResult.text !== undefined && speechResult.text.length > 0) sendFinal = true;
                                        else if (speechPayload.id === this.privLastPartialUtteranceId) // send final as normal. We had a non-empty partial for this same utterance
                                        // so sending the empty final is important
                                        sendFinal = true;
                                        if (sendFinal) {
                                            if (!!this.privConversationServiceConnector.translationReceived) this.privConversationServiceConnector.translationReceived(this.privConversationServiceConnector, new $35r7p.ConversationReceivedTranslationEventArgs($kWIMy.ConversationTranslatorMessageTypes.final, speechResult, sessionId));
                                        }
                                    } else if (speechResult.text !== undefined) {
                                        this.privLastPartialUtteranceId = speechPayload.id;
                                        if (!!this.privConversationServiceConnector.translationReceived) this.privConversationServiceConnector.translationReceived(this.privConversationServiceConnector, new $35r7p.ConversationReceivedTranslationEventArgs($kWIMy.ConversationTranslatorMessageTypes.partial, speechResult, sessionId));
                                    }
                                    break;
                                /**
                                 * "translated_message" is a text message or instant message (IM).
                                 */ case "translated_message":
                                    textPayload = $eIcxa.TextResponsePayload.fromJSON(message.textBody);
                                    textResult = new $hM4QX.ConversationTranslationResult(textPayload.participantId, this.getTranslations(textPayload.translations), textPayload.language, undefined, undefined, textPayload.originalText, undefined, undefined, undefined, message.textBody, undefined);
                                    if (!!this.privConversationServiceConnector.translationReceived) this.privConversationServiceConnector.translationReceived(this.privConversationServiceConnector, new $35r7p.ConversationReceivedTranslationEventArgs($kWIMy.ConversationTranslatorMessageTypes.instantMessage, textResult, sessionId));
                                    break;
                                default:
                                    break;
                            }
                        } catch (e) {
                        // continue
                        }
                        return [
                            2 /*return*/ ,
                            this.receiveConversationMessageOverride()
                        ];
                    case 4:
                        e_1 = _a.sent();
                        this.terminateMessageLoop = true;
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 5:
                        return [
                            2 /*return*/ ,
                            communicationCustodian.promise
                        ];
                }
            });
        });
    };
    ConversationServiceAdapter.prototype.startMessageLoop = function() {
        return $144f6c0222fcef93$var$__awaiter(this, void 0, void 0, function() {
            var messageRetrievalPromise, r, error_1;
            return $144f6c0222fcef93$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (this.isDisposed()) return [
                            2 /*return*/ ,
                            Promise.resolve()
                        ];
                        this.terminateMessageLoop = false;
                        messageRetrievalPromise = this.receiveConversationMessageOverride();
                        _a.label = 1;
                    case 1:
                        _a.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4 /*yield*/ ,
                            messageRetrievalPromise
                        ];
                    case 2:
                        r = _a.sent();
                        return [
                            2 /*return*/ ,
                            r
                        ];
                    case 3:
                        error_1 = _a.sent();
                        this.cancelRecognition(this.privRequestSession ? this.privRequestSession.sessionId : "", this.privRequestSession ? this.privRequestSession.requestId : "", $hM4QX.CancellationReason.Error, $hM4QX.CancellationErrorCode.RuntimeError, error_1);
                        return [
                            2 /*return*/ ,
                            null
                        ];
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    // Takes an established websocket connection to the endpoint
    ConversationServiceAdapter.prototype.configConnection = function() {
        var _this = this;
        if (this.isDisposed()) return Promise.resolve(undefined);
        if (this.privConnectionConfigPromise !== undefined) return this.privConnectionConfigPromise.then(function(connection) {
            if (connection.state() === $em8BD.ConnectionState.Disconnected) {
                _this.privConnectionId = null;
                _this.privConnectionConfigPromise = undefined;
                return _this.configConnection();
            }
            return _this.privConnectionConfigPromise;
        }, function() {
            _this.privConnectionId = null;
            _this.privConnectionConfigPromise = undefined;
            return _this.configConnection();
        });
        if (this.terminateMessageLoop) return Promise.resolve(undefined);
        this.privConnectionConfigPromise = this.connectImpl().then(function(connection) {
            return connection;
        });
        return this.privConnectionConfigPromise;
    };
    ConversationServiceAdapter.prototype.getTranslations = function(serviceResultTranslations) {
        var translations;
        if (undefined !== serviceResultTranslations) {
            translations = new $hM4QX.Translations();
            for(var _i = 0, serviceResultTranslations_1 = serviceResultTranslations; _i < serviceResultTranslations_1.length; _i++){
                var translation = serviceResultTranslations_1[_i];
                translations.set(translation.lang, translation.translation);
            }
        }
        return translations;
    };
    return ConversationServiceAdapter;
}($dEkJU.ServiceRecognizerBase);
module.exports.ConversationServiceAdapter = $144f6c0222fcef93$var$ConversationServiceAdapter;

});
parcelRequire.register("jmLsD", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
var $e194e31bee5770c4$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $e194e31bee5770c4$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ConversationRequestSession = void 0;

var $em8BD = parcelRequire("em8BD");
/**
 * Placeholder class for the Conversation Request Session. Based off RequestSession.
 * TODO: define what telemetry is required.
 */ var $e194e31bee5770c4$var$ConversationRequestSession = /** @class */ function() {
    function ConversationRequestSession(sessionId) {
        this.privIsDisposed = false;
        this.privDetachables = new Array();
        this.privSessionId = sessionId;
        this.privRequestId = $em8BD.createNoDashGuid();
        this.privRequestCompletionDeferral = new $em8BD.Deferred();
    }
    Object.defineProperty(ConversationRequestSession.prototype, "sessionId", {
        get: function() {
            return this.privSessionId;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ConversationRequestSession.prototype, "requestId", {
        get: function() {
            return this.privRequestId;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ConversationRequestSession.prototype, "completionPromise", {
        get: function() {
            return this.privRequestCompletionDeferral.promise;
        },
        enumerable: false,
        configurable: true
    });
    ConversationRequestSession.prototype.onPreConnectionStart = function(authFetchEventId, connectionId) {
        this.privSessionId = connectionId;
    };
    ConversationRequestSession.prototype.onAuthCompleted = function(isError) {
        if (isError) this.onComplete();
    };
    ConversationRequestSession.prototype.onConnectionEstablishCompleted = function(statusCode) {
        if (statusCode === 200) return;
        else if (statusCode === 403) this.onComplete();
    };
    ConversationRequestSession.prototype.onServiceTurnEndResponse = function(continuousRecognition) {
        if (!continuousRecognition) this.onComplete();
        else this.privRequestId = $em8BD.createNoDashGuid();
    };
    ConversationRequestSession.prototype.dispose = function() {
        return $e194e31bee5770c4$var$__awaiter(this, void 0, void 0, function() {
            var _i, _a, detachable;
            return $e194e31bee5770c4$var$__generator(this, function(_b) {
                switch(_b.label){
                    case 0:
                        if (!!this.privIsDisposed) return [
                            3 /*break*/ ,
                            4
                        ];
                        // we should have completed by now. If we did not its an unknown error.
                        this.privIsDisposed = true;
                        _i = 0, _a = this.privDetachables;
                        _b.label = 1;
                    case 1:
                        if (!(_i < _a.length)) return [
                            3 /*break*/ ,
                            4
                        ];
                        detachable = _a[_i];
                        return [
                            4 /*yield*/ ,
                            detachable.detach()
                        ];
                    case 2:
                        _b.sent();
                        _b.label = 3;
                    case 3:
                        _i++;
                        return [
                            3 /*break*/ ,
                            1
                        ];
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    ConversationRequestSession.prototype.onComplete = function() {
    //
    };
    return ConversationRequestSession;
}();
module.exports.ConversationRequestSession = $e194e31bee5770c4$var$ConversationRequestSession;

});

parcelRequire.register("35r7p", function(module, exports) {
"use strict";
var $23f6dfea89618b52$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ConversationReceivedTranslationEventArgs = module.exports.ParticipantsListEventArgs = module.exports.ParticipantAttributeEventArgs = module.exports.ParticipantEventArgs = module.exports.LockRoomEventArgs = module.exports.MuteAllEventArgs = void 0;

var $hM4QX = parcelRequire("hM4QX");
var $23f6dfea89618b52$var$MuteAllEventArgs = /** @class */ function(_super) {
    $23f6dfea89618b52$var$__extends(MuteAllEventArgs, _super);
    function MuteAllEventArgs(isMuted, sessionId) {
        var _this = _super.call(this, sessionId) || this;
        _this.privIsMuted = isMuted;
        return _this;
    }
    Object.defineProperty(MuteAllEventArgs.prototype, "isMuted", {
        get: function() {
            return this.privIsMuted;
        },
        enumerable: false,
        configurable: true
    });
    return MuteAllEventArgs;
}($hM4QX.SessionEventArgs);
module.exports.MuteAllEventArgs = $23f6dfea89618b52$var$MuteAllEventArgs;
var $23f6dfea89618b52$var$LockRoomEventArgs = /** @class */ function(_super) {
    $23f6dfea89618b52$var$__extends(LockRoomEventArgs, _super);
    function LockRoomEventArgs(isLocked, sessionId) {
        var _this = _super.call(this, sessionId) || this;
        _this.privIsLocked = isLocked;
        return _this;
    }
    Object.defineProperty(LockRoomEventArgs.prototype, "isMuted", {
        get: function() {
            return this.privIsLocked;
        },
        enumerable: false,
        configurable: true
    });
    return LockRoomEventArgs;
}($hM4QX.SessionEventArgs);
module.exports.LockRoomEventArgs = $23f6dfea89618b52$var$LockRoomEventArgs;
var $23f6dfea89618b52$var$ParticipantEventArgs = /** @class */ function(_super) {
    $23f6dfea89618b52$var$__extends(ParticipantEventArgs, _super);
    function ParticipantEventArgs(participant, sessionId) {
        var _this = _super.call(this, sessionId) || this;
        _this.privParticipant = participant;
        return _this;
    }
    Object.defineProperty(ParticipantEventArgs.prototype, "participant", {
        get: function() {
            return this.privParticipant;
        },
        enumerable: false,
        configurable: true
    });
    return ParticipantEventArgs;
}($hM4QX.SessionEventArgs);
module.exports.ParticipantEventArgs = $23f6dfea89618b52$var$ParticipantEventArgs;
var $23f6dfea89618b52$var$ParticipantAttributeEventArgs = /** @class */ function(_super) {
    $23f6dfea89618b52$var$__extends(ParticipantAttributeEventArgs, _super);
    function ParticipantAttributeEventArgs(participantId, key, value, sessionId) {
        var _this = _super.call(this, sessionId) || this;
        _this.privKey = key;
        _this.privValue = value;
        _this.privParticipantId = participantId;
        return _this;
    }
    Object.defineProperty(ParticipantAttributeEventArgs.prototype, "value", {
        get: function() {
            return this.privValue;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ParticipantAttributeEventArgs.prototype, "key", {
        get: function() {
            return this.privKey;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ParticipantAttributeEventArgs.prototype, "id", {
        get: function() {
            return this.privParticipantId;
        },
        enumerable: false,
        configurable: true
    });
    return ParticipantAttributeEventArgs;
}($hM4QX.SessionEventArgs);
module.exports.ParticipantAttributeEventArgs = $23f6dfea89618b52$var$ParticipantAttributeEventArgs;
var $23f6dfea89618b52$var$ParticipantsListEventArgs = /** @class */ function(_super) {
    $23f6dfea89618b52$var$__extends(ParticipantsListEventArgs, _super);
    function ParticipantsListEventArgs(conversationId, token, translateTo, profanityFilter, roomProfanityFilter, isRoomLocked, isMuteAll, participants, sessionId) {
        var _this = _super.call(this, sessionId) || this;
        _this.privRoomId = conversationId;
        _this.privSessionToken = token;
        _this.privTranslateTo = translateTo;
        _this.privProfanityFilter = profanityFilter;
        _this.privRoomProfanityFilter = roomProfanityFilter;
        _this.privIsRoomLocked = isRoomLocked;
        _this.privIsRoomLocked = isMuteAll;
        _this.privParticipants = participants;
        return _this;
    }
    Object.defineProperty(ParticipantsListEventArgs.prototype, "sessionToken", {
        get: function() {
            return this.privSessionToken;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ParticipantsListEventArgs.prototype, "conversationId", {
        get: function() {
            return this.privRoomId;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ParticipantsListEventArgs.prototype, "translateTo", {
        get: function() {
            return this.privTranslateTo;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ParticipantsListEventArgs.prototype, "profanityFilter", {
        get: function() {
            return this.privProfanityFilter;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ParticipantsListEventArgs.prototype, "roomProfanityFilter", {
        get: function() {
            return this.privRoomProfanityFilter;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ParticipantsListEventArgs.prototype, "isRoomLocked", {
        get: function() {
            return this.privIsRoomLocked;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ParticipantsListEventArgs.prototype, "isMuteAll", {
        get: function() {
            return this.privIsMuteAll;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ParticipantsListEventArgs.prototype, "participants", {
        get: function() {
            return this.privParticipants;
        },
        enumerable: false,
        configurable: true
    });
    return ParticipantsListEventArgs;
}($hM4QX.SessionEventArgs);
module.exports.ParticipantsListEventArgs = $23f6dfea89618b52$var$ParticipantsListEventArgs;
var $23f6dfea89618b52$var$ConversationReceivedTranslationEventArgs = /** @class */ function() {
    function ConversationReceivedTranslationEventArgs(command, payload, sessionId) {
        this.privPayload = payload;
        this.privCommand = command;
        this.privSessionId = sessionId;
    }
    Object.defineProperty(ConversationReceivedTranslationEventArgs.prototype, "payload", {
        get: function() {
            return this.privPayload;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ConversationReceivedTranslationEventArgs.prototype, "command", {
        get: function() {
            return this.privCommand;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ConversationReceivedTranslationEventArgs.prototype, "sessionId", {
        get: function() {
            return this.privSessionId;
        },
        enumerable: false,
        configurable: true
    });
    return ConversationReceivedTranslationEventArgs;
}();
module.exports.ConversationReceivedTranslationEventArgs = $23f6dfea89618b52$var$ConversationReceivedTranslationEventArgs;

});

parcelRequire.register("kWIMy", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ConversationTranslatorCommandTypes = module.exports.ConversationTranslatorMessageTypes = module.exports.InternalParticipants = void 0;
/** Users participating in the conversation */ var $f3fbf63fe774a239$var$InternalParticipants = /** @class */ function() {
    function InternalParticipants(participants, meId) {
        if (participants === void 0) participants = [];
        this.participants = participants;
        this.meId = meId;
    }
    /**
     * Add or update a participant
     * @param value
     */ InternalParticipants.prototype.addOrUpdateParticipant = function(value) {
        if (value === undefined) return;
        var exists = this.getParticipantIndex(value.id);
        if (exists > -1) this.participants.splice(exists, 1, value);
        else this.participants.push(value);
        // ensure it was added ok
        return this.getParticipant(value.id);
    };
    /**
     * Find the participant's position in the participants list.
     * @param id
     */ InternalParticipants.prototype.getParticipantIndex = function(id) {
        return this.participants.findIndex(function(p) {
            return p.id === id;
        });
    };
    /**
     * Find the participant by id.
     * @param id
     */ InternalParticipants.prototype.getParticipant = function(id) {
        return this.participants.find(function(p) {
            return p.id === id;
        });
    };
    /**
     * Remove a participant from the participants list.
     */ InternalParticipants.prototype.deleteParticipant = function(id) {
        this.participants = this.participants.filter(function(p) {
            return p.id !== id;
        });
    };
    Object.defineProperty(InternalParticipants.prototype, "host", {
        /**
         * Helper to return the conversation host.
         */ get: function() {
            return this.participants.find(function(p) {
                return p.isHost === true;
            });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InternalParticipants.prototype, "me", {
        /**
         * Helper to return the current user.
         */ get: function() {
            return this.getParticipant(this.meId);
        },
        enumerable: false,
        configurable: true
    });
    return InternalParticipants;
}();
module.exports.InternalParticipants = $f3fbf63fe774a239$var$InternalParticipants;
/**
 * List of command message types
 */ module.exports.ConversationTranslatorMessageTypes = {
    command: "command",
    final: "final",
    info: "info",
    instantMessage: "instant_message",
    keepAlive: "keep_alive",
    partial: "partial",
    participantCommand: "participant_command",
    translatedMessage: "translated_message"
};
/**
 * List of command types
 */ module.exports.ConversationTranslatorCommandTypes = {
    changeNickname: "ChangeNickname",
    disconnectSession: "DisconnectSession",
    ejectParticipant: "EjectParticipant",
    instant_message: "instant_message",
    joinSession: "JoinSession",
    leaveSession: "LeaveSession",
    participantList: "ParticipantList",
    roomExpirationWarning: "RoomExpirationWarning",
    setLockState: "SetLockState",
    setMute: "SetMute",
    setMuteAll: "SetMuteAll",
    setProfanityFiltering: "SetProfanityFiltering",
    setTranslateToLanguages: "SetTranslateToLanguages",
    setUseTTS: "SetUseTTS"
};

});

parcelRequire.register("eIcxa", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $v8lZD = parcelRequire("v8lZD");
Object.defineProperty(module.exports, "CommandResponsePayload", {
    enumerable: true,
    get: function() {
        return $v8lZD.CommandResponsePayload;
    }
});

var $aAK8v = parcelRequire("aAK8v");
Object.defineProperty(module.exports, "ParticipantsListPayloadResponse", {
    enumerable: true,
    get: function() {
        return $aAK8v.ParticipantsListPayloadResponse;
    }
});
Object.defineProperty(module.exports, "ParticipantPayloadResponse", {
    enumerable: true,
    get: function() {
        return $aAK8v.ParticipantPayloadResponse;
    }
});

var $0ulck = parcelRequire("0ulck");
Object.defineProperty(module.exports, "SpeechResponsePayload", {
    enumerable: true,
    get: function() {
        return $0ulck.SpeechResponsePayload;
    }
});
Object.defineProperty(module.exports, "TextResponsePayload", {
    enumerable: true,
    get: function() {
        return $0ulck.TextResponsePayload;
    }
});

});
parcelRequire.register("v8lZD", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CommandResponsePayload = void 0;
var $05d9603de0bb7dd6$var$parseCommandResponse = function(json) {
    return JSON.parse(json);
};
var $05d9603de0bb7dd6$var$CommandResponsePayload = /** @class */ function() {
    function CommandResponsePayload(json) {
        this.privCommandResponse = $05d9603de0bb7dd6$var$parseCommandResponse(json);
    }
    Object.defineProperty(CommandResponsePayload.prototype, "type", {
        get: function() {
            return this.privCommandResponse.type;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CommandResponsePayload.prototype, "command", {
        get: function() {
            return this.privCommandResponse.command;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CommandResponsePayload.prototype, "id", {
        get: function() {
            return this.privCommandResponse.id;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CommandResponsePayload.prototype, "nickname", {
        get: function() {
            return this.privCommandResponse.nickname;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CommandResponsePayload.prototype, "participantId", {
        get: function() {
            return this.privCommandResponse.participantId;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CommandResponsePayload.prototype, "roomid", {
        get: function() {
            return this.privCommandResponse.roomid;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CommandResponsePayload.prototype, "value", {
        get: function() {
            return this.privCommandResponse.value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CommandResponsePayload.prototype, "token", {
        get: function() {
            return this.privCommandResponse.token;
        },
        enumerable: false,
        configurable: true
    });
    CommandResponsePayload.fromJSON = function(json) {
        return new CommandResponsePayload(json);
    };
    return CommandResponsePayload;
}();
module.exports.CommandResponsePayload = $05d9603de0bb7dd6$var$CommandResponsePayload;

});

parcelRequire.register("aAK8v", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ParticipantPayloadResponse = module.exports.ParticipantsListPayloadResponse = void 0;
var $7b610dd64f438401$var$parseListResponse = function(json) {
    return JSON.parse(json);
};
var $7b610dd64f438401$var$parseParticipantResponse = function(json) {
    return JSON.parse(json);
};
var $7b610dd64f438401$var$ParticipantsListPayloadResponse = /** @class */ function() {
    function ParticipantsListPayloadResponse(json) {
        this.privParticipantsPayloadResponse = $7b610dd64f438401$var$parseListResponse(json);
    }
    Object.defineProperty(ParticipantsListPayloadResponse.prototype, "roomid", {
        get: function() {
            return this.privParticipantsPayloadResponse.roomid;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ParticipantsListPayloadResponse.prototype, "id", {
        get: function() {
            return this.privParticipantsPayloadResponse.id;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ParticipantsListPayloadResponse.prototype, "command", {
        get: function() {
            return this.privParticipantsPayloadResponse.command;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ParticipantsListPayloadResponse.prototype, "participants", {
        get: function() {
            return this.privParticipantsPayloadResponse.participants;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ParticipantsListPayloadResponse.prototype, "token", {
        get: function() {
            return this.privParticipantsPayloadResponse.token;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ParticipantsListPayloadResponse.prototype, "translateTo", {
        get: function() {
            return this.privParticipantsPayloadResponse.translateTo;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ParticipantsListPayloadResponse.prototype, "profanityFilter", {
        get: function() {
            return this.privParticipantsPayloadResponse.profanityFilter;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ParticipantsListPayloadResponse.prototype, "roomProfanityFilter", {
        get: function() {
            return this.privParticipantsPayloadResponse.roomProfanityFilter;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ParticipantsListPayloadResponse.prototype, "roomLocked", {
        get: function() {
            return this.privParticipantsPayloadResponse.roomLocked;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ParticipantsListPayloadResponse.prototype, "muteAll", {
        get: function() {
            return this.privParticipantsPayloadResponse.muteAll;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ParticipantsListPayloadResponse.prototype, "type", {
        get: function() {
            return this.privParticipantsPayloadResponse.type;
        },
        enumerable: false,
        configurable: true
    });
    ParticipantsListPayloadResponse.fromJSON = function(json) {
        return new ParticipantsListPayloadResponse(json);
    };
    return ParticipantsListPayloadResponse;
}();
module.exports.ParticipantsListPayloadResponse = $7b610dd64f438401$var$ParticipantsListPayloadResponse;
var $7b610dd64f438401$var$ParticipantPayloadResponse = /** @class */ function() {
    function ParticipantPayloadResponse(json) {
        this.privParticipantPayloadResponse = $7b610dd64f438401$var$parseParticipantResponse(json);
    }
    Object.defineProperty(ParticipantPayloadResponse.prototype, "nickname", {
        get: function() {
            return this.privParticipantPayloadResponse.nickname;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ParticipantPayloadResponse.prototype, "locale", {
        get: function() {
            return this.privParticipantPayloadResponse.locale;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ParticipantPayloadResponse.prototype, "usetts", {
        get: function() {
            return this.privParticipantPayloadResponse.usetts;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ParticipantPayloadResponse.prototype, "ismuted", {
        get: function() {
            return this.privParticipantPayloadResponse.ismuted;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ParticipantPayloadResponse.prototype, "ishost", {
        get: function() {
            return this.privParticipantPayloadResponse.ishost;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ParticipantPayloadResponse.prototype, "participantId", {
        get: function() {
            return this.privParticipantPayloadResponse.participantId;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ParticipantPayloadResponse.prototype, "avatar", {
        get: function() {
            return this.privParticipantPayloadResponse.avatar;
        },
        enumerable: false,
        configurable: true
    });
    ParticipantPayloadResponse.fromJSON = function(json) {
        return new ParticipantPayloadResponse(json);
    };
    return ParticipantPayloadResponse;
}();
module.exports.ParticipantPayloadResponse = $7b610dd64f438401$var$ParticipantPayloadResponse;

});

parcelRequire.register("0ulck", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TextResponsePayload = module.exports.SpeechResponsePayload = void 0;
var $00178945de808c9f$var$parseSpeechResponse = function(json) {
    return JSON.parse(json);
};
var $00178945de808c9f$var$parseTextResponse = function(json) {
    return JSON.parse(json);
};
var $00178945de808c9f$var$SpeechResponsePayload = /** @class */ function() {
    function SpeechResponsePayload(json) {
        this.privSpeechResponse = $00178945de808c9f$var$parseSpeechResponse(json);
    }
    Object.defineProperty(SpeechResponsePayload.prototype, "recognition", {
        get: function() {
            return this.privSpeechResponse.recognition;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SpeechResponsePayload.prototype, "translations", {
        get: function() {
            return this.privSpeechResponse.translations;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SpeechResponsePayload.prototype, "id", {
        get: function() {
            return this.privSpeechResponse.id;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SpeechResponsePayload.prototype, "language", {
        get: function() {
            return this.privSpeechResponse.language;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SpeechResponsePayload.prototype, "nickname", {
        get: function() {
            return this.privSpeechResponse.nickname;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SpeechResponsePayload.prototype, "participantId", {
        get: function() {
            return this.privSpeechResponse.participantId;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SpeechResponsePayload.prototype, "roomid", {
        get: function() {
            return this.privSpeechResponse.roomid;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SpeechResponsePayload.prototype, "timestamp", {
        get: function() {
            return this.privSpeechResponse.timestamp;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SpeechResponsePayload.prototype, "type", {
        get: function() {
            return this.privSpeechResponse.type;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SpeechResponsePayload.prototype, "isFinal", {
        get: function() {
            return this.privSpeechResponse.type === "final";
        },
        enumerable: false,
        configurable: true
    });
    SpeechResponsePayload.fromJSON = function(json) {
        return new SpeechResponsePayload(json);
    };
    return SpeechResponsePayload;
}();
module.exports.SpeechResponsePayload = $00178945de808c9f$var$SpeechResponsePayload;
var $00178945de808c9f$var$TextResponsePayload = /** @class */ function() {
    function TextResponsePayload(json) {
        this.privTextResponse = $00178945de808c9f$var$parseTextResponse(json);
    }
    Object.defineProperty(TextResponsePayload.prototype, "originalText", {
        get: function() {
            return this.privTextResponse.originalText;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TextResponsePayload.prototype, "translations", {
        get: function() {
            return this.privTextResponse.translations;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TextResponsePayload.prototype, "id", {
        get: function() {
            return this.privTextResponse.id;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TextResponsePayload.prototype, "language", {
        get: function() {
            return this.privTextResponse.language;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TextResponsePayload.prototype, "nickname", {
        get: function() {
            return this.privTextResponse.nickname;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TextResponsePayload.prototype, "participantId", {
        get: function() {
            return this.privTextResponse.participantId;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TextResponsePayload.prototype, "roomid", {
        get: function() {
            return this.privTextResponse.roomid;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TextResponsePayload.prototype, "timestamp", {
        get: function() {
            return this.privTextResponse.timestamp;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TextResponsePayload.prototype, "type", {
        get: function() {
            return this.privTextResponse.type;
        },
        enumerable: false,
        configurable: true
    });
    TextResponsePayload.fromJSON = function(json) {
        return new TextResponsePayload(json);
    };
    return TextResponsePayload;
}();
module.exports.TextResponsePayload = $00178945de808c9f$var$TextResponsePayload;

});




parcelRequire.register("DiRch", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
var $0762453e81428502$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $0762453e81428502$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $0762453e81428502$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TranscriberRecognizer = void 0;

var $em8BD = parcelRequire("em8BD");

var $gBGZx = parcelRequire("gBGZx");

var $hM4QX = parcelRequire("hM4QX");

var $dEkJU = parcelRequire("dEkJU");
var $0762453e81428502$var$TranscriberRecognizer = /** @class */ function(_super) {
    $0762453e81428502$var$__extends(TranscriberRecognizer, _super);
    /**
     * TranscriberRecognizer constructor.
     * @constructor
     * @param {SpeechTranslationConfig} speechTranslationConfig - Non-audio configuration associated with the recognizer
     * @param {AudioConfig} audioConfig - An audio configuration associated with the recognizer
     */ function TranscriberRecognizer(speechTranslationConfig, audioConfig) {
        var _this = this;
        var speechTranslationConfigImpl = speechTranslationConfig;
        $gBGZx.Contracts.throwIfNull(speechTranslationConfigImpl, "speechTranslationConfig");
        var audioConfigImpl = audioConfig;
        $gBGZx.Contracts.throwIfNull(audioConfigImpl, "audioConfigImpl");
        $gBGZx.Contracts.throwIfNullOrWhitespace(speechTranslationConfigImpl.speechRecognitionLanguage, $hM4QX.PropertyId[$hM4QX.PropertyId.SpeechServiceConnection_RecoLanguage]);
        _this = _super.call(this, audioConfig, speechTranslationConfigImpl.properties, new $dEkJU.TranscriberConnectionFactory()) || this;
        _this.privDisposedRecognizer = false;
        return _this;
    }
    Object.defineProperty(TranscriberRecognizer.prototype, "speechRecognitionLanguage", {
        get: function() {
            $gBGZx.Contracts.throwIfDisposed(this.privDisposedRecognizer);
            return this.properties.getProperty($hM4QX.PropertyId.SpeechServiceConnection_RecoLanguage);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TranscriberRecognizer.prototype, "properties", {
        get: function() {
            return this.privProperties;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TranscriberRecognizer.prototype, "authorizationToken", {
        get: function() {
            return this.properties.getProperty($hM4QX.PropertyId.SpeechServiceAuthorization_Token);
        },
        set: function(token) {
            $gBGZx.Contracts.throwIfNullOrWhitespace(token, "token");
            this.properties.setProperty($hM4QX.PropertyId.SpeechServiceAuthorization_Token, token);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TranscriberRecognizer.prototype, "conversation", {
        set: function(c) {
            $gBGZx.Contracts.throwIfNullOrUndefined(c, "Conversation");
            this.privConversation = c;
        },
        enumerable: false,
        configurable: true
    });
    TranscriberRecognizer.prototype.getConversationInfo = function() {
        $gBGZx.Contracts.throwIfNullOrUndefined(this.privConversation, "Conversation");
        return this.privConversation.conversationInfo;
    };
    TranscriberRecognizer.prototype.startContinuousRecognitionAsync = function(cb, err) {
        $em8BD.marshalPromiseToCallbacks(this.startContinuousRecognitionAsyncImpl($dEkJU.RecognitionMode.Conversation), cb, err);
    };
    TranscriberRecognizer.prototype.stopContinuousRecognitionAsync = function(cb, err) {
        $em8BD.marshalPromiseToCallbacks(this.stopContinuousRecognitionAsyncImpl(), cb, err);
    };
    TranscriberRecognizer.prototype.close = function() {
        return $0762453e81428502$var$__awaiter(this, void 0, void 0, function() {
            return $0762453e81428502$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!!this.privDisposedRecognizer) return [
                            3 /*break*/ ,
                            2
                        ];
                        return [
                            4 /*yield*/ ,
                            this.dispose(true)
                        ];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    // Push async join/leave conversation message via serviceRecognizer
    TranscriberRecognizer.prototype.pushConversationEvent = function(conversationInfo, command) {
        return $0762453e81428502$var$__awaiter(this, void 0, void 0, function() {
            var reco;
            return $0762453e81428502$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        reco = this.privReco;
                        $gBGZx.Contracts.throwIfNullOrUndefined(reco, "serviceRecognizer");
                        return [
                            4 /*yield*/ ,
                            reco.sendSpeechEventAsync(conversationInfo, command)
                        ];
                    case 1:
                        _a.sent();
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    TranscriberRecognizer.prototype.enforceAudioGating = function() {
        return $0762453e81428502$var$__awaiter(this, void 0, void 0, function() {
            var audioConfigImpl, format, channels;
            return $0762453e81428502$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        audioConfigImpl = this.audioConfig;
                        return [
                            4 /*yield*/ ,
                            audioConfigImpl.format
                        ];
                    case 1:
                        format = _a.sent();
                        channels = format.channels;
                        if (channels === 1) {
                            if (this.properties.getProperty("f0f5debc-f8c9-4892-ac4b-90a7ab359fd2", "false").toLowerCase() !== "true") throw new Error("Single channel audio configuration for ConversationTranscriber is currently under private preview, please contact diarizationrequest@microsoft.com for more details");
                        } else if (channels !== 8) throw new Error("Unsupported audio configuration: Detected " + channels + "-channel audio");
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    TranscriberRecognizer.prototype.connectCallbacks = function(transcriber) {
        this.canceled = function(s, e) {
            if (!!transcriber.canceled) transcriber.canceled(transcriber, e);
        };
        this.recognizing = function(s, e) {
            if (!!transcriber.transcribing) transcriber.transcribing(transcriber, e);
        };
        this.recognized = function(s, e) {
            if (!!transcriber.transcribed) transcriber.transcribed(transcriber, e);
        };
        this.sessionStarted = function(s, e) {
            if (!!transcriber.sessionStarted) transcriber.sessionStarted(transcriber, e);
        };
        this.sessionStopped = function(s, e) {
            if (!!transcriber.sessionStopped) transcriber.sessionStopped(transcriber, e);
        };
    };
    TranscriberRecognizer.prototype.disconnectCallbacks = function() {
        this.canceled = undefined;
        this.recognizing = undefined;
        this.recognized = undefined;
        this.sessionStarted = undefined;
        this.sessionStopped = undefined;
    };
    /**
     * Disposes any resources held by the object.
     * @member ConversationTranscriber.prototype.dispose
     * @function
     * @public
     * @param {boolean} disposing - true if disposing the object.
     */ TranscriberRecognizer.prototype.dispose = function(disposing) {
        return $0762453e81428502$var$__awaiter(this, void 0, void 0, function() {
            return $0762453e81428502$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (this.privDisposedRecognizer) return [
                            2 /*return*/ 
                        ];
                        if (!disposing) return [
                            3 /*break*/ ,
                            2
                        ];
                        this.privDisposedRecognizer = true;
                        return [
                            4 /*yield*/ ,
                            this.implRecognizerStop()
                        ];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        return [
                            4 /*yield*/ ,
                            _super.prototype.dispose.call(this, disposing)
                        ];
                    case 3:
                        _a.sent();
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    TranscriberRecognizer.prototype.createRecognizerConfig = function(speechConfig) {
        return new $dEkJU.RecognizerConfig(speechConfig, this.properties);
    };
    TranscriberRecognizer.prototype.createServiceRecognizer = function(authentication, connectionFactory, audioConfig, recognizerConfig) {
        var configImpl = audioConfig;
        return new $dEkJU.TranscriptionServiceRecognizer(authentication, connectionFactory, configImpl, recognizerConfig, this);
    };
    return TranscriberRecognizer;
}($hM4QX.Recognizer);
module.exports.TranscriberRecognizer = $0762453e81428502$var$TranscriberRecognizer;

});


parcelRequire.register("3SSAZ", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SynthesisAudioMetadata = module.exports.MetadataType = void 0;
var $2d40c3cc4ffb966b$var$MetadataType;
(function(MetadataType) {
    MetadataType["WordBoundary"] = "WordBoundary";
    MetadataType["Bookmark"] = "Bookmark";
    MetadataType["Viseme"] = "Viseme";
    MetadataType["SentenceBoundary"] = "SentenceBoundary";
    MetadataType["SessionEnd"] = "SessionEnd";
})($2d40c3cc4ffb966b$var$MetadataType = module.exports.MetadataType || (module.exports.MetadataType = {}));
var $2d40c3cc4ffb966b$var$SynthesisAudioMetadata = /** @class */ function() {
    function SynthesisAudioMetadata(json) {
        this.privSynthesisAudioMetadata = JSON.parse(json);
    }
    SynthesisAudioMetadata.fromJSON = function(json) {
        return new SynthesisAudioMetadata(json);
    };
    Object.defineProperty(SynthesisAudioMetadata.prototype, "Metadata", {
        get: function() {
            return this.privSynthesisAudioMetadata.Metadata;
        },
        enumerable: false,
        configurable: true
    });
    return SynthesisAudioMetadata;
}();
module.exports.SynthesisAudioMetadata = $2d40c3cc4ffb966b$var$SynthesisAudioMetadata;

});

parcelRequire.register("5UJWy", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
var $44e5d223c49b3bb6$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $44e5d223c49b3bb6$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SynthesisTurn = void 0;

var $em8BD = parcelRequire("em8BD");

var $aBCur = parcelRequire("aBCur");

var $3SSAZ = parcelRequire("3SSAZ");

var $gilPA = parcelRequire("gilPA");

var $guyCE = parcelRequire("guyCE");
var $44e5d223c49b3bb6$var$SynthesisTurn = /** @class */ function() {
    function SynthesisTurn() {
        this.privIsDisposed = false;
        this.privIsSynthesizing = false;
        this.privIsSynthesisEnded = false;
        this.privBytesReceived = 0;
        this.privInTurn = false;
        this.privTextOffset = 0;
        this.privNextSearchTextIndex = 0;
        this.privSentenceOffset = 0;
        this.privNextSearchSentenceIndex = 0;
        this.privRequestId = $em8BD.createNoDashGuid();
        this.privTurnDeferral = new $em8BD.Deferred();
        // We're not in a turn, so resolve.
        this.privTurnDeferral.resolve();
    }
    Object.defineProperty(SynthesisTurn.prototype, "requestId", {
        get: function() {
            return this.privRequestId;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SynthesisTurn.prototype, "streamId", {
        get: function() {
            return this.privStreamId;
        },
        set: function(value) {
            this.privStreamId = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SynthesisTurn.prototype, "audioOutputFormat", {
        get: function() {
            return this.privAudioOutputFormat;
        },
        set: function(format) {
            this.privAudioOutputFormat = format;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SynthesisTurn.prototype, "turnCompletionPromise", {
        get: function() {
            return this.privTurnDeferral.promise;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SynthesisTurn.prototype, "isSynthesisEnded", {
        get: function() {
            return this.privIsSynthesisEnded;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SynthesisTurn.prototype, "isSynthesizing", {
        get: function() {
            return this.privIsSynthesizing;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SynthesisTurn.prototype, "currentTextOffset", {
        get: function() {
            return this.privTextOffset;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SynthesisTurn.prototype, "currentSentenceOffset", {
        get: function() {
            return this.privSentenceOffset;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SynthesisTurn.prototype, "bytesReceived", {
        // The number of bytes received for current turn
        get: function() {
            return this.privBytesReceived;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SynthesisTurn.prototype, "audioDuration", {
        get: function() {
            return this.privAudioDuration;
        },
        enumerable: false,
        configurable: true
    });
    SynthesisTurn.prototype.getAllReceivedAudio = function() {
        return $44e5d223c49b3bb6$var$__awaiter(this, void 0, void 0, function() {
            return $44e5d223c49b3bb6$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!!this.privReceivedAudio) return [
                            2 /*return*/ ,
                            Promise.resolve(this.privReceivedAudio)
                        ];
                        if (!this.privIsSynthesisEnded) return [
                            2 /*return*/ ,
                            null
                        ];
                        return [
                            4 /*yield*/ ,
                            this.readAllAudioFromStream()
                        ];
                    case 1:
                        _a.sent();
                        return [
                            2 /*return*/ ,
                            Promise.resolve(this.privReceivedAudio)
                        ];
                }
            });
        });
    };
    SynthesisTurn.prototype.getAllReceivedAudioWithHeader = function() {
        return $44e5d223c49b3bb6$var$__awaiter(this, void 0, void 0, function() {
            var audio;
            return $44e5d223c49b3bb6$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!!this.privReceivedAudioWithHeader) return [
                            2 /*return*/ ,
                            this.privReceivedAudioWithHeader
                        ];
                        if (!this.privIsSynthesisEnded) return [
                            2 /*return*/ ,
                            null
                        ];
                        if (!this.audioOutputFormat.hasHeader) return [
                            3 /*break*/ ,
                            2
                        ];
                        return [
                            4 /*yield*/ ,
                            this.getAllReceivedAudio()
                        ];
                    case 1:
                        audio = _a.sent();
                        this.privReceivedAudioWithHeader = $gilPA.SynthesisAdapterBase.addHeader(audio, this.audioOutputFormat);
                        return [
                            2 /*return*/ ,
                            this.privReceivedAudioWithHeader
                        ];
                    case 2:
                        return [
                            2 /*return*/ ,
                            this.getAllReceivedAudio()
                        ];
                }
            });
        });
    };
    SynthesisTurn.prototype.startNewSynthesis = function(requestId, rawText, isSSML, audioDestination) {
        this.privIsSynthesisEnded = false;
        this.privIsSynthesizing = true;
        this.privRequestId = requestId;
        this.privRawText = rawText;
        this.privIsSSML = isSSML;
        this.privAudioOutputStream = new $aBCur.PullAudioOutputStreamImpl();
        this.privAudioOutputStream.format = this.privAudioOutputFormat;
        this.privReceivedAudio = null;
        this.privReceivedAudioWithHeader = null;
        this.privBytesReceived = 0;
        this.privTextOffset = 0;
        this.privNextSearchTextIndex = 0;
        this.privSentenceOffset = 0;
        this.privNextSearchSentenceIndex = 0;
        this.privPartialVisemeAnimation = "";
        if (audioDestination !== undefined) {
            this.privTurnAudioDestination = audioDestination;
            this.privTurnAudioDestination.format = this.privAudioOutputFormat;
        }
        this.onEvent(new $guyCE.SynthesisTriggeredEvent(this.requestId, undefined, audioDestination === undefined ? undefined : audioDestination.id()));
    };
    SynthesisTurn.prototype.onPreConnectionStart = function(authFetchEventId) {
        this.privAuthFetchEventId = authFetchEventId;
        this.onEvent(new $guyCE.ConnectingToSynthesisServiceEvent(this.privRequestId, this.privAuthFetchEventId));
    };
    SynthesisTurn.prototype.onAuthCompleted = function(isError) {
        if (isError) this.onComplete();
    };
    SynthesisTurn.prototype.onConnectionEstablishCompleted = function(statusCode) {
        if (statusCode === 200) {
            this.onEvent(new $guyCE.SynthesisStartedEvent(this.requestId, this.privAuthFetchEventId));
            this.privBytesReceived = 0;
            return;
        } else if (statusCode === 403) this.onComplete();
    };
    SynthesisTurn.prototype.onServiceResponseMessage = function(responseJson) {
        var response = JSON.parse(responseJson);
        this.streamId = response.audio.streamId;
    };
    SynthesisTurn.prototype.onServiceTurnEndResponse = function() {
        this.privInTurn = false;
        this.privTurnDeferral.resolve();
        this.onComplete();
    };
    SynthesisTurn.prototype.onServiceTurnStartResponse = function() {
        if (!!this.privTurnDeferral && !!this.privInTurn) {
            // What? How are we starting a turn with another not done?
            this.privTurnDeferral.reject("Another turn started before current completed.");
            // Avoid UnhandledPromiseRejection if privTurnDeferral is not being awaited
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            this.privTurnDeferral.promise.then().catch(function() {});
        }
        this.privInTurn = true;
        this.privTurnDeferral = new $em8BD.Deferred();
    };
    SynthesisTurn.prototype.onAudioChunkReceived = function(data) {
        if (this.isSynthesizing) {
            this.privAudioOutputStream.write(data);
            this.privBytesReceived += data.byteLength;
            if (this.privTurnAudioDestination !== undefined) this.privTurnAudioDestination.write(data);
        }
    };
    SynthesisTurn.prototype.onTextBoundaryEvent = function(metadata) {
        this.updateTextOffset(metadata.Data.text.Text, metadata.Type);
    };
    SynthesisTurn.prototype.onVisemeMetadataReceived = function(metadata) {
        if (metadata.Data.AnimationChunk !== undefined) this.privPartialVisemeAnimation += metadata.Data.AnimationChunk;
    };
    SynthesisTurn.prototype.onSessionEnd = function(metadata) {
        this.privAudioDuration = metadata.Data.Offset;
    };
    SynthesisTurn.prototype.dispose = function() {
        if (!this.privIsDisposed) // we should have completed by now. If we did not its an unknown error.
        this.privIsDisposed = true;
    };
    SynthesisTurn.prototype.onStopSynthesizing = function() {
        this.onComplete();
    };
    /**
     * Gets the viseme animation string (merged from animation chunk), and clears the internal
     * partial animation.
     */ SynthesisTurn.prototype.getAndClearVisemeAnimation = function() {
        var animation = this.privPartialVisemeAnimation;
        this.privPartialVisemeAnimation = "";
        return animation;
    };
    SynthesisTurn.prototype.onEvent = function(event) {
        $em8BD.Events.instance.onEvent(event);
    };
    /**
     * Check if the text is an XML(SSML) tag
     * @param text
     * @private
     */ SynthesisTurn.isXmlTag = function(text) {
        return text.length >= 2 && text[0] === "<" && text[text.length - 1] === ">";
    };
    SynthesisTurn.prototype.updateTextOffset = function(text, type) {
        if (type === $3SSAZ.MetadataType.WordBoundary) {
            this.privTextOffset = this.privRawText.indexOf(text, this.privNextSearchTextIndex);
            if (this.privTextOffset >= 0) {
                this.privNextSearchTextIndex = this.privTextOffset + text.length;
                if (this.privIsSSML) {
                    if (this.withinXmlTag(this.privTextOffset) && !SynthesisTurn.isXmlTag(text)) this.updateTextOffset(text, type);
                }
            }
        } else {
            this.privSentenceOffset = this.privRawText.indexOf(text, this.privNextSearchSentenceIndex);
            if (this.privSentenceOffset >= 0) {
                this.privNextSearchSentenceIndex = this.privSentenceOffset + text.length;
                if (this.privIsSSML) {
                    if (this.withinXmlTag(this.privSentenceOffset) && !SynthesisTurn.isXmlTag(text)) this.updateTextOffset(text, type);
                }
            }
        }
    };
    SynthesisTurn.prototype.onComplete = function() {
        if (this.privIsSynthesizing) {
            this.privIsSynthesizing = false;
            this.privIsSynthesisEnded = true;
            this.privAudioOutputStream.close();
            this.privInTurn = false;
            if (this.privTurnAudioDestination !== undefined) {
                this.privTurnAudioDestination.close();
                this.privTurnAudioDestination = undefined;
            }
        }
    };
    SynthesisTurn.prototype.readAllAudioFromStream = function() {
        return $44e5d223c49b3bb6$var$__awaiter(this, void 0, void 0, function() {
            var e_1;
            return $44e5d223c49b3bb6$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!this.privIsSynthesisEnded) return [
                            3 /*break*/ ,
                            4
                        ];
                        this.privReceivedAudio = new ArrayBuffer(this.bytesReceived);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4 /*yield*/ ,
                            this.privAudioOutputStream.read(this.privReceivedAudio)
                        ];
                    case 2:
                        _a.sent();
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 3:
                        e_1 = _a.sent();
                        this.privReceivedAudio = new ArrayBuffer(0);
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * Check if current idx is in XML(SSML) tag
     * @param idx
     * @private
     */ SynthesisTurn.prototype.withinXmlTag = function(idx) {
        return this.privRawText.indexOf("<", idx + 1) > this.privRawText.indexOf(">", idx + 1);
    };
    return SynthesisTurn;
}();
module.exports.SynthesisTurn = $44e5d223c49b3bb6$var$SynthesisTurn;

});
parcelRequire.register("gilPA", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
var $bdcf42f712403f5e$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $bdcf42f712403f5e$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SynthesisAdapterBase = void 0;

var $em8BD = parcelRequire("em8BD");

var $hM4QX = parcelRequire("hM4QX");

var $dEkJU = parcelRequire("dEkJU");

var $bhJcv = parcelRequire("bhJcv");
var $bdcf42f712403f5e$var$SynthesisAdapterBase = /** @class */ function() {
    function SynthesisAdapterBase(authentication, connectionFactory, synthesizerConfig, speechSynthesizer, audioDestination) {
        var _this = this;
        this.speakOverride = undefined;
        this.receiveMessageOverride = undefined;
        this.connectImplOverride = undefined;
        this.configConnectionOverride = undefined;
        // A promise for a configured connection.
        // Do not consume directly, call fetchConnection instead.
        this.privConnectionConfigurationPromise = undefined;
        if (!authentication) throw new $em8BD.ArgumentNullError("authentication");
        if (!connectionFactory) throw new $em8BD.ArgumentNullError("connectionFactory");
        if (!synthesizerConfig) throw new $em8BD.ArgumentNullError("synthesizerConfig");
        this.privAuthentication = authentication;
        this.privConnectionFactory = connectionFactory;
        this.privSynthesizerConfig = synthesizerConfig;
        this.privIsDisposed = false;
        this.privSpeechSynthesizer = speechSynthesizer;
        this.privSessionAudioDestination = audioDestination;
        this.privSynthesisTurn = new $dEkJU.SynthesisTurn();
        this.privConnectionEvents = new $em8BD.EventSource();
        this.privServiceEvents = new $em8BD.EventSource();
        this.privSynthesisContext = new $dEkJU.SynthesisContext(this.privSpeechSynthesizer);
        this.privAgentConfig = new $dEkJU.AgentConfig();
        this.connectionEvents.attach(function(connectionEvent) {
            if (connectionEvent.name === "ConnectionClosedEvent") {
                var connectionClosedEvent = connectionEvent;
                if (connectionClosedEvent.statusCode !== 1000) _this.cancelSynthesisLocal($hM4QX.CancellationReason.Error, connectionClosedEvent.statusCode === 1007 ? $hM4QX.CancellationErrorCode.BadRequestParameters : $hM4QX.CancellationErrorCode.ConnectionFailure, connectionClosedEvent.reason + " websocket error code: " + connectionClosedEvent.statusCode);
            }
        });
    }
    Object.defineProperty(SynthesisAdapterBase.prototype, "synthesisContext", {
        get: function() {
            return this.privSynthesisContext;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SynthesisAdapterBase.prototype, "agentConfig", {
        get: function() {
            return this.privAgentConfig;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SynthesisAdapterBase.prototype, "connectionEvents", {
        get: function() {
            return this.privConnectionEvents;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SynthesisAdapterBase.prototype, "serviceEvents", {
        get: function() {
            return this.privServiceEvents;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SynthesisAdapterBase.prototype, "activityTemplate", {
        get: function() {
            return this.privActivityTemplate;
        },
        set: function(messagePayload) {
            this.privActivityTemplate = messagePayload;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SynthesisAdapterBase.prototype, "audioOutputFormat", {
        set: function(format) {
            this.privAudioOutputFormat = format;
            this.privSynthesisTurn.audioOutputFormat = format;
            if (this.privSessionAudioDestination !== undefined) this.privSessionAudioDestination.format = format;
            if (this.synthesisContext !== undefined) this.synthesisContext.audioOutputFormat = format;
        },
        enumerable: false,
        configurable: true
    });
    SynthesisAdapterBase.addHeader = function(audio, format) {
        if (!format.hasHeader) return audio;
        format.updateHeader(audio.byteLength);
        var tmp = new Uint8Array(audio.byteLength + format.header.byteLength);
        tmp.set(new Uint8Array(format.header), 0);
        tmp.set(new Uint8Array(audio), format.header.byteLength);
        return tmp.buffer;
    };
    SynthesisAdapterBase.prototype.isDisposed = function() {
        return this.privIsDisposed;
    };
    SynthesisAdapterBase.prototype.dispose = function(reason) {
        return $bdcf42f712403f5e$var$__awaiter(this, void 0, void 0, function() {
            var connection;
            return $bdcf42f712403f5e$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        this.privIsDisposed = true;
                        if (this.privSessionAudioDestination !== undefined) this.privSessionAudioDestination.close();
                        if (!(this.privConnectionConfigurationPromise !== undefined)) return [
                            3 /*break*/ ,
                            3
                        ];
                        return [
                            4 /*yield*/ ,
                            this.privConnectionConfigurationPromise
                        ];
                    case 1:
                        connection = _a.sent();
                        return [
                            4 /*yield*/ ,
                            connection.dispose(reason)
                        ];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    SynthesisAdapterBase.prototype.connect = function() {
        return $bdcf42f712403f5e$var$__awaiter(this, void 0, void 0, function() {
            return $bdcf42f712403f5e$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.connectImpl()
                        ];
                    case 1:
                        _a.sent();
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    SynthesisAdapterBase.prototype.sendNetworkMessage = function(path, payload) {
        return $bdcf42f712403f5e$var$__awaiter(this, void 0, void 0, function() {
            var type, contentType, connection;
            return $bdcf42f712403f5e$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        type = typeof payload === "string" ? $em8BD.MessageType.Text : $em8BD.MessageType.Binary;
                        contentType = typeof payload === "string" ? "application/json" : "";
                        return [
                            4 /*yield*/ ,
                            this.fetchConnection()
                        ];
                    case 1:
                        connection = _a.sent();
                        return [
                            2 /*return*/ ,
                            connection.send(new $bhJcv.SpeechConnectionMessage(type, path, this.privSynthesisTurn.requestId, contentType, payload))
                        ];
                }
            });
        });
    };
    SynthesisAdapterBase.prototype.Speak = function(text, isSSML, requestId, successCallback, errorCallBack, audioDestination) {
        return $bdcf42f712403f5e$var$__awaiter(this, void 0, void 0, function() {
            var ssml, connection, synthesisStartEventArgs, e_1;
            return $bdcf42f712403f5e$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (isSSML) ssml = text;
                        else ssml = this.privSpeechSynthesizer.buildSsml(text);
                        if (this.speakOverride !== undefined) return [
                            2 /*return*/ ,
                            this.speakOverride(ssml, requestId, successCallback, errorCallBack)
                        ];
                        this.privSuccessCallback = successCallback;
                        this.privErrorCallback = errorCallBack;
                        this.privSynthesisTurn.startNewSynthesis(requestId, text, isSSML, audioDestination);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([
                            1,
                            6,
                            ,
                            7
                        ]);
                        return [
                            4 /*yield*/ ,
                            this.connectImpl()
                        ];
                    case 2:
                        _a.sent();
                        return [
                            4 /*yield*/ ,
                            this.fetchConnection()
                        ];
                    case 3:
                        connection = _a.sent();
                        return [
                            4 /*yield*/ ,
                            this.sendSynthesisContext(connection)
                        ];
                    case 4:
                        _a.sent();
                        return [
                            4 /*yield*/ ,
                            this.sendSsmlMessage(connection, ssml, requestId)
                        ];
                    case 5:
                        _a.sent();
                        synthesisStartEventArgs = new $hM4QX.SpeechSynthesisEventArgs(new $hM4QX.SpeechSynthesisResult(requestId, $hM4QX.ResultReason.SynthesizingAudioStarted));
                        if (!!this.privSpeechSynthesizer.synthesisStarted) this.privSpeechSynthesizer.synthesisStarted(this.privSpeechSynthesizer, synthesisStartEventArgs);
                        this.receiveMessage();
                        return [
                            3 /*break*/ ,
                            7
                        ];
                    case 6:
                        e_1 = _a.sent();
                        this.cancelSynthesisLocal($hM4QX.CancellationReason.Error, $hM4QX.CancellationErrorCode.ConnectionFailure, e_1);
                        return [
                            2 /*return*/ ,
                            Promise.reject(e_1)
                        ];
                    case 7:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    // Cancels synthesis.
    SynthesisAdapterBase.prototype.cancelSynthesis = function(requestId, cancellationReason, errorCode, error) {
        var properties = new $hM4QX.PropertyCollection();
        properties.setProperty($dEkJU.CancellationErrorCodePropertyName, $hM4QX.CancellationErrorCode[errorCode]);
        var result = new $hM4QX.SpeechSynthesisResult(requestId, $hM4QX.ResultReason.Canceled, undefined, error, properties);
        if (!!this.privSpeechSynthesizer.SynthesisCanceled) {
            var cancelEvent = new $hM4QX.SpeechSynthesisEventArgs(result);
            try {
                this.privSpeechSynthesizer.SynthesisCanceled(this.privSpeechSynthesizer, cancelEvent);
            /* eslint-disable no-empty */ } catch (_a) {}
        }
        if (!!this.privSuccessCallback) try {
            this.privSuccessCallback(result);
        /* eslint-disable no-empty */ } catch (_b) {}
    };
    // Cancels synthesis.
    SynthesisAdapterBase.prototype.cancelSynthesisLocal = function(cancellationReason, errorCode, error) {
        if (!!this.privSynthesisTurn.isSynthesizing) {
            this.privSynthesisTurn.onStopSynthesizing();
            this.cancelSynthesis(this.privSynthesisTurn.requestId, cancellationReason, errorCode, error);
        }
    };
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    SynthesisAdapterBase.prototype.processTypeSpecificMessages = function(connectionMessage) {
        return true;
    };
    SynthesisAdapterBase.prototype.receiveMessage = function() {
        return $bdcf42f712403f5e$var$__awaiter(this, void 0, void 0, function() {
            var connection, message, connectionMessage, _a, audioWithHeader, ev, metadataList, _i, metadataList_1, metadata, wordBoundaryEventArgs, bookmarkEventArgs, visemeEventArgs, result, audioBuffer, error_1, e_2;
            return $bdcf42f712403f5e$var$__generator(this, function(_b) {
                switch(_b.label){
                    case 0:
                        _b.trys.push([
                            0,
                            14,
                            ,
                            15
                        ]);
                        return [
                            4 /*yield*/ ,
                            this.fetchConnection()
                        ];
                    case 1:
                        connection = _b.sent();
                        return [
                            4 /*yield*/ ,
                            connection.read()
                        ];
                    case 2:
                        message = _b.sent();
                        if (this.receiveMessageOverride !== undefined) return [
                            2 /*return*/ ,
                            this.receiveMessageOverride()
                        ];
                        if (this.privIsDisposed) // We're done.
                        return [
                            2 /*return*/ 
                        ];
                        // indicates we are draining the queue and it came with no message;
                        if (!message) {
                            if (!this.privSynthesisTurn.isSynthesizing) return [
                                2 /*return*/ 
                            ];
                            else return [
                                2 /*return*/ ,
                                this.receiveMessage()
                            ];
                        }
                        connectionMessage = $bhJcv.SpeechConnectionMessage.fromConnectionMessage(message);
                        if (!(connectionMessage.requestId.toLowerCase() === this.privSynthesisTurn.requestId.toLowerCase())) return [
                            3 /*break*/ ,
                            13
                        ];
                        _a = connectionMessage.path.toLowerCase();
                        switch(_a){
                            case "turn.start":
                                return [
                                    3 /*break*/ ,
                                    3
                                ];
                            case "response":
                                return [
                                    3 /*break*/ ,
                                    4
                                ];
                            case "audio":
                                return [
                                    3 /*break*/ ,
                                    5
                                ];
                            case "audio.metadata":
                                return [
                                    3 /*break*/ ,
                                    6
                                ];
                            case "turn.end":
                                return [
                                    3 /*break*/ ,
                                    7
                                ];
                        }
                        return [
                            3 /*break*/ ,
                            12
                        ];
                    case 3:
                        this.privSynthesisTurn.onServiceTurnStartResponse();
                        return [
                            3 /*break*/ ,
                            13
                        ];
                    case 4:
                        this.privSynthesisTurn.onServiceResponseMessage(connectionMessage.textBody);
                        return [
                            3 /*break*/ ,
                            13
                        ];
                    case 5:
                        if (this.privSynthesisTurn.streamId.toLowerCase() === connectionMessage.streamId.toLowerCase() && !!connectionMessage.binaryBody) {
                            this.privSynthesisTurn.onAudioChunkReceived(connectionMessage.binaryBody);
                            if (!!this.privSpeechSynthesizer.synthesizing) try {
                                audioWithHeader = SynthesisAdapterBase.addHeader(connectionMessage.binaryBody, this.privSynthesisTurn.audioOutputFormat);
                                ev = new $hM4QX.SpeechSynthesisEventArgs(new $hM4QX.SpeechSynthesisResult(this.privSynthesisTurn.requestId, $hM4QX.ResultReason.SynthesizingAudio, audioWithHeader));
                                this.privSpeechSynthesizer.synthesizing(this.privSpeechSynthesizer, ev);
                            } catch (error) {
                            // Not going to let errors in the event handler
                            // trip things up.
                            }
                            if (this.privSessionAudioDestination !== undefined) this.privSessionAudioDestination.write(connectionMessage.binaryBody);
                        }
                        return [
                            3 /*break*/ ,
                            13
                        ];
                    case 6:
                        metadataList = $dEkJU.SynthesisAudioMetadata.fromJSON(connectionMessage.textBody).Metadata;
                        for(_i = 0, metadataList_1 = metadataList; _i < metadataList_1.length; _i++){
                            metadata = metadataList_1[_i];
                            switch(metadata.Type){
                                case $dEkJU.MetadataType.WordBoundary:
                                case $dEkJU.MetadataType.SentenceBoundary:
                                    this.privSynthesisTurn.onTextBoundaryEvent(metadata);
                                    wordBoundaryEventArgs = new $hM4QX.SpeechSynthesisWordBoundaryEventArgs(metadata.Data.Offset, metadata.Data.Duration, metadata.Data.text.Text, metadata.Data.text.Length, metadata.Type === $dEkJU.MetadataType.WordBoundary ? this.privSynthesisTurn.currentTextOffset : this.privSynthesisTurn.currentSentenceOffset, metadata.Data.text.BoundaryType);
                                    if (!!this.privSpeechSynthesizer.wordBoundary) try {
                                        this.privSpeechSynthesizer.wordBoundary(this.privSpeechSynthesizer, wordBoundaryEventArgs);
                                    } catch (error) {
                                    // Not going to let errors in the event handler
                                    // trip things up.
                                    }
                                    break;
                                case $dEkJU.MetadataType.Bookmark:
                                    bookmarkEventArgs = new $hM4QX.SpeechSynthesisBookmarkEventArgs(metadata.Data.Offset, metadata.Data.Bookmark);
                                    if (!!this.privSpeechSynthesizer.bookmarkReached) try {
                                        this.privSpeechSynthesizer.bookmarkReached(this.privSpeechSynthesizer, bookmarkEventArgs);
                                    } catch (error) {
                                    // Not going to let errors in the event handler
                                    // trip things up.
                                    }
                                    break;
                                case $dEkJU.MetadataType.Viseme:
                                    this.privSynthesisTurn.onVisemeMetadataReceived(metadata);
                                    if (metadata.Data.IsLastAnimation) {
                                        visemeEventArgs = new $hM4QX.SpeechSynthesisVisemeEventArgs(metadata.Data.Offset, metadata.Data.VisemeId, this.privSynthesisTurn.getAndClearVisemeAnimation());
                                        if (!!this.privSpeechSynthesizer.visemeReceived) try {
                                            this.privSpeechSynthesizer.visemeReceived(this.privSpeechSynthesizer, visemeEventArgs);
                                        } catch (error) {
                                        // Not going to let errors in the event handler
                                        // trip things up.
                                        }
                                    }
                                    break;
                                case $dEkJU.MetadataType.SessionEnd:
                                    this.privSynthesisTurn.onSessionEnd(metadata);
                                    break;
                            }
                        }
                        return [
                            3 /*break*/ ,
                            13
                        ];
                    case 7:
                        this.privSynthesisTurn.onServiceTurnEndResponse();
                        result = void 0;
                        _b.label = 8;
                    case 8:
                        _b.trys.push([
                            8,
                            10,
                            ,
                            11
                        ]);
                        return [
                            4 /*yield*/ ,
                            this.privSynthesisTurn.getAllReceivedAudioWithHeader()
                        ];
                    case 9:
                        audioBuffer = _b.sent();
                        result = new $hM4QX.SpeechSynthesisResult(this.privSynthesisTurn.requestId, $hM4QX.ResultReason.SynthesizingAudioCompleted, audioBuffer, undefined, undefined, this.privSynthesisTurn.audioDuration);
                        if (!!this.privSuccessCallback) this.privSuccessCallback(result);
                        return [
                            3 /*break*/ ,
                            11
                        ];
                    case 10:
                        error_1 = _b.sent();
                        if (!!this.privErrorCallback) this.privErrorCallback(error_1);
                        return [
                            3 /*break*/ ,
                            11
                        ];
                    case 11:
                        if (this.privSpeechSynthesizer.synthesisCompleted) try {
                            this.privSpeechSynthesizer.synthesisCompleted(this.privSpeechSynthesizer, new $hM4QX.SpeechSynthesisEventArgs(result));
                        } catch (e) {
                        // Not going to let errors in the event handler
                        // trip things up.
                        }
                        return [
                            3 /*break*/ ,
                            13
                        ];
                    case 12:
                        if (!this.processTypeSpecificMessages(connectionMessage)) // here are some messages that the derived class has not processed, dispatch them to connect class
                        {
                            if (!!this.privServiceEvents) this.serviceEvents.onEvent(new $em8BD.ServiceEvent(connectionMessage.path.toLowerCase(), connectionMessage.textBody));
                        }
                        _b.label = 13;
                    case 13:
                        return [
                            2 /*return*/ ,
                            this.receiveMessage()
                        ];
                    case 14:
                        e_2 = _b.sent();
                        return [
                            3 /*break*/ ,
                            15
                        ];
                    case 15:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    SynthesisAdapterBase.prototype.sendSynthesisContext = function(connection) {
        var synthesisContextJson = this.synthesisContext.toJSON();
        if (synthesisContextJson) return connection.send(new $bhJcv.SpeechConnectionMessage($em8BD.MessageType.Text, "synthesis.context", this.privSynthesisTurn.requestId, "application/json", synthesisContextJson));
        return;
    };
    SynthesisAdapterBase.prototype.connectImpl = function(isUnAuthorized) {
        var _this = this;
        if (isUnAuthorized === void 0) isUnAuthorized = false;
        if (this.privConnectionPromise != null) return this.privConnectionPromise.then(function(connection) {
            if (connection.state() === $em8BD.ConnectionState.Disconnected) {
                _this.privConnectionId = null;
                _this.privConnectionPromise = null;
                return _this.connectImpl();
            }
            return _this.privConnectionPromise;
        }, function() {
            _this.privConnectionId = null;
            _this.privConnectionPromise = null;
            return _this.connectImpl();
        });
        this.privAuthFetchEventId = $em8BD.createNoDashGuid();
        this.privConnectionId = $em8BD.createNoDashGuid();
        this.privSynthesisTurn.onPreConnectionStart(this.privAuthFetchEventId);
        var authPromise = isUnAuthorized ? this.privAuthentication.fetchOnExpiry(this.privAuthFetchEventId) : this.privAuthentication.fetch(this.privAuthFetchEventId);
        this.privConnectionPromise = authPromise.then(function(result) {
            return $bdcf42f712403f5e$var$__awaiter(_this, void 0, void 0, function() {
                var connection, response;
                var _this = this;
                return $bdcf42f712403f5e$var$__generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            this.privSynthesisTurn.onAuthCompleted(false);
                            connection = this.privConnectionFactory.create(this.privSynthesizerConfig, result, this.privConnectionId);
                            // Attach to the underlying event. No need to hold onto the detach pointers as in the event the connection goes away,
                            // it'll stop sending events.
                            connection.events.attach(function(event) {
                                _this.connectionEvents.onEvent(event);
                            });
                            return [
                                4 /*yield*/ ,
                                connection.open()
                            ];
                        case 1:
                            response = _a.sent();
                            if (response.statusCode === 200) {
                                this.privSynthesisTurn.onConnectionEstablishCompleted(response.statusCode);
                                return [
                                    2 /*return*/ ,
                                    Promise.resolve(connection)
                                ];
                            } else if (response.statusCode === 403 && !isUnAuthorized) return [
                                2 /*return*/ ,
                                this.connectImpl(true)
                            ];
                            else {
                                this.privSynthesisTurn.onConnectionEstablishCompleted(response.statusCode);
                                return [
                                    2 /*return*/ ,
                                    Promise.reject("Unable to contact server. StatusCode: " + response.statusCode + ", " + this.privSynthesizerConfig.parameters.getProperty($hM4QX.PropertyId.SpeechServiceConnection_Endpoint) + " Reason: " + response.reason)
                                ];
                            }
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        }, function(error) {
            _this.privSynthesisTurn.onAuthCompleted(true);
            throw new Error(error);
        });
        // Attach an empty handler to allow the promise to run in the background while
        // other startup events happen. It'll eventually be awaited on.
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        this.privConnectionPromise.catch(function() {});
        return this.privConnectionPromise;
    };
    SynthesisAdapterBase.prototype.sendSpeechServiceConfig = function(connection, SpeechServiceConfigJson) {
        if (SpeechServiceConfigJson) return connection.send(new $bhJcv.SpeechConnectionMessage($em8BD.MessageType.Text, "speech.config", this.privSynthesisTurn.requestId, "application/json", SpeechServiceConfigJson));
    };
    SynthesisAdapterBase.prototype.sendSsmlMessage = function(connection, ssml, requestId) {
        return connection.send(new $bhJcv.SpeechConnectionMessage($em8BD.MessageType.Text, "ssml", requestId, "application/ssml+xml", ssml));
    };
    SynthesisAdapterBase.prototype.fetchConnection = function() {
        return $bdcf42f712403f5e$var$__awaiter(this, void 0, void 0, function() {
            var _this = this;
            return $bdcf42f712403f5e$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (this.privConnectionConfigurationPromise !== undefined) return [
                            2 /*return*/ ,
                            this.privConnectionConfigurationPromise.then(function(connection) {
                                if (connection.state() === $em8BD.ConnectionState.Disconnected) {
                                    _this.privConnectionId = null;
                                    _this.privConnectionConfigurationPromise = undefined;
                                    return _this.fetchConnection();
                                }
                                return _this.privConnectionConfigurationPromise;
                            }, function() {
                                _this.privConnectionId = null;
                                _this.privConnectionConfigurationPromise = undefined;
                                return _this.fetchConnection();
                            })
                        ];
                        this.privConnectionConfigurationPromise = this.configureConnection();
                        return [
                            4 /*yield*/ ,
                            this.privConnectionConfigurationPromise
                        ];
                    case 1:
                        return [
                            2 /*return*/ ,
                            _a.sent()
                        ];
                }
            });
        });
    };
    // Takes an established websocket connection to the endpoint and sends speech configuration information.
    SynthesisAdapterBase.prototype.configureConnection = function() {
        return $bdcf42f712403f5e$var$__awaiter(this, void 0, void 0, function() {
            var connection;
            return $bdcf42f712403f5e$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.connectImpl()
                        ];
                    case 1:
                        connection = _a.sent();
                        if (this.configConnectionOverride !== undefined) return [
                            2 /*return*/ ,
                            this.configConnectionOverride(connection)
                        ];
                        return [
                            4 /*yield*/ ,
                            this.sendSpeechServiceConfig(connection, this.privSynthesizerConfig.SpeechServiceConfig.serialize())
                        ];
                    case 2:
                        _a.sent();
                        return [
                            2 /*return*/ ,
                            connection
                        ];
                }
            });
        });
    };
    SynthesisAdapterBase.telemetryDataEnabled = true;
    return SynthesisAdapterBase;
}();
module.exports.SynthesisAdapterBase = $bdcf42f712403f5e$var$SynthesisAdapterBase;

});

parcelRequire.register("guyCE", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
var $031932ce4020221c$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SynthesisStartedEvent = module.exports.ConnectingToSynthesisServiceEvent = module.exports.SynthesisTriggeredEvent = module.exports.SpeechSynthesisEvent = void 0;

var $em8BD = parcelRequire("em8BD");
var $031932ce4020221c$var$SpeechSynthesisEvent = /** @class */ function(_super) {
    $031932ce4020221c$var$__extends(SpeechSynthesisEvent, _super);
    function SpeechSynthesisEvent(eventName, requestId, eventType) {
        if (eventType === void 0) eventType = $em8BD.EventType.Info;
        var _this = _super.call(this, eventName, eventType) || this;
        _this.privRequestId = requestId;
        return _this;
    }
    Object.defineProperty(SpeechSynthesisEvent.prototype, "requestId", {
        get: function() {
            return this.privRequestId;
        },
        enumerable: false,
        configurable: true
    });
    return SpeechSynthesisEvent;
}($em8BD.PlatformEvent);
module.exports.SpeechSynthesisEvent = $031932ce4020221c$var$SpeechSynthesisEvent;
var $031932ce4020221c$var$SynthesisTriggeredEvent = /** @class */ function(_super) {
    $031932ce4020221c$var$__extends(SynthesisTriggeredEvent, _super);
    function SynthesisTriggeredEvent(requestId, sessionAudioDestinationId, turnAudioDestinationId) {
        var _this = _super.call(this, "SynthesisTriggeredEvent", requestId) || this;
        _this.privSessionAudioDestinationId = sessionAudioDestinationId;
        _this.privTurnAudioDestinationId = turnAudioDestinationId;
        return _this;
    }
    Object.defineProperty(SynthesisTriggeredEvent.prototype, "audioSessionDestinationId", {
        get: function() {
            return this.privSessionAudioDestinationId;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SynthesisTriggeredEvent.prototype, "audioTurnDestinationId", {
        get: function() {
            return this.privTurnAudioDestinationId;
        },
        enumerable: false,
        configurable: true
    });
    return SynthesisTriggeredEvent;
}($031932ce4020221c$var$SpeechSynthesisEvent);
module.exports.SynthesisTriggeredEvent = $031932ce4020221c$var$SynthesisTriggeredEvent;
var $031932ce4020221c$var$ConnectingToSynthesisServiceEvent = /** @class */ function(_super) {
    $031932ce4020221c$var$__extends(ConnectingToSynthesisServiceEvent, _super);
    function ConnectingToSynthesisServiceEvent(requestId, authFetchEventId) {
        var _this = _super.call(this, "ConnectingToSynthesisServiceEvent", requestId) || this;
        _this.privAuthFetchEventId = authFetchEventId;
        return _this;
    }
    Object.defineProperty(ConnectingToSynthesisServiceEvent.prototype, "authFetchEventId", {
        get: function() {
            return this.privAuthFetchEventId;
        },
        enumerable: false,
        configurable: true
    });
    return ConnectingToSynthesisServiceEvent;
}($031932ce4020221c$var$SpeechSynthesisEvent);
module.exports.ConnectingToSynthesisServiceEvent = $031932ce4020221c$var$ConnectingToSynthesisServiceEvent;
var $031932ce4020221c$var$SynthesisStartedEvent = /** @class */ function(_super) {
    $031932ce4020221c$var$__extends(SynthesisStartedEvent, _super);
    function SynthesisStartedEvent(requestId, authFetchEventId) {
        var _this = _super.call(this, "SynthesisStartedEvent", requestId) || this;
        _this.privAuthFetchEventId = authFetchEventId;
        return _this;
    }
    Object.defineProperty(SynthesisStartedEvent.prototype, "authFetchEventId", {
        get: function() {
            return this.privAuthFetchEventId;
        },
        enumerable: false,
        configurable: true
    });
    return SynthesisStartedEvent;
}($031932ce4020221c$var$SpeechSynthesisEvent);
module.exports.SynthesisStartedEvent = $031932ce4020221c$var$SynthesisStartedEvent;

});


parcelRequire.register("3l6i6", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SynthesisRestAdapter = void 0;

var $j1V0D = parcelRequire("j1V0D");

var $hM4QX = parcelRequire("hM4QX");

var $hGMva = parcelRequire("hGMva");

var $btbfh = parcelRequire("btbfh");
/**
 * Implements methods for speaker recognition classes, sending requests to endpoint
 * and parsing response into expected format
 * @class SynthesisRestAdapter
 */ var $26e836840b0c86df$var$SynthesisRestAdapter = /** @class */ function() {
    function SynthesisRestAdapter(config, authentication) {
        var endpoint = config.parameters.getProperty($hM4QX.PropertyId.SpeechServiceConnection_Endpoint, undefined);
        if (!endpoint) {
            var region = config.parameters.getProperty($hM4QX.PropertyId.SpeechServiceConnection_Region, "westus");
            var hostSuffix = $hGMva.ConnectionFactoryBase.getHostSuffix(region);
            endpoint = config.parameters.getProperty($hM4QX.PropertyId.SpeechServiceConnection_Host, "https://" + region + ".tts.speech" + hostSuffix);
        }
        this.privUri = endpoint + "/cognitiveservices/voices/list";
        var options = $j1V0D.RestConfigBase.requestOptions;
        this.privRestAdapter = new $j1V0D.RestMessageAdapter(options);
        this.privAuthentication = authentication;
    }
    /**
     * Sends list voices request to endpoint.
     * @function
     * @public
     * @param connectionId - guid for connectionId
     * @returns {Promise<IRestResponse>} rest response to status request
     */ SynthesisRestAdapter.prototype.getVoicesList = function(connectionId) {
        var _this = this;
        this.privRestAdapter.setHeaders($btbfh.HeaderNames.ConnectionId, connectionId);
        return this.privAuthentication.fetch(connectionId).then(function(authInfo) {
            _this.privRestAdapter.setHeaders(authInfo.headerName, authInfo.token);
            return _this.privRestAdapter.request($j1V0D.RestRequestType.Get, _this.privUri);
        });
    };
    return SynthesisRestAdapter;
}();
module.exports.SynthesisRestAdapter = $26e836840b0c86df$var$SynthesisRestAdapter;

});

parcelRequire.register("9A8d8", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SynthesizerConfig = module.exports.SynthesisServiceType = void 0;

var $dEkJU = parcelRequire("dEkJU");
var $6f9dd85f0aa9a987$var$SynthesisServiceType;
(function(SynthesisServiceType) {
    SynthesisServiceType[SynthesisServiceType["Standard"] = 0] = "Standard";
    SynthesisServiceType[SynthesisServiceType["Custom"] = 1] = "Custom";
})($6f9dd85f0aa9a987$var$SynthesisServiceType = module.exports.SynthesisServiceType || (module.exports.SynthesisServiceType = {}));
var $6f9dd85f0aa9a987$var$SynthesizerConfig = /** @class */ function() {
    function SynthesizerConfig(speechServiceConfig, parameters) {
        this.privSynthesisServiceType = $6f9dd85f0aa9a987$var$SynthesisServiceType.Standard;
        this.privSpeechServiceConfig = speechServiceConfig ? speechServiceConfig : new $dEkJU.SpeechServiceConfig(new $dEkJU.Context(null));
        this.privParameters = parameters;
    }
    Object.defineProperty(SynthesizerConfig.prototype, "parameters", {
        get: function() {
            return this.privParameters;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SynthesizerConfig.prototype, "synthesisServiceType", {
        get: function() {
            return this.privSynthesisServiceType;
        },
        set: function(value) {
            this.privSynthesisServiceType = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SynthesizerConfig.prototype, "SpeechServiceConfig", {
        get: function() {
            return this.privSpeechServiceConfig;
        },
        enumerable: false,
        configurable: true
    });
    return SynthesizerConfig;
}();
module.exports.SynthesizerConfig = $6f9dd85f0aa9a987$var$SynthesizerConfig;

});

parcelRequire.register("7EOsZ", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SynthesisContext = void 0;

var $hM4QX = parcelRequire("hM4QX");
/**
 * Represents the JSON used in the synthesis.context message sent to the speech service.
 * The dynamic grammar is always refreshed from the encapsulated dynamic grammar object.
 */ var $59336a714abea9eb$var$SynthesisContext = /** @class */ function() {
    function SynthesisContext(speechSynthesizer) {
        this.privContext = {};
        this.privSpeechSynthesizer = speechSynthesizer;
    }
    /**
     * Adds a section to the synthesis.context object.
     * @param sectionName Name of the section to add.
     * @param value JSON serializable object that represents the value.
     */ SynthesisContext.prototype.setSection = function(sectionName, value) {
        this.privContext[sectionName] = value;
    };
    Object.defineProperty(SynthesisContext.prototype, "audioOutputFormat", {
        /**
         * Sets the audio output format for synthesis context generation.
         * @param format {AudioOutputFormatImpl} the output format
         */ set: function(format) {
            this.privAudioOutputFormat = format;
        },
        enumerable: false,
        configurable: true
    });
    SynthesisContext.prototype.toJSON = function() {
        var synthesisSection = this.buildSynthesisContext();
        this.setSection("synthesis", synthesisSection);
        return JSON.stringify(this.privContext);
    };
    SynthesisContext.prototype.buildSynthesisContext = function() {
        return {
            audio: {
                metadataOptions: {
                    bookmarkEnabled: !!this.privSpeechSynthesizer.bookmarkReached,
                    punctuationBoundaryEnabled: this.privSpeechSynthesizer.properties.getProperty($hM4QX.PropertyId.SpeechServiceResponse_RequestPunctuationBoundary, !!this.privSpeechSynthesizer.wordBoundary),
                    sentenceBoundaryEnabled: this.privSpeechSynthesizer.properties.getProperty($hM4QX.PropertyId.SpeechServiceResponse_RequestSentenceBoundary, false),
                    sessionEndEnabled: true,
                    visemeEnabled: !!this.privSpeechSynthesizer.visemeReceived,
                    wordBoundaryEnabled: this.privSpeechSynthesizer.properties.getProperty($hM4QX.PropertyId.SpeechServiceResponse_RequestWordBoundary, !!this.privSpeechSynthesizer.wordBoundary)
                },
                outputFormat: this.privAudioOutputFormat.requestAudioFormatString
            },
            language: {
                autoDetection: this.privSpeechSynthesizer.autoDetectSourceLanguage
            }
        };
    };
    return SynthesisContext;
}();
module.exports.SynthesisContext = $59336a714abea9eb$var$SynthesisContext;

});

parcelRequire.register("3AJQx", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SpeakerRecognitionConfig = void 0;

var $dEkJU = parcelRequire("dEkJU");
var $29d84c070f7851b6$var$SpeakerRecognitionConfig = /** @class */ function() {
    function SpeakerRecognitionConfig(context, parameters) {
        this.privContext = context ? context : new $dEkJU.Context(null);
        this.privParameters = parameters;
    }
    Object.defineProperty(SpeakerRecognitionConfig.prototype, "parameters", {
        get: function() {
            return this.privParameters;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SpeakerRecognitionConfig.prototype, "Context", {
        get: function() {
            return this.privContext;
        },
        enumerable: false,
        configurable: true
    });
    return SpeakerRecognitionConfig;
}();
module.exports.SpeakerRecognitionConfig = $29d84c070f7851b6$var$SpeakerRecognitionConfig;

});

parcelRequire.register("ezBrJ", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
var $a9c1619fdfe2bcd9$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $a9c1619fdfe2bcd9$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $a9c1619fdfe2bcd9$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SpeakerServiceRecognizer = void 0;

var $j1V0D = parcelRequire("j1V0D");

var $em8BD = parcelRequire("em8BD");

var $hM4QX = parcelRequire("hM4QX");

var $dEkJU = parcelRequire("dEkJU");

var $bhJcv = parcelRequire("bhJcv");
// eslint-disable-next-line max-classes-per-file
var $a9c1619fdfe2bcd9$var$SpeakerServiceRecognizer = /** @class */ function(_super) {
    $a9c1619fdfe2bcd9$var$__extends(SpeakerServiceRecognizer, _super);
    function SpeakerServiceRecognizer(authentication, connectionFactory, audioSource, recognizerConfig, recognizer) {
        var _this = _super.call(this, authentication, connectionFactory, audioSource, recognizerConfig, recognizer) || this;
        _this.privSpeakerRecognizer = recognizer;
        _this.privSpeakerAudioSource = audioSource;
        _this.recognizeSpeaker = function(model) {
            return _this.recognizeSpeakerOnce(model);
        };
        _this.sendPrePayloadJSONOverride = function() {
            return _this.noOp();
        };
        return _this;
    }
    SpeakerServiceRecognizer.prototype.processTypeSpecificMessages = function(connectionMessage) {
        var processed = false;
        var resultProps = new $hM4QX.PropertyCollection();
        if (connectionMessage.messageType === $em8BD.MessageType.Text) resultProps.setProperty($hM4QX.PropertyId.SpeechServiceResponse_JsonResult, connectionMessage.textBody);
        switch(connectionMessage.path.toLowerCase()){
            case "speaker.response":
                var response = JSON.parse(connectionMessage.textBody);
                var result = void 0;
                if (response.status.statusCode.toLowerCase() !== "success") result = new $hM4QX.SpeakerRecognitionResult(response, $hM4QX.ResultReason.Canceled, $hM4QX.CancellationErrorCode.ServiceError, response.status.reason);
                else result = new $hM4QX.SpeakerRecognitionResult(response, $hM4QX.ResultReason.RecognizedSpeaker);
                if (!!this.privResultDeferral) this.privResultDeferral.resolve(result);
                processed = true;
                break;
            default:
                break;
        }
        var defferal = new $em8BD.Deferred();
        defferal.resolve(processed);
        return defferal.promise;
    };
    // Cancels recognition.
    SpeakerServiceRecognizer.prototype.cancelRecognition = function(sessionId, requestId, cancellationReason, errorCode, error) {
        var properties = new $hM4QX.PropertyCollection();
        properties.setProperty($dEkJU.CancellationErrorCodePropertyName, $hM4QX.CancellationErrorCode[errorCode]);
        if (!!this.privResultDeferral) {
            var result = new $hM4QX.SpeakerRecognitionResult({
                scenario: this.privSpeakerModel.scenario,
                status: {
                    statusCode: error,
                    reason: error
                }
            }, $hM4QX.ResultReason.Canceled, errorCode, error);
            try {
                this.privResultDeferral.resolve(result);
            } catch (error) {
                this.privResultDeferral.reject(error);
            }
        }
    };
    SpeakerServiceRecognizer.prototype.recognizeSpeakerOnce = function(model) {
        return $a9c1619fdfe2bcd9$var$__awaiter(this, void 0, void 0, function() {
            var conPromise, preAudioPromise, node, format, deviceInfo, audioNode, err_1, sessionStartEventArgs, audioSendPromise;
            var _this = this;
            return $a9c1619fdfe2bcd9$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        this.privSpeakerModel = model;
                        this.voiceProfileType = model.scenario;
                        if (!this.privResultDeferral) this.privResultDeferral = new $em8BD.Deferred();
                        this.privRequestSession.startNewRecognition();
                        this.privRequestSession.listenForServiceTelemetry(this.privSpeakerAudioSource.events);
                        this.privRecognizerConfig.parameters.setProperty($hM4QX.PropertyId.Speech_SessionId, this.privRequestSession.sessionId);
                        conPromise = this.connectImpl();
                        preAudioPromise = this.sendPreAudioMessages(this.extractSpeakerContext(model));
                        return [
                            4 /*yield*/ ,
                            this.privSpeakerAudioSource.attach(this.privRequestSession.audioNodeId)
                        ];
                    case 1:
                        node = _a.sent();
                        return [
                            4 /*yield*/ ,
                            this.privSpeakerAudioSource.format
                        ];
                    case 2:
                        format = _a.sent();
                        return [
                            4 /*yield*/ ,
                            this.privSpeakerAudioSource.deviceInfo
                        ];
                    case 3:
                        deviceInfo = _a.sent();
                        audioNode = new $j1V0D.ReplayableAudioNode(node, format.avgBytesPerSec);
                        return [
                            4 /*yield*/ ,
                            this.privRequestSession.onAudioSourceAttachCompleted(audioNode, false)
                        ];
                    case 4:
                        _a.sent();
                        this.privRecognizerConfig.SpeechServiceConfig.Context.audio = {
                            source: deviceInfo
                        };
                        _a.label = 5;
                    case 5:
                        _a.trys.push([
                            5,
                            8,
                            ,
                            9
                        ]);
                        return [
                            4 /*yield*/ ,
                            conPromise
                        ];
                    case 6:
                        _a.sent();
                        return [
                            4 /*yield*/ ,
                            preAudioPromise
                        ];
                    case 7:
                        _a.sent();
                        return [
                            3 /*break*/ ,
                            9
                        ];
                    case 8:
                        err_1 = _a.sent();
                        this.cancelRecognition(this.privRequestSession.sessionId, this.privRequestSession.requestId, $hM4QX.CancellationReason.Error, $hM4QX.CancellationErrorCode.ConnectionFailure, err_1);
                        return [
                            3 /*break*/ ,
                            9
                        ];
                    case 9:
                        sessionStartEventArgs = new $hM4QX.SessionEventArgs(this.privRequestSession.sessionId);
                        if (!!this.privRecognizer.sessionStarted) this.privRecognizer.sessionStarted(this.privRecognizer, sessionStartEventArgs);
                        this.receiveMessage();
                        audioSendPromise = this.sendAudio(audioNode);
                        // /* eslint-disable no-empty */
                        audioSendPromise.then(function() {}, function(error) {
                            _this.cancelRecognition(_this.privRequestSession.sessionId, _this.privRequestSession.requestId, $hM4QX.CancellationReason.Error, $hM4QX.CancellationErrorCode.RuntimeError, error);
                        });
                        return [
                            2 /*return*/ ,
                            this.privResultDeferral.promise
                        ];
                }
            });
        });
    };
    SpeakerServiceRecognizer.prototype.sendPreAudioMessages = function(context) {
        return $a9c1619fdfe2bcd9$var$__awaiter(this, void 0, void 0, function() {
            var connection;
            return $a9c1619fdfe2bcd9$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.fetchConnection()
                        ];
                    case 1:
                        connection = _a.sent();
                        return [
                            4 /*yield*/ ,
                            this.sendSpeakerRecognition(connection, context)
                        ];
                    case 2:
                        _a.sent();
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    SpeakerServiceRecognizer.prototype.sendSpeakerRecognition = function(connection, context) {
        return $a9c1619fdfe2bcd9$var$__awaiter(this, void 0, void 0, function() {
            var speakerContextJson;
            return $a9c1619fdfe2bcd9$var$__generator(this, function(_a) {
                speakerContextJson = JSON.stringify(context);
                return [
                    2 /*return*/ ,
                    connection.send(new $bhJcv.SpeechConnectionMessage($em8BD.MessageType.Text, "speaker.context", this.privRequestSession.requestId, "application/json; charset=utf-8", speakerContextJson))
                ];
            });
        });
    };
    SpeakerServiceRecognizer.prototype.extractSpeakerContext = function(model) {
        return {
            features: {
                interimResult: "enabled",
                progressiveDetection: "disabled"
            },
            profileIds: model.profileIds,
            scenario: model.scenario
        };
    };
    return SpeakerServiceRecognizer;
}($dEkJU.ServiceRecognizerBase);
module.exports.SpeakerServiceRecognizer = $a9c1619fdfe2bcd9$var$SpeakerServiceRecognizer;

});

parcelRequire.register("lTxWZ", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
var $ff0911e164f83a27$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $ff0911e164f83a27$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $ff0911e164f83a27$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.VoiceServiceRecognizer = void 0;

var $j1V0D = parcelRequire("j1V0D");

var $em8BD = parcelRequire("em8BD");

var $hM4QX = parcelRequire("hM4QX");

var $dEkJU = parcelRequire("dEkJU");

var $bhJcv = parcelRequire("bhJcv");
// eslint-disable-next-line max-classes-per-file
var $ff0911e164f83a27$var$VoiceServiceRecognizer = /** @class */ function(_super) {
    $ff0911e164f83a27$var$__extends(VoiceServiceRecognizer, _super);
    function VoiceServiceRecognizer(authentication, connectionFactory, audioSource, recognizerConfig, recognizer) {
        var _this = _super.call(this, authentication, connectionFactory, audioSource, recognizerConfig, recognizer) || this;
        _this.privDeferralMap = new $em8BD.DeferralMap();
        _this.privSpeakerAudioSource = audioSource;
        _this.sendPrePayloadJSONOverride = function() {
            return _this.noOp();
        };
        return _this;
    }
    Object.defineProperty(VoiceServiceRecognizer.prototype, "SpeakerAudioSource", {
        set: function(audioSource) {
            this.privSpeakerAudioSource = audioSource;
        },
        enumerable: false,
        configurable: true
    });
    VoiceServiceRecognizer.prototype.processTypeSpecificMessages = function(connectionMessage) {
        var processed = false;
        var resultProps = new $hM4QX.PropertyCollection();
        if (connectionMessage.messageType === $em8BD.MessageType.Text) resultProps.setProperty($hM4QX.PropertyId.SpeechServiceResponse_JsonResult, connectionMessage.textBody);
        switch(connectionMessage.path.toLowerCase()){
            // Profile management response for create, fetch, delete, reset
            case "speaker.profiles":
                var response = JSON.parse(connectionMessage.textBody);
                switch(response.operation.toLowerCase()){
                    case "create":
                        this.handleCreateResponse(response, connectionMessage.requestId);
                        break;
                    case "delete":
                    case "reset":
                        this.handleResultResponse(response, connectionMessage.requestId);
                        break;
                    case "fetch":
                        var enrollmentResponse_1 = JSON.parse(connectionMessage.textBody);
                        this.handleFetchResponse(enrollmentResponse_1, connectionMessage.requestId);
                        break;
                    default:
                        break;
                }
                processed = true;
                break;
            // Activation and authorization phrase response
            case "speaker.phrases":
                var phraseResponse = JSON.parse(connectionMessage.textBody);
                this.handlePhrasesResponse(phraseResponse, connectionMessage.requestId);
                processed = true;
                break;
            // Enrollment response
            case "speaker.profile.enrollment":
                var enrollmentResponse = JSON.parse(connectionMessage.textBody);
                var result = new $hM4QX.VoiceProfileEnrollmentResult(this.enrollmentReasonFrom(!!enrollmentResponse.enrollment ? enrollmentResponse.enrollment.enrollmentStatus : enrollmentResponse.status.statusCode), !!enrollmentResponse.enrollment ? JSON.stringify(enrollmentResponse.enrollment) : undefined, enrollmentResponse.status.reason);
                if (!!this.privDeferralMap.getId(connectionMessage.requestId)) this.privDeferralMap.complete(connectionMessage.requestId, result);
                this.privRequestSession.onSpeechEnded();
                processed = true;
                break;
            default:
                break;
        }
        var defferal = new $em8BD.Deferred();
        defferal.resolve(processed);
        return defferal.promise;
    };
    // Cancels recognition.
    VoiceServiceRecognizer.prototype.cancelRecognition = function(sessionId, requestId, cancellationReason, errorCode, error) {
        var properties = new $hM4QX.PropertyCollection();
        // const enrollmentResponse: EnrollmentResponse = JSON.parse(connectionMessage.textBody) as EnrollmentResponse;
        properties.setProperty($dEkJU.CancellationErrorCodePropertyName, $hM4QX.CancellationErrorCode[errorCode]);
        var result = new $hM4QX.VoiceProfileEnrollmentResult($hM4QX.ResultReason.Canceled, error, error);
        if (!!this.privDeferralMap.getId(requestId)) this.privDeferralMap.complete(requestId, result);
    };
    VoiceServiceRecognizer.prototype.createProfile = function(profileType, locale) {
        return $ff0911e164f83a27$var$__awaiter(this, void 0, void 0, function() {
            var conPromise, createProfileDeferral, err_1;
            return $ff0911e164f83a27$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        // Start the connection to the service. The promise this will create is stored and will be used by configureConnection().
                        this.voiceProfileType = profileType.toString();
                        conPromise = this.connectImpl();
                        _a.label = 1;
                    case 1:
                        _a.trys.push([
                            1,
                            4,
                            ,
                            5
                        ]);
                        createProfileDeferral = new $em8BD.Deferred();
                        return [
                            4 /*yield*/ ,
                            conPromise
                        ];
                    case 2:
                        _a.sent();
                        return [
                            4 /*yield*/ ,
                            this.sendCreateProfile(createProfileDeferral, profileType, locale)
                        ];
                    case 3:
                        _a.sent();
                        this.receiveMessage();
                        return [
                            2 /*return*/ ,
                            createProfileDeferral.promise
                        ];
                    case 4:
                        err_1 = _a.sent();
                        throw err_1;
                    case 5:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    VoiceServiceRecognizer.prototype.resetProfile = function(profile) {
        return $ff0911e164f83a27$var$__awaiter(this, void 0, void 0, function() {
            return $ff0911e164f83a27$var$__generator(this, function(_a) {
                this.voiceProfileType = profile.profileType.toString();
                return [
                    2 /*return*/ ,
                    this.sendCommonRequest("reset", profile.profileType, profile)
                ];
            });
        });
    };
    VoiceServiceRecognizer.prototype.deleteProfile = function(profile) {
        return $ff0911e164f83a27$var$__awaiter(this, void 0, void 0, function() {
            return $ff0911e164f83a27$var$__generator(this, function(_a) {
                this.voiceProfileType = profile.profileType.toString();
                return [
                    2 /*return*/ ,
                    this.sendCommonRequest("delete", profile.profileType, profile)
                ];
            });
        });
    };
    VoiceServiceRecognizer.prototype.retrieveEnrollmentResult = function(profile) {
        return $ff0911e164f83a27$var$__awaiter(this, void 0, void 0, function() {
            return $ff0911e164f83a27$var$__generator(this, function(_a) {
                this.voiceProfileType = profile.profileType.toString();
                this.privExpectedProfileId = profile.profileId;
                return [
                    2 /*return*/ ,
                    this.sendCommonRequest("fetch", profile.profileType, profile)
                ];
            });
        });
    };
    VoiceServiceRecognizer.prototype.getAllProfiles = function(profileType) {
        return $ff0911e164f83a27$var$__awaiter(this, void 0, void 0, function() {
            return $ff0911e164f83a27$var$__generator(this, function(_a) {
                this.voiceProfileType = profileType.toString();
                return [
                    2 /*return*/ ,
                    this.sendCommonRequest("fetch", profileType)
                ];
            });
        });
    };
    VoiceServiceRecognizer.prototype.getActivationPhrases = function(profileType, lang) {
        return $ff0911e164f83a27$var$__awaiter(this, void 0, void 0, function() {
            var conPromise, getPhrasesDeferral, err_2;
            return $ff0911e164f83a27$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        this.voiceProfileType = profileType.toString();
                        conPromise = this.connectImpl();
                        _a.label = 1;
                    case 1:
                        _a.trys.push([
                            1,
                            4,
                            ,
                            5
                        ]);
                        getPhrasesDeferral = new $em8BD.Deferred();
                        return [
                            4 /*yield*/ ,
                            conPromise
                        ];
                    case 2:
                        _a.sent();
                        return [
                            4 /*yield*/ ,
                            this.sendPhrasesRequest(getPhrasesDeferral, profileType, lang)
                        ];
                    case 3:
                        _a.sent();
                        this.receiveMessage();
                        return [
                            2 /*return*/ ,
                            getPhrasesDeferral.promise
                        ];
                    case 4:
                        err_2 = _a.sent();
                        throw err_2;
                    case 5:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    VoiceServiceRecognizer.prototype.enrollProfile = function(profile) {
        return $ff0911e164f83a27$var$__awaiter(this, void 0, void 0, function() {
            var enrollmentDeferral, conPromise, preAudioPromise, node, format, deviceInfo, audioNode, err_3, sessionStartEventArgs, audioSendPromise;
            var _this = this;
            return $ff0911e164f83a27$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        this.voiceProfileType = profile.profileType.toString();
                        enrollmentDeferral = new $em8BD.Deferred();
                        this.privRequestSession.startNewRecognition();
                        this.privRequestSession.listenForServiceTelemetry(this.privSpeakerAudioSource.events);
                        this.privRecognizerConfig.parameters.setProperty($hM4QX.PropertyId.Speech_SessionId, this.privRequestSession.sessionId);
                        conPromise = this.connectImpl();
                        preAudioPromise = this.sendPreAudioMessages(profile, enrollmentDeferral);
                        return [
                            4 /*yield*/ ,
                            this.privSpeakerAudioSource.attach(this.privRequestSession.audioNodeId)
                        ];
                    case 1:
                        node = _a.sent();
                        return [
                            4 /*yield*/ ,
                            this.privSpeakerAudioSource.format
                        ];
                    case 2:
                        format = _a.sent();
                        return [
                            4 /*yield*/ ,
                            this.privSpeakerAudioSource.deviceInfo
                        ];
                    case 3:
                        deviceInfo = _a.sent();
                        audioNode = new $j1V0D.ReplayableAudioNode(node, format.avgBytesPerSec);
                        return [
                            4 /*yield*/ ,
                            this.privRequestSession.onAudioSourceAttachCompleted(audioNode, false)
                        ];
                    case 4:
                        _a.sent();
                        this.privRecognizerConfig.SpeechServiceConfig.Context.audio = {
                            source: deviceInfo
                        };
                        _a.label = 5;
                    case 5:
                        _a.trys.push([
                            5,
                            8,
                            ,
                            9
                        ]);
                        return [
                            4 /*yield*/ ,
                            conPromise
                        ];
                    case 6:
                        _a.sent();
                        return [
                            4 /*yield*/ ,
                            preAudioPromise
                        ];
                    case 7:
                        _a.sent();
                        return [
                            3 /*break*/ ,
                            9
                        ];
                    case 8:
                        err_3 = _a.sent();
                        this.cancelRecognition(this.privRequestSession.sessionId, this.privRequestSession.requestId, $hM4QX.CancellationReason.Error, $hM4QX.CancellationErrorCode.ConnectionFailure, err_3);
                        return [
                            3 /*break*/ ,
                            9
                        ];
                    case 9:
                        sessionStartEventArgs = new $hM4QX.SessionEventArgs(this.privRequestSession.sessionId);
                        if (!!this.privRecognizer.sessionStarted) this.privRecognizer.sessionStarted(this.privRecognizer, sessionStartEventArgs);
                        this.receiveMessage();
                        audioSendPromise = this.sendAudio(audioNode);
                        // /* eslint-disable no-empty */
                        audioSendPromise.then(function() {}, function(error) {
                            _this.cancelRecognition(_this.privRequestSession.sessionId, _this.privRequestSession.requestId, $hM4QX.CancellationReason.Error, $hM4QX.CancellationErrorCode.RuntimeError, error);
                        });
                        return [
                            2 /*return*/ ,
                            enrollmentDeferral.promise
                        ];
                }
            });
        });
    };
    VoiceServiceRecognizer.prototype.sendPreAudioMessages = function(profile, enrollmentDeferral) {
        return $ff0911e164f83a27$var$__awaiter(this, void 0, void 0, function() {
            var connection;
            return $ff0911e164f83a27$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.fetchConnection()
                        ];
                    case 1:
                        connection = _a.sent();
                        this.privRequestSession.onSpeechContext();
                        this.privDeferralMap.add(this.privRequestSession.requestId, enrollmentDeferral);
                        return [
                            4 /*yield*/ ,
                            this.sendBaseRequest(connection, "enroll", this.scenarioFrom(profile.profileType), profile)
                        ];
                    case 2:
                        _a.sent();
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    VoiceServiceRecognizer.prototype.sendPhrasesRequest = function(getPhrasesDeferral, profileType, locale) {
        return $ff0911e164f83a27$var$__awaiter(this, void 0, void 0, function() {
            var connection, scenario, profileCreateRequest;
            return $ff0911e164f83a27$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.fetchConnection()
                        ];
                    case 1:
                        connection = _a.sent();
                        this.privRequestSession.onSpeechContext();
                        this.privDeferralMap.add(this.privRequestSession.requestId, getPhrasesDeferral);
                        scenario = this.scenarioFrom(profileType);
                        profileCreateRequest = {
                            locale: locale,
                            scenario: scenario
                        };
                        return [
                            2 /*return*/ ,
                            connection.send(new $bhJcv.SpeechConnectionMessage($em8BD.MessageType.Text, "speaker.profile.phrases", this.privRequestSession.requestId, "application/json; charset=utf-8", JSON.stringify(profileCreateRequest)))
                        ];
                }
            });
        });
    };
    VoiceServiceRecognizer.prototype.sendCreateProfile = function(createProfileDeferral, profileType, locale) {
        return $ff0911e164f83a27$var$__awaiter(this, void 0, void 0, function() {
            var connection, scenario, profileCreateRequest;
            return $ff0911e164f83a27$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.fetchConnection()
                        ];
                    case 1:
                        connection = _a.sent();
                        this.privRequestSession.onSpeechContext();
                        this.privDeferralMap.add(this.privRequestSession.requestId, createProfileDeferral);
                        scenario = profileType === $hM4QX.VoiceProfileType.TextIndependentIdentification ? "TextIndependentIdentification" : profileType === $hM4QX.VoiceProfileType.TextIndependentVerification ? "TextIndependentVerification" : "TextDependentVerification";
                        profileCreateRequest = {
                            locale: locale,
                            number: "1",
                            scenario: scenario
                        };
                        return [
                            2 /*return*/ ,
                            connection.send(new $bhJcv.SpeechConnectionMessage($em8BD.MessageType.Text, "speaker.profile.create", this.privRequestSession.requestId, "application/json; charset=utf-8", JSON.stringify(profileCreateRequest)))
                        ];
                }
            });
        });
    };
    VoiceServiceRecognizer.prototype.sendCommonRequest = function(operation, profileType, profile) {
        if (profile === void 0) profile = undefined;
        return $ff0911e164f83a27$var$__awaiter(this, void 0, void 0, function() {
            var conPromise, deferral, connection, err_4;
            return $ff0911e164f83a27$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        conPromise = this.connectImpl();
                        _a.label = 1;
                    case 1:
                        _a.trys.push([
                            1,
                            5,
                            ,
                            6
                        ]);
                        deferral = new $em8BD.Deferred();
                        this.privRequestSession.onSpeechContext();
                        return [
                            4 /*yield*/ ,
                            conPromise
                        ];
                    case 2:
                        _a.sent();
                        return [
                            4 /*yield*/ ,
                            this.fetchConnection()
                        ];
                    case 3:
                        connection = _a.sent();
                        this.privDeferralMap.add(this.privRequestSession.requestId, deferral);
                        return [
                            4 /*yield*/ ,
                            this.sendBaseRequest(connection, operation, this.scenarioFrom(profileType), profile)
                        ];
                    case 4:
                        _a.sent();
                        this.receiveMessage();
                        return [
                            2 /*return*/ ,
                            deferral.promise
                        ];
                    case 5:
                        err_4 = _a.sent();
                        throw err_4;
                    case 6:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    VoiceServiceRecognizer.prototype.sendBaseRequest = function(connection, operation, scenario, profile) {
        return $ff0911e164f83a27$var$__awaiter(this, void 0, void 0, function() {
            var profileRequest;
            return $ff0911e164f83a27$var$__generator(this, function(_a) {
                profileRequest = {
                    scenario: scenario
                };
                if (!!profile) profileRequest.profileIds = [
                    profile.profileId
                ];
                else profileRequest.maxPageSize = -1;
                return [
                    2 /*return*/ ,
                    connection.send(new $bhJcv.SpeechConnectionMessage($em8BD.MessageType.Text, "speaker.profile." + operation, this.privRequestSession.requestId, "application/json; charset=utf-8", JSON.stringify(profileRequest)))
                ];
            });
        });
    };
    VoiceServiceRecognizer.prototype.extractSpeakerContext = function(model) {
        return {
            features: {
                interimResult: "enabled",
                progressiveDetection: "disabled"
            },
            profileIds: model.profileIds,
            scenario: model.scenario
        };
    };
    VoiceServiceRecognizer.prototype.handlePhrasesResponse = function(response, requestId) {
        if (!!this.privDeferralMap.getId(requestId)) {
            if (response.status.statusCode.toLowerCase() !== "success") {
                var reason = $hM4QX.ResultReason.Canceled;
                var result = new $hM4QX.VoiceProfilePhraseResult(reason, response.status.statusCode, response.passPhraseType, []);
                this.privDeferralMap.complete(requestId, result);
            } else if (!!response.phrases && response.phrases.length > 0) {
                var reason = $hM4QX.ResultReason.EnrollingVoiceProfile;
                var result = new $hM4QX.VoiceProfilePhraseResult(reason, response.status.statusCode, response.passPhraseType, response.phrases);
                this.privDeferralMap.complete(requestId, result);
            } else throw new Error("Voice Profile get activation phrases failed, no phrases received");
        } else throw new Error("Voice Profile get activation phrases request for requestID " + requestId + " not found");
    };
    VoiceServiceRecognizer.prototype.handleCreateResponse = function(response, requestId) {
        if (!!response.profiles && response.profiles.length > 0) {
            if (!!this.privDeferralMap.getId(requestId)) {
                var profileIds = response.profiles.map(function(profile) {
                    return profile.profileId;
                });
                this.privDeferralMap.complete(requestId, profileIds);
            } else throw new Error("Voice Profile create request for requestID " + requestId + " not found");
        } else throw new Error("Voice Profile create failed, no profile id received");
    };
    VoiceServiceRecognizer.prototype.handleResultResponse = function(response, requestId) {
        if (!!this.privDeferralMap.getId(requestId)) {
            var successReason = response.operation.toLowerCase() === "delete" ? $hM4QX.ResultReason.DeletedVoiceProfile : $hM4QX.ResultReason.ResetVoiceProfile;
            var reason = response.status.statusCode.toLowerCase() === "success" ? successReason : $hM4QX.ResultReason.Canceled;
            var result = new $hM4QX.VoiceProfileResult(reason, "statusCode: " + response.status.statusCode + ", errorDetails: " + response.status.reason);
            this.privDeferralMap.complete(requestId, result);
        } else throw new Error("Voice Profile create request for requestID " + requestId + " not found");
    };
    VoiceServiceRecognizer.prototype.handleFetchResponse = function(enrollmentResponse, requestId) {
        if (!!this.privDeferralMap.getId(requestId) && !!enrollmentResponse.profiles[0]) {
            if (!!this.privExpectedProfileId && enrollmentResponse.profiles.length === 1 && enrollmentResponse.profiles[0].profileId === this.privExpectedProfileId) {
                this.privExpectedProfileId = undefined;
                var profileInfo = enrollmentResponse.profiles[0];
                var result = new $hM4QX.VoiceProfileEnrollmentResult(this.enrollmentReasonFrom(profileInfo.enrollmentStatus), JSON.stringify(profileInfo), enrollmentResponse.status.reason);
                this.privDeferralMap.complete(requestId, result);
            } else if (enrollmentResponse.profiles.length > 0) {
                var iProfiles = enrollmentResponse.profiles;
                var profileResults = [];
                for(var _i = 0, iProfiles_1 = iProfiles; _i < iProfiles_1.length; _i++){
                    var profile = iProfiles_1[_i];
                    profileResults.push(new $hM4QX.VoiceProfileEnrollmentResult(this.enrollmentReasonFrom(profile.enrollmentStatus), JSON.stringify(profile), enrollmentResponse.status.reason));
                }
                this.privDeferralMap.complete(requestId, profileResults);
            }
        } else throw new Error("Voice Profile fetch request for requestID " + requestId + " not found");
    };
    VoiceServiceRecognizer.prototype.enrollmentReasonFrom = function(statusCode) {
        switch(statusCode.toLowerCase()){
            case "enrolled":
                return $hM4QX.ResultReason.EnrolledVoiceProfile;
            case "invalidlocale":
            case "invalidphrase":
            case "invalidaudioformat":
            case "invalidscenario":
            case "invalidprofilecount":
            case "invalidoperation":
            case "audiotooshort":
            case "audiotoolong":
            case "toomanyenrollments":
            case "storageconflict":
            case "profilenotfound":
            case "incompatibleprofiles":
            case "incompleteenrollment":
                return $hM4QX.ResultReason.Canceled;
            default:
                return $hM4QX.ResultReason.EnrollingVoiceProfile;
        }
    };
    VoiceServiceRecognizer.prototype.scenarioFrom = function(profileType) {
        return profileType === $hM4QX.VoiceProfileType.TextIndependentIdentification ? "TextIndependentIdentification" : profileType === $hM4QX.VoiceProfileType.TextIndependentVerification ? "TextIndependentVerification" : "TextDependentVerification";
    };
    return VoiceServiceRecognizer;
}($dEkJU.ServiceRecognizerBase);
module.exports.VoiceServiceRecognizer = $ff0911e164f83a27$var$VoiceServiceRecognizer;

});



parcelRequire.register("f07mb", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
var $aebc9000a6616d69$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $aebc9000a6616d69$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.FileAudioSource = void 0;

var $dEkJU = parcelRequire("dEkJU");

var $em8BD = parcelRequire("em8BD");

var $kQmaR = parcelRequire("kQmaR");
var $aebc9000a6616d69$var$FileAudioSource = /** @class */ function() {
    function FileAudioSource(file, filename, audioSourceId) {
        this.privStreams = {};
        this.privHeaderEnd = 44;
        this.privId = audioSourceId ? audioSourceId : $em8BD.createNoDashGuid();
        this.privEvents = new $em8BD.EventSource();
        this.privSource = file;
        if (typeof window !== "undefined" && typeof Blob !== "undefined" && this.privSource instanceof Blob) this.privFilename = file.name;
        else this.privFilename = filename || "unknown.wav";
        // Read the header.
        this.privAudioFormatPromise = this.readHeader();
    }
    Object.defineProperty(FileAudioSource.prototype, "format", {
        get: function() {
            return this.privAudioFormatPromise;
        },
        enumerable: false,
        configurable: true
    });
    FileAudioSource.prototype.turnOn = function() {
        if (this.privFilename.lastIndexOf(".wav") !== this.privFilename.length - 4) {
            var errorMsg = this.privFilename + " is not supported. Only WAVE files are allowed at the moment.";
            this.onEvent(new $em8BD.AudioSourceErrorEvent(errorMsg, ""));
            return Promise.reject(errorMsg);
        }
        this.onEvent(new $em8BD.AudioSourceInitializingEvent(this.privId)); // no stream id
        this.onEvent(new $em8BD.AudioSourceReadyEvent(this.privId));
        return;
    };
    FileAudioSource.prototype.id = function() {
        return this.privId;
    };
    FileAudioSource.prototype.attach = function(audioNodeId) {
        return $aebc9000a6616d69$var$__awaiter(this, void 0, void 0, function() {
            var stream;
            var _this = this;
            return $aebc9000a6616d69$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        this.onEvent(new $em8BD.AudioStreamNodeAttachingEvent(this.privId, audioNodeId));
                        return [
                            4 /*yield*/ ,
                            this.upload(audioNodeId)
                        ];
                    case 1:
                        stream = _a.sent();
                        this.onEvent(new $em8BD.AudioStreamNodeAttachedEvent(this.privId, audioNodeId));
                        return [
                            2 /*return*/ ,
                            Promise.resolve({
                                detach: function() {
                                    return $aebc9000a6616d69$var$__awaiter(_this, void 0, void 0, function() {
                                        return $aebc9000a6616d69$var$__generator(this, function(_a) {
                                            switch(_a.label){
                                                case 0:
                                                    stream.readEnded();
                                                    delete this.privStreams[audioNodeId];
                                                    this.onEvent(new $em8BD.AudioStreamNodeDetachedEvent(this.privId, audioNodeId));
                                                    return [
                                                        4 /*yield*/ ,
                                                        this.turnOff()
                                                    ];
                                                case 1:
                                                    _a.sent();
                                                    return [
                                                        2 /*return*/ 
                                                    ];
                                            }
                                        });
                                    });
                                },
                                id: function() {
                                    return audioNodeId;
                                },
                                read: function() {
                                    return stream.read();
                                }
                            })
                        ];
                }
            });
        });
    };
    FileAudioSource.prototype.detach = function(audioNodeId) {
        if (audioNodeId && this.privStreams[audioNodeId]) {
            this.privStreams[audioNodeId].close();
            delete this.privStreams[audioNodeId];
            this.onEvent(new $em8BD.AudioStreamNodeDetachedEvent(this.privId, audioNodeId));
        }
    };
    FileAudioSource.prototype.turnOff = function() {
        for(var streamId in this.privStreams)if (streamId) {
            var stream = this.privStreams[streamId];
            if (stream && !stream.isClosed) stream.close();
        }
        this.onEvent(new $em8BD.AudioSourceOffEvent(this.privId)); // no stream now
        return Promise.resolve();
    };
    Object.defineProperty(FileAudioSource.prototype, "events", {
        get: function() {
            return this.privEvents;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FileAudioSource.prototype, "deviceInfo", {
        get: function() {
            return this.privAudioFormatPromise.then(function(result) {
                return Promise.resolve({
                    bitspersample: result.bitsPerSample,
                    channelcount: result.channels,
                    connectivity: $dEkJU.connectivity.Unknown,
                    manufacturer: "Speech SDK",
                    model: "File",
                    samplerate: result.samplesPerSec,
                    type: $dEkJU.type.File
                });
            });
        },
        enumerable: false,
        configurable: true
    });
    FileAudioSource.prototype.readHeader = function() {
        var _this = this;
        // Read the wave header.
        var maxHeaderSize = 4296;
        var header = this.privSource.slice(0, maxHeaderSize);
        var headerResult = new $em8BD.Deferred();
        var processHeader = function(header) {
            var view = new DataView(header);
            var getWord = function(index) {
                return String.fromCharCode(view.getUint8(index), view.getUint8(index + 1), view.getUint8(index + 2), view.getUint8(index + 3));
            };
            // RIFF 4 bytes.
            if ("RIFF" !== getWord(0)) {
                headerResult.reject("Invalid WAV header in file, RIFF was not found");
                return;
            }
            // length, 4 bytes
            // RIFF Type & fmt 8 bytes
            if ("WAVE" !== getWord(8) || "fmt " !== getWord(12)) {
                headerResult.reject("Invalid WAV header in file, WAVEfmt was not found");
                return;
            }
            var formatSize = view.getInt32(16, true);
            var channelCount = view.getUint16(22, true);
            var sampleRate = view.getUint32(24, true);
            var bitsPerSample = view.getUint16(34, true);
            // Confirm if header is 44 bytes long.
            var pos = 36 + Math.max(formatSize - 16, 0);
            for(; getWord(pos) !== "data"; pos += 2)if (pos > maxHeaderSize - 8) {
                headerResult.reject("Invalid WAV header in file, data block was not found");
                return;
            }
            _this.privHeaderEnd = pos + 8;
            headerResult.resolve($kQmaR.AudioStreamFormat.getWaveFormatPCM(sampleRate, bitsPerSample, channelCount));
        };
        if (typeof window !== "undefined" && typeof Blob !== "undefined" && header instanceof Blob) {
            var reader = new FileReader();
            reader.onload = function(event) {
                var header = event.target.result;
                processHeader(header);
            };
            reader.readAsArrayBuffer(header);
        } else {
            var h = header;
            processHeader(h.buffer.slice(h.byteOffset, h.byteOffset + h.byteLength));
        }
        return headerResult.promise;
    };
    FileAudioSource.prototype.upload = function(audioNodeId) {
        return $aebc9000a6616d69$var$__awaiter(this, void 0, void 0, function() {
            var onerror, format, stream_1, chunk, processFile_1, reader, c, e_1;
            var _this = this;
            return $aebc9000a6616d69$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        onerror = function(error) {
                            var errorMsg = "Error occurred while processing '" + _this.privFilename + "'. " + error;
                            _this.onEvent(new $em8BD.AudioStreamNodeErrorEvent(_this.privId, audioNodeId, errorMsg));
                            throw new Error(errorMsg);
                        };
                        _a.label = 1;
                    case 1:
                        _a.trys.push([
                            1,
                            4,
                            ,
                            5
                        ]);
                        return [
                            4 /*yield*/ ,
                            this.turnOn()
                        ];
                    case 2:
                        _a.sent();
                        return [
                            4 /*yield*/ ,
                            this.privAudioFormatPromise
                        ];
                    case 3:
                        format = _a.sent();
                        stream_1 = new $em8BD.ChunkedArrayBufferStream(format.avgBytesPerSec / 10, audioNodeId);
                        this.privStreams[audioNodeId] = stream_1;
                        chunk = this.privSource.slice(this.privHeaderEnd);
                        processFile_1 = function(buff) {
                            if (stream_1.isClosed) return; // output stream was closed (somebody called TurnOff). We're done here.
                            stream_1.writeStreamChunk({
                                buffer: buff,
                                isEnd: false,
                                timeReceived: Date.now()
                            });
                            stream_1.close();
                        };
                        if (typeof window !== "undefined" && typeof Blob !== "undefined" && chunk instanceof Blob) {
                            reader = new FileReader();
                            reader.onerror = function(ev) {
                                return onerror(ev.toString());
                            };
                            reader.onload = function(event) {
                                var fileBuffer = event.target.result;
                                processFile_1(fileBuffer);
                            };
                            reader.readAsArrayBuffer(chunk);
                        } else {
                            c = chunk;
                            processFile_1(c.buffer.slice(c.byteOffset, c.byteOffset + c.byteLength));
                        }
                        return [
                            2 /*return*/ ,
                            stream_1
                        ];
                    case 4:
                        e_1 = _a.sent();
                        onerror(e_1);
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 5:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    FileAudioSource.prototype.onEvent = function(event) {
        this.privEvents.onEvent(event);
        $em8BD.Events.instance.onEvent(event);
    };
    return FileAudioSource;
}();
module.exports.FileAudioSource = $aebc9000a6616d69$var$FileAudioSource;

});

parcelRequire.register("aY3vd", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PcmRecorder = void 0;

var $em8BD = parcelRequire("em8BD");
var $7fc2397f74b4c940$var$PcmRecorder = /** @class */ function() {
    function PcmRecorder(stopInputOnRelease) {
        this.privStopInputOnRelease = stopInputOnRelease;
    }
    PcmRecorder.prototype.record = function(context, mediaStream, outputStream) {
        var _this = this;
        var desiredSampleRate = 16000;
        var waveStreamEncoder = new $em8BD.RiffPcmEncoder(context.sampleRate, desiredSampleRate);
        var micInput = context.createMediaStreamSource(mediaStream);
        var attachScriptProcessor = function() {
            // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
            var scriptNode = function() {
                var bufferSize = 0;
                try {
                    return context.createScriptProcessor(bufferSize, 1, 1);
                } catch (error) {
                    // Webkit (<= version 31) requires a valid bufferSize.
                    bufferSize = 2048;
                    var audioSampleRate = context.sampleRate;
                    while(bufferSize < 16384 && audioSampleRate >= 2 * desiredSampleRate){
                        bufferSize <<= 1;
                        audioSampleRate >>= 1;
                    }
                    return context.createScriptProcessor(bufferSize, 1, 1);
                }
            }();
            scriptNode.onaudioprocess = function(event) {
                var inputFrame = event.inputBuffer.getChannelData(0);
                if (outputStream && !outputStream.isClosed) {
                    var waveFrame = waveStreamEncoder.encode(inputFrame);
                    if (!!waveFrame) outputStream.writeStreamChunk({
                        buffer: waveFrame,
                        isEnd: false,
                        timeReceived: Date.now()
                    });
                }
            };
            micInput.connect(scriptNode);
            scriptNode.connect(context.destination);
            _this.privMediaResources = {
                scriptProcessorNode: scriptNode,
                source: micInput,
                stream: mediaStream
            };
        };
        // https://webaudio.github.io/web-audio-api/#audioworklet
        // Using AudioWorklet to improve audio quality and avoid audio glitches due to blocking the UI thread
        if (!!context.audioWorklet) {
            if (!this.privSpeechProcessorScript) {
                var workletScript = "class SP extends AudioWorkletProcessor {\n                    constructor(options) {\n                      super(options);\n                    }\n                    process(inputs, outputs) {\n                      const input = inputs[0];\n                      const output = [];\n                      for (let channel = 0; channel < input.length; channel += 1) {\n                        output[channel] = input[channel];\n                      }\n                      this.port.postMessage(output[0]);\n                      return true;\n                    }\n                  }\n                  registerProcessor('speech-processor', SP);";
                var blob = new Blob([
                    workletScript
                ], {
                    type: "application/javascript; charset=utf-8"
                });
                this.privSpeechProcessorScript = URL.createObjectURL(blob);
            }
            context.audioWorklet.addModule(this.privSpeechProcessorScript).then(function() {
                var workletNode = new AudioWorkletNode(context, "speech-processor");
                workletNode.port.onmessage = function(ev) {
                    var inputFrame = ev.data;
                    if (outputStream && !outputStream.isClosed) {
                        var waveFrame = waveStreamEncoder.encode(inputFrame);
                        if (!!waveFrame) outputStream.writeStreamChunk({
                            buffer: waveFrame,
                            isEnd: false,
                            timeReceived: Date.now()
                        });
                    }
                };
                micInput.connect(workletNode);
                workletNode.connect(context.destination);
                _this.privMediaResources = {
                    scriptProcessorNode: workletNode,
                    source: micInput,
                    stream: mediaStream
                };
            }).catch(function() {
                attachScriptProcessor();
            });
        } else try {
            attachScriptProcessor();
        } catch (err) {
            throw new Error("Unable to start audio worklet node for PCMRecorder: " + err);
        }
    };
    PcmRecorder.prototype.releaseMediaResources = function(context) {
        if (this.privMediaResources) {
            if (this.privMediaResources.scriptProcessorNode) {
                this.privMediaResources.scriptProcessorNode.disconnect(context.destination);
                this.privMediaResources.scriptProcessorNode = null;
            }
            if (this.privMediaResources.source) {
                this.privMediaResources.source.disconnect();
                if (this.privStopInputOnRelease) this.privMediaResources.stream.getTracks().forEach(function(track) {
                    return track.stop();
                });
                this.privMediaResources.source = null;
            }
        }
    };
    PcmRecorder.prototype.setWorkletUrl = function(url) {
        this.privSpeechProcessorScript = url;
    };
    return PcmRecorder;
}();
module.exports.PcmRecorder = $7fc2397f74b4c940$var$PcmRecorder;

});

parcelRequire.register("djMwj", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
var $9b22afc8ed089735$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $9b22afc8ed089735$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.WebsocketConnection = void 0;

var $em8BD = parcelRequire("em8BD");

var $i7W09 = parcelRequire("i7W09");
var $9b22afc8ed089735$var$WebsocketConnection = /** @class */ function() {
    function WebsocketConnection(uri, queryParameters, headers, messageFormatter, proxyInfo, enableCompression, connectionId) {
        if (enableCompression === void 0) enableCompression = false;
        this.privIsDisposed = false;
        if (!uri) throw new $em8BD.ArgumentNullError("uri");
        if (!messageFormatter) throw new $em8BD.ArgumentNullError("messageFormatter");
        this.privMessageFormatter = messageFormatter;
        var queryParams = "";
        var i = 0;
        if (queryParameters) {
            for(var paramName in queryParameters)if (paramName) {
                queryParams += i === 0 && uri.indexOf("?") === -1 ? "?" : "&";
                var key = encodeURIComponent(paramName);
                queryParams += key;
                var val = queryParameters[paramName];
                if (val) {
                    val = encodeURIComponent(val);
                    queryParams += "=" + val;
                }
                i++;
            }
        }
        if (headers) {
            for(var headerName in headers)if (headerName) {
                queryParams += i === 0 && uri.indexOf("?") === -1 ? "?" : "&";
                var val = encodeURIComponent(headers[headerName]);
                queryParams += headerName + "=" + val;
                i++;
            }
        }
        this.privUri = uri + queryParams;
        this.privId = connectionId ? connectionId : $em8BD.createNoDashGuid();
        this.privConnectionMessageAdapter = new $i7W09.WebsocketMessageAdapter(this.privUri, this.id, this.privMessageFormatter, proxyInfo, headers, enableCompression);
    }
    WebsocketConnection.prototype.dispose = function() {
        return $9b22afc8ed089735$var$__awaiter(this, void 0, void 0, function() {
            return $9b22afc8ed089735$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        this.privIsDisposed = true;
                        if (!this.privConnectionMessageAdapter) return [
                            3 /*break*/ ,
                            2
                        ];
                        return [
                            4 /*yield*/ ,
                            this.privConnectionMessageAdapter.close()
                        ];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    WebsocketConnection.prototype.isDisposed = function() {
        return this.privIsDisposed;
    };
    Object.defineProperty(WebsocketConnection.prototype, "id", {
        get: function() {
            return this.privId;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(WebsocketConnection.prototype, "uri", {
        get: function() {
            return this.privUri;
        },
        enumerable: false,
        configurable: true
    });
    WebsocketConnection.prototype.state = function() {
        return this.privConnectionMessageAdapter.state;
    };
    WebsocketConnection.prototype.open = function() {
        return this.privConnectionMessageAdapter.open();
    };
    WebsocketConnection.prototype.send = function(message) {
        return this.privConnectionMessageAdapter.send(message);
    };
    WebsocketConnection.prototype.read = function() {
        return this.privConnectionMessageAdapter.read();
    };
    Object.defineProperty(WebsocketConnection.prototype, "events", {
        get: function() {
            return this.privConnectionMessageAdapter.events;
        },
        enumerable: false,
        configurable: true
    });
    return WebsocketConnection;
}();
module.exports.WebsocketConnection = $9b22afc8ed089735$var$WebsocketConnection;

});
parcelRequire.register("i7W09", function(module, exports) {

var $cBXue = parcelRequire("cBXue");
var $d325df56f5902625$require$Buffer = $cBXue.Buffer;
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
var $d325df56f5902625$var$__assign = module.exports && module.exports.__assign || function() {
    $d325df56f5902625$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $d325df56f5902625$var$__assign.apply(this, arguments);
};
var $d325df56f5902625$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $d325df56f5902625$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $d325df56f5902625$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.hasOwnProperty.call(mod, k)) $d325df56f5902625$var$__createBinding(result, mod, k);
    }
    $d325df56f5902625$var$__setModuleDefault(result, mod);
    return result;
};
var $d325df56f5902625$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $d325df56f5902625$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $d325df56f5902625$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.WebsocketMessageAdapter = void 0;

var $d325df56f5902625$var$net = $d325df56f5902625$var$__importStar((parcelRequire("gR5sk")));

var $d325df56f5902625$var$tls = $d325df56f5902625$var$__importStar((parcelRequire("gR5sk")));

var $d325df56f5902625$var$agent_base_1 = $d325df56f5902625$var$__importDefault((parcelRequire("gR5sk")));

var $d325df56f5902625$var$https_proxy_agent_1 = $d325df56f5902625$var$__importDefault((parcelRequire("gR5sk")));

var $d325df56f5902625$var$ws_1 = $d325df56f5902625$var$__importDefault((parcelRequire("gR5sk")));

var $btbfh = parcelRequire("btbfh");

var $em8BD = parcelRequire("em8BD");
var $d325df56f5902625$var$WebsocketMessageAdapter = /** @class */ function() {
    function WebsocketMessageAdapter(uri, connectionId, messageFormatter, proxyInfo, headers, enableCompression) {
        if (!uri) throw new $em8BD.ArgumentNullError("uri");
        if (!messageFormatter) throw new $em8BD.ArgumentNullError("messageFormatter");
        this.proxyInfo = proxyInfo;
        this.privConnectionEvents = new $em8BD.EventSource();
        this.privConnectionId = connectionId;
        this.privMessageFormatter = messageFormatter;
        this.privConnectionState = $em8BD.ConnectionState.None;
        this.privUri = uri;
        this.privHeaders = headers;
        this.privEnableCompression = enableCompression;
        // Add the connection ID to the headers
        this.privHeaders[$btbfh.HeaderNames.ConnectionId] = this.privConnectionId;
        this.privLastErrorReceived = "";
    }
    Object.defineProperty(WebsocketMessageAdapter.prototype, "state", {
        get: function() {
            return this.privConnectionState;
        },
        enumerable: false,
        configurable: true
    });
    WebsocketMessageAdapter.prototype.open = function() {
        var _this = this;
        if (this.privConnectionState === $em8BD.ConnectionState.Disconnected) return Promise.reject("Cannot open a connection that is in " + this.privConnectionState + " state");
        if (this.privConnectionEstablishDeferral) return this.privConnectionEstablishDeferral.promise;
        this.privConnectionEstablishDeferral = new $em8BD.Deferred();
        this.privCertificateValidatedDeferral = new $em8BD.Deferred();
        this.privConnectionState = $em8BD.ConnectionState.Connecting;
        try {
            if (typeof WebSocket !== "undefined" && !WebsocketMessageAdapter.forceNpmWebSocket) {
                // Browser handles cert checks.
                this.privCertificateValidatedDeferral.resolve();
                this.privWebsocketClient = new WebSocket(this.privUri);
            } else {
                var options = {
                    headers: this.privHeaders,
                    perMessageDeflate: this.privEnableCompression
                };
                // The ocsp library will handle validation for us and fail the connection if needed.
                this.privCertificateValidatedDeferral.resolve();
                options.agent = this.getAgent();
                // Workaround for https://github.com/microsoft/cognitive-services-speech-sdk-js/issues/465
                // Which is root caused by https://github.com/TooTallNate/node-agent-base/issues/61
                var uri = new URL(this.privUri);
                var protocol = uri.protocol;
                if ((protocol === null || protocol === void 0 ? void 0 : protocol.toLocaleLowerCase()) === "wss:") protocol = "https:";
                else if ((protocol === null || protocol === void 0 ? void 0 : protocol.toLocaleLowerCase()) === "ws:") protocol = "http:";
                // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
                options.agent.protocol = protocol;
                this.privWebsocketClient = new $d325df56f5902625$var$ws_1.default(this.privUri, options);
            }
            this.privWebsocketClient.binaryType = "arraybuffer";
            this.privReceivingMessageQueue = new $em8BD.Queue();
            this.privDisconnectDeferral = new $em8BD.Deferred();
            this.privSendMessageQueue = new $em8BD.Queue();
            this.processSendQueue().catch(function(reason) {
                $em8BD.Events.instance.onEvent(new $em8BD.BackgroundEvent(reason));
            });
        } catch (error) {
            this.privConnectionEstablishDeferral.resolve(new $em8BD.ConnectionOpenResponse(500, error));
            return this.privConnectionEstablishDeferral.promise;
        }
        this.onEvent(new $em8BD.ConnectionStartEvent(this.privConnectionId, this.privUri));
        this.privWebsocketClient.onopen = function() {
            _this.privCertificateValidatedDeferral.promise.then(function() {
                _this.privConnectionState = $em8BD.ConnectionState.Connected;
                _this.onEvent(new $em8BD.ConnectionEstablishedEvent(_this.privConnectionId));
                _this.privConnectionEstablishDeferral.resolve(new $em8BD.ConnectionOpenResponse(200, ""));
            }, function(error) {
                _this.privConnectionEstablishDeferral.reject(error);
            });
        };
        this.privWebsocketClient.onerror = function(e) {
            _this.onEvent(new $em8BD.ConnectionErrorEvent(_this.privConnectionId, e.message, e.type));
            _this.privLastErrorReceived = e.message;
        };
        this.privWebsocketClient.onclose = function(e) {
            if (_this.privConnectionState === $em8BD.ConnectionState.Connecting) {
                _this.privConnectionState = $em8BD.ConnectionState.Disconnected;
                // this.onEvent(new ConnectionEstablishErrorEvent(this.connectionId, e.code, e.reason));
                _this.privConnectionEstablishDeferral.resolve(new $em8BD.ConnectionOpenResponse(e.code, e.reason + " " + _this.privLastErrorReceived));
            } else {
                _this.privConnectionState = $em8BD.ConnectionState.Disconnected;
                _this.privWebsocketClient = null;
                _this.onEvent(new $em8BD.ConnectionClosedEvent(_this.privConnectionId, e.code, e.reason));
            }
            _this.onClose(e.code, e.reason).catch(function(reason) {
                $em8BD.Events.instance.onEvent(new $em8BD.BackgroundEvent(reason));
            });
        };
        this.privWebsocketClient.onmessage = function(e) {
            var networkReceivedTime = new Date().toISOString();
            if (_this.privConnectionState === $em8BD.ConnectionState.Connected) {
                var deferred_1 = new $em8BD.Deferred();
                // let id = ++this.idCounter;
                _this.privReceivingMessageQueue.enqueueFromPromise(deferred_1.promise);
                if (e.data instanceof ArrayBuffer) {
                    var rawMessage = new $em8BD.RawWebsocketMessage($em8BD.MessageType.Binary, e.data);
                    _this.privMessageFormatter.toConnectionMessage(rawMessage).then(function(connectionMessage) {
                        _this.onEvent(new $em8BD.ConnectionMessageReceivedEvent(_this.privConnectionId, networkReceivedTime, connectionMessage));
                        deferred_1.resolve(connectionMessage);
                    }, function(error) {
                        // TODO: Events for these ?
                        deferred_1.reject("Invalid binary message format. Error: " + error);
                    });
                } else {
                    var rawMessage = new $em8BD.RawWebsocketMessage($em8BD.MessageType.Text, e.data);
                    _this.privMessageFormatter.toConnectionMessage(rawMessage).then(function(connectionMessage) {
                        _this.onEvent(new $em8BD.ConnectionMessageReceivedEvent(_this.privConnectionId, networkReceivedTime, connectionMessage));
                        deferred_1.resolve(connectionMessage);
                    }, function(error) {
                        // TODO: Events for these ?
                        deferred_1.reject("Invalid text message format. Error: " + error);
                    });
                }
            }
        };
        return this.privConnectionEstablishDeferral.promise;
    };
    WebsocketMessageAdapter.prototype.send = function(message) {
        if (this.privConnectionState !== $em8BD.ConnectionState.Connected) return Promise.reject("Cannot send on connection that is in " + $em8BD.ConnectionState[this.privConnectionState] + " state");
        var messageSendStatusDeferral = new $em8BD.Deferred();
        var messageSendDeferral = new $em8BD.Deferred();
        this.privSendMessageQueue.enqueueFromPromise(messageSendDeferral.promise);
        this.privMessageFormatter.fromConnectionMessage(message).then(function(rawMessage) {
            messageSendDeferral.resolve({
                Message: message,
                RawWebsocketMessage: rawMessage,
                sendStatusDeferral: messageSendStatusDeferral
            });
        }, function(error) {
            messageSendDeferral.reject("Error formatting the message. " + error);
        });
        return messageSendStatusDeferral.promise;
    };
    WebsocketMessageAdapter.prototype.read = function() {
        if (this.privConnectionState !== $em8BD.ConnectionState.Connected) return Promise.reject("Cannot read on connection that is in " + this.privConnectionState + " state");
        return this.privReceivingMessageQueue.dequeue();
    };
    WebsocketMessageAdapter.prototype.close = function(reason) {
        if (this.privWebsocketClient) {
            if (this.privConnectionState !== $em8BD.ConnectionState.Disconnected) this.privWebsocketClient.close(1000, reason ? reason : "Normal closure by client");
        } else return Promise.resolve();
        return this.privDisconnectDeferral.promise;
    };
    Object.defineProperty(WebsocketMessageAdapter.prototype, "events", {
        get: function() {
            return this.privConnectionEvents;
        },
        enumerable: false,
        configurable: true
    });
    WebsocketMessageAdapter.prototype.sendRawMessage = function(sendItem) {
        try {
            // indicates we are draining the queue and it came with no message;
            if (!sendItem) return Promise.resolve();
            this.onEvent(new $em8BD.ConnectionMessageSentEvent(this.privConnectionId, new Date().toISOString(), sendItem.Message));
            // add a check for the ws readystate in order to stop the red console error 'WebSocket is already in CLOSING or CLOSED state' appearing
            if (this.isWebsocketOpen) // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
            this.privWebsocketClient.send(sendItem.RawWebsocketMessage.payload);
            else return Promise.reject("websocket send error: Websocket not ready " + this.privConnectionId + " " + sendItem.Message.id + " " + new Error().stack);
            return Promise.resolve();
        } catch (e) {
            return Promise.reject("websocket send error: " + e);
        }
    };
    WebsocketMessageAdapter.prototype.onClose = function(code, reason) {
        return $d325df56f5902625$var$__awaiter(this, void 0, void 0, function() {
            var closeReason;
            return $d325df56f5902625$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        closeReason = "Connection closed. " + code + ": " + reason;
                        this.privConnectionState = $em8BD.ConnectionState.Disconnected;
                        this.privDisconnectDeferral.resolve();
                        return [
                            4 /*yield*/ ,
                            this.privReceivingMessageQueue.drainAndDispose(function() {
                            // TODO: Events for these ?
                            // Logger.instance.onEvent(new LoggingEvent(LogType.Warning, null, `Failed to process received message. Reason: ${closeReason}, Message: ${JSON.stringify(pendingReceiveItem)}`));
                            }, closeReason)
                        ];
                    case 1:
                        _a.sent();
                        return [
                            4 /*yield*/ ,
                            this.privSendMessageQueue.drainAndDispose(function(pendingSendItem) {
                                pendingSendItem.sendStatusDeferral.reject(closeReason);
                            }, closeReason)
                        ];
                    case 2:
                        _a.sent();
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    WebsocketMessageAdapter.prototype.processSendQueue = function() {
        return $d325df56f5902625$var$__awaiter(this, void 0, void 0, function() {
            var itemToSend, sendItem, sendError_1;
            return $d325df56f5902625$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        itemToSend = this.privSendMessageQueue.dequeue();
                        return [
                            4 /*yield*/ ,
                            itemToSend
                        ];
                    case 1:
                        sendItem = _a.sent();
                        // indicates we are draining the queue and it came with no message;
                        if (!sendItem) return [
                            2 /*return*/ 
                        ];
                        _a.label = 2;
                    case 2:
                        _a.trys.push([
                            2,
                            4,
                            ,
                            5
                        ]);
                        return [
                            4 /*yield*/ ,
                            this.sendRawMessage(sendItem)
                        ];
                    case 3:
                        _a.sent();
                        sendItem.sendStatusDeferral.resolve();
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 4:
                        sendError_1 = _a.sent();
                        sendItem.sendStatusDeferral.reject(sendError_1);
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 5:
                        return [
                            3 /*break*/ ,
                            0
                        ];
                    case 6:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    WebsocketMessageAdapter.prototype.onEvent = function(event) {
        this.privConnectionEvents.onEvent(event);
        $em8BD.Events.instance.onEvent(event);
    };
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    WebsocketMessageAdapter.prototype.getAgent = function() {
        // eslint-disable-next-line @typescript-eslint/unbound-method
        var agent = new $d325df56f5902625$var$agent_base_1.default.Agent(this.createConnection);
        if (this.proxyInfo !== undefined && this.proxyInfo.HostName !== undefined && this.proxyInfo.Port > 0) agent.proxyInfo = this.proxyInfo;
        return agent;
    };
    WebsocketMessageAdapter.GetProxyAgent = function(proxyInfo) {
        var httpProxyOptions = {
            host: proxyInfo.HostName,
            port: proxyInfo.Port
        };
        if (!!proxyInfo.UserName) httpProxyOptions.headers = {
            "Proxy-Authentication": "Basic " + new $d325df56f5902625$require$Buffer(proxyInfo.UserName + ":" + (proxyInfo.Password === undefined ? "" : proxyInfo.Password)).toString("base64")
        };
        else httpProxyOptions.headers = {};
        httpProxyOptions.headers.requestOCSP = "true";
        var httpProxyAgent = new $d325df56f5902625$var$https_proxy_agent_1.default(httpProxyOptions);
        return httpProxyAgent;
    };
    WebsocketMessageAdapter.prototype.createConnection = function(request, options) {
        var socketPromise;
        options = $d325df56f5902625$var$__assign($d325df56f5902625$var$__assign({}, options), {
            requestOCSP: true,
            servername: options.host
        });
        if (!!this.proxyInfo) {
            var httpProxyAgent = WebsocketMessageAdapter.GetProxyAgent(this.proxyInfo);
            var baseAgent_1 = httpProxyAgent;
            socketPromise = new Promise(function(resolve, reject) {
                baseAgent_1.callback(request, options, function(error, socket) {
                    if (!!error) reject(error);
                    else resolve(socket);
                });
            });
        } else if (!!options.secureEndpoint) socketPromise = Promise.resolve($d325df56f5902625$var$tls.connect(options));
        else socketPromise = Promise.resolve($d325df56f5902625$var$net.connect(options));
        return socketPromise;
    };
    Object.defineProperty(WebsocketMessageAdapter.prototype, "isWebsocketOpen", {
        get: function() {
            return this.privWebsocketClient && this.privWebsocketClient.readyState === this.privWebsocketClient.OPEN;
        },
        enumerable: false,
        configurable: true
    });
    WebsocketMessageAdapter.forceNpmWebSocket = false;
    return WebsocketMessageAdapter;
}();
module.exports.WebsocketMessageAdapter = $d325df56f5902625$var$WebsocketMessageAdapter;

});


parcelRequire.register("cPF2y", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ReplayableAudioNode = void 0;
var $957a15295781bd24$var$ReplayableAudioNode = /** @class */ function() {
    function ReplayableAudioNode(audioSource, bytesPerSecond) {
        this.privBuffers = [];
        this.privReplayOffset = 0;
        this.privLastShrinkOffset = 0;
        this.privBufferStartOffset = 0;
        this.privBufferSerial = 0;
        this.privBufferedBytes = 0;
        this.privReplay = false;
        this.privLastChunkAcquiredTime = 0;
        this.privAudioNode = audioSource;
        this.privBytesPerSecond = bytesPerSecond;
    }
    ReplayableAudioNode.prototype.id = function() {
        return this.privAudioNode.id();
    };
    // Reads and returns the next chunk of audio buffer.
    // If replay of existing buffers are needed, read() will first seek and replay
    // existing content, and upoin completion it will read new content from the underlying
    // audio node, saving that content into the replayable buffers.
    ReplayableAudioNode.prototype.read = function() {
        var _this = this;
        // if there is a replay request to honor.
        if (!!this.privReplay && this.privBuffers.length !== 0) {
            // Find the start point in the buffers.
            // Offsets are in 100ns increments.
            // So how many bytes do we need to seek to get the right offset?
            var offsetToSeek = this.privReplayOffset - this.privBufferStartOffset;
            var bytesToSeek = Math.round(offsetToSeek * this.privBytesPerSecond * 1e-7);
            if (0 !== bytesToSeek % 2) bytesToSeek++;
            var i = 0;
            while(i < this.privBuffers.length && bytesToSeek >= this.privBuffers[i].chunk.buffer.byteLength)bytesToSeek -= this.privBuffers[i++].chunk.buffer.byteLength;
            if (i < this.privBuffers.length) {
                var retVal = this.privBuffers[i].chunk.buffer.slice(bytesToSeek);
                this.privReplayOffset += retVal.byteLength / this.privBytesPerSecond * 1e+7;
                // If we've reached the end of the buffers, stop replaying.
                if (i === this.privBuffers.length - 1) this.privReplay = false;
                return Promise.resolve({
                    buffer: retVal,
                    isEnd: false,
                    timeReceived: this.privBuffers[i].chunk.timeReceived
                });
            }
        }
        return this.privAudioNode.read().then(function(result) {
            if (result && result.buffer) {
                _this.privBuffers.push(new $957a15295781bd24$var$BufferEntry(result, _this.privBufferSerial++, _this.privBufferedBytes));
                _this.privBufferedBytes += result.buffer.byteLength;
            }
            return result;
        });
    };
    ReplayableAudioNode.prototype.detach = function() {
        this.privBuffers = undefined;
        return this.privAudioNode.detach();
    };
    ReplayableAudioNode.prototype.replay = function() {
        if (this.privBuffers && 0 !== this.privBuffers.length) {
            this.privReplay = true;
            this.privReplayOffset = this.privLastShrinkOffset;
        }
    };
    // Shrinks the existing audio buffers to start at the new offset, or at the
    // beginning of the buffer closest to the requested offset.
    // A replay request will start from the last shrink point.
    ReplayableAudioNode.prototype.shrinkBuffers = function(offset) {
        if (this.privBuffers === undefined || this.privBuffers.length === 0) return;
        this.privLastShrinkOffset = offset;
        // Find the start point in the buffers.
        // Offsets are in 100ns increments.
        // So how many bytes do we need to seek to get the right offset?
        var offsetToSeek = offset - this.privBufferStartOffset;
        var bytesToSeek = Math.round(offsetToSeek * this.privBytesPerSecond * 1e-7);
        var i = 0;
        while(i < this.privBuffers.length && bytesToSeek >= this.privBuffers[i].chunk.buffer.byteLength)bytesToSeek -= this.privBuffers[i++].chunk.buffer.byteLength;
        this.privBufferStartOffset = Math.round(offset - bytesToSeek / this.privBytesPerSecond * 1e+7);
        this.privBuffers = this.privBuffers.slice(i);
    };
    // Finds the time a buffer of audio was first seen by offset.
    ReplayableAudioNode.prototype.findTimeAtOffset = function(offset) {
        if (offset < this.privBufferStartOffset || this.privBuffers === undefined) return 0;
        for(var _i = 0, _a = this.privBuffers; _i < _a.length; _i++){
            var value = _a[_i];
            var startOffset = value.byteOffset / this.privBytesPerSecond * 1e7;
            var endOffset = startOffset + value.chunk.buffer.byteLength / this.privBytesPerSecond * 1e7;
            if (offset >= startOffset && offset <= endOffset) return value.chunk.timeReceived;
        }
        return 0;
    };
    return ReplayableAudioNode;
}();
module.exports.ReplayableAudioNode = $957a15295781bd24$var$ReplayableAudioNode;
// Primary use of this class is to help debugging problems with the replay
// code. If the memory cost of alloc / dealloc gets too much, drop it and just use
// the ArrayBuffer directly.
var $957a15295781bd24$var$BufferEntry = /** @class */ function() {
    function BufferEntry(chunk, serial, byteOffset) {
        this.chunk = chunk;
        this.serial = serial;
        this.byteOffset = byteOffset;
    }
    return BufferEntry;
}();

});

parcelRequire.register("hk1SB", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ProxyInfo = void 0;

var $hM4QX = parcelRequire("hM4QX");
var $c9c5c32fe734ad0e$var$ProxyInfo = /** @class */ function() {
    function ProxyInfo(proxyHostName, proxyPort, proxyUserName, proxyPassword) {
        this.privProxyHostName = proxyHostName;
        this.privProxyPort = proxyPort;
        this.privProxyUserName = proxyUserName;
        this.privProxyPassword = proxyPassword;
    }
    ProxyInfo.fromParameters = function(parameters) {
        return new ProxyInfo(parameters.getProperty($hM4QX.PropertyId.SpeechServiceConnection_ProxyHostName), parseInt(parameters.getProperty($hM4QX.PropertyId.SpeechServiceConnection_ProxyPort), 10), parameters.getProperty($hM4QX.PropertyId.SpeechServiceConnection_ProxyUserName), parameters.getProperty($hM4QX.PropertyId.SpeechServiceConnection_ProxyPassword));
    };
    ProxyInfo.fromRecognizerConfig = function(config) {
        return this.fromParameters(config.parameters);
    };
    Object.defineProperty(ProxyInfo.prototype, "HostName", {
        get: function() {
            return this.privProxyHostName;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ProxyInfo.prototype, "Port", {
        get: function() {
            return this.privProxyPort;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ProxyInfo.prototype, "UserName", {
        get: function() {
            return this.privProxyUserName;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ProxyInfo.prototype, "Password", {
        get: function() {
            return this.privProxyPassword;
        },
        enumerable: false,
        configurable: true
    });
    return ProxyInfo;
}();
module.exports.ProxyInfo = $c9c5c32fe734ad0e$var$ProxyInfo;

});

parcelRequire.register("bnWMI", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
var $849f7121d4f9c64c$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $849f7121d4f9c64c$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $849f7121d4f9c64c$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RestMessageAdapter = module.exports.RestRequestType = void 0;

var $849f7121d4f9c64c$var$bent_1 = $849f7121d4f9c64c$var$__importDefault((parcelRequire("1poFJ")));

var $em8BD = parcelRequire("em8BD");
var $849f7121d4f9c64c$var$RestRequestType;
(function(RestRequestType) {
    RestRequestType["Get"] = "GET";
    RestRequestType["Post"] = "POST";
    RestRequestType["Delete"] = "DELETE";
    RestRequestType["File"] = "file";
})($849f7121d4f9c64c$var$RestRequestType = module.exports.RestRequestType || (module.exports.RestRequestType = {}));
// accept rest operations via request method and return abstracted objects from server response
var $849f7121d4f9c64c$var$RestMessageAdapter = /** @class */ function() {
    function RestMessageAdapter(configParams) {
        if (!configParams) throw new $em8BD.ArgumentNullError("configParams");
        this.privHeaders = configParams.headers;
        this.privIgnoreCache = configParams.ignoreCache;
    }
    RestMessageAdapter.extractHeaderValue = function(headerKey, headers) {
        var headerValue = "";
        try {
            var arr = headers.trim().split(/[\r\n]+/);
            var headerMap_1 = {};
            arr.forEach(function(line) {
                var parts = line.split(": ");
                var header = parts.shift().toLowerCase();
                var value = parts.join(": ");
                headerMap_1[header] = value;
            });
            headerValue = headerMap_1[headerKey.toLowerCase()];
        } catch (e) {
        // ignore the error
        }
        return headerValue;
    };
    Object.defineProperty(RestMessageAdapter.prototype, "options", {
        set: function(configParams) {
            this.privHeaders = configParams.headers;
            this.privIgnoreCache = configParams.ignoreCache;
        },
        enumerable: false,
        configurable: true
    });
    RestMessageAdapter.prototype.setHeaders = function(key, value) {
        this.privHeaders[key] = value;
    };
    RestMessageAdapter.prototype.request = function(method, uri, queryParams, body) {
        var _this = this;
        if (queryParams === void 0) queryParams = {};
        if (body === void 0) body = null;
        var responseReceivedDeferral = new $em8BD.Deferred();
        var requestCommand = method === $849f7121d4f9c64c$var$RestRequestType.File ? "POST" : method;
        var handleRestResponse = function(data, j) {
            if (j === void 0) j = {};
            var d = data;
            return {
                data: JSON.stringify(j),
                headers: JSON.stringify(data.headers),
                json: j,
                ok: data.statusCode >= 200 && data.statusCode < 300,
                status: data.statusCode,
                statusText: j.error ? j.error.message : d.statusText ? d.statusText : d.statusMessage
            };
        };
        var send = function(postData) {
            var sendRequest = $849f7121d4f9c64c$var$bent_1.default(uri, requestCommand, _this.privHeaders, 200, 201, 202, 204, 400, 401, 402, 403, 404);
            var params = _this.queryParams(queryParams) === "" ? "" : "?" + _this.queryParams(queryParams);
            sendRequest(params, postData).then(function(data) {
                return $849f7121d4f9c64c$var$__awaiter(_this, void 0, void 0, function() {
                    var j, _a;
                    return $849f7121d4f9c64c$var$__generator(this, function(_b) {
                        switch(_b.label){
                            case 0:
                                if (!(method === $849f7121d4f9c64c$var$RestRequestType.Delete || data.statusCode === 204)) return [
                                    3 /*break*/ ,
                                    1
                                ];
                                // No JSON from Delete and reset (204) operations
                                responseReceivedDeferral.resolve(handleRestResponse(data));
                                return [
                                    3 /*break*/ ,
                                    4
                                ];
                            case 1:
                                _b.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                return [
                                    4 /*yield*/ ,
                                    data.json()
                                ];
                            case 2:
                                j = _b.sent();
                                responseReceivedDeferral.resolve(handleRestResponse(data, j));
                                return [
                                    3 /*break*/ ,
                                    4
                                ];
                            case 3:
                                _a = _b.sent();
                                responseReceivedDeferral.resolve(handleRestResponse(data));
                                return [
                                    3 /*break*/ ,
                                    4
                                ];
                            case 4:
                                return [
                                    2 /*return*/ 
                                ];
                        }
                    });
                });
            }).catch(function(error) {
                responseReceivedDeferral.reject(error);
            });
        };
        if (this.privIgnoreCache) this.privHeaders["Cache-Control"] = "no-cache";
        if (method === $849f7121d4f9c64c$var$RestRequestType.Post && body) {
            this.privHeaders["content-type"] = "application/json";
            this.privHeaders["Content-Type"] = "application/json";
        }
        send(body);
        return responseReceivedDeferral.promise;
    };
    RestMessageAdapter.prototype.queryParams = function(params) {
        if (params === void 0) params = {};
        return Object.keys(params).map(function(k) {
            return encodeURIComponent(k) + "=" + encodeURIComponent(params[k]);
        }).join("&");
    };
    return RestMessageAdapter;
}();
module.exports.RestMessageAdapter = $849f7121d4f9c64c$var$RestMessageAdapter;

});
parcelRequire.register("1poFJ", function(module, exports) {
"use strict";

var $2QhZM = parcelRequire("2QhZM");
class $106b43969f5c992f$var$StatusError extends Error {
    constructor(res, ...params){
        super(...params);
        if (Error.captureStackTrace) Error.captureStackTrace(this, $106b43969f5c992f$var$StatusError);
        this.name = "StatusError";
        this.message = res.statusMessage;
        this.statusCode = res.status;
        this.res = res;
        this.json = res.json.bind(res);
        this.text = res.text.bind(res);
        this.arrayBuffer = res.arrayBuffer.bind(res);
        let buffer;
        const get = ()=>{
            if (!buffer) buffer = this.arrayBuffer();
            return buffer;
        };
        Object.defineProperty(this, "responseBody", {
            get: get
        });
        // match Node.js headers object
        this.headers = {};
        for (const [key, value] of res.headers.entries())this.headers[key.toLowerCase()] = value;
    }
}
const $106b43969f5c992f$var$mkrequest = (statusCodes, method, encoding, headers, baseurl)=>async (_url, body, _headers = {})=>{
        _url = baseurl + (_url || "");
        let parsed = new URL(_url);
        if (!headers) headers = {};
        if (parsed.username) {
            headers.Authorization = "Basic " + btoa(parsed.username + ":" + parsed.password);
            parsed = new URL(parsed.protocol + "//" + parsed.host + parsed.pathname + parsed.search);
        }
        if (parsed.protocol !== "https:" && parsed.protocol !== "http:") throw new Error(`Unknown protocol, ${parsed.protocol}`);
        if (body) {
            if (body instanceof ArrayBuffer || ArrayBuffer.isView(body) || typeof body === "string") ;
            else if (typeof body === "object") {
                body = JSON.stringify(body);
                headers["Content-Type"] = "application/json";
            } else throw new Error("Unknown body type.");
        }
        _headers = new Headers({
            ...headers || {},
            ..._headers
        });
        const resp = await fetch(parsed, {
            method: method,
            headers: _headers,
            body: body
        });
        resp.statusCode = resp.status;
        if (!statusCodes.has(resp.status)) throw new $106b43969f5c992f$var$StatusError(resp);
        if (encoding === "json") return resp.json();
        else if (encoding === "buffer") return resp.arrayBuffer();
        else if (encoding === "string") return resp.text();
        else return resp;
    };
module.exports = $2QhZM($106b43969f5c992f$var$mkrequest);

});
parcelRequire.register("2QhZM", function(module, exports) {
"use strict";
const $211e659c01b3e71c$var$encodings = new Set([
    "json",
    "buffer",
    "string"
]);
module.exports = (mkrequest)=>(...args)=>{
        const statusCodes = new Set();
        let method;
        let encoding;
        let headers;
        let baseurl = "";
        args.forEach((arg)=>{
            if (typeof arg === "string") {
                if (arg.toUpperCase() === arg) {
                    if (method) {
                        const msg = `Can't set method to ${arg}, already set to ${method}.`;
                        throw new Error(msg);
                    } else method = arg;
                } else if (arg.startsWith("http:") || arg.startsWith("https:")) baseurl = arg;
                else {
                    if ($211e659c01b3e71c$var$encodings.has(arg)) encoding = arg;
                    else throw new Error(`Unknown encoding, ${arg}`);
                }
            } else if (typeof arg === "number") statusCodes.add(arg);
            else if (typeof arg === "object") {
                if (Array.isArray(arg) || arg instanceof Set) arg.forEach((code)=>statusCodes.add(code));
                else {
                    if (headers) throw new Error("Cannot set headers twice.");
                    headers = arg;
                }
            } else throw new Error(`Unknown type: ${typeof arg}`);
        });
        if (!method) method = "GET";
        if (statusCodes.size === 0) statusCodes.add(200);
        return mkrequest(statusCodes, method, encoding, headers, baseurl);
    };

});







parcelRequire.register("kBJXM", function(module, exports) {
"use strict";

var $clWYw = parcelRequire("clWYw");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $f00aeaa965b0a69e$var$_default;

var $f00aeaa965b0a69e$var$_pDeferEs = $clWYw((parcelRequire("5la41")));
function $f00aeaa965b0a69e$var$_default() {
    var shiftDeferred;
    var queue = [];
    var push = function push(value) {
        if (shiftDeferred) {
            var _shiftDeferred = shiftDeferred, resolve = _shiftDeferred.resolve;
            shiftDeferred = null;
            resolve(value);
        } else queue.push(value);
    };
    var shift = function shift() {
        if (queue.length) return Promise.resolve(queue.shift());
        return (shiftDeferred || (shiftDeferred = (0, $f00aeaa965b0a69e$var$_pDeferEs.default)())).promise;
    };
    return {
        push: push,
        shift: shift
    };
}

});

parcelRequire.register("240sx", function(module, exports) {
"use strict";

var $clWYw = parcelRequire("clWYw");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $180c4fb84cf97bfb$var$patchOptions;

var $180c4fb84cf97bfb$var$_regenerator = $clWYw((parcelRequire("ilkkY")));

var $180c4fb84cf97bfb$var$_defineProperty2 = $clWYw((parcelRequire("0ITDg")));

var $180c4fb84cf97bfb$var$_asyncToGenerator2 = $clWYw((parcelRequire("f4cyQ")));

var $180c4fb84cf97bfb$var$_objectWithoutProperties2 = $clWYw((parcelRequire("3dibB")));

var $180c4fb84cf97bfb$var$_resolveFunctionOrReturnValue = $clWYw((parcelRequire("85o5X")));
var $180c4fb84cf97bfb$var$_excluded = [
    "authorizationToken",
    "credentials",
    "looseEvent",
    "looseEvents",
    "region",
    "subscriptionKey"
];
function $180c4fb84cf97bfb$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $180c4fb84cf97bfb$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $180c4fb84cf97bfb$var$ownKeys(Object(source), !0).forEach(function(key) {
            (0, $180c4fb84cf97bfb$var$_defineProperty2.default)(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $180c4fb84cf97bfb$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var $180c4fb84cf97bfb$var$shouldWarnOnSubscriptionKey = true;
function $180c4fb84cf97bfb$var$patchOptions() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var authorizationToken = _ref.authorizationToken, credentials = _ref.credentials, looseEvent = _ref.looseEvent, looseEvents = _ref.looseEvents, _ref$region = _ref.region, region = _ref$region === void 0 ? "westus" : _ref$region, subscriptionKey = _ref.subscriptionKey, otherOptions = (0, $180c4fb84cf97bfb$var$_objectWithoutProperties2.default)(_ref, $180c4fb84cf97bfb$var$_excluded);
    if (typeof looseEvent !== "undefined") {
        console.warn('web-speech-cognitive-services: The option "looseEvent" should be named as "looseEvents".');
        looseEvents = looseEvent;
    }
    if (!credentials) {
        if (!authorizationToken && !subscriptionKey) throw new Error("web-speech-cognitive-services: Credentials must be specified.");
        else {
            console.warn("web-speech-cognitive-services: We are deprecating authorizationToken, region, and subscriptionKey. Please use credentials instead. The deprecated option will be removed on or after 2020-11-14.");
            credentials = /*#__PURE__*/ function() {
                var _ref2 = (0, $180c4fb84cf97bfb$var$_asyncToGenerator2.default)(/*#__PURE__*/ $180c4fb84cf97bfb$var$_regenerator.default.mark(function _callee() {
                    return $180c4fb84cf97bfb$var$_regenerator.default.wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                if (!authorizationToken) {
                                    _context.next = 8;
                                    break;
                                }
                                _context.next = 3;
                                return (0, $180c4fb84cf97bfb$var$_resolveFunctionOrReturnValue.default)(authorizationToken);
                            case 3:
                                _context.t1 = _context.sent;
                                _context.t2 = region;
                                _context.t0 = {
                                    authorizationToken: _context.t1,
                                    region: _context.t2
                                };
                                _context.next = 13;
                                break;
                            case 8:
                                _context.t3 = region;
                                _context.next = 11;
                                return (0, $180c4fb84cf97bfb$var$_resolveFunctionOrReturnValue.default)(subscriptionKey);
                            case 11:
                                _context.t4 = _context.sent;
                                _context.t0 = {
                                    region: _context.t3,
                                    subscriptionKey: _context.t4
                                };
                            case 13:
                                return _context.abrupt("return", _context.t0);
                            case 14:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee);
                }));
                return function credentials() {
                    return _ref2.apply(this, arguments);
                };
            }();
        }
    }
    return $180c4fb84cf97bfb$var$_objectSpread($180c4fb84cf97bfb$var$_objectSpread({}, otherOptions), {}, {
        fetchCredentials: function() {
            var _fetchCredentials = (0, $180c4fb84cf97bfb$var$_asyncToGenerator2.default)(/*#__PURE__*/ $180c4fb84cf97bfb$var$_regenerator.default.mark(function _callee2() {
                var _yield$resolveFunctio, authorizationToken, customVoiceHostname, region, speechRecognitionHostname, speechSynthesisHostname, subscriptionKey, resolvedCredentials;
                return $180c4fb84cf97bfb$var$_regenerator.default.wrap(function _callee2$(_context2) {
                    while(true)switch(_context2.prev = _context2.next){
                        case 0:
                            _context2.next = 2;
                            return (0, $180c4fb84cf97bfb$var$_resolveFunctionOrReturnValue.default)(credentials);
                        case 2:
                            _yield$resolveFunctio = _context2.sent;
                            authorizationToken = _yield$resolveFunctio.authorizationToken;
                            customVoiceHostname = _yield$resolveFunctio.customVoiceHostname;
                            region = _yield$resolveFunctio.region;
                            speechRecognitionHostname = _yield$resolveFunctio.speechRecognitionHostname;
                            speechSynthesisHostname = _yield$resolveFunctio.speechSynthesisHostname;
                            subscriptionKey = _yield$resolveFunctio.subscriptionKey;
                            if (!(!authorizationToken && !subscriptionKey || authorizationToken && subscriptionKey)) {
                                _context2.next = 13;
                                break;
                            }
                            throw new Error('web-speech-cognitive-services: Either "authorizationToken" or "subscriptionKey" must be provided.');
                        case 13:
                            if (!(!region && !(speechRecognitionHostname && speechSynthesisHostname))) {
                                _context2.next = 17;
                                break;
                            }
                            throw new Error('web-speech-cognitive-services: Either "region" or "speechRecognitionHostname" and "speechSynthesisHostname" must be set.');
                        case 17:
                            if (!(region && (customVoiceHostname || speechRecognitionHostname || speechSynthesisHostname))) {
                                _context2.next = 21;
                                break;
                            }
                            throw new Error('web-speech-cognitive-services: Only either "region" or "customVoiceHostname", "speechRecognitionHostname" and "speechSynthesisHostname" can be set.');
                        case 21:
                            if (!authorizationToken) {
                                _context2.next = 26;
                                break;
                            }
                            if (!(typeof authorizationToken !== "string")) {
                                _context2.next = 24;
                                break;
                            }
                            throw new Error('web-speech-cognitive-services: "authorizationToken" must be a string.');
                        case 24:
                            _context2.next = 28;
                            break;
                        case 26:
                            if (!(typeof subscriptionKey !== "string")) {
                                _context2.next = 28;
                                break;
                            }
                            throw new Error('web-speech-cognitive-services: "subscriptionKey" must be a string.');
                        case 28:
                            if ($180c4fb84cf97bfb$var$shouldWarnOnSubscriptionKey && subscriptionKey) {
                                console.warn("web-speech-cognitive-services: In production environment, subscription key should not be used, authorization token should be used instead.");
                                $180c4fb84cf97bfb$var$shouldWarnOnSubscriptionKey = false;
                            }
                            resolvedCredentials = authorizationToken ? {
                                authorizationToken: authorizationToken
                            } : {
                                subscriptionKey: subscriptionKey
                            };
                            if (region) resolvedCredentials.region = region;
                            else {
                                resolvedCredentials.customVoiceHostname = customVoiceHostname;
                                resolvedCredentials.speechRecognitionHostname = speechRecognitionHostname;
                                resolvedCredentials.speechSynthesisHostname = speechSynthesisHostname;
                            }
                            return _context2.abrupt("return", resolvedCredentials);
                        case 32:
                        case "end":
                            return _context2.stop();
                    }
                }, _callee2);
            }));
            function fetchCredentials() {
                return _fetchCredentials.apply(this, arguments);
            }
            return fetchCredentials;
        }(),
        looseEvents: looseEvents
    });
}

});
parcelRequire.register("3dibB", function(module, exports) {

var $heScU = parcelRequire("heScU");
function $2570b167c424e6bf$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $heScU(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
module.exports = $2570b167c424e6bf$var$_objectWithoutProperties, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRequire.register("heScU", function(module, exports) {
function $c8cdcae274f56604$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
module.exports = $c8cdcae274f56604$var$_objectWithoutPropertiesLoose, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRequire.register("85o5X", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $5e317b207e1f8fdf$var$resolveFunctionOrReturnValue;
function $5e317b207e1f8fdf$var$resolveFunctionOrReturnValue(fnOrValue) {
    return typeof fnOrValue === "function" ? fnOrValue() : fnOrValue;
}

});


parcelRequire.register("1BJRz", function(module, exports) {
"use strict";

var $clWYw = parcelRequire("clWYw");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $12bcd29bd5f54f18$var$_classCallCheck2 = $clWYw((parcelRequire("kFs3a")));

var $12bcd29bd5f54f18$var$_createClass2 = $clWYw((parcelRequire("kkabb")));
/* eslint class-methods-use-this: "off" */ var $12bcd29bd5f54f18$var$_default = /*#__PURE__*/ function() {
    function _default() {
        (0, $12bcd29bd5f54f18$var$_classCallCheck2.default)(this, _default);
        this._phrases = [];
    }
    (0, $12bcd29bd5f54f18$var$_createClass2.default)(_default, [
        {
            key: "addFromString",
            value: function addFromString() {
                throw new Error("JSGF is not supported");
            }
        },
        {
            key: "phrases",
            get: function get() {
                return this._phrases;
            },
            set: function set(value) {
                if (Array.isArray(value)) this._phrases = value;
                else if (typeof value === "string") this._phrases = [
                    value
                ];
                else throw new Error("The provided value is not an array or of type 'string'");
            }
        }
    ]);
    return _default;
}();
module.exports.default = $12bcd29bd5f54f18$var$_default;

});



parcelRequire.register("tFivm", function(module, exports) {
"use strict";

var $clWYw = parcelRequire("clWYw");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0592be5d5bf53c72$var$_createSpeechSynthesisPonyfill = $clWYw((parcelRequire("90yC2")));
var $0592be5d5bf53c72$var$_default = $0592be5d5bf53c72$var$_createSpeechSynthesisPonyfill.default;
module.exports.default = $0592be5d5bf53c72$var$_default;

});
parcelRequire.register("90yC2", function(module, exports) {
"use strict";

var $clWYw = parcelRequire("clWYw");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $68eef677d68c073a$var$_regenerator = $clWYw((parcelRequire("ilkkY")));

var $68eef677d68c073a$var$_asyncToGenerator2 = $clWYw((parcelRequire("f4cyQ")));

var $68eef677d68c073a$var$_classCallCheck2 = $clWYw((parcelRequire("kFs3a")));

var $68eef677d68c073a$var$_createClass2 = $clWYw((parcelRequire("kkabb")));

var $68eef677d68c073a$var$_inherits2 = $clWYw((parcelRequire("edsvT")));

var $68eef677d68c073a$var$_possibleConstructorReturn2 = $clWYw((parcelRequire("lKMYv")));

var $68eef677d68c073a$var$_getPrototypeOf2 = $clWYw((parcelRequire("iXZmE")));

var $bgEWP = parcelRequire("bgEWP");

var $68eef677d68c073a$var$_SpeechSDK = $clWYw((parcelRequire("gLWFf")));

var $boVMX = parcelRequire("boVMX");
var $feGef = parcelRequire("feGef");

var $68eef677d68c073a$var$_patchOptions2 = $clWYw((parcelRequire("240sx")));

var $68eef677d68c073a$var$_SpeechSynthesisEvent = $clWYw((parcelRequire("8h1lI")));

var $68eef677d68c073a$var$_SpeechSynthesisUtterance = $clWYw((parcelRequire("O7wfL")));

var $68eef677d68c073a$var$_SpeechSynthesisVoice = $clWYw((parcelRequire("4t9QW")));
function $68eef677d68c073a$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $68eef677d68c073a$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, $68eef677d68c073a$var$_getPrototypeOf2.default)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $68eef677d68c073a$var$_getPrototypeOf2.default)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $68eef677d68c073a$var$_possibleConstructorReturn2.default)(this, result);
    };
}
function $68eef677d68c073a$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
var $68eef677d68c073a$var$_default = function _default(options) {
    // Extract parameters from options using the patchOptions function
    var _patchOptions = (0, $68eef677d68c073a$var$_patchOptions2.default)(options), audioContext = _patchOptions.audioContext, fetchCredentials = _patchOptions.fetchCredentials, _patchOptions$ponyfil = _patchOptions.ponyfill, ponyfill = _patchOptions$ponyfil === void 0 ? {
        AudioContext: window.AudioContext || window.webkitAudioContext
    } : _patchOptions$ponyfil, speechSynthesisDeploymentId = _patchOptions.speechSynthesisDeploymentId; // Check if the browser supports the Web Audio API, if not, return an empty object
    if (!audioContext && !ponyfill.AudioContext) {
        console.warn("web-speech-cognitive-services: This browser does not support Web Audio and it will not work with Cognitive Services Speech Services.");
        return {};
    }
    var SpeechSynthesis = /*#__PURE__*/ function(_EventTarget) {
        (0, $68eef677d68c073a$var$_inherits2.default)(SpeechSynthesis, _EventTarget);
        var _super = $68eef677d68c073a$var$_createSuper(SpeechSynthesis);
        function SpeechSynthesis() {
            var _this;
            (0, $68eef677d68c073a$var$_classCallCheck2.default)(this, SpeechSynthesis);
            _this = _super.call(this);
            _this.speaking = false;
            _this.speakerAudioDestination = new $feGef.SpeakerAudioDestination();
            _this.audioConfig = audioContext ? $68eef677d68c073a$var$_SpeechSDK.default.AudioConfig.fromAudioContext(audioContext) : $boVMX.AudioConfig.fromSpeakerOutput(_this.speakerAudioDestination); // Init synthesizer
            _this.initSpeechSynthesizer(); // Initialize the queue for managing the utterances
            _this.queue = [];
            _this.canceled = false;
            return _this;
        }
        (0, $68eef677d68c073a$var$_createClass2.default)(SpeechSynthesis, [
            {
                key: "mute",
                value: function mute() {
                    this.speakerAudioDestination && this.speakerAudioDestination.mute();
                }
            },
            {
                key: "unmute",
                value: function unmute() {
                    this.speakerAudioDestination && this.speakerAudioDestination.unmute();
                }
            },
            {
                key: "getVolume",
                value: function getVolume() {
                    // eslint-disable-next-line no-magic-numbers
                    return this.speakerAudioDestination ? this.speakerAudioDestination.volume : -1;
                }
            },
            {
                key: "setVolume",
                value: function setVolume(value) {
                    this.speakerAudioDestination && (this.speakerAudioDestination.volume = value);
                } // Asynchronous function that initializes the speech synthesizer class
            },
            {
                key: "initSpeechSynthesizer",
                value: function() {
                    var _initSpeechSynthesizer = (0, $68eef677d68c073a$var$_asyncToGenerator2.default)(/*#__PURE__*/ $68eef677d68c073a$var$_regenerator.default.mark(function _callee() {
                        var _yield$fetchCredentia, speechSynthesisHostname, subscriptionKey, authorizationToken, region, hostname, url;
                        return $68eef677d68c073a$var$_regenerator.default.wrap(function _callee$(_context) {
                            while(true)switch(_context.prev = _context.next){
                                case 0:
                                    _context.next = 2;
                                    return fetchCredentials();
                                case 2:
                                    _yield$fetchCredentia = _context.sent;
                                    speechSynthesisHostname = _yield$fetchCredentia.speechSynthesisHostname;
                                    subscriptionKey = _yield$fetchCredentia.subscriptionKey;
                                    authorizationToken = _yield$fetchCredentia.authorizationToken;
                                    region = _yield$fetchCredentia.region;
                                    if (!(!authorizationToken && !subscriptionKey)) {
                                        _context.next = 9;
                                        break;
                                    }
                                    throw new Error("no subscription data : authorizationToken or subscriptionKey needed");
                                case 9:
                                    // Configure the synthesizer and audio
                                    if (speechSynthesisDeploymentId) {
                                        hostname = speechSynthesisHostname || "".concat(region, ".customvoice.api.speech.microsoft.com");
                                        url = "https://".concat(encodeURI(hostname), "/api/texttospeech/v2.0/endpoints/").concat(encodeURIComponent(speechSynthesisDeploymentId));
                                        this.speechConfig = $68eef677d68c073a$var$_SpeechSDK.default.SpeechConfig.fromEndpoint(url, subscriptionKey);
                                    } else if (speechSynthesisHostname) this.speechConfig = $68eef677d68c073a$var$_SpeechSDK.default.SpeechConfig.fromHost(speechSynthesisHostname, subscriptionKey);
                                    else this.speechConfig = authorizationToken ? $68eef677d68c073a$var$_SpeechSDK.default.SpeechConfig.fromAuthorizationToken(authorizationToken, region) : $68eef677d68c073a$var$_SpeechSDK.default.SpeechConfig.fromSubscription(subscriptionKey, region);
                                    this.synth = new $68eef677d68c073a$var$_SpeechSDK.default.SpeechSynthesizer(this.speechConfig, this.audioConfig); // Update available voices
                                    this.updateVoices();
                                case 12:
                                case "end":
                                    return _context.stop();
                            }
                        }, _callee, this);
                    }));
                    function initSpeechSynthesizer() {
                        return _initSpeechSynthesizer.apply(this, arguments);
                    }
                    return initSpeechSynthesizer;
                }() // Function to recreate the synthesizer
            },
            {
                key: "recreateSynthesizer",
                value: function recreateSynthesizer() {
                    var voice = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
                    this.speakerAudioDestination = new $feGef.SpeakerAudioDestination();
                    this.audioConfig = audioContext ? $68eef677d68c073a$var$_SpeechSDK.default.AudioConfig.fromAudioContext(audioContext) : $boVMX.AudioConfig.fromSpeakerOutput(this.speakerAudioDestination);
                    if (voice) {
                        var tempSpeechConfig = this.speechConfig;
                        tempSpeechConfig.speechSynthesisVoiceName = voice;
                        this.synth = new $68eef677d68c073a$var$_SpeechSDK.default.SpeechSynthesizer(tempSpeechConfig, this.audioConfig);
                    } else this.synth = new $68eef677d68c073a$var$_SpeechSDK.default.SpeechSynthesizer(this.speechConfig, this.audioConfig);
                } // Cancel current synthesis
            },
            {
                key: "cancel",
                value: function cancel() {
                    if (this.synth.synthesisstarted && !this.synth.synthesiscompleted) {
                        this.synth.close();
                        this.queue = [];
                    } else if (this.speaking) try {
                        this.speakerAudioDestination.pause();
                        this.speakerAudioDestination.onAudioEnd();
                        this.speakerAudioDestination.close();
                    } catch (e) {
                        console.warn(e);
                    }
                    this.queue = [];
                    this.canceled = true;
                } // Pause current synthesis
            },
            {
                key: "pause",
                value: function pause() {
                    if (this.speakerAudioDestination) this.speakerAudioDestination.pause();
                } // Resume current synthesis
            },
            {
                key: "resume",
                value: function resume() {
                    if (this.speakerAudioDestination && !this.canceled) this.speakerAudioDestination.resume();
                } // Function that returns an empty array of available voices
            },
            {
                key: "getVoices",
                value: function getVoices() {
                    return this.EMPTY_ARRAY;
                } // Function that returns the 'onvoiceschanged' attribute of the object
            },
            {
                key: "onvoiceschanged",
                get: function get() {
                    return (0, $bgEWP.getEventAttributeValue)(this, "voiceschanged");
                } // Function that updates the 'onvoiceschanged' attribute of the object
                ,
                set: function set(value) {
                    (0, $bgEWP.setEventAttributeValue)(this, "voiceschanged", value);
                }
            },
            {
                key: "speak",
                value: function speak(utterance) {
                    var _this2 = this;
                    // Test utterance
                    if (!(utterance instanceof $68eef677d68c073a$var$_SpeechSynthesisUtterance.default)) throw new Error("invalid utterance");
                     // Add the utterance to the queue
                    this.queue.push(utterance); // Function to process the queued utterances
                    var processQueue = function processQueue() {
                        if (_this2.queue.length && !_this2.speaking) {
                            var currentUtterance = _this2.queue.shift(); // Get the next utterance from the queue
                            var isSSML = /<[s\u017F]pea[k\u212A](?:[\0-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])*?>/i.test(currentUtterance.text);
                            if (currentUtterance.voice && (currentUtterance.voice.voiceURI || currentUtterance.voice._name)) _this2.recreateSynthesizer(currentUtterance.voice.voiceURI || currentUtterance.voice._name);
                            else if (_this2.speakerAudioDestination.isClosed) _this2.recreateSynthesizer();
                             // Set volume / mute status if present in the utterance parameters
                            currentUtterance.volume && (_this2.speakerAudioDestination.volume = currentUtterance.volume); // SpeakerAudioDestination events callbacks
                            _this2.speakerAudioDestination.onAudioStart = function() {
                                _this2.speaking = true;
                                var event = new $68eef677d68c073a$var$_SpeechSynthesisEvent.default("start");
                                currentUtterance.dispatchEvent(event);
                            };
                            _this2.speakerAudioDestination.onAudioEnd = function() {
                                _this2.speaking = false;
                                var event = new $68eef677d68c073a$var$_SpeechSynthesisEvent.default("end");
                                currentUtterance.dispatchEvent(event);
                                processQueue(); // Process the next queued utterance after the current one has finished
                            }; // Events callbacks
                            _this2.synth.synthesisStarted = function() {
                                currentUtterance.onsynthesisstart && currentUtterance.onsynthesisstart();
                            };
                            _this2.synth.synthesisCompleted = function() {
                                currentUtterance.onsynthesiscompleted && currentUtterance.onsynthesiscompleted();
                            };
                            _this2.synth.error = function(synth, e) {
                                var event = new $68eef677d68c073a$var$_SpeechSynthesisEvent.default("error");
                                event.errorDetails = e;
                                currentUtterance.dispatchEvent(event);
                            };
                            _this2.synth.wordBoundary = function(synth, e) {
                                var event = new $68eef677d68c073a$var$_SpeechSynthesisEvent.default("boundary");
                                event.boundaryType = e.privBoundaryType;
                                event.name = e.privText;
                                event.elapsedTime = e.privAudioOffset;
                                event.duration = e.privDuration;
                                currentUtterance.dispatchEvent(event);
                            };
                            _this2.synth.visemeReceived = function(synth, e) {
                                // Create a new SpeechSynthesisEvent of type 'boundary' that is returned as a boundary.
                                var event = new $68eef677d68c073a$var$_SpeechSynthesisEvent.default("boundary");
                                event.boundaryType = "Viseme";
                                event.name = e.privVisemeId;
                                event.elapsedTime = e.privAudioOffset;
                                event.duration = 0;
                                currentUtterance.dispatchEvent(event); // Create a new SpeechSynthesisEvent of type 'viseme' that is sent to a custom 'onviseme' method
                                var event2 = new $68eef677d68c073a$var$_SpeechSynthesisEvent.default("viseme");
                                event2.boundaryType = "Viseme";
                                event2.name = e.privVisemeId;
                                event2.elapsedTime = e.privAudioOffset;
                                event2.duration = 0;
                                currentUtterance.dispatchEvent(event2);
                            };
                            _this2.synth.bookmarkReached = function(synth, e) {
                                var event = new $68eef677d68c073a$var$_SpeechSynthesisEvent.default("mark");
                                event.name = e.privText;
                                event.elapsedTime = e.privAudioOffset;
                                currentUtterance.dispatchEvent(event);
                            };
                            return isSSML ? new Promise(function(resolve, reject) {
                                _this2.synth.speakSsmlAsync(currentUtterance.text, function(result) {
                                    if (result) {
                                        _this2.synth.close();
                                        resolve();
                                    } else reject(new Error("No synthesis result."));
                                }, function(error) {
                                    reject(new Error("Synthesis failed : ", error));
                                });
                            }) : new Promise(function(resolve, reject) {
                                _this2.synth.speakTextAsync(currentUtterance.text, function(result) {
                                    if (result) {
                                        _this2.synth.close();
                                        resolve();
                                    } else reject(new Error("No synthesis result."));
                                }, function(error) {
                                    reject(new Error("Synthesis failed : ", error));
                                });
                            });
                        }
                    };
                    processQueue(); // Start processing the queue
                    this.canceled = false; // Reset canceled state after processing the queue
                } // Asynchronous function that updates available voices
            },
            {
                key: "updateVoices",
                value: function() {
                    var _updateVoices = (0, $68eef677d68c073a$var$_asyncToGenerator2.default)(/*#__PURE__*/ $68eef677d68c073a$var$_regenerator.default.mark(function _callee2() {
                        var voicesResult, voices, formattedVoices;
                        return $68eef677d68c073a$var$_regenerator.default.wrap(function _callee2$(_context2) {
                            while(true)switch(_context2.prev = _context2.next){
                                case 0:
                                    _context2.next = 2;
                                    return this.synth.getVoicesAsync();
                                case 2:
                                    voicesResult = _context2.sent;
                                    voices = voicesResult.privVoices;
                                    if (Array.isArray(voices)) {
                                        formattedVoices = voices.map(function(voice) {
                                            return new $68eef677d68c073a$var$_SpeechSynthesisVoice.default({
                                                gender: voice.gender,
                                                lang: voice.locale,
                                                voiceURI: voice.name
                                            });
                                        });
                                        this.getVoices = function() {
                                            return formattedVoices;
                                        };
                                    } else console.warn("Failed to retrieve voices. 'voices' is not an array.");
                                     // Trigger the 'voiceschanged' event to notify the voices update
                                    this.dispatchEvent(new Event("voiceschanged"));
                                case 6:
                                case "end":
                                    return _context2.stop();
                            }
                        }, _callee2, this);
                    }));
                    function updateVoices() {
                        return _updateVoices.apply(this, arguments);
                    }
                    return updateVoices;
                }()
            }
        ]);
        return SpeechSynthesis;
    }($bgEWP.EventTarget); // Return the object containing the instance of the speech synthesis, the SpeechSynthesisEvent and SpeechSynthesisUtterance classes
    return {
        speechSynthesis: new SpeechSynthesis(),
        SpeechSynthesisEvent: $68eef677d68c073a$var$_SpeechSynthesisEvent.default,
        SpeechSynthesisUtterance: $68eef677d68c073a$var$_SpeechSynthesisUtterance.default
    };
};
module.exports.default = $68eef677d68c073a$var$_default;

});
parcelRequire.register("boVMX", function(module, exports) {

$parcel$export(module.exports, "AudioConfig", () => $84cec33d1dd2ea9c$export$3b730bf34c92a0f9);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
parcelRequire("2iayq");
var $3uS3N = parcelRequire("3uS3N");
var $7FTUT = parcelRequire("7FTUT");
var $35uUw = parcelRequire("35uUw");

var $8HmyV = parcelRequire("8HmyV");

var $gcbed = parcelRequire("gcbed");
var $9QD3l = parcelRequire("9QD3l");
var $isMcl = parcelRequire("isMcl");
var $ckEpY = parcelRequire("ckEpY");
var $feGef = parcelRequire("feGef");

var $3JFU9 = parcelRequire("3JFU9");

var $gcbed = parcelRequire("gcbed");

var $isMcl = parcelRequire("isMcl");
class $84cec33d1dd2ea9c$export$3b730bf34c92a0f9 {
    /**
     * Creates an AudioConfig object representing the default microphone on the system.
     * @member AudioConfig.fromDefaultMicrophoneInput
     * @function
     * @public
     * @returns {AudioConfig} The audio input configuration being created.
     */ static fromDefaultMicrophoneInput() {
        const pcmRecorder = new (0, $3uS3N.PcmRecorder)(true);
        return new $84cec33d1dd2ea9c$export$7da309f8663a918b(new (0, $7FTUT.MicAudioSource)(pcmRecorder));
    }
    /**
     * Creates an AudioConfig object representing a microphone with the specified device ID.
     * @member AudioConfig.fromMicrophoneInput
     * @function
     * @public
     * @param {string | undefined} deviceId - Specifies the device ID of the microphone to be used.
     * Default microphone is used the value is omitted.
     * @returns {AudioConfig} The audio input configuration being created.
     */ static fromMicrophoneInput(deviceId) {
        const pcmRecorder = new (0, $3uS3N.PcmRecorder)(true);
        return new $84cec33d1dd2ea9c$export$7da309f8663a918b(new (0, $7FTUT.MicAudioSource)(pcmRecorder, deviceId));
    }
    /**
     * Creates an AudioConfig object representing the specified file.
     * @member AudioConfig.fromWavFileInput
     * @function
     * @public
     * @param {File} fileName - Specifies the audio input file. Currently, only WAV / PCM is supported.
     * @returns {AudioConfig} The audio input configuration being created.
     */ static fromWavFileInput(file, name = "unnamedBuffer.wav") {
        return new $84cec33d1dd2ea9c$export$7da309f8663a918b(new (0, $35uUw.FileAudioSource)(file, name));
    }
    /**
     * Creates an AudioConfig object representing the specified stream.
     * @member AudioConfig.fromStreamInput
     * @function
     * @public
     * @param {AudioInputStream | PullAudioInputStreamCallback | MediaStream} audioStream - Specifies the custom audio input
     * stream. Currently, only WAV / PCM is supported.
     * @returns {AudioConfig} The audio input configuration being created.
     */ static fromStreamInput(audioStream) {
        if (audioStream instanceof (0, $9QD3l.PullAudioInputStreamCallback)) return new $84cec33d1dd2ea9c$export$7da309f8663a918b(new (0, $gcbed.PullAudioInputStreamImpl)(audioStream));
        if (audioStream instanceof (0, $gcbed.AudioInputStream)) return new $84cec33d1dd2ea9c$export$7da309f8663a918b(audioStream);
        if (typeof MediaStream !== "undefined" && audioStream instanceof MediaStream) {
            const pcmRecorder = new (0, $3uS3N.PcmRecorder)(false);
            return new $84cec33d1dd2ea9c$export$7da309f8663a918b(new (0, $7FTUT.MicAudioSource)(pcmRecorder, null, null, audioStream));
        }
        throw new Error("Not Supported Type");
    }
    /**
     * Creates an AudioConfig object representing the default speaker.
     * @member AudioConfig.fromDefaultSpeakerOutput
     * @function
     * @public
     * @returns {AudioConfig} The audio output configuration being created.
     * Added in version 1.11.0
     */ static fromDefaultSpeakerOutput() {
        return new $84cec33d1dd2ea9c$export$6474c8308a86365e(new (0, $feGef.SpeakerAudioDestination)());
    }
    /**
     * Creates an AudioConfig object representing the custom IPlayer object.
     * You can use the IPlayer object to control pause, resume, etc.
     * @member AudioConfig.fromSpeakerOutput
     * @function
     * @public
     * @param {IPlayer} player - the IPlayer object for playback.
     * @returns {AudioConfig} The audio output configuration being created.
     * Added in version 1.12.0
     */ static fromSpeakerOutput(player) {
        if (player === undefined) return $84cec33d1dd2ea9c$export$3b730bf34c92a0f9.fromDefaultSpeakerOutput();
        if (player instanceof (0, $feGef.SpeakerAudioDestination)) return new $84cec33d1dd2ea9c$export$6474c8308a86365e(player);
        throw new Error("Not Supported Type");
    }
    /**
     * Creates an AudioConfig object representing a specified output audio file
     * @member AudioConfig.fromAudioFileOutput
     * @function
     * @public
     * @param {PathLike} filename - the filename of the output audio file
     * @returns {AudioConfig} The audio output configuration being created.
     * Added in version 1.11.0
     */ static fromAudioFileOutput(filename) {
        return new $84cec33d1dd2ea9c$export$6474c8308a86365e(new (0, $3JFU9.AudioFileWriter)(filename));
    }
    /**
     * Creates an AudioConfig object representing a specified audio output stream
     * @member AudioConfig.fromStreamOutput
     * @function
     * @public
     * @param {AudioOutputStream | PushAudioOutputStreamCallback} audioStream - Specifies the custom audio output
     * stream.
     * @returns {AudioConfig} The audio output configuration being created.
     * Added in version 1.11.0
     */ static fromStreamOutput(audioStream) {
        if (audioStream instanceof (0, $ckEpY.PushAudioOutputStreamCallback)) return new $84cec33d1dd2ea9c$export$6474c8308a86365e(new (0, $isMcl.PushAudioOutputStreamImpl)(audioStream));
        if (audioStream instanceof (0, $isMcl.PushAudioOutputStream)) return new $84cec33d1dd2ea9c$export$6474c8308a86365e(audioStream);
        if (audioStream instanceof (0, $isMcl.PullAudioOutputStream)) return new $84cec33d1dd2ea9c$export$6474c8308a86365e(audioStream);
        throw new Error("Not Supported Type");
    }
}
class $84cec33d1dd2ea9c$export$7da309f8663a918b extends $84cec33d1dd2ea9c$export$3b730bf34c92a0f9 {
    /**
     * Creates and initializes an instance of this class.
     * @constructor
     * @param {IAudioSource} source - An audio source.
     */ constructor(source){
        super();
        this.privSource = source;
    }
    /**
     * Format information for the audio
     */ get format() {
        return this.privSource.format;
    }
    /**
     * @member AudioConfigImpl.prototype.close
     * @function
     * @public
     */ close(cb, err) {
        this.privSource.turnOff().then(()=>{
            if (!!cb) cb();
        }, (error)=>{
            if (!!err) err(error);
        });
    }
    /**
     * @member AudioConfigImpl.prototype.id
     * @function
     * @public
     */ id() {
        return this.privSource.id();
    }
    /**
     * @member AudioConfigImpl.prototype.turnOn
     * @function
     * @public
     * @returns {Promise<void>} A promise.
     */ turnOn() {
        return this.privSource.turnOn();
    }
    /**
     * @member AudioConfigImpl.prototype.attach
     * @function
     * @public
     * @param {string} audioNodeId - The audio node id.
     * @returns {Promise<IAudioStreamNode>} A promise.
     */ attach(audioNodeId) {
        return this.privSource.attach(audioNodeId);
    }
    /**
     * @member AudioConfigImpl.prototype.detach
     * @function
     * @public
     * @param {string} audioNodeId - The audio node id.
     */ detach(audioNodeId) {
        return this.privSource.detach(audioNodeId);
    }
    /**
     * @member AudioConfigImpl.prototype.turnOff
     * @function
     * @public
     * @returns {Promise<void>} A promise.
     */ turnOff() {
        return this.privSource.turnOff();
    }
    /**
     * @member AudioConfigImpl.prototype.events
     * @function
     * @public
     * @returns {EventSource<AudioSourceEvent>} An event source for audio events.
     */ get events() {
        return this.privSource.events;
    }
    setProperty(name, value) {
        (0, $8HmyV.Contracts).throwIfNull(value, "value");
        if (undefined !== this.privSource.setProperty) this.privSource.setProperty(name, value);
        else throw new Error("This AudioConfig instance does not support setting properties.");
    }
    getProperty(name, def) {
        if (undefined !== this.privSource.getProperty) return this.privSource.getProperty(name, def);
        else throw new Error("This AudioConfig instance does not support getting properties.");
        return def;
    }
    get deviceInfo() {
        return this.privSource.deviceInfo;
    }
}
class $84cec33d1dd2ea9c$export$6474c8308a86365e extends $84cec33d1dd2ea9c$export$3b730bf34c92a0f9 {
    /**
     * Creates and initializes an instance of this class.
     * @constructor
     * @param {IAudioDestination} destination - An audio destination.
     */ constructor(destination){
        super();
        this.privDestination = destination;
    }
    set format(format) {
        this.privDestination.format = format;
    }
    write(buffer) {
        this.privDestination.write(buffer);
    }
    close() {
        this.privDestination.close();
    }
    id() {
        return this.privDestination.id();
    }
    setProperty() {
        throw new Error("This AudioConfig instance does not support setting properties.");
    }
    getProperty() {
        throw new Error("This AudioConfig instance does not support getting properties.");
    }
}

});
parcelRequire.register("2iayq", function(module, exports) {
$parcel$export(module.exports, "ConsoleLoggingListener", () => (parcelRequire("b2eer")).ConsoleLoggingListener);
$parcel$export(module.exports, "PcmRecorder", () => (parcelRequire("3uS3N")).PcmRecorder);
$parcel$export(module.exports, "ReplayableAudioNode", () => (parcelRequire("6RE4c")).ReplayableAudioNode);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
parcelRequire("b2eer");


var $7FTUT = parcelRequire("7FTUT");

var $35uUw = parcelRequire("35uUw");
parcelRequire("3uS3N");

var $jSt6R = parcelRequire("jSt6R");

var $a0Dqy = parcelRequire("a0Dqy");
parcelRequire("6RE4c");


var $SMwRY = parcelRequire("SMwRY");

$parcel$exportWildcard(module.exports, $7FTUT);
$parcel$exportWildcard(module.exports, $35uUw);
$parcel$exportWildcard(module.exports, $jSt6R);
$parcel$exportWildcard(module.exports, $a0Dqy);
$parcel$exportWildcard(module.exports, $SMwRY);

});
parcelRequire.register("b2eer", function(module, exports) {

$parcel$export(module.exports, "ConsoleLoggingListener", () => $808aebc9492ec877$export$724e95fb67472979);
/* eslint-disable @typescript-eslint/no-unsafe-assignment */ // Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.

var $gR5sk = parcelRequire("gR5sk");
parcelRequire("cR8AB");
var $6yPtW = parcelRequire("6yPtW");

var $8HmyV = parcelRequire("8HmyV");
class $808aebc9492ec877$export$724e95fb67472979 {
    constructor(logLevelFilter = (0, $6yPtW.EventType).None){
        this.privLogPath = undefined;
        this.privEnableConsoleOutput = true;
        this.privLogLevelFilter = logLevelFilter;
    }
    set logPath(path) {
        (0, $8HmyV.Contracts).throwIfNullOrUndefined($gR5sk.openSync, "\nFile System access not available");
        this.privLogPath = path;
    }
    set enableConsoleOutput(enableOutput) {
        this.privEnableConsoleOutput = enableOutput;
    }
    onEvent(event) {
        if (event.eventType >= this.privLogLevelFilter) {
            const log = this.toString(event);
            if (!!this.privLogPath) $gR5sk.writeFileSync(this.privLogPath, log + "\n", {
                flag: "a+"
            });
            if (this.privEnableConsoleOutput) switch(event.eventType){
                case (0, $6yPtW.EventType).Debug:
                    // eslint-disable-next-line no-console
                    console.debug(log);
                    break;
                case (0, $6yPtW.EventType).Info:
                    // eslint-disable-next-line no-console
                    console.info(log);
                    break;
                case (0, $6yPtW.EventType).Warning:
                    // eslint-disable-next-line no-console
                    console.warn(log);
                    break;
                case (0, $6yPtW.EventType).Error:
                    // eslint-disable-next-line no-console
                    console.error(log);
                    break;
                default:
                    // eslint-disable-next-line no-console
                    console.log(log);
                    break;
            }
        }
    }
    toString(event) {
        const logFragments = [
            `${event.eventTime}`,
            `${event.name}`
        ];
        const e = event;
        for(const prop in e)if (prop && event.hasOwnProperty(prop) && prop !== "eventTime" && prop !== "eventType" && prop !== "eventId" && prop !== "name" && prop !== "constructor") {
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            const value = e[prop];
            let valueToLog = "<NULL>";
            if (value !== undefined && value !== null) {
                if (typeof value === "number" || typeof value === "string") valueToLog = value.toString();
                else valueToLog = JSON.stringify(value);
            }
            logFragments.push(`${prop}: ${valueToLog}`);
        }
        return logFragments.join(" | ");
    }
}

});
parcelRequire.register("cR8AB", function(module, exports) {
$parcel$export(module.exports, "AudioSourceErrorEvent", () => (parcelRequire("bqySL")).AudioSourceErrorEvent);
$parcel$export(module.exports, "AudioSourceInitializingEvent", () => (parcelRequire("bqySL")).AudioSourceInitializingEvent);
$parcel$export(module.exports, "AudioSourceOffEvent", () => (parcelRequire("bqySL")).AudioSourceOffEvent);
$parcel$export(module.exports, "AudioSourceReadyEvent", () => (parcelRequire("bqySL")).AudioSourceReadyEvent);
$parcel$export(module.exports, "AudioStreamNodeAttachedEvent", () => (parcelRequire("bqySL")).AudioStreamNodeAttachedEvent);
$parcel$export(module.exports, "AudioStreamNodeAttachingEvent", () => (parcelRequire("bqySL")).AudioStreamNodeAttachingEvent);
$parcel$export(module.exports, "AudioStreamNodeDetachedEvent", () => (parcelRequire("bqySL")).AudioStreamNodeDetachedEvent);
$parcel$export(module.exports, "AudioStreamNodeErrorEvent", () => (parcelRequire("bqySL")).AudioStreamNodeErrorEvent);
$parcel$export(module.exports, "ConnectionClosedEvent", () => (parcelRequire("ieLRH")).ConnectionClosedEvent);
$parcel$export(module.exports, "ConnectionErrorEvent", () => (parcelRequire("ieLRH")).ConnectionErrorEvent);
$parcel$export(module.exports, "ConnectionEstablishedEvent", () => (parcelRequire("ieLRH")).ConnectionEstablishedEvent);
$parcel$export(module.exports, "ConnectionEstablishErrorEvent", () => (parcelRequire("ieLRH")).ConnectionEstablishErrorEvent);
$parcel$export(module.exports, "ConnectionMessageReceivedEvent", () => (parcelRequire("ieLRH")).ConnectionMessageReceivedEvent);
$parcel$export(module.exports, "ConnectionMessageSentEvent", () => (parcelRequire("ieLRH")).ConnectionMessageSentEvent);
$parcel$export(module.exports, "ConnectionStartEvent", () => (parcelRequire("ieLRH")).ConnectionStartEvent);
$parcel$export(module.exports, "ServiceEvent", () => (parcelRequire("ieLRH")).ServiceEvent);
$parcel$export(module.exports, "ConnectionMessage", () => (parcelRequire("jQZQm")).ConnectionMessage);
$parcel$export(module.exports, "MessageType", () => (parcelRequire("jQZQm")).MessageType);
$parcel$export(module.exports, "ConnectionOpenResponse", () => (parcelRequire("g9GEc")).ConnectionOpenResponse);
$parcel$export(module.exports, "DeferralMap", () => (parcelRequire("36zth")).DeferralMap);
$parcel$export(module.exports, "ArgumentNullError", () => (parcelRequire("83Xvm")).ArgumentNullError);
$parcel$export(module.exports, "Events", () => (parcelRequire("4utc3")).Events);
$parcel$export(module.exports, "EventSource", () => (parcelRequire("dxrNf")).EventSource);
$parcel$export(module.exports, "createGuid", () => (parcelRequire("hsGnG")).createGuid);
$parcel$export(module.exports, "createNoDashGuid", () => (parcelRequire("hsGnG")).createNoDashGuid);
$parcel$export(module.exports, "ConnectionState", () => (parcelRequire("1v63k")).ConnectionState);
$parcel$export(module.exports, "EventType", () => (parcelRequire("6yPtW")).EventType);
$parcel$export(module.exports, "PlatformEvent", () => (parcelRequire("6yPtW")).PlatformEvent);
$parcel$export(module.exports, "Deferred", () => (parcelRequire("2YVQf")).Deferred);
$parcel$export(module.exports, "RawWebsocketMessage", () => (parcelRequire("fERMy")).RawWebsocketMessage);
$parcel$export(module.exports, "RiffPcmEncoder", () => (parcelRequire("4cyUj")).RiffPcmEncoder);
$parcel$export(module.exports, "ChunkedArrayBufferStream", () => (parcelRequire("2mIQY")).ChunkedArrayBufferStream);
$parcel$export(module.exports, "Timeout", () => (parcelRequire("fjbxF")).Timeout);
$parcel$export(module.exports, "BackgroundEvent", () => (parcelRequire("3qWVN")).BackgroundEvent);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
parcelRequire("bqySL");
parcelRequire("ieLRH");
parcelRequire("jQZQm");
parcelRequire("g9GEc");
parcelRequire("36zth");

parcelRequire("83Xvm");
parcelRequire("4utc3");
parcelRequire("dxrNf");
parcelRequire("hsGnG");

parcelRequire("1v63k");








parcelRequire("6yPtW");
parcelRequire("2YVQf");

var $g4XyH = parcelRequire("g4XyH");
parcelRequire("fERMy");
parcelRequire("4cyUj");

var $1T8k7 = parcelRequire("1T8k7");

var $frtBW = parcelRequire("frtBW");
parcelRequire("2mIQY");

parcelRequire("fjbxF");

parcelRequire("3qWVN");
$parcel$exportWildcard(module.exports, $g4XyH);
$parcel$exportWildcard(module.exports, $1T8k7);

});
parcelRequire.register("bqySL", function(module, exports) {

$parcel$export(module.exports, "AudioSourceInitializingEvent", () => $851d2e4e03554731$export$3ea896e783b014bc);
$parcel$export(module.exports, "AudioSourceReadyEvent", () => $851d2e4e03554731$export$54b576ec7ac02ebe);
$parcel$export(module.exports, "AudioSourceOffEvent", () => $851d2e4e03554731$export$6b78daffb3d5512d);
$parcel$export(module.exports, "AudioSourceErrorEvent", () => $851d2e4e03554731$export$846353fbe6243328);
$parcel$export(module.exports, "AudioStreamNodeAttachingEvent", () => $851d2e4e03554731$export$4fd6277c5ad6f287);
$parcel$export(module.exports, "AudioStreamNodeAttachedEvent", () => $851d2e4e03554731$export$5080ccbedcd117ea);
$parcel$export(module.exports, "AudioStreamNodeDetachedEvent", () => $851d2e4e03554731$export$cc8a6ff2edb60616);
$parcel$export(module.exports, "AudioStreamNodeErrorEvent", () => $851d2e4e03554731$export$787ac83068e70a4c);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
/* eslint-disable max-classes-per-file */ 
var $6yPtW = parcelRequire("6yPtW");
class $851d2e4e03554731$export$46570d6d6ccc791d extends (0, $6yPtW.PlatformEvent) {
    constructor(eventName, audioSourceId, eventType = (0, $6yPtW.EventType).Info){
        super(eventName, eventType);
        this.privAudioSourceId = audioSourceId;
    }
    get audioSourceId() {
        return this.privAudioSourceId;
    }
}
class $851d2e4e03554731$export$3ea896e783b014bc extends $851d2e4e03554731$export$46570d6d6ccc791d {
    constructor(audioSourceId){
        super("AudioSourceInitializingEvent", audioSourceId);
    }
}
class $851d2e4e03554731$export$54b576ec7ac02ebe extends $851d2e4e03554731$export$46570d6d6ccc791d {
    constructor(audioSourceId){
        super("AudioSourceReadyEvent", audioSourceId);
    }
}
class $851d2e4e03554731$export$6b78daffb3d5512d extends $851d2e4e03554731$export$46570d6d6ccc791d {
    constructor(audioSourceId){
        super("AudioSourceOffEvent", audioSourceId);
    }
}
class $851d2e4e03554731$export$846353fbe6243328 extends $851d2e4e03554731$export$46570d6d6ccc791d {
    constructor(audioSourceId, error){
        super("AudioSourceErrorEvent", audioSourceId, (0, $6yPtW.EventType).Error);
        this.privError = error;
    }
    get error() {
        return this.privError;
    }
}
class $851d2e4e03554731$export$bcf1319de53b0d5d extends $851d2e4e03554731$export$46570d6d6ccc791d {
    constructor(eventName, audioSourceId, audioNodeId){
        super(eventName, audioSourceId);
        this.privAudioNodeId = audioNodeId;
    }
    get audioNodeId() {
        return this.privAudioNodeId;
    }
}
class $851d2e4e03554731$export$4fd6277c5ad6f287 extends $851d2e4e03554731$export$bcf1319de53b0d5d {
    constructor(audioSourceId, audioNodeId){
        super("AudioStreamNodeAttachingEvent", audioSourceId, audioNodeId);
    }
}
class $851d2e4e03554731$export$5080ccbedcd117ea extends $851d2e4e03554731$export$bcf1319de53b0d5d {
    constructor(audioSourceId, audioNodeId){
        super("AudioStreamNodeAttachedEvent", audioSourceId, audioNodeId);
    }
}
class $851d2e4e03554731$export$cc8a6ff2edb60616 extends $851d2e4e03554731$export$bcf1319de53b0d5d {
    constructor(audioSourceId, audioNodeId){
        super("AudioStreamNodeDetachedEvent", audioSourceId, audioNodeId);
    }
}
class $851d2e4e03554731$export$787ac83068e70a4c extends $851d2e4e03554731$export$bcf1319de53b0d5d {
    constructor(audioSourceId, audioNodeId, error){
        super("AudioStreamNodeErrorEvent", audioSourceId, audioNodeId);
        this.privError = error;
    }
    get error() {
        return this.privError;
    }
}

});
parcelRequire.register("6yPtW", function(module, exports) {

$parcel$export(module.exports, "EventType", () => $4c6dda4d5c6c2e97$export$3d7865934588d77e);
$parcel$export(module.exports, "PlatformEvent", () => $4c6dda4d5c6c2e97$export$fd68248162ec482a);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.

var $hsGnG = parcelRequire("hsGnG");
var $4c6dda4d5c6c2e97$export$3d7865934588d77e;
(function(EventType) {
    EventType[EventType["Debug"] = 0] = "Debug";
    EventType[EventType["Info"] = 1] = "Info";
    EventType[EventType["Warning"] = 2] = "Warning";
    EventType[EventType["Error"] = 3] = "Error";
    EventType[EventType["None"] = 4] = "None";
})($4c6dda4d5c6c2e97$export$3d7865934588d77e || ($4c6dda4d5c6c2e97$export$3d7865934588d77e = {}));
class $4c6dda4d5c6c2e97$export$fd68248162ec482a {
    constructor(eventName, eventType){
        this.privName = eventName;
        this.privEventId = (0, $hsGnG.createNoDashGuid)();
        this.privEventTime = new Date().toISOString();
        this.privEventType = eventType;
        this.privMetadata = {};
    }
    get name() {
        return this.privName;
    }
    get eventId() {
        return this.privEventId;
    }
    get eventTime() {
        return this.privEventTime;
    }
    get eventType() {
        return this.privEventType;
    }
    get metadata() {
        return this.privMetadata;
    }
}

});
parcelRequire.register("hsGnG", function(module, exports) {

$parcel$export(module.exports, "createGuid", () => $cb65ed27716c801c$export$7571c350ed9fec74);
$parcel$export(module.exports, "createNoDashGuid", () => $cb65ed27716c801c$export$992f04952fbcb07f);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.

var $02MKj = parcelRequire("02MKj");
const $cb65ed27716c801c$export$7571c350ed9fec74 = ()=>(0, $02MKj.default)();
const $cb65ed27716c801c$export$992f04952fbcb07f = ()=>$cb65ed27716c801c$export$7571c350ed9fec74().replace(new RegExp("-", "g"), "").toUpperCase();

});



parcelRequire.register("ieLRH", function(module, exports) {

$parcel$export(module.exports, "ServiceEvent", () => $d46ea9d103f1c278$export$4a3bd582097411);
$parcel$export(module.exports, "ConnectionStartEvent", () => $d46ea9d103f1c278$export$b07a5b383e429393);
$parcel$export(module.exports, "ConnectionEstablishedEvent", () => $d46ea9d103f1c278$export$89bbcdbfdd7f98d6);
$parcel$export(module.exports, "ConnectionClosedEvent", () => $d46ea9d103f1c278$export$c0d6050433d51d03);
$parcel$export(module.exports, "ConnectionErrorEvent", () => $d46ea9d103f1c278$export$3299e654b279c3f8);
$parcel$export(module.exports, "ConnectionEstablishErrorEvent", () => $d46ea9d103f1c278$export$e916fc8e35135338);
$parcel$export(module.exports, "ConnectionMessageReceivedEvent", () => $d46ea9d103f1c278$export$60c815f18d84ea31);
$parcel$export(module.exports, "ConnectionMessageSentEvent", () => $d46ea9d103f1c278$export$41b2353b9658d253);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.

var $6yPtW = parcelRequire("6yPtW");
class $d46ea9d103f1c278$export$4a3bd582097411 extends (0, $6yPtW.PlatformEvent) {
    constructor(eventName, jsonstring, eventType = (0, $6yPtW.EventType).Info){
        super(eventName, eventType);
        this.privJsonResult = jsonstring;
    }
    get jsonString() {
        return this.privJsonResult;
    }
}
class $d46ea9d103f1c278$export$a5d2cb21a485eb9 extends (0, $6yPtW.PlatformEvent) {
    constructor(eventName, connectionId, eventType = (0, $6yPtW.EventType).Info){
        super(eventName, eventType);
        this.privConnectionId = connectionId;
    }
    get connectionId() {
        return this.privConnectionId;
    }
}
class $d46ea9d103f1c278$export$b07a5b383e429393 extends $d46ea9d103f1c278$export$a5d2cb21a485eb9 {
    constructor(connectionId, uri, headers){
        super("ConnectionStartEvent", connectionId);
        this.privUri = uri;
        this.privHeaders = headers;
    }
    get uri() {
        return this.privUri;
    }
    get headers() {
        return this.privHeaders;
    }
}
class $d46ea9d103f1c278$export$89bbcdbfdd7f98d6 extends $d46ea9d103f1c278$export$a5d2cb21a485eb9 {
    constructor(connectionId){
        super("ConnectionEstablishedEvent", connectionId);
    }
}
class $d46ea9d103f1c278$export$c0d6050433d51d03 extends $d46ea9d103f1c278$export$a5d2cb21a485eb9 {
    constructor(connectionId, statusCode, reason){
        super("ConnectionClosedEvent", connectionId, (0, $6yPtW.EventType).Debug);
        this.privReason = reason;
        this.privStatusCode = statusCode;
    }
    get reason() {
        return this.privReason;
    }
    get statusCode() {
        return this.privStatusCode;
    }
}
class $d46ea9d103f1c278$export$3299e654b279c3f8 extends $d46ea9d103f1c278$export$a5d2cb21a485eb9 {
    constructor(connectionId, message, type){
        super("ConnectionErrorEvent", connectionId, (0, $6yPtW.EventType).Debug);
        this.privMessage = message;
        this.privType = type;
    }
    get message() {
        return this.privMessage;
    }
    get type() {
        return this.privType;
    }
}
class $d46ea9d103f1c278$export$e916fc8e35135338 extends $d46ea9d103f1c278$export$a5d2cb21a485eb9 {
    constructor(connectionId, statuscode, reason){
        super("ConnectionEstablishErrorEvent", connectionId, (0, $6yPtW.EventType).Error);
        this.privStatusCode = statuscode;
        this.privReason = reason;
    }
    get reason() {
        return this.privReason;
    }
    get statusCode() {
        return this.privStatusCode;
    }
}
class $d46ea9d103f1c278$export$60c815f18d84ea31 extends $d46ea9d103f1c278$export$a5d2cb21a485eb9 {
    constructor(connectionId, networkReceivedTimeISO, message){
        super("ConnectionMessageReceivedEvent", connectionId);
        this.privNetworkReceivedTime = networkReceivedTimeISO;
        this.privMessage = message;
    }
    get networkReceivedTime() {
        return this.privNetworkReceivedTime;
    }
    get message() {
        return this.privMessage;
    }
}
class $d46ea9d103f1c278$export$41b2353b9658d253 extends $d46ea9d103f1c278$export$a5d2cb21a485eb9 {
    constructor(connectionId, networkSentTimeISO, message){
        super("ConnectionMessageSentEvent", connectionId);
        this.privNetworkSentTime = networkSentTimeISO;
        this.privMessage = message;
    }
    get networkSentTime() {
        return this.privNetworkSentTime;
    }
    get message() {
        return this.privMessage;
    }
}

});

parcelRequire.register("jQZQm", function(module, exports) {

$parcel$export(module.exports, "MessageType", () => $e742d87ea0312ab6$export$80edbf15fa61a4db);
$parcel$export(module.exports, "ConnectionMessage", () => $e742d87ea0312ab6$export$fa43bbfea96f2015);
/* eslint-disable @typescript-eslint/no-unsafe-return */ // Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.

var $83Xvm = parcelRequire("83Xvm");

var $hsGnG = parcelRequire("hsGnG");
var $e742d87ea0312ab6$export$80edbf15fa61a4db;
(function(MessageType) {
    MessageType[MessageType["Text"] = 0] = "Text";
    MessageType[MessageType["Binary"] = 1] = "Binary";
})($e742d87ea0312ab6$export$80edbf15fa61a4db || ($e742d87ea0312ab6$export$80edbf15fa61a4db = {}));
class $e742d87ea0312ab6$export$fa43bbfea96f2015 {
    constructor(messageType, body, headers, id){
        this.privBody = null;
        if (messageType === $e742d87ea0312ab6$export$80edbf15fa61a4db.Text && body && !(typeof body === "string")) throw new (0, $83Xvm.InvalidOperationError)("Payload must be a string");
        if (messageType === $e742d87ea0312ab6$export$80edbf15fa61a4db.Binary && body && !(body instanceof ArrayBuffer)) throw new (0, $83Xvm.InvalidOperationError)("Payload must be ArrayBuffer");
        this.privMessageType = messageType;
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        this.privBody = body;
        this.privHeaders = headers ? headers : {};
        this.privId = id ? id : (0, $hsGnG.createNoDashGuid)();
        switch(this.messageType){
            case $e742d87ea0312ab6$export$80edbf15fa61a4db.Binary:
                this.privSize = this.binaryBody !== null ? this.binaryBody.byteLength : 0;
                break;
            case $e742d87ea0312ab6$export$80edbf15fa61a4db.Text:
                this.privSize = this.textBody.length;
        }
    }
    get messageType() {
        return this.privMessageType;
    }
    get headers() {
        return this.privHeaders;
    }
    get body() {
        return this.privBody;
    }
    get textBody() {
        if (this.privMessageType === $e742d87ea0312ab6$export$80edbf15fa61a4db.Binary) throw new (0, $83Xvm.InvalidOperationError)("Not supported for binary message");
        return this.privBody;
    }
    get binaryBody() {
        if (this.privMessageType === $e742d87ea0312ab6$export$80edbf15fa61a4db.Text) throw new (0, $83Xvm.InvalidOperationError)("Not supported for text message");
        return this.privBody;
    }
    get id() {
        return this.privId;
    }
}

});
parcelRequire.register("83Xvm", function(module, exports) {

$parcel$export(module.exports, "ArgumentNullError", () => $5decc2f359a9bb01$export$5ab68a1dbe1fe1a4);
$parcel$export(module.exports, "InvalidOperationError", () => $5decc2f359a9bb01$export$59a732e9476f38b5);
$parcel$export(module.exports, "ObjectDisposedError", () => $5decc2f359a9bb01$export$1697868c944415ee);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
/* eslint-disable max-classes-per-file */ /**
 * The error that is thrown when an argument passed in is null.
 *
 * @export
 * @class ArgumentNullError
 * @extends {Error}
 */ class $5decc2f359a9bb01$export$5ab68a1dbe1fe1a4 extends Error {
    /**
     * Creates an instance of ArgumentNullError.
     *
     * @param {string} argumentName - Name of the argument that is null
     *
     * @memberOf ArgumentNullError
     */ constructor(argumentName){
        super(argumentName);
        this.name = "ArgumentNull";
        this.message = argumentName;
    }
}
class $5decc2f359a9bb01$export$59a732e9476f38b5 extends Error {
    /**
     * Creates an instance of InvalidOperationError.
     *
     * @param {string} error - The error
     *
     * @memberOf InvalidOperationError
     */ constructor(error){
        super(error);
        this.name = "InvalidOperation";
        this.message = error;
    }
}
class $5decc2f359a9bb01$export$1697868c944415ee extends Error {
    /**
     * Creates an instance of ObjectDisposedError.
     *
     * @param {string} objectName - The object that is disposed
     * @param {string} error - The error
     *
     * @memberOf ObjectDisposedError
     */ constructor(objectName, error){
        super(error);
        this.name = objectName + "ObjectDisposed";
        this.message = error;
    }
}

});


parcelRequire.register("g9GEc", function(module, exports) {

$parcel$export(module.exports, "ConnectionOpenResponse", () => $bc2e917764175ef6$export$c90e9ce8e513a038);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
class $bc2e917764175ef6$export$c90e9ce8e513a038 {
    constructor(statusCode, reason){
        this.privStatusCode = statusCode;
        this.privReason = reason;
    }
    get statusCode() {
        return this.privStatusCode;
    }
    get reason() {
        return this.privReason;
    }
}

});

parcelRequire.register("36zth", function(module, exports) {

$parcel$export(module.exports, "DeferralMap", () => $242d7277107e0417$export$d6d7193a53fd88d0);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
/**
 * The error that is thrown when an argument passed in is null.
 *
 * @export
 * @class DefferalMap
 */ class $242d7277107e0417$export$d6d7193a53fd88d0 {
    constructor(){
        this.privMap = {};
    }
    add(id, deferral) {
        this.privMap[id] = deferral;
    }
    getId(id) {
        return this.privMap[id];
    }
    complete(id, result) {
        try {
            this.privMap[id].resolve(result);
        } catch (error) {
            this.privMap[id].reject(error);
        } finally{
            this.privMap[id] = undefined;
        }
    }
}

});

parcelRequire.register("4utc3", function(module, exports) {

$parcel$export(module.exports, "Events", () => $34509bf8ec2e3506$export$ada873a34909da65);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.

var $83Xvm = parcelRequire("83Xvm");

var $dxrNf = parcelRequire("dxrNf");
class $34509bf8ec2e3506$export$ada873a34909da65 {
    static setEventSource(eventSource) {
        if (!eventSource) throw new (0, $83Xvm.ArgumentNullError)("eventSource");
        $34509bf8ec2e3506$export$ada873a34909da65.privInstance = eventSource;
    }
    static get instance() {
        return $34509bf8ec2e3506$export$ada873a34909da65.privInstance;
    }
}
$34509bf8ec2e3506$export$ada873a34909da65.privInstance = new (0, $dxrNf.EventSource)();

});
parcelRequire.register("dxrNf", function(module, exports) {

$parcel$export(module.exports, "EventSource", () => $9db3ea9869b68913$export$31c54eb8781d4391);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.

var $83Xvm = parcelRequire("83Xvm");

var $hsGnG = parcelRequire("hsGnG");
class $9db3ea9869b68913$export$31c54eb8781d4391 {
    constructor(metadata){
        this.privEventListeners = {};
        this.privIsDisposed = false;
        this.privConsoleListener = undefined;
        this.privMetadata = metadata;
    }
    onEvent(event) {
        if (this.isDisposed()) throw new (0, $83Xvm.ObjectDisposedError)("EventSource");
        if (this.metadata) {
            for(const paramName in this.metadata)if (paramName) {
                if (event.metadata) {
                    if (!event.metadata[paramName]) event.metadata[paramName] = this.metadata[paramName];
                }
            }
        }
        for(const eventId in this.privEventListeners)if (eventId && this.privEventListeners[eventId]) this.privEventListeners[eventId](event);
    }
    attach(onEventCallback) {
        const id = (0, $hsGnG.createNoDashGuid)();
        this.privEventListeners[id] = onEventCallback;
        return {
            detach: ()=>{
                delete this.privEventListeners[id];
                return Promise.resolve();
            }
        };
    }
    attachListener(listener) {
        return this.attach((e)=>listener.onEvent(e));
    }
    attachConsoleListener(listener) {
        if (!!this.privConsoleListener) this.privConsoleListener.detach(); // Detach implementation for eventListeners is synchronous
        this.privConsoleListener = this.attach((e)=>listener.onEvent(e));
        return this.privConsoleListener;
    }
    isDisposed() {
        return this.privIsDisposed;
    }
    dispose() {
        this.privEventListeners = null;
        this.privIsDisposed = true;
    }
    get metadata() {
        return this.privMetadata;
    }
}

});


parcelRequire.register("1v63k", function(module, exports) {

$parcel$export(module.exports, "ConnectionState", () => $117d61a08c073232$export$cd9c3c6bf535afc9);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
var $117d61a08c073232$export$cd9c3c6bf535afc9;
(function(ConnectionState) {
    ConnectionState[ConnectionState["None"] = 0] = "None";
    ConnectionState[ConnectionState["Connected"] = 1] = "Connected";
    ConnectionState[ConnectionState["Connecting"] = 2] = "Connecting";
    ConnectionState[ConnectionState["Disconnected"] = 3] = "Disconnected";
})($117d61a08c073232$export$cd9c3c6bf535afc9 || ($117d61a08c073232$export$cd9c3c6bf535afc9 = {}));

});

parcelRequire.register("2YVQf", function(module, exports) {

$parcel$export(module.exports, "Deferred", () => $22be0d8c828bedfb$export$85f6557964517f1a);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
/* eslint-disable max-classes-per-file, @typescript-eslint/typedef */ var $22be0d8c828bedfb$export$7bc76142acab2181;
(function(PromiseState) {
    PromiseState[PromiseState["None"] = 0] = "None";
    PromiseState[PromiseState["Resolved"] = 1] = "Resolved";
    PromiseState[PromiseState["Rejected"] = 2] = "Rejected";
})($22be0d8c828bedfb$export$7bc76142acab2181 || ($22be0d8c828bedfb$export$7bc76142acab2181 = {}));
class $22be0d8c828bedfb$export$66aad414e2a6f5ad {
    constructor(promiseResultEventSource){
        this.throwIfError = ()=>{
            if (this.isError) throw this.error;
        };
        promiseResultEventSource.on((result)=>{
            if (!this.privIsCompleted) {
                this.privIsCompleted = true;
                this.privIsError = false;
                this.privResult = result;
            }
        }, (error)=>{
            if (!this.privIsCompleted) {
                this.privIsCompleted = true;
                this.privIsError = true;
                this.privError = error;
            }
        });
    }
    get isCompleted() {
        return this.privIsCompleted;
    }
    get isError() {
        return this.privIsError;
    }
    get error() {
        return this.privError;
    }
    get result() {
        return this.privResult;
    }
}
class $22be0d8c828bedfb$export$30541693eb0f7895 {
    constructor(){
        this.setResult = (result)=>{
            this.privOnSetResult(result);
        };
        this.setError = (error)=>{
            this.privOnSetError(error);
        };
        this.on = (onSetResult, onSetError)=>{
            this.privOnSetResult = onSetResult;
            this.privOnSetError = onSetError;
        };
    }
}
class $22be0d8c828bedfb$export$85f6557964517f1a {
    constructor(){
        this.resolve = (result)=>{
            this.privResolve(result);
            return this;
        };
        this.reject = (error)=>{
            this.privReject(error);
            return this;
        };
        // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
        this.privPromise = new Promise((resolve, reject)=>{
            this.privResolve = resolve;
            this.privReject = reject;
        });
    }
    get promise() {
        return this.privPromise;
    }
}
class $22be0d8c828bedfb$export$e287445474a1d9bf {
    constructor(){
        this.privState = $22be0d8c828bedfb$export$7bc76142acab2181.None;
        this.privPromiseResult = null;
        this.privPromiseResultEvents = null;
        this.privSuccessHandlers = [];
        this.privErrorHandlers = [];
        this.privPromiseResultEvents = new $22be0d8c828bedfb$export$30541693eb0f7895();
        this.privPromiseResult = new $22be0d8c828bedfb$export$66aad414e2a6f5ad(this.privPromiseResultEvents);
    }
    get state() {
        return this.privState;
    }
    get result() {
        return this.privPromiseResult;
    }
    resolve(result) {
        if (this.privState !== $22be0d8c828bedfb$export$7bc76142acab2181.None) throw new Error("'Cannot resolve a completed promise'");
        this.privState = $22be0d8c828bedfb$export$7bc76142acab2181.Resolved;
        this.privPromiseResultEvents.setResult(result);
        for(let i = 0; i < this.privSuccessHandlers.length; i++)this.executeSuccessCallback(result, this.privSuccessHandlers[i], this.privErrorHandlers[i]);
        this.detachHandlers();
    }
    reject(error) {
        if (this.privState !== $22be0d8c828bedfb$export$7bc76142acab2181.None) throw new Error("'Cannot reject a completed promise'");
        this.privState = $22be0d8c828bedfb$export$7bc76142acab2181.Rejected;
        this.privPromiseResultEvents.setError(error);
        for (const errorHandler of this.privErrorHandlers)this.executeErrorCallback(error, errorHandler);
        this.detachHandlers();
    }
    on(successCallback, errorCallback) {
        if (successCallback == null) // eslint-disable-next-line @typescript-eslint/no-empty-function
        successCallback = ()=>{};
        if (this.privState === $22be0d8c828bedfb$export$7bc76142acab2181.None) {
            this.privSuccessHandlers.push(successCallback);
            this.privErrorHandlers.push(errorCallback);
        } else {
            if (this.privState === $22be0d8c828bedfb$export$7bc76142acab2181.Resolved) this.executeSuccessCallback(this.privPromiseResult.result, successCallback, errorCallback);
            else if (this.privState === $22be0d8c828bedfb$export$7bc76142acab2181.Rejected) this.executeErrorCallback(this.privPromiseResult.error, errorCallback);
            this.detachHandlers();
        }
    }
    executeSuccessCallback(result, successCallback, errorCallback) {
        try {
            successCallback(result);
        } catch (e) {
            this.executeErrorCallback(`'Unhandled callback error: ${e}'`, errorCallback);
        }
    }
    executeErrorCallback(error, errorCallback) {
        if (errorCallback) try {
            errorCallback(error);
        } catch (e) {
            throw new Error(`'Unhandled callback error: ${e}. InnerError: ${error}'`);
        }
        else throw new Error(`'Unhandled error: ${error}'`);
    }
    detachHandlers() {
        this.privErrorHandlers = [];
        this.privSuccessHandlers = [];
    }
}
function $22be0d8c828bedfb$export$509551f10457d7e0(promise, cb, err) {
    promise.then((val)=>{
        try {
            if (!!cb) cb(val);
        } catch (error) {
            if (!!err) try {
                if (error instanceof Error) {
                    const typedError = error;
                    err(typedError.name + ": " + typedError.message);
                } else err(error);
            // eslint-disable-next-line no-empty
            } catch (error) {}
        }
    }, (error)=>{
        if (!!err) try {
            if (error instanceof Error) {
                const typedError = error;
                err(typedError.name + ": " + typedError.message);
            } else err(error);
        // eslint-disable-next-line no-empty
        } catch (error) {}
    });
}

});

parcelRequire.register("g4XyH", function(module, exports) {

$parcel$export(module.exports, "Queue", () => $bb4b382a646d5727$export$3dc07afe418952bc);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.

var $83Xvm = parcelRequire("83Xvm");

var $eWkmg = parcelRequire("eWkmg");

var $2YVQf = parcelRequire("2YVQf");
var $bb4b382a646d5727$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $bb4b382a646d5727$var$SubscriberType;
(function(SubscriberType) {
    SubscriberType[SubscriberType["Dequeue"] = 0] = "Dequeue";
    SubscriberType[SubscriberType["Peek"] = 1] = "Peek";
})($bb4b382a646d5727$var$SubscriberType || ($bb4b382a646d5727$var$SubscriberType = {}));
class $bb4b382a646d5727$export$3dc07afe418952bc {
    constructor(list){
        this.privPromiseStore = new (0, $eWkmg.List)();
        this.privIsDrainInProgress = false;
        this.privIsDisposing = false;
        this.privDisposeReason = null;
        this.privList = list ? list : new (0, $eWkmg.List)();
        this.privDetachables = [];
        this.privSubscribers = new (0, $eWkmg.List)();
        this.privDetachables.push(this.privList.onAdded(()=>this.drain()));
    }
    enqueue(item) {
        this.throwIfDispose();
        this.enqueueFromPromise(new Promise((resolve)=>resolve(item)));
    }
    enqueueFromPromise(promise) {
        this.throwIfDispose();
        promise.then((val)=>{
            this.privList.add(val);
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        }, ()=>{});
    }
    dequeue() {
        this.throwIfDispose();
        const deferredSubscriber = new (0, $2YVQf.Deferred)();
        if (this.privSubscribers) {
            this.privSubscribers.add({
                deferral: deferredSubscriber,
                type: $bb4b382a646d5727$var$SubscriberType.Dequeue
            });
            this.drain();
        }
        return deferredSubscriber.promise;
    }
    peek() {
        this.throwIfDispose();
        const deferredSubscriber = new (0, $2YVQf.Deferred)();
        const subs = this.privSubscribers;
        if (subs) {
            this.privSubscribers.add({
                deferral: deferredSubscriber,
                type: $bb4b382a646d5727$var$SubscriberType.Peek
            });
            this.drain();
        }
        return deferredSubscriber.promise;
    }
    length() {
        this.throwIfDispose();
        return this.privList.length();
    }
    isDisposed() {
        return this.privSubscribers == null;
    }
    drainAndDispose(pendingItemProcessor, reason) {
        return $bb4b382a646d5727$var$__awaiter(this, void 0, void 0, function*() {
            if (!this.isDisposed() && !this.privIsDisposing) {
                this.privDisposeReason = reason;
                this.privIsDisposing = true;
                const subs = this.privSubscribers;
                if (subs) {
                    while(subs.length() > 0){
                        const subscriber = subs.removeFirst();
                        // TODO: this needs work (Resolve(null) instead?).
                        subscriber.deferral.resolve(undefined);
                    // subscriber.deferral.reject("Disposed");
                    }
                    // note: this block assumes cooperative multitasking, i.e.,
                    // between the if-statement and the assignment there are no
                    // thread switches.
                    // Reason is that between the initial const = this.; and this
                    // point there is the derral.resolve() operation that might have
                    // caused recursive calls to the Queue, especially, calling
                    // Dispose() on the queue alredy (which would reset the var
                    // here to null!).
                    // That should generally hold true for javascript...
                    if (this.privSubscribers === subs) this.privSubscribers = subs;
                }
                for (const detachable of this.privDetachables)yield detachable.detach();
                if (this.privPromiseStore.length() > 0 && pendingItemProcessor) {
                    const promiseArray = [];
                    this.privPromiseStore.toArray().forEach((wrapper)=>{
                        promiseArray.push(wrapper);
                    });
                    return Promise.all(promiseArray).finally(()=>{
                        this.privSubscribers = null;
                        this.privList.forEach((item)=>{
                            pendingItemProcessor(item);
                        });
                        this.privList = null;
                        return;
                    }).then();
                } else {
                    this.privSubscribers = null;
                    this.privList = null;
                }
            }
        });
    }
    dispose(reason) {
        return $bb4b382a646d5727$var$__awaiter(this, void 0, void 0, function*() {
            yield this.drainAndDispose(null, reason);
        });
    }
    drain() {
        if (!this.privIsDrainInProgress && !this.privIsDisposing) {
            this.privIsDrainInProgress = true;
            const subs = this.privSubscribers;
            const lists = this.privList;
            if (subs && lists) {
                while(lists.length() > 0 && subs.length() > 0 && !this.privIsDisposing){
                    const subscriber = subs.removeFirst();
                    if (subscriber.type === $bb4b382a646d5727$var$SubscriberType.Peek) subscriber.deferral.resolve(lists.first());
                    else {
                        const dequeuedItem = lists.removeFirst();
                        subscriber.deferral.resolve(dequeuedItem);
                    }
                }
                // note: this block assumes cooperative multitasking, i.e.,
                // between the if-statement and the assignment there are no
                // thread switches.
                // Reason is that between the initial const = this.; and this
                // point there is the derral.resolve() operation that might have
                // caused recursive calls to the Queue, especially, calling
                // Dispose() on the queue alredy (which would reset the var
                // here to null!).
                // That should generally hold true for javascript...
                if (this.privSubscribers === subs) this.privSubscribers = subs;
                // note: this block assumes cooperative multitasking, i.e.,
                // between the if-statement and the assignment there are no
                // thread switches.
                // Reason is that between the initial const = this.; and this
                // point there is the derral.resolve() operation that might have
                // caused recursive calls to the Queue, especially, calling
                // Dispose() on the queue alredy (which would reset the var
                // here to null!).
                // That should generally hold true for javascript...
                if (this.privList === lists) this.privList = lists;
            }
            this.privIsDrainInProgress = false;
        }
    }
    throwIfDispose() {
        if (this.isDisposed()) {
            if (this.privDisposeReason) throw new (0, $83Xvm.InvalidOperationError)(this.privDisposeReason);
            throw new (0, $83Xvm.ObjectDisposedError)("Queue");
        } else if (this.privIsDisposing) throw new (0, $83Xvm.InvalidOperationError)("Queue disposing");
    }
}

});
parcelRequire.register("eWkmg", function(module, exports) {

$parcel$export(module.exports, "List", () => $ae0646234750b869$export$54c2e3dc7acea9f5);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.

var $83Xvm = parcelRequire("83Xvm");
class $ae0646234750b869$export$54c2e3dc7acea9f5 {
    constructor(list){
        this.privSubscriptionIdCounter = 0;
        this.privAddSubscriptions = {};
        this.privRemoveSubscriptions = {};
        this.privDisposedSubscriptions = {};
        this.privDisposeReason = null;
        this.privList = [];
        // copy the list rather than taking as is.
        if (list) for (const item of list)this.privList.push(item);
    }
    get(itemIndex) {
        this.throwIfDisposed();
        return this.privList[itemIndex];
    }
    first() {
        return this.get(0);
    }
    last() {
        return this.get(this.length() - 1);
    }
    add(item) {
        this.throwIfDisposed();
        this.insertAt(this.privList.length, item);
    }
    insertAt(index, item) {
        this.throwIfDisposed();
        if (index === 0) this.privList.unshift(item);
        else if (index === this.privList.length) this.privList.push(item);
        else this.privList.splice(index, 0, item);
        this.triggerSubscriptions(this.privAddSubscriptions);
    }
    removeFirst() {
        this.throwIfDisposed();
        return this.removeAt(0);
    }
    removeLast() {
        this.throwIfDisposed();
        return this.removeAt(this.length() - 1);
    }
    removeAt(index) {
        this.throwIfDisposed();
        return this.remove(index, 1)[0];
    }
    remove(index, count) {
        this.throwIfDisposed();
        const removedElements = this.privList.splice(index, count);
        this.triggerSubscriptions(this.privRemoveSubscriptions);
        return removedElements;
    }
    clear() {
        this.throwIfDisposed();
        this.remove(0, this.length());
    }
    length() {
        this.throwIfDisposed();
        return this.privList.length;
    }
    onAdded(addedCallback) {
        this.throwIfDisposed();
        const subscriptionId = this.privSubscriptionIdCounter++;
        this.privAddSubscriptions[subscriptionId] = addedCallback;
        return {
            detach: ()=>{
                delete this.privAddSubscriptions[subscriptionId];
                return Promise.resolve();
            }
        };
    }
    onRemoved(removedCallback) {
        this.throwIfDisposed();
        const subscriptionId = this.privSubscriptionIdCounter++;
        this.privRemoveSubscriptions[subscriptionId] = removedCallback;
        return {
            detach: ()=>{
                delete this.privRemoveSubscriptions[subscriptionId];
                return Promise.resolve();
            }
        };
    }
    onDisposed(disposedCallback) {
        this.throwIfDisposed();
        const subscriptionId = this.privSubscriptionIdCounter++;
        this.privDisposedSubscriptions[subscriptionId] = disposedCallback;
        return {
            detach: ()=>{
                delete this.privDisposedSubscriptions[subscriptionId];
                return Promise.resolve();
            }
        };
    }
    join(seperator) {
        this.throwIfDisposed();
        return this.privList.join(seperator);
    }
    toArray() {
        const cloneCopy = Array();
        this.privList.forEach((val)=>{
            cloneCopy.push(val);
        });
        return cloneCopy;
    }
    any(callback) {
        this.throwIfDisposed();
        if (callback) return this.where(callback).length() > 0;
        else return this.length() > 0;
    }
    all(callback) {
        this.throwIfDisposed();
        return this.where(callback).length() === this.length();
    }
    forEach(callback) {
        this.throwIfDisposed();
        for(let i = 0; i < this.length(); i++)callback(this.privList[i], i);
    }
    select(callback) {
        this.throwIfDisposed();
        const selectList = [];
        for(let i = 0; i < this.privList.length; i++)selectList.push(callback(this.privList[i], i));
        return new $ae0646234750b869$export$54c2e3dc7acea9f5(selectList);
    }
    where(callback) {
        this.throwIfDisposed();
        const filteredList = new $ae0646234750b869$export$54c2e3dc7acea9f5();
        for(let i = 0; i < this.privList.length; i++)if (callback(this.privList[i], i)) filteredList.add(this.privList[i]);
        return filteredList;
    }
    orderBy(compareFn) {
        this.throwIfDisposed();
        const clonedArray = this.toArray();
        const orderedArray = clonedArray.sort(compareFn);
        return new $ae0646234750b869$export$54c2e3dc7acea9f5(orderedArray);
    }
    orderByDesc(compareFn) {
        this.throwIfDisposed();
        return this.orderBy((a, b)=>compareFn(b, a));
    }
    clone() {
        this.throwIfDisposed();
        return new $ae0646234750b869$export$54c2e3dc7acea9f5(this.toArray());
    }
    concat(list) {
        this.throwIfDisposed();
        return new $ae0646234750b869$export$54c2e3dc7acea9f5(this.privList.concat(list.toArray()));
    }
    concatArray(array) {
        this.throwIfDisposed();
        return new $ae0646234750b869$export$54c2e3dc7acea9f5(this.privList.concat(array));
    }
    isDisposed() {
        return this.privList == null;
    }
    dispose(reason) {
        if (!this.isDisposed()) {
            this.privDisposeReason = reason;
            this.privList = null;
            this.privAddSubscriptions = null;
            this.privRemoveSubscriptions = null;
            this.triggerSubscriptions(this.privDisposedSubscriptions);
        }
    }
    throwIfDisposed() {
        if (this.isDisposed()) throw new (0, $83Xvm.ObjectDisposedError)("List", this.privDisposeReason);
    }
    triggerSubscriptions(subscriptions) {
        if (subscriptions) {
            for(const subscriptionId in subscriptions)if (subscriptionId) subscriptions[subscriptionId]();
        }
    }
}

});


parcelRequire.register("fERMy", function(module, exports) {

$parcel$export(module.exports, "RawWebsocketMessage", () => $b6644f6e91be1477$export$4d4fca4599964cf2);
/* eslint-disable @typescript-eslint/no-unsafe-assignment */ // Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.

var $jQZQm = parcelRequire("jQZQm");

var $83Xvm = parcelRequire("83Xvm");

var $hsGnG = parcelRequire("hsGnG");
class $b6644f6e91be1477$export$4d4fca4599964cf2 {
    constructor(messageType, payload, id){
        this.privPayload = null;
        if (!payload) throw new (0, $83Xvm.ArgumentNullError)("payload");
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        if (messageType === (0, $jQZQm.MessageType).Binary && payload.__proto__.constructor.name !== "ArrayBuffer") throw new (0, $83Xvm.InvalidOperationError)("Payload must be ArrayBuffer");
        if (messageType === (0, $jQZQm.MessageType).Text && !(typeof payload === "string")) throw new (0, $83Xvm.InvalidOperationError)("Payload must be a string");
        this.privMessageType = messageType;
        this.privPayload = payload;
        this.privId = id ? id : (0, $hsGnG.createNoDashGuid)();
    }
    get messageType() {
        return this.privMessageType;
    }
    get payload() {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-return
        return this.privPayload;
    }
    get textContent() {
        if (this.privMessageType === (0, $jQZQm.MessageType).Binary) throw new (0, $83Xvm.InvalidOperationError)("Not supported for binary message");
        return this.privPayload;
    }
    get binaryContent() {
        if (this.privMessageType === (0, $jQZQm.MessageType).Text) throw new (0, $83Xvm.InvalidOperationError)("Not supported for text message");
        return this.privPayload;
    }
    get id() {
        return this.privId;
    }
}

});

parcelRequire.register("4cyUj", function(module, exports) {

$parcel$export(module.exports, "RiffPcmEncoder", () => $30f35c45702828ba$export$f0c1cabbb64251f4);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
class $30f35c45702828ba$export$f0c1cabbb64251f4 {
    constructor(actualSampleRate, desiredSampleRate){
        this.privActualSampleRate = actualSampleRate;
        this.privDesiredSampleRate = desiredSampleRate;
    }
    encode(actualAudioFrame) {
        const audioFrame = this.downSampleAudioFrame(actualAudioFrame, this.privActualSampleRate, this.privDesiredSampleRate);
        if (!audioFrame) return null;
        const audioLength = audioFrame.length * 2;
        const buffer = new ArrayBuffer(audioLength);
        const view = new DataView(buffer);
        this.floatTo16BitPCM(view, 0, audioFrame);
        return buffer;
    }
    setString(view, offset, str) {
        for(let i = 0; i < str.length; i++)view.setUint8(offset + i, str.charCodeAt(i));
    }
    floatTo16BitPCM(view, offset, input) {
        for(let i = 0; i < input.length; i++, offset += 2){
            const s = Math.max(-1, Math.min(1, input[i]));
            view.setInt16(offset, s < 0 ? s * 0x8000 : s * 0x7FFF, true);
        }
    }
    downSampleAudioFrame(srcFrame, srcRate, dstRate) {
        if (!srcFrame) return null;
        if (dstRate === srcRate || dstRate > srcRate) return srcFrame;
        const ratio = srcRate / dstRate;
        const dstLength = Math.round(srcFrame.length / ratio);
        const dstFrame = new Float32Array(dstLength);
        let srcOffset = 0;
        let dstOffset = 0;
        while(dstOffset < dstLength){
            const nextSrcOffset = Math.round((dstOffset + 1) * ratio);
            let accum = 0;
            let count = 0;
            while(srcOffset < nextSrcOffset && srcOffset < srcFrame.length){
                accum += srcFrame[srcOffset++];
                count++;
            }
            dstFrame[dstOffset++] = accum / count;
        }
        return dstFrame;
    }
}

});

parcelRequire.register("1T8k7", function(module, exports) {

$parcel$export(module.exports, "Stream", () => $16016261aab670fa$export$6a4eb2e7fc9e8903);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.

var $83Xvm = parcelRequire("83Xvm");

var $hsGnG = parcelRequire("hsGnG");

var $g4XyH = parcelRequire("g4XyH");
var $16016261aab670fa$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
class $16016261aab670fa$export$6a4eb2e7fc9e8903 {
    constructor(streamId){
        this.privIsWriteEnded = false;
        this.privIsReadEnded = false;
        this.privId = streamId ? streamId : (0, $hsGnG.createNoDashGuid)();
        this.privReaderQueue = new (0, $g4XyH.Queue)();
    }
    get isClosed() {
        return this.privIsWriteEnded;
    }
    get isReadEnded() {
        return this.privIsReadEnded;
    }
    get id() {
        return this.privId;
    }
    close() {
        if (!this.privIsWriteEnded) {
            this.writeStreamChunk({
                buffer: null,
                isEnd: true,
                timeReceived: Date.now()
            });
            this.privIsWriteEnded = true;
        }
    }
    writeStreamChunk(streamChunk) {
        this.throwIfClosed();
        if (!this.privReaderQueue.isDisposed()) try {
            this.privReaderQueue.enqueue(streamChunk);
        } catch (e) {
        // Do nothing
        }
    }
    read() {
        if (this.privIsReadEnded) throw new (0, $83Xvm.InvalidOperationError)("Stream read has already finished");
        return this.privReaderQueue.dequeue().then((streamChunk)=>$16016261aab670fa$var$__awaiter(this, void 0, void 0, function*() {
                if (streamChunk === undefined || streamChunk.isEnd) yield this.privReaderQueue.dispose("End of stream reached");
                return streamChunk;
            }));
    }
    readEnded() {
        if (!this.privIsReadEnded) {
            this.privIsReadEnded = true;
            this.privReaderQueue = new (0, $g4XyH.Queue)();
        }
    }
    throwIfClosed() {
        if (this.privIsWriteEnded) throw new (0, $83Xvm.InvalidOperationError)("Stream closed");
    }
}

});

parcelRequire.register("frtBW", function(module, exports) {

$parcel$export(module.exports, "TranslationStatus", () => $b3e058c54d15ae55$export$96c657d6fc0132e5);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
/**
 * Defines translation status.
 * @class TranslationStatus
 */ var $b3e058c54d15ae55$export$96c657d6fc0132e5;
(function(TranslationStatus) {
    /**
     * @member TranslationStatus.Success
     */ TranslationStatus[TranslationStatus["Success"] = 0] = "Success";
    /**
     * @member TranslationStatus.Error
     */ TranslationStatus[TranslationStatus["Error"] = 1] = "Error";
})($b3e058c54d15ae55$export$96c657d6fc0132e5 || ($b3e058c54d15ae55$export$96c657d6fc0132e5 = {}));

});

parcelRequire.register("2mIQY", function(module, exports) {

$parcel$export(module.exports, "ChunkedArrayBufferStream", () => $1b906dcc18ac1720$export$8451797d25cb97b2);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
parcelRequire("cR8AB");
var $1T8k7 = parcelRequire("1T8k7");
class $1b906dcc18ac1720$export$8451797d25cb97b2 extends (0, $1T8k7.Stream) {
    constructor(targetChunkSize, streamId){
        super(streamId);
        this.privTargetChunkSize = targetChunkSize;
        this.privNextBufferReadyBytes = 0;
    }
    writeStreamChunk(chunk) {
        // No pending write, and the buffer is the right size so write it.
        if (chunk.isEnd || 0 === this.privNextBufferReadyBytes && chunk.buffer.byteLength === this.privTargetChunkSize) {
            super.writeStreamChunk(chunk);
            return;
        }
        let bytesCopiedFromBuffer = 0;
        while(bytesCopiedFromBuffer < chunk.buffer.byteLength){
            // Fill the next buffer.
            if (undefined === this.privNextBufferToWrite) {
                this.privNextBufferToWrite = new ArrayBuffer(this.privTargetChunkSize);
                this.privNextBufferStartTime = chunk.timeReceived;
            }
            // Find out how many bytes we can copy into the read buffer.
            const bytesToCopy = Math.min(chunk.buffer.byteLength - bytesCopiedFromBuffer, this.privTargetChunkSize - this.privNextBufferReadyBytes);
            const targetView = new Uint8Array(this.privNextBufferToWrite);
            const sourceView = new Uint8Array(chunk.buffer.slice(bytesCopiedFromBuffer, bytesToCopy + bytesCopiedFromBuffer));
            targetView.set(sourceView, this.privNextBufferReadyBytes);
            this.privNextBufferReadyBytes += bytesToCopy;
            bytesCopiedFromBuffer += bytesToCopy;
            // Are we ready to write?
            if (this.privNextBufferReadyBytes === this.privTargetChunkSize) {
                super.writeStreamChunk({
                    buffer: this.privNextBufferToWrite,
                    isEnd: false,
                    timeReceived: this.privNextBufferStartTime
                });
                this.privNextBufferReadyBytes = 0;
                this.privNextBufferToWrite = undefined;
            }
        }
    }
    close() {
        // Send whatever is pending, then close the base class.
        if (0 !== this.privNextBufferReadyBytes && !this.isClosed) super.writeStreamChunk({
            buffer: this.privNextBufferToWrite.slice(0, this.privNextBufferReadyBytes),
            isEnd: false,
            timeReceived: this.privNextBufferStartTime
        });
        super.close();
    }
}

});

parcelRequire.register("fjbxF", function(module, exports) {

$parcel$export(module.exports, "Timeout", () => $b251955938db0b71$export$786b4da70f00938b);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
class $b251955938db0b71$export$786b4da70f00938b {
    static load() {
        // Prefilling the Maps with a function indexed by zero is necessary to be compliant with the specification.
        const scheduledTimeoutFunctions = new Map([
            [
                0,
                ()=>{}
            ]
        ]); // eslint-disable-line @typescript-eslint/no-empty-function
        const unhandledRequests = new Map();
        // eslint-disable-next-line
        const workerScript = `!function(e){var t={};function n(r){if(t[r])return t[r].exports;var o=t[r]={i:r,l:!1,exports:{}};return e[r].call(o.exports,o,o.exports,n),o.l=!0,o.exports}n.m=e,n.c=t,n.d=function(e,t,r){n.o(e,t)||Object.defineProperty(e,t,{enumerable:!0,get:r})},n.r=function(e){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(e,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(e,"__esModule",{value:!0})},n.t=function(e,t){if(1&t&&(e=n(e)),8&t)return e;if(4&t&&"object"==typeof e&&e&&e.__esModule)return e;var r=Object.create(null);if(n.r(r),Object.defineProperty(r,"default",{enumerable:!0,value:e}),2&t&&"string"!=typeof e)for(var o in e)n.d(r,o,function(t){return e[t]}.bind(null,o));return r},n.n=function(e){var t=e&&e.__esModule?function(){return e.default}:function(){return e};return n.d(t,"a",t),t},n.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},n.p="",n(n.s=14)}([function(e,t,n){"use strict";n.d(t,"a",(function(){return i})),n.d(t,"b",(function(){return u})),n.d(t,"c",(function(){return a})),n.d(t,"d",(function(){return d}));const r=new Map,o=new Map,i=e=>{const t=r.get(e);if(void 0===t)throw new Error('There is no interval scheduled with the given id "'.concat(e,'".'));clearTimeout(t),r.delete(e)},u=e=>{const t=o.get(e);if(void 0===t)throw new Error('There is no timeout scheduled with the given id "'.concat(e,'".'));clearTimeout(t),o.delete(e)},f=(e,t)=>{let n,r;if("performance"in self){const o=performance.now();n=o,r=e-Math.max(0,o-t)}else n=Date.now(),r=e;return{expected:n+r,remainingDelay:r}},c=(e,t,n,r)=>{const o="performance"in self?performance.now():Date.now();o>n?postMessage({id:null,method:"call",params:{timerId:t}}):e.set(t,setTimeout(c,n-o,e,t,n))},a=(e,t,n)=>{const{expected:o,remainingDelay:i}=f(e,n);r.set(t,setTimeout(c,i,r,t,o))},d=(e,t,n)=>{const{expected:r,remainingDelay:i}=f(e,n);o.set(t,setTimeout(c,i,o,t,r))}},function(e,t,n){"use strict";n.r(t);var r=n(2);for(var o in r)"default"!==o&&function(e){n.d(t,e,(function(){return r[e]}))}(o);var i=n(3);for(var o in i)"default"!==o&&function(e){n.d(t,e,(function(){return i[e]}))}(o);var u=n(4);for(var o in u)"default"!==o&&function(e){n.d(t,e,(function(){return u[e]}))}(o);var f=n(5);for(var o in f)"default"!==o&&function(e){n.d(t,e,(function(){return f[e]}))}(o);var c=n(6);for(var o in c)"default"!==o&&function(e){n.d(t,e,(function(){return c[e]}))}(o);var a=n(7);for(var o in a)"default"!==o&&function(e){n.d(t,e,(function(){return a[e]}))}(o);var d=n(8);for(var o in d)"default"!==o&&function(e){n.d(t,e,(function(){return d[e]}))}(o);var s=n(9);for(var o in s)"default"!==o&&function(e){n.d(t,e,(function(){return s[e]}))}(o)},function(e,t){},function(e,t){},function(e,t){},function(e,t){},function(e,t){},function(e,t){},function(e,t){},function(e,t){},function(e,t,n){"use strict";n.r(t);var r=n(11);for(var o in r)"default"!==o&&function(e){n.d(t,e,(function(){return r[e]}))}(o);var i=n(12);for(var o in i)"default"!==o&&function(e){n.d(t,e,(function(){return i[e]}))}(o);var u=n(13);for(var o in u)"default"!==o&&function(e){n.d(t,e,(function(){return u[e]}))}(o)},function(e,t){},function(e,t){},function(e,t){},function(e,t,n){"use strict";n.r(t);var r=n(0),o=n(1);for(var i in o)"default"!==i&&function(e){n.d(t,e,(function(){return o[e]}))}(i);var u=n(10);for(var i in u)"default"!==i&&function(e){n.d(t,e,(function(){return u[e]}))}(i);addEventListener("message",({data:e})=>{try{if("clear"===e.method){const{id:t,params:{timerId:n}}=e;Object(r.b)(n),postMessage({error:null,id:t})}else{if("set"!==e.method)throw new Error('The given method "'.concat(e.method,'" is not supported'));{const{params:{delay:t,now:n,timerId:o}}=e;Object(r.d)(t,o,n)}}}catch(t){postMessage({error:{message:t.message},id:e.id,result:null})}})}]);`;
        const workerUrl = "data:text/javascript;base64," + btoa(workerScript);
        const worker = new Worker(workerUrl);
        worker.addEventListener("message", ({ data: data })=>{
            if ($b251955938db0b71$export$786b4da70f00938b.isCallNotification(data)) {
                const { params: { timerId: timerId } } = data;
                const idOrFunc = scheduledTimeoutFunctions.get(timerId);
                if (typeof idOrFunc === "number") {
                    const unhandledTimerId = unhandledRequests.get(idOrFunc);
                    if (unhandledTimerId === undefined || unhandledTimerId !== timerId) throw new Error("The timer is in an undefined state.");
                } else if (typeof idOrFunc !== "undefined") {
                    idOrFunc();
                    // A timeout can be safely deleted because it is only called once.
                    scheduledTimeoutFunctions.delete(timerId);
                } else throw new Error("The timer is in an undefined state.");
            } else if ($b251955938db0b71$export$786b4da70f00938b.isClearResponse(data)) {
                const { id: id } = data;
                const unhandledTimerId = unhandledRequests.get(id);
                if (unhandledTimerId === undefined) throw new Error("The timer is in an undefined state.");
                unhandledRequests.delete(id);
                scheduledTimeoutFunctions.delete(unhandledTimerId);
            } else {
                const { error: { message: message } } = data;
                throw new Error(message);
            }
        });
        const clearTimeout = (timerId)=>{
            const id = Math.random();
            unhandledRequests.set(id, timerId);
            scheduledTimeoutFunctions.set(timerId, id);
            worker.postMessage({
                id: id,
                method: "clear",
                params: {
                    timerId: timerId
                }
            });
        };
        const setTimeout = (func, delay)=>{
            const timerId = Math.random();
            scheduledTimeoutFunctions.set(timerId, func);
            worker.postMessage({
                id: null,
                method: "set",
                params: {
                    delay: delay,
                    now: performance.now(),
                    timerId: timerId
                }
            });
            return timerId;
        };
        return {
            clearTimeout: clearTimeout,
            setTimeout: setTimeout
        };
    }
    static loadWorkerTimers() {
        return ()=>{
            if ($b251955938db0b71$export$786b4da70f00938b.workerTimers !== null) return $b251955938db0b71$export$786b4da70f00938b.workerTimers;
            $b251955938db0b71$export$786b4da70f00938b.workerTimers = $b251955938db0b71$export$786b4da70f00938b.load();
            return $b251955938db0b71$export$786b4da70f00938b.workerTimers;
        };
    }
    static isCallNotification(message) {
        return message.method !== undefined && message.method === "call";
    }
    static isClearResponse(message) {
        return message.error === null && typeof message.id === "number";
    }
}
$b251955938db0b71$export$786b4da70f00938b.workerTimers = null;
$b251955938db0b71$export$786b4da70f00938b.clearTimeout = (timerId)=>$b251955938db0b71$export$786b4da70f00938b.timers().clearTimeout(timerId);
$b251955938db0b71$export$786b4da70f00938b.setTimeout = (func, delay)=>$b251955938db0b71$export$786b4da70f00938b.timers().setTimeout(func, delay);
$b251955938db0b71$export$786b4da70f00938b.timers = $b251955938db0b71$export$786b4da70f00938b.loadWorkerTimers();

});

parcelRequire.register("3qWVN", function(module, exports) {

$parcel$export(module.exports, "BackgroundEvent", () => $28018351186d5080$export$3e33db5d08e1fac7);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
parcelRequire("cR8AB");
var $6yPtW = parcelRequire("6yPtW");
class $28018351186d5080$export$3e33db5d08e1fac7 extends (0, $6yPtW.PlatformEvent) {
    constructor(error){
        super("BackgroundEvent", (0, $6yPtW.EventType).Error);
        this.privError = error;
    }
    get error() {
        return this.privError;
    }
}

});


parcelRequire.register("8HmyV", function(module, exports) {

$parcel$export(module.exports, "Contracts", () => $6553d74bb612819e$export$e93adfd13fa159ba);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
/**
 * @class Contracts
 * @private
 */ class $6553d74bb612819e$export$e93adfd13fa159ba {
    static throwIfNullOrUndefined(param, name) {
        if (param === undefined || param === null) throw new Error("throwIfNullOrUndefined:" + name);
    }
    static throwIfNull(param, name) {
        if (param === null) throw new Error("throwIfNull:" + name);
    }
    static throwIfNullOrWhitespace(param, name) {
        $6553d74bb612819e$export$e93adfd13fa159ba.throwIfNullOrUndefined(param, name);
        if (("" + param).trim().length < 1) throw new Error("throwIfNullOrWhitespace:" + name);
    }
    static throwIfNullOrTooLong(param, name, maxLength) {
        $6553d74bb612819e$export$e93adfd13fa159ba.throwIfNullOrUndefined(param, name);
        if (("" + param).length > maxLength) throw new Error("throwIfNullOrTooLong:" + name + " (more than " + maxLength.toString() + " characters)");
    }
    static throwIfNullOrTooShort(param, name, minLength) {
        $6553d74bb612819e$export$e93adfd13fa159ba.throwIfNullOrUndefined(param, name);
        if (("" + param).length < minLength) throw new Error("throwIfNullOrTooShort:" + name + " (less than " + minLength.toString() + " characters)");
    }
    static throwIfDisposed(isDisposed) {
        if (isDisposed) throw new Error("the object is already disposed");
    }
    static throwIfArrayEmptyOrWhitespace(array, name) {
        $6553d74bb612819e$export$e93adfd13fa159ba.throwIfNullOrUndefined(array, name);
        if (array.length === 0) throw new Error("throwIfArrayEmptyOrWhitespace:" + name);
        for (const item of array)$6553d74bb612819e$export$e93adfd13fa159ba.throwIfNullOrWhitespace(item, name);
    }
    static throwIfFileDoesNotExist(param, name) {
        $6553d74bb612819e$export$e93adfd13fa159ba.throwIfNullOrWhitespace(param, name);
    // TODO check for file existence.
    }
    static throwIfNotUndefined(param, name) {
        if (param !== undefined) throw new Error("throwIfNotUndefined:" + name);
    }
}

});


parcelRequire.register("7FTUT", function(module, exports) {

$parcel$export(module.exports, "MicAudioSource", () => $5967bc9825da7889$export$401b719c640c9369);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
parcelRequire("jSpbe");
var $cOea6 = parcelRequire("cOea6");
parcelRequire("cR8AB");
var $hsGnG = parcelRequire("hsGnG");
var $dxrNf = parcelRequire("dxrNf");
var $2YVQf = parcelRequire("2YVQf");
var $bqySL = parcelRequire("bqySL");
var $2mIQY = parcelRequire("2mIQY");
var $4utc3 = parcelRequire("4utc3");

var $6489m = parcelRequire("6489m");
var $5967bc9825da7889$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const $5967bc9825da7889$export$a38f7a762545a7e0 = "MICROPHONE-WorkletSourceUrl";
class $5967bc9825da7889$export$401b719c640c9369 {
    constructor(privRecorder, deviceId, audioSourceId, mediaStream){
        this.privRecorder = privRecorder;
        this.deviceId = deviceId;
        this.privStreams = {};
        this.privOutputChunkSize = $5967bc9825da7889$export$401b719c640c9369.AUDIOFORMAT.avgBytesPerSec / 10;
        this.privId = audioSourceId ? audioSourceId : (0, $hsGnG.createNoDashGuid)();
        this.privEvents = new (0, $dxrNf.EventSource)();
        this.privMediaStream = mediaStream || null;
        this.privIsClosing = false;
    }
    get format() {
        return Promise.resolve($5967bc9825da7889$export$401b719c640c9369.AUDIOFORMAT);
    }
    turnOn() {
        if (this.privInitializeDeferral) return this.privInitializeDeferral.promise;
        this.privInitializeDeferral = new (0, $2YVQf.Deferred)();
        try {
            this.createAudioContext();
        } catch (error) {
            if (error instanceof Error) {
                const typedError = error;
                this.privInitializeDeferral.reject(typedError.name + ": " + typedError.message);
            } else this.privInitializeDeferral.reject(error);
            return this.privInitializeDeferral.promise;
        }
        const nav = window.navigator;
        let getUserMedia = // eslint-disable-next-line
        nav.getUserMedia || nav.webkitGetUserMedia || nav.mozGetUserMedia || nav.msGetUserMedia;
        if (!!nav.mediaDevices) getUserMedia = (constraints, successCallback, errorCallback)=>{
            nav.mediaDevices.getUserMedia(constraints).then(successCallback).catch(errorCallback);
        };
        if (!getUserMedia) {
            const errorMsg = "Browser does not support getUserMedia.";
            this.privInitializeDeferral.reject(errorMsg);
            this.onEvent(new (0, $bqySL.AudioSourceErrorEvent)(errorMsg, "")); // mic initialized error - no streamid at this point
        } else {
            const next = ()=>{
                this.onEvent(new (0, $bqySL.AudioSourceInitializingEvent)(this.privId)); // no stream id
                if (this.privMediaStream && this.privMediaStream.active) {
                    this.onEvent(new (0, $bqySL.AudioSourceReadyEvent)(this.privId));
                    this.privInitializeDeferral.resolve();
                } else getUserMedia({
                    audio: this.deviceId ? {
                        deviceId: this.deviceId
                    } : true,
                    video: false
                }, (mediaStream)=>{
                    this.privMediaStream = mediaStream;
                    this.onEvent(new (0, $bqySL.AudioSourceReadyEvent)(this.privId));
                    this.privInitializeDeferral.resolve();
                }, (error)=>{
                    const errorMsg = `Error occurred during microphone initialization: ${error}`;
                    this.privInitializeDeferral.reject(errorMsg);
                    this.onEvent(new (0, $bqySL.AudioSourceErrorEvent)(this.privId, errorMsg));
                });
            };
            if (this.privContext.state === "suspended") // NOTE: On iOS, the Web Audio API requires sounds to be triggered from an explicit user action.
            // https://github.com/WebAudio/web-audio-api/issues/790
            this.privContext.resume().then(next).catch((reason)=>{
                this.privInitializeDeferral.reject(`Failed to initialize audio context: ${reason}`);
            });
            else next();
        }
        return this.privInitializeDeferral.promise;
    }
    id() {
        return this.privId;
    }
    attach(audioNodeId) {
        this.onEvent(new (0, $bqySL.AudioStreamNodeAttachingEvent)(this.privId, audioNodeId));
        return this.listen(audioNodeId).then((stream)=>{
            this.onEvent(new (0, $bqySL.AudioStreamNodeAttachedEvent)(this.privId, audioNodeId));
            return {
                detach: ()=>$5967bc9825da7889$var$__awaiter(this, void 0, void 0, function*() {
                        stream.readEnded();
                        delete this.privStreams[audioNodeId];
                        this.onEvent(new (0, $bqySL.AudioStreamNodeDetachedEvent)(this.privId, audioNodeId));
                        return this.turnOff();
                    }),
                id: ()=>audioNodeId,
                read: ()=>stream.read()
            };
        });
    }
    detach(audioNodeId) {
        if (audioNodeId && this.privStreams[audioNodeId]) {
            this.privStreams[audioNodeId].close();
            delete this.privStreams[audioNodeId];
            this.onEvent(new (0, $bqySL.AudioStreamNodeDetachedEvent)(this.privId, audioNodeId));
        }
    }
    turnOff() {
        return $5967bc9825da7889$var$__awaiter(this, void 0, void 0, function*() {
            for(const streamId in this.privStreams)if (streamId) {
                const stream = this.privStreams[streamId];
                if (stream) stream.close();
            }
            this.onEvent(new (0, $bqySL.AudioSourceOffEvent)(this.privId)); // no stream now
            if (this.privInitializeDeferral) {
                // Correctly handle when browser forces mic off before turnOn() completes
                // eslint-disable-next-line @typescript-eslint/await-thenable
                yield this.privInitializeDeferral;
                this.privInitializeDeferral = null;
            }
            yield this.destroyAudioContext();
            return;
        });
    }
    get events() {
        return this.privEvents;
    }
    get deviceInfo() {
        return this.getMicrophoneLabel().then((label)=>({
                bitspersample: $5967bc9825da7889$export$401b719c640c9369.AUDIOFORMAT.bitsPerSample,
                channelcount: $5967bc9825da7889$export$401b719c640c9369.AUDIOFORMAT.channels,
                connectivity: (0, $cOea6.connectivity).Unknown,
                manufacturer: "Speech SDK",
                model: label,
                samplerate: $5967bc9825da7889$export$401b719c640c9369.AUDIOFORMAT.samplesPerSec,
                type: (0, $cOea6.type).Microphones
            }));
    }
    setProperty(name, value) {
        if (name === $5967bc9825da7889$export$a38f7a762545a7e0) this.privRecorder.setWorkletUrl(value);
        else throw new Error("Property '" + name + "' is not supported on Microphone.");
    }
    getMicrophoneLabel() {
        const defaultMicrophoneName = "microphone";
        // If we did this already, return the value.
        if (this.privMicrophoneLabel !== undefined) return Promise.resolve(this.privMicrophoneLabel);
        // If the stream isn't currently running, we can't query devices because security.
        if (this.privMediaStream === undefined || !this.privMediaStream.active) return Promise.resolve(defaultMicrophoneName);
        // Setup a default
        this.privMicrophoneLabel = defaultMicrophoneName;
        // Get the id of the device running the audio track.
        const microphoneDeviceId = this.privMediaStream.getTracks()[0].getSettings().deviceId;
        // If the browser doesn't support getting the device ID, set a default and return.
        if (undefined === microphoneDeviceId) return Promise.resolve(this.privMicrophoneLabel);
        const deferred = new (0, $2YVQf.Deferred)();
        // Enumerate the media devices.
        navigator.mediaDevices.enumerateDevices().then((devices)=>{
            for (const device of devices)if (device.deviceId === microphoneDeviceId) {
                // Found the device
                this.privMicrophoneLabel = device.label;
                break;
            }
            deferred.resolve(this.privMicrophoneLabel);
        }, ()=>deferred.resolve(this.privMicrophoneLabel));
        return deferred.promise;
    }
    listen(audioNodeId) {
        return $5967bc9825da7889$var$__awaiter(this, void 0, void 0, function*() {
            yield this.turnOn();
            const stream = new (0, $2mIQY.ChunkedArrayBufferStream)(this.privOutputChunkSize, audioNodeId);
            this.privStreams[audioNodeId] = stream;
            try {
                this.privRecorder.record(this.privContext, this.privMediaStream, stream);
            } catch (error) {
                this.onEvent(new (0, $bqySL.AudioStreamNodeErrorEvent)(this.privId, audioNodeId, error));
                throw error;
            }
            const result = stream;
            return result;
        });
    }
    onEvent(event) {
        this.privEvents.onEvent(event);
        (0, $4utc3.Events).instance.onEvent(event);
    }
    createAudioContext() {
        if (!!this.privContext) return;
        this.privContext = (0, $6489m.AudioStreamFormatImpl).getAudioContext($5967bc9825da7889$export$401b719c640c9369.AUDIOFORMAT.samplesPerSec);
    }
    destroyAudioContext() {
        return $5967bc9825da7889$var$__awaiter(this, void 0, void 0, function*() {
            if (!this.privContext) return;
            this.privRecorder.releaseMediaResources(this.privContext);
            // This pattern brought to you by a bug in the TypeScript compiler where it
            // confuses the ("close" in this.privContext) with this.privContext always being null as the alternate.
            // https://github.com/Microsoft/TypeScript/issues/11498
            let hasClose = false;
            if ("close" in this.privContext) hasClose = true;
            if (hasClose) {
                if (!this.privIsClosing) {
                    // The audio context close may take enough time that the close is called twice
                    this.privIsClosing = true;
                    yield this.privContext.close();
                    this.privContext = null;
                    this.privIsClosing = false;
                }
            } else if (null !== this.privContext && this.privContext.state === "running") // Suspend actually takes a callback, but analogous to the
            // resume method, it'll be only fired if suspend is called
            // in a direct response to a user action. The later is not always
            // the case, as TurnOff is also called, when we receive an
            // end-of-speech message from the service. So, doing a best effort
            // fire-and-forget here.
            yield this.privContext.suspend();
        });
    }
}
$5967bc9825da7889$export$401b719c640c9369.AUDIOFORMAT = (0, $6489m.AudioStreamFormat).getDefaultInputFormat();

});
parcelRequire.register("jSpbe", function(module, exports) {
$parcel$export(module.exports, "connectivity", () => (parcelRequire("cOea6")).connectivity);
$parcel$export(module.exports, "RecognitionMode", () => (parcelRequire("cOea6")).RecognitionMode);
$parcel$export(module.exports, "type", () => (parcelRequire("cOea6")).type);
$parcel$export(module.exports, "EnumTranslation", () => (parcelRequire("iBWCB")).EnumTranslation);
$parcel$export(module.exports, "RecognitionStatus", () => (parcelRequire("c7Irs")).RecognitionStatus);
$parcel$export(module.exports, "SynthesisStatus", () => (parcelRequire("c7Irs")).SynthesisStatus);
$parcel$export(module.exports, "TranslationSynthesisEnd", () => (parcelRequire("5fZ8e")).TranslationSynthesisEnd);
$parcel$export(module.exports, "TranslationHypothesis", () => (parcelRequire("aWATK")).TranslationHypothesis);
$parcel$export(module.exports, "TranslationPhrase", () => (parcelRequire("bhcO2")).TranslationPhrase);
$parcel$export(module.exports, "SpeechDetected", () => (parcelRequire("gdyuc")).SpeechDetected);
$parcel$export(module.exports, "SpeechHypothesis", () => (parcelRequire("i1ulX")).SpeechHypothesis);
$parcel$export(module.exports, "SpeechKeyword", () => (parcelRequire("1Anur")).SpeechKeyword);
$parcel$export(module.exports, "DetailedSpeechPhrase", () => (parcelRequire("bO7IR")).DetailedSpeechPhrase);
$parcel$export(module.exports, "SimpleSpeechPhrase", () => (parcelRequire("ea7Fz")).SimpleSpeechPhrase);
$parcel$export(module.exports, "SpeechContext", () => (parcelRequire("3AOeU")).SpeechContext);
$parcel$export(module.exports, "DynamicGrammarBuilder", () => (parcelRequire("a1SmT")).DynamicGrammarBuilder);
$parcel$export(module.exports, "AgentConfig", () => (parcelRequire("gBeX5")).AgentConfig);
$parcel$export(module.exports, "MetadataType", () => (parcelRequire("irXhw")).MetadataType);
$parcel$export(module.exports, "SynthesisAudioMetadata", () => (parcelRequire("irXhw")).SynthesisAudioMetadata);
$parcel$export(module.exports, "SynthesisContext", () => (parcelRequire("6u2b1")).SynthesisContext);

$parcel$export(module.exports, "OutputFormatPropertyName", () => $e78697b44b556af2$export$ad4e0600dd11837f);
$parcel$export(module.exports, "CancellationErrorCodePropertyName", () => $e78697b44b556af2$export$cbbf1d2efc001695);
$parcel$export(module.exports, "ServicePropertiesPropertyName", () => $e78697b44b556af2$export$84df797b3b5f7f6c);
$parcel$export(module.exports, "ForceDictationPropertyName", () => $e78697b44b556af2$export$9fd1049e23088e5e);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
// Make sure not to export internal modules.
//









var $je076 = parcelRequire("je076");

var $3kAgv = parcelRequire("3kAgv");
parcelRequire("cOea6");






parcelRequire("iBWCB");
parcelRequire("c7Irs");
parcelRequire("5fZ8e");
parcelRequire("aWATK");
parcelRequire("bhcO2");

var $kK3Rc = parcelRequire("kK3Rc");
parcelRequire("gdyuc");
parcelRequire("i1ulX");
parcelRequire("1Anur");

var $dRPvB = parcelRequire("dRPvB");

var $5TEdQ = parcelRequire("5TEdQ");
parcelRequire("bO7IR");
parcelRequire("ea7Fz");





var $30z0l = parcelRequire("30z0l");
parcelRequire("3AOeU");
parcelRequire("a1SmT");


var $iEXXa = parcelRequire("iEXXa");
parcelRequire("gBeX5");

parcelRequire("irXhw");

var $cNneV = parcelRequire("cNneV");

var $iuSgX = parcelRequire("iuSgX");


parcelRequire("6u2b1");


var $4biu1 = parcelRequire("4biu1");

var $4pUHf = parcelRequire("4pUHf");
const $e78697b44b556af2$export$ad4e0600dd11837f = "OutputFormat";
const $e78697b44b556af2$export$cbbf1d2efc001695 = "CancellationErrorCode";
const $e78697b44b556af2$export$84df797b3b5f7f6c = "ServiceProperties";
const $e78697b44b556af2$export$9fd1049e23088e5e = "ForceDictation";
const $e78697b44b556af2$export$dfb31ff7bb3a5cb4 = "OpenRange";
$parcel$exportWildcard(module.exports, $je076);
$parcel$exportWildcard(module.exports, $3kAgv);
$parcel$exportWildcard(module.exports, $kK3Rc);
$parcel$exportWildcard(module.exports, $dRPvB);
$parcel$exportWildcard(module.exports, $5TEdQ);
$parcel$exportWildcard(module.exports, $30z0l);
$parcel$exportWildcard(module.exports, $iEXXa);
$parcel$exportWildcard(module.exports, $cNneV);
$parcel$exportWildcard(module.exports, $iuSgX);
$parcel$exportWildcard(module.exports, $4biu1);
$parcel$exportWildcard(module.exports, $4pUHf);

});
parcelRequire.register("je076", function(module, exports) {

$parcel$export(module.exports, "ServiceRecognizerBase", () => $dfef69b3b1d23c3f$export$984734d84ac7a9a1);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
parcelRequire("2iayq");
var $6RE4c = parcelRequire("6RE4c");
parcelRequire("cR8AB");
var $83Xvm = parcelRequire("83Xvm");
var $dxrNf = parcelRequire("dxrNf");
var $fjbxF = parcelRequire("fjbxF");
var $jQZQm = parcelRequire("jQZQm");
var $ieLRH = parcelRequire("ieLRH");
var $1v63k = parcelRequire("1v63k");
var $hsGnG = parcelRequire("hsGnG");

var $lnpwm = parcelRequire("lnpwm");
var $5idXV = parcelRequire("5idXV");
var $bjdWp = parcelRequire("bjdWp");
var $eylh7 = parcelRequire("eylh7");
var $daYNc = parcelRequire("daYNc");
parcelRequire("jSpbe");
var $30z0l = parcelRequire("30z0l");
var $a1SmT = parcelRequire("a1SmT");
var $3AOeU = parcelRequire("3AOeU");
var $gBeX5 = parcelRequire("gBeX5");
var $cOea6 = parcelRequire("cOea6");
var $gdyuc = parcelRequire("gdyuc");

var $l4rU0 = parcelRequire("l4rU0");
var $dfef69b3b1d23c3f$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
class $dfef69b3b1d23c3f$export$984734d84ac7a9a1 {
    constructor(authentication, connectionFactory, audioSource, recognizerConfig, recognizer){
        // A promise for a configured connection.
        // Do not consume directly, call fetchConnection instead.
        this.privConnectionConfigurationPromise = undefined;
        // A promise for a connection, but one that has not had the speech context sent yet.
        // Do not consume directly, call fetchConnection instead.
        this.privConnectionPromise = undefined;
        this.privSetTimeout = setTimeout;
        this.privIsLiveAudio = false;
        this.recognizeOverride = undefined;
        this.recognizeSpeaker = undefined;
        this.disconnectOverride = undefined;
        this.receiveMessageOverride = undefined;
        this.sendPrePayloadJSONOverride = undefined;
        this.postConnectImplOverride = undefined;
        this.configConnectionOverride = undefined;
        this.handleSpeechPhraseMessage = undefined;
        this.handleSpeechHypothesisMessage = undefined;
        if (!authentication) throw new (0, $83Xvm.ArgumentNullError)("authentication");
        if (!connectionFactory) throw new (0, $83Xvm.ArgumentNullError)("connectionFactory");
        if (!audioSource) throw new (0, $83Xvm.ArgumentNullError)("audioSource");
        if (!recognizerConfig) throw new (0, $83Xvm.ArgumentNullError)("recognizerConfig");
        this.privMustReportEndOfStream = false;
        this.privAuthentication = authentication;
        this.privConnectionFactory = connectionFactory;
        this.privAudioSource = audioSource;
        this.privRecognizerConfig = recognizerConfig;
        this.privIsDisposed = false;
        this.privRecognizer = recognizer;
        this.privRequestSession = new (0, $30z0l.RequestSession)(this.privAudioSource.id());
        this.privConnectionEvents = new (0, $dxrNf.EventSource)();
        this.privServiceEvents = new (0, $dxrNf.EventSource)();
        this.privDynamicGrammar = new (0, $a1SmT.DynamicGrammarBuilder)();
        this.privSpeechContext = new (0, $3AOeU.SpeechContext)(this.privDynamicGrammar);
        this.privAgentConfig = new (0, $gBeX5.AgentConfig)();
        if (typeof Blob !== "undefined" && typeof Worker !== "undefined") this.privSetTimeout = (0, $fjbxF.Timeout).setTimeout;
        this.connectionEvents.attach((connectionEvent)=>{
            if (connectionEvent.name === "ConnectionClosedEvent") {
                const connectionClosedEvent = connectionEvent;
                if (connectionClosedEvent.statusCode === 1003 || connectionClosedEvent.statusCode === 1007 || connectionClosedEvent.statusCode === 1002 || connectionClosedEvent.statusCode === 4000 || this.privRequestSession.numConnectionAttempts > this.privRecognizerConfig.maxRetryCount) this.cancelRecognitionLocal((0, $5idXV.CancellationReason).Error, connectionClosedEvent.statusCode === 1007 ? (0, $lnpwm.CancellationErrorCode).BadRequestParameters : (0, $lnpwm.CancellationErrorCode).ConnectionFailure, `${connectionClosedEvent.reason} websocket error code: ${connectionClosedEvent.statusCode}`);
            }
        });
        const phraseDetection = {};
        if (recognizerConfig.autoDetectSourceLanguages !== undefined) {
            const sourceLanguages = recognizerConfig.autoDetectSourceLanguages.split(",");
            let speechContextLidMode;
            if (recognizerConfig.languageIdMode === "Continuous") speechContextLidMode = "DetectContinuous";
            else speechContextLidMode = "DetectAtAudioStart";
            this.privSpeechContext.setSection("languageId", {
                Priority: "PrioritizeLatency",
                languages: sourceLanguages,
                mode: speechContextLidMode,
                onSuccess: {
                    action: "Recognize"
                },
                onUnknown: {
                    action: "None"
                }
            });
            this.privSpeechContext.setSection("phraseOutput", {
                interimResults: {
                    resultType: "Auto"
                },
                phraseResults: {
                    resultType: "Always"
                }
            });
            const customModels = recognizerConfig.sourceLanguageModels;
            if (customModels !== undefined) {
                phraseDetection.customModels = customModels;
                phraseDetection.onInterim = {
                    action: "None"
                };
                phraseDetection.onSuccess = {
                    action: "None"
                };
            }
        }
        const isEmpty = (obj)=>{
            // eslint-disable-next-line guard-for-in, brace-style
            for(const x in obj)return false;
            return true;
        };
        if (!isEmpty(phraseDetection)) this.privSpeechContext.setSection("phraseDetection", phraseDetection);
    }
    setSpeechSegmentationTimeout() {
        const speechSegmentationTimeout = this.privRecognizerConfig.parameters.getProperty((0, $bjdWp.PropertyId).Speech_SegmentationSilenceTimeoutMs, undefined);
        if (speechSegmentationTimeout !== undefined) {
            const mode = this.recognitionMode === (0, $cOea6.RecognitionMode).Conversation ? "CONVERSATION" : this.recognitionMode === (0, $cOea6.RecognitionMode).Dictation ? "DICTATION" : "INTERACTIVE";
            const segmentationSilenceTimeoutMs = parseInt(speechSegmentationTimeout, 10);
            const phraseDetection = this.privSpeechContext.getSection("phraseDetection");
            phraseDetection.mode = mode;
            phraseDetection[mode] = {
                segmentation: {
                    mode: "Custom",
                    segmentationSilenceTimeoutMs: segmentationSilenceTimeoutMs
                }
            };
            this.privSpeechContext.setSection("phraseDetection", phraseDetection);
        }
    }
    get audioSource() {
        return this.privAudioSource;
    }
    get speechContext() {
        return this.privSpeechContext;
    }
    get dynamicGrammar() {
        return this.privDynamicGrammar;
    }
    get agentConfig() {
        return this.privAgentConfig;
    }
    set conversationTranslatorToken(token) {
        this.privRecognizerConfig.parameters.setProperty((0, $bjdWp.PropertyId).ConversationTranslator_Token, token);
    }
    set voiceProfileType(type) {
        this.privRecognizerConfig.parameters.setProperty((0, $bjdWp.PropertyId).SpeechServiceConnection_SpeakerIdMode, type);
    }
    set authentication(auth) {
        this.privAuthentication = this.authentication;
    }
    isDisposed() {
        return this.privIsDisposed;
    }
    dispose(reason) {
        return $dfef69b3b1d23c3f$var$__awaiter(this, void 0, void 0, function*() {
            this.privIsDisposed = true;
            if (this.privConnectionConfigurationPromise !== undefined) try {
                const connection = yield this.privConnectionConfigurationPromise;
                yield connection.dispose(reason);
            } catch (error) {
                // The connection is in a bad state. But we're trying to kill it, so...
                return;
            }
        });
    }
    get connectionEvents() {
        return this.privConnectionEvents;
    }
    get serviceEvents() {
        return this.privServiceEvents;
    }
    get recognitionMode() {
        return this.privRecognizerConfig.recognitionMode;
    }
    recognize(recoMode, successCallback, errorCallBack) {
        return $dfef69b3b1d23c3f$var$__awaiter(this, void 0, void 0, function*() {
            if (this.recognizeOverride !== undefined) {
                yield this.recognizeOverride(recoMode, successCallback, errorCallBack);
                return;
            }
            // Clear the existing configuration promise to force a re-transmission of config and context.
            this.privConnectionConfigurationPromise = undefined;
            this.privRecognizerConfig.recognitionMode = recoMode;
            this.setSpeechSegmentationTimeout();
            this.privSuccessCallback = successCallback;
            this.privErrorCallback = errorCallBack;
            this.privRequestSession.startNewRecognition();
            this.privRequestSession.listenForServiceTelemetry(this.privAudioSource.events);
            // Start the connection to the service. The promise this will create is stored and will be used by configureConnection().
            const conPromise = this.connectImpl();
            let audioNode;
            try {
                const audioStreamNode = yield this.audioSource.attach(this.privRequestSession.audioNodeId);
                const format = yield this.audioSource.format;
                const deviceInfo = yield this.audioSource.deviceInfo;
                this.privIsLiveAudio = deviceInfo.type && deviceInfo.type === (0, $cOea6.type).Microphones;
                audioNode = new (0, $6RE4c.ReplayableAudioNode)(audioStreamNode, format.avgBytesPerSec);
                yield this.privRequestSession.onAudioSourceAttachCompleted(audioNode, false);
                this.privRecognizerConfig.SpeechServiceConfig.Context.audio = {
                    source: deviceInfo
                };
            } catch (error) {
                yield this.privRequestSession.onStopRecognizing();
                throw error;
            }
            try {
                yield conPromise;
            } catch (error) {
                yield this.cancelRecognitionLocal((0, $5idXV.CancellationReason).Error, (0, $lnpwm.CancellationErrorCode).ConnectionFailure, error);
                return;
            }
            const sessionStartEventArgs = new (0, $daYNc.SessionEventArgs)(this.privRequestSession.sessionId);
            if (!!this.privRecognizer.sessionStarted) this.privRecognizer.sessionStarted(this.privRecognizer, sessionStartEventArgs);
            this.receiveMessage();
            const audioSendPromise = this.sendAudio(audioNode);
            audioSendPromise.catch((error)=>$dfef69b3b1d23c3f$var$__awaiter(this, void 0, void 0, function*() {
                    yield this.cancelRecognitionLocal((0, $5idXV.CancellationReason).Error, (0, $lnpwm.CancellationErrorCode).RuntimeError, error);
                }));
            return;
        });
    }
    stopRecognizing() {
        return $dfef69b3b1d23c3f$var$__awaiter(this, void 0, void 0, function*() {
            if (this.privRequestSession.isRecognizing) try {
                yield this.audioSource.turnOff();
                yield this.sendFinalAudio();
                yield this.privRequestSession.onStopRecognizing();
                yield this.privRequestSession.turnCompletionPromise;
            } finally{
                yield this.privRequestSession.dispose();
            }
            return;
        });
    }
    connect() {
        return $dfef69b3b1d23c3f$var$__awaiter(this, void 0, void 0, function*() {
            yield this.connectImpl();
            return Promise.resolve();
        });
    }
    connectAsync(cb, err) {
        this.connectImpl().then(()=>{
            try {
                if (!!cb) cb();
            } catch (e) {
                if (!!err) err(e);
            }
        }, (reason)=>{
            try {
                if (!!err) err(reason);
            /* eslint-disable no-empty */ } catch (error) {}
        });
    }
    disconnect() {
        return $dfef69b3b1d23c3f$var$__awaiter(this, void 0, void 0, function*() {
            yield this.cancelRecognitionLocal((0, $5idXV.CancellationReason).Error, (0, $lnpwm.CancellationErrorCode).NoError, "Disconnecting");
            if (this.disconnectOverride !== undefined) yield this.disconnectOverride();
            if (this.privConnectionPromise !== undefined) try {
                yield (yield this.privConnectionPromise).dispose();
            } catch (error) {}
            this.privConnectionPromise = undefined;
        });
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    sendMessage(message) {
        return;
    }
    sendNetworkMessage(path, payload) {
        return $dfef69b3b1d23c3f$var$__awaiter(this, void 0, void 0, function*() {
            const type = typeof payload === "string" ? (0, $jQZQm.MessageType).Text : (0, $jQZQm.MessageType).Binary;
            const contentType = typeof payload === "string" ? "application/json" : "";
            const connection = yield this.fetchConnection();
            return connection.send(new (0, $l4rU0.SpeechConnectionMessage)(type, path, this.privRequestSession.requestId, contentType, payload));
        });
    }
    set activityTemplate(messagePayload) {
        this.privActivityTemplate = messagePayload;
    }
    get activityTemplate() {
        return this.privActivityTemplate;
    }
    sendTelemetryData() {
        return $dfef69b3b1d23c3f$var$__awaiter(this, void 0, void 0, function*() {
            const telemetryData = this.privRequestSession.getTelemetry();
            if ($dfef69b3b1d23c3f$export$984734d84ac7a9a1.telemetryDataEnabled !== true || this.privIsDisposed || null === telemetryData) return;
            if (!!$dfef69b3b1d23c3f$export$984734d84ac7a9a1.telemetryData) try {
                $dfef69b3b1d23c3f$export$984734d84ac7a9a1.telemetryData(telemetryData);
            /* eslint-disable no-empty */ } catch (_a) {}
            const connection = yield this.fetchConnection();
            yield connection.send(new (0, $l4rU0.SpeechConnectionMessage)((0, $jQZQm.MessageType).Text, "telemetry", this.privRequestSession.requestId, "application/json", telemetryData));
        });
    }
    // Cancels recognition.
    cancelRecognitionLocal(cancellationReason, errorCode, error) {
        return $dfef69b3b1d23c3f$var$__awaiter(this, void 0, void 0, function*() {
            if (!!this.privRequestSession.isRecognizing) {
                yield this.privRequestSession.onStopRecognizing();
                this.cancelRecognition(this.privRequestSession.sessionId, this.privRequestSession.requestId, cancellationReason, errorCode, error);
            }
        });
    }
    receiveMessage() {
        return $dfef69b3b1d23c3f$var$__awaiter(this, void 0, void 0, function*() {
            try {
                if (this.privIsDisposed) // We're done.
                return;
                let connection = yield this.fetchConnection();
                const message = yield connection.read();
                if (this.receiveMessageOverride !== undefined) return this.receiveMessageOverride();
                // indicates we are draining the queue and it came with no message;
                if (!message) {
                    if (!this.privRequestSession.isRecognizing) return;
                    else return this.receiveMessage();
                }
                this.privServiceHasSentMessage = true;
                const connectionMessage = (0, $l4rU0.SpeechConnectionMessage).fromConnectionMessage(message);
                if (connectionMessage.requestId.toLowerCase() === this.privRequestSession.requestId.toLowerCase()) switch(connectionMessage.path.toLowerCase()){
                    case "turn.start":
                        this.privMustReportEndOfStream = true;
                        this.privRequestSession.onServiceTurnStartResponse();
                        break;
                    case "speech.startdetected":
                        const speechStartDetected = (0, $gdyuc.SpeechDetected).fromJSON(connectionMessage.textBody);
                        const speechStartEventArgs = new (0, $eylh7.RecognitionEventArgs)(speechStartDetected.Offset, this.privRequestSession.sessionId);
                        if (!!this.privRecognizer.speechStartDetected) this.privRecognizer.speechStartDetected(this.privRecognizer, speechStartEventArgs);
                        break;
                    case "speech.enddetected":
                        let json;
                        if (connectionMessage.textBody.length > 0) json = connectionMessage.textBody;
                        else // If the request was empty, the JSON returned is empty.
                        json = "{ Offset: 0 }";
                        const speechStopDetected = (0, $gdyuc.SpeechDetected).fromJSON(json);
                        const speechStopEventArgs = new (0, $eylh7.RecognitionEventArgs)(speechStopDetected.Offset + this.privRequestSession.currentTurnAudioOffset, this.privRequestSession.sessionId);
                        if (!!this.privRecognizer.speechEndDetected) this.privRecognizer.speechEndDetected(this.privRecognizer, speechStopEventArgs);
                        break;
                    case "turn.end":
                        yield this.sendTelemetryData();
                        if (this.privRequestSession.isSpeechEnded && this.privMustReportEndOfStream) {
                            this.privMustReportEndOfStream = false;
                            yield this.cancelRecognitionLocal((0, $5idXV.CancellationReason).EndOfStream, (0, $lnpwm.CancellationErrorCode).NoError, undefined);
                        }
                        const sessionStopEventArgs = new (0, $daYNc.SessionEventArgs)(this.privRequestSession.sessionId);
                        yield this.privRequestSession.onServiceTurnEndResponse(this.privRecognizerConfig.isContinuousRecognition);
                        if (!this.privRecognizerConfig.isContinuousRecognition || this.privRequestSession.isSpeechEnded || !this.privRequestSession.isRecognizing) {
                            if (!!this.privRecognizer.sessionStopped) this.privRecognizer.sessionStopped(this.privRecognizer, sessionStopEventArgs);
                            return;
                        } else {
                            connection = yield this.fetchConnection();
                            yield this.sendPrePayloadJSON(connection);
                        }
                        break;
                    default:
                        if (!(yield this.processTypeSpecificMessages(connectionMessage))) // here are some messages that the derived class has not processed, dispatch them to connect class
                        {
                            if (!!this.privServiceEvents) this.serviceEvents.onEvent(new (0, $ieLRH.ServiceEvent)(connectionMessage.path.toLowerCase(), connectionMessage.textBody));
                        }
                }
                return this.receiveMessage();
            } catch (error) {
                return null;
            }
        });
    }
    sendSpeechContext(connection, generateNewRequestId) {
        const speechContextJson = this.speechContext.toJSON();
        if (generateNewRequestId) this.privRequestSession.onSpeechContext();
        if (speechContextJson) return connection.send(new (0, $l4rU0.SpeechConnectionMessage)((0, $jQZQm.MessageType).Text, "speech.context", this.privRequestSession.requestId, "application/json", speechContextJson));
        return;
    }
    noOp() {
        // operation not supported
        return;
    }
    // Encapsulated for derived service recognizers that need to send additional JSON
    sendPrePayloadJSON(connection, generateNewRequestId = true) {
        return $dfef69b3b1d23c3f$var$__awaiter(this, void 0, void 0, function*() {
            if (this.sendPrePayloadJSONOverride !== undefined) return this.sendPrePayloadJSONOverride(connection);
            yield this.sendSpeechContext(connection, generateNewRequestId);
            yield this.sendWaveHeader(connection);
            return;
        });
    }
    sendWaveHeader(connection) {
        return $dfef69b3b1d23c3f$var$__awaiter(this, void 0, void 0, function*() {
            const format = yield this.audioSource.format;
            // this.writeBufferToConsole(format.header);
            return connection.send(new (0, $l4rU0.SpeechConnectionMessage)((0, $jQZQm.MessageType).Binary, "audio", this.privRequestSession.requestId, "audio/x-wav", format.header));
        });
    }
    // Establishes a websocket connection to the end point.
    connectImpl() {
        if (this.privConnectionPromise !== undefined) return this.privConnectionPromise.then((connection)=>{
            if (connection.state() === (0, $1v63k.ConnectionState).Disconnected) {
                this.privConnectionId = null;
                this.privConnectionPromise = undefined;
                this.privServiceHasSentMessage = false;
                return this.connectImpl();
            }
            return this.privConnectionPromise;
        }, ()=>{
            this.privConnectionId = null;
            this.privConnectionPromise = undefined;
            this.privServiceHasSentMessage = false;
            return this.connectImpl();
        });
        this.privConnectionPromise = this.retryableConnect();
        // Attach an empty handler to allow the promise to run in the background while
        // other startup events happen. It'll eventually be awaited on.
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        this.privConnectionPromise.catch(()=>{});
        if (this.postConnectImplOverride !== undefined) return this.postConnectImplOverride(this.privConnectionPromise);
        return this.privConnectionPromise;
    }
    sendSpeechServiceConfig(connection, requestSession, SpeechServiceConfigJson) {
        requestSession.onSpeechContext();
        // filter out anything that is not required for the service to work.
        if ($dfef69b3b1d23c3f$export$984734d84ac7a9a1.telemetryDataEnabled !== true) {
            const withTelemetry = JSON.parse(SpeechServiceConfigJson);
            const replacement = {
                context: {
                    system: withTelemetry.context.system
                }
            };
            SpeechServiceConfigJson = JSON.stringify(replacement);
        }
        if (this.privRecognizerConfig.parameters.getProperty("f0f5debc-f8c9-4892-ac4b-90a7ab359fd2", "false").toLowerCase() === "true") {
            const json = JSON.parse(SpeechServiceConfigJson);
            json.context.DisableReferenceChannel = "True";
            json.context.MicSpec = "1_0_0";
            SpeechServiceConfigJson = JSON.stringify(json);
        }
        if (SpeechServiceConfigJson) return connection.send(new (0, $l4rU0.SpeechConnectionMessage)((0, $jQZQm.MessageType).Text, "speech.config", requestSession.requestId, "application/json", SpeechServiceConfigJson));
        return;
    }
    fetchConnection() {
        return $dfef69b3b1d23c3f$var$__awaiter(this, void 0, void 0, function*() {
            if (this.privConnectionConfigurationPromise !== undefined) return this.privConnectionConfigurationPromise.then((connection)=>{
                if (connection.state() === (0, $1v63k.ConnectionState).Disconnected) {
                    this.privConnectionId = null;
                    this.privConnectionConfigurationPromise = undefined;
                    this.privServiceHasSentMessage = false;
                    return this.fetchConnection();
                }
                return this.privConnectionConfigurationPromise;
            }, ()=>{
                this.privConnectionId = null;
                this.privConnectionConfigurationPromise = undefined;
                this.privServiceHasSentMessage = false;
                return this.fetchConnection();
            });
            this.privConnectionConfigurationPromise = this.configureConnection();
            return yield this.privConnectionConfigurationPromise;
        });
    }
    sendAudio(audioStreamNode) {
        return $dfef69b3b1d23c3f$var$__awaiter(this, void 0, void 0, function*() {
            const audioFormat = yield this.audioSource.format;
            // The time we last sent data to the service.
            let nextSendTime = Date.now();
            // Max amount to send before we start to throttle
            const fastLaneSizeMs = this.privRecognizerConfig.parameters.getProperty("SPEECH-TransmitLengthBeforThrottleMs", "5000");
            const maxSendUnthrottledBytes = audioFormat.avgBytesPerSec / 1000 * parseInt(fastLaneSizeMs, 10);
            const startRecogNumber = this.privRequestSession.recogNumber;
            const readAndUploadCycle = ()=>$dfef69b3b1d23c3f$var$__awaiter(this, void 0, void 0, function*() {
                    // If speech is done, stop sending audio.
                    if (!this.privIsDisposed && !this.privRequestSession.isSpeechEnded && this.privRequestSession.isRecognizing && this.privRequestSession.recogNumber === startRecogNumber) {
                        const connection = yield this.fetchConnection();
                        const audioStreamChunk = yield audioStreamNode.read();
                        // we have a new audio chunk to upload.
                        if (this.privRequestSession.isSpeechEnded) // If service already recognized audio end then don't send any more audio
                        return;
                        let payload;
                        let sendDelay;
                        if (!audioStreamChunk || audioStreamChunk.isEnd) {
                            payload = null;
                            sendDelay = 0;
                        } else {
                            payload = audioStreamChunk.buffer;
                            this.privRequestSession.onAudioSent(payload.byteLength);
                            if (maxSendUnthrottledBytes >= this.privRequestSession.bytesSent) sendDelay = 0;
                            else sendDelay = Math.max(0, nextSendTime - Date.now());
                        }
                        if (0 !== sendDelay) yield this.delay(sendDelay);
                        if (payload !== null) nextSendTime = Date.now() + payload.byteLength * 1000 / (audioFormat.avgBytesPerSec * 2);
                        // Are we still alive?
                        if (!this.privIsDisposed && !this.privRequestSession.isSpeechEnded && this.privRequestSession.isRecognizing && this.privRequestSession.recogNumber === startRecogNumber) {
                            connection.send(new (0, $l4rU0.SpeechConnectionMessage)((0, $jQZQm.MessageType).Binary, "audio", this.privRequestSession.requestId, null, payload)).catch(()=>{
                                // eslint-disable-next-line @typescript-eslint/no-empty-function
                                this.privRequestSession.onServiceTurnEndResponse(this.privRecognizerConfig.isContinuousRecognition).catch(()=>{});
                            });
                            if (!(audioStreamChunk === null || audioStreamChunk === void 0 ? void 0 : audioStreamChunk.isEnd)) // this.writeBufferToConsole(payload);
                            // Regardless of success or failure, schedule the next upload.
                            // If the underlying connection was broken, the next cycle will
                            // get a new connection and re-transmit missing audio automatically.
                            return readAndUploadCycle();
                            else // the audio stream has been closed, no need to schedule next
                            // read-upload cycle.
                            if (!this.privIsLiveAudio) this.privRequestSession.onSpeechEnded();
                        }
                    }
                });
            return readAndUploadCycle();
        });
    }
    retryableConnect() {
        return $dfef69b3b1d23c3f$var$__awaiter(this, void 0, void 0, function*() {
            let isUnAuthorized = false;
            this.privAuthFetchEventId = (0, $hsGnG.createNoDashGuid)();
            const sessionId = this.privRequestSession.sessionId;
            this.privConnectionId = sessionId !== undefined ? sessionId : (0, $hsGnG.createNoDashGuid)();
            this.privRequestSession.onPreConnectionStart(this.privAuthFetchEventId, this.privConnectionId);
            let lastStatusCode = 0;
            let lastReason = "";
            while(this.privRequestSession.numConnectionAttempts <= this.privRecognizerConfig.maxRetryCount){
                // Get the auth information for the connection. This is a bit of overkill for the current API surface, but leaving the plumbing in place to be able to raise a developer-customer
                // facing event when a connection fails to let them try and provide new auth information.
                const authPromise = isUnAuthorized ? this.privAuthentication.fetchOnExpiry(this.privAuthFetchEventId) : this.privAuthentication.fetch(this.privAuthFetchEventId);
                const auth = yield authPromise;
                yield this.privRequestSession.onAuthCompleted(false);
                // Create the connection
                const connection = this.privConnectionFactory.create(this.privRecognizerConfig, auth, this.privConnectionId);
                // Attach the telemetry handlers.
                this.privRequestSession.listenForServiceTelemetry(connection.events);
                // Attach to the underlying event. No need to hold onto the detach pointers as in the event the connection goes away,
                // it'll stop sending events.
                connection.events.attach((event)=>{
                    this.connectionEvents.onEvent(event);
                });
                const response = yield connection.open();
                // 200 == everything is fine.
                if (response.statusCode === 200) {
                    yield this.privRequestSession.onConnectionEstablishCompleted(response.statusCode);
                    return Promise.resolve(connection);
                } else if (response.statusCode === 1006) isUnAuthorized = true;
                lastStatusCode = response.statusCode;
                lastReason = response.reason;
                this.privRequestSession.onRetryConnection();
            }
            yield this.privRequestSession.onConnectionEstablishCompleted(lastStatusCode, lastReason);
            return Promise.reject(`Unable to contact server. StatusCode: ${lastStatusCode}, ${this.privRecognizerConfig.parameters.getProperty((0, $bjdWp.PropertyId).SpeechServiceConnection_Endpoint)} Reason: ${lastReason}`);
        });
    }
    delay(delayMs) {
        return new Promise((resolve)=>this.privSetTimeout(resolve, delayMs));
    }
    writeBufferToConsole(buffer) {
        let out = "Buffer Size: ";
        if (null === buffer) out += "null";
        else {
            const readView = new Uint8Array(buffer);
            out += `${buffer.byteLength}\r\n`;
            for(let i = 0; i < buffer.byteLength; i++){
                out += readView[i].toString(16).padStart(2, "0") + " ";
                if ((i + 1) % 16 === 0) {
                    // eslint-disable-next-line no-console
                    console.info(out);
                    out = "";
                }
            }
        }
        // eslint-disable-next-line no-console
        console.info(out);
    }
    sendFinalAudio() {
        return $dfef69b3b1d23c3f$var$__awaiter(this, void 0, void 0, function*() {
            const connection = yield this.fetchConnection();
            yield connection.send(new (0, $l4rU0.SpeechConnectionMessage)((0, $jQZQm.MessageType).Binary, "audio", this.privRequestSession.requestId, null, null));
            return;
        });
    }
    // Takes an established websocket connection to the endpoint and sends speech configuration information.
    configureConnection() {
        return $dfef69b3b1d23c3f$var$__awaiter(this, void 0, void 0, function*() {
            const connection = yield this.connectImpl();
            if (this.configConnectionOverride !== undefined) return this.configConnectionOverride(connection);
            yield this.sendSpeechServiceConfig(connection, this.privRequestSession, this.privRecognizerConfig.SpeechServiceConfig.serialize());
            yield this.sendPrePayloadJSON(connection, false);
            return connection;
        });
    }
}
$dfef69b3b1d23c3f$export$984734d84ac7a9a1.telemetryDataEnabled = true;

});
parcelRequire.register("lnpwm", function(module, exports) {

$parcel$export(module.exports, "CancellationErrorCode", () => $f8ff8ae2f556a794$export$b0e2ad361e796e97);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
/**
 * Defines error code in case that CancellationReason is Error.
 * Added in version 1.1.0.
 */ var $f8ff8ae2f556a794$export$b0e2ad361e796e97;
(function(CancellationErrorCode) {
    /**
     * Indicates that no error occurred during speech recognition.
     */ CancellationErrorCode[CancellationErrorCode["NoError"] = 0] = "NoError";
    /**
     * Indicates an authentication error.
     */ CancellationErrorCode[CancellationErrorCode["AuthenticationFailure"] = 1] = "AuthenticationFailure";
    /**
     * Indicates that one or more recognition parameters are invalid.
     */ CancellationErrorCode[CancellationErrorCode["BadRequestParameters"] = 2] = "BadRequestParameters";
    /**
     * Indicates that the number of parallel requests exceeded the number of allowed
     * concurrent transcriptions for the subscription.
     */ CancellationErrorCode[CancellationErrorCode["TooManyRequests"] = 3] = "TooManyRequests";
    /**
     * Indicates a connection error.
     */ CancellationErrorCode[CancellationErrorCode["ConnectionFailure"] = 4] = "ConnectionFailure";
    /**
     * Indicates a time-out error when waiting for response from service.
     */ CancellationErrorCode[CancellationErrorCode["ServiceTimeout"] = 5] = "ServiceTimeout";
    /**
     * Indicates that an error is returned by the service.
     */ CancellationErrorCode[CancellationErrorCode["ServiceError"] = 6] = "ServiceError";
    /**
     * Indicates an unexpected runtime error.
     */ CancellationErrorCode[CancellationErrorCode["RuntimeError"] = 7] = "RuntimeError";
    /**
     * Indicates an quota overrun on existing key.
     */ CancellationErrorCode[CancellationErrorCode["Forbidden"] = 8] = "Forbidden";
})($f8ff8ae2f556a794$export$b0e2ad361e796e97 || ($f8ff8ae2f556a794$export$b0e2ad361e796e97 = {}));

});

parcelRequire.register("5idXV", function(module, exports) {

$parcel$export(module.exports, "CancellationReason", () => $3da97777942b8ea5$export$cbce095b92028433);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
/**
 * Defines the possible reasons a recognition result might be canceled.
 * @class CancellationReason
 */ var $3da97777942b8ea5$export$cbce095b92028433;
(function(CancellationReason) {
    /**
     * Indicates that an error occurred during speech recognition.
     * @member CancellationReason.Error
     */ CancellationReason[CancellationReason["Error"] = 0] = "Error";
    /**
     * Indicates that the end of the audio stream was reached.
     * @member CancellationReason.EndOfStream
     */ CancellationReason[CancellationReason["EndOfStream"] = 1] = "EndOfStream";
})($3da97777942b8ea5$export$cbce095b92028433 || ($3da97777942b8ea5$export$cbce095b92028433 = {}));

});

parcelRequire.register("bjdWp", function(module, exports) {

$parcel$export(module.exports, "PropertyId", () => $83bc4874065a0f92$export$f7caa2a6f083d81);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
/**
 * Defines speech property ids.
 * @class PropertyId
 */ var $83bc4874065a0f92$export$f7caa2a6f083d81;
(function(PropertyId) {
    /**
     * The Cognitive Services Speech Service subscription Key. If you are using an intent recognizer, you need to
     * specify the LUIS endpoint key for your particular LUIS app. Under normal circumstances, you shouldn't
     * have to use this property directly.
     * Instead, use [[SpeechConfig.fromSubscription]].
     * @member PropertyId.SpeechServiceConnection_Key
     */ PropertyId[PropertyId["SpeechServiceConnection_Key"] = 0] = "SpeechServiceConnection_Key";
    /**
     * The Cognitive Services Speech Service endpoint (url). Under normal circumstances, you shouldn't
     * have to use this property directly.
     * Instead, use [[SpeechConfig.fromEndpoint]].
     * NOTE: This endpoint is not the same as the endpoint used to obtain an access token.
     * @member PropertyId.SpeechServiceConnection_Endpoint
     */ PropertyId[PropertyId["SpeechServiceConnection_Endpoint"] = 1] = "SpeechServiceConnection_Endpoint";
    /**
     * The Cognitive Services Speech Service region. Under normal circumstances, you shouldn't have to
     * use this property directly.
     * Instead, use [[SpeechConfig.fromSubscription]], [[SpeechConfig.fromEndpoint]], [[SpeechConfig.fromAuthorizationToken]].
     * @member PropertyId.SpeechServiceConnection_Region
     */ PropertyId[PropertyId["SpeechServiceConnection_Region"] = 2] = "SpeechServiceConnection_Region";
    /**
     * The Cognitive Services Speech Service authorization token (aka access token). Under normal circumstances,
     * you shouldn't have to use this property directly.
     * Instead, use [[SpeechConfig.fromAuthorizationToken]], [[SpeechRecognizer.authorizationToken]],
     * [[IntentRecognizer.authorizationToken]], [[TranslationRecognizer.authorizationToken]], [[SpeakerRecognizer.authorizationToken]].
     * @member PropertyId.SpeechServiceAuthorization_Token
     */ PropertyId[PropertyId["SpeechServiceAuthorization_Token"] = 3] = "SpeechServiceAuthorization_Token";
    /**
     * The Cognitive Services Speech Service authorization type. Currently unused.
     * @member PropertyId.SpeechServiceAuthorization_Type
     */ PropertyId[PropertyId["SpeechServiceAuthorization_Type"] = 4] = "SpeechServiceAuthorization_Type";
    /**
     * The Cognitive Services Speech Service endpoint id. Under normal circumstances, you shouldn't
     * have to use this property directly.
     * Instead, use [[SpeechConfig.endpointId]].
     * NOTE: The endpoint id is available in the Speech Portal, listed under Endpoint Details.
     * @member PropertyId.SpeechServiceConnection_EndpointId
     */ PropertyId[PropertyId["SpeechServiceConnection_EndpointId"] = 5] = "SpeechServiceConnection_EndpointId";
    /**
     * The list of comma separated languages (BCP-47 format) used as target translation languages. Under normal circumstances,
     * you shouldn't have to use this property directly.
     * Instead use [[SpeechTranslationConfig.addTargetLanguage]],
     * [[SpeechTranslationConfig.targetLanguages]], [[TranslationRecognizer.targetLanguages]].
     * @member PropertyId.SpeechServiceConnection_TranslationToLanguages
     */ PropertyId[PropertyId["SpeechServiceConnection_TranslationToLanguages"] = 6] = "SpeechServiceConnection_TranslationToLanguages";
    /**
     * The name of the Cognitive Service Text to Speech Service Voice. Under normal circumstances, you shouldn't have to use this
     * property directly.
     * Instead, use [[SpeechTranslationConfig.voiceName]].
     * NOTE: Valid voice names can be found <a href="https://aka.ms/csspeech/voicenames">here</a>.
     * @member PropertyId.SpeechServiceConnection_TranslationVoice
     */ PropertyId[PropertyId["SpeechServiceConnection_TranslationVoice"] = 7] = "SpeechServiceConnection_TranslationVoice";
    /**
     * Translation features.
     * @member PropertyId.SpeechServiceConnection_TranslationFeatures
     */ PropertyId[PropertyId["SpeechServiceConnection_TranslationFeatures"] = 8] = "SpeechServiceConnection_TranslationFeatures";
    /**
     * The Language Understanding Service Region. Under normal circumstances, you shouldn't have to use this property directly.
     * Instead, use [[LanguageUnderstandingModel]].
     * @member PropertyId.SpeechServiceConnection_IntentRegion
     */ PropertyId[PropertyId["SpeechServiceConnection_IntentRegion"] = 9] = "SpeechServiceConnection_IntentRegion";
    /**
     * The host name of the proxy server used to connect to the Cognitive Services Speech Service. Only relevant in Node.js environments.
     * You shouldn't have to use this property directly.
     * Instead use <see cref="SpeechConfig.SetProxy(string,int,string,string)"/>.
     * Added in version 1.4.0.
     */ PropertyId[PropertyId["SpeechServiceConnection_ProxyHostName"] = 10] = "SpeechServiceConnection_ProxyHostName";
    /**
     * The port of the proxy server used to connect to the Cognitive Services Speech Service. Only relevant in Node.js environments.
     * You shouldn't have to use this property directly.
     * Instead use <see cref="SpeechConfig.SetProxy(string,int,string,string)"/>.
     * Added in version 1.4.0.
     */ PropertyId[PropertyId["SpeechServiceConnection_ProxyPort"] = 11] = "SpeechServiceConnection_ProxyPort";
    /**
     * The user name of the proxy server used to connect to the Cognitive Services Speech Service. Only relevant in Node.js environments.
     * You shouldn't have to use this property directly.
     * Instead use <see cref="SpeechConfig.SetProxy(string,int,string,string)"/>.
     * Added in version 1.4.0.
     */ PropertyId[PropertyId["SpeechServiceConnection_ProxyUserName"] = 12] = "SpeechServiceConnection_ProxyUserName";
    /**
     * The password of the proxy server used to connect to the Cognitive Services Speech Service. Only relevant in Node.js environments.
     * You shouldn't have to use this property directly.
     * Instead use <see cref="SpeechConfig.SetProxy(string,int,string,string)"/>.
     * Added in version 1.4.0.
     */ PropertyId[PropertyId["SpeechServiceConnection_ProxyPassword"] = 13] = "SpeechServiceConnection_ProxyPassword";
    /**
     * The Cognitive Services Speech Service recognition Mode. Can be "INTERACTIVE", "CONVERSATION", "DICTATION".
     * This property is intended to be read-only. The SDK is using it internally.
     * @member PropertyId.SpeechServiceConnection_RecoMode
     */ PropertyId[PropertyId["SpeechServiceConnection_RecoMode"] = 14] = "SpeechServiceConnection_RecoMode";
    /**
     * The spoken language to be recognized (in BCP-47 format). Under normal circumstances, you shouldn't have to use this property
     * directly.
     * Instead, use [[SpeechConfig.speechRecognitionLanguage]].
     * @member PropertyId.SpeechServiceConnection_RecoLanguage
     */ PropertyId[PropertyId["SpeechServiceConnection_RecoLanguage"] = 15] = "SpeechServiceConnection_RecoLanguage";
    /**
     * The session id. This id is a universally unique identifier (aka UUID) representing a specific binding of an audio input stream
     * and the underlying speech recognition instance to which it is bound. Under normal circumstances, you shouldn't have to use this
     * property directly.
     * Instead use [[SessionEventArgs.sessionId]].
     * @member PropertyId.Speech_SessionId
     */ PropertyId[PropertyId["Speech_SessionId"] = 16] = "Speech_SessionId";
    /**
     * The spoken language to be synthesized (e.g. en-US)
     * @member PropertyId.SpeechServiceConnection_SynthLanguage
     */ PropertyId[PropertyId["SpeechServiceConnection_SynthLanguage"] = 17] = "SpeechServiceConnection_SynthLanguage";
    /**
     * The name of the TTS voice to be used for speech synthesis
     * @member PropertyId.SpeechServiceConnection_SynthVoice
     */ PropertyId[PropertyId["SpeechServiceConnection_SynthVoice"] = 18] = "SpeechServiceConnection_SynthVoice";
    /**
     * The string to specify TTS output audio format
     * @member PropertyId.SpeechServiceConnection_SynthOutputFormat
     */ PropertyId[PropertyId["SpeechServiceConnection_SynthOutputFormat"] = 19] = "SpeechServiceConnection_SynthOutputFormat";
    /**
     * The list of comma separated languages used as possible source languages
     * Added in version 1.13.0
     * @member PropertyId.SpeechServiceConnection_AutoDetectSourceLanguages
     */ PropertyId[PropertyId["SpeechServiceConnection_AutoDetectSourceLanguages"] = 20] = "SpeechServiceConnection_AutoDetectSourceLanguages";
    /**
     * The requested Cognitive Services Speech Service response output format (simple or detailed). Under normal circumstances, you shouldn't have
     * to use this property directly.
     * Instead use [[SpeechConfig.outputFormat]].
     * @member PropertyId.SpeechServiceResponse_RequestDetailedResultTrueFalse
     */ PropertyId[PropertyId["SpeechServiceResponse_RequestDetailedResultTrueFalse"] = 21] = "SpeechServiceResponse_RequestDetailedResultTrueFalse";
    /**
     * The requested Cognitive Services Speech Service response output profanity level. Currently unused.
     * @member PropertyId.SpeechServiceResponse_RequestProfanityFilterTrueFalse
     */ PropertyId[PropertyId["SpeechServiceResponse_RequestProfanityFilterTrueFalse"] = 22] = "SpeechServiceResponse_RequestProfanityFilterTrueFalse";
    /**
     * The Cognitive Services Speech Service response output (in JSON format). This property is available on recognition result objects only.
     * @member PropertyId.SpeechServiceResponse_JsonResult
     */ PropertyId[PropertyId["SpeechServiceResponse_JsonResult"] = 23] = "SpeechServiceResponse_JsonResult";
    /**
     * The Cognitive Services Speech Service error details (in JSON format). Under normal circumstances, you shouldn't have to
     * use this property directly. Instead use [[CancellationDetails.errorDetails]].
     * @member PropertyId.SpeechServiceResponse_JsonErrorDetails
     */ PropertyId[PropertyId["SpeechServiceResponse_JsonErrorDetails"] = 24] = "SpeechServiceResponse_JsonErrorDetails";
    /**
     * The cancellation reason. Currently unused.
     * @member PropertyId.CancellationDetails_Reason
     */ PropertyId[PropertyId["CancellationDetails_Reason"] = 25] = "CancellationDetails_Reason";
    /**
     * The cancellation text. Currently unused.
     * @member PropertyId.CancellationDetails_ReasonText
     */ PropertyId[PropertyId["CancellationDetails_ReasonText"] = 26] = "CancellationDetails_ReasonText";
    /**
     * The Cancellation detailed text. Currently unused.
     * @member PropertyId.CancellationDetails_ReasonDetailedText
     */ PropertyId[PropertyId["CancellationDetails_ReasonDetailedText"] = 27] = "CancellationDetails_ReasonDetailedText";
    /**
     * The Language Understanding Service response output (in JSON format). Available via [[IntentRecognitionResult]]
     * @member PropertyId.LanguageUnderstandingServiceResponse_JsonResult
     */ PropertyId[PropertyId["LanguageUnderstandingServiceResponse_JsonResult"] = 28] = "LanguageUnderstandingServiceResponse_JsonResult";
    /**
     * The URL string built from speech configuration.
     * This property is intended to be read-only. The SDK is using it internally.
     * NOTE: Added in version 1.7.0.
     */ PropertyId[PropertyId["SpeechServiceConnection_Url"] = 29] = "SpeechServiceConnection_Url";
    /**
     * The initial silence timeout value (in milliseconds) used by the service.
     * Added in version 1.7.0
     */ PropertyId[PropertyId["SpeechServiceConnection_InitialSilenceTimeoutMs"] = 30] = "SpeechServiceConnection_InitialSilenceTimeoutMs";
    /**
     * The end silence timeout value (in milliseconds) used by the service.
     * Added in version 1.7.0
     */ PropertyId[PropertyId["SpeechServiceConnection_EndSilenceTimeoutMs"] = 31] = "SpeechServiceConnection_EndSilenceTimeoutMs";
    /**
     * A duration of detected silence, measured in milliseconds, after which speech-to-text will determine a spoken
     * phrase has ended and generate a final Recognized result. Configuring this timeout may be helpful in situations
     * where spoken input is significantly faster or slower than usual and default segmentation behavior consistently
     * yields results that are too long or too short. Segmentation timeout values that are inappropriately high or low
     * can negatively affect speech-to-text accuracy; this property should be carefully configured and the resulting
     * behavior should be thoroughly validated as intended.
     *
     * For more information about timeout configuration that includes discussion of default behaviors, please visit
     * https://aka.ms/csspeech/timeouts.
     *
     * Added in version 1.21.0.
     */ PropertyId[PropertyId["Speech_SegmentationSilenceTimeoutMs"] = 32] = "Speech_SegmentationSilenceTimeoutMs";
    /**
     * A boolean value specifying whether audio logging is enabled in the service or not.
     * Audio and content logs are stored either in Microsoft-owned storage, or in your own storage account linked
     * to your Cognitive Services subscription (Bring Your Own Storage (BYOS) enabled Speech resource).
     * The logs will be removed after 30 days.
     * Added in version 1.7.0
     */ PropertyId[PropertyId["SpeechServiceConnection_EnableAudioLogging"] = 33] = "SpeechServiceConnection_EnableAudioLogging";
    /**
     * The speech service connection language identifier mode.
     * Can be "AtStart" (the default), or "Continuous". See Language
     * Identification document https://aka.ms/speech/lid?pivots=programming-language-javascript
     * for more details.
     * Added in 1.25.0
     **/ PropertyId[PropertyId["SpeechServiceConnection_LanguageIdMode"] = 34] = "SpeechServiceConnection_LanguageIdMode";
    /**
     * A string value representing the desired endpoint version to target for Speech Recognition.
     * Added in version 1.21.0
     */ PropertyId[PropertyId["SpeechServiceConnection_RecognitionEndpointVersion"] = 35] = "SpeechServiceConnection_RecognitionEndpointVersion";
    /**
    /**
     * A string value the current speaker recognition scenario/mode (TextIndependentIdentification, etc.).
     * Added in version 1.23.0
     */ PropertyId[PropertyId["SpeechServiceConnection_SpeakerIdMode"] = 36] = "SpeechServiceConnection_SpeakerIdMode";
    /**
     * The requested Cognitive Services Speech Service response output profanity setting.
     * Allowed values are "masked", "removed", and "raw".
     * Added in version 1.7.0.
     */ PropertyId[PropertyId["SpeechServiceResponse_ProfanityOption"] = 37] = "SpeechServiceResponse_ProfanityOption";
    /**
     * A string value specifying which post processing option should be used by service.
     * Allowed values are "TrueText".
     * Added in version 1.7.0
     */ PropertyId[PropertyId["SpeechServiceResponse_PostProcessingOption"] = 38] = "SpeechServiceResponse_PostProcessingOption";
    /**
     * A boolean value specifying whether to include word-level timestamps in the response result.
     * Added in version 1.7.0
     */ PropertyId[PropertyId["SpeechServiceResponse_RequestWordLevelTimestamps"] = 39] = "SpeechServiceResponse_RequestWordLevelTimestamps";
    /**
     * The number of times a word has to be in partial results to be returned.
     * Added in version 1.7.0
     */ PropertyId[PropertyId["SpeechServiceResponse_StablePartialResultThreshold"] = 40] = "SpeechServiceResponse_StablePartialResultThreshold";
    /**
     * A string value specifying the output format option in the response result. Internal use only.
     * Added in version 1.7.0.
     */ PropertyId[PropertyId["SpeechServiceResponse_OutputFormatOption"] = 41] = "SpeechServiceResponse_OutputFormatOption";
    /**
     * A boolean value to request for stabilizing translation partial results by omitting words in the end.
     * Added in version 1.7.0.
     */ PropertyId[PropertyId["SpeechServiceResponse_TranslationRequestStablePartialResult"] = 42] = "SpeechServiceResponse_TranslationRequestStablePartialResult";
    /**
     * A boolean value specifying whether to request WordBoundary events.
     * @member PropertyId.SpeechServiceResponse_RequestWordBoundary
     * Added in version 1.21.0.
     */ PropertyId[PropertyId["SpeechServiceResponse_RequestWordBoundary"] = 43] = "SpeechServiceResponse_RequestWordBoundary";
    /**
     * A boolean value specifying whether to request punctuation boundary in WordBoundary Events. Default is true.
     * @member PropertyId.SpeechServiceResponse_RequestPunctuationBoundary
     * Added in version 1.21.0.
     */ PropertyId[PropertyId["SpeechServiceResponse_RequestPunctuationBoundary"] = 44] = "SpeechServiceResponse_RequestPunctuationBoundary";
    /**
     * A boolean value specifying whether to request sentence boundary in WordBoundary Events. Default is false.
     * @member PropertyId.SpeechServiceResponse_RequestSentenceBoundary
     * Added in version 1.21.0.
     */ PropertyId[PropertyId["SpeechServiceResponse_RequestSentenceBoundary"] = 45] = "SpeechServiceResponse_RequestSentenceBoundary";
    /**
     * Identifier used to connect to the backend service.
     * @member PropertyId.Conversation_ApplicationId
     */ PropertyId[PropertyId["Conversation_ApplicationId"] = 46] = "Conversation_ApplicationId";
    /**
     * Type of dialog backend to connect to.
     * @member PropertyId.Conversation_DialogType
     */ PropertyId[PropertyId["Conversation_DialogType"] = 47] = "Conversation_DialogType";
    /**
     * Silence timeout for listening
     * @member PropertyId.Conversation_Initial_Silence_Timeout
     */ PropertyId[PropertyId["Conversation_Initial_Silence_Timeout"] = 48] = "Conversation_Initial_Silence_Timeout";
    /**
     * From Id to add to speech recognition activities.
     * @member PropertyId.Conversation_From_Id
     */ PropertyId[PropertyId["Conversation_From_Id"] = 49] = "Conversation_From_Id";
    /**
     * ConversationId for the session.
     * @member PropertyId.Conversation_Conversation_Id
     */ PropertyId[PropertyId["Conversation_Conversation_Id"] = 50] = "Conversation_Conversation_Id";
    /**
     * Comma separated list of custom voice deployment ids.
     * @member PropertyId.Conversation_Custom_Voice_Deployment_Ids
     */ PropertyId[PropertyId["Conversation_Custom_Voice_Deployment_Ids"] = 51] = "Conversation_Custom_Voice_Deployment_Ids";
    /**
     * Speech activity template, stamp properties from the template on the activity generated by the service for speech.
     * @member PropertyId.Conversation_Speech_Activity_Template
     * Added in version 1.10.0.
     */ PropertyId[PropertyId["Conversation_Speech_Activity_Template"] = 52] = "Conversation_Speech_Activity_Template";
    /**
     * Enables or disables the receipt of turn status messages as obtained on the turnStatusReceived event.
     * @member PropertyId.Conversation_Request_Bot_Status_Messages
     * Added in version 1.15.0.
     */ PropertyId[PropertyId["Conversation_Request_Bot_Status_Messages"] = 53] = "Conversation_Request_Bot_Status_Messages";
    /**
     * Specifies the connection ID to be provided in the Agent configuration message, e.g. a Direct Line token for
     * channel authentication.
     * Added in version 1.15.1.
     */ PropertyId[PropertyId["Conversation_Agent_Connection_Id"] = 54] = "Conversation_Agent_Connection_Id";
    /**
     * The Cognitive Services Speech Service host (url). Under normal circumstances, you shouldn't have to use this property directly.
     * Instead, use [[SpeechConfig.fromHost]].
     */ PropertyId[PropertyId["SpeechServiceConnection_Host"] = 55] = "SpeechServiceConnection_Host";
    /**
     * Set the host for service calls to the Conversation Translator REST management and websocket calls.
     */ PropertyId[PropertyId["ConversationTranslator_Host"] = 56] = "ConversationTranslator_Host";
    /**
     * Optionally set the the host's display name.
     * Used when joining a conversation.
     */ PropertyId[PropertyId["ConversationTranslator_Name"] = 57] = "ConversationTranslator_Name";
    /**
     * Optionally set a value for the X-CorrelationId request header.
     * Used for troubleshooting errors in the server logs. It should be a valid guid.
     */ PropertyId[PropertyId["ConversationTranslator_CorrelationId"] = 58] = "ConversationTranslator_CorrelationId";
    /**
     * Set the conversation token to be sent to the speech service. This enables the
     * service to service call from the speech service to the Conversation Translator service for relaying
     * recognitions. For internal use.
     */ PropertyId[PropertyId["ConversationTranslator_Token"] = 59] = "ConversationTranslator_Token";
    /**
     * The reference text of the audio for pronunciation evaluation.
     * For this and the following pronunciation assessment parameters, see
     * https://docs.microsoft.com/azure/cognitive-services/speech-service/rest-speech-to-text#pronunciation-assessment-parameters for details.
     * Under normal circumstances, you shouldn't have to use this property directly.
     * Added in version 1.15.0
     */ PropertyId[PropertyId["PronunciationAssessment_ReferenceText"] = 60] = "PronunciationAssessment_ReferenceText";
    /**
     * The point system for pronunciation score calibration (FivePoint or HundredMark).
     * Under normal circumstances, you shouldn't have to use this property directly.
     * Added in version 1.15.0
     */ PropertyId[PropertyId["PronunciationAssessment_GradingSystem"] = 61] = "PronunciationAssessment_GradingSystem";
    /**
     * The pronunciation evaluation granularity (Phoneme, Word, or FullText).
     * Under normal circumstances, you shouldn't have to use this property directly.
     * Added in version 1.15.0
     */ PropertyId[PropertyId["PronunciationAssessment_Granularity"] = 62] = "PronunciationAssessment_Granularity";
    /**
     * Defines if enable miscue calculation.
     * With this enabled, the pronounced words will be compared to the reference text,
     * and will be marked with omission/insertion based on the comparison. The default setting is False.
     * Under normal circumstances, you shouldn't have to use this property directly.
     * Added in version 1.15.0
     */ PropertyId[PropertyId["PronunciationAssessment_EnableMiscue"] = 63] = "PronunciationAssessment_EnableMiscue";
    /**
     * The json string of pronunciation assessment parameters
     * Under normal circumstances, you shouldn't have to use this property directly.
     * Added in version 1.15.0
     */ PropertyId[PropertyId["PronunciationAssessment_Json"] = 64] = "PronunciationAssessment_Json";
    /**
     * Pronunciation assessment parameters.
     * This property is intended to be read-only. The SDK is using it internally.
     * Added in version 1.15.0
     */ PropertyId[PropertyId["PronunciationAssessment_Params"] = 65] = "PronunciationAssessment_Params";
    /**
     * Version of Speaker Recognition API to use.
     * Added in version 1.18.0
     */ PropertyId[PropertyId["SpeakerRecognition_Api_Version"] = 66] = "SpeakerRecognition_Api_Version";
})($83bc4874065a0f92$export$f7caa2a6f083d81 || ($83bc4874065a0f92$export$f7caa2a6f083d81 = {}));

});

parcelRequire.register("eylh7", function(module, exports) {

$parcel$export(module.exports, "RecognitionEventArgs", () => $a984be6ec86845a4$export$12431311bd74173);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.

var $daYNc = parcelRequire("daYNc");
class $a984be6ec86845a4$export$12431311bd74173 extends (0, $daYNc.SessionEventArgs) {
    /**
     * Creates and initializes an instance of this class.
     * @constructor
     * @param {number} offset - The offset.
     * @param {string} sessionId - The session id.
     */ constructor(offset, sessionId){
        super(sessionId);
        this.privOffset = offset;
    }
    /**
     * Represents the message offset
     * @member RecognitionEventArgs.prototype.offset
     * @function
     * @public
     */ get offset() {
        return this.privOffset;
    }
}

});
parcelRequire.register("daYNc", function(module, exports) {

$parcel$export(module.exports, "SessionEventArgs", () => $997b5daaecc4cc5b$export$ddbc7bb13aa93fd9);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
/**
 * Defines content for session events like SessionStarted/Stopped, SoundStarted/Stopped.
 * @class SessionEventArgs
 */ class $997b5daaecc4cc5b$export$ddbc7bb13aa93fd9 {
    /**
     * Creates and initializes an instance of this class.
     * @constructor
     * @param {string} sessionId - The session id.
     */ constructor(sessionId){
        this.privSessionId = sessionId;
    }
    /**
     * Represents the session identifier.
     * @member SessionEventArgs.prototype.sessionId
     * @function
     * @public
     * @returns {string} Represents the session identifier.
     */ get sessionId() {
        return this.privSessionId;
    }
}

});


parcelRequire.register("l4rU0", function(module, exports) {

$parcel$export(module.exports, "SpeechConnectionMessage", () => $f56f9d7edaaab091$export$d7d1294d295e5b2a);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
parcelRequire("cR8AB");
var $83Xvm = parcelRequire("83Xvm");
var $jQZQm = parcelRequire("jQZQm");

var $dazVK = parcelRequire("dazVK");
class $f56f9d7edaaab091$export$d7d1294d295e5b2a extends (0, $jQZQm.ConnectionMessage) {
    constructor(messageType, path, requestId, contentType, body, streamId, additionalHeaders, id){
        if (!path) throw new (0, $83Xvm.ArgumentNullError)("path");
        if (!requestId) throw new (0, $83Xvm.ArgumentNullError)("requestId");
        const headers = {};
        headers[(0, $dazVK.HeaderNames).Path] = path;
        headers[(0, $dazVK.HeaderNames).RequestId] = requestId;
        headers[(0, $dazVK.HeaderNames).RequestTimestamp] = new Date().toISOString();
        if (contentType) headers[(0, $dazVK.HeaderNames).ContentType] = contentType;
        if (streamId) headers[(0, $dazVK.HeaderNames).RequestStreamId] = streamId;
        if (additionalHeaders) {
            for(const headerName in additionalHeaders)if (headerName) headers[headerName] = additionalHeaders[headerName];
        }
        if (id) super(messageType, body, headers, id);
        else super(messageType, body, headers);
        this.privPath = path;
        this.privRequestId = requestId;
        this.privContentType = contentType;
        this.privStreamId = streamId;
        this.privAdditionalHeaders = additionalHeaders;
    }
    get path() {
        return this.privPath;
    }
    get requestId() {
        return this.privRequestId;
    }
    get contentType() {
        return this.privContentType;
    }
    get streamId() {
        return this.privStreamId;
    }
    get additionalHeaders() {
        return this.privAdditionalHeaders;
    }
    static fromConnectionMessage(message) {
        let path = null;
        let requestId = null;
        let contentType = null;
        // let requestTimestamp = null;
        let streamId = null;
        const additionalHeaders = {};
        if (message.headers) {
            for(const headerName in message.headers)if (headerName) {
                if (headerName.toLowerCase() === (0, $dazVK.HeaderNames).Path.toLowerCase()) path = message.headers[headerName];
                else if (headerName.toLowerCase() === (0, $dazVK.HeaderNames).RequestId.toLowerCase()) requestId = message.headers[headerName];
                else if (headerName.toLowerCase() === (0, $dazVK.HeaderNames).ContentType.toLowerCase()) contentType = message.headers[headerName];
                else if (headerName.toLowerCase() === (0, $dazVK.HeaderNames).RequestStreamId.toLowerCase()) streamId = message.headers[headerName];
                else additionalHeaders[headerName] = message.headers[headerName];
            }
        }
        return new $f56f9d7edaaab091$export$d7d1294d295e5b2a(message.messageType, path, requestId, contentType, message.body, streamId, additionalHeaders, message.id);
    }
}

});
parcelRequire.register("dazVK", function(module, exports) {

$parcel$export(module.exports, "HeaderNames", () => $9968148b10fd300e$export$28d77f87efed1d88);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
class $9968148b10fd300e$export$28d77f87efed1d88 {
}
$9968148b10fd300e$export$28d77f87efed1d88.AuthKey = "Ocp-Apim-Subscription-Key";
$9968148b10fd300e$export$28d77f87efed1d88.Authorization = "Authorization";
$9968148b10fd300e$export$28d77f87efed1d88.SpIDAuthKey = "Apim-Subscription-Id";
$9968148b10fd300e$export$28d77f87efed1d88.ConnectionId = "X-ConnectionId";
$9968148b10fd300e$export$28d77f87efed1d88.ContentType = "Content-Type";
$9968148b10fd300e$export$28d77f87efed1d88.CustomCommandsAppId = "X-CommandsAppId";
$9968148b10fd300e$export$28d77f87efed1d88.Path = "Path";
$9968148b10fd300e$export$28d77f87efed1d88.RequestId = "X-RequestId";
$9968148b10fd300e$export$28d77f87efed1d88.RequestStreamId = "X-StreamId";
$9968148b10fd300e$export$28d77f87efed1d88.RequestTimestamp = "X-Timestamp";

});



parcelRequire.register("3kAgv", function(module, exports) {

$parcel$export(module.exports, "ConversationServiceRecognizer", () => $26cf5ee055b22627$export$2279f5957a34159d);

var $7cfhB = parcelRequire("7cfhB");
var $3fCi1 = parcelRequire("3fCi1");
var $bjdWp = parcelRequire("bjdWp");
var $9Wq4L = parcelRequire("9Wq4L");
var $fmH2B = parcelRequire("fmH2B");
parcelRequire("jSpbe");
var $ea7Fz = parcelRequire("ea7Fz");
var $iBWCB = parcelRequire("iBWCB");
var $c7Irs = parcelRequire("c7Irs");
var $jSpbe = parcelRequire("jSpbe");
var $bO7IR = parcelRequire("bO7IR");
var $i1ulX = parcelRequire("i1ulX");
var $je076 = parcelRequire("je076");
var $26cf5ee055b22627$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
class $26cf5ee055b22627$export$2279f5957a34159d extends (0, $je076.ServiceRecognizerBase) {
    constructor(authentication, connectionFactory, audioSource, recognizerConfig, recognizer){
        super(authentication, connectionFactory, audioSource, recognizerConfig, recognizer);
        this.handleSpeechPhraseMessage = (textBody)=>$26cf5ee055b22627$var$__awaiter(this, void 0, void 0, function*() {
                return this.handleSpeechPhrase(textBody);
            });
        this.handleSpeechHypothesisMessage = (textBody)=>this.handleSpeechHypothesis(textBody);
    }
    processTypeSpecificMessages(connectionMessage) {
        return;
    }
    handleRecognizedCallback(result, offset, sessionId) {
        return;
    }
    handleRecognizingCallback(result, duration, sessionId) {
        return;
    }
    processSpeechMessages(connectionMessage) {
        return $26cf5ee055b22627$var$__awaiter(this, void 0, void 0, function*() {
            let processed = false;
            switch(connectionMessage.path.toLowerCase()){
                case "speech.hypothesis":
                case "speech.fragment":
                    if (!!this.handleSpeechHypothesisMessage) this.handleSpeechHypothesisMessage(connectionMessage.textBody);
                    processed = true;
                    break;
                case "speech.phrase":
                    if (!!this.handleSpeechPhraseMessage) yield this.handleSpeechPhraseMessage(connectionMessage.textBody);
                    processed = true;
                    break;
                default:
                    break;
            }
            return processed;
        });
    }
    cancelRecognition(sessionId, requestId, cancellationReason, errorCode, error) {}
    handleSpeechPhrase(textBody) {
        return $26cf5ee055b22627$var$__awaiter(this, void 0, void 0, function*() {
            const simple = (0, $ea7Fz.SimpleSpeechPhrase).fromJSON(textBody);
            const resultReason = (0, $iBWCB.EnumTranslation).implTranslateRecognitionResult(simple.RecognitionStatus);
            let result;
            const resultProps = new (0, $3fCi1.PropertyCollection)();
            resultProps.setProperty((0, $bjdWp.PropertyId).SpeechServiceResponse_JsonResult, textBody);
            const simpleOffset = simple.Offset + this.privRequestSession.currentTurnAudioOffset;
            let offset = simpleOffset;
            this.privRequestSession.onPhraseRecognized(this.privRequestSession.currentTurnAudioOffset + simple.Offset + simple.Duration);
            if ((0, $9Wq4L.ResultReason).Canceled === resultReason) {
                const cancelReason = (0, $iBWCB.EnumTranslation).implTranslateCancelResult(simple.RecognitionStatus);
                const cancellationErrorCode = (0, $iBWCB.EnumTranslation).implTranslateCancelErrorCode(simple.RecognitionStatus);
                yield this.cancelRecognitionLocal(cancelReason, cancellationErrorCode, (0, $iBWCB.EnumTranslation).implTranslateErrorDetails(cancellationErrorCode));
            } else if (!(this.privRequestSession.isSpeechEnded && resultReason === (0, $9Wq4L.ResultReason).NoMatch && simple.RecognitionStatus !== (0, $c7Irs.RecognitionStatus).InitialSilenceTimeout)) {
                if (this.privRecognizerConfig.parameters.getProperty((0, $jSpbe.OutputFormatPropertyName)) === (0, $7cfhB.OutputFormat)[(0, $7cfhB.OutputFormat).Simple]) result = new (0, $fmH2B.SpeechRecognitionResult)(this.privRequestSession.requestId, resultReason, simple.DisplayText, simple.Duration, simpleOffset, simple.Language, simple.LanguageDetectionConfidence, simple.SpeakerId, undefined, textBody, resultProps);
                else {
                    const detailed = (0, $bO7IR.DetailedSpeechPhrase).fromJSON(textBody);
                    const totalOffset = detailed.Offset + this.privRequestSession.currentTurnAudioOffset;
                    const offsetCorrectedJson = detailed.getJsonWithCorrectedOffsets(totalOffset);
                    result = new (0, $fmH2B.SpeechRecognitionResult)(this.privRequestSession.requestId, resultReason, detailed.Text, detailed.Duration, totalOffset, detailed.Language, detailed.LanguageDetectionConfidence, detailed.SpeakerId, undefined, offsetCorrectedJson, resultProps);
                    offset = result.offset;
                }
                this.handleRecognizedCallback(result, offset, this.privRequestSession.sessionId);
            }
        });
    }
    handleSpeechHypothesis(textBody) {
        const hypothesis = (0, $i1ulX.SpeechHypothesis).fromJSON(textBody);
        const offset = hypothesis.Offset + this.privRequestSession.currentTurnAudioOffset;
        const resultProps = new (0, $3fCi1.PropertyCollection)();
        resultProps.setProperty((0, $bjdWp.PropertyId).SpeechServiceResponse_JsonResult, textBody);
        const result = new (0, $fmH2B.SpeechRecognitionResult)(this.privRequestSession.requestId, (0, $9Wq4L.ResultReason).RecognizingSpeech, hypothesis.Text, hypothesis.Duration, offset, hypothesis.Language, hypothesis.LanguageDetectionConfidence, hypothesis.SpeakerId, undefined, textBody, resultProps);
        this.privRequestSession.onHypothesis(offset);
        this.handleRecognizingCallback(result, hypothesis.Duration, this.privRequestSession.sessionId);
    }
}

});
parcelRequire.register("7cfhB", function(module, exports) {

$parcel$export(module.exports, "OutputFormat", () => $53d58247ae61e930$export$ed6df354c75a09e0);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
/**
 * Define Speech Recognizer output formats.
 * @class OutputFormat
 */ var $53d58247ae61e930$export$ed6df354c75a09e0;
(function(OutputFormat) {
    /**
     * @member OutputFormat.Simple
     */ OutputFormat[OutputFormat["Simple"] = 0] = "Simple";
    /**
     * @member OutputFormat.Detailed
     */ OutputFormat[OutputFormat["Detailed"] = 1] = "Detailed";
})($53d58247ae61e930$export$ed6df354c75a09e0 || ($53d58247ae61e930$export$ed6df354c75a09e0 = {}));

});

parcelRequire.register("3fCi1", function(module, exports) {

$parcel$export(module.exports, "PropertyCollection", () => $25e0795234ee7262$export$a9938bacf0fbb927);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.

var $bjdWp = parcelRequire("bjdWp");
class $25e0795234ee7262$export$a9938bacf0fbb927 {
    constructor(){
        this.privKeys = [];
        this.privValues = [];
    }
    /**
     * Returns the property value in type String.
     * Currently only String, int and bool are allowed.
     * If the name is not available, the specified defaultValue is returned.
     * @member PropertyCollection.prototype.getProperty
     * @function
     * @public
     * @param {string} key - The parameter name.
     * @param {string | number | boolean} def - The default value which is returned if the parameter
     * is not available in the collection.
     * @returns {string} value of the parameter.
     */ getProperty(key, def) {
        let keyToUse;
        if (typeof key === "string") keyToUse = key;
        else keyToUse = (0, $bjdWp.PropertyId)[key];
        for(let n = 0; n < this.privKeys.length; n++){
            if (this.privKeys[n] === keyToUse) return this.privValues[n];
        }
        if (def === undefined) return undefined;
        return String(def);
    }
    /**
     * Sets the String value of the parameter specified by name.
     * @member PropertyCollection.prototype.setProperty
     * @function
     * @public
     * @param {string} key - The parameter name.
     * @param {string} value - The value of the parameter.
     */ setProperty(key, value) {
        let keyToUse;
        if (typeof key === "string") keyToUse = key;
        else keyToUse = (0, $bjdWp.PropertyId)[key];
        for(let n = 0; n < this.privKeys.length; n++)if (this.privKeys[n] === keyToUse) {
            this.privValues[n] = value;
            return;
        }
        this.privKeys.push(keyToUse);
        this.privValues.push(value);
    }
    /**
     * Clones the collection.
     * @member PropertyCollection.prototype.clone
     * @function
     * @public
     * @returns {PropertyCollection} A copy of the collection.
     */ clone() {
        const clonedMap = new $25e0795234ee7262$export$a9938bacf0fbb927();
        for(let n = 0; n < this.privKeys.length; n++){
            clonedMap.privKeys.push(this.privKeys[n]);
            clonedMap.privValues.push(this.privValues[n]);
        }
        return clonedMap;
    }
    /**
     * Merges this set of properties into another, no overwrites.
     * @member PropertyCollection.prototype.mergeTo
     * @function
     * @public
     * @param {PropertyCollection}  destinationCollection - The collection to merge into.
     */ mergeTo(destinationCollection) {
        this.privKeys.forEach((key)=>{
            if (destinationCollection.getProperty(key, undefined) === undefined) {
                const value = this.getProperty(key);
                destinationCollection.setProperty(key, value);
            }
        });
    }
    /**
     * Get the keys in Property Collection.
     * @member PropertyCollection.prototype.keys
     * @function
     * @public
     * @returns {string []} Keys in the collection.
     */ get keys() {
        return this.privKeys;
    }
}

});

parcelRequire.register("9Wq4L", function(module, exports) {

$parcel$export(module.exports, "ResultReason", () => $73cdc1ef34958697$export$3527eaa7db1a45df);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
/**
 * Defines the possible reasons a recognition result might be generated.
 * @class ResultReason
 */ var $73cdc1ef34958697$export$3527eaa7db1a45df;
(function(ResultReason) {
    /**
     * Indicates speech could not be recognized. More details
     * can be found in the NoMatchDetails object.
     * @member ResultReason.NoMatch
     */ ResultReason[ResultReason["NoMatch"] = 0] = "NoMatch";
    /**
     * Indicates that the recognition was canceled. More details
     * can be found using the CancellationDetails object.
     * @member ResultReason.Canceled
     */ ResultReason[ResultReason["Canceled"] = 1] = "Canceled";
    /**
     * Indicates the speech result contains hypothesis text.
     * @member ResultReason.RecognizedSpeech
     */ ResultReason[ResultReason["RecognizingSpeech"] = 2] = "RecognizingSpeech";
    /**
     * Indicates the speech result contains final text that has been recognized.
     * Speech Recognition is now complete for this phrase.
     * @member ResultReason.RecognizedSpeech
     */ ResultReason[ResultReason["RecognizedSpeech"] = 3] = "RecognizedSpeech";
    /**
     * Indicates the speech result contains a finalized acceptance of a provided keyword.
     * Speech recognition will continue unless otherwise configured.
     * @member ResultReason.RecognizedKeyword
     */ ResultReason[ResultReason["RecognizedKeyword"] = 4] = "RecognizedKeyword";
    /**
     * Indicates the intent result contains hypothesis text and intent.
     * @member ResultReason.RecognizingIntent
     */ ResultReason[ResultReason["RecognizingIntent"] = 5] = "RecognizingIntent";
    /**
     * Indicates the intent result contains final text and intent.
     * Speech Recognition and Intent determination are now complete for this phrase.
     * @member ResultReason.RecognizedIntent
     */ ResultReason[ResultReason["RecognizedIntent"] = 6] = "RecognizedIntent";
    /**
     * Indicates the translation result contains hypothesis text and its translation(s).
     * @member ResultReason.TranslatingSpeech
     */ ResultReason[ResultReason["TranslatingSpeech"] = 7] = "TranslatingSpeech";
    /**
     * Indicates the translation result contains final text and corresponding translation(s).
     * Speech Recognition and Translation are now complete for this phrase.
     * @member ResultReason.TranslatedSpeech
     */ ResultReason[ResultReason["TranslatedSpeech"] = 8] = "TranslatedSpeech";
    /**
     * Indicates the synthesized audio result contains a non-zero amount of audio data
     * @member ResultReason.SynthesizingAudio
     */ ResultReason[ResultReason["SynthesizingAudio"] = 9] = "SynthesizingAudio";
    /**
     * Indicates the synthesized audio is now complete for this phrase.
     * @member ResultReason.SynthesizingAudioCompleted
     */ ResultReason[ResultReason["SynthesizingAudioCompleted"] = 10] = "SynthesizingAudioCompleted";
    /**
     * Indicates the speech synthesis is now started
     * @member ResultReason.SynthesizingAudioStarted
     */ ResultReason[ResultReason["SynthesizingAudioStarted"] = 11] = "SynthesizingAudioStarted";
    /**
     * Indicates the voice profile is being enrolled and customers need to send more audio to create a voice profile.
     * @member ResultReason.EnrollingVoiceProfile
     */ ResultReason[ResultReason["EnrollingVoiceProfile"] = 12] = "EnrollingVoiceProfile";
    /**
     * Indicates the voice profile has been enrolled.
     * @member ResultReason.EnrolledVoiceProfile
     */ ResultReason[ResultReason["EnrolledVoiceProfile"] = 13] = "EnrolledVoiceProfile";
    /**
     * Indicates successful identification of some speakers.
     * @member ResultReason.RecognizedSpeakers
     */ ResultReason[ResultReason["RecognizedSpeakers"] = 14] = "RecognizedSpeakers";
    /**
     * Indicates successfully verified one speaker.
     * @member ResultReason.RecognizedSpeaker
     */ ResultReason[ResultReason["RecognizedSpeaker"] = 15] = "RecognizedSpeaker";
    /**
     * Indicates a voice profile has been reset successfully.
     * @member ResultReason.ResetVoiceProfile
     */ ResultReason[ResultReason["ResetVoiceProfile"] = 16] = "ResetVoiceProfile";
    /**
     * Indicates a voice profile has been deleted successfully.
     * @member ResultReason.DeletedVoiceProfile
     */ ResultReason[ResultReason["DeletedVoiceProfile"] = 17] = "DeletedVoiceProfile";
    /**
     * Indicates synthesis voices list has been successfully retrieved.
     * @member ResultReason.VoicesListRetrieved
     */ ResultReason[ResultReason["VoicesListRetrieved"] = 18] = "VoicesListRetrieved";
})($73cdc1ef34958697$export$3527eaa7db1a45df || ($73cdc1ef34958697$export$3527eaa7db1a45df = {}));

});

parcelRequire.register("fmH2B", function(module, exports) {

$parcel$export(module.exports, "SpeechRecognitionResult", () => $b2fa4c21dbabbda8$export$e41fbbd40b4d7802);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.

var $gp5uS = parcelRequire("gp5uS");
class $b2fa4c21dbabbda8$export$e41fbbd40b4d7802 extends (0, $gp5uS.RecognitionResult) {
    /**
     * Creates and initializes an instance of this class.
     * @constructor
     * @public
     * @param {string} resultId - The result id.
     * @param {ResultReason} reason - The reason.
     * @param {string} text - The recognized text.
     * @param {number} duration - The duration.
     * @param {number} offset - The offset into the stream.
     * @param {string} language - Primary Language detected, if provided.
     * @param {string} languageDetectionConfidence - Primary Language confidence ("Unknown," "Low," "Medium," "High"...), if provided.
     * @param {string} speakerId - speaker id for conversation transcription, if provided.
     * @param {string} errorDetails - Error details, if provided.
     * @param {string} json - Additional Json, if provided.
     * @param {PropertyCollection} properties - Additional properties, if provided.
     */ constructor(resultId, reason, text, duration, offset, language, languageDetectionConfidence, speakerId, errorDetails, json, properties){
        super(resultId, reason, text, duration, offset, language, languageDetectionConfidence, errorDetails, json, properties);
        this.privSpeakerId = speakerId;
    }
    /**
     * speaker id from conversation transcription/id scenarios
     * @member SpeechRecognitionResult.prototype.speakerId
     * @function
     * @public
     * @returns {string} id of speaker in given result
     */ get speakerId() {
        return this.privSpeakerId;
    }
}

});
parcelRequire.register("gp5uS", function(module, exports) {

$parcel$export(module.exports, "RecognitionResult", () => $bf133ec177b89272$export$fbb9fad6e09cd236);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
/**
 * Defines result of speech recognition.
 * @class RecognitionResult
 */ class $bf133ec177b89272$export$fbb9fad6e09cd236 {
    /**
     * Creates and initializes an instance of this class.
     * @constructor
     * @param {string} resultId - The result id.
     * @param {ResultReason} reason - The reason.
     * @param {string} text - The recognized text.
     * @param {number} duration - The duration.
     * @param {number} offset - The offset into the stream.
     * @param {string} language - Primary Language detected, if provided.
     * @param {string} languageDetectionConfidence - Primary Language confidence ("Unknown," "Low," "Medium," "High"...), if provided.
     * @param {string} errorDetails - Error details, if provided.
     * @param {string} json - Additional Json, if provided.
     * @param {PropertyCollection} properties - Additional properties, if provided.
     */ constructor(resultId, reason, text, duration, offset, language, languageDetectionConfidence, errorDetails, json, properties){
        this.privResultId = resultId;
        this.privReason = reason;
        this.privText = text;
        this.privDuration = duration;
        this.privOffset = offset;
        this.privLanguage = language;
        this.privLanguageDetectionConfidence = languageDetectionConfidence;
        this.privErrorDetails = errorDetails;
        this.privJson = json;
        this.privProperties = properties;
    }
    /**
     * Specifies the result identifier.
     * @member RecognitionResult.prototype.resultId
     * @function
     * @public
     * @returns {string} Specifies the result identifier.
     */ get resultId() {
        return this.privResultId;
    }
    /**
     * Specifies status of the result.
     * @member RecognitionResult.prototype.reason
     * @function
     * @public
     * @returns {ResultReason} Specifies status of the result.
     */ get reason() {
        return this.privReason;
    }
    /**
     * Presents the recognized text in the result.
     * @member RecognitionResult.prototype.text
     * @function
     * @public
     * @returns {string} Presents the recognized text in the result.
     */ get text() {
        return this.privText;
    }
    /**
     * Duration of recognized speech in 100 nano second increments.
     * @member RecognitionResult.prototype.duration
     * @function
     * @public
     * @returns {number} Duration of recognized speech in 100 nano second increments.
     */ get duration() {
        return this.privDuration;
    }
    /**
     * Offset of recognized speech in 100 nano second increments.
     * @member RecognitionResult.prototype.offset
     * @function
     * @public
     * @returns {number} Offset of recognized speech in 100 nano second increments.
     */ get offset() {
        return this.privOffset;
    }
    /**
     * Primary Language detected.
     * @member RecognitionResult.prototype.language
     * @function
     * @public
     * @returns {string} language detected.
     */ get language() {
        return this.privLanguage;
    }
    /**
     * Primary Language detection confidence (Unknown, Low, Medium, High).
     * @member RecognitionResult.prototype.languageDetectionConfidence
     * @function
     * @public
     * @returns {string} detection confidence strength.
     */ get languageDetectionConfidence() {
        return this.privLanguageDetectionConfidence;
    }
    /**
     * In case of an unsuccessful recognition, provides details of the occurred error.
     * @member RecognitionResult.prototype.errorDetails
     * @function
     * @public
     * @returns {string} a brief description of an error.
     */ get errorDetails() {
        return this.privErrorDetails;
    }
    /**
     * A string containing Json serialized recognition result as it was received from the service.
     * @member RecognitionResult.prototype.json
     * @function
     * @private
     * @returns {string} Json serialized representation of the result.
     */ get json() {
        return this.privJson;
    }
    /**
     * The set of properties exposed in the result.
     * @member RecognitionResult.prototype.properties
     * @function
     * @public
     * @returns {PropertyCollection} The set of properties exposed in the result.
     */ get properties() {
        return this.privProperties;
    }
}

});



parcelRequire.register("cOea6", function(module, exports) {

$parcel$export(module.exports, "RecognitionMode", () => $953523d6e1e822e6$export$79403a05110b2cfc);
$parcel$export(module.exports, "connectivity", () => $953523d6e1e822e6$export$bc2c1e1c80c298f2);
$parcel$export(module.exports, "type", () => $953523d6e1e822e6$export$bf9fb029d174d554);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
/* eslint-disable max-classes-per-file */ 
var $bjdWp = parcelRequire("bjdWp");
var $953523d6e1e822e6$export$79403a05110b2cfc;
(function(RecognitionMode) {
    RecognitionMode[RecognitionMode["Interactive"] = 0] = "Interactive";
    RecognitionMode[RecognitionMode["Conversation"] = 1] = "Conversation";
    RecognitionMode[RecognitionMode["Dictation"] = 2] = "Dictation";
})($953523d6e1e822e6$export$79403a05110b2cfc || ($953523d6e1e822e6$export$79403a05110b2cfc = {}));
var $953523d6e1e822e6$export$e92bebf6311e8221;
(function(SpeechResultFormat) {
    SpeechResultFormat[SpeechResultFormat["Simple"] = 0] = "Simple";
    SpeechResultFormat[SpeechResultFormat["Detailed"] = 1] = "Detailed";
})($953523d6e1e822e6$export$e92bebf6311e8221 || ($953523d6e1e822e6$export$e92bebf6311e8221 = {}));
class $953523d6e1e822e6$export$6036b6a06cf1bd7e {
    constructor(speechServiceConfig, parameters){
        this.privSpeechServiceConfig = speechServiceConfig ? speechServiceConfig : new $953523d6e1e822e6$export$51f52f0a07e48303(new $953523d6e1e822e6$export$841858b892ce1f4c(null));
        this.privParameters = parameters;
        this.privMaxRetryCount = parseInt(parameters.getProperty("SPEECH-Error-MaxRetryCount", "4"), 10);
        this.privLanguageIdMode = parameters.getProperty((0, $bjdWp.PropertyId).SpeechServiceConnection_LanguageIdMode, undefined);
    }
    get parameters() {
        return this.privParameters;
    }
    get recognitionMode() {
        return this.privRecognitionMode;
    }
    set recognitionMode(value) {
        this.privRecognitionMode = value;
        this.privRecognitionActivityTimeout = value === $953523d6e1e822e6$export$79403a05110b2cfc.Interactive ? 8000 : 25000;
        this.privSpeechServiceConfig.Recognition = $953523d6e1e822e6$export$79403a05110b2cfc[value];
    }
    get SpeechServiceConfig() {
        return this.privSpeechServiceConfig;
    }
    get recognitionActivityTimeout() {
        return this.privRecognitionActivityTimeout;
    }
    get isContinuousRecognition() {
        return this.privRecognitionMode !== $953523d6e1e822e6$export$79403a05110b2cfc.Interactive;
    }
    get languageIdMode() {
        return this.privLanguageIdMode;
    }
    get autoDetectSourceLanguages() {
        return this.parameters.getProperty((0, $bjdWp.PropertyId).SpeechServiceConnection_AutoDetectSourceLanguages, undefined);
    }
    get recognitionEndpointVersion() {
        return this.parameters.getProperty((0, $bjdWp.PropertyId).SpeechServiceConnection_RecognitionEndpointVersion, undefined);
    }
    get sourceLanguageModels() {
        const models = [];
        let modelsExist = false;
        if (this.autoDetectSourceLanguages !== undefined) for (const language of this.autoDetectSourceLanguages.split(",")){
            const customProperty = language + (0, $bjdWp.PropertyId).SpeechServiceConnection_EndpointId.toString();
            const modelId = this.parameters.getProperty(customProperty, undefined);
            if (modelId !== undefined) {
                models.push({
                    language: language,
                    endpoint: modelId
                });
                modelsExist = true;
            } else models.push({
                language: language,
                endpoint: ""
            });
        }
        return modelsExist ? models : undefined;
    }
    get maxRetryCount() {
        return this.privMaxRetryCount;
    }
}
class $953523d6e1e822e6$export$51f52f0a07e48303 {
    constructor(context){
        this.context = context;
    }
    serialize() {
        return JSON.stringify(this, (key, value)=>{
            if (value && typeof value === "object") {
                const replacement = {};
                for(const k in value)if (Object.hasOwnProperty.call(value, k)) // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
                replacement[k && k.charAt(0).toLowerCase() + k.substring(1)] = value[k];
                return replacement;
            }
            return value;
        });
    }
    get Context() {
        return this.context;
    }
    get Recognition() {
        return this.recognition;
    }
    set Recognition(value) {
        this.recognition = value.toLowerCase();
    }
}
class $953523d6e1e822e6$export$841858b892ce1f4c {
    constructor(os){
        this.system = new $953523d6e1e822e6$export$e1dae5660003ffa7();
        this.os = os;
    }
}
class $953523d6e1e822e6$export$e1dae5660003ffa7 {
    constructor(){
        // Note: below will be patched for official builds.
        const SPEECHSDK_CLIENTSDK_VERSION = "1.29.0";
        this.name = "SpeechSDK";
        this.version = SPEECHSDK_CLIENTSDK_VERSION;
        this.build = "JavaScript";
        this.lang = "JavaScript";
    }
}
class $953523d6e1e822e6$export$decc4a6e69bbf763 {
    constructor(platform, name, version){
        this.platform = platform;
        this.name = name;
        this.version = version;
    }
}
class $953523d6e1e822e6$export$8215d14a63d9fb10 {
    constructor(manufacturer, model, version){
        this.manufacturer = manufacturer;
        this.model = model;
        this.version = version;
    }
}
var $953523d6e1e822e6$export$bc2c1e1c80c298f2;
(function(connectivity) {
    connectivity["Bluetooth"] = "Bluetooth";
    connectivity["Wired"] = "Wired";
    connectivity["WiFi"] = "WiFi";
    connectivity["Cellular"] = "Cellular";
    connectivity["InBuilt"] = "InBuilt";
    connectivity["Unknown"] = "Unknown";
})($953523d6e1e822e6$export$bc2c1e1c80c298f2 || ($953523d6e1e822e6$export$bc2c1e1c80c298f2 = {}));
var $953523d6e1e822e6$export$bf9fb029d174d554;
(function(type) {
    type["Phone"] = "Phone";
    type["Speaker"] = "Speaker";
    type["Car"] = "Car";
    type["Headset"] = "Headset";
    type["Thermostat"] = "Thermostat";
    type["Microphones"] = "Microphones";
    type["Deskphone"] = "Deskphone";
    type["RemoteControl"] = "RemoteControl";
    type["Unknown"] = "Unknown";
    type["File"] = "File";
    type["Stream"] = "Stream";
})($953523d6e1e822e6$export$bf9fb029d174d554 || ($953523d6e1e822e6$export$bf9fb029d174d554 = {}));

});

parcelRequire.register("iBWCB", function(module, exports) {

$parcel$export(module.exports, "EnumTranslation", () => $d8c927be133e5ddb$export$f8492c3e19247e15);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.

var $lnpwm = parcelRequire("lnpwm");
var $5idXV = parcelRequire("5idXV");
var $9Wq4L = parcelRequire("9Wq4L");
parcelRequire("jSpbe");
var $c7Irs = parcelRequire("c7Irs");
class $d8c927be133e5ddb$export$f8492c3e19247e15 {
    static implTranslateRecognitionResult(recognitionStatus) {
        let reason = (0, $9Wq4L.ResultReason).Canceled;
        switch(recognitionStatus){
            case (0, $c7Irs.RecognitionStatus).Success:
                reason = (0, $9Wq4L.ResultReason).RecognizedSpeech;
                break;
            case (0, $c7Irs.RecognitionStatus).NoMatch:
            case (0, $c7Irs.RecognitionStatus).InitialSilenceTimeout:
            case (0, $c7Irs.RecognitionStatus).BabbleTimeout:
            case (0, $c7Irs.RecognitionStatus).EndOfDictation:
                reason = (0, $9Wq4L.ResultReason).NoMatch;
                break;
            case (0, $c7Irs.RecognitionStatus).Error:
            case (0, $c7Irs.RecognitionStatus).BadRequest:
            case (0, $c7Irs.RecognitionStatus).Forbidden:
            default:
                reason = (0, $9Wq4L.ResultReason).Canceled;
                break;
        }
        return reason;
    }
    static implTranslateCancelResult(recognitionStatus) {
        let reason = (0, $5idXV.CancellationReason).EndOfStream;
        switch(recognitionStatus){
            case (0, $c7Irs.RecognitionStatus).Success:
            case (0, $c7Irs.RecognitionStatus).EndOfDictation:
            case (0, $c7Irs.RecognitionStatus).NoMatch:
                reason = (0, $5idXV.CancellationReason).EndOfStream;
                break;
            case (0, $c7Irs.RecognitionStatus).InitialSilenceTimeout:
            case (0, $c7Irs.RecognitionStatus).BabbleTimeout:
            case (0, $c7Irs.RecognitionStatus).Error:
            case (0, $c7Irs.RecognitionStatus).BadRequest:
            case (0, $c7Irs.RecognitionStatus).Forbidden:
            default:
                reason = (0, $5idXV.CancellationReason).Error;
                break;
        }
        return reason;
    }
    static implTranslateCancelErrorCode(recognitionStatus) {
        let reason = (0, $lnpwm.CancellationErrorCode).NoError;
        switch(recognitionStatus){
            case (0, $c7Irs.RecognitionStatus).Error:
                reason = (0, $lnpwm.CancellationErrorCode).ServiceError;
                break;
            case (0, $c7Irs.RecognitionStatus).TooManyRequests:
                reason = (0, $lnpwm.CancellationErrorCode).TooManyRequests;
                break;
            case (0, $c7Irs.RecognitionStatus).BadRequest:
                reason = (0, $lnpwm.CancellationErrorCode).BadRequestParameters;
                break;
            case (0, $c7Irs.RecognitionStatus).Forbidden:
                reason = (0, $lnpwm.CancellationErrorCode).Forbidden;
                break;
            default:
                reason = (0, $lnpwm.CancellationErrorCode).NoError;
                break;
        }
        return reason;
    }
    static implTranslateErrorDetails(cancellationErrorCode) {
        let errorDetails = "The speech service encountered an internal error and could not continue.";
        switch(cancellationErrorCode){
            case (0, $lnpwm.CancellationErrorCode).Forbidden:
                errorDetails = "The recognizer is using a free subscription that ran out of quota.";
                break;
            case (0, $lnpwm.CancellationErrorCode).BadRequestParameters:
                errorDetails = "Invalid parameter or unsupported audio format in the request.";
                break;
            case (0, $lnpwm.CancellationErrorCode).TooManyRequests:
                errorDetails = "The number of parallel requests exceeded the number of allowed concurrent transcriptions.";
                break;
            default:
                break;
        }
        return errorDetails;
    }
}

});

parcelRequire.register("c7Irs", function(module, exports) {

$parcel$export(module.exports, "SynthesisStatus", () => $8d389cafbcee0b00$export$7be11a9ec645348f);
$parcel$export(module.exports, "RecognitionStatus", () => $8d389cafbcee0b00$export$9eb5d8ff1b75c8c9);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
/**
 * @class SynthesisStatus
 * @private
 */ var $8d389cafbcee0b00$export$7be11a9ec645348f;
(function(SynthesisStatus) {
    /**
     * The response contains valid audio data.
     * @member SynthesisStatus.Success
     */ SynthesisStatus[SynthesisStatus["Success"] = 0] = "Success";
    /**
     * Indicates the end of audio data. No valid audio data is included in the message.
     * @member SynthesisStatus.SynthesisEnd
     */ SynthesisStatus[SynthesisStatus["SynthesisEnd"] = 1] = "SynthesisEnd";
    /**
     * Indicates an error occurred during synthesis data processing.
     * @member SynthesisStatus.Error
     */ SynthesisStatus[SynthesisStatus["Error"] = 2] = "Error";
})($8d389cafbcee0b00$export$7be11a9ec645348f || ($8d389cafbcee0b00$export$7be11a9ec645348f = {}));
var $8d389cafbcee0b00$export$9eb5d8ff1b75c8c9;
(function(RecognitionStatus) {
    RecognitionStatus[RecognitionStatus["Success"] = 0] = "Success";
    RecognitionStatus[RecognitionStatus["NoMatch"] = 1] = "NoMatch";
    RecognitionStatus[RecognitionStatus["InitialSilenceTimeout"] = 2] = "InitialSilenceTimeout";
    RecognitionStatus[RecognitionStatus["BabbleTimeout"] = 3] = "BabbleTimeout";
    RecognitionStatus[RecognitionStatus["Error"] = 4] = "Error";
    RecognitionStatus[RecognitionStatus["EndOfDictation"] = 5] = "EndOfDictation";
    RecognitionStatus[RecognitionStatus["TooManyRequests"] = 6] = "TooManyRequests";
    RecognitionStatus[RecognitionStatus["BadRequest"] = 7] = "BadRequest";
    RecognitionStatus[RecognitionStatus["Forbidden"] = 8] = "Forbidden";
})($8d389cafbcee0b00$export$9eb5d8ff1b75c8c9 || ($8d389cafbcee0b00$export$9eb5d8ff1b75c8c9 = {}));

});

parcelRequire.register("5fZ8e", function(module, exports) {

$parcel$export(module.exports, "TranslationSynthesisEnd", () => $3d3dc5f15a04ce56$export$3de8adee428d019);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
parcelRequire("jSpbe");
var $c7Irs = parcelRequire("c7Irs");
class $3d3dc5f15a04ce56$export$3de8adee428d019 {
    constructor(json){
        this.privSynthesisEnd = JSON.parse(json);
        if (!!this.privSynthesisEnd.SynthesisStatus) this.privSynthesisEnd.SynthesisStatus = (0, $c7Irs.SynthesisStatus)[this.privSynthesisEnd.SynthesisStatus];
        if (!!this.privSynthesisEnd.Status) this.privSynthesisEnd.SynthesisStatus = (0, $c7Irs.SynthesisStatus)[this.privSynthesisEnd.Status];
    }
    static fromJSON(json) {
        return new $3d3dc5f15a04ce56$export$3de8adee428d019(json);
    }
    get SynthesisStatus() {
        return this.privSynthesisEnd.SynthesisStatus;
    }
    get FailureReason() {
        return this.privSynthesisEnd.FailureReason;
    }
}

});

parcelRequire.register("aWATK", function(module, exports) {

$parcel$export(module.exports, "TranslationHypothesis", () => $7f7bf1605256d4a8$export$1c96cbc019746d38);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.

var $frtBW = parcelRequire("frtBW");
class $7f7bf1605256d4a8$export$1c96cbc019746d38 {
    constructor(json){
        this.privTranslationHypothesis = JSON.parse(json);
        this.privTranslationHypothesis.Translation.TranslationStatus = (0, $frtBW.TranslationStatus)[this.privTranslationHypothesis.Translation.TranslationStatus];
    }
    static fromJSON(json) {
        return new $7f7bf1605256d4a8$export$1c96cbc019746d38(json);
    }
    get Duration() {
        return this.privTranslationHypothesis.Duration;
    }
    get Offset() {
        return this.privTranslationHypothesis.Offset;
    }
    get Text() {
        return this.privTranslationHypothesis.Text;
    }
    get Translation() {
        return this.privTranslationHypothesis.Translation;
    }
}

});

parcelRequire.register("bhcO2", function(module, exports) {

$parcel$export(module.exports, "TranslationPhrase", () => $835b3743b50280ca$export$cc005ab76f972fce);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.

var $8HmyV = parcelRequire("8HmyV");
parcelRequire("jSpbe");
var $c7Irs = parcelRequire("c7Irs");

var $frtBW = parcelRequire("frtBW");
class $835b3743b50280ca$export$cc005ab76f972fce {
    constructor(phrase){
        this.privTranslationPhrase = phrase;
        this.privTranslationPhrase.RecognitionStatus = (0, $c7Irs.RecognitionStatus)[this.privTranslationPhrase.RecognitionStatus];
        if (this.privTranslationPhrase.Translation !== undefined) this.privTranslationPhrase.Translation.TranslationStatus = (0, $frtBW.TranslationStatus)[this.privTranslationPhrase.Translation.TranslationStatus];
    }
    static fromJSON(json) {
        return new $835b3743b50280ca$export$cc005ab76f972fce(JSON.parse(json));
    }
    static fromTranslationResponse(translationResponse) {
        (0, $8HmyV.Contracts).throwIfNullOrUndefined(translationResponse, "translationResponse");
        const phrase = translationResponse.SpeechPhrase;
        translationResponse.SpeechPhrase = undefined;
        phrase.Translation = translationResponse;
        phrase.Text = phrase.DisplayText;
        return new $835b3743b50280ca$export$cc005ab76f972fce(phrase);
    }
    get RecognitionStatus() {
        return this.privTranslationPhrase.RecognitionStatus;
    }
    get Offset() {
        return this.privTranslationPhrase.Offset;
    }
    get Duration() {
        return this.privTranslationPhrase.Duration;
    }
    get Text() {
        return this.privTranslationPhrase.Text;
    }
    get Language() {
        var _a;
        return (_a = this.privTranslationPhrase.PrimaryLanguage) === null || _a === void 0 ? void 0 : _a.Language;
    }
    get Confidence() {
        var _a;
        return (_a = this.privTranslationPhrase.PrimaryLanguage) === null || _a === void 0 ? void 0 : _a.Confidence;
    }
    get Translation() {
        return this.privTranslationPhrase.Translation;
    }
}

});

parcelRequire.register("kK3Rc", function(module, exports) {
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
parcelRequire("cR8AB");
var $jQZQm = parcelRequire("jQZQm");
var $frtBW = parcelRequire("frtBW");

var $lnpwm = parcelRequire("lnpwm");
var $5idXV = parcelRequire("5idXV");
var $3fCi1 = parcelRequire("3fCi1");
var $bjdWp = parcelRequire("bjdWp");
var $9Wq4L = parcelRequire("9Wq4L");
var $lvUQW = parcelRequire("lvUQW");
var $lViPh = parcelRequire("lViPh");
var $3t7nZ = parcelRequire("3t7nZ");
var $3PErW = parcelRequire("3PErW");
var $i4QCK = parcelRequire("i4QCK");
var $7g8sL = parcelRequire("7g8sL");
parcelRequire("jSpbe");
var $c7Irs = parcelRequire("c7Irs");
var $iBWCB = parcelRequire("iBWCB");
var $aWATK = parcelRequire("aWATK");
var $bhcO2 = parcelRequire("bhcO2");
var $5fZ8e = parcelRequire("5fZ8e");
var $jSpbe = parcelRequire("jSpbe");
var $3kAgv = parcelRequire("3kAgv");
var $f19b187730430a21$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
class $f19b187730430a21$export$bf332edf125f0dc6 extends (0, $3kAgv.ConversationServiceRecognizer) {
    constructor(authentication, connectionFactory, audioSource, recognizerConfig, translationRecognizer){
        super(authentication, connectionFactory, audioSource, recognizerConfig, translationRecognizer);
        this.privTranslationRecognizer = translationRecognizer;
        this.connectionEvents.attach((connectionEvent)=>{
            if (connectionEvent.name === "ConnectionEstablishedEvent") this.privTranslationRecognizer.onConnection();
            else if (connectionEvent.name === "ConnectionClosedEvent") this.privTranslationRecognizer.onDisconnection();
        });
    }
    processTypeSpecificMessages(connectionMessage) {
        return $f19b187730430a21$var$__awaiter(this, void 0, void 0, function*() {
            const resultProps = new (0, $3fCi1.PropertyCollection)();
            let processed = yield this.processSpeechMessages(connectionMessage);
            if (processed) return true;
            const handleTranslationPhrase = (translatedPhrase)=>$f19b187730430a21$var$__awaiter(this, void 0, void 0, function*() {
                    this.privRequestSession.onPhraseRecognized(this.privRequestSession.currentTurnAudioOffset + translatedPhrase.Offset + translatedPhrase.Duration);
                    if (translatedPhrase.RecognitionStatus === (0, $c7Irs.RecognitionStatus).Success) {
                        // OK, the recognition was successful. How'd the translation do?
                        const result = this.fireEventForResult(translatedPhrase, resultProps);
                        if (!!this.privTranslationRecognizer.recognized) try {
                            this.privTranslationRecognizer.recognized(this.privTranslationRecognizer, result);
                        /* eslint-disable no-empty */ } catch (error) {
                        // Not going to let errors in the event handler
                        // trip things up.
                        }
                        // report result to promise.
                        if (!!this.privSuccessCallback) {
                            try {
                                this.privSuccessCallback(result.result);
                            } catch (e) {
                                if (!!this.privErrorCallback) this.privErrorCallback(e);
                            }
                            // Only invoke the call back once.
                            // and if it's successful don't invoke the
                            // error after that.
                            this.privSuccessCallback = undefined;
                            this.privErrorCallback = undefined;
                        }
                    } else {
                        const reason = (0, $iBWCB.EnumTranslation).implTranslateRecognitionResult(translatedPhrase.RecognitionStatus);
                        const result = new (0, $3t7nZ.TranslationRecognitionResult)(undefined, this.privRequestSession.requestId, reason, translatedPhrase.Text, translatedPhrase.Duration, this.privRequestSession.currentTurnAudioOffset + translatedPhrase.Offset, translatedPhrase.Language, translatedPhrase.Confidence, undefined, connectionMessage.textBody, resultProps);
                        if (reason === (0, $9Wq4L.ResultReason).Canceled) {
                            const cancelReason = (0, $iBWCB.EnumTranslation).implTranslateCancelResult(translatedPhrase.RecognitionStatus);
                            const cancellationErrorCode = (0, $iBWCB.EnumTranslation).implTranslateCancelErrorCode(translatedPhrase.RecognitionStatus);
                            yield this.cancelRecognitionLocal(cancelReason, cancellationErrorCode, (0, $iBWCB.EnumTranslation).implTranslateErrorDetails(cancellationErrorCode));
                        } else {
                            if (!(this.privRequestSession.isSpeechEnded && reason === (0, $9Wq4L.ResultReason).NoMatch && translatedPhrase.RecognitionStatus !== (0, $c7Irs.RecognitionStatus).InitialSilenceTimeout)) {
                                const ev = new (0, $lViPh.TranslationRecognitionEventArgs)(result, result.offset, this.privRequestSession.sessionId);
                                if (!!this.privTranslationRecognizer.recognized) try {
                                    this.privTranslationRecognizer.recognized(this.privTranslationRecognizer, ev);
                                /* eslint-disable no-empty */ } catch (error) {
                                // Not going to let errors in the event handler
                                // trip things up.
                                }
                            }
                            // report result to promise.
                            if (!!this.privSuccessCallback) {
                                try {
                                    this.privSuccessCallback(result);
                                } catch (e) {
                                    if (!!this.privErrorCallback) this.privErrorCallback(e);
                                }
                                // Only invoke the call back once.
                                // and if it's successful don't invoke the
                                // error after that.
                                this.privSuccessCallback = undefined;
                                this.privErrorCallback = undefined;
                            }
                        }
                        processed = true;
                    }
                });
            if (connectionMessage.messageType === (0, $jQZQm.MessageType).Text) resultProps.setProperty((0, $bjdWp.PropertyId).SpeechServiceResponse_JsonResult, connectionMessage.textBody);
            switch(connectionMessage.path.toLowerCase()){
                case "translation.hypothesis":
                    const result = this.fireEventForResult((0, $aWATK.TranslationHypothesis).fromJSON(connectionMessage.textBody), resultProps);
                    this.privRequestSession.onHypothesis(this.privRequestSession.currentTurnAudioOffset + result.offset);
                    if (!!this.privTranslationRecognizer.recognizing) try {
                        this.privTranslationRecognizer.recognizing(this.privTranslationRecognizer, result);
                    /* eslint-disable no-empty */ } catch (error) {
                    // Not going to let errors in the event handler
                    // trip things up.
                    }
                    processed = true;
                    break;
                case "translation.response":
                    const phrase = JSON.parse(connectionMessage.textBody);
                    if (!!phrase.SpeechPhrase) yield handleTranslationPhrase((0, $bhcO2.TranslationPhrase).fromTranslationResponse(phrase));
                    break;
                case "translation.phrase":
                    yield handleTranslationPhrase((0, $bhcO2.TranslationPhrase).fromJSON(connectionMessage.textBody));
                    break;
                case "translation.synthesis":
                    this.sendSynthesisAudio(connectionMessage.binaryBody, this.privRequestSession.sessionId);
                    processed = true;
                    break;
                case "audio.end":
                case "translation.synthesis.end":
                    const synthEnd = (0, $5fZ8e.TranslationSynthesisEnd).fromJSON(connectionMessage.textBody);
                    switch(synthEnd.SynthesisStatus){
                        case (0, $c7Irs.SynthesisStatus).Error:
                            if (!!this.privTranslationRecognizer.synthesizing) {
                                const result = new (0, $7g8sL.TranslationSynthesisResult)((0, $9Wq4L.ResultReason).Canceled, undefined);
                                const retEvent = new (0, $i4QCK.TranslationSynthesisEventArgs)(result, this.privRequestSession.sessionId);
                                try {
                                    this.privTranslationRecognizer.synthesizing(this.privTranslationRecognizer, retEvent);
                                /* eslint-disable no-empty */ } catch (error) {
                                // Not going to let errors in the event handler
                                // trip things up.
                                }
                            }
                            if (!!this.privTranslationRecognizer.canceled) {
                                // And raise a canceled event to send the rich(er) error message back.
                                const canceledResult = new (0, $lvUQW.TranslationRecognitionCanceledEventArgs)(this.privRequestSession.sessionId, (0, $5idXV.CancellationReason).Error, synthEnd.FailureReason, (0, $lnpwm.CancellationErrorCode).ServiceError, null);
                                try {
                                    this.privTranslationRecognizer.canceled(this.privTranslationRecognizer, canceledResult);
                                /* eslint-disable no-empty */ } catch (error) {
                                // Not going to let errors in the event handler
                                // trip things up.
                                }
                            }
                            break;
                        case (0, $c7Irs.SynthesisStatus).Success:
                            this.sendSynthesisAudio(undefined, this.privRequestSession.sessionId);
                            break;
                        default:
                            break;
                    }
                    processed = true;
                    break;
                default:
                    break;
            }
            return processed;
        });
    }
    // Cancels recognition.
    cancelRecognition(sessionId, requestId, cancellationReason, errorCode, error) {
        const properties = new (0, $3fCi1.PropertyCollection)();
        properties.setProperty((0, $jSpbe.CancellationErrorCodePropertyName), (0, $lnpwm.CancellationErrorCode)[errorCode]);
        if (!!this.privTranslationRecognizer.canceled) {
            const cancelEvent = new (0, $lvUQW.TranslationRecognitionCanceledEventArgs)(sessionId, cancellationReason, error, errorCode, undefined);
            try {
                this.privTranslationRecognizer.canceled(this.privTranslationRecognizer, cancelEvent);
            /* eslint-disable no-empty */ } catch (_a) {}
        }
        if (!!this.privSuccessCallback) {
            const result = new (0, $3t7nZ.TranslationRecognitionResult)(undefined, requestId, (0, $9Wq4L.ResultReason).Canceled, undefined, undefined, undefined, undefined, undefined, error, undefined, properties);
            try {
                this.privSuccessCallback(result);
                /* eslint-disable no-empty */ this.privSuccessCallback = undefined;
            } catch (_b) {}
        }
    }
    handleRecognizingCallback(result, duration, sessionId) {
        try {
            const ev = new (0, $lViPh.TranslationRecognitionEventArgs)((0, $3t7nZ.TranslationRecognitionResult).fromSpeechRecognitionResult(result), duration, sessionId);
            this.privTranslationRecognizer.recognizing(this.privTranslationRecognizer, ev);
        /* eslint-disable no-empty */ } catch (error) {
        // Not going to let errors in the event handler
        // trip things up.
        }
    }
    handleRecognizedCallback(result, offset, sessionId) {
        try {
            const ev = new (0, $lViPh.TranslationRecognitionEventArgs)((0, $3t7nZ.TranslationRecognitionResult).fromSpeechRecognitionResult(result), offset, sessionId);
            this.privTranslationRecognizer.recognized(this.privTranslationRecognizer, ev);
        } catch (error) {
        // Not going to let errors in the event handler
        // trip things up.
        }
    }
    fireEventForResult(serviceResult, properties) {
        let translations;
        if (undefined !== serviceResult.Translation.Translations) {
            translations = new (0, $3PErW.Translations)();
            for (const translation of serviceResult.Translation.Translations)translations.set(translation.Language, translation.Text || translation.DisplayText);
        }
        let resultReason;
        let language;
        let confidence;
        if (serviceResult instanceof (0, $bhcO2.TranslationPhrase)) {
            if (!!serviceResult.Translation && serviceResult.Translation.TranslationStatus === (0, $frtBW.TranslationStatus).Success) resultReason = (0, $9Wq4L.ResultReason).TranslatedSpeech;
            else resultReason = (0, $9Wq4L.ResultReason).RecognizedSpeech;
            language = serviceResult.Language;
            confidence = serviceResult.Confidence;
        } else resultReason = (0, $9Wq4L.ResultReason).TranslatingSpeech;
        const offset = serviceResult.Offset + this.privRequestSession.currentTurnAudioOffset;
        const result = new (0, $3t7nZ.TranslationRecognitionResult)(translations, this.privRequestSession.requestId, resultReason, serviceResult.Text, serviceResult.Duration, offset, language, confidence, serviceResult.Translation.FailureReason, JSON.stringify(serviceResult), properties);
        const ev = new (0, $lViPh.TranslationRecognitionEventArgs)(result, offset, this.privRequestSession.sessionId);
        return ev;
    }
    sendSynthesisAudio(audio, sessionId) {
        const reason = undefined === audio ? (0, $9Wq4L.ResultReason).SynthesizingAudioCompleted : (0, $9Wq4L.ResultReason).SynthesizingAudio;
        const result = new (0, $7g8sL.TranslationSynthesisResult)(reason, audio);
        const retEvent = new (0, $i4QCK.TranslationSynthesisEventArgs)(result, sessionId);
        if (!!this.privTranslationRecognizer.synthesizing) try {
            this.privTranslationRecognizer.synthesizing(this.privTranslationRecognizer, retEvent);
        /* eslint-disable no-empty */ } catch (error) {
        // Not going to let errors in the event handler
        // trip things up.
        }
    }
}

});
parcelRequire.register("lvUQW", function(module, exports) {

$parcel$export(module.exports, "TranslationRecognitionCanceledEventArgs", () => $fa98980145d4491b$export$99f29a98babb31f);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
/**
 * Define payload of speech recognition canceled result events.
 * @class TranslationRecognitionCanceledEventArgs
 */ class $fa98980145d4491b$export$99f29a98babb31f {
    /**
     * Creates and initializes an instance of this class.
     * @constructor
     * @param {string} sessionid - The session id.
     * @param {CancellationReason} cancellationReason - The cancellation reason.
     * @param {string} errorDetails - Error details, if provided.
     * @param {TranslationRecognitionResult} result - The result.
     */ constructor(sessionid, cancellationReason, errorDetails, errorCode, result){
        this.privCancelReason = cancellationReason;
        this.privErrorDetails = errorDetails;
        this.privResult = result;
        this.privSessionId = sessionid;
        this.privErrorCode = errorCode;
    }
    /**
     * Specifies the recognition result.
     * @member TranslationRecognitionCanceledEventArgs.prototype.result
     * @function
     * @public
     * @returns {TranslationRecognitionResult} the recognition result.
     */ get result() {
        return this.privResult;
    }
    /**
     * Specifies the session identifier.
     * @member TranslationRecognitionCanceledEventArgs.prototype.sessionId
     * @function
     * @public
     * @returns {string} the session identifier.
     */ get sessionId() {
        return this.privSessionId;
    }
    /**
     * The reason the recognition was canceled.
     * @member TranslationRecognitionCanceledEventArgs.prototype.reason
     * @function
     * @public
     * @returns {CancellationReason} Specifies the reason canceled.
     */ get reason() {
        return this.privCancelReason;
    }
    /**
     * The error code in case of an unsuccessful recognition.
     * Added in version 1.1.0.
     * @return An error code that represents the error reason.
     */ get errorCode() {
        return this.privErrorCode;
    }
    /**
     * In case of an unsuccessful recognition, provides details of the occurred error.
     * @member TranslationRecognitionCanceledEventArgs.prototype.errorDetails
     * @function
     * @public
     * @returns {string} A String that represents the error details.
     */ get errorDetails() {
        return this.privErrorDetails;
    }
}

});

parcelRequire.register("lViPh", function(module, exports) {

$parcel$export(module.exports, "TranslationRecognitionEventArgs", () => $ff5d8655972a000a$export$3d30fcebb19c1429);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.

var $eylh7 = parcelRequire("eylh7");
class $ff5d8655972a000a$export$3d30fcebb19c1429 extends (0, $eylh7.RecognitionEventArgs) {
    /**
     * Creates and initializes an instance of this class.
     * @constructor
     * @param {TranslationRecognitionResult} result - The translation recognition result.
     * @param {number} offset - The offset.
     * @param {string} sessionId - The session id.
     */ constructor(result, offset, sessionId){
        super(offset, sessionId);
        this.privResult = result;
    }
    /**
     * Specifies the recognition result.
     * @member TranslationRecognitionEventArgs.prototype.result
     * @function
     * @public
     * @returns {TranslationRecognitionResult} the recognition result.
     */ get result() {
        return this.privResult;
    }
}

});

parcelRequire.register("3t7nZ", function(module, exports) {

$parcel$export(module.exports, "TranslationRecognitionResult", () => $2869cf35e9ea1f77$export$a82ef3e7bb29fe5f);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.

var $fmH2B = parcelRequire("fmH2B");
class $2869cf35e9ea1f77$export$a82ef3e7bb29fe5f extends (0, $fmH2B.SpeechRecognitionResult) {
    /**
     * Creates and initializes an instance of this class.
     * @constructor
     * @param {Translations} translations - The translations.
     * @param {string} resultId - The result id.
     * @param {ResultReason} reason - The reason.
     * @param {string} text - The recognized text.
     * @param {number} duration - The duration.
     * @param {number} offset - The offset into the stream.
     * @param {string} language - Primary Language detected, if provided.
     * @param {string} languageDetectionConfidence - Primary Language confidence ("Unknown," "Low," "Medium," "High"...), if provided.
     * @param {string} errorDetails - Error details, if provided.
     * @param {string} json - Additional Json, if provided.
     * @param {PropertyCollection} properties - Additional properties, if provided.
     */ constructor(translations, resultId, reason, text, duration, offset, language, languageDetectionConfidence, errorDetails, json, properties){
        super(resultId, reason, text, duration, offset, language, languageDetectionConfidence, undefined, errorDetails, json, properties);
        this.privTranslations = translations;
    }
    static fromSpeechRecognitionResult(result) {
        return new $2869cf35e9ea1f77$export$a82ef3e7bb29fe5f(undefined, result.resultId, result.reason, result.text, result.duration, result.offset, result.language, result.languageDetectionConfidence, result.errorDetails, result.json, result.properties);
    }
    /**
     * Presents the translation results. Each item in the dictionary represents
     * a translation result in one of target languages, where the key is the name
     * of the target language, in BCP-47 format, and the value is the translation
     * text in the specified language.
     * @member TranslationRecognitionResult.prototype.translations
     * @function
     * @public
     * @returns {Translations} the current translation map that holds all translations requested.
     */ get translations() {
        return this.privTranslations;
    }
}

});

parcelRequire.register("3PErW", function(module, exports) {

$parcel$export(module.exports, "Translations", () => $2ca582f90c137677$export$1f12680e68c5100d);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.

var $3fCi1 = parcelRequire("3fCi1");
class $2ca582f90c137677$export$1f12680e68c5100d {
    constructor(){
        // Use an PropertyCollection internally, just wrapping it to hide the | enum syntax it has.
        this.privMap = new (0, $3fCi1.PropertyCollection)();
    }
    /**
     * Get the languages in the object in a String array.
     * @member Translations.prototype.languages
     * @function
     * @public
     * @returns {string[]} languages in translations object.
     */ get languages() {
        return this.privMap.keys;
    }
    /**
     * Returns the parameter value in type String. The parameter must have the same type as String.
     * Currently only String, int and bool are allowed.
     * If the name is not available, the specified defaultValue is returned.
     * @member Translations.prototype.get
     * @function
     * @public
     * @param {string} key - The parameter name.
     * @param {string} def - The default value which is returned if the parameter is not available in the collection.
     * @returns {string} value of the parameter.
     */ get(key, def) {
        return this.privMap.getProperty(key, def);
    }
    /**
     * Sets the String value of the parameter specified by name.
     * @member Translations.prototype.set
     * @function
     * @public
     * @param {string} key - The parameter name.
     * @param {string} value - The value of the parameter.
     */ set(key, value) {
        this.privMap.setProperty(key, value);
    }
}

});

parcelRequire.register("i4QCK", function(module, exports) {

$parcel$export(module.exports, "TranslationSynthesisEventArgs", () => $d2916bbf49ee7589$export$137d31b3848d9c32);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.

var $daYNc = parcelRequire("daYNc");
class $d2916bbf49ee7589$export$137d31b3848d9c32 extends (0, $daYNc.SessionEventArgs) {
    /**
     * Creates and initializes an instance of this class.
     * @constructor
     * @param {TranslationSynthesisResult} result - The translation synthesis result.
     * @param {string} sessionId - The session id.
     */ constructor(result, sessionId){
        super(sessionId);
        this.privResult = result;
    }
    /**
     * Specifies the translation synthesis result.
     * @member TranslationSynthesisEventArgs.prototype.result
     * @function
     * @public
     * @returns {TranslationSynthesisResult} Specifies the translation synthesis result.
     */ get result() {
        return this.privResult;
    }
}

});

parcelRequire.register("7g8sL", function(module, exports) {

$parcel$export(module.exports, "TranslationSynthesisResult", () => $549097936e714bf2$export$17f18d3f3dbd9330);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
/**
 * Defines translation synthesis result, i.e. the voice output of the translated
 * text in the target language.
 * @class TranslationSynthesisResult
 */ class $549097936e714bf2$export$17f18d3f3dbd9330 {
    /**
     * Creates and initializes an instance of this class.
     * @constructor
     * @param {ResultReason} reason - The synthesis reason.
     * @param {ArrayBuffer} audio - The audio data.
     */ constructor(reason, audio){
        this.privReason = reason;
        this.privAudio = audio;
    }
    /**
     * Translated text in the target language.
     * @member TranslationSynthesisResult.prototype.audio
     * @function
     * @public
     * @returns {ArrayBuffer} Translated audio in the target language.
     */ get audio() {
        return this.privAudio;
    }
    /**
     * The synthesis status.
     * @member TranslationSynthesisResult.prototype.reason
     * @function
     * @public
     * @returns {ResultReason} The synthesis status.
     */ get reason() {
        return this.privReason;
    }
}

});


parcelRequire.register("gdyuc", function(module, exports) {

$parcel$export(module.exports, "SpeechDetected", () => $bce89c73f030d4a8$export$fa943fcb498ea779);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
class $bce89c73f030d4a8$export$fa943fcb498ea779 {
    constructor(json){
        this.privSpeechStartDetected = JSON.parse(json);
    }
    static fromJSON(json) {
        return new $bce89c73f030d4a8$export$fa943fcb498ea779(json);
    }
    get Offset() {
        return this.privSpeechStartDetected.Offset;
    }
}

});

parcelRequire.register("i1ulX", function(module, exports) {

$parcel$export(module.exports, "SpeechHypothesis", () => $d1efdd7bea695084$export$b698b2694660f661);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
class $d1efdd7bea695084$export$b698b2694660f661 {
    constructor(json){
        this.privSpeechHypothesis = JSON.parse(json);
    }
    static fromJSON(json) {
        return new $d1efdd7bea695084$export$b698b2694660f661(json);
    }
    get Text() {
        return this.privSpeechHypothesis.Text;
    }
    get Offset() {
        return this.privSpeechHypothesis.Offset;
    }
    get Duration() {
        return this.privSpeechHypothesis.Duration;
    }
    get Language() {
        return this.privSpeechHypothesis.PrimaryLanguage === undefined ? undefined : this.privSpeechHypothesis.PrimaryLanguage.Language;
    }
    get LanguageDetectionConfidence() {
        return this.privSpeechHypothesis.PrimaryLanguage === undefined ? undefined : this.privSpeechHypothesis.PrimaryLanguage.Confidence;
    }
    get SpeakerId() {
        return this.privSpeechHypothesis.SpeakerId;
    }
}

});

parcelRequire.register("1Anur", function(module, exports) {

$parcel$export(module.exports, "SpeechKeyword", () => $127b5fe1cbca3bb5$export$f0f3620dc9fff52f);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
class $127b5fe1cbca3bb5$export$f0f3620dc9fff52f {
    constructor(json){
        this.privSpeechKeyword = JSON.parse(json);
    }
    static fromJSON(json) {
        return new $127b5fe1cbca3bb5$export$f0f3620dc9fff52f(json);
    }
    get Status() {
        return this.privSpeechKeyword.Status;
    }
    get Text() {
        return this.privSpeechKeyword.Text;
    }
    get Offset() {
        return this.privSpeechKeyword.Offset;
    }
    get Duration() {
        return this.privSpeechKeyword.Duration;
    }
}

});

parcelRequire.register("dRPvB", function(module, exports) {
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.

var $lnpwm = parcelRequire("lnpwm");
var $7cfhB = parcelRequire("7cfhB");
var $3fCi1 = parcelRequire("3fCi1");
var $bjdWp = parcelRequire("bjdWp");
var $9Wq4L = parcelRequire("9Wq4L");
var $13q8D = parcelRequire("13q8D");
var $6Pkpi = parcelRequire("6Pkpi");
var $fmH2B = parcelRequire("fmH2B");
parcelRequire("jSpbe");
var $i1ulX = parcelRequire("i1ulX");
var $ea7Fz = parcelRequire("ea7Fz");
var $iBWCB = parcelRequire("iBWCB");
var $c7Irs = parcelRequire("c7Irs");
var $jSpbe = parcelRequire("jSpbe");
var $bO7IR = parcelRequire("bO7IR");
var $je076 = parcelRequire("je076");
var $a1882e25d6d0a6e0$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
class $a1882e25d6d0a6e0$export$ed87a00dda91f8bd extends (0, $je076.ServiceRecognizerBase) {
    constructor(authentication, connectionFactory, audioSource, recognizerConfig, speechRecognizer){
        super(authentication, connectionFactory, audioSource, recognizerConfig, speechRecognizer);
        this.privSpeechRecognizer = speechRecognizer;
    }
    processTypeSpecificMessages(connectionMessage) {
        return $a1882e25d6d0a6e0$var$__awaiter(this, void 0, void 0, function*() {
            let result;
            const resultProps = new (0, $3fCi1.PropertyCollection)();
            resultProps.setProperty((0, $bjdWp.PropertyId).SpeechServiceResponse_JsonResult, connectionMessage.textBody);
            let processed = false;
            switch(connectionMessage.path.toLowerCase()){
                case "speech.hypothesis":
                case "speech.fragment":
                    const hypothesis = (0, $i1ulX.SpeechHypothesis).fromJSON(connectionMessage.textBody);
                    const offset = hypothesis.Offset + this.privRequestSession.currentTurnAudioOffset;
                    result = new (0, $fmH2B.SpeechRecognitionResult)(this.privRequestSession.requestId, (0, $9Wq4L.ResultReason).RecognizingSpeech, hypothesis.Text, hypothesis.Duration, offset, hypothesis.Language, hypothesis.LanguageDetectionConfidence, undefined, undefined, connectionMessage.textBody, resultProps);
                    this.privRequestSession.onHypothesis(offset);
                    const ev = new (0, $6Pkpi.SpeechRecognitionEventArgs)(result, hypothesis.Duration, this.privRequestSession.sessionId);
                    if (!!this.privSpeechRecognizer.recognizing) try {
                        this.privSpeechRecognizer.recognizing(this.privSpeechRecognizer, ev);
                    /* eslint-disable no-empty */ } catch (error) {
                    // Not going to let errors in the event handler
                    // trip things up.
                    }
                    processed = true;
                    break;
                case "speech.phrase":
                    const simple = (0, $ea7Fz.SimpleSpeechPhrase).fromJSON(connectionMessage.textBody);
                    const resultReason = (0, $iBWCB.EnumTranslation).implTranslateRecognitionResult(simple.RecognitionStatus);
                    this.privRequestSession.onPhraseRecognized(this.privRequestSession.currentTurnAudioOffset + simple.Offset + simple.Duration);
                    if ((0, $9Wq4L.ResultReason).Canceled === resultReason) {
                        const cancelReason = (0, $iBWCB.EnumTranslation).implTranslateCancelResult(simple.RecognitionStatus);
                        const cancellationErrorCode = (0, $iBWCB.EnumTranslation).implTranslateCancelErrorCode(simple.RecognitionStatus);
                        yield this.cancelRecognitionLocal(cancelReason, cancellationErrorCode, (0, $iBWCB.EnumTranslation).implTranslateErrorDetails(cancellationErrorCode));
                    } else {
                        if (!(this.privRequestSession.isSpeechEnded && resultReason === (0, $9Wq4L.ResultReason).NoMatch && simple.RecognitionStatus !== (0, $c7Irs.RecognitionStatus).InitialSilenceTimeout)) {
                            if (this.privRecognizerConfig.parameters.getProperty((0, $jSpbe.OutputFormatPropertyName)) === (0, $7cfhB.OutputFormat)[(0, $7cfhB.OutputFormat).Simple]) result = new (0, $fmH2B.SpeechRecognitionResult)(this.privRequestSession.requestId, resultReason, simple.DisplayText, simple.Duration, simple.Offset + this.privRequestSession.currentTurnAudioOffset, simple.Language, simple.LanguageDetectionConfidence, undefined, undefined, connectionMessage.textBody, resultProps);
                            else {
                                const detailed = (0, $bO7IR.DetailedSpeechPhrase).fromJSON(connectionMessage.textBody);
                                const totalOffset = detailed.Offset + this.privRequestSession.currentTurnAudioOffset;
                                const offsetCorrectedJson = detailed.getJsonWithCorrectedOffsets(totalOffset);
                                result = new (0, $fmH2B.SpeechRecognitionResult)(this.privRequestSession.requestId, resultReason, detailed.RecognitionStatus === (0, $c7Irs.RecognitionStatus).Success ? detailed.NBest[0].Display : undefined, detailed.Duration, totalOffset, detailed.Language, detailed.LanguageDetectionConfidence, undefined, undefined, offsetCorrectedJson, resultProps);
                            }
                            const event = new (0, $6Pkpi.SpeechRecognitionEventArgs)(result, result.offset, this.privRequestSession.sessionId);
                            if (!!this.privSpeechRecognizer.recognized) try {
                                this.privSpeechRecognizer.recognized(this.privSpeechRecognizer, event);
                            /* eslint-disable no-empty */ } catch (error) {
                            // Not going to let errors in the event handler
                            // trip things up.
                            }
                        }
                        if (!!this.privSuccessCallback) {
                            try {
                                this.privSuccessCallback(result);
                            } catch (e) {
                                if (!!this.privErrorCallback) this.privErrorCallback(e);
                            }
                            // Only invoke the call back once.
                            // and if it's successful don't invoke the
                            // error after that.
                            this.privSuccessCallback = undefined;
                            this.privErrorCallback = undefined;
                        }
                    }
                    processed = true;
                    break;
                default:
                    break;
            }
            return processed;
        });
    }
    // Cancels recognition.
    cancelRecognition(sessionId, requestId, cancellationReason, errorCode, error) {
        const properties = new (0, $3fCi1.PropertyCollection)();
        properties.setProperty((0, $jSpbe.CancellationErrorCodePropertyName), (0, $lnpwm.CancellationErrorCode)[errorCode]);
        if (!!this.privSpeechRecognizer.canceled) {
            const cancelEvent = new (0, $13q8D.SpeechRecognitionCanceledEventArgs)(cancellationReason, error, errorCode, undefined, sessionId);
            try {
                this.privSpeechRecognizer.canceled(this.privSpeechRecognizer, cancelEvent);
            /* eslint-disable no-empty */ } catch (_a) {}
        }
        if (!!this.privSuccessCallback) {
            const result = new (0, $fmH2B.SpeechRecognitionResult)(requestId, (0, $9Wq4L.ResultReason).Canceled, undefined, undefined, undefined, undefined, undefined, undefined, error, undefined, properties);
            try {
                this.privSuccessCallback(result);
                this.privSuccessCallback = undefined;
            /* eslint-disable no-empty */ } catch (_b) {}
        }
    }
}

});
parcelRequire.register("13q8D", function(module, exports) {

$parcel$export(module.exports, "SpeechRecognitionCanceledEventArgs", () => $0c4a58c9a27bc49e$export$15ff9e6d819b9207);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.

var $jd917 = parcelRequire("jd917");
class $0c4a58c9a27bc49e$export$15ff9e6d819b9207 extends (0, $jd917.CancellationEventArgsBase) {
}

});
parcelRequire.register("jd917", function(module, exports) {

$parcel$export(module.exports, "CancellationEventArgsBase", () => $dfc639d6a9b335ee$export$dd228f7536b5286b);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.

var $eylh7 = parcelRequire("eylh7");
class $dfc639d6a9b335ee$export$dd228f7536b5286b extends (0, $eylh7.RecognitionEventArgs) {
    /**
     * Creates and initializes an instance of this class.
     * @constructor
     * @param {CancellationReason} reason - The cancellation reason.
     * @param {string} errorDetails - Error details, if provided.
     * @param {number} offset - The offset.
     * @param {string} sessionId - The session id.
     */ constructor(reason, errorDetails, errorCode, offset, sessionId){
        super(offset, sessionId);
        this.privReason = reason;
        this.privErrorDetails = errorDetails;
        this.privErrorCode = errorCode;
    }
    /**
     * The reason the recognition was canceled.
     * @member CancellationEventArgsBase.prototype.reason
     * @function
     * @public
     * @returns {CancellationReason} Specifies the reason canceled.
     */ get reason() {
        return this.privReason;
    }
    /**
     * The error code in case of an unsuccessful operation.
     * @return An error code that represents the error reason.
     */ get errorCode() {
        return this.privErrorCode;
    }
    /**
     * In case of an unsuccessful operation, provides details of the occurred error.
     * @member CancellationEventArgsBase.prototype.errorDetails
     * @function
     * @public
     * @returns {string} A String that represents the error details.
     */ get errorDetails() {
        return this.privErrorDetails;
    }
}

});


parcelRequire.register("6Pkpi", function(module, exports) {

$parcel$export(module.exports, "SpeechRecognitionEventArgs", () => $4f8755e2b077695c$export$a9c37a51b7d8dc18);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
/* eslint-disable max-classes-per-file */ 
var $eylh7 = parcelRequire("eylh7");
class $4f8755e2b077695c$export$a9c37a51b7d8dc18 extends (0, $eylh7.RecognitionEventArgs) {
    /**
     * Creates and initializes an instance of this class.
     * @constructor
     * @param {SpeechRecognitionResult} result - The speech recognition result.
     * @param {number} offset - The offset.
     * @param {string} sessionId - The session id.
     */ constructor(result, offset, sessionId){
        super(offset, sessionId);
        this.privResult = result;
    }
    /**
     * Specifies the recognition result.
     * @member SpeechRecognitionEventArgs.prototype.result
     * @function
     * @public
     * @returns {SpeechRecognitionResult} the recognition result.
     */ get result() {
        return this.privResult;
    }
}
class $4f8755e2b077695c$export$bdeacab7c8f9ce49 extends $4f8755e2b077695c$export$a9c37a51b7d8dc18 {
}

});


parcelRequire.register("5TEdQ", function(module, exports) {
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
parcelRequire("cR8AB");
var $jQZQm = parcelRequire("jQZQm");

var $lnpwm = parcelRequire("lnpwm");
var $3xKhu = parcelRequire("3xKhu");
var $3fCi1 = parcelRequire("3fCi1");
var $bjdWp = parcelRequire("bjdWp");
var $9Wq4L = parcelRequire("9Wq4L");
var $6Pkpi = parcelRequire("6Pkpi");
var $fmH2B = parcelRequire("fmH2B");

var $jSpbe = parcelRequire("jSpbe");
var $3kAgv = parcelRequire("3kAgv");

var $l4rU0 = parcelRequire("l4rU0");
var $44b14a221e3fb58a$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
class $44b14a221e3fb58a$export$f161eb90b75c9577 extends (0, $3kAgv.ConversationServiceRecognizer) {
    constructor(authentication, connectionFactory, audioSource, recognizerConfig, transcriber){
        super(authentication, connectionFactory, audioSource, recognizerConfig, transcriber);
        this.privTranscriberRecognizer = transcriber;
        this.sendPrePayloadJSONOverride = (connection)=>this.sendTranscriptionStartJSON(connection);
        if (this.privRecognizerConfig.parameters.getProperty((0, $bjdWp.PropertyId).SpeechServiceResponse_RequestWordLevelTimestamps) === "true") this.privSpeechContext.setWordLevelTimings();
    }
    sendSpeechEventAsync(info, command) {
        return $44b14a221e3fb58a$var$__awaiter(this, void 0, void 0, function*() {
            if (!!this.privRequestSession.isRecognizing) {
                const connection = yield this.fetchConnection();
                yield this.sendSpeechEvent(connection, this.createSpeechEventPayload(info, command));
            }
        });
    }
    processTypeSpecificMessages(connectionMessage) {
        return this.processSpeechMessages(connectionMessage);
    }
    handleRecognizedCallback(result, offset, sessionId) {
        try {
            const event = new (0, $6Pkpi.SpeechRecognitionEventArgs)(result, offset, sessionId);
            this.privTranscriberRecognizer.recognized(this.privTranscriberRecognizer, event);
            if (!!this.privSuccessCallback) {
                try {
                    this.privSuccessCallback(result);
                } catch (e) {
                    if (!!this.privErrorCallback) this.privErrorCallback(e);
                }
                // Only invoke the call back once.
                // and if it's successful don't invoke the
                // error after that.
                this.privSuccessCallback = undefined;
                this.privErrorCallback = undefined;
            }
        /* eslint-disable no-empty */ } catch (error) {
        // Not going to let errors in the event handler
        // trip things up.
        }
    }
    handleRecognizingCallback(result, duration, sessionId) {
        try {
            const ev = new (0, $6Pkpi.SpeechRecognitionEventArgs)(result, duration, sessionId);
            this.privTranscriberRecognizer.recognizing(this.privTranscriberRecognizer, ev);
        /* eslint-disable no-empty */ } catch (error) {
        // Not going to let errors in the event handler
        // trip things up.
        }
    }
    // Cancels recognition.
    cancelRecognition(sessionId, requestId, cancellationReason, errorCode, error) {
        const properties = new (0, $3fCi1.PropertyCollection)();
        properties.setProperty((0, $jSpbe.CancellationErrorCodePropertyName), (0, $lnpwm.CancellationErrorCode)[errorCode]);
        if (!!this.privTranscriberRecognizer.canceled) {
            const cancelEvent = new (0, $3xKhu.ConversationTranscriptionCanceledEventArgs)(cancellationReason, error, errorCode, undefined, sessionId);
            try {
                this.privTranscriberRecognizer.canceled(this.privTranscriberRecognizer, cancelEvent);
            /* eslint-disable no-empty */ } catch (_a) {}
        }
        if (!!this.privSuccessCallback) {
            const result = new (0, $fmH2B.SpeechRecognitionResult)(requestId, (0, $9Wq4L.ResultReason).Canceled, undefined, undefined, undefined, undefined, undefined, undefined, error, undefined, properties);
            try {
                this.privSuccessCallback(result);
                this.privSuccessCallback = undefined;
            /* eslint-disable no-empty */ } catch (_b) {}
        }
    }
    // Encapsulated for derived service recognizers that need to send additional JSON
    sendTranscriptionStartJSON(connection) {
        return $44b14a221e3fb58a$var$__awaiter(this, void 0, void 0, function*() {
            yield this.sendSpeechContext(connection, true);
            const info = this.privTranscriberRecognizer.getConversationInfo();
            const payload = this.createSpeechEventPayload(info, "start");
            yield this.sendSpeechEvent(connection, payload);
            yield this.sendWaveHeader(connection);
            return;
        });
    }
    sendSpeechEvent(connection, payload) {
        const speechEventJson = JSON.stringify(payload);
        if (speechEventJson) return connection.send(new (0, $l4rU0.SpeechConnectionMessage)((0, $jQZQm.MessageType).Text, "speech.event", this.privRequestSession.requestId, "application/json", speechEventJson));
        return;
    }
    createSpeechEventPayload(info, command) {
        const eventDict = {
            id: "meeting",
            name: command,
            meeting: info.conversationProperties
        };
        eventDict.meeting.id = info.id;
        eventDict.meeting.attendees = info.participants;
        eventDict.meeting.record = info.conversationProperties.audiorecording === "on" ? "true" : "false";
        return eventDict;
    }
}

});
parcelRequire.register("3xKhu", function(module, exports) {

$parcel$export(module.exports, "ConversationTranscriptionCanceledEventArgs", () => $29485aa30702a7c1$export$9601f7f2aa8b229e);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.

var $jd917 = parcelRequire("jd917");
class $29485aa30702a7c1$export$9601f7f2aa8b229e extends (0, $jd917.CancellationEventArgsBase) {
}

});


parcelRequire.register("bO7IR", function(module, exports) {

$parcel$export(module.exports, "DetailedSpeechPhrase", () => $898a5ac81e07726c$export$a2619747d8979906);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
parcelRequire("jSpbe");
var $c7Irs = parcelRequire("c7Irs");
class $898a5ac81e07726c$export$a2619747d8979906 {
    constructor(json){
        this.privDetailedSpeechPhrase = JSON.parse(json);
        this.privDetailedSpeechPhrase.RecognitionStatus = (0, $c7Irs.RecognitionStatus)[this.privDetailedSpeechPhrase.RecognitionStatus];
    }
    static fromJSON(json) {
        return new $898a5ac81e07726c$export$a2619747d8979906(json);
    }
    getJsonWithCorrectedOffsets(baseOffset) {
        if (!!this.privDetailedSpeechPhrase.NBest) {
            let firstWordOffset;
            for (const phrase of this.privDetailedSpeechPhrase.NBest)if (!!phrase.Words && !!phrase.Words[0]) {
                firstWordOffset = phrase.Words[0].Offset;
                break;
            }
            if (!!firstWordOffset && firstWordOffset < baseOffset) {
                const offset = baseOffset - firstWordOffset;
                for (const details of this.privDetailedSpeechPhrase.NBest){
                    if (!!details.Words) for (const word of details.Words)word.Offset += offset;
                    if (!!details.DisplayWords) for (const word of details.DisplayWords)word.Offset += offset;
                }
            }
        }
        return JSON.stringify(this.privDetailedSpeechPhrase);
    }
    get RecognitionStatus() {
        return this.privDetailedSpeechPhrase.RecognitionStatus;
    }
    get NBest() {
        return this.privDetailedSpeechPhrase.NBest;
    }
    get Duration() {
        return this.privDetailedSpeechPhrase.Duration;
    }
    get Offset() {
        return this.privDetailedSpeechPhrase.Offset;
    }
    get Language() {
        return this.privDetailedSpeechPhrase.PrimaryLanguage === undefined ? undefined : this.privDetailedSpeechPhrase.PrimaryLanguage.Language;
    }
    get LanguageDetectionConfidence() {
        return this.privDetailedSpeechPhrase.PrimaryLanguage === undefined ? undefined : this.privDetailedSpeechPhrase.PrimaryLanguage.Confidence;
    }
    get Text() {
        if (!!this.privDetailedSpeechPhrase.NBest && this.privDetailedSpeechPhrase.NBest[0]) return this.privDetailedSpeechPhrase.NBest[0].Display || this.privDetailedSpeechPhrase.NBest[0].DisplayText;
        return this.privDetailedSpeechPhrase.DisplayText;
    }
    get SpeakerId() {
        return this.privDetailedSpeechPhrase.SpeakerId;
    }
}

});

parcelRequire.register("ea7Fz", function(module, exports) {

$parcel$export(module.exports, "SimpleSpeechPhrase", () => $a4f7f2e1d87e3b2c$export$20e2c3c1649e1f71);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
parcelRequire("jSpbe");
var $c7Irs = parcelRequire("c7Irs");
class $a4f7f2e1d87e3b2c$export$20e2c3c1649e1f71 {
    constructor(json){
        this.privSimpleSpeechPhrase = JSON.parse(json);
        this.privSimpleSpeechPhrase.RecognitionStatus = (0, $c7Irs.RecognitionStatus)[this.privSimpleSpeechPhrase.RecognitionStatus];
    }
    static fromJSON(json) {
        return new $a4f7f2e1d87e3b2c$export$20e2c3c1649e1f71(json);
    }
    get RecognitionStatus() {
        return this.privSimpleSpeechPhrase.RecognitionStatus;
    }
    get DisplayText() {
        return this.privSimpleSpeechPhrase.DisplayText;
    }
    get Offset() {
        return this.privSimpleSpeechPhrase.Offset;
    }
    get Duration() {
        return this.privSimpleSpeechPhrase.Duration;
    }
    get Language() {
        return this.privSimpleSpeechPhrase.PrimaryLanguage === undefined ? undefined : this.privSimpleSpeechPhrase.PrimaryLanguage.Language;
    }
    get LanguageDetectionConfidence() {
        return this.privSimpleSpeechPhrase.PrimaryLanguage === undefined ? undefined : this.privSimpleSpeechPhrase.PrimaryLanguage.Confidence;
    }
    get SpeakerId() {
        return this.privSimpleSpeechPhrase.SpeakerId;
    }
}

});

parcelRequire.register("30z0l", function(module, exports) {

$parcel$export(module.exports, "RequestSession", () => $230c865a5f998f71$export$64a8db883c198597);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
parcelRequire("cR8AB");
var $hsGnG = parcelRequire("hsGnG");
var $2YVQf = parcelRequire("2YVQf");
var $4utc3 = parcelRequire("4utc3");

var $3ZhZh = parcelRequire("3ZhZh");

var $dNuTA = parcelRequire("dNuTA");
var $230c865a5f998f71$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
class $230c865a5f998f71$export$64a8db883c198597 {
    constructor(audioSourceId){
        this.privIsDisposed = false;
        this.privDetachables = new Array();
        this.privIsAudioNodeDetached = false;
        this.privIsRecognizing = false;
        this.privIsSpeechEnded = false;
        this.privTurnStartAudioOffset = 0;
        this.privLastRecoOffset = 0;
        this.privHypothesisReceived = false;
        this.privBytesSent = 0;
        this.privRecogNumber = 0;
        this.privInTurn = false;
        this.privConnectionAttempts = 0;
        this.privAudioSourceId = audioSourceId;
        this.privRequestId = (0, $hsGnG.createNoDashGuid)();
        this.privAudioNodeId = (0, $hsGnG.createNoDashGuid)();
        this.privTurnDeferral = new (0, $2YVQf.Deferred)();
        // We're not in a turn, so resolve.
        this.privTurnDeferral.resolve();
    }
    get sessionId() {
        return this.privSessionId;
    }
    get requestId() {
        return this.privRequestId;
    }
    get audioNodeId() {
        return this.privAudioNodeId;
    }
    get turnCompletionPromise() {
        return this.privTurnDeferral.promise;
    }
    get isSpeechEnded() {
        return this.privIsSpeechEnded;
    }
    get isRecognizing() {
        return this.privIsRecognizing;
    }
    get currentTurnAudioOffset() {
        return this.privTurnStartAudioOffset;
    }
    get recogNumber() {
        return this.privRecogNumber;
    }
    get numConnectionAttempts() {
        return this.privConnectionAttempts;
    }
    // The number of bytes sent for the current connection.
    // Counter is reset to 0 each time a connection is established.
    get bytesSent() {
        return this.privBytesSent;
    }
    listenForServiceTelemetry(eventSource) {
        if (!!this.privServiceTelemetryListener) this.privDetachables.push(eventSource.attachListener(this.privServiceTelemetryListener));
    }
    startNewRecognition() {
        this.privIsSpeechEnded = false;
        this.privIsRecognizing = true;
        this.privTurnStartAudioOffset = 0;
        this.privLastRecoOffset = 0;
        this.privRecogNumber++;
        this.privServiceTelemetryListener = new (0, $dNuTA.ServiceTelemetryListener)(this.privRequestId, this.privAudioSourceId, this.privAudioNodeId);
        this.onEvent(new (0, $3ZhZh.RecognitionTriggeredEvent)(this.requestId, this.privSessionId, this.privAudioSourceId, this.privAudioNodeId));
    }
    onAudioSourceAttachCompleted(audioNode, isError) {
        return $230c865a5f998f71$var$__awaiter(this, void 0, void 0, function*() {
            this.privAudioNode = audioNode;
            this.privIsAudioNodeDetached = false;
            if (isError) yield this.onComplete();
            else this.onEvent(new (0, $3ZhZh.ListeningStartedEvent)(this.privRequestId, this.privSessionId, this.privAudioSourceId, this.privAudioNodeId));
        });
    }
    onPreConnectionStart(authFetchEventId, connectionId) {
        this.privAuthFetchEventId = authFetchEventId;
        this.privSessionId = connectionId;
        this.onEvent(new (0, $3ZhZh.ConnectingToServiceEvent)(this.privRequestId, this.privAuthFetchEventId, this.privSessionId));
    }
    onAuthCompleted(isError) {
        return $230c865a5f998f71$var$__awaiter(this, void 0, void 0, function*() {
            if (isError) yield this.onComplete();
        });
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    onConnectionEstablishCompleted(statusCode, reason) {
        return $230c865a5f998f71$var$__awaiter(this, void 0, void 0, function*() {
            if (statusCode === 200) {
                this.onEvent(new (0, $3ZhZh.RecognitionStartedEvent)(this.requestId, this.privAudioSourceId, this.privAudioNodeId, this.privAuthFetchEventId, this.privSessionId));
                if (!!this.privAudioNode) this.privAudioNode.replay();
                this.privTurnStartAudioOffset = this.privLastRecoOffset;
                this.privBytesSent = 0;
                return;
            } else if (statusCode === 403) yield this.onComplete();
        });
    }
    onServiceTurnEndResponse(continuousRecognition) {
        return $230c865a5f998f71$var$__awaiter(this, void 0, void 0, function*() {
            this.privTurnDeferral.resolve();
            if (!continuousRecognition || this.isSpeechEnded) {
                yield this.onComplete();
                this.privInTurn = false;
            } else {
                // Start a new request set.
                this.privTurnStartAudioOffset = this.privLastRecoOffset;
                this.privAudioNode.replay();
            }
        });
    }
    onSpeechContext() {
        this.privRequestId = (0, $hsGnG.createNoDashGuid)();
    }
    onServiceTurnStartResponse() {
        if (!!this.privTurnDeferral && !!this.privInTurn) {
            // What? How are we starting a turn with another not done?
            this.privTurnDeferral.reject("Another turn started before current completed.");
            // Avoid UnhandledPromiseRejection if privTurnDeferral is not being awaited
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            this.privTurnDeferral.promise.then().catch(()=>{});
        }
        this.privInTurn = true;
        this.privTurnDeferral = new (0, $2YVQf.Deferred)();
    }
    onHypothesis(offset) {
        if (!this.privHypothesisReceived) {
            this.privHypothesisReceived = true;
            this.privServiceTelemetryListener.hypothesisReceived(this.privAudioNode.findTimeAtOffset(offset));
        }
    }
    onPhraseRecognized(offset) {
        this.privServiceTelemetryListener.phraseReceived(this.privAudioNode.findTimeAtOffset(offset));
        this.onServiceRecognized(offset);
    }
    onServiceRecognized(offset) {
        this.privLastRecoOffset = offset;
        this.privHypothesisReceived = false;
        this.privAudioNode.shrinkBuffers(offset);
        this.privConnectionAttempts = 0;
    }
    onAudioSent(bytesSent) {
        this.privBytesSent += bytesSent;
    }
    onRetryConnection() {
        this.privConnectionAttempts++;
    }
    dispose() {
        return $230c865a5f998f71$var$__awaiter(this, void 0, void 0, function*() {
            if (!this.privIsDisposed) {
                // we should have completed by now. If we did not its an unknown error.
                this.privIsDisposed = true;
                for (const detachable of this.privDetachables)yield detachable.detach();
                if (!!this.privServiceTelemetryListener) this.privServiceTelemetryListener.dispose();
                this.privIsRecognizing = false;
            }
        });
    }
    getTelemetry() {
        if (this.privServiceTelemetryListener.hasTelemetry) return this.privServiceTelemetryListener.getTelemetry();
        else return null;
    }
    onStopRecognizing() {
        return $230c865a5f998f71$var$__awaiter(this, void 0, void 0, function*() {
            yield this.onComplete();
        });
    }
    // Should be called with the audioNode for this session has indicated that it is out of speech.
    onSpeechEnded() {
        this.privIsSpeechEnded = true;
    }
    onEvent(event) {
        if (!!this.privServiceTelemetryListener) this.privServiceTelemetryListener.onEvent(event);
        (0, $4utc3.Events).instance.onEvent(event);
    }
    onComplete() {
        return $230c865a5f998f71$var$__awaiter(this, void 0, void 0, function*() {
            if (!!this.privIsRecognizing) {
                this.privIsRecognizing = false;
                yield this.detachAudioNode();
            }
        });
    }
    detachAudioNode() {
        return $230c865a5f998f71$var$__awaiter(this, void 0, void 0, function*() {
            if (!this.privIsAudioNodeDetached) {
                this.privIsAudioNodeDetached = true;
                if (this.privAudioNode) yield this.privAudioNode.detach();
            }
        });
    }
}

});
parcelRequire.register("3ZhZh", function(module, exports) {

$parcel$export(module.exports, "RecognitionTriggeredEvent", () => $2e750582d4abeb0f$export$5a7a93aa45921175);
$parcel$export(module.exports, "ListeningStartedEvent", () => $2e750582d4abeb0f$export$4093ad2c899cda43);
$parcel$export(module.exports, "ConnectingToServiceEvent", () => $2e750582d4abeb0f$export$beef32cc459c1496);
$parcel$export(module.exports, "RecognitionStartedEvent", () => $2e750582d4abeb0f$export$32b70f34e60833d0);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
/* eslint-disable max-classes-per-file */ parcelRequire("cR8AB");
var $6yPtW = parcelRequire("6yPtW");
class $2e750582d4abeb0f$export$2faa991ee52d1699 extends (0, $6yPtW.PlatformEvent) {
    constructor(eventName, requestId, sessionId, eventType = (0, $6yPtW.EventType).Info){
        super(eventName, eventType);
        this.privRequestId = requestId;
        this.privSessionId = sessionId;
    }
    get requestId() {
        return this.privRequestId;
    }
    get sessionId() {
        return this.privSessionId;
    }
}
class $2e750582d4abeb0f$export$5a7a93aa45921175 extends $2e750582d4abeb0f$export$2faa991ee52d1699 {
    constructor(requestId, sessionId, audioSourceId, audioNodeId){
        super("RecognitionTriggeredEvent", requestId, sessionId);
        this.privAudioSourceId = audioSourceId;
        this.privAudioNodeId = audioNodeId;
    }
    get audioSourceId() {
        return this.privAudioSourceId;
    }
    get audioNodeId() {
        return this.privAudioNodeId;
    }
}
class $2e750582d4abeb0f$export$4093ad2c899cda43 extends $2e750582d4abeb0f$export$2faa991ee52d1699 {
    constructor(requestId, sessionId, audioSourceId, audioNodeId){
        super("ListeningStartedEvent", requestId, sessionId);
        this.privAudioSourceId = audioSourceId;
        this.privAudioNodeId = audioNodeId;
    }
    get audioSourceId() {
        return this.privAudioSourceId;
    }
    get audioNodeId() {
        return this.privAudioNodeId;
    }
}
class $2e750582d4abeb0f$export$beef32cc459c1496 extends $2e750582d4abeb0f$export$2faa991ee52d1699 {
    constructor(requestId, authFetchEventid, sessionId){
        super("ConnectingToServiceEvent", requestId, sessionId);
        this.privAuthFetchEventid = authFetchEventid;
    }
    get authFetchEventid() {
        return this.privAuthFetchEventid;
    }
}
class $2e750582d4abeb0f$export$32b70f34e60833d0 extends $2e750582d4abeb0f$export$2faa991ee52d1699 {
    constructor(requestId, audioSourceId, audioNodeId, authFetchEventId, sessionId){
        super("RecognitionStartedEvent", requestId, sessionId);
        this.privAudioSourceId = audioSourceId;
        this.privAudioNodeId = audioNodeId;
        this.privAuthFetchEventId = authFetchEventId;
    }
    get audioSourceId() {
        return this.privAudioSourceId;
    }
    get audioNodeId() {
        return this.privAudioNodeId;
    }
    get authFetchEventId() {
        return this.privAuthFetchEventId;
    }
}
var $2e750582d4abeb0f$export$ed6cf71006422f40;
(function(RecognitionCompletionStatus) {
    RecognitionCompletionStatus[RecognitionCompletionStatus["Success"] = 0] = "Success";
    RecognitionCompletionStatus[RecognitionCompletionStatus["AudioSourceError"] = 1] = "AudioSourceError";
    RecognitionCompletionStatus[RecognitionCompletionStatus["AudioSourceTimeout"] = 2] = "AudioSourceTimeout";
    RecognitionCompletionStatus[RecognitionCompletionStatus["AuthTokenFetchError"] = 3] = "AuthTokenFetchError";
    RecognitionCompletionStatus[RecognitionCompletionStatus["AuthTokenFetchTimeout"] = 4] = "AuthTokenFetchTimeout";
    RecognitionCompletionStatus[RecognitionCompletionStatus["UnAuthorized"] = 5] = "UnAuthorized";
    RecognitionCompletionStatus[RecognitionCompletionStatus["ConnectTimeout"] = 6] = "ConnectTimeout";
    RecognitionCompletionStatus[RecognitionCompletionStatus["ConnectError"] = 7] = "ConnectError";
    RecognitionCompletionStatus[RecognitionCompletionStatus["ClientRecognitionActivityTimeout"] = 8] = "ClientRecognitionActivityTimeout";
    RecognitionCompletionStatus[RecognitionCompletionStatus["UnknownError"] = 9] = "UnknownError";
})($2e750582d4abeb0f$export$ed6cf71006422f40 || ($2e750582d4abeb0f$export$ed6cf71006422f40 = {}));
class $2e750582d4abeb0f$export$8de1ba0528dc7861 extends $2e750582d4abeb0f$export$2faa991ee52d1699 {
    constructor(requestId, audioSourceId, audioNodeId, authFetchEventId, sessionId, serviceTag, status, error){
        super("RecognitionEndedEvent", requestId, sessionId, status === $2e750582d4abeb0f$export$ed6cf71006422f40.Success ? (0, $6yPtW.EventType).Info : (0, $6yPtW.EventType).Error);
        this.privAudioSourceId = audioSourceId;
        this.privAudioNodeId = audioNodeId;
        this.privAuthFetchEventId = authFetchEventId;
        this.privStatus = status;
        this.privError = error;
        this.privServiceTag = serviceTag;
    }
    get audioSourceId() {
        return this.privAudioSourceId;
    }
    get audioNodeId() {
        return this.privAudioNodeId;
    }
    get authFetchEventId() {
        return this.privAuthFetchEventId;
    }
    get serviceTag() {
        return this.privServiceTag;
    }
    get status() {
        return this.privStatus;
    }
    get error() {
        return this.privError;
    }
}

});

parcelRequire.register("dNuTA", function(module, exports) {

$parcel$export(module.exports, "ServiceTelemetryListener", () => $a0b7d12d2d222c6d$export$12a36cb0f88ffb8d);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
/* eslint-disable max-classes-per-file */ parcelRequire("cR8AB");
var $bqySL = parcelRequire("bqySL");
var $ieLRH = parcelRequire("ieLRH");

var $3ZhZh = parcelRequire("3ZhZh");
class $a0b7d12d2d222c6d$export$12a36cb0f88ffb8d {
    constructor(requestId, audioSourceId, audioNodeId){
        this.privIsDisposed = false;
        this.privListeningTriggerMetric = null;
        this.privMicMetric = null;
        this.privConnectionEstablishMetric = null;
        this.privRequestId = requestId;
        this.privAudioSourceId = audioSourceId;
        this.privAudioNodeId = audioNodeId;
        this.privReceivedMessages = {};
        this.privPhraseLatencies = [];
        this.privHypothesisLatencies = [];
    }
    phraseReceived(audioReceivedTime) {
        if (audioReceivedTime > 0) this.privPhraseLatencies.push(Date.now() - audioReceivedTime);
    }
    hypothesisReceived(audioReceivedTime) {
        if (audioReceivedTime > 0) this.privHypothesisLatencies.push(Date.now() - audioReceivedTime);
    }
    onEvent(e) {
        if (this.privIsDisposed) return;
        if (e instanceof (0, $3ZhZh.RecognitionTriggeredEvent) && e.requestId === this.privRequestId) this.privListeningTriggerMetric = {
            End: e.eventTime,
            Name: "ListeningTrigger",
            Start: e.eventTime
        };
        if (e instanceof (0, $bqySL.AudioStreamNodeAttachingEvent) && e.audioSourceId === this.privAudioSourceId && e.audioNodeId === this.privAudioNodeId) this.privMicStartTime = e.eventTime;
        if (e instanceof (0, $bqySL.AudioStreamNodeAttachedEvent) && e.audioSourceId === this.privAudioSourceId && e.audioNodeId === this.privAudioNodeId) this.privMicStartTime = e.eventTime;
        if (e instanceof (0, $bqySL.AudioSourceErrorEvent) && e.audioSourceId === this.privAudioSourceId) {
            if (!this.privMicMetric) this.privMicMetric = {
                End: e.eventTime,
                Error: e.error,
                Name: "Microphone",
                Start: this.privMicStartTime
            };
        }
        if (e instanceof (0, $bqySL.AudioStreamNodeErrorEvent) && e.audioSourceId === this.privAudioSourceId && e.audioNodeId === this.privAudioNodeId) {
            if (!this.privMicMetric) this.privMicMetric = {
                End: e.eventTime,
                Error: e.error,
                Name: "Microphone",
                Start: this.privMicStartTime
            };
        }
        if (e instanceof (0, $bqySL.AudioStreamNodeDetachedEvent) && e.audioSourceId === this.privAudioSourceId && e.audioNodeId === this.privAudioNodeId) {
            if (!this.privMicMetric) this.privMicMetric = {
                End: e.eventTime,
                Name: "Microphone",
                Start: this.privMicStartTime
            };
        }
        if (e instanceof (0, $3ZhZh.ConnectingToServiceEvent) && e.requestId === this.privRequestId) this.privConnectionId = e.sessionId;
        if (e instanceof (0, $ieLRH.ConnectionStartEvent) && e.connectionId === this.privConnectionId) this.privConnectionStartTime = e.eventTime;
        if (e instanceof (0, $ieLRH.ConnectionEstablishedEvent) && e.connectionId === this.privConnectionId) {
            if (!this.privConnectionEstablishMetric) this.privConnectionEstablishMetric = {
                End: e.eventTime,
                Id: this.privConnectionId,
                Name: "Connection",
                Start: this.privConnectionStartTime
            };
        }
        if (e instanceof (0, $ieLRH.ConnectionEstablishErrorEvent) && e.connectionId === this.privConnectionId) {
            if (!this.privConnectionEstablishMetric) this.privConnectionEstablishMetric = {
                End: e.eventTime,
                Error: this.getConnectionError(e.statusCode),
                Id: this.privConnectionId,
                Name: "Connection",
                Start: this.privConnectionStartTime
            };
        }
        if (e instanceof (0, $ieLRH.ConnectionMessageReceivedEvent) && e.connectionId === this.privConnectionId) {
            if (e.message && e.message.headers && e.message.headers.path) {
                if (!this.privReceivedMessages[e.message.headers.path]) this.privReceivedMessages[e.message.headers.path] = new Array();
                const maxMessagesToSend = 50;
                if (this.privReceivedMessages[e.message.headers.path].length < maxMessagesToSend) this.privReceivedMessages[e.message.headers.path].push(e.networkReceivedTime);
            }
        }
    }
    getTelemetry() {
        const metrics = new Array();
        if (this.privListeningTriggerMetric) metrics.push(this.privListeningTriggerMetric);
        if (this.privMicMetric) metrics.push(this.privMicMetric);
        if (this.privConnectionEstablishMetric) metrics.push(this.privConnectionEstablishMetric);
        if (this.privPhraseLatencies.length > 0) metrics.push({
            PhraseLatencyMs: this.privPhraseLatencies
        });
        if (this.privHypothesisLatencies.length > 0) metrics.push({
            FirstHypothesisLatencyMs: this.privHypothesisLatencies
        });
        const telemetry = {
            Metrics: metrics,
            ReceivedMessages: this.privReceivedMessages
        };
        const json = JSON.stringify(telemetry);
        // We dont want to send the same telemetry again. So clean those out.
        this.privReceivedMessages = {};
        this.privListeningTriggerMetric = null;
        this.privMicMetric = null;
        this.privConnectionEstablishMetric = null;
        this.privPhraseLatencies = [];
        this.privHypothesisLatencies = [];
        return json;
    }
    // Determines if there are any telemetry events to send to the service.
    get hasTelemetry() {
        return Object.keys(this.privReceivedMessages).length !== 0 || this.privListeningTriggerMetric !== null || this.privMicMetric !== null || this.privConnectionEstablishMetric !== null || this.privPhraseLatencies.length !== 0 || this.privHypothesisLatencies.length !== 0;
    }
    dispose() {
        this.privIsDisposed = true;
    }
    getConnectionError(statusCode) {
        /*
        -- Websocket status codes --
        NormalClosure = 1000,
        EndpointUnavailable = 1001,
        ProtocolError = 1002,
        InvalidMessageType = 1003,
        Empty = 1005,
        InvalidPayloadData = 1007,
        PolicyViolation = 1008,
        MessageTooBig = 1009,
        MandatoryExtension = 1010,
        InternalServerError = 1011
        */ switch(statusCode){
            case 400:
            case 1002:
            case 1003:
            case 1005:
            case 1007:
            case 1008:
            case 1009:
                return "BadRequest";
            case 401:
                return "Unauthorized";
            case 403:
                return "Forbidden";
            case 503:
            case 1001:
                return "ServerUnavailable";
            case 500:
            case 1011:
                return "ServerError";
            case 408:
            case 504:
                return "Timeout";
            default:
                return "statuscode:" + statusCode.toString();
        }
    }
}

});


parcelRequire.register("3AOeU", function(module, exports) {

$parcel$export(module.exports, "SpeechContext", () => $29dbb46ba811f11f$export$11ed12a49459a250);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
/**
 * Represents the JSON used in the speech.context message sent to the speech service.
 * The dynamic grammar is always refreshed from the encapsulated dynamic grammar object.
 */ class $29dbb46ba811f11f$export$11ed12a49459a250 {
    constructor(dynamicGrammar){
        this.privContext = {};
        this.privDynamicGrammar = dynamicGrammar;
    }
    /**
     * Gets a section of the speech.context object.
     * @param sectionName Name of the section to get.
     * @return string or Context JSON serializable object that represents the value.
     */ getSection(sectionName) {
        return this.privContext[sectionName] || {};
    }
    /**
     * Adds a section to the speech.context object.
     * @param sectionName Name of the section to add.
     * @param value JSON serializable object that represents the value.
     */ setSection(sectionName, value) {
        this.privContext[sectionName] = value;
    }
    /**
     * @Internal
     * This is only used by pronunciation assessment config.
     * Do not use externally, object returned will change without warning or notice.
     */ setPronunciationAssessmentParams(params) {
        if (this.privContext.phraseDetection === undefined) this.privContext.phraseDetection = {
            enrichment: {
                pronunciationAssessment: {}
            }
        };
        this.privContext.phraseDetection.enrichment.pronunciationAssessment = JSON.parse(params);
        this.setWordLevelTimings();
        this.privContext.phraseOutput.detailed.options.push("PronunciationAssessment");
        if (this.privContext.phraseOutput.detailed.options.indexOf("SNR") === -1) this.privContext.phraseOutput.detailed.options.push("SNR");
    }
    setWordLevelTimings() {
        if (this.privContext.phraseOutput === undefined) this.privContext.phraseOutput = {
            detailed: {
                options: []
            },
            format: {}
        };
        if (this.privContext.phraseOutput.detailed === undefined) this.privContext.phraseOutput.detailed = {
            options: []
        };
        this.privContext.phraseOutput.format = "Detailed";
        if (this.privContext.phraseOutput.detailed.options.indexOf("WordTimings") === -1) this.privContext.phraseOutput.detailed.options.push("WordTimings");
    }
    toJSON() {
        const dgi = this.privDynamicGrammar.generateGrammarObject();
        this.setSection("dgi", dgi);
        const ret = JSON.stringify(this.privContext);
        return ret;
    }
}

});

parcelRequire.register("a1SmT", function(module, exports) {

$parcel$export(module.exports, "DynamicGrammarBuilder", () => $74d42bc6ee0d9b5a$export$feefa659188a6539);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
/**
 * Responsible for building the object to be sent to the speech service to support dynamic grammars.
 * @class DynamicGrammarBuilder
 */ class $74d42bc6ee0d9b5a$export$feefa659188a6539 {
    // Adds one more reference phrases to the dynamic grammar to send.
    // All added phrases are generic phrases.
    addPhrase(phrase) {
        if (!this.privPhrases) this.privPhrases = [];
        if (phrase instanceof Array) this.privPhrases = this.privPhrases.concat(phrase);
        else this.privPhrases.push(phrase);
    }
    // Clears all phrases stored in the current object.
    clearPhrases() {
        this.privPhrases = undefined;
    }
    // Adds one or more reference grammars to the current grammar.
    addReferenceGrammar(grammar) {
        if (!this.privGrammars) this.privGrammars = [];
        if (grammar instanceof Array) this.privGrammars = this.privGrammars.concat(grammar);
        else this.privGrammars.push(grammar);
    }
    // clears all grammars stored on the recognizer.
    clearGrammars() {
        this.privGrammars = undefined;
    }
    // Generates an object that represents the dynamic grammar used by the Speech Service.
    // This is done by building an object with the correct layout based on the phrases and reference grammars added to this instance
    // of a DynamicGrammarBuilder
    generateGrammarObject() {
        if (this.privGrammars === undefined && this.privPhrases === undefined) return undefined;
        const retObj = {};
        retObj.ReferenceGrammars = this.privGrammars;
        if (undefined !== this.privPhrases && 0 !== this.privPhrases.length) {
            const retPhrases = [];
            this.privPhrases.forEach((value)=>{
                retPhrases.push({
                    Text: value
                });
            });
            retObj.Groups = [
                {
                    Type: "Generic",
                    Items: retPhrases
                }
            ];
        }
        return retObj;
    }
}

});

parcelRequire.register("iEXXa", function(module, exports) {
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
parcelRequire("2iayq");
var $6RE4c = parcelRequire("6RE4c");

var $h7OH2 = parcelRequire("h7OH2");
parcelRequire("cR8AB");
var $dxrNf = parcelRequire("dxrNf");
var $hsGnG = parcelRequire("hsGnG");
var $jQZQm = parcelRequire("jQZQm");
var $2YVQf = parcelRequire("2YVQf");
var $ieLRH = parcelRequire("ieLRH");
var $4utc3 = parcelRequire("4utc3");
var $3qWVN = parcelRequire("3qWVN");

var $gFkNt = parcelRequire("gFkNt");

var $kNh7Z = parcelRequire("kNh7Z");
var $lnpwm = parcelRequire("lnpwm");
var $5idXV = parcelRequire("5idXV");
var $bHuZw = parcelRequire("bHuZw");
var $3fCi1 = parcelRequire("3fCi1");
var $bjdWp = parcelRequire("bjdWp");
var $eylh7 = parcelRequire("eylh7");
var $9Wq4L = parcelRequire("9Wq4L");
var $daYNc = parcelRequire("daYNc");
var $13q8D = parcelRequire("13q8D");
var $6Pkpi = parcelRequire("6Pkpi");
var $fmH2B = parcelRequire("fmH2B");
var $fT2Hj = parcelRequire("fT2Hj");

var $aFrAz = parcelRequire("aFrAz");
parcelRequire("jSpbe");
var $ea7Fz = parcelRequire("ea7Fz");
var $c7Irs = parcelRequire("c7Irs");
var $i1ulX = parcelRequire("i1ulX");
var $1Anur = parcelRequire("1Anur");
var $jSpbe = parcelRequire("jSpbe");
var $gdyuc = parcelRequire("gdyuc");
var $iBWCB = parcelRequire("iBWCB");
var $je076 = parcelRequire("je076");

var $9ly0x = parcelRequire("9ly0x");

var $l4rU0 = parcelRequire("l4rU0");
var $d95a77e342fe3177$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
class $d95a77e342fe3177$export$6c74c1d33ebaa2d2 extends (0, $je076.ServiceRecognizerBase) {
    constructor(authentication, connectionFactory, audioSource, recognizerConfig, dialogServiceConnector){
        super(authentication, connectionFactory, audioSource, recognizerConfig, dialogServiceConnector);
        this.privEvents = new (0, $dxrNf.EventSource)();
        this.privDialogServiceConnector = dialogServiceConnector;
        this.receiveMessageOverride = ()=>this.receiveDialogMessageOverride();
        this.privTurnStateManager = new (0, $aFrAz.DialogServiceTurnStateManager)();
        this.recognizeOverride = (recoMode, successCallback, errorCallback)=>this.listenOnce(recoMode, successCallback, errorCallback);
        this.postConnectImplOverride = (connection)=>this.dialogConnectImpl(connection);
        this.configConnectionOverride = (connection)=>this.configConnection(connection);
        this.disconnectOverride = ()=>this.privDisconnect();
        this.privDialogAudioSource = audioSource;
        this.agentConfigSent = false;
        this.privLastResult = null;
        this.connectionEvents.attach((connectionEvent)=>{
            if (connectionEvent.name === "ConnectionClosedEvent") this.terminateMessageLoop = true;
        });
    }
    sendMessage(message) {
        return $d95a77e342fe3177$var$__awaiter(this, void 0, void 0, function*() {
            const interactionGuid = (0, $hsGnG.createGuid)();
            const requestId = (0, $hsGnG.createNoDashGuid)();
            const agentMessage = {
                context: {
                    interactionId: interactionGuid
                },
                // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
                messagePayload: JSON.parse(message),
                version: 0.5
            };
            const agentMessageJson = JSON.stringify(agentMessage);
            const connection = yield this.fetchConnection();
            yield connection.send(new (0, $l4rU0.SpeechConnectionMessage)((0, $jQZQm.MessageType).Text, "agent", requestId, "application/json", agentMessageJson));
        });
    }
    privDisconnect() {
        return $d95a77e342fe3177$var$__awaiter(this, void 0, void 0, function*() {
            yield this.cancelRecognition(this.privRequestSession.sessionId, this.privRequestSession.requestId, (0, $5idXV.CancellationReason).Error, (0, $lnpwm.CancellationErrorCode).NoError, "Disconnecting");
            this.terminateMessageLoop = true;
            this.agentConfigSent = false;
            return;
        });
    }
    processTypeSpecificMessages(connectionMessage) {
        const resultProps = new (0, $3fCi1.PropertyCollection)();
        if (connectionMessage.messageType === (0, $jQZQm.MessageType).Text) resultProps.setProperty((0, $bjdWp.PropertyId).SpeechServiceResponse_JsonResult, connectionMessage.textBody);
        let result;
        let processed;
        switch(connectionMessage.path.toLowerCase()){
            case "speech.phrase":
                const speechPhrase = (0, $ea7Fz.SimpleSpeechPhrase).fromJSON(connectionMessage.textBody);
                this.privRequestSession.onPhraseRecognized(this.privRequestSession.currentTurnAudioOffset + speechPhrase.Offset + speechPhrase.Duration);
                if (speechPhrase.RecognitionStatus !== (0, $c7Irs.RecognitionStatus).TooManyRequests && speechPhrase.RecognitionStatus !== (0, $c7Irs.RecognitionStatus).Error) {
                    const args = this.fireEventForResult(speechPhrase, resultProps);
                    this.privLastResult = args.result;
                    if (!!this.privDialogServiceConnector.recognized) try {
                        this.privDialogServiceConnector.recognized(this.privDialogServiceConnector, args);
                    /* eslint-disable no-empty */ } catch (error) {
                    // Not going to let errors in the event handler
                    // trip things up.
                    }
                }
                processed = true;
                break;
            case "speech.hypothesis":
                const hypothesis = (0, $i1ulX.SpeechHypothesis).fromJSON(connectionMessage.textBody);
                const offset = hypothesis.Offset + this.privRequestSession.currentTurnAudioOffset;
                result = new (0, $fmH2B.SpeechRecognitionResult)(this.privRequestSession.requestId, (0, $9Wq4L.ResultReason).RecognizingSpeech, hypothesis.Text, hypothesis.Duration, offset, hypothesis.Language, hypothesis.LanguageDetectionConfidence, undefined, undefined, connectionMessage.textBody, resultProps);
                this.privRequestSession.onHypothesis(offset);
                const ev = new (0, $6Pkpi.SpeechRecognitionEventArgs)(result, hypothesis.Duration, this.privRequestSession.sessionId);
                if (!!this.privDialogServiceConnector.recognizing) try {
                    this.privDialogServiceConnector.recognizing(this.privDialogServiceConnector, ev);
                /* eslint-disable no-empty */ } catch (error) {
                // Not going to let errors in the event handler
                // trip things up.
                }
                processed = true;
                break;
            case "speech.keyword":
                const keyword = (0, $1Anur.SpeechKeyword).fromJSON(connectionMessage.textBody);
                result = new (0, $fmH2B.SpeechRecognitionResult)(this.privRequestSession.requestId, keyword.Status === "Accepted" ? (0, $9Wq4L.ResultReason).RecognizedKeyword : (0, $9Wq4L.ResultReason).NoMatch, keyword.Text, keyword.Duration, keyword.Offset, undefined, undefined, undefined, undefined, connectionMessage.textBody, resultProps);
                if (keyword.Status !== "Accepted") this.privLastResult = result;
                const event = new (0, $6Pkpi.SpeechRecognitionEventArgs)(result, result.duration, result.resultId);
                if (!!this.privDialogServiceConnector.recognized) try {
                    this.privDialogServiceConnector.recognized(this.privDialogServiceConnector, event);
                /* eslint-disable no-empty */ } catch (error) {
                // Not going to let errors in the event handler
                // trip things up.
                }
                processed = true;
                break;
            case "audio":
                {
                    const audioRequestId = connectionMessage.requestId.toUpperCase();
                    const turn = this.privTurnStateManager.GetTurn(audioRequestId);
                    try {
                        // Empty binary message signals end of stream.
                        if (!connectionMessage.binaryBody) turn.endAudioStream();
                        else turn.audioStream.write(connectionMessage.binaryBody);
                    } catch (error) {
                    // Not going to let errors in the event handler
                    // trip things up.
                    }
                }
                processed = true;
                break;
            case "response":
                this.handleResponseMessage(connectionMessage);
                processed = true;
                break;
            default:
                break;
        }
        const defferal = new (0, $2YVQf.Deferred)();
        defferal.resolve(processed);
        return defferal.promise;
    }
    // Cancels recognition.
    cancelRecognition(sessionId, requestId, cancellationReason, errorCode, error) {
        return $d95a77e342fe3177$var$__awaiter(this, void 0, void 0, function*() {
            this.terminateMessageLoop = true;
            if (!!this.privRequestSession.isRecognizing) yield this.privRequestSession.onStopRecognizing();
            if (!!this.privDialogServiceConnector.canceled) {
                const properties = new (0, $3fCi1.PropertyCollection)();
                properties.setProperty((0, $jSpbe.CancellationErrorCodePropertyName), (0, $lnpwm.CancellationErrorCode)[errorCode]);
                const cancelEvent = new (0, $13q8D.SpeechRecognitionCanceledEventArgs)(cancellationReason, error, errorCode, undefined, sessionId);
                try {
                    this.privDialogServiceConnector.canceled(this.privDialogServiceConnector, cancelEvent);
                /* eslint-disable no-empty */ } catch (_a) {}
                if (!!this.privSuccessCallback) {
                    const result = new (0, $fmH2B.SpeechRecognitionResult)(undefined, (0, $9Wq4L.ResultReason).Canceled, undefined, undefined, undefined, undefined, undefined, undefined, error, undefined, properties);
                    try {
                        this.privSuccessCallback(result);
                        this.privSuccessCallback = undefined;
                    /* eslint-disable no-empty */ } catch (_b) {}
                }
            }
        });
    }
    listenOnce(recoMode, successCallback, errorCallback) {
        return $d95a77e342fe3177$var$__awaiter(this, void 0, void 0, function*() {
            this.privRecognizerConfig.recognitionMode = recoMode;
            this.privSuccessCallback = successCallback;
            this.privErrorCallback = errorCallback;
            this.privRequestSession.startNewRecognition();
            this.privRequestSession.listenForServiceTelemetry(this.privDialogAudioSource.events);
            this.privRecognizerConfig.parameters.setProperty((0, $bjdWp.PropertyId).Speech_SessionId, this.privRequestSession.sessionId);
            // Start the connection to the service. The promise this will create is stored and will be used by configureConnection().
            const conPromise = this.connectImpl();
            const preAudioPromise = this.sendPreAudioMessages();
            const node = yield this.privDialogAudioSource.attach(this.privRequestSession.audioNodeId);
            const format = yield this.privDialogAudioSource.format;
            const deviceInfo = yield this.privDialogAudioSource.deviceInfo;
            const audioNode = new (0, $6RE4c.ReplayableAudioNode)(node, format.avgBytesPerSec);
            yield this.privRequestSession.onAudioSourceAttachCompleted(audioNode, false);
            this.privRecognizerConfig.SpeechServiceConfig.Context.audio = {
                source: deviceInfo
            };
            try {
                yield conPromise;
                yield preAudioPromise;
            } catch (error) {
                yield this.cancelRecognition(this.privRequestSession.sessionId, this.privRequestSession.requestId, (0, $5idXV.CancellationReason).Error, (0, $lnpwm.CancellationErrorCode).ConnectionFailure, error);
                return Promise.resolve();
            }
            const sessionStartEventArgs = new (0, $daYNc.SessionEventArgs)(this.privRequestSession.sessionId);
            if (!!this.privRecognizer.sessionStarted) this.privRecognizer.sessionStarted(this.privRecognizer, sessionStartEventArgs);
            const audioSendPromise = this.sendAudio(audioNode);
            // /* eslint-disable no-empty */
            audioSendPromise.then(()=>{}, (error)=>$d95a77e342fe3177$var$__awaiter(this, void 0, void 0, function*() {
                    yield this.cancelRecognition(this.privRequestSession.sessionId, this.privRequestSession.requestId, (0, $5idXV.CancellationReason).Error, (0, $lnpwm.CancellationErrorCode).RuntimeError, error);
                }));
        });
    }
    // Establishes a websocket connection to the end point.
    dialogConnectImpl(connection) {
        this.privConnectionLoop = this.startMessageLoop();
        return connection;
    }
    receiveDialogMessageOverride() {
        // we won't rely on the cascading promises of the connection since we want to continually be available to receive messages
        const communicationCustodian = new (0, $2YVQf.Deferred)();
        const loop = ()=>$d95a77e342fe3177$var$__awaiter(this, void 0, void 0, function*() {
                try {
                    const isDisposed = this.isDisposed();
                    const terminateMessageLoop = !this.isDisposed() && this.terminateMessageLoop;
                    if (isDisposed || terminateMessageLoop) {
                        // We're done.
                        communicationCustodian.resolve(undefined);
                        return;
                    }
                    const connection = yield this.fetchConnection();
                    const message = yield connection.read();
                    if (!message) return loop();
                    const connectionMessage = (0, $l4rU0.SpeechConnectionMessage).fromConnectionMessage(message);
                    switch(connectionMessage.path.toLowerCase()){
                        case "turn.start":
                            {
                                const turnRequestId = connectionMessage.requestId.toUpperCase();
                                const audioSessionReqId = this.privRequestSession.requestId.toUpperCase();
                                // turn started by the service
                                if (turnRequestId !== audioSessionReqId) this.privTurnStateManager.StartTurn(turnRequestId);
                                else this.privRequestSession.onServiceTurnStartResponse();
                            }
                            break;
                        case "speech.startdetected":
                            const speechStartDetected = (0, $gdyuc.SpeechDetected).fromJSON(connectionMessage.textBody);
                            const speechStartEventArgs = new (0, $eylh7.RecognitionEventArgs)(speechStartDetected.Offset, this.privRequestSession.sessionId);
                            if (!!this.privRecognizer.speechStartDetected) this.privRecognizer.speechStartDetected(this.privRecognizer, speechStartEventArgs);
                            break;
                        case "speech.enddetected":
                            let json;
                            if (connectionMessage.textBody.length > 0) json = connectionMessage.textBody;
                            else // If the request was empty, the JSON returned is empty.
                            json = "{ Offset: 0 }";
                            const speechStopDetected = (0, $gdyuc.SpeechDetected).fromJSON(json);
                            this.privRequestSession.onServiceRecognized(speechStopDetected.Offset + this.privRequestSession.currentTurnAudioOffset);
                            const speechStopEventArgs = new (0, $eylh7.RecognitionEventArgs)(speechStopDetected.Offset + this.privRequestSession.currentTurnAudioOffset, this.privRequestSession.sessionId);
                            if (!!this.privRecognizer.speechEndDetected) this.privRecognizer.speechEndDetected(this.privRecognizer, speechStopEventArgs);
                            break;
                        case "turn.end":
                            {
                                const turnEndRequestId = connectionMessage.requestId.toUpperCase();
                                const audioSessionReqId = this.privRequestSession.requestId.toUpperCase();
                                // turn started by the service
                                if (turnEndRequestId !== audioSessionReqId) this.privTurnStateManager.CompleteTurn(turnEndRequestId);
                                else {
                                    // Audio session turn
                                    const sessionStopEventArgs = new (0, $daYNc.SessionEventArgs)(this.privRequestSession.sessionId);
                                    yield this.privRequestSession.onServiceTurnEndResponse(false);
                                    if (!this.privRecognizerConfig.isContinuousRecognition || this.privRequestSession.isSpeechEnded || !this.privRequestSession.isRecognizing) {
                                        if (!!this.privRecognizer.sessionStopped) this.privRecognizer.sessionStopped(this.privRecognizer, sessionStopEventArgs);
                                    }
                                    // report result to promise.
                                    if (!!this.privSuccessCallback && this.privLastResult) {
                                        try {
                                            this.privSuccessCallback(this.privLastResult);
                                            this.privLastResult = null;
                                        } catch (e) {
                                            if (!!this.privErrorCallback) this.privErrorCallback(e);
                                        }
                                        // Only invoke the call back once.
                                        // and if it's successful don't invoke the
                                        // error after that.
                                        this.privSuccessCallback = undefined;
                                        this.privErrorCallback = undefined;
                                    }
                                }
                            }
                            break;
                        default:
                            try {
                                const processed = yield this.processTypeSpecificMessages(connectionMessage);
                                if (!processed) {
                                    if (!!this.serviceEvents) this.serviceEvents.onEvent(new (0, $ieLRH.ServiceEvent)(connectionMessage.path.toLowerCase(), connectionMessage.textBody));
                                }
                            } catch (e) {
                            //
                            }
                    }
                    const ret = loop();
                    return ret;
                } catch (error) {
                    this.terminateMessageLoop = true;
                    communicationCustodian.resolve();
                }
            });
        loop().catch((reason)=>{
            (0, $4utc3.Events).instance.onEvent(new (0, $3qWVN.BackgroundEvent)(reason));
        });
        return communicationCustodian.promise;
    }
    startMessageLoop() {
        return $d95a77e342fe3177$var$__awaiter(this, void 0, void 0, function*() {
            this.terminateMessageLoop = false;
            try {
                yield this.receiveDialogMessageOverride();
            } catch (error) {
                yield this.cancelRecognition(this.privRequestSession.sessionId, this.privRequestSession.requestId, (0, $5idXV.CancellationReason).Error, (0, $lnpwm.CancellationErrorCode).RuntimeError, error);
            }
            return Promise.resolve();
        });
    }
    // Takes an established websocket connection to the endpoint and sends speech configuration information.
    configConnection(connection) {
        return $d95a77e342fe3177$var$__awaiter(this, void 0, void 0, function*() {
            if (this.terminateMessageLoop) {
                this.terminateMessageLoop = false;
                return Promise.reject("Connection to service terminated.");
            }
            yield this.sendSpeechServiceConfig(connection, this.privRequestSession, this.privRecognizerConfig.SpeechServiceConfig.serialize());
            yield this.sendAgentConfig(connection);
            return connection;
        });
    }
    sendPreAudioMessages() {
        return $d95a77e342fe3177$var$__awaiter(this, void 0, void 0, function*() {
            const connection = yield this.fetchConnection();
            this.addKeywordContextData();
            yield this.sendSpeechContext(connection, true);
            yield this.sendAgentContext(connection);
            yield this.sendWaveHeader(connection);
        });
    }
    sendAgentConfig(connection) {
        if (this.agentConfig && !this.agentConfigSent) {
            if (this.privRecognizerConfig.parameters.getProperty((0, $bjdWp.PropertyId).Conversation_DialogType) === (0, $bHuZw.DialogServiceConfig).DialogTypes.CustomCommands) {
                const config = this.agentConfig.get();
                config.botInfo.commandsCulture = this.privRecognizerConfig.parameters.getProperty((0, $bjdWp.PropertyId).SpeechServiceConnection_RecoLanguage, "en-us");
                this.agentConfig.set(config);
            }
            this.onEvent(new (0, $h7OH2.SendingAgentContextMessageEvent)(this.agentConfig));
            const agentConfigJson = this.agentConfig.toJsonString();
            // guard against sending this multiple times on one connection
            this.agentConfigSent = true;
            return connection.send(new (0, $l4rU0.SpeechConnectionMessage)((0, $jQZQm.MessageType).Text, "agent.config", this.privRequestSession.requestId, "application/json", agentConfigJson));
        }
        return;
    }
    sendAgentContext(connection) {
        const guid = (0, $hsGnG.createGuid)();
        const speechActivityTemplate = this.privDialogServiceConnector.properties.getProperty((0, $bjdWp.PropertyId).Conversation_Speech_Activity_Template);
        const agentContext = {
            channelData: "",
            context: {
                interactionId: guid
            },
            messagePayload: speechActivityTemplate,
            version: 0.5
        };
        const agentContextJson = JSON.stringify(agentContext);
        return connection.send(new (0, $l4rU0.SpeechConnectionMessage)((0, $jQZQm.MessageType).Text, "speech.agent.context", this.privRequestSession.requestId, "application/json", agentContextJson));
    }
    fireEventForResult(serviceResult, properties) {
        const resultReason = (0, $iBWCB.EnumTranslation).implTranslateRecognitionResult(serviceResult.RecognitionStatus);
        const offset = serviceResult.Offset + this.privRequestSession.currentTurnAudioOffset;
        const result = new (0, $fmH2B.SpeechRecognitionResult)(this.privRequestSession.requestId, resultReason, serviceResult.DisplayText, serviceResult.Duration, offset, serviceResult.Language, serviceResult.LanguageDetectionConfidence, undefined, undefined, JSON.stringify(serviceResult), properties);
        const ev = new (0, $6Pkpi.SpeechRecognitionEventArgs)(result, offset, this.privRequestSession.sessionId);
        return ev;
    }
    handleResponseMessage(responseMessage) {
        // "response" messages can contain either "message" (activity) or "MessageStatus" data. Fire the appropriate
        // event according to the message type that's specified.
        const responsePayload = JSON.parse(responseMessage.textBody);
        switch(responsePayload.messageType.toLowerCase()){
            case "message":
                const responseRequestId = responseMessage.requestId.toUpperCase();
                const activityPayload = (0, $9ly0x.ActivityPayloadResponse).fromJSON(responseMessage.textBody);
                const turn = this.privTurnStateManager.GetTurn(responseRequestId);
                // update the conversation Id
                if (activityPayload.conversationId) {
                    const updateAgentConfig = this.agentConfig.get();
                    updateAgentConfig.botInfo.conversationId = activityPayload.conversationId;
                    this.agentConfig.set(updateAgentConfig);
                }
                const pullAudioOutputStream = turn.processActivityPayload(activityPayload, (0, $gFkNt.AudioOutputFormatImpl).fromSpeechSynthesisOutputFormatString(this.privDialogServiceConnector.properties.getProperty((0, $bjdWp.PropertyId).SpeechServiceConnection_SynthOutputFormat, undefined)));
                const activity = new (0, $kNh7Z.ActivityReceivedEventArgs)(activityPayload.messagePayload, pullAudioOutputStream);
                if (!!this.privDialogServiceConnector.activityReceived) try {
                    this.privDialogServiceConnector.activityReceived(this.privDialogServiceConnector, activity);
                /* eslint-disable-next-line no-empty */ } catch (error) {
                // Not going to let errors in the event handler
                // trip things up.
                }
                break;
            case "messagestatus":
                if (!!this.privDialogServiceConnector.turnStatusReceived) try {
                    this.privDialogServiceConnector.turnStatusReceived(this.privDialogServiceConnector, new (0, $fT2Hj.TurnStatusReceivedEventArgs)(responseMessage.textBody));
                /* eslint-disable-next-line no-empty */ } catch (error) {
                // Not going to let errors in the event handler
                // trip things up.
                }
                break;
            default:
                (0, $4utc3.Events).instance.onEvent(new (0, $3qWVN.BackgroundEvent)(`Unexpected response of type ${responsePayload.messageType}. Ignoring.`));
                break;
        }
    }
    onEvent(event) {
        this.privEvents.onEvent(event);
        (0, $4utc3.Events).instance.onEvent(event);
    }
    addKeywordContextData() {
        const keywordPropertyValue = this.privRecognizerConfig.parameters.getProperty("SPEECH-KeywordsToDetect");
        if (keywordPropertyValue === undefined) return;
        const keywordOffsetPropertyValue = this.privRecognizerConfig.parameters.getProperty("SPEECH-KeywordsToDetect-Offsets");
        const keywordDurationPropertyValue = this.privRecognizerConfig.parameters.getProperty("SPEECH-KeywordsToDetect-Durations");
        const keywords = keywordPropertyValue.split(";");
        const keywordOffsets = keywordOffsetPropertyValue === undefined ? [] : keywordOffsetPropertyValue.split(";");
        const keywordDurations = keywordDurationPropertyValue === undefined ? [] : keywordDurationPropertyValue.split(";");
        const keywordDefinitionArray = [];
        for(let i = 0; i < keywords.length; i++){
            const definition = {};
            definition.text = keywords[i];
            if (i < keywordOffsets.length) definition.offset = Number(keywordOffsets[i]);
            if (i < keywordDurations.length) definition.duration = Number(keywordDurations[i]);
            keywordDefinitionArray.push(definition);
        }
        this.speechContext.setSection("invocationSource", "VoiceActivationWithKeyword");
        this.speechContext.setSection("keywordDetection", [
            {
                clientDetectedKeywords: keywordDefinitionArray,
                onReject: {
                    action: "EndOfTurn"
                },
                type: "startTrigger"
            }
        ]);
    }
}

});
parcelRequire.register("h7OH2", function(module, exports) {

$parcel$export(module.exports, "SendingAgentContextMessageEvent", () => $c77a69b781fb9f7c$export$7ea279b2e8f18604);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.

var $6yPtW = parcelRequire("6yPtW");
class $c77a69b781fb9f7c$export$8c08a5d7274b175d extends (0, $6yPtW.PlatformEvent) {
    constructor(eventName, eventType = (0, $6yPtW.EventType).Info){
        super(eventName, eventType);
    }
}
class $c77a69b781fb9f7c$export$7ea279b2e8f18604 extends $c77a69b781fb9f7c$export$8c08a5d7274b175d {
    constructor(agentConfig){
        super("SendingAgentContextMessageEvent");
        this.privAgentConfig = agentConfig;
    }
    get agentConfig() {
        return this.privAgentConfig;
    }
}

});

parcelRequire.register("gFkNt", function(module, exports) {

$parcel$export(module.exports, "AudioOutputFormatImpl", () => $03218ee542c620c9$export$53c5e8ad1050e453);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.

var $cyJfF = parcelRequire("cyJfF");

var $6489m = parcelRequire("6489m");
class $03218ee542c620c9$export$53c5e8ad1050e453 extends (0, $6489m.AudioStreamFormatImpl) {
    /**
     * Creates an instance with the given values.
     * @constructor
     * @param formatTag
     * @param {number} channels - Number of channels.
     * @param {number} samplesPerSec - Samples per second.
     * @param {number} avgBytesPerSec - Average bytes per second.
     * @param {number} blockAlign - Block alignment.
     * @param {number} bitsPerSample - Bits per sample.
     * @param {string} audioFormatString - Audio format string
     * @param {string} requestAudioFormatString - Audio format string sent to service.
     * @param {boolean} hasHeader - If the format has header or not.
     */ constructor(formatTag, channels, samplesPerSec, avgBytesPerSec, blockAlign, bitsPerSample, audioFormatString, requestAudioFormatString, hasHeader){
        super(samplesPerSec, bitsPerSample, channels, formatTag);
        this.formatTag = formatTag;
        this.avgBytesPerSec = avgBytesPerSec;
        this.blockAlign = blockAlign;
        this.priAudioFormatString = audioFormatString;
        this.priRequestAudioFormatString = requestAudioFormatString;
        this.priHasHeader = hasHeader;
    }
    static fromSpeechSynthesisOutputFormat(speechSynthesisOutputFormat) {
        if (speechSynthesisOutputFormat === undefined) return $03218ee542c620c9$export$53c5e8ad1050e453.getDefaultOutputFormat();
        return $03218ee542c620c9$export$53c5e8ad1050e453.fromSpeechSynthesisOutputFormatString($03218ee542c620c9$export$53c5e8ad1050e453.SpeechSynthesisOutputFormatToString[speechSynthesisOutputFormat]);
    }
    static fromSpeechSynthesisOutputFormatString(speechSynthesisOutputFormatString) {
        switch(speechSynthesisOutputFormatString){
            case "raw-8khz-8bit-mono-mulaw":
                return new $03218ee542c620c9$export$53c5e8ad1050e453((0, $6489m.AudioFormatTag).MuLaw, 1, 8000, 8000, 1, 8, speechSynthesisOutputFormatString, speechSynthesisOutputFormatString, false);
            case "riff-16khz-16kbps-mono-siren":
                return new $03218ee542c620c9$export$53c5e8ad1050e453((0, $6489m.AudioFormatTag).Siren, 1, 16000, 2000, 40, 0, speechSynthesisOutputFormatString, "audio-16khz-16kbps-mono-siren", true);
            case "audio-16khz-16kbps-mono-siren":
                return new $03218ee542c620c9$export$53c5e8ad1050e453((0, $6489m.AudioFormatTag).Siren, 1, 16000, 2000, 40, 0, speechSynthesisOutputFormatString, speechSynthesisOutputFormatString, false);
            case "audio-16khz-32kbitrate-mono-mp3":
                return new $03218ee542c620c9$export$53c5e8ad1050e453((0, $6489m.AudioFormatTag).MP3, 1, 16000, 4096, 2, 16, speechSynthesisOutputFormatString, speechSynthesisOutputFormatString, false);
            case "audio-16khz-128kbitrate-mono-mp3":
                return new $03218ee542c620c9$export$53c5e8ad1050e453((0, $6489m.AudioFormatTag).MP3, 1, 16000, 16384, 2, 16, speechSynthesisOutputFormatString, speechSynthesisOutputFormatString, false);
            case "audio-16khz-64kbitrate-mono-mp3":
                return new $03218ee542c620c9$export$53c5e8ad1050e453((0, $6489m.AudioFormatTag).MP3, 1, 16000, 8192, 2, 16, speechSynthesisOutputFormatString, speechSynthesisOutputFormatString, false);
            case "audio-24khz-48kbitrate-mono-mp3":
                return new $03218ee542c620c9$export$53c5e8ad1050e453((0, $6489m.AudioFormatTag).MP3, 1, 24000, 6144, 2, 16, speechSynthesisOutputFormatString, speechSynthesisOutputFormatString, false);
            case "audio-24khz-96kbitrate-mono-mp3":
                return new $03218ee542c620c9$export$53c5e8ad1050e453((0, $6489m.AudioFormatTag).MP3, 1, 24000, 12288, 2, 16, speechSynthesisOutputFormatString, speechSynthesisOutputFormatString, false);
            case "audio-24khz-160kbitrate-mono-mp3":
                return new $03218ee542c620c9$export$53c5e8ad1050e453((0, $6489m.AudioFormatTag).MP3, 1, 24000, 20480, 2, 16, speechSynthesisOutputFormatString, speechSynthesisOutputFormatString, false);
            case "raw-16khz-16bit-mono-truesilk":
                return new $03218ee542c620c9$export$53c5e8ad1050e453((0, $6489m.AudioFormatTag).SILKSkype, 1, 16000, 32000, 2, 16, speechSynthesisOutputFormatString, speechSynthesisOutputFormatString, false);
            case "riff-8khz-16bit-mono-pcm":
                return new $03218ee542c620c9$export$53c5e8ad1050e453((0, $6489m.AudioFormatTag).PCM, 1, 8000, 16000, 2, 16, speechSynthesisOutputFormatString, "raw-8khz-16bit-mono-pcm", true);
            case "riff-24khz-16bit-mono-pcm":
                return new $03218ee542c620c9$export$53c5e8ad1050e453((0, $6489m.AudioFormatTag).PCM, 1, 24000, 48000, 2, 16, speechSynthesisOutputFormatString, "raw-24khz-16bit-mono-pcm", true);
            case "riff-8khz-8bit-mono-mulaw":
                return new $03218ee542c620c9$export$53c5e8ad1050e453((0, $6489m.AudioFormatTag).MuLaw, 1, 8000, 8000, 1, 8, speechSynthesisOutputFormatString, "raw-8khz-8bit-mono-mulaw", true);
            case "raw-16khz-16bit-mono-pcm":
                return new $03218ee542c620c9$export$53c5e8ad1050e453((0, $6489m.AudioFormatTag).PCM, 1, 16000, 32000, 2, 16, speechSynthesisOutputFormatString, "raw-16khz-16bit-mono-pcm", false);
            case "raw-24khz-16bit-mono-pcm":
                return new $03218ee542c620c9$export$53c5e8ad1050e453((0, $6489m.AudioFormatTag).PCM, 1, 24000, 48000, 2, 16, speechSynthesisOutputFormatString, "raw-24khz-16bit-mono-pcm", false);
            case "raw-8khz-16bit-mono-pcm":
                return new $03218ee542c620c9$export$53c5e8ad1050e453((0, $6489m.AudioFormatTag).PCM, 1, 8000, 16000, 2, 16, speechSynthesisOutputFormatString, "raw-8khz-16bit-mono-pcm", false);
            case "ogg-16khz-16bit-mono-opus":
                return new $03218ee542c620c9$export$53c5e8ad1050e453((0, $6489m.AudioFormatTag).OGG_OPUS, 1, 16000, 8192, 2, 16, speechSynthesisOutputFormatString, speechSynthesisOutputFormatString, false);
            case "ogg-24khz-16bit-mono-opus":
                return new $03218ee542c620c9$export$53c5e8ad1050e453((0, $6489m.AudioFormatTag).OGG_OPUS, 1, 24000, 8192, 2, 16, speechSynthesisOutputFormatString, speechSynthesisOutputFormatString, false);
            case "raw-48khz-16bit-mono-pcm":
                return new $03218ee542c620c9$export$53c5e8ad1050e453((0, $6489m.AudioFormatTag).PCM, 1, 48000, 96000, 2, 16, speechSynthesisOutputFormatString, "raw-48khz-16bit-mono-pcm", false);
            case "riff-48khz-16bit-mono-pcm":
                return new $03218ee542c620c9$export$53c5e8ad1050e453((0, $6489m.AudioFormatTag).PCM, 1, 48000, 96000, 2, 16, speechSynthesisOutputFormatString, "raw-48khz-16bit-mono-pcm", true);
            case "audio-48khz-96kbitrate-mono-mp3":
                return new $03218ee542c620c9$export$53c5e8ad1050e453((0, $6489m.AudioFormatTag).MP3, 1, 48000, 12288, 2, 16, speechSynthesisOutputFormatString, speechSynthesisOutputFormatString, false);
            case "audio-48khz-192kbitrate-mono-mp3":
                return new $03218ee542c620c9$export$53c5e8ad1050e453((0, $6489m.AudioFormatTag).MP3, 1, 48000, 24576, 2, 16, speechSynthesisOutputFormatString, speechSynthesisOutputFormatString, false);
            case "ogg-48khz-16bit-mono-opus":
                return new $03218ee542c620c9$export$53c5e8ad1050e453((0, $6489m.AudioFormatTag).OGG_OPUS, 1, 48000, 12000, 2, 16, speechSynthesisOutputFormatString, speechSynthesisOutputFormatString, false);
            case "webm-16khz-16bit-mono-opus":
                return new $03218ee542c620c9$export$53c5e8ad1050e453((0, $6489m.AudioFormatTag).WEBM_OPUS, 1, 16000, 4000, 2, 16, speechSynthesisOutputFormatString, speechSynthesisOutputFormatString, false);
            case "webm-24khz-16bit-mono-opus":
                return new $03218ee542c620c9$export$53c5e8ad1050e453((0, $6489m.AudioFormatTag).WEBM_OPUS, 1, 24000, 6000, 2, 16, speechSynthesisOutputFormatString, speechSynthesisOutputFormatString, false);
            case "webm-24khz-16bit-24kbps-mono-opus":
                return new $03218ee542c620c9$export$53c5e8ad1050e453((0, $6489m.AudioFormatTag).WEBM_OPUS, 1, 24000, 3000, 2, 16, speechSynthesisOutputFormatString, speechSynthesisOutputFormatString, false);
            case "audio-16khz-16bit-32kbps-mono-opus":
                return new $03218ee542c620c9$export$53c5e8ad1050e453((0, $6489m.AudioFormatTag).OPUS, 1, 16000, 4000, 2, 16, speechSynthesisOutputFormatString, speechSynthesisOutputFormatString, false);
            case "audio-24khz-16bit-48kbps-mono-opus":
                return new $03218ee542c620c9$export$53c5e8ad1050e453((0, $6489m.AudioFormatTag).OPUS, 1, 24000, 6000, 2, 16, speechSynthesisOutputFormatString, speechSynthesisOutputFormatString, false);
            case "audio-24khz-16bit-24kbps-mono-opus":
                return new $03218ee542c620c9$export$53c5e8ad1050e453((0, $6489m.AudioFormatTag).OPUS, 1, 24000, 3000, 2, 16, speechSynthesisOutputFormatString, speechSynthesisOutputFormatString, false);
            case "audio-24khz-16bit-mono-flac":
                return new $03218ee542c620c9$export$53c5e8ad1050e453((0, $6489m.AudioFormatTag).FLAC, 1, 24000, 24000, 2, 16, speechSynthesisOutputFormatString, speechSynthesisOutputFormatString, false);
            case "audio-48khz-16bit-mono-flac":
                return new $03218ee542c620c9$export$53c5e8ad1050e453((0, $6489m.AudioFormatTag).FLAC, 1, 48000, 30000, 2, 16, speechSynthesisOutputFormatString, speechSynthesisOutputFormatString, false);
            case "raw-24khz-16bit-mono-truesilk":
                return new $03218ee542c620c9$export$53c5e8ad1050e453((0, $6489m.AudioFormatTag).SILKSkype, 1, 24000, 48000, 2, 16, speechSynthesisOutputFormatString, speechSynthesisOutputFormatString, false);
            case "raw-8khz-8bit-mono-alaw":
                return new $03218ee542c620c9$export$53c5e8ad1050e453((0, $6489m.AudioFormatTag).ALaw, 1, 8000, 8000, 1, 8, speechSynthesisOutputFormatString, speechSynthesisOutputFormatString, false);
            case "riff-8khz-8bit-mono-alaw":
                return new $03218ee542c620c9$export$53c5e8ad1050e453((0, $6489m.AudioFormatTag).ALaw, 1, 8000, 8000, 1, 8, speechSynthesisOutputFormatString, "raw-8khz-8bit-mono-alaw", true);
            case "raw-22050hz-16bit-mono-pcm":
                return new $03218ee542c620c9$export$53c5e8ad1050e453((0, $6489m.AudioFormatTag).PCM, 1, 22050, 44100, 2, 16, speechSynthesisOutputFormatString, speechSynthesisOutputFormatString, false);
            case "riff-22050hz-16bit-mono-pcm":
                return new $03218ee542c620c9$export$53c5e8ad1050e453((0, $6489m.AudioFormatTag).PCM, 1, 22050, 44100, 2, 16, speechSynthesisOutputFormatString, "raw-22050hz-16bit-mono-pcm", true);
            case "raw-44100hz-16bit-mono-pcm":
                return new $03218ee542c620c9$export$53c5e8ad1050e453((0, $6489m.AudioFormatTag).PCM, 1, 44100, 88200, 2, 16, speechSynthesisOutputFormatString, speechSynthesisOutputFormatString, false);
            case "riff-44100hz-16bit-mono-pcm":
                return new $03218ee542c620c9$export$53c5e8ad1050e453((0, $6489m.AudioFormatTag).PCM, 1, 44100, 88200, 2, 16, speechSynthesisOutputFormatString, "raw-44100hz-16bit-mono-pcm", true);
            case "riff-16khz-16bit-mono-pcm":
            default:
                return new $03218ee542c620c9$export$53c5e8ad1050e453((0, $6489m.AudioFormatTag).PCM, 1, 16000, 32000, 2, 16, "riff-16khz-16bit-mono-pcm", "raw-16khz-16bit-mono-pcm", true);
        }
    }
    static getDefaultOutputFormat() {
        return $03218ee542c620c9$export$53c5e8ad1050e453.fromSpeechSynthesisOutputFormatString(typeof window !== "undefined" ? "audio-24khz-48kbitrate-mono-mp3" : "riff-16khz-16bit-mono-pcm");
    }
    /**
     * Specifies if this audio output format has a header
     * @boolean AudioOutputFormatImpl.prototype.hasHeader
     * @function
     * @public
     */ get hasHeader() {
        return this.priHasHeader;
    }
    /**
     * Specifies the header of this format
     * @ArrayBuffer AudioOutputFormatImpl.prototype.header
     * @function
     * @public
     */ get header() {
        if (this.hasHeader) return this.privHeader;
        return undefined;
    }
    /**
     * Updates the header based on the audio length
     * @member AudioOutputFormatImpl.updateHeader
     * @function
     * @public
     * @param {number} audioLength - the audio length
     */ updateHeader(audioLength) {
        if (this.priHasHeader) {
            const view = new DataView(this.privHeader);
            view.setUint32(4, audioLength + this.privHeader.byteLength - 8, true);
            view.setUint32(40, audioLength, true);
        }
    }
    /**
     * Specifies the audio format string to be sent to the service
     * @string AudioOutputFormatImpl.prototype.requestAudioFormatString
     * @function
     * @public
     */ get requestAudioFormatString() {
        return this.priRequestAudioFormatString;
    }
}
$03218ee542c620c9$export$53c5e8ad1050e453.SpeechSynthesisOutputFormatToString = {
    [(0, $cyJfF.SpeechSynthesisOutputFormat).Raw8Khz8BitMonoMULaw]: "raw-8khz-8bit-mono-mulaw",
    [(0, $cyJfF.SpeechSynthesisOutputFormat).Riff16Khz16KbpsMonoSiren]: "riff-16khz-16kbps-mono-siren",
    [(0, $cyJfF.SpeechSynthesisOutputFormat).Audio16Khz16KbpsMonoSiren]: "audio-16khz-16kbps-mono-siren",
    [(0, $cyJfF.SpeechSynthesisOutputFormat).Audio16Khz32KBitRateMonoMp3]: "audio-16khz-32kbitrate-mono-mp3",
    [(0, $cyJfF.SpeechSynthesisOutputFormat).Audio16Khz128KBitRateMonoMp3]: "audio-16khz-128kbitrate-mono-mp3",
    [(0, $cyJfF.SpeechSynthesisOutputFormat).Audio16Khz64KBitRateMonoMp3]: "audio-16khz-64kbitrate-mono-mp3",
    [(0, $cyJfF.SpeechSynthesisOutputFormat).Audio24Khz48KBitRateMonoMp3]: "audio-24khz-48kbitrate-mono-mp3",
    [(0, $cyJfF.SpeechSynthesisOutputFormat).Audio24Khz96KBitRateMonoMp3]: "audio-24khz-96kbitrate-mono-mp3",
    [(0, $cyJfF.SpeechSynthesisOutputFormat).Audio24Khz160KBitRateMonoMp3]: "audio-24khz-160kbitrate-mono-mp3",
    [(0, $cyJfF.SpeechSynthesisOutputFormat).Raw16Khz16BitMonoTrueSilk]: "raw-16khz-16bit-mono-truesilk",
    [(0, $cyJfF.SpeechSynthesisOutputFormat).Riff16Khz16BitMonoPcm]: "riff-16khz-16bit-mono-pcm",
    [(0, $cyJfF.SpeechSynthesisOutputFormat).Riff8Khz16BitMonoPcm]: "riff-8khz-16bit-mono-pcm",
    [(0, $cyJfF.SpeechSynthesisOutputFormat).Riff24Khz16BitMonoPcm]: "riff-24khz-16bit-mono-pcm",
    [(0, $cyJfF.SpeechSynthesisOutputFormat).Riff8Khz8BitMonoMULaw]: "riff-8khz-8bit-mono-mulaw",
    [(0, $cyJfF.SpeechSynthesisOutputFormat).Raw16Khz16BitMonoPcm]: "raw-16khz-16bit-mono-pcm",
    [(0, $cyJfF.SpeechSynthesisOutputFormat).Raw24Khz16BitMonoPcm]: "raw-24khz-16bit-mono-pcm",
    [(0, $cyJfF.SpeechSynthesisOutputFormat).Raw8Khz16BitMonoPcm]: "raw-8khz-16bit-mono-pcm",
    [(0, $cyJfF.SpeechSynthesisOutputFormat).Ogg16Khz16BitMonoOpus]: "ogg-16khz-16bit-mono-opus",
    [(0, $cyJfF.SpeechSynthesisOutputFormat).Ogg24Khz16BitMonoOpus]: "ogg-24khz-16bit-mono-opus",
    [(0, $cyJfF.SpeechSynthesisOutputFormat).Raw48Khz16BitMonoPcm]: "raw-48khz-16bit-mono-pcm",
    [(0, $cyJfF.SpeechSynthesisOutputFormat).Riff48Khz16BitMonoPcm]: "riff-48khz-16bit-mono-pcm",
    [(0, $cyJfF.SpeechSynthesisOutputFormat).Audio48Khz96KBitRateMonoMp3]: "audio-48khz-96kbitrate-mono-mp3",
    [(0, $cyJfF.SpeechSynthesisOutputFormat).Audio48Khz192KBitRateMonoMp3]: "audio-48khz-192kbitrate-mono-mp3",
    [(0, $cyJfF.SpeechSynthesisOutputFormat).Ogg48Khz16BitMonoOpus]: "ogg-48khz-16bit-mono-opus",
    [(0, $cyJfF.SpeechSynthesisOutputFormat).Webm16Khz16BitMonoOpus]: "webm-16khz-16bit-mono-opus",
    [(0, $cyJfF.SpeechSynthesisOutputFormat).Webm24Khz16BitMonoOpus]: "webm-24khz-16bit-mono-opus",
    [(0, $cyJfF.SpeechSynthesisOutputFormat).Webm24Khz16Bit24KbpsMonoOpus]: "webm-24khz-16bit-24kbps-mono-opus",
    [(0, $cyJfF.SpeechSynthesisOutputFormat).Raw24Khz16BitMonoTrueSilk]: "raw-24khz-16bit-mono-truesilk",
    [(0, $cyJfF.SpeechSynthesisOutputFormat).Raw8Khz8BitMonoALaw]: "raw-8khz-8bit-mono-alaw",
    [(0, $cyJfF.SpeechSynthesisOutputFormat).Riff8Khz8BitMonoALaw]: "riff-8khz-8bit-mono-alaw",
    [(0, $cyJfF.SpeechSynthesisOutputFormat).Audio16Khz16Bit32KbpsMonoOpus]: "audio-16khz-16bit-32kbps-mono-opus",
    [(0, $cyJfF.SpeechSynthesisOutputFormat).Audio24Khz16Bit48KbpsMonoOpus]: "audio-24khz-16bit-48kbps-mono-opus",
    [(0, $cyJfF.SpeechSynthesisOutputFormat).Audio24Khz16Bit24KbpsMonoOpus]: "audio-24khz-16bit-24kbps-mono-opus",
    [(0, $cyJfF.SpeechSynthesisOutputFormat).Raw22050Hz16BitMonoPcm]: "raw-22050hz-16bit-mono-pcm",
    [(0, $cyJfF.SpeechSynthesisOutputFormat).Riff22050Hz16BitMonoPcm]: "riff-22050hz-16bit-mono-pcm",
    [(0, $cyJfF.SpeechSynthesisOutputFormat).Raw44100Hz16BitMonoPcm]: "raw-44100hz-16bit-mono-pcm",
    [(0, $cyJfF.SpeechSynthesisOutputFormat).Riff44100Hz16BitMonoPcm]: "riff-44100hz-16bit-mono-pcm"
};

});
parcelRequire.register("cyJfF", function(module, exports) {

$parcel$export(module.exports, "SpeechSynthesisOutputFormat", () => $924bc30e0eab0957$export$3671c0863ecfe8a6);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
/**
 * Define speech synthesis audio output formats.
 * @enum SpeechSynthesisOutputFormat
 * Updated in version 1.17.0
 */ var $924bc30e0eab0957$export$3671c0863ecfe8a6;
(function(SpeechSynthesisOutputFormat) {
    /**
     * raw-8khz-8bit-mono-mulaw
     * @member SpeechSynthesisOutputFormat.Raw8Khz8BitMonoMULaw,
     */ SpeechSynthesisOutputFormat[SpeechSynthesisOutputFormat["Raw8Khz8BitMonoMULaw"] = 0] = "Raw8Khz8BitMonoMULaw";
    /**
     * riff-16khz-16kbps-mono-siren
     * @note Unsupported by the service. Do not use this value.
     * @member SpeechSynthesisOutputFormat.Riff16Khz16KbpsMonoSiren
     */ SpeechSynthesisOutputFormat[SpeechSynthesisOutputFormat["Riff16Khz16KbpsMonoSiren"] = 1] = "Riff16Khz16KbpsMonoSiren";
    /**
     * audio-16khz-16kbps-mono-siren
     * @note Unsupported by the service. Do not use this value.
     * @member SpeechSynthesisOutputFormat.Audio16Khz16KbpsMonoSiren
     */ SpeechSynthesisOutputFormat[SpeechSynthesisOutputFormat["Audio16Khz16KbpsMonoSiren"] = 2] = "Audio16Khz16KbpsMonoSiren";
    /**
     * audio-16khz-32kbitrate-mono-mp3
     * @member SpeechSynthesisOutputFormat.Audio16Khz32KBitRateMonoMp3
     */ SpeechSynthesisOutputFormat[SpeechSynthesisOutputFormat["Audio16Khz32KBitRateMonoMp3"] = 3] = "Audio16Khz32KBitRateMonoMp3";
    /**
     * audio-16khz-128kbitrate-mono-mp3
     * @member SpeechSynthesisOutputFormat.Audio16Khz128KBitRateMonoMp3
     */ SpeechSynthesisOutputFormat[SpeechSynthesisOutputFormat["Audio16Khz128KBitRateMonoMp3"] = 4] = "Audio16Khz128KBitRateMonoMp3";
    /**
     * audio-16khz-64kbitrate-mono-mp3
     * @member SpeechSynthesisOutputFormat.Audio16Khz64KBitRateMonoMp3
     */ SpeechSynthesisOutputFormat[SpeechSynthesisOutputFormat["Audio16Khz64KBitRateMonoMp3"] = 5] = "Audio16Khz64KBitRateMonoMp3";
    /**
     * audio-24khz-48kbitrate-mono-mp3
     * @member SpeechSynthesisOutputFormat.Audio24Khz48KBitRateMonoMp3
     */ SpeechSynthesisOutputFormat[SpeechSynthesisOutputFormat["Audio24Khz48KBitRateMonoMp3"] = 6] = "Audio24Khz48KBitRateMonoMp3";
    /**
     * audio-24khz-96kbitrate-mono-mp3
     * @member SpeechSynthesisOutputFormat.Audio24Khz96KBitRateMonoMp3
     */ SpeechSynthesisOutputFormat[SpeechSynthesisOutputFormat["Audio24Khz96KBitRateMonoMp3"] = 7] = "Audio24Khz96KBitRateMonoMp3";
    /**
     * audio-24khz-160kbitrate-mono-mp3
     * @member SpeechSynthesisOutputFormat.Audio24Khz160KBitRateMonoMp3
     */ SpeechSynthesisOutputFormat[SpeechSynthesisOutputFormat["Audio24Khz160KBitRateMonoMp3"] = 8] = "Audio24Khz160KBitRateMonoMp3";
    /**
     * raw-16khz-16bit-mono-truesilk
     * @member SpeechSynthesisOutputFormat.Raw16Khz16BitMonoTrueSilk
     */ SpeechSynthesisOutputFormat[SpeechSynthesisOutputFormat["Raw16Khz16BitMonoTrueSilk"] = 9] = "Raw16Khz16BitMonoTrueSilk";
    /**
     * riff-16khz-16bit-mono-pcm
     * @member SpeechSynthesisOutputFormat.Riff16Khz16BitMonoPcm
     */ SpeechSynthesisOutputFormat[SpeechSynthesisOutputFormat["Riff16Khz16BitMonoPcm"] = 10] = "Riff16Khz16BitMonoPcm";
    /**
     * riff-8khz-16bit-mono-pcm
     * @member SpeechSynthesisOutputFormat.Riff8Khz16BitMonoPcm
     */ SpeechSynthesisOutputFormat[SpeechSynthesisOutputFormat["Riff8Khz16BitMonoPcm"] = 11] = "Riff8Khz16BitMonoPcm";
    /**
     * riff-24khz-16bit-mono-pcm
     * @member SpeechSynthesisOutputFormat.Riff24Khz16BitMonoPcm
     */ SpeechSynthesisOutputFormat[SpeechSynthesisOutputFormat["Riff24Khz16BitMonoPcm"] = 12] = "Riff24Khz16BitMonoPcm";
    /**
     * riff-8khz-8bit-mono-mulaw
     * @member SpeechSynthesisOutputFormat.Riff8Khz8BitMonoMULaw
     */ SpeechSynthesisOutputFormat[SpeechSynthesisOutputFormat["Riff8Khz8BitMonoMULaw"] = 13] = "Riff8Khz8BitMonoMULaw";
    /**
     * raw-16khz-16bit-mono-pcm
     * @member SpeechSynthesisOutputFormat.Raw16Khz16BitMonoPcm
     */ SpeechSynthesisOutputFormat[SpeechSynthesisOutputFormat["Raw16Khz16BitMonoPcm"] = 14] = "Raw16Khz16BitMonoPcm";
    /**
     * raw-24khz-16bit-mono-pcm
     * @member SpeechSynthesisOutputFormat.Raw24Khz16BitMonoPcm
     */ SpeechSynthesisOutputFormat[SpeechSynthesisOutputFormat["Raw24Khz16BitMonoPcm"] = 15] = "Raw24Khz16BitMonoPcm";
    /**
     * raw-8khz-16bit-mono-pcm
     * @member SpeechSynthesisOutputFormat.Raw8Khz16BitMonoPcm
     */ SpeechSynthesisOutputFormat[SpeechSynthesisOutputFormat["Raw8Khz16BitMonoPcm"] = 16] = "Raw8Khz16BitMonoPcm";
    /**
     * ogg-16khz-16bit-mono-opus
     * @member SpeechSynthesisOutputFormat.Ogg16Khz16BitMonoOpus
     */ SpeechSynthesisOutputFormat[SpeechSynthesisOutputFormat["Ogg16Khz16BitMonoOpus"] = 17] = "Ogg16Khz16BitMonoOpus";
    /**
     * ogg-24khz-16bit-mono-opus
     * @member SpeechSynthesisOutputFormat.Ogg24Khz16BitMonoOpus
     */ SpeechSynthesisOutputFormat[SpeechSynthesisOutputFormat["Ogg24Khz16BitMonoOpus"] = 18] = "Ogg24Khz16BitMonoOpus";
    /**
     * raw-48khz-16bit-mono-pcm
     * @member SpeechSynthesisOutputFormat.Raw48Khz16BitMonoPcm
     */ SpeechSynthesisOutputFormat[SpeechSynthesisOutputFormat["Raw48Khz16BitMonoPcm"] = 19] = "Raw48Khz16BitMonoPcm";
    /**
     * riff-48khz-16bit-mono-pcm
     * @member SpeechSynthesisOutputFormat.Riff48Khz16BitMonoPcm
     */ SpeechSynthesisOutputFormat[SpeechSynthesisOutputFormat["Riff48Khz16BitMonoPcm"] = 20] = "Riff48Khz16BitMonoPcm";
    /**
     * audio-48khz-96kbitrate-mono-mp3
     * @member SpeechSynthesisOutputFormat.Audio48Khz96KBitRateMonoMp3
     */ SpeechSynthesisOutputFormat[SpeechSynthesisOutputFormat["Audio48Khz96KBitRateMonoMp3"] = 21] = "Audio48Khz96KBitRateMonoMp3";
    /**
     * audio-48khz-192kbitrate-mono-mp3
     * @member SpeechSynthesisOutputFormat.Audio48Khz192KBitRateMonoMp3
     */ SpeechSynthesisOutputFormat[SpeechSynthesisOutputFormat["Audio48Khz192KBitRateMonoMp3"] = 22] = "Audio48Khz192KBitRateMonoMp3";
    /**
     * ogg-48khz-16bit-mono-opus
     * Added in version 1.16.0
     * @member SpeechSynthesisOutputFormat.Ogg48Khz16BitMonoOpus
     */ SpeechSynthesisOutputFormat[SpeechSynthesisOutputFormat["Ogg48Khz16BitMonoOpus"] = 23] = "Ogg48Khz16BitMonoOpus";
    /**
     * webm-16khz-16bit-mono-opus
     * Added in version 1.16.0
     * @member SpeechSynthesisOutputFormat.Webm16Khz16BitMonoOpus
     */ SpeechSynthesisOutputFormat[SpeechSynthesisOutputFormat["Webm16Khz16BitMonoOpus"] = 24] = "Webm16Khz16BitMonoOpus";
    /**
     * webm-24khz-16bit-mono-opus
     * Added in version 1.16.0
     * @member SpeechSynthesisOutputFormat.Webm24Khz16BitMonoOpus
     */ SpeechSynthesisOutputFormat[SpeechSynthesisOutputFormat["Webm24Khz16BitMonoOpus"] = 25] = "Webm24Khz16BitMonoOpus";
    /**
     * raw-24khz-16bit-mono-truesilk
     * Added in version 1.17.0
     * @member SpeechSynthesisOutputFormat.Raw24Khz16BitMonoTrueSilk
     */ SpeechSynthesisOutputFormat[SpeechSynthesisOutputFormat["Raw24Khz16BitMonoTrueSilk"] = 26] = "Raw24Khz16BitMonoTrueSilk";
    /**
     * raw-8khz-8bit-mono-alaw
     * Added in version 1.17.0
     * @member SpeechSynthesisOutputFormat.Raw8Khz8BitMonoALaw
     */ SpeechSynthesisOutputFormat[SpeechSynthesisOutputFormat["Raw8Khz8BitMonoALaw"] = 27] = "Raw8Khz8BitMonoALaw";
    /**
     * riff-8khz-8bit-mono-alaw
     * Added in version 1.17.0
     * @member SpeechSynthesisOutputFormat.Riff8Khz8BitMonoALaw
     */ SpeechSynthesisOutputFormat[SpeechSynthesisOutputFormat["Riff8Khz8BitMonoALaw"] = 28] = "Riff8Khz8BitMonoALaw";
    /**
     * webm-24khz-16bit-24kbps-mono-opus
     * Audio compressed by OPUS codec in a webm container, with bitrate of 24kbps, optimized for IoT scenario.
     * Added in version 1.19.0
     * @member SpeechSynthesisOutputFormat.Webm24Khz16Bit24KbpsMonoOpus
     */ SpeechSynthesisOutputFormat[SpeechSynthesisOutputFormat["Webm24Khz16Bit24KbpsMonoOpus"] = 29] = "Webm24Khz16Bit24KbpsMonoOpus";
    /**
     * audio-16khz-16bit-32kbps-mono-opus
     * Audio compressed by OPUS codec without container, with bitrate of 32kbps.
     * Added in version 1.20.0
     * @member SpeechSynthesisOutputFormat.Audio16Khz16Bit32KbpsMonoOpus
     */ SpeechSynthesisOutputFormat[SpeechSynthesisOutputFormat["Audio16Khz16Bit32KbpsMonoOpus"] = 30] = "Audio16Khz16Bit32KbpsMonoOpus";
    /**
     * audio-24khz-16bit-48kbps-mono-opus
     * Audio compressed by OPUS codec without container, with bitrate of 48kbps.
     * Added in version 1.20.0
     * @member SpeechSynthesisOutputFormat.Audio24Khz16Bit48KbpsMonoOpus
     */ SpeechSynthesisOutputFormat[SpeechSynthesisOutputFormat["Audio24Khz16Bit48KbpsMonoOpus"] = 31] = "Audio24Khz16Bit48KbpsMonoOpus";
    /**
     * audio-24khz-16bit-24kbps-mono-opus
     * Audio compressed by OPUS codec without container, with bitrate of 24kbps.
     * Added in version 1.20.0
     * @member SpeechSynthesisOutputFormat.Audio24Khz16Bit24KbpsMonoOpus
     */ SpeechSynthesisOutputFormat[SpeechSynthesisOutputFormat["Audio24Khz16Bit24KbpsMonoOpus"] = 32] = "Audio24Khz16Bit24KbpsMonoOpus";
    /**
     * raw-22050hz-16bit-mono-pcm
     * Raw PCM audio at 22050Hz sampling rate and 16-bit depth.
     * Added in version 1.22.0
     * @member SpeechSynthesisOutputFormat.Raw22050Hz16BitMonoPcm
     */ SpeechSynthesisOutputFormat[SpeechSynthesisOutputFormat["Raw22050Hz16BitMonoPcm"] = 33] = "Raw22050Hz16BitMonoPcm";
    /**
     * riff-22050hz-16bit-mono-pcm
     * PCM audio at 22050Hz sampling rate and 16-bit depth, with RIFF header.
     * Added in version 1.22.0
     * @member SpeechSynthesisOutputFormat.Riff22050Hz16BitMonoPcm
     */ SpeechSynthesisOutputFormat[SpeechSynthesisOutputFormat["Riff22050Hz16BitMonoPcm"] = 34] = "Riff22050Hz16BitMonoPcm";
    /**
     * raw-44100hz-16bit-mono-pcm
     * Raw PCM audio at 44100Hz sampling rate and 16-bit depth.
     * Added in version 1.22.0
     * @member SpeechSynthesisOutputFormat.Raw44100Hz16BitMonoPcm
     */ SpeechSynthesisOutputFormat[SpeechSynthesisOutputFormat["Raw44100Hz16BitMonoPcm"] = 35] = "Raw44100Hz16BitMonoPcm";
    /**
     * riff-44100hz-16bit-mono-pcm
     * PCM audio at 44100Hz sampling rate and 16-bit depth, with RIFF header.
     * Added in version 1.22.0
     * @member SpeechSynthesisOutputFormat.Riff44100Hz16BitMonoPcm
     */ SpeechSynthesisOutputFormat[SpeechSynthesisOutputFormat["Riff44100Hz16BitMonoPcm"] = 36] = "Riff44100Hz16BitMonoPcm";
})($924bc30e0eab0957$export$3671c0863ecfe8a6 || ($924bc30e0eab0957$export$3671c0863ecfe8a6 = {}));

});

parcelRequire.register("6489m", function(module, exports) {

$parcel$export(module.exports, "AudioFormatTag", () => $46a97036c37034c3$export$97592a59cf8dc84a);
$parcel$export(module.exports, "AudioStreamFormat", () => $46a97036c37034c3$export$2d50fcba14d14cb0);
$parcel$export(module.exports, "AudioStreamFormatImpl", () => $46a97036c37034c3$export$22b9ff0cbb278347);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
// eslint-disable-next-line max-classes-per-file
var $46a97036c37034c3$export$97592a59cf8dc84a;
(function(AudioFormatTag) {
    AudioFormatTag[AudioFormatTag["PCM"] = 1] = "PCM";
    AudioFormatTag[AudioFormatTag["MuLaw"] = 2] = "MuLaw";
    AudioFormatTag[AudioFormatTag["Siren"] = 3] = "Siren";
    AudioFormatTag[AudioFormatTag["MP3"] = 4] = "MP3";
    AudioFormatTag[AudioFormatTag["SILKSkype"] = 5] = "SILKSkype";
    AudioFormatTag[AudioFormatTag["OGG_OPUS"] = 6] = "OGG_OPUS";
    AudioFormatTag[AudioFormatTag["WEBM_OPUS"] = 7] = "WEBM_OPUS";
    AudioFormatTag[AudioFormatTag["ALaw"] = 8] = "ALaw";
    AudioFormatTag[AudioFormatTag["FLAC"] = 9] = "FLAC";
    AudioFormatTag[AudioFormatTag["OPUS"] = 10] = "OPUS";
})($46a97036c37034c3$export$97592a59cf8dc84a || ($46a97036c37034c3$export$97592a59cf8dc84a = {}));
class $46a97036c37034c3$export$2d50fcba14d14cb0 {
    /**
     * Creates an audio stream format object representing the default audio stream
     * format (16KHz 16bit mono PCM).
     * @member AudioStreamFormat.getDefaultInputFormat
     * @function
     * @public
     * @returns {AudioStreamFormat} The audio stream format being created.
     */ static getDefaultInputFormat() {
        return $46a97036c37034c3$export$22b9ff0cbb278347.getDefaultInputFormat();
    }
    /**
     * Creates an audio stream format object with the specified format characteristics.
     * @member AudioStreamFormat.getWaveFormat
     * @function
     * @public
     * @param {number} samplesPerSecond - Sample rate, in samples per second (Hertz).
     * @param {number} bitsPerSample - Bits per sample, typically 16.
     * @param {number} channels - Number of channels in the waveform-audio data. Monaural data
     * uses one channel and stereo data uses two channels.
     * @param {AudioFormatTag} format - Audio format (PCM, alaw or mulaw).
     * @returns {AudioStreamFormat} The audio stream format being created.
     */ static getWaveFormat(samplesPerSecond, bitsPerSample, channels, format) {
        return new $46a97036c37034c3$export$22b9ff0cbb278347(samplesPerSecond, bitsPerSample, channels, format);
    }
    /**
     * Creates an audio stream format object with the specified pcm waveformat characteristics.
     * @member AudioStreamFormat.getWaveFormatPCM
     * @function
     * @public
     * @param {number} samplesPerSecond - Sample rate, in samples per second (Hertz).
     * @param {number} bitsPerSample - Bits per sample, typically 16.
     * @param {number} channels - Number of channels in the waveform-audio data. Monaural data
     * uses one channel and stereo data uses two channels.
     * @returns {AudioStreamFormat} The audio stream format being created.
     */ static getWaveFormatPCM(samplesPerSecond, bitsPerSample, channels) {
        return new $46a97036c37034c3$export$22b9ff0cbb278347(samplesPerSecond, bitsPerSample, channels);
    }
}
class $46a97036c37034c3$export$22b9ff0cbb278347 extends $46a97036c37034c3$export$2d50fcba14d14cb0 {
    /**
     * Creates an instance with the given values.
     * @constructor
     * @param {number} samplesPerSec - Samples per second.
     * @param {number} bitsPerSample - Bits per sample.
     * @param {number} channels - Number of channels.
     * @param {AudioFormatTag} format - Audio format (PCM, alaw or mulaw).
     */ constructor(samplesPerSec = 16000, bitsPerSample = 16, channels = 1, format = $46a97036c37034c3$export$97592a59cf8dc84a.PCM){
        super();
        let isWavFormat = true;
        /* 1 for PCM; 6 for alaw; 7 for mulaw */ switch(format){
            case $46a97036c37034c3$export$97592a59cf8dc84a.PCM:
                this.formatTag = 1;
                break;
            case $46a97036c37034c3$export$97592a59cf8dc84a.ALaw:
                this.formatTag = 6;
                break;
            case $46a97036c37034c3$export$97592a59cf8dc84a.MuLaw:
                this.formatTag = 7;
                break;
            default:
                isWavFormat = false;
        }
        this.bitsPerSample = bitsPerSample;
        this.samplesPerSec = samplesPerSec;
        this.channels = channels;
        this.avgBytesPerSec = this.samplesPerSec * this.channels * (this.bitsPerSample / 8);
        this.blockAlign = this.channels * Math.max(this.bitsPerSample, 8);
        if (isWavFormat) {
            this.privHeader = new ArrayBuffer(44);
            // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DataView
            const view = new DataView(this.privHeader);
            /* RIFF identifier */ this.setString(view, 0, "RIFF");
            /* file length */ view.setUint32(4, 0, true);
            /* RIFF type & Format */ this.setString(view, 8, "WAVEfmt ");
            /* format chunk length */ view.setUint32(16, 16, true);
            /* audio format */ view.setUint16(20, this.formatTag, true);
            /* channel count */ view.setUint16(22, this.channels, true);
            /* sample rate */ view.setUint32(24, this.samplesPerSec, true);
            /* byte rate (sample rate * block align) */ view.setUint32(28, this.avgBytesPerSec, true);
            /* block align (channel count * bytes per sample) */ view.setUint16(32, this.channels * (this.bitsPerSample / 8), true);
            /* bits per sample */ view.setUint16(34, this.bitsPerSample, true);
            /* data chunk identifier */ this.setString(view, 36, "data");
            /* data chunk length */ view.setUint32(40, 0, true);
        }
    }
    /**
     * Retrieves the default input format.
     * @member AudioStreamFormatImpl.getDefaultInputFormat
     * @function
     * @public
     * @returns {AudioStreamFormatImpl} The default input format.
     */ static getDefaultInputFormat() {
        return new $46a97036c37034c3$export$22b9ff0cbb278347();
    }
    /**
     * Creates an audio context appropriate to current browser
     * @member AudioStreamFormatImpl.getAudioContext
     * @function
     * @public
     * @returns {AudioContext} An audio context instance
     */ /* eslint-disable */ static getAudioContext(sampleRate) {
        // Workaround for Speech SDK bug in Safari.
        const AudioContext = window.AudioContext // our preferred impl
         || window.webkitAudioContext // fallback, mostly when on Safari
         || false; // could not find.
        // https://developer.mozilla.org/en-US/docs/Web/API/AudioContext
        if (!!AudioContext) {
            if (sampleRate !== undefined && navigator.mediaDevices.getSupportedConstraints().sampleRate) return new AudioContext({
                sampleRate: sampleRate
            });
            else return new AudioContext();
        } else throw new Error("Browser does not support Web Audio API (AudioContext is not available).");
    }
    /* eslint-enable */ /**
     * Closes the configuration object.
     * @member AudioStreamFormatImpl.prototype.close
     * @function
     * @public
     */ close() {
        return;
    }
    get header() {
        return this.privHeader;
    }
    setString(view, offset, str) {
        for(let i = 0; i < str.length; i++)view.setUint8(offset + i, str.charCodeAt(i));
    }
}

});


parcelRequire.register("kNh7Z", function(module, exports) {

$parcel$export(module.exports, "ActivityReceivedEventArgs", () => $f235ab7d59d6bd26$export$1a8a3934f34e049c);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
/**
 * Defines contents of received message/events.
 * @class ActivityReceivedEventArgs
 */ class $f235ab7d59d6bd26$export$1a8a3934f34e049c {
    /**
     * Creates and initializes an instance of this class.
     * @constructor
     * @param {any} activity - The activity..
     */ constructor(activity, audioStream){
        this.privActivity = activity;
        this.privAudioStream = audioStream;
    }
    /**
     * Gets the received activity
     * @member ActivityReceivedEventArgs.prototype.activity
     * @function
     * @public
     * @returns {any} the received activity.
     */ get activity() {
        return this.privActivity;
    }
    get audioStream() {
        return this.privAudioStream;
    }
}

});

parcelRequire.register("bHuZw", function(module, exports) {

$parcel$export(module.exports, "DialogServiceConfig", () => $884bc01a27890765$export$dff5a88488f70ec8);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
/* eslint-disable max-classes-per-file */ 
var $8HmyV = parcelRequire("8HmyV");

var $bjdWp = parcelRequire("bjdWp");
var $eIeaS = parcelRequire("eIeaS");
class $884bc01a27890765$export$dff5a88488f70ec8 {
    /**
     * Creates an instance of DialogService config.
     * @constructor
     */ constructor(){
        return;
    }
    /**
     * Sets the corresponding backend application identifier.
     * @member DialogServiceConfig.prototype.Conversation_ApplicationId
     * @function
     * @public
     * @param {string} value - The application identifier to set.
     */ // eslint-disable-next-line @typescript-eslint/no-empty-function
    set applicationId(value) {}
    static get DialogTypes() {
        return {
            BotFramework: "bot_framework",
            CustomCommands: "custom_commands"
        };
    }
}
class $884bc01a27890765$export$77638a68c815581e extends $884bc01a27890765$export$dff5a88488f70ec8 {
    /**
     * Creates an instance of dialogService config.
     */ constructor(){
        super();
        this.privSpeechConfig = new (0, $eIeaS.SpeechConfigImpl)();
    }
    /**
     * Provides access to custom properties.
     * @member DialogServiceConfigImpl.prototype.properties
     * @function
     * @public
     * @returns {PropertyCollection} The properties.
     */ get properties() {
        return this.privSpeechConfig.properties;
    }
    /**
     * Gets the speech recognition language.
     * @member DialogServiceConfigImpl.prototype.speechRecognitionLanguage
     * @function
     * @public
     */ get speechRecognitionLanguage() {
        return this.privSpeechConfig.speechRecognitionLanguage;
    }
    /**
     * Sets the speech recognition language.
     * @member DialogServiceConfigImpl.prototype.speechRecognitionLanguage
     * @function
     * @public
     * @param {string} value - The language to set.
     */ set speechRecognitionLanguage(value) {
        (0, $8HmyV.Contracts).throwIfNullOrWhitespace(value, "value");
        this.privSpeechConfig.speechRecognitionLanguage = value;
    }
    get outputFormat() {
        return this.privSpeechConfig.outputFormat;
    }
    set outputFormat(value) {
        this.privSpeechConfig.outputFormat = value;
    }
    /**
     * Sets a named property as value
     * @member DialogServiceConfigImpl.prototype.setProperty
     * @function
     * @public
     * @param {PropertyId | string} name - The property to set.
     * @param {string} value - The value.
     */ setProperty(name, value) {
        this.privSpeechConfig.setProperty(name, value);
    }
    /**
     * Sets a named property as value
     * @member DialogServiceConfigImpl.prototype.getProperty
     * @function
     * @public
     * @param {PropertyId | string} name - The property to get.
     * @param {string} def - The default value to return in case the property is not known.
     * @returns {string} The current value, or provided default, of the given property.
     */ getProperty(name, def) {
        return this.privSpeechConfig.getProperty(name);
    }
    /**
     * Sets the proxy configuration.
     * Only relevant in Node.js environments.
     * Added in version 1.4.0.
     * @param proxyHostName The host name of the proxy server, without the protocol scheme (http://)
     * @param proxyPort The port number of the proxy server.
     * @param proxyUserName The user name of the proxy server.
     * @param proxyPassword The password of the proxy server.
     */ setProxy(proxyHostName, proxyPort, proxyUserName, proxyPassword) {
        this.setProperty((0, $bjdWp.PropertyId).SpeechServiceConnection_ProxyHostName, proxyHostName);
        this.setProperty((0, $bjdWp.PropertyId).SpeechServiceConnection_ProxyPort, `${proxyPort}`);
        if (proxyUserName) this.setProperty((0, $bjdWp.PropertyId).SpeechServiceConnection_ProxyUserName, proxyUserName);
        if (proxyPassword) this.setProperty((0, $bjdWp.PropertyId).SpeechServiceConnection_ProxyPassword, proxyPassword);
    }
    setServiceProperty(name, value, channel) {
        this.privSpeechConfig.setServiceProperty(name, value);
    }
    /**
     * Dispose of associated resources.
     * @member DialogServiceConfigImpl.prototype.close
     * @function
     * @public
     */ close() {
        return;
    }
}

});
parcelRequire.register("eIeaS", function(module, exports) {

$parcel$export(module.exports, "SpeechConfigImpl", () => $ab602b7cdabf679d$export$974c5658476a7259);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
/* eslint-disable max-classes-per-file */ 
var $jSpbe = parcelRequire("jSpbe");

var $8HmyV = parcelRequire("8HmyV");

var $7cfhB = parcelRequire("7cfhB");
var $b3w2H = parcelRequire("b3w2H");
var $3fCi1 = parcelRequire("3fCi1");
var $bjdWp = parcelRequire("bjdWp");
var $cyJfF = parcelRequire("cyJfF");
class $ab602b7cdabf679d$export$de011cb7b5310b31 {
    /**
     * Creates and initializes an instance.
     * @constructor
     */ constructor(){
        return;
    }
    /**
     * Static instance of SpeechConfig returned by passing subscriptionKey and service region.
     * Note: Please use your LanguageUnderstanding subscription key in case you want to use the Intent recognizer.
     * @member SpeechConfig.fromSubscription
     * @function
     * @public
     * @param {string} subscriptionKey - The subscription key.
     * @param {string} region - The region name (see the <a href="https://aka.ms/csspeech/region">region page</a>).
     * @returns {SpeechConfig} The speech factory
     */ static fromSubscription(subscriptionKey, region) {
        (0, $8HmyV.Contracts).throwIfNullOrWhitespace(subscriptionKey, "subscriptionKey");
        (0, $8HmyV.Contracts).throwIfNullOrWhitespace(region, "region");
        const speechImpl = new $ab602b7cdabf679d$export$974c5658476a7259();
        speechImpl.setProperty((0, $bjdWp.PropertyId).SpeechServiceConnection_Region, region);
        speechImpl.setProperty((0, $bjdWp.PropertyId).SpeechServiceConnection_IntentRegion, region);
        speechImpl.setProperty((0, $bjdWp.PropertyId).SpeechServiceConnection_Key, subscriptionKey);
        return speechImpl;
    }
    /**
     * Creates an instance of the speech config with specified endpoint and subscription key.
     * This method is intended only for users who use a non-standard service endpoint or parameters.
     * Note: Please use your LanguageUnderstanding subscription key in case you want to use the Intent recognizer.
     * Note: The query parameters specified in the endpoint URL are not changed, even if they are set by any other APIs.
     * For example, if language is defined in the uri as query parameter "language=de-DE", and also set by
     * SpeechConfig.speechRecognitionLanguage = "en-US", the language setting in uri takes precedence,
     * and the effective language is "de-DE". Only the parameters that are not specified in the
     * endpoint URL can be set by other APIs.
     * Note: To use authorization token with fromEndpoint, pass an empty string to the subscriptionKey in the
     * fromEndpoint method, and then set authorizationToken="token" on the created SpeechConfig instance to
     * use the authorization token.
     * @member SpeechConfig.fromEndpoint
     * @function
     * @public
     * @param {URL} endpoint - The service endpoint to connect to.
     * @param {string} subscriptionKey - The subscription key. If a subscription key is not specified, an authorization token must be set.
     * @returns {SpeechConfig} A speech factory instance.
     */ static fromEndpoint(endpoint, subscriptionKey) {
        (0, $8HmyV.Contracts).throwIfNull(endpoint, "endpoint");
        const speechImpl = new $ab602b7cdabf679d$export$974c5658476a7259();
        speechImpl.setProperty((0, $bjdWp.PropertyId).SpeechServiceConnection_Endpoint, endpoint.href);
        if (undefined !== subscriptionKey) speechImpl.setProperty((0, $bjdWp.PropertyId).SpeechServiceConnection_Key, subscriptionKey);
        return speechImpl;
    }
    /**
     * Creates an instance of the speech config with specified host and subscription key.
     * This method is intended only for users who use a non-default service host. Standard resource path will be assumed.
     * For services with a non-standard resource path or no path at all, use fromEndpoint instead.
     * Note: Query parameters are not allowed in the host URI and must be set by other APIs.
     * Note: To use an authorization token with fromHost, use fromHost(URL),
     * and then set the AuthorizationToken property on the created SpeechConfig instance.
     * Note: Added in version 1.9.0.
     * @member SpeechConfig.fromHost
     * @function
     * @public
     * @param {URL} host - The service endpoint to connect to. Format is "protocol://host:port" where ":port" is optional.
     * @param {string} subscriptionKey - The subscription key. If a subscription key is not specified, an authorization token must be set.
     * @returns {SpeechConfig} A speech factory instance.
     */ static fromHost(hostName, subscriptionKey) {
        (0, $8HmyV.Contracts).throwIfNull(hostName, "hostName");
        const speechImpl = new $ab602b7cdabf679d$export$974c5658476a7259();
        speechImpl.setProperty((0, $bjdWp.PropertyId).SpeechServiceConnection_Host, hostName.protocol + "//" + hostName.hostname + (hostName.port === "" ? "" : ":" + hostName.port));
        if (undefined !== subscriptionKey) speechImpl.setProperty((0, $bjdWp.PropertyId).SpeechServiceConnection_Key, subscriptionKey);
        return speechImpl;
    }
    /**
     * Creates an instance of the speech factory with specified initial authorization token and region.
     * Note: The caller needs to ensure that the authorization token is valid. Before the authorization token
     * expires, the caller needs to refresh it by calling this setter with a new valid token.
     * Note: Please use a token derived from your LanguageUnderstanding subscription key in case you want
     * to use the Intent recognizer. As configuration values are copied when creating a new recognizer,
     * the new token value will not apply to recognizers that have already been created. For recognizers
     * that have been created before, you need to set authorization token of the corresponding recognizer
     * to refresh the token. Otherwise, the recognizers will encounter errors during recognition.
     * @member SpeechConfig.fromAuthorizationToken
     * @function
     * @public
     * @param {string} authorizationToken - The initial authorization token.
     * @param {string} region - The region name (see the <a href="https://aka.ms/csspeech/region">region page</a>).
     * @returns {SpeechConfig} A speech factory instance.
     */ static fromAuthorizationToken(authorizationToken, region) {
        (0, $8HmyV.Contracts).throwIfNull(authorizationToken, "authorizationToken");
        (0, $8HmyV.Contracts).throwIfNullOrWhitespace(region, "region");
        const speechImpl = new $ab602b7cdabf679d$export$974c5658476a7259();
        speechImpl.setProperty((0, $bjdWp.PropertyId).SpeechServiceConnection_Region, region);
        speechImpl.setProperty((0, $bjdWp.PropertyId).SpeechServiceConnection_IntentRegion, region);
        speechImpl.authorizationToken = authorizationToken;
        return speechImpl;
    }
    /**
     * Closes the configuration.
     * @member SpeechConfig.prototype.close
     * @function
     * @public
     */ // eslint-disable-next-line @typescript-eslint/no-empty-function
    close() {}
}
class $ab602b7cdabf679d$export$974c5658476a7259 extends $ab602b7cdabf679d$export$de011cb7b5310b31 {
    constructor(){
        super();
        this.privProperties = new (0, $3fCi1.PropertyCollection)();
        this.speechRecognitionLanguage = "en-US"; // Should we have a default?
        this.outputFormat = (0, $7cfhB.OutputFormat).Simple;
    }
    get properties() {
        return this.privProperties;
    }
    get endPoint() {
        return new URL(this.privProperties.getProperty((0, $bjdWp.PropertyId).SpeechServiceConnection_Endpoint));
    }
    get subscriptionKey() {
        return this.privProperties.getProperty((0, $bjdWp.PropertyId).SpeechServiceConnection_Key);
    }
    get region() {
        return this.privProperties.getProperty((0, $bjdWp.PropertyId).SpeechServiceConnection_Region);
    }
    get authorizationToken() {
        return this.privProperties.getProperty((0, $bjdWp.PropertyId).SpeechServiceAuthorization_Token);
    }
    set authorizationToken(value) {
        this.privProperties.setProperty((0, $bjdWp.PropertyId).SpeechServiceAuthorization_Token, value);
    }
    get speechRecognitionLanguage() {
        return this.privProperties.getProperty((0, $bjdWp.PropertyId).SpeechServiceConnection_RecoLanguage);
    }
    set speechRecognitionLanguage(value) {
        this.privProperties.setProperty((0, $bjdWp.PropertyId).SpeechServiceConnection_RecoLanguage, value);
    }
    get autoDetectSourceLanguages() {
        return this.privProperties.getProperty((0, $bjdWp.PropertyId).SpeechServiceConnection_AutoDetectSourceLanguages);
    }
    set autoDetectSourceLanguages(value) {
        this.privProperties.setProperty((0, $bjdWp.PropertyId).SpeechServiceConnection_AutoDetectSourceLanguages, value);
    }
    get outputFormat() {
        return (0, $7cfhB.OutputFormat)[this.privProperties.getProperty((0, $jSpbe.OutputFormatPropertyName), undefined)];
    }
    set outputFormat(value) {
        this.privProperties.setProperty((0, $jSpbe.OutputFormatPropertyName), (0, $7cfhB.OutputFormat)[value]);
    }
    get endpointId() {
        return this.privProperties.getProperty((0, $bjdWp.PropertyId).SpeechServiceConnection_EndpointId);
    }
    set endpointId(value) {
        this.privProperties.setProperty((0, $bjdWp.PropertyId).SpeechServiceConnection_EndpointId, value);
    }
    setProperty(name, value) {
        (0, $8HmyV.Contracts).throwIfNull(value, "value");
        this.privProperties.setProperty(name, value);
    }
    getProperty(name, def) {
        return this.privProperties.getProperty(name, def);
    }
    setProxy(proxyHostName, proxyPort, proxyUserName, proxyPassword) {
        this.setProperty((0, $bjdWp.PropertyId)[(0, $bjdWp.PropertyId).SpeechServiceConnection_ProxyHostName], proxyHostName);
        this.setProperty((0, $bjdWp.PropertyId)[(0, $bjdWp.PropertyId).SpeechServiceConnection_ProxyPort], proxyPort);
        this.setProperty((0, $bjdWp.PropertyId)[(0, $bjdWp.PropertyId).SpeechServiceConnection_ProxyUserName], proxyUserName);
        this.setProperty((0, $bjdWp.PropertyId)[(0, $bjdWp.PropertyId).SpeechServiceConnection_ProxyPassword], proxyPassword);
    }
    setServiceProperty(name, value) {
        const currentProperties = JSON.parse(this.privProperties.getProperty((0, $jSpbe.ServicePropertiesPropertyName), "{}"));
        currentProperties[name] = value;
        this.privProperties.setProperty((0, $jSpbe.ServicePropertiesPropertyName), JSON.stringify(currentProperties));
    }
    setProfanity(profanity) {
        this.privProperties.setProperty((0, $bjdWp.PropertyId).SpeechServiceResponse_ProfanityOption, (0, $b3w2H.ProfanityOption)[profanity]);
    }
    enableAudioLogging() {
        this.privProperties.setProperty((0, $bjdWp.PropertyId).SpeechServiceConnection_EnableAudioLogging, "true");
    }
    requestWordLevelTimestamps() {
        this.privProperties.setProperty((0, $bjdWp.PropertyId).SpeechServiceResponse_RequestWordLevelTimestamps, "true");
    }
    enableDictation() {
        this.privProperties.setProperty((0, $jSpbe.ForceDictationPropertyName), "true");
    }
    clone() {
        const ret = new $ab602b7cdabf679d$export$974c5658476a7259();
        ret.privProperties = this.privProperties.clone();
        return ret;
    }
    get speechSynthesisLanguage() {
        return this.privProperties.getProperty((0, $bjdWp.PropertyId).SpeechServiceConnection_SynthLanguage);
    }
    set speechSynthesisLanguage(language) {
        this.privProperties.setProperty((0, $bjdWp.PropertyId).SpeechServiceConnection_SynthLanguage, language);
    }
    get speechSynthesisVoiceName() {
        return this.privProperties.getProperty((0, $bjdWp.PropertyId).SpeechServiceConnection_SynthVoice);
    }
    set speechSynthesisVoiceName(voice) {
        this.privProperties.setProperty((0, $bjdWp.PropertyId).SpeechServiceConnection_SynthVoice, voice);
    }
    get speechSynthesisOutputFormat() {
        return (0, $cyJfF.SpeechSynthesisOutputFormat)[this.privProperties.getProperty((0, $bjdWp.PropertyId).SpeechServiceConnection_SynthOutputFormat, undefined)];
    }
    set speechSynthesisOutputFormat(format) {
        this.privProperties.setProperty((0, $bjdWp.PropertyId).SpeechServiceConnection_SynthOutputFormat, (0, $cyJfF.SpeechSynthesisOutputFormat)[format]);
    }
}

});
parcelRequire.register("b3w2H", function(module, exports) {

$parcel$export(module.exports, "ProfanityOption", () => $80c8d47e757e2663$export$84f426873273f221);
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
/**
 * Profanity option.
 * Added in version 1.7.0.
 */ var $80c8d47e757e2663$export$84f426873273f221;
(function(ProfanityOption) {
    ProfanityOption[ProfanityOption["Masked"] = 0] = "Masked";
    ProfanityOption[ProfanityOption["Removed"] = 1] = "Removed";
    ProfanityOption[ProfanityOption["Raw"] = 2] = "Raw";
})($80c8d47e757e2663$export$84f426873273f221 || ($80c8d47e757e2663$export$84f426873273f221 = {}));

});



parcelRequire.register("fT2Hj", function(module, exports) {

$parcel$export(module.exports, "TurnStatusReceivedEventArgs", () => $b90e15c5bcec747a$export$5ce0e8ca4b442b8a);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.

var $6rnCN = parcelRequire("6rnCN");
class $b90e15c5bcec747a$export$5ce0e8ca4b442b8a {
    /**
     * Creates and initializes an instance of this class.
     * @constructor
     * @param {string} turnStatus - The JSON-encoded turn status message.
     */ constructor(turnStatus){
        this.privTurnStatus = (0, $6rnCN.TurnStatusResponsePayload).fromJSON(turnStatus);
    }
    /**
     * Gets the interaction identifier associated with this turn status event.
     * @member TurnStatusReceivedEventArgs.prototype.interactionId
     * @function
     * @public
     * @returns {any} the received interaction id.
     */ get interactionId() {
        return this.privTurnStatus.interactionId;
    }
    /**
     * Gets the conversation identifier associated with this turn status event.
     * @member TurnStatusReceivedEventArgs.prototype.conversationId
     * @function
     * @public
     * @returns {any} the received conversation id.
     */ get conversationId() {
        return this.privTurnStatus.conversationId;
    }
    /**
     * Gets the received turn status code.
     * @member TurnStatusReceivedEventArgs.prototype.statusCode
     * @function
     * @public
     * @returns {number} the received turn status.
     */ get statusCode() {
        return this.privTurnStatus.statusCode; // eslint-disable-line @typescript-eslint/no-unsafe-return
    }
}

});
parcelRequire.register("6rnCN", function(module, exports) {

$parcel$export(module.exports, "TurnStatusResponsePayload", () => $4b07970d5509ff6c$export$844c4df474757a2d);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
class $4b07970d5509ff6c$export$844c4df474757a2d {
    constructor(json){
        this.privMessageStatusResponse = JSON.parse(json);
    }
    static fromJSON(json) {
        return new $4b07970d5509ff6c$export$844c4df474757a2d(json);
    }
    get interactionId() {
        return this.privMessageStatusResponse.interactionId;
    }
    get conversationId() {
        return this.privMessageStatusResponse.conversationId;
    }
    get statusCode() {
        // Payloads may contain a limited set of textual representations or a numeric status
        // code. The textual values are here converted into numeric ones.
        switch(this.privMessageStatusResponse.statusCode){
            case "Success":
                return 200;
            case "Failed":
                return 400;
            case "TimedOut":
                return 429;
            default:
                // eslint-disable-next-line @typescript-eslint/no-unsafe-return
                return this.privMessageStatusResponse.statusCode;
        }
    }
}

});


parcelRequire.register("aFrAz", function(module, exports) {

$parcel$export(module.exports, "DialogServiceTurnStateManager", () => $7c43224fdd098c78$export$6277820b28ebdcfc);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.

var $83Xvm = parcelRequire("83Xvm");

var $gvIm7 = parcelRequire("gvIm7");
class $7c43224fdd098c78$export$6277820b28ebdcfc {
    constructor(){
        this.privTurnMap = new Map();
        return;
    }
    StartTurn(id) {
        if (this.privTurnMap.has(id)) throw new (0, $83Xvm.InvalidOperationError)("Service error: There is already a turn with id:" + id);
        const turnState = new (0, $gvIm7.DialogServiceTurnState)(this, id);
        this.privTurnMap.set(id, turnState);
        return this.privTurnMap.get(id);
    }
    GetTurn(id) {
        return this.privTurnMap.get(id);
    }
    CompleteTurn(id) {
        if (!this.privTurnMap.has(id)) throw new (0, $83Xvm.InvalidOperationError)("Service error: Received turn end for an unknown turn id:" + id);
        const turnState = this.privTurnMap.get(id);
        turnState.complete();
        this.privTurnMap.delete(id);
        return turnState;
    }
}

});
parcelRequire.register("gvIm7", function(module, exports) {

$parcel$export(module.exports, "DialogServiceTurnState", () => $c051f2b3ea27b1eb$export$3bb70bcf565a069a);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.

var $gFkNt = parcelRequire("gFkNt");

var $isMcl = parcelRequire("isMcl");

var $9ly0x = parcelRequire("9ly0x");
class $c051f2b3ea27b1eb$export$3bb70bcf565a069a {
    constructor(manager, requestId){
        this.privRequestId = requestId;
        this.privIsCompleted = false;
        this.privAudioStream = null;
        this.privTurnManager = manager;
        this.resetTurnEndTimeout();
    }
    get audioStream() {
        // Called when is needed to stream.
        this.resetTurnEndTimeout();
        return this.privAudioStream;
    }
    processActivityPayload(payload, audioFormat) {
        if (payload.messageDataStreamType === (0, $9ly0x.MessageDataStreamType).TextToSpeechAudio) {
            this.privAudioStream = (0, $isMcl.AudioOutputStream).createPullStream();
            this.privAudioStream.format = audioFormat !== undefined ? audioFormat : (0, $gFkNt.AudioOutputFormatImpl).getDefaultOutputFormat();
        }
        return this.privAudioStream;
    }
    endAudioStream() {
        if (this.privAudioStream !== null && !this.privAudioStream.isClosed) this.privAudioStream.close();
    }
    complete() {
        if (this.privTimeoutToken !== undefined) // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
        clearTimeout(this.privTimeoutToken);
        this.endAudioStream();
    }
    resetTurnEndTimeout() {
        if (this.privTimeoutToken !== undefined) // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
        clearTimeout(this.privTimeoutToken);
        this.privTimeoutToken = setTimeout(()=>{
            this.privTurnManager.CompleteTurn(this.privRequestId);
            return;
        }, 2000);
    }
}

});
parcelRequire.register("isMcl", function(module, exports) {

$parcel$export(module.exports, "AudioOutputStream", () => $d7103aab518ae367$export$e0b7acef3648253f);
$parcel$export(module.exports, "PullAudioOutputStream", () => $d7103aab518ae367$export$bdc5f48d2816203a);
$parcel$export(module.exports, "PullAudioOutputStreamImpl", () => $d7103aab518ae367$export$ccb0817f052cc8c4);
$parcel$export(module.exports, "PushAudioOutputStream", () => $d7103aab518ae367$export$cabdb2d97c90043d);
$parcel$export(module.exports, "PushAudioOutputStreamImpl", () => $d7103aab518ae367$export$8469916a21360061);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
parcelRequire("cR8AB");
var $hsGnG = parcelRequire("hsGnG");
var $1T8k7 = parcelRequire("1T8k7");

var $8HmyV = parcelRequire("8HmyV");

var $gFkNt = parcelRequire("gFkNt");
var $d7103aab518ae367$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
class $d7103aab518ae367$export$e0b7acef3648253f {
    /**
     * Creates and initializes an instance.
     * @constructor
     */ constructor(){
        return;
    }
    /**
     * Creates a memory backed PullAudioOutputStream with the specified audio format.
     * @member AudioOutputStream.createPullStream
     * @function
     * @public
     * @returns {PullAudioOutputStream} The audio output stream being created.
     */ static createPullStream() {
        return $d7103aab518ae367$export$bdc5f48d2816203a.create();
    }
}
class $d7103aab518ae367$export$bdc5f48d2816203a extends $d7103aab518ae367$export$e0b7acef3648253f {
    /**
     * Creates a memory backed PullAudioOutputStream with the specified audio format.
     * @member PullAudioOutputStream.create
     * @function
     * @public
     * @returns {PullAudioOutputStream} The push audio output stream being created.
     */ static create() {
        return new $d7103aab518ae367$export$ccb0817f052cc8c4();
    }
}
class $d7103aab518ae367$export$ccb0817f052cc8c4 extends $d7103aab518ae367$export$bdc5f48d2816203a {
    /**
     * Creates and initializes an instance with the given values.
     * @constructor
     */ constructor(){
        super();
        this.privId = (0, $hsGnG.createNoDashGuid)();
        this.privStream = new (0, $1T8k7.Stream)();
    }
    /**
     * Sets the format information to the stream. For internal use only.
     * @param {AudioStreamFormat} format - the format to be set.
     */ set format(format) {
        if (format === undefined || format === null) this.privFormat = (0, $gFkNt.AudioOutputFormatImpl).getDefaultOutputFormat();
        this.privFormat = format;
    }
    /**
     * Format information for the audio
     */ get format() {
        return this.privFormat;
    }
    /**
     * Checks if the stream is closed
     * @member PullAudioOutputStreamImpl.prototype.isClosed
     * @property
     * @public
     */ get isClosed() {
        return this.privStream.isClosed;
    }
    /**
     * Gets the id of the stream
     * @member PullAudioOutputStreamImpl.prototype.id
     * @property
     * @public
     */ id() {
        return this.privId;
    }
    /**
     * Reads audio data from the internal buffer.
     * @member PullAudioOutputStreamImpl.prototype.read
     * @function
     * @public
     * @param {ArrayBuffer} dataBuffer - An ArrayBuffer to store the read data.
     * @returns {Promise<number>} - Audio buffer length has been read.
     */ read(dataBuffer) {
        return $d7103aab518ae367$var$__awaiter(this, void 0, void 0, function*() {
            const intView = new Int8Array(dataBuffer);
            let totalBytes = 0;
            if (this.privLastChunkView !== undefined) {
                if (this.privLastChunkView.length > dataBuffer.byteLength) {
                    intView.set(this.privLastChunkView.slice(0, dataBuffer.byteLength));
                    this.privLastChunkView = this.privLastChunkView.slice(dataBuffer.byteLength);
                    return Promise.resolve(dataBuffer.byteLength);
                }
                intView.set(this.privLastChunkView);
                totalBytes = this.privLastChunkView.length;
                this.privLastChunkView = undefined;
            }
            // Until we have the minimum number of bytes to send in a transmission, keep asking for more.
            while(totalBytes < dataBuffer.byteLength && !this.privStream.isReadEnded){
                const chunk = yield this.privStream.read();
                if (chunk !== undefined && !chunk.isEnd) {
                    let tmpBuffer;
                    if (chunk.buffer.byteLength > dataBuffer.byteLength - totalBytes) {
                        tmpBuffer = chunk.buffer.slice(0, dataBuffer.byteLength - totalBytes);
                        this.privLastChunkView = new Int8Array(chunk.buffer.slice(dataBuffer.byteLength - totalBytes));
                    } else tmpBuffer = chunk.buffer;
                    intView.set(new Int8Array(tmpBuffer), totalBytes);
                    totalBytes += tmpBuffer.byteLength;
                } else this.privStream.readEnded();
            }
            return totalBytes;
        });
    }
    /**
     * Writes the audio data specified by making an internal copy of the data.
     * @member PullAudioOutputStreamImpl.prototype.write
     * @function
     * @public
     * @param {ArrayBuffer} dataBuffer - The audio buffer of which this function will make a copy.
     */ write(dataBuffer) {
        (0, $8HmyV.Contracts).throwIfNullOrUndefined(this.privStream, "must set format before writing");
        this.privStream.writeStreamChunk({
            buffer: dataBuffer,
            isEnd: false,
            timeReceived: Date.now()
        });
    }
    /**
     * Closes the stream.
     * @member PullAudioOutputStreamImpl.prototype.close
     * @function
     * @public
     */ close() {
        this.privStream.close();
    }
}
class $d7103aab518ae367$export$cabdb2d97c90043d extends $d7103aab518ae367$export$e0b7acef3648253f {
    /**
     * Creates and initializes and instance.
     * @constructor
     */ constructor(){
        super();
    }
    /**
     * Creates a PushAudioOutputStream that delegates to the specified callback interface for
     * write() and close() methods.
     * @member PushAudioOutputStream.create
     * @function
     * @public
     * @param {PushAudioOutputStreamCallback} callback - The custom audio output object,
     * derived from PushAudioOutputStreamCallback
     * @returns {PushAudioOutputStream} The push audio output stream being created.
     */ static create(callback) {
        return new $d7103aab518ae367$export$8469916a21360061(callback);
    }
}
class $d7103aab518ae367$export$8469916a21360061 extends $d7103aab518ae367$export$cabdb2d97c90043d {
    /**
     * Creates a PushAudioOutputStream that delegates to the specified callback interface for
     * read() and close() methods.
     * @constructor
     * @param {PushAudioOutputStreamCallback} callback - The custom audio output object,
     * derived from PushAudioOutputStreamCallback
     */ constructor(callback){
        super();
        this.privId = (0, $hsGnG.createNoDashGuid)();
        this.privCallback = callback;
    }
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    set format(format) {}
    write(buffer) {
        if (!!this.privCallback.write) this.privCallback.write(buffer);
    }
    close() {
        if (!!this.privCallback.close) this.privCallback.close();
    }
    id() {
        return this.privId;
    }
}

});

parcelRequire.register("9ly0x", function(module, exports) {

$parcel$export(module.exports, "ActivityPayloadResponse", () => $6ce0746db4107f96$export$32a9af590766ce14);
$parcel$export(module.exports, "MessageDataStreamType", () => $6ce0746db4107f96$export$f73f8c1ce60bb199);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
// response
class $6ce0746db4107f96$export$32a9af590766ce14 {
    constructor(json){
        this.privActivityResponse = JSON.parse(json);
    }
    static fromJSON(json) {
        return new $6ce0746db4107f96$export$32a9af590766ce14(json);
    }
    get conversationId() {
        return this.privActivityResponse.conversationId;
    }
    get messageDataStreamType() {
        return this.privActivityResponse.messageDataStreamType;
    }
    get messagePayload() {
        return this.privActivityResponse.messagePayload;
    }
    get version() {
        return this.privActivityResponse.version;
    }
}
var $6ce0746db4107f96$export$f73f8c1ce60bb199;
(function(MessageDataStreamType) {
    MessageDataStreamType[MessageDataStreamType["None"] = 0] = "None";
    MessageDataStreamType[MessageDataStreamType["TextToSpeechAudio"] = 1] = "TextToSpeechAudio";
})($6ce0746db4107f96$export$f73f8c1ce60bb199 || ($6ce0746db4107f96$export$f73f8c1ce60bb199 = {}));

});




parcelRequire.register("gBeX5", function(module, exports) {

$parcel$export(module.exports, "AgentConfig", () => $c15bb3349a9ed539$export$561104de51a59cce);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
/**
 * Represents the JSON used in the agent.config message sent to the speech service.
 */ class $c15bb3349a9ed539$export$561104de51a59cce {
    toJsonString() {
        return JSON.stringify(this.iPrivConfig);
    }
    get() {
        return this.iPrivConfig;
    }
    /**
     * Setter for the agent.config object.
     * @param value a JSON serializable object.
     */ set(value) {
        this.iPrivConfig = value;
    }
}

});

parcelRequire.register("irXhw", function(module, exports) {

$parcel$export(module.exports, "MetadataType", () => $d6e8bbb8f53e36a2$export$aaf15ef60576e95);
$parcel$export(module.exports, "SynthesisAudioMetadata", () => $d6e8bbb8f53e36a2$export$82529c92128bfe6c);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
var $d6e8bbb8f53e36a2$export$aaf15ef60576e95;
(function(MetadataType) {
    MetadataType["WordBoundary"] = "WordBoundary";
    MetadataType["Bookmark"] = "Bookmark";
    MetadataType["Viseme"] = "Viseme";
    MetadataType["SentenceBoundary"] = "SentenceBoundary";
    MetadataType["SessionEnd"] = "SessionEnd";
})($d6e8bbb8f53e36a2$export$aaf15ef60576e95 || ($d6e8bbb8f53e36a2$export$aaf15ef60576e95 = {}));
class $d6e8bbb8f53e36a2$export$82529c92128bfe6c {
    constructor(json){
        this.privSynthesisAudioMetadata = JSON.parse(json);
    }
    static fromJSON(json) {
        return new $d6e8bbb8f53e36a2$export$82529c92128bfe6c(json);
    }
    get Metadata() {
        return this.privSynthesisAudioMetadata.Metadata;
    }
}

});

parcelRequire.register("cNneV", function(module, exports) {

$parcel$export(module.exports, "SynthesisTurn", () => $950c168e38b23901$export$ffc1d5309a5caa5f);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
parcelRequire("cR8AB");
var $hsGnG = parcelRequire("hsGnG");
var $2YVQf = parcelRequire("2YVQf");
var $4utc3 = parcelRequire("4utc3");

var $isMcl = parcelRequire("isMcl");

var $irXhw = parcelRequire("irXhw");

var $iuSgX = parcelRequire("iuSgX");

var $gkMCN = parcelRequire("gkMCN");
var $950c168e38b23901$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
class $950c168e38b23901$export$ffc1d5309a5caa5f {
    constructor(){
        this.privIsDisposed = false;
        this.privIsSynthesizing = false;
        this.privIsSynthesisEnded = false;
        this.privBytesReceived = 0;
        this.privInTurn = false;
        this.privTextOffset = 0;
        this.privNextSearchTextIndex = 0;
        this.privSentenceOffset = 0;
        this.privNextSearchSentenceIndex = 0;
        this.privRequestId = (0, $hsGnG.createNoDashGuid)();
        this.privTurnDeferral = new (0, $2YVQf.Deferred)();
        // We're not in a turn, so resolve.
        this.privTurnDeferral.resolve();
    }
    get requestId() {
        return this.privRequestId;
    }
    get streamId() {
        return this.privStreamId;
    }
    set streamId(value) {
        this.privStreamId = value;
    }
    get audioOutputFormat() {
        return this.privAudioOutputFormat;
    }
    set audioOutputFormat(format) {
        this.privAudioOutputFormat = format;
    }
    get turnCompletionPromise() {
        return this.privTurnDeferral.promise;
    }
    get isSynthesisEnded() {
        return this.privIsSynthesisEnded;
    }
    get isSynthesizing() {
        return this.privIsSynthesizing;
    }
    get currentTextOffset() {
        return this.privTextOffset;
    }
    get currentSentenceOffset() {
        return this.privSentenceOffset;
    }
    // The number of bytes received for current turn
    get bytesReceived() {
        return this.privBytesReceived;
    }
    get audioDuration() {
        return this.privAudioDuration;
    }
    getAllReceivedAudio() {
        return $950c168e38b23901$var$__awaiter(this, void 0, void 0, function*() {
            if (!!this.privReceivedAudio) return Promise.resolve(this.privReceivedAudio);
            if (!this.privIsSynthesisEnded) return null;
            yield this.readAllAudioFromStream();
            return Promise.resolve(this.privReceivedAudio);
        });
    }
    getAllReceivedAudioWithHeader() {
        return $950c168e38b23901$var$__awaiter(this, void 0, void 0, function*() {
            if (!!this.privReceivedAudioWithHeader) return this.privReceivedAudioWithHeader;
            if (!this.privIsSynthesisEnded) return null;
            if (this.audioOutputFormat.hasHeader) {
                const audio = yield this.getAllReceivedAudio();
                this.privReceivedAudioWithHeader = (0, $iuSgX.SynthesisAdapterBase).addHeader(audio, this.audioOutputFormat);
                return this.privReceivedAudioWithHeader;
            } else return this.getAllReceivedAudio();
        });
    }
    startNewSynthesis(requestId, rawText, isSSML, audioDestination) {
        this.privIsSynthesisEnded = false;
        this.privIsSynthesizing = true;
        this.privRequestId = requestId;
        this.privRawText = rawText;
        this.privIsSSML = isSSML;
        this.privAudioOutputStream = new (0, $isMcl.PullAudioOutputStreamImpl)();
        this.privAudioOutputStream.format = this.privAudioOutputFormat;
        this.privReceivedAudio = null;
        this.privReceivedAudioWithHeader = null;
        this.privBytesReceived = 0;
        this.privTextOffset = 0;
        this.privNextSearchTextIndex = 0;
        this.privSentenceOffset = 0;
        this.privNextSearchSentenceIndex = 0;
        this.privPartialVisemeAnimation = "";
        if (audioDestination !== undefined) {
            this.privTurnAudioDestination = audioDestination;
            this.privTurnAudioDestination.format = this.privAudioOutputFormat;
        }
        this.onEvent(new (0, $gkMCN.SynthesisTriggeredEvent)(this.requestId, undefined, audioDestination === undefined ? undefined : audioDestination.id()));
    }
    onPreConnectionStart(authFetchEventId) {
        this.privAuthFetchEventId = authFetchEventId;
        this.onEvent(new (0, $gkMCN.ConnectingToSynthesisServiceEvent)(this.privRequestId, this.privAuthFetchEventId));
    }
    onAuthCompleted(isError) {
        if (isError) this.onComplete();
    }
    onConnectionEstablishCompleted(statusCode) {
        if (statusCode === 200) {
            this.onEvent(new (0, $gkMCN.SynthesisStartedEvent)(this.requestId, this.privAuthFetchEventId));
            this.privBytesReceived = 0;
            return;
        } else if (statusCode === 403) this.onComplete();
    }
    onServiceResponseMessage(responseJson) {
        const response = JSON.parse(responseJson);
        this.streamId = response.audio.streamId;
    }
    onServiceTurnEndResponse() {
        this.privInTurn = false;
        this.privTurnDeferral.resolve();
        this.onComplete();
    }
    onServiceTurnStartResponse() {
        if (!!this.privTurnDeferral && !!this.privInTurn) {
            // What? How are we starting a turn with another not done?
            this.privTurnDeferral.reject("Another turn started before current completed.");
            // Avoid UnhandledPromiseRejection if privTurnDeferral is not being awaited
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            this.privTurnDeferral.promise.then().catch(()=>{});
        }
        this.privInTurn = true;
        this.privTurnDeferral = new (0, $2YVQf.Deferred)();
    }
    onAudioChunkReceived(data) {
        if (this.isSynthesizing) {
            this.privAudioOutputStream.write(data);
            this.privBytesReceived += data.byteLength;
            if (this.privTurnAudioDestination !== undefined) this.privTurnAudioDestination.write(data);
        }
    }
    onTextBoundaryEvent(metadata) {
        this.updateTextOffset(metadata.Data.text.Text, metadata.Type);
    }
    onVisemeMetadataReceived(metadata) {
        if (metadata.Data.AnimationChunk !== undefined) this.privPartialVisemeAnimation += metadata.Data.AnimationChunk;
    }
    onSessionEnd(metadata) {
        this.privAudioDuration = metadata.Data.Offset;
    }
    dispose() {
        if (!this.privIsDisposed) // we should have completed by now. If we did not its an unknown error.
        this.privIsDisposed = true;
    }
    onStopSynthesizing() {
        this.onComplete();
    }
    /**
     * Gets the viseme animation string (merged from animation chunk), and clears the internal
     * partial animation.
     */ getAndClearVisemeAnimation() {
        const animation = this.privPartialVisemeAnimation;
        this.privPartialVisemeAnimation = "";
        return animation;
    }
    onEvent(event) {
        (0, $4utc3.Events).instance.onEvent(event);
    }
    /**
     * Check if the text is an XML(SSML) tag
     * @param text
     * @private
     */ static isXmlTag(text) {
        return text.length >= 2 && text[0] === "<" && text[text.length - 1] === ">";
    }
    updateTextOffset(text, type) {
        if (type === (0, $irXhw.MetadataType).WordBoundary) {
            this.privTextOffset = this.privRawText.indexOf(text, this.privNextSearchTextIndex);
            if (this.privTextOffset >= 0) {
                this.privNextSearchTextIndex = this.privTextOffset + text.length;
                if (this.privIsSSML) {
                    if (this.withinXmlTag(this.privTextOffset) && !$950c168e38b23901$export$ffc1d5309a5caa5f.isXmlTag(text)) this.updateTextOffset(text, type);
                }
            }
        } else {
            this.privSentenceOffset = this.privRawText.indexOf(text, this.privNextSearchSentenceIndex);
            if (this.privSentenceOffset >= 0) {
                this.privNextSearchSentenceIndex = this.privSentenceOffset + text.length;
                if (this.privIsSSML) {
                    if (this.withinXmlTag(this.privSentenceOffset) && !$950c168e38b23901$export$ffc1d5309a5caa5f.isXmlTag(text)) this.updateTextOffset(text, type);
                }
            }
        }
    }
    onComplete() {
        if (this.privIsSynthesizing) {
            this.privIsSynthesizing = false;
            this.privIsSynthesisEnded = true;
            this.privAudioOutputStream.close();
            this.privInTurn = false;
            if (this.privTurnAudioDestination !== undefined) {
                this.privTurnAudioDestination.close();
                this.privTurnAudioDestination = undefined;
            }
        }
    }
    readAllAudioFromStream() {
        return $950c168e38b23901$var$__awaiter(this, void 0, void 0, function*() {
            if (this.privIsSynthesisEnded) {
                this.privReceivedAudio = new ArrayBuffer(this.bytesReceived);
                try {
                    yield this.privAudioOutputStream.read(this.privReceivedAudio);
                } catch (e) {
                    this.privReceivedAudio = new ArrayBuffer(0);
                }
            }
        });
    }
    /**
     * Check if current idx is in XML(SSML) tag
     * @param idx
     * @private
     */ withinXmlTag(idx) {
        return this.privRawText.indexOf("<", idx + 1) > this.privRawText.indexOf(">", idx + 1);
    }
}

});
parcelRequire.register("iuSgX", function(module, exports) {

$parcel$export(module.exports, "SynthesisAdapterBase", () => $d77520bc15e0df43$export$6a9ae5f91b217634);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
parcelRequire("cR8AB");
var $83Xvm = parcelRequire("83Xvm");
var $dxrNf = parcelRequire("dxrNf");
var $jQZQm = parcelRequire("jQZQm");
var $ieLRH = parcelRequire("ieLRH");
var $1v63k = parcelRequire("1v63k");
var $hsGnG = parcelRequire("hsGnG");

var $lnpwm = parcelRequire("lnpwm");
var $5idXV = parcelRequire("5idXV");
var $3fCi1 = parcelRequire("3fCi1");
var $bjdWp = parcelRequire("bjdWp");
var $9Wq4L = parcelRequire("9Wq4L");
var $fle1C = parcelRequire("fle1C");
var $gM5V8 = parcelRequire("gM5V8");
var $dVnb4 = parcelRequire("dVnb4");
var $5Omek = parcelRequire("5Omek");
var $gIPz7 = parcelRequire("gIPz7");
parcelRequire("jSpbe");
var $cNneV = parcelRequire("cNneV");
var $6u2b1 = parcelRequire("6u2b1");
var $gBeX5 = parcelRequire("gBeX5");
var $jSpbe = parcelRequire("jSpbe");
var $irXhw = parcelRequire("irXhw");

var $l4rU0 = parcelRequire("l4rU0");
var $d77520bc15e0df43$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
class $d77520bc15e0df43$export$6a9ae5f91b217634 {
    constructor(authentication, connectionFactory, synthesizerConfig, speechSynthesizer, audioDestination){
        this.speakOverride = undefined;
        this.receiveMessageOverride = undefined;
        this.connectImplOverride = undefined;
        this.configConnectionOverride = undefined;
        // A promise for a configured connection.
        // Do not consume directly, call fetchConnection instead.
        this.privConnectionConfigurationPromise = undefined;
        if (!authentication) throw new (0, $83Xvm.ArgumentNullError)("authentication");
        if (!connectionFactory) throw new (0, $83Xvm.ArgumentNullError)("connectionFactory");
        if (!synthesizerConfig) throw new (0, $83Xvm.ArgumentNullError)("synthesizerConfig");
        this.privAuthentication = authentication;
        this.privConnectionFactory = connectionFactory;
        this.privSynthesizerConfig = synthesizerConfig;
        this.privIsDisposed = false;
        this.privSpeechSynthesizer = speechSynthesizer;
        this.privSessionAudioDestination = audioDestination;
        this.privSynthesisTurn = new (0, $cNneV.SynthesisTurn)();
        this.privConnectionEvents = new (0, $dxrNf.EventSource)();
        this.privServiceEvents = new (0, $dxrNf.EventSource)();
        this.privSynthesisContext = new (0, $6u2b1.SynthesisContext)(this.privSpeechSynthesizer);
        this.privAgentConfig = new (0, $gBeX5.AgentConfig)();
        this.connectionEvents.attach((connectionEvent)=>{
            if (connectionEvent.name === "ConnectionClosedEvent") {
                const connectionClosedEvent = connectionEvent;
                if (connectionClosedEvent.statusCode !== 1000) this.cancelSynthesisLocal((0, $5idXV.CancellationReason).Error, connectionClosedEvent.statusCode === 1007 ? (0, $lnpwm.CancellationErrorCode).BadRequestParameters : (0, $lnpwm.CancellationErrorCode).ConnectionFailure, `${connectionClosedEvent.reason} websocket error code: ${connectionClosedEvent.statusCode}`);
            }
        });
    }
    get synthesisContext() {
        return this.privSynthesisContext;
    }
    get agentConfig() {
        return this.privAgentConfig;
    }
    get connectionEvents() {
        return this.privConnectionEvents;
    }
    get serviceEvents() {
        return this.privServiceEvents;
    }
    set activityTemplate(messagePayload) {
        this.privActivityTemplate = messagePayload;
    }
    get activityTemplate() {
        return this.privActivityTemplate;
    }
    set audioOutputFormat(format) {
        this.privAudioOutputFormat = format;
        this.privSynthesisTurn.audioOutputFormat = format;
        if (this.privSessionAudioDestination !== undefined) this.privSessionAudioDestination.format = format;
        if (this.synthesisContext !== undefined) this.synthesisContext.audioOutputFormat = format;
    }
    static addHeader(audio, format) {
        if (!format.hasHeader) return audio;
        format.updateHeader(audio.byteLength);
        const tmp = new Uint8Array(audio.byteLength + format.header.byteLength);
        tmp.set(new Uint8Array(format.header), 0);
        tmp.set(new Uint8Array(audio), format.header.byteLength);
        return tmp.buffer;
    }
    isDisposed() {
        return this.privIsDisposed;
    }
    dispose(reason) {
        return $d77520bc15e0df43$var$__awaiter(this, void 0, void 0, function*() {
            this.privIsDisposed = true;
            if (this.privSessionAudioDestination !== undefined) this.privSessionAudioDestination.close();
            if (this.privConnectionConfigurationPromise !== undefined) {
                const connection = yield this.privConnectionConfigurationPromise;
                yield connection.dispose(reason);
            }
        });
    }
    connect() {
        return $d77520bc15e0df43$var$__awaiter(this, void 0, void 0, function*() {
            yield this.connectImpl();
        });
    }
    sendNetworkMessage(path, payload) {
        return $d77520bc15e0df43$var$__awaiter(this, void 0, void 0, function*() {
            const type = typeof payload === "string" ? (0, $jQZQm.MessageType).Text : (0, $jQZQm.MessageType).Binary;
            const contentType = typeof payload === "string" ? "application/json" : "";
            const connection = yield this.fetchConnection();
            return connection.send(new (0, $l4rU0.SpeechConnectionMessage)(type, path, this.privSynthesisTurn.requestId, contentType, payload));
        });
    }
    Speak(text, isSSML, requestId, successCallback, errorCallBack, audioDestination) {
        return $d77520bc15e0df43$var$__awaiter(this, void 0, void 0, function*() {
            let ssml;
            if (isSSML) ssml = text;
            else ssml = this.privSpeechSynthesizer.buildSsml(text);
            if (this.speakOverride !== undefined) return this.speakOverride(ssml, requestId, successCallback, errorCallBack);
            this.privSuccessCallback = successCallback;
            this.privErrorCallback = errorCallBack;
            this.privSynthesisTurn.startNewSynthesis(requestId, text, isSSML, audioDestination);
            try {
                yield this.connectImpl();
                const connection = yield this.fetchConnection();
                yield this.sendSynthesisContext(connection);
                yield this.sendSsmlMessage(connection, ssml, requestId);
                const synthesisStartEventArgs = new (0, $gM5V8.SpeechSynthesisEventArgs)(new (0, $dVnb4.SpeechSynthesisResult)(requestId, (0, $9Wq4L.ResultReason).SynthesizingAudioStarted));
                if (!!this.privSpeechSynthesizer.synthesisStarted) this.privSpeechSynthesizer.synthesisStarted(this.privSpeechSynthesizer, synthesisStartEventArgs);
                this.receiveMessage();
            } catch (e) {
                this.cancelSynthesisLocal((0, $5idXV.CancellationReason).Error, (0, $lnpwm.CancellationErrorCode).ConnectionFailure, e);
                return Promise.reject(e);
            }
        });
    }
    // Cancels synthesis.
    cancelSynthesis(requestId, cancellationReason, errorCode, error) {
        const properties = new (0, $3fCi1.PropertyCollection)();
        properties.setProperty((0, $jSpbe.CancellationErrorCodePropertyName), (0, $lnpwm.CancellationErrorCode)[errorCode]);
        const result = new (0, $dVnb4.SpeechSynthesisResult)(requestId, (0, $9Wq4L.ResultReason).Canceled, undefined, error, properties);
        if (!!this.privSpeechSynthesizer.SynthesisCanceled) {
            const cancelEvent = new (0, $gM5V8.SpeechSynthesisEventArgs)(result);
            try {
                this.privSpeechSynthesizer.SynthesisCanceled(this.privSpeechSynthesizer, cancelEvent);
            /* eslint-disable no-empty */ } catch (_a) {}
        }
        if (!!this.privSuccessCallback) try {
            this.privSuccessCallback(result);
        /* eslint-disable no-empty */ } catch (_b) {}
    }
    // Cancels synthesis.
    cancelSynthesisLocal(cancellationReason, errorCode, error) {
        if (!!this.privSynthesisTurn.isSynthesizing) {
            this.privSynthesisTurn.onStopSynthesizing();
            this.cancelSynthesis(this.privSynthesisTurn.requestId, cancellationReason, errorCode, error);
        }
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    processTypeSpecificMessages(connectionMessage) {
        return true;
    }
    receiveMessage() {
        return $d77520bc15e0df43$var$__awaiter(this, void 0, void 0, function*() {
            try {
                const connection = yield this.fetchConnection();
                const message = yield connection.read();
                if (this.receiveMessageOverride !== undefined) return this.receiveMessageOverride();
                if (this.privIsDisposed) // We're done.
                return;
                // indicates we are draining the queue and it came with no message;
                if (!message) {
                    if (!this.privSynthesisTurn.isSynthesizing) return;
                    else return this.receiveMessage();
                }
                const connectionMessage = (0, $l4rU0.SpeechConnectionMessage).fromConnectionMessage(message);
                if (connectionMessage.requestId.toLowerCase() === this.privSynthesisTurn.requestId.toLowerCase()) switch(connectionMessage.path.toLowerCase()){
                    case "turn.start":
                        this.privSynthesisTurn.onServiceTurnStartResponse();
                        break;
                    case "response":
                        this.privSynthesisTurn.onServiceResponseMessage(connectionMessage.textBody);
                        break;
                    case "audio":
                        if (this.privSynthesisTurn.streamId.toLowerCase() === connectionMessage.streamId.toLowerCase() && !!connectionMessage.binaryBody) {
                            this.privSynthesisTurn.onAudioChunkReceived(connectionMessage.binaryBody);
                            if (!!this.privSpeechSynthesizer.synthesizing) try {
                                const audioWithHeader = $d77520bc15e0df43$export$6a9ae5f91b217634.addHeader(connectionMessage.binaryBody, this.privSynthesisTurn.audioOutputFormat);
                                const ev = new (0, $gM5V8.SpeechSynthesisEventArgs)(new (0, $dVnb4.SpeechSynthesisResult)(this.privSynthesisTurn.requestId, (0, $9Wq4L.ResultReason).SynthesizingAudio, audioWithHeader));
                                this.privSpeechSynthesizer.synthesizing(this.privSpeechSynthesizer, ev);
                            } catch (error) {
                            // Not going to let errors in the event handler
                            // trip things up.
                            }
                            if (this.privSessionAudioDestination !== undefined) this.privSessionAudioDestination.write(connectionMessage.binaryBody);
                        }
                        break;
                    case "audio.metadata":
                        const metadataList = (0, $irXhw.SynthesisAudioMetadata).fromJSON(connectionMessage.textBody).Metadata;
                        for (const metadata of metadataList)switch(metadata.Type){
                            case (0, $irXhw.MetadataType).WordBoundary:
                            case (0, $irXhw.MetadataType).SentenceBoundary:
                                this.privSynthesisTurn.onTextBoundaryEvent(metadata);
                                const wordBoundaryEventArgs = new (0, $gIPz7.SpeechSynthesisWordBoundaryEventArgs)(metadata.Data.Offset, metadata.Data.Duration, metadata.Data.text.Text, metadata.Data.text.Length, metadata.Type === (0, $irXhw.MetadataType).WordBoundary ? this.privSynthesisTurn.currentTextOffset : this.privSynthesisTurn.currentSentenceOffset, metadata.Data.text.BoundaryType);
                                if (!!this.privSpeechSynthesizer.wordBoundary) try {
                                    this.privSpeechSynthesizer.wordBoundary(this.privSpeechSynthesizer, wordBoundaryEventArgs);
                                } catch (error) {
                                // Not going to let errors in the event handler
                                // trip things up.
                                }
                                break;
                            case (0, $irXhw.MetadataType).Bookmark:
                                const bookmarkEventArgs = new (0, $fle1C.SpeechSynthesisBookmarkEventArgs)(metadata.Data.Offset, metadata.Data.Bookmark);
                                if (!!this.privSpeechSynthesizer.bookmarkReached) try {
                                    this.privSpeechSynthesizer.bookmarkReached(this.privSpeechSynthesizer, bookmarkEventArgs);
                                } catch (error) {
                                // Not going to let errors in the event handler
                                // trip things up.
                                }
                                break;
                            case (0, $irXhw.MetadataType).Viseme:
                                this.privSynthesisTurn.onVisemeMetadataReceived(metadata);
                                if (metadata.Data.IsLastAnimation) {
                                    const visemeEventArgs = new (0, $5Omek.SpeechSynthesisVisemeEventArgs)(metadata.Data.Offset, metadata.Data.VisemeId, this.privSynthesisTurn.getAndClearVisemeAnimation());
                                    if (!!this.privSpeechSynthesizer.visemeReceived) try {
                                        this.privSpeechSynthesizer.visemeReceived(this.privSpeechSynthesizer, visemeEventArgs);
                                    } catch (error) {
                                    // Not going to let errors in the event handler
                                    // trip things up.
                                    }
                                }
                                break;
                            case (0, $irXhw.MetadataType).SessionEnd:
                                this.privSynthesisTurn.onSessionEnd(metadata);
                                break;
                        }
                        break;
                    case "turn.end":
                        this.privSynthesisTurn.onServiceTurnEndResponse();
                        let result;
                        try {
                            const audioBuffer = yield this.privSynthesisTurn.getAllReceivedAudioWithHeader();
                            result = new (0, $dVnb4.SpeechSynthesisResult)(this.privSynthesisTurn.requestId, (0, $9Wq4L.ResultReason).SynthesizingAudioCompleted, audioBuffer, undefined, undefined, this.privSynthesisTurn.audioDuration);
                            if (!!this.privSuccessCallback) this.privSuccessCallback(result);
                        } catch (error) {
                            if (!!this.privErrorCallback) this.privErrorCallback(error);
                        }
                        if (this.privSpeechSynthesizer.synthesisCompleted) try {
                            this.privSpeechSynthesizer.synthesisCompleted(this.privSpeechSynthesizer, new (0, $gM5V8.SpeechSynthesisEventArgs)(result));
                        } catch (e) {
                        // Not going to let errors in the event handler
                        // trip things up.
                        }
                        break;
                    default:
                        if (!this.processTypeSpecificMessages(connectionMessage)) // here are some messages that the derived class has not processed, dispatch them to connect class
                        {
                            if (!!this.privServiceEvents) this.serviceEvents.onEvent(new (0, $ieLRH.ServiceEvent)(connectionMessage.path.toLowerCase(), connectionMessage.textBody));
                        }
                }
                return this.receiveMessage();
            } catch (e) {
            // TODO: What goes here?
            }
        });
    }
    sendSynthesisContext(connection) {
        const synthesisContextJson = this.synthesisContext.toJSON();
        if (synthesisContextJson) return connection.send(new (0, $l4rU0.SpeechConnectionMessage)((0, $jQZQm.MessageType).Text, "synthesis.context", this.privSynthesisTurn.requestId, "application/json", synthesisContextJson));
        return;
    }
    connectImpl(isUnAuthorized = false) {
        if (this.privConnectionPromise != null) return this.privConnectionPromise.then((connection)=>{
            if (connection.state() === (0, $1v63k.ConnectionState).Disconnected) {
                this.privConnectionId = null;
                this.privConnectionPromise = null;
                return this.connectImpl();
            }
            return this.privConnectionPromise;
        }, ()=>{
            this.privConnectionId = null;
            this.privConnectionPromise = null;
            return this.connectImpl();
        });
        this.privAuthFetchEventId = (0, $hsGnG.createNoDashGuid)();
        this.privConnectionId = (0, $hsGnG.createNoDashGuid)();
        this.privSynthesisTurn.onPreConnectionStart(this.privAuthFetchEventId);
        const authPromise = isUnAuthorized ? this.privAuthentication.fetchOnExpiry(this.privAuthFetchEventId) : this.privAuthentication.fetch(this.privAuthFetchEventId);
        this.privConnectionPromise = authPromise.then((result)=>$d77520bc15e0df43$var$__awaiter(this, void 0, void 0, function*() {
                this.privSynthesisTurn.onAuthCompleted(false);
                const connection = this.privConnectionFactory.create(this.privSynthesizerConfig, result, this.privConnectionId);
                // Attach to the underlying event. No need to hold onto the detach pointers as in the event the connection goes away,
                // it'll stop sending events.
                connection.events.attach((event)=>{
                    this.connectionEvents.onEvent(event);
                });
                const response = yield connection.open();
                if (response.statusCode === 200) {
                    this.privSynthesisTurn.onConnectionEstablishCompleted(response.statusCode);
                    return Promise.resolve(connection);
                } else if (response.statusCode === 403 && !isUnAuthorized) return this.connectImpl(true);
                else {
                    this.privSynthesisTurn.onConnectionEstablishCompleted(response.statusCode);
                    return Promise.reject(`Unable to contact server. StatusCode: ${response.statusCode}, ${this.privSynthesizerConfig.parameters.getProperty((0, $bjdWp.PropertyId).SpeechServiceConnection_Endpoint)} Reason: ${response.reason}`);
                }
            }), (error)=>{
            this.privSynthesisTurn.onAuthCompleted(true);
            throw new Error(error);
        });
        // Attach an empty handler to allow the promise to run in the background while
        // other startup events happen. It'll eventually be awaited on.
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        this.privConnectionPromise.catch(()=>{});
        return this.privConnectionPromise;
    }
    sendSpeechServiceConfig(connection, SpeechServiceConfigJson) {
        if (SpeechServiceConfigJson) return connection.send(new (0, $l4rU0.SpeechConnectionMessage)((0, $jQZQm.MessageType).Text, "speech.config", this.privSynthesisTurn.requestId, "application/json", SpeechServiceConfigJson));
    }
    sendSsmlMessage(connection, ssml, requestId) {
        return connection.send(new (0, $l4rU0.SpeechConnectionMessage)((0, $jQZQm.MessageType).Text, "ssml", requestId, "application/ssml+xml", ssml));
    }
    fetchConnection() {
        return $d77520bc15e0df43$var$__awaiter(this, void 0, void 0, function*() {
            if (this.privConnectionConfigurationPromise !== undefined) return this.privConnectionConfigurationPromise.then((connection)=>{
                if (connection.state() === (0, $1v63k.ConnectionState).Disconnected) {
                    this.privConnectionId = null;
                    this.privConnectionConfigurationPromise = undefined;
                    return this.fetchConnection();
                }
                return this.privConnectionConfigurationPromise;
            }, ()=>{
                this.privConnectionId = null;
                this.privConnectionConfigurationPromise = undefined;
                return this.fetchConnection();
            });
            this.privConnectionConfigurationPromise = this.configureConnection();
            return yield this.privConnectionConfigurationPromise;
        });
    }
    // Takes an established websocket connection to the endpoint and sends speech configuration information.
    configureConnection() {
        return $d77520bc15e0df43$var$__awaiter(this, void 0, void 0, function*() {
            const connection = yield this.connectImpl();
            if (this.configConnectionOverride !== undefined) return this.configConnectionOverride(connection);
            yield this.sendSpeechServiceConfig(connection, this.privSynthesizerConfig.SpeechServiceConfig.serialize());
            return connection;
        });
    }
}
$d77520bc15e0df43$export$6a9ae5f91b217634.telemetryDataEnabled = true;

});
parcelRequire.register("fle1C", function(module, exports) {

$parcel$export(module.exports, "SpeechSynthesisBookmarkEventArgs", () => $b2b3b24b352753fb$export$8f9389ce6b5310bb);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
/**
 * Defines contents of speech synthesis bookmark event.
 * @class SpeechSynthesisBookmarkEventArgs
 * Added in version 1.16.0
 */ class $b2b3b24b352753fb$export$8f9389ce6b5310bb {
    /**
     * Creates and initializes an instance of this class.
     * @constructor
     * @param {number} audioOffset - The audio offset.
     * @param {string} text - The bookmark text.
     */ constructor(audioOffset, text){
        this.privAudioOffset = audioOffset;
        this.privText = text;
    }
    /**
     * Specifies the audio offset.
     * @member SpeechSynthesisBookmarkEventArgs.prototype.audioOffset
     * @function
     * @public
     * @returns {number} the audio offset.
     */ get audioOffset() {
        return this.privAudioOffset;
    }
    /**
     * Specifies the bookmark.
     * @member SpeechSynthesisBookmarkEventArgs.prototype.text
     * @function
     * @public
     * @returns {string} the bookmark text.
     */ get text() {
        return this.privText;
    }
}

});

parcelRequire.register("gM5V8", function(module, exports) {

$parcel$export(module.exports, "SpeechSynthesisEventArgs", () => $c365b8ba934026e0$export$771b44dbfb6bc7af);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
/**
 * Defines contents of speech synthesis events.
 * @class SpeechSynthesisEventArgs
 * Added in version 1.11.0
 */ class $c365b8ba934026e0$export$771b44dbfb6bc7af {
    /**
     * Creates and initializes an instance of this class.
     * @constructor
     * @param {SpeechSynthesisResult} result - The speech synthesis result.
     */ constructor(result){
        this.privResult = result;
    }
    /**
     * Specifies the synthesis result.
     * @member SpeechSynthesisEventArgs.prototype.result
     * @function
     * @public
     * @returns {SpeechSynthesisResult} the synthesis result.
     */ get result() {
        return this.privResult;
    }
}

});

parcelRequire.register("dVnb4", function(module, exports) {

$parcel$export(module.exports, "SpeechSynthesisResult", () => $a23293caa792e77d$export$7483af638e01359e);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.

var $38DxL = parcelRequire("38DxL");
class $a23293caa792e77d$export$7483af638e01359e extends (0, $38DxL.SynthesisResult) {
    /**
     * Creates and initializes an instance of this class.
     * @constructor
     * @param {string} resultId - The result id.
     * @param {ResultReason} reason - The reason.
     * @param {ArrayBuffer} audioData - The synthesized audio binary.
     * @param {string} errorDetails - Error details, if provided.
     * @param {PropertyCollection} properties - Additional properties, if provided.
     * @param {number} audioDuration - The audio duration.
     */ constructor(resultId, reason, audioData, errorDetails, properties, audioDuration){
        super(resultId, reason, errorDetails, properties);
        this.privAudioData = audioData;
        this.privAudioDuration = audioDuration;
    }
    /**
     * The synthesized audio data
     * @member SpeechSynthesisResult.prototype.audioData
     * @function
     * @public
     * @returns {ArrayBuffer} The synthesized audio data.
     */ get audioData() {
        return this.privAudioData;
    }
    /**
     * The time duration of synthesized audio, in ticks (100 nanoseconds).
     * @member SpeechSynthesisResult.prototype.audioDuration
     * @function
     * @public
     * @returns {number} The time duration of synthesized audio.
     */ get audioDuration() {
        return this.privAudioDuration;
    }
}

});
parcelRequire.register("38DxL", function(module, exports) {

$parcel$export(module.exports, "SynthesisResult", () => $2490cafbd5dafd25$export$39f27198a7645486);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
/**
 * Base class for synthesis results
 * @class SynthesisResult
 * Added in version 1.20.0
 */ class $2490cafbd5dafd25$export$39f27198a7645486 {
    /**
     * Creates and initializes an instance of this class.
     * @constructor
     * @param {string} resultId - The result id.
     * @param {ResultReason} reason - The reason.
     * @param {string} errorDetails - Error details, if provided.
     * @param {PropertyCollection} properties - Additional properties, if provided.
     */ constructor(resultId, reason, errorDetails, properties){
        this.privResultId = resultId;
        this.privReason = reason;
        this.privErrorDetails = errorDetails;
        this.privProperties = properties;
    }
    /**
     * Specifies the result identifier.
     * @member SynthesisResult.prototype.resultId
     * @function
     * @public
     * @returns {string} Specifies the result identifier.
     */ get resultId() {
        return this.privResultId;
    }
    /**
     * Specifies status of the result.
     * @member SynthesisResult.prototype.reason
     * @function
     * @public
     * @returns {ResultReason} Specifies status of the result.
     */ get reason() {
        return this.privReason;
    }
    /**
     * In case of an unsuccessful synthesis, provides details of the occurred error.
     * @member SynthesisResult.prototype.errorDetails
     * @function
     * @public
     * @returns {string} a brief description of an error.
     */ get errorDetails() {
        return this.privErrorDetails;
    }
    /**
     * The set of properties exposed in the result.
     * @member SynthesisResult.prototype.properties
     * @function
     * @public
     * @returns {PropertyCollection} The set of properties exposed in the result.
     */ get properties() {
        return this.privProperties;
    }
}

});


parcelRequire.register("5Omek", function(module, exports) {

$parcel$export(module.exports, "SpeechSynthesisVisemeEventArgs", () => $43b2ddb1fb2aac03$export$bed102a9cb8b5da);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
/**
 * Defines contents of speech synthesis viseme event.
 * @class SpeechSynthesisVisemeEventArgs
 * Added in version 1.16.0
 */ class $43b2ddb1fb2aac03$export$bed102a9cb8b5da {
    /**
     * Creates and initializes an instance of this class.
     * @constructor
     * @param {number} audioOffset - The audio offset.
     * @param {number} visemeId - The viseme ID.
     * @param {string} animation - The animation, could be in svg or other format.
     */ constructor(audioOffset, visemeId, animation){
        this.privAudioOffset = audioOffset;
        this.privVisemeId = visemeId;
        this.privAnimation = animation;
    }
    /**
     * Specifies the audio offset.
     * @member SpeechSynthesisVisemeEventArgs.prototype.audioOffset
     * @function
     * @public
     * @returns {number} the audio offset.
     */ get audioOffset() {
        return this.privAudioOffset;
    }
    /**
     * Specifies the viseme ID.
     * @member SpeechSynthesisVisemeEventArgs.prototype.visemeId
     * @function
     * @public
     * @returns {number} the viseme ID.
     */ get visemeId() {
        return this.privVisemeId;
    }
    /**
     * Specifies the animation.
     * @member SpeechSynthesisVisemeEventArgs.prototype.animation
     * @function
     * @public
     * @returns {string} the animation, could be in svg or other format.
     */ get animation() {
        return this.privAnimation;
    }
}

});

parcelRequire.register("gIPz7", function(module, exports) {

$parcel$export(module.exports, "SpeechSynthesisWordBoundaryEventArgs", () => $c2c8c1374b2afc48$export$5baece3a3f21e6ae);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
/**
 * Defines contents of speech synthesis word boundary event.
 * @class SpeechSynthesisWordBoundaryEventArgs
 * Added in version 1.11.0
 */ class $c2c8c1374b2afc48$export$5baece3a3f21e6ae {
    /**
     * Creates and initializes an instance of this class.
     * @constructor
     * @param {number} audioOffset - The audio offset.
     * @param {number} duration - The audio duration.
     * @param {string} text - The text.
     * @param {number} wordLength - The length of the word.
     * @param {number} textOffset - The text offset.
     * @param {SpeechSynthesisBoundaryType} boundaryType - The boundary type
     */ constructor(audioOffset, duration, text, wordLength, textOffset, boundaryType){
        this.privAudioOffset = audioOffset;
        this.privDuration = duration;
        this.privText = text;
        this.privWordLength = wordLength;
        this.privTextOffset = textOffset;
        this.privBoundaryType = boundaryType;
    }
    /**
     * Specifies the audio offset.
     * @member SpeechSynthesisWordBoundaryEventArgs.prototype.audioOffset
     * @function
     * @public
     * @returns {number} the audio offset.
     */ get audioOffset() {
        return this.privAudioOffset;
    }
    /**
     * Specifies the duration, in ticks (100 nanoseconds).
     * @member SpeechSynthesisWordBoundaryEventArgs.prototype.duration
     * @function
     * @public
     * @returns {number} Duration in 100 nanosecond increments.
     */ get duration() {
        return this.privDuration;
    }
    /**
     * Specifies the text of the word boundary event.
     * @member SpeechSynthesisWordBoundaryEventArgs.prototype.text
     * @function
     * @public
     * @returns {string} the text.
     */ get text() {
        return this.privText;
    }
    /**
     * Specifies the word length
     * @member SpeechSynthesisWordBoundaryEventArgs.prototype.wordLength
     * @function
     * @public
     * @returns {number} the word length
     */ get wordLength() {
        return this.privWordLength;
    }
    /**
     * Specifies the text offset.
     * @member SpeechSynthesisWordBoundaryEventArgs.prototype.textOffset
     * @function
     * @public
     * @returns {number} the text offset.
     */ get textOffset() {
        return this.privTextOffset;
    }
    /**
     * Specifies the boundary type.
     * @member SpeechSynthesisWordBoundaryEventArgs.prototype.boundaryType
     * @function
     * @public
     * @returns {SpeechSynthesisBoundaryType} the boundary type.
     */ get boundaryType() {
        return this.privBoundaryType;
    }
}

});


parcelRequire.register("gkMCN", function(module, exports) {

$parcel$export(module.exports, "SynthesisTriggeredEvent", () => $be443b7a32e887e6$export$4bdadafede730bd5);
$parcel$export(module.exports, "ConnectingToSynthesisServiceEvent", () => $be443b7a32e887e6$export$2024970667be27b8);
$parcel$export(module.exports, "SynthesisStartedEvent", () => $be443b7a32e887e6$export$4aa6db8ac8b32039);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
/* eslint-disable max-classes-per-file */ parcelRequire("cR8AB");
var $6yPtW = parcelRequire("6yPtW");
class $be443b7a32e887e6$export$cd674f01be9bedfb extends (0, $6yPtW.PlatformEvent) {
    constructor(eventName, requestId, eventType = (0, $6yPtW.EventType).Info){
        super(eventName, eventType);
        this.privRequestId = requestId;
    }
    get requestId() {
        return this.privRequestId;
    }
}
class $be443b7a32e887e6$export$4bdadafede730bd5 extends $be443b7a32e887e6$export$cd674f01be9bedfb {
    constructor(requestId, sessionAudioDestinationId, turnAudioDestinationId){
        super("SynthesisTriggeredEvent", requestId);
        this.privSessionAudioDestinationId = sessionAudioDestinationId;
        this.privTurnAudioDestinationId = turnAudioDestinationId;
    }
    get audioSessionDestinationId() {
        return this.privSessionAudioDestinationId;
    }
    get audioTurnDestinationId() {
        return this.privTurnAudioDestinationId;
    }
}
class $be443b7a32e887e6$export$2024970667be27b8 extends $be443b7a32e887e6$export$cd674f01be9bedfb {
    constructor(requestId, authFetchEventId){
        super("ConnectingToSynthesisServiceEvent", requestId);
        this.privAuthFetchEventId = authFetchEventId;
    }
    get authFetchEventId() {
        return this.privAuthFetchEventId;
    }
}
class $be443b7a32e887e6$export$4aa6db8ac8b32039 extends $be443b7a32e887e6$export$cd674f01be9bedfb {
    constructor(requestId, authFetchEventId){
        super("SynthesisStartedEvent", requestId);
        this.privAuthFetchEventId = authFetchEventId;
    }
    get authFetchEventId() {
        return this.privAuthFetchEventId;
    }
}

});


parcelRequire.register("6u2b1", function(module, exports) {

$parcel$export(module.exports, "SynthesisContext", () => $4b873bb381cbaad1$export$a7af640f564c9d7a);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.

var $bjdWp = parcelRequire("bjdWp");
class $4b873bb381cbaad1$export$a7af640f564c9d7a {
    constructor(speechSynthesizer){
        this.privContext = {};
        this.privSpeechSynthesizer = speechSynthesizer;
    }
    /**
     * Adds a section to the synthesis.context object.
     * @param sectionName Name of the section to add.
     * @param value JSON serializable object that represents the value.
     */ setSection(sectionName, value) {
        this.privContext[sectionName] = value;
    }
    /**
     * Sets the audio output format for synthesis context generation.
     * @param format {AudioOutputFormatImpl} the output format
     */ set audioOutputFormat(format) {
        this.privAudioOutputFormat = format;
    }
    toJSON() {
        const synthesisSection = this.buildSynthesisContext();
        this.setSection("synthesis", synthesisSection);
        return JSON.stringify(this.privContext);
    }
    buildSynthesisContext() {
        return {
            audio: {
                metadataOptions: {
                    bookmarkEnabled: !!this.privSpeechSynthesizer.bookmarkReached,
                    punctuationBoundaryEnabled: this.privSpeechSynthesizer.properties.getProperty((0, $bjdWp.PropertyId).SpeechServiceResponse_RequestPunctuationBoundary, !!this.privSpeechSynthesizer.wordBoundary),
                    sentenceBoundaryEnabled: this.privSpeechSynthesizer.properties.getProperty((0, $bjdWp.PropertyId).SpeechServiceResponse_RequestSentenceBoundary, false),
                    sessionEndEnabled: true,
                    visemeEnabled: !!this.privSpeechSynthesizer.visemeReceived,
                    wordBoundaryEnabled: this.privSpeechSynthesizer.properties.getProperty((0, $bjdWp.PropertyId).SpeechServiceResponse_RequestWordBoundary, !!this.privSpeechSynthesizer.wordBoundary)
                },
                outputFormat: this.privAudioOutputFormat.requestAudioFormatString
            },
            language: {
                autoDetection: this.privSpeechSynthesizer.autoDetectSourceLanguage
            }
        };
    }
}

});

parcelRequire.register("4biu1", function(module, exports) {
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
parcelRequire("2iayq");
var $6RE4c = parcelRequire("6RE4c");
parcelRequire("cR8AB");
var $jQZQm = parcelRequire("jQZQm");
var $2YVQf = parcelRequire("2YVQf");

var $lnpwm = parcelRequire("lnpwm");
var $5idXV = parcelRequire("5idXV");
var $3fCi1 = parcelRequire("3fCi1");
var $bjdWp = parcelRequire("bjdWp");
var $9Wq4L = parcelRequire("9Wq4L");
var $daYNc = parcelRequire("daYNc");
var $8QDGa = parcelRequire("8QDGa");

var $jSpbe = parcelRequire("jSpbe");
var $je076 = parcelRequire("je076");

var $l4rU0 = parcelRequire("l4rU0");
var $30b686e58b95f83e$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
class $30b686e58b95f83e$export$66c96b853002c768 extends (0, $je076.ServiceRecognizerBase) {
    constructor(authentication, connectionFactory, audioSource, recognizerConfig, recognizer){
        super(authentication, connectionFactory, audioSource, recognizerConfig, recognizer);
        this.privSpeakerRecognizer = recognizer;
        this.privSpeakerAudioSource = audioSource;
        this.recognizeSpeaker = (model)=>this.recognizeSpeakerOnce(model);
        this.sendPrePayloadJSONOverride = ()=>this.noOp();
    }
    processTypeSpecificMessages(connectionMessage) {
        let processed = false;
        const resultProps = new (0, $3fCi1.PropertyCollection)();
        if (connectionMessage.messageType === (0, $jQZQm.MessageType).Text) resultProps.setProperty((0, $bjdWp.PropertyId).SpeechServiceResponse_JsonResult, connectionMessage.textBody);
        switch(connectionMessage.path.toLowerCase()){
            case "speaker.response":
                const response = JSON.parse(connectionMessage.textBody);
                let result;
                if (response.status.statusCode.toLowerCase() !== "success") result = new (0, $8QDGa.SpeakerRecognitionResult)(response, (0, $9Wq4L.ResultReason).Canceled, (0, $lnpwm.CancellationErrorCode).ServiceError, response.status.reason);
                else result = new (0, $8QDGa.SpeakerRecognitionResult)(response, (0, $9Wq4L.ResultReason).RecognizedSpeaker);
                if (!!this.privResultDeferral) this.privResultDeferral.resolve(result);
                processed = true;
                break;
            default:
                break;
        }
        const defferal = new (0, $2YVQf.Deferred)();
        defferal.resolve(processed);
        return defferal.promise;
    }
    // Cancels recognition.
    cancelRecognition(sessionId, requestId, cancellationReason, errorCode, error) {
        const properties = new (0, $3fCi1.PropertyCollection)();
        properties.setProperty((0, $jSpbe.CancellationErrorCodePropertyName), (0, $lnpwm.CancellationErrorCode)[errorCode]);
        if (!!this.privResultDeferral) {
            const result = new (0, $8QDGa.SpeakerRecognitionResult)({
                scenario: this.privSpeakerModel.scenario,
                status: {
                    statusCode: error,
                    reason: error
                }
            }, (0, $9Wq4L.ResultReason).Canceled, errorCode, error);
            try {
                this.privResultDeferral.resolve(result);
            } catch (error) {
                this.privResultDeferral.reject(error);
            }
        }
    }
    recognizeSpeakerOnce(model) {
        return $30b686e58b95f83e$var$__awaiter(this, void 0, void 0, function*() {
            this.privSpeakerModel = model;
            this.voiceProfileType = model.scenario;
            if (!this.privResultDeferral) this.privResultDeferral = new (0, $2YVQf.Deferred)();
            this.privRequestSession.startNewRecognition();
            this.privRequestSession.listenForServiceTelemetry(this.privSpeakerAudioSource.events);
            this.privRecognizerConfig.parameters.setProperty((0, $bjdWp.PropertyId).Speech_SessionId, this.privRequestSession.sessionId);
            // Start the connection to the service. The promise this will create is stored and will be used by configureConnection().
            const conPromise = this.connectImpl();
            const preAudioPromise = this.sendPreAudioMessages(this.extractSpeakerContext(model));
            const node = yield this.privSpeakerAudioSource.attach(this.privRequestSession.audioNodeId);
            const format = yield this.privSpeakerAudioSource.format;
            const deviceInfo = yield this.privSpeakerAudioSource.deviceInfo;
            const audioNode = new (0, $6RE4c.ReplayableAudioNode)(node, format.avgBytesPerSec);
            yield this.privRequestSession.onAudioSourceAttachCompleted(audioNode, false);
            this.privRecognizerConfig.SpeechServiceConfig.Context.audio = {
                source: deviceInfo
            };
            try {
                yield conPromise;
                yield preAudioPromise;
            } catch (err) {
                this.cancelRecognition(this.privRequestSession.sessionId, this.privRequestSession.requestId, (0, $5idXV.CancellationReason).Error, (0, $lnpwm.CancellationErrorCode).ConnectionFailure, err);
            }
            const sessionStartEventArgs = new (0, $daYNc.SessionEventArgs)(this.privRequestSession.sessionId);
            if (!!this.privRecognizer.sessionStarted) this.privRecognizer.sessionStarted(this.privRecognizer, sessionStartEventArgs);
            this.receiveMessage();
            const audioSendPromise = this.sendAudio(audioNode);
            // /* eslint-disable no-empty */
            audioSendPromise.then(()=>{}, (error)=>{
                this.cancelRecognition(this.privRequestSession.sessionId, this.privRequestSession.requestId, (0, $5idXV.CancellationReason).Error, (0, $lnpwm.CancellationErrorCode).RuntimeError, error);
            });
            return this.privResultDeferral.promise;
        });
    }
    sendPreAudioMessages(context) {
        return $30b686e58b95f83e$var$__awaiter(this, void 0, void 0, function*() {
            const connection = yield this.fetchConnection();
            yield this.sendSpeakerRecognition(connection, context);
        // await this.sendWaveHeader(connection);
        });
    }
    sendSpeakerRecognition(connection, context) {
        return $30b686e58b95f83e$var$__awaiter(this, void 0, void 0, function*() {
            const speakerContextJson = JSON.stringify(context);
            return connection.send(new (0, $l4rU0.SpeechConnectionMessage)((0, $jQZQm.MessageType).Text, "speaker.context", this.privRequestSession.requestId, "application/json; charset=utf-8", speakerContextJson));
        });
    }
    extractSpeakerContext(model) {
        return {
            features: {
                interimResult: "enabled",
                progressiveDetection: "disabled"
            },
            profileIds: model.profileIds,
            scenario: model.scenario
        };
    }
}

});
parcelRequire.register("8QDGa", function(module, exports) {

$parcel$export(module.exports, "SpeakerRecognitionResult", () => $6711f57deaec75ce$export$60ff47e56183bac3);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
/* eslint-disable max-classes-per-file */ 
var $jSpbe = parcelRequire("jSpbe");

var $8lL2R = parcelRequire("8lL2R");
var $lnpwm = parcelRequire("lnpwm");
var $5idXV = parcelRequire("5idXV");
var $3fCi1 = parcelRequire("3fCi1");
var $bjdWp = parcelRequire("bjdWp");
var $9Wq4L = parcelRequire("9Wq4L");
var $6711f57deaec75ce$export$530151139ee4bd37;
(function(SpeakerRecognitionResultType) {
    SpeakerRecognitionResultType[SpeakerRecognitionResultType["Verify"] = 0] = "Verify";
    SpeakerRecognitionResultType[SpeakerRecognitionResultType["Identify"] = 1] = "Identify";
})($6711f57deaec75ce$export$530151139ee4bd37 || ($6711f57deaec75ce$export$530151139ee4bd37 = {}));
class $6711f57deaec75ce$export$60ff47e56183bac3 {
    constructor(response, resultReason = (0, $9Wq4L.ResultReason).RecognizedSpeaker, cancellationErrorCode = (0, $lnpwm.CancellationErrorCode).NoError, errorDetails = ""){
        this.privProperties = new (0, $3fCi1.PropertyCollection)();
        const resultType = response.scenario === "TextIndependentIdentification" ? $6711f57deaec75ce$export$530151139ee4bd37.Identify : $6711f57deaec75ce$export$530151139ee4bd37.Verify;
        this.privReason = resultReason;
        if (this.privReason !== (0, $9Wq4L.ResultReason).Canceled) {
            if (resultType === $6711f57deaec75ce$export$530151139ee4bd37.Identify) {
                this.privProfileId = response.identificationResult.identifiedProfile.profileId;
                this.privScore = response.identificationResult.identifiedProfile.score;
                this.privReason = (0, $9Wq4L.ResultReason).RecognizedSpeakers;
            } else {
                this.privScore = response.verificationResult.score;
                if (response.verificationResult.recognitionResult.toLowerCase() !== "accept") this.privReason = (0, $9Wq4L.ResultReason).NoMatch;
                if (response.verificationResult.profileId !== undefined && response.verificationResult.profileId !== "") this.privProfileId = response.verificationResult.profileId;
            }
        } else {
            this.privErrorDetails = errorDetails;
            this.privProperties.setProperty((0, $jSpbe.CancellationErrorCodePropertyName), (0, $lnpwm.CancellationErrorCode)[cancellationErrorCode]);
        }
        this.privProperties.setProperty((0, $bjdWp.PropertyId).SpeechServiceResponse_JsonResult, JSON.stringify(response));
    }
    get properties() {
        return this.privProperties;
    }
    get reason() {
        return this.privReason;
    }
    get profileId() {
        return this.privProfileId;
    }
    get errorDetails() {
        return this.privErrorDetails;
    }
    get score() {
        return this.privScore;
    }
}
class $6711f57deaec75ce$export$9039c49adcf9e79f extends (0, $8lL2R.CancellationDetailsBase) {
    constructor(reason, errorDetails, errorCode){
        super(reason, errorDetails, errorCode);
    }
    /**
     * Creates an instance of SpeakerRecognitionCancellationDetails object for the canceled SpeakerRecognitionResult
     * @member SpeakerRecognitionCancellationDetails.fromResult
     * @function
     * @public
     * @param {SpeakerRecognitionResult} result - The result that was canceled.
     * @returns {SpeakerRecognitionCancellationDetails} The cancellation details object being created.
     */ static fromResult(result) {
        const reason = (0, $5idXV.CancellationReason).Error;
        let errorCode = (0, $lnpwm.CancellationErrorCode).NoError;
        if (!!result.properties) errorCode = (0, $lnpwm.CancellationErrorCode)[result.properties.getProperty((0, $jSpbe.CancellationErrorCodePropertyName), (0, $lnpwm.CancellationErrorCode)[(0, $lnpwm.CancellationErrorCode).NoError])];
        return new $6711f57deaec75ce$export$9039c49adcf9e79f(reason, result.errorDetails, errorCode);
    }
}

});
parcelRequire.register("8lL2R", function(module, exports) {

$parcel$export(module.exports, "CancellationDetailsBase", () => $6144c710a293b0f9$export$96dddb8560a3c887);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
/**
 * Contains detailed information about why a result was canceled.
 * @class CancellationDetailsBase
 */ class $6144c710a293b0f9$export$96dddb8560a3c887 {
    /**
     * Creates and initializes an instance of this class.
     * @constructor
     * @param {CancellationReason} reason - The cancellation reason.
     * @param {string} errorDetails - The error details, if provided.
     */ constructor(reason, errorDetails, errorCode){
        this.privReason = reason;
        this.privErrorDetails = errorDetails;
        this.privErrorCode = errorCode;
    }
    /**
     * The reason the recognition was canceled.
     * @member CancellationDetailsBase.prototype.reason
     * @function
     * @public
     * @returns {CancellationReason} Specifies the reason canceled.
     */ get reason() {
        return this.privReason;
    }
    /**
     * In case of an unsuccessful recognition, provides details of the occurred error.
     * @member CancellationDetailsBase.prototype.errorDetails
     * @function
     * @public
     * @returns {string} A String that represents the error details.
     */ get errorDetails() {
        return this.privErrorDetails;
    }
    /**
     * The error code in case of an unsuccessful recognition.
     * Added in version 1.1.0.
     * @return An error code that represents the error reason.
     */ get ErrorCode() {
        return this.privErrorCode;
    }
}

});



parcelRequire.register("4pUHf", function(module, exports) {
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
parcelRequire("2iayq");
var $6RE4c = parcelRequire("6RE4c");
parcelRequire("cR8AB");
var $36zth = parcelRequire("36zth");
var $jQZQm = parcelRequire("jQZQm");
var $2YVQf = parcelRequire("2YVQf");

var $lnpwm = parcelRequire("lnpwm");
var $5idXV = parcelRequire("5idXV");
var $3fCi1 = parcelRequire("3fCi1");
var $bjdWp = parcelRequire("bjdWp");
var $9Wq4L = parcelRequire("9Wq4L");
var $daYNc = parcelRequire("daYNc");
var $gyfMS = parcelRequire("gyfMS");
var $56BYc = parcelRequire("56BYc");
var $i6Xt5 = parcelRequire("i6Xt5");
var $aIVcu = parcelRequire("aIVcu");

var $jSpbe = parcelRequire("jSpbe");
var $je076 = parcelRequire("je076");

var $l4rU0 = parcelRequire("l4rU0");
var $337579f3f33d75ea$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
class $337579f3f33d75ea$export$aed5db38041d46a5 extends (0, $je076.ServiceRecognizerBase) {
    constructor(authentication, connectionFactory, audioSource, recognizerConfig, recognizer){
        super(authentication, connectionFactory, audioSource, recognizerConfig, recognizer);
        this.privDeferralMap = new (0, $36zth.DeferralMap)();
        this.privSpeakerAudioSource = audioSource;
        this.sendPrePayloadJSONOverride = ()=>this.noOp();
    }
    set SpeakerAudioSource(audioSource) {
        this.privSpeakerAudioSource = audioSource;
    }
    processTypeSpecificMessages(connectionMessage) {
        let processed = false;
        const resultProps = new (0, $3fCi1.PropertyCollection)();
        if (connectionMessage.messageType === (0, $jQZQm.MessageType).Text) resultProps.setProperty((0, $bjdWp.PropertyId).SpeechServiceResponse_JsonResult, connectionMessage.textBody);
        switch(connectionMessage.path.toLowerCase()){
            // Profile management response for create, fetch, delete, reset
            case "speaker.profiles":
                const response = JSON.parse(connectionMessage.textBody);
                switch(response.operation.toLowerCase()){
                    case "create":
                        this.handleCreateResponse(response, connectionMessage.requestId);
                        break;
                    case "delete":
                    case "reset":
                        this.handleResultResponse(response, connectionMessage.requestId);
                        break;
                    case "fetch":
                        const enrollmentResponse = JSON.parse(connectionMessage.textBody);
                        this.handleFetchResponse(enrollmentResponse, connectionMessage.requestId);
                        break;
                    default:
                        break;
                }
                processed = true;
                break;
            // Activation and authorization phrase response
            case "speaker.phrases":
                const phraseResponse = JSON.parse(connectionMessage.textBody);
                this.handlePhrasesResponse(phraseResponse, connectionMessage.requestId);
                processed = true;
                break;
            // Enrollment response
            case "speaker.profile.enrollment":
                const enrollmentResponse1 = JSON.parse(connectionMessage.textBody);
                const result = new (0, $gyfMS.VoiceProfileEnrollmentResult)(this.enrollmentReasonFrom(!!enrollmentResponse1.enrollment ? enrollmentResponse1.enrollment.enrollmentStatus : enrollmentResponse1.status.statusCode), !!enrollmentResponse1.enrollment ? JSON.stringify(enrollmentResponse1.enrollment) : undefined, enrollmentResponse1.status.reason);
                if (!!this.privDeferralMap.getId(connectionMessage.requestId)) this.privDeferralMap.complete(connectionMessage.requestId, result);
                this.privRequestSession.onSpeechEnded();
                processed = true;
                break;
            default:
                break;
        }
        const defferal = new (0, $2YVQf.Deferred)();
        defferal.resolve(processed);
        return defferal.promise;
    }
    // Cancels recognition.
    cancelRecognition(sessionId, requestId, cancellationReason, errorCode, error) {
        const properties = new (0, $3fCi1.PropertyCollection)();
        // const enrollmentResponse: EnrollmentResponse = JSON.parse(connectionMessage.textBody) as EnrollmentResponse;
        properties.setProperty((0, $jSpbe.CancellationErrorCodePropertyName), (0, $lnpwm.CancellationErrorCode)[errorCode]);
        const result = new (0, $gyfMS.VoiceProfileEnrollmentResult)((0, $9Wq4L.ResultReason).Canceled, error, error);
        if (!!this.privDeferralMap.getId(requestId)) this.privDeferralMap.complete(requestId, result);
    }
    createProfile(profileType, locale) {
        return $337579f3f33d75ea$var$__awaiter(this, void 0, void 0, function*() {
            // Start the connection to the service. The promise this will create is stored and will be used by configureConnection().
            this.voiceProfileType = profileType.toString();
            const conPromise = this.connectImpl();
            try {
                const createProfileDeferral = new (0, $2YVQf.Deferred)();
                yield conPromise;
                yield this.sendCreateProfile(createProfileDeferral, profileType, locale);
                this.receiveMessage();
                return createProfileDeferral.promise;
            } catch (err) {
                throw err;
            }
        });
    }
    resetProfile(profile) {
        return $337579f3f33d75ea$var$__awaiter(this, void 0, void 0, function*() {
            this.voiceProfileType = profile.profileType.toString();
            return this.sendCommonRequest("reset", profile.profileType, profile);
        });
    }
    deleteProfile(profile) {
        return $337579f3f33d75ea$var$__awaiter(this, void 0, void 0, function*() {
            this.voiceProfileType = profile.profileType.toString();
            return this.sendCommonRequest("delete", profile.profileType, profile);
        });
    }
    retrieveEnrollmentResult(profile) {
        return $337579f3f33d75ea$var$__awaiter(this, void 0, void 0, function*() {
            this.voiceProfileType = profile.profileType.toString();
            this.privExpectedProfileId = profile.profileId;
            return this.sendCommonRequest("fetch", profile.profileType, profile);
        });
    }
    getAllProfiles(profileType) {
        return $337579f3f33d75ea$var$__awaiter(this, void 0, void 0, function*() {
            this.voiceProfileType = profileType.toString();
            return this.sendCommonRequest("fetch", profileType);
        });
    }
    getActivationPhrases(profileType, lang) {
        return $337579f3f33d75ea$var$__awaiter(this, void 0, void 0, function*() {
            this.voiceProfileType = profileType.toString();
            // Start the connection to the service. The promise this will create is stored and will be used by configureConnection().
            const conPromise = this.connectImpl();
            try {
                const getPhrasesDeferral = new (0, $2YVQf.Deferred)();
                yield conPromise;
                yield this.sendPhrasesRequest(getPhrasesDeferral, profileType, lang);
                this.receiveMessage();
                return getPhrasesDeferral.promise;
            } catch (err) {
                throw err;
            }
        });
    }
    enrollProfile(profile) {
        return $337579f3f33d75ea$var$__awaiter(this, void 0, void 0, function*() {
            this.voiceProfileType = profile.profileType.toString();
            const enrollmentDeferral = new (0, $2YVQf.Deferred)();
            this.privRequestSession.startNewRecognition();
            this.privRequestSession.listenForServiceTelemetry(this.privSpeakerAudioSource.events);
            this.privRecognizerConfig.parameters.setProperty((0, $bjdWp.PropertyId).Speech_SessionId, this.privRequestSession.sessionId);
            // Start the connection to the service. The promise this will create is stored and will be used by configureConnection().
            const conPromise = this.connectImpl();
            const preAudioPromise = this.sendPreAudioMessages(profile, enrollmentDeferral);
            const node = yield this.privSpeakerAudioSource.attach(this.privRequestSession.audioNodeId);
            const format = yield this.privSpeakerAudioSource.format;
            const deviceInfo = yield this.privSpeakerAudioSource.deviceInfo;
            const audioNode = new (0, $6RE4c.ReplayableAudioNode)(node, format.avgBytesPerSec);
            yield this.privRequestSession.onAudioSourceAttachCompleted(audioNode, false);
            this.privRecognizerConfig.SpeechServiceConfig.Context.audio = {
                source: deviceInfo
            };
            try {
                yield conPromise;
                yield preAudioPromise;
            } catch (err) {
                this.cancelRecognition(this.privRequestSession.sessionId, this.privRequestSession.requestId, (0, $5idXV.CancellationReason).Error, (0, $lnpwm.CancellationErrorCode).ConnectionFailure, err);
            }
            const sessionStartEventArgs = new (0, $daYNc.SessionEventArgs)(this.privRequestSession.sessionId);
            if (!!this.privRecognizer.sessionStarted) this.privRecognizer.sessionStarted(this.privRecognizer, sessionStartEventArgs);
            this.receiveMessage();
            const audioSendPromise = this.sendAudio(audioNode);
            // /* eslint-disable no-empty */
            audioSendPromise.then(()=>{}, (error)=>{
                this.cancelRecognition(this.privRequestSession.sessionId, this.privRequestSession.requestId, (0, $5idXV.CancellationReason).Error, (0, $lnpwm.CancellationErrorCode).RuntimeError, error);
            });
            return enrollmentDeferral.promise;
        });
    }
    sendPreAudioMessages(profile, enrollmentDeferral) {
        return $337579f3f33d75ea$var$__awaiter(this, void 0, void 0, function*() {
            const connection = yield this.fetchConnection();
            this.privRequestSession.onSpeechContext();
            this.privDeferralMap.add(this.privRequestSession.requestId, enrollmentDeferral);
            yield this.sendBaseRequest(connection, "enroll", this.scenarioFrom(profile.profileType), profile);
        });
    }
    sendPhrasesRequest(getPhrasesDeferral, profileType, locale) {
        return $337579f3f33d75ea$var$__awaiter(this, void 0, void 0, function*() {
            const connection = yield this.fetchConnection();
            this.privRequestSession.onSpeechContext();
            this.privDeferralMap.add(this.privRequestSession.requestId, getPhrasesDeferral);
            const scenario = this.scenarioFrom(profileType);
            const profileCreateRequest = {
                locale: locale,
                scenario: scenario
            };
            return connection.send(new (0, $l4rU0.SpeechConnectionMessage)((0, $jQZQm.MessageType).Text, "speaker.profile.phrases", this.privRequestSession.requestId, "application/json; charset=utf-8", JSON.stringify(profileCreateRequest)));
        });
    }
    sendCreateProfile(createProfileDeferral, profileType, locale) {
        return $337579f3f33d75ea$var$__awaiter(this, void 0, void 0, function*() {
            const connection = yield this.fetchConnection();
            this.privRequestSession.onSpeechContext();
            this.privDeferralMap.add(this.privRequestSession.requestId, createProfileDeferral);
            const scenario = profileType === (0, $aIVcu.VoiceProfileType).TextIndependentIdentification ? "TextIndependentIdentification" : profileType === (0, $aIVcu.VoiceProfileType).TextIndependentVerification ? "TextIndependentVerification" : "TextDependentVerification";
            const profileCreateRequest = {
                locale: locale,
                number: "1",
                scenario: scenario
            };
            return connection.send(new (0, $l4rU0.SpeechConnectionMessage)((0, $jQZQm.MessageType).Text, "speaker.profile.create", this.privRequestSession.requestId, "application/json; charset=utf-8", JSON.stringify(profileCreateRequest)));
        });
    }
    sendCommonRequest(operation, profileType, profile) {
        return $337579f3f33d75ea$var$__awaiter(this, void 0, void 0, function*() {
            // Start the connection to the service. The promise this will create is stored and will be used by configureConnection().
            const conPromise = this.connectImpl();
            try {
                const deferral = new (0, $2YVQf.Deferred)();
                this.privRequestSession.onSpeechContext();
                yield conPromise;
                const connection = yield this.fetchConnection();
                this.privDeferralMap.add(this.privRequestSession.requestId, deferral);
                yield this.sendBaseRequest(connection, operation, this.scenarioFrom(profileType), profile);
                this.receiveMessage();
                return deferral.promise;
            } catch (err) {
                throw err;
            }
        });
    }
    sendBaseRequest(connection, operation, scenario, profile) {
        return $337579f3f33d75ea$var$__awaiter(this, void 0, void 0, function*() {
            const profileRequest = {
                scenario: scenario
            };
            if (!!profile) profileRequest.profileIds = [
                profile.profileId
            ];
            else profileRequest.maxPageSize = -1;
            return connection.send(new (0, $l4rU0.SpeechConnectionMessage)((0, $jQZQm.MessageType).Text, `speaker.profile.${operation}`, this.privRequestSession.requestId, "application/json; charset=utf-8", JSON.stringify(profileRequest)));
        });
    }
    extractSpeakerContext(model) {
        return {
            features: {
                interimResult: "enabled",
                progressiveDetection: "disabled"
            },
            profileIds: model.profileIds,
            scenario: model.scenario
        };
    }
    handlePhrasesResponse(response, requestId) {
        if (!!this.privDeferralMap.getId(requestId)) {
            if (response.status.statusCode.toLowerCase() !== "success") {
                const reason = (0, $9Wq4L.ResultReason).Canceled;
                const result = new (0, $56BYc.VoiceProfilePhraseResult)(reason, response.status.statusCode, response.passPhraseType, []);
                this.privDeferralMap.complete(requestId, result);
            } else if (!!response.phrases && response.phrases.length > 0) {
                const reason = (0, $9Wq4L.ResultReason).EnrollingVoiceProfile;
                const result = new (0, $56BYc.VoiceProfilePhraseResult)(reason, response.status.statusCode, response.passPhraseType, response.phrases);
                this.privDeferralMap.complete(requestId, result);
            } else throw new Error("Voice Profile get activation phrases failed, no phrases received");
        } else throw new Error(`Voice Profile get activation phrases request for requestID ${requestId} not found`);
    }
    handleCreateResponse(response, requestId) {
        if (!!response.profiles && response.profiles.length > 0) {
            if (!!this.privDeferralMap.getId(requestId)) {
                const profileIds = response.profiles.map((profile)=>profile.profileId);
                this.privDeferralMap.complete(requestId, profileIds);
            } else throw new Error(`Voice Profile create request for requestID ${requestId} not found`);
        } else throw new Error("Voice Profile create failed, no profile id received");
    }
    handleResultResponse(response, requestId) {
        if (!!this.privDeferralMap.getId(requestId)) {
            const successReason = response.operation.toLowerCase() === "delete" ? (0, $9Wq4L.ResultReason).DeletedVoiceProfile : (0, $9Wq4L.ResultReason).ResetVoiceProfile;
            const reason = response.status.statusCode.toLowerCase() === "success" ? successReason : (0, $9Wq4L.ResultReason).Canceled;
            const result = new (0, $i6Xt5.VoiceProfileResult)(reason, `statusCode: ${response.status.statusCode}, errorDetails: ${response.status.reason}`);
            this.privDeferralMap.complete(requestId, result);
        } else throw new Error(`Voice Profile create request for requestID ${requestId} not found`);
    }
    handleFetchResponse(enrollmentResponse, requestId) {
        if (!!this.privDeferralMap.getId(requestId) && !!enrollmentResponse.profiles[0]) {
            if (!!this.privExpectedProfileId && enrollmentResponse.profiles.length === 1 && enrollmentResponse.profiles[0].profileId === this.privExpectedProfileId) {
                this.privExpectedProfileId = undefined;
                const profileInfo = enrollmentResponse.profiles[0];
                const result = new (0, $gyfMS.VoiceProfileEnrollmentResult)(this.enrollmentReasonFrom(profileInfo.enrollmentStatus), JSON.stringify(profileInfo), enrollmentResponse.status.reason);
                this.privDeferralMap.complete(requestId, result);
            } else if (enrollmentResponse.profiles.length > 0) {
                const iProfiles = enrollmentResponse.profiles;
                const profileResults = [];
                for (const profile of iProfiles)profileResults.push(new (0, $gyfMS.VoiceProfileEnrollmentResult)(this.enrollmentReasonFrom(profile.enrollmentStatus), JSON.stringify(profile), enrollmentResponse.status.reason));
                this.privDeferralMap.complete(requestId, profileResults);
            }
        } else throw new Error(`Voice Profile fetch request for requestID ${requestId} not found`);
    }
    enrollmentReasonFrom(statusCode) {
        switch(statusCode.toLowerCase()){
            case "enrolled":
                return (0, $9Wq4L.ResultReason).EnrolledVoiceProfile;
            case "invalidlocale":
            case "invalidphrase":
            case "invalidaudioformat":
            case "invalidscenario":
            case "invalidprofilecount":
            case "invalidoperation":
            case "audiotooshort":
            case "audiotoolong":
            case "toomanyenrollments":
            case "storageconflict":
            case "profilenotfound":
            case "incompatibleprofiles":
            case "incompleteenrollment":
                return (0, $9Wq4L.ResultReason).Canceled;
            default:
                return (0, $9Wq4L.ResultReason).EnrollingVoiceProfile;
        }
    }
    scenarioFrom(profileType) {
        return profileType === (0, $aIVcu.VoiceProfileType).TextIndependentIdentification ? "TextIndependentIdentification" : profileType === (0, $aIVcu.VoiceProfileType).TextIndependentVerification ? "TextIndependentVerification" : "TextDependentVerification";
    }
}

});
parcelRequire.register("gyfMS", function(module, exports) {

$parcel$export(module.exports, "VoiceProfileEnrollmentResult", () => $c0cc115c338626f0$export$419e22d41159778b);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
/* eslint-disable max-classes-per-file */ 
var $jSpbe = parcelRequire("jSpbe");

var $8lL2R = parcelRequire("8lL2R");
var $lnpwm = parcelRequire("lnpwm");
var $5idXV = parcelRequire("5idXV");
var $3fCi1 = parcelRequire("3fCi1");
var $9Wq4L = parcelRequire("9Wq4L");
class $c0cc115c338626f0$export$419e22d41159778b {
    constructor(reason, json, statusText){
        this.privReason = reason;
        this.privProperties = new (0, $3fCi1.PropertyCollection)();
        if (this.privReason !== (0, $9Wq4L.ResultReason).Canceled) {
            if (!!json) {
                this.privDetails = JSON.parse(json);
                if (this.privDetails.enrollmentStatus.toLowerCase() === "enrolling") this.privReason = (0, $9Wq4L.ResultReason).EnrollingVoiceProfile;
            }
        } else {
            this.privErrorDetails = statusText;
            this.privProperties.setProperty((0, $jSpbe.CancellationErrorCodePropertyName), (0, $lnpwm.CancellationErrorCode)[(0, $lnpwm.CancellationErrorCode).ServiceError]);
        }
    }
    get reason() {
        return this.privReason;
    }
    get enrollmentsCount() {
        return this.privDetails.enrollmentsCount;
    }
    get enrollmentsLength() {
        return this.privDetails.enrollmentsLength;
    }
    get properties() {
        return this.privProperties;
    }
    get enrollmentResultDetails() {
        return this.privDetails;
    }
    get errorDetails() {
        return this.privErrorDetails;
    }
    static FromIdentificationProfileList(json) {
        const results = [];
        for (const item of json.value){
            const reason = item.enrollmentStatus.toLowerCase() === "enrolling" ? (0, $9Wq4L.ResultReason).EnrollingVoiceProfile : item.enrollmentStatus.toLowerCase() === "enrolled" ? (0, $9Wq4L.ResultReason).EnrolledVoiceProfile : (0, $9Wq4L.ResultReason).Canceled;
            const result = new $c0cc115c338626f0$export$419e22d41159778b(reason, null, null);
            result.privDetails = this.getIdentificationDetails(item);
            results.push(result);
        }
        return results;
    }
    static FromVerificationProfileList(json) {
        const results = [];
        for (const item of json.value){
            const reason = item.enrollmentStatus.toLowerCase() === "enrolling" ? (0, $9Wq4L.ResultReason).EnrollingVoiceProfile : item.enrollmentStatus.toLowerCase() === "enrolled" ? (0, $9Wq4L.ResultReason).EnrolledVoiceProfile : (0, $9Wq4L.ResultReason).Canceled;
            const result = new $c0cc115c338626f0$export$419e22d41159778b(reason, null, null);
            result.privDetails = this.getVerificationDetails(item);
            results.push(result);
        }
        return results;
    }
    static getIdentificationDetails(json) {
        return {
            audioLength: json.audioLength ? parseFloat(json.audioLength) : 0,
            audioSpeechLength: json.audioSpeechLength ? parseFloat(json.audioSpeechLength) : 0,
            enrollmentStatus: json.enrollmentStatus,
            enrollmentsCount: json.enrollmentsCount || 0,
            enrollmentsLength: json.enrollmentsLength ? parseFloat(json.enrollmentsLength) : 0,
            enrollmentsSpeechLength: json.enrollmentsSpeechLength ? parseFloat(json.enrollmentsSpeechLength) : 0,
            profileId: json.profileId || json.identificationProfileId,
            remainingEnrollmentsSpeechLength: json.remainingEnrollmentsSpeechLength ? parseFloat(json.remainingEnrollmentsSpeechLength) : 0
        };
    }
    static getVerificationDetails(json) {
        return {
            audioLength: json.audioLength ? parseFloat(json.audioLength) : 0,
            audioSpeechLength: json.audioSpeechLength ? parseFloat(json.audioSpeechLength) : 0,
            enrollmentStatus: json.enrollmentStatus,
            enrollmentsCount: json.enrollmentsCount,
            enrollmentsLength: json.enrollmentsLength ? parseFloat(json.enrollmentsLength) : 0,
            enrollmentsSpeechLength: json.enrollmentsSpeechLength ? parseFloat(json.enrollmentsSpeechLength) : 0,
            profileId: json.profileId || json.verificationProfileId,
            remainingEnrollmentsCount: json.remainingEnrollments || json.remainingEnrollmentsCount,
            remainingEnrollmentsSpeechLength: json.remainingEnrollmentsSpeechLength ? parseFloat(json.remainingEnrollmentsSpeechLength) : 0
        };
    }
}
class $c0cc115c338626f0$export$9b6eca0644ef28e4 extends (0, $8lL2R.CancellationDetailsBase) {
    constructor(reason, errorDetails, errorCode){
        super(reason, errorDetails, errorCode);
    }
    /**
     * Creates an instance of VoiceProfileEnrollmentCancellationDetails object for the canceled VoiceProfileEnrollmentResult.
     * @member VoiceProfileEnrollmentCancellationDetails.fromResult
     * @function
     * @public
     * @param {VoiceProfileEnrollmentResult} result - The result that was canceled.
     * @returns {VoiceProfileEnrollmentCancellationDetails} The cancellation details object being created.
     */ static fromResult(result) {
        const reason = (0, $5idXV.CancellationReason).Error;
        let errorCode = (0, $lnpwm.CancellationErrorCode).NoError;
        if (!!result.properties) errorCode = (0, $lnpwm.CancellationErrorCode)[result.properties.getProperty((0, $jSpbe.CancellationErrorCodePropertyName), (0, $lnpwm.CancellationErrorCode)[(0, $lnpwm.CancellationErrorCode).NoError])]; //eslint-disable-line
        return new $c0cc115c338626f0$export$9b6eca0644ef28e4(reason, result.errorDetails, errorCode);
    }
}

});

parcelRequire.register("56BYc", function(module, exports) {

$parcel$export(module.exports, "VoiceProfilePhraseResult", () => $3b7af7568125b606$export$2ad036d2d7639c77);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.

var $8HmyV = parcelRequire("8HmyV");

var $i6Xt5 = parcelRequire("i6Xt5");
class $3b7af7568125b606$export$2ad036d2d7639c77 extends (0, $i6Xt5.VoiceProfileResult) {
    constructor(reason, statusText, type, phraseArray){
        super(reason, statusText);
        this.privPhrases = [];
        (0, $8HmyV.Contracts).throwIfNullOrUndefined(phraseArray, "phrase array");
        this.privType = type;
        if (!!phraseArray && !!phraseArray[0]) this.privPhrases = phraseArray;
    }
    get phrases() {
        return this.privPhrases;
    }
    get type() {
        return this.privType;
    }
}

});
parcelRequire.register("i6Xt5", function(module, exports) {

$parcel$export(module.exports, "VoiceProfileResult", () => $d2f6eaa7d0a6b490$export$7401a5fe6738caa6);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
/* eslint-disable max-classes-per-file */ 
var $jSpbe = parcelRequire("jSpbe");

var $8HmyV = parcelRequire("8HmyV");

var $8lL2R = parcelRequire("8lL2R");
var $lnpwm = parcelRequire("lnpwm");
var $5idXV = parcelRequire("5idXV");
var $3fCi1 = parcelRequire("3fCi1");
var $9Wq4L = parcelRequire("9Wq4L");
class $d2f6eaa7d0a6b490$export$7401a5fe6738caa6 {
    constructor(reason, statusText){
        this.privReason = reason;
        this.privProperties = new (0, $3fCi1.PropertyCollection)();
        if (reason === (0, $9Wq4L.ResultReason).Canceled) {
            (0, $8HmyV.Contracts).throwIfNullOrUndefined(statusText, "statusText");
            this.privErrorDetails = statusText;
            this.privProperties.setProperty((0, $jSpbe.CancellationErrorCodePropertyName), (0, $lnpwm.CancellationErrorCode)[(0, $lnpwm.CancellationErrorCode).ServiceError]);
        }
    }
    get reason() {
        return this.privReason;
    }
    get properties() {
        return this.privProperties;
    }
    get errorDetails() {
        return this.privErrorDetails;
    }
}
class $d2f6eaa7d0a6b490$export$90c0dc05d18a73e extends (0, $8lL2R.CancellationDetailsBase) {
    constructor(reason, errorDetails, errorCode){
        super(reason, errorDetails, errorCode);
    }
    /**
     * Creates an instance of VoiceProfileCancellationDetails object for the canceled VoiceProfileResult.
     * @member VoiceProfileCancellationDetails.fromResult
     * @function
     * @public
     * @param {VoiceProfileResult} result - The result that was canceled.
     * @returns {VoiceProfileCancellationDetails} The cancellation details object being created.
     */ static fromResult(result) {
        const reason = (0, $5idXV.CancellationReason).Error;
        let errorCode = (0, $lnpwm.CancellationErrorCode).NoError;
        if (!!result.properties) errorCode = (0, $lnpwm.CancellationErrorCode)[result.properties.getProperty((0, $jSpbe.CancellationErrorCodePropertyName), (0, $lnpwm.CancellationErrorCode)[(0, $lnpwm.CancellationErrorCode).NoError])]; //eslint-disable-line
        return new $d2f6eaa7d0a6b490$export$90c0dc05d18a73e(reason, result.errorDetails, errorCode);
    }
}

});


parcelRequire.register("aIVcu", function(module, exports) {

$parcel$export(module.exports, "VoiceProfileType", () => $7cea62406be9b47d$export$bcc212421e479399);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
/**
 * Output format
 * @class VoiceProfileType
 */ var $7cea62406be9b47d$export$bcc212421e479399;
(function(VoiceProfileType) {
    /**
     * Text independent speaker identification
     * @member VoiceProfileType.TextIndependentIdentification
     */ VoiceProfileType[VoiceProfileType["TextIndependentIdentification"] = 0] = "TextIndependentIdentification";
    /**
     * Text dependent speaker verification
     * @member VoiceProfileType.TextDependentVerification
     */ VoiceProfileType[VoiceProfileType["TextDependentVerification"] = 1] = "TextDependentVerification";
    /**
     * Text independent speaker verification
     * @member VoiceProfileType.TextIndependentVerification
     */ VoiceProfileType[VoiceProfileType["TextIndependentVerification"] = 2] = "TextIndependentVerification";
})($7cea62406be9b47d$export$bcc212421e479399 || ($7cea62406be9b47d$export$bcc212421e479399 = {}));

});




parcelRequire.register("35uUw", function(module, exports) {

$parcel$export(module.exports, "FileAudioSource", () => $23f9d0ee7ec10515$export$2457f6fad5859840);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
parcelRequire("jSpbe");
var $cOea6 = parcelRequire("cOea6");
parcelRequire("cR8AB");
var $hsGnG = parcelRequire("hsGnG");
var $dxrNf = parcelRequire("dxrNf");
var $bqySL = parcelRequire("bqySL");
var $2YVQf = parcelRequire("2YVQf");
var $2mIQY = parcelRequire("2mIQY");
var $4utc3 = parcelRequire("4utc3");

var $6489m = parcelRequire("6489m");
var $23f9d0ee7ec10515$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
class $23f9d0ee7ec10515$export$2457f6fad5859840 {
    constructor(file, filename, audioSourceId){
        this.privStreams = {};
        this.privHeaderEnd = 44;
        this.privId = audioSourceId ? audioSourceId : (0, $hsGnG.createNoDashGuid)();
        this.privEvents = new (0, $dxrNf.EventSource)();
        this.privSource = file;
        if (typeof window !== "undefined" && typeof Blob !== "undefined" && this.privSource instanceof Blob) this.privFilename = file.name;
        else this.privFilename = filename || "unknown.wav";
        // Read the header.
        this.privAudioFormatPromise = this.readHeader();
    }
    get format() {
        return this.privAudioFormatPromise;
    }
    turnOn() {
        if (this.privFilename.lastIndexOf(".wav") !== this.privFilename.length - 4) {
            const errorMsg = this.privFilename + " is not supported. Only WAVE files are allowed at the moment.";
            this.onEvent(new (0, $bqySL.AudioSourceErrorEvent)(errorMsg, ""));
            return Promise.reject(errorMsg);
        }
        this.onEvent(new (0, $bqySL.AudioSourceInitializingEvent)(this.privId)); // no stream id
        this.onEvent(new (0, $bqySL.AudioSourceReadyEvent)(this.privId));
        return;
    }
    id() {
        return this.privId;
    }
    attach(audioNodeId) {
        return $23f9d0ee7ec10515$var$__awaiter(this, void 0, void 0, function*() {
            this.onEvent(new (0, $bqySL.AudioStreamNodeAttachingEvent)(this.privId, audioNodeId));
            const stream = yield this.upload(audioNodeId);
            this.onEvent(new (0, $bqySL.AudioStreamNodeAttachedEvent)(this.privId, audioNodeId));
            return Promise.resolve({
                detach: ()=>$23f9d0ee7ec10515$var$__awaiter(this, void 0, void 0, function*() {
                        stream.readEnded();
                        delete this.privStreams[audioNodeId];
                        this.onEvent(new (0, $bqySL.AudioStreamNodeDetachedEvent)(this.privId, audioNodeId));
                        yield this.turnOff();
                    }),
                id: ()=>audioNodeId,
                read: ()=>stream.read()
            });
        });
    }
    detach(audioNodeId) {
        if (audioNodeId && this.privStreams[audioNodeId]) {
            this.privStreams[audioNodeId].close();
            delete this.privStreams[audioNodeId];
            this.onEvent(new (0, $bqySL.AudioStreamNodeDetachedEvent)(this.privId, audioNodeId));
        }
    }
    turnOff() {
        for(const streamId in this.privStreams)if (streamId) {
            const stream = this.privStreams[streamId];
            if (stream && !stream.isClosed) stream.close();
        }
        this.onEvent(new (0, $bqySL.AudioSourceOffEvent)(this.privId)); // no stream now
        return Promise.resolve();
    }
    get events() {
        return this.privEvents;
    }
    get deviceInfo() {
        return this.privAudioFormatPromise.then((result)=>Promise.resolve({
                bitspersample: result.bitsPerSample,
                channelcount: result.channels,
                connectivity: (0, $cOea6.connectivity).Unknown,
                manufacturer: "Speech SDK",
                model: "File",
                samplerate: result.samplesPerSec,
                type: (0, $cOea6.type).File
            }));
    }
    readHeader() {
        // Read the wave header.
        const maxHeaderSize = 4296;
        const header = this.privSource.slice(0, maxHeaderSize);
        const headerResult = new (0, $2YVQf.Deferred)();
        const processHeader = (header)=>{
            const view = new DataView(header);
            const getWord = (index)=>String.fromCharCode(view.getUint8(index), view.getUint8(index + 1), view.getUint8(index + 2), view.getUint8(index + 3));
            // RIFF 4 bytes.
            if ("RIFF" !== getWord(0)) {
                headerResult.reject("Invalid WAV header in file, RIFF was not found");
                return;
            }
            // length, 4 bytes
            // RIFF Type & fmt 8 bytes
            if ("WAVE" !== getWord(8) || "fmt " !== getWord(12)) {
                headerResult.reject("Invalid WAV header in file, WAVEfmt was not found");
                return;
            }
            const formatSize = view.getInt32(16, true);
            const channelCount = view.getUint16(22, true);
            const sampleRate = view.getUint32(24, true);
            const bitsPerSample = view.getUint16(34, true);
            // Confirm if header is 44 bytes long.
            let pos = 36 + Math.max(formatSize - 16, 0);
            for(; getWord(pos) !== "data"; pos += 2)if (pos > maxHeaderSize - 8) {
                headerResult.reject("Invalid WAV header in file, data block was not found");
                return;
            }
            this.privHeaderEnd = pos + 8;
            headerResult.resolve((0, $6489m.AudioStreamFormat).getWaveFormatPCM(sampleRate, bitsPerSample, channelCount));
        };
        if (typeof window !== "undefined" && typeof Blob !== "undefined" && header instanceof Blob) {
            const reader = new FileReader();
            reader.onload = (event)=>{
                const header = event.target.result;
                processHeader(header);
            };
            reader.readAsArrayBuffer(header);
        } else {
            const h = header;
            processHeader(h.buffer.slice(h.byteOffset, h.byteOffset + h.byteLength));
        }
        return headerResult.promise;
    }
    upload(audioNodeId) {
        return $23f9d0ee7ec10515$var$__awaiter(this, void 0, void 0, function*() {
            const onerror = (error)=>{
                const errorMsg = `Error occurred while processing '${this.privFilename}'. ${error}`;
                this.onEvent(new (0, $bqySL.AudioStreamNodeErrorEvent)(this.privId, audioNodeId, errorMsg));
                throw new Error(errorMsg);
            };
            try {
                yield this.turnOn();
                const format = yield this.privAudioFormatPromise;
                const stream = new (0, $2mIQY.ChunkedArrayBufferStream)(format.avgBytesPerSec / 10, audioNodeId);
                this.privStreams[audioNodeId] = stream;
                const chunk = this.privSource.slice(this.privHeaderEnd);
                const processFile = (buff)=>{
                    if (stream.isClosed) return; // output stream was closed (somebody called TurnOff). We're done here.
                    stream.writeStreamChunk({
                        buffer: buff,
                        isEnd: false,
                        timeReceived: Date.now()
                    });
                    stream.close();
                };
                if (typeof window !== "undefined" && typeof Blob !== "undefined" && chunk instanceof Blob) {
                    const reader = new FileReader();
                    reader.onerror = (ev)=>onerror(ev.toString());
                    reader.onload = (event)=>{
                        const fileBuffer = event.target.result;
                        processFile(fileBuffer);
                    };
                    reader.readAsArrayBuffer(chunk);
                } else {
                    const c = chunk;
                    processFile(c.buffer.slice(c.byteOffset, c.byteOffset + c.byteLength));
                }
                return stream;
            } catch (e) {
                onerror(e);
            }
        });
    }
    onEvent(event) {
        this.privEvents.onEvent(event);
        (0, $4utc3.Events).instance.onEvent(event);
    }
}

});

parcelRequire.register("3uS3N", function(module, exports) {

$parcel$export(module.exports, "PcmRecorder", () => $28be1bb360810b2a$export$b4d48a500005f7a2);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
parcelRequire("cR8AB");
var $4cyUj = parcelRequire("4cyUj");
class $28be1bb360810b2a$export$b4d48a500005f7a2 {
    constructor(stopInputOnRelease){
        this.privStopInputOnRelease = stopInputOnRelease;
    }
    record(context, mediaStream, outputStream) {
        const desiredSampleRate = 16000;
        const waveStreamEncoder = new (0, $4cyUj.RiffPcmEncoder)(context.sampleRate, desiredSampleRate);
        const micInput = context.createMediaStreamSource(mediaStream);
        const attachScriptProcessor = ()=>{
            // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
            const scriptNode = (()=>{
                let bufferSize = 0;
                try {
                    return context.createScriptProcessor(bufferSize, 1, 1);
                } catch (error) {
                    // Webkit (<= version 31) requires a valid bufferSize.
                    bufferSize = 2048;
                    let audioSampleRate = context.sampleRate;
                    while(bufferSize < 16384 && audioSampleRate >= 2 * desiredSampleRate){
                        bufferSize <<= 1;
                        audioSampleRate >>= 1;
                    }
                    return context.createScriptProcessor(bufferSize, 1, 1);
                }
            })();
            scriptNode.onaudioprocess = (event)=>{
                const inputFrame = event.inputBuffer.getChannelData(0);
                if (outputStream && !outputStream.isClosed) {
                    const waveFrame = waveStreamEncoder.encode(inputFrame);
                    if (!!waveFrame) outputStream.writeStreamChunk({
                        buffer: waveFrame,
                        isEnd: false,
                        timeReceived: Date.now()
                    });
                }
            };
            micInput.connect(scriptNode);
            scriptNode.connect(context.destination);
            this.privMediaResources = {
                scriptProcessorNode: scriptNode,
                source: micInput,
                stream: mediaStream
            };
        };
        // https://webaudio.github.io/web-audio-api/#audioworklet
        // Using AudioWorklet to improve audio quality and avoid audio glitches due to blocking the UI thread
        if (!!context.audioWorklet) {
            if (!this.privSpeechProcessorScript) {
                const workletScript = `class SP extends AudioWorkletProcessor {
                    constructor(options) {
                      super(options);
                    }
                    process(inputs, outputs) {
                      const input = inputs[0];
                      const output = [];
                      for (let channel = 0; channel < input.length; channel += 1) {
                        output[channel] = input[channel];
                      }
                      this.port.postMessage(output[0]);
                      return true;
                    }
                  }
                  registerProcessor('speech-processor', SP);`;
                const blob = new Blob([
                    workletScript
                ], {
                    type: "application/javascript; charset=utf-8"
                });
                this.privSpeechProcessorScript = URL.createObjectURL(blob);
            }
            context.audioWorklet.addModule(this.privSpeechProcessorScript).then(()=>{
                const workletNode = new AudioWorkletNode(context, "speech-processor");
                workletNode.port.onmessage = (ev)=>{
                    const inputFrame = ev.data;
                    if (outputStream && !outputStream.isClosed) {
                        const waveFrame = waveStreamEncoder.encode(inputFrame);
                        if (!!waveFrame) outputStream.writeStreamChunk({
                            buffer: waveFrame,
                            isEnd: false,
                            timeReceived: Date.now()
                        });
                    }
                };
                micInput.connect(workletNode);
                workletNode.connect(context.destination);
                this.privMediaResources = {
                    scriptProcessorNode: workletNode,
                    source: micInput,
                    stream: mediaStream
                };
            }).catch(()=>{
                attachScriptProcessor();
            });
        } else try {
            attachScriptProcessor();
        } catch (err) {
            throw new Error(`Unable to start audio worklet node for PCMRecorder: ${err}`);
        }
    }
    releaseMediaResources(context) {
        if (this.privMediaResources) {
            if (this.privMediaResources.scriptProcessorNode) {
                this.privMediaResources.scriptProcessorNode.disconnect(context.destination);
                this.privMediaResources.scriptProcessorNode = null;
            }
            if (this.privMediaResources.source) {
                this.privMediaResources.source.disconnect();
                if (this.privStopInputOnRelease) this.privMediaResources.stream.getTracks().forEach((track)=>track.stop());
                this.privMediaResources.source = null;
            }
        }
    }
    setWorkletUrl(url) {
        this.privSpeechProcessorScript = url;
    }
}

});

parcelRequire.register("jSt6R", function(module, exports) {
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
parcelRequire("cR8AB");
var $83Xvm = parcelRequire("83Xvm");
var $hsGnG = parcelRequire("hsGnG");

var $a0Dqy = parcelRequire("a0Dqy");
var $e789a40f1408068a$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
class $e789a40f1408068a$export$659cb444c1aa6c10 {
    constructor(uri, queryParameters, headers, messageFormatter, proxyInfo, enableCompression = false, connectionId){
        this.privIsDisposed = false;
        if (!uri) throw new (0, $83Xvm.ArgumentNullError)("uri");
        if (!messageFormatter) throw new (0, $83Xvm.ArgumentNullError)("messageFormatter");
        this.privMessageFormatter = messageFormatter;
        let queryParams = "";
        let i = 0;
        if (queryParameters) {
            for(const paramName in queryParameters)if (paramName) {
                queryParams += i === 0 && uri.indexOf("?") === -1 ? "?" : "&";
                const key = encodeURIComponent(paramName);
                queryParams += key;
                let val = queryParameters[paramName];
                if (val) {
                    val = encodeURIComponent(val);
                    queryParams += `=${val}`;
                }
                i++;
            }
        }
        if (headers) {
            for(const headerName in headers)if (headerName) {
                queryParams += i === 0 && uri.indexOf("?") === -1 ? "?" : "&";
                const val = encodeURIComponent(headers[headerName]);
                queryParams += `${headerName}=${val}`;
                i++;
            }
        }
        this.privUri = uri + queryParams;
        this.privId = connectionId ? connectionId : (0, $hsGnG.createNoDashGuid)();
        this.privConnectionMessageAdapter = new (0, $a0Dqy.WebsocketMessageAdapter)(this.privUri, this.id, this.privMessageFormatter, proxyInfo, headers, enableCompression);
    }
    dispose() {
        return $e789a40f1408068a$var$__awaiter(this, void 0, void 0, function*() {
            this.privIsDisposed = true;
            if (this.privConnectionMessageAdapter) yield this.privConnectionMessageAdapter.close();
        });
    }
    isDisposed() {
        return this.privIsDisposed;
    }
    get id() {
        return this.privId;
    }
    get uri() {
        return this.privUri;
    }
    state() {
        return this.privConnectionMessageAdapter.state;
    }
    open() {
        return this.privConnectionMessageAdapter.open();
    }
    send(message) {
        return this.privConnectionMessageAdapter.send(message);
    }
    read() {
        return this.privConnectionMessageAdapter.read();
    }
    get events() {
        return this.privConnectionMessageAdapter.events;
    }
}

});
parcelRequire.register("a0Dqy", function(module, exports) {

$parcel$export(module.exports, "WebsocketMessageAdapter", () => $74987ce79b90e7f1$export$2b2f6d87ad7998b5);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.

var $gR5sk = parcelRequire("gR5sk");

var $gR5sk = parcelRequire("gR5sk");

var $gR5sk = parcelRequire("gR5sk");

var $gR5sk = parcelRequire("gR5sk");

var $gR5sk = parcelRequire("gR5sk");

var $dazVK = parcelRequire("dazVK");
parcelRequire("cR8AB");
var $83Xvm = parcelRequire("83Xvm");
var $dxrNf = parcelRequire("dxrNf");
var $1v63k = parcelRequire("1v63k");
var $2YVQf = parcelRequire("2YVQf");
var $g4XyH = parcelRequire("g4XyH");
var $4utc3 = parcelRequire("4utc3");
var $3qWVN = parcelRequire("3qWVN");
var $g9GEc = parcelRequire("g9GEc");
var $ieLRH = parcelRequire("ieLRH");
var $fERMy = parcelRequire("fERMy");
var $jQZQm = parcelRequire("jQZQm");

var $cBXue = parcelRequire("cBXue");
var $74987ce79b90e7f1$require$Buffer = $cBXue.Buffer;
var $74987ce79b90e7f1$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
class $74987ce79b90e7f1$export$2b2f6d87ad7998b5 {
    constructor(uri, connectionId, messageFormatter, proxyInfo, headers, enableCompression){
        if (!uri) throw new (0, $83Xvm.ArgumentNullError)("uri");
        if (!messageFormatter) throw new (0, $83Xvm.ArgumentNullError)("messageFormatter");
        this.proxyInfo = proxyInfo;
        this.privConnectionEvents = new (0, $dxrNf.EventSource)();
        this.privConnectionId = connectionId;
        this.privMessageFormatter = messageFormatter;
        this.privConnectionState = (0, $1v63k.ConnectionState).None;
        this.privUri = uri;
        this.privHeaders = headers;
        this.privEnableCompression = enableCompression;
        // Add the connection ID to the headers
        this.privHeaders[(0, $dazVK.HeaderNames).ConnectionId] = this.privConnectionId;
        this.privLastErrorReceived = "";
    }
    get state() {
        return this.privConnectionState;
    }
    open() {
        if (this.privConnectionState === (0, $1v63k.ConnectionState).Disconnected) return Promise.reject(`Cannot open a connection that is in ${this.privConnectionState} state`);
        if (this.privConnectionEstablishDeferral) return this.privConnectionEstablishDeferral.promise;
        this.privConnectionEstablishDeferral = new (0, $2YVQf.Deferred)();
        this.privCertificateValidatedDeferral = new (0, $2YVQf.Deferred)();
        this.privConnectionState = (0, $1v63k.ConnectionState).Connecting;
        try {
            if (typeof WebSocket !== "undefined" && !$74987ce79b90e7f1$export$2b2f6d87ad7998b5.forceNpmWebSocket) {
                // Browser handles cert checks.
                this.privCertificateValidatedDeferral.resolve();
                this.privWebsocketClient = new WebSocket(this.privUri);
            } else {
                const options = {
                    headers: this.privHeaders,
                    perMessageDeflate: this.privEnableCompression
                };
                // The ocsp library will handle validation for us and fail the connection if needed.
                this.privCertificateValidatedDeferral.resolve();
                options.agent = this.getAgent();
                // Workaround for https://github.com/microsoft/cognitive-services-speech-sdk-js/issues/465
                // Which is root caused by https://github.com/TooTallNate/node-agent-base/issues/61
                const uri = new URL(this.privUri);
                let protocol = uri.protocol;
                if ((protocol === null || protocol === void 0 ? void 0 : protocol.toLocaleLowerCase()) === "wss:") protocol = "https:";
                else if ((protocol === null || protocol === void 0 ? void 0 : protocol.toLocaleLowerCase()) === "ws:") protocol = "http:";
                // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
                options.agent.protocol = protocol;
                this.privWebsocketClient = new (0, (/*@__PURE__*/$parcel$interopDefault($gR5sk)))(this.privUri, options);
            }
            this.privWebsocketClient.binaryType = "arraybuffer";
            this.privReceivingMessageQueue = new (0, $g4XyH.Queue)();
            this.privDisconnectDeferral = new (0, $2YVQf.Deferred)();
            this.privSendMessageQueue = new (0, $g4XyH.Queue)();
            this.processSendQueue().catch((reason)=>{
                (0, $4utc3.Events).instance.onEvent(new (0, $3qWVN.BackgroundEvent)(reason));
            });
        } catch (error) {
            this.privConnectionEstablishDeferral.resolve(new (0, $g9GEc.ConnectionOpenResponse)(500, error));
            return this.privConnectionEstablishDeferral.promise;
        }
        this.onEvent(new (0, $ieLRH.ConnectionStartEvent)(this.privConnectionId, this.privUri));
        this.privWebsocketClient.onopen = ()=>{
            this.privCertificateValidatedDeferral.promise.then(()=>{
                this.privConnectionState = (0, $1v63k.ConnectionState).Connected;
                this.onEvent(new (0, $ieLRH.ConnectionEstablishedEvent)(this.privConnectionId));
                this.privConnectionEstablishDeferral.resolve(new (0, $g9GEc.ConnectionOpenResponse)(200, ""));
            }, (error)=>{
                this.privConnectionEstablishDeferral.reject(error);
            });
        };
        this.privWebsocketClient.onerror = (e)=>{
            this.onEvent(new (0, $ieLRH.ConnectionErrorEvent)(this.privConnectionId, e.message, e.type));
            this.privLastErrorReceived = e.message;
        };
        this.privWebsocketClient.onclose = (e)=>{
            if (this.privConnectionState === (0, $1v63k.ConnectionState).Connecting) {
                this.privConnectionState = (0, $1v63k.ConnectionState).Disconnected;
                // this.onEvent(new ConnectionEstablishErrorEvent(this.connectionId, e.code, e.reason));
                this.privConnectionEstablishDeferral.resolve(new (0, $g9GEc.ConnectionOpenResponse)(e.code, e.reason + " " + this.privLastErrorReceived));
            } else {
                this.privConnectionState = (0, $1v63k.ConnectionState).Disconnected;
                this.privWebsocketClient = null;
                this.onEvent(new (0, $ieLRH.ConnectionClosedEvent)(this.privConnectionId, e.code, e.reason));
            }
            this.onClose(e.code, e.reason).catch((reason)=>{
                (0, $4utc3.Events).instance.onEvent(new (0, $3qWVN.BackgroundEvent)(reason));
            });
        };
        this.privWebsocketClient.onmessage = (e)=>{
            const networkReceivedTime = new Date().toISOString();
            if (this.privConnectionState === (0, $1v63k.ConnectionState).Connected) {
                const deferred = new (0, $2YVQf.Deferred)();
                // let id = ++this.idCounter;
                this.privReceivingMessageQueue.enqueueFromPromise(deferred.promise);
                if (e.data instanceof ArrayBuffer) {
                    const rawMessage = new (0, $fERMy.RawWebsocketMessage)((0, $jQZQm.MessageType).Binary, e.data);
                    this.privMessageFormatter.toConnectionMessage(rawMessage).then((connectionMessage)=>{
                        this.onEvent(new (0, $ieLRH.ConnectionMessageReceivedEvent)(this.privConnectionId, networkReceivedTime, connectionMessage));
                        deferred.resolve(connectionMessage);
                    }, (error)=>{
                        // TODO: Events for these ?
                        deferred.reject(`Invalid binary message format. Error: ${error}`);
                    });
                } else {
                    const rawMessage = new (0, $fERMy.RawWebsocketMessage)((0, $jQZQm.MessageType).Text, e.data);
                    this.privMessageFormatter.toConnectionMessage(rawMessage).then((connectionMessage)=>{
                        this.onEvent(new (0, $ieLRH.ConnectionMessageReceivedEvent)(this.privConnectionId, networkReceivedTime, connectionMessage));
                        deferred.resolve(connectionMessage);
                    }, (error)=>{
                        // TODO: Events for these ?
                        deferred.reject(`Invalid text message format. Error: ${error}`);
                    });
                }
            }
        };
        return this.privConnectionEstablishDeferral.promise;
    }
    send(message) {
        if (this.privConnectionState !== (0, $1v63k.ConnectionState).Connected) return Promise.reject(`Cannot send on connection that is in ${(0, $1v63k.ConnectionState)[this.privConnectionState]} state`);
        const messageSendStatusDeferral = new (0, $2YVQf.Deferred)();
        const messageSendDeferral = new (0, $2YVQf.Deferred)();
        this.privSendMessageQueue.enqueueFromPromise(messageSendDeferral.promise);
        this.privMessageFormatter.fromConnectionMessage(message).then((rawMessage)=>{
            messageSendDeferral.resolve({
                Message: message,
                RawWebsocketMessage: rawMessage,
                sendStatusDeferral: messageSendStatusDeferral
            });
        }, (error)=>{
            messageSendDeferral.reject(`Error formatting the message. ${error}`);
        });
        return messageSendStatusDeferral.promise;
    }
    read() {
        if (this.privConnectionState !== (0, $1v63k.ConnectionState).Connected) return Promise.reject(`Cannot read on connection that is in ${this.privConnectionState} state`);
        return this.privReceivingMessageQueue.dequeue();
    }
    close(reason) {
        if (this.privWebsocketClient) {
            if (this.privConnectionState !== (0, $1v63k.ConnectionState).Disconnected) this.privWebsocketClient.close(1000, reason ? reason : "Normal closure by client");
        } else return Promise.resolve();
        return this.privDisconnectDeferral.promise;
    }
    get events() {
        return this.privConnectionEvents;
    }
    sendRawMessage(sendItem) {
        try {
            // indicates we are draining the queue and it came with no message;
            if (!sendItem) return Promise.resolve();
            this.onEvent(new (0, $ieLRH.ConnectionMessageSentEvent)(this.privConnectionId, new Date().toISOString(), sendItem.Message));
            // add a check for the ws readystate in order to stop the red console error 'WebSocket is already in CLOSING or CLOSED state' appearing
            if (this.isWebsocketOpen) // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
            this.privWebsocketClient.send(sendItem.RawWebsocketMessage.payload);
            else return Promise.reject("websocket send error: Websocket not ready " + this.privConnectionId + " " + sendItem.Message.id + " " + new Error().stack);
            return Promise.resolve();
        } catch (e) {
            return Promise.reject(`websocket send error: ${e}`);
        }
    }
    onClose(code, reason) {
        return $74987ce79b90e7f1$var$__awaiter(this, void 0, void 0, function*() {
            const closeReason = `Connection closed. ${code}: ${reason}`;
            this.privConnectionState = (0, $1v63k.ConnectionState).Disconnected;
            this.privDisconnectDeferral.resolve();
            yield this.privReceivingMessageQueue.drainAndDispose(()=>{
            // TODO: Events for these ?
            // Logger.instance.onEvent(new LoggingEvent(LogType.Warning, null, `Failed to process received message. Reason: ${closeReason}, Message: ${JSON.stringify(pendingReceiveItem)}`));
            }, closeReason);
            yield this.privSendMessageQueue.drainAndDispose((pendingSendItem)=>{
                pendingSendItem.sendStatusDeferral.reject(closeReason);
            }, closeReason);
        });
    }
    processSendQueue() {
        return $74987ce79b90e7f1$var$__awaiter(this, void 0, void 0, function*() {
            while(true){
                const itemToSend = this.privSendMessageQueue.dequeue();
                const sendItem = yield itemToSend;
                // indicates we are draining the queue and it came with no message;
                if (!sendItem) return;
                try {
                    yield this.sendRawMessage(sendItem);
                    sendItem.sendStatusDeferral.resolve();
                } catch (sendError) {
                    sendItem.sendStatusDeferral.reject(sendError);
                }
            }
        });
    }
    onEvent(event) {
        this.privConnectionEvents.onEvent(event);
        (0, $4utc3.Events).instance.onEvent(event);
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    getAgent() {
        // eslint-disable-next-line @typescript-eslint/unbound-method
        const agent = new (0, (/*@__PURE__*/$parcel$interopDefault($gR5sk))).Agent(this.createConnection);
        if (this.proxyInfo !== undefined && this.proxyInfo.HostName !== undefined && this.proxyInfo.Port > 0) agent.proxyInfo = this.proxyInfo;
        return agent;
    }
    static GetProxyAgent(proxyInfo) {
        const httpProxyOptions = {
            host: proxyInfo.HostName,
            port: proxyInfo.Port
        };
        if (!!proxyInfo.UserName) httpProxyOptions.headers = {
            "Proxy-Authentication": "Basic " + new $74987ce79b90e7f1$require$Buffer(`${proxyInfo.UserName}:${proxyInfo.Password === undefined ? "" : proxyInfo.Password}`).toString("base64")
        };
        else httpProxyOptions.headers = {};
        httpProxyOptions.headers.requestOCSP = "true";
        const httpProxyAgent = new (0, (/*@__PURE__*/$parcel$interopDefault($gR5sk)))(httpProxyOptions);
        return httpProxyAgent;
    }
    createConnection(request, options) {
        let socketPromise;
        options = Object.assign(Object.assign({}, options), {
            requestOCSP: true,
            servername: options.host
        });
        if (!!this.proxyInfo) {
            const httpProxyAgent = $74987ce79b90e7f1$export$2b2f6d87ad7998b5.GetProxyAgent(this.proxyInfo);
            const baseAgent = httpProxyAgent;
            socketPromise = new Promise((resolve, reject)=>{
                baseAgent.callback(request, options, (error, socket)=>{
                    if (!!error) reject(error);
                    else resolve(socket);
                });
            });
        } else if (!!options.secureEndpoint) socketPromise = Promise.resolve($gR5sk.connect(options));
        else socketPromise = Promise.resolve($gR5sk.connect(options));
        return socketPromise;
    }
    get isWebsocketOpen() {
        return this.privWebsocketClient && this.privWebsocketClient.readyState === this.privWebsocketClient.OPEN;
    }
}
$74987ce79b90e7f1$export$2b2f6d87ad7998b5.forceNpmWebSocket = false;

});


parcelRequire.register("6RE4c", function(module, exports) {

$parcel$export(module.exports, "ReplayableAudioNode", () => $4ff6c5bb25508f9a$export$3553271f667249af);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
class $4ff6c5bb25508f9a$export$3553271f667249af {
    constructor(audioSource, bytesPerSecond){
        this.privBuffers = [];
        this.privReplayOffset = 0;
        this.privLastShrinkOffset = 0;
        this.privBufferStartOffset = 0;
        this.privBufferSerial = 0;
        this.privBufferedBytes = 0;
        this.privReplay = false;
        this.privLastChunkAcquiredTime = 0;
        this.privAudioNode = audioSource;
        this.privBytesPerSecond = bytesPerSecond;
    }
    id() {
        return this.privAudioNode.id();
    }
    // Reads and returns the next chunk of audio buffer.
    // If replay of existing buffers are needed, read() will first seek and replay
    // existing content, and upoin completion it will read new content from the underlying
    // audio node, saving that content into the replayable buffers.
    read() {
        // if there is a replay request to honor.
        if (!!this.privReplay && this.privBuffers.length !== 0) {
            // Find the start point in the buffers.
            // Offsets are in 100ns increments.
            // So how many bytes do we need to seek to get the right offset?
            const offsetToSeek = this.privReplayOffset - this.privBufferStartOffset;
            let bytesToSeek = Math.round(offsetToSeek * this.privBytesPerSecond * 1e-7);
            if (0 !== bytesToSeek % 2) bytesToSeek++;
            let i = 0;
            while(i < this.privBuffers.length && bytesToSeek >= this.privBuffers[i].chunk.buffer.byteLength)bytesToSeek -= this.privBuffers[i++].chunk.buffer.byteLength;
            if (i < this.privBuffers.length) {
                const retVal = this.privBuffers[i].chunk.buffer.slice(bytesToSeek);
                this.privReplayOffset += retVal.byteLength / this.privBytesPerSecond * 1e+7;
                // If we've reached the end of the buffers, stop replaying.
                if (i === this.privBuffers.length - 1) this.privReplay = false;
                return Promise.resolve({
                    buffer: retVal,
                    isEnd: false,
                    timeReceived: this.privBuffers[i].chunk.timeReceived
                });
            }
        }
        return this.privAudioNode.read().then((result)=>{
            if (result && result.buffer) {
                this.privBuffers.push(new $4ff6c5bb25508f9a$var$BufferEntry(result, this.privBufferSerial++, this.privBufferedBytes));
                this.privBufferedBytes += result.buffer.byteLength;
            }
            return result;
        });
    }
    detach() {
        this.privBuffers = undefined;
        return this.privAudioNode.detach();
    }
    replay() {
        if (this.privBuffers && 0 !== this.privBuffers.length) {
            this.privReplay = true;
            this.privReplayOffset = this.privLastShrinkOffset;
        }
    }
    // Shrinks the existing audio buffers to start at the new offset, or at the
    // beginning of the buffer closest to the requested offset.
    // A replay request will start from the last shrink point.
    shrinkBuffers(offset) {
        if (this.privBuffers === undefined || this.privBuffers.length === 0) return;
        this.privLastShrinkOffset = offset;
        // Find the start point in the buffers.
        // Offsets are in 100ns increments.
        // So how many bytes do we need to seek to get the right offset?
        const offsetToSeek = offset - this.privBufferStartOffset;
        let bytesToSeek = Math.round(offsetToSeek * this.privBytesPerSecond * 1e-7);
        let i = 0;
        while(i < this.privBuffers.length && bytesToSeek >= this.privBuffers[i].chunk.buffer.byteLength)bytesToSeek -= this.privBuffers[i++].chunk.buffer.byteLength;
        this.privBufferStartOffset = Math.round(offset - bytesToSeek / this.privBytesPerSecond * 1e+7);
        this.privBuffers = this.privBuffers.slice(i);
    }
    // Finds the time a buffer of audio was first seen by offset.
    findTimeAtOffset(offset) {
        if (offset < this.privBufferStartOffset || this.privBuffers === undefined) return 0;
        for (const value of this.privBuffers){
            const startOffset = value.byteOffset / this.privBytesPerSecond * 1e7;
            const endOffset = startOffset + value.chunk.buffer.byteLength / this.privBytesPerSecond * 1e7;
            if (offset >= startOffset && offset <= endOffset) return value.chunk.timeReceived;
        }
        return 0;
    }
}
// Primary use of this class is to help debugging problems with the replay
// code. If the memory cost of alloc / dealloc gets too much, drop it and just use
// the ArrayBuffer directly.
class $4ff6c5bb25508f9a$var$BufferEntry {
    constructor(chunk, serial, byteOffset){
        this.chunk = chunk;
        this.serial = serial;
        this.byteOffset = byteOffset;
    }
}

});

parcelRequire.register("SMwRY", function(module, exports) {
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.

var $1poFJ = parcelRequire("1poFJ");
parcelRequire("cR8AB");
var $83Xvm = parcelRequire("83Xvm");
var $2YVQf = parcelRequire("2YVQf");
var $0a4ab023c11c858d$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $0a4ab023c11c858d$export$7e4a254cc224227f;
(function(RestRequestType) {
    RestRequestType["Get"] = "GET";
    RestRequestType["Post"] = "POST";
    RestRequestType["Delete"] = "DELETE";
    RestRequestType["File"] = "file";
})($0a4ab023c11c858d$export$7e4a254cc224227f || ($0a4ab023c11c858d$export$7e4a254cc224227f = {}));
class $0a4ab023c11c858d$export$9721ae21c2a3931a {
    constructor(configParams){
        if (!configParams) throw new (0, $83Xvm.ArgumentNullError)("configParams");
        this.privHeaders = configParams.headers;
        this.privIgnoreCache = configParams.ignoreCache;
    }
    static extractHeaderValue(headerKey, headers) {
        let headerValue = "";
        try {
            const arr = headers.trim().split(/[\r\n]+/);
            const headerMap = {};
            arr.forEach((line)=>{
                const parts = line.split(": ");
                const header = parts.shift().toLowerCase();
                const value = parts.join(": ");
                headerMap[header] = value;
            });
            headerValue = headerMap[headerKey.toLowerCase()];
        } catch (e) {
        // ignore the error
        }
        return headerValue;
    }
    set options(configParams) {
        this.privHeaders = configParams.headers;
        this.privIgnoreCache = configParams.ignoreCache;
    }
    setHeaders(key, value) {
        this.privHeaders[key] = value;
    }
    request(method, uri, queryParams = {}, body = null) {
        const responseReceivedDeferral = new (0, $2YVQf.Deferred)();
        const requestCommand = method === $0a4ab023c11c858d$export$7e4a254cc224227f.File ? "POST" : method;
        const handleRestResponse = (data, j = {})=>{
            const d = data;
            return {
                data: JSON.stringify(j),
                headers: JSON.stringify(data.headers),
                json: j,
                ok: data.statusCode >= 200 && data.statusCode < 300,
                status: data.statusCode,
                statusText: j.error ? j.error.message : d.statusText ? d.statusText : d.statusMessage
            };
        };
        const send = (postData)=>{
            const sendRequest = (0, (/*@__PURE__*/$parcel$interopDefault($1poFJ)))(uri, requestCommand, this.privHeaders, 200, 201, 202, 204, 400, 401, 402, 403, 404);
            const params = this.queryParams(queryParams) === "" ? "" : `?${this.queryParams(queryParams)}`;
            sendRequest(params, postData).then((data)=>$0a4ab023c11c858d$var$__awaiter(this, void 0, void 0, function*() {
                    if (method === $0a4ab023c11c858d$export$7e4a254cc224227f.Delete || data.statusCode === 204) // No JSON from Delete and reset (204) operations
                    responseReceivedDeferral.resolve(handleRestResponse(data));
                    else try {
                        const j = yield data.json();
                        responseReceivedDeferral.resolve(handleRestResponse(data, j));
                    } catch (_a) {
                        responseReceivedDeferral.resolve(handleRestResponse(data));
                    }
                })).catch((error)=>{
                responseReceivedDeferral.reject(error);
            });
        };
        if (this.privIgnoreCache) this.privHeaders["Cache-Control"] = "no-cache";
        if (method === $0a4ab023c11c858d$export$7e4a254cc224227f.Post && body) {
            this.privHeaders["content-type"] = "application/json";
            this.privHeaders["Content-Type"] = "application/json";
        }
        send(body);
        return responseReceivedDeferral.promise;
    }
    queryParams(params = {}) {
        return Object.keys(params).map((k)=>encodeURIComponent(k) + "=" + encodeURIComponent(params[k])).join("&");
    }
}

});


parcelRequire.register("gcbed", function(module, exports) {

$parcel$export(module.exports, "AudioInputStream", () => $bca67a033e930139$export$d2b41ea729bcd23a);
$parcel$export(module.exports, "PullAudioInputStreamImpl", () => $bca67a033e930139$export$aa28c96dd85a430d);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
parcelRequire("jSpbe");
var $cOea6 = parcelRequire("cOea6");
parcelRequire("cR8AB");
var $dxrNf = parcelRequire("dxrNf");
var $2mIQY = parcelRequire("2mIQY");
var $bqySL = parcelRequire("bqySL");
var $4utc3 = parcelRequire("4utc3");

var $hsGnG = parcelRequire("hsGnG");

var $6489m = parcelRequire("6489m");

var $6489m = parcelRequire("6489m");

var $cBXue = parcelRequire("cBXue");
var $bca67a033e930139$require$Buffer = $cBXue.Buffer;
var $bca67a033e930139$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
class $bca67a033e930139$export$d2b41ea729bcd23a {
    /**
     * Creates and initializes an instance.
     * @constructor
     */ constructor(){
        return;
    }
    /**
     * Creates a memory backed PushAudioInputStream with the specified audio format.
     * @member AudioInputStream.createPushStream
     * @function
     * @public
     * @param {AudioStreamFormat} format - The audio data format in which audio will be
     * written to the push audio stream's write() method (Required if format is not 16 kHz 16bit mono PCM).
     * @returns {PushAudioInputStream} The audio input stream being created.
     */ static createPushStream(format) {
        return $bca67a033e930139$export$c65274612fceab73.create(format);
    }
    /**
     * Creates a PullAudioInputStream that delegates to the specified callback interface for read()
     * and close() methods.
     * @member AudioInputStream.createPullStream
     * @function
     * @public
     * @param {PullAudioInputStreamCallback} callback - The custom audio input object, derived from
     * PullAudioInputStreamCallback
     * @param {AudioStreamFormat} format - The audio data format in which audio will be returned from
     * the callback's read() method (Required if format is not 16 kHz 16bit mono PCM).
     * @returns {PullAudioInputStream} The audio input stream being created.
     */ static createPullStream(callback, format) {
        return $bca67a033e930139$export$2b6293045b3dda4e.create(callback, format);
    // throw new Error("Oops");
    }
}
class $bca67a033e930139$export$c65274612fceab73 extends $bca67a033e930139$export$d2b41ea729bcd23a {
    /**
     * Creates a memory backed PushAudioInputStream with the specified audio format.
     * @member PushAudioInputStream.create
     * @function
     * @public
     * @param {AudioStreamFormat} format - The audio data format in which audio will be written to the
     * push audio stream's write() method (Required if format is not 16 kHz 16bit mono PCM).
     * @returns {PushAudioInputStream} The push audio input stream being created.
     */ static create(format) {
        return new $bca67a033e930139$export$96d17a539b8936d6(format);
    }
}
class $bca67a033e930139$export$96d17a539b8936d6 extends $bca67a033e930139$export$c65274612fceab73 {
    /**
     * Creates and initalizes an instance with the given values.
     * @constructor
     * @param {AudioStreamFormat} format - The audio stream format.
     */ constructor(format){
        super();
        if (format === undefined) this.privFormat = (0, $6489m.AudioStreamFormatImpl).getDefaultInputFormat();
        else this.privFormat = format;
        this.privEvents = new (0, $dxrNf.EventSource)();
        this.privId = (0, $hsGnG.createNoDashGuid)();
        this.privStream = new (0, $2mIQY.ChunkedArrayBufferStream)(this.privFormat.avgBytesPerSec / 10);
    }
    /**
     * Format information for the audio
     */ get format() {
        return Promise.resolve(this.privFormat);
    }
    /**
     * Writes the audio data specified by making an internal copy of the data.
     * @member PushAudioInputStreamImpl.prototype.write
     * @function
     * @public
     * @param {ArrayBuffer} dataBuffer - The audio buffer of which this function will make a copy.
     */ write(dataBuffer) {
        this.privStream.writeStreamChunk({
            buffer: dataBuffer,
            isEnd: false,
            timeReceived: Date.now()
        });
    }
    /**
     * Closes the stream.
     * @member PushAudioInputStreamImpl.prototype.close
     * @function
     * @public
     */ close() {
        this.privStream.close();
    }
    id() {
        return this.privId;
    }
    turnOn() {
        this.onEvent(new (0, $bqySL.AudioSourceInitializingEvent)(this.privId)); // no stream id
        this.onEvent(new (0, $bqySL.AudioSourceReadyEvent)(this.privId));
        return;
    }
    attach(audioNodeId) {
        return $bca67a033e930139$var$__awaiter(this, void 0, void 0, function*() {
            this.onEvent(new (0, $bqySL.AudioStreamNodeAttachingEvent)(this.privId, audioNodeId));
            yield this.turnOn();
            const stream = this.privStream;
            this.onEvent(new (0, $bqySL.AudioStreamNodeAttachedEvent)(this.privId, audioNodeId));
            return {
                detach: ()=>$bca67a033e930139$var$__awaiter(this, void 0, void 0, function*() {
                        this.onEvent(new (0, $bqySL.AudioStreamNodeDetachedEvent)(this.privId, audioNodeId));
                        return this.turnOff();
                    }),
                id: ()=>audioNodeId,
                read: ()=>stream.read()
            };
        });
    }
    detach(audioNodeId) {
        this.onEvent(new (0, $bqySL.AudioStreamNodeDetachedEvent)(this.privId, audioNodeId));
    }
    turnOff() {
        return;
    }
    get events() {
        return this.privEvents;
    }
    get deviceInfo() {
        return Promise.resolve({
            bitspersample: this.privFormat.bitsPerSample,
            channelcount: this.privFormat.channels,
            connectivity: (0, $cOea6.connectivity).Unknown,
            manufacturer: "Speech SDK",
            model: "PushStream",
            samplerate: this.privFormat.samplesPerSec,
            type: (0, $cOea6.type).Stream
        });
    }
    onEvent(event) {
        this.privEvents.onEvent(event);
        (0, $4utc3.Events).instance.onEvent(event);
    }
    toBuffer(arrayBuffer) {
        const buf = $bca67a033e930139$require$Buffer.alloc(arrayBuffer.byteLength);
        const view = new Uint8Array(arrayBuffer);
        for(let i = 0; i < buf.length; ++i)buf[i] = view[i];
        return buf;
    }
}
class $bca67a033e930139$export$2b6293045b3dda4e extends $bca67a033e930139$export$d2b41ea729bcd23a {
    /**
     * Creates and initializes and instance.
     * @constructor
     */ constructor(){
        super();
    }
    /**
     * Creates a PullAudioInputStream that delegates to the specified callback interface for
     * read() and close() methods, using the default format (16 kHz 16bit mono PCM).
     * @member PullAudioInputStream.create
     * @function
     * @public
     * @param {PullAudioInputStreamCallback} callback - The custom audio input object,
     * derived from PullAudioInputStreamCustomCallback
     * @param {AudioStreamFormat} format - The audio data format in which audio will be
     * returned from the callback's read() method (Required if format is not 16 kHz 16bit mono PCM).
     * @returns {PullAudioInputStream} The push audio input stream being created.
     */ static create(callback, format) {
        return new $bca67a033e930139$export$aa28c96dd85a430d(callback, format);
    }
}
class $bca67a033e930139$export$aa28c96dd85a430d extends $bca67a033e930139$export$2b6293045b3dda4e {
    /**
     * Creates a PullAudioInputStream that delegates to the specified callback interface for
     * read() and close() methods, using the default format (16 kHz 16bit mono PCM).
     * @constructor
     * @param {PullAudioInputStreamCallback} callback - The custom audio input object,
     * derived from PullAudioInputStreamCustomCallback
     * @param {AudioStreamFormat} format - The audio data format in which audio will be
     * returned from the callback's read() method (Required if format is not 16 kHz 16bit mono PCM).
     */ constructor(callback, format){
        super();
        if (undefined === format) this.privFormat = (0, $6489m.AudioStreamFormat).getDefaultInputFormat();
        else this.privFormat = format;
        this.privEvents = new (0, $dxrNf.EventSource)();
        this.privId = (0, $hsGnG.createNoDashGuid)();
        this.privCallback = callback;
        this.privIsClosed = false;
        this.privBufferSize = this.privFormat.avgBytesPerSec / 10;
    }
    /**
     * Format information for the audio
     */ get format() {
        return Promise.resolve(this.privFormat);
    }
    /**
     * Closes the stream.
     * @member PullAudioInputStreamImpl.prototype.close
     * @function
     * @public
     */ close() {
        this.privIsClosed = true;
        this.privCallback.close();
    }
    id() {
        return this.privId;
    }
    turnOn() {
        this.onEvent(new (0, $bqySL.AudioSourceInitializingEvent)(this.privId)); // no stream id
        this.onEvent(new (0, $bqySL.AudioSourceReadyEvent)(this.privId));
        return;
    }
    attach(audioNodeId) {
        return $bca67a033e930139$var$__awaiter(this, void 0, void 0, function*() {
            this.onEvent(new (0, $bqySL.AudioStreamNodeAttachingEvent)(this.privId, audioNodeId));
            yield this.turnOn();
            this.onEvent(new (0, $bqySL.AudioStreamNodeAttachedEvent)(this.privId, audioNodeId));
            return {
                detach: ()=>{
                    this.privCallback.close();
                    this.onEvent(new (0, $bqySL.AudioStreamNodeDetachedEvent)(this.privId, audioNodeId));
                    return this.turnOff();
                },
                id: ()=>audioNodeId,
                read: ()=>{
                    let totalBytes = 0;
                    let transmitBuff;
                    // Until we have the minimum number of bytes to send in a transmission, keep asking for more.
                    while(totalBytes < this.privBufferSize){
                        // Sizing the read buffer to the delta between the perfect size and what's left means we won't ever get too much
                        // data back.
                        const readBuff = new ArrayBuffer(this.privBufferSize - totalBytes);
                        const pulledBytes = this.privCallback.read(readBuff);
                        // If there is no return buffer yet defined, set the return buffer to the that was just populated.
                        // This was, if we have enough data there's no copy penalty, but if we don't we have a buffer that's the
                        // preferred size allocated.
                        if (undefined === transmitBuff) transmitBuff = readBuff;
                        else {
                            // Not the first bite at the apple, so fill the return buffer with the data we got back.
                            const intView = new Int8Array(transmitBuff);
                            intView.set(new Int8Array(readBuff), totalBytes);
                        }
                        // If there are no bytes to read, just break out and be done.
                        if (0 === pulledBytes) break;
                        totalBytes += pulledBytes;
                    }
                    return Promise.resolve({
                        buffer: transmitBuff.slice(0, totalBytes),
                        isEnd: this.privIsClosed || totalBytes === 0,
                        timeReceived: Date.now()
                    });
                }
            };
        });
    }
    detach(audioNodeId) {
        this.onEvent(new (0, $bqySL.AudioStreamNodeDetachedEvent)(this.privId, audioNodeId));
    }
    turnOff() {
        return;
    }
    get events() {
        return this.privEvents;
    }
    get deviceInfo() {
        return Promise.resolve({
            bitspersample: this.privFormat.bitsPerSample,
            channelcount: this.privFormat.channels,
            connectivity: (0, $cOea6.connectivity).Unknown,
            manufacturer: "Speech SDK",
            model: "PullStream",
            samplerate: this.privFormat.samplesPerSec,
            type: (0, $cOea6.type).Stream
        });
    }
    onEvent(event) {
        this.privEvents.onEvent(event);
        (0, $4utc3.Events).instance.onEvent(event);
    }
}

});

parcelRequire.register("9QD3l", function(module, exports) {

$parcel$export(module.exports, "PullAudioInputStreamCallback", () => $72b743815858ffdf$export$2d63425b32f9d538);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
/**
 * An abstract base class that defines callback methods (read() and close()) for
 * custom audio input streams).
 * @class PullAudioInputStreamCallback
 */ class $72b743815858ffdf$export$2d63425b32f9d538 {
}

});

parcelRequire.register("ckEpY", function(module, exports) {

$parcel$export(module.exports, "PushAudioOutputStreamCallback", () => $8fa6b4731d7683ba$export$af7283ebc568ec10);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
/**
 * An abstract base class that defines callback methods (write() and close()) for
 * custom audio output streams).
 * @class PushAudioOutputStreamCallback
 */ class $8fa6b4731d7683ba$export$af7283ebc568ec10 {
}

});

parcelRequire.register("feGef", function(module, exports) {

$parcel$export(module.exports, "SpeakerAudioDestination", () => $b178eb948ed8576e$export$c717373bdea3ec69);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
parcelRequire("jSpbe");
var $iuSgX = parcelRequire("iuSgX");
parcelRequire("cR8AB");
var $hsGnG = parcelRequire("hsGnG");
var $4utc3 = parcelRequire("4utc3");
var $3qWVN = parcelRequire("3qWVN");

var $isMcl = parcelRequire("isMcl");

var $6489m = parcelRequire("6489m");
var $b178eb948ed8576e$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const $b178eb948ed8576e$var$MediaDurationPlaceholderSeconds = 1800;
const $b178eb948ed8576e$var$AudioFormatToMimeType = {
    [(0, $6489m.AudioFormatTag).PCM]: "audio/wav",
    [(0, $6489m.AudioFormatTag).MuLaw]: "audio/x-wav",
    [(0, $6489m.AudioFormatTag).MP3]: "audio/mpeg",
    [(0, $6489m.AudioFormatTag).OGG_OPUS]: "audio/ogg",
    [(0, $6489m.AudioFormatTag).WEBM_OPUS]: "audio/webm; codecs=opus",
    [(0, $6489m.AudioFormatTag).ALaw]: "audio/x-wav",
    [(0, $6489m.AudioFormatTag).FLAC]: "audio/flac"
};
class $b178eb948ed8576e$export$c717373bdea3ec69 {
    constructor(audioDestinationId){
        this.privPlaybackStarted = false;
        this.privAppendingToBuffer = false;
        this.privMediaSourceOpened = false;
        this.privBytesReceived = 0;
        this.privId = audioDestinationId ? audioDestinationId : (0, $hsGnG.createNoDashGuid)();
        this.privIsPaused = false;
        this.privIsClosed = false;
    }
    id() {
        return this.privId;
    }
    write(buffer, cb, err) {
        if (this.privAudioBuffer !== undefined) {
            this.privAudioBuffer.push(buffer);
            this.updateSourceBuffer().then(()=>{
                if (!!cb) cb();
            }, (error)=>{
                if (!!err) err(error);
            });
        } else if (this.privAudioOutputStream !== undefined) {
            this.privAudioOutputStream.write(buffer);
            this.privBytesReceived += buffer.byteLength;
        }
    }
    close(cb, err) {
        this.privIsClosed = true;
        if (this.privSourceBuffer !== undefined) this.handleSourceBufferUpdateEnd().then(()=>{
            if (!!cb) cb();
        }, (error)=>{
            if (!!err) err(error);
        });
        else if (this.privAudioOutputStream !== undefined && typeof window !== "undefined") {
            if ((this.privFormat.formatTag === (0, $6489m.AudioFormatTag).PCM || this.privFormat.formatTag === (0, $6489m.AudioFormatTag).MuLaw || this.privFormat.formatTag === (0, $6489m.AudioFormatTag).ALaw) && this.privFormat.hasHeader === false) {
                // eslint-disable-next-line no-console
                console.warn("Play back is not supported for raw PCM, mulaw or alaw format without header.");
                if (!!this.onAudioEnd) this.onAudioEnd(this);
            } else {
                let receivedAudio = new ArrayBuffer(this.privBytesReceived);
                this.privAudioOutputStream.read(receivedAudio).then(()=>{
                    receivedAudio = (0, $iuSgX.SynthesisAdapterBase).addHeader(receivedAudio, this.privFormat);
                    const audioBlob = new Blob([
                        receivedAudio
                    ], {
                        type: $b178eb948ed8576e$var$AudioFormatToMimeType[this.privFormat.formatTag]
                    });
                    this.privAudio.src = window.URL.createObjectURL(audioBlob);
                    this.notifyPlayback().then(()=>{
                        if (!!cb) cb();
                    }, (error)=>{
                        if (!!err) err(error);
                    });
                }, (error)=>{
                    if (!!err) err(error);
                });
            }
        } else // unsupported format, call onAudioEnd directly.
        if (!!this.onAudioEnd) this.onAudioEnd(this);
    }
    set format(format) {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        if (typeof AudioContext !== "undefined" || typeof window !== "undefined" && typeof window.webkitAudioContext !== "undefined") {
            this.privFormat = format;
            const mimeType = $b178eb948ed8576e$var$AudioFormatToMimeType[this.privFormat.formatTag];
            if (mimeType === undefined) // eslint-disable-next-line no-console
            console.warn(`Unknown mimeType for format ${(0, $6489m.AudioFormatTag)[this.privFormat.formatTag]}; playback is not supported.`);
            else if (typeof MediaSource !== "undefined" && MediaSource.isTypeSupported(mimeType)) {
                this.privAudio = new Audio();
                this.privAudioBuffer = [];
                this.privMediaSource = new MediaSource();
                this.privAudio.src = URL.createObjectURL(this.privMediaSource);
                this.privAudio.load();
                this.privMediaSource.onsourceopen = ()=>{
                    this.privMediaSourceOpened = true;
                    this.privMediaSource.duration = $b178eb948ed8576e$var$MediaDurationPlaceholderSeconds;
                    this.privSourceBuffer = this.privMediaSource.addSourceBuffer(mimeType);
                    this.privSourceBuffer.onupdate = ()=>{
                        this.updateSourceBuffer().catch((reason)=>{
                            (0, $4utc3.Events).instance.onEvent(new (0, $3qWVN.BackgroundEvent)(reason));
                        });
                    };
                    this.privSourceBuffer.onupdateend = ()=>{
                        this.handleSourceBufferUpdateEnd().catch((reason)=>{
                            (0, $4utc3.Events).instance.onEvent(new (0, $3qWVN.BackgroundEvent)(reason));
                        });
                    };
                    this.privSourceBuffer.onupdatestart = ()=>{
                        this.privAppendingToBuffer = false;
                    };
                };
                this.updateSourceBuffer().catch((reason)=>{
                    (0, $4utc3.Events).instance.onEvent(new (0, $3qWVN.BackgroundEvent)(reason));
                });
            } else {
                // eslint-disable-next-line no-console
                console.warn(`Format ${(0, $6489m.AudioFormatTag)[this.privFormat.formatTag]} could not be played by MSE, streaming playback is not enabled.`);
                this.privAudioOutputStream = new (0, $isMcl.PullAudioOutputStreamImpl)();
                this.privAudioOutputStream.format = this.privFormat;
                this.privAudio = new Audio();
            }
        }
    }
    get volume() {
        var _a, _b;
        return (_b = (_a = this.privAudio) === null || _a === void 0 ? void 0 : _a.volume) !== null && _b !== void 0 ? _b : -1;
    }
    set volume(volume) {
        if (!!this.privAudio) this.privAudio.volume = volume;
    }
    mute() {
        if (!!this.privAudio) this.privAudio.muted = true;
    }
    unmute() {
        if (!!this.privAudio) this.privAudio.muted = false;
    }
    get isClosed() {
        return this.privIsClosed;
    }
    get currentTime() {
        if (this.privAudio !== undefined) return this.privAudio.currentTime;
        return -1;
    }
    pause() {
        if (!this.privIsPaused && this.privAudio !== undefined) {
            this.privAudio.pause();
            this.privIsPaused = true;
        }
    }
    resume(cb, err) {
        if (this.privIsPaused && this.privAudio !== undefined) {
            this.privAudio.play().then(()=>{
                if (!!cb) cb();
            }, (error)=>{
                if (!!err) err(error);
            });
            this.privIsPaused = false;
        }
    }
    get internalAudio() {
        return this.privAudio;
    }
    updateSourceBuffer() {
        return $b178eb948ed8576e$var$__awaiter(this, void 0, void 0, function*() {
            if (this.privAudioBuffer !== undefined && this.privAudioBuffer.length > 0 && this.sourceBufferAvailable()) {
                this.privAppendingToBuffer = true;
                const binary = this.privAudioBuffer.shift();
                try {
                    this.privSourceBuffer.appendBuffer(binary);
                } catch (error) {
                    this.privAudioBuffer.unshift(binary);
                    // eslint-disable-next-line no-console
                    console.log("buffer filled, pausing addition of binaries until space is made");
                    return;
                }
                yield this.notifyPlayback();
            } else if (this.canEndStream()) yield this.handleSourceBufferUpdateEnd();
        });
    }
    handleSourceBufferUpdateEnd() {
        return $b178eb948ed8576e$var$__awaiter(this, void 0, void 0, function*() {
            if (this.canEndStream() && this.sourceBufferAvailable()) {
                this.privMediaSource.endOfStream();
                yield this.notifyPlayback();
            }
        });
    }
    notifyPlayback() {
        return $b178eb948ed8576e$var$__awaiter(this, void 0, void 0, function*() {
            if (!this.privPlaybackStarted && this.privAudio !== undefined) {
                this.privPlaybackStarted = true;
                if (!!this.onAudioStart) this.onAudioStart(this);
                this.privAudio.onended = ()=>{
                    if (!!this.onAudioEnd) this.onAudioEnd(this);
                };
                if (!this.privIsPaused) yield this.privAudio.play();
            }
        });
    }
    canEndStream() {
        return this.isClosed && this.privSourceBuffer !== undefined && this.privAudioBuffer.length === 0 && this.privMediaSourceOpened && !this.privAppendingToBuffer && this.privMediaSource.readyState === "open";
    }
    sourceBufferAvailable() {
        return this.privSourceBuffer !== undefined && !this.privSourceBuffer.updating;
    }
}

});

parcelRequire.register("3JFU9", function(module, exports) {

$parcel$export(module.exports, "AudioFileWriter", () => $2b86147110b9e5a9$export$b18256b0fa0aa326);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.

var $gR5sk = parcelRequire("gR5sk");

var $8HmyV = parcelRequire("8HmyV");
class $2b86147110b9e5a9$export$b18256b0fa0aa326 {
    constructor(filename){
        (0, $8HmyV.Contracts).throwIfNullOrUndefined($gR5sk.openSync, "\nFile System access not available, please use Push or PullAudioOutputStream");
        this.privFd = $gR5sk.openSync(filename, "w");
    }
    set format(format) {
        (0, $8HmyV.Contracts).throwIfNotUndefined(this.privAudioFormat, "format is already set");
        this.privAudioFormat = format;
        let headerOffset = 0;
        if (this.privAudioFormat.hasHeader) headerOffset = this.privAudioFormat.header.byteLength;
        if (this.privFd !== undefined) this.privWriteStream = $gR5sk.createWriteStream("", {
            fd: this.privFd,
            start: headerOffset,
            autoClose: false
        });
    }
    write(buffer) {
        (0, $8HmyV.Contracts).throwIfNullOrUndefined(this.privAudioFormat, "must set format before writing.");
        if (this.privWriteStream !== undefined) this.privWriteStream.write(new Uint8Array(buffer.slice(0)));
    }
    close() {
        if (this.privFd !== undefined) {
            this.privWriteStream.on("finish", ()=>{
                if (this.privAudioFormat.hasHeader) {
                    this.privAudioFormat.updateHeader(this.privWriteStream.bytesWritten);
                    $gR5sk.writeSync(this.privFd, new Int8Array(this.privAudioFormat.header), 0, this.privAudioFormat.header.byteLength, 0);
                }
                $gR5sk.closeSync(this.privFd);
                this.privFd = undefined;
            });
            this.privWriteStream.end();
        }
    }
    id() {
        return this.privId;
    }
}

});


parcelRequire.register("8h1lI", function(module, exports) {
"use strict";

var $clWYw = parcelRequire("clWYw");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6060f52fa57abad9$var$_createClass2 = $clWYw((parcelRequire("kkabb")));

var $6060f52fa57abad9$var$_classCallCheck2 = $clWYw((parcelRequire("kFs3a")));

var $6060f52fa57abad9$var$_inherits2 = $clWYw((parcelRequire("edsvT")));

var $6060f52fa57abad9$var$_possibleConstructorReturn2 = $clWYw((parcelRequire("lKMYv")));

var $6060f52fa57abad9$var$_getPrototypeOf2 = $clWYw((parcelRequire("iXZmE")));

var $bgEWP = parcelRequire("bgEWP");
function $6060f52fa57abad9$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $6060f52fa57abad9$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, $6060f52fa57abad9$var$_getPrototypeOf2.default)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $6060f52fa57abad9$var$_getPrototypeOf2.default)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $6060f52fa57abad9$var$_possibleConstructorReturn2.default)(this, result);
    };
}
function $6060f52fa57abad9$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
var $6060f52fa57abad9$var$SpeechSynthesisEvent = /*#__PURE__*/ function(_Event) {
    (0, $6060f52fa57abad9$var$_inherits2.default)(SpeechSynthesisEvent, _Event);
    var _super = $6060f52fa57abad9$var$_createSuper(SpeechSynthesisEvent);
    function SpeechSynthesisEvent() {
        (0, $6060f52fa57abad9$var$_classCallCheck2.default)(this, SpeechSynthesisEvent);
        return _super.apply(this, arguments);
    }
    return (0, $6060f52fa57abad9$var$_createClass2.default)(SpeechSynthesisEvent);
}($bgEWP.Event);
module.exports.default = $6060f52fa57abad9$var$SpeechSynthesisEvent;

});

parcelRequire.register("O7wfL", function(module, exports) {
"use strict";

var $clWYw = parcelRequire("clWYw");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $096a80c91263f165$var$_regenerator = $clWYw((parcelRequire("ilkkY")));

var $096a80c91263f165$var$_asyncToGenerator2 = $clWYw((parcelRequire("f4cyQ")));

var $096a80c91263f165$var$_classCallCheck2 = $clWYw((parcelRequire("kFs3a")));

var $096a80c91263f165$var$_createClass2 = $clWYw((parcelRequire("kkabb")));

var $096a80c91263f165$var$_inherits2 = $clWYw((parcelRequire("edsvT")));

var $096a80c91263f165$var$_possibleConstructorReturn2 = $clWYw((parcelRequire("lKMYv")));

var $096a80c91263f165$var$_getPrototypeOf2 = $clWYw((parcelRequire("iXZmE")));

var $bgEWP = parcelRequire("bgEWP");

var $096a80c91263f165$var$_eventAsPromise = $clWYw((parcelRequire("2pzIa")));

var $096a80c91263f165$var$_fetchSpeechData = $clWYw((parcelRequire("fUgqV")));

var $096a80c91263f165$var$_SpeechSynthesisEvent = $clWYw((parcelRequire("8h1lI")));

var $096a80c91263f165$var$_subscribeEvent = $clWYw((parcelRequire("hkWGM")));
function $096a80c91263f165$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $096a80c91263f165$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, $096a80c91263f165$var$_getPrototypeOf2.default)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $096a80c91263f165$var$_getPrototypeOf2.default)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $096a80c91263f165$var$_possibleConstructorReturn2.default)(this, result);
    };
}
function $096a80c91263f165$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $096a80c91263f165$var$asyncDecodeAudioData(audioContext, arrayBuffer) {
    return new Promise(function(resolve, reject) {
        var promise = audioContext.decodeAudioData(arrayBuffer, resolve, reject); // Newer implementation of "decodeAudioData" will return a Promise
        promise && typeof promise.then === "function" && resolve(promise);
    });
}
function $096a80c91263f165$var$playDecoded(audioContext, audioBuffer, source) {
    return new Promise(function(resolve, reject) {
        var audioContextClosed = new $096a80c91263f165$var$_eventAsPromise.default();
        var sourceEnded = new $096a80c91263f165$var$_eventAsPromise.default();
        var unsubscribe = (0, $096a80c91263f165$var$_subscribeEvent.default)(audioContext, "statechange", function(_ref) {
            var state = _ref.target.state;
            return state === "closed" && audioContextClosed.eventListener();
        });
        try {
            source.buffer = audioBuffer; // "ended" may not fire if the underlying AudioContext is closed prematurely
            source.onended = sourceEnded.eventListener;
            source.connect(audioContext.destination);
            source.start(0);
            Promise.race([
                audioContextClosed.upcoming(),
                sourceEnded.upcoming()
            ]).then(resolve);
        } catch (err) {
            reject(err);
        } finally{
            unsubscribe();
        }
    });
}
var $096a80c91263f165$var$SpeechSynthesisUtterance = /*#__PURE__*/ function(_EventTarget) {
    (0, $096a80c91263f165$var$_inherits2.default)(SpeechSynthesisUtterance, _EventTarget);
    var _super = $096a80c91263f165$var$_createSuper(SpeechSynthesisUtterance);
    function SpeechSynthesisUtterance(text) {
        var _this;
        (0, $096a80c91263f165$var$_classCallCheck2.default)(this, SpeechSynthesisUtterance);
        _this = _super.call(this);
        _this._lang = null;
        _this._pitch = 1;
        _this._rate = 1;
        _this._voice = null;
        _this._volume = 1;
        _this.text = text;
        _this.onboundary = null;
        _this.onend = null;
        _this.onerror = null;
        _this.onmark = null;
        _this.onpause = null;
        _this.onresume = null;
        _this.onstart = null;
        _this.onviseme = null;
        _this.audioElement = new Audio();
        return _this;
    }
    (0, $096a80c91263f165$var$_createClass2.default)(SpeechSynthesisUtterance, [
        {
            key: "lang",
            get: function get() {
                return this._lang;
            },
            set: function set(value) {
                this._lang = value;
            }
        },
        {
            key: "onboundary",
            get: function get() {
                return (0, $bgEWP.getEventAttributeValue)(this, "boundary");
            },
            set: function set(value) {
                (0, $bgEWP.setEventAttributeValue)(this, "boundary", value);
            }
        },
        {
            key: "onend",
            get: function get() {
                return (0, $bgEWP.getEventAttributeValue)(this, "end");
            },
            set: function set(value) {
                (0, $bgEWP.setEventAttributeValue)(this, "end", value);
            }
        },
        {
            key: "onerror",
            get: function get() {
                return (0, $bgEWP.getEventAttributeValue)(this, "error");
            },
            set: function set(value) {
                (0, $bgEWP.setEventAttributeValue)(this, "error", value);
            }
        },
        {
            key: "onmark",
            get: function get() {
                return (0, $bgEWP.getEventAttributeValue)(this, "mark");
            },
            set: function set(value) {
                (0, $bgEWP.setEventAttributeValue)(this, "mark", value);
            }
        },
        {
            key: "onpause",
            get: function get() {
                return (0, $bgEWP.getEventAttributeValue)(this, "pause");
            },
            set: function set(value) {
                (0, $bgEWP.setEventAttributeValue)(this, "pause", value);
            }
        },
        {
            key: "onresume",
            get: function get() {
                return (0, $bgEWP.getEventAttributeValue)(this, "resume");
            },
            set: function set(value) {
                (0, $bgEWP.setEventAttributeValue)(this, "resume", value);
            }
        },
        {
            key: "onstart",
            get: function get() {
                return (0, $bgEWP.getEventAttributeValue)(this, "start");
            },
            set: function set(value) {
                (0, $bgEWP.setEventAttributeValue)(this, "start", value);
            }
        },
        {
            key: "onviseme",
            get: function get() {
                return (0, $bgEWP.getEventAttributeValue)(this, "viseme");
            },
            set: function set(value) {
                (0, $bgEWP.setEventAttributeValue)(this, "viseme", value);
            }
        },
        {
            key: "pitch",
            get: function get() {
                return this._pitch;
            },
            set: function set(value) {
                this._pitch = value;
            }
        },
        {
            key: "rate",
            get: function get() {
                return this._rate;
            },
            set: function set(value) {
                this._rate = value;
            }
        },
        {
            key: "voice",
            get: function get() {
                return this._voice;
            },
            set: function set(value) {
                this._voice = value;
            }
        },
        {
            key: "volume",
            get: function get() {
                return this._volume;
            },
            set: function set(value) {
                this._volume = value;
            }
        },
        {
            key: "preload",
            value: function() {
                var _preload = (0, $096a80c91263f165$var$_asyncToGenerator2.default)(/*#__PURE__*/ $096a80c91263f165$var$_regenerator.default.mark(function _callee(_ref2) {
                    var deploymentId, fetchCredentials, outputFormat, arrayBuffer, blob, url;
                    return $096a80c91263f165$var$_regenerator.default.wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                deploymentId = _ref2.deploymentId, fetchCredentials = _ref2.fetchCredentials, outputFormat = _ref2.outputFormat;
                                this.arrayBufferPromise = (0, $096a80c91263f165$var$_fetchSpeechData.default)({
                                    fetchCredentials: fetchCredentials,
                                    deploymentId: deploymentId,
                                    lang: this.lang || window.navigator.language,
                                    outputFormat: outputFormat,
                                    pitch: this.pitch,
                                    rate: this.rate,
                                    text: this.text,
                                    voice: this.voice && this.voice.voiceURI,
                                    volume: this.volume
                                }); // We need to call "catch" to make sure the Promise is running.
                                // We will ignore the reject result and handled in play() later.
                                this.arrayBufferPromise.catch(); // Set the source for the audioElement after fetching the URL
                                _context.next = 5;
                                return this.arrayBufferPromise;
                            case 5:
                                arrayBuffer = _context.sent;
                                blob = new Blob([
                                    arrayBuffer
                                ], {
                                    type: "audio/mp3"
                                });
                                url = URL.createObjectURL(blob);
                                this.audioElement.src = url;
                            case 9:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this);
                }));
                function preload(_x) {
                    return _preload.apply(this, arguments);
                }
                return preload;
            }()
        },
        {
            key: "play",
            value: function() {
                var _play = (0, $096a80c91263f165$var$_asyncToGenerator2.default)(/*#__PURE__*/ $096a80c91263f165$var$_regenerator.default.mark(function _callee2(audioContext) {
                    var source, audioBuffer;
                    return $096a80c91263f165$var$_regenerator.default.wrap(function _callee2$(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                _context2.prev = 0;
                                // We should emit "start" event even if preload() failed.
                                this.dispatchEvent(new $096a80c91263f165$var$_SpeechSynthesisEvent.default("start")); // HACK: iOS requires bufferSourceNode to be constructed before decoding data.
                                source = audioContext.createBufferSource();
                                _context2.t0 = $096a80c91263f165$var$asyncDecodeAudioData;
                                _context2.t1 = audioContext;
                                _context2.next = 7;
                                return this.arrayBufferPromise;
                            case 7:
                                _context2.t2 = _context2.sent;
                                _context2.next = 10;
                                return (0, _context2.t0)(_context2.t1, _context2.t2);
                            case 10:
                                audioBuffer = _context2.sent;
                                this._playingSource = source;
                                _context2.next = 14;
                                return $096a80c91263f165$var$playDecoded(audioContext, audioBuffer, source);
                            case 14:
                                this._playingSource = null;
                                this.dispatchEvent(new $096a80c91263f165$var$_SpeechSynthesisEvent.default("end"));
                                _context2.next = 21;
                                break;
                            case 18:
                                _context2.prev = 18;
                                _context2.t3 = _context2["catch"](0);
                                // "message" is not in spec but to provide a friendly message.
                                this.dispatchEvent(new ErrorEvent("error", {
                                    error: "synthesis-failed",
                                    message: _context2.t3.stack
                                }));
                            case 21:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, this, [
                        [
                            0,
                            18
                        ]
                    ]);
                }));
                function play(_x2) {
                    return _play.apply(this, arguments);
                }
                return play;
            }()
        },
        {
            key: "stop",
            value: function stop() {
                this._playingSource && this._playingSource.stop();
            }
        }
    ]);
    return SpeechSynthesisUtterance;
}($bgEWP.EventTarget);
var $096a80c91263f165$var$_default = $096a80c91263f165$var$SpeechSynthesisUtterance;
module.exports.default = $096a80c91263f165$var$_default;

});
parcelRequire.register("fUgqV", function(module, exports) {
"use strict";

var $clWYw = parcelRequire("clWYw");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $b948d5496cbed354$var$_default;

var $b948d5496cbed354$var$_regenerator = $clWYw((parcelRequire("ilkkY")));

var $b948d5496cbed354$var$_defineProperty2 = $clWYw((parcelRequire("0ITDg")));

var $b948d5496cbed354$var$_asyncToGenerator2 = $clWYw((parcelRequire("f4cyQ")));

var $gmKnH = parcelRequire("gmKnH");

var $b948d5496cbed354$var$_buildSSML = $clWYw((parcelRequire("jUnJz")));

var $b948d5496cbed354$var$_isSSML = $clWYw((parcelRequire("ahIca")));
function $b948d5496cbed354$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $b948d5496cbed354$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $b948d5496cbed354$var$ownKeys(Object(source), !0).forEach(function(key) {
            (0, $b948d5496cbed354$var$_defineProperty2.default)(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $b948d5496cbed354$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var $b948d5496cbed354$var$DEFAULT_LANGUAGE = "en-US";
var $b948d5496cbed354$var$DEFAULT_OUTPUT_FORMAT = "riff-16khz-16bit-mono-pcm";
var $b948d5496cbed354$var$DEFAULT_VOICE = "Microsoft Server Speech Text to Speech Voice (en-US, AriaNeural)";
var $b948d5496cbed354$var$EMPTY_MP3_BASE64 = "SUQzBAAAAAAAI1RTU0UAAAAPAAADTGF2ZjU3LjU2LjEwMQAAAAAAAAAAAAAA//tAwAAAAAAAAAAAAAAAAAAAAAAASW5mbwAAAA8AAAACAAABhgC7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7//////////////////////////////////////////////////////////////////8AAAAATGF2YzU3LjY0AAAAAAAAAAAAAAAAJAUHAAAAAAAAAYYoRBqpAAAAAAD/+xDEAAPAAAGkAAAAIAAANIAAAARMQU1FMy45OS41VVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVf/7EMQpg8AAAaQAAAAgAAA0gAAABFVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVV";
function $b948d5496cbed354$var$_default(_x) {
    return $b948d5496cbed354$var$_ref2.apply(this, arguments);
}
function $b948d5496cbed354$var$_ref2() {
    $b948d5496cbed354$var$_ref2 = (0, $b948d5496cbed354$var$_asyncToGenerator2.default)(/*#__PURE__*/ $b948d5496cbed354$var$_regenerator.default.mark(function _callee(_ref) {
        var deploymentId, fetchCredentials, _ref$lang, lang, _ref$outputFormat, outputFormat, pitch, rate, text, _ref$voice, voice, volume, _yield$fetchCredentia, authorizationToken, region, speechSynthesisHostname, subscriptionKey, ssml, hostname, search, url, res;
        return $b948d5496cbed354$var$_regenerator.default.wrap(function _callee$(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    deploymentId = _ref.deploymentId, fetchCredentials = _ref.fetchCredentials, _ref$lang = _ref.lang, lang = _ref$lang === void 0 ? $b948d5496cbed354$var$DEFAULT_LANGUAGE : _ref$lang, _ref$outputFormat = _ref.outputFormat, outputFormat = _ref$outputFormat === void 0 ? $b948d5496cbed354$var$DEFAULT_OUTPUT_FORMAT : _ref$outputFormat, pitch = _ref.pitch, rate = _ref.rate, text = _ref.text, _ref$voice = _ref.voice, voice = _ref$voice === void 0 ? $b948d5496cbed354$var$DEFAULT_VOICE : _ref$voice, volume = _ref.volume;
                    if (text) {
                        _context.next = 3;
                        break;
                    }
                    return _context.abrupt("return", (0, $gmKnH.decode)($b948d5496cbed354$var$EMPTY_MP3_BASE64));
                case 3:
                    _context.next = 5;
                    return fetchCredentials();
                case 5:
                    _yield$fetchCredentia = _context.sent;
                    authorizationToken = _yield$fetchCredentia.authorizationToken;
                    region = _yield$fetchCredentia.region;
                    speechSynthesisHostname = _yield$fetchCredentia.speechSynthesisHostname;
                    subscriptionKey = _yield$fetchCredentia.subscriptionKey;
                    if (!(authorizationToken && subscriptionKey || !authorizationToken && !subscriptionKey)) {
                        _context.next = 14;
                        break;
                    }
                    throw new Error('Only "authorizationToken" or "subscriptionKey" should be set.');
                case 14:
                    if (!(region && speechSynthesisHostname || !region && !speechSynthesisHostname)) {
                        _context.next = 16;
                        break;
                    }
                    throw new Error('Only "region" or "speechSynthesisHostnamename" should be set.');
                case 16:
                    ssml = (0, $b948d5496cbed354$var$_isSSML.default)(text) ? text : (0, $b948d5496cbed354$var$_buildSSML.default)({
                        lang: lang,
                        pitch: pitch,
                        rate: rate,
                        text: text,
                        voice: voice,
                        volume: volume
                    }); // Although calling encodeURI on hostname does not actually works, it fails faster and safer.
                    hostname = speechSynthesisHostname || (deploymentId ? "".concat(encodeURI(region), ".voice.speech.microsoft.com") : "".concat(encodeURI(region), ".tts.speech.microsoft.com"));
                    search = deploymentId ? "?deploymentId=".concat(encodeURI(deploymentId)) : "";
                    url = "https://".concat(hostname, "/cognitiveservices/v1").concat(search);
                    _context.next = 22;
                    return fetch(url, {
                        headers: $b948d5496cbed354$var$_objectSpread({
                            "Content-Type": "application/ssml+xml",
                            "X-Microsoft-OutputFormat": outputFormat
                        }, authorizationToken ? {
                            Authorization: "Bearer ".concat(authorizationToken)
                        } : {
                            "Ocp-Apim-Subscription-Key": subscriptionKey
                        }),
                        method: "POST",
                        body: ssml
                    });
                case 22:
                    res = _context.sent;
                    if (res.ok) {
                        _context.next = 25;
                        break;
                    }
                    throw new Error("web-speech-cognitive-services: Failed to syntheis speech, server returned ".concat(res.status));
                case 25:
                    return _context.abrupt("return", res.arrayBuffer());
                case 26:
                case "end":
                    return _context.stop();
            }
        }, _callee);
    }));
    return $b948d5496cbed354$var$_ref2.apply(this, arguments);
}

});
parcelRequire.register("jUnJz", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $e7e5a861bda659c4$var$buildSSML;
/* eslint no-magic-numbers: ["error", { "ignore": [0, 1, 100] }] */ // Cognitive Services does not support unsigned percentage
// It must be converted into +/- first.
function $e7e5a861bda659c4$var$relativePercentage(value) {
    var relative = Math.round((value - 1) * 100);
    if (relative >= 0) relative = "+" + relative;
    return relative + "%";
}
function $e7e5a861bda659c4$var$buildSSML(_ref) {
    var lang = _ref.lang, _ref$pitch = _ref.pitch, pitch = _ref$pitch === void 0 ? 1 : _ref$pitch, _ref$rate = _ref.rate, rate = _ref$rate === void 0 ? 1 : _ref$rate, text = _ref.text, voice = _ref.voice, volume = _ref.volume;
    return '<speak version="1.0" xml:lang="'.concat(lang, '">\n  <voice xml:lang="').concat(lang, '" name="').concat(voice, '">\n    <prosody pitch="').concat($e7e5a861bda659c4$var$relativePercentage(pitch), '" rate="').concat($e7e5a861bda659c4$var$relativePercentage(rate), '" volume="').concat($e7e5a861bda659c4$var$relativePercentage(volume), '">\n      ').concat(text, "\n    </prosody>\n  </voice>\n</speak>");
}

});

parcelRequire.register("ahIca", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $77cdc626a67e8bc2$var$isSSML;
var $77cdc626a67e8bc2$var$SPEAK_TAG_PATTERN = /^[\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]*<speak([\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]|\/?>)/;
var $77cdc626a67e8bc2$var$XML_PROLOG_PATTERN = /^[\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]*<\?xml[\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]/;
function $77cdc626a67e8bc2$var$isSSML(text) {
    return $77cdc626a67e8bc2$var$SPEAK_TAG_PATTERN.test(text) || $77cdc626a67e8bc2$var$XML_PROLOG_PATTERN.test(text);
}

});


parcelRequire.register("hkWGM", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $c9f1d45034255e35$var$subscribeEvent;
function $c9f1d45034255e35$var$subscribeEvent(target, name, handler) {
    target.addEventListener(name, handler);
    return function() {
        return target.removeEventListener(name, handler);
    };
}

});


parcelRequire.register("4t9QW", function(module, exports) {
"use strict";

var $clWYw = parcelRequire("clWYw");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3411836e31c84b63$var$_classCallCheck2 = $clWYw((parcelRequire("kFs3a")));

var $3411836e31c84b63$var$_createClass2 = $clWYw((parcelRequire("kkabb")));
var $3411836e31c84b63$var$_default = /*#__PURE__*/ function() {
    function _default(_ref) {
        var gender = _ref.gender, lang = _ref.lang, voiceURI = _ref.voiceURI;
        (0, $3411836e31c84b63$var$_classCallCheck2.default)(this, _default);
        this._default = false;
        this._gender = gender;
        this._lang = lang;
        this._localService = false;
        this._name = voiceURI;
        this._voiceURI = voiceURI;
    }
    (0, $3411836e31c84b63$var$_createClass2.default)(_default, [
        {
            key: "default",
            get: function get() {
                return this._default;
            }
        },
        {
            key: "gender",
            get: function get() {
                return this._gender;
            }
        },
        {
            key: "lang",
            get: function get() {
                return this._lang;
            }
        },
        {
            key: "localService",
            get: function get() {
                return this._localService;
            }
        },
        {
            key: "name",
            get: function get() {
                return this._name;
            }
        },
        {
            key: "voiceURI",
            get: function get() {
                return this._voiceURI;
            }
        }
    ]);
    return _default;
}();
module.exports.default = $3411836e31c84b63$var$_default;

});



parcelRequire.register("iWVEf", function(module, exports) {
"use strict";

var $clWYw = parcelRequire("clWYw");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $dcba5c7b25878cda$var$_default;

var $dcba5c7b25878cda$var$_regenerator = $clWYw((parcelRequire("ilkkY")));

var $dcba5c7b25878cda$var$_asyncToGenerator2 = $clWYw((parcelRequire("f4cyQ")));
var $dcba5c7b25878cda$var$TOKEN_URL_TEMPLATE = "https://{region}.api.cognitive.microsoft.com/sts/v1.0/issueToken";
function $dcba5c7b25878cda$var$_default(_x) {
    return $dcba5c7b25878cda$var$_ref2.apply(this, arguments);
}
function $dcba5c7b25878cda$var$_ref2() {
    $dcba5c7b25878cda$var$_ref2 = (0, $dcba5c7b25878cda$var$_asyncToGenerator2.default)(/*#__PURE__*/ $dcba5c7b25878cda$var$_regenerator.default.mark(function _callee(_ref) {
        var region, subscriptionKey, res;
        return $dcba5c7b25878cda$var$_regenerator.default.wrap(function _callee$(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    region = _ref.region, subscriptionKey = _ref.subscriptionKey;
                    _context.next = 3;
                    return fetch($dcba5c7b25878cda$var$TOKEN_URL_TEMPLATE.replace(/\{region\}/, region), {
                        headers: {
                            "Ocp-Apim-Subscription-Key": subscriptionKey
                        },
                        method: "POST"
                    });
                case 3:
                    res = _context.sent;
                    if (res.ok) {
                        _context.next = 6;
                        break;
                    }
                    throw new Error("Failed to fetch authorization token, server returned ".concat(res.status));
                case 6:
                    return _context.abrupt("return", res.text());
                case 7:
                case "end":
                    return _context.stop();
            }
        }, _callee);
    }));
    return $dcba5c7b25878cda$var$_ref2.apply(this, arguments);
}

});

parcelRequire.register("9oAFS", function(module, exports) {
/* UAParser.js v1.0.35
   Copyright © 2012-2021 Faisal Salman <f@faisalman.com>
   MIT License */ (function(window1, undefined) {
    "use strict";
    var LIBVERSION = "1.0.35", EMPTY = "", UNKNOWN = "?", FUNC_TYPE = "function", UNDEF_TYPE = "undefined", OBJ_TYPE = "object", STR_TYPE = "string", MAJOR = "major", MODEL = "model", NAME = "name", TYPE = "type", VENDOR = "vendor", VERSION = "version", ARCHITECTURE = "architecture", CONSOLE = "console", MOBILE = "mobile", TABLET = "tablet", SMARTTV = "smarttv", WEARABLE = "wearable", EMBEDDED = "embedded", UA_MAX_LENGTH = 350;
    var AMAZON = "Amazon", APPLE = "Apple", ASUS = "ASUS", BLACKBERRY = "BlackBerry", BROWSER = "Browser", CHROME = "Chrome", EDGE = "Edge", FIREFOX = "Firefox", GOOGLE = "Google", HUAWEI = "Huawei", LG = "LG", MICROSOFT = "Microsoft", MOTOROLA = "Motorola", OPERA = "Opera", SAMSUNG = "Samsung", SHARP = "Sharp", SONY = "Sony", VIERA = "Viera", XIAOMI = "Xiaomi", ZEBRA = "Zebra", FACEBOOK = "Facebook", CHROMIUM_OS = "Chromium OS", MAC_OS = "Mac OS";
    var extend = function(regexes, extensions) {
        var mergedRegexes = {};
        for(var i in regexes)if (extensions[i] && extensions[i].length % 2 === 0) mergedRegexes[i] = extensions[i].concat(regexes[i]);
        else mergedRegexes[i] = regexes[i];
        return mergedRegexes;
    }, enumerize = function(arr) {
        var enums = {};
        for(var i = 0; i < arr.length; i++)enums[arr[i].toUpperCase()] = arr[i];
        return enums;
    }, has = function(str1, str2) {
        return typeof str1 === STR_TYPE ? lowerize(str2).indexOf(lowerize(str1)) !== -1 : false;
    }, lowerize = function(str) {
        return str.toLowerCase();
    }, majorize = function(version) {
        return typeof version === STR_TYPE ? version.replace(/[^\d\.]/g, EMPTY).split(".")[0] : undefined;
    }, trim = function(str, len) {
        if (typeof str === STR_TYPE) {
            str = str.replace(/^\s\s*/, EMPTY);
            return typeof len === UNDEF_TYPE ? str : str.substring(0, UA_MAX_LENGTH);
        }
    };
    var rgxMapper = function(ua, arrays) {
        var i = 0, j, k, p, q, matches, match;
        while(i < arrays.length && !matches){
            var regex = arrays[i], props = arrays[i + 1];
            j = k = 0;
            while(j < regex.length && !matches){
                if (!regex[j]) break;
                matches = regex[j++].exec(ua);
                if (!!matches) for(p = 0; p < props.length; p++){
                    match = matches[++k];
                    q = props[p];
                    if (typeof q === OBJ_TYPE && q.length > 0) {
                        if (q.length === 2) {
                            if (typeof q[1] == FUNC_TYPE) this[q[0]] = q[1].call(this, match);
                            else this[q[0]] = q[1];
                        } else if (q.length === 3) {
                            if (typeof q[1] === FUNC_TYPE && !(q[1].exec && q[1].test)) this[q[0]] = match ? q[1].call(this, match, q[2]) : undefined;
                            else this[q[0]] = match ? match.replace(q[1], q[2]) : undefined;
                        } else if (q.length === 4) this[q[0]] = match ? q[3].call(this, match.replace(q[1], q[2])) : undefined;
                    } else this[q] = match ? match : undefined;
                }
            }
            i += 2;
        }
    }, strMapper = function(str, map) {
        for(var i in map){
            if (typeof map[i] === OBJ_TYPE && map[i].length > 0) for(var j = 0; j < map[i].length; j++){
                if (has(map[i][j], str)) return i === UNKNOWN ? undefined : i;
            }
            else if (has(map[i], str)) return i === UNKNOWN ? undefined : i;
        }
        return str;
    };
    var oldSafariMap = {
        "1.0": "/8",
        1.2: "/1",
        1.3: "/3",
        "2.0": "/412",
        "2.0.2": "/416",
        "2.0.3": "/417",
        "2.0.4": "/419",
        "?": "/"
    }, windowsVersionMap = {
        ME: "4.90",
        "NT 3.11": "NT3.51",
        "NT 4.0": "NT4.0",
        2e3: "NT 5.0",
        XP: [
            "NT 5.1",
            "NT 5.2"
        ],
        Vista: "NT 6.0",
        7: "NT 6.1",
        8: "NT 6.2",
        8.1: "NT 6.3",
        10: [
            "NT 6.4",
            "NT 10.0"
        ],
        RT: "ARM"
    };
    var regexes = {
        browser: [
            [
                /\b(?:crmo|crios)\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Chrome"
                ]
            ],
            [
                /edg(?:e|ios|a)?\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Edge"
                ]
            ],
            [
                /(opera mini)\/([-\w\.]+)/i,
                /(opera [mobiletab]{3,6})\b.+version\/([-\w\.]+)/i,
                /(opera)(?:.+version\/|[\/ ]+)([\w\.]+)/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                /opios[\/ ]+([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    OPERA + " Mini"
                ]
            ],
            [
                /\bopr\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    OPERA
                ]
            ],
            [
                /(kindle)\/([\w\.]+)/i,
                /(lunascape|maxthon|netfront|jasmine|blazer)[\/ ]?([\w\.]*)/i,
                /(avant |iemobile|slim)(?:browser)?[\/ ]?([\w\.]*)/i,
                /(ba?idubrowser)[\/ ]?([\w\.]+)/i,
                /(?:ms|\()(ie) ([\w\.]+)/i,
                /(flock|rockmelt|midori|epiphany|silk|skyfire|bolt|iron|vivaldi|iridium|phantomjs|bowser|quark|qupzilla|falkon|rekonq|puffin|brave|whale(?!.+naver)|qqbrowserlite|qq|duckduckgo)\/([-\w\.]+)/i,
                /(heytap|ovi)browser\/([\d\.]+)/i,
                /(weibo)__([\d\.]+)/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                /(?:\buc? ?browser|(?:juc.+)ucweb)[\/ ]?([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "UC" + BROWSER
                ]
            ],
            [
                /microm.+\bqbcore\/([\w\.]+)/i,
                /\bqbcore\/([\w\.]+).+microm/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "WeChat(Win) Desktop"
                ]
            ],
            [
                /micromessenger\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "WeChat"
                ]
            ],
            [
                /konqueror\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Konqueror"
                ]
            ],
            [
                /trident.+rv[: ]([\w\.]{1,9})\b.+like gecko/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "IE"
                ]
            ],
            [
                /ya(?:search)?browser\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Yandex"
                ]
            ],
            [
                /(avast|avg)\/([\w\.]+)/i
            ],
            [
                [
                    NAME,
                    /(.+)/,
                    "$1 Secure " + BROWSER
                ],
                VERSION
            ],
            [
                /\bfocus\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    FIREFOX + " Focus"
                ]
            ],
            [
                /\bopt\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    OPERA + " Touch"
                ]
            ],
            [
                /coc_coc\w+\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Coc Coc"
                ]
            ],
            [
                /dolfin\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Dolphin"
                ]
            ],
            [
                /coast\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    OPERA + " Coast"
                ]
            ],
            [
                /miuibrowser\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "MIUI " + BROWSER
                ]
            ],
            [
                /fxios\/([-\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    FIREFOX
                ]
            ],
            [
                /\bqihu|(qi?ho?o?|360)browser/i
            ],
            [
                [
                    NAME,
                    "360 " + BROWSER
                ]
            ],
            [
                /(oculus|samsung|sailfish|huawei)browser\/([\w\.]+)/i
            ],
            [
                [
                    NAME,
                    /(.+)/,
                    "$1 " + BROWSER
                ],
                VERSION
            ],
            [
                /(comodo_dragon)\/([\w\.]+)/i
            ],
            [
                [
                    NAME,
                    /_/g,
                    " "
                ],
                VERSION
            ],
            [
                /(electron)\/([\w\.]+) safari/i,
                /(tesla)(?: qtcarbrowser|\/(20\d\d\.[-\w\.]+))/i,
                /m?(qqbrowser|baiduboxapp|2345Explorer)[\/ ]?([\w\.]+)/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                /(metasr)[\/ ]?([\w\.]+)/i,
                /(lbbrowser)/i,
                /\[(linkedin)app\]/i
            ],
            [
                NAME
            ],
            [
                /((?:fban\/fbios|fb_iab\/fb4a)(?!.+fbav)|;fbav\/([\w\.]+);)/i
            ],
            [
                [
                    NAME,
                    FACEBOOK
                ],
                VERSION
            ],
            [
                /(kakao(?:talk|story))[\/ ]([\w\.]+)/i,
                /(naver)\(.*?(\d+\.[\w\.]+).*\)/i,
                /safari (line)\/([\w\.]+)/i,
                /\b(line)\/([\w\.]+)\/iab/i,
                /(chromium|instagram)[\/ ]([-\w\.]+)/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                /\bgsa\/([\w\.]+) .*safari\//i
            ],
            [
                VERSION,
                [
                    NAME,
                    "GSA"
                ]
            ],
            [
                /musical_ly(?:.+app_?version\/|_)([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "TikTok"
                ]
            ],
            [
                /headlesschrome(?:\/([\w\.]+)| )/i
            ],
            [
                VERSION,
                [
                    NAME,
                    CHROME + " Headless"
                ]
            ],
            [
                / wv\).+(chrome)\/([\w\.]+)/i
            ],
            [
                [
                    NAME,
                    CHROME + " WebView"
                ],
                VERSION
            ],
            [
                /droid.+ version\/([\w\.]+)\b.+(?:mobile safari|safari)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Android " + BROWSER
                ]
            ],
            [
                /(chrome|omniweb|arora|[tizenoka]{5} ?browser)\/v?([\w\.]+)/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                /version\/([\w\.\,]+) .*mobile\/\w+ (safari)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Mobile Safari"
                ]
            ],
            [
                /version\/([\w(\.|\,)]+) .*(mobile ?safari|safari)/i
            ],
            [
                VERSION,
                NAME
            ],
            [
                /webkit.+?(mobile ?safari|safari)(\/[\w\.]+)/i
            ],
            [
                NAME,
                [
                    VERSION,
                    strMapper,
                    oldSafariMap
                ]
            ],
            [
                /(webkit|khtml)\/([\w\.]+)/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                /(navigator|netscape\d?)\/([-\w\.]+)/i
            ],
            [
                [
                    NAME,
                    "Netscape"
                ],
                VERSION
            ],
            [
                /mobile vr; rv:([\w\.]+)\).+firefox/i
            ],
            [
                VERSION,
                [
                    NAME,
                    FIREFOX + " Reality"
                ]
            ],
            [
                /ekiohf.+(flow)\/([\w\.]+)/i,
                /(swiftfox)/i,
                /(icedragon|iceweasel|camino|chimera|fennec|maemo browser|minimo|conkeror|klar)[\/ ]?([\w\.\+]+)/i,
                /(seamonkey|k-meleon|icecat|iceape|firebird|phoenix|palemoon|basilisk|waterfox)\/([-\w\.]+)$/i,
                /(firefox)\/([\w\.]+)/i,
                /(mozilla)\/([\w\.]+) .+rv\:.+gecko\/\d+/i,
                /(polaris|lynx|dillo|icab|doris|amaya|w3m|netsurf|sleipnir|obigo|mosaic|(?:go|ice|up)[\. ]?browser)[-\/ ]?v?([\w\.]+)/i,
                /(links) \(([\w\.]+)/i,
                /panasonic;(viera)/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                /(cobalt)\/([\w\.]+)/i
            ],
            [
                NAME,
                [
                    VERSION,
                    /master.|lts./,
                    ""
                ]
            ]
        ],
        cpu: [
            [
                /(?:(amd|x(?:(?:86|64)[-_])?|wow|win)64)[;\)]/i
            ],
            [
                [
                    ARCHITECTURE,
                    "amd64"
                ]
            ],
            [
                /(ia32(?=;))/i
            ],
            [
                [
                    ARCHITECTURE,
                    lowerize
                ]
            ],
            [
                /((?:i[346]|x)86)[;\)]/i
            ],
            [
                [
                    ARCHITECTURE,
                    "ia32"
                ]
            ],
            [
                /\b(aarch64|arm(v?8e?l?|_?64))\b/i
            ],
            [
                [
                    ARCHITECTURE,
                    "arm64"
                ]
            ],
            [
                /\b(arm(?:v[67])?ht?n?[fl]p?)\b/i
            ],
            [
                [
                    ARCHITECTURE,
                    "armhf"
                ]
            ],
            [
                /windows (ce|mobile); ppc;/i
            ],
            [
                [
                    ARCHITECTURE,
                    "arm"
                ]
            ],
            [
                /((?:ppc|powerpc)(?:64)?)(?: mac|;|\))/i
            ],
            [
                [
                    ARCHITECTURE,
                    /ower/,
                    EMPTY,
                    lowerize
                ]
            ],
            [
                /(sun4\w)[;\)]/i
            ],
            [
                [
                    ARCHITECTURE,
                    "sparc"
                ]
            ],
            [
                /((?:avr32|ia64(?=;))|68k(?=\))|\barm(?=v(?:[1-7]|[5-7]1)l?|;|eabi)|(?=atmel )avr|(?:irix|mips|sparc)(?:64)?\b|pa-risc)/i
            ],
            [
                [
                    ARCHITECTURE,
                    lowerize
                ]
            ]
        ],
        device: [
            [
                /\b(sch-i[89]0\d|shw-m380s|sm-[ptx]\w{2,4}|gt-[pn]\d{2,4}|sgh-t8[56]9|nexus 10)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SAMSUNG
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b((?:s[cgp]h|gt|sm)-\w+|sc[g-]?[\d]+a?|galaxy nexus)/i,
                /samsung[- ]([-\w]+)/i,
                /sec-(sgh\w+)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SAMSUNG
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(?:\/|\()(ip(?:hone|od)[\w, ]*)(?:\/|;)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    APPLE
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\((ipad);[-\w\),; ]+apple/i,
                /applecoremedia\/[\w\.]+ \((ipad)/i,
                /\b(ipad)\d\d?,\d\d?[;\]].+ios/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    APPLE
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(macintosh);/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    APPLE
                ]
            ],
            [
                /\b(sh-?[altvz]?\d\d[a-ekm]?)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SHARP
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b((?:ag[rs][23]?|bah2?|sht?|btv)-a?[lw]\d{2})\b(?!.+d\/s)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    HUAWEI
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(?:huawei|honor)([-\w ]+)[;\)]/i,
                /\b(nexus 6p|\w{2,4}e?-[atu]?[ln][\dx][012359c][adn]?)\b(?!.+d\/s)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    HUAWEI
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(poco[\w ]+)(?: bui|\))/i,
                /\b; (\w+) build\/hm\1/i,
                /\b(hm[-_ ]?note?[_ ]?(?:\d\w)?) bui/i,
                /\b(redmi[\-_ ]?(?:note|k)?[\w_ ]+)(?: bui|\))/i,
                /\b(mi[-_ ]?(?:a\d|one|one[_ ]plus|note lte|max|cc)?[_ ]?(?:\d?\w?)[_ ]?(?:plus|se|lite)?)(?: bui|\))/i
            ],
            [
                [
                    MODEL,
                    /_/g,
                    " "
                ],
                [
                    VENDOR,
                    XIAOMI
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(mi[-_ ]?(?:pad)(?:[\w_ ]+))(?: bui|\))/i
            ],
            [
                [
                    MODEL,
                    /_/g,
                    " "
                ],
                [
                    VENDOR,
                    XIAOMI
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /; (\w+) bui.+ oppo/i,
                /\b(cph[12]\d{3}|p(?:af|c[al]|d\w|e[ar])[mt]\d0|x9007|a101op)\b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "OPPO"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /vivo (\w+)(?: bui|\))/i,
                /\b(v[12]\d{3}\w?[at])(?: bui|;)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Vivo"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(rmx[12]\d{3})(?: bui|;|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Realme"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(milestone|droid(?:[2-4x]| (?:bionic|x2|pro|razr))?:?( 4g)?)\b[\w ]+build\//i,
                /\bmot(?:orola)?[- ](\w*)/i,
                /((?:moto[\w\(\) ]+|xt\d{3,4}|nexus 6)(?= bui|\)))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    MOTOROLA
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(mz60\d|xoom[2 ]{0,2}) build\//i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    MOTOROLA
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /((?=lg)?[vl]k\-?\d{3}) bui| 3\.[-\w; ]{10}lg?-([06cv9]{3,4})/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    LG
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(lm(?:-?f100[nv]?|-[\w\.]+)(?= bui|\))|nexus [45])/i,
                /\blg[-e;\/ ]+((?!browser|netcast|android tv)\w+)/i,
                /\blg-?([\d\w]+) bui/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    LG
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(ideatab[-\w ]+)/i,
                /lenovo ?(s[56]000[-\w]+|tab(?:[\w ]+)|yt[-\d\w]{6}|tb[-\d\w]{6})/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Lenovo"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(?:maemo|nokia).*(n900|lumia \d+)/i,
                /nokia[-_ ]?([-\w\.]*)/i
            ],
            [
                [
                    MODEL,
                    /_/g,
                    " "
                ],
                [
                    VENDOR,
                    "Nokia"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(pixel c)\b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    GOOGLE
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /droid.+; (pixel[\daxl ]{0,6})(?: bui|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    GOOGLE
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /droid.+ (a?\d[0-2]{2}so|[c-g]\d{4}|so[-gl]\w+|xq-a\w[4-7][12])(?= bui|\).+chrome\/(?![1-6]{0,1}\d\.))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SONY
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /sony tablet [ps]/i,
                /\b(?:sony)?sgp\w+(?: bui|\))/i
            ],
            [
                [
                    MODEL,
                    "Xperia Tablet"
                ],
                [
                    VENDOR,
                    SONY
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                / (kb2005|in20[12]5|be20[12][59])\b/i,
                /(?:one)?(?:plus)? (a\d0\d\d)(?: b|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "OnePlus"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(alexa)webm/i,
                /(kf[a-z]{2}wi|aeo[c-r]{2})( bui|\))/i,
                /(kf[a-z]+)( bui|\)).+silk\//i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    AMAZON
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /((?:sd|kf)[0349hijorstuw]+)( bui|\)).+silk\//i
            ],
            [
                [
                    MODEL,
                    /(.+)/g,
                    "Fire Phone $1"
                ],
                [
                    VENDOR,
                    AMAZON
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(playbook);[-\w\),; ]+(rim)/i
            ],
            [
                MODEL,
                VENDOR,
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b((?:bb[a-f]|st[hv])100-\d)/i,
                /\(bb10; (\w+)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    BLACKBERRY
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(?:\b|asus_)(transfo[prime ]{4,10} \w+|eeepc|slider \w+|nexus 7|padfone|p00[cj])/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    ASUS
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                / (z[bes]6[027][012][km][ls]|zenfone \d\w?)\b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    ASUS
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(nexus 9)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "HTC"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(htc)[-;_ ]{1,2}([\w ]+(?=\)| bui)|\w+)/i,
                /(zte)[- ]([\w ]+?)(?: bui|\/|\))/i,
                /(alcatel|geeksphone|nexian|panasonic(?!(?:;|\.))|sony(?!-bra))[-_ ]?([-\w]*)/i
            ],
            [
                VENDOR,
                [
                    MODEL,
                    /_/g,
                    " "
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /droid.+; ([ab][1-7]-?[0178a]\d\d?)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Acer"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /droid.+; (m[1-5] note) bui/i,
                /\bmz-([-\w]{2,})/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Meizu"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(blackberry|benq|palm(?=\-)|sonyericsson|acer|asus|dell|meizu|motorola|polytron)[-_ ]?([-\w]*)/i,
                /(hp) ([\w ]+\w)/i,
                /(asus)-?(\w+)/i,
                /(microsoft); (lumia[\w ]+)/i,
                /(lenovo)[-_ ]?([-\w]+)/i,
                /(jolla)/i,
                /(oppo) ?([\w ]+) bui/i
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(kobo)\s(ereader|touch)/i,
                /(archos) (gamepad2?)/i,
                /(hp).+(touchpad(?!.+tablet)|tablet)/i,
                /(kindle)\/([\w\.]+)/i,
                /(nook)[\w ]+build\/(\w+)/i,
                /(dell) (strea[kpr\d ]*[\dko])/i,
                /(le[- ]+pan)[- ]+(\w{1,9}) bui/i,
                /(trinity)[- ]*(t\d{3}) bui/i,
                /(gigaset)[- ]+(q\w{1,9}) bui/i,
                /(vodafone) ([\w ]+)(?:\)| bui)/i
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(surface duo)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    MICROSOFT
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /droid [\d\.]+; (fp\du?)(?: b|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Fairphone"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(u304aa)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "AT&T"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\bsie-(\w*)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Siemens"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(rct\w+) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "RCA"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(venue[\d ]{2,7}) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Dell"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(q(?:mv|ta)\w+) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Verizon"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(?:barnes[& ]+noble |bn[rt])([\w\+ ]*) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Barnes & Noble"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(tm\d{3}\w+) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "NuVision"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(k88) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "ZTE"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(nx\d{3}j) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "ZTE"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(gen\d{3}) b.+49h/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Swiss"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(zur\d{3}) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Swiss"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b((zeki)?tb.*\b) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Zeki"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b([yr]\d{2}) b/i,
                /\b(dragon[- ]+touch |dt)(\w{5}) b/i
            ],
            [
                [
                    VENDOR,
                    "Dragon Touch"
                ],
                MODEL,
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(ns-?\w{0,9}) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Insignia"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b((nxa|next)-?\w{0,9}) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "NextBook"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(xtreme\_)?(v(1[045]|2[015]|[3469]0|7[05])) b/i
            ],
            [
                [
                    VENDOR,
                    "Voice"
                ],
                MODEL,
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(lvtel\-)?(v1[12]) b/i
            ],
            [
                [
                    VENDOR,
                    "LvTel"
                ],
                MODEL,
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(ph-1) /i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Essential"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(v(100md|700na|7011|917g).*\b) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Envizen"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(trio[-\w\. ]+) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "MachSpeed"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\btu_(1491) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Rotor"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(shield[\w ]+) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Nvidia"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(sprint) (\w+)/i
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(kin\.[onetw]{3})/i
            ],
            [
                [
                    MODEL,
                    /\./g,
                    " "
                ],
                [
                    VENDOR,
                    MICROSOFT
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /droid.+; (cc6666?|et5[16]|mc[239][23]x?|vc8[03]x?)\)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    ZEBRA
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /droid.+; (ec30|ps20|tc[2-8]\d[kx])\)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    ZEBRA
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /smart-tv.+(samsung)/i
            ],
            [
                VENDOR,
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /hbbtv.+maple;(\d+)/i
            ],
            [
                [
                    MODEL,
                    /^/,
                    "SmartTV"
                ],
                [
                    VENDOR,
                    SAMSUNG
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /(nux; netcast.+smarttv|lg (netcast\.tv-201\d|android tv))/i
            ],
            [
                [
                    VENDOR,
                    LG
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /(apple) ?tv/i
            ],
            [
                VENDOR,
                [
                    MODEL,
                    APPLE + " TV"
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /crkey/i
            ],
            [
                [
                    MODEL,
                    CHROME + "cast"
                ],
                [
                    VENDOR,
                    GOOGLE
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /droid.+aft(\w)( bui|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    AMAZON
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /\(dtv[\);].+(aquos)/i,
                /(aquos-tv[\w ]+)\)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SHARP
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /(bravia[\w ]+)( bui|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SONY
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /(mitv-\w{5}) bui/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    XIAOMI
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /Hbbtv.*(technisat) (.*);/i
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /\b(roku)[\dx]*[\)\/]((?:dvp-)?[\d\.]*)/i,
                /hbbtv\/\d+\.\d+\.\d+ +\([\w\+ ]*; *([\w\d][^;]*);([^;]*)/i
            ],
            [
                [
                    VENDOR,
                    trim
                ],
                [
                    MODEL,
                    trim
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /\b(android tv|smart[- ]?tv|opera tv|tv; rv:)\b/i
            ],
            [
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /(ouya)/i,
                /(nintendo) ([wids3utch]+)/i
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    CONSOLE
                ]
            ],
            [
                /droid.+; (shield) bui/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Nvidia"
                ],
                [
                    TYPE,
                    CONSOLE
                ]
            ],
            [
                /(playstation [345portablevi]+)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SONY
                ],
                [
                    TYPE,
                    CONSOLE
                ]
            ],
            [
                /\b(xbox(?: one)?(?!; xbox))[\); ]/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    MICROSOFT
                ],
                [
                    TYPE,
                    CONSOLE
                ]
            ],
            [
                /((pebble))app/i
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /(watch)(?: ?os[,\/]|\d,\d\/)[\d\.]+/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    APPLE
                ],
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /droid.+; (glass) \d/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    GOOGLE
                ],
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /droid.+; (wt63?0{2,3})\)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    ZEBRA
                ],
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /(quest( 2| pro)?)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    FACEBOOK
                ],
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /(tesla)(?: qtcarbrowser|\/[-\w\.]+)/i
            ],
            [
                VENDOR,
                [
                    TYPE,
                    EMBEDDED
                ]
            ],
            [
                /(aeobc)\b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    AMAZON
                ],
                [
                    TYPE,
                    EMBEDDED
                ]
            ],
            [
                /droid .+?; ([^;]+?)(?: bui|\) applew).+? mobile safari/i
            ],
            [
                MODEL,
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /droid .+?; ([^;]+?)(?: bui|\) applew).+?(?! mobile) safari/i
            ],
            [
                MODEL,
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b((tablet|tab)[;\/]|focus\/\d(?!.+mobile))/i
            ],
            [
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(phone|mobile(?:[;\/]| [ \w\/\.]*safari)|pda(?=.+windows ce))/i
            ],
            [
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(android[-\w\. ]{0,9});.+buil/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Generic"
                ]
            ]
        ],
        engine: [
            [
                /windows.+ edge\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    EDGE + "HTML"
                ]
            ],
            [
                /webkit\/537\.36.+chrome\/(?!27)([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Blink"
                ]
            ],
            [
                /(presto)\/([\w\.]+)/i,
                /(webkit|trident|netfront|netsurf|amaya|lynx|w3m|goanna)\/([\w\.]+)/i,
                /ekioh(flow)\/([\w\.]+)/i,
                /(khtml|tasman|links)[\/ ]\(?([\w\.]+)/i,
                /(icab)[\/ ]([23]\.[\d\.]+)/i,
                /\b(libweb)/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                /rv\:([\w\.]{1,9})\b.+(gecko)/i
            ],
            [
                VERSION,
                NAME
            ]
        ],
        os: [
            [
                /microsoft (windows) (vista|xp)/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                /(windows) nt 6\.2; (arm)/i,
                /(windows (?:phone(?: os)?|mobile))[\/ ]?([\d\.\w ]*)/i,
                /(windows)[\/ ]?([ntce\d\. ]+\w)(?!.+xbox)/i
            ],
            [
                NAME,
                [
                    VERSION,
                    strMapper,
                    windowsVersionMap
                ]
            ],
            [
                /(win(?=3|9|n)|win 9x )([nt\d\.]+)/i
            ],
            [
                [
                    NAME,
                    "Windows"
                ],
                [
                    VERSION,
                    strMapper,
                    windowsVersionMap
                ]
            ],
            [
                /ip[honead]{2,4}\b(?:.*os ([\w]+) like mac|; opera)/i,
                /ios;fbsv\/([\d\.]+)/i,
                /cfnetwork\/.+darwin/i
            ],
            [
                [
                    VERSION,
                    /_/g,
                    "."
                ],
                [
                    NAME,
                    "iOS"
                ]
            ],
            [
                /(mac os x) ?([\w\. ]*)/i,
                /(macintosh|mac_powerpc\b)(?!.+haiku)/i
            ],
            [
                [
                    NAME,
                    MAC_OS
                ],
                [
                    VERSION,
                    /_/g,
                    "."
                ]
            ],
            [
                /droid ([\w\.]+)\b.+(android[- ]x86|harmonyos)/i
            ],
            [
                VERSION,
                NAME
            ],
            [
                /(android|webos|qnx|bada|rim tablet os|maemo|meego|sailfish)[-\/ ]?([\w\.]*)/i,
                /(blackberry)\w*\/([\w\.]*)/i,
                /(tizen|kaios)[\/ ]([\w\.]+)/i,
                /\((series40);/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                /\(bb(10);/i
            ],
            [
                VERSION,
                [
                    NAME,
                    BLACKBERRY
                ]
            ],
            [
                /(?:symbian ?os|symbos|s60(?=;)|series60)[-\/ ]?([\w\.]*)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Symbian"
                ]
            ],
            [
                /mozilla\/[\d\.]+ \((?:mobile|tablet|tv|mobile; [\w ]+); rv:.+ gecko\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    FIREFOX + " OS"
                ]
            ],
            [
                /web0s;.+rt(tv)/i,
                /\b(?:hp)?wos(?:browser)?\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "webOS"
                ]
            ],
            [
                /watch(?: ?os[,\/]|\d,\d\/)([\d\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "watchOS"
                ]
            ],
            [
                /crkey\/([\d\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    CHROME + "cast"
                ]
            ],
            [
                /(cros) [\w]+(?:\)| ([\w\.]+)\b)/i
            ],
            [
                [
                    NAME,
                    CHROMIUM_OS
                ],
                VERSION
            ],
            [
                /panasonic;(viera)/i,
                /(netrange)mmh/i,
                /(nettv)\/(\d+\.[\w\.]+)/i,
                /(nintendo|playstation) ([wids345portablevuch]+)/i,
                /(xbox); +xbox ([^\);]+)/i,
                /\b(joli|palm)\b ?(?:os)?\/?([\w\.]*)/i,
                /(mint)[\/\(\) ]?(\w*)/i,
                /(mageia|vectorlinux)[; ]/i,
                /([kxln]?ubuntu|debian|suse|opensuse|gentoo|arch(?= linux)|slackware|fedora|mandriva|centos|pclinuxos|red ?hat|zenwalk|linpus|raspbian|plan 9|minix|risc os|contiki|deepin|manjaro|elementary os|sabayon|linspire)(?: gnu\/linux)?(?: enterprise)?(?:[- ]linux)?(?:-gnu)?[-\/ ]?(?!chrom|package)([-\w\.]*)/i,
                /(hurd|linux) ?([\w\.]*)/i,
                /(gnu) ?([\w\.]*)/i,
                /\b([-frentopcghs]{0,5}bsd|dragonfly)[\/ ]?(?!amd|[ix346]{1,2}86)([\w\.]*)/i,
                /(haiku) (\w+)/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                /(sunos) ?([\w\.\d]*)/i
            ],
            [
                [
                    NAME,
                    "Solaris"
                ],
                VERSION
            ],
            [
                /((?:open)?solaris)[-\/ ]?([\w\.]*)/i,
                /(aix) ((\d)(?=\.|\)| )[\w\.])*/i,
                /\b(beos|os\/2|amigaos|morphos|openvms|fuchsia|hp-ux|serenityos)/i,
                /(unix) ?([\w\.]*)/i
            ],
            [
                NAME,
                VERSION
            ]
        ]
    };
    var UAParser = function(ua, extensions) {
        if (typeof ua === OBJ_TYPE) {
            extensions = ua;
            ua = undefined;
        }
        if (!(this instanceof UAParser)) return new UAParser(ua, extensions).getResult();
        var _navigator = typeof window1 !== UNDEF_TYPE && window1.navigator ? window1.navigator : undefined;
        var _ua = ua || (_navigator && _navigator.userAgent ? _navigator.userAgent : EMPTY);
        var _uach = _navigator && _navigator.userAgentData ? _navigator.userAgentData : undefined;
        var _rgxmap = extensions ? extend(regexes, extensions) : regexes;
        var _isSelfNav = _navigator && _navigator.userAgent == _ua;
        this.getBrowser = function() {
            var _browser = {};
            _browser[NAME] = undefined;
            _browser[VERSION] = undefined;
            rgxMapper.call(_browser, _ua, _rgxmap.browser);
            _browser[MAJOR] = majorize(_browser[VERSION]);
            if (_isSelfNav && _navigator && _navigator.brave && typeof _navigator.brave.isBrave == FUNC_TYPE) _browser[NAME] = "Brave";
            return _browser;
        };
        this.getCPU = function() {
            var _cpu = {};
            _cpu[ARCHITECTURE] = undefined;
            rgxMapper.call(_cpu, _ua, _rgxmap.cpu);
            return _cpu;
        };
        this.getDevice = function() {
            var _device = {};
            _device[VENDOR] = undefined;
            _device[MODEL] = undefined;
            _device[TYPE] = undefined;
            rgxMapper.call(_device, _ua, _rgxmap.device);
            if (_isSelfNav && !_device[TYPE] && _uach && _uach.mobile) _device[TYPE] = MOBILE;
            if (_isSelfNav && _device[MODEL] == "Macintosh" && _navigator && typeof _navigator.standalone !== UNDEF_TYPE && _navigator.maxTouchPoints && _navigator.maxTouchPoints > 2) {
                _device[MODEL] = "iPad";
                _device[TYPE] = TABLET;
            }
            return _device;
        };
        this.getEngine = function() {
            var _engine = {};
            _engine[NAME] = undefined;
            _engine[VERSION] = undefined;
            rgxMapper.call(_engine, _ua, _rgxmap.engine);
            return _engine;
        };
        this.getOS = function() {
            var _os = {};
            _os[NAME] = undefined;
            _os[VERSION] = undefined;
            rgxMapper.call(_os, _ua, _rgxmap.os);
            if (_isSelfNav && !_os[NAME] && _uach && _uach.platform != "Unknown") _os[NAME] = _uach.platform.replace(/chrome os/i, CHROMIUM_OS).replace(/macos/i, MAC_OS);
            return _os;
        };
        this.getResult = function() {
            return {
                ua: this.getUA(),
                browser: this.getBrowser(),
                engine: this.getEngine(),
                os: this.getOS(),
                device: this.getDevice(),
                cpu: this.getCPU()
            };
        };
        this.getUA = function() {
            return _ua;
        };
        this.setUA = function(ua) {
            _ua = typeof ua === STR_TYPE && ua.length > UA_MAX_LENGTH ? trim(ua, UA_MAX_LENGTH) : ua;
            return this;
        };
        this.setUA(_ua);
        return this;
    };
    UAParser.VERSION = LIBVERSION;
    UAParser.BROWSER = enumerize([
        NAME,
        VERSION,
        MAJOR
    ]);
    UAParser.CPU = enumerize([
        ARCHITECTURE
    ]);
    UAParser.DEVICE = enumerize([
        MODEL,
        VENDOR,
        TYPE,
        CONSOLE,
        MOBILE,
        SMARTTV,
        TABLET,
        WEARABLE,
        EMBEDDED
    ]);
    UAParser.ENGINE = UAParser.OS = enumerize([
        NAME,
        VERSION
    ]);
    if ("object" !== UNDEF_TYPE) {
        if ("object" !== UNDEF_TYPE && module.exports) exports = module.exports = UAParser;
        exports.UAParser = UAParser;
    } else {
        if (typeof define === FUNC_TYPE && define.amd) define(function() {
            return UAParser;
        });
        else if (typeof window1 !== UNDEF_TYPE) window1.UAParser = UAParser;
    }
    var $ = typeof window1 !== UNDEF_TYPE && (window1.jQuery || window1.Zepto);
    if ($ && !$.ua) {
        var parser = new UAParser;
        $.ua = parser.getResult();
        $.ua.get = function() {
            return parser.getUA();
        };
        $.ua.set = function(ua) {
            parser.setUA(ua);
            var result = parser.getResult();
            for(var prop in result)$.ua[prop] = result[prop];
        };
    }
})(typeof window === "object" ? window : this);

});

parcelRequire.register("2fMvx", function(module, exports) {
// shim for using process in browser
var $1a429c18f8f84809$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $1a429c18f8f84809$var$cachedSetTimeout;
var $1a429c18f8f84809$var$cachedClearTimeout;
function $1a429c18f8f84809$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $1a429c18f8f84809$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $1a429c18f8f84809$var$cachedSetTimeout = setTimeout;
        else $1a429c18f8f84809$var$cachedSetTimeout = $1a429c18f8f84809$var$defaultSetTimout;
    } catch (e) {
        $1a429c18f8f84809$var$cachedSetTimeout = $1a429c18f8f84809$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $1a429c18f8f84809$var$cachedClearTimeout = clearTimeout;
        else $1a429c18f8f84809$var$cachedClearTimeout = $1a429c18f8f84809$var$defaultClearTimeout;
    } catch (e) {
        $1a429c18f8f84809$var$cachedClearTimeout = $1a429c18f8f84809$var$defaultClearTimeout;
    }
})();
function $1a429c18f8f84809$var$runTimeout(fun) {
    if ($1a429c18f8f84809$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($1a429c18f8f84809$var$cachedSetTimeout === $1a429c18f8f84809$var$defaultSetTimout || !$1a429c18f8f84809$var$cachedSetTimeout) && setTimeout) {
        $1a429c18f8f84809$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $1a429c18f8f84809$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $1a429c18f8f84809$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $1a429c18f8f84809$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $1a429c18f8f84809$var$runClearTimeout(marker) {
    if ($1a429c18f8f84809$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($1a429c18f8f84809$var$cachedClearTimeout === $1a429c18f8f84809$var$defaultClearTimeout || !$1a429c18f8f84809$var$cachedClearTimeout) && clearTimeout) {
        $1a429c18f8f84809$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $1a429c18f8f84809$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $1a429c18f8f84809$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $1a429c18f8f84809$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $1a429c18f8f84809$var$queue = [];
var $1a429c18f8f84809$var$draining = false;
var $1a429c18f8f84809$var$currentQueue;
var $1a429c18f8f84809$var$queueIndex = -1;
function $1a429c18f8f84809$var$cleanUpNextTick() {
    if (!$1a429c18f8f84809$var$draining || !$1a429c18f8f84809$var$currentQueue) return;
    $1a429c18f8f84809$var$draining = false;
    if ($1a429c18f8f84809$var$currentQueue.length) $1a429c18f8f84809$var$queue = $1a429c18f8f84809$var$currentQueue.concat($1a429c18f8f84809$var$queue);
    else $1a429c18f8f84809$var$queueIndex = -1;
    if ($1a429c18f8f84809$var$queue.length) $1a429c18f8f84809$var$drainQueue();
}
function $1a429c18f8f84809$var$drainQueue() {
    if ($1a429c18f8f84809$var$draining) return;
    var timeout = $1a429c18f8f84809$var$runTimeout($1a429c18f8f84809$var$cleanUpNextTick);
    $1a429c18f8f84809$var$draining = true;
    var len = $1a429c18f8f84809$var$queue.length;
    while(len){
        $1a429c18f8f84809$var$currentQueue = $1a429c18f8f84809$var$queue;
        $1a429c18f8f84809$var$queue = [];
        while(++$1a429c18f8f84809$var$queueIndex < len)if ($1a429c18f8f84809$var$currentQueue) $1a429c18f8f84809$var$currentQueue[$1a429c18f8f84809$var$queueIndex].run();
        $1a429c18f8f84809$var$queueIndex = -1;
        len = $1a429c18f8f84809$var$queue.length;
    }
    $1a429c18f8f84809$var$currentQueue = null;
    $1a429c18f8f84809$var$draining = false;
    $1a429c18f8f84809$var$runClearTimeout(timeout);
}
$1a429c18f8f84809$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $1a429c18f8f84809$var$queue.push(new $1a429c18f8f84809$var$Item(fun, args));
    if ($1a429c18f8f84809$var$queue.length === 1 && !$1a429c18f8f84809$var$draining) $1a429c18f8f84809$var$runTimeout($1a429c18f8f84809$var$drainQueue);
};
// v8 likes predictible objects
function $1a429c18f8f84809$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$1a429c18f8f84809$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$1a429c18f8f84809$var$process.title = "browser";
$1a429c18f8f84809$var$process.browser = true;
$1a429c18f8f84809$var$process.env = {};
$1a429c18f8f84809$var$process.argv = [];
$1a429c18f8f84809$var$process.version = ""; // empty string to avoid regexp issues
$1a429c18f8f84809$var$process.versions = {};
function $1a429c18f8f84809$var$noop() {}
$1a429c18f8f84809$var$process.on = $1a429c18f8f84809$var$noop;
$1a429c18f8f84809$var$process.addListener = $1a429c18f8f84809$var$noop;
$1a429c18f8f84809$var$process.once = $1a429c18f8f84809$var$noop;
$1a429c18f8f84809$var$process.off = $1a429c18f8f84809$var$noop;
$1a429c18f8f84809$var$process.removeListener = $1a429c18f8f84809$var$noop;
$1a429c18f8f84809$var$process.removeAllListeners = $1a429c18f8f84809$var$noop;
$1a429c18f8f84809$var$process.emit = $1a429c18f8f84809$var$noop;
$1a429c18f8f84809$var$process.prependListener = $1a429c18f8f84809$var$noop;
$1a429c18f8f84809$var$process.prependOnceListener = $1a429c18f8f84809$var$noop;
$1a429c18f8f84809$var$process.listeners = function(name) {
    return [];
};
$1a429c18f8f84809$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$1a429c18f8f84809$var$process.cwd = function() {
    return "/";
};
$1a429c18f8f84809$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$1a429c18f8f84809$var$process.umask = function() {
    return 0;
};

});

var $f2c255d67d34a8b9$exports = {};

(parcelRequire("9LHVU")).register(JSON.parse('{"5aFkV":"index.js","3GmPV":"marker-shadow.8f26ed1f.png","92ztr":"layers.760a0456.png","fHzNM":"layers-2x.b7b89169.png","ius7p":"marker-icon.3f7d3721.png","2yf0d":"index.css"}'));

var $179ad052de55b86f$exports = {};
"use strict";

$179ad052de55b86f$exports = (parcelRequire("fI7KS"));


parcelRequire("eO7Kz");
var $c244115e8f747aae$export$882461b6382ed46c;
var $c244115e8f747aae$export$757ceba2d55c277e;
"use strict";

var $kz03S = parcelRequire("kz03S");
var $c244115e8f747aae$var$i;
$c244115e8f747aae$export$882461b6382ed46c = $kz03S.createRoot;
$c244115e8f747aae$export$757ceba2d55c277e = $kz03S.hydrateRoot;


function $4e80c14196de719d$export$2e2bcd8739ae039(RetorikAgent, props, element) {
    const root = (0, $c244115e8f747aae$export$882461b6382ed46c)(element);
    root.render(/*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)(RetorikAgent, {
        ...props
    }));
}



parcelRequire("eO7Kz");

function $795ef26b02b77e41$export$2e2bcd8739ae039(RetorikWidget, props, element) {
    const root = (0, $c244115e8f747aae$export$882461b6382ed46c)(element);
    root.render(/*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)(RetorikWidget, {
        ...props
    }));
}



parcelRequire("eO7Kz");


var $eO7Kz = parcelRequire("eO7Kz");

var $kz03S = parcelRequire("kz03S");

var $f7UXb = parcelRequire("f7UXb");
var $5dd5447bf377a209$var$s = "undefined" != typeof globalThis ? globalThis : "undefined" != typeof window ? window : "undefined" != typeof $parcel$global ? $parcel$global : "undefined" != typeof self ? self : {};
function $5dd5447bf377a209$var$f(e, r) {
    return e(r = {
        exports: {}
    }, r.exports), r.exports;
}
var $5dd5447bf377a209$var$p = $5dd5447bf377a209$var$f(function(e) {
    !function(r) {
        var t = function(e, r, n) {
            if (!i(r) || s(r) || f(r) || p(r) || u(r)) return r;
            var o, a = 0, c = 0;
            if (l(r)) for(o = [], c = r.length; a < c; a++)o.push(t(e, r[a], n));
            else for(var d in o = {}, r)Object.prototype.hasOwnProperty.call(r, d) && (o[e(d, n)] = t(e, r[d], n));
            return o;
        }, n = function(e) {
            return d(e) ? e : (e = e.replace(/[\-_\s]+(.)?/g, function(e, r) {
                return r ? r.toUpperCase() : "";
            })).substr(0, 1).toLowerCase() + e.substr(1);
        }, o = function(e) {
            var r = n(e);
            return r.substr(0, 1).toUpperCase() + r.substr(1);
        }, a = function(e, r) {
            return (function(e, r) {
                var t = (r = r || {}).separator || "_", n = r.split || /(?=[A-Z])/;
                return e.split(n).join(t);
            })(e, r).toLowerCase();
        }, c = Object.prototype.toString, u = function(e) {
            return "function" == typeof e;
        }, i = function(e) {
            return e === Object(e);
        }, l = function(e) {
            return "[object Array]" == c.call(e);
        }, s = function(e) {
            return "[object Date]" == c.call(e);
        }, f = function(e) {
            return "[object RegExp]" == c.call(e);
        }, p = function(e) {
            return "[object Boolean]" == c.call(e);
        }, d = function(e) {
            return (e -= 0) == e;
        }, y = function(e, r) {
            var t = r && "process" in r ? r.process : r;
            return "function" != typeof t ? e : function(r, n) {
                return t(r, e, n);
            };
        }, h = {
            camelize: n,
            decamelize: a,
            pascalize: o,
            depascalize: a,
            camelizeKeys: function(e, r) {
                return t(y(n, r), e);
            },
            decamelizeKeys: function(e, r) {
                return t(y(a, r), e, r);
            },
            pascalizeKeys: function(e, r) {
                return t(y(o, r), e);
            },
            depascalizeKeys: function() {
                return this.decamelizeKeys.apply(this, arguments);
            }
        };
        e.exports ? e.exports = h : r.humps = h;
    }($5dd5447bf377a209$var$s);
}).decamelize, $5dd5447bf377a209$var$d = $5dd5447bf377a209$var$f(function(e) {
    function r() {
        return e.exports = r = Object.assign || function(e) {
            for(var r = 1; r < arguments.length; r++){
                var t = arguments[r];
                for(var n in t)Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
            }
            return e;
        }, r.apply(this, arguments);
    }
    e.exports = r;
});
var $5dd5447bf377a209$var$y = function(e) {
    if (Array.isArray(e)) return e;
};
var $5dd5447bf377a209$var$h = function(e, r) {
    if ("undefined" != typeof Symbol && Symbol.iterator in Object(e)) {
        var t = [], n = !0, o = !1, a = void 0;
        try {
            for(var c, u = e[Symbol.iterator](); !(n = (c = u.next()).done) && (t.push(c.value), !r || t.length !== r); n = !0);
        } catch (e) {
            o = !0, a = e;
        } finally{
            try {
                n || null == u.return || u.return();
            } finally{
                if (o) throw a;
            }
        }
        return t;
    }
};
var $5dd5447bf377a209$var$v = function(e, r) {
    (null == r || r > e.length) && (r = e.length);
    for(var t = 0, n = new Array(r); t < r; t++)n[t] = e[t];
    return n;
};
var $5dd5447bf377a209$var$m = function(e, r) {
    if (e) {
        if ("string" == typeof e) return $5dd5447bf377a209$var$v(e, r);
        var t = Object.prototype.toString.call(e).slice(8, -1);
        return "Object" === t && e.constructor && (t = e.constructor.name), "Map" === t || "Set" === t ? Array.from(e) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $5dd5447bf377a209$var$v(e, r) : void 0;
    }
};
var $5dd5447bf377a209$var$b = function() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
};
var $5dd5447bf377a209$var$g = function(e, r) {
    return $5dd5447bf377a209$var$y(e) || $5dd5447bf377a209$var$h(e, r) || $5dd5447bf377a209$var$m(e, r) || $5dd5447bf377a209$var$b();
};
var $5dd5447bf377a209$var$S = function(e, r) {
    if (null == e) return {};
    var t, n, o = {}, a = Object.keys(e);
    for(n = 0; n < a.length; n++)t = a[n], r.indexOf(t) >= 0 || (o[t] = e[t]);
    return o;
};
var $5dd5447bf377a209$var$w = function(e, r) {
    if (null == e) return {};
    var t, n, o = $5dd5447bf377a209$var$S(e, r);
    if (Object.getOwnPropertySymbols) {
        var a = Object.getOwnPropertySymbols(e);
        for(n = 0; n < a.length; n++)t = a[n], r.indexOf(t) >= 0 || Object.prototype.propertyIsEnumerable.call(e, t) && (o[t] = e[t]);
    }
    return o;
};
var $5dd5447bf377a209$var$O = (0, $eO7Kz.createContext)(null);
function $5dd5447bf377a209$var$j(e) {
    var r = e.root, t = e.children;
    return (0, $kz03S.createPortal)(t, r);
}
function $5dd5447bf377a209$var$x(n) {
    var u = (0, $eO7Kz.forwardRef)(function(o, u) {
        var i, l, s = o.mode, f = o.delegatesFocus, p = o.styleSheets, y = o.ssr, h = o.children, v = $5dd5447bf377a209$var$w(o, [
            "mode",
            "delegatesFocus",
            "styleSheets",
            "ssr",
            "children"
        ]), m = (l = (0, $eO7Kz.useRef)((i = u) && i.current), (0, $eO7Kz.useEffect)(function() {
            i && (i.current = l.current);
        }, [
            i
        ]), l), b = (0, $eO7Kz.useState)(null), S = $5dd5447bf377a209$var$g(b, 2), x = S[0], z = S[1], E = "node_".concat(s).concat(f);
        return (0, $eO7Kz.useLayoutEffect)(function() {
            if (m.current) try {
                if ("function" == typeof u && u(m.current), y) {
                    var e = m.current.shadowRoot;
                    return void z(e);
                }
                var r = m.current.attachShadow({
                    mode: s,
                    delegatesFocus: f
                });
                p.length > 0 && (r.adoptedStyleSheets = p), z(r);
            } catch (e) {
                !function(e) {
                    var r = e.error, t = e.styleSheets, n = e.root;
                    switch(r.name){
                        case "NotSupportedError":
                            t.length > 0 && (n.adoptedStyleSheets = t);
                            break;
                        default:
                            throw r;
                    }
                }({
                    error: e,
                    styleSheets: p,
                    root: x
                });
            }
        }, [
            u,
            m,
            p
        ]), (0, (/*@__PURE__*/$parcel$interopDefault($eO7Kz))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eO7Kz))).Fragment, null, (0, (/*@__PURE__*/$parcel$interopDefault($eO7Kz))).createElement(n.tag, $5dd5447bf377a209$var$d({
            key: E,
            ref: m
        }, v), (x || y) && (0, (/*@__PURE__*/$parcel$interopDefault($eO7Kz))).createElement($5dd5447bf377a209$var$O.Provider, {
            value: x
        }, y ? (0, (/*@__PURE__*/$parcel$interopDefault($eO7Kz))).createElement("template", {
            shadowroot: "open"
        }, n.render({
            root: x,
            ssr: y,
            children: h
        })) : (0, (/*@__PURE__*/$parcel$interopDefault($eO7Kz))).createElement($5dd5447bf377a209$var$j, {
            root: x
        }, n.render({
            root: x,
            ssr: y,
            children: h
        })))));
    });
    return u.propTypes = {
        mode: (0, (/*@__PURE__*/$parcel$interopDefault($f7UXb))).oneOf([
            "open",
            "closed"
        ]),
        delegatesFocus: (0, (/*@__PURE__*/$parcel$interopDefault($f7UXb))).bool,
        styleSheets: (0, (/*@__PURE__*/$parcel$interopDefault($f7UXb))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($f7UXb))).instanceOf(globalThis.CSSStyleSheet)),
        ssr: (0, (/*@__PURE__*/$parcel$interopDefault($f7UXb))).bool,
        children: (0, (/*@__PURE__*/$parcel$interopDefault($f7UXb))).node
    }, u.defaultProps = {
        mode: "open",
        delegatesFocus: !1,
        styleSheets: [],
        ssr: !1,
        children: null
    }, u;
}
$5dd5447bf377a209$var$j.propTypes = {
    root: (0, (/*@__PURE__*/$parcel$interopDefault($f7UXb))).object.isRequired,
    children: (0, (/*@__PURE__*/$parcel$interopDefault($f7UXb))).node
}, $5dd5447bf377a209$var$j.defaultProps = {
    children: null
};
var $5dd5447bf377a209$var$z = new Map;
function $5dd5447bf377a209$export$64d45095031fa749() {
    return (0, $eO7Kz.useContext)($5dd5447bf377a209$var$O);
}
function $5dd5447bf377a209$export$7865d0c7f908de6b() {
    var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}, r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "core", t = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : function(e) {
        return e.children;
    };
    return new Proxy(e, {
        get: function(e, n) {
            var o = $5dd5447bf377a209$var$p(n, {
                separator: "-"
            }), a = "".concat(r, "-").concat(o);
            return $5dd5447bf377a209$var$z.has(a) || $5dd5447bf377a209$var$z.set(a, $5dd5447bf377a209$var$x({
                tag: o,
                render: t
            })), $5dd5447bf377a209$var$z.get(a);
        }
    });
}
var $5dd5447bf377a209$var$P = $5dd5447bf377a209$export$7865d0c7f908de6b();
var $5dd5447bf377a209$export$2e2bcd8739ae039 = $5dd5447bf377a209$var$P;


parcelRequire("eO7Kz");
var $6d61f87c604fad49$exports = {};
$6d61f87c604fad49$exports = "*,:before,:after{box-sizing:border-box;border:0 solid}:before,:after{--tw-content:\"\"}html{-webkit-text-size-adjust:100%;-moz-tab-size:4;tab-size:4;font-feature-settings:normal;font-variation-settings:normal;font-family:ui-sans-serif,system-ui,-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,Noto Sans,sans-serif,Apple Color Emoji,Segoe UI Emoji,Segoe UI Symbol,Noto Color Emoji;line-height:1.5}body{line-height:inherit;margin:0}hr{color:inherit;border-top-width:1px;height:0}abbr:where([title]){text-decoration:underline dotted}h1,h2,h3,h4,h5,h6{font-size:inherit;font-weight:inherit}a{color:inherit;text-decoration:inherit}b,strong{font-weight:bolder}code,kbd,samp,pre{font-family:ui-monospace,SFMono-Regular,Menlo,Monaco,Consolas,Liberation Mono,Courier New,monospace;font-size:1em}small{font-size:80%}sub,sup{vertical-align:baseline;font-size:75%;line-height:0;position:relative}sub{bottom:-.25em}sup{top:-.5em}table{text-indent:0;border-color:inherit;border-collapse:collapse}button,input,optgroup,select,textarea{font-family:inherit;font-size:100%;font-weight:inherit;line-height:inherit;color:inherit;margin:0;padding:0}button,select{text-transform:none}button,[type=button],[type=reset],[type=submit]{-webkit-appearance:button;background-color:#0000;background-image:none}:-moz-focusring{outline:auto}:-moz-ui-invalid{box-shadow:none}progress{vertical-align:baseline}:is(){height:auto}[type=search]{-webkit-appearance:textfield;outline-offset:-2px}::-webkit-search-decoration{-webkit-appearance:none}::-webkit-file-upload-button{-webkit-appearance:button;font:inherit}summary{display:list-item}blockquote,dl,dd,h1,h2,h3,h4,h5,h6,hr,figure,p,pre{margin:0}fieldset{margin:0;padding:0}legend{padding:0}ol,ul,menu{margin:0;padding:0;list-style:none}textarea{resize:vertical}input::placeholder,textarea::placeholder{opacity:1;color:#9ca3af}button,[role=button]{cursor:pointer}:disabled{cursor:default}img,svg,video,canvas,audio,iframe,embed,object{vertical-align:middle;display:block}img,video{max-width:100%;height:auto}[hidden]{display:none}*,:before,:after,::backdrop{--tw-border-spacing-x:0;--tw-border-spacing-y:0;--tw-translate-x:0;--tw-translate-y:0;--tw-rotate:0;--tw-skew-x:0;--tw-skew-y:0;--tw-scale-x:1;--tw-scale-y:1;--tw-pan-x: ;--tw-pan-y: ;--tw-pinch-zoom: ;--tw-scroll-snap-strictness:proximity;--tw-gradient-from-position: ;--tw-gradient-via-position: ;--tw-gradient-to-position: ;--tw-ordinal: ;--tw-slashed-zero: ;--tw-numeric-figure: ;--tw-numeric-spacing: ;--tw-numeric-fraction: ;--tw-ring-inset: ;--tw-ring-offset-width:0px;--tw-ring-offset-color:#fff;--tw-ring-color:#3b82f680;--tw-ring-offset-shadow:0 0 #0000;--tw-ring-shadow:0 0 #0000;--tw-shadow:0 0 #0000;--tw-shadow-colored:0 0 #0000;--tw-blur: ;--tw-brightness: ;--tw-contrast: ;--tw-grayscale: ;--tw-hue-rotate: ;--tw-invert: ;--tw-saturate: ;--tw-sepia: ;--tw-drop-shadow: ;--tw-backdrop-blur: ;--tw-backdrop-brightness: ;--tw-backdrop-contrast: ;--tw-backdrop-grayscale: ;--tw-backdrop-hue-rotate: ;--tw-backdrop-invert: ;--tw-backdrop-opacity: ;--tw-backdrop-saturate: ;--tw-backdrop-sepia: }.rf-pointer-events-none{pointer-events:none}.rf-pointer-events-auto{pointer-events:auto}.rf-fixed{position:fixed}.rf-absolute{position:absolute}.rf-relative{position:relative}.-rf-left-6{left:-1.5rem}.-rf-top-6{top:-1.5rem}.rf--bottom-2{bottom:-.5rem}.rf-bottom-0{bottom:0}.rf-bottom-1{bottom:.25rem}.rf-bottom-16{bottom:4rem}.rf-bottom-2{bottom:.5rem}.rf-bottom-4{bottom:1rem}.rf-bottom-40{bottom:10rem}.rf-left-0{left:0}.rf-left-1{left:.25rem}.rf-left-1\\/2{left:50%}.rf-left-2{left:.5rem}.rf-left-4{left:1rem}.rf-right-0{right:0}.rf-right-1{right:.25rem}.rf-right-2{right:.5rem}.rf-right-4{right:1rem}.rf-right-6{right:1.5rem}.rf-top-0{top:0}.rf-top-1{top:.25rem}.rf-top-1\\/2{top:50%}.rf-top-1\\/3{top:33.3333%}.rf-top-110{top:110%}.rf-top-2{top:.5rem}.rf-top-4{top:1rem}.rf-top-\\[0\\.125rem\\]{top:.125rem}.rf-z-background{z-index:0}.rf-z-chatbot{z-index:10}.rf-z-detailedPOI{z-index:2}.rf-z-dropdown{z-index:30}.rf-z-exitwidget{z-index:55}.rf-z-menu{z-index:40}.rf-z-modal{z-index:50}.rf-z-overlay{z-index:40}.rf-z-ui{z-index:20}.rf-z-util{z-index:1}.rf-col-span-2{grid-column:span 2/span 2}.rf-col-span-3{grid-column:span 3/span 3}.rf-col-span-5{grid-column:span 5/span 5}.rf-col-span-6{grid-column:span 6/span 6}.rf-col-span-full{grid-column:1/-1}.rf-col-start-1{grid-column-start:1}.rf-col-start-2{grid-column-start:2}.rf-col-start-4{grid-column-start:4}.rf-col-start-5{grid-column-start:5}.rf-col-end-13{grid-column-end:13}.rf-col-end-2{grid-column-end:2}.rf-col-end-9{grid-column-end:9}.rf-row-span-1{grid-row:span 1/span 1}.rf-row-span-2{grid-row:span 2/span 2}.rf-row-span-3{grid-row:span 3/span 3}.rf-row-span-5{grid-row:span 5/span 5}.rf-row-span-6{grid-row:span 6/span 6}.rf-row-span-9{grid-row:span 9/span 9}.rf-row-span-full{grid-row:1/-1}.rf-row-start-1{grid-row-start:1}.rf-row-start-12{grid-row-start:12}.rf-row-start-2{grid-row-start:2}.rf-row-start-3{grid-row-start:3}.rf-row-start-4{grid-row-start:4}.rf-row-start-6{grid-row-start:6}.rf-row-start-9{grid-row-start:9}.rf-row-end-13{grid-row-end:13}.rf-row-end-2{grid-row-end:2}.rf-row-end-3{grid-row-end:3}.rf-row-end-4{grid-row-end:4}.rf-row-end-5{grid-row-end:5}.rf-float-right{float:right}.rf-m-0{margin:0}.rf-m-4{margin:1rem}.rf-m-auto{margin:auto}.-rf-mx-6{margin-left:-1.5rem;margin-right:-1.5rem}.rf-mx-2{margin-left:.5rem;margin-right:.5rem}.rf-mx-3{margin-left:.75rem;margin-right:.75rem}.rf-mx-8{margin-left:2rem;margin-right:2rem}.rf-mx-auto{margin-left:auto;margin-right:auto}.rf-my-1{margin-top:.25rem;margin-bottom:.25rem}.rf-my-2{margin-top:.5rem;margin-bottom:.5rem}.rf-my-4{margin-top:1rem;margin-bottom:1rem}.-rf-mb-4{margin-bottom:-1rem}.-rf-ml-2{margin-left:-.5rem}.rf-mb-0{margin-bottom:0}.rf-mb-1{margin-bottom:.25rem}.rf-mb-10{margin-bottom:2.5rem}.rf-mb-12{margin-bottom:3rem}.rf-mb-16{margin-bottom:4rem}.rf-mb-2{margin-bottom:.5rem}.rf-mb-26{margin-bottom:6.5rem}.rf-mb-28{margin-bottom:7rem}.rf-mb-3{margin-bottom:.75rem}.rf-mb-30{margin-bottom:7.5rem}.rf-mb-4{margin-bottom:1rem}.rf-mb-5{margin-bottom:1.25rem}.rf-mb-6{margin-bottom:1.5rem}.rf-mb-8{margin-bottom:2rem}.rf-ml-1{margin-left:.25rem}.rf-ml-2{margin-left:.5rem}.rf-ml-4{margin-left:1rem}.rf-ml-6{margin-left:1.5rem}.rf-mr-1{margin-right:.25rem}.rf-mr-2{margin-right:.5rem}.rf-mr-3{margin-right:.75rem}.rf-mr-4{margin-right:1rem}.rf-mr-5{margin-right:1.25rem}.rf-mt-1{margin-top:.25rem}.rf-mt-10{margin-top:2.5rem}.rf-mt-2{margin-top:.5rem}.rf-mt-4{margin-top:1rem}.rf-mt-5{margin-top:1.25rem}.rf-mt-8{margin-top:2rem}.rf-mt-auto{margin-top:auto}.rf-line-clamp-1{-webkit-line-clamp:1;-webkit-box-orient:vertical;display:-webkit-box;overflow:hidden}.rf-line-clamp-2{-webkit-line-clamp:2;-webkit-box-orient:vertical;display:-webkit-box;overflow:hidden}.rf-inline{display:inline}.rf-flex{display:flex}.rf-grid{display:grid}.rf-hidden{display:none}.rf-aspect-square{aspect-ratio:1}.rf-aspect-video{aspect-ratio:16/9}.rf-h-0{height:0}.rf-h-1{height:.25rem}.rf-h-1\\/2{height:50%}.rf-h-1\\/3{height:33.3333%}.rf-h-12{height:3rem}.rf-h-14{height:3.5rem}.rf-h-16{height:4rem}.rf-h-18{height:4.5rem}.rf-h-2{height:.5rem}.rf-h-2\\/3{height:66.6667%}.rf-h-24{height:6rem}.rf-h-3{height:.75rem}.rf-h-3\\/10{height:30%}.rf-h-32{height:8rem}.rf-h-36{height:9rem}.rf-h-4{height:1rem}.rf-h-48{height:12rem}.rf-h-5{height:1.25rem}.rf-h-6{height:1.5rem}.rf-h-7{height:1.75rem}.rf-h-8{height:2rem}.rf-h-9{height:2.25rem}.rf-h-\\[0\\.875rem\\]{height:.875rem}.rf-h-\\[calc\\(50vw-3rem\\)\\]{height:calc(50vw - 3rem)}.rf-h-fit{height:fit-content}.rf-h-full{height:100%}.rf-h-max{height:max-content}.rf-h-screen{height:100vh}.rf-max-h-12{max-height:3rem}.rf-max-h-4\\/5{max-height:80%}.rf-max-h-48{max-height:12rem}.rf-max-h-6{max-height:1.5rem}.rf-max-h-\\[40vh\\]{max-height:40vh}.rf-max-h-full{max-height:100%}.rf-max-h-screen{max-height:100vh}.rf-min-h-2\\/5{min-height:40%}.rf-min-h-6{min-height:1.5rem}.rf-min-h-full{min-height:100%}.rf-min-h-inherit{min-height:inherit}.rf-w-0{width:0}.rf-w-1\\/2{width:50%}.rf-w-1\\/3{width:33.3333%}.rf-w-1\\/4{width:25%}.rf-w-11\\/12{width:91.6667%}.rf-w-12{width:3rem}.rf-w-16{width:4rem}.rf-w-18{width:4.5rem}.rf-w-2\\/3{width:66.6667%}.rf-w-20{width:5rem}.rf-w-24{width:6rem}.rf-w-3{width:.75rem}.rf-w-3\\/5{width:60%}.rf-w-32{width:8rem}.rf-w-36{width:9rem}.rf-w-4{width:1rem}.rf-w-4\\/9{width:45%}.rf-w-48{width:12rem}.rf-w-5{width:1.25rem}.rf-w-6{width:1.5rem}.rf-w-7{width:1.75rem}.rf-w-8{width:2rem}.rf-w-9{width:2.25rem}.rf-w-\\[45\\%\\]{width:45%}.rf-w-\\[45ch\\]{width:45ch}.rf-w-\\[90\\%\\]{width:90%}.rf-w-\\[calc\\(100\\%-3rem\\)\\]{width:calc(100% - 3rem)}.rf-w-fit{width:fit-content}.rf-w-full{width:100%}.rf-w-max{width:max-content}.rf-w-screen{width:100vw}.rf-min-w-11\\/12{min-width:91.7%}.rf-min-w-12{min-width:3rem}.rf-min-w-6{min-width:1.5rem}.rf-min-w-\\[45\\%\\]{min-width:45%}.rf-max-w-6{max-width:1.5rem}.rf-max-w-7\\/10{max-width:70%}.rf-max-w-\\[100vw\\]{max-width:100vw}.rf-max-w-\\[45\\%\\]{max-width:45%}.rf-max-w-\\[600px\\]{max-width:600px}.rf-max-w-\\[70vw\\]{max-width:70vw}.rf-max-w-\\[calc\\(100\\%-2rem\\)\\]{max-width:calc(100% - 2rem)}.rf-max-w-full{max-width:100%}.rf-max-w-none{max-width:none}.rf-flex-1{flex:1}.rf-flex-\\[0_0_40\\%\\]{flex:0 0 40%}.rf-flex-\\[2_1_0\\%\\]{flex:2}.rf-flex-\\[4_1_0\\%\\]{flex:4}.rf-origin-center{transform-origin:50%}.-rf-translate-x-1\\/2{--tw-translate-x:-50%;transform:translate(var(--tw-translate-x),var(--tw-translate-y))rotate(var(--tw-rotate))skewX(var(--tw-skew-x))skewY(var(--tw-skew-y))scaleX(var(--tw-scale-x))scaleY(var(--tw-scale-y))}.-rf-translate-y-1\\/2{--tw-translate-y:-50%;transform:translate(var(--tw-translate-x),var(--tw-translate-y))rotate(var(--tw-rotate))skewX(var(--tw-skew-x))skewY(var(--tw-skew-y))scaleX(var(--tw-scale-x))scaleY(var(--tw-scale-y))}.rf--translate-x-1\\/2{--tw-translate-x:-50%;transform:translate(var(--tw-translate-x),var(--tw-translate-y))rotate(var(--tw-rotate))skewX(var(--tw-skew-x))skewY(var(--tw-skew-y))scaleX(var(--tw-scale-x))scaleY(var(--tw-scale-y))}.rf-translate-x-1{--tw-translate-x:.25rem;transform:translate(var(--tw-translate-x),var(--tw-translate-y))rotate(var(--tw-rotate))skewX(var(--tw-skew-x))skewY(var(--tw-skew-y))scaleX(var(--tw-scale-x))scaleY(var(--tw-scale-y))}.rf-translate-x-5{--tw-translate-x:1.25rem;transform:translate(var(--tw-translate-x),var(--tw-translate-y))rotate(var(--tw-rotate))skewX(var(--tw-skew-x))skewY(var(--tw-skew-y))scaleX(var(--tw-scale-x))scaleY(var(--tw-scale-y))}.rf--rotate-90{--tw-rotate:-90deg;transform:translate(var(--tw-translate-x),var(--tw-translate-y))rotate(var(--tw-rotate))skewX(var(--tw-skew-x))skewY(var(--tw-skew-y))scaleX(var(--tw-scale-x))scaleY(var(--tw-scale-y))}.rf-rotate-0{--tw-rotate:0deg;transform:translate(var(--tw-translate-x),var(--tw-translate-y))rotate(var(--tw-rotate))skewX(var(--tw-skew-x))skewY(var(--tw-skew-y))scaleX(var(--tw-scale-x))scaleY(var(--tw-scale-y))}.rf-rotate-180{--tw-rotate:180deg;transform:translate(var(--tw-translate-x),var(--tw-translate-y))rotate(var(--tw-rotate))skewX(var(--tw-skew-x))skewY(var(--tw-skew-y))scaleX(var(--tw-scale-x))scaleY(var(--tw-scale-y))}.rf-rotate-90{--tw-rotate:90deg;transform:translate(var(--tw-translate-x),var(--tw-translate-y))rotate(var(--tw-rotate))skewX(var(--tw-skew-x))skewY(var(--tw-skew-y))scaleX(var(--tw-scale-x))scaleY(var(--tw-scale-y))}.rf-scale-0{--tw-scale-x:0;--tw-scale-y:0;transform:translate(var(--tw-translate-x),var(--tw-translate-y))rotate(var(--tw-rotate))skewX(var(--tw-skew-x))skewY(var(--tw-skew-y))scaleX(var(--tw-scale-x))scaleY(var(--tw-scale-y))}.rf-transform{transform:translate(var(--tw-translate-x),var(--tw-translate-y))rotate(var(--tw-rotate))skewX(var(--tw-skew-x))skewY(var(--tw-skew-y))scaleX(var(--tw-scale-x))scaleY(var(--tw-scale-y))}@keyframes rf-hScroll{0%{transform:translate(0)}to{transform:translate(calc(-100% - 2rem))}}.rf-animate-hScroll{animation:20s linear infinite rf-hScroll}@keyframes rf-loader{0%{box-shadow:0 1.5rem 0 -1.5rem var(--rf-color-loader-animation)}40%{box-shadow:0 1.5rem 0 -.3rem var(--rf-color-loader-animation)}80%{box-shadow:0 1.5rem 0 -1.5rem var(--rf-color-loader-animation)}to{box-shadow:0 1.5rem 0 -1.5rem var(--rf-color-loader-animation)}}.rf-animate-loader{animation:1.8s ease-in-out -.16s infinite both rf-loader}@keyframes rf-slideBottom{0%{opacity:0;transform:translateY(20px)}to{opacity:1;transform:matrix(1,0,0,1,0,0)}}.rf-animate-slideBottom{animation:.5s .2s backwards rf-slideBottom}@keyframes rf-spin{to{transform:rotate(360deg)}}.rf-animate-spin{animation:1s linear infinite rf-spin}.rf-cursor-pointer{cursor:pointer}.rf-touch-none{touch-action:none}.rf-select-none{user-select:none}.rf-resize-none{resize:none}.rf-scroll-pb-8{scroll-padding-bottom:2rem}.rf-grid-cols-1{grid-template-columns:repeat(1,minmax(0,1fr))}.rf-grid-cols-2{grid-template-columns:repeat(2,minmax(0,1fr))}.rf-grid-cols-3{grid-template-columns:repeat(3,minmax(0,1fr))}.rf-grid-cols-4{grid-template-columns:repeat(4,minmax(0,1fr))}.rf-grid-cols-6{grid-template-columns:repeat(6,minmax(0,1fr))}.rf-grid-cols-7{grid-template-columns:repeat(7,minmax(0,1fr))}.rf-grid-cols-8{grid-template-columns:repeat(8,minmax(0,1fr))}.rf-grid-cols-routes{grid-template-columns:repeat(3,max-content)}.rf-grid-rows-1{grid-template-rows:repeat(1,minmax(0,1fr))}.rf-grid-rows-2{grid-template-rows:repeat(2,minmax(0,1fr))}.rf-grid-rows-container{grid-template-rows:repeat(12,minmax(0,1fr))}.rf-grid-rows-headerContainer{grid-template-rows:repeat(3,minmax(0,1fr))}.rf-flex-row{flex-direction:row}.rf-flex-col{flex-direction:column}.rf-flex-col-reverse{flex-direction:column-reverse}.rf-flex-wrap{flex-wrap:wrap}.rf-flex-nowrap{flex-wrap:nowrap}.rf-content-around{align-content:space-around}.rf-items-start{align-items:flex-start}.rf-items-end{align-items:flex-end}.rf-items-center{align-items:center}.rf-justify-start{justify-content:flex-start}.rf-justify-end{justify-content:flex-end}.rf-justify-center{justify-content:center}.rf-justify-between{justify-content:space-between}.rf-justify-around{justify-content:space-around}.rf-justify-evenly{justify-content:space-evenly}.rf-gap-1{gap:.25rem}.rf-gap-12{gap:3rem}.rf-gap-2{gap:.5rem}.rf-gap-3{gap:.75rem}.rf-gap-4{gap:1rem}.rf-gap-5{gap:1.25rem}.rf-gap-8{gap:2rem}.rf-gap-9{gap:2.25rem}.rf-divide-x>:not([hidden])~:not([hidden]){--tw-divide-x-reverse:0;border-right-width:calc(1px*var(--tw-divide-x-reverse));border-left-width:calc(1px*calc(1 - var(--tw-divide-x-reverse)))}.rf-self-auto{align-self:auto}.rf-self-start{align-self:flex-start}.rf-self-end{align-self:flex-end}.rf-self-center{align-self:center}.rf-justify-self-start{justify-self:start}.rf-justify-self-end{justify-self:end}.rf-justify-self-center{justify-self:center}.rf-overflow-hidden{overflow:hidden}.rf-overflow-clip{overflow:clip}.rf-overflow-x-auto{overflow-x:auto}.rf-overflow-y-auto{overflow-y:auto}.rf-overflow-x-hidden{overflow-x:hidden}.rf-overflow-y-hidden{overflow-y:hidden}.rf-overflow-y-visible{overflow-y:visible}.rf-overflow-x-scroll{overflow-x:scroll}.rf-overflow-y-scroll{overflow-y:scroll}.rf-truncate{text-overflow:ellipsis;white-space:nowrap;overflow:hidden}.rf-whitespace-nowrap{white-space:nowrap}.rf-rounded{border-radius:.3125rem}.rf-rounded-6{border-radius:1.5rem}.rf-rounded-8{border-radius:2rem}.rf-rounded-\\[20px\\]{border-radius:20px}.rf-rounded-full{border-radius:9999px}.rf-rounded-half{border-radius:50%}.rf-rounded-lg{border-radius:.5rem}.rf-rounded-b{border-bottom-right-radius:.3125rem;border-bottom-left-radius:.3125rem}.rf-rounded-l-lg{border-top-left-radius:.5rem;border-bottom-left-radius:.5rem}.rf-border{border-width:1px}.rf-border-0{border-width:0}.rf-border-2{border-width:2px}.rf-border-y{border-top-width:1px;border-bottom-width:1px}.rf-border-b{border-bottom-width:1px}.rf-border-b-2{border-bottom-width:2px}.rf-border-l{border-left-width:1px}.rf-border-r{border-right-width:1px}.rf-border-t{border-top-width:1px}.rf-border-t-0{border-top-width:0}.rf-border-none{border-style:none}.rf-border-\\[\\#00000029\\]{border-color:#00000029}.rf-border-\\[\\#9FA2AA\\]{--tw-border-opacity:1;border-color:rgb(159 162 170/var(--tw-border-opacity))}.rf-border-\\[\\#C7C6C6\\]{--tw-border-opacity:1;border-color:rgb(199 198 198/var(--tw-border-opacity))}.rf-border-black{border-color:var(--rf-color-black)}.rf-border-cardButtonBorderDefault{border-color:var(--rf-color-cardButtonBorderDefault)}.rf-border-cardFrameBorder{border-color:var(--rf-color-cardFrameBorder)}.rf-border-formInputButtonBorderDefault{border-color:var(--rf-color-formInputButtonBorderDefault)}.rf-border-formInputButtonBorderHover{border-color:var(--rf-color-formInputButtonBorderHover)}.rf-border-formInputRadioCheckboxCheckedBorder{border-color:var(--rf-color-formInputRadioCheckboxCheckedBorder)}.rf-border-formInputRadioCheckboxUncheckedBorder{border-color:var(--rf-color-formInputRadioCheckboxUncheckedBorder)}.rf-border-gray{--tw-border-opacity:1;border-color:rgb(128 128 128/var(--tw-border-opacity))}.rf-border-menuBorder{--tw-border-opacity:1;border-color:rgb(224 225 231/var(--tw-border-opacity))}.rf-border-primary{border-color:var(--rf-color-primary)}.rf-border-red-700{--tw-border-opacity:1;border-color:rgb(185 28 28/var(--tw-border-opacity))}.rf-border-secondary{border-color:var(--rf-color-secondary)}.rf-border-templateCheckboxBorder{--tw-border-opacity:1;border-color:rgb(112 112 112/var(--tw-border-opacity))}.rf-border-trueblack{--tw-border-opacity:1;border-color:rgb(0 0 0/var(--tw-border-opacity))}.rf-border-truewhite{--tw-border-opacity:1;border-color:rgb(255 255 255/var(--tw-border-opacity))}.rf-border-x-primary{border-left-color:var(--rf-color-primary);border-right-color:var(--rf-color-primary)}.rf-border-x-silver{--tw-border-opacity:1;border-left-color:rgb(192 192 192/var(--tw-border-opacity));border-right-color:rgb(192 192 192/var(--tw-border-opacity))}.rf-border-x-transparent{border-left-color:#0000;border-right-color:#0000}.rf-border-x-truewhite{--tw-border-opacity:1;border-left-color:rgb(255 255 255/var(--tw-border-opacity));border-right-color:rgb(255 255 255/var(--tw-border-opacity))}.rf-border-y-menuBorder{--tw-border-opacity:1;border-top-color:rgb(224 225 231/var(--tw-border-opacity));border-bottom-color:rgb(224 225 231/var(--tw-border-opacity))}.rf-border-y-transparent{border-top-color:#0000;border-bottom-color:#0000}.rf-border-b-\\[\\#C4C5C8\\]{--tw-border-opacity:1;border-bottom-color:rgb(196 197 200/var(--tw-border-opacity))}.rf-border-b-black{border-bottom-color:var(--rf-color-black)}.rf-border-b-menuBorder{--tw-border-opacity:1;border-bottom-color:rgb(224 225 231/var(--tw-border-opacity))}.rf-border-b-silver{--tw-border-opacity:1;border-bottom-color:rgb(192 192 192/var(--tw-border-opacity))}.rf-border-b-transparent{border-bottom-color:#0000}.rf-border-l-menuBorder{--tw-border-opacity:1;border-left-color:rgb(224 225 231/var(--tw-border-opacity))}.rf-border-r-silver{--tw-border-opacity:1;border-right-color:rgb(192 192 192/var(--tw-border-opacity))}.rf-border-t-\\[\\#CBC9C9\\]{--tw-border-opacity:1;border-top-color:rgb(203 201 201/var(--tw-border-opacity))}.rf-border-t-menuBorder{--tw-border-opacity:1;border-top-color:rgb(224 225 231/var(--tw-border-opacity))}.rf-bg-\\[\\#00000050\\]{background-color:#00000050}.rf-bg-\\[\\#F0F0F0\\]{--tw-bg-opacity:1;background-color:rgb(240 240 240/var(--tw-bg-opacity))}.rf-bg-\\[\\#F8F8F8\\]{--tw-bg-opacity:1;background-color:rgb(248 248 248/var(--tw-bg-opacity))}.rf-bg-black{background-color:var(--rf-color-black)}.rf-bg-blue-500{--tw-bg-opacity:1;background-color:rgb(59 130 246/var(--tw-bg-opacity))}.rf-bg-cardButtonBackgroundDefault{background-color:var(--rf-color-cardButtonBackgroundDefault)}.rf-bg-cardButtonBackgroundHover{background-color:var(--rf-color-cardButtonBackgroundHover)}.rf-bg-cardFrameBackground{background-color:var(--rf-color-cardFrameBackground)}.rf-bg-formInputButtonBackgroundDefault{background-color:var(--rf-color-formInputButtonBackgroundDefault)}.rf-bg-formInputButtonBackgroundHover{background-color:var(--rf-color-formInputButtonBackgroundHover)}.rf-bg-formInputRadioCheckboxUncheckedBackground{background-color:var(--rf-color-formInputRadioCheckboxUncheckedBackground)}.rf-bg-gray{--tw-bg-opacity:1;background-color:rgb(128 128 128/var(--tw-bg-opacity))}.rf-bg-primary{background-color:var(--rf-color-primary)}.rf-bg-red-600{--tw-bg-opacity:1;background-color:rgb(220 38 38/var(--tw-bg-opacity))}.rf-bg-secondary{background-color:var(--rf-color-secondary)}.rf-bg-silver{--tw-bg-opacity:1;background-color:rgb(192 192 192/var(--tw-bg-opacity))}.rf-bg-templateBackground{--tw-bg-opacity:1;background-color:rgb(241 241 241/var(--tw-bg-opacity))}.rf-bg-templateEmptyCard{--tw-bg-opacity:1;background-color:rgb(232 231 231/var(--tw-bg-opacity))}.rf-bg-textModePanelBackground{background-color:var(--rf-color-textModePanelBackground)}.rf-bg-transparent{background-color:#0000}.rf-bg-truewhite{--tw-bg-opacity:1;background-color:rgb(255 255 255/var(--tw-bg-opacity))}.rf-bg-vocalModeSubtitlesBackground{background-color:var(--rf-color-vocalModeSubtitlesBackground)}.rf-bg-white{--tw-bg-opacity:1;background-color:rgb(247 243 246/var(--tw-bg-opacity))}.rf-bg-opacity-30{--tw-bg-opacity:.3}.rf-bg-opacity-50{--tw-bg-opacity:.5}.rf-bg-opacity-80{--tw-bg-opacity:.8}.rf-bg-gradient-to-r{background-image:linear-gradient(to right,var(--tw-gradient-stops))}.rf-from-red-900{--tw-gradient-from:#7f1d1d var(--tw-gradient-from-position);--tw-gradient-to:#7f1d1d00 var(--tw-gradient-to-position);--tw-gradient-stops:var(--tw-gradient-from),var(--tw-gradient-to)}.rf-to-red-500{--tw-gradient-to:#ef4444 var(--tw-gradient-to-position)}.rf-object-cover{object-fit:cover}.rf-p-0{padding:0}.rf-p-1{padding:.25rem}.rf-p-2{padding:.5rem}.rf-p-4{padding:1rem}.rf-p-6{padding:1.5rem}.rf-p-\\[25px\\]{padding:25px}.rf-p-\\[7px_12px\\]{padding:7px 12px}.rf-px-1{padding-left:.25rem;padding-right:.25rem}.rf-px-2{padding-left:.5rem;padding-right:.5rem}.rf-px-3{padding-left:.75rem;padding-right:.75rem}.rf-px-4{padding-left:1rem;padding-right:1rem}.rf-px-5,.rf-px-6{padding-left:1.5rem;padding-right:1.5rem}.rf-px-8{padding-left:2rem;padding-right:2rem}.rf-py-0{padding-top:0;padding-bottom:0}.rf-py-1{padding-top:.25rem;padding-bottom:.25rem}.rf-py-12{padding-top:3rem;padding-bottom:3rem}.rf-py-2{padding-top:.5rem;padding-bottom:.5rem}.rf-py-3{padding-top:.75rem;padding-bottom:.75rem}.rf-py-4{padding-top:1rem;padding-bottom:1rem}.rf-py-6{padding-top:1.5rem;padding-bottom:1.5rem}.rf-py-\\[0\\.1rem\\]{padding-top:.1rem;padding-bottom:.1rem}.rf-pb-12{padding-bottom:3rem}.rf-pb-14{padding-bottom:3.5rem}.rf-pb-2{padding-bottom:.5rem}.rf-pb-3{padding-bottom:.75rem}.rf-pb-4{padding-bottom:1rem}.rf-pb-5,.rf-pb-6{padding-bottom:1.5rem}.rf-pb-8{padding-bottom:2rem}.rf-pb-\\[15vh\\]{padding-bottom:15vh}.rf-pl-0{padding-left:0}.rf-pl-1{padding-left:.25rem}.rf-pl-2{padding-left:.5rem}.rf-pl-4{padding-left:1rem}.rf-pr-1{padding-right:.25rem}.rf-pr-2{padding-right:.5rem}.rf-pr-4{padding-right:1rem}.rf-pr-8{padding-right:2rem}.rf-pt-1{padding-top:.25rem}.rf-pt-11\\/20{padding-top:55%}.rf-pt-12{padding-top:3rem}.rf-pt-14{padding-top:3.5rem}.rf-pt-2{padding-top:.5rem}.rf-pt-24{padding-top:6rem}.rf-pt-3{padding-top:.75rem}.rf-pt-4{padding-top:1rem}.rf-pt-8{padding-top:2rem}.rf-pt-\\[25vh\\]{padding-top:25vh}.rf-pt-\\[26vh\\]{padding-top:26vh}.rf-text-left{text-align:left}.rf-text-center{text-align:center}.rf-text-right{text-align:right}.rf-font-default{font-family:Helvetica Neue,sans-serif}.rf-text-3xl{font-size:1.875rem;line-height:2.25rem}.rf-text-5xl{font-size:3rem;line-height:1}.rf-text-7xl{font-size:4.5rem;line-height:1}.rf-text-8xl{font-size:6rem;line-height:1}.rf-text-\\[0\\.5rem\\]{font-size:.5rem}.rf-text-base{font-size:1rem;line-height:1.5rem}.rf-text-basecustom{font-size:1rem;line-height:1.3rem}.rf-text-lgcustom{font-size:1.125rem;line-height:1.5rem}.rf-text-sm{font-size:.875rem;line-height:1.25rem}.rf-text-xl{font-size:1.25rem;line-height:1.75rem}.rf-text-xs{font-size:.75rem;line-height:1rem}.rf-text-xsl{font-size:.7rem}.rf-text-xsm{font-size:.6rem}.rf-font-bold{font-weight:600}.rf-font-medium{font-weight:300}.rf-font-semibold{font-weight:400}.rf-uppercase{text-transform:uppercase}.rf-capitalize{text-transform:capitalize}.rf-normal-case{text-transform:none}.rf-italic{font-style:italic}.rf-text-\\[\\#575F6B\\]{--tw-text-opacity:1;color:rgb(87 95 107/var(--tw-text-opacity))}.rf-text-\\[\\#9A9A9A\\]{--tw-text-opacity:1;color:rgb(154 154 154/var(--tw-text-opacity))}.rf-text-black{color:var(--rf-color-black)}.rf-text-cardButtonTextDefault{color:var(--rf-color-cardButtonTextDefault)}.rf-text-cardFrameText{color:var(--rf-color-cardFrameText)}.rf-text-formInputButtonTextDefault{color:var(--rf-color-formInputButtonTextDefault)}.rf-text-formInputButtonTextHover{color:var(--rf-color-formInputButtonTextHover)}.rf-text-formInputRadioCheckboxUncheckedBackground{color:var(--rf-color-formInputRadioCheckboxUncheckedBackground)}.rf-text-formInputTextDefault{color:var(--rf-color-formInputTextDefault)}.rf-text-gray{--tw-text-opacity:1;color:rgb(128 128 128/var(--tw-text-opacity))}.rf-text-lightgray{--tw-text-opacity:1;color:rgb(129 129 129/var(--tw-text-opacity))}.rf-text-primary{color:var(--rf-color-primary)}.rf-text-red-700{--tw-text-opacity:1;color:rgb(185 28 28/var(--tw-text-opacity))}.rf-text-secondary{color:var(--rf-color-secondary)}.rf-text-textModePanelConversationBot{color:var(--rf-color-textModePanelConversationBot)}.rf-text-textModePanelConversationUser{color:var(--rf-color-textModePanelConversationUser)}.rf-text-trueblack{--tw-text-opacity:1;color:rgb(0 0 0/var(--tw-text-opacity))}.rf-text-truewhite{--tw-text-opacity:1;color:rgb(255 255 255/var(--tw-text-opacity))}.rf-text-vocalModeSubtitlesText{color:var(--rf-color-vocalModeSubtitlesText)}.rf-text-white{--tw-text-opacity:1;color:rgb(247 243 246/var(--tw-text-opacity))}.rf-underline{text-decoration-line:underline}.rf-shadow-\\[0_-5px_10px_silver\\,-5px_0_10px_silver\\,5px_0_10px_silver\\]{--tw-shadow:0 -5px 10px silver,-5px 0 10px silver,5px 0 10px silver;--tw-shadow-colored:0 -5px 10px var(--tw-shadow-color),-5px 0 10px var(--tw-shadow-color),5px 0 10px var(--tw-shadow-color);box-shadow:var(--tw-ring-offset-shadow,0 0 #0000),var(--tw-ring-shadow,0 0 #0000),var(--tw-shadow)}.rf-shadow-\\[0_0_15px_0_silver\\]{--tw-shadow:0 0 15px 0 silver;--tw-shadow-colored:0 0 15px 0 var(--tw-shadow-color);box-shadow:var(--tw-ring-offset-shadow,0 0 #0000),var(--tw-ring-shadow,0 0 #0000),var(--tw-shadow)}.rf-shadow-\\[0_0_20px_1px_\\#A4A7AF80\\]{--tw-shadow:0 0 20px 1px #a4a7af80;--tw-shadow-colored:0 0 20px 1px var(--tw-shadow-color);box-shadow:var(--tw-ring-offset-shadow,0 0 #0000),var(--tw-ring-shadow,0 0 #0000),var(--tw-shadow)}.rf-shadow-\\[0_0_3px_6px_\\#00000029\\]{--tw-shadow:0 0 3px 6px #00000029;--tw-shadow-colored:0 0 3px 6px var(--tw-shadow-color);box-shadow:var(--tw-ring-offset-shadow,0 0 #0000),var(--tw-ring-shadow,0 0 #0000),var(--tw-shadow)}.rf-shadow-\\[0_3px_6px_\\#00000029\\]{--tw-shadow:0 3px 6px #00000029;--tw-shadow-colored:0 3px 6px var(--tw-shadow-color);box-shadow:var(--tw-ring-offset-shadow,0 0 #0000),var(--tw-ring-shadow,0 0 #0000),var(--tw-shadow)}.rf-shadow-\\[0_3px_6px_\\#606267\\]{--tw-shadow:0 3px 6px #606267;--tw-shadow-colored:0 3px 6px var(--tw-shadow-color);box-shadow:var(--tw-ring-offset-shadow,0 0 #0000),var(--tw-ring-shadow,0 0 #0000),var(--tw-shadow)}.rf-shadow-\\[0_3px_6px_rgba\\(0\\,0\\,0\\,0\\.16\\)\\]{--tw-shadow:0 3px 6px #00000029;--tw-shadow-colored:0 3px 6px var(--tw-shadow-color);box-shadow:var(--tw-ring-offset-shadow,0 0 #0000),var(--tw-ring-shadow,0 0 #0000),var(--tw-shadow)}.rf-shadow-\\[20px_3px_20px_\\#00000029\\]{--tw-shadow:20px 3px 20px #00000029;--tw-shadow-colored:20px 3px 20px var(--tw-shadow-color);box-shadow:var(--tw-ring-offset-shadow,0 0 #0000),var(--tw-ring-shadow,0 0 #0000),var(--tw-shadow)}.rf-shadow-\\[3px_3px_16px_\\#00000029\\]{--tw-shadow:3px 3px 16px #00000029;--tw-shadow-colored:3px 3px 16px var(--tw-shadow-color);box-shadow:var(--tw-ring-offset-shadow,0 0 #0000),var(--tw-ring-shadow,0 0 #0000),var(--tw-shadow)}.rf-shadow-\\[3px_3px_6px_\\#00000029\\]{--tw-shadow:3px 3px 6px #00000029;--tw-shadow-colored:3px 3px 6px var(--tw-shadow-color);box-shadow:var(--tw-ring-offset-shadow,0 0 #0000),var(--tw-ring-shadow,0 0 #0000),var(--tw-shadow)}.rf-shadow-\\[inset_0_0_6px_\\#0000003B\\]{--tw-shadow:inset 0 0 6px #0000003b;--tw-shadow-colored:inset 0 0 6px var(--tw-shadow-color);box-shadow:var(--tw-ring-offset-shadow,0 0 #0000),var(--tw-ring-shadow,0 0 #0000),var(--tw-shadow)}.rf-shadow-\\[inset_0_12px_12px_-12px_\\#00000029\\,inset_0_-12px_12px_-12px_\\#00000029\\]{--tw-shadow:inset 0 12px 12px -12px #00000029,inset 0 -12px 12px -12px #00000029;--tw-shadow-colored:inset 0 12px 12px -12px var(--tw-shadow-color),inset 0 -12px 12px -12px var(--tw-shadow-color);box-shadow:var(--tw-ring-offset-shadow,0 0 #0000),var(--tw-ring-shadow,0 0 #0000),var(--tw-shadow)}.rf-shadow-card{--tw-shadow:0px 0px 13px 3px #101219;--tw-shadow-colored:0px 0px 13px 3px var(--tw-shadow-color);box-shadow:var(--tw-ring-offset-shadow,0 0 #0000),var(--tw-ring-shadow,0 0 #0000),var(--tw-shadow)}.rf-outline-none{outline-offset:2px;outline:2px solid #0000}.rf-blur-background{--tw-blur:blur(var(--rf-blur-background));filter:var(--tw-blur)var(--tw-brightness)var(--tw-contrast)var(--tw-grayscale)var(--tw-hue-rotate)var(--tw-invert)var(--tw-saturate)var(--tw-sepia)var(--tw-drop-shadow)}.rf-filter{filter:var(--tw-blur)var(--tw-brightness)var(--tw-contrast)var(--tw-grayscale)var(--tw-hue-rotate)var(--tw-invert)var(--tw-saturate)var(--tw-sepia)var(--tw-drop-shadow)}.rf-transition-all{transition-property:all;transition-duration:.15s;transition-timing-function:cubic-bezier(.4,0,.2,1)}.rf-transition-transform{transition-property:transform;transition-duration:.15s;transition-timing-function:cubic-bezier(.4,0,.2,1)}.rf-text-shadow-black{text-shadow:2px 0 5px #000,-2px 0 5px #000,0 2px 5px #000,0 -2px 5px #000}.rf-capitalize-first:first-letter{text-transform:uppercase}ol{padding-left:2rem;list-style-type:decimal}ul{padding-left:2rem;list-style-type:disc}.rf-glass-background,#retorik-container.portrait .portrait\\:rf-glass-background{background-color:var(--rf-color-black);--tw-bg-opacity:.62;--tw-backdrop-blur:blur(8px);backdrop-filter:var(--tw-backdrop-blur)var(--tw-backdrop-brightness)var(--tw-backdrop-contrast)var(--tw-backdrop-grayscale)var(--tw-backdrop-hue-rotate)var(--tw-backdrop-invert)var(--tw-backdrop-opacity)var(--tw-backdrop-saturate)var(--tw-backdrop-sepia)}.rf-loader:before{content:\"\";border-radius:50%;width:1.5rem;height:1.5rem;animation:1.8s ease-in-out -.32s infinite both rf-loader;display:block;position:absolute;right:1.5rem}.rf-loader:after{content:\"\";border-radius:50%;width:1.5rem;height:1.5rem;animation:1.8s ease-in-out infinite both rf-loader;display:block;position:absolute;left:1.5rem}.rf-touch-action-none{touch-action:none}.rf-unselectable{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;-webkit-touch-callout:none}.rf-title-extralarge-bold-size-auto{font-size:2.25rem;font-weight:600;line-height:2.5rem}#retorik-container.rf-large .rf-title-extralarge-bold-size-auto{font-size:3rem;line-height:1}#retorik-container.rf-large.rf-portrait .rf-title-extralarge-bold-size-auto{font-size:3.75rem;line-height:1}.rf-title-extralarge-size-auto{font-size:2.25rem;font-weight:400;line-height:2.5rem}#retorik-container.rf-large .rf-title-extralarge-size-auto{font-size:3rem;line-height:1}#retorik-container.rf-large.rf-portrait .rf-title-extralarge-size-auto{font-size:3.75rem;line-height:1}.rf-title-large-size-auto{font-size:1.5rem;font-weight:400;line-height:2rem}#retorik-container.rf-large .rf-title-large-size-auto{font-size:2.25rem;line-height:2.5rem}#retorik-container.rf-large.rf-portrait .rf-title-large-size-auto{font-size:3rem;line-height:1}.rf-title-large-bold-size-auto{font-size:1.875rem;font-weight:600;line-height:2.25rem}#retorik-container.rf-large .rf-title-large-bold-size-auto{font-size:2.25rem;line-height:2.5rem}#retorik-container.rf-large.rf-portrait .rf-title-large-bold-size-auto{font-size:3rem;line-height:1}.rf-title-size-auto{font-size:1.5rem;font-weight:400;line-height:2rem}#retorik-container.rf-large .rf-title-size-auto{font-size:1.875rem;line-height:2.25rem}#retorik-container.rf-large.rf-portrait .rf-title-size-auto{font-size:2.25rem;line-height:2.5rem}.rf-title-bold-size-auto{font-size:1.5rem;font-weight:600;line-height:2rem}#retorik-container.rf-large .rf-title-bold-size-auto{font-size:1.875rem;line-height:2.25rem}#retorik-container.rf-large.rf-portrait .rf-title-bold-size-auto{font-size:2.25rem;line-height:2.5rem}.rf-subtitle-size-auto{font-size:1.125rem;line-height:1.5rem}#retorik-container.rf-large .rf-subtitle-size-auto{font-size:1.25rem;line-height:1.75rem}#retorik-container.rf-large.rf-portrait .rf-subtitle-size-auto{font-size:1.5rem;line-height:2rem}.rf-text-extralarge-size-auto{font-size:2.25rem;line-height:2.5rem}#retorik-container.rf-large .rf-text-extralarge-size-auto{font-size:3rem;line-height:1}#retorik-container.rf-large.rf-portrait .rf-text-extralarge-size-auto{font-size:3.75rem;line-height:1}.rf-text-verylarge-size-auto{font-size:1.5rem;line-height:2rem}#retorik-container.rf-large .rf-text-verylarge-size-auto{font-size:3.75rem;line-height:1}#retorik-container.rf-large.rf-portrait .rf-text-verylarge-size-auto{font-size:4.5rem;line-height:1}.rf-text-large-size-auto{font-size:1.5rem;line-height:2rem}#retorik-container.rf-large .rf-text-large-size-auto{font-size:1.875rem;line-height:2.25rem}#retorik-container.rf-large.rf-portrait .rf-text-large-size-auto{font-size:2.25rem;line-height:2.5rem}.rf-text-medium-size-auto{font-size:1rem;line-height:1.3rem}#retorik-container.rf-large .rf-text-medium-size-auto{font-size:1.125rem;line-height:1.5rem}.rf-text-size-auto{font-size:.875rem;line-height:1.25rem}#retorik-container.rf-large .rf-text-size-auto{font-size:1rem;line-height:1.3rem}#retorik-container.rf-large.rf-portrait .rf-text-size-auto{font-size:1.125rem;line-height:1.5rem}.rf-small-size-auto{font-size:.6rem}#retorik-container.rf-large .rf-small-size-auto{font-size:.75rem;line-height:1rem}#retorik-container.rf-large.rf-portrait .rf-small-size-auto{font-size:.875rem;line-height:1.25rem}.rf-line-clamp-unknown{hyphens:auto;-webkit-box-orient:vertical;display:-webkit-box;overflow:hidden}.rf-line-clamp-1{hyphens:auto;-webkit-line-clamp:1;-webkit-box-orient:vertical;display:-webkit-box;overflow:hidden}.rf-line-clamp-2{hyphens:auto;-webkit-line-clamp:2;-webkit-box-orient:vertical;display:-webkit-box;overflow:hidden}.rf-line-clamp-3{hyphens:auto;-webkit-line-clamp:3;-webkit-box-orient:vertical;display:-webkit-box;overflow:hidden}.rf-line-clamp-4{hyphens:auto;-webkit-line-clamp:4;-webkit-box-orient:vertical;display:-webkit-box;overflow:hidden}.rf-line-clamp-5{hyphens:auto;-webkit-line-clamp:5;-webkit-box-orient:vertical;display:-webkit-box;overflow:hidden}.rf-line-clamp-6{hyphens:auto;-webkit-line-clamp:6;-webkit-box-orient:vertical;display:-webkit-box;overflow:hidden}.rf-line-clamp-7{hyphens:auto;-webkit-line-clamp:7;-webkit-box-orient:vertical;display:-webkit-box;overflow:hidden}.rf-line-clamp-8{hyphens:auto;-webkit-line-clamp:8;-webkit-box-orient:vertical;display:-webkit-box;overflow:hidden}.rf-line-clamp-9{hyphens:auto;-webkit-line-clamp:9;-webkit-box-orient:vertical;display:-webkit-box;overflow:hidden}.rf-line-clamp-10{hyphens:auto;-webkit-line-clamp:10;-webkit-box-orient:vertical;display:-webkit-box;overflow:hidden}.rf-height-fill-available{height:stretch}.rf-width-fill-available{width:stretch}.rf-animation-delay-2{animation-delay:.2s}.rf-animation-delay-4{animation-delay:.4s}.rf-scrollbar-thin{scrollbar-width:thin;scrollbar-color:var(--rf-color-secondary)transparent}.rf-scrollbar-thin::-webkit-scrollbar{width:.2rem;height:.2rem;margin:.25rem 0}.rf-scrollbar-thin::-webkit-scrollbar-thumb{background-color:var(--rf-color-secondary);border-radius:.5rem}.rf-scrollbar-x-custom::-webkit-scrollbar{background-color:var(--rf-color-formInputRadioCheckboxUncheckedBackground);border-radius:2rem;height:.5rem}.rf-scrollbar-x-custom::-webkit-scrollbar-thumb{background-color:var(--rf-color-primary);border-radius:2rem}.rf-scrollbar-hidden{scrollbar-width:none}.rf-scrollbar-hidden::-webkit-scrollbar{display:none}.rf-opacity-gradient-b{-webkit-mask-image:linear-gradient(#000 50%,#0000 100%)}.rf-opacity-gradient-b-thin{-webkit-mask-image:linear-gradient(#797676 84%,#0000 100%)}.rf-opacity-gradient-l{-webkit-mask-image:linear-gradient(270deg,#000 75%,gray 80%,#0000 85%)}.rf-opacity-gradient-l-thin{-webkit-mask-image:linear-gradient(270deg,#000 90%,gray 95%,#0000 100%)}.rf-opacity-gradient-h{-webkit-mask-image:linear-gradient(90deg,#0000 0%,6%,#000,94%,#0000 100%)}.rf-card-button{border-width:1px;border-color:var(--rf-color-cardButtonBorderDefault);background-color:var(--rf-color-cardButtonBackgroundDefault);color:var(--rf-color-cardButtonTextDefault);border-radius:.3125rem;padding:.25rem .5rem;font-size:.875rem;line-height:1.25rem}#retorik-container.rf-large .rf-card-button{font-size:1rem;line-height:1.3rem}#retorik-container.rf-large.rf-portrait .rf-card-button{font-size:1.125rem;line-height:1.5rem}#retorik-container.rf-large .rf-card-button{padding:.5rem 1rem}.rf-card-button:hover{cursor:pointer;border-color:var(--rf-color-cardButtonBorderHover);background-color:var(--rf-color-cardButtonBackgroundHover);color:var(--rf-color-cardButtonTextHover)}.rf-card-button-secondary{border-width:1px;border-color:var(--rf-color-secondary);color:var(--rf-color-secondary);background-color:#0000;border-radius:.3125rem;padding:.25rem .5rem;font-size:.875rem;line-height:1.25rem}#retorik-container.rf-large .rf-card-button-secondary{font-size:1rem;line-height:1.3rem}#retorik-container.rf-large.rf-portrait .rf-card-button-secondary{font-size:1.125rem;line-height:1.5rem}#retorik-container.rf-large .rf-card-button-secondary{padding:.5rem 1rem}.rf-card-button-secondary:hover{cursor:pointer;border-color:var(--rf-color-secondary);background-color:var(--rf-color-secondary);--tw-text-opacity:1;color:rgb(255 255 255/var(--tw-text-opacity))}.rf-card-button-discover{border-width:1px;border-color:var(--rf-color-cardButtonDiscoverBorderDefault);background-color:var(--rf-color-cardButtonDiscoverBackgroundDefault);color:var(--rf-color-cardButtonDiscoverTextDefault);border-radius:.3125rem;padding:.5rem;font-size:.875rem;line-height:1.25rem}#retorik-container.rf-large .rf-card-button-discover{padding:1rem .5rem}.rf-card-button-discover:hover{cursor:pointer;border-color:var(--rf-color-cardButtonDiscoverBorderHover);background-color:var(--rf-color-cardButtonDiscoverBackgroundHover);color:var(--rf-color-cardButtonDiscoverTextHover)}.rf-card-button-history{cursor:default;border-width:1px;border-color:var(--rf-color-cardButtonBorderDefault);background-color:var(--rf-color-cardButtonBackgroundDefault);color:var(--rf-color-cardButtonTextDefault);border-radius:.3125rem;padding:.25rem .5rem;font-size:.875rem;line-height:1.25rem}#retorik-container.rf-large .rf-card-button-history{font-size:1rem;line-height:1.3rem}#retorik-container.rf-large.rf-portrait .rf-card-button-history{font-size:1.125rem;line-height:1.5rem}#retorik-container.rf-large .rf-card-button-history{padding:.5rem 1rem}.lf-player-container{align-items:flex-end;width:100%;height:100%;display:flex;overflow:hidden}.rf-input-label{text-overflow:ellipsis;color:var(--rf-color-formInputTextDefault);margin-top:.1rem;margin-left:.75rem;overflow-x:hidden}#retorik-container.rf-large .rf-input-label{margin-top:.25rem}#retorik-container.rf-large.rf-portrait .rf-input-label{margin-top:.2rem}.rf-radio-custom{-webkit-appearance:none;appearance:none;border-width:2px;border-color:var(--rf-color-formInputRadioCheckboxUncheckedBorder);background-color:var(--rf-color-formInputRadioCheckboxUncheckedBackground);border-radius:50%;place-content:center;width:1.5rem;min-width:1.5rem;height:1.5rem;margin:0;display:grid}.rf-radio-custom:checked{border-color:var(--rf-color-formInputRadioCheckboxCheckedBorder);background-color:var(--rf-color-formInputRadioCheckboxCheckedBackground)}#retorik-container.rf-large .rf-radio-custom{width:1.75rem;min-width:1.75rem;height:1.75rem}#retorik-container.rf-large.rf-portrait .rf-radio-custom{width:2rem;min-width:2rem;height:2rem}.rf-radio-custom:before{content:\"\";--tw-scale-x:0;--tw-scale-y:0;transform:translate(var(--tw-translate-x),var(--tw-translate-y))rotate(var(--tw-rotate))skewX(var(--tw-skew-x))skewY(var(--tw-skew-y))scaleX(var(--tw-scale-x))scaleY(var(--tw-scale-y));background-color:var(--rf-color-formInputRadioCheckboxCheckedItem);border-radius:50%;width:.5rem;height:.5rem;transition-property:all;transition-duration:.15s;transition-timing-function:cubic-bezier(.4,0,.2,1)}#retorik-container.rf-large .rf-radio-custom:before{width:.75rem;height:.75rem}#retorik-container.rf-large.rf-portrait .rf-radio-custom:before{width:1rem;height:1rem}.rf-radio-custom:checked:before{--tw-scale-x:1;--tw-scale-y:1;transform:translate(var(--tw-translate-x),var(--tw-translate-y))rotate(var(--tw-rotate))skewX(var(--tw-skew-x))skewY(var(--tw-skew-y))scaleX(var(--tw-scale-x))scaleY(var(--tw-scale-y))}.rf-input-hidden{-webkit-appearance:none;appearance:none;margin:0}.rf-checkbox-custom{-webkit-appearance:none;appearance:none;border-width:2px;border-color:var(--rf-color-formInputRadioCheckboxUncheckedBorder);background-color:var(--rf-color-formInputRadioCheckboxUncheckedBackground);border-radius:.3125rem;place-content:center;width:1.5rem;min-width:1.5rem;height:1.5rem;margin:0;display:grid}#retorik-container.rf-large .rf-checkbox-custom{width:1.75rem;min-width:1.75rem;height:1.75rem}#retorik-container.rf-large.rf-portrait .rf-checkbox-custom{width:2rem;min-width:2rem;height:2rem}.rf-checkbox-custom:checked{border-color:var(--rf-color-formInputRadioCheckboxCheckedBorder);background-color:var(--rf-color-formInputRadioCheckboxCheckedBackground)}.rf-toggle-custom{-webkit-appearance:none;appearance:none;background-color:var(--rf-color-black);border-radius:1.5rem;width:3rem;min-width:3rem;height:1.5rem;margin:0;position:relative}.rf-toggle-custom:checked{background-color:var(--rf-color-primary)}#retorik-container.rf-large .rf-toggle-custom{border-radius:1.75rem;width:3.5rem;min-width:3.5rem;height:1.75rem}#retorik-container.rf-large.rf-portrait .rf-toggle-custom{border-radius:2rem;width:4rem;min-width:4rem;height:2rem}.rf-toggle-custom:before{content:\"\";--tw-translate-x:0px;transform:translate(var(--tw-translate-x),var(--tw-translate-y))rotate(var(--tw-rotate))skewX(var(--tw-skew-x))skewY(var(--tw-skew-y))scaleX(var(--tw-scale-x))scaleY(var(--tw-scale-y));--tw-bg-opacity:1;background-color:rgb(255 255 255/var(--tw-bg-opacity));border-radius:50%;width:1rem;height:1rem;transition-property:all;transition-duration:.15s;transition-timing-function:cubic-bezier(.4,0,.2,1);position:absolute;top:.25rem;left:.25rem}#retorik-container.rf-large .rf-toggle-custom:before{width:1.25rem;height:1.25rem}#retorik-container.rf-large.rf-portrait .rf-toggle-custom:before{width:1.5rem;height:1.5rem}.rf-toggle-custom:checked:before{--tw-translate-x:1.5rem;transform:translate(var(--tw-translate-x),var(--tw-translate-y))rotate(var(--tw-rotate))skewX(var(--tw-skew-x))skewY(var(--tw-skew-y))scaleX(var(--tw-scale-x))scaleY(var(--tw-scale-y))}#retorik-container.rf-large .rf-toggle-custom:checked:before{--tw-translate-x:1.75rem;transform:translate(var(--tw-translate-x),var(--tw-translate-y))rotate(var(--tw-rotate))skewX(var(--tw-skew-x))skewY(var(--tw-skew-y))scaleX(var(--tw-scale-x))scaleY(var(--tw-scale-y))}#retorik-container.rf-large.rf-portrait .rf-toggle-custom:checked:before{--tw-translate-x:2rem;transform:translate(var(--tw-translate-x),var(--tw-translate-y))rotate(var(--tw-rotate))skewX(var(--tw-skew-x))skewY(var(--tw-skew-y))scaleX(var(--tw-scale-x))scaleY(var(--tw-scale-y))}.rf-select-custom{-webkit-appearance:none;appearance:none;border-width:2px;border-color:var(--rf-color-formInputRadioCheckboxUncheckedBorder);background-color:var(--rf-color-formInputRadioCheckboxUncheckedBackground);border-radius:.3125rem;margin:0;padding:1rem}.rf-select-custom:hover{cursor:pointer}.rf-select-custom:focus-visible{border-color:var(--rf-color-formInputRadioCheckboxCheckedBorder)}.rf-slider-custom{-webkit-appearance:none;-moz-appearance:none;outline-offset:2px;border-radius:.5rem;outline:2px solid #0000;width:100%;height:.25rem;display:block;position:relative}.rf-slider-custom::-webkit-slider-runnable-track{-webkit-appearance:none}.rf-slider-custom::-moz-track{-moz-appearance:none}.rf-slider-custom::-ms-track{appearance:none}.rf-slider-custom::-webkit-slider-thumb{-webkit-appearance:none;--tw-bg-opacity:1;background-color:rgb(255 255 255/var(--tw-bg-opacity));border-style:none;border-radius:50%;width:1.5rem;height:1.5rem;margin-top:-.2rem}.rf-slider-custom::-webkit-slider-thumb:hover{cursor:pointer}.rf-slider-custom::-moz-range-thumb{-webkit-appearance:none;--tw-bg-opacity:1;background-color:rgb(255 255 255/var(--tw-bg-opacity));border-style:none;border-radius:50%;width:1.5rem;height:1.5rem;margin-top:-.2rem}.rf-slider-custom::-moz-range-thumb:hover{cursor:pointer}.rf-slider-custom::-ms-thumb{appearance:none;--tw-bg-opacity:1;background-color:rgb(255 255 255/var(--tw-bg-opacity));border-style:none;border-radius:50%;width:1.5rem;height:1.5rem;margin-top:-.2rem}.rf-slider-custom::-ms-thumb:hover{cursor:pointer}.rf-likert-custom{cursor:pointer;outline-offset:2px;-webkit-text-stroke-width:1px;-webkit-text-stroke-color:white;background-color:#0000;border-style:none;outline:2px solid #0000}.placeholder\\:rf-text-black::placeholder{color:var(--rf-color-black)}.placeholder\\:rf-opacity-100::placeholder{opacity:1}.hover\\:rf-cursor-pointer:hover{cursor:pointer}.hover\\:rf-bg-formInputRadioCheckboxCheckedBackground:hover{background-color:var(--rf-color-formInputRadioCheckboxCheckedBackground)}.hover\\:rf-bg-truewhite:hover{--tw-bg-opacity:1;background-color:rgb(255 255 255/var(--tw-bg-opacity))}.hover\\:rf-text-formInputRadioCheckboxCheckedItem:hover{color:var(--rf-color-formInputRadioCheckboxCheckedItem)}#retorik-container.rf-portrait .vertical\\:rf-col-span-full{grid-column:1/-1}#retorik-container.rf-portrait .vertical\\:rf-col-start-1{grid-column-start:1}#retorik-container.rf-portrait .vertical\\:rf-row-span-1{grid-row:span 1/span 1}#retorik-container.rf-portrait .vertical\\:rf-row-span-full{grid-row:1/-1}#retorik-container.rf-portrait .vertical\\:rf-row-start-1{grid-row-start:1}#retorik-container.rf-portrait .vertical\\:rf-row-start-11{grid-row-start:11}#retorik-container.rf-portrait .vertical\\:rf-row-end-13{grid-row-end:13}#retorik-container.rf-portrait .vertical\\:rf-w-5\\/6{width:83.3333%}#retorik-container.rf-portrait .vertical\\:rf-w-full{width:100%}#retorik-container.rf-portrait .vertical\\:rf-flex-col{flex-direction:column}#retorik-container.rf-portrait .vertical\\:rf-overflow-x-auto{overflow-x:auto}#retorik-container.rf-portrait .vertical\\:rf-border-r-0{border-right-width:0}#retorik-container.rf-portrait .vertical\\:rf-py-1{padding-top:.25rem;padding-bottom:.25rem}#retorik-container.rf-large .large\\:rf-absolute{position:absolute}#retorik-container.rf-large .large\\:rf-left-4{left:1rem}#retorik-container.rf-large .large\\:rf-top-8{top:2rem}#retorik-container.rf-large .large\\:rf-col-start-5{grid-column-start:5}#retorik-container.rf-large .large\\:rf-col-end-6{grid-column-end:6}#retorik-container.rf-large .large\\:rf-row-span-full{grid-row:1/-1}#retorik-container.rf-large .large\\:rf-row-start-10{grid-row-start:10}#retorik-container.rf-large .large\\:rf-row-start-5{grid-row-start:5}#retorik-container.rf-large .large\\:rf-m-8{margin:2rem}#retorik-container.rf-large .large\\:rf-my-3{margin-top:.75rem;margin-bottom:.75rem}#retorik-container.rf-large .large\\:rf-my-8{margin-top:2rem;margin-bottom:2rem}#retorik-container.rf-large .large\\:rf-mb-0{margin-bottom:0}#retorik-container.rf-large .large\\:rf-mb-4{margin-bottom:1rem}#retorik-container.rf-large .large\\:rf-mb-6{margin-bottom:1.5rem}#retorik-container.rf-large .large\\:rf-ml-0{margin-left:0}#retorik-container.rf-large .large\\:rf-ml-12{margin-left:3rem}#retorik-container.rf-large .large\\:rf-ml-4{margin-left:1rem}#retorik-container.rf-large .large\\:rf-ml-8{margin-left:2rem}#retorik-container.rf-large .large\\:rf-mr-3{margin-right:.75rem}#retorik-container.rf-large .large\\:rf-mr-30{margin-right:7.5rem}#retorik-container.rf-large .large\\:rf-mt-0{margin-top:0}#retorik-container.rf-large .large\\:rf-mt-20{margin-top:5rem}#retorik-container.rf-large .large\\:rf-mt-3{margin-top:.75rem}#retorik-container.rf-large .large\\:rf-mt-4{margin-top:1rem}#retorik-container.rf-large .large\\:rf-mt-\\[20vh\\]{margin-top:20vh}#retorik-container.rf-large .large\\:rf-block{display:block}#retorik-container.rf-large .large\\:rf-flex{display:flex}#retorik-container.rf-large .large\\:rf-hidden{display:none}#retorik-container.rf-large .large\\:rf-aspect-video{aspect-ratio:16/9}#retorik-container.rf-large .large\\:rf-h-16{height:4rem}#retorik-container.rf-large .large\\:rf-h-3\\/5{height:60%}#retorik-container.rf-large .large\\:rf-h-4{height:1rem}#retorik-container.rf-large .large\\:rf-h-5{height:1.25rem}#retorik-container.rf-large .large\\:rf-h-6{height:1.5rem}#retorik-container.rf-large .large\\:rf-h-8{height:2rem}#retorik-container.rf-large .large\\:rf-h-\\[60vh\\]{height:60vh}#retorik-container.rf-large .large\\:rf-h-auto{height:auto}#retorik-container.rf-large .large\\:rf-h-full{height:100%}#retorik-container.rf-large .large\\:rf-max-h-28{max-height:7rem}#retorik-container.rf-large .large\\:rf-w-14{width:3.5rem}#retorik-container.rf-large .large\\:rf-w-16{width:4rem}#retorik-container.rf-large .large\\:rf-w-3\\/5{width:60%}#retorik-container.rf-large .large\\:rf-w-4{width:1rem}#retorik-container.rf-large .large\\:rf-w-5{width:1.25rem}#retorik-container.rf-large .large\\:rf-w-6{width:1.5rem}#retorik-container.rf-large .large\\:rf-w-8{width:2rem}#retorik-container.rf-large .large\\:rf-w-fit{width:fit-content}#retorik-container.rf-large .large\\:rf-w-full{width:100%}#retorik-container.rf-large .large\\:rf-min-w-1\\/2{min-width:50%}#retorik-container.rf-large .large\\:rf-min-w-16{min-width:4rem}#retorik-container.rf-large .large\\:rf-min-w-3\\/5{min-width:60%}#retorik-container.rf-large .large\\:rf-max-w-\\[12rem\\]{max-width:12rem}#retorik-container.rf-large .large\\:rf-max-w-full{max-width:100%}#retorik-container.rf-large .large\\:rf-grid-cols-5{grid-template-columns:repeat(5,minmax(0,1fr))}#retorik-container.rf-large .large\\:rf-flex-row{flex-direction:row}#retorik-container.rf-large .large\\:rf-flex-col{flex-direction:column}#retorik-container.rf-large .large\\:rf-items-baseline{align-items:baseline}#retorik-container.rf-large .large\\:rf-justify-start{justify-content:flex-start}#retorik-container.rf-large .large\\:rf-gap-1{gap:.25rem}#retorik-container.rf-large .large\\:rf-gap-4{gap:1rem}#retorik-container.rf-large .large\\:rf-gap-6{gap:1.5rem}#retorik-container.rf-large .large\\:rf-overflow-y-scroll{overflow-y:scroll}#retorik-container.rf-large .large\\:rf-rounded{border-radius:.3125rem}#retorik-container.rf-large .large\\:rf-border-t-0{border-top-width:0}#retorik-container.rf-large .large\\:rf-bg-truewhite{--tw-bg-opacity:1;background-color:rgb(255 255 255/var(--tw-bg-opacity))}#retorik-container.rf-large .large\\:rf-p-4{padding:1rem}#retorik-container.rf-large .large\\:rf-p-\\[25px\\]{padding:25px}#retorik-container.rf-large .large\\:rf-p-min1{padding:.1rem}#retorik-container.rf-large .large\\:rf-px-0{padding-left:0;padding-right:0}#retorik-container.rf-large .large\\:rf-px-16{padding-left:4rem;padding-right:4rem}#retorik-container.rf-large .large\\:rf-px-4{padding-left:1rem;padding-right:1rem}#retorik-container.rf-large .large\\:rf-px-5,#retorik-container.rf-large .large\\:rf-px-6{padding-left:1.5rem;padding-right:1.5rem}#retorik-container.rf-large .large\\:rf-px-8{padding-left:2rem;padding-right:2rem}#retorik-container.rf-large .large\\:rf-py-0{padding-top:0;padding-bottom:0}#retorik-container.rf-large .large\\:rf-py-1{padding-top:.25rem;padding-bottom:.25rem}#retorik-container.rf-large .large\\:rf-py-2{padding-top:.5rem;padding-bottom:.5rem}#retorik-container.rf-large .large\\:rf-py-3{padding-top:.75rem;padding-bottom:.75rem}#retorik-container.rf-large .large\\:rf-py-4{padding-top:1rem;padding-bottom:1rem}#retorik-container.rf-large .large\\:rf-pb-16{padding-bottom:4rem}#retorik-container.rf-large .large\\:rf-pl-4{padding-left:1rem}#retorik-container.rf-large .large\\:rf-pr-4{padding-right:1rem}#retorik-container.rf-large .large\\:rf-pt-16{padding-top:4rem}#retorik-container.rf-large .large\\:rf-pt-3{padding-top:.75rem}#retorik-container.rf-large .large\\:rf-text-5xl{font-size:3rem;line-height:1}#retorik-container.rf-large .large\\:rf-text-6xl{font-size:3.75rem;line-height:1}#retorik-container.rf-large .large\\:rf-text-base{font-size:1rem;line-height:1.5rem}#retorik-container.rf-large .large\\:rf-text-sm{font-size:.875rem;line-height:1.25rem}#retorik-container.rf-large .large\\:rf-uppercase{text-transform:uppercase}#retorik-container.rf-tactile .tactile\\:rf-h-4{height:1rem}#retorik-container.rf-tactile .tactile\\:rf-h-6{height:1.5rem}#retorik-container.rf-tactile .tactile\\:rf-w-6{width:1.5rem}#retorik-container.rf-tactile .tactile\\:rf-pt-1\\/5{padding-top:20%}#retorik-container.rf-large.rf-portrait .large-vertical\\:rf-left-4{left:1rem}#retorik-container.rf-large.rf-portrait .large-vertical\\:rf-top-4{top:1rem}#retorik-container.rf-large.rf-portrait .large-vertical\\:rf-col-span-full{grid-column:1/-1}#retorik-container.rf-large.rf-portrait .large-vertical\\:rf-col-start-1{grid-column-start:1}#retorik-container.rf-large.rf-portrait .large-vertical\\:rf-col-start-2{grid-column-start:2}#retorik-container.rf-large.rf-portrait .large-vertical\\:rf-col-end-8{grid-column-end:8}#retorik-container.rf-large.rf-portrait .large-vertical\\:rf-col-end-9{grid-column-end:9}#retorik-container.rf-large.rf-portrait .large-vertical\\:rf-row-span-4{grid-row:span 4/span 4}#retorik-container.rf-large.rf-portrait .large-vertical\\:rf-row-span-6{grid-row:span 6/span 6}#retorik-container.rf-large.rf-portrait .large-vertical\\:rf-row-start-5{grid-row-start:5}#retorik-container.rf-large.rf-portrait .large-vertical\\:rf-row-start-7{grid-row-start:7}#retorik-container.rf-large.rf-portrait .large-vertical\\:rf-row-end-11{grid-row-end:11}#retorik-container.rf-large.rf-portrait .large-vertical\\:rf-row-end-7{grid-row-end:7}#retorik-container.rf-large.rf-portrait .large-vertical\\:rf-mt-\\[25vh\\]{margin-top:25vh}#retorik-container.rf-large.rf-portrait .large-vertical\\:rf-block{display:block}#retorik-container.rf-large.rf-portrait .large-vertical\\:rf-hidden{display:none}#retorik-container.rf-large.rf-portrait .large-vertical\\:rf-h-14{height:3.5rem}#retorik-container.rf-large.rf-portrait .large-vertical\\:rf-h-24{height:6rem}#retorik-container.rf-large.rf-portrait .large-vertical\\:rf-h-6{height:1.5rem}#retorik-container.rf-large.rf-portrait .large-vertical\\:rf-h-\\[50vh\\]{height:50vh}#retorik-container.rf-large.rf-portrait .large-vertical\\:rf-max-h-11\\/12{max-height:91.67%}#retorik-container.rf-large.rf-portrait .large-vertical\\:rf-max-h-36{max-height:9rem}#retorik-container.rf-large.rf-portrait .large-vertical\\:rf-w-1\\/2{width:50%}#retorik-container.rf-large.rf-portrait .large-vertical\\:rf-w-14{width:3.5rem}#retorik-container.rf-large.rf-portrait .large-vertical\\:rf-w-16{width:4rem}#retorik-container.rf-large.rf-portrait .large-vertical\\:rf-w-24{width:6rem}#retorik-container.rf-large.rf-portrait .large-vertical\\:rf-w-4\\/9{width:45%}#retorik-container.rf-large.rf-portrait .large-vertical\\:rf-w-6{width:1.5rem}#retorik-container.rf-large.rf-portrait .large-vertical\\:rf-min-w-24{min-width:6rem}#retorik-container.rf-large.rf-portrait .large-vertical\\:rf-min-w-4\\/9{min-width:45%}#retorik-container.rf-large.rf-portrait .large-vertical\\:rf-max-w-2\\/3{max-width:66.67%}#retorik-container.rf-large.rf-portrait .large-vertical\\:rf-grid-cols-3{grid-template-columns:repeat(3,minmax(0,1fr))}#retorik-container.rf-large.rf-portrait .large-vertical\\:rf-flex-row{flex-direction:row}#retorik-container.rf-large.rf-portrait .large-vertical\\:rf-items-center{align-items:center}#retorik-container.rf-large.rf-portrait .large-vertical\\:rf-justify-center{justify-content:center}#retorik-container.rf-large.rf-portrait .large-vertical\\:rf-gap-6{gap:1.5rem}#retorik-container.rf-large.rf-portrait .large-vertical\\:rf-border-t{border-top-width:1px}#retorik-container.rf-large.rf-portrait .large-vertical\\:rf-border-t-menuBorder{--tw-border-opacity:1;border-top-color:rgb(224 225 231/var(--tw-border-opacity))}#retorik-container.rf-large.rf-portrait .large-vertical\\:rf-py-4{padding-top:1rem;padding-bottom:1rem}#retorik-container.rf-large.rf-portrait .large-vertical\\:rf-py-5{padding-top:1.5rem;padding-bottom:1.5rem}#retorik-container.rf-large.rf-portrait .large-vertical\\:rf-pl-0{padding-left:0}#retorik-container.rf-large.rf-portrait .large-vertical\\:rf-pt-8{padding-top:2rem}#retorik-container.rf-large.rf-portrait .large-vertical\\:rf-pt-\\[16\\.67\\%\\]{padding-top:16.67%}#retorik-container.rf-large.rf-portrait .large-vertical\\:rf-pt-\\[20vh\\]{padding-top:20vh}#retorik-container.rf-large.rf-portrait .large-vertical\\:rf-text-basecustomuppercase{font-size:1rem;line-height:1.1rem}#retorik-container.rf-large.rf-tactile .large-tactile\\:rf-mt-0{margin-top:0}#retorik-container.rf-large.rf-tactile .large-tactile\\:rf-flex{display:flex}#retorik-container.rf-large.rf-tactile .large-tactile\\:rf-hidden{display:none}@media (height<=700px) and (width<=300px){.small-mobile\\:rf-row-span-6{grid-row:span 6/span 6}.small-mobile\\:rf-row-span-7{grid-row:span 7/span 7}.small-mobile\\:rf-row-start-5{grid-row-start:5}}";


var $9acfeaf8313b98ad$exports = {};
$9acfeaf8313b98ad$exports = "*,:before,:after,::backdrop{--tw-border-spacing-x:0;--tw-border-spacing-y:0;--tw-translate-x:0;--tw-translate-y:0;--tw-rotate:0;--tw-skew-x:0;--tw-skew-y:0;--tw-scale-x:1;--tw-scale-y:1;--tw-pan-x: ;--tw-pan-y: ;--tw-pinch-zoom: ;--tw-scroll-snap-strictness:proximity;--tw-ordinal: ;--tw-slashed-zero: ;--tw-numeric-figure: ;--tw-numeric-spacing: ;--tw-numeric-fraction: ;--tw-ring-inset: ;--tw-ring-offset-width:0px;--tw-ring-offset-color:#fff;--tw-ring-color:#3b82f680;--tw-ring-offset-shadow:0 0 #0000;--tw-ring-shadow:0 0 #0000;--tw-shadow:0 0 #0000;--tw-shadow-colored:0 0 #0000;--tw-blur: ;--tw-brightness: ;--tw-contrast: ;--tw-grayscale: ;--tw-hue-rotate: ;--tw-invert: ;--tw-saturate: ;--tw-sepia: ;--tw-drop-shadow: ;--tw-backdrop-blur: ;--tw-backdrop-brightness: ;--tw-backdrop-contrast: ;--tw-backdrop-grayscale: ;--tw-backdrop-hue-rotate: ;--tw-backdrop-invert: ;--tw-backdrop-opacity: ;--tw-backdrop-saturate: ;--tw-backdrop-sepia: }.ses-pointer-events-none{pointer-events:none}.ses-invisible{visibility:hidden}.ses-relative{position:relative}.ses-col-span-1{grid-column:span 1/span 1}.ses-col-start-1{grid-column-start:1}.ses-row-span-1{grid-row:span 1/span 1}.ses-row-start-1{grid-row-start:1}.ses-grid{display:grid}.ses-h-full{height:100%}.ses-w-full{width:100%}.ses-max-w-none{max-width:none}.ses-items-start{align-items:flex-start}.ses-justify-center{justify-content:center}.ses-self-start{align-self:flex-start}.ses-justify-self-center{justify-self:center}.ses-overflow-hidden{overflow:hidden}.ses-object-cover{object-fit:cover}.animation-delay-2{ses-animation-delay:.2s}.animation-delay-4{ses-animation-delay:.4s}.opacity-gradient{-webkit-mask-image:linear-gradient(#0000 0%,6%,#000,94%,#0000 100%)}";


var $03257026ff01fcda$exports = {};
$03257026ff01fcda$exports = ".leaflet-pane,.leaflet-tile,.leaflet-marker-icon,.leaflet-marker-shadow,.leaflet-tile-container,.leaflet-pane>svg,.leaflet-pane>canvas,.leaflet-zoom-box,.leaflet-image-layer,.leaflet-layer{position:absolute;top:0;left:0}.leaflet-container{overflow:hidden}.leaflet-tile,.leaflet-marker-icon,.leaflet-marker-shadow{-webkit-user-select:none;-moz-user-select:none;user-select:none;-webkit-user-drag:none}.leaflet-tile::selection{background:0 0}.leaflet-safari .leaflet-tile{image-rendering:-webkit-optimize-contrast}.leaflet-safari .leaflet-tile-container{-webkit-transform-origin:0 0;width:1600px;height:1600px}.leaflet-marker-icon,.leaflet-marker-shadow{display:block}.leaflet-container .leaflet-overlay-pane svg{max-width:none!important;max-height:none!important}.leaflet-container .leaflet-marker-pane img,.leaflet-container .leaflet-shadow-pane img,.leaflet-container .leaflet-tile-pane img,.leaflet-container img.leaflet-image-layer,.leaflet-container .leaflet-tile{width:auto;padding:0;max-width:none!important;max-height:none!important}.leaflet-container img.leaflet-tile{mix-blend-mode:plus-lighter}.leaflet-container.leaflet-touch-zoom{-ms-touch-action:pan-x pan-y;touch-action:pan-x pan-y}.leaflet-container.leaflet-touch-drag{-ms-touch-action:pinch-zoom;touch-action:none;touch-action:pinch-zoom}.leaflet-container.leaflet-touch-drag.leaflet-touch-zoom{-ms-touch-action:none;touch-action:none}.leaflet-container{-webkit-tap-highlight-color:transparent}.leaflet-container a{-webkit-tap-highlight-color:#33b5e566}.leaflet-tile{filter:inherit;visibility:hidden}.leaflet-tile-loaded{visibility:inherit}.leaflet-zoom-box{-moz-box-sizing:border-box;box-sizing:border-box;z-index:800;width:0;height:0}.leaflet-overlay-pane svg{-moz-user-select:none}.leaflet-pane{z-index:400}.leaflet-tile-pane{z-index:200}.leaflet-overlay-pane{z-index:400}.leaflet-shadow-pane{z-index:500}.leaflet-marker-pane{z-index:600}.leaflet-tooltip-pane{z-index:650}.leaflet-popup-pane{z-index:700}.leaflet-map-pane canvas{z-index:100}.leaflet-map-pane svg{z-index:200}.leaflet-vml-shape{width:1px;height:1px}.lvml{behavior:url(#default#VML);display:inline-block;position:absolute}.leaflet-control{z-index:800;pointer-events:visiblePainted;pointer-events:auto;position:relative}.leaflet-top,.leaflet-bottom{z-index:1000;pointer-events:none;position:absolute}.leaflet-top{top:0}.leaflet-right{right:0}.leaflet-bottom{bottom:0}.leaflet-left{left:0}.leaflet-control{float:left;clear:both}.leaflet-right .leaflet-control{float:right}.leaflet-top .leaflet-control{margin-top:10px}.leaflet-bottom .leaflet-control{margin-bottom:10px}.leaflet-left .leaflet-control{margin-left:10px}.leaflet-right .leaflet-control{margin-right:10px}.leaflet-fade-anim .leaflet-popup{opacity:0;-webkit-transition:opacity .2s linear;-moz-transition:opacity .2s linear;transition:opacity .2s linear}.leaflet-fade-anim .leaflet-map-pane .leaflet-popup{opacity:1}.leaflet-zoom-animated{-webkit-transform-origin:0 0;-ms-transform-origin:0 0;transform-origin:0 0}svg.leaflet-zoom-animated{will-change:transform}.leaflet-zoom-anim .leaflet-zoom-animated{-webkit-transition:-webkit-transform .25s cubic-bezier(0,0,.25,1);-moz-transition:-moz-transform .25s cubic-bezier(0,0,.25,1);transition:transform .25s cubic-bezier(0,0,.25,1)}.leaflet-zoom-anim .leaflet-tile,.leaflet-pan-anim .leaflet-tile{-webkit-transition:none;-moz-transition:none;transition:none}.leaflet-zoom-anim .leaflet-zoom-hide{visibility:hidden}.leaflet-interactive{cursor:pointer}.leaflet-grab{cursor:-webkit-grab;cursor:-moz-grab;cursor:grab}.leaflet-crosshair,.leaflet-crosshair .leaflet-interactive{cursor:crosshair}.leaflet-popup-pane,.leaflet-control{cursor:auto}.leaflet-dragging .leaflet-grab,.leaflet-dragging .leaflet-grab .leaflet-interactive,.leaflet-dragging .leaflet-marker-draggable{cursor:move;cursor:-webkit-grabbing;cursor:-moz-grabbing;cursor:grabbing}.leaflet-marker-icon,.leaflet-marker-shadow,.leaflet-image-layer,.leaflet-pane>svg path,.leaflet-tile-container{pointer-events:none}.leaflet-marker-icon.leaflet-interactive,.leaflet-image-layer.leaflet-interactive,.leaflet-pane>svg path.leaflet-interactive,svg.leaflet-image-layer.leaflet-interactive path{pointer-events:visiblePainted;pointer-events:auto}.leaflet-container{outline-offset:1px;background:#ddd}.leaflet-container a{color:#0078a8}.leaflet-zoom-box{background:#ffffff80;border:2px dotted #38f}.leaflet-container{font-family:Helvetica Neue,Arial,Helvetica,sans-serif;font-size:.75rem;line-height:1.5}.leaflet-bar{border-radius:4px;box-shadow:0 1px 5px #000000a6}.leaflet-bar a{text-align:center;color:#000;background-color:#fff;border-bottom:1px solid #ccc;width:26px;height:26px;line-height:26px;text-decoration:none;display:block}.leaflet-bar a,.leaflet-control-layers-toggle{background-position:50%;background-repeat:no-repeat;display:block}.leaflet-bar a:hover,.leaflet-bar a:focus{background-color:#f4f4f4}.leaflet-bar a:first-child{border-top-left-radius:4px;border-top-right-radius:4px}.leaflet-bar a:last-child{border-bottom:none;border-bottom-right-radius:4px;border-bottom-left-radius:4px}.leaflet-bar a.leaflet-disabled{cursor:default;color:#bbb;background-color:#f4f4f4}.leaflet-touch .leaflet-bar a{width:30px;height:30px;line-height:30px}.leaflet-touch .leaflet-bar a:first-child{border-top-left-radius:2px;border-top-right-radius:2px}.leaflet-touch .leaflet-bar a:last-child{border-bottom-right-radius:2px;border-bottom-left-radius:2px}.leaflet-control-zoom-in,.leaflet-control-zoom-out{text-indent:1px;font:700 18px Lucida Console,Monaco,monospace}.leaflet-touch .leaflet-control-zoom-in,.leaflet-touch .leaflet-control-zoom-out{font-size:22px}.leaflet-control-layers{background:#fff;border-radius:5px;box-shadow:0 1px 5px #0006}.leaflet-control-layers-toggle{background-image:url(layers.760a0456.png);width:36px;height:36px}.leaflet-retina .leaflet-control-layers-toggle{background-image:url(layers-2x.b7b89169.png);background-size:26px 26px}.leaflet-touch .leaflet-control-layers-toggle{width:44px;height:44px}.leaflet-control-layers .leaflet-control-layers-list,.leaflet-control-layers-expanded .leaflet-control-layers-toggle{display:none}.leaflet-control-layers-expanded .leaflet-control-layers-list{display:block;position:relative}.leaflet-control-layers-expanded{color:#333;background:#fff;padding:6px 10px 6px 6px}.leaflet-control-layers-scrollbar{padding-right:5px;overflow:hidden scroll}.leaflet-control-layers-selector{margin-top:2px;position:relative;top:1px}.leaflet-control-layers label{font-size:1.08333em;display:block}.leaflet-control-layers-separator{border-top:1px solid #ddd;height:0;margin:5px -10px 5px -6px}.leaflet-default-icon-path{background-image:url(marker-icon.3f7d3721.png)}.leaflet-container .leaflet-control-attribution{background:#fffc;margin:0}.leaflet-control-attribution,.leaflet-control-scale-line{color:#333;padding:0 5px;line-height:1.4}.leaflet-control-attribution a{text-decoration:none}.leaflet-control-attribution a:hover,.leaflet-control-attribution a:focus{text-decoration:underline}.leaflet-attribution-flag{width:1em;height:.6669em;vertical-align:baseline!important;display:inline!important}.leaflet-left .leaflet-control-scale{margin-left:5px}.leaflet-bottom .leaflet-control-scale{margin-bottom:5px}.leaflet-control-scale-line{white-space:nowrap;-moz-box-sizing:border-box;box-sizing:border-box;text-shadow:1px 1px #fff;background:#fffc;border:2px solid #777;border-top:none;padding:2px 5px 1px;line-height:1.1}.leaflet-control-scale-line:not(:first-child){border-top:2px solid #777;border-bottom:none;margin-top:-2px}.leaflet-control-scale-line:not(:first-child):not(:last-child){border-bottom:2px solid #777}.leaflet-touch .leaflet-control-attribution,.leaflet-touch .leaflet-control-layers,.leaflet-touch .leaflet-bar{box-shadow:none}.leaflet-touch .leaflet-control-layers,.leaflet-touch .leaflet-bar{background-clip:padding-box;border:2px solid #0003}.leaflet-popup{text-align:center;margin-bottom:20px;position:absolute}.leaflet-popup-content-wrapper{text-align:left;border-radius:12px;padding:1px}.leaflet-popup-content{min-height:1px;margin:13px 24px 13px 20px;font-size:1.08333em;line-height:1.3}.leaflet-popup-content p{margin:1.3em 0}.leaflet-popup-tip-container{pointer-events:none;width:40px;height:20px;margin-top:-1px;margin-left:-20px;position:absolute;left:50%;overflow:hidden}.leaflet-popup-tip{pointer-events:auto;width:17px;height:17px;margin:-10px auto 0;padding:1px;-webkit-transform:rotate(45deg);-moz-transform:rotate(45deg);-ms-transform:rotate(45deg);transform:rotate(45deg)}.leaflet-popup-content-wrapper,.leaflet-popup-tip{color:#333;background:#fff;box-shadow:0 3px 14px #0006}.leaflet-container a.leaflet-popup-close-button{text-align:center;color:#757575;background:0 0;border:none;width:24px;height:24px;font:16px/24px Tahoma,Verdana,sans-serif;text-decoration:none;position:absolute;top:0;right:0}.leaflet-container a.leaflet-popup-close-button:hover,.leaflet-container a.leaflet-popup-close-button:focus{color:#585858}.leaflet-popup-scrolled{overflow:auto}.leaflet-oldie .leaflet-popup-content-wrapper{-ms-zoom:1}.leaflet-oldie .leaflet-popup-tip{-ms-filter:\"progid:DXImageTransform.Microsoft.Matrix(M11=0.70710678, M12=0.70710678, M21=-0.70710678, M22=0.70710678)\";filter:progid:DXImageTransform.Microsoft.Matrix(M11=.707107,M12=.707107,M21=-.707107,M22=.707107);width:24px;margin:0 auto}.leaflet-oldie .leaflet-control-zoom,.leaflet-oldie .leaflet-control-layers,.leaflet-oldie .leaflet-popup-content-wrapper,.leaflet-oldie .leaflet-popup-tip{border:1px solid #999}.leaflet-div-icon{background:#fff;border:1px solid #666}.leaflet-tooltip{color:#222;white-space:nowrap;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;pointer-events:none;background-color:#fff;border:1px solid #fff;border-radius:3px;padding:6px;position:absolute;box-shadow:0 1px 3px #0006}.leaflet-tooltip.leaflet-interactive{cursor:pointer;pointer-events:auto}.leaflet-tooltip-top:before,.leaflet-tooltip-bottom:before,.leaflet-tooltip-left:before,.leaflet-tooltip-right:before{pointer-events:none;content:\"\";background:0 0;border:6px solid #0000;position:absolute}.leaflet-tooltip-bottom{margin-top:6px}.leaflet-tooltip-top{margin-top:-6px}.leaflet-tooltip-bottom:before,.leaflet-tooltip-top:before{margin-left:-6px;left:50%}.leaflet-tooltip-top:before{border-top-color:#fff;margin-bottom:-12px;bottom:0}.leaflet-tooltip-bottom:before{border-bottom-color:#fff;margin-top:-12px;margin-left:-6px;top:0}.leaflet-tooltip-left{margin-left:-6px}.leaflet-tooltip-right{margin-left:6px}.leaflet-tooltip-left:before,.leaflet-tooltip-right:before{margin-top:-6px;top:50%}.leaflet-tooltip-left:before{border-left-color:#fff;margin-right:-12px;right:0}.leaflet-tooltip-right:before{border-right-color:#fff;margin-left:-12px;left:0}@media print{.leaflet-control{-webkit-print-color-adjust:exact;print-color-adjust:exact}}";


var $16ad089b9ce6627d$export$3b4d92ba873f009a;
(function($16ad089b9ce6627d$export$3b4d92ba873f009a) {
    $16ad089b9ce6627d$export$3b4d92ba873f009a[$16ad089b9ce6627d$export$3b4d92ba873f009a["home"] = 1] = "home";
    $16ad089b9ce6627d$export$3b4d92ba873f009a[$16ad089b9ce6627d$export$3b4d92ba873f009a["news"] = 2] = "news";
    $16ad089b9ce6627d$export$3b4d92ba873f009a[$16ad089b9ce6627d$export$3b4d92ba873f009a["weather"] = 3] = "weather";
    $16ad089b9ce6627d$export$3b4d92ba873f009a[$16ad089b9ce6627d$export$3b4d92ba873f009a["emergency"] = 4] = "emergency";
})($16ad089b9ce6627d$export$3b4d92ba873f009a || ($16ad089b9ce6627d$export$3b4d92ba873f009a = {}));
var $16ad089b9ce6627d$export$c5a4c3ea2d78493c;
(function($16ad089b9ce6627d$export$c5a4c3ea2d78493c) {
    $16ad089b9ce6627d$export$c5a4c3ea2d78493c[$16ad089b9ce6627d$export$c5a4c3ea2d78493c["history"] = 1000] = "history";
    $16ad089b9ce6627d$export$c5a4c3ea2d78493c[$16ad089b9ce6627d$export$c5a4c3ea2d78493c["tutorial"] = 1001] = "tutorial";
})($16ad089b9ce6627d$export$c5a4c3ea2d78493c || ($16ad089b9ce6627d$export$c5a4c3ea2d78493c = {}));
var $16ad089b9ce6627d$export$22b261e08140d6b2;
(function($16ad089b9ce6627d$export$22b261e08140d6b2) {
    $16ad089b9ce6627d$export$22b261e08140d6b2["eat"] = "where to eat";
    $16ad089b9ce6627d$export$22b261e08140d6b2["sleep"] = "where to sleep";
    $16ad089b9ce6627d$export$22b261e08140d6b2["see"] = "what to see";
    $16ad089b9ce6627d$export$22b261e08140d6b2["do"] = "what to do";
    $16ad089b9ce6627d$export$22b261e08140d6b2["localproducts"] = "local products";
    $16ad089b9ce6627d$export$22b261e08140d6b2["services"] = "services";
    $16ad089b9ce6627d$export$22b261e08140d6b2["agenda"] = "events";
})($16ad089b9ce6627d$export$22b261e08140d6b2 || ($16ad089b9ce6627d$export$22b261e08140d6b2 = {}));
var $16ad089b9ce6627d$export$a31c5a03aaeee5f;
(function($16ad089b9ce6627d$export$a31c5a03aaeee5f) {
    $16ad089b9ce6627d$export$a31c5a03aaeee5f[$16ad089b9ce6627d$export$a31c5a03aaeee5f["agent"] = 1] = "agent";
    $16ad089b9ce6627d$export$a31c5a03aaeee5f[$16ad089b9ce6627d$export$a31c5a03aaeee5f["widget"] = 2] = "widget";
    $16ad089b9ce6627d$export$a31c5a03aaeee5f[$16ad089b9ce6627d$export$a31c5a03aaeee5f["news"] = 3] = "news";
})($16ad089b9ce6627d$export$a31c5a03aaeee5f || ($16ad089b9ce6627d$export$a31c5a03aaeee5f = {}));
var $16ad089b9ce6627d$export$f05d0fed0593ead7;
(function($16ad089b9ce6627d$export$f05d0fed0593ead7) {
    $16ad089b9ce6627d$export$f05d0fed0593ead7[$16ad089b9ce6627d$export$f05d0fed0593ead7["none"] = 1] = "none";
    $16ad089b9ce6627d$export$f05d0fed0593ead7[$16ad089b9ce6627d$export$f05d0fed0593ead7["history"] = 2] = "history";
    $16ad089b9ce6627d$export$f05d0fed0593ead7[$16ad089b9ce6627d$export$f05d0fed0593ead7["languages"] = 3] = "languages";
    $16ad089b9ce6627d$export$f05d0fed0593ead7[$16ad089b9ce6627d$export$f05d0fed0593ead7["weather"] = 4] = "weather";
    $16ad089b9ce6627d$export$f05d0fed0593ead7[$16ad089b9ce6627d$export$f05d0fed0593ead7["emergency"] = 5] = "emergency";
    $16ad089b9ce6627d$export$f05d0fed0593ead7[$16ad089b9ce6627d$export$f05d0fed0593ead7["custom"] = 6] = "custom";
})($16ad089b9ce6627d$export$f05d0fed0593ead7 || ($16ad089b9ce6627d$export$f05d0fed0593ead7 = {}));
var $16ad089b9ce6627d$export$950556173b6cbecb;
(function($16ad089b9ce6627d$export$950556173b6cbecb) {
    $16ad089b9ce6627d$export$950556173b6cbecb[$16ad089b9ce6627d$export$950556173b6cbecb["background"] = 1] = "background";
    $16ad089b9ce6627d$export$950556173b6cbecb[$16ad089b9ce6627d$export$950556173b6cbecb["util"] = 2] = "util";
    $16ad089b9ce6627d$export$950556173b6cbecb[$16ad089b9ce6627d$export$950556173b6cbecb["chatbot"] = 3] = "chatbot";
    $16ad089b9ce6627d$export$950556173b6cbecb[$16ad089b9ce6627d$export$950556173b6cbecb["ui"] = 4] = "ui";
    $16ad089b9ce6627d$export$950556173b6cbecb[$16ad089b9ce6627d$export$950556173b6cbecb["dropdown"] = 5] = "dropdown";
    $16ad089b9ce6627d$export$950556173b6cbecb[$16ad089b9ce6627d$export$950556173b6cbecb["overlay"] = 6] = "overlay";
    $16ad089b9ce6627d$export$950556173b6cbecb[$16ad089b9ce6627d$export$950556173b6cbecb["menu"] = 7] = "menu";
    $16ad089b9ce6627d$export$950556173b6cbecb[$16ad089b9ce6627d$export$950556173b6cbecb["modal"] = 8] = "modal";
    $16ad089b9ce6627d$export$950556173b6cbecb[$16ad089b9ce6627d$export$950556173b6cbecb["exitwidget"] = 9] = "exitwidget";
})($16ad089b9ce6627d$export$950556173b6cbecb || ($16ad089b9ce6627d$export$950556173b6cbecb = {}));
var $16ad089b9ce6627d$export$ec1e04e4e5ef8233;
(function($16ad089b9ce6627d$export$ec1e04e4e5ef8233) {
    $16ad089b9ce6627d$export$ec1e04e4e5ef8233[$16ad089b9ce6627d$export$ec1e04e4e5ef8233["mobile"] = 1] = "mobile";
    $16ad089b9ce6627d$export$ec1e04e4e5ef8233[$16ad089b9ce6627d$export$ec1e04e4e5ef8233["borne"] = 2] = "borne";
    $16ad089b9ce6627d$export$ec1e04e4e5ef8233[$16ad089b9ce6627d$export$ec1e04e4e5ef8233["landscape"] = 3] = "landscape";
    $16ad089b9ce6627d$export$ec1e04e4e5ef8233[$16ad089b9ce6627d$export$ec1e04e4e5ef8233["widget"] = 4] = "widget";
})($16ad089b9ce6627d$export$ec1e04e4e5ef8233 || ($16ad089b9ce6627d$export$ec1e04e4e5ef8233 = {}));
var $16ad089b9ce6627d$export$bd7313a2f8345cae;
(function($16ad089b9ce6627d$export$bd7313a2f8345cae) {
    $16ad089b9ce6627d$export$bd7313a2f8345cae[$16ad089b9ce6627d$export$bd7313a2f8345cae["loader"] = 1] = "loader";
    $16ad089b9ce6627d$export$bd7313a2f8345cae[$16ad089b9ce6627d$export$bd7313a2f8345cae["locale"] = 2] = "locale";
    $16ad089b9ce6627d$export$bd7313a2f8345cae[$16ad089b9ce6627d$export$bd7313a2f8345cae["supported"] = 3] = "supported";
    $16ad089b9ce6627d$export$bd7313a2f8345cae[$16ad089b9ce6627d$export$bd7313a2f8345cae["store"] = 4] = "store";
    $16ad089b9ce6627d$export$bd7313a2f8345cae[$16ad089b9ce6627d$export$bd7313a2f8345cae["directline"] = 5] = "directline";
    $16ad089b9ce6627d$export$bd7313a2f8345cae[$16ad089b9ce6627d$export$bd7313a2f8345cae["ponyfill"] = 6] = "ponyfill";
    $16ad089b9ce6627d$export$bd7313a2f8345cae[$16ad089b9ce6627d$export$bd7313a2f8345cae["agentdata"] = 7] = "agentdata";
})($16ad089b9ce6627d$export$bd7313a2f8345cae || ($16ad089b9ce6627d$export$bd7313a2f8345cae = {}));
var $16ad089b9ce6627d$export$9484bbecc3c49a2e;
(function($16ad089b9ce6627d$export$9484bbecc3c49a2e) {
    $16ad089b9ce6627d$export$9484bbecc3c49a2e[$16ad089b9ce6627d$export$9484bbecc3c49a2e["vocal"] = 1] = "vocal";
    $16ad089b9ce6627d$export$9484bbecc3c49a2e[$16ad089b9ce6627d$export$9484bbecc3c49a2e["text"] = 2] = "text";
    $16ad089b9ce6627d$export$9484bbecc3c49a2e[$16ad089b9ce6627d$export$9484bbecc3c49a2e["dashboard"] = 3] = "dashboard";
})($16ad089b9ce6627d$export$9484bbecc3c49a2e || ($16ad089b9ce6627d$export$9484bbecc3c49a2e = {}));
var $16ad089b9ce6627d$export$13807d9ee5a34a42;
(function($16ad089b9ce6627d$export$13807d9ee5a34a42) {
    $16ad089b9ce6627d$export$13807d9ee5a34a42[$16ad089b9ce6627d$export$13807d9ee5a34a42["top"] = 1] = "top";
    $16ad089b9ce6627d$export$13807d9ee5a34a42[$16ad089b9ce6627d$export$13807d9ee5a34a42["right"] = 2] = "right";
    $16ad089b9ce6627d$export$13807d9ee5a34a42[$16ad089b9ce6627d$export$13807d9ee5a34a42["bottom"] = 3] = "bottom";
    $16ad089b9ce6627d$export$13807d9ee5a34a42[$16ad089b9ce6627d$export$13807d9ee5a34a42["left"] = 4] = "left";
})($16ad089b9ce6627d$export$13807d9ee5a34a42 || ($16ad089b9ce6627d$export$13807d9ee5a34a42 = {}));
var $16ad089b9ce6627d$export$4f7cd669585dc69f;
(function($16ad089b9ce6627d$export$4f7cd669585dc69f) {
    $16ad089b9ce6627d$export$4f7cd669585dc69f[$16ad089b9ce6627d$export$4f7cd669585dc69f["DetailViewOpen"] = 1] = "DetailViewOpen";
    $16ad089b9ce6627d$export$4f7cd669585dc69f[$16ad089b9ce6627d$export$4f7cd669585dc69f["DetailViewClose"] = 2] = "DetailViewClose";
    $16ad089b9ce6627d$export$4f7cd669585dc69f[$16ad089b9ce6627d$export$4f7cd669585dc69f["SpeechStarted"] = 3] = "SpeechStarted";
    $16ad089b9ce6627d$export$4f7cd669585dc69f[$16ad089b9ce6627d$export$4f7cd669585dc69f["SpeechEnded"] = 4] = "SpeechEnded";
})($16ad089b9ce6627d$export$4f7cd669585dc69f || ($16ad089b9ce6627d$export$4f7cd669585dc69f = {}));


const $674f1d59bae686ab$export$2e65b7c7134e01f0 = 600;
const $674f1d59bae686ab$export$91e4bf93df95a062 = 1500;
const $674f1d59bae686ab$export$66b40c15080ce99b = "https://cdn.retorik.ai";
const $674f1d59bae686ab$export$2475544086fd222b = `${$674f1d59bae686ab$export$66b40c15080ce99b}/spiritenginehtml5/characters`;
const $674f1d59bae686ab$export$f718170a6537817b = `${$674f1d59bae686ab$export$66b40c15080ce99b}/retorik-framework/imagefiles`;
const $674f1d59bae686ab$export$eefca12493f9e9b9 = `${$674f1d59bae686ab$export$66b40c15080ce99b}/retorik-framework/audiofiles`;
const $674f1d59bae686ab$export$c398bfda6cfa19ff = "https://studio.retorik.ai";
const $674f1d59bae686ab$export$9adff68f093278ec = "https://dev.studio.retorik.ai";
const $674f1d59bae686ab$export$409889737849a04f = "https://preview.studio.retorik.ai";
const $674f1d59bae686ab$export$a4481ccc388fce2a = "https://experimental.studio.retorik.ai";
const $674f1d59bae686ab$export$9a9d93503cb8eba5 = "https://management.retorik.ai";
const $674f1d59bae686ab$export$9679f5e7d9635332 = "https://dev.management.retorik.ai";
const $674f1d59bae686ab$export$d775aabd593372b1 = "https://staging.management.retorik.ai";
const $674f1d59bae686ab$export$9683c9c18296186 = "/api/getOGData";
const $674f1d59bae686ab$export$d6542303192de6db = "https://api.openrouteservice.org/v2/directions";
const $674f1d59bae686ab$export$6f60da16472d34a7 = "5b3ce3597851110001cf62483cfd6bd46f934b7d96f108a35e0f08b8";
const $674f1d59bae686ab$export$dc91bcad81fffb1f = "https://api.open-meteo.com/v1/forecast?";
const $674f1d59bae686ab$export$68b4ac416ba801c6 = "&daily=weathercode,temperature_2m_max,temperature_2m_min&timezone=auto&current_weather=true";
const $674f1d59bae686ab$export$d9e38c0112bbdae6 = "K2.ContentFields.WebChat/api/GetWebchatToken";
const $674f1d59bae686ab$export$1ca3e229e23d7f42 = "api/hospitality/Emergency";
const $674f1d59bae686ab$export$8828fbbb6034a09b = {
    default: "fr-FR",
    all: [
        "fr-FR"
    ]
};
const $674f1d59bae686ab$export$9bbca248acc786d3 = [
    {
        view: (0, $16ad089b9ce6627d$export$3b4d92ba873f009a).home,
        indice: 1
    },
    {
        view: (0, $16ad089b9ce6627d$export$3b4d92ba873f009a).emergency,
        indice: 2
    }
];
const $674f1d59bae686ab$export$890576ebf405f6b7 = [
    {
        view: (0, $16ad089b9ce6627d$export$c5a4c3ea2d78493c).history,
        indice: 1
    },
    {
        view: (0, $16ad089b9ce6627d$export$c5a4c3ea2d78493c).tutorial,
        indice: 2
    }
];
const $674f1d59bae686ab$export$78f16669b353a880 = [
    (0, $16ad089b9ce6627d$export$ec1e04e4e5ef8233).mobile,
    (0, $16ad089b9ce6627d$export$ec1e04e4e5ef8233).widget
];
const $674f1d59bae686ab$export$c0da64553318f2cb = {
    primary: "#00D7FF",
    secondary: "#1999B1",
    black: "#101219",
    whereToEatColor: "#FC952E",
    whereToSleepColor: "#9F007D",
    tobeSeenColor: "#76AB2A",
    tobeDoneColor: "#E23C2A",
    localProductsColor: "#AFB942",
    servicesColor: "#00C8BC",
    agendaColor: "#865DA2"
};


const $9062ab1ccebf2f9e$export$e56d88b19b5c9fbf = {
    noimage: `${(0, $674f1d59bae686ab$export$f718170a6537817b)}/no-image.png`,
    logoRetorikBlack: `${(0, $674f1d59bae686ab$export$f718170a6537817b)}/logo_RETORIK_black.png`,
    logoRetorikWhite: `${(0, $674f1d59bae686ab$export$f718170a6537817b)}/logo_RETORIK_white.png`,
    mapDeparture: `${(0, $674f1d59bae686ab$export$f718170a6537817b)}/Leaflet/map_departure.png`,
    mapArrival: `${(0, $674f1d59bae686ab$export$f718170a6537817b)}/Leaflet/map_arrival.png`,
    leaMini: `${(0, $674f1d59bae686ab$export$f718170a6537817b)}/lea_mini.png`
};


var $3df1761126dc5bba$exports = {};
/* @preserve
 * Leaflet 1.9.4, a JS library for interactive maps. https://leafletjs.com
 * (c) 2010-2023 Vladimir Agafonkin, (c) 2010-2011 CloudMade
 */ (function(global, factory) {
    factory($3df1761126dc5bba$exports);
})($3df1761126dc5bba$exports, function(exports) {
    "use strict";
    var version = "1.9.4";
    /*
   * @namespace Util
   *
   * Various utility functions, used by Leaflet internally.
   */ // @function extend(dest: Object, src?: Object): Object
    // Merges the properties of the `src` object (or multiple objects) into `dest` object and returns the latter. Has an `L.extend` shortcut.
    function extend(dest) {
        var i, j, len, src;
        for(j = 1, len = arguments.length; j < len; j++){
            src = arguments[j];
            for(i in src)dest[i] = src[i];
        }
        return dest;
    }
    // @function create(proto: Object, properties?: Object): Object
    // Compatibility polyfill for [Object.create](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Object/create)
    var create$2 = Object.create || function() {
        function F() {}
        return function(proto) {
            F.prototype = proto;
            return new F();
        };
    }();
    // @function bind(fn: Function, …): Function
    // Returns a new function bound to the arguments passed, like [Function.prototype.bind](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Function/bind).
    // Has a `L.bind()` shortcut.
    function bind(fn, obj) {
        var slice = Array.prototype.slice;
        if (fn.bind) return fn.bind.apply(fn, slice.call(arguments, 1));
        var args = slice.call(arguments, 2);
        return function() {
            return fn.apply(obj, args.length ? args.concat(slice.call(arguments)) : arguments);
        };
    }
    // @property lastId: Number
    // Last unique ID used by [`stamp()`](#util-stamp)
    var lastId = 0;
    // @function stamp(obj: Object): Number
    // Returns the unique ID of an object, assigning it one if it doesn't have it.
    function stamp(obj) {
        if (!("_leaflet_id" in obj)) obj["_leaflet_id"] = ++lastId;
        return obj._leaflet_id;
    }
    // @function throttle(fn: Function, time: Number, context: Object): Function
    // Returns a function which executes function `fn` with the given scope `context`
    // (so that the `this` keyword refers to `context` inside `fn`'s code). The function
    // `fn` will be called no more than one time per given amount of `time`. The arguments
    // received by the bound function will be any arguments passed when binding the
    // function, followed by any arguments passed when invoking the bound function.
    // Has an `L.throttle` shortcut.
    function throttle(fn, time, context) {
        var lock, args, wrapperFn, later;
        later = function() {
            // reset lock and call if queued
            lock = false;
            if (args) {
                wrapperFn.apply(context, args);
                args = false;
            }
        };
        wrapperFn = function() {
            if (lock) // called too soon, queue to call later
            args = arguments;
            else {
                // call and lock until later
                fn.apply(context, arguments);
                setTimeout(later, time);
                lock = true;
            }
        };
        return wrapperFn;
    }
    // @function wrapNum(num: Number, range: Number[], includeMax?: Boolean): Number
    // Returns the number `num` modulo `range` in such a way so it lies within
    // `range[0]` and `range[1]`. The returned value will be always smaller than
    // `range[1]` unless `includeMax` is set to `true`.
    function wrapNum(x, range, includeMax) {
        var max = range[1], min = range[0], d = max - min;
        return x === max && includeMax ? x : ((x - min) % d + d) % d + min;
    }
    // @function falseFn(): Function
    // Returns a function which always returns `false`.
    function falseFn() {
        return false;
    }
    // @function formatNum(num: Number, precision?: Number|false): Number
    // Returns the number `num` rounded with specified `precision`.
    // The default `precision` value is 6 decimal places.
    // `false` can be passed to skip any processing (can be useful to avoid round-off errors).
    function formatNum(num, precision) {
        if (precision === false) return num;
        var pow = Math.pow(10, precision === undefined ? 6 : precision);
        return Math.round(num * pow) / pow;
    }
    // @function trim(str: String): String
    // Compatibility polyfill for [String.prototype.trim](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/String/Trim)
    function trim(str) {
        return str.trim ? str.trim() : str.replace(/^\s+|\s+$/g, "");
    }
    // @function splitWords(str: String): String[]
    // Trims and splits the string on whitespace and returns the array of parts.
    function splitWords(str) {
        return trim(str).split(/\s+/);
    }
    // @function setOptions(obj: Object, options: Object): Object
    // Merges the given properties to the `options` of the `obj` object, returning the resulting options. See `Class options`. Has an `L.setOptions` shortcut.
    function setOptions(obj, options) {
        if (!Object.prototype.hasOwnProperty.call(obj, "options")) obj.options = obj.options ? create$2(obj.options) : {};
        for(var i in options)obj.options[i] = options[i];
        return obj.options;
    }
    // @function getParamString(obj: Object, existingUrl?: String, uppercase?: Boolean): String
    // Converts an object into a parameter URL string, e.g. `{a: "foo", b: "bar"}`
    // translates to `'?a=foo&b=bar'`. If `existingUrl` is set, the parameters will
    // be appended at the end. If `uppercase` is `true`, the parameter names will
    // be uppercased (e.g. `'?A=foo&B=bar'`)
    function getParamString(obj, existingUrl, uppercase) {
        var params = [];
        for(var i in obj)params.push(encodeURIComponent(uppercase ? i.toUpperCase() : i) + "=" + encodeURIComponent(obj[i]));
        return (!existingUrl || existingUrl.indexOf("?") === -1 ? "?" : "&") + params.join("&");
    }
    var templateRe = /\{ *([\w_ -]+) *\}/g;
    // @function template(str: String, data: Object): String
    // Simple templating facility, accepts a template string of the form `'Hello {a}, {b}'`
    // and a data object like `{a: 'foo', b: 'bar'}`, returns evaluated string
    // `('Hello foo, bar')`. You can also specify functions instead of strings for
    // data values — they will be evaluated passing `data` as an argument.
    function template(str, data) {
        return str.replace(templateRe, function(str, key) {
            var value = data[key];
            if (value === undefined) throw new Error("No value provided for variable " + str);
            else if (typeof value === "function") value = value(data);
            return value;
        });
    }
    // @function isArray(obj): Boolean
    // Compatibility polyfill for [Array.isArray](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Array/isArray)
    var isArray = Array.isArray || function(obj) {
        return Object.prototype.toString.call(obj) === "[object Array]";
    };
    // @function indexOf(array: Array, el: Object): Number
    // Compatibility polyfill for [Array.prototype.indexOf](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Array/indexOf)
    function indexOf(array, el) {
        for(var i = 0; i < array.length; i++){
            if (array[i] === el) return i;
        }
        return -1;
    }
    // @property emptyImageUrl: String
    // Data URI string containing a base64-encoded empty GIF image.
    // Used as a hack to free memory from unused images on WebKit-powered
    // mobile devices (by setting image `src` to this string).
    var emptyImageUrl = "data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs=";
    // inspired by https://paulirish.com/2011/requestanimationframe-for-smart-animating/
    function getPrefixed(name) {
        return window["webkit" + name] || window["moz" + name] || window["ms" + name];
    }
    var lastTime = 0;
    // fallback for IE 7-8
    function timeoutDefer(fn) {
        var time = +new Date(), timeToCall = Math.max(0, 16 - (time - lastTime));
        lastTime = time + timeToCall;
        return window.setTimeout(fn, timeToCall);
    }
    var requestFn = window.requestAnimationFrame || getPrefixed("RequestAnimationFrame") || timeoutDefer;
    var cancelFn = window.cancelAnimationFrame || getPrefixed("CancelAnimationFrame") || getPrefixed("CancelRequestAnimationFrame") || function(id) {
        window.clearTimeout(id);
    };
    // @function requestAnimFrame(fn: Function, context?: Object, immediate?: Boolean): Number
    // Schedules `fn` to be executed when the browser repaints. `fn` is bound to
    // `context` if given. When `immediate` is set, `fn` is called immediately if
    // the browser doesn't have native support for
    // [`window.requestAnimationFrame`](https://developer.mozilla.org/docs/Web/API/window/requestAnimationFrame),
    // otherwise it's delayed. Returns a request ID that can be used to cancel the request.
    function requestAnimFrame(fn, context, immediate) {
        if (immediate && requestFn === timeoutDefer) fn.call(context);
        else return requestFn.call(window, bind(fn, context));
    }
    // @function cancelAnimFrame(id: Number): undefined
    // Cancels a previous `requestAnimFrame`. See also [window.cancelAnimationFrame](https://developer.mozilla.org/docs/Web/API/window/cancelAnimationFrame).
    function cancelAnimFrame(id) {
        if (id) cancelFn.call(window, id);
    }
    var Util = {
        __proto__: null,
        extend: extend,
        create: create$2,
        bind: bind,
        get lastId () {
            return lastId;
        },
        stamp: stamp,
        throttle: throttle,
        wrapNum: wrapNum,
        falseFn: falseFn,
        formatNum: formatNum,
        trim: trim,
        splitWords: splitWords,
        setOptions: setOptions,
        getParamString: getParamString,
        template: template,
        isArray: isArray,
        indexOf: indexOf,
        emptyImageUrl: emptyImageUrl,
        requestFn: requestFn,
        cancelFn: cancelFn,
        requestAnimFrame: requestAnimFrame,
        cancelAnimFrame: cancelAnimFrame
    };
    // @class Class
    // @aka L.Class
    // @section
    // @uninheritable
    // Thanks to John Resig and Dean Edwards for inspiration!
    function Class() {}
    Class.extend = function(props) {
        // @function extend(props: Object): Function
        // [Extends the current class](#class-inheritance) given the properties to be included.
        // Returns a Javascript function that is a class constructor (to be called with `new`).
        var NewClass = function() {
            setOptions(this);
            // call the constructor
            if (this.initialize) this.initialize.apply(this, arguments);
            // call all constructor hooks
            this.callInitHooks();
        };
        var parentProto = NewClass.__super__ = this.prototype;
        var proto = create$2(parentProto);
        proto.constructor = NewClass;
        NewClass.prototype = proto;
        // inherit parent's statics
        for(var i in this)if (Object.prototype.hasOwnProperty.call(this, i) && i !== "prototype" && i !== "__super__") NewClass[i] = this[i];
        // mix static properties into the class
        if (props.statics) extend(NewClass, props.statics);
        // mix includes into the prototype
        if (props.includes) {
            checkDeprecatedMixinEvents(props.includes);
            extend.apply(null, [
                proto
            ].concat(props.includes));
        }
        // mix given properties into the prototype
        extend(proto, props);
        delete proto.statics;
        delete proto.includes;
        // merge options
        if (proto.options) {
            proto.options = parentProto.options ? create$2(parentProto.options) : {};
            extend(proto.options, props.options);
        }
        proto._initHooks = [];
        // add method for calling all hooks
        proto.callInitHooks = function() {
            if (this._initHooksCalled) return;
            if (parentProto.callInitHooks) parentProto.callInitHooks.call(this);
            this._initHooksCalled = true;
            for(var i = 0, len = proto._initHooks.length; i < len; i++)proto._initHooks[i].call(this);
        };
        return NewClass;
    };
    // @function include(properties: Object): this
    // [Includes a mixin](#class-includes) into the current class.
    Class.include = function(props) {
        var parentOptions = this.prototype.options;
        extend(this.prototype, props);
        if (props.options) {
            this.prototype.options = parentOptions;
            this.mergeOptions(props.options);
        }
        return this;
    };
    // @function mergeOptions(options: Object): this
    // [Merges `options`](#class-options) into the defaults of the class.
    Class.mergeOptions = function(options) {
        extend(this.prototype.options, options);
        return this;
    };
    // @function addInitHook(fn: Function): this
    // Adds a [constructor hook](#class-constructor-hooks) to the class.
    Class.addInitHook = function(fn) {
        var args = Array.prototype.slice.call(arguments, 1);
        var init = typeof fn === "function" ? fn : function() {
            this[fn].apply(this, args);
        };
        this.prototype._initHooks = this.prototype._initHooks || [];
        this.prototype._initHooks.push(init);
        return this;
    };
    function checkDeprecatedMixinEvents(includes) {
        /* global L: true */ if (typeof L === "undefined" || !L || !L.Mixin) return;
        includes = isArray(includes) ? includes : [
            includes
        ];
        for(var i = 0; i < includes.length; i++)if (includes[i] === L.Mixin.Events) console.warn("Deprecated include of L.Mixin.Events: this property will be removed in future releases, please inherit from L.Evented instead.", new Error().stack);
    }
    /*
   * @class Evented
   * @aka L.Evented
   * @inherits Class
   *
   * A set of methods shared between event-powered classes (like `Map` and `Marker`). Generally, events allow you to execute some function when something happens with an object (e.g. the user clicks on the map, causing the map to fire `'click'` event).
   *
   * @example
   *
   * ```js
   * map.on('click', function(e) {
   * 	alert(e.latlng);
   * } );
   * ```
   *
   * Leaflet deals with event listeners by reference, so if you want to add a listener and then remove it, define it as a function:
   *
   * ```js
   * function onClick(e) { ... }
   *
   * map.on('click', onClick);
   * map.off('click', onClick);
   * ```
   */ var Events = {
        /* @method on(type: String, fn: Function, context?: Object): this
  	 * Adds a listener function (`fn`) to a particular event type of the object. You can optionally specify the context of the listener (object the this keyword will point to). You can also pass several space-separated types (e.g. `'click dblclick'`).
  	 *
  	 * @alternative
  	 * @method on(eventMap: Object): this
  	 * Adds a set of type/listener pairs, e.g. `{click: onClick, mousemove: onMouseMove}`
  	 */ on: function(types, fn, context) {
            // types can be a map of types/handlers
            if (typeof types === "object") for(var type in types)// we don't process space-separated events here for performance;
            // it's a hot path since Layer uses the on(obj) syntax
            this._on(type, types[type], fn);
            else {
                // types can be a string of space-separated words
                types = splitWords(types);
                for(var i = 0, len = types.length; i < len; i++)this._on(types[i], fn, context);
            }
            return this;
        },
        /* @method off(type: String, fn?: Function, context?: Object): this
  	 * Removes a previously added listener function. If no function is specified, it will remove all the listeners of that particular event from the object. Note that if you passed a custom context to `on`, you must pass the same context to `off` in order to remove the listener.
  	 *
  	 * @alternative
  	 * @method off(eventMap: Object): this
  	 * Removes a set of type/listener pairs.
  	 *
  	 * @alternative
  	 * @method off: this
  	 * Removes all listeners to all events on the object. This includes implicitly attached events.
  	 */ off: function(types, fn, context) {
            if (!arguments.length) // clear all listeners if called without arguments
            delete this._events;
            else if (typeof types === "object") for(var type in types)this._off(type, types[type], fn);
            else {
                types = splitWords(types);
                var removeAll = arguments.length === 1;
                for(var i = 0, len = types.length; i < len; i++)if (removeAll) this._off(types[i]);
                else this._off(types[i], fn, context);
            }
            return this;
        },
        // attach listener (without syntactic sugar now)
        _on: function(type, fn, context, _once) {
            if (typeof fn !== "function") {
                console.warn("wrong listener type: " + typeof fn);
                return;
            }
            // check if fn already there
            if (this._listens(type, fn, context) !== false) return;
            if (context === this) // Less memory footprint.
            context = undefined;
            var newListener = {
                fn: fn,
                ctx: context
            };
            if (_once) newListener.once = true;
            this._events = this._events || {};
            this._events[type] = this._events[type] || [];
            this._events[type].push(newListener);
        },
        _off: function(type, fn, context) {
            var listeners, i, len;
            if (!this._events) return;
            listeners = this._events[type];
            if (!listeners) return;
            if (arguments.length === 1) {
                if (this._firingCount) // Set all removed listeners to noop
                // so they are not called if remove happens in fire
                for(i = 0, len = listeners.length; i < len; i++)listeners[i].fn = falseFn;
                // clear all listeners for a type if function isn't specified
                delete this._events[type];
                return;
            }
            if (typeof fn !== "function") {
                console.warn("wrong listener type: " + typeof fn);
                return;
            }
            // find fn and remove it
            var index = this._listens(type, fn, context);
            if (index !== false) {
                var listener = listeners[index];
                if (this._firingCount) {
                    // set the removed listener to noop so that's not called if remove happens in fire
                    listener.fn = falseFn;
                    /* copy array in case events are being fired */ this._events[type] = listeners = listeners.slice();
                }
                listeners.splice(index, 1);
            }
        },
        // @method fire(type: String, data?: Object, propagate?: Boolean): this
        // Fires an event of the specified type. You can optionally provide a data
        // object — the first argument of the listener function will contain its
        // properties. The event can optionally be propagated to event parents.
        fire: function(type, data, propagate) {
            if (!this.listens(type, propagate)) return this;
            var event = extend({}, data, {
                type: type,
                target: this,
                sourceTarget: data && data.sourceTarget || this
            });
            if (this._events) {
                var listeners = this._events[type];
                if (listeners) {
                    this._firingCount = this._firingCount + 1 || 1;
                    for(var i = 0, len = listeners.length; i < len; i++){
                        var l = listeners[i];
                        // off overwrites l.fn, so we need to copy fn to a var
                        var fn = l.fn;
                        if (l.once) this.off(type, fn, l.ctx);
                        fn.call(l.ctx || this, event);
                    }
                    this._firingCount--;
                }
            }
            if (propagate) // propagate the event to parents (set with addEventParent)
            this._propagateEvent(event);
            return this;
        },
        // @method listens(type: String, propagate?: Boolean): Boolean
        // @method listens(type: String, fn: Function, context?: Object, propagate?: Boolean): Boolean
        // Returns `true` if a particular event type has any listeners attached to it.
        // The verification can optionally be propagated, it will return `true` if parents have the listener attached to it.
        listens: function(type, fn, context, propagate) {
            if (typeof type !== "string") console.warn('"string" type argument expected');
            // we don't overwrite the input `fn` value, because we need to use it for propagation
            var _fn = fn;
            if (typeof fn !== "function") {
                propagate = !!fn;
                _fn = undefined;
                context = undefined;
            }
            var listeners = this._events && this._events[type];
            if (listeners && listeners.length) {
                if (this._listens(type, _fn, context) !== false) return true;
            }
            if (propagate) // also check parents for listeners if event propagates
            for(var id in this._eventParents){
                if (this._eventParents[id].listens(type, fn, context, propagate)) return true;
            }
            return false;
        },
        // returns the index (number) or false
        _listens: function(type, fn, context) {
            if (!this._events) return false;
            var listeners = this._events[type] || [];
            if (!fn) return !!listeners.length;
            if (context === this) // Less memory footprint.
            context = undefined;
            for(var i = 0, len = listeners.length; i < len; i++){
                if (listeners[i].fn === fn && listeners[i].ctx === context) return i;
            }
            return false;
        },
        // @method once(…): this
        // Behaves as [`on(…)`](#evented-on), except the listener will only get fired once and then removed.
        once: function(types, fn, context) {
            // types can be a map of types/handlers
            if (typeof types === "object") for(var type in types)// we don't process space-separated events here for performance;
            // it's a hot path since Layer uses the on(obj) syntax
            this._on(type, types[type], fn, true);
            else {
                // types can be a string of space-separated words
                types = splitWords(types);
                for(var i = 0, len = types.length; i < len; i++)this._on(types[i], fn, context, true);
            }
            return this;
        },
        // @method addEventParent(obj: Evented): this
        // Adds an event parent - an `Evented` that will receive propagated events
        addEventParent: function(obj) {
            this._eventParents = this._eventParents || {};
            this._eventParents[stamp(obj)] = obj;
            return this;
        },
        // @method removeEventParent(obj: Evented): this
        // Removes an event parent, so it will stop receiving propagated events
        removeEventParent: function(obj) {
            if (this._eventParents) delete this._eventParents[stamp(obj)];
            return this;
        },
        _propagateEvent: function(e) {
            for(var id in this._eventParents)this._eventParents[id].fire(e.type, extend({
                layer: e.target,
                propagatedFrom: e.target
            }, e), true);
        }
    };
    // aliases; we should ditch those eventually
    // @method addEventListener(…): this
    // Alias to [`on(…)`](#evented-on)
    Events.addEventListener = Events.on;
    // @method removeEventListener(…): this
    // Alias to [`off(…)`](#evented-off)
    // @method clearAllEventListeners(…): this
    // Alias to [`off()`](#evented-off)
    Events.removeEventListener = Events.clearAllEventListeners = Events.off;
    // @method addOneTimeEventListener(…): this
    // Alias to [`once(…)`](#evented-once)
    Events.addOneTimeEventListener = Events.once;
    // @method fireEvent(…): this
    // Alias to [`fire(…)`](#evented-fire)
    Events.fireEvent = Events.fire;
    // @method hasEventListeners(…): Boolean
    // Alias to [`listens(…)`](#evented-listens)
    Events.hasEventListeners = Events.listens;
    var Evented = Class.extend(Events);
    /*
   * @class Point
   * @aka L.Point
   *
   * Represents a point with `x` and `y` coordinates in pixels.
   *
   * @example
   *
   * ```js
   * var point = L.point(200, 300);
   * ```
   *
   * All Leaflet methods and options that accept `Point` objects also accept them in a simple Array form (unless noted otherwise), so these lines are equivalent:
   *
   * ```js
   * map.panBy([200, 300]);
   * map.panBy(L.point(200, 300));
   * ```
   *
   * Note that `Point` does not inherit from Leaflet's `Class` object,
   * which means new classes can't inherit from it, and new methods
   * can't be added to it with the `include` function.
   */ function Point(x, y, round) {
        // @property x: Number; The `x` coordinate of the point
        this.x = round ? Math.round(x) : x;
        // @property y: Number; The `y` coordinate of the point
        this.y = round ? Math.round(y) : y;
    }
    var trunc = Math.trunc || function(v) {
        return v > 0 ? Math.floor(v) : Math.ceil(v);
    };
    Point.prototype = {
        // @method clone(): Point
        // Returns a copy of the current point.
        clone: function() {
            return new Point(this.x, this.y);
        },
        // @method add(otherPoint: Point): Point
        // Returns the result of addition of the current and the given points.
        add: function(point) {
            // non-destructive, returns a new point
            return this.clone()._add(toPoint(point));
        },
        _add: function(point) {
            // destructive, used directly for performance in situations where it's safe to modify existing point
            this.x += point.x;
            this.y += point.y;
            return this;
        },
        // @method subtract(otherPoint: Point): Point
        // Returns the result of subtraction of the given point from the current.
        subtract: function(point) {
            return this.clone()._subtract(toPoint(point));
        },
        _subtract: function(point) {
            this.x -= point.x;
            this.y -= point.y;
            return this;
        },
        // @method divideBy(num: Number): Point
        // Returns the result of division of the current point by the given number.
        divideBy: function(num) {
            return this.clone()._divideBy(num);
        },
        _divideBy: function(num) {
            this.x /= num;
            this.y /= num;
            return this;
        },
        // @method multiplyBy(num: Number): Point
        // Returns the result of multiplication of the current point by the given number.
        multiplyBy: function(num) {
            return this.clone()._multiplyBy(num);
        },
        _multiplyBy: function(num) {
            this.x *= num;
            this.y *= num;
            return this;
        },
        // @method scaleBy(scale: Point): Point
        // Multiply each coordinate of the current point by each coordinate of
        // `scale`. In linear algebra terms, multiply the point by the
        // [scaling matrix](https://en.wikipedia.org/wiki/Scaling_%28geometry%29#Matrix_representation)
        // defined by `scale`.
        scaleBy: function(point) {
            return new Point(this.x * point.x, this.y * point.y);
        },
        // @method unscaleBy(scale: Point): Point
        // Inverse of `scaleBy`. Divide each coordinate of the current point by
        // each coordinate of `scale`.
        unscaleBy: function(point) {
            return new Point(this.x / point.x, this.y / point.y);
        },
        // @method round(): Point
        // Returns a copy of the current point with rounded coordinates.
        round: function() {
            return this.clone()._round();
        },
        _round: function() {
            this.x = Math.round(this.x);
            this.y = Math.round(this.y);
            return this;
        },
        // @method floor(): Point
        // Returns a copy of the current point with floored coordinates (rounded down).
        floor: function() {
            return this.clone()._floor();
        },
        _floor: function() {
            this.x = Math.floor(this.x);
            this.y = Math.floor(this.y);
            return this;
        },
        // @method ceil(): Point
        // Returns a copy of the current point with ceiled coordinates (rounded up).
        ceil: function() {
            return this.clone()._ceil();
        },
        _ceil: function() {
            this.x = Math.ceil(this.x);
            this.y = Math.ceil(this.y);
            return this;
        },
        // @method trunc(): Point
        // Returns a copy of the current point with truncated coordinates (rounded towards zero).
        trunc: function() {
            return this.clone()._trunc();
        },
        _trunc: function() {
            this.x = trunc(this.x);
            this.y = trunc(this.y);
            return this;
        },
        // @method distanceTo(otherPoint: Point): Number
        // Returns the cartesian distance between the current and the given points.
        distanceTo: function(point) {
            point = toPoint(point);
            var x = point.x - this.x, y = point.y - this.y;
            return Math.sqrt(x * x + y * y);
        },
        // @method equals(otherPoint: Point): Boolean
        // Returns `true` if the given point has the same coordinates.
        equals: function(point) {
            point = toPoint(point);
            return point.x === this.x && point.y === this.y;
        },
        // @method contains(otherPoint: Point): Boolean
        // Returns `true` if both coordinates of the given point are less than the corresponding current point coordinates (in absolute values).
        contains: function(point) {
            point = toPoint(point);
            return Math.abs(point.x) <= Math.abs(this.x) && Math.abs(point.y) <= Math.abs(this.y);
        },
        // @method toString(): String
        // Returns a string representation of the point for debugging purposes.
        toString: function() {
            return "Point(" + formatNum(this.x) + ", " + formatNum(this.y) + ")";
        }
    };
    // @factory L.point(x: Number, y: Number, round?: Boolean)
    // Creates a Point object with the given `x` and `y` coordinates. If optional `round` is set to true, rounds the `x` and `y` values.
    // @alternative
    // @factory L.point(coords: Number[])
    // Expects an array of the form `[x, y]` instead.
    // @alternative
    // @factory L.point(coords: Object)
    // Expects a plain object of the form `{x: Number, y: Number}` instead.
    function toPoint(x, y, round) {
        if (x instanceof Point) return x;
        if (isArray(x)) return new Point(x[0], x[1]);
        if (x === undefined || x === null) return x;
        if (typeof x === "object" && "x" in x && "y" in x) return new Point(x.x, x.y);
        return new Point(x, y, round);
    }
    /*
   * @class Bounds
   * @aka L.Bounds
   *
   * Represents a rectangular area in pixel coordinates.
   *
   * @example
   *
   * ```js
   * var p1 = L.point(10, 10),
   * p2 = L.point(40, 60),
   * bounds = L.bounds(p1, p2);
   * ```
   *
   * All Leaflet methods that accept `Bounds` objects also accept them in a simple Array form (unless noted otherwise), so the bounds example above can be passed like this:
   *
   * ```js
   * otherBounds.intersects([[10, 10], [40, 60]]);
   * ```
   *
   * Note that `Bounds` does not inherit from Leaflet's `Class` object,
   * which means new classes can't inherit from it, and new methods
   * can't be added to it with the `include` function.
   */ function Bounds(a, b) {
        if (!a) return;
        var points = b ? [
            a,
            b
        ] : a;
        for(var i = 0, len = points.length; i < len; i++)this.extend(points[i]);
    }
    Bounds.prototype = {
        // @method extend(point: Point): this
        // Extends the bounds to contain the given point.
        // @alternative
        // @method extend(otherBounds: Bounds): this
        // Extend the bounds to contain the given bounds
        extend: function(obj) {
            var min2, max2;
            if (!obj) return this;
            if (obj instanceof Point || typeof obj[0] === "number" || "x" in obj) min2 = max2 = toPoint(obj);
            else {
                obj = toBounds(obj);
                min2 = obj.min;
                max2 = obj.max;
                if (!min2 || !max2) return this;
            }
            // @property min: Point
            // The top left corner of the rectangle.
            // @property max: Point
            // The bottom right corner of the rectangle.
            if (!this.min && !this.max) {
                this.min = min2.clone();
                this.max = max2.clone();
            } else {
                this.min.x = Math.min(min2.x, this.min.x);
                this.max.x = Math.max(max2.x, this.max.x);
                this.min.y = Math.min(min2.y, this.min.y);
                this.max.y = Math.max(max2.y, this.max.y);
            }
            return this;
        },
        // @method getCenter(round?: Boolean): Point
        // Returns the center point of the bounds.
        getCenter: function(round) {
            return toPoint((this.min.x + this.max.x) / 2, (this.min.y + this.max.y) / 2, round);
        },
        // @method getBottomLeft(): Point
        // Returns the bottom-left point of the bounds.
        getBottomLeft: function() {
            return toPoint(this.min.x, this.max.y);
        },
        // @method getTopRight(): Point
        // Returns the top-right point of the bounds.
        getTopRight: function() {
            return toPoint(this.max.x, this.min.y);
        },
        // @method getTopLeft(): Point
        // Returns the top-left point of the bounds (i.e. [`this.min`](#bounds-min)).
        getTopLeft: function() {
            return this.min; // left, top
        },
        // @method getBottomRight(): Point
        // Returns the bottom-right point of the bounds (i.e. [`this.max`](#bounds-max)).
        getBottomRight: function() {
            return this.max; // right, bottom
        },
        // @method getSize(): Point
        // Returns the size of the given bounds
        getSize: function() {
            return this.max.subtract(this.min);
        },
        // @method contains(otherBounds: Bounds): Boolean
        // Returns `true` if the rectangle contains the given one.
        // @alternative
        // @method contains(point: Point): Boolean
        // Returns `true` if the rectangle contains the given point.
        contains: function(obj) {
            var min, max;
            if (typeof obj[0] === "number" || obj instanceof Point) obj = toPoint(obj);
            else obj = toBounds(obj);
            if (obj instanceof Bounds) {
                min = obj.min;
                max = obj.max;
            } else min = max = obj;
            return min.x >= this.min.x && max.x <= this.max.x && min.y >= this.min.y && max.y <= this.max.y;
        },
        // @method intersects(otherBounds: Bounds): Boolean
        // Returns `true` if the rectangle intersects the given bounds. Two bounds
        // intersect if they have at least one point in common.
        intersects: function(bounds) {
            bounds = toBounds(bounds);
            var min = this.min, max = this.max, min2 = bounds.min, max2 = bounds.max, xIntersects = max2.x >= min.x && min2.x <= max.x, yIntersects = max2.y >= min.y && min2.y <= max.y;
            return xIntersects && yIntersects;
        },
        // @method overlaps(otherBounds: Bounds): Boolean
        // Returns `true` if the rectangle overlaps the given bounds. Two bounds
        // overlap if their intersection is an area.
        overlaps: function(bounds) {
            bounds = toBounds(bounds);
            var min = this.min, max = this.max, min2 = bounds.min, max2 = bounds.max, xOverlaps = max2.x > min.x && min2.x < max.x, yOverlaps = max2.y > min.y && min2.y < max.y;
            return xOverlaps && yOverlaps;
        },
        // @method isValid(): Boolean
        // Returns `true` if the bounds are properly initialized.
        isValid: function() {
            return !!(this.min && this.max);
        },
        // @method pad(bufferRatio: Number): Bounds
        // Returns bounds created by extending or retracting the current bounds by a given ratio in each direction.
        // For example, a ratio of 0.5 extends the bounds by 50% in each direction.
        // Negative values will retract the bounds.
        pad: function(bufferRatio) {
            var min = this.min, max = this.max, heightBuffer = Math.abs(min.x - max.x) * bufferRatio, widthBuffer = Math.abs(min.y - max.y) * bufferRatio;
            return toBounds(toPoint(min.x - heightBuffer, min.y - widthBuffer), toPoint(max.x + heightBuffer, max.y + widthBuffer));
        },
        // @method equals(otherBounds: Bounds): Boolean
        // Returns `true` if the rectangle is equivalent to the given bounds.
        equals: function(bounds) {
            if (!bounds) return false;
            bounds = toBounds(bounds);
            return this.min.equals(bounds.getTopLeft()) && this.max.equals(bounds.getBottomRight());
        }
    };
    // @factory L.bounds(corner1: Point, corner2: Point)
    // Creates a Bounds object from two corners coordinate pairs.
    // @alternative
    // @factory L.bounds(points: Point[])
    // Creates a Bounds object from the given array of points.
    function toBounds(a, b) {
        if (!a || a instanceof Bounds) return a;
        return new Bounds(a, b);
    }
    /*
   * @class LatLngBounds
   * @aka L.LatLngBounds
   *
   * Represents a rectangular geographical area on a map.
   *
   * @example
   *
   * ```js
   * var corner1 = L.latLng(40.712, -74.227),
   * corner2 = L.latLng(40.774, -74.125),
   * bounds = L.latLngBounds(corner1, corner2);
   * ```
   *
   * All Leaflet methods that accept LatLngBounds objects also accept them in a simple Array form (unless noted otherwise), so the bounds example above can be passed like this:
   *
   * ```js
   * map.fitBounds([
   * 	[40.712, -74.227],
   * 	[40.774, -74.125]
   * ]);
   * ```
   *
   * Caution: if the area crosses the antimeridian (often confused with the International Date Line), you must specify corners _outside_ the [-180, 180] degrees longitude range.
   *
   * Note that `LatLngBounds` does not inherit from Leaflet's `Class` object,
   * which means new classes can't inherit from it, and new methods
   * can't be added to it with the `include` function.
   */ function LatLngBounds(corner1, corner2) {
        if (!corner1) return;
        var latlngs = corner2 ? [
            corner1,
            corner2
        ] : corner1;
        for(var i = 0, len = latlngs.length; i < len; i++)this.extend(latlngs[i]);
    }
    LatLngBounds.prototype = {
        // @method extend(latlng: LatLng): this
        // Extend the bounds to contain the given point
        // @alternative
        // @method extend(otherBounds: LatLngBounds): this
        // Extend the bounds to contain the given bounds
        extend: function(obj) {
            var sw = this._southWest, ne = this._northEast, sw2, ne2;
            if (obj instanceof LatLng) {
                sw2 = obj;
                ne2 = obj;
            } else if (obj instanceof LatLngBounds) {
                sw2 = obj._southWest;
                ne2 = obj._northEast;
                if (!sw2 || !ne2) return this;
            } else return obj ? this.extend(toLatLng(obj) || toLatLngBounds(obj)) : this;
            if (!sw && !ne) {
                this._southWest = new LatLng(sw2.lat, sw2.lng);
                this._northEast = new LatLng(ne2.lat, ne2.lng);
            } else {
                sw.lat = Math.min(sw2.lat, sw.lat);
                sw.lng = Math.min(sw2.lng, sw.lng);
                ne.lat = Math.max(ne2.lat, ne.lat);
                ne.lng = Math.max(ne2.lng, ne.lng);
            }
            return this;
        },
        // @method pad(bufferRatio: Number): LatLngBounds
        // Returns bounds created by extending or retracting the current bounds by a given ratio in each direction.
        // For example, a ratio of 0.5 extends the bounds by 50% in each direction.
        // Negative values will retract the bounds.
        pad: function(bufferRatio) {
            var sw = this._southWest, ne = this._northEast, heightBuffer = Math.abs(sw.lat - ne.lat) * bufferRatio, widthBuffer = Math.abs(sw.lng - ne.lng) * bufferRatio;
            return new LatLngBounds(new LatLng(sw.lat - heightBuffer, sw.lng - widthBuffer), new LatLng(ne.lat + heightBuffer, ne.lng + widthBuffer));
        },
        // @method getCenter(): LatLng
        // Returns the center point of the bounds.
        getCenter: function() {
            return new LatLng((this._southWest.lat + this._northEast.lat) / 2, (this._southWest.lng + this._northEast.lng) / 2);
        },
        // @method getSouthWest(): LatLng
        // Returns the south-west point of the bounds.
        getSouthWest: function() {
            return this._southWest;
        },
        // @method getNorthEast(): LatLng
        // Returns the north-east point of the bounds.
        getNorthEast: function() {
            return this._northEast;
        },
        // @method getNorthWest(): LatLng
        // Returns the north-west point of the bounds.
        getNorthWest: function() {
            return new LatLng(this.getNorth(), this.getWest());
        },
        // @method getSouthEast(): LatLng
        // Returns the south-east point of the bounds.
        getSouthEast: function() {
            return new LatLng(this.getSouth(), this.getEast());
        },
        // @method getWest(): Number
        // Returns the west longitude of the bounds
        getWest: function() {
            return this._southWest.lng;
        },
        // @method getSouth(): Number
        // Returns the south latitude of the bounds
        getSouth: function() {
            return this._southWest.lat;
        },
        // @method getEast(): Number
        // Returns the east longitude of the bounds
        getEast: function() {
            return this._northEast.lng;
        },
        // @method getNorth(): Number
        // Returns the north latitude of the bounds
        getNorth: function() {
            return this._northEast.lat;
        },
        // @method contains(otherBounds: LatLngBounds): Boolean
        // Returns `true` if the rectangle contains the given one.
        // @alternative
        // @method contains (latlng: LatLng): Boolean
        // Returns `true` if the rectangle contains the given point.
        contains: function(obj) {
            if (typeof obj[0] === "number" || obj instanceof LatLng || "lat" in obj) obj = toLatLng(obj);
            else obj = toLatLngBounds(obj);
            var sw = this._southWest, ne = this._northEast, sw2, ne2;
            if (obj instanceof LatLngBounds) {
                sw2 = obj.getSouthWest();
                ne2 = obj.getNorthEast();
            } else sw2 = ne2 = obj;
            return sw2.lat >= sw.lat && ne2.lat <= ne.lat && sw2.lng >= sw.lng && ne2.lng <= ne.lng;
        },
        // @method intersects(otherBounds: LatLngBounds): Boolean
        // Returns `true` if the rectangle intersects the given bounds. Two bounds intersect if they have at least one point in common.
        intersects: function(bounds) {
            bounds = toLatLngBounds(bounds);
            var sw = this._southWest, ne = this._northEast, sw2 = bounds.getSouthWest(), ne2 = bounds.getNorthEast(), latIntersects = ne2.lat >= sw.lat && sw2.lat <= ne.lat, lngIntersects = ne2.lng >= sw.lng && sw2.lng <= ne.lng;
            return latIntersects && lngIntersects;
        },
        // @method overlaps(otherBounds: LatLngBounds): Boolean
        // Returns `true` if the rectangle overlaps the given bounds. Two bounds overlap if their intersection is an area.
        overlaps: function(bounds) {
            bounds = toLatLngBounds(bounds);
            var sw = this._southWest, ne = this._northEast, sw2 = bounds.getSouthWest(), ne2 = bounds.getNorthEast(), latOverlaps = ne2.lat > sw.lat && sw2.lat < ne.lat, lngOverlaps = ne2.lng > sw.lng && sw2.lng < ne.lng;
            return latOverlaps && lngOverlaps;
        },
        // @method toBBoxString(): String
        // Returns a string with bounding box coordinates in a 'southwest_lng,southwest_lat,northeast_lng,northeast_lat' format. Useful for sending requests to web services that return geo data.
        toBBoxString: function() {
            return [
                this.getWest(),
                this.getSouth(),
                this.getEast(),
                this.getNorth()
            ].join(",");
        },
        // @method equals(otherBounds: LatLngBounds, maxMargin?: Number): Boolean
        // Returns `true` if the rectangle is equivalent (within a small margin of error) to the given bounds. The margin of error can be overridden by setting `maxMargin` to a small number.
        equals: function(bounds, maxMargin) {
            if (!bounds) return false;
            bounds = toLatLngBounds(bounds);
            return this._southWest.equals(bounds.getSouthWest(), maxMargin) && this._northEast.equals(bounds.getNorthEast(), maxMargin);
        },
        // @method isValid(): Boolean
        // Returns `true` if the bounds are properly initialized.
        isValid: function() {
            return !!(this._southWest && this._northEast);
        }
    };
    // TODO International date line?
    // @factory L.latLngBounds(corner1: LatLng, corner2: LatLng)
    // Creates a `LatLngBounds` object by defining two diagonally opposite corners of the rectangle.
    // @alternative
    // @factory L.latLngBounds(latlngs: LatLng[])
    // Creates a `LatLngBounds` object defined by the geographical points it contains. Very useful for zooming the map to fit a particular set of locations with [`fitBounds`](#map-fitbounds).
    function toLatLngBounds(a, b) {
        if (a instanceof LatLngBounds) return a;
        return new LatLngBounds(a, b);
    }
    /* @class LatLng
   * @aka L.LatLng
   *
   * Represents a geographical point with a certain latitude and longitude.
   *
   * @example
   *
   * ```
   * var latlng = L.latLng(50.5, 30.5);
   * ```
   *
   * All Leaflet methods that accept LatLng objects also accept them in a simple Array form and simple object form (unless noted otherwise), so these lines are equivalent:
   *
   * ```
   * map.panTo([50, 30]);
   * map.panTo({lon: 30, lat: 50});
   * map.panTo({lat: 50, lng: 30});
   * map.panTo(L.latLng(50, 30));
   * ```
   *
   * Note that `LatLng` does not inherit from Leaflet's `Class` object,
   * which means new classes can't inherit from it, and new methods
   * can't be added to it with the `include` function.
   */ function LatLng(lat, lng, alt) {
        if (isNaN(lat) || isNaN(lng)) throw new Error("Invalid LatLng object: (" + lat + ", " + lng + ")");
        // @property lat: Number
        // Latitude in degrees
        this.lat = +lat;
        // @property lng: Number
        // Longitude in degrees
        this.lng = +lng;
        // @property alt: Number
        // Altitude in meters (optional)
        if (alt !== undefined) this.alt = +alt;
    }
    LatLng.prototype = {
        // @method equals(otherLatLng: LatLng, maxMargin?: Number): Boolean
        // Returns `true` if the given `LatLng` point is at the same position (within a small margin of error). The margin of error can be overridden by setting `maxMargin` to a small number.
        equals: function(obj, maxMargin) {
            if (!obj) return false;
            obj = toLatLng(obj);
            var margin = Math.max(Math.abs(this.lat - obj.lat), Math.abs(this.lng - obj.lng));
            return margin <= (maxMargin === undefined ? 1.0E-9 : maxMargin);
        },
        // @method toString(): String
        // Returns a string representation of the point (for debugging purposes).
        toString: function(precision) {
            return "LatLng(" + formatNum(this.lat, precision) + ", " + formatNum(this.lng, precision) + ")";
        },
        // @method distanceTo(otherLatLng: LatLng): Number
        // Returns the distance (in meters) to the given `LatLng` calculated using the [Spherical Law of Cosines](https://en.wikipedia.org/wiki/Spherical_law_of_cosines).
        distanceTo: function(other) {
            return Earth.distance(this, toLatLng(other));
        },
        // @method wrap(): LatLng
        // Returns a new `LatLng` object with the longitude wrapped so it's always between -180 and +180 degrees.
        wrap: function() {
            return Earth.wrapLatLng(this);
        },
        // @method toBounds(sizeInMeters: Number): LatLngBounds
        // Returns a new `LatLngBounds` object in which each boundary is `sizeInMeters/2` meters apart from the `LatLng`.
        toBounds: function(sizeInMeters) {
            var latAccuracy = 180 * sizeInMeters / 40075017, lngAccuracy = latAccuracy / Math.cos(Math.PI / 180 * this.lat);
            return toLatLngBounds([
                this.lat - latAccuracy,
                this.lng - lngAccuracy
            ], [
                this.lat + latAccuracy,
                this.lng + lngAccuracy
            ]);
        },
        clone: function() {
            return new LatLng(this.lat, this.lng, this.alt);
        }
    };
    // @factory L.latLng(latitude: Number, longitude: Number, altitude?: Number): LatLng
    // Creates an object representing a geographical point with the given latitude and longitude (and optionally altitude).
    // @alternative
    // @factory L.latLng(coords: Array): LatLng
    // Expects an array of the form `[Number, Number]` or `[Number, Number, Number]` instead.
    // @alternative
    // @factory L.latLng(coords: Object): LatLng
    // Expects an plain object of the form `{lat: Number, lng: Number}` or `{lat: Number, lng: Number, alt: Number}` instead.
    function toLatLng(a, b, c) {
        if (a instanceof LatLng) return a;
        if (isArray(a) && typeof a[0] !== "object") {
            if (a.length === 3) return new LatLng(a[0], a[1], a[2]);
            if (a.length === 2) return new LatLng(a[0], a[1]);
            return null;
        }
        if (a === undefined || a === null) return a;
        if (typeof a === "object" && "lat" in a) return new LatLng(a.lat, "lng" in a ? a.lng : a.lon, a.alt);
        if (b === undefined) return null;
        return new LatLng(a, b, c);
    }
    /*
   * @namespace CRS
   * @crs L.CRS.Base
   * Object that defines coordinate reference systems for projecting
   * geographical points into pixel (screen) coordinates and back (and to
   * coordinates in other units for [WMS](https://en.wikipedia.org/wiki/Web_Map_Service) services). See
   * [spatial reference system](https://en.wikipedia.org/wiki/Spatial_reference_system).
   *
   * Leaflet defines the most usual CRSs by default. If you want to use a
   * CRS not defined by default, take a look at the
   * [Proj4Leaflet](https://github.com/kartena/Proj4Leaflet) plugin.
   *
   * Note that the CRS instances do not inherit from Leaflet's `Class` object,
   * and can't be instantiated. Also, new classes can't inherit from them,
   * and methods can't be added to them with the `include` function.
   */ var CRS = {
        // @method latLngToPoint(latlng: LatLng, zoom: Number): Point
        // Projects geographical coordinates into pixel coordinates for a given zoom.
        latLngToPoint: function(latlng, zoom) {
            var projectedPoint = this.projection.project(latlng), scale = this.scale(zoom);
            return this.transformation._transform(projectedPoint, scale);
        },
        // @method pointToLatLng(point: Point, zoom: Number): LatLng
        // The inverse of `latLngToPoint`. Projects pixel coordinates on a given
        // zoom into geographical coordinates.
        pointToLatLng: function(point, zoom) {
            var scale = this.scale(zoom), untransformedPoint = this.transformation.untransform(point, scale);
            return this.projection.unproject(untransformedPoint);
        },
        // @method project(latlng: LatLng): Point
        // Projects geographical coordinates into coordinates in units accepted for
        // this CRS (e.g. meters for EPSG:3857, for passing it to WMS services).
        project: function(latlng) {
            return this.projection.project(latlng);
        },
        // @method unproject(point: Point): LatLng
        // Given a projected coordinate returns the corresponding LatLng.
        // The inverse of `project`.
        unproject: function(point) {
            return this.projection.unproject(point);
        },
        // @method scale(zoom: Number): Number
        // Returns the scale used when transforming projected coordinates into
        // pixel coordinates for a particular zoom. For example, it returns
        // `256 * 2^zoom` for Mercator-based CRS.
        scale: function(zoom) {
            return 256 * Math.pow(2, zoom);
        },
        // @method zoom(scale: Number): Number
        // Inverse of `scale()`, returns the zoom level corresponding to a scale
        // factor of `scale`.
        zoom: function(scale) {
            return Math.log(scale / 256) / Math.LN2;
        },
        // @method getProjectedBounds(zoom: Number): Bounds
        // Returns the projection's bounds scaled and transformed for the provided `zoom`.
        getProjectedBounds: function(zoom) {
            if (this.infinite) return null;
            var b = this.projection.bounds, s = this.scale(zoom), min = this.transformation.transform(b.min, s), max = this.transformation.transform(b.max, s);
            return new Bounds(min, max);
        },
        // @method distance(latlng1: LatLng, latlng2: LatLng): Number
        // Returns the distance between two geographical coordinates.
        // @property code: String
        // Standard code name of the CRS passed into WMS services (e.g. `'EPSG:3857'`)
        //
        // @property wrapLng: Number[]
        // An array of two numbers defining whether the longitude (horizontal) coordinate
        // axis wraps around a given range and how. Defaults to `[-180, 180]` in most
        // geographical CRSs. If `undefined`, the longitude axis does not wrap around.
        //
        // @property wrapLat: Number[]
        // Like `wrapLng`, but for the latitude (vertical) axis.
        // wrapLng: [min, max],
        // wrapLat: [min, max],
        // @property infinite: Boolean
        // If true, the coordinate space will be unbounded (infinite in both axes)
        infinite: false,
        // @method wrapLatLng(latlng: LatLng): LatLng
        // Returns a `LatLng` where lat and lng has been wrapped according to the
        // CRS's `wrapLat` and `wrapLng` properties, if they are outside the CRS's bounds.
        wrapLatLng: function(latlng) {
            var lng = this.wrapLng ? wrapNum(latlng.lng, this.wrapLng, true) : latlng.lng, lat = this.wrapLat ? wrapNum(latlng.lat, this.wrapLat, true) : latlng.lat, alt = latlng.alt;
            return new LatLng(lat, lng, alt);
        },
        // @method wrapLatLngBounds(bounds: LatLngBounds): LatLngBounds
        // Returns a `LatLngBounds` with the same size as the given one, ensuring
        // that its center is within the CRS's bounds.
        // Only accepts actual `L.LatLngBounds` instances, not arrays.
        wrapLatLngBounds: function(bounds) {
            var center = bounds.getCenter(), newCenter = this.wrapLatLng(center), latShift = center.lat - newCenter.lat, lngShift = center.lng - newCenter.lng;
            if (latShift === 0 && lngShift === 0) return bounds;
            var sw = bounds.getSouthWest(), ne = bounds.getNorthEast(), newSw = new LatLng(sw.lat - latShift, sw.lng - lngShift), newNe = new LatLng(ne.lat - latShift, ne.lng - lngShift);
            return new LatLngBounds(newSw, newNe);
        }
    };
    /*
   * @namespace CRS
   * @crs L.CRS.Earth
   *
   * Serves as the base for CRS that are global such that they cover the earth.
   * Can only be used as the base for other CRS and cannot be used directly,
   * since it does not have a `code`, `projection` or `transformation`. `distance()` returns
   * meters.
   */ var Earth = extend({}, CRS, {
        wrapLng: [
            -180,
            180
        ],
        // Mean Earth Radius, as recommended for use by
        // the International Union of Geodesy and Geophysics,
        // see https://rosettacode.org/wiki/Haversine_formula
        R: 6371000,
        // distance between two geographical points using spherical law of cosines approximation
        distance: function(latlng1, latlng2) {
            var rad = Math.PI / 180, lat1 = latlng1.lat * rad, lat2 = latlng2.lat * rad, sinDLat = Math.sin((latlng2.lat - latlng1.lat) * rad / 2), sinDLon = Math.sin((latlng2.lng - latlng1.lng) * rad / 2), a = sinDLat * sinDLat + Math.cos(lat1) * Math.cos(lat2) * sinDLon * sinDLon, c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
            return this.R * c;
        }
    });
    /*
   * @namespace Projection
   * @projection L.Projection.SphericalMercator
   *
   * Spherical Mercator projection — the most common projection for online maps,
   * used by almost all free and commercial tile providers. Assumes that Earth is
   * a sphere. Used by the `EPSG:3857` CRS.
   */ var earthRadius = 6378137;
    var SphericalMercator = {
        R: earthRadius,
        MAX_LATITUDE: 85.0511287798,
        project: function(latlng) {
            var d = Math.PI / 180, max = this.MAX_LATITUDE, lat = Math.max(Math.min(max, latlng.lat), -max), sin = Math.sin(lat * d);
            return new Point(this.R * latlng.lng * d, this.R * Math.log((1 + sin) / (1 - sin)) / 2);
        },
        unproject: function(point) {
            var d = 180 / Math.PI;
            return new LatLng((2 * Math.atan(Math.exp(point.y / this.R)) - Math.PI / 2) * d, point.x * d / this.R);
        },
        bounds: function() {
            var d = earthRadius * Math.PI;
            return new Bounds([
                -d,
                -d
            ], [
                d,
                d
            ]);
        }()
    };
    /*
   * @class Transformation
   * @aka L.Transformation
   *
   * Represents an affine transformation: a set of coefficients `a`, `b`, `c`, `d`
   * for transforming a point of a form `(x, y)` into `(a*x + b, c*y + d)` and doing
   * the reverse. Used by Leaflet in its projections code.
   *
   * @example
   *
   * ```js
   * var transformation = L.transformation(2, 5, -1, 10),
   * 	p = L.point(1, 2),
   * 	p2 = transformation.transform(p), //  L.point(7, 8)
   * 	p3 = transformation.untransform(p2); //  L.point(1, 2)
   * ```
   */ // factory new L.Transformation(a: Number, b: Number, c: Number, d: Number)
    // Creates a `Transformation` object with the given coefficients.
    function Transformation(a, b, c, d) {
        if (isArray(a)) {
            // use array properties
            this._a = a[0];
            this._b = a[1];
            this._c = a[2];
            this._d = a[3];
            return;
        }
        this._a = a;
        this._b = b;
        this._c = c;
        this._d = d;
    }
    Transformation.prototype = {
        // @method transform(point: Point, scale?: Number): Point
        // Returns a transformed point, optionally multiplied by the given scale.
        // Only accepts actual `L.Point` instances, not arrays.
        transform: function(point, scale) {
            return this._transform(point.clone(), scale);
        },
        // destructive transform (faster)
        _transform: function(point, scale) {
            scale = scale || 1;
            point.x = scale * (this._a * point.x + this._b);
            point.y = scale * (this._c * point.y + this._d);
            return point;
        },
        // @method untransform(point: Point, scale?: Number): Point
        // Returns the reverse transformation of the given point, optionally divided
        // by the given scale. Only accepts actual `L.Point` instances, not arrays.
        untransform: function(point, scale) {
            scale = scale || 1;
            return new Point((point.x / scale - this._b) / this._a, (point.y / scale - this._d) / this._c);
        }
    };
    // factory L.transformation(a: Number, b: Number, c: Number, d: Number)
    // @factory L.transformation(a: Number, b: Number, c: Number, d: Number)
    // Instantiates a Transformation object with the given coefficients.
    // @alternative
    // @factory L.transformation(coefficients: Array): Transformation
    // Expects an coefficients array of the form
    // `[a: Number, b: Number, c: Number, d: Number]`.
    function toTransformation(a, b, c, d) {
        return new Transformation(a, b, c, d);
    }
    /*
   * @namespace CRS
   * @crs L.CRS.EPSG3857
   *
   * The most common CRS for online maps, used by almost all free and commercial
   * tile providers. Uses Spherical Mercator projection. Set in by default in
   * Map's `crs` option.
   */ var EPSG3857 = extend({}, Earth, {
        code: "EPSG:3857",
        projection: SphericalMercator,
        transformation: function() {
            var scale = 0.5 / (Math.PI * SphericalMercator.R);
            return toTransformation(scale, 0.5, -scale, 0.5);
        }()
    });
    var EPSG900913 = extend({}, EPSG3857, {
        code: "EPSG:900913"
    });
    // @namespace SVG; @section
    // There are several static functions which can be called without instantiating L.SVG:
    // @function create(name: String): SVGElement
    // Returns a instance of [SVGElement](https://developer.mozilla.org/docs/Web/API/SVGElement),
    // corresponding to the class name passed. For example, using 'line' will return
    // an instance of [SVGLineElement](https://developer.mozilla.org/docs/Web/API/SVGLineElement).
    function svgCreate(name) {
        return document.createElementNS("http://www.w3.org/2000/svg", name);
    }
    // @function pointsToPath(rings: Point[], closed: Boolean): String
    // Generates a SVG path string for multiple rings, with each ring turning
    // into "M..L..L.." instructions
    function pointsToPath(rings, closed) {
        var str = "", i, j, len, len2, points, p;
        for(i = 0, len = rings.length; i < len; i++){
            points = rings[i];
            for(j = 0, len2 = points.length; j < len2; j++){
                p = points[j];
                str += (j ? "L" : "M") + p.x + " " + p.y;
            }
            // closes the ring for polygons; "x" is VML syntax
            str += closed ? Browser.svg ? "z" : "x" : "";
        }
        // SVG complains about empty path strings
        return str || "M0 0";
    }
    /*
   * @namespace Browser
   * @aka L.Browser
   *
   * A namespace with static properties for browser/feature detection used by Leaflet internally.
   *
   * @example
   *
   * ```js
   * if (L.Browser.ielt9) {
   *   alert('Upgrade your browser, dude!');
   * }
   * ```
   */ var style = document.documentElement.style;
    // @property ie: Boolean; `true` for all Internet Explorer versions (not Edge).
    var ie = "ActiveXObject" in window;
    // @property ielt9: Boolean; `true` for Internet Explorer versions less than 9.
    var ielt9 = ie && !document.addEventListener;
    // @property edge: Boolean; `true` for the Edge web browser.
    var edge = "msLaunchUri" in navigator && !("documentMode" in document);
    // @property webkit: Boolean;
    // `true` for webkit-based browsers like Chrome and Safari (including mobile versions).
    var webkit = userAgentContains("webkit");
    // @property android: Boolean
    // **Deprecated.** `true` for any browser running on an Android platform.
    var android = userAgentContains("android");
    // @property android23: Boolean; **Deprecated.** `true` for browsers running on Android 2 or Android 3.
    var android23 = userAgentContains("android 2") || userAgentContains("android 3");
    /* See https://stackoverflow.com/a/17961266 for details on detecting stock Android */ var webkitVer = parseInt(/WebKit\/([0-9]+)|$/.exec(navigator.userAgent)[1], 10); // also matches AppleWebKit
    // @property androidStock: Boolean; **Deprecated.** `true` for the Android stock browser (i.e. not Chrome)
    var androidStock = android && userAgentContains("Google") && webkitVer < 537 && !("AudioNode" in window);
    // @property opera: Boolean; `true` for the Opera browser
    var opera = !!window.opera;
    // @property chrome: Boolean; `true` for the Chrome browser.
    var chrome = !edge && userAgentContains("chrome");
    // @property gecko: Boolean; `true` for gecko-based browsers like Firefox.
    var gecko = userAgentContains("gecko") && !webkit && !opera && !ie;
    // @property safari: Boolean; `true` for the Safari browser.
    var safari = !chrome && userAgentContains("safari");
    var phantom = userAgentContains("phantom");
    // @property opera12: Boolean
    // `true` for the Opera browser supporting CSS transforms (version 12 or later).
    var opera12 = "OTransition" in style;
    // @property win: Boolean; `true` when the browser is running in a Windows platform
    var win = navigator.platform.indexOf("Win") === 0;
    // @property ie3d: Boolean; `true` for all Internet Explorer versions supporting CSS transforms.
    var ie3d = ie && "transition" in style;
    // @property webkit3d: Boolean; `true` for webkit-based browsers supporting CSS transforms.
    var webkit3d = "WebKitCSSMatrix" in window && "m11" in new window.WebKitCSSMatrix() && !android23;
    // @property gecko3d: Boolean; `true` for gecko-based browsers supporting CSS transforms.
    var gecko3d = "MozPerspective" in style;
    // @property any3d: Boolean
    // `true` for all browsers supporting CSS transforms.
    var any3d = !window.L_DISABLE_3D && (ie3d || webkit3d || gecko3d) && !opera12 && !phantom;
    // @property mobile: Boolean; `true` for all browsers running in a mobile device.
    var mobile = typeof orientation !== "undefined" || userAgentContains("mobile");
    // @property mobileWebkit: Boolean; `true` for all webkit-based browsers in a mobile device.
    var mobileWebkit = mobile && webkit;
    // @property mobileWebkit3d: Boolean
    // `true` for all webkit-based browsers in a mobile device supporting CSS transforms.
    var mobileWebkit3d = mobile && webkit3d;
    // @property msPointer: Boolean
    // `true` for browsers implementing the Microsoft touch events model (notably IE10).
    var msPointer = !window.PointerEvent && window.MSPointerEvent;
    // @property pointer: Boolean
    // `true` for all browsers supporting [pointer events](https://msdn.microsoft.com/en-us/library/dn433244%28v=vs.85%29.aspx).
    var pointer = !!(window.PointerEvent || msPointer);
    // @property touchNative: Boolean
    // `true` for all browsers supporting [touch events](https://developer.mozilla.org/docs/Web/API/Touch_events).
    // **This does not necessarily mean** that the browser is running in a computer with
    // a touchscreen, it only means that the browser is capable of understanding
    // touch events.
    var touchNative = "ontouchstart" in window || !!window.TouchEvent;
    // @property touch: Boolean
    // `true` for all browsers supporting either [touch](#browser-touch) or [pointer](#browser-pointer) events.
    // Note: pointer events will be preferred (if available), and processed for all `touch*` listeners.
    var touch = !window.L_NO_TOUCH && (touchNative || pointer);
    // @property mobileOpera: Boolean; `true` for the Opera browser in a mobile device.
    var mobileOpera = mobile && opera;
    // @property mobileGecko: Boolean
    // `true` for gecko-based browsers running in a mobile device.
    var mobileGecko = mobile && gecko;
    // @property retina: Boolean
    // `true` for browsers on a high-resolution "retina" screen or on any screen when browser's display zoom is more than 100%.
    var retina = (window.devicePixelRatio || window.screen.deviceXDPI / window.screen.logicalXDPI) > 1;
    // @property passiveEvents: Boolean
    // `true` for browsers that support passive events.
    var passiveEvents = function() {
        var supportsPassiveOption = false;
        try {
            var opts = Object.defineProperty({}, "passive", {
                get: function() {
                    supportsPassiveOption = true;
                }
            });
            window.addEventListener("testPassiveEventSupport", falseFn, opts);
            window.removeEventListener("testPassiveEventSupport", falseFn, opts);
        } catch (e) {
        // Errors can safely be ignored since this is only a browser support test.
        }
        return supportsPassiveOption;
    }();
    // @property canvas: Boolean
    // `true` when the browser supports [`<canvas>`](https://developer.mozilla.org/docs/Web/API/Canvas_API).
    var canvas$1 = function() {
        return !!document.createElement("canvas").getContext;
    }();
    // @property svg: Boolean
    // `true` when the browser supports [SVG](https://developer.mozilla.org/docs/Web/SVG).
    var svg$1 = !!(document.createElementNS && svgCreate("svg").createSVGRect);
    var inlineSvg = !!svg$1 && function() {
        var div = document.createElement("div");
        div.innerHTML = "<svg/>";
        return (div.firstChild && div.firstChild.namespaceURI) === "http://www.w3.org/2000/svg";
    }();
    // @property vml: Boolean
    // `true` if the browser supports [VML](https://en.wikipedia.org/wiki/Vector_Markup_Language).
    var vml = !svg$1 && function() {
        try {
            var div = document.createElement("div");
            div.innerHTML = '<v:shape adj="1"/>';
            var shape = div.firstChild;
            shape.style.behavior = "url(#default#VML)";
            return shape && typeof shape.adj === "object";
        } catch (e) {
            return false;
        }
    }();
    // @property mac: Boolean; `true` when the browser is running in a Mac platform
    var mac = navigator.platform.indexOf("Mac") === 0;
    // @property mac: Boolean; `true` when the browser is running in a Linux platform
    var linux = navigator.platform.indexOf("Linux") === 0;
    function userAgentContains(str) {
        return navigator.userAgent.toLowerCase().indexOf(str) >= 0;
    }
    var Browser = {
        ie: ie,
        ielt9: ielt9,
        edge: edge,
        webkit: webkit,
        android: android,
        android23: android23,
        androidStock: androidStock,
        opera: opera,
        chrome: chrome,
        gecko: gecko,
        safari: safari,
        phantom: phantom,
        opera12: opera12,
        win: win,
        ie3d: ie3d,
        webkit3d: webkit3d,
        gecko3d: gecko3d,
        any3d: any3d,
        mobile: mobile,
        mobileWebkit: mobileWebkit,
        mobileWebkit3d: mobileWebkit3d,
        msPointer: msPointer,
        pointer: pointer,
        touch: touch,
        touchNative: touchNative,
        mobileOpera: mobileOpera,
        mobileGecko: mobileGecko,
        retina: retina,
        passiveEvents: passiveEvents,
        canvas: canvas$1,
        svg: svg$1,
        vml: vml,
        inlineSvg: inlineSvg,
        mac: mac,
        linux: linux
    };
    /*
   * Extends L.DomEvent to provide touch support for Internet Explorer and Windows-based devices.
   */ var POINTER_DOWN = Browser.msPointer ? "MSPointerDown" : "pointerdown";
    var POINTER_MOVE = Browser.msPointer ? "MSPointerMove" : "pointermove";
    var POINTER_UP = Browser.msPointer ? "MSPointerUp" : "pointerup";
    var POINTER_CANCEL = Browser.msPointer ? "MSPointerCancel" : "pointercancel";
    var pEvent = {
        touchstart: POINTER_DOWN,
        touchmove: POINTER_MOVE,
        touchend: POINTER_UP,
        touchcancel: POINTER_CANCEL
    };
    var handle = {
        touchstart: _onPointerStart,
        touchmove: _handlePointer,
        touchend: _handlePointer,
        touchcancel: _handlePointer
    };
    var _pointers = {};
    var _pointerDocListener = false;
    // Provides a touch events wrapper for (ms)pointer events.
    // ref https://www.w3.org/TR/pointerevents/ https://www.w3.org/Bugs/Public/show_bug.cgi?id=22890
    function addPointerListener(obj, type, handler) {
        if (type === "touchstart") _addPointerDocListener();
        if (!handle[type]) {
            console.warn("wrong event specified:", type);
            return falseFn;
        }
        handler = handle[type].bind(this, handler);
        obj.addEventListener(pEvent[type], handler, false);
        return handler;
    }
    function removePointerListener(obj, type, handler) {
        if (!pEvent[type]) {
            console.warn("wrong event specified:", type);
            return;
        }
        obj.removeEventListener(pEvent[type], handler, false);
    }
    function _globalPointerDown(e) {
        _pointers[e.pointerId] = e;
    }
    function _globalPointerMove(e) {
        if (_pointers[e.pointerId]) _pointers[e.pointerId] = e;
    }
    function _globalPointerUp(e) {
        delete _pointers[e.pointerId];
    }
    function _addPointerDocListener() {
        // need to keep track of what pointers and how many are active to provide e.touches emulation
        if (!_pointerDocListener) {
            // we listen document as any drags that end by moving the touch off the screen get fired there
            document.addEventListener(POINTER_DOWN, _globalPointerDown, true);
            document.addEventListener(POINTER_MOVE, _globalPointerMove, true);
            document.addEventListener(POINTER_UP, _globalPointerUp, true);
            document.addEventListener(POINTER_CANCEL, _globalPointerUp, true);
            _pointerDocListener = true;
        }
    }
    function _handlePointer(handler, e) {
        if (e.pointerType === (e.MSPOINTER_TYPE_MOUSE || "mouse")) return;
        e.touches = [];
        for(var i in _pointers)e.touches.push(_pointers[i]);
        e.changedTouches = [
            e
        ];
        handler(e);
    }
    function _onPointerStart(handler, e) {
        // IE10 specific: MsTouch needs preventDefault. See #2000
        if (e.MSPOINTER_TYPE_TOUCH && e.pointerType === e.MSPOINTER_TYPE_TOUCH) preventDefault(e);
        _handlePointer(handler, e);
    }
    /*
   * Extends the event handling code with double tap support for mobile browsers.
   *
   * Note: currently most browsers fire native dblclick, with only a few exceptions
   * (see https://github.com/Leaflet/Leaflet/issues/7012#issuecomment-595087386)
   */ function makeDblclick(event) {
        // in modern browsers `type` cannot be just overridden:
        // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Errors/Getter_only
        var newEvent = {}, prop, i;
        for(i in event){
            prop = event[i];
            newEvent[i] = prop && prop.bind ? prop.bind(event) : prop;
        }
        event = newEvent;
        newEvent.type = "dblclick";
        newEvent.detail = 2;
        newEvent.isTrusted = false;
        newEvent._simulated = true; // for debug purposes
        return newEvent;
    }
    var delay = 200;
    function addDoubleTapListener(obj, handler) {
        // Most browsers handle double tap natively
        obj.addEventListener("dblclick", handler);
        // On some platforms the browser doesn't fire native dblclicks for touch events.
        // It seems that in all such cases `detail` property of `click` event is always `1`.
        // So here we rely on that fact to avoid excessive 'dblclick' simulation when not needed.
        var last = 0, detail;
        function simDblclick(e) {
            if (e.detail !== 1) {
                detail = e.detail; // keep in sync to avoid false dblclick in some cases
                return;
            }
            if (e.pointerType === "mouse" || e.sourceCapabilities && !e.sourceCapabilities.firesTouchEvents) return;
            // When clicking on an <input>, the browser generates a click on its
            // <label> (and vice versa) triggering two clicks in quick succession.
            // This ignores clicks on elements which are a label with a 'for'
            // attribute (or children of such a label), but not children of
            // a <input>.
            var path = getPropagationPath(e);
            if (path.some(function(el) {
                return el instanceof HTMLLabelElement && el.attributes.for;
            }) && !path.some(function(el) {
                return el instanceof HTMLInputElement || el instanceof HTMLSelectElement;
            })) return;
            var now = Date.now();
            if (now - last <= delay) {
                detail++;
                if (detail === 2) handler(makeDblclick(e));
            } else detail = 1;
            last = now;
        }
        obj.addEventListener("click", simDblclick);
        return {
            dblclick: handler,
            simDblclick: simDblclick
        };
    }
    function removeDoubleTapListener(obj, handlers) {
        obj.removeEventListener("dblclick", handlers.dblclick);
        obj.removeEventListener("click", handlers.simDblclick);
    }
    /*
   * @namespace DomUtil
   *
   * Utility functions to work with the [DOM](https://developer.mozilla.org/docs/Web/API/Document_Object_Model)
   * tree, used by Leaflet internally.
   *
   * Most functions expecting or returning a `HTMLElement` also work for
   * SVG elements. The only difference is that classes refer to CSS classes
   * in HTML and SVG classes in SVG.
   */ // @property TRANSFORM: String
    // Vendor-prefixed transform style name (e.g. `'webkitTransform'` for WebKit).
    var TRANSFORM = testProp([
        "transform",
        "webkitTransform",
        "OTransform",
        "MozTransform",
        "msTransform"
    ]);
    // webkitTransition comes first because some browser versions that drop vendor prefix don't do
    // the same for the transitionend event, in particular the Android 4.1 stock browser
    // @property TRANSITION: String
    // Vendor-prefixed transition style name.
    var TRANSITION = testProp([
        "webkitTransition",
        "transition",
        "OTransition",
        "MozTransition",
        "msTransition"
    ]);
    // @property TRANSITION_END: String
    // Vendor-prefixed transitionend event name.
    var TRANSITION_END = TRANSITION === "webkitTransition" || TRANSITION === "OTransition" ? TRANSITION + "End" : "transitionend";
    // @function get(id: String|HTMLElement): HTMLElement
    // Returns an element given its DOM id, or returns the element itself
    // if it was passed directly.
    function get(id) {
        return typeof id === "string" ? document.getElementById(id) : id;
    }
    // @function getStyle(el: HTMLElement, styleAttrib: String): String
    // Returns the value for a certain style attribute on an element,
    // including computed values or values set through CSS.
    function getStyle(el, style) {
        var value = el.style[style] || el.currentStyle && el.currentStyle[style];
        if ((!value || value === "auto") && document.defaultView) {
            var css = document.defaultView.getComputedStyle(el, null);
            value = css ? css[style] : null;
        }
        return value === "auto" ? null : value;
    }
    // @function create(tagName: String, className?: String, container?: HTMLElement): HTMLElement
    // Creates an HTML element with `tagName`, sets its class to `className`, and optionally appends it to `container` element.
    function create$1(tagName, className, container) {
        var el = document.createElement(tagName);
        el.className = className || "";
        if (container) container.appendChild(el);
        return el;
    }
    // @function remove(el: HTMLElement)
    // Removes `el` from its parent element
    function remove(el) {
        var parent = el.parentNode;
        if (parent) parent.removeChild(el);
    }
    // @function empty(el: HTMLElement)
    // Removes all of `el`'s children elements from `el`
    function empty(el) {
        while(el.firstChild)el.removeChild(el.firstChild);
    }
    // @function toFront(el: HTMLElement)
    // Makes `el` the last child of its parent, so it renders in front of the other children.
    function toFront(el) {
        var parent = el.parentNode;
        if (parent && parent.lastChild !== el) parent.appendChild(el);
    }
    // @function toBack(el: HTMLElement)
    // Makes `el` the first child of its parent, so it renders behind the other children.
    function toBack(el) {
        var parent = el.parentNode;
        if (parent && parent.firstChild !== el) parent.insertBefore(el, parent.firstChild);
    }
    // @function hasClass(el: HTMLElement, name: String): Boolean
    // Returns `true` if the element's class attribute contains `name`.
    function hasClass(el, name) {
        if (el.classList !== undefined) return el.classList.contains(name);
        var className = getClass(el);
        return className.length > 0 && new RegExp("(^|\\s)" + name + "(\\s|$)").test(className);
    }
    // @function addClass(el: HTMLElement, name: String)
    // Adds `name` to the element's class attribute.
    function addClass(el, name) {
        if (el.classList !== undefined) {
            var classes = splitWords(name);
            for(var i = 0, len = classes.length; i < len; i++)el.classList.add(classes[i]);
        } else if (!hasClass(el, name)) {
            var className = getClass(el);
            setClass(el, (className ? className + " " : "") + name);
        }
    }
    // @function removeClass(el: HTMLElement, name: String)
    // Removes `name` from the element's class attribute.
    function removeClass(el, name) {
        if (el.classList !== undefined) el.classList.remove(name);
        else setClass(el, trim((" " + getClass(el) + " ").replace(" " + name + " ", " ")));
    }
    // @function setClass(el: HTMLElement, name: String)
    // Sets the element's class.
    function setClass(el, name) {
        if (el.className.baseVal === undefined) el.className = name;
        else // in case of SVG element
        el.className.baseVal = name;
    }
    // @function getClass(el: HTMLElement): String
    // Returns the element's class.
    function getClass(el) {
        // Check if the element is an SVGElementInstance and use the correspondingElement instead
        // (Required for linked SVG elements in IE11.)
        if (el.correspondingElement) el = el.correspondingElement;
        return el.className.baseVal === undefined ? el.className : el.className.baseVal;
    }
    // @function setOpacity(el: HTMLElement, opacity: Number)
    // Set the opacity of an element (including old IE support).
    // `opacity` must be a number from `0` to `1`.
    function setOpacity(el, value) {
        if ("opacity" in el.style) el.style.opacity = value;
        else if ("filter" in el.style) _setOpacityIE(el, value);
    }
    function _setOpacityIE(el, value) {
        var filter = false, filterName = "DXImageTransform.Microsoft.Alpha";
        // filters collection throws an error if we try to retrieve a filter that doesn't exist
        try {
            filter = el.filters.item(filterName);
        } catch (e) {
            // don't set opacity to 1 if we haven't already set an opacity,
            // it isn't needed and breaks transparent pngs.
            if (value === 1) return;
        }
        value = Math.round(value * 100);
        if (filter) {
            filter.Enabled = value !== 100;
            filter.Opacity = value;
        } else el.style.filter += " progid:" + filterName + "(opacity=" + value + ")";
    }
    // @function testProp(props: String[]): String|false
    // Goes through the array of style names and returns the first name
    // that is a valid style name for an element. If no such name is found,
    // it returns false. Useful for vendor-prefixed styles like `transform`.
    function testProp(props) {
        var style = document.documentElement.style;
        for(var i = 0; i < props.length; i++){
            if (props[i] in style) return props[i];
        }
        return false;
    }
    // @function setTransform(el: HTMLElement, offset: Point, scale?: Number)
    // Resets the 3D CSS transform of `el` so it is translated by `offset` pixels
    // and optionally scaled by `scale`. Does not have an effect if the
    // browser doesn't support 3D CSS transforms.
    function setTransform(el, offset, scale) {
        var pos = offset || new Point(0, 0);
        el.style[TRANSFORM] = (Browser.ie3d ? "translate(" + pos.x + "px," + pos.y + "px)" : "translate3d(" + pos.x + "px," + pos.y + "px,0)") + (scale ? " scale(" + scale + ")" : "");
    }
    // @function setPosition(el: HTMLElement, position: Point)
    // Sets the position of `el` to coordinates specified by `position`,
    // using CSS translate or top/left positioning depending on the browser
    // (used by Leaflet internally to position its layers).
    function setPosition(el, point) {
        /*eslint-disable */ el._leaflet_pos = point;
        /* eslint-enable */ if (Browser.any3d) setTransform(el, point);
        else {
            el.style.left = point.x + "px";
            el.style.top = point.y + "px";
        }
    }
    // @function getPosition(el: HTMLElement): Point
    // Returns the coordinates of an element previously positioned with setPosition.
    function getPosition(el) {
        // this method is only used for elements previously positioned using setPosition,
        // so it's safe to cache the position for performance
        return el._leaflet_pos || new Point(0, 0);
    }
    // @function disableTextSelection()
    // Prevents the user from generating `selectstart` DOM events, usually generated
    // when the user drags the mouse through a page with text. Used internally
    // by Leaflet to override the behaviour of any click-and-drag interaction on
    // the map. Affects drag interactions on the whole document.
    // @function enableTextSelection()
    // Cancels the effects of a previous [`L.DomUtil.disableTextSelection`](#domutil-disabletextselection).
    var disableTextSelection;
    var enableTextSelection;
    var _userSelect;
    if ("onselectstart" in document) {
        disableTextSelection = function() {
            on(window, "selectstart", preventDefault);
        };
        enableTextSelection = function() {
            off(window, "selectstart", preventDefault);
        };
    } else {
        var userSelectProperty = testProp([
            "userSelect",
            "WebkitUserSelect",
            "OUserSelect",
            "MozUserSelect",
            "msUserSelect"
        ]);
        disableTextSelection = function() {
            if (userSelectProperty) {
                var style = document.documentElement.style;
                _userSelect = style[userSelectProperty];
                style[userSelectProperty] = "none";
            }
        };
        enableTextSelection = function() {
            if (userSelectProperty) {
                document.documentElement.style[userSelectProperty] = _userSelect;
                _userSelect = undefined;
            }
        };
    }
    // @function disableImageDrag()
    // As [`L.DomUtil.disableTextSelection`](#domutil-disabletextselection), but
    // for `dragstart` DOM events, usually generated when the user drags an image.
    function disableImageDrag() {
        on(window, "dragstart", preventDefault);
    }
    // @function enableImageDrag()
    // Cancels the effects of a previous [`L.DomUtil.disableImageDrag`](#domutil-disabletextselection).
    function enableImageDrag() {
        off(window, "dragstart", preventDefault);
    }
    var _outlineElement, _outlineStyle;
    // @function preventOutline(el: HTMLElement)
    // Makes the [outline](https://developer.mozilla.org/docs/Web/CSS/outline)
    // of the element `el` invisible. Used internally by Leaflet to prevent
    // focusable elements from displaying an outline when the user performs a
    // drag interaction on them.
    function preventOutline(element) {
        while(element.tabIndex === -1)element = element.parentNode;
        if (!element.style) return;
        restoreOutline();
        _outlineElement = element;
        _outlineStyle = element.style.outlineStyle;
        element.style.outlineStyle = "none";
        on(window, "keydown", restoreOutline);
    }
    // @function restoreOutline()
    // Cancels the effects of a previous [`L.DomUtil.preventOutline`]().
    function restoreOutline() {
        if (!_outlineElement) return;
        _outlineElement.style.outlineStyle = _outlineStyle;
        _outlineElement = undefined;
        _outlineStyle = undefined;
        off(window, "keydown", restoreOutline);
    }
    // @function getSizedParentNode(el: HTMLElement): HTMLElement
    // Finds the closest parent node which size (width and height) is not null.
    function getSizedParentNode(element) {
        do element = element.parentNode;
        while ((!element.offsetWidth || !element.offsetHeight) && element !== document.body);
        return element;
    }
    // @function getScale(el: HTMLElement): Object
    // Computes the CSS scale currently applied on the element.
    // Returns an object with `x` and `y` members as horizontal and vertical scales respectively,
    // and `boundingClientRect` as the result of [`getBoundingClientRect()`](https://developer.mozilla.org/en-US/docs/Web/API/Element/getBoundingClientRect).
    function getScale(element) {
        var rect = element.getBoundingClientRect(); // Read-only in old browsers.
        return {
            x: rect.width / element.offsetWidth || 1,
            y: rect.height / element.offsetHeight || 1,
            boundingClientRect: rect
        };
    }
    var DomUtil = {
        __proto__: null,
        TRANSFORM: TRANSFORM,
        TRANSITION: TRANSITION,
        TRANSITION_END: TRANSITION_END,
        get: get,
        getStyle: getStyle,
        create: create$1,
        remove: remove,
        empty: empty,
        toFront: toFront,
        toBack: toBack,
        hasClass: hasClass,
        addClass: addClass,
        removeClass: removeClass,
        setClass: setClass,
        getClass: getClass,
        setOpacity: setOpacity,
        testProp: testProp,
        setTransform: setTransform,
        setPosition: setPosition,
        getPosition: getPosition,
        get disableTextSelection () {
            return disableTextSelection;
        },
        get enableTextSelection () {
            return enableTextSelection;
        },
        disableImageDrag: disableImageDrag,
        enableImageDrag: enableImageDrag,
        preventOutline: preventOutline,
        restoreOutline: restoreOutline,
        getSizedParentNode: getSizedParentNode,
        getScale: getScale
    };
    /*
   * @namespace DomEvent
   * Utility functions to work with the [DOM events](https://developer.mozilla.org/docs/Web/API/Event), used by Leaflet internally.
   */ // Inspired by John Resig, Dean Edwards and YUI addEvent implementations.
    // @function on(el: HTMLElement, types: String, fn: Function, context?: Object): this
    // Adds a listener function (`fn`) to a particular DOM event type of the
    // element `el`. You can optionally specify the context of the listener
    // (object the `this` keyword will point to). You can also pass several
    // space-separated types (e.g. `'click dblclick'`).
    // @alternative
    // @function on(el: HTMLElement, eventMap: Object, context?: Object): this
    // Adds a set of type/listener pairs, e.g. `{click: onClick, mousemove: onMouseMove}`
    function on(obj, types, fn, context) {
        if (types && typeof types === "object") for(var type in types)addOne(obj, type, types[type], fn);
        else {
            types = splitWords(types);
            for(var i = 0, len = types.length; i < len; i++)addOne(obj, types[i], fn, context);
        }
        return this;
    }
    var eventsKey = "_leaflet_events";
    // @function off(el: HTMLElement, types: String, fn: Function, context?: Object): this
    // Removes a previously added listener function.
    // Note that if you passed a custom context to on, you must pass the same
    // context to `off` in order to remove the listener.
    // @alternative
    // @function off(el: HTMLElement, eventMap: Object, context?: Object): this
    // Removes a set of type/listener pairs, e.g. `{click: onClick, mousemove: onMouseMove}`
    // @alternative
    // @function off(el: HTMLElement, types: String): this
    // Removes all previously added listeners of given types.
    // @alternative
    // @function off(el: HTMLElement): this
    // Removes all previously added listeners from given HTMLElement
    function off(obj, types, fn, context) {
        if (arguments.length === 1) {
            batchRemove(obj);
            delete obj[eventsKey];
        } else if (types && typeof types === "object") for(var type in types)removeOne(obj, type, types[type], fn);
        else {
            types = splitWords(types);
            if (arguments.length === 2) batchRemove(obj, function(type) {
                return indexOf(types, type) !== -1;
            });
            else for(var i = 0, len = types.length; i < len; i++)removeOne(obj, types[i], fn, context);
        }
        return this;
    }
    function batchRemove(obj, filterFn) {
        for(var id in obj[eventsKey]){
            var type = id.split(/\d/)[0];
            if (!filterFn || filterFn(type)) removeOne(obj, type, null, null, id);
        }
    }
    var mouseSubst = {
        mouseenter: "mouseover",
        mouseleave: "mouseout",
        wheel: !("onwheel" in window) && "mousewheel"
    };
    function addOne(obj, type, fn, context) {
        var id = type + stamp(fn) + (context ? "_" + stamp(context) : "");
        if (obj[eventsKey] && obj[eventsKey][id]) return this;
        var handler = function(e) {
            return fn.call(context || obj, e || window.event);
        };
        var originalHandler = handler;
        if (!Browser.touchNative && Browser.pointer && type.indexOf("touch") === 0) // Needs DomEvent.Pointer.js
        handler = addPointerListener(obj, type, handler);
        else if (Browser.touch && type === "dblclick") handler = addDoubleTapListener(obj, handler);
        else if ("addEventListener" in obj) {
            if (type === "touchstart" || type === "touchmove" || type === "wheel" || type === "mousewheel") obj.addEventListener(mouseSubst[type] || type, handler, Browser.passiveEvents ? {
                passive: false
            } : false);
            else if (type === "mouseenter" || type === "mouseleave") {
                handler = function(e) {
                    e = e || window.event;
                    if (isExternalTarget(obj, e)) originalHandler(e);
                };
                obj.addEventListener(mouseSubst[type], handler, false);
            } else obj.addEventListener(type, originalHandler, false);
        } else obj.attachEvent("on" + type, handler);
        obj[eventsKey] = obj[eventsKey] || {};
        obj[eventsKey][id] = handler;
    }
    function removeOne(obj, type, fn, context, id) {
        id = id || type + stamp(fn) + (context ? "_" + stamp(context) : "");
        var handler = obj[eventsKey] && obj[eventsKey][id];
        if (!handler) return this;
        if (!Browser.touchNative && Browser.pointer && type.indexOf("touch") === 0) removePointerListener(obj, type, handler);
        else if (Browser.touch && type === "dblclick") removeDoubleTapListener(obj, handler);
        else if ("removeEventListener" in obj) obj.removeEventListener(mouseSubst[type] || type, handler, false);
        else obj.detachEvent("on" + type, handler);
        obj[eventsKey][id] = null;
    }
    // @function stopPropagation(ev: DOMEvent): this
    // Stop the given event from propagation to parent elements. Used inside the listener functions:
    // ```js
    // L.DomEvent.on(div, 'click', function (ev) {
    // 	L.DomEvent.stopPropagation(ev);
    // });
    // ```
    function stopPropagation(e) {
        if (e.stopPropagation) e.stopPropagation();
        else if (e.originalEvent) e.originalEvent._stopped = true;
        else e.cancelBubble = true;
        return this;
    }
    // @function disableScrollPropagation(el: HTMLElement): this
    // Adds `stopPropagation` to the element's `'wheel'` events (plus browser variants).
    function disableScrollPropagation(el) {
        addOne(el, "wheel", stopPropagation);
        return this;
    }
    // @function disableClickPropagation(el: HTMLElement): this
    // Adds `stopPropagation` to the element's `'click'`, `'dblclick'`, `'contextmenu'`,
    // `'mousedown'` and `'touchstart'` events (plus browser variants).
    function disableClickPropagation(el) {
        on(el, "mousedown touchstart dblclick contextmenu", stopPropagation);
        el["_leaflet_disable_click"] = true;
        return this;
    }
    // @function preventDefault(ev: DOMEvent): this
    // Prevents the default action of the DOM Event `ev` from happening (such as
    // following a link in the href of the a element, or doing a POST request
    // with page reload when a `<form>` is submitted).
    // Use it inside listener functions.
    function preventDefault(e) {
        if (e.preventDefault) e.preventDefault();
        else e.returnValue = false;
        return this;
    }
    // @function stop(ev: DOMEvent): this
    // Does `stopPropagation` and `preventDefault` at the same time.
    function stop(e) {
        preventDefault(e);
        stopPropagation(e);
        return this;
    }
    // @function getPropagationPath(ev: DOMEvent): Array
    // Compatibility polyfill for [`Event.composedPath()`](https://developer.mozilla.org/en-US/docs/Web/API/Event/composedPath).
    // Returns an array containing the `HTMLElement`s that the given DOM event
    // should propagate to (if not stopped).
    function getPropagationPath(ev) {
        if (ev.composedPath) return ev.composedPath();
        var path = [];
        var el = ev.target;
        while(el){
            path.push(el);
            el = el.parentNode;
        }
        return path;
    }
    // @function getMousePosition(ev: DOMEvent, container?: HTMLElement): Point
    // Gets normalized mouse position from a DOM event relative to the
    // `container` (border excluded) or to the whole page if not specified.
    function getMousePosition(e, container) {
        if (!container) return new Point(e.clientX, e.clientY);
        var scale = getScale(container), offset = scale.boundingClientRect; // left and top  values are in page scale (like the event clientX/Y)
        return new Point(// offset.left/top values are in page scale (like clientX/Y),
        // whereas clientLeft/Top (border width) values are the original values (before CSS scale applies).
        (e.clientX - offset.left) / scale.x - container.clientLeft, (e.clientY - offset.top) / scale.y - container.clientTop);
    }
    //  except , Safari and
    // We need double the scroll pixels (see #7403 and #4538) for all Browsers
    // except OSX (Mac) -> 3x, Chrome running on Linux 1x
    var wheelPxFactor = Browser.linux && Browser.chrome ? window.devicePixelRatio : Browser.mac ? window.devicePixelRatio * 3 : window.devicePixelRatio > 0 ? 2 * window.devicePixelRatio : 1;
    // @function getWheelDelta(ev: DOMEvent): Number
    // Gets normalized wheel delta from a wheel DOM event, in vertical
    // pixels scrolled (negative if scrolling down).
    // Events from pointing devices without precise scrolling are mapped to
    // a best guess of 60 pixels.
    function getWheelDelta(e) {
        return Browser.edge ? e.wheelDeltaY / 2 : e.deltaY && e.deltaMode === 0 ? -e.deltaY / wheelPxFactor : e.deltaY && e.deltaMode === 1 ? -e.deltaY * 20 : e.deltaY && e.deltaMode === 2 ? -e.deltaY * 60 : e.deltaX || e.deltaZ ? 0 : e.wheelDelta ? (e.wheelDeltaY || e.wheelDelta) / 2 : e.detail && Math.abs(e.detail) < 32765 ? -e.detail * 20 : e.detail ? e.detail / -32765 * 60 : 0;
    }
    // check if element really left/entered the event target (for mouseenter/mouseleave)
    function isExternalTarget(el, e) {
        var related = e.relatedTarget;
        if (!related) return true;
        try {
            while(related && related !== el)related = related.parentNode;
        } catch (err) {
            return false;
        }
        return related !== el;
    }
    var DomEvent = {
        __proto__: null,
        on: on,
        off: off,
        stopPropagation: stopPropagation,
        disableScrollPropagation: disableScrollPropagation,
        disableClickPropagation: disableClickPropagation,
        preventDefault: preventDefault,
        stop: stop,
        getPropagationPath: getPropagationPath,
        getMousePosition: getMousePosition,
        getWheelDelta: getWheelDelta,
        isExternalTarget: isExternalTarget,
        addListener: on,
        removeListener: off
    };
    /*
   * @class PosAnimation
   * @aka L.PosAnimation
   * @inherits Evented
   * Used internally for panning animations, utilizing CSS3 Transitions for modern browsers and a timer fallback for IE6-9.
   *
   * @example
   * ```js
   * var myPositionMarker = L.marker([48.864716, 2.294694]).addTo(map);
   *
   * myPositionMarker.on("click", function() {
   * 	var pos = map.latLngToLayerPoint(myPositionMarker.getLatLng());
   * 	pos.y -= 25;
   * 	var fx = new L.PosAnimation();
   *
   * 	fx.once('end',function() {
   * 		pos.y += 25;
   * 		fx.run(myPositionMarker._icon, pos, 0.8);
   * 	});
   *
   * 	fx.run(myPositionMarker._icon, pos, 0.3);
   * });
   *
   * ```
   *
   * @constructor L.PosAnimation()
   * Creates a `PosAnimation` object.
   *
   */ var PosAnimation = Evented.extend({
        // @method run(el: HTMLElement, newPos: Point, duration?: Number, easeLinearity?: Number)
        // Run an animation of a given element to a new position, optionally setting
        // duration in seconds (`0.25` by default) and easing linearity factor (3rd
        // argument of the [cubic bezier curve](https://cubic-bezier.com/#0,0,.5,1),
        // `0.5` by default).
        run: function(el, newPos, duration, easeLinearity) {
            this.stop();
            this._el = el;
            this._inProgress = true;
            this._duration = duration || 0.25;
            this._easeOutPower = 1 / Math.max(easeLinearity || 0.5, 0.2);
            this._startPos = getPosition(el);
            this._offset = newPos.subtract(this._startPos);
            this._startTime = +new Date();
            // @event start: Event
            // Fired when the animation starts
            this.fire("start");
            this._animate();
        },
        // @method stop()
        // Stops the animation (if currently running).
        stop: function() {
            if (!this._inProgress) return;
            this._step(true);
            this._complete();
        },
        _animate: function() {
            // animation loop
            this._animId = requestAnimFrame(this._animate, this);
            this._step();
        },
        _step: function(round) {
            var elapsed = +new Date() - this._startTime, duration = this._duration * 1000;
            if (elapsed < duration) this._runFrame(this._easeOut(elapsed / duration), round);
            else {
                this._runFrame(1);
                this._complete();
            }
        },
        _runFrame: function(progress, round) {
            var pos = this._startPos.add(this._offset.multiplyBy(progress));
            if (round) pos._round();
            setPosition(this._el, pos);
            // @event step: Event
            // Fired continuously during the animation.
            this.fire("step");
        },
        _complete: function() {
            cancelAnimFrame(this._animId);
            this._inProgress = false;
            // @event end: Event
            // Fired when the animation ends.
            this.fire("end");
        },
        _easeOut: function(t) {
            return 1 - Math.pow(1 - t, this._easeOutPower);
        }
    });
    /*
   * @class Map
   * @aka L.Map
   * @inherits Evented
   *
   * The central class of the API — it is used to create a map on a page and manipulate it.
   *
   * @example
   *
   * ```js
   * // initialize the map on the "map" div with a given center and zoom
   * var map = L.map('map', {
   * 	center: [51.505, -0.09],
   * 	zoom: 13
   * });
   * ```
   *
   */ var Map = Evented.extend({
        options: {
            // @section Map State Options
            // @option crs: CRS = L.CRS.EPSG3857
            // The [Coordinate Reference System](#crs) to use. Don't change this if you're not
            // sure what it means.
            crs: EPSG3857,
            // @option center: LatLng = undefined
            // Initial geographic center of the map
            center: undefined,
            // @option zoom: Number = undefined
            // Initial map zoom level
            zoom: undefined,
            // @option minZoom: Number = *
            // Minimum zoom level of the map.
            // If not specified and at least one `GridLayer` or `TileLayer` is in the map,
            // the lowest of their `minZoom` options will be used instead.
            minZoom: undefined,
            // @option maxZoom: Number = *
            // Maximum zoom level of the map.
            // If not specified and at least one `GridLayer` or `TileLayer` is in the map,
            // the highest of their `maxZoom` options will be used instead.
            maxZoom: undefined,
            // @option layers: Layer[] = []
            // Array of layers that will be added to the map initially
            layers: [],
            // @option maxBounds: LatLngBounds = null
            // When this option is set, the map restricts the view to the given
            // geographical bounds, bouncing the user back if the user tries to pan
            // outside the view. To set the restriction dynamically, use
            // [`setMaxBounds`](#map-setmaxbounds) method.
            maxBounds: undefined,
            // @option renderer: Renderer = *
            // The default method for drawing vector layers on the map. `L.SVG`
            // or `L.Canvas` by default depending on browser support.
            renderer: undefined,
            // @section Animation Options
            // @option zoomAnimation: Boolean = true
            // Whether the map zoom animation is enabled. By default it's enabled
            // in all browsers that support CSS3 Transitions except Android.
            zoomAnimation: true,
            // @option zoomAnimationThreshold: Number = 4
            // Won't animate zoom if the zoom difference exceeds this value.
            zoomAnimationThreshold: 4,
            // @option fadeAnimation: Boolean = true
            // Whether the tile fade animation is enabled. By default it's enabled
            // in all browsers that support CSS3 Transitions except Android.
            fadeAnimation: true,
            // @option markerZoomAnimation: Boolean = true
            // Whether markers animate their zoom with the zoom animation, if disabled
            // they will disappear for the length of the animation. By default it's
            // enabled in all browsers that support CSS3 Transitions except Android.
            markerZoomAnimation: true,
            // @option transform3DLimit: Number = 2^23
            // Defines the maximum size of a CSS translation transform. The default
            // value should not be changed unless a web browser positions layers in
            // the wrong place after doing a large `panBy`.
            transform3DLimit: 8388608,
            // @section Interaction Options
            // @option zoomSnap: Number = 1
            // Forces the map's zoom level to always be a multiple of this, particularly
            // right after a [`fitBounds()`](#map-fitbounds) or a pinch-zoom.
            // By default, the zoom level snaps to the nearest integer; lower values
            // (e.g. `0.5` or `0.1`) allow for greater granularity. A value of `0`
            // means the zoom level will not be snapped after `fitBounds` or a pinch-zoom.
            zoomSnap: 1,
            // @option zoomDelta: Number = 1
            // Controls how much the map's zoom level will change after a
            // [`zoomIn()`](#map-zoomin), [`zoomOut()`](#map-zoomout), pressing `+`
            // or `-` on the keyboard, or using the [zoom controls](#control-zoom).
            // Values smaller than `1` (e.g. `0.5`) allow for greater granularity.
            zoomDelta: 1,
            // @option trackResize: Boolean = true
            // Whether the map automatically handles browser window resize to update itself.
            trackResize: true
        },
        initialize: function(id, options) {
            options = setOptions(this, options);
            // Make sure to assign internal flags at the beginning,
            // to avoid inconsistent state in some edge cases.
            this._handlers = [];
            this._layers = {};
            this._zoomBoundLayers = {};
            this._sizeChanged = true;
            this._initContainer(id);
            this._initLayout();
            // hack for https://github.com/Leaflet/Leaflet/issues/1980
            this._onResize = bind(this._onResize, this);
            this._initEvents();
            if (options.maxBounds) this.setMaxBounds(options.maxBounds);
            if (options.zoom !== undefined) this._zoom = this._limitZoom(options.zoom);
            if (options.center && options.zoom !== undefined) this.setView(toLatLng(options.center), options.zoom, {
                reset: true
            });
            this.callInitHooks();
            // don't animate on browsers without hardware-accelerated transitions or old Android/Opera
            this._zoomAnimated = TRANSITION && Browser.any3d && !Browser.mobileOpera && this.options.zoomAnimation;
            // zoom transitions run with the same duration for all layers, so if one of transitionend events
            // happens after starting zoom animation (propagating to the map pane), we know that it ended globally
            if (this._zoomAnimated) {
                this._createAnimProxy();
                on(this._proxy, TRANSITION_END, this._catchTransitionEnd, this);
            }
            this._addLayers(this.options.layers);
        },
        // @section Methods for modifying map state
        // @method setView(center: LatLng, zoom: Number, options?: Zoom/pan options): this
        // Sets the view of the map (geographical center and zoom) with the given
        // animation options.
        setView: function(center, zoom, options) {
            zoom = zoom === undefined ? this._zoom : this._limitZoom(zoom);
            center = this._limitCenter(toLatLng(center), zoom, this.options.maxBounds);
            options = options || {};
            this._stop();
            if (this._loaded && !options.reset && options !== true) {
                if (options.animate !== undefined) {
                    options.zoom = extend({
                        animate: options.animate
                    }, options.zoom);
                    options.pan = extend({
                        animate: options.animate,
                        duration: options.duration
                    }, options.pan);
                }
                // try animating pan or zoom
                var moved = this._zoom !== zoom ? this._tryAnimatedZoom && this._tryAnimatedZoom(center, zoom, options.zoom) : this._tryAnimatedPan(center, options.pan);
                if (moved) {
                    // prevent resize handler call, the view will refresh after animation anyway
                    clearTimeout(this._sizeTimer);
                    return this;
                }
            }
            // animation didn't start, just reset the map view
            this._resetView(center, zoom, options.pan && options.pan.noMoveStart);
            return this;
        },
        // @method setZoom(zoom: Number, options?: Zoom/pan options): this
        // Sets the zoom of the map.
        setZoom: function(zoom, options) {
            if (!this._loaded) {
                this._zoom = zoom;
                return this;
            }
            return this.setView(this.getCenter(), zoom, {
                zoom: options
            });
        },
        // @method zoomIn(delta?: Number, options?: Zoom options): this
        // Increases the zoom of the map by `delta` ([`zoomDelta`](#map-zoomdelta) by default).
        zoomIn: function(delta, options) {
            delta = delta || (Browser.any3d ? this.options.zoomDelta : 1);
            return this.setZoom(this._zoom + delta, options);
        },
        // @method zoomOut(delta?: Number, options?: Zoom options): this
        // Decreases the zoom of the map by `delta` ([`zoomDelta`](#map-zoomdelta) by default).
        zoomOut: function(delta, options) {
            delta = delta || (Browser.any3d ? this.options.zoomDelta : 1);
            return this.setZoom(this._zoom - delta, options);
        },
        // @method setZoomAround(latlng: LatLng, zoom: Number, options: Zoom options): this
        // Zooms the map while keeping a specified geographical point on the map
        // stationary (e.g. used internally for scroll zoom and double-click zoom).
        // @alternative
        // @method setZoomAround(offset: Point, zoom: Number, options: Zoom options): this
        // Zooms the map while keeping a specified pixel on the map (relative to the top-left corner) stationary.
        setZoomAround: function(latlng, zoom, options) {
            var scale = this.getZoomScale(zoom), viewHalf = this.getSize().divideBy(2), containerPoint = latlng instanceof Point ? latlng : this.latLngToContainerPoint(latlng), centerOffset = containerPoint.subtract(viewHalf).multiplyBy(1 - 1 / scale), newCenter = this.containerPointToLatLng(viewHalf.add(centerOffset));
            return this.setView(newCenter, zoom, {
                zoom: options
            });
        },
        _getBoundsCenterZoom: function(bounds, options) {
            options = options || {};
            bounds = bounds.getBounds ? bounds.getBounds() : toLatLngBounds(bounds);
            var paddingTL = toPoint(options.paddingTopLeft || options.padding || [
                0,
                0
            ]), paddingBR = toPoint(options.paddingBottomRight || options.padding || [
                0,
                0
            ]), zoom = this.getBoundsZoom(bounds, false, paddingTL.add(paddingBR));
            zoom = typeof options.maxZoom === "number" ? Math.min(options.maxZoom, zoom) : zoom;
            if (zoom === Infinity) return {
                center: bounds.getCenter(),
                zoom: zoom
            };
            var paddingOffset = paddingBR.subtract(paddingTL).divideBy(2), swPoint = this.project(bounds.getSouthWest(), zoom), nePoint = this.project(bounds.getNorthEast(), zoom), center = this.unproject(swPoint.add(nePoint).divideBy(2).add(paddingOffset), zoom);
            return {
                center: center,
                zoom: zoom
            };
        },
        // @method fitBounds(bounds: LatLngBounds, options?: fitBounds options): this
        // Sets a map view that contains the given geographical bounds with the
        // maximum zoom level possible.
        fitBounds: function(bounds, options) {
            bounds = toLatLngBounds(bounds);
            if (!bounds.isValid()) throw new Error("Bounds are not valid.");
            var target = this._getBoundsCenterZoom(bounds, options);
            return this.setView(target.center, target.zoom, options);
        },
        // @method fitWorld(options?: fitBounds options): this
        // Sets a map view that mostly contains the whole world with the maximum
        // zoom level possible.
        fitWorld: function(options) {
            return this.fitBounds([
                [
                    -90,
                    -180
                ],
                [
                    90,
                    180
                ]
            ], options);
        },
        // @method panTo(latlng: LatLng, options?: Pan options): this
        // Pans the map to a given center.
        panTo: function(center, options) {
            return this.setView(center, this._zoom, {
                pan: options
            });
        },
        // @method panBy(offset: Point, options?: Pan options): this
        // Pans the map by a given number of pixels (animated).
        panBy: function(offset, options) {
            offset = toPoint(offset).round();
            options = options || {};
            if (!offset.x && !offset.y) return this.fire("moveend");
            // If we pan too far, Chrome gets issues with tiles
            // and makes them disappear or appear in the wrong place (slightly offset) #2602
            if (options.animate !== true && !this.getSize().contains(offset)) {
                this._resetView(this.unproject(this.project(this.getCenter()).add(offset)), this.getZoom());
                return this;
            }
            if (!this._panAnim) {
                this._panAnim = new PosAnimation();
                this._panAnim.on({
                    "step": this._onPanTransitionStep,
                    "end": this._onPanTransitionEnd
                }, this);
            }
            // don't fire movestart if animating inertia
            if (!options.noMoveStart) this.fire("movestart");
            // animate pan unless animate: false specified
            if (options.animate !== false) {
                addClass(this._mapPane, "leaflet-pan-anim");
                var newPos = this._getMapPanePos().subtract(offset).round();
                this._panAnim.run(this._mapPane, newPos, options.duration || 0.25, options.easeLinearity);
            } else {
                this._rawPanBy(offset);
                this.fire("move").fire("moveend");
            }
            return this;
        },
        // @method flyTo(latlng: LatLng, zoom?: Number, options?: Zoom/pan options): this
        // Sets the view of the map (geographical center and zoom) performing a smooth
        // pan-zoom animation.
        flyTo: function(targetCenter, targetZoom, options) {
            options = options || {};
            if (options.animate === false || !Browser.any3d) return this.setView(targetCenter, targetZoom, options);
            this._stop();
            var from = this.project(this.getCenter()), to = this.project(targetCenter), size = this.getSize(), startZoom = this._zoom;
            targetCenter = toLatLng(targetCenter);
            targetZoom = targetZoom === undefined ? startZoom : targetZoom;
            var w0 = Math.max(size.x, size.y), w1 = w0 * this.getZoomScale(startZoom, targetZoom), u1 = to.distanceTo(from) || 1, rho = 1.42, rho2 = rho * rho;
            function r(i) {
                var s1 = i ? -1 : 1, s2 = i ? w1 : w0, t1 = w1 * w1 - w0 * w0 + s1 * rho2 * rho2 * u1 * u1, b1 = 2 * s2 * rho2 * u1, b = t1 / b1, sq = Math.sqrt(b * b + 1) - b;
                // workaround for floating point precision bug when sq = 0, log = -Infinite,
                // thus triggering an infinite loop in flyTo
                var log = sq < 0.000000001 ? -18 : Math.log(sq);
                return log;
            }
            function sinh(n) {
                return (Math.exp(n) - Math.exp(-n)) / 2;
            }
            function cosh(n) {
                return (Math.exp(n) + Math.exp(-n)) / 2;
            }
            function tanh(n) {
                return sinh(n) / cosh(n);
            }
            var r0 = r(0);
            function w(s) {
                return w0 * (cosh(r0) / cosh(r0 + rho * s));
            }
            function u(s) {
                return w0 * (cosh(r0) * tanh(r0 + rho * s) - sinh(r0)) / rho2;
            }
            function easeOut(t) {
                return 1 - Math.pow(1 - t, 1.5);
            }
            var start = Date.now(), S = (r(1) - r0) / rho, duration = options.duration ? 1000 * options.duration : 1000 * S * 0.8;
            function frame() {
                var t = (Date.now() - start) / duration, s = easeOut(t) * S;
                if (t <= 1) {
                    this._flyToFrame = requestAnimFrame(frame, this);
                    this._move(this.unproject(from.add(to.subtract(from).multiplyBy(u(s) / u1)), startZoom), this.getScaleZoom(w0 / w(s), startZoom), {
                        flyTo: true
                    });
                } else this._move(targetCenter, targetZoom)._moveEnd(true);
            }
            this._moveStart(true, options.noMoveStart);
            frame.call(this);
            return this;
        },
        // @method flyToBounds(bounds: LatLngBounds, options?: fitBounds options): this
        // Sets the view of the map with a smooth animation like [`flyTo`](#map-flyto),
        // but takes a bounds parameter like [`fitBounds`](#map-fitbounds).
        flyToBounds: function(bounds, options) {
            var target = this._getBoundsCenterZoom(bounds, options);
            return this.flyTo(target.center, target.zoom, options);
        },
        // @method setMaxBounds(bounds: LatLngBounds): this
        // Restricts the map view to the given bounds (see the [maxBounds](#map-maxbounds) option).
        setMaxBounds: function(bounds) {
            bounds = toLatLngBounds(bounds);
            if (this.listens("moveend", this._panInsideMaxBounds)) this.off("moveend", this._panInsideMaxBounds);
            if (!bounds.isValid()) {
                this.options.maxBounds = null;
                return this;
            }
            this.options.maxBounds = bounds;
            if (this._loaded) this._panInsideMaxBounds();
            return this.on("moveend", this._panInsideMaxBounds);
        },
        // @method setMinZoom(zoom: Number): this
        // Sets the lower limit for the available zoom levels (see the [minZoom](#map-minzoom) option).
        setMinZoom: function(zoom) {
            var oldZoom = this.options.minZoom;
            this.options.minZoom = zoom;
            if (this._loaded && oldZoom !== zoom) {
                this.fire("zoomlevelschange");
                if (this.getZoom() < this.options.minZoom) return this.setZoom(zoom);
            }
            return this;
        },
        // @method setMaxZoom(zoom: Number): this
        // Sets the upper limit for the available zoom levels (see the [maxZoom](#map-maxzoom) option).
        setMaxZoom: function(zoom) {
            var oldZoom = this.options.maxZoom;
            this.options.maxZoom = zoom;
            if (this._loaded && oldZoom !== zoom) {
                this.fire("zoomlevelschange");
                if (this.getZoom() > this.options.maxZoom) return this.setZoom(zoom);
            }
            return this;
        },
        // @method panInsideBounds(bounds: LatLngBounds, options?: Pan options): this
        // Pans the map to the closest view that would lie inside the given bounds (if it's not already), controlling the animation using the options specific, if any.
        panInsideBounds: function(bounds, options) {
            this._enforcingBounds = true;
            var center = this.getCenter(), newCenter = this._limitCenter(center, this._zoom, toLatLngBounds(bounds));
            if (!center.equals(newCenter)) this.panTo(newCenter, options);
            this._enforcingBounds = false;
            return this;
        },
        // @method panInside(latlng: LatLng, options?: padding options): this
        // Pans the map the minimum amount to make the `latlng` visible. Use
        // padding options to fit the display to more restricted bounds.
        // If `latlng` is already within the (optionally padded) display bounds,
        // the map will not be panned.
        panInside: function(latlng, options) {
            options = options || {};
            var paddingTL = toPoint(options.paddingTopLeft || options.padding || [
                0,
                0
            ]), paddingBR = toPoint(options.paddingBottomRight || options.padding || [
                0,
                0
            ]), pixelCenter = this.project(this.getCenter()), pixelPoint = this.project(latlng), pixelBounds = this.getPixelBounds(), paddedBounds = toBounds([
                pixelBounds.min.add(paddingTL),
                pixelBounds.max.subtract(paddingBR)
            ]), paddedSize = paddedBounds.getSize();
            if (!paddedBounds.contains(pixelPoint)) {
                this._enforcingBounds = true;
                var centerOffset = pixelPoint.subtract(paddedBounds.getCenter());
                var offset = paddedBounds.extend(pixelPoint).getSize().subtract(paddedSize);
                pixelCenter.x += centerOffset.x < 0 ? -offset.x : offset.x;
                pixelCenter.y += centerOffset.y < 0 ? -offset.y : offset.y;
                this.panTo(this.unproject(pixelCenter), options);
                this._enforcingBounds = false;
            }
            return this;
        },
        // @method invalidateSize(options: Zoom/pan options): this
        // Checks if the map container size changed and updates the map if so —
        // call it after you've changed the map size dynamically, also animating
        // pan by default. If `options.pan` is `false`, panning will not occur.
        // If `options.debounceMoveend` is `true`, it will delay `moveend` event so
        // that it doesn't happen often even if the method is called many
        // times in a row.
        // @alternative
        // @method invalidateSize(animate: Boolean): this
        // Checks if the map container size changed and updates the map if so —
        // call it after you've changed the map size dynamically, also animating
        // pan by default.
        invalidateSize: function(options) {
            if (!this._loaded) return this;
            options = extend({
                animate: false,
                pan: true
            }, options === true ? {
                animate: true
            } : options);
            var oldSize = this.getSize();
            this._sizeChanged = true;
            this._lastCenter = null;
            var newSize = this.getSize(), oldCenter = oldSize.divideBy(2).round(), newCenter = newSize.divideBy(2).round(), offset = oldCenter.subtract(newCenter);
            if (!offset.x && !offset.y) return this;
            if (options.animate && options.pan) this.panBy(offset);
            else {
                if (options.pan) this._rawPanBy(offset);
                this.fire("move");
                if (options.debounceMoveend) {
                    clearTimeout(this._sizeTimer);
                    this._sizeTimer = setTimeout(bind(this.fire, this, "moveend"), 200);
                } else this.fire("moveend");
            }
            // @section Map state change events
            // @event resize: ResizeEvent
            // Fired when the map is resized.
            return this.fire("resize", {
                oldSize: oldSize,
                newSize: newSize
            });
        },
        // @section Methods for modifying map state
        // @method stop(): this
        // Stops the currently running `panTo` or `flyTo` animation, if any.
        stop: function() {
            this.setZoom(this._limitZoom(this._zoom));
            if (!this.options.zoomSnap) this.fire("viewreset");
            return this._stop();
        },
        // @section Geolocation methods
        // @method locate(options?: Locate options): this
        // Tries to locate the user using the Geolocation API, firing a [`locationfound`](#map-locationfound)
        // event with location data on success or a [`locationerror`](#map-locationerror) event on failure,
        // and optionally sets the map view to the user's location with respect to
        // detection accuracy (or to the world view if geolocation failed).
        // Note that, if your page doesn't use HTTPS, this method will fail in
        // modern browsers ([Chrome 50 and newer](https://sites.google.com/a/chromium.org/dev/Home/chromium-security/deprecating-powerful-features-on-insecure-origins))
        // See `Locate options` for more details.
        locate: function(options) {
            options = this._locateOptions = extend({
                timeout: 10000,
                watch: false
            }, options);
            if (!("geolocation" in navigator)) {
                this._handleGeolocationError({
                    code: 0,
                    message: "Geolocation not supported."
                });
                return this;
            }
            var onResponse = bind(this._handleGeolocationResponse, this), onError = bind(this._handleGeolocationError, this);
            if (options.watch) this._locationWatchId = navigator.geolocation.watchPosition(onResponse, onError, options);
            else navigator.geolocation.getCurrentPosition(onResponse, onError, options);
            return this;
        },
        // @method stopLocate(): this
        // Stops watching location previously initiated by `map.locate({watch: true})`
        // and aborts resetting the map view if map.locate was called with
        // `{setView: true}`.
        stopLocate: function() {
            if (navigator.geolocation && navigator.geolocation.clearWatch) navigator.geolocation.clearWatch(this._locationWatchId);
            if (this._locateOptions) this._locateOptions.setView = false;
            return this;
        },
        _handleGeolocationError: function(error) {
            if (!this._container._leaflet_id) return;
            var c = error.code, message = error.message || (c === 1 ? "permission denied" : c === 2 ? "position unavailable" : "timeout");
            if (this._locateOptions.setView && !this._loaded) this.fitWorld();
            // @section Location events
            // @event locationerror: ErrorEvent
            // Fired when geolocation (using the [`locate`](#map-locate) method) failed.
            this.fire("locationerror", {
                code: c,
                message: "Geolocation error: " + message + "."
            });
        },
        _handleGeolocationResponse: function(pos) {
            if (!this._container._leaflet_id) return;
            var lat = pos.coords.latitude, lng = pos.coords.longitude, latlng = new LatLng(lat, lng), bounds = latlng.toBounds(pos.coords.accuracy * 2), options = this._locateOptions;
            if (options.setView) {
                var zoom = this.getBoundsZoom(bounds);
                this.setView(latlng, options.maxZoom ? Math.min(zoom, options.maxZoom) : zoom);
            }
            var data = {
                latlng: latlng,
                bounds: bounds,
                timestamp: pos.timestamp
            };
            for(var i in pos.coords)if (typeof pos.coords[i] === "number") data[i] = pos.coords[i];
            // @event locationfound: LocationEvent
            // Fired when geolocation (using the [`locate`](#map-locate) method)
            // went successfully.
            this.fire("locationfound", data);
        },
        // TODO Appropriate docs section?
        // @section Other Methods
        // @method addHandler(name: String, HandlerClass: Function): this
        // Adds a new `Handler` to the map, given its name and constructor function.
        addHandler: function(name, HandlerClass) {
            if (!HandlerClass) return this;
            var handler = this[name] = new HandlerClass(this);
            this._handlers.push(handler);
            if (this.options[name]) handler.enable();
            return this;
        },
        // @method remove(): this
        // Destroys the map and clears all related event listeners.
        remove: function() {
            this._initEvents(true);
            if (this.options.maxBounds) this.off("moveend", this._panInsideMaxBounds);
            if (this._containerId !== this._container._leaflet_id) throw new Error("Map container is being reused by another instance");
            try {
                // throws error in IE6-8
                delete this._container._leaflet_id;
                delete this._containerId;
            } catch (e) {
                /*eslint-disable */ this._container._leaflet_id = undefined;
                /* eslint-enable */ this._containerId = undefined;
            }
            if (this._locationWatchId !== undefined) this.stopLocate();
            this._stop();
            remove(this._mapPane);
            if (this._clearControlPos) this._clearControlPos();
            if (this._resizeRequest) {
                cancelAnimFrame(this._resizeRequest);
                this._resizeRequest = null;
            }
            this._clearHandlers();
            if (this._loaded) // @section Map state change events
            // @event unload: Event
            // Fired when the map is destroyed with [remove](#map-remove) method.
            this.fire("unload");
            var i;
            for(i in this._layers)this._layers[i].remove();
            for(i in this._panes)remove(this._panes[i]);
            this._layers = [];
            this._panes = [];
            delete this._mapPane;
            delete this._renderer;
            return this;
        },
        // @section Other Methods
        // @method createPane(name: String, container?: HTMLElement): HTMLElement
        // Creates a new [map pane](#map-pane) with the given name if it doesn't exist already,
        // then returns it. The pane is created as a child of `container`, or
        // as a child of the main map pane if not set.
        createPane: function(name, container) {
            var className = "leaflet-pane" + (name ? " leaflet-" + name.replace("Pane", "") + "-pane" : ""), pane = create$1("div", className, container || this._mapPane);
            if (name) this._panes[name] = pane;
            return pane;
        },
        // @section Methods for Getting Map State
        // @method getCenter(): LatLng
        // Returns the geographical center of the map view
        getCenter: function() {
            this._checkIfLoaded();
            if (this._lastCenter && !this._moved()) return this._lastCenter.clone();
            return this.layerPointToLatLng(this._getCenterLayerPoint());
        },
        // @method getZoom(): Number
        // Returns the current zoom level of the map view
        getZoom: function() {
            return this._zoom;
        },
        // @method getBounds(): LatLngBounds
        // Returns the geographical bounds visible in the current map view
        getBounds: function() {
            var bounds = this.getPixelBounds(), sw = this.unproject(bounds.getBottomLeft()), ne = this.unproject(bounds.getTopRight());
            return new LatLngBounds(sw, ne);
        },
        // @method getMinZoom(): Number
        // Returns the minimum zoom level of the map (if set in the `minZoom` option of the map or of any layers), or `0` by default.
        getMinZoom: function() {
            return this.options.minZoom === undefined ? this._layersMinZoom || 0 : this.options.minZoom;
        },
        // @method getMaxZoom(): Number
        // Returns the maximum zoom level of the map (if set in the `maxZoom` option of the map or of any layers).
        getMaxZoom: function() {
            return this.options.maxZoom === undefined ? this._layersMaxZoom === undefined ? Infinity : this._layersMaxZoom : this.options.maxZoom;
        },
        // @method getBoundsZoom(bounds: LatLngBounds, inside?: Boolean, padding?: Point): Number
        // Returns the maximum zoom level on which the given bounds fit to the map
        // view in its entirety. If `inside` (optional) is set to `true`, the method
        // instead returns the minimum zoom level on which the map view fits into
        // the given bounds in its entirety.
        getBoundsZoom: function(bounds, inside, padding) {
            bounds = toLatLngBounds(bounds);
            padding = toPoint(padding || [
                0,
                0
            ]);
            var zoom = this.getZoom() || 0, min = this.getMinZoom(), max = this.getMaxZoom(), nw = bounds.getNorthWest(), se = bounds.getSouthEast(), size = this.getSize().subtract(padding), boundsSize = toBounds(this.project(se, zoom), this.project(nw, zoom)).getSize(), snap = Browser.any3d ? this.options.zoomSnap : 1, scalex = size.x / boundsSize.x, scaley = size.y / boundsSize.y, scale = inside ? Math.max(scalex, scaley) : Math.min(scalex, scaley);
            zoom = this.getScaleZoom(scale, zoom);
            if (snap) {
                zoom = Math.round(zoom / (snap / 100)) * (snap / 100); // don't jump if within 1% of a snap level
                zoom = inside ? Math.ceil(zoom / snap) * snap : Math.floor(zoom / snap) * snap;
            }
            return Math.max(min, Math.min(max, zoom));
        },
        // @method getSize(): Point
        // Returns the current size of the map container (in pixels).
        getSize: function() {
            if (!this._size || this._sizeChanged) {
                this._size = new Point(this._container.clientWidth || 0, this._container.clientHeight || 0);
                this._sizeChanged = false;
            }
            return this._size.clone();
        },
        // @method getPixelBounds(): Bounds
        // Returns the bounds of the current map view in projected pixel
        // coordinates (sometimes useful in layer and overlay implementations).
        getPixelBounds: function(center, zoom) {
            var topLeftPoint = this._getTopLeftPoint(center, zoom);
            return new Bounds(topLeftPoint, topLeftPoint.add(this.getSize()));
        },
        // TODO: Check semantics - isn't the pixel origin the 0,0 coord relative to
        // the map pane? "left point of the map layer" can be confusing, specially
        // since there can be negative offsets.
        // @method getPixelOrigin(): Point
        // Returns the projected pixel coordinates of the top left point of
        // the map layer (useful in custom layer and overlay implementations).
        getPixelOrigin: function() {
            this._checkIfLoaded();
            return this._pixelOrigin;
        },
        // @method getPixelWorldBounds(zoom?: Number): Bounds
        // Returns the world's bounds in pixel coordinates for zoom level `zoom`.
        // If `zoom` is omitted, the map's current zoom level is used.
        getPixelWorldBounds: function(zoom) {
            return this.options.crs.getProjectedBounds(zoom === undefined ? this.getZoom() : zoom);
        },
        // @section Other Methods
        // @method getPane(pane: String|HTMLElement): HTMLElement
        // Returns a [map pane](#map-pane), given its name or its HTML element (its identity).
        getPane: function(pane) {
            return typeof pane === "string" ? this._panes[pane] : pane;
        },
        // @method getPanes(): Object
        // Returns a plain object containing the names of all [panes](#map-pane) as keys and
        // the panes as values.
        getPanes: function() {
            return this._panes;
        },
        // @method getContainer: HTMLElement
        // Returns the HTML element that contains the map.
        getContainer: function() {
            return this._container;
        },
        // @section Conversion Methods
        // @method getZoomScale(toZoom: Number, fromZoom: Number): Number
        // Returns the scale factor to be applied to a map transition from zoom level
        // `fromZoom` to `toZoom`. Used internally to help with zoom animations.
        getZoomScale: function(toZoom, fromZoom) {
            // TODO replace with universal implementation after refactoring projections
            var crs = this.options.crs;
            fromZoom = fromZoom === undefined ? this._zoom : fromZoom;
            return crs.scale(toZoom) / crs.scale(fromZoom);
        },
        // @method getScaleZoom(scale: Number, fromZoom: Number): Number
        // Returns the zoom level that the map would end up at, if it is at `fromZoom`
        // level and everything is scaled by a factor of `scale`. Inverse of
        // [`getZoomScale`](#map-getZoomScale).
        getScaleZoom: function(scale, fromZoom) {
            var crs = this.options.crs;
            fromZoom = fromZoom === undefined ? this._zoom : fromZoom;
            var zoom = crs.zoom(scale * crs.scale(fromZoom));
            return isNaN(zoom) ? Infinity : zoom;
        },
        // @method project(latlng: LatLng, zoom: Number): Point
        // Projects a geographical coordinate `LatLng` according to the projection
        // of the map's CRS, then scales it according to `zoom` and the CRS's
        // `Transformation`. The result is pixel coordinate relative to
        // the CRS origin.
        project: function(latlng, zoom) {
            zoom = zoom === undefined ? this._zoom : zoom;
            return this.options.crs.latLngToPoint(toLatLng(latlng), zoom);
        },
        // @method unproject(point: Point, zoom: Number): LatLng
        // Inverse of [`project`](#map-project).
        unproject: function(point, zoom) {
            zoom = zoom === undefined ? this._zoom : zoom;
            return this.options.crs.pointToLatLng(toPoint(point), zoom);
        },
        // @method layerPointToLatLng(point: Point): LatLng
        // Given a pixel coordinate relative to the [origin pixel](#map-getpixelorigin),
        // returns the corresponding geographical coordinate (for the current zoom level).
        layerPointToLatLng: function(point) {
            var projectedPoint = toPoint(point).add(this.getPixelOrigin());
            return this.unproject(projectedPoint);
        },
        // @method latLngToLayerPoint(latlng: LatLng): Point
        // Given a geographical coordinate, returns the corresponding pixel coordinate
        // relative to the [origin pixel](#map-getpixelorigin).
        latLngToLayerPoint: function(latlng) {
            var projectedPoint = this.project(toLatLng(latlng))._round();
            return projectedPoint._subtract(this.getPixelOrigin());
        },
        // @method wrapLatLng(latlng: LatLng): LatLng
        // Returns a `LatLng` where `lat` and `lng` has been wrapped according to the
        // map's CRS's `wrapLat` and `wrapLng` properties, if they are outside the
        // CRS's bounds.
        // By default this means longitude is wrapped around the dateline so its
        // value is between -180 and +180 degrees.
        wrapLatLng: function(latlng) {
            return this.options.crs.wrapLatLng(toLatLng(latlng));
        },
        // @method wrapLatLngBounds(bounds: LatLngBounds): LatLngBounds
        // Returns a `LatLngBounds` with the same size as the given one, ensuring that
        // its center is within the CRS's bounds.
        // By default this means the center longitude is wrapped around the dateline so its
        // value is between -180 and +180 degrees, and the majority of the bounds
        // overlaps the CRS's bounds.
        wrapLatLngBounds: function(latlng) {
            return this.options.crs.wrapLatLngBounds(toLatLngBounds(latlng));
        },
        // @method distance(latlng1: LatLng, latlng2: LatLng): Number
        // Returns the distance between two geographical coordinates according to
        // the map's CRS. By default this measures distance in meters.
        distance: function(latlng1, latlng2) {
            return this.options.crs.distance(toLatLng(latlng1), toLatLng(latlng2));
        },
        // @method containerPointToLayerPoint(point: Point): Point
        // Given a pixel coordinate relative to the map container, returns the corresponding
        // pixel coordinate relative to the [origin pixel](#map-getpixelorigin).
        containerPointToLayerPoint: function(point) {
            return toPoint(point).subtract(this._getMapPanePos());
        },
        // @method layerPointToContainerPoint(point: Point): Point
        // Given a pixel coordinate relative to the [origin pixel](#map-getpixelorigin),
        // returns the corresponding pixel coordinate relative to the map container.
        layerPointToContainerPoint: function(point) {
            return toPoint(point).add(this._getMapPanePos());
        },
        // @method containerPointToLatLng(point: Point): LatLng
        // Given a pixel coordinate relative to the map container, returns
        // the corresponding geographical coordinate (for the current zoom level).
        containerPointToLatLng: function(point) {
            var layerPoint = this.containerPointToLayerPoint(toPoint(point));
            return this.layerPointToLatLng(layerPoint);
        },
        // @method latLngToContainerPoint(latlng: LatLng): Point
        // Given a geographical coordinate, returns the corresponding pixel coordinate
        // relative to the map container.
        latLngToContainerPoint: function(latlng) {
            return this.layerPointToContainerPoint(this.latLngToLayerPoint(toLatLng(latlng)));
        },
        // @method mouseEventToContainerPoint(ev: MouseEvent): Point
        // Given a MouseEvent object, returns the pixel coordinate relative to the
        // map container where the event took place.
        mouseEventToContainerPoint: function(e) {
            return getMousePosition(e, this._container);
        },
        // @method mouseEventToLayerPoint(ev: MouseEvent): Point
        // Given a MouseEvent object, returns the pixel coordinate relative to
        // the [origin pixel](#map-getpixelorigin) where the event took place.
        mouseEventToLayerPoint: function(e) {
            return this.containerPointToLayerPoint(this.mouseEventToContainerPoint(e));
        },
        // @method mouseEventToLatLng(ev: MouseEvent): LatLng
        // Given a MouseEvent object, returns geographical coordinate where the
        // event took place.
        mouseEventToLatLng: function(e) {
            return this.layerPointToLatLng(this.mouseEventToLayerPoint(e));
        },
        // map initialization methods
        _initContainer: function(id) {
            var container = this._container = get(id);
            if (!container) throw new Error("Map container not found.");
            else if (container._leaflet_id) throw new Error("Map container is already initialized.");
            on(container, "scroll", this._onScroll, this);
            this._containerId = stamp(container);
        },
        _initLayout: function() {
            var container = this._container;
            this._fadeAnimated = this.options.fadeAnimation && Browser.any3d;
            addClass(container, "leaflet-container" + (Browser.touch ? " leaflet-touch" : "") + (Browser.retina ? " leaflet-retina" : "") + (Browser.ielt9 ? " leaflet-oldie" : "") + (Browser.safari ? " leaflet-safari" : "") + (this._fadeAnimated ? " leaflet-fade-anim" : ""));
            var position = getStyle(container, "position");
            if (position !== "absolute" && position !== "relative" && position !== "fixed" && position !== "sticky") container.style.position = "relative";
            this._initPanes();
            if (this._initControlPos) this._initControlPos();
        },
        _initPanes: function() {
            var panes = this._panes = {};
            this._paneRenderers = {};
            // @section
            //
            // Panes are DOM elements used to control the ordering of layers on the map. You
            // can access panes with [`map.getPane`](#map-getpane) or
            // [`map.getPanes`](#map-getpanes) methods. New panes can be created with the
            // [`map.createPane`](#map-createpane) method.
            //
            // Every map has the following default panes that differ only in zIndex.
            //
            // @pane mapPane: HTMLElement = 'auto'
            // Pane that contains all other map panes
            this._mapPane = this.createPane("mapPane", this._container);
            setPosition(this._mapPane, new Point(0, 0));
            // @pane tilePane: HTMLElement = 200
            // Pane for `GridLayer`s and `TileLayer`s
            this.createPane("tilePane");
            // @pane overlayPane: HTMLElement = 400
            // Pane for vectors (`Path`s, like `Polyline`s and `Polygon`s), `ImageOverlay`s and `VideoOverlay`s
            this.createPane("overlayPane");
            // @pane shadowPane: HTMLElement = 500
            // Pane for overlay shadows (e.g. `Marker` shadows)
            this.createPane("shadowPane");
            // @pane markerPane: HTMLElement = 600
            // Pane for `Icon`s of `Marker`s
            this.createPane("markerPane");
            // @pane tooltipPane: HTMLElement = 650
            // Pane for `Tooltip`s.
            this.createPane("tooltipPane");
            // @pane popupPane: HTMLElement = 700
            // Pane for `Popup`s.
            this.createPane("popupPane");
            if (!this.options.markerZoomAnimation) {
                addClass(panes.markerPane, "leaflet-zoom-hide");
                addClass(panes.shadowPane, "leaflet-zoom-hide");
            }
        },
        // private methods that modify map state
        // @section Map state change events
        _resetView: function(center, zoom, noMoveStart) {
            setPosition(this._mapPane, new Point(0, 0));
            var loading = !this._loaded;
            this._loaded = true;
            zoom = this._limitZoom(zoom);
            this.fire("viewprereset");
            var zoomChanged = this._zoom !== zoom;
            this._moveStart(zoomChanged, noMoveStart)._move(center, zoom)._moveEnd(zoomChanged);
            // @event viewreset: Event
            // Fired when the map needs to redraw its content (this usually happens
            // on map zoom or load). Very useful for creating custom overlays.
            this.fire("viewreset");
            // @event load: Event
            // Fired when the map is initialized (when its center and zoom are set
            // for the first time).
            if (loading) this.fire("load");
        },
        _moveStart: function(zoomChanged, noMoveStart) {
            // @event zoomstart: Event
            // Fired when the map zoom is about to change (e.g. before zoom animation).
            // @event movestart: Event
            // Fired when the view of the map starts changing (e.g. user starts dragging the map).
            if (zoomChanged) this.fire("zoomstart");
            if (!noMoveStart) this.fire("movestart");
            return this;
        },
        _move: function(center, zoom, data, supressEvent) {
            if (zoom === undefined) zoom = this._zoom;
            var zoomChanged = this._zoom !== zoom;
            this._zoom = zoom;
            this._lastCenter = center;
            this._pixelOrigin = this._getNewPixelOrigin(center);
            if (!supressEvent) {
                // @event zoom: Event
                // Fired repeatedly during any change in zoom level,
                // including zoom and fly animations.
                if (zoomChanged || data && data.pinch) this.fire("zoom", data);
                // @event move: Event
                // Fired repeatedly during any movement of the map,
                // including pan and fly animations.
                this.fire("move", data);
            } else if (data && data.pinch) this.fire("zoom", data);
            return this;
        },
        _moveEnd: function(zoomChanged) {
            // @event zoomend: Event
            // Fired when the map zoom changed, after any animations.
            if (zoomChanged) this.fire("zoomend");
            // @event moveend: Event
            // Fired when the center of the map stops changing
            // (e.g. user stopped dragging the map or after non-centered zoom).
            return this.fire("moveend");
        },
        _stop: function() {
            cancelAnimFrame(this._flyToFrame);
            if (this._panAnim) this._panAnim.stop();
            return this;
        },
        _rawPanBy: function(offset) {
            setPosition(this._mapPane, this._getMapPanePos().subtract(offset));
        },
        _getZoomSpan: function() {
            return this.getMaxZoom() - this.getMinZoom();
        },
        _panInsideMaxBounds: function() {
            if (!this._enforcingBounds) this.panInsideBounds(this.options.maxBounds);
        },
        _checkIfLoaded: function() {
            if (!this._loaded) throw new Error("Set map center and zoom first.");
        },
        // DOM event handling
        // @section Interaction events
        _initEvents: function(remove) {
            this._targets = {};
            this._targets[stamp(this._container)] = this;
            var onOff = remove ? off : on;
            // @event click: MouseEvent
            // Fired when the user clicks (or taps) the map.
            // @event dblclick: MouseEvent
            // Fired when the user double-clicks (or double-taps) the map.
            // @event mousedown: MouseEvent
            // Fired when the user pushes the mouse button on the map.
            // @event mouseup: MouseEvent
            // Fired when the user releases the mouse button on the map.
            // @event mouseover: MouseEvent
            // Fired when the mouse enters the map.
            // @event mouseout: MouseEvent
            // Fired when the mouse leaves the map.
            // @event mousemove: MouseEvent
            // Fired while the mouse moves over the map.
            // @event contextmenu: MouseEvent
            // Fired when the user pushes the right mouse button on the map, prevents
            // default browser context menu from showing if there are listeners on
            // this event. Also fired on mobile when the user holds a single touch
            // for a second (also called long press).
            // @event keypress: KeyboardEvent
            // Fired when the user presses a key from the keyboard that produces a character value while the map is focused.
            // @event keydown: KeyboardEvent
            // Fired when the user presses a key from the keyboard while the map is focused. Unlike the `keypress` event,
            // the `keydown` event is fired for keys that produce a character value and for keys
            // that do not produce a character value.
            // @event keyup: KeyboardEvent
            // Fired when the user releases a key from the keyboard while the map is focused.
            onOff(this._container, "click dblclick mousedown mouseup mouseover mouseout mousemove contextmenu keypress keydown keyup", this._handleDOMEvent, this);
            if (this.options.trackResize) onOff(window, "resize", this._onResize, this);
            if (Browser.any3d && this.options.transform3DLimit) (remove ? this.off : this.on).call(this, "moveend", this._onMoveEnd);
        },
        _onResize: function() {
            cancelAnimFrame(this._resizeRequest);
            this._resizeRequest = requestAnimFrame(function() {
                this.invalidateSize({
                    debounceMoveend: true
                });
            }, this);
        },
        _onScroll: function() {
            this._container.scrollTop = 0;
            this._container.scrollLeft = 0;
        },
        _onMoveEnd: function() {
            var pos = this._getMapPanePos();
            if (Math.max(Math.abs(pos.x), Math.abs(pos.y)) >= this.options.transform3DLimit) // https://bugzilla.mozilla.org/show_bug.cgi?id=1203873 but Webkit also have
            // a pixel offset on very high values, see: https://jsfiddle.net/dg6r5hhb/
            this._resetView(this.getCenter(), this.getZoom());
        },
        _findEventTargets: function(e, type) {
            var targets = [], target, isHover = type === "mouseout" || type === "mouseover", src = e.target || e.srcElement, dragging = false;
            while(src){
                target = this._targets[stamp(src)];
                if (target && (type === "click" || type === "preclick") && this._draggableMoved(target)) {
                    // Prevent firing click after you just dragged an object.
                    dragging = true;
                    break;
                }
                if (target && target.listens(type, true)) {
                    if (isHover && !isExternalTarget(src, e)) break;
                    targets.push(target);
                    if (isHover) break;
                }
                if (src === this._container) break;
                src = src.parentNode;
            }
            if (!targets.length && !dragging && !isHover && this.listens(type, true)) targets = [
                this
            ];
            return targets;
        },
        _isClickDisabled: function(el) {
            while(el && el !== this._container){
                if (el["_leaflet_disable_click"]) return true;
                el = el.parentNode;
            }
        },
        _handleDOMEvent: function(e) {
            var el = e.target || e.srcElement;
            if (!this._loaded || el["_leaflet_disable_events"] || e.type === "click" && this._isClickDisabled(el)) return;
            var type = e.type;
            if (type === "mousedown") // prevents outline when clicking on keyboard-focusable element
            preventOutline(el);
            this._fireDOMEvent(e, type);
        },
        _mouseEvents: [
            "click",
            "dblclick",
            "mouseover",
            "mouseout",
            "contextmenu"
        ],
        _fireDOMEvent: function(e, type, canvasTargets) {
            if (e.type === "click") {
                // Fire a synthetic 'preclick' event which propagates up (mainly for closing popups).
                // @event preclick: MouseEvent
                // Fired before mouse click on the map (sometimes useful when you
                // want something to happen on click before any existing click
                // handlers start running).
                var synth = extend({}, e);
                synth.type = "preclick";
                this._fireDOMEvent(synth, synth.type, canvasTargets);
            }
            // Find the layer the event is propagating from and its parents.
            var targets = this._findEventTargets(e, type);
            if (canvasTargets) {
                var filtered = []; // pick only targets with listeners
                for(var i = 0; i < canvasTargets.length; i++)if (canvasTargets[i].listens(type, true)) filtered.push(canvasTargets[i]);
                targets = filtered.concat(targets);
            }
            if (!targets.length) return;
            if (type === "contextmenu") preventDefault(e);
            var target = targets[0];
            var data = {
                originalEvent: e
            };
            if (e.type !== "keypress" && e.type !== "keydown" && e.type !== "keyup") {
                var isMarker = target.getLatLng && (!target._radius || target._radius <= 10);
                data.containerPoint = isMarker ? this.latLngToContainerPoint(target.getLatLng()) : this.mouseEventToContainerPoint(e);
                data.layerPoint = this.containerPointToLayerPoint(data.containerPoint);
                data.latlng = isMarker ? target.getLatLng() : this.layerPointToLatLng(data.layerPoint);
            }
            for(i = 0; i < targets.length; i++){
                targets[i].fire(type, data, true);
                if (data.originalEvent._stopped || targets[i].options.bubblingMouseEvents === false && indexOf(this._mouseEvents, type) !== -1) return;
            }
        },
        _draggableMoved: function(obj) {
            obj = obj.dragging && obj.dragging.enabled() ? obj : this;
            return obj.dragging && obj.dragging.moved() || this.boxZoom && this.boxZoom.moved();
        },
        _clearHandlers: function() {
            for(var i = 0, len = this._handlers.length; i < len; i++)this._handlers[i].disable();
        },
        // @section Other Methods
        // @method whenReady(fn: Function, context?: Object): this
        // Runs the given function `fn` when the map gets initialized with
        // a view (center and zoom) and at least one layer, or immediately
        // if it's already initialized, optionally passing a function context.
        whenReady: function(callback, context) {
            if (this._loaded) callback.call(context || this, {
                target: this
            });
            else this.on("load", callback, context);
            return this;
        },
        // private methods for getting map state
        _getMapPanePos: function() {
            return getPosition(this._mapPane) || new Point(0, 0);
        },
        _moved: function() {
            var pos = this._getMapPanePos();
            return pos && !pos.equals([
                0,
                0
            ]);
        },
        _getTopLeftPoint: function(center, zoom) {
            var pixelOrigin = center && zoom !== undefined ? this._getNewPixelOrigin(center, zoom) : this.getPixelOrigin();
            return pixelOrigin.subtract(this._getMapPanePos());
        },
        _getNewPixelOrigin: function(center, zoom) {
            var viewHalf = this.getSize()._divideBy(2);
            return this.project(center, zoom)._subtract(viewHalf)._add(this._getMapPanePos())._round();
        },
        _latLngToNewLayerPoint: function(latlng, zoom, center) {
            var topLeft = this._getNewPixelOrigin(center, zoom);
            return this.project(latlng, zoom)._subtract(topLeft);
        },
        _latLngBoundsToNewLayerBounds: function(latLngBounds, zoom, center) {
            var topLeft = this._getNewPixelOrigin(center, zoom);
            return toBounds([
                this.project(latLngBounds.getSouthWest(), zoom)._subtract(topLeft),
                this.project(latLngBounds.getNorthWest(), zoom)._subtract(topLeft),
                this.project(latLngBounds.getSouthEast(), zoom)._subtract(topLeft),
                this.project(latLngBounds.getNorthEast(), zoom)._subtract(topLeft)
            ]);
        },
        // layer point of the current center
        _getCenterLayerPoint: function() {
            return this.containerPointToLayerPoint(this.getSize()._divideBy(2));
        },
        // offset of the specified place to the current center in pixels
        _getCenterOffset: function(latlng) {
            return this.latLngToLayerPoint(latlng).subtract(this._getCenterLayerPoint());
        },
        // adjust center for view to get inside bounds
        _limitCenter: function(center, zoom, bounds) {
            if (!bounds) return center;
            var centerPoint = this.project(center, zoom), viewHalf = this.getSize().divideBy(2), viewBounds = new Bounds(centerPoint.subtract(viewHalf), centerPoint.add(viewHalf)), offset = this._getBoundsOffset(viewBounds, bounds, zoom);
            // If offset is less than a pixel, ignore.
            // This prevents unstable projections from getting into
            // an infinite loop of tiny offsets.
            if (Math.abs(offset.x) <= 1 && Math.abs(offset.y) <= 1) return center;
            return this.unproject(centerPoint.add(offset), zoom);
        },
        // adjust offset for view to get inside bounds
        _limitOffset: function(offset, bounds) {
            if (!bounds) return offset;
            var viewBounds = this.getPixelBounds(), newBounds = new Bounds(viewBounds.min.add(offset), viewBounds.max.add(offset));
            return offset.add(this._getBoundsOffset(newBounds, bounds));
        },
        // returns offset needed for pxBounds to get inside maxBounds at a specified zoom
        _getBoundsOffset: function(pxBounds, maxBounds, zoom) {
            var projectedMaxBounds = toBounds(this.project(maxBounds.getNorthEast(), zoom), this.project(maxBounds.getSouthWest(), zoom)), minOffset = projectedMaxBounds.min.subtract(pxBounds.min), maxOffset = projectedMaxBounds.max.subtract(pxBounds.max), dx = this._rebound(minOffset.x, -maxOffset.x), dy = this._rebound(minOffset.y, -maxOffset.y);
            return new Point(dx, dy);
        },
        _rebound: function(left, right) {
            return left + right > 0 ? Math.round(left - right) / 2 : Math.max(0, Math.ceil(left)) - Math.max(0, Math.floor(right));
        },
        _limitZoom: function(zoom) {
            var min = this.getMinZoom(), max = this.getMaxZoom(), snap = Browser.any3d ? this.options.zoomSnap : 1;
            if (snap) zoom = Math.round(zoom / snap) * snap;
            return Math.max(min, Math.min(max, zoom));
        },
        _onPanTransitionStep: function() {
            this.fire("move");
        },
        _onPanTransitionEnd: function() {
            removeClass(this._mapPane, "leaflet-pan-anim");
            this.fire("moveend");
        },
        _tryAnimatedPan: function(center, options) {
            // difference between the new and current centers in pixels
            var offset = this._getCenterOffset(center)._trunc();
            // don't animate too far unless animate: true specified in options
            if ((options && options.animate) !== true && !this.getSize().contains(offset)) return false;
            this.panBy(offset, options);
            return true;
        },
        _createAnimProxy: function() {
            var proxy = this._proxy = create$1("div", "leaflet-proxy leaflet-zoom-animated");
            this._panes.mapPane.appendChild(proxy);
            this.on("zoomanim", function(e) {
                var prop = TRANSFORM, transform = this._proxy.style[prop];
                setTransform(this._proxy, this.project(e.center, e.zoom), this.getZoomScale(e.zoom, 1));
                // workaround for case when transform is the same and so transitionend event is not fired
                if (transform === this._proxy.style[prop] && this._animatingZoom) this._onZoomTransitionEnd();
            }, this);
            this.on("load moveend", this._animMoveEnd, this);
            this._on("unload", this._destroyAnimProxy, this);
        },
        _destroyAnimProxy: function() {
            remove(this._proxy);
            this.off("load moveend", this._animMoveEnd, this);
            delete this._proxy;
        },
        _animMoveEnd: function() {
            var c = this.getCenter(), z = this.getZoom();
            setTransform(this._proxy, this.project(c, z), this.getZoomScale(z, 1));
        },
        _catchTransitionEnd: function(e) {
            if (this._animatingZoom && e.propertyName.indexOf("transform") >= 0) this._onZoomTransitionEnd();
        },
        _nothingToAnimate: function() {
            return !this._container.getElementsByClassName("leaflet-zoom-animated").length;
        },
        _tryAnimatedZoom: function(center, zoom, options) {
            if (this._animatingZoom) return true;
            options = options || {};
            // don't animate if disabled, not supported or zoom difference is too large
            if (!this._zoomAnimated || options.animate === false || this._nothingToAnimate() || Math.abs(zoom - this._zoom) > this.options.zoomAnimationThreshold) return false;
            // offset is the pixel coords of the zoom origin relative to the current center
            var scale = this.getZoomScale(zoom), offset = this._getCenterOffset(center)._divideBy(1 - 1 / scale);
            // don't animate if the zoom origin isn't within one screen from the current center, unless forced
            if (options.animate !== true && !this.getSize().contains(offset)) return false;
            requestAnimFrame(function() {
                this._moveStart(true, options.noMoveStart || false)._animateZoom(center, zoom, true);
            }, this);
            return true;
        },
        _animateZoom: function(center, zoom, startAnim, noUpdate) {
            if (!this._mapPane) return;
            if (startAnim) {
                this._animatingZoom = true;
                // remember what center/zoom to set after animation
                this._animateToCenter = center;
                this._animateToZoom = zoom;
                addClass(this._mapPane, "leaflet-zoom-anim");
            }
            // @section Other Events
            // @event zoomanim: ZoomAnimEvent
            // Fired at least once per zoom animation. For continuous zoom, like pinch zooming, fired once per frame during zoom.
            this.fire("zoomanim", {
                center: center,
                zoom: zoom,
                noUpdate: noUpdate
            });
            if (!this._tempFireZoomEvent) this._tempFireZoomEvent = this._zoom !== this._animateToZoom;
            this._move(this._animateToCenter, this._animateToZoom, undefined, true);
            // Work around webkit not firing 'transitionend', see https://github.com/Leaflet/Leaflet/issues/3689, 2693
            setTimeout(bind(this._onZoomTransitionEnd, this), 250);
        },
        _onZoomTransitionEnd: function() {
            if (!this._animatingZoom) return;
            if (this._mapPane) removeClass(this._mapPane, "leaflet-zoom-anim");
            this._animatingZoom = false;
            this._move(this._animateToCenter, this._animateToZoom, undefined, true);
            if (this._tempFireZoomEvent) this.fire("zoom");
            delete this._tempFireZoomEvent;
            this.fire("move");
            this._moveEnd(true);
        }
    });
    // @section
    // @factory L.map(id: String, options?: Map options)
    // Instantiates a map object given the DOM ID of a `<div>` element
    // and optionally an object literal with `Map options`.
    //
    // @alternative
    // @factory L.map(el: HTMLElement, options?: Map options)
    // Instantiates a map object given an instance of a `<div>` HTML element
    // and optionally an object literal with `Map options`.
    function createMap(id, options) {
        return new Map(id, options);
    }
    /*
   * @class Control
   * @aka L.Control
   * @inherits Class
   *
   * L.Control is a base class for implementing map controls. Handles positioning.
   * All other controls extend from this class.
   */ var Control = Class.extend({
        // @section
        // @aka Control Options
        options: {
            // @option position: String = 'topright'
            // The position of the control (one of the map corners). Possible values are `'topleft'`,
            // `'topright'`, `'bottomleft'` or `'bottomright'`
            position: "topright"
        },
        initialize: function(options) {
            setOptions(this, options);
        },
        /* @section
  	 * Classes extending L.Control will inherit the following methods:
  	 *
  	 * @method getPosition: string
  	 * Returns the position of the control.
  	 */ getPosition: function() {
            return this.options.position;
        },
        // @method setPosition(position: string): this
        // Sets the position of the control.
        setPosition: function(position) {
            var map = this._map;
            if (map) map.removeControl(this);
            this.options.position = position;
            if (map) map.addControl(this);
            return this;
        },
        // @method getContainer: HTMLElement
        // Returns the HTMLElement that contains the control.
        getContainer: function() {
            return this._container;
        },
        // @method addTo(map: Map): this
        // Adds the control to the given map.
        addTo: function(map) {
            this.remove();
            this._map = map;
            var container = this._container = this.onAdd(map), pos = this.getPosition(), corner = map._controlCorners[pos];
            addClass(container, "leaflet-control");
            if (pos.indexOf("bottom") !== -1) corner.insertBefore(container, corner.firstChild);
            else corner.appendChild(container);
            this._map.on("unload", this.remove, this);
            return this;
        },
        // @method remove: this
        // Removes the control from the map it is currently active on.
        remove: function() {
            if (!this._map) return this;
            remove(this._container);
            if (this.onRemove) this.onRemove(this._map);
            this._map.off("unload", this.remove, this);
            this._map = null;
            return this;
        },
        _refocusOnMap: function(e) {
            // if map exists and event is not a keyboard event
            if (this._map && e && e.screenX > 0 && e.screenY > 0) this._map.getContainer().focus();
        }
    });
    var control = function(options) {
        return new Control(options);
    };
    /* @section Extension methods
   * @uninheritable
   *
   * Every control should extend from `L.Control` and (re-)implement the following methods.
   *
   * @method onAdd(map: Map): HTMLElement
   * Should return the container DOM element for the control and add listeners on relevant map events. Called on [`control.addTo(map)`](#control-addTo).
   *
   * @method onRemove(map: Map)
   * Optional method. Should contain all clean up code that removes the listeners previously added in [`onAdd`](#control-onadd). Called on [`control.remove()`](#control-remove).
   */ /* @namespace Map
   * @section Methods for Layers and Controls
   */ Map.include({
        // @method addControl(control: Control): this
        // Adds the given control to the map
        addControl: function(control) {
            control.addTo(this);
            return this;
        },
        // @method removeControl(control: Control): this
        // Removes the given control from the map
        removeControl: function(control) {
            control.remove();
            return this;
        },
        _initControlPos: function() {
            var corners = this._controlCorners = {}, l = "leaflet-", container = this._controlContainer = create$1("div", l + "control-container", this._container);
            function createCorner(vSide, hSide) {
                var className = l + vSide + " " + l + hSide;
                corners[vSide + hSide] = create$1("div", className, container);
            }
            createCorner("top", "left");
            createCorner("top", "right");
            createCorner("bottom", "left");
            createCorner("bottom", "right");
        },
        _clearControlPos: function() {
            for(var i in this._controlCorners)remove(this._controlCorners[i]);
            remove(this._controlContainer);
            delete this._controlCorners;
            delete this._controlContainer;
        }
    });
    /*
   * @class Control.Layers
   * @aka L.Control.Layers
   * @inherits Control
   *
   * The layers control gives users the ability to switch between different base layers and switch overlays on/off (check out the [detailed example](https://leafletjs.com/examples/layers-control/)). Extends `Control`.
   *
   * @example
   *
   * ```js
   * var baseLayers = {
   * 	"Mapbox": mapbox,
   * 	"OpenStreetMap": osm
   * };
   *
   * var overlays = {
   * 	"Marker": marker,
   * 	"Roads": roadsLayer
   * };
   *
   * L.control.layers(baseLayers, overlays).addTo(map);
   * ```
   *
   * The `baseLayers` and `overlays` parameters are object literals with layer names as keys and `Layer` objects as values:
   *
   * ```js
   * {
   *     "<someName1>": layer1,
   *     "<someName2>": layer2
   * }
   * ```
   *
   * The layer names can contain HTML, which allows you to add additional styling to the items:
   *
   * ```js
   * {"<img src='my-layer-icon' /> <span class='my-layer-item'>My Layer</span>": myLayer}
   * ```
   */ var Layers = Control.extend({
        // @section
        // @aka Control.Layers options
        options: {
            // @option collapsed: Boolean = true
            // If `true`, the control will be collapsed into an icon and expanded on mouse hover, touch, or keyboard activation.
            collapsed: true,
            position: "topright",
            // @option autoZIndex: Boolean = true
            // If `true`, the control will assign zIndexes in increasing order to all of its layers so that the order is preserved when switching them on/off.
            autoZIndex: true,
            // @option hideSingleBase: Boolean = false
            // If `true`, the base layers in the control will be hidden when there is only one.
            hideSingleBase: false,
            // @option sortLayers: Boolean = false
            // Whether to sort the layers. When `false`, layers will keep the order
            // in which they were added to the control.
            sortLayers: false,
            // @option sortFunction: Function = *
            // A [compare function](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Array/sort)
            // that will be used for sorting the layers, when `sortLayers` is `true`.
            // The function receives both the `L.Layer` instances and their names, as in
            // `sortFunction(layerA, layerB, nameA, nameB)`.
            // By default, it sorts layers alphabetically by their name.
            sortFunction: function(layerA, layerB, nameA, nameB) {
                return nameA < nameB ? -1 : nameB < nameA ? 1 : 0;
            }
        },
        initialize: function(baseLayers, overlays, options) {
            setOptions(this, options);
            this._layerControlInputs = [];
            this._layers = [];
            this._lastZIndex = 0;
            this._handlingClick = false;
            this._preventClick = false;
            for(var i in baseLayers)this._addLayer(baseLayers[i], i);
            for(i in overlays)this._addLayer(overlays[i], i, true);
        },
        onAdd: function(map) {
            this._initLayout();
            this._update();
            this._map = map;
            map.on("zoomend", this._checkDisabledLayers, this);
            for(var i = 0; i < this._layers.length; i++)this._layers[i].layer.on("add remove", this._onLayerChange, this);
            return this._container;
        },
        addTo: function(map) {
            Control.prototype.addTo.call(this, map);
            // Trigger expand after Layers Control has been inserted into DOM so that is now has an actual height.
            return this._expandIfNotCollapsed();
        },
        onRemove: function() {
            this._map.off("zoomend", this._checkDisabledLayers, this);
            for(var i = 0; i < this._layers.length; i++)this._layers[i].layer.off("add remove", this._onLayerChange, this);
        },
        // @method addBaseLayer(layer: Layer, name: String): this
        // Adds a base layer (radio button entry) with the given name to the control.
        addBaseLayer: function(layer, name) {
            this._addLayer(layer, name);
            return this._map ? this._update() : this;
        },
        // @method addOverlay(layer: Layer, name: String): this
        // Adds an overlay (checkbox entry) with the given name to the control.
        addOverlay: function(layer, name) {
            this._addLayer(layer, name, true);
            return this._map ? this._update() : this;
        },
        // @method removeLayer(layer: Layer): this
        // Remove the given layer from the control.
        removeLayer: function(layer) {
            layer.off("add remove", this._onLayerChange, this);
            var obj = this._getLayer(stamp(layer));
            if (obj) this._layers.splice(this._layers.indexOf(obj), 1);
            return this._map ? this._update() : this;
        },
        // @method expand(): this
        // Expand the control container if collapsed.
        expand: function() {
            addClass(this._container, "leaflet-control-layers-expanded");
            this._section.style.height = null;
            var acceptableHeight = this._map.getSize().y - (this._container.offsetTop + 50);
            if (acceptableHeight < this._section.clientHeight) {
                addClass(this._section, "leaflet-control-layers-scrollbar");
                this._section.style.height = acceptableHeight + "px";
            } else removeClass(this._section, "leaflet-control-layers-scrollbar");
            this._checkDisabledLayers();
            return this;
        },
        // @method collapse(): this
        // Collapse the control container if expanded.
        collapse: function() {
            removeClass(this._container, "leaflet-control-layers-expanded");
            return this;
        },
        _initLayout: function() {
            var className = "leaflet-control-layers", container = this._container = create$1("div", className), collapsed = this.options.collapsed;
            // makes this work on IE touch devices by stopping it from firing a mouseout event when the touch is released
            container.setAttribute("aria-haspopup", true);
            disableClickPropagation(container);
            disableScrollPropagation(container);
            var section = this._section = create$1("section", className + "-list");
            if (collapsed) {
                this._map.on("click", this.collapse, this);
                on(container, {
                    mouseenter: this._expandSafely,
                    mouseleave: this.collapse
                }, this);
            }
            var link = this._layersLink = create$1("a", className + "-toggle", container);
            link.href = "#";
            link.title = "Layers";
            link.setAttribute("role", "button");
            on(link, {
                keydown: function(e) {
                    if (e.keyCode === 13) this._expandSafely();
                },
                // Certain screen readers intercept the key event and instead send a click event
                click: function(e) {
                    preventDefault(e);
                    this._expandSafely();
                }
            }, this);
            if (!collapsed) this.expand();
            this._baseLayersList = create$1("div", className + "-base", section);
            this._separator = create$1("div", className + "-separator", section);
            this._overlaysList = create$1("div", className + "-overlays", section);
            container.appendChild(section);
        },
        _getLayer: function(id) {
            for(var i = 0; i < this._layers.length; i++){
                if (this._layers[i] && stamp(this._layers[i].layer) === id) return this._layers[i];
            }
        },
        _addLayer: function(layer, name, overlay) {
            if (this._map) layer.on("add remove", this._onLayerChange, this);
            this._layers.push({
                layer: layer,
                name: name,
                overlay: overlay
            });
            if (this.options.sortLayers) this._layers.sort(bind(function(a, b) {
                return this.options.sortFunction(a.layer, b.layer, a.name, b.name);
            }, this));
            if (this.options.autoZIndex && layer.setZIndex) {
                this._lastZIndex++;
                layer.setZIndex(this._lastZIndex);
            }
            this._expandIfNotCollapsed();
        },
        _update: function() {
            if (!this._container) return this;
            empty(this._baseLayersList);
            empty(this._overlaysList);
            this._layerControlInputs = [];
            var baseLayersPresent, overlaysPresent, i, obj, baseLayersCount = 0;
            for(i = 0; i < this._layers.length; i++){
                obj = this._layers[i];
                this._addItem(obj);
                overlaysPresent = overlaysPresent || obj.overlay;
                baseLayersPresent = baseLayersPresent || !obj.overlay;
                baseLayersCount += !obj.overlay ? 1 : 0;
            }
            // Hide base layers section if there's only one layer.
            if (this.options.hideSingleBase) {
                baseLayersPresent = baseLayersPresent && baseLayersCount > 1;
                this._baseLayersList.style.display = baseLayersPresent ? "" : "none";
            }
            this._separator.style.display = overlaysPresent && baseLayersPresent ? "" : "none";
            return this;
        },
        _onLayerChange: function(e) {
            if (!this._handlingClick) this._update();
            var obj = this._getLayer(stamp(e.target));
            // @namespace Map
            // @section Layer events
            // @event baselayerchange: LayersControlEvent
            // Fired when the base layer is changed through the [layers control](#control-layers).
            // @event overlayadd: LayersControlEvent
            // Fired when an overlay is selected through the [layers control](#control-layers).
            // @event overlayremove: LayersControlEvent
            // Fired when an overlay is deselected through the [layers control](#control-layers).
            // @namespace Control.Layers
            var type = obj.overlay ? e.type === "add" ? "overlayadd" : "overlayremove" : e.type === "add" ? "baselayerchange" : null;
            if (type) this._map.fire(type, obj);
        },
        // IE7 bugs out if you create a radio dynamically, so you have to do it this hacky way (see https://stackoverflow.com/a/119079)
        _createRadioElement: function(name, checked) {
            var radioHtml = '<input type="radio" class="leaflet-control-layers-selector" name="' + name + '"' + (checked ? ' checked="checked"' : "") + "/>";
            var radioFragment = document.createElement("div");
            radioFragment.innerHTML = radioHtml;
            return radioFragment.firstChild;
        },
        _addItem: function(obj) {
            var label = document.createElement("label"), checked = this._map.hasLayer(obj.layer), input;
            if (obj.overlay) {
                input = document.createElement("input");
                input.type = "checkbox";
                input.className = "leaflet-control-layers-selector";
                input.defaultChecked = checked;
            } else input = this._createRadioElement("leaflet-base-layers_" + stamp(this), checked);
            this._layerControlInputs.push(input);
            input.layerId = stamp(obj.layer);
            on(input, "click", this._onInputClick, this);
            var name = document.createElement("span");
            name.innerHTML = " " + obj.name;
            // Helps from preventing layer control flicker when checkboxes are disabled
            // https://github.com/Leaflet/Leaflet/issues/2771
            var holder = document.createElement("span");
            label.appendChild(holder);
            holder.appendChild(input);
            holder.appendChild(name);
            var container = obj.overlay ? this._overlaysList : this._baseLayersList;
            container.appendChild(label);
            this._checkDisabledLayers();
            return label;
        },
        _onInputClick: function() {
            // expanding the control on mobile with a click can cause adding a layer - we don't want this
            if (this._preventClick) return;
            var inputs = this._layerControlInputs, input, layer;
            var addedLayers = [], removedLayers = [];
            this._handlingClick = true;
            for(var i = inputs.length - 1; i >= 0; i--){
                input = inputs[i];
                layer = this._getLayer(input.layerId).layer;
                if (input.checked) addedLayers.push(layer);
                else if (!input.checked) removedLayers.push(layer);
            }
            // Bugfix issue 2318: Should remove all old layers before readding new ones
            for(i = 0; i < removedLayers.length; i++)if (this._map.hasLayer(removedLayers[i])) this._map.removeLayer(removedLayers[i]);
            for(i = 0; i < addedLayers.length; i++)if (!this._map.hasLayer(addedLayers[i])) this._map.addLayer(addedLayers[i]);
            this._handlingClick = false;
            this._refocusOnMap();
        },
        _checkDisabledLayers: function() {
            var inputs = this._layerControlInputs, input, layer, zoom = this._map.getZoom();
            for(var i = inputs.length - 1; i >= 0; i--){
                input = inputs[i];
                layer = this._getLayer(input.layerId).layer;
                input.disabled = layer.options.minZoom !== undefined && zoom < layer.options.minZoom || layer.options.maxZoom !== undefined && zoom > layer.options.maxZoom;
            }
        },
        _expandIfNotCollapsed: function() {
            if (this._map && !this.options.collapsed) this.expand();
            return this;
        },
        _expandSafely: function() {
            var section = this._section;
            this._preventClick = true;
            on(section, "click", preventDefault);
            this.expand();
            var that = this;
            setTimeout(function() {
                off(section, "click", preventDefault);
                that._preventClick = false;
            });
        }
    });
    // @factory L.control.layers(baselayers?: Object, overlays?: Object, options?: Control.Layers options)
    // Creates a layers control with the given layers. Base layers will be switched with radio buttons, while overlays will be switched with checkboxes. Note that all base layers should be passed in the base layers object, but only one should be added to the map during map instantiation.
    var layers = function(baseLayers, overlays, options) {
        return new Layers(baseLayers, overlays, options);
    };
    /*
   * @class Control.Zoom
   * @aka L.Control.Zoom
   * @inherits Control
   *
   * A basic zoom control with two buttons (zoom in and zoom out). It is put on the map by default unless you set its [`zoomControl` option](#map-zoomcontrol) to `false`. Extends `Control`.
   */ var Zoom = Control.extend({
        // @section
        // @aka Control.Zoom options
        options: {
            position: "topleft",
            // @option zoomInText: String = '<span aria-hidden="true">+</span>'
            // The text set on the 'zoom in' button.
            zoomInText: '<span aria-hidden="true">+</span>',
            // @option zoomInTitle: String = 'Zoom in'
            // The title set on the 'zoom in' button.
            zoomInTitle: "Zoom in",
            // @option zoomOutText: String = '<span aria-hidden="true">&#x2212;</span>'
            // The text set on the 'zoom out' button.
            zoomOutText: '<span aria-hidden="true">&#x2212;</span>',
            // @option zoomOutTitle: String = 'Zoom out'
            // The title set on the 'zoom out' button.
            zoomOutTitle: "Zoom out"
        },
        onAdd: function(map) {
            var zoomName = "leaflet-control-zoom", container = create$1("div", zoomName + " leaflet-bar"), options = this.options;
            this._zoomInButton = this._createButton(options.zoomInText, options.zoomInTitle, zoomName + "-in", container, this._zoomIn);
            this._zoomOutButton = this._createButton(options.zoomOutText, options.zoomOutTitle, zoomName + "-out", container, this._zoomOut);
            this._updateDisabled();
            map.on("zoomend zoomlevelschange", this._updateDisabled, this);
            return container;
        },
        onRemove: function(map) {
            map.off("zoomend zoomlevelschange", this._updateDisabled, this);
        },
        disable: function() {
            this._disabled = true;
            this._updateDisabled();
            return this;
        },
        enable: function() {
            this._disabled = false;
            this._updateDisabled();
            return this;
        },
        _zoomIn: function(e) {
            if (!this._disabled && this._map._zoom < this._map.getMaxZoom()) this._map.zoomIn(this._map.options.zoomDelta * (e.shiftKey ? 3 : 1));
        },
        _zoomOut: function(e) {
            if (!this._disabled && this._map._zoom > this._map.getMinZoom()) this._map.zoomOut(this._map.options.zoomDelta * (e.shiftKey ? 3 : 1));
        },
        _createButton: function(html, title, className, container, fn) {
            var link = create$1("a", className, container);
            link.innerHTML = html;
            link.href = "#";
            link.title = title;
            /*
  		 * Will force screen readers like VoiceOver to read this as "Zoom in - button"
  		 */ link.setAttribute("role", "button");
            link.setAttribute("aria-label", title);
            disableClickPropagation(link);
            on(link, "click", stop);
            on(link, "click", fn, this);
            on(link, "click", this._refocusOnMap, this);
            return link;
        },
        _updateDisabled: function() {
            var map = this._map, className = "leaflet-disabled";
            removeClass(this._zoomInButton, className);
            removeClass(this._zoomOutButton, className);
            this._zoomInButton.setAttribute("aria-disabled", "false");
            this._zoomOutButton.setAttribute("aria-disabled", "false");
            if (this._disabled || map._zoom === map.getMinZoom()) {
                addClass(this._zoomOutButton, className);
                this._zoomOutButton.setAttribute("aria-disabled", "true");
            }
            if (this._disabled || map._zoom === map.getMaxZoom()) {
                addClass(this._zoomInButton, className);
                this._zoomInButton.setAttribute("aria-disabled", "true");
            }
        }
    });
    // @namespace Map
    // @section Control options
    // @option zoomControl: Boolean = true
    // Whether a [zoom control](#control-zoom) is added to the map by default.
    Map.mergeOptions({
        zoomControl: true
    });
    Map.addInitHook(function() {
        if (this.options.zoomControl) {
            // @section Controls
            // @property zoomControl: Control.Zoom
            // The default zoom control (only available if the
            // [`zoomControl` option](#map-zoomcontrol) was `true` when creating the map).
            this.zoomControl = new Zoom();
            this.addControl(this.zoomControl);
        }
    });
    // @namespace Control.Zoom
    // @factory L.control.zoom(options: Control.Zoom options)
    // Creates a zoom control
    var zoom = function(options) {
        return new Zoom(options);
    };
    /*
   * @class Control.Scale
   * @aka L.Control.Scale
   * @inherits Control
   *
   * A simple scale control that shows the scale of the current center of screen in metric (m/km) and imperial (mi/ft) systems. Extends `Control`.
   *
   * @example
   *
   * ```js
   * L.control.scale().addTo(map);
   * ```
   */ var Scale = Control.extend({
        // @section
        // @aka Control.Scale options
        options: {
            position: "bottomleft",
            // @option maxWidth: Number = 100
            // Maximum width of the control in pixels. The width is set dynamically to show round values (e.g. 100, 200, 500).
            maxWidth: 100,
            // @option metric: Boolean = True
            // Whether to show the metric scale line (m/km).
            metric: true,
            // @option imperial: Boolean = True
            // Whether to show the imperial scale line (mi/ft).
            imperial: true
        },
        onAdd: function(map) {
            var className = "leaflet-control-scale", container = create$1("div", className), options = this.options;
            this._addScales(options, className + "-line", container);
            map.on(options.updateWhenIdle ? "moveend" : "move", this._update, this);
            map.whenReady(this._update, this);
            return container;
        },
        onRemove: function(map) {
            map.off(this.options.updateWhenIdle ? "moveend" : "move", this._update, this);
        },
        _addScales: function(options, className, container) {
            if (options.metric) this._mScale = create$1("div", className, container);
            if (options.imperial) this._iScale = create$1("div", className, container);
        },
        _update: function() {
            var map = this._map, y = map.getSize().y / 2;
            var maxMeters = map.distance(map.containerPointToLatLng([
                0,
                y
            ]), map.containerPointToLatLng([
                this.options.maxWidth,
                y
            ]));
            this._updateScales(maxMeters);
        },
        _updateScales: function(maxMeters) {
            if (this.options.metric && maxMeters) this._updateMetric(maxMeters);
            if (this.options.imperial && maxMeters) this._updateImperial(maxMeters);
        },
        _updateMetric: function(maxMeters) {
            var meters = this._getRoundNum(maxMeters), label = meters < 1000 ? meters + " m" : meters / 1000 + " km";
            this._updateScale(this._mScale, label, meters / maxMeters);
        },
        _updateImperial: function(maxMeters) {
            var maxFeet = maxMeters * 3.2808399, maxMiles, miles, feet;
            if (maxFeet > 5280) {
                maxMiles = maxFeet / 5280;
                miles = this._getRoundNum(maxMiles);
                this._updateScale(this._iScale, miles + " mi", miles / maxMiles);
            } else {
                feet = this._getRoundNum(maxFeet);
                this._updateScale(this._iScale, feet + " ft", feet / maxFeet);
            }
        },
        _updateScale: function(scale, text, ratio) {
            scale.style.width = Math.round(this.options.maxWidth * ratio) + "px";
            scale.innerHTML = text;
        },
        _getRoundNum: function(num) {
            var pow10 = Math.pow(10, (Math.floor(num) + "").length - 1), d = num / pow10;
            d = d >= 10 ? 10 : d >= 5 ? 5 : d >= 3 ? 3 : d >= 2 ? 2 : 1;
            return pow10 * d;
        }
    });
    // @factory L.control.scale(options?: Control.Scale options)
    // Creates an scale control with the given options.
    var scale = function(options) {
        return new Scale(options);
    };
    var ukrainianFlag = '<svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="12" height="8" viewBox="0 0 12 8" class="leaflet-attribution-flag"><path fill="#4C7BE1" d="M0 0h12v4H0z"/><path fill="#FFD500" d="M0 4h12v3H0z"/><path fill="#E0BC00" d="M0 7h12v1H0z"/></svg>';
    /*
   * @class Control.Attribution
   * @aka L.Control.Attribution
   * @inherits Control
   *
   * The attribution control allows you to display attribution data in a small text box on a map. It is put on the map by default unless you set its [`attributionControl` option](#map-attributioncontrol) to `false`, and it fetches attribution texts from layers with the [`getAttribution` method](#layer-getattribution) automatically. Extends Control.
   */ var Attribution = Control.extend({
        // @section
        // @aka Control.Attribution options
        options: {
            position: "bottomright",
            // @option prefix: String|false = 'Leaflet'
            // The HTML text shown before the attributions. Pass `false` to disable.
            prefix: '<a href="https://leafletjs.com" title="A JavaScript library for interactive maps">' + (Browser.inlineSvg ? ukrainianFlag + " " : "") + "Leaflet</a>"
        },
        initialize: function(options) {
            setOptions(this, options);
            this._attributions = {};
        },
        onAdd: function(map) {
            map.attributionControl = this;
            this._container = create$1("div", "leaflet-control-attribution");
            disableClickPropagation(this._container);
            // TODO ugly, refactor
            for(var i in map._layers)if (map._layers[i].getAttribution) this.addAttribution(map._layers[i].getAttribution());
            this._update();
            map.on("layeradd", this._addAttribution, this);
            return this._container;
        },
        onRemove: function(map) {
            map.off("layeradd", this._addAttribution, this);
        },
        _addAttribution: function(ev) {
            if (ev.layer.getAttribution) {
                this.addAttribution(ev.layer.getAttribution());
                ev.layer.once("remove", function() {
                    this.removeAttribution(ev.layer.getAttribution());
                }, this);
            }
        },
        // @method setPrefix(prefix: String|false): this
        // The HTML text shown before the attributions. Pass `false` to disable.
        setPrefix: function(prefix) {
            this.options.prefix = prefix;
            this._update();
            return this;
        },
        // @method addAttribution(text: String): this
        // Adds an attribution text (e.g. `'&copy; OpenStreetMap contributors'`).
        addAttribution: function(text) {
            if (!text) return this;
            if (!this._attributions[text]) this._attributions[text] = 0;
            this._attributions[text]++;
            this._update();
            return this;
        },
        // @method removeAttribution(text: String): this
        // Removes an attribution text.
        removeAttribution: function(text) {
            if (!text) return this;
            if (this._attributions[text]) {
                this._attributions[text]--;
                this._update();
            }
            return this;
        },
        _update: function() {
            if (!this._map) return;
            var attribs = [];
            for(var i in this._attributions)if (this._attributions[i]) attribs.push(i);
            var prefixAndAttribs = [];
            if (this.options.prefix) prefixAndAttribs.push(this.options.prefix);
            if (attribs.length) prefixAndAttribs.push(attribs.join(", "));
            this._container.innerHTML = prefixAndAttribs.join(' <span aria-hidden="true">|</span> ');
        }
    });
    // @namespace Map
    // @section Control options
    // @option attributionControl: Boolean = true
    // Whether a [attribution control](#control-attribution) is added to the map by default.
    Map.mergeOptions({
        attributionControl: true
    });
    Map.addInitHook(function() {
        if (this.options.attributionControl) new Attribution().addTo(this);
    });
    // @namespace Control.Attribution
    // @factory L.control.attribution(options: Control.Attribution options)
    // Creates an attribution control.
    var attribution = function(options) {
        return new Attribution(options);
    };
    Control.Layers = Layers;
    Control.Zoom = Zoom;
    Control.Scale = Scale;
    Control.Attribution = Attribution;
    control.layers = layers;
    control.zoom = zoom;
    control.scale = scale;
    control.attribution = attribution;
    /*
  	L.Handler is a base class for handler classes that are used internally to inject
  	interaction features like dragging to classes like Map and Marker.
  */ // @class Handler
    // @aka L.Handler
    // Abstract class for map interaction handlers
    var Handler = Class.extend({
        initialize: function(map) {
            this._map = map;
        },
        // @method enable(): this
        // Enables the handler
        enable: function() {
            if (this._enabled) return this;
            this._enabled = true;
            this.addHooks();
            return this;
        },
        // @method disable(): this
        // Disables the handler
        disable: function() {
            if (!this._enabled) return this;
            this._enabled = false;
            this.removeHooks();
            return this;
        },
        // @method enabled(): Boolean
        // Returns `true` if the handler is enabled
        enabled: function() {
            return !!this._enabled;
        }
    });
    // @section There is static function which can be called without instantiating L.Handler:
    // @function addTo(map: Map, name: String): this
    // Adds a new Handler to the given map with the given name.
    Handler.addTo = function(map, name) {
        map.addHandler(name, this);
        return this;
    };
    var Mixin = {
        Events: Events
    };
    /*
   * @class Draggable
   * @aka L.Draggable
   * @inherits Evented
   *
   * A class for making DOM elements draggable (including touch support).
   * Used internally for map and marker dragging. Only works for elements
   * that were positioned with [`L.DomUtil.setPosition`](#domutil-setposition).
   *
   * @example
   * ```js
   * var draggable = new L.Draggable(elementToDrag);
   * draggable.enable();
   * ```
   */ var START = Browser.touch ? "touchstart mousedown" : "mousedown";
    var Draggable = Evented.extend({
        options: {
            // @section
            // @aka Draggable options
            // @option clickTolerance: Number = 3
            // The max number of pixels a user can shift the mouse pointer during a click
            // for it to be considered a valid click (as opposed to a mouse drag).
            clickTolerance: 3
        },
        // @constructor L.Draggable(el: HTMLElement, dragHandle?: HTMLElement, preventOutline?: Boolean, options?: Draggable options)
        // Creates a `Draggable` object for moving `el` when you start dragging the `dragHandle` element (equals `el` itself by default).
        initialize: function(element, dragStartTarget, preventOutline, options) {
            setOptions(this, options);
            this._element = element;
            this._dragStartTarget = dragStartTarget || element;
            this._preventOutline = preventOutline;
        },
        // @method enable()
        // Enables the dragging ability
        enable: function() {
            if (this._enabled) return;
            on(this._dragStartTarget, START, this._onDown, this);
            this._enabled = true;
        },
        // @method disable()
        // Disables the dragging ability
        disable: function() {
            if (!this._enabled) return;
            // If we're currently dragging this draggable,
            // disabling it counts as first ending the drag.
            if (Draggable._dragging === this) this.finishDrag(true);
            off(this._dragStartTarget, START, this._onDown, this);
            this._enabled = false;
            this._moved = false;
        },
        _onDown: function(e) {
            // Ignore the event if disabled; this happens in IE11
            // under some circumstances, see #3666.
            if (!this._enabled) return;
            this._moved = false;
            if (hasClass(this._element, "leaflet-zoom-anim")) return;
            if (e.touches && e.touches.length !== 1) {
                // Finish dragging to avoid conflict with touchZoom
                if (Draggable._dragging === this) this.finishDrag();
                return;
            }
            if (Draggable._dragging || e.shiftKey || e.which !== 1 && e.button !== 1 && !e.touches) return;
            Draggable._dragging = this; // Prevent dragging multiple objects at once.
            if (this._preventOutline) preventOutline(this._element);
            disableImageDrag();
            disableTextSelection();
            if (this._moving) return;
            // @event down: Event
            // Fired when a drag is about to start.
            this.fire("down");
            var first = e.touches ? e.touches[0] : e, sizedParent = getSizedParentNode(this._element);
            this._startPoint = new Point(first.clientX, first.clientY);
            this._startPos = getPosition(this._element);
            // Cache the scale, so that we can continuously compensate for it during drag (_onMove).
            this._parentScale = getScale(sizedParent);
            var mouseevent = e.type === "mousedown";
            on(document, mouseevent ? "mousemove" : "touchmove", this._onMove, this);
            on(document, mouseevent ? "mouseup" : "touchend touchcancel", this._onUp, this);
        },
        _onMove: function(e) {
            // Ignore the event if disabled; this happens in IE11
            // under some circumstances, see #3666.
            if (!this._enabled) return;
            if (e.touches && e.touches.length > 1) {
                this._moved = true;
                return;
            }
            var first = e.touches && e.touches.length === 1 ? e.touches[0] : e, offset = new Point(first.clientX, first.clientY)._subtract(this._startPoint);
            if (!offset.x && !offset.y) return;
            if (Math.abs(offset.x) + Math.abs(offset.y) < this.options.clickTolerance) return;
            // We assume that the parent container's position, border and scale do not change for the duration of the drag.
            // Therefore there is no need to account for the position and border (they are eliminated by the subtraction)
            // and we can use the cached value for the scale.
            offset.x /= this._parentScale.x;
            offset.y /= this._parentScale.y;
            preventDefault(e);
            if (!this._moved) {
                // @event dragstart: Event
                // Fired when a drag starts
                this.fire("dragstart");
                this._moved = true;
                addClass(document.body, "leaflet-dragging");
                this._lastTarget = e.target || e.srcElement;
                // IE and Edge do not give the <use> element, so fetch it
                // if necessary
                if (window.SVGElementInstance && this._lastTarget instanceof window.SVGElementInstance) this._lastTarget = this._lastTarget.correspondingUseElement;
                addClass(this._lastTarget, "leaflet-drag-target");
            }
            this._newPos = this._startPos.add(offset);
            this._moving = true;
            this._lastEvent = e;
            this._updatePosition();
        },
        _updatePosition: function() {
            var e = {
                originalEvent: this._lastEvent
            };
            // @event predrag: Event
            // Fired continuously during dragging *before* each corresponding
            // update of the element's position.
            this.fire("predrag", e);
            setPosition(this._element, this._newPos);
            // @event drag: Event
            // Fired continuously during dragging.
            this.fire("drag", e);
        },
        _onUp: function() {
            // Ignore the event if disabled; this happens in IE11
            // under some circumstances, see #3666.
            if (!this._enabled) return;
            this.finishDrag();
        },
        finishDrag: function(noInertia) {
            removeClass(document.body, "leaflet-dragging");
            if (this._lastTarget) {
                removeClass(this._lastTarget, "leaflet-drag-target");
                this._lastTarget = null;
            }
            off(document, "mousemove touchmove", this._onMove, this);
            off(document, "mouseup touchend touchcancel", this._onUp, this);
            enableImageDrag();
            enableTextSelection();
            var fireDragend = this._moved && this._moving;
            this._moving = false;
            Draggable._dragging = false;
            if (fireDragend) // @event dragend: DragEndEvent
            // Fired when the drag ends.
            this.fire("dragend", {
                noInertia: noInertia,
                distance: this._newPos.distanceTo(this._startPos)
            });
        }
    });
    /*
   * @namespace PolyUtil
   * Various utility functions for polygon geometries.
   */ /* @function clipPolygon(points: Point[], bounds: Bounds, round?: Boolean): Point[]
   * Clips the polygon geometry defined by the given `points` by the given bounds (using the [Sutherland-Hodgman algorithm](https://en.wikipedia.org/wiki/Sutherland%E2%80%93Hodgman_algorithm)).
   * Used by Leaflet to only show polygon points that are on the screen or near, increasing
   * performance. Note that polygon points needs different algorithm for clipping
   * than polyline, so there's a separate method for it.
   */ function clipPolygon(points, bounds, round) {
        var clippedPoints, edges = [
            1,
            4,
            2,
            8
        ], i, j, k, a, b, len, edge, p;
        for(i = 0, len = points.length; i < len; i++)points[i]._code = _getBitCode(points[i], bounds);
        // for each edge (left, bottom, right, top)
        for(k = 0; k < 4; k++){
            edge = edges[k];
            clippedPoints = [];
            for(i = 0, len = points.length, j = len - 1; i < len; j = i++){
                a = points[i];
                b = points[j];
                // if a is inside the clip window
                if (!(a._code & edge)) {
                    // if b is outside the clip window (a->b goes out of screen)
                    if (b._code & edge) {
                        p = _getEdgeIntersection(b, a, edge, bounds, round);
                        p._code = _getBitCode(p, bounds);
                        clippedPoints.push(p);
                    }
                    clippedPoints.push(a);
                // else if b is inside the clip window (a->b enters the screen)
                } else if (!(b._code & edge)) {
                    p = _getEdgeIntersection(b, a, edge, bounds, round);
                    p._code = _getBitCode(p, bounds);
                    clippedPoints.push(p);
                }
            }
            points = clippedPoints;
        }
        return points;
    }
    /* @function polygonCenter(latlngs: LatLng[], crs: CRS): LatLng
   * Returns the center ([centroid](http://en.wikipedia.org/wiki/Centroid)) of the passed LatLngs (first ring) from a polygon.
   */ function polygonCenter(latlngs, crs) {
        var i, j, p1, p2, f, area, x, y, center;
        if (!latlngs || latlngs.length === 0) throw new Error("latlngs not passed");
        if (!isFlat(latlngs)) {
            console.warn("latlngs are not flat! Only the first ring will be used");
            latlngs = latlngs[0];
        }
        var centroidLatLng = toLatLng([
            0,
            0
        ]);
        var bounds = toLatLngBounds(latlngs);
        var areaBounds = bounds.getNorthWest().distanceTo(bounds.getSouthWest()) * bounds.getNorthEast().distanceTo(bounds.getNorthWest());
        // tests showed that below 1700 rounding errors are happening
        if (areaBounds < 1700) // getting a inexact center, to move the latlngs near to [0, 0] to prevent rounding errors
        centroidLatLng = centroid(latlngs);
        var len = latlngs.length;
        var points = [];
        for(i = 0; i < len; i++){
            var latlng = toLatLng(latlngs[i]);
            points.push(crs.project(toLatLng([
                latlng.lat - centroidLatLng.lat,
                latlng.lng - centroidLatLng.lng
            ])));
        }
        area = x = y = 0;
        // polygon centroid algorithm;
        for(i = 0, j = len - 1; i < len; j = i++){
            p1 = points[i];
            p2 = points[j];
            f = p1.y * p2.x - p2.y * p1.x;
            x += (p1.x + p2.x) * f;
            y += (p1.y + p2.y) * f;
            area += f * 3;
        }
        if (area === 0) // Polygon is so small that all points are on same pixel.
        center = points[0];
        else center = [
            x / area,
            y / area
        ];
        var latlngCenter = crs.unproject(toPoint(center));
        return toLatLng([
            latlngCenter.lat + centroidLatLng.lat,
            latlngCenter.lng + centroidLatLng.lng
        ]);
    }
    /* @function centroid(latlngs: LatLng[]): LatLng
   * Returns the 'center of mass' of the passed LatLngs.
   */ function centroid(coords) {
        var latSum = 0;
        var lngSum = 0;
        var len = 0;
        for(var i = 0; i < coords.length; i++){
            var latlng = toLatLng(coords[i]);
            latSum += latlng.lat;
            lngSum += latlng.lng;
            len++;
        }
        return toLatLng([
            latSum / len,
            lngSum / len
        ]);
    }
    var PolyUtil = {
        __proto__: null,
        clipPolygon: clipPolygon,
        polygonCenter: polygonCenter,
        centroid: centroid
    };
    /*
   * @namespace LineUtil
   *
   * Various utility functions for polyline points processing, used by Leaflet internally to make polylines lightning-fast.
   */ // Simplify polyline with vertex reduction and Douglas-Peucker simplification.
    // Improves rendering performance dramatically by lessening the number of points to draw.
    // @function simplify(points: Point[], tolerance: Number): Point[]
    // Dramatically reduces the number of points in a polyline while retaining
    // its shape and returns a new array of simplified points, using the
    // [Ramer-Douglas-Peucker algorithm](https://en.wikipedia.org/wiki/Ramer-Douglas-Peucker_algorithm).
    // Used for a huge performance boost when processing/displaying Leaflet polylines for
    // each zoom level and also reducing visual noise. tolerance affects the amount of
    // simplification (lesser value means higher quality but slower and with more points).
    // Also released as a separated micro-library [Simplify.js](https://mourner.github.io/simplify-js/).
    function simplify(points, tolerance) {
        if (!tolerance || !points.length) return points.slice();
        var sqTolerance = tolerance * tolerance;
        // stage 1: vertex reduction
        points = _reducePoints(points, sqTolerance);
        // stage 2: Douglas-Peucker simplification
        points = _simplifyDP(points, sqTolerance);
        return points;
    }
    // @function pointToSegmentDistance(p: Point, p1: Point, p2: Point): Number
    // Returns the distance between point `p` and segment `p1` to `p2`.
    function pointToSegmentDistance(p, p1, p2) {
        return Math.sqrt(_sqClosestPointOnSegment(p, p1, p2, true));
    }
    // @function closestPointOnSegment(p: Point, p1: Point, p2: Point): Number
    // Returns the closest point from a point `p` on a segment `p1` to `p2`.
    function closestPointOnSegment(p, p1, p2) {
        return _sqClosestPointOnSegment(p, p1, p2);
    }
    // Ramer-Douglas-Peucker simplification, see https://en.wikipedia.org/wiki/Ramer-Douglas-Peucker_algorithm
    function _simplifyDP(points, sqTolerance) {
        var len = points.length, ArrayConstructor = typeof Uint8Array !== "undefined" ? Uint8Array : Array, markers = new ArrayConstructor(len);
        markers[0] = markers[len - 1] = 1;
        _simplifyDPStep(points, markers, sqTolerance, 0, len - 1);
        var i, newPoints = [];
        for(i = 0; i < len; i++)if (markers[i]) newPoints.push(points[i]);
        return newPoints;
    }
    function _simplifyDPStep(points, markers, sqTolerance, first, last) {
        var maxSqDist = 0, index, i, sqDist;
        for(i = first + 1; i <= last - 1; i++){
            sqDist = _sqClosestPointOnSegment(points[i], points[first], points[last], true);
            if (sqDist > maxSqDist) {
                index = i;
                maxSqDist = sqDist;
            }
        }
        if (maxSqDist > sqTolerance) {
            markers[index] = 1;
            _simplifyDPStep(points, markers, sqTolerance, first, index);
            _simplifyDPStep(points, markers, sqTolerance, index, last);
        }
    }
    // reduce points that are too close to each other to a single point
    function _reducePoints(points, sqTolerance) {
        var reducedPoints = [
            points[0]
        ];
        for(var i = 1, prev = 0, len = points.length; i < len; i++)if (_sqDist(points[i], points[prev]) > sqTolerance) {
            reducedPoints.push(points[i]);
            prev = i;
        }
        if (prev < len - 1) reducedPoints.push(points[len - 1]);
        return reducedPoints;
    }
    var _lastCode;
    // @function clipSegment(a: Point, b: Point, bounds: Bounds, useLastCode?: Boolean, round?: Boolean): Point[]|Boolean
    // Clips the segment a to b by rectangular bounds with the
    // [Cohen-Sutherland algorithm](https://en.wikipedia.org/wiki/Cohen%E2%80%93Sutherland_algorithm)
    // (modifying the segment points directly!). Used by Leaflet to only show polyline
    // points that are on the screen or near, increasing performance.
    function clipSegment(a, b, bounds, useLastCode, round) {
        var codeA = useLastCode ? _lastCode : _getBitCode(a, bounds), codeB = _getBitCode(b, bounds), codeOut, p, newCode;
        // save 2nd code to avoid calculating it on the next segment
        _lastCode = codeB;
        while(true){
            // if a,b is inside the clip window (trivial accept)
            if (!(codeA | codeB)) return [
                a,
                b
            ];
            // if a,b is outside the clip window (trivial reject)
            if (codeA & codeB) return false;
            // other cases
            codeOut = codeA || codeB;
            p = _getEdgeIntersection(a, b, codeOut, bounds, round);
            newCode = _getBitCode(p, bounds);
            if (codeOut === codeA) {
                a = p;
                codeA = newCode;
            } else {
                b = p;
                codeB = newCode;
            }
        }
    }
    function _getEdgeIntersection(a, b, code, bounds, round) {
        var dx = b.x - a.x, dy = b.y - a.y, min = bounds.min, max = bounds.max, x, y;
        if (code & 8) {
            x = a.x + dx * (max.y - a.y) / dy;
            y = max.y;
        } else if (code & 4) {
            x = a.x + dx * (min.y - a.y) / dy;
            y = min.y;
        } else if (code & 2) {
            x = max.x;
            y = a.y + dy * (max.x - a.x) / dx;
        } else if (code & 1) {
            x = min.x;
            y = a.y + dy * (min.x - a.x) / dx;
        }
        return new Point(x, y, round);
    }
    function _getBitCode(p, bounds) {
        var code = 0;
        if (p.x < bounds.min.x) code |= 1;
        else if (p.x > bounds.max.x) code |= 2;
        if (p.y < bounds.min.y) code |= 4;
        else if (p.y > bounds.max.y) code |= 8;
        return code;
    }
    // square distance (to avoid unnecessary Math.sqrt calls)
    function _sqDist(p1, p2) {
        var dx = p2.x - p1.x, dy = p2.y - p1.y;
        return dx * dx + dy * dy;
    }
    // return closest point on segment or distance to that point
    function _sqClosestPointOnSegment(p, p1, p2, sqDist) {
        var x = p1.x, y = p1.y, dx = p2.x - x, dy = p2.y - y, dot = dx * dx + dy * dy, t;
        if (dot > 0) {
            t = ((p.x - x) * dx + (p.y - y) * dy) / dot;
            if (t > 1) {
                x = p2.x;
                y = p2.y;
            } else if (t > 0) {
                x += dx * t;
                y += dy * t;
            }
        }
        dx = p.x - x;
        dy = p.y - y;
        return sqDist ? dx * dx + dy * dy : new Point(x, y);
    }
    // @function isFlat(latlngs: LatLng[]): Boolean
    // Returns true if `latlngs` is a flat array, false is nested.
    function isFlat(latlngs) {
        return !isArray(latlngs[0]) || typeof latlngs[0][0] !== "object" && typeof latlngs[0][0] !== "undefined";
    }
    function _flat(latlngs) {
        console.warn("Deprecated use of _flat, please use L.LineUtil.isFlat instead.");
        return isFlat(latlngs);
    }
    /* @function polylineCenter(latlngs: LatLng[], crs: CRS): LatLng
   * Returns the center ([centroid](http://en.wikipedia.org/wiki/Centroid)) of the passed LatLngs (first ring) from a polyline.
   */ function polylineCenter(latlngs, crs) {
        var i, halfDist, segDist, dist, p1, p2, ratio, center;
        if (!latlngs || latlngs.length === 0) throw new Error("latlngs not passed");
        if (!isFlat(latlngs)) {
            console.warn("latlngs are not flat! Only the first ring will be used");
            latlngs = latlngs[0];
        }
        var centroidLatLng = toLatLng([
            0,
            0
        ]);
        var bounds = toLatLngBounds(latlngs);
        var areaBounds = bounds.getNorthWest().distanceTo(bounds.getSouthWest()) * bounds.getNorthEast().distanceTo(bounds.getNorthWest());
        // tests showed that below 1700 rounding errors are happening
        if (areaBounds < 1700) // getting a inexact center, to move the latlngs near to [0, 0] to prevent rounding errors
        centroidLatLng = centroid(latlngs);
        var len = latlngs.length;
        var points = [];
        for(i = 0; i < len; i++){
            var latlng = toLatLng(latlngs[i]);
            points.push(crs.project(toLatLng([
                latlng.lat - centroidLatLng.lat,
                latlng.lng - centroidLatLng.lng
            ])));
        }
        for(i = 0, halfDist = 0; i < len - 1; i++)halfDist += points[i].distanceTo(points[i + 1]) / 2;
        // The line is so small in the current view that all points are on the same pixel.
        if (halfDist === 0) center = points[0];
        else for(i = 0, dist = 0; i < len - 1; i++){
            p1 = points[i];
            p2 = points[i + 1];
            segDist = p1.distanceTo(p2);
            dist += segDist;
            if (dist > halfDist) {
                ratio = (dist - halfDist) / segDist;
                center = [
                    p2.x - ratio * (p2.x - p1.x),
                    p2.y - ratio * (p2.y - p1.y)
                ];
                break;
            }
        }
        var latlngCenter = crs.unproject(toPoint(center));
        return toLatLng([
            latlngCenter.lat + centroidLatLng.lat,
            latlngCenter.lng + centroidLatLng.lng
        ]);
    }
    var LineUtil = {
        __proto__: null,
        simplify: simplify,
        pointToSegmentDistance: pointToSegmentDistance,
        closestPointOnSegment: closestPointOnSegment,
        clipSegment: clipSegment,
        _getEdgeIntersection: _getEdgeIntersection,
        _getBitCode: _getBitCode,
        _sqClosestPointOnSegment: _sqClosestPointOnSegment,
        isFlat: isFlat,
        _flat: _flat,
        polylineCenter: polylineCenter
    };
    /*
   * @namespace Projection
   * @section
   * Leaflet comes with a set of already defined Projections out of the box:
   *
   * @projection L.Projection.LonLat
   *
   * Equirectangular, or Plate Carree projection — the most simple projection,
   * mostly used by GIS enthusiasts. Directly maps `x` as longitude, and `y` as
   * latitude. Also suitable for flat worlds, e.g. game maps. Used by the
   * `EPSG:4326` and `Simple` CRS.
   */ var LonLat = {
        project: function(latlng) {
            return new Point(latlng.lng, latlng.lat);
        },
        unproject: function(point) {
            return new LatLng(point.y, point.x);
        },
        bounds: new Bounds([
            -180,
            -90
        ], [
            180,
            90
        ])
    };
    /*
   * @namespace Projection
   * @projection L.Projection.Mercator
   *
   * Elliptical Mercator projection — more complex than Spherical Mercator. Assumes that Earth is an ellipsoid. Used by the EPSG:3395 CRS.
   */ var Mercator = {
        R: 6378137,
        R_MINOR: 6356752.314245179,
        bounds: new Bounds([
            -20037508.34279,
            -15496570.73972
        ], [
            20037508.34279,
            18764656.23138
        ]),
        project: function(latlng) {
            var d = Math.PI / 180, r = this.R, y = latlng.lat * d, tmp = this.R_MINOR / r, e = Math.sqrt(1 - tmp * tmp), con = e * Math.sin(y);
            var ts = Math.tan(Math.PI / 4 - y / 2) / Math.pow((1 - con) / (1 + con), e / 2);
            y = -r * Math.log(Math.max(ts, 1E-10));
            return new Point(latlng.lng * d * r, y);
        },
        unproject: function(point) {
            var d = 180 / Math.PI, r = this.R, tmp = this.R_MINOR / r, e = Math.sqrt(1 - tmp * tmp), ts = Math.exp(-point.y / r), phi = Math.PI / 2 - 2 * Math.atan(ts);
            for(var i = 0, dphi = 0.1, con; i < 15 && Math.abs(dphi) > 1e-7; i++){
                con = e * Math.sin(phi);
                con = Math.pow((1 - con) / (1 + con), e / 2);
                dphi = Math.PI / 2 - 2 * Math.atan(ts * con) - phi;
                phi += dphi;
            }
            return new LatLng(phi * d, point.x * d / r);
        }
    };
    /*
   * @class Projection

   * An object with methods for projecting geographical coordinates of the world onto
   * a flat surface (and back). See [Map projection](https://en.wikipedia.org/wiki/Map_projection).

   * @property bounds: Bounds
   * The bounds (specified in CRS units) where the projection is valid

   * @method project(latlng: LatLng): Point
   * Projects geographical coordinates into a 2D point.
   * Only accepts actual `L.LatLng` instances, not arrays.

   * @method unproject(point: Point): LatLng
   * The inverse of `project`. Projects a 2D point into a geographical location.
   * Only accepts actual `L.Point` instances, not arrays.

   * Note that the projection instances do not inherit from Leaflet's `Class` object,
   * and can't be instantiated. Also, new classes can't inherit from them,
   * and methods can't be added to them with the `include` function.

   */ var index = {
        __proto__: null,
        LonLat: LonLat,
        Mercator: Mercator,
        SphericalMercator: SphericalMercator
    };
    /*
   * @namespace CRS
   * @crs L.CRS.EPSG3395
   *
   * Rarely used by some commercial tile providers. Uses Elliptical Mercator projection.
   */ var EPSG3395 = extend({}, Earth, {
        code: "EPSG:3395",
        projection: Mercator,
        transformation: function() {
            var scale = 0.5 / (Math.PI * Mercator.R);
            return toTransformation(scale, 0.5, -scale, 0.5);
        }()
    });
    /*
   * @namespace CRS
   * @crs L.CRS.EPSG4326
   *
   * A common CRS among GIS enthusiasts. Uses simple Equirectangular projection.
   *
   * Leaflet 1.0.x complies with the [TMS coordinate scheme for EPSG:4326](https://wiki.osgeo.org/wiki/Tile_Map_Service_Specification#global-geodetic),
   * which is a breaking change from 0.7.x behaviour.  If you are using a `TileLayer`
   * with this CRS, ensure that there are two 256x256 pixel tiles covering the
   * whole earth at zoom level zero, and that the tile coordinate origin is (-180,+90),
   * or (-180,-90) for `TileLayer`s with [the `tms` option](#tilelayer-tms) set.
   */ var EPSG4326 = extend({}, Earth, {
        code: "EPSG:4326",
        projection: LonLat,
        transformation: toTransformation(1 / 180, 1, -1 / 180, 0.5)
    });
    /*
   * @namespace CRS
   * @crs L.CRS.Simple
   *
   * A simple CRS that maps longitude and latitude into `x` and `y` directly.
   * May be used for maps of flat surfaces (e.g. game maps). Note that the `y`
   * axis should still be inverted (going from bottom to top). `distance()` returns
   * simple euclidean distance.
   */ var Simple = extend({}, CRS, {
        projection: LonLat,
        transformation: toTransformation(1, 0, -1, 0),
        scale: function(zoom) {
            return Math.pow(2, zoom);
        },
        zoom: function(scale) {
            return Math.log(scale) / Math.LN2;
        },
        distance: function(latlng1, latlng2) {
            var dx = latlng2.lng - latlng1.lng, dy = latlng2.lat - latlng1.lat;
            return Math.sqrt(dx * dx + dy * dy);
        },
        infinite: true
    });
    CRS.Earth = Earth;
    CRS.EPSG3395 = EPSG3395;
    CRS.EPSG3857 = EPSG3857;
    CRS.EPSG900913 = EPSG900913;
    CRS.EPSG4326 = EPSG4326;
    CRS.Simple = Simple;
    /*
   * @class Layer
   * @inherits Evented
   * @aka L.Layer
   * @aka ILayer
   *
   * A set of methods from the Layer base class that all Leaflet layers use.
   * Inherits all methods, options and events from `L.Evented`.
   *
   * @example
   *
   * ```js
   * var layer = L.marker(latlng).addTo(map);
   * layer.addTo(map);
   * layer.remove();
   * ```
   *
   * @event add: Event
   * Fired after the layer is added to a map
   *
   * @event remove: Event
   * Fired after the layer is removed from a map
   */ var Layer = Evented.extend({
        // Classes extending `L.Layer` will inherit the following options:
        options: {
            // @option pane: String = 'overlayPane'
            // By default the layer will be added to the map's [overlay pane](#map-overlaypane). Overriding this option will cause the layer to be placed on another pane by default.
            pane: "overlayPane",
            // @option attribution: String = null
            // String to be shown in the attribution control, e.g. "© OpenStreetMap contributors". It describes the layer data and is often a legal obligation towards copyright holders and tile providers.
            attribution: null,
            bubblingMouseEvents: true
        },
        /* @section
  	 * Classes extending `L.Layer` will inherit the following methods:
  	 *
  	 * @method addTo(map: Map|LayerGroup): this
  	 * Adds the layer to the given map or layer group.
  	 */ addTo: function(map) {
            map.addLayer(this);
            return this;
        },
        // @method remove: this
        // Removes the layer from the map it is currently active on.
        remove: function() {
            return this.removeFrom(this._map || this._mapToAdd);
        },
        // @method removeFrom(map: Map): this
        // Removes the layer from the given map
        //
        // @alternative
        // @method removeFrom(group: LayerGroup): this
        // Removes the layer from the given `LayerGroup`
        removeFrom: function(obj) {
            if (obj) obj.removeLayer(this);
            return this;
        },
        // @method getPane(name? : String): HTMLElement
        // Returns the `HTMLElement` representing the named pane on the map. If `name` is omitted, returns the pane for this layer.
        getPane: function(name) {
            return this._map.getPane(name ? this.options[name] || name : this.options.pane);
        },
        addInteractiveTarget: function(targetEl) {
            this._map._targets[stamp(targetEl)] = this;
            return this;
        },
        removeInteractiveTarget: function(targetEl) {
            delete this._map._targets[stamp(targetEl)];
            return this;
        },
        // @method getAttribution: String
        // Used by the `attribution control`, returns the [attribution option](#gridlayer-attribution).
        getAttribution: function() {
            return this.options.attribution;
        },
        _layerAdd: function(e) {
            var map = e.target;
            // check in case layer gets added and then removed before the map is ready
            if (!map.hasLayer(this)) return;
            this._map = map;
            this._zoomAnimated = map._zoomAnimated;
            if (this.getEvents) {
                var events = this.getEvents();
                map.on(events, this);
                this.once("remove", function() {
                    map.off(events, this);
                }, this);
            }
            this.onAdd(map);
            this.fire("add");
            map.fire("layeradd", {
                layer: this
            });
        }
    });
    /* @section Extension methods
   * @uninheritable
   *
   * Every layer should extend from `L.Layer` and (re-)implement the following methods.
   *
   * @method onAdd(map: Map): this
   * Should contain code that creates DOM elements for the layer, adds them to `map panes` where they should belong and puts listeners on relevant map events. Called on [`map.addLayer(layer)`](#map-addlayer).
   *
   * @method onRemove(map: Map): this
   * Should contain all clean up code that removes the layer's elements from the DOM and removes listeners previously added in [`onAdd`](#layer-onadd). Called on [`map.removeLayer(layer)`](#map-removelayer).
   *
   * @method getEvents(): Object
   * This optional method should return an object like `{ viewreset: this._reset }` for [`addEventListener`](#evented-addeventlistener). The event handlers in this object will be automatically added and removed from the map with your layer.
   *
   * @method getAttribution(): String
   * This optional method should return a string containing HTML to be shown on the `Attribution control` whenever the layer is visible.
   *
   * @method beforeAdd(map: Map): this
   * Optional method. Called on [`map.addLayer(layer)`](#map-addlayer), before the layer is added to the map, before events are initialized, without waiting until the map is in a usable state. Use for early initialization only.
   */ /* @namespace Map
   * @section Layer events
   *
   * @event layeradd: LayerEvent
   * Fired when a new layer is added to the map.
   *
   * @event layerremove: LayerEvent
   * Fired when some layer is removed from the map
   *
   * @section Methods for Layers and Controls
   */ Map.include({
        // @method addLayer(layer: Layer): this
        // Adds the given layer to the map
        addLayer: function(layer) {
            if (!layer._layerAdd) throw new Error("The provided object is not a Layer.");
            var id = stamp(layer);
            if (this._layers[id]) return this;
            this._layers[id] = layer;
            layer._mapToAdd = this;
            if (layer.beforeAdd) layer.beforeAdd(this);
            this.whenReady(layer._layerAdd, layer);
            return this;
        },
        // @method removeLayer(layer: Layer): this
        // Removes the given layer from the map.
        removeLayer: function(layer) {
            var id = stamp(layer);
            if (!this._layers[id]) return this;
            if (this._loaded) layer.onRemove(this);
            delete this._layers[id];
            if (this._loaded) {
                this.fire("layerremove", {
                    layer: layer
                });
                layer.fire("remove");
            }
            layer._map = layer._mapToAdd = null;
            return this;
        },
        // @method hasLayer(layer: Layer): Boolean
        // Returns `true` if the given layer is currently added to the map
        hasLayer: function(layer) {
            return stamp(layer) in this._layers;
        },
        /* @method eachLayer(fn: Function, context?: Object): this
  	 * Iterates over the layers of the map, optionally specifying context of the iterator function.
  	 * ```
  	 * map.eachLayer(function(layer){
  	 *     layer.bindPopup('Hello');
  	 * });
  	 * ```
  	 */ eachLayer: function(method, context) {
            for(var i in this._layers)method.call(context, this._layers[i]);
            return this;
        },
        _addLayers: function(layers) {
            layers = layers ? isArray(layers) ? layers : [
                layers
            ] : [];
            for(var i = 0, len = layers.length; i < len; i++)this.addLayer(layers[i]);
        },
        _addZoomLimit: function(layer) {
            if (!isNaN(layer.options.maxZoom) || !isNaN(layer.options.minZoom)) {
                this._zoomBoundLayers[stamp(layer)] = layer;
                this._updateZoomLevels();
            }
        },
        _removeZoomLimit: function(layer) {
            var id = stamp(layer);
            if (this._zoomBoundLayers[id]) {
                delete this._zoomBoundLayers[id];
                this._updateZoomLevels();
            }
        },
        _updateZoomLevels: function() {
            var minZoom = Infinity, maxZoom = -Infinity, oldZoomSpan = this._getZoomSpan();
            for(var i in this._zoomBoundLayers){
                var options = this._zoomBoundLayers[i].options;
                minZoom = options.minZoom === undefined ? minZoom : Math.min(minZoom, options.minZoom);
                maxZoom = options.maxZoom === undefined ? maxZoom : Math.max(maxZoom, options.maxZoom);
            }
            this._layersMaxZoom = maxZoom === -Infinity ? undefined : maxZoom;
            this._layersMinZoom = minZoom === Infinity ? undefined : minZoom;
            // @section Map state change events
            // @event zoomlevelschange: Event
            // Fired when the number of zoomlevels on the map is changed due
            // to adding or removing a layer.
            if (oldZoomSpan !== this._getZoomSpan()) this.fire("zoomlevelschange");
            if (this.options.maxZoom === undefined && this._layersMaxZoom && this.getZoom() > this._layersMaxZoom) this.setZoom(this._layersMaxZoom);
            if (this.options.minZoom === undefined && this._layersMinZoom && this.getZoom() < this._layersMinZoom) this.setZoom(this._layersMinZoom);
        }
    });
    /*
   * @class LayerGroup
   * @aka L.LayerGroup
   * @inherits Interactive layer
   *
   * Used to group several layers and handle them as one. If you add it to the map,
   * any layers added or removed from the group will be added/removed on the map as
   * well. Extends `Layer`.
   *
   * @example
   *
   * ```js
   * L.layerGroup([marker1, marker2])
   * 	.addLayer(polyline)
   * 	.addTo(map);
   * ```
   */ var LayerGroup = Layer.extend({
        initialize: function(layers, options) {
            setOptions(this, options);
            this._layers = {};
            var i, len;
            if (layers) for(i = 0, len = layers.length; i < len; i++)this.addLayer(layers[i]);
        },
        // @method addLayer(layer: Layer): this
        // Adds the given layer to the group.
        addLayer: function(layer) {
            var id = this.getLayerId(layer);
            this._layers[id] = layer;
            if (this._map) this._map.addLayer(layer);
            return this;
        },
        // @method removeLayer(layer: Layer): this
        // Removes the given layer from the group.
        // @alternative
        // @method removeLayer(id: Number): this
        // Removes the layer with the given internal ID from the group.
        removeLayer: function(layer) {
            var id = layer in this._layers ? layer : this.getLayerId(layer);
            if (this._map && this._layers[id]) this._map.removeLayer(this._layers[id]);
            delete this._layers[id];
            return this;
        },
        // @method hasLayer(layer: Layer): Boolean
        // Returns `true` if the given layer is currently added to the group.
        // @alternative
        // @method hasLayer(id: Number): Boolean
        // Returns `true` if the given internal ID is currently added to the group.
        hasLayer: function(layer) {
            var layerId = typeof layer === "number" ? layer : this.getLayerId(layer);
            return layerId in this._layers;
        },
        // @method clearLayers(): this
        // Removes all the layers from the group.
        clearLayers: function() {
            return this.eachLayer(this.removeLayer, this);
        },
        // @method invoke(methodName: String, …): this
        // Calls `methodName` on every layer contained in this group, passing any
        // additional parameters. Has no effect if the layers contained do not
        // implement `methodName`.
        invoke: function(methodName) {
            var args = Array.prototype.slice.call(arguments, 1), i, layer;
            for(i in this._layers){
                layer = this._layers[i];
                if (layer[methodName]) layer[methodName].apply(layer, args);
            }
            return this;
        },
        onAdd: function(map) {
            this.eachLayer(map.addLayer, map);
        },
        onRemove: function(map) {
            this.eachLayer(map.removeLayer, map);
        },
        // @method eachLayer(fn: Function, context?: Object): this
        // Iterates over the layers of the group, optionally specifying context of the iterator function.
        // ```js
        // group.eachLayer(function (layer) {
        // 	layer.bindPopup('Hello');
        // });
        // ```
        eachLayer: function(method, context) {
            for(var i in this._layers)method.call(context, this._layers[i]);
            return this;
        },
        // @method getLayer(id: Number): Layer
        // Returns the layer with the given internal ID.
        getLayer: function(id) {
            return this._layers[id];
        },
        // @method getLayers(): Layer[]
        // Returns an array of all the layers added to the group.
        getLayers: function() {
            var layers = [];
            this.eachLayer(layers.push, layers);
            return layers;
        },
        // @method setZIndex(zIndex: Number): this
        // Calls `setZIndex` on every layer contained in this group, passing the z-index.
        setZIndex: function(zIndex) {
            return this.invoke("setZIndex", zIndex);
        },
        // @method getLayerId(layer: Layer): Number
        // Returns the internal ID for a layer
        getLayerId: function(layer) {
            return stamp(layer);
        }
    });
    // @factory L.layerGroup(layers?: Layer[], options?: Object)
    // Create a layer group, optionally given an initial set of layers and an `options` object.
    var layerGroup = function(layers, options) {
        return new LayerGroup(layers, options);
    };
    /*
   * @class FeatureGroup
   * @aka L.FeatureGroup
   * @inherits LayerGroup
   *
   * Extended `LayerGroup` that makes it easier to do the same thing to all its member layers:
   *  * [`bindPopup`](#layer-bindpopup) binds a popup to all of the layers at once (likewise with [`bindTooltip`](#layer-bindtooltip))
   *  * Events are propagated to the `FeatureGroup`, so if the group has an event
   * handler, it will handle events from any of the layers. This includes mouse events
   * and custom events.
   *  * Has `layeradd` and `layerremove` events
   *
   * @example
   *
   * ```js
   * L.featureGroup([marker1, marker2, polyline])
   * 	.bindPopup('Hello world!')
   * 	.on('click', function() { alert('Clicked on a member of the group!'); })
   * 	.addTo(map);
   * ```
   */ var FeatureGroup = LayerGroup.extend({
        addLayer: function(layer) {
            if (this.hasLayer(layer)) return this;
            layer.addEventParent(this);
            LayerGroup.prototype.addLayer.call(this, layer);
            // @event layeradd: LayerEvent
            // Fired when a layer is added to this `FeatureGroup`
            return this.fire("layeradd", {
                layer: layer
            });
        },
        removeLayer: function(layer) {
            if (!this.hasLayer(layer)) return this;
            if (layer in this._layers) layer = this._layers[layer];
            layer.removeEventParent(this);
            LayerGroup.prototype.removeLayer.call(this, layer);
            // @event layerremove: LayerEvent
            // Fired when a layer is removed from this `FeatureGroup`
            return this.fire("layerremove", {
                layer: layer
            });
        },
        // @method setStyle(style: Path options): this
        // Sets the given path options to each layer of the group that has a `setStyle` method.
        setStyle: function(style) {
            return this.invoke("setStyle", style);
        },
        // @method bringToFront(): this
        // Brings the layer group to the top of all other layers
        bringToFront: function() {
            return this.invoke("bringToFront");
        },
        // @method bringToBack(): this
        // Brings the layer group to the back of all other layers
        bringToBack: function() {
            return this.invoke("bringToBack");
        },
        // @method getBounds(): LatLngBounds
        // Returns the LatLngBounds of the Feature Group (created from bounds and coordinates of its children).
        getBounds: function() {
            var bounds = new LatLngBounds();
            for(var id in this._layers){
                var layer = this._layers[id];
                bounds.extend(layer.getBounds ? layer.getBounds() : layer.getLatLng());
            }
            return bounds;
        }
    });
    // @factory L.featureGroup(layers?: Layer[], options?: Object)
    // Create a feature group, optionally given an initial set of layers and an `options` object.
    var featureGroup = function(layers, options) {
        return new FeatureGroup(layers, options);
    };
    /*
   * @class Icon
   * @aka L.Icon
   *
   * Represents an icon to provide when creating a marker.
   *
   * @example
   *
   * ```js
   * var myIcon = L.icon({
   *     iconUrl: 'my-icon.png',
   *     iconRetinaUrl: 'my-icon@2x.png',
   *     iconSize: [38, 95],
   *     iconAnchor: [22, 94],
   *     popupAnchor: [-3, -76],
   *     shadowUrl: 'my-icon-shadow.png',
   *     shadowRetinaUrl: 'my-icon-shadow@2x.png',
   *     shadowSize: [68, 95],
   *     shadowAnchor: [22, 94]
   * });
   *
   * L.marker([50.505, 30.57], {icon: myIcon}).addTo(map);
   * ```
   *
   * `L.Icon.Default` extends `L.Icon` and is the blue icon Leaflet uses for markers by default.
   *
   */ var Icon = Class.extend({
        /* @section
  	 * @aka Icon options
  	 *
  	 * @option iconUrl: String = null
  	 * **(required)** The URL to the icon image (absolute or relative to your script path).
  	 *
  	 * @option iconRetinaUrl: String = null
  	 * The URL to a retina sized version of the icon image (absolute or relative to your
  	 * script path). Used for Retina screen devices.
  	 *
  	 * @option iconSize: Point = null
  	 * Size of the icon image in pixels.
  	 *
  	 * @option iconAnchor: Point = null
  	 * The coordinates of the "tip" of the icon (relative to its top left corner). The icon
  	 * will be aligned so that this point is at the marker's geographical location. Centered
  	 * by default if size is specified, also can be set in CSS with negative margins.
  	 *
  	 * @option popupAnchor: Point = [0, 0]
  	 * The coordinates of the point from which popups will "open", relative to the icon anchor.
  	 *
  	 * @option tooltipAnchor: Point = [0, 0]
  	 * The coordinates of the point from which tooltips will "open", relative to the icon anchor.
  	 *
  	 * @option shadowUrl: String = null
  	 * The URL to the icon shadow image. If not specified, no shadow image will be created.
  	 *
  	 * @option shadowRetinaUrl: String = null
  	 *
  	 * @option shadowSize: Point = null
  	 * Size of the shadow image in pixels.
  	 *
  	 * @option shadowAnchor: Point = null
  	 * The coordinates of the "tip" of the shadow (relative to its top left corner) (the same
  	 * as iconAnchor if not specified).
  	 *
  	 * @option className: String = ''
  	 * A custom class name to assign to both icon and shadow images. Empty by default.
  	 */ options: {
            popupAnchor: [
                0,
                0
            ],
            tooltipAnchor: [
                0,
                0
            ],
            // @option crossOrigin: Boolean|String = false
            // Whether the crossOrigin attribute will be added to the tiles.
            // If a String is provided, all tiles will have their crossOrigin attribute set to the String provided. This is needed if you want to access tile pixel data.
            // Refer to [CORS Settings](https://developer.mozilla.org/en-US/docs/Web/HTML/CORS_settings_attributes) for valid String values.
            crossOrigin: false
        },
        initialize: function(options) {
            setOptions(this, options);
        },
        // @method createIcon(oldIcon?: HTMLElement): HTMLElement
        // Called internally when the icon has to be shown, returns a `<img>` HTML element
        // styled according to the options.
        createIcon: function(oldIcon) {
            return this._createIcon("icon", oldIcon);
        },
        // @method createShadow(oldIcon?: HTMLElement): HTMLElement
        // As `createIcon`, but for the shadow beneath it.
        createShadow: function(oldIcon) {
            return this._createIcon("shadow", oldIcon);
        },
        _createIcon: function(name, oldIcon) {
            var src = this._getIconUrl(name);
            if (!src) {
                if (name === "icon") throw new Error("iconUrl not set in Icon options (see the docs).");
                return null;
            }
            var img = this._createImg(src, oldIcon && oldIcon.tagName === "IMG" ? oldIcon : null);
            this._setIconStyles(img, name);
            if (this.options.crossOrigin || this.options.crossOrigin === "") img.crossOrigin = this.options.crossOrigin === true ? "" : this.options.crossOrigin;
            return img;
        },
        _setIconStyles: function(img, name) {
            var options = this.options;
            var sizeOption = options[name + "Size"];
            if (typeof sizeOption === "number") sizeOption = [
                sizeOption,
                sizeOption
            ];
            var size = toPoint(sizeOption), anchor = toPoint(name === "shadow" && options.shadowAnchor || options.iconAnchor || size && size.divideBy(2, true));
            img.className = "leaflet-marker-" + name + " " + (options.className || "");
            if (anchor) {
                img.style.marginLeft = -anchor.x + "px";
                img.style.marginTop = -anchor.y + "px";
            }
            if (size) {
                img.style.width = size.x + "px";
                img.style.height = size.y + "px";
            }
        },
        _createImg: function(src, el) {
            el = el || document.createElement("img");
            el.src = src;
            return el;
        },
        _getIconUrl: function(name) {
            return Browser.retina && this.options[name + "RetinaUrl"] || this.options[name + "Url"];
        }
    });
    // @factory L.icon(options: Icon options)
    // Creates an icon instance with the given options.
    function icon(options) {
        return new Icon(options);
    }
    /*
   * @miniclass Icon.Default (Icon)
   * @aka L.Icon.Default
   * @section
   *
   * A trivial subclass of `Icon`, represents the icon to use in `Marker`s when
   * no icon is specified. Points to the blue marker image distributed with Leaflet
   * releases.
   *
   * In order to customize the default icon, just change the properties of `L.Icon.Default.prototype.options`
   * (which is a set of `Icon options`).
   *
   * If you want to _completely_ replace the default icon, override the
   * `L.Marker.prototype.options.icon` with your own icon instead.
   */ var IconDefault = Icon.extend({
        options: {
            iconUrl: "marker-icon.png",
            iconRetinaUrl: "marker-icon-2x.png",
            shadowUrl: "marker-shadow.png",
            iconSize: [
                25,
                41
            ],
            iconAnchor: [
                12,
                41
            ],
            popupAnchor: [
                1,
                -34
            ],
            tooltipAnchor: [
                16,
                -28
            ],
            shadowSize: [
                41,
                41
            ]
        },
        _getIconUrl: function(name) {
            if (typeof IconDefault.imagePath !== "string") IconDefault.imagePath = this._detectIconPath();
            // @option imagePath: String
            // `Icon.Default` will try to auto-detect the location of the
            // blue icon images. If you are placing these images in a non-standard
            // way, set this option to point to the right path.
            return (this.options.imagePath || IconDefault.imagePath) + Icon.prototype._getIconUrl.call(this, name);
        },
        _stripUrl: function(path) {
            var strip = function(str, re, idx) {
                var match = re.exec(str);
                return match && match[idx];
            };
            path = strip(path, /^url\((['"])?(.+)\1\)$/, 2);
            return path && strip(path, /^(.*)marker-icon\.png$/, 1);
        },
        _detectIconPath: function() {
            var el = create$1("div", "leaflet-default-icon-path", document.body);
            var path = getStyle(el, "background-image") || getStyle(el, "backgroundImage"); // IE8
            document.body.removeChild(el);
            path = this._stripUrl(path);
            if (path) return path;
            var link = document.querySelector('link[href$="leaflet.css"]');
            if (!link) return "";
            return link.href.substring(0, link.href.length - 11 - 1);
        }
    });
    /*
   * L.Handler.MarkerDrag is used internally by L.Marker to make the markers draggable.
   */ /* @namespace Marker
   * @section Interaction handlers
   *
   * Interaction handlers are properties of a marker instance that allow you to control interaction behavior in runtime, enabling or disabling certain features such as dragging (see `Handler` methods). Example:
   *
   * ```js
   * marker.dragging.disable();
   * ```
   *
   * @property dragging: Handler
   * Marker dragging handler (by both mouse and touch). Only valid when the marker is on the map (Otherwise set [`marker.options.draggable`](#marker-draggable)).
   */ var MarkerDrag = Handler.extend({
        initialize: function(marker) {
            this._marker = marker;
        },
        addHooks: function() {
            var icon = this._marker._icon;
            if (!this._draggable) this._draggable = new Draggable(icon, icon, true);
            this._draggable.on({
                dragstart: this._onDragStart,
                predrag: this._onPreDrag,
                drag: this._onDrag,
                dragend: this._onDragEnd
            }, this).enable();
            addClass(icon, "leaflet-marker-draggable");
        },
        removeHooks: function() {
            this._draggable.off({
                dragstart: this._onDragStart,
                predrag: this._onPreDrag,
                drag: this._onDrag,
                dragend: this._onDragEnd
            }, this).disable();
            if (this._marker._icon) removeClass(this._marker._icon, "leaflet-marker-draggable");
        },
        moved: function() {
            return this._draggable && this._draggable._moved;
        },
        _adjustPan: function(e) {
            var marker = this._marker, map = marker._map, speed = this._marker.options.autoPanSpeed, padding = this._marker.options.autoPanPadding, iconPos = getPosition(marker._icon), bounds = map.getPixelBounds(), origin = map.getPixelOrigin();
            var panBounds = toBounds(bounds.min._subtract(origin).add(padding), bounds.max._subtract(origin).subtract(padding));
            if (!panBounds.contains(iconPos)) {
                // Compute incremental movement
                var movement = toPoint((Math.max(panBounds.max.x, iconPos.x) - panBounds.max.x) / (bounds.max.x - panBounds.max.x) - (Math.min(panBounds.min.x, iconPos.x) - panBounds.min.x) / (bounds.min.x - panBounds.min.x), (Math.max(panBounds.max.y, iconPos.y) - panBounds.max.y) / (bounds.max.y - panBounds.max.y) - (Math.min(panBounds.min.y, iconPos.y) - panBounds.min.y) / (bounds.min.y - panBounds.min.y)).multiplyBy(speed);
                map.panBy(movement, {
                    animate: false
                });
                this._draggable._newPos._add(movement);
                this._draggable._startPos._add(movement);
                setPosition(marker._icon, this._draggable._newPos);
                this._onDrag(e);
                this._panRequest = requestAnimFrame(this._adjustPan.bind(this, e));
            }
        },
        _onDragStart: function() {
            // @section Dragging events
            // @event dragstart: Event
            // Fired when the user starts dragging the marker.
            // @event movestart: Event
            // Fired when the marker starts moving (because of dragging).
            this._oldLatLng = this._marker.getLatLng();
            // When using ES6 imports it could not be set when `Popup` was not imported as well
            this._marker.closePopup && this._marker.closePopup();
            this._marker.fire("movestart").fire("dragstart");
        },
        _onPreDrag: function(e) {
            if (this._marker.options.autoPan) {
                cancelAnimFrame(this._panRequest);
                this._panRequest = requestAnimFrame(this._adjustPan.bind(this, e));
            }
        },
        _onDrag: function(e) {
            var marker = this._marker, shadow = marker._shadow, iconPos = getPosition(marker._icon), latlng = marker._map.layerPointToLatLng(iconPos);
            // update shadow position
            if (shadow) setPosition(shadow, iconPos);
            marker._latlng = latlng;
            e.latlng = latlng;
            e.oldLatLng = this._oldLatLng;
            // @event drag: Event
            // Fired repeatedly while the user drags the marker.
            marker.fire("move", e).fire("drag", e);
        },
        _onDragEnd: function(e) {
            // @event dragend: DragEndEvent
            // Fired when the user stops dragging the marker.
            cancelAnimFrame(this._panRequest);
            // @event moveend: Event
            // Fired when the marker stops moving (because of dragging).
            delete this._oldLatLng;
            this._marker.fire("moveend").fire("dragend", e);
        }
    });
    /*
   * @class Marker
   * @inherits Interactive layer
   * @aka L.Marker
   * L.Marker is used to display clickable/draggable icons on the map. Extends `Layer`.
   *
   * @example
   *
   * ```js
   * L.marker([50.5, 30.5]).addTo(map);
   * ```
   */ var Marker = Layer.extend({
        // @section
        // @aka Marker options
        options: {
            // @option icon: Icon = *
            // Icon instance to use for rendering the marker.
            // See [Icon documentation](#L.Icon) for details on how to customize the marker icon.
            // If not specified, a common instance of `L.Icon.Default` is used.
            icon: new IconDefault(),
            // Option inherited from "Interactive layer" abstract class
            interactive: true,
            // @option keyboard: Boolean = true
            // Whether the marker can be tabbed to with a keyboard and clicked by pressing enter.
            keyboard: true,
            // @option title: String = ''
            // Text for the browser tooltip that appear on marker hover (no tooltip by default).
            // [Useful for accessibility](https://leafletjs.com/examples/accessibility/#markers-must-be-labelled).
            title: "",
            // @option alt: String = 'Marker'
            // Text for the `alt` attribute of the icon image.
            // [Useful for accessibility](https://leafletjs.com/examples/accessibility/#markers-must-be-labelled).
            alt: "Marker",
            // @option zIndexOffset: Number = 0
            // By default, marker images zIndex is set automatically based on its latitude. Use this option if you want to put the marker on top of all others (or below), specifying a high value like `1000` (or high negative value, respectively).
            zIndexOffset: 0,
            // @option opacity: Number = 1.0
            // The opacity of the marker.
            opacity: 1,
            // @option riseOnHover: Boolean = false
            // If `true`, the marker will get on top of others when you hover the mouse over it.
            riseOnHover: false,
            // @option riseOffset: Number = 250
            // The z-index offset used for the `riseOnHover` feature.
            riseOffset: 250,
            // @option pane: String = 'markerPane'
            // `Map pane` where the markers icon will be added.
            pane: "markerPane",
            // @option shadowPane: String = 'shadowPane'
            // `Map pane` where the markers shadow will be added.
            shadowPane: "shadowPane",
            // @option bubblingMouseEvents: Boolean = false
            // When `true`, a mouse event on this marker will trigger the same event on the map
            // (unless [`L.DomEvent.stopPropagation`](#domevent-stoppropagation) is used).
            bubblingMouseEvents: false,
            // @option autoPanOnFocus: Boolean = true
            // When `true`, the map will pan whenever the marker is focused (via
            // e.g. pressing `tab` on the keyboard) to ensure the marker is
            // visible within the map's bounds
            autoPanOnFocus: true,
            // @section Draggable marker options
            // @option draggable: Boolean = false
            // Whether the marker is draggable with mouse/touch or not.
            draggable: false,
            // @option autoPan: Boolean = false
            // Whether to pan the map when dragging this marker near its edge or not.
            autoPan: false,
            // @option autoPanPadding: Point = Point(50, 50)
            // Distance (in pixels to the left/right and to the top/bottom) of the
            // map edge to start panning the map.
            autoPanPadding: [
                50,
                50
            ],
            // @option autoPanSpeed: Number = 10
            // Number of pixels the map should pan by.
            autoPanSpeed: 10
        },
        /* @section
  	 *
  	 * In addition to [shared layer methods](#Layer) like `addTo()` and `remove()` and [popup methods](#Popup) like bindPopup() you can also use the following methods:
  	 */ initialize: function(latlng, options) {
            setOptions(this, options);
            this._latlng = toLatLng(latlng);
        },
        onAdd: function(map) {
            this._zoomAnimated = this._zoomAnimated && map.options.markerZoomAnimation;
            if (this._zoomAnimated) map.on("zoomanim", this._animateZoom, this);
            this._initIcon();
            this.update();
        },
        onRemove: function(map) {
            if (this.dragging && this.dragging.enabled()) {
                this.options.draggable = true;
                this.dragging.removeHooks();
            }
            delete this.dragging;
            if (this._zoomAnimated) map.off("zoomanim", this._animateZoom, this);
            this._removeIcon();
            this._removeShadow();
        },
        getEvents: function() {
            return {
                zoom: this.update,
                viewreset: this.update
            };
        },
        // @method getLatLng: LatLng
        // Returns the current geographical position of the marker.
        getLatLng: function() {
            return this._latlng;
        },
        // @method setLatLng(latlng: LatLng): this
        // Changes the marker position to the given point.
        setLatLng: function(latlng) {
            var oldLatLng = this._latlng;
            this._latlng = toLatLng(latlng);
            this.update();
            // @event move: Event
            // Fired when the marker is moved via [`setLatLng`](#marker-setlatlng) or by [dragging](#marker-dragging). Old and new coordinates are included in event arguments as `oldLatLng`, `latlng`.
            return this.fire("move", {
                oldLatLng: oldLatLng,
                latlng: this._latlng
            });
        },
        // @method setZIndexOffset(offset: Number): this
        // Changes the [zIndex offset](#marker-zindexoffset) of the marker.
        setZIndexOffset: function(offset) {
            this.options.zIndexOffset = offset;
            return this.update();
        },
        // @method getIcon: Icon
        // Returns the current icon used by the marker
        getIcon: function() {
            return this.options.icon;
        },
        // @method setIcon(icon: Icon): this
        // Changes the marker icon.
        setIcon: function(icon) {
            this.options.icon = icon;
            if (this._map) {
                this._initIcon();
                this.update();
            }
            if (this._popup) this.bindPopup(this._popup, this._popup.options);
            return this;
        },
        getElement: function() {
            return this._icon;
        },
        update: function() {
            if (this._icon && this._map) {
                var pos = this._map.latLngToLayerPoint(this._latlng).round();
                this._setPos(pos);
            }
            return this;
        },
        _initIcon: function() {
            var options = this.options, classToAdd = "leaflet-zoom-" + (this._zoomAnimated ? "animated" : "hide");
            var icon = options.icon.createIcon(this._icon), addIcon = false;
            // if we're not reusing the icon, remove the old one and init new one
            if (icon !== this._icon) {
                if (this._icon) this._removeIcon();
                addIcon = true;
                if (options.title) icon.title = options.title;
                if (icon.tagName === "IMG") icon.alt = options.alt || "";
            }
            addClass(icon, classToAdd);
            if (options.keyboard) {
                icon.tabIndex = "0";
                icon.setAttribute("role", "button");
            }
            this._icon = icon;
            if (options.riseOnHover) this.on({
                mouseover: this._bringToFront,
                mouseout: this._resetZIndex
            });
            if (this.options.autoPanOnFocus) on(icon, "focus", this._panOnFocus, this);
            var newShadow = options.icon.createShadow(this._shadow), addShadow = false;
            if (newShadow !== this._shadow) {
                this._removeShadow();
                addShadow = true;
            }
            if (newShadow) {
                addClass(newShadow, classToAdd);
                newShadow.alt = "";
            }
            this._shadow = newShadow;
            if (options.opacity < 1) this._updateOpacity();
            if (addIcon) this.getPane().appendChild(this._icon);
            this._initInteraction();
            if (newShadow && addShadow) this.getPane(options.shadowPane).appendChild(this._shadow);
        },
        _removeIcon: function() {
            if (this.options.riseOnHover) this.off({
                mouseover: this._bringToFront,
                mouseout: this._resetZIndex
            });
            if (this.options.autoPanOnFocus) off(this._icon, "focus", this._panOnFocus, this);
            remove(this._icon);
            this.removeInteractiveTarget(this._icon);
            this._icon = null;
        },
        _removeShadow: function() {
            if (this._shadow) remove(this._shadow);
            this._shadow = null;
        },
        _setPos: function(pos) {
            if (this._icon) setPosition(this._icon, pos);
            if (this._shadow) setPosition(this._shadow, pos);
            this._zIndex = pos.y + this.options.zIndexOffset;
            this._resetZIndex();
        },
        _updateZIndex: function(offset) {
            if (this._icon) this._icon.style.zIndex = this._zIndex + offset;
        },
        _animateZoom: function(opt) {
            var pos = this._map._latLngToNewLayerPoint(this._latlng, opt.zoom, opt.center).round();
            this._setPos(pos);
        },
        _initInteraction: function() {
            if (!this.options.interactive) return;
            addClass(this._icon, "leaflet-interactive");
            this.addInteractiveTarget(this._icon);
            if (MarkerDrag) {
                var draggable = this.options.draggable;
                if (this.dragging) {
                    draggable = this.dragging.enabled();
                    this.dragging.disable();
                }
                this.dragging = new MarkerDrag(this);
                if (draggable) this.dragging.enable();
            }
        },
        // @method setOpacity(opacity: Number): this
        // Changes the opacity of the marker.
        setOpacity: function(opacity) {
            this.options.opacity = opacity;
            if (this._map) this._updateOpacity();
            return this;
        },
        _updateOpacity: function() {
            var opacity = this.options.opacity;
            if (this._icon) setOpacity(this._icon, opacity);
            if (this._shadow) setOpacity(this._shadow, opacity);
        },
        _bringToFront: function() {
            this._updateZIndex(this.options.riseOffset);
        },
        _resetZIndex: function() {
            this._updateZIndex(0);
        },
        _panOnFocus: function() {
            var map = this._map;
            if (!map) return;
            var iconOpts = this.options.icon.options;
            var size = iconOpts.iconSize ? toPoint(iconOpts.iconSize) : toPoint(0, 0);
            var anchor = iconOpts.iconAnchor ? toPoint(iconOpts.iconAnchor) : toPoint(0, 0);
            map.panInside(this._latlng, {
                paddingTopLeft: anchor,
                paddingBottomRight: size.subtract(anchor)
            });
        },
        _getPopupAnchor: function() {
            return this.options.icon.options.popupAnchor;
        },
        _getTooltipAnchor: function() {
            return this.options.icon.options.tooltipAnchor;
        }
    });
    // factory L.marker(latlng: LatLng, options? : Marker options)
    // @factory L.marker(latlng: LatLng, options? : Marker options)
    // Instantiates a Marker object given a geographical point and optionally an options object.
    function marker(latlng, options) {
        return new Marker(latlng, options);
    }
    /*
   * @class Path
   * @aka L.Path
   * @inherits Interactive layer
   *
   * An abstract class that contains options and constants shared between vector
   * overlays (Polygon, Polyline, Circle). Do not use it directly. Extends `Layer`.
   */ var Path = Layer.extend({
        // @section
        // @aka Path options
        options: {
            // @option stroke: Boolean = true
            // Whether to draw stroke along the path. Set it to `false` to disable borders on polygons or circles.
            stroke: true,
            // @option color: String = '#3388ff'
            // Stroke color
            color: "#3388ff",
            // @option weight: Number = 3
            // Stroke width in pixels
            weight: 3,
            // @option opacity: Number = 1.0
            // Stroke opacity
            opacity: 1,
            // @option lineCap: String= 'round'
            // A string that defines [shape to be used at the end](https://developer.mozilla.org/docs/Web/SVG/Attribute/stroke-linecap) of the stroke.
            lineCap: "round",
            // @option lineJoin: String = 'round'
            // A string that defines [shape to be used at the corners](https://developer.mozilla.org/docs/Web/SVG/Attribute/stroke-linejoin) of the stroke.
            lineJoin: "round",
            // @option dashArray: String = null
            // A string that defines the stroke [dash pattern](https://developer.mozilla.org/docs/Web/SVG/Attribute/stroke-dasharray). Doesn't work on `Canvas`-powered layers in [some old browsers](https://developer.mozilla.org/docs/Web/API/CanvasRenderingContext2D/setLineDash#Browser_compatibility).
            dashArray: null,
            // @option dashOffset: String = null
            // A string that defines the [distance into the dash pattern to start the dash](https://developer.mozilla.org/docs/Web/SVG/Attribute/stroke-dashoffset). Doesn't work on `Canvas`-powered layers in [some old browsers](https://developer.mozilla.org/docs/Web/API/CanvasRenderingContext2D/setLineDash#Browser_compatibility).
            dashOffset: null,
            // @option fill: Boolean = depends
            // Whether to fill the path with color. Set it to `false` to disable filling on polygons or circles.
            fill: false,
            // @option fillColor: String = *
            // Fill color. Defaults to the value of the [`color`](#path-color) option
            fillColor: null,
            // @option fillOpacity: Number = 0.2
            // Fill opacity.
            fillOpacity: 0.2,
            // @option fillRule: String = 'evenodd'
            // A string that defines [how the inside of a shape](https://developer.mozilla.org/docs/Web/SVG/Attribute/fill-rule) is determined.
            fillRule: "evenodd",
            // className: '',
            // Option inherited from "Interactive layer" abstract class
            interactive: true,
            // @option bubblingMouseEvents: Boolean = true
            // When `true`, a mouse event on this path will trigger the same event on the map
            // (unless [`L.DomEvent.stopPropagation`](#domevent-stoppropagation) is used).
            bubblingMouseEvents: true
        },
        beforeAdd: function(map) {
            // Renderer is set here because we need to call renderer.getEvents
            // before this.getEvents.
            this._renderer = map.getRenderer(this);
        },
        onAdd: function() {
            this._renderer._initPath(this);
            this._reset();
            this._renderer._addPath(this);
        },
        onRemove: function() {
            this._renderer._removePath(this);
        },
        // @method redraw(): this
        // Redraws the layer. Sometimes useful after you changed the coordinates that the path uses.
        redraw: function() {
            if (this._map) this._renderer._updatePath(this);
            return this;
        },
        // @method setStyle(style: Path options): this
        // Changes the appearance of a Path based on the options in the `Path options` object.
        setStyle: function(style) {
            setOptions(this, style);
            if (this._renderer) {
                this._renderer._updateStyle(this);
                if (this.options.stroke && style && Object.prototype.hasOwnProperty.call(style, "weight")) this._updateBounds();
            }
            return this;
        },
        // @method bringToFront(): this
        // Brings the layer to the top of all path layers.
        bringToFront: function() {
            if (this._renderer) this._renderer._bringToFront(this);
            return this;
        },
        // @method bringToBack(): this
        // Brings the layer to the bottom of all path layers.
        bringToBack: function() {
            if (this._renderer) this._renderer._bringToBack(this);
            return this;
        },
        getElement: function() {
            return this._path;
        },
        _reset: function() {
            // defined in child classes
            this._project();
            this._update();
        },
        _clickTolerance: function() {
            // used when doing hit detection for Canvas layers
            return (this.options.stroke ? this.options.weight / 2 : 0) + (this._renderer.options.tolerance || 0);
        }
    });
    /*
   * @class CircleMarker
   * @aka L.CircleMarker
   * @inherits Path
   *
   * A circle of a fixed size with radius specified in pixels. Extends `Path`.
   */ var CircleMarker = Path.extend({
        // @section
        // @aka CircleMarker options
        options: {
            fill: true,
            // @option radius: Number = 10
            // Radius of the circle marker, in pixels
            radius: 10
        },
        initialize: function(latlng, options) {
            setOptions(this, options);
            this._latlng = toLatLng(latlng);
            this._radius = this.options.radius;
        },
        // @method setLatLng(latLng: LatLng): this
        // Sets the position of a circle marker to a new location.
        setLatLng: function(latlng) {
            var oldLatLng = this._latlng;
            this._latlng = toLatLng(latlng);
            this.redraw();
            // @event move: Event
            // Fired when the marker is moved via [`setLatLng`](#circlemarker-setlatlng). Old and new coordinates are included in event arguments as `oldLatLng`, `latlng`.
            return this.fire("move", {
                oldLatLng: oldLatLng,
                latlng: this._latlng
            });
        },
        // @method getLatLng(): LatLng
        // Returns the current geographical position of the circle marker
        getLatLng: function() {
            return this._latlng;
        },
        // @method setRadius(radius: Number): this
        // Sets the radius of a circle marker. Units are in pixels.
        setRadius: function(radius) {
            this.options.radius = this._radius = radius;
            return this.redraw();
        },
        // @method getRadius(): Number
        // Returns the current radius of the circle
        getRadius: function() {
            return this._radius;
        },
        setStyle: function(options) {
            var radius = options && options.radius || this._radius;
            Path.prototype.setStyle.call(this, options);
            this.setRadius(radius);
            return this;
        },
        _project: function() {
            this._point = this._map.latLngToLayerPoint(this._latlng);
            this._updateBounds();
        },
        _updateBounds: function() {
            var r = this._radius, r2 = this._radiusY || r, w = this._clickTolerance(), p = [
                r + w,
                r2 + w
            ];
            this._pxBounds = new Bounds(this._point.subtract(p), this._point.add(p));
        },
        _update: function() {
            if (this._map) this._updatePath();
        },
        _updatePath: function() {
            this._renderer._updateCircle(this);
        },
        _empty: function() {
            return this._radius && !this._renderer._bounds.intersects(this._pxBounds);
        },
        // Needed by the `Canvas` renderer for interactivity
        _containsPoint: function(p) {
            return p.distanceTo(this._point) <= this._radius + this._clickTolerance();
        }
    });
    // @factory L.circleMarker(latlng: LatLng, options?: CircleMarker options)
    // Instantiates a circle marker object given a geographical point, and an optional options object.
    function circleMarker(latlng, options) {
        return new CircleMarker(latlng, options);
    }
    /*
   * @class Circle
   * @aka L.Circle
   * @inherits CircleMarker
   *
   * A class for drawing circle overlays on a map. Extends `CircleMarker`.
   *
   * It's an approximation and starts to diverge from a real circle closer to poles (due to projection distortion).
   *
   * @example
   *
   * ```js
   * L.circle([50.5, 30.5], {radius: 200}).addTo(map);
   * ```
   */ var Circle = CircleMarker.extend({
        initialize: function(latlng, options, legacyOptions) {
            if (typeof options === "number") // Backwards compatibility with 0.7.x factory (latlng, radius, options?)
            options = extend({}, legacyOptions, {
                radius: options
            });
            setOptions(this, options);
            this._latlng = toLatLng(latlng);
            if (isNaN(this.options.radius)) throw new Error("Circle radius cannot be NaN");
            // @section
            // @aka Circle options
            // @option radius: Number; Radius of the circle, in meters.
            this._mRadius = this.options.radius;
        },
        // @method setRadius(radius: Number): this
        // Sets the radius of a circle. Units are in meters.
        setRadius: function(radius) {
            this._mRadius = radius;
            return this.redraw();
        },
        // @method getRadius(): Number
        // Returns the current radius of a circle. Units are in meters.
        getRadius: function() {
            return this._mRadius;
        },
        // @method getBounds(): LatLngBounds
        // Returns the `LatLngBounds` of the path.
        getBounds: function() {
            var half = [
                this._radius,
                this._radiusY || this._radius
            ];
            return new LatLngBounds(this._map.layerPointToLatLng(this._point.subtract(half)), this._map.layerPointToLatLng(this._point.add(half)));
        },
        setStyle: Path.prototype.setStyle,
        _project: function() {
            var lng = this._latlng.lng, lat = this._latlng.lat, map = this._map, crs = map.options.crs;
            if (crs.distance === Earth.distance) {
                var d = Math.PI / 180, latR = this._mRadius / Earth.R / d, top = map.project([
                    lat + latR,
                    lng
                ]), bottom = map.project([
                    lat - latR,
                    lng
                ]), p = top.add(bottom).divideBy(2), lat2 = map.unproject(p).lat, lngR = Math.acos((Math.cos(latR * d) - Math.sin(lat * d) * Math.sin(lat2 * d)) / (Math.cos(lat * d) * Math.cos(lat2 * d))) / d;
                if (isNaN(lngR) || lngR === 0) lngR = latR / Math.cos(Math.PI / 180 * lat); // Fallback for edge case, #2425
                this._point = p.subtract(map.getPixelOrigin());
                this._radius = isNaN(lngR) ? 0 : p.x - map.project([
                    lat2,
                    lng - lngR
                ]).x;
                this._radiusY = p.y - top.y;
            } else {
                var latlng2 = crs.unproject(crs.project(this._latlng).subtract([
                    this._mRadius,
                    0
                ]));
                this._point = map.latLngToLayerPoint(this._latlng);
                this._radius = this._point.x - map.latLngToLayerPoint(latlng2).x;
            }
            this._updateBounds();
        }
    });
    // @factory L.circle(latlng: LatLng, options?: Circle options)
    // Instantiates a circle object given a geographical point, and an options object
    // which contains the circle radius.
    // @alternative
    // @factory L.circle(latlng: LatLng, radius: Number, options?: Circle options)
    // Obsolete way of instantiating a circle, for compatibility with 0.7.x code.
    // Do not use in new applications or plugins.
    function circle(latlng, options, legacyOptions) {
        return new Circle(latlng, options, legacyOptions);
    }
    /*
   * @class Polyline
   * @aka L.Polyline
   * @inherits Path
   *
   * A class for drawing polyline overlays on a map. Extends `Path`.
   *
   * @example
   *
   * ```js
   * // create a red polyline from an array of LatLng points
   * var latlngs = [
   * 	[45.51, -122.68],
   * 	[37.77, -122.43],
   * 	[34.04, -118.2]
   * ];
   *
   * var polyline = L.polyline(latlngs, {color: 'red'}).addTo(map);
   *
   * // zoom the map to the polyline
   * map.fitBounds(polyline.getBounds());
   * ```
   *
   * You can also pass a multi-dimensional array to represent a `MultiPolyline` shape:
   *
   * ```js
   * // create a red polyline from an array of arrays of LatLng points
   * var latlngs = [
   * 	[[45.51, -122.68],
   * 	 [37.77, -122.43],
   * 	 [34.04, -118.2]],
   * 	[[40.78, -73.91],
   * 	 [41.83, -87.62],
   * 	 [32.76, -96.72]]
   * ];
   * ```
   */ var Polyline = Path.extend({
        // @section
        // @aka Polyline options
        options: {
            // @option smoothFactor: Number = 1.0
            // How much to simplify the polyline on each zoom level. More means
            // better performance and smoother look, and less means more accurate representation.
            smoothFactor: 1.0,
            // @option noClip: Boolean = false
            // Disable polyline clipping.
            noClip: false
        },
        initialize: function(latlngs, options) {
            setOptions(this, options);
            this._setLatLngs(latlngs);
        },
        // @method getLatLngs(): LatLng[]
        // Returns an array of the points in the path, or nested arrays of points in case of multi-polyline.
        getLatLngs: function() {
            return this._latlngs;
        },
        // @method setLatLngs(latlngs: LatLng[]): this
        // Replaces all the points in the polyline with the given array of geographical points.
        setLatLngs: function(latlngs) {
            this._setLatLngs(latlngs);
            return this.redraw();
        },
        // @method isEmpty(): Boolean
        // Returns `true` if the Polyline has no LatLngs.
        isEmpty: function() {
            return !this._latlngs.length;
        },
        // @method closestLayerPoint(p: Point): Point
        // Returns the point closest to `p` on the Polyline.
        closestLayerPoint: function(p) {
            var minDistance = Infinity, minPoint = null, closest = _sqClosestPointOnSegment, p1, p2;
            for(var j = 0, jLen = this._parts.length; j < jLen; j++){
                var points = this._parts[j];
                for(var i = 1, len = points.length; i < len; i++){
                    p1 = points[i - 1];
                    p2 = points[i];
                    var sqDist = closest(p, p1, p2, true);
                    if (sqDist < minDistance) {
                        minDistance = sqDist;
                        minPoint = closest(p, p1, p2);
                    }
                }
            }
            if (minPoint) minPoint.distance = Math.sqrt(minDistance);
            return minPoint;
        },
        // @method getCenter(): LatLng
        // Returns the center ([centroid](https://en.wikipedia.org/wiki/Centroid)) of the polyline.
        getCenter: function() {
            // throws error when not yet added to map as this center calculation requires projected coordinates
            if (!this._map) throw new Error("Must add layer to map before using getCenter()");
            return polylineCenter(this._defaultShape(), this._map.options.crs);
        },
        // @method getBounds(): LatLngBounds
        // Returns the `LatLngBounds` of the path.
        getBounds: function() {
            return this._bounds;
        },
        // @method addLatLng(latlng: LatLng, latlngs?: LatLng[]): this
        // Adds a given point to the polyline. By default, adds to the first ring of
        // the polyline in case of a multi-polyline, but can be overridden by passing
        // a specific ring as a LatLng array (that you can earlier access with [`getLatLngs`](#polyline-getlatlngs)).
        addLatLng: function(latlng, latlngs) {
            latlngs = latlngs || this._defaultShape();
            latlng = toLatLng(latlng);
            latlngs.push(latlng);
            this._bounds.extend(latlng);
            return this.redraw();
        },
        _setLatLngs: function(latlngs) {
            this._bounds = new LatLngBounds();
            this._latlngs = this._convertLatLngs(latlngs);
        },
        _defaultShape: function() {
            return isFlat(this._latlngs) ? this._latlngs : this._latlngs[0];
        },
        // recursively convert latlngs input into actual LatLng instances; calculate bounds along the way
        _convertLatLngs: function(latlngs) {
            var result = [], flat = isFlat(latlngs);
            for(var i = 0, len = latlngs.length; i < len; i++)if (flat) {
                result[i] = toLatLng(latlngs[i]);
                this._bounds.extend(result[i]);
            } else result[i] = this._convertLatLngs(latlngs[i]);
            return result;
        },
        _project: function() {
            var pxBounds = new Bounds();
            this._rings = [];
            this._projectLatlngs(this._latlngs, this._rings, pxBounds);
            if (this._bounds.isValid() && pxBounds.isValid()) {
                this._rawPxBounds = pxBounds;
                this._updateBounds();
            }
        },
        _updateBounds: function() {
            var w = this._clickTolerance(), p = new Point(w, w);
            if (!this._rawPxBounds) return;
            this._pxBounds = new Bounds([
                this._rawPxBounds.min.subtract(p),
                this._rawPxBounds.max.add(p)
            ]);
        },
        // recursively turns latlngs into a set of rings with projected coordinates
        _projectLatlngs: function(latlngs, result, projectedBounds) {
            var flat = latlngs[0] instanceof LatLng, len = latlngs.length, i, ring;
            if (flat) {
                ring = [];
                for(i = 0; i < len; i++){
                    ring[i] = this._map.latLngToLayerPoint(latlngs[i]);
                    projectedBounds.extend(ring[i]);
                }
                result.push(ring);
            } else for(i = 0; i < len; i++)this._projectLatlngs(latlngs[i], result, projectedBounds);
        },
        // clip polyline by renderer bounds so that we have less to render for performance
        _clipPoints: function() {
            var bounds = this._renderer._bounds;
            this._parts = [];
            if (!this._pxBounds || !this._pxBounds.intersects(bounds)) return;
            if (this.options.noClip) {
                this._parts = this._rings;
                return;
            }
            var parts = this._parts, i, j, k, len, len2, segment, points;
            for(i = 0, k = 0, len = this._rings.length; i < len; i++){
                points = this._rings[i];
                for(j = 0, len2 = points.length; j < len2 - 1; j++){
                    segment = clipSegment(points[j], points[j + 1], bounds, j, true);
                    if (!segment) continue;
                    parts[k] = parts[k] || [];
                    parts[k].push(segment[0]);
                    // if segment goes out of screen, or it's the last one, it's the end of the line part
                    if (segment[1] !== points[j + 1] || j === len2 - 2) {
                        parts[k].push(segment[1]);
                        k++;
                    }
                }
            }
        },
        // simplify each clipped part of the polyline for performance
        _simplifyPoints: function() {
            var parts = this._parts, tolerance = this.options.smoothFactor;
            for(var i = 0, len = parts.length; i < len; i++)parts[i] = simplify(parts[i], tolerance);
        },
        _update: function() {
            if (!this._map) return;
            this._clipPoints();
            this._simplifyPoints();
            this._updatePath();
        },
        _updatePath: function() {
            this._renderer._updatePoly(this);
        },
        // Needed by the `Canvas` renderer for interactivity
        _containsPoint: function(p, closed) {
            var i, j, k, len, len2, part, w = this._clickTolerance();
            if (!this._pxBounds || !this._pxBounds.contains(p)) return false;
            // hit detection for polylines
            for(i = 0, len = this._parts.length; i < len; i++){
                part = this._parts[i];
                for(j = 0, len2 = part.length, k = len2 - 1; j < len2; k = j++){
                    if (!closed && j === 0) continue;
                    if (pointToSegmentDistance(p, part[k], part[j]) <= w) return true;
                }
            }
            return false;
        }
    });
    // @factory L.polyline(latlngs: LatLng[], options?: Polyline options)
    // Instantiates a polyline object given an array of geographical points and
    // optionally an options object. You can create a `Polyline` object with
    // multiple separate lines (`MultiPolyline`) by passing an array of arrays
    // of geographic points.
    function polyline(latlngs, options) {
        return new Polyline(latlngs, options);
    }
    // Retrocompat. Allow plugins to support Leaflet versions before and after 1.1.
    Polyline._flat = _flat;
    /*
   * @class Polygon
   * @aka L.Polygon
   * @inherits Polyline
   *
   * A class for drawing polygon overlays on a map. Extends `Polyline`.
   *
   * Note that points you pass when creating a polygon shouldn't have an additional last point equal to the first one — it's better to filter out such points.
   *
   *
   * @example
   *
   * ```js
   * // create a red polygon from an array of LatLng points
   * var latlngs = [[37, -109.05],[41, -109.03],[41, -102.05],[37, -102.04]];
   *
   * var polygon = L.polygon(latlngs, {color: 'red'}).addTo(map);
   *
   * // zoom the map to the polygon
   * map.fitBounds(polygon.getBounds());
   * ```
   *
   * You can also pass an array of arrays of latlngs, with the first array representing the outer shape and the other arrays representing holes in the outer shape:
   *
   * ```js
   * var latlngs = [
   *   [[37, -109.05],[41, -109.03],[41, -102.05],[37, -102.04]], // outer ring
   *   [[37.29, -108.58],[40.71, -108.58],[40.71, -102.50],[37.29, -102.50]] // hole
   * ];
   * ```
   *
   * Additionally, you can pass a multi-dimensional array to represent a MultiPolygon shape.
   *
   * ```js
   * var latlngs = [
   *   [ // first polygon
   *     [[37, -109.05],[41, -109.03],[41, -102.05],[37, -102.04]], // outer ring
   *     [[37.29, -108.58],[40.71, -108.58],[40.71, -102.50],[37.29, -102.50]] // hole
   *   ],
   *   [ // second polygon
   *     [[41, -111.03],[45, -111.04],[45, -104.05],[41, -104.05]]
   *   ]
   * ];
   * ```
   */ var Polygon = Polyline.extend({
        options: {
            fill: true
        },
        isEmpty: function() {
            return !this._latlngs.length || !this._latlngs[0].length;
        },
        // @method getCenter(): LatLng
        // Returns the center ([centroid](http://en.wikipedia.org/wiki/Centroid)) of the Polygon.
        getCenter: function() {
            // throws error when not yet added to map as this center calculation requires projected coordinates
            if (!this._map) throw new Error("Must add layer to map before using getCenter()");
            return polygonCenter(this._defaultShape(), this._map.options.crs);
        },
        _convertLatLngs: function(latlngs) {
            var result = Polyline.prototype._convertLatLngs.call(this, latlngs), len = result.length;
            // remove last point if it equals first one
            if (len >= 2 && result[0] instanceof LatLng && result[0].equals(result[len - 1])) result.pop();
            return result;
        },
        _setLatLngs: function(latlngs) {
            Polyline.prototype._setLatLngs.call(this, latlngs);
            if (isFlat(this._latlngs)) this._latlngs = [
                this._latlngs
            ];
        },
        _defaultShape: function() {
            return isFlat(this._latlngs[0]) ? this._latlngs[0] : this._latlngs[0][0];
        },
        _clipPoints: function() {
            // polygons need a different clipping algorithm so we redefine that
            var bounds = this._renderer._bounds, w = this.options.weight, p = new Point(w, w);
            // increase clip padding by stroke width to avoid stroke on clip edges
            bounds = new Bounds(bounds.min.subtract(p), bounds.max.add(p));
            this._parts = [];
            if (!this._pxBounds || !this._pxBounds.intersects(bounds)) return;
            if (this.options.noClip) {
                this._parts = this._rings;
                return;
            }
            for(var i = 0, len = this._rings.length, clipped; i < len; i++){
                clipped = clipPolygon(this._rings[i], bounds, true);
                if (clipped.length) this._parts.push(clipped);
            }
        },
        _updatePath: function() {
            this._renderer._updatePoly(this, true);
        },
        // Needed by the `Canvas` renderer for interactivity
        _containsPoint: function(p) {
            var inside = false, part, p1, p2, i, j, k, len, len2;
            if (!this._pxBounds || !this._pxBounds.contains(p)) return false;
            // ray casting algorithm for detecting if point is in polygon
            for(i = 0, len = this._parts.length; i < len; i++){
                part = this._parts[i];
                for(j = 0, len2 = part.length, k = len2 - 1; j < len2; k = j++){
                    p1 = part[j];
                    p2 = part[k];
                    if (p1.y > p.y !== p2.y > p.y && p.x < (p2.x - p1.x) * (p.y - p1.y) / (p2.y - p1.y) + p1.x) inside = !inside;
                }
            }
            // also check if it's on polygon stroke
            return inside || Polyline.prototype._containsPoint.call(this, p, true);
        }
    });
    // @factory L.polygon(latlngs: LatLng[], options?: Polyline options)
    function polygon(latlngs, options) {
        return new Polygon(latlngs, options);
    }
    /*
   * @class GeoJSON
   * @aka L.GeoJSON
   * @inherits FeatureGroup
   *
   * Represents a GeoJSON object or an array of GeoJSON objects. Allows you to parse
   * GeoJSON data and display it on the map. Extends `FeatureGroup`.
   *
   * @example
   *
   * ```js
   * L.geoJSON(data, {
   * 	style: function (feature) {
   * 		return {color: feature.properties.color};
   * 	}
   * }).bindPopup(function (layer) {
   * 	return layer.feature.properties.description;
   * }).addTo(map);
   * ```
   */ var GeoJSON = FeatureGroup.extend({
        /* @section
  	 * @aka GeoJSON options
  	 *
  	 * @option pointToLayer: Function = *
  	 * A `Function` defining how GeoJSON points spawn Leaflet layers. It is internally
  	 * called when data is added, passing the GeoJSON point feature and its `LatLng`.
  	 * The default is to spawn a default `Marker`:
  	 * ```js
  	 * function(geoJsonPoint, latlng) {
  	 * 	return L.marker(latlng);
  	 * }
  	 * ```
  	 *
  	 * @option style: Function = *
  	 * A `Function` defining the `Path options` for styling GeoJSON lines and polygons,
  	 * called internally when data is added.
  	 * The default value is to not override any defaults:
  	 * ```js
  	 * function (geoJsonFeature) {
  	 * 	return {}
  	 * }
  	 * ```
  	 *
  	 * @option onEachFeature: Function = *
  	 * A `Function` that will be called once for each created `Feature`, after it has
  	 * been created and styled. Useful for attaching events and popups to features.
  	 * The default is to do nothing with the newly created layers:
  	 * ```js
  	 * function (feature, layer) {}
  	 * ```
  	 *
  	 * @option filter: Function = *
  	 * A `Function` that will be used to decide whether to include a feature or not.
  	 * The default is to include all features:
  	 * ```js
  	 * function (geoJsonFeature) {
  	 * 	return true;
  	 * }
  	 * ```
  	 * Note: dynamically changing the `filter` option will have effect only on newly
  	 * added data. It will _not_ re-evaluate already included features.
  	 *
  	 * @option coordsToLatLng: Function = *
  	 * A `Function` that will be used for converting GeoJSON coordinates to `LatLng`s.
  	 * The default is the `coordsToLatLng` static method.
  	 *
  	 * @option markersInheritOptions: Boolean = false
  	 * Whether default Markers for "Point" type Features inherit from group options.
  	 */ initialize: function(geojson, options) {
            setOptions(this, options);
            this._layers = {};
            if (geojson) this.addData(geojson);
        },
        // @method addData( <GeoJSON> data ): this
        // Adds a GeoJSON object to the layer.
        addData: function(geojson) {
            var features = isArray(geojson) ? geojson : geojson.features, i, len, feature;
            if (features) {
                for(i = 0, len = features.length; i < len; i++){
                    // only add this if geometry or geometries are set and not null
                    feature = features[i];
                    if (feature.geometries || feature.geometry || feature.features || feature.coordinates) this.addData(feature);
                }
                return this;
            }
            var options = this.options;
            if (options.filter && !options.filter(geojson)) return this;
            var layer = geometryToLayer(geojson, options);
            if (!layer) return this;
            layer.feature = asFeature(geojson);
            layer.defaultOptions = layer.options;
            this.resetStyle(layer);
            if (options.onEachFeature) options.onEachFeature(geojson, layer);
            return this.addLayer(layer);
        },
        // @method resetStyle( <Path> layer? ): this
        // Resets the given vector layer's style to the original GeoJSON style, useful for resetting style after hover events.
        // If `layer` is omitted, the style of all features in the current layer is reset.
        resetStyle: function(layer) {
            if (layer === undefined) return this.eachLayer(this.resetStyle, this);
            // reset any custom styles
            layer.options = extend({}, layer.defaultOptions);
            this._setLayerStyle(layer, this.options.style);
            return this;
        },
        // @method setStyle( <Function> style ): this
        // Changes styles of GeoJSON vector layers with the given style function.
        setStyle: function(style) {
            return this.eachLayer(function(layer) {
                this._setLayerStyle(layer, style);
            }, this);
        },
        _setLayerStyle: function(layer, style) {
            if (layer.setStyle) {
                if (typeof style === "function") style = style(layer.feature);
                layer.setStyle(style);
            }
        }
    });
    // @section
    // There are several static functions which can be called without instantiating L.GeoJSON:
    // @function geometryToLayer(featureData: Object, options?: GeoJSON options): Layer
    // Creates a `Layer` from a given GeoJSON feature. Can use a custom
    // [`pointToLayer`](#geojson-pointtolayer) and/or [`coordsToLatLng`](#geojson-coordstolatlng)
    // functions if provided as options.
    function geometryToLayer(geojson, options) {
        var geometry = geojson.type === "Feature" ? geojson.geometry : geojson, coords = geometry ? geometry.coordinates : null, layers = [], pointToLayer = options && options.pointToLayer, _coordsToLatLng = options && options.coordsToLatLng || coordsToLatLng, latlng, latlngs, i, len;
        if (!coords && !geometry) return null;
        switch(geometry.type){
            case "Point":
                latlng = _coordsToLatLng(coords);
                return _pointToLayer(pointToLayer, geojson, latlng, options);
            case "MultiPoint":
                for(i = 0, len = coords.length; i < len; i++){
                    latlng = _coordsToLatLng(coords[i]);
                    layers.push(_pointToLayer(pointToLayer, geojson, latlng, options));
                }
                return new FeatureGroup(layers);
            case "LineString":
            case "MultiLineString":
                latlngs = coordsToLatLngs(coords, geometry.type === "LineString" ? 0 : 1, _coordsToLatLng);
                return new Polyline(latlngs, options);
            case "Polygon":
            case "MultiPolygon":
                latlngs = coordsToLatLngs(coords, geometry.type === "Polygon" ? 1 : 2, _coordsToLatLng);
                return new Polygon(latlngs, options);
            case "GeometryCollection":
                for(i = 0, len = geometry.geometries.length; i < len; i++){
                    var geoLayer = geometryToLayer({
                        geometry: geometry.geometries[i],
                        type: "Feature",
                        properties: geojson.properties
                    }, options);
                    if (geoLayer) layers.push(geoLayer);
                }
                return new FeatureGroup(layers);
            case "FeatureCollection":
                for(i = 0, len = geometry.features.length; i < len; i++){
                    var featureLayer = geometryToLayer(geometry.features[i], options);
                    if (featureLayer) layers.push(featureLayer);
                }
                return new FeatureGroup(layers);
            default:
                throw new Error("Invalid GeoJSON object.");
        }
    }
    function _pointToLayer(pointToLayerFn, geojson, latlng, options) {
        return pointToLayerFn ? pointToLayerFn(geojson, latlng) : new Marker(latlng, options && options.markersInheritOptions && options);
    }
    // @function coordsToLatLng(coords: Array): LatLng
    // Creates a `LatLng` object from an array of 2 numbers (longitude, latitude)
    // or 3 numbers (longitude, latitude, altitude) used in GeoJSON for points.
    function coordsToLatLng(coords) {
        return new LatLng(coords[1], coords[0], coords[2]);
    }
    // @function coordsToLatLngs(coords: Array, levelsDeep?: Number, coordsToLatLng?: Function): Array
    // Creates a multidimensional array of `LatLng`s from a GeoJSON coordinates array.
    // `levelsDeep` specifies the nesting level (0 is for an array of points, 1 for an array of arrays of points, etc., 0 by default).
    // Can use a custom [`coordsToLatLng`](#geojson-coordstolatlng) function.
    function coordsToLatLngs(coords, levelsDeep, _coordsToLatLng) {
        var latlngs = [];
        for(var i = 0, len = coords.length, latlng; i < len; i++){
            latlng = levelsDeep ? coordsToLatLngs(coords[i], levelsDeep - 1, _coordsToLatLng) : (_coordsToLatLng || coordsToLatLng)(coords[i]);
            latlngs.push(latlng);
        }
        return latlngs;
    }
    // @function latLngToCoords(latlng: LatLng, precision?: Number|false): Array
    // Reverse of [`coordsToLatLng`](#geojson-coordstolatlng)
    // Coordinates values are rounded with [`formatNum`](#util-formatnum) function.
    function latLngToCoords(latlng, precision) {
        latlng = toLatLng(latlng);
        return latlng.alt !== undefined ? [
            formatNum(latlng.lng, precision),
            formatNum(latlng.lat, precision),
            formatNum(latlng.alt, precision)
        ] : [
            formatNum(latlng.lng, precision),
            formatNum(latlng.lat, precision)
        ];
    }
    // @function latLngsToCoords(latlngs: Array, levelsDeep?: Number, closed?: Boolean, precision?: Number|false): Array
    // Reverse of [`coordsToLatLngs`](#geojson-coordstolatlngs)
    // `closed` determines whether the first point should be appended to the end of the array to close the feature, only used when `levelsDeep` is 0. False by default.
    // Coordinates values are rounded with [`formatNum`](#util-formatnum) function.
    function latLngsToCoords(latlngs, levelsDeep, closed, precision) {
        var coords = [];
        for(var i = 0, len = latlngs.length; i < len; i++)// Check for flat arrays required to ensure unbalanced arrays are correctly converted in recursion
        coords.push(levelsDeep ? latLngsToCoords(latlngs[i], isFlat(latlngs[i]) ? 0 : levelsDeep - 1, closed, precision) : latLngToCoords(latlngs[i], precision));
        if (!levelsDeep && closed && coords.length > 0) coords.push(coords[0].slice());
        return coords;
    }
    function getFeature(layer, newGeometry) {
        return layer.feature ? extend({}, layer.feature, {
            geometry: newGeometry
        }) : asFeature(newGeometry);
    }
    // @function asFeature(geojson: Object): Object
    // Normalize GeoJSON geometries/features into GeoJSON features.
    function asFeature(geojson) {
        if (geojson.type === "Feature" || geojson.type === "FeatureCollection") return geojson;
        return {
            type: "Feature",
            properties: {},
            geometry: geojson
        };
    }
    var PointToGeoJSON = {
        toGeoJSON: function(precision) {
            return getFeature(this, {
                type: "Point",
                coordinates: latLngToCoords(this.getLatLng(), precision)
            });
        }
    };
    // @namespace Marker
    // @section Other methods
    // @method toGeoJSON(precision?: Number|false): Object
    // Coordinates values are rounded with [`formatNum`](#util-formatnum) function with given `precision`.
    // Returns a [`GeoJSON`](https://en.wikipedia.org/wiki/GeoJSON) representation of the marker (as a GeoJSON `Point` Feature).
    Marker.include(PointToGeoJSON);
    // @namespace CircleMarker
    // @method toGeoJSON(precision?: Number|false): Object
    // Coordinates values are rounded with [`formatNum`](#util-formatnum) function with given `precision`.
    // Returns a [`GeoJSON`](https://en.wikipedia.org/wiki/GeoJSON) representation of the circle marker (as a GeoJSON `Point` Feature).
    Circle.include(PointToGeoJSON);
    CircleMarker.include(PointToGeoJSON);
    // @namespace Polyline
    // @method toGeoJSON(precision?: Number|false): Object
    // Coordinates values are rounded with [`formatNum`](#util-formatnum) function with given `precision`.
    // Returns a [`GeoJSON`](https://en.wikipedia.org/wiki/GeoJSON) representation of the polyline (as a GeoJSON `LineString` or `MultiLineString` Feature).
    Polyline.include({
        toGeoJSON: function(precision) {
            var multi = !isFlat(this._latlngs);
            var coords = latLngsToCoords(this._latlngs, multi ? 1 : 0, false, precision);
            return getFeature(this, {
                type: (multi ? "Multi" : "") + "LineString",
                coordinates: coords
            });
        }
    });
    // @namespace Polygon
    // @method toGeoJSON(precision?: Number|false): Object
    // Coordinates values are rounded with [`formatNum`](#util-formatnum) function with given `precision`.
    // Returns a [`GeoJSON`](https://en.wikipedia.org/wiki/GeoJSON) representation of the polygon (as a GeoJSON `Polygon` or `MultiPolygon` Feature).
    Polygon.include({
        toGeoJSON: function(precision) {
            var holes = !isFlat(this._latlngs), multi = holes && !isFlat(this._latlngs[0]);
            var coords = latLngsToCoords(this._latlngs, multi ? 2 : holes ? 1 : 0, true, precision);
            if (!holes) coords = [
                coords
            ];
            return getFeature(this, {
                type: (multi ? "Multi" : "") + "Polygon",
                coordinates: coords
            });
        }
    });
    // @namespace LayerGroup
    LayerGroup.include({
        toMultiPoint: function(precision) {
            var coords = [];
            this.eachLayer(function(layer) {
                coords.push(layer.toGeoJSON(precision).geometry.coordinates);
            });
            return getFeature(this, {
                type: "MultiPoint",
                coordinates: coords
            });
        },
        // @method toGeoJSON(precision?: Number|false): Object
        // Coordinates values are rounded with [`formatNum`](#util-formatnum) function with given `precision`.
        // Returns a [`GeoJSON`](https://en.wikipedia.org/wiki/GeoJSON) representation of the layer group (as a GeoJSON `FeatureCollection`, `GeometryCollection`, or `MultiPoint`).
        toGeoJSON: function(precision) {
            var type = this.feature && this.feature.geometry && this.feature.geometry.type;
            if (type === "MultiPoint") return this.toMultiPoint(precision);
            var isGeometryCollection = type === "GeometryCollection", jsons = [];
            this.eachLayer(function(layer) {
                if (layer.toGeoJSON) {
                    var json = layer.toGeoJSON(precision);
                    if (isGeometryCollection) jsons.push(json.geometry);
                    else {
                        var feature = asFeature(json);
                        // Squash nested feature collections
                        if (feature.type === "FeatureCollection") jsons.push.apply(jsons, feature.features);
                        else jsons.push(feature);
                    }
                }
            });
            if (isGeometryCollection) return getFeature(this, {
                geometries: jsons,
                type: "GeometryCollection"
            });
            return {
                type: "FeatureCollection",
                features: jsons
            };
        }
    });
    // @namespace GeoJSON
    // @factory L.geoJSON(geojson?: Object, options?: GeoJSON options)
    // Creates a GeoJSON layer. Optionally accepts an object in
    // [GeoJSON format](https://tools.ietf.org/html/rfc7946) to display on the map
    // (you can alternatively add it later with `addData` method) and an `options` object.
    function geoJSON(geojson, options) {
        return new GeoJSON(geojson, options);
    }
    // Backward compatibility.
    var geoJson = geoJSON;
    /*
   * @class ImageOverlay
   * @aka L.ImageOverlay
   * @inherits Interactive layer
   *
   * Used to load and display a single image over specific bounds of the map. Extends `Layer`.
   *
   * @example
   *
   * ```js
   * var imageUrl = 'https://maps.lib.utexas.edu/maps/historical/newark_nj_1922.jpg',
   * 	imageBounds = [[40.712216, -74.22655], [40.773941, -74.12544]];
   * L.imageOverlay(imageUrl, imageBounds).addTo(map);
   * ```
   */ var ImageOverlay = Layer.extend({
        // @section
        // @aka ImageOverlay options
        options: {
            // @option opacity: Number = 1.0
            // The opacity of the image overlay.
            opacity: 1,
            // @option alt: String = ''
            // Text for the `alt` attribute of the image (useful for accessibility).
            alt: "",
            // @option interactive: Boolean = false
            // If `true`, the image overlay will emit [mouse events](#interactive-layer) when clicked or hovered.
            interactive: false,
            // @option crossOrigin: Boolean|String = false
            // Whether the crossOrigin attribute will be added to the image.
            // If a String is provided, the image will have its crossOrigin attribute set to the String provided. This is needed if you want to access image pixel data.
            // Refer to [CORS Settings](https://developer.mozilla.org/en-US/docs/Web/HTML/CORS_settings_attributes) for valid String values.
            crossOrigin: false,
            // @option errorOverlayUrl: String = ''
            // URL to the overlay image to show in place of the overlay that failed to load.
            errorOverlayUrl: "",
            // @option zIndex: Number = 1
            // The explicit [zIndex](https://developer.mozilla.org/docs/Web/CSS/CSS_Positioning/Understanding_z_index) of the overlay layer.
            zIndex: 1,
            // @option className: String = ''
            // A custom class name to assign to the image. Empty by default.
            className: ""
        },
        initialize: function(url, bounds, options) {
            this._url = url;
            this._bounds = toLatLngBounds(bounds);
            setOptions(this, options);
        },
        onAdd: function() {
            if (!this._image) {
                this._initImage();
                if (this.options.opacity < 1) this._updateOpacity();
            }
            if (this.options.interactive) {
                addClass(this._image, "leaflet-interactive");
                this.addInteractiveTarget(this._image);
            }
            this.getPane().appendChild(this._image);
            this._reset();
        },
        onRemove: function() {
            remove(this._image);
            if (this.options.interactive) this.removeInteractiveTarget(this._image);
        },
        // @method setOpacity(opacity: Number): this
        // Sets the opacity of the overlay.
        setOpacity: function(opacity) {
            this.options.opacity = opacity;
            if (this._image) this._updateOpacity();
            return this;
        },
        setStyle: function(styleOpts) {
            if (styleOpts.opacity) this.setOpacity(styleOpts.opacity);
            return this;
        },
        // @method bringToFront(): this
        // Brings the layer to the top of all overlays.
        bringToFront: function() {
            if (this._map) toFront(this._image);
            return this;
        },
        // @method bringToBack(): this
        // Brings the layer to the bottom of all overlays.
        bringToBack: function() {
            if (this._map) toBack(this._image);
            return this;
        },
        // @method setUrl(url: String): this
        // Changes the URL of the image.
        setUrl: function(url) {
            this._url = url;
            if (this._image) this._image.src = url;
            return this;
        },
        // @method setBounds(bounds: LatLngBounds): this
        // Update the bounds that this ImageOverlay covers
        setBounds: function(bounds) {
            this._bounds = toLatLngBounds(bounds);
            if (this._map) this._reset();
            return this;
        },
        getEvents: function() {
            var events = {
                zoom: this._reset,
                viewreset: this._reset
            };
            if (this._zoomAnimated) events.zoomanim = this._animateZoom;
            return events;
        },
        // @method setZIndex(value: Number): this
        // Changes the [zIndex](#imageoverlay-zindex) of the image overlay.
        setZIndex: function(value) {
            this.options.zIndex = value;
            this._updateZIndex();
            return this;
        },
        // @method getBounds(): LatLngBounds
        // Get the bounds that this ImageOverlay covers
        getBounds: function() {
            return this._bounds;
        },
        // @method getElement(): HTMLElement
        // Returns the instance of [`HTMLImageElement`](https://developer.mozilla.org/docs/Web/API/HTMLImageElement)
        // used by this overlay.
        getElement: function() {
            return this._image;
        },
        _initImage: function() {
            var wasElementSupplied = this._url.tagName === "IMG";
            var img = this._image = wasElementSupplied ? this._url : create$1("img");
            addClass(img, "leaflet-image-layer");
            if (this._zoomAnimated) addClass(img, "leaflet-zoom-animated");
            if (this.options.className) addClass(img, this.options.className);
            img.onselectstart = falseFn;
            img.onmousemove = falseFn;
            // @event load: Event
            // Fired when the ImageOverlay layer has loaded its image
            img.onload = bind(this.fire, this, "load");
            img.onerror = bind(this._overlayOnError, this, "error");
            if (this.options.crossOrigin || this.options.crossOrigin === "") img.crossOrigin = this.options.crossOrigin === true ? "" : this.options.crossOrigin;
            if (this.options.zIndex) this._updateZIndex();
            if (wasElementSupplied) {
                this._url = img.src;
                return;
            }
            img.src = this._url;
            img.alt = this.options.alt;
        },
        _animateZoom: function(e) {
            var scale = this._map.getZoomScale(e.zoom), offset = this._map._latLngBoundsToNewLayerBounds(this._bounds, e.zoom, e.center).min;
            setTransform(this._image, offset, scale);
        },
        _reset: function() {
            var image = this._image, bounds = new Bounds(this._map.latLngToLayerPoint(this._bounds.getNorthWest()), this._map.latLngToLayerPoint(this._bounds.getSouthEast())), size = bounds.getSize();
            setPosition(image, bounds.min);
            image.style.width = size.x + "px";
            image.style.height = size.y + "px";
        },
        _updateOpacity: function() {
            setOpacity(this._image, this.options.opacity);
        },
        _updateZIndex: function() {
            if (this._image && this.options.zIndex !== undefined && this.options.zIndex !== null) this._image.style.zIndex = this.options.zIndex;
        },
        _overlayOnError: function() {
            // @event error: Event
            // Fired when the ImageOverlay layer fails to load its image
            this.fire("error");
            var errorUrl = this.options.errorOverlayUrl;
            if (errorUrl && this._url !== errorUrl) {
                this._url = errorUrl;
                this._image.src = errorUrl;
            }
        },
        // @method getCenter(): LatLng
        // Returns the center of the ImageOverlay.
        getCenter: function() {
            return this._bounds.getCenter();
        }
    });
    // @factory L.imageOverlay(imageUrl: String, bounds: LatLngBounds, options?: ImageOverlay options)
    // Instantiates an image overlay object given the URL of the image and the
    // geographical bounds it is tied to.
    var imageOverlay = function(url, bounds, options) {
        return new ImageOverlay(url, bounds, options);
    };
    /*
   * @class VideoOverlay
   * @aka L.VideoOverlay
   * @inherits ImageOverlay
   *
   * Used to load and display a video player over specific bounds of the map. Extends `ImageOverlay`.
   *
   * A video overlay uses the [`<video>`](https://developer.mozilla.org/docs/Web/HTML/Element/video)
   * HTML5 element.
   *
   * @example
   *
   * ```js
   * var videoUrl = 'https://www.mapbox.com/bites/00188/patricia_nasa.webm',
   * 	videoBounds = [[ 32, -130], [ 13, -100]];
   * L.videoOverlay(videoUrl, videoBounds ).addTo(map);
   * ```
   */ var VideoOverlay = ImageOverlay.extend({
        // @section
        // @aka VideoOverlay options
        options: {
            // @option autoplay: Boolean = true
            // Whether the video starts playing automatically when loaded.
            // On some browsers autoplay will only work with `muted: true`
            autoplay: true,
            // @option loop: Boolean = true
            // Whether the video will loop back to the beginning when played.
            loop: true,
            // @option keepAspectRatio: Boolean = true
            // Whether the video will save aspect ratio after the projection.
            // Relevant for supported browsers. See [browser compatibility](https://developer.mozilla.org/en-US/docs/Web/CSS/object-fit)
            keepAspectRatio: true,
            // @option muted: Boolean = false
            // Whether the video starts on mute when loaded.
            muted: false,
            // @option playsInline: Boolean = true
            // Mobile browsers will play the video right where it is instead of open it up in fullscreen mode.
            playsInline: true
        },
        _initImage: function() {
            var wasElementSupplied = this._url.tagName === "VIDEO";
            var vid = this._image = wasElementSupplied ? this._url : create$1("video");
            addClass(vid, "leaflet-image-layer");
            if (this._zoomAnimated) addClass(vid, "leaflet-zoom-animated");
            if (this.options.className) addClass(vid, this.options.className);
            vid.onselectstart = falseFn;
            vid.onmousemove = falseFn;
            // @event load: Event
            // Fired when the video has finished loading the first frame
            vid.onloadeddata = bind(this.fire, this, "load");
            if (wasElementSupplied) {
                var sourceElements = vid.getElementsByTagName("source");
                var sources = [];
                for(var j = 0; j < sourceElements.length; j++)sources.push(sourceElements[j].src);
                this._url = sourceElements.length > 0 ? sources : [
                    vid.src
                ];
                return;
            }
            if (!isArray(this._url)) this._url = [
                this._url
            ];
            if (!this.options.keepAspectRatio && Object.prototype.hasOwnProperty.call(vid.style, "objectFit")) vid.style["objectFit"] = "fill";
            vid.autoplay = !!this.options.autoplay;
            vid.loop = !!this.options.loop;
            vid.muted = !!this.options.muted;
            vid.playsInline = !!this.options.playsInline;
            for(var i = 0; i < this._url.length; i++){
                var source = create$1("source");
                source.src = this._url[i];
                vid.appendChild(source);
            }
        }
    });
    // @factory L.videoOverlay(video: String|Array|HTMLVideoElement, bounds: LatLngBounds, options?: VideoOverlay options)
    // Instantiates an image overlay object given the URL of the video (or array of URLs, or even a video element) and the
    // geographical bounds it is tied to.
    function videoOverlay(video, bounds, options) {
        return new VideoOverlay(video, bounds, options);
    }
    /*
   * @class SVGOverlay
   * @aka L.SVGOverlay
   * @inherits ImageOverlay
   *
   * Used to load, display and provide DOM access to an SVG file over specific bounds of the map. Extends `ImageOverlay`.
   *
   * An SVG overlay uses the [`<svg>`](https://developer.mozilla.org/docs/Web/SVG/Element/svg) element.
   *
   * @example
   *
   * ```js
   * var svgElement = document.createElementNS("http://www.w3.org/2000/svg", "svg");
   * svgElement.setAttribute('xmlns', "http://www.w3.org/2000/svg");
   * svgElement.setAttribute('viewBox', "0 0 200 200");
   * svgElement.innerHTML = '<rect width="200" height="200"/><rect x="75" y="23" width="50" height="50" style="fill:red"/><rect x="75" y="123" width="50" height="50" style="fill:#0013ff"/>';
   * var svgElementBounds = [ [ 32, -130 ], [ 13, -100 ] ];
   * L.svgOverlay(svgElement, svgElementBounds).addTo(map);
   * ```
   */ var SVGOverlay = ImageOverlay.extend({
        _initImage: function() {
            var el = this._image = this._url;
            addClass(el, "leaflet-image-layer");
            if (this._zoomAnimated) addClass(el, "leaflet-zoom-animated");
            if (this.options.className) addClass(el, this.options.className);
            el.onselectstart = falseFn;
            el.onmousemove = falseFn;
        }
    });
    // @factory L.svgOverlay(svg: String|SVGElement, bounds: LatLngBounds, options?: SVGOverlay options)
    // Instantiates an image overlay object given an SVG element and the geographical bounds it is tied to.
    // A viewBox attribute is required on the SVG element to zoom in and out properly.
    function svgOverlay(el, bounds, options) {
        return new SVGOverlay(el, bounds, options);
    }
    /*
   * @class DivOverlay
   * @inherits Interactive layer
   * @aka L.DivOverlay
   * Base model for L.Popup and L.Tooltip. Inherit from it for custom overlays like plugins.
   */ // @namespace DivOverlay
    var DivOverlay = Layer.extend({
        // @section
        // @aka DivOverlay options
        options: {
            // @option interactive: Boolean = false
            // If true, the popup/tooltip will listen to the mouse events.
            interactive: false,
            // @option offset: Point = Point(0, 0)
            // The offset of the overlay position.
            offset: [
                0,
                0
            ],
            // @option className: String = ''
            // A custom CSS class name to assign to the overlay.
            className: "",
            // @option pane: String = undefined
            // `Map pane` where the overlay will be added.
            pane: undefined,
            // @option content: String|HTMLElement|Function = ''
            // Sets the HTML content of the overlay while initializing. If a function is passed the source layer will be
            // passed to the function. The function should return a `String` or `HTMLElement` to be used in the overlay.
            content: ""
        },
        initialize: function(options, source) {
            if (options && (options instanceof LatLng || isArray(options))) {
                this._latlng = toLatLng(options);
                setOptions(this, source);
            } else {
                setOptions(this, options);
                this._source = source;
            }
            if (this.options.content) this._content = this.options.content;
        },
        // @method openOn(map: Map): this
        // Adds the overlay to the map.
        // Alternative to `map.openPopup(popup)`/`.openTooltip(tooltip)`.
        openOn: function(map) {
            map = arguments.length ? map : this._source._map; // experimental, not the part of public api
            if (!map.hasLayer(this)) map.addLayer(this);
            return this;
        },
        // @method close(): this
        // Closes the overlay.
        // Alternative to `map.closePopup(popup)`/`.closeTooltip(tooltip)`
        // and `layer.closePopup()`/`.closeTooltip()`.
        close: function() {
            if (this._map) this._map.removeLayer(this);
            return this;
        },
        // @method toggle(layer?: Layer): this
        // Opens or closes the overlay bound to layer depending on its current state.
        // Argument may be omitted only for overlay bound to layer.
        // Alternative to `layer.togglePopup()`/`.toggleTooltip()`.
        toggle: function(layer) {
            if (this._map) this.close();
            else {
                if (arguments.length) this._source = layer;
                else layer = this._source;
                this._prepareOpen();
                // open the overlay on the map
                this.openOn(layer._map);
            }
            return this;
        },
        onAdd: function(map) {
            this._zoomAnimated = map._zoomAnimated;
            if (!this._container) this._initLayout();
            if (map._fadeAnimated) setOpacity(this._container, 0);
            clearTimeout(this._removeTimeout);
            this.getPane().appendChild(this._container);
            this.update();
            if (map._fadeAnimated) setOpacity(this._container, 1);
            this.bringToFront();
            if (this.options.interactive) {
                addClass(this._container, "leaflet-interactive");
                this.addInteractiveTarget(this._container);
            }
        },
        onRemove: function(map) {
            if (map._fadeAnimated) {
                setOpacity(this._container, 0);
                this._removeTimeout = setTimeout(bind(remove, undefined, this._container), 200);
            } else remove(this._container);
            if (this.options.interactive) {
                removeClass(this._container, "leaflet-interactive");
                this.removeInteractiveTarget(this._container);
            }
        },
        // @namespace DivOverlay
        // @method getLatLng: LatLng
        // Returns the geographical point of the overlay.
        getLatLng: function() {
            return this._latlng;
        },
        // @method setLatLng(latlng: LatLng): this
        // Sets the geographical point where the overlay will open.
        setLatLng: function(latlng) {
            this._latlng = toLatLng(latlng);
            if (this._map) {
                this._updatePosition();
                this._adjustPan();
            }
            return this;
        },
        // @method getContent: String|HTMLElement
        // Returns the content of the overlay.
        getContent: function() {
            return this._content;
        },
        // @method setContent(htmlContent: String|HTMLElement|Function): this
        // Sets the HTML content of the overlay. If a function is passed the source layer will be passed to the function.
        // The function should return a `String` or `HTMLElement` to be used in the overlay.
        setContent: function(content) {
            this._content = content;
            this.update();
            return this;
        },
        // @method getElement: String|HTMLElement
        // Returns the HTML container of the overlay.
        getElement: function() {
            return this._container;
        },
        // @method update: null
        // Updates the overlay content, layout and position. Useful for updating the overlay after something inside changed, e.g. image loaded.
        update: function() {
            if (!this._map) return;
            this._container.style.visibility = "hidden";
            this._updateContent();
            this._updateLayout();
            this._updatePosition();
            this._container.style.visibility = "";
            this._adjustPan();
        },
        getEvents: function() {
            var events = {
                zoom: this._updatePosition,
                viewreset: this._updatePosition
            };
            if (this._zoomAnimated) events.zoomanim = this._animateZoom;
            return events;
        },
        // @method isOpen: Boolean
        // Returns `true` when the overlay is visible on the map.
        isOpen: function() {
            return !!this._map && this._map.hasLayer(this);
        },
        // @method bringToFront: this
        // Brings this overlay in front of other overlays (in the same map pane).
        bringToFront: function() {
            if (this._map) toFront(this._container);
            return this;
        },
        // @method bringToBack: this
        // Brings this overlay to the back of other overlays (in the same map pane).
        bringToBack: function() {
            if (this._map) toBack(this._container);
            return this;
        },
        // prepare bound overlay to open: update latlng pos / content source (for FeatureGroup)
        _prepareOpen: function(latlng) {
            var source = this._source;
            if (!source._map) return false;
            if (source instanceof FeatureGroup) {
                source = null;
                var layers = this._source._layers;
                for(var id in layers)if (layers[id]._map) {
                    source = layers[id];
                    break;
                }
                if (!source) return false;
                 // Unable to get source layer.
                // set overlay source to this layer
                this._source = source;
            }
            if (!latlng) {
                if (source.getCenter) latlng = source.getCenter();
                else if (source.getLatLng) latlng = source.getLatLng();
                else if (source.getBounds) latlng = source.getBounds().getCenter();
                else throw new Error("Unable to get source layer LatLng.");
            }
            this.setLatLng(latlng);
            if (this._map) // update the overlay (content, layout, etc...)
            this.update();
            return true;
        },
        _updateContent: function() {
            if (!this._content) return;
            var node = this._contentNode;
            var content = typeof this._content === "function" ? this._content(this._source || this) : this._content;
            if (typeof content === "string") node.innerHTML = content;
            else {
                while(node.hasChildNodes())node.removeChild(node.firstChild);
                node.appendChild(content);
            }
            // @namespace DivOverlay
            // @section DivOverlay events
            // @event contentupdate: Event
            // Fired when the content of the overlay is updated
            this.fire("contentupdate");
        },
        _updatePosition: function() {
            if (!this._map) return;
            var pos = this._map.latLngToLayerPoint(this._latlng), offset = toPoint(this.options.offset), anchor = this._getAnchor();
            if (this._zoomAnimated) setPosition(this._container, pos.add(anchor));
            else offset = offset.add(pos).add(anchor);
            var bottom = this._containerBottom = -offset.y, left = this._containerLeft = -Math.round(this._containerWidth / 2) + offset.x;
            // bottom position the overlay in case the height of the overlay changes (images loading etc)
            this._container.style.bottom = bottom + "px";
            this._container.style.left = left + "px";
        },
        _getAnchor: function() {
            return [
                0,
                0
            ];
        }
    });
    Map.include({
        _initOverlay: function(OverlayClass, content, latlng, options) {
            var overlay = content;
            if (!(overlay instanceof OverlayClass)) overlay = new OverlayClass(options).setContent(content);
            if (latlng) overlay.setLatLng(latlng);
            return overlay;
        }
    });
    Layer.include({
        _initOverlay: function(OverlayClass, old, content, options) {
            var overlay = content;
            if (overlay instanceof OverlayClass) {
                setOptions(overlay, options);
                overlay._source = this;
            } else {
                overlay = old && !options ? old : new OverlayClass(options, this);
                overlay.setContent(content);
            }
            return overlay;
        }
    });
    /*
   * @class Popup
   * @inherits DivOverlay
   * @aka L.Popup
   * Used to open popups in certain places of the map. Use [Map.openPopup](#map-openpopup) to
   * open popups while making sure that only one popup is open at one time
   * (recommended for usability), or use [Map.addLayer](#map-addlayer) to open as many as you want.
   *
   * @example
   *
   * If you want to just bind a popup to marker click and then open it, it's really easy:
   *
   * ```js
   * marker.bindPopup(popupContent).openPopup();
   * ```
   * Path overlays like polylines also have a `bindPopup` method.
   *
   * A popup can be also standalone:
   *
   * ```js
   * var popup = L.popup()
   * 	.setLatLng(latlng)
   * 	.setContent('<p>Hello world!<br />This is a nice popup.</p>')
   * 	.openOn(map);
   * ```
   * or
   * ```js
   * var popup = L.popup(latlng, {content: '<p>Hello world!<br />This is a nice popup.</p>')
   * 	.openOn(map);
   * ```
   */ // @namespace Popup
    var Popup = DivOverlay.extend({
        // @section
        // @aka Popup options
        options: {
            // @option pane: String = 'popupPane'
            // `Map pane` where the popup will be added.
            pane: "popupPane",
            // @option offset: Point = Point(0, 7)
            // The offset of the popup position.
            offset: [
                0,
                7
            ],
            // @option maxWidth: Number = 300
            // Max width of the popup, in pixels.
            maxWidth: 300,
            // @option minWidth: Number = 50
            // Min width of the popup, in pixels.
            minWidth: 50,
            // @option maxHeight: Number = null
            // If set, creates a scrollable container of the given height
            // inside a popup if its content exceeds it.
            // The scrollable container can be styled using the
            // `leaflet-popup-scrolled` CSS class selector.
            maxHeight: null,
            // @option autoPan: Boolean = true
            // Set it to `false` if you don't want the map to do panning animation
            // to fit the opened popup.
            autoPan: true,
            // @option autoPanPaddingTopLeft: Point = null
            // The margin between the popup and the top left corner of the map
            // view after autopanning was performed.
            autoPanPaddingTopLeft: null,
            // @option autoPanPaddingBottomRight: Point = null
            // The margin between the popup and the bottom right corner of the map
            // view after autopanning was performed.
            autoPanPaddingBottomRight: null,
            // @option autoPanPadding: Point = Point(5, 5)
            // Equivalent of setting both top left and bottom right autopan padding to the same value.
            autoPanPadding: [
                5,
                5
            ],
            // @option keepInView: Boolean = false
            // Set it to `true` if you want to prevent users from panning the popup
            // off of the screen while it is open.
            keepInView: false,
            // @option closeButton: Boolean = true
            // Controls the presence of a close button in the popup.
            closeButton: true,
            // @option autoClose: Boolean = true
            // Set it to `false` if you want to override the default behavior of
            // the popup closing when another popup is opened.
            autoClose: true,
            // @option closeOnEscapeKey: Boolean = true
            // Set it to `false` if you want to override the default behavior of
            // the ESC key for closing of the popup.
            closeOnEscapeKey: true,
            // @option closeOnClick: Boolean = *
            // Set it if you want to override the default behavior of the popup closing when user clicks
            // on the map. Defaults to the map's [`closePopupOnClick`](#map-closepopuponclick) option.
            // @option className: String = ''
            // A custom CSS class name to assign to the popup.
            className: ""
        },
        // @namespace Popup
        // @method openOn(map: Map): this
        // Alternative to `map.openPopup(popup)`.
        // Adds the popup to the map and closes the previous one.
        openOn: function(map) {
            map = arguments.length ? map : this._source._map; // experimental, not the part of public api
            if (!map.hasLayer(this) && map._popup && map._popup.options.autoClose) map.removeLayer(map._popup);
            map._popup = this;
            return DivOverlay.prototype.openOn.call(this, map);
        },
        onAdd: function(map) {
            DivOverlay.prototype.onAdd.call(this, map);
            // @namespace Map
            // @section Popup events
            // @event popupopen: PopupEvent
            // Fired when a popup is opened in the map
            map.fire("popupopen", {
                popup: this
            });
            if (this._source) {
                // @namespace Layer
                // @section Popup events
                // @event popupopen: PopupEvent
                // Fired when a popup bound to this layer is opened
                this._source.fire("popupopen", {
                    popup: this
                }, true);
                // For non-path layers, we toggle the popup when clicking
                // again the layer, so prevent the map to reopen it.
                if (!(this._source instanceof Path)) this._source.on("preclick", stopPropagation);
            }
        },
        onRemove: function(map) {
            DivOverlay.prototype.onRemove.call(this, map);
            // @namespace Map
            // @section Popup events
            // @event popupclose: PopupEvent
            // Fired when a popup in the map is closed
            map.fire("popupclose", {
                popup: this
            });
            if (this._source) {
                // @namespace Layer
                // @section Popup events
                // @event popupclose: PopupEvent
                // Fired when a popup bound to this layer is closed
                this._source.fire("popupclose", {
                    popup: this
                }, true);
                if (!(this._source instanceof Path)) this._source.off("preclick", stopPropagation);
            }
        },
        getEvents: function() {
            var events = DivOverlay.prototype.getEvents.call(this);
            if (this.options.closeOnClick !== undefined ? this.options.closeOnClick : this._map.options.closePopupOnClick) events.preclick = this.close;
            if (this.options.keepInView) events.moveend = this._adjustPan;
            return events;
        },
        _initLayout: function() {
            var prefix = "leaflet-popup", container = this._container = create$1("div", prefix + " " + (this.options.className || "") + " leaflet-zoom-animated");
            var wrapper = this._wrapper = create$1("div", prefix + "-content-wrapper", container);
            this._contentNode = create$1("div", prefix + "-content", wrapper);
            disableClickPropagation(container);
            disableScrollPropagation(this._contentNode);
            on(container, "contextmenu", stopPropagation);
            this._tipContainer = create$1("div", prefix + "-tip-container", container);
            this._tip = create$1("div", prefix + "-tip", this._tipContainer);
            if (this.options.closeButton) {
                var closeButton = this._closeButton = create$1("a", prefix + "-close-button", container);
                closeButton.setAttribute("role", "button"); // overrides the implicit role=link of <a> elements #7399
                closeButton.setAttribute("aria-label", "Close popup");
                closeButton.href = "#close";
                closeButton.innerHTML = '<span aria-hidden="true">&#215;</span>';
                on(closeButton, "click", function(ev) {
                    preventDefault(ev);
                    this.close();
                }, this);
            }
        },
        _updateLayout: function() {
            var container = this._contentNode, style = container.style;
            style.width = "";
            style.whiteSpace = "nowrap";
            var width = container.offsetWidth;
            width = Math.min(width, this.options.maxWidth);
            width = Math.max(width, this.options.minWidth);
            style.width = width + 1 + "px";
            style.whiteSpace = "";
            style.height = "";
            var height = container.offsetHeight, maxHeight = this.options.maxHeight, scrolledClass = "leaflet-popup-scrolled";
            if (maxHeight && height > maxHeight) {
                style.height = maxHeight + "px";
                addClass(container, scrolledClass);
            } else removeClass(container, scrolledClass);
            this._containerWidth = this._container.offsetWidth;
        },
        _animateZoom: function(e) {
            var pos = this._map._latLngToNewLayerPoint(this._latlng, e.zoom, e.center), anchor = this._getAnchor();
            setPosition(this._container, pos.add(anchor));
        },
        _adjustPan: function() {
            if (!this.options.autoPan) return;
            if (this._map._panAnim) this._map._panAnim.stop();
            // We can endlessly recurse if keepInView is set and the view resets.
            // Let's guard against that by exiting early if we're responding to our own autopan.
            if (this._autopanning) {
                this._autopanning = false;
                return;
            }
            var map = this._map, marginBottom = parseInt(getStyle(this._container, "marginBottom"), 10) || 0, containerHeight = this._container.offsetHeight + marginBottom, containerWidth = this._containerWidth, layerPos = new Point(this._containerLeft, -containerHeight - this._containerBottom);
            layerPos._add(getPosition(this._container));
            var containerPos = map.layerPointToContainerPoint(layerPos), padding = toPoint(this.options.autoPanPadding), paddingTL = toPoint(this.options.autoPanPaddingTopLeft || padding), paddingBR = toPoint(this.options.autoPanPaddingBottomRight || padding), size = map.getSize(), dx = 0, dy = 0;
            if (containerPos.x + containerWidth + paddingBR.x > size.x) dx = containerPos.x + containerWidth - size.x + paddingBR.x;
            if (containerPos.x - dx - paddingTL.x < 0) dx = containerPos.x - paddingTL.x;
            if (containerPos.y + containerHeight + paddingBR.y > size.y) dy = containerPos.y + containerHeight - size.y + paddingBR.y;
            if (containerPos.y - dy - paddingTL.y < 0) dy = containerPos.y - paddingTL.y;
            // @namespace Map
            // @section Popup events
            // @event autopanstart: Event
            // Fired when the map starts autopanning when opening a popup.
            if (dx || dy) {
                // Track that we're autopanning, as this function will be re-ran on moveend
                if (this.options.keepInView) this._autopanning = true;
                map.fire("autopanstart").panBy([
                    dx,
                    dy
                ]);
            }
        },
        _getAnchor: function() {
            // Where should we anchor the popup on the source layer?
            return toPoint(this._source && this._source._getPopupAnchor ? this._source._getPopupAnchor() : [
                0,
                0
            ]);
        }
    });
    // @namespace Popup
    // @factory L.popup(options?: Popup options, source?: Layer)
    // Instantiates a `Popup` object given an optional `options` object that describes its appearance and location and an optional `source` object that is used to tag the popup with a reference to the Layer to which it refers.
    // @alternative
    // @factory L.popup(latlng: LatLng, options?: Popup options)
    // Instantiates a `Popup` object given `latlng` where the popup will open and an optional `options` object that describes its appearance and location.
    var popup = function(options, source) {
        return new Popup(options, source);
    };
    /* @namespace Map
   * @section Interaction Options
   * @option closePopupOnClick: Boolean = true
   * Set it to `false` if you don't want popups to close when user clicks the map.
   */ Map.mergeOptions({
        closePopupOnClick: true
    });
    // @namespace Map
    // @section Methods for Layers and Controls
    Map.include({
        // @method openPopup(popup: Popup): this
        // Opens the specified popup while closing the previously opened (to make sure only one is opened at one time for usability).
        // @alternative
        // @method openPopup(content: String|HTMLElement, latlng: LatLng, options?: Popup options): this
        // Creates a popup with the specified content and options and opens it in the given point on a map.
        openPopup: function(popup, latlng, options) {
            this._initOverlay(Popup, popup, latlng, options).openOn(this);
            return this;
        },
        // @method closePopup(popup?: Popup): this
        // Closes the popup previously opened with [openPopup](#map-openpopup) (or the given one).
        closePopup: function(popup) {
            popup = arguments.length ? popup : this._popup;
            if (popup) popup.close();
            return this;
        }
    });
    /*
   * @namespace Layer
   * @section Popup methods example
   *
   * All layers share a set of methods convenient for binding popups to it.
   *
   * ```js
   * var layer = L.Polygon(latlngs).bindPopup('Hi There!').addTo(map);
   * layer.openPopup();
   * layer.closePopup();
   * ```
   *
   * Popups will also be automatically opened when the layer is clicked on and closed when the layer is removed from the map or another popup is opened.
   */ // @section Popup methods
    Layer.include({
        // @method bindPopup(content: String|HTMLElement|Function|Popup, options?: Popup options): this
        // Binds a popup to the layer with the passed `content` and sets up the
        // necessary event listeners. If a `Function` is passed it will receive
        // the layer as the first argument and should return a `String` or `HTMLElement`.
        bindPopup: function(content, options) {
            this._popup = this._initOverlay(Popup, this._popup, content, options);
            if (!this._popupHandlersAdded) {
                this.on({
                    click: this._openPopup,
                    keypress: this._onKeyPress,
                    remove: this.closePopup,
                    move: this._movePopup
                });
                this._popupHandlersAdded = true;
            }
            return this;
        },
        // @method unbindPopup(): this
        // Removes the popup previously bound with `bindPopup`.
        unbindPopup: function() {
            if (this._popup) {
                this.off({
                    click: this._openPopup,
                    keypress: this._onKeyPress,
                    remove: this.closePopup,
                    move: this._movePopup
                });
                this._popupHandlersAdded = false;
                this._popup = null;
            }
            return this;
        },
        // @method openPopup(latlng?: LatLng): this
        // Opens the bound popup at the specified `latlng` or at the default popup anchor if no `latlng` is passed.
        openPopup: function(latlng) {
            if (this._popup) {
                if (!(this instanceof FeatureGroup)) this._popup._source = this;
                if (this._popup._prepareOpen(latlng || this._latlng)) // open the popup on the map
                this._popup.openOn(this._map);
            }
            return this;
        },
        // @method closePopup(): this
        // Closes the popup bound to this layer if it is open.
        closePopup: function() {
            if (this._popup) this._popup.close();
            return this;
        },
        // @method togglePopup(): this
        // Opens or closes the popup bound to this layer depending on its current state.
        togglePopup: function() {
            if (this._popup) this._popup.toggle(this);
            return this;
        },
        // @method isPopupOpen(): boolean
        // Returns `true` if the popup bound to this layer is currently open.
        isPopupOpen: function() {
            return this._popup ? this._popup.isOpen() : false;
        },
        // @method setPopupContent(content: String|HTMLElement|Popup): this
        // Sets the content of the popup bound to this layer.
        setPopupContent: function(content) {
            if (this._popup) this._popup.setContent(content);
            return this;
        },
        // @method getPopup(): Popup
        // Returns the popup bound to this layer.
        getPopup: function() {
            return this._popup;
        },
        _openPopup: function(e) {
            if (!this._popup || !this._map) return;
            // prevent map click
            stop(e);
            var target = e.layer || e.target;
            if (this._popup._source === target && !(target instanceof Path)) {
                // treat it like a marker and figure out
                // if we should toggle it open/closed
                if (this._map.hasLayer(this._popup)) this.closePopup();
                else this.openPopup(e.latlng);
                return;
            }
            this._popup._source = target;
            this.openPopup(e.latlng);
        },
        _movePopup: function(e) {
            this._popup.setLatLng(e.latlng);
        },
        _onKeyPress: function(e) {
            if (e.originalEvent.keyCode === 13) this._openPopup(e);
        }
    });
    /*
   * @class Tooltip
   * @inherits DivOverlay
   * @aka L.Tooltip
   * Used to display small texts on top of map layers.
   *
   * @example
   * If you want to just bind a tooltip to marker:
   *
   * ```js
   * marker.bindTooltip("my tooltip text").openTooltip();
   * ```
   * Path overlays like polylines also have a `bindTooltip` method.
   *
   * A tooltip can be also standalone:
   *
   * ```js
   * var tooltip = L.tooltip()
   * 	.setLatLng(latlng)
   * 	.setContent('Hello world!<br />This is a nice tooltip.')
   * 	.addTo(map);
   * ```
   * or
   * ```js
   * var tooltip = L.tooltip(latlng, {content: 'Hello world!<br />This is a nice tooltip.'})
   * 	.addTo(map);
   * ```
   *
   *
   * Note about tooltip offset. Leaflet takes two options in consideration
   * for computing tooltip offsetting:
   * - the `offset` Tooltip option: it defaults to [0, 0], and it's specific to one tooltip.
   *   Add a positive x offset to move the tooltip to the right, and a positive y offset to
   *   move it to the bottom. Negatives will move to the left and top.
   * - the `tooltipAnchor` Icon option: this will only be considered for Marker. You
   *   should adapt this value if you use a custom icon.
   */ // @namespace Tooltip
    var Tooltip = DivOverlay.extend({
        // @section
        // @aka Tooltip options
        options: {
            // @option pane: String = 'tooltipPane'
            // `Map pane` where the tooltip will be added.
            pane: "tooltipPane",
            // @option offset: Point = Point(0, 0)
            // Optional offset of the tooltip position.
            offset: [
                0,
                0
            ],
            // @option direction: String = 'auto'
            // Direction where to open the tooltip. Possible values are: `right`, `left`,
            // `top`, `bottom`, `center`, `auto`.
            // `auto` will dynamically switch between `right` and `left` according to the tooltip
            // position on the map.
            direction: "auto",
            // @option permanent: Boolean = false
            // Whether to open the tooltip permanently or only on mouseover.
            permanent: false,
            // @option sticky: Boolean = false
            // If true, the tooltip will follow the mouse instead of being fixed at the feature center.
            sticky: false,
            // @option opacity: Number = 0.9
            // Tooltip container opacity.
            opacity: 0.9
        },
        onAdd: function(map) {
            DivOverlay.prototype.onAdd.call(this, map);
            this.setOpacity(this.options.opacity);
            // @namespace Map
            // @section Tooltip events
            // @event tooltipopen: TooltipEvent
            // Fired when a tooltip is opened in the map.
            map.fire("tooltipopen", {
                tooltip: this
            });
            if (this._source) {
                this.addEventParent(this._source);
                // @namespace Layer
                // @section Tooltip events
                // @event tooltipopen: TooltipEvent
                // Fired when a tooltip bound to this layer is opened.
                this._source.fire("tooltipopen", {
                    tooltip: this
                }, true);
            }
        },
        onRemove: function(map) {
            DivOverlay.prototype.onRemove.call(this, map);
            // @namespace Map
            // @section Tooltip events
            // @event tooltipclose: TooltipEvent
            // Fired when a tooltip in the map is closed.
            map.fire("tooltipclose", {
                tooltip: this
            });
            if (this._source) {
                this.removeEventParent(this._source);
                // @namespace Layer
                // @section Tooltip events
                // @event tooltipclose: TooltipEvent
                // Fired when a tooltip bound to this layer is closed.
                this._source.fire("tooltipclose", {
                    tooltip: this
                }, true);
            }
        },
        getEvents: function() {
            var events = DivOverlay.prototype.getEvents.call(this);
            if (!this.options.permanent) events.preclick = this.close;
            return events;
        },
        _initLayout: function() {
            var prefix = "leaflet-tooltip", className = prefix + " " + (this.options.className || "") + " leaflet-zoom-" + (this._zoomAnimated ? "animated" : "hide");
            this._contentNode = this._container = create$1("div", className);
            this._container.setAttribute("role", "tooltip");
            this._container.setAttribute("id", "leaflet-tooltip-" + stamp(this));
        },
        _updateLayout: function() {},
        _adjustPan: function() {},
        _setPosition: function(pos) {
            var subX, subY, map = this._map, container = this._container, centerPoint = map.latLngToContainerPoint(map.getCenter()), tooltipPoint = map.layerPointToContainerPoint(pos), direction = this.options.direction, tooltipWidth = container.offsetWidth, tooltipHeight = container.offsetHeight, offset = toPoint(this.options.offset), anchor = this._getAnchor();
            if (direction === "top") {
                subX = tooltipWidth / 2;
                subY = tooltipHeight;
            } else if (direction === "bottom") {
                subX = tooltipWidth / 2;
                subY = 0;
            } else if (direction === "center") {
                subX = tooltipWidth / 2;
                subY = tooltipHeight / 2;
            } else if (direction === "right") {
                subX = 0;
                subY = tooltipHeight / 2;
            } else if (direction === "left") {
                subX = tooltipWidth;
                subY = tooltipHeight / 2;
            } else if (tooltipPoint.x < centerPoint.x) {
                direction = "right";
                subX = 0;
                subY = tooltipHeight / 2;
            } else {
                direction = "left";
                subX = tooltipWidth + (offset.x + anchor.x) * 2;
                subY = tooltipHeight / 2;
            }
            pos = pos.subtract(toPoint(subX, subY, true)).add(offset).add(anchor);
            removeClass(container, "leaflet-tooltip-right");
            removeClass(container, "leaflet-tooltip-left");
            removeClass(container, "leaflet-tooltip-top");
            removeClass(container, "leaflet-tooltip-bottom");
            addClass(container, "leaflet-tooltip-" + direction);
            setPosition(container, pos);
        },
        _updatePosition: function() {
            var pos = this._map.latLngToLayerPoint(this._latlng);
            this._setPosition(pos);
        },
        setOpacity: function(opacity) {
            this.options.opacity = opacity;
            if (this._container) setOpacity(this._container, opacity);
        },
        _animateZoom: function(e) {
            var pos = this._map._latLngToNewLayerPoint(this._latlng, e.zoom, e.center);
            this._setPosition(pos);
        },
        _getAnchor: function() {
            // Where should we anchor the tooltip on the source layer?
            return toPoint(this._source && this._source._getTooltipAnchor && !this.options.sticky ? this._source._getTooltipAnchor() : [
                0,
                0
            ]);
        }
    });
    // @namespace Tooltip
    // @factory L.tooltip(options?: Tooltip options, source?: Layer)
    // Instantiates a `Tooltip` object given an optional `options` object that describes its appearance and location and an optional `source` object that is used to tag the tooltip with a reference to the Layer to which it refers.
    // @alternative
    // @factory L.tooltip(latlng: LatLng, options?: Tooltip options)
    // Instantiates a `Tooltip` object given `latlng` where the tooltip will open and an optional `options` object that describes its appearance and location.
    var tooltip = function(options, source) {
        return new Tooltip(options, source);
    };
    // @namespace Map
    // @section Methods for Layers and Controls
    Map.include({
        // @method openTooltip(tooltip: Tooltip): this
        // Opens the specified tooltip.
        // @alternative
        // @method openTooltip(content: String|HTMLElement, latlng: LatLng, options?: Tooltip options): this
        // Creates a tooltip with the specified content and options and open it.
        openTooltip: function(tooltip, latlng, options) {
            this._initOverlay(Tooltip, tooltip, latlng, options).openOn(this);
            return this;
        },
        // @method closeTooltip(tooltip: Tooltip): this
        // Closes the tooltip given as parameter.
        closeTooltip: function(tooltip) {
            tooltip.close();
            return this;
        }
    });
    /*
   * @namespace Layer
   * @section Tooltip methods example
   *
   * All layers share a set of methods convenient for binding tooltips to it.
   *
   * ```js
   * var layer = L.Polygon(latlngs).bindTooltip('Hi There!').addTo(map);
   * layer.openTooltip();
   * layer.closeTooltip();
   * ```
   */ // @section Tooltip methods
    Layer.include({
        // @method bindTooltip(content: String|HTMLElement|Function|Tooltip, options?: Tooltip options): this
        // Binds a tooltip to the layer with the passed `content` and sets up the
        // necessary event listeners. If a `Function` is passed it will receive
        // the layer as the first argument and should return a `String` or `HTMLElement`.
        bindTooltip: function(content, options) {
            if (this._tooltip && this.isTooltipOpen()) this.unbindTooltip();
            this._tooltip = this._initOverlay(Tooltip, this._tooltip, content, options);
            this._initTooltipInteractions();
            if (this._tooltip.options.permanent && this._map && this._map.hasLayer(this)) this.openTooltip();
            return this;
        },
        // @method unbindTooltip(): this
        // Removes the tooltip previously bound with `bindTooltip`.
        unbindTooltip: function() {
            if (this._tooltip) {
                this._initTooltipInteractions(true);
                this.closeTooltip();
                this._tooltip = null;
            }
            return this;
        },
        _initTooltipInteractions: function(remove) {
            if (!remove && this._tooltipHandlersAdded) return;
            var onOff = remove ? "off" : "on", events = {
                remove: this.closeTooltip,
                move: this._moveTooltip
            };
            if (!this._tooltip.options.permanent) {
                events.mouseover = this._openTooltip;
                events.mouseout = this.closeTooltip;
                events.click = this._openTooltip;
                if (this._map) this._addFocusListeners();
                else events.add = this._addFocusListeners;
            } else events.add = this._openTooltip;
            if (this._tooltip.options.sticky) events.mousemove = this._moveTooltip;
            this[onOff](events);
            this._tooltipHandlersAdded = !remove;
        },
        // @method openTooltip(latlng?: LatLng): this
        // Opens the bound tooltip at the specified `latlng` or at the default tooltip anchor if no `latlng` is passed.
        openTooltip: function(latlng) {
            if (this._tooltip) {
                if (!(this instanceof FeatureGroup)) this._tooltip._source = this;
                if (this._tooltip._prepareOpen(latlng)) {
                    // open the tooltip on the map
                    this._tooltip.openOn(this._map);
                    if (this.getElement) this._setAriaDescribedByOnLayer(this);
                    else if (this.eachLayer) this.eachLayer(this._setAriaDescribedByOnLayer, this);
                }
            }
            return this;
        },
        // @method closeTooltip(): this
        // Closes the tooltip bound to this layer if it is open.
        closeTooltip: function() {
            if (this._tooltip) return this._tooltip.close();
        },
        // @method toggleTooltip(): this
        // Opens or closes the tooltip bound to this layer depending on its current state.
        toggleTooltip: function() {
            if (this._tooltip) this._tooltip.toggle(this);
            return this;
        },
        // @method isTooltipOpen(): boolean
        // Returns `true` if the tooltip bound to this layer is currently open.
        isTooltipOpen: function() {
            return this._tooltip.isOpen();
        },
        // @method setTooltipContent(content: String|HTMLElement|Tooltip): this
        // Sets the content of the tooltip bound to this layer.
        setTooltipContent: function(content) {
            if (this._tooltip) this._tooltip.setContent(content);
            return this;
        },
        // @method getTooltip(): Tooltip
        // Returns the tooltip bound to this layer.
        getTooltip: function() {
            return this._tooltip;
        },
        _addFocusListeners: function() {
            if (this.getElement) this._addFocusListenersOnLayer(this);
            else if (this.eachLayer) this.eachLayer(this._addFocusListenersOnLayer, this);
        },
        _addFocusListenersOnLayer: function(layer) {
            var el = typeof layer.getElement === "function" && layer.getElement();
            if (el) {
                on(el, "focus", function() {
                    this._tooltip._source = layer;
                    this.openTooltip();
                }, this);
                on(el, "blur", this.closeTooltip, this);
            }
        },
        _setAriaDescribedByOnLayer: function(layer) {
            var el = typeof layer.getElement === "function" && layer.getElement();
            if (el) el.setAttribute("aria-describedby", this._tooltip._container.id);
        },
        _openTooltip: function(e) {
            if (!this._tooltip || !this._map) return;
            // If the map is moving, we will show the tooltip after it's done.
            if (this._map.dragging && this._map.dragging.moving() && !this._openOnceFlag) {
                this._openOnceFlag = true;
                var that = this;
                this._map.once("moveend", function() {
                    that._openOnceFlag = false;
                    that._openTooltip(e);
                });
                return;
            }
            this._tooltip._source = e.layer || e.target;
            this.openTooltip(this._tooltip.options.sticky ? e.latlng : undefined);
        },
        _moveTooltip: function(e) {
            var latlng = e.latlng, containerPoint, layerPoint;
            if (this._tooltip.options.sticky && e.originalEvent) {
                containerPoint = this._map.mouseEventToContainerPoint(e.originalEvent);
                layerPoint = this._map.containerPointToLayerPoint(containerPoint);
                latlng = this._map.layerPointToLatLng(layerPoint);
            }
            this._tooltip.setLatLng(latlng);
        }
    });
    /*
   * @class DivIcon
   * @aka L.DivIcon
   * @inherits Icon
   *
   * Represents a lightweight icon for markers that uses a simple `<div>`
   * element instead of an image. Inherits from `Icon` but ignores the `iconUrl` and shadow options.
   *
   * @example
   * ```js
   * var myIcon = L.divIcon({className: 'my-div-icon'});
   * // you can set .my-div-icon styles in CSS
   *
   * L.marker([50.505, 30.57], {icon: myIcon}).addTo(map);
   * ```
   *
   * By default, it has a 'leaflet-div-icon' CSS class and is styled as a little white square with a shadow.
   */ var DivIcon = Icon.extend({
        options: {
            // @section
            // @aka DivIcon options
            iconSize: [
                12,
                12
            ],
            // iconAnchor: (Point),
            // popupAnchor: (Point),
            // @option html: String|HTMLElement = ''
            // Custom HTML code to put inside the div element, empty by default. Alternatively,
            // an instance of `HTMLElement`.
            html: false,
            // @option bgPos: Point = [0, 0]
            // Optional relative position of the background, in pixels
            bgPos: null,
            className: "leaflet-div-icon"
        },
        createIcon: function(oldIcon) {
            var div = oldIcon && oldIcon.tagName === "DIV" ? oldIcon : document.createElement("div"), options = this.options;
            if (options.html instanceof Element) {
                empty(div);
                div.appendChild(options.html);
            } else div.innerHTML = options.html !== false ? options.html : "";
            if (options.bgPos) {
                var bgPos = toPoint(options.bgPos);
                div.style.backgroundPosition = -bgPos.x + "px " + -bgPos.y + "px";
            }
            this._setIconStyles(div, "icon");
            return div;
        },
        createShadow: function() {
            return null;
        }
    });
    // @factory L.divIcon(options: DivIcon options)
    // Creates a `DivIcon` instance with the given options.
    function divIcon(options) {
        return new DivIcon(options);
    }
    Icon.Default = IconDefault;
    /*
   * @class GridLayer
   * @inherits Layer
   * @aka L.GridLayer
   *
   * Generic class for handling a tiled grid of HTML elements. This is the base class for all tile layers and replaces `TileLayer.Canvas`.
   * GridLayer can be extended to create a tiled grid of HTML elements like `<canvas>`, `<img>` or `<div>`. GridLayer will handle creating and animating these DOM elements for you.
   *
   *
   * @section Synchronous usage
   * @example
   *
   * To create a custom layer, extend GridLayer and implement the `createTile()` method, which will be passed a `Point` object with the `x`, `y`, and `z` (zoom level) coordinates to draw your tile.
   *
   * ```js
   * var CanvasLayer = L.GridLayer.extend({
   *     createTile: function(coords){
   *         // create a <canvas> element for drawing
   *         var tile = L.DomUtil.create('canvas', 'leaflet-tile');
   *
   *         // setup tile width and height according to the options
   *         var size = this.getTileSize();
   *         tile.width = size.x;
   *         tile.height = size.y;
   *
   *         // get a canvas context and draw something on it using coords.x, coords.y and coords.z
   *         var ctx = tile.getContext('2d');
   *
   *         // return the tile so it can be rendered on screen
   *         return tile;
   *     }
   * });
   * ```
   *
   * @section Asynchronous usage
   * @example
   *
   * Tile creation can also be asynchronous, this is useful when using a third-party drawing library. Once the tile is finished drawing it can be passed to the `done()` callback.
   *
   * ```js
   * var CanvasLayer = L.GridLayer.extend({
   *     createTile: function(coords, done){
   *         var error;
   *
   *         // create a <canvas> element for drawing
   *         var tile = L.DomUtil.create('canvas', 'leaflet-tile');
   *
   *         // setup tile width and height according to the options
   *         var size = this.getTileSize();
   *         tile.width = size.x;
   *         tile.height = size.y;
   *
   *         // draw something asynchronously and pass the tile to the done() callback
   *         setTimeout(function() {
   *             done(error, tile);
   *         }, 1000);
   *
   *         return tile;
   *     }
   * });
   * ```
   *
   * @section
   */ var GridLayer = Layer.extend({
        // @section
        // @aka GridLayer options
        options: {
            // @option tileSize: Number|Point = 256
            // Width and height of tiles in the grid. Use a number if width and height are equal, or `L.point(width, height)` otherwise.
            tileSize: 256,
            // @option opacity: Number = 1.0
            // Opacity of the tiles. Can be used in the `createTile()` function.
            opacity: 1,
            // @option updateWhenIdle: Boolean = (depends)
            // Load new tiles only when panning ends.
            // `true` by default on mobile browsers, in order to avoid too many requests and keep smooth navigation.
            // `false` otherwise in order to display new tiles _during_ panning, since it is easy to pan outside the
            // [`keepBuffer`](#gridlayer-keepbuffer) option in desktop browsers.
            updateWhenIdle: Browser.mobile,
            // @option updateWhenZooming: Boolean = true
            // By default, a smooth zoom animation (during a [touch zoom](#map-touchzoom) or a [`flyTo()`](#map-flyto)) will update grid layers every integer zoom level. Setting this option to `false` will update the grid layer only when the smooth animation ends.
            updateWhenZooming: true,
            // @option updateInterval: Number = 200
            // Tiles will not update more than once every `updateInterval` milliseconds when panning.
            updateInterval: 200,
            // @option zIndex: Number = 1
            // The explicit zIndex of the tile layer.
            zIndex: 1,
            // @option bounds: LatLngBounds = undefined
            // If set, tiles will only be loaded inside the set `LatLngBounds`.
            bounds: null,
            // @option minZoom: Number = 0
            // The minimum zoom level down to which this layer will be displayed (inclusive).
            minZoom: 0,
            // @option maxZoom: Number = undefined
            // The maximum zoom level up to which this layer will be displayed (inclusive).
            maxZoom: undefined,
            // @option maxNativeZoom: Number = undefined
            // Maximum zoom number the tile source has available. If it is specified,
            // the tiles on all zoom levels higher than `maxNativeZoom` will be loaded
            // from `maxNativeZoom` level and auto-scaled.
            maxNativeZoom: undefined,
            // @option minNativeZoom: Number = undefined
            // Minimum zoom number the tile source has available. If it is specified,
            // the tiles on all zoom levels lower than `minNativeZoom` will be loaded
            // from `minNativeZoom` level and auto-scaled.
            minNativeZoom: undefined,
            // @option noWrap: Boolean = false
            // Whether the layer is wrapped around the antimeridian. If `true`, the
            // GridLayer will only be displayed once at low zoom levels. Has no
            // effect when the [map CRS](#map-crs) doesn't wrap around. Can be used
            // in combination with [`bounds`](#gridlayer-bounds) to prevent requesting
            // tiles outside the CRS limits.
            noWrap: false,
            // @option pane: String = 'tilePane'
            // `Map pane` where the grid layer will be added.
            pane: "tilePane",
            // @option className: String = ''
            // A custom class name to assign to the tile layer. Empty by default.
            className: "",
            // @option keepBuffer: Number = 2
            // When panning the map, keep this many rows and columns of tiles before unloading them.
            keepBuffer: 2
        },
        initialize: function(options) {
            setOptions(this, options);
        },
        onAdd: function() {
            this._initContainer();
            this._levels = {};
            this._tiles = {};
            this._resetView(); // implicit _update() call
        },
        beforeAdd: function(map) {
            map._addZoomLimit(this);
        },
        onRemove: function(map) {
            this._removeAllTiles();
            remove(this._container);
            map._removeZoomLimit(this);
            this._container = null;
            this._tileZoom = undefined;
        },
        // @method bringToFront: this
        // Brings the tile layer to the top of all tile layers.
        bringToFront: function() {
            if (this._map) {
                toFront(this._container);
                this._setAutoZIndex(Math.max);
            }
            return this;
        },
        // @method bringToBack: this
        // Brings the tile layer to the bottom of all tile layers.
        bringToBack: function() {
            if (this._map) {
                toBack(this._container);
                this._setAutoZIndex(Math.min);
            }
            return this;
        },
        // @method getContainer: HTMLElement
        // Returns the HTML element that contains the tiles for this layer.
        getContainer: function() {
            return this._container;
        },
        // @method setOpacity(opacity: Number): this
        // Changes the [opacity](#gridlayer-opacity) of the grid layer.
        setOpacity: function(opacity) {
            this.options.opacity = opacity;
            this._updateOpacity();
            return this;
        },
        // @method setZIndex(zIndex: Number): this
        // Changes the [zIndex](#gridlayer-zindex) of the grid layer.
        setZIndex: function(zIndex) {
            this.options.zIndex = zIndex;
            this._updateZIndex();
            return this;
        },
        // @method isLoading: Boolean
        // Returns `true` if any tile in the grid layer has not finished loading.
        isLoading: function() {
            return this._loading;
        },
        // @method redraw: this
        // Causes the layer to clear all the tiles and request them again.
        redraw: function() {
            if (this._map) {
                this._removeAllTiles();
                var tileZoom = this._clampZoom(this._map.getZoom());
                if (tileZoom !== this._tileZoom) {
                    this._tileZoom = tileZoom;
                    this._updateLevels();
                }
                this._update();
            }
            return this;
        },
        getEvents: function() {
            var events = {
                viewprereset: this._invalidateAll,
                viewreset: this._resetView,
                zoom: this._resetView,
                moveend: this._onMoveEnd
            };
            if (!this.options.updateWhenIdle) {
                // update tiles on move, but not more often than once per given interval
                if (!this._onMove) this._onMove = throttle(this._onMoveEnd, this.options.updateInterval, this);
                events.move = this._onMove;
            }
            if (this._zoomAnimated) events.zoomanim = this._animateZoom;
            return events;
        },
        // @section Extension methods
        // Layers extending `GridLayer` shall reimplement the following method.
        // @method createTile(coords: Object, done?: Function): HTMLElement
        // Called only internally, must be overridden by classes extending `GridLayer`.
        // Returns the `HTMLElement` corresponding to the given `coords`. If the `done` callback
        // is specified, it must be called when the tile has finished loading and drawing.
        createTile: function() {
            return document.createElement("div");
        },
        // @section
        // @method getTileSize: Point
        // Normalizes the [tileSize option](#gridlayer-tilesize) into a point. Used by the `createTile()` method.
        getTileSize: function() {
            var s = this.options.tileSize;
            return s instanceof Point ? s : new Point(s, s);
        },
        _updateZIndex: function() {
            if (this._container && this.options.zIndex !== undefined && this.options.zIndex !== null) this._container.style.zIndex = this.options.zIndex;
        },
        _setAutoZIndex: function(compare) {
            // go through all other layers of the same pane, set zIndex to max + 1 (front) or min - 1 (back)
            var layers = this.getPane().children, edgeZIndex = -compare(-Infinity, Infinity); // -Infinity for max, Infinity for min
            for(var i = 0, len = layers.length, zIndex; i < len; i++){
                zIndex = layers[i].style.zIndex;
                if (layers[i] !== this._container && zIndex) edgeZIndex = compare(edgeZIndex, +zIndex);
            }
            if (isFinite(edgeZIndex)) {
                this.options.zIndex = edgeZIndex + compare(-1, 1);
                this._updateZIndex();
            }
        },
        _updateOpacity: function() {
            if (!this._map) return;
            // IE doesn't inherit filter opacity properly, so we're forced to set it on tiles
            if (Browser.ielt9) return;
            setOpacity(this._container, this.options.opacity);
            var now = +new Date(), nextFrame = false, willPrune = false;
            for(var key in this._tiles){
                var tile = this._tiles[key];
                if (!tile.current || !tile.loaded) continue;
                var fade = Math.min(1, (now - tile.loaded) / 200);
                setOpacity(tile.el, fade);
                if (fade < 1) nextFrame = true;
                else {
                    if (tile.active) willPrune = true;
                    else this._onOpaqueTile(tile);
                    tile.active = true;
                }
            }
            if (willPrune && !this._noPrune) this._pruneTiles();
            if (nextFrame) {
                cancelAnimFrame(this._fadeFrame);
                this._fadeFrame = requestAnimFrame(this._updateOpacity, this);
            }
        },
        _onOpaqueTile: falseFn,
        _initContainer: function() {
            if (this._container) return;
            this._container = create$1("div", "leaflet-layer " + (this.options.className || ""));
            this._updateZIndex();
            if (this.options.opacity < 1) this._updateOpacity();
            this.getPane().appendChild(this._container);
        },
        _updateLevels: function() {
            var zoom = this._tileZoom, maxZoom = this.options.maxZoom;
            if (zoom === undefined) return undefined;
            for(var z in this._levels){
                z = Number(z);
                if (this._levels[z].el.children.length || z === zoom) {
                    this._levels[z].el.style.zIndex = maxZoom - Math.abs(zoom - z);
                    this._onUpdateLevel(z);
                } else {
                    remove(this._levels[z].el);
                    this._removeTilesAtZoom(z);
                    this._onRemoveLevel(z);
                    delete this._levels[z];
                }
            }
            var level = this._levels[zoom], map = this._map;
            if (!level) {
                level = this._levels[zoom] = {};
                level.el = create$1("div", "leaflet-tile-container leaflet-zoom-animated", this._container);
                level.el.style.zIndex = maxZoom;
                level.origin = map.project(map.unproject(map.getPixelOrigin()), zoom).round();
                level.zoom = zoom;
                this._setZoomTransform(level, map.getCenter(), map.getZoom());
                // force the browser to consider the newly added element for transition
                falseFn(level.el.offsetWidth);
                this._onCreateLevel(level);
            }
            this._level = level;
            return level;
        },
        _onUpdateLevel: falseFn,
        _onRemoveLevel: falseFn,
        _onCreateLevel: falseFn,
        _pruneTiles: function() {
            if (!this._map) return;
            var key, tile;
            var zoom = this._map.getZoom();
            if (zoom > this.options.maxZoom || zoom < this.options.minZoom) {
                this._removeAllTiles();
                return;
            }
            for(key in this._tiles){
                tile = this._tiles[key];
                tile.retain = tile.current;
            }
            for(key in this._tiles){
                tile = this._tiles[key];
                if (tile.current && !tile.active) {
                    var coords = tile.coords;
                    if (!this._retainParent(coords.x, coords.y, coords.z, coords.z - 5)) this._retainChildren(coords.x, coords.y, coords.z, coords.z + 2);
                }
            }
            for(key in this._tiles)if (!this._tiles[key].retain) this._removeTile(key);
        },
        _removeTilesAtZoom: function(zoom) {
            for(var key in this._tiles){
                if (this._tiles[key].coords.z !== zoom) continue;
                this._removeTile(key);
            }
        },
        _removeAllTiles: function() {
            for(var key in this._tiles)this._removeTile(key);
        },
        _invalidateAll: function() {
            for(var z in this._levels){
                remove(this._levels[z].el);
                this._onRemoveLevel(Number(z));
                delete this._levels[z];
            }
            this._removeAllTiles();
            this._tileZoom = undefined;
        },
        _retainParent: function(x, y, z, minZoom) {
            var x2 = Math.floor(x / 2), y2 = Math.floor(y / 2), z2 = z - 1, coords2 = new Point(+x2, +y2);
            coords2.z = +z2;
            var key = this._tileCoordsToKey(coords2), tile = this._tiles[key];
            if (tile && tile.active) {
                tile.retain = true;
                return true;
            } else if (tile && tile.loaded) tile.retain = true;
            if (z2 > minZoom) return this._retainParent(x2, y2, z2, minZoom);
            return false;
        },
        _retainChildren: function(x, y, z, maxZoom) {
            for(var i = 2 * x; i < 2 * x + 2; i++)for(var j = 2 * y; j < 2 * y + 2; j++){
                var coords = new Point(i, j);
                coords.z = z + 1;
                var key = this._tileCoordsToKey(coords), tile = this._tiles[key];
                if (tile && tile.active) {
                    tile.retain = true;
                    continue;
                } else if (tile && tile.loaded) tile.retain = true;
                if (z + 1 < maxZoom) this._retainChildren(i, j, z + 1, maxZoom);
            }
        },
        _resetView: function(e) {
            var animating = e && (e.pinch || e.flyTo);
            this._setView(this._map.getCenter(), this._map.getZoom(), animating, animating);
        },
        _animateZoom: function(e) {
            this._setView(e.center, e.zoom, true, e.noUpdate);
        },
        _clampZoom: function(zoom) {
            var options = this.options;
            if (undefined !== options.minNativeZoom && zoom < options.minNativeZoom) return options.minNativeZoom;
            if (undefined !== options.maxNativeZoom && options.maxNativeZoom < zoom) return options.maxNativeZoom;
            return zoom;
        },
        _setView: function(center, zoom, noPrune, noUpdate) {
            var tileZoom = Math.round(zoom);
            if (this.options.maxZoom !== undefined && tileZoom > this.options.maxZoom || this.options.minZoom !== undefined && tileZoom < this.options.minZoom) tileZoom = undefined;
            else tileZoom = this._clampZoom(tileZoom);
            var tileZoomChanged = this.options.updateWhenZooming && tileZoom !== this._tileZoom;
            if (!noUpdate || tileZoomChanged) {
                this._tileZoom = tileZoom;
                if (this._abortLoading) this._abortLoading();
                this._updateLevels();
                this._resetGrid();
                if (tileZoom !== undefined) this._update(center);
                if (!noPrune) this._pruneTiles();
                // Flag to prevent _updateOpacity from pruning tiles during
                // a zoom anim or a pinch gesture
                this._noPrune = !!noPrune;
            }
            this._setZoomTransforms(center, zoom);
        },
        _setZoomTransforms: function(center, zoom) {
            for(var i in this._levels)this._setZoomTransform(this._levels[i], center, zoom);
        },
        _setZoomTransform: function(level, center, zoom) {
            var scale = this._map.getZoomScale(zoom, level.zoom), translate = level.origin.multiplyBy(scale).subtract(this._map._getNewPixelOrigin(center, zoom)).round();
            if (Browser.any3d) setTransform(level.el, translate, scale);
            else setPosition(level.el, translate);
        },
        _resetGrid: function() {
            var map = this._map, crs = map.options.crs, tileSize = this._tileSize = this.getTileSize(), tileZoom = this._tileZoom;
            var bounds = this._map.getPixelWorldBounds(this._tileZoom);
            if (bounds) this._globalTileRange = this._pxBoundsToTileRange(bounds);
            this._wrapX = crs.wrapLng && !this.options.noWrap && [
                Math.floor(map.project([
                    0,
                    crs.wrapLng[0]
                ], tileZoom).x / tileSize.x),
                Math.ceil(map.project([
                    0,
                    crs.wrapLng[1]
                ], tileZoom).x / tileSize.y)
            ];
            this._wrapY = crs.wrapLat && !this.options.noWrap && [
                Math.floor(map.project([
                    crs.wrapLat[0],
                    0
                ], tileZoom).y / tileSize.x),
                Math.ceil(map.project([
                    crs.wrapLat[1],
                    0
                ], tileZoom).y / tileSize.y)
            ];
        },
        _onMoveEnd: function() {
            if (!this._map || this._map._animatingZoom) return;
            this._update();
        },
        _getTiledPixelBounds: function(center) {
            var map = this._map, mapZoom = map._animatingZoom ? Math.max(map._animateToZoom, map.getZoom()) : map.getZoom(), scale = map.getZoomScale(mapZoom, this._tileZoom), pixelCenter = map.project(center, this._tileZoom).floor(), halfSize = map.getSize().divideBy(scale * 2);
            return new Bounds(pixelCenter.subtract(halfSize), pixelCenter.add(halfSize));
        },
        // Private method to load tiles in the grid's active zoom level according to map bounds
        _update: function(center) {
            var map = this._map;
            if (!map) return;
            var zoom = this._clampZoom(map.getZoom());
            if (center === undefined) center = map.getCenter();
            if (this._tileZoom === undefined) return;
             // if out of minzoom/maxzoom
            var pixelBounds = this._getTiledPixelBounds(center), tileRange = this._pxBoundsToTileRange(pixelBounds), tileCenter = tileRange.getCenter(), queue = [], margin = this.options.keepBuffer, noPruneRange = new Bounds(tileRange.getBottomLeft().subtract([
                margin,
                -margin
            ]), tileRange.getTopRight().add([
                margin,
                -margin
            ]));
            // Sanity check: panic if the tile range contains Infinity somewhere.
            if (!(isFinite(tileRange.min.x) && isFinite(tileRange.min.y) && isFinite(tileRange.max.x) && isFinite(tileRange.max.y))) throw new Error("Attempted to load an infinite number of tiles");
            for(var key in this._tiles){
                var c = this._tiles[key].coords;
                if (c.z !== this._tileZoom || !noPruneRange.contains(new Point(c.x, c.y))) this._tiles[key].current = false;
            }
            // _update just loads more tiles. If the tile zoom level differs too much
            // from the map's, let _setView reset levels and prune old tiles.
            if (Math.abs(zoom - this._tileZoom) > 1) {
                this._setView(center, zoom);
                return;
            }
            // create a queue of coordinates to load tiles from
            for(var j = tileRange.min.y; j <= tileRange.max.y; j++)for(var i = tileRange.min.x; i <= tileRange.max.x; i++){
                var coords = new Point(i, j);
                coords.z = this._tileZoom;
                if (!this._isValidTile(coords)) continue;
                var tile = this._tiles[this._tileCoordsToKey(coords)];
                if (tile) tile.current = true;
                else queue.push(coords);
            }
            // sort tile queue to load tiles in order of their distance to center
            queue.sort(function(a, b) {
                return a.distanceTo(tileCenter) - b.distanceTo(tileCenter);
            });
            if (queue.length !== 0) {
                // if it's the first batch of tiles to load
                if (!this._loading) {
                    this._loading = true;
                    // @event loading: Event
                    // Fired when the grid layer starts loading tiles.
                    this.fire("loading");
                }
                // create DOM fragment to append tiles in one batch
                var fragment = document.createDocumentFragment();
                for(i = 0; i < queue.length; i++)this._addTile(queue[i], fragment);
                this._level.el.appendChild(fragment);
            }
        },
        _isValidTile: function(coords) {
            var crs = this._map.options.crs;
            if (!crs.infinite) {
                // don't load tile if it's out of bounds and not wrapped
                var bounds = this._globalTileRange;
                if (!crs.wrapLng && (coords.x < bounds.min.x || coords.x > bounds.max.x) || !crs.wrapLat && (coords.y < bounds.min.y || coords.y > bounds.max.y)) return false;
            }
            if (!this.options.bounds) return true;
            // don't load tile if it doesn't intersect the bounds in options
            var tileBounds = this._tileCoordsToBounds(coords);
            return toLatLngBounds(this.options.bounds).overlaps(tileBounds);
        },
        _keyToBounds: function(key) {
            return this._tileCoordsToBounds(this._keyToTileCoords(key));
        },
        _tileCoordsToNwSe: function(coords) {
            var map = this._map, tileSize = this.getTileSize(), nwPoint = coords.scaleBy(tileSize), sePoint = nwPoint.add(tileSize), nw = map.unproject(nwPoint, coords.z), se = map.unproject(sePoint, coords.z);
            return [
                nw,
                se
            ];
        },
        // converts tile coordinates to its geographical bounds
        _tileCoordsToBounds: function(coords) {
            var bp = this._tileCoordsToNwSe(coords), bounds = new LatLngBounds(bp[0], bp[1]);
            if (!this.options.noWrap) bounds = this._map.wrapLatLngBounds(bounds);
            return bounds;
        },
        // converts tile coordinates to key for the tile cache
        _tileCoordsToKey: function(coords) {
            return coords.x + ":" + coords.y + ":" + coords.z;
        },
        // converts tile cache key to coordinates
        _keyToTileCoords: function(key) {
            var k = key.split(":"), coords = new Point(+k[0], +k[1]);
            coords.z = +k[2];
            return coords;
        },
        _removeTile: function(key) {
            var tile = this._tiles[key];
            if (!tile) return;
            remove(tile.el);
            delete this._tiles[key];
            // @event tileunload: TileEvent
            // Fired when a tile is removed (e.g. when a tile goes off the screen).
            this.fire("tileunload", {
                tile: tile.el,
                coords: this._keyToTileCoords(key)
            });
        },
        _initTile: function(tile) {
            addClass(tile, "leaflet-tile");
            var tileSize = this.getTileSize();
            tile.style.width = tileSize.x + "px";
            tile.style.height = tileSize.y + "px";
            tile.onselectstart = falseFn;
            tile.onmousemove = falseFn;
            // update opacity on tiles in IE7-8 because of filter inheritance problems
            if (Browser.ielt9 && this.options.opacity < 1) setOpacity(tile, this.options.opacity);
        },
        _addTile: function(coords, container) {
            var tilePos = this._getTilePos(coords), key = this._tileCoordsToKey(coords);
            var tile = this.createTile(this._wrapCoords(coords), bind(this._tileReady, this, coords));
            this._initTile(tile);
            // if createTile is defined with a second argument ("done" callback),
            // we know that tile is async and will be ready later; otherwise
            if (this.createTile.length < 2) // mark tile as ready, but delay one frame for opacity animation to happen
            requestAnimFrame(bind(this._tileReady, this, coords, null, tile));
            setPosition(tile, tilePos);
            // save tile in cache
            this._tiles[key] = {
                el: tile,
                coords: coords,
                current: true
            };
            container.appendChild(tile);
            // @event tileloadstart: TileEvent
            // Fired when a tile is requested and starts loading.
            this.fire("tileloadstart", {
                tile: tile,
                coords: coords
            });
        },
        _tileReady: function(coords, err, tile) {
            if (err) // @event tileerror: TileErrorEvent
            // Fired when there is an error loading a tile.
            this.fire("tileerror", {
                error: err,
                tile: tile,
                coords: coords
            });
            var key = this._tileCoordsToKey(coords);
            tile = this._tiles[key];
            if (!tile) return;
            tile.loaded = +new Date();
            if (this._map._fadeAnimated) {
                setOpacity(tile.el, 0);
                cancelAnimFrame(this._fadeFrame);
                this._fadeFrame = requestAnimFrame(this._updateOpacity, this);
            } else {
                tile.active = true;
                this._pruneTiles();
            }
            if (!err) {
                addClass(tile.el, "leaflet-tile-loaded");
                // @event tileload: TileEvent
                // Fired when a tile loads.
                this.fire("tileload", {
                    tile: tile.el,
                    coords: coords
                });
            }
            if (this._noTilesToLoad()) {
                this._loading = false;
                // @event load: Event
                // Fired when the grid layer loaded all visible tiles.
                this.fire("load");
                if (Browser.ielt9 || !this._map._fadeAnimated) requestAnimFrame(this._pruneTiles, this);
                else // Wait a bit more than 0.2 secs (the duration of the tile fade-in)
                // to trigger a pruning.
                setTimeout(bind(this._pruneTiles, this), 250);
            }
        },
        _getTilePos: function(coords) {
            return coords.scaleBy(this.getTileSize()).subtract(this._level.origin);
        },
        _wrapCoords: function(coords) {
            var newCoords = new Point(this._wrapX ? wrapNum(coords.x, this._wrapX) : coords.x, this._wrapY ? wrapNum(coords.y, this._wrapY) : coords.y);
            newCoords.z = coords.z;
            return newCoords;
        },
        _pxBoundsToTileRange: function(bounds) {
            var tileSize = this.getTileSize();
            return new Bounds(bounds.min.unscaleBy(tileSize).floor(), bounds.max.unscaleBy(tileSize).ceil().subtract([
                1,
                1
            ]));
        },
        _noTilesToLoad: function() {
            for(var key in this._tiles){
                if (!this._tiles[key].loaded) return false;
            }
            return true;
        }
    });
    // @factory L.gridLayer(options?: GridLayer options)
    // Creates a new instance of GridLayer with the supplied options.
    function gridLayer(options) {
        return new GridLayer(options);
    }
    /*
   * @class TileLayer
   * @inherits GridLayer
   * @aka L.TileLayer
   * Used to load and display tile layers on the map. Note that most tile servers require attribution, which you can set under `Layer`. Extends `GridLayer`.
   *
   * @example
   *
   * ```js
   * L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png?{foo}', {foo: 'bar', attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'}).addTo(map);
   * ```
   *
   * @section URL template
   * @example
   *
   * A string of the following form:
   *
   * ```
   * 'https://{s}.somedomain.com/blabla/{z}/{x}/{y}{r}.png'
   * ```
   *
   * `{s}` means one of the available subdomains (used sequentially to help with browser parallel requests per domain limitation; subdomain values are specified in options; `a`, `b` or `c` by default, can be omitted), `{z}` — zoom level, `{x}` and `{y}` — tile coordinates. `{r}` can be used to add "&commat;2x" to the URL to load retina tiles.
   *
   * You can use custom keys in the template, which will be [evaluated](#util-template) from TileLayer options, like this:
   *
   * ```
   * L.tileLayer('https://{s}.somedomain.com/{foo}/{z}/{x}/{y}.png', {foo: 'bar'});
   * ```
   */ var TileLayer = GridLayer.extend({
        // @section
        // @aka TileLayer options
        options: {
            // @option minZoom: Number = 0
            // The minimum zoom level down to which this layer will be displayed (inclusive).
            minZoom: 0,
            // @option maxZoom: Number = 18
            // The maximum zoom level up to which this layer will be displayed (inclusive).
            maxZoom: 18,
            // @option subdomains: String|String[] = 'abc'
            // Subdomains of the tile service. Can be passed in the form of one string (where each letter is a subdomain name) or an array of strings.
            subdomains: "abc",
            // @option errorTileUrl: String = ''
            // URL to the tile image to show in place of the tile that failed to load.
            errorTileUrl: "",
            // @option zoomOffset: Number = 0
            // The zoom number used in tile URLs will be offset with this value.
            zoomOffset: 0,
            // @option tms: Boolean = false
            // If `true`, inverses Y axis numbering for tiles (turn this on for [TMS](https://en.wikipedia.org/wiki/Tile_Map_Service) services).
            tms: false,
            // @option zoomReverse: Boolean = false
            // If set to true, the zoom number used in tile URLs will be reversed (`maxZoom - zoom` instead of `zoom`)
            zoomReverse: false,
            // @option detectRetina: Boolean = false
            // If `true` and user is on a retina display, it will request four tiles of half the specified size and a bigger zoom level in place of one to utilize the high resolution.
            detectRetina: false,
            // @option crossOrigin: Boolean|String = false
            // Whether the crossOrigin attribute will be added to the tiles.
            // If a String is provided, all tiles will have their crossOrigin attribute set to the String provided. This is needed if you want to access tile pixel data.
            // Refer to [CORS Settings](https://developer.mozilla.org/en-US/docs/Web/HTML/CORS_settings_attributes) for valid String values.
            crossOrigin: false,
            // @option referrerPolicy: Boolean|String = false
            // Whether the referrerPolicy attribute will be added to the tiles.
            // If a String is provided, all tiles will have their referrerPolicy attribute set to the String provided.
            // This may be needed if your map's rendering context has a strict default but your tile provider expects a valid referrer
            // (e.g. to validate an API token).
            // Refer to [HTMLImageElement.referrerPolicy](https://developer.mozilla.org/en-US/docs/Web/API/HTMLImageElement/referrerPolicy) for valid String values.
            referrerPolicy: false
        },
        initialize: function(url, options) {
            this._url = url;
            options = setOptions(this, options);
            // detecting retina displays, adjusting tileSize and zoom levels
            if (options.detectRetina && Browser.retina && options.maxZoom > 0) {
                options.tileSize = Math.floor(options.tileSize / 2);
                if (!options.zoomReverse) {
                    options.zoomOffset++;
                    options.maxZoom = Math.max(options.minZoom, options.maxZoom - 1);
                } else {
                    options.zoomOffset--;
                    options.minZoom = Math.min(options.maxZoom, options.minZoom + 1);
                }
                options.minZoom = Math.max(0, options.minZoom);
            } else if (!options.zoomReverse) // make sure maxZoom is gte minZoom
            options.maxZoom = Math.max(options.minZoom, options.maxZoom);
            else // make sure minZoom is lte maxZoom
            options.minZoom = Math.min(options.maxZoom, options.minZoom);
            if (typeof options.subdomains === "string") options.subdomains = options.subdomains.split("");
            this.on("tileunload", this._onTileRemove);
        },
        // @method setUrl(url: String, noRedraw?: Boolean): this
        // Updates the layer's URL template and redraws it (unless `noRedraw` is set to `true`).
        // If the URL does not change, the layer will not be redrawn unless
        // the noRedraw parameter is set to false.
        setUrl: function(url, noRedraw) {
            if (this._url === url && noRedraw === undefined) noRedraw = true;
            this._url = url;
            if (!noRedraw) this.redraw();
            return this;
        },
        // @method createTile(coords: Object, done?: Function): HTMLElement
        // Called only internally, overrides GridLayer's [`createTile()`](#gridlayer-createtile)
        // to return an `<img>` HTML element with the appropriate image URL given `coords`. The `done`
        // callback is called when the tile has been loaded.
        createTile: function(coords, done) {
            var tile = document.createElement("img");
            on(tile, "load", bind(this._tileOnLoad, this, done, tile));
            on(tile, "error", bind(this._tileOnError, this, done, tile));
            if (this.options.crossOrigin || this.options.crossOrigin === "") tile.crossOrigin = this.options.crossOrigin === true ? "" : this.options.crossOrigin;
            // for this new option we follow the documented behavior
            // more closely by only setting the property when string
            if (typeof this.options.referrerPolicy === "string") tile.referrerPolicy = this.options.referrerPolicy;
            // The alt attribute is set to the empty string,
            // allowing screen readers to ignore the decorative image tiles.
            // https://www.w3.org/WAI/tutorials/images/decorative/
            // https://www.w3.org/TR/html-aria/#el-img-empty-alt
            tile.alt = "";
            tile.src = this.getTileUrl(coords);
            return tile;
        },
        // @section Extension methods
        // @uninheritable
        // Layers extending `TileLayer` might reimplement the following method.
        // @method getTileUrl(coords: Object): String
        // Called only internally, returns the URL for a tile given its coordinates.
        // Classes extending `TileLayer` can override this function to provide custom tile URL naming schemes.
        getTileUrl: function(coords) {
            var data = {
                r: Browser.retina ? "@2x" : "",
                s: this._getSubdomain(coords),
                x: coords.x,
                y: coords.y,
                z: this._getZoomForUrl()
            };
            if (this._map && !this._map.options.crs.infinite) {
                var invertedY = this._globalTileRange.max.y - coords.y;
                if (this.options.tms) data["y"] = invertedY;
                data["-y"] = invertedY;
            }
            return template(this._url, extend(data, this.options));
        },
        _tileOnLoad: function(done, tile) {
            // For https://github.com/Leaflet/Leaflet/issues/3332
            if (Browser.ielt9) setTimeout(bind(done, this, null, tile), 0);
            else done(null, tile);
        },
        _tileOnError: function(done, tile, e) {
            var errorUrl = this.options.errorTileUrl;
            if (errorUrl && tile.getAttribute("src") !== errorUrl) tile.src = errorUrl;
            done(e, tile);
        },
        _onTileRemove: function(e) {
            e.tile.onload = null;
        },
        _getZoomForUrl: function() {
            var zoom = this._tileZoom, maxZoom = this.options.maxZoom, zoomReverse = this.options.zoomReverse, zoomOffset = this.options.zoomOffset;
            if (zoomReverse) zoom = maxZoom - zoom;
            return zoom + zoomOffset;
        },
        _getSubdomain: function(tilePoint) {
            var index = Math.abs(tilePoint.x + tilePoint.y) % this.options.subdomains.length;
            return this.options.subdomains[index];
        },
        // stops loading all tiles in the background layer
        _abortLoading: function() {
            var i, tile;
            for(i in this._tiles)if (this._tiles[i].coords.z !== this._tileZoom) {
                tile = this._tiles[i].el;
                tile.onload = falseFn;
                tile.onerror = falseFn;
                if (!tile.complete) {
                    tile.src = emptyImageUrl;
                    var coords = this._tiles[i].coords;
                    remove(tile);
                    delete this._tiles[i];
                    // @event tileabort: TileEvent
                    // Fired when a tile was loading but is now not wanted.
                    this.fire("tileabort", {
                        tile: tile,
                        coords: coords
                    });
                }
            }
        },
        _removeTile: function(key) {
            var tile = this._tiles[key];
            if (!tile) return;
            // Cancels any pending http requests associated with the tile
            tile.el.setAttribute("src", emptyImageUrl);
            return GridLayer.prototype._removeTile.call(this, key);
        },
        _tileReady: function(coords, err, tile) {
            if (!this._map || tile && tile.getAttribute("src") === emptyImageUrl) return;
            return GridLayer.prototype._tileReady.call(this, coords, err, tile);
        }
    });
    // @factory L.tilelayer(urlTemplate: String, options?: TileLayer options)
    // Instantiates a tile layer object given a `URL template` and optionally an options object.
    function tileLayer(url, options) {
        return new TileLayer(url, options);
    }
    /*
   * @class TileLayer.WMS
   * @inherits TileLayer
   * @aka L.TileLayer.WMS
   * Used to display [WMS](https://en.wikipedia.org/wiki/Web_Map_Service) services as tile layers on the map. Extends `TileLayer`.
   *
   * @example
   *
   * ```js
   * var nexrad = L.tileLayer.wms("http://mesonet.agron.iastate.edu/cgi-bin/wms/nexrad/n0r.cgi", {
   * 	layers: 'nexrad-n0r-900913',
   * 	format: 'image/png',
   * 	transparent: true,
   * 	attribution: "Weather data © 2012 IEM Nexrad"
   * });
   * ```
   */ var TileLayerWMS = TileLayer.extend({
        // @section
        // @aka TileLayer.WMS options
        // If any custom options not documented here are used, they will be sent to the
        // WMS server as extra parameters in each request URL. This can be useful for
        // [non-standard vendor WMS parameters](https://docs.geoserver.org/stable/en/user/services/wms/vendor.html).
        defaultWmsParams: {
            service: "WMS",
            request: "GetMap",
            // @option layers: String = ''
            // **(required)** Comma-separated list of WMS layers to show.
            layers: "",
            // @option styles: String = ''
            // Comma-separated list of WMS styles.
            styles: "",
            // @option format: String = 'image/jpeg'
            // WMS image format (use `'image/png'` for layers with transparency).
            format: "image/jpeg",
            // @option transparent: Boolean = false
            // If `true`, the WMS service will return images with transparency.
            transparent: false,
            // @option version: String = '1.1.1'
            // Version of the WMS service to use
            version: "1.1.1"
        },
        options: {
            // @option crs: CRS = null
            // Coordinate Reference System to use for the WMS requests, defaults to
            // map CRS. Don't change this if you're not sure what it means.
            crs: null,
            // @option uppercase: Boolean = false
            // If `true`, WMS request parameter keys will be uppercase.
            uppercase: false
        },
        initialize: function(url, options) {
            this._url = url;
            var wmsParams = extend({}, this.defaultWmsParams);
            // all keys that are not TileLayer options go to WMS params
            for(var i in options)if (!(i in this.options)) wmsParams[i] = options[i];
            options = setOptions(this, options);
            var realRetina = options.detectRetina && Browser.retina ? 2 : 1;
            var tileSize = this.getTileSize();
            wmsParams.width = tileSize.x * realRetina;
            wmsParams.height = tileSize.y * realRetina;
            this.wmsParams = wmsParams;
        },
        onAdd: function(map) {
            this._crs = this.options.crs || map.options.crs;
            this._wmsVersion = parseFloat(this.wmsParams.version);
            var projectionKey = this._wmsVersion >= 1.3 ? "crs" : "srs";
            this.wmsParams[projectionKey] = this._crs.code;
            TileLayer.prototype.onAdd.call(this, map);
        },
        getTileUrl: function(coords) {
            var tileBounds = this._tileCoordsToNwSe(coords), crs = this._crs, bounds = toBounds(crs.project(tileBounds[0]), crs.project(tileBounds[1])), min = bounds.min, max = bounds.max, bbox = (this._wmsVersion >= 1.3 && this._crs === EPSG4326 ? [
                min.y,
                min.x,
                max.y,
                max.x
            ] : [
                min.x,
                min.y,
                max.x,
                max.y
            ]).join(","), url = TileLayer.prototype.getTileUrl.call(this, coords);
            return url + getParamString(this.wmsParams, url, this.options.uppercase) + (this.options.uppercase ? "&BBOX=" : "&bbox=") + bbox;
        },
        // @method setParams(params: Object, noRedraw?: Boolean): this
        // Merges an object with the new parameters and re-requests tiles on the current screen (unless `noRedraw` was set to true).
        setParams: function(params, noRedraw) {
            extend(this.wmsParams, params);
            if (!noRedraw) this.redraw();
            return this;
        }
    });
    // @factory L.tileLayer.wms(baseUrl: String, options: TileLayer.WMS options)
    // Instantiates a WMS tile layer object given a base URL of the WMS service and a WMS parameters/options object.
    function tileLayerWMS(url, options) {
        return new TileLayerWMS(url, options);
    }
    TileLayer.WMS = TileLayerWMS;
    tileLayer.wms = tileLayerWMS;
    /*
   * @class Renderer
   * @inherits Layer
   * @aka L.Renderer
   *
   * Base class for vector renderer implementations (`SVG`, `Canvas`). Handles the
   * DOM container of the renderer, its bounds, and its zoom animation.
   *
   * A `Renderer` works as an implicit layer group for all `Path`s - the renderer
   * itself can be added or removed to the map. All paths use a renderer, which can
   * be implicit (the map will decide the type of renderer and use it automatically)
   * or explicit (using the [`renderer`](#path-renderer) option of the path).
   *
   * Do not use this class directly, use `SVG` and `Canvas` instead.
   *
   * @event update: Event
   * Fired when the renderer updates its bounds, center and zoom, for example when
   * its map has moved
   */ var Renderer = Layer.extend({
        // @section
        // @aka Renderer options
        options: {
            // @option padding: Number = 0.1
            // How much to extend the clip area around the map view (relative to its size)
            // e.g. 0.1 would be 10% of map view in each direction
            padding: 0.1
        },
        initialize: function(options) {
            setOptions(this, options);
            stamp(this);
            this._layers = this._layers || {};
        },
        onAdd: function() {
            if (!this._container) {
                this._initContainer(); // defined by renderer implementations
                // always keep transform-origin as 0 0
                addClass(this._container, "leaflet-zoom-animated");
            }
            this.getPane().appendChild(this._container);
            this._update();
            this.on("update", this._updatePaths, this);
        },
        onRemove: function() {
            this.off("update", this._updatePaths, this);
            this._destroyContainer();
        },
        getEvents: function() {
            var events = {
                viewreset: this._reset,
                zoom: this._onZoom,
                moveend: this._update,
                zoomend: this._onZoomEnd
            };
            if (this._zoomAnimated) events.zoomanim = this._onAnimZoom;
            return events;
        },
        _onAnimZoom: function(ev) {
            this._updateTransform(ev.center, ev.zoom);
        },
        _onZoom: function() {
            this._updateTransform(this._map.getCenter(), this._map.getZoom());
        },
        _updateTransform: function(center, zoom) {
            var scale = this._map.getZoomScale(zoom, this._zoom), viewHalf = this._map.getSize().multiplyBy(0.5 + this.options.padding), currentCenterPoint = this._map.project(this._center, zoom), topLeftOffset = viewHalf.multiplyBy(-scale).add(currentCenterPoint).subtract(this._map._getNewPixelOrigin(center, zoom));
            if (Browser.any3d) setTransform(this._container, topLeftOffset, scale);
            else setPosition(this._container, topLeftOffset);
        },
        _reset: function() {
            this._update();
            this._updateTransform(this._center, this._zoom);
            for(var id in this._layers)this._layers[id]._reset();
        },
        _onZoomEnd: function() {
            for(var id in this._layers)this._layers[id]._project();
        },
        _updatePaths: function() {
            for(var id in this._layers)this._layers[id]._update();
        },
        _update: function() {
            // Update pixel bounds of renderer container (for positioning/sizing/clipping later)
            // Subclasses are responsible of firing the 'update' event.
            var p = this.options.padding, size = this._map.getSize(), min = this._map.containerPointToLayerPoint(size.multiplyBy(-p)).round();
            this._bounds = new Bounds(min, min.add(size.multiplyBy(1 + p * 2)).round());
            this._center = this._map.getCenter();
            this._zoom = this._map.getZoom();
        }
    });
    /*
   * @class Canvas
   * @inherits Renderer
   * @aka L.Canvas
   *
   * Allows vector layers to be displayed with [`<canvas>`](https://developer.mozilla.org/docs/Web/API/Canvas_API).
   * Inherits `Renderer`.
   *
   * Due to [technical limitations](https://caniuse.com/canvas), Canvas is not
   * available in all web browsers, notably IE8, and overlapping geometries might
   * not display properly in some edge cases.
   *
   * @example
   *
   * Use Canvas by default for all paths in the map:
   *
   * ```js
   * var map = L.map('map', {
   * 	renderer: L.canvas()
   * });
   * ```
   *
   * Use a Canvas renderer with extra padding for specific vector geometries:
   *
   * ```js
   * var map = L.map('map');
   * var myRenderer = L.canvas({ padding: 0.5 });
   * var line = L.polyline( coordinates, { renderer: myRenderer } );
   * var circle = L.circle( center, { renderer: myRenderer } );
   * ```
   */ var Canvas = Renderer.extend({
        // @section
        // @aka Canvas options
        options: {
            // @option tolerance: Number = 0
            // How much to extend the click tolerance around a path/object on the map.
            tolerance: 0
        },
        getEvents: function() {
            var events = Renderer.prototype.getEvents.call(this);
            events.viewprereset = this._onViewPreReset;
            return events;
        },
        _onViewPreReset: function() {
            // Set a flag so that a viewprereset+moveend+viewreset only updates&redraws once
            this._postponeUpdatePaths = true;
        },
        onAdd: function() {
            Renderer.prototype.onAdd.call(this);
            // Redraw vectors since canvas is cleared upon removal,
            // in case of removing the renderer itself from the map.
            this._draw();
        },
        _initContainer: function() {
            var container = this._container = document.createElement("canvas");
            on(container, "mousemove", this._onMouseMove, this);
            on(container, "click dblclick mousedown mouseup contextmenu", this._onClick, this);
            on(container, "mouseout", this._handleMouseOut, this);
            container["_leaflet_disable_events"] = true;
            this._ctx = container.getContext("2d");
        },
        _destroyContainer: function() {
            cancelAnimFrame(this._redrawRequest);
            delete this._ctx;
            remove(this._container);
            off(this._container);
            delete this._container;
        },
        _updatePaths: function() {
            if (this._postponeUpdatePaths) return;
            var layer;
            this._redrawBounds = null;
            for(var id in this._layers){
                layer = this._layers[id];
                layer._update();
            }
            this._redraw();
        },
        _update: function() {
            if (this._map._animatingZoom && this._bounds) return;
            Renderer.prototype._update.call(this);
            var b = this._bounds, container = this._container, size = b.getSize(), m = Browser.retina ? 2 : 1;
            setPosition(container, b.min);
            // set canvas size (also clearing it); use double size on retina
            container.width = m * size.x;
            container.height = m * size.y;
            container.style.width = size.x + "px";
            container.style.height = size.y + "px";
            if (Browser.retina) this._ctx.scale(2, 2);
            // translate so we use the same path coordinates after canvas element moves
            this._ctx.translate(-b.min.x, -b.min.y);
            // Tell paths to redraw themselves
            this.fire("update");
        },
        _reset: function() {
            Renderer.prototype._reset.call(this);
            if (this._postponeUpdatePaths) {
                this._postponeUpdatePaths = false;
                this._updatePaths();
            }
        },
        _initPath: function(layer) {
            this._updateDashArray(layer);
            this._layers[stamp(layer)] = layer;
            var order = layer._order = {
                layer: layer,
                prev: this._drawLast,
                next: null
            };
            if (this._drawLast) this._drawLast.next = order;
            this._drawLast = order;
            this._drawFirst = this._drawFirst || this._drawLast;
        },
        _addPath: function(layer) {
            this._requestRedraw(layer);
        },
        _removePath: function(layer) {
            var order = layer._order;
            var next = order.next;
            var prev = order.prev;
            if (next) next.prev = prev;
            else this._drawLast = prev;
            if (prev) prev.next = next;
            else this._drawFirst = next;
            delete layer._order;
            delete this._layers[stamp(layer)];
            this._requestRedraw(layer);
        },
        _updatePath: function(layer) {
            // Redraw the union of the layer's old pixel
            // bounds and the new pixel bounds.
            this._extendRedrawBounds(layer);
            layer._project();
            layer._update();
            // The redraw will extend the redraw bounds
            // with the new pixel bounds.
            this._requestRedraw(layer);
        },
        _updateStyle: function(layer) {
            this._updateDashArray(layer);
            this._requestRedraw(layer);
        },
        _updateDashArray: function(layer) {
            if (typeof layer.options.dashArray === "string") {
                var parts = layer.options.dashArray.split(/[, ]+/), dashArray = [], dashValue, i;
                for(i = 0; i < parts.length; i++){
                    dashValue = Number(parts[i]);
                    // Ignore dash array containing invalid lengths
                    if (isNaN(dashValue)) return;
                    dashArray.push(dashValue);
                }
                layer.options._dashArray = dashArray;
            } else layer.options._dashArray = layer.options.dashArray;
        },
        _requestRedraw: function(layer) {
            if (!this._map) return;
            this._extendRedrawBounds(layer);
            this._redrawRequest = this._redrawRequest || requestAnimFrame(this._redraw, this);
        },
        _extendRedrawBounds: function(layer) {
            if (layer._pxBounds) {
                var padding = (layer.options.weight || 0) + 1;
                this._redrawBounds = this._redrawBounds || new Bounds();
                this._redrawBounds.extend(layer._pxBounds.min.subtract([
                    padding,
                    padding
                ]));
                this._redrawBounds.extend(layer._pxBounds.max.add([
                    padding,
                    padding
                ]));
            }
        },
        _redraw: function() {
            this._redrawRequest = null;
            if (this._redrawBounds) {
                this._redrawBounds.min._floor();
                this._redrawBounds.max._ceil();
            }
            this._clear(); // clear layers in redraw bounds
            this._draw(); // draw layers
            this._redrawBounds = null;
        },
        _clear: function() {
            var bounds = this._redrawBounds;
            if (bounds) {
                var size = bounds.getSize();
                this._ctx.clearRect(bounds.min.x, bounds.min.y, size.x, size.y);
            } else {
                this._ctx.save();
                this._ctx.setTransform(1, 0, 0, 1, 0, 0);
                this._ctx.clearRect(0, 0, this._container.width, this._container.height);
                this._ctx.restore();
            }
        },
        _draw: function() {
            var layer, bounds = this._redrawBounds;
            this._ctx.save();
            if (bounds) {
                var size = bounds.getSize();
                this._ctx.beginPath();
                this._ctx.rect(bounds.min.x, bounds.min.y, size.x, size.y);
                this._ctx.clip();
            }
            this._drawing = true;
            for(var order = this._drawFirst; order; order = order.next){
                layer = order.layer;
                if (!bounds || layer._pxBounds && layer._pxBounds.intersects(bounds)) layer._updatePath();
            }
            this._drawing = false;
            this._ctx.restore(); // Restore state before clipping.
        },
        _updatePoly: function(layer, closed) {
            if (!this._drawing) return;
            var i, j, len2, p, parts = layer._parts, len = parts.length, ctx = this._ctx;
            if (!len) return;
            ctx.beginPath();
            for(i = 0; i < len; i++){
                for(j = 0, len2 = parts[i].length; j < len2; j++){
                    p = parts[i][j];
                    ctx[j ? "lineTo" : "moveTo"](p.x, p.y);
                }
                if (closed) ctx.closePath();
            }
            this._fillStroke(ctx, layer);
        // TODO optimization: 1 fill/stroke for all features with equal style instead of 1 for each feature
        },
        _updateCircle: function(layer) {
            if (!this._drawing || layer._empty()) return;
            var p = layer._point, ctx = this._ctx, r = Math.max(Math.round(layer._radius), 1), s = (Math.max(Math.round(layer._radiusY), 1) || r) / r;
            if (s !== 1) {
                ctx.save();
                ctx.scale(1, s);
            }
            ctx.beginPath();
            ctx.arc(p.x, p.y / s, r, 0, Math.PI * 2, false);
            if (s !== 1) ctx.restore();
            this._fillStroke(ctx, layer);
        },
        _fillStroke: function(ctx, layer) {
            var options = layer.options;
            if (options.fill) {
                ctx.globalAlpha = options.fillOpacity;
                ctx.fillStyle = options.fillColor || options.color;
                ctx.fill(options.fillRule || "evenodd");
            }
            if (options.stroke && options.weight !== 0) {
                if (ctx.setLineDash) ctx.setLineDash(layer.options && layer.options._dashArray || []);
                ctx.globalAlpha = options.opacity;
                ctx.lineWidth = options.weight;
                ctx.strokeStyle = options.color;
                ctx.lineCap = options.lineCap;
                ctx.lineJoin = options.lineJoin;
                ctx.stroke();
            }
        },
        // Canvas obviously doesn't have mouse events for individual drawn objects,
        // so we emulate that by calculating what's under the mouse on mousemove/click manually
        _onClick: function(e) {
            var point = this._map.mouseEventToLayerPoint(e), layer, clickedLayer;
            for(var order = this._drawFirst; order; order = order.next){
                layer = order.layer;
                if (layer.options.interactive && layer._containsPoint(point)) {
                    if (!(e.type === "click" || e.type === "preclick") || !this._map._draggableMoved(layer)) clickedLayer = layer;
                }
            }
            this._fireEvent(clickedLayer ? [
                clickedLayer
            ] : false, e);
        },
        _onMouseMove: function(e) {
            if (!this._map || this._map.dragging.moving() || this._map._animatingZoom) return;
            var point = this._map.mouseEventToLayerPoint(e);
            this._handleMouseHover(e, point);
        },
        _handleMouseOut: function(e) {
            var layer = this._hoveredLayer;
            if (layer) {
                // if we're leaving the layer, fire mouseout
                removeClass(this._container, "leaflet-interactive");
                this._fireEvent([
                    layer
                ], e, "mouseout");
                this._hoveredLayer = null;
                this._mouseHoverThrottled = false;
            }
        },
        _handleMouseHover: function(e, point) {
            if (this._mouseHoverThrottled) return;
            var layer, candidateHoveredLayer;
            for(var order = this._drawFirst; order; order = order.next){
                layer = order.layer;
                if (layer.options.interactive && layer._containsPoint(point)) candidateHoveredLayer = layer;
            }
            if (candidateHoveredLayer !== this._hoveredLayer) {
                this._handleMouseOut(e);
                if (candidateHoveredLayer) {
                    addClass(this._container, "leaflet-interactive"); // change cursor
                    this._fireEvent([
                        candidateHoveredLayer
                    ], e, "mouseover");
                    this._hoveredLayer = candidateHoveredLayer;
                }
            }
            this._fireEvent(this._hoveredLayer ? [
                this._hoveredLayer
            ] : false, e);
            this._mouseHoverThrottled = true;
            setTimeout(bind(function() {
                this._mouseHoverThrottled = false;
            }, this), 32);
        },
        _fireEvent: function(layers, e, type) {
            this._map._fireDOMEvent(e, type || e.type, layers);
        },
        _bringToFront: function(layer) {
            var order = layer._order;
            if (!order) return;
            var next = order.next;
            var prev = order.prev;
            if (next) next.prev = prev;
            else // Already last
            return;
            if (prev) prev.next = next;
            else if (next) // Update first entry unless this is the
            // single entry
            this._drawFirst = next;
            order.prev = this._drawLast;
            this._drawLast.next = order;
            order.next = null;
            this._drawLast = order;
            this._requestRedraw(layer);
        },
        _bringToBack: function(layer) {
            var order = layer._order;
            if (!order) return;
            var next = order.next;
            var prev = order.prev;
            if (prev) prev.next = next;
            else // Already first
            return;
            if (next) next.prev = prev;
            else if (prev) // Update last entry unless this is the
            // single entry
            this._drawLast = prev;
            order.prev = null;
            order.next = this._drawFirst;
            this._drawFirst.prev = order;
            this._drawFirst = order;
            this._requestRedraw(layer);
        }
    });
    // @factory L.canvas(options?: Renderer options)
    // Creates a Canvas renderer with the given options.
    function canvas(options) {
        return Browser.canvas ? new Canvas(options) : null;
    }
    /*
   * Thanks to Dmitry Baranovsky and his Raphael library for inspiration!
   */ var vmlCreate = function() {
        try {
            document.namespaces.add("lvml", "urn:schemas-microsoft-com:vml");
            return function(name) {
                return document.createElement("<lvml:" + name + ' class="lvml">');
            };
        } catch (e) {
        // Do not return fn from catch block so `e` can be garbage collected
        // See https://github.com/Leaflet/Leaflet/pull/7279
        }
        return function(name) {
            return document.createElement("<" + name + ' xmlns="urn:schemas-microsoft.com:vml" class="lvml">');
        };
    }();
    /*
   * @class SVG
   *
   *
   * VML was deprecated in 2012, which means VML functionality exists only for backwards compatibility
   * with old versions of Internet Explorer.
   */ // mixin to redefine some SVG methods to handle VML syntax which is similar but with some differences
    var vmlMixin = {
        _initContainer: function() {
            this._container = create$1("div", "leaflet-vml-container");
        },
        _update: function() {
            if (this._map._animatingZoom) return;
            Renderer.prototype._update.call(this);
            this.fire("update");
        },
        _initPath: function(layer) {
            var container = layer._container = vmlCreate("shape");
            addClass(container, "leaflet-vml-shape " + (this.options.className || ""));
            container.coordsize = "1 1";
            layer._path = vmlCreate("path");
            container.appendChild(layer._path);
            this._updateStyle(layer);
            this._layers[stamp(layer)] = layer;
        },
        _addPath: function(layer) {
            var container = layer._container;
            this._container.appendChild(container);
            if (layer.options.interactive) layer.addInteractiveTarget(container);
        },
        _removePath: function(layer) {
            var container = layer._container;
            remove(container);
            layer.removeInteractiveTarget(container);
            delete this._layers[stamp(layer)];
        },
        _updateStyle: function(layer) {
            var stroke = layer._stroke, fill = layer._fill, options = layer.options, container = layer._container;
            container.stroked = !!options.stroke;
            container.filled = !!options.fill;
            if (options.stroke) {
                if (!stroke) stroke = layer._stroke = vmlCreate("stroke");
                container.appendChild(stroke);
                stroke.weight = options.weight + "px";
                stroke.color = options.color;
                stroke.opacity = options.opacity;
                if (options.dashArray) stroke.dashStyle = isArray(options.dashArray) ? options.dashArray.join(" ") : options.dashArray.replace(/( *, *)/g, " ");
                else stroke.dashStyle = "";
                stroke.endcap = options.lineCap.replace("butt", "flat");
                stroke.joinstyle = options.lineJoin;
            } else if (stroke) {
                container.removeChild(stroke);
                layer._stroke = null;
            }
            if (options.fill) {
                if (!fill) fill = layer._fill = vmlCreate("fill");
                container.appendChild(fill);
                fill.color = options.fillColor || options.color;
                fill.opacity = options.fillOpacity;
            } else if (fill) {
                container.removeChild(fill);
                layer._fill = null;
            }
        },
        _updateCircle: function(layer) {
            var p = layer._point.round(), r = Math.round(layer._radius), r2 = Math.round(layer._radiusY || r);
            this._setPath(layer, layer._empty() ? "M0 0" : "AL " + p.x + "," + p.y + " " + r + "," + r2 + " 0," + 23592600);
        },
        _setPath: function(layer, path) {
            layer._path.v = path;
        },
        _bringToFront: function(layer) {
            toFront(layer._container);
        },
        _bringToBack: function(layer) {
            toBack(layer._container);
        }
    };
    var create = Browser.vml ? vmlCreate : svgCreate;
    /*
   * @class SVG
   * @inherits Renderer
   * @aka L.SVG
   *
   * Allows vector layers to be displayed with [SVG](https://developer.mozilla.org/docs/Web/SVG).
   * Inherits `Renderer`.
   *
   * Due to [technical limitations](https://caniuse.com/svg), SVG is not
   * available in all web browsers, notably Android 2.x and 3.x.
   *
   * Although SVG is not available on IE7 and IE8, these browsers support
   * [VML](https://en.wikipedia.org/wiki/Vector_Markup_Language)
   * (a now deprecated technology), and the SVG renderer will fall back to VML in
   * this case.
   *
   * @example
   *
   * Use SVG by default for all paths in the map:
   *
   * ```js
   * var map = L.map('map', {
   * 	renderer: L.svg()
   * });
   * ```
   *
   * Use a SVG renderer with extra padding for specific vector geometries:
   *
   * ```js
   * var map = L.map('map');
   * var myRenderer = L.svg({ padding: 0.5 });
   * var line = L.polyline( coordinates, { renderer: myRenderer } );
   * var circle = L.circle( center, { renderer: myRenderer } );
   * ```
   */ var SVG = Renderer.extend({
        _initContainer: function() {
            this._container = create("svg");
            // makes it possible to click through svg root; we'll reset it back in individual paths
            this._container.setAttribute("pointer-events", "none");
            this._rootGroup = create("g");
            this._container.appendChild(this._rootGroup);
        },
        _destroyContainer: function() {
            remove(this._container);
            off(this._container);
            delete this._container;
            delete this._rootGroup;
            delete this._svgSize;
        },
        _update: function() {
            if (this._map._animatingZoom && this._bounds) return;
            Renderer.prototype._update.call(this);
            var b = this._bounds, size = b.getSize(), container = this._container;
            // set size of svg-container if changed
            if (!this._svgSize || !this._svgSize.equals(size)) {
                this._svgSize = size;
                container.setAttribute("width", size.x);
                container.setAttribute("height", size.y);
            }
            // movement: update container viewBox so that we don't have to change coordinates of individual layers
            setPosition(container, b.min);
            container.setAttribute("viewBox", [
                b.min.x,
                b.min.y,
                size.x,
                size.y
            ].join(" "));
            this.fire("update");
        },
        // methods below are called by vector layers implementations
        _initPath: function(layer) {
            var path = layer._path = create("path");
            // @namespace Path
            // @option className: String = null
            // Custom class name set on an element. Only for SVG renderer.
            if (layer.options.className) addClass(path, layer.options.className);
            if (layer.options.interactive) addClass(path, "leaflet-interactive");
            this._updateStyle(layer);
            this._layers[stamp(layer)] = layer;
        },
        _addPath: function(layer) {
            if (!this._rootGroup) this._initContainer();
            this._rootGroup.appendChild(layer._path);
            layer.addInteractiveTarget(layer._path);
        },
        _removePath: function(layer) {
            remove(layer._path);
            layer.removeInteractiveTarget(layer._path);
            delete this._layers[stamp(layer)];
        },
        _updatePath: function(layer) {
            layer._project();
            layer._update();
        },
        _updateStyle: function(layer) {
            var path = layer._path, options = layer.options;
            if (!path) return;
            if (options.stroke) {
                path.setAttribute("stroke", options.color);
                path.setAttribute("stroke-opacity", options.opacity);
                path.setAttribute("stroke-width", options.weight);
                path.setAttribute("stroke-linecap", options.lineCap);
                path.setAttribute("stroke-linejoin", options.lineJoin);
                if (options.dashArray) path.setAttribute("stroke-dasharray", options.dashArray);
                else path.removeAttribute("stroke-dasharray");
                if (options.dashOffset) path.setAttribute("stroke-dashoffset", options.dashOffset);
                else path.removeAttribute("stroke-dashoffset");
            } else path.setAttribute("stroke", "none");
            if (options.fill) {
                path.setAttribute("fill", options.fillColor || options.color);
                path.setAttribute("fill-opacity", options.fillOpacity);
                path.setAttribute("fill-rule", options.fillRule || "evenodd");
            } else path.setAttribute("fill", "none");
        },
        _updatePoly: function(layer, closed) {
            this._setPath(layer, pointsToPath(layer._parts, closed));
        },
        _updateCircle: function(layer) {
            var p = layer._point, r = Math.max(Math.round(layer._radius), 1), r2 = Math.max(Math.round(layer._radiusY), 1) || r, arc = "a" + r + "," + r2 + " 0 1,0 ";
            // drawing a circle with two half-arcs
            var d = layer._empty() ? "M0 0" : "M" + (p.x - r) + "," + p.y + arc + r * 2 + ",0 " + arc + -r * 2 + ",0 ";
            this._setPath(layer, d);
        },
        _setPath: function(layer, path) {
            layer._path.setAttribute("d", path);
        },
        // SVG does not have the concept of zIndex so we resort to changing the DOM order of elements
        _bringToFront: function(layer) {
            toFront(layer._path);
        },
        _bringToBack: function(layer) {
            toBack(layer._path);
        }
    });
    if (Browser.vml) SVG.include(vmlMixin);
    // @namespace SVG
    // @factory L.svg(options?: Renderer options)
    // Creates a SVG renderer with the given options.
    function svg(options) {
        return Browser.svg || Browser.vml ? new SVG(options) : null;
    }
    Map.include({
        // @namespace Map; @method getRenderer(layer: Path): Renderer
        // Returns the instance of `Renderer` that should be used to render the given
        // `Path`. It will ensure that the `renderer` options of the map and paths
        // are respected, and that the renderers do exist on the map.
        getRenderer: function(layer) {
            // @namespace Path; @option renderer: Renderer
            // Use this specific instance of `Renderer` for this path. Takes
            // precedence over the map's [default renderer](#map-renderer).
            var renderer = layer.options.renderer || this._getPaneRenderer(layer.options.pane) || this.options.renderer || this._renderer;
            if (!renderer) renderer = this._renderer = this._createRenderer();
            if (!this.hasLayer(renderer)) this.addLayer(renderer);
            return renderer;
        },
        _getPaneRenderer: function(name) {
            if (name === "overlayPane" || name === undefined) return false;
            var renderer = this._paneRenderers[name];
            if (renderer === undefined) {
                renderer = this._createRenderer({
                    pane: name
                });
                this._paneRenderers[name] = renderer;
            }
            return renderer;
        },
        _createRenderer: function(options) {
            // @namespace Map; @option preferCanvas: Boolean = false
            // Whether `Path`s should be rendered on a `Canvas` renderer.
            // By default, all `Path`s are rendered in a `SVG` renderer.
            return this.options.preferCanvas && canvas(options) || svg(options);
        }
    });
    /*
   * L.Rectangle extends Polygon and creates a rectangle when passed a LatLngBounds object.
   */ /*
   * @class Rectangle
   * @aka L.Rectangle
   * @inherits Polygon
   *
   * A class for drawing rectangle overlays on a map. Extends `Polygon`.
   *
   * @example
   *
   * ```js
   * // define rectangle geographical bounds
   * var bounds = [[54.559322, -5.767822], [56.1210604, -3.021240]];
   *
   * // create an orange rectangle
   * L.rectangle(bounds, {color: "#ff7800", weight: 1}).addTo(map);
   *
   * // zoom the map to the rectangle bounds
   * map.fitBounds(bounds);
   * ```
   *
   */ var Rectangle = Polygon.extend({
        initialize: function(latLngBounds, options) {
            Polygon.prototype.initialize.call(this, this._boundsToLatLngs(latLngBounds), options);
        },
        // @method setBounds(latLngBounds: LatLngBounds): this
        // Redraws the rectangle with the passed bounds.
        setBounds: function(latLngBounds) {
            return this.setLatLngs(this._boundsToLatLngs(latLngBounds));
        },
        _boundsToLatLngs: function(latLngBounds) {
            latLngBounds = toLatLngBounds(latLngBounds);
            return [
                latLngBounds.getSouthWest(),
                latLngBounds.getNorthWest(),
                latLngBounds.getNorthEast(),
                latLngBounds.getSouthEast()
            ];
        }
    });
    // @factory L.rectangle(latLngBounds: LatLngBounds, options?: Polyline options)
    function rectangle(latLngBounds, options) {
        return new Rectangle(latLngBounds, options);
    }
    SVG.create = create;
    SVG.pointsToPath = pointsToPath;
    GeoJSON.geometryToLayer = geometryToLayer;
    GeoJSON.coordsToLatLng = coordsToLatLng;
    GeoJSON.coordsToLatLngs = coordsToLatLngs;
    GeoJSON.latLngToCoords = latLngToCoords;
    GeoJSON.latLngsToCoords = latLngsToCoords;
    GeoJSON.getFeature = getFeature;
    GeoJSON.asFeature = asFeature;
    /*
   * L.Handler.BoxZoom is used to add shift-drag zoom interaction to the map
   * (zoom to a selected bounding box), enabled by default.
   */ // @namespace Map
    // @section Interaction Options
    Map.mergeOptions({
        // @option boxZoom: Boolean = true
        // Whether the map can be zoomed to a rectangular area specified by
        // dragging the mouse while pressing the shift key.
        boxZoom: true
    });
    var BoxZoom = Handler.extend({
        initialize: function(map) {
            this._map = map;
            this._container = map._container;
            this._pane = map._panes.overlayPane;
            this._resetStateTimeout = 0;
            map.on("unload", this._destroy, this);
        },
        addHooks: function() {
            on(this._container, "mousedown", this._onMouseDown, this);
        },
        removeHooks: function() {
            off(this._container, "mousedown", this._onMouseDown, this);
        },
        moved: function() {
            return this._moved;
        },
        _destroy: function() {
            remove(this._pane);
            delete this._pane;
        },
        _resetState: function() {
            this._resetStateTimeout = 0;
            this._moved = false;
        },
        _clearDeferredResetState: function() {
            if (this._resetStateTimeout !== 0) {
                clearTimeout(this._resetStateTimeout);
                this._resetStateTimeout = 0;
            }
        },
        _onMouseDown: function(e) {
            if (!e.shiftKey || e.which !== 1 && e.button !== 1) return false;
            // Clear the deferred resetState if it hasn't executed yet, otherwise it
            // will interrupt the interaction and orphan a box element in the container.
            this._clearDeferredResetState();
            this._resetState();
            disableTextSelection();
            disableImageDrag();
            this._startPoint = this._map.mouseEventToContainerPoint(e);
            on(document, {
                contextmenu: stop,
                mousemove: this._onMouseMove,
                mouseup: this._onMouseUp,
                keydown: this._onKeyDown
            }, this);
        },
        _onMouseMove: function(e) {
            if (!this._moved) {
                this._moved = true;
                this._box = create$1("div", "leaflet-zoom-box", this._container);
                addClass(this._container, "leaflet-crosshair");
                this._map.fire("boxzoomstart");
            }
            this._point = this._map.mouseEventToContainerPoint(e);
            var bounds = new Bounds(this._point, this._startPoint), size = bounds.getSize();
            setPosition(this._box, bounds.min);
            this._box.style.width = size.x + "px";
            this._box.style.height = size.y + "px";
        },
        _finish: function() {
            if (this._moved) {
                remove(this._box);
                removeClass(this._container, "leaflet-crosshair");
            }
            enableTextSelection();
            enableImageDrag();
            off(document, {
                contextmenu: stop,
                mousemove: this._onMouseMove,
                mouseup: this._onMouseUp,
                keydown: this._onKeyDown
            }, this);
        },
        _onMouseUp: function(e) {
            if (e.which !== 1 && e.button !== 1) return;
            this._finish();
            if (!this._moved) return;
            // Postpone to next JS tick so internal click event handling
            // still see it as "moved".
            this._clearDeferredResetState();
            this._resetStateTimeout = setTimeout(bind(this._resetState, this), 0);
            var bounds = new LatLngBounds(this._map.containerPointToLatLng(this._startPoint), this._map.containerPointToLatLng(this._point));
            this._map.fitBounds(bounds).fire("boxzoomend", {
                boxZoomBounds: bounds
            });
        },
        _onKeyDown: function(e) {
            if (e.keyCode === 27) {
                this._finish();
                this._clearDeferredResetState();
                this._resetState();
            }
        }
    });
    // @section Handlers
    // @property boxZoom: Handler
    // Box (shift-drag with mouse) zoom handler.
    Map.addInitHook("addHandler", "boxZoom", BoxZoom);
    /*
   * L.Handler.DoubleClickZoom is used to handle double-click zoom on the map, enabled by default.
   */ // @namespace Map
    // @section Interaction Options
    Map.mergeOptions({
        // @option doubleClickZoom: Boolean|String = true
        // Whether the map can be zoomed in by double clicking on it and
        // zoomed out by double clicking while holding shift. If passed
        // `'center'`, double-click zoom will zoom to the center of the
        //  view regardless of where the mouse was.
        doubleClickZoom: true
    });
    var DoubleClickZoom = Handler.extend({
        addHooks: function() {
            this._map.on("dblclick", this._onDoubleClick, this);
        },
        removeHooks: function() {
            this._map.off("dblclick", this._onDoubleClick, this);
        },
        _onDoubleClick: function(e) {
            var map = this._map, oldZoom = map.getZoom(), delta = map.options.zoomDelta, zoom = e.originalEvent.shiftKey ? oldZoom - delta : oldZoom + delta;
            if (map.options.doubleClickZoom === "center") map.setZoom(zoom);
            else map.setZoomAround(e.containerPoint, zoom);
        }
    });
    // @section Handlers
    //
    // Map properties include interaction handlers that allow you to control
    // interaction behavior in runtime, enabling or disabling certain features such
    // as dragging or touch zoom (see `Handler` methods). For example:
    //
    // ```js
    // map.doubleClickZoom.disable();
    // ```
    //
    // @property doubleClickZoom: Handler
    // Double click zoom handler.
    Map.addInitHook("addHandler", "doubleClickZoom", DoubleClickZoom);
    /*
   * L.Handler.MapDrag is used to make the map draggable (with panning inertia), enabled by default.
   */ // @namespace Map
    // @section Interaction Options
    Map.mergeOptions({
        // @option dragging: Boolean = true
        // Whether the map is draggable with mouse/touch or not.
        dragging: true,
        // @section Panning Inertia Options
        // @option inertia: Boolean = *
        // If enabled, panning of the map will have an inertia effect where
        // the map builds momentum while dragging and continues moving in
        // the same direction for some time. Feels especially nice on touch
        // devices. Enabled by default.
        inertia: true,
        // @option inertiaDeceleration: Number = 3000
        // The rate with which the inertial movement slows down, in pixels/second².
        inertiaDeceleration: 3400,
        // @option inertiaMaxSpeed: Number = Infinity
        // Max speed of the inertial movement, in pixels/second.
        inertiaMaxSpeed: Infinity,
        // @option easeLinearity: Number = 0.2
        easeLinearity: 0.2,
        // TODO refactor, move to CRS
        // @option worldCopyJump: Boolean = false
        // With this option enabled, the map tracks when you pan to another "copy"
        // of the world and seamlessly jumps to the original one so that all overlays
        // like markers and vector layers are still visible.
        worldCopyJump: false,
        // @option maxBoundsViscosity: Number = 0.0
        // If `maxBounds` is set, this option will control how solid the bounds
        // are when dragging the map around. The default value of `0.0` allows the
        // user to drag outside the bounds at normal speed, higher values will
        // slow down map dragging outside bounds, and `1.0` makes the bounds fully
        // solid, preventing the user from dragging outside the bounds.
        maxBoundsViscosity: 0.0
    });
    var Drag = Handler.extend({
        addHooks: function() {
            if (!this._draggable) {
                var map = this._map;
                this._draggable = new Draggable(map._mapPane, map._container);
                this._draggable.on({
                    dragstart: this._onDragStart,
                    drag: this._onDrag,
                    dragend: this._onDragEnd
                }, this);
                this._draggable.on("predrag", this._onPreDragLimit, this);
                if (map.options.worldCopyJump) {
                    this._draggable.on("predrag", this._onPreDragWrap, this);
                    map.on("zoomend", this._onZoomEnd, this);
                    map.whenReady(this._onZoomEnd, this);
                }
            }
            addClass(this._map._container, "leaflet-grab leaflet-touch-drag");
            this._draggable.enable();
            this._positions = [];
            this._times = [];
        },
        removeHooks: function() {
            removeClass(this._map._container, "leaflet-grab");
            removeClass(this._map._container, "leaflet-touch-drag");
            this._draggable.disable();
        },
        moved: function() {
            return this._draggable && this._draggable._moved;
        },
        moving: function() {
            return this._draggable && this._draggable._moving;
        },
        _onDragStart: function() {
            var map = this._map;
            map._stop();
            if (this._map.options.maxBounds && this._map.options.maxBoundsViscosity) {
                var bounds = toLatLngBounds(this._map.options.maxBounds);
                this._offsetLimit = toBounds(this._map.latLngToContainerPoint(bounds.getNorthWest()).multiplyBy(-1), this._map.latLngToContainerPoint(bounds.getSouthEast()).multiplyBy(-1).add(this._map.getSize()));
                this._viscosity = Math.min(1.0, Math.max(0.0, this._map.options.maxBoundsViscosity));
            } else this._offsetLimit = null;
            map.fire("movestart").fire("dragstart");
            if (map.options.inertia) {
                this._positions = [];
                this._times = [];
            }
        },
        _onDrag: function(e) {
            if (this._map.options.inertia) {
                var time = this._lastTime = +new Date(), pos = this._lastPos = this._draggable._absPos || this._draggable._newPos;
                this._positions.push(pos);
                this._times.push(time);
                this._prunePositions(time);
            }
            this._map.fire("move", e).fire("drag", e);
        },
        _prunePositions: function(time) {
            while(this._positions.length > 1 && time - this._times[0] > 50){
                this._positions.shift();
                this._times.shift();
            }
        },
        _onZoomEnd: function() {
            var pxCenter = this._map.getSize().divideBy(2), pxWorldCenter = this._map.latLngToLayerPoint([
                0,
                0
            ]);
            this._initialWorldOffset = pxWorldCenter.subtract(pxCenter).x;
            this._worldWidth = this._map.getPixelWorldBounds().getSize().x;
        },
        _viscousLimit: function(value, threshold) {
            return value - (value - threshold) * this._viscosity;
        },
        _onPreDragLimit: function() {
            if (!this._viscosity || !this._offsetLimit) return;
            var offset = this._draggable._newPos.subtract(this._draggable._startPos);
            var limit = this._offsetLimit;
            if (offset.x < limit.min.x) offset.x = this._viscousLimit(offset.x, limit.min.x);
            if (offset.y < limit.min.y) offset.y = this._viscousLimit(offset.y, limit.min.y);
            if (offset.x > limit.max.x) offset.x = this._viscousLimit(offset.x, limit.max.x);
            if (offset.y > limit.max.y) offset.y = this._viscousLimit(offset.y, limit.max.y);
            this._draggable._newPos = this._draggable._startPos.add(offset);
        },
        _onPreDragWrap: function() {
            // TODO refactor to be able to adjust map pane position after zoom
            var worldWidth = this._worldWidth, halfWidth = Math.round(worldWidth / 2), dx = this._initialWorldOffset, x = this._draggable._newPos.x, newX1 = (x - halfWidth + dx) % worldWidth + halfWidth - dx, newX2 = (x + halfWidth + dx) % worldWidth - halfWidth - dx, newX = Math.abs(newX1 + dx) < Math.abs(newX2 + dx) ? newX1 : newX2;
            this._draggable._absPos = this._draggable._newPos.clone();
            this._draggable._newPos.x = newX;
        },
        _onDragEnd: function(e) {
            var map = this._map, options = map.options, noInertia = !options.inertia || e.noInertia || this._times.length < 2;
            map.fire("dragend", e);
            if (noInertia) map.fire("moveend");
            else {
                this._prunePositions(+new Date());
                var direction = this._lastPos.subtract(this._positions[0]), duration = (this._lastTime - this._times[0]) / 1000, ease = options.easeLinearity, speedVector = direction.multiplyBy(ease / duration), speed = speedVector.distanceTo([
                    0,
                    0
                ]), limitedSpeed = Math.min(options.inertiaMaxSpeed, speed), limitedSpeedVector = speedVector.multiplyBy(limitedSpeed / speed), decelerationDuration = limitedSpeed / (options.inertiaDeceleration * ease), offset = limitedSpeedVector.multiplyBy(-decelerationDuration / 2).round();
                if (!offset.x && !offset.y) map.fire("moveend");
                else {
                    offset = map._limitOffset(offset, map.options.maxBounds);
                    requestAnimFrame(function() {
                        map.panBy(offset, {
                            duration: decelerationDuration,
                            easeLinearity: ease,
                            noMoveStart: true,
                            animate: true
                        });
                    });
                }
            }
        }
    });
    // @section Handlers
    // @property dragging: Handler
    // Map dragging handler (by both mouse and touch).
    Map.addInitHook("addHandler", "dragging", Drag);
    /*
   * L.Map.Keyboard is handling keyboard interaction with the map, enabled by default.
   */ // @namespace Map
    // @section Keyboard Navigation Options
    Map.mergeOptions({
        // @option keyboard: Boolean = true
        // Makes the map focusable and allows users to navigate the map with keyboard
        // arrows and `+`/`-` keys.
        keyboard: true,
        // @option keyboardPanDelta: Number = 80
        // Amount of pixels to pan when pressing an arrow key.
        keyboardPanDelta: 80
    });
    var Keyboard = Handler.extend({
        keyCodes: {
            left: [
                37
            ],
            right: [
                39
            ],
            down: [
                40
            ],
            up: [
                38
            ],
            zoomIn: [
                187,
                107,
                61,
                171
            ],
            zoomOut: [
                189,
                109,
                54,
                173
            ]
        },
        initialize: function(map) {
            this._map = map;
            this._setPanDelta(map.options.keyboardPanDelta);
            this._setZoomDelta(map.options.zoomDelta);
        },
        addHooks: function() {
            var container = this._map._container;
            // make the container focusable by tabbing
            if (container.tabIndex <= 0) container.tabIndex = "0";
            on(container, {
                focus: this._onFocus,
                blur: this._onBlur,
                mousedown: this._onMouseDown
            }, this);
            this._map.on({
                focus: this._addHooks,
                blur: this._removeHooks
            }, this);
        },
        removeHooks: function() {
            this._removeHooks();
            off(this._map._container, {
                focus: this._onFocus,
                blur: this._onBlur,
                mousedown: this._onMouseDown
            }, this);
            this._map.off({
                focus: this._addHooks,
                blur: this._removeHooks
            }, this);
        },
        _onMouseDown: function() {
            if (this._focused) return;
            var body = document.body, docEl = document.documentElement, top = body.scrollTop || docEl.scrollTop, left = body.scrollLeft || docEl.scrollLeft;
            this._map._container.focus();
            window.scrollTo(left, top);
        },
        _onFocus: function() {
            this._focused = true;
            this._map.fire("focus");
        },
        _onBlur: function() {
            this._focused = false;
            this._map.fire("blur");
        },
        _setPanDelta: function(panDelta) {
            var keys = this._panKeys = {}, codes = this.keyCodes, i, len;
            for(i = 0, len = codes.left.length; i < len; i++)keys[codes.left[i]] = [
                -1 * panDelta,
                0
            ];
            for(i = 0, len = codes.right.length; i < len; i++)keys[codes.right[i]] = [
                panDelta,
                0
            ];
            for(i = 0, len = codes.down.length; i < len; i++)keys[codes.down[i]] = [
                0,
                panDelta
            ];
            for(i = 0, len = codes.up.length; i < len; i++)keys[codes.up[i]] = [
                0,
                -1 * panDelta
            ];
        },
        _setZoomDelta: function(zoomDelta) {
            var keys = this._zoomKeys = {}, codes = this.keyCodes, i, len;
            for(i = 0, len = codes.zoomIn.length; i < len; i++)keys[codes.zoomIn[i]] = zoomDelta;
            for(i = 0, len = codes.zoomOut.length; i < len; i++)keys[codes.zoomOut[i]] = -zoomDelta;
        },
        _addHooks: function() {
            on(document, "keydown", this._onKeyDown, this);
        },
        _removeHooks: function() {
            off(document, "keydown", this._onKeyDown, this);
        },
        _onKeyDown: function(e) {
            if (e.altKey || e.ctrlKey || e.metaKey) return;
            var key = e.keyCode, map = this._map, offset;
            if (key in this._panKeys) {
                if (!map._panAnim || !map._panAnim._inProgress) {
                    offset = this._panKeys[key];
                    if (e.shiftKey) offset = toPoint(offset).multiplyBy(3);
                    if (map.options.maxBounds) offset = map._limitOffset(toPoint(offset), map.options.maxBounds);
                    if (map.options.worldCopyJump) {
                        var newLatLng = map.wrapLatLng(map.unproject(map.project(map.getCenter()).add(offset)));
                        map.panTo(newLatLng);
                    } else map.panBy(offset);
                }
            } else if (key in this._zoomKeys) map.setZoom(map.getZoom() + (e.shiftKey ? 3 : 1) * this._zoomKeys[key]);
            else if (key === 27 && map._popup && map._popup.options.closeOnEscapeKey) map.closePopup();
            else return;
            stop(e);
        }
    });
    // @section Handlers
    // @section Handlers
    // @property keyboard: Handler
    // Keyboard navigation handler.
    Map.addInitHook("addHandler", "keyboard", Keyboard);
    /*
   * L.Handler.ScrollWheelZoom is used by L.Map to enable mouse scroll wheel zoom on the map.
   */ // @namespace Map
    // @section Interaction Options
    Map.mergeOptions({
        // @section Mouse wheel options
        // @option scrollWheelZoom: Boolean|String = true
        // Whether the map can be zoomed by using the mouse wheel. If passed `'center'`,
        // it will zoom to the center of the view regardless of where the mouse was.
        scrollWheelZoom: true,
        // @option wheelDebounceTime: Number = 40
        // Limits the rate at which a wheel can fire (in milliseconds). By default
        // user can't zoom via wheel more often than once per 40 ms.
        wheelDebounceTime: 40,
        // @option wheelPxPerZoomLevel: Number = 60
        // How many scroll pixels (as reported by [L.DomEvent.getWheelDelta](#domevent-getwheeldelta))
        // mean a change of one full zoom level. Smaller values will make wheel-zooming
        // faster (and vice versa).
        wheelPxPerZoomLevel: 60
    });
    var ScrollWheelZoom = Handler.extend({
        addHooks: function() {
            on(this._map._container, "wheel", this._onWheelScroll, this);
            this._delta = 0;
        },
        removeHooks: function() {
            off(this._map._container, "wheel", this._onWheelScroll, this);
        },
        _onWheelScroll: function(e) {
            var delta = getWheelDelta(e);
            var debounce = this._map.options.wheelDebounceTime;
            this._delta += delta;
            this._lastMousePos = this._map.mouseEventToContainerPoint(e);
            if (!this._startTime) this._startTime = +new Date();
            var left = Math.max(debounce - (+new Date() - this._startTime), 0);
            clearTimeout(this._timer);
            this._timer = setTimeout(bind(this._performZoom, this), left);
            stop(e);
        },
        _performZoom: function() {
            var map = this._map, zoom = map.getZoom(), snap = this._map.options.zoomSnap || 0;
            map._stop(); // stop panning and fly animations if any
            // map the delta with a sigmoid function to -4..4 range leaning on -1..1
            var d2 = this._delta / (this._map.options.wheelPxPerZoomLevel * 4), d3 = 4 * Math.log(2 / (1 + Math.exp(-Math.abs(d2)))) / Math.LN2, d4 = snap ? Math.ceil(d3 / snap) * snap : d3, delta = map._limitZoom(zoom + (this._delta > 0 ? d4 : -d4)) - zoom;
            this._delta = 0;
            this._startTime = null;
            if (!delta) return;
            if (map.options.scrollWheelZoom === "center") map.setZoom(zoom + delta);
            else map.setZoomAround(this._lastMousePos, zoom + delta);
        }
    });
    // @section Handlers
    // @property scrollWheelZoom: Handler
    // Scroll wheel zoom handler.
    Map.addInitHook("addHandler", "scrollWheelZoom", ScrollWheelZoom);
    /*
   * L.Map.TapHold is used to simulate `contextmenu` event on long hold,
   * which otherwise is not fired by mobile Safari.
   */ var tapHoldDelay = 600;
    // @namespace Map
    // @section Interaction Options
    Map.mergeOptions({
        // @section Touch interaction options
        // @option tapHold: Boolean
        // Enables simulation of `contextmenu` event, default is `true` for mobile Safari.
        tapHold: Browser.touchNative && Browser.safari && Browser.mobile,
        // @option tapTolerance: Number = 15
        // The max number of pixels a user can shift his finger during touch
        // for it to be considered a valid tap.
        tapTolerance: 15
    });
    var TapHold = Handler.extend({
        addHooks: function() {
            on(this._map._container, "touchstart", this._onDown, this);
        },
        removeHooks: function() {
            off(this._map._container, "touchstart", this._onDown, this);
        },
        _onDown: function(e) {
            clearTimeout(this._holdTimeout);
            if (e.touches.length !== 1) return;
            var first = e.touches[0];
            this._startPos = this._newPos = new Point(first.clientX, first.clientY);
            this._holdTimeout = setTimeout(bind(function() {
                this._cancel();
                if (!this._isTapValid()) return;
                // prevent simulated mouse events https://w3c.github.io/touch-events/#mouse-events
                on(document, "touchend", preventDefault);
                on(document, "touchend touchcancel", this._cancelClickPrevent);
                this._simulateEvent("contextmenu", first);
            }, this), tapHoldDelay);
            on(document, "touchend touchcancel contextmenu", this._cancel, this);
            on(document, "touchmove", this._onMove, this);
        },
        _cancelClickPrevent: function cancelClickPrevent() {
            off(document, "touchend", preventDefault);
            off(document, "touchend touchcancel", cancelClickPrevent);
        },
        _cancel: function() {
            clearTimeout(this._holdTimeout);
            off(document, "touchend touchcancel contextmenu", this._cancel, this);
            off(document, "touchmove", this._onMove, this);
        },
        _onMove: function(e) {
            var first = e.touches[0];
            this._newPos = new Point(first.clientX, first.clientY);
        },
        _isTapValid: function() {
            return this._newPos.distanceTo(this._startPos) <= this._map.options.tapTolerance;
        },
        _simulateEvent: function(type, e) {
            var simulatedEvent = new MouseEvent(type, {
                bubbles: true,
                cancelable: true,
                view: window,
                // detail: 1,
                screenX: e.screenX,
                screenY: e.screenY,
                clientX: e.clientX,
                clientY: e.clientY
            });
            simulatedEvent._simulated = true;
            e.target.dispatchEvent(simulatedEvent);
        }
    });
    // @section Handlers
    // @property tapHold: Handler
    // Long tap handler to simulate `contextmenu` event (useful in mobile Safari).
    Map.addInitHook("addHandler", "tapHold", TapHold);
    /*
   * L.Handler.TouchZoom is used by L.Map to add pinch zoom on supported mobile browsers.
   */ // @namespace Map
    // @section Interaction Options
    Map.mergeOptions({
        // @section Touch interaction options
        // @option touchZoom: Boolean|String = *
        // Whether the map can be zoomed by touch-dragging with two fingers. If
        // passed `'center'`, it will zoom to the center of the view regardless of
        // where the touch events (fingers) were. Enabled for touch-capable web
        // browsers.
        touchZoom: Browser.touch,
        // @option bounceAtZoomLimits: Boolean = true
        // Set it to false if you don't want the map to zoom beyond min/max zoom
        // and then bounce back when pinch-zooming.
        bounceAtZoomLimits: true
    });
    var TouchZoom = Handler.extend({
        addHooks: function() {
            addClass(this._map._container, "leaflet-touch-zoom");
            on(this._map._container, "touchstart", this._onTouchStart, this);
        },
        removeHooks: function() {
            removeClass(this._map._container, "leaflet-touch-zoom");
            off(this._map._container, "touchstart", this._onTouchStart, this);
        },
        _onTouchStart: function(e) {
            var map = this._map;
            if (!e.touches || e.touches.length !== 2 || map._animatingZoom || this._zooming) return;
            var p1 = map.mouseEventToContainerPoint(e.touches[0]), p2 = map.mouseEventToContainerPoint(e.touches[1]);
            this._centerPoint = map.getSize()._divideBy(2);
            this._startLatLng = map.containerPointToLatLng(this._centerPoint);
            if (map.options.touchZoom !== "center") this._pinchStartLatLng = map.containerPointToLatLng(p1.add(p2)._divideBy(2));
            this._startDist = p1.distanceTo(p2);
            this._startZoom = map.getZoom();
            this._moved = false;
            this._zooming = true;
            map._stop();
            on(document, "touchmove", this._onTouchMove, this);
            on(document, "touchend touchcancel", this._onTouchEnd, this);
            preventDefault(e);
        },
        _onTouchMove: function(e) {
            if (!e.touches || e.touches.length !== 2 || !this._zooming) return;
            var map = this._map, p1 = map.mouseEventToContainerPoint(e.touches[0]), p2 = map.mouseEventToContainerPoint(e.touches[1]), scale = p1.distanceTo(p2) / this._startDist;
            this._zoom = map.getScaleZoom(scale, this._startZoom);
            if (!map.options.bounceAtZoomLimits && (this._zoom < map.getMinZoom() && scale < 1 || this._zoom > map.getMaxZoom() && scale > 1)) this._zoom = map._limitZoom(this._zoom);
            if (map.options.touchZoom === "center") {
                this._center = this._startLatLng;
                if (scale === 1) return;
            } else {
                // Get delta from pinch to center, so centerLatLng is delta applied to initial pinchLatLng
                var delta = p1._add(p2)._divideBy(2)._subtract(this._centerPoint);
                if (scale === 1 && delta.x === 0 && delta.y === 0) return;
                this._center = map.unproject(map.project(this._pinchStartLatLng, this._zoom).subtract(delta), this._zoom);
            }
            if (!this._moved) {
                map._moveStart(true, false);
                this._moved = true;
            }
            cancelAnimFrame(this._animRequest);
            var moveFn = bind(map._move, map, this._center, this._zoom, {
                pinch: true,
                round: false
            }, undefined);
            this._animRequest = requestAnimFrame(moveFn, this, true);
            preventDefault(e);
        },
        _onTouchEnd: function() {
            if (!this._moved || !this._zooming) {
                this._zooming = false;
                return;
            }
            this._zooming = false;
            cancelAnimFrame(this._animRequest);
            off(document, "touchmove", this._onTouchMove, this);
            off(document, "touchend touchcancel", this._onTouchEnd, this);
            // Pinch updates GridLayers' levels only when zoomSnap is off, so zoomSnap becomes noUpdate.
            if (this._map.options.zoomAnimation) this._map._animateZoom(this._center, this._map._limitZoom(this._zoom), true, this._map.options.zoomSnap);
            else this._map._resetView(this._center, this._map._limitZoom(this._zoom));
        }
    });
    // @section Handlers
    // @property touchZoom: Handler
    // Touch zoom handler.
    Map.addInitHook("addHandler", "touchZoom", TouchZoom);
    Map.BoxZoom = BoxZoom;
    Map.DoubleClickZoom = DoubleClickZoom;
    Map.Drag = Drag;
    Map.Keyboard = Keyboard;
    Map.ScrollWheelZoom = ScrollWheelZoom;
    Map.TapHold = TapHold;
    Map.TouchZoom = TouchZoom;
    exports.Bounds = Bounds;
    exports.Browser = Browser;
    exports.CRS = CRS;
    exports.Canvas = Canvas;
    exports.Circle = Circle;
    exports.CircleMarker = CircleMarker;
    exports.Class = Class;
    exports.Control = Control;
    exports.DivIcon = DivIcon;
    exports.DivOverlay = DivOverlay;
    exports.DomEvent = DomEvent;
    exports.DomUtil = DomUtil;
    exports.Draggable = Draggable;
    exports.Evented = Evented;
    exports.FeatureGroup = FeatureGroup;
    exports.GeoJSON = GeoJSON;
    exports.GridLayer = GridLayer;
    exports.Handler = Handler;
    exports.Icon = Icon;
    exports.ImageOverlay = ImageOverlay;
    exports.LatLng = LatLng;
    exports.LatLngBounds = LatLngBounds;
    exports.Layer = Layer;
    exports.LayerGroup = LayerGroup;
    exports.LineUtil = LineUtil;
    exports.Map = Map;
    exports.Marker = Marker;
    exports.Mixin = Mixin;
    exports.Path = Path;
    exports.Point = Point;
    exports.PolyUtil = PolyUtil;
    exports.Polygon = Polygon;
    exports.Polyline = Polyline;
    exports.Popup = Popup;
    exports.PosAnimation = PosAnimation;
    exports.Projection = index;
    exports.Rectangle = Rectangle;
    exports.Renderer = Renderer;
    exports.SVG = SVG;
    exports.SVGOverlay = SVGOverlay;
    exports.TileLayer = TileLayer;
    exports.Tooltip = Tooltip;
    exports.Transformation = Transformation;
    exports.Util = Util;
    exports.VideoOverlay = VideoOverlay;
    exports.bind = bind;
    exports.bounds = toBounds;
    exports.canvas = canvas;
    exports.circle = circle;
    exports.circleMarker = circleMarker;
    exports.control = control;
    exports.divIcon = divIcon;
    exports.extend = extend;
    exports.featureGroup = featureGroup;
    exports.geoJSON = geoJSON;
    exports.geoJson = geoJson;
    exports.gridLayer = gridLayer;
    exports.icon = icon;
    exports.imageOverlay = imageOverlay;
    exports.latLng = toLatLng;
    exports.latLngBounds = toLatLngBounds;
    exports.layerGroup = layerGroup;
    exports.map = createMap;
    exports.marker = marker;
    exports.point = toPoint;
    exports.polygon = polygon;
    exports.polyline = polyline;
    exports.popup = popup;
    exports.rectangle = rectangle;
    exports.setOptions = setOptions;
    exports.stamp = stamp;
    exports.svg = svg;
    exports.svgOverlay = svgOverlay;
    exports.tileLayer = tileLayer;
    exports.tooltip = tooltip;
    exports.transformation = toTransformation;
    exports.version = version;
    exports.videoOverlay = videoOverlay;
    var oldL = window.L;
    exports.noConflict = function() {
        window.L = oldL;
        return this;
    };
    // Always export us to window global (see #2364)
    window.L = exports;
});


var $91413e73098b9b1c$exports = {};


$91413e73098b9b1c$exports = (parcelRequire("iygN0")).getBundleURL("5aFkV") + (parcelRequire("9LHVU")).resolve("3GmPV");


/**
 * STORYBOOK : there is a conflict between parcel and webpack. Here we use bundle-text from parcel and it's not recognized in webpack, that is used in storybook.
 * To prevent conflict, you need to comment the 3 imports unsign 'bundle-text' above, and the 3 'style' tags in the HTML below.
 */ const $c2309a35977c160d$var$DefaultIcon = (0, (/*@__PURE__*/$parcel$interopDefault($3df1761126dc5bba$exports))).icon({
    iconUrl: `${(0, $9062ab1ccebf2f9e$export$e56d88b19b5c9fbf).mapArrival}`,
    shadowUrl: (0, (/*@__PURE__*/$parcel$interopDefault($91413e73098b9b1c$exports))),
    iconSize: [
        32,
        41
    ],
    iconAnchor: [
        10,
        41
    ]
});
(0, (/*@__PURE__*/$parcel$interopDefault($3df1761126dc5bba$exports))).Marker.prototype.options.icon = $c2309a35977c160d$var$DefaultIcon;
const $c2309a35977c160d$var$ShadowRoot = ({ children: children })=>{
    return /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsxs)((0, $5dd5447bf377a209$export$2e2bcd8739ae039).div, {
        id: "retorik-shadow",
        className: "rf-w-full rf-h-full",
        style: {
            position: "relative"
        },
        children: [
            children,
            /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("style", {
                type: "text/css",
                children: `${(0, (/*@__PURE__*/$parcel$interopDefault($6d61f87c604fad49$exports)))}`
            }),
            /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("style", {
                type: "text/css",
                children: `${(0, (/*@__PURE__*/$parcel$interopDefault($9acfeaf8313b98ad$exports)))}`
            }),
            /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("style", {
                type: "text/css",
                children: `${(0, (/*@__PURE__*/$parcel$interopDefault($03257026ff01fcda$exports)))}`
            })
        ]
    });
};
var $c2309a35977c160d$export$2e2bcd8739ae039 = $c2309a35977c160d$var$ShadowRoot;


/* eslint-disable react/jsx-boolean-value */ 

var $eO7Kz = parcelRequire("eO7Kz");
// @ts-nocheck


var $eO7Kz = parcelRequire("eO7Kz");
var $497baa802110a7bc$exports = {};
"use strict";

var $luOtD = parcelRequire("luOtD");
Object.defineProperty($497baa802110a7bc$exports, "__esModule", {
    value: true
});
var $497baa802110a7bc$var$_exportNames = {
    createDirectLine: true,
    createDirectLineAppServiceExtension: true,
    Components: true,
    hooks: true,
    renderWebChat: true,
    createAdaptiveCardsAttachmentMiddleware: true,
    createAdaptiveCardsAttachmentForScreenReaderMiddleware: true,
    createCognitiveServicesSpeechServicesPonyfillFactory: true,
    createDirectLineSpeechAdapters: true,
    createStyleSet: true,
    renderMarkdown: true
};
$497baa802110a7bc$exports.Components = void 0;
Object.defineProperty($497baa802110a7bc$exports, "createAdaptiveCardsAttachmentForScreenReaderMiddleware", {
    enumerable: true,
    get: function get() {
        return $497baa802110a7bc$var$_createAdaptiveCardsAttachmentForScreenReaderMiddleware.default;
    }
});
Object.defineProperty($497baa802110a7bc$exports, "createAdaptiveCardsAttachmentMiddleware", {
    enumerable: true,
    get: function get() {
        return $497baa802110a7bc$var$_createAdaptiveCardsAttachmentMiddleware.default;
    }
});
Object.defineProperty($497baa802110a7bc$exports, "createCognitiveServicesSpeechServicesPonyfillFactory", {
    enumerable: true,
    get: function get() {
        return $497baa802110a7bc$var$_createCognitiveServicesSpeechServicesPonyfillFactory.default;
    }
});
$497baa802110a7bc$exports.createDirectLineAppServiceExtension = $497baa802110a7bc$exports.createDirectLine = void 0;
Object.defineProperty($497baa802110a7bc$exports, "createDirectLineSpeechAdapters", {
    enumerable: true,
    get: function get() {
        return $497baa802110a7bc$var$_createDirectLineSpeechAdapters.default;
    }
});
Object.defineProperty($497baa802110a7bc$exports, "createStyleSet", {
    enumerable: true,
    get: function get() {
        return $497baa802110a7bc$var$_createFullStyleSet.default;
    }
});
$497baa802110a7bc$exports.hooks = $497baa802110a7bc$exports.default = void 0;
Object.defineProperty($497baa802110a7bc$exports, "renderMarkdown", {
    enumerable: true,
    get: function get() {
        return $497baa802110a7bc$var$_renderMarkdown.default;
    }
});
$497baa802110a7bc$exports.renderWebChat = void 0;

var $497baa802110a7bc$var$_defineProperty2 = $luOtD((parcelRequire("3w8Sv")));
var $8fbe9fb13c033bfd$exports = {};
"use strict";

var $luOtD = parcelRequire("luOtD");

var $2PxO1 = parcelRequire("2PxO1");
Object.defineProperty($8fbe9fb13c033bfd$exports, "__esModule", {
    value: true
});
Object.defineProperty($8fbe9fb13c033bfd$exports, "Components", {
    enumerable: true,
    get: function get() {
        return $8fbe9fb13c033bfd$var$_botframeworkWebchatComponent.Components;
    }
});
Object.defineProperty($8fbe9fb13c033bfd$exports, "Constants", {
    enumerable: true,
    get: function get() {
        return $cG9B9.Constants;
    }
});
Object.defineProperty($8fbe9fb13c033bfd$exports, "concatMiddleware", {
    enumerable: true,
    get: function get() {
        return $8fbe9fb13c033bfd$var$_botframeworkWebchatComponent.concatMiddleware;
    }
});
Object.defineProperty($8fbe9fb13c033bfd$exports, "connectToWebChat", {
    enumerable: true,
    get: function get() {
        return $8fbe9fb13c033bfd$var$_botframeworkWebchatComponent.connectToWebChat;
    }
});
Object.defineProperty($8fbe9fb13c033bfd$exports, "createBrowserWebSpeechPonyfillFactory", {
    enumerable: true,
    get: function get() {
        return $8fbe9fb13c033bfd$var$_createBrowserWebSpeechPonyfillFactory.default;
    }
});
$8fbe9fb13c033bfd$exports.createDirectLineAppServiceExtension = $8fbe9fb13c033bfd$exports.createDirectLine = void 0;
Object.defineProperty($8fbe9fb13c033bfd$exports, "createStore", {
    enumerable: true,
    get: function get() {
        return $cG9B9.createStore;
    }
});
Object.defineProperty($8fbe9fb13c033bfd$exports, "createStoreWithDevTools", {
    enumerable: true,
    get: function get() {
        return $cG9B9.createStoreWithDevTools;
    }
});
Object.defineProperty($8fbe9fb13c033bfd$exports, "createStoreWithOptions", {
    enumerable: true,
    get: function get() {
        return $cG9B9.createStoreWithOptions;
    }
});
Object.defineProperty($8fbe9fb13c033bfd$exports, "createStyleSet", {
    enumerable: true,
    get: function get() {
        return $8fbe9fb13c033bfd$var$_botframeworkWebchatComponent.createStyleSet;
    }
});
$8fbe9fb13c033bfd$exports.default = void 0;
Object.defineProperty($8fbe9fb13c033bfd$exports, "hooks", {
    enumerable: true,
    get: function get() {
        return $8fbe9fb13c033bfd$var$_botframeworkWebchatComponent.hooks;
    }
});
$8fbe9fb13c033bfd$exports.renderWebChat = void 0;
Object.defineProperty($8fbe9fb13c033bfd$exports, "version", {
    enumerable: true,
    get: function get() {
        return $cG9B9.version;
    }
});

var $8fbe9fb13c033bfd$var$_defineProperty2 = $luOtD((parcelRequire("3w8Sv")));

var $cG9B9 = parcelRequire("cG9B9");

var $8fbe9fb13c033bfd$var$_botframeworkWebchatComponent = $8fbe9fb13c033bfd$var$_interopRequireWildcard((parcelRequire("fD7D4")));

var $8fbe9fb13c033bfd$var$_addVersion = $luOtD((parcelRequire("2q5ze")));

var $8fbe9fb13c033bfd$var$_renderWebChat = $luOtD((parcelRequire("lBhHu")));

var $8fbe9fb13c033bfd$var$_createBrowserWebSpeechPonyfillFactory = $luOtD((parcelRequire("3F9kf")));

var $8fbe9fb13c033bfd$var$_createDirectLine = $luOtD((parcelRequire("bZDNv")));

var $8fbe9fb13c033bfd$var$_createDirectLineAppServiceExtension = $luOtD((parcelRequire("eZI1G")));
function $8fbe9fb13c033bfd$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($8fbe9fb13c033bfd$var$_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $8fbe9fb13c033bfd$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || $2PxO1(obj) !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $8fbe9fb13c033bfd$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $8fbe9fb13c033bfd$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $8fbe9fb13c033bfd$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $8fbe9fb13c033bfd$var$ownKeys(Object(source), !0).forEach(function(key) {
            (0, $8fbe9fb13c033bfd$var$_defineProperty2.default)(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $8fbe9fb13c033bfd$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var $8fbe9fb13c033bfd$var$renderWebChat = $8fbe9fb13c033bfd$var$_renderWebChat.default.bind(null, $8fbe9fb13c033bfd$var$_botframeworkWebchatComponent.default);
$8fbe9fb13c033bfd$exports.renderWebChat = $8fbe9fb13c033bfd$var$renderWebChat;
var $8fbe9fb13c033bfd$var$createDirectLine = function createDirectLine(options) {
    options.botAgent && console.warn("Web Chat: Developers are not currently allowed to set botAgent in the createDirectLine function. See https://github.com/microsoft/BotFramework-WebChat/issues/2119 for more details.");
    return (0, $8fbe9fb13c033bfd$var$_createDirectLine.default)($8fbe9fb13c033bfd$var$_objectSpread($8fbe9fb13c033bfd$var$_objectSpread({}, options), {}, {
        botAgent: "WebChat/".concat($cG9B9.version, " (Minimal)")
    }));
};
$8fbe9fb13c033bfd$exports.createDirectLine = $8fbe9fb13c033bfd$var$createDirectLine;
var $8fbe9fb13c033bfd$var$createDirectLineAppServiceExtension = function createDirectLineAppServiceExtension(options) {
    options.botAgent && console.warn("Web Chat: Developers are not currently allowed to set botAgent in the createDirectLine function. See https://github.com/microsoft/BotFramework-WebChat/issues/2119 for more details.");
    return (0, $8fbe9fb13c033bfd$var$_createDirectLineAppServiceExtension.default)($8fbe9fb13c033bfd$var$_objectSpread($8fbe9fb13c033bfd$var$_objectSpread({}, options), {}, {
        botAgent: "WebChat/".concat($cG9B9.version, " (Minimal)")
    }));
};
$8fbe9fb13c033bfd$exports.createDirectLineAppServiceExtension = $8fbe9fb13c033bfd$var$createDirectLineAppServiceExtension;
var $8fbe9fb13c033bfd$var$_default = $8fbe9fb13c033bfd$var$_botframeworkWebchatComponent.default;
$8fbe9fb13c033bfd$exports.default = $8fbe9fb13c033bfd$var$_default;
// Until we have a development-specific bundle, we are not shipping createStoreWithDevTools in bundle.
window["WebChat"] = $8fbe9fb13c033bfd$var$_objectSpread($8fbe9fb13c033bfd$var$_objectSpread({}, window["WebChat"]), {}, {
    concatMiddleware: $8fbe9fb13c033bfd$var$_botframeworkWebchatComponent.concatMiddleware,
    connectToWebChat: $8fbe9fb13c033bfd$var$_botframeworkWebchatComponent.connectToWebChat,
    Constants: $cG9B9.Constants,
    createBrowserWebSpeechPonyfillFactory: $8fbe9fb13c033bfd$var$_createBrowserWebSpeechPonyfillFactory.default,
    createDirectLine: $8fbe9fb13c033bfd$var$createDirectLine,
    createDirectLineAppServiceExtension: $8fbe9fb13c033bfd$var$createDirectLineAppServiceExtension,
    createStore: $cG9B9.createStore,
    createStoreWithOptions: $cG9B9.createStoreWithOptions,
    createStyleSet: $8fbe9fb13c033bfd$var$_botframeworkWebchatComponent.createStyleSet,
    hooks: $8fbe9fb13c033bfd$var$_botframeworkWebchatComponent.hooks,
    ReactWebChat: $8fbe9fb13c033bfd$var$_botframeworkWebchatComponent.default,
    renderWebChat: $8fbe9fb13c033bfd$var$renderWebChat
});
(0, $8fbe9fb13c033bfd$var$_addVersion.default)("minimal");


Object.keys($8fbe9fb13c033bfd$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($497baa802110a7bc$var$_exportNames, key)) return;
    if (key in $497baa802110a7bc$exports && $497baa802110a7bc$exports[key] === $8fbe9fb13c033bfd$exports[key]) return;
    Object.defineProperty($497baa802110a7bc$exports, key, {
        enumerable: true,
        get: function get() {
            return $8fbe9fb13c033bfd$exports[key];
        }
    });
});

var $497baa802110a7bc$var$_AdaptiveCardContent = $luOtD((parcelRequire("f0Leo")));

var $497baa802110a7bc$var$_addVersion = $luOtD((parcelRequire("2q5ze")));

var $497baa802110a7bc$var$_AnimationCardContent = $luOtD((parcelRequire("6PqZf")));

var $497baa802110a7bc$var$_AudioCardContent = $luOtD((parcelRequire("7BYwH")));

var $497baa802110a7bc$var$_renderWebChat = $luOtD((parcelRequire("lBhHu")));

var $497baa802110a7bc$var$_createAdaptiveCardsAttachmentMiddleware = $luOtD((parcelRequire("kgxJb")));

var $497baa802110a7bc$var$_createAdaptiveCardsAttachmentForScreenReaderMiddleware = $luOtD((parcelRequire("gixiP")));

var $497baa802110a7bc$var$_createCognitiveServicesSpeechServicesPonyfillFactory = $luOtD((parcelRequire("ccGPK")));

var $497baa802110a7bc$var$_createDirectLineSpeechAdapters = $luOtD((parcelRequire("MZIq5")));

var $497baa802110a7bc$var$_createFullStyleSet = $luOtD((parcelRequire("bpJl4")));

var $497baa802110a7bc$var$_createDirectLine = $luOtD((parcelRequire("bZDNv")));

var $497baa802110a7bc$var$_createDirectLineAppServiceExtension = $luOtD((parcelRequire("eZI1G")));

var $497baa802110a7bc$var$_FullComposer = $luOtD((parcelRequire("caYbs")));

var $497baa802110a7bc$var$_HeroCardContent = $luOtD((parcelRequire("qVAKz")));

var $497baa802110a7bc$var$_OAuthCardContent = $luOtD((parcelRequire("eEDa4")));

var $497baa802110a7bc$var$_FullReactWebChat = $luOtD((parcelRequire("bgVZk")));

var $497baa802110a7bc$var$_ReceiptCardContent = $luOtD((parcelRequire("lUOAR")));

var $497baa802110a7bc$var$_renderMarkdown = $luOtD((parcelRequire("gPdBB")));

var $497baa802110a7bc$var$_SignInCardContent = $luOtD((parcelRequire("idxQs")));

var $497baa802110a7bc$var$_ThumbnailCardContent = $luOtD((parcelRequire("gBtw4")));

var $497baa802110a7bc$var$_useAdaptiveCardsHostConfig = $luOtD((parcelRequire("8JJxt")));

var $497baa802110a7bc$var$_useAdaptiveCardsPackage = $luOtD((parcelRequire("fdwbc")));

var $497baa802110a7bc$var$_useStyleOptions = $luOtD((parcelRequire("gwtqY")));

var $497baa802110a7bc$var$_VideoCardContent = $luOtD((parcelRequire("lfUgi")));
function $497baa802110a7bc$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $497baa802110a7bc$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $497baa802110a7bc$var$ownKeys(Object(source), !0).forEach(function(key) {
            (0, $497baa802110a7bc$var$_defineProperty2.default)(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $497baa802110a7bc$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var $497baa802110a7bc$var$renderWebChat = $497baa802110a7bc$var$_renderWebChat.default.bind(null, $497baa802110a7bc$var$_FullReactWebChat.default);
$497baa802110a7bc$exports.renderWebChat = $497baa802110a7bc$var$renderWebChat;
var $497baa802110a7bc$var$createDirectLine = function createDirectLine(options) {
    options.botAgent && console.warn("Web Chat: Developers are not currently allowed to set botAgent. See https://github.com/microsoft/BotFramework-WebChat/issues/2119 for more details.");
    return (0, $497baa802110a7bc$var$_createDirectLine.default)($497baa802110a7bc$var$_objectSpread($497baa802110a7bc$var$_objectSpread({}, options), {}, {
        botAgent: "WebChat/".concat($8fbe9fb13c033bfd$exports.version, " (Full)")
    }));
};
$497baa802110a7bc$exports.createDirectLine = $497baa802110a7bc$var$createDirectLine;
var $497baa802110a7bc$var$createDirectLineAppServiceExtension = function createDirectLineAppServiceExtension(options) {
    options.botAgent && console.warn("Web Chat: Developers are not currently allowed to set botAgent. See https://github.com/microsoft/BotFramework-WebChat/issues/2119 for more details.");
    return (0, $497baa802110a7bc$var$_createDirectLineAppServiceExtension.default)($497baa802110a7bc$var$_objectSpread($497baa802110a7bc$var$_objectSpread({}, options), {}, {
        botAgent: "WebChat/".concat($8fbe9fb13c033bfd$exports.version, " (Full)")
    }));
};
$497baa802110a7bc$exports.createDirectLineAppServiceExtension = $497baa802110a7bc$var$createDirectLineAppServiceExtension;
var $497baa802110a7bc$var$patchedHooks = $497baa802110a7bc$var$_objectSpread($497baa802110a7bc$var$_objectSpread({}, $8fbe9fb13c033bfd$exports.hooks), {}, {
    useAdaptiveCardsHostConfig: $497baa802110a7bc$var$_useAdaptiveCardsHostConfig.default,
    useAdaptiveCardsPackage: $497baa802110a7bc$var$_useAdaptiveCardsPackage.default,
    useStyleOptions: $497baa802110a7bc$var$_useStyleOptions.default
});
$497baa802110a7bc$exports.hooks = $497baa802110a7bc$var$patchedHooks;
var $497baa802110a7bc$var$AdditionalComponents = {
    AdaptiveCardContent: $497baa802110a7bc$var$_AdaptiveCardContent.default,
    AnimationCardContent: $497baa802110a7bc$var$_AnimationCardContent.default,
    AudioCardContent: $497baa802110a7bc$var$_AudioCardContent.default,
    Composer: $497baa802110a7bc$var$_FullComposer.default,
    HeroCardContent: $497baa802110a7bc$var$_HeroCardContent.default,
    OAuthCardContent: $497baa802110a7bc$var$_OAuthCardContent.default,
    ReceiptCardContent: $497baa802110a7bc$var$_ReceiptCardContent.default,
    SignInCardContent: $497baa802110a7bc$var$_SignInCardContent.default,
    ThumbnailCardContent: $497baa802110a7bc$var$_ThumbnailCardContent.default,
    VideoCardContent: $497baa802110a7bc$var$_VideoCardContent.default
};
var $497baa802110a7bc$var$Components = $497baa802110a7bc$var$_objectSpread($497baa802110a7bc$var$_objectSpread({}, $8fbe9fb13c033bfd$exports.Components), $497baa802110a7bc$var$AdditionalComponents);
$497baa802110a7bc$exports.Components = $497baa802110a7bc$var$Components;
var $497baa802110a7bc$var$_default = $497baa802110a7bc$var$_FullReactWebChat.default;
$497baa802110a7bc$exports.default = $497baa802110a7bc$var$_default;
window["WebChat"] = $497baa802110a7bc$var$_objectSpread($497baa802110a7bc$var$_objectSpread({}, window["WebChat"]), {}, {
    Components: $497baa802110a7bc$var$Components,
    createAdaptiveCardsAttachmentMiddleware: $497baa802110a7bc$var$_createAdaptiveCardsAttachmentMiddleware.default,
    createAdaptiveCardsAttachmentForScreenReaderMiddleware: $497baa802110a7bc$var$_createAdaptiveCardsAttachmentForScreenReaderMiddleware.default,
    createCognitiveServicesSpeechServicesPonyfillFactory: $497baa802110a7bc$var$_createCognitiveServicesSpeechServicesPonyfillFactory.default,
    createDirectLine: $497baa802110a7bc$var$createDirectLine,
    createDirectLineAppServiceExtension: $497baa802110a7bc$var$createDirectLineAppServiceExtension,
    createDirectLineSpeechAdapters: $497baa802110a7bc$var$_createDirectLineSpeechAdapters.default,
    createStyleSet: $497baa802110a7bc$var$_createFullStyleSet.default,
    hooks: $497baa802110a7bc$var$patchedHooks,
    ReactWebChat: $497baa802110a7bc$var$_FullReactWebChat.default,
    renderMarkdown: $497baa802110a7bc$var$_renderMarkdown.default,
    renderWebChat: $497baa802110a7bc$var$renderWebChat
});
(0, $497baa802110a7bc$var$_addVersion.default)("full");



var $caYbs = parcelRequire("caYbs");


const $519f31eef1fe5fca$var$processPrefix = (prefix)=>{
    switch(prefix){
        case "dev":
            return 0, $674f1d59bae686ab$export$9adff68f093278ec;
        case "staging":
        case "preview":
            return 0, $674f1d59bae686ab$export$409889737849a04f;
        case "experimental":
            return 0, $674f1d59bae686ab$export$a4481ccc388fce2a;
        default:
            return 0, $674f1d59bae686ab$export$c398bfda6cfa19ff;
    }
};
var $519f31eef1fe5fca$export$2e2bcd8739ae039 = $519f31eef1fe5fca$var$processPrefix;


async function $487d6caaad26fd47$export$2ce265f68d021d6(key) {
    const data = {
        method: "POST",
        headers: {
            Authorization: `Bearer ${key}`
        }
    };
    const res = await fetch("https://directline.botframework.com/v3/directline/tokens/generate", data);
    const { token: token } = await res.json();
    return token;
}
async function $487d6caaad26fd47$export$97c24bbbbbd7be8a(data) {
    // baseURI is used for retrocompatibility
    let fullAddress = "";
    if (data.baseURI) fullAddress = data.baseURI;
    else fullAddress = `${(0, $519f31eef1fe5fca$export$2e2bcd8739ae039)(data.prefix)}/${data.tenant}/${0, $674f1d59bae686ab$export$d9e38c0112bbdae6}`;
    const res = await fetch(fullAddress);
    const token = await res.json();
    return token;
}



var $d452087480f7647a$exports = {};

$parcel$export($d452087480f7647a$exports, "create", () => $d452087480f7647a$export$185802fd694ee1f5, (v) => $d452087480f7647a$export$185802fd694ee1f5 = v);
$parcel$export($d452087480f7647a$exports, "toCanvas", () => $d452087480f7647a$export$f87f6982d1fd4f81, (v) => $d452087480f7647a$export$f87f6982d1fd4f81 = v);
$parcel$export($d452087480f7647a$exports, "toDataURL", () => $d452087480f7647a$export$723e4939e5a27c8, (v) => $d452087480f7647a$export$723e4939e5a27c8 = v);
$parcel$export($d452087480f7647a$exports, "toString", () => $d452087480f7647a$export$f84e8e69fd4488a5, (v) => $d452087480f7647a$export$f84e8e69fd4488a5 = v);
var $d452087480f7647a$export$185802fd694ee1f5;
var $d452087480f7647a$export$f87f6982d1fd4f81;
var $d452087480f7647a$export$723e4939e5a27c8;
// only svg for now.
var $d452087480f7647a$export$f84e8e69fd4488a5;
var $a9657f3e8f777016$exports = {};
// can-promise has a crash in some versions of react native that dont have
// standard global objects
// https://github.com/soldair/node-qrcode/issues/157
$a9657f3e8f777016$exports = function() {
    return typeof Promise === "function" && Promise.prototype && Promise.prototype.then;
};


/**
 * QR Code
 *
 * @param {String | Array} data                 Input data
 * @param {Object} options                      Optional configurations
 * @param {Number} options.version              QR Code version
 * @param {String} options.errorCorrectionLevel Error correction level
 * @param {Function} options.toSJISFunc         Helper func to convert utf8 to sjis
 */ var $c412bf950f65ef05$export$185802fd694ee1f5;
/**
 * Returns the QR Code size for the specified version
 *
 * @param  {Number} version QR Code version
 * @return {Number}         size of QR code
 */ var $ae0eaf7ed71e598d$export$8d4a06d3facd414b;
/**
 * Returns the total number of codewords used to store data and EC information.
 *
 * @param  {Number} version QR Code version
 * @return {Number}         Data length in bits
 */ var $ae0eaf7ed71e598d$export$b05dac13c7a35c32;
/**
 * Encode data with Bose-Chaudhuri-Hocquenghem
 *
 * @param  {Number} data Value to encode
 * @return {Number}      Encoded value
 */ var $ae0eaf7ed71e598d$export$ed1d66da50968976;
var $ae0eaf7ed71e598d$export$6733b14783f975c2;
var $ae0eaf7ed71e598d$export$ce5b1274f8597fa0;
var $ae0eaf7ed71e598d$export$43dd553ecded716d;
let $ae0eaf7ed71e598d$var$toSJISFunction;
const $ae0eaf7ed71e598d$var$CODEWORDS_COUNT = [
    0,
    26,
    44,
    70,
    100,
    134,
    172,
    196,
    242,
    292,
    346,
    404,
    466,
    532,
    581,
    655,
    733,
    815,
    901,
    991,
    1085,
    1156,
    1258,
    1364,
    1474,
    1588,
    1706,
    1828,
    1921,
    2051,
    2185,
    2323,
    2465,
    2611,
    2761,
    2876,
    3034,
    3196,
    3362,
    3532,
    3706
];
$ae0eaf7ed71e598d$export$8d4a06d3facd414b = function getSymbolSize(version) {
    if (!version) throw new Error('"version" cannot be null or undefined');
    if (version < 1 || version > 40) throw new Error('"version" should be in range from 1 to 40');
    return version * 4 + 17;
};
$ae0eaf7ed71e598d$export$b05dac13c7a35c32 = function getSymbolTotalCodewords(version) {
    return $ae0eaf7ed71e598d$var$CODEWORDS_COUNT[version];
};
$ae0eaf7ed71e598d$export$ed1d66da50968976 = function(data) {
    let digit = 0;
    while(data !== 0){
        digit++;
        data >>>= 1;
    }
    return digit;
};
$ae0eaf7ed71e598d$export$6733b14783f975c2 = function setToSJISFunction(f) {
    if (typeof f !== "function") throw new Error('"toSJISFunc" is not a valid function.');
    $ae0eaf7ed71e598d$var$toSJISFunction = f;
};
$ae0eaf7ed71e598d$export$ce5b1274f8597fa0 = function() {
    return typeof $ae0eaf7ed71e598d$var$toSJISFunction !== "undefined";
};
$ae0eaf7ed71e598d$export$43dd553ecded716d = function toSJIS(kanji) {
    return $ae0eaf7ed71e598d$var$toSJISFunction(kanji);
};


var $85200a578c5005f7$export$61196ced6d74a310;
var $85200a578c5005f7$export$3a1a48c8f6ef640e;
var $85200a578c5005f7$export$3722cfe417b6ed86;
var $85200a578c5005f7$export$7f8ddf7c7c20b3cd;
var $85200a578c5005f7$export$1ea939691cdc45b8;
var $85200a578c5005f7$export$6788812c4e6611e6;
$85200a578c5005f7$export$61196ced6d74a310 = {
    bit: 1
};
$85200a578c5005f7$export$3a1a48c8f6ef640e = {
    bit: 0
};
$85200a578c5005f7$export$3722cfe417b6ed86 = {
    bit: 3
};
$85200a578c5005f7$export$7f8ddf7c7c20b3cd = {
    bit: 2
};
function $85200a578c5005f7$var$fromString(string) {
    if (typeof string !== "string") throw new Error("Param is not a string");
    const lcStr = string.toLowerCase();
    switch(lcStr){
        case "l":
        case "low":
            return $85200a578c5005f7$export$61196ced6d74a310;
        case "m":
        case "medium":
            return $85200a578c5005f7$export$3a1a48c8f6ef640e;
        case "q":
        case "quartile":
            return $85200a578c5005f7$export$3722cfe417b6ed86;
        case "h":
        case "high":
            return $85200a578c5005f7$export$7f8ddf7c7c20b3cd;
        default:
            throw new Error("Unknown EC Level: " + string);
    }
}
$85200a578c5005f7$export$1ea939691cdc45b8 = function isValid(level) {
    return level && typeof level.bit !== "undefined" && level.bit >= 0 && level.bit < 4;
};
$85200a578c5005f7$export$6788812c4e6611e6 = function from(value, defaultValue) {
    if ($85200a578c5005f7$export$1ea939691cdc45b8(value)) return value;
    try {
        return $85200a578c5005f7$var$fromString(value);
    } catch (e) {
        return defaultValue;
    }
};


var $826a8c47eb337ba0$exports = {};
function $826a8c47eb337ba0$var$BitBuffer() {
    this.buffer = [];
    this.length = 0;
}
$826a8c47eb337ba0$var$BitBuffer.prototype = {
    get: function(index) {
        const bufIndex = Math.floor(index / 8);
        return (this.buffer[bufIndex] >>> 7 - index % 8 & 1) === 1;
    },
    put: function(num, length) {
        for(let i = 0; i < length; i++)this.putBit((num >>> length - i - 1 & 1) === 1);
    },
    getLengthInBits: function() {
        return this.length;
    },
    putBit: function(bit) {
        const bufIndex = Math.floor(this.length / 8);
        if (this.buffer.length <= bufIndex) this.buffer.push(0);
        if (bit) this.buffer[bufIndex] |= 0x80 >>> this.length % 8;
        this.length++;
    }
};
$826a8c47eb337ba0$exports = $826a8c47eb337ba0$var$BitBuffer;


var $a97ef3070731feca$exports = {};
/**
 * Helper class to handle QR Code symbol modules
 *
 * @param {Number} size Symbol size
 */ function $a97ef3070731feca$var$BitMatrix(size) {
    if (!size || size < 1) throw new Error("BitMatrix size must be defined and greater than 0");
    this.size = size;
    this.data = new Uint8Array(size * size);
    this.reservedBit = new Uint8Array(size * size);
}
/**
 * Set bit value at specified location
 * If reserved flag is set, this bit will be ignored during masking process
 *
 * @param {Number}  row
 * @param {Number}  col
 * @param {Boolean} value
 * @param {Boolean} reserved
 */ $a97ef3070731feca$var$BitMatrix.prototype.set = function(row, col, value, reserved) {
    const index = row * this.size + col;
    this.data[index] = value;
    if (reserved) this.reservedBit[index] = true;
};
/**
 * Returns bit value at specified location
 *
 * @param  {Number}  row
 * @param  {Number}  col
 * @return {Boolean}
 */ $a97ef3070731feca$var$BitMatrix.prototype.get = function(row, col) {
    return this.data[row * this.size + col];
};
/**
 * Applies xor operator at specified location
 * (used during masking process)
 *
 * @param {Number}  row
 * @param {Number}  col
 * @param {Boolean} value
 */ $a97ef3070731feca$var$BitMatrix.prototype.xor = function(row, col, value) {
    this.data[row * this.size + col] ^= value;
};
/**
 * Check if bit at specified location is reserved
 *
 * @param {Number}   row
 * @param {Number}   col
 * @return {Boolean}
 */ $a97ef3070731feca$var$BitMatrix.prototype.isReserved = function(row, col) {
    return this.reservedBit[row * this.size + col];
};
$a97ef3070731feca$exports = $a97ef3070731feca$var$BitMatrix;


/**
 * Alignment pattern are fixed reference pattern in defined positions
 * in a matrix symbology, which enables the decode software to re-synchronise
 * the coordinate mapping of the image modules in the event of moderate amounts
 * of distortion of the image.
 *
 * Alignment patterns are present only in QR Code symbols of version 2 or larger
 * and their number depends on the symbol version.
 */ /**
 * Calculate the row/column coordinates of the center module of each alignment pattern
 * for the specified QR Code version.
 *
 * The alignment patterns are positioned symmetrically on either side of the diagonal
 * running from the top left corner of the symbol to the bottom right corner.
 *
 * Since positions are simmetrical only half of the coordinates are returned.
 * Each item of the array will represent in turn the x and y coordinate.
 * @see {@link getPositions}
 *
 * @param  {Number} version QR Code version
 * @return {Array}          Array of coordinate
 */ var $f3200cae265fe7a0$export$cb05537eb8e57a83;
/**
 * Returns an array containing the positions of each alignment pattern.
 * Each array's element represent the center point of the pattern as (x, y) coordinates
 *
 * Coordinates are calculated expanding the row/column coordinates returned by {@link getRowColCoords}
 * and filtering out the items that overlaps with finder pattern
 *
 * @example
 * For a Version 7 symbol {@link getRowColCoords} returns values 6, 22 and 38.
 * The alignment patterns, therefore, are to be centered on (row, column)
 * positions (6,22), (22,6), (22,22), (22,38), (38,22), (38,38).
 * Note that the coordinates (6,6), (6,38), (38,6) are occupied by finder patterns
 * and are not therefore used for alignment patterns.
 *
 * let pos = getPositions(7)
 * // [[6,22], [22,6], [22,22], [22,38], [38,22], [38,38]]
 *
 * @param  {Number} version QR Code version
 * @return {Array}          Array of coordinates
 */ var $f3200cae265fe7a0$export$c39457c570f2b189;

var $f3200cae265fe7a0$require$getSymbolSize = $ae0eaf7ed71e598d$export$8d4a06d3facd414b;
$f3200cae265fe7a0$export$cb05537eb8e57a83 = function getRowColCoords(version) {
    if (version === 1) return [];
    const posCount = Math.floor(version / 7) + 2;
    const size = $f3200cae265fe7a0$require$getSymbolSize(version);
    const intervals = size === 145 ? 26 : Math.ceil((size - 13) / (2 * posCount - 2)) * 2;
    const positions = [
        size - 7
    ] // Last coord is always (size - 7)
    ;
    for(let i = 1; i < posCount - 1; i++)positions[i] = positions[i - 1] - intervals;
    positions.push(6) // First coord is always 6
    ;
    return positions.reverse();
};
$f3200cae265fe7a0$export$c39457c570f2b189 = function getPositions(version) {
    const coords = [];
    const pos = $f3200cae265fe7a0$export$cb05537eb8e57a83(version);
    const posLength = pos.length;
    for(let i = 0; i < posLength; i++)for(let j = 0; j < posLength; j++){
        // Skip if position is occupied by finder patterns
        if (i === 0 && j === 0 || // top-left
        i === 0 && j === posLength - 1 || // bottom-left
        i === posLength - 1 && j === 0) continue;
        coords.push([
            pos[i],
            pos[j]
        ]);
    }
    return coords;
};


/**
 * Returns an array containing the positions of each finder pattern.
 * Each array's element represent the top-left point of the pattern as (x, y) coordinates
 *
 * @param  {Number} version QR Code version
 * @return {Array}          Array of coordinates
 */ var $84e24b233d358480$export$c39457c570f2b189;

var $84e24b233d358480$require$getSymbolSize = $ae0eaf7ed71e598d$export$8d4a06d3facd414b;
const $84e24b233d358480$var$FINDER_PATTERN_SIZE = 7;
$84e24b233d358480$export$c39457c570f2b189 = function getPositions(version) {
    const size = $84e24b233d358480$require$getSymbolSize(version);
    return [
        // top-left
        [
            0,
            0
        ],
        // top-right
        [
            size - $84e24b233d358480$var$FINDER_PATTERN_SIZE,
            0
        ],
        // bottom-left
        [
            0,
            size - $84e24b233d358480$var$FINDER_PATTERN_SIZE
        ]
    ];
};


/**
 * Data mask pattern reference
 * @type {Object}
 */ var $d9a5de0035d34ab3$export$7ed115685df827af;
/**
 * Check if mask pattern value is valid
 *
 * @param  {Number}  mask    Mask pattern
 * @return {Boolean}         true if valid, false otherwise
 */ var $d9a5de0035d34ab3$export$1ea939691cdc45b8;
/**
 * Returns mask pattern from a value.
 * If value is not valid, returns undefined
 *
 * @param  {Number|String} value        Mask pattern value
 * @return {Number}                     Valid mask pattern or undefined
 */ var $d9a5de0035d34ab3$export$6788812c4e6611e6;
/**
* Find adjacent modules in row/column with the same color
* and assign a penalty value.
*
* Points: N1 + i
* i is the amount by which the number of adjacent modules of the same color exceeds 5
*/ var $d9a5de0035d34ab3$export$a5fd3a02c14d0b3e;
/**
 * Find 2x2 blocks with the same color and assign a penalty value
 *
 * Points: N2 * (m - 1) * (n - 1)
 */ var $d9a5de0035d34ab3$export$9a9385107a518e46;
/**
 * Find 1:1:3:1:1 ratio (dark:light:dark:light:dark) pattern in row/column,
 * preceded or followed by light area 4 modules wide
 *
 * Points: N3 * number of pattern found
 */ var $d9a5de0035d34ab3$export$ade754353f0dc75e;
/**
 * Calculate proportion of dark modules in entire symbol
 *
 * Points: N4 * k
 *
 * k is the rating of the deviation of the proportion of dark modules
 * in the symbol from 50% in steps of 5%
 */ var $d9a5de0035d34ab3$export$3ff6f04d40d9962b;
/**
 * Apply a mask pattern to a BitMatrix
 *
 * @param  {Number}    pattern Pattern reference number
 * @param  {BitMatrix} data    BitMatrix data
 */ var $d9a5de0035d34ab3$export$a1c9aa9c0e8ba394;
/**
 * Returns the best mask pattern for data
 *
 * @param  {BitMatrix} data
 * @return {Number} Mask pattern reference number
 */ var $d9a5de0035d34ab3$export$fe9625aaceb0e563;
$d9a5de0035d34ab3$export$7ed115685df827af = {
    PATTERN000: 0,
    PATTERN001: 1,
    PATTERN010: 2,
    PATTERN011: 3,
    PATTERN100: 4,
    PATTERN101: 5,
    PATTERN110: 6,
    PATTERN111: 7
};
/**
 * Weighted penalty scores for the undesirable features
 * @type {Object}
 */ const $d9a5de0035d34ab3$var$PenaltyScores = {
    N1: 3,
    N2: 3,
    N3: 40,
    N4: 10
};
$d9a5de0035d34ab3$export$1ea939691cdc45b8 = function isValid(mask) {
    return mask != null && mask !== "" && !isNaN(mask) && mask >= 0 && mask <= 7;
};
$d9a5de0035d34ab3$export$6788812c4e6611e6 = function from(value) {
    return $d9a5de0035d34ab3$export$1ea939691cdc45b8(value) ? parseInt(value, 10) : undefined;
};
$d9a5de0035d34ab3$export$a5fd3a02c14d0b3e = function getPenaltyN1(data) {
    const size = data.size;
    let points = 0;
    let sameCountCol = 0;
    let sameCountRow = 0;
    let lastCol = null;
    let lastRow = null;
    for(let row = 0; row < size; row++){
        sameCountCol = sameCountRow = 0;
        lastCol = lastRow = null;
        for(let col = 0; col < size; col++){
            let module = data.get(row, col);
            if (module === lastCol) sameCountCol++;
            else {
                if (sameCountCol >= 5) points += $d9a5de0035d34ab3$var$PenaltyScores.N1 + (sameCountCol - 5);
                lastCol = module;
                sameCountCol = 1;
            }
            module = data.get(col, row);
            if (module === lastRow) sameCountRow++;
            else {
                if (sameCountRow >= 5) points += $d9a5de0035d34ab3$var$PenaltyScores.N1 + (sameCountRow - 5);
                lastRow = module;
                sameCountRow = 1;
            }
        }
        if (sameCountCol >= 5) points += $d9a5de0035d34ab3$var$PenaltyScores.N1 + (sameCountCol - 5);
        if (sameCountRow >= 5) points += $d9a5de0035d34ab3$var$PenaltyScores.N1 + (sameCountRow - 5);
    }
    return points;
};
$d9a5de0035d34ab3$export$9a9385107a518e46 = function getPenaltyN2(data) {
    const size = data.size;
    let points = 0;
    for(let row = 0; row < size - 1; row++)for(let col = 0; col < size - 1; col++){
        const last = data.get(row, col) + data.get(row, col + 1) + data.get(row + 1, col) + data.get(row + 1, col + 1);
        if (last === 4 || last === 0) points++;
    }
    return points * $d9a5de0035d34ab3$var$PenaltyScores.N2;
};
$d9a5de0035d34ab3$export$ade754353f0dc75e = function getPenaltyN3(data) {
    const size = data.size;
    let points = 0;
    let bitsCol = 0;
    let bitsRow = 0;
    for(let row = 0; row < size; row++){
        bitsCol = bitsRow = 0;
        for(let col = 0; col < size; col++){
            bitsCol = bitsCol << 1 & 0x7FF | data.get(row, col);
            if (col >= 10 && (bitsCol === 0x5D0 || bitsCol === 0x05D)) points++;
            bitsRow = bitsRow << 1 & 0x7FF | data.get(col, row);
            if (col >= 10 && (bitsRow === 0x5D0 || bitsRow === 0x05D)) points++;
        }
    }
    return points * $d9a5de0035d34ab3$var$PenaltyScores.N3;
};
$d9a5de0035d34ab3$export$3ff6f04d40d9962b = function getPenaltyN4(data) {
    let darkCount = 0;
    const modulesCount = data.data.length;
    for(let i = 0; i < modulesCount; i++)darkCount += data.data[i];
    const k = Math.abs(Math.ceil(darkCount * 100 / modulesCount / 5) - 10);
    return k * $d9a5de0035d34ab3$var$PenaltyScores.N4;
};
/**
 * Return mask value at given position
 *
 * @param  {Number} maskPattern Pattern reference value
 * @param  {Number} i           Row
 * @param  {Number} j           Column
 * @return {Boolean}            Mask value
 */ function $d9a5de0035d34ab3$var$getMaskAt(maskPattern, i, j) {
    switch(maskPattern){
        case $d9a5de0035d34ab3$export$7ed115685df827af.PATTERN000:
            return (i + j) % 2 === 0;
        case $d9a5de0035d34ab3$export$7ed115685df827af.PATTERN001:
            return i % 2 === 0;
        case $d9a5de0035d34ab3$export$7ed115685df827af.PATTERN010:
            return j % 3 === 0;
        case $d9a5de0035d34ab3$export$7ed115685df827af.PATTERN011:
            return (i + j) % 3 === 0;
        case $d9a5de0035d34ab3$export$7ed115685df827af.PATTERN100:
            return (Math.floor(i / 2) + Math.floor(j / 3)) % 2 === 0;
        case $d9a5de0035d34ab3$export$7ed115685df827af.PATTERN101:
            return i * j % 2 + i * j % 3 === 0;
        case $d9a5de0035d34ab3$export$7ed115685df827af.PATTERN110:
            return (i * j % 2 + i * j % 3) % 2 === 0;
        case $d9a5de0035d34ab3$export$7ed115685df827af.PATTERN111:
            return (i * j % 3 + (i + j) % 2) % 2 === 0;
        default:
            throw new Error("bad maskPattern:" + maskPattern);
    }
}
$d9a5de0035d34ab3$export$a1c9aa9c0e8ba394 = function applyMask(pattern, data) {
    const size = data.size;
    for(let col = 0; col < size; col++)for(let row = 0; row < size; row++){
        if (data.isReserved(row, col)) continue;
        data.xor(row, col, $d9a5de0035d34ab3$var$getMaskAt(pattern, row, col));
    }
};
$d9a5de0035d34ab3$export$fe9625aaceb0e563 = function getBestMask(data, setupFormatFunc) {
    const numPatterns = Object.keys($d9a5de0035d34ab3$export$7ed115685df827af).length;
    let bestPattern = 0;
    let lowerPenalty = Infinity;
    for(let p = 0; p < numPatterns; p++){
        setupFormatFunc(p);
        $d9a5de0035d34ab3$export$a1c9aa9c0e8ba394(p, data);
        // Calculate penalty
        const penalty = $d9a5de0035d34ab3$export$a5fd3a02c14d0b3e(data) + $d9a5de0035d34ab3$export$9a9385107a518e46(data) + $d9a5de0035d34ab3$export$ade754353f0dc75e(data) + $d9a5de0035d34ab3$export$3ff6f04d40d9962b(data);
        // Undo previously applied mask
        $d9a5de0035d34ab3$export$a1c9aa9c0e8ba394(p, data);
        if (penalty < lowerPenalty) {
            lowerPenalty = penalty;
            bestPattern = p;
        }
    }
    return bestPattern;
};


/**
 * Returns the number of error correction block that the QR Code should contain
 * for the specified version and error correction level.
 *
 * @param  {Number} version              QR Code version
 * @param  {Number} errorCorrectionLevel Error correction level
 * @return {Number}                      Number of error correction blocks
 */ var $163ea6b830a815e3$export$41a1fc627aca72b9;
/**
 * Returns the number of error correction codewords to use for the specified
 * version and error correction level.
 *
 * @param  {Number} version              QR Code version
 * @param  {Number} errorCorrectionLevel Error correction level
 * @return {Number}                      Number of error correction codewords
 */ var $163ea6b830a815e3$export$683d1b3e8a1a8438;

const $163ea6b830a815e3$var$EC_BLOCKS_TABLE = [
    // L  M  Q  H
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    2,
    2,
    1,
    2,
    2,
    4,
    1,
    2,
    4,
    4,
    2,
    4,
    4,
    4,
    2,
    4,
    6,
    5,
    2,
    4,
    6,
    6,
    2,
    5,
    8,
    8,
    4,
    5,
    8,
    8,
    4,
    5,
    8,
    11,
    4,
    8,
    10,
    11,
    4,
    9,
    12,
    16,
    4,
    9,
    16,
    16,
    6,
    10,
    12,
    18,
    6,
    10,
    17,
    16,
    6,
    11,
    16,
    19,
    6,
    13,
    18,
    21,
    7,
    14,
    21,
    25,
    8,
    16,
    20,
    25,
    8,
    17,
    23,
    25,
    9,
    17,
    23,
    34,
    9,
    18,
    25,
    30,
    10,
    20,
    27,
    32,
    12,
    21,
    29,
    35,
    12,
    23,
    34,
    37,
    12,
    25,
    34,
    40,
    13,
    26,
    35,
    42,
    14,
    28,
    38,
    45,
    15,
    29,
    40,
    48,
    16,
    31,
    43,
    51,
    17,
    33,
    45,
    54,
    18,
    35,
    48,
    57,
    19,
    37,
    51,
    60,
    19,
    38,
    53,
    63,
    20,
    40,
    56,
    66,
    21,
    43,
    59,
    70,
    22,
    45,
    62,
    74,
    24,
    47,
    65,
    77,
    25,
    49,
    68,
    81
];
const $163ea6b830a815e3$var$EC_CODEWORDS_TABLE = [
    // L  M  Q  H
    7,
    10,
    13,
    17,
    10,
    16,
    22,
    28,
    15,
    26,
    36,
    44,
    20,
    36,
    52,
    64,
    26,
    48,
    72,
    88,
    36,
    64,
    96,
    112,
    40,
    72,
    108,
    130,
    48,
    88,
    132,
    156,
    60,
    110,
    160,
    192,
    72,
    130,
    192,
    224,
    80,
    150,
    224,
    264,
    96,
    176,
    260,
    308,
    104,
    198,
    288,
    352,
    120,
    216,
    320,
    384,
    132,
    240,
    360,
    432,
    144,
    280,
    408,
    480,
    168,
    308,
    448,
    532,
    180,
    338,
    504,
    588,
    196,
    364,
    546,
    650,
    224,
    416,
    600,
    700,
    224,
    442,
    644,
    750,
    252,
    476,
    690,
    816,
    270,
    504,
    750,
    900,
    300,
    560,
    810,
    960,
    312,
    588,
    870,
    1050,
    336,
    644,
    952,
    1110,
    360,
    700,
    1020,
    1200,
    390,
    728,
    1050,
    1260,
    420,
    784,
    1140,
    1350,
    450,
    812,
    1200,
    1440,
    480,
    868,
    1290,
    1530,
    510,
    924,
    1350,
    1620,
    540,
    980,
    1440,
    1710,
    570,
    1036,
    1530,
    1800,
    570,
    1064,
    1590,
    1890,
    600,
    1120,
    1680,
    1980,
    630,
    1204,
    1770,
    2100,
    660,
    1260,
    1860,
    2220,
    720,
    1316,
    1950,
    2310,
    750,
    1372,
    2040,
    2430
];
$163ea6b830a815e3$export$41a1fc627aca72b9 = function getBlocksCount(version, errorCorrectionLevel) {
    switch(errorCorrectionLevel){
        case $85200a578c5005f7$export$61196ced6d74a310:
            return $163ea6b830a815e3$var$EC_BLOCKS_TABLE[(version - 1) * 4 + 0];
        case $85200a578c5005f7$export$3a1a48c8f6ef640e:
            return $163ea6b830a815e3$var$EC_BLOCKS_TABLE[(version - 1) * 4 + 1];
        case $85200a578c5005f7$export$3722cfe417b6ed86:
            return $163ea6b830a815e3$var$EC_BLOCKS_TABLE[(version - 1) * 4 + 2];
        case $85200a578c5005f7$export$7f8ddf7c7c20b3cd:
            return $163ea6b830a815e3$var$EC_BLOCKS_TABLE[(version - 1) * 4 + 3];
        default:
            return undefined;
    }
};
$163ea6b830a815e3$export$683d1b3e8a1a8438 = function getTotalCodewordsCount(version, errorCorrectionLevel) {
    switch(errorCorrectionLevel){
        case $85200a578c5005f7$export$61196ced6d74a310:
            return $163ea6b830a815e3$var$EC_CODEWORDS_TABLE[(version - 1) * 4 + 0];
        case $85200a578c5005f7$export$3a1a48c8f6ef640e:
            return $163ea6b830a815e3$var$EC_CODEWORDS_TABLE[(version - 1) * 4 + 1];
        case $85200a578c5005f7$export$3722cfe417b6ed86:
            return $163ea6b830a815e3$var$EC_CODEWORDS_TABLE[(version - 1) * 4 + 2];
        case $85200a578c5005f7$export$7f8ddf7c7c20b3cd:
            return $163ea6b830a815e3$var$EC_CODEWORDS_TABLE[(version - 1) * 4 + 3];
        default:
            return undefined;
    }
};


var $e5968549bd660bd4$exports = {};
/**
 * Multiplies two polynomials inside Galois Field
 *
 * @param  {Uint8Array} p1 Polynomial
 * @param  {Uint8Array} p2 Polynomial
 * @return {Uint8Array}    Product of p1 and p2
 */ var $64ba10da07b8a690$export$6e3a27864ab166fe;
/**
 * Calculate the remainder of polynomials division
 *
 * @param  {Uint8Array} divident Polynomial
 * @param  {Uint8Array} divisor  Polynomial
 * @return {Uint8Array}          Remainder
 */ var $64ba10da07b8a690$export$842a2cf37af977e1;
/**
 * Generate an irreducible generator polynomial of specified degree
 * (used by Reed-Solomon encoder)
 *
 * @param  {Number} degree Degree of the generator polynomial
 * @return {Uint8Array}    Buffer containing polynomial coefficients
 */ var $64ba10da07b8a690$export$7b8be06a973a9d05;
/**
 * Returns log value of n inside Galois Field
 *
 * @param  {Number} n
 * @return {Number}
 */ var $ed0fcbbe142c895d$export$bef1f36f5486a6a3;
/**
 * Returns anti-log value of n inside Galois Field
 *
 * @param  {Number} n
 * @return {Number}
 */ var $ed0fcbbe142c895d$export$b310ec824aaee37f;
/**
 * Multiplies two number inside Galois Field
 *
 * @param  {Number} x
 * @param  {Number} y
 * @return {Number}
 */ var $ed0fcbbe142c895d$export$6e3a27864ab166fe;
const $ed0fcbbe142c895d$var$EXP_TABLE = new Uint8Array(512);
const $ed0fcbbe142c895d$var$LOG_TABLE = new Uint8Array(256) /**
 * Precompute the log and anti-log tables for faster computation later
 *
 * For each possible value in the galois field 2^8, we will pre-compute
 * the logarithm and anti-logarithm (exponential) of this value
 *
 * ref {@link https://en.wikiversity.org/wiki/Reed%E2%80%93Solomon_codes_for_coders#Introduction_to_mathematical_fields}
 */ ;
(function initTables() {
    let x = 1;
    for(let i = 0; i < 255; i++){
        $ed0fcbbe142c895d$var$EXP_TABLE[i] = x;
        $ed0fcbbe142c895d$var$LOG_TABLE[x] = i;
        x <<= 1 // multiply by 2
        ;
        // The QR code specification says to use byte-wise modulo 100011101 arithmetic.
        // This means that when a number is 256 or larger, it should be XORed with 0x11D.
        if (x & 0x100) x ^= 0x11D;
    }
    // Optimization: double the size of the anti-log table so that we don't need to mod 255 to
    // stay inside the bounds (because we will mainly use this table for the multiplication of
    // two GF numbers, no more).
    // @see {@link mul}
    for(let i = 255; i < 512; i++)$ed0fcbbe142c895d$var$EXP_TABLE[i] = $ed0fcbbe142c895d$var$EXP_TABLE[i - 255];
})();
$ed0fcbbe142c895d$export$bef1f36f5486a6a3 = function log(n) {
    if (n < 1) throw new Error("log(" + n + ")");
    return $ed0fcbbe142c895d$var$LOG_TABLE[n];
};
$ed0fcbbe142c895d$export$b310ec824aaee37f = function exp(n) {
    return $ed0fcbbe142c895d$var$EXP_TABLE[n];
};
$ed0fcbbe142c895d$export$6e3a27864ab166fe = function mul(x, y) {
    if (x === 0 || y === 0) return 0;
    // should be EXP_TABLE[(LOG_TABLE[x] + LOG_TABLE[y]) % 255] if EXP_TABLE wasn't oversized
    // @see {@link initTables}
    return $ed0fcbbe142c895d$var$EXP_TABLE[$ed0fcbbe142c895d$var$LOG_TABLE[x] + $ed0fcbbe142c895d$var$LOG_TABLE[y]];
};


$64ba10da07b8a690$export$6e3a27864ab166fe = function mul(p1, p2) {
    const coeff = new Uint8Array(p1.length + p2.length - 1);
    for(let i = 0; i < p1.length; i++)for(let j = 0; j < p2.length; j++)coeff[i + j] ^= $ed0fcbbe142c895d$export$6e3a27864ab166fe(p1[i], p2[j]);
    return coeff;
};
$64ba10da07b8a690$export$842a2cf37af977e1 = function mod(divident, divisor) {
    let result = new Uint8Array(divident);
    while(result.length - divisor.length >= 0){
        const coeff = result[0];
        for(let i = 0; i < divisor.length; i++)result[i] ^= $ed0fcbbe142c895d$export$6e3a27864ab166fe(divisor[i], coeff);
        // remove all zeros from buffer head
        let offset = 0;
        while(offset < result.length && result[offset] === 0)offset++;
        result = result.slice(offset);
    }
    return result;
};
$64ba10da07b8a690$export$7b8be06a973a9d05 = function generateECPolynomial(degree) {
    let poly = new Uint8Array([
        1
    ]);
    for(let i = 0; i < degree; i++)poly = $64ba10da07b8a690$export$6e3a27864ab166fe(poly, new Uint8Array([
        1,
        $ed0fcbbe142c895d$export$b310ec824aaee37f(i)
    ]));
    return poly;
};


function $e5968549bd660bd4$var$ReedSolomonEncoder(degree) {
    this.genPoly = undefined;
    this.degree = degree;
    if (this.degree) this.initialize(this.degree);
}
/**
 * Initialize the encoder.
 * The input param should correspond to the number of error correction codewords.
 *
 * @param  {Number} degree
 */ $e5968549bd660bd4$var$ReedSolomonEncoder.prototype.initialize = function initialize(degree) {
    // create an irreducible generator polynomial
    this.degree = degree;
    this.genPoly = $64ba10da07b8a690$export$7b8be06a973a9d05(this.degree);
};
/**
 * Encodes a chunk of data
 *
 * @param  {Uint8Array} data Buffer containing input data
 * @return {Uint8Array}      Buffer containing encoded data
 */ $e5968549bd660bd4$var$ReedSolomonEncoder.prototype.encode = function encode(data) {
    if (!this.genPoly) throw new Error("Encoder not initialized");
    // Calculate EC for this data block
    // extends data size to data+genPoly size
    const paddedData = new Uint8Array(data.length + this.degree);
    paddedData.set(data);
    // The error correction codewords are the remainder after dividing the data codewords
    // by a generator polynomial
    const remainder = $64ba10da07b8a690$export$842a2cf37af977e1(paddedData, this.genPoly);
    // return EC data blocks (last n byte, where n is the degree of genPoly)
    // If coefficients number in remainder are less than genPoly degree,
    // pad with 0s to the left to reach the needed number of coefficients
    const start = this.degree - remainder.length;
    if (start > 0) {
        const buff = new Uint8Array(this.degree);
        buff.set(remainder, start);
        return buff;
    }
    return remainder;
};
$e5968549bd660bd4$exports = $e5968549bd660bd4$var$ReedSolomonEncoder;


/**
 * Returns version number from a value.
 * If value is not a valid version, returns defaultValue
 *
 * @param  {Number|String} value        QR Code version
 * @param  {Number}        defaultValue Fallback value
 * @return {Number}                     QR Code version number
 */ var $06fdc23db1d37f8e$export$6788812c4e6611e6;
/**
 * Returns how much data can be stored with the specified QR code version
 * and error correction level
 *
 * @param  {Number} version              QR Code version (1-40)
 * @param  {Number} errorCorrectionLevel Error correction level
 * @param  {Mode}   mode                 Data mode
 * @return {Number}                      Quantity of storable data
 */ var $06fdc23db1d37f8e$export$55b283886ec2d3fb;
/**
 * Returns the minimum version needed to contain the amount of data
 *
 * @param  {Segment} data                    Segment of data
 * @param  {Number} [errorCorrectionLevel=H] Error correction level
 * @param  {Mode} mode                       Data mode
 * @return {Number}                          QR Code version
 */ var $06fdc23db1d37f8e$export$264e969aa7a8ff7e;
/**
 * Returns version information with relative error correction bits
 *
 * The version information is included in QR Code symbols of version 7 or larger.
 * It consists of an 18-bit sequence containing 6 data bits,
 * with 12 error correction bits calculated using the (18, 6) Golay code.
 *
 * @param  {Number} version QR Code version
 * @return {Number}         Encoded version info bits
 */ var $06fdc23db1d37f8e$export$eee5438974ef6f0e;



/**
 * Numeric mode encodes data from the decimal digit set (0 - 9)
 * (byte values 30HEX to 39HEX).
 * Normally, 3 data characters are represented by 10 bits.
 *
 * @type {Object}
 */ var $262d80345880615b$export$4d318981b5a83836;
/**
 * Alphanumeric mode encodes data from a set of 45 characters,
 * i.e. 10 numeric digits (0 - 9),
 *      26 alphabetic characters (A - Z),
 *   and 9 symbols (SP, $, %, *, +, -, ., /, :).
 * Normally, two input characters are represented by 11 bits.
 *
 * @type {Object}
 */ var $262d80345880615b$export$376a9ed239d6c1c8;
/**
 * In byte mode, data is encoded at 8 bits per character.
 *
 * @type {Object}
 */ var $262d80345880615b$export$8f4bf8f7eb581284;
/**
 * The Kanji mode efficiently encodes Kanji characters in accordance with
 * the Shift JIS system based on JIS X 0208.
 * The Shift JIS values are shifted from the JIS X 0208 values.
 * JIS X 0208 gives details of the shift coded representation.
 * Each two-byte character value is compacted to a 13-bit binary codeword.
 *
 * @type {Object}
 */ var $262d80345880615b$export$a4d452c2363c8e12;
/**
 * Mixed mode will contain a sequences of data in a combination of any of
 * the modes described above
 *
 * @type {Object}
 */ var $262d80345880615b$export$bb410559a65d3418;
/**
 * Returns the number of bits needed to store the data length
 * according to QR Code specifications.
 *
 * @param  {Mode}   mode    Data mode
 * @param  {Number} version QR Code version
 * @return {Number}         Number of bits
 */ var $262d80345880615b$export$e79764af6ffaeb8d;
/**
 * Returns the most efficient mode to store the specified data
 *
 * @param  {String} dataStr Input data string
 * @return {Mode}           Best mode
 */ var $262d80345880615b$export$1bd4c93ffb42e55e;
/**
 * Return mode name as string
 *
 * @param {Mode} mode Mode object
 * @returns {String}  Mode name
 */ var $262d80345880615b$export$f84e8e69fd4488a5;
/**
 * Check if input param is a valid mode object
 *
 * @param   {Mode}    mode Mode object
 * @returns {Boolean} True if valid mode, false otherwise
 */ var $262d80345880615b$export$1ea939691cdc45b8;
/**
 * Returns mode from a value.
 * If value is not a valid mode, returns defaultValue
 *
 * @param  {Mode|String} value        Encoding mode
 * @param  {Mode}        defaultValue Fallback value
 * @return {Mode}                     Encoding mode
 */ var $262d80345880615b$export$6788812c4e6611e6;
/**
 * Check if QR Code version is valid
 *
 * @param  {Number}  version QR Code version
 * @return {Boolean}         true if valid version, false otherwise
 */ var $511d34761a3f9212$export$1ea939691cdc45b8;
$511d34761a3f9212$export$1ea939691cdc45b8 = function isValid(version) {
    return !isNaN(version) && version >= 1 && version <= 40;
};


var $c261698d8f09b64f$export$a4d452c2363c8e12;
var $c261698d8f09b64f$export$9df7c29d562bab83;
var $c261698d8f09b64f$export$8f4bf8f7eb581284;
var $c261698d8f09b64f$export$4d318981b5a83836;
var $c261698d8f09b64f$export$376a9ed239d6c1c8;
var $c261698d8f09b64f$export$175f16aef75a4569;
var $c261698d8f09b64f$export$50b7f9bf92c74274;
var $c261698d8f09b64f$export$4ba5f52893b4ac97;
const $c261698d8f09b64f$var$numeric = "[0-9]+";
const $c261698d8f09b64f$var$alphanumeric = "[A-Z $%*+\\-./:]+";
let $c261698d8f09b64f$var$kanji = "(?:[u3000-u303F]|[u3040-u309F]|[u30A0-u30FF]|[uFF00-uFFEF]|[u4E00-u9FAF]|[u2605-u2606]|[u2190-u2195]|u203B|[u2010u2015u2018u2019u2025u2026u201Cu201Du2225u2260]|[u0391-u0451]|[u00A7u00A8u00B1u00B4u00D7u00F7])+";
$c261698d8f09b64f$var$kanji = $c261698d8f09b64f$var$kanji.replace(/u/g, "\\u");
const $c261698d8f09b64f$var$byte = "(?:(?![A-Z0-9 $%*+\\-./:]|" + $c261698d8f09b64f$var$kanji + ")(?:.|[\r\n]))+";
$c261698d8f09b64f$export$a4d452c2363c8e12 = new RegExp($c261698d8f09b64f$var$kanji, "g");
$c261698d8f09b64f$export$9df7c29d562bab83 = new RegExp("[^A-Z0-9 $%*+\\-./:]+", "g");
$c261698d8f09b64f$export$8f4bf8f7eb581284 = new RegExp($c261698d8f09b64f$var$byte, "g");
$c261698d8f09b64f$export$4d318981b5a83836 = new RegExp($c261698d8f09b64f$var$numeric, "g");
$c261698d8f09b64f$export$376a9ed239d6c1c8 = new RegExp($c261698d8f09b64f$var$alphanumeric, "g");
const $c261698d8f09b64f$var$TEST_KANJI = new RegExp("^" + $c261698d8f09b64f$var$kanji + "$");
const $c261698d8f09b64f$var$TEST_NUMERIC = new RegExp("^" + $c261698d8f09b64f$var$numeric + "$");
const $c261698d8f09b64f$var$TEST_ALPHANUMERIC = new RegExp("^[A-Z0-9 $%*+\\-./:]+$");
$c261698d8f09b64f$export$175f16aef75a4569 = function testKanji(str) {
    return $c261698d8f09b64f$var$TEST_KANJI.test(str);
};
$c261698d8f09b64f$export$50b7f9bf92c74274 = function testNumeric(str) {
    return $c261698d8f09b64f$var$TEST_NUMERIC.test(str);
};
$c261698d8f09b64f$export$4ba5f52893b4ac97 = function testAlphanumeric(str) {
    return $c261698d8f09b64f$var$TEST_ALPHANUMERIC.test(str);
};


$262d80345880615b$export$4d318981b5a83836 = {
    id: "Numeric",
    bit: 1,
    ccBits: [
        10,
        12,
        14
    ]
};
$262d80345880615b$export$376a9ed239d6c1c8 = {
    id: "Alphanumeric",
    bit: 2,
    ccBits: [
        9,
        11,
        13
    ]
};
$262d80345880615b$export$8f4bf8f7eb581284 = {
    id: "Byte",
    bit: 4,
    ccBits: [
        8,
        16,
        16
    ]
};
$262d80345880615b$export$a4d452c2363c8e12 = {
    id: "Kanji",
    bit: 8,
    ccBits: [
        8,
        10,
        12
    ]
};
$262d80345880615b$export$bb410559a65d3418 = {
    bit: -1
};
$262d80345880615b$export$e79764af6ffaeb8d = function getCharCountIndicator(mode, version) {
    if (!mode.ccBits) throw new Error("Invalid mode: " + mode);
    if (!$511d34761a3f9212$export$1ea939691cdc45b8(version)) throw new Error("Invalid version: " + version);
    if (version >= 1 && version < 10) return mode.ccBits[0];
    else if (version < 27) return mode.ccBits[1];
    return mode.ccBits[2];
};
$262d80345880615b$export$1bd4c93ffb42e55e = function getBestModeForData(dataStr) {
    if ($c261698d8f09b64f$export$50b7f9bf92c74274(dataStr)) return $262d80345880615b$export$4d318981b5a83836;
    else if ($c261698d8f09b64f$export$4ba5f52893b4ac97(dataStr)) return $262d80345880615b$export$376a9ed239d6c1c8;
    else if ($c261698d8f09b64f$export$175f16aef75a4569(dataStr)) return $262d80345880615b$export$a4d452c2363c8e12;
    else return $262d80345880615b$export$8f4bf8f7eb581284;
};
$262d80345880615b$export$f84e8e69fd4488a5 = function toString(mode) {
    if (mode && mode.id) return mode.id;
    throw new Error("Invalid mode");
};
$262d80345880615b$export$1ea939691cdc45b8 = function isValid(mode) {
    return mode && mode.bit && mode.ccBits;
};
/**
 * Get mode object from its name
 *
 * @param   {String} string Mode name
 * @returns {Mode}          Mode object
 */ function $262d80345880615b$var$fromString(string) {
    if (typeof string !== "string") throw new Error("Param is not a string");
    const lcStr = string.toLowerCase();
    switch(lcStr){
        case "numeric":
            return $262d80345880615b$export$4d318981b5a83836;
        case "alphanumeric":
            return $262d80345880615b$export$376a9ed239d6c1c8;
        case "kanji":
            return $262d80345880615b$export$a4d452c2363c8e12;
        case "byte":
            return $262d80345880615b$export$8f4bf8f7eb581284;
        default:
            throw new Error("Unknown mode: " + string);
    }
}
$262d80345880615b$export$6788812c4e6611e6 = function from(value, defaultValue) {
    if ($262d80345880615b$export$1ea939691cdc45b8(value)) return value;
    try {
        return $262d80345880615b$var$fromString(value);
    } catch (e) {
        return defaultValue;
    }
};



// Generator polynomial used to encode version information
const $06fdc23db1d37f8e$var$G18 = 7973;
const $06fdc23db1d37f8e$var$G18_BCH = $ae0eaf7ed71e598d$export$ed1d66da50968976($06fdc23db1d37f8e$var$G18);
function $06fdc23db1d37f8e$var$getBestVersionForDataLength(mode, length, errorCorrectionLevel) {
    for(let currentVersion = 1; currentVersion <= 40; currentVersion++){
        if (length <= $06fdc23db1d37f8e$export$55b283886ec2d3fb(currentVersion, errorCorrectionLevel, mode)) return currentVersion;
    }
    return undefined;
}
function $06fdc23db1d37f8e$var$getReservedBitsCount(mode, version) {
    // Character count indicator + mode indicator bits
    return $262d80345880615b$export$e79764af6ffaeb8d(mode, version) + 4;
}
function $06fdc23db1d37f8e$var$getTotalBitsFromDataArray(segments, version) {
    let totalBits = 0;
    segments.forEach(function(data) {
        const reservedBits = $06fdc23db1d37f8e$var$getReservedBitsCount(data.mode, version);
        totalBits += reservedBits + data.getBitsLength();
    });
    return totalBits;
}
function $06fdc23db1d37f8e$var$getBestVersionForMixedData(segments, errorCorrectionLevel) {
    for(let currentVersion = 1; currentVersion <= 40; currentVersion++){
        const length = $06fdc23db1d37f8e$var$getTotalBitsFromDataArray(segments, currentVersion);
        if (length <= $06fdc23db1d37f8e$export$55b283886ec2d3fb(currentVersion, errorCorrectionLevel, $262d80345880615b$export$bb410559a65d3418)) return currentVersion;
    }
    return undefined;
}
$06fdc23db1d37f8e$export$6788812c4e6611e6 = function from(value, defaultValue) {
    if ($511d34761a3f9212$export$1ea939691cdc45b8(value)) return parseInt(value, 10);
    return defaultValue;
};
$06fdc23db1d37f8e$export$55b283886ec2d3fb = function getCapacity(version, errorCorrectionLevel, mode) {
    if (!$511d34761a3f9212$export$1ea939691cdc45b8(version)) throw new Error("Invalid QR Code version");
    // Use Byte mode as default
    if (typeof mode === "undefined") mode = $262d80345880615b$export$8f4bf8f7eb581284;
    // Total codewords for this QR code version (Data + Error correction)
    const totalCodewords = $ae0eaf7ed71e598d$export$b05dac13c7a35c32(version);
    // Total number of error correction codewords
    const ecTotalCodewords = $163ea6b830a815e3$export$683d1b3e8a1a8438(version, errorCorrectionLevel);
    // Total number of data codewords
    const dataTotalCodewordsBits = (totalCodewords - ecTotalCodewords) * 8;
    if (mode === $262d80345880615b$export$bb410559a65d3418) return dataTotalCodewordsBits;
    const usableBits = dataTotalCodewordsBits - $06fdc23db1d37f8e$var$getReservedBitsCount(mode, version);
    // Return max number of storable codewords
    switch(mode){
        case $262d80345880615b$export$4d318981b5a83836:
            return Math.floor(usableBits / 10 * 3);
        case $262d80345880615b$export$376a9ed239d6c1c8:
            return Math.floor(usableBits / 11 * 2);
        case $262d80345880615b$export$a4d452c2363c8e12:
            return Math.floor(usableBits / 13);
        case $262d80345880615b$export$8f4bf8f7eb581284:
        default:
            return Math.floor(usableBits / 8);
    }
};
$06fdc23db1d37f8e$export$264e969aa7a8ff7e = function getBestVersionForData(data, errorCorrectionLevel) {
    let seg;
    const ecl = $85200a578c5005f7$export$6788812c4e6611e6(errorCorrectionLevel, $85200a578c5005f7$export$3a1a48c8f6ef640e);
    if (Array.isArray(data)) {
        if (data.length > 1) return $06fdc23db1d37f8e$var$getBestVersionForMixedData(data, ecl);
        if (data.length === 0) return 1;
        seg = data[0];
    } else seg = data;
    return $06fdc23db1d37f8e$var$getBestVersionForDataLength(seg.mode, seg.getLength(), ecl);
};
$06fdc23db1d37f8e$export$eee5438974ef6f0e = function getEncodedBits(version) {
    if (!$511d34761a3f9212$export$1ea939691cdc45b8(version) || version < 7) throw new Error("Invalid QR Code version");
    let d = version << 12;
    while($ae0eaf7ed71e598d$export$ed1d66da50968976(d) - $06fdc23db1d37f8e$var$G18_BCH >= 0)d ^= $06fdc23db1d37f8e$var$G18 << $ae0eaf7ed71e598d$export$ed1d66da50968976(d) - $06fdc23db1d37f8e$var$G18_BCH;
    return version << 12 | d;
};


/**
 * Returns format information with relative error correction bits
 *
 * The format information is a 15-bit sequence containing 5 data bits,
 * with 10 error correction bits calculated using the (15, 5) BCH code.
 *
 * @param  {Number} errorCorrectionLevel Error correction level
 * @param  {Number} mask                 Mask pattern
 * @return {Number}                      Encoded format information bits
 */ var $1edfc4f4bc0a013c$export$eee5438974ef6f0e;

const $1edfc4f4bc0a013c$var$G15 = 1335;
const $1edfc4f4bc0a013c$var$G15_MASK = 21522;
const $1edfc4f4bc0a013c$var$G15_BCH = $ae0eaf7ed71e598d$export$ed1d66da50968976($1edfc4f4bc0a013c$var$G15);
$1edfc4f4bc0a013c$export$eee5438974ef6f0e = function getEncodedBits(errorCorrectionLevel, mask) {
    const data = errorCorrectionLevel.bit << 3 | mask;
    let d = data << 10;
    while($ae0eaf7ed71e598d$export$ed1d66da50968976(d) - $1edfc4f4bc0a013c$var$G15_BCH >= 0)d ^= $1edfc4f4bc0a013c$var$G15 << $ae0eaf7ed71e598d$export$ed1d66da50968976(d) - $1edfc4f4bc0a013c$var$G15_BCH;
    // xor final data with mask pattern in order to ensure that
    // no combination of Error Correction Level and data mask pattern
    // will result in an all-zero data string
    return (data << 10 | d) ^ $1edfc4f4bc0a013c$var$G15_MASK;
};



/**
 * Builds a list of segments from an array.
 * Array can contain Strings or Objects with segment's info.
 *
 * For each item which is a string, will be generated a segment with the given
 * string and the more appropriate encoding mode.
 *
 * For each item which is an object, will be generated a segment with the given
 * data and mode.
 * Objects must contain at least the property "data".
 * If property "mode" is not present, the more suitable mode will be used.
 *
 * @param  {Array} array Array of objects with segments data
 * @return {Array}       Array of Segments
 */ var $cb57a851a537406f$export$571d59b505e6bb4e;
/**
 * Builds an optimized sequence of segments from a string,
 * which will produce the shortest possible bitstream.
 *
 * @param  {String} data    Input string
 * @param  {Number} version QR Code version
 * @return {Array}          Array of segments
 */ var $cb57a851a537406f$export$3004f64547af360e;
/**
 * Splits a string in various segments with the modes which
 * best represent their content.
 * The produced segments are far from being optimized.
 * The output of this function is only used to estimate a QR Code version
 * which may contain the data.
 *
 * @param  {string} data Input string
 * @return {Array}       Array of segments
 */ var $cb57a851a537406f$export$89ab1afb9839589b;

var $9c02a8e9f5222a4c$exports = {};

function $9c02a8e9f5222a4c$var$NumericData(data) {
    this.mode = $262d80345880615b$export$4d318981b5a83836;
    this.data = data.toString();
}
$9c02a8e9f5222a4c$var$NumericData.getBitsLength = function getBitsLength(length) {
    return 10 * Math.floor(length / 3) + (length % 3 ? length % 3 * 3 + 1 : 0);
};
$9c02a8e9f5222a4c$var$NumericData.prototype.getLength = function getLength() {
    return this.data.length;
};
$9c02a8e9f5222a4c$var$NumericData.prototype.getBitsLength = function getBitsLength() {
    return $9c02a8e9f5222a4c$var$NumericData.getBitsLength(this.data.length);
};
$9c02a8e9f5222a4c$var$NumericData.prototype.write = function write(bitBuffer) {
    let i, group, value;
    // The input data string is divided into groups of three digits,
    // and each group is converted to its 10-bit binary equivalent.
    for(i = 0; i + 3 <= this.data.length; i += 3){
        group = this.data.substr(i, 3);
        value = parseInt(group, 10);
        bitBuffer.put(value, 10);
    }
    // If the number of input digits is not an exact multiple of three,
    // the final one or two digits are converted to 4 or 7 bits respectively.
    const remainingNum = this.data.length - i;
    if (remainingNum > 0) {
        group = this.data.substr(i);
        value = parseInt(group, 10);
        bitBuffer.put(value, remainingNum * 3 + 1);
    }
};
$9c02a8e9f5222a4c$exports = $9c02a8e9f5222a4c$var$NumericData;


var $740ea9b4583d99e7$exports = {};

/**
 * Array of characters available in alphanumeric mode
 *
 * As per QR Code specification, to each character
 * is assigned a value from 0 to 44 which in this case coincides
 * with the array index
 *
 * @type {Array}
 */ const $740ea9b4583d99e7$var$ALPHA_NUM_CHARS = [
    "0",
    "1",
    "2",
    "3",
    "4",
    "5",
    "6",
    "7",
    "8",
    "9",
    "A",
    "B",
    "C",
    "D",
    "E",
    "F",
    "G",
    "H",
    "I",
    "J",
    "K",
    "L",
    "M",
    "N",
    "O",
    "P",
    "Q",
    "R",
    "S",
    "T",
    "U",
    "V",
    "W",
    "X",
    "Y",
    "Z",
    " ",
    "$",
    "%",
    "*",
    "+",
    "-",
    ".",
    "/",
    ":"
];
function $740ea9b4583d99e7$var$AlphanumericData(data) {
    this.mode = $262d80345880615b$export$376a9ed239d6c1c8;
    this.data = data;
}
$740ea9b4583d99e7$var$AlphanumericData.getBitsLength = function getBitsLength(length) {
    return 11 * Math.floor(length / 2) + 6 * (length % 2);
};
$740ea9b4583d99e7$var$AlphanumericData.prototype.getLength = function getLength() {
    return this.data.length;
};
$740ea9b4583d99e7$var$AlphanumericData.prototype.getBitsLength = function getBitsLength() {
    return $740ea9b4583d99e7$var$AlphanumericData.getBitsLength(this.data.length);
};
$740ea9b4583d99e7$var$AlphanumericData.prototype.write = function write(bitBuffer) {
    let i;
    // Input data characters are divided into groups of two characters
    // and encoded as 11-bit binary codes.
    for(i = 0; i + 2 <= this.data.length; i += 2){
        // The character value of the first character is multiplied by 45
        let value = $740ea9b4583d99e7$var$ALPHA_NUM_CHARS.indexOf(this.data[i]) * 45;
        // The character value of the second digit is added to the product
        value += $740ea9b4583d99e7$var$ALPHA_NUM_CHARS.indexOf(this.data[i + 1]);
        // The sum is then stored as 11-bit binary number
        bitBuffer.put(value, 11);
    }
    // If the number of input data characters is not a multiple of two,
    // the character value of the final character is encoded as a 6-bit binary number.
    if (this.data.length % 2) bitBuffer.put($740ea9b4583d99e7$var$ALPHA_NUM_CHARS.indexOf(this.data[i]), 6);
};
$740ea9b4583d99e7$exports = $740ea9b4583d99e7$var$AlphanumericData;


var $807fa6385fd9238a$exports = {};
var $446ed4bdb8880117$exports = {};
"use strict";
$446ed4bdb8880117$exports = function encodeUtf8(input) {
    var result = [];
    var size = input.length;
    for(var index = 0; index < size; index++){
        var point = input.charCodeAt(index);
        if (point >= 0xD800 && point <= 0xDBFF && size > index + 1) {
            var second = input.charCodeAt(index + 1);
            if (second >= 0xDC00 && second <= 0xDFFF) {
                // https://mathiasbynens.be/notes/javascript-encoding#surrogate-formulae
                point = (point - 0xD800) * 0x400 + second - 0xDC00 + 0x10000;
                index += 1;
            }
        }
        // US-ASCII
        if (point < 0x80) {
            result.push(point);
            continue;
        }
        // 2-byte UTF-8
        if (point < 0x800) {
            result.push(point >> 6 | 192);
            result.push(point & 63 | 128);
            continue;
        }
        // 3-byte UTF-8
        if (point < 0xD800 || point >= 0xE000 && point < 0x10000) {
            result.push(point >> 12 | 224);
            result.push(point >> 6 & 63 | 128);
            result.push(point & 63 | 128);
            continue;
        }
        // 4-byte UTF-8
        if (point >= 0x10000 && point <= 0x10FFFF) {
            result.push(point >> 18 | 240);
            result.push(point >> 12 & 63 | 128);
            result.push(point >> 6 & 63 | 128);
            result.push(point & 63 | 128);
            continue;
        }
        // Invalid character
        result.push(0xEF, 0xBF, 0xBD);
    }
    return new Uint8Array(result).buffer;
};



function $807fa6385fd9238a$var$ByteData(data) {
    this.mode = $262d80345880615b$export$8f4bf8f7eb581284;
    if (typeof data === "string") data = $446ed4bdb8880117$exports(data);
    this.data = new Uint8Array(data);
}
$807fa6385fd9238a$var$ByteData.getBitsLength = function getBitsLength(length) {
    return length * 8;
};
$807fa6385fd9238a$var$ByteData.prototype.getLength = function getLength() {
    return this.data.length;
};
$807fa6385fd9238a$var$ByteData.prototype.getBitsLength = function getBitsLength() {
    return $807fa6385fd9238a$var$ByteData.getBitsLength(this.data.length);
};
$807fa6385fd9238a$var$ByteData.prototype.write = function(bitBuffer) {
    for(let i = 0, l = this.data.length; i < l; i++)bitBuffer.put(this.data[i], 8);
};
$807fa6385fd9238a$exports = $807fa6385fd9238a$var$ByteData;


var $563b1fe4effbea9d$exports = {};


function $563b1fe4effbea9d$var$KanjiData(data) {
    this.mode = $262d80345880615b$export$a4d452c2363c8e12;
    this.data = data;
}
$563b1fe4effbea9d$var$KanjiData.getBitsLength = function getBitsLength(length) {
    return length * 13;
};
$563b1fe4effbea9d$var$KanjiData.prototype.getLength = function getLength() {
    return this.data.length;
};
$563b1fe4effbea9d$var$KanjiData.prototype.getBitsLength = function getBitsLength() {
    return $563b1fe4effbea9d$var$KanjiData.getBitsLength(this.data.length);
};
$563b1fe4effbea9d$var$KanjiData.prototype.write = function(bitBuffer) {
    let i;
    // In the Shift JIS system, Kanji characters are represented by a two byte combination.
    // These byte values are shifted from the JIS X 0208 values.
    // JIS X 0208 gives details of the shift coded representation.
    for(i = 0; i < this.data.length; i++){
        let value = $ae0eaf7ed71e598d$export$43dd553ecded716d(this.data[i]);
        // For characters with Shift JIS values from 0x8140 to 0x9FFC:
        if (value >= 0x8140 && value <= 0x9FFC) // Subtract 0x8140 from Shift JIS value
        value -= 0x8140;
        else if (value >= 0xE040 && value <= 0xEBBF) // Subtract 0xC140 from Shift JIS value
        value -= 0xC140;
        else throw new Error("Invalid SJIS character: " + this.data[i] + "\n" + "Make sure your charset is UTF-8");
        // Multiply most significant byte of result by 0xC0
        // and add least significant byte to product
        value = (value >>> 8 & 0xff) * 0xC0 + (value & 0xff);
        // Convert result to a 13-bit binary string
        bitBuffer.put(value, 13);
    }
};
$563b1fe4effbea9d$exports = $563b1fe4effbea9d$var$KanjiData;




var $e63751dcc8f0e65b$exports = {};
"use strict";
/******************************************************************************
 * Created 2008-08-19.
 *
 * Dijkstra path-finding functions. Adapted from the Dijkstar Python project.
 *
 * Copyright (C) 2008
 *   Wyatt Baldwin <self@wyattbaldwin.com>
 *   All rights reserved
 *
 * Licensed under the MIT license.
 *
 *   http://www.opensource.org/licenses/mit-license.php
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 *****************************************************************************/ var $e63751dcc8f0e65b$var$dijkstra = {
    single_source_shortest_paths: function(graph, s, d) {
        // Predecessor map for each node that has been encountered.
        // node ID => predecessor node ID
        var predecessors = {};
        // Costs of shortest paths from s to all nodes encountered.
        // node ID => cost
        var costs = {};
        costs[s] = 0;
        // Costs of shortest paths from s to all nodes encountered; differs from
        // `costs` in that it provides easy access to the node that currently has
        // the known shortest path from s.
        // XXX: Do we actually need both `costs` and `open`?
        var open = $e63751dcc8f0e65b$var$dijkstra.PriorityQueue.make();
        open.push(s, 0);
        var closest, u, v, cost_of_s_to_u, adjacent_nodes, cost_of_e, cost_of_s_to_u_plus_cost_of_e, cost_of_s_to_v, first_visit;
        while(!open.empty()){
            // In the nodes remaining in graph that have a known cost from s,
            // find the node, u, that currently has the shortest path from s.
            closest = open.pop();
            u = closest.value;
            cost_of_s_to_u = closest.cost;
            // Get nodes adjacent to u...
            adjacent_nodes = graph[u] || {};
            // ...and explore the edges that connect u to those nodes, updating
            // the cost of the shortest paths to any or all of those nodes as
            // necessary. v is the node across the current edge from u.
            for(v in adjacent_nodes)if (adjacent_nodes.hasOwnProperty(v)) {
                // Get the cost of the edge running from u to v.
                cost_of_e = adjacent_nodes[v];
                // Cost of s to u plus the cost of u to v across e--this is *a*
                // cost from s to v that may or may not be less than the current
                // known cost to v.
                cost_of_s_to_u_plus_cost_of_e = cost_of_s_to_u + cost_of_e;
                // If we haven't visited v yet OR if the current known cost from s to
                // v is greater than the new cost we just found (cost of s to u plus
                // cost of u to v across e), update v's cost in the cost list and
                // update v's predecessor in the predecessor list (it's now u).
                cost_of_s_to_v = costs[v];
                first_visit = typeof costs[v] === "undefined";
                if (first_visit || cost_of_s_to_v > cost_of_s_to_u_plus_cost_of_e) {
                    costs[v] = cost_of_s_to_u_plus_cost_of_e;
                    open.push(v, cost_of_s_to_u_plus_cost_of_e);
                    predecessors[v] = u;
                }
            }
        }
        if (typeof d !== "undefined" && typeof costs[d] === "undefined") {
            var msg = [
                "Could not find a path from ",
                s,
                " to ",
                d,
                "."
            ].join("");
            throw new Error(msg);
        }
        return predecessors;
    },
    extract_shortest_path_from_predecessor_list: function(predecessors, d) {
        var nodes = [];
        var u = d;
        var predecessor;
        while(u){
            nodes.push(u);
            predecessor = predecessors[u];
            u = predecessors[u];
        }
        nodes.reverse();
        return nodes;
    },
    find_path: function(graph, s, d) {
        var predecessors = $e63751dcc8f0e65b$var$dijkstra.single_source_shortest_paths(graph, s, d);
        return $e63751dcc8f0e65b$var$dijkstra.extract_shortest_path_from_predecessor_list(predecessors, d);
    },
    /**
   * A very naive priority queue implementation.
   */ PriorityQueue: {
        make: function(opts) {
            var T = $e63751dcc8f0e65b$var$dijkstra.PriorityQueue, t = {}, key;
            opts = opts || {};
            for(key in T)if (T.hasOwnProperty(key)) t[key] = T[key];
            t.queue = [];
            t.sorter = opts.sorter || T.default_sorter;
            return t;
        },
        default_sorter: function(a, b) {
            return a.cost - b.cost;
        },
        /**
     * Add a new item to the queue and ensure the highest priority element
     * is at the front of the queue.
     */ push: function(value, cost) {
            var item = {
                value: value,
                cost: cost
            };
            this.queue.push(item);
            this.queue.sort(this.sorter);
        },
        /**
     * Return the highest priority element in the queue.
     */ pop: function() {
            return this.queue.shift();
        },
        empty: function() {
            return this.queue.length === 0;
        }
    }
};
$e63751dcc8f0e65b$exports = $e63751dcc8f0e65b$var$dijkstra;


/**
 * Returns UTF8 byte length
 *
 * @param  {String} str Input string
 * @return {Number}     Number of byte
 */ function $cb57a851a537406f$var$getStringByteLength(str) {
    return unescape(encodeURIComponent(str)).length;
}
/**
 * Get a list of segments of the specified mode
 * from a string
 *
 * @param  {Mode}   mode Segment mode
 * @param  {String} str  String to process
 * @return {Array}       Array of object with segments data
 */ function $cb57a851a537406f$var$getSegments(regex, mode, str) {
    const segments = [];
    let result;
    while((result = regex.exec(str)) !== null)segments.push({
        data: result[0],
        index: result.index,
        mode: mode,
        length: result[0].length
    });
    return segments;
}
/**
 * Extracts a series of segments with the appropriate
 * modes from a string
 *
 * @param  {String} dataStr Input string
 * @return {Array}          Array of object with segments data
 */ function $cb57a851a537406f$var$getSegmentsFromString(dataStr) {
    const numSegs = $cb57a851a537406f$var$getSegments($c261698d8f09b64f$export$4d318981b5a83836, $262d80345880615b$export$4d318981b5a83836, dataStr);
    const alphaNumSegs = $cb57a851a537406f$var$getSegments($c261698d8f09b64f$export$376a9ed239d6c1c8, $262d80345880615b$export$376a9ed239d6c1c8, dataStr);
    let byteSegs;
    let kanjiSegs;
    if ($ae0eaf7ed71e598d$export$ce5b1274f8597fa0()) {
        byteSegs = $cb57a851a537406f$var$getSegments($c261698d8f09b64f$export$8f4bf8f7eb581284, $262d80345880615b$export$8f4bf8f7eb581284, dataStr);
        kanjiSegs = $cb57a851a537406f$var$getSegments($c261698d8f09b64f$export$a4d452c2363c8e12, $262d80345880615b$export$a4d452c2363c8e12, dataStr);
    } else {
        byteSegs = $cb57a851a537406f$var$getSegments($c261698d8f09b64f$export$9df7c29d562bab83, $262d80345880615b$export$8f4bf8f7eb581284, dataStr);
        kanjiSegs = [];
    }
    const segs = numSegs.concat(alphaNumSegs, byteSegs, kanjiSegs);
    return segs.sort(function(s1, s2) {
        return s1.index - s2.index;
    }).map(function(obj) {
        return {
            data: obj.data,
            mode: obj.mode,
            length: obj.length
        };
    });
}
/**
 * Returns how many bits are needed to encode a string of
 * specified length with the specified mode
 *
 * @param  {Number} length String length
 * @param  {Mode} mode     Segment mode
 * @return {Number}        Bit length
 */ function $cb57a851a537406f$var$getSegmentBitsLength(length, mode) {
    switch(mode){
        case $262d80345880615b$export$4d318981b5a83836:
            return $9c02a8e9f5222a4c$exports.getBitsLength(length);
        case $262d80345880615b$export$376a9ed239d6c1c8:
            return $740ea9b4583d99e7$exports.getBitsLength(length);
        case $262d80345880615b$export$a4d452c2363c8e12:
            return $563b1fe4effbea9d$exports.getBitsLength(length);
        case $262d80345880615b$export$8f4bf8f7eb581284:
            return $807fa6385fd9238a$exports.getBitsLength(length);
    }
}
/**
 * Merges adjacent segments which have the same mode
 *
 * @param  {Array} segs Array of object with segments data
 * @return {Array}      Array of object with segments data
 */ function $cb57a851a537406f$var$mergeSegments(segs) {
    return segs.reduce(function(acc, curr) {
        const prevSeg = acc.length - 1 >= 0 ? acc[acc.length - 1] : null;
        if (prevSeg && prevSeg.mode === curr.mode) {
            acc[acc.length - 1].data += curr.data;
            return acc;
        }
        acc.push(curr);
        return acc;
    }, []);
}
/**
 * Generates a list of all possible nodes combination which
 * will be used to build a segments graph.
 *
 * Nodes are divided by groups. Each group will contain a list of all the modes
 * in which is possible to encode the given text.
 *
 * For example the text '12345' can be encoded as Numeric, Alphanumeric or Byte.
 * The group for '12345' will contain then 3 objects, one for each
 * possible encoding mode.
 *
 * Each node represents a possible segment.
 *
 * @param  {Array} segs Array of object with segments data
 * @return {Array}      Array of object with segments data
 */ function $cb57a851a537406f$var$buildNodes(segs) {
    const nodes = [];
    for(let i = 0; i < segs.length; i++){
        const seg = segs[i];
        switch(seg.mode){
            case $262d80345880615b$export$4d318981b5a83836:
                nodes.push([
                    seg,
                    {
                        data: seg.data,
                        mode: $262d80345880615b$export$376a9ed239d6c1c8,
                        length: seg.length
                    },
                    {
                        data: seg.data,
                        mode: $262d80345880615b$export$8f4bf8f7eb581284,
                        length: seg.length
                    }
                ]);
                break;
            case $262d80345880615b$export$376a9ed239d6c1c8:
                nodes.push([
                    seg,
                    {
                        data: seg.data,
                        mode: $262d80345880615b$export$8f4bf8f7eb581284,
                        length: seg.length
                    }
                ]);
                break;
            case $262d80345880615b$export$a4d452c2363c8e12:
                nodes.push([
                    seg,
                    {
                        data: seg.data,
                        mode: $262d80345880615b$export$8f4bf8f7eb581284,
                        length: $cb57a851a537406f$var$getStringByteLength(seg.data)
                    }
                ]);
                break;
            case $262d80345880615b$export$8f4bf8f7eb581284:
                nodes.push([
                    {
                        data: seg.data,
                        mode: $262d80345880615b$export$8f4bf8f7eb581284,
                        length: $cb57a851a537406f$var$getStringByteLength(seg.data)
                    }
                ]);
        }
    }
    return nodes;
}
/**
 * Builds a graph from a list of nodes.
 * All segments in each node group will be connected with all the segments of
 * the next group and so on.
 *
 * At each connection will be assigned a weight depending on the
 * segment's byte length.
 *
 * @param  {Array} nodes    Array of object with segments data
 * @param  {Number} version QR Code version
 * @return {Object}         Graph of all possible segments
 */ function $cb57a851a537406f$var$buildGraph(nodes, version) {
    const table = {};
    const graph = {
        start: {}
    };
    let prevNodeIds = [
        "start"
    ];
    for(let i = 0; i < nodes.length; i++){
        const nodeGroup = nodes[i];
        const currentNodeIds = [];
        for(let j = 0; j < nodeGroup.length; j++){
            const node = nodeGroup[j];
            const key = "" + i + j;
            currentNodeIds.push(key);
            table[key] = {
                node: node,
                lastCount: 0
            };
            graph[key] = {};
            for(let n = 0; n < prevNodeIds.length; n++){
                const prevNodeId = prevNodeIds[n];
                if (table[prevNodeId] && table[prevNodeId].node.mode === node.mode) {
                    graph[prevNodeId][key] = $cb57a851a537406f$var$getSegmentBitsLength(table[prevNodeId].lastCount + node.length, node.mode) - $cb57a851a537406f$var$getSegmentBitsLength(table[prevNodeId].lastCount, node.mode);
                    table[prevNodeId].lastCount += node.length;
                } else {
                    if (table[prevNodeId]) table[prevNodeId].lastCount = node.length;
                    graph[prevNodeId][key] = $cb57a851a537406f$var$getSegmentBitsLength(node.length, node.mode) + 4 + $262d80345880615b$export$e79764af6ffaeb8d(node.mode, version) // switch cost
                    ;
                }
            }
        }
        prevNodeIds = currentNodeIds;
    }
    for(let n = 0; n < prevNodeIds.length; n++)graph[prevNodeIds[n]].end = 0;
    return {
        map: graph,
        table: table
    };
}
/**
 * Builds a segment from a specified data and mode.
 * If a mode is not specified, the more suitable will be used.
 *
 * @param  {String} data             Input data
 * @param  {Mode | String} modesHint Data mode
 * @return {Segment}                 Segment
 */ function $cb57a851a537406f$var$buildSingleSegment(data, modesHint) {
    let mode;
    const bestMode = $262d80345880615b$export$1bd4c93ffb42e55e(data);
    mode = $262d80345880615b$export$6788812c4e6611e6(modesHint, bestMode);
    // Make sure data can be encoded
    if (mode !== $262d80345880615b$export$8f4bf8f7eb581284 && mode.bit < bestMode.bit) throw new Error('"' + data + '"' + " cannot be encoded with mode " + $262d80345880615b$export$f84e8e69fd4488a5(mode) + ".\n Suggested mode is: " + $262d80345880615b$export$f84e8e69fd4488a5(bestMode));
    // Use Mode.BYTE if Kanji support is disabled
    if (mode === $262d80345880615b$export$a4d452c2363c8e12 && !$ae0eaf7ed71e598d$export$ce5b1274f8597fa0()) mode = $262d80345880615b$export$8f4bf8f7eb581284;
    switch(mode){
        case $262d80345880615b$export$4d318981b5a83836:
            return new $9c02a8e9f5222a4c$exports(data);
        case $262d80345880615b$export$376a9ed239d6c1c8:
            return new $740ea9b4583d99e7$exports(data);
        case $262d80345880615b$export$a4d452c2363c8e12:
            return new $563b1fe4effbea9d$exports(data);
        case $262d80345880615b$export$8f4bf8f7eb581284:
            return new $807fa6385fd9238a$exports(data);
    }
}
$cb57a851a537406f$export$571d59b505e6bb4e = function fromArray(array) {
    return array.reduce(function(acc, seg) {
        if (typeof seg === "string") acc.push($cb57a851a537406f$var$buildSingleSegment(seg, null));
        else if (seg.data) acc.push($cb57a851a537406f$var$buildSingleSegment(seg.data, seg.mode));
        return acc;
    }, []);
};
$cb57a851a537406f$export$3004f64547af360e = function fromString(data, version) {
    const segs = $cb57a851a537406f$var$getSegmentsFromString(data, $ae0eaf7ed71e598d$export$ce5b1274f8597fa0());
    const nodes = $cb57a851a537406f$var$buildNodes(segs);
    const graph = $cb57a851a537406f$var$buildGraph(nodes, version);
    const path = $e63751dcc8f0e65b$exports.find_path(graph.map, "start", "end");
    const optimizedSegs = [];
    for(let i = 1; i < path.length - 1; i++)optimizedSegs.push(graph.table[path[i]].node);
    return $cb57a851a537406f$export$571d59b505e6bb4e($cb57a851a537406f$var$mergeSegments(optimizedSegs));
};
$cb57a851a537406f$export$89ab1afb9839589b = function rawSplit(data) {
    return $cb57a851a537406f$export$571d59b505e6bb4e($cb57a851a537406f$var$getSegmentsFromString(data, $ae0eaf7ed71e598d$export$ce5b1274f8597fa0()));
};


/**
 * QRCode for JavaScript
 *
 * modified by Ryan Day for nodejs support
 * Copyright (c) 2011 Ryan Day
 *
 * Licensed under the MIT license:
 *   http://www.opensource.org/licenses/mit-license.php
 *
//---------------------------------------------------------------------
// QRCode for JavaScript
//
// Copyright (c) 2009 Kazuhiko Arase
//
// URL: http://www.d-project.com/
//
// Licensed under the MIT license:
//   http://www.opensource.org/licenses/mit-license.php
//
// The word "QR Code" is registered trademark of
// DENSO WAVE INCORPORATED
//   http://www.denso-wave.com/qrcode/faqpatent-e.html
//
//---------------------------------------------------------------------
*/ /**
 * Add finder patterns bits to matrix
 *
 * @param  {BitMatrix} matrix  Modules matrix
 * @param  {Number}    version QR Code version
 */ function $c412bf950f65ef05$var$setupFinderPattern(matrix, version) {
    const size = matrix.size;
    const pos = $84e24b233d358480$export$c39457c570f2b189(version);
    for(let i = 0; i < pos.length; i++){
        const row = pos[i][0];
        const col = pos[i][1];
        for(let r = -1; r <= 7; r++){
            if (row + r <= -1 || size <= row + r) continue;
            for(let c = -1; c <= 7; c++){
                if (col + c <= -1 || size <= col + c) continue;
                if (r >= 0 && r <= 6 && (c === 0 || c === 6) || c >= 0 && c <= 6 && (r === 0 || r === 6) || r >= 2 && r <= 4 && c >= 2 && c <= 4) matrix.set(row + r, col + c, true, true);
                else matrix.set(row + r, col + c, false, true);
            }
        }
    }
}
/**
 * Add timing pattern bits to matrix
 *
 * Note: this function must be called before {@link setupAlignmentPattern}
 *
 * @param  {BitMatrix} matrix Modules matrix
 */ function $c412bf950f65ef05$var$setupTimingPattern(matrix) {
    const size = matrix.size;
    for(let r = 8; r < size - 8; r++){
        const value = r % 2 === 0;
        matrix.set(r, 6, value, true);
        matrix.set(6, r, value, true);
    }
}
/**
 * Add alignment patterns bits to matrix
 *
 * Note: this function must be called after {@link setupTimingPattern}
 *
 * @param  {BitMatrix} matrix  Modules matrix
 * @param  {Number}    version QR Code version
 */ function $c412bf950f65ef05$var$setupAlignmentPattern(matrix, version) {
    const pos = $f3200cae265fe7a0$export$c39457c570f2b189(version);
    for(let i = 0; i < pos.length; i++){
        const row = pos[i][0];
        const col = pos[i][1];
        for(let r = -2; r <= 2; r++){
            for(let c = -2; c <= 2; c++)if (r === -2 || r === 2 || c === -2 || c === 2 || r === 0 && c === 0) matrix.set(row + r, col + c, true, true);
            else matrix.set(row + r, col + c, false, true);
        }
    }
}
/**
 * Add version info bits to matrix
 *
 * @param  {BitMatrix} matrix  Modules matrix
 * @param  {Number}    version QR Code version
 */ function $c412bf950f65ef05$var$setupVersionInfo(matrix, version) {
    const size = matrix.size;
    const bits = $06fdc23db1d37f8e$export$eee5438974ef6f0e(version);
    let row, col, mod;
    for(let i = 0; i < 18; i++){
        row = Math.floor(i / 3);
        col = i % 3 + size - 8 - 3;
        mod = (bits >> i & 1) === 1;
        matrix.set(row, col, mod, true);
        matrix.set(col, row, mod, true);
    }
}
/**
 * Add format info bits to matrix
 *
 * @param  {BitMatrix} matrix               Modules matrix
 * @param  {ErrorCorrectionLevel}    errorCorrectionLevel Error correction level
 * @param  {Number}    maskPattern          Mask pattern reference value
 */ function $c412bf950f65ef05$var$setupFormatInfo(matrix, errorCorrectionLevel, maskPattern) {
    const size = matrix.size;
    const bits = $1edfc4f4bc0a013c$export$eee5438974ef6f0e(errorCorrectionLevel, maskPattern);
    let i, mod;
    for(i = 0; i < 15; i++){
        mod = (bits >> i & 1) === 1;
        // vertical
        if (i < 6) matrix.set(i, 8, mod, true);
        else if (i < 8) matrix.set(i + 1, 8, mod, true);
        else matrix.set(size - 15 + i, 8, mod, true);
        // horizontal
        if (i < 8) matrix.set(8, size - i - 1, mod, true);
        else if (i < 9) matrix.set(8, 15 - i - 1 + 1, mod, true);
        else matrix.set(8, 15 - i - 1, mod, true);
    }
    // fixed module
    matrix.set(size - 8, 8, 1, true);
}
/**
 * Add encoded data bits to matrix
 *
 * @param  {BitMatrix}  matrix Modules matrix
 * @param  {Uint8Array} data   Data codewords
 */ function $c412bf950f65ef05$var$setupData(matrix, data) {
    const size = matrix.size;
    let inc = -1;
    let row = size - 1;
    let bitIndex = 7;
    let byteIndex = 0;
    for(let col = size - 1; col > 0; col -= 2){
        if (col === 6) col--;
        while(true){
            for(let c = 0; c < 2; c++)if (!matrix.isReserved(row, col - c)) {
                let dark = false;
                if (byteIndex < data.length) dark = (data[byteIndex] >>> bitIndex & 1) === 1;
                matrix.set(row, col - c, dark);
                bitIndex--;
                if (bitIndex === -1) {
                    byteIndex++;
                    bitIndex = 7;
                }
            }
            row += inc;
            if (row < 0 || size <= row) {
                row -= inc;
                inc = -inc;
                break;
            }
        }
    }
}
/**
 * Create encoded codewords from data input
 *
 * @param  {Number}   version              QR Code version
 * @param  {ErrorCorrectionLevel}   errorCorrectionLevel Error correction level
 * @param  {ByteData} data                 Data input
 * @return {Uint8Array}                    Buffer containing encoded codewords
 */ function $c412bf950f65ef05$var$createData(version, errorCorrectionLevel, segments) {
    // Prepare data buffer
    const buffer = new $826a8c47eb337ba0$exports();
    segments.forEach(function(data) {
        // prefix data with mode indicator (4 bits)
        buffer.put(data.mode.bit, 4);
        // Prefix data with character count indicator.
        // The character count indicator is a string of bits that represents the
        // number of characters that are being encoded.
        // The character count indicator must be placed after the mode indicator
        // and must be a certain number of bits long, depending on the QR version
        // and data mode
        // @see {@link Mode.getCharCountIndicator}.
        buffer.put(data.getLength(), $262d80345880615b$export$e79764af6ffaeb8d(data.mode, version));
        // add binary data sequence to buffer
        data.write(buffer);
    });
    // Calculate required number of bits
    const totalCodewords = $ae0eaf7ed71e598d$export$b05dac13c7a35c32(version);
    const ecTotalCodewords = $163ea6b830a815e3$export$683d1b3e8a1a8438(version, errorCorrectionLevel);
    const dataTotalCodewordsBits = (totalCodewords - ecTotalCodewords) * 8;
    // Add a terminator.
    // If the bit string is shorter than the total number of required bits,
    // a terminator of up to four 0s must be added to the right side of the string.
    // If the bit string is more than four bits shorter than the required number of bits,
    // add four 0s to the end.
    if (buffer.getLengthInBits() + 4 <= dataTotalCodewordsBits) buffer.put(0, 4);
    // If the bit string is fewer than four bits shorter, add only the number of 0s that
    // are needed to reach the required number of bits.
    // After adding the terminator, if the number of bits in the string is not a multiple of 8,
    // pad the string on the right with 0s to make the string's length a multiple of 8.
    while(buffer.getLengthInBits() % 8 !== 0)buffer.putBit(0);
    // Add pad bytes if the string is still shorter than the total number of required bits.
    // Extend the buffer to fill the data capacity of the symbol corresponding to
    // the Version and Error Correction Level by adding the Pad Codewords 11101100 (0xEC)
    // and 00010001 (0x11) alternately.
    const remainingByte = (dataTotalCodewordsBits - buffer.getLengthInBits()) / 8;
    for(let i = 0; i < remainingByte; i++)buffer.put(i % 2 ? 0x11 : 0xEC, 8);
    return $c412bf950f65ef05$var$createCodewords(buffer, version, errorCorrectionLevel);
}
/**
 * Encode input data with Reed-Solomon and return codewords with
 * relative error correction bits
 *
 * @param  {BitBuffer} bitBuffer            Data to encode
 * @param  {Number}    version              QR Code version
 * @param  {ErrorCorrectionLevel} errorCorrectionLevel Error correction level
 * @return {Uint8Array}                     Buffer containing encoded codewords
 */ function $c412bf950f65ef05$var$createCodewords(bitBuffer, version, errorCorrectionLevel) {
    // Total codewords for this QR code version (Data + Error correction)
    const totalCodewords = $ae0eaf7ed71e598d$export$b05dac13c7a35c32(version);
    // Total number of error correction codewords
    const ecTotalCodewords = $163ea6b830a815e3$export$683d1b3e8a1a8438(version, errorCorrectionLevel);
    // Total number of data codewords
    const dataTotalCodewords = totalCodewords - ecTotalCodewords;
    // Total number of blocks
    const ecTotalBlocks = $163ea6b830a815e3$export$41a1fc627aca72b9(version, errorCorrectionLevel);
    // Calculate how many blocks each group should contain
    const blocksInGroup2 = totalCodewords % ecTotalBlocks;
    const blocksInGroup1 = ecTotalBlocks - blocksInGroup2;
    const totalCodewordsInGroup1 = Math.floor(totalCodewords / ecTotalBlocks);
    const dataCodewordsInGroup1 = Math.floor(dataTotalCodewords / ecTotalBlocks);
    const dataCodewordsInGroup2 = dataCodewordsInGroup1 + 1;
    // Number of EC codewords is the same for both groups
    const ecCount = totalCodewordsInGroup1 - dataCodewordsInGroup1;
    // Initialize a Reed-Solomon encoder with a generator polynomial of degree ecCount
    const rs = new $e5968549bd660bd4$exports(ecCount);
    let offset = 0;
    const dcData = new Array(ecTotalBlocks);
    const ecData = new Array(ecTotalBlocks);
    let maxDataSize = 0;
    const buffer = new Uint8Array(bitBuffer.buffer);
    // Divide the buffer into the required number of blocks
    for(let b = 0; b < ecTotalBlocks; b++){
        const dataSize = b < blocksInGroup1 ? dataCodewordsInGroup1 : dataCodewordsInGroup2;
        // extract a block of data from buffer
        dcData[b] = buffer.slice(offset, offset + dataSize);
        // Calculate EC codewords for this data block
        ecData[b] = rs.encode(dcData[b]);
        offset += dataSize;
        maxDataSize = Math.max(maxDataSize, dataSize);
    }
    // Create final data
    // Interleave the data and error correction codewords from each block
    const data = new Uint8Array(totalCodewords);
    let index = 0;
    let i, r;
    // Add data codewords
    for(i = 0; i < maxDataSize; i++){
        for(r = 0; r < ecTotalBlocks; r++)if (i < dcData[r].length) data[index++] = dcData[r][i];
    }
    // Apped EC codewords
    for(i = 0; i < ecCount; i++)for(r = 0; r < ecTotalBlocks; r++)data[index++] = ecData[r][i];
    return data;
}
/**
 * Build QR Code symbol
 *
 * @param  {String} data                 Input string
 * @param  {Number} version              QR Code version
 * @param  {ErrorCorretionLevel} errorCorrectionLevel Error level
 * @param  {MaskPattern} maskPattern     Mask pattern
 * @return {Object}                      Object containing symbol data
 */ function $c412bf950f65ef05$var$createSymbol(data, version, errorCorrectionLevel, maskPattern) {
    let segments;
    if (Array.isArray(data)) segments = $cb57a851a537406f$export$571d59b505e6bb4e(data);
    else if (typeof data === "string") {
        let estimatedVersion = version;
        if (!estimatedVersion) {
            const rawSegments = $cb57a851a537406f$export$89ab1afb9839589b(data);
            // Estimate best version that can contain raw splitted segments
            estimatedVersion = $06fdc23db1d37f8e$export$264e969aa7a8ff7e(rawSegments, errorCorrectionLevel);
        }
        // Build optimized segments
        // If estimated version is undefined, try with the highest version
        segments = $cb57a851a537406f$export$3004f64547af360e(data, estimatedVersion || 40);
    } else throw new Error("Invalid data");
    // Get the min version that can contain data
    const bestVersion = $06fdc23db1d37f8e$export$264e969aa7a8ff7e(segments, errorCorrectionLevel);
    // If no version is found, data cannot be stored
    if (!bestVersion) throw new Error("The amount of data is too big to be stored in a QR Code");
    // If not specified, use min version as default
    if (!version) version = bestVersion;
    else if (version < bestVersion) throw new Error("\nThe chosen QR Code version cannot contain this amount of data.\nMinimum version required to store current data is: " + bestVersion + ".\n");
    const dataBits = $c412bf950f65ef05$var$createData(version, errorCorrectionLevel, segments);
    // Allocate matrix buffer
    const moduleCount = $ae0eaf7ed71e598d$export$8d4a06d3facd414b(version);
    const modules = new $a97ef3070731feca$exports(moduleCount);
    // Add function modules
    $c412bf950f65ef05$var$setupFinderPattern(modules, version);
    $c412bf950f65ef05$var$setupTimingPattern(modules);
    $c412bf950f65ef05$var$setupAlignmentPattern(modules, version);
    // Add temporary dummy bits for format info just to set them as reserved.
    // This is needed to prevent these bits from being masked by {@link MaskPattern.applyMask}
    // since the masking operation must be performed only on the encoding region.
    // These blocks will be replaced with correct values later in code.
    $c412bf950f65ef05$var$setupFormatInfo(modules, errorCorrectionLevel, 0);
    if (version >= 7) $c412bf950f65ef05$var$setupVersionInfo(modules, version);
    // Add data codewords
    $c412bf950f65ef05$var$setupData(modules, dataBits);
    if (isNaN(maskPattern)) // Find best mask pattern
    maskPattern = $d9a5de0035d34ab3$export$fe9625aaceb0e563(modules, $c412bf950f65ef05$var$setupFormatInfo.bind(null, modules, errorCorrectionLevel));
    // Apply mask pattern
    $d9a5de0035d34ab3$export$a1c9aa9c0e8ba394(maskPattern, modules);
    // Replace format info bits with correct values
    $c412bf950f65ef05$var$setupFormatInfo(modules, errorCorrectionLevel, maskPattern);
    return {
        modules: modules,
        version: version,
        errorCorrectionLevel: errorCorrectionLevel,
        maskPattern: maskPattern,
        segments: segments
    };
}
$c412bf950f65ef05$export$185802fd694ee1f5 = function create(data, options) {
    if (typeof data === "undefined" || data === "") throw new Error("No input text");
    let errorCorrectionLevel = $85200a578c5005f7$export$3a1a48c8f6ef640e;
    let version;
    let mask;
    if (typeof options !== "undefined") {
        // Use higher error correction level as default
        errorCorrectionLevel = $85200a578c5005f7$export$6788812c4e6611e6(options.errorCorrectionLevel, $85200a578c5005f7$export$3a1a48c8f6ef640e);
        version = $06fdc23db1d37f8e$export$6788812c4e6611e6(options.version);
        mask = $d9a5de0035d34ab3$export$6788812c4e6611e6(options.maskPattern);
        if (options.toSJISFunc) $ae0eaf7ed71e598d$export$6733b14783f975c2(options.toSJISFunc);
    }
    return $c412bf950f65ef05$var$createSymbol(data, version, errorCorrectionLevel, mask);
};


var $177b99fe2c6ba927$export$b3890eb0ae9dca99;
var $177b99fe2c6ba927$export$c3e5526bbaf70a25;
var $2578b2c07a196979$export$d2312e68e1f5ad00;
var $2578b2c07a196979$export$5cdac61cf538712e;
var $2578b2c07a196979$export$c3a1a1f268a8142b;
var $2578b2c07a196979$export$83136f57c739c5f3;
function $2578b2c07a196979$var$hex2rgba(hex) {
    if (typeof hex === "number") hex = hex.toString();
    if (typeof hex !== "string") throw new Error("Color should be defined as hex string");
    let hexCode = hex.slice().replace("#", "").split("");
    if (hexCode.length < 3 || hexCode.length === 5 || hexCode.length > 8) throw new Error("Invalid hex color: " + hex);
    // Convert from short to long form (fff -> ffffff)
    if (hexCode.length === 3 || hexCode.length === 4) hexCode = Array.prototype.concat.apply([], hexCode.map(function(c) {
        return [
            c,
            c
        ];
    }));
    // Add default alpha value
    if (hexCode.length === 6) hexCode.push("F", "F");
    const hexValue = parseInt(hexCode.join(""), 16);
    return {
        r: hexValue >> 24 & 255,
        g: hexValue >> 16 & 255,
        b: hexValue >> 8 & 255,
        a: hexValue & 255,
        hex: "#" + hexCode.slice(0, 6).join("")
    };
}
$2578b2c07a196979$export$d2312e68e1f5ad00 = function getOptions(options) {
    if (!options) options = {};
    if (!options.color) options.color = {};
    const margin = typeof options.margin === "undefined" || options.margin === null || options.margin < 0 ? 4 : options.margin;
    const width = options.width && options.width >= 21 ? options.width : undefined;
    const scale = options.scale || 4;
    return {
        width: width,
        scale: width ? 4 : scale,
        margin: margin,
        color: {
            dark: $2578b2c07a196979$var$hex2rgba(options.color.dark || "#000000ff"),
            light: $2578b2c07a196979$var$hex2rgba(options.color.light || "#ffffffff")
        },
        type: options.type,
        rendererOpts: options.rendererOpts || {}
    };
};
$2578b2c07a196979$export$5cdac61cf538712e = function getScale(qrSize, opts) {
    return opts.width && opts.width >= qrSize + opts.margin * 2 ? opts.width / (qrSize + opts.margin * 2) : opts.scale;
};
$2578b2c07a196979$export$c3a1a1f268a8142b = function getImageWidth(qrSize, opts) {
    const scale = $2578b2c07a196979$export$5cdac61cf538712e(qrSize, opts);
    return Math.floor((qrSize + opts.margin * 2) * scale);
};
$2578b2c07a196979$export$83136f57c739c5f3 = function qrToImageData(imgData, qr, opts) {
    const size = qr.modules.size;
    const data = qr.modules.data;
    const scale = $2578b2c07a196979$export$5cdac61cf538712e(size, opts);
    const symbolSize = Math.floor((size + opts.margin * 2) * scale);
    const scaledMargin = opts.margin * scale;
    const palette = [
        opts.color.light,
        opts.color.dark
    ];
    for(let i = 0; i < symbolSize; i++)for(let j = 0; j < symbolSize; j++){
        let posDst = (i * symbolSize + j) * 4;
        let pxColor = opts.color.light;
        if (i >= scaledMargin && j >= scaledMargin && i < symbolSize - scaledMargin && j < symbolSize - scaledMargin) {
            const iSrc = Math.floor((i - scaledMargin) / scale);
            const jSrc = Math.floor((j - scaledMargin) / scale);
            pxColor = palette[data[iSrc * size + jSrc] ? 1 : 0];
        }
        imgData[posDst++] = pxColor.r;
        imgData[posDst++] = pxColor.g;
        imgData[posDst++] = pxColor.b;
        imgData[posDst] = pxColor.a;
    }
};


function $177b99fe2c6ba927$var$clearCanvas(ctx, canvas, size) {
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    if (!canvas.style) canvas.style = {};
    canvas.height = size;
    canvas.width = size;
    canvas.style.height = size + "px";
    canvas.style.width = size + "px";
}
function $177b99fe2c6ba927$var$getCanvasElement() {
    try {
        return document.createElement("canvas");
    } catch (e) {
        throw new Error("You need to specify a canvas element");
    }
}
$177b99fe2c6ba927$export$b3890eb0ae9dca99 = function render(qrData, canvas, options) {
    let opts = options;
    let canvasEl = canvas;
    if (typeof opts === "undefined" && (!canvas || !canvas.getContext)) {
        opts = canvas;
        canvas = undefined;
    }
    if (!canvas) canvasEl = $177b99fe2c6ba927$var$getCanvasElement();
    opts = $2578b2c07a196979$export$d2312e68e1f5ad00(opts);
    const size = $2578b2c07a196979$export$c3a1a1f268a8142b(qrData.modules.size, opts);
    const ctx = canvasEl.getContext("2d");
    const image = ctx.createImageData(size, size);
    $2578b2c07a196979$export$83136f57c739c5f3(image.data, qrData, opts);
    $177b99fe2c6ba927$var$clearCanvas(ctx, canvasEl, size);
    ctx.putImageData(image, 0, 0);
    return canvasEl;
};
$177b99fe2c6ba927$export$c3e5526bbaf70a25 = function renderToDataURL(qrData, canvas, options) {
    let opts = options;
    if (typeof opts === "undefined" && (!canvas || !canvas.getContext)) {
        opts = canvas;
        canvas = undefined;
    }
    if (!opts) opts = {};
    const canvasEl = $177b99fe2c6ba927$export$b3890eb0ae9dca99(qrData, canvas, opts);
    const type = opts.type || "image/png";
    const rendererOpts = opts.rendererOpts || {};
    return canvasEl.toDataURL(type, rendererOpts.quality);
};


var $e20e697aa582b31b$export$b3890eb0ae9dca99;

function $e20e697aa582b31b$var$getColorAttrib(color, attrib) {
    const alpha = color.a / 255;
    const str = attrib + '="' + color.hex + '"';
    return alpha < 1 ? str + " " + attrib + '-opacity="' + alpha.toFixed(2).slice(1) + '"' : str;
}
function $e20e697aa582b31b$var$svgCmd(cmd, x, y) {
    let str = cmd + x;
    if (typeof y !== "undefined") str += " " + y;
    return str;
}
function $e20e697aa582b31b$var$qrToPath(data, size, margin) {
    let path = "";
    let moveBy = 0;
    let newRow = false;
    let lineLength = 0;
    for(let i = 0; i < data.length; i++){
        const col = Math.floor(i % size);
        const row = Math.floor(i / size);
        if (!col && !newRow) newRow = true;
        if (data[i]) {
            lineLength++;
            if (!(i > 0 && col > 0 && data[i - 1])) {
                path += newRow ? $e20e697aa582b31b$var$svgCmd("M", col + margin, 0.5 + row + margin) : $e20e697aa582b31b$var$svgCmd("m", moveBy, 0);
                moveBy = 0;
                newRow = false;
            }
            if (!(col + 1 < size && data[i + 1])) {
                path += $e20e697aa582b31b$var$svgCmd("h", lineLength);
                lineLength = 0;
            }
        } else moveBy++;
    }
    return path;
}
$e20e697aa582b31b$export$b3890eb0ae9dca99 = function render(qrData, options, cb) {
    const opts = $2578b2c07a196979$export$d2312e68e1f5ad00(options);
    const size = qrData.modules.size;
    const data = qrData.modules.data;
    const qrcodesize = size + opts.margin * 2;
    const bg = !opts.color.light.a ? "" : "<path " + $e20e697aa582b31b$var$getColorAttrib(opts.color.light, "fill") + ' d="M0 0h' + qrcodesize + "v" + qrcodesize + 'H0z"/>';
    const path = "<path " + $e20e697aa582b31b$var$getColorAttrib(opts.color.dark, "stroke") + ' d="' + $e20e697aa582b31b$var$qrToPath(data, size, opts.margin) + '"/>';
    const viewBox = 'viewBox="0 0 ' + qrcodesize + " " + qrcodesize + '"';
    const width = !opts.width ? "" : 'width="' + opts.width + '" height="' + opts.width + '" ';
    const svgTag = '<svg xmlns="http://www.w3.org/2000/svg" ' + width + viewBox + ' shape-rendering="crispEdges">' + bg + path + "</svg>\n";
    if (typeof cb === "function") cb(null, svgTag);
    return svgTag;
};


function $d452087480f7647a$var$renderCanvas(renderFunc, canvas, text, opts, cb) {
    const args = [].slice.call(arguments, 1);
    const argsNum = args.length;
    const isLastArgCb = typeof args[argsNum - 1] === "function";
    if (!isLastArgCb && !$a9657f3e8f777016$exports()) throw new Error("Callback required as last argument");
    if (isLastArgCb) {
        if (argsNum < 2) throw new Error("Too few arguments provided");
        if (argsNum === 2) {
            cb = text;
            text = canvas;
            canvas = opts = undefined;
        } else if (argsNum === 3) {
            if (canvas.getContext && typeof cb === "undefined") {
                cb = opts;
                opts = undefined;
            } else {
                cb = opts;
                opts = text;
                text = canvas;
                canvas = undefined;
            }
        }
    } else {
        if (argsNum < 1) throw new Error("Too few arguments provided");
        if (argsNum === 1) {
            text = canvas;
            canvas = opts = undefined;
        } else if (argsNum === 2 && !canvas.getContext) {
            opts = text;
            text = canvas;
            canvas = undefined;
        }
        return new Promise(function(resolve, reject) {
            try {
                const data = $c412bf950f65ef05$export$185802fd694ee1f5(text, opts);
                resolve(renderFunc(data, canvas, opts));
            } catch (e) {
                reject(e);
            }
        });
    }
    try {
        const data = $c412bf950f65ef05$export$185802fd694ee1f5(text, opts);
        cb(null, renderFunc(data, canvas, opts));
    } catch (e) {
        cb(e);
    }
}
$d452087480f7647a$export$185802fd694ee1f5 = $c412bf950f65ef05$export$185802fd694ee1f5;
$d452087480f7647a$export$f87f6982d1fd4f81 = $d452087480f7647a$var$renderCanvas.bind(null, $177b99fe2c6ba927$export$b3890eb0ae9dca99);
$d452087480f7647a$export$723e4939e5a27c8 = $d452087480f7647a$var$renderCanvas.bind(null, $177b99fe2c6ba927$export$c3e5526bbaf70a25);
$d452087480f7647a$export$f84e8e69fd4488a5 = $d452087480f7647a$var$renderCanvas.bind(null, function(data, _, opts) {
    return $e20e697aa582b31b$export$b3890eb0ae9dca99(data, opts);
});


const $67e1576cd7fc37b7$export$bbfd0bb0baceb2f8 = "application/vnd.microsoft.card.adaptive";
const $67e1576cd7fc37b7$export$264354e75632a3ba = "application/vnd.microsoft.card.hero";
const $67e1576cd7fc37b7$export$7ff82c027074e396 = "application/vnd.davi.retorik.card.news";
const $67e1576cd7fc37b7$export$8c612ad42a82284 = "application/vnd.davi.retorik.card.poi";
const $67e1576cd7fc37b7$export$4e4550ddaa0ad2f9 = "application/vnd.davi.retorik.card.pagination";
const $67e1576cd7fc37b7$export$9399f66a54c38cac = "application/vnd.davi.retorik.card.empty";
const $67e1576cd7fc37b7$export$c50891df8986f6d9 = "application/vnd.davi.retorik.card.image";
const $67e1576cd7fc37b7$export$cce25171fe980112 = "application/vnd.davi.retorik.card.link";
const $67e1576cd7fc37b7$export$8ebd8d161896e63a = "application/vnd.davi.retorik.card.discover";
const $67e1576cd7fc37b7$export$a4f2f23a67537f78 = "application/vnd.davi.retorik.card.suggestion";
const $67e1576cd7fc37b7$export$2730c89e9ebd0948 = "application/vnd.davi.retorik.card.suggestedaction";


const $3f68a0a0632324e9$var$createLinkAttachmentCard = async ({ url: url, title: title, download: download })=>{
    const qrcode = await (0, (/*@__PURE__*/$parcel$interopDefault($d452087480f7647a$exports))).toDataURL(url);
    const hasTitle = title && !title.includes("pause0x0") && !title.includes("pause1x1") && !title.includes("pause2x2");
    return {
        contentType: (0, $67e1576cd7fc37b7$export$cce25171fe980112),
        content: {
            urlData: {
                url: url,
                title: hasTitle ? title : undefined,
                download: download
            },
            qrCode: qrcode
        }
    };
};
const $3f68a0a0632324e9$export$bd1cb79b05472e01 = async (urlDataArray)=>{
    const splitAttachments = [];
    for (const data of urlDataArray){
        const qrcode = await (0, (/*@__PURE__*/$parcel$interopDefault($d452087480f7647a$exports))).toDataURL(data.url);
        const newLinkAttachment = {
            contentType: (0, $67e1576cd7fc37b7$export$cce25171fe980112),
            content: {
                urlData: {
                    url: data.url,
                    title: data.title,
                    download: data.download
                },
                qrCode: qrcode
            }
        };
        splitAttachments.push(newLinkAttachment);
    }
    return splitAttachments;
};
var $3f68a0a0632324e9$export$2e2bcd8739ae039 = $3f68a0a0632324e9$var$createLinkAttachmentCard;




const $ece6f00909886802$var$createImageAttachmentCard = async (imageData)=>{
    const naturalSize = await $ece6f00909886802$var$getNaturalSize(imageData.url);
    let miniaturedDisplay = false;
    // If an error occured, we retrieve width = 0 and height = 0
    if (naturalSize.width === 0 && naturalSize.height === 0) imageData = {
        url: `${(0, $9062ab1ccebf2f9e$export$e56d88b19b5c9fbf).noimage}`,
        alt: "Image no found"
    };
    else miniaturedDisplay = naturalSize.width < 400 && naturalSize.height < 300;
    return {
        contentType: (0, $67e1576cd7fc37b7$export$c50891df8986f6d9),
        content: {
            ...imageData,
            isMiniature: miniaturedDisplay
        }
    };
};
const $ece6f00909886802$var$getNaturalSize = async (url)=>{
    return new Promise((resolve)=>{
        const img = new Image();
        img.onload = ()=>resolve({
                width: img.naturalWidth,
                height: img.naturalHeight
            });
        img.onerror = ()=>{
            resolve({
                width: 0,
                height: 0
            });
        };
        img.src = url;
    });
};
var $ece6f00909886802$export$2e2bcd8739ae039 = $ece6f00909886802$var$createImageAttachmentCard;


var $462e820625752270$exports = {};
"use strict";

$462e820625752270$exports = (parcelRequire("3E5Ww"));


var $0005a2081ed17843$exports = {};
"use strict";
Object.defineProperty($0005a2081ed17843$exports, "__esModule", {
    value: true
});
var $e822f5a6e821446b$exports = {};
"use strict";
var $e822f5a6e821446b$var$__assign = $e822f5a6e821446b$exports && $e822f5a6e821446b$exports.__assign || function() {
    $e822f5a6e821446b$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $e822f5a6e821446b$var$__assign.apply(this, arguments);
};
var $e822f5a6e821446b$var$__importStar = $e822f5a6e821446b$exports && $e822f5a6e821446b$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result["default"] = mod;
    return result;
};
Object.defineProperty($e822f5a6e821446b$exports, "__esModule", {
    value: true
});

var $e822f5a6e821446b$var$factory = $e822f5a6e821446b$var$__importStar((parcelRequire("fH33H")));
var $fe9ae0483961e692$exports = {};
"use strict";
Object.defineProperty($fe9ae0483961e692$exports, "__esModule", {
    value: true
});
var $311e31ab8024e26f$exports = {};
// Myna Parsing Library
// Copyright (c) 2016 Christopher Diggins
// Usage permitted under terms of MIT License
"use strict";
var $311e31ab8024e26f$var$__extends = $311e31ab8024e26f$exports && $311e31ab8024e26f$exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
// A parsing combinator library for JavaScript/TypeScript based on the PEG formalism.
// For more information see http://www.github.com/cdiggins/myna-parser
var $311e31ab8024e26f$var$Myna;
(function(Myna) {
    // A parser error class
    var ParserError = function(_super) {
        $311e31ab8024e26f$var$__extends(ParserError, _super);
        function ParserError(message) {
            _super.call(this, message);
            this.type = "ParserError";
        }
        return ParserError;
    }(Error);
    Myna.ParserError = ParserError;
    //====================================================================================
    // Internal variables used by the Myna library
    // A lookup table of all grammars registered with the Myna module 
    Myna.grammars = {};
    // A lookup table of all named rules registered with the Myna module
    Myna.allRules = {};
    // A lookup table of parsing functions for each registered grammar  
    Myna.parsers = {};
    //===========================================================================
    // class ParseLocation
    // Used to indicate the location of the parser to the user in a pleasant way.
    var ParseLocation = function() {
        function ParseLocation(input, index) {
            this.input = input;
            this.index = index;
            this.lineNum = 0;
            this.colNum = 0;
            this.lineStart = 0;
            this.lineEnd = 0;
            var r1 = 0;
            var r2 = 1;
            for(var i = 0; i < this.index; ++i){
                if (this.input.charCodeAt(i) == 13) {
                    this.lineStart = i;
                    r1++;
                }
                if (this.input.charCodeAt(i) == 10) {
                    this.lineStart = i;
                    r2++;
                }
            }
            for(this.lineEnd = this.index; this.lineEnd < this.input.length; ++this.lineEnd){
                if (this.input.charCodeAt(this.lineEnd) == 13 || this.input.charCodeAt(this.lineEnd) == 10) break;
            }
            this.lineNum = r1 > r2 ? r1 : r2;
            this.colNum = this.index - this.lineStart;
            this.lineText = this.input.substring(this.lineStart, this.lineEnd);
            this.pointerText = Array(this.colNum).join(" ") + "^";
        }
        ParseLocation.prototype.toString = function() {
            return "Index " + this.index + ", Line " + this.lineNum + ", Column " + this.colNum + "\n" + this.lineText + "\n" + this.pointerText;
        };
        return ParseLocation;
    }();
    Myna.ParseLocation = ParseLocation;
    //===========================================================================
    // class ParseState
    // This stores the state of the parser and is passed to the parse and match functions.
    var ParseState = function() {
        function ParseState(input, index, nodes) {
            this.input = input;
            this.index = index;
            this.nodes = nodes;
            this.length = 0;
            this.rules = [];
            this.length = this.input.length;
        }
        Object.defineProperty(ParseState.prototype, "location", {
            // Returns an object that representation of the location. 
            get: function() {
                return new ParseLocation(this.input, this.index);
            },
            enumerable: true,
            configurable: true
        });
        return ParseState;
    }();
    Myna.ParseState = ParseState;
    // Represents a node in the generated parse tree. These nodes are returned by the Rule.parse function. If a Rule 
    // has the "_createAstNode" field set to true (because you created the rule using the ".ast" property), then the 
    // generated node will also be added to the constructed parse tree.   
    var AstNode = function() {
        // Constructs a new node associated with the given rule.  
        function AstNode(rule, input, start, end) {
            if (start === void 0) start = 0;
            if (end === void 0) end = -1;
            this.rule = rule;
            this.input = input;
            this.start = start;
            this.end = end;
            // The list of child nodes in the parse tree. 
            // This is not allocated unless used, to minimize memory consumption 
            this.children = null;
        }
        Object.defineProperty(AstNode.prototype, "name", {
            // Returns the name of the rule associated with this node
            get: function() {
                return this.rule != null ? this.rule.name : "unnamed";
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(AstNode.prototype, "fullName", {
            // Returns the name of the rule, preceded by the grammar name, associated with this node
            get: function() {
                return this.rule != null ? this.rule.fullName : "unnamed";
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(AstNode.prototype, "allText", {
            // Returns the parsed text associated with this node's start and end locations  
            get: function() {
                return this.input.slice(this.start, this.end);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(AstNode.prototype, "isLeaf", {
            // Returns true if this node has no children
            get: function() {
                return this.children == null || this.children.length == 0;
            },
            enumerable: true,
            configurable: true
        });
        // Returns the first child with the given name, or null if no named child is found. 
        AstNode.prototype.child = function(name) {
            if (this.children) for(var _i = 0, _a = this.children; _i < _a.length; _i++){
                var c = _a[_i];
                if (c.name == name) return c;
            }
            return null;
        };
        Object.defineProperty(AstNode.prototype, "_firstChildStart", {
            // The position of the first child, or the end position for the entire node if no children 
            get: function() {
                return this.isLeaf ? this.end : this.children[0].start;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(AstNode.prototype, "_lastChildEnd", {
            // The end position of the last child, or the end position for the entire node if no children 
            get: function() {
                return this.isLeaf ? this.end : this.children[0].end;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(AstNode.prototype, "beforeChildrenText", {
            // Returns the text before the children, or if no children returns the entire text. 
            get: function() {
                return this.input.slice(this.start, this._firstChildStart);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(AstNode.prototype, "afterChildrenText", {
            // Returns the text after the children, or if no children returns the empty string.
            get: function() {
                return this.input.slice(this._lastChildEnd, this.end);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(AstNode.prototype, "allChildrenText", {
            // Returns the text from the beginning of the first child to the end of the last child.
            get: function() {
                return this.input.slice(this._firstChildStart, this._lastChildEnd);
            },
            enumerable: true,
            configurable: true
        });
        // Returns the AST as a string for debug and test purposes
        AstNode.prototype.toString = function() {
            var contents = this.isLeaf ? this.allText : this.children.map(function(c) {
                return c.toString();
            }).join(" ");
            return "(" + this.rule.name + ": " + contents + ")";
        };
        return AstNode;
    }();
    Myna.AstNode = AstNode;
    //===============================================================
    // class Rule
    // A Rule is both a rule in the PEG grammar and a parser. The parse function takes  
    // a particular parse location (in either a string, or array of tokens) and will return 
    // the location of the end of the parse if successful or null if not successful.  
    var Rule = function() {
        // Constructor
        // Note: child-rules are exposed as a public field
        function Rule(rules) {
            this.rules = rules;
            // Identifies individual rule
            this.name = "";
            // Identifies the grammar that this rule belongs to 
            this.grammarName = "";
            // Identifies types of rules. Rules can have "types" that are different than the class name
            this.type = "";
            // Used to provide access to the name of the class 
            this.className = "Rule";
            // Indicates whether generated nodes should be added to the abstract syntax tree
            this._createAstNode = false;
            // A parser function, computed in a rule's constructor. If successful returns either the original or a new 
            // ParseState object. If it fails it returns null.
            this.parser = null;
            // A lexer function, computed in a rule's constructor. The lexer may update the ParseState if successful.
            // If it fails it is required that the lexer restore the ParseState index to the previous state. 
            // Lexers should only update the index. 
            this.lexer = null;
        }
        // Creates a node with the given children. This is used to manually build parts of the AST.
        Rule.prototype.node = function(text) {
            if (text === void 0) text = "";
            var children = [];
            for(var _i = 1; _i < arguments.length; _i++)children[_i - 1] = arguments[_i];
            var r = new AstNode(this, text, 0, text.length);
            r.children = children;
            return r;
        };
        // Parses a string into an AST node
        Rule.prototype.parse = function(s) {
            return Myna.parse(this, s);
        };
        // Sets the name of the rule, and the grammar 
        // Warning: this modifies the rule, use "copy" first if you don't want to update the rule.
        Rule.prototype.setName = function(grammarName, ruleName) {
            this.grammarName = grammarName;
            this.name = ruleName;
            return this;
        };
        Object.defineProperty(Rule.prototype, "definition", {
            // Returns a default definition of the rule
            get: function() {
                return this.className + "(" + this.rules.map(function(r) {
                    return r.toString();
                }).join(", ") + ")";
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Rule.prototype, "fullName", {
            // Returns the name of the rule preceded by the grammar name and a "."
            get: function() {
                return this.grammarName + "." + this.name;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Rule.prototype, "nameOrDefinition", {
            // Returns either the name of the rule, or it's definition
            get: function() {
                return this.name ? this.fullName : this.definition;
            },
            enumerable: true,
            configurable: true
        });
        // Returns a string representation of the rule 
        Rule.prototype.toString = function() {
            return this.nameOrDefinition;
        };
        Object.defineProperty(Rule.prototype, "firstChild", {
            // Returns the first child rule
            get: function() {
                return this.rules[0];
            },
            enumerable: true,
            configurable: true
        });
        // Sets the "type" associated with the rule. 
        // This is useful for tracking how a rule was created. 
        Rule.prototype.setType = function(type) {
            this.type = type;
            return this;
        };
        // Returns a copy of this rule with default values for all fields.  
        // Note: Every new rule class must override cloneImplemenation
        Rule.prototype.cloneImplementation = function() {
            throw new Error("Missing override for cloneImplementation");
        };
        Object.defineProperty(Rule.prototype, "copy", {
            // Returns a copy of this rule with all fields copied.  
            get: function() {
                var r = this.cloneImplementation();
                if (typeof r !== typeof this) throw new Error("Error in implementation of cloneImplementation: not returning object of correct type");
                r.name = this.name;
                r.grammarName = this.grammarName;
                r._createAstNode = this._createAstNode;
                return r;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Rule.prototype, "hasAstChildRule", {
            // Returns true if any of the child rules are "ast rules" meaning they create nodes in the parse tree.
            get: function() {
                return this.rules.filter(function(r) {
                    return r.createsAstNode;
                }).length > 0;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Rule.prototype, "createsAstNode", {
            // Returns true if this rule when parsed successfully will create a node in the parse tree. 
            // Some rules will override this function. 
            get: function() {
                return this._createAstNode;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Rule.prototype, "nonAdvancing", {
            // Returns true if this rule doesn't advance the input
            get: function() {
                return false;
            },
            enumerable: true,
            configurable: true
        });
        // Returns a string that describes the AST nodes created by this rule.
        // Will throw an exception if this is not a valid AST rule (this.isAstRule != true)
        Rule.prototype.astRuleDefn = function(inSeq, inChoice) {
            if (inSeq === void 0) inSeq = false;
            if (inChoice === void 0) inChoice = false;
            var rules = this.rules.filter(function(r) {
                return r.createsAstNode;
            });
            if (!rules.length) return this.name;
            if (rules.length == 1) {
                var result = rules[0].astRuleNameOrDefn(inSeq, inChoice);
                if (this instanceof Quantified) result += "[" + this.min + "," + this.max + "]";
                return result;
            }
            if (this instanceof Sequence) {
                var tmp = rules.map(function(r) {
                    return r.astRuleNameOrDefn(true, false);
                }).join(",");
                if (inSeq) return tmp;
                return "seq(" + tmp + ")";
            }
            if (this instanceof Choice) {
                var tmp = rules.map(function(r) {
                    return r.astRuleNameOrDefn(false, true);
                }).join(",");
                if (inChoice) return tmp;
                return "choice(" + tmp + ")";
            }
            throw new Error("Internal error: not a valid AST rule");
        };
        // Returns a string that is either the name of the AST parse node, or a definition 
        // (schema) describing the makeup of the rules. 
        Rule.prototype.astRuleNameOrDefn = function(inSeq, inChoice) {
            if (inSeq === void 0) inSeq = false;
            if (inChoice === void 0) inChoice = false;
            if (this._createAstNode) return this.name;
            return this.astRuleDefn(inSeq, inChoice);
        };
        Object.defineProperty(Rule.prototype, "opt", {
            //======================================================
            // Extensions to support method/property chaining. 
            // This is also known as a fluent API syntax
            get: function() {
                return opt(this);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Rule.prototype, "zeroOrMore", {
            get: function() {
                return zeroOrMore(this);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Rule.prototype, "oneOrMore", {
            get: function() {
                return oneOrMore(this);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Rule.prototype, "at", {
            get: function() {
                return at(this);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Rule.prototype, "not", {
            get: function() {
                return not(this);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Rule.prototype, "advance", {
            get: function() {
                return this.then(Myna.advance);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Rule.prototype, "ws", {
            get: function() {
                return this.then(Myna.ws);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Rule.prototype, "all", {
            get: function() {
                return this.then(Myna.all);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Rule.prototype, "end", {
            get: function() {
                return this.then(Myna.end);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Rule.prototype, "assert", {
            get: function() {
                return assert(this);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Rule.prototype, "ast", {
            get: function() {
                return new AstRule(this);
            },
            enumerable: true,
            configurable: true
        });
        Rule.prototype.then = function(r) {
            return seq(this, r);
        };
        Rule.prototype.thenAt = function(r) {
            return this.then(at(r));
        };
        Rule.prototype.thenNot = function(r) {
            return this.then(not(r));
        };
        Rule.prototype.or = function(r) {
            return choice(this, r);
        };
        Rule.prototype.until = function(r) {
            return repeatWhileNot(this, r);
        };
        Rule.prototype.untilPast = function(r) {
            return repeatUntilPast(this, r);
        };
        Rule.prototype.repeat = function(count) {
            return repeat(this, count);
        };
        Rule.prototype.quantified = function(min, max) {
            return quantified(this, min, max);
        };
        Rule.prototype.delimited = function(delimiter) {
            return delimited(this, delimiter);
        };
        Rule.prototype.unless = function(r) {
            return unless(this, r);
        };
        return Rule;
    }();
    Myna.Rule = Rule;
    //===============================================================
    // Rule derived classes 
    // These are the core Rule classes of Myna. Normally you would not use theses directly but use the factory methods
    // If you fork this code, think twice before adding new classes here. Maybe you can implement your new Rule
    // in terms of functions or other low-level rules. Then you can be happy knowing that the same code is being 
    // re-used and tested all the time.  
    // Creates a node in the AST tree 
    var AstRule = function(_super) {
        $311e31ab8024e26f$var$__extends(AstRule, _super);
        function AstRule(r) {
            var _this = this;
            _super.call(this, [
                r
            ]);
            this.r = r;
            this.type = "ast";
            this.className = "AstRule";
            this._createAstNode = true;
            this.parser = function(p) {
                var originalIndex = p.index;
                var originalNodes = p.nodes;
                p.nodes = [];
                p.rules.push(_this);
                if (!r.parser(p)) {
                    p.rules.pop();
                    p.nodes = originalNodes;
                    p.index = originalIndex;
                    return false;
                } else {
                    p.rules.pop();
                    var node = new AstNode(_this, p.input, originalIndex, p.index);
                    node.children = p.nodes;
                    p.nodes = originalNodes;
                    p.nodes.push(node);
                    return true;
                }
            };
            this.lexer = r.lexer;
        }
        return AstRule;
    }(Rule);
    Myna.AstRule = AstRule;
    // Matches a series of rules in order. Succeeds only if all sub-rules succeed. 
    var Sequence = function(_super) {
        $311e31ab8024e26f$var$__extends(Sequence, _super);
        function Sequence(rule1, rule2) {
            _super.call(this, [
                rule1,
                rule2
            ]);
            this.rule1 = rule1;
            this.rule2 = rule2;
            this.type = "seq";
            this.className = "Sequence";
            this.parser = function(p) {
                var originalCount = p.nodes.length;
                var originalIndex = p.index;
                if (rule1.parser(p) === false) // The first parser will restore everything automatically 
                return false;
                if (rule2.parser(p) === false) {
                    // Any created nodes need to be popped off the list 
                    if (p.nodes.length !== originalCount) p.nodes.splice(-1, p.nodes.length - originalCount);
                    // Assure that the parser is restored to its original position 
                    p.index = originalIndex;
                    return false;
                }
                return true;
            };
            this.lexer = function(p) {
                var original = p.index;
                if (rule1.lexer(p) === false) return false;
                if (rule2.lexer(p) === false) {
                    p.index = original;
                    return false;
                }
                return true;
            };
            // When none of the child rules create a node, we can use the lexer to parse
            if (!this.createsAstNode) this.parser = this.lexer;
        }
        Object.defineProperty(Sequence.prototype, "definition", {
            get: function() {
                var result = this.rules.map(function(r) {
                    return r.toString();
                }).join(" ");
                if (this.rules.length > 1) result = "(" + result + ")";
                return result;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Sequence.prototype, "nonAdvancing", {
            get: function() {
                return this.rules.every(function(r) {
                    return r.nonAdvancing;
                });
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Sequence.prototype, "createsAstNode", {
            get: function() {
                return this._createAstNode || this.hasAstChildRule;
            },
            enumerable: true,
            configurable: true
        });
        Sequence.prototype.cloneImplementation = function() {
            return new Sequence(this.rule1, this.rule2);
        };
        return Sequence;
    }(Rule);
    Myna.Sequence = Sequence;
    // Tries to match each rule in order until one succeeds. Succeeds if any of the sub-rules succeed. 
    var Choice = function(_super) {
        $311e31ab8024e26f$var$__extends(Choice, _super);
        function Choice(rule1, rule2) {
            _super.call(this, [
                rule1,
                rule2
            ]);
            this.rule1 = rule1;
            this.rule2 = rule2;
            this.type = "choice";
            this.className = "Choice";
            this.parser = function(p) {
                return rule1.parser(p) || rule2.parser(p);
            };
            this.lexer = function(p) {
                return rule1.lexer(p) || rule2.lexer(p);
            };
            // When none of the child rules create a node, we can use the lexer to parse
            if (!this.createsAstNode) this.parser = this.lexer;
        }
        Object.defineProperty(Choice.prototype, "definition", {
            get: function() {
                var result = this.rules.map(function(r) {
                    return r.toString();
                }).join(" / ");
                if (this.rules.length > 1) result = "(" + result + ")";
                return result;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Choice.prototype, "nonAdvancing", {
            get: function() {
                return this.rules.every(function(r) {
                    return r.nonAdvancing;
                });
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Choice.prototype, "createsAstNode", {
            get: function() {
                return this._createAstNode || this.hasAstChildRule;
            },
            enumerable: true,
            configurable: true
        });
        Choice.prototype.cloneImplementation = function() {
            return new Choice(this.rule1, this.rule2);
        };
        return Choice;
    }(Rule);
    Myna.Choice = Choice;
    // A generalization of several rules such as zeroOrMore (0+), oneOrMore (1+), opt(0 or 1),
    // When matching with an unbounded upper limit set the maxium to  -1   
    var Quantified = function(_super) {
        $311e31ab8024e26f$var$__extends(Quantified, _super);
        function Quantified(rule, min, max) {
            var _this = this;
            if (min === void 0) min = 0;
            if (max === void 0) max = Infinity;
            _super.call(this, [
                rule
            ]);
            this.min = min;
            this.max = max;
            this.type = "quantified";
            this.className = "Quantified";
            if (max === Infinity && rule.nonAdvancing) throw new Error("Rule would create an infinite loop");
            this.parser = function(p) {
                var originalCount = p.nodes.length;
                var originalIndex = p.index;
                for(var i = 0; i < max; ++i){
                    // If parsing the rule fails, we return the last result, or failed 
                    // if the minimum number of matches is not met. 
                    if (rule.parser(p) === false) {
                        if (i >= min) return true;
                        // Any created nodes need to be popped off the list 
                        if (p.nodes.length !== originalCount) p.nodes.splice(-1, p.nodes.length - originalCount);
                        // Assure that the parser is restored to its original position 
                        p.index = originalIndex;
                        return false;
                    }
                    // Check for progress, to assure we aren't hitting an infinite loop  
                    debugAssert(max !== Infinity || p.index !== originalIndex, _this);
                }
                return true;
            };
            this.lexer = function(p) {
                var originalIndex = p.index;
                for(var i = 0; i < max; ++i){
                    if (rule.lexer(p) === false) {
                        if (i >= min) return true;
                        p.index = originalIndex;
                        return false;
                    }
                    // Check for progress, to assure we aren't hitting an infinite loop  
                    debugAssert(max !== Infinity || p.index !== originalIndex, _this, "Infinite loop");
                }
                return true;
            };
            // When none of the child rules create a node, we can use the lexer to parse
            if (!this.createsAstNode) this.parser = this.lexer;
        }
        Object.defineProperty(Quantified.prototype, "definition", {
            // Used for creating a human readable definition of the grammar.
            get: function() {
                if (this.min == 0 && this.max == 1) return this.firstChild.toString() + "?";
                if (this.min == 0 && this.max == Infinity) return this.firstChild.toString() + "*";
                if (this.min == 1 && this.max == Infinity) return this.firstChild.toString() + "+";
                return this.firstChild.toString() + "{" + this.min + "," + this.max + "}";
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Quantified.prototype, "createsAstNode", {
            get: function() {
                return this._createAstNode || this.hasAstChildRule;
            },
            enumerable: true,
            configurable: true
        });
        Quantified.prototype.cloneImplementation = function() {
            return new Quantified(this.firstChild, this.min, this.max);
        };
        return Quantified;
    }(Rule);
    Myna.Quantified = Quantified;
    // Matches a child rule zero or once. 
    var Optional = function(_super) {
        $311e31ab8024e26f$var$__extends(Optional, _super);
        function Optional(rule) {
            _super.call(this, rule, 0, 1);
            this.type = "optional";
            this.className = "Optional";
            this.parser = function(p) {
                rule.parser(p);
                return true;
            };
            this.lexer = function(p) {
                rule.lexer(p);
                return true;
            };
            // When none of the child rules create a node, we can use the lexer to parse
            if (!this.createsAstNode) this.parser = this.lexer;
        }
        Object.defineProperty(Optional.prototype, "definition", {
            // Used for creating a human readable definition of the grammar.
            get: function() {
                return this.firstChild.toString() + "?";
            },
            enumerable: true,
            configurable: true
        });
        Optional.prototype.cloneImplementation = function() {
            return new Optional(this.firstChild);
        };
        return Optional;
    }(Quantified);
    Myna.Optional = Optional;
    // Advances the parser by one token unless at the end
    var Advance = function(_super) {
        $311e31ab8024e26f$var$__extends(Advance, _super);
        function Advance() {
            _super.call(this, []);
            this.type = "advance";
            this.className = "Advance";
            this.lexer = function(p) {
                return p.index < p.length ? ++p.index >= 0 : false;
            };
            this.parser = this.lexer;
        }
        Object.defineProperty(Advance.prototype, "definition", {
            get: function() {
                return "<advance>";
            },
            enumerable: true,
            configurable: true
        });
        Advance.prototype.cloneImplementation = function() {
            return new Advance();
        };
        return Advance;
    }(Rule);
    Myna.Advance = Advance;
    // Advances the parser by one token if the predicate is true.
    var AdvanceIf = function(_super) {
        $311e31ab8024e26f$var$__extends(AdvanceIf, _super);
        function AdvanceIf(condition) {
            _super.call(this, [
                condition
            ]);
            this.type = "advanceIf";
            this.className = "AdvanceIf";
            this.lexer = function(p) {
                return condition.lexer(p) && p.index < p.length ? ++p.index !== 0 : false;
            };
            this.parser = this.lexer;
        }
        Object.defineProperty(AdvanceIf.prototype, "definition", {
            get: function() {
                return "advanceIf(" + this.firstChild.toString() + ")";
            },
            enumerable: true,
            configurable: true
        });
        AdvanceIf.prototype.cloneImplementation = function() {
            return new AdvanceIf(this.firstChild);
        };
        return AdvanceIf;
    }(Rule);
    Myna.AdvanceIf = AdvanceIf;
    // Used to match a string in the input string, advances the token. 
    var Text = function(_super) {
        $311e31ab8024e26f$var$__extends(Text, _super);
        function Text(text) {
            _super.call(this, []);
            this.text = text;
            this.type = "text";
            this.className = "Text";
            var length = text.length;
            var vals = [];
            for(var i = 0; i < length; ++i)vals.push(text.charCodeAt(i));
            this.lexer = function(p) {
                var index = p.index;
                if (index + vals.length > p.input.length) return false;
                // TODO: consider pulling the sub-string out of the text.        
                for(var _i = 0, vals_1 = vals; _i < vals_1.length; _i++){
                    var val = vals_1[_i];
                    if (p.input.charCodeAt(index++) !== val) return false;
                }
                p.index = index;
                return true;
            };
            this.parser = this.lexer;
        }
        Object.defineProperty(Text.prototype, "definition", {
            get: function() {
                return '"' + escapeChars(this.text) + '"';
            },
            enumerable: true,
            configurable: true
        });
        Text.prototype.cloneImplementation = function() {
            return new Text(this.text);
        };
        return Text;
    }(Rule);
    Myna.Text = Text;
    // Used to match a string in the input string ignoring case, advances the token. 
    var AnyCaseText = function(_super) {
        $311e31ab8024e26f$var$__extends(AnyCaseText, _super);
        function AnyCaseText(text) {
            _super.call(this, []);
            this.text = text;
            this.type = "anyCaseText";
            this.className = "AnyCaseText";
            text = text.toLowerCase();
            this.text = text;
            var length = text.length;
            var vals = [];
            for(var i = 0; i < length; ++i)vals.push(text[i]);
            this.lexer = function(p) {
                var index = p.index;
                if (index + vals.length > p.input.length) return false;
                for(var _i = 0, vals_2 = vals; _i < vals_2.length; _i++){
                    var val = vals_2[_i];
                    if (p.input[index++].toLowerCase() !== val) return false;
                }
                p.index = index;
                return true;
            };
            this.parser = this.lexer;
        }
        Object.defineProperty(AnyCaseText.prototype, "definition", {
            get: function() {
                return 'AnyCase("' + escapeChars(this.text) + '")';
            },
            enumerable: true,
            configurable: true
        });
        AnyCaseText.prototype.cloneImplementation = function() {
            return new AnyCaseText(this.text);
        };
        return AnyCaseText;
    }(Rule);
    Myna.AnyCaseText = AnyCaseText;
    // Creates a rule that is defined from a function that generates the rule. 
    // This allows two rules to have a cyclic relation. 
    var Delay = function(_super) {
        $311e31ab8024e26f$var$__extends(Delay, _super);
        function Delay(fn) {
            _super.call(this, []);
            this.fn = fn;
            this.type = "delay";
            this.className = "Delay";
            var tmpParser = null;
            this.parser = function(p) {
                return (tmpParser ? tmpParser : tmpParser = fn().parser)(p);
            };
            var tmpLexer = null;
            this.lexer = function(p) {
                return (tmpLexer ? tmpLexer : tmpLexer = fn().lexer)(p);
            };
        }
        Delay.prototype.cloneImplementation = function() {
            return new Delay(this.fn);
        };
        Object.defineProperty(Delay.prototype, "definition", {
            get: function() {
                return "<delay>";
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Delay.prototype, "createsAstNode", {
            // It is assumed that a delay function creates an AST node,
            get: function() {
                return true;
            },
            enumerable: true,
            configurable: true
        });
        return Delay;
    }(Rule);
    Myna.Delay = Delay;
    //====================================================================================================================
    // Predicates don't advance the input 
    // Used to identify rules that do not advance the input
    var NonAdvancingRule = function(_super) {
        $311e31ab8024e26f$var$__extends(NonAdvancingRule, _super);
        function NonAdvancingRule(rules) {
            _super.call(this, rules);
            this.type = "charSet";
        }
        Object.defineProperty(NonAdvancingRule.prototype, "nonAdvancing", {
            get: function() {
                return true;
            },
            enumerable: true,
            configurable: true
        });
        return NonAdvancingRule;
    }(Rule);
    Myna.NonAdvancingRule = NonAdvancingRule;
    // Returns true if the current token is in the token set. 
    var CharSet = function(_super) {
        $311e31ab8024e26f$var$__extends(CharSet, _super);
        function CharSet(chars) {
            _super.call(this, []);
            this.chars = chars;
            this.type = "charSet";
            this.className = "CharSet";
            var vals = [];
            var length = chars.length;
            for(var i = 0; i < length; ++i)vals[i] = chars.charCodeAt(i);
            this.lexer = function(p) {
                // TODO: Try this instead, could be faster.
                // chars.indexOf(p.input[p.index]) >= 0;
                return vals.indexOf(p.input.charCodeAt(p.index)) >= 0;
            };
            this.parser = this.lexer;
        }
        Object.defineProperty(CharSet.prototype, "definition", {
            get: function() {
                return "[" + escapeChars(this.chars) + "]";
            },
            enumerable: true,
            configurable: true
        });
        CharSet.prototype.cloneImplementation = function() {
            return new CharSet(this.chars);
        };
        return CharSet;
    }(NonAdvancingRule);
    Myna.CharSet = CharSet;
    // Returns true if the current token is within a range of characters, otherwise returns false
    var CharRange = function(_super) {
        $311e31ab8024e26f$var$__extends(CharRange, _super);
        function CharRange(min, max) {
            _super.call(this, []);
            this.min = min;
            this.max = max;
            this.type = "charRange";
            this.className = "CharRange";
            var minCode = min.charCodeAt(0);
            var maxCode = max.charCodeAt(0);
            this.lexer = function(p) {
                var code = p.input.charCodeAt(p.index);
                return code >= minCode && code <= maxCode;
            };
            this.parser = this.lexer;
        }
        Object.defineProperty(CharRange.prototype, "definition", {
            get: function() {
                return "[" + this.min + ".." + this.max + "]";
            },
            enumerable: true,
            configurable: true
        });
        CharRange.prototype.cloneImplementation = function() {
            return new CharRange(this.min, this.max);
        };
        return CharRange;
    }(NonAdvancingRule);
    Myna.CharRange = CharRange;
    // Returns true only if the child rule fails to match.
    var Not = function(_super) {
        $311e31ab8024e26f$var$__extends(Not, _super);
        function Not(rule) {
            _super.call(this, [
                rule
            ]);
            this.type = "not";
            this.className = "Not";
            var childLexer = rule.lexer;
            this.lexer = function(p) {
                if (p.index >= p.length) return true;
                var index = p.index;
                if (childLexer(p) === false) return true;
                p.index = index;
                return false;
            };
            this.parser = this.lexer;
        }
        Not.prototype.cloneImplementation = function() {
            return new Not(this.firstChild);
        };
        Object.defineProperty(Not.prototype, "definition", {
            get: function() {
                return "!" + this.firstChild.toString();
            },
            enumerable: true,
            configurable: true
        });
        return Not;
    }(NonAdvancingRule);
    Myna.Not = Not;
    // Returns true only if the child rule matches, but does not advance the parser
    var At = function(_super) {
        $311e31ab8024e26f$var$__extends(At, _super);
        function At(rule) {
            _super.call(this, [
                rule
            ]);
            this.type = "at";
            this.className = "At";
            var childLexer = rule.lexer;
            this.lexer = function(p) {
                var index = p.index;
                if (childLexer(p) === false) return false;
                p.index = index;
                return true;
            };
            this.parser = this.lexer;
        }
        At.prototype.cloneImplementation = function() {
            return new At(this.firstChild);
        };
        Object.defineProperty(At.prototype, "definition", {
            get: function() {
                return "&" + this.firstChild.toString();
            },
            enumerable: true,
            configurable: true
        });
        return At;
    }(NonAdvancingRule);
    Myna.At = At;
    // Uses a function to return true or not based on the behavior of the predicate rule
    var Predicate = function(_super) {
        $311e31ab8024e26f$var$__extends(Predicate, _super);
        function Predicate(fn) {
            _super.call(this, []);
            this.fn = fn;
            this.type = "predicate";
            this.className = "Predicate";
            this.lexer = fn;
            this.parser = this.lexer;
        }
        Predicate.prototype.cloneImplementation = function() {
            return new Predicate(this.fn);
        };
        Object.defineProperty(Predicate.prototype, "definition", {
            get: function() {
                return "<predicate>";
            },
            enumerable: true,
            configurable: true
        });
        return Predicate;
    }(NonAdvancingRule);
    Myna.Predicate = Predicate;
    //===============================================================
    // Rule creation function
    // Create a rule that matches the text 
    function text(text) {
        return new Text(text);
    }
    Myna.text = text;
    // Create a rule that matches the text 
    function textAnyCase(text) {
        return new AnyCaseText(text);
    }
    Myna.textAnyCase = textAnyCase;
    // Creates a rule that matches a series of rules in order, and succeeds if they all do
    function seq() {
        var rules = [];
        for(var _i = 0; _i < arguments.length; _i++)rules[_i - 0] = arguments[_i];
        var rs = rules.map(RuleTypeToRule);
        if (rs.length == 0) throw new Error("At least one rule is expected when calling `seq`");
        if (rs.length == 1) return rs[0];
        var rule1 = rs[0];
        var rule2 = seq.apply(void 0, rs.slice(1));
        if (rule1.nonAdvancing && rule2 instanceof Advance) return new AdvanceIf(rule1);
        else return new Sequence(rule1, rule2);
    }
    Myna.seq = seq;
    // Creates a rule that tries to match each rule in order, and succeeds if at least one does 
    function choice() {
        var rules = [];
        for(var _i = 0; _i < arguments.length; _i++)rules[_i - 0] = arguments[_i];
        var rs = rules.map(RuleTypeToRule);
        if (rs.length == 0) throw new Error("At least one rule is expected when calling `choice`");
        if (rs.length == 1) return rs[0];
        var rule1 = rs[0];
        var rule2 = choice.apply(void 0, rs.slice(1));
        if (rule1 instanceof AdvanceIf && rule2 instanceof AdvanceIf) return new AdvanceIf(choice(rule1.firstChild, rule2.firstChild));
        else return new Choice(rule1, rule2);
    }
    Myna.choice = choice;
    // Enables Rules to be defined in terms of variables that are defined later on.
    // This enables recursive rule definitions.  
    function delay(fxn) {
        return new Delay(fxn);
    }
    Myna.delay = delay;
    // Parses successfully if the given rule does not match the input at the current location  
    function not(rule) {
        return new Not(RuleTypeToRule(rule));
    }
    Myna.not = not;
    // Returns true if the rule successfully matches, but does not advance the parser index. 
    function at(rule) {
        return new At(RuleTypeToRule(rule));
    }
    Myna.at = at;
    // Attempts to apply a rule between min and max number of times inclusive. If the maximum is set to Infinity, 
    // it will attempt to match as many times as it can, but throw an exception if the parser does not advance 
    function quantified(rule, min, max) {
        if (min === void 0) min = 0;
        if (max === void 0) max = Infinity;
        if (min === 0 && max === 1) return new Optional(RuleTypeToRule(rule));
        else return new Quantified(RuleTypeToRule(rule), min, max);
    }
    Myna.quantified = quantified;
    // Attempts to apply the rule 0 or more times. Will always succeed unless the parser does not 
    // advance, in which case an exception is thrown.    
    function zeroOrMore(rule) {
        return quantified(rule).setType("zeroOrMore");
    }
    Myna.zeroOrMore = zeroOrMore;
    // Attempts to apply the rule 1 or more times. Will throw an exception if the parser does not advance.  
    function oneOrMore(rule) {
        return quantified(rule, 1).setType("oneOrMore");
    }
    Myna.oneOrMore = oneOrMore;
    // Attempts to match a rule 0 or 1 times. Always succeeds.   
    function opt(rule) {
        return quantified(rule, 0, 1).setType("optional");
    }
    Myna.opt = opt;
    // Attempts to apply a rule a precise number of times
    function repeat(rule, count) {
        return quantified(rule, count, count).setType("repeat");
    }
    Myna.repeat = repeat;
    // Returns true if one of the characters are present. Does not advances the parser position.
    function atChar(chars) {
        return new CharSet(chars);
    }
    Myna.atChar = atChar;
    // Returns true if none of the characters are present. Does not advances the parser position.
    function notAtChar(chars) {
        return atChar(chars).not;
    }
    Myna.notAtChar = notAtChar;
    // Advances parser if one of the characters are present.
    function char(chars) {
        return atChar(chars).advance;
    }
    Myna.char = char;
    // Advances parser if none of the characters are present.
    function notChar(chars) {
        return notAtChar(chars).advance;
    }
    Myna.notChar = notChar;
    // Advances if one of the characters are present, or returns false
    function atRange(min, max) {
        return new CharRange(min, max);
    }
    Myna.atRange = atRange;
    // Advances if one of the characters are present, or returns false
    function range(min, max) {
        return atRange(min, max).advance;
    }
    Myna.range = range;
    // Returns true if on of the characters are not in the range, but does not advance the parser position
    function notRange(min, max) {
        return range(min, max).not;
    }
    Myna.notRange = notRange;
    // Repeats a rule zero or more times, with a delimiter between each one. 
    function delimited(rule, delimiter) {
        return opt(seq(rule, seq(delimiter, rule).zeroOrMore)).setType("delimitedList");
    }
    Myna.delimited = delimited;
    // Executes the rule, if the condition is not true
    function unless(rule, condition) {
        return seq(not(condition), rule).setType("unless");
    }
    Myna.unless = unless;
    // Repeats the rule while the condition is not true
    function repeatWhileNot(body, condition) {
        return unless(body, condition).zeroOrMore.setType("repeatWhileNot");
    }
    Myna.repeatWhileNot = repeatWhileNot;
    // Repeats the rule while the condition is not true, but must execute at least once 
    function repeatOneOrMoreWhileNot(body, condition) {
        return not(condition).then(body).then(repeatWhileNot(body, condition)).setType("repeatOneOrMoreWhileNot");
    }
    Myna.repeatOneOrMoreWhileNot = repeatOneOrMoreWhileNot;
    // Repeats the rule until just after the condition is true once 
    function repeatUntilPast(body, condition) {
        return repeatWhileNot(body, condition).then(condition).setType("repeatUntilPast");
    }
    Myna.repeatUntilPast = repeatUntilPast;
    // Repeats the rule until just after the condition is true once but must execute at least once 
    function repeatOneOrMoreUntilPast(body, condition) {
        return not(condition).then(body).then(repeatUntilPast(body, condition)).setType("repeatOneOrMoreUntilPast");
    }
    Myna.repeatOneOrMoreUntilPast = repeatOneOrMoreUntilPast;
    // Advances the parse state while the rule is not true. 
    function advanceWhileNot(rule) {
        return repeatWhileNot(Myna.advance, rule).setType("advanceWhileNot");
    }
    Myna.advanceWhileNot = advanceWhileNot;
    // Advances the parse state while the rule is not true but must execute ast least once 
    function advanceOneOrMoreWhileNot(rule) {
        return repeatOneOrMoreWhileNot(Myna.advance, rule).setType("advanceOneOrMoreWhileNot");
    }
    Myna.advanceOneOrMoreWhileNot = advanceOneOrMoreWhileNot;
    // Advance the parser until just after the rule is executed 
    function advanceUntilPast(rule) {
        return repeatUntilPast(Myna.advance, rule).setType("advanceUntilPast");
    }
    Myna.advanceUntilPast = advanceUntilPast;
    // Advance the parser until just after the rule is executed, but must execute at least once  
    function advanceOneOrMoreUntilPast(rule) {
        return repeatOneOrMoreUntilPast(Myna.advance, rule).setType("advanceOneOrMoreUntilPast");
    }
    Myna.advanceOneOrMoreUntilPast = advanceOneOrMoreUntilPast;
    // Advances the parser unless the rule is true. 
    function advanceUnless(rule) {
        return Myna.advance.unless(rule).setType("advanceUnless");
    }
    Myna.advanceUnless = advanceUnless;
    // Parses successfully if  the predictate passes
    function predicate(fn) {
        return new Predicate(fn);
    }
    Myna.predicate = predicate;
    // Executes an action when arrived at and continues 
    function action(fn) {
        return predicate(function(p) {
            fn(p);
            return true;
        }).setType("action");
    }
    Myna.action = action;
    // Logs a message as an action 
    function log(msg) {
        if (msg === void 0) msg = "";
        return action(function(p) {
            console.log(msg);
        }).setType("log");
    }
    Myna.log = log;
    // Throw a Error if reached 
    function err(message) {
        return action(function(p) {
            var e = new ParserError(message + "\n" + p.location.toString());
            throw e;
        }).setType("err");
    }
    Myna.err = err;
    // Asserts that the rule is executed 
    // This has to be embedded in a function because the rule might be in a circular definition.  
    function assert(rule) {
        return choice(rule, err("Expected: " + RuleTypeToRule(rule)));
    }
    Myna.assert = assert;
    // If first part of a guarded sequence passes then each subsequent rule must pass as well 
    // otherwise an exception occurs. This helps create parsers that fail fast, and thus provide
    // better feedback for badly formed input.      
    function guardedSeq(condition) {
        var rules = [];
        for(var _i = 1; _i < arguments.length; _i++)rules[_i - 1] = arguments[_i];
        return seq(condition, seq.apply(void 0, rules.map(function(r) {
            return assert(r);
        }))).setType("guardedSeq");
    }
    Myna.guardedSeq = guardedSeq;
    // Parses the given rule surrounded by double quotes 
    function doubleQuoted(rule) {
        return guardedSeq('"', rule, assert('"')).setType("doubleQuoted");
    }
    Myna.doubleQuoted = doubleQuoted;
    // Parses a double quoted string, taking into account special escape rules
    function doubleQuotedString(escape) {
        return doubleQuoted(choice(escape, notChar('"').zeroOrMore)).setType("doubleQuotedString");
    }
    Myna.doubleQuotedString = doubleQuotedString;
    // Parses the given rule surrounded by single quotes 
    function singleQuoted(rule) {
        return guardedSeq("'", rule, assert("'")).setType("singleQuoted");
    }
    Myna.singleQuoted = singleQuoted;
    // Parses a singe quoted string, taking into account special escape rules
    function singleQuotedString(escape) {
        return singleQuoted(choice(escape, notChar("'").zeroOrMore)).setType("singleQuotedString");
    }
    Myna.singleQuotedString = singleQuotedString;
    // Parses the given rule surrounded by parentheses, and consumes whitespace  
    function parenthesized(rule) {
        return guardedSeq("(", Myna.ws, rule, Myna.ws, ")").setType("parenthesized");
    }
    Myna.parenthesized = parenthesized;
    // Parses the given rule surrounded by curly braces, and consumes whitespace 
    function braced(rule) {
        return guardedSeq("{", Myna.ws, rule, Myna.ws, "}").setType("braced");
    }
    Myna.braced = braced;
    // Parses the given rule surrounded by square brackets, and consumes whitespace 
    function bracketed(rule) {
        return guardedSeq("[", Myna.ws, rule, Myna.ws, "]").setType("bracketed");
    }
    Myna.bracketed = bracketed;
    // Parses the given rule surrounded by angle brackets, and consumes whitespace 
    function tagged(rule) {
        return guardedSeq("<", Myna.ws, rule, Myna.ws, ">").setType("tagged");
    }
    Myna.tagged = tagged;
    // A complete identifier, with no other letters or numbers
    function keyword(text) {
        return seq(text, not(Myna.identifierNext)).setType("keyword");
    }
    Myna.keyword = keyword;
    // A complete identifier, with no other letters or numbers, but case insensitive
    function keywordAnyCase(text) {
        return seq(textAnyCase(text), not(Myna.identifierNext)).setType("keywordAnyCase");
    }
    Myna.keywordAnyCase = keywordAnyCase;
    // Chooses one of a a list of identifiers
    function keywords() {
        var words = [];
        for(var _i = 0; _i < arguments.length; _i++)words[_i - 0] = arguments[_i];
        return choice.apply(void 0, words.map(keyword));
    }
    Myna.keywords = keywords;
    //===============================================================    
    // Core grammar rules 
    Myna.truePredicate = new Predicate(function(p) {
        return true;
    });
    Myna.falsePredicate = new Predicate(function(p) {
        return false;
    });
    Myna.end = new Predicate(function(p) {
        return p.index >= p.length;
    });
    Myna.notEnd = new Predicate(function(p) {
        return p.index < p.length;
    });
    Myna.advance = new Advance();
    Myna.all = Myna.advance.zeroOrMore;
    Myna.atLetterLower = atRange("a", "z");
    Myna.atLetterUpper = atRange("A", "Z");
    Myna.atLetter = choice(Myna.atLetterLower, Myna.atLetterUpper);
    Myna.atDigit = atRange("0", "9");
    Myna.atDigitNonZero = atRange("1", "9");
    Myna.atHexDigit = choice(Myna.atDigit, atRange("a", "f"), atRange("A", "F"));
    Myna.atBinaryDigit = atChar("01");
    Myna.atOctalDigit = atRange("0", "7");
    Myna.atAlphaNumeric = choice(Myna.atLetter, Myna.atDigit);
    Myna.atUnderscore = atChar("_");
    Myna.atSpace = atChar(" ");
    Myna.atTab = atChar("	");
    Myna.atWs = atChar(" 	\r\n\xa0\uFEFF");
    Myna.atIdentifierNext = choice(Myna.atAlphaNumeric, Myna.atUnderscore);
    Myna.letterLower = Myna.atLetterLower.advance;
    Myna.letterUpper = Myna.atLetterUpper.advance;
    Myna.letter = Myna.atLetter.advance;
    Myna.letters = Myna.letter.oneOrMore;
    Myna.digit = Myna.atDigit.advance;
    Myna.digitNonZero = Myna.atDigitNonZero.advance;
    Myna.digits = Myna.digit.oneOrMore;
    Myna.integer = char("0").or(Myna.digits);
    Myna.hexDigit = Myna.atHexDigit.advance;
    Myna.binaryDigit = Myna.atBinaryDigit.advance;
    Myna.octalDigit = Myna.atOctalDigit.advance;
    Myna.alphaNumeric = Myna.atAlphaNumeric.advance;
    Myna.underscore = Myna.atUnderscore.advance;
    Myna.identifierFirst = choice(Myna.atLetter, Myna.atUnderscore).advance;
    Myna.identifierNext = choice(Myna.atAlphaNumeric, Myna.atUnderscore).advance;
    Myna.identifier = seq(Myna.identifierFirst, Myna.identifierNext.zeroOrMore);
    Myna.hyphen = text("-");
    Myna.crlf = text("\r\n");
    Myna.newLine = choice(Myna.crlf, "\n");
    Myna.space = text(" ");
    Myna.tab = text("	");
    // JSON definition of white-space 
    Myna.ws = Myna.atWs.advance.zeroOrMore;
    //===============================================================
    // Parsing function 
    // Returns an array of nodes created by parsing the given rule repeatedly until 
    // it fails or the end of the input is arrived. One Astnode is created for each time 
    // the token is parsed successfully, whether or not it explicitly has the "_createAstNode" 
    // flag set explicitly. 
    function tokenize(r, s) {
        var result = this.parse(r.ast.zeroOrMore, s);
        return result ? result.children : [];
    }
    Myna.tokenize = tokenize;
    // Returns the root node of the abstract syntax tree created 
    // by parsing the rule.  
    function parse(r, s) {
        var p = new ParseState(s, 0, []);
        if (!(r instanceof AstRule)) r = r.ast;
        if (!r.parser(p)) return null;
        return p && p.nodes ? p.nodes[0] : null;
    }
    Myna.parse = parse;
    //===============================================================
    // Grammar functions 
    // The following are helper functions for grammar objects. A grammar is a loosely defined concept.
    // It is any JavaScript object where one or more member fields are instances of the Rule class.    
    // Returns all rules that belong to a specific grammar and that create AST nodes. 
    function grammarAstRules(grammarName) {
        return grammarRules(grammarName).filter(function(r) {
            return r._createAstNode;
        });
    }
    Myna.grammarAstRules = grammarAstRules;
    // Returns all rules that belong to a specific grammar
    function grammarRules(grammarName) {
        return allGrammarRules().filter(function(r) {
            return r.grammarName == grammarName;
        });
    }
    Myna.grammarRules = grammarRules;
    // Returns all rules as an array sorted by name.
    function allGrammarRules() {
        return Object.keys(Myna.allRules).sort().map(function(k) {
            return Myna.allRules[k];
        });
    }
    Myna.allGrammarRules = allGrammarRules;
    // Returns an array of names of the grammars
    function grammarNames() {
        return Object.keys(Myna.grammars).sort();
    }
    Myna.grammarNames = grammarNames;
    // Creates a string representation of a grammar 
    function grammarToString(grammarName) {
        return grammarRules(grammarName).map(function(r) {
            return r.fullName + " <- " + r.definition;
        }).join("\n");
    }
    Myna.grammarToString = grammarToString;
    // Creates a string representation of the AST schema generated by parsing the grammar 
    function astSchemaToString(grammarName) {
        return grammarAstRules(grammarName).map(function(r) {
            return r.name + " <- " + r.astRuleDefn();
        }).join("\n");
    }
    Myna.astSchemaToString = astSchemaToString;
    // Initializes and register a grammar object and all of the rules. 
    // Sets names for all of the rules from the name of the field it is associated with combined with the 
    // name of the grammar. Each rule is stored in Myna.rules and each grammar is stored in Myna.grammars. 
    function registerGrammar(grammarName, grammar, defaultRule) {
        for(var k in grammar)if (grammar[k] instanceof Rule) {
            var rule = grammar[k];
            rule.setName(grammarName, k);
            Myna.allRules[rule.fullName] = rule;
        }
        Myna.grammars[grammarName] = grammar;
        if (defaultRule) Myna.parsers[grammarName] = function(text) {
            return parse(defaultRule, text);
        };
        return grammar;
    }
    Myna.registerGrammar = registerGrammar;
    //===========================================================================
    // Utility functions
    // Replaces characters with the JSON escaped version
    function escapeChars(text) {
        var r = JSON.stringify(text);
        return r.slice(1, r.length - 1);
    }
    Myna.escapeChars = escapeChars;
    // Given a RuleType returns an instance of a Rule.
    function RuleTypeToRule(rule) {
        if (rule instanceof Rule) return rule;
        if (typeof rule === "string") return text(rule);
        if (typeof rule === "boolean") return rule ? Myna.truePredicate : Myna.falsePredicate;
        throw new Error("Invalid rule type: " + rule);
    }
    Myna.RuleTypeToRule = RuleTypeToRule;
    // These should be commented out in the filnal version 
    function debugAssert(condition, rule, message) {
        if (!condition) throw new Error("Error occured while parsing rule: " + rule.fullName + " " + (message || ""));
    }
    Myna.debugAssert = debugAssert;
    //===========================================================================
    // Initialization
    // The entire module is a grammar because it is an object that exposes rules as properties
    registerGrammar("core", Myna, null);
})($311e31ab8024e26f$var$Myna = $311e31ab8024e26f$exports.Myna || ($311e31ab8024e26f$exports.Myna = {}));
if (0, $311e31ab8024e26f$exports) {
    $311e31ab8024e26f$exports = $311e31ab8024e26f$var$Myna;
    // When importing from TypeScript the imports expect a "Myna" variable 
    $311e31ab8024e26f$exports.Myna = $311e31ab8024e26f$var$Myna;
}


var $b968b1035f949a9d$exports = {};
"use strict";
var $b968b1035f949a9d$var$__spreadArrays = $b968b1035f949a9d$exports && $b968b1035f949a9d$exports.__spreadArrays || function() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
};
Object.defineProperty($b968b1035f949a9d$exports, "__esModule", {
    value: true
});
// tslint:disable-next-line: max-func-body-length
function $b968b1035f949a9d$var$speechMarkdownGrammar(myna) {
    var m = myna;
    // Override parenthesis function to not use `.guardedSeq`
    // This sequence is too assertive, and may cause exceptions rather than just returning null
    m.parenthesized = function(rule) {
        return m.seq("(", m.ws, rule, m.ws, ")").setType("parenthesized");
    };
    // tslint:disable-next-line: typedef
    // tslint:disable-next-line: max-func-body-length
    var g = new function() {
        //         // Allows the "inline" to be referenced before it is defined.
        //         // This enables recursive definitions.
        //         this.inlineDelayed = m.delay(() => this.inline);
        //         this.boundedInline = function(begin: any, end: any) : any {
        // // tslint:disable-next-line: no-parameter-reassignment
        //             if (end === undefined) { end = begin; }
        //             return m.seq(begin, this.inlineDelayed.unless(end).zeroOrMore, end);
        //         }
        // Plain text
        var specialCharSet = "[]()";
        var specialCharSetEmphasis = "[]()*~`@#\\_!+-";
        var ws = m.char(" 	").oneOrMore;
        var optWs = ws.opt;
        var wsOrNewLine = ws.or(m.newLine);
        var nonSpecialChar = m.notChar(specialCharSetEmphasis).unless(m.newLine);
        var nonSpecialCharEmphasis = m.notChar(specialCharSet).unless(m.newLine);
        var quoteChar = m.notChar('"');
        /*
         xsd:token - XML Schema2 section 3.3.2
         token represents tokenized strings.
         The ·value space· of token is the set of strings that do not contain the
         carriage return (#xD), line feed (#xA) nor tab (#x9) characters, that have
         no leading or trailing spaces (#x20) and that have no internal sequences
         of two or more spaces. The ·lexical space· of token is the set of strings
         that do not contain the carriage return (#xD), line feed (#xA) nor
         tab (#x9) characters, that have no leading or trailing spaces (#x20) and
         that have no internal sequences of two or more spaces.
    
         This implementation plays very loose with the definition.
         */ this.xsdToken = m.choice(m.digits, m.letters, m.char(specialCharSetEmphasis)).oneOrMore.ast;
        this.plainText = m.choice(m.digits, m.letters, ws, nonSpecialChar).oneOrMore.ast;
        this.plainTextEmphasis = m.choice(m.digits, m.letters, ws, nonSpecialChar).oneOrMore.ast;
        var plainTextChoice = m.choice(m.digits, m.letters, ws, nonSpecialCharEmphasis);
        this.plainTextModifier = plainTextChoice.oneOrMore.ast;
        this.plainTextPhone = m.seq(m.parenthesized(m.digits), plainTextChoice.oneOrMore).ast;
        this.plainTextSpecialChars = m.choice(m.seq("(", plainTextChoice, ") "), m.seq("[", plainTextChoice, "] "), m.choice.apply(m, specialCharSetEmphasis.split("")).oneOrMore).oneOrMore.ast;
        // Audio
        this.urlSpecialChar = m.char(":/.-_~?#[]@!+,;%=()&");
        this.url = m.choice(m.digit, m.letter, this.urlSpecialChar).oneOrMore.ast;
        this.audio = m.seq("![", m.choice(m.singleQuoted(this.url), m.doubleQuoted(this.url)), "]").ast;
        // Break
        this.timeUnit = m.choice("s", "ms").ast;
        this.fraction = m.seq(".", m.digit.zeroOrMore);
        this.number = m.seq(m.integer, this.fraction.opt).ast;
        this.time = m.seq(this.number, this.timeUnit).ast;
        this.shortBreak = m.seq("[", this.time, "]").ast;
        // Silence
        this.silenceTypeValue = m.choice("Leading", "Tailing", "Sentenceboundary").ast;
        this.silenceData = m.seq(this.silenceTypeValue, " ", this.time).ast;
        this.silence = m.seq("[", "silence", ":", m.choice(m.singleQuoted(this.silenceData), m.doubleQuoted(this.silenceData)), "]").ast;
        // Backgroundaudio
        this.backgroundData = m.seq(" ", this.url);
        this.backgroundAudio = m.seq("[", "backgroundaudio", ":", m.choice(m.singleQuoted(m.seq(this.url, this.backgroundData.zeroOrMore).ast), m.doubleQuoted(m.seq(this.url, this.backgroundData.zeroOrMore).ast)), "]").ast;
        // Lexicon
        this.lexicon = m.seq("[", "lexicon", ":", m.choice(m.singleQuoted(this.url), m.doubleQuoted(this.url)), "]").ast;
        // Bookmark
        this.bookmarkChar = m.char(".-_");
        this.bookmarkString = m.choice(m.digit, m.letter, this.bookmarkChar).oneOrMore.ast;
        this.bookmark = m.seq("[", "bookmark", ":", m.choice(m.singleQuoted(this.bookmarkString), m.doubleQuoted(this.bookmarkString)), "]").ast;
        // this.string = m.choice(m.doubleQuotedString(), m.singleQuotedString()).ast;
        // Emphasis
        // The emphasis tag should be preluded and followed by a not-letter-character.
        // Otherwise an example like above would be captured.
        var notLetterChar = m.not(m.letters);
        this.shortEmphasisModerate = m.seq(notLetterChar, "+", this.plainTextEmphasis, "+", notLetterChar).ast;
        this.shortEmphasisStrong = m.seq(notLetterChar, "++", this.plainTextEmphasis, "++", notLetterChar).ast;
        this.shortEmphasisNone = m.seq(notLetterChar, "~", this.plainTextEmphasis, "~", notLetterChar).ast;
        this.shortEmphasisReduced = m.seq(notLetterChar, "-", this.plainTextEmphasis, "-", notLetterChar).ast;
        this.emphasis = m.choice(this.shortEmphasisModerate, this.shortEmphasisStrong, this.shortEmphasisNone, this.shortEmphasisReduced);
        // Modifier
        // (text)[key] or (text)[key;]
        // (text)[key:'value'] or (text)[key:'value';]
        // (text)[key: "value"] or (text)[key: "value";]
        // (text)[key:'value';key;key:"value"]
        var colon = m.char(":").ws;
        var semicolon = m.char(";").ws;
        this.textModifierKey = m.keywords("emphasis", "address", "number", "cardinal", "characters", "chars", "digits", "drc", "expletive", "bleep", "fraction", "interjection", "ordinal", "telephone", "phone", "unit", "time", "date", "whisper", "ipa", "sapi", "ups", "sub", "vol", "volume", "rate", "pitch", "contour", "range", "timbre", "lang", "voice", "excited", "disappointed", "emotion", "paragraph", "sentence").ast;
        // Special characters for <phoneme alphabet="ipa" ph="..."> tag
        // const ipaChars = ['.', "'", 'æ', '͡ʒ', 'ð', 'ʃ', '͡ʃ', 'θ', 'ʒ', 'ə', 'ɚ', 'aɪ', 'aʊ', 'ɑ',
        //  'eɪ', 'ɝ', 'ɛ', 'ɪ', 'oʊ', 'ɔ', 'ɔɪ', 'ʊ', 'ʌ', 'ɒ', 'ɛə', 'ɪə', 'ʊə', 'ˈ', 'ˌ', 'ŋ', 'ɹ'];
        var ipaChars = [
            ".",
            "\xe6",
            "͡ʒ",
            "\xf0",
            "ʃ",
            "͡ʃ",
            "θ",
            "ʒ",
            "ə",
            "ɚ",
            "aɪ",
            "aʊ",
            "ɑ",
            "eɪ",
            "ɝ",
            "ɛ",
            "ɪ",
            "oʊ",
            "ɔ",
            "ɔɪ",
            "ʊ",
            "ʌ",
            "ɒ",
            "ɛə",
            "ɪə",
            "ʊə",
            "ˈ",
            "ˌ",
            "ŋ",
            "ɹ"
        ];
        var percentChange = [
            "+",
            m.hyphen,
            m.digit,
            "%"
        ];
        this.textModifierText = m.choice.apply(m, $b968b1035f949a9d$var$__spreadArrays([
            m.digit,
            m.letter,
            m.hyphen,
            m.space
        ], ipaChars, percentChange)).oneOrMore.ast;
        this.textModifierTextDoubleQuote = m.choice.apply(m, $b968b1035f949a9d$var$__spreadArrays([
            m.digit,
            m.letter,
            m.hyphen,
            m.space
        ], ipaChars, percentChange, [
            "'"
        ])).oneOrMore.ast;
        this.textModifierValue = m.seq(colon, m.choice(m.singleQuoted(this.textModifierText), m.doubleQuoted(this.textModifierTextDoubleQuote)));
        this.textModifierKeyOptionalValue = m.seq(this.textModifierKey, this.textModifierValue.opt).ast;
        this.modifier = m.bracketed(m.delimited(this.textModifierKeyOptionalValue.ws, semicolon));
        var textText = m.parenthesized(this.plainTextModifier);
        var textTextPhone = m.parenthesized(this.plainTextPhone);
        this.textModifier = m.seq(m.choice(textText, textTextPhone), this.modifier).ast;
        // Section
        this.sectionModifierKey = m.keywords("lang", "voice", "defaults", "dj", "newscaster", "excited", "disappointed").ast;
        this.sectionModifierText = m.choice(m.digit, m.letter, m.hyphen).oneOrMore.ast;
        this.sectionModifierValue = m.seq(colon, m.choice(m.singleQuoted(this.sectionModifierText), m.doubleQuoted(this.sectionModifierText)));
        this.sectionModifierKeyOptionalValue = m.seq(this.sectionModifierKey, this.sectionModifierValue.opt).ast;
        this.sectionModifier = m.bracketed(m.delimited(this.sectionModifierKeyOptionalValue.ws, semicolon));
        this.section = m.seq("#", this.sectionModifier).ast;
        // values
        this.valueNone = "none";
        this.valueXWeak = "x-weak";
        this.valueWeak = "weak";
        this.valueMedium = "medium";
        this.valueStrong = "strong";
        this.valueXStrong = "x-strong";
        this.breakStrengthValue = m.keywords(this.valueNone, this.valueXWeak, this.valueWeak, this.valueMedium, this.valueStrong, this.valueXStrong).ast;
        this.breakValue = m.choice(this.breakStrengthValue, this.time).ast;
        this.break = m.seq("[", "break", ":", m.choice(m.singleQuoted(this.breakValue), m.doubleQuoted(this.breakValue)), "]").ast;
        this.markTag = m.seq("[", "mark", ":", m.choice(m.singleQuoted(this.xsdToken), m.doubleQuoted(this.xsdToken)), "]").ast;
        this.any = m.advance;
        this.inline = m.choice(this.backgroundAudio, this.lexicon, this.bookmark, this.textModifier, this.emphasis, this.shortBreak, this.silence, this.break, this.audio, this.markTag, this.plainTextSpecialChars, this.plainText, this.any).unless(m.newLine);
        this.lineEnd = m.newLine.or(m.assert(m.end)).ast;
        this.emptyLine = m.char(" 	").zeroOrMore.then(m.newLine).ast;
        this.restOfLine = m.seq(this.inline.zeroOrMore).then(this.lineEnd);
        this.simpleLine = m.seq(this.emptyLine.not, m.notEnd, this.restOfLine).ast;
        this.paragraph = this.simpleLine.oneOrMore.ast;
        this.content = m.choice(this.section, this.paragraph, this.emptyLine);
        this.document = this.content.zeroOrMore.ast;
    }();
    // Register the grammar, providing a name and the default parse rule
    return m.registerGrammar("speechmarkdown", g, g.document);
}
$b968b1035f949a9d$exports.speechMarkdownGrammar = $b968b1035f949a9d$var$speechMarkdownGrammar;


var $fe9ae0483961e692$var$SpeechMarkdownParser = /** @class */ function() {
    function SpeechMarkdownParser() {
        this.myna = $311e31ab8024e26f$exports.Myna;
        $b968b1035f949a9d$exports.speechMarkdownGrammar(this.myna);
        this.parser = this.myna.parsers.speechmarkdown;
    }
    SpeechMarkdownParser.prototype.parse = function(speechmarkdown) {
        // tslint:disable-next-line: no-unnecessary-local-variable
        return this.parser(speechmarkdown);
    };
    return SpeechMarkdownParser;
}();
$fe9ae0483961e692$exports.SpeechMarkdownParser = $fe9ae0483961e692$var$SpeechMarkdownParser;


var $e822f5a6e821446b$var$SpeechMarkdown = /** @class */ function() {
    function SpeechMarkdown(options) {
        this.options = options;
        this.defaults = {
            includeFormatterComment: false,
            includeParagraphTag: false,
            includeSpeakTag: true,
            platform: "",
            preserveEmptyLines: true
        };
        this.options = $e822f5a6e821446b$var$__assign($e822f5a6e821446b$var$__assign({}, this.defaults), options);
    }
    Object.defineProperty(SpeechMarkdown.prototype, "Parser", {
        get: function() {
            if (!this.parser) this.parser = new $fe9ae0483961e692$exports.SpeechMarkdownParser();
            return this.parser;
        },
        enumerable: true,
        configurable: true
    });
    SpeechMarkdown.prototype.toText = function(speechmarkdown, options) {
        var methodOptions = $e822f5a6e821446b$var$__assign($e822f5a6e821446b$var$__assign({}, this.options), options);
        var ast = this.Parser.parse(speechmarkdown);
        var formatter = $e822f5a6e821446b$var$factory.createTextFormatter(methodOptions);
        return formatter.format(ast);
    };
    SpeechMarkdown.prototype.toSSML = function(speechmarkdown, options) {
        var methodOptions = $e822f5a6e821446b$var$__assign($e822f5a6e821446b$var$__assign({}, this.options), options);
        var returnSSML = speechmarkdown;
        try {
            // If there are tags in the text included in other tags, we need to format several times to process all the tags
            // If we don't do that, therer is a chance that tags will remain unprocessed in the output
            do {
                var ast = this.Parser.parse(returnSSML);
                var formatter = $e822f5a6e821446b$var$factory.createFormatter(methodOptions);
                returnSSML = formatter.format(ast);
            }while (returnSSML.includes(")["));
            // returnSSML now contains the core SSML, let's generate global tags if there is a need to
            // 'mstts:backgroundaudio' tag
            var backgroundAudiotag = "";
            if (returnSSML.includes("<mstts:backgroundaudio")) {
                var beginIndex = returnSSML.indexOf("<mstts:backgroundaudio");
                var endIndex = returnSSML.substring(beginIndex).indexOf("/>") + 2;
                backgroundAudiotag = returnSSML.substring(beginIndex, endIndex);
                returnSSML = returnSSML.replace(backgroundAudiotag, "");
            }
            // 'voice' tag
            var beginVoiceTag = "";
            var endVoiceTag = "";
            if (methodOptions.globalVoiceAndLang && methodOptions.globalVoiceAndLang.voice) {
                beginVoiceTag = '<voice name="' + methodOptions.globalVoiceAndLang.voice + '">';
                endVoiceTag = "</voice>";
            }
            // 'lang' tag
            var beginLangTag = "";
            var endLangTag = "";
            if (methodOptions.globalVoiceAndLang && methodOptions.globalVoiceAndLang.lang) {
                beginLangTag = '<lang xml:lang="' + methodOptions.globalVoiceAndLang.lang + '">';
                endLangTag = "</lang>";
            }
            var SSML = "" + (backgroundAudiotag + beginVoiceTag + beginLangTag + returnSSML + endLangTag + endVoiceTag);
            return SSML;
        } catch (error) {
            console.log("Error : ", error);
            return returnSSML;
        }
    };
    SpeechMarkdown.prototype.toAST = function(speechmarkdown) {
        return this.Parser.parse(speechmarkdown);
    };
    SpeechMarkdown.prototype.toASTString = function(speechmarkdown) {
        var ast = this.Parser.parse(speechmarkdown);
        return ast.toString();
    };
    return SpeechMarkdown;
}();
$e822f5a6e821446b$exports.SpeechMarkdown = $e822f5a6e821446b$var$SpeechMarkdown;


$0005a2081ed17843$exports.SpeechMarkdown = $e822f5a6e821446b$exports.SpeechMarkdown;


const $8e06b2d561dfd8ee$var$speechMarkdownParser = new (0, $0005a2081ed17843$exports.SpeechMarkdown)();
const $8e06b2d561dfd8ee$export$d6c6ec86eedacfd9 = (text, speechMarkdownTagsPosition = [])=>{
    let res = "";
    // Myna parser used in speechmarkdown parsing can't deal with dashes which aren't in speechmarkdown tags properly.
    // Let's change them and put them back after treatment
    if (text.indexOf("-") !== -1) {
        const dashesOutsideSpeechmarkdown = [];
        for(let i = 0; i < text.length; i++)if (text[i] === "-") {
            let test = true;
            speechMarkdownTagsPosition.forEach((position)=>{
                if (i >= position[0] || i <= position[1]) test = false;
            });
            test && dashesOutsideSpeechmarkdown.push(i);
        }
        let textWithoutDashes = "";
        if (dashesOutsideSpeechmarkdown.length > 0) {
            for(let i = 0; i < dashesOutsideSpeechmarkdown.length; i++){
                textWithoutDashes += i === 0 ? text.substring(0, dashesOutsideSpeechmarkdown[i]) : text.substring(dashesOutsideSpeechmarkdown[i - 1] + 1, dashesOutsideSpeechmarkdown[i]);
                textWithoutDashes += "1xx1";
            }
            // Add the rest of the text (after the last dash)
            textWithoutDashes += text.substring(dashesOutsideSpeechmarkdown[dashesOutsideSpeechmarkdown.length - 1] + 1);
        }
        res = $8e06b2d561dfd8ee$var$speechMarkdownParser.toText(textWithoutDashes);
        res = res.replaceAll("1xx1", "-");
    } else res = $8e06b2d561dfd8ee$var$speechMarkdownParser.toText(text);
    // Remove phoneme tag
    res = res.replaceAll(/<\/?phoneme?[^>]+>|$/g, "");
    return res;
};
const $8e06b2d561dfd8ee$export$f355fac925ad880f = (text)=>{
    const replacements = [];
    let textWithReplacements = text;
    // Get the indexes of all the occurences of ')['
    let indexes = [];
    let position = text.indexOf(")[");
    while(position !== -1){
        indexes.push(position);
        position = text.indexOf(")[", position + 1);
    }
    // If at least one occurence has been found escape all characters related
    if (indexes.length > 0) // Loop on indexes to get all indexes
    for(let i = 0; i < indexes.length; i++){
        // Get the opening parenthesis related to the closing one from the expression
        const openingParenthesisIndex = $8e06b2d561dfd8ee$var$getOpeningParenthesis(text, indexes[i]);
        // Get the closing bracket related to the opening one from the expression
        const closingBracketIndex = text.substring(indexes[i]).indexOf("]") + indexes[i];
        const replacement = {
            // Use string for replacement as : 'replacement1x1'
            replacementString: `replacement${i}x${i}`,
            speechMarkdown: text.substring(openingParenthesisIndex, closingBracketIndex + 1)
        };
        replacements.push(replacement);
        textWithReplacements = textWithReplacements.replace(replacement.speechMarkdown, replacement.replacementString);
    }
    // In markdown links can be found as [...](...) so we need to find data between brackets without parentheses related to the closing bracket. Example : 'Hello. [1s] How are you ?'
    // Reset indexes array and set basic text to textWithReplacements to prevent searching again for brackets that have already been removed
    indexes = [];
    const tempText = textWithReplacements;
    position = tempText.indexOf("]");
    while(position !== -1){
        indexes.push(position);
        position = tempText.indexOf("]", position + 1);
    }
    if (indexes.length > 0) {
        for(let i = 0; i < indexes.length; i++)// If the index is the last character of the string, or if the next character isn't an opening parenthesis, it's ok
        if (indexes[i] === tempText.length - 1 || tempText.charAt(indexes[i] + 1) !== "(") {
            // Find the position of the previous opening bracket
            const openingBracketIndex = tempText.substring(0, indexes[i]).lastIndexOf("[");
            const replacement = {
                // Use string for replacement as : 'pause1x1'
                replacementString: `pause${i}x${i}`,
                speechMarkdown: tempText.substring(openingBracketIndex, indexes[i] + 1)
            };
            replacements.push(replacement);
            textWithReplacements = textWithReplacements.replace(replacement.speechMarkdown, replacement.replacementString);
        }
    }
    return {
        text: textWithReplacements,
        replacements: replacements
    };
};
const $8e06b2d561dfd8ee$var$getOpeningParenthesis = (text, index)=>{
    let nbOpeningParenthesis = 0;
    let nbClosingParenthesis = 0;
    // Search from the end of the string for an equivalence between opening and ending parenthesis, to prevent error if the text to be
    // spoken contains parenthesis.
    for(let i = index; i > 0; i--){
        if (text.charAt(i) === ")") nbClosingParenthesis++;
        else if (text.charAt(i) === "(") {
            nbOpeningParenthesis++;
            if (nbClosingParenthesis === nbOpeningParenthesis) return i;
        }
    }
    return 0;
};


const $4c169ea82b0bd75e$var$regexLink = /<\/?a([^>])+>/g;
const $4c169ea82b0bd75e$var$regexImg = /<\/?img([^>])+>/g;
const $4c169ea82b0bd75e$export$1b8fbc30fb87d9aa = (text)=>{
    const md = new (0, (/*@__PURE__*/$parcel$interopDefault($462e820625752270$exports)))({
        breaks: true,
        html: true,
        xhtmlOut: true,
        typographer: true,
        quotes: `""''`
    });
    let attachmentsToCreate = {
        images: [],
        urls: []
    };
    // text = `[backgroundaudio:"https://daviretorikcdnstorage.blob.core.windows.net/retorik-framework/audiofiles/audiotest.mp3 0.5 2000 1500"][silence:"Leading 1s"] ((Bonjour, comment  allez-vous)[sentence] ? (Bien, merci, et vous-même ?)[sentence;voice:"Fr-fR-jerOMeNeuRal"])[paragraph] (Je suis de (tomato)[ipa:"təˈmeɪtoʊ"] (sapi)[sapi:"iy eh n y uw eh s"] (ups)[ups:"JH AU"] retour (après avoir été remplacée)[emphasis:"strong"] par Brigitte.[silence:"Sentenceboundary 3s"] Au revoir)[voice:"fr-FR-DeniseNeural";emotion:"calm SeniorMale"] ![image](images/bertranges.jpg)`
    // text = `((Bonjour, comment allez-vous ?)[sentence] [1s] (Bien, et toi Jérôme, ça va ?)[sentence])[paragraph] (Bien, merci, et vous-même ?)[voice:"Fr-fR-jerOMeNeuRal"]. Tout-va-pour-le-mieux. (Hallo Denise, wie geht es dir heute ?)[rate:"slow";vol:"x-loud";lang:"de-DE"] (Bonjour, je suis de retour (ASAP)[characters] après avoir été remplacée par Brigitte.Merci)[voice:"fr-FR-DeniseNeural";vol:"loud"] ![image](images/bertranges.jpg)`
    // text = `(Como estas ?)[lang:"es-ES"][1s] Parti - pour le test - (greenage)[lang:"en-US"]. Mettons une image ![image](images/bertranges.jpg).[500ms] En anglais, (parce-que en Français ce n'est pas ça...) greenage se dit (greenage)[lang:"en-US"]. Fin de message (aufwiedersehen)[lang:"de-DE"]`
    const speechMarkdownReplacedData = (0, $8e06b2d561dfd8ee$export$f355fac925ad880f)(text);
    const parsed = md.parseInline(speechMarkdownReplacedData.text);
    parsed.length > 0 && (attachmentsToCreate = $4c169ea82b0bd75e$var$createNewAttachments(parsed[0].children));
    const textWithHtmlTags = md.render(text);
    // Strip html tags from rendered text
    const newText = $4c169ea82b0bd75e$var$stripHtml(textWithHtmlTags);
    const speechMarkdownTagsPosition = [];
    speechMarkdownReplacedData.replacements.forEach((replacement)=>{
        const index = text.indexOf(replacement.speechMarkdown);
        speechMarkdownTagsPosition.push([
            index,
            index + replacement.speechMarkdown.length
        ]);
    });
    return {
        ...attachmentsToCreate,
        text: newText,
        htmlText: $4c169ea82b0bd75e$var$stripHtmlLinkTags(textWithHtmlTags, speechMarkdownTagsPosition)
    };
};
/**
 * Removes speechmarkdown, <a href ...></a> and <img ... /> tags from the text and keeps the others
 * @param text : string
 * @returns string
 */ const $4c169ea82b0bd75e$var$stripHtmlLinkTags = (text, speechMarkdownTagsPosition)=>{
    // Replace all characters replaced by mardkdown-it renderer (quotes, <, >)
    let newText = text.replaceAll("&quot;", '"');
    newText = newText.replaceAll("&lt;", "<");
    newText = newText.replaceAll("&gt;", ">");
    // Remove speechMarkdown tags, and link/images html tags
    newText = (0, $8e06b2d561dfd8ee$export$d6c6ec86eedacfd9)(newText, speechMarkdownTagsPosition).replaceAll($4c169ea82b0bd75e$var$regexLink, "");
    newText = newText.replaceAll($4c169ea82b0bd75e$var$regexImg, "");
    return newText;
};
/**
 * Removes all html tags from the text
 * @param text : string
 * @returns string
 */ const $4c169ea82b0bd75e$var$stripHtml = (text)=>{
    const temp = document.createElement("div");
    temp.innerHTML = text;
    return temp.textContent && temp.textContent !== "" ? temp.textContent : "";
};
const $4c169ea82b0bd75e$var$getDataFromToken = (attributes, type)=>{
    // Check if there are attributes, then if one of these attributes contains data with the desired key, and finally if there is a value attached to this key
    const allData = attributes?.find((data)=>data.length > 1 && data[0] === type && data.length > 0 && data[1] !== "");
    if (allData && allData.length > 1) return allData[1];
    return type === "href" ? undefined : "";
};
const $4c169ea82b0bd75e$var$createNewAttachments = (tokens)=>{
    const images = [];
    const urls = [];
    if (tokens && tokens.length > 0) for(let i = 0; i < tokens.length; i++){
        const attributes = tokens[i].attrs;
        switch(tokens[i].type){
            case "link_open":
                {
                    // Try to retrieve an URl from the href token
                    const url = $4c169ea82b0bd75e$var$getDataFromToken(attributes, "href");
                    // If there is an URL, try to retrieve the text contained in the next token 'content' field
                    if (url) {
                        const title = $4c169ea82b0bd75e$var$getDataFromToken(attributes, "title") || tokens[i + 1]?.content;
                        urls.push({
                            url: url,
                            title: title
                        });
                    }
                    break;
                }
            case "image":
                {
                    const url = $4c169ea82b0bd75e$var$getDataFromToken(attributes, "src");
                    url && images.push({
                        url: url,
                        title: $4c169ea82b0bd75e$var$getDataFromToken(attributes, "title"),
                        alt: $4c169ea82b0bd75e$var$getDataFromToken(attributes, "alt")
                    });
                    break;
                }
            default:
                break;
        }
    }
    return {
        images: images,
        urls: urls
    };
};


const $3a13fefbd1dfa779$var$processDirectLineIncomingActivity = (action)=>{
    const dataToReturn = {
        speak: undefined,
        text: undefined,
        htmlText: undefined,
        images: [],
        urls: []
    };
    const usedImageURLs = [];
    const usedLinkURLs = [];
    // Deal with 'speak' field if present
    if (action.payload?.activity?.speak) {
        // Make all the treatments needed for markdown and speechmarkdown
        const data = (0, $4c169ea82b0bd75e$export$1b8fbc30fb87d9aa)(action.payload.activity.speak);
        dataToReturn.speak = data.text;
        dataToReturn.images = data.images;
        dataToReturn.urls = data.urls;
        // Add the used image URLs and link URLs to prevent doubles
        data.images.forEach((data)=>{
            usedImageURLs.push(data.url);
        });
        data.urls.forEach((data)=>{
            usedLinkURLs.push(data.url);
        });
    }
    // Deal with 'text' field if present
    if (action.payload?.activity?.text) {
        // Make all the treatments needed for markdown and speechmarkdown
        const data = (0, $4c169ea82b0bd75e$export$1b8fbc30fb87d9aa)(action.payload.activity.text);
        dataToReturn.text = data.text;
        dataToReturn.htmlText = data.htmlText;
        // Don't add images if they are already in the array (already extracted from the 'speak' field)
        data.images.forEach((image)=>{
            !usedImageURLs.includes(image.url) && dataToReturn.images.push(image);
        });
        // Don't add urls if they are already in the array (already extracted from the 'speak' field)
        data.urls.forEach((url)=>{
            !usedLinkURLs.includes(url.url) && dataToReturn.urls.push(url);
        });
    }
    return dataToReturn;
};
var $3a13fefbd1dfa779$export$2e2bcd8739ae039 = $3a13fefbd1dfa779$var$processDirectLineIncomingActivity;





const $8f6009a09b34e5bf$var$addTextBlock = (text, type)=>{
    const textBlock = {
        type: "TextBlock",
        text: text,
        size: undefined,
        horizontalAlignment: undefined,
        wrap: true,
        maxLines: undefined
    };
    switch(type){
        case "title":
            textBlock.size = "large";
            break;
        case "subtitle":
            textBlock.size = "medium";
            break;
        case "text":
        default:
            break;
    }
    return textBlock;
};
const $8f6009a09b34e5bf$var$addImage = (data)=>{
    const image = {
        type: "Image",
        url: "",
        size: "Large",
        altText: undefined,
        selectAction: undefined
    };
    image.url = data.url;
    image.altText = data.alt || "image";
    image.selectAction = data.tap && $8f6009a09b34e5bf$var$addAction(data.tap);
    image.size = "Stretch";
    return {
        ...image
    };
};
const $8f6009a09b34e5bf$var$addAction = (cardAction, includesOAuthButtons)=>{
    const action = {
        type: "Action.Submit",
        title: undefined,
        url: undefined,
        data: undefined,
        fullWidth: undefined,
        position: undefined,
        display: undefined
    };
    for(const val in cardAction)if (cardAction[val] && typeof cardAction[val] === "string") cardAction[val] = (0, $8e06b2d561dfd8ee$export$d6c6ec86eedacfd9)(cardAction[val]);
    if (cardAction.type === "imBack" || cardAction.type === "messageBack" || cardAction.type === "postBack" || cardAction.type === "signin" && includesOAuthButtons) {
        action.type = "Action.Submit";
        action.data = {
            __isBotFrameworkCardAction: true,
            cardAction: cardAction
        };
        action.title = cardAction.title || "";
    } else {
        action.type = "Action.OpenUrl";
        action.title = cardAction.title || "";
        action.url = cardAction.type === "call" ? `tel:${cardAction.value}` : cardAction.value;
    }
    const channelData = cardAction.channelData;
    if (channelData) {
        action.fullWidth = channelData.fullWidth;
        action.position = channelData.position;
        action.display = channelData.display;
    }
    return {
        ...action
    };
};
const $8f6009a09b34e5bf$export$52053c22b954067e = (content)=>{
    const adaptiveCard = {
        contentType: (0, $67e1576cd7fc37b7$export$bbfd0bb0baceb2f8),
        content: {
            type: "AdaptiveCard",
            $schema: "http://adaptivecards.io/schemas/adaptive-card.json",
            version: "1.5",
            body: [],
            text: undefined,
            speak: undefined,
            selectAction: undefined
        }
    };
    // Add texts first in order : title - subtitle - text
    let cardTexts = [];
    if (content.title) {
        const ti = $8f6009a09b34e5bf$var$addTextBlock(content.title, "title");
        cardTexts = [
            ...cardTexts,
            {
                ...ti
            }
        ];
    }
    if (content.subtitle) {
        const st = $8f6009a09b34e5bf$var$addTextBlock(content.subtitle, "subtitle");
        cardTexts = [
            ...cardTexts,
            {
                ...st
            }
        ];
    }
    if (content.text) {
        const txt = $8f6009a09b34e5bf$var$addTextBlock(content.text, "text");
        cardTexts = [
            ...cardTexts,
            {
                ...txt
            }
        ];
        adaptiveCard.content.text = content.text;
    }
    // Set speak data so that the card is taken in account in the renderer
    if (content.speak || content.text) adaptiveCard.content.speak = content.speak || content.text;
    // Set body as Container with empty items
    adaptiveCard.content.body = [
        {
            type: "Container",
            items: []
        }
    ];
    // Add texts to items is there are some
    cardTexts.length > 0 && (adaptiveCard.content.body[0].items = [
        ...cardTexts
    ]);
    // Add Images if there are some
    let images = [];
    content.images && content.images.forEach((heroImage)=>{
        const image = $8f6009a09b34e5bf$var$addImage(heroImage);
        images = [
            ...images,
            {
                ...image
            }
        ];
    });
    images.length > 0 && (adaptiveCard.content.body[0].items = [
        ...adaptiveCard.content.body[0].items,
        ...images
    ]);
    // Add actions if there are some
    let actions = [];
    content.buttons && content.buttons.forEach((button)=>{
        const action = $8f6009a09b34e5bf$var$addAction(button);
        actions = [
            ...actions,
            {
                ...action
            }
        ];
    });
    if (actions.length > 0) {
        const actionSet = {
            type: "ActionSet",
            actions: [
                ...actions
            ]
        };
        adaptiveCard.content.body[0].items = [
            ...adaptiveCard.content.body[0].items,
            {
                ...actionSet
            }
        ];
    }
    // Tap action
    if (content.tap) {
        const tapAction = $8f6009a09b34e5bf$var$addAction(content.tap);
        adaptiveCard.content.selectAction = {
            ...tapAction
        };
    }
    return {
        ...adaptiveCard
    };
};



const $ff92641258eba8d4$export$4a92a69e5bfa5f9a = (attachments)=>{
    if (attachments && attachments.length > 0) {
        let tempAttachments = [];
        attachments.forEach((attachment)=>{
            if (attachment.contentType === (0, $67e1576cd7fc37b7$export$264354e75632a3ba)) {
                const heroToAdaptive = (0, $8f6009a09b34e5bf$export$52053c22b954067e)({
                    ...attachment.content
                });
                tempAttachments = [
                    ...tempAttachments,
                    {
                        ...heroToAdaptive
                    }
                ];
            } else tempAttachments = [
                ...tempAttachments,
                {
                    ...attachment
                }
            ];
        });
        return tempAttachments;
    }
    return undefined;
};


var $8deac4f58fe9f113$exports = {};
"use strict";
var $84b328b3870241b2$exports = {};
"use strict";
var $84b328b3870241b2$var$createStoreImpl = function createStoreImpl(createState) {
    var state;
    var listeners = new Set();
    var setState = function setState(partial, replace) {
        var nextState = typeof partial === "function" ? partial(state) : partial;
        if (!Object.is(nextState, state)) {
            var _previousState = state;
            state = (replace != null ? replace : typeof nextState !== "object") ? nextState : Object.assign({}, state, nextState);
            listeners.forEach(function(listener) {
                return listener(state, _previousState);
            });
        }
    };
    var getState = function getState() {
        return state;
    };
    var subscribe = function subscribe(listener) {
        listeners.add(listener);
        return function() {
            return listeners.delete(listener);
        };
    };
    var destroy = function destroy() {
        listeners.clear();
    };
    var api = {
        setState: setState,
        getState: getState,
        subscribe: subscribe,
        destroy: destroy
    };
    state = createState(setState, getState, api);
    return api;
};
var $84b328b3870241b2$var$createStore = function createStore(createState) {
    return createState ? $84b328b3870241b2$var$createStoreImpl(createState) : $84b328b3870241b2$var$createStoreImpl;
};
var $84b328b3870241b2$var$vanilla = function(createState) {
    return $84b328b3870241b2$var$createStore(createState);
};
$84b328b3870241b2$exports.createStore = $84b328b3870241b2$var$createStore;
$84b328b3870241b2$exports.default = $84b328b3870241b2$var$vanilla;
$84b328b3870241b2$exports = $84b328b3870241b2$var$vanilla;
$84b328b3870241b2$exports.createStore = $84b328b3870241b2$var$createStore;
$84b328b3870241b2$exports.default = $84b328b3870241b2$exports;



var $eO7Kz = parcelRequire("eO7Kz");
var $bd4c1f4e43279253$exports = {};
"use strict";

$bd4c1f4e43279253$exports = (parcelRequire("kojeU"));


var $8deac4f58fe9f113$var$useSyncExternalStoreWithSelector = $bd4c1f4e43279253$exports.useSyncExternalStoreWithSelector;
function $8deac4f58fe9f113$var$useStore(api, selector, equalityFn) {
    if (selector === void 0) selector = api.getState;
    var slice = $8deac4f58fe9f113$var$useSyncExternalStoreWithSelector(api.subscribe, api.getState, api.getServerState || api.getState, selector, equalityFn);
    $eO7Kz.useDebugValue(slice);
    return slice;
}
var $8deac4f58fe9f113$var$createImpl = function createImpl(createState) {
    var api = typeof createState === "function" ? $84b328b3870241b2$exports.createStore(createState) : createState;
    var useBoundStore = function useBoundStore(selector, equalityFn) {
        return $8deac4f58fe9f113$var$useStore(api, selector, equalityFn);
    };
    Object.assign(useBoundStore, api);
    return useBoundStore;
};
var $8deac4f58fe9f113$var$create = function create(createState) {
    return createState ? $8deac4f58fe9f113$var$createImpl(createState) : $8deac4f58fe9f113$var$createImpl;
};
var $8deac4f58fe9f113$var$react = function(createState) {
    return $8deac4f58fe9f113$var$create(createState);
};
$8deac4f58fe9f113$exports.create = $8deac4f58fe9f113$var$create;
$8deac4f58fe9f113$exports.default = $8deac4f58fe9f113$var$react;
$8deac4f58fe9f113$exports.useStore = $8deac4f58fe9f113$var$useStore;
Object.keys($84b328b3870241b2$exports).forEach(function(k) {
    if (k !== "default" && !$8deac4f58fe9f113$exports.hasOwnProperty(k)) Object.defineProperty($8deac4f58fe9f113$exports, k, {
        enumerable: true,
        get: function() {
            return $84b328b3870241b2$exports[k];
        }
    });
});
$8deac4f58fe9f113$exports = $8deac4f58fe9f113$var$react;
$8deac4f58fe9f113$exports.create = $8deac4f58fe9f113$var$create;
$8deac4f58fe9f113$exports.useStore = $8deac4f58fe9f113$var$useStore;
$8deac4f58fe9f113$exports.createStore = $84b328b3870241b2$exports.createStore;
$8deac4f58fe9f113$exports.default = $8deac4f58fe9f113$exports;


const $b3b97ac6cb18c5e1$export$88ac23e9e2fc8440 = (0, $8deac4f58fe9f113$exports.create)()(()=>{
    return {
        cancel: false
    };
});
const $b3b97ac6cb18c5e1$export$d0df6aec4e971f52 = (cancel)=>{
    $b3b97ac6cb18c5e1$export$88ac23e9e2fc8440.setState({
        cancel: cancel
    });
};




const $134592d23f105dbc$export$77e4cc5334565f28 = (0, $8deac4f58fe9f113$exports.create)()(()=>{
    return {
        fullScreenImage: undefined,
        lastListActivity: undefined,
        listClosed: false,
        currentSubView: (0, $16ad089b9ce6627d$export$f05d0fed0593ead7).none,
        currentCustomView: undefined,
        retorikEvent: undefined,
        displayAgent: true,
        activityToSend: undefined
    };
});
const $134592d23f105dbc$export$4e062bd31c814155 = (src)=>{
    $134592d23f105dbc$export$77e4cc5334565f28.setState({
        fullScreenImage: src
    });
};
const $134592d23f105dbc$export$e2194ce98b9711c9 = (id)=>{
    $134592d23f105dbc$export$77e4cc5334565f28.setState({
        lastListActivity: id
    });
};
const $134592d23f105dbc$export$f03cfde7db70aa27 = (value)=>{
    $134592d23f105dbc$export$77e4cc5334565f28.setState({
        listClosed: value
    });
};
const $134592d23f105dbc$export$f0c096b4ecd7115d = (subview)=>{
    $134592d23f105dbc$export$77e4cc5334565f28.setState({
        currentSubView: subview
    });
};
const $134592d23f105dbc$export$5a678fd51bd89633 = (customView)=>{
    $134592d23f105dbc$export$77e4cc5334565f28.setState({
        currentCustomView: customView
    });
};
const $134592d23f105dbc$export$dcb32d000c0e0280 = (event)=>{
    $134592d23f105dbc$export$77e4cc5334565f28.setState({
        retorikEvent: event
    });
};
const $134592d23f105dbc$export$ae67eb518a2aae74 = ()=>{
    $134592d23f105dbc$export$77e4cc5334565f28.setState({
        displayAgent: true
    });
};
const $134592d23f105dbc$export$e73dbd7ba351e3e = ()=>{
    $134592d23f105dbc$export$77e4cc5334565f28.setState({
        displayAgent: false
    });
};
const $134592d23f105dbc$export$d4c8c6daac289378 = (activity)=>{
    $134592d23f105dbc$export$77e4cc5334565f28.setState({
        activityToSend: activity
    });
};


const $a56e9ca45008a3e7$var$regexDataCommand = /(\{data-command=")[\p{L}\p{N}\p{Po}\p{Pd}\p{Pc}\s]+("\})(<br\s\/>)?/gu;
const $a56e9ca45008a3e7$var$createCustomStore = (userData, enableConversationCookie, conversationCookieMaxAge, addressData, skipWelcome, locale, externalEventHandler, isUsedOnBorne)=>{
    return (0, $497baa802110a7bc$exports.createStore)({}, ({ dispatch: dispatch })=>(next)=>async (action)=>{
                // Switch on action's type to process if needed
                switch(action.type){
                    case "DIRECT_LINE/CONNECT_FULFILLED":
                        // Start_speaking for webchat to get the welcome speech if there is one
                        dispatch({
                            type: "WEB_CHAT/START_SPEAKING"
                        });
                        if (!(enableConversationCookie === false)) {
                            const conversationCookie = document.cookie.split("; ").find((row)=>row.startsWith("retorikConversationCookie="))?.split("=")[1];
                            const fullTenantName = (addressData.baseURI || `${addressData.prefix || ""}${addressData.tenant}`).replace(/;|,|\s/g, "");
                            if (conversationCookie && conversationCookie.split("||").length === 2 && conversationCookie.split("||")[1] === fullTenantName) break;
                            else document.cookie = `retorikConversationCookie=${action.payload.directLine.conversationId}||${fullTenantName}; max-age=${conversationCookieMaxAge || 3600}`;
                        }
                        setTimeout(()=>{
                            dispatch({
                                type: "WEB_CHAT/SEND_EVENT",
                                payload: {
                                    name: "setUser",
                                    value: {
                                        user: userData,
                                        skipWelcome: skipWelcome
                                    }
                                }
                            });
                        }, 2000);
                        break;
                    case "DIRECT_LINE/POST_ACTIVITY":
                        // Cancel playing utterance if there is one
                        (0, $b3b97ac6cb18c5e1$export$d0df6aec4e971f52)(true);
                        // Send pagination and position data in channelData on each activity sent to the chatbot, using local storage to get up to date data
                        if (action.payload?.activity) {
                            const paginationAsString = localStorage.getItem("Retorik.Framework.Pagination");
                            const positionAsString = localStorage.getItem("Retorik.Framework.Location");
                            const position = positionAsString ? JSON.parse(positionAsString) : undefined;
                            const dataAddedToChannelData = {
                                pageSize: paginationAsString ? JSON.parse(paginationAsString) : 10
                            };
                            if (position && position.latitude && position.longitude) {
                                dataAddedToChannelData.location = {
                                    latitude: position.latitude,
                                    longitude: position.longitude
                                };
                                dataAddedToChannelData.position = {
                                    latitude: position.latitude,
                                    longitude: position.longitude
                                };
                            }
                            if (action.payload.activity.channelData === undefined) action.payload.activity = {
                                ...action.payload.activity,
                                channelData: dataAddedToChannelData
                            };
                            else action.payload.activity.channelData = {
                                ...action.payload.activity.channelData,
                                ...dataAddedToChannelData
                            };
                        }
                        break;
                    case "DIRECT_LINE/DISCONNECT":
                        action = {
                            type: "WEB_CHAT/SET_LANGUAGE",
                            payload: {
                                language: locale
                            }
                        };
                        break;
                    case "DIRECT_LINE/INCOMING_ACTIVITY":
                        // Only process message activities from the bot
                        if (action.payload?.activity?.type === "message" && action.payload.activity.from.role === "bot") {
                            (0, $134592d23f105dbc$export$f03cfde7db70aa27)(false);
                            // If the application is used on a borne and there are attachments, check if a received attachment is a multi-link one.
                            // If there is some, we need to split it in several attachments, one for each link.
                            if (isUsedOnBorne && action.payload?.activity?.attachments && action.payload.activity.attachments.length > 0) {
                                let count = 0;
                                const tempAttachments = [];
                                for (const attachment of action.payload.activity.attachments)if (attachment.contentType === (0, $67e1576cd7fc37b7$export$cce25171fe980112) && Array.isArray(attachment.content?.urlData)) {
                                    count++;
                                    const splitAttachments = await (0, $3f68a0a0632324e9$export$bd1cb79b05472e01)(attachment.content.urlData);
                                    tempAttachments.push(...splitAttachments);
                                } else tempAttachments.push(attachment);
                                // If some attachments have been split, we replace the attachments in the activity
                                count > 0 && (action.payload.activity.attachments = tempAttachments);
                                // Carousel display if there is more than 1 card
                                count > 0 && action.payload.activity.attachments.length > 1 && (action.payload.activity.attachmentLayout = "carousel");
                            }
                            const processedData = (0, $3a13fefbd1dfa779$export$2e2bcd8739ae039)(action);
                            // Set processed speak, text and attachments if there are some
                            processedData.speak && (action.payload.activity.speak = processedData.speak);
                            processedData.text && (action.payload.activity.text = processedData.text);
                            processedData.htmlText && (action.payload.activity.htmlText = processedData.htmlText);
                            // Check if there are cards to create from images
                            if (processedData.images.length > 0) {
                                // If there is no attachment field, create an empty one
                                action.payload.activity.attachments === undefined && (action.payload.activity.attachments = []);
                                // Create content from image data and add it to the attachments
                                for (const image of processedData.images){
                                    const imageAttachment = await (0, $ece6f00909886802$export$2e2bcd8739ae039)(image);
                                    action.payload.activity.attachments.push(imageAttachment);
                                }
                                action.payload.activity.attachments.length > 1 && (action.payload.activity.attachmentLayout = "carousel");
                            }
                            // Check if there are cards to create from links
                            if (processedData.urls.length > 0) {
                                // If there is no attachment field, create an empty one
                                action.payload.activity.attachments === undefined && (action.payload.activity.attachments = []);
                                // Create content asynchonously from url data and add it to the attachments
                                for (const url of processedData.urls){
                                    const fetchedAttachment = await (0, $3f68a0a0632324e9$export$2e2bcd8739ae039)(url);
                                    action.payload.activity.attachments.push(fetchedAttachment);
                                }
                                action.payload.activity.attachments.length > 1 && (action.payload.activity.attachmentLayout = "carousel");
                            }
                            // Transform herocards in adaptivecards
                            const heroToAdaptiveAttachments = (0, $ff92641258eba8d4$export$4a92a69e5bfa5f9a)(action.payload.activity.attachments);
                            heroToAdaptiveAttachments && (action.payload.activity.attachments = [
                                ...heroToAdaptiveAttachments
                            ]);
                            // Transform suggested actions into cards if the display isn't daviList
                            if (action.payload.activity.suggestedActions?.actions && action.payload.activity.attachmentLayout?.toLowerCase() !== "davilist") {
                                let actionsArray = [];
                                action.payload.activity.suggestedActions.actions.forEach((suggestedAction)=>{
                                    const action = {
                                        title: suggestedAction.title,
                                        action: suggestedAction.value
                                    };
                                    actionsArray = [
                                        ...actionsArray,
                                        action
                                    ];
                                });
                                const suggestedActionAttachment = {
                                    contentType: (0, $67e1576cd7fc37b7$export$2730c89e9ebd0948),
                                    content: {
                                        title: action.payload.activity.text || "",
                                        actions: actionsArray
                                    }
                                };
                                // Create field attachments with the newly created one if no attachment yet, or add to existing ones
                                action.payload.activity.attachments === undefined ? action.payload.activity.attachments = [
                                    suggestedActionAttachment
                                ] : action.payload.activity.attachments.push(suggestedActionAttachment);
                            }
                            // Deal with text containing [data command] data to make them usable in text mode
                            if (action.payload.activity?.text && action.payload.activity.text.includes("{data-command=")) {
                                const splitText = action.payload.activity.text.split("{data-command=");
                                const dataForAttachment = [];
                                for(let i = 1; i < splitText.length; i++){
                                    const text = splitText[i - 1].substring(splitText[i - 1].lastIndexOf("\n") ? splitText[i - 1].lastIndexOf("\n") + 1 : 0);
                                    const replacement = splitText[i].substring(0, splitText[i].indexOf("}")).replaceAll('"', "");
                                    dataForAttachment.push({
                                        text: text,
                                        differentTextToSend: replacement
                                    });
                                    // Remove text part from speak / text / htmlText
                                    action.payload.activity.speak && (action.payload.activity.speak = action.payload.activity.speak.replace(text, ""));
                                    action.payload.activity.text = action.payload.activity.text.replace(text, "");
                                    action.payload.activity.htmlText = action.payload.activity.htmlText.replace(text, "");
                                }
                                if (dataForAttachment.length > 0) {
                                    const suggestionAttachment = {
                                        contentType: (0, $67e1576cd7fc37b7$export$a4f2f23a67537f78),
                                        content: {
                                            suggestions: dataForAttachment,
                                            showTutorial: false
                                        }
                                    };
                                    // Create field attachment swith the newly created one if no attachment yet, or add to existing ones
                                    action.payload.activity.attachments === undefined ? action.payload.activity.attachments = [
                                        suggestionAttachment
                                    ] : action.payload.activity.attachments.push(suggestionAttachment);
                                }
                                // Remove all [data command] from speak / text / htmlText
                                action.payload.activity.speak && (action.payload.activity.speak = action.payload.activity.speak.replaceAll($a56e9ca45008a3e7$var$regexDataCommand, ""));
                                action.payload.activity.text = action.payload.activity.text.replaceAll($a56e9ca45008a3e7$var$regexDataCommand, "");
                                action.payload.activity.htmlText = action.payload.activity.htmlText.replaceAll($a56e9ca45008a3e7$var$regexDataCommand, "");
                            }
                        }
                        break;
                    case "WEB_CHAT/START_DICTATE":
                    case "WEB_CHAT/SEND_MESSAGE":
                        // Cancel playing utterance if there is one
                        (0, $b3b97ac6cb18c5e1$export$d0df6aec4e971f52)(true);
                        break;
                    case "WEB_CHAT/SUBMIT_SEND_BOX":
                        {
                            // Send event containing the speech retrieved from speech recognition
                            const alternatives = action.payload?.channelData?.speech?.alternatives;
                            if (alternatives && Array.isArray(alternatives) && alternatives.length > 0) {
                                const speech = alternatives[0].transcript;
                                const speechEvent = new CustomEvent("retorikSpeechRecognitionEnded", {
                                    detail: speech
                                });
                                document.dispatchEvent(speechEvent);
                            }
                            break;
                        }
                    default:
                        break;
                }
                // External event handler to listen for actions from outside the Composer component
                if (externalEventHandler && externalEventHandler !== null && typeof externalEventHandler === "function") {
                    const externalStopTrigger = externalEventHandler(action, dispatch);
                    if (externalStopTrigger) return;
                }
                return next(action);
            });
};
var $a56e9ca45008a3e7$export$2e2bcd8739ae039 = $a56e9ca45008a3e7$var$createCustomStore;



var $eO7Kz = parcelRequire("eO7Kz");



var $eO7Kz = parcelRequire("eO7Kz");


const $e599569c1fc3ca2c$var$defaultConfiguration = {
    subtitles: false
};
const $e599569c1fc3ca2c$var$RetorikContextDefaultValues = {
    mode: (0, $16ad089b9ce6627d$export$9484bbecc3c49a2e).vocal,
    configuration: $e599569c1fc3ca2c$var$defaultConfiguration,
    displaySubtitles: false,
    allLanguages: [],
    agentData: undefined,
    appAvailable: false,
    currentSubView: (0, $16ad089b9ce6627d$export$f05d0fed0593ead7).none,
    customView: undefined,
    loaderClosed: false,
    addressData: {},
    canFocusSendBox: false,
    setMode: ()=>{},
    setConfiguration: ()=>{},
    setDisplaySubtitles: ()=>{},
    setAllLanguages: ()=>{},
    setAgentData: ()=>{},
    setAppAvailable: ()=>{},
    setCurrentSubView: ()=>{},
    setCustomView: ()=>{},
    setLoaderClosed: ()=>{},
    setCurrentAddressData: ()=>{},
    setSendBoxRef: ()=>{},
    focusSendBox: ()=>{},
    setCanFocusSendBox: ()=>{}
};
const $e599569c1fc3ca2c$export$353e73f2cc0f3642 = /*#__PURE__*/ (0, $eO7Kz.createContext)($e599569c1fc3ca2c$var$RetorikContextDefaultValues);
function $e599569c1fc3ca2c$export$d8760bee47331b1d() {
    return (0, $eO7Kz.useContext)($e599569c1fc3ca2c$export$353e73f2cc0f3642);
}
function $e599569c1fc3ca2c$export$8d0f3aad9142f5c7({ skipLoader: skipLoader, chosenMode: chosenMode, config: config, currentLocale: currentLocale, allLocales: allLocales, agentManifest: agentManifest, children: children, addressData: addressData }) {
    const [currentAddressData, setCurrentAddressData] = (0, $eO7Kz.useState)(addressData);
    const [mode, setMode] = (0, $eO7Kz.useState)(chosenMode);
    const [configuration, setConfiguration] = (0, $eO7Kz.useState)(config);
    const [displaySubtitles, setDisplaySubtitles] = (0, $eO7Kz.useState)(config.subtitles || mode === (0, $16ad089b9ce6627d$export$9484bbecc3c49a2e).text);
    const [locale, setLocale] = (0, $eO7Kz.useState)(currentLocale);
    const [allLanguages, setAllLanguages] = (0, $eO7Kz.useState)(allLocales || []);
    const [currentSubView, setCurrentSubView] = (0, $eO7Kz.useState)((0, $16ad089b9ce6627d$export$f05d0fed0593ead7).none);
    const [customView, setCustomView] = (0, $eO7Kz.useState)();
    const [agentData, setAgentData] = (0, $eO7Kz.useState)(agentManifest);
    const [appAvailable, setAppAvailable] = (0, $eO7Kz.useState)(false);
    const [loaderClosed, setLoaderClosed] = (0, $eO7Kz.useState)(!!skipLoader);
    const [sendBoxRef, setSendBoxRef] = (0, $eO7Kz.useState)(null);
    const [canFocusSendBox, setCanFocusSendBox] = (0, $eO7Kz.useState)(false);
    const { currentCustomView: currentCustomView } = (0, $134592d23f105dbc$export$77e4cc5334565f28)();
    const focusSendBox = ()=>{
        sendBoxRef && document.activeElement !== sendBoxRef && sendBoxRef.focus();
    };
    const value = (0, $eO7Kz.useMemo)(()=>({
            mode: mode,
            configuration: configuration,
            displaySubtitles: displaySubtitles,
            locale: locale,
            allLanguages: allLanguages,
            agentData: agentData,
            appAvailable: appAvailable,
            currentSubView: currentSubView,
            customView: customView,
            loaderClosed: loaderClosed,
            currentAddressData: currentAddressData,
            addressData: addressData,
            canFocusSendBox: canFocusSendBox,
            setConfiguration: setConfiguration,
            setDisplaySubtitles: setDisplaySubtitles,
            setLocale: setLocale,
            setAllLanguages: setAllLanguages,
            setAgentData: setAgentData,
            setAppAvailable: setAppAvailable,
            setMode: setMode,
            setCurrentSubView: setCurrentSubView,
            setCustomView: setCustomView,
            setLoaderClosed: setLoaderClosed,
            setCurrentAddressData: setCurrentAddressData,
            setSendBoxRef: setSendBoxRef,
            focusSendBox: focusSendBox,
            setCanFocusSendBox: setCanFocusSendBox
        }), [
        mode,
        configuration,
        displaySubtitles,
        locale,
        allLanguages,
        agentData,
        appAvailable,
        currentSubView,
        customView,
        loaderClosed,
        currentAddressData,
        canFocusSendBox,
        setConfiguration,
        setDisplaySubtitles,
        setLocale,
        setAllLanguages,
        setAgentData,
        setAppAvailable,
        setMode,
        setCurrentSubView,
        setCustomView,
        setLoaderClosed,
        setCurrentAddressData,
        setSendBoxRef,
        setCanFocusSendBox
    ]);
    const setLocation = async (data)=>{
        const position = {
            searchForLocation: true,
            latitude: data.coords.latitude,
            longitude: data.coords.longitude
        };
        localStorage.setItem("Retorik.Framework.Location", JSON.stringify(position));
        /*
    const cityName = await getCity(data.coords.latitude, data.coords.longitude)
    if (cityName) {
      position.city = cityName.city
      position.country = cityName.country
    }
    */ setConfiguration({
            ...configuration,
            position: position
        });
    };
    // TODO find a stronger solution for this (using free api service with limited usage)
    /*
  const getCity = async (
    latitude,
    longitude
  ): Promise<{ city: string; country: string } | undefined> => {
    console.log('using reverse geocoding to fetch city')
    return fetch(
      `https://api.opencagedata.com/geocode/v1/json?q=${latitude}+${longitude}&key=3ee1620fde1f4bbeb44b2d01314ae5da`
    )
      .then((response) => response.json())
      .then((data) => {
        console.log(data)
        if (data.results?.length) {
          const result = data.results[0].components
          if (result) {
            return { city: result.city, country: result.country }
          }
        }
        return undefined
      })
      .catch((error) => {
        console.log(error)
        return undefined
      })
  }
  */ // get position from navigator
    (0, $eO7Kz.useEffect)(()=>{
        if (configuration.position?.searchForLocation) // Position enabled
        {
            if (configuration.position?.latitude === undefined && configuration.position?.longitude === undefined) {
                // Try to get the position of the device if no one has been given in the configuration
                const geoloc = navigator.geolocation;
                geoloc.getCurrentPosition(setLocation, ()=>{
                    console.log("navigator.geolocalisation failed");
                }, {
                    timeout: 3000
                });
            }
        }
    }, []);
    /**
   * On chosenMode props change :
   *  - update mode state
   *  - update displaySubtitles state if no data has been provided in the configuration
   */ (0, $eO7Kz.useEffect)(()=>{
        setMode(chosenMode);
    }, [
        chosenMode
    ]);
    /**
   * On mode state change :
   *  - update displaySubtitles state depending on the mode
   */ (0, $eO7Kz.useEffect)(()=>{
        if (!config.subtitles) setDisplaySubtitles(false);
        (0, $134592d23f105dbc$export$e2194ce98b9711c9)(undefined);
    }, [
        mode
    ]);
    /**
   * On config props change :
   *  - update configuration state
   */ (0, $eO7Kz.useEffect)(()=>{
        setConfiguration(config);
    }, [
        config
    ]);
    /**
   * On configuration.position change :
   *  - set the new data in localStorage
   */ (0, $eO7Kz.useEffect)(()=>{
        localStorage.setItem("Retorik.Framework.Location", JSON.stringify(configuration.position || null));
    }, [
        configuration.position
    ]);
    /**
   * On locale change :
   *  - dispatch CustomEvent 'retorikChangeLocale' with locale in detail field for external use
   */ (0, $eO7Kz.useEffect)(()=>{
        const changeLocaleEvent = new CustomEvent("retorikChangeLocale", {
            detail: {
                locale: locale
            }
        });
        document.dispatchEvent(changeLocaleEvent);
    }, [
        locale
    ]);
    (0, $eO7Kz.useEffect)(()=>{
        (0, $134592d23f105dbc$export$f0c096b4ecd7115d)(currentSubView);
    }, [
        currentSubView
    ]);
    (0, $eO7Kz.useEffect)(()=>{
        if (currentCustomView) {
            let label = "";
            if (currentCustomView.label && typeof currentCustomView.label === "string") label = currentCustomView.label;
            else if (currentCustomView.label && typeof currentCustomView.label === "object") label = currentCustomView.label[locale];
            if (label && currentCustomView.customDisplay && currentCustomView.icon) setCustomView({
                view: currentCustomView.customDisplay,
                title: label,
                icon: currentCustomView.icon
            });
            setCurrentSubView((0, $16ad089b9ce6627d$export$f05d0fed0593ead7).custom);
        }
    }, [
        currentCustomView
    ]);
    /**
   * On agentManifest change :
   *  - Set Agent Data if different
   */ (0, $eO7Kz.useEffect)(()=>{
        if (agentData !== agentManifest) {
            console.log("Switch Agent Data", agentManifest);
            setAgentData(agentManifest);
        }
    }, [
        agentManifest
    ]);
    return /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)($e599569c1fc3ca2c$export$353e73f2cc0f3642.Provider, {
        value: value,
        children: children
    });
}






const $c3aed5b5062ec765$var$processBaseURI = (baseURI)=>{
    if (baseURI && baseURI.length > 0) {
        if (baseURI.indexOf(`/${(0, $674f1d59bae686ab$export$d9e38c0112bbdae6)}`) > -1) baseURI = baseURI.replace(`/${(0, $674f1d59bae686ab$export$d9e38c0112bbdae6)}`, "");
    }
    return baseURI;
};
var $c3aed5b5062ec765$export$2e2bcd8739ae039 = $c3aed5b5062ec765$var$processBaseURI;



async function $01e7c60bc140a1c6$export$2e2bcd8739ae039({ tenant: tenant, prefix: prefix, baseURI: baseURI }) {
    const fullAddress = `${baseURI && baseURI?.length > 0 ? (0, $c3aed5b5062ec765$export$2e2bcd8739ae039)(baseURI) : (0, $519f31eef1fe5fca$export$2e2bcd8739ae039)(prefix)}/${tenant ? tenant + "/" : ""}api/graphql?query={siteCultures{culture,default}}`;
    const languages = await fetch(fullAddress).then((res)=>res.json()).then((json)=>{
        return $01e7c60bc140a1c6$var$processJson(json);
    }).catch((error)=>{
        console.log(error);
        return 0, $674f1d59bae686ab$export$8828fbbb6034a09b;
    });
    return languages;
}
/* The data received from the fetch are as follows
{
  data: {
    siteCultures: [
      {
        culture: "fr-FR",
        default: true
      },
      {
        culture: "en-US",
        default: false
      },
      {
        culture: "de-DE",
        default: false
      }
    ]
  }
}
*/ const $01e7c60bc140a1c6$var$processJson = (json)=>{
    if (!json.data?.siteCultures || !json.data.siteCultures?.length) return 0, $674f1d59bae686ab$export$8828fbbb6034a09b;
    const siteCultures = json.data.siteCultures;
    const processedLanguages = {
        all: siteCultures.map((siteCulture)=>siteCulture.culture),
        default: siteCultures.find((siteCulture)=>siteCulture.default)?.culture || siteCultures[0].culture
    };
    return processedLanguages;
};


const $2e4dc8fa28d39601$export$6650dace022cfacc = (0, $8deac4f58fe9f113$exports.create)()(()=>{
    return {
        locale: "",
        defaultLocale: "fr-FR",
        supported: []
    };
});
const $2e4dc8fa28d39601$export$180605366c04f0cd = ()=>{
    return $2e4dc8fa28d39601$export$6650dace022cfacc((state)=>state.locale);
};
const $2e4dc8fa28d39601$export$c8aadf3621e41efb = (locale)=>{
    $2e4dc8fa28d39601$export$6650dace022cfacc.setState({
        locale: locale
    });
};
const $2e4dc8fa28d39601$export$fe443f6e3680433 = async (addressData)=>{
    return (0, $01e7c60bc140a1c6$export$2e2bcd8739ae039)(addressData).then((languages)=>{
        $2e4dc8fa28d39601$export$6650dace022cfacc.setState({
            defaultLocale: languages.default,
            supported: languages.all
        });
        return languages;
    });
};


const { useMicrophoneButtonClick: $509013a06567fce8$var$useMicrophoneButtonClick, usePostActivity: $509013a06567fce8$var$usePostActivity } = (0, $497baa802110a7bc$exports.hooks);
const $509013a06567fce8$var$SendActivityEventListener = ()=>{
    const sendPostActivity = $509013a06567fce8$var$usePostActivity();
    const locale = (0, $2e4dc8fa28d39601$export$6650dace022cfacc)((state)=>state.locale);
    const activityToSend = (0, $134592d23f105dbc$export$77e4cc5334565f28)((state)=>state.activityToSend);
    const microphoneButtonClick = $509013a06567fce8$var$useMicrophoneButtonClick();
    const { setDisplaySubtitles: setDisplaySubtitles } = (0, $e599569c1fc3ca2c$export$d8760bee47331b1d)();
    const sendActivity = (event)=>{
        if (event.type === "sendMessageEvent") console.log("sendMessageEvent has been replaced by retorikSendActivity. Please use retorikSendActivity instead");
        else if (event.detail) sendPostActivity(event.detail);
    };
    const handleStartListening = ()=>{
        microphoneButtonClick();
    };
    const handleDisplaySubtitles = (event)=>{
        setDisplaySubtitles(!!event.detail);
    };
    (0, $eO7Kz.useEffect)(()=>{
        document.addEventListener("sendMessageEvent", sendActivity);
        document.addEventListener("retorikSendActivity", sendActivity);
        document.addEventListener("retorikStartListening", handleStartListening);
        document.addEventListener("retorikDisplaySubtitles", handleDisplaySubtitles);
        return ()=>{
            document.removeEventListener("sendMessageEvent", sendActivity);
            document.removeEventListener("retorikSendActivity", sendActivity);
            document.removeEventListener("retorikStartListening", handleStartListening);
            document.removeEventListener("retorikDisplaySubtitles", handleDisplaySubtitles);
        };
    }, []);
    (0, $eO7Kz.useEffect)(()=>{
        if (activityToSend) {
            if (activityToSend.type === "message" && activityToSend.text && typeof activityToSend.text !== "string") {
                const tempActivity = {
                    ...activityToSend
                };
                tempActivity.text = activityToSend.text[locale] || "";
                sendPostActivity(tempActivity);
            } else sendPostActivity(activityToSend);
            (0, $134592d23f105dbc$export$d4c8c6daac289378)(undefined);
        }
    }, [
        activityToSend
    ]);
    return null;
};
var $509013a06567fce8$export$2e2bcd8739ae039 = $509013a06567fce8$var$SendActivityEventListener;




var $eO7Kz = parcelRequire("eO7Kz");



const $633c6ef6f1f791c0$var$SpeechContextDefaultValues = {
    speaking: false,
    currentReplyToId: undefined,
    currentPlaying: undefined,
    queuedActivities: [],
    endedActivities: [],
    ponyfillCredentials: {
        region: "francecentral",
        subscriptionKey: ""
    },
    muted: false,
    speechAllowed: true,
    boundaryData: [],
    setSpeaking: ()=>{},
    setCurrentReplyToId: ()=>{},
    setCurrentPlaying: ()=>{},
    setQueuedActivities: ()=>{},
    setEndedActivities: ()=>{},
    setPonyfillCredentials: ()=>{},
    setMuted: ()=>{},
    setSpeechAllowed: ()=>{},
    setBoundaryData: ()=>{}
};
const $633c6ef6f1f791c0$export$11ed12a49459a250 = /*#__PURE__*/ (0, $eO7Kz.createContext)($633c6ef6f1f791c0$var$SpeechContextDefaultValues);
function $633c6ef6f1f791c0$export$57e792e009c800a0() {
    return (0, $eO7Kz.useContext)($633c6ef6f1f791c0$export$11ed12a49459a250);
}
function $633c6ef6f1f791c0$export$c3549adc483a11c2({ ponyfillFactoryCredentials: ponyfillFactoryCredentials, children: children }) {
    const { mode: mode } = (0, $e599569c1fc3ca2c$export$d8760bee47331b1d)();
    const [speaking, setSpeaking] = (0, $eO7Kz.useState)(false);
    const [currentReplyToId, setCurrentReplyToId] = (0, $eO7Kz.useState)(undefined);
    const [currentPlaying, setCurrentPlaying] = (0, $eO7Kz.useState)(undefined);
    const [queuedActivities, setQueuedActivities] = (0, $eO7Kz.useState)([]);
    const [endedActivities, setEndedActivities] = (0, $eO7Kz.useState)([]);
    const [ponyfillCredentials, setPonyfillCredentials] = (0, $eO7Kz.useState)(ponyfillFactoryCredentials);
    const [muted, setMuted] = (0, $eO7Kz.useState)(false);
    const [speechAllowed, setSpeechAllowed] = (0, $eO7Kz.useState)(mode === (0, $16ad089b9ce6627d$export$9484bbecc3c49a2e).vocal);
    const [boundaryData, setBoundaryData] = (0, $eO7Kz.useState)([]);
    const value = (0, $eO7Kz.useMemo)(()=>({
            speaking: speaking,
            currentReplyToId: currentReplyToId,
            currentPlaying: currentPlaying,
            queuedActivities: queuedActivities,
            endedActivities: endedActivities,
            ponyfillCredentials: ponyfillCredentials,
            muted: muted,
            speechAllowed: speechAllowed,
            boundaryData: boundaryData,
            setSpeaking: setSpeaking,
            setCurrentReplyToId: setCurrentReplyToId,
            setCurrentPlaying: setCurrentPlaying,
            setQueuedActivities: setQueuedActivities,
            setEndedActivities: setEndedActivities,
            setPonyfillCredentials: setPonyfillCredentials,
            setMuted: setMuted,
            setSpeechAllowed: setSpeechAllowed,
            setBoundaryData: setBoundaryData
        }), [
        speaking,
        currentReplyToId,
        currentPlaying,
        queuedActivities,
        endedActivities,
        ponyfillCredentials,
        muted,
        speechAllowed,
        boundaryData,
        setSpeaking,
        setCurrentReplyToId,
        setCurrentPlaying,
        setQueuedActivities,
        setEndedActivities,
        setPonyfillCredentials,
        setMuted,
        setSpeechAllowed,
        setBoundaryData
    ]);
    /**
   * On mode change :
   *  - update speechAllowed state
   */ (0, $eO7Kz.useEffect)(()=>{
        setSpeechAllowed(mode === (0, $16ad089b9ce6627d$export$9484bbecc3c49a2e).vocal);
    }, [
        mode
    ]);
    (0, $eO7Kz.useEffect)(()=>{
        (0, $134592d23f105dbc$export$dcb32d000c0e0280)(speaking ? (0, $16ad089b9ce6627d$export$4f7cd669585dc69f).SpeechStarted : (0, $16ad089b9ce6627d$export$4f7cd669585dc69f).SpeechEnded);
    }, [
        speaking
    ]);
    return /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eO7Kz))).Fragment, {
        children: /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)($633c6ef6f1f791c0$export$11ed12a49459a250.Provider, {
            value: value,
            children: children
        })
    });
}




const $c08ae7852f6ee92a$var$color = "#00D7FF";
const $c08ae7852f6ee92a$var$white = "#F7F3F6";
const $c08ae7852f6ee92a$export$d30af3ec38729f1 = {
    hostCapabilities: {
        capabilities: null
    },
    choiceSetInputValueSeparator: ",",
    supportsInteractivity: true,
    fontTypes: {
        default: {
            fontFamily: '"Helvetica Neue", sans-serif',
            fontSizes: {
                small: 12,
                default: 16,
                medium: 20,
                large: 26,
                extraLarge: 33
            },
            fontWeights: {
                lighter: 200,
                default: 300,
                bolder: 400
            }
        },
        monospace: {
            fontFamily: '"Helvetica Neue", sans-serif',
            fontSizes: {
                small: 12,
                default: 16,
                medium: 20,
                large: 26,
                extraLarge: 33
            },
            fontWeights: {
                lighter: 200,
                default: 300,
                bolder: 400
            }
        }
    },
    spacing: {
        small: 8,
        default: 16,
        medium: 20,
        large: 30,
        extraLarge: 40,
        padding: 25
    },
    separator: {
        lineThickness: 1,
        lineColor: "transparent"
    },
    imageSizes: {
        small: 40,
        medium: 100,
        large: 160
    },
    containerStyles: {
        default: {
            foregroundColors: {
                default: {
                    default: `${$c08ae7852f6ee92a$var$white}`,
                    subtle: `${$c08ae7852f6ee92a$var$color}`,
                    highlightColors: {
                        default: `${$c08ae7852f6ee92a$var$color}`,
                        subtle: "#11000000"
                    }
                },
                dark: {
                    default: "#000000",
                    subtle: "#66000000",
                    highlightColors: {
                        default: "#22000000",
                        subtle: "#11000000"
                    }
                },
                light: {
                    default: "#FFFFFF",
                    subtle: "#33000000",
                    highlightColors: {
                        default: "#22000000",
                        subtle: "#11000000"
                    }
                },
                accent: {
                    default: "#0063B1",
                    subtle: "#0063B1",
                    highlightColors: {
                        default: "#22000000",
                        subtle: "#11000000"
                    }
                },
                good: {
                    default: "#54a254",
                    subtle: "#DD54a254",
                    highlightColors: {
                        default: "#22000000",
                        subtle: "#11000000"
                    }
                },
                warning: {
                    default: "#c3ab23",
                    subtle: "#DDc3ab23",
                    highlightColors: {
                        default: "#22000000",
                        subtle: "#11000000"
                    }
                },
                attention: {
                    default: "#FF0000",
                    subtle: "#DDFF0000",
                    highlightColors: {
                        default: "#22000000",
                        subtle: "#11000000"
                    }
                }
            },
            backgroundColor: "transparent"
        },
        emphasis: {
            foregroundColors: {
                default: {
                    default: "#000000",
                    subtle: "#767676",
                    highlightColors: {
                        default: "#22000000",
                        subtle: "#11000000"
                    }
                },
                dark: {
                    default: "#000000",
                    subtle: "#66000000",
                    highlightColors: {
                        default: "#22000000",
                        subtle: "#11000000"
                    }
                },
                light: {
                    default: "#FFFFFF",
                    subtle: "#33000000",
                    highlightColors: {
                        default: "#22000000",
                        subtle: "#11000000"
                    }
                },
                accent: {
                    default: "#2E89FC",
                    subtle: "#882E89FC",
                    highlightColors: {
                        default: "#22000000",
                        subtle: "#11000000"
                    }
                },
                good: {
                    default: "#54a254",
                    subtle: "#DD54a254",
                    highlightColors: {
                        default: "#22000000",
                        subtle: "#11000000"
                    }
                },
                warning: {
                    default: "#c3ab23",
                    subtle: "#DDc3ab23",
                    highlightColors: {
                        default: "#22000000",
                        subtle: "#11000000"
                    }
                },
                attention: {
                    default: "#FF0000",
                    subtle: "#DDFF0000",
                    highlightColors: {
                        default: "#22000000",
                        subtle: "#11000000"
                    }
                }
            },
            backgroundColor: "#F0F0F0"
        }
    },
    actions: {
        maxActions: 100,
        spacing: "Default",
        buttonSpacing: 0,
        showCard: {
            actionMode: "Inline",
            inlineTopMargin: 8,
            style: "emphasis"
        },
        preExpandSingleShowCardAction: false,
        actionsOrientation: "vertical",
        actionAlignment: "left",
        wrap: true
    },
    adaptiveCard: {
        allowCustomStyle: true
    },
    imageSet: {
        maxImageHeight: 100
    },
    media: {
        allowInlinePlayback: true
    },
    factSet: {
        title: {
            size: "Default",
            color: `${$c08ae7852f6ee92a$var$color}`,
            isSubtle: false,
            weight: "Bolder",
            wrap: true
        },
        value: {
            size: "Default",
            color: `${$c08ae7852f6ee92a$var$color}`,
            isSubtle: false,
            weight: "Default",
            wrap: true
        },
        spacing: 1000
    },
    cssClassNamePrefix: null,
    _legacyFontType: {
        fontFamily: "Helvetica Neue,sans-serif",
        fontSizes: {
            small: 12,
            default: 16,
            medium: 20,
            large: 26,
            extraLarge: 33
        },
        fontWeights: {
            lighter: 200,
            default: 400,
            bolder: 600
        }
    }
};


const $264104565ab24525$var$createAdaptiveCardHostConfig = (primary, cardBackground)=>{
    const template = (0, $c08ae7852f6ee92a$export$d30af3ec38729f1);
    template.containerStyles.default.foregroundColors.default.default = primary;
    template.containerStyles.default.backgroundColor = cardBackground;
    return template;
};
var $264104565ab24525$export$2e2bcd8739ae039 = $264104565ab24525$var$createAdaptiveCardHostConfig;



parcelRequire("eO7Kz");


parcelRequire("eO7Kz");


var $eO7Kz = parcelRequire("eO7Kz");

parcelRequire("eO7Kz");
const $95567835a53bf5e8$var$ChevronLeftIcon = ({ className: className, color: color })=>{
    return /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        className: className || "rf-h-6 rf-w-4",
        viewBox: "0 0 7.414 12.828",
        children: /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("path", {
            d: "M1429.081,2861.407l5-5-5-5",
            transform: "translate(1435.081 2862.822) rotate(180)",
            fill: "none",
            stroke: color || "#fff",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: "2"
        })
    });
};
var $95567835a53bf5e8$export$2e2bcd8739ae039 = $95567835a53bf5e8$var$ChevronLeftIcon;



parcelRequire("eO7Kz");
const $665d46c53901fdd5$var$ChevronRightIcon = ({ className: className, color: color })=>{
    return /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        className: className || "rf-h-6 rf-w-4",
        viewBox: "0 0 10.131 17.719",
        children: /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("path", {
            d: "M8.863,7.077l6.7-6.705a1.261,1.261,0,0,1,1.788,0,1.277,1.277,0,0,1,0,1.794L9.76,9.762A1.264,1.264,0,0,1,8.014,9.8L.369,2.171A1.266,1.266,0,0,1,2.158.377Z",
            transform: "translate(0 17.719) rotate(-90)",
            fill: color || "#818181"
        })
    });
};
var $665d46c53901fdd5$export$2e2bcd8739ae039 = $665d46c53901fdd5$var$ChevronRightIcon;



parcelRequire("eO7Kz");
const $57df9afa081b7d16$var$ChevronUpIcon = ({ className: className, color: color })=>{
    return /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 28 16.01",
        fill: color || "currentColor",
        className: className || "rf-h-6 rf-w-6",
        children: /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("path", {
            d: "M14 4.83 3.4 15.43a2 2 0 0 1-2.82 0 2.02 2.02 0 0 1 0-2.84l12-12a2 2 0 0 1 2.76-.06l12.08 12.05a2 2 0 0 1-2.83 2.83Z"
        })
    });
};
var $57df9afa081b7d16$export$2e2bcd8739ae039 = $57df9afa081b7d16$var$ChevronUpIcon;




var /**
 * Media types enum
 */ $fff38b5425abcfb1$var$MediaTypes;
(function($fff38b5425abcfb1$var$MediaTypes) {
    $fff38b5425abcfb1$var$MediaTypes[$fff38b5425abcfb1$var$MediaTypes["image"] = 1] = "image";
    $fff38b5425abcfb1$var$MediaTypes[$fff38b5425abcfb1$var$MediaTypes["video"] = 2] = "video";
})($fff38b5425abcfb1$var$MediaTypes || ($fff38b5425abcfb1$var$MediaTypes = {}));
const $fff38b5425abcfb1$var$images = [
    "png",
    "gif",
    "jpg",
    "jpeg"
];
const $fff38b5425abcfb1$var$videos = [
    "mp4",
    "webm",
    "3gp",
    "ogg"
];
const $fff38b5425abcfb1$var$Carousel = ({ className: className, medias: medias, controls: controls, timer: timer, color: color, maxHeight: maxHeight })=>{
    const [currentIndex, setCurrentIndex] = (0, $eO7Kz.useState)(0);
    const [currentMedia, setCurrentMedia] = (0, $eO7Kz.useState)();
    const timerRef = (0, $eO7Kz.useRef)(null);
    /**
   * On medias state change :
   *  - clear timerRef interval if set
   *  - call startNewMedia to reset medias
   *  - if there are more than 1 media, set a timeout and launch it
   * On component unmount :
   *  - clear timerRef interval if set
   */ (0, $eO7Kz.useEffect)(()=>{
        // Clear interval
        timerRef.current && clearInterval(timerRef.current);
        // Call the reset function to set currentIndex and currentMedia states
        startNewMedias();
        // Launch timer only if there are more than 1 media
        if (medias.length > 1 && timer !== 0) timerRef.current = setTimeout(()=>{
            handleMore();
        }, timer || 3000);
        return ()=>timerRef.current && clearTimeout(timerRef.current);
    }, [
        medias
    ]);
    /**
   * On currentIndex state change :
   *  - check type of media in medias array at current index by calling checkType method
   *  - set currentMedia state
   */ (0, $eO7Kz.useEffect)(()=>{
        if (currentIndex !== undefined) {
            const index = currentIndex % medias.length;
            const type = checkType(medias[index].url);
            if (type) {
                setCurrentMedia({
                    ...medias[index],
                    type: type
                });
                // Reset timer only if there are more than 1 media
                if (medias.length > 1 && timer !== 0) {
                    timerRef.current && clearTimeout(timerRef.current);
                    timerRef.current = setTimeout(()=>{
                        handleMore();
                    }, timer || 3000);
                }
            }
        }
    }, [
        currentIndex
    ]);
    /**
   * On call :
   *  - check if the currentIndex state is 0
   *  - if so, if we just update this state to 0 it will remain the same and won't change the currentMedia state. We just leave currentIndex as is and set currentMedia state instead.
   *  - otherwise, set the currentIndex state to 0
   */ const startNewMedias = ()=>{
        if (currentIndex === 0) {
            const type = checkType(medias[0].url);
            if (type) setCurrentMedia({
                ...medias[0],
                type: type
            });
        } else setCurrentIndex(0);
    };
    /**
   * On call :
   *  - retrieve the extension of the media
   *  - return if it's either an image, or a video, or null
   * @param src : string
   * @returns number | null
   */ const checkType = (src)=>{
        const extension = src.split(".").slice(-1)[0];
        return $fff38b5425abcfb1$var$images.includes(extension.toLowerCase()) ? $fff38b5425abcfb1$var$MediaTypes.image : $fff38b5425abcfb1$var$videos.includes(extension.toLowerCase()) ? $fff38b5425abcfb1$var$MediaTypes.video : null;
    };
    const handleChoice = (choice)=>{
        setCurrentIndex(choice);
    };
    const handleLess = ()=>{
        currentIndex === 0 ? setCurrentIndex(medias.length - 1) : setCurrentIndex((currentIndex)=>currentIndex - 1);
    };
    const handleMore = ()=>{
        currentIndex === medias.length - 1 ? setCurrentIndex(0) : setCurrentIndex((currentIndex)=>currentIndex + 1);
    };
    return currentMedia && currentMedia.type ? /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($eO7Kz))).Fragment, {
        children: [
            currentMedia.type === $fff38b5425abcfb1$var$MediaTypes.image ? /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("img", {
                className: className,
                src: currentMedia.url,
                alt: currentMedia.alt || "image",
                style: {
                    maxHeight: maxHeight
                }
            }) : /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("video", {
                className: className,
                style: {
                    maxHeight: maxHeight
                },
                children: /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("source", {
                    src: currentMedia.url
                })
            }),
            controls && medias.length > 1 && /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($eO7Kz))).Fragment, {
                children: [
                    /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("div", {
                        className: "rf-absolute rf-bottom-4 rf-left-1/2 -rf-translate-x-1/2 rf-flex rf-flex-row rf-items-center rf-gap-2",
                        children: medias.map((media, key)=>{
                            return /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("div", {
                                className: "rf-h-3 rf-w-3 rf-rounded-half rf-border rf-border-truewhite rf-cursor-pointer",
                                onClick: ()=>handleChoice(key),
                                style: {
                                    backgroundColor: currentIndex === key ? color : "transparent"
                                }
                            }, `${media.url}${key}`);
                        })
                    }),
                    /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("div", {
                        className: "rf-absolute rf-left-4 rf-top-1/2 -rf-translate-y-1/2 rf-cursor-pointer",
                        onClick: handleLess,
                        children: /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $95567835a53bf5e8$export$2e2bcd8739ae039), {
                            className: "rf-h-6 large:rf-h-8",
                            color: "#FFF"
                        })
                    }),
                    /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("div", {
                        className: "rf-absolute rf-right-4 rf-top-1/2 -rf-translate-y-1/2 rf-cursor-pointer",
                        onClick: handleMore,
                        children: /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $665d46c53901fdd5$export$2e2bcd8739ae039), {
                            className: "rf-h-6 large:rf-h-8",
                            color: "#FFF"
                        })
                    })
                ]
            })
        ]
    }) : /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eO7Kz))).Fragment, {});
};
var $fff38b5425abcfb1$export$2e2bcd8739ae039 = $fff38b5425abcfb1$var$Carousel;




var $eO7Kz = parcelRequire("eO7Kz");

const $d7666235a46cb40b$var$LocaleChangeEventListener = ()=>{
    const supportedLanguages = (0, $2e4dc8fa28d39601$export$6650dace022cfacc)((state)=>state.supported);
    (0, $eO7Kz.useEffect)(()=>{
        document.addEventListener("changeRetorikLocale", handleChangeRetorikLocale);
        return ()=>{
            document.removeEventListener("changeRetorikLocale", handleChangeRetorikLocale);
        };
    }, []);
    const handleChangeRetorikLocale = (event)=>{
        console.warn("changeRetorikLocale event is depreciated and will be removed soon. Please use setLocale function instead.");
        const newLocale = event.detail?.locale;
        if (newLocale && supportedLanguages?.includes(newLocale)) (0, $2e4dc8fa28d39601$export$c8aadf3621e41efb)(newLocale);
    };
    return /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eO7Kz))).Fragment, {});
};
var $d7666235a46cb40b$export$2e2bcd8739ae039 = $d7666235a46cb40b$var$LocaleChangeEventListener;




var $eO7Kz = parcelRequire("eO7Kz");
const $0a1ceddd13a58a1c$var$Radio = ({ className: className, title: title, handleChange: handleChange, checked: checked })=>{
    const [transition, setTransition] = (0, $eO7Kz.useState)(checked ? "rf-scale-1" : "rf-scale-0");
    const handleToggle = ()=>{
        setTransition(checked ? "rf-scale-0" : "rf-scale-1");
        handleChange(title);
    };
    return /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsxs)("div", {
        className: `rf-flex rf-flex-row rf-items-center rf-justify-between hover:rf-cursor-pointer ${className}`,
        children: [
            /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("div", {
                className: "rf-capitalize",
                children: title
            }),
            /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("button", {
                className: `rf-relative rf-w-7 large:rf-w-8 large-vertical:rf-w-14 rf-h-7 large:rf-h-8 large-vertical:rf-h-14 ${!checked && "rf-border rf-border-[#9FA2AA]"} rf-rounded-half`,
                style: {
                    background: checked ? "linear-gradient(to right, #1999B1, #0a4652)" : "#FFFFFF",
                    boxShadow: checked ? "-3px 3px 6px #00000029" : ""
                },
                onClick: handleToggle,
                "aria-label": title,
                children: /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("div", {
                    className: `rf-absolute rf-top-2 large-vertical:rf-top-4 rf-left-2 large-vertical:rf-left-4 rf-w-3 large:rf-w-4 large-vertical:rf-w-6 rf-h-3 large:rf-h-4 large-vertical:rf-h-6 rf-rounded-half rf-bg-[#F8F8F8] rf-transition-all ${transition}`
                })
            })
        ]
    });
};
var $0a1ceddd13a58a1c$export$2e2bcd8739ae039 = $0a1ceddd13a58a1c$var$Radio;



/* eslint-disable react/self-closing-comp */ 

var $eO7Kz = parcelRequire("eO7Kz");


var $eO7Kz = parcelRequire("eO7Kz");

const $f8d049bab9f68eda$export$4aebf65ed07cf17b = {
    rgb: "rgb(112, 112, 112)"
};
const $f8d049bab9f68eda$export$d80fe84b82195dbd = {
    ...(0, $674f1d59bae686ab$export$c0da64553318f2cb),
    companyName: "#000",
    loader: {
        animation: (0, $674f1d59bae686ab$export$c0da64553318f2cb).primary,
        background: "rgba(18,18,18,0.7)",
        text: "#FFF",
        toggle: {
            text: "#000",
            background: (0, $674f1d59bae686ab$export$c0da64553318f2cb).primary
        },
        button: {
            background: {
                default: "transparent",
                hover: "transparent"
            },
            border: {
                default: (0, $674f1d59bae686ab$export$c0da64553318f2cb).primary,
                hover: "#FFF"
            },
            text: {
                default: (0, $674f1d59bae686ab$export$c0da64553318f2cb).primary,
                hover: "#FFF"
            }
        }
    },
    card: {
        frame: {
            background: "#2B2B2B",
            border: "transparent",
            text: "#F7F3F6"
        },
        button: {
            background: {
                default: "transparent",
                hover: "transparent"
            },
            border: {
                default: (0, $674f1d59bae686ab$export$c0da64553318f2cb).primary,
                hover: "#FFF"
            },
            text: {
                default: (0, $674f1d59bae686ab$export$c0da64553318f2cb).primary,
                hover: "#FFF"
            }
        },
        discoverButton: {
            background: {
                default: "#eaebf0",
                hover: "transparent"
            },
            border: {
                default: "transparent",
                hover: "#FFF"
            },
            text: {
                default: "#575F6B",
                hover: "#FFF"
            }
        }
    },
    textMode: {
        panel: {
            background: "rgba(255, 255, 255, 0.9)",
            border: "transparent",
            conversationUser: "#101219",
            conversationBot: "#1999B1"
        }
    },
    vocalMode: {
        subtitles: {
            text: "#FFF",
            background: "#000"
        }
    },
    formInput: {
        text: {
            default: (0, $674f1d59bae686ab$export$c0da64553318f2cb).secondary,
            hover: "#FFF"
        },
        inputRadioCheckbox: {
            unchecked: {
                background: "#434141",
                border: "#818181"
            },
            checked: {
                background: (0, $674f1d59bae686ab$export$c0da64553318f2cb).primary,
                border: (0, $674f1d59bae686ab$export$c0da64553318f2cb).primary,
                item: "#000"
            }
        },
        inputButton: {
            background: {
                default: (0, $674f1d59bae686ab$export$c0da64553318f2cb).black,
                hover: (0, $674f1d59bae686ab$export$c0da64553318f2cb).primary
            },
            border: {
                default: (0, $674f1d59bae686ab$export$c0da64553318f2cb).primary,
                hover: "#FFF"
            },
            text: {
                default: "#FFF",
                hover: "#FFF"
            }
        },
        likert: {
            default: "transparent",
            hover: "#E8B712"
        }
    }
};
const $f8d049bab9f68eda$export$1196b7bf97f3d16c = {
    ...(0, $674f1d59bae686ab$export$c0da64553318f2cb),
    companyName: "#000",
    loader: {
        animation: (0, $674f1d59bae686ab$export$c0da64553318f2cb).primary,
        background: "rgba(18,18,18,0.7)",
        text: "#FFF",
        toggle: {
            text: "#000",
            background: (0, $674f1d59bae686ab$export$c0da64553318f2cb).primary
        },
        button: {
            background: {
                default: "transparent",
                hover: "transparent"
            },
            border: {
                default: (0, $674f1d59bae686ab$export$c0da64553318f2cb).primary,
                hover: "#FFF"
            },
            text: {
                default: (0, $674f1d59bae686ab$export$c0da64553318f2cb).primary,
                hover: "#FFF"
            }
        }
    },
    card: {
        frame: {
            background: "#2B2B2B",
            border: "transparent",
            text: "#F7F3F6"
        },
        button: {
            background: {
                default: "transparent",
                hover: "transparent"
            },
            border: {
                default: (0, $674f1d59bae686ab$export$c0da64553318f2cb).primary,
                hover: "#FFF"
            },
            text: {
                default: (0, $674f1d59bae686ab$export$c0da64553318f2cb).primary,
                hover: "#FFF"
            }
        },
        discoverButton: {
            background: {
                default: "#eaebf0",
                hover: "transparent"
            },
            border: {
                default: "transparent",
                hover: "#FFF"
            },
            text: {
                default: "#575F6B",
                hover: "#FFF"
            }
        }
    },
    textMode: {
        panel: {
            background: "rgba(255, 255, 255, 0.9)",
            border: "transparent",
            conversationUser: "#101219",
            conversationBot: "#1999B1"
        }
    },
    vocalMode: {
        subtitles: {
            text: "#FFF",
            background: "#000"
        }
    },
    formInput: {
        text: {
            default: (0, $674f1d59bae686ab$export$c0da64553318f2cb).secondary,
            hover: "#FFF"
        },
        inputRadioCheckbox: {
            unchecked: {
                background: "#434141",
                border: "#818181"
            },
            checked: {
                background: (0, $674f1d59bae686ab$export$c0da64553318f2cb).primary,
                border: (0, $674f1d59bae686ab$export$c0da64553318f2cb).primary,
                item: "#000"
            }
        },
        inputButton: {
            background: {
                default: (0, $674f1d59bae686ab$export$c0da64553318f2cb).black,
                hover: (0, $674f1d59bae686ab$export$c0da64553318f2cb).primary
            },
            border: {
                default: (0, $674f1d59bae686ab$export$c0da64553318f2cb).primary,
                hover: "#FFF"
            },
            text: {
                default: "#FFF",
                hover: "#FFF"
            }
        },
        likert: {
            default: "transparent",
            hover: "#E8B712"
        }
    }
};




const $8b59a4dbb18c269b$var$defaultConfiguration = {
    homeRoute: "home",
    views: {
        home: {
            background: {
                image: "",
                style: "image"
            }
        }
    }
};
const $8b59a4dbb18c269b$var$ViewContextDefaultValues = {
    configurations: $8b59a4dbb18c269b$var$defaultConfiguration,
    route: "home",
    currentDeviceType: (0, $16ad089b9ce6627d$export$ec1e04e4e5ef8233).mobile,
    currentHeight: 1080,
    currentWidth: 1920,
    themeColors: (0, $f8d049bab9f68eda$export$d80fe84b82195dbd),
    isTactile: false,
    isMobile: false,
    isMobileLandscape: false,
    displayControls: true,
    homeActivityKey: undefined,
    showHomeAttachments: undefined,
    mediumLandscape: false,
    setConfigurations: ()=>{},
    setRoute: ()=>{},
    setCurrentDeviceType: ()=>{},
    setCurrentHeight: ()=>{},
    setCurrentWidth: ()=>{},
    setDisplayControls: ()=>{},
    setHomeActivityKey: ()=>{},
    setShowHomeAttachments: ()=>{}
};
const $8b59a4dbb18c269b$export$c3ad42ebfc49b96d = /*#__PURE__*/ (0, $eO7Kz.createContext)($8b59a4dbb18c269b$var$ViewContextDefaultValues);
function $8b59a4dbb18c269b$export$3abe3478af3cb63b() {
    return (0, $eO7Kz.useContext)($8b59a4dbb18c269b$export$c3ad42ebfc49b96d);
}
function $8b59a4dbb18c269b$export$50e22524de02f5db({ viewsConfiguration: viewsConfiguration, themeColors: themeColors, children: children }) {
    const [configurations, setConfigurations] = (0, $eO7Kz.useState)(viewsConfiguration);
    const [route, setRoute] = (0, $eO7Kz.useState)(configurations.homeRoute || "home");
    const [currentDeviceType, setCurrentDeviceType] = (0, $eO7Kz.useState)((0, $16ad089b9ce6627d$export$ec1e04e4e5ef8233).mobile);
    const [currentHeight, setCurrentHeight] = (0, $eO7Kz.useState)(0);
    const [currentWidth, setCurrentWidth] = (0, $eO7Kz.useState)(0);
    const mediumLandscape = (0, $eO7Kz.useMemo)(()=>{
        return currentWidth < (0, $674f1d59bae686ab$export$91e4bf93df95a062);
    }, [
        currentWidth
    ]);
    const overlayOpacity = (0, $eO7Kz.useMemo)(()=>{
        return configurations.views[route]?.background?.overlayOpacity;
    }, [
        configurations
    ]);
    const [isTactile, setIsTactile] = (0, $eO7Kz.useState)(false);
    const isMobile = (0, $eO7Kz.useMemo)(()=>{
        return (0, $674f1d59bae686ab$export$78f16669b353a880).includes(currentDeviceType);
    }, [
        currentDeviceType
    ]);
    const isMobileLandscape = (0, $eO7Kz.useMemo)(()=>{
        if (currentDeviceType === (0, $16ad089b9ce6627d$export$ec1e04e4e5ef8233).mobile && currentHeight < currentWidth) return true;
        return false;
    }, [
        currentHeight,
        currentWidth,
        currentDeviceType
    ]);
    const [displayControls, setDisplayControls] = (0, $eO7Kz.useState)(true);
    const [homeActivityKey, setHomeActivityKey] = (0, $eO7Kz.useState)(undefined);
    const [showHomeAttachments, setShowHomeAttachments] = (0, $eO7Kz.useState)(undefined);
    const value = (0, $eO7Kz.useMemo)(()=>({
            configurations: configurations,
            route: route,
            currentDeviceType: currentDeviceType,
            currentHeight: currentHeight,
            currentWidth: currentWidth,
            overlayOpacity: overlayOpacity,
            themeColors: themeColors,
            isTactile: isTactile,
            isMobile: isMobile,
            isMobileLandscape: isMobileLandscape,
            displayControls: displayControls,
            homeActivityKey: homeActivityKey,
            showHomeAttachments: showHomeAttachments,
            mediumLandscape: mediumLandscape,
            setConfigurations: setConfigurations,
            setRoute: setRoute,
            setCurrentDeviceType: setCurrentDeviceType,
            setCurrentHeight: setCurrentHeight,
            setCurrentWidth: setCurrentWidth,
            setDisplayControls: setDisplayControls,
            setShowHomeAttachments: setShowHomeAttachments,
            setHomeActivityKey: setHomeActivityKey
        }), [
        configurations,
        route,
        currentDeviceType,
        currentHeight,
        currentWidth,
        overlayOpacity,
        themeColors,
        isTactile,
        isMobileLandscape,
        displayControls,
        homeActivityKey,
        showHomeAttachments,
        mediumLandscape,
        setConfigurations,
        setRoute,
        setCurrentDeviceType,
        setCurrentHeight,
        setCurrentWidth,
        setDisplayControls,
        setShowHomeAttachments,
        setHomeActivityKey
    ]);
    (0, $eO7Kz.useEffect)(()=>{
        setIsTactile("ontouchstart" in window || navigator.maxTouchPoints > 0);
    }, []);
    (0, $eO7Kz.useEffect)(()=>{
        setConfigurations(viewsConfiguration);
    }, [
        viewsConfiguration
    ]);
    return /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eO7Kz))).Fragment, {
        children: /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)($8b59a4dbb18c269b$export$c3ad42ebfc49b96d.Provider, {
            value: value,
            children: children
        })
    });
}





var $abbebf5de79f9da4$exports = {};
$abbebf5de79f9da4$exports = JSON.parse('{"fr-FR":{"menu":"menu","mode":"mode","parameters":"param\xe8tres","sound":"son","subtitle":"sous-titre","tutorial":"tutoriel","history":"historique","lang":"langues","singleLang":"langue","message":"Saisissez votre message","allowMicrophone":"Autorisez votre navigateur \xe0 utiliser votre micro pour continuer","back":"retour","backconversation":"retour \xe0 la conversation","close":"fermer","answer":" r\xe9pond \xe0 vos questions"},"en-US":{"menu":"menu","mode":"mode","parameters":"parameters","sound":"sound","subtitle":"subtitle","tutorial":"tutorial","history":"history","lang":"languages","singleLang":"language","message":"Enter your message","allowMicrophone":"Give your browser permission to use microphone to continue","back":"back","backconversation":"back to the conversation","close":"close","answer":" answers your questions"},"es-ES":{"menu":"menu","mode":"mode","parameters":"parameters","sound":"sound","subtitle":"subtitle","tutorial":"tutorial","history":"history","lang":"languages","singleLang":"language","message":"Enter your message","allowMicrophone":"Give your browser permission to use microphone to continue","back":"back","backconversation":"back to the conversation","close":"close","answer":" answers your questions"},"de-DE":{"menu":"menu","mode":"mode","parameters":"parameters","sound":"sound","subtitle":"subtitle","tutorial":"tutorial","history":"history","lang":"languages","singleLang":"language","message":"Enter your message","allowMicrophone":"Give your browser permission to use microphone to continue","back":"back","backconversation":"back to the conversation","close":"close","answer":" answers your questions"}}');



parcelRequire("eO7Kz");
const $afdfbac274da5706$var$CloseIcon = ({ className: className, color: color })=>{
    return /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        className: className || "rf-h-6 rf-w-6",
        fill: "none",
        viewBox: "0 0 24 24",
        stroke: color || "currentColor",
        strokeWidth: 2,
        children: /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("path", {
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M6 18L18 6M6 6l12 12"
        })
    });
};
var $afdfbac274da5706$export$2e2bcd8739ae039 = $afdfbac274da5706$var$CloseIcon;



parcelRequire("eO7Kz");
const $bed7757a8efcb599$var$DownloadIcon = ({ className: className, color: color })=>{
    return /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 30 30",
        className: className || "rf-h-6 rf-w-6",
        children: [
            /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("path", {
                d: "M20.75 14.38H16V.96c0-.53-.45-.96-1-.96s-1 .43-1 .96v13.42H9.25c-.19 0-.32.2-.22.36l5.75 9.52c.1.16.34.16.44 0l5.75-9.52c.09-.16-.03-.36-.22-.36z",
                fill: color || "currentColor"
            }),
            /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("path", {
                d: "M29 19.76V27c0 1.1-.86 2-1.93 2H2.93C1.86 29 1 28.1 1 27v-7.24",
                fill: "none",
                stroke: color || "currentColor"
            })
        ]
    });
};
var $bed7757a8efcb599$export$2e2bcd8739ae039 = $bed7757a8efcb599$var$DownloadIcon;



parcelRequire("eO7Kz");
const $416cf8987d72a3d6$var$FeatherCheckIcon = ({ className: className, color: color })=>{
    return /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "28.676",
        height: "20.419",
        viewBox: "0 0 28.676 20.419",
        className: className || "rf-w-4 rf-h-4",
        children: /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("path", {
            d: "M30.434,9l-16.8,16.8L6,18.163",
            transform: "translate(-3.879 -6.879)",
            fill: "none",
            stroke: color || "#fff",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: "3"
        })
    });
};
var $416cf8987d72a3d6$export$2e2bcd8739ae039 = $416cf8987d72a3d6$var$FeatherCheckIcon;



parcelRequire("eO7Kz");
const $8a6bb6dedf1de271$var$FeatherFilterIcon = ({ className: className, color: color })=>{
    return /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "14.333",
        height: "13",
        viewBox: "0 0 14.333 13",
        className: className || "rf-w-6 rf-h-6",
        children: /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("path", {
            d: "M16.333,4.5H3l5.333,6.307v4.36L11,16.5V10.807Z",
            transform: "translate(-2.5 -4)",
            fill: "none",
            stroke: color || "#000",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: "1"
        })
    });
};
var $8a6bb6dedf1de271$export$2e2bcd8739ae039 = $8a6bb6dedf1de271$var$FeatherFilterIcon;



parcelRequire("eO7Kz");
const $e46aea93ab3102c7$var$InfoWithCircleIcon = ({ className: className, color: color })=>{
    return /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("div", {
        className: className || "rf-h-6",
        children: /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 33 33",
            className: "rf-h-full",
            children: /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsxs)("g", {
                transform: "translate(-1.5 -1.5)",
                children: [
                    /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("path", {
                        d: "M33,18A15,15,0,1,1,18,3,15,15,0,0,1,33,18Z",
                        fill: "none",
                        stroke: color || "#00d7ff",
                        strokeLinecap: "round",
                        strokeLinejoin: "round",
                        strokeWidth: "3"
                    }),
                    /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("path", {
                        d: "M18,24V18",
                        fill: "none",
                        stroke: color || "#00d7ff",
                        strokeLinecap: "round",
                        strokeLinejoin: "round",
                        strokeWidth: "3"
                    }),
                    /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("path", {
                        d: "M18,12h0",
                        fill: "none",
                        stroke: color || "#00d7ff",
                        strokeLinecap: "round",
                        strokeLinejoin: "round",
                        strokeWidth: "3"
                    })
                ]
            })
        })
    });
};
var $e46aea93ab3102c7$export$2e2bcd8739ae039 = $e46aea93ab3102c7$var$InfoWithCircleIcon;



parcelRequire("eO7Kz");
const $68bbdda0cb461c72$var$SendMessageIcon = ({ className: className, color: color })=>{
    return /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        className: className || "rf-w-6",
        viewBox: "0 0 23.207 23.207",
        children: /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsxs)("g", {
            transform: "translate(0.5 0.707)",
            children: [
                /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("path", {
                    d: "M28.6,3,16.5,15.1",
                    transform: "translate(-6.6 -3)",
                    fill: "none",
                    stroke: color || "#1999b1",
                    strokeLinecap: "round",
                    strokeLinejoin: "round",
                    strokeWidth: "1"
                }),
                /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("path", {
                    d: "M25,3,17.3,25l-4.4-9.9L3,10.7Z",
                    transform: "translate(-3 -3)",
                    fill: "none",
                    stroke: color || "#1999b1",
                    strokeLinecap: "round",
                    strokeLinejoin: "round",
                    strokeWidth: "1"
                })
            ]
        })
    });
};
var $68bbdda0cb461c72$export$2e2bcd8739ae039 = $68bbdda0cb461c72$var$SendMessageIcon;



parcelRequire("eO7Kz");
const $b5ac7737de70de3d$var$ZoomOutIcon = ({ className: className, color: color })=>{
    return /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 37.91 37.91",
        className: className || "rf-h-6 rf-w-6",
        children: /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("path", {
            d: "M29.773,4.5l4.844,4.844-6.087,6.044,2.991,2.991,6.044-6.087,4.844,4.844V4.5ZM4.5,17.137l4.844-4.844,6.044,6.087,2.991-2.991L12.293,9.344,17.137,4.5H4.5ZM17.137,42.41l-4.844-4.844,6.087-6.044-2.991-2.991L9.344,34.617,4.5,29.773V42.41ZM42.41,29.773l-4.844,4.844-6.044-6.087-2.991,2.991,6.087,6.044L29.773,42.41H42.41Z",
            transform: "translate(-4.5 -4.5)",
            fill: color || "#00d7ff"
        })
    });
};
var $b5ac7737de70de3d$export$2e2bcd8739ae039 = $b5ac7737de70de3d$var$ZoomOutIcon;



parcelRequire("eO7Kz");
const $31dbbe0462359456$var$RetorikLogoIcon = ({ className: className, color: color })=>{
    return /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        x: "0px",
        y: "0px",
        viewBox: "0 0 325 135",
        className: className || "rf-h-6 rf-w-6",
        children: [
            /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("rect", {
                x: "0",
                y: "-6",
                width: "325",
                height: "143",
                fill: "transparent"
            }),
            /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsxs)("g", {
                children: [
                    /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("path", {
                        fill: color || "#FFF",
                        d: "M93.6,70.9V50.8c0-14.2-11.5-25.7-25.7-25.7h0c-14.2,0-25.7,11.5-25.7,25.7v20.1c0,14.2,11.5,25.7,25.7,25.7v0   h25.7l-13.3-3.2C88.2,89,93.6,80.6,93.6,70.9z M67.9,89.8C57.5,89.8,49,81.3,49,70.9V50.8c0-10.4,8.5-18.9,18.9-18.9   c10.4,0,18.9,8.5,18.9,18.9v20.1C86.8,81.3,78.3,89.8,67.9,89.8z"
                    }),
                    /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("g", {
                        children: /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("path", {
                            fill: color || "#FFF",
                            d: "M67.9,82.6c-2.3,0-4.5-0.9-6.1-2.5c-0.7-0.7-0.7-1.9,0-2.6c0.7-0.7,1.9-0.7,2.6,0c0.9,0.9,2.2,1.4,3.5,1.4    c1.3,0,2.6-0.5,3.5-1.4c0.7-0.7,1.9-0.7,2.6,0c0.7,0.7,0.7,1.9,0,2.6C72.4,81.7,70.2,82.6,67.9,82.6z"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsxs)("g", {
                children: [
                    /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("path", {
                        fill: color || "#FFF",
                        d: "M117.1,61.6V34.9h11.1c1.1,0,2.2,0.2,3.1,0.7c1,0.5,1.8,1.1,2.5,1.9c0.7,0.8,1.2,1.7,1.6,2.7   c0.4,1,0.6,2,0.6,3c0,1-0.2,1.9-0.5,2.8c-0.3,0.9-0.7,1.7-1.3,2.5c-0.6,0.7-1.2,1.3-2,1.8c-0.8,0.5-1.6,0.8-2.6,0.9l6.7,10.4h-2.2   l-6.5-10.1H119v10.1H117.1z M119,49.7h9.4c0.9,0,1.6-0.2,2.3-0.6c0.7-0.4,1.3-0.9,1.8-1.5c0.5-0.6,0.9-1.3,1.1-2.1   c0.3-0.8,0.4-1.6,0.4-2.4c0-0.9-0.2-1.7-0.5-2.5c-0.3-0.8-0.7-1.5-1.3-2.1c-0.5-0.6-1.2-1.1-1.9-1.4c-0.7-0.4-1.5-0.5-2.3-0.5H119   V49.7z"
                    }),
                    /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("path", {
                        fill: color || "#FFF",
                        d: "M161.6,59.9v1.7h-17.8V34.9h17.5v1.7h-15.5v10.5h13.6v1.7h-13.6v11.1H161.6z"
                    }),
                    /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("path", {
                        fill: color || "#FFF",
                        d: "M187.8,36.6H178v25h-1.9v-25h-9.8v-1.7h21.5V36.6z"
                    }),
                    /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("path", {
                        fill: color || "#FFF",
                        d: "M203.7,61.8c-1.9,0-3.5-0.4-5.1-1.2c-1.5-0.8-2.8-1.8-4-3c-1.1-1.3-2-2.7-2.6-4.3c-0.6-1.6-0.9-3.3-0.9-5   c0-1.8,0.3-3.5,1-5.1c0.6-1.6,1.5-3.1,2.6-4.3c1.1-1.3,2.4-2.3,4-3c1.5-0.7,3.2-1.1,5-1.1c1.9,0,3.6,0.4,5.1,1.2   c1.5,0.8,2.9,1.8,4,3.1c1.1,1.3,1.9,2.7,2.5,4.3s0.9,3.3,0.9,4.9c0,1.8-0.3,3.5-1,5.2c-0.6,1.6-1.5,3.1-2.6,4.3   c-1.1,1.2-2.4,2.2-4,3C207.1,61.4,205.5,61.8,203.7,61.8z M193.1,48.2c0,1.5,0.3,3,0.8,4.4c0.5,1.4,1.2,2.7,2.2,3.8   c0.9,1.1,2.1,2,3.4,2.6c1.3,0.7,2.7,1,4.3,1c1.6,0,3.1-0.3,4.3-1c1.3-0.7,2.4-1.6,3.3-2.7c0.9-1.1,1.6-2.4,2.1-3.8   c0.5-1.4,0.8-2.8,0.8-4.3c0-1.5-0.3-3-0.8-4.4c-0.5-1.4-1.3-2.7-2.2-3.8c-0.9-1.1-2-2-3.3-2.6c-1.3-0.7-2.7-1-4.2-1   c-1.6,0-3.1,0.3-4.4,1S197,39,196,40.2c-0.9,1.1-1.6,2.4-2.1,3.8C193.4,45.4,193.1,46.8,193.1,48.2z",
                        id: "path19"
                    }),
                    /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("path", {
                        fill: color || "#FFF",
                        d: "M223.7,61.6V34.9h11.1c1.1,0,2.2,0.2,3.1,0.7c1,0.5,1.8,1.1,2.5,1.9c0.7,0.8,1.2,1.7,1.6,2.7   c0.4,1,0.6,2,0.6,3c0,1-0.2,1.9-0.5,2.8c-0.3,0.9-0.7,1.7-1.3,2.5c-0.6,0.7-1.2,1.3-2,1.8c-0.8,0.5-1.6,0.8-2.6,0.9l6.7,10.4h-2.2   l-6.5-10.1h-8.7v10.1H223.7z M225.6,49.7h9.4c0.9,0,1.6-0.2,2.3-0.6c0.7-0.4,1.3-0.9,1.8-1.5c0.5-0.6,0.9-1.3,1.1-2.1   c0.3-0.8,0.4-1.6,0.4-2.4c0-0.9-0.2-1.7-0.5-2.5c-0.3-0.8-0.7-1.5-1.3-2.1c-0.5-0.6-1.2-1.1-1.9-1.4c-0.7-0.4-1.5-0.5-2.3-0.5h-9.1   V49.7z"
                    }),
                    /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("path", {
                        fill: color || "#FFF",
                        d: "M250.5,61.6V34.9h1.9v26.7H250.5z"
                    }),
                    /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("path", {
                        fill: color || "#FFF",
                        d: "M261.7,61.6V34.9h1.9v16.2l15.6-16.2h2.2l-11.1,11.7l11.7,15h-2.2l-10.7-13.8l-5.5,5.6v8.2H261.7z"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsxs)("g", {
                children: [
                    /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("g", {
                        children: /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsxs)("g", {
                            children: [
                                /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("g", {
                                    children: /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("path", {
                                        fill: color || "#FFF",
                                        d: "M122.9,96.1c-1,0-1.9-0.3-2.7-0.8c-0.8-0.5-1.5-1.2-2-2v2.5h-1.1V78.4h1.2v7.7c0.6-0.9,1.3-1.6,2.1-2.1      c0.8-0.5,1.7-0.8,2.8-0.8c0.9,0,1.7,0.2,2.4,0.6c0.7,0.4,1.3,0.9,1.8,1.5c0.5,0.6,0.9,1.3,1.1,2.1c0.3,0.8,0.4,1.6,0.4,2.4      c0,0.9-0.2,1.7-0.5,2.4s-0.7,1.4-1.3,2c-0.5,0.6-1.2,1-1.9,1.4C124.5,95.9,123.7,96.1,122.9,96.1z M122.6,95      c0.7,0,1.4-0.2,2-0.5c0.6-0.3,1.1-0.7,1.6-1.2c0.4-0.5,0.8-1.1,1-1.7c0.2-0.6,0.4-1.3,0.4-2c0-0.7-0.1-1.4-0.3-2      c-0.2-0.6-0.6-1.2-1-1.7c-0.4-0.5-0.9-0.9-1.5-1.2c-0.6-0.3-1.2-0.5-1.9-0.5c-0.5,0-1,0.1-1.5,0.3c-0.5,0.2-0.9,0.4-1.3,0.7      c-0.4,0.3-0.7,0.7-1.1,1.1c-0.3,0.4-0.6,0.8-0.8,1.2v4.1c0,0.5,0.2,0.9,0.5,1.3c0.3,0.4,0.7,0.8,1.1,1.1      c0.4,0.3,0.9,0.5,1.4,0.7C121.7,95,122.2,95,122.6,95z"
                                    })
                                }),
                                /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("g", {
                                    children: /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("path", {
                                        fill: color || "#FFF",
                                        d: "M133.3,100.1c0.1,0,0.2,0,0.4,0c0.2,0,0.3,0,0.4,0c0.1,0,0.3-0.1,0.4-0.1c0.1,0,0.2-0.1,0.3-0.2      c0.1-0.1,0.2-0.3,0.3-0.5c0.1-0.3,0.3-0.7,0.5-1.2c0.2-0.5,0.5-1.2,0.9-2.1L131,83.5h1.2l4.9,11.3l4.6-11.3h1.2l-6.8,16.3      c-0.2,0.4-0.5,0.8-0.8,1c-0.4,0.2-0.9,0.4-1.6,0.4c-0.1,0-0.1,0-0.2,0c-0.1,0-0.1,0-0.2,0V100.1z"
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("g", {
                        children: /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("path", {
                            fill: color || "#FFF",
                            d: "M213.9,95.9l0.4-0.3c1.4-1.2,2.1-2.7,2.1-4.6l0-8h-2.5V95.9z"
                        })
                    }),
                    /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("g", {
                        children: /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("polygon", {
                            fill: color || "#FFF",
                            points: "202.9,93.3 196.9,83 193.9,83 201.4,95.9 201.4,95.9 204.4,95.9 204.4,95.9 212,83 208.9,83   "
                        })
                    }),
                    /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("g", {
                        children: /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("path", {
                            fill: color || "#FFF",
                            d: "M174.1,87.5v3.9c0,2.5,2,4.5,4.5,4.5h8.9c0.7,0,1.4-0.2,2-0.5v0.4h2.5V83l-13.4,0    C176.1,83,174.1,85,174.1,87.5z M189.4,85.5v5.7c-0.1,1.2-1,2.1-2.2,2.1h-8.6c-1.2,0-2.2-1-2.2-2.3v-3.4c0-1.2,1-2.2,2.2-2.2    H189.4z"
                        })
                    }),
                    /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("g", {
                        children: /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("path", {
                            fill: color || "#FFF",
                            d: "M171.3,75.2l-2.5-0.8v9.1c-0.6-0.3-1.3-0.5-2-0.5H158c-2.5,0-4.5,2-4.5,4.5v3.9c0,2.5,2,4.5,4.5,4.5l13.2,0    h1.4h0.3c-1-1.2-1.6-2.8-1.6-4.5L171.3,75.2z M168.8,93.4h-10.7c-1.2,0-2.2-1-2.2-2.2v-3.4c0-1.2,1-2.2,2.2-2.2h8.5    c1.1,0,2.1,0.9,2.1,2.1V93.4z"
                        })
                    }),
                    /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("g", {
                        children: /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("path", {
                            fill: color || "#FFF",
                            d: "M215.1,80.6c0.3,0,0.6-0.1,0.9-0.4c0.3-0.2,0.4-0.5,0.4-0.9c0-0.3-0.1-0.6-0.4-0.9c-0.3-0.3-0.6-0.4-0.9-0.4    c-0.4,0-0.7,0.1-0.9,0.4c-0.2,0.2-0.4,0.5-0.4,0.9c0,0.4,0.1,0.7,0.4,0.9C214.5,80.5,214.8,80.6,215.1,80.6z"
                        })
                    })
                ]
            })
        ]
    });
};
var $31dbbe0462359456$export$2e2bcd8739ae039 = $31dbbe0462359456$var$RetorikLogoIcon;




const { useSendMessage: $cc51107c7c4d0305$var$useSendMessage } = (0, $497baa802110a7bc$exports.hooks);
const $cc51107c7c4d0305$var$SendTextBox = ({ className: className, withButton: withButton })=>{
    const locale = (0, $2e4dc8fa28d39601$export$6650dace022cfacc)((state)=>state.locale);
    const { setSendBoxRef: setSendBoxRef, canFocusSendBox: canFocusSendBox } = (0, $e599569c1fc3ca2c$export$d8760bee47331b1d)();
    const { themeColors: themeColors, isMobile: isMobile } = (0, $8b59a4dbb18c269b$export$3abe3478af3cb63b)();
    const sendMessage = $cc51107c7c4d0305$var$useSendMessage();
    const [height, setHeight] = (0, $eO7Kz.useState)();
    const [message, setMessage] = (0, $eO7Kz.useState)("");
    const textareaRef = (0, $eO7Kz.useRef)(null);
    (0, $eO7Kz.useEffect)(()=>{
        if (canFocusSendBox && textareaRef.current) document.activeElement !== textareaRef.current && textareaRef.current.focus();
    }, [
        textareaRef,
        canFocusSendBox
    ]);
    (0, $eO7Kz.useEffect)(()=>{
        textareaRef.current && setSendBoxRef(textareaRef.current);
    }, [
        textareaRef
    ]);
    const handleChange = (e)=>{
        setMessage(e.currentTarget.value);
        textareaRef?.current && setHeight(`${textareaRef.current.scrollHeight}px`);
    };
    const handleKeyDown = (e)=>{
        if (e.key === "Enter" || e.key === "NumpadEnter") {
            e.preventDefault();
            e.stopPropagation();
            handleSend();
        }
    };
    const handleSend = ()=>{
        if (message.length > 0) {
            sendMessage(message, "speech");
            setMessage("");
            setHeight(undefined);
        }
    };
    return /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsxs)("div", {
        className: `rf-relative rf-min-h-12 rf-px-4 rf-text-base rf-pt-3 rf-pb-3 rf-flex rf-items-center rf-border rf-border-menuBorder rf-rounded-lg rf-bg-truewhite rf-shadow-[inset_0_0_6px_#0000003B] ${className}`,
        children: [
            /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("textarea", {
                ref: textareaRef,
                className: `rf-input-hidden rf-outline-none ${withButton ? "rf-w-[calc(100%-3rem)]" : "rf-w-full"} rf-resize-none rf-scrollbar-hidden ${isMobile && "placeholder:rf-text-black placeholder:rf-opacity-100"}`,
                value: message,
                placeholder: (0, (/*@__PURE__*/$parcel$interopDefault($abbebf5de79f9da4$exports)))[locale]?.message || (0, (/*@__PURE__*/$parcel$interopDefault($abbebf5de79f9da4$exports)))["fr-FR"].message,
                onKeyDown: (e)=>handleKeyDown(e),
                onChange: (e)=>handleChange(e),
                style: {
                    height: height || "1.5rem"
                }
            }),
            withButton && /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("button", {
                className: "rf-absolute rf-right-4 rf-h-5 rf-w-5",
                onClick: handleSend,
                children: /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $68bbdda0cb461c72$export$2e2bcd8739ae039), {
                    className: "rf-w-5",
                    color: themeColors.secondary
                })
            })
        ]
    });
};
var $cc51107c7c4d0305$export$2e2bcd8739ae039 = $cc51107c7c4d0305$var$SendTextBox;




var $eO7Kz = parcelRequire("eO7Kz");


const $c0e24d884a46844c$var$Subtitle = ()=>{
    const { displaySubtitles: displaySubtitles } = (0, $e599569c1fc3ca2c$export$d8760bee47331b1d)();
    const { speechAllowed: speechAllowed, boundaryData: boundaryData, speaking: speaking } = (0, $633c6ef6f1f791c0$export$57e792e009c800a0)();
    const [sentenceToDisplay, setSentenceToDisplay] = (0, $eO7Kz.useState)("");
    const timer = (0, $eO7Kz.useRef)(null);
    const [index, setIndex] = (0, $eO7Kz.useState)(-1);
    // Generate an array of sentences from boundaryData
    const sentences = (0, $eO7Kz.useMemo)(()=>{
        // If no boundary data is available, return an empty array
        if (!boundaryData || boundaryData.length === 0) {
            setSentenceToDisplay("");
            return [];
        }
        // Prepare an array to store sentences and their durations
        const sentencesArray = [];
        let currentSentence = "";
        let currentStartTime = boundaryData[0]?.startTime || 0;
        // Loop over each boundary data item
        for(let i = 0; i < boundaryData.length; i++){
            const boundary = boundaryData[i];
            // Prepare a string based on the word at the boundary
            let boundaryString = "";
            if ([
                ".",
                ",",
                "..."
            ].includes(boundary.word)) boundaryString = boundary.word;
            else if ([
                ":",
                ";",
                "!",
                "?"
            ].includes(boundary.word)) boundaryString = "\xa0" + boundary.word;
            else boundaryString = i === 0 ? boundary.word : " " + boundary.word;
            // Construct a new sentence
            const newSentence = currentSentence + boundaryString;
            // If it's the last boundary of the current array or the end of the boundaries (type 'EndBoundary')
            if (i === boundaryData.length - 1 || boundary.boundaryType === "EndBoundary") {
                // Calculate the sentence duration
                let sentenceDuration = 0;
                if (boundary.boundaryType === "EndBoundary") {
                    const previousBoundary = i === 0 ? boundary : boundaryData[i - 1];
                    const end = previousBoundary.endTime;
                    sentenceDuration = (end - currentStartTime) / 10000;
                } else sentenceDuration = (boundary.endTime - currentStartTime) / 10000;
                // If there is a sentence to push, add it to the array
                if (newSentence.trim() !== "") sentencesArray.push({
                    sentence: newSentence,
                    duration: sentenceDuration
                });
            } else if (newSentence.length > 50) {
                // If the current word is a punctuation, add it even if it goes beyond 50 characters
                if (boundary.boundaryType === "PunctuationBoundary") {
                    // Calculate the sentence duration
                    const sentenceDuration = (boundary.endTime - currentStartTime) / 10000;
                    if (newSentence.trim() !== "") sentencesArray.push({
                        sentence: newSentence,
                        duration: sentenceDuration
                    });
                    currentStartTime = i === boundaryData.length - 1 ? boundary.startTime : boundaryData[i + 1].startTime;
                    currentSentence = "";
                } else {
                    // Endtime is the one from the previous boundary, or the current one if there isn't
                    const previousBoundary = i === 0 ? boundary : boundaryData[i - 1];
                    const sentenceDuration = (previousBoundary.endTime - currentStartTime) / 10000;
                    if (newSentence.trim() !== "") sentencesArray.push({
                        sentence: currentSentence,
                        duration: sentenceDuration
                    });
                    currentStartTime = boundary.startTime;
                    currentSentence = boundary.word;
                }
            } else // Continue the current sentence
            currentSentence = newSentence;
        }
        // Return the array of sentences and their durations
        return sentencesArray;
    }, [
        boundaryData
    ]);
    (0, $eO7Kz.useEffect)(()=>{
        setIndex(speaking ? 0 : -1);
    }, [
        speaking
    ]);
    (0, $eO7Kz.useEffect)(()=>{
        if (index !== -1) {
            // Set the current sentence
            const sentence = sentences[index];
            setSentenceToDisplay(sentence?.sentence || "");
            // Set a new timer to update the index after the sentence's duration
            timer.current = setTimeout(()=>{
                setIndex((i)=>i + 1);
            }, sentence?.duration || 1000);
        } else {
            if (timer.current) clearTimeout(timer.current);
            setSentenceToDisplay("");
        }
    }, [
        index
    ]);
    return sentenceToDisplay && speechAllowed && displaySubtitles ? /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("div", {
        className: "rf-relative rf-col-start-1 vertical:rf-col-span-full rf-col-span-6 rf-row-start-9 rf-row-span-full vertical:rf-row-start-11 vertical:rf-row-span-1 rf-justify-self-center rf-self-center rf-overflow-y-auto rf-scrollbar-thin rf-w-1/2 vertical:rf-w-5/6 rf-max-h-full rf-py-1 large:rf-py-4",
        children: /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("div", {
            className: "rf-relative rf-max-h-full rf-bg-vocalModeSubtitlesBackground rf-text-vocalModeSubtitlesText rf-justify-self-center rf-self-center rf-p-2 large:rf-p-4 rf-text-size-auto rf-text-center",
            id: "retorik-subtitles",
            children: sentenceToDisplay
        })
    }) : null;
};
var $c0e24d884a46844c$export$2e2bcd8739ae039 = $c0e24d884a46844c$var$Subtitle;




var $eO7Kz = parcelRequire("eO7Kz");


const $e942a9e6425a3ae1$var$Toggle = ({ className: className, title: title, handleChange: handleChange, defaultChecked: defaultChecked, lockInTextMode: lockInTextMode })=>{
    const { mode: mode } = (0, $e599569c1fc3ca2c$export$d8760bee47331b1d)();
    const [on, setOn] = (0, $eO7Kz.useState)(!!defaultChecked);
    const [transition, setTransition] = (0, $eO7Kz.useState)(on ? "rf-right-1" : "rf-left-1");
    (0, $eO7Kz.useEffect)(()=>{
        setOn(!!defaultChecked);
        setTransition(defaultChecked ? "rf-right-1" : "rf-left-1");
    }, [
        defaultChecked
    ]);
    const handleToggle = ()=>{
        if (!(lockInTextMode && mode === (0, $16ad089b9ce6627d$export$9484bbecc3c49a2e).text)) {
            setTransition(on ? "rf-translate-x-1" : "rf-translate-x-5");
            handleChange(!on);
            setOn(!on);
        }
    };
    return /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsxs)("div", {
        className: `rf-flex rf-flex-row large:rf-flex-col rf-items-center rf-justify-between large:rf-justify-start large:rf-gap-1 hover:rf-cursor-pointer ${className}`,
        children: [
            /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("div", {
                className: "rf-capitalize large:rf-uppercase",
                children: title
            }),
            /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("button", {
                className: "rf-relative rf-w-12 rf-min-w-12 rf-h-6 rf-rounded-6",
                style: {
                    background: "linear-gradient(to left, #E5E6EC, #F2F3F6)",
                    boxShadow: "inset 3px 3px 6px #00000029"
                },
                onClick: handleToggle,
                "aria-label": title,
                children: /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("div", {
                    className: `rf-absolute rf-top-1 rf-w-4 rf-h-4 rf-rounded-half ${on ? "rf-bg-secondary" : "rf-bg-[#F8F8F8]"} rf-transition-all ${transition}`,
                    style: {
                        boxShadow: on ? "-3px -3px 3px #00000029" : "3px 3px 3px #00000029"
                    }
                })
            })
        ]
    });
};
var $e942a9e6425a3ae1$export$2e2bcd8739ae039 = $e942a9e6425a3ae1$var$Toggle;




var $eO7Kz = parcelRequire("eO7Kz");
const $a6958f8775cfa233$var$ToggleWithTexts = ({ texts: texts, colors: colors, handleChange: handleChange, defaultChecked: defaultChecked })=>{
    const [left, setLeft] = (0, $eO7Kz.useState)(!defaultChecked || defaultChecked === texts.leftId);
    /**
   * On call :
   *  - call parent method with either leftId or rightId depending on the leftSide parameter
   *  - set left state
   * @param leftSide : boolean
   */ const handleToggle = (leftSide)=>{
        handleChange(leftSide ? texts.leftId : texts.rightId);
        setLeft(leftSide);
    };
    return /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsxs)("div", {
        className: "rf-w-full rf-flex rf-flex-row rf-justify-between rf-text-size-auto rf-rounded-8 rf-cursor-pointer rf-select-none rf-shadow-[inset_0_12px_12px_-12px_#00000029,inset_0_-12px_12px_-12px_#00000029]",
        style: {
            background: "linear-gradient(to left, #CBCBCB 0%, #9A9797 50%, #4E4C4C 100%)",
            color: colors.text
        },
        children: [
            /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("div", {
                className: `rf-px-4 rf-py-2 rf-uppercase rf-font-bold rf-border rf-rounded-8 ${left && "rf-shadow-[0_0_3px_6px_#00000029]"} `,
                style: {
                    background: left ? colors.background : "transparent",
                    borderColor: left ? colors.background : "transparent"
                },
                onClick: ()=>handleToggle(true),
                children: texts.left
            }),
            /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("div", {
                className: `rf-px-4 rf-py-2 rf-uppercase rf-font-bold rf-border rf-rounded-8 ${!left && "rf-shadow-[0_0_3px_6px_#00000029]"}`,
                style: {
                    background: left ? "transparent" : colors.background,
                    borderColor: left ? "transparent" : colors.background
                },
                onClick: ()=>handleToggle(false),
                children: texts.right
            })
        ]
    });
};
var $a6958f8775cfa233$export$2e2bcd8739ae039 = $a6958f8775cfa233$var$ToggleWithTexts;




var $eO7Kz = parcelRequire("eO7Kz");
const $ea490a709941d5e3$var$Wheeler = ({ className: className, handleWheel: handleWheel, paramInHandle: paramInHandle, handleBoth: handleBoth, xAxisOnly: xAxisOnly, children: children })=>{
    const ref = (0, $eO7Kz.useRef)(null);
    /**
   * On mouse wheel :
   *  - check if the event has to be taken in account
   *  - if  yes, retrieve the wanted data
   *  - prevent event default
   *  - stop event propagation
   *  - call parent function with delta value and paramInHandle from props if defined
   * @param e : WheelEvent
   */ const internalHandleWheel = (e)=>{
        if (xAxisOnly && e.deltaY) return;
        const delta = handleBoth ? {
            x: e.deltaX,
            y: e.deltaY
        } : xAxisOnly ? e.deltaX : e.deltaY;
        e.preventDefault();
        e.stopImmediatePropagation();
        paramInHandle ? handleWheel(delta, paramInHandle) : handleWheel(delta);
    };
    /**
   * On ref change :
   *  - add wheel event listener, with passive = false to allow preventDefault in processing
   * On component unmount :
   *  - unbind wheel event listener
   */ (0, $eO7Kz.useEffect)(()=>{
        if (ref.current) ref.current.addEventListener("wheel", (e)=>internalHandleWheel(e), {
            passive: false
        });
        return ()=>{
            ref.current && ref.current.removeEventListener("wheel", (e)=>internalHandleWheel(e));
        };
    }, [
        ref.current
    ]);
    return /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("div", {
        className: className,
        ref: ref,
        children: children
    });
};
var $ea490a709941d5e3$export$2e2bcd8739ae039 = $ea490a709941d5e3$var$Wheeler;




const $b185857b63ab2eea$var$NewsAttachment = ({ title: title, subtitle: subtitle, text: text, media: media, height: height })=>{
    const medias = [];
    media && media.forEach((med)=>{
        medias.push({
            url: med.url,
            alt: med.profile || "media"
        });
    });
    return /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsxs)("div", {
        className: "rf-w-full rf-p-4 rf-flex rf-flex-col rf-gap-4 rf-rounded rf-bg-cardFrameBackground rf-text-cardFrameText rf-touch-none",
        style: {
            height: height
        },
        children: [
            /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("div", {
                className: "rf-w-fit rf-px-2 rf-py-1 large:rf-py-2 rf-small-size-auto rf-uppercase rf-border rf-border-black rf-bg-black rf-text-primary",
                children: title
            }),
            /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("div", {
                className: "rf-title-size-auto",
                children: subtitle
            }),
            /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsxs)("div", {
                className: "rf-w-full rf-flex rf-flex-row rf-items-start rf-gap-3",
                children: [
                    medias.length > 0 && /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("div", {
                        className: "rf-w-[45%] rf-min-w-[45%] rf-max-w-[45%] rf-flex rf-justify-center rf-aspect-square large:rf-aspect-video",
                        children: /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $fff38b5425abcfb1$export$2e2bcd8739ae039), {
                            className: "rf-max-h-full rf-max-w-full rf-h-fit rf-w-fit",
                            medias: medias
                        })
                    }),
                    /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("div", {
                        className: "rf-line-clamp-7",
                        children: text
                    })
                ]
            })
        ]
    });
};
var $b185857b63ab2eea$export$2e2bcd8739ae039 = $b185857b63ab2eea$var$NewsAttachment;




var $eO7Kz = parcelRequire("eO7Kz");

var $fD7D4 = parcelRequire("fD7D4");

parcelRequire("eO7Kz");
const $3b4b4959ec363ff6$var$CommentsPennantIcon = ({ className: className, color: color })=>{
    return /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 72.258 45",
        className: className || "w-6",
        children: /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsxs)("g", {
            transform: "translate(-2203.071 -428.34)",
            children: [
                /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("path", {
                    d: "M11.129,3l2.512,5.089,5.617.821-4.064,3.959.959,5.593-5.024-2.642L6.105,18.461l.959-5.593L3,8.91l5.617-.821Z",
                    transform: "translate(2201.071 426.34)",
                    fill: "none",
                    stroke: color || "#ffffff",
                    strokeLinecap: "round",
                    strokeLinejoin: "round",
                    strokeWidth: "2"
                }),
                /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("path", {
                    d: "M11.129,3l2.512,5.089,5.617.821-4.064,3.959.959,5.593-5.024-2.642L6.105,18.461l.959-5.593L3,8.91l5.617-.821Z",
                    transform: "translate(2255.071 426.34)",
                    fill: "none",
                    stroke: color || "#ffffff",
                    strokeLinecap: "round",
                    strokeLinejoin: "round",
                    strokeWidth: "2"
                }),
                /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("path", {
                    d: "M28,11.225A5.775,5.775,0,1,1,22.225,17,5.774,5.774,0,0,1,28,11.225m0,24.75c8.167,0,16.775,4.015,16.775,5.775v3.025H11.225V41.75c0-1.76,8.608-5.775,16.775-5.775M28,6A11,11,0,1,0,39,17,11,11,0,0,0,28,6Zm0,24.75c-7.342,0-22,3.685-22,11V50H50V41.75C50,34.435,35.343,30.75,28,30.75Z",
                    transform: "translate(2211 423.34)",
                    fill: color || "#ffffff"
                })
            ]
        })
    });
};
var $3b4b4959ec363ff6$export$2e2bcd8739ae039 = $3b4b4959ec363ff6$var$CommentsPennantIcon;



parcelRequire("eO7Kz");
const $8dac97be2cee3a05$var$FavoriteIcon = ({ className: className })=>{
    return /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("div", {
        className: className || "",
        children: /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsxs)("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 72 72",
            className: "rf-h-full",
            children: [
                /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("path", {
                    d: "M413.444,281.927a24.4,24.4,0,1,0,24.4,24.4A24.4,24.4,0,0,0,413.444,281.927Zm12.233,30.989a51.118,51.118,0,0,1-9.936,9.6l-2.3,1.654-2.3-1.654a51.118,51.118,0,0,1-9.936-9.6,17.7,17.7,0,0,1-3.462-9.826,10.357,10.357,0,0,1,10.227-10.321h.095a10.267,10.267,0,0,1,5.373,1.514,10.271,10.271,0,0,1,5.373-1.514h.095a10.357,10.357,0,0,1,10.226,10.321A17.7,17.7,0,0,1,425.677,312.916Z",
                    transform: "translate(-380.234 -271.942)",
                    fill: "#0c89a2"
                }),
                /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("path", {
                    d: "M428.741,308.235h-.057a6.436,6.436,0,0,0-5.373,2.941,6.435,6.435,0,0,0-5.373-2.941h-.057a6.394,6.394,0,0,0-6.335,6.391,13.766,13.766,0,0,0,2.7,7.505,47.374,47.374,0,0,0,9.06,8.727,47.369,47.369,0,0,0,9.061-8.727,13.765,13.765,0,0,0,2.7-7.505A6.394,6.394,0,0,0,428.741,308.235Z",
                    transform: "translate(-390.101 -283.478)",
                    fill: "#cb0038"
                }),
                /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsxs)("g", {
                    children: [
                        /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("path", {
                            d: "M379.123,306.092l.984-.568a3.667,3.667,0,1,1-4.851-1.228l.554,1a2.435,2.435,0,0,0-1.228,1.529,2.533,2.533,0,0,0,4.873,1.339A2.519,2.519,0,0,0,379.123,306.092Z",
                            transform: "translate(-373.354 -281.75)",
                            fill: "#161615"
                        }),
                        /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("path", {
                            d: "M383.877,292.134a3.579,3.579,0,1,1-4.955,1.283A3.524,3.524,0,0,1,383.877,292.134Zm-.614,1.07a2.35,2.35,0,1,0,1.007,3.281A2.36,2.36,0,0,0,383.263,293.2Z",
                            transform: "translate(-375.577 -276.186)",
                            fill: "#161615"
                        }),
                        /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("path", {
                            d: "M388.494,279.91l.851-.864,3.212,3.162a2.729,2.729,0,0,1-3.83,3.889l-3.211-3.163.85-.864,3.1,3.056a1.525,1.525,0,1,0,2.127-2.161Z",
                            transform: "translate(-378.687 -270.679)",
                            fill: "#161615"
                        }),
                        /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("path", {
                            d: "M396.125,274.77l2.02-1.306a2.265,2.265,0,1,1,2.457,3.8l-1,.647,1.382,2.138-1.018.658Zm4.181-.008a1.092,1.092,0,0,0-1.664-.248l-.874.564,1.206,1.867.874-.565A1.092,1.092,0,0,0,400.306,274.762Z",
                            transform: "translate(-383.338 -268.046)",
                            fill: "#161615"
                        }),
                        /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("path", {
                            d: "M418.982,268.841a3.387,3.387,0,0,1-2.494,4.305l-2.211.575-1.782-6.847,2.211-.576A3.387,3.387,0,0,1,418.982,268.841Zm-1.194.311a2.247,2.247,0,0,0-2.772-1.743l-1.056.275,1.2,4.617,1.057-.275A2.254,2.254,0,0,0,417.788,269.151Z",
                            transform: "translate(-390.516 -265.032)",
                            fill: "#161615"
                        }),
                        /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("path", {
                            d: "M427.818,267.132l2.828-.109.044,1.151-2.827.11.073,1.9,3.132-.122.044,1.151-4.343.17-.275-7.07,4.282-.167.045,1.151-3.07.12Z",
                            transform: "translate(-396.655 -264.145)",
                            fill: "#161615"
                        }),
                        /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("path", {
                            d: "M446.9,272.151l.56.988a3.666,3.666,0,1,1,1.268-4.839l-1.006.544a2.431,2.431,0,0,0-1.518-1.239,2.532,2.532,0,0,0-1.38,4.86A2.519,2.519,0,0,0,446.9,272.151Z",
                            transform: "translate(-403.416 -265.121)",
                            fill: "#161615"
                        }),
                        /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("path", {
                            d: "M460.445,277.009a3.579,3.579,0,1,1-1.242-4.964A3.523,3.523,0,0,1,460.445,277.009Zm-1.064-.622a2.35,2.35,0,1,0-3.289.98A2.361,2.361,0,0,0,459.381,276.386Z",
                            transform: "translate(-408.594 -267.384)",
                            fill: "#161615"
                        }),
                        /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("path", {
                            d: "M467.155,281.565l2.048,1.953-.8.834L466.36,282.4l-1.311,1.375,2.268,2.162-.8.834-3.145-3,4.882-5.12,3.1,2.957-.8.834-2.224-2.12Z",
                            transform: "translate(-412.827 -270.506)",
                            fill: "#161615"
                        }),
                        /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("path", {
                            d: "M478.916,290.648l.678,1.006-3.737,2.52a2.729,2.729,0,0,1-3.052-4.525l3.738-2.521.678,1.006-3.612,2.435a1.525,1.525,0,1,0,1.7,2.514Z",
                            transform: "translate(-416.422 -274.223)",
                            fill: "#161615"
                        }),
                        /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("path", {
                            d: "M482.854,299.49l.848,2.165a2.168,2.168,0,0,1-1.2,2.987,2.045,2.045,0,0,1-2.552-.694l-1.915,2.649-.516-1.317,1.873-2.535-.2-.518-2.485.973-.442-1.129Zm-.8,4c.649-.254.8-.835.518-1.56l-.351-.894-1.957.766.35.894C480.9,303.425,481.406,303.748,482.055,303.494Z",
                            transform: "translate(-418.479 -279.643)",
                            fill: "#161615"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsxs)("g", {
                    transform: "translate(4.89 51.981)",
                    children: [
                        /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("path", {
                            d: "M384.888,365.352l-.9-1.038.58-.5a2.025,2.025,0,0,1-1.846-.74,3.084,3.084,0,0,1,4.657-4.019,2.09,2.09,0,0,1,.5,1.753l3.1-2.68.969,1.122Zm1.911-3.608a1.623,1.623,0,0,0-.294-1.589,1.695,1.695,0,0,0-2.562,2.211,1.621,1.621,0,0,0,1.529.524Z",
                            transform: "translate(-382.062 -357.324)",
                            fill: "#161615"
                        }),
                        /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("path", {
                            d: "M397.773,372.316c-.066.09-.2.269-.337.442l-3.535-2.577a1.672,1.672,0,0,0,.629,1.927,2.359,2.359,0,0,0,1.648.467l-.057,1.335a3.75,3.75,0,0,1-2.392-.7,3.078,3.078,0,0,1-.733-4.342,2.949,2.949,0,1,1,4.777,3.452Zm-.893-1.293a1.481,1.481,0,0,0-2.346-1.71Z",
                            transform: "translate(-386.596 -361.465)",
                            fill: "#161615"
                        }),
                        /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("path", {
                            d: "M412.418,369.575l1.391.51-3.215,8.768-1.391-.511Z",
                            transform: "translate(-393.963 -362.355)",
                            fill: "#161615"
                        }),
                        /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("path", {
                            d: "M418.264,372.236l1.265.337-.784,2.936-1.265-.337Z",
                            transform: "translate(-397.592 -363.522)",
                            fill: "#161615"
                        }),
                        /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("path", {
                            d: "M426.423,379.222c-.013.111-.039.331-.076.551l-4.344-.5a1.671,1.671,0,0,0,1.5,1.366,2.353,2.353,0,0,0,1.662-.407l.61,1.188a3.749,3.749,0,0,1-2.427.568,3.077,3.077,0,0,1-2.779-3.414,2.948,2.948,0,1,1,5.857.646Zm-1.414-.684a1.481,1.481,0,0,0-2.884-.33Zm.961-5.025-2.384,1.816-.842-1,2.343-1.895Z",
                            transform: "translate(-398.936 -363.608)",
                            fill: "#161615"
                        }),
                        /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("path", {
                            d: "M438.911,378.258l.963,8.642-1.473.164-.382-3.425a2.092,2.092,0,0,1-1.561.933,3.084,3.084,0,0,1-.682-6.114,2.123,2.123,0,0,1,1.857.713l-.085-.761Zm-1.247,2.2a1.62,1.62,0,0,0-1.477-.655,1.694,1.694,0,0,0,.375,3.363,1.623,1.623,0,0,0,1.3-.965Z",
                            transform: "translate(-404.51 -366.163)",
                            fill: "#161615"
                        }),
                        /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("path", {
                            d: "M447.021,379.887l-1.251-3.581,1.4-.489,1.117,3.2a1.053,1.053,0,0,0,1.5.783,1.442,1.442,0,0,0,.86-1.06l-1.288-3.686,1.4-.489,1.933,5.529-1.307.457-.281-.805a2.111,2.111,0,0,1-4.086.145Z",
                            transform: "translate(-409.996 -364.542)",
                            fill: "#161615"
                        }),
                        /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("path", {
                            d: "M455.552,367.9a.976.976,0,1,1-.385,1.325A.97.97,0,0,1,455.552,367.9Zm.73,2.869,1.3-.714,2.819,5.132-1.3.714Z",
                            transform: "translate(-414.063 -361.567)",
                            fill: "#161615"
                        }),
                        /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("path", {
                            d: "M463.272,367.506l.478.6a2.125,2.125,0,0,1,.809-1.818,3.086,3.086,0,0,1,3.842,4.807,2.089,2.089,0,0,1-1.764.445l2.152,2.694-1.159.926-5.43-6.8Zm2.462,2.9a1.625,1.625,0,0,0,1.6-.234,1.7,1.7,0,0,0-2.114-2.645,1.623,1.623,0,0,0-.582,1.509Z",
                            transform: "translate(-417.201 -360.651)",
                            fill: "#161615"
                        }),
                        /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("path", {
                            d: "M478.073,357.422c.086.069.261.207.427.355l-2.719,3.423a1.67,1.67,0,0,0,1.95-.549,2.354,2.354,0,0,0,.535-1.626l1.332.111a3.751,3.751,0,0,1-.8,2.36,3.077,3.077,0,0,1-4.367.551,2.947,2.947,0,1,1,3.646-4.626Zm-1.327.837a1.481,1.481,0,0,0-1.806,2.273Z",
                            transform: "translate(-422.028 -356.717)",
                            fill: "#161615"
                        })
                    ]
                })
            ]
        })
    });
};
var $8dac97be2cee3a05$export$2e2bcd8739ae039 = $8dac97be2cee3a05$var$FavoriteIcon;



parcelRequire("eO7Kz");
const $5526cdecb7b345a6$var$FavoriteLightIcon = ({ className: className })=>{
    return /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 56 55",
        className: className || "rf-h-full",
        children: /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsxs)("g", {
            transform: "translate(0.465 -0.307)",
            children: [
                /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("ellipse", {
                    cx: "28",
                    cy: "27.5",
                    rx: "28",
                    ry: "27.5",
                    transform: "translate(-0.465 0.307)",
                    fill: "#fff"
                }),
                /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("path", {
                    d: "M449.065,485.074a24.475,24.475,0,1,0,24.476,24.476A24.475,24.475,0,0,0,449.065,485.074Zm12.272,31.086a51.307,51.307,0,0,1-9.969,9.625l-2.3,1.659-2.3-1.659a51.425,51.425,0,0,1-9.966-9.625,17.755,17.755,0,0,1-3.474-9.857,10.391,10.391,0,0,1,10.26-10.353h.1a10.28,10.28,0,0,1,5.387,1.52,10.291,10.291,0,0,1,5.39-1.52h.1A10.388,10.388,0,0,1,464.808,506.3,17.75,17.75,0,0,1,461.337,516.16Z",
                    transform: "translate(-421.48 -482.143)",
                    fill: "#0c89a2"
                }),
                /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("path", {
                    d: "M445.93,489.861h-.056a6.46,6.46,0,0,0-5.39,2.947,6.45,6.45,0,0,0-5.387-2.947h-.059a6.412,6.412,0,0,0-6.353,6.409A13.817,13.817,0,0,0,431.4,503.8a47.5,47.5,0,0,0,9.086,8.752,47.479,47.479,0,0,0,9.09-8.752,13.817,13.817,0,0,0,2.712-7.529A6.413,6.413,0,0,0,445.93,489.861Z",
                    transform: "translate(-412.899 -472.11)",
                    fill: "#cb0038"
                })
            ]
        })
    });
};
var $5526cdecb7b345a6$export$2e2bcd8739ae039 = $5526cdecb7b345a6$var$FavoriteLightIcon;



parcelRequire("eO7Kz");
const $262d364151278ab0$var$PhoneIcon = ({ className: className })=>{
    return /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 30 40",
        className: className || "rf-h-6 rf-w-6",
        children: /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("g", {
            transform: "translate(-183.86 -57.462) rotate(-21)",
            children: /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("path", {
                d: "M162.1,156.952a2.852,2.852,0,0,0,2.91-2.915V127.8a2.851,2.851,0,0,0-2.91-2.915H151.91A2.851,2.851,0,0,0,149,127.8v26.233a2.852,2.852,0,0,0,2.91,2.915ZM157,155.738a1.455,1.455,0,1,1,1.455-1.455A1.456,1.456,0,0,1,157,155.738Zm-2.183-29.072c0-.18.086-.322.194-.322h3.978c.106,0,.194.144.194.322v.086c0,.18-.087.322-.194.322h-3.978c-.106,0-.194-.144-.194-.322Zm-4.365,1.861h13.1V151.81h-13.1Zm0,0"
            })
        })
    });
};
var $262d364151278ab0$export$2e2bcd8739ae039 = $262d364151278ab0$var$PhoneIcon;



parcelRequire("eO7Kz");
const $26568f0a198ce8ef$var$PhotoCameraIcon = ({ className: className, color: color })=>{
    return /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 67.258 60.532",
        className: className || "rf-w-6 rf-h-6",
        children: /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsxs)("g", {
            transform: "translate(15.629 13.766)",
            children: [
                /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("path", {
                    d: "M34.722,23.961A10.761,10.761,0,1,1,23.961,13.2,10.761,10.761,0,0,1,34.722,23.961Z",
                    transform: "translate(-5.961 -4.098)",
                    fill: color || "#f1f1f1"
                }),
                /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("path", {
                    d: "M26.54,3,20.386,9.726H9.726A6.746,6.746,0,0,0,3,16.452V56.806a6.746,6.746,0,0,0,6.726,6.726H63.532a6.746,6.746,0,0,0,6.726-6.726V16.452a6.746,6.746,0,0,0-6.726-6.726H52.872L46.718,3ZM36.629,53.443A16.814,16.814,0,1,1,53.443,36.629,16.821,16.821,0,0,1,36.629,53.443Z",
                    transform: "translate(-18.629 -16.766)",
                    fill: color || "#f1f1f1"
                })
            ]
        })
    });
};
var $26568f0a198ce8ef$export$2e2bcd8739ae039 = $26568f0a198ce8ef$var$PhotoCameraIcon;






var $eO7Kz = parcelRequire("eO7Kz");


var $eO7Kz = parcelRequire("eO7Kz");

var $fD7D4 = parcelRequire("fD7D4");

const $ef53ee7f96bcc303$export$7c3e7489ecac4759 = (id, themeColors)=>{
    let color = themeColors.secondary;
    if (id) switch(id.toLowerCase()){
        case (0, $16ad089b9ce6627d$export$22b261e08140d6b2).eat:
            color = themeColors.whereToEatColor;
            break;
        case (0, $16ad089b9ce6627d$export$22b261e08140d6b2).sleep:
            color = themeColors.whereToSleepColor;
            break;
        case (0, $16ad089b9ce6627d$export$22b261e08140d6b2).see:
            color = themeColors.tobeSeenColor;
            break;
        case (0, $16ad089b9ce6627d$export$22b261e08140d6b2).do:
            color = themeColors.tobeDoneColor;
            break;
        case (0, $16ad089b9ce6627d$export$22b261e08140d6b2).localproducts:
            color = themeColors.localProductsColor;
            break;
        case (0, $16ad089b9ce6627d$export$22b261e08140d6b2).services:
            color = themeColors.servicesColor;
            break;
        case (0, $16ad089b9ce6627d$export$22b261e08140d6b2).agenda:
            color = themeColors.agendaColor;
            break;
        default:
            color = themeColors.secondary;
            break;
    }
    return color;
};



const { useSendPostBack: $719f01871b6350db$var$useSendPostBack } = (0, $fD7D4.hooks);
const $719f01871b6350db$var$ListContextDefaultValues = {
    content: undefined,
    filters: [],
    selectedFilters: [],
    color: "",
    setContent: ()=>{},
    setSelectedFilters: ()=>{},
    resetFilters: ()=>{},
    processFiltersOnChange: ()=>{},
    setSuggestedFilter: ()=>{}
};
const $719f01871b6350db$export$52411773e0d6f15d = /*#__PURE__*/ (0, $eO7Kz.createContext)($719f01871b6350db$var$ListContextDefaultValues);
function $719f01871b6350db$export$f9763ecd339e95eb() {
    return (0, $eO7Kz.useContext)($719f01871b6350db$export$52411773e0d6f15d);
}
function $719f01871b6350db$export$9b0a72e5d41d62ec({ children: children }) {
    const { themeColors: themeColors } = (0, $8b59a4dbb18c269b$export$3abe3478af3cb63b)();
    const [content, setContent] = (0, $eO7Kz.useState)();
    const [filters, setFilters] = (0, $eO7Kz.useState)([]);
    const [selectedFilters, setSelectedFilters] = (0, $eO7Kz.useState)([]);
    const color = (0, $eO7Kz.useMemo)(()=>{
        return (0, $ef53ee7f96bcc303$export$7c3e7489ecac4759)(content?.channelData?.category?.id, themeColors);
    }, [
        content
    ]);
    const sendPostBack = $719f01871b6350db$var$useSendPostBack();
    const setSuggestedFilter = (filter)=>{
        setSelectedFilters([
            filter
        ]);
    };
    /**
   * On call :
   *  - set selectedFilters state to empty array
   *  - send postBack message with empty filters
   */ const resetFilters = ()=>{
        setSelectedFilters([]);
        sendPostBack({
            filters: []
        });
    };
    /**
   * On call :
   *  - set selectedFilters and filters states to empty arrays
   */ const totalReset = ()=>{
        setSelectedFilters([]);
        setFilters([]);
    };
    const processFiltersOnChange = (data, full = false)=>{
        let tempFilters = [];
        if (selectedFilters.length > 0) {
            let remainingData = [
                ...data
            ];
            // Check on each selected filter to modify if necessary
            selectedFilters.forEach((selectedFilter)=>{
                let items = [
                    ...selectedFilter.items
                ];
                data.forEach((filter)=>{
                    if (filter.id === selectedFilter.id) {
                        // Special treatment for calendar filter : only 1 value allowed
                        if (filter.id === "Event.DateRange") {
                            if (items.length > 0 && filter.items.length > 0 && items[0] === filter.items[0]) items = [];
                            else items = [
                                ...filter.items
                            ];
                        } else // If the chosen filter is a full one and has already at least one item chosen, let's choose all its items
                        if (full) items = selectedFilter.items.length === filter.items.length ? [] : [
                            ...filter.items
                        ];
                        else items = [
                            ...selectedFilter.items,
                            ...filter.items
                        ].filter((item)=>!(selectedFilter.items.includes(item) && filter.items.includes(item)));
                        // Let's remove this filter from remainingData because it has been processed
                        remainingData = remainingData.filter((fil)=>fil.id !== filter.id);
                    }
                });
                items.length > 0 && (tempFilters = [
                    ...tempFilters,
                    {
                        id: selectedFilter.id,
                        title: selectedFilter.title,
                        items: items
                    }
                ]);
            });
            // If some filters weren't in the selected filters, we add them to the selected filters
            remainingData.length > 0 && (tempFilters = [
                ...tempFilters,
                ...remainingData
            ]);
        } else data.length > 0 && (tempFilters = data);
        setSelectedFilters(tempFilters);
        sendPostBack({
            filters: tempFilters
        });
    };
    const value = (0, $eO7Kz.useMemo)(()=>({
            content: content,
            filters: filters,
            selectedFilters: selectedFilters,
            color: color,
            setContent: setContent,
            setSelectedFilters: setSelectedFilters,
            resetFilters: resetFilters,
            processFiltersOnChange: processFiltersOnChange,
            setSuggestedFilter: setSuggestedFilter
        }), [
        content,
        filters,
        selectedFilters,
        color,
        setContent,
        setSelectedFilters,
        resetFilters,
        processFiltersOnChange,
        setSuggestedFilter
    ]);
    /**
   * On content state change :
   *  - if there is no content, reset all filters and selected filters
   *  - if there is some content, set filters state with the content received or an empty array, and selectedFilters state with received data if there are some
   */ (0, $eO7Kz.useEffect)(()=>{
        if (content) {
            if (filters.length === 0 || content.channelData?.filters !== filters) setFilters(content.channelData?.filters || []);
            content.channelData?.selectedFilters && setSelectedFilters(content.channelData?.selectedFilters);
        } else totalReset();
    }, [
        content
    ]);
    return /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eO7Kz))).Fragment, {
        children: /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)($719f01871b6350db$export$52411773e0d6f15d.Provider, {
            value: value,
            children: children
        })
    });
}



const $46f44f794c70793f$var$CommentsPennant = ({ className: className, customerReviews: customerReviews })=>{
    const { color: color } = (0, $719f01871b6350db$export$f9763ecd339e95eb)();
    const [widthInPx, setWidthInPx] = (0, $eO7Kz.useState)(0);
    const pennantRef = (0, $eO7Kz.useRef)(null);
    (0, $eO7Kz.useEffect)(()=>{
        if (pennantRef.current) setWidthInPx(Math.ceil(pennantRef.current.offsetWidth / 2));
    }, [
        pennantRef
    ]);
    return /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsxs)("div", {
        className: `${className} rf-flex rf-flex-col rf-justify-center rf-text-white`,
        ref: pennantRef,
        children: [
            /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsxs)("div", {
                className: "rf-flex rf-flex-col rf-items-center rf-p-1",
                style: {
                    backgroundColor: color
                },
                children: [
                    /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $3b4b4959ec363ff6$export$2e2bcd8739ae039), {
                        className: "rf-w-6 large:rf-w-8 rf-py-2 vertical:rf-py-1"
                    }),
                    /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsxs)("div", {
                        className: "rf-font-bold rf-small-size-auto rf-text-center",
                        children: [
                            customerReviews,
                            "/10"
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("div", {
                className: "rf-w-0 rf-h-0 rf-border-t-0 rf-border-x-primary rf-border-b-transparent",
                style: {
                    borderLeftColor: color,
                    borderRightColor: color,
                    borderBottomWidth: widthInPx * 2 / 3,
                    borderLeftWidth: widthInPx,
                    borderRightWidth: widthInPx
                }
            })
        ]
    });
};
var $46f44f794c70793f$export$2e2bcd8739ae039 = $46f44f794c70793f$var$CommentsPennant;



const { useSendPostBack: $dfe49777cbd97eb3$var$useSendPostBack } = (0, $fD7D4.hooks);
const $dfe49777cbd97eb3$var$ReviewsAndFavorite = ({ reviews: reviews, favorite: favorite })=>{
    return /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($eO7Kz))).Fragment, {
        children: [
            reviews && /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $46f44f794c70793f$export$2e2bcd8739ae039), {
                customerReviews: reviews,
                className: "rf-absolute rf-top-0 rf-right-2"
            }),
            favorite && /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $5526cdecb7b345a6$export$2e2bcd8739ae039), {
                className: "rf-absolute rf-h-6 large:rf-h-8 rf-bottom-2 rf-right-2"
            })
        ]
    });
};
const $dfe49777cbd97eb3$var$POIAttachment = ({ media: media, title: title, subtitle: subtitle, favorite: favorite, customerReviews: customerReviews, tap: tap })=>{
    const sendPostBack = $dfe49777cbd97eb3$var$useSendPostBack();
    const { themeColors: themeColors } = (0, $8b59a4dbb18c269b$export$3abe3478af3cb63b)();
    const handleClick = ()=>{
        tap && sendPostBack(tap);
    };
    return /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsxs)("div", {
        className: "rf-w-full rf-h-full rf-flex rf-flex-col rf-rounded hover:rf-cursor-pointer",
        onClick: handleClick,
        children: [
            media && media[0]?.url ? /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("div", {
                className: "rf-relative rf-w-full rf-rounded rf-aspect-video",
                style: {
                    backgroundImage: `url(${media[0].url})`,
                    backgroundSize: "cover",
                    backgroundRepeat: "no-repeat",
                    backgroundPosition: "center"
                },
                children: /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)($dfe49777cbd97eb3$var$ReviewsAndFavorite, {
                    reviews: customerReviews,
                    favorite: favorite
                })
            }) : /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsxs)("div", {
                className: "rf-relative rf-w-full rf-bg-silver rf-rounded rf-aspect-video",
                children: [
                    /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $26568f0a198ce8ef$export$2e2bcd8739ae039), {
                        className: "rf-absolute rf-h-1/3 rf-top-1/3 rf-left-1/2 rf-transform -rf-translate-x-1/2"
                    }),
                    /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)($dfe49777cbd97eb3$var$ReviewsAndFavorite, {
                        reviews: customerReviews,
                        favorite: favorite
                    })
                ]
            }),
            subtitle && /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("p", {
                className: "rf-mt-2 rf-font-bold rf-line-clamp-2",
                style: {
                    color: themeColors.agendaColor
                },
                children: subtitle
            }),
            /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("p", {
                className: "rf-my-2 rf-font-bold rf-line-clamp-2",
                children: title || ""
            })
        ]
    });
};
var $dfe49777cbd97eb3$export$2e2bcd8739ae039 = $dfe49777cbd97eb3$var$POIAttachment;



parcelRequire("eO7Kz");


var $fD7D4 = parcelRequire("fD7D4");
var $8f95d7a47c249d24$exports = {};
$8f95d7a47c249d24$exports = JSON.parse('{"fr-FR":{"comment":"avis clients","route":"itin\xe9raire","nodata":"Aucun contenu ne correspond \xe0 votre recherche","pr\xe9c\xe9dent":"Page pr\xe9c\xe9dente","suivant":"Voir la suite","download":"T\xe9l\xe9charger cette fiche","scanQR":"en scannant le QrCode"},"en-US":{"comment":"customer review","route":"route","nodata":"No content corresponds to your search","pr\xe9c\xe9dent":"Previous page","suivant":"Next page","download":"Download this sheet","scanQR":"by scanning the QrCode"},"es-ES":{"comment":"customer review","route":"route","nodata":"No content corresponds to your search","pr\xe9c\xe9dent":"Previous page","suivant":"Next page","download":"Download this sheet","scanQR":"by scanning the QrCode"},"de-DE":{"comment":"customer review","route":"route","nodata":"No content corresponds to your search","pr\xe9c\xe9dent":"Previous page","suivant":"Next page","download":"Download this sheet","scanQR":"by scanning the QrCode"}}');


const { useSendPostBack: $72abea21b49e844e$var$useSendPostBack } = (0, $fD7D4.hooks);
const $72abea21b49e844e$var$PaginationAttachment = ({ body: body, selectAction: selectAction })=>{
    const locale = (0, $2e4dc8fa28d39601$export$6650dace022cfacc)((state)=>state.locale);
    const sendPostBack = $72abea21b49e844e$var$useSendPostBack();
    const handleClick = ()=>{
        selectAction.data && sendPostBack(selectAction.data);
    };
    return /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("div", {
        className: "rf-w-full rf-rounded",
        onClick: handleClick,
        children: /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("div", {
            className: "rf-relative rf-w-full rf-flex rf-items-center rf-justify-center rf-bg-truewhite rf-rounded rf-aspect-video rf-underline rf-cursor-pointer",
            children: (0, (/*@__PURE__*/$parcel$interopDefault($8f95d7a47c249d24$exports)))[locale]?.[body[0].text.toLowerCase()] || (0, (/*@__PURE__*/$parcel$interopDefault($8f95d7a47c249d24$exports)))["fr-FR"][body[0].text.toLowerCase()]
        })
    });
};
var $72abea21b49e844e$export$2e2bcd8739ae039 = $72abea21b49e844e$var$PaginationAttachment;



parcelRequire("eO7Kz");
const $ba4f586932f588ed$var$EmptyAttachment = ()=>{
    return /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("div", {
        className: "rf-w-full rf-h-full rf-flex rf-flex-col rf-gap-2 rf-rounded",
        children: /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("div", {
            className: "rf-relative rf-w-full rf-bg-templateEmptyCard rf-rounded rf-aspect-video"
        })
    });
};
var $ba4f586932f588ed$export$2e2bcd8739ae039 = $ba4f586932f588ed$var$EmptyAttachment;




var $eO7Kz = parcelRequire("eO7Kz");

parcelRequire("eO7Kz");



const $f2726869187ac18c$var$DisplayFullScreenButton = ({ url: url })=>{
    const { themeColors: themeColors } = (0, $8b59a4dbb18c269b$export$3abe3478af3cb63b)();
    const handleClick = ()=>{
        (0, $134592d23f105dbc$export$4e062bd31c814155)(url);
    };
    return /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("div", {
        className: "rf-absolute rf-right-2 rf-top-2 rf-p-2 rf-border rf-rounded-lg rf-bg-cardFrameBackground rf-bg-opacity-30 rf-border-cardButtonBorderDefault hover:rf-cursor-pointer",
        onClick: handleClick,
        children: /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $b5ac7737de70de3d$export$2e2bcd8739ae039), {
            className: "rf-h-4 rf-w-4 large:rf-h-6 large:rf-w-6",
            color: themeColors.card.button.text.default
        })
    });
};
var $f2726869187ac18c$export$2e2bcd8739ae039 = $f2726869187ac18c$var$DisplayFullScreenButton;





const $98e0c6e06d3c4bd8$var$ImageAttachment = ({ url: url, title: title, alt: alt, isMiniature: isMiniature, height: height })=>{
    const { displaySubtitles: displaySubtitles } = (0, $e599569c1fc3ca2c$export$d8760bee47331b1d)();
    const { currentHeight: currentHeight, currentDeviceType: currentDeviceType } = (0, $8b59a4dbb18c269b$export$3abe3478af3cb63b)();
    const [maxHeight, setMaxHeight] = (0, $eO7Kz.useState)(0);
    (0, $eO7Kz.useEffect)(()=>{
        if (currentHeight && currentDeviceType) switch(currentDeviceType){
            case (0, $16ad089b9ce6627d$export$ec1e04e4e5ef8233).mobile:
            case (0, $16ad089b9ce6627d$export$ec1e04e4e5ef8233).widget:
                setMaxHeight(Math.floor(currentHeight * (displaySubtitles ? 0.34 : 0.5)));
                break;
            case (0, $16ad089b9ce6627d$export$ec1e04e4e5ef8233).landscape:
                setMaxHeight(Math.floor(currentHeight * 0.67));
                break;
            case (0, $16ad089b9ce6627d$export$ec1e04e4e5ef8233).borne:
                setMaxHeight(Math.floor(currentHeight * 0.34));
                break;
            default:
                break;
        }
    }, [
        currentHeight,
        currentDeviceType,
        displaySubtitles
    ]);
    return /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsxs)("div", {
        className: "rf-w-full rf-p-4 rf-flex rf-flex-row rf-items-center rf-justify-center rf-rounded rf-bg-cardFrameBackground rf-touch-none",
        style: {
            height: height
        },
        children: [
            /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $f2726869187ac18c$export$2e2bcd8739ae039), {
                url: url
            }),
            isMiniature ? /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($eO7Kz))).Fragment, {
                children: [
                    /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("div", {
                        className: "rf-w-1/4"
                    }),
                    /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("img", {
                        className: "rf-max-w-1/2",
                        src: url,
                        alt: alt || "image",
                        style: {
                            maxHeight: `calc(${maxHeight}px - 3rem)`
                        }
                    }),
                    /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("div", {
                        className: "rf-w-1/4"
                    })
                ]
            }) : /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("img", {
                className: "rf-max-w-full",
                src: url,
                alt: alt || "image",
                style: {
                    maxHeight: `calc(${maxHeight}px - 3rem)`
                }
            }),
            title && /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("div", {
                className: "rf-absolute rf-bottom-0 rf-py-2 rf-text-center rf-text-sm large:rf-text-base rf-text-cardFrameText rf-bg-cardFrameBackground rf-bg-opacity-80 rf-rounded-b rf-w-full",
                children: title
            })
        ]
    });
};
var $98e0c6e06d3c4bd8$export$2e2bcd8739ae039 = $98e0c6e06d3c4bd8$var$ImageAttachment;


/* eslint-disable react/jsx-boolean-value */ 

var $eO7Kz = parcelRequire("eO7Kz");


var $45d6b2651062dc62$exports = {};
$45d6b2651062dc62$exports = JSON.parse('{"fr-FR":{"download":"T\xe9l\xe9charger","goto":"Acc\xe9der \xe0 l\'adresse","click":"Cliquez-ici","scanQR":"en scannant le QrCode"},"en-US":{"download":"Download","goto":"Go to address","click":"Click here","scanQR":"by scanning the QrCode"},"es-ES":{"download":"Download","goto":"Go to address","click":"Click here","scanQR":"by scanning the QrCode"},"de-DE":{"download":"Download","goto":"Go to address","click":"Click here","scanQR":"by scanning the QrCode"}}');


const $8fd1ab545cc1ab7a$export$d07f57595c356899 = (text, locale = "fr-FR")=>{
    if (text && text.length > 0) {
        const first = text.charAt(0);
        const rest = text.slice(1);
        return first.toLocaleUpperCase(locale) + rest;
    }
    return "";
};


const $fa9225bd23941b54$export$a6f11fce0a840e6c = (url)=>{
    const [lastPart] = url.split("/").slice(-1);
    if (lastPart && lastPart.length > 4 && lastPart.includes(".")) return lastPart;
    return undefined;
};



parcelRequire("eO7Kz");

parcelRequire("eO7Kz");
const $5352670cffb3057c$var$ArrowDownIcon = ({ className: className, color: color })=>{
    return /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 28 16.01",
        fill: color || "currentColor",
        className: className || "rf-h-6 rf-w-6",
        children: /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("path", {
            d: "M14 11.18 24.6.58a2 2 0 0 1 2.82 0 2.02 2.02 0 0 1 0 2.84l-12 12a2 2 0 0 1-2.76.05L.58 3.44A2 2 0 0 1 3.41.6Z"
        })
    });
};
var $5352670cffb3057c$export$2e2bcd8739ae039 = $5352670cffb3057c$var$ArrowDownIcon;



parcelRequire("eO7Kz");
const $ed16b2a5f01fd8db$var$ArrowIcon = ({ className: className, color: color })=>{
    return /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 43.776 39.197",
        className: className || "rf-h-6 rf-w-8",
        children: /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsxs)("g", {
            transform: "translate(9.939 -0.321) rotate(17)",
            children: [
                /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("path", {
                    d: "M28.156,0S31.392,28.156,0,28.156",
                    transform: "translate(5.721 0)",
                    fill: "none",
                    stroke: color || "#1999b1",
                    strokeLinecap: "round",
                    strokeWidth: "2"
                }),
                /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("path", {
                    d: "M0,0,8.8,8.8l8.8-8.8",
                    transform: "translate(8.688 18.779) rotate(81)",
                    fill: "none",
                    stroke: color || "#1999b1",
                    strokeLinecap: "round",
                    strokeWidth: "2"
                })
            ]
        })
    });
};
var $ed16b2a5f01fd8db$export$2e2bcd8739ae039 = $ed16b2a5f01fd8db$var$ArrowIcon;



parcelRequire("eO7Kz");
const $ec723792d02ac7e8$var$ArrowLeftIcon = ({ className: className, color: color })=>{
    return /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        className: className || "rf-h-6 rf-w-6",
        fill: "none",
        viewBox: "0 0 24 24",
        stroke: color || "currentColor",
        strokeWidth: 2,
        children: /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("path", {
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M11 17l-5-5m0 0l5-5m-5 5h12"
        })
    });
};
var $ec723792d02ac7e8$export$2e2bcd8739ae039 = $ec723792d02ac7e8$var$ArrowLeftIcon;



parcelRequire("eO7Kz");
const $e2ba1a14911a30a0$var$ArrowRightIcon = ({ className: className, color: color })=>{
    return /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        className: className || "rf-h-6 rf-w-6",
        fill: "none",
        viewBox: "0 0 24 24",
        stroke: color || "currentColor",
        strokeWidth: 2,
        children: /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("path", {
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M13 7l5 5m0 0l-5 5m5-5H6"
        })
    });
};
var $e2ba1a14911a30a0$export$2e2bcd8739ae039 = $e2ba1a14911a30a0$var$ArrowRightIcon;



parcelRequire("eO7Kz");
const $dccbc315b4d39afa$var$ArrowUpIcon = ({ className: className, color: color })=>{
    return /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 28 16.01",
        fill: color || "currentColor",
        className: className || "rf-h-6 rf-w-6",
        children: /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("path", {
            d: "M14 4.83 3.4 15.43a2 2 0 0 1-2.82 0 2.02 2.02 0 0 1 0-2.84l12-12a2 2 0 0 1 2.76-.06l12.08 12.05a2 2 0 0 1-2.83 2.83Z"
        })
    });
};
var $dccbc315b4d39afa$export$2e2bcd8739ae039 = $dccbc315b4d39afa$var$ArrowUpIcon;





const $aee380fb2f9133b7$var$ClassicButton = ({ url: url, text: text, description: description, download: download })=>{
    return /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("div", {
        className: `rf-w-full rf-flex ${description ? "rf-justify-start" : "rf-justify-center"}`,
        children: /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsxs)("a", {
            href: url,
            target: "_blank",
            rel: "noopener noreferrer",
            className: "rf-card-button rf-flex rf-flex-row rf-items-center",
            children: [
                /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("div", {
                    className: "rf-h-6 rf-w-6",
                    children: download ? /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $bed7757a8efcb599$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $e2ba1a14911a30a0$export$2e2bcd8739ae039), {})
                }),
                /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("div", {
                    className: "rf-ml-2 rf-truncate",
                    children: text || ""
                })
            ]
        })
    });
};
var $aee380fb2f9133b7$export$2e2bcd8739ae039 = $aee380fb2f9133b7$var$ClassicButton;




var $eO7Kz = parcelRequire("eO7Kz");



const $7716a19fe6d7feda$var$BorderlessButton = ({ url: url, text: text, download: download })=>{
    const { themeColors: themeColors } = (0, $8b59a4dbb18c269b$export$3abe3478af3cb63b)();
    const [hover, setHover] = (0, $eO7Kz.useState)(false);
    return /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("div", {
        className: "rf-w-full rf-flex rf-justify-start",
        children: /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsxs)("a", {
            href: url,
            target: "_blank",
            rel: "noopener noreferrer",
            className: "rf-w-full rf-flex rf-flex-row rf-items-center rf-justify-start rf-text-cardButtonTextDefault",
            onPointerEnter: ()=>setHover(true),
            onPointerLeave: ()=>setHover(false),
            onClick: ()=>setHover(true),
            children: [
                /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("div", {
                    className: `rf-h-6 rf-w-6 rf-rounded ${hover ? "rf-bg-cardButtonBackgroundHover" : "rf-bg-cardButtonBackgroundDefault"}`,
                    children: download ? /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $bed7757a8efcb599$export$2e2bcd8739ae039), {
                        className: "rf-h-6 rf-p-1 rf-border rf-rounded rf-border-cardButtonBorderDefault",
                        color: hover ? themeColors.card.button.text.hover : themeColors.card.button.text.default
                    }) : /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $e2ba1a14911a30a0$export$2e2bcd8739ae039), {
                        className: "rf-h-6 rf-p-1 rf-border rf-rounded rf-border-cardButtonBorderDefault",
                        color: hover ? themeColors.card.button.text.hover : themeColors.card.button.text.default
                    })
                }),
                /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("div", {
                    className: "rf-ml-4",
                    children: text || ""
                })
            ]
        })
    });
};
var $7716a19fe6d7feda$export$2e2bcd8739ae039 = $7716a19fe6d7feda$var$BorderlessButton;




const $94a607a4ca89b9e0$var$LinkAttachment = ({ urlData: urlData, fileName: fileName, qrCode: qrCode, description: description, height: height })=>{
    const { configuration: configuration } = (0, $e599569c1fc3ca2c$export$d8760bee47331b1d)();
    const { locale: locale } = (0, $2e4dc8fa28d39601$export$6650dace022cfacc)();
    !fileName && (fileName = (0, $fa9225bd23941b54$export$a6f11fce0a840e6c)(urlData.url));
    const title = urlData.title || fileName;
    const [qrCodeData, setQrCodeData] = (0, $eO7Kz.useState)(qrCode);
    /**
   * On call :
   *  - get text to display depending on configuration, urlData and locale
   * @returns string
   */ const getTextTodisplay = ()=>{
        let textToDisplay = "";
        const downloadText = (0, (/*@__PURE__*/$parcel$interopDefault($45d6b2651062dc62$exports)))[locale]?.download || (0, (/*@__PURE__*/$parcel$interopDefault($45d6b2651062dc62$exports)))["fr-FR"].download;
        const gotoText = (0, (/*@__PURE__*/$parcel$interopDefault($45d6b2651062dc62$exports)))[locale]?.goto || (0, (/*@__PURE__*/$parcel$interopDefault($45d6b2651062dc62$exports)))["fr-FR"].goto;
        const clickText = (0, (/*@__PURE__*/$parcel$interopDefault($45d6b2651062dc62$exports)))[locale]?.click || (0, (/*@__PURE__*/$parcel$interopDefault($45d6b2651062dc62$exports)))["fr-FR"].click;
        const scanQRText = (0, (/*@__PURE__*/$parcel$interopDefault($45d6b2651062dc62$exports)))[locale]?.scanQR || (0, (/*@__PURE__*/$parcel$interopDefault($45d6b2651062dc62$exports)))["fr-FR"].scanQR;
        if (configuration.isUsedOnBorne) {
            if (urlData.download) {
                if (urlData.title) textToDisplay = `${downloadText} \u00ab ${fileName} \u00bb`;
                else textToDisplay = downloadText;
            } else textToDisplay = gotoText;
            textToDisplay += ` ${scanQRText}`;
        } else if (urlData.download) {
            if (urlData.title) textToDisplay = `${downloadText} ${fileName}`;
            else textToDisplay = downloadText;
        } else textToDisplay = clickText;
        return textToDisplay;
    };
    /**
   * On component creation :
   *  - call setQrCodeDataAsync only if used on a borne
   */ (0, $eO7Kz.useEffect)(()=>{
        !qrCode && configuration.isUsedOnBorne && setQrCodeDataAsync();
    }, []);
    /**
   * On call :
   *  - generate a qrcode as dataURL
   *  - set qrCodeData state with the data
   */ const setQrCodeDataAsync = async ()=>{
        const qrCodeString = await (0, (/*@__PURE__*/$parcel$interopDefault($d452087480f7647a$exports))).toDataURL(urlData.url);
        setQrCodeData(qrCodeString);
    };
    return /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsxs)("div", {
        className: `rf-w-full rf-p-[25px] rf-flex rf-flex-col rf-items-center ${title || description ? "rf-justify-between" : "rf-justify-around"} rf-rounded rf-bg-cardFrameBackground rf-text-cardFrameText rf-overflow-y-scroll rf-scrollbar-thin rf-touch-none`,
        style: {
            height: height
        },
        children: [
            title && // Title on the left if there is a description, middle otherwise
            /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("div", {
                className: `rf-w-full rf-mb-4 ${description ? "rf-text-left" : "rf-text-center"} rf-title-size-auto ${configuration.isUsedOnBorne ? "rf-truncate" : "rf-line-clamp-2"}`,
                children: (0, $8fd1ab545cc1ab7a$export$d07f57595c356899)(title)
            }),
            configuration.isUsedOnBorne ? /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($eO7Kz))).Fragment, {
                children: [
                    /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsxs)("div", {
                        className: "rf-w-full rf-mb-4 rf-flex rf-flex-row rf-items-center rf-justify-center",
                        children: [
                            description && /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("div", {
                                className: "rf-mb-4",
                                children: description
                            }),
                            qrCodeData && /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("img", {
                                className: "rf-h-full",
                                src: qrCodeData,
                                alt: "QR Code"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsxs)("div", {
                        className: "rf-relative rf-text-center rf-mx-8 rf-italic",
                        children: [
                            /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $e46aea93ab3102c7$export$2e2bcd8739ae039), {
                                className: "rf-absolute rf-top-[0.125rem] -rf-left-6 rf-h-4"
                            }),
                            getTextTodisplay()
                        ]
                    })
                ]
            }) : /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($eO7Kz))).Fragment, {
                children: [
                    description && /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("div", {
                        className: "rf-mb-4",
                        children: description
                    }),
                    urlData.download && urlData.title && getTextTodisplay().length >= 40 ? /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $7716a19fe6d7feda$export$2e2bcd8739ae039), {
                        url: urlData.url,
                        text: getTextTodisplay(),
                        download: true
                    }) : /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $aee380fb2f9133b7$export$2e2bcd8739ae039), {
                        url: urlData.url,
                        text: getTextTodisplay(),
                        description: !!description,
                        download: !!urlData.download
                    })
                ]
            })
        ]
    });
};
var $94a607a4ca89b9e0$export$2e2bcd8739ae039 = $94a607a4ca89b9e0$var$LinkAttachment;


/* eslint-disable react/jsx-boolean-value */ 
parcelRequire("eO7Kz");




const $016b7c6eec4e62b6$var$MultiLinkAttachment = ({ urlData: urlData, title: title, description: description, height: height })=>{
    const { configuration: configuration } = (0, $e599569c1fc3ca2c$export$d8760bee47331b1d)();
    return /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsxs)("div", {
        className: `rf-w-full rf-p-[25px] rf-flex rf-flex-col rf-items-center rf-gap-2 ${title || description ? "rf-justify-between" : "rf-justify-around"} rf-min-h-inherit rf-rounded rf-bg-cardFrameBackground rf-text-cardFrameText rf-overflow-y-scroll rf-scrollbar-thin rf-touch-none`,
        style: {
            height: height
        },
        children: [
            title && // Title on the left if there is a description, middle otherwise
            /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("div", {
                className: `rf-w-full rf-mb-4 ${description ? "rf-text-left" : "rf-text-center"} rf-title-size-auto ${configuration.isUsedOnBorne ? "rf-truncate" : "rf-line-clamp-2"}`,
                children: (0, $8fd1ab545cc1ab7a$export$d07f57595c356899)(title)
            }),
            description && /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("div", {
                className: "rf-mb-4",
                children: description
            }),
            urlData.map((data, key)=>{
                return /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $7716a19fe6d7feda$export$2e2bcd8739ae039), {
                    url: data.url,
                    text: data.title || (0, $fa9225bd23941b54$export$a6f11fce0a840e6c)(data.url) || data.url,
                    download: !!data.download
                }, key);
            })
        ]
    });
};
var $016b7c6eec4e62b6$export$2e2bcd8739ae039 = $016b7c6eec4e62b6$var$MultiLinkAttachment;



parcelRequire("eO7Kz");


var $fD7D4 = parcelRequire("fD7D4");

const { useSendMessage: $238f70d244df3470$var$useSendMessage } = (0, $fD7D4.hooks);
const $238f70d244df3470$var$SuggestedActionAttachment = ({ title: title, actions: actions, history: history, height: height })=>{
    const { locale: locale } = (0, $2e4dc8fa28d39601$export$6650dace022cfacc)();
    const sendMessage = $238f70d244df3470$var$useSendMessage();
    /**
   * On call :
   *  - use botframework's useSendMessage hook to send a message containing the value
   * @param value : string
   */ const handleClick = (value)=>{
        sendMessage(value);
    };
    return /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsxs)("div", {
        className: "rf-w-full rf-p-4 rf-flex rf-flex-col rf-items-center rf-justify-center rf-rounded rf-bg-cardFrameBackground",
        style: {
            height: height
        },
        children: [
            /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("div", {
                className: "rf-w-full rf-pb-4 rf-text-center rf-text-cardFrameText rf-subtitle-size-auto",
                children: (0, $8fd1ab545cc1ab7a$export$d07f57595c356899)(title, locale)
            }),
            /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("div", {
                className: "rf-w-full rf-pt-4 rf-flex rf-flex-row rf-justify-center rf-items-center rf-gap-4 rf-flex-wrap",
                children: actions.map((action, key)=>{
                    return /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("button", {
                        className: "rf-card-button",
                        onClick: history ? ()=>{} : ()=>handleClick(action.action),
                        children: action.title || "?"
                    }, key);
                })
            })
        ]
    });
};
var $238f70d244df3470$export$2e2bcd8739ae039 = $238f70d244df3470$var$SuggestedActionAttachment;



parcelRequire("eO7Kz");

var $fD7D4 = parcelRequire("fD7D4");



const { useSendPostBack: $726a6aca92aa7207$var$useSendPostBack } = (0, $fD7D4.hooks);
const $726a6aca92aa7207$var$DiscoverAttachment = ({ title: title, mainButtons: mainButtons, recommandationButton: recommandationButton, history: history, height: height })=>{
    const sendPostBack = $726a6aca92aa7207$var$useSendPostBack();
    const { locale: locale } = (0, $2e4dc8fa28d39601$export$6650dace022cfacc)();
    const { isMobile: isMobile } = (0, $8b59a4dbb18c269b$export$3abe3478af3cb63b)();
    const handleClick = (event)=>{
        // tap && sendPostBack(tap)
        sendPostBack({
            name: event,
            type: "event"
        });
    };
    return /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsxs)("div", {
        className: `rf-w-full rf-flex rf-flex-col rf-items-center rf-justify-between rf-rounded rf-bg-cardFrameBackground large:rf-p-[25px] rf-p-4 ${history && "rf-pointer-events-none"} `,
        style: {
            height: height
        },
        children: [
            /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("div", {
                className: "rf-min-h-inherit rf-rounded rf-bg-cardFrameBackground rf-text-cardFrameText rf-self-start rf-title-size-auto rf-mb-2",
                children: (0, $8fd1ab545cc1ab7a$export$d07f57595c356899)(title, locale)
            }),
            /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("div", {
                className: "rf-w-full rf-h-full rf-flex rf-flex-row rf-justify-evenly rf-items-center rf-gap-2 large:rf-gap-4",
                children: mainButtons && mainButtons.length > 0 ? mainButtons.map((button, i)=>{
                    return /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsxs)("div", {
                        className: "rf-relative rf-card-button-discover rf-rounded rf-flex rf-flex-col rf-gap-2 large:rf-gap-4 rf-items-center",
                        onClick: ()=>handleClick(button.EventName),
                        style: {
                            flex: isMobile ? "0 1 6rem" : "0 1 8rem",
                            boxShadow: "0px 0px 13px #0000009c"
                        },
                        children: [
                            /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("img", {
                                src: button.MediaUrl,
                                alt: button.Text,
                                style: {
                                    height: "50px"
                                }
                            }),
                            /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("p", {
                                className: "rf-text-center rf-uppercase rf-font-bold large:rf-text-base rf-text-xsl rf-whitespace-nowrap",
                                children: button.Text
                            })
                        ]
                    }, i);
                }) : /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $179ad052de55b86f$exports.Fragment), {})
            }),
            recommandationButton && /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("p", {
                className: "large:rf-mt-4 rf-font-bold rf-card-button rf-text-center rf-capitalize-first",
                onClick: ()=>handleClick(recommandationButton.eventName),
                children: recommandationButton.text
            })
        ]
    });
};
var $726a6aca92aa7207$export$2e2bcd8739ae039 = $726a6aca92aa7207$var$DiscoverAttachment;


/* eslint-disable react/jsx-boolean-value */ 

var $eO7Kz = parcelRequire("eO7Kz");




var $eO7Kz = parcelRequire("eO7Kz");



var $fD7D4 = parcelRequire("fD7D4");
const { useSendPostBack: $1b89a7af3b04604c$var$useSendPostBack } = (0, $fD7D4.hooks);
const $1b89a7af3b04604c$var$BorderlessButtonMessage = ({ text: text, differentTextTosend: differentTextTosend })=>{
    const { themeColors: themeColors } = (0, $8b59a4dbb18c269b$export$3abe3478af3cb63b)();
    const [hover, setHover] = (0, $eO7Kz.useState)(false);
    const sendPostBack = $1b89a7af3b04604c$var$useSendPostBack();
    const onClick = (text)=>{
        sendPostBack(text);
    };
    return /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("div", {
        className: "rf-w-full rf-flex rf-justify-start rf-cursor-pointer",
        children: /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsxs)("div", {
            className: "rf-w-full rf-flex rf-flex-row rf-items-center rf-justify-start rf-text-cardButtonTextDefault",
            onPointerEnter: ()=>setHover(true),
            onPointerLeave: ()=>setHover(false),
            onClick: ()=>{
                setHover(true);
                onClick(differentTextTosend || text);
            },
            children: [
                /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("div", {
                    className: `rf-h-6 rf-w-6 rf-rounded ${hover ? "rf-bg-cardButtonBackgroundHover" : "rf-bg-cardButtonBackgroundDefault"}`,
                    children: /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $e2ba1a14911a30a0$export$2e2bcd8739ae039), {
                        className: "rf-h-6 rf-p-1 rf-border rf-rounded rf-border-cardButtonBorderDefault",
                        color: hover ? themeColors.card.button.text.hover : themeColors.card.button.text.default
                    })
                }),
                /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("div", {
                    className: "rf-ml-4",
                    children: text || ""
                })
            ]
        })
    });
};
var $1b89a7af3b04604c$export$2e2bcd8739ae039 = $1b89a7af3b04604c$var$BorderlessButtonMessage;



var $e73785f533b5e2c5$exports = {};
$e73785f533b5e2c5$exports = JSON.parse('{"fr-FR":{"needhelp":"Besoin d\'aide ?","consult":"Consultez","thetutorial":"le tutoriel"},"en-US":{"needhelp":"Need help ?","consult":"Check out","thetutorial":"the tutorial"},"es-ES":{"needhelp":"Necesitar ayuda ?","consult":"Mira","thetutorial":"el tutorial"},"de-DE":{"needhelp":"Brauche Hilfe ?","consult":"Schauen Sie sich","thetutorial":"das Tutorial an"}}');




const $5f40c3b320d6542d$var$SuggestionAttachment = ({ suggestions: suggestions, title: title, description: description, height: height, history: history, showTutorial: showTutorial })=>{
    const { configuration: configuration } = (0, $e599569c1fc3ca2c$export$d8760bee47331b1d)();
    const { locale: locale } = (0, $2e4dc8fa28d39601$export$6650dace022cfacc)();
    const { themeColors: themeColors } = (0, $8b59a4dbb18c269b$export$3abe3478af3cb63b)();
    const onTutorialClick = ()=>{
        // TODO
        console.log("show tutorial");
    };
    return /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsxs)("div", {
        className: `rf-w-full large:rf-p-[25px] rf-p-4 rf-flex rf-flex-col rf-items-center rf-gap-2 ${title || description ? "rf-justify-between" : "rf-justify-around"} rf-min-h-inherit rf-rounded rf-bg-cardFrameBackground rf-text-cardFrameText rf-overflow-y-scroll rf-scrollbar-thin rf-touch-none ${history && "rf-pointer-events-none"} `,
        style: {
            height: height
        },
        children: [
            title && // Title on the left if there is a description, middle otherwise
            /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("div", {
                className: `rf-w-full ${description ? "rf-text-left" : "rf-text-center"} rf-title-size-auto ${configuration.isUsedOnBorne ? "rf-truncate" : "rf-line-clamp-2"}`,
                children: (0, $8fd1ab545cc1ab7a$export$d07f57595c356899)(title)
            }),
            description && /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("div", {
                className: "rf-text-left rf-w-full",
                children: description
            }),
            suggestions?.map((data, key)=>{
                const text = typeof data === "string" ? data : data.text;
                const differentTextTosend = typeof data === "string" ? undefined : data.differentTextToSend || data.text;
                return /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eO7Kz))).Fragment, {
                    children: /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $1b89a7af3b04604c$export$2e2bcd8739ae039), {
                        text: text,
                        differentTextTosend: differentTextTosend
                    })
                }, key);
            }),
            showTutorial && /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsxs)("div", {
                className: "rf-text-left rf-w-full rf-flex rf-items-end rf-italic",
                children: [
                    /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $e46aea93ab3102c7$export$2e2bcd8739ae039), {
                        className: "rf-pr-2 rf-h-6",
                        color: themeColors.card.button.text.default
                    }),
                    (0, (/*@__PURE__*/$parcel$interopDefault($e73785f533b5e2c5$exports)))[locale]?.needhelp || (0, (/*@__PURE__*/$parcel$interopDefault($e73785f533b5e2c5$exports)))["fr-FR"].needhelp,
                    " ",
                    (0, (/*@__PURE__*/$parcel$interopDefault($e73785f533b5e2c5$exports)))[locale]?.consult || (0, (/*@__PURE__*/$parcel$interopDefault($e73785f533b5e2c5$exports)))["fr-FR"].consult,
                    /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("span", {
                        className: "rf-pl-1 rf-underline rf-cursor-pointer",
                        onClick: onTutorialClick,
                        children: (0, (/*@__PURE__*/$parcel$interopDefault($e73785f533b5e2c5$exports)))[locale]?.thetutorial || (0, (/*@__PURE__*/$parcel$interopDefault($e73785f533b5e2c5$exports)))["fr-FR"].thetutorial
                    })
                ]
            })
        ]
    });
};
var $5f40c3b320d6542d$export$2e2bcd8739ae039 = $5f40c3b320d6542d$var$SuggestionAttachment;


const $60ac0716299d3329$var$attachmentMiddleware = ()=>(next)=>(...args)=>{
            const [{ attachment: attachment, history: history, height: height }] = args;
            switch(attachment.contentType){
                case 0, $67e1576cd7fc37b7$export$7ff82c027074e396:
                    return /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $b185857b63ab2eea$export$2e2bcd8739ae039), {
                        ...attachment.content,
                        height: height
                    });
                case 0, $67e1576cd7fc37b7$export$8c612ad42a82284:
                    return /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $dfe49777cbd97eb3$export$2e2bcd8739ae039), {
                        ...attachment.content
                    });
                case 0, $67e1576cd7fc37b7$export$4e4550ddaa0ad2f9:
                    return /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $72abea21b49e844e$export$2e2bcd8739ae039), {
                        ...attachment.content
                    });
                case 0, $67e1576cd7fc37b7$export$9399f66a54c38cac:
                    return /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $ba4f586932f588ed$export$2e2bcd8739ae039), {});
                case 0, $67e1576cd7fc37b7$export$c50891df8986f6d9:
                    return /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $98e0c6e06d3c4bd8$export$2e2bcd8739ae039), {
                        ...attachment.content,
                        height: height
                    });
                case 0, $67e1576cd7fc37b7$export$cce25171fe980112:
                    return Array.isArray(attachment.content.urlData) ? /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $016b7c6eec4e62b6$export$2e2bcd8739ae039), {
                        ...attachment.content,
                        height: height
                    }) : /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $94a607a4ca89b9e0$export$2e2bcd8739ae039), {
                        ...attachment.content,
                        height: height
                    });
                case 0, $67e1576cd7fc37b7$export$2730c89e9ebd0948:
                    return /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $238f70d244df3470$export$2e2bcd8739ae039), {
                        ...attachment.content,
                        history: history,
                        height: height
                    });
                case 0, $67e1576cd7fc37b7$export$8ebd8d161896e63a:
                    return /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $726a6aca92aa7207$export$2e2bcd8739ae039), {
                        ...attachment.content,
                        history: history,
                        height: height
                    });
                case 0, $67e1576cd7fc37b7$export$a4f2f23a67537f78:
                    return /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $5f40c3b320d6542d$export$2e2bcd8739ae039), {
                        ...attachment.content,
                        history: history,
                        height: height
                    });
                default:
                    if (height) {
                        const tempArgs = args[0];
                        tempArgs.attachment.content.minHeight = `${height}px`;
                        tempArgs.attachment.content.verticalContentAlignment = "Center";
                        args[0] = tempArgs;
                    }
                    return next(...args);
            }
        };
var $60ac0716299d3329$export$2e2bcd8739ae039 = $60ac0716299d3329$var$attachmentMiddleware;


const $c8af573dcfa63824$var$activityMiddleware = ()=>(next)=>(...args)=>{
            const [{ activity: activity }] = args;
            if (activity && activity.type === "message" && activity.attachments && activity.attachments.length > 0 && activity.attachments[0].contentType === "application/vnd.davi.retorik.card.suggestedaction" && activity.attachments[0].content?.title?.indexOf(activity.text) > -1) {
                // Hack for Suggested Action : Only show text in card, not in message
                activity.text = "";
                activity.htmlText = "";
            }
            return next(...args);
        };
var $c8af573dcfa63824$export$2e2bcd8739ae039 = $c8af573dcfa63824$var$activityMiddleware;


var $d47cbf04a0a44873$exports = {};
"use strict";
var $d47cbf04a0a44873$var$__createBinding = $d47cbf04a0a44873$exports && $d47cbf04a0a44873$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $d47cbf04a0a44873$var$__exportStar = $d47cbf04a0a44873$exports && $d47cbf04a0a44873$exports.__exportStar || function(m, exports) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) $d47cbf04a0a44873$var$__createBinding(exports, m, p);
};
Object.defineProperty($d47cbf04a0a44873$exports, "__esModule", {
    value: true
});

// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.
$d47cbf04a0a44873$var$__exportStar((parcelRequire("c6BU9")), $d47cbf04a0a44873$exports);

$d47cbf04a0a44873$var$__exportStar((parcelRequire("kD48O")), $d47cbf04a0a44873$exports);

$d47cbf04a0a44873$var$__exportStar((parcelRequire("8Lw6d")), $d47cbf04a0a44873$exports);

$d47cbf04a0a44873$var$__exportStar((parcelRequire("8QA0A")), $d47cbf04a0a44873$exports);

$d47cbf04a0a44873$var$__exportStar((parcelRequire("eZfTX")), $d47cbf04a0a44873$exports);

$d47cbf04a0a44873$var$__exportStar((parcelRequire("KzWne")), $d47cbf04a0a44873$exports);

$d47cbf04a0a44873$var$__exportStar((parcelRequire("lHSNo")), $d47cbf04a0a44873$exports);

$d47cbf04a0a44873$var$__exportStar((parcelRequire("hfx8W")), $d47cbf04a0a44873$exports);

$d47cbf04a0a44873$var$__exportStar((parcelRequire("01FSm")), $d47cbf04a0a44873$exports);

$d47cbf04a0a44873$var$__exportStar((parcelRequire("eDhMr")), $d47cbf04a0a44873$exports);

$d47cbf04a0a44873$var$__exportStar((parcelRequire("2d7mp")), $d47cbf04a0a44873$exports);

$d47cbf04a0a44873$var$__exportStar((parcelRequire("6u2EN")), $d47cbf04a0a44873$exports);

$d47cbf04a0a44873$var$__exportStar((parcelRequire("gOrNK")), $d47cbf04a0a44873$exports);

$d47cbf04a0a44873$var$__exportStar((parcelRequire("kIKLf")), $d47cbf04a0a44873$exports);

$d47cbf04a0a44873$var$__exportStar((parcelRequire("4f7Lw")), $d47cbf04a0a44873$exports);



// Your use of the content in the files referenced here is subject to the terms of the license at https://aka.ms/fluentui-assets-license


/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $b1c38fba2c0065a7$var$extendStatics = function(d, b) {
    $b1c38fba2c0065a7$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $b1c38fba2c0065a7$var$extendStatics(d, b);
};
function $b1c38fba2c0065a7$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $b1c38fba2c0065a7$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $b1c38fba2c0065a7$export$18ce0697a983be9b = function() {
    $b1c38fba2c0065a7$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $b1c38fba2c0065a7$export$18ce0697a983be9b.apply(this, arguments);
};
function $b1c38fba2c0065a7$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $b1c38fba2c0065a7$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $b1c38fba2c0065a7$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $b1c38fba2c0065a7$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $b1c38fba2c0065a7$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $b1c38fba2c0065a7$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $b1c38fba2c0065a7$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $b1c38fba2c0065a7$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $b1c38fba2c0065a7$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $b1c38fba2c0065a7$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $b1c38fba2c0065a7$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $b1c38fba2c0065a7$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $b1c38fba2c0065a7$export$45d3717a4c69092e(o, m, p);
}
function $b1c38fba2c0065a7$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $b1c38fba2c0065a7$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $b1c38fba2c0065a7$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($b1c38fba2c0065a7$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $b1c38fba2c0065a7$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $b1c38fba2c0065a7$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $b1c38fba2c0065a7$export$10c90e4f7922046c(v) {
    return this instanceof $b1c38fba2c0065a7$export$10c90e4f7922046c ? (this.v = v, this) : new $b1c38fba2c0065a7$export$10c90e4f7922046c(v);
}
function $b1c38fba2c0065a7$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $b1c38fba2c0065a7$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $b1c38fba2c0065a7$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $b1c38fba2c0065a7$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $b1c38fba2c0065a7$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $b1c38fba2c0065a7$export$19a8beecd37a4c45 === "function" ? $b1c38fba2c0065a7$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $b1c38fba2c0065a7$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $b1c38fba2c0065a7$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function $b1c38fba2c0065a7$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $b1c38fba2c0065a7$export$45d3717a4c69092e(result, mod, k);
    }
    $b1c38fba2c0065a7$var$__setModuleDefault(result, mod);
    return result;
}
function $b1c38fba2c0065a7$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $b1c38fba2c0065a7$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $b1c38fba2c0065a7$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $b1c38fba2c0065a7$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
var $b1c38fba2c0065a7$export$2e2bcd8739ae039 = {
    __extends: $b1c38fba2c0065a7$export$a8ba968b8961cb8a,
    __assign: $b1c38fba2c0065a7$export$18ce0697a983be9b,
    __rest: $b1c38fba2c0065a7$export$3c9a16f847548506,
    __decorate: $b1c38fba2c0065a7$export$29e00dfd3077644b,
    __param: $b1c38fba2c0065a7$export$d5ad3fd78186038f,
    __metadata: $b1c38fba2c0065a7$export$f1db080c865becb9,
    __awaiter: $b1c38fba2c0065a7$export$1050f835b63b671e,
    __generator: $b1c38fba2c0065a7$export$67ebef60e6f28a6,
    __createBinding: $b1c38fba2c0065a7$export$45d3717a4c69092e,
    __exportStar: $b1c38fba2c0065a7$export$f33643c0debef087,
    __values: $b1c38fba2c0065a7$export$19a8beecd37a4c45,
    __read: $b1c38fba2c0065a7$export$8d051b38c9118094,
    __spread: $b1c38fba2c0065a7$export$afc72e2116322959,
    __spreadArrays: $b1c38fba2c0065a7$export$6388937ca91ccae8,
    __spreadArray: $b1c38fba2c0065a7$export$1216008129fb82ed,
    __await: $b1c38fba2c0065a7$export$10c90e4f7922046c,
    __asyncGenerator: $b1c38fba2c0065a7$export$e427f37a30a4de9b,
    __asyncDelegator: $b1c38fba2c0065a7$export$bbd80228419bb833,
    __asyncValues: $b1c38fba2c0065a7$export$e3b29a3d6162315f,
    __makeTemplateObject: $b1c38fba2c0065a7$export$4fb47efe1390b86f,
    __importStar: $b1c38fba2c0065a7$export$c21735bcef00d192,
    __importDefault: $b1c38fba2c0065a7$export$da59b14a69baef04,
    __classPrivateFieldGet: $b1c38fba2c0065a7$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $b1c38fba2c0065a7$export$d40a35129aaff81f,
    __classPrivateFieldIn: $b1c38fba2c0065a7$export$81fdc39f203e4e04
};


/**
 * Verifies if an application can use DOM.
 */ function $410af2618185d52d$export$71594e8a50f746f4() {
    return typeof window !== "undefined" && !!(window.document && // eslint-disable-next-line deprecation/deprecation
    window.document.createElement);
}


var $109c028fea018492$var$_window = undefined;
// Note: Accessing "window" in IE11 is somewhat expensive, and calling "typeof window"
// hits a memory leak, whereas aliasing it and calling "typeof _window" does not.
// Caching the window value at the file scope lets us minimize the impact.
try {
    $109c028fea018492$var$_window = window;
} catch (e) {
/* no-op */ }
function $109c028fea018492$export$38b2d434cce3ea22(rootElement) {
    if (!(0, $410af2618185d52d$export$71594e8a50f746f4)() || typeof $109c028fea018492$var$_window === "undefined") return undefined;
    else {
        var el = rootElement;
        return el && el.ownerDocument && el.ownerDocument.defaultView ? el.ownerDocument.defaultView : $109c028fea018492$var$_window;
    }
}


/**
 * Storing global state in local module variables has issues when more than one copy
 * if the module gets loaded on the page (due to a bundling error or simply by consuming
 * a prebundled script.)
 *
 * This file contains helpers to deal with the getting and setting local state, and allows
 * callers to get called back when it mutates.
 */ var $f115fbba50f668f9$var$GLOBAL_SETTINGS_PROP_NAME = "__globalSettings__";
var $f115fbba50f668f9$var$CALLBACK_STATE_PROP_NAME = "__callbacks__";
var $f115fbba50f668f9$var$_counter = 0;
/**
 * Global settings helper, which stores settings in the global (window) namespace.
 * If window is not provided, it will store settings in module scope. Provides a
 * way to observe changes as well when their values change.
 *
 * @public
 * {@docCategory GlobalSettings}
 */ var $f115fbba50f668f9$export$e962ef7984a884aa = /** @class */ function() {
    function GlobalSettings() {}
    GlobalSettings.getValue = function(key, defaultValue) {
        var globalSettings = $f115fbba50f668f9$var$_getGlobalSettings();
        if (globalSettings[key] === undefined) globalSettings[key] = typeof defaultValue === "function" ? defaultValue() : defaultValue;
        return globalSettings[key];
    };
    GlobalSettings.setValue = function(key, value) {
        var globalSettings = $f115fbba50f668f9$var$_getGlobalSettings();
        var callbacks = globalSettings[$f115fbba50f668f9$var$CALLBACK_STATE_PROP_NAME];
        var oldValue = globalSettings[key];
        if (value !== oldValue) {
            globalSettings[key] = value;
            var changeDescription = {
                oldValue: oldValue,
                value: value,
                key: key
            };
            for(var id in callbacks)if (callbacks.hasOwnProperty(id)) callbacks[id](changeDescription);
        }
        return value;
    };
    GlobalSettings.addChangeListener = function(cb) {
        // Note: we use generated ids on the callbacks to create a map of the callbacks, which optimizes removal.
        // (It's faster to delete a key than it is to look up the index of an object and splice an array.)
        var id = cb.__id__;
        var callbacks = $f115fbba50f668f9$var$_getCallbacks();
        if (!id) id = cb.__id__ = String($f115fbba50f668f9$var$_counter++);
        callbacks[id] = cb;
    };
    GlobalSettings.removeChangeListener = function(cb) {
        var callbacks = $f115fbba50f668f9$var$_getCallbacks();
        delete callbacks[cb.__id__];
    };
    return GlobalSettings;
}();
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $f115fbba50f668f9$var$_getGlobalSettings() {
    var _a;
    var win = (0, $109c028fea018492$export$38b2d434cce3ea22)();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var globalObj = win || {};
    if (!globalObj[$f115fbba50f668f9$var$GLOBAL_SETTINGS_PROP_NAME]) globalObj[$f115fbba50f668f9$var$GLOBAL_SETTINGS_PROP_NAME] = (_a = {}, _a[$f115fbba50f668f9$var$CALLBACK_STATE_PROP_NAME] = {}, _a);
    return globalObj[$f115fbba50f668f9$var$GLOBAL_SETTINGS_PROP_NAME];
}
function $f115fbba50f668f9$var$_getCallbacks() {
    var globalSettings = $f115fbba50f668f9$var$_getGlobalSettings();
    return globalSettings[$f115fbba50f668f9$var$CALLBACK_STATE_PROP_NAME];
}

/* eslint-disable no-console */ var $d337f08bfbdbd736$var$_warningCallback = undefined;
function $d337f08bfbdbd736$export$c106dd0671a0fc2d(message) {
    if (console && console.warn) console.warn(message);
}
function $d337f08bfbdbd736$export$70b267401ac98961(warningCallback) {
    $d337f08bfbdbd736$var$_warningCallback = warningCallback;
}


/**
 * Sets the current RTL value.
 */ function $96e333458f0e6a00$export$64006deca925fb65(isRTL) {
    if ($96e333458f0e6a00$var$_rtl !== isRTL) $96e333458f0e6a00$var$_rtl = isRTL;
}
function $96e333458f0e6a00$export$b2303637e9533380() {
    if ($96e333458f0e6a00$var$_rtl === undefined) $96e333458f0e6a00$var$_rtl = typeof document !== "undefined" && !!document.documentElement && document.documentElement.getAttribute("dir") === "rtl";
    return $96e333458f0e6a00$var$_rtl;
}
// This has been split into 2 lines because it was working in Fabric due to the code being transpiled to es5, so this
// was converted to var while not working in Fluent that uses babel to transpile the code to be es6-like. Splitting the
// logic into two lines, however, allows it to work in both scenarios.
var $96e333458f0e6a00$var$_rtl;
$96e333458f0e6a00$var$_rtl = $96e333458f0e6a00$export$b2303637e9533380();
function $96e333458f0e6a00$export$6c4e12d3949051a() {
    return {
        rtl: $96e333458f0e6a00$export$b2303637e9533380()
    };
}


/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $33314d0661ee64f5$var$extendStatics = function(d, b) {
    $33314d0661ee64f5$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $33314d0661ee64f5$var$extendStatics(d, b);
};
function $33314d0661ee64f5$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $33314d0661ee64f5$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $33314d0661ee64f5$export$18ce0697a983be9b = function() {
    $33314d0661ee64f5$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $33314d0661ee64f5$export$18ce0697a983be9b.apply(this, arguments);
};
function $33314d0661ee64f5$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $33314d0661ee64f5$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $33314d0661ee64f5$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $33314d0661ee64f5$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $33314d0661ee64f5$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $33314d0661ee64f5$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $33314d0661ee64f5$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $33314d0661ee64f5$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $33314d0661ee64f5$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $33314d0661ee64f5$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $33314d0661ee64f5$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $33314d0661ee64f5$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $33314d0661ee64f5$export$45d3717a4c69092e(o, m, p);
}
function $33314d0661ee64f5$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $33314d0661ee64f5$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $33314d0661ee64f5$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($33314d0661ee64f5$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $33314d0661ee64f5$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $33314d0661ee64f5$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $33314d0661ee64f5$export$10c90e4f7922046c(v) {
    return this instanceof $33314d0661ee64f5$export$10c90e4f7922046c ? (this.v = v, this) : new $33314d0661ee64f5$export$10c90e4f7922046c(v);
}
function $33314d0661ee64f5$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $33314d0661ee64f5$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $33314d0661ee64f5$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $33314d0661ee64f5$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $33314d0661ee64f5$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $33314d0661ee64f5$export$19a8beecd37a4c45 === "function" ? $33314d0661ee64f5$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $33314d0661ee64f5$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $33314d0661ee64f5$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function $33314d0661ee64f5$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $33314d0661ee64f5$export$45d3717a4c69092e(result, mod, k);
    }
    $33314d0661ee64f5$var$__setModuleDefault(result, mod);
    return result;
}
function $33314d0661ee64f5$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $33314d0661ee64f5$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $33314d0661ee64f5$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $33314d0661ee64f5$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
var $33314d0661ee64f5$export$2e2bcd8739ae039 = {
    __extends: $33314d0661ee64f5$export$a8ba968b8961cb8a,
    __assign: $33314d0661ee64f5$export$18ce0697a983be9b,
    __rest: $33314d0661ee64f5$export$3c9a16f847548506,
    __decorate: $33314d0661ee64f5$export$29e00dfd3077644b,
    __param: $33314d0661ee64f5$export$d5ad3fd78186038f,
    __metadata: $33314d0661ee64f5$export$f1db080c865becb9,
    __awaiter: $33314d0661ee64f5$export$1050f835b63b671e,
    __generator: $33314d0661ee64f5$export$67ebef60e6f28a6,
    __createBinding: $33314d0661ee64f5$export$45d3717a4c69092e,
    __exportStar: $33314d0661ee64f5$export$f33643c0debef087,
    __values: $33314d0661ee64f5$export$19a8beecd37a4c45,
    __read: $33314d0661ee64f5$export$8d051b38c9118094,
    __spread: $33314d0661ee64f5$export$afc72e2116322959,
    __spreadArrays: $33314d0661ee64f5$export$6388937ca91ccae8,
    __spreadArray: $33314d0661ee64f5$export$1216008129fb82ed,
    __await: $33314d0661ee64f5$export$10c90e4f7922046c,
    __asyncGenerator: $33314d0661ee64f5$export$e427f37a30a4de9b,
    __asyncDelegator: $33314d0661ee64f5$export$bbd80228419bb833,
    __asyncValues: $33314d0661ee64f5$export$e3b29a3d6162315f,
    __makeTemplateObject: $33314d0661ee64f5$export$4fb47efe1390b86f,
    __importStar: $33314d0661ee64f5$export$c21735bcef00d192,
    __importDefault: $33314d0661ee64f5$export$da59b14a69baef04,
    __classPrivateFieldGet: $33314d0661ee64f5$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $33314d0661ee64f5$export$d40a35129aaff81f,
    __classPrivateFieldIn: $33314d0661ee64f5$export$81fdc39f203e4e04
};


var $6d7e31dfb44cf7e4$export$acb42adc2faed244 = {
    /**
     * Avoids style injection, use getRules() to read the styles.
     */ none: 0,
    /**
     * Inserts rules using the insertRule api.
     */ insertNode: 1,
    /**
     * Appends rules using appendChild.
     */ appendChild: 2
};
var $6d7e31dfb44cf7e4$var$STYLESHEET_SETTING = "__stylesheet__";
/**
 * MSIE 11 doesn't cascade styles based on DOM ordering, but rather on the order that each style node
 * is created. As such, to maintain consistent priority, IE11 should reuse a single style node.
 */ var $6d7e31dfb44cf7e4$var$REUSE_STYLE_NODE = typeof navigator !== "undefined" && /rv:11.0/.test(navigator.userAgent);
var $6d7e31dfb44cf7e4$var$_global = {};
// Grab window.
try {
    // Why the cast?
    // if compiled/type checked in same program with `@fluentui/font-icons-mdl2` which extends `Window` on global
    // ( check packages/font-icons-mdl2/src/index.ts ) the definitions don't match! Thus the need of this extra assertion
    $6d7e31dfb44cf7e4$var$_global = window || {};
} catch (_a) {
/* leave as blank object */ }
var $6d7e31dfb44cf7e4$var$_stylesheet;
/**
 * Represents the state of styles registered in the page. Abstracts
 * the surface for adding styles to the stylesheet, exposes helpers
 * for reading the styles registered in server rendered scenarios.
 *
 * @public
 */ var $6d7e31dfb44cf7e4$export$cd02bf5de16fbd7c = /** @class */ function() {
    function Stylesheet(config, serializedStylesheet) {
        var _a, _b, _c, _d, _e, _f;
        this._rules = [];
        this._preservedRules = [];
        this._counter = 0;
        this._keyToClassName = {};
        this._onInsertRuleCallbacks = [];
        this._onResetCallbacks = [];
        this._classNameToArgs = {};
        this._config = (0, $33314d0661ee64f5$export$18ce0697a983be9b)({
            // If there is no document we won't have an element to inject into.
            injectionMode: typeof document === "undefined" ? $6d7e31dfb44cf7e4$export$acb42adc2faed244.none : $6d7e31dfb44cf7e4$export$acb42adc2faed244.insertNode,
            defaultPrefix: "css",
            namespace: undefined,
            cspSettings: undefined
        }, config);
        this._classNameToArgs = (_a = serializedStylesheet === null || serializedStylesheet === void 0 ? void 0 : serializedStylesheet.classNameToArgs) !== null && _a !== void 0 ? _a : this._classNameToArgs;
        this._counter = (_b = serializedStylesheet === null || serializedStylesheet === void 0 ? void 0 : serializedStylesheet.counter) !== null && _b !== void 0 ? _b : this._counter;
        this._keyToClassName = (_d = (_c = this._config.classNameCache) !== null && _c !== void 0 ? _c : serializedStylesheet === null || serializedStylesheet === void 0 ? void 0 : serializedStylesheet.keyToClassName) !== null && _d !== void 0 ? _d : this._keyToClassName;
        this._preservedRules = (_e = serializedStylesheet === null || serializedStylesheet === void 0 ? void 0 : serializedStylesheet.preservedRules) !== null && _e !== void 0 ? _e : this._preservedRules;
        this._rules = (_f = serializedStylesheet === null || serializedStylesheet === void 0 ? void 0 : serializedStylesheet.rules) !== null && _f !== void 0 ? _f : this._rules;
    }
    /**
     * Gets the singleton instance.
     */ Stylesheet.getInstance = function() {
        $6d7e31dfb44cf7e4$var$_stylesheet = $6d7e31dfb44cf7e4$var$_global[$6d7e31dfb44cf7e4$var$STYLESHEET_SETTING];
        if (!$6d7e31dfb44cf7e4$var$_stylesheet || $6d7e31dfb44cf7e4$var$_stylesheet._lastStyleElement && $6d7e31dfb44cf7e4$var$_stylesheet._lastStyleElement.ownerDocument !== document) {
            var fabricConfig = ($6d7e31dfb44cf7e4$var$_global === null || $6d7e31dfb44cf7e4$var$_global === void 0 ? void 0 : $6d7e31dfb44cf7e4$var$_global.FabricConfig) || {};
            var stylesheet = new Stylesheet(fabricConfig.mergeStyles, fabricConfig.serializedStylesheet);
            $6d7e31dfb44cf7e4$var$_stylesheet = stylesheet;
            $6d7e31dfb44cf7e4$var$_global[$6d7e31dfb44cf7e4$var$STYLESHEET_SETTING] = stylesheet;
        }
        return $6d7e31dfb44cf7e4$var$_stylesheet;
    };
    /**
     * Serializes the Stylesheet instance into a format which allows rehydration on creation.
     * @returns string representation of `ISerializedStylesheet` interface.
     */ Stylesheet.prototype.serialize = function() {
        return JSON.stringify({
            classNameToArgs: this._classNameToArgs,
            counter: this._counter,
            keyToClassName: this._keyToClassName,
            preservedRules: this._preservedRules,
            rules: this._rules
        });
    };
    /**
     * Configures the stylesheet.
     */ Stylesheet.prototype.setConfig = function(config) {
        this._config = (0, $33314d0661ee64f5$export$18ce0697a983be9b)((0, $33314d0661ee64f5$export$18ce0697a983be9b)({}, this._config), config);
    };
    /**
     * Configures a reset callback.
     *
     * @param callback - A callback which will be called when the Stylesheet is reset.
     * @returns function which when called un-registers provided callback.
     */ Stylesheet.prototype.onReset = function(callback) {
        var _this = this;
        this._onResetCallbacks.push(callback);
        return function() {
            _this._onResetCallbacks = _this._onResetCallbacks.filter(function(cb) {
                return cb !== callback;
            });
        };
    };
    /**
     * Configures an insert rule callback.
     *
     * @param callback - A callback which will be called when a rule is inserted.
     * @returns function which when called un-registers provided callback.
     */ Stylesheet.prototype.onInsertRule = function(callback) {
        var _this = this;
        this._onInsertRuleCallbacks.push(callback);
        return function() {
            _this._onInsertRuleCallbacks = _this._onInsertRuleCallbacks.filter(function(cb) {
                return cb !== callback;
            });
        };
    };
    /**
     * Generates a unique classname.
     *
     * @param displayName - Optional value to use as a prefix.
     */ Stylesheet.prototype.getClassName = function(displayName) {
        var namespace = this._config.namespace;
        var prefix = displayName || this._config.defaultPrefix;
        return "".concat(namespace ? namespace + "-" : "").concat(prefix, "-").concat(this._counter++);
    };
    /**
     * Used internally to cache information about a class which was
     * registered with the stylesheet.
     */ Stylesheet.prototype.cacheClassName = function(className, key, args, rules) {
        this._keyToClassName[key] = className;
        this._classNameToArgs[className] = {
            args: args,
            rules: rules
        };
    };
    /**
     * Gets the appropriate classname given a key which was previously
     * registered using cacheClassName.
     */ Stylesheet.prototype.classNameFromKey = function(key) {
        return this._keyToClassName[key];
    };
    /**
     * Gets all classnames cache with the stylesheet.
     */ Stylesheet.prototype.getClassNameCache = function() {
        return this._keyToClassName;
    };
    /**
     * Gets the arguments associated with a given classname which was
     * previously registered using cacheClassName.
     */ Stylesheet.prototype.argsFromClassName = function(className) {
        var entry = this._classNameToArgs[className];
        return entry && entry.args;
    };
    /**
     * Gets the rules associated with a given classname which was
     * previously registered using cacheClassName.
     */ Stylesheet.prototype.insertedRulesFromClassName = function(className) {
        var entry = this._classNameToArgs[className];
        return entry && entry.rules;
    };
    /**
     * Inserts a css rule into the stylesheet.
     * @param preserve - Preserves the rule beyond a reset boundary.
     */ Stylesheet.prototype.insertRule = function(rule, preserve) {
        var injectionMode = this._config.injectionMode;
        var element = injectionMode !== $6d7e31dfb44cf7e4$export$acb42adc2faed244.none ? this._getStyleElement() : undefined;
        if (preserve) this._preservedRules.push(rule);
        if (element) switch(injectionMode){
            case $6d7e31dfb44cf7e4$export$acb42adc2faed244.insertNode:
                var sheet = element.sheet;
                try {
                    sheet.insertRule(rule, sheet.cssRules.length);
                } catch (e) {
                // The browser will throw exceptions on unsupported rules (such as a moz prefix in webkit.)
                // We need to swallow the exceptions for this scenario, otherwise we'd need to filter
                // which could be slower and bulkier.
                }
                break;
            case $6d7e31dfb44cf7e4$export$acb42adc2faed244.appendChild:
                element.appendChild(document.createTextNode(rule));
                break;
        }
        else this._rules.push(rule);
        // eslint-disable-next-line deprecation/deprecation
        if (this._config.onInsertRule) // eslint-disable-next-line deprecation/deprecation
        this._config.onInsertRule(rule);
        this._onInsertRuleCallbacks.forEach(function(callback) {
            return callback();
        });
    };
    /**
     * Gets all rules registered with the stylesheet; only valid when
     * using InsertionMode.none.
     */ Stylesheet.prototype.getRules = function(includePreservedRules) {
        return (includePreservedRules ? this._preservedRules.join("") : "") + this._rules.join("");
    };
    /**
     * Resets the internal state of the stylesheet. Only used in server
     * rendered scenarios where we're using InsertionMode.none.
     */ Stylesheet.prototype.reset = function() {
        this._rules = [];
        this._counter = 0;
        this._classNameToArgs = {};
        this._keyToClassName = {};
        this._onResetCallbacks.forEach(function(callback) {
            return callback();
        });
    };
    // Forces the regeneration of incoming styles without totally resetting the stylesheet.
    Stylesheet.prototype.resetKeys = function() {
        this._keyToClassName = {};
    };
    Stylesheet.prototype._getStyleElement = function() {
        var _this = this;
        if (!this._styleElement && typeof document !== "undefined") {
            this._styleElement = this._createStyleElement();
            if (!$6d7e31dfb44cf7e4$var$REUSE_STYLE_NODE) // Reset the style element on the next frame.
            window.requestAnimationFrame(function() {
                _this._styleElement = undefined;
            });
        }
        return this._styleElement;
    };
    Stylesheet.prototype._createStyleElement = function() {
        var head = document.head;
        var styleElement = document.createElement("style");
        var nodeToInsertBefore = null;
        styleElement.setAttribute("data-merge-styles", "true");
        var cspSettings = this._config.cspSettings;
        if (cspSettings) {
            if (cspSettings.nonce) styleElement.setAttribute("nonce", cspSettings.nonce);
        }
        if (this._lastStyleElement) // If the `nextElementSibling` is null, then the insertBefore will act as a regular append.
        // https://developer.mozilla.org/en-US/docs/Web/API/Node/insertBefore#Syntax
        nodeToInsertBefore = this._lastStyleElement.nextElementSibling;
        else {
            var placeholderStyleTag = this._findPlaceholderStyleTag();
            if (placeholderStyleTag) nodeToInsertBefore = placeholderStyleTag.nextElementSibling;
            else nodeToInsertBefore = head.childNodes[0];
        }
        head.insertBefore(styleElement, head.contains(nodeToInsertBefore) ? nodeToInsertBefore : null);
        this._lastStyleElement = styleElement;
        return styleElement;
    };
    Stylesheet.prototype._findPlaceholderStyleTag = function() {
        var head = document.head;
        if (head) return head.querySelector("style[data-merge-styles]");
        return null;
    };
    return Stylesheet;
}();




var $673926cee7115029$var$rules = {};
function $673926cee7115029$export$81a4f1c533782259(rulePairs, index) {
    var rule = rulePairs[index];
    if (rule.charAt(0) !== "-") rulePairs[index] = $673926cee7115029$var$rules[rule] = $673926cee7115029$var$rules[rule] || rule.replace(/([A-Z])/g, "-$1").toLowerCase();
}


var $fc95008e0bd70aea$var$_vendorSettings;
function $fc95008e0bd70aea$export$80b0e239f56c8c7d() {
    var _a;
    if (!$fc95008e0bd70aea$var$_vendorSettings) {
        var doc = typeof document !== "undefined" ? document : undefined;
        var nav = typeof navigator !== "undefined" ? navigator : undefined;
        var userAgent = (_a = nav === null || nav === void 0 ? void 0 : nav.userAgent) === null || _a === void 0 ? void 0 : _a.toLowerCase();
        if (!doc) $fc95008e0bd70aea$var$_vendorSettings = {
            isWebkit: true,
            isMoz: true,
            isOpera: true,
            isMs: true
        };
        else $fc95008e0bd70aea$var$_vendorSettings = {
            isWebkit: !!(doc && "WebkitAppearance" in doc.documentElement.style),
            isMoz: !!(userAgent && userAgent.indexOf("firefox") > -1),
            isOpera: !!(userAgent && userAgent.indexOf("opera") > -1),
            isMs: !!(nav && (/rv:11.0/i.test(nav.userAgent) || /Edge\/\d./i.test(navigator.userAgent)))
        };
    }
    return $fc95008e0bd70aea$var$_vendorSettings;
}
function $fc95008e0bd70aea$export$9f7e3c53560dab05(vendorSettings) {
    $fc95008e0bd70aea$var$_vendorSettings = vendorSettings;
}


var $3ab8d6ef4d356354$var$autoPrefixNames = {
    "user-select": 1
};
function $3ab8d6ef4d356354$export$6c6679cd94cc8e5a(rulePairs, index) {
    var vendorSettings = (0, $fc95008e0bd70aea$export$80b0e239f56c8c7d)();
    var name = rulePairs[index];
    if ($3ab8d6ef4d356354$var$autoPrefixNames[name]) {
        var value = rulePairs[index + 1];
        if ($3ab8d6ef4d356354$var$autoPrefixNames[name]) {
            if (vendorSettings.isWebkit) rulePairs.push("-webkit-" + name, value);
            if (vendorSettings.isMoz) rulePairs.push("-moz-" + name, value);
            if (vendorSettings.isMs) rulePairs.push("-ms-" + name, value);
            if (vendorSettings.isOpera) rulePairs.push("-o-" + name, value);
        }
    }
}


var $5abae14ffb3e4a64$var$NON_PIXEL_NUMBER_PROPS = [
    "column-count",
    "font-weight",
    "flex",
    "flex-grow",
    "flex-shrink",
    "fill-opacity",
    "opacity",
    "order",
    "z-index",
    "zoom"
];
function $5abae14ffb3e4a64$export$4d98e579c8cf34c8(rulePairs, index) {
    var name = rulePairs[index];
    var value = rulePairs[index + 1];
    if (typeof value === "number") {
        var isNonPixelProp = $5abae14ffb3e4a64$var$NON_PIXEL_NUMBER_PROPS.indexOf(name) > -1;
        var isVariableOrPrefixed = name.indexOf("--") > -1;
        var unit = isNonPixelProp || isVariableOrPrefixed ? "" : "px";
        rulePairs[index + 1] = "".concat(value).concat(unit);
    }
}


var $0842560a9363e6b6$var$_a;
var $0842560a9363e6b6$var$LEFT = "left";
var $0842560a9363e6b6$var$RIGHT = "right";
var $0842560a9363e6b6$var$NO_FLIP = "@noflip";
var $0842560a9363e6b6$var$NAME_REPLACEMENTS = ($0842560a9363e6b6$var$_a = {}, $0842560a9363e6b6$var$_a[$0842560a9363e6b6$var$LEFT] = $0842560a9363e6b6$var$RIGHT, $0842560a9363e6b6$var$_a[$0842560a9363e6b6$var$RIGHT] = $0842560a9363e6b6$var$LEFT, $0842560a9363e6b6$var$_a);
var $0842560a9363e6b6$var$VALUE_REPLACEMENTS = {
    "w-resize": "e-resize",
    "sw-resize": "se-resize",
    "nw-resize": "ne-resize"
};
function $0842560a9363e6b6$export$79e12f79f6fb4537(options, rulePairs, index) {
    if (options.rtl) {
        var name_1 = rulePairs[index];
        if (!name_1) return;
        var value = rulePairs[index + 1];
        if (typeof value === "string" && value.indexOf($0842560a9363e6b6$var$NO_FLIP) >= 0) rulePairs[index + 1] = value.replace(/\s*(?:\/\*\s*)?\@noflip\b(?:\s*\*\/)?\s*?/g, "");
        else if (name_1.indexOf($0842560a9363e6b6$var$LEFT) >= 0) rulePairs[index] = name_1.replace($0842560a9363e6b6$var$LEFT, $0842560a9363e6b6$var$RIGHT);
        else if (name_1.indexOf($0842560a9363e6b6$var$RIGHT) >= 0) rulePairs[index] = name_1.replace($0842560a9363e6b6$var$RIGHT, $0842560a9363e6b6$var$LEFT);
        else if (String(value).indexOf($0842560a9363e6b6$var$LEFT) >= 0) rulePairs[index + 1] = value.replace($0842560a9363e6b6$var$LEFT, $0842560a9363e6b6$var$RIGHT);
        else if (String(value).indexOf($0842560a9363e6b6$var$RIGHT) >= 0) rulePairs[index + 1] = value.replace($0842560a9363e6b6$var$RIGHT, $0842560a9363e6b6$var$LEFT);
        else if ($0842560a9363e6b6$var$NAME_REPLACEMENTS[name_1]) rulePairs[index] = $0842560a9363e6b6$var$NAME_REPLACEMENTS[name_1];
        else if ($0842560a9363e6b6$var$VALUE_REPLACEMENTS[value]) rulePairs[index + 1] = $0842560a9363e6b6$var$VALUE_REPLACEMENTS[value];
        else switch(name_1){
            case "margin":
            case "padding":
                rulePairs[index + 1] = $0842560a9363e6b6$var$flipQuad(value);
                break;
            case "box-shadow":
                rulePairs[index + 1] = $0842560a9363e6b6$var$negateNum(value, 0);
                break;
        }
    }
}
/**
 * Given a string value in a space delimited format (e.g. "1 2 3 4"), negates a particular value.
 */ function $0842560a9363e6b6$var$negateNum(value, partIndex) {
    var parts = value.split(" ");
    var numberVal = parseInt(parts[partIndex], 10);
    parts[0] = parts[0].replace(String(numberVal), String(numberVal * -1));
    return parts.join(" ");
}
/**
 * Given a string quad, flips the left and right values.
 */ function $0842560a9363e6b6$var$flipQuad(value) {
    if (typeof value === "string") {
        var parts = value.split(" ");
        if (parts.length === 4) return "".concat(parts[0], " ").concat(parts[3], " ").concat(parts[2], " ").concat(parts[1]);
    }
    return value;
}


/**
 * Split a string into tokens separated by whitespace, except all text within parentheses
 * is treated as a single token (whitespace is ignored within parentheses).
 *
 * Unlike String.split(' '), multiple consecutive space characters are collapsed and
 * removed from the returned array (including leading and trailing spaces).
 *
 * For example:
 * `tokenizeWithParentheses("3px calc(var(--x) / 2) 9px    0 ")`
 *   => `["3px", "calc(var(--x) / 2)", "9px", "0"]`
 *
 * @returns The array of tokens. Returns an empty array if the string was empty or contained only whitespace.
 */ function $0eccdb1d59fff073$export$73b82e713dad971(value) {
    var parts = [];
    var partStart = 0;
    var parens = 0;
    for(var i = 0; i < value.length; i++)switch(value[i]){
        case "(":
            parens++;
            break;
        case ")":
            if (parens) parens--;
            break;
        case "	":
        case " ":
            if (!parens) {
                // Add the new part if it's not an empty string
                if (i > partStart) parts.push(value.substring(partStart, i));
                partStart = i + 1;
            }
            break;
    }
    // Add the last part
    if (partStart < value.length) parts.push(value.substring(partStart));
    return parts;
}


var $2b75e2556a0a5b7f$var$DISPLAY_NAME = "displayName";
function $2b75e2556a0a5b7f$var$getDisplayName(rules) {
    var rootStyle = rules && rules["&"];
    return rootStyle ? rootStyle.displayName : undefined;
}
var $2b75e2556a0a5b7f$var$globalSelectorRegExp = /\:global\((.+?)\)/g;
/**
 * Finds comma separated selectors in a :global() e.g. ":global(.class1, .class2, .class3)"
 * and wraps them each in their own global ":global(.class1), :global(.class2), :global(.class3)"
 *
 * @param selectorWithGlobals The selector to process
 * @returns The updated selector
 */ function $2b75e2556a0a5b7f$var$expandCommaSeparatedGlobals(selectorWithGlobals) {
    // We the selector does not have a :global() we can shortcut
    if (!$2b75e2556a0a5b7f$var$globalSelectorRegExp.test(selectorWithGlobals)) return selectorWithGlobals;
    var replacementInfo = [];
    var findGlobal = /\:global\((.+?)\)/g;
    var match = null;
    // Create a result list for global selectors so we can replace them.
    while(match = findGlobal.exec(selectorWithGlobals))// Only if the found selector is a comma separated list we'll process it.
    if (match[1].indexOf(",") > -1) replacementInfo.push([
        match.index,
        match.index + match[0].length,
        // Wrap each of the found selectors in :global()
        match[1].split(",").map(function(v) {
            return ":global(".concat(v.trim(), ")");
        }).join(", ")
    ]);
    // Replace the found selectors with their wrapped variants in reverse order
    return replacementInfo.reverse().reduce(function(selector, _a) {
        var matchIndex = _a[0], matchEndIndex = _a[1], replacement = _a[2];
        var prefix = selector.slice(0, matchIndex);
        var suffix = selector.slice(matchEndIndex);
        return prefix + replacement + suffix;
    }, selectorWithGlobals);
}
function $2b75e2556a0a5b7f$var$expandSelector(newSelector, currentSelector) {
    if (newSelector.indexOf(":global(") >= 0) return newSelector.replace($2b75e2556a0a5b7f$var$globalSelectorRegExp, "$1");
    else if (newSelector.indexOf(":") === 0) return currentSelector + newSelector;
    else if (newSelector.indexOf("&") < 0) return currentSelector + " " + newSelector;
    return newSelector;
}
function $2b75e2556a0a5b7f$var$extractSelector(currentSelector, rules, selector, value) {
    if (rules === void 0) rules = {
        __order: []
    };
    if (selector.indexOf("@") === 0) {
        selector = selector + "{" + currentSelector;
        $2b75e2556a0a5b7f$var$extractRules([
            value
        ], rules, selector);
    } else if (selector.indexOf(",") > -1) $2b75e2556a0a5b7f$var$expandCommaSeparatedGlobals(selector).split(",").map(function(s) {
        return s.trim();
    }).forEach(function(separatedSelector) {
        return $2b75e2556a0a5b7f$var$extractRules([
            value
        ], rules, $2b75e2556a0a5b7f$var$expandSelector(separatedSelector, currentSelector));
    });
    else $2b75e2556a0a5b7f$var$extractRules([
        value
    ], rules, $2b75e2556a0a5b7f$var$expandSelector(selector, currentSelector));
}
function $2b75e2556a0a5b7f$var$extractRules(args, rules, currentSelector) {
    if (rules === void 0) rules = {
        __order: []
    };
    if (currentSelector === void 0) currentSelector = "&";
    var stylesheet = (0, $6d7e31dfb44cf7e4$export$cd02bf5de16fbd7c).getInstance();
    var currentRules = rules[currentSelector];
    if (!currentRules) {
        currentRules = {};
        rules[currentSelector] = currentRules;
        rules.__order.push(currentSelector);
    }
    for(var _i = 0, args_1 = args; _i < args_1.length; _i++){
        var arg = args_1[_i];
        // If the arg is a string, we need to look up the class map and merge.
        if (typeof arg === "string") {
            var expandedRules = stylesheet.argsFromClassName(arg);
            if (expandedRules) $2b75e2556a0a5b7f$var$extractRules(expandedRules, rules, currentSelector);
        // Else if the arg is an array, we need to recurse in.
        } else if (Array.isArray(arg)) $2b75e2556a0a5b7f$var$extractRules(arg, rules, currentSelector);
        else {
            for(var prop in arg)if (arg.hasOwnProperty(prop)) {
                var propValue = arg[prop];
                if (prop === "selectors") {
                    // every child is a selector.
                    var selectors = arg.selectors;
                    for(var newSelector in selectors)if (selectors.hasOwnProperty(newSelector)) $2b75e2556a0a5b7f$var$extractSelector(currentSelector, rules, newSelector, selectors[newSelector]);
                } else if (typeof propValue === "object") // prop is a selector.
                {
                    if (propValue !== null) $2b75e2556a0a5b7f$var$extractSelector(currentSelector, rules, prop, propValue);
                } else if (propValue !== undefined) {
                    // Else, add the rule to the currentSelector.
                    if (prop === "margin" || prop === "padding") $2b75e2556a0a5b7f$var$expandQuads(currentRules, prop, propValue);
                    else currentRules[prop] = propValue;
                }
            }
        }
    }
    return rules;
}
function $2b75e2556a0a5b7f$var$expandQuads(currentRules, name, value) {
    var parts = typeof value === "string" ? (0, $0eccdb1d59fff073$export$73b82e713dad971)(value) : [
        value
    ];
    if (parts.length === 0) parts.push(value);
    if (parts[parts.length - 1] === "!important") // Remove !important from parts, and append it to each part individually
    parts = parts.slice(0, -1).map(function(p) {
        return p + " !important";
    });
    currentRules[name + "Top"] = parts[0];
    currentRules[name + "Right"] = parts[1] || parts[0];
    currentRules[name + "Bottom"] = parts[2] || parts[0];
    currentRules[name + "Left"] = parts[3] || parts[1] || parts[0];
}
function $2b75e2556a0a5b7f$var$getKeyForRules(options, rules) {
    var serialized = [
        options.rtl ? "rtl" : "ltr"
    ];
    var hasProps = false;
    for(var _i = 0, _a = rules.__order; _i < _a.length; _i++){
        var selector = _a[_i];
        serialized.push(selector);
        var rulesForSelector = rules[selector];
        for(var propName in rulesForSelector)if (rulesForSelector.hasOwnProperty(propName) && rulesForSelector[propName] !== undefined) {
            hasProps = true;
            serialized.push(propName, rulesForSelector[propName]);
        }
    }
    return hasProps ? serialized.join("") : undefined;
}
function $2b75e2556a0a5b7f$var$repeatString(target, count) {
    if (count <= 0) return "";
    if (count === 1) return target;
    return target + $2b75e2556a0a5b7f$var$repeatString(target, count - 1);
}
function $2b75e2556a0a5b7f$export$4080b13ebe249c61(options, ruleEntries) {
    if (!ruleEntries) return "";
    var allEntries = [];
    for(var entry in ruleEntries)if (ruleEntries.hasOwnProperty(entry) && entry !== $2b75e2556a0a5b7f$var$DISPLAY_NAME && ruleEntries[entry] !== undefined) allEntries.push(entry, ruleEntries[entry]);
    // Apply transforms.
    for(var i = 0; i < allEntries.length; i += 2){
        (0, $673926cee7115029$export$81a4f1c533782259)(allEntries, i);
        (0, $5abae14ffb3e4a64$export$4d98e579c8cf34c8)(allEntries, i);
        (0, $0842560a9363e6b6$export$79e12f79f6fb4537)(options, allEntries, i);
        (0, $3ab8d6ef4d356354$export$6c6679cd94cc8e5a)(allEntries, i);
    }
    // Apply punctuation.
    for(var i = 1; i < allEntries.length; i += 4)allEntries.splice(i, 1, ":", allEntries[i], ";");
    return allEntries.join("");
}
function $2b75e2556a0a5b7f$export$f51c5a57f5409a02(options) {
    var args = [];
    for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
    var rules = $2b75e2556a0a5b7f$var$extractRules(args);
    var key = $2b75e2556a0a5b7f$var$getKeyForRules(options, rules);
    if (key) {
        var stylesheet = (0, $6d7e31dfb44cf7e4$export$cd02bf5de16fbd7c).getInstance();
        var registration = {
            className: stylesheet.classNameFromKey(key),
            key: key,
            args: args
        };
        if (!registration.className) {
            registration.className = stylesheet.getClassName($2b75e2556a0a5b7f$var$getDisplayName(rules));
            var rulesToInsert = [];
            for(var _a = 0, _b = rules.__order; _a < _b.length; _a++){
                var selector = _b[_a];
                rulesToInsert.push(selector, $2b75e2556a0a5b7f$export$4080b13ebe249c61(options, rules[selector]));
            }
            registration.rulesToInsert = rulesToInsert;
        }
        return registration;
    }
    return undefined;
}
function $2b75e2556a0a5b7f$export$cf30abcc7f4a413c(registration, specificityMultiplier) {
    if (specificityMultiplier === void 0) specificityMultiplier = 1;
    var stylesheet = (0, $6d7e31dfb44cf7e4$export$cd02bf5de16fbd7c).getInstance();
    var className = registration.className, key = registration.key, args = registration.args, rulesToInsert = registration.rulesToInsert;
    if (rulesToInsert) {
        // rulesToInsert is an ordered array of selector/rule pairs.
        for(var i = 0; i < rulesToInsert.length; i += 2){
            var rules = rulesToInsert[i + 1];
            if (rules) {
                var selector = rulesToInsert[i];
                selector = selector.replace(/&/g, $2b75e2556a0a5b7f$var$repeatString(".".concat(registration.className), specificityMultiplier));
                // Insert. Note if a media query, we must close the query with a final bracket.
                var processedRule = "".concat(selector, "{").concat(rules, "}").concat(selector.indexOf("@") === 0 ? "}" : "");
                stylesheet.insertRule(processedRule);
            }
        }
        stylesheet.cacheClassName(className, key, args, rulesToInsert);
    }
}
function $2b75e2556a0a5b7f$export$40e90054d98a04a(options) {
    var args = [];
    for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
    var registration = $2b75e2556a0a5b7f$export$f51c5a57f5409a02.apply(void 0, (0, $33314d0661ee64f5$export$1216008129fb82ed)([
        options
    ], args, false));
    if (registration) {
        $2b75e2556a0a5b7f$export$cf30abcc7f4a413c(registration, options.specificityMultiplier);
        return registration.className;
    }
    return "";
}


function $2bb15913561d0e25$export$566c6c2ff0443c7(font) {
    var stylesheet = (0, $6d7e31dfb44cf7e4$export$cd02bf5de16fbd7c).getInstance();
    var rule = (0, $2b75e2556a0a5b7f$export$4080b13ebe249c61)((0, $96e333458f0e6a00$export$6c4e12d3949051a)(), font);
    var className = stylesheet.classNameFromKey(rule);
    if (className) return;
    var name = stylesheet.getClassName();
    stylesheet.insertRule("@font-face{".concat(rule, "}"), true);
    stylesheet.cacheClassName(name, rule, [], [
        "font-face",
        rule
    ]);
}


function $07383d36d312ff17$export$b1c01d3d68dc0b88() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    var classes = [];
    var objects = [];
    var stylesheet = (0, $6d7e31dfb44cf7e4$export$cd02bf5de16fbd7c).getInstance();
    function _processArgs(argsList) {
        for(var _i = 0, argsList_1 = argsList; _i < argsList_1.length; _i++){
            var arg = argsList_1[_i];
            if (arg) {
                if (typeof arg === "string") {
                    if (arg.indexOf(" ") >= 0) _processArgs(arg.split(" "));
                    else {
                        var translatedArgs = stylesheet.argsFromClassName(arg);
                        if (translatedArgs) _processArgs(translatedArgs);
                        else // Avoid adding the same class twice.
                        if (classes.indexOf(arg) === -1) classes.push(arg);
                    }
                } else if (Array.isArray(arg)) _processArgs(arg);
                else if (typeof arg === "object") objects.push(arg);
            }
        }
    }
    _processArgs(args);
    return {
        classes: classes,
        objects: objects
    };
}




function $28e9f889cecb6636$export$e618dc39ac9ad607() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    return $28e9f889cecb6636$export$f77a3199de250644(args, (0, $96e333458f0e6a00$export$6c4e12d3949051a)());
}
function $28e9f889cecb6636$export$f77a3199de250644(args, options) {
    var styleArgs = args instanceof Array ? args : [
        args
    ];
    var _a = (0, $07383d36d312ff17$export$b1c01d3d68dc0b88)(styleArgs), classes = _a.classes, objects = _a.objects;
    if (objects.length) classes.push((0, $2b75e2556a0a5b7f$export$40e90054d98a04a)(options || {}, objects));
    return classes.join(" ");
}


var $44598dd284782b17$var$ICON_SETTING_NAME = "icons";
var $44598dd284782b17$var$_iconSettings = (0, $f115fbba50f668f9$export$e962ef7984a884aa).getValue($44598dd284782b17$var$ICON_SETTING_NAME, {
    __options: {
        disableWarnings: false,
        warnOnMissingIcons: true
    },
    __remapped: {}
});
// Reset icon registration on stylesheet resets.
var $44598dd284782b17$var$stylesheet = (0, $6d7e31dfb44cf7e4$export$cd02bf5de16fbd7c).getInstance();
if ($44598dd284782b17$var$stylesheet && $44598dd284782b17$var$stylesheet.onReset) $44598dd284782b17$var$stylesheet.onReset(function() {
    for(var name_1 in $44598dd284782b17$var$_iconSettings)if ($44598dd284782b17$var$_iconSettings.hasOwnProperty(name_1) && !!$44598dd284782b17$var$_iconSettings[name_1].subset) $44598dd284782b17$var$_iconSettings[name_1].subset.className = undefined;
});
/**
 * Normalizes an icon name for consistent mapping.
 * Current implementation is to convert the icon name to lower case.
 *
 * @param name - Icon name to normalize.
 * @returns {string} Normalized icon name to use for indexing and mapping.
 */ var $44598dd284782b17$var$normalizeIconName = function(name) {
    return name.toLowerCase();
};
function $44598dd284782b17$export$99b432e1290ef823(iconSubset, options) {
    var subset = (0, $b1c38fba2c0065a7$export$18ce0697a983be9b)((0, $b1c38fba2c0065a7$export$18ce0697a983be9b)({}, iconSubset), {
        isRegistered: false,
        className: undefined
    });
    var icons = iconSubset.icons;
    // Grab options, optionally mix user provided ones on top.
    options = options ? (0, $b1c38fba2c0065a7$export$18ce0697a983be9b)((0, $b1c38fba2c0065a7$export$18ce0697a983be9b)({}, $44598dd284782b17$var$_iconSettings.__options), options) : $44598dd284782b17$var$_iconSettings.__options;
    for(var iconName in icons)if (icons.hasOwnProperty(iconName)) {
        var code = icons[iconName];
        var normalizedIconName = $44598dd284782b17$var$normalizeIconName(iconName);
        if ($44598dd284782b17$var$_iconSettings[normalizedIconName]) $44598dd284782b17$var$_warnDuplicateIcon(iconName);
        else $44598dd284782b17$var$_iconSettings[normalizedIconName] = {
            code: code,
            subset: subset
        };
    }
}
function $44598dd284782b17$export$d4eb2d2d2a4efe94(iconNames) {
    var options = $44598dd284782b17$var$_iconSettings.__options;
    var _loop_1 = function(iconName) {
        var normalizedIconName = $44598dd284782b17$var$normalizeIconName(iconName);
        if ($44598dd284782b17$var$_iconSettings[normalizedIconName]) delete $44598dd284782b17$var$_iconSettings[normalizedIconName];
        else // Warn that we are trying to delete an icon that doesn't exist
        if (!options.disableWarnings) (0, $d337f08bfbdbd736$export$c106dd0671a0fc2d)('The icon "'.concat(iconName, '" tried to unregister but was not registered.'));
        // Delete any aliases for this iconName
        if ($44598dd284782b17$var$_iconSettings.__remapped[normalizedIconName]) delete $44598dd284782b17$var$_iconSettings.__remapped[normalizedIconName];
        // Delete any items that were an alias for this iconName
        Object.keys($44598dd284782b17$var$_iconSettings.__remapped).forEach(function(key) {
            if ($44598dd284782b17$var$_iconSettings.__remapped[key] === normalizedIconName) delete $44598dd284782b17$var$_iconSettings.__remapped[key];
        });
    };
    for(var _i = 0, iconNames_1 = iconNames; _i < iconNames_1.length; _i++){
        var iconName = iconNames_1[_i];
        _loop_1(iconName);
    }
}
function $44598dd284782b17$export$4fad376c7613260(iconName, mappedToName) {
    $44598dd284782b17$var$_iconSettings.__remapped[$44598dd284782b17$var$normalizeIconName(iconName)] = $44598dd284782b17$var$normalizeIconName(mappedToName);
}
function $44598dd284782b17$export$16b26cd5e98d9100(name) {
    var icon = undefined;
    var options = $44598dd284782b17$var$_iconSettings.__options;
    name = name ? $44598dd284782b17$var$normalizeIconName(name) : "";
    name = $44598dd284782b17$var$_iconSettings.__remapped[name] || name;
    if (name) {
        icon = $44598dd284782b17$var$_iconSettings[name];
        if (icon) {
            var subset = icon.subset;
            if (subset && subset.fontFace) {
                if (!subset.isRegistered) {
                    (0, $2bb15913561d0e25$export$566c6c2ff0443c7)(subset.fontFace);
                    subset.isRegistered = true;
                }
                if (!subset.className) subset.className = (0, $28e9f889cecb6636$export$e618dc39ac9ad607)(subset.style, {
                    fontFamily: subset.fontFace.fontFamily,
                    fontWeight: subset.fontFace.fontWeight || "normal",
                    fontStyle: subset.fontFace.fontStyle || "normal"
                });
            }
        } else // eslint-disable-next-line deprecation/deprecation
        if (!options.disableWarnings && options.warnOnMissingIcons) (0, $d337f08bfbdbd736$export$c106dd0671a0fc2d)('The icon "'.concat(name, '" was used but not registered. See https://github.com/microsoft/fluentui/wiki/Using-icons for more information.'));
    }
    return icon;
}
function $44598dd284782b17$export$931896f68834c675(options) {
    $44598dd284782b17$var$_iconSettings.__options = (0, $b1c38fba2c0065a7$export$18ce0697a983be9b)((0, $b1c38fba2c0065a7$export$18ce0697a983be9b)({}, $44598dd284782b17$var$_iconSettings.__options), options);
}
var $44598dd284782b17$var$_missingIcons = [];
var $44598dd284782b17$var$_missingIconsTimer = undefined;
function $44598dd284782b17$var$_warnDuplicateIcon(iconName) {
    var options = $44598dd284782b17$var$_iconSettings.__options;
    var warningDelay = 2000;
    var maxIconsInMessage = 10;
    if (!options.disableWarnings) {
        $44598dd284782b17$var$_missingIcons.push(iconName);
        if ($44598dd284782b17$var$_missingIconsTimer === undefined) $44598dd284782b17$var$_missingIconsTimer = setTimeout(function() {
            (0, $d337f08bfbdbd736$export$c106dd0671a0fc2d)("Some icons were re-registered. Applications should only call registerIcons for any given icon once. Redefining what an icon is may have unintended consequences. Duplicates include: \n" + $44598dd284782b17$var$_missingIcons.slice(0, maxIconsInMessage).join(", ") + ($44598dd284782b17$var$_missingIcons.length > maxIconsInMessage ? " (+ ".concat($44598dd284782b17$var$_missingIcons.length - maxIconsInMessage, " more)") : ""));
            $44598dd284782b17$var$_missingIconsTimer = undefined;
            $44598dd284782b17$var$_missingIcons = [];
        }, warningDelay);
    }
}




var $16e0681304e1db17$export$61818e3b2f7b5d12 = "https://res.cdn.office.net/files/fabric-cdn-prod_20230524.001";


// Do not modify this file; it is generated as part of publish.
// The checked in version is a placeholder only and will not be updated.
// A packages cache that makes sure that we don't inject the same packageName twice in the same bundle -
// this cache is local to the module closure inside this bundle
var $886f0d32cc24089c$var$packagesCache = {};
// Cache access to window to avoid IE11 memory leak.
var $886f0d32cc24089c$var$_win = undefined;
try {
    $886f0d32cc24089c$var$_win = window;
} catch (e) {
/* no-op */ }
function $886f0d32cc24089c$export$f99c3c9c04cda7ae(packageName, packageVersion) {
    if (typeof $886f0d32cc24089c$var$_win !== "undefined") {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        var packages = $886f0d32cc24089c$var$_win.__packages__ = $886f0d32cc24089c$var$_win.__packages__ || {};
        // We allow either the global packages or local packages caches to invalidate so testing can
        // just clear the global to set this state
        if (!packages[packageName] || !$886f0d32cc24089c$var$packagesCache[packageName]) {
            $886f0d32cc24089c$var$packagesCache[packageName] = packageVersion;
            var versions = packages[packageName] = packages[packageName] || [];
            versions.push(packageVersion);
        }
    }
}


(0, $886f0d32cc24089c$export$f99c3c9c04cda7ae)("@fluentui/set-version", "6.0.0");


(0, $886f0d32cc24089c$export$f99c3c9c04cda7ae)("@fluentui/style-utilities", "8.9.14");



/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $0dcf9eba0ca41477$var$extendStatics = function(d, b) {
    $0dcf9eba0ca41477$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $0dcf9eba0ca41477$var$extendStatics(d, b);
};
function $0dcf9eba0ca41477$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $0dcf9eba0ca41477$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $0dcf9eba0ca41477$export$18ce0697a983be9b = function() {
    $0dcf9eba0ca41477$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $0dcf9eba0ca41477$export$18ce0697a983be9b.apply(this, arguments);
};
function $0dcf9eba0ca41477$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $0dcf9eba0ca41477$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $0dcf9eba0ca41477$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $0dcf9eba0ca41477$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $0dcf9eba0ca41477$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $0dcf9eba0ca41477$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $0dcf9eba0ca41477$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $0dcf9eba0ca41477$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $0dcf9eba0ca41477$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $0dcf9eba0ca41477$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $0dcf9eba0ca41477$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $0dcf9eba0ca41477$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $0dcf9eba0ca41477$export$45d3717a4c69092e(o, m, p);
}
function $0dcf9eba0ca41477$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $0dcf9eba0ca41477$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $0dcf9eba0ca41477$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($0dcf9eba0ca41477$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $0dcf9eba0ca41477$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $0dcf9eba0ca41477$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $0dcf9eba0ca41477$export$10c90e4f7922046c(v) {
    return this instanceof $0dcf9eba0ca41477$export$10c90e4f7922046c ? (this.v = v, this) : new $0dcf9eba0ca41477$export$10c90e4f7922046c(v);
}
function $0dcf9eba0ca41477$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $0dcf9eba0ca41477$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $0dcf9eba0ca41477$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $0dcf9eba0ca41477$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $0dcf9eba0ca41477$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $0dcf9eba0ca41477$export$19a8beecd37a4c45 === "function" ? $0dcf9eba0ca41477$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $0dcf9eba0ca41477$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $0dcf9eba0ca41477$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function $0dcf9eba0ca41477$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $0dcf9eba0ca41477$export$45d3717a4c69092e(result, mod, k);
    }
    $0dcf9eba0ca41477$var$__setModuleDefault(result, mod);
    return result;
}
function $0dcf9eba0ca41477$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $0dcf9eba0ca41477$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $0dcf9eba0ca41477$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $0dcf9eba0ca41477$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
var $0dcf9eba0ca41477$export$2e2bcd8739ae039 = {
    __extends: $0dcf9eba0ca41477$export$a8ba968b8961cb8a,
    __assign: $0dcf9eba0ca41477$export$18ce0697a983be9b,
    __rest: $0dcf9eba0ca41477$export$3c9a16f847548506,
    __decorate: $0dcf9eba0ca41477$export$29e00dfd3077644b,
    __param: $0dcf9eba0ca41477$export$d5ad3fd78186038f,
    __metadata: $0dcf9eba0ca41477$export$f1db080c865becb9,
    __awaiter: $0dcf9eba0ca41477$export$1050f835b63b671e,
    __generator: $0dcf9eba0ca41477$export$67ebef60e6f28a6,
    __createBinding: $0dcf9eba0ca41477$export$45d3717a4c69092e,
    __exportStar: $0dcf9eba0ca41477$export$f33643c0debef087,
    __values: $0dcf9eba0ca41477$export$19a8beecd37a4c45,
    __read: $0dcf9eba0ca41477$export$8d051b38c9118094,
    __spread: $0dcf9eba0ca41477$export$afc72e2116322959,
    __spreadArrays: $0dcf9eba0ca41477$export$6388937ca91ccae8,
    __spreadArray: $0dcf9eba0ca41477$export$1216008129fb82ed,
    __await: $0dcf9eba0ca41477$export$10c90e4f7922046c,
    __asyncGenerator: $0dcf9eba0ca41477$export$e427f37a30a4de9b,
    __asyncDelegator: $0dcf9eba0ca41477$export$bbd80228419bb833,
    __asyncValues: $0dcf9eba0ca41477$export$e3b29a3d6162315f,
    __makeTemplateObject: $0dcf9eba0ca41477$export$4fb47efe1390b86f,
    __importStar: $0dcf9eba0ca41477$export$c21735bcef00d192,
    __importDefault: $0dcf9eba0ca41477$export$da59b14a69baef04,
    __classPrivateFieldGet: $0dcf9eba0ca41477$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $0dcf9eba0ca41477$export$d40a35129aaff81f,
    __classPrivateFieldIn: $0dcf9eba0ca41477$export$81fdc39f203e4e04
};



var $4f645c8fd987e645$var$CustomizationsGlobalKey = "customizations";
var $4f645c8fd987e645$var$NO_CUSTOMIZATIONS = {
    settings: {},
    scopedSettings: {},
    inCustomizerContext: false
};
var $4f645c8fd987e645$var$_allSettings = (0, $f115fbba50f668f9$export$e962ef7984a884aa).getValue($4f645c8fd987e645$var$CustomizationsGlobalKey, {
    settings: {},
    scopedSettings: {},
    inCustomizerContext: false
});
var $4f645c8fd987e645$var$_events = [];
var $4f645c8fd987e645$export$cbb5b5586292cdb = /** @class */ function() {
    function Customizations() {}
    Customizations.reset = function() {
        $4f645c8fd987e645$var$_allSettings.settings = {};
        $4f645c8fd987e645$var$_allSettings.scopedSettings = {};
    };
    /** Apply global Customization settings.
     * @example Customizations.applySettings(\{ theme: \{...\} \});
     */ Customizations.applySettings = function(settings) {
        $4f645c8fd987e645$var$_allSettings.settings = (0, $0dcf9eba0ca41477$export$18ce0697a983be9b)((0, $0dcf9eba0ca41477$export$18ce0697a983be9b)({}, $4f645c8fd987e645$var$_allSettings.settings), settings);
        Customizations._raiseChange();
    };
    /** Apply Customizations to a particular named scope, like a component.
     * @example Customizations.applyScopedSettings('Nav', \{ styles: () =\> \{\} \});
     */ Customizations.applyScopedSettings = function(scopeName, settings) {
        $4f645c8fd987e645$var$_allSettings.scopedSettings[scopeName] = (0, $0dcf9eba0ca41477$export$18ce0697a983be9b)((0, $0dcf9eba0ca41477$export$18ce0697a983be9b)({}, $4f645c8fd987e645$var$_allSettings.scopedSettings[scopeName]), settings);
        Customizations._raiseChange();
    };
    Customizations.getSettings = function(properties, scopeName, localSettings) {
        if (localSettings === void 0) localSettings = $4f645c8fd987e645$var$NO_CUSTOMIZATIONS;
        var settings = {};
        var localScopedSettings = scopeName && localSettings.scopedSettings[scopeName] || {};
        var globalScopedSettings = scopeName && $4f645c8fd987e645$var$_allSettings.scopedSettings[scopeName] || {};
        for(var _i = 0, properties_1 = properties; _i < properties_1.length; _i++){
            var property = properties_1[_i];
            settings[property] = localScopedSettings[property] || localSettings.settings[property] || globalScopedSettings[property] || $4f645c8fd987e645$var$_allSettings.settings[property];
        }
        return settings;
    };
    /** Used to run some code that sets Customizations without triggering an update until the end.
     * Useful for applying Customizations that don't affect anything currently rendered, or for
     * applying many customizations at once.
     * @param suppressUpdate - Do not raise the change event at the end, preventing all updates
     */ Customizations.applyBatchedUpdates = function(code, suppressUpdate) {
        Customizations._suppressUpdates = true;
        try {
            code();
        } catch (_a) {
        /* do nothing */ }
        Customizations._suppressUpdates = false;
        if (!suppressUpdate) Customizations._raiseChange();
    };
    Customizations.observe = function(onChange) {
        $4f645c8fd987e645$var$_events.push(onChange);
    };
    Customizations.unobserve = function(onChange) {
        $4f645c8fd987e645$var$_events = $4f645c8fd987e645$var$_events.filter(function(cb) {
            return cb !== onChange;
        });
    };
    Customizations._raiseChange = function() {
        if (!Customizations._suppressUpdates) $4f645c8fd987e645$var$_events.forEach(function(cb) {
            return cb();
        });
    };
    return Customizations;
}();


var $82c9985af4073ce0$exports = {};

$parcel$export($82c9985af4073ce0$exports, "loadTheme", () => $82c9985af4073ce0$export$a1d87755f3c9500d);
// Copyright (c) Microsoft Corporation. All rights reserved. Licensed under the MIT license.
// See LICENSE in the project root for license information.
var $82c9985af4073ce0$var$__assign = undefined && undefined.__assign || function() {
    $82c9985af4073ce0$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $82c9985af4073ce0$var$__assign.apply(this, arguments);
};
// Store the theming state in __themeState__ global scope for reuse in the case of duplicate
// load-themed-styles hosted on the page.
var $82c9985af4073ce0$var$_root = typeof window === "undefined" ? $parcel$global : window; // eslint-disable-line @typescript-eslint/no-explicit-any
// Nonce string to inject into script tag if one provided. This is used in CSP (Content Security Policy).
var $82c9985af4073ce0$var$_styleNonce = $82c9985af4073ce0$var$_root && $82c9985af4073ce0$var$_root.CSPSettings && $82c9985af4073ce0$var$_root.CSPSettings.nonce;
var $82c9985af4073ce0$var$_themeState = $82c9985af4073ce0$var$initializeThemeState();
/**
 * Matches theming tokens. For example, "[theme: themeSlotName, default: #FFF]" (including the quotes).
 */ var $82c9985af4073ce0$var$_themeTokenRegex = /[\'\"]\[theme:\s*(\w+)\s*(?:\,\s*default:\s*([\\"\']?[\.\,\(\)\#\-\s\w]*[\.\,\(\)\#\-\w][\"\']?))?\s*\][\'\"]/g;
var $82c9985af4073ce0$var$now = function() {
    return typeof performance !== "undefined" && !!performance.now ? performance.now() : Date.now();
};
function $82c9985af4073ce0$var$measure(func) {
    var start = $82c9985af4073ce0$var$now();
    func();
    var end = $82c9985af4073ce0$var$now();
    $82c9985af4073ce0$var$_themeState.perf.duration += end - start;
}
/**
 * initialize global state object
 */ function $82c9985af4073ce0$var$initializeThemeState() {
    var state = $82c9985af4073ce0$var$_root.__themeState__ || {
        theme: undefined,
        lastStyleElement: undefined,
        registeredStyles: []
    };
    if (!state.runState) state = $82c9985af4073ce0$var$__assign($82c9985af4073ce0$var$__assign({}, state), {
        perf: {
            count: 0,
            duration: 0
        },
        runState: {
            flushTimer: 0,
            mode: 0 /* Mode.sync */ ,
            buffer: []
        }
    });
    if (!state.registeredThemableStyles) state = $82c9985af4073ce0$var$__assign($82c9985af4073ce0$var$__assign({}, state), {
        registeredThemableStyles: []
    });
    $82c9985af4073ce0$var$_root.__themeState__ = state;
    return state;
}
function $82c9985af4073ce0$export$277cf3cf4a1518cd(styles, loadAsync) {
    if (loadAsync === void 0) loadAsync = false;
    $82c9985af4073ce0$var$measure(function() {
        var styleParts = Array.isArray(styles) ? styles : $82c9985af4073ce0$export$bb01df06f2c55008(styles);
        var _a = $82c9985af4073ce0$var$_themeState.runState, mode = _a.mode, buffer = _a.buffer, flushTimer = _a.flushTimer;
        if (loadAsync || mode === 1 /* Mode.async */ ) {
            buffer.push(styleParts);
            if (!flushTimer) $82c9985af4073ce0$var$_themeState.runState.flushTimer = $82c9985af4073ce0$var$asyncLoadStyles();
        } else $82c9985af4073ce0$var$applyThemableStyles(styleParts);
    });
}
function $82c9985af4073ce0$export$181b9c90f55ff807(loadStylesFn) {
    $82c9985af4073ce0$var$_themeState.loadStyles = loadStylesFn;
}
function $82c9985af4073ce0$export$116c501adb0c3234(mode) {
    $82c9985af4073ce0$var$_themeState.runState.mode = mode;
}
function $82c9985af4073ce0$export$4909b86c8034bf73() {
    $82c9985af4073ce0$var$measure(function() {
        var styleArrays = $82c9985af4073ce0$var$_themeState.runState.buffer.slice();
        $82c9985af4073ce0$var$_themeState.runState.buffer = [];
        var mergedStyleArray = [].concat.apply([], styleArrays);
        if (mergedStyleArray.length > 0) $82c9985af4073ce0$var$applyThemableStyles(mergedStyleArray);
    });
}
/**
 * register async loadStyles
 */ function $82c9985af4073ce0$var$asyncLoadStyles() {
    return setTimeout(function() {
        $82c9985af4073ce0$var$_themeState.runState.flushTimer = 0;
        $82c9985af4073ce0$export$4909b86c8034bf73();
    }, 0);
}
/**
 * Loads a set of style text. If it is registered too early, we will register it when the window.load event
 * is fired.
 * @param {string} styleText Style to register.
 * @param {IStyleRecord} styleRecord Existing style record to re-apply.
 */ function $82c9985af4073ce0$var$applyThemableStyles(stylesArray, styleRecord) {
    if ($82c9985af4073ce0$var$_themeState.loadStyles) $82c9985af4073ce0$var$_themeState.loadStyles($82c9985af4073ce0$var$resolveThemableArray(stylesArray).styleString, stylesArray);
    else $82c9985af4073ce0$var$registerStyles(stylesArray);
}
function $82c9985af4073ce0$export$a1d87755f3c9500d(theme) {
    $82c9985af4073ce0$var$_themeState.theme = theme;
    // reload styles.
    $82c9985af4073ce0$var$reloadStyles();
}
function $82c9985af4073ce0$export$537f61d53c932351(option) {
    if (option === void 0) option = 3 /* ClearStyleOptions.all */ ;
    if (option === 3 /* ClearStyleOptions.all */  || option === 2 /* ClearStyleOptions.onlyNonThemable */ ) {
        $82c9985af4073ce0$var$clearStylesInternal($82c9985af4073ce0$var$_themeState.registeredStyles);
        $82c9985af4073ce0$var$_themeState.registeredStyles = [];
    }
    if (option === 3 /* ClearStyleOptions.all */  || option === 1 /* ClearStyleOptions.onlyThemable */ ) {
        $82c9985af4073ce0$var$clearStylesInternal($82c9985af4073ce0$var$_themeState.registeredThemableStyles);
        $82c9985af4073ce0$var$_themeState.registeredThemableStyles = [];
    }
}
function $82c9985af4073ce0$var$clearStylesInternal(records) {
    records.forEach(function(styleRecord) {
        var styleElement = styleRecord && styleRecord.styleElement;
        if (styleElement && styleElement.parentElement) styleElement.parentElement.removeChild(styleElement);
    });
}
/**
 * Reloads styles.
 */ function $82c9985af4073ce0$var$reloadStyles() {
    if ($82c9985af4073ce0$var$_themeState.theme) {
        var themableStyles = [];
        for(var _i = 0, _a = $82c9985af4073ce0$var$_themeState.registeredThemableStyles; _i < _a.length; _i++){
            var styleRecord = _a[_i];
            themableStyles.push(styleRecord.themableStyle);
        }
        if (themableStyles.length > 0) {
            $82c9985af4073ce0$export$537f61d53c932351(1 /* ClearStyleOptions.onlyThemable */ );
            $82c9985af4073ce0$var$applyThemableStyles([].concat.apply([], themableStyles));
        }
    }
}
function $82c9985af4073ce0$export$208ca8297aba2218(styles) {
    if (styles) styles = $82c9985af4073ce0$var$resolveThemableArray($82c9985af4073ce0$export$bb01df06f2c55008(styles)).styleString;
    return styles;
}
/**
 * Resolves ThemingInstruction objects in an array and joins the result into a string.
 * @param {ThemableArray} splitStyleArray ThemableArray to resolve and join.
 */ function $82c9985af4073ce0$var$resolveThemableArray(splitStyleArray) {
    var theme = $82c9985af4073ce0$var$_themeState.theme;
    var themable = false;
    // Resolve the array of theming instructions to an array of strings.
    // Then join the array to produce the final CSS string.
    var resolvedArray = (splitStyleArray || []).map(function(currentValue) {
        var themeSlot = currentValue.theme;
        if (themeSlot) {
            themable = true;
            // A theming annotation. Resolve it.
            var themedValue = theme ? theme[themeSlot] : undefined;
            var defaultValue = currentValue.defaultValue || "inherit";
            // Warn to console if we hit an unthemed value even when themes are provided, but only if "DEBUG" is true.
            // Allow the themedValue to be undefined to explicitly request the default value.
            if (theme && !themedValue && console && !(themeSlot in theme) && typeof DEBUG !== "undefined" && DEBUG) console.warn('Theming value not provided for "'.concat(themeSlot, '". Falling back to "').concat(defaultValue, '".'));
            return themedValue || defaultValue;
        } else // A non-themable string. Preserve it.
        return currentValue.rawString;
    });
    return {
        styleString: resolvedArray.join(""),
        themable: themable
    };
}
function $82c9985af4073ce0$export$bb01df06f2c55008(styles) {
    var result = [];
    if (styles) {
        var pos = 0; // Current position in styles.
        var tokenMatch = void 0;
        while(tokenMatch = $82c9985af4073ce0$var$_themeTokenRegex.exec(styles)){
            var matchIndex = tokenMatch.index;
            if (matchIndex > pos) result.push({
                rawString: styles.substring(pos, matchIndex)
            });
            result.push({
                theme: tokenMatch[1],
                defaultValue: tokenMatch[2] // May be undefined
            });
            // index of the first character after the current match
            pos = $82c9985af4073ce0$var$_themeTokenRegex.lastIndex;
        }
        // Push the rest of the string after the last match.
        result.push({
            rawString: styles.substring(pos)
        });
    }
    return result;
}
/**
 * Registers a set of style text. If it is registered too early, we will register it when the
 * window.load event is fired.
 * @param {ThemableArray} styleArray Array of IThemingInstruction objects to register.
 * @param {IStyleRecord} styleRecord May specify a style Element to update.
 */ function $82c9985af4073ce0$var$registerStyles(styleArray) {
    if (typeof document === "undefined") return;
    var head = document.getElementsByTagName("head")[0];
    var styleElement = document.createElement("style");
    var _a = $82c9985af4073ce0$var$resolveThemableArray(styleArray), styleString = _a.styleString, themable = _a.themable;
    styleElement.setAttribute("data-load-themed-styles", "true");
    if ($82c9985af4073ce0$var$_styleNonce) styleElement.setAttribute("nonce", $82c9985af4073ce0$var$_styleNonce);
    styleElement.appendChild(document.createTextNode(styleString));
    $82c9985af4073ce0$var$_themeState.perf.count++;
    head.appendChild(styleElement);
    var ev = document.createEvent("HTMLEvents");
    ev.initEvent("styleinsert", true, false);
    ev.args = {
        newStyle: styleElement
    };
    document.dispatchEvent(ev);
    var record = {
        styleElement: styleElement,
        themableStyle: styleArray
    };
    if (themable) $82c9985af4073ce0$var$_themeState.registeredThemableStyles.push(record);
    else $82c9985af4073ce0$var$_themeState.registeredStyles.push(record);
}


// When adding or removing a color, make sure you keep this consistent with IColorClassNames
// by adding the color variants.
var $75934eec2dece75a$export$109c1b21def6ffa4 = {
    themeDarker: "#004578",
    themeDark: "#005a9e",
    themeDarkAlt: "#106ebe",
    themePrimary: "#0078d4",
    themeSecondary: "#2b88d8",
    themeTertiary: "#71afe5",
    themeLight: "#c7e0f4",
    themeLighter: "#deecf9",
    themeLighterAlt: "#eff6fc",
    black: "#000000",
    blackTranslucent40: "rgba(0,0,0,.4)",
    neutralDark: "#201f1e",
    neutralPrimary: "#323130",
    neutralPrimaryAlt: "#3b3a39",
    neutralSecondary: "#605e5c",
    neutralSecondaryAlt: "#8a8886",
    neutralTertiary: "#a19f9d",
    neutralTertiaryAlt: "#c8c6c4",
    neutralQuaternary: "#d2d0ce",
    neutralQuaternaryAlt: "#e1dfdd",
    neutralLight: "#edebe9",
    neutralLighter: "#f3f2f1",
    neutralLighterAlt: "#faf9f8",
    accent: "#0078d4",
    white: "#ffffff",
    whiteTranslucent40: "rgba(255,255,255,.4)",
    yellowDark: "#d29200",
    yellow: "#ffb900",
    yellowLight: "#fff100",
    orange: "#d83b01",
    orangeLight: "#ea4300",
    orangeLighter: "#ff8c00",
    redDark: "#a4262c",
    red: "#e81123",
    magentaDark: "#5c005c",
    magenta: "#b4009e",
    magentaLight: "#e3008c",
    purpleDark: "#32145a",
    purple: "#5c2d91",
    purpleLight: "#b4a0ff",
    blueDark: "#002050",
    blueMid: "#00188f",
    blue: "#0078d4",
    blueLight: "#00bcf2",
    tealDark: "#004b50",
    teal: "#008272",
    tealLight: "#00b294",
    greenDark: "#004b1c",
    green: "#107c10",
    greenLight: "#bad80a"
};


var $f7566a4f14ce9d5d$export$9b00c83187ceb0d1;
(function(Depths) {
    Depths.depth0 = "0 0 0 0 transparent";
    Depths.depth4 = "0 1.6px 3.6px 0 rgba(0, 0, 0, 0.132), 0 0.3px 0.9px 0 rgba(0, 0, 0, 0.108)";
    Depths.depth8 = "0 3.2px 7.2px 0 rgba(0, 0, 0, 0.132), 0 0.6px 1.8px 0 rgba(0, 0, 0, 0.108)";
    Depths.depth16 = "0 6.4px 14.4px 0 rgba(0, 0, 0, 0.132), 0 1.2px 3.6px 0 rgba(0, 0, 0, 0.108)";
    Depths.depth64 = "0 25.6px 57.6px 0 rgba(0, 0, 0, 0.22), 0 4.8px 14.4px 0 rgba(0, 0, 0, 0.18)";
})($f7566a4f14ce9d5d$export$9b00c83187ceb0d1 || ($f7566a4f14ce9d5d$export$9b00c83187ceb0d1 = {}));


var $127ed105ff1331cb$export$1b052b16bf67042a = {
    elevation4: (0, $f7566a4f14ce9d5d$export$9b00c83187ceb0d1).depth4,
    elevation8: (0, $f7566a4f14ce9d5d$export$9b00c83187ceb0d1).depth8,
    elevation16: (0, $f7566a4f14ce9d5d$export$9b00c83187ceb0d1).depth16,
    elevation64: (0, $f7566a4f14ce9d5d$export$9b00c83187ceb0d1).depth64,
    roundedCorner2: "2px",
    roundedCorner4: "4px",
    roundedCorner6: "6px"
};



// Font face names to be registered.
var $05d8966a4db14fbe$export$ed6682c3a2de350f;
(function(LocalizedFontNames) {
    LocalizedFontNames.Arabic = "Segoe UI Web (Arabic)";
    LocalizedFontNames.Cyrillic = "Segoe UI Web (Cyrillic)";
    LocalizedFontNames.EastEuropean = "Segoe UI Web (East European)";
    LocalizedFontNames.Greek = "Segoe UI Web (Greek)";
    LocalizedFontNames.Hebrew = "Segoe UI Web (Hebrew)";
    LocalizedFontNames.Thai = "Leelawadee UI Web";
    LocalizedFontNames.Vietnamese = "Segoe UI Web (Vietnamese)";
    LocalizedFontNames.WestEuropean = "Segoe UI Web (West European)";
    LocalizedFontNames.Selawik = "Selawik Web";
    LocalizedFontNames.Armenian = "Segoe UI Web (Armenian)";
    LocalizedFontNames.Georgian = "Segoe UI Web (Georgian)";
})($05d8966a4db14fbe$export$ed6682c3a2de350f || ($05d8966a4db14fbe$export$ed6682c3a2de350f = {}));
var $05d8966a4db14fbe$export$a84f0633d5188de4;
(function(LocalizedFontFamilies) {
    LocalizedFontFamilies.Arabic = "'".concat($05d8966a4db14fbe$export$ed6682c3a2de350f.Arabic, "'");
    LocalizedFontFamilies.ChineseSimplified = "'Microsoft Yahei UI', Verdana, Simsun";
    LocalizedFontFamilies.ChineseTraditional = "'Microsoft Jhenghei UI', Pmingliu";
    LocalizedFontFamilies.Cyrillic = "'".concat($05d8966a4db14fbe$export$ed6682c3a2de350f.Cyrillic, "'");
    LocalizedFontFamilies.EastEuropean = "'".concat($05d8966a4db14fbe$export$ed6682c3a2de350f.EastEuropean, "'");
    LocalizedFontFamilies.Greek = "'".concat($05d8966a4db14fbe$export$ed6682c3a2de350f.Greek, "'");
    LocalizedFontFamilies.Hebrew = "'".concat($05d8966a4db14fbe$export$ed6682c3a2de350f.Hebrew, "'");
    LocalizedFontFamilies.Hindi = "'Nirmala UI'";
    LocalizedFontFamilies.Japanese = "'Yu Gothic UI', 'Meiryo UI', Meiryo, 'MS Pgothic', Osaka";
    LocalizedFontFamilies.Korean = "'Malgun Gothic', Gulim";
    LocalizedFontFamilies.Selawik = "'".concat($05d8966a4db14fbe$export$ed6682c3a2de350f.Selawik, "'");
    LocalizedFontFamilies.Thai = "'Leelawadee UI Web', 'Kmer UI'";
    LocalizedFontFamilies.Vietnamese = "'".concat($05d8966a4db14fbe$export$ed6682c3a2de350f.Vietnamese, "'");
    LocalizedFontFamilies.WestEuropean = "'".concat($05d8966a4db14fbe$export$ed6682c3a2de350f.WestEuropean, "'");
    LocalizedFontFamilies.Armenian = "'".concat($05d8966a4db14fbe$export$ed6682c3a2de350f.Armenian, "'");
    LocalizedFontFamilies.Georgian = "'".concat($05d8966a4db14fbe$export$ed6682c3a2de350f.Georgian, "'");
})($05d8966a4db14fbe$export$a84f0633d5188de4 || ($05d8966a4db14fbe$export$a84f0633d5188de4 = {}));
var $05d8966a4db14fbe$export$f2bd2ec6ef52693e;
(function(FontSizes) {
    FontSizes.size10 = "10px";
    FontSizes.size12 = "12px";
    FontSizes.size14 = "14px";
    FontSizes.size16 = "16px";
    FontSizes.size18 = "18px";
    FontSizes.size20 = "20px";
    FontSizes.size24 = "24px";
    FontSizes.size28 = "28px";
    FontSizes.size32 = "32px";
    FontSizes.size42 = "42px";
    FontSizes.size68 = "68px";
    FontSizes.mini = "10px";
    FontSizes.xSmall = "10px";
    FontSizes.small = "12px";
    FontSizes.smallPlus = "12px";
    FontSizes.medium = "14px";
    FontSizes.mediumPlus = "16px";
    FontSizes.icon = "16px";
    FontSizes.large = "18px";
    FontSizes.xLarge = "20px";
    FontSizes.xLargePlus = "24px";
    FontSizes.xxLarge = "28px";
    FontSizes.xxLargePlus = "32px";
    FontSizes.superLarge = "42px";
    FontSizes.mega = "68px";
})($05d8966a4db14fbe$export$f2bd2ec6ef52693e || ($05d8966a4db14fbe$export$f2bd2ec6ef52693e = {}));
var $05d8966a4db14fbe$export$32743b01f42d159e;
(function(FontWeights) {
    FontWeights.light = 100;
    FontWeights.semilight = 300;
    FontWeights.regular = 400;
    FontWeights.semibold = 600;
    FontWeights.bold = 700;
})($05d8966a4db14fbe$export$32743b01f42d159e || ($05d8966a4db14fbe$export$32743b01f42d159e = {}));
var $05d8966a4db14fbe$export$7f8918a48f5782fd;
(function(IconFontSizes) {
    IconFontSizes.xSmall = "10px";
    IconFontSizes.small = "12px";
    IconFontSizes.medium = "16px";
    IconFontSizes.large = "20px";
})($05d8966a4db14fbe$export$7f8918a48f5782fd || ($05d8966a4db14fbe$export$7f8918a48f5782fd = {}));



// Fallback fonts, if specified system or web fonts are unavailable.
var $6222ef6f5d96fd9d$var$FontFamilyFallbacks = "'Segoe UI', -apple-system, BlinkMacSystemFont, 'Roboto', 'Helvetica Neue', sans-serif";
// By default, we favor system fonts for the default.
// All localized fonts use a web font and never use the system font.
var $6222ef6f5d96fd9d$var$defaultFontFamily = "'Segoe UI', '".concat((0, $05d8966a4db14fbe$export$ed6682c3a2de350f).WestEuropean, "'");
// Mapping of language prefix to to font family.
var $6222ef6f5d96fd9d$var$LanguageToFontMap = {
    ar: (0, $05d8966a4db14fbe$export$a84f0633d5188de4).Arabic,
    bg: (0, $05d8966a4db14fbe$export$a84f0633d5188de4).Cyrillic,
    cs: (0, $05d8966a4db14fbe$export$a84f0633d5188de4).EastEuropean,
    el: (0, $05d8966a4db14fbe$export$a84f0633d5188de4).Greek,
    et: (0, $05d8966a4db14fbe$export$a84f0633d5188de4).EastEuropean,
    he: (0, $05d8966a4db14fbe$export$a84f0633d5188de4).Hebrew,
    hi: (0, $05d8966a4db14fbe$export$a84f0633d5188de4).Hindi,
    hr: (0, $05d8966a4db14fbe$export$a84f0633d5188de4).EastEuropean,
    hu: (0, $05d8966a4db14fbe$export$a84f0633d5188de4).EastEuropean,
    ja: (0, $05d8966a4db14fbe$export$a84f0633d5188de4).Japanese,
    kk: (0, $05d8966a4db14fbe$export$a84f0633d5188de4).EastEuropean,
    ko: (0, $05d8966a4db14fbe$export$a84f0633d5188de4).Korean,
    lt: (0, $05d8966a4db14fbe$export$a84f0633d5188de4).EastEuropean,
    lv: (0, $05d8966a4db14fbe$export$a84f0633d5188de4).EastEuropean,
    pl: (0, $05d8966a4db14fbe$export$a84f0633d5188de4).EastEuropean,
    ru: (0, $05d8966a4db14fbe$export$a84f0633d5188de4).Cyrillic,
    sk: (0, $05d8966a4db14fbe$export$a84f0633d5188de4).EastEuropean,
    "sr-latn": (0, $05d8966a4db14fbe$export$a84f0633d5188de4).EastEuropean,
    th: (0, $05d8966a4db14fbe$export$a84f0633d5188de4).Thai,
    tr: (0, $05d8966a4db14fbe$export$a84f0633d5188de4).EastEuropean,
    uk: (0, $05d8966a4db14fbe$export$a84f0633d5188de4).Cyrillic,
    vi: (0, $05d8966a4db14fbe$export$a84f0633d5188de4).Vietnamese,
    "zh-hans": (0, $05d8966a4db14fbe$export$a84f0633d5188de4).ChineseSimplified,
    "zh-hant": (0, $05d8966a4db14fbe$export$a84f0633d5188de4).ChineseTraditional,
    hy: (0, $05d8966a4db14fbe$export$a84f0633d5188de4).Armenian,
    ka: (0, $05d8966a4db14fbe$export$a84f0633d5188de4).Georgian
};
function $6222ef6f5d96fd9d$var$_fontFamilyWithFallbacks(fontFamily) {
    return "".concat(fontFamily, ", ").concat($6222ef6f5d96fd9d$var$FontFamilyFallbacks);
}
/**
 * If there is a localized font for this language, return that.
 * Returns undefined if there is no localized font for that language.
 */ function $6222ef6f5d96fd9d$var$_getLocalizedFontFamily(language) {
    for(var lang in $6222ef6f5d96fd9d$var$LanguageToFontMap){
        if ($6222ef6f5d96fd9d$var$LanguageToFontMap.hasOwnProperty(lang) && language && lang.indexOf(language) === 0) // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return $6222ef6f5d96fd9d$var$LanguageToFontMap[lang];
    }
    return $6222ef6f5d96fd9d$var$defaultFontFamily;
}
function $6222ef6f5d96fd9d$var$_createFont(size, weight, fontFamily) {
    return {
        fontFamily: fontFamily,
        MozOsxFontSmoothing: "grayscale",
        WebkitFontSmoothing: "antialiased",
        fontSize: size,
        fontWeight: weight
    };
}
function $6222ef6f5d96fd9d$export$a4fa8de6a1c20b63(localeCode) {
    var localizedFont = $6222ef6f5d96fd9d$var$_getLocalizedFontFamily(localeCode);
    var fontFamilyWithFallback = $6222ef6f5d96fd9d$var$_fontFamilyWithFallbacks(localizedFont);
    var fontStyles = {
        tiny: $6222ef6f5d96fd9d$var$_createFont((0, $05d8966a4db14fbe$export$f2bd2ec6ef52693e).mini, (0, $05d8966a4db14fbe$export$32743b01f42d159e).regular, fontFamilyWithFallback),
        xSmall: $6222ef6f5d96fd9d$var$_createFont((0, $05d8966a4db14fbe$export$f2bd2ec6ef52693e).xSmall, (0, $05d8966a4db14fbe$export$32743b01f42d159e).regular, fontFamilyWithFallback),
        small: $6222ef6f5d96fd9d$var$_createFont((0, $05d8966a4db14fbe$export$f2bd2ec6ef52693e).small, (0, $05d8966a4db14fbe$export$32743b01f42d159e).regular, fontFamilyWithFallback),
        smallPlus: $6222ef6f5d96fd9d$var$_createFont((0, $05d8966a4db14fbe$export$f2bd2ec6ef52693e).smallPlus, (0, $05d8966a4db14fbe$export$32743b01f42d159e).regular, fontFamilyWithFallback),
        medium: $6222ef6f5d96fd9d$var$_createFont((0, $05d8966a4db14fbe$export$f2bd2ec6ef52693e).medium, (0, $05d8966a4db14fbe$export$32743b01f42d159e).regular, fontFamilyWithFallback),
        mediumPlus: $6222ef6f5d96fd9d$var$_createFont((0, $05d8966a4db14fbe$export$f2bd2ec6ef52693e).mediumPlus, (0, $05d8966a4db14fbe$export$32743b01f42d159e).regular, fontFamilyWithFallback),
        large: $6222ef6f5d96fd9d$var$_createFont((0, $05d8966a4db14fbe$export$f2bd2ec6ef52693e).large, (0, $05d8966a4db14fbe$export$32743b01f42d159e).regular, fontFamilyWithFallback),
        xLarge: $6222ef6f5d96fd9d$var$_createFont((0, $05d8966a4db14fbe$export$f2bd2ec6ef52693e).xLarge, (0, $05d8966a4db14fbe$export$32743b01f42d159e).semibold, fontFamilyWithFallback),
        xLargePlus: $6222ef6f5d96fd9d$var$_createFont((0, $05d8966a4db14fbe$export$f2bd2ec6ef52693e).xLargePlus, (0, $05d8966a4db14fbe$export$32743b01f42d159e).semibold, fontFamilyWithFallback),
        xxLarge: $6222ef6f5d96fd9d$var$_createFont((0, $05d8966a4db14fbe$export$f2bd2ec6ef52693e).xxLarge, (0, $05d8966a4db14fbe$export$32743b01f42d159e).semibold, fontFamilyWithFallback),
        xxLargePlus: $6222ef6f5d96fd9d$var$_createFont((0, $05d8966a4db14fbe$export$f2bd2ec6ef52693e).xxLargePlus, (0, $05d8966a4db14fbe$export$32743b01f42d159e).semibold, fontFamilyWithFallback),
        superLarge: $6222ef6f5d96fd9d$var$_createFont((0, $05d8966a4db14fbe$export$f2bd2ec6ef52693e).superLarge, (0, $05d8966a4db14fbe$export$32743b01f42d159e).semibold, fontFamilyWithFallback),
        mega: $6222ef6f5d96fd9d$var$_createFont((0, $05d8966a4db14fbe$export$f2bd2ec6ef52693e).mega, (0, $05d8966a4db14fbe$export$32743b01f42d159e).semibold, fontFamilyWithFallback)
    };
    return fontStyles;
}



function $631e53953b675a89$export$f65ca476c09acec0(rootElement) {
    if (!(0, $410af2618185d52d$export$71594e8a50f746f4)() || typeof document === "undefined") return undefined;
    else {
        var el = rootElement;
        return el && el.ownerDocument ? el.ownerDocument : document;
    }
}



function $cfc39cdc240b3d22$export$f92dfeb71e9bb569(key) {
    var result = null;
    try {
        var win = (0, $109c028fea018492$export$38b2d434cce3ea22)();
        result = win ? win.localStorage.getItem(key) : null;
    } catch (e) {
    /* Eat the exception */ }
    return result;
}
function $cfc39cdc240b3d22$export$8a8216c44337cd5(key, data) {
    try {
        var win = (0, $109c028fea018492$export$38b2d434cce3ea22)();
        win && win.localStorage.setItem(key, data);
    } catch (e) {
    /* Eat the exception */ }
}



function $0944ebb06a49e6ce$export$f92dfeb71e9bb569(key) {
    var result = null;
    try {
        var win = (0, $109c028fea018492$export$38b2d434cce3ea22)();
        result = win ? win.sessionStorage.getItem(key) : null;
    } catch (e) {
    /* Eat the exception */ }
    return result;
}
function $0944ebb06a49e6ce$export$8a8216c44337cd5(key, data) {
    var _a;
    try {
        (_a = (0, $109c028fea018492$export$38b2d434cce3ea22)()) === null || _a === void 0 || _a.sessionStorage.setItem(key, data);
    } catch (e) {
    /* Eat the exception */ }
}


// Default to undefined so that we initialize on first read.
var $58719880ab2ee694$var$_language;
var $58719880ab2ee694$var$STORAGE_KEY = "language";
function $58719880ab2ee694$export$64783e31db14f0ba(persistenceType) {
    if (persistenceType === void 0) persistenceType = "sessionStorage";
    if ($58719880ab2ee694$var$_language === undefined) {
        var doc = (0, $631e53953b675a89$export$f65ca476c09acec0)();
        var savedLanguage = persistenceType === "localStorage" ? $cfc39cdc240b3d22$export$f92dfeb71e9bb569($58719880ab2ee694$var$STORAGE_KEY) : persistenceType === "sessionStorage" ? $0944ebb06a49e6ce$export$f92dfeb71e9bb569($58719880ab2ee694$var$STORAGE_KEY) : undefined;
        if (savedLanguage) $58719880ab2ee694$var$_language = savedLanguage;
        if ($58719880ab2ee694$var$_language === undefined && doc) $58719880ab2ee694$var$_language = doc.documentElement.getAttribute("lang");
        if ($58719880ab2ee694$var$_language === undefined) $58719880ab2ee694$var$_language = "en";
    }
    return $58719880ab2ee694$var$_language;
}
function $58719880ab2ee694$export$4b6bf64406ec64af(language, persistenceParam) {
    var doc = (0, $631e53953b675a89$export$f65ca476c09acec0)();
    if (doc) doc.documentElement.setAttribute("lang", language);
    var persistenceType = persistenceParam === true ? "none" : !persistenceParam ? "sessionStorage" : persistenceParam;
    if (persistenceType === "localStorage") $cfc39cdc240b3d22$export$8a8216c44337cd5($58719880ab2ee694$var$STORAGE_KEY, language);
    else if (persistenceType === "sessionStorage") $0944ebb06a49e6ce$export$8a8216c44337cd5($58719880ab2ee694$var$STORAGE_KEY, language);
    $58719880ab2ee694$var$_language = language;
}


// Default urls.
var $97a399499554f854$var$DefaultBaseUrl = "https://res-1.cdn.office.net/files/fabric-cdn-prod_20221209.001/assets";
var $97a399499554f854$export$3d534eec2182c14b = (0, $6222ef6f5d96fd9d$export$a4fa8de6a1c20b63)((0, $58719880ab2ee694$export$64783e31db14f0ba)());
function $97a399499554f854$var$_registerFontFace(fontFamily, url, fontWeight, localFontName) {
    fontFamily = "'".concat(fontFamily, "'");
    var localFontSrc = localFontName !== undefined ? "local('".concat(localFontName, "'),") : "";
    (0, $2bb15913561d0e25$export$566c6c2ff0443c7)({
        fontFamily: fontFamily,
        src: localFontSrc + "url('".concat(url, ".woff2') format('woff2'),") + "url('".concat(url, ".woff') format('woff')"),
        fontWeight: fontWeight,
        fontStyle: "normal",
        fontDisplay: "swap"
    });
}
function $97a399499554f854$var$_registerFontFaceSet(baseUrl, fontFamily, cdnFolder, cdnFontName, localFontName) {
    if (cdnFontName === void 0) cdnFontName = "segoeui";
    var urlBase = "".concat(baseUrl, "/").concat(cdnFolder, "/").concat(cdnFontName);
    $97a399499554f854$var$_registerFontFace(fontFamily, urlBase + "-light", (0, $05d8966a4db14fbe$export$32743b01f42d159e).light, localFontName && localFontName + " Light");
    $97a399499554f854$var$_registerFontFace(fontFamily, urlBase + "-semilight", (0, $05d8966a4db14fbe$export$32743b01f42d159e).semilight, localFontName && localFontName + " SemiLight");
    $97a399499554f854$var$_registerFontFace(fontFamily, urlBase + "-regular", (0, $05d8966a4db14fbe$export$32743b01f42d159e).regular, localFontName);
    $97a399499554f854$var$_registerFontFace(fontFamily, urlBase + "-semibold", (0, $05d8966a4db14fbe$export$32743b01f42d159e).semibold, localFontName && localFontName + " SemiBold");
    $97a399499554f854$var$_registerFontFace(fontFamily, urlBase + "-bold", (0, $05d8966a4db14fbe$export$32743b01f42d159e).bold, localFontName && localFontName + " Bold");
}
function $97a399499554f854$export$1c5ba4c2e362bd9e(baseUrl) {
    if (baseUrl) {
        var fontUrl = "".concat(baseUrl, "/fonts");
        // Produce @font-face definitions for all supported web fonts.
        $97a399499554f854$var$_registerFontFaceSet(fontUrl, (0, $05d8966a4db14fbe$export$ed6682c3a2de350f).Thai, "leelawadeeui-thai", "leelawadeeui");
        $97a399499554f854$var$_registerFontFaceSet(fontUrl, (0, $05d8966a4db14fbe$export$ed6682c3a2de350f).Arabic, "segoeui-arabic");
        $97a399499554f854$var$_registerFontFaceSet(fontUrl, (0, $05d8966a4db14fbe$export$ed6682c3a2de350f).Cyrillic, "segoeui-cyrillic");
        $97a399499554f854$var$_registerFontFaceSet(fontUrl, (0, $05d8966a4db14fbe$export$ed6682c3a2de350f).EastEuropean, "segoeui-easteuropean");
        $97a399499554f854$var$_registerFontFaceSet(fontUrl, (0, $05d8966a4db14fbe$export$ed6682c3a2de350f).Greek, "segoeui-greek");
        $97a399499554f854$var$_registerFontFaceSet(fontUrl, (0, $05d8966a4db14fbe$export$ed6682c3a2de350f).Hebrew, "segoeui-hebrew");
        $97a399499554f854$var$_registerFontFaceSet(fontUrl, (0, $05d8966a4db14fbe$export$ed6682c3a2de350f).Vietnamese, "segoeui-vietnamese");
        $97a399499554f854$var$_registerFontFaceSet(fontUrl, (0, $05d8966a4db14fbe$export$ed6682c3a2de350f).WestEuropean, "segoeui-westeuropean", "segoeui", "Segoe UI");
        $97a399499554f854$var$_registerFontFaceSet(fontUrl, (0, $05d8966a4db14fbe$export$a84f0633d5188de4).Selawik, "selawik", "selawik");
        $97a399499554f854$var$_registerFontFaceSet(fontUrl, (0, $05d8966a4db14fbe$export$ed6682c3a2de350f).Armenian, "segoeui-armenian");
        $97a399499554f854$var$_registerFontFaceSet(fontUrl, (0, $05d8966a4db14fbe$export$ed6682c3a2de350f).Georgian, "segoeui-georgian");
        // Leelawadee UI (Thai) does not have a 'light' weight, so we override
        // the font-face generated above to use the 'semilight' weight instead.
        $97a399499554f854$var$_registerFontFace("Leelawadee UI Web", "".concat(fontUrl, "/leelawadeeui-thai/leelawadeeui-semilight"), (0, $05d8966a4db14fbe$export$32743b01f42d159e).light);
        // Leelawadee UI (Thai) does not have a 'semibold' weight, so we override
        // the font-face generated above to use the 'bold' weight instead.
        $97a399499554f854$var$_registerFontFace("Leelawadee UI Web", "".concat(fontUrl, "/leelawadeeui-thai/leelawadeeui-bold"), (0, $05d8966a4db14fbe$export$32743b01f42d159e).semibold);
    }
}
/**
 * Reads the fontBaseUrl from window.FabricConfig.fontBaseUrl or falls back to a default.
 */ function $97a399499554f854$var$_getFontBaseUrl() {
    var _a, _b;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var fabricConfig = (_a = (0, $109c028fea018492$export$38b2d434cce3ea22)()) === null || _a === void 0 ? void 0 : _a.FabricConfig;
    return (_b = fabricConfig === null || fabricConfig === void 0 ? void 0 : fabricConfig.fontBaseUrl) !== null && _b !== void 0 ? _b : $97a399499554f854$var$DefaultBaseUrl;
}
/**
 * Register the font faces.
 */ $97a399499554f854$export$1c5ba4c2e362bd9e($97a399499554f854$var$_getFontBaseUrl());


/**
 * Simple deep merge function. Takes all arguments and returns a deep copy of the objects merged
 * together in the order provided. If an object creates a circular reference, it will assign the
 * original reference.
 */ function $983cf71e91911571$export$4950aa0f605343fb(target) {
    var args = [];
    for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
    for(var _a = 0, args_1 = args; _a < args_1.length; _a++){
        var arg = args_1[_a];
        $983cf71e91911571$var$_merge(target || {}, arg);
    }
    return target;
}
/**
 * The _merge helper iterates through all props on source and assigns them to target.
 * When the value is an object, we will create a deep clone of the object. However if
 * there is a circular reference, the value will not be deep cloned and will persist
 * the reference.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $983cf71e91911571$var$_merge(target, source, circularReferences) {
    if (circularReferences === void 0) circularReferences = [];
    circularReferences.push(source);
    for(var name_1 in source){
        if (source.hasOwnProperty(name_1)) {
            if (name_1 !== "__proto__" && name_1 !== "constructor" && name_1 !== "prototype") {
                var value = source[name_1];
                if (typeof value === "object" && value !== null && !Array.isArray(value)) {
                    var isCircularReference = circularReferences.indexOf(value) > -1;
                    target[name_1] = isCircularReference ? value : $983cf71e91911571$var$_merge(target[name_1] || {}, value, circularReferences);
                } else target[name_1] = value;
            }
        }
    }
    circularReferences.pop();
    return target;
}


/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $bb41901b3fd3e16e$var$extendStatics = function(d, b) {
    $bb41901b3fd3e16e$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $bb41901b3fd3e16e$var$extendStatics(d, b);
};
function $bb41901b3fd3e16e$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $bb41901b3fd3e16e$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $bb41901b3fd3e16e$export$18ce0697a983be9b = function() {
    $bb41901b3fd3e16e$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $bb41901b3fd3e16e$export$18ce0697a983be9b.apply(this, arguments);
};
function $bb41901b3fd3e16e$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $bb41901b3fd3e16e$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $bb41901b3fd3e16e$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $bb41901b3fd3e16e$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $bb41901b3fd3e16e$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $bb41901b3fd3e16e$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $bb41901b3fd3e16e$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $bb41901b3fd3e16e$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $bb41901b3fd3e16e$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $bb41901b3fd3e16e$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $bb41901b3fd3e16e$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $bb41901b3fd3e16e$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $bb41901b3fd3e16e$export$45d3717a4c69092e(o, m, p);
}
function $bb41901b3fd3e16e$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $bb41901b3fd3e16e$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $bb41901b3fd3e16e$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($bb41901b3fd3e16e$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $bb41901b3fd3e16e$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $bb41901b3fd3e16e$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $bb41901b3fd3e16e$export$10c90e4f7922046c(v) {
    return this instanceof $bb41901b3fd3e16e$export$10c90e4f7922046c ? (this.v = v, this) : new $bb41901b3fd3e16e$export$10c90e4f7922046c(v);
}
function $bb41901b3fd3e16e$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $bb41901b3fd3e16e$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $bb41901b3fd3e16e$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $bb41901b3fd3e16e$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $bb41901b3fd3e16e$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $bb41901b3fd3e16e$export$19a8beecd37a4c45 === "function" ? $bb41901b3fd3e16e$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $bb41901b3fd3e16e$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $bb41901b3fd3e16e$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function $bb41901b3fd3e16e$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $bb41901b3fd3e16e$export$45d3717a4c69092e(result, mod, k);
    }
    $bb41901b3fd3e16e$var$__setModuleDefault(result, mod);
    return result;
}
function $bb41901b3fd3e16e$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $bb41901b3fd3e16e$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $bb41901b3fd3e16e$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $bb41901b3fd3e16e$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
var $bb41901b3fd3e16e$export$2e2bcd8739ae039 = {
    __extends: $bb41901b3fd3e16e$export$a8ba968b8961cb8a,
    __assign: $bb41901b3fd3e16e$export$18ce0697a983be9b,
    __rest: $bb41901b3fd3e16e$export$3c9a16f847548506,
    __decorate: $bb41901b3fd3e16e$export$29e00dfd3077644b,
    __param: $bb41901b3fd3e16e$export$d5ad3fd78186038f,
    __metadata: $bb41901b3fd3e16e$export$f1db080c865becb9,
    __awaiter: $bb41901b3fd3e16e$export$1050f835b63b671e,
    __generator: $bb41901b3fd3e16e$export$67ebef60e6f28a6,
    __createBinding: $bb41901b3fd3e16e$export$45d3717a4c69092e,
    __exportStar: $bb41901b3fd3e16e$export$f33643c0debef087,
    __values: $bb41901b3fd3e16e$export$19a8beecd37a4c45,
    __read: $bb41901b3fd3e16e$export$8d051b38c9118094,
    __spread: $bb41901b3fd3e16e$export$afc72e2116322959,
    __spreadArrays: $bb41901b3fd3e16e$export$6388937ca91ccae8,
    __spreadArray: $bb41901b3fd3e16e$export$1216008129fb82ed,
    __await: $bb41901b3fd3e16e$export$10c90e4f7922046c,
    __asyncGenerator: $bb41901b3fd3e16e$export$e427f37a30a4de9b,
    __asyncDelegator: $bb41901b3fd3e16e$export$bbd80228419bb833,
    __asyncValues: $bb41901b3fd3e16e$export$e3b29a3d6162315f,
    __makeTemplateObject: $bb41901b3fd3e16e$export$4fb47efe1390b86f,
    __importStar: $bb41901b3fd3e16e$export$c21735bcef00d192,
    __importDefault: $bb41901b3fd3e16e$export$da59b14a69baef04,
    __classPrivateFieldGet: $bb41901b3fd3e16e$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $bb41901b3fd3e16e$export$d40a35129aaff81f,
    __classPrivateFieldIn: $bb41901b3fd3e16e$export$81fdc39f203e4e04
};


function $0e63f6b711bb27ee$export$1084519c371c0719(p, e, s, isInverted, depComments) {
    if (depComments === void 0) depComments = false;
    var semanticColors = (0, $bb41901b3fd3e16e$export$18ce0697a983be9b)({
        primaryButtonBorder: "transparent",
        errorText: !isInverted ? "#a4262c" : "#F1707B",
        messageText: !isInverted ? "#323130" : "#F3F2F1",
        messageLink: !isInverted ? "#005A9E" : "#6CB8F6",
        messageLinkHovered: !isInverted ? "#004578" : "#82C7FF",
        infoIcon: !isInverted ? "#605e5c" : "#C8C6C4",
        errorIcon: !isInverted ? "#A80000" : "#F1707B",
        blockingIcon: !isInverted ? "#FDE7E9" : "#442726",
        warningIcon: !isInverted ? "#797775" : "#C8C6C4",
        severeWarningIcon: !isInverted ? "#D83B01" : "#FCE100",
        successIcon: !isInverted ? "#107C10" : "#92C353",
        infoBackground: !isInverted ? "#f3f2f1" : "#323130",
        errorBackground: !isInverted ? "#FDE7E9" : "#442726",
        blockingBackground: !isInverted ? "#FDE7E9" : "#442726",
        warningBackground: !isInverted ? "#FFF4CE" : "#433519",
        severeWarningBackground: !isInverted ? "#FED9CC" : "#4F2A0F",
        successBackground: !isInverted ? "#DFF6DD" : "#393D1B",
        // deprecated
        warningHighlight: !isInverted ? "#ffb900" : "#fff100",
        successText: !isInverted ? "#107C10" : "#92c353"
    }, s);
    var fullSemanticColors = $0e63f6b711bb27ee$export$aca509a1becd8a60(p, e, semanticColors, isInverted);
    return $0e63f6b711bb27ee$var$_fixDeprecatedSlots(fullSemanticColors, depComments);
}
function $0e63f6b711bb27ee$export$aca509a1becd8a60(p, e, s, isInverted, depComments) {
    if (depComments === void 0) depComments = false;
    var result = {};
    // map palette
    var _a = p || {}, white = _a.white, black = _a.black, themePrimary = _a.themePrimary, themeDark = _a.themeDark, themeDarker = _a.themeDarker, themeDarkAlt = _a.themeDarkAlt, themeLighter = _a.themeLighter, neutralLight = _a.neutralLight, neutralLighter = _a.neutralLighter, neutralDark = _a.neutralDark, neutralQuaternary = _a.neutralQuaternary, neutralQuaternaryAlt = _a.neutralQuaternaryAlt, neutralPrimary = _a.neutralPrimary, neutralSecondary = _a.neutralSecondary, neutralSecondaryAlt = _a.neutralSecondaryAlt, neutralTertiary = _a.neutralTertiary, neutralTertiaryAlt = _a.neutralTertiaryAlt, neutralLighterAlt = _a.neutralLighterAlt, accent = _a.accent;
    if (white) {
        result.bodyBackground = white;
        result.bodyFrameBackground = white;
        result.accentButtonText = white;
        result.buttonBackground = white;
        result.primaryButtonText = white;
        result.primaryButtonTextHovered = white;
        result.primaryButtonTextPressed = white;
        result.inputBackground = white;
        result.inputForegroundChecked = white;
        result.listBackground = white;
        result.menuBackground = white;
        result.cardStandoutBackground = white;
    }
    if (black) {
        result.bodyTextChecked = black;
        result.buttonTextCheckedHovered = black;
    }
    if (themePrimary) {
        result.link = themePrimary;
        result.primaryButtonBackground = themePrimary;
        result.inputBackgroundChecked = themePrimary;
        result.inputIcon = themePrimary;
        result.inputFocusBorderAlt = themePrimary;
        result.menuIcon = themePrimary;
        result.menuHeader = themePrimary;
        result.accentButtonBackground = themePrimary;
    }
    if (themeDark) {
        result.primaryButtonBackgroundPressed = themeDark;
        result.inputBackgroundCheckedHovered = themeDark;
        result.inputIconHovered = themeDark;
    }
    if (themeDarker) result.linkHovered = themeDarker;
    if (themeDarkAlt) result.primaryButtonBackgroundHovered = themeDarkAlt;
    if (themeLighter) result.inputPlaceholderBackgroundChecked = themeLighter;
    if (neutralLight) {
        result.bodyBackgroundChecked = neutralLight;
        result.bodyFrameDivider = neutralLight;
        result.bodyDivider = neutralLight;
        result.variantBorder = neutralLight;
        result.buttonBackgroundCheckedHovered = neutralLight;
        result.buttonBackgroundPressed = neutralLight;
        result.listItemBackgroundChecked = neutralLight;
        result.listHeaderBackgroundPressed = neutralLight;
        result.menuItemBackgroundPressed = neutralLight;
        // eslint-disable-next-line deprecation/deprecation
        result.menuItemBackgroundChecked = neutralLight;
    }
    if (neutralLighter) {
        result.bodyBackgroundHovered = neutralLighter;
        result.buttonBackgroundHovered = neutralLighter;
        result.buttonBackgroundDisabled = neutralLighter;
        result.buttonBorderDisabled = neutralLighter;
        result.primaryButtonBackgroundDisabled = neutralLighter;
        result.disabledBackground = neutralLighter;
        result.listItemBackgroundHovered = neutralLighter;
        result.listHeaderBackgroundHovered = neutralLighter;
        result.menuItemBackgroundHovered = neutralLighter;
    }
    if (neutralQuaternary) {
        result.primaryButtonTextDisabled = neutralQuaternary;
        result.disabledSubtext = neutralQuaternary;
    }
    if (neutralQuaternaryAlt) result.listItemBackgroundCheckedHovered = neutralQuaternaryAlt;
    if (neutralTertiary) {
        result.disabledBodyText = neutralTertiary;
        result.variantBorderHovered = (s === null || s === void 0 ? void 0 : s.variantBorderHovered) || neutralTertiary;
        result.buttonTextDisabled = neutralTertiary;
        result.inputIconDisabled = neutralTertiary;
        result.disabledText = neutralTertiary;
    }
    if (neutralPrimary) {
        result.bodyText = neutralPrimary;
        result.actionLink = neutralPrimary;
        result.buttonText = neutralPrimary;
        result.inputBorderHovered = neutralPrimary;
        result.inputText = neutralPrimary;
        result.listText = neutralPrimary;
        result.menuItemText = neutralPrimary;
    }
    if (neutralLighterAlt) {
        result.bodyStandoutBackground = neutralLighterAlt;
        result.defaultStateBackground = neutralLighterAlt;
    }
    if (neutralDark) {
        result.actionLinkHovered = neutralDark;
        result.buttonTextHovered = neutralDark;
        result.buttonTextChecked = neutralDark;
        result.buttonTextPressed = neutralDark;
        result.inputTextHovered = neutralDark;
        result.menuItemTextHovered = neutralDark;
    }
    if (neutralSecondary) {
        result.bodySubtext = neutralSecondary;
        result.focusBorder = neutralSecondary;
        result.inputBorder = neutralSecondary;
        result.smallInputBorder = neutralSecondary;
        result.inputPlaceholderText = neutralSecondary;
    }
    if (neutralSecondaryAlt) result.buttonBorder = neutralSecondaryAlt;
    if (neutralTertiaryAlt) {
        result.disabledBodySubtext = neutralTertiaryAlt;
        result.disabledBorder = neutralTertiaryAlt;
        result.buttonBackgroundChecked = neutralTertiaryAlt;
        result.menuDivider = neutralTertiaryAlt;
    }
    if (accent) result.accentButtonBackground = accent;
    // map effects
    if (e === null || e === void 0 ? void 0 : e.elevation4) result.cardShadow = e.elevation4;
    if (!isInverted && (e === null || e === void 0 ? void 0 : e.elevation8)) result.cardShadowHovered = e.elevation8;
    else if (result.variantBorderHovered) result.cardShadowHovered = "0 0 1px " + result.variantBorderHovered;
    result = (0, $bb41901b3fd3e16e$export$18ce0697a983be9b)((0, $bb41901b3fd3e16e$export$18ce0697a983be9b)({}, result), s);
    return result;
}
function $0e63f6b711bb27ee$var$_fixDeprecatedSlots(s, depComments) {
    // Add @deprecated tag as comment if enabled
    var dep = "";
    if (depComments === true) dep = " /* @deprecated */";
    /* eslint-disable deprecation/deprecation */ s.listTextColor = s.listText + dep;
    s.menuItemBackgroundChecked += dep;
    s.warningHighlight += dep;
    s.warningText = s.messageText + dep;
    s.successText += dep;
    /* eslint-enable deprecation/deprecation */ return s;
}


function $4c8c0e5cfbcfd3cc$export$919aa3481b25eaec(theme, partialTheme) {
    var _a, _b, _c;
    if (partialTheme === void 0) partialTheme = {};
    var mergedTheme = (0, $983cf71e91911571$export$4950aa0f605343fb)({}, theme, partialTheme, {
        semanticColors: (0, $0e63f6b711bb27ee$export$aca509a1becd8a60)(partialTheme.palette, partialTheme.effects, partialTheme.semanticColors, partialTheme.isInverted === undefined ? theme.isInverted : partialTheme.isInverted)
    });
    if (((_a = partialTheme.palette) === null || _a === void 0 ? void 0 : _a.themePrimary) && !((_b = partialTheme.palette) === null || _b === void 0 ? void 0 : _b.accent)) mergedTheme.palette.accent = partialTheme.palette.themePrimary;
    if (partialTheme.defaultFontStyle) for(var _i = 0, _d = Object.keys(mergedTheme.fonts); _i < _d.length; _i++){
        var fontStyle = _d[_i];
        mergedTheme.fonts[fontStyle] = (0, $983cf71e91911571$export$4950aa0f605343fb)(mergedTheme.fonts[fontStyle], partialTheme.defaultFontStyle, (_c = partialTheme === null || partialTheme === void 0 ? void 0 : partialTheme.fonts) === null || _c === void 0 ? void 0 : _c[fontStyle]);
    }
    return mergedTheme;
}


var $34aef0718bbcb646$export$f1e7669f0aafe571 = {
    s2: "4px",
    s1: "8px",
    m: "16px",
    l1: "20px",
    l2: "32px"
};



function $fd3e132738d2e72b$export$25d302a5b900a763(theme, depComments) {
    if (theme === void 0) theme = {};
    if (depComments === void 0) depComments = false;
    var isInverted = !!theme.isInverted;
    var baseTheme = {
        palette: (0, $75934eec2dece75a$export$109c1b21def6ffa4),
        effects: (0, $127ed105ff1331cb$export$1b052b16bf67042a),
        fonts: (0, $97a399499554f854$export$3d534eec2182c14b),
        spacing: (0, $34aef0718bbcb646$export$f1e7669f0aafe571),
        isInverted: isInverted,
        disableGlobalClassNames: false,
        semanticColors: (0, $0e63f6b711bb27ee$export$1084519c371c0719)((0, $75934eec2dece75a$export$109c1b21def6ffa4), (0, $127ed105ff1331cb$export$1b052b16bf67042a), undefined, isInverted, depComments),
        rtl: undefined
    };
    return (0, $4c8c0e5cfbcfd3cc$export$919aa3481b25eaec)(baseTheme, theme);
}


var $a29b06a0c330c050$var$_theme = (0, $fd3e132738d2e72b$export$25d302a5b900a763)({});
var $a29b06a0c330c050$var$_onThemeChangeCallbacks = [];
var $a29b06a0c330c050$export$cf613f78cce4b73f = "theme";
function $a29b06a0c330c050$export$8a248add43552e89() {
    var _a;
    var _b, _c;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var win = (0, $109c028fea018492$export$38b2d434cce3ea22)();
    if ((_b = win === null || win === void 0 ? void 0 : win.FabricConfig) === null || _b === void 0 ? void 0 : _b.legacyTheme) // does everything the `else` clause does and more, such as invoke legacy theming
    $a29b06a0c330c050$export$a1d87755f3c9500d(win.FabricConfig.legacyTheme);
    else if (!(0, $4f645c8fd987e645$export$cbb5b5586292cdb).getSettings([
        $a29b06a0c330c050$export$cf613f78cce4b73f
    ]).theme) {
        if ((_c = win === null || win === void 0 ? void 0 : win.FabricConfig) === null || _c === void 0 ? void 0 : _c.theme) $a29b06a0c330c050$var$_theme = (0, $fd3e132738d2e72b$export$25d302a5b900a763)(win.FabricConfig.theme);
        // Set the default theme.
        (0, $4f645c8fd987e645$export$cbb5b5586292cdb).applySettings((_a = {}, _a[$a29b06a0c330c050$export$cf613f78cce4b73f] = $a29b06a0c330c050$var$_theme, _a));
    }
}
$a29b06a0c330c050$export$8a248add43552e89();
function $a29b06a0c330c050$export$89cbf1a0881c8b9c(depComments) {
    if (depComments === void 0) depComments = false;
    if (depComments === true) $a29b06a0c330c050$var$_theme = (0, $fd3e132738d2e72b$export$25d302a5b900a763)({}, depComments);
    return $a29b06a0c330c050$var$_theme;
}
function $a29b06a0c330c050$export$e7b32ab372e04de(callback) {
    if ($a29b06a0c330c050$var$_onThemeChangeCallbacks.indexOf(callback) === -1) $a29b06a0c330c050$var$_onThemeChangeCallbacks.push(callback);
}
function $a29b06a0c330c050$export$d0ea9fdf152462c9(callback) {
    var i = $a29b06a0c330c050$var$_onThemeChangeCallbacks.indexOf(callback);
    if (i === -1) return;
    $a29b06a0c330c050$var$_onThemeChangeCallbacks.splice(i, 1);
}
function $a29b06a0c330c050$export$a1d87755f3c9500d(theme, depComments) {
    var _a;
    if (depComments === void 0) depComments = false;
    $a29b06a0c330c050$var$_theme = (0, $fd3e132738d2e72b$export$25d302a5b900a763)(theme, depComments);
    // Invoke the legacy method of theming the page as well.
    (0, $82c9985af4073ce0$exports.loadTheme)((0, $b1c38fba2c0065a7$export$18ce0697a983be9b)((0, $b1c38fba2c0065a7$export$18ce0697a983be9b)((0, $b1c38fba2c0065a7$export$18ce0697a983be9b)((0, $b1c38fba2c0065a7$export$18ce0697a983be9b)({}, $a29b06a0c330c050$var$_theme.palette), $a29b06a0c330c050$var$_theme.semanticColors), $a29b06a0c330c050$var$_theme.effects), $a29b06a0c330c050$var$_loadFonts($a29b06a0c330c050$var$_theme)));
    (0, $4f645c8fd987e645$export$cbb5b5586292cdb).applySettings((_a = {}, _a[$a29b06a0c330c050$export$cf613f78cce4b73f] = $a29b06a0c330c050$var$_theme, _a));
    $a29b06a0c330c050$var$_onThemeChangeCallbacks.forEach(function(callback) {
        try {
            callback($a29b06a0c330c050$var$_theme);
        } catch (e) {
        // don't let a bad callback break everything else
        }
    });
    return $a29b06a0c330c050$var$_theme;
}
/**
 * Loads font variables into a JSON object.
 * @param theme - The theme object
 */ function $a29b06a0c330c050$var$_loadFonts(theme) {
    var lines = {};
    for(var _i = 0, _a = Object.keys(theme.fonts); _i < _a.length; _i++){
        var fontName = _a[_i];
        var font = theme.fonts[fontName];
        for(var _b = 0, _c = Object.keys(font); _b < _c.length; _b++){
            var propName = _c[_b];
            var name_1 = fontName + propName.charAt(0).toUpperCase() + propName.slice(1);
            var value = font[propName];
            if (propName === "fontSize" && typeof value === "number") // if it's a number, convert it to px by default like our theming system does
            value = value + "px";
            lines[name_1] = value;
        }
    }
    return lines;
}


(0, $a29b06a0c330c050$export$8a248add43552e89)();


function $00899995ba8cdbb5$export$daed2daeba655e15(baseUrl, options) {
    if (baseUrl === void 0) baseUrl = "";
    var subset = {
        style: {
            MozOsxFontSmoothing: "grayscale",
            WebkitFontSmoothing: "antialiased",
            fontStyle: "normal",
            fontWeight: "normal",
            speak: "none"
        },
        fontFace: {
            fontFamily: '"FabricMDL2Icons"',
            src: "url('".concat(baseUrl, "fabric-icons-a13498cf.woff') format('woff')")
        },
        icons: {
            GlobalNavButton: "",
            ChevronDown: "",
            ChevronUp: "",
            Edit: "",
            Add: "",
            Cancel: "",
            More: "",
            Settings: "",
            Mail: "",
            Filter: "",
            Search: "",
            Share: "",
            BlockedSite: "",
            FavoriteStar: "",
            FavoriteStarFill: "",
            CheckMark: "",
            Delete: "",
            ChevronLeft: "",
            ChevronRight: "",
            Calendar: "",
            Megaphone: "",
            Undo: "",
            Flag: "",
            Page: "",
            Pinned: "",
            View: "",
            Clear: "",
            Download: "",
            Upload: "",
            Folder: "",
            Sort: "",
            AlignRight: "",
            AlignLeft: "",
            Tag: "",
            AddFriend: "",
            Info: "",
            SortLines: "",
            List: "",
            CircleRing: "",
            Heart: "",
            HeartFill: "",
            Tiles: "",
            Embed: "",
            Glimmer: "",
            Ascending: "",
            Descending: "",
            SortUp: "",
            SortDown: "",
            SyncToPC: "",
            LargeGrid: "",
            SkypeCheck: "",
            SkypeClock: "",
            SkypeMinus: "",
            ClearFilter: "",
            Flow: "",
            StatusCircleCheckmark: "",
            MoreVertical: ""
        }
    };
    (0, $44598dd284782b17$export$99b432e1290ef823)(subset, options);
}


// Your use of the content in the files referenced here is subject to the terms of the license at https://aka.ms/fluentui-assets-license

function $11501ede8f3e9220$export$daed2daeba655e15(baseUrl, options) {
    if (baseUrl === void 0) baseUrl = "";
    var subset = {
        style: {
            MozOsxFontSmoothing: "grayscale",
            WebkitFontSmoothing: "antialiased",
            fontStyle: "normal",
            fontWeight: "normal",
            speak: "none"
        },
        fontFace: {
            fontFamily: '"FabricMDL2Icons-0"',
            src: "url('".concat(baseUrl, "fabric-icons-0-467ee27f.woff') format('woff')")
        },
        icons: {
            "PageLink": "",
            "CommentSolid": "",
            "ChangeEntitlements": "",
            "Installation": "",
            "WebAppBuilderModule": "",
            "WebAppBuilderFragment": "",
            "WebAppBuilderSlot": "",
            "BullseyeTargetEdit": "",
            "WebAppBuilderFragmentCreate": "",
            "PageData": "",
            "PageHeaderEdit": "",
            "ProductList": "",
            "UnpublishContent": "",
            "DependencyAdd": "",
            "DependencyRemove": "",
            "EntitlementPolicy": "",
            "EntitlementRedemption": "",
            "SchoolDataSyncLogo": "",
            "PinSolid12": "",
            "PinSolidOff12": "",
            "AddLink": "",
            "SharepointAppIcon16": "",
            "DataflowsLink": "",
            "TimePicker": "",
            "UserWarning": "",
            "ComplianceAudit": "",
            "InternetSharing": "",
            "Brightness": "",
            "MapPin": "",
            "Airplane": "",
            "Tablet": "",
            "QuickNote": "",
            "Video": "",
            "People": "",
            "Phone": "",
            "Pin": "",
            "Shop": "",
            "Stop": "",
            "Link": "",
            "AllApps": "",
            "Zoom": "",
            "ZoomOut": "",
            "Microphone": "",
            "Camera": "",
            "Attach": "",
            "Send": "",
            "FavoriteList": "",
            "PageSolid": "",
            "Forward": "",
            "Back": "",
            "Refresh": "",
            "Lock": "",
            "ReportHacked": "",
            "EMI": "",
            "MiniLink": "",
            "Blocked": "",
            "ReadingMode": "",
            "Favicon": "",
            "Remove": "",
            "Checkbox": "",
            "CheckboxComposite": "",
            "CheckboxFill": "",
            "CheckboxIndeterminate": "",
            "CheckboxCompositeReversed": "",
            "BackToWindow": "",
            "FullScreen": "",
            "Print": "",
            "Up": "",
            "Down": "",
            "OEM": "",
            "Save": "",
            "ReturnKey": "",
            "Cloud": "",
            "Flashlight": "",
            "CommandPrompt": "",
            "Sad": "",
            "RealEstate": "",
            "SIPMove": "",
            "EraseTool": "",
            "GripperTool": "",
            "Dialpad": "",
            "PageLeft": "",
            "PageRight": "",
            "MultiSelect": "",
            "KeyboardClassic": "",
            "Play": "",
            "Pause": "",
            "InkingTool": "",
            "Emoji2": "",
            "GripperBarHorizontal": "",
            "System": "",
            "Personalize": "",
            "SearchAndApps": "",
            "Globe": "",
            "EaseOfAccess": "",
            "ContactInfo": "",
            "Unpin": "",
            "Contact": "",
            "Memo": "",
            "IncomingCall": ""
        }
    };
    (0, $44598dd284782b17$export$99b432e1290ef823)(subset, options);
}


// Your use of the content in the files referenced here is subject to the terms of the license at https://aka.ms/fluentui-assets-license

function $597129c96331b5dd$export$daed2daeba655e15(baseUrl, options) {
    if (baseUrl === void 0) baseUrl = "";
    var subset = {
        style: {
            MozOsxFontSmoothing: "grayscale",
            WebkitFontSmoothing: "antialiased",
            fontStyle: "normal",
            fontWeight: "normal",
            speak: "none"
        },
        fontFace: {
            fontFamily: '"FabricMDL2Icons-1"',
            src: "url('".concat(baseUrl, "fabric-icons-1-4d521695.woff') format('woff')")
        },
        icons: {
            "Paste": "",
            "WindowsLogo": "",
            "Error": "",
            "GripperBarVertical": "",
            "Unlock": "",
            "Slideshow": "",
            "Trim": "",
            "AutoEnhanceOn": "",
            "AutoEnhanceOff": "",
            "Color": "",
            "SaveAs": "",
            "Light": "",
            "Filters": "",
            "AspectRatio": "",
            "Contrast": "",
            "Redo": "",
            "Crop": "",
            "PhotoCollection": "",
            "Album": "",
            "Rotate": "",
            "PanoIndicator": "",
            "Translate": "",
            "RedEye": "",
            "ViewOriginal": "",
            "ThumbnailView": "",
            "Package": "",
            "Telemarketer": "",
            "Warning": "",
            "Financial": "",
            "Education": "",
            "ShoppingCart": "",
            "Train": "",
            "Move": "",
            "TouchPointer": "",
            "Merge": "",
            "TurnRight": "",
            "Ferry": "",
            "Highlight": "",
            "PowerButton": "",
            "Tab": "",
            "Admin": "",
            "TVMonitor": "",
            "Speakers": "",
            "Game": "",
            "HorizontalTabKey": "",
            "UnstackSelected": "",
            "StackIndicator": "",
            "Nav2DMapView": "",
            "StreetsideSplitMinimize": "",
            "Car": "",
            "Bus": "",
            "EatDrink": "",
            "SeeDo": "",
            "LocationCircle": "",
            "Home": "",
            "SwitcherStartEnd": "",
            "ParkingLocation": "",
            "IncidentTriangle": "",
            "Touch": "",
            "MapDirections": "",
            "CaretHollow": "",
            "CaretSolid": "",
            "History": "",
            "Location": "",
            "MapLayers": "",
            "SearchNearby": "",
            "Work": "",
            "Recent": "",
            "Hotel": "",
            "Bank": "",
            "LocationDot": "",
            "Dictionary": "",
            "ChromeBack": "",
            "FolderOpen": "",
            "PinnedFill": "",
            "RevToggleKey": "",
            "USB": "",
            "Previous": "",
            "Next": "",
            "Sync": "",
            "Help": "",
            "Emoji": "",
            "MailForward": "",
            "ClosePane": "",
            "OpenPane": "",
            "PreviewLink": "",
            "ZoomIn": "",
            "Bookmarks": "",
            "Document": "",
            "ProtectedDocument": "",
            "OpenInNewWindow": "",
            "MailFill": "",
            "ViewAll": "",
            "Switch": "",
            "Rename": "",
            "Go": "",
            "Remote": "",
            "SelectAll": "",
            "Orientation": "",
            "Import": ""
        }
    };
    (0, $44598dd284782b17$export$99b432e1290ef823)(subset, options);
}


// Your use of the content in the files referenced here is subject to the terms of the license at https://aka.ms/fluentui-assets-license

function $3fb1fdfa2a82adeb$export$daed2daeba655e15(baseUrl, options) {
    if (baseUrl === void 0) baseUrl = "";
    var subset = {
        style: {
            MozOsxFontSmoothing: "grayscale",
            WebkitFontSmoothing: "antialiased",
            fontStyle: "normal",
            fontWeight: "normal",
            speak: "none"
        },
        fontFace: {
            fontFamily: '"FabricMDL2Icons-2"',
            src: "url('".concat(baseUrl, "fabric-icons-2-63c99abf.woff') format('woff')")
        },
        icons: {
            "Picture": "",
            "ChromeClose": "",
            "ShowResults": "",
            "Message": "",
            "CalendarDay": "",
            "CalendarWeek": "",
            "MailReplyAll": "",
            "Read": "",
            "Cut": "",
            "PaymentCard": "",
            "Copy": "",
            "Important": "",
            "MailReply": "",
            "GotoToday": "",
            "Font": "",
            "FontColor": "",
            "FolderFill": "",
            "Permissions": "",
            "DisableUpdates": "",
            "Unfavorite": "",
            "Italic": "",
            "Underline": "",
            "Bold": "",
            "MoveToFolder": "",
            "Dislike": "",
            "Like": "",
            "AlignCenter": "",
            "OpenFile": "",
            "ClearSelection": "",
            "FontDecrease": "",
            "FontIncrease": "",
            "FontSize": "",
            "CellPhone": "",
            "RepeatOne": "",
            "RepeatAll": "",
            "Calculator": "",
            "Library": "",
            "PostUpdate": "",
            "NewFolder": "",
            "CalendarReply": "",
            "UnsyncFolder": "",
            "SyncFolder": "",
            "BlockContact": "",
            "Accept": "",
            "BulletedList": "",
            "Preview": "",
            "News": "",
            "Chat": "",
            "Group": "",
            "World": "",
            "Comment": "",
            "DockLeft": "",
            "DockRight": "",
            "Repair": "",
            "Accounts": "",
            "Street": "",
            "RadioBullet": "",
            "Stopwatch": "",
            "Clock": "",
            "WorldClock": "",
            "AlarmClock": "",
            "Photo": "",
            "ActionCenter": "",
            "Hospital": "",
            "Timer": "",
            "FullCircleMask": "",
            "LocationFill": "",
            "ChromeMinimize": "",
            "ChromeRestore": "",
            "Annotation": "",
            "Fingerprint": "",
            "Handwriting": "",
            "ChromeFullScreen": "",
            "Completed": "",
            "Label": "",
            "FlickDown": "",
            "FlickUp": "",
            "FlickLeft": "",
            "FlickRight": "",
            "MiniExpand": "",
            "MiniContract": "",
            "Streaming": "",
            "MusicInCollection": "",
            "OneDriveLogo": "",
            "CompassNW": "",
            "Code": "",
            "LightningBolt": "",
            "CalculatorMultiply": "",
            "CalculatorAddition": "",
            "CalculatorSubtract": "",
            "CalculatorPercentage": "",
            "CalculatorEqualTo": "",
            "PrintfaxPrinterFile": "",
            "StorageOptical": "",
            "Communications": "",
            "Headset": "",
            "Health": "",
            "Webcam2": "",
            "FrontCamera": "",
            "ChevronUpSmall": ""
        }
    };
    (0, $44598dd284782b17$export$99b432e1290ef823)(subset, options);
}


// Your use of the content in the files referenced here is subject to the terms of the license at https://aka.ms/fluentui-assets-license

function $edffabbaeab0660c$export$daed2daeba655e15(baseUrl, options) {
    if (baseUrl === void 0) baseUrl = "";
    var subset = {
        style: {
            MozOsxFontSmoothing: "grayscale",
            WebkitFontSmoothing: "antialiased",
            fontStyle: "normal",
            fontWeight: "normal",
            speak: "none"
        },
        fontFace: {
            fontFamily: '"FabricMDL2Icons-3"',
            src: "url('".concat(baseUrl, "fabric-icons-3-089e217a.woff') format('woff')")
        },
        icons: {
            "ChevronDownSmall": "",
            "ChevronLeftSmall": "",
            "ChevronRightSmall": "",
            "ChevronUpMed": "",
            "ChevronDownMed": "",
            "ChevronLeftMed": "",
            "ChevronRightMed": "",
            "Devices2": "",
            "PC1": "",
            "PresenceChickletVideo": "",
            "Reply": "",
            "HalfAlpha": "",
            "ConstructionCone": "",
            "DoubleChevronLeftMed": "",
            "Volume0": "",
            "Volume1": "",
            "Volume2": "",
            "Volume3": "",
            "Chart": "",
            "Robot": "",
            "Manufacturing": "",
            "LockSolid": "",
            "FitPage": "",
            "FitWidth": "",
            "BidiLtr": "",
            "BidiRtl": "",
            "RightDoubleQuote": "",
            "Sunny": "",
            "CloudWeather": "",
            "Cloudy": "",
            "PartlyCloudyDay": "",
            "PartlyCloudyNight": "",
            "ClearNight": "",
            "RainShowersDay": "",
            "Rain": "",
            "Thunderstorms": "",
            "RainSnow": "",
            "Snow": "",
            "BlowingSnow": "",
            "Frigid": "",
            "Fog": "",
            "Squalls": "",
            "Duststorm": "",
            "Unknown": "",
            "Precipitation": "",
            "Ribbon": "",
            "AreaChart": "",
            "Assign": "",
            "FlowChart": "",
            "CheckList": "",
            "Diagnostic": "",
            "Generate": "",
            "LineChart": "",
            "Equalizer": "",
            "BarChartHorizontal": "",
            "BarChartVertical": "",
            "Freezing": "",
            "FunnelChart": "",
            "Processing": "",
            "Quantity": "",
            "ReportDocument": "",
            "StackColumnChart": "",
            "SnowShowerDay": "",
            "HailDay": "",
            "WorkFlow": "",
            "HourGlass": "",
            "StoreLogoMed20": "",
            "TimeSheet": "",
            "TriangleSolid": "",
            "UpgradeAnalysis": "",
            "VideoSolid": "",
            "RainShowersNight": "",
            "SnowShowerNight": "",
            "Teamwork": "",
            "HailNight": "",
            "PeopleAdd": "",
            "Glasses": "",
            "DateTime2": "",
            "Shield": "",
            "Header1": "",
            "PageAdd": "",
            "NumberedList": "",
            "PowerBILogo": "",
            "Info2": "",
            "MusicInCollectionFill": "",
            "Asterisk": "",
            "ErrorBadge": "",
            "CircleFill": "",
            "Record2": "",
            "AllAppsMirrored": "",
            "BookmarksMirrored": "",
            "BulletedListMirrored": "",
            "CaretHollowMirrored": "",
            "CaretSolidMirrored": "",
            "ChromeBackMirrored": "",
            "ClearSelectionMirrored": "",
            "ClosePaneMirrored": "",
            "DockLeftMirrored": "",
            "DoubleChevronLeftMedMirrored": "",
            "GoMirrored": ""
        }
    };
    (0, $44598dd284782b17$export$99b432e1290ef823)(subset, options);
}


// Your use of the content in the files referenced here is subject to the terms of the license at https://aka.ms/fluentui-assets-license

function $5994872aa61308d3$export$daed2daeba655e15(baseUrl, options) {
    if (baseUrl === void 0) baseUrl = "";
    var subset = {
        style: {
            MozOsxFontSmoothing: "grayscale",
            WebkitFontSmoothing: "antialiased",
            fontStyle: "normal",
            fontWeight: "normal",
            speak: "none"
        },
        fontFace: {
            fontFamily: '"FabricMDL2Icons-4"',
            src: "url('".concat(baseUrl, "fabric-icons-4-a656cc0a.woff') format('woff')")
        },
        icons: {
            "HelpMirrored": "",
            "ImportMirrored": "",
            "ImportAllMirrored": "",
            "ListMirrored": "",
            "MailForwardMirrored": "",
            "MailReplyMirrored": "",
            "MailReplyAllMirrored": "",
            "MiniContractMirrored": "",
            "MiniExpandMirrored": "",
            "OpenPaneMirrored": "",
            "ParkingLocationMirrored": "",
            "SendMirrored": "",
            "ShowResultsMirrored": "",
            "ThumbnailViewMirrored": "",
            "Media": "",
            "Devices3": "",
            "Focus": "",
            "VideoLightOff": "",
            "Lightbulb": "",
            "StatusTriangle": "",
            "VolumeDisabled": "",
            "Puzzle": "",
            "EmojiNeutral": "",
            "EmojiDisappointed": "",
            "HomeSolid": "",
            "Ringer": "",
            "PDF": "",
            "HeartBroken": "",
            "StoreLogo16": "",
            "MultiSelectMirrored": "",
            "Broom": "",
            "AddToShoppingList": "",
            "Cocktails": "",
            "Wines": "",
            "Articles": "",
            "Cycling": "",
            "DietPlanNotebook": "",
            "Pill": "",
            "ExerciseTracker": "",
            "HandsFree": "",
            "Medical": "",
            "Running": "",
            "Weights": "",
            "Trackers": "",
            "AddNotes": "",
            "AllCurrency": "",
            "BarChart4": "",
            "CirclePlus": "",
            "Coffee": "",
            "Cotton": "",
            "Market": "",
            "Money": "",
            "PieDouble": "",
            "PieSingle": "",
            "RemoveFilter": "",
            "Savings": "",
            "Sell": "",
            "StockDown": "",
            "StockUp": "",
            "Lamp": "",
            "Source": "",
            "MSNVideos": "",
            "Cricket": "",
            "Golf": "",
            "Baseball": "",
            "Soccer": "",
            "MoreSports": "",
            "AutoRacing": "",
            "CollegeHoops": "",
            "CollegeFootball": "",
            "ProFootball": "",
            "ProHockey": "",
            "Rugby": "",
            "SubstitutionsIn": "",
            "Tennis": "",
            "Arrivals": "",
            "Design": "",
            "Website": "",
            "Drop": "",
            "HistoricalWeather": "",
            "SkiResorts": "",
            "Snowflake": "",
            "BusSolid": "",
            "FerrySolid": "",
            "AirplaneSolid": "",
            "TrainSolid": "",
            "Ticket": "",
            "WifiWarning4": "",
            "Devices4": "",
            "AzureLogo": "",
            "BingLogo": "",
            "MSNLogo": "",
            "OutlookLogoInverse": "",
            "OfficeLogo": "",
            "SkypeLogo": "",
            "Door": "",
            "EditMirrored": "",
            "GiftCard": "",
            "DoubleBookmark": "",
            "StatusErrorFull": ""
        }
    };
    (0, $44598dd284782b17$export$99b432e1290ef823)(subset, options);
}


// Your use of the content in the files referenced here is subject to the terms of the license at https://aka.ms/fluentui-assets-license

function $9c99ff6af0115050$export$daed2daeba655e15(baseUrl, options) {
    if (baseUrl === void 0) baseUrl = "";
    var subset = {
        style: {
            MozOsxFontSmoothing: "grayscale",
            WebkitFontSmoothing: "antialiased",
            fontStyle: "normal",
            fontWeight: "normal",
            speak: "none"
        },
        fontFace: {
            fontFamily: '"FabricMDL2Icons-5"',
            src: "url('".concat(baseUrl, "fabric-icons-5-f95ba260.woff') format('woff')")
        },
        icons: {
            "Certificate": "",
            "FastForward": "",
            "Rewind": "",
            "Photo2": "",
            "OpenSource": "",
            "Movers": "",
            "CloudDownload": "",
            "Family": "",
            "WindDirection": "",
            "Bug": "",
            "SiteScan": "",
            "BrowserScreenShot": "",
            "F12DevTools": "",
            "CSS": "",
            "JS": "",
            "DeliveryTruck": "",
            "ReminderPerson": "",
            "ReminderGroup": "",
            "ReminderTime": "",
            "TabletMode": "",
            "Umbrella": "",
            "NetworkTower": "",
            "CityNext": "",
            "CityNext2": "",
            "Section": "",
            "OneNoteLogoInverse": "",
            "ToggleFilled": "",
            "ToggleBorder": "",
            "SliderThumb": "",
            "ToggleThumb": "",
            "Documentation": "",
            "Badge": "",
            "Giftbox": "",
            "VisualStudioLogo": "",
            "HomeGroup": "",
            "ExcelLogoInverse": "",
            "WordLogoInverse": "",
            "PowerPointLogoInverse": "",
            "Cafe": "",
            "SpeedHigh": "",
            "Commitments": "",
            "ThisPC": "",
            "MusicNote": "",
            "MicOff": "",
            "PlaybackRate1x": "",
            "EdgeLogo": "",
            "CompletedSolid": "",
            "AlbumRemove": "",
            "MessageFill": "",
            "TabletSelected": "",
            "MobileSelected": "",
            "LaptopSelected": "",
            "TVMonitorSelected": "",
            "DeveloperTools": "",
            "Shapes": "",
            "InsertTextBox": "",
            "LowerBrightness": "",
            "WebComponents": "",
            "OfflineStorage": "",
            "DOM": "",
            "CloudUpload": "",
            "ScrollUpDown": "",
            "DateTime": "",
            "Event": "",
            "Cake": "",
            "Org": "",
            "PartyLeader": "",
            "DRM": "",
            "CloudAdd": "",
            "AppIconDefault": "",
            "Photo2Add": "",
            "Photo2Remove": "",
            "Calories": "",
            "POI": "",
            "AddTo": "",
            "RadioBtnOff": "",
            "RadioBtnOn": "",
            "ExploreContent": "",
            "Product": "",
            "ProgressLoopInner": "",
            "ProgressLoopOuter": "",
            "Blocked2": "",
            "FangBody": "",
            "Toolbox": "",
            "PageHeader": "",
            "ChatInviteFriend": "",
            "Brush": "",
            "Shirt": "",
            "Crown": "",
            "Diamond": "",
            "ScaleUp": "",
            "QRCode": "",
            "Feedback": "",
            "SharepointLogoInverse": "",
            "YammerLogo": "",
            "Hide": "",
            "Uneditable": "",
            "ReturnToSession": "",
            "OpenFolderHorizontal": "",
            "CalendarMirrored": ""
        }
    };
    (0, $44598dd284782b17$export$99b432e1290ef823)(subset, options);
}


// Your use of the content in the files referenced here is subject to the terms of the license at https://aka.ms/fluentui-assets-license

function $d151d84c28c94532$export$daed2daeba655e15(baseUrl, options) {
    if (baseUrl === void 0) baseUrl = "";
    var subset = {
        style: {
            MozOsxFontSmoothing: "grayscale",
            WebkitFontSmoothing: "antialiased",
            fontStyle: "normal",
            fontWeight: "normal",
            speak: "none"
        },
        fontFace: {
            fontFamily: '"FabricMDL2Icons-6"',
            src: "url('".concat(baseUrl, "fabric-icons-6-ef6fd590.woff') format('woff')")
        },
        icons: {
            "SwayLogoInverse": "",
            "OutOfOffice": "",
            "Trophy": "",
            "ReopenPages": "",
            "EmojiTabSymbols": "",
            "AADLogo": "",
            "AccessLogo": "",
            "AdminALogoInverse32": "",
            "AdminCLogoInverse32": "",
            "AdminDLogoInverse32": "",
            "AdminELogoInverse32": "",
            "AdminLLogoInverse32": "",
            "AdminMLogoInverse32": "",
            "AdminOLogoInverse32": "",
            "AdminPLogoInverse32": "",
            "AdminSLogoInverse32": "",
            "AdminYLogoInverse32": "",
            "DelveLogoInverse": "",
            "ExchangeLogoInverse": "",
            "LyncLogo": "",
            "OfficeVideoLogoInverse": "",
            "SocialListeningLogo": "",
            "VisioLogoInverse": "",
            "Balloons": "",
            "Cat": "",
            "MailAlert": "",
            "MailCheck": "",
            "MailLowImportance": "",
            "MailPause": "",
            "MailRepeat": "",
            "SecurityGroup": "",
            "Table": "",
            "VoicemailForward": "",
            "VoicemailReply": "",
            "Waffle": "",
            "RemoveEvent": "",
            "EventInfo": "",
            "ForwardEvent": "",
            "WipePhone": "",
            "AddOnlineMeeting": "",
            "JoinOnlineMeeting": "",
            "RemoveLink": "",
            "PeopleBlock": "",
            "PeopleRepeat": "",
            "PeopleAlert": "",
            "PeoplePause": "",
            "TransferCall": "",
            "AddPhone": "",
            "UnknownCall": "",
            "NoteReply": "",
            "NoteForward": "",
            "NotePinned": "",
            "RemoveOccurrence": "",
            "Timeline": "",
            "EditNote": "",
            "CircleHalfFull": "",
            "Room": "",
            "Unsubscribe": "",
            "Subscribe": "",
            "HardDrive": "",
            "RecurringTask": "",
            "TaskManager": "",
            "TaskManagerMirrored": "",
            "Combine": "",
            "Split": "",
            "DoubleChevronUp": "",
            "DoubleChevronLeft": "",
            "DoubleChevronRight": "",
            "TextBox": "",
            "TextField": "",
            "NumberField": "",
            "Dropdown": "",
            "PenWorkspace": "",
            "BookingsLogo": "",
            "ClassNotebookLogoInverse": "",
            "DelveAnalyticsLogo": "",
            "DocsLogoInverse": "",
            "Dynamics365Logo": "",
            "DynamicSMBLogo": "",
            "OfficeAssistantLogo": "",
            "OfficeStoreLogo": "",
            "OneNoteEduLogoInverse": "",
            "PlannerLogo": "",
            "PowerApps": "",
            "Suitcase": "",
            "ProjectLogoInverse": "",
            "CaretLeft8": "",
            "CaretRight8": "",
            "CaretUp8": "",
            "CaretDown8": "",
            "CaretLeftSolid8": "",
            "CaretRightSolid8": "",
            "CaretUpSolid8": "",
            "CaretDownSolid8": "",
            "ClearFormatting": "",
            "Superscript": "",
            "Subscript": "",
            "Strikethrough": "",
            "Export": "",
            "ExportMirrored": ""
        }
    };
    (0, $44598dd284782b17$export$99b432e1290ef823)(subset, options);
}


// Your use of the content in the files referenced here is subject to the terms of the license at https://aka.ms/fluentui-assets-license

function $cdbdab2a9653c3e5$export$daed2daeba655e15(baseUrl, options) {
    if (baseUrl === void 0) baseUrl = "";
    var subset = {
        style: {
            MozOsxFontSmoothing: "grayscale",
            WebkitFontSmoothing: "antialiased",
            fontStyle: "normal",
            fontWeight: "normal",
            speak: "none"
        },
        fontFace: {
            fontFamily: '"FabricMDL2Icons-7"',
            src: "url('".concat(baseUrl, "fabric-icons-7-2b97bb99.woff') format('woff')")
        },
        icons: {
            "SingleBookmark": "",
            "SingleBookmarkSolid": "",
            "DoubleChevronDown": "",
            "FollowUser": "",
            "ReplyAll": "",
            "WorkforceManagement": "",
            "RecruitmentManagement": "",
            "Questionnaire": "",
            "ManagerSelfService": "",
            "ProductionFloorManagement": "",
            "ProductRelease": "",
            "ProductVariant": "",
            "ReplyMirrored": "",
            "ReplyAllMirrored": "",
            "Medal": "",
            "AddGroup": "",
            "QuestionnaireMirrored": "",
            "CloudImportExport": "",
            "TemporaryUser": "",
            "CaretSolid16": "",
            "GroupedDescending": "",
            "GroupedAscending": "",
            "AwayStatus": "",
            "MyMoviesTV": "",
            "GenericScan": "",
            "AustralianRules": "",
            "WifiEthernet": "",
            "TrackersMirrored": "",
            "DateTimeMirrored": "",
            "StopSolid": "",
            "DoubleChevronUp12": "",
            "DoubleChevronDown12": "",
            "DoubleChevronLeft12": "",
            "DoubleChevronRight12": "",
            "CalendarAgenda": "",
            "ConnectVirtualMachine": "",
            "AddEvent": "",
            "AssetLibrary": "",
            "DataConnectionLibrary": "",
            "DocLibrary": "",
            "FormLibrary": "",
            "FormLibraryMirrored": "",
            "ReportLibrary": "",
            "ReportLibraryMirrored": "",
            "ContactCard": "",
            "CustomList": "",
            "CustomListMirrored": "",
            "IssueTracking": "",
            "IssueTrackingMirrored": "",
            "PictureLibrary": "",
            "OfficeAddinsLogo": "",
            "OfflineOneDriveParachute": "",
            "OfflineOneDriveParachuteDisabled": "",
            "TriangleSolidUp12": "",
            "TriangleSolidDown12": "",
            "TriangleSolidLeft12": "",
            "TriangleSolidRight12": "",
            "TriangleUp12": "",
            "TriangleDown12": "",
            "TriangleLeft12": "",
            "TriangleRight12": "",
            "ArrowUpRight8": "",
            "ArrowDownRight8": "",
            "DocumentSet": "",
            "GoToDashboard": "",
            "DelveAnalytics": "",
            "ArrowUpRightMirrored8": "",
            "ArrowDownRightMirrored8": "",
            "CompanyDirectory": "",
            "OpenEnrollment": "",
            "CompanyDirectoryMirrored": "",
            "OneDriveAdd": "",
            "ProfileSearch": "",
            "Header2": "",
            "Header3": "",
            "Header4": "",
            "RingerSolid": "",
            "Eyedropper": "",
            "MarketDown": "",
            "CalendarWorkWeek": "",
            "SidePanel": "",
            "GlobeFavorite": "",
            "CaretTopLeftSolid8": "",
            "CaretTopRightSolid8": "",
            "ViewAll2": "",
            "DocumentReply": "",
            "PlayerSettings": "",
            "ReceiptForward": "",
            "ReceiptReply": "",
            "ReceiptCheck": "",
            "Fax": "",
            "RecurringEvent": "",
            "ReplyAlt": "",
            "ReplyAllAlt": "",
            "EditStyle": "",
            "EditMail": "",
            "Lifesaver": "",
            "LifesaverLock": "",
            "InboxCheck": "",
            "FolderSearch": ""
        }
    };
    (0, $44598dd284782b17$export$99b432e1290ef823)(subset, options);
}


// Your use of the content in the files referenced here is subject to the terms of the license at https://aka.ms/fluentui-assets-license

function $edae70a72c6a7a60$export$daed2daeba655e15(baseUrl, options) {
    if (baseUrl === void 0) baseUrl = "";
    var subset = {
        style: {
            MozOsxFontSmoothing: "grayscale",
            WebkitFontSmoothing: "antialiased",
            fontStyle: "normal",
            fontWeight: "normal",
            speak: "none"
        },
        fontFace: {
            fontFamily: '"FabricMDL2Icons-8"',
            src: "url('".concat(baseUrl, "fabric-icons-8-6fdf1528.woff') format('woff')")
        },
        icons: {
            "CollapseMenu": "",
            "ExpandMenu": "",
            "Boards": "",
            "SunAdd": "",
            "SunQuestionMark": "",
            "LandscapeOrientation": "",
            "DocumentSearch": "",
            "PublicCalendar": "",
            "PublicContactCard": "",
            "PublicEmail": "",
            "PublicFolder": "",
            "WordDocument": "",
            "PowerPointDocument": "",
            "ExcelDocument": "",
            "GroupedList": "",
            "ClassroomLogo": "",
            "Sections": "",
            "EditPhoto": "",
            "Starburst": "",
            "ShareiOS": "",
            "AirTickets": "",
            "PencilReply": "",
            "Tiles2": "",
            "SkypeCircleCheck": "",
            "SkypeCircleClock": "",
            "SkypeCircleMinus": "",
            "SkypeMessage": "",
            "ClosedCaption": "",
            "ATPLogo": "",
            "OfficeFormsLogoInverse": "",
            "RecycleBin": "",
            "EmptyRecycleBin": "",
            "Hide2": "",
            "Breadcrumb": "",
            "BirthdayCake": "",
            "TimeEntry": "",
            "CRMProcesses": "",
            "PageEdit": "",
            "PageArrowRight": "",
            "PageRemove": "",
            "Database": "",
            "DataManagementSettings": "",
            "CRMServices": "",
            "EditContact": "",
            "ConnectContacts": "",
            "AppIconDefaultAdd": "",
            "AppIconDefaultList": "",
            "ActivateOrders": "",
            "DeactivateOrders": "",
            "ProductCatalog": "",
            "ScatterChart": "",
            "AccountActivity": "",
            "DocumentManagement": "",
            "CRMReport": "",
            "KnowledgeArticle": "",
            "Relationship": "",
            "HomeVerify": "",
            "ZipFolder": "",
            "SurveyQuestions": "",
            "TextDocument": "",
            "TextDocumentShared": "",
            "PageCheckedOut": "",
            "PageShared": "",
            "SaveAndClose": "",
            "Script": "",
            "Archive": "",
            "ActivityFeed": "",
            "Compare": "",
            "EventDate": "",
            "ArrowUpRight": "",
            "CaretRight": "",
            "SetAction": "",
            "ChatBot": "",
            "CaretSolidLeft": "",
            "CaretSolidDown": "",
            "CaretSolidRight": "",
            "CaretSolidUp": "",
            "PowerAppsLogo": "",
            "PowerApps2Logo": "",
            "SearchIssue": "",
            "SearchIssueMirrored": "",
            "FabricAssetLibrary": "",
            "FabricDataConnectionLibrary": "",
            "FabricDocLibrary": "",
            "FabricFormLibrary": "",
            "FabricFormLibraryMirrored": "",
            "FabricReportLibrary": "",
            "FabricReportLibraryMirrored": "",
            "FabricPublicFolder": "",
            "FabricFolderSearch": "",
            "FabricMovetoFolder": "",
            "FabricUnsyncFolder": "",
            "FabricSyncFolder": "",
            "FabricOpenFolderHorizontal": "",
            "FabricFolder": "",
            "FabricFolderFill": "",
            "FabricNewFolder": "",
            "FabricPictureLibrary": "",
            "PhotoVideoMedia": "",
            "AddFavorite": ""
        }
    };
    (0, $44598dd284782b17$export$99b432e1290ef823)(subset, options);
}


// Your use of the content in the files referenced here is subject to the terms of the license at https://aka.ms/fluentui-assets-license

function $4f7ad8921db3fa1f$export$daed2daeba655e15(baseUrl, options) {
    if (baseUrl === void 0) baseUrl = "";
    var subset = {
        style: {
            MozOsxFontSmoothing: "grayscale",
            WebkitFontSmoothing: "antialiased",
            fontStyle: "normal",
            fontWeight: "normal",
            speak: "none"
        },
        fontFace: {
            fontFamily: '"FabricMDL2Icons-9"',
            src: "url('".concat(baseUrl, "fabric-icons-9-c6162b42.woff') format('woff')")
        },
        icons: {
            "AddFavoriteFill": "",
            "BufferTimeBefore": "",
            "BufferTimeAfter": "",
            "BufferTimeBoth": "",
            "PublishContent": "",
            "ClipboardList": "",
            "ClipboardListMirrored": "",
            "CannedChat": "",
            "SkypeForBusinessLogo": "",
            "TabCenter": "",
            "PageCheckedin": "",
            "PageList": "",
            "ReadOutLoud": "",
            "CaretBottomLeftSolid8": "",
            "CaretBottomRightSolid8": "",
            "FolderHorizontal": "",
            "MicrosoftStaffhubLogo": "",
            "GiftboxOpen": "",
            "StatusCircleOuter": "",
            "StatusCircleInner": "",
            "StatusCircleRing": "",
            "StatusTriangleOuter": "",
            "StatusTriangleInner": "",
            "StatusTriangleExclamation": "",
            "StatusCircleExclamation": "",
            "StatusCircleErrorX": "",
            "StatusCircleInfo": "",
            "StatusCircleBlock": "",
            "StatusCircleBlock2": "",
            "StatusCircleQuestionMark": "",
            "StatusCircleSync": "",
            "Toll": "",
            "ExploreContentSingle": "",
            "CollapseContent": "",
            "CollapseContentSingle": "",
            "InfoSolid": "",
            "GroupList": "",
            "ProgressRingDots": "",
            "CaloriesAdd": "",
            "BranchFork": "",
            "MuteChat": "",
            "AddHome": "",
            "AddWork": "",
            "MobileReport": "",
            "ScaleVolume": "",
            "HardDriveGroup": "",
            "FastMode": "",
            "ToggleLeft": "",
            "ToggleRight": "",
            "TriangleShape": "",
            "RectangleShape": "",
            "CubeShape": "",
            "Trophy2": "",
            "BucketColor": "",
            "BucketColorFill": "",
            "Taskboard": "",
            "SingleColumn": "",
            "DoubleColumn": "",
            "TripleColumn": "",
            "ColumnLeftTwoThirds": "",
            "ColumnRightTwoThirds": "",
            "AccessLogoFill": "",
            "AnalyticsLogo": "",
            "AnalyticsQuery": "",
            "NewAnalyticsQuery": "",
            "AnalyticsReport": "",
            "WordLogo": "",
            "WordLogoFill": "",
            "ExcelLogo": "",
            "ExcelLogoFill": "",
            "OneNoteLogo": "",
            "OneNoteLogoFill": "",
            "OutlookLogo": "",
            "OutlookLogoFill": "",
            "PowerPointLogo": "",
            "PowerPointLogoFill": "",
            "PublisherLogo": "",
            "PublisherLogoFill": "",
            "ScheduleEventAction": "",
            "FlameSolid": "",
            "ServerProcesses": "",
            "Server": "",
            "SaveAll": "",
            "LinkedInLogo": "",
            "Decimals": "",
            "SidePanelMirrored": "",
            "ProtectRestrict": "",
            "Blog": "",
            "UnknownMirrored": "",
            "PublicContactCardMirrored": "",
            "GridViewSmall": "",
            "GridViewMedium": "",
            "GridViewLarge": "",
            "Step": "",
            "StepInsert": "",
            "StepShared": "",
            "StepSharedAdd": "",
            "StepSharedInsert": "",
            "ViewDashboard": "",
            "ViewList": ""
        }
    };
    (0, $44598dd284782b17$export$99b432e1290ef823)(subset, options);
}


// Your use of the content in the files referenced here is subject to the terms of the license at https://aka.ms/fluentui-assets-license

function $23391c75f43d71f2$export$daed2daeba655e15(baseUrl, options) {
    if (baseUrl === void 0) baseUrl = "";
    var subset = {
        style: {
            MozOsxFontSmoothing: "grayscale",
            WebkitFontSmoothing: "antialiased",
            fontStyle: "normal",
            fontWeight: "normal",
            speak: "none"
        },
        fontFace: {
            fontFamily: '"FabricMDL2Icons-10"',
            src: "url('".concat(baseUrl, "fabric-icons-10-c4ded8e4.woff') format('woff')")
        },
        icons: {
            "ViewListGroup": "",
            "ViewListTree": "",
            "TriggerAuto": "",
            "TriggerUser": "",
            "PivotChart": "",
            "StackedBarChart": "",
            "StackedLineChart": "",
            "BuildQueue": "",
            "BuildQueueNew": "",
            "UserFollowed": "",
            "ContactLink": "",
            "Stack": "",
            "Bullseye": "",
            "VennDiagram": "",
            "FiveTileGrid": "",
            "FocalPoint": "",
            "Insert": "",
            "RingerRemove": "",
            "TeamsLogoInverse": "",
            "TeamsLogo": "",
            "TeamsLogoFill": "",
            "SkypeForBusinessLogoFill": "",
            "SharepointLogo": "",
            "SharepointLogoFill": "",
            "DelveLogo": "",
            "DelveLogoFill": "",
            "OfficeVideoLogo": "",
            "OfficeVideoLogoFill": "",
            "ExchangeLogo": "",
            "ExchangeLogoFill": "",
            "Signin": "",
            "DocumentApproval": "",
            "CloneToDesktop": "",
            "InstallToDrive": "",
            "Blur": "",
            "Build": "",
            "ProcessMetaTask": "",
            "BranchFork2": "",
            "BranchLocked": "",
            "BranchCommit": "",
            "BranchCompare": "",
            "BranchMerge": "",
            "BranchPullRequest": "",
            "BranchSearch": "",
            "BranchShelveset": "",
            "RawSource": "",
            "MergeDuplicate": "",
            "RowsGroup": "",
            "RowsChild": "",
            "Deploy": "",
            "Redeploy": "",
            "ServerEnviroment": "",
            "VisioDiagram": "",
            "HighlightMappedShapes": "",
            "TextCallout": "",
            "IconSetsFlag": "",
            "VisioLogo": "",
            "VisioLogoFill": "",
            "VisioDocument": "",
            "TimelineProgress": "",
            "TimelineDelivery": "",
            "Backlog": "",
            "TeamFavorite": "",
            "TaskGroup": "",
            "TaskGroupMirrored": "",
            "ScopeTemplate": "",
            "AssessmentGroupTemplate": "",
            "NewTeamProject": "",
            "CommentAdd": "",
            "CommentNext": "",
            "CommentPrevious": "",
            "ShopServer": "",
            "LocaleLanguage": "",
            "QueryList": "",
            "UserSync": "",
            "UserPause": "",
            "StreamingOff": "",
            "ArrowTallUpLeft": "",
            "ArrowTallUpRight": "",
            "ArrowTallDownLeft": "",
            "ArrowTallDownRight": "",
            "FieldEmpty": "",
            "FieldFilled": "",
            "FieldChanged": "",
            "FieldNotChanged": "",
            "RingerOff": "",
            "PlayResume": "",
            "BulletedList2": "",
            "BulletedList2Mirrored": "",
            "ImageCrosshair": "",
            "GitGraph": "",
            "Repo": "",
            "RepoSolid": "",
            "FolderQuery": "",
            "FolderList": "",
            "FolderListMirrored": "",
            "LocationOutline": "",
            "POISolid": "",
            "CalculatorNotEqualTo": "",
            "BoxSubtractSolid": ""
        }
    };
    (0, $44598dd284782b17$export$99b432e1290ef823)(subset, options);
}


// Your use of the content in the files referenced here is subject to the terms of the license at https://aka.ms/fluentui-assets-license

function $d16dd188875b8cc4$export$daed2daeba655e15(baseUrl, options) {
    if (baseUrl === void 0) baseUrl = "";
    var subset = {
        style: {
            MozOsxFontSmoothing: "grayscale",
            WebkitFontSmoothing: "antialiased",
            fontStyle: "normal",
            fontWeight: "normal",
            speak: "none"
        },
        fontFace: {
            fontFamily: '"FabricMDL2Icons-11"',
            src: "url('".concat(baseUrl, "fabric-icons-11-2a8393d6.woff') format('woff')")
        },
        icons: {
            "BoxAdditionSolid": "",
            "BoxMultiplySolid": "",
            "BoxPlaySolid": "",
            "BoxCheckmarkSolid": "",
            "CirclePauseSolid": "",
            "CirclePause": "",
            "MSNVideosSolid": "",
            "CircleStopSolid": "",
            "CircleStop": "",
            "NavigateBack": "",
            "NavigateBackMirrored": "",
            "NavigateForward": "",
            "NavigateForwardMirrored": "",
            "UnknownSolid": "",
            "UnknownMirroredSolid": "",
            "CircleAddition": "",
            "CircleAdditionSolid": "",
            "FilePDB": "",
            "FileTemplate": "",
            "FileSQL": "",
            "FileJAVA": "",
            "FileASPX": "",
            "FileCSS": "",
            "FileSass": "",
            "FileLess": "",
            "FileHTML": "",
            "JavaScriptLanguage": "",
            "CSharpLanguage": "",
            "CSharp": "",
            "VisualBasicLanguage": "",
            "VB": "",
            "CPlusPlusLanguage": "",
            "CPlusPlus": "",
            "FSharpLanguage": "",
            "FSharp": "",
            "TypeScriptLanguage": "",
            "PythonLanguage": "",
            "PY": "",
            "CoffeeScript": "",
            "MarkDownLanguage": "",
            "FullWidth": "",
            "FullWidthEdit": "",
            "Plug": "",
            "PlugSolid": "",
            "PlugConnected": "",
            "PlugDisconnected": "",
            "UnlockSolid": "",
            "Variable": "",
            "Parameter": "",
            "CommentUrgent": "",
            "Storyboard": "",
            "DiffInline": "",
            "DiffSideBySide": "",
            "ImageDiff": "",
            "ImagePixel": "",
            "FileBug": "",
            "FileCode": "",
            "FileComment": "",
            "BusinessHoursSign": "",
            "FileImage": "",
            "FileSymlink": "",
            "AutoFillTemplate": "",
            "WorkItem": "",
            "WorkItemBug": "",
            "LogRemove": "",
            "ColumnOptions": "",
            "Packages": "",
            "BuildIssue": "",
            "AssessmentGroup": "",
            "VariableGroup": "",
            "FullHistory": "",
            "Wheelchair": "",
            "SingleColumnEdit": "",
            "DoubleColumnEdit": "",
            "TripleColumnEdit": "",
            "ColumnLeftTwoThirdsEdit": "",
            "ColumnRightTwoThirdsEdit": "",
            "StreamLogo": "",
            "PassiveAuthentication": "",
            "AlertSolid": "",
            "MegaphoneSolid": "",
            "TaskSolid": "",
            "ConfigurationSolid": "",
            "BugSolid": "",
            "CrownSolid": "",
            "Trophy2Solid": "",
            "QuickNoteSolid": "",
            "ConstructionConeSolid": "",
            "PageListSolid": "",
            "PageListMirroredSolid": "",
            "StarburstSolid": "",
            "ReadingModeSolid": "",
            "SadSolid": "",
            "HealthSolid": "",
            "ShieldSolid": "",
            "GiftBoxSolid": "",
            "ShoppingCartSolid": "",
            "MailSolid": "",
            "ChatSolid": "",
            "RibbonSolid": ""
        }
    };
    (0, $44598dd284782b17$export$99b432e1290ef823)(subset, options);
}


// Your use of the content in the files referenced here is subject to the terms of the license at https://aka.ms/fluentui-assets-license

function $9087b5e6b6b2c950$export$daed2daeba655e15(baseUrl, options) {
    if (baseUrl === void 0) baseUrl = "";
    var subset = {
        style: {
            MozOsxFontSmoothing: "grayscale",
            WebkitFontSmoothing: "antialiased",
            fontStyle: "normal",
            fontWeight: "normal",
            speak: "none"
        },
        fontFace: {
            fontFamily: '"FabricMDL2Icons-12"',
            src: "url('".concat(baseUrl, "fabric-icons-12-7e945a1e.woff') format('woff')")
        },
        icons: {
            "FinancialSolid": "",
            "FinancialMirroredSolid": "",
            "HeadsetSolid": "",
            "PermissionsSolid": "",
            "ParkingSolid": "",
            "ParkingMirroredSolid": "",
            "DiamondSolid": "",
            "AsteriskSolid": "",
            "OfflineStorageSolid": "",
            "BankSolid": "",
            "DecisionSolid": "",
            "Parachute": "",
            "ParachuteSolid": "",
            "FiltersSolid": "",
            "ColorSolid": "",
            "ReviewSolid": "",
            "ReviewRequestSolid": "",
            "ReviewRequestMirroredSolid": "",
            "ReviewResponseSolid": "",
            "FeedbackRequestSolid": "",
            "FeedbackRequestMirroredSolid": "",
            "FeedbackResponseSolid": "",
            "WorkItemBar": "",
            "WorkItemBarSolid": "",
            "Separator": "",
            "NavigateExternalInline": "",
            "PlanView": "",
            "TimelineMatrixView": "",
            "EngineeringGroup": "",
            "ProjectCollection": "",
            "CaretBottomRightCenter8": "",
            "CaretBottomLeftCenter8": "",
            "CaretTopRightCenter8": "",
            "CaretTopLeftCenter8": "",
            "DonutChart": "",
            "ChevronUnfold10": "",
            "ChevronFold10": "",
            "DoubleChevronDown8": "",
            "DoubleChevronUp8": "",
            "DoubleChevronLeft8": "",
            "DoubleChevronRight8": "",
            "ChevronDownEnd6": "",
            "ChevronUpEnd6": "",
            "ChevronLeftEnd6": "",
            "ChevronRightEnd6": "",
            "ContextMenu": "",
            "AzureAPIManagement": "",
            "AzureServiceEndpoint": "",
            "VSTSLogo": "",
            "VSTSAltLogo1": "",
            "VSTSAltLogo2": "",
            "FileTypeSolution": "",
            "WordLogoInverse16": "",
            "WordLogo16": "",
            "WordLogoFill16": "",
            "PowerPointLogoInverse16": "",
            "PowerPointLogo16": "",
            "PowerPointLogoFill16": "",
            "ExcelLogoInverse16": "",
            "ExcelLogo16": "",
            "ExcelLogoFill16": "",
            "OneNoteLogoInverse16": "",
            "OneNoteLogo16": "",
            "OneNoteLogoFill16": "",
            "OutlookLogoInverse16": "",
            "OutlookLogo16": "",
            "OutlookLogoFill16": "",
            "PublisherLogoInverse16": "",
            "PublisherLogo16": "",
            "PublisherLogoFill16": "",
            "VisioLogoInverse16": "",
            "VisioLogo16": "",
            "VisioLogoFill16": "",
            "TestBeaker": "",
            "TestBeakerSolid": "",
            "TestExploreSolid": "",
            "TestAutoSolid": "",
            "TestUserSolid": "",
            "TestImpactSolid": "",
            "TestPlan": "",
            "TestStep": "",
            "TestParameter": "",
            "TestSuite": "",
            "TestCase": "",
            "Sprint": "",
            "SignOut": "",
            "TriggerApproval": "",
            "Rocket": "",
            "AzureKeyVault": "",
            "Onboarding": "",
            "Transition": "",
            "LikeSolid": "",
            "DislikeSolid": "",
            "CRMCustomerInsightsApp": "",
            "EditCreate": "",
            "PlayReverseResume": "",
            "PlayReverse": "",
            "SearchData": "",
            "UnSetColor": "",
            "DeclineCall": ""
        }
    };
    (0, $44598dd284782b17$export$99b432e1290ef823)(subset, options);
}


// Your use of the content in the files referenced here is subject to the terms of the license at https://aka.ms/fluentui-assets-license

function $faace2758a0adb7d$export$daed2daeba655e15(baseUrl, options) {
    if (baseUrl === void 0) baseUrl = "";
    var subset = {
        style: {
            MozOsxFontSmoothing: "grayscale",
            WebkitFontSmoothing: "antialiased",
            fontStyle: "normal",
            fontWeight: "normal",
            speak: "none"
        },
        fontFace: {
            fontFamily: '"FabricMDL2Icons-13"',
            src: "url('".concat(baseUrl, "fabric-icons-13-c3989a02.woff') format('woff')")
        },
        icons: {
            "RectangularClipping": "",
            "TeamsLogo16": "",
            "TeamsLogoFill16": "",
            "Spacer": "",
            "SkypeLogo16": "",
            "SkypeForBusinessLogo16": "",
            "SkypeForBusinessLogoFill16": "",
            "FilterSolid": "",
            "MailUndelivered": "",
            "MailTentative": "",
            "MailTentativeMirrored": "",
            "MailReminder": "",
            "ReceiptUndelivered": "",
            "ReceiptTentative": "",
            "ReceiptTentativeMirrored": "",
            "Inbox": "",
            "IRMReply": "",
            "IRMReplyMirrored": "",
            "IRMForward": "",
            "IRMForwardMirrored": "",
            "VoicemailIRM": "",
            "EventAccepted": "",
            "EventTentative": "",
            "EventTentativeMirrored": "",
            "EventDeclined": "",
            "IDBadge": "",
            "BackgroundColor": "",
            "OfficeFormsLogoInverse16": "",
            "OfficeFormsLogo": "",
            "OfficeFormsLogoFill": "",
            "OfficeFormsLogo16": "",
            "OfficeFormsLogoFill16": "",
            "OfficeFormsLogoInverse24": "",
            "OfficeFormsLogo24": "",
            "OfficeFormsLogoFill24": "",
            "PageLock": "",
            "NotExecuted": "",
            "NotImpactedSolid": "",
            "FieldReadOnly": "",
            "FieldRequired": "",
            "BacklogBoard": "",
            "ExternalBuild": "",
            "ExternalTFVC": "",
            "ExternalXAML": "",
            "IssueSolid": "",
            "DefectSolid": "",
            "LadybugSolid": "",
            "NugetLogo": "",
            "TFVCLogo": "",
            "ProjectLogo32": "",
            "ProjectLogoFill32": "",
            "ProjectLogo16": "",
            "ProjectLogoFill16": "",
            "SwayLogo32": "",
            "SwayLogoFill32": "",
            "SwayLogo16": "",
            "SwayLogoFill16": "",
            "ClassNotebookLogo32": "",
            "ClassNotebookLogoFill32": "",
            "ClassNotebookLogo16": "",
            "ClassNotebookLogoFill16": "",
            "ClassNotebookLogoInverse32": "",
            "ClassNotebookLogoInverse16": "",
            "StaffNotebookLogo32": "",
            "StaffNotebookLogoFill32": "",
            "StaffNotebookLogo16": "",
            "StaffNotebookLogoFill16": "",
            "StaffNotebookLogoInverted32": "",
            "StaffNotebookLogoInverted16": "",
            "KaizalaLogo": "",
            "TaskLogo": "",
            "ProtectionCenterLogo32": "",
            "GallatinLogo": "",
            "Globe2": "",
            "Guitar": "",
            "Breakfast": "",
            "Brunch": "",
            "BeerMug": "",
            "Vacation": "",
            "Teeth": "",
            "Taxi": "",
            "Chopsticks": "",
            "SyncOccurence": "",
            "UnsyncOccurence": "",
            "GIF": "",
            "PrimaryCalendar": "",
            "SearchCalendar": "",
            "VideoOff": "",
            "MicrosoftFlowLogo": "",
            "BusinessCenterLogo": "",
            "ToDoLogoBottom": "",
            "ToDoLogoTop": "",
            "EditSolid12": "",
            "EditSolidMirrored12": "",
            "UneditableSolid12": "",
            "UneditableSolidMirrored12": "",
            "UneditableMirrored": "",
            "AdminALogo32": "",
            "AdminALogoFill32": "",
            "ToDoLogoInverse": ""
        }
    };
    (0, $44598dd284782b17$export$99b432e1290ef823)(subset, options);
}


// Your use of the content in the files referenced here is subject to the terms of the license at https://aka.ms/fluentui-assets-license

function $4f9401b0b82cedef$export$daed2daeba655e15(baseUrl, options) {
    if (baseUrl === void 0) baseUrl = "";
    var subset = {
        style: {
            MozOsxFontSmoothing: "grayscale",
            WebkitFontSmoothing: "antialiased",
            fontStyle: "normal",
            fontWeight: "normal",
            speak: "none"
        },
        fontFace: {
            fontFamily: '"FabricMDL2Icons-14"',
            src: "url('".concat(baseUrl, "fabric-icons-14-5cf58db8.woff') format('woff')")
        },
        icons: {
            "Snooze": "",
            "WaffleOffice365": "",
            "ImageSearch": "",
            "NewsSearch": "",
            "VideoSearch": "",
            "R": "",
            "FontColorA": "",
            "FontColorSwatch": "",
            "LightWeight": "",
            "NormalWeight": "",
            "SemiboldWeight": "",
            "GroupObject": "",
            "UngroupObject": "",
            "AlignHorizontalLeft": "",
            "AlignHorizontalCenter": "",
            "AlignHorizontalRight": "",
            "AlignVerticalTop": "",
            "AlignVerticalCenter": "",
            "AlignVerticalBottom": "",
            "HorizontalDistributeCenter": "",
            "VerticalDistributeCenter": "",
            "Ellipse": "",
            "Line": "",
            "Octagon": "",
            "Hexagon": "",
            "Pentagon": "",
            "RightTriangle": "",
            "HalfCircle": "",
            "QuarterCircle": "",
            "ThreeQuarterCircle": "",
            "6PointStar": "",
            "12PointStar": "",
            "ArrangeBringToFront": "",
            "ArrangeSendToBack": "",
            "ArrangeSendBackward": "",
            "ArrangeBringForward": "",
            "BorderDash": "",
            "BorderDot": "",
            "LineStyle": "",
            "LineThickness": "",
            "WindowEdit": "",
            "HintText": "",
            "MediaAdd": "",
            "AnchorLock": "",
            "AutoHeight": "",
            "ChartSeries": "",
            "ChartXAngle": "",
            "ChartYAngle": "",
            "Combobox": "",
            "LineSpacing": "",
            "Padding": "",
            "PaddingTop": "",
            "PaddingBottom": "",
            "PaddingLeft": "",
            "PaddingRight": "",
            "NavigationFlipper": "",
            "AlignJustify": "",
            "TextOverflow": "",
            "VisualsFolder": "",
            "VisualsStore": "",
            "PictureCenter": "",
            "PictureFill": "",
            "PicturePosition": "",
            "PictureStretch": "",
            "PictureTile": "",
            "Slider": "",
            "SliderHandleSize": "",
            "DefaultRatio": "",
            "NumberSequence": "",
            "GUID": "",
            "ReportAdd": "",
            "DashboardAdd": "",
            "MapPinSolid": "",
            "WebPublish": "",
            "PieSingleSolid": "",
            "BlockedSolid": "",
            "DrillDown": "",
            "DrillDownSolid": "",
            "DrillExpand": "",
            "DrillShow": "",
            "SpecialEvent": "",
            "OneDriveFolder16": "",
            "FunctionalManagerDashboard": "",
            "BIDashboard": "",
            "CodeEdit": "",
            "RenewalCurrent": "",
            "RenewalFuture": "",
            "SplitObject": "",
            "BulkUpload": "",
            "DownloadDocument": "",
            "GreetingCard": "",
            "Flower": "",
            "WaitlistConfirm": "",
            "WaitlistConfirmMirrored": "",
            "LaptopSecure": "",
            "DragObject": "",
            "EntryView": "",
            "EntryDecline": "",
            "ContactCardSettings": "",
            "ContactCardSettingsMirrored": ""
        }
    };
    (0, $44598dd284782b17$export$99b432e1290ef823)(subset, options);
}


// Your use of the content in the files referenced here is subject to the terms of the license at https://aka.ms/fluentui-assets-license

function $6a2cd399c6784655$export$daed2daeba655e15(baseUrl, options) {
    if (baseUrl === void 0) baseUrl = "";
    var subset = {
        style: {
            MozOsxFontSmoothing: "grayscale",
            WebkitFontSmoothing: "antialiased",
            fontStyle: "normal",
            fontWeight: "normal",
            speak: "none"
        },
        fontFace: {
            fontFamily: '"FabricMDL2Icons-15"',
            src: "url('".concat(baseUrl, "fabric-icons-15-3807251b.woff') format('woff')")
        },
        icons: {
            "CalendarSettings": "",
            "CalendarSettingsMirrored": "",
            "HardDriveLock": "",
            "HardDriveUnlock": "",
            "AccountManagement": "",
            "ReportWarning": "",
            "TransitionPop": "",
            "TransitionPush": "",
            "TransitionEffect": "",
            "LookupEntities": "",
            "ExploreData": "",
            "AddBookmark": "",
            "SearchBookmark": "",
            "DrillThrough": "",
            "MasterDatabase": "",
            "CertifiedDatabase": "",
            "MaximumValue": "",
            "MinimumValue": "",
            "VisualStudioIDELogo32": "",
            "PasteAsText": "",
            "PasteAsCode": "",
            "BrowserTab": "",
            "BrowserTabScreenshot": "",
            "DesktopScreenshot": "",
            "FileYML": "",
            "ClipboardSolid": "",
            "FabricUserFolder": "",
            "FabricNetworkFolder": "",
            "BullseyeTarget": "",
            "AnalyticsView": "",
            "Video360Generic": "",
            "Untag": "",
            "Leave": "",
            "Trending12": "",
            "Blocked12": "",
            "Warning12": "",
            "CheckedOutByOther12": "",
            "CheckedOutByYou12": "",
            "CircleShapeSolid": "",
            "SquareShapeSolid": "",
            "TriangleShapeSolid": "",
            "DropShapeSolid": "",
            "RectangleShapeSolid": "",
            "ZoomToFit": "",
            "InsertColumnsLeft": "",
            "InsertColumnsRight": "",
            "InsertRowsAbove": "",
            "InsertRowsBelow": "",
            "DeleteColumns": "",
            "DeleteRows": "",
            "DeleteRowsMirrored": "",
            "DeleteTable": "",
            "AccountBrowser": "",
            "VersionControlPush": "",
            "StackedColumnChart2": "",
            "TripleColumnWide": "",
            "QuadColumn": "",
            "WhiteBoardApp16": "",
            "WhiteBoardApp32": "",
            "PinnedSolid": "",
            "InsertSignatureLine": "",
            "ArrangeByFrom": "",
            "Phishing": "",
            "CreateMailRule": "",
            "PublishCourse": "",
            "DictionaryRemove": "",
            "UserRemove": "",
            "UserEvent": "",
            "Encryption": "",
            "PasswordField": "",
            "OpenInNewTab": "",
            "Hide3": "",
            "VerifiedBrandSolid": "",
            "MarkAsProtected": "",
            "AuthenticatorApp": "",
            "WebTemplate": "",
            "DefenderTVM": "",
            "MedalSolid": "",
            "D365TalentLearn": "",
            "D365TalentInsight": "",
            "D365TalentHRCore": "",
            "BacklogList": "",
            "ButtonControl": "",
            "TableGroup": "",
            "MountainClimbing": "",
            "TagUnknown": "",
            "TagUnknownMirror": "",
            "TagUnknown12": "",
            "TagUnknown12Mirror": "",
            "Link12": "",
            "Presentation": "",
            "Presentation12": "",
            "Lock12": "",
            "BuildDefinition": "",
            "ReleaseDefinition": "",
            "SaveTemplate": "",
            "UserGauge": "",
            "BlockedSiteSolid12": "",
            "TagSolid": "",
            "OfficeChat": ""
        }
    };
    (0, $44598dd284782b17$export$99b432e1290ef823)(subset, options);
}


// Your use of the content in the files referenced here is subject to the terms of the license at https://aka.ms/fluentui-assets-license

function $4cbb2f38b1fb0998$export$daed2daeba655e15(baseUrl, options) {
    if (baseUrl === void 0) baseUrl = "";
    var subset = {
        style: {
            MozOsxFontSmoothing: "grayscale",
            WebkitFontSmoothing: "antialiased",
            fontStyle: "normal",
            fontWeight: "normal",
            speak: "none"
        },
        fontFace: {
            fontFamily: '"FabricMDL2Icons-16"',
            src: "url('".concat(baseUrl, "fabric-icons-16-9cf93f3b.woff') format('woff')")
        },
        icons: {
            "OfficeChatSolid": "",
            "MailSchedule": "",
            "WarningSolid": "",
            "Blocked2Solid": "",
            "SkypeCircleArrow": "",
            "SkypeArrow": "",
            "SyncStatus": "",
            "SyncStatusSolid": "",
            "ProjectDocument": "",
            "ToDoLogoOutline": "",
            "VisioOnlineLogoFill32": "",
            "VisioOnlineLogo32": "",
            "VisioOnlineLogoCloud32": "",
            "VisioDiagramSync": "",
            "Event12": "",
            "EventDateMissed12": "",
            "UserOptional": "",
            "ResponsesMenu": "",
            "DoubleDownArrow": "",
            "DistributeDown": "",
            "BookmarkReport": "",
            "FilterSettings": "",
            "GripperDotsVertical": "",
            "MailAttached": "",
            "AddIn": "",
            "LinkedDatabase": "",
            "TableLink": "",
            "PromotedDatabase": "",
            "BarChartVerticalFilter": "",
            "BarChartVerticalFilterSolid": "",
            "MicOff2": "",
            "MicrosoftTranslatorLogo": "",
            "ShowTimeAs": "",
            "FileRequest": "",
            "WorkItemAlert": "",
            "PowerBILogo16": "",
            "PowerBILogoBackplate16": "",
            "BulletedListText": "",
            "BulletedListBullet": "",
            "BulletedListTextMirrored": "",
            "BulletedListBulletMirrored": "",
            "NumberedListText": "",
            "NumberedListNumber": "",
            "NumberedListTextMirrored": "",
            "NumberedListNumberMirrored": "",
            "RemoveLinkChain": "",
            "RemoveLinkX": "",
            "FabricTextHighlight": "",
            "ClearFormattingA": "",
            "ClearFormattingEraser": "",
            "Photo2Fill": "",
            "IncreaseIndentText": "",
            "IncreaseIndentArrow": "",
            "DecreaseIndentText": "",
            "DecreaseIndentArrow": "",
            "IncreaseIndentTextMirrored": "",
            "IncreaseIndentArrowMirrored": "",
            "DecreaseIndentTextMirrored": "",
            "DecreaseIndentArrowMirrored": "",
            "CheckListText": "",
            "CheckListCheck": "",
            "CheckListTextMirrored": "",
            "CheckListCheckMirrored": "",
            "NumberSymbol": "",
            "Coupon": "",
            "VerifiedBrand": "",
            "ReleaseGate": "",
            "ReleaseGateCheck": "",
            "ReleaseGateError": "",
            "M365InvoicingLogo": "",
            "RemoveFromShoppingList": "",
            "ShieldAlert": "",
            "FabricTextHighlightComposite": "",
            "Dataflows": "",
            "GenericScanFilled": "",
            "DiagnosticDataBarTooltip": "",
            "SaveToMobile": "",
            "Orientation2": "",
            "ScreenCast": "",
            "ShowGrid": "",
            "SnapToGrid": "",
            "ContactList": "",
            "NewMail": "",
            "EyeShadow": "",
            "FabricFolderConfirm": "",
            "InformationBarriers": "",
            "CommentActive": "",
            "ColumnVerticalSectionEdit": "",
            "WavingHand": "",
            "ShakeDevice": "",
            "SmartGlassRemote": "",
            "Rotate90Clockwise": "",
            "Rotate90CounterClockwise": "",
            "CampaignTemplate": "",
            "ChartTemplate": "",
            "PageListFilter": "",
            "SecondaryNav": "",
            "ColumnVerticalSection": "",
            "SkypeCircleSlash": "",
            "SkypeSlash": ""
        }
    };
    (0, $44598dd284782b17$export$99b432e1290ef823)(subset, options);
}


// Your use of the content in the files referenced here is subject to the terms of the license at https://aka.ms/fluentui-assets-license

function $7c15fbb2f92f505e$export$daed2daeba655e15(baseUrl, options) {
    if (baseUrl === void 0) baseUrl = "";
    var subset = {
        style: {
            MozOsxFontSmoothing: "grayscale",
            WebkitFontSmoothing: "antialiased",
            fontStyle: "normal",
            fontWeight: "normal",
            speak: "none"
        },
        fontFace: {
            fontFamily: '"FabricMDL2Icons-17"',
            src: "url('".concat(baseUrl, "fabric-icons-17-0c4ed701.woff') format('woff')")
        },
        icons: {
            "CustomizeToolbar": "",
            "DuplicateRow": "",
            "RemoveFromTrash": "",
            "MailOptions": "",
            "Childof": "",
            "Footer": "",
            "Header": "",
            "BarChartVerticalFill": "",
            "StackedColumnChart2Fill": "",
            "PlainText": "",
            "AccessibiltyChecker": "",
            "DatabaseSync": "",
            "ReservationOrders": "",
            "TabOneColumn": "",
            "TabTwoColumn": "",
            "TabThreeColumn": "",
            "BulletedTreeList": "",
            "MicrosoftTranslatorLogoGreen": "",
            "MicrosoftTranslatorLogoBlue": "",
            "InternalInvestigation": "",
            "AddReaction": "",
            "ContactHeart": "",
            "VisuallyImpaired": "",
            "EventToDoLogo": "",
            "Variable2": "",
            "ModelingView": "",
            "DisconnectVirtualMachine": "",
            "ReportLock": "",
            "Uneditable2": "",
            "Uneditable2Mirrored": "",
            "BarChartVerticalEdit": "",
            "GlobalNavButtonActive": "",
            "PollResults": "",
            "Rerun": "",
            "QandA": "",
            "QandAMirror": "",
            "BookAnswers": "",
            "AlertSettings": "",
            "TrimStart": "",
            "TrimEnd": "",
            "TableComputed": "",
            "DecreaseIndentLegacy": "",
            "IncreaseIndentLegacy": "",
            "SizeLegacy": ""
        }
    };
    (0, $44598dd284782b17$export$99b432e1290ef823)(subset, options);
}




var $06bf3f318da564ed$export$9836c3198c99edae = function() {
    (0, $44598dd284782b17$export$4fad376c7613260)("trash", "delete");
    (0, $44598dd284782b17$export$4fad376c7613260)("onedrive", "onedrivelogo");
    (0, $44598dd284782b17$export$4fad376c7613260)("alertsolid12", "eventdatemissed12");
    (0, $44598dd284782b17$export$4fad376c7613260)("sixpointstar", "6pointstar");
    (0, $44598dd284782b17$export$4fad376c7613260)("twelvepointstar", "12pointstar");
    (0, $44598dd284782b17$export$4fad376c7613260)("toggleon", "toggleleft");
    (0, $44598dd284782b17$export$4fad376c7613260)("toggleoff", "toggleright");
};
var $06bf3f318da564ed$export$2e2bcd8739ae039 = $06bf3f318da564ed$export$9836c3198c99edae;



// Do not modify this file; it is generated as part of publish.
// The checked in version is a placeholder only and will not be updated.

(0, $886f0d32cc24089c$export$f99c3c9c04cda7ae)("@fluentui/font-icons-mdl2", "8.5.21");


var $d668900f9755141e$var$DEFAULT_BASE_URL = "".concat((0, $16e0681304e1db17$export$61818e3b2f7b5d12), "/assets/icons/");
var $d668900f9755141e$var$win = (0, $109c028fea018492$export$38b2d434cce3ea22)();
function $d668900f9755141e$export$daed2daeba655e15(baseUrl, options) {
    var _a, _b;
    if (baseUrl === void 0) baseUrl = ((_a = $d668900f9755141e$var$win === null || $d668900f9755141e$var$win === void 0 ? void 0 : $d668900f9755141e$var$win.FabricConfig) === null || _a === void 0 ? void 0 : _a.iconBaseUrl) || ((_b = $d668900f9755141e$var$win === null || $d668900f9755141e$var$win === void 0 ? void 0 : $d668900f9755141e$var$win.FabricConfig) === null || _b === void 0 ? void 0 : _b.fontBaseUrl) || $d668900f9755141e$var$DEFAULT_BASE_URL;
    [
        (0, $00899995ba8cdbb5$export$daed2daeba655e15),
        (0, $11501ede8f3e9220$export$daed2daeba655e15),
        (0, $597129c96331b5dd$export$daed2daeba655e15),
        (0, $3fb1fdfa2a82adeb$export$daed2daeba655e15),
        (0, $edffabbaeab0660c$export$daed2daeba655e15),
        (0, $5994872aa61308d3$export$daed2daeba655e15),
        (0, $9c99ff6af0115050$export$daed2daeba655e15),
        (0, $d151d84c28c94532$export$daed2daeba655e15),
        (0, $cdbdab2a9653c3e5$export$daed2daeba655e15),
        (0, $edae70a72c6a7a60$export$daed2daeba655e15),
        (0, $4f7ad8921db3fa1f$export$daed2daeba655e15),
        (0, $23391c75f43d71f2$export$daed2daeba655e15),
        (0, $d16dd188875b8cc4$export$daed2daeba655e15),
        (0, $9087b5e6b6b2c950$export$daed2daeba655e15),
        (0, $faace2758a0adb7d$export$daed2daeba655e15),
        (0, $4f9401b0b82cedef$export$daed2daeba655e15),
        (0, $6a2cd399c6784655$export$daed2daeba655e15),
        (0, $4cbb2f38b1fb0998$export$daed2daeba655e15),
        (0, $7c15fbb2f92f505e$export$daed2daeba655e15)
    ].forEach(function(initialize) {
        return initialize(baseUrl, options);
    });
    (0, $06bf3f318da564ed$export$9836c3198c99edae)();
}



parcelRequire("eO7Kz");

const $ca7727ba78b87422$export$f23ef6cb462a47f7 = (element)=>{
    const div = document.createElement("div");
    div.style.width = "100%";
    const root = (0, $c244115e8f747aae$export$882461b6382ed46c)(div);
    root.render(element);
    return div;
};



var $eDhMr = parcelRequire("eDhMr");



var $eO7Kz = parcelRequire("eO7Kz");

const $65c53156e2137f30$var$getSizeFromEnum = (size)=>{
    switch(size){
        case (0, $d47cbf04a0a44873$exports.TextSize).Small:
            return "rf-small-size-auto";
        case (0, $d47cbf04a0a44873$exports.TextSize).Medium:
            return "rf-text-medium-size-auto";
        case (0, $d47cbf04a0a44873$exports.TextSize).Large:
            return "rf-text-large-size-auto";
        case (0, $d47cbf04a0a44873$exports.TextSize).ExtraLarge:
            return "rf-text-extralarge-size-auto";
        case (0, $d47cbf04a0a44873$exports.TextSize).Default:
        default:
            return "rf-text-size-auto";
    }
};
const $65c53156e2137f30$var$TextBlock = ({ text: text, isTitle: isTitle, isSubtitle: isSubtitle, size: size, horizontalAlignment: horizontalAlignment, wrap: wrap, maxLines: maxLines })=>{
    const [style, setStyle] = (0, $eO7Kz.useState)("");
    (0, $eO7Kz.useEffect)(()=>{
        if (text) {
            // Text size
            let styleToApply = isTitle ? "rf-title-size-auto" : isSubtitle ? "rf-subtitle-size-auto" : size ? $65c53156e2137f30$var$getSizeFromEnum(size) : "rf-text-size-auto";
            // Text horizontal alignment
            if (horizontalAlignment) switch(horizontalAlignment){
                case 1:
                    styleToApply += " rf-text-center";
                    break;
                case 2:
                    styleToApply += " rf-text-right";
                    break;
                case 0:
                default:
                    styleToApply += " rf-text-left";
                    break;
            }
            else styleToApply += " rf-text-left";
            // Wrap ?
            wrap ? (isTitle || isSubtitle) && (styleToApply += " rf-line-clamp-2") : styleToApply += " rf-truncate";
            // Max lines ? If this is a title it has already been set to 2 lines if wrap is not false
            !isTitle && maxLines && maxLines > 0 && maxLines <= 10 && (styleToApply += ` rf-line-clamp-${maxLines}`);
            setStyle(styleToApply);
        }
    }, []);
    return text ? /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("div", {
        className: `rf-w-full rf-text-cardFrameText ${style}`,
        children: (0, $8fd1ab545cc1ab7a$export$d07f57595c356899)(text)
    }) : /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eO7Kz))).Fragment, {});
};
var $65c53156e2137f30$export$2e2bcd8739ae039 = $65c53156e2137f30$var$TextBlock;



class $6c27d03abb27bc22$export$92739f4310a31a0d extends (0, $eDhMr.TextBlock) {
    internalRender() {
        const element = (0, $ca7727ba78b87422$export$f23ef6cb462a47f7)(this.renderReact());
        return element;
    }
    renderReact = ()=>{
        let isTitle = false;
        let isSubtitle = false;
        if (this.size && this.size === (0, $d47cbf04a0a44873$exports.TextSize).Large) isTitle = true;
        else if (this.size && this.size === (0, $d47cbf04a0a44873$exports.TextSize).Medium) isSubtitle = true;
        const props = {
            text: this.text,
            isTitle: isTitle,
            isSubtitle: isSubtitle,
            size: this.size,
            horizontalAlignment: this.horizontalAlignment,
            wrap: this.wrap,
            maxLines: this.maxLines
        };
        return /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $65c53156e2137f30$export$2e2bcd8739ae039), {
            ...props
        });
    };
}


/* eslint-disable react/jsx-boolean-value */ 

var $eO7Kz = parcelRequire("eO7Kz");


var $eDhMr = parcelRequire("eDhMr");


var $eO7Kz = parcelRequire("eO7Kz");


const $dcb3b373c5027d86$export$b5ed0bbebfb6af43 = (id, defaultData)=>{
    let value = defaultData;
    const currentData = JSON.parse(localStorage.getItem("Retorik.Framework.Inputs") || "null");
    if (currentData && Array.isArray(currentData)) currentData.forEach((data)=>{
        if (data.id === id) value = data.value;
    });
    return value;
};
const $dcb3b373c5027d86$export$3bf0495508a61ee = (id, value)=>{
    const currentData = JSON.parse(localStorage.getItem("Retorik.Framework.Inputs") || "null");
    if (currentData && Array.isArray(currentData)) {
        let changed = false;
        currentData.forEach((data)=>{
            if (data.id === id) {
                data.value = value;
                changed = true;
            }
        });
        // If some data were changed
        if (changed) localStorage.setItem("Retorik.Framework.Inputs", JSON.stringify(currentData));
        else {
            const newData = [
                ...currentData,
                {
                    id: id,
                    value: value
                }
            ];
            localStorage.setItem("Retorik.Framework.Inputs", JSON.stringify(newData));
        }
    } else localStorage.setItem("Retorik.Framework.Inputs", JSON.stringify([
        {
            id: id,
            value: value
        }
    ]));
};



const $dea1aa47b59a74de$var$InputToggle = ({ id: id, title: title, handleChange: handleChange, valueOn: valueOn, defaultValue: defaultValue })=>{
    const { currentSubView: currentSubView } = (0, $134592d23f105dbc$export$77e4cc5334565f28)();
    const [on, setOn] = (0, $eO7Kz.useState)((0, $dcb3b373c5027d86$export$b5ed0bbebfb6af43)(id, defaultValue) === valueOn);
    /**
   * On call :
   *  - check if the component will be rendered in history, if so bypass every interaction
   *  - call parent's handleChange method
   *  - set on state to its opposite
   */ const handleToggle = ()=>{
        if (currentSubView !== (0, $16ad089b9ce6627d$export$f05d0fed0593ead7).history) {
            handleChange(!on);
            setOn(!on);
        }
    };
    return /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("div", {
        className: "rf-w-full rf-flex rf-flex-row rf-items-start rf-text-size-auto rf-text-white",
        children: /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsxs)("label", {
            className: "rf-flex rf-flex-row rf-items-start",
            children: [
                /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("input", {
                    type: "checkbox",
                    onChange: handleToggle,
                    className: "rf-toggle-custom",
                    checked: on
                }),
                /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("div", {
                    className: "rf-input-label",
                    children: (0, $8fd1ab545cc1ab7a$export$d07f57595c356899)(title || id)
                })
            ]
        })
    });
};
var $dea1aa47b59a74de$export$2e2bcd8739ae039 = $dea1aa47b59a74de$var$InputToggle;



class $cb0e37c77bf07f7e$export$c99bfd6b0ed44fbd extends (0, $eDhMr.ToggleInput) {
    _value = this.defaultValue || this.valueOff;
    get value() {
        return this._value;
    }
    isSet() {
        return this._value;
    }
    handleChange = (on)=>{
        this._value = on ? this.valueOn : this.valueOff;
        this.id && (0, $dcb3b373c5027d86$export$3bf0495508a61ee)(this.id, on ? this.valueOn : this.valueOff);
    };
    internalRender() {
        const element = (0, $ca7727ba78b87422$export$f23ef6cb462a47f7)(this.renderReact());
        return element;
    }
    renderReact = ()=>{
        return this.id ? /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $dea1aa47b59a74de$export$2e2bcd8739ae039), {
            id: this.id,
            title: this.title,
            handleChange: this.handleChange,
            valueOn: this.valueOn,
            defaultValue: this.defaultValue || this.valueOff
        }) : /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eO7Kz))).Fragment, {});
    };
}


/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $49f51cfbe488d9fc$var$extendStatics = function(d, b) {
    $49f51cfbe488d9fc$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $49f51cfbe488d9fc$var$extendStatics(d, b);
};
function $49f51cfbe488d9fc$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $49f51cfbe488d9fc$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $49f51cfbe488d9fc$export$18ce0697a983be9b = function() {
    $49f51cfbe488d9fc$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $49f51cfbe488d9fc$export$18ce0697a983be9b.apply(this, arguments);
};
function $49f51cfbe488d9fc$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $49f51cfbe488d9fc$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $49f51cfbe488d9fc$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $49f51cfbe488d9fc$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $49f51cfbe488d9fc$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $49f51cfbe488d9fc$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $49f51cfbe488d9fc$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $49f51cfbe488d9fc$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $49f51cfbe488d9fc$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $49f51cfbe488d9fc$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $49f51cfbe488d9fc$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $49f51cfbe488d9fc$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $49f51cfbe488d9fc$export$45d3717a4c69092e(o, m, p);
}
function $49f51cfbe488d9fc$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $49f51cfbe488d9fc$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $49f51cfbe488d9fc$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($49f51cfbe488d9fc$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $49f51cfbe488d9fc$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $49f51cfbe488d9fc$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $49f51cfbe488d9fc$export$10c90e4f7922046c(v) {
    return this instanceof $49f51cfbe488d9fc$export$10c90e4f7922046c ? (this.v = v, this) : new $49f51cfbe488d9fc$export$10c90e4f7922046c(v);
}
function $49f51cfbe488d9fc$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $49f51cfbe488d9fc$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $49f51cfbe488d9fc$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $49f51cfbe488d9fc$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $49f51cfbe488d9fc$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $49f51cfbe488d9fc$export$19a8beecd37a4c45 === "function" ? $49f51cfbe488d9fc$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $49f51cfbe488d9fc$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $49f51cfbe488d9fc$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function $49f51cfbe488d9fc$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $49f51cfbe488d9fc$export$45d3717a4c69092e(result, mod, k);
    }
    $49f51cfbe488d9fc$var$__setModuleDefault(result, mod);
    return result;
}
function $49f51cfbe488d9fc$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $49f51cfbe488d9fc$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $49f51cfbe488d9fc$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $49f51cfbe488d9fc$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
var $49f51cfbe488d9fc$export$2e2bcd8739ae039 = {
    __extends: $49f51cfbe488d9fc$export$a8ba968b8961cb8a,
    __assign: $49f51cfbe488d9fc$export$18ce0697a983be9b,
    __rest: $49f51cfbe488d9fc$export$3c9a16f847548506,
    __decorate: $49f51cfbe488d9fc$export$29e00dfd3077644b,
    __param: $49f51cfbe488d9fc$export$d5ad3fd78186038f,
    __metadata: $49f51cfbe488d9fc$export$f1db080c865becb9,
    __awaiter: $49f51cfbe488d9fc$export$1050f835b63b671e,
    __generator: $49f51cfbe488d9fc$export$67ebef60e6f28a6,
    __createBinding: $49f51cfbe488d9fc$export$45d3717a4c69092e,
    __exportStar: $49f51cfbe488d9fc$export$f33643c0debef087,
    __values: $49f51cfbe488d9fc$export$19a8beecd37a4c45,
    __read: $49f51cfbe488d9fc$export$8d051b38c9118094,
    __spread: $49f51cfbe488d9fc$export$afc72e2116322959,
    __spreadArrays: $49f51cfbe488d9fc$export$6388937ca91ccae8,
    __spreadArray: $49f51cfbe488d9fc$export$1216008129fb82ed,
    __await: $49f51cfbe488d9fc$export$10c90e4f7922046c,
    __asyncGenerator: $49f51cfbe488d9fc$export$e427f37a30a4de9b,
    __asyncDelegator: $49f51cfbe488d9fc$export$bbd80228419bb833,
    __asyncValues: $49f51cfbe488d9fc$export$e3b29a3d6162315f,
    __makeTemplateObject: $49f51cfbe488d9fc$export$4fb47efe1390b86f,
    __importStar: $49f51cfbe488d9fc$export$c21735bcef00d192,
    __importDefault: $49f51cfbe488d9fc$export$da59b14a69baef04,
    __classPrivateFieldGet: $49f51cfbe488d9fc$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $49f51cfbe488d9fc$export$d40a35129aaff81f,
    __classPrivateFieldIn: $49f51cfbe488d9fc$export$81fdc39f203e4e04
};




var $eO7Kz = parcelRequire("eO7Kz");


var $eDhMr = parcelRequire("eDhMr");


var $eO7Kz = parcelRequire("eO7Kz");



const $8d815798cd441aa9$export$ffedad9fbd47bff0 = (id, dateAsString)=>{
    // Test local storage first, then parameter dateAsString, finally get current date if nothing has been found
    const dateFromLocalStorage = (0, $dcb3b373c5027d86$export$b5ed0bbebfb6af43)(id, dateAsString);
    if (dateFromLocalStorage) {
        const resultFromLocal = $8d815798cd441aa9$var$processSplitDate(dateFromLocalStorage.split("-"));
        if (resultFromLocal) return resultFromLocal;
    }
    const now = new Date();
    return [
        now.getFullYear(),
        now.getMonth() + 1,
        now.getDate()
    ];
};
const $8d815798cd441aa9$var$processSplitDate = (splitDate)=>{
    if (splitDate.length === 3) {
        const year = parseInt(splitDate[0]);
        const month = parseInt(splitDate[1]);
        const day = parseInt(splitDate[2]);
        if (!isNaN(year) && !isNaN(month) && !isNaN(day)) return [
            year,
            month,
            day
        ];
    }
    return undefined;
};
const $8d815798cd441aa9$export$9e9b71dbaf488f87 = (month, locale)=>{
    const date = new Date(`2000-${month}-1`).toLocaleString(locale, {
        month: "long"
    });
    return date;
};





/**
 * Oddmonths used to calculate the max amount of days in a month
 */ const $8d388d75fbf3858b$var$oddMonths = [
    4,
    6,
    9,
    11
];
const $8d388d75fbf3858b$var$InputDate = ({ id: id, defaultValue: defaultValue, maxValue: maxValue, minValue: minValue, handleChange: handleChange })=>{
    const { locale: locale } = (0, $2e4dc8fa28d39601$export$6650dace022cfacc)();
    const { currentSubView: currentSubView } = (0, $134592d23f105dbc$export$77e4cc5334565f28)();
    const [year, setYear] = (0, $eO7Kz.useState)(2023);
    const [month, setMonth] = (0, $eO7Kz.useState)(1);
    const [day, setDay] = (0, $eO7Kz.useState)(1);
    const [maxYear, setMaxYear] = (0, $eO7Kz.useState)(0);
    const [minYear, setMinYear] = (0, $eO7Kz.useState)(100000);
    const [maxMonth, setMaxMonth] = (0, $eO7Kz.useState)(12);
    const [minMonth, setMinMonth] = (0, $eO7Kz.useState)(1);
    const [maxDay, setMaxDay] = (0, $eO7Kz.useState)(31);
    const [minDay, setMinDay] = (0, $eO7Kz.useState)(1);
    const [maxValueAsDate, setMaxValueAsDate] = (0, $eO7Kz.useState)(undefined);
    const [minValueAsDate, setMinValueAsDate] = (0, $eO7Kz.useState)(undefined);
    const [updatingDate, setUpdatingDate] = (0, $eO7Kz.useState)(false);
    const [dayWheel, setDayWheel] = (0, $eO7Kz.useState)(0);
    const [monthWheel, setMonthWheel] = (0, $eO7Kz.useState)(0);
    const [yearWheel, setYearWheel] = (0, $eO7Kz.useState)(0);
    const days = (0, $eO7Kz.useMemo)(()=>{
        if (month && year) {
            // If we check the february month, either 28 or 29 days depending on the year
            if (month === 2) return year % 4 === 0 ? 29 : 28;
            // 30 days for oddMonths, 31 otherwise
            return $8d388d75fbf3858b$var$oddMonths.includes(month) ? 30 : 31;
        }
        return undefined;
    }, [
        month,
        year
    ]);
    /**
   * On days state change :
   *  - set day state if current day is higher than days
   */ (0, $eO7Kz.useEffect)(()=>{
        day && days && day > days && setDay(days);
    }, [
        days
    ]);
    /**
   * On component mount :
   *  - set day / month / year from localStorage value if there is one, current Date otherwise
   *  - set max values from props or current Date + 150 years otherwise
   */ (0, $eO7Kz.useEffect)(()=>{
        const dateAsArray = (0, $8d815798cd441aa9$export$ffedad9fbd47bff0)(id, defaultValue);
        setYear(dateAsArray[0]);
        setMonth(dateAsArray[1]);
        setDay(dateAsArray[2]);
        // Set min and max years
        const now = new Date();
        if (maxValue) {
            const maxAsDate = new Date(maxValue);
            setMaxValueAsDate(maxAsDate);
            setMaxYear(maxAsDate.getFullYear());
            setMaxMonth(maxAsDate.getMonth() + 1);
            setMaxDay(maxAsDate.getDate());
        } else setMaxYear(now.getFullYear() + 150);
        if (minValue) {
            const minAsDate = new Date(minValue);
            setMinValueAsDate(minAsDate);
            setMinYear(minAsDate.getFullYear());
            setMinMonth(minAsDate.getMonth() + 1);
            setMinDay(minAsDate.getDate());
        } else setMinYear(now.getFullYear() - 150);
    }, []);
    /**
   * On day / month / year state change :
   *  - check if a day / month / year change is needed to keep the date a proper one
   *  - for example on february, there are either 28 or 29 days depending on the year
   *  - set the value in localStorage
   *  - if an update is needed, set the updatingDate state to true to prevent concurrent modification, update, and set updatingdate back to false to release lock
   */ (0, $eO7Kz.useEffect)(()=>{
        // Check if we are in the bounds of minValue and maxValue if there are some
        if (!updatingDate && day && month && year) {
            let updating = false;
            let dateAsString = `${year}-${month}-${day}`;
            const date = new Date(dateAsString);
            if (minValue && minValueAsDate && date < minValueAsDate) {
                dateAsString = minValue;
                updating = true;
            } else if (maxValue && maxValueAsDate && date > maxValueAsDate) {
                dateAsString = maxValue;
                updating = true;
            }
            // Save date
            handleChange(dateAsString);
            // Update states if necessary
            if (updating) {
                setUpdatingDate(true);
                const dateAsArray = dateAsString.split("-");
                setYear(parseInt(dateAsArray[0]));
                setMonth(parseInt(dateAsArray[1]));
                setDay(parseInt(dateAsArray[2]));
                setUpdatingDate(false);
            }
        }
    }, [
        day,
        month,
        year
    ]);
    /**
   * On dayWheel change, if dayWheel !== 0 :
   *  - try to update the day state
   *  - reset dayWheel state to 0
   */ (0, $eO7Kz.useEffect)(()=>{
        if (dayWheel !== 0 && day && days) {
            if (dayWheel > 0) day + 1 > days ? setDay(1) : setDay((day)=>day + 1);
            else day - 1 > 0 ? setDay((day)=>day - 1) : setDay(days);
            // Reset dayWheel
            setDayWheel(0);
        }
    }, [
        dayWheel
    ]);
    /**
   * On monthWheel change, if monthWheel !== 0 :
   *  - try to update the month state
   *  - reset monthWheel state to 0
   */ (0, $eO7Kz.useEffect)(()=>{
        if (monthWheel !== 0 && month) {
            if (monthWheel > 0) month + 1 > 12 ? setMonth(1) : setMonth((month)=>month + 1);
            else month - 1 > 0 ? setMonth((month)=>month - 1) : setMonth(12);
            // Reset monthWheel
            setMonthWheel(0);
        }
    }, [
        monthWheel
    ]);
    /**
   * On yearWheel change, if yearWheel !== 0 :
   *  - try to update the year state
   *  - reset yearWheel state to 0
   */ (0, $eO7Kz.useEffect)(()=>{
        if (yearWheel !== 0 && year && minYear && maxYear) {
            if (yearWheel > 0) year !== maxYear && setYear((year)=>year + 1);
            else year !== minYear && setYear((year)=>year - 1);
            // Reset yearWheel
            setYearWheel(0);
        }
    }, [
        yearWheel
    ]);
    /**
   * On wheel event on day / month / year part :
   *  - check if a hour / minute change is needed to respect minValue or maxValue
   *  - call wheel state depending on the type, that will trigger the related day / month / year state update if possible
   * @param delta : number
   * @param type : string
   */ const handleWheel = (delta, type)=>{
        if (currentSubView !== (0, $16ad089b9ce6627d$export$f05d0fed0593ead7).history) switch(type){
            case "day":
                setDayWheel(delta);
                break;
            case "month":
                setMonthWheel(delta);
                break;
            case "year":
                setYearWheel(delta);
                break;
            default:
                break;
        }
    };
    /**
   * On click on a day / month / year :
   *  - check if a hour / minute change is needed to respect minValue or maxValue
   *  - set chosen day / month / year if it is within the accepted bounds
   * @param value : number
   * @param type : string
   */ const handleClick = (value, type)=>{
        if (currentSubView !== (0, $16ad089b9ce6627d$export$f05d0fed0593ead7).history) switch(type){
            case "day":
                day && setDay(value);
                break;
            case "month":
                month && value !== -1 && setMonth(value);
                break;
            case "year":
                year && value !== -1 && setYear(value);
                break;
            default:
                break;
        }
    };
    return /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsxs)("div", {
        className: "rf-w-full rf-mt-4 rf-py-2 rf-flex rf-flex-row rf-justify-center rf-items-center rf-rounded-lg rf-subtitle-size-auto rf-text-formInputRadioCheckboxUncheckedBackground rf-unselectable",
        style: {
            background: "linear-gradient(rgb(0, 0, 0, 0.5) 0%, rgb(0, 0, 0, 0.5) 34%, black 34%, black 65%, rgb(0, 0, 0, 0.5) 65%, rgb(0, 0, 0, 0.5) 100%)"
        },
        children: [
            /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("input", {
                type: "date",
                className: "rf-hidden"
            }),
            year && month && day && /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($eO7Kz))).Fragment, {
                children: [
                    /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsxs)((0, $ea490a709941d5e3$export$2e2bcd8739ae039), {
                        className: "rf-flex rf-flex-col rf-items-center rf-px-4 rf-py-1",
                        handleWheel: handleWheel,
                        paramInHandle: "day",
                        children: [
                            /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("div", {
                                className: "rf-py-1 hover:rf-cursor-pointer",
                                onClick: ()=>handleClick(year === minYear && month === minMonth && day === minDay ? -1 : day === 1 ? days || 1 : day - 1, "day"),
                                children: year === minYear && month === minMonth && day === minDay ? "⠀" : day === 1 ? `${days}` : `${day - 1}`
                            }),
                            /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("div", {
                                className: "rf-py-1 rf-text-primary",
                                children: day
                            }),
                            /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("div", {
                                className: "rf-py-1 hover:rf-cursor-pointer",
                                onClick: ()=>handleClick(year === maxYear && month === maxMonth && day === maxDay ? -1 : day === days ? 1 : day + 1, "day"),
                                children: year === maxYear && month === maxMonth && day === maxDay ? "⠀" : day === days ? "1" : `${day + 1}`
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsxs)((0, $ea490a709941d5e3$export$2e2bcd8739ae039), {
                        className: "rf-flex rf-flex-col rf-items-center rf-px-4 rf-py-1",
                        handleWheel: handleWheel,
                        paramInHandle: "month",
                        children: [
                            /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("div", {
                                className: "rf-py-1 hover:rf-cursor-pointer",
                                onClick: ()=>handleClick(year === minYear && month === minMonth ? -1 : month === 1 ? 12 : month - 1, "month"),
                                children: year === minYear && month === minMonth ? "⠀" : month === 1 ? `${(0, $8fd1ab545cc1ab7a$export$d07f57595c356899)((0, $8d815798cd441aa9$export$9e9b71dbaf488f87)(12, locale))}` : `${(0, $8fd1ab545cc1ab7a$export$d07f57595c356899)((0, $8d815798cd441aa9$export$9e9b71dbaf488f87)(month - 1, locale))}`
                            }),
                            /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("div", {
                                className: "rf-py-1 rf-text-primary",
                                children: `${(0, $8fd1ab545cc1ab7a$export$d07f57595c356899)((0, $8d815798cd441aa9$export$9e9b71dbaf488f87)(month, locale))}`
                            }),
                            /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("div", {
                                className: "rf-py-1 hover:rf-cursor-pointer",
                                onClick: ()=>handleClick(year === maxYear && month === maxMonth ? -1 : month === 12 ? 1 : month + 1, "month"),
                                children: year === maxYear && month === maxMonth ? "⠀" : month === 12 ? `${(0, $8fd1ab545cc1ab7a$export$d07f57595c356899)((0, $8d815798cd441aa9$export$9e9b71dbaf488f87)(1, locale))}` : `${(0, $8fd1ab545cc1ab7a$export$d07f57595c356899)((0, $8d815798cd441aa9$export$9e9b71dbaf488f87)(month + 1, locale))}`
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsxs)((0, $ea490a709941d5e3$export$2e2bcd8739ae039), {
                        className: "rf-flex rf-flex-col rf-items-center rf-px-4 rf-py-1",
                        handleWheel: handleWheel,
                        paramInHandle: "year",
                        children: [
                            /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("div", {
                                className: "rf-py-1 hover:rf-cursor-pointer",
                                onClick: ()=>handleClick(year === minYear ? -1 : year - 1, "year"),
                                children: year === minYear ? "⠀" : year - 1
                            }),
                            /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("div", {
                                className: "rf-py-1 rf-text-primary",
                                children: year
                            }),
                            /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("div", {
                                className: "rf-py-1 hover:rf-cursor-pointer",
                                onClick: ()=>handleClick(year === maxYear ? -1 : year + 1, "year"),
                                children: year === maxYear ? "⠀" : year + 1
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $8d388d75fbf3858b$export$2e2bcd8739ae039 = $8d388d75fbf3858b$var$InputDate;




var $eO7Kz = parcelRequire("eO7Kz");






/**
 * Oddmonths used to calculate the max amount of days in a month
 */ const $cc34a7543405d90a$var$oddMonths = [
    4,
    6,
    9,
    11
];
const $cc34a7543405d90a$var$InputCalendar = ({ id: id, defaultValue: defaultValue, maxValue: maxValue, minValue: minValue, handleChange: handleChange, isFilter: isFilter })=>{
    const locale = (0, $2e4dc8fa28d39601$export$6650dace022cfacc)((state)=>state.locale);
    const { currentSubView: currentSubView } = (0, $134592d23f105dbc$export$77e4cc5334565f28)();
    const [year, setYear] = (0, $eO7Kz.useState)(2023);
    const [month, setMonth] = (0, $eO7Kz.useState)(1);
    const [day, setDay] = (0, $eO7Kz.useState)(1);
    const [maxYear, setMaxYear] = (0, $eO7Kz.useState)(0);
    const [minYear, setMinYear] = (0, $eO7Kz.useState)(100000);
    const [maxMonth, setMaxMonth] = (0, $eO7Kz.useState)(12);
    const [minMonth, setMinMonth] = (0, $eO7Kz.useState)(1);
    const [maxDay, setMaxDay] = (0, $eO7Kz.useState)(31);
    const [minDay, setMinDay] = (0, $eO7Kz.useState)(1);
    const [maxValueAsDate, setMaxValueAsDate] = (0, $eO7Kz.useState)(undefined);
    const [minValueAsDate, setMinValueAsDate] = (0, $eO7Kz.useState)(undefined);
    const [date, setDate] = (0, $eO7Kz.useState)(`${year}-${month}-${day}`);
    /**
   * On month / year states change :
   *  - calculate and return the number of days of the current month
   */ const days = (0, $eO7Kz.useMemo)(()=>{
        if (month && year) {
            // If we check the february month, either 28 or 29 days depending on the year
            if (month === 2) return year % 4 === 0 ? 29 : 28;
            // 30 days for oddMonths, 31 otherwise
            return $cc34a7543405d90a$var$oddMonths.includes(month) ? 30 : 31;
        }
        return undefined;
    }, [
        month,
        year
    ]);
    /**
   * On month / year states change :
   *  - check which day is the first day of the month
   *  - return the number of days of week before the first one of the month
   */ const emptyDays = (0, $eO7Kz.useMemo)(()=>{
        const firstDay = new Date(year, month - 1, 1).toLocaleString("fr-FR", {
            weekday: "long"
        });
        switch(firstDay.toLowerCase()){
            case "lundi":
                return 0;
            case "mardi":
                return 1;
            case "mercredi":
                return 2;
            case "jeudi":
                return 3;
            case "vendredi":
                return 4;
            case "samedi":
                return 5;
            case "dimanche":
                return 6;
        }
        return 0;
    }, [
        month,
        year
    ]);
    const title = (0, $eO7Kz.useMemo)(()=>{
        const newDate = new Date(year, month - 1, 1);
        return (0, $8fd1ab545cc1ab7a$export$d07f57595c356899)(new Date(newDate).toLocaleString(locale, {
            month: "long",
            year: "numeric"
        }));
    }, [
        month,
        year
    ]);
    /**
   * On locale change :
   *  - translate the days of week to display depending on the locale
   */ const daysOfWeek = (0, $eO7Kz.useMemo)(()=>{
        let tempArray = [];
        for(let i = 1; i < 8; i++){
            // First day of May 2023 is monday, let's get each day one after another beginning by monday
            const newDate = new Date(2023, 4, i);
            tempArray = [
                ...tempArray,
                (0, $8fd1ab545cc1ab7a$export$d07f57595c356899)(newDate.toLocaleString(locale, {
                    weekday: "short"
                }))
            ];
        }
        return tempArray;
    }, [
        locale
    ]);
    /**
   * On component mount :
   *  - set day / month / year from localStorage value if there is one, current Date otherwise
   *  - set max values from props or current Date + 150 years otherwise
   */ (0, $eO7Kz.useEffect)(()=>{
        const dateAsArray = (0, $8d815798cd441aa9$export$ffedad9fbd47bff0)(id, defaultValue);
        setYear(dateAsArray[0]);
        setMonth(dateAsArray[1]);
        setDay(dateAsArray[2]);
        setDate(`${dateAsArray[0]}-${dateAsArray[1]}-${dateAsArray[2]}`);
        // Set min and max years
        const now = new Date();
        if (maxValue) {
            const maxAsDate = new Date(maxValue);
            setMaxValueAsDate(maxAsDate);
            setMaxYear(maxAsDate.getFullYear());
            setMaxMonth(maxAsDate.getMonth() + 1);
            setMaxDay(maxAsDate.getDate());
        } else setMaxYear(now.getFullYear() + 150);
        if (minValue) {
            const minAsDate = new Date(minValue);
            setMinValueAsDate(minAsDate);
            setMinYear(minAsDate.getFullYear());
            setMinMonth(minAsDate.getMonth() + 1);
            setMinDay(minAsDate.getDate());
        } else setMinYear(now.getFullYear() - 150);
    }, []);
    /**
   * On day / month / year state change :
   *  - check if the date is in the boundaries of minDate / maxDate
   *  - set the value in localStorage
   */ (0, $eO7Kz.useEffect)(()=>{
        // Check if we are in the bounds of minValue and maxValue if there are some
        // Explode date to extract each value and substract 1 to the month (begins at 0 in js Date object)
        const dateAsArray = date.split("-");
        const newDate = new Date(parseInt(dateAsArray[0]), parseInt(dateAsArray[1]) - 1, parseInt(dateAsArray[2]));
        if (minValue && minValueAsDate && newDate < minValueAsDate) {
            setDay(minDay);
            setMonth(minMonth);
            setYear(minYear);
            setDate(minValue);
        } else if (maxValue && maxValueAsDate && newDate > maxValueAsDate) {
            setDay(maxDay);
            setMonth(maxMonth);
            setYear(maxYear);
            setDate(maxValue);
        } else // Save date
        id !== "filterCalendar" && handleChange(date);
    }, [
        date
    ]);
    const handlePreviousMonth = ()=>{
        if (currentSubView !== (0, $16ad089b9ce6627d$export$f05d0fed0593ead7).history) {
            if (year > minYear) {
                setMonth((month)=>month === 1 ? 12 : month - 1);
                month === 1 && setYear((year)=>year - 1);
            } else if (year === minYear && month > minMonth) month > 1 && setMonth((month)=>month - 1);
        }
    };
    const handleNextMonth = ()=>{
        if (currentSubView !== (0, $16ad089b9ce6627d$export$f05d0fed0593ead7).history) {
            if (year < maxYear) {
                setMonth((month)=>month === 12 ? 1 : month + 1);
                month === 12 && setYear((year)=>year + 1);
            } else if (year === maxYear && month < maxMonth) month < 12 && setMonth((month)=>month + 1);
        }
    };
    const handleClick = (value)=>{
        if (currentSubView !== (0, $16ad089b9ce6627d$export$f05d0fed0593ead7).history) {
            setDay(value);
            setDate(`${year}-${month}-${value}`);
            id === "filterCalendar" && handleChange(`${year}-${month < 10 ? "0" : ""}${month}-${value < 10 ? "0" : ""}${value}`);
        }
    };
    return /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsxs)("div", {
        className: `rf-w-full rf-px-2 rf-flex rf-flex-col rf-rounded-lg ${isFilter ? "rf-text-trueblack" : "rf-text-truewhite"} rf-subtitle-size-auto rf-unselectable`,
        style: {
            background: isFilter ? "#FFF" : "rgba(0, 0, 0, 0.5)"
        },
        children: [
            /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsxs)("div", {
                className: "rf-w-full rf-px-4 rf-py-6 rf-flex rf-flex-row rf-justify-between rf-items-center",
                children: [
                    /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("div", {
                        className: "rf-w-4 rf-cursor-pointer",
                        onClick: (e)=>{
                            e.preventDefault();
                            e.stopPropagation();
                            handlePreviousMonth();
                        },
                        children: (year > minYear || year === minYear && month > minMonth) && /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $95567835a53bf5e8$export$2e2bcd8739ae039), {
                            className: "rf-h-4",
                            color: isFilter ? "#000" : "#FFF"
                        })
                    }),
                    /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("div", {
                        className: `rf-width-fill-available rf-text-center rf-title-size-auto ${isFilter ? "rf-text-secondary" : "rf-text-primary"}`,
                        children: title
                    }),
                    /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("div", {
                        className: "rf-w-4 rf-cursor-pointer",
                        onClick: (e)=>{
                            e.preventDefault();
                            e.stopPropagation();
                            handleNextMonth();
                        },
                        children: (year < maxYear || year === maxYear && month < maxMonth) && /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $665d46c53901fdd5$export$2e2bcd8739ae039), {
                            className: "rf-h-4",
                            color: isFilter ? "#000" : "#FFF"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsxs)("div", {
                className: "rf-w-full rf-py-6 rf-grid rf-grid-cols-7 rf-gap-4",
                children: [
                    daysOfWeek.map((weekDay, key)=>{
                        return /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("div", {
                            className: "rf-flex rf-justify-center rf-items-center rf-aspect-square",
                            children: weekDay
                        }, key);
                    }),
                    [
                        ...Array(emptyDays)
                    ].map((e, key)=>{
                        return /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("div", {
                            className: "rf-aspect-square",
                            children: e || "⠀"
                        }, (key + 1) * 10);
                    }),
                    [
                        ...Array(days)
                    ].map((e, key)=>{
                        return /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("div", {
                            className: `rf-flex rf-justify-center rf-items-center rf-aspect-square ${key + 1 === day && parseInt(date.split("-")[1]) === month && parseInt(date.split("-")[0]) === year ? `rf-font-bold rf-text-trueblack ${isFilter ? "rf-bg-secondary" : "rf-bg-primary"} rf-rounded-half` : year === maxYear && month === maxMonth && key + 1 > maxDay ? "rf-text-formInputRadioCheckboxUncheckedBackground" : "rf-cursor-pointer"}`,
                            onClick: (e)=>{
                                e.preventDefault();
                                e.stopPropagation();
                                handleClick(key + 1);
                            },
                            children: e || key + 1
                        }, (key + 1) * 100);
                    })
                ]
            })
        ]
    });
};
var $cc34a7543405d90a$export$2e2bcd8739ae039 = $cc34a7543405d90a$var$InputCalendar;




class $62c56236a538f649$export$a9633577dcb92569 extends (0, $eDhMr.DateInput) {
    _value = this.defaultValue || undefined;
    get value() {
        return this._value;
    }
    isSet() {
        return this._value;
    }
    // Add custom property to schema
    static calendarProperty = new $d47cbf04a0a44873$exports.BoolProperty($d47cbf04a0a44873$exports.Versions.v1_0, "calendar", false);
    // Calendar property accessors
    get calendar() {
        return !!this.getValue($62c56236a538f649$export$a9633577dcb92569.calendarProperty);
    }
    handleChange = (value)=>{
        this._value = value;
        this.id && (0, $dcb3b373c5027d86$export$3bf0495508a61ee)(this.id, value);
    };
    internalRender() {
        const element = (0, $ca7727ba78b87422$export$f23ef6cb462a47f7)(this.renderReact());
        return element;
    }
    renderReact = ()=>{
        return this.id ? this.calendar ? /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $cc34a7543405d90a$export$2e2bcd8739ae039), {
            id: this.id,
            defaultValue: this.defaultValue,
            maxValue: this.max,
            minValue: this.min,
            handleChange: this.handleChange
        }) : /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $8d388d75fbf3858b$export$2e2bcd8739ae039), {
            id: this.id,
            defaultValue: this.defaultValue,
            maxValue: this.max,
            minValue: this.min,
            handleChange: this.handleChange
        }) : /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eO7Kz))).Fragment, {});
    };
}
(0, $49f51cfbe488d9fc$export$29e00dfd3077644b)([
    $d47cbf04a0a44873$exports.property($62c56236a538f649$export$a9633577dcb92569.calendarProperty)
], $62c56236a538f649$export$a9633577dcb92569.prototype, "calendar", null);




var $eO7Kz = parcelRequire("eO7Kz");


var $eDhMr = parcelRequire("eDhMr");


var $eO7Kz = parcelRequire("eO7Kz");




const $2dfb662a49e6ad80$var$InputTime = ({ id: id, defaultValue: defaultValue, maxValue: maxValue, minValue: minValue, handleChange: handleChange })=>{
    const { currentSubView: currentSubView } = (0, $134592d23f105dbc$export$77e4cc5334565f28)();
    const [hour, setHour] = (0, $eO7Kz.useState)(12);
    const [minute, setMinute] = (0, $eO7Kz.useState)(0);
    const [maxHour, setMaxHour] = (0, $eO7Kz.useState)(23);
    const [minHour, setMinHour] = (0, $eO7Kz.useState)(0);
    const [maxMinute, setMaxMinute] = (0, $eO7Kz.useState)(59);
    const [minMinute, setMinMinute] = (0, $eO7Kz.useState)(0);
    const [updatingTime, setUpdatingTime] = (0, $eO7Kz.useState)(false);
    const [hourWheel, setHourWheel] = (0, $eO7Kz.useState)(0);
    const [minuteWheel, setMinuteWheel] = (0, $eO7Kz.useState)(0);
    /**
   * On component mount :
   *  - set hour / minute from localStorage value if there is one, or defaultValue, or 12:00 if no other data
   *  - set maxHour and maxMinute states if maxValue prop is set
   *  - set minHour and minMinute states if minValue prop is set
   */ (0, $eO7Kz.useEffect)(()=>{
        // Set hour and minute from localstorage or defaultvalue if one of those is set
        const timeFromLocalStorage = (0, $dcb3b373c5027d86$export$b5ed0bbebfb6af43)(id, null);
        const timeAsArray = timeFromLocalStorage ? timeFromLocalStorage.split(":") : defaultValue ? defaultValue.split(":") : [];
        if (timeAsArray.length === 2) {
            !isNaN(parseInt(timeAsArray[0])) && setHour(parseInt(timeAsArray[0]));
            !isNaN(parseInt(timeAsArray[1])) && setMinute(parseInt(timeAsArray[1]));
        }
        // Set min and max times
        if (maxValue) {
            const maxTimeAsArray = maxValue.split(":");
            setMaxHour(parseInt(maxTimeAsArray[0]));
            setMaxMinute(parseInt(maxTimeAsArray[1]));
        }
        if (minValue) {
            const minTimeAsArray = minValue.split(":");
            setMinHour(parseInt(minTimeAsArray[0]));
            setMinMinute(parseInt(minTimeAsArray[1]));
        }
    }, []);
    /**
   * On hour / minute state change :
   *  - check if a hour / minute change is needed to respect minValue or maxValue
   *  - set the value in localStorage
   *  - if an update is needed, set the updatingTime state to true to prevent concurrent modification, update, and set updatingTime back to false to release lock
   */ (0, $eO7Kz.useEffect)(()=>{
        // Check if we are in the bounds of minValue and maxValue if there are some
        if (!updatingTime && hour !== undefined && minute !== undefined) {
            let updating = false;
            // Deal with hours and minutes lower than 10 : add a '0' before to keep 2-characters length for each
            const tempHour = hour < 10 ? `0${hour}` : hour;
            const tempMinute = minute < 10 ? `0${minute}` : minute;
            let timeAsString = `${tempHour}:${tempMinute}`;
            // Check if the time is lower than the minimal value if given, or greater than the maximal one if given
            if (minValue && (hour < minHour || hour === minHour && minute < minMinute)) {
                timeAsString = minValue;
                updating = true;
            } else if (maxValue && (hour > maxHour || hour === maxHour && minute > maxMinute)) {
                timeAsString = maxValue;
                updating = true;
            }
            // Save time
            handleChange(timeAsString);
            // Update states if necessary
            if (updating) {
                setUpdatingTime(true);
                const timeAsArray = timeAsString.split(":");
                setHour(parseInt(timeAsArray[0]));
                setMinute(parseInt(timeAsArray[1]));
                setUpdatingTime(false);
            }
        }
    }, [
        hour,
        minute
    ]);
    /**
   * On hourWheel change, if hourWheel !== 0 :
   *  - try to update the hour state
   *  - reset hourWheel state to 0
   */ (0, $eO7Kz.useEffect)(()=>{
        if (hourWheel !== 0 && hour !== undefined) {
            if (hourWheel > 0) hour + 1 > 23 ? setHour(0) : setHour((hour)=>hour + 1);
            else hour - 1 < 0 ? setHour(23) : setHour((hour)=>hour - 1);
            // Reset dayWheel
            setHourWheel(0);
        }
    }, [
        hourWheel
    ]);
    /**
   * On minuteWheel change, if minuteWheel !== 0 :
   *  - try to update the minute state
   *  - reset minuteWheel state to 0
   */ (0, $eO7Kz.useEffect)(()=>{
        if (minuteWheel !== 0 && minute !== undefined) {
            if (minuteWheel > 0) minute + 1 > 59 ? setMinute(0) : setMinute((minute)=>minute + 1);
            else minute - 1 < 0 ? setMinute(59) : setMinute((minute)=>minute - 1);
            // Reset monthWheel
            setMinuteWheel(0);
        }
    }, [
        minuteWheel
    ]);
    /**
   * On wheel event on hour / minute part :
   *  - check if the component will be rendered in history, if so bypass every interaction
   *  - call wheel state depending on the type, that will trigger the related hour / minute state update if possible
   * @param delta : number
   * @param type : string
   */ const handleWheel = (delta, type)=>{
        if (currentSubView !== (0, $16ad089b9ce6627d$export$f05d0fed0593ead7).history) switch(type){
            case "hour":
                setHourWheel(delta);
                break;
            case "minute":
                setMinuteWheel(delta);
                break;
            default:
                break;
        }
    };
    /**
   * On click on a hour / minute :
   *  - check if the component will be rendered in history, if so bypass every interaction
   *  - set chosen hour / minute if it is within the accepted bounds
   * @param value : number
   * @param type : string
   */ const handleClick = (value, type)=>{
        if (currentSubView !== (0, $16ad089b9ce6627d$export$f05d0fed0593ead7).history) switch(type){
            case "hour":
                hour !== undefined && value !== -1 && setHour(value);
                break;
            case "minute":
                minute !== undefined && value !== -1 && setMinute(value);
                break;
            default:
                break;
        }
    };
    return /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsxs)("div", {
        className: "rf-w-full rf-mt-4 rf-py-2 rf-flex rf-flex-row rf-justify-center rf-items-center rf-rounded-lg rf-subtitle-size-auto rf-text-formInputRadioCheckboxUncheckedBackground rf-unselectable",
        style: {
            background: "linear-gradient(rgb(0, 0, 0, 0.5) 0%, rgb(0, 0, 0, 0.5) 34%, black 34%, black 65%, rgb(0, 0, 0, 0.5) 65%, rgb(0, 0, 0, 0.5) 100%)"
        },
        children: [
            /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("input", {
                type: "time",
                className: "rf-hidden"
            }),
            hour !== undefined && minute !== undefined && /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($eO7Kz))).Fragment, {
                children: [
                    /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsxs)((0, $ea490a709941d5e3$export$2e2bcd8739ae039), {
                        className: "rf-flex rf-flex-col rf-items-center rf-pr-1 rf-py-1",
                        handleWheel: handleWheel,
                        paramInHandle: "hour",
                        children: [
                            /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("div", {
                                className: "rf-py-1 hover:rf-cursor-pointer",
                                onClick: ()=>handleClick(minValue && hour === minHour ? -1 : hour === 0 ? 23 : hour - 1, "hour"),
                                children: minValue && hour === minHour ? "⠀" : hour === 0 ? "23" : hour < 11 ? `0${hour - 1}` : hour - 1
                            }),
                            /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("div", {
                                className: "rf-py-1 rf-text-primary",
                                children: hour < 10 ? `0${hour}` : hour
                            }),
                            /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("div", {
                                className: "rf-py-1 hover:rf-cursor-pointer",
                                onClick: ()=>handleClick(maxValue && hour === maxHour ? -1 : hour === 23 ? 0 : hour + 1, "hour"),
                                children: maxValue && hour === maxHour ? "⠀" : hour === 23 ? "00" : hour < 9 ? `0${hour + 1}` : hour + 1
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsxs)("div", {
                        className: "rf-flex rf-flex-col rf-items-center rf-py-1",
                        children: [
                            /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("div", {
                                children: "⠀"
                            }),
                            /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("div", {
                                className: "rf-text-primary",
                                children: ":"
                            }),
                            /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("div", {
                                children: "⠀"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsxs)((0, $ea490a709941d5e3$export$2e2bcd8739ae039), {
                        className: "rf-flex rf-flex-col rf-items-center rf-pl-1 rf-py-1",
                        handleWheel: handleWheel,
                        paramInHandle: "minute",
                        children: [
                            /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("div", {
                                className: "rf-py-1 hover:rf-cursor-pointer",
                                onClick: ()=>handleClick(minValue && hour === minHour && minute === minMinute ? -1 : minute === 0 ? 59 : minute - 1, "minute"),
                                children: minValue && hour === minHour && minute === minMinute ? "⠀" : minute === 0 ? "59" : minute < 11 ? `0${minute - 1}` : minute - 1
                            }),
                            /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("div", {
                                className: "rf-py-1 rf-text-primary",
                                children: minute < 10 ? `0${minute}` : minute
                            }),
                            /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("div", {
                                className: "rf-py-1 hover:rf-cursor-pointer",
                                onClick: ()=>handleClick(maxValue && hour === maxHour && minute === maxMinute ? -1 : minute === 59 ? 0 : minute + 1, "minute"),
                                children: maxValue && hour === maxHour && minute === maxMinute ? "⠀" : minute < 9 ? `0${minute + 1}` : minute === 59 ? "00" : minute + 1
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $2dfb662a49e6ad80$export$2e2bcd8739ae039 = $2dfb662a49e6ad80$var$InputTime;



class $0ecaa55e6c7a6555$export$27dc9c3aadf0815c extends (0, $eDhMr.TimeInput) {
    _value = this.defaultValue || undefined;
    get value() {
        return this._value;
    }
    isSet() {
        return this._value;
    }
    handleChange = (value)=>{
        this._value = value;
        this.id && (0, $dcb3b373c5027d86$export$3bf0495508a61ee)(this.id, value);
    };
    internalRender() {
        const element = (0, $ca7727ba78b87422$export$f23ef6cb462a47f7)(this.renderReact());
        return element;
    }
    renderReact = ()=>{
        return this.id ? /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $2dfb662a49e6ad80$export$2e2bcd8739ae039), {
            id: this.id,
            defaultValue: this.defaultValue,
            maxValue: this.max,
            minValue: this.min,
            handleChange: this.handleChange
        }) : /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eO7Kz))).Fragment, {});
    };
}


/* eslint-disable react/jsx-boolean-value */ 


var $eO7Kz = parcelRequire("eO7Kz");




var $eO7Kz = parcelRequire("eO7Kz");




const $b06915b34ca5680e$var$Radio = ({ id: id, choices: choices, split: split, handleSelect: handleSelect })=>{
    const { currentSubView: currentSubView } = (0, $134592d23f105dbc$export$77e4cc5334565f28)();
    const [display, setDisplay] = (0, $eO7Kz.useState)([]);
    const [chosen, setChosen] = (0, $eO7Kz.useState)((0, $dcb3b373c5027d86$export$b5ed0bbebfb6af43)(id, ""));
    /**
   * On choices prop change :
   *  - if choices is defined, fill display state with choices value
   */ (0, $eO7Kz.useEffect)(()=>{
        if (choices) {
            if (split) {
                const nbRows = Math.ceil(choices.length / 2);
                setDisplay([
                    choices.slice(0, nbRows),
                    choices.slice(nbRows)
                ]);
            } else setDisplay(choices);
        }
    }, [
        choices
    ]);
    /**
   * On call:
   *  - check if the component will be rendered in history, if so bypass every interaction
   *  - fill chosen state with value
   *  - call parent's handleSelect method
   * @param value : string
   */ const handleChange = (value)=>{
        if (currentSubView !== (0, $16ad089b9ce6627d$export$f05d0fed0593ead7).history) {
            setChosen(value);
            handleSelect(value);
        }
    };
    return display && display.length > 0 ? split ? /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsxs)("div", {
        className: "rf-w-full rf-mt-4 rf-flex rf-flex-row rf-text-size-auto rf-text-white",
        children: [
            /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("div", {
                className: "rf-w-1/2 rf-flex rf-flex-col rf-items-start",
                children: display[0].map((choice, key)=>{
                    return /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsxs)("div", {
                        className: "rf-w-full rf-flex rf-flex-row rf-items-start rf-mb-3",
                        children: [
                            /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("input", {
                                type: "radio",
                                value: choice.value,
                                checked: choice.value === chosen,
                                className: "rf-radio-custom",
                                onChange: ()=>handleChange(choice.value)
                            }),
                            /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("label", {
                                htmlFor: `radio-${key}`,
                                className: "rf-input-label rf-mr-2 rf-max-w-[calc(100%-2rem)]",
                                children: (0, $8fd1ab545cc1ab7a$export$d07f57595c356899)(choice.title)
                            })
                        ]
                    }, key);
                })
            }),
            /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("div", {
                className: "rf-w-1/2 rf-flex rf-flex-col rf-items-start",
                children: display[1].map((choice, key)=>{
                    return /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsxs)("div", {
                        className: "rf-w-full rf-flex rf-flex-row rf-items-start rf-mb-3",
                        children: [
                            /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("input", {
                                type: "radio",
                                value: choice.value,
                                checked: choice.value === chosen,
                                className: "rf-radio-custom",
                                onChange: ()=>handleChange(choice.value)
                            }),
                            /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("label", {
                                htmlFor: `radio-${key}`,
                                className: "rf-input-label rf-mr-2 rf-max-w-[calc(100%-2rem)]",
                                children: (0, $8fd1ab545cc1ab7a$export$d07f57595c356899)(choice.title)
                            })
                        ]
                    }, key);
                })
            })
        ]
    }) : /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("div", {
        className: "rf-w-full rf-mt-4 rf-text-size-auto rf-text-white",
        children: display.map((choice, key)=>{
            return /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsxs)("div", {
                className: "rf-w-full rf-flex rf-flex-row rf-items-start rf-mb-3",
                children: [
                    /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("input", {
                        type: "radio",
                        value: choice.value,
                        checked: choice.value === chosen,
                        className: "rf-radio-custom",
                        onChange: ()=>handleChange(choice.value)
                    }),
                    /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("label", {
                        htmlFor: `radio-${key}`,
                        className: "rf-input-label rf-mr-2 rf-max-w-[calc(100%-2rem)]",
                        children: (0, $8fd1ab545cc1ab7a$export$d07f57595c356899)(choice.title)
                    })
                ]
            }, key);
        })
    }) : /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eO7Kz))).Fragment, {});
};
var $b06915b34ca5680e$export$2e2bcd8739ae039 = $b06915b34ca5680e$var$Radio;




var $eO7Kz = parcelRequire("eO7Kz");




const $5657573d2a0b5a17$var$RadioAsButton = ({ id: id, choices: choices, handleSelect: handleSelect })=>{
    const { currentSubView: currentSubView } = (0, $134592d23f105dbc$export$77e4cc5334565f28)();
    const [display, setDisplay] = (0, $eO7Kz.useState)([]);
    const [chosen, setChosen] = (0, $eO7Kz.useState)((0, $dcb3b373c5027d86$export$b5ed0bbebfb6af43)(id, ""));
    /**
   * On choices prop change :
   *  - if choices is defined, fill display state with choices value
   */ (0, $eO7Kz.useEffect)(()=>{
        choices && setDisplay(choices);
    }, [
        choices
    ]);
    /**
   * On call:
   *  - check if the component will be rendered in history, if so bypass every interaction
   *  - fill chosen state with value
   *  - call parent's handleSelect method
   * @param value : string
   */ const handleChange = (value)=>{
        if (currentSubView !== (0, $16ad089b9ce6627d$export$f05d0fed0593ead7).history) {
            setChosen(value);
            handleSelect(value);
        }
    };
    return display && display.length > 0 ? /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("div", {
        className: "rf-w-full rf-mt-4 rf-flex rf-flex-row rf-flex-wrap rf-justify-center rf-items-center rf-text-size-auto rf-text-white",
        children: display.map((choice, key)=>{
            return /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsxs)("label", {
                className: `rf-mx-2 rf-flex rf-justify-center rf-items-center rf-px-4 rf-py-2 large:rf-px-5 large:rf-py-3 rf-border rf-rounded-lg ${choice.value === chosen ? "rf-bg-formInputButtonBackgroundHover rf-text-formInputButtonTextHover rf-border-formInputButtonBorderHover" : "rf-bg-formInputButtonBackgroundDefault rf-text-formInputButtonTextDefault rf-border-formInputButtonBorderDefault"} rf-mb-4 hover:rf-cursor-pointer`,
                children: [
                    /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("input", {
                        type: "radio",
                        value: choice.value,
                        checked: choice.value === chosen,
                        className: "rf-input-hidden",
                        onChange: ()=>handleChange(choice.value)
                    }),
                    (0, $8fd1ab545cc1ab7a$export$d07f57595c356899)(choice.title)
                ]
            }, key);
        })
    }) : /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eO7Kz))).Fragment, {});
};
var $5657573d2a0b5a17$export$2e2bcd8739ae039 = $5657573d2a0b5a17$var$RadioAsButton;




var $eO7Kz = parcelRequire("eO7Kz");






const $f53b126995ef391b$var$Checkbox = ({ id: id, choices: choices, split: split, handleChangeCheckbox: handleChangeCheckbox })=>{
    const { themeColors: themeColors } = (0, $8b59a4dbb18c269b$export$3abe3478af3cb63b)();
    const { currentSubView: currentSubView } = (0, $134592d23f105dbc$export$77e4cc5334565f28)();
    const [display, setDisplay] = (0, $eO7Kz.useState)([]);
    const [chosen, setChosen] = (0, $eO7Kz.useState)((0, $dcb3b373c5027d86$export$b5ed0bbebfb6af43)(id, []));
    /**
   * On choices prop change :
   *  - if choices is defined, fill display state with choices value
   */ (0, $eO7Kz.useEffect)(()=>{
        if (choices) {
            if (split) {
                const nbRows = Math.ceil(choices.length / 2);
                setDisplay([
                    choices.slice(0, nbRows),
                    choices.slice(nbRows)
                ]);
            } else setDisplay(choices);
        }
    }, [
        choices
    ]);
    /**
   * On chosen state change :
   *  - call parent's handleChangeCheckbox method
   */ (0, $eO7Kz.useEffect)(()=>{
        handleChangeCheckbox(chosen);
    }, [
        chosen
    ]);
    /**
   * On call :
   *  - check if the component will be rendered in history, if so bypass every interaction
   *  - check for checked / unchecked values and fill chosen state with these
   *  - call parent's handleChangeCheckbox method
   * @param value : string
   */ const handleChange = (value)=>{
        if (currentSubView !== (0, $16ad089b9ce6627d$export$f05d0fed0593ead7).history) {
            let tempChosen = [
                ...chosen
            ];
            if (tempChosen.includes(value)) tempChosen = tempChosen.filter((chosenValue)=>chosenValue !== value);
            else tempChosen = [
                ...tempChosen,
                value
            ];
            setChosen(tempChosen);
        }
    };
    return display && display.length > 0 ? split ? /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsxs)("div", {
        className: "rf-w-full rf-mt-4 rf-flex rf-flex-row rf-text-size-auto rf-text-white",
        children: [
            /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("div", {
                className: "rf-w-1/2 rf-pr-2 rf-flex rf-flex-col rf-items-start",
                children: display[0].map((choice, key)=>{
                    return /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("div", {
                        className: "rf-relative rf-mb-3",
                        children: /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsxs)("label", {
                            className: "rf-w-full rf-flex rf-flex-row rf-items-start",
                            children: [
                                /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("input", {
                                    type: "checkbox",
                                    value: choice.value,
                                    checked: chosen.includes(choice.value),
                                    onChange: ()=>handleChange(choice.value),
                                    className: "rf-checkbox-custom"
                                }),
                                chosen.includes(choice.value) && /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $416cf8987d72a3d6$export$2e2bcd8739ae039), {
                                    className: "rf-absolute rf-left-1 rf-top-1 rf-h-4 rf-w-4 large:rf-h-5 large:rf-w-5 large-vertical:rf-h-6 large-vertical:rf-w-6 rf-transition-all",
                                    color: themeColors.formInput.inputRadioCheckbox.checked.item
                                }),
                                /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("div", {
                                    className: "rf-input-label rf-mr-2 rf-max-w-[calc(100%-2rem)]",
                                    children: (0, $8fd1ab545cc1ab7a$export$d07f57595c356899)(choice.title)
                                })
                            ]
                        })
                    }, key);
                })
            }),
            /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("div", {
                className: "rf-w-1/2 rf-flex rf-flex-col rf-items-start",
                children: display[1].map((choice, key)=>{
                    return /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("div", {
                        className: "rf-relative rf-mb-3",
                        children: /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsxs)("label", {
                            className: "rf-w-full rf-flex rf-flex-row rf-items-start",
                            children: [
                                /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("input", {
                                    type: "checkbox",
                                    value: choice.value,
                                    checked: chosen.includes(choice.value),
                                    onChange: ()=>handleChange(choice.value),
                                    className: "rf-checkbox-custom"
                                }),
                                chosen.includes(choice.value) && /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $416cf8987d72a3d6$export$2e2bcd8739ae039), {
                                    className: "rf-absolute rf-left-1 rf-top-1 rf-h-4 rf-w-4 large:rf-h-5 large:rf-w-5 large-vertical:rf-h-6 large-vertical:rf-w-6 rf-transition-all",
                                    color: themeColors.formInput.inputRadioCheckbox.checked.item
                                }),
                                /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("div", {
                                    className: "rf-input-label rf-mr-2 rf-max-w-[calc(100%-2rem)]",
                                    children: (0, $8fd1ab545cc1ab7a$export$d07f57595c356899)(choice.title)
                                })
                            ]
                        })
                    }, key);
                })
            })
        ]
    }) : /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("div", {
        className: "rf-w-full rf-mt-4 rf-flex rf-flex-col rf-items-start rf-text-size-auto rf-text-white",
        children: display.map((choice, key)=>{
            return /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("div", {
                className: "rf-relative rf-mb-3",
                children: /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsxs)("label", {
                    className: "rf-w-full rf-flex rf-flex-row rf-items-start",
                    children: [
                        /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("input", {
                            type: "checkbox",
                            value: choice.value,
                            checked: chosen.includes(choice.value),
                            onChange: ()=>handleChange(choice.value),
                            className: "rf-checkbox-custom"
                        }),
                        chosen.includes(choice.value) && /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $416cf8987d72a3d6$export$2e2bcd8739ae039), {
                            className: "rf-absolute rf-left-1 rf-top-1 rf-h-4 rf-w-4 large:rf-h-5 large:rf-w-5 large-vertical:rf-h-6 large-vertical:rf-w-6 rf-transition-all",
                            color: themeColors.formInput.inputRadioCheckbox.checked.item
                        }),
                        /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("div", {
                            className: "rf-input-label rf-mr-2 rf-max-w-[calc(100%-2rem)]",
                            children: (0, $8fd1ab545cc1ab7a$export$d07f57595c356899)(choice.title)
                        })
                    ]
                })
            }, key);
        })
    }) : /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eO7Kz))).Fragment, {});
};
var $f53b126995ef391b$export$2e2bcd8739ae039 = $f53b126995ef391b$var$Checkbox;




var $eO7Kz = parcelRequire("eO7Kz");




const $d3411b4c1e525373$var$CheckboxAsButton = ({ id: id, choices: choices, handleChangeCheckbox: handleChangeCheckbox })=>{
    const { currentSubView: currentSubView } = (0, $134592d23f105dbc$export$77e4cc5334565f28)();
    const [display, setDisplay] = (0, $eO7Kz.useState)([]);
    const [chosen, setChosen] = (0, $eO7Kz.useState)((0, $dcb3b373c5027d86$export$b5ed0bbebfb6af43)(id, []));
    /**
   * On choices prop change :
   *  - if choices is defined, fill display state with choices value
   */ (0, $eO7Kz.useEffect)(()=>{
        choices && setDisplay(choices);
    }, [
        choices
    ]);
    /**
   * On chosen state change :
   *  - call parent's handleChangeCheckbox method
   */ (0, $eO7Kz.useEffect)(()=>{
        handleChangeCheckbox(chosen);
    }, [
        chosen
    ]);
    /**
   * On call :
   *  - check if the component will be rendered in history, if so bypass every interaction
   *  - check for checked / unchecked values and fill chosen state with these
   *  - call parent's handleChangeCheckbox method
   * @param value : string
   */ const handleChange = (value)=>{
        if (currentSubView !== (0, $16ad089b9ce6627d$export$f05d0fed0593ead7).history) {
            let tempChosen = [
                ...chosen
            ];
            if (tempChosen.includes(value)) tempChosen = tempChosen.filter((chosenValue)=>chosenValue !== value);
            else tempChosen = [
                ...tempChosen,
                value
            ];
            setChosen(tempChosen);
        }
    };
    return display && display.length > 0 ? /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("div", {
        className: "rf-w-full rf-mt-4 rf-flex rf-flex-row rf-flex-wrap rf-justify-center rf-items-center rf-text-size-auto",
        children: display.map((choice, key)=>{
            return /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsxs)("label", {
                className: `rf-mx-2 rf-flex rf-justify-center rf-items-center rf-px-4 rf-py-2 large:rf-px-5 large:rf-py-3 rf-border rf-rounded-lg ${chosen.includes(choice.value) ? "rf-bg-formInputButtonBackgroundHover rf-text-formInputButtonTextHover rf-border-formInputButtonBorderHover" : "rf-bg-formInputButtonBackgroundDefault rf-text-formInputButtonTextDefault rf-border-formInputButtonBorderDefault"} rf-mb-4 hover:rf-cursor-pointer`,
                children: [
                    /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("input", {
                        type: "checkbox",
                        value: choice.value,
                        checked: chosen.includes(choice.value),
                        className: "rf-input-hidden",
                        onChange: ()=>handleChange(choice.value)
                    }),
                    (0, $8fd1ab545cc1ab7a$export$d07f57595c356899)(choice.title)
                ]
            }, key);
        })
    }) : /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eO7Kz))).Fragment, {});
};
var $d3411b4c1e525373$export$2e2bcd8739ae039 = $d3411b4c1e525373$var$CheckboxAsButton;




var $eO7Kz = parcelRequire("eO7Kz");



var $c4f4e8117c4a001a$exports = {};
$c4f4e8117c4a001a$exports = JSON.parse('{"fr-FR":{"choose":"Choisissez une r\xe9ponse","submit":"valider"},"en-US":{"choose":"Choose an answer","submit":"submit"},"es-ES":{"choose":"Choose an answer","submit":"submit"},"de-DE":{"choose":"Choose an answer","submit":"submit"}}');





const $d4322f7293d1439c$var$Select = ({ id: id, choices: choices, placeholder: placeholder, handleSelect: handleSelect })=>{
    const { locale: locale } = (0, $2e4dc8fa28d39601$export$6650dace022cfacc)();
    const { currentSubView: currentSubView } = (0, $134592d23f105dbc$export$77e4cc5334565f28)();
    const [display, setDisplay] = (0, $eO7Kz.useState)([]);
    const [open, setOpen] = (0, $eO7Kz.useState)(false);
    const [chosen, setChosen] = (0, $eO7Kz.useState)(checkLocalStorage());
    /**
   * On call :
   *  - check if a choice's value matches to one in local storage if there is one
   *  - return either the choice that matches, or null if no match
   * @returns Choice | null
   */ function checkLocalStorage() {
        const existing = choices.filter((choice)=>choice.value === (0, $dcb3b373c5027d86$export$b5ed0bbebfb6af43)(id, null));
        return existing.length > 0 ? existing[0] : null;
    }
    /**
   * On choices prop change :
   *  - if choices is defined, fill display state with choices value
   */ (0, $eO7Kz.useEffect)(()=>{
        choices && setDisplay(choices);
    }, [
        choices
    ]);
    /**
   * On call :
   *  - set open state to its contrary
   */ const toggleOpen = ()=>{
        setOpen(!open);
    };
    /**
   * On call :
   *  - check if the component will be rendered in history, if so bypass every interaction
   *  - fill chosen state with choice value
   *  - call parent's handleSelect method
   *  - call toggleOpen method
   * @param choice : Choice
   */ const handleChange = (choice)=>{
        if (currentSubView !== (0, $16ad089b9ce6627d$export$f05d0fed0593ead7).history) {
            setChosen(choice);
            handleSelect(choice);
            toggleOpen();
        }
    };
    return display && display.length > 0 ? /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsxs)("div", {
        className: "rf-w-full rf-mt-4 rf-text-size-auto rf-text-formInputTextDefault",
        children: [
            /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsxs)("div", {
                onClick: toggleOpen,
                className: `rf-w-full rf-flex rf-flex-row rf-justify-between rf-items-center rf-p-4 rf-border-2 rf-rounded ${open ? "rf-border-formInputRadioCheckboxCheckedBorder" : "rf-border-formInputRadioCheckboxUncheckedBorder"} rf-bg-formInputRadioCheckboxUncheckedBackground`,
                children: [
                    /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("div", {
                        className: "rf-truncate",
                        children: chosen?.title || placeholder || (0, (/*@__PURE__*/$parcel$interopDefault($c4f4e8117c4a001a$exports)))[locale]?.choose || (0, (/*@__PURE__*/$parcel$interopDefault($c4f4e8117c4a001a$exports)))["fr-FR"].choose
                    }),
                    /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("div", {
                        className: "rf-h-2",
                        children: /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $5352670cffb3057c$export$2e2bcd8739ae039), {
                            className: "rf-h-full"
                        })
                    })
                ]
            }),
            open && /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("ul", {
                className: "rf-mt-1 rf-max-h-48 rf-pl-0 rf-w-full rf-rounded rf-border-2 rf-border-formInputRadioCheckboxUncheckedBorder rf-bg-formInputRadioCheckboxUncheckedBackground rf-overflow-y-scroll rf-scrollbar-thin",
                style: {
                    listStyle: "none"
                },
                children: display.map((choice, key)=>{
                    return /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("li", {
                        onClick: ()=>handleChange(choice),
                        className: "rf-px-4 rf-py-2 hover:rf-text-formInputRadioCheckboxCheckedItem hover:rf-bg-formInputRadioCheckboxCheckedBackground",
                        children: (0, $8fd1ab545cc1ab7a$export$d07f57595c356899)(choice.title)
                    }, key);
                })
            })
        ]
    }) : /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eO7Kz))).Fragment, {});
};
var $d4322f7293d1439c$export$2e2bcd8739ae039 = $d4322f7293d1439c$var$Select;



class $21bf09b727f272df$export$3d2f970ec3b98a50 extends $d47cbf04a0a44873$exports.ChoiceSetInput {
    _value;
    static JsonTypeName = "ChoiceSetClass";
    getJsonTypeName() {
        return $21bf09b727f272df$export$3d2f970ec3b98a50.JsonTypeName;
    }
    // Add custom preperties to schema
    static splitProperty = new $d47cbf04a0a44873$exports.BoolProperty($d47cbf04a0a44873$exports.Versions.v1_0, "split", false);
    static displayAsButtonProperty = new $d47cbf04a0a44873$exports.BoolProperty($d47cbf04a0a44873$exports.Versions.v1_0, "asButtons", false);
    // Split property accessors
    get split() {
        return !!this.getValue($21bf09b727f272df$export$3d2f970ec3b98a50.splitProperty);
    }
    set split(value) {
        if (this.split !== value) {
            this.setValue($21bf09b727f272df$export$3d2f970ec3b98a50.splitProperty, value);
            this.updateLayout();
        }
    }
    // AsButtons property accessors
    get asButtons() {
        return !!this.getValue($21bf09b727f272df$export$3d2f970ec3b98a50.displayAsButtonProperty);
    }
    set asButtons(value) {
        if (this.asButtons !== value) {
            this.setValue($21bf09b727f272df$export$3d2f970ec3b98a50.displayAsButtonProperty, value);
            this.updateLayout();
        }
    }
    get value() {
        return this._value;
    }
    isSet() {
        return this._value;
    }
    handleSelectOne = (value)=>{
        this._value = value;
        this.id && (0, $dcb3b373c5027d86$export$3bf0495508a61ee)(this.id, value);
    };
    handleSelect = (choice)=>{
        this._value = choice.value;
        this.id && (0, $dcb3b373c5027d86$export$3bf0495508a61ee)(this.id, choice.value);
    };
    handleChangeCheckbox = (value)=>{
        this._value = value;
        this.id && (0, $dcb3b373c5027d86$export$3bf0495508a61ee)(this.id, value);
    };
    internalRender() {
        const element = (0, $ca7727ba78b87422$export$f23ef6cb462a47f7)(this.renderReact());
        return element;
    }
    renderReact = ()=>{
        // Return empty fragment if no id provided
        if (!this.id) return /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eO7Kz))).Fragment, {});
        // Check if we use checkboxes, radio buttons or select input
        let inputType = "select";
        if (this.asButtons) inputType = this.isMultiSelect ? "checkboxbuttons" : "radiobuttons";
        else if (!this.isCompact) inputType = this.isMultiSelect ? "checkbox" : "radio";
        switch(inputType){
            case "select":
                break;
            case "checkbox":
                this._value = [];
                return /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $f53b126995ef391b$export$2e2bcd8739ae039), {
                    id: this.id,
                    choices: this.choices,
                    split: this.split,
                    handleChangeCheckbox: this.handleChangeCheckbox
                });
            case "radio":
                return /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $b06915b34ca5680e$export$2e2bcd8739ae039), {
                    id: this.id,
                    choices: this.choices,
                    split: this.split,
                    handleSelect: this.handleSelectOne
                });
            case "checkboxbuttons":
                return /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $d3411b4c1e525373$export$2e2bcd8739ae039), {
                    id: this.id,
                    choices: this.choices,
                    handleChangeCheckbox: this.handleChangeCheckbox
                });
            case "radiobuttons":
                return /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $5657573d2a0b5a17$export$2e2bcd8739ae039), {
                    id: this.id,
                    choices: this.choices,
                    handleSelect: this.handleSelectOne
                });
        }
        return /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $d4322f7293d1439c$export$2e2bcd8739ae039), {
            id: this.id,
            choices: this.choices,
            placeholder: this.placeholder,
            handleSelect: this.handleSelect
        });
    };
}
(0, $49f51cfbe488d9fc$export$29e00dfd3077644b)([
    $d47cbf04a0a44873$exports.property($21bf09b727f272df$export$3d2f970ec3b98a50.splitProperty)
], $21bf09b727f272df$export$3d2f970ec3b98a50.prototype, "split", null);
(0, $49f51cfbe488d9fc$export$29e00dfd3077644b)([
    $d47cbf04a0a44873$exports.property($21bf09b727f272df$export$3d2f970ec3b98a50.displayAsButtonProperty)
], $21bf09b727f272df$export$3d2f970ec3b98a50.prototype, "asButtons", null);





var $eO7Kz = parcelRequire("eO7Kz");



var $eO7Kz = parcelRequire("eO7Kz");




/**
 * Default data if not given in props :
 *  - defaultEmoji = default displayed object
 */ const $0eac5ed5b4c13616$var$defaultEmoji = "\uD83D\uDFCA";
// emoji examples ['🟊', '♠', '✺', 'Ϙ', '◎', '₱', '😔', '😐', '😀']
const $0eac5ed5b4c13616$var$Likert = ({ id: id, ratingMin: ratingMin, ratingMax: ratingMax, emojis: emojis, strokeColor: strokeColor, handleChange: handleChange })=>{
    const { themeColors: themeColors } = (0, $8b59a4dbb18c269b$export$3abe3478af3cb63b)();
    const { currentSubView: currentSubView } = (0, $134592d23f105dbc$export$77e4cc5334565f28)();
    const [data, setData] = (0, $eO7Kz.useState)([]);
    const [rating, setRating] = (0, $eO7Kz.useState)((0, $dcb3b373c5027d86$export$b5ed0bbebfb6af43)(id, ratingMin || 0));
    const [hover, setHover] = (0, $eO7Kz.useState)(0);
    const hoverColor = strokeColor || themeColors.formInput.likert.hover;
    /**
   * On component mount :
   *  - create array of Dataset to be mapped for display
   *  - set stroke color if given in props
   */ (0, $eO7Kz.useEffect)(()=>{
        const min = ratingMin || 0;
        const range = min <= 0 ? Math.abs(min) + ratingMax + 1 : ratingMax;
        let dataArray = [];
        // If there are as many emojis as values, let's use them all
        if (emojis.length === range) for(let i = 0; i < range; i++)dataArray = [
            ...dataArray,
            {
                emoji: emojis[i],
                value: min + i
            }
        ];
        else for(let i = 0; i < range; i++)dataArray = [
            ...dataArray,
            {
                emoji: emojis[0] || $0eac5ed5b4c13616$var$defaultEmoji,
                value: min + i
            }
        ];
        setData(dataArray);
    }, []);
    /**
   * On element click :
   *  - check if the component will be rendered in history, if so bypass every interaction
   *  - call parent function from props with the value retrieved
   *  - set rating
   */ const handleClick = (value)=>{
        if (currentSubView !== (0, $16ad089b9ce6627d$export$f05d0fed0593ead7).history) {
            handleChange(value);
            setRating(value);
        }
    };
    return /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("div", {
        className: "rf-my-4 rf-flex rf-flex-row rf-flex-nowrap rf-justify-center rf-items-center rf-title-large-size-auto",
        children: data.map((tuple, index)=>{
            return /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("div", {
                className: "rf-px-1 rf-likert-custom",
                style: {
                    color: tuple.value <= (hover || rating) ? hoverColor : themeColors.formInput.likert.default
                },
                onClick: ()=>handleClick(tuple.value),
                onMouseEnter: ()=>setHover(tuple.value),
                onMouseLeave: ()=>setHover(rating),
                children: tuple.emoji
            }, index);
        })
    });
};
var $0eac5ed5b4c13616$export$2e2bcd8739ae039 = $0eac5ed5b4c13616$var$Likert;




class $23976b476f54bdf7$export$527d02f4ea70b77 extends $d47cbf04a0a44873$exports.Input {
    _value = this.ratingMin;
    static JsonTypeName = "Retorik.Likert";
    getJsonTypeName() {
        return $23976b476f54bdf7$export$527d02f4ea70b77.JsonTypeName;
    }
    get value() {
        return this._value;
    }
    isSet() {
        return this._value;
    }
    static ratingMinProperty = new $d47cbf04a0a44873$exports.NumProperty($d47cbf04a0a44873$exports.Versions.v1_0, "ratingMin", 1);
    static ratingMaxProperty = new $d47cbf04a0a44873$exports.NumProperty($d47cbf04a0a44873$exports.Versions.v1_0, "ratingMax", 5);
    static emojisProperty = new $d47cbf04a0a44873$exports.StringArrayProperty($d47cbf04a0a44873$exports.Versions.v1_0, "emojis", []);
    static strokeColorProperty = new $d47cbf04a0a44873$exports.StringProperty($d47cbf04a0a44873$exports.Versions.v1_0, "strokeColor", true);
    // ratingMin property accessors
    get ratingMin() {
        return this.getValue($23976b476f54bdf7$export$527d02f4ea70b77.ratingMinProperty) || "";
    }
    set ratingMin(val) {
        if (this.ratingMin !== val) this.setValue($23976b476f54bdf7$export$527d02f4ea70b77.ratingMinProperty, val);
    }
    // ratingMax property accessors
    get ratingMax() {
        return this.getValue($23976b476f54bdf7$export$527d02f4ea70b77.ratingMaxProperty) || "";
    }
    set ratingMax(val) {
        if (this.ratingMax !== val) this.setValue($23976b476f54bdf7$export$527d02f4ea70b77.ratingMaxProperty, val);
    }
    // emojis property accessors
    get emojis() {
        return this.getValue($23976b476f54bdf7$export$527d02f4ea70b77.emojisProperty) || "";
    }
    set emojis(val) {
        if (this.emojis !== val) this.setValue($23976b476f54bdf7$export$527d02f4ea70b77.emojisProperty, val);
    }
    // strokeColor property accessors
    get strokeColor() {
        return this.getValue($23976b476f54bdf7$export$527d02f4ea70b77.strokeColorProperty) || "";
    }
    set strokeColor(val) {
        if (this.strokeColor !== val) this.setValue($23976b476f54bdf7$export$527d02f4ea70b77.strokeColorProperty, val);
    }
    handleChange = (value)=>{
        this._value = value;
        this.id && (0, $dcb3b373c5027d86$export$3bf0495508a61ee)(this.id, value);
    };
    internalRender() {
        const element = (0, $ca7727ba78b87422$export$f23ef6cb462a47f7)(this.renderReact());
        return element;
    }
    renderReact = ()=>{
        return this.id ? /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $0eac5ed5b4c13616$export$2e2bcd8739ae039), {
            id: this.id,
            ratingMin: this.ratingMin,
            ratingMax: this.ratingMax,
            emojis: this.emojis,
            strokeColor: this.strokeColor,
            handleChange: this.handleChange
        }) : /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eO7Kz))).Fragment, {});
    };
}
(0, $49f51cfbe488d9fc$export$29e00dfd3077644b)([
    $d47cbf04a0a44873$exports.property($23976b476f54bdf7$export$527d02f4ea70b77.ratingMinProperty)
], $23976b476f54bdf7$export$527d02f4ea70b77.prototype, "ratingMin", null);
(0, $49f51cfbe488d9fc$export$29e00dfd3077644b)([
    $d47cbf04a0a44873$exports.property($23976b476f54bdf7$export$527d02f4ea70b77.ratingMaxProperty)
], $23976b476f54bdf7$export$527d02f4ea70b77.prototype, "ratingMax", null);
(0, $49f51cfbe488d9fc$export$29e00dfd3077644b)([
    $d47cbf04a0a44873$exports.property($23976b476f54bdf7$export$527d02f4ea70b77.emojisProperty)
], $23976b476f54bdf7$export$527d02f4ea70b77.prototype, "emojis", null);
(0, $49f51cfbe488d9fc$export$29e00dfd3077644b)([
    $d47cbf04a0a44873$exports.property($23976b476f54bdf7$export$527d02f4ea70b77.strokeColorProperty)
], $23976b476f54bdf7$export$527d02f4ea70b77.prototype, "strokeColor", null);


/* eslint-disable react/jsx-boolean-value */ 


var $eO7Kz = parcelRequire("eO7Kz");


/* eslint-disable react/jsx-boolean-value */ 

class $438812f10645fa33$export$fce58f7f7dbd3025 extends $d47cbf04a0a44873$exports.SerializableObject {
    static JsonTypeName = "ChoiceWithUrl";
    getJsonTypeName() {
        return $438812f10645fa33$export$fce58f7f7dbd3025.JsonTypeName;
    }
    getSchemaKey() {
        return $438812f10645fa33$export$fce58f7f7dbd3025.JsonTypeName;
    }
    static titleProperty = new $d47cbf04a0a44873$exports.StringProperty($d47cbf04a0a44873$exports.Versions.v1_0, "title", true);
    static valueProperty = new $d47cbf04a0a44873$exports.StringProperty($d47cbf04a0a44873$exports.Versions.v1_0, "value", true);
    // Add url property to schema
    static urlProperty = new $d47cbf04a0a44873$exports.StringProperty($d47cbf04a0a44873$exports.Versions.v1_0, "url", true);
    get title() {
        return this.getValue($438812f10645fa33$export$fce58f7f7dbd3025.titleProperty) || "";
    }
    set title(val) {
        if (this.title !== val) this.setValue($438812f10645fa33$export$fce58f7f7dbd3025.titleProperty, val);
    }
    get value() {
        return this.getValue($438812f10645fa33$export$fce58f7f7dbd3025.valueProperty) || "";
    }
    set value(val) {
        if (this.value !== val) this.setValue($438812f10645fa33$export$fce58f7f7dbd3025.valueProperty, val);
    }
    get url() {
        return this.getValue($438812f10645fa33$export$fce58f7f7dbd3025.urlProperty) || "";
    }
    set url(val) {
        if (this.url !== val) this.setValue($438812f10645fa33$export$fce58f7f7dbd3025.urlProperty, val);
    }
    constructor(title, value, url){
        super();
        this.title = title || "";
        this.value = value || "";
        this.url = url || "";
    }
}
(0, $49f51cfbe488d9fc$export$29e00dfd3077644b)([
    $d47cbf04a0a44873$exports.property($438812f10645fa33$export$fce58f7f7dbd3025.titleProperty)
], $438812f10645fa33$export$fce58f7f7dbd3025.prototype, "title", null);
(0, $49f51cfbe488d9fc$export$29e00dfd3077644b)([
    $d47cbf04a0a44873$exports.property($438812f10645fa33$export$fce58f7f7dbd3025.valueProperty)
], $438812f10645fa33$export$fce58f7f7dbd3025.prototype, "value", null);
(0, $49f51cfbe488d9fc$export$29e00dfd3077644b)([
    $d47cbf04a0a44873$exports.property($438812f10645fa33$export$fce58f7f7dbd3025.urlProperty)
], $438812f10645fa33$export$fce58f7f7dbd3025.prototype, "url", null);




var $eO7Kz = parcelRequire("eO7Kz");




const $1de7bf472cdf56cf$var$MultiSelect = ({ id: id, choices: choices, smallImages: smallImages, showCaptions: showCaptions, handleSelect: handleSelect })=>{
    const { currentSubView: currentSubView } = (0, $134592d23f105dbc$export$77e4cc5334565f28)();
    const [display, setDisplay] = (0, $eO7Kz.useState)([]);
    const [chosen, setChosen] = (0, $eO7Kz.useState)((0, $dcb3b373c5027d86$export$b5ed0bbebfb6af43)(id, []));
    const [overflow, setOverflow] = (0, $eO7Kz.useState)(false);
    const [style, setStyle] = (0, $eO7Kz.useState)("");
    /**
   * On choices props change :
   *  - fill display state with choices value
   *  - set overflow and style states depending on the smallImages boolean prop and the number of choices
   */ (0, $eO7Kz.useEffect)(()=>{
        if (choices) {
            setDisplay(choices);
            if (smallImages) {
                if (choices.length > 6) {
                    setOverflow(true);
                    setStyle("rf-flex rf-flex-row rf-justify-start rf-align-center rf-overflow-x-scroll rf-pb-4");
                } else {
                    setOverflow(false);
                    setStyle("rf-grid rf-grid-rows-2 rf-grid-cols-3");
                }
            } else if (choices.length > 2) {
                setOverflow(true);
                setStyle("rf-flex rf-flex-row rf-justify-start rf-align-center rf-overflow-x-scroll rf-pb-4");
            } else {
                setOverflow(false);
                setStyle("rf-grid rf-grid-rows-1 rf-grid-cols-2");
            }
        }
    }, [
        choices
    ]);
    /**
   * On chosen state change :
   *  - call parent's handleChangeCheckbox method
   */ (0, $eO7Kz.useEffect)(()=>{
        handleSelect(chosen);
    }, [
        chosen
    ]);
    /**
   * On call:
   *  - check if the component will be rendered in history, if so bypass every interaction
   *  - check for checked / unchecked values and fill chosen state with these
   *  - call parent's handleSelect method
   * @param value : string
   */ const handleChange = (value)=>{
        if (currentSubView !== (0, $16ad089b9ce6627d$export$f05d0fed0593ead7).history) {
            let tempChosen = [
                ...chosen
            ];
            if (tempChosen.includes(value)) tempChosen = tempChosen.filter((chosenValue)=>chosenValue !== value);
            else tempChosen = [
                ...tempChosen,
                value
            ];
            setChosen(tempChosen);
        }
    };
    return display && display.length > 0 ? /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("div", {
        className: `rf-w-full rf-gap-4 rf-text-size-auto rf-text-white ${style} rf-scrollbar-x-custom`,
        children: display.map((choice, key)=>{
            return /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsxs)("div", {
                className: `rf-flex rf-flex-col rf-items-start ${overflow && "rf-flex-[0_0_40%]"}`,
                children: [
                    /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsxs)("label", {
                        className: `rf-w-full rf-h-full rf-flex rf-justify-center rf-items-center rf-border-2 rf-rounded-lg ${chosen.includes(choice.value) ? "rf-border-primary" : "rf-border-formInputRadioCheckboxUncheckedBorder"} hover:rf-cursor-pointer rf-aspect-square rf-overflow-hidden`,
                        children: [
                            /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("img", {
                                src: choice.url,
                                className: "rf-max-w-full rf-max-h-full"
                            }),
                            /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("input", {
                                type: "checkbox",
                                value: choice.value,
                                checked: chosen.includes(choice.value),
                                className: "rf-input-hidden",
                                onChange: ()=>handleChange(choice.value)
                            })
                        ]
                    }),
                    showCaptions && /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("div", {
                        className: "rf-mt-2 rf-truncate",
                        children: (0, $8fd1ab545cc1ab7a$export$d07f57595c356899)(choice.title)
                    })
                ]
            }, key);
        })
    }) : /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eO7Kz))).Fragment, {});
};
var $1de7bf472cdf56cf$export$2e2bcd8739ae039 = $1de7bf472cdf56cf$var$MultiSelect;




var $eO7Kz = parcelRequire("eO7Kz");




const $d2cbd5148597ca9a$var$MonoSelect = ({ id: id, choices: choices, smallImages: smallImages, showCaptions: showCaptions, handleSelect: handleSelect })=>{
    const { currentSubView: currentSubView } = (0, $134592d23f105dbc$export$77e4cc5334565f28)();
    const [display, setDisplay] = (0, $eO7Kz.useState)([]);
    const [chosen, setChosen] = (0, $eO7Kz.useState)((0, $dcb3b373c5027d86$export$b5ed0bbebfb6af43)(id, ""));
    const [overflow, setOverflow] = (0, $eO7Kz.useState)(false);
    const [style, setStyle] = (0, $eO7Kz.useState)("");
    /**
   * On choices props change :
   *  - fill display state with choices value
   *  - set overflow and style states depending on the smallImages boolean prop and the number of choices
   */ (0, $eO7Kz.useEffect)(()=>{
        if (choices) {
            setDisplay(choices);
            if (smallImages) {
                if (choices.length > 6) {
                    setOverflow(true);
                    setStyle("rf-flex rf-flex-row rf-justify-start rf-align-center rf-overflow-x-scroll rf-pb-4");
                } else {
                    setOverflow(false);
                    setStyle(`rf-grid ${choices.length > 3 && "rf-grid-rows-2"} rf-grid-cols-3`);
                }
            } else if (choices.length > 2) {
                setOverflow(true);
                setStyle("rf-flex rf-flex-row rf-justify-start rf-align-center rf-overflow-x-scroll rf-pb-4");
            } else {
                setOverflow(false);
                setStyle("rf-grid rf-grid-rows-1 rf-grid-cols-2");
            }
        }
    }, [
        choices
    ]);
    /**
   * On call:
   *  - check if the component will be rendered in history, if so bypass every interaction
   *  - fill chosen state with value
   *  - call parent's handleSelect method
   * @param value : string
   */ const handleChange = (value)=>{
        if (currentSubView !== (0, $16ad089b9ce6627d$export$f05d0fed0593ead7).history) {
            setChosen(value);
            handleSelect(value);
        }
    };
    return display && display.length > 0 ? /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("div", {
        className: `rf-w-full rf-gap-4 rf-text-size-auto rf-text-white ${style} rf-scrollbar-x-custom`,
        children: display.map((choice, key)=>{
            return /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsxs)("div", {
                className: `rf-flex rf-flex-col rf-items-start ${overflow && "rf-flex-[0_0_40%]"}`,
                children: [
                    /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsxs)("label", {
                        className: `rf-w-full rf-h-full rf-flex rf-justify-center rf-items-center rf-border-2 rf-rounded-lg ${choice.value === chosen ? "rf-border-primary" : "rf-border-formInputRadioCheckboxUncheckedBorder"} hover:rf-cursor-pointer rf-aspect-square rf-overflow-hidden`,
                        children: [
                            /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("img", {
                                src: choice.url,
                                className: "rf-max-w-full rf-max-h-full"
                            }),
                            /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("input", {
                                type: "radio",
                                value: choice.value,
                                checked: choice.value === chosen,
                                className: "rf-input-hidden",
                                onChange: ()=>handleChange(choice.value)
                            })
                        ]
                    }),
                    showCaptions && /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("div", {
                        className: "rf-mt-2 rf-truncate",
                        children: (0, $8fd1ab545cc1ab7a$export$d07f57595c356899)(choice.title)
                    })
                ]
            }, key);
        })
    }) : /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eO7Kz))).Fragment, {});
};
var $d2cbd5148597ca9a$export$2e2bcd8739ae039 = $d2cbd5148597ca9a$var$MonoSelect;



class $8bb9b53866c746f9$export$97d8aa00da3f172d extends $d47cbf04a0a44873$exports.Input {
    _value;
    static JsonTypeName = "Retorik.ImageChoiceSet";
    getJsonTypeName() {
        return $8bb9b53866c746f9$export$97d8aa00da3f172d.JsonTypeName;
    }
    // Add custom preperties to schema
    static isMultiSelectProperty = new $d47cbf04a0a44873$exports.BoolProperty($d47cbf04a0a44873$exports.Versions.v1_0, "isMultiSelect", false);
    static smallImagesProperty = new $d47cbf04a0a44873$exports.BoolProperty($d47cbf04a0a44873$exports.Versions.v1_0, "smallImages", false);
    static showCaptionsProperty = new $d47cbf04a0a44873$exports.BoolProperty($d47cbf04a0a44873$exports.Versions.v1_0, "showCaptions", false);
    static choicesWithUrlProperty = new $d47cbf04a0a44873$exports.SerializableObjectCollectionProperty($d47cbf04a0a44873$exports.Versions.v1_0, "choicesWithUrl", (0, $438812f10645fa33$export$fce58f7f7dbd3025));
    // multiSelect property accessors
    get isMultiSelect() {
        return !!this.getValue($8bb9b53866c746f9$export$97d8aa00da3f172d.isMultiSelectProperty);
    }
    set isMultiSelect(value) {
        if (this.isMultiSelect !== value) {
            this.setValue($8bb9b53866c746f9$export$97d8aa00da3f172d.isMultiSelectProperty, value);
            this.updateLayout();
        }
    }
    // smallImages property accessors
    get smallImages() {
        return !!this.getValue($8bb9b53866c746f9$export$97d8aa00da3f172d.smallImagesProperty);
    }
    set smallImages(value) {
        if (this.smallImages !== value) {
            this.setValue($8bb9b53866c746f9$export$97d8aa00da3f172d.smallImagesProperty, value);
            this.updateLayout();
        }
    }
    // showCaptions property accessors
    get showCaptions() {
        return !!this.getValue($8bb9b53866c746f9$export$97d8aa00da3f172d.showCaptionsProperty);
    }
    set showCaptions(value) {
        if (this.smallImages !== value) {
            this.setValue($8bb9b53866c746f9$export$97d8aa00da3f172d.showCaptionsProperty, value);
            this.updateLayout();
        }
    }
    // choicesWithUrl property accessors
    get choicesWithUrl() {
        return this.getValue($8bb9b53866c746f9$export$97d8aa00da3f172d.choicesWithUrlProperty) || [];
    }
    set choicesWithUrl(value) {
        if (this.choicesWithUrl !== value) {
            this.setValue($8bb9b53866c746f9$export$97d8aa00da3f172d.choicesWithUrlProperty, value);
            this.updateLayout();
        }
    }
    get value() {
        return this._value;
    }
    isSet() {
        return this._value;
    }
    handleSelectOne = (value)=>{
        this._value = value;
        this.id && (0, $dcb3b373c5027d86$export$3bf0495508a61ee)(this.id, value);
    };
    handleChangeCheckbox = (value)=>{
        this._value = value;
        this.id && (0, $dcb3b373c5027d86$export$3bf0495508a61ee)(this.id, value);
    };
    internalRender() {
        const element = (0, $ca7727ba78b87422$export$f23ef6cb462a47f7)(this.renderReact());
        return element;
    }
    renderReact = ()=>{
        if (!this.id) return /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eO7Kz))).Fragment, {});
        if (this.isMultiSelect) {
            this._value = [];
            return /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $1de7bf472cdf56cf$export$2e2bcd8739ae039), {
                id: this.id,
                choices: this.choicesWithUrl,
                smallImages: this.smallImages,
                showCaptions: this.showCaptions,
                handleSelect: this.handleChangeCheckbox
            });
        } else return /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $d2cbd5148597ca9a$export$2e2bcd8739ae039), {
            id: this.id,
            choices: this.choicesWithUrl,
            smallImages: this.smallImages,
            showCaptions: this.showCaptions,
            handleSelect: this.handleSelectOne
        });
    };
}
(0, $49f51cfbe488d9fc$export$29e00dfd3077644b)([
    $d47cbf04a0a44873$exports.property($8bb9b53866c746f9$export$97d8aa00da3f172d.isMultiSelectProperty)
], $8bb9b53866c746f9$export$97d8aa00da3f172d.prototype, "isMultiSelect", null);
(0, $49f51cfbe488d9fc$export$29e00dfd3077644b)([
    $d47cbf04a0a44873$exports.property($8bb9b53866c746f9$export$97d8aa00da3f172d.smallImagesProperty)
], $8bb9b53866c746f9$export$97d8aa00da3f172d.prototype, "smallImages", null);
(0, $49f51cfbe488d9fc$export$29e00dfd3077644b)([
    $d47cbf04a0a44873$exports.property($8bb9b53866c746f9$export$97d8aa00da3f172d.showCaptionsProperty)
], $8bb9b53866c746f9$export$97d8aa00da3f172d.prototype, "showCaptions", null);
(0, $49f51cfbe488d9fc$export$29e00dfd3077644b)([
    $d47cbf04a0a44873$exports.property($8bb9b53866c746f9$export$97d8aa00da3f172d.choicesWithUrlProperty)
], $8bb9b53866c746f9$export$97d8aa00da3f172d.prototype, "choicesWithUrl", null);





var $eO7Kz = parcelRequire("eO7Kz");



var $eO7Kz = parcelRequire("eO7Kz");




const $033486522d57cfb0$var$Slider = ({ id: id, minValue: minValue, maxValue: maxValue, minLabel: minLabel, maxLabel: maxLabel, handleChangeSlider: handleChangeSlider })=>{
    const { themeColors: themeColors } = (0, $8b59a4dbb18c269b$export$3abe3478af3cb63b)();
    const { currentSubView: currentSubView } = (0, $134592d23f105dbc$export$77e4cc5334565f28)();
    const [sliderValue, setSliderValue] = (0, $eO7Kz.useState)((0, $dcb3b373c5027d86$export$b5ed0bbebfb6af43)(id, ((minValue || 0) + (maxValue || 100)) / 2));
    const [sliderStyle, setSliderStyle] = (0, $eO7Kz.useState)(`linear-gradient(to right, ${themeColors.primary} ${(sliderValue - (minValue || 0)) / ((maxValue || 100) - (minValue || 0)) * 100}%, #7878805C ${(sliderValue - (minValue || 0)) / ((maxValue || 100) - (minValue || 0)) * 100}%)`);
    /**
   * On slider value change :
   *  - check if the component will be rendered in history, if so bypass every interaction
   *  - set sliderValue state
   *  - call parent function with event value
   * @param e : changeEvent
   */ const handleChange = (e)=>{
        if (currentSubView !== (0, $16ad089b9ce6627d$export$f05d0fed0593ead7).history) {
            setSliderValue(e.target.value);
            handleChangeSlider(e.target.value);
        }
    };
    /**
   * On value input in slider :
   *  - check if the component will be rendered in history, if so bypass every interaction
   *  - get value as percentage
   *  - set the slider color depending on the percentage obtained
   * @param e : inputEvent
   */ const handleOnInput = (e)=>{
        if (currentSubView !== (0, $16ad089b9ce6627d$export$f05d0fed0593ead7).history) {
            // Value as percentage, we substract minValue up and down to get the right percentage if minValue !== 0
            const valPourcentage = (e.target.value - (minValue || 0)) / (e.target.max - (minValue || 0)) * 100;
            setSliderStyle(`linear-gradient(to right, ${themeColors.primary} ${valPourcentage}%, #7878805C ${valPourcentage}%)`);
        }
    };
    return /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsxs)("div", {
        className: `rf-w-full rf-px-6 rf-pt-14 ${minLabel || maxLabel ? "rf-pb-5" : "rf-pb-14"} rf-rounded-lg rf-text-size-auto rf-text-white`,
        style: {
            background: "rgba(0, 0, 0, 0.5)"
        },
        children: [
            /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("input", {
                style: {
                    background: sliderStyle
                },
                onInput: handleOnInput,
                onChange: handleChange,
                value: sliderValue,
                type: "range",
                min: minValue || 0,
                max: maxValue || 100,
                className: "rf-slider-custom"
            }),
            (minLabel || maxLabel) && /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsxs)("div", {
                className: "rf-w-full rf-mt-5 rf-flex rf-flex-row rf-justify-between rf-items-center",
                children: [
                    minLabel && /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("div", {
                        children: minLabel
                    }),
                    maxLabel && (minLabel ? /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("div", {
                        children: maxLabel
                    }) : /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($eO7Kz))).Fragment, {
                        children: [
                            /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("div", {
                                children: "⠀"
                            }),
                            /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("div", {
                                children: maxLabel
                            })
                        ]
                    }))
                ]
            })
        ]
    });
};
var $033486522d57cfb0$export$2e2bcd8739ae039 = $033486522d57cfb0$var$Slider;




class $31f4f10bf6668fc6$export$7f21b8f94f2ce32b extends $d47cbf04a0a44873$exports.Input {
    _value = this.minValue && this.maxValue ? Math.floor((this.minValue + this.maxValue) / 2) : 50;
    get value() {
        return this._value;
    }
    isSet() {
        return this._value;
    }
    static JsonTypeName = "Retorik.Slider";
    getJsonTypeName() {
        return $31f4f10bf6668fc6$export$7f21b8f94f2ce32b.JsonTypeName;
    }
    // Add custom properties to schema
    static minValueProperty = new $d47cbf04a0a44873$exports.NumProperty($d47cbf04a0a44873$exports.Versions.v1_0, "minValue");
    static maxValueProperty = new $d47cbf04a0a44873$exports.NumProperty($d47cbf04a0a44873$exports.Versions.v1_0, "maxValue");
    static minLabelProperty = new $d47cbf04a0a44873$exports.StringProperty($d47cbf04a0a44873$exports.Versions.v1_0, "minLabel", true);
    static maxLabelProperty = new $d47cbf04a0a44873$exports.StringProperty($d47cbf04a0a44873$exports.Versions.v1_0, "maxLabel", true);
    // minValue property accessors
    get minValue() {
        return this.getValue($31f4f10bf6668fc6$export$7f21b8f94f2ce32b.minValueProperty);
    }
    set minValue(value) {
        if (this.minValue !== value) {
            this.setValue($31f4f10bf6668fc6$export$7f21b8f94f2ce32b.minValueProperty, value);
            this.updateLayout();
        }
    }
    // maxValue property accessors
    get maxValue() {
        return this.getValue($31f4f10bf6668fc6$export$7f21b8f94f2ce32b.maxValueProperty);
    }
    set maxValue(value) {
        if (this.maxValue !== value) {
            this.setValue($31f4f10bf6668fc6$export$7f21b8f94f2ce32b.maxValueProperty, value);
            this.updateLayout();
        }
    }
    // minLabel property accessors
    get minLabel() {
        return this.getValue($31f4f10bf6668fc6$export$7f21b8f94f2ce32b.minLabelProperty);
    }
    set minLabel(value) {
        if (this.minLabel !== value) {
            this.setValue($31f4f10bf6668fc6$export$7f21b8f94f2ce32b.minLabelProperty, value);
            this.updateLayout();
        }
    }
    // maxLabel property accessors
    get maxLabel() {
        return this.getValue($31f4f10bf6668fc6$export$7f21b8f94f2ce32b.maxLabelProperty);
    }
    set maxLabel(value) {
        if (this.maxLabel !== value) {
            this.setValue($31f4f10bf6668fc6$export$7f21b8f94f2ce32b.maxLabelProperty, value);
            this.updateLayout();
        }
    }
    handleChange = (value)=>{
        this._value = value;
        this.id && (0, $dcb3b373c5027d86$export$3bf0495508a61ee)(this.id, value);
    };
    internalRender() {
        const element = (0, $ca7727ba78b87422$export$f23ef6cb462a47f7)(this.renderReact());
        return element;
    }
    renderReact = ()=>{
        return this.id ? /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $033486522d57cfb0$export$2e2bcd8739ae039), {
            id: this.id,
            minValue: this.minValue,
            maxValue: this.maxValue,
            minLabel: this.minLabel,
            maxLabel: this.maxLabel,
            handleChangeSlider: this.handleChange
        }) : /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eO7Kz))).Fragment, {});
    };
}
(0, $49f51cfbe488d9fc$export$29e00dfd3077644b)([
    $d47cbf04a0a44873$exports.property($31f4f10bf6668fc6$export$7f21b8f94f2ce32b.minValueProperty)
], $31f4f10bf6668fc6$export$7f21b8f94f2ce32b.prototype, "minValue", null);
(0, $49f51cfbe488d9fc$export$29e00dfd3077644b)([
    $d47cbf04a0a44873$exports.property($31f4f10bf6668fc6$export$7f21b8f94f2ce32b.maxValueProperty)
], $31f4f10bf6668fc6$export$7f21b8f94f2ce32b.prototype, "maxValue", null);
(0, $49f51cfbe488d9fc$export$29e00dfd3077644b)([
    $d47cbf04a0a44873$exports.property($31f4f10bf6668fc6$export$7f21b8f94f2ce32b.minLabelProperty)
], $31f4f10bf6668fc6$export$7f21b8f94f2ce32b.prototype, "minLabel", null);
(0, $49f51cfbe488d9fc$export$29e00dfd3077644b)([
    $d47cbf04a0a44873$exports.property($31f4f10bf6668fc6$export$7f21b8f94f2ce32b.maxLabelProperty)
], $31f4f10bf6668fc6$export$7f21b8f94f2ce32b.prototype, "maxLabel", null);




parcelRequire("eO7Kz");




var $eO7Kz = parcelRequire("eO7Kz");








const $8624846274e8958a$var$ActionButton = ({ text: text, fullWidth: fullWidth, position: position, display: display, onClick: onClick })=>{
    const { currentSubView: currentSubView } = (0, $134592d23f105dbc$export$77e4cc5334565f28)();
    const { locale: locale } = (0, $2e4dc8fa28d39601$export$6650dace022cfacc)();
    const { themeColors: themeColors } = (0, $8b59a4dbb18c269b$export$3abe3478af3cb63b)();
    const [style, setStyle] = (0, $eO7Kz.useState)();
    const [hover, setHover] = (0, $eO7Kz.useState)(false);
    (0, $eO7Kz.useEffect)(()=>{
        // Set width : full or fit
        let temp = fullWidth ? "rf-w-full" : "rf-w-fit";
        // Set position if not in full width
        if (!fullWidth && position) switch(position){
            case "right":
                temp += " rf-float-right";
                break;
            case "center":
                temp += " rf-mx-auto";
                break;
            case "left":
            default:
                break;
        }
        setStyle(temp);
    }, []);
    const handleClick = ()=>{
        if (currentSubView !== (0, $16ad089b9ce6627d$export$f05d0fed0593ead7).history) {
            setHover(true);
            onClick();
        }
    };
    const handleEnter = ()=>{
        if (currentSubView !== (0, $16ad089b9ce6627d$export$f05d0fed0593ead7).history) setHover(true);
    };
    const handleLeave = ()=>{
        if (currentSubView !== (0, $16ad089b9ce6627d$export$f05d0fed0593ead7).history) setHover(false);
    };
    return text && display.toLowerCase() === "link" ? /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsxs)("div", {
        className: `rf-w-full rf-mt-2 rf-flex rf-justify-start rf-items-center rf-text-cardButtonTextDefault ${currentSubView !== (0, $16ad089b9ce6627d$export$f05d0fed0593ead7).history && "rf-cursor-pointer"}`,
        onPointerEnter: handleEnter,
        onPointerLeave: handleLeave,
        onClick: handleClick,
        children: [
            /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("div", {
                className: `rf-h-6 rf-w-6 rf-rounded ${hover ? "rf-bg-cardButtonBackgroundHover" : "rf-bg-cardButtonBackgroundDefault"}`,
                children: /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $e2ba1a14911a30a0$export$2e2bcd8739ae039), {
                    className: "rf-h-6 rf-p-1 rf-border rf-rounded rf-border-cardButtonBorderDefault",
                    color: hover ? themeColors.card.button.text.hover : themeColors.card.button.text.default
                })
            }),
            /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("div", {
                className: "rf-ml-4",
                children: (0, $8fd1ab545cc1ab7a$export$d07f57595c356899)(text)
            })
        ]
    }) : /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("div", {
        className: ` ${currentSubView !== (0, $16ad089b9ce6627d$export$f05d0fed0593ead7).history ? "rf-card-button" : "rf-card-button-history"} rf-mt-2 ${fullWidth ? "rf-text-center" : "rf-text-left"} ${style}`,
        onClick: handleClick,
        children: (0, $8fd1ab545cc1ab7a$export$d07f57595c356899)(text || (0, (/*@__PURE__*/$parcel$interopDefault($c4f4e8117c4a001a$exports)))[locale]?.submit || (0, (/*@__PURE__*/$parcel$interopDefault($c4f4e8117c4a001a$exports)))[(0, $674f1d59bae686ab$export$8828fbbb6034a09b).default].submit)
    });
};
var $8624846274e8958a$export$2e2bcd8739ae039 = $8624846274e8958a$var$ActionButton;


class $2fa3aca4c1877507$export$ea4365d42c3e8532 extends $d47cbf04a0a44873$exports.SubmitAction {
    internalRenderedElement = document.createElement("div");
    static fullWidthProperty = new $d47cbf04a0a44873$exports.BoolProperty($d47cbf04a0a44873$exports.Versions.v1_0, "fullWidth", false);
    static positionProperty = new $d47cbf04a0a44873$exports.StringProperty($d47cbf04a0a44873$exports.Versions.v1_0, "position", true, undefined, "left");
    static displayProperty = new $d47cbf04a0a44873$exports.StringProperty($d47cbf04a0a44873$exports.Versions.v1_0, "display", true, undefined, "button");
    // fullWidth property accessors
    get fullWidth() {
        return this.getValue($2fa3aca4c1877507$export$ea4365d42c3e8532.fullWidthProperty);
    }
    set fullWidth(value) {
        if (this.fullWidth !== value) this.setValue($2fa3aca4c1877507$export$ea4365d42c3e8532.fullWidthProperty, value);
    }
    // position property accessors
    get position() {
        return this.getValue($2fa3aca4c1877507$export$ea4365d42c3e8532.positionProperty);
    }
    set position(value) {
        if (this.position !== value) this.setValue($2fa3aca4c1877507$export$ea4365d42c3e8532.positionProperty, value);
    }
    // display property accessors
    get display() {
        return this.getValue($2fa3aca4c1877507$export$ea4365d42c3e8532.displayProperty);
    }
    set display(value) {
        if (this.display !== value) this.setValue($2fa3aca4c1877507$export$ea4365d42c3e8532.displayProperty, value);
    }
    get renderedElement() {
        return this.internalRenderedElement;
    }
    render() {
        this.internalRenderedElement = (0, $ca7727ba78b87422$export$f23ef6cb462a47f7)(this.renderReact());
    }
    renderReact = ()=>{
        const props = {
            onClick: ()=>this.execute(),
            text: this.title,
            fullWidth: this.fullWidth,
            position: this.position,
            display: this.display
        };
        return /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $8624846274e8958a$export$2e2bcd8739ae039), {
            ...props
        });
    };
}
(0, $49f51cfbe488d9fc$export$29e00dfd3077644b)([
    $d47cbf04a0a44873$exports.property($2fa3aca4c1877507$export$ea4365d42c3e8532.fullWidthProperty)
], $2fa3aca4c1877507$export$ea4365d42c3e8532.prototype, "fullWidth", null);
(0, $49f51cfbe488d9fc$export$29e00dfd3077644b)([
    $d47cbf04a0a44873$exports.property($2fa3aca4c1877507$export$ea4365d42c3e8532.positionProperty)
], $2fa3aca4c1877507$export$ea4365d42c3e8532.prototype, "position", null);
(0, $49f51cfbe488d9fc$export$29e00dfd3077644b)([
    $d47cbf04a0a44873$exports.property($2fa3aca4c1877507$export$ea4365d42c3e8532.displayProperty)
], $2fa3aca4c1877507$export$ea4365d42c3e8532.prototype, "display", null);




parcelRequire("eO7Kz");



class $adbb250a6f696a24$export$3226295bbd9dad06 extends $d47cbf04a0a44873$exports.OpenUrlAction {
    internalRenderedElement = document.createElement("div");
    static fullWidthProperty = new $d47cbf04a0a44873$exports.BoolProperty($d47cbf04a0a44873$exports.Versions.v1_0, "fullWidth", false);
    static positionProperty = new $d47cbf04a0a44873$exports.StringProperty($d47cbf04a0a44873$exports.Versions.v1_0, "position", true, undefined, "left");
    static displayProperty = new $d47cbf04a0a44873$exports.StringProperty($d47cbf04a0a44873$exports.Versions.v1_0, "display", true, undefined, "button");
    // fullWidth property accessors
    get fullWidth() {
        return this.getValue($adbb250a6f696a24$export$3226295bbd9dad06.fullWidthProperty);
    }
    set fullWidth(value) {
        if (this.fullWidth !== value) this.setValue($adbb250a6f696a24$export$3226295bbd9dad06.fullWidthProperty, value);
    }
    // position property accessors
    get position() {
        return this.getValue($adbb250a6f696a24$export$3226295bbd9dad06.positionProperty);
    }
    set position(value) {
        if (this.position !== value) this.setValue($adbb250a6f696a24$export$3226295bbd9dad06.positionProperty, value);
    }
    // display property accessors
    get display() {
        return this.getValue($adbb250a6f696a24$export$3226295bbd9dad06.displayProperty);
    }
    set display(value) {
        if (this.display !== value) this.setValue($adbb250a6f696a24$export$3226295bbd9dad06.displayProperty, value);
    }
    get renderedElement() {
        return this.internalRenderedElement;
    }
    render() {
        this.internalRenderedElement = (0, $ca7727ba78b87422$export$f23ef6cb462a47f7)(this.renderReact());
    }
    renderReact = ()=>{
        const props = {
            onClick: ()=>this.execute(),
            text: this.title,
            fullWidth: this.fullWidth,
            position: this.position,
            display: this.display
        };
        return /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $8624846274e8958a$export$2e2bcd8739ae039), {
            ...props
        });
    };
}
(0, $49f51cfbe488d9fc$export$29e00dfd3077644b)([
    $d47cbf04a0a44873$exports.property($adbb250a6f696a24$export$3226295bbd9dad06.fullWidthProperty)
], $adbb250a6f696a24$export$3226295bbd9dad06.prototype, "fullWidth", null);
(0, $49f51cfbe488d9fc$export$29e00dfd3077644b)([
    $d47cbf04a0a44873$exports.property($adbb250a6f696a24$export$3226295bbd9dad06.positionProperty)
], $adbb250a6f696a24$export$3226295bbd9dad06.prototype, "position", null);
(0, $49f51cfbe488d9fc$export$29e00dfd3077644b)([
    $d47cbf04a0a44873$exports.property($adbb250a6f696a24$export$3226295bbd9dad06.displayProperty)
], $adbb250a6f696a24$export$3226295bbd9dad06.prototype, "display", null);




parcelRequire("eO7Kz");



class $4def75d9051009b5$export$17915a7271c45b27 extends $d47cbf04a0a44873$exports.ShowCardAction {
    internalRenderedElement = document.createElement("div");
    static fullWidthProperty = new $d47cbf04a0a44873$exports.BoolProperty($d47cbf04a0a44873$exports.Versions.v1_0, "fullWidth", false);
    static positionProperty = new $d47cbf04a0a44873$exports.StringProperty($d47cbf04a0a44873$exports.Versions.v1_0, "position", true, undefined, "left");
    static displayProperty = new $d47cbf04a0a44873$exports.StringProperty($d47cbf04a0a44873$exports.Versions.v1_0, "display", true, undefined, "button");
    // fullWidth property accessors
    get fullWidth() {
        return this.getValue($4def75d9051009b5$export$17915a7271c45b27.fullWidthProperty);
    }
    set fullWidth(value) {
        if (this.fullWidth !== value) this.setValue($4def75d9051009b5$export$17915a7271c45b27.fullWidthProperty, value);
    }
    // position property accessors
    get position() {
        return this.getValue($4def75d9051009b5$export$17915a7271c45b27.positionProperty);
    }
    set position(value) {
        if (this.position !== value) this.setValue($4def75d9051009b5$export$17915a7271c45b27.positionProperty, value);
    }
    // display property accessors
    get display() {
        return this.getValue($4def75d9051009b5$export$17915a7271c45b27.displayProperty);
    }
    set display(value) {
        if (this.display !== value) this.setValue($4def75d9051009b5$export$17915a7271c45b27.displayProperty, value);
    }
    get renderedElement() {
        return this.internalRenderedElement;
    }
    render() {
        this.internalRenderedElement = (0, $ca7727ba78b87422$export$f23ef6cb462a47f7)(this.renderReact());
    }
    renderReact = ()=>{
        const props = {
            onClick: ()=>this.execute(),
            text: this.title,
            fullWidth: this.fullWidth,
            position: this.position,
            display: this.display
        };
        return /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $8624846274e8958a$export$2e2bcd8739ae039), {
            ...props
        });
    };
}
(0, $49f51cfbe488d9fc$export$29e00dfd3077644b)([
    $d47cbf04a0a44873$exports.property($4def75d9051009b5$export$17915a7271c45b27.fullWidthProperty)
], $4def75d9051009b5$export$17915a7271c45b27.prototype, "fullWidth", null);
(0, $49f51cfbe488d9fc$export$29e00dfd3077644b)([
    $d47cbf04a0a44873$exports.property($4def75d9051009b5$export$17915a7271c45b27.positionProperty)
], $4def75d9051009b5$export$17915a7271c45b27.prototype, "position", null);
(0, $49f51cfbe488d9fc$export$29e00dfd3077644b)([
    $d47cbf04a0a44873$exports.property($4def75d9051009b5$export$17915a7271c45b27.displayProperty)
], $4def75d9051009b5$export$17915a7271c45b27.prototype, "display", null);




parcelRequire("eO7Kz");



class $245071f7fd353dc0$export$e4bbccd75e2f23fc extends $d47cbf04a0a44873$exports.ToggleVisibilityAction {
    internalRenderedElement = document.createElement("div");
    static fullWidthProperty = new $d47cbf04a0a44873$exports.BoolProperty($d47cbf04a0a44873$exports.Versions.v1_0, "fullWidth", false);
    static positionProperty = new $d47cbf04a0a44873$exports.StringProperty($d47cbf04a0a44873$exports.Versions.v1_0, "position", true, undefined, "left");
    static displayProperty = new $d47cbf04a0a44873$exports.StringProperty($d47cbf04a0a44873$exports.Versions.v1_0, "display", true, undefined, "button");
    // fullWidth property accessors
    get fullWidth() {
        return this.getValue($245071f7fd353dc0$export$e4bbccd75e2f23fc.fullWidthProperty);
    }
    set fullWidth(value) {
        if (this.fullWidth !== value) this.setValue($245071f7fd353dc0$export$e4bbccd75e2f23fc.fullWidthProperty, value);
    }
    // position property accessors
    get position() {
        return this.getValue($245071f7fd353dc0$export$e4bbccd75e2f23fc.positionProperty);
    }
    set position(value) {
        if (this.position !== value) this.setValue($245071f7fd353dc0$export$e4bbccd75e2f23fc.positionProperty, value);
    }
    // display property accessors
    get display() {
        return this.getValue($245071f7fd353dc0$export$e4bbccd75e2f23fc.displayProperty);
    }
    set display(value) {
        if (this.display !== value) this.setValue($245071f7fd353dc0$export$e4bbccd75e2f23fc.displayProperty, value);
    }
    get renderedElement() {
        return this.internalRenderedElement;
    }
    render() {
        this.internalRenderedElement = (0, $ca7727ba78b87422$export$f23ef6cb462a47f7)(this.renderReact());
    }
    renderReact = ()=>{
        const props = {
            onClick: ()=>this.execute(),
            text: this.title,
            fullWidth: this.fullWidth,
            position: this.position,
            display: this.display
        };
        return /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $8624846274e8958a$export$2e2bcd8739ae039), {
            ...props
        });
    };
}
(0, $49f51cfbe488d9fc$export$29e00dfd3077644b)([
    $d47cbf04a0a44873$exports.property($245071f7fd353dc0$export$e4bbccd75e2f23fc.fullWidthProperty)
], $245071f7fd353dc0$export$e4bbccd75e2f23fc.prototype, "fullWidth", null);
(0, $49f51cfbe488d9fc$export$29e00dfd3077644b)([
    $d47cbf04a0a44873$exports.property($245071f7fd353dc0$export$e4bbccd75e2f23fc.positionProperty)
], $245071f7fd353dc0$export$e4bbccd75e2f23fc.prototype, "position", null);
(0, $49f51cfbe488d9fc$export$29e00dfd3077644b)([
    $d47cbf04a0a44873$exports.property($245071f7fd353dc0$export$e4bbccd75e2f23fc.displayProperty)
], $245071f7fd353dc0$export$e4bbccd75e2f23fc.prototype, "display", null);


let $da5f59a8e6b29cdb$var$iconsInitialized = false;
/**
 * STORYBOOK : elements that have no decorator and thus don't have to be commented to build storybook :
 *  - TextBlock
 *  - Input.Toggle
 * Every other element has to be commented otherwise storybook build will fail
 */ const $da5f59a8e6b29cdb$export$6108075486421829 = ()=>{
    if (!$da5f59a8e6b29cdb$var$iconsInitialized) {
        (0, $d668900f9755141e$export$daed2daeba655e15)();
        $da5f59a8e6b29cdb$var$iconsInitialized = true;
    }
    // Override existing elements
    $d47cbf04a0a44873$exports.GlobalRegistry.elements.register("TextBlock", (0, $6c27d03abb27bc22$export$92739f4310a31a0d));
    $d47cbf04a0a44873$exports.GlobalRegistry.elements.register("Input.Toggle", (0, $cb0e37c77bf07f7e$export$c99bfd6b0ed44fbd));
    $d47cbf04a0a44873$exports.GlobalRegistry.elements.register("Input.Date", (0, $62c56236a538f649$export$a9633577dcb92569));
    $d47cbf04a0a44873$exports.GlobalRegistry.elements.register("Input.Time", (0, $0ecaa55e6c7a6555$export$27dc9c3aadf0815c));
    $d47cbf04a0a44873$exports.GlobalRegistry.elements.register("Input.ChoiceSet", (0, $21bf09b727f272df$export$3d2f970ec3b98a50));
    // Register new elements
    $d47cbf04a0a44873$exports.GlobalRegistry.elements.register("Retorik.ImageChoiceSet", (0, $8bb9b53866c746f9$export$97d8aa00da3f172d));
    $d47cbf04a0a44873$exports.GlobalRegistry.elements.register("Retorik.Likert", (0, $23976b476f54bdf7$export$527d02f4ea70b77));
    $d47cbf04a0a44873$exports.GlobalRegistry.elements.register("Retorik.Slider", (0, $31f4f10bf6668fc6$export$7f21b8f94f2ce32b));
    // Override existing actions
    $d47cbf04a0a44873$exports.GlobalRegistry.actions.register("Action.Submit", (0, $2fa3aca4c1877507$export$ea4365d42c3e8532));
    $d47cbf04a0a44873$exports.GlobalRegistry.actions.register("Action.OpenUrl", (0, $adbb250a6f696a24$export$3226295bbd9dad06));
    $d47cbf04a0a44873$exports.GlobalRegistry.actions.register("Action.ShowCard", (0, $4def75d9051009b5$export$17915a7271c45b27));
    $d47cbf04a0a44873$exports.GlobalRegistry.actions.register("Action.ToggleVisibility", (0, $245071f7fd353dc0$export$e4bbccd75e2f23fc));
};



// Add markdown-it to window for markdown processing
window.markdownit = (0, (/*@__PURE__*/$parcel$interopDefault($462e820625752270$exports)));
(0, $da5f59a8e6b29cdb$export$6108075486421829)();
const $17a5c51a47881692$var$defaultUser = {
    name: "default",
    id: "",
    username: "default",
    nom: "defaultName",
    prenom: "\xe0 vous",
    email: "",
    token: "",
    referrer: "",
    ipaddress: ""
};
/**
 * Component using DirectLine
 * @param props
 */ const $17a5c51a47881692$var$RetorikComposer = ({ addressData: addressData, userData: userData, externalEventHandler: externalEventHandler, customVoice: customVoice, children: children, colors: colors })=>{
    const [directLine, setDirectLine] = (0, $eO7Kz.useState)(null);
    const [store, setStore] = (0, $eO7Kz.useState)(null);
    const { ponyfillCredentials: ponyfillCredentials } = (0, $633c6ef6f1f791c0$export$57e792e009c800a0)();
    const { configuration: configuration, agentData: agentData, setAppAvailable: setAppAvailable, loaderClosed: loaderClosed } = (0, $e599569c1fc3ca2c$export$d8760bee47331b1d)();
    const { locale: locale, supported: supported } = (0, $2e4dc8fa28d39601$export$6650dace022cfacc)();
    (0, $eO7Kz.useEffect)(()=>{
        if (addressData) (0, $487d6caaad26fd47$export$97c24bbbbbd7be8a)(addressData).then((token)=>{
            let test = true;
            if (configuration.enableConversationCookie !== false) {
                const conversationCookie = document.cookie.split("; ").find((row)=>row.startsWith("retorikConversationCookie="))?.split("=")[1];
                if (conversationCookie) {
                    const splitCookieData = conversationCookie.split("||");
                    if (splitCookieData.length === 2) {
                        const cookieConversationId = splitCookieData[0];
                        const cookieTenantName = splitCookieData[1];
                        const fullTenantName = (addressData.baseURI || `${addressData.prefix || ""}${addressData.tenant}`).replace(/;|,|\s/g, "");
                        if (cookieTenantName === fullTenantName) {
                            setDirectLine((0, $497baa802110a7bc$exports.createDirectLine)({
                                token: token,
                                conversationId: cookieConversationId,
                                watermark: "0"
                            }));
                            test = false;
                        }
                    }
                }
            }
            test && setDirectLine((0, $497baa802110a7bc$exports.createDirectLine)({
                token: token
            }));
        });
    }, [
        addressData
    ]);
    const ponyfillFactory = (0, $eO7Kz.useMemo)(()=>{
        if (ponyfillCredentials) {
            const ponyfill = (0, $497baa802110a7bc$exports.createCognitiveServicesSpeechServicesPonyfillFactory)({
                credentials: ponyfillCredentials
            });
            return ponyfill;
        }
        return null;
    }, [
        ponyfillCredentials
    ]);
    // Initialize the store
    (0, $eO7Kz.useEffect)(()=>{
        initStore();
    }, []);
    // Create custom store
    function initStore() {
        setStore((0, $a56e9ca45008a3e7$export$2e2bcd8739ae039)(userData || $17a5c51a47881692$var$defaultUser, configuration.enableConversationCookie, configuration.conversationCookieMaxAge, addressData, configuration.skipWelcome || false, locale, externalEventHandler, !!configuration.isUsedOnBorne));
    }
    const selectVoice = (voices, activity)=>{
        let voice = null;
        // Check if a custom voice is defined in the props
        if (customVoice) {
            if (customVoice.voice) {
                // Search voice with its full name (ex: AriaNeural, GuyNeural)
                const neuralVoice = new RegExp(customVoice.voice, "iu");
                voice = voices.find(({ name: name })=>neuralVoice.test(name) || name === customVoice.voice);
            } else if (customVoice.gender) // Search voice depending on given gender and locale
            voice = voices.find(({ gender: gender, lang: lang })=>{
                return gender.toLowerCase() === customVoice?.gender?.toLowerCase() && lang === activity.locale;
            });
        }
        // Get voice depending on locale and gender
        if (!voice) voice = voices.find(({ gender: gender, lang: lang })=>{
            return gender.toLowerCase() === (agentData?.gender?.toLowerCase() || "female") && lang === activity.locale;
        });
        // No voice found, fall back to US default voices : female => Aria / male => Guy
        if (!voice) {
            const genderedVoice = agentData?.gender?.toLowerCase() === "female" ? "AriaNeural" : "GuyNeural";
            const neuralVoice = new RegExp(genderedVoice, "iu");
            voice = voices.find(({ name: name })=>neuralVoice.test(name));
        }
        return voice;
    };
    const customAdaptiveCardHostConfig = (0, $264104565ab24525$export$2e2bcd8739ae039)(colors.primary, colors.card.frame.background);
    (0, $eO7Kz.useEffect)(()=>{
        if (locale && supported && directLine && ponyfillFactory && store && agentData && loaderClosed) setAppAvailable(true);
        else setAppAvailable(false);
    }, [
        locale,
        supported,
        directLine,
        ponyfillFactory,
        store,
        agentData,
        loaderClosed
    ]);
    return directLine && ponyfillFactory && store && agentData ? /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($caYbs))), {
        adaptiveCardsHostConfig: customAdaptiveCardHostConfig,
        adaptiveCardsPackage: $d47cbf04a0a44873$exports,
        styleOptions: {
            primaryFont: '"Helvetica Neue", sans-serif',
            sendBoxTextWrap: true,
            sendBoxBackground: "transparent"
        },
        directLine: directLine,
        webSpeechPonyfillFactory: ponyfillFactory,
        selectVoice: selectVoice,
        store: store,
        locale: locale,
        attachmentMiddleware: (0, $60ac0716299d3329$export$2e2bcd8739ae039),
        activityMiddleware: (0, $c8af573dcfa63824$export$2e2bcd8739ae039),
        children: [
            /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $509013a06567fce8$export$2e2bcd8739ae039), {}),
            children
        ]
    }) : /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eO7Kz))).Fragment, {});
};
var $17a5c51a47881692$export$2e2bcd8739ae039 = $17a5c51a47881692$var$RetorikComposer;




var $eO7Kz = parcelRequire("eO7Kz");

const { useActivities: $d1f091fecbe0bca7$var$useActivities } = (0, $497baa802110a7bc$exports.hooks);
const $d1f091fecbe0bca7$var$useLastEventActivity = ()=>{
    const [activities] = $d1f091fecbe0bca7$var$useActivities();
    return activities.slice().reverse().find((activity)=>activity.type === "event");
};
var $d1f091fecbe0bca7$export$2e2bcd8739ae039 = $d1f091fecbe0bca7$var$useLastEventActivity;







var $eO7Kz = parcelRequire("eO7Kz");







var $eO7Kz = parcelRequire("eO7Kz");
// The primary entry point assumes we're working with standard ReactDOM/RN, but
// older versions that do not include `useSyncExternalStore` (React 16.9 - 17.x).
// Because of that, the useSyncExternalStore compat shim is needed.

var $bqHew = parcelRequire("bqHew");


var $kz03S = parcelRequire("kz03S");


var $kz03S = parcelRequire("kz03S");
// Default to a dummy "batch" implementation that just runs the callback
function $ab3f7370cfda2d8c$var$defaultNoopBatch(callback) {
    callback();
}
let $ab3f7370cfda2d8c$var$batch = $ab3f7370cfda2d8c$var$defaultNoopBatch; // Allow injecting another batching function later
const $ab3f7370cfda2d8c$export$4b9874722d0da7bc = (newBatch)=>$ab3f7370cfda2d8c$var$batch = newBatch; // Supply a getter just to skip dealing with ESM bindings
const $ab3f7370cfda2d8c$export$fc47d4c0ba3bd2c6 = ()=>$ab3f7370cfda2d8c$var$batch;



var $eO7Kz = parcelRequire("eO7Kz");

var $eO7Kz = parcelRequire("eO7Kz");

var $eO7Kz = parcelRequire("eO7Kz");
const $41f70b1282892289$export$cc80c08dc91f1c00 = /*#__PURE__*/ (0, $eO7Kz.createContext)(null);
var $41f70b1282892289$export$2e2bcd8739ae039 = $41f70b1282892289$export$cc80c08dc91f1c00;


function $84a73a91ff6a84d9$export$c1275ca9a6fd3ec5() {
    const contextValue = (0, $eO7Kz.useContext)((0, $41f70b1282892289$export$cc80c08dc91f1c00));
    return contextValue;
}



const $084b70d0751c7871$export$20656a4825650bd0 = ()=>{
    throw new Error("uSES not initialized!");
};


let $ea41252a5ec6592a$var$useSyncExternalStoreWithSelector = (0, $084b70d0751c7871$export$20656a4825650bd0);
const $ea41252a5ec6592a$export$e2e6e3f3f3b782e3 = (fn)=>{
    $ea41252a5ec6592a$var$useSyncExternalStoreWithSelector = fn;
};
const $ea41252a5ec6592a$var$refEquality = (a, b)=>a === b;
function $ea41252a5ec6592a$export$2b53f90d2bd1cbfb(context = (0, $41f70b1282892289$export$cc80c08dc91f1c00)) {
    const useReduxContext = context === (0, $41f70b1282892289$export$cc80c08dc91f1c00) ? (0, $84a73a91ff6a84d9$export$c1275ca9a6fd3ec5) : ()=>(0, $eO7Kz.useContext)(context);
    return function useSelector(selector, equalityFn = $ea41252a5ec6592a$var$refEquality) {
        const { store: store, subscription: subscription, getServerState: getServerState } = useReduxContext();
        const selectedState = $ea41252a5ec6592a$var$useSyncExternalStoreWithSelector(subscription.addNestedSub, store.getState, getServerState || store.getState, selector, equalityFn);
        (0, $eO7Kz.useDebugValue)(selectedState);
        return selectedState;
    };
}
const $ea41252a5ec6592a$export$2105062e25df4afe = /*#__PURE__*/ $ea41252a5ec6592a$export$2b53f90d2bd1cbfb();



var $aO5a1 = parcelRequire("aO5a1");

var $akilq = parcelRequire("akilq");

var $hKDRv = parcelRequire("hKDRv");

var $eO7Kz = parcelRequire("eO7Kz");
var $bbe78774a659a47d$exports = {};
"use strict";

$bbe78774a659a47d$exports = (parcelRequire("yQrA7"));



var $akilq = parcelRequire("akilq");
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */ function $9dedcf6b41a382a6$export$2e2bcd8739ae039(message) {
    /* eslint-disable no-console */ if (typeof console !== "undefined" && typeof console.error === "function") console.error(message);
    /* eslint-enable no-console */ try {
        // This error was thrown as a convenience so that if you enable
        // "break on all exceptions" in your console,
        // it would pause the execution at this line.
        throw new Error(message);
    /* eslint-disable no-empty */ } catch (e) {}
/* eslint-enable no-empty */ }


function $f7a9733df6dcdd6b$var$verify(selector, methodName) {
    if (!selector) throw new Error(`Unexpected value for ${methodName} in connect.`);
    else if (methodName === "mapStateToProps" || methodName === "mapDispatchToProps") {
        if (!Object.prototype.hasOwnProperty.call(selector, "dependsOnOwnProps")) (0, $9dedcf6b41a382a6$export$2e2bcd8739ae039)(`The selector for ${methodName} of connect did not specify a value for dependsOnOwnProps.`);
    }
}
function $f7a9733df6dcdd6b$export$2e2bcd8739ae039(mapStateToProps, mapDispatchToProps, mergeProps) {
    $f7a9733df6dcdd6b$var$verify(mapStateToProps, "mapStateToProps");
    $f7a9733df6dcdd6b$var$verify(mapDispatchToProps, "mapDispatchToProps");
    $f7a9733df6dcdd6b$var$verify(mergeProps, "mergeProps");
}


const $c502df705bd4bced$var$_excluded = [
    "initMapStateToProps",
    "initMapDispatchToProps",
    "initMergeProps"
];
function $c502df705bd4bced$export$d20c0c2ca6eb2b6f(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, { areStatesEqual: areStatesEqual, areOwnPropsEqual: areOwnPropsEqual, areStatePropsEqual: areStatePropsEqual }) {
    let hasRunAtLeastOnce = false;
    let state;
    let ownProps;
    let stateProps;
    let dispatchProps;
    let mergedProps;
    function handleFirstCall(firstState, firstOwnProps) {
        state = firstState;
        ownProps = firstOwnProps;
        stateProps = mapStateToProps(state, ownProps);
        dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        hasRunAtLeastOnce = true;
        return mergedProps;
    }
    function handleNewPropsAndNewState() {
        stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewProps() {
        if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewState() {
        const nextStateProps = mapStateToProps(state, ownProps);
        const statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
        stateProps = nextStateProps;
        if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleSubsequentCalls(nextState, nextOwnProps) {
        const propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
        const stateChanged = !areStatesEqual(nextState, state, nextOwnProps, ownProps);
        state = nextState;
        ownProps = nextOwnProps;
        if (propsChanged && stateChanged) return handleNewPropsAndNewState();
        if (propsChanged) return handleNewProps();
        if (stateChanged) return handleNewState();
        return mergedProps;
    }
    return function pureFinalPropsSelector(nextState, nextOwnProps) {
        return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
    };
}
function $c502df705bd4bced$export$2e2bcd8739ae039(dispatch, _ref) {
    let { initMapStateToProps: initMapStateToProps, initMapDispatchToProps: initMapDispatchToProps, initMergeProps: initMergeProps } = _ref, options = (0, $akilq.default)(_ref, $c502df705bd4bced$var$_excluded);
    const mapStateToProps = initMapStateToProps(dispatch, options);
    const mapDispatchToProps = initMapDispatchToProps(dispatch, options);
    const mergeProps = initMergeProps(dispatch, options);
    return $c502df705bd4bced$export$d20c0c2ca6eb2b6f(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}


function $a780661d8a7de03b$export$2e2bcd8739ae039(actionCreators, dispatch) {
    const boundActionCreators = {};
    for(const key in actionCreators){
        const actionCreator = actionCreators[key];
        if (typeof actionCreator === "function") boundActionCreators[key] = (...args)=>dispatch(actionCreator(...args));
    }
    return boundActionCreators;
}


/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */ function $9553fb062e480804$export$2e2bcd8739ae039(obj) {
    if (typeof obj !== "object" || obj === null) return false;
    let proto = Object.getPrototypeOf(obj);
    if (proto === null) return true;
    let baseProto = proto;
    while(Object.getPrototypeOf(baseProto) !== null)baseProto = Object.getPrototypeOf(baseProto);
    return proto === baseProto;
}



function $c18fc251fe0f2a77$export$2e2bcd8739ae039(value, displayName, methodName) {
    if (!(0, $9553fb062e480804$export$2e2bcd8739ae039)(value)) (0, $9dedcf6b41a382a6$export$2e2bcd8739ae039)(`${methodName}() in ${displayName} must return a plain object. Instead received ${value}.`);
}


function $a39e4ae7e1293327$export$710f7c60f68acd3e(//  It seems that the dispatch argument
//  could be a dispatch function in some cases (ex: whenMapDispatchToPropsIsMissing)
//  and a state object in some others (ex: whenMapStateToPropsIsMissing)
// eslint-disable-next-line no-unused-vars
getConstant) {
    return function initConstantSelector(dispatch) {
        const constant = getConstant(dispatch);
        function constantSelector() {
            return constant;
        }
        constantSelector.dependsOnOwnProps = false;
        return constantSelector;
    };
} // dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
function $a39e4ae7e1293327$export$e561b938df936d57(mapToProps) {
    return mapToProps.dependsOnOwnProps ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
} // Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
function $a39e4ae7e1293327$export$8d46c7f53c8c602f(mapToProps, methodName) {
    return function initProxySelector(dispatch, { displayName: displayName }) {
        const proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
            return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch, undefined);
        }; // allow detectFactoryAndVerify to get ownProps
        proxy.dependsOnOwnProps = true;
        proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
            proxy.mapToProps = mapToProps;
            proxy.dependsOnOwnProps = $a39e4ae7e1293327$export$e561b938df936d57(mapToProps);
            let props = proxy(stateOrDispatch, ownProps);
            if (typeof props === "function") {
                proxy.mapToProps = props;
                proxy.dependsOnOwnProps = $a39e4ae7e1293327$export$e561b938df936d57(props);
                props = proxy(stateOrDispatch, ownProps);
            }
            return props;
        };
        return proxy;
    };
}


function $8178a4646686f871$export$19ef7b929f7e2559(arg, name) {
    return (dispatch, options)=>{
        throw new Error(`Invalid value of type ${typeof arg} for ${name} argument when connecting component ${options.wrappedComponentName}.`);
    };
}


function $1c2a15c8a5280aa0$export$b69a785ceac019a6(mapDispatchToProps) {
    return mapDispatchToProps && typeof mapDispatchToProps === "object" ? (0, $a39e4ae7e1293327$export$710f7c60f68acd3e)((dispatch)=>(0, $a780661d8a7de03b$export$2e2bcd8739ae039)(mapDispatchToProps, dispatch)) : !mapDispatchToProps ? (0, $a39e4ae7e1293327$export$710f7c60f68acd3e)((dispatch)=>({
            dispatch: dispatch
        })) : typeof mapDispatchToProps === "function" ? (0, $a39e4ae7e1293327$export$8d46c7f53c8c602f)(mapDispatchToProps, "mapDispatchToProps") : (0, $8178a4646686f871$export$19ef7b929f7e2559)(mapDispatchToProps, "mapDispatchToProps");
}




function $ce3a2a3766c2d60d$export$e00e93951827eda7(mapStateToProps) {
    return !mapStateToProps ? (0, $a39e4ae7e1293327$export$710f7c60f68acd3e)(()=>({})) : typeof mapStateToProps === "function" ? (0, $a39e4ae7e1293327$export$8d46c7f53c8c602f)(mapStateToProps, "mapStateToProps") : (0, $8178a4646686f871$export$19ef7b929f7e2559)(mapStateToProps, "mapStateToProps");
}



var $aO5a1 = parcelRequire("aO5a1");


function $dc03f90e5d490759$export$691c327fc30bc857(stateProps, dispatchProps, ownProps) {
    // @ts-ignore
    return (0, $aO5a1.default)({}, ownProps, stateProps, dispatchProps);
}
function $dc03f90e5d490759$export$5b105939c84b5234(mergeProps) {
    return function initMergePropsProxy(dispatch, { displayName: displayName, areMergedPropsEqual: areMergedPropsEqual }) {
        let hasRunOnce = false;
        let mergedProps;
        return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
            const nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);
            if (hasRunOnce) {
                if (!areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
            } else {
                hasRunOnce = true;
                mergedProps = nextMergedProps;
            }
            return mergedProps;
        };
    };
}
function $dc03f90e5d490759$export$17457cf6fa742f84(mergeProps) {
    return !mergeProps ? ()=>$dc03f90e5d490759$export$691c327fc30bc857 : typeof mergeProps === "function" ? $dc03f90e5d490759$export$5b105939c84b5234(mergeProps) : (0, $8178a4646686f871$export$19ef7b929f7e2559)(mergeProps, "mergeProps");
}



// well as nesting subscriptions of descendant components, so that we can ensure the
// ancestor components re-render before descendants
function $d18d08c0e143d039$var$createListenerCollection() {
    const batch = (0, $ab3f7370cfda2d8c$export$fc47d4c0ba3bd2c6)();
    let first = null;
    let last = null;
    return {
        clear () {
            first = null;
            last = null;
        },
        notify () {
            batch(()=>{
                let listener = first;
                while(listener){
                    listener.callback();
                    listener = listener.next;
                }
            });
        },
        get () {
            let listeners = [];
            let listener = first;
            while(listener){
                listeners.push(listener);
                listener = listener.next;
            }
            return listeners;
        },
        subscribe (callback) {
            let isSubscribed = true;
            let listener = last = {
                callback: callback,
                next: null,
                prev: last
            };
            if (listener.prev) listener.prev.next = listener;
            else first = listener;
            return function unsubscribe() {
                if (!isSubscribed || first === null) return;
                isSubscribed = false;
                if (listener.next) listener.next.prev = listener.prev;
                else last = listener.prev;
                if (listener.prev) listener.prev.next = listener.next;
                else first = listener.next;
            };
        }
    };
}
const $d18d08c0e143d039$var$nullListeners = {
    notify () {},
    get: ()=>[]
};
function $d18d08c0e143d039$export$d567d2b9af322f8f(store, parentSub) {
    let unsubscribe;
    let listeners = $d18d08c0e143d039$var$nullListeners;
    function addNestedSub(listener) {
        trySubscribe();
        return listeners.subscribe(listener);
    }
    function notifyNestedSubs() {
        listeners.notify();
    }
    function handleChangeWrapper() {
        if (subscription.onStateChange) subscription.onStateChange();
    }
    function isSubscribed() {
        return Boolean(unsubscribe);
    }
    function trySubscribe() {
        if (!unsubscribe) {
            unsubscribe = parentSub ? parentSub.addNestedSub(handleChangeWrapper) : store.subscribe(handleChangeWrapper);
            listeners = $d18d08c0e143d039$var$createListenerCollection();
        }
    }
    function tryUnsubscribe() {
        if (unsubscribe) {
            unsubscribe();
            unsubscribe = undefined;
            listeners.clear();
            listeners = $d18d08c0e143d039$var$nullListeners;
        }
    }
    const subscription = {
        addNestedSub: addNestedSub,
        notifyNestedSubs: notifyNestedSubs,
        handleChangeWrapper: handleChangeWrapper,
        isSubscribed: isSubscribed,
        trySubscribe: trySubscribe,
        tryUnsubscribe: tryUnsubscribe,
        getListeners: ()=>listeners
    };
    return subscription;
}



var $eO7Kz = parcelRequire("eO7Kz");
const $3215cb77accc2228$export$71594e8a50f746f4 = !!(typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined");
const $3215cb77accc2228$export$700979bc83e7db82 = $3215cb77accc2228$export$71594e8a50f746f4 ? (0, $eO7Kz.useLayoutEffect) : (0, $eO7Kz.useEffect);


function $50c13d45bf4cfda1$var$is(x, y) {
    if (x === y) return x !== 0 || y !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
function $50c13d45bf4cfda1$export$2e2bcd8739ae039(objA, objB) {
    if ($50c13d45bf4cfda1$var$is(objA, objB)) return true;
    if (typeof objA !== "object" || objA === null || typeof objB !== "object" || objB === null) return false;
    const keysA = Object.keys(objA);
    const keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    for(let i = 0; i < keysA.length; i++){
        if (!Object.prototype.hasOwnProperty.call(objB, keysA[i]) || !$50c13d45bf4cfda1$var$is(objA[keysA[i]], objB[keysA[i]])) return false;
    }
    return true;
}





const $d38b5d506960cd1f$var$_excluded = [
    "reactReduxForwardedRef"
];
let $d38b5d506960cd1f$var$useSyncExternalStore = (0, $084b70d0751c7871$export$20656a4825650bd0);
const $d38b5d506960cd1f$export$36d45daa6a4925b8 = (fn)=>{
    $d38b5d506960cd1f$var$useSyncExternalStore = fn;
}; // Define some constant arrays just to avoid re-creating these
const $d38b5d506960cd1f$var$EMPTY_ARRAY = [
    null,
    0
];
const $d38b5d506960cd1f$var$NO_SUBSCRIPTION_ARRAY = [
    null,
    null
]; // Attempts to stringify whatever not-really-a-component value we were given
// for logging in an error message
const $d38b5d506960cd1f$var$stringifyComponent = (Comp)=>{
    try {
        return JSON.stringify(Comp);
    } catch (err) {
        return String(Comp);
    }
};
// This is "just" a `useLayoutEffect`, but with two modifications:
// - we need to fall back to `useEffect` in SSR to avoid annoying warnings
// - we extract this to a separate function to avoid closing over values
//   and causing memory leaks
function $d38b5d506960cd1f$var$useIsomorphicLayoutEffectWithArgs(effectFunc, effectArgs, dependencies) {
    (0, $3215cb77accc2228$export$700979bc83e7db82)(()=>effectFunc(...effectArgs), dependencies);
} // Effect callback, extracted: assign the latest props values to refs for later usage
function $d38b5d506960cd1f$var$captureWrapperProps(lastWrapperProps, lastChildProps, renderIsScheduled, wrapperProps, childPropsFromStoreUpdate, notifyNestedSubs) {
    // We want to capture the wrapper props and child props we used for later comparisons
    lastWrapperProps.current = wrapperProps;
    renderIsScheduled.current = false; // If the render was from a store update, clear out that reference and cascade the subscriber update
    if (childPropsFromStoreUpdate.current) {
        childPropsFromStoreUpdate.current = null;
        notifyNestedSubs();
    }
} // Effect callback, extracted: subscribe to the Redux store or nearest connected ancestor,
// check for updates after dispatched actions, and trigger re-renders.
function $d38b5d506960cd1f$var$subscribeUpdates(shouldHandleStateChanges, store, subscription, childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, isMounted, childPropsFromStoreUpdate, notifyNestedSubs, additionalSubscribeListener) {
    // If we're not subscribed to the store, nothing to do here
    if (!shouldHandleStateChanges) return ()=>{}; // Capture values for checking if and when this component unmounts
    let didUnsubscribe = false;
    let lastThrownError = null; // We'll run this callback every time a store subscription update propagates to this component
    const checkForUpdates = ()=>{
        if (didUnsubscribe || !isMounted.current) // Don't run stale listeners.
        // Redux doesn't guarantee unsubscriptions happen until next dispatch.
        return;
         // TODO We're currently calling getState ourselves here, rather than letting `uSES` do it
        const latestStoreState = store.getState();
        let newChildProps, error;
        try {
            // Actually run the selector with the most recent store state and wrapper props
            // to determine what the child props should be
            newChildProps = childPropsSelector(latestStoreState, lastWrapperProps.current);
        } catch (e) {
            error = e;
            lastThrownError = e;
        }
        if (!error) lastThrownError = null;
         // If the child props haven't changed, nothing to do here - cascade the subscription update
        if (newChildProps === lastChildProps.current) {
            if (!renderIsScheduled.current) notifyNestedSubs();
        } else {
            // Save references to the new child props.  Note that we track the "child props from store update"
            // as a ref instead of a useState/useReducer because we need a way to determine if that value has
            // been processed.  If this went into useState/useReducer, we couldn't clear out the value without
            // forcing another re-render, which we don't want.
            lastChildProps.current = newChildProps;
            childPropsFromStoreUpdate.current = newChildProps;
            renderIsScheduled.current = true; // TODO This is hacky and not how `uSES` is meant to be used
            // Trigger the React `useSyncExternalStore` subscriber
            additionalSubscribeListener();
        }
    }; // Actually subscribe to the nearest connected ancestor (or store)
    subscription.onStateChange = checkForUpdates;
    subscription.trySubscribe(); // Pull data from the store after first render in case the store has
    // changed since we began.
    checkForUpdates();
    const unsubscribeWrapper = ()=>{
        didUnsubscribe = true;
        subscription.tryUnsubscribe();
        subscription.onStateChange = null;
        if (lastThrownError) // It's possible that we caught an error due to a bad mapState function, but the
        // parent re-rendered without this component and we're about to unmount.
        // This shouldn't happen as long as we do top-down subscriptions correctly, but
        // if we ever do those wrong, this throw will surface the error in our tests.
        // In that case, throw the error from here so it doesn't get lost.
        throw lastThrownError;
    };
    return unsubscribeWrapper;
} // Reducer initial state creation for our update reducer
const $d38b5d506960cd1f$var$initStateUpdates = ()=>$d38b5d506960cd1f$var$EMPTY_ARRAY;
function $d38b5d506960cd1f$var$strictEqual(a, b) {
    return a === b;
}
/**
 * Infers the type of props that a connector will inject into a component.
 */ let $d38b5d506960cd1f$var$hasWarnedAboutDeprecatedPureOption = false;
/**
 * Connects a React component to a Redux store.
 *
 * - Without arguments, just wraps the component, without changing the behavior / props
 *
 * - If 2 params are passed (3rd param, mergeProps, is skipped), default behavior
 * is to override ownProps (as stated in the docs), so what remains is everything that's
 * not a state or dispatch prop
 *
 * - When 3rd param is passed, we don't know if ownProps propagate and whether they
 * should be valid component props, because it depends on mergeProps implementation.
 * As such, it is the user's responsibility to extend ownProps interface from state or
 * dispatch props or both when applicable
 *
 * @param mapStateToProps A function that extracts values from state
 * @param mapDispatchToProps Setup for dispatching actions
 * @param mergeProps Optional callback to merge state and dispatch props together
 * @param options Options for configuring the connection
 *
 */ function $d38b5d506960cd1f$var$connect(mapStateToProps, mapDispatchToProps, mergeProps, { pure: // The `pure` option has been removed, so TS doesn't like us destructuring this to check its existence.
// @ts-ignore
pure, areStatesEqual: areStatesEqual = $d38b5d506960cd1f$var$strictEqual, areOwnPropsEqual: areOwnPropsEqual = (0, $50c13d45bf4cfda1$export$2e2bcd8739ae039), areStatePropsEqual: areStatePropsEqual = (0, $50c13d45bf4cfda1$export$2e2bcd8739ae039), areMergedPropsEqual: areMergedPropsEqual = (0, $50c13d45bf4cfda1$export$2e2bcd8739ae039), forwardRef: // use React's forwardRef to expose a ref of the wrapped component
forwardRef = false, context: // the context consumer to use
context = (0, $41f70b1282892289$export$cc80c08dc91f1c00) } = {}) {
    const Context = context;
    const initMapStateToProps = (0, $ce3a2a3766c2d60d$export$e00e93951827eda7)(mapStateToProps);
    const initMapDispatchToProps = (0, $1c2a15c8a5280aa0$export$b69a785ceac019a6)(mapDispatchToProps);
    const initMergeProps = (0, $dc03f90e5d490759$export$17457cf6fa742f84)(mergeProps);
    const shouldHandleStateChanges = Boolean(mapStateToProps);
    const wrapWithConnect = (WrappedComponent)=>{
        const wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || "Component";
        const displayName = `Connect(${wrappedComponentName})`;
        const selectorFactoryOptions = {
            shouldHandleStateChanges: shouldHandleStateChanges,
            displayName: displayName,
            wrappedComponentName: wrappedComponentName,
            WrappedComponent: WrappedComponent,
            initMapStateToProps: // @ts-ignore
            initMapStateToProps,
            initMapDispatchToProps: // @ts-ignore
            initMapDispatchToProps,
            initMergeProps: initMergeProps,
            areStatesEqual: areStatesEqual,
            areStatePropsEqual: areStatePropsEqual,
            areOwnPropsEqual: areOwnPropsEqual,
            areMergedPropsEqual: areMergedPropsEqual
        };
        function ConnectFunction(props) {
            const [propsContext, reactReduxForwardedRef, wrapperProps] = (0, $eO7Kz.useMemo)(()=>{
                // Distinguish between actual "data" props that were passed to the wrapper component,
                // and values needed to control behavior (forwarded refs, alternate context instances).
                // To maintain the wrapperProps object reference, memoize this destructuring.
                const { reactReduxForwardedRef: reactReduxForwardedRef } = props, wrapperProps = (0, $akilq.default)(props, $d38b5d506960cd1f$var$_excluded);
                return [
                    props.context,
                    reactReduxForwardedRef,
                    wrapperProps
                ];
            }, [
                props
            ]);
            const ContextToUse = (0, $eO7Kz.useMemo)(()=>{
                // Users may optionally pass in a custom context instance to use instead of our ReactReduxContext.
                // Memoize the check that determines which context instance we should use.
                return propsContext && propsContext.Consumer && // @ts-ignore
                (0, $bbe78774a659a47d$exports.isContextConsumer)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eO7Kz))).createElement(propsContext.Consumer, null)) ? propsContext : Context;
            }, [
                propsContext,
                Context
            ]); // Retrieve the store and ancestor subscription via context, if available
            const contextValue = (0, $eO7Kz.useContext)(ContextToUse); // The store _must_ exist as either a prop or in context.
            // We'll check to see if it _looks_ like a Redux store first.
            // This allows us to pass through a `store` prop that is just a plain value.
            const didStoreComeFromProps = Boolean(props.store) && Boolean(props.store.getState) && Boolean(props.store.dispatch);
            const didStoreComeFromContext = Boolean(contextValue) && Boolean(contextValue.store);
            const store = didStoreComeFromProps ? props.store : contextValue.store;
            const getServerState = didStoreComeFromContext ? contextValue.getServerState : store.getState;
            const childPropsSelector = (0, $eO7Kz.useMemo)(()=>{
                // The child props selector needs the store reference as an input.
                // Re-create this selector whenever the store changes.
                return (0, $c502df705bd4bced$export$2e2bcd8739ae039)(store.dispatch, selectorFactoryOptions);
            }, [
                store
            ]);
            const [subscription, notifyNestedSubs] = (0, $eO7Kz.useMemo)(()=>{
                if (!shouldHandleStateChanges) return $d38b5d506960cd1f$var$NO_SUBSCRIPTION_ARRAY; // This Subscription's source should match where store came from: props vs. context. A component
                // connected to the store via props shouldn't use subscription from context, or vice versa.
                const subscription = (0, $d18d08c0e143d039$export$d567d2b9af322f8f)(store, didStoreComeFromProps ? undefined : contextValue.subscription); // `notifyNestedSubs` is duplicated to handle the case where the component is unmounted in
                // the middle of the notification loop, where `subscription` will then be null. This can
                // probably be avoided if Subscription's listeners logic is changed to not call listeners
                // that have been unsubscribed in the  middle of the notification loop.
                const notifyNestedSubs = subscription.notifyNestedSubs.bind(subscription);
                return [
                    subscription,
                    notifyNestedSubs
                ];
            }, [
                store,
                didStoreComeFromProps,
                contextValue
            ]); // Determine what {store, subscription} value should be put into nested context, if necessary,
            // and memoize that value to avoid unnecessary context updates.
            const overriddenContextValue = (0, $eO7Kz.useMemo)(()=>{
                if (didStoreComeFromProps) // This component is directly subscribed to a store from props.
                // We don't want descendants reading from this store - pass down whatever
                // the existing context value is from the nearest connected ancestor.
                return contextValue;
                 // Otherwise, put this component's subscription instance into context, so that
                // connected descendants won't update until after this component is done
                return (0, $aO5a1.default)({}, contextValue, {
                    subscription: subscription
                });
            }, [
                didStoreComeFromProps,
                contextValue,
                subscription
            ]); // Set up refs to coordinate values between the subscription effect and the render logic
            const lastChildProps = (0, $eO7Kz.useRef)();
            const lastWrapperProps = (0, $eO7Kz.useRef)(wrapperProps);
            const childPropsFromStoreUpdate = (0, $eO7Kz.useRef)();
            const renderIsScheduled = (0, $eO7Kz.useRef)(false);
            const isProcessingDispatch = (0, $eO7Kz.useRef)(false);
            const isMounted = (0, $eO7Kz.useRef)(false);
            const latestSubscriptionCallbackError = (0, $eO7Kz.useRef)();
            (0, $3215cb77accc2228$export$700979bc83e7db82)(()=>{
                isMounted.current = true;
                return ()=>{
                    isMounted.current = false;
                };
            }, []);
            const actualChildPropsSelector = (0, $eO7Kz.useMemo)(()=>{
                const selector = ()=>{
                    // Tricky logic here:
                    // - This render may have been triggered by a Redux store update that produced new child props
                    // - However, we may have gotten new wrapper props after that
                    // If we have new child props, and the same wrapper props, we know we should use the new child props as-is.
                    // But, if we have new wrapper props, those might change the child props, so we have to recalculate things.
                    // So, we'll use the child props from store update only if the wrapper props are the same as last time.
                    if (childPropsFromStoreUpdate.current && wrapperProps === lastWrapperProps.current) return childPropsFromStoreUpdate.current;
                     // TODO We're reading the store directly in render() here. Bad idea?
                    // This will likely cause Bad Things (TM) to happen in Concurrent Mode.
                    // Note that we do this because on renders _not_ caused by store updates, we need the latest store state
                    // to determine what the child props should be.
                    return childPropsSelector(store.getState(), wrapperProps);
                };
                return selector;
            }, [
                store,
                wrapperProps
            ]); // We need this to execute synchronously every time we re-render. However, React warns
            // about useLayoutEffect in SSR, so we try to detect environment and fall back to
            // just useEffect instead to avoid the warning, since neither will run anyway.
            const subscribeForReact = (0, $eO7Kz.useMemo)(()=>{
                const subscribe = (reactListener)=>{
                    if (!subscription) return ()=>{};
                    return $d38b5d506960cd1f$var$subscribeUpdates(shouldHandleStateChanges, store, subscription, childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, isMounted, childPropsFromStoreUpdate, notifyNestedSubs, reactListener);
                };
                return subscribe;
            }, [
                subscription
            ]);
            $d38b5d506960cd1f$var$useIsomorphicLayoutEffectWithArgs($d38b5d506960cd1f$var$captureWrapperProps, [
                lastWrapperProps,
                lastChildProps,
                renderIsScheduled,
                wrapperProps,
                childPropsFromStoreUpdate,
                notifyNestedSubs
            ]);
            let actualChildProps;
            try {
                actualChildProps = $d38b5d506960cd1f$var$useSyncExternalStore(subscribeForReact, // TODO and we're just passing that through so it triggers a re-render for us rather than relying on `uSES`.
                actualChildPropsSelector, getServerState ? ()=>childPropsSelector(getServerState(), wrapperProps) : actualChildPropsSelector);
            } catch (err) {
                if (latestSubscriptionCallbackError.current) err.message += `\nThe error may be correlated with this previous error:\n${latestSubscriptionCallbackError.current.stack}\n\n`;
                throw err;
            }
            (0, $3215cb77accc2228$export$700979bc83e7db82)(()=>{
                latestSubscriptionCallbackError.current = undefined;
                childPropsFromStoreUpdate.current = undefined;
                lastChildProps.current = actualChildProps;
            }); // Now that all that's done, we can finally try to actually render the child component.
            // We memoize the elements for the rendered child component as an optimization.
            const renderedWrappedComponent = (0, $eO7Kz.useMemo)(()=>{
                return(/*#__PURE__*/ // @ts-ignore
                (0, (/*@__PURE__*/$parcel$interopDefault($eO7Kz))).createElement(WrappedComponent, (0, $aO5a1.default)({}, actualChildProps, {
                    ref: reactReduxForwardedRef
                })));
            }, [
                reactReduxForwardedRef,
                WrappedComponent,
                actualChildProps
            ]); // If React sees the exact same element reference as last time, it bails out of re-rendering
            // that child, same as if it was wrapped in React.memo() or returned false from shouldComponentUpdate.
            const renderedChild = (0, $eO7Kz.useMemo)(()=>{
                if (shouldHandleStateChanges) // If this component is subscribed to store updates, we need to pass its own
                // subscription instance down to our descendants. That means rendering the same
                // Context instance, and putting a different value into the context.
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eO7Kz))).createElement(ContextToUse.Provider, {
                    value: overriddenContextValue
                }, renderedWrappedComponent);
                return renderedWrappedComponent;
            }, [
                ContextToUse,
                renderedWrappedComponent,
                overriddenContextValue
            ]);
            return renderedChild;
        }
        const _Connect = (0, (/*@__PURE__*/$parcel$interopDefault($eO7Kz))).memo(ConnectFunction);
        // Add a hacky cast to get the right output type
        const Connect = _Connect;
        Connect.WrappedComponent = WrappedComponent;
        Connect.displayName = ConnectFunction.displayName = displayName;
        if (forwardRef) {
            const _forwarded = (0, (/*@__PURE__*/$parcel$interopDefault($eO7Kz))).forwardRef(function forwardConnectRef(props, ref) {
                // @ts-ignore
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eO7Kz))).createElement(Connect, (0, $aO5a1.default)({}, props, {
                    reactReduxForwardedRef: ref
                }));
            });
            const forwarded = _forwarded;
            forwarded.displayName = displayName;
            forwarded.WrappedComponent = WrappedComponent;
            return (0, (/*@__PURE__*/$parcel$interopDefault($hKDRv)))(forwarded, WrappedComponent);
        }
        return (0, (/*@__PURE__*/$parcel$interopDefault($hKDRv)))(Connect, WrappedComponent);
    };
    return wrapWithConnect;
}
var $d38b5d506960cd1f$export$2e2bcd8739ae039 = $d38b5d506960cd1f$var$connect;



var $eO7Kz = parcelRequire("eO7Kz");



function $18b122cd2de4fd43$var$Provider({ store: store, context: context, children: children, serverState: serverState }) {
    const contextValue = (0, $eO7Kz.useMemo)(()=>{
        const subscription = (0, $d18d08c0e143d039$export$d567d2b9af322f8f)(store);
        return {
            store: store,
            subscription: subscription,
            getServerState: serverState ? ()=>serverState : undefined
        };
    }, [
        store,
        serverState
    ]);
    const previousState = (0, $eO7Kz.useMemo)(()=>store.getState(), [
        store
    ]);
    (0, $3215cb77accc2228$export$700979bc83e7db82)(()=>{
        const { subscription: subscription } = contextValue;
        subscription.onStateChange = subscription.notifyNestedSubs;
        subscription.trySubscribe();
        if (previousState !== store.getState()) subscription.notifyNestedSubs();
        return ()=>{
            subscription.tryUnsubscribe();
            subscription.onStateChange = undefined;
        };
    }, [
        contextValue,
        previousState
    ]);
    const Context = context || (0, $41f70b1282892289$export$cc80c08dc91f1c00); // @ts-ignore 'AnyAction' is assignable to the constraint of type 'A', but 'A' could be instantiated with a different subtype
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eO7Kz))).createElement(Context.Provider, {
        value: contextValue
    }, children);
}
var $18b122cd2de4fd43$export$2e2bcd8739ae039 = $18b122cd2de4fd43$var$Provider;






var $eO7Kz = parcelRequire("eO7Kz");


function $22cd86e9057096af$export$671dba69185d0304(context = (0, $41f70b1282892289$export$cc80c08dc91f1c00)) {
    const useReduxContext = context === (0, $41f70b1282892289$export$cc80c08dc91f1c00) ? (0, $84a73a91ff6a84d9$export$c1275ca9a6fd3ec5) : ()=>(0, $eO7Kz.useContext)(context);
    return function useStore() {
        const { store: store } = useReduxContext(); // @ts-ignore
        return store;
    };
}
const $22cd86e9057096af$export$6ccbb43953eebf8 = /*#__PURE__*/ $22cd86e9057096af$export$671dba69185d0304();


function $cdba447f92a85742$export$bc9b55530897c558(context = (0, $41f70b1282892289$export$cc80c08dc91f1c00)) {
    const useStore = context === (0, $41f70b1282892289$export$cc80c08dc91f1c00) ? (0, $22cd86e9057096af$export$6ccbb43953eebf8) : (0, $22cd86e9057096af$export$671dba69185d0304)(context);
    return function useDispatch() {
        const store = useStore(); // @ts-ignore
        return store.dispatch;
    };
}
const $cdba447f92a85742$export$8ad76b76a4c905f8 = /*#__PURE__*/ $cdba447f92a85742$export$bc9b55530897c558();









(0, $ea41252a5ec6592a$export$e2e6e3f3f3b782e3)((0, $bd4c1f4e43279253$exports.useSyncExternalStoreWithSelector));
(0, $d38b5d506960cd1f$export$36d45daa6a4925b8)((0, $bqHew.useSyncExternalStore)); // Enable batched updates in our subscriptions for use
// with standard React renderers (ReactDOM, React Native)
(0, $ab3f7370cfda2d8c$export$4b9874722d0da7bc)((0, $kz03S.unstable_batchedUpdates));


var $7908c0d6cb321887$exports = {};
$parcel$export($7908c0d6cb321887$exports, "applyMiddleware", () => (parcelRequire("8ixsH")).applyMiddleware, (v) => (parcelRequire("8ixsH")).applyMiddleware = v);
$parcel$export($7908c0d6cb321887$exports, "combineReducers", () => (parcelRequire("8ixsH")).combineReducers, (v) => (parcelRequire("8ixsH")).combineReducers = v);
$parcel$export($7908c0d6cb321887$exports, "compose", () => (parcelRequire("8ixsH")).compose, (v) => (parcelRequire("8ixsH")).compose = v);
$parcel$export($7908c0d6cb321887$exports, "createStore", () => (parcelRequire("8ixsH")).createStore, (v) => (parcelRequire("8ixsH")).createStore = v);

$parcel$export($7908c0d6cb321887$exports, "configureStore", () => $7908c0d6cb321887$export$7d8a5b498da695ac);
$parcel$export($7908c0d6cb321887$exports, "createSlice", () => $7908c0d6cb321887$export$4d8d9bd83c24ae8b);
function $241418c3f336c28b$var$n(n) {
    for(var r = arguments.length, t = Array(r > 1 ? r - 1 : 0), e = 1; e < r; e++)t[e - 1] = arguments[e];
    var i, o;
    throw Error("[Immer] minified error nr: " + n + (t.length ? " " + t.map(function(n) {
        return "'" + n + "'";
    }).join(",") : "") + ". Find the full error at: https://bit.ly/3cXEKWf");
}
function $241418c3f336c28b$export$541ac630993a4c84(n) {
    return !!n && !!n[$241418c3f336c28b$var$Q];
}
function $241418c3f336c28b$export$16e3aed3edb85946(n) {
    var r;
    return !!n && (function(n) {
        if (!n || "object" != typeof n) return !1;
        var r = Object.getPrototypeOf(n);
        if (null === r) return !0;
        var t = Object.hasOwnProperty.call(r, "constructor") && r.constructor;
        return t === Object || "function" == typeof t && Function.toString.call(t) === $241418c3f336c28b$var$Z;
    }(n) || Array.isArray(n) || !!n[$241418c3f336c28b$export$6ee2082928bcb0ee] || !!(null === (r = n.constructor) || void 0 === r ? void 0 : r[$241418c3f336c28b$export$6ee2082928bcb0ee]) || $241418c3f336c28b$var$s(n) || $241418c3f336c28b$var$v(n));
}
function $241418c3f336c28b$export$22e8af3f75a010e3(t) {
    return $241418c3f336c28b$export$541ac630993a4c84(t) || $241418c3f336c28b$var$n(23, t), t[$241418c3f336c28b$var$Q].t;
}
function $241418c3f336c28b$var$i(n, r, t) {
    void 0 === t && (t = !1), 0 === $241418c3f336c28b$var$o(n) ? (t ? Object.keys : $241418c3f336c28b$var$nn)(n).forEach(function(e) {
        t && "symbol" == typeof e || r(e, n[e], n);
    }) : n.forEach(function(t, e) {
        return r(e, t, n);
    });
}
function $241418c3f336c28b$var$o(n) {
    var r = n[$241418c3f336c28b$var$Q];
    return r ? r.i > 3 ? r.i - 4 : r.i : Array.isArray(n) ? 1 : $241418c3f336c28b$var$s(n) ? 2 : $241418c3f336c28b$var$v(n) ? 3 : 0;
}
function $241418c3f336c28b$var$u(n, r) {
    return 2 === $241418c3f336c28b$var$o(n) ? n.has(r) : Object.prototype.hasOwnProperty.call(n, r);
}
function $241418c3f336c28b$var$a(n, r) {
    return 2 === $241418c3f336c28b$var$o(n) ? n.get(r) : n[r];
}
function $241418c3f336c28b$var$f(n, r, t) {
    var e = $241418c3f336c28b$var$o(n);
    2 === e ? n.set(r, t) : 3 === e ? n.add(t) : n[r] = t;
}
function $241418c3f336c28b$var$c(n, r) {
    return n === r ? 0 !== n || 1 / n == 1 / r : n != n && r != r;
}
function $241418c3f336c28b$var$s(n) {
    return $241418c3f336c28b$var$X && n instanceof Map;
}
function $241418c3f336c28b$var$v(n) {
    return $241418c3f336c28b$var$q && n instanceof Set;
}
function $241418c3f336c28b$var$p(n) {
    return n.o || n.t;
}
function $241418c3f336c28b$var$l(n) {
    if (Array.isArray(n)) return Array.prototype.slice.call(n);
    var r = $241418c3f336c28b$var$rn(n);
    delete r[$241418c3f336c28b$var$Q];
    for(var t = $241418c3f336c28b$var$nn(r), e = 0; e < t.length; e++){
        var i = t[e], o = r[i];
        !1 === o.writable && (o.writable = !0, o.configurable = !0), (o.get || o.set) && (r[i] = {
            configurable: !0,
            writable: !0,
            enumerable: o.enumerable,
            value: n[i]
        });
    }
    return Object.create(Object.getPrototypeOf(n), r);
}
function $241418c3f336c28b$export$792f3d81ea979f55(n, e) {
    return void 0 === e && (e = !1), $241418c3f336c28b$var$y(n) || $241418c3f336c28b$export$541ac630993a4c84(n) || !$241418c3f336c28b$export$16e3aed3edb85946(n) || ($241418c3f336c28b$var$o(n) > 1 && (n.set = n.add = n.clear = n.delete = $241418c3f336c28b$var$h), Object.freeze(n), e && $241418c3f336c28b$var$i(n, function(n, r) {
        return $241418c3f336c28b$export$792f3d81ea979f55(r, !0);
    }, !0)), n;
}
function $241418c3f336c28b$var$h() {
    $241418c3f336c28b$var$n(2);
}
function $241418c3f336c28b$var$y(n) {
    return null == n || "object" != typeof n || Object.isFrozen(n);
}
function $241418c3f336c28b$var$b(r) {
    var t = $241418c3f336c28b$var$tn[r];
    return t || $241418c3f336c28b$var$n(18, r), t;
}
function $241418c3f336c28b$var$m(n, r) {
    $241418c3f336c28b$var$tn[n] || ($241418c3f336c28b$var$tn[n] = r);
}
function $241418c3f336c28b$var$_() {
    return $241418c3f336c28b$var$U;
}
function $241418c3f336c28b$var$j(n, r) {
    r && ($241418c3f336c28b$var$b("Patches"), n.u = [], n.s = [], n.v = r);
}
function $241418c3f336c28b$var$g(n) {
    $241418c3f336c28b$var$O(n), n.p.forEach($241418c3f336c28b$var$S), n.p = null;
}
function $241418c3f336c28b$var$O(n) {
    n === $241418c3f336c28b$var$U && ($241418c3f336c28b$var$U = n.l);
}
function $241418c3f336c28b$var$w(n) {
    return $241418c3f336c28b$var$U = {
        p: [],
        l: $241418c3f336c28b$var$U,
        h: n,
        m: !0,
        _: 0
    };
}
function $241418c3f336c28b$var$S(n) {
    var r = n[$241418c3f336c28b$var$Q];
    0 === r.i || 1 === r.i ? r.j() : r.g = !0;
}
function $241418c3f336c28b$var$P(r, e) {
    e._ = e.p.length;
    var i = e.p[0], o = void 0 !== r && r !== i;
    return e.h.O || $241418c3f336c28b$var$b("ES5").S(e, r, o), o ? (i[$241418c3f336c28b$var$Q].P && ($241418c3f336c28b$var$g(e), $241418c3f336c28b$var$n(4)), $241418c3f336c28b$export$16e3aed3edb85946(r) && (r = $241418c3f336c28b$var$M(e, r), e.l || $241418c3f336c28b$var$x(e, r)), e.u && $241418c3f336c28b$var$b("Patches").M(i[$241418c3f336c28b$var$Q].t, r, e.u, e.s)) : r = $241418c3f336c28b$var$M(e, i, []), $241418c3f336c28b$var$g(e), e.u && e.v(e.u, e.s), r !== $241418c3f336c28b$export$45b790e32b2810ee ? r : void 0;
}
function $241418c3f336c28b$var$M(n, r, t) {
    if ($241418c3f336c28b$var$y(r)) return r;
    var e = r[$241418c3f336c28b$var$Q];
    if (!e) return $241418c3f336c28b$var$i(r, function(i, o) {
        return $241418c3f336c28b$var$A(n, e, r, i, o, t);
    }, !0), r;
    if (e.A !== n) return r;
    if (!e.P) return $241418c3f336c28b$var$x(n, e.t, !0), e.t;
    if (!e.I) {
        e.I = !0, e.A._--;
        var o = 4 === e.i || 5 === e.i ? e.o = $241418c3f336c28b$var$l(e.k) : e.o, u = o, a = !1;
        3 === e.i && (u = new Set(o), o.clear(), a = !0), $241418c3f336c28b$var$i(u, function(r, i) {
            return $241418c3f336c28b$var$A(n, e, o, r, i, t, a);
        }), $241418c3f336c28b$var$x(n, o, !1), t && n.u && $241418c3f336c28b$var$b("Patches").N(e, t, n.u, n.s);
    }
    return e.o;
}
function $241418c3f336c28b$var$A(e, i, o, a, c, s, v) {
    if ($241418c3f336c28b$export$541ac630993a4c84(c)) {
        var p = $241418c3f336c28b$var$M(e, c, s && i && 3 !== i.i && !$241418c3f336c28b$var$u(i.R, a) ? s.concat(a) : void 0);
        if ($241418c3f336c28b$var$f(o, a, p), !$241418c3f336c28b$export$541ac630993a4c84(p)) return;
        e.m = !1;
    } else v && o.add(c);
    if ($241418c3f336c28b$export$16e3aed3edb85946(c) && !$241418c3f336c28b$var$y(c)) {
        if (!e.h.D && e._ < 1) return;
        $241418c3f336c28b$var$M(e, c), i && i.A.l || $241418c3f336c28b$var$x(e, c);
    }
}
function $241418c3f336c28b$var$x(n, r, t) {
    void 0 === t && (t = !1), !n.l && n.h.D && n.m && $241418c3f336c28b$export$792f3d81ea979f55(r, t);
}
function $241418c3f336c28b$var$z(n, r) {
    var t = n[$241418c3f336c28b$var$Q];
    return (t ? $241418c3f336c28b$var$p(t) : n)[r];
}
function $241418c3f336c28b$var$I(n, r) {
    if (r in n) for(var t = Object.getPrototypeOf(n); t;){
        var e = Object.getOwnPropertyDescriptor(t, r);
        if (e) return e;
        t = Object.getPrototypeOf(t);
    }
}
function $241418c3f336c28b$var$k(n) {
    n.P || (n.P = !0, n.l && $241418c3f336c28b$var$k(n.l));
}
function $241418c3f336c28b$var$E(n) {
    n.o || (n.o = $241418c3f336c28b$var$l(n.t));
}
function $241418c3f336c28b$var$N(n, r, t) {
    var e = $241418c3f336c28b$var$s(r) ? $241418c3f336c28b$var$b("MapSet").F(r, t) : $241418c3f336c28b$var$v(r) ? $241418c3f336c28b$var$b("MapSet").T(r, t) : n.O ? function(n, r) {
        var t = Array.isArray(n), e = {
            i: t ? 1 : 0,
            A: r ? r.A : $241418c3f336c28b$var$_(),
            P: !1,
            I: !1,
            R: {},
            l: r,
            t: n,
            k: null,
            o: null,
            j: null,
            C: !1
        }, i = e, o = $241418c3f336c28b$var$en;
        t && (i = [
            e
        ], o = $241418c3f336c28b$var$on);
        var u = Proxy.revocable(i, o), a = u.revoke, f = u.proxy;
        return e.k = f, e.j = a, f;
    }(r, t) : $241418c3f336c28b$var$b("ES5").J(r, t);
    return (t ? t.A : $241418c3f336c28b$var$_()).p.push(e), e;
}
function $241418c3f336c28b$export$97aac956da55dae9(e) {
    return $241418c3f336c28b$export$541ac630993a4c84(e) || $241418c3f336c28b$var$n(22, e), function n(r) {
        if (!$241418c3f336c28b$export$16e3aed3edb85946(r)) return r;
        var e, u = r[$241418c3f336c28b$var$Q], c = $241418c3f336c28b$var$o(r);
        if (u) {
            if (!u.P && (u.i < 4 || !$241418c3f336c28b$var$b("ES5").K(u))) return u.t;
            u.I = !0, e = $241418c3f336c28b$var$D(r, c), u.I = !1;
        } else e = $241418c3f336c28b$var$D(r, c);
        return $241418c3f336c28b$var$i(e, function(r, t) {
            u && $241418c3f336c28b$var$a(u.t, r) === t || $241418c3f336c28b$var$f(e, r, n(t));
        }), 3 === c ? new Set(e) : e;
    }(e);
}
function $241418c3f336c28b$var$D(n, r) {
    switch(r){
        case 2:
            return new Map(n);
        case 3:
            return Array.from(n);
    }
    return $241418c3f336c28b$var$l(n);
}
function $241418c3f336c28b$export$56771cf63ee491f5() {
    function t(n, r) {
        var t = s[n];
        return t ? t.enumerable = r : s[n] = t = {
            configurable: !0,
            enumerable: r,
            get: function() {
                var r = this[$241418c3f336c28b$var$Q];
                return $241418c3f336c28b$var$en.get(r, n);
            },
            set: function(r) {
                var t = this[$241418c3f336c28b$var$Q];
                $241418c3f336c28b$var$en.set(t, n, r);
            }
        }, t;
    }
    function e(n) {
        for(var r = n.length - 1; r >= 0; r--){
            var t = n[r][$241418c3f336c28b$var$Q];
            if (!t.P) switch(t.i){
                case 5:
                    a(t) && $241418c3f336c28b$var$k(t);
                    break;
                case 4:
                    o(t) && $241418c3f336c28b$var$k(t);
            }
        }
    }
    function o(n) {
        for(var r = n.t, t = n.k, e = $241418c3f336c28b$var$nn(t), i = e.length - 1; i >= 0; i--){
            var o = e[i];
            if (o !== $241418c3f336c28b$var$Q) {
                var a = r[o];
                if (void 0 === a && !$241418c3f336c28b$var$u(r, o)) return !0;
                var f = t[o], s = f && f[$241418c3f336c28b$var$Q];
                if (s ? s.t !== a : !$241418c3f336c28b$var$c(f, a)) return !0;
            }
        }
        var v = !!r[$241418c3f336c28b$var$Q];
        return e.length !== $241418c3f336c28b$var$nn(r).length + (v ? 0 : 1);
    }
    function a(n) {
        var r = n.k;
        if (r.length !== n.t.length) return !0;
        var t = Object.getOwnPropertyDescriptor(r, r.length - 1);
        if (t && !t.get) return !0;
        for(var e = 0; e < r.length; e++)if (!r.hasOwnProperty(e)) return !0;
        return !1;
    }
    function f(r) {
        r.g && $241418c3f336c28b$var$n(3, JSON.stringify($241418c3f336c28b$var$p(r)));
    }
    var s = {};
    $241418c3f336c28b$var$m("ES5", {
        J: function(n, r) {
            var e = Array.isArray(n), i = function(n, r) {
                if (n) {
                    for(var e = Array(r.length), i = 0; i < r.length; i++)Object.defineProperty(e, "" + i, t(i, !0));
                    return e;
                }
                var o = $241418c3f336c28b$var$rn(r);
                delete o[$241418c3f336c28b$var$Q];
                for(var u = $241418c3f336c28b$var$nn(o), a = 0; a < u.length; a++){
                    var f = u[a];
                    o[f] = t(f, n || !!o[f].enumerable);
                }
                return Object.create(Object.getPrototypeOf(r), o);
            }(e, n), o = {
                i: e ? 5 : 4,
                A: r ? r.A : $241418c3f336c28b$var$_(),
                P: !1,
                I: !1,
                R: {},
                l: r,
                t: n,
                k: i,
                o: null,
                g: !1,
                C: !1
            };
            return Object.defineProperty(i, $241418c3f336c28b$var$Q, {
                value: o,
                writable: !0
            }), i;
        },
        S: function(n, t, o) {
            o ? $241418c3f336c28b$export$541ac630993a4c84(t) && t[$241418c3f336c28b$var$Q].A === n && e(n.p) : (n.u && function n(r) {
                if (r && "object" == typeof r) {
                    var t = r[$241418c3f336c28b$var$Q];
                    if (t) {
                        var e = t.t, o = t.k, f = t.R, c = t.i;
                        if (4 === c) $241418c3f336c28b$var$i(o, function(r) {
                            r !== $241418c3f336c28b$var$Q && (void 0 !== e[r] || $241418c3f336c28b$var$u(e, r) ? f[r] || n(o[r]) : (f[r] = !0, $241418c3f336c28b$var$k(t)));
                        }), $241418c3f336c28b$var$i(e, function(n) {
                            void 0 !== o[n] || $241418c3f336c28b$var$u(o, n) || (f[n] = !1, $241418c3f336c28b$var$k(t));
                        });
                        else if (5 === c) {
                            if (a(t) && ($241418c3f336c28b$var$k(t), f.length = !0), o.length < e.length) for(var s = o.length; s < e.length; s++)f[s] = !1;
                            else for(var v = e.length; v < o.length; v++)f[v] = !0;
                            for(var p = Math.min(o.length, e.length), l = 0; l < p; l++)o.hasOwnProperty(l) || (f[l] = !0), void 0 === f[l] && n(o[l]);
                        }
                    }
                }
            }(n.p[0]), e(n.p));
        },
        K: function(n) {
            return 4 === n.i ? o(n) : a(n);
        }
    });
}
function $241418c3f336c28b$export$d3a6659991a0696c() {
    function e(n) {
        if (!$241418c3f336c28b$export$16e3aed3edb85946(n)) return n;
        if (Array.isArray(n)) return n.map(e);
        if ($241418c3f336c28b$var$s(n)) return new Map(Array.from(n.entries()).map(function(n) {
            return [
                n[0],
                e(n[1])
            ];
        }));
        if ($241418c3f336c28b$var$v(n)) return new Set(Array.from(n).map(e));
        var r = Object.create(Object.getPrototypeOf(n));
        for(var i in n)r[i] = e(n[i]);
        return $241418c3f336c28b$var$u(n, $241418c3f336c28b$export$6ee2082928bcb0ee) && (r[$241418c3f336c28b$export$6ee2082928bcb0ee] = n[$241418c3f336c28b$export$6ee2082928bcb0ee]), r;
    }
    function f(n) {
        return $241418c3f336c28b$export$541ac630993a4c84(n) ? e(n) : n;
    }
    var c = "add";
    $241418c3f336c28b$var$m("Patches", {
        $: function(r, t) {
            return t.forEach(function(t) {
                for(var i = t.path, u = t.op, f = r, s = 0; s < i.length - 1; s++){
                    var v = $241418c3f336c28b$var$o(f), p = i[s];
                    "string" != typeof p && "number" != typeof p && (p = "" + p), 0 !== v && 1 !== v || "__proto__" !== p && "constructor" !== p || $241418c3f336c28b$var$n(24), "function" == typeof f && "prototype" === p && $241418c3f336c28b$var$n(24), "object" != typeof (f = $241418c3f336c28b$var$a(f, p)) && $241418c3f336c28b$var$n(15, i.join("/"));
                }
                var l = $241418c3f336c28b$var$o(f), d = e(t.value), h = i[i.length - 1];
                switch(u){
                    case "replace":
                        switch(l){
                            case 2:
                                return f.set(h, d);
                            case 3:
                                $241418c3f336c28b$var$n(16);
                            default:
                                return f[h] = d;
                        }
                    case c:
                        switch(l){
                            case 1:
                                return "-" === h ? f.push(d) : f.splice(h, 0, d);
                            case 2:
                                return f.set(h, d);
                            case 3:
                                return f.add(d);
                            default:
                                return f[h] = d;
                        }
                    case "remove":
                        switch(l){
                            case 1:
                                return f.splice(h, 1);
                            case 2:
                                return f.delete(h);
                            case 3:
                                return f.delete(t.value);
                            default:
                                return delete f[h];
                        }
                    default:
                        $241418c3f336c28b$var$n(17, u);
                }
            }), r;
        },
        N: function(n, r, t, e) {
            switch(n.i){
                case 0:
                case 4:
                case 2:
                    return function(n, r, t, e) {
                        var o = n.t, s = n.o;
                        $241418c3f336c28b$var$i(n.R, function(n, i) {
                            var v = $241418c3f336c28b$var$a(o, n), p = $241418c3f336c28b$var$a(s, n), l = i ? $241418c3f336c28b$var$u(o, n) ? "replace" : c : "remove";
                            if (v !== p || "replace" !== l) {
                                var d = r.concat(n);
                                t.push("remove" === l ? {
                                    op: l,
                                    path: d
                                } : {
                                    op: l,
                                    path: d,
                                    value: p
                                }), e.push(l === c ? {
                                    op: "remove",
                                    path: d
                                } : "remove" === l ? {
                                    op: c,
                                    path: d,
                                    value: f(v)
                                } : {
                                    op: "replace",
                                    path: d,
                                    value: f(v)
                                });
                            }
                        });
                    }(n, r, t, e);
                case 5:
                case 1:
                    return function(n, r, t, e) {
                        var i = n.t, o = n.R, u = n.o;
                        if (u.length < i.length) {
                            var a = [
                                u,
                                i
                            ];
                            i = a[0], u = a[1];
                            var s = [
                                e,
                                t
                            ];
                            t = s[0], e = s[1];
                        }
                        for(var v = 0; v < i.length; v++)if (o[v] && u[v] !== i[v]) {
                            var p = r.concat([
                                v
                            ]);
                            t.push({
                                op: "replace",
                                path: p,
                                value: f(u[v])
                            }), e.push({
                                op: "replace",
                                path: p,
                                value: f(i[v])
                            });
                        }
                        for(var l = i.length; l < u.length; l++){
                            var d = r.concat([
                                l
                            ]);
                            t.push({
                                op: c,
                                path: d,
                                value: f(u[l])
                            });
                        }
                        i.length < u.length && e.push({
                            op: "replace",
                            path: r.concat([
                                "length"
                            ]),
                            value: i.length
                        });
                    }(n, r, t, e);
                case 3:
                    return function(n, r, t, e) {
                        var i = n.t, o = n.o, u = 0;
                        i.forEach(function(n) {
                            if (!o.has(n)) {
                                var i = r.concat([
                                    u
                                ]);
                                t.push({
                                    op: "remove",
                                    path: i,
                                    value: n
                                }), e.unshift({
                                    op: c,
                                    path: i,
                                    value: n
                                });
                            }
                            u++;
                        }), u = 0, o.forEach(function(n) {
                            if (!i.has(n)) {
                                var o = r.concat([
                                    u
                                ]);
                                t.push({
                                    op: c,
                                    path: o,
                                    value: n
                                }), e.unshift({
                                    op: "remove",
                                    path: o,
                                    value: n
                                });
                            }
                            u++;
                        });
                    }(n, r, t, e);
            }
        },
        M: function(n, r, t, e) {
            t.push({
                op: "replace",
                path: [],
                value: r === $241418c3f336c28b$export$45b790e32b2810ee ? void 0 : r
            }), e.push({
                op: "replace",
                path: [],
                value: n
            });
        }
    });
}
function $241418c3f336c28b$export$7d9f65390203b435() {
    function r(n, r) {
        function t() {
            this.constructor = n;
        }
        a(n, r), n.prototype = (t.prototype = r.prototype, new t);
    }
    function e(n) {
        n.o || (n.R = new Map, n.o = new Map(n.t));
    }
    function o(n) {
        n.o || (n.o = new Set, n.t.forEach(function(r) {
            if ($241418c3f336c28b$export$16e3aed3edb85946(r)) {
                var e = $241418c3f336c28b$var$N(n.A.h, r, n);
                n.p.set(r, e), n.o.add(e);
            } else n.o.add(r);
        }));
    }
    function u(r) {
        r.g && $241418c3f336c28b$var$n(3, JSON.stringify($241418c3f336c28b$var$p(r)));
    }
    var a = function(n, r) {
        return (a = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(n, r) {
            n.__proto__ = r;
        } || function(n, r) {
            for(var t in r)r.hasOwnProperty(t) && (n[t] = r[t]);
        })(n, r);
    }, f = function() {
        function n(n, r) {
            return this[$241418c3f336c28b$var$Q] = {
                i: 2,
                l: r,
                A: r ? r.A : $241418c3f336c28b$var$_(),
                P: !1,
                I: !1,
                o: void 0,
                R: void 0,
                t: n,
                k: this,
                C: !1,
                g: !1
            }, this;
        }
        r(n, Map);
        var o = n.prototype;
        return Object.defineProperty(o, "size", {
            get: function() {
                return $241418c3f336c28b$var$p(this[$241418c3f336c28b$var$Q]).size;
            }
        }), o.has = function(n) {
            return $241418c3f336c28b$var$p(this[$241418c3f336c28b$var$Q]).has(n);
        }, o.set = function(n, r) {
            var t = this[$241418c3f336c28b$var$Q];
            return u(t), $241418c3f336c28b$var$p(t).has(n) && $241418c3f336c28b$var$p(t).get(n) === r || (e(t), $241418c3f336c28b$var$k(t), t.R.set(n, !0), t.o.set(n, r), t.R.set(n, !0)), this;
        }, o.delete = function(n) {
            if (!this.has(n)) return !1;
            var r = this[$241418c3f336c28b$var$Q];
            return u(r), e(r), $241418c3f336c28b$var$k(r), r.t.has(n) ? r.R.set(n, !1) : r.R.delete(n), r.o.delete(n), !0;
        }, o.clear = function() {
            var n = this[$241418c3f336c28b$var$Q];
            u(n), $241418c3f336c28b$var$p(n).size && (e(n), $241418c3f336c28b$var$k(n), n.R = new Map, $241418c3f336c28b$var$i(n.t, function(r) {
                n.R.set(r, !1);
            }), n.o.clear());
        }, o.forEach = function(n, r) {
            var t = this;
            $241418c3f336c28b$var$p(this[$241418c3f336c28b$var$Q]).forEach(function(e, i) {
                n.call(r, t.get(i), i, t);
            });
        }, o.get = function(n) {
            var r = this[$241418c3f336c28b$var$Q];
            u(r);
            var i = $241418c3f336c28b$var$p(r).get(n);
            if (r.I || !$241418c3f336c28b$export$16e3aed3edb85946(i)) return i;
            if (i !== r.t.get(n)) return i;
            var o = $241418c3f336c28b$var$N(r.A.h, i, r);
            return e(r), r.o.set(n, o), o;
        }, o.keys = function() {
            return $241418c3f336c28b$var$p(this[$241418c3f336c28b$var$Q]).keys();
        }, o.values = function() {
            var n, r = this, t = this.keys();
            return (n = {})[$241418c3f336c28b$var$V] = function() {
                return r.values();
            }, n.next = function() {
                var n = t.next();
                return n.done ? n : {
                    done: !1,
                    value: r.get(n.value)
                };
            }, n;
        }, o.entries = function() {
            var n, r = this, t = this.keys();
            return (n = {})[$241418c3f336c28b$var$V] = function() {
                return r.entries();
            }, n.next = function() {
                var n = t.next();
                if (n.done) return n;
                var e = r.get(n.value);
                return {
                    done: !1,
                    value: [
                        n.value,
                        e
                    ]
                };
            }, n;
        }, o[$241418c3f336c28b$var$V] = function() {
            return this.entries();
        }, n;
    }(), c = function() {
        function n(n, r) {
            return this[$241418c3f336c28b$var$Q] = {
                i: 3,
                l: r,
                A: r ? r.A : $241418c3f336c28b$var$_(),
                P: !1,
                I: !1,
                o: void 0,
                t: n,
                k: this,
                p: new Map,
                g: !1,
                C: !1
            }, this;
        }
        r(n, Set);
        var t = n.prototype;
        return Object.defineProperty(t, "size", {
            get: function() {
                return $241418c3f336c28b$var$p(this[$241418c3f336c28b$var$Q]).size;
            }
        }), t.has = function(n) {
            var r = this[$241418c3f336c28b$var$Q];
            return u(r), r.o ? !!r.o.has(n) || !(!r.p.has(n) || !r.o.has(r.p.get(n))) : r.t.has(n);
        }, t.add = function(n) {
            var r = this[$241418c3f336c28b$var$Q];
            return u(r), this.has(n) || (o(r), $241418c3f336c28b$var$k(r), r.o.add(n)), this;
        }, t.delete = function(n) {
            if (!this.has(n)) return !1;
            var r = this[$241418c3f336c28b$var$Q];
            return u(r), o(r), $241418c3f336c28b$var$k(r), r.o.delete(n) || !!r.p.has(n) && r.o.delete(r.p.get(n));
        }, t.clear = function() {
            var n = this[$241418c3f336c28b$var$Q];
            u(n), $241418c3f336c28b$var$p(n).size && (o(n), $241418c3f336c28b$var$k(n), n.o.clear());
        }, t.values = function() {
            var n = this[$241418c3f336c28b$var$Q];
            return u(n), o(n), n.o.values();
        }, t.entries = function() {
            var n = this[$241418c3f336c28b$var$Q];
            return u(n), o(n), n.o.entries();
        }, t.keys = function() {
            return this.values();
        }, t[$241418c3f336c28b$var$V] = function() {
            return this.values();
        }, t.forEach = function(n, r) {
            for(var t = this.values(), e = t.next(); !e.done;)n.call(r, e.value, e.value, this), e = t.next();
        }, n;
    }();
    $241418c3f336c28b$var$m("MapSet", {
        F: function(n, r) {
            return new f(n, r);
        },
        T: function(n, r) {
            return new c(n, r);
        }
    });
}
function $241418c3f336c28b$export$cae049b67c7d1bc9() {
    $241418c3f336c28b$export$56771cf63ee491f5(), $241418c3f336c28b$export$7d9f65390203b435(), $241418c3f336c28b$export$d3a6659991a0696c();
}
function $241418c3f336c28b$export$c05b21e3257751e5(n) {
    return n;
}
function $241418c3f336c28b$export$20f911b3f8cf0b74(n) {
    return n;
}
var $241418c3f336c28b$var$G, $241418c3f336c28b$var$U, $241418c3f336c28b$var$W = "undefined" != typeof Symbol && "symbol" == typeof Symbol("x"), $241418c3f336c28b$var$X = "undefined" != typeof Map, $241418c3f336c28b$var$q = "undefined" != typeof Set, $241418c3f336c28b$var$B = "undefined" != typeof Proxy && void 0 !== Proxy.revocable && "undefined" != typeof Reflect, $241418c3f336c28b$export$45b790e32b2810ee = $241418c3f336c28b$var$W ? Symbol.for("immer-nothing") : (($241418c3f336c28b$var$G = {})["immer-nothing"] = !0, $241418c3f336c28b$var$G), $241418c3f336c28b$export$6ee2082928bcb0ee = $241418c3f336c28b$var$W ? Symbol.for("immer-draftable") : "__$immer_draftable", $241418c3f336c28b$var$Q = $241418c3f336c28b$var$W ? Symbol.for("immer-state") : "__$immer_state", $241418c3f336c28b$var$V = "undefined" != typeof Symbol && Symbol.iterator || "@@iterator", $241418c3f336c28b$var$Y = {
    0: "Illegal state",
    1: "Immer drafts cannot have computed properties",
    2: "This object has been frozen and should not be mutated",
    3: function(n) {
        return "Cannot use a proxy that has been revoked. Did you pass an object from inside an immer function to an async process? " + n;
    },
    4: "An immer producer returned a new value *and* modified its draft. Either return a new value *or* modify the draft.",
    5: "Immer forbids circular references",
    6: "The first or second argument to `produce` must be a function",
    7: "The third argument to `produce` must be a function or undefined",
    8: "First argument to `createDraft` must be a plain object, an array, or an immerable object",
    9: "First argument to `finishDraft` must be a draft returned by `createDraft`",
    10: "The given draft is already finalized",
    11: "Object.defineProperty() cannot be used on an Immer draft",
    12: "Object.setPrototypeOf() cannot be used on an Immer draft",
    13: "Immer only supports deleting array indices",
    14: "Immer only supports setting array indices and the 'length' property",
    15: function(n) {
        return "Cannot apply patch, path doesn't resolve: " + n;
    },
    16: 'Sets cannot have "replace" patches.',
    17: function(n) {
        return "Unsupported patch operation: " + n;
    },
    18: function(n) {
        return "The plugin for '" + n + "' has not been loaded into Immer. To enable the plugin, import and call `enable" + n + "()` when initializing your application.";
    },
    20: "Cannot use proxies if Proxy, Proxy.revocable or Reflect are not available",
    21: function(n) {
        return "produce can only be called on things that are draftable: plain objects, arrays, Map, Set or classes that are marked with '[immerable]: true'. Got '" + n + "'";
    },
    22: function(n) {
        return "'current' expects a draft, got: " + n;
    },
    23: function(n) {
        return "'original' expects a draft, got: " + n;
    },
    24: "Patching reserved attributes like __proto__, prototype and constructor is not allowed"
}, $241418c3f336c28b$var$Z = "" + Object.prototype.constructor, $241418c3f336c28b$var$nn = "undefined" != typeof Reflect && Reflect.ownKeys ? Reflect.ownKeys : void 0 !== Object.getOwnPropertySymbols ? function(n) {
    return Object.getOwnPropertyNames(n).concat(Object.getOwnPropertySymbols(n));
} : Object.getOwnPropertyNames, $241418c3f336c28b$var$rn = Object.getOwnPropertyDescriptors || function(n) {
    var r = {};
    return $241418c3f336c28b$var$nn(n).forEach(function(t) {
        r[t] = Object.getOwnPropertyDescriptor(n, t);
    }), r;
}, $241418c3f336c28b$var$tn = {}, $241418c3f336c28b$var$en = {
    get: function(n, r) {
        if (r === $241418c3f336c28b$var$Q) return n;
        var e = $241418c3f336c28b$var$p(n);
        if (!$241418c3f336c28b$var$u(e, r)) return function(n, r, t) {
            var e, i = $241418c3f336c28b$var$I(r, t);
            return i ? "value" in i ? i.value : null === (e = i.get) || void 0 === e ? void 0 : e.call(n.k) : void 0;
        }(n, e, r);
        var i = e[r];
        return n.I || !$241418c3f336c28b$export$16e3aed3edb85946(i) ? i : i === $241418c3f336c28b$var$z(n.t, r) ? ($241418c3f336c28b$var$E(n), n.o[r] = $241418c3f336c28b$var$N(n.A.h, i, n)) : i;
    },
    has: function(n, r) {
        return r in $241418c3f336c28b$var$p(n);
    },
    ownKeys: function(n) {
        return Reflect.ownKeys($241418c3f336c28b$var$p(n));
    },
    set: function(n, r, t) {
        var e = $241418c3f336c28b$var$I($241418c3f336c28b$var$p(n), r);
        if (null == e ? void 0 : e.set) return e.set.call(n.k, t), !0;
        if (!n.P) {
            var i = $241418c3f336c28b$var$z($241418c3f336c28b$var$p(n), r), o = null == i ? void 0 : i[$241418c3f336c28b$var$Q];
            if (o && o.t === t) return n.o[r] = t, n.R[r] = !1, !0;
            if ($241418c3f336c28b$var$c(t, i) && (void 0 !== t || $241418c3f336c28b$var$u(n.t, r))) return !0;
            $241418c3f336c28b$var$E(n), $241418c3f336c28b$var$k(n);
        }
        return n.o[r] === t && (void 0 !== t || r in n.o) || Number.isNaN(t) && Number.isNaN(n.o[r]) || (n.o[r] = t, n.R[r] = !0), !0;
    },
    deleteProperty: function(n, r) {
        return void 0 !== $241418c3f336c28b$var$z(n.t, r) || r in n.t ? (n.R[r] = !1, $241418c3f336c28b$var$E(n), $241418c3f336c28b$var$k(n)) : delete n.R[r], n.o && delete n.o[r], !0;
    },
    getOwnPropertyDescriptor: function(n, r) {
        var t = $241418c3f336c28b$var$p(n), e = Reflect.getOwnPropertyDescriptor(t, r);
        return e ? {
            writable: !0,
            configurable: 1 !== n.i || "length" !== r,
            enumerable: e.enumerable,
            value: t[r]
        } : e;
    },
    defineProperty: function() {
        $241418c3f336c28b$var$n(11);
    },
    getPrototypeOf: function(n) {
        return Object.getPrototypeOf(n.t);
    },
    setPrototypeOf: function() {
        $241418c3f336c28b$var$n(12);
    }
}, $241418c3f336c28b$var$on = {};
$241418c3f336c28b$var$i($241418c3f336c28b$var$en, function(n, r) {
    $241418c3f336c28b$var$on[n] = function() {
        return arguments[0] = arguments[0][0], r.apply(this, arguments);
    };
}), $241418c3f336c28b$var$on.deleteProperty = function(r, t) {
    return $241418c3f336c28b$var$on.set.call(this, r, t, void 0);
}, $241418c3f336c28b$var$on.set = function(r, t, e) {
    return $241418c3f336c28b$var$en.set.call(this, r[0], t, e, r[0]);
};
var $241418c3f336c28b$export$aaadc6ff0f822719 = function() {
    function e(r) {
        var e = this;
        this.O = $241418c3f336c28b$var$B, this.D = !0, this.produce = function(r, i, o) {
            if ("function" == typeof r && "function" != typeof i) {
                var u = i;
                i = r;
                var a = e;
                return function(n) {
                    var r = this;
                    void 0 === n && (n = u);
                    for(var t = arguments.length, e = Array(t > 1 ? t - 1 : 0), o = 1; o < t; o++)e[o - 1] = arguments[o];
                    return a.produce(n, function(n) {
                        var t;
                        return (t = i).call.apply(t, [
                            r,
                            n
                        ].concat(e));
                    });
                };
            }
            var f;
            if ("function" != typeof i && $241418c3f336c28b$var$n(6), void 0 !== o && "function" != typeof o && $241418c3f336c28b$var$n(7), $241418c3f336c28b$export$16e3aed3edb85946(r)) {
                var c = $241418c3f336c28b$var$w(e), s = $241418c3f336c28b$var$N(e, r, void 0), v = !0;
                try {
                    f = i(s), v = !1;
                } finally{
                    v ? $241418c3f336c28b$var$g(c) : $241418c3f336c28b$var$O(c);
                }
                return "undefined" != typeof Promise && f instanceof Promise ? f.then(function(n) {
                    return $241418c3f336c28b$var$j(c, o), $241418c3f336c28b$var$P(n, c);
                }, function(n) {
                    throw $241418c3f336c28b$var$g(c), n;
                }) : ($241418c3f336c28b$var$j(c, o), $241418c3f336c28b$var$P(f, c));
            }
            if (!r || "object" != typeof r) {
                if (void 0 === (f = i(r)) && (f = r), f === $241418c3f336c28b$export$45b790e32b2810ee && (f = void 0), e.D && $241418c3f336c28b$export$792f3d81ea979f55(f, !0), o) {
                    var p = [], l = [];
                    $241418c3f336c28b$var$b("Patches").M(r, f, p, l), o(p, l);
                }
                return f;
            }
            $241418c3f336c28b$var$n(21, r);
        }, this.produceWithPatches = function(n, r) {
            if ("function" == typeof n) return function(r) {
                for(var t = arguments.length, i = Array(t > 1 ? t - 1 : 0), o = 1; o < t; o++)i[o - 1] = arguments[o];
                return e.produceWithPatches(r, function(r) {
                    return n.apply(void 0, [
                        r
                    ].concat(i));
                });
            };
            var t, i, o = e.produce(n, r, function(n, r) {
                t = n, i = r;
            });
            return "undefined" != typeof Promise && o instanceof Promise ? o.then(function(n) {
                return [
                    n,
                    t,
                    i
                ];
            }) : [
                o,
                t,
                i
            ];
        }, "boolean" == typeof (null == r ? void 0 : r.useProxies) && this.setUseProxies(r.useProxies), "boolean" == typeof (null == r ? void 0 : r.autoFreeze) && this.setAutoFreeze(r.autoFreeze);
    }
    var i = e.prototype;
    return i.createDraft = function(e) {
        $241418c3f336c28b$export$16e3aed3edb85946(e) || $241418c3f336c28b$var$n(8), $241418c3f336c28b$export$541ac630993a4c84(e) && (e = $241418c3f336c28b$export$97aac956da55dae9(e));
        var i = $241418c3f336c28b$var$w(this), o = $241418c3f336c28b$var$N(this, e, void 0);
        return o[$241418c3f336c28b$var$Q].C = !0, $241418c3f336c28b$var$O(i), o;
    }, i.finishDraft = function(r, t) {
        var e = r && r[$241418c3f336c28b$var$Q];
        var i = e.A;
        return $241418c3f336c28b$var$j(i, t), $241418c3f336c28b$var$P(void 0, i);
    }, i.setAutoFreeze = function(n) {
        this.D = n;
    }, i.setUseProxies = function(r) {
        r && !$241418c3f336c28b$var$B && $241418c3f336c28b$var$n(20), this.O = r;
    }, i.applyPatches = function(n, t) {
        var e;
        for(e = t.length - 1; e >= 0; e--){
            var i = t[e];
            if (0 === i.path.length && "replace" === i.op) {
                n = i.value;
                break;
            }
        }
        e > -1 && (t = t.slice(e + 1));
        var o = $241418c3f336c28b$var$b("Patches").$;
        return $241418c3f336c28b$export$541ac630993a4c84(n) ? o(n, t) : this.produce(n, function(n) {
            return o(n, t);
        });
    }, e;
}(), $241418c3f336c28b$var$an = new $241418c3f336c28b$export$aaadc6ff0f822719, $241418c3f336c28b$export$b46cabe22e78bc00 = $241418c3f336c28b$var$an.produce, $241418c3f336c28b$export$4da66d41c9492c78 = $241418c3f336c28b$var$an.produceWithPatches.bind($241418c3f336c28b$var$an), $241418c3f336c28b$export$573f26f60825c493 = $241418c3f336c28b$var$an.setAutoFreeze.bind($241418c3f336c28b$var$an), $241418c3f336c28b$export$36ccd207ae29b74e = $241418c3f336c28b$var$an.setUseProxies.bind($241418c3f336c28b$var$an), $241418c3f336c28b$export$a8b8e03e6bbe5473 = $241418c3f336c28b$var$an.applyPatches.bind($241418c3f336c28b$var$an), $241418c3f336c28b$export$3c3214997190395f = $241418c3f336c28b$var$an.createDraft.bind($241418c3f336c28b$var$an), $241418c3f336c28b$export$c60f5e69c521b528 = $241418c3f336c28b$var$an.finishDraft.bind($241418c3f336c28b$var$an);
var $241418c3f336c28b$export$2e2bcd8739ae039 = $241418c3f336c28b$export$b46cabe22e78bc00;



var $8ixsH = parcelRequire("8ixsH");
// Cache implementation based on Erik Rasmussen's `lru-memoize`:
// https://github.com/erikras/lru-memoize
var $2ecd578a6744d6a7$var$NOT_FOUND = "NOT_FOUND";
function $2ecd578a6744d6a7$var$createSingletonCache(equals) {
    var entry;
    return {
        get: function get(key) {
            if (entry && equals(entry.key, key)) return entry.value;
            return $2ecd578a6744d6a7$var$NOT_FOUND;
        },
        put: function put(key, value) {
            entry = {
                key: key,
                value: value
            };
        },
        getEntries: function getEntries() {
            return entry ? [
                entry
            ] : [];
        },
        clear: function clear() {
            entry = undefined;
        }
    };
}
function $2ecd578a6744d6a7$var$createLruCache(maxSize, equals) {
    var entries = [];
    function get(key) {
        var cacheIndex = entries.findIndex(function(entry) {
            return equals(key, entry.key);
        }); // We found a cached entry
        if (cacheIndex > -1) {
            var entry = entries[cacheIndex]; // Cached entry not at top of cache, move it to the top
            if (cacheIndex > 0) {
                entries.splice(cacheIndex, 1);
                entries.unshift(entry);
            }
            return entry.value;
        } // No entry found in cache, return sentinel
        return $2ecd578a6744d6a7$var$NOT_FOUND;
    }
    function put(key, value) {
        if (get(key) === $2ecd578a6744d6a7$var$NOT_FOUND) {
            // TODO Is unshift slow?
            entries.unshift({
                key: key,
                value: value
            });
            if (entries.length > maxSize) entries.pop();
        }
    }
    function getEntries() {
        return entries;
    }
    function clear() {
        entries = [];
    }
    return {
        get: get,
        put: put,
        getEntries: getEntries,
        clear: clear
    };
}
var $2ecd578a6744d6a7$export$e0b28855d0126ccc = function defaultEqualityCheck(a, b) {
    return a === b;
};
function $2ecd578a6744d6a7$export$823674481ed171f9(equalityCheck) {
    return function areArgumentsShallowlyEqual(prev, next) {
        if (prev === null || next === null || prev.length !== next.length) return false;
         // Do this in a for loop (and not a `forEach` or an `every`) so we can determine equality as fast as possible.
        var length = prev.length;
        for(var i = 0; i < length; i++){
            if (!equalityCheck(prev[i], next[i])) return false;
        }
        return true;
    };
}
function $2ecd578a6744d6a7$export$281bff7f05488aa2(func, equalityCheckOrOptions) {
    var providedOptions = typeof equalityCheckOrOptions === "object" ? equalityCheckOrOptions : {
        equalityCheck: equalityCheckOrOptions
    };
    var _providedOptions$equa = providedOptions.equalityCheck, equalityCheck = _providedOptions$equa === void 0 ? $2ecd578a6744d6a7$export$e0b28855d0126ccc : _providedOptions$equa, _providedOptions$maxS = providedOptions.maxSize, maxSize = _providedOptions$maxS === void 0 ? 1 : _providedOptions$maxS, resultEqualityCheck = providedOptions.resultEqualityCheck;
    var comparator = $2ecd578a6744d6a7$export$823674481ed171f9(equalityCheck);
    var cache = maxSize === 1 ? $2ecd578a6744d6a7$var$createSingletonCache(comparator) : $2ecd578a6744d6a7$var$createLruCache(maxSize, comparator); // we reference arguments instead of spreading them for performance reasons
    function memoized() {
        var value = cache.get(arguments);
        if (value === $2ecd578a6744d6a7$var$NOT_FOUND) {
            // @ts-ignore
            value = func.apply(null, arguments);
            if (resultEqualityCheck) {
                var entries = cache.getEntries();
                var matchingEntry = entries.find(function(entry) {
                    return resultEqualityCheck(entry.value, value);
                });
                if (matchingEntry) value = matchingEntry.value;
            }
            cache.put(arguments, value);
        }
        return value;
    }
    memoized.clearCache = function() {
        return cache.clear();
    };
    return memoized;
}


function $8fd128d37504b12a$var$getDependencies(funcs) {
    var dependencies = Array.isArray(funcs[0]) ? funcs[0] : funcs;
    if (!dependencies.every(function(dep) {
        return typeof dep === "function";
    })) {
        var dependencyTypes = dependencies.map(function(dep) {
            return typeof dep === "function" ? "function " + (dep.name || "unnamed") + "()" : typeof dep;
        }).join(", ");
        throw new Error("createSelector expects all input-selectors to be functions, but received the following types: [" + dependencyTypes + "]");
    }
    return dependencies;
}
function $8fd128d37504b12a$export$5943f4447f6ef248(memoize) {
    for(var _len = arguments.length, memoizeOptionsFromArgs = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)memoizeOptionsFromArgs[_key - 1] = arguments[_key];
    var createSelector = function createSelector() {
        for(var _len2 = arguments.length, funcs = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)funcs[_key2] = arguments[_key2];
        var _recomputations = 0;
        var _lastResult; // Due to the intricacies of rest params, we can't do an optional arg after `...funcs`.
        // So, start by declaring the default value here.
        // (And yes, the words 'memoize' and 'options' appear too many times in this next sequence.)
        var directlyPassedOptions = {
            memoizeOptions: undefined
        }; // Normally, the result func or "output selector" is the last arg
        var resultFunc = funcs.pop(); // If the result func is actually an _object_, assume it's our options object
        if (typeof resultFunc === "object") {
            directlyPassedOptions = resultFunc; // and pop the real result func off
            resultFunc = funcs.pop();
        }
        if (typeof resultFunc !== "function") throw new Error("createSelector expects an output function after the inputs, but received: [" + typeof resultFunc + "]");
         // Determine which set of options we're using. Prefer options passed directly,
        // but fall back to options given to createSelectorCreator.
        var _directlyPassedOption = directlyPassedOptions, _directlyPassedOption2 = _directlyPassedOption.memoizeOptions, memoizeOptions = _directlyPassedOption2 === void 0 ? memoizeOptionsFromArgs : _directlyPassedOption2; // Simplifying assumption: it's unlikely that the first options arg of the provided memoizer
        // is an array. In most libs I've looked at, it's an equality function or options object.
        // Based on that, if `memoizeOptions` _is_ an array, we assume it's a full
        // user-provided array of options. Otherwise, it must be just the _first_ arg, and so
        // we wrap it in an array so we can apply it.
        var finalMemoizeOptions = Array.isArray(memoizeOptions) ? memoizeOptions : [
            memoizeOptions
        ];
        var dependencies = $8fd128d37504b12a$var$getDependencies(funcs);
        var memoizedResultFunc = memoize.apply(void 0, [
            function recomputationWrapper() {
                _recomputations++; // apply arguments instead of spreading for performance.
                return resultFunc.apply(null, arguments);
            }
        ].concat(finalMemoizeOptions)); // If a selector is called with the exact same arguments we don't need to traverse our dependencies again.
        var selector = memoize(function dependenciesChecker() {
            var params = [];
            var length = dependencies.length;
            for(var i = 0; i < length; i++)// apply arguments instead of spreading and mutate a local list of params for performance.
            // @ts-ignore
            params.push(dependencies[i].apply(null, arguments));
             // apply arguments instead of spreading for performance.
            _lastResult = memoizedResultFunc.apply(null, params);
            return _lastResult;
        });
        Object.assign(selector, {
            resultFunc: resultFunc,
            memoizedResultFunc: memoizedResultFunc,
            dependencies: dependencies,
            lastResult: function lastResult() {
                return _lastResult;
            },
            recomputations: function recomputations() {
                return _recomputations;
            },
            resetRecomputations: function resetRecomputations() {
                return _recomputations = 0;
            }
        });
        return selector;
    }; // @ts-ignore
    return createSelector;
}
var $8fd128d37504b12a$export$595d22ed68ca2841 = /* #__PURE__ */ $8fd128d37504b12a$export$5943f4447f6ef248((0, $2ecd578a6744d6a7$export$281bff7f05488aa2));
var $8fd128d37504b12a$export$75979cfcd91bf38f = function createStructuredSelector(selectors, selectorCreator) {
    if (selectorCreator === void 0) selectorCreator = $8fd128d37504b12a$export$595d22ed68ca2841;
    if (typeof selectors !== "object") throw new Error("createStructuredSelector expects first argument to be an object " + ("where each property is a selector, instead received a " + typeof selectors));
    var objectKeys = Object.keys(selectors);
    var resultSelector = selectorCreator(objectKeys.map(function(key) {
        return selectors[key];
    }), function() {
        for(var _len3 = arguments.length, values = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)values[_key3] = arguments[_key3];
        return values.reduce(function(composition, value, index) {
            composition[objectKeys[index]] = value;
            return composition;
        }, {});
    });
    return resultSelector;
};


/** A function that accepts a potential "extra argument" value to be injected later,
 * and returns an instance of the thunk middleware that uses that value
 */ function $ab4e91f92ff74997$var$createThunkMiddleware(extraArgument) {
    // Standard Redux middleware definition pattern:
    // See: https://redux.js.org/tutorials/fundamentals/part-4-store#writing-custom-middleware
    var middleware = function middleware(_ref) {
        var dispatch = _ref.dispatch, getState = _ref.getState;
        return function(next) {
            return function(action) {
                // The thunk middleware looks for any functions that were passed to `store.dispatch`.
                // If this "action" is really a function, call it and return the result.
                if (typeof action === "function") // Inject the store's `dispatch` and `getState` methods, as well as any "extra arg"
                return action(dispatch, getState, extraArgument);
                 // Otherwise, pass the action down the middleware chain as usual
                return next(action);
            };
        };
    };
    return middleware;
}
var $ab4e91f92ff74997$var$thunk = $ab4e91f92ff74997$var$createThunkMiddleware(); // Attach the factory function so users can create a customized version
// with whatever "extra arg" they want to inject into their thunks
$ab4e91f92ff74997$var$thunk.withExtraArgument = $ab4e91f92ff74997$var$createThunkMiddleware;
var $ab4e91f92ff74997$export$2e2bcd8739ae039 = $ab4e91f92ff74997$var$thunk;



var $hIXGI = parcelRequire("hIXGI");
var $7908c0d6cb321887$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $7908c0d6cb321887$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $7908c0d6cb321887$var$__spreadArray = undefined && undefined.__spreadArray || function(to, from) {
    for(var i = 0, il = from.length, j = to.length; i < il; i++, j++)to[j] = from[i];
    return to;
};
var $7908c0d6cb321887$var$__defProp = Object.defineProperty;
var $7908c0d6cb321887$var$__defProps = Object.defineProperties;
var $7908c0d6cb321887$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $7908c0d6cb321887$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $7908c0d6cb321887$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $7908c0d6cb321887$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $7908c0d6cb321887$var$__defNormalProp = function(obj, key, value) {
    return key in obj ? $7908c0d6cb321887$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
};
var $7908c0d6cb321887$var$__spreadValues = function(a, b) {
    for(var prop in b || (b = {}))if ($7908c0d6cb321887$var$__hasOwnProp.call(b, prop)) $7908c0d6cb321887$var$__defNormalProp(a, prop, b[prop]);
    if ($7908c0d6cb321887$var$__getOwnPropSymbols) for(var _i = 0, _c = $7908c0d6cb321887$var$__getOwnPropSymbols(b); _i < _c.length; _i++){
        var prop = _c[_i];
        if ($7908c0d6cb321887$var$__propIsEnum.call(b, prop)) $7908c0d6cb321887$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $7908c0d6cb321887$var$__spreadProps = function(a, b) {
    return $7908c0d6cb321887$var$__defProps(a, $7908c0d6cb321887$var$__getOwnPropDescs(b));
};
var $7908c0d6cb321887$var$__async = function(__this, __arguments, generator) {
    return new Promise(function(resolve, reject) {
        var fulfilled = function(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        };
        var rejected = function(value) {
            try {
                step(generator.throw(value));
            } catch (e) {
                reject(e);
            }
        };
        var step = function(x) {
            return x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
        };
        step((generator = generator.apply(__this, __arguments)).next());
    });
};
var $7908c0d6cb321887$export$a5d3c27355e35910 = function() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    var selector = (0, $8fd128d37504b12a$export$595d22ed68ca2841).apply(void 0, args);
    var wrappedSelector = function(value) {
        var rest = [];
        for(var _i = 1; _i < arguments.length; _i++)rest[_i - 1] = arguments[_i];
        return selector.apply(void 0, $7908c0d6cb321887$var$__spreadArray([
            (0, $241418c3f336c28b$export$541ac630993a4c84)(value) ? (0, $241418c3f336c28b$export$97aac956da55dae9)(value) : value
        ], rest));
    };
    return wrappedSelector;
};
var $7908c0d6cb321887$var$composeWithDevTools = typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ : function() {
    if (arguments.length === 0) return void 0;
    if (typeof arguments[0] === "object") return 0, $8ixsH.compose;
    return (0, $8ixsH.compose).apply(null, arguments);
};
var $7908c0d6cb321887$var$devToolsEnhancer = typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__ : function() {
    return function(noop2) {
        return noop2;
    };
};
// src/isPlainObject.ts
function $7908c0d6cb321887$export$53b83ca8eaab0383(value) {
    if (typeof value !== "object" || value === null) return false;
    var proto = Object.getPrototypeOf(value);
    if (proto === null) return true;
    var baseProto = proto;
    while(Object.getPrototypeOf(baseProto) !== null)baseProto = Object.getPrototypeOf(baseProto);
    return proto === baseProto;
}
function $7908c0d6cb321887$var$getTimeMeasureUtils(maxDelay, fnName) {
    var elapsed = 0;
    return {
        measureTime: function(fn) {
            var started = Date.now();
            try {
                return fn();
            } finally{
                var finished = Date.now();
                elapsed += finished - started;
            }
        },
        warnIfExceeded: function() {
            if (elapsed > maxDelay) console.warn(fnName + " took " + elapsed + "ms, which is more than the warning threshold of " + maxDelay + "ms. \nIf your state or actions are very large, you may want to disable the middleware as it might cause too much of a slowdown in development mode. See https://redux-toolkit.js.org/api/getDefaultMiddleware for instructions.\nIt is disabled in production builds, so you don't need to worry about that.");
        }
    };
}
var $7908c0d6cb321887$export$20df1e9bd1a54f25 = /** @class */ function(_super) {
    $7908c0d6cb321887$var$__extends(MiddlewareArray, _super);
    function MiddlewareArray() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        var _this = _super.apply(this, args) || this;
        Object.setPrototypeOf(_this, MiddlewareArray.prototype);
        return _this;
    }
    Object.defineProperty(MiddlewareArray, Symbol.species, {
        get: function() {
            return MiddlewareArray;
        },
        enumerable: false,
        configurable: true
    });
    MiddlewareArray.prototype.concat = function() {
        var arr = [];
        for(var _i = 0; _i < arguments.length; _i++)arr[_i] = arguments[_i];
        return _super.prototype.concat.apply(this, arr);
    };
    MiddlewareArray.prototype.prepend = function() {
        var arr = [];
        for(var _i = 0; _i < arguments.length; _i++)arr[_i] = arguments[_i];
        if (arr.length === 1 && Array.isArray(arr[0])) return new (MiddlewareArray.bind.apply(MiddlewareArray, $7908c0d6cb321887$var$__spreadArray([
            void 0
        ], arr[0].concat(this))))();
        return new (MiddlewareArray.bind.apply(MiddlewareArray, $7908c0d6cb321887$var$__spreadArray([
            void 0
        ], arr.concat(this))))();
    };
    return MiddlewareArray;
}(Array);
var $7908c0d6cb321887$export$490d10040a0cbe8a = /** @class */ function(_super) {
    $7908c0d6cb321887$var$__extends(EnhancerArray, _super);
    function EnhancerArray() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        var _this = _super.apply(this, args) || this;
        Object.setPrototypeOf(_this, EnhancerArray.prototype);
        return _this;
    }
    Object.defineProperty(EnhancerArray, Symbol.species, {
        get: function() {
            return EnhancerArray;
        },
        enumerable: false,
        configurable: true
    });
    EnhancerArray.prototype.concat = function() {
        var arr = [];
        for(var _i = 0; _i < arguments.length; _i++)arr[_i] = arguments[_i];
        return _super.prototype.concat.apply(this, arr);
    };
    EnhancerArray.prototype.prepend = function() {
        var arr = [];
        for(var _i = 0; _i < arguments.length; _i++)arr[_i] = arguments[_i];
        if (arr.length === 1 && Array.isArray(arr[0])) return new (EnhancerArray.bind.apply(EnhancerArray, $7908c0d6cb321887$var$__spreadArray([
            void 0
        ], arr[0].concat(this))))();
        return new (EnhancerArray.bind.apply(EnhancerArray, $7908c0d6cb321887$var$__spreadArray([
            void 0
        ], arr.concat(this))))();
    };
    return EnhancerArray;
}(Array);
function $7908c0d6cb321887$var$freezeDraftable(val) {
    return (0, $241418c3f336c28b$export$16e3aed3edb85946)(val) ? (0, $241418c3f336c28b$export$2e2bcd8739ae039)(val, function() {}) : val;
}
// src/immutableStateInvariantMiddleware.ts
var $7908c0d6cb321887$var$isProduction = true;
var $7908c0d6cb321887$var$prefix = "Invariant failed";
function $7908c0d6cb321887$var$invariant(condition, message) {
    if (condition) return;
    if ($7908c0d6cb321887$var$isProduction) throw new Error($7908c0d6cb321887$var$prefix);
    throw new Error($7908c0d6cb321887$var$prefix + ": " + (message || ""));
}
function $7908c0d6cb321887$var$stringify(obj, serializer, indent, decycler) {
    return JSON.stringify(obj, $7908c0d6cb321887$var$getSerialize(serializer, decycler), indent);
}
function $7908c0d6cb321887$var$getSerialize(serializer, decycler) {
    var stack = [], keys = [];
    if (!decycler) decycler = function(_, value) {
        if (stack[0] === value) return "[Circular ~]";
        return "[Circular ~." + keys.slice(0, stack.indexOf(value)).join(".") + "]";
    };
    return function(key, value) {
        if (stack.length > 0) {
            var thisPos = stack.indexOf(this);
            ~thisPos ? stack.splice(thisPos + 1) : stack.push(this);
            ~thisPos ? keys.splice(thisPos, Infinity, key) : keys.push(key);
            if (~stack.indexOf(value)) value = decycler.call(this, key, value);
        } else stack.push(value);
        return serializer == null ? value : serializer.call(this, key, value);
    };
}
function $7908c0d6cb321887$export$9021b2733a0028a3(value) {
    return typeof value !== "object" || value == null || Object.isFrozen(value);
}
function $7908c0d6cb321887$var$trackForMutations(isImmutable, ignorePaths, obj) {
    var trackedProperties = $7908c0d6cb321887$var$trackProperties(isImmutable, ignorePaths, obj);
    return {
        detectMutations: function() {
            return $7908c0d6cb321887$var$detectMutations(isImmutable, ignorePaths, trackedProperties, obj);
        }
    };
}
function $7908c0d6cb321887$var$trackProperties(isImmutable, ignorePaths, obj, path) {
    if (ignorePaths === void 0) ignorePaths = [];
    if (path === void 0) path = "";
    var tracked = {
        value: obj
    };
    if (!isImmutable(obj)) {
        tracked.children = {};
        for(var key in obj){
            var childPath = path ? path + "." + key : key;
            if (ignorePaths.length && ignorePaths.indexOf(childPath) !== -1) continue;
            tracked.children[key] = $7908c0d6cb321887$var$trackProperties(isImmutable, ignorePaths, obj[key], childPath);
        }
    }
    return tracked;
}
function $7908c0d6cb321887$var$detectMutations(isImmutable, ignoredPaths, trackedProperty, obj, sameParentRef, path) {
    if (ignoredPaths === void 0) ignoredPaths = [];
    if (sameParentRef === void 0) sameParentRef = false;
    if (path === void 0) path = "";
    var prevObj = trackedProperty ? trackedProperty.value : void 0;
    var sameRef = prevObj === obj;
    if (sameParentRef && !sameRef && !Number.isNaN(obj)) return {
        wasMutated: true,
        path: path
    };
    if (isImmutable(prevObj) || isImmutable(obj)) return {
        wasMutated: false
    };
    var keysToDetect = {};
    for(var key in trackedProperty.children)keysToDetect[key] = true;
    for(var key in obj)keysToDetect[key] = true;
    var hasIgnoredPaths = ignoredPaths.length > 0;
    var _loop_1 = function(key) {
        var nestedPath = path ? path + "." + key : key;
        if (hasIgnoredPaths) {
            var hasMatches = ignoredPaths.some(function(ignored) {
                if (ignored instanceof RegExp) return ignored.test(nestedPath);
                return nestedPath === ignored;
            });
            if (hasMatches) return "continue";
        }
        var result = $7908c0d6cb321887$var$detectMutations(isImmutable, ignoredPaths, trackedProperty.children[key], obj[key], sameRef, nestedPath);
        if (result.wasMutated) return {
            value: result
        };
    };
    for(var key in keysToDetect){
        var state_1 = _loop_1(key);
        if (typeof state_1 === "object") return state_1.value;
    }
    return {
        wasMutated: false
    };
}
function $7908c0d6cb321887$export$9181bb1a5474289(options) {
    if (options === void 0) options = {};
    var _c, isImmutable, ignoredPaths, _d, warnAfter, ignore, track;
    return function() {
        return function(next) {
            return function(action) {
                return next(action);
            };
        };
    };
}
// src/serializableStateInvariantMiddleware.ts
function $7908c0d6cb321887$export$77670485918dab4e(val) {
    var type = typeof val;
    return val == null || type === "string" || type === "boolean" || type === "number" || Array.isArray(val) || $7908c0d6cb321887$export$53b83ca8eaab0383(val);
}
function $7908c0d6cb321887$export$ada5dca0b571bc7(value, path, isSerializable, getEntries, ignoredPaths, cache) {
    if (path === void 0) path = "";
    if (isSerializable === void 0) isSerializable = $7908c0d6cb321887$export$77670485918dab4e;
    if (ignoredPaths === void 0) ignoredPaths = [];
    var foundNestedSerializable;
    if (!isSerializable(value)) return {
        keyPath: path || "<root>",
        value: value
    };
    if (typeof value !== "object" || value === null) return false;
    if (cache == null ? void 0 : cache.has(value)) return false;
    var entries = getEntries != null ? getEntries(value) : Object.entries(value);
    var hasIgnoredPaths = ignoredPaths.length > 0;
    var _loop_2 = function(key, nestedValue) {
        var nestedPath = path ? path + "." + key : key;
        if (hasIgnoredPaths) {
            var hasMatches = ignoredPaths.some(function(ignored) {
                if (ignored instanceof RegExp) return ignored.test(nestedPath);
                return nestedPath === ignored;
            });
            if (hasMatches) return "continue";
        }
        if (!isSerializable(nestedValue)) return {
            value: {
                keyPath: nestedPath,
                value: nestedValue
            }
        };
        if (typeof nestedValue === "object") {
            foundNestedSerializable = $7908c0d6cb321887$export$ada5dca0b571bc7(nestedValue, nestedPath, isSerializable, getEntries, ignoredPaths, cache);
            if (foundNestedSerializable) return {
                value: foundNestedSerializable
            };
        }
    };
    for(var _i = 0, entries_1 = entries; _i < entries_1.length; _i++){
        var _c = entries_1[_i], key = _c[0], nestedValue = _c[1];
        var state_2 = _loop_2(key, nestedValue);
        if (typeof state_2 === "object") return state_2.value;
    }
    if (cache && $7908c0d6cb321887$var$isNestedFrozen(value)) cache.add(value);
    return false;
}
function $7908c0d6cb321887$var$isNestedFrozen(value) {
    if (!Object.isFrozen(value)) return false;
    for(var _i = 0, _c = Object.values(value); _i < _c.length; _i++){
        var nestedValue = _c[_i];
        if (typeof nestedValue !== "object" || nestedValue === null) continue;
        if (!$7908c0d6cb321887$var$isNestedFrozen(nestedValue)) return false;
    }
    return true;
}
function $7908c0d6cb321887$export$6dea1aad6dac5ac2(options) {
    if (options === void 0) options = {};
    var _c, isSerializable, getEntries, _d, ignoredActions, _e, ignoredActionPaths, _f, ignoredPaths, _g, warnAfter, _h, ignoreState, _j, ignoreActions, _k, disableCache, cache;
    return function() {
        return function(next) {
            return function(action) {
                return next(action);
            };
        };
    };
}
// src/getDefaultMiddleware.ts
function $7908c0d6cb321887$var$isBoolean(x) {
    return typeof x === "boolean";
}
function $7908c0d6cb321887$var$curryGetDefaultMiddleware() {
    return function curriedGetDefaultMiddleware(options) {
        return $7908c0d6cb321887$export$36c1185aeee5b0a6(options);
    };
}
function $7908c0d6cb321887$export$36c1185aeee5b0a6(options) {
    if (options === void 0) options = {};
    var _c = options.thunk, thunk = _c === void 0 ? true : _c, _d = options.immutableCheck, immutableCheck = _d === void 0 ? true : _d, _e = options.serializableCheck, serializableCheck = _e === void 0 ? true : _e;
    var middlewareArray = new $7908c0d6cb321887$export$20df1e9bd1a54f25();
    if (thunk) {
        if ($7908c0d6cb321887$var$isBoolean(thunk)) middlewareArray.push((0, $ab4e91f92ff74997$export$2e2bcd8739ae039));
        else middlewareArray.push((0, $ab4e91f92ff74997$export$2e2bcd8739ae039).withExtraArgument(thunk.extraArgument));
    }
    var immutableOptions, serializableOptions;
    return middlewareArray;
}
// src/configureStore.ts
var $7908c0d6cb321887$var$IS_PRODUCTION = true;
function $7908c0d6cb321887$export$7d8a5b498da695ac(options) {
    var curriedGetDefaultMiddleware = $7908c0d6cb321887$var$curryGetDefaultMiddleware();
    var _c = options || {}, _d = _c.reducer, reducer = _d === void 0 ? void 0 : _d, _e = _c.middleware, middleware = _e === void 0 ? curriedGetDefaultMiddleware() : _e, _f = _c.devTools, devTools = _f === void 0 ? true : _f, _g = _c.preloadedState, preloadedState = _g === void 0 ? void 0 : _g, _h = _c.enhancers, enhancers = _h === void 0 ? void 0 : _h;
    var rootReducer;
    if (typeof reducer === "function") rootReducer = reducer;
    else if ($7908c0d6cb321887$export$53b83ca8eaab0383(reducer)) rootReducer = (0, $8ixsH.combineReducers)(reducer);
    else throw new Error('"reducer" is a required argument, and must be a function or an object of functions that can be passed to combineReducers');
    var finalMiddleware = middleware;
    if (typeof finalMiddleware === "function") {
        finalMiddleware = finalMiddleware(curriedGetDefaultMiddleware);
        if (!$7908c0d6cb321887$var$IS_PRODUCTION && !Array.isArray(finalMiddleware)) throw new Error("when using a middleware builder function, an array of middleware must be returned");
    }
    if (!$7908c0d6cb321887$var$IS_PRODUCTION && finalMiddleware.some(function(item) {
        return typeof item !== "function";
    })) throw new Error("each middleware provided to configureStore must be a function");
    var middlewareEnhancer = (0, $8ixsH.applyMiddleware).apply(void 0, finalMiddleware);
    var finalCompose = (0, $8ixsH.compose);
    if (devTools) finalCompose = $7908c0d6cb321887$var$composeWithDevTools($7908c0d6cb321887$var$__spreadValues({
        trace: !$7908c0d6cb321887$var$IS_PRODUCTION
    }, typeof devTools === "object" && devTools));
    var defaultEnhancers = new $7908c0d6cb321887$export$490d10040a0cbe8a(middlewareEnhancer);
    var storeEnhancers = defaultEnhancers;
    if (Array.isArray(enhancers)) storeEnhancers = $7908c0d6cb321887$var$__spreadArray([
        middlewareEnhancer
    ], enhancers);
    else if (typeof enhancers === "function") storeEnhancers = enhancers(defaultEnhancers);
    var composedEnhancer = finalCompose.apply(void 0, storeEnhancers);
    return (0, $8ixsH.createStore)(rootReducer, preloadedState, composedEnhancer);
}
// src/createAction.ts
function $7908c0d6cb321887$export$309c7a02b0b0bc62(type, prepareAction) {
    function actionCreator() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        if (prepareAction) {
            var prepared = prepareAction.apply(void 0, args);
            if (!prepared) throw new Error("prepareAction did not return an object");
            return $7908c0d6cb321887$var$__spreadValues($7908c0d6cb321887$var$__spreadValues({
                type: type,
                payload: prepared.payload
            }, "meta" in prepared && {
                meta: prepared.meta
            }), "error" in prepared && {
                error: prepared.error
            });
        }
        return {
            type: type,
            payload: args[0]
        };
    }
    actionCreator.toString = function() {
        return "" + type;
    };
    actionCreator.type = type;
    actionCreator.match = function(action) {
        return action.type === type;
    };
    return actionCreator;
}
function $7908c0d6cb321887$export$b956e38827fca970(action) {
    return $7908c0d6cb321887$export$53b83ca8eaab0383(action) && "type" in action;
}
function $7908c0d6cb321887$export$ebd532f9034651f3(action) {
    return $7908c0d6cb321887$export$b956e38827fca970(action) && typeof action.type === "string" && Object.keys(action).every($7908c0d6cb321887$var$isValidKey);
}
function $7908c0d6cb321887$var$isValidKey(key) {
    return [
        "type",
        "payload",
        "error",
        "meta"
    ].indexOf(key) > -1;
}
function $7908c0d6cb321887$export$e2b5c5db9e2009fd(actionCreator) {
    return "" + actionCreator;
}
// src/mapBuilders.ts
function $7908c0d6cb321887$var$executeReducerBuilderCallback(builderCallback) {
    var actionsMap = {};
    var actionMatchers = [];
    var defaultCaseReducer;
    var builder = {
        addCase: function(typeOrActionCreator, reducer) {
            var type = typeof typeOrActionCreator === "string" ? typeOrActionCreator : typeOrActionCreator.type;
            if (type in actionsMap) throw new Error("addCase cannot be called with two reducers for the same action type");
            actionsMap[type] = reducer;
            return builder;
        },
        addMatcher: function(matcher, reducer) {
            actionMatchers.push({
                matcher: matcher,
                reducer: reducer
            });
            return builder;
        },
        addDefaultCase: function(reducer) {
            defaultCaseReducer = reducer;
            return builder;
        }
    };
    builderCallback(builder);
    return [
        actionsMap,
        actionMatchers,
        defaultCaseReducer
    ];
}
// src/createReducer.ts
function $7908c0d6cb321887$var$isStateFunction(x) {
    return typeof x === "function";
}
var $7908c0d6cb321887$var$hasWarnedAboutObjectNotation = false;
function $7908c0d6cb321887$export$473eb76d322d0290(initialState, mapOrBuilderCallback, actionMatchers, defaultCaseReducer) {
    if (actionMatchers === void 0) actionMatchers = [];
    var _c = typeof mapOrBuilderCallback === "function" ? $7908c0d6cb321887$var$executeReducerBuilderCallback(mapOrBuilderCallback) : [
        mapOrBuilderCallback,
        actionMatchers,
        defaultCaseReducer
    ], actionsMap = _c[0], finalActionMatchers = _c[1], finalDefaultCaseReducer = _c[2];
    var getInitialState;
    if ($7908c0d6cb321887$var$isStateFunction(initialState)) getInitialState = function() {
        return $7908c0d6cb321887$var$freezeDraftable(initialState());
    };
    else {
        var frozenInitialState_1 = $7908c0d6cb321887$var$freezeDraftable(initialState);
        getInitialState = function() {
            return frozenInitialState_1;
        };
    }
    function reducer(state, action) {
        if (state === void 0) state = getInitialState();
        var caseReducers = $7908c0d6cb321887$var$__spreadArray([
            actionsMap[action.type]
        ], finalActionMatchers.filter(function(_c) {
            var matcher = _c.matcher;
            return matcher(action);
        }).map(function(_c) {
            var reducer2 = _c.reducer;
            return reducer2;
        }));
        if (caseReducers.filter(function(cr) {
            return !!cr;
        }).length === 0) caseReducers = [
            finalDefaultCaseReducer
        ];
        return caseReducers.reduce(function(previousState, caseReducer) {
            if (caseReducer) {
                if ((0, $241418c3f336c28b$export$541ac630993a4c84)(previousState)) {
                    var draft = previousState;
                    var result = caseReducer(draft, action);
                    if (result === void 0) return previousState;
                    return result;
                } else if (!(0, $241418c3f336c28b$export$16e3aed3edb85946)(previousState)) {
                    var result = caseReducer(previousState, action);
                    if (result === void 0) {
                        if (previousState === null) return previousState;
                        throw Error("A case reducer on a non-draftable value must not return undefined");
                    }
                    return result;
                } else return (0, $241418c3f336c28b$export$2e2bcd8739ae039)(previousState, function(draft) {
                    return caseReducer(draft, action);
                });
            }
            return previousState;
        }, state);
    }
    reducer.getInitialState = getInitialState;
    return reducer;
}
// src/createSlice.ts
var $7908c0d6cb321887$var$hasWarnedAboutObjectNotation2 = false;
function $7908c0d6cb321887$var$getType2(slice, actionKey) {
    return slice + "/" + actionKey;
}
function $7908c0d6cb321887$export$4d8d9bd83c24ae8b(options) {
    var name = options.name;
    if (!name) throw new Error("`name` is a required option for createSlice");
    typeof $hIXGI;
    var initialState = typeof options.initialState == "function" ? options.initialState : $7908c0d6cb321887$var$freezeDraftable(options.initialState);
    var reducers = options.reducers || {};
    var reducerNames = Object.keys(reducers);
    var sliceCaseReducersByName = {};
    var sliceCaseReducersByType = {};
    var actionCreators = {};
    reducerNames.forEach(function(reducerName) {
        var maybeReducerWithPrepare = reducers[reducerName];
        var type = $7908c0d6cb321887$var$getType2(name, reducerName);
        var caseReducer;
        var prepareCallback;
        if ("reducer" in maybeReducerWithPrepare) {
            caseReducer = maybeReducerWithPrepare.reducer;
            prepareCallback = maybeReducerWithPrepare.prepare;
        } else caseReducer = maybeReducerWithPrepare;
        sliceCaseReducersByName[reducerName] = caseReducer;
        sliceCaseReducersByType[type] = caseReducer;
        actionCreators[reducerName] = prepareCallback ? $7908c0d6cb321887$export$309c7a02b0b0bc62(type, prepareCallback) : $7908c0d6cb321887$export$309c7a02b0b0bc62(type);
    });
    function buildReducer() {
        var _c = typeof options.extraReducers === "function" ? $7908c0d6cb321887$var$executeReducerBuilderCallback(options.extraReducers) : [
            options.extraReducers
        ], _d = _c[0], extraReducers = _d === void 0 ? {} : _d, _e = _c[1], actionMatchers = _e === void 0 ? [] : _e, _f = _c[2], defaultCaseReducer = _f === void 0 ? void 0 : _f;
        var finalCaseReducers = $7908c0d6cb321887$var$__spreadValues($7908c0d6cb321887$var$__spreadValues({}, extraReducers), sliceCaseReducersByType);
        return $7908c0d6cb321887$export$473eb76d322d0290(initialState, function(builder) {
            for(var key in finalCaseReducers)builder.addCase(key, finalCaseReducers[key]);
            for(var _i = 0, actionMatchers_1 = actionMatchers; _i < actionMatchers_1.length; _i++){
                var m = actionMatchers_1[_i];
                builder.addMatcher(m.matcher, m.reducer);
            }
            if (defaultCaseReducer) builder.addDefaultCase(defaultCaseReducer);
        });
    }
    var _reducer;
    return {
        name: name,
        reducer: function(state, action) {
            if (!_reducer) _reducer = buildReducer();
            return _reducer(state, action);
        },
        actions: actionCreators,
        caseReducers: sliceCaseReducersByName,
        getInitialState: function() {
            if (!_reducer) _reducer = buildReducer();
            return _reducer.getInitialState();
        }
    };
}
// src/entities/entity_state.ts
function $7908c0d6cb321887$var$getInitialEntityState() {
    return {
        ids: [],
        entities: {}
    };
}
function $7908c0d6cb321887$var$createInitialStateFactory() {
    function getInitialState(additionalState) {
        if (additionalState === void 0) additionalState = {};
        return Object.assign($7908c0d6cb321887$var$getInitialEntityState(), additionalState);
    }
    return {
        getInitialState: getInitialState
    };
}
// src/entities/state_selectors.ts
function $7908c0d6cb321887$var$createSelectorsFactory() {
    function getSelectors(selectState) {
        var selectIds = function(state) {
            return state.ids;
        };
        var selectEntities = function(state) {
            return state.entities;
        };
        var selectAll = $7908c0d6cb321887$export$a5d3c27355e35910(selectIds, selectEntities, function(ids, entities) {
            return ids.map(function(id) {
                return entities[id];
            });
        });
        var selectId = function(_, id) {
            return id;
        };
        var selectById = function(entities, id) {
            return entities[id];
        };
        var selectTotal = $7908c0d6cb321887$export$a5d3c27355e35910(selectIds, function(ids) {
            return ids.length;
        });
        if (!selectState) return {
            selectIds: selectIds,
            selectEntities: selectEntities,
            selectAll: selectAll,
            selectTotal: selectTotal,
            selectById: $7908c0d6cb321887$export$a5d3c27355e35910(selectEntities, selectId, selectById)
        };
        var selectGlobalizedEntities = $7908c0d6cb321887$export$a5d3c27355e35910(selectState, selectEntities);
        return {
            selectIds: $7908c0d6cb321887$export$a5d3c27355e35910(selectState, selectIds),
            selectEntities: selectGlobalizedEntities,
            selectAll: $7908c0d6cb321887$export$a5d3c27355e35910(selectState, selectAll),
            selectTotal: $7908c0d6cb321887$export$a5d3c27355e35910(selectState, selectTotal),
            selectById: $7908c0d6cb321887$export$a5d3c27355e35910(selectGlobalizedEntities, selectId, selectById)
        };
    }
    return {
        getSelectors: getSelectors
    };
}
function $7908c0d6cb321887$var$createSingleArgumentStateOperator(mutator) {
    var operator = $7908c0d6cb321887$var$createStateOperator(function(_, state) {
        return mutator(state);
    });
    return function operation(state) {
        return operator(state, void 0);
    };
}
function $7908c0d6cb321887$var$createStateOperator(mutator) {
    return function operation(state, arg) {
        function isPayloadActionArgument(arg2) {
            return $7908c0d6cb321887$export$ebd532f9034651f3(arg2);
        }
        var runMutator = function(draft) {
            if (isPayloadActionArgument(arg)) mutator(arg.payload, draft);
            else mutator(arg, draft);
        };
        if ((0, $241418c3f336c28b$export$541ac630993a4c84)(state)) {
            runMutator(state);
            return state;
        } else return (0, $241418c3f336c28b$export$2e2bcd8739ae039)(state, runMutator);
    };
}
// src/entities/utils.ts
function $7908c0d6cb321887$var$selectIdValue(entity, selectId) {
    var key = selectId(entity);
    return key;
}
function $7908c0d6cb321887$var$ensureEntitiesArray(entities) {
    if (!Array.isArray(entities)) entities = Object.values(entities);
    return entities;
}
function $7908c0d6cb321887$var$splitAddedUpdatedEntities(newEntities, selectId, state) {
    newEntities = $7908c0d6cb321887$var$ensureEntitiesArray(newEntities);
    var added = [];
    var updated = [];
    for(var _i = 0, newEntities_1 = newEntities; _i < newEntities_1.length; _i++){
        var entity = newEntities_1[_i];
        var id = $7908c0d6cb321887$var$selectIdValue(entity, selectId);
        if (id in state.entities) updated.push({
            id: id,
            changes: entity
        });
        else added.push(entity);
    }
    return [
        added,
        updated
    ];
}
// src/entities/unsorted_state_adapter.ts
function $7908c0d6cb321887$var$createUnsortedStateAdapter(selectId) {
    function addOneMutably(entity, state) {
        var key = $7908c0d6cb321887$var$selectIdValue(entity, selectId);
        if (key in state.entities) return;
        state.ids.push(key);
        state.entities[key] = entity;
    }
    function addManyMutably(newEntities, state) {
        newEntities = $7908c0d6cb321887$var$ensureEntitiesArray(newEntities);
        for(var _i = 0, newEntities_2 = newEntities; _i < newEntities_2.length; _i++){
            var entity = newEntities_2[_i];
            addOneMutably(entity, state);
        }
    }
    function setOneMutably(entity, state) {
        var key = $7908c0d6cb321887$var$selectIdValue(entity, selectId);
        if (!(key in state.entities)) state.ids.push(key);
        state.entities[key] = entity;
    }
    function setManyMutably(newEntities, state) {
        newEntities = $7908c0d6cb321887$var$ensureEntitiesArray(newEntities);
        for(var _i = 0, newEntities_3 = newEntities; _i < newEntities_3.length; _i++){
            var entity = newEntities_3[_i];
            setOneMutably(entity, state);
        }
    }
    function setAllMutably(newEntities, state) {
        newEntities = $7908c0d6cb321887$var$ensureEntitiesArray(newEntities);
        state.ids = [];
        state.entities = {};
        addManyMutably(newEntities, state);
    }
    function removeOneMutably(key, state) {
        return removeManyMutably([
            key
        ], state);
    }
    function removeManyMutably(keys, state) {
        var didMutate = false;
        keys.forEach(function(key) {
            if (key in state.entities) {
                delete state.entities[key];
                didMutate = true;
            }
        });
        if (didMutate) state.ids = state.ids.filter(function(id) {
            return id in state.entities;
        });
    }
    function removeAllMutably(state) {
        Object.assign(state, {
            ids: [],
            entities: {}
        });
    }
    function takeNewKey(keys, update, state) {
        var original2 = state.entities[update.id];
        var updated = Object.assign({}, original2, update.changes);
        var newKey = $7908c0d6cb321887$var$selectIdValue(updated, selectId);
        var hasNewKey = newKey !== update.id;
        if (hasNewKey) {
            keys[update.id] = newKey;
            delete state.entities[update.id];
        }
        state.entities[newKey] = updated;
        return hasNewKey;
    }
    function updateOneMutably(update, state) {
        return updateManyMutably([
            update
        ], state);
    }
    function updateManyMutably(updates, state) {
        var newKeys = {};
        var updatesPerEntity = {};
        updates.forEach(function(update) {
            if (update.id in state.entities) updatesPerEntity[update.id] = {
                id: update.id,
                changes: $7908c0d6cb321887$var$__spreadValues($7908c0d6cb321887$var$__spreadValues({}, updatesPerEntity[update.id] ? updatesPerEntity[update.id].changes : null), update.changes)
            };
        });
        updates = Object.values(updatesPerEntity);
        var didMutateEntities = updates.length > 0;
        if (didMutateEntities) {
            var didMutateIds = updates.filter(function(update) {
                return takeNewKey(newKeys, update, state);
            }).length > 0;
            if (didMutateIds) state.ids = Object.keys(state.entities);
        }
    }
    function upsertOneMutably(entity, state) {
        return upsertManyMutably([
            entity
        ], state);
    }
    function upsertManyMutably(newEntities, state) {
        var _c = $7908c0d6cb321887$var$splitAddedUpdatedEntities(newEntities, selectId, state), added = _c[0], updated = _c[1];
        updateManyMutably(updated, state);
        addManyMutably(added, state);
    }
    return {
        removeAll: $7908c0d6cb321887$var$createSingleArgumentStateOperator(removeAllMutably),
        addOne: $7908c0d6cb321887$var$createStateOperator(addOneMutably),
        addMany: $7908c0d6cb321887$var$createStateOperator(addManyMutably),
        setOne: $7908c0d6cb321887$var$createStateOperator(setOneMutably),
        setMany: $7908c0d6cb321887$var$createStateOperator(setManyMutably),
        setAll: $7908c0d6cb321887$var$createStateOperator(setAllMutably),
        updateOne: $7908c0d6cb321887$var$createStateOperator(updateOneMutably),
        updateMany: $7908c0d6cb321887$var$createStateOperator(updateManyMutably),
        upsertOne: $7908c0d6cb321887$var$createStateOperator(upsertOneMutably),
        upsertMany: $7908c0d6cb321887$var$createStateOperator(upsertManyMutably),
        removeOne: $7908c0d6cb321887$var$createStateOperator(removeOneMutably),
        removeMany: $7908c0d6cb321887$var$createStateOperator(removeManyMutably)
    };
}
// src/entities/sorted_state_adapter.ts
function $7908c0d6cb321887$var$createSortedStateAdapter(selectId, sort) {
    var _c = $7908c0d6cb321887$var$createUnsortedStateAdapter(selectId), removeOne = _c.removeOne, removeMany = _c.removeMany, removeAll = _c.removeAll;
    function addOneMutably(entity, state) {
        return addManyMutably([
            entity
        ], state);
    }
    function addManyMutably(newEntities, state) {
        newEntities = $7908c0d6cb321887$var$ensureEntitiesArray(newEntities);
        var models = newEntities.filter(function(model) {
            return !($7908c0d6cb321887$var$selectIdValue(model, selectId) in state.entities);
        });
        if (models.length !== 0) merge(models, state);
    }
    function setOneMutably(entity, state) {
        return setManyMutably([
            entity
        ], state);
    }
    function setManyMutably(newEntities, state) {
        newEntities = $7908c0d6cb321887$var$ensureEntitiesArray(newEntities);
        if (newEntities.length !== 0) merge(newEntities, state);
    }
    function setAllMutably(newEntities, state) {
        newEntities = $7908c0d6cb321887$var$ensureEntitiesArray(newEntities);
        state.entities = {};
        state.ids = [];
        addManyMutably(newEntities, state);
    }
    function updateOneMutably(update, state) {
        return updateManyMutably([
            update
        ], state);
    }
    function updateManyMutably(updates, state) {
        var appliedUpdates = false;
        for(var _i = 0, updates_1 = updates; _i < updates_1.length; _i++){
            var update = updates_1[_i];
            var entity = state.entities[update.id];
            if (!entity) continue;
            appliedUpdates = true;
            Object.assign(entity, update.changes);
            var newId = selectId(entity);
            if (update.id !== newId) {
                delete state.entities[update.id];
                state.entities[newId] = entity;
            }
        }
        if (appliedUpdates) resortEntities(state);
    }
    function upsertOneMutably(entity, state) {
        return upsertManyMutably([
            entity
        ], state);
    }
    function upsertManyMutably(newEntities, state) {
        var _c = $7908c0d6cb321887$var$splitAddedUpdatedEntities(newEntities, selectId, state), added = _c[0], updated = _c[1];
        updateManyMutably(updated, state);
        addManyMutably(added, state);
    }
    function areArraysEqual(a, b) {
        if (a.length !== b.length) return false;
        for(var i = 0; i < a.length && i < b.length; i++){
            if (a[i] === b[i]) continue;
            return false;
        }
        return true;
    }
    function merge(models, state) {
        models.forEach(function(model) {
            state.entities[selectId(model)] = model;
        });
        resortEntities(state);
    }
    function resortEntities(state) {
        var allEntities = Object.values(state.entities);
        allEntities.sort(sort);
        var newSortedIds = allEntities.map(selectId);
        var ids = state.ids;
        if (!areArraysEqual(ids, newSortedIds)) state.ids = newSortedIds;
    }
    return {
        removeOne: removeOne,
        removeMany: removeMany,
        removeAll: removeAll,
        addOne: $7908c0d6cb321887$var$createStateOperator(addOneMutably),
        updateOne: $7908c0d6cb321887$var$createStateOperator(updateOneMutably),
        upsertOne: $7908c0d6cb321887$var$createStateOperator(upsertOneMutably),
        setOne: $7908c0d6cb321887$var$createStateOperator(setOneMutably),
        setMany: $7908c0d6cb321887$var$createStateOperator(setManyMutably),
        setAll: $7908c0d6cb321887$var$createStateOperator(setAllMutably),
        addMany: $7908c0d6cb321887$var$createStateOperator(addManyMutably),
        updateMany: $7908c0d6cb321887$var$createStateOperator(updateManyMutably),
        upsertMany: $7908c0d6cb321887$var$createStateOperator(upsertManyMutably)
    };
}
// src/entities/create_adapter.ts
function $7908c0d6cb321887$export$abcf4037b41e0df(options) {
    if (options === void 0) options = {};
    var _c = $7908c0d6cb321887$var$__spreadValues({
        sortComparer: false,
        selectId: function(instance) {
            return instance.id;
        }
    }, options), selectId = _c.selectId, sortComparer = _c.sortComparer;
    var stateFactory = $7908c0d6cb321887$var$createInitialStateFactory();
    var selectorsFactory = $7908c0d6cb321887$var$createSelectorsFactory();
    var stateAdapter = sortComparer ? $7908c0d6cb321887$var$createSortedStateAdapter(selectId, sortComparer) : $7908c0d6cb321887$var$createUnsortedStateAdapter(selectId);
    return $7908c0d6cb321887$var$__spreadValues($7908c0d6cb321887$var$__spreadValues($7908c0d6cb321887$var$__spreadValues({
        selectId: selectId,
        sortComparer: sortComparer
    }, stateFactory), selectorsFactory), stateAdapter);
}
// src/nanoid.ts
var $7908c0d6cb321887$var$urlAlphabet = "ModuleSymbhasOwnPr-0123456789ABCDEFGHNRVfgctiUvz_KqYTJkLxpZXIjQW";
var $7908c0d6cb321887$export$ac4959f4f1338dfc = function(size) {
    if (size === void 0) size = 21;
    var id = "";
    var i = size;
    while(i--)id += $7908c0d6cb321887$var$urlAlphabet[Math.random() * 64 | 0];
    return id;
};
// src/createAsyncThunk.ts
var $7908c0d6cb321887$var$commonProperties = [
    "name",
    "message",
    "stack",
    "code"
];
var $7908c0d6cb321887$var$RejectWithValue = /** @class */ function() {
    function RejectWithValue(payload, meta) {
        this.payload = payload;
        this.meta = meta;
    }
    return RejectWithValue;
}();
var $7908c0d6cb321887$var$FulfillWithMeta = /** @class */ function() {
    function FulfillWithMeta(payload, meta) {
        this.payload = payload;
        this.meta = meta;
    }
    return FulfillWithMeta;
}();
var $7908c0d6cb321887$export$c97c53d0b2d5d81e = function(value) {
    if (typeof value === "object" && value !== null) {
        var simpleError = {};
        for(var _i = 0, commonProperties_1 = $7908c0d6cb321887$var$commonProperties; _i < commonProperties_1.length; _i++){
            var property = commonProperties_1[_i];
            if (typeof value[property] === "string") simpleError[property] = value[property];
        }
        return simpleError;
    }
    return {
        message: String(value)
    };
};
var $7908c0d6cb321887$export$6abd22dc03e5063f = function() {
    function createAsyncThunk2(typePrefix, payloadCreator, options) {
        var fulfilled = $7908c0d6cb321887$export$309c7a02b0b0bc62(typePrefix + "/fulfilled", function(payload, requestId, arg, meta) {
            return {
                payload: payload,
                meta: $7908c0d6cb321887$var$__spreadProps($7908c0d6cb321887$var$__spreadValues({}, meta || {}), {
                    arg: arg,
                    requestId: requestId,
                    requestStatus: "fulfilled"
                })
            };
        });
        var pending = $7908c0d6cb321887$export$309c7a02b0b0bc62(typePrefix + "/pending", function(requestId, arg, meta) {
            return {
                payload: void 0,
                meta: $7908c0d6cb321887$var$__spreadProps($7908c0d6cb321887$var$__spreadValues({}, meta || {}), {
                    arg: arg,
                    requestId: requestId,
                    requestStatus: "pending"
                })
            };
        });
        var rejected = $7908c0d6cb321887$export$309c7a02b0b0bc62(typePrefix + "/rejected", function(error, requestId, arg, payload, meta) {
            return {
                payload: payload,
                error: (options && options.serializeError || $7908c0d6cb321887$export$c97c53d0b2d5d81e)(error || "Rejected"),
                meta: $7908c0d6cb321887$var$__spreadProps($7908c0d6cb321887$var$__spreadValues({}, meta || {}), {
                    arg: arg,
                    requestId: requestId,
                    rejectedWithValue: !!payload,
                    requestStatus: "rejected",
                    aborted: (error == null ? void 0 : error.name) === "AbortError",
                    condition: (error == null ? void 0 : error.name) === "ConditionError"
                })
            };
        });
        var displayedWarning = false;
        var AC = typeof AbortController !== "undefined" ? AbortController : /** @class */ function() {
            function class_1() {
                this.signal = {
                    aborted: false,
                    addEventListener: function() {},
                    dispatchEvent: function() {
                        return false;
                    },
                    onabort: function() {},
                    removeEventListener: function() {},
                    reason: void 0,
                    throwIfAborted: function() {}
                };
            }
            class_1.prototype.abort = function() {};
            return class_1;
        }();
        function actionCreator(arg) {
            return function(dispatch, getState, extra) {
                var requestId = (options == null ? void 0 : options.idGenerator) ? options.idGenerator(arg) : $7908c0d6cb321887$export$ac4959f4f1338dfc();
                var abortController = new AC();
                var abortReason;
                var started = false;
                function abort(reason) {
                    abortReason = reason;
                    abortController.abort();
                }
                var promise2 = function() {
                    return $7908c0d6cb321887$var$__async(this, null, function() {
                        var _a, _b, finalAction, conditionResult, abortedPromise, err_1, skipDispatch;
                        return $7908c0d6cb321887$var$__generator(this, function(_c) {
                            switch(_c.label){
                                case 0:
                                    _c.trys.push([
                                        0,
                                        4,
                                        ,
                                        5
                                    ]);
                                    conditionResult = (_a = options == null ? void 0 : options.condition) == null ? void 0 : _a.call(options, arg, {
                                        getState: getState,
                                        extra: extra
                                    });
                                    if (!$7908c0d6cb321887$var$isThenable(conditionResult)) return [
                                        3 /*break*/ ,
                                        2
                                    ];
                                    return [
                                        4 /*yield*/ ,
                                        conditionResult
                                    ];
                                case 1:
                                    conditionResult = _c.sent();
                                    _c.label = 2;
                                case 2:
                                    if (conditionResult === false || abortController.signal.aborted) throw {
                                        name: "ConditionError",
                                        message: "Aborted due to condition callback returning false."
                                    };
                                    started = true;
                                    abortedPromise = new Promise(function(_, reject) {
                                        return abortController.signal.addEventListener("abort", function() {
                                            return reject({
                                                name: "AbortError",
                                                message: abortReason || "Aborted"
                                            });
                                        });
                                    });
                                    dispatch(pending(requestId, arg, (_b = options == null ? void 0 : options.getPendingMeta) == null ? void 0 : _b.call(options, {
                                        requestId: requestId,
                                        arg: arg
                                    }, {
                                        getState: getState,
                                        extra: extra
                                    })));
                                    return [
                                        4 /*yield*/ ,
                                        Promise.race([
                                            abortedPromise,
                                            Promise.resolve(payloadCreator(arg, {
                                                dispatch: dispatch,
                                                getState: getState,
                                                extra: extra,
                                                requestId: requestId,
                                                signal: abortController.signal,
                                                abort: abort,
                                                rejectWithValue: function(value, meta) {
                                                    return new $7908c0d6cb321887$var$RejectWithValue(value, meta);
                                                },
                                                fulfillWithValue: function(value, meta) {
                                                    return new $7908c0d6cb321887$var$FulfillWithMeta(value, meta);
                                                }
                                            })).then(function(result) {
                                                if (result instanceof $7908c0d6cb321887$var$RejectWithValue) throw result;
                                                if (result instanceof $7908c0d6cb321887$var$FulfillWithMeta) return fulfilled(result.payload, requestId, arg, result.meta);
                                                return fulfilled(result, requestId, arg);
                                            })
                                        ])
                                    ];
                                case 3:
                                    finalAction = _c.sent();
                                    return [
                                        3 /*break*/ ,
                                        5
                                    ];
                                case 4:
                                    err_1 = _c.sent();
                                    finalAction = err_1 instanceof $7908c0d6cb321887$var$RejectWithValue ? rejected(null, requestId, arg, err_1.payload, err_1.meta) : rejected(err_1, requestId, arg);
                                    return [
                                        3 /*break*/ ,
                                        5
                                    ];
                                case 5:
                                    skipDispatch = options && !options.dispatchConditionRejection && rejected.match(finalAction) && finalAction.meta.condition;
                                    if (!skipDispatch) dispatch(finalAction);
                                    return [
                                        2 /*return*/ ,
                                        finalAction
                                    ];
                            }
                        });
                    });
                }();
                return Object.assign(promise2, {
                    abort: abort,
                    requestId: requestId,
                    arg: arg,
                    unwrap: function() {
                        return promise2.then($7908c0d6cb321887$export$5b28227b4c5dc983);
                    }
                });
            };
        }
        return Object.assign(actionCreator, {
            pending: pending,
            rejected: rejected,
            fulfilled: fulfilled,
            typePrefix: typePrefix
        });
    }
    createAsyncThunk2.withTypes = function() {
        return createAsyncThunk2;
    };
    return createAsyncThunk2;
}();
function $7908c0d6cb321887$export$5b28227b4c5dc983(action) {
    if (action.meta && action.meta.rejectedWithValue) throw action.payload;
    if (action.error) throw action.error;
    return action.payload;
}
function $7908c0d6cb321887$var$isThenable(value) {
    return value !== null && typeof value === "object" && typeof value.then === "function";
}
// src/tsHelpers.ts
var $7908c0d6cb321887$var$hasMatchFunction = function(v) {
    return v && typeof v.match === "function";
};
// src/matchers.ts
var $7908c0d6cb321887$var$matches = function(matcher, action) {
    if ($7908c0d6cb321887$var$hasMatchFunction(matcher)) return matcher.match(action);
    else return matcher(action);
};
function $7908c0d6cb321887$export$2c3435c7647f7b0d() {
    var matchers = [];
    for(var _i = 0; _i < arguments.length; _i++)matchers[_i] = arguments[_i];
    return function(action) {
        return matchers.some(function(matcher) {
            return $7908c0d6cb321887$var$matches(matcher, action);
        });
    };
}
function $7908c0d6cb321887$export$9dd1fb32974da385() {
    var matchers = [];
    for(var _i = 0; _i < arguments.length; _i++)matchers[_i] = arguments[_i];
    return function(action) {
        return matchers.every(function(matcher) {
            return $7908c0d6cb321887$var$matches(matcher, action);
        });
    };
}
function $7908c0d6cb321887$var$hasExpectedRequestMetadata(action, validStatus) {
    if (!action || !action.meta) return false;
    var hasValidRequestId = typeof action.meta.requestId === "string";
    var hasValidRequestStatus = validStatus.indexOf(action.meta.requestStatus) > -1;
    return hasValidRequestId && hasValidRequestStatus;
}
function $7908c0d6cb321887$var$isAsyncThunkArray(a) {
    return typeof a[0] === "function" && "pending" in a[0] && "fulfilled" in a[0] && "rejected" in a[0];
}
function $7908c0d6cb321887$export$872dec21e9a69476() {
    var asyncThunks = [];
    for(var _i = 0; _i < arguments.length; _i++)asyncThunks[_i] = arguments[_i];
    if (asyncThunks.length === 0) return function(action) {
        return $7908c0d6cb321887$var$hasExpectedRequestMetadata(action, [
            "pending"
        ]);
    };
    if (!$7908c0d6cb321887$var$isAsyncThunkArray(asyncThunks)) return $7908c0d6cb321887$export$872dec21e9a69476()(asyncThunks[0]);
    return function(action) {
        var matchers = asyncThunks.map(function(asyncThunk) {
            return asyncThunk.pending;
        });
        var combinedMatcher = $7908c0d6cb321887$export$2c3435c7647f7b0d.apply(void 0, matchers);
        return combinedMatcher(action);
    };
}
function $7908c0d6cb321887$export$a5c5d27e3994c5be() {
    var asyncThunks = [];
    for(var _i = 0; _i < arguments.length; _i++)asyncThunks[_i] = arguments[_i];
    if (asyncThunks.length === 0) return function(action) {
        return $7908c0d6cb321887$var$hasExpectedRequestMetadata(action, [
            "rejected"
        ]);
    };
    if (!$7908c0d6cb321887$var$isAsyncThunkArray(asyncThunks)) return $7908c0d6cb321887$export$a5c5d27e3994c5be()(asyncThunks[0]);
    return function(action) {
        var matchers = asyncThunks.map(function(asyncThunk) {
            return asyncThunk.rejected;
        });
        var combinedMatcher = $7908c0d6cb321887$export$2c3435c7647f7b0d.apply(void 0, matchers);
        return combinedMatcher(action);
    };
}
function $7908c0d6cb321887$export$fcc3388fb56de601() {
    var asyncThunks = [];
    for(var _i = 0; _i < arguments.length; _i++)asyncThunks[_i] = arguments[_i];
    var hasFlag = function(action) {
        return action && action.meta && action.meta.rejectedWithValue;
    };
    if (asyncThunks.length === 0) return function(action) {
        var combinedMatcher = $7908c0d6cb321887$export$9dd1fb32974da385($7908c0d6cb321887$export$a5c5d27e3994c5be.apply(void 0, asyncThunks), hasFlag);
        return combinedMatcher(action);
    };
    if (!$7908c0d6cb321887$var$isAsyncThunkArray(asyncThunks)) return $7908c0d6cb321887$export$fcc3388fb56de601()(asyncThunks[0]);
    return function(action) {
        var combinedMatcher = $7908c0d6cb321887$export$9dd1fb32974da385($7908c0d6cb321887$export$a5c5d27e3994c5be.apply(void 0, asyncThunks), hasFlag);
        return combinedMatcher(action);
    };
}
function $7908c0d6cb321887$export$1da80a6ef1307441() {
    var asyncThunks = [];
    for(var _i = 0; _i < arguments.length; _i++)asyncThunks[_i] = arguments[_i];
    if (asyncThunks.length === 0) return function(action) {
        return $7908c0d6cb321887$var$hasExpectedRequestMetadata(action, [
            "fulfilled"
        ]);
    };
    if (!$7908c0d6cb321887$var$isAsyncThunkArray(asyncThunks)) return $7908c0d6cb321887$export$1da80a6ef1307441()(asyncThunks[0]);
    return function(action) {
        var matchers = asyncThunks.map(function(asyncThunk) {
            return asyncThunk.fulfilled;
        });
        var combinedMatcher = $7908c0d6cb321887$export$2c3435c7647f7b0d.apply(void 0, matchers);
        return combinedMatcher(action);
    };
}
function $7908c0d6cb321887$export$6aa4142d99c1abce() {
    var asyncThunks = [];
    for(var _i = 0; _i < arguments.length; _i++)asyncThunks[_i] = arguments[_i];
    if (asyncThunks.length === 0) return function(action) {
        return $7908c0d6cb321887$var$hasExpectedRequestMetadata(action, [
            "pending",
            "fulfilled",
            "rejected"
        ]);
    };
    if (!$7908c0d6cb321887$var$isAsyncThunkArray(asyncThunks)) return $7908c0d6cb321887$export$6aa4142d99c1abce()(asyncThunks[0]);
    return function(action) {
        var matchers = [];
        for(var _i = 0, asyncThunks_1 = asyncThunks; _i < asyncThunks_1.length; _i++){
            var asyncThunk = asyncThunks_1[_i];
            matchers.push(asyncThunk.pending, asyncThunk.rejected, asyncThunk.fulfilled);
        }
        var combinedMatcher = $7908c0d6cb321887$export$2c3435c7647f7b0d.apply(void 0, matchers);
        return combinedMatcher(action);
    };
}
// src/listenerMiddleware/utils.ts
var $7908c0d6cb321887$var$assertFunction = function(func, expected) {
    if (typeof func !== "function") throw new TypeError(expected + " is not a function");
};
var $7908c0d6cb321887$var$noop = function() {};
var $7908c0d6cb321887$var$catchRejection = function(promise2, onError) {
    if (onError === void 0) onError = $7908c0d6cb321887$var$noop;
    promise2.catch(onError);
    return promise2;
};
var $7908c0d6cb321887$var$addAbortSignalListener = function(abortSignal, callback) {
    abortSignal.addEventListener("abort", callback, {
        once: true
    });
    return function() {
        return abortSignal.removeEventListener("abort", callback);
    };
};
var $7908c0d6cb321887$var$abortControllerWithReason = function(abortController, reason) {
    var signal = abortController.signal;
    if (signal.aborted) return;
    if (!("reason" in signal)) Object.defineProperty(signal, "reason", {
        enumerable: true,
        value: reason,
        configurable: true,
        writable: true
    });
    abortController.abort(reason);
};
// src/listenerMiddleware/exceptions.ts
var $7908c0d6cb321887$var$task = "task";
var $7908c0d6cb321887$var$listener = "listener";
var $7908c0d6cb321887$var$completed = "completed";
var $7908c0d6cb321887$var$cancelled = "cancelled";
var $7908c0d6cb321887$var$taskCancelled = "task-" + $7908c0d6cb321887$var$cancelled;
var $7908c0d6cb321887$var$taskCompleted = "task-" + $7908c0d6cb321887$var$completed;
var $7908c0d6cb321887$var$listenerCancelled = $7908c0d6cb321887$var$listener + "-" + $7908c0d6cb321887$var$cancelled;
var $7908c0d6cb321887$var$listenerCompleted = $7908c0d6cb321887$var$listener + "-" + $7908c0d6cb321887$var$completed;
var $7908c0d6cb321887$export$cb1bdac908fed7f = /** @class */ function() {
    function TaskAbortError(code) {
        this.code = code;
        this.name = "TaskAbortError";
        this.message = $7908c0d6cb321887$var$task + " " + $7908c0d6cb321887$var$cancelled + " (reason: " + code + ")";
    }
    return TaskAbortError;
}();
// src/listenerMiddleware/task.ts
var $7908c0d6cb321887$var$validateActive = function(signal) {
    if (signal.aborted) throw new $7908c0d6cb321887$export$cb1bdac908fed7f(signal.reason);
};
function $7908c0d6cb321887$var$raceWithSignal(signal, promise2) {
    var cleanup = $7908c0d6cb321887$var$noop;
    return new Promise(function(resolve, reject) {
        var notifyRejection = function() {
            return reject(new $7908c0d6cb321887$export$cb1bdac908fed7f(signal.reason));
        };
        if (signal.aborted) {
            notifyRejection();
            return;
        }
        cleanup = $7908c0d6cb321887$var$addAbortSignalListener(signal, notifyRejection);
        promise2.finally(function() {
            return cleanup();
        }).then(resolve, reject);
    }).finally(function() {
        cleanup = $7908c0d6cb321887$var$noop;
    });
}
var $7908c0d6cb321887$var$runTask = function(task2, cleanUp) {
    return $7908c0d6cb321887$var$__async(void 0, null, function() {
        var value, error_1;
        return $7908c0d6cb321887$var$__generator(this, function(_c) {
            switch(_c.label){
                case 0:
                    _c.trys.push([
                        0,
                        3,
                        4,
                        5
                    ]);
                    return [
                        4 /*yield*/ ,
                        Promise.resolve()
                    ];
                case 1:
                    _c.sent();
                    return [
                        4 /*yield*/ ,
                        task2()
                    ];
                case 2:
                    value = _c.sent();
                    return [
                        2 /*return*/ ,
                        {
                            status: "ok",
                            value: value
                        }
                    ];
                case 3:
                    error_1 = _c.sent();
                    return [
                        2 /*return*/ ,
                        {
                            status: error_1 instanceof $7908c0d6cb321887$export$cb1bdac908fed7f ? "cancelled" : "rejected",
                            error: error_1
                        }
                    ];
                case 4:
                    cleanUp == null || cleanUp();
                    return [
                        7 /*endfinally*/ 
                    ];
                case 5:
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    });
};
var $7908c0d6cb321887$var$createPause = function(signal) {
    return function(promise2) {
        return $7908c0d6cb321887$var$catchRejection($7908c0d6cb321887$var$raceWithSignal(signal, promise2).then(function(output) {
            $7908c0d6cb321887$var$validateActive(signal);
            return output;
        }));
    };
};
var $7908c0d6cb321887$var$createDelay = function(signal) {
    var pause = $7908c0d6cb321887$var$createPause(signal);
    return function(timeoutMs) {
        return pause(new Promise(function(resolve) {
            return setTimeout(resolve, timeoutMs);
        }));
    };
};
// src/listenerMiddleware/index.ts
var $7908c0d6cb321887$var$assign = Object.assign;
var $7908c0d6cb321887$var$INTERNAL_NIL_TOKEN = {};
var $7908c0d6cb321887$var$alm = "listenerMiddleware";
var $7908c0d6cb321887$var$createFork = function(parentAbortSignal) {
    var linkControllers = function(controller) {
        return $7908c0d6cb321887$var$addAbortSignalListener(parentAbortSignal, function() {
            return $7908c0d6cb321887$var$abortControllerWithReason(controller, parentAbortSignal.reason);
        });
    };
    return function(taskExecutor) {
        $7908c0d6cb321887$var$assertFunction(taskExecutor, "taskExecutor");
        var childAbortController = new AbortController();
        linkControllers(childAbortController);
        var result = $7908c0d6cb321887$var$runTask(function() {
            return $7908c0d6cb321887$var$__async(void 0, null, function() {
                var result2;
                return $7908c0d6cb321887$var$__generator(this, function(_c) {
                    switch(_c.label){
                        case 0:
                            $7908c0d6cb321887$var$validateActive(parentAbortSignal);
                            $7908c0d6cb321887$var$validateActive(childAbortController.signal);
                            return [
                                4 /*yield*/ ,
                                taskExecutor({
                                    pause: $7908c0d6cb321887$var$createPause(childAbortController.signal),
                                    delay: $7908c0d6cb321887$var$createDelay(childAbortController.signal),
                                    signal: childAbortController.signal
                                })
                            ];
                        case 1:
                            result2 = _c.sent();
                            $7908c0d6cb321887$var$validateActive(childAbortController.signal);
                            return [
                                2 /*return*/ ,
                                result2
                            ];
                    }
                });
            });
        }, function() {
            return $7908c0d6cb321887$var$abortControllerWithReason(childAbortController, $7908c0d6cb321887$var$taskCompleted);
        });
        return {
            result: $7908c0d6cb321887$var$createPause(parentAbortSignal)(result),
            cancel: function() {
                $7908c0d6cb321887$var$abortControllerWithReason(childAbortController, $7908c0d6cb321887$var$taskCancelled);
            }
        };
    };
};
var $7908c0d6cb321887$var$createTakePattern = function(startListening, signal) {
    var take = function(predicate, timeout) {
        return $7908c0d6cb321887$var$__async(void 0, null, function() {
            var unsubscribe, tuplePromise, promises, output;
            return $7908c0d6cb321887$var$__generator(this, function(_c) {
                switch(_c.label){
                    case 0:
                        $7908c0d6cb321887$var$validateActive(signal);
                        unsubscribe = function() {};
                        tuplePromise = new Promise(function(resolve, reject) {
                            var stopListening = startListening({
                                predicate: predicate,
                                effect: function(action, listenerApi) {
                                    listenerApi.unsubscribe();
                                    resolve([
                                        action,
                                        listenerApi.getState(),
                                        listenerApi.getOriginalState()
                                    ]);
                                }
                            });
                            unsubscribe = function() {
                                stopListening();
                                reject();
                            };
                        });
                        promises = [
                            tuplePromise
                        ];
                        if (timeout != null) promises.push(new Promise(function(resolve) {
                            return setTimeout(resolve, timeout, null);
                        }));
                        _c.label = 1;
                    case 1:
                        _c.trys.push([
                            1,
                            ,
                            3,
                            4
                        ]);
                        return [
                            4 /*yield*/ ,
                            $7908c0d6cb321887$var$raceWithSignal(signal, Promise.race(promises))
                        ];
                    case 2:
                        output = _c.sent();
                        $7908c0d6cb321887$var$validateActive(signal);
                        return [
                            2 /*return*/ ,
                            output
                        ];
                    case 3:
                        unsubscribe();
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    return function(predicate, timeout) {
        return $7908c0d6cb321887$var$catchRejection(take(predicate, timeout));
    };
};
var $7908c0d6cb321887$var$getListenerEntryPropsFrom = function(options) {
    var type = options.type, actionCreator = options.actionCreator, matcher = options.matcher, predicate = options.predicate, effect = options.effect;
    if (type) predicate = $7908c0d6cb321887$export$309c7a02b0b0bc62(type).match;
    else if (actionCreator) {
        type = actionCreator.type;
        predicate = actionCreator.match;
    } else if (matcher) predicate = matcher;
    else if (predicate) ;
    else throw new Error("Creating or removing a listener requires one of the known fields for matching an action");
    $7908c0d6cb321887$var$assertFunction(effect, "options.listener");
    return {
        predicate: predicate,
        type: type,
        effect: effect
    };
};
var $7908c0d6cb321887$var$createListenerEntry = function(options) {
    var _c = $7908c0d6cb321887$var$getListenerEntryPropsFrom(options), type = _c.type, predicate = _c.predicate, effect = _c.effect;
    var id = $7908c0d6cb321887$export$ac4959f4f1338dfc();
    var entry = {
        id: id,
        effect: effect,
        type: type,
        predicate: predicate,
        pending: new Set(),
        unsubscribe: function() {
            throw new Error("Unsubscribe not initialized");
        }
    };
    return entry;
};
var $7908c0d6cb321887$var$cancelActiveListeners = function(entry) {
    entry.pending.forEach(function(controller) {
        $7908c0d6cb321887$var$abortControllerWithReason(controller, $7908c0d6cb321887$var$listenerCancelled);
    });
};
var $7908c0d6cb321887$var$createClearListenerMiddleware = function(listenerMap) {
    return function() {
        listenerMap.forEach($7908c0d6cb321887$var$cancelActiveListeners);
        listenerMap.clear();
    };
};
var $7908c0d6cb321887$var$safelyNotifyError = function(errorHandler, errorToNotify, errorInfo) {
    try {
        errorHandler(errorToNotify, errorInfo);
    } catch (errorHandlerError) {
        setTimeout(function() {
            throw errorHandlerError;
        }, 0);
    }
};
var $7908c0d6cb321887$export$f03a6b845d3fb58b = $7908c0d6cb321887$export$309c7a02b0b0bc62($7908c0d6cb321887$var$alm + "/add");
var $7908c0d6cb321887$export$b1b8022855fb2b71 = $7908c0d6cb321887$export$309c7a02b0b0bc62($7908c0d6cb321887$var$alm + "/removeAll");
var $7908c0d6cb321887$export$b03e9483f936dccb = $7908c0d6cb321887$export$309c7a02b0b0bc62($7908c0d6cb321887$var$alm + "/remove");
var $7908c0d6cb321887$var$defaultErrorHandler = function() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    console.error.apply(console, $7908c0d6cb321887$var$__spreadArray([
        $7908c0d6cb321887$var$alm + "/error"
    ], args));
};
function $7908c0d6cb321887$export$1228acebbbcb485b(middlewareOptions) {
    var _this = this;
    if (middlewareOptions === void 0) middlewareOptions = {};
    var listenerMap = new Map();
    var extra = middlewareOptions.extra, _c = middlewareOptions.onError, onError = _c === void 0 ? $7908c0d6cb321887$var$defaultErrorHandler : _c;
    $7908c0d6cb321887$var$assertFunction(onError, "onError");
    var insertEntry = function(entry) {
        entry.unsubscribe = function() {
            return listenerMap.delete(entry.id);
        };
        listenerMap.set(entry.id, entry);
        return function(cancelOptions) {
            entry.unsubscribe();
            if (cancelOptions == null ? void 0 : cancelOptions.cancelActive) $7908c0d6cb321887$var$cancelActiveListeners(entry);
        };
    };
    var findListenerEntry = function(comparator) {
        for(var _i = 0, _c = Array.from(listenerMap.values()); _i < _c.length; _i++){
            var entry = _c[_i];
            if (comparator(entry)) return entry;
        }
        return void 0;
    };
    var startListening = function(options) {
        var entry = findListenerEntry(function(existingEntry) {
            return existingEntry.effect === options.effect;
        });
        if (!entry) entry = $7908c0d6cb321887$var$createListenerEntry(options);
        return insertEntry(entry);
    };
    var stopListening = function(options) {
        var _c = $7908c0d6cb321887$var$getListenerEntryPropsFrom(options), type = _c.type, effect = _c.effect, predicate = _c.predicate;
        var entry = findListenerEntry(function(entry2) {
            var matchPredicateOrType = typeof type === "string" ? entry2.type === type : entry2.predicate === predicate;
            return matchPredicateOrType && entry2.effect === effect;
        });
        if (entry) {
            entry.unsubscribe();
            if (options.cancelActive) $7908c0d6cb321887$var$cancelActiveListeners(entry);
        }
        return !!entry;
    };
    var notifyListener = function(entry, action, api, getOriginalState) {
        return $7908c0d6cb321887$var$__async(_this, null, function() {
            var internalTaskController, take, listenerError_1;
            return $7908c0d6cb321887$var$__generator(this, function(_c) {
                switch(_c.label){
                    case 0:
                        internalTaskController = new AbortController();
                        take = $7908c0d6cb321887$var$createTakePattern(startListening, internalTaskController.signal);
                        _c.label = 1;
                    case 1:
                        _c.trys.push([
                            1,
                            3,
                            4,
                            5
                        ]);
                        entry.pending.add(internalTaskController);
                        return [
                            4 /*yield*/ ,
                            Promise.resolve(entry.effect(action, $7908c0d6cb321887$var$assign({}, api, {
                                getOriginalState: getOriginalState,
                                condition: function(predicate, timeout) {
                                    return take(predicate, timeout).then(Boolean);
                                },
                                take: take,
                                delay: $7908c0d6cb321887$var$createDelay(internalTaskController.signal),
                                pause: $7908c0d6cb321887$var$createPause(internalTaskController.signal),
                                extra: extra,
                                signal: internalTaskController.signal,
                                fork: $7908c0d6cb321887$var$createFork(internalTaskController.signal),
                                unsubscribe: entry.unsubscribe,
                                subscribe: function() {
                                    listenerMap.set(entry.id, entry);
                                },
                                cancelActiveListeners: function() {
                                    entry.pending.forEach(function(controller, _, set) {
                                        if (controller !== internalTaskController) {
                                            $7908c0d6cb321887$var$abortControllerWithReason(controller, $7908c0d6cb321887$var$listenerCancelled);
                                            set.delete(controller);
                                        }
                                    });
                                }
                            })))
                        ];
                    case 2:
                        _c.sent();
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 3:
                        listenerError_1 = _c.sent();
                        if (!(listenerError_1 instanceof $7908c0d6cb321887$export$cb1bdac908fed7f)) $7908c0d6cb321887$var$safelyNotifyError(onError, listenerError_1, {
                            raisedBy: "effect"
                        });
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 4:
                        $7908c0d6cb321887$var$abortControllerWithReason(internalTaskController, $7908c0d6cb321887$var$listenerCompleted);
                        entry.pending.delete(internalTaskController);
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 5:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    var clearListenerMiddleware = $7908c0d6cb321887$var$createClearListenerMiddleware(listenerMap);
    var middleware = function(api) {
        return function(next) {
            return function(action) {
                if (!$7908c0d6cb321887$export$b956e38827fca970(action)) return next(action);
                if ($7908c0d6cb321887$export$f03a6b845d3fb58b.match(action)) return startListening(action.payload);
                if ($7908c0d6cb321887$export$b1b8022855fb2b71.match(action)) {
                    clearListenerMiddleware();
                    return;
                }
                if ($7908c0d6cb321887$export$b03e9483f936dccb.match(action)) return stopListening(action.payload);
                var originalState = api.getState();
                var getOriginalState = function() {
                    if (originalState === $7908c0d6cb321887$var$INTERNAL_NIL_TOKEN) throw new Error($7908c0d6cb321887$var$alm + ": getOriginalState can only be called synchronously");
                    return originalState;
                };
                var result;
                try {
                    result = next(action);
                    if (listenerMap.size > 0) {
                        var currentState = api.getState();
                        var listenerEntries = Array.from(listenerMap.values());
                        for(var _i = 0, listenerEntries_1 = listenerEntries; _i < listenerEntries_1.length; _i++){
                            var entry = listenerEntries_1[_i];
                            var runListener = false;
                            try {
                                runListener = entry.predicate(action, currentState, originalState);
                            } catch (predicateError) {
                                runListener = false;
                                $7908c0d6cb321887$var$safelyNotifyError(onError, predicateError, {
                                    raisedBy: "predicate"
                                });
                            }
                            if (!runListener) continue;
                            notifyListener(entry, action, api, getOriginalState);
                        }
                    }
                } finally{
                    originalState = $7908c0d6cb321887$var$INTERNAL_NIL_TOKEN;
                }
                return result;
            };
        };
    };
    return {
        middleware: middleware,
        startListening: startListening,
        stopListening: stopListening,
        clearListeners: clearListenerMiddleware
    };
}
// src/autoBatchEnhancer.ts
var $7908c0d6cb321887$export$8fb31c0f05df007b = "RTK_autoBatch";
var $7908c0d6cb321887$export$39fcd5145ec5e4e2 = function() {
    return function(payload) {
        var _c;
        return {
            payload: payload,
            meta: (_c = {}, _c[$7908c0d6cb321887$export$8fb31c0f05df007b] = true, _c)
        };
    };
};
var $7908c0d6cb321887$var$promise;
var $7908c0d6cb321887$var$queueMicrotaskShim = typeof queueMicrotask === "function" ? queueMicrotask.bind(typeof window !== "undefined" ? window : typeof $parcel$global !== "undefined" ? $parcel$global : globalThis) : function(cb) {
    return ($7908c0d6cb321887$var$promise || ($7908c0d6cb321887$var$promise = Promise.resolve())).then(cb).catch(function(err) {
        return setTimeout(function() {
            throw err;
        }, 0);
    });
};
var $7908c0d6cb321887$var$createQueueWithTimer = function(timeout) {
    return function(notify) {
        setTimeout(notify, timeout);
    };
};
var $7908c0d6cb321887$var$rAF = typeof window !== "undefined" && window.requestAnimationFrame ? window.requestAnimationFrame : $7908c0d6cb321887$var$createQueueWithTimer(10);
var $7908c0d6cb321887$export$676277d7dca0f396 = function(options) {
    if (options === void 0) options = {
        type: "raf"
    };
    return function(next) {
        return function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            var store = next.apply(void 0, args);
            var notifying = true;
            var shouldNotifyAtEndOfTick = false;
            var notificationQueued = false;
            var listeners = new Set();
            var queueCallback = options.type === "tick" ? $7908c0d6cb321887$var$queueMicrotaskShim : options.type === "raf" ? $7908c0d6cb321887$var$rAF : options.type === "callback" ? options.queueNotification : $7908c0d6cb321887$var$createQueueWithTimer(options.timeout);
            var notifyListeners = function() {
                notificationQueued = false;
                if (shouldNotifyAtEndOfTick) {
                    shouldNotifyAtEndOfTick = false;
                    listeners.forEach(function(l) {
                        return l();
                    });
                }
            };
            return Object.assign({}, store, {
                subscribe: function(listener2) {
                    var wrappedListener = function() {
                        return notifying && listener2();
                    };
                    var unsubscribe = store.subscribe(wrappedListener);
                    listeners.add(listener2);
                    return function() {
                        unsubscribe();
                        listeners.delete(listener2);
                    };
                },
                dispatch: function(action) {
                    var _a;
                    try {
                        notifying = !((_a = action == null ? void 0 : action.meta) == null ? void 0 : _a[$7908c0d6cb321887$export$8fb31c0f05df007b]);
                        shouldNotifyAtEndOfTick = !notifying;
                        if (shouldNotifyAtEndOfTick) {
                            if (!notificationQueued) {
                                notificationQueued = true;
                                queueCallback(notifyListeners);
                            }
                        }
                        return store.dispatch(action);
                    } finally{
                        notifying = true;
                    }
                }
            });
        };
    };
};
// src/index.ts
(0, $241418c3f336c28b$export$56771cf63ee491f5)();



/* eslint-disable prettier/prettier */ const $1ff9b34fabc7ea86$var$$1c4b483bd8e0f582$export$aeae6d33ee4c22ee = "093A49A9-4EF5-4D1D-9BC4-102361C87844";
/* Error codes
0: no error
1: no licence
2: incorrect licence
3: no data for this product
4: outdated licence
*/ // Define the initial state using that type
const $1ff9b34fabc7ea86$var$$993360e742630fa4$var$initialState = {
    value: {
        licence: undefined,
        allowed: false,
        errorCode: 1
    }
};
const $1ff9b34fabc7ea86$var$$993360e742630fa4$export$9bf02b14ad6809a5 = (0, $7908c0d6cb321887$exports.createSlice)({
    name: "licenceSlice",
    initialState: $1ff9b34fabc7ea86$var$$993360e742630fa4$var$initialState,
    reducers: {
        setLicence: (state, action)=>{
            state.value = {
                licence: action.payload,
                allowed: false,
                errorCode: 1
            };
        },
        checkLicence: (state)=>{
            // TODO Decrypt licence
            const decodedLicence = {
                Customer: {
                    Name: "DAVI SAS"
                },
                Vendor: {
                    Name: "DAVI SAS"
                },
                Licences: [
                    {
                        productid: "093A49A9-4EF5-4D1D-9BC4-102361C87844",
                        expireAt: "2026-02-18"
                    }
                ]
            };
            // Check licence data validity
            const licence = state.value.licence;
            var errorCode = 0;
            // Check if the fields are present
            !(decodedLicence.Customer && decodedLicence.Customer.Name) && (errorCode = 2);
            !(decodedLicence.Vendor && decodedLicence.Vendor.Name) && (errorCode = 2);
            !decodedLicence.Licences && (errorCode = 2);
            var goodItem = null;
            if (errorCode === 0) {
                decodedLicence.Licences.length === 0 && (errorCode = 3);
                // Check if the product id is the same as the GUID for the SpiritEngineSprite
                goodItem = decodedLicence.Licences.find((item)=>item.productid === $1ff9b34fabc7ea86$var$$1c4b483bd8e0f582$export$aeae6d33ee4c22ee);
                !goodItem && (errorCode = 3);
            }
            if (errorCode === 0) {
                !goodItem?.expireAt && (errorCode = 2);
                // @ts-ignore
                const date = new Date(goodItem.expireAt).getTime();
                const now = Date.now();
                // Check if the timestamp retrieved is a number
                if (isNaN(date)) errorCode = 2;
                else date < now && (errorCode = 4);
            }
            state.value = {
                licence: licence,
                allowed: errorCode === 0 ? true : false,
                errorCode: errorCode
            };
        }
    }
});
const { setLicence: $1ff9b34fabc7ea86$var$$993360e742630fa4$export$5e2c75f54104f5e4, checkLicence: $1ff9b34fabc7ea86$var$$993360e742630fa4$export$bed470be7ed80787 } = $1ff9b34fabc7ea86$var$$993360e742630fa4$export$9bf02b14ad6809a5.actions;
var $1ff9b34fabc7ea86$var$$993360e742630fa4$export$2e2bcd8739ae039 = $1ff9b34fabc7ea86$var$$993360e742630fa4$export$9bf02b14ad6809a5.reducer;
const $1ff9b34fabc7ea86$var$$63565878075adc80$var$store = (0, $7908c0d6cb321887$exports.configureStore)({
    reducer: {
        licenceReducer: $1ff9b34fabc7ea86$var$$993360e742630fa4$export$2e2bcd8739ae039
    }
});
var $1ff9b34fabc7ea86$var$$63565878075adc80$export$2e2bcd8739ae039 = $1ff9b34fabc7ea86$var$$63565878075adc80$var$store;
/* eslint-disable no-unused-vars */ const $1ff9b34fabc7ea86$var$$65f6af6b2b4224a7$var$Video = (0, (/*@__PURE__*/$parcel$interopDefault($eO7Kz))).forwardRef(({ srcMp4: srcMp4, srcWebm: srcWebm, onEnded: onEnded, size: size }, ref)=>{
    return (0, $179ad052de55b86f$exports.jsxs)("video", {
        ref: ref,
        className: "ses-invisible ses-col-start-1 ses-row-start-1 ses-col-span-1 ses-row-span-1 ses-max-w-none ses-self-start ses-justify-self-center ses-object-cover",
        muted: true,
        preload: "auto",
        onEnded: onEnded,
        playsInline: true,
        controls: true,
        style: {
            height: size
        },
        children: [
            (0, $179ad052de55b86f$exports.jsx)("source", {
                src: srcMp4,
                type: 'video/mp4; codecs="hvc1"'
            }),
            (0, $179ad052de55b86f$exports.jsx)("source", {
                src: srcWebm,
                type: "video/webm"
            })
        ]
    });
});
var $1ff9b34fabc7ea86$var$$65f6af6b2b4224a7$export$2e2bcd8739ae039 = $1ff9b34fabc7ea86$var$$65f6af6b2b4224a7$var$Video;
const $1ff9b34fabc7ea86$var$$01c612cb40aac877$var$getRandomInt = (max = 1)=>{
    return Math.ceil(Math.random() * max);
};
const $1ff9b34fabc7ea86$var$$01c612cb40aac877$var$fps = 60;
const $1ff9b34fabc7ea86$var$$01c612cb40aac877$var$Chatbot = ({ agentData: agentData, height: height, size: size, speak: speak, animationQueue: animationQueue, setAnimationQueue: setAnimationQueue })=>{
    const [allowSpeechAnimations, setAllowSpeechAnimations] = (0, $eO7Kz.useState)(true);
    const [speaking, setSpeaking] = (0, $eO7Kz.useState)(speak);
    const [minScreen, setMinScreen] = (0, $eO7Kz.useState)(Math.min(screen.height, screen.width));
    const [moving, setMoving] = (0, $eO7Kz.useState)(true);
    const moveNS = (0, $eO7Kz.useRef)(null);
    const moveSP = (0, $eO7Kz.useRef)(null);
    const stillNS = (0, $eO7Kz.useRef)(null);
    const stillSP = (0, $eO7Kz.useRef)(null);
    const [currentStill, setCurrentStill] = (0, $eO7Kz.useState)("still1");
    const [currentMove, setCurrentMove] = (0, $eO7Kz.useState)("idle1");
    const [queue, setQueue] = (0, $eO7Kz.useState)([]);
    const [idleAndExplainFolder, setIdleAndExplainFolder] = (0, $eO7Kz.useState)("move");
    const [stillFolder, setStillFolder] = (0, $eO7Kz.useState)("still");
    const [trigger, setTrigger] = (0, $eO7Kz.useState)(false);
    const sizeInPx = (0, $eO7Kz.useMemo)(()=>{
        if (size) {
            if (typeof size === "number") return size;
            else {
                console.log(size.slice(-2));
                if (size.slice(-2).toLowerCase() === "vh") {
                    const num = parseInt(size.substring(0, size.length - 2));
                    return isNaN(num) ? window.innerHeight : num * window.innerHeight / 100;
                } else if (size.slice(-1) === "%") {
                    const num = parseInt(size.substring(0, size.length - 1));
                    return isNaN(num) ? window.innerHeight : num * window.innerHeight / 100;
                }
            }
        }
        return window.innerHeight;
    }, [
        size
    ]);
    const videoRef = (0, $eO7Kz.useRef)(null);
    const canvasRef = (0, $eO7Kz.useRef)(null);
    const imageSize = (0, $eO7Kz.useMemo)(()=>{
        const realSize = size || minScreen;
        if (typeof realSize === "number" && realSize < 480) return "small";
        if (typeof realSize === "number" && realSize < 1200) return "medium";
        return "large";
    }, [
        size
    ]);
    // Function to set the minimum between screen height and width to use the right animations
    const detectSize = ()=>{
        setMinScreen(Math.min(screen.height, screen.width));
    };
    (0, $eO7Kz.useEffect)(()=>{
        setSpeaking(allowSpeechAnimations ? speak : false);
    }, [
        speak,
        allowSpeechAnimations
    ]);
    const computeFrame = ()=>{
        let vid = null;
        switch(videoRef.current){
            case "moveNS":
                vid = moveNS.current;
                break;
            case "moveSP":
                vid = moveSP.current;
                break;
            case "stillNS":
                vid = stillNS.current;
                break;
            case "stillSP":
                vid = stillSP.current;
                break;
        }
        const canvas = canvasRef.current;
        if (vid && canvas) {
            const context = canvas.getContext("2d");
            if (context) {
                context.clearRect(0, 0, canvas.width, canvas.height);
                context.drawImage(vid, 0, 0, canvas.width, canvas.height);
            }
        }
    };
    (0, $eO7Kz.useEffect)(()=>{
        const computeCallback = ()=>{
            computeFrame();
            setTimeout(()=>{
                requestAnimationFrame(computeCallback);
            }, 1000 / $1ff9b34fabc7ea86$var$$01c612cb40aac877$var$fps);
        };
        computeCallback();
    }, []);
    (0, $eO7Kz.useEffect)(()=>{
        if (moving) setCurrentStill("still1");
        else if (speaking) setCurrentMove("explain1");
        else setCurrentMove("idle1");
    }, [
        agentData
    ]);
    (0, $eO7Kz.useEffect)(()=>{
        if (animationQueue) {
            if (animationQueue.length === 0) setQueue([]);
            else {
                // Verify if the wanted animations shall exist from the data given in the manifest.json file
                const animationDataArray = checkQueue(animationQueue);
                if (animationDataArray.length > 0) {
                    setQueue(animationDataArray);
                    setTrigger(true);
                }
            }
        }
    }, [
        animationQueue
    ]);
    // Check if each element of the given queue has a match in the data from the manifest.json file loaded
    function checkQueue(queueToCheck) {
        var test = true;
        const dataToReturn = [];
        // Get the defined folders from the manifest
        const keys = agentData ? Object.keys(agentData.data) : [];
        // Parse each item to get an array with the name of the animation and its index
        queueToCheck.forEach((item)=>{
            const data = !isNaN(parseInt(item.substring(item.length - 2))) ? [
                item.substring(0, item.length - 2),
                parseInt(item.substring(item.length - 2))
            ] : !isNaN(parseInt(item.substring(item.length - 1))) ? [
                item.substring(0, item.length - 1),
                parseInt(item.substring(item.length - 1))
            ] : [
                item,
                -1
            ];
            const lowCase = data[0].toLowerCase();
            // Check if the folder exists in the manifest and if the index of the animation is lower than the max one
            if (keys.includes(lowCase) && agentData && agentData.data[lowCase] >= data[1]) dataToReturn.push(data);
            else {
                console.log("Wrong animation wanted : ", item);
                test = false;
            }
        });
        return test ? dataToReturn : [];
    }
    // Switch animation when not in a queue
    function switchAnimation(data) {
        var rand = 0;
        switch(data){
            case "idle":
                setIdleAndExplainFolder("move");
                rand = $1ff9b34fabc7ea86$var$$01c612cb40aac877$var$getRandomInt(agentData?.data.idle);
                break;
            case "explain":
                setIdleAndExplainFolder("move");
                rand = $1ff9b34fabc7ea86$var$$01c612cb40aac877$var$getRandomInt(agentData?.data.explain);
                break;
            case "still":
                setStillFolder("still");
                rand = $1ff9b34fabc7ea86$var$$01c612cb40aac877$var$getRandomInt(agentData?.data.still);
                break;
            default:
                break;
        }
        if (data === "still") {
            if (currentStill === `still${rand}`) rand === 1 ? setCurrentStill("still2") : setCurrentStill(`still${rand - 1}`);
            else setCurrentStill(`still${rand}`);
        } else if (currentMove === `${data}${rand}`) rand === 1 ? setCurrentMove(`${data}2`) : setCurrentMove(`${data}${rand - 1}`);
        else setCurrentMove(`${data}${rand}`);
    }
    // Switch animation when in a queue
    function switchQueue(still) {
        const item = queue[0];
        // Check if we are using an 'Explain' or 'Idle' animation. If so, the folder is 'Move'
        const folder = [
            "explain",
            "idle"
        ].includes(item[0].toLowerCase()) ? "move" : item[0];
        // Check if an animation index has been found. If not, use a random
        const animationToDisplay = item[1] === -1 ? `${item[0]}${$1ff9b34fabc7ea86$var$$01c612cb40aac877$var$getRandomInt(agentData?.data[item[0].toLowerCase()])}` : `${item[0]}${item[1]}`;
        if (still) {
            setStillFolder(folder);
            setCurrentStill(animationToDisplay);
        } else {
            setIdleAndExplainFolder(folder);
            setCurrentMove(animationToDisplay);
        }
        const newQueue = [
            ...queue
        ];
        newQueue.splice(0, 1);
        if (newQueue.length === 0) {
            console.log("Send empty queue");
            setAnimationQueue && setAnimationQueue([]);
        } else setQueue(newQueue);
    }
    // Handle changes of 'moving' and 'speaking' states
    function handleMovingOrSpeaking(movingChanged) {
        if (moving === true) {
            // If the 'moving' constant has changed launch moving animations and switch animations.
            // Either way, only change the displayed animation
            if (movingChanged) {
                moveSP.current && moveSP.current.play().catch((e)=>{
                    e !== null && console.warn(e);
                });
                moveNS.current && moveNS.current.play().catch((e)=>{
                    e !== null && console.warn(e);
                });
                queue.length > 0 ? switchQueue(true) : switchAnimation("still");
            }
            videoRef.current = speaking ? "moveSP" : "moveNS";
        } else {
            if (movingChanged) {
                stillSP.current && stillSP.current.play().catch((e)=>{
                    e !== null && console.warn(e);
                });
                stillNS.current && stillNS.current.play().catch((e)=>{
                    e !== null && console.warn(e);
                });
                if (speaking) queue.length > 0 ? switchQueue(false) : switchAnimation("explain");
                else queue.length > 0 ? switchQueue(false) : switchAnimation("idle");
            }
            videoRef.current = speaking ? "stillSP" : "stillNS";
        }
    }
    (0, $eO7Kz.useEffect)(()=>{
        handleMovingOrSpeaking(true);
    }, [
        moving
    ]);
    (0, $eO7Kz.useEffect)(()=>{
        handleMovingOrSpeaking(false);
    }, [
        speaking
    ]);
    (0, $eO7Kz.useEffect)(()=>{
        if (trigger) {
            switchQueue(!!moving);
            setTrigger(false);
        }
    }, [
        trigger
    ]);
    (0, $eO7Kz.useEffect)(()=>{
        moveNS.current && moveNS.current.load();
        moveSP.current && moveSP.current.load();
    }, [
        currentMove
    ]);
    (0, $eO7Kz.useEffect)(()=>{
        stillSP.current && stillSP.current.load();
        stillNS.current && stillNS.current.load();
    }, [
        currentStill
    ]);
    (0, $eO7Kz.useEffect)(()=>{
        // Add event listener for screen resize to adjust videos size
        window.addEventListener("resize", detectSize);
        window.addEventListener("preventChatbotSpeakAnimationsEvent", ()=>{
            setAllowSpeechAnimations(false);
        });
        window.addEventListener("allowChatbotSpeakAnimationsEvent", ()=>{
            setAllowSpeechAnimations(true);
        });
        window.addEventListener("setSpeaking", (e)=>{
            setSpeaking(e.detail);
        });
        // Event listener handling external calls for playing (used for safari permissions issue)
        window.addEventListener("retorikSpiritEnginePlay", handleExternalCallForPlay);
        setTimeout(()=>{
            moveNS.current && moveNS.current.play().catch((e)=>{
                e !== null && console.warn(e);
            });
            moveSP.current && moveSP.current.play().catch((e)=>{
                e !== null && console.warn(e);
            });
        }, 500);
        return ()=>{
            // Remove event listeners on component unmount
            window.removeEventListener("resize", detectSize);
            window.removeEventListener("preventChatbotSpeakAnimationsEvent", ()=>setAllowSpeechAnimations(false));
            window.removeEventListener("allowChatbotSpeakAnimationsEvent", ()=>setAllowSpeechAnimations(true));
            window.removeEventListener("setSpeaking", (e)=>setSpeaking(e.detail));
            window.removeEventListener("retorikSpiritEnginePlay", handleExternalCallForPlay);
        };
    }, []);
    const handleEnd = ()=>{
        setMoving(!moving);
    };
    const handleAudioEnd = ()=>{
        document.dispatchEvent(new Event("retorikSpiritEngineAudioEnded"));
        setSpeaking(false);
    };
    const handleExternalCallForPlay = ()=>{
        if (moveNS.current && moveSP.current && stillNS.current) {
            if (!(moveNS.current.currentTime > 0 && !moveNS.current.paused && !moveNS.current.ended && moveNS.current.readyState > 2) && !(stillNS.current.currentTime > 0 && !stillNS.current.paused && !stillNS.current.ended && stillNS.current.readyState > 2)) {
                moveNS.current.play().catch((e)=>{
                    e !== null && console.warn(e);
                });
                moveSP.current.play().catch((e)=>{
                    e !== null && console.warn(e);
                });
            }
        }
    };
    return (0, $179ad052de55b86f$exports.jsxs)("div", {
        className: "ses-relative ses-pointer-events-none ses-h-full ses-w-full ses-grid ses-justify-center ses-items-start ses-overflow-hidden",
        id: "retorik-animation",
        children: [
            (0, $179ad052de55b86f$exports.jsx)("audio", {
                id: "spirit-engine-sprite-audio",
                onCanPlayThrough: ()=>setSpeaking(true),
                onEnded: handleAudioEnd,
                onError: handleAudioEnd
            }),
            (0, $179ad052de55b86f$exports.jsx)("canvas", {
                id: "spirit-engine-sprite-canvas",
                className: "ses-col-start-1 ses-row-start-1 ses-col-span-1 ses-row-span-1 ses-max-w-none ses-self-start ses-justify-self-center ses-object-cover",
                ref: canvasRef,
                height: sizeInPx,
                width: sizeInPx,
                style: {
                    marginTop: height || "auto"
                }
            }),
            (0, $179ad052de55b86f$exports.jsx)($1ff9b34fabc7ea86$var$$65f6af6b2b4224a7$export$2e2bcd8739ae039, {
                ref: moveNS,
                onEnded: ()=>{},
                srcMp4: `${agentData?.url}/mp4/${imageSize}/${idleAndExplainFolder}/ns/${currentMove}_ns.mp4`,
                srcWebm: `${agentData?.url}/webm/${imageSize}/${idleAndExplainFolder}/ns/${currentMove}_ns.webm`,
                size: sizeInPx
            }),
            (0, $179ad052de55b86f$exports.jsx)($1ff9b34fabc7ea86$var$$65f6af6b2b4224a7$export$2e2bcd8739ae039, {
                ref: moveSP,
                onEnded: handleEnd,
                srcMp4: `${agentData?.url}/mp4/${imageSize}/${idleAndExplainFolder}/sp/${currentMove}_sp.mp4`,
                srcWebm: `${agentData?.url}/webm/${imageSize}/${idleAndExplainFolder}/sp/${currentMove}_sp.webm`,
                size: sizeInPx
            }),
            (0, $179ad052de55b86f$exports.jsx)($1ff9b34fabc7ea86$var$$65f6af6b2b4224a7$export$2e2bcd8739ae039, {
                ref: stillNS,
                onEnded: ()=>{},
                srcMp4: `${agentData?.url}/mp4/${imageSize}/${stillFolder}/ns/${currentStill}_ns.mp4`,
                srcWebm: `${agentData?.url}/webm/${imageSize}/${stillFolder}/ns/${currentStill}_ns.webm`,
                size: sizeInPx
            }),
            (0, $179ad052de55b86f$exports.jsx)($1ff9b34fabc7ea86$var$$65f6af6b2b4224a7$export$2e2bcd8739ae039, {
                ref: stillSP,
                onEnded: handleEnd,
                srcMp4: `${agentData?.url}/mp4/${imageSize}/${stillFolder}/sp/${currentStill}_sp.mp4`,
                srcWebm: `${agentData?.url}/webm/${imageSize}/${stillFolder}/sp/${currentStill}_sp.webm`,
                size: sizeInPx
            })
        ]
    });
};
var $1ff9b34fabc7ea86$var$$01c612cb40aac877$export$2e2bcd8739ae039 = $1ff9b34fabc7ea86$var$$01c612cb40aac877$var$Chatbot;
const $1ff9b34fabc7ea86$var$$5ad02cede29c1661$var$Loader = (props)=>{
    const [message, setMessage] = (0, $eO7Kz.useState)();
    (0, $eO7Kz.useEffect)(()=>{
        switch(props.errorCode){
            case 1:
                setMessage("No licence found");
                break;
            case 2:
                setMessage("Invalid licence");
                break;
            case 3:
                setMessage("No data found for this product");
                break;
            case 4:
                setMessage("Licence expired");
                break;
            case 0:
            default:
                setMessage("");
                break;
        }
    }, [
        props.errorCode
    ]);
    return (0, $179ad052de55b86f$exports.jsxs)("div", {
        className: "relative h-full w-full flex flex-col justify-center items-center",
        children: [
            (0, $179ad052de55b86f$exports.jsx)("div", {
                className: "mb-8 font-bold text-lg",
                children: message
            }),
            (0, $179ad052de55b86f$exports.jsx)("div", {
                className: "border-box border-b border-t border-r animate-spin w-16 h-16 border-4 rounded-full"
            })
        ]
    });
};
var $1ff9b34fabc7ea86$var$$5ad02cede29c1661$export$2e2bcd8739ae039 = $1ff9b34fabc7ea86$var$$5ad02cede29c1661$var$Loader;
// Use throughout your app instead of plain `useDispatch` and `useSelector`
const $1ff9b34fabc7ea86$var$$890729a126ff6e91$export$f51d452c10d5b956 = ()=>(0, $cdba447f92a85742$export$8ad76b76a4c905f8)();
const $1ff9b34fabc7ea86$var$$890729a126ff6e91$export$a7347740d65f620b = (0, $ea41252a5ec6592a$export$2105062e25df4afe);
const $1ff9b34fabc7ea86$var$$890729a126ff6e91$export$5a120d91e5204be4 = ()=>$1ff9b34fabc7ea86$var$$890729a126ff6e91$export$a7347740d65f620b((state)=>state.licenceReducer.value.allowed);
const $1ff9b34fabc7ea86$var$$890729a126ff6e91$export$7b348fc9f96d3a4b = ()=>$1ff9b34fabc7ea86$var$$890729a126ff6e91$export$a7347740d65f620b((state)=>state.licenceReducer.value.licence);
const $1ff9b34fabc7ea86$var$$890729a126ff6e91$export$23745d1f9ed321fa = ()=>$1ff9b34fabc7ea86$var$$890729a126ff6e91$export$a7347740d65f620b((state)=>state.licenceReducer.value.errorCode);
const $1ff9b34fabc7ea86$var$$890729a126ff6e91$export$c1cf1cf4c5d51937 = ()=>$1ff9b34fabc7ea86$var$$890729a126ff6e91$export$a7347740d65f620b((state)=>state.licenceReducer.value);
const $1ff9b34fabc7ea86$var$$0604fad8b796cc31$var$DataRetriever = ({ licence: licence, agentData: agentData, height: height, size: size, speak: speak, animationQueue: animationQueue, setAnimationQueue: setAnimationQueue })=>{
    const dispatch = $1ff9b34fabc7ea86$var$$890729a126ff6e91$export$f51d452c10d5b956();
    const allowedByLicence = $1ff9b34fabc7ea86$var$$890729a126ff6e91$export$5a120d91e5204be4();
    const errorCode = $1ff9b34fabc7ea86$var$$890729a126ff6e91$export$23745d1f9ed321fa();
    (0, $eO7Kz.useEffect)(()=>{
        dispatch($1ff9b34fabc7ea86$var$$993360e742630fa4$export$bed470be7ed80787());
    }, [
        licence
    ]);
    return (0, $179ad052de55b86f$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eO7Kz))).Fragment, {
        children: allowedByLicence ? (0, $179ad052de55b86f$exports.jsx)($1ff9b34fabc7ea86$var$$01c612cb40aac877$export$2e2bcd8739ae039, {
            agentData: agentData,
            height: height,
            size: size,
            speak: speak,
            animationQueue: animationQueue,
            setAnimationQueue: setAnimationQueue
        }) : (0, $179ad052de55b86f$exports.jsx)($1ff9b34fabc7ea86$var$$5ad02cede29c1661$export$2e2bcd8739ae039, {
            errorCode: errorCode
        })
    });
};
var $1ff9b34fabc7ea86$var$$0604fad8b796cc31$export$2e2bcd8739ae039 = $1ff9b34fabc7ea86$var$$0604fad8b796cc31$var$DataRetriever;
const $1ff9b34fabc7ea86$var$$e3a2da95730ed7d6$var$ChatbotProvider = (props)=>{
    return (0, $179ad052de55b86f$exports.jsx)((0, $18b122cd2de4fd43$export$2e2bcd8739ae039), {
        store: $1ff9b34fabc7ea86$var$$63565878075adc80$export$2e2bcd8739ae039,
        children: (0, $179ad052de55b86f$exports.jsx)($1ff9b34fabc7ea86$var$$0604fad8b796cc31$export$2e2bcd8739ae039, {
            ...props
        })
    });
};
var $1ff9b34fabc7ea86$var$$e3a2da95730ed7d6$export$2e2bcd8739ae039 = $1ff9b34fabc7ea86$var$$e3a2da95730ed7d6$var$ChatbotProvider;
function $1ff9b34fabc7ea86$var$$0531a00fb289598f$export$2e2bcd8739ae039(RetorikSpiritEngineSprite, props, element) {
    const root = (0, $c244115e8f747aae$export$882461b6382ed46c)(element);
    root.render((0, $179ad052de55b86f$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eO7Kz))).StrictMode, {
        children: (0, $179ad052de55b86f$exports.jsx)(RetorikSpiritEngineSprite, {
            ...props
        })
    }));
}
/* eslint-disable camelcase */ /* eslint-disable prettier/prettier */ const $1ff9b34fabc7ea86$var$$ba07c5dc2bd20c2a$var$authenticate = async (licence)=>{
    const sessionId = await fetch("https://paas.retorik.fr/rest?method=authentification", {
        method: "POST",
        headers: {
            "Content-type": "application/json"
        },
        body: JSON.stringify({
            aLicence: licence
        })
    }).then((response)=>{
        return response.json();
    }).then((data)=>{
        if (data?.authentification?.status === "success") return data.authentification;
        return false;
    }).catch((error)=>{
        console.log(error);
        return false;
    });
    return sessionId;
};
const $1ff9b34fabc7ea86$var$$ba07c5dc2bd20c2a$var$sendMessage = async (licence, text)=>{
    const auth = await $1ff9b34fabc7ea86$var$$ba07c5dc2bd20c2a$var$authenticate(licence);
    if (auth.status === "success") {
        const requestData = {
            idSession: auth.response,
            aFormat: "mp3",
            aText: text
        };
        await fetch("https://paas.retorik.fr/rest?method=tts_send", {
            method: "POST",
            headers: {
                "Content-type": "application/json"
            },
            body: JSON.stringify(requestData)
        }).then((response)=>{
            return response.json();
        }).then((data)=>{
            if (data?.tts_send?.status === "success") $1ff9b34fabc7ea86$var$$ba07c5dc2bd20c2a$var$play(data?.tts_send.response);
            return data;
        }).catch((error)=>console.log(error));
    } else console.log("Authentication error");
};
const $1ff9b34fabc7ea86$var$$ba07c5dc2bd20c2a$var$play = (mp3)=>{
    const audioElement = document.getElementById("spirit-engine-sprite-audio");
    if (audioElement) {
        audioElement.src = mp3;
        audioElement.play();
    }
};
var $1ff9b34fabc7ea86$var$$ba07c5dc2bd20c2a$export$2e2bcd8739ae039 = $1ff9b34fabc7ea86$var$$ba07c5dc2bd20c2a$var$sendMessage;
const $1ff9b34fabc7ea86$export$7dc86772e2a8d289 = $1ff9b34fabc7ea86$var$$0531a00fb289598f$export$2e2bcd8739ae039.bind(null, $1ff9b34fabc7ea86$var$$e3a2da95730ed7d6$export$2e2bcd8739ae039);
var $1ff9b34fabc7ea86$export$2e2bcd8739ae039 = $1ff9b34fabc7ea86$var$$e3a2da95730ed7d6$export$2e2bcd8739ae039;
window.Retorik = {
    ...window.Retorik,
    sendMessage: $1ff9b34fabc7ea86$var$$ba07c5dc2bd20c2a$export$2e2bcd8739ae039,
    renderSpiritEngineSprite: $1ff9b34fabc7ea86$export$7dc86772e2a8d289
};




var $eO7Kz = parcelRequire("eO7Kz");


var $eO7Kz = parcelRequire("eO7Kz");

const $c85d978b5d95e228$var$BackgroundVideo = ({ source: source, style: style, loop: loop, muted: muted, onVideoEnded: onVideoEnded, onVideoCanPlay: onVideoCanPlay })=>{
    const { currentHeight: currentHeight, currentWidth: currentWidth } = (0, $8b59a4dbb18c269b$export$3abe3478af3cb63b)();
    const videoRef = (0, $eO7Kz.useRef)(null);
    (0, $eO7Kz.useEffect)(()=>{
        if (videoRef.current) {
            videoRef.current.pause();
            videoRef.current.load();
            videoRef.current.play();
        }
    }, [
        videoRef
    ]);
    return /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("video", {
        ref: videoRef,
        id: "retorik-background-video",
        className: "rf-relative rf-col-span-full rf-row-span-full rf-object-cover rf-overflow-hidden rf-filter rf-blur-background",
        onEnded: onVideoEnded,
        onError: onVideoEnded,
        onCanPlay: onVideoCanPlay,
        autoPlay: true,
        loop: loop,
        muted: muted,
        style: {
            ...style,
            height: currentHeight,
            width: currentWidth
        },
        children: /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("source", {
            src: source
        })
    });
};
var $c85d978b5d95e228$export$2e2bcd8739ae039 = $c85d978b5d95e228$var$BackgroundVideo;


var $2365c8d06b74278a$exports = {};

(function webpackUniversalModuleDefinition(root, factory) {
    $2365c8d06b74278a$exports = factory((parcelRequire("eO7Kz")));
})($2365c8d06b74278a$exports, function(__WEBPACK_EXTERNAL_MODULE_react__) {
    return /******/ function(modules) {
        /******/ // The module cache
        /******/ var installedModules = {};
        /******/ /******/ // The require function
        /******/ function __webpack_require__(moduleId) {
            /******/ /******/ // Check if module is in cache
            /******/ if (installedModules[moduleId]) /******/ return installedModules[moduleId].exports;
            /******/ // Create a new module (and put it into the cache)
            /******/ var module = installedModules[moduleId] = {
                /******/ i: moduleId,
                /******/ l: false,
                /******/ exports: {}
            };
            /******/ /******/ // Execute the module function
            /******/ modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
            /******/ /******/ // Flag the module as loaded
            /******/ module.l = true;
            /******/ /******/ // Return the exports of the module
            /******/ return module.exports;
        /******/ }
        /******/ /******/ /******/ // expose the modules object (__webpack_modules__)
        /******/ __webpack_require__.m = modules;
        /******/ /******/ // expose the module cache
        /******/ __webpack_require__.c = installedModules;
        /******/ /******/ // define getter function for harmony exports
        /******/ __webpack_require__.d = function(exports, name, getter) {
            /******/ if (!__webpack_require__.o(exports, name)) /******/ Object.defineProperty(exports, name, {
                enumerable: true,
                get: getter
            });
        /******/ };
        /******/ /******/ // define __esModule on exports
        /******/ __webpack_require__.r = function(exports) {
            /******/ if (typeof Symbol !== "undefined" && Symbol.toStringTag) /******/ Object.defineProperty(exports, Symbol.toStringTag, {
                value: "Module"
            });
            /******/ Object.defineProperty(exports, "__esModule", {
                value: true
            });
        /******/ };
        /******/ /******/ // create a fake namespace object
        /******/ // mode & 1: value is a module id, require it
        /******/ // mode & 2: merge all properties of value into the ns
        /******/ // mode & 4: return value when already ns object
        /******/ // mode & 8|1: behave like require
        /******/ __webpack_require__.t = function(value, mode) {
            /******/ if (mode & 1) value = __webpack_require__(value);
            /******/ if (mode & 8) return value;
            /******/ if (mode & 4 && typeof value === "object" && value && value.__esModule) return value;
            /******/ var ns = Object.create(null);
            /******/ __webpack_require__.r(ns);
            /******/ Object.defineProperty(ns, "default", {
                enumerable: true,
                value: value
            });
            /******/ if (mode & 2 && typeof value != "string") for(var key in value)__webpack_require__.d(ns, key, (function(key) {
                return value[key];
            }).bind(null, key));
            /******/ return ns;
        /******/ };
        /******/ /******/ // getDefaultExport function for compatibility with non-harmony modules
        /******/ __webpack_require__.n = function(module) {
            /******/ var getter = module && module.__esModule ? /******/ function getDefault() {
                return module["default"];
            } : /******/ function getModuleExports() {
                return module;
            };
            /******/ __webpack_require__.d(getter, "a", getter);
            /******/ return getter;
        /******/ };
        /******/ /******/ // Object.prototype.hasOwnProperty.call
        /******/ __webpack_require__.o = function(object, property) {
            return Object.prototype.hasOwnProperty.call(object, property);
        };
        /******/ /******/ // __webpack_public_path__
        /******/ __webpack_require__.p = "";
        /******/ /******/ /******/ // Load entry module and return exports
        /******/ return __webpack_require__(__webpack_require__.s = "./src/react-webcam.tsx");
    /******/ }({
        /***/ "./src/react-webcam.tsx": /*!******************************!*\
  !*** ./src/react-webcam.tsx ***!
  \******************************/ /*! exports provided: default */ /***/ function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
            /* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/ __webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
            var __extends = function() {
                var extendStatics = function(d, b) {
                    extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
                    };
                    return extendStatics(d, b);
                };
                return function(d, b) {
                    extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            var __assign = function() {
                __assign = Object.assign || function(t) {
                    for(var s, i = 1, n = arguments.length; i < n; i++){
                        s = arguments[i];
                        for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
                    }
                    return t;
                };
                return __assign.apply(this, arguments);
            };
            var __rest = function(s, e) {
                var t = {};
                for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
                if (s != null && typeof Object.getOwnPropertySymbols === "function") {
                    for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
                }
                return t;
            };
            // polyfill based on https://developer.mozilla.org/en-US/docs/Web/API/MediaDevices/getUserMedia
            (function polyfillGetUserMedia() {
                if (typeof window === "undefined") return;
                // Older browsers might not implement mediaDevices at all, so we set an empty object first
                if (navigator.mediaDevices === undefined) navigator.mediaDevices = {};
                // Some browsers partially implement mediaDevices. We can't just assign an object
                // with getUserMedia as it would overwrite existing properties.
                // Here, we will just add the getUserMedia property if it's missing.
                if (navigator.mediaDevices.getUserMedia === undefined) navigator.mediaDevices.getUserMedia = function(constraints) {
                    // First get ahold of the legacy getUserMedia, if present
                    var getUserMedia = navigator.getUserMedia || navigator.webkitGetUserMedia || navigator.mozGetUserMedia || navigator.msGetUserMedia;
                    // Some browsers just don't implement it - return a rejected promise with an error
                    // to keep a consistent interface
                    if (!getUserMedia) return Promise.reject(new Error("getUserMedia is not implemented in this browser"));
                    // Otherwise, wrap the call to the old navigator.getUserMedia with a Promise
                    return new Promise(function(resolve, reject) {
                        getUserMedia.call(navigator, constraints, resolve, reject);
                    });
                };
            })();
            function hasGetUserMedia() {
                return !!(navigator.mediaDevices && navigator.mediaDevices.getUserMedia);
            }
            var Webcam = /** @class */ function(_super) {
                __extends(Webcam, _super);
                function Webcam(props) {
                    var _this = _super.call(this, props) || this;
                    _this.canvas = null;
                    _this.ctx = null;
                    _this.requestUserMediaId = 0;
                    _this.unmounted = false;
                    _this.state = {
                        hasUserMedia: false
                    };
                    return _this;
                }
                Webcam.prototype.componentDidMount = function() {
                    var _a = this, state = _a.state, props = _a.props;
                    if (!hasGetUserMedia()) {
                        props.onUserMediaError("getUserMedia not supported");
                        return;
                    }
                    if (!state.hasUserMedia) this.requestUserMedia();
                };
                Webcam.prototype.componentDidUpdate = function(nextProps) {
                    var props = this.props;
                    if (!hasGetUserMedia()) {
                        props.onUserMediaError("getUserMedia not supported");
                        return;
                    }
                    var audioConstraintsChanged = JSON.stringify(nextProps.audioConstraints) !== JSON.stringify(props.audioConstraints);
                    var videoConstraintsChanged = JSON.stringify(nextProps.videoConstraints) !== JSON.stringify(props.videoConstraints);
                    var minScreenshotWidthChanged = nextProps.minScreenshotWidth !== props.minScreenshotWidth;
                    var minScreenshotHeightChanged = nextProps.minScreenshotHeight !== props.minScreenshotHeight;
                    if (videoConstraintsChanged || minScreenshotWidthChanged || minScreenshotHeightChanged) {
                        this.canvas = null;
                        this.ctx = null;
                    }
                    if (audioConstraintsChanged || videoConstraintsChanged) {
                        this.stopAndCleanup();
                        this.requestUserMedia();
                    }
                };
                Webcam.prototype.componentWillUnmount = function() {
                    this.unmounted = true;
                    this.stopAndCleanup();
                };
                Webcam.stopMediaStream = function(stream) {
                    if (stream) {
                        if (stream.getVideoTracks && stream.getAudioTracks) {
                            stream.getVideoTracks().map(function(track) {
                                stream.removeTrack(track);
                                track.stop();
                            });
                            stream.getAudioTracks().map(function(track) {
                                stream.removeTrack(track);
                                track.stop();
                            });
                        } else stream.stop();
                    }
                };
                Webcam.prototype.stopAndCleanup = function() {
                    var state = this.state;
                    if (state.hasUserMedia) {
                        Webcam.stopMediaStream(this.stream);
                        if (state.src) window.URL.revokeObjectURL(state.src);
                    }
                };
                Webcam.prototype.getScreenshot = function(screenshotDimensions) {
                    var _a = this, state = _a.state, props = _a.props;
                    if (!state.hasUserMedia) return null;
                    var canvas = this.getCanvas(screenshotDimensions);
                    return canvas && canvas.toDataURL(props.screenshotFormat, props.screenshotQuality);
                };
                Webcam.prototype.getCanvas = function(screenshotDimensions) {
                    var _a = this, state = _a.state, props = _a.props;
                    if (!this.video) return null;
                    if (!state.hasUserMedia || !this.video.videoHeight) return null;
                    if (!this.ctx) {
                        var canvasWidth = this.video.videoWidth;
                        var canvasHeight = this.video.videoHeight;
                        if (!this.props.forceScreenshotSourceSize) {
                            var aspectRatio = canvasWidth / canvasHeight;
                            canvasWidth = props.minScreenshotWidth || this.video.clientWidth;
                            canvasHeight = canvasWidth / aspectRatio;
                            if (props.minScreenshotHeight && canvasHeight < props.minScreenshotHeight) {
                                canvasHeight = props.minScreenshotHeight;
                                canvasWidth = canvasHeight * aspectRatio;
                            }
                        }
                        this.canvas = document.createElement("canvas");
                        this.canvas.width = (screenshotDimensions === null || screenshotDimensions === void 0 ? void 0 : screenshotDimensions.width) || canvasWidth;
                        this.canvas.height = (screenshotDimensions === null || screenshotDimensions === void 0 ? void 0 : screenshotDimensions.height) || canvasHeight;
                        this.ctx = this.canvas.getContext("2d");
                    }
                    var _b = this, ctx = _b.ctx, canvas = _b.canvas;
                    if (ctx && canvas) {
                        // mirror the screenshot
                        if (props.mirrored) {
                            ctx.translate(canvas.width, 0);
                            ctx.scale(-1, 1);
                        }
                        ctx.imageSmoothingEnabled = props.imageSmoothing;
                        ctx.drawImage(this.video, 0, 0, (screenshotDimensions === null || screenshotDimensions === void 0 ? void 0 : screenshotDimensions.width) || canvas.width, (screenshotDimensions === null || screenshotDimensions === void 0 ? void 0 : screenshotDimensions.height) || canvas.height);
                        // invert mirroring
                        if (props.mirrored) {
                            ctx.scale(-1, 1);
                            ctx.translate(-canvas.width, 0);
                        }
                    }
                    return canvas;
                };
                Webcam.prototype.requestUserMedia = function() {
                    var _this = this;
                    var props = this.props;
                    var sourceSelected = function(audioConstraints, videoConstraints) {
                        var constraints = {
                            video: typeof videoConstraints !== "undefined" ? videoConstraints : true
                        };
                        if (props.audio) constraints.audio = typeof audioConstraints !== "undefined" ? audioConstraints : true;
                        _this.requestUserMediaId++;
                        var myRequestUserMediaId = _this.requestUserMediaId;
                        navigator.mediaDevices.getUserMedia(constraints).then(function(stream) {
                            if (_this.unmounted || myRequestUserMediaId !== _this.requestUserMediaId) Webcam.stopMediaStream(stream);
                            else _this.handleUserMedia(null, stream);
                        }).catch(function(e) {
                            _this.handleUserMedia(e);
                        });
                    };
                    if ("mediaDevices" in navigator) sourceSelected(props.audioConstraints, props.videoConstraints);
                    else {
                        var optionalSource_1 = function(id) {
                            return {
                                optional: [
                                    {
                                        sourceId: id
                                    }
                                ]
                            };
                        };
                        var constraintToSourceId_1 = function(constraint) {
                            var deviceId = constraint.deviceId;
                            if (typeof deviceId === "string") return deviceId;
                            if (Array.isArray(deviceId) && deviceId.length > 0) return deviceId[0];
                            if (typeof deviceId === "object" && deviceId.ideal) return deviceId.ideal;
                            return null;
                        };
                        // @ts-ignore: deprecated api
                        MediaStreamTrack.getSources(function(sources) {
                            var audioSource = null;
                            var videoSource = null;
                            sources.forEach(function(source) {
                                if (source.kind === "audio") audioSource = source.id;
                                else if (source.kind === "video") videoSource = source.id;
                            });
                            var audioSourceId = constraintToSourceId_1(props.audioConstraints);
                            if (audioSourceId) audioSource = audioSourceId;
                            var videoSourceId = constraintToSourceId_1(props.videoConstraints);
                            if (videoSourceId) videoSource = videoSourceId;
                            sourceSelected(optionalSource_1(audioSource), optionalSource_1(videoSource));
                        });
                    }
                };
                Webcam.prototype.handleUserMedia = function(err, stream) {
                    var props = this.props;
                    if (err || !stream) {
                        this.setState({
                            hasUserMedia: false
                        });
                        props.onUserMediaError(err);
                        return;
                    }
                    this.stream = stream;
                    try {
                        if (this.video) this.video.srcObject = stream;
                        this.setState({
                            hasUserMedia: true
                        });
                    } catch (error) {
                        this.setState({
                            hasUserMedia: true,
                            src: window.URL.createObjectURL(stream)
                        });
                    }
                    props.onUserMedia(stream);
                };
                Webcam.prototype.render = function() {
                    var _this = this;
                    var _a = this, state = _a.state, props = _a.props;
                    var audio = props.audio, forceScreenshotSourceSize = props.forceScreenshotSourceSize, onUserMedia = props.onUserMedia, onUserMediaError = props.onUserMediaError, screenshotFormat = props.screenshotFormat, screenshotQuality = props.screenshotQuality, minScreenshotWidth = props.minScreenshotWidth, minScreenshotHeight = props.minScreenshotHeight, audioConstraints = props.audioConstraints, videoConstraints = props.videoConstraints, imageSmoothing = props.imageSmoothing, mirrored = props.mirrored, _b = props.style, style = _b === void 0 ? {} : _b, rest = __rest(props, [
                        "audio",
                        "forceScreenshotSourceSize",
                        "onUserMedia",
                        "onUserMediaError",
                        "screenshotFormat",
                        "screenshotQuality",
                        "minScreenshotWidth",
                        "minScreenshotHeight",
                        "audioConstraints",
                        "videoConstraints",
                        "imageSmoothing",
                        "mirrored",
                        "style"
                    ]);
                    var videoStyle = mirrored ? __assign(__assign({}, style), {
                        transform: (style.transform || "") + " scaleX(-1)"
                    }) : style;
                    return react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("video", __assign({
                        autoPlay: true,
                        src: state.src,
                        muted: !audio,
                        playsInline: true,
                        ref: function(ref) {
                            _this.video = ref;
                        },
                        style: videoStyle
                    }, rest));
                };
                Webcam.defaultProps = {
                    audio: false,
                    forceScreenshotSourceSize: false,
                    imageSmoothing: true,
                    mirrored: false,
                    onUserMedia: function() {
                        return undefined;
                    },
                    onUserMediaError: function() {
                        return undefined;
                    },
                    screenshotFormat: "image/webp",
                    screenshotQuality: 0.92
                };
                return Webcam;
            }(react__WEBPACK_IMPORTED_MODULE_0__["Component"]);
            /* harmony default export */ __webpack_exports__["default"] = Webcam;
        /***/ },
        /***/ "react": /*!**************************************************************************************!*\
  !*** external {"root":"React","commonjs2":"react","commonjs":"react","amd":"react"} ***!
  \**************************************************************************************/ /*! no static exports found */ /***/ function(module, exports) {
            module.exports = __WEBPACK_EXTERNAL_MODULE_react__;
        /***/ }
    })["default"];
});




var $eO7Kz = parcelRequire("eO7Kz");
const $6860898abc4c0a4f$var$useRefDimensions = (ref)=>{
    const [dimensions, setDimensions] = (0, $eO7Kz.useState)({
        width: 1,
        height: 1
    });
    const [windowSize, setWindowSize] = (0, $eO7Kz.useState)({
        width: window.innerWidth,
        height: window.innerHeight
    });
    const handleResize = ()=>{
        setWindowSize({
            width: window.innerWidth,
            height: window.innerHeight
        });
    };
    (0, $eO7Kz.useEffect)(()=>{
        window.addEventListener("resize", handleResize);
        if (ref.current) {
            const { width: width, height: height } = ref.current.getBoundingClientRect();
            setDimensions({
                width: width,
                height: height
            });
        }
        return ()=>window.removeEventListener("resize", handleResize);
    }, [
        ref,
        windowSize
    ]);
    return dimensions;
};
var $6860898abc4c0a4f$export$2e2bcd8739ae039 = $6860898abc4c0a4f$var$useRefDimensions;


const $76554fe10d7587c9$var$Background = ({ config: config, videoLoop: videoLoop, videoMuted: videoMuted, onVideoEnded: onVideoEnded, onVideoCanPlay: onVideoCanPlay })=>{
    const webcamRotation = (0, $8b59a4dbb18c269b$export$3abe3478af3cb63b)().configurations.webcamRotation;
    const [isWebcamAllowed, setIsWebcamAllowed] = (0, $eO7Kz.useState)(false);
    const imageRef = (0, $eO7Kz.useRef)(null);
    const dimensions = (0, $6860898abc4c0a4f$export$2e2bcd8739ae039)(imageRef);
    const source = {};
    const [videoDimensions, setVideoDimensions] = (0, $eO7Kz.useState)(dimensions);
    const [rotation, setRotation] = (0, $eO7Kz.useState)("");
    const [webcamSizeStyle, setWebcamSizeStyle] = (0, $eO7Kz.useState)({});
    const blurValue = {
        "--rf-blur-background": config.blur !== undefined ? `${config.blur}px` : "0"
    };
    if (config.style === "webcam" && config.webcam) switch(config.webcam){
        case "back":
            source.facingMode = {
                exact: "environment"
            };
            break;
        case "front":
        case undefined:
            source.facingMode = "user";
            break;
        default:
            source.deviceId = config.webcam;
    }
    (0, $eO7Kz.useEffect)(()=>{
        if (config.style === "webcam") askForWebcamPermission();
    }, []);
    const askForWebcamPermission = async ()=>{
        navigator?.mediaDevices && navigator.mediaDevices.getUserMedia({
            video: true
        }).then(()=>{
            setIsWebcamAllowed(true);
        }).catch((error)=>{
            console.log(error);
            setIsWebcamAllowed(false);
        });
    };
    (0, $eO7Kz.useEffect)(function updateVideoDimensions() {
        if (config.style === "webcam") {
            if (!webcamRotation || webcamRotation % 180 === 0) setVideoDimensions(dimensions);
            else setVideoDimensions({
                height: dimensions.width,
                width: dimensions.height
            });
        }
    }, [
        dimensions
    ]);
    (0, $eO7Kz.useEffect)(function updateRotation() {
        switch(webcamRotation){
            case 90:
                setRotation("rf-rotate-90 rf-origin-center");
                setWebcamSizeStyle({
                    width: "100vh",
                    height: "100vw"
                });
                break;
            case -90:
                setRotation("rf--rotate-90 rf-origin-center");
                setWebcamSizeStyle({
                    width: "100vh",
                    height: "100vw"
                });
                break;
            case 180:
                setRotation("rf-rotate-180 rf-origin-center");
                setWebcamSizeStyle({});
                break;
            default:
                setRotation("");
                setWebcamSizeStyle({});
                break;
        }
    }, [
        webcamRotation
    ]);
    return /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($eO7Kz))).Fragment, {
        children: [
            config.image && /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("img", {
                ref: imageRef,
                src: config.image,
                alt: "background image",
                className: "rf-col-span-full rf-row-span-full rf-w-full rf-h-full rf-object-cover rf-filter rf-blur-background",
                style: blurValue
            }),
            config.style === "video" && config.video && /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $c85d978b5d95e228$export$2e2bcd8739ae039), {
                source: config.video,
                loop: !!videoLoop,
                muted: !!videoMuted,
                onVideoEnded: onVideoEnded,
                onVideoCanPlay: onVideoCanPlay,
                style: blurValue
            }),
            config.style === "webcam" && isWebcamAllowed && /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2365c8d06b74278a$exports))), {
                className: `rf-relative rf-col-span-full rf-row-span-full rf-overflow-hidden rf-max-w-none rf-w-screen rf-h-screen rf-filter rf-blur-background rf-border rf-self-center rf-justify-self-center rf-object-cover ${rotation}`,
                ...videoDimensions,
                style: {
                    ...blurValue,
                    ...webcamSizeStyle
                },
                audio: false,
                videoConstraints: {
                    ...source,
                    ...videoDimensions
                }
            })
        ]
    });
};
var $76554fe10d7587c9$export$2e2bcd8739ae039 = $76554fe10d7587c9$var$Background;


/* eslint-disable react/jsx-boolean-value */ 

var $eO7Kz = parcelRequire("eO7Kz");





var $eO7Kz = parcelRequire("eO7Kz");


const { useDictateState: $925563db5be72378$var$useDictateState, useDictateInterims: $925563db5be72378$var$useDictateInterims } = (0, $497baa802110a7bc$exports.hooks);
const $925563db5be72378$var$VoiceInput = ({ className: className, setListening: setListening })=>{
    const { isMobile: isMobile } = (0, $8b59a4dbb18c269b$export$3abe3478af3cb63b)();
    const dictateState = $925563db5be72378$var$useDictateState()[0];
    const [dictateInterims] = $925563db5be72378$var$useDictateInterims();
    const [textToDisplay, setTextToDisplay] = (0, $eO7Kz.useState)("⠀");
    const [hideText, setHideText] = (0, $eO7Kz.useState)(true);
    const timerRef = (0, $eO7Kz.useRef)(null);
    (0, $eO7Kz.useEffect)(()=>{
        if (dictateState === 2 || dictateState === 3) {
            if (dictateInterims.length > 0 && dictateInterims[0].length > 0) setHideText(false);
        } else timerRef && (timerRef.current = setTimeout(()=>{
            setHideText(true);
            setTextToDisplay("⠀");
            setListening && setListening(false);
        }, 1500));
        return ()=>{
            timerRef && clearTimeout(timerRef.current);
        };
    }, [
        dictateState,
        dictateInterims
    ]);
    /**
   * On dictateInterims change :
   *  - update textToDisplay state
   */ (0, $eO7Kz.useEffect)(()=>{
        dictateInterims[0] && setTextToDisplay(dictateInterims[0]);
    }, [
        dictateInterims
    ]);
    return !hideText ? isMobile ? /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("p", {
        className: className,
        children: textToDisplay
    }) : /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("div", {
        className: "rf-w-full rf-px-4 rf-py-3 rf-subtitle-size-auto rf-font-bold rf-text-truewhite rf-text-shadow-black",
        children: textToDisplay
    }) : /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eO7Kz))).Fragment, {});
};
var $925563db5be72378$export$2e2bcd8739ae039 = $925563db5be72378$var$VoiceInput;



const $eac94ac313894af3$var$UserRequest = ()=>{
    const { mode: mode } = (0, $e599569c1fc3ca2c$export$d8760bee47331b1d)();
    const { isMobile: isMobile, currentDeviceType: currentDeviceType, mediumLandscape: mediumLandscape } = (0, $8b59a4dbb18c269b$export$3abe3478af3cb63b)();
    return /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eO7Kz))).Fragment, {
        children: !isMobile && /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("div", {
            className: `rf-relative rf-h-full
            ${currentDeviceType === (0, $16ad089b9ce6627d$export$ec1e04e4e5ef8233).borne && mode === (0, $16ad089b9ce6627d$export$9484bbecc3c49a2e).vocal ? "rf-w-4/9" : "rf-w-3/5"}
            ${mode === (0, $16ad089b9ce6627d$export$9484bbecc3c49a2e).text && mediumLandscape ? "rf-col-start-4" : "rf-col-start-5"} rf-col-span-full rf-row-start-1 ${mode === (0, $16ad089b9ce6627d$export$9484bbecc3c49a2e).text ? "rf-row-end-4" : "rf-row-end-5"} rf-py-4
            large-vertical:rf-col-start-1 large-vertical:rf-col-span-full large-vertical:rf-row-start-5 large-vertical:rf-row-end-7
            large-vertical:rf-py-5
            rf-flex rf-flex-col rf-justify-self-center rf-justify-end rf-text-size-auto rf-text-trueblack`,
            id: "retorik-userRequest",
            children: mode === (0, $16ad089b9ce6627d$export$9484bbecc3c49a2e).text ? /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $cc51107c7c4d0305$export$2e2bcd8739ae039), {
                withButton: true
            }) : /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $925563db5be72378$export$2e2bcd8739ae039), {})
        })
    });
};
var $eac94ac313894af3$export$2e2bcd8739ae039 = $eac94ac313894af3$var$UserRequest;





var $eO7Kz = parcelRequire("eO7Kz");

const $9856d835783ad65d$var$Logo = ({ className: className })=>{
    const { configuration: configuration } = (0, $e599569c1fc3ca2c$export$d8760bee47331b1d)();
    return configuration.logo?.src ? /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("div", {
        className: `${className || "rf-absolute rf-m-4 large:rf-m-8 rf-top-0 rf-left-0"}`,
        children: /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("img", {
            src: configuration.logo?.src,
            alt: "Logo",
            className: "rf-max-h-12 rf-max-w-16 large:rf-max-h-28 large:rf-max-w-[12rem] large-vertical:rf-max-h-36"
        })
    }) : /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eO7Kz))).Fragment, {});
};
var $9856d835783ad65d$export$2e2bcd8739ae039 = $9856d835783ad65d$var$Logo;


/* eslint-disable no-unused-expressions */ 

var $eO7Kz = parcelRequire("eO7Kz");







const { useActivities: $e1bf7fd78241e7c2$var$useActivities } = (0, $497baa802110a7bc$exports.hooks);
function $e1bf7fd78241e7c2$export$2e2bcd8739ae039() {
    const [activities] = $e1bf7fd78241e7c2$var$useActivities();
    const { currentPlaying: currentPlaying } = (0, $633c6ef6f1f791c0$export$57e792e009c800a0)();
    const { endedActivities: endedActivities } = (0, $633c6ef6f1f791c0$export$57e792e009c800a0)();
    if (!currentPlaying) {
        if (endedActivities.length > 0) return activities.find((activity)=>activity.id === endedActivities[endedActivities.length - 1]) || undefined;
    } else return currentPlaying;
    return undefined;
}



parcelRequire("eO7Kz");

parcelRequire("eO7Kz");

const $b1b23721940b85e5$var$ListContextProvider = ({ children: children })=>{
    return /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $719f01871b6350db$export$9b0a72e5d41d62ec), {
        children: children
    });
};
var $b1b23721940b85e5$export$2e2bcd8739ae039 = $b1b23721940b85e5$var$ListContextProvider;




var $eO7Kz = parcelRequire("eO7Kz");







/* eslint-disable react/jsx-boolean-value */ 

var $eO7Kz = parcelRequire("eO7Kz");



parcelRequire("eO7Kz");
const $590d7215cbc4acb3$var$Desktop = ({ className: className, background: background, children: children })=>{
    return /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("div", {
        className: `rf-z-dropdown rf-relative rf-col-start-5 rf-col-end-13 rf-row-start-1 rf-row-span-full rf-w-3/5 rf-justify-self-center tactile:rf-pt-1/5 rf-flex rf-flex-col rf-justify-start rf-items-center rf-bg-templateBackground rf-shadow-[3px_3px_6px_#00000029] rf-overflow-y-scroll rf-scrollbar-hidden ${className}`,
        style: {
            background: background || ""
        },
        children: children
    });
};
var $590d7215cbc4acb3$export$2e2bcd8739ae039 = $590d7215cbc4acb3$var$Desktop;




var $eO7Kz = parcelRequire("eO7Kz");

const $5798dbaf1694ea15$var$FullScreen = ({ className: className, depth: depth, background: background, children: children })=>{
    const [zindex, setzindex] = (0, $eO7Kz.useState)("rf-z-ui");
    (0, $eO7Kz.useEffect)(()=>{
        switch(depth){
            case (0, $16ad089b9ce6627d$export$950556173b6cbecb).background:
                setzindex("rf-z-background");
                break;
            case (0, $16ad089b9ce6627d$export$950556173b6cbecb).util:
                setzindex("rf-z-util");
                break;
            case (0, $16ad089b9ce6627d$export$950556173b6cbecb).chatbot:
                setzindex("rf-z-chatbot");
                break;
            case (0, $16ad089b9ce6627d$export$950556173b6cbecb).ui:
                setzindex("rf-z-ui");
                break;
            case (0, $16ad089b9ce6627d$export$950556173b6cbecb).dropdown:
                setzindex("rf-z-dropdown");
                break;
            case (0, $16ad089b9ce6627d$export$950556173b6cbecb).overlay:
                setzindex("rf-z-overlay");
                break;
            case (0, $16ad089b9ce6627d$export$950556173b6cbecb).modal:
                setzindex("rf-z-modal");
                break;
            case (0, $16ad089b9ce6627d$export$950556173b6cbecb).exitwidget:
                setzindex("rf-z-exitwidget");
                break;
            case (0, $16ad089b9ce6627d$export$950556173b6cbecb).menu:
                setzindex("rf-z-menu");
                break;
            default:
                setzindex("rf-z-dropdown");
                break;
        }
    }, [
        depth
    ]);
    return /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("div", {
        className: `rf-relative ${zindex} rf-col-start-1 rf-col-span-full rf-row-start-1 rf-row-span-full rf-text-trueblack ${className}`,
        style: {
            background: background || "linear-gradient(to right bottom, #F8F8FC , #E1E2E8)"
        },
        children: children
    });
};
var $5798dbaf1694ea15$export$2e2bcd8739ae039 = $5798dbaf1694ea15$var$FullScreen;



parcelRequire("eO7Kz");


const $47178ad01294ff29$var$FullScreenMobile = ({ className: className, depth: depth, background: background, children: children })=>{
    const { isMobile: isMobile, displayControls: displayControls } = (0, $8b59a4dbb18c269b$export$3abe3478af3cb63b)();
    return /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $5798dbaf1694ea15$export$2e2bcd8739ae039), {
        className: `${isMobile && displayControls && "rf-mb-12"} rf-p-4 rf-flex rf-flex-col ${className}`,
        depth: depth,
        background: background || "#FFFFFF",
        children: children
    });
};
var $47178ad01294ff29$export$2e2bcd8739ae039 = $47178ad01294ff29$var$FullScreenMobile;



parcelRequire("eO7Kz");
const $55cde5205173a884$var$FullScreenRemote = ({ className: className, background: background, onClick: onClick, children: children })=>{
    return /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("div", {
        className: `rf-relative rf-overflow-y-scroll rf-scrollbar-hidden rf-text-black rf-text-size-auto rf-bg-templateBackground large:rf-mr-30 rf-col-span-full rf-row-span-full ${className}`,
        style: {
            background: background || ""
        },
        onClick: onClick ? ()=>onClick() : ()=>{},
        children: children
    });
};
var $55cde5205173a884$export$2e2bcd8739ae039 = $55cde5205173a884$var$FullScreenRemote;





var $eO7Kz = parcelRequire("eO7Kz");
const $8f63b1b0cd12cb7f$var$Grid = ({ children: children })=>{
    return /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("div", {
        className: "rf-grid rf-grid-cols-2 large:rf-grid-cols-5 large-vertical:rf-grid-cols-3 rf-gap-4 large:rf-gap-6",
        children: (0, (/*@__PURE__*/$parcel$interopDefault($eO7Kz))).Children.map(children, (child)=>{
            return child;
        })
    });
};
var $8f63b1b0cd12cb7f$export$2e2bcd8739ae039 = $8f63b1b0cd12cb7f$var$Grid;



/* eslint-disable react/jsx-boolean-value */ 

var $eO7Kz = parcelRequire("eO7Kz");






var $eO7Kz = parcelRequire("eO7Kz");


var $eO7Kz = parcelRequire("eO7Kz");



const $7b896b1616483503$var$useCloseButtonTop = ()=>{
    const { configuration: configuration } = (0, $e599569c1fc3ca2c$export$d8760bee47331b1d)();
    const { currentDeviceType: currentDeviceType, isTactile: isTactile } = (0, $8b59a4dbb18c269b$export$3abe3478af3cb63b)();
    const [top, setTop] = (0, $eO7Kz.useState)(200);
    /**
   * On currentDeviceType change :
   *  - switch on currentDeviceType and check for tactile
   *  - set top state to the value in configuration if given, or a default one
   */ (0, $eO7Kz.useEffect)(()=>{
        switch(currentDeviceType){
            case (0, $16ad089b9ce6627d$export$ec1e04e4e5ef8233).landscape:
                if (isTactile) setTop(configuration.remote?.desktopTactile || "9.75rem");
                else setTop(configuration.remote?.desktop || "9.75rem");
                break;
            case (0, $16ad089b9ce6627d$export$ec1e04e4e5ef8233).borne:
                setTop(configuration.remote?.verticalTactile || "calc(50% - 11.25rem)");
                break;
            default:
                setTop(200);
                break;
        }
    }, [
        currentDeviceType
    ]);
    return top;
};
var $7b896b1616483503$export$2e2bcd8739ae039 = $7b896b1616483503$var$useCloseButtonTop;




var $eO7Kz = parcelRequire("eO7Kz");

parcelRequire("eO7Kz");
const $2b2ac986a23018e3$var$DashboardIcon = ({ className: className, color: color })=>{
    return /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: color || "currentColor",
        className: className || "w-6",
        viewBox: "0 0 27.93 16.72",
        children: /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("path", {
            d: "M1.23 2.46a1.23 1.23 0 1 1 0-2.46h25.46a1.23 1.23 0 1 1 0 2.46H1.23ZM1.23 9.59a1.23 1.23 0 1 1 0-2.46h25.46a1.23 1.23 0 1 1 0 2.46H1.23ZM1.23 16.72a1.23 1.23 0 1 1 0-2.46h25.46a1.23 1.23 0 1 1 0 2.46H1.23Z"
        })
    });
};
var $2b2ac986a23018e3$export$2e2bcd8739ae039 = $2b2ac986a23018e3$var$DashboardIcon;



parcelRequire("eO7Kz");
const $c213472e440373a4$var$KeyboardIcon = ({ className: className, color: color })=>{
    return /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        viewBox: "0 0 22.5 15",
        className: className || "w-6",
        children: [
            /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("defs", {
                children: /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsxs)("filter", {
                    id: "Icon_awesome-keyboard",
                    children: [
                        /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("feOffset", {
                            dy: "3",
                            in: "SourceAlpha"
                        }),
                        /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("feGaussianBlur", {
                            stdDeviation: "3",
                            result: "blur"
                        }),
                        /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("feFlood", {
                            floodOpacity: "0.161",
                            result: "color"
                        }),
                        /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("feComposite", {
                            operator: "out",
                            in: "SourceGraphic",
                            in2: "blur"
                        }),
                        /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("feComposite", {
                            operator: "in",
                            in: "color"
                        }),
                        /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("feComposite", {
                            operator: "in",
                            in2: "SourceGraphic"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsxs)("g", {
                children: [
                    /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("path", {
                        d: "M20.625,19.5H1.875A1.875,1.875,0,0,1,0,17.625V6.375A1.875,1.875,0,0,1,1.875,4.5h18.75A1.875,1.875,0,0,1,22.5,6.375v11.25A1.875,1.875,0,0,1,20.625,19.5ZM5,9.031V7.469A.469.469,0,0,0,4.531,7H2.969a.469.469,0,0,0-.469.469V9.031a.469.469,0,0,0,.469.469H4.531A.469.469,0,0,0,5,9.031Zm3.75,0V7.469A.469.469,0,0,0,8.281,7H6.719a.469.469,0,0,0-.469.469V9.031a.469.469,0,0,0,.469.469H8.281A.469.469,0,0,0,8.75,9.031Zm3.75,0V7.469A.469.469,0,0,0,12.031,7H10.469A.469.469,0,0,0,10,7.469V9.031a.469.469,0,0,0,.469.469h1.563A.469.469,0,0,0,12.5,9.031Zm3.75,0V7.469A.469.469,0,0,0,15.781,7H14.219a.469.469,0,0,0-.469.469V9.031a.469.469,0,0,0,.469.469h1.563A.469.469,0,0,0,16.25,9.031Zm3.75,0V7.469A.469.469,0,0,0,19.531,7H17.969a.469.469,0,0,0-.469.469V9.031a.469.469,0,0,0,.469.469h1.563A.469.469,0,0,0,20,9.031ZM6.875,12.781V11.219a.469.469,0,0,0-.469-.469H4.844a.469.469,0,0,0-.469.469v1.563a.469.469,0,0,0,.469.469H6.406A.469.469,0,0,0,6.875,12.781Zm3.75,0V11.219a.469.469,0,0,0-.469-.469H8.594a.469.469,0,0,0-.469.469v1.563a.469.469,0,0,0,.469.469h1.563A.469.469,0,0,0,10.625,12.781Zm3.75,0V11.219a.469.469,0,0,0-.469-.469H12.344a.469.469,0,0,0-.469.469v1.563a.469.469,0,0,0,.469.469h1.562A.469.469,0,0,0,14.375,12.781Zm3.75,0V11.219a.469.469,0,0,0-.469-.469H16.094a.469.469,0,0,0-.469.469v1.563a.469.469,0,0,0,.469.469h1.563A.469.469,0,0,0,18.125,12.781ZM5,16.531V14.969a.469.469,0,0,0-.469-.469H2.969a.469.469,0,0,0-.469.469v1.563A.469.469,0,0,0,2.969,17H4.531A.469.469,0,0,0,5,16.531Zm11.25,0V14.969a.469.469,0,0,0-.469-.469H6.719a.469.469,0,0,0-.469.469v1.563A.469.469,0,0,0,6.719,17h9.063A.469.469,0,0,0,16.25,16.531Zm3.75,0V14.969a.469.469,0,0,0-.469-.469H17.969a.469.469,0,0,0-.469.469v1.563a.469.469,0,0,0,.469.469h1.563A.469.469,0,0,0,20,16.531Z",
                        transform: "translate(0 -4.5)",
                        fill: color || "#a4a7af"
                    }),
                    /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("g", {
                        transform: "matrix(1, 0, 0, 1, 0, 0)",
                        filter: "url(#Icon_awesome-keyboard)",
                        children: /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("path", {
                            d: "M20.625,19.5H1.875A1.875,1.875,0,0,1,0,17.625V6.375A1.875,1.875,0,0,1,1.875,4.5h18.75A1.875,1.875,0,0,1,22.5,6.375v11.25A1.875,1.875,0,0,1,20.625,19.5ZM5,9.031V7.469A.469.469,0,0,0,4.531,7H2.969a.469.469,0,0,0-.469.469V9.031a.469.469,0,0,0,.469.469H4.531A.469.469,0,0,0,5,9.031Zm3.75,0V7.469A.469.469,0,0,0,8.281,7H6.719a.469.469,0,0,0-.469.469V9.031a.469.469,0,0,0,.469.469H8.281A.469.469,0,0,0,8.75,9.031Zm3.75,0V7.469A.469.469,0,0,0,12.031,7H10.469A.469.469,0,0,0,10,7.469V9.031a.469.469,0,0,0,.469.469h1.563A.469.469,0,0,0,12.5,9.031Zm3.75,0V7.469A.469.469,0,0,0,15.781,7H14.219a.469.469,0,0,0-.469.469V9.031a.469.469,0,0,0,.469.469h1.563A.469.469,0,0,0,16.25,9.031Zm3.75,0V7.469A.469.469,0,0,0,19.531,7H17.969a.469.469,0,0,0-.469.469V9.031a.469.469,0,0,0,.469.469h1.563A.469.469,0,0,0,20,9.031ZM6.875,12.781V11.219a.469.469,0,0,0-.469-.469H4.844a.469.469,0,0,0-.469.469v1.563a.469.469,0,0,0,.469.469H6.406A.469.469,0,0,0,6.875,12.781Zm3.75,0V11.219a.469.469,0,0,0-.469-.469H8.594a.469.469,0,0,0-.469.469v1.563a.469.469,0,0,0,.469.469h1.563A.469.469,0,0,0,10.625,12.781Zm3.75,0V11.219a.469.469,0,0,0-.469-.469H12.344a.469.469,0,0,0-.469.469v1.563a.469.469,0,0,0,.469.469h1.562A.469.469,0,0,0,14.375,12.781Zm3.75,0V11.219a.469.469,0,0,0-.469-.469H16.094a.469.469,0,0,0-.469.469v1.563a.469.469,0,0,0,.469.469h1.563A.469.469,0,0,0,18.125,12.781ZM5,16.531V14.969a.469.469,0,0,0-.469-.469H2.969a.469.469,0,0,0-.469.469v1.563A.469.469,0,0,0,2.969,17H4.531A.469.469,0,0,0,5,16.531Zm11.25,0V14.969a.469.469,0,0,0-.469-.469H6.719a.469.469,0,0,0-.469.469v1.563A.469.469,0,0,0,6.719,17h9.063A.469.469,0,0,0,16.25,16.531Zm3.75,0V14.969a.469.469,0,0,0-.469-.469H17.969a.469.469,0,0,0-.469.469v1.563a.469.469,0,0,0,.469.469h1.563A.469.469,0,0,0,20,16.531Z",
                            transform: "translate(0 -4.5)",
                            fill: "#fff"
                        })
                    })
                ]
            })
        ]
    });
};
var $c213472e440373a4$export$2e2bcd8739ae039 = $c213472e440373a4$var$KeyboardIcon;



parcelRequire("eO7Kz");
const $723367a4828ad150$var$MicrophoneIcon = ({ className: className, color: color })=>{
    return /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        className: className || "rf-h-6",
        viewBox: "0 0 14.426 20.983",
        children: [
            /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("defs", {
                children: /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsxs)("filter", {
                    id: "Icon_awesome-microphone",
                    children: [
                        /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("feOffset", {
                            dy: "3",
                            in: "SourceAlpha"
                        }),
                        /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("feGaussianBlur", {
                            stdDeviation: "3",
                            result: "blur"
                        }),
                        /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("feFlood", {
                            floodOpacity: "0.161",
                            result: "color"
                        }),
                        /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("feComposite", {
                            operator: "out",
                            in: "SourceGraphic",
                            in2: "blur"
                        }),
                        /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("feComposite", {
                            operator: "in",
                            in: "color"
                        }),
                        /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("feComposite", {
                            operator: "in",
                            in2: "SourceGraphic"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsxs)("g", {
                children: [
                    /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("path", {
                        d: "M7.213,14.426a3.934,3.934,0,0,0,3.934-3.934V3.934a3.934,3.934,0,1,0-7.869,0v6.557A3.934,3.934,0,0,0,7.213,14.426ZM13.77,7.869h-.656a.656.656,0,0,0-.656.656v1.967a5.252,5.252,0,0,1-5.77,5.22,5.405,5.405,0,0,1-4.722-5.454V8.524a.656.656,0,0,0-.656-.656H.656A.656.656,0,0,0,0,8.524V10.17a7.439,7.439,0,0,0,6.229,7.446v1.4h-2.3a.656.656,0,0,0-.656.656v.656a.656.656,0,0,0,.656.656h6.557a.656.656,0,0,0,.656-.656v-.656a.656.656,0,0,0-.656-.656H8.2V17.632a7.22,7.22,0,0,0,6.229-7.14V8.524A.656.656,0,0,0,13.77,7.869Z",
                        fill: color || "#a4a7af"
                    }),
                    /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("g", {
                        transform: "matrix(1, 0, 0, 1, 0, 0)",
                        filter: "url(#Icon_awesome-microphone)",
                        children: /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("path", {
                            d: "M7.213,14.426a3.934,3.934,0,0,0,3.934-3.934V3.934a3.934,3.934,0,1,0-7.869,0v6.557A3.934,3.934,0,0,0,7.213,14.426ZM13.77,7.869h-.656a.656.656,0,0,0-.656.656v1.967a5.252,5.252,0,0,1-5.77,5.22,5.405,5.405,0,0,1-4.722-5.454V8.524a.656.656,0,0,0-.656-.656H.656A.656.656,0,0,0,0,8.524V10.17a7.439,7.439,0,0,0,6.229,7.446v1.4h-2.3a.656.656,0,0,0-.656.656v.656a.656.656,0,0,0,.656.656h6.557a.656.656,0,0,0,.656-.656v-.656a.656.656,0,0,0-.656-.656H8.2V17.632a7.22,7.22,0,0,0,6.229-7.14V8.524A.656.656,0,0,0,13.77,7.869Z",
                            fill: "#fff"
                        })
                    })
                ]
            })
        ]
    });
};
var $723367a4828ad150$export$2e2bcd8739ae039 = $723367a4828ad150$var$MicrophoneIcon;



parcelRequire("eO7Kz");
const $f309fe650f673139$var$MicrophoneIconOn = ({ className: className, color: color })=>{
    return /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        className: className || "rf-h-6 rf-w-8",
        viewBox: "0 0 21.055 18.479",
        children: /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsxs)("g", {
            transform: "translate(-44.181 -45.388)",
            children: [
                /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("rect", {
                    width: "8.229",
                    height: "18.479",
                    rx: "2",
                    transform: "translate(44.181 45.388)",
                    fill: color || "#ff6462"
                }),
                /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("rect", {
                    width: "8.229",
                    height: "18.479",
                    rx: "2",
                    transform: "translate(57.007 45.388)",
                    fill: color || "#ff6462"
                })
            ]
        })
    });
};
var $f309fe650f673139$export$2e2bcd8739ae039 = $f309fe650f673139$var$MicrophoneIconOn;



parcelRequire("eO7Kz");
const $b0feb87ac133ec73$var$MicrophoneIconOff = ({ className: className, color: color })=>{
    return /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        className: className || "rf-h-6 rf-w-6",
        viewBox: "0 0 19 19",
        children: /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("circle", {
            cx: "9.5",
            cy: "9.5",
            r: "9.5",
            fill: color || "#ff6462"
        })
    });
};
var $b0feb87ac133ec73$export$2e2bcd8739ae039 = $b0feb87ac133ec73$var$MicrophoneIconOff;







const $70f9c74a044f19d9$var$DashboardButton = ({ dashboardVisible: dashboardVisible, onClick: onClick })=>{
    const { locale: locale } = (0, $2e4dc8fa28d39601$export$6650dace022cfacc)();
    const [label, setLabel] = (0, $eO7Kz.useState)("");
    (0, $eO7Kz.useEffect)(()=>{
        setLabel(dashboardVisible ? (0, (/*@__PURE__*/$parcel$interopDefault($abbebf5de79f9da4$exports)))[locale]?.close || (0, (/*@__PURE__*/$parcel$interopDefault($abbebf5de79f9da4$exports)))["fr-FR"].close : (0, (/*@__PURE__*/$parcel$interopDefault($abbebf5de79f9da4$exports)))[locale]?.menu || (0, (/*@__PURE__*/$parcel$interopDefault($abbebf5de79f9da4$exports)))["fr-FR"].menu);
    }, []);
    return /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsxs)("button", {
        className: "rf-w-18 rf-h-18 rf-mb-6 rf-flex rf-flex-col rf-justify-center rf-items-center rf-bg-truewhite rf-text-xsm rf-text-trueblack rf-border rf-border-menuBorder rf-rounded-half hover:rf-cursor-pointer rf-shadow-[0_3px_6px_#606267]",
        "aria-label": label,
        onClick: onClick,
        children: [
            /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("div", {
                className: "rf-uppercase",
                children: label
            }),
            dashboardVisible ? /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $afdfbac274da5706$export$2e2bcd8739ae039), {
                className: "rf-h-6 rf-w-6"
            }) : /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $2b2ac986a23018e3$export$2e2bcd8739ae039), {
                className: "rf-h-6 rf-w-6"
            })
        ]
    });
};
var $70f9c74a044f19d9$export$2e2bcd8739ae039 = $70f9c74a044f19d9$var$DashboardButton;


const $4becae071fdebff0$var$AbsoluteLargeClosingButton = ({ dashboardVisible: dashboardVisible, zIndexClassname: zIndexClassname, onClick: onClick })=>{
    const { isMobile: isMobile } = (0, $8b59a4dbb18c269b$export$3abe3478af3cb63b)();
    const top = (0, $7b896b1616483503$export$2e2bcd8739ae039)();
    return isMobile ? /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eO7Kz))).Fragment, {}) : /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("div", {
        className: `rf-absolute rf-w-24 rf-flex rf-justify-center rf-right-0 ${zIndexClassname}`,
        style: {
            top: top
        },
        children: /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $70f9c74a044f19d9$export$2e2bcd8739ae039), {
            dashboardVisible: dashboardVisible,
            onClick: onClick
        })
    });
};
var $4becae071fdebff0$export$2e2bcd8739ae039 = $4becae071fdebff0$var$AbsoluteLargeClosingButton;


const $66f1584cfff93673$var$SubMenu = ({ background: background, onClick: onClick, children: children })=>{
    const { currentDeviceType: currentDeviceType, isMobile: isMobile } = (0, $8b59a4dbb18c269b$export$3abe3478af3cb63b)();
    return /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($eO7Kz))).Fragment, {
        children: [
            !isMobile && onClick && /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $4becae071fdebff0$export$2e2bcd8739ae039), {
                dashboardVisible: true,
                zIndexClassname: "rf-z-util",
                onClick: onClick
            }),
            currentDeviceType === (0, $16ad089b9ce6627d$export$ec1e04e4e5ef8233).borne ? /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsxs)((0, $55cde5205173a884$export$2e2bcd8739ae039), {
                className: "rf-z-dropdown rf-flex rf-flex-col rf-pt-[25vh] rf-pb-[15vh] rf-justify-start rf-items-center rf-shadow-[20px_3px_20px_#00000029] rf-overflow-y-scroll rf-scrollbar-hidden",
                background: background || "#FFFFFF",
                children: [
                    /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $9856d835783ad65d$export$2e2bcd8739ae039), {}),
                    children
                ]
            }) : currentDeviceType === (0, $16ad089b9ce6627d$export$ec1e04e4e5ef8233).landscape ? /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $590d7215cbc4acb3$export$2e2bcd8739ae039), {
                background: background || "#FFFFFF",
                children: children
            }) : /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $47178ad01294ff29$export$2e2bcd8739ae039), {
                depth: (0, $16ad089b9ce6627d$export$950556173b6cbecb).dropdown,
                children: children
            })
        ]
    });
};
var $66f1584cfff93673$export$2e2bcd8739ae039 = $66f1584cfff93673$var$SubMenu;



parcelRequire("eO7Kz");






parcelRequire("eO7Kz");


const $53c3829f3df8be22$var$BackButton = ({ title: title, className: className, handleBack: handleBack })=>{
    return /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsxs)("button", {
        className: `rf-flex rf-flex-row rf-items-center ${className}`,
        onClick: handleBack,
        "aria-label": title,
        children: [
            /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $ec723792d02ac7e8$export$2e2bcd8739ae039), {
                className: "rf-w-8"
            }),
            /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("div", {
                className: "rf-ml-1",
                children: (0, $8fd1ab545cc1ab7a$export$d07f57595c356899)(title)
            })
        ]
    });
};
var $53c3829f3df8be22$export$2e2bcd8739ae039 = $53c3829f3df8be22$var$BackButton;


/* eslint-disable react/jsx-boolean-value */ 
parcelRequire("eO7Kz");






var $eO7Kz = parcelRequire("eO7Kz");




var $eO7Kz = parcelRequire("eO7Kz");

var $gySRD = parcelRequire("gySRD");


var $e2141f1e3ec1b348$exports = {};
$e2141f1e3ec1b348$exports = JSON.parse('{"fr-FR":{"1":"accueil","2":"cha\xeene info live","3":"m\xe9t\xe9o","4":"num\xe9ros d\'urgence","1000":"historique","1001":"tutoriel"},"en-US":{"1":"home","2":"live info channel","3":"weather","4":"emergency numbers","1000":"history","1001":"tutorial"},"es-ES":{"1":"home","2":"live info channel","3":"weather","4":"emergency numbers","1000":"history","1001":"tutorial"},"de-DE":{"1":"home","2":"live info channel","3":"weather","4":"emergency numbers","1000":"history","1001":"tutorial"}}');





parcelRequire("eO7Kz");

/* eslint-disable react/self-closing-comp */ 
parcelRequire("eO7Kz");
const $5208182085f9f5ff$var$EmergencyIcon = ({ className: className, color: color })=>{
    return /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("svg", {
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        x: "0px",
        y: "0px",
        className: className || "rf-h-6 rf-w-6",
        viewBox: "0 0 512 512",
        xmlSpace: "preserve",
        children: /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsxs)("g", {
            fill: color || "#1999B1",
            children: [
                /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("path", {
                    d: "M294.4,182.4h34.1v34.1c0,3.9,3.1,7,7,7h47c3.9,0,7-3.1,7-7v-34.1h34.1c3.9,0,7-3.1,7-7v-47c0-3.9-3.1-7-7-7h-34.1V87.3   c0-3.9-3.1-7-7-7h-47c-3.9,0-7,3.1-7,7v34.1h-34.1c-3.9,0-7,3.1-7,7v47C287.4,179.3,290.6,182.4,294.4,182.4z M301.4,135.4h34.1   c3.9,0,7-3.1,7-7V94.3h33v34.1c0,3.9,3.1,7,7,7h34.1v33h-34.1c-3.9,0-7,3.1-7,7v34.1h-33v-34.1c0-3.9-3.1-7-7-7h-34.1V135.4z"
                }),
                /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("path", {
                    d: "M218.1,285.1c0.1,3.8,3.2,6.8,6.9,6.8c0.9,0,95.2,1.1,133.1,1.1c78.5,0,142.5-63.9,142.5-142.5S436.7,8.2,358.1,8.2   c-78.5,0-142.5,63.9-142.5,142.5C215.7,186.8,218.1,284.2,218.1,285.1z M358.1,22.2c70.8,0,128.5,57.6,128.5,128.5   S429,279.1,358.1,279.1c-31.9,0-103.8-0.8-126.2-1c-0.5-22.8-2.3-97-2.3-127.4C229.7,79.8,287.3,22.2,358.1,22.2z"
                }),
                /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("path", {
                    d: "M191.5,94c1,0.5,2,0.7,3,0.7c2.6,0,5.1-1.5,6.3-4c0.2-0.4,21.5-45.1,51-70.9c2.9-2.5,3.2-7,0.7-9.9c-2.5-2.9-7-3.2-9.9-0.7   c-31.8,27.7-53.6,73.5-54.5,75.5C186.5,88.2,188,92.3,191.5,94z"
                }),
                /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("path", {
                    d: "M176.6,60.1c1.1,0.6,2.2,0.8,3.3,0.8c2.5,0,4.9-1.3,6.2-3.7c0.1-0.2,13.2-24.6,27.9-36.4c3-2.4,3.5-6.8,1.1-9.8   c-2.4-3-6.8-3.5-9.8-1.1c-16.9,13.6-30.9,39.6-31.5,40.7C171.9,54.1,173.2,58.3,176.6,60.1z"
                }),
                /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("path", {
                    d: "M490.2,255.8c-0.3,0.4-34.6,36.1-70.7,51.3c-3.6,1.5-5.2,5.6-3.7,9.2c1.1,2.7,3.7,4.3,6.5,4.3c0.9,0,1.8-0.2,2.7-0.5   c38.9-16.3,73.9-53,75.4-54.6c2.7-2.8,2.5-7.2-0.3-9.9S492.8,253,490.2,255.8z"
                }),
                /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("path", {
                    d: "M503.6,292.4c-2.7-2.8-7.1-2.9-9.9-0.2c-0.2,0.2-20.3,19.2-37.9,25.8c-3.6,1.4-5.5,5.4-4.1,9c1.1,2.8,3.7,4.5,6.6,4.5   c0.8,0,1.6-0.1,2.5-0.4c20.3-7.6,41.8-27.9,42.7-28.8C506.2,299.6,506.3,295.2,503.6,292.4z"
                }),
                /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("path", {
                    d: "M490.2,372.5c-1.6-0.5-40.7-13.2-71.4,4c-16,9-26.7,24.2-31.6,45.4c-12.9,55-48.2,58-85.6,52l17.2-10   c18.4-10.7,24.7-34.4,14-52.8L302.5,359c-10.7-18.4-34.4-24.7-52.8-14l-36.7,21.3c-0.2,0.1-0.3,0.2-0.5,0.3c-0.1,0-6.4,4-17.1,1.6   c-12.6-2.7-32.6-14.3-56.7-53.7c-22-39.9-22.4-62.9-18.8-75.2c3.1-10.5,9.4-14.3,10.1-14.7c0.2-0.1,0.2-0.1,0.4-0.2l36.7-21.3   c18.4-10.7,24.7-34.4,14-52.8L151,98.2c-10.7-18.4-34.4-24.7-52.8-14L60.8,106c-0.1,0-0.2,0.1-0.2,0.1c-1.5,1-38.1,24.6-48.6,67   C-4,237.2,63,350,65.9,354.7c0.3,0.6,0.8,1.1,1.2,1.5c0.1,0.6,0.4,1.2,0.7,1.8c2.7,4.8,67.5,118.9,131,136.8   c42.1,11.8,80.7-8.2,82.3-9c0.1,0,0.2-0.1,0.2-0.1l2.4-1.4c0.7,0.5,1.6,0.9,2.5,1c12.3,2.5,25.9,4.8,39.4,4.8   c8.5,0,17-0.9,25.2-3.4c25.4-7.6,42.2-28.3,50-61.7c4-17.1,12.3-29.3,24.8-36.3c25.3-14.2,59.9-3.1,60.2-3c3.7,1.2,7.6-0.8,8.8-4.4   C495.9,377.7,493.9,373.8,490.2,372.5z M256.8,357.2c11.7-6.8,26.8-2.8,33.7,8.9l30.3,52.1c6.8,11.7,2.8,26.8-8.9,33.7l-9.5,5.5   c-39.1-34.5-52.5-80.7-55.8-94.2L256.8,357.2z M202.6,481.4C144.7,465.1,80.7,352.3,80,351.2c-0.4-0.6-0.8-1.2-1.3-1.7   c-0.2-0.7-0.4-1.4-0.8-2c-0.7-1.1-66.9-112.5-52.4-171c8.9-35.9,40.5-57.3,42.4-58.5l14.6-8.5c1.8,7,5.2,18,10.9,30.9   c1.6,3.5,5.7,5.1,9.2,3.6c0.2-0.1,0.5-0.2,0.7-0.4c3-1.8,4.3-5.6,2.9-8.9c-6.6-14.8-9.8-27-11.1-32.6l10.1-5.9   c11.7-6.8,26.8-2.8,33.7,8.9l30.3,52.1c6.8,11.7,2.8,26.8-8.9,33.7l-9.6,5.6c-11.1-9.9-21-21.4-29.5-34.5c-2.1-3.2-6.4-4.1-9.7-2   c-3.2,2.1-4.1,6.5-2,9.7c8.3,12.7,17.9,24.2,28.6,34.2l-14.2,8.2c-2.2,1.1-12.1,7-16.9,22.3c-6.6,21-0.5,49.1,18,83.7   c0.2,0.5,0.4,1,0.6,1.4c0.4,0.7,0.8,1.3,1.2,2c0.4,0.7,0.7,1.3,1.1,2c0.3,0.5,0.6,0.9,0.9,1.3c20.9,33.2,42.3,52.4,63.8,57.1   c15.7,3.4,25.7-2.3,27.7-3.6l13.7-7.9c4.7,18.1,19,60.2,55.7,94.3l-15.1,8.8C272.4,474.6,238.4,491.5,202.6,481.4z"
                })
            ]
        })
    });
};
var $5208182085f9f5ff$export$2e2bcd8739ae039 = $5208182085f9f5ff$var$EmergencyIcon;


/* eslint-disable react/self-closing-comp */ 
parcelRequire("eO7Kz");
const $375b88ba82918e51$var$HomeIcon = ({ className: className, color: color })=>{
    return /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        className: className || "rf-h-6 rf-w-6",
        viewBox: "0 0 25 25",
        children: /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("path", {
            d: "M39.908,31.05l-4.784-4.784V21.032a.312.312,0,0,0-.312-.312H31.887a.312.312,0,0,0-.312.312v1.685L27.72,18.861a.312.312,0,0,0-.441,0L15.091,31.05a.312.312,0,1,0,.441.441L17.925,29.1V42.483a.312.312,0,0,0,.312.312h6.825a.312.312,0,0,0,.312-.312V35.97h4.252v6.514a.312.312,0,0,0,.312.312h6.825a.312.312,0,0,0,.312-.312V29.1l2.393,2.393a.312.312,0,1,0,.441-.441ZM32.2,21.344h2.3v4.3l-2.3-2.3Zm4.252,20.827h-6.2V35.658a.312.312,0,0,0-.312-.312H25.062a.312.312,0,0,0-.312.312v6.514h-6.2v-13.7L27.5,19.523l4.167,4.167h0l2.925,2.925h0l1.859,1.859Z",
            transform: "translate(-15 -18.77)",
            fill: color || "#1999b1"
        })
    });
};
var $375b88ba82918e51$export$2e2bcd8739ae039 = $375b88ba82918e51$var$HomeIcon;


/* eslint-disable react/self-closing-comp */ 
parcelRequire("eO7Kz");
const $d583155dcf79c4bc$var$InteractiveMapIcon = ({ className: className, color: color })=>{
    return /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsxs)("svg", {
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        x: "0px",
        y: "0px",
        className: className || "rf-h-6 rf-w-6",
        viewBox: "0 0 512 512",
        xmlSpace: "preserve",
        children: [
            /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("g", {
                fill: color || "#1999B1",
                children: /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("g", {
                    children: /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("path", {
                        d: "M256,93.297c-14.021,0-27.516,4.218-39.025,12.198c-3.402,2.359-4.262,7.05-1.921,10.478 c2.342,3.428,6.998,4.294,10.4,1.936c9.004-6.243,19.566-9.543,30.546-9.543c29.754,0,53.96,24.388,53.96,54.365 c0,29.977-24.206,54.366-53.96,54.366c-29.754,0-53.96-24.389-53.96-54.366c0-8.843,2.038-17.273,6.057-25.055 c1.906-3.692,0.482-8.241-3.182-10.161c-3.665-1.919-8.178-0.486-10.085,3.206c-5.067,9.812-7.746,20.881-7.746,32.01 C187.085,201.018,218,232.166,256,232.166s68.915-31.148,68.915-69.435C324.915,124.445,294,93.297,256,93.297z"
                    })
                })
            }),
            /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("g", {
                fill: color || "#1999B1",
                children: /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("g", {
                    children: /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("path", {
                        d: "M511.426,501.571l-73.804-178.665c-1.16-2.809-3.883-4.639-6.903-4.639h-73.547 c14.305-19.498,26.212-38.919,35.511-57.988c16.48-33.794,24.835-66.613,24.835-97.547C417.517,73.001,345.061,0,256,0 S94.483,73.001,94.483,162.731c0,30.934,8.355,63.754,24.835,97.547c9.298,19.069,21.205,38.491,35.511,57.988H81.282 c-3.02,0-5.744,1.831-6.903,4.639L24.087,444.651c-1.587,3.842,0.217,8.252,4.03,9.85c0.94,0.394,1.912,0.581,2.87,0.581 c2.93,0,5.711-1.746,6.906-4.641l7.176-17.372h50.906l-26.38,63.862H18.69l7.647-18.513c1.587-3.842-0.217-8.252-4.03-9.85 c-3.815-1.601-8.191,0.219-9.777,4.06L0.575,501.571c-0.961,2.325-0.705,4.981,0.683,7.075c1.386,2.095,3.72,3.354,6.22,3.354 h497.044c2.499,0,4.834-1.259,6.221-3.354C512.13,506.552,512.387,503.896,511.426,501.571z M109.439,162.731 c0-81.422,65.747-147.663,146.561-147.663S402.561,81.31,402.561,162.731c0,34.143-11.775,88.703-66.245,158.231 c-0.055,0.065-0.104,0.134-0.156,0.201c-2.782,3.547-5.672,7.132-8.681,10.757c-29.932,36.062-60.222,62.395-71.48,71.751 c-11.225-9.324-41.372-35.525-71.283-71.518c-3.084-3.711-6.042-7.38-8.889-11.01c-0.046-0.058-0.089-0.118-0.137-0.175 C121.222,251.445,109.439,196.887,109.439,162.731z M86.269,333.335h50.907l-18.568,44.948H67.702L86.269,333.335z M129.997,496.932l46.741-113.148l133.014,113.148H129.997z M332.935,496.932L332.935,496.932l-154.352-131.3 c-1.822-1.551-4.27-2.132-6.584-1.566c-2.316,0.565-4.228,2.21-5.143,4.427l-53.057,128.438H85.795l28.296-68.502 c0.961-2.325,0.705-4.98-0.683-7.075c-1.386-2.095-3.721-3.354-6.221-3.354H51.296l10.182-24.65h62.118 c3.02,0,5.744-1.831,6.903-4.639l22.876-55.377h12.978c2.253,2.83,4.543,5.661,6.894,8.491 c38.585,46.43,76.578,76.239,78.177,77.486c1.348,1.051,2.962,1.575,4.576,1.575s3.229-0.525,4.576-1.575 c0.879-0.685,12.757-10.009,29.673-25.96h84.681c4.13,0,7.478-3.373,7.478-7.534s-3.348-7.534-7.478-7.534h-69.269 c10.368-10.503,21.7-22.749,33.093-36.457c2.351-2.83,4.642-5.66,6.894-8.491h80.083l18.567,44.948h-39.457 c-4.13,0-7.478,3.373-7.478,7.534s3.347,7.534,7.478,7.534h45.681l10.182,24.65h-154.07c-3.121,0-5.913,1.952-7.006,4.898 c-1.091,2.946-0.253,6.265,2.104,8.326l75.133,65.707H332.935z M399.681,496.932l-73.024-63.862H466.93l26.381,63.862H399.681z"
                    })
                })
            }),
            /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("g", {}),
            /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("g", {}),
            /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("g", {}),
            /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("g", {}),
            /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("g", {}),
            /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("g", {}),
            /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("g", {}),
            /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("g", {}),
            /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("g", {}),
            /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("g", {}),
            /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("g", {}),
            /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("g", {}),
            /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("g", {}),
            /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("g", {}),
            /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("g", {})
        ]
    });
};
var $d583155dcf79c4bc$export$2e2bcd8739ae039 = $d583155dcf79c4bc$var$InteractiveMapIcon;


/* eslint-disable react/self-closing-comp */ 
parcelRequire("eO7Kz");
const $b5603eb67ba1d8c6$var$NewsChannelIcon = ({ className: className, color: color })=>{
    return /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("svg", {
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        x: "0px",
        y: "0px",
        viewBox: "0 0 512 512",
        className: className || "rf-h-6 rf-w-6",
        xmlSpace: "preserve",
        children: /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsxs)("g", {
            fill: color || "#1999B1",
            children: [
                /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("path", {
                    d: "M500.9,13.5H325.3c-3.9,0-7,3.1-7,7v142.4c0,3.9,3.1,7,7,7h39.6v41.4c0,2.7,1.6,5.2,4,6.3c0.9,0.4,2,0.7,3,0.7   c1.6,0,3.2-0.6,4.5-1.6l55.5-46.8h68.9c3.9,0,7-3.1,7-7V20.5C507.9,16.6,504.8,13.5,500.9,13.5z M493.9,155.9h-64.5   c-1.6,0-3.2,0.6-4.5,1.6l-46,38.7v-33.4c0-3.9-3.1-7-7-7h-39.6V27.5h161.6V155.9z"
                }),
                /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("path", {
                    d: "M386.2,66h28.2c3.9,0,7-3.1,7-7s-3.1-7-7-7h-28.2c-3.9,0-7,3.1-7,7S382.3,66,386.2,66z"
                }),
                /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("path", {
                    d: "M436.7,66h32.6c3.9,0,7-3.1,7-7s-3.1-7-7-7h-32.6c-3.9,0-7,3.1-7,7S432.8,66,436.7,66z"
                }),
                /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("path", {
                    d: "M355.6,98.5h113.7c3.9,0,7-3.1,7-7s-3.1-7-7-7H355.6c-3.9,0-7,3.1-7,7S351.7,98.5,355.6,98.5z"
                }),
                /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("path", {
                    d: "M355.6,130.8h113.7c3.9,0,7-3.1,7-7s-3.1-7-7-7H355.6c-3.9,0-7,3.1-7,7S351.7,130.8,355.6,130.8z"
                }),
                /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("path", {
                    d: "M335.4,277.7c-17-4.2-47.9-12.2-60.2-15.4c0.7-1.7,0.7-3.6-0.1-5.4c-0.9-2-2.6-3.5-4.7-4l-40.8-10.2v-12.9   c18.6-11.3,32.3-30.3,37-52.8h12.9c12.1,0,21.9-9.8,21.9-21.9s-9.8-21.9-21.9-21.9h-12c4.4-7.2,16.2-28.5,16.6-48.9   c0.4-26.5-29.5-49.5-37.6-53.3c-1.1-0.5-2.8-1.6-4.9-2.8c-10-5.9-28.6-16.9-50.6-16.9c-32.8,0.1-55.2,25-56.1,26.1   c-0.4,0.5-0.8,1-1,1.6C112,43.2,95.5,62.5,95.5,85.6c0,3.1,0.3,6.3,0.9,9.5c0.1,0.4,0.2,0.9,0.4,1.3l14.7,36.8h-9.8   c-12.1,0-21.9,9.8-21.9,21.9s9.8,21.9,21.9,21.9h12.9c4.7,22.5,18.4,41.5,36.9,52.8v12.9l-40.8,10.2c-2.1,0.5-3.9,2-4.7,4   c-0.8,1.8-0.8,3.8,0,5.5l-62.7,16.7c0,0-0.1,0-0.1,0c-1.1,0.3-26.8,8.1-26.8,42.2v140.6c0,0.3,0,0.6,0.1,0.8   c1.8,14.9,12.5,43,40.2,43h299.3c3.9,0,7-3.1,7-7l0-177.9C362.9,319.3,362.1,284.3,335.4,277.7z M258.1,264.3l-29.1,52l-25.1-27.9   c16.2-5.9,23.6-21.6,25.5-31.3L258.1,264.3z M287.4,155.1c0,4.4-3.5,7.9-7.9,7.9h-11.2c0-1,0.1-2.1,0.1-3.1c0-4.4-0.2-8.6-0.6-12.7   h11.7C283.9,147.2,287.4,150.7,287.4,155.1z M109.5,85.6c0-18.5,15.1-33.6,33.6-33.6c12.2,0,23.5,6.7,29.4,17.4   c1.9,3.4,6.1,4.6,9.5,2.7c3.4-1.9,4.6-6.1,2.7-9.5c-6.6-12-18-20.4-31.1-23.4c8-6.1,21.3-13.9,37.3-13.9c18.2,0,34,9.3,43.4,14.9   c2.5,1.5,4.4,2.6,6.1,3.4c5.1,2.4,29.8,21.3,29.6,40.4c-0.2,11.4-5.1,23.7-9.4,32.4c-2.6-6.8-5.8-13.6-9.8-20.7   c-1.1-2-3.1-3.3-5.4-3.5c-2.2-0.2-4.5,0.6-6,2.3c-0.2,0.2-20,22.1-49,22.2c-28.9-0.2-48.8-22-49-22.2c-1.5-1.7-3.7-2.6-6-2.3   c-2.3,0.2-4.3,1.5-5.4,3.5c-4.2,7.4-7.5,14.4-10.1,21.5l-10.1-25.4C109.7,89.8,109.5,87.6,109.5,85.6z M101.7,163   c-4.4,0-7.9-3.5-7.9-7.9s3.5-7.9,7.9-7.9h11.7c-0.4,4.1-0.6,8.3-0.6,12.7c0,1,0,2.1,0.1,3.1H101.7z M126.8,159.9   c0-17.8,3.5-33,11.5-49.3c9.5,7.9,27.7,19.9,51.7,20.2c0.1,0,0.2,0,0.3,0c0.1,0,0.2,0,0.3,0c0.1,0,0.2,0,0.3,0c0.1,0,0.2,0,0.3,0   c24-0.3,42.3-12.3,51.7-20.2c8,16.3,11.5,31.5,11.5,49.3c0,36.8-28.6,66.8-63.8,67C155.4,226.7,126.8,196.7,126.8,159.9z   M189.5,240.9c0.2,0,0.5,0,0.7,0c0.1,0,0.3,0,0.4,0c0.1,0,0.3,0,0.4,0c0.3,0,0.5,0,0.7,0c8.3-0.2,16.3-1.7,23.9-4.4v17.8   c-0.8,3.5-5.8,22.1-25,22.3c-19.3-0.2-24.3-18.9-25.1-22.3v-17.9C173,239.2,181.1,240.7,189.5,240.9z M151.8,257.1   c1.9,9.7,9.3,25.4,25.5,31.3l-25.1,27.9l-29.1-52L151.8,257.1z M209.4,445.8c2.1,0.8,8.2,4.2,8.2,16.5v29.4h-53.8v-45.9H209.4z   M208.3,369.8h-34.6v-15.2c0-9.5,7.8-17.3,17.3-17.3s17.3,7.8,17.3,17.3V369.8z M219.9,383.8V403H159v-19.3H219.9z M199.9,417v14.8   h-18.8V417H199.9z M348.9,491.7h-56.1V381.6c0-3.9-3.1-7-7-7s-7,3.1-7,7v110.1h-47.2v-29.4c0-13-5.1-20.5-9.3-24.5   c-3.2-3-6.4-4.5-8.4-5.2V417h13c3.9,0,7-3.1,7-7v-33.3c0-3.9-3.1-7-7-7h-4.6v-15.2c0-17.3-14-31.3-31.3-31.3s-31.3,14-31.3,31.3   v15.2H152c-3.9,0-7,3.1-7,7V410c0,3.9,3.1,7,7,7h15.2v14.8h-65.8v-49.8c0-3.9-3.1-7-7-7s-7,3.1-7,7v56.8c0,3.9,3.1,7,7,7h55.5v45.9   H56.6c-21.1,0-25.7-26.6-26.3-30.3V321.3c0-23.1,15.7-28.4,16.6-28.7l66-17.5l31.7,56.6c1.1,2,3.1,3.3,5.3,3.5c0.3,0,0.5,0,0.8,0   c2,0,3.9-0.8,5.2-2.3l34.5-38.4l34.5,38.4c1.3,1.5,3.2,2.3,5.2,2.3c0.3,0,0.5,0,0.8,0c2.2-0.2,4.2-1.6,5.3-3.5l31.8-56.7   c8.6,2.2,44.9,11.7,63.9,16.4c15.9,3.9,16.8,28.5,16.8,29.6V491.7z"
                })
            ]
        })
    });
};
var $b5603eb67ba1d8c6$export$2e2bcd8739ae039 = $b5603eb67ba1d8c6$var$NewsChannelIcon;


/* eslint-disable react/self-closing-comp */ 
parcelRequire("eO7Kz");
const $d2eed5123295ffb9$var$WeatherIcon = ({ className: className, color: color })=>{
    return /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("svg", {
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        x: "0px",
        y: "0px",
        className: className || "rf-h-6 rf-w-6",
        viewBox: "0 0 512 512",
        xmlSpace: "preserve",
        children: /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("g", {
            fill: color || "#1999B1",
            children: /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsxs)("g", {
                children: [
                    /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("path", {
                        d: "M439.2,385.3c0.7-3.5,1-7,1-10.6c0-31.2-25.4-56.5-56.5-56.5c-6.5,0-13,1.1-19.1,3.3c-1.4-3.6-3-7.1-4.8-10.4    C392,287.3,411,249.8,411,209.6c0-69.5-56.5-126-126-126c-69.5,0-126,56.5-126,126c0,5.7,0.4,11.3,1.1,16.9    c-16.7,9.5-30,24.6-37.2,43c-5.5-1.9-11.4-2.9-17.3-2.9c-29.1,0-52.7,23.6-52.7,52.7c0,3.2,0.3,6.4,0.9,9.5    c-20.8,10.3-34.5,31.8-34.5,55.3c0,34,27.6,61.6,61.6,61.6c0.7,0.2,1.4,0.3,2.1,0.3h26.1c2.9,15.6,10.3,29.9,21.6,41.4    c14.2,14.4,33,22.8,53.2,23.7c0.8,0.3,1.6,0.4,2.5,0.4h221.5c0.8,0,1.5-0.1,2.2-0.3c0,0,0.1,0,0.1,0c36.5,0,66.2-29.7,66.2-66.2    C476.6,419.5,461.8,396.3,439.2,385.3z M173.1,209.6c0-61.7,50.2-112,112-112s112,50.2,112,112c0,35.4-16.7,68.5-44.8,89.6    c-17-22.6-44-36.7-73.4-36.7c-0.1,0-0.1,0-0.2,0c-14.3-28.8-43.8-47.2-76.2-47.2c-10,0-19.7,1.8-28.8,5.1    C173.3,216.7,173.1,213.2,173.1,209.6z M85.4,432c-0.8-0.3-1.7-0.4-2.5-0.4c-0.6,0-1.2,0-1.8,0c-26.3,0-47.6-21.4-47.6-47.6    c0-19.8,12.5-37.8,31.1-44.7c3.5-1.3,5.4-5.1,4.3-8.6c-1.1-3.7-1.7-7.6-1.7-11.5c0-21.3,17.4-38.7,38.7-38.7    c6.3,0,12.6,1.6,18.2,4.5c1.9,1,4.1,1.1,6,0.3c1.9-0.8,3.4-2.5,4-4.5c8.6-30.4,36.8-51.6,68.4-51.6c25.2,0,48.2,13.3,61,34.5    c-42.5,7.2-75.1,43.8-76.2,88c-43.7,0.3-79.2,35.9-79.2,79.7c0,0.2,0,0.4,0,0.6H85.4z M410.3,497.2c-0.7,0-1.3,0-2-0.1    c-0.9,0-1.8,0.1-2.6,0.4H188.9c-0.7-0.2-1.4-0.4-2.2-0.4c-17.4-0.3-33.6-7.2-45.8-19.6c-12.2-12.4-18.9-28.8-18.9-46.1    c0-36.2,29.5-65.7,65.7-65.7c1.9,0,3.9,0.1,6,0.3c2,0.2,4-0.5,5.5-1.9s2.2-3.4,2.1-5.4c-0.1-1.6-0.1-3.1-0.1-4.5    c0-42.8,34.8-77.7,77.7-77.7c34.6,0,65.3,23.2,74.7,56.4c0.6,2,2,3.7,4,4.5c1.9,0.8,4.2,0.7,6-0.3c6.1-3.3,13-5,20-5    c23.5,0,42.5,19.1,42.5,42.5c0,4.3-0.6,8.6-1.9,12.6c-1.1,3.6,0.8,7.3,4.3,8.6c20.4,7.6,34.1,27.2,34.1,49    C462.6,473.8,439.2,497.2,410.3,497.2z"
                    }),
                    /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("path", {
                        d: "M485.4,203.6H443c-3.9,0-7,3.1-7,7s3.1,7,7,7h42.4c3.9,0,7-3.1,7-7S489.3,203.6,485.4,203.6z"
                    }),
                    /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("path", {
                        d: "M84.6,217.6h42.4c3.9,0,7-3.1,7-7s-3.1-7-7-7H84.6c-3.9,0-7,3.1-7,7S80.7,217.6,84.6,217.6z"
                    }),
                    /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("path", {
                        d: "M284.7,58.9c3.9,0,7-3.1,7-7V9.5c0-3.9-3.1-7-7-7s-7,3.1-7,7v42.4C277.7,55.7,280.8,58.9,284.7,58.9z"
                    }),
                    /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("path", {
                        d: "M360,79.4c1.1,0.6,2.3,0.9,3.5,0.9c2.4,0,4.8-1.3,6.1-3.5l21.2-36.7c1.9-3.3,0.8-7.6-2.6-9.6    s-7.6-0.8-9.6,2.6l-21.2,36.7C355.5,73.2,356.7,77.4,360,79.4z"
                    }),
                    /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("path", {
                        d: "M199.7,76.8c1.3,2.2,3.6,3.5,6.1,3.5c1.2,0,2.4-0.3,3.5-0.9c3.3-1.9,4.5-6.2,2.6-9.6l-21.2-36.7    c-1.9-3.3-6.2-4.5-9.6-2.6s-4.5,6.2-2.6,9.6L199.7,76.8z"
                    }),
                    /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("path", {
                        d: "M107.8,116.6l36.7,21.2c1.1,0.6,2.3,0.9,3.5,0.9c2.4,0,4.8-1.3,6.1-3.5c1.9-3.3,0.8-7.6-2.6-9.6l-36.7-21.2    c-3.3-1.9-7.6-0.8-9.6,2.6S104.5,114.7,107.8,116.6z"
                    }),
                    /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("path", {
                        d: "M422.3,138.7c1.2,0,2.4-0.3,3.5-0.9l36.7-21.2c3.3-1.9,4.5-6.2,2.6-9.6c-1.9-3.3-6.2-4.5-9.6-2.6l-36.7,21.2    c-3.3,1.9-4.5,6.2-2.6,9.6C417.5,137.5,419.9,138.7,422.3,138.7z"
                    }),
                    /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("path", {
                        d: "M416.5,286.6c-1.9,3.3-0.8,7.6,2.6,9.6l36.7,21.2c1.1,0.6,2.3,0.9,3.5,0.9c2.4,0,4.8-1.3,6.1-3.5    c1.9-3.3,0.8-7.6-2.6-9.6l-36.7-21.2C422.8,282.1,418.5,283.3,416.5,286.6z"
                    })
                ]
            })
        })
    });
};
var $d2eed5123295ffb9$export$2e2bcd8739ae039 = $d2eed5123295ffb9$var$WeatherIcon;





parcelRequire("eO7Kz");
const $5236365909a0a806$var$HistoryIcon = ({ className: className, color: color })=>{
    return /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        className: className || "rf-w-6 rf-flex-1",
        viewBox: "0 0 14 14",
        children: [
            /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("defs", {
                children: /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsxs)("filter", {
                    id: "Icon_awesome-history",
                    children: [
                        /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("feOffset", {
                            dy: "3",
                            in: "SourceAlpha"
                        }),
                        /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("feGaussianBlur", {
                            stdDeviation: "3",
                            result: "blur"
                        }),
                        /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("feFlood", {
                            floodOpacity: "0.161",
                            result: "color"
                        }),
                        /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("feComposite", {
                            operator: "out",
                            in: "SourceGraphic",
                            in2: "blur"
                        }),
                        /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("feComposite", {
                            operator: "in",
                            in: "color"
                        }),
                        /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("feComposite", {
                            operator: "in",
                            in2: "SourceGraphic"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsxs)("g", {
                children: [
                    /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("path", {
                        d: "M14.562,7.549A7,7,0,0,1,3.169,13.013a.677.677,0,0,1-.052-1.005l.318-.318a.679.679,0,0,1,.9-.056A5.194,5.194,0,1,0,4,3.778L5.437,5.211a.452.452,0,0,1-.319.771h-4.1A.452.452,0,0,1,.563,5.53v-4.1a.452.452,0,0,1,.771-.319L2.727,2.5A7,7,0,0,1,14.562,7.549ZM9.456,9.773l.277-.356a.677.677,0,0,0-.119-.951L8.466,7.572V4.627a.677.677,0,0,0-.677-.677H7.337a.677.677,0,0,0-.677.677V8.456L8.505,9.892A.677.677,0,0,0,9.456,9.773Z",
                        transform: "translate(-0.563 -0.563)",
                        fill: color || "#a4a7af"
                    }),
                    /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("g", {
                        transform: "matrix(1, 0, 0, 1, 0, 0)",
                        filter: "url(#Icon_awesome-history)",
                        children: /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("path", {
                            d: "M14.562,7.549A7,7,0,0,1,3.169,13.013a.677.677,0,0,1-.052-1.005l.318-.318a.679.679,0,0,1,.9-.056A5.194,5.194,0,1,0,4,3.778L5.437,5.211a.452.452,0,0,1-.319.771h-4.1A.452.452,0,0,1,.563,5.53v-4.1a.452.452,0,0,1,.771-.319L2.727,2.5A7,7,0,0,1,14.562,7.549ZM9.456,9.773l.277-.356a.677.677,0,0,0-.119-.951L8.466,7.572V4.627a.677.677,0,0,0-.677-.677H7.337a.677.677,0,0,0-.677.677V8.456L8.505,9.892A.677.677,0,0,0,9.456,9.773Z",
                            transform: "translate(-0.56 -0.56)",
                            fill: "#fff"
                        })
                    })
                ]
            })
        ]
    });
};
var $5236365909a0a806$export$2e2bcd8739ae039 = $5236365909a0a806$var$HistoryIcon;



parcelRequire("eO7Kz");
const $072caa5b40a1b8df$var$LanguageIcon = ({ className: className, color: color })=>{
    return /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        className: className || "w-6",
        viewBox: "0 0 21 21",
        children: /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("path", {
            d: "M13.49,3A10.5,10.5,0,1,0,24,13.5,10.495,10.495,0,0,0,13.49,3Zm7.277,6.3h-3.1A16.432,16.432,0,0,0,16.22,5.562,8.431,8.431,0,0,1,20.766,9.3ZM13.5,5.142A14.791,14.791,0,0,1,15.505,9.3H11.494A14.791,14.791,0,0,1,13.5,5.142ZM5.373,15.6a8.213,8.213,0,0,1,0-4.2H8.922a17.341,17.341,0,0,0-.147,2.1,17.341,17.341,0,0,0,.147,2.1Zm.861,2.1h3.1a16.432,16.432,0,0,0,1.449,3.738A8.386,8.386,0,0,1,6.234,17.7Zm3.1-8.4h-3.1A8.386,8.386,0,0,1,10.78,5.562,16.432,16.432,0,0,0,9.331,9.3ZM13.5,21.858A14.791,14.791,0,0,1,11.494,17.7h4.011A14.791,14.791,0,0,1,13.5,21.858ZM15.957,15.6H11.043a15.448,15.448,0,0,1-.168-2.1,15.314,15.314,0,0,1,.168-2.1h4.914a15.314,15.314,0,0,1,.168,2.1A15.448,15.448,0,0,1,15.957,15.6Zm.262,5.838A16.431,16.431,0,0,0,17.668,17.7h3.1a8.431,8.431,0,0,1-4.546,3.738ZM18.078,15.6a17.341,17.341,0,0,0,.147-2.1,17.341,17.341,0,0,0-.147-2.1h3.549a8.213,8.213,0,0,1,0,4.2Z",
            transform: "translate(-3 -3)",
            fill: color || "#90939a"
        })
    });
};
var $072caa5b40a1b8df$export$2e2bcd8739ae039 = $072caa5b40a1b8df$var$LanguageIcon;



parcelRequire("eO7Kz");
const $b573100abadc9cd4$var$ParametersIcon = ({ className: className, color: color })=>{
    return /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        className: className || "rf-h-6 rf-w-6",
        viewBox: "0 0 27.005 27.012",
        children: [
            /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("defs", {
                children: /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsxs)("filter", {
                    id: "Icon_ionic-ios-settings",
                    children: [
                        /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("feOffset", {
                            dy: "3",
                            in: "SourceAlpha"
                        }),
                        /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("feGaussianBlur", {
                            stdDeviation: "3",
                            result: "blur"
                        }),
                        /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("feFlood", {
                            floodOpacity: "0.161",
                            result: "color"
                        }),
                        /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("feComposite", {
                            operator: "out",
                            in: "SourceGraphic",
                            in2: "blur"
                        }),
                        /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("feComposite", {
                            operator: "in",
                            in: "color"
                        }),
                        /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("feComposite", {
                            operator: "in",
                            in2: "SourceGraphic"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsxs)("g", {
                children: [
                    /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("path", {
                        d: "M29.276,18a3.475,3.475,0,0,1,2.229-3.242,13.774,13.774,0,0,0-1.667-4.016,3.522,3.522,0,0,1-1.414.3,3.467,3.467,0,0,1-3.172-4.881A13.733,13.733,0,0,0,21.245,4.5a3.472,3.472,0,0,1-6.484,0,13.774,13.774,0,0,0-4.016,1.667,3.467,3.467,0,0,1-3.172,4.881,3.407,3.407,0,0,1-1.414-.3A14.079,14.079,0,0,0,4.5,14.768a3.474,3.474,0,0,1,.007,6.484,13.774,13.774,0,0,0,1.667,4.016,3.469,3.469,0,0,1,4.578,4.578,13.855,13.855,0,0,0,4.016,1.667,3.466,3.466,0,0,1,6.47,0,13.774,13.774,0,0,0,4.016-1.667,3.472,3.472,0,0,1,4.578-4.578A13.855,13.855,0,0,0,31.5,21.252,3.492,3.492,0,0,1,29.276,18Zm-11.21,5.619A5.626,5.626,0,1,1,23.692,18,5.625,5.625,0,0,1,18.066,23.622Z",
                        transform: "translate(-4.5 -4.5)",
                        fill: color || "#a4a7af"
                    }),
                    /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("g", {
                        transform: "matrix(1, 0, 0, 1, 0, 0)",
                        filter: "url(#Icon_ionic-ios-settings)",
                        children: /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("path", {
                            d: "M29.276,18a3.475,3.475,0,0,1,2.229-3.242,13.774,13.774,0,0,0-1.667-4.016,3.522,3.522,0,0,1-1.414.3,3.467,3.467,0,0,1-3.172-4.881A13.733,13.733,0,0,0,21.245,4.5a3.472,3.472,0,0,1-6.484,0,13.774,13.774,0,0,0-4.016,1.667,3.467,3.467,0,0,1-3.172,4.881,3.407,3.407,0,0,1-1.414-.3A14.079,14.079,0,0,0,4.5,14.768a3.474,3.474,0,0,1,.007,6.484,13.774,13.774,0,0,0,1.667,4.016,3.469,3.469,0,0,1,4.578,4.578,13.855,13.855,0,0,0,4.016,1.667,3.466,3.466,0,0,1,6.47,0,13.774,13.774,0,0,0,4.016-1.667,3.472,3.472,0,0,1,4.578-4.578A13.855,13.855,0,0,0,31.5,21.252,3.492,3.492,0,0,1,29.276,18Zm-11.21,5.619A5.626,5.626,0,1,1,23.692,18,5.625,5.625,0,0,1,18.066,23.622Z",
                            transform: "translate(-4.5 -4.5)",
                            fill: "#fff"
                        })
                    })
                ]
            })
        ]
    });
};
var $b573100abadc9cd4$export$2e2bcd8739ae039 = $b573100abadc9cd4$var$ParametersIcon;



parcelRequire("eO7Kz");
const $f3c1b15eda8692b1$var$TutorialIcon = ({ className: className, color: color })=>{
    return /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        className: className || "rf-h-6 rf-w-6",
        viewBox: "0 0 21.039 21.039",
        children: [
            /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("defs", {
                children: /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsxs)("filter", {
                    id: "Icon_ionic-ios-help-buoy",
                    children: [
                        /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("feOffset", {
                            dy: "3",
                            in: "SourceAlpha"
                        }),
                        /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("feGaussianBlur", {
                            stdDeviation: "3",
                            result: "blur"
                        }),
                        /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("feFlood", {
                            floodOpacity: "0.161",
                            result: "color"
                        }),
                        /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("feComposite", {
                            operator: "out",
                            in: "SourceGraphic",
                            in2: "blur"
                        }),
                        /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("feComposite", {
                            operator: "in",
                            in: "color"
                        }),
                        /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("feComposite", {
                            operator: "in",
                            in2: "SourceGraphic"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsxs)("g", {
                "data-type": "innerShadowGroup",
                children: [
                    /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("path", {
                        id: "Icon_ionic-ios-help-buoy-2",
                        "data-name": "Icon ionic-ios-help-buoy",
                        d: "M13.894,3.375A10.519,10.519,0,1,0,24.414,13.894,10.518,10.518,0,0,0,13.894,3.375Zm2.761,1.841a9.126,9.126,0,0,1,5.917,5.917l-4.491.3a4.856,4.856,0,0,0-1.714-1.72Zm-9.2,2.24a9.038,9.038,0,0,1,3.677-2.24l.288,4.5a4.968,4.968,0,0,0-1.714,1.714l-4.5-.3A9.139,9.139,0,0,1,7.456,7.456Zm3.677,15.117a9.126,9.126,0,0,1-5.917-5.917l4.5-.288a4.9,4.9,0,0,0,1.709,1.709Zm2.761-5.239a3.439,3.439,0,1,1,3.439-3.439A3.443,3.443,0,0,1,13.894,17.333Zm6.438,3a9.072,9.072,0,0,1-3.677,2.24l-.3-4.5a4.872,4.872,0,0,0,1.725-1.73l4.491.3A9.056,9.056,0,0,1,20.332,20.332Z",
                        transform: "translate(-3.375 -3.375)",
                        fill: color || "#a4a7af"
                    }),
                    /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("g", {
                        transform: "matrix(1, 0, 0, 1, 0, 0)",
                        filter: "url(#Icon_ionic-ios-help-buoy)",
                        children: /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("path", {
                            d: "M13.894,3.375A10.519,10.519,0,1,0,24.414,13.894,10.518,10.518,0,0,0,13.894,3.375Zm2.761,1.841a9.126,9.126,0,0,1,5.917,5.917l-4.491.3a4.856,4.856,0,0,0-1.714-1.72Zm-9.2,2.24a9.038,9.038,0,0,1,3.677-2.24l.288,4.5a4.968,4.968,0,0,0-1.714,1.714l-4.5-.3A9.139,9.139,0,0,1,7.456,7.456Zm3.677,15.117a9.126,9.126,0,0,1-5.917-5.917l4.5-.288a4.9,4.9,0,0,0,1.709,1.709Zm2.761-5.239a3.439,3.439,0,1,1,3.439-3.439A3.443,3.443,0,0,1,13.894,17.333Zm6.438,3a9.072,9.072,0,0,1-3.677,2.24l-.3-4.5a4.872,4.872,0,0,0,1.725-1.73l4.491.3A9.056,9.056,0,0,1,20.332,20.332Z",
                            transform: "translate(-3.38 -3.38)",
                            fill: "#fff"
                        })
                    })
                ]
            })
        ]
    });
};
var $f3c1b15eda8692b1$export$2e2bcd8739ae039 = $f3c1b15eda8692b1$var$TutorialIcon;




const $671685948e10781f$var$DisplayIcon = ({ view: view, icon: icon, className: className })=>{
    if (view) return view === (0, $16ad089b9ce6627d$export$3b4d92ba873f009a).home ? /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)($375b88ba82918e51$export$2e2bcd8739ae039, {
        className: className
    }) : view === (0, $16ad089b9ce6627d$export$3b4d92ba873f009a).news ? /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)($b5603eb67ba1d8c6$export$2e2bcd8739ae039, {
        className: className
    }) : view === (0, $16ad089b9ce6627d$export$3b4d92ba873f009a).weather ? /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)($d2eed5123295ffb9$export$2e2bcd8739ae039, {
        className: className
    }) : view === (0, $16ad089b9ce6627d$export$3b4d92ba873f009a).emergency ? /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)($5208182085f9f5ff$export$2e2bcd8739ae039, {
        className: className
    }) : view === (0, $16ad089b9ce6627d$export$c5a4c3ea2d78493c).history ? /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)($5236365909a0a806$export$2e2bcd8739ae039, {
        className: className
    }) : view === (0, $16ad089b9ce6627d$export$c5a4c3ea2d78493c).tutorial ? /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)($f3c1b15eda8692b1$export$2e2bcd8739ae039, {
        className: className
    }) : /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)($d583155dcf79c4bc$export$2e2bcd8739ae039, {
        className: className
    });
    else if (icon) return /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("div", {
        className: className,
        children: icon
    });
    return /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $179ad052de55b86f$exports.Fragment), {});
};
var $671685948e10781f$export$2e2bcd8739ae039 = $671685948e10781f$var$DisplayIcon;




function $0d7b0704b930b003$var$instanceOfDisplayGeneratorProps(object) {
    return "view" in object && object.type === "BaseMenu";
}
function $0d7b0704b930b003$var$instanceOfCustomMenuDisplayGeneratorProps(object) {
    return "icon" in object && object.type === "CustomMenu";
}
const $0d7b0704b930b003$var$DisplayGenerator = (props)=>{
    const locale = (0, $2e4dc8fa28d39601$export$6650dace022cfacc)((state)=>state.locale);
    const getActivityByKey = (0, $gySRD.useGetActivityByKey)();
    const { setRoute: setRoute, isMobile: isMobile, homeActivityKey: homeActivityKey, setShowHomeAttachments: setShowHomeAttachments } = (0, $8b59a4dbb18c269b$export$3abe3478af3cb63b)();
    const { setCurrentSubView: setCurrentSubView, setCustomView: setCustomView } = (0, $e599569c1fc3ca2c$export$d8760bee47331b1d)();
    const [label, setLabel] = (0, $eO7Kz.useState)("");
    /**
   * On component mount :
   *  - set label state depending on the locale
   */ (0, $eO7Kz.useEffect)(()=>{
        if ($0d7b0704b930b003$var$instanceOfDisplayGeneratorProps(props)) setLabel((0, (/*@__PURE__*/$parcel$interopDefault($e2141f1e3ec1b348$exports)))[locale]?.[props.view.toString()] || (0, (/*@__PURE__*/$parcel$interopDefault($e2141f1e3ec1b348$exports)))["fr-FR"][props.view.toString()]);
        else if ($0d7b0704b930b003$var$instanceOfCustomMenuDisplayGeneratorProps(props)) {
            if (props.label && typeof props.label === "string") setLabel(props.label);
            else if (props.label && typeof props.label === "object") setLabel(props.label[locale]);
        }
    }, [
        locale
    ]);
    /**
   * On call :
   *  - switch on chosen view
   *  - either display an overlaying page or redirect to another view
   *  - if handleClick is defined, call it
   */ const handleClickOnCard = ()=>{
        if ($0d7b0704b930b003$var$instanceOfDisplayGeneratorProps(props)) switch(props.view){
            case (0, $16ad089b9ce6627d$export$3b4d92ba873f009a).home:
                homeActivityKey && setShowHomeAttachments(getActivityByKey(homeActivityKey));
                isMobile && props.conditionalHandleClick && props.conditionalHandleClick();
                break;
            case (0, $16ad089b9ce6627d$export$3b4d92ba873f009a).news:
                setRoute("news");
                break;
            case (0, $16ad089b9ce6627d$export$3b4d92ba873f009a).weather:
                setCurrentSubView((0, $16ad089b9ce6627d$export$f05d0fed0593ead7).weather);
                break;
            case (0, $16ad089b9ce6627d$export$3b4d92ba873f009a).emergency:
                setCurrentSubView((0, $16ad089b9ce6627d$export$f05d0fed0593ead7).emergency);
                break;
        }
        else if ($0d7b0704b930b003$var$instanceOfCustomMenuDisplayGeneratorProps(props)) {
            // Call props' closing function in mobile mode if asked by the custom component
            isMobile && props.conditionalHandleClick && props.conditionalHandleClick();
            // Display custom component if present
            if (props.customDisplay) {
                setCurrentSubView((0, $16ad089b9ce6627d$export$f05d0fed0593ead7).custom);
                setCustomView({
                    view: props.customDisplay,
                    title: label,
                    icon: props.icon
                });
            }
        }
        props.handleClick && props.handleClick();
    };
    return (0, $674f1d59bae686ab$export$78f16669b353a880).includes(props.device) ? /* On mobile / widget : display available views as lines */ /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsxs)("button", {
        className: `rf-w-full rf-py-3 rf-flex rf-flex-row rf-items-center ${props.indice !== 0 && "rf-border-t rf-border-t-menuBorder"}`,
        onClick: handleClickOnCard,
        "aria-label": label,
        children: [
            $0d7b0704b930b003$var$instanceOfDisplayGeneratorProps(props) ? /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $671685948e10781f$export$2e2bcd8739ae039), {
                view: props.view
            }) : /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $671685948e10781f$export$2e2bcd8739ae039), {
                icon: props.icon,
                className: "rf-max-h-6 rf-max-w-6 rf-flex rf-items-center"
            }),
            /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("div", {
                className: "rf-ml-4 rf-font-bold",
                children: (0, $8fd1ab545cc1ab7a$export$d07f57595c356899)(label)
            })
        ]
    }) : /* On desktop / borne : display available views as buttons at the center of the screen */ /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsxs)("button", {
        className: "rf-h-36 rf-w-36 rf-p-4 rf-flex rf-flex-col rf-items-center rf-justify-between rf-rounded rf-shadow-[3px_3px_16px_#00000029]",
        style: {
            background: "linear-gradient(to left top, #F2F3F6, #E5E6EC)"
        },
        onClick: handleClickOnCard,
        "aria-label": label,
        children: [
            $0d7b0704b930b003$var$instanceOfDisplayGeneratorProps(props) ? /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $671685948e10781f$export$2e2bcd8739ae039), {
                view: props.view,
                className: "rf-h-16"
            }) : /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $671685948e10781f$export$2e2bcd8739ae039), {
                icon: props.icon,
                className: "rf-h-16 rf-w-16 rf-flex"
            }),
            /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("div", {
                className: "rf-uppercase rf-text-[#575F6B] rf-text-xs large-vertical:rf-text-basecustomuppercase",
                children: label
            })
        ]
    });
};
var $0d7b0704b930b003$export$2e2bcd8739ae039 = $0d7b0704b930b003$var$DisplayGenerator;



const $15f49c76b141cf89$var$DisplayViews = ({ handleClick: handleClick, conditionalHandleClick: conditionalHandleClick })=>{
    const { currentDeviceType: currentDeviceType, isMobile: isMobile } = (0, $8b59a4dbb18c269b$export$3abe3478af3cb63b)();
    const { configuration: configuration } = (0, $e599569c1fc3ca2c$export$d8760bee47331b1d)();
    const [finalMenu, setFinalMenu] = (0, $eO7Kz.useState)([]);
    const buildMenu = (menu)=>{
        let fullMenu = [];
        menu.forEach((currentMenu)=>{
            // If the menu has 'icon' as key, it's a CustomMenu. Otherwise it's a BaseMenu
            if (Object.keys(currentMenu).includes("icon")) {
                const customCurrentMenu = currentMenu;
                fullMenu.push(/*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $0d7b0704b930b003$export$2e2bcd8739ae039), {
                    type: "CustomMenu",
                    indice: customCurrentMenu.indice,
                    label: customCurrentMenu.label,
                    icon: customCurrentMenu.icon,
                    device: currentDeviceType,
                    handleClick: ()=>{
                        if (customCurrentMenu.clickHandler) customCurrentMenu.clickHandler();
                        handleClick && handleClick();
                    },
                    customDisplay: customCurrentMenu.customDisplay,
                    conditionalHandleClick: customCurrentMenu.closeParametersOnClickInMobileMode ? conditionalHandleClick : undefined
                }));
            } else fullMenu.push(/*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $0d7b0704b930b003$export$2e2bcd8739ae039), {
                type: "BaseMenu",
                indice: currentMenu.indice,
                view: currentMenu.view,
                device: currentDeviceType,
                handleClick: handleClick,
                conditionalHandleClick: conditionalHandleClick
            }));
        });
        fullMenu = fullMenu.sort((a, b)=>a.props.indice - b.props.indice);
        return fullMenu;
    };
    (0, $eO7Kz.useEffect)(()=>{
        const tempFinalMenu = [];
        // Basic menu
        tempFinalMenu.push(buildMenu(configuration && configuration.baseMenu ? [
            ...configuration.baseMenu
        ] : [
            ...(0, $674f1d59bae686ab$export$9bbca248acc786d3)
        ]));
        // Custom menus
        if (configuration && configuration.customMenu && configuration.customMenu.length > 0) {
            if (Array.isArray(configuration.customMenu[0])) configuration.customMenu.forEach((menuArray)=>{
                tempFinalMenu.push(buildMenu(menuArray));
            });
            else tempFinalMenu.push(buildMenu(configuration.customMenu));
        }
        setFinalMenu(tempFinalMenu);
    }, []);
    return /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eO7Kz))).Fragment, {
        children: finalMenu.map((line, key)=>{
            return isMobile ? /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsxs)("div", {
                className: `${key === 0 && "rf-pb-4"} rf-flex rf-flex-col rf-items-center`,
                children: [
                    key !== 0 && /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("div", {
                        className: "rf-h-6 -rf-mx-6 rf-width-fill-available rf-bg-[#F0F0F0] rf-border-y rf-border-y-menuBorder"
                    }),
                    line.map((e, subkey)=>{
                        return /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eO7Kz))).Fragment, {
                            children: e
                        }, subkey);
                    })
                ]
            }, key) : /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("div", {
                className: "rf-flex rf-flex-row rf-items-center rf-flex-wrap rf-gap-8",
                children: line.map((e, subkey)=>{
                    return /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eO7Kz))).Fragment, {
                        children: e
                    }, subkey);
                })
            }, key);
        })
    });
};
var $15f49c76b141cf89$export$2e2bcd8739ae039 = $15f49c76b141cf89$var$DisplayViews;




var $eO7Kz = parcelRequire("eO7Kz");




var $eO7Kz = parcelRequire("eO7Kz");








function $bc69893582beebcf$var$instanceOfDisplayGeneratorProps(object) {
    return "view" in object && object.type === "BaseMenu";
}
function $bc69893582beebcf$var$instanceOfCustomMenuDisplayGeneratorProps(object) {
    return "icon" in object && object.type === "CustomMenu";
}
const $bc69893582beebcf$var$DisplaySubGenerator = (props)=>{
    const locale = (0, $2e4dc8fa28d39601$export$6650dace022cfacc)((state)=>state.locale);
    const { setCurrentSubView: setCurrentSubView, setCustomView: setCustomView } = (0, $e599569c1fc3ca2c$export$d8760bee47331b1d)();
    const { isMobile: isMobile } = (0, $8b59a4dbb18c269b$export$3abe3478af3cb63b)();
    const [label, setLabel] = (0, $eO7Kz.useState)("");
    /**
   * On component mount :
   *  - set label state depending on the locale
   */ (0, $eO7Kz.useEffect)(()=>{
        if ($bc69893582beebcf$var$instanceOfDisplayGeneratorProps(props)) setLabel((0, (/*@__PURE__*/$parcel$interopDefault($e2141f1e3ec1b348$exports)))[locale]?.[props.view.toString()] || (0, (/*@__PURE__*/$parcel$interopDefault($e2141f1e3ec1b348$exports)))["fr-FR"][props.view.toString()]);
        else if ($bc69893582beebcf$var$instanceOfCustomMenuDisplayGeneratorProps(props)) {
            if (props.label && typeof props.label === "string") setLabel(props.label);
            else if (props.label && typeof props.label === "object") setLabel(props.label[locale]);
        }
    }, [
        locale
    ]);
    /**
   * On call :
   *  - switch on chosen view
   *  - either display an overlaying page or redirect to another view
   *  - if handleClick is defined, call it
   */ const handleClickOnCard = ()=>{
        if ($bc69893582beebcf$var$instanceOfDisplayGeneratorProps(props)) switch(props.view){
            case (0, $16ad089b9ce6627d$export$c5a4c3ea2d78493c).history:
                setCurrentSubView((0, $16ad089b9ce6627d$export$f05d0fed0593ead7).history);
                break;
            case (0, $16ad089b9ce6627d$export$c5a4c3ea2d78493c).tutorial:
                console.log("Tutorial");
                break;
        }
        else if ($bc69893582beebcf$var$instanceOfCustomMenuDisplayGeneratorProps(props)) {
            // Call props' closing function in mobile mode if asked by the custom component
            isMobile && props.conditionalHandleClick && props.conditionalHandleClick();
            if (props.customDisplay) {
                setCurrentSubView((0, $16ad089b9ce6627d$export$f05d0fed0593ead7).custom);
                setCustomView({
                    view: props.customDisplay,
                    title: label,
                    icon: props.icon
                });
            }
        }
        props.handleClick && props.handleClick();
    };
    return (0, $674f1d59bae686ab$export$78f16669b353a880).includes(props.device) ? /* On mobile / widget : display available views as lines, without icons */ /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("button", {
        className: `rf-w-full rf-py-4 rf-flex rf-flex-row rf-items-center ${props.indice !== 0 && "rf-border-t rf-border-t-menuBorder"}`,
        onClick: handleClickOnCard,
        "aria-label": label,
        children: (0, $8fd1ab545cc1ab7a$export$d07f57595c356899)(label)
    }) : /* On desktop / borne : display available views as buttons at the center of the screen */ /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsxs)("button", {
        className: "rf-h-24 rf-w-24 rf-p-4 rf-flex rf-flex-col rf-items-center rf-justify-between rf-rounded rf-shadow-[3px_3px_16px_#00000029]",
        style: {
            background: "linear-gradient(to left top, #F2F3F6, #E5E6EC)"
        },
        onClick: handleClickOnCard,
        "aria-label": label,
        children: [
            $bc69893582beebcf$var$instanceOfDisplayGeneratorProps(props) ? /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $671685948e10781f$export$2e2bcd8739ae039), {
                view: props.view,
                className: "rf-h-8"
            }) : /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $671685948e10781f$export$2e2bcd8739ae039), {
                icon: props.icon,
                className: "rf-h-8 rf-w-8 rf-flex"
            }),
            /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("div", {
                className: "rf-uppercase rf-text-[#575F6B] rf-text-xs",
                children: label
            })
        ]
    });
};
var $bc69893582beebcf$export$2e2bcd8739ae039 = $bc69893582beebcf$var$DisplaySubGenerator;



const $9576580b55fc829f$var$DisplaySubViews = ({ handleClick: handleClick, conditionalHandleClick: conditionalHandleClick })=>{
    const { currentDeviceType: currentDeviceType, isMobile: isMobile } = (0, $8b59a4dbb18c269b$export$3abe3478af3cb63b)();
    const { configuration: configuration } = (0, $e599569c1fc3ca2c$export$d8760bee47331b1d)();
    const [subMenu, setSubMenu] = (0, $eO7Kz.useState)([]);
    const buildMenu = (menu)=>{
        let fullMenu = [];
        menu.forEach((currentMenu)=>{
            // If the menu has 'icon' as key, it's a CustomMenu. Otherwise it's a BaseSubMenu
            if (Object.keys(currentMenu).includes("icon")) {
                const customCurrentMenu = currentMenu;
                fullMenu.push(/*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $bc69893582beebcf$export$2e2bcd8739ae039), {
                    type: "CustomMenu",
                    indice: customCurrentMenu.indice,
                    label: customCurrentMenu.label,
                    icon: customCurrentMenu.icon,
                    device: currentDeviceType,
                    handleClick: ()=>{
                        if (customCurrentMenu.clickHandler) customCurrentMenu.clickHandler();
                        handleClick && handleClick();
                    },
                    customDisplay: customCurrentMenu.customDisplay,
                    conditionalHandleClick: customCurrentMenu.closeParametersOnClickInMobileMode ? conditionalHandleClick : undefined
                }));
            } else // In mobile mode, we only push custom items, base items (history / tutorial) have their own render
            !isMobile && fullMenu.push(/*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $bc69893582beebcf$export$2e2bcd8739ae039), {
                type: "BaseMenu",
                indice: currentMenu.indice,
                view: currentMenu.view,
                device: currentDeviceType,
                handleClick: handleClick
            }));
        });
        fullMenu = fullMenu.sort((a, b)=>a.props.indice - b.props.indice);
        return fullMenu;
    };
    (0, $eO7Kz.useEffect)(()=>{
        // Handle custom submenus
        if (configuration && configuration.subMenu) setSubMenu(buildMenu(configuration.subMenu));
        else setSubMenu(buildMenu((0, $674f1d59bae686ab$export$890576ebf405f6b7)));
    }, []);
    return /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eO7Kz))).Fragment, {
        children: subMenu.map((e, key)=>{
            return /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eO7Kz))).Fragment, {
                children: e
            }, key);
        })
    });
};
var $9576580b55fc829f$export$2e2bcd8739ae039 = $9576580b55fc829f$var$DisplaySubViews;


const $4e7da85755ba84f6$var$Dashboard = ({ toggleDashboard: toggleDashboard })=>{
    const { isMobile: isMobile } = (0, $8b59a4dbb18c269b$export$3abe3478af3cb63b)();
    /**
   * On call :
   *  - if the parent method toggleDashboard is defined, call it
   */ const handleClick = ()=>{
        toggleDashboard && toggleDashboard();
    };
    return isMobile ? /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("div", {
        className: "rf-w-full rf-px-5 rf-pt-4 rf-flex rf-flex-col rf-justify-start",
        children: /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $15f49c76b141cf89$export$2e2bcd8739ae039), {
            conditionalHandleClick: handleClick
        })
    }) : /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsxs)((0, $5798dbaf1694ea15$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsxs)("div", {
                className: "rf-h-full rf-w-full rf-flex rf-justify-center rf-items-center",
                children: [
                    /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $9856d835783ad65d$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsxs)("div", {
                        className: "rf-relative rf-h-full rf-max-w-7/10 rf-flex rf-flex-col rf-items-start rf-gap-8",
                        children: [
                            /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("div", {
                                className: "rf-min-h-2/5 rf-py-4 rf-mt-auto rf-flex rf-flex-col rf-gap-8 rf-overflow-y-scroll rf-scrollbar-hidden",
                                children: /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $15f49c76b141cf89$export$2e2bcd8739ae039), {
                                    handleClick: toggleDashboard
                                })
                            }),
                            /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("div", {
                                className: "rf-h-3/10 rf-flex rf-flex-row rf-items-center rf-flex-wrap rf-gap-8",
                                children: /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $9576580b55fc829f$export$2e2bcd8739ae039), {
                                    handleClick: toggleDashboard
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $4becae071fdebff0$export$2e2bcd8739ae039), {
                dashboardVisible: true,
                onClick: handleClick
            })
        ]
    });
};
var $4e7da85755ba84f6$export$2e2bcd8739ae039 = $4e7da85755ba84f6$var$Dashboard;



parcelRequire("eO7Kz");






var $eO7Kz = parcelRequire("eO7Kz");


var $da0c5262b7538598$exports = {};
$da0c5262b7538598$exports = JSON.parse('{"aa":"Qafar","aa-DJ":"Qafar (Yabuuti)","aa-ER":"Qafar (Eretria)","aa-ET":"Qafar (Otobbia)","af":"Afrikaans","af-NA":"Afrikaans (Namibi\xeb)","af-ZA":"Afrikaans (Suid-Afrika)","agq":"Aghem","agq-CM":"Aghem (K\xe0m\xe0l\xfbŋ)","ak":"Akan","ak-GH":"Akan (Gaana)","am":"አማርኛ","am-ET":"አማርኛ (ኢትዮጵያ)","ar":"العربية","ar-001":"العربية (العالم)","ar-AE":"العربية (الإمارات العربية المتحدة)","ar-BH":"العربية (البحرين)","ar-DJ":"العربية (جيبوتي)","ar-DZ":"العربية (الجزائر)","ar-EG":"العربية (مصر)","ar-ER":"العربية (إريتريا)","ar-IL":"العربية (إسرائيل)","ar-IQ":"العربية (العراق)","ar-JO":"العربية (الأردن)","ar-KM":"العربية (جزر القمر)","ar-KW":"العربية (الكويت)","ar-LB":"العربية (لبنان)","ar-LY":"العربية (ليبيا)","ar-MA":"العربية (المملكة المغربية)","ar-MR":"العربية (موريتانيا)","arn":"Mapudungun","arn-CL":"Mapudungun (Chile)","ar-OM":"العربية (عمان)","ar-PS":"العربية (السلطة الفلسطينية)","ar-QA":"العربية (قطر)","ar-SA":"العربية (المملكة العربية السعودية)","ar-SD":"العربية (السودان)","ar-SO":"العربية (الصومال)","ar-SS":"العربية (جنوب السودان)","ar-SY":"العربية (سوريا)","ar-TD":"العربية (تشاد)","ar-TN":"العربية (تونس)","ar-YE":"العربية (اليمن)","as":"অসমীয়া","asa":"Kipare","asa-TZ":"Kipare (Tadhania)","as-IN":"অসমীয়া (ভাৰত)","ast":"asturianu","ast-ES":"asturianu (Espa\xf1a)","az":"azərbaycan","az-Cyrl":"Азәрбајҹан дили","az-Cyrl-AZ":"азәрбајҹан (Азәрбајҹан)","az-Latn":"azərbaycan","az-Latn-AZ":"azərbaycan (Azərbaycan)","ba":"Башҡорт","ba-RU":"Башҡорт (Рәсәй)","bas":"Ɓ\xe0s\xe0a","bas-CM":"Ɓ\xe0s\xe0a (K\xe0mɛ̀r\xfbn)","be":"Беларуская","be-BY":"Беларуская (Беларусь)","bem":"Ichibemba","bem-ZM":"Ichibemba (Zambia)","bez":"Hibena","bez-TZ":"Hibena (Hutanzania)","bg":"български","bg-BG":"български (България)","bin":"Ẹ̀d\xf3","bin-NG":"Ẹ̀d\xf3 (Nigeria)","bm":"bamanakan","bm-Latn":"bamanakan","bm-Latn-ML":"bamanakan (Mali)","bn":"বাংলা","bn-BD":"বাংলা (বাংলাদেশ)","bn-IN":"বাংলা (ভারত)","bo":"བོད་ཡིག","bo-CN":"བོད་ཡིག (ཀྲུང་ཧྭ་མི་དམངས་སྤྱི་མཐུན་རྒྱལ་ཁབ།)","bo-IN":"བོད་སྐད་ (རྒྱ་གར་)","br":"brezhoneg","br-FR":"brezhoneg (Fra\xf1s)","brx":"बड़ो","brx-IN":"बड़ो (भारत)","bs":"bosanski","bs-Cyrl":"босански","bs-Cyrl-BA":"босански (Босна и Херцеговина)","bs-Latn":"bosanski","bs-Latn-BA":"bosanski (Bosna i Hercegovina)","byn":"ብሊን","byn-ER":"ብሊን (ኤርትራ)","ca":"catal\xe0","ca-AD":"catal\xe0 (Andorra)","ca-ES":"catal\xe0 (catal\xe0)","ca-ES-valencia":"valenci\xe0 (Espanya)","ca-FR":"catal\xe0 (Fran\xe7a)","ca-IT":"catal\xe0 (It\xe0lia)","ce":"нохчийн","ce-RU":"нохчийн (Росси)","cgg":"Rukiga","cgg-UG":"Rukiga (Uganda)","chr":"ᏣᎳᎩ","chr-Cher":"ᏣᎳᎩ","chr-Cher-US":"ᏣᎳᎩ (ᏌᏊ ᎢᏳᎾᎵᏍᏔᏅ ᏍᎦᏚᎩ)","co":"Corsu","co-FR":"Corsu (Francia)","cs":"čeština","cs-CZ":"čeština (Česko)","cu":"церковнослове́нскїй","cu-RU":"церковнослове́нскїй (рѡссі́а)","cy":"Cymraeg","cy-GB":"Cymraeg (Y Deyrnas Unedig)","da":"dansk","da-DK":"dansk (Danmark)","da-GL":"dansk (Gr\xf8nland)","dav":"Kitaita","dav-KE":"Kitaita (Kenya)","de":"Deutsch","de-AT":"Deutsch (\xd6sterreich)","de-BE":"Deutsch (Belgien)","de-CH":"Deutsch (Schweiz)","de-DE":"Deutsch (Deutschland)","de-IT":"Deutsch (Italien)","de-LI":"Deutsch (Liechtenstein)","de-LU":"Deutsch (Luxemburg)","dje":"Zarmaciine","dje-NE":"Zarmaciine (Nižer)","dsb":"dolnoserbšćina","dsb-DE":"dolnoserbšćina (Nimska)","dua":"du\xe1l\xe1","dua-CM":"du\xe1l\xe1 (Cameroun)","dv":"ދިވެހިބަސް","dv-MV":"ދިވެހިބަސް (ދިވެހި ރާއްޖެ)","dyo":"joola","dyo-SN":"joola (Senegal)","dz":"རྫོང་ཁ","dz-BT":"རྫོང་ཁ (འབྲུག)","ebu":"Kĩembu","ebu-KE":"Kĩembu (Kenya)","ee":"Eʋegbe","ee-GH":"Eʋegbe (Ghana nutome)","ee-TG":"Eʋegbe (Togo nutome)","el":"Ελληνικά","el-CY":"Ελληνικά (Κύπρος)","el-GR":"Ελληνικά (Ελλάδα)","en":"English","en-001":"English (World)","en-029":"English (Caribbean)","en-150":"English (Europe)","en-AG":"English (Antigua and Barbuda)","en-AI":"English (Anguilla)","en-AS":"English (American Samoa)","en-AT":"English (Austria)","en-AU":"English (Australia)","en-BB":"English (Barbados)","en-BE":"English (Belgium)","en-BI":"English (Burundi)","en-BM":"English (Bermuda)","en-BS":"English (Bahamas)","en-BW":"English (Botswana)","en-BZ":"English (Belize)","en-CA":"English (Canada)","en-CC":"English (Cocos (Keeling) Islands)","en-CH":"English (Switzerland)","en-CK":"English (Cook Islands)","en-CM":"English (Cameroon)","en-CX":"English (Christmas Island)","en-CY":"English (Cyprus)","en-DE":"English (Germany)","en-DK":"English (Denmark)","en-DM":"English (Dominica)","en-ER":"English (Eritrea)","en-FI":"English (Finland)","en-FJ":"English (Fiji)","en-FK":"English (Falkland Islands)","en-FM":"English (Micronesia)","en-GB":"English (United Kingdom)","en-GD":"English (Grenada)","en-GG":"English (Guernsey)","en-GH":"English (Ghana)","en-GI":"English (Gibraltar)","en-GM":"English (Gambia)","en-GU":"English (Guam)","en-GY":"English (Guyana)","en-HK":"English (Hong Kong SAR)","en-ID":"English (Indonesia)","en-IE":"English (Ireland)","en-IL":"English (Israel)","en-IM":"English (Isle of Man)","en-IN":"English (India)","en-IO":"English (British Indian Ocean Territory)","en-JE":"English (Jersey)","en-JM":"English (Jamaica)","en-KE":"English (Kenya)","en-KI":"English (Kiribati)","en-KN":"English (Saint Kitts and Nevis)","en-KY":"English (Cayman Islands)","en-LC":"English (Saint Lucia)","en-LR":"English (Liberia)","en-LS":"English (Lesotho)","en-MG":"English (Madagascar)","en-MH":"English (Marshall Islands)","en-MO":"English (Macao SAR)","en-MP":"English (Northern Mariana Islands)","en-MS":"English (Montserrat)","en-MT":"English (Malta)","en-MU":"English (Mauritius)","en-MW":"English (Malawi)","en-MY":"English (Malaysia)","en-NA":"English (Namibia)","en-NF":"English (Norfolk Island)","en-NG":"English (Nigeria)","en-NL":"English (Netherlands)","en-NR":"English (Nauru)","en-NU":"English (Niue)","en-NZ":"English (New Zealand)","en-PG":"English (Papua New Guinea)","en-PH":"English (Philippines)","en-PK":"English (Pakistan)","en-PN":"English (Pitcairn Islands)","en-PR":"English (Puerto Rico)","en-PW":"English (Palau)","en-RW":"English (Rwanda)","en-SB":"English (Solomon Islands)","en-SC":"English (Seychelles)","en-SD":"English (Sudan)","en-SE":"English (Sweden)","en-SG":"English (Singapore)","en-SH":"English (St Helena, Ascension, Tristan da Cunha)","en-SI":"English (Slovenia)","en-SL":"English (Sierra Leone)","en-SS":"English (South Sudan)","en-SX":"English (Sint Maarten)","en-SZ":"English (Swaziland)","en-TC":"English (Turks and Caicos Islands)","en-TK":"English (Tokelau)","en-TO":"English (Tonga)","en-TT":"English (Trinidad and Tobago)","en-TV":"English (Tuvalu)","en-TZ":"English (Tanzania)","en-UG":"English (Uganda)","en-UM":"English (U.S. Outlying Islands)","en-US":"English (United States)","en-VC":"English (Saint Vincent and the Grenadines)","en-VG":"English (British Virgin Islands)","en-VI":"English (U.S. Virgin Islands)","en-VU":"English (Vanuatu)","en-WS":"English (Samoa)","en-ZA":"English (South Africa)","en-ZM":"English (Zambia)","en-ZW":"English (Zimbabwe)","eo":"esperanto","eo-001":"esperanto (World)","es":"espa\xf1ol","es-419":"espa\xf1ol (Latinoam\xe9rica)","es-AR":"espa\xf1ol (Argentina)","es-BO":"espa\xf1ol (Bolivia)","es-BR":"espa\xf1ol (Brasil)","es-BZ":"espa\xf1ol (Belice)","es-CL":"espa\xf1ol (Chile)","es-CO":"espa\xf1ol (Colombia)","es-CR":"espa\xf1ol (Costa Rica)","es-CU":"espa\xf1ol (Cuba)","es-DO":"espa\xf1ol (Rep\xfablica Dominicana)","es-EC":"espa\xf1ol (Ecuador)","es-ES":"espa\xf1ol (Espa\xf1a, alfabetizaci\xf3n internacional)","es-GQ":"espa\xf1ol (Guinea Ecuatorial)","es-GT":"espa\xf1ol (Guatemala)","es-HN":"espa\xf1ol (Honduras)","es-MX":"espa\xf1ol (M\xe9xico)","es-NI":"espa\xf1ol (Nicaragua)","es-PA":"espa\xf1ol (Panam\xe1)","es-PE":"espa\xf1ol (Per\xfa)","es-PH":"espa\xf1ol (Filipinas)","es-PR":"espa\xf1ol (Puerto Rico)","es-PY":"espa\xf1ol (Paraguay)","es-SV":"espa\xf1ol (El Salvador)","es-US":"espa\xf1ol (Estados Unidos)","es-UY":"espa\xf1ol (Uruguay)","es-VE":"espa\xf1ol (Venezuela)","et":"eesti","et-EE":"eesti (Eesti)","eu":"euskara","eu-ES":"euskara (euskara)","ewo":"ewondo","ewo-CM":"ewondo (Kamər\xfan)","fa":"فارسی","fa-IR":"فارسی (ایران)","ff":"Fulah","ff-CM":"Pulaar (Kameruun)","ff-GN":"Pulaar (Gine)","ff-Latn":"Fulah","ff-Latn-SN":"Fulah (S\xe9n\xe9gal)","ff-MR":"Pulaar (Muritani)","ff-NG":"Pulaar (Nigeria)","fi":"suomi","fi-FI":"suomi (Suomi)","fil":"Filipino","fil-PH":"Filipino (Pilipinas)","fo":"f\xf8royskt","fo-DK":"f\xf8royskt (Danmark)","fo-FO":"f\xf8royskt (F\xf8royar)","fr":"fran\xe7ais","fr-029":"fran\xe7ais (cara\xefbes)","fr-BE":"fran\xe7ais (Belgique)","fr-BF":"fran\xe7ais (Burkina Faso)","fr-BI":"fran\xe7ais (Burundi)","fr-BJ":"fran\xe7ais (B\xe9nin)","fr-BL":"fran\xe7ais (Saint-Barth\xe9lemy)","fr-CA":"fran\xe7ais (Canada)","fr-CD":"fran\xe7ais (Congo, R\xe9publique d\xe9mocratique du)","fr-CF":"fran\xe7ais (R\xe9publique centrafricaine)","fr-CG":"fran\xe7ais (Congo)","fr-CH":"fran\xe7ais (Suisse)","fr-CI":"fran\xe7ais (C\xf4te d’Ivoire)","fr-CM":"fran\xe7ais (Cameroun)","fr-DJ":"fran\xe7ais (Djibouti)","fr-DZ":"fran\xe7ais (Alg\xe9rie)","fr-FR":"fran\xe7ais (France)","fr-GA":"fran\xe7ais (Gabon)","fr-GF":"fran\xe7ais (Guyane fran\xe7aise)","fr-GN":"fran\xe7ais (Guin\xe9e)","fr-GP":"fran\xe7ais (Guadeloupe)","fr-GQ":"fran\xe7ais (Guin\xe9e \xe9quatoriale)","fr-HT":"fran\xe7ais (Ha\xefti)","fr-KM":"fran\xe7ais (Comores)","fr-LU":"fran\xe7ais (Luxembourg)","fr-MA":"fran\xe7ais (Maroc)","fr-MC":"fran\xe7ais (Monaco)","fr-MF":"fran\xe7ais (Saint-Martin)","fr-MG":"fran\xe7ais (Madagascar)","fr-ML":"fran\xe7ais (Mali)","fr-MQ":"fran\xe7ais (Martinique)","fr-MR":"fran\xe7ais (Mauritanie)","fr-MU":"fran\xe7ais (Maurice)","fr-NC":"fran\xe7ais (Nouvelle-Cal\xe9donie)","fr-NE":"fran\xe7ais (Niger)","fr-PF":"fran\xe7ais (Polyn\xe9sie fran\xe7aise)","fr-PM":"fran\xe7ais (Saint-Pierre-et-Miquelon)","fr-RE":"fran\xe7ais (La R\xe9union)","fr-RW":"fran\xe7ais (Rwanda)","fr-SC":"fran\xe7ais (Seychelles)","fr-SN":"fran\xe7ais (S\xe9n\xe9gal)","fr-SY":"fran\xe7ais (Syrie)","fr-TD":"fran\xe7ais (Tchad)","fr-TG":"fran\xe7ais (Togo)","fr-TN":"fran\xe7ais (Tunisie)","fr-VU":"fran\xe7ais (Vanuatu)","fr-WF":"fran\xe7ais (Wallis-et-Futuna)","fr-YT":"fran\xe7ais (Mayotte)","fur":"furlan","fur-IT":"furlan (Italie)","fy":"Frysk","fy-NL":"Frysk (Nederl\xe2n)","ga":"Gaeilge","ga-IE":"Gaeilge (\xc9ire)","gd":"G\xe0idhlig","gd-GB":"G\xe0idhlig (An R\xecoghachd Aonaichte)","gl":"galego","gl-ES":"galego (galego)","gn":"Ava\xf1e’ẽ","gn-PY":"Ava\xf1e’ẽ (Paragu\xe1i)","gsw":"Schwiizert\xfc\xfctsch","gsw-CH":"Schwiizert\xfc\xfctsch (Schwiiz)","gsw-FR":"Els\xe4ssisch (Fr\xe0nkrisch)","gsw-LI":"Schwiizert\xfc\xfctsch (Li\xe4chtescht\xe4i)","gu":"ગુજરાતી","gu-IN":"ગુજરાતી (ભારત)","guz":"Ekegusii","guz-KE":"Ekegusii (Kenya)","gv":"Gaelg","gv-IM":"Gaelg (Ellan Vannin)","ha":"Hausa","ha-Latn":"Hausa","ha-Latn-GH":"Hausa (Gana)","ha-Latn-NE":"Hausa (Nijar)","ha-Latn-NG":"Hausa (Najeriya)","haw":"ʻŌlelo Hawaiʻi","haw-US":"ʻŌlelo Hawaiʻi (ʻAmelika Hui Pū ʻIa)","he":"עברית","he-IL":"עברית (ישראל)","hi":"हिन्दी","hi-IN":"हिन्दी (भारत)","hr":"hrvatski","hr-BA":"hrvatski (Bosna i Hercegovina)","hr-HR":"hrvatski (Hrvatska)","hsb":"hornjoserbšćina","hsb-DE":"hornjoserbšćina (Němska)","hu":"magyar","hu-HU":"magyar (Magyarorsz\xe1g)","hy":"Հայերեն","hy-AM":"Հայերեն (Հայաստան)","ia":"interlingua","ia-001":"interlingua (World)","ia-FR":"interlingua (Francia)","ibb":"Ibibio-Efik","ibb-NG":"Ibibio-Efik (Nigeria)","id":"Indonesia","id-ID":"Indonesia (Indonesia)","ig":"Igbo","ig-NG":"Igbo (Naịjịrịa)","ii":"ꆈꌠꁱꂷ","ii-CN":"ꆈꌠꁱꂷ (ꍏꉸꏓꂱꇭꉼꇩ)","is":"\xedslenska","is-IS":"\xedslenska (\xcdsland)","it":"italiano","it-CH":"italiano (Svizzera)","it-IT":"italiano (Italia)","it-SM":"italiano (San Marino)","it-VA":"italiano (Citt\xe0 del Vaticano)","iu":"Inuktitut","iu-Cans":"ᐃᓄᒃᑎᑐᑦ","iu-Cans-CA":"ᐃᓄᒃᑎᑐᑦ (ᑲᓇᑕᒥ)","iu-Latn":"Inuktitut","iu-Latn-CA":"Inuktitut (Kanatami)","ja":"日本語","ja-JP":"日本語 (日本)","jgo":"Ndaꞌa","jgo-CM":"Ndaꞌa (Kamɛl\xfbn)","jmc":"Kimachame","jmc-TZ":"Kimachame (Tanzania)","jv":"Basa Jawa","jv-Java":"ꦧꦱꦗꦮ","jv-Java-ID":"ꦧꦱꦗꦮ (Indonesia)","jv-Latn":"Basa Jawa","jv-Latn-ID":"Basa Jawa (Indonesia)","ka":"ქართული","kab":"Taqbaylit","kab-DZ":"Taqbaylit (Lezzayer)","ka-GE":"ქართული (საქართველო)","kam":"Kikamba","kam-KE":"Kikamba (Kenya)","kde":"Chimakonde","kde-TZ":"Chimakonde (Tanzania)","kea":"kabuverdianu","kea-CV":"kabuverdianu (Kabu Verdi)","khq":"Koyra ciini","khq-ML":"Koyra ciini (Maali)","ki":"Gikuyu","ki-KE":"Gikuyu (Kenya)","kk":"қазақ тілі","kkj":"kakɔ","kkj-CM":"kakɔ (Kamɛrun)","kk-KZ":"қазақ тілі (Қазақстан)","kl":"kalaallisut","kl-GL":"kalaallisut (Kalaallit Nunaat)","kln":"Kalenjin","kln-KE":"Kalenjin (Emetab Kenya)","km":"ភាសាខ្មែរ","km-KH":"ភាសាខ្មែរ (កម្ពុជា)","kn":"ಕನ್ನಡ","kn-IN":"ಕನ್ನಡ (ಭಾರತ)","ko":"한국어","kok":"कोंकणी","kok-IN":"कोंकणी (भारत)","ko-KP":"한국어 (조선민주주의인민공화국)","ko-KR":"한국어(대한민국)","kr":"Kanuri","kr-NG":"Kanuri (Nigeria)","ks":"کٲشُر","ks-Arab":"کٲشُر","ks-Arab-IN":"کٲشُر (اَربی)","ksb":"Kishambaa","ksb-TZ":"Kishambaa (Tanzania)","ks-Deva":"कॉशुर","ks-Deva-IN":"कॉशुर","ksf":"rikpa","ksf-CM":"rikpa (kamɛr\xfan)","ksh":"K\xf6lsch","ksh-DE":"K\xf6lsch (Do\xfctschland)","ku":"کوردیی ناوەڕاست","ku-Arab":"کوردیی ناوەڕاست","ku-Arab-IQ":"کوردیی ناوەڕاست (عێراق)","ku-Arab-IR":"کوردی (ئێران)","kw":"kernewek","kw-GB":"kernewek (Rywvaneth Unys)","ky":"Кыргыз","ky-KG":"Кыргыз (Кыргызстан)","la":"lingua latīna","la-001":"lingua latīna (World)","lag":"Kɨlaangi","lag-TZ":"Kɨlaangi (Taansan\xeda)","lb":"L\xebtzebuergesch","lb-LU":"L\xebtzebuergesch (L\xebtzebuerg)","lg":"Luganda","lg-UG":"Luganda (Yuganda)","lkt":"Lakȟ\xf3lʼiyapi","lkt-US":"Lakȟ\xf3lʼiyapi (M\xedlahaŋska Tȟam\xe1kȟočhe)","ln":"ling\xe1la","ln-AO":"ling\xe1la (Ang\xf3la)","ln-CD":"ling\xe1la (Republ\xedki ya Kong\xf3 Demokrat\xedki)","ln-CF":"ling\xe1la (Repibiki ya Afr\xedka ya K\xe1ti)","ln-CG":"ling\xe1la (Kongo)","lo":"ລາວ","lo-LA":"ລາວ (ລາວ)","lrc":"لۊری شومالی","lrc-IQ":"لۊری شومالی (Iraq)","lrc-IR":"لۊری شومالی (Iran)","lt":"lietuvių","lt-LT":"lietuvių (Lietuva)","lu":"Tshiluba","lu-CD":"Tshiluba (Ditunga wa Kongu)","luo":"Dholuo","luo-KE":"Dholuo (Kenya)","luy":"Luluhia","luy-KE":"Luluhia (Kenya)","lv":"latviešu","lv-LV":"latviešu (Latvija)","mas":"Maa","mas-KE":"Maa (Kenya)","mas-TZ":"Maa (Tansania)","mer":"Kĩmĩrũ","mer-KE":"Kĩmĩrũ (Kenya)","mfe":"kreol morisien","mfe-MU":"kreol morisien (Moris)","mg":"Malagasy","mgh":"Makua","mgh-MZ":"Makua (Umozambiki)","mg-MG":"Malagasy (Madagasikara)","mgo":"metaʼ","mgo-CM":"metaʼ (Kamalun)","mi":"te reo Māori","mi-NZ":"te reo Māori (Aotearoa)","mk":"македонски","mk-MK":"македонски (Република Македонија)","ml":"മലയാളം","ml-IN":"മലയാളം (ഇന്ത്യ)","mn":"монгол","mn-Cyrl":"монгол","mni":"মৈতৈলোন্","mni-IN":"মৈতৈলোন্ (India)","mn-MN":"монгол (Монгол)","mn-Mong":"ᠮᠣᠩᠭᠣᠤᠯ ᠬᠡᠯᠡ","mn-Mong-CN":"ᠮᠣᠩᠭᠣᠤᠯ ᠬᠡᠯᠡ (ᠪᠦᠭᠦᠳᠡ ᠨᠠᠢᠷᠠᠮᠳᠠᠬᠤ ᠳᠤᠮᠳᠠᠳᠤ ᠠᠷᠠᠳ ᠣᠯᠣᠰ)","mn-Mong-MN":"ᠮᠣᠩᠭᠣᠯ ᠬᠡᠯᠡ (ᠮᠣᠩᠭᠣᠯ ᠣᠯᠣᠰ)","moh":"Kanien’k\xe9ha","moh-CA":"Kanien\'k\xe9ha","mr":"मराठी","mr-IN":"मराठी (भारत)","ms":"Melayu","ms-BN":"Melayu (Brunei)","ms-MY":"Melayu (Malaysia)","ms-SG":"Melayu (Singapura)","mt":"Malti","mt-MT":"Malti (Malta)","mua":"MUNDAŊ","mua-CM":"MUNDAŊ (kameruŋ)","my":"ဗမာ","my-MM":"မြန်မာ (မြန်မာ)","mzn":"مازرونی","mzn-IR":"مازرونی (ایران)","naq":"Khoekhoegowab","naq-NA":"Khoekhoegowab (Namibiab)","nb":"norsk bokm\xe5l","nb-NO":"norsk bokm\xe5l (Norge)","nb-SJ":"norsk bokm\xe5l (Svalbard og Jan Mayen)","nd":"isiNdebele","nds":"Neddersass’sch","nds-DE":"Neddersass’sch (D\xfc\xfctschland)","nds-NL":"Neddersass’sch (Nedderlannen)","nd-ZW":"isiNdebele (Zimbabwe)","ne":"नेपाली","ne-IN":"नेपाली (भारत)","ne-NP":"नेपाली (नेपाल)","nl":"Nederlands","nl-AW":"Nederlands (Aruba)","nl-BE":"Nederlands (Belgi\xeb)","nl-BQ":"Nederlands (Bonaire, Sint Eustatius en Saba)","nl-CW":"Nederlands (Cura\xe7ao)","nl-NL":"Nederlands (Nederland)","nl-SR":"Nederlands (Suriname)","nl-SX":"Nederlands (Sint-Maarten)","nmg":"Kwasio","nmg-CM":"Kwasio (Kamerun)","nn":"nynorsk","nnh":"Shw\xf3ŋ\xf2 ngiembɔɔn","nnh-CM":"Shw\xf3ŋ\xf2 ngiembɔɔn (K\xe0mal\xfbm)","nn-NO":"nynorsk (Noreg)","no":"norsk","nqo":"ߒߞߏ","nqo-GN":"ߒߞߏ (ߖߌ߬ߣߍ߬ ߞߊ߲ߓߍ߲)","nr":"isiNdebele","nr-ZA":"isiNdebele (South Africa)","nso":"Sesotho sa Leboa","nso-ZA":"Sesotho sa Leboa (Afrika Borwa)","nus":"Thok Nath","nus-SS":"Thok Nath (South Sudan)","nyn":"Runyankore","nyn-UG":"Runyankore (Uganda)","oc":"Occitan","oc-FR":"Occitan (Fran\xe7a)","om":"Oromoo","om-ET":"Oromoo (Itoophiyaa)","om-KE":"Oromoo (Keeniyaa)","or":"ଓଡ଼ିଆ","or-IN":"ଓଡ଼ିଆ (ଭାରତ)","os":"ирон","os-GE":"ирон (Гуырдзыстон)","os-RU":"ирон (Уӕрӕсе)","pa":"ਪੰਜਾਬੀ","pa-Arab":"پنجابی","pa-Arab-PK":"پنجابی (پاکستان)","pa-Guru":"ਪੰਜਾਬੀ","pa-IN":"ਪੰਜਾਬੀ (ਭਾਰਤ)","pap":"Papiamentu","pap-029":"Papiamentu (Caribbean)","pl":"polski","pl-PL":"polski (Polska)","prg":"prūsiskan","prg-001":"prūsiskan (swītai)","prs":"درى","prs-AF":"درى (افغانستان)","ps":"پښتو","ps-AF":"پښتو (افغانستان)","pt":"portugu\xeas","pt-AO":"portugu\xeas (Angola)","pt-BR":"portugu\xeas (Brasil)","pt-CH":"portugu\xeas (Su\xed\xe7a)","pt-CV":"portugu\xeas (Cabo Verde)","pt-GQ":"portugu\xeas (Guin\xe9 Equatorial)","pt-GW":"portugu\xeas (Guin\xe9-Bissau)","pt-LU":"portugu\xeas (Luxemburgo)","pt-MO":"portugu\xeas (RAE de Macau)","pt-MZ":"portugu\xeas (Mo\xe7ambique)","pt-PT":"portugu\xeas (Portugal)","pt-ST":"portugu\xeas (S\xe3o Tom\xe9 e Pr\xedncipe)","pt-TL":"portugu\xeas (Timor-Leste)","quc":"K\'iche\'","quc-Latn":"K\'iche\'","quc-Latn-GT":"K\'iche\' (Guatemala)","quz":"Runasimi","quz-BO":"Runasimi (Bolivia)","quz-EC":"Runasimi (Ecuador)","quz-PE":"Runasimi (Per\xfa)","rm":"rumantsch","rm-CH":"rumantsch (Svizra)","rn":"Ikirundi","rn-BI":"Ikirundi (Uburundi)","ro":"rom\xe2nă","rof":"Kihorombo","rof-TZ":"Kihorombo (Tanzania)","ro-MD":"rom\xe2nă (Republica Moldova)","ro-RO":"rom\xe2nă (Rom\xe2nia)","ru":"русский","ru-BY":"русский (Беларусь)","ru-KG":"русский (Киргизия)","ru-KZ":"русский (Казахстан)","ru-MD":"русский (Молдова)","ru-RU":"русский (Россия)","ru-UA":"русский (Украина)","rw":"Kinyarwanda","rwk":"Kiruwa","rwk-TZ":"Kiruwa (Tanzania)","rw-RW":"Kinyarwanda (U Rwanda)","sa":"संस्कृत","sah":"Саха","sah-RU":"Саха (Россия)","sa-IN":"संस्कृत (भारतम्)","saq":"Kisampur","saq-KE":"Kisampur (Kenya)","sbp":"Ishisangu","sbp-TZ":"Ishisangu (Tansaniya)","sd":"سنڌي","sd-Arab":"سنڌي","sd-Arab-PK":"سنڌي (پاکستان)","sd-Deva":"सिन्धी","sd-Deva-IN":"सिन्धी (India)","se":"davvis\xe1megiella","se-FI":"davvis\xe1megiella (Suopma)","seh":"sena","seh-MZ":"sena (Mo\xe7ambique)","se-NO":"davvis\xe1megiella (Norga)","ses":"Koyraboro senni","se-SE":"davvis\xe1megiella (Ruoŧŧa)","ses-ML":"Koyraboro senni (Maali)","sg":"S\xe4ng\xf6","sg-CF":"S\xe4ng\xf6 (K\xf6d\xf6r\xf6s\xease t\xee B\xeaafr\xeeka)","shi":"ⵜⴰⵛⵍⵃⵉⵜ","shi-Latn":"Tashelḥiyt","shi-Latn-MA":"Tashelḥiyt (lmɣrib)","shi-Tfng":"ⵜⴰⵛⵍⵃⵉⵜ","shi-Tfng-MA":"ⵜⴰⵛⵍⵃⵉⵜ (ⵍⵎⵖⵔⵉⴱ)","si":"සිංහල","si-LK":"සිංහල (ශ්‍රී ලංකාව)","sk":"slovenčina","sk-SK":"slovenčina (Slovensko)","sl":"slovenščina","sl-SI":"slovenščina (Slovenija)","sma":"\xe5arjelsaemieng\xefele","sma-NO":"\xe5arjelsaemieng\xefele (N\xf6\xf6rje)","sma-SE":"\xe5arjelsaemieng\xefele (Sveerje)","smj":"julevus\xe1megiella","smj-NO":"julevus\xe1megiella (Vuodna)","smj-SE":"julevus\xe1megiella (Svierik)","smn":"anar\xe2škiel\xe2","smn-FI":"anar\xe2škiel\xe2 (Suom\xe2)","sms":"s\xe4\xe4\xb4mǩi\xf5ll","sms-FI":"s\xe4\xe4\xb4mǩi\xf5ll (L\xe4\xe4\xb4ddj\xe2nnam)","sn":"chiShona","sn-Latn":"chiShona (Latin)","sn-Latn-ZW":"chiShona (Zimbabwe)","so":"Soomaali","so-DJ":"Soomaali (Jabuuti)","so-ET":"Soomaali (Itoobiya)","so-KE":"Soomaali (Kiiniya)","so-SO":"Soomaali (Soomaaliya)","sq":"shqip","sq-AL":"shqip (Shqip\xebri)","sq-MK":"shqip (Republika e Maqedonis\xeb)","sq-XK":"shqip (Kosov\xeb)","sr":"srpski","sr-Cyrl":"српски","sr-Cyrl-BA":"српски (Босна и Херцеговина)","sr-Cyrl-ME":"српски (Црна Гора)","sr-Cyrl-RS":"српски (Србија)","sr-Cyrl-XK":"српски (Косово)","sr-Latn":"srpski","sr-Latn-BA":"srpski (Bosna i Hercegovina)","sr-Latn-ME":"srpski (Crna Gora)","sr-Latn-RS":"srpski (Srbija)","sr-Latn-XK":"srpski (Kosovo)","ss":"Siswati","ss-SZ":"siSwati (Swaziland)","ssy":"Saho","ssy-ER":"Saho (Eretria)","ss-ZA":"siSwati (South Africa)","st":"Sesotho","st-LS":"Sesotho (Lesotho)","st-ZA":"Sesotho (South Africa)","sv":"svenska","sv-AX":"svenska (\xc5land)","sv-FI":"svenska (Finland)","sv-SE":"svenska (Sverige)","sw":"Kiswahili","sw-CD":"Kiswahili (Jamhuri ya Kidemokrasia ya Kongo)","sw-KE":"Kiswahili (Kenya)","sw-TZ":"Kiswahili (Tanzania)","sw-UG":"Kiswahili (Uganda)","syr":"ܣܘܪܝܝܐ","syr-SY":"ܣܘܪܝܝܐ (ܣܘܪܝܐ)","ta":"தமிழ்","ta-IN":"தமிழ் (இந்தியா)","ta-LK":"தமிழ் (இலங்கை)","ta-MY":"தமிழ் (மலேசியா)","ta-SG":"தமிழ் (சிங்கப்பூர்)","te":"తెలుగు","te-IN":"తెలుగు (భారత దేశం)","teo":"Kiteso","teo-KE":"Kiteso (Kenia)","teo-UG":"Kiteso (Uganda)","tg":"Тоҷикӣ","tg-Cyrl":"тоҷикӣ","tg-Cyrl-TJ":"тоҷикӣ (Тоҷикистон)","th":"ไทย","th-TH":"ไทย (ไทย)","ti":"ትግርኛ","ti-ER":"ትግርኛ (ኤርትራ)","ti-ET":"ትግርኛ (ኢትዮጵያ)","tig":"ትግረ","tig-ER":"ትግረ (ኤርትራ)","tk":"T\xfcrkmen dili","tk-TM":"T\xfcrkmen dili (T\xfcrkmenistan)","tn":"Setswana","tn-BW":"Setswana (Botswana)","tn-ZA":"Setswana (Aforika Borwa)","to":"lea fakatonga","to-TO":"lea fakatonga (Tonga)","tr":"T\xfcrk\xe7e","tr-CY":"T\xfcrk\xe7e (Kıbrıs)","tr-TR":"T\xfcrk\xe7e (T\xfcrkiye)","ts":"Xitsonga","ts-ZA":"Xitsonga (South Africa)","tt":"Татар","tt-RU":"Татар (Россия)","twq":"Tasawaq senni","twq-NE":"Tasawaq senni (Nižer)","tzm":"Tamaziɣt n laṭlaṣ","tzm-Arab":"أطلس المركزية التامازيتية","tzm-Arab-MA":"أطلس المركزية التامازيتية (Morocco)","tzm-Latn":"Tamaziɣt n laṭlaṣ","tzm-Latn-DZ":"Tamaziɣt n laṭlaṣ (Djaza\xefr)","tzm-Latn-MA":"Tamaziɣt n laṭlaṣ (Meṛṛuk)","tzm-Tfng":"ⵜⴰⵎⴰⵣⵉⵖⵜ","tzm-Tfng-MA":"ⵜⴰⵎⴰⵣⵉⵖⵜ (ⵍⵎⵖⵔⵉⴱ)","ug":"ئۇيغۇرچە","ug-CN":"ئۇيغۇرچە (جۇڭخۇا خەلق جۇمھۇرىيىتى)","uk":"українська","uk-UA":"українська (Україна)","ur":"اُردو","ur-IN":"اردو (بھارت)","ur-PK":"اُردو (پاکستان)","uz":"o‘zbek","uz-Arab":"اوزبیک","uz-Arab-AF":"اوزبیک (افغانستان)","uz-Cyrl":"ўзбекча","uz-Cyrl-UZ":"ўзбекча (Ўзбекистон)","uz-Latn":"o‘zbek","uz-Latn-UZ":"o‘zbek (Oʻzbekiston)","vai":"ꕙꔤ","vai-Latn":"Vai","vai-Latn-LR":"Vai (Laibhiya)","vai-Vaii":"ꕙꔤ","vai-Vaii-LR":"ꕙꔤ (ꕞꔤꔫꕩ)","ve":"Tshivenḓa","ve-ZA":"Tshivenḓa (South Africa)","vi":"Ti\xeáng Việt","vi-VN":"Ti\xeáng Việt (Việt Nam)","vo":"Volap\xfck","vo-001":"Volap\xfck (World)","vun":"Kyivunjo","vun-TZ":"Kyivunjo (Tanzania)","wae":"Walser","wae-CH":"Walser (Schwiz)","wal":"ወላይታቱ","wal-ET":"ወላይታቱ (ኢትዮጵያ)","wo":"Wolof","wo-SN":"Wolof (Senegaal)","xh":"isiXhosa","xh-ZA":"isiXhosa (eMzantsi Afrika)","xog":"Olusoga","xog-UG":"Olusoga (Yuganda)","yav":"nuasue","yav-CM":"nuasue (Kemel\xfan)","yi":"ייִדיש","yi-001":"ייִדיש (וועלט)","yo":"\xc8d\xe8 Yor\xf9b\xe1","yo-BJ":"\xc8d\xe8 Yor\xf9b\xe1 (Or\xedlɛ́\xe8de Bɛ̀nɛ̀)","yo-NG":"\xc8d\xe8 Yor\xf9b\xe1 (Or\xedlẹ́\xe8de N\xe0\xecj\xedr\xed\xe0)","zgh":"ⵜⴰⵎⴰⵣⵉⵖⵜ","zgh-Tfng":"ⵜⴰⵎⴰⵣⵉⵖⵜ","zgh-Tfng-MA":"ⵜⴰⵎⴰⵣⵉⵖⵜ (ⵍⵎⵖⵔⵉⴱ)","zh":"中文","zh-CHS":"中文(简体) 旧版","zh-CHT":"中文(繁體) 舊版","zh-CN":"中文(中国)","zh-Hans":"中文(简体)","zh-Hans-HK":"中文 (香港特别行政区)","zh-Hans-MO":"中文 (澳门特别行政区)","zh-Hant":"中文(繁體)","zh-HK":"中文(香港特別行政區)","zh-MO":"中文(澳門特別行政區)","zh-SG":"中文(新加坡)","zh-TW":"中文(台灣)","zu":"isiZulu","zu-ZA":"isiZulu (iNingizimu Afrika)"}');




const $5c5831e4bd7b8883$var$ParameterButton = ({ title: title, color: color, icon: icon, onClick: onClick })=>{
    const { locale: locale } = (0, $2e4dc8fa28d39601$export$6650dace022cfacc)();
    const { isMobile: isMobile } = (0, $8b59a4dbb18c269b$export$3abe3478af3cb63b)();
    return isMobile ? /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsxs)("button", {
        className: `rf-w-full rf-py-4 rf-flex rf-flex-row ${icon === "lang" ? "rf-justify-between" : "rf-justify-start"} rf-items-center rf-border-t rf-border-t-menuBorder rf-capitalize`,
        onClick: onClick,
        "aria-label": title,
        children: [
            title,
            icon === "lang" && /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsxs)("div", {
                className: "rf-flex rf-flex-row rf-items-center",
                children: [
                    /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("div", {
                        className: "rf-mr-3 rf-text-lightgray rf-normal-case",
                        children: (0, (/*@__PURE__*/$parcel$interopDefault($da0c5262b7538598$exports)))[locale]
                    }),
                    /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $665d46c53901fdd5$export$2e2bcd8739ae039), {
                        className: "rf-h-4"
                    })
                ]
            })
        ]
    }) : /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsxs)("button", {
        className: "rf-width-fill-available rf-mx-3 rf-py-2 rf-flex rf-flex-row rf-justify-center rf-items-center rf-rounded-lg",
        style: {
            color: color || "#A4A7AF",
            background: "linear-gradient(to left top, #F2F3F6, #E5E6EC)",
            boxShadow: "2px 2px 6px #00000029"
        },
        onClick: onClick,
        "aria-label": title,
        children: [
            icon === "tutorial" ? /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)($f3c1b15eda8692b1$export$2e2bcd8739ae039, {
                className: "rf-h-3 tactile:rf-h-4",
                color: color
            }) : icon === "history" ? /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)($5236365909a0a806$export$2e2bcd8739ae039, {
                className: "rf-h-3 tactile:rf-h-4",
                color: color
            }) : icon === "lang" ? /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)($072caa5b40a1b8df$export$2e2bcd8739ae039, {
                className: "rf-h-3 tactile:rf-h-4",
                color: color
            }) : /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eO7Kz))).Fragment, {}),
            /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("div", {
                className: "rf-ml-1 rf-uppercase",
                children: title
            })
        ]
    });
};
var $5c5831e4bd7b8883$export$2e2bcd8739ae039 = $5c5831e4bd7b8883$var$ParameterButton;



const $8d45ee11f4d62feb$var$HistoryButton = ({ handleBack: handleBack })=>{
    const { locale: locale } = (0, $2e4dc8fa28d39601$export$6650dace022cfacc)();
    const { themeColors: themeColors } = (0, $8b59a4dbb18c269b$export$3abe3478af3cb63b)();
    const { currentSubView: currentSubView, setCurrentSubView: setCurrentSubView } = (0, $e599569c1fc3ca2c$export$d8760bee47331b1d)();
    /**
   * On call :
   *  - call parent's handleBack method if defined
   *  - change RetorikContext's currentSubView state
   */ const handleClick = ()=>{
        handleBack && handleBack();
        setCurrentSubView(currentSubView === (0, $16ad089b9ce6627d$export$f05d0fed0593ead7).history ? (0, $16ad089b9ce6627d$export$f05d0fed0593ead7).none : (0, $16ad089b9ce6627d$export$f05d0fed0593ead7).history);
    };
    return /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $5c5831e4bd7b8883$export$2e2bcd8739ae039), {
        title: (0, (/*@__PURE__*/$parcel$interopDefault($abbebf5de79f9da4$exports)))[locale]?.history || (0, (/*@__PURE__*/$parcel$interopDefault($abbebf5de79f9da4$exports)))["fr-FR"].history,
        icon: "history",
        color: currentSubView === (0, $16ad089b9ce6627d$export$f05d0fed0593ead7).history ? themeColors.secondary : "#A4A7AF",
        onClick: handleClick
    });
};
var $8d45ee11f4d62feb$export$2e2bcd8739ae039 = $8d45ee11f4d62feb$var$HistoryButton;




var $eO7Kz = parcelRequire("eO7Kz");





// Check if the locale in the current browser is in the array of available locales
const $f4c1c4ed4ddeab4a$var$checkLocaleFromBrowser = (allLanguages)=>{
    const navLang = navigator?.language;
    if (navLang && allLanguages && allLanguages.length > 0) {
        let res;
        // Navigator language can be 2-chars
        if (navLang.length === 2) res = allLanguages.find((language)=>{
            return language.substring(3, 5).toLowerCase() === navigator.language.toLowerCase();
        });
        else res = allLanguages.find((language)=>{
            return language.toLowerCase() === navigator.language.toLowerCase();
        });
        if (res) return res;
    }
    return undefined;
};
const $f4c1c4ed4ddeab4a$export$d64c0ac95bb7fd72 = (languageData, localeConfig)=>{
    if (localeConfig) {
        // Use localeConfig.default if available and supported
        if (localeConfig.default && languageData.all.includes(localeConfig.default)) return localeConfig.default;
        // else, use browser locale if config say so
        if (localeConfig.getDefaultFromBrowser) {
            const browserLocale = $f4c1c4ed4ddeab4a$var$checkLocaleFromBrowser(languageData.all);
            if (browserLocale) return browserLocale;
        }
    }
    // else, use default from languageData
    return languageData.default;
};
const $f4c1c4ed4ddeab4a$export$91fc93b93c368955 = (locale)=>{
    const split = locale.split("-");
    return split.length > 0 ? split[1] : split[0];
};





const $03a0d44db8cf0b1b$var$LanguageButton = ()=>{
    const { locale: locale, supported: supported } = (0, $2e4dc8fa28d39601$export$6650dace022cfacc)();
    const { themeColors: themeColors, isMobile: isMobile } = (0, $8b59a4dbb18c269b$export$3abe3478af3cb63b)();
    const { currentSubView: currentSubView, setCurrentSubView: setCurrentSubView } = (0, $e599569c1fc3ca2c$export$d8760bee47331b1d)();
    const [mainLocale, setMainLocale] = (0, $eO7Kz.useState)((0, $f4c1c4ed4ddeab4a$export$91fc93b93c368955)(locale).toUpperCase());
    (0, $eO7Kz.useEffect)(()=>{
        setMainLocale((0, $f4c1c4ed4ddeab4a$export$91fc93b93c368955)(locale).toUpperCase());
    }, [
        locale
    ]);
    /**
   * On call :
   *  - change RetorikContext's currentSubView state
   */ const handleClick = ()=>{
        setCurrentSubView(currentSubView === (0, $16ad089b9ce6627d$export$f05d0fed0593ead7).languages ? (0, $16ad089b9ce6627d$export$f05d0fed0593ead7).none : (0, $16ad089b9ce6627d$export$f05d0fed0593ead7).languages);
    };
    return supported.length > 1 ? isMobile ? /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $5c5831e4bd7b8883$export$2e2bcd8739ae039), {
        title: (0, (/*@__PURE__*/$parcel$interopDefault($abbebf5de79f9da4$exports)))[locale]?.lang || (0, (/*@__PURE__*/$parcel$interopDefault($abbebf5de79f9da4$exports)))["fr-FR"].lang,
        icon: "lang",
        color: currentSubView === (0, $16ad089b9ce6627d$export$f05d0fed0593ead7).languages ? themeColors.secondary : "#A4A7AF",
        onClick: handleClick
    }) : /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsxs)("button", {
        className: "rf-absolute rf-bottom-16 rf-right-0 rf-px-3 rf-pl-2 rf-pr-8 rf-flex rf-flex-row rf-items-center rf-rounded-l-lg",
        style: {
            background: "linear-gradient(#F8F8FC, #EDEEF3)"
        },
        onClick: handleClick,
        children: [
            /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("div", {
                className: "rf-h-8 rf-mr-2",
                children: /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("img", {
                    className: "rf-h-full",
                    src: `https://flagsapi.com/${mainLocale}/flat/64.png`
                })
            }),
            /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsxs)("div", {
                className: "rf-flex rf-flex-col rf-items-start rf-text-xsm",
                children: [
                    /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("div", {
                        className: "rf-text-trueblack",
                        children: (0, $8fd1ab545cc1ab7a$export$d07f57595c356899)((0, (/*@__PURE__*/$parcel$interopDefault($abbebf5de79f9da4$exports)))[locale]?.singleLang || (0, (/*@__PURE__*/$parcel$interopDefault($abbebf5de79f9da4$exports)))["fr-FR"].singleLang)
                    }),
                    /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("div", {
                        className: "rf-text-lightgray",
                        children: (0, $8fd1ab545cc1ab7a$export$d07f57595c356899)((0, (/*@__PURE__*/$parcel$interopDefault($da0c5262b7538598$exports)))[locale])
                    })
                ]
            })
        ]
    }) : /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eO7Kz))).Fragment, {});
};
var $03a0d44db8cf0b1b$export$2e2bcd8739ae039 = $03a0d44db8cf0b1b$var$LanguageButton;




var $eO7Kz = parcelRequire("eO7Kz");






var $cb952076575bb9f2$exports = {};
$cb952076575bb9f2$exports = JSON.parse('{"v":"5.7.4","fr":29.9700012207031,"ip":0,"op":45.0000018328876,"w":256,"h":256,"nm":"vibe","ddd":0,"assets":[],"layers":[{"ddd":0,"ind":1,"ty":4,"nm":"Calque de forme 1","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[128,128,0],"ix":2,"l":2},"a":{"a":0,"k":[0,0,0],"ix":1,"l":2},"s":{"a":0,"k":[100,100,100],"ix":6,"l":2}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":1,"k":[{"i":{"x":0.833,"y":0.833},"o":{"x":0.167,"y":0.167},"t":0,"s":[{"i":[[30.504,0],[26.499,-0.285],[23.25,0],[0,0],[0,-1],[0,0],[0,0],[20.501,0],[22.747,-0.37]],"o":[[-29.75,0],[-23.25,0.25],[-22.103,0],[0,0],[0,1],[0,0],[0,0],[-18.75,0],[-30.75,0.5]],"v":[[3.25,-10.25],[-49.5,103],[-92.5,39],[-129,128.25],[-129.5,167.5],[128.75,171.75],[129.75,127.75],[100.25,65.5],[54.75,110]],"c":true}]},{"i":{"x":0.833,"y":0.833},"o":{"x":0.167,"y":0.167},"t":8,"s":[{"i":[[30.504,0],[26.499,-0.285],[23.25,0],[0,0],[0,-1],[0,0],[0,0],[20.501,0],[22.747,-0.37]],"o":[[-29.75,0],[-23.25,0.25],[-22.103,0],[0,0],[0,1],[0,0],[0,0],[-18.75,0],[-30.75,0.5]],"v":[[3.25,31.25],[-49.5,103],[-92.5,81],[-129,128.25],[-129.5,167.5],[128.75,171.75],[129.75,127.75],[100.25,18],[54.75,110]],"c":true}]},{"i":{"x":0.833,"y":0.833},"o":{"x":0.167,"y":0.167},"t":16,"s":[{"i":[[30.504,0],[26.499,-0.285],[23.25,0],[0,0],[0,-1],[0,0],[0,0],[20.501,0],[22.747,-0.37]],"o":[[-29.75,0],[-23.25,0.25],[-22.103,0],[0,0],[0,1],[0,0],[0,0],[-18.75,0],[-30.75,0.5]],"v":[[3.247,87.636],[-49.5,62.5],[-92.5,8.144],[-129,128.25],[-129.5,167.5],[128.75,171.75],[129.75,10.5],[100.25,84.403],[54.75,36.25]],"c":true}]},{"i":{"x":0.833,"y":0.833},"o":{"x":0.167,"y":0.167},"t":23,"s":[{"i":[[30.504,0],[26.499,-0.285],[23.25,0],[0,0],[0,-1],[0,0],[0,0],[20.501,0],[22.747,-0.37]],"o":[[-29.75,0],[-23.25,0.25],[-22.103,0],[0,0],[0,1],[0,0],[0,0],[-18.75,0],[-30.75,0.5]],"v":[[3.249,51.758],[-49.5,103],[-92.5,48.989],[-129,-22],[-129.5,167.5],[128.75,171.75],[129.75,19.75],[100.25,93.847],[54.75,-2]],"c":true}]},{"i":{"x":0.833,"y":0.833},"o":{"x":0.167,"y":0.167},"t":31,"s":[{"i":[[30.504,0],[26.498,-0.285],[23.25,0],[0,0],[0,-1],[0,0],[0,0],[20.501,0],[22.747,-0.37]],"o":[[-29.75,0],[-23.25,0.25],[-22.103,0],[0,0],[0,1],[0,0],[0,0],[-18.75,0],[-30.75,0.5]],"v":[[3.249,-34.148],[-49.5,39.75],[-92.5,90.277],[-129,128.25],[-129.5,167.5],[128.75,171.75],[129.75,127.75],[100.25,33.052],[54.75,110]],"c":true}]},{"i":{"x":0.833,"y":0.833},"o":{"x":0.167,"y":0.167},"t":38,"s":[{"i":[[30.504,0],[26.499,-0.285],[23.25,0],[0,0],[0,-1],[0,0],[0,0],[20.501,0],[22.747,-0.37]],"o":[[-29.75,0],[-23.25,0.25],[-22.103,0],[0,0],[0,1],[0,0],[0,0],[-18.75,0],[-30.75,0.5]],"v":[[3.249,23.747],[-49.5,-21.5],[-92.5,115.754],[-129,62.5],[-129.5,167.5],[128.75,171.75],[129.75,127.75],[100.25,90.836],[54.75,110]],"c":true}]},{"t":45.0000018328876,"s":[{"i":[[30.504,0],[26.499,-0.285],[23.25,0],[0,0],[0,-1],[0,0],[0,0],[20.501,0],[22.747,-0.37]],"o":[[-29.75,0],[-23.25,0.25],[-22.103,0],[0,0],[0,1],[0,0],[0,0],[-18.75,0],[-30.75,0.5]],"v":[[3.25,-10.25],[-49.5,103],[-92.5,39],[-129,128.25],[-129.5,167.5],[128.75,171.75],[129.75,127.75],[100.25,65.5],[54.75,110]],"c":true}]}],"ix":2},"nm":"Trac\xe9 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[1,1,1,1],"ix":3},"o":{"a":0,"k":19,"ix":4},"w":{"a":0,"k":0,"ix":5},"lc":1,"lj":1,"ml":4,"bm":0,"nm":"Contour 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"fl","c":{"a":0,"k":[0,0,0,1],"ix":4},"o":{"a":0,"k":19,"ix":5},"r":1,"bm":0,"nm":"Fond 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transformer "}],"nm":"Forme 1","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":45.0000018328876,"st":0,"bm":0},{"ddd":0,"ind":2,"ty":4,"nm":"Calque de forme 2","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[128,128,0],"ix":2,"l":2},"a":{"a":0,"k":[0,0,0],"ix":1,"l":2},"s":{"a":0,"k":[100,100,100],"ix":6,"l":2}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":1,"k":[{"i":{"x":0.833,"y":0.833},"o":{"x":0.167,"y":0.167},"t":0,"s":[{"i":[[30.504,0],[26.499,-0.285],[23.25,0],[0,0],[0,-1],[0,0],[0,0],[20.501,0],[22.747,-0.37]],"o":[[-29.75,0],[-23.25,0.25],[-22.103,0],[0,0],[0,1],[0,0],[0,0],[-18.75,0],[-30.75,0.5]],"v":[[3.25,104.5],[-49.5,68.5],[-92.5,108.5],[-129,4.75],[-129.5,167.5],[128.75,171.75],[129.75,53],[100.25,110.5],[54.75,38.25]],"c":true}]},{"i":{"x":0.833,"y":0.833},"o":{"x":0.167,"y":0.167},"t":8,"s":[{"i":[[30.504,0],[26.499,-0.285],[23.25,0],[0,0],[0,-1],[0,0],[0,0],[20.501,0],[22.747,-0.37]],"o":[[-29.75,0],[-23.25,0.25],[-22.103,0],[0,0],[0,1],[0,0],[0,0],[-18.75,0],[-30.75,0.5]],"v":[[3.25,48.5],[-49.5,-11.5],[-92.5,44],[-129,116],[-129.5,167.5],[128.75,171.75],[129.75,125.5],[100.25,62.5],[54.749,95.5]],"c":true}]},{"i":{"x":0.833,"y":0.833},"o":{"x":0.167,"y":0.167},"t":16,"s":[{"i":[[30.504,0],[26.499,-0.285],[23.25,0],[0,0],[0,-1],[0,0],[0,0],[20.501,0],[22.747,-0.37]],"o":[[-29.75,0],[-23.25,0.25],[-22.103,0],[0,0],[0,1],[0,0],[0,0],[-18.75,0],[-30.75,0.5]],"v":[[3.25,27],[-49.502,94.547],[-92.5,55],[-129,-19.068],[-129.5,167.5],[128.75,171.75],[129.75,125],[100.25,110.5],[54.749,-63.236]],"c":true}]},{"i":{"x":0.833,"y":0.833},"o":{"x":0.167,"y":0.167},"t":23,"s":[{"i":[[30.504,0],[26.499,-0.285],[23.25,0],[0,0],[0,-1],[0,0],[0,0],[20.501,0],[22.747,-0.37]],"o":[[-29.75,0],[-23.25,0.25],[-22.103,0],[0,0],[0,1],[0,0],[0,0],[-18.75,0],[-30.75,0.5]],"v":[[3.25,70],[-49.501,1.079],[-92.5,120.5],[-129,57.802],[-129.5,167.5],[128.75,171.75],[129.75,-0.19],[100.25,65.5],[54.749,45.01]],"c":true}]},{"i":{"x":0.833,"y":0.833},"o":{"x":0.167,"y":0.167},"t":31,"s":[{"i":[[30.504,0],[26.499,-0.285],[23.25,0],[0,0],[0,-1],[0,0],[0,0],[20.501,0],[22.747,-0.37]],"o":[[-29.75,0],[-23.25,0.25],[-22.103,0],[0,0],[0,1],[0,0],[0,0],[-18.75,0],[-30.75,0.5]],"v":[[3.25,22.75],[-49.501,80.531],[-92.5,33],[-129,114.922],[-129.5,167.5],[128.75,171.75],[129.75,-17.129],[100.25,106.25],[54.747,69.109]],"c":true}]},{"i":{"x":0.833,"y":0.833},"o":{"x":0.167,"y":0.167},"t":38,"s":[{"i":[[30.504,0],[26.499,-0.285],[23.25,0],[0,0],[0,-1],[0,0],[0,0],[20.501,0],[22.747,-0.37]],"o":[[-29.75,0],[-23.25,0.25],[-22.103,0],[0,0],[0,1],[0,0],[0,0],[-18.75,0],[-30.75,0.5]],"v":[[3.25,104.5],[-49.501,68.115],[-92.5,106.017],[-129,129.414],[-129.5,167.5],[128.75,171.75],[129.75,63.44],[100.25,-1.2],[54.748,66.851]],"c":true}]},{"t":45.0000018328876,"s":[{"i":[[30.504,0],[26.499,-0.285],[23.25,0],[0,0],[0,-1],[0,0],[0,0],[20.501,0],[22.747,-0.37]],"o":[[-29.75,0],[-23.25,0.25],[-22.103,0],[0,0],[0,1],[0,0],[0,0],[-18.75,0],[-30.75,0.5]],"v":[[3.25,104.5],[-49.5,68.5],[-92.5,108.5],[-129,4.75],[-129.5,167.5],[128.75,171.75],[129.75,53],[100.25,110.5],[54.75,38.25]],"c":true}]}],"ix":2},"nm":"Trac\xe9 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[1,1,1,1],"ix":3},"o":{"a":0,"k":19,"ix":4},"w":{"a":0,"k":0,"ix":5},"lc":1,"lj":1,"ml":4,"bm":0,"nm":"Contour 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"fl","c":{"a":0,"k":[0,0,0,1],"ix":4},"o":{"a":0,"k":19,"ix":5},"r":1,"bm":0,"nm":"Fond 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transformer "}],"nm":"Forme 1","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":45.0000018328876,"st":0,"bm":0}],"markers":[]}');


const $8837eabe7f1a4634$var$getMicrophonePermission = async ()=>{
    try {
        return navigator.mediaDevices.getUserMedia({
            audio: true
        }).then((stream)=>{
            return !!stream;
        });
    } catch (error) {
        console.log(error);
        return false;
    }
};
var $8837eabe7f1a4634$export$2e2bcd8739ae039 = $8837eabe7f1a4634$var$getMicrophonePermission;



var $l7gGd = parcelRequire("l7gGd");


var $eO7Kz = parcelRequire("eO7Kz");

parcelRequire("eO7Kz");

var $fed8bf1a9b4c836a$exports = {};
$fed8bf1a9b4c836a$exports = JSON.parse('{"fr-FR":{"close":"Fermer"},"en-US":{"close":"Close"},"es-ES":{"close":"Close"},"de-DE":{"close":"Close"}}');



const $445bb358cf4be0d2$var$CloseButton = ({ onClick: onClick, label: label, className: className, showLabel: showLabel })=>{
    const { locale: locale } = (0, $2e4dc8fa28d39601$export$6650dace022cfacc)();
    return /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsxs)("button", {
        "aria-label": label || (0, (/*@__PURE__*/$parcel$interopDefault($fed8bf1a9b4c836a$exports)))[locale]?.close || (0, (/*@__PURE__*/$parcel$interopDefault($fed8bf1a9b4c836a$exports)))["fr-FR"].close,
        onClick: onClick,
        className: `${className} rf-absolute rf-flex rf-flex-col rf-items-center rf-right-0 rf-top-0 rf-p-2`,
        children: [
            /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $afdfbac274da5706$export$2e2bcd8739ae039), {
                className: "rf-h-6 rf-w-6"
            }),
            showLabel && /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("div", {
                className: "rf-text-[0.5rem] rf-uppercase",
                children: label || (0, (/*@__PURE__*/$parcel$interopDefault($fed8bf1a9b4c836a$exports)))[locale]?.close || (0, (/*@__PURE__*/$parcel$interopDefault($fed8bf1a9b4c836a$exports)))["fr-FR"].close
            })
        ]
    });
};
var $445bb358cf4be0d2$export$2e2bcd8739ae039 = $445bb358cf4be0d2$var$CloseButton;


const $9a0fc3848b8bf907$var$Modal = ({ isOpened: isOpened, onClose: onClose, colorClasses: colorClasses, children: children })=>{
    const modalRef = (0, $eO7Kz.useRef)(null);
    (0, $eO7Kz.useEffect)(()=>{
        if (isOpened) modalRef.current && modalRef.current.showModal();
        else modalRef.current && modalRef.current.close();
    }, [
        isOpened
    ]);
    return /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("dialog", {
        onCancel: onClose,
        className: `rf-absolute backdrop:rf-bg-black/50 rf-left-0 rf-w-[45ch] rf-max-w-[70vw] rf-px-4 rf-rounded ${colorClasses || "rf-bg-truewhite rf-border rf-border-red-700 rf-text-red-700"} rf-font-semibold rf-text-center`,
        ref: modalRef,
        onClick: onClose,
        children: /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsxs)("div", {
            className: "rf-flex rf-flex-col rf-p-6",
            onClick: (event)=>event?.stopPropagation(),
            children: [
                children,
                /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $445bb358cf4be0d2$export$2e2bcd8739ae039), {
                    onClick: onClose
                })
            ]
        })
    });
};
var $9a0fc3848b8bf907$export$2e2bcd8739ae039 = $9a0fc3848b8bf907$var$Modal;




const { useMicrophoneButtonClick: $b4b3f77eb1eaf002$var$useMicrophoneButtonClick, useSendBoxSpeechInterimsVisible: $b4b3f77eb1eaf002$var$useSendBoxSpeechInterimsVisible } = (0, $497baa802110a7bc$exports.hooks);
const $b4b3f77eb1eaf002$var$MicrophoneButton = ({ openMicrophone: openMicrophone })=>{
    const { isMobile: isMobile, themeColors: themeColors } = (0, $8b59a4dbb18c269b$export$3abe3478af3cb63b)();
    const { locale: locale } = (0, $2e4dc8fa28d39601$export$6650dace022cfacc)();
    const { setCurrentSubView: setCurrentSubView } = (0, $e599569c1fc3ca2c$export$d8760bee47331b1d)();
    const microphoneClick = $b4b3f77eb1eaf002$var$useMicrophoneButtonClick();
    const [interimsVisible] = $b4b3f77eb1eaf002$var$useSendBoxSpeechInterimsVisible();
    const [allowed, setAllowed] = (0, $eO7Kz.useState)(false);
    const [message, setMessage] = (0, $eO7Kz.useState)("");
    const [playerRef, setPlayerRef] = (0, $eO7Kz.useState)(null);
    const handleClick = (0, $eO7Kz.useCallback)(()=>{
        if (!allowed) askPermission();
        else startListening();
    }, [
        allowed,
        microphoneClick
    ]);
    (0, $eO7Kz.useEffect)(()=>{
        openMicrophone && handleClick();
    }, []);
    /**
   * On interimsVisible change :
   *  - if the interims are visible (waiting for user's speak input), play the lottie animation
   *  - if the interims are not visible (user's speak ended), stop the lottie animation
   *  - remove subviews if visible
   *  - remove fullscreen image if there is one
   */ (0, $eO7Kz.useEffect)(()=>{
        if (interimsVisible) playerRef && playerRef.lottie.play();
        else playerRef && playerRef.lottie.stop();
        setCurrentSubView((0, $16ad089b9ce6627d$export$f05d0fed0593ead7).none);
        (0, $134592d23f105dbc$export$4e062bd31c814155)(undefined);
    }, [
        interimsVisible,
        playerRef
    ]);
    (0, $eO7Kz.useEffect)(()=>{
        if (allowed) {
            closeModal();
            startListening();
        }
    }, [
        allowed
    ]);
    const startListening = ()=>{
        microphoneClick();
    };
    const closeModal = ()=>{
        setMessage("");
    };
    const askPermission = ()=>{
        setMessage((0, (/*@__PURE__*/$parcel$interopDefault($abbebf5de79f9da4$exports)))[locale]?.allowMicrophone || "Give your browser permission to use microphone to continue");
        return (0, $8837eabe7f1a4634$export$2e2bcd8739ae039)().then((permission)=>{
            setAllowed(permission);
        }).catch(console.log);
    };
    return /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($eO7Kz))).Fragment, {
        children: [
            /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsxs)("button", {
                className: `rf-relative large:rf-w-full large:rf-h-auto rf-aspect-square rf-flex rf-justify-center rf-items-center rf-border ${interimsVisible ? isMobile ? "rf-h-12 rf-border-[#00000029]" : "rf-border-[#00000029]" : isMobile ? "rf-h-8 rf-border-none" : "rf-border-menuBorder"} rf-rounded-half rf-overflow-hidden`,
                onClick: handleClick,
                "aria-label": "microphone",
                style: {
                    boxShadow: interimsVisible ? "inset 0 0 6px 3px#00000029" : isMobile ? undefined : "0 0 20px 1px #A4A7AF80",
                    WebkitMaskImage: interimsVisible ? "-webkit-radial-gradient(white, black)" : undefined
                },
                children: [
                    /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("div", {
                        className: "rf-absolute rf-h-full rf-w-full rf-flex rf-justify-end",
                        children: interimsVisible && /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $l7gGd.Player), {
                            lottieRef: (instance)=>{
                                setPlayerRef({
                                    lottie: instance
                                });
                            },
                            loop: true,
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($cb952076575bb9f2$exports))),
                            className: "rf-w-full"
                        })
                    }),
                    interimsVisible ? /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)($f309fe650f673139$export$2e2bcd8739ae039, {
                        className: "rf-h-3 rf-w-3 large:rf-h-4 large:rf-w-4"
                    }) : /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)($723367a4828ad150$export$2e2bcd8739ae039, {
                        className: "rf-h-5 rf-w-5",
                        color: themeColors.secondary
                    })
                ]
            }),
            /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $9a0fc3848b8bf907$export$2e2bcd8739ae039), {
                isOpened: !!message,
                onClose: closeModal,
                children: message
            })
        ]
    });
};
var $b4b3f77eb1eaf002$export$2e2bcd8739ae039 = $b4b3f77eb1eaf002$var$MicrophoneButton;


/* eslint-disable react/jsx-boolean-value */ 

var $eO7Kz = parcelRequire("eO7Kz");









const $565625f6c996aee4$var$Parameters = ({ handleBack: handleBack })=>{
    const { locale: locale } = (0, $2e4dc8fa28d39601$export$6650dace022cfacc)();
    const { mode: mode, displaySubtitles: displaySubtitles, setDisplaySubtitles: setDisplaySubtitles } = (0, $e599569c1fc3ca2c$export$d8760bee47331b1d)();
    const { speechAllowed: speechAllowed, setSpeechAllowed: setSpeechAllowed } = (0, $633c6ef6f1f791c0$export$57e792e009c800a0)();
    const { isMobile: isMobile } = (0, $8b59a4dbb18c269b$export$3abe3478af3cb63b)();
    return /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($eO7Kz))).Fragment, {
        children: [
            /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $e942a9e6425a3ae1$export$2e2bcd8739ae039), {
                className: "rf-py-3 large:rf-py-0",
                title: (0, (/*@__PURE__*/$parcel$interopDefault($abbebf5de79f9da4$exports)))[locale]?.sound || (0, (/*@__PURE__*/$parcel$interopDefault($abbebf5de79f9da4$exports)))["fr-FR"].sound,
                handleChange: setSpeechAllowed,
                defaultChecked: speechAllowed
            }),
            isMobile && /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("div", {
                className: "rf-h-0 rf-w-full rf-border-t rf-border-t-menuBorder"
            }),
            mode !== (0, $16ad089b9ce6627d$export$9484bbecc3c49a2e).text && /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $e942a9e6425a3ae1$export$2e2bcd8739ae039), {
                className: "rf-py-3 large:rf-py-0",
                title: (0, (/*@__PURE__*/$parcel$interopDefault($abbebf5de79f9da4$exports)))[locale]?.subtitle || (0, (/*@__PURE__*/$parcel$interopDefault($abbebf5de79f9da4$exports)))["fr-FR"].subtitle,
                handleChange: setDisplaySubtitles,
                defaultChecked: displaySubtitles
            }),
            isMobile && /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($eO7Kz))).Fragment, {
                children: [
                    /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $03a0d44db8cf0b1b$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $8c7f1a729a647551$export$2e2bcd8739ae039), {
                        handleBack: handleBack
                    }),
                    /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $8d45ee11f4d62feb$export$2e2bcd8739ae039), {
                        handleBack: handleBack
                    }),
                    /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $9576580b55fc829f$export$2e2bcd8739ae039), {
                        handleClick: handleBack
                    })
                ]
            })
        ]
    });
};
var $565625f6c996aee4$export$2e2bcd8739ae039 = $565625f6c996aee4$var$Parameters;




parcelRequire("eO7Kz");



const $8c7f1a729a647551$var$TutorialButton = ({ handleBack: handleBack })=>{
    // const sendMessage = useSendMessage()
    const { locale: locale } = (0, $2e4dc8fa28d39601$export$6650dace022cfacc)();
    const handleClick = ()=>{
        handleBack && handleBack();
        console.log("Launch tutorial");
    // sendMessage('conseil', 'speech')
    };
    return /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $5c5831e4bd7b8883$export$2e2bcd8739ae039), {
        title: (0, (/*@__PURE__*/$parcel$interopDefault($abbebf5de79f9da4$exports)))[locale]?.tutorial || (0, (/*@__PURE__*/$parcel$interopDefault($abbebf5de79f9da4$exports)))["fr-FR"].tutorial,
        icon: "tutorial",
        onClick: handleClick
    });
};
var $8c7f1a729a647551$export$2e2bcd8739ae039 = $8c7f1a729a647551$var$TutorialButton;




const $d7dd81018f15de78$var$SubMenuClosing = ({ className: className, background: background, handleClose: handleClose, backIsConversation: backIsConversation, title: title, children: children })=>{
    const { locale: locale } = (0, $2e4dc8fa28d39601$export$6650dace022cfacc)();
    const { isMobile: isMobile } = (0, $8b59a4dbb18c269b$export$3abe3478af3cb63b)();
    return /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsxs)((0, $66f1584cfff93673$export$2e2bcd8739ae039), {
        background: background,
        onClick: handleClose,
        children: [
            /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $53c3829f3df8be22$export$2e2bcd8739ae039), {
                title: backIsConversation ? (0, (/*@__PURE__*/$parcel$interopDefault($abbebf5de79f9da4$exports)))[locale]?.backconversation || (0, (/*@__PURE__*/$parcel$interopDefault($abbebf5de79f9da4$exports)))["fr-FR"].backconversation : isMobile ? (0, (/*@__PURE__*/$parcel$interopDefault($abbebf5de79f9da4$exports)))[locale]?.back || (0, (/*@__PURE__*/$parcel$interopDefault($abbebf5de79f9da4$exports)))["fr-FR"].back : (0, (/*@__PURE__*/$parcel$interopDefault($abbebf5de79f9da4$exports)))[locale]?.backconversation || (0, (/*@__PURE__*/$parcel$interopDefault($abbebf5de79f9da4$exports)))["fr-FR"].backconversation,
                handleBack: handleClose,
                className: "rf-relative large:rf-absolute large-tactile:rf-hidden rf-pb-6 large:rf-left-4 large:rf-top-8 rf-text-size-auto"
            }),
            /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsxs)("div", {
                className: `rf-w-full large:rf-w-fit large:rf-max-w-full large-vertical:rf-max-w-2/3 large:rf-px-6 rf-flex rf-flex-col large-vertical:rf-text-size-auto rf-overflow-y-scroll rf-scrollbar-hidden ${className}`,
                children: [
                    /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $53c3829f3df8be22$export$2e2bcd8739ae039), {
                        title: (0, (/*@__PURE__*/$parcel$interopDefault($abbebf5de79f9da4$exports)))[locale]?.backconversation || (0, (/*@__PURE__*/$parcel$interopDefault($abbebf5de79f9da4$exports)))["fr-FR"].backconversation,
                        handleBack: handleClose,
                        className: "rf-hidden large-tactile:rf-flex rf-pt-4 rf-pb-6"
                    }),
                    title && /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("div", {
                        className: "large:rf-mt-20 large-tactile:rf-mt-0 rf-mb-6 rf-title-bold-size-auto rf-font-bold",
                        children: (0, $8fd1ab545cc1ab7a$export$d07f57595c356899)(title)
                    }),
                    children
                ]
            })
        ]
    });
};
var $d7dd81018f15de78$export$2e2bcd8739ae039 = $d7dd81018f15de78$var$SubMenuClosing;







const $47785786bd448bb5$var$FullScreenRemoteClosing = ({ className: className, background: background, closeButtonClassName: closeButtonClassName, remoteCloseButtonZIndex: remoteCloseButtonZIndex, mobileReturnTitle: mobileReturnTitle, handleClose: handleClose, onClick: onClick, children: children })=>{
    const { currentDeviceType: currentDeviceType, isMobile: isMobile } = (0, $8b59a4dbb18c269b$export$3abe3478af3cb63b)();
    return /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($eO7Kz))).Fragment, {
        children: [
            /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsxs)((0, $55cde5205173a884$export$2e2bcd8739ae039), {
                className: className,
                background: background,
                onClick: onClick,
                children: [
                    currentDeviceType === (0, $16ad089b9ce6627d$export$ec1e04e4e5ef8233).landscape && /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $445bb358cf4be0d2$export$2e2bcd8739ae039), {
                        onClick: handleClose,
                        className: closeButtonClassName,
                        showLabel: true
                    }),
                    isMobile && mobileReturnTitle && /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $53c3829f3df8be22$export$2e2bcd8739ae039), {
                        title: mobileReturnTitle,
                        handleBack: handleClose,
                        className: "rf-p-4 rf-text-size-auto"
                    }),
                    children
                ]
            }),
            currentDeviceType === (0, $16ad089b9ce6627d$export$ec1e04e4e5ef8233).borne && /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $4becae071fdebff0$export$2e2bcd8739ae039), {
                dashboardVisible: true,
                zIndexClassname: remoteCloseButtonZIndex,
                onClick: handleClose
            })
        ]
    });
};
var $47785786bd448bb5$export$2e2bcd8739ae039 = $47785786bd448bb5$var$FullScreenRemoteClosing;



parcelRequire("eO7Kz");
var $de9b046f76977201$exports = {};
$de9b046f76977201$exports = JSON.parse('{"fr-FR":{"result":"r\xe9sultat","results":"r\xe9sultats","all":"tous","filter":"Filtrer","reset":"effacer tout","showresults":"Afficher les r\xe9sultats","suggestiontitle":"Suggestions de recherches","reminder":"N\'oubliez pas,\\n je peux r\xe9pondre \xe0 vos questions."},"en-US":{"result":"result","results":"results","all":"all","filter":"Filter","reset":"reset filters","showresults":"Show results","suggestiontitle":"Research suggestions","reminder":"Don\'t forget,\\n I can answer your questions."},"es-ES":{"result":"result","results":"results","all":"all","filter":"Filter","reset":"reset filters","showresults":"Show results","suggestiontitle":"Research suggestions","reminder":"Don\'t forget,\\n I can answer your questions."},"de-DE":{"result":"result","results":"results","all":"all","filter":"Filter","reset":"reset filters","showresults":"Show results","suggestiontitle":"Research suggestions","reminder":"Don\'t forget,\\n I can answer your questions."}}');



const $54dc5120d2a03001$var$Title = ({ className: className, title: title, numberOfResults: numberOfResults })=>{
    const { locale: locale } = (0, $2e4dc8fa28d39601$export$6650dace022cfacc)((state)=>({
            locale: state.locale
        }));
    return /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsxs)("div", {
        className: `rf-mb-4 rf-flex rf-flex-col rf-items-start rf-justify-center large:rf-flex-row large:rf-items-baseline large:rf-justify-start ${className}`,
        children: [
            /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("div", {
                className: "rf-text-3xl large:rf-text-5xl rf-font-bold",
                children: title
            }),
            numberOfResults !== undefined && /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsxs)("div", {
                className: "rf-text-gray large:rf-ml-4",
                children: [
                    numberOfResults,
                    " ",
                    numberOfResults > 1 ? (0, (/*@__PURE__*/$parcel$interopDefault($de9b046f76977201$exports)))[locale]?.results || "results" : (0, (/*@__PURE__*/$parcel$interopDefault($de9b046f76977201$exports)))[locale]?.result || "result"
                ]
            })
        ]
    });
};
var $54dc5120d2a03001$export$2e2bcd8739ae039 = $54dc5120d2a03001$var$Title;



parcelRequire("eO7Kz");


parcelRequire("eO7Kz");




const $fa5dc3d629beb18e$var$ChosenItem = ({ className: className, name: name, parent: parent })=>{
    const { processFiltersOnChange: processFiltersOnChange } = (0, $719f01871b6350db$export$f9763ecd339e95eb)();
    const { locale: locale } = (0, $2e4dc8fa28d39601$export$6650dace022cfacc)((state)=>({
            locale: state.locale
        }));
    return /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsxs)("div", {
        className: `rf-py-1 rf-text-size-auto rf-text-white rf-bg-gray hover:rf-cursor-pointer rf-rounded-lg rf-flex rf-flex-row rf-items-center rf-justify-center ${className}`,
        onClick: ()=>processFiltersOnChange([
                {
                    ...parent,
                    items: [
                        name
                    ]
                }
            ]),
        children: [
            /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("div", {
                className: "rf-mr-2 large:rf-mr-3",
                children: parent.id === "Event.DateRange" ? `${name.substring(8, 10)}/${name.substring(5, 7)}/${name.substring(0, 4)}` : (0, $8fd1ab545cc1ab7a$export$d07f57595c356899)(name, locale)
            }),
            /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $afdfbac274da5706$export$2e2bcd8739ae039), {
                className: "rf-h-3 rf-w-3"
            })
        ]
    });
};
var $fa5dc3d629beb18e$export$2e2bcd8739ae039 = $fa5dc3d629beb18e$var$ChosenItem;




var $eO7Kz = parcelRequire("eO7Kz");





parcelRequire("eO7Kz");





var $eO7Kz = parcelRequire("eO7Kz");

const $c4c5ab9a3bd3f778$var$CheckBox = ({ className: className, iconClassName: iconClassName, checked: checked, onClick: onClick })=>{
    const [bgColor, setBgColor] = (0, $eO7Kz.useState)(checked ? "rf-bg-secondary" : "rf-bg-truewhite");
    (0, $eO7Kz.useEffect)(()=>{
        setBgColor(checked ? "rf-bg-secondary" : "rf-bg-truewhite");
    }, [
        checked
    ]);
    const handleClick = (e)=>{
        e.preventDefault();
        e.stopPropagation();
        onClick && onClick();
    };
    return /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("div", {
        className: `rf-w-6 rf-h-6 rf-min-w-6 rf-min-h-6 rf-flex rf-justify-center rf-items-center rf-border rf-border-templateCheckboxBorder hover:rf-cursor-pointer ${bgColor} ${className}`,
        onClick: (e)=>handleClick(e),
        children: /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $416cf8987d72a3d6$export$2e2bcd8739ae039), {
            className: iconClassName
        })
    });
};
var $c4c5ab9a3bd3f778$export$2e2bcd8739ae039 = $c4c5ab9a3bd3f778$var$CheckBox;


const $f9ac84ac4cb3ced3$var$SubFilter = ({ className: className, name: name, parent: parent })=>{
    const { selectedFilters: selectedFilters, processFiltersOnChange: processFiltersOnChange } = (0, $719f01871b6350db$export$f9763ecd339e95eb)();
    const { locale: locale } = (0, $2e4dc8fa28d39601$export$6650dace022cfacc)((state)=>({
            locale: state.locale
        }));
    return /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsxs)("div", {
        className: `rf-w-full rf-pt-4 large:rf-py-1 rf-flex rf-justify-between rf-items-center ${className}`,
        children: [
            (0, $8fd1ab545cc1ab7a$export$d07f57595c356899)(name, locale),
            /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $c4c5ab9a3bd3f778$export$2e2bcd8739ae039), {
                className: "rf-rounded large:rf-ml-8",
                iconClassName: "rf-w-4 rf-h-4 large:rf-p-min1 large:rf-w-6 large:rf-h-6",
                checked: selectedFilters.filter((filter)=>filter.title === parent.title && filter.items.includes(name)).length === 1,
                onClick: ()=>processFiltersOnChange([
                        {
                            ...parent,
                            items: [
                                name
                            ]
                        }
                    ])
            })
        ]
    });
};
var $f9ac84ac4cb3ced3$export$2e2bcd8739ae039 = $f9ac84ac4cb3ced3$var$SubFilter;



parcelRequire("eO7Kz");





const $55b63b49088809dc$var$SubFilterAll = ({ className: className, fullParent: fullParent })=>{
    const { selectedFilters: selectedFilters, processFiltersOnChange: processFiltersOnChange } = (0, $719f01871b6350db$export$f9763ecd339e95eb)();
    const { locale: locale } = (0, $2e4dc8fa28d39601$export$6650dace022cfacc)();
    return /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsxs)("div", {
        className: `rf-w-full rf-py-4 large:rf-py-1 rf-flex rf-justify-between rf-items-center ${className}`,
        children: [
            (0, $8fd1ab545cc1ab7a$export$d07f57595c356899)((0, (/*@__PURE__*/$parcel$interopDefault($de9b046f76977201$exports)))[locale]?.all || (0, (/*@__PURE__*/$parcel$interopDefault($de9b046f76977201$exports)))["fr-FR"].all, locale),
            /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $c4c5ab9a3bd3f778$export$2e2bcd8739ae039), {
                className: "rf-rounded large:rf-ml-8",
                iconClassName: "rf-w-4 rf-h-4 large:rf-p-min1 large:rf-w-6 large:rf-h-6",
                checked: selectedFilters.filter((filter)=>filter.title === fullParent.title && filter.items.length === fullParent.items.length).length === 1,
                onClick: ()=>processFiltersOnChange([
                        {
                            ...fullParent
                        }
                    ], true)
            })
        ]
    });
};
var $55b63b49088809dc$export$2e2bcd8739ae039 = $55b63b49088809dc$var$SubFilterAll;


/* eslint-disable react/jsx-boolean-value */ 
parcelRequire("eO7Kz");


const $b1e71a3296b972dc$var$SubFilterCalendar = ({ parent: parent })=>{
    const { selectedFilters: selectedFilters, processFiltersOnChange: processFiltersOnChange } = (0, $719f01871b6350db$export$f9763ecd339e95eb)();
    const handleCalendarChange = (newDate)=>{
        processFiltersOnChange([
            {
                ...parent,
                items: [
                    newDate
                ]
            }
        ]);
    };
    return /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("div", {
        className: "rf-w-full rf-pt-4 large:rf-py-1 rf-flex rf-justify-between rf-items-center",
        children: /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $cc34a7543405d90a$export$2e2bcd8739ae039), {
            id: "filterCalendar",
            handleChange: handleCalendarChange,
            defaultValue: selectedFilters.find((filter)=>filter.id === "Event.DateRange" && filter.items.length > 0)?.items[0].substring(0, 11),
            isFilter: true
        })
    });
};
var $b1e71a3296b972dc$export$2e2bcd8739ae039 = $b1e71a3296b972dc$var$SubFilterCalendar;


const $98f9edd52458e26a$var$FilterItem = ({ className: className, identifier: identifier, opened: opened, filter: filter, closeOpenedFilters: closeOpenedFilters })=>{
    const { locale: locale } = (0, $2e4dc8fa28d39601$export$6650dace022cfacc)((state)=>({
            locale: state.locale
        }));
    const { isMobile: isMobile } = (0, $8b59a4dbb18c269b$export$3abe3478af3cb63b)();
    const [style, setStyle] = (0, $eO7Kz.useState)("");
    (0, $eO7Kz.useEffect)(()=>{
        opened ? setStyle("rf-bg-truewhite rf-text-black rf-border-black") : setStyle("rf-bg-templateBackground rf-text-gray rf-border-gray");
    }, [
        opened
    ]);
    const handleOpen = (e)=>{
        e.preventDefault();
        e.stopPropagation();
        closeOpenedFilters(opened ? undefined : identifier);
    };
    return /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsxs)("div", {
        className: "rf-relative rf-mt-1",
        children: [
            /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsxs)("div", {
                className: `rf-px-4 rf-py-3 rf-mr-4 large-vertical:rf-py-4 ${style} rf-border rf-rounded-lg hover:rf-cursor-pointer rf-flex rf-flex-row rf-items-center rf-justify-center ${className}`,
                onClick: (e)=>handleOpen(e),
                children: [
                    /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("div", {
                        className: "rf-mr-3",
                        children: (0, $8fd1ab545cc1ab7a$export$d07f57595c356899)(filter.title, locale)
                    }),
                    opened ? /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $dccbc315b4d39afa$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $5352670cffb3057c$export$2e2bcd8739ae039), {})
                ]
            }),
            opened && /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("div", {
                className: "rf-absolute rf-left-0 rf-top-110 rf-z-util rf-w-max rf-py-1 rf-px-4 rf-text-black rf-border rf-rounded-lg rf-border-black rf-bg-truewhite rf-flex rf-flex-col rf-items-center rf-justify-center",
                style: {
                    transform: filter.id === "Event.DateRange" && !isMobile ? "translate(-20%, -20%) scale(0.6, 0.6)" : ""
                },
                children: filter.id === "Event.DateRange" ? /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $b1e71a3296b972dc$export$2e2bcd8739ae039), {
                    parent: {
                        id: filter.id,
                        title: filter.title
                    }
                }) : /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($eO7Kz))).Fragment, {
                    children: [
                        /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $55b63b49088809dc$export$2e2bcd8739ae039), {
                            fullParent: filter
                        }),
                        filter.items.map((item, key)=>{
                            return /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $f9ac84ac4cb3ced3$export$2e2bcd8739ae039), {
                                name: item,
                                parent: {
                                    id: filter.id,
                                    title: filter.title
                                }
                            }, key);
                        })
                    ]
                })
            })
        ]
    });
};
var $98f9edd52458e26a$export$2e2bcd8739ae039 = $98f9edd52458e26a$var$FilterItem;


const $9e37daabc598fe89$var$FilterLarge = ({ className: className, openedFilterKey: openedFilterKey, setOpenedFilterKey: setOpenedFilterKey })=>{
    const { filters: filters, selectedFilters: selectedFilters } = (0, $719f01871b6350db$export$f9763ecd339e95eb)();
    const closeOpenedFilters = (key)=>{
        setOpenedFilterKey(key);
    };
    return /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsxs)("div", {
        className: `rf-flex rf-flex-col rf-justify-start ${className}`,
        children: [
            /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("div", {
                className: "rf-relative rf-flex rf-flex-row rf-flex-wrap",
                children: filters.map((filter, key)=>{
                    return /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $98f9edd52458e26a$export$2e2bcd8739ae039), {
                        identifier: key + 1,
                        opened: (openedFilterKey && key + 1 === openedFilterKey) === true,
                        filter: filter,
                        closeOpenedFilters: closeOpenedFilters
                    }, key);
                })
            }),
            /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("div", {
                className: "rf-flex rf-flex-row rf-my-2 rf-flex-wrap",
                children: selectedFilters?.map((chosenFilter, key1)=>{
                    return chosenFilter.items.map((name, key2)=>{
                        return /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $fa5dc3d629beb18e$export$2e2bcd8739ae039), {
                            className: "rf-px-4 rf-mr-2 rf-mb-1",
                            name: name,
                            parent: {
                                id: chosenFilter.id,
                                title: chosenFilter.title
                            }
                        }, `${key1}-${key2}`);
                    });
                })
            })
        ]
    });
};
var $9e37daabc598fe89$export$2e2bcd8739ae039 = $9e37daabc598fe89$var$FilterLarge;




var $eO7Kz = parcelRequire("eO7Kz");







var $eO7Kz = parcelRequire("eO7Kz");






parcelRequire("eO7Kz");



const $3358755e29a6c47b$var$MobileUpperBand = ({ title: title, handleReset: handleReset, handleReturn: handleReturn })=>{
    const { locale: locale } = (0, $2e4dc8fa28d39601$export$6650dace022cfacc)();
    return /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsxs)("div", {
        className: "rf-w-full rf-py-4 rf-px-4 rf-flex rf-justify-between rf-items-center rf-border-b rf-border-b-black",
        children: [
            /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsxs)("button", {
                className: "rf-flex rf-flex-row rf-items-center rf-text-size-auto",
                onClick: handleReturn,
                children: [
                    /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $ec723792d02ac7e8$export$2e2bcd8739ae039), {
                        className: "rf-w-8"
                    }),
                    /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("div", {
                        className: "rf-ml-1",
                        children: title
                    })
                ]
            }),
            /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("div", {
                className: "rf-text-xsm rf-uppercase rf-text-secondary rf-underline",
                onClick: handleReset,
                children: (0, (/*@__PURE__*/$parcel$interopDefault($de9b046f76977201$exports)))[locale]?.reset || (0, (/*@__PURE__*/$parcel$interopDefault($de9b046f76977201$exports)))["fr-FR"].reset
            })
        ]
    });
};
var $3358755e29a6c47b$export$2e2bcd8739ae039 = $3358755e29a6c47b$var$MobileUpperBand;


const $127c2d8bc98ac06e$var$MobileFilterPage = ({ close: close, resetFilters: resetFilters, setCurrentOpened: setCurrentOpened })=>{
    const { filters: filters, processFiltersOnChange: processFiltersOnChange } = (0, $719f01871b6350db$export$f9763ecd339e95eb)();
    const { locale: locale } = (0, $2e4dc8fa28d39601$export$6650dace022cfacc)((state)=>({
            locale: state.locale
        }));
    const handleSelectAllAndOpen = (filter)=>{
        processFiltersOnChange([
            filter
        ], true);
        setCurrentOpened(filter);
    };
    return /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($eO7Kz))).Fragment, {
        children: [
            /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $3358755e29a6c47b$export$2e2bcd8739ae039), {
                title: (0, (/*@__PURE__*/$parcel$interopDefault($de9b046f76977201$exports)))[locale]?.filter || "Filter",
                handleReset: resetFilters,
                handleReturn: close
            }),
            /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("div", {
                className: "rf-w-full rf-px-2",
                children: filters.map((filter, key)=>{
                    return /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsxs)("div", {
                        className: `rf-py-4 rf-text-xl rf-font-semibold rf-flex rf-justify-between rf-items-center rf-cursor-pointer ${key !== 0 && "rf-border-t rf-border-t-[#CBC9C9]"}`,
                        onClick: ()=>setCurrentOpened(filter),
                        children: [
                            (0, $8fd1ab545cc1ab7a$export$d07f57595c356899)(filter.title, locale),
                            /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsxs)("div", {
                                className: "rf-flex rf-items-center",
                                children: [
                                    filter.id !== "Event.DateRange" && /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("div", {
                                        className: "rf-text-sm rf-text-gray rf-mr-5",
                                        onClick: ()=>handleSelectAllAndOpen(filter),
                                        children: (0, $8fd1ab545cc1ab7a$export$d07f57595c356899)((0, (/*@__PURE__*/$parcel$interopDefault($de9b046f76977201$exports)))[locale]?.all || "all", locale)
                                    }),
                                    /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $665d46c53901fdd5$export$2e2bcd8739ae039), {
                                        className: "rf-h-5",
                                        color: "#000"
                                    })
                                ]
                            })
                        ]
                    }, key);
                })
            })
        ]
    });
};
var $127c2d8bc98ac06e$export$2e2bcd8739ae039 = $127c2d8bc98ac06e$var$MobileFilterPage;




var $eO7Kz = parcelRequire("eO7Kz");






const $f4b8e89ef5f4ce80$var$MobileSubFilterPage = ({ filter: filter, close: close, resetFilters: resetFilters })=>{
    const { locale: locale } = (0, $2e4dc8fa28d39601$export$6650dace022cfacc)((state)=>({
            locale: state.locale
        }));
    return /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($eO7Kz))).Fragment, {
        children: [
            /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $3358755e29a6c47b$export$2e2bcd8739ae039), {
                title: (0, $8fd1ab545cc1ab7a$export$d07f57595c356899)(filter.title, locale),
                handleReset: resetFilters,
                handleReturn: close
            }),
            /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("div", {
                className: "rf-w-full rf-px-2",
                children: filter.id === "Event.DateRange" ? /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $b1e71a3296b972dc$export$2e2bcd8739ae039), {
                    parent: {
                        id: filter.id,
                        title: filter.title
                    }
                }) : /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($eO7Kz))).Fragment, {
                    children: [
                        /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $55b63b49088809dc$export$2e2bcd8739ae039), {
                            className: "rf-text-xl rf-border-b rf-border-b-silver",
                            fullParent: filter
                        }),
                        filter.items.map((item, key)=>{
                            return /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $f9ac84ac4cb3ced3$export$2e2bcd8739ae039), {
                                className: "rf-text-xl",
                                name: item,
                                parent: {
                                    id: filter.id,
                                    title: filter.title
                                }
                            }, key);
                        })
                    ]
                })
            })
        ]
    });
};
var $f4b8e89ef5f4ce80$export$2e2bcd8739ae039 = $f4b8e89ef5f4ce80$var$MobileSubFilterPage;



parcelRequire("eO7Kz");




const $0835d64f62a6e8e5$var$MobileDisplayResult = ({ onClick: onClick })=>{
    const { locale: locale } = (0, $2e4dc8fa28d39601$export$6650dace022cfacc)((state)=>({
            locale: state.locale
        }));
    const { mode: mode } = (0, $e599569c1fc3ca2c$export$d8760bee47331b1d)();
    return /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("div", {
        className: `rf-w-full rf-pt-8 ${mode === (0, $16ad089b9ce6627d$export$9484bbecc3c49a2e).text ? "rf-mb-30" : "rf-mb-16"} rf-flex rf-justify-center rf-justify-self-end`,
        children: /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("button", {
            className: "rf-py-4 rf-px-6 rf-font-bold rf-text-secondary rf-border-2 rf-rounded-lg rf-border-secondary",
            onClick: onClick,
            children: (0, (/*@__PURE__*/$parcel$interopDefault($de9b046f76977201$exports)))[locale]?.showresults || "Show results"
        })
    });
};
var $0835d64f62a6e8e5$export$2e2bcd8739ae039 = $0835d64f62a6e8e5$var$MobileDisplayResult;



const $c5fbdb5183846e78$var$FilterMobile = ({ className: className, setFiltersOpened: setFiltersOpened, handleClose: handleClose })=>{
    const { resetFilters: resetFilters } = (0, $719f01871b6350db$export$f9763ecd339e95eb)();
    const { locale: locale } = (0, $2e4dc8fa28d39601$export$6650dace022cfacc)();
    const [open, setOpen] = (0, $eO7Kz.useState)(false);
    const [currentOpened, setCurrentOpened] = (0, $eO7Kz.useState)(undefined);
    (0, $eO7Kz.useEffect)(()=>{
        setFiltersOpened(open);
    }, [
        open
    ]);
    const handleClick = ()=>{
        setOpen(true);
    };
    const handleReturn = ()=>{
        setOpen(false);
    };
    const handleReset = ()=>{
        setOpen(false);
        resetFilters && resetFilters();
    };
    const closeCurrentSubFilters = ()=>{
        setCurrentOpened(undefined);
    };
    const handleDisplayResults = ()=>{
        setCurrentOpened(undefined);
        setOpen(false);
    };
    return !open ? /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsxs)("div", {
        className: `large:rf-hidden rf-w-full rf-py-4 rf-px-4 rf-flex rf-flex-row rf-justify-between rf-items-center rf-bg-truewhite rf-shadow-[0_0_15px_0_silver] ${className}`,
        children: [
            /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $53c3829f3df8be22$export$2e2bcd8739ae039), {
                title: (0, (/*@__PURE__*/$parcel$interopDefault($abbebf5de79f9da4$exports)))[locale]?.backconversation || (0, (/*@__PURE__*/$parcel$interopDefault($abbebf5de79f9da4$exports)))["fr-FR"].backconversation,
                handleBack: handleClose,
                className: "rf-relative rf-text-size-auto"
            }),
            /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsxs)("button", {
                className: "rf-px-4 rf-py-1 rf-flex rf-flex-row rf-items-center rf-border rf-rounded-lg rf-border-black",
                onClick: handleClick,
                children: [
                    /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $8a6bb6dedf1de271$export$2e2bcd8739ae039), {
                        className: "rf-h-4 rf-w-4"
                    }),
                    /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("div", {
                        className: "rf-ml-2",
                        children: (0, (/*@__PURE__*/$parcel$interopDefault($de9b046f76977201$exports)))[locale]?.filter || (0, (/*@__PURE__*/$parcel$interopDefault($de9b046f76977201$exports)))["fr-FR"].filter
                    })
                ]
            })
        ]
    }) : /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsxs)("div", {
        className: "rf-absolute rf-z-util large:rf-hidden rf-top-0 rf-left-0 rf-w-full rf-min-h-full rf-overflow-y-scroll rf-scrollbar-hidden rf-bg-truewhite rf-flex rf-flex-col rf-justify-between",
        children: [
            /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("div", {
                className: "rf-flex rf-flex-col rf-justify-start rf-align-center",
                children: currentOpened ? /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $f4b8e89ef5f4ce80$export$2e2bcd8739ae039), {
                    filter: currentOpened,
                    close: closeCurrentSubFilters,
                    resetFilters: handleReset
                }) : /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $127c2d8bc98ac06e$export$2e2bcd8739ae039), {
                    setCurrentOpened: setCurrentOpened,
                    close: handleReturn,
                    resetFilters: handleReset
                })
            }),
            /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $0835d64f62a6e8e5$export$2e2bcd8739ae039), {
                onClick: handleDisplayResults
            })
        ]
    });
};
var $c5fbdb5183846e78$export$2e2bcd8739ae039 = $c5fbdb5183846e78$var$FilterMobile;





var $eO7Kz = parcelRequire("eO7Kz");




var $gySRD = parcelRequire("gySRD");




const $a082062d01100882$var$ListContainer = ({ hasFilterOrSuggestedAction: hasFilterOrSuggestedAction })=>{
    const locale = (0, $2e4dc8fa28d39601$export$6650dace022cfacc)((state)=>state.locale);
    const { content: content } = (0, $719f01871b6350db$export$f9763ecd339e95eb)();
    const { currentDeviceType: currentDeviceType, isMobile: isMobile } = (0, $8b59a4dbb18c269b$export$3abe3478af3cb63b)();
    const [contentToDisplay, setContentToDisplay] = (0, $eO7Kz.useState)([]);
    const [landscapeStyle, setLandscapeStyle] = (0, $eO7Kz.useState)("large:rf-h-3/5");
    const [limitToFill, setLimitToFill] = (0, $eO7Kz.useState)(0);
    const renderAttachment = (0, $gySRD.useRenderAttachment)();
    const scrollRef = (0, $eO7Kz.useRef)(null);
    (0, $eO7Kz.useEffect)(()=>{
        setLandscapeStyle(hasFilterOrSuggestedAction ? "large:rf-h-[60vh]" : "");
    }, [
        hasFilterOrSuggestedAction
    ]);
    (0, $eO7Kz.useEffect)(()=>{
        switch(currentDeviceType){
            case (0, $16ad089b9ce6627d$export$ec1e04e4e5ef8233).landscape:
                setLimitToFill(10);
                break;
            case (0, $16ad089b9ce6627d$export$ec1e04e4e5ef8233).borne:
                setLimitToFill(9);
                break;
            case (0, $16ad089b9ce6627d$export$ec1e04e4e5ef8233).mobile:
            case (0, $16ad089b9ce6627d$export$ec1e04e4e5ef8233).widget:
                setLimitToFill(0);
                break;
        }
    }, [
        currentDeviceType
    ]);
    (0, $eO7Kz.useEffect)(()=>{
        if (content?.attachments && content.attachments.length > 0) {
            // Transform first and last attachments if they are 'previous' or 'next' cards
            if (content.attachments[0].contentType !== (0, $67e1576cd7fc37b7$export$8c612ad42a82284)) content.attachments[0].contentType = (0, $67e1576cd7fc37b7$export$4e4550ddaa0ad2f9);
            if (content.attachments.length > 2 && content.attachments[content.attachments.length - 1].contentType !== (0, $67e1576cd7fc37b7$export$8c612ad42a82284)) content.attachments[content.attachments.length - 1].contentType = (0, $67e1576cd7fc37b7$export$4e4550ddaa0ad2f9);
            // On a mobile device, if there is an odd number of attachments, we put a grey one at the end
            if (isMobile && content.attachments.length % 2 !== 0) setContentToDisplay([
                ...content?.attachments,
                {
                    contentType: (0, $67e1576cd7fc37b7$export$9399f66a54c38cac)
                }
            ]);
            else if (content.attachments.length < limitToFill) {
                const tempAttachments = [
                    ...content.attachments
                ];
                let i = content.attachments.length;
                while(i < limitToFill){
                    tempAttachments.push({
                        contentType: (0, $67e1576cd7fc37b7$export$9399f66a54c38cac)
                    });
                    i++;
                }
                setContentToDisplay(tempAttachments);
            } else setContentToDisplay(content.attachments);
        } else setContentToDisplay([]);
    }, [
        content,
        limitToFill
    ]);
    /**
   * On call :
   *  - scroll to the scrollRef HTML element at the top of the view
   */ const scrollToRef = ()=>{
        if (scrollRef && scrollRef.current !== null) scrollRef.current.scrollIntoView({
            behavior: "smooth"
        });
    };
    /**
   * On content change :
   *  - call scrollToRef method if we are not in mobile mobe
   */ (0, $eO7Kz.useEffect)(()=>{
        const timer = content && !isMobile ? setTimeout(()=>{
            scrollToRef();
        }, 100) : null;
        return ()=>{
            timer && clearTimeout(timer);
        };
    }, [
        content
    ]);
    return content ? /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsxs)("div", {
        className: `rf-w-full rf-mb-8 ${landscapeStyle} large-vertical:rf-h-[50vh] rf-overflow-y-visible large:rf-overflow-y-scroll rf-scrollbar-hidden ${!isMobile && "rf-opacity-gradient-b-thin"} rf-px-2 large:rf-px-0 rf-pb-8 large:rf-pb-16`,
        children: [
            /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("div", {
                ref: scrollRef
            }),
            /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $8f63b1b0cd12cb7f$export$2e2bcd8739ae039), {
                children: contentToDisplay.length === 0 ? /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("div", {
                    children: (0, (/*@__PURE__*/$parcel$interopDefault($8f95d7a47c249d24$exports)))[locale]?.nodata || (0, (/*@__PURE__*/$parcel$interopDefault($8f95d7a47c249d24$exports)))["fr-FR"].nodata
                }) : contentToDisplay.map((attachment, key)=>{
                    return /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("div", {
                        children: renderAttachment({
                            activity: content,
                            attachment: attachment
                        })
                    }, key);
                })
            })
        ]
    }) : /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eO7Kz))).Fragment, {});
};
var $a082062d01100882$export$2e2bcd8739ae039 = $a082062d01100882$var$ListContainer;



parcelRequire("eO7Kz");




parcelRequire("eO7Kz");




const $40be3aab6abbd331$var$VocalReminder = ({ className: className, handleClose: handleClose })=>{
    const { locale: locale } = (0, $2e4dc8fa28d39601$export$6650dace022cfacc)((state)=>({
            locale: state.locale
        }));
    return /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsxs)("div", {
        className: `hover:rf-cursor-pointer rf-flex rf-flex-row rf-items-start ${className}`,
        onClick: handleClose,
        children: [
            /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("img", {
                src: (0, $9062ab1ccebf2f9e$export$e56d88b19b5c9fbf).leaMini,
                className: "rf-h-12"
            }),
            /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsxs)("div", {
                className: "rf-flex rf-flex-col rf-align-start rf-justify-start",
                children: [
                    /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("div", {
                        className: "rf-flex rf-flex-col rf-pl-2",
                        children: ((0, (/*@__PURE__*/$parcel$interopDefault($de9b046f76977201$exports)))[locale]?.reminder || (0, (/*@__PURE__*/$parcel$interopDefault($de9b046f76977201$exports)))["fr-FR"]?.reminder).split("\n").map((line, key)=>{
                            return /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("div", {
                                children: line
                            }, key);
                        })
                    }),
                    /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $ed16b2a5f01fd8db$export$2e2bcd8739ae039), {})
                ]
            })
        ]
    });
};
var $40be3aab6abbd331$export$2e2bcd8739ae039 = $40be3aab6abbd331$var$VocalReminder;



parcelRequire("eO7Kz");


const $a4a5fdc510119616$var$SuggestionsItem = ({ className: className, title: title, value: value, results: results, handleClick: handleClick })=>{
    const { locale: locale } = (0, $2e4dc8fa28d39601$export$6650dace022cfacc)();
    return /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsxs)("button", {
        onClick: ()=>handleClick(value),
        className: `rf-h-fit rf-px-4 rf-py-3 rf-mr-4 rf-mb-4 large-vertical:rf-py-4 rf-border rf-rounded-lg rf-bg-templateBackground rf-text-black rf-border-black hover:rf-cursor-pointer rf-flex rf-flex-row rf-items-center rf-justify-center ${className}`,
        "aria-label": title,
        children: [
            (0, $8fd1ab545cc1ab7a$export$d07f57595c356899)(title, locale),
            /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("div", {
                className: "rf-ml-6 rf-text-gray",
                children: results || 0
            })
        ]
    });
};
var $a4a5fdc510119616$export$2e2bcd8739ae039 = $a4a5fdc510119616$var$SuggestionsItem;



var $fD7D4 = parcelRequire("fD7D4");
const { useSendPostBack: $1b08de545e9bafe6$var$useSendPostBack } = (0, $fD7D4.hooks);
const $1b08de545e9bafe6$var$Suggestions = ({ className: className, suggestions: suggestions, handleClose: handleClose })=>{
    const sendPostBack = $1b08de545e9bafe6$var$useSendPostBack();
    const { setSuggestedFilter: setSuggestedFilter } = (0, $719f01871b6350db$export$f9763ecd339e95eb)();
    const { locale: locale } = (0, $2e4dc8fa28d39601$export$6650dace022cfacc)();
    const handleClick = (value)=>{
        setSuggestedFilter(value);
        sendPostBack({
            filters: [
                value
            ]
        });
    };
    return /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsxs)("div", {
        className: `rf-flex rf-flex-col rf-items-start ${className}`,
        children: [
            /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("div", {
                className: "rf-text-3xl large:rf-text-5xl rf-font-bold rf-mb-5",
                children: (0, (/*@__PURE__*/$parcel$interopDefault($de9b046f76977201$exports)))[locale]?.suggestiontitle || (0, (/*@__PURE__*/$parcel$interopDefault($de9b046f76977201$exports)))["fr-FR"].suggestiontitle
            }),
            /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsxs)("div", {
                className: "rf-flex rf-flex-row rf-flex-wrap",
                children: [
                    /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("div", {
                        className: "rf-flex rf-flex-row rf-flex-wrap",
                        children: suggestions.map((suggestion, key)=>{
                            return /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $a4a5fdc510119616$export$2e2bcd8739ae039), {
                                title: suggestion.title,
                                value: suggestion.value.filter,
                                results: suggestion.value.results !== undefined ? suggestion.value.results : "NC",
                                handleClick: handleClick
                            }, key);
                        })
                    }),
                    /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $40be3aab6abbd331$export$2e2bcd8739ae039), {
                        handleClose: handleClose,
                        className: "large:rf-ml-12"
                    })
                ]
            })
        ]
    });
};
var $1b08de545e9bafe6$export$2e2bcd8739ae039 = $1b08de545e9bafe6$var$Suggestions;


const $9062708e85f1e456$var$List = ({ activity: activity, onClose: onClose })=>{
    const { mode: mode } = (0, $e599569c1fc3ca2c$export$d8760bee47331b1d)();
    const { isMobile: isMobile } = (0, $8b59a4dbb18c269b$export$3abe3478af3cb63b)();
    const { content: content, filters: filters, selectedFilters: selectedFilters, setContent: setContent } = (0, $719f01871b6350db$export$f9763ecd339e95eb)();
    const { locale: locale } = (0, $2e4dc8fa28d39601$export$6650dace022cfacc)();
    const { lastListActivity: lastListActivity } = (0, $134592d23f105dbc$export$77e4cc5334565f28)();
    const [mobileFiltersOpened, setMobileFiltersOpened] = (0, $eO7Kz.useState)(false);
    const [largeFilterOpenedKey, setLargeFilterOpenedKey] = (0, $eO7Kz.useState)(undefined);
    const scrollRef = (0, $eO7Kz.useRef)(null);
    /**
   * On call :
   *  - set ListContext's content state to undefined
   */ const handleClose = ()=>{
        onClose && onClose();
        setContent(undefined);
    };
    /**
   * On activity prop change :
   *  - check if the activity has already been displayed or not, using utilsStore's lastListActivity state
   *  - if the activity hasn't been displayed yet, set ListContext's content state with the activity
   * On component unmount :
   *  - set utilsStore's lastListActivity state to the current activity's id
   */ (0, $eO7Kz.useEffect)(()=>{
        activity && activity.id !== lastListActivity && setContent(activity);
        return ()=>{
            activity?.id && (0, $134592d23f105dbc$export$e2194ce98b9711c9)(activity.id);
        };
    }, [
        activity
    ]);
    /**
   * On call :
   *  - scroll to the scrollRef HTML element at the top of the view
   */ const scrollToRef = ()=>{
        if (scrollRef && scrollRef.current !== null) scrollRef.current.scrollIntoView({
            behavior: "smooth"
        });
    };
    /**
   * On content change :
   *  - call scrollToRef method
   */ (0, $eO7Kz.useEffect)(()=>{
        const timer = content && isMobile ? setTimeout(()=>{
            scrollToRef();
        }, 100) : null;
        return ()=>{
            timer && clearTimeout(timer);
        };
    }, [
        content
    ]);
    return content ? /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsxs)((0, $47785786bd448bb5$export$2e2bcd8739ae039), {
        className: "large:rf-px-16 rf-flex rf-flex-col large:rf-h-full",
        handleClose: handleClose,
        onClick: isMobile ? ()=>{} : ()=>setLargeFilterOpenedKey(undefined),
        remoteCloseButtonZIndex: "rf-z-util",
        children: [
            isMobile && filters.length > 0 && /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $c5fbdb5183846e78$export$2e2bcd8739ae039), {
                setFiltersOpened: setMobileFiltersOpened,
                handleClose: handleClose
            }),
            /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsxs)("div", {
                className: "rf-w-full rf-overflow-y-scroll rf-scrollbar-hidden",
                children: [
                    /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("div", {
                        ref: scrollRef
                    }),
                    /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsxs)("div", {
                        className: `${mobileFiltersOpened ? "rf-hidden" : "rf-flex"} rf-flex-col rf-items-start large:rf-pt-16 large-vertical:rf-pt-[20vh]`,
                        children: [
                            content.text && /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $54dc5120d2a03001$export$2e2bcd8739ae039), {
                                className: "rf-ml-2 rf-mt-8 large:rf-ml-0 large:rf-mt-0",
                                title: (0, $8fd1ab545cc1ab7a$export$d07f57595c356899)(content.text, locale),
                                numberOfResults: content.channelData?.numberOfResults || 0
                            }),
                            !isMobile && filters.length > 0 && /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $9e37daabc598fe89$export$2e2bcd8739ae039), {
                                openedFilterKey: largeFilterOpenedKey,
                                setOpenedFilterKey: setLargeFilterOpenedKey
                            }),
                            isMobile && /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("div", {
                                className: "rf-flex rf-flex-row rf-mx-2 rf-gap-2 rf-mb-2 rf-flex-wrap",
                                children: selectedFilters?.map((chosenFilter, key1)=>{
                                    return chosenFilter.items.map((name, key2)=>{
                                        return /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $fa5dc3d629beb18e$export$2e2bcd8739ae039), {
                                            className: "rf-px-2",
                                            name: name,
                                            parent: {
                                                id: chosenFilter.id,
                                                title: chosenFilter.title
                                            }
                                        }, `${key1}-${key2}`);
                                    });
                                })
                            }),
                            /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $a082062d01100882$export$2e2bcd8739ae039), {
                                hasFilterOrSuggestedAction: filters.length > 0 || content.suggestedActions?.actions?.length > 0
                            }),
                            content.suggestedActions?.actions && content.suggestedActions.actions.length > 0 && /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $1b08de545e9bafe6$export$2e2bcd8739ae039), {
                                className: `rf-px-2 ${mode === (0, $16ad089b9ce6627d$export$9484bbecc3c49a2e).text ? "rf-mb-28" : "rf-mb-16"} large:rf-px-0 large:rf-mb-4`,
                                suggestions: content.suggestedActions.actions,
                                handleClose: handleClose
                            })
                        ]
                    })
                ]
            })
        ]
    }) : /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eO7Kz))).Fragment, {});
};
var $9062708e85f1e456$export$2e2bcd8739ae039 = $9062708e85f1e456$var$List;


const $b1d30aac07bca848$var$List = ({ activity: activity, onClose: onClose })=>{
    return /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $b1b23721940b85e5$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $9062708e85f1e456$export$2e2bcd8739ae039), {
            activity: activity,
            onClose: onClose
        })
    });
};
var $b1d30aac07bca848$export$2e2bcd8739ae039 = $b1d30aac07bca848$var$List;




var $eO7Kz = parcelRequire("eO7Kz");


var $gySRD = parcelRequire("gySRD");



var $eO7Kz = parcelRequire("eO7Kz");

parcelRequire("eO7Kz");



const { useActivities: $7bb94569b6340a35$var$useActivities } = (0, $497baa802110a7bc$exports.hooks);
const $7bb94569b6340a35$var$useFullscreenImage = ()=>{
    const [activities] = $7bb94569b6340a35$var$useActivities();
    const { fullScreenImage: fullScreenImage } = (0, $134592d23f105dbc$export$77e4cc5334565f28)();
    if (fullScreenImage) return fullScreenImage;
    if (activities && activities.length > 0) {
        const lastActivity = activities.slice(-1)[0];
        if (lastActivity.type === "event" && lastActivity.name === "hospitality.ShowImage" && lastActivity.value) return lastActivity.value;
    }
    return undefined;
};
var $7bb94569b6340a35$export$2e2bcd8739ae039 = $7bb94569b6340a35$var$useFullscreenImage;



parcelRequire("eO7Kz");
const $e4777c2eb860cbef$var$ScrollButtonIcon = ({ className: className, color: color })=>{
    return /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("svg", {
        version: "1.1",
        id: "Layer_1",
        xmlns: "http://www.w3.org/2000/svg",
        x: "0px",
        y: "0px",
        viewBox: "0 0 100 100",
        className: className,
        children: /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("path", {
            id: "Icon_ionic-ios-arrow-down",
            fill: color,
            className: "st0",
            d: "M 49.948 29.033 L 13.413 65.414 C 10.792 68.035 6.323 68.188 3.702 65.414 C 3.702 65.414 3.702 65.414 3.702 65.414 C 1.081 62.639 1.081 58.322 3.702 55.702 L 45.015 14.388 C 47.636 11.767 51.798 11.767 54.573 14.233 L 96.195 55.856 C 98.97 58.477 98.97 62.947 96.195 65.568 C 93.574 68.343 89.103 68.343 86.484 65.568 L 49.948 29.033 Z"
        })
    });
};
var $e4777c2eb860cbef$export$2e2bcd8739ae039 = $e4777c2eb860cbef$var$ScrollButtonIcon;


const $b17b9cd9c76f9d83$export$93d01adc5582c83e = ({ direction: direction, display: display, ScrollHandler: ScrollHandler, setPreventScroll: setPreventScroll, className: className })=>{
    const { themeColors: themeColors } = (0, $8b59a4dbb18c269b$export$3abe3478af3cb63b)();
    const fullScreenImage = (0, $7bb94569b6340a35$export$2e2bcd8739ae039)();
    const handleClick = ()=>{
        setPreventScroll(true);
        if (direction === "top") {
            ScrollHandler("top", "button");
            console.log("handleClick - top");
        } else {
            console.log("handleClick - bottom");
            ScrollHandler("bottom", "button");
        }
    };
    return /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $179ad052de55b86f$exports.Fragment), {
        children: display && !fullScreenImage ? /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("div", {
            id: "ScrollButton",
            className: className,
            onClick: handleClick,
            children: /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $e4777c2eb860cbef$export$2e2bcd8739ae039), {
                className: `${direction === "top" ? "rf-rotate-0" : "rf-rotate-180"}`,
                color: themeColors.primary
            })
        }) : /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $179ad052de55b86f$exports.Fragment), {})
    });
};


const $dd8ded24a1e95991$var$Card = ({ children: children, className: className, shadow: shadow = false })=>{
    const [scrollButtonDisplay, setScrollButtonDisplay] = (0, $eO7Kz.useState)(false);
    const [scrollButtonDirection, setScrollButtonDirection] = (0, $eO7Kz.useState)("bottom");
    const botEndRef = (0, $eO7Kz.useRef)(null);
    const cardRef = (0, $eO7Kz.useRef)(null);
    const ScrollHandler = (to, from)=>{
        if (to === "bottom") setScrollButtonDirection("top");
        else setScrollButtonDirection("bottom");
        if (from === "button" && botEndRef && botEndRef.current !== null && to === "bottom") botEndRef.current.scrollIntoView({
            behavior: "smooth"
        });
        else if (to === "top" && cardRef && cardRef.current) cardRef.current.children[1].scrollIntoView({
            behavior: "smooth"
        });
    };
    const handleScroll = ()=>{
        if (cardRef.current) {
            const parentHeight = cardRef.current.parentElement?.clientHeight;
            const scrollHeight = cardRef.current.scrollHeight;
            const scrollTop = cardRef.current.scrollTop;
            // const offsetHeight = (cardRef.current as HTMLDivElement).offsetHeight
            const clientHeight = cardRef.current.clientHeight;
            if (parentHeight && scrollHeight > parentHeight) {
                if (scrollHeight - scrollTop < clientHeight + 10) {
                    setScrollButtonDisplay(true);
                    setScrollButtonDirection("top");
                } else {
                    setScrollButtonDisplay(true);
                    setScrollButtonDirection("bottom");
                }
            } else setScrollButtonDisplay(false);
        }
    };
    /**
   * On DragStart event call :
   *  - prevent default behaviour and stop propagation of the event
   *  - this is to prevent image dragging while trying to swipe in a carousel
   * @param e : React.DragEvent
   */ const handleDragStart = (e)=>{
        e.preventDefault();
        e.stopPropagation();
    };
    // Check scroll at component first render
    (0, $eO7Kz.useEffect)(()=>{
        const timer = setTimeout(()=>{
            handleScroll();
        }, 500);
        return ()=>timer && clearTimeout(timer);
    }, []);
    return /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsxs)("div", {
        className: `rf-relative rf-max-h-full rf-flex rf-flex-col rf-text-size-auto rf-unselectable ${className}`,
        draggable: true,
        onDragStart: handleDragStart,
        style: {
            pointerEvents: "all"
        },
        children: [
            /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsxs)("div", {
                className: "rf-w-full rf-max-h-full rf-rounded rf-border rf-border-cardFrameBorder rf-flex rf-flex-col rf-content-around rf-justify-start rf-overflow-y-auto rf-scrollbar-thin rf-touch-none",
                ref: cardRef,
                onScroll: ()=>handleScroll(),
                children: [
                    /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $b17b9cd9c76f9d83$export$93d01adc5582c83e), {
                        direction: scrollButtonDirection,
                        display: scrollButtonDisplay,
                        ScrollHandler: ScrollHandler,
                        setPreventScroll: ()=>{},
                        className: "rf-absolute rf-z-ui rf-bottom-1 rf-right-6 rf-w-9 rf-h-9 rf-cursor-pointer rf-bg-[#00000050] rf-p-[7px_12px] rf-rounded-[20px] rf-flex"
                    }),
                    children,
                    /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("div", {
                        ref: botEndRef
                    })
                ]
            }),
            shadow && /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("div", {
                className: "rf-relative rf--bottom-2 rf-h-0 rf-w-11/12 rf-mx-auto rf-shadow-card"
            })
        ]
    });
};
var $dd8ded24a1e95991$export$2e2bcd8739ae039 = $dd8ded24a1e95991$var$Card;


/* eslint-disable react/jsx-boolean-value */ 

var $eO7Kz = parcelRequire("eO7Kz");







var $eO7Kz = parcelRequire("eO7Kz");
// The required distance between touchStart and touchEnd to be detected as a swipe
const $c77e7081a1b54b8c$var$minSwipeDistance = 30;
const $c77e7081a1b54b8c$var$Swiper = ({ direction: direction, onSwiping: onSwiping, onSwipeLeft: onSwipeLeft, onSwipeRight: onSwipeRight, onSwipeTop: onSwipeTop, onSwipeBottom: onSwipeBottom, className: className, children: children })=>{
    const [moveStart, setMoveStart] = (0, $eO7Kz.useState)(null);
    const [moveEnd, setMoveEnd] = (0, $eO7Kz.useState)(null);
    const [timeStart, setTimeStart] = (0, $eO7Kz.useState)(0);
    /**
   * On moveEnd state change :
   *  - set swiping distance to moveStart - moveEnd
   */ (0, $eO7Kz.useEffect)(()=>{
        if (moveStart && moveEnd) {
            const distance = moveStart - moveEnd;
            onSwiping(distance);
        }
    }, [
        moveEnd
    ]);
    /**
   * On PointerDown event fire :
   *  - set timeStart state to current timestamp
   *  - reset moveEnd state to null to prevent activation on single touch
   *  - set moveStart state with the current X or Y position depending on the direction prop
   * @param e : React.PointerEvent
   */ const onPointerDown = (e)=>{
        setTimeStart(Date.now());
        setMoveEnd(null);
        setMoveStart(direction === "horizontal" ? e.clientX : e.clientY);
    };
    /**
   * On PointerMove event fire :
   *  - set moveEnd state with the current X or Y position depending on the direction prop
   * @param e : React.PointerEvent
   */ const onPointerMove = (e)=>{
        setMoveEnd(direction === "horizontal" ? e.clientX : e.clientY);
    };
    /**
   * On PointerUp event fire :
   *  - calculate the distance between move start and end
   *  - prevent default behaviour and propagation of the event if the distance is large enough (prevent unwanted touch/click at the end of a slide)
   *  - call the parent method depending on the distance and the direction, or reset position if the distance is too small
   *  - reset moveStart state to null
   */ const onPointerUp = (e)=>{
        if (moveStart && moveEnd) {
            const elapsedTime = Date.now() - timeStart;
            const distance = moveStart - moveEnd;
            if (distance > $c77e7081a1b54b8c$var$minSwipeDistance) {
                e.preventDefault();
                e.stopPropagation();
                direction === "horizontal" ? onSwipeLeft(distance, elapsedTime) : onSwipeTop(distance, elapsedTime);
            } else if (distance < -$c77e7081a1b54b8c$var$minSwipeDistance) {
                e.preventDefault();
                e.stopPropagation();
                direction === "horizontal" ? onSwipeRight(distance, elapsedTime) : onSwipeBottom(distance, elapsedTime);
            } else onSwiping(0);
        }
        setMoveStart(null);
    };
    return /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("div", {
        className: `rf-relative rf-w-full rf-overflow-hidden ${className}`,
        onPointerDown: onPointerDown,
        onPointerUp: onPointerUp,
        onPointerMove: onPointerMove,
        onPointerLeave: onPointerUp,
        children: children
    });
};
var $c77e7081a1b54b8c$export$2e2bcd8739ae039 = $c77e7081a1b54b8c$var$Swiper;


// Cards' width coefficients depending on the mode and display type
const $0e854a097f4ee7fa$var$widthCoefficients = {
    textAndVocalMobile: 0.9,
    vocalDesktop: 0.6,
    vocalBorne: 0.45
};
const $0e854a097f4ee7fa$var$defaultTransitionDuration = "300ms";
const $0e854a097f4ee7fa$var$velocityBreakpoint = 0.5;
const $0e854a097f4ee7fa$var$Carousel = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eO7Kz))).forwardRef(({ direction: direction, history: history, children: children }, ref)=>{
    const { mode: mode } = (0, $e599569c1fc3ca2c$export$d8760bee47331b1d)();
    const { currentDeviceType: currentDeviceType, isMobile: isMobile, showHomeAttachments: showHomeAttachments } = (0, $8b59a4dbb18c269b$export$3abe3478af3cb63b)();
    const activity = (0, $e1bf7fd78241e7c2$export$2e2bcd8739ae039)();
    const nbCards = (0, (/*@__PURE__*/$parcel$interopDefault($eO7Kz))).Children.count(children);
    const gap = (0, $eO7Kz.useMemo)(()=>{
        return isMobile ? 0.3 : 1;
    }, [
        currentDeviceType
    ]);
    const coefficient = (0, $eO7Kz.useMemo)(()=>{
        return mode === (0, $16ad089b9ce6627d$export$9484bbecc3c49a2e).vocal ? currentDeviceType === (0, $16ad089b9ce6627d$export$ec1e04e4e5ef8233).landscape ? history ? $0e854a097f4ee7fa$var$widthCoefficients.textAndVocalMobile : $0e854a097f4ee7fa$var$widthCoefficients.vocalDesktop : currentDeviceType === (0, $16ad089b9ce6627d$export$ec1e04e4e5ef8233).borne ? history ? $0e854a097f4ee7fa$var$widthCoefficients.vocalDesktop : $0e854a097f4ee7fa$var$widthCoefficients.vocalBorne : $0e854a097f4ee7fa$var$widthCoefficients.textAndVocalMobile : $0e854a097f4ee7fa$var$widthCoefficients.textAndVocalMobile;
    }, [
        mode,
        currentDeviceType
    ]);
    const [cardWidth, setCardWidth] = (0, $eO7Kz.useState)(currentDeviceType === (0, $16ad089b9ce6627d$export$ec1e04e4e5ef8233).widget ? 400 * coefficient : window.innerWidth * coefficient);
    const [cardHeight, setCardHeight] = (0, $eO7Kz.useState)();
    const [currentCard, setCurrentCard] = (0, $eO7Kz.useState)(0);
    const [currentPadding, setCurrentPadding] = (0, $eO7Kz.useState)();
    const [translation, setTranslation] = (0, $eO7Kz.useState)("");
    const [transitionDuration, setTransitionDuration] = (0, $eO7Kz.useState)("1ms");
    const [gridTemplateColumn, setGridTemplateColumn] = (0, $eO7Kz.useState)(direction !== "vertical" ? `repeat(${nbCards}, ${cardWidth}px)` : "");
    const [gridTemplateRow, setGridTemplateRow] = (0, $eO7Kz.useState)(direction === "vertical" ? `repeat(${nbCards}, ${cardWidth * 10 / 16}px)` : "");
    const [wheeling, setWheeling] = (0, $eO7Kz.useState)(0);
    const divRef = (0, $eO7Kz.useRef)(null);
    const timerRef = (0, $eO7Kz.useRef)(null);
    /**
     * On cards container reference, mode / currentDeviceType states change :
     *  - calculate the cards' width depending on the coefficient
     *  - calculate the cards' height depending on the width (use a 16/10 format). Only used in vertical disposition
     *  - set the currentPadding state to have centered cards in horizontal disposition
     *  - set cardWidth, cardHeight and gridTemplateRow / gridTemplateColumn (depending on direction) states
     * On component unmount :
     *  - clear timeout
     */ (0, $eO7Kz.useEffect)(()=>{
        if (divRef.current) {
            const newCardWidth = Math.floor(divRef.current.clientWidth * coefficient);
            const newCardHeight = Math.ceil(newCardWidth * 10 / 16);
            // Space needed to center to cards
            setCurrentPadding((1 - coefficient) * divRef.current.clientWidth / 2);
            // Cards' width (all dispositions) and height (only used in vertical disposition)
            setCardWidth(newCardWidth);
            setCardHeight(newCardHeight);
            direction === "vertical" ? setGridTemplateRow(`repeat(${nbCards}, ${newCardHeight}px)`) : setGridTemplateColumn(`repeat(${nbCards}, ${newCardWidth}px)`);
            setCurrentCard(0);
        }
        return ()=>timerRef && clearTimeout(timerRef.current);
    }, [
        divRef,
        coefficient,
        currentDeviceType,
        activity?.id
    ]);
    /**
     * On currentCard, cardWidth, cardHeight, currentPadding states change :
     *  - set translation state depending on the direction
     */ (0, $eO7Kz.useEffect)(()=>{
        if (currentCard !== undefined && cardWidth !== undefined && cardHeight !== undefined && currentPadding !== undefined) direction === "vertical" ? setTranslation(`translateY(calc(-${currentCard * cardHeight}px - ${currentCard * gap}rem))`) : setTranslation(`translateX(calc(-${currentCard * cardWidth}px - ${currentCard * gap}rem + ${currentPadding}px))`);
    }, [
        currentCard,
        cardWidth,
        cardHeight,
        currentPadding
    ]);
    /**
     * On wheeling state change :
     *  - call either onSwipeRight or onSwipeLeft (with high values to enter the right part of the if condition), depending on the wheeling value (positive or negative)
     */ (0, $eO7Kz.useEffect)(()=>{
        wheeling && (wheeling > 0 ? onSwipeLeft(1000, 1000) : onSwipeRight(1000, 1000));
    }, [
        wheeling
    ]);
    (0, $eO7Kz.useEffect)(()=>{
        if (showHomeAttachments) setCurrentCard(0);
    }, [
        showHomeAttachments
    ]);
    /**
     * On call :
     *  - set translation to its initial state
     */ const resetPosition = ()=>{
        cardWidth && setTranslation(`translateX(calc(-${currentCard * cardWidth}px - ${currentCard * gap}rem + ${currentPadding}px))`);
    };
    /**
     * On call :
     *  - simulate a bounce effect by translating 1/10 of the width of a card in a sense, and then back
     * @param left : boolean
     */ const bounce = (left)=>{
        if (cardWidth) {
            setTransitionDuration($0e854a097f4ee7fa$var$defaultTransitionDuration);
            setTranslation(`translateX(calc(-${currentCard * cardWidth}px - ${currentCard * gap}rem + ${currentPadding}px ${left ? "-" : "+"} ${cardWidth / 10}px))`);
            timerRef && (timerRef.current = setTimeout(()=>{
                setTranslation(`translateX(calc(-${currentCard * cardWidth}px - ${currentCard * gap}rem + ${currentPadding}px`);
            }, 300));
        }
    };
    /**
     * On call :
     *  - check if the current card is not already the last one
     *  - check the distance of the swipe, if it's higher than half a card's width, add 1 to currentCard state
     *  - check the velocity of the swipe, if it's higher than the limit, add 1 to currentCard state by 0.1 velocity over the limit, otherwise add 1
     * @param distance : number
     * @param elpasedTime : number
     */ const onSwipeLeft = (distance, elapsedTime)=>{
        const velocity = Math.abs(distance / elapsedTime);
        setTransitionDuration($0e854a097f4ee7fa$var$defaultTransitionDuration);
        if (currentCard !== nbCards - 1 && cardWidth) {
            if (Math.abs(distance) > cardWidth / 2) setCurrentCard((card)=>card + 1);
            else {
                const velocityDifference = Math.round((velocity - $0e854a097f4ee7fa$var$velocityBreakpoint) * 10);
                const nextCard = currentCard + (velocityDifference > 0 ? velocityDifference : 1);
                setCurrentCard(nextCard < nbCards ? nextCard : nbCards - 1);
            }
        } else distance === 1000 && elapsedTime === 1000 ? bounce(true) : resetPosition();
    };
    /**
     * On call :
     *  - check if the current card is not already the first one
     *  - check the distance of the swipe, if it's higher than half a card's width, substract 1 from currentCard state
     *  - check the velocity of the swipe, if it's higher than the limit, substract 1 to currentCard state by 0.1 velocity over the limit, otherwise substract 1
     * @param distance : number
     * @param elpasedTime : number
     */ const onSwipeRight = (distance, elapsedTime)=>{
        const velocity = Math.abs(distance / elapsedTime);
        setTransitionDuration($0e854a097f4ee7fa$var$defaultTransitionDuration);
        if (currentCard !== 0 && cardWidth) {
            if (Math.abs(distance) > cardWidth / 2) setCurrentCard((card)=>card - 1);
            else {
                const velocityDifference = Math.round((velocity - $0e854a097f4ee7fa$var$velocityBreakpoint) * 10);
                const nextCard = currentCard - (velocityDifference > 0 ? velocityDifference : 1);
                setCurrentCard(nextCard >= 0 ? nextCard : 0);
            }
        } else distance === 1000 && elapsedTime === 1000 ? bounce() : resetPosition();
    };
    /**
     * On call :
     *  - check if the translation is available (inside allowed bounds)
     *  - if available, set transitionDuration state to '0ms' and then update translation state to the default distance - received distance param
     * @param distance : number
     */ const onSwiping = (distance)=>{
        const available = currentCard === 0 || currentCard === nbCards - 1 ? checkSwipingAvailable(distance, gap) : true;
        if (cardWidth !== undefined) {
            setTransitionDuration("0ms");
            if (available) {
                if (currentCard !== undefined && cardHeight !== undefined && currentPadding !== undefined) setTranslation(`translateX(calc(-${currentCard * cardWidth}px - ${currentCard * gap}rem + ${currentPadding}px - ${distance}px))`);
            } else {
                const bounceLimit = cardWidth / 3;
                if (Math.abs(distance) <= bounceLimit / 2) setTranslation(`translateX(calc(-${currentCard * cardWidth}px - ${currentCard * gap}rem + ${currentPadding}px - ${distance * (1 - Math.abs(distance) / bounceLimit)}px))`);
            }
        }
    };
    /**
     * On call :
     *  - calculate the max length allowed
     *  - calculate the future length depending on the distance
     *  - check if the future length is inside the available bounds and return a boolean
     * @param distance : number
     * @param gap : number
     * @returns boolean
     */ const checkSwipingAvailable = (distance, gap)=>{
        if (currentCard !== undefined && cardWidth && currentPadding) {
            const maxLength = (nbCards - 1) * cardWidth + (nbCards - 1) * gap + currentPadding;
            const currentLength = currentCard * cardWidth + currentCard * gap * parseFloat(getComputedStyle(document.documentElement).fontSize) + currentPadding + distance;
            return !(currentLength < currentPadding || currentLength > maxLength);
        }
        return false;
    };
    /**
     * On call :
     *  - call onSwipeLeft method
     * @param distance : number
     */ const onSwipeTop = (distance, elapsedTime)=>{
        onSwipeLeft(distance, elapsedTime);
    };
    /**
     * On call :
     *  - call onSwipeRight method
     * @param distance : number
     */ const onSwipeBottom = (distance, elapsedTime)=>{
        onSwipeRight(distance, elapsedTime);
    };
    /**
     * On click event fire :
     *  - set transitionDuration state to default value
     *  - update currentCard state with the key parameter
     * @param key : number
     */ const handleClick = (key)=>{
        setTransitionDuration($0e854a097f4ee7fa$var$defaultTransitionDuration);
        setCurrentCard(key);
    };
    /**
     * On wheel event fire :
     *  - check which axis has been triggered (x or y) to get its value
     *  - set wheeling state to a positive or negative unique value (here Date.now() is used as unique)
     * @param delta : number
     */ const handleWheel = (delta)=>{
        if (delta !== undefined) setWheeling(delta > 0 ? Date.now() : -Date.now());
    };
    return /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsxs)("div", {
        ref: divRef,
        className: "rf-w-full rf-flex rf-flex-col",
        style: {
            pointerEvents: "all"
        },
        children: [
            /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $ea490a709941d5e3$export$2e2bcd8739ae039), {
                className: "rf-w-full",
                handleWheel: handleWheel,
                xAxisOnly: true,
                children: /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $c77e7081a1b54b8c$export$2e2bcd8739ae039), {
                    direction: direction || "horizontal",
                    onSwiping: onSwiping,
                    onSwipeLeft: onSwipeLeft,
                    onSwipeRight: onSwipeRight,
                    onSwipeTop: onSwipeTop,
                    onSwipeBottom: onSwipeBottom,
                    className: direction === "vertical" ? "rf-flex rf-justify-center" : mode === (0, $16ad089b9ce6627d$export$9484bbecc3c49a2e).vocal && !isMobile ? history ? "rf-opacity-gradient-l-thin" : "rf-opacity-gradient-l" : "",
                    children: /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("div", {
                        ref: ref,
                        className: `rf-relative ${direction === "vertical" ? "rf-h-max" : "rf-w-max"} rf-transition-transform`,
                        style: {
                            display: "grid",
                            gridTemplateColumns: direction === "vertical" ? `${cardWidth}px` : gridTemplateColumn,
                            gridTemplateRows: gridTemplateRow,
                            gap: isMobile ? "0.3rem" : "1rem",
                            transitionTimingFunction: "linear",
                            transitionDuration: transitionDuration,
                            transform: translation
                        },
                        children: children
                    })
                })
            }),
            /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("div", {
                className: "rf-w-full rf-py-3 rf-flex rf-flex-row rf-justify-center rf-gap-1",
                children: (0, (/*@__PURE__*/$parcel$interopDefault($eO7Kz))).Children.map(children, (_child, key)=>{
                    return /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("button", {
                        className: `rf-w-3 rf-h-3 rf-border rf-border-trueblack rf-rounded-half ${key === currentCard ? "rf-bg-primary" : "rf-bg-truewhite"}`,
                        onClick: ()=>handleClick(key)
                    }, key);
                })
            })
        ]
    });
});
var $0e854a097f4ee7fa$export$2e2bcd8739ae039 = $0e854a097f4ee7fa$var$Carousel;


const $a115f00bb53e5be0$var$classNameText = "rf-max-h-full";
const $a115f00bb53e5be0$var$classNameVocal = "rf-w-11/12 large:rf-w-3/5 large-vertical:rf-w-4/9 rf-min-w-11/12 large:rf-min-w-3/5 large-vertical:rf-min-w-4/9 rf-max-h-full";
const $a115f00bb53e5be0$var$Attachments = ({ activity: activity, history: history })=>{
    const renderAttachment = (0, $gySRD.useRenderAttachment)();
    const { mode: mode } = (0, $e599569c1fc3ca2c$export$d8760bee47331b1d)();
    const attachments = (0, $eO7Kz.useMemo)(()=>{
        return activity?.attachments || [];
    }, [
        activity
    ]);
    const className = (0, $eO7Kz.useMemo)(()=>{
        return mode === (0, $16ad089b9ce6627d$export$9484bbecc3c49a2e).text ? $a115f00bb53e5be0$var$classNameText : $a115f00bb53e5be0$var$classNameVocal;
    }, [
        mode
    ]);
    const [height, setHeight] = (0, $eO7Kz.useState)(0);
    const carouselRef = (0, $eO7Kz.useRef)(null);
    const timerRef = (0, $eO7Kz.useRef)(null);
    /**
   * On activity props change :
   *  - reset height by setting height state to 0
   *  - after a short timeout, get the max height from the rendered carousel, and put it into height state
   */ (0, $eO7Kz.useEffect)(()=>{
        setHeight(0);
        timerRef && (timerRef.current = setTimeout(()=>{
            if (carouselRef.current) setHeight(carouselRef.current.clientHeight);
        }, 300));
        return ()=>timerRef && clearTimeout(timerRef.current);
    }, [
        activity
    ]);
    return /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eO7Kz))).Fragment, {
        children: attachments?.length > 1 ? height !== 0 ? // Displayed carousel with cards having all the same min-height
        /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $0e854a097f4ee7fa$export$2e2bcd8739ae039), {
            history: history,
            children: attachments.map((attachment, key)=>{
                return /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $dd8ded24a1e95991$export$2e2bcd8739ae039), {
                    className: "rf-w-full",
                    children: renderAttachment({
                        activity: activity,
                        attachment: attachment,
                        history: history,
                        height: height
                    })
                }, key);
            })
        }) : // Test carousel used to retrieve the highest height from all cards to be used to display the 'right' carousel
        /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $0e854a097f4ee7fa$export$2e2bcd8739ae039), {
            ref: carouselRef,
            history: history,
            children: attachments.map((attachment, key)=>{
                return /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $dd8ded24a1e95991$export$2e2bcd8739ae039), {
                    className: "rf-w-full",
                    children: renderAttachment({
                        activity: activity,
                        attachment: attachment
                    })
                }, (key + 1) * 100);
            })
        }) : /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $dd8ded24a1e95991$export$2e2bcd8739ae039), {
            className: history ? "rf-w-full" : className,
            children: renderAttachment({
                activity: activity,
                attachment: attachments[0],
                history: history
            })
        })
    });
};
var $a115f00bb53e5be0$export$2e2bcd8739ae039 = $a115f00bb53e5be0$var$Attachments;


const { useSendBoxSpeechInterimsVisible: $42c0795976cacc7b$var$useSendBoxSpeechInterimsVisible } = (0, $497baa802110a7bc$exports.hooks);
const $42c0795976cacc7b$var$BotResponse = ()=>{
    const { showHomeAttachments: showHomeAttachments } = (0, $8b59a4dbb18c269b$export$3abe3478af3cb63b)();
    const { speaking: speaking } = (0, $633c6ef6f1f791c0$export$57e792e009c800a0)();
    const activity = (0, $e1bf7fd78241e7c2$export$2e2bcd8739ae039)();
    const { displaySubtitles: displaySubtitles } = (0, $e599569c1fc3ca2c$export$d8760bee47331b1d)();
    const listClosed = (0, $134592d23f105dbc$export$77e4cc5334565f28)((state)=>state.listClosed);
    const [interimsVisible] = $42c0795976cacc7b$var$useSendBoxSpeechInterimsVisible();
    const [list, setList] = (0, $eO7Kz.useState)();
    const [rowSpanVertical, setRowSpanVertical] = (0, $eO7Kz.useState)("rf-row-span-6 small-mobile:rf-row-span-7");
    (0, $eO7Kz.useEffect)(()=>{
        setRowSpanVertical(displaySubtitles && speaking ? "rf-row-span-5 small-mobile:rf-row-span-6" : "rf-row-span-6 small-mobile:rf-row-span-7");
    }, [
        displaySubtitles,
        speaking
    ]);
    (0, $eO7Kz.useEffect)(()=>{
        if (activity) {
            if (activity.attachmentLayout?.toLowerCase() === "davilist" || activity.attachmentLayout !== "carousel" && activity.attachments && activity.attachments.length > 1) setList(true);
            else setList(false);
        }
    }, [
        activity
    ]);
    return showHomeAttachments && showHomeAttachments.attachments?.length > 0 ? /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("div", {
        id: "retorik-botResponse",
        className: `rf-relative rf-w-full rf-h-full
        rf-col-start-1 large-vertical:rf-col-start-1 large:rf-col-start-5 rf-col-span-full
        rf-row-start-6 small-mobile:rf-row-start-5 large:rf-row-start-5 large-vertical:rf-row-start-7 ${rowSpanVertical} large:rf-row-span-full large-vertical:rf-row-span-4
        rf-overflow-y-scroll rf-scrollbar-thin
      `,
        children: /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("div", {
            className: "rf-w-full rf-h-full rf-flex rf-justify-center",
            children: /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $a115f00bb53e5be0$export$2e2bcd8739ae039), {
                activity: showHomeAttachments
            })
        })
    }) : activity?.type === "message" ? list ? !interimsVisible && !listClosed ? /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $b1d30aac07bca848$export$2e2bcd8739ae039), {
        activity: activity,
        onClose: ()=>(0, $134592d23f105dbc$export$f03cfde7db70aa27)(true)
    }) : /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eO7Kz))).Fragment, {}) : /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("div", {
        id: "retorik-botResponse",
        className: `rf-relative rf-w-full rf-h-full
            rf-col-start-1 large-vertical:rf-col-start-1 large:rf-col-start-5 rf-col-span-full
            rf-row-start-6 small-mobile:rf-row-start-5 large:rf-row-start-5 large-vertical:rf-row-start-7 ${rowSpanVertical} large:rf-row-span-full large-vertical:rf-row-span-4
            rf-overflow-y-scroll rf-scrollbar-thin
          `,
        children: /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("div", {
            className: "rf-w-full rf-h-full rf-flex rf-justify-center",
            children: !!activity?.attachments?.length && /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $a115f00bb53e5be0$export$2e2bcd8739ae039), {
                activity: activity
            })
        })
    }) : /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eO7Kz))).Fragment, {});
};
var $42c0795976cacc7b$export$2e2bcd8739ae039 = $42c0795976cacc7b$var$BotResponse;



var $eO7Kz = parcelRequire("eO7Kz");

const { useActivities: $d28e9cb6a5674991$var$useActivities } = (0, $497baa802110a7bc$exports.hooks);
function $d28e9cb6a5674991$export$2e2bcd8739ae039() {
    const [activities] = $d28e9cb6a5674991$var$useActivities();
    const lastBotActivity = activities.slice().reverse().find(({ from: { role: role }, type: type })=>role === "bot" && type === "message");
    return [
        lastBotActivity
    ];
}


function $6ab2a7bfc556faf0$export$2e2bcd8739ae039() {
    const [lastBotActivity] = (0, $d28e9cb6a5674991$export$2e2bcd8739ae039)();
    const [animationQueue, setAnimationQueue] = (0, $eO7Kz.useState)();
    const handleEvent = (e)=>{
        e.detail && setAnimationQueue(e.detail.queue);
    };
    (0, $eO7Kz.useEffect)(()=>{
        document.addEventListener("sendPlayAnimationEvent", handleEvent);
    }, []);
    (0, $eO7Kz.useEffect)(()=>{
        if (lastBotActivity?.meta?.queue && lastBotActivity.meta.queue.length > 0) setAnimationQueue(lastBotActivity.meta.queue);
    }, [
        lastBotActivity
    ]);
    return animationQueue;
}



parcelRequire("eO7Kz");

const $b149f92e325fd606$var$RetorikLogo = ()=>{
    return /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("a", {
        href: "https://davi.ai/retorik",
        title: "Retorik by Davi",
        target: "_blank",
        rel: "noreferrer",
        className: "rf-hidden large:rf-block rf-relative rf-col-start-1 rf-col-span-full rf-row-start-12 rf-row-span-1 rf-self-end rf-justify-self-start",
        children: /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $31dbbe0462359456$export$2e2bcd8739ae039), {
            className: "rf-ml-4 rf-mb-4 rf-h-14"
        })
    });
};
var $b149f92e325fd606$export$2e2bcd8739ae039 = $b149f92e325fd606$var$RetorikLogo;




var $eO7Kz = parcelRequire("eO7Kz");

/* eslint-disable react/jsx-boolean-value */ 

var $eO7Kz = parcelRequire("eO7Kz");



const { useActivities: $8dd410d840a0b388$var$useActivities } = (0, $497baa802110a7bc$exports.hooks);
function $8dd410d840a0b388$export$2e2bcd8739ae039() {
    const [allActivities] = $8dd410d840a0b388$var$useActivities();
    // processedId contains the ids of the activities already processed (because useActivities gives duplicate activities with different state depending on if it's been spoken or not )
    const processedId = [];
    const history = [];
    const activities = allActivities.slice().filter(({ type: type })=>type === "message");
    activities.forEach((activity)=>{
        if (activity.id && !processedId.includes(activity.id)) {
            processedId.push(activity.id);
            // Check if this is a question or an answer (questions from the user don't have a replyToId field)
            if (activity.replyToId) {
                const question = history.find((historyItem)=>historyItem.question.id === activity.replyToId);
                if (question) question.answers.push(activity);
                else {
                    // Get answer's timestamp or create a new one if none present
                    const timestamp = activity.localTimestamp || activity.timestamp || Date.now().toString();
                    const newQuestion = {
                        id: activity.id,
                        type: "message",
                        text: "",
                        channelData: {
                            "webchat:sequence-id": 1
                        },
                        timestamp: timestamp,
                        localTimestamp: timestamp,
                        from: {
                            id: "bot",
                            role: "bot"
                        }
                    };
                    history.push({
                        question: newQuestion,
                        answers: [
                            activity
                        ]
                    });
                }
            } else history.push({
                question: activity,
                answers: []
            });
        }
    });
    return history;
}


var $a886d2cc5dc130a6$exports = {};
$a886d2cc5dc130a6$exports = JSON.parse('{"fr-FR":{"title":"historique de conversation"},"en-US":{"title":"chat history"},"es-ES":{"title":"chat history"},"de-DE":{"title":"chat history"}}');



/* eslint-disable react/jsx-boolean-value */ 

var $eO7Kz = parcelRequire("eO7Kz");
/* eslint-disable react/jsx-boolean-value */ 

var $eO7Kz = parcelRequire("eO7Kz");




const $967f111e7935f7e8$var$HistoryQA = ({ activity: activity, isQuestion: isQuestion })=>{
    const { locale: locale } = (0, $2e4dc8fa28d39601$export$6650dace022cfacc)();
    const { isMobile: isMobile } = (0, $8b59a4dbb18c269b$export$3abe3478af3cb63b)();
    const time = activity.localTimestamp ? new Date(activity.localTimestamp) : activity.timestamp ? new Date(activity.timestamp) : new Date();
    return activity.text || !!activity.attachments?.length ? /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsxs)("div", {
        className: `${isMobile ? "rf-w-full" : "rf-max-w-full"} rf-flex rf-flex-col rf-gap-1`,
        children: [
            /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("div", {
                className: "rf-text-[#9A9A9A]",
                children: time.toLocaleString(locale, {
                    hour: "numeric",
                    minute: "numeric"
                })
            }),
            /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsxs)("div", {
                className: `${isQuestion ? "rf-text-textModePanelConversationUser" : "rf-text-textModePanelConversationBot"}`,
                children: [
                    activity.htmlText ? /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("div", {
                        dangerouslySetInnerHTML: {
                            __html: activity.htmlText
                        }
                    }) : activity.text ? (0, $8e06b2d561dfd8ee$export$d6c6ec86eedacfd9)(activity.text) : "",
                    !!activity.attachments?.length && !(activity.attachmentLayout && activity.attachmentLayout.toLowerCase() === "davilist") && /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("div", {
                        className: `rf-w-full rf-min-h-16 rf-overflow-x-hidden rf-overflow-y-auto ${activity.text && "rf-pt-4"}`,
                        children: /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $a115f00bb53e5be0$export$2e2bcd8739ae039), {
                            activity: activity,
                            history: true
                        })
                    })
                ]
            })
        ]
    }) : /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eO7Kz))).Fragment, {});
};
var $967f111e7935f7e8$export$2e2bcd8739ae039 = $967f111e7935f7e8$var$HistoryQA;


const $0204c1afb4250490$var$HistoryItem = ({ activity: activity })=>{
    return /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsxs)("div", {
        className: "rf-mb-4 rf-flex rf-flex-col rf-justify-start rf-items-start rf-gap-4 rf-text-size-auto",
        children: [
            activity?.question && activity.question.type === "message" && /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $967f111e7935f7e8$export$2e2bcd8739ae039), {
                activity: activity.question,
                isQuestion: true
            }),
            activity.answers.map((answer, j)=>{
                return answer.type === "message" ? /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $967f111e7935f7e8$export$2e2bcd8739ae039), {
                    activity: answer,
                    isQuestion: false
                }, j) : /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eO7Kz))).Fragment, {});
            })
        ]
    });
};
var $0204c1afb4250490$export$2e2bcd8739ae039 = $0204c1afb4250490$var$HistoryItem;




const $d63a7ea7bbd74325$var$HistoryList = ()=>{
    const { setCurrentSubView: setCurrentSubView } = (0, $e599569c1fc3ca2c$export$d8760bee47331b1d)();
    const { currentDeviceType: currentDeviceType } = (0, $8b59a4dbb18c269b$export$3abe3478af3cb63b)();
    const { locale: locale } = (0, $2e4dc8fa28d39601$export$6650dace022cfacc)();
    const activities = (0, $8dd410d840a0b388$export$2e2bcd8739ae039)();
    const scrollRef = (0, $eO7Kz.useRef)(null);
    /**
   * On call :
   *  - scroll to the scrollRef HTML element at the bottom of the view
   */ const scrollToRef = ()=>{
        if (scrollRef && scrollRef.current !== null) scrollRef.current.scrollIntoView({
            behavior: "smooth"
        });
    };
    /**
   * On component mount :
   *  - call scrollToRef method
   */ (0, $eO7Kz.useEffect)(()=>{
        setTimeout(()=>{
            scrollToRef();
        }, 200);
    }, []);
    const handleClose = ()=>{
        setCurrentSubView((0, $16ad089b9ce6627d$export$f05d0fed0593ead7).none);
    };
    return /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $d7dd81018f15de78$export$2e2bcd8739ae039), {
        handleClose: handleClose,
        backIsConversation: true,
        title: (0, (/*@__PURE__*/$parcel$interopDefault($a886d2cc5dc130a6$exports)))[locale]?.title || (0, (/*@__PURE__*/$parcel$interopDefault($a886d2cc5dc130a6$exports)))["fr-FR"].title,
        children: /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsxs)("div", {
            className: `rf-pb-4 rf-overflow-y-scroll ${currentDeviceType === (0, $16ad089b9ce6627d$export$ec1e04e4e5ef8233).borne ? "rf-scrollbar-thin" : "rf-scrollbar-hidden"}`,
            children: [
                activities.map((activity, key)=>{
                    return /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $0204c1afb4250490$export$2e2bcd8739ae039), {
                        activity: activity
                    }, key);
                }),
                /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("div", {
                    ref: scrollRef
                })
            ]
        })
    });
};
var $d63a7ea7bbd74325$export$2e2bcd8739ae039 = $d63a7ea7bbd74325$var$HistoryList;




var $eO7Kz = parcelRequire("eO7Kz");


var $b47dc11f1fe06924$exports = {};
$b47dc11f1fe06924$exports = JSON.parse('{"fr-FR":{"change":"changer la langue","select":"s\xe9lectionnez la langue de votre choix","validate":"valider"},"en-US":{"change":"change the language","select":"select the language you want to use","validate":"validate"},"es-ES":{"change":"change the language","select":"select the language you want to use","validate":"validate"},"de-DE":{"change":"change the language","select":"select the language you want to use","validate":"validate"}}');







const $6a67b0d4511779d3$var$LanguageChoice = ()=>{
    const { setCurrentSubView: setCurrentSubView } = (0, $e599569c1fc3ca2c$export$d8760bee47331b1d)();
    const { locale: locale, supported: supported } = (0, $2e4dc8fa28d39601$export$6650dace022cfacc)();
    const [currentLanguage, setCurrentLanguage] = (0, $eO7Kz.useState)(locale);
    const handleClose = ()=>{
        setCurrentSubView((0, $16ad089b9ce6627d$export$f05d0fed0593ead7).none);
    };
    const handleChange = (language)=>{
        setCurrentLanguage(language);
    };
    const handleSelect = (language)=>{
        (0, $2e4dc8fa28d39601$export$c8aadf3621e41efb)(language);
        handleClose();
    };
    return /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsxs)((0, $d7dd81018f15de78$export$2e2bcd8739ae039), {
        handleClose: handleClose,
        children: [
            /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("div", {
                className: "large:rf-mt-[20vh] large-tactile:rf-mt-0 rf-title-bold-size-auto rf-font-bold",
                children: (0, $8fd1ab545cc1ab7a$export$d07f57595c356899)((0, (/*@__PURE__*/$parcel$interopDefault($b47dc11f1fe06924$exports)))[locale]?.change || (0, (/*@__PURE__*/$parcel$interopDefault($b47dc11f1fe06924$exports)))["fr-FR"].change)
            }),
            /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("div", {
                className: "rf-text-lightgray rf-pt-1 rf-pb-2",
                children: (0, $8fd1ab545cc1ab7a$export$d07f57595c356899)((0, (/*@__PURE__*/$parcel$interopDefault($b47dc11f1fe06924$exports)))[locale]?.select || (0, (/*@__PURE__*/$parcel$interopDefault($b47dc11f1fe06924$exports)))["fr-FR"].select)
            }),
            supported.map((language, key)=>{
                return /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("div", {
                    className: `rf-w-full rf-py-4 rf-border-t rf-border-t-menuBorder ${key === 0 && "large:rf-border-t-0"}`,
                    children: /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $0a1ceddd13a58a1c$export$2e2bcd8739ae039), {
                        title: (0, (/*@__PURE__*/$parcel$interopDefault($da0c5262b7538598$exports)))[language],
                        checked: language === currentLanguage,
                        handleChange: ()=>handleChange(language)
                    })
                }, key);
            }),
            /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("div", {
                className: "rf-w-full rf-mt-8 rf-flex rf-justify-center",
                children: /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("button", {
                    className: "rf-px-8 rf-py-3 rf-text-secondary rf-font-bold rf-border-2 rf-border-secondary rf-rounded-lg",
                    onClick: ()=>handleSelect(currentLanguage),
                    children: (0, $8fd1ab545cc1ab7a$export$d07f57595c356899)((0, (/*@__PURE__*/$parcel$interopDefault($b47dc11f1fe06924$exports)))[locale]?.validate || (0, (/*@__PURE__*/$parcel$interopDefault($b47dc11f1fe06924$exports)))["fr-FR"].validate)
                })
            })
        ]
    });
};
var $6a67b0d4511779d3$export$2e2bcd8739ae039 = $6a67b0d4511779d3$var$LanguageChoice;


/* eslint-disable react/jsx-boolean-value */ 

var $eO7Kz = parcelRequire("eO7Kz");

const { useActivities: $8e8554fbe249bb45$var$useActivities } = (0, $497baa802110a7bc$exports.hooks);
const $8e8554fbe249bb45$var$useShowPOI = ()=>{
    const [activities] = $8e8554fbe249bb45$var$useActivities();
    if (activities && activities.length > 0) {
        const lastActivity = activities.slice(-1)[0];
        if (lastActivity.type === "event" && lastActivity.name === "hospitality.ShowPointOfInterest" && lastActivity.value) return lastActivity.value;
    }
    return undefined;
};
var $8e8554fbe249bb45$export$2e2bcd8739ae039 = $8e8554fbe249bb45$var$useShowPOI;





const $00bd6a4dae2c5391$export$730331b97844b22d = (color, transparency)=>{
    let tempColorObject = null;
    try {
        tempColorObject = color.includes("rgb") ? $00bd6a4dae2c5391$var$rgbToObject(color) : $00bd6a4dae2c5391$export$5a544e13ad4e1fa5(color);
    } catch (error) {
        console.log(error);
    }
    if (tempColorObject) return `rgba(${tempColorObject.r}, ${tempColorObject.g}, ${tempColorObject.b}, ${transparency})`;
    return color;
};
const $00bd6a4dae2c5391$export$186ed2fadd5d0f9d = (color)=>{
    let tempColorObject = null;
    try {
        tempColorObject = color.includes("rgb") ? $00bd6a4dae2c5391$var$rgbToObject(color) : $00bd6a4dae2c5391$export$5a544e13ad4e1fa5(color);
    } catch (error) {
        console.log(error);
    }
    if (tempColorObject) return `rgba(${tempColorObject.r / 2}, ${tempColorObject.g / 2}, ${tempColorObject.b / 2})`;
    return color;
};
const $00bd6a4dae2c5391$var$rgbToObject = (rgb)=>{
    // Replace unwanted characters
    rgb = rgb.replace("rgb(", "");
    rgb = rgb.replace(")", "");
    rgb = rgb.replace(" ", "");
    const stringArray = rgb.split(",");
    return {
        r: parseInt(stringArray[0], 16),
        g: parseInt(stringArray[1], 16),
        b: parseInt(stringArray[2], 16)
    };
};
const $00bd6a4dae2c5391$export$5a544e13ad4e1fa5 = (hex)=>{
    // Remove '#' char if present
    if (hex.charAt(0) === "#") hex = hex.slice(1);
    // Transform if shorthand form (e.g. "03F") to full form (e.g. "0033FF")
    if (hex.length === 3) hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
    return {
        r: parseInt(hex.slice(0, 2), 16),
        g: parseInt(hex.slice(2, 4), 16),
        b: parseInt(hex.slice(4), 16)
    };
};





parcelRequire("eO7Kz");





var $eO7Kz = parcelRequire("eO7Kz");



const $a5cb86689a9eed96$var$CommentsPennant = ({ className: className, color: color, customerReviews: customerReviews })=>{
    const locale = (0, $2e4dc8fa28d39601$export$6650dace022cfacc)((state)=>state.locale);
    const [widthInPx, setWidthInPx] = (0, $eO7Kz.useState)(0);
    const pennantRef = (0, $eO7Kz.useRef)(null);
    (0, $eO7Kz.useEffect)(()=>{
        if (pennantRef.current) setWidthInPx(Math.ceil(pennantRef.current.offsetWidth / 2));
    }, [
        pennantRef
    ]);
    return /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsxs)("div", {
        className: `${className} rf-flex rf-flex-col rf-justify-center rf-text-white`,
        ref: pennantRef,
        children: [
            /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsxs)("div", {
                className: "rf-flex rf-flex-col rf-items-center rf-p-2 rf-bg-primary",
                style: {
                    backgroundColor: color
                },
                children: [
                    /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $3b4b4959ec363ff6$export$2e2bcd8739ae039), {
                        className: "rf-w-12 large:rf-w-14 large-vertical:rf-w-16 rf-pb-2"
                    }),
                    /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("div", {
                        className: "rf-flex-col rf-text-center rf-text-size-auto rf-uppercase",
                        children: (0, (/*@__PURE__*/$parcel$interopDefault($8f95d7a47c249d24$exports)))[locale]?.comment ? (0, (/*@__PURE__*/$parcel$interopDefault($8f95d7a47c249d24$exports)))[locale]?.comment.split(" ").map((word, index)=>{
                            return /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("div", {
                                children: word
                            }, index);
                        }) : /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($eO7Kz))).Fragment, {
                            children: [
                                /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("div", {
                                    children: "customer"
                                }),
                                /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("div", {
                                    children: "reviews"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsxs)("div", {
                        className: "rf-font-bold rf-subtitle-size-auto",
                        children: [
                            customerReviews,
                            "/10"
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("div", {
                className: "rf-w-0 rf-h-0 rf-border-t-0 rf-border-x-primary rf-border-b-transparent",
                style: {
                    borderLeftColor: color,
                    borderRightColor: color,
                    borderBottomWidth: widthInPx * 2 / 3,
                    borderLeftWidth: widthInPx,
                    borderRightWidth: widthInPx
                }
            })
        ]
    });
};
var $a5cb86689a9eed96$export$2e2bcd8739ae039 = $a5cb86689a9eed96$var$CommentsPennant;




const $5006fba2be467a7a$var$DetailedTitle = ({ category: category, title: title, infoBanner: infoBanner, color: color, customerReviews: customerReviews, favorite: favorite, handleClose: handleClose })=>{
    const { locale: locale } = (0, $2e4dc8fa28d39601$export$6650dace022cfacc)();
    const { isMobile: isMobile } = (0, $8b59a4dbb18c269b$export$3abe3478af3cb63b)();
    return /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsxs)("div", {
        className: "rf-relative rf-pb-4 rf-flex-col rf-items-start rf-justify-center",
        children: [
            customerReviews && /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $a5cb86689a9eed96$export$2e2bcd8739ae039), {
                className: "rf-absolute rf-hidden large-vertical:rf-block rf-top-0 rf-right-0",
                color: color,
                customerReviews: customerReviews
            }),
            /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsxs)("div", {
                className: "rf-w-full rf-flex rf-flex-row rf-justify-between rf-items-start",
                children: [
                    isMobile && /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $53c3829f3df8be22$export$2e2bcd8739ae039), {
                        title: (0, (/*@__PURE__*/$parcel$interopDefault($abbebf5de79f9da4$exports)))[locale]?.back || (0, (/*@__PURE__*/$parcel$interopDefault($abbebf5de79f9da4$exports)))["fr-FR"].back,
                        handleBack: handleClose,
                        className: "rf-relative rf-mt-4 rf-text-size-auto"
                    }),
                    /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("div", {
                        className: "rf-uppercase rf-w-fit rf-py-2 large:rf-py-3 rf-px-4 rf-bg-black rf-text-primary",
                        style: {
                            color: color
                        },
                        children: category?.label || "category"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsxs)("div", {
                className: "rf-py-6 rf-title-large-bold-size-auto large-vertical:rf-pt-[16.67%] rf-flex rf-flex-row rf-items-center rf-font-bold",
                children: [
                    favorite && /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $8dac97be2cee3a05$export$2e2bcd8739ae039), {
                        className: "rf-h-16 rf-w-20 rf-pr-4"
                    }),
                    title || ""
                ]
            }),
            infoBanner && /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("div", {
                className: "rf-py-1 rf-px-4 rf-subtitle-size-auto rf-bg-primary rf-text-truewhite",
                style: {
                    backgroundColor: color
                },
                children: infoBanner
            })
        ]
    });
};
var $5006fba2be467a7a$export$2e2bcd8739ae039 = $5006fba2be467a7a$var$DetailedTitle;




var $eO7Kz = parcelRequire("eO7Kz");



parcelRequire("eO7Kz");



const $02a6addb65ee69eb$var$DownloadSheet = ({ className: className, url: url })=>{
    const locale = (0, $2e4dc8fa28d39601$export$6650dace022cfacc)((state)=>state.locale);
    return /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("div", {
        className: `${className} rf-w-full rf-flex`,
        children: /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsxs)("a", {
            href: url,
            className: "rf-px-5 rf-py-3 rf-h-fit rf-flex rf-flex-row rf-items-center rf-mt-8 rf-mb-16 large:rf-my-8 rf-border-2 rf-border-black rf-rounded-lg hover:rf-bg-truewhite rf-cursor-pointer rf-font-bold",
            children: [
                /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $bed7757a8efcb599$export$2e2bcd8739ae039), {
                    className: "rf-h-6 rf-w-6 rf-mr-1"
                }),
                (0, (/*@__PURE__*/$parcel$interopDefault($8f95d7a47c249d24$exports)))[locale]?.download || (0, (/*@__PURE__*/$parcel$interopDefault($8f95d7a47c249d24$exports)))["fr-FR"].download
            ]
        })
    });
};
var $02a6addb65ee69eb$export$2e2bcd8739ae039 = $02a6addb65ee69eb$var$DownloadSheet;




var $eO7Kz = parcelRequire("eO7Kz");



const $23a0015420938728$var$DownloadQR = ({ url: url })=>{
    const locale = (0, $2e4dc8fa28d39601$export$6650dace022cfacc)((state)=>state.locale);
    const [qrCodeData, setQrCodeData] = (0, $eO7Kz.useState)(undefined);
    (0, $eO7Kz.useEffect)(()=>{
        setQrCodeDataAsync();
    }, []);
    const setQrCodeDataAsync = async ()=>{
        const qrCodeString = await (0, (/*@__PURE__*/$parcel$interopDefault($d452087480f7647a$exports))).toDataURL(url);
        setQrCodeData(qrCodeString);
    };
    return /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsxs)("div", {
        className: "rf-w-full rf-flex rf-flex-col rf-items-start large-vertical:rf-items-center",
        children: [
            `${(0, (/*@__PURE__*/$parcel$interopDefault($8f95d7a47c249d24$exports)))[locale]?.download || (0, (/*@__PURE__*/$parcel$interopDefault($8f95d7a47c249d24$exports)))["fr-FR"].download} ${(0, (/*@__PURE__*/$parcel$interopDefault($8f95d7a47c249d24$exports)))[locale]?.scanQR || (0, (/*@__PURE__*/$parcel$interopDefault($8f95d7a47c249d24$exports)))["fr-FR"].scanQR}`,
            qrCodeData && /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("div", {
                className: "rf-mt-4",
                children: /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("img", {
                    src: qrCodeData,
                    alt: "QR Code"
                })
            })
        ]
    });
};
var $23a0015420938728$export$2e2bcd8739ae039 = $23a0015420938728$var$DownloadQR;



const $84dec8e96990628c$var$DetailedText = ({ text: text, otherInformations: otherInformations, color: color, url: url })=>{
    const { configuration: configuration } = (0, $e599569c1fc3ca2c$export$d8760bee47331b1d)();
    const { currentDeviceType: currentDeviceType } = (0, $8b59a4dbb18c269b$export$3abe3478af3cb63b)();
    const textRef = (0, $eO7Kz.useRef)(null);
    const [opacityStyle, setOpacityStyle] = (0, $eO7Kz.useState)("");
    const processedText = (0, $eO7Kz.useMemo)(()=>{
        if (text) return text.replaceAll("\n", "<br>");
        return "";
    }, [
        text
    ]);
    /**
   * On textRef change :
   *  - check if textRef.current is defined
   *  - if scrollHeight > clientHeight, call handleScroll
   *  - if scrollHeight <= clientHeight, set opacityStyle state to undefined
   */ (0, $eO7Kz.useEffect)(()=>{
        if (textRef.current) {
            if (textRef.current.scrollHeight > textRef.current.clientHeight) handleScroll();
            else setOpacityStyle(undefined);
        }
    }, [
        textRef
    ]);
    /**
   * On call :
   *  - check if textRef.current is defined
   *  - set opacityStyle state depending on scroll height and current scrolling
   */ const handleScroll = ()=>{
        if (textRef.current) {
            const maxScroll = textRef.current.scrollHeight - textRef.current.clientHeight;
            const percentage = Math.ceil(textRef.current.scrollTop / maxScroll * 50);
            setOpacityStyle(`linear-gradient(to bottom, black ${50 + percentage}%, transparent 100%)`);
        }
    };
    return /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsxs)("div", {
        className: "rf-flex rf-flex-col large:rf-pr-4 large:rf-min-w-1/2 rf-items-start",
        children: [
            processedText && /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("div", {
                ref: textRef,
                className: "rf-max-h-[40vh] rf-font-medium rf-overflow-y-scroll rf-mb-4 rf-scroll-pb-8 rf-scrollbar-hidden",
                style: {
                    WebkitMaskImage: opacityStyle
                },
                onScroll: handleScroll,
                dangerouslySetInnerHTML: {
                    __html: processedText
                }
            }),
            otherInformations && otherInformations.length > 0 && /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("div", {
                className: "rf-my-4 rf-flex rf-flex-col rf-justify-start rf-text-lightgray",
                children: otherInformations.map((information, key)=>{
                    return /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($eO7Kz))).Fragment, {
                        children: [
                            /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("div", {
                                className: "rf-mt-4",
                                style: {
                                    color: color || "rgb(25, 153, 177)"
                                },
                                children: information.title
                            }),
                            /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("div", {
                                children: Array.isArray(information.content) ? information.content.join(" | ") : information.content
                            })
                        ]
                    }, key);
                })
            }),
            currentDeviceType === (0, $16ad089b9ce6627d$export$ec1e04e4e5ef8233).landscape && url && (configuration.isUsedOnBorne ? /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $23a0015420938728$export$2e2bcd8739ae039), {
                url: url
            }) : /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $02a6addb65ee69eb$export$2e2bcd8739ae039), {
                url: url
            }))
        ]
    });
};
var $84dec8e96990628c$export$2e2bcd8739ae039 = $84dec8e96990628c$var$DetailedText;


/* eslint-disable react/jsx-boolean-value */ 

var $eO7Kz = parcelRequire("eO7Kz");





const $a495e45504638d20$var$DetailedMedia = ({ media: media, review: review, color: color })=>{
    const { currentWidth: currentWidth, isMobile: isMobile, currentDeviceType: currentDeviceType } = (0, $8b59a4dbb18c269b$export$3abe3478af3cb63b)();
    const [landscapeImage, setLandscapeImage] = (0, $eO7Kz.useState)(false);
    const [carouselMedia, setCarouselMedia] = (0, $eO7Kz.useState)([]);
    const maxHeight = (0, $eO7Kz.useMemo)(()=>{
        const remToPx = parseFloat(getComputedStyle(document.documentElement).fontSize);
        return isMobile ? (currentWidth - 2 * remToPx) * 0.625 : currentDeviceType === (0, $16ad089b9ce6627d$export$ec1e04e4e5ef8233).borne ? (currentWidth / 2 - 3 * remToPx) * 0.625 : "33vh";
    }, [
        currentDeviceType
    ]);
    (0, $eO7Kz.useEffect)(()=>{
        if (media && media.length > 0) {
            let tempMedia = [];
            media.forEach((med)=>{
                med.url && (tempMedia = [
                    ...tempMedia,
                    {
                        url: med.url,
                        alt: med.title || "media"
                    }
                ]);
            });
            setCarouselMedia(tempMedia);
        }
    }, [
        media
    ]);
    /**
   * On review change :
   *  - check if the review contains a picture url
   *  - if so, create an Image with this url, and check if its width is larger than its height
   *  - set landscapeImage state with the result
   */ (0, $eO7Kz.useEffect)(()=>{
        if (review?.picture?.url) {
            const getImageData = async ()=>{
                const image = new Image();
                image.onload = ()=>{
                    setLandscapeImage(image.width > image.height);
                };
                image.src = review?.picture?.url || "";
            };
            getImageData();
        }
    }, [
        review
    ]);
    return /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsxs)("div", {
        className: "large:rf-min-w-1/2 large:rf-pl-4 rf-flex rf-flex-col rf-items-center",
        children: [
            carouselMedia && carouselMedia.length > 0 && /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("div", {
                className: "rf-relative rf-flex rf-justify-center rf-mb-4 rf-overflow-x-hidden",
                children: /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $fff38b5425abcfb1$export$2e2bcd8739ae039), {
                    medias: carouselMedia,
                    controls: true,
                    timer: 3000,
                    color: color,
                    maxHeight: maxHeight
                })
            }),
            review && review.comment && /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsxs)("div", {
                className: "rf-w-full rf-p-4 large:rf-mb-4 rf-flex rf-flex-col rf-gap-4 rf-bg-truewhite rf-rounded-lg rf-shadow-[0_3px_6px_#00000029]",
                children: [
                    /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("div", {
                        className: "rf-text-lightgray",
                        children: review.comment
                    }),
                    (review.picture || review.author) && /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsxs)("div", {
                        className: "rf-flex rf-flex-row rf-items-center",
                        children: [
                            review.picture && /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("div", {
                                className: "rf-h-12 rf-w-12 rf-min-w-12 large:rf-h-16 large:rf-w-16 large:rf-min-w-16 large-vertical:rf-h-24 large-vertical:rf-w-24 large-vertical:rf-min-w-24 rf-mr-4 rf-flex rf-items-center rf-rounded-half rf-overflow-hidden",
                                children: /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("img", {
                                    src: review.picture.url || (0, $9062ab1ccebf2f9e$export$e56d88b19b5c9fbf).noimage,
                                    alt: review.picture.description || "auteur",
                                    className: landscapeImage ? "rf-h-full rf-max-w-none" : "rf-w-full"
                                })
                            }),
                            review.author && /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsxs)("div", {
                                className: "rf-flex rf-flex-col rf-items-start",
                                children: [
                                    /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("p", {
                                        className: "rf-font-bold",
                                        children: (0, $8fd1ab545cc1ab7a$export$d07f57595c356899)(review.author.name || "")
                                    }),
                                    /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("p", {
                                        className: "rf-italic",
                                        children: (0, $8fd1ab545cc1ab7a$export$d07f57595c356899)(review.author.capacity || "")
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $a495e45504638d20$export$2e2bcd8739ae039 = $a495e45504638d20$var$DetailedMedia;


/* eslint-disable react/jsx-boolean-value */ 

var $eO7Kz = parcelRequire("eO7Kz");




var $eO7Kz = parcelRequire("eO7Kz");

const $4836ad818fa804ff$var$ShowPhoneNumber = ({ phoneNumber: phoneNumber })=>{
    const [show, setShow] = (0, $eO7Kz.useState)(false);
    return /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsxs)("button", {
        onClick: ()=>setShow(!show),
        className: "rf-px-5 rf-py-3 rf-mb-8 rf-flex rf-flex-row rf-items-center rf-border-2 rf-border-black rf-rounded-lg hover:rf-bg-truewhite rf-font-bold",
        children: [
            /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $262d364151278ab0$export$2e2bcd8739ae039), {
                className: "rf-h-6 rf-w-6 rf-mr-2"
            }),
            show ? phoneNumber : "Afficher le num\xe9ro"
        ]
    });
};
var $4836ad818fa804ff$export$2e2bcd8739ae039 = $4836ad818fa804ff$var$ShowPhoneNumber;





var $eO7Kz = parcelRequire("eO7Kz");


var $eO7Kz = parcelRequire("eO7Kz");
function $207a01508dad26aa$export$a080ff44e8067a44(instance, context, container) {
    return Object.freeze({
        instance: instance,
        context: context,
        container: container
    });
}
function $207a01508dad26aa$export$2e66ec8a7fb1892f(createElement, updateElement) {
    if (updateElement == null) return function useImmutableLeafletElement(props, context) {
        const elementRef = (0, $eO7Kz.useRef)();
        if (!elementRef.current) elementRef.current = createElement(props, context);
        return elementRef;
    };
    return function useMutableLeafletElement(props, context) {
        const elementRef = (0, $eO7Kz.useRef)();
        if (!elementRef.current) elementRef.current = createElement(props, context);
        const propsRef = (0, $eO7Kz.useRef)(props);
        const { instance: instance } = elementRef.current;
        (0, $eO7Kz.useEffect)(function updateElementProps() {
            if (propsRef.current !== props) {
                updateElement(instance, props, propsRef.current);
                propsRef.current = props;
            }
        }, [
            instance,
            props,
            context
        ]);
        return elementRef;
    };
}


var $eO7Kz = parcelRequire("eO7Kz");

var $kz03S = parcelRequire("kz03S");

var $eO7Kz = parcelRequire("eO7Kz");
const $bc5a8ed0a8cbb7cf$export$b8efcc4bff45e15b = 1;
function $bc5a8ed0a8cbb7cf$export$fb237fa819e17281(map) {
    return Object.freeze({
        __version: $bc5a8ed0a8cbb7cf$export$b8efcc4bff45e15b,
        map: map
    });
}
function $bc5a8ed0a8cbb7cf$export$9efaf186a2224858(source, extra) {
    return Object.freeze({
        ...source,
        ...extra
    });
}
const $bc5a8ed0a8cbb7cf$export$7de1b54b0142048f = (0, $eO7Kz.createContext)(null);
const $bc5a8ed0a8cbb7cf$export$a24c9fc2f87814b2 = $bc5a8ed0a8cbb7cf$export$7de1b54b0142048f.Provider;
function $bc5a8ed0a8cbb7cf$export$ea59151b8430a4e9() {
    const context = (0, $eO7Kz.useContext)($bc5a8ed0a8cbb7cf$export$7de1b54b0142048f);
    if (context == null) throw new Error("No context provided: useLeafletContext() can only be used in a descendant of <MapContainer>");
    return context;
}


function $1131c72c064c6dc6$export$96eac748c3f41e82(useElement) {
    function ContainerComponent(props, forwardedRef) {
        const { instance: instance, context: context } = useElement(props).current;
        (0, $eO7Kz.useImperativeHandle)(forwardedRef, ()=>instance);
        return props.children == null ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eO7Kz))).createElement((0, $bc5a8ed0a8cbb7cf$export$a24c9fc2f87814b2), {
            value: context
        }, props.children);
    }
    return /*#__PURE__*/ (0, $eO7Kz.forwardRef)(ContainerComponent);
}
function $1131c72c064c6dc6$export$bc37ddc24ed05446(useElement) {
    function OverlayComponent(props, forwardedRef) {
        const [isOpen, setOpen] = (0, $eO7Kz.useState)(false);
        const { instance: instance } = useElement(props, setOpen).current;
        (0, $eO7Kz.useImperativeHandle)(forwardedRef, ()=>instance);
        (0, $eO7Kz.useEffect)(function updateOverlay() {
            if (isOpen) instance.update();
        }, [
            instance,
            isOpen,
            props.children
        ]);
        // @ts-ignore _contentNode missing in type definition
        const contentNode = instance._contentNode;
        return contentNode ? /*#__PURE__*/ (0, $kz03S.createPortal)(props.children, contentNode) : null;
    }
    return /*#__PURE__*/ (0, $eO7Kz.forwardRef)(OverlayComponent);
}
function $1131c72c064c6dc6$export$18af5c7a9e9b3664(useElement) {
    function LeafComponent(props, forwardedRef) {
        const { instance: instance } = useElement(props).current;
        (0, $eO7Kz.useImperativeHandle)(forwardedRef, ()=>instance);
        return null;
    }
    return /*#__PURE__*/ (0, $eO7Kz.forwardRef)(LeafComponent);
}



var $eO7Kz = parcelRequire("eO7Kz");

function $8904bb794d842818$export$28d24ab3914549cd(useElement) {
    return function useLeafletControl(props) {
        const context = (0, $bc5a8ed0a8cbb7cf$export$ea59151b8430a4e9)();
        const elementRef = useElement(props, context);
        const { instance: instance } = elementRef.current;
        const positionRef = (0, $eO7Kz.useRef)(props.position);
        const { position: position } = props;
        (0, $eO7Kz.useEffect)(function addControl() {
            instance.addTo(context.map);
            return function removeControl() {
                instance.remove();
            };
        }, [
            context.map,
            instance
        ]);
        (0, $eO7Kz.useEffect)(function updateControl() {
            if (position != null && position !== positionRef.current) {
                instance.setPosition(position);
                positionRef.current = position;
            }
        }, [
            instance,
            position
        ]);
        return elementRef;
    };
}




var $eO7Kz = parcelRequire("eO7Kz");

var $eO7Kz = parcelRequire("eO7Kz");
function $8b2e2af1c6fdf102$export$46b870813daca3d4(map, attribution) {
    const attributionRef = (0, $eO7Kz.useRef)(attribution);
    (0, $eO7Kz.useEffect)(function updateAttribution() {
        if (attribution !== attributionRef.current && map.attributionControl != null) {
            if (attributionRef.current != null) map.attributionControl.removeAttribution(attributionRef.current);
            if (attribution != null) map.attributionControl.addAttribution(attribution);
        }
        attributionRef.current = attribution;
    }, [
        map,
        attribution
    ]);
}




var $eO7Kz = parcelRequire("eO7Kz");
function $7f356d7371154613$export$8ce912bc34d0dbea(element, eventHandlers) {
    const eventHandlersRef = (0, $eO7Kz.useRef)();
    (0, $eO7Kz.useEffect)(function addEventHandlers() {
        if (eventHandlers != null) element.instance.on(eventHandlers);
        eventHandlersRef.current = eventHandlers;
        return function removeEventHandlers() {
            if (eventHandlersRef.current != null) element.instance.off(eventHandlersRef.current);
            eventHandlersRef.current = null;
        };
    }, [
        element,
        eventHandlers
    ]);
}


function $b3399aabbd38b7ab$export$6ee5d263358f5c0e(props, context) {
    const pane = props.pane ?? context.pane;
    return pane ? {
        ...props,
        pane: pane
    } : props;
}


function $3d6062cc1a2e3f32$export$cd00a227f8cfb2c2(element, context) {
    (0, $eO7Kz.useEffect)(function addLayer() {
        const container = context.layerContainer ?? context.map;
        container.addLayer(element.instance);
        return function removeLayer() {
            context.layerContainer?.removeLayer(element.instance);
            context.map.removeLayer(element.instance);
        };
    }, [
        context,
        element
    ]);
}
function $3d6062cc1a2e3f32$export$73f852c6a5abdefa(useElement) {
    return function useLayer(props) {
        const context = (0, $bc5a8ed0a8cbb7cf$export$ea59151b8430a4e9)();
        const elementRef = useElement((0, $b3399aabbd38b7ab$export$6ee5d263358f5c0e)(props, context), context);
        (0, $8b2e2af1c6fdf102$export$46b870813daca3d4)(context.map, props.attribution);
        (0, $7f356d7371154613$export$8ce912bc34d0dbea)(elementRef.current, props.eventHandlers);
        $3d6062cc1a2e3f32$export$cd00a227f8cfb2c2(elementRef.current, context);
        return elementRef;
    };
}






function $95a46a2409161932$export$d5eca53b0accc0e0(useElement, useLifecycle) {
    return function useDivOverlay(props, setOpen) {
        const context = (0, $bc5a8ed0a8cbb7cf$export$ea59151b8430a4e9)();
        const elementRef = useElement((0, $b3399aabbd38b7ab$export$6ee5d263358f5c0e)(props, context), context);
        (0, $8b2e2af1c6fdf102$export$46b870813daca3d4)(context.map, props.attribution);
        (0, $7f356d7371154613$export$8ce912bc34d0dbea)(elementRef.current, props.eventHandlers);
        useLifecycle(elementRef.current, context, props, setOpen);
        return elementRef;
    };
}



var $eO7Kz = parcelRequire("eO7Kz");




function $e7806665f62b7f9a$export$d0296329a1f118ca(element, props) {
    const optionsRef = (0, $eO7Kz.useRef)();
    (0, $eO7Kz.useEffect)(function updatePathOptions() {
        if (props.pathOptions !== optionsRef.current) {
            const options = props.pathOptions ?? {};
            element.instance.setStyle(options);
            optionsRef.current = options;
        }
    }, [
        element,
        props
    ]);
}
function $e7806665f62b7f9a$export$5fea2fe6048fc3db(useElement) {
    return function usePath(props) {
        const context = (0, $bc5a8ed0a8cbb7cf$export$ea59151b8430a4e9)();
        const elementRef = useElement((0, $b3399aabbd38b7ab$export$6ee5d263358f5c0e)(props, context), context);
        (0, $7f356d7371154613$export$8ce912bc34d0dbea)(elementRef.current, props.eventHandlers);
        (0, $3d6062cc1a2e3f32$export$cd00a227f8cfb2c2)(elementRef.current, context);
        $e7806665f62b7f9a$export$d0296329a1f118ca(elementRef.current, props);
        return elementRef;
    };
}


function $412372e3104ea643$export$896a3ef451e396c4(createInstance) {
    function createElement(props, context) {
        return (0, $207a01508dad26aa$export$a080ff44e8067a44)(createInstance(props), context);
    }
    const useElement = (0, $207a01508dad26aa$export$2e66ec8a7fb1892f)(createElement);
    const useControl = (0, $8904bb794d842818$export$28d24ab3914549cd)(useElement);
    return (0, $1131c72c064c6dc6$export$18af5c7a9e9b3664)(useControl);
}
function $412372e3104ea643$export$8a4d5778bce4c3ac(createElement, updateElement) {
    const useElement = (0, $207a01508dad26aa$export$2e66ec8a7fb1892f)(createElement, updateElement);
    const useLayer = (0, $3d6062cc1a2e3f32$export$73f852c6a5abdefa)(useElement);
    return (0, $1131c72c064c6dc6$export$96eac748c3f41e82)(useLayer);
}
function $412372e3104ea643$export$7d18e209be943d7d(createElement, useLifecycle) {
    const useElement = (0, $207a01508dad26aa$export$2e66ec8a7fb1892f)(createElement);
    const useOverlay = (0, $95a46a2409161932$export$d5eca53b0accc0e0)(useElement, useLifecycle);
    return (0, $1131c72c064c6dc6$export$bc37ddc24ed05446)(useOverlay);
}
function $412372e3104ea643$export$5e776dbe3c7d2790(createElement, updateElement) {
    const useElement = (0, $207a01508dad26aa$export$2e66ec8a7fb1892f)(createElement, updateElement);
    const usePath = (0, $e7806665f62b7f9a$export$5fea2fe6048fc3db)(useElement);
    return (0, $1131c72c064c6dc6$export$96eac748c3f41e82)(usePath);
}
function $412372e3104ea643$export$4f432c6de5c4ddb8(createElement, updateElement) {
    const useElement = (0, $207a01508dad26aa$export$2e66ec8a7fb1892f)(createElement, updateElement);
    const useLayer = (0, $3d6062cc1a2e3f32$export$73f852c6a5abdefa)(useElement);
    return (0, $1131c72c064c6dc6$export$18af5c7a9e9b3664)(useLayer);
}



const $195c90e737d8a92f$export$3a16e672cb3a069e = (0, $412372e3104ea643$export$5e776dbe3c7d2790)(function createGeoJSON({ data: data, ...options }, ctx) {
    const geoJSON = new (0, $3df1761126dc5bba$exports.GeoJSON)(data, options);
    return (0, $207a01508dad26aa$export$a080ff44e8067a44)(geoJSON, (0, $bc5a8ed0a8cbb7cf$export$9efaf186a2224858)(ctx, {
        overlayContainer: geoJSON
    }));
}, function updateGeoJSON(layer, props, prevProps) {
    if (props.style !== prevProps.style) {
        if (props.style == null) layer.resetStyle();
        else layer.setStyle(props.style);
    }
});




var $eO7Kz = parcelRequire("eO7Kz");
function $757dda645ff21de7$var$_extends() {
    $757dda645ff21de7$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $757dda645ff21de7$var$_extends.apply(this, arguments);
}
function $757dda645ff21de7$var$MapContainerComponent({ bounds: bounds, boundsOptions: boundsOptions, center: center, children: children, className: className, id: id, placeholder: placeholder, style: style, whenReady: whenReady, zoom: zoom, ...options }, forwardedRef) {
    const [props] = (0, $eO7Kz.useState)({
        className: className,
        id: id,
        style: style
    });
    const [context, setContext] = (0, $eO7Kz.useState)(null);
    (0, $eO7Kz.useImperativeHandle)(forwardedRef, ()=>context?.map ?? null, [
        context
    ]);
    const mapRef = (0, $eO7Kz.useCallback)((node)=>{
        if (node !== null && context === null) {
            const map = new (0, $3df1761126dc5bba$exports.Map)(node, options);
            if (center != null && zoom != null) map.setView(center, zoom);
            else if (bounds != null) map.fitBounds(bounds, boundsOptions);
            if (whenReady != null) map.whenReady(whenReady);
            setContext((0, $bc5a8ed0a8cbb7cf$export$fb237fa819e17281)(map));
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    (0, $eO7Kz.useEffect)(()=>{
        return ()=>{
            context?.map.remove();
        };
    }, [
        context
    ]);
    const contents = context ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eO7Kz))).createElement((0, $bc5a8ed0a8cbb7cf$export$a24c9fc2f87814b2), {
        value: context
    }, children) : placeholder ?? null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eO7Kz))).createElement("div", $757dda645ff21de7$var$_extends({}, props, {
        ref: mapRef
    }), contents);
}
const $757dda645ff21de7$export$23f3dfd47374502b = /*#__PURE__*/ (0, $eO7Kz.forwardRef)($757dda645ff21de7$var$MapContainerComponent);



const $eddf09e248834647$export$e98856a975cab58e = (0, $412372e3104ea643$export$8a4d5778bce4c3ac)(function createMarker({ position: position, ...options }, ctx) {
    const marker = new (0, $3df1761126dc5bba$exports.Marker)(position, options);
    return (0, $207a01508dad26aa$export$a080ff44e8067a44)(marker, (0, $bc5a8ed0a8cbb7cf$export$9efaf186a2224858)(ctx, {
        overlayContainer: marker
    }));
}, function updateMarker(marker, props, prevProps) {
    if (props.position !== prevProps.position) marker.setLatLng(props.position);
    if (props.icon != null && props.icon !== prevProps.icon) marker.setIcon(props.icon);
    if (props.zIndexOffset != null && props.zIndexOffset !== prevProps.zIndexOffset) marker.setZIndexOffset(props.zIndexOffset);
    if (props.opacity != null && props.opacity !== prevProps.opacity) marker.setOpacity(props.opacity);
    if (marker.dragging != null && props.draggable !== prevProps.draggable) {
        if (props.draggable === true) marker.dragging.enable();
        else marker.dragging.disable();
    }
});

function $4617c4aa76443040$export$b39104a5f1b9296f(layer, props, prevProps) {
    const { opacity: opacity, zIndex: zIndex } = props;
    if (opacity != null && opacity !== prevProps.opacity) layer.setOpacity(opacity);
    if (zIndex != null && zIndex !== prevProps.zIndex) layer.setZIndex(zIndex);
}



const $ca1d5c5c8fa4e13e$export$f52ee31d61d0b27b = (0, $412372e3104ea643$export$4f432c6de5c4ddb8)(function createTileLayer({ url: url, ...options }, context) {
    const layer = new (0, $3df1761126dc5bba$exports.TileLayer)(url, (0, $b3399aabbd38b7ab$export$6ee5d263358f5c0e)(options, context));
    return (0, $207a01508dad26aa$export$a080ff44e8067a44)(layer, context);
}, function updateTileLayer(layer, props, prevProps) {
    (0, $4617c4aa76443040$export$b39104a5f1b9296f)(layer, props, prevProps);
    const { url: url } = props;
    if (url != null && url !== prevProps.url) layer.setUrl(url);
});




var $eO7Kz = parcelRequire("eO7Kz");

parcelRequire("eO7Kz");

const $70b35c6d35183943$var$getDistanceAsString = (distance)=>{
    if (typeof distance !== "number") return "NC";
    if (distance <= 0) return "0 m";
    if (distance < 1) return `${distance * 100} cm`;
    if (distance < 1000) return `${distance} m`;
    if (distance >= 1000) return `${Math.ceil(distance / 1000) * 10 / 10} km`;
    return "NC";
};
var $70b35c6d35183943$export$2e2bcd8739ae039 = $70b35c6d35183943$var$getDistanceAsString;


const $4655ef91f4d29fba$var$getTimeAsString = (time)=>{
    if (typeof time !== "number") return "NC";
    if (time < 1) return "NC";
    if (time < 60) return `${time} s`;
    if (time < 3600) return `${Math.ceil(time / 60)} min`;
    if (time === 3600) return `1 H`;
    if (time > 3600) {
        const hours = Math.floor(time / 3600);
        return `${hours} H ${Math.ceil((time - hours * 3600) / 60)} min`;
    }
    return "NC";
};
var $4655ef91f4d29fba$export$2e2bcd8739ae039 = $4655ef91f4d29fba$var$getTimeAsString;




parcelRequire("eO7Kz");
const $267f22d3dcb05f04$var$CyclingRegularIcon = ({ className: className, color: color })=>{
    return /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 34.168 29.135",
        className: className || "rf-w-8 rf-h-8",
        children: /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("g", {
            transform: "translate(0.5 -1.484)",
            children: /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("path", {
                d: "M20.5,6.789a2.645,2.645,0,1,0-2.645-2.645A2.653,2.653,0,0,0,20.5,6.789Zm-13.885,8.6a6.612,6.612,0,1,0,0,13.224,6.612,6.612,0,1,0,0-13.224Zm0,11.24a4.628,4.628,0,1,1,0-9.257,4.628,4.628,0,1,1,0,9.257ZM14.282,13.4l3.174-3.174,1.058,1.058a9.264,9.264,0,0,0,6.744,2.777V11.418A6.57,6.57,0,0,1,20.5,9.434L17.984,6.922a3.242,3.242,0,0,0-2.116-.793,2.219,2.219,0,0,0-1.851.793l-3.7,3.7a2.611,2.611,0,0,0-.793,1.851,2.219,2.219,0,0,0,.793,1.851l4.232,3.7v6.612h2.645v-8.2Zm10.843,1.984A6.612,6.612,0,1,0,31.737,22,6.548,6.548,0,0,0,25.125,15.385Zm0,11.24A4.628,4.628,0,1,1,29.753,22,4.685,4.685,0,0,1,25.125,26.625Z",
                transform: "translate(0 0.484)",
                fill: color || "#fff",
                stroke: "#000",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: "1"
            })
        })
    });
};
var $267f22d3dcb05f04$export$2e2bcd8739ae039 = $267f22d3dcb05f04$var$CyclingRegularIcon;



parcelRequire("eO7Kz");
const $1166353c42330d85$var$DrivingCarIcon = ({ className: className, color: color })=>{
    return /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 34.168 29.135",
        className: className || "rf-w-8 rf-h-8",
        children: /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("path", {
            id: "car",
            d: "M32.385,71.254H28.507L27.43,68.559A7.217,7.217,0,0,0,20.7,64H12.471a7.219,7.219,0,0,0-6.735,4.559L4.658,71.254H.781a.777.777,0,0,0-.754.966l.389,1.554a.777.777,0,0,0,.754.589h1.3a4.116,4.116,0,0,0-1.43,3.109V80.58A4.111,4.111,0,0,0,2.076,83.3v3.5a2.073,2.073,0,0,0,2.072,2.072H6.221A2.073,2.073,0,0,0,8.293,86.8V84.725h16.58V86.8a2.073,2.073,0,0,0,2.072,2.072h2.072A2.073,2.073,0,0,0,31.09,86.8V83.3a4.109,4.109,0,0,0,1.036-2.716V77.471A4.118,4.118,0,0,0,30.7,74.362H32a.777.777,0,0,0,.754-.589l.389-1.554a.778.778,0,0,0-.754-.966ZM9.584,70.1a3.109,3.109,0,0,1,2.887-1.954H20.7A3.109,3.109,0,0,1,23.582,70.1l1.291,3.227H8.293ZM6.221,80.567a2.066,2.066,0,1,1,0-4.132,3.987,3.987,0,0,1,3.109,3.1c0,1.24-1.865,1.033-3.109,1.033Zm20.725,0c-1.243,0-3.109.207-3.109-1.033a3.987,3.987,0,0,1,3.109-3.1,2.066,2.066,0,1,1,0,4.132Z",
            transform: "translate(0.501 -63.5)",
            fill: color || "#fff",
            stroke: "#000",
            strokeWidth: "1"
        })
    });
};
var $1166353c42330d85$export$2e2bcd8739ae039 = $1166353c42330d85$var$DrivingCarIcon;



parcelRequire("eO7Kz");
const $874d32f526cce5d6$var$FootWalkingIcon = ({ className: className, color: color })=>{
    return /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "-6 0 34.168 29.135",
        className: className || "rf-w-8 rf-h-8",
        children: /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("path", {
            d: "M11.4,5.249A2.625,2.625,0,1,0,8.772,2.625,2.625,2.625,0,0,0,11.4,5.249ZM16.564,13.4l-1.274-.645-.53-1.608A5.962,5.962,0,0,0,9.171,7c-1.968-.005-3.057.552-5.1,1.378A5.216,5.216,0,0,0,1.352,10.9l-.366.744a1.755,1.755,0,0,0,.776,2.346,1.726,1.726,0,0,0,2.324-.782l.366-.744a1.738,1.738,0,0,1,.9-.842l1.465-.591-.831,3.319A3.512,3.512,0,0,0,6.8,17.568l3.275,3.576a3.529,3.529,0,0,1,.815,1.515l1,4.008a1.75,1.75,0,0,0,3.4-.848l-1.214-4.866a3.5,3.5,0,0,0-.815-1.515l-2.488-2.718.94-3.756.3.9a3.487,3.487,0,0,0,1.733,2.023l1.274.645a1.726,1.726,0,0,0,2.324-.782,1.77,1.77,0,0,0-.782-2.351ZM4.048,21.1a3.393,3.393,0,0,1-.776,1.176L.538,25.01a1.75,1.75,0,1,0,2.472,2.477l3.248-3.248a3.554,3.554,0,0,0,.776-1.176l.738-1.848c-3.024-3.3-2.116-2.286-2.592-2.936L4.048,21.1Z",
            transform: "translate(0.612 0.5)",
            fill: color || "#fff",
            stroke: "#000",
            strokeWidth: "1"
        })
    });
};
var $874d32f526cce5d6$export$2e2bcd8739ae039 = $874d32f526cce5d6$var$FootWalkingIcon;




const $012c61a4cafa04f1$var$RoutesItem = ({ summary: summary, middle: middle, chosen: chosen, color: color, colorWithTransparency: colorWithTransparency, onClick: onClick })=>{
    const { locale: locale } = (0, $2e4dc8fa28d39601$export$6650dace022cfacc)();
    const topBorders = middle ? "rf-border rf-border-x-silver rf-border-y-transparent" : "";
    const bottomBorders = middle ? "rf-border-x-truewhite" : "rf-border-x-transparent";
    return /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsxs)("div", {
        className: "rf-flex rf-flex-col rf-justify-end hover:rf-cursor-pointer",
        onClick: ()=>onClick(summary.type),
        children: [
            /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsxs)("div", {
                className: `rf-h-full rf-pr-2 rf-flex rf-flex-row rf-items-center rf-bg-opacity-50 ${topBorders}`,
                style: {
                    backgroundColor: chosen ? colorWithTransparency || "rgba(25, 153, 177, 0.5)" : undefined
                },
                children: [
                    /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsxs)("div", {
                        className: "rf-py-2 rf-flex rf-justify-center rf-items-center",
                        children: [
                            summary.type === "drivingCar" && /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)($1166353c42330d85$export$2e2bcd8739ae039, {
                                className: "rf-w-8 rf-mx-2"
                            }),
                            summary.type === "cyclingRegular" && /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)($267f22d3dcb05f04$export$2e2bcd8739ae039, {
                                className: "rf-w-8 rf-mx-2"
                            }),
                            summary.type === "footWalking" && /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)($874d32f526cce5d6$export$2e2bcd8739ae039, {
                                className: "rf-w-8 rf-ml-1"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsxs)("div", {
                        className: "rf-flex rf-py-1 rf-flex-col rf-justify-center rf-items-center",
                        children: [
                            /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("div", {
                                className: "rf-whitespace-nowrap",
                                children: (0, $70b35c6d35183943$export$2e2bcd8739ae039)(summary?.distance)
                            }),
                            /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("div", {
                                className: "rf-whitespace-nowrap",
                                children: (0, $4655ef91f4d29fba$export$2e2bcd8739ae039)(summary?.duration)
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("div", {
                className: `rf-py-[0.1rem] rf-text-center rf-uppercase rf-border rf-border-t-0 rf-text-truewhite ${bottomBorders}`,
                style: {
                    backgroundColor: color || "#1999B1"
                },
                children: (0, (/*@__PURE__*/$parcel$interopDefault($8f95d7a47c249d24$exports)))[locale]?.route || (0, (/*@__PURE__*/$parcel$interopDefault($8f95d7a47c249d24$exports)))["fr-FR"].route
            })
        ]
    });
};
var $012c61a4cafa04f1$export$2e2bcd8739ae039 = $012c61a4cafa04f1$var$RoutesItem;



const $00a6b7b09177952f$var$Routes = ({ coordinates: coordinates, setMapLayerData: setMapLayerData, color: color, colorWithTransparency: colorWithTransparency })=>{
    const [drivingCar, setDrivingCar] = (0, $eO7Kz.useState)(undefined);
    const [cyclingRegular, setCyclingRegular] = (0, $eO7Kz.useState)(undefined);
    const [footWalking, setFootWalking] = (0, $eO7Kz.useState)(undefined);
    const [currentChosen, setCurrentChosen] = (0, $eO7Kz.useState)(undefined);
    /**
   * On component mount :
   *  - call methods to retrieve data from openroute API
   */ (0, $eO7Kz.useEffect)(()=>{
        calculateForProfile("driving-car");
        calculateForProfile("cycling-regular");
        calculateForProfile("foot-walking");
    }, []);
    /**
   * On currentChosen state change :
   *  - switch on currentChosen value to display the associated data on the map
   */ (0, $eO7Kz.useEffect)(()=>{
        switch(currentChosen){
            case "drivingCar":
                drivingCar && drivingCar.features && setMapLayerData(drivingCar);
                break;
            case "cyclingRegular":
                cyclingRegular && cyclingRegular.features && setMapLayerData(cyclingRegular);
                break;
            case "footWalking":
                footWalking && footWalking.features && setMapLayerData(footWalking);
                break;
            default:
                break;
        }
    }, [
        currentChosen
    ]);
    /**
   * On drivingCar state change :
   *  - if driving car data were retrieved and no course has been chosen, set curretnChosen state to 'driving-car'
   */ (0, $eO7Kz.useEffect)(()=>{
        drivingCar && !currentChosen && setCurrentChosen("drivingCar");
    }, [
        drivingCar
    ]);
    /**
   * On call :
   *  - call the openroute API to retrieve data for the current course
   * @param profile : string
   */ const calculateForProfile = async (profile)=>{
        const url = `${(0, $674f1d59bae686ab$export$d6542303192de6db)}/${profile}/geojson`;
        const data = await fetch(url, {
            method: "POST",
            headers: {
                Authorization: (0, $674f1d59bae686ab$export$6f60da16472d34a7),
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                coordinates: coordinates
            })
        }).then((result)=>{
            return result.json();
        }).catch(()=>{
            return null;
        });
        if (data && !data.error) switch(profile){
            case "driving-car":
                setDrivingCar(data);
                break;
            case "cycling-regular":
                setCyclingRegular(data);
                break;
            case "foot-walking":
                setFootWalking(data);
                break;
            default:
                break;
        }
    };
    return drivingCar || cyclingRegular || footWalking ? /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsxs)("div", {
        className: "rf-absolute rf-bottom-0 rf-left-1/2 -rf-translate-x-1/2 rf-grid rf-grid-cols-routes rf-border rf-border-x-truewhite rf-border-t-0 rf-bg-truewhite rf-text-xs large:rf-text-sm rf-shadow-[0_-5px_10px_silver,-5px_0_10px_silver,5px_0_10px_silver]",
        children: [
            /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $012c61a4cafa04f1$export$2e2bcd8739ae039), {
                summary: {
                    type: "drivingCar",
                    distance: drivingCar?.features && drivingCar.features.length > 0 ? drivingCar.features[0].properties?.summary?.distance : undefined,
                    duration: drivingCar?.features && drivingCar.features.length > 0 ? drivingCar.features[0].properties?.summary?.duration : undefined
                },
                chosen: currentChosen === "drivingCar",
                color: color,
                colorWithTransparency: colorWithTransparency,
                onClick: setCurrentChosen
            }),
            /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $012c61a4cafa04f1$export$2e2bcd8739ae039), {
                summary: {
                    type: "cyclingRegular",
                    distance: cyclingRegular?.features && cyclingRegular.features.length > 0 ? cyclingRegular.features[0].properties?.summary?.distance : undefined,
                    duration: cyclingRegular?.features && cyclingRegular.features.length > 0 ? cyclingRegular.features[0].properties?.summary?.duration : undefined
                },
                // eslint-disable-next-line react/jsx-boolean-value
                middle: true,
                chosen: currentChosen === "cyclingRegular",
                color: color,
                colorWithTransparency: colorWithTransparency,
                onClick: setCurrentChosen
            }),
            /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $012c61a4cafa04f1$export$2e2bcd8739ae039), {
                summary: {
                    type: "footWalking",
                    distance: footWalking?.features && footWalking.features.length > 0 ? footWalking.features[0].properties?.summary?.distance : undefined,
                    duration: footWalking?.features && footWalking.features.length > 0 ? footWalking.features[0].properties?.summary?.duration : undefined
                },
                chosen: currentChosen === "footWalking",
                color: color,
                colorWithTransparency: colorWithTransparency,
                onClick: setCurrentChosen
            })
        ]
    }) : /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eO7Kz))).Fragment, {});
};
var $00a6b7b09177952f$export$2e2bcd8739ae039 = $00a6b7b09177952f$var$Routes;




var $eO7Kz = parcelRequire("eO7Kz");


var $eO7Kz = parcelRequire("eO7Kz");
function $ef7bf4cfdd335a54$export$86f8f9f08863e403() {
    return (0, $bc5a8ed0a8cbb7cf$export$ea59151b8430a4e9)().map;
}
function $ef7bf4cfdd335a54$export$4c2959913f5c7962(type, handler) {
    const map = $ef7bf4cfdd335a54$export$86f8f9f08863e403();
    (0, $eO7Kz.useEffect)(function addMapEventHandler() {
        // @ts-ignore event type
        map.on(type, handler);
        return function removeMapEventHandler() {
            // @ts-ignore event type
            map.off(type, handler);
        };
    }, [
        map,
        type,
        handler
    ]);
    return map;
}
function $ef7bf4cfdd335a54$export$1c51e2c234152172(handlers) {
    const map = $ef7bf4cfdd335a54$export$86f8f9f08863e403();
    (0, $eO7Kz.useEffect)(function addMapEventHandlers() {
        map.on(handlers);
        return function removeMapEventHandlers() {
            map.off(handlers);
        };
    }, [
        map,
        handlers
    ]);
    return map;
}


const $21ecaa0b1a4cc78e$var$MapUser = ({ configurationPosition: configurationPosition, coordinates: coordinates, data: data })=>{
    const map = (0, $ef7bf4cfdd335a54$export$86f8f9f08863e403)();
    (0, $eO7Kz.useEffect)(()=>{
        if (configurationPosition !== coordinates) {
            const coords1 = [
                ...configurationPosition
            ];
            const coords2 = [
                ...coordinates
            ];
            if (configurationPosition[0] > coordinates[0]) coords2[0] -= (configurationPosition[0] - coordinates[0]) / 2;
            else coords1[0] -= (coordinates[0] - configurationPosition[0]) / 2;
            map.flyToBounds([
                coords1,
                coords2
            ]);
        } else map.flyToBounds([
            configurationPosition,
            coordinates
        ]);
    }, [
        data
    ]);
    return /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eO7Kz))).Fragment, {});
};
var $21ecaa0b1a4cc78e$export$2e2bcd8739ae039 = $21ecaa0b1a4cc78e$var$MapUser;





const $600ffc7613525482$var$userIcon = (0, (/*@__PURE__*/$parcel$interopDefault($3df1761126dc5bba$exports))).icon({
    iconUrl: `${(0, $9062ab1ccebf2f9e$export$e56d88b19b5c9fbf).mapDeparture}`,
    shadowUrl: (0, (/*@__PURE__*/$parcel$interopDefault($91413e73098b9b1c$exports))),
    iconSize: [
        32,
        41
    ],
    iconAnchor: [
        16,
        41
    ]
});
const $600ffc7613525482$var$Map = ({ latitude: latitude, longitude: longitude, color: color, colorWithTransparency: colorWithTransparency })=>{
    const { configuration: configuration } = (0, $e599569c1fc3ca2c$export$d8760bee47331b1d)();
    const [mapLayerData, setMapLayerData] = (0, $eO7Kz.useState)(undefined);
    const geoJsonLayer = (0, $eO7Kz.useRef)(null);
    const coordinates = configuration.position?.latitude && configuration.position?.longitude ? [
        [
            configuration.position.longitude,
            configuration.position.latitude
        ],
        [
            longitude,
            latitude
        ]
    ] : undefined;
    (0, $eO7Kz.useEffect)(()=>{
        if (geoJsonLayer.current) mapLayerData && geoJsonLayer.current.clearLayers().addData(mapLayerData);
    }, [
        mapLayerData
    ]);
    return /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($eO7Kz))).Fragment, {
        children: [
            /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsxs)((0, $757dda645ff21de7$export$23f3dfd47374502b), {
                center: [
                    latitude,
                    longitude
                ],
                zoom: 12,
                scrollWheelZoom: false,
                style: {
                    height: "100%",
                    width: "100%",
                    zIndex: 0
                },
                children: [
                    /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $ca1d5c5c8fa4e13e$export$f52ee31d61d0b27b), {
                        url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                    }),
                    /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $eddf09e248834647$export$e98856a975cab58e), {
                        position: [
                            latitude,
                            longitude
                        ]
                    }),
                    configuration.position?.latitude && configuration.position?.longitude && /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $eddf09e248834647$export$e98856a975cab58e), {
                        position: [
                            configuration.position.latitude,
                            configuration.position.longitude
                        ],
                        icon: $600ffc7613525482$var$userIcon
                    }),
                    mapLayerData && /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $195c90e737d8a92f$export$3a16e672cb3a069e), {
                        ref: geoJsonLayer,
                        data: mapLayerData
                    }),
                    /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $21ecaa0b1a4cc78e$export$2e2bcd8739ae039), {
                        configurationPosition: [
                            configuration.position?.latitude || latitude,
                            configuration.position?.longitude || longitude
                        ],
                        coordinates: [
                            latitude,
                            longitude
                        ],
                        data: mapLayerData
                    })
                ]
            }),
            coordinates && /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $00a6b7b09177952f$export$2e2bcd8739ae039), {
                coordinates: coordinates,
                setMapLayerData: setMapLayerData,
                color: color,
                colorWithTransparency: colorWithTransparency
            })
        ]
    });
};
var $600ffc7613525482$export$2e2bcd8739ae039 = $600ffc7613525482$var$Map;





const $8ec20b1c7384f834$var$DetailedAddress = ({ address: address, phoneNumber: phoneNumber, coordinates: coordinates, color: color, colorWithTransparency: colorWithTransparency, customerReviews: customerReviews, url: url })=>{
    const { currentWidth: currentWidth, currentDeviceType: currentDeviceType, isMobile: isMobile } = (0, $8b59a4dbb18c269b$export$3abe3478af3cb63b)();
    const { configuration: configuration } = (0, $e599569c1fc3ca2c$export$d8760bee47331b1d)();
    return /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsxs)("div", {
        className: "rf-relative rf-w-1/3 vertical:rf-w-full large:rf-bg-truewhite rf-flex rf-flex-col large-vertical:rf-flex-row",
        children: [
            customerReviews && /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $a5cb86689a9eed96$export$2e2bcd8739ae039), {
                className: "rf-absolute large-vertical:rf-hidden rf-top-0 rf-left-1/2 rf--translate-x-1/2",
                color: color,
                customerReviews: customerReviews
            }),
            /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsxs)("div", {
                className: `rf-px-6 rf-flex rf-flex-col large-vertical:rf-w-1/2 rf-items-center rf-text-center ${customerReviews ? currentDeviceType !== (0, $16ad089b9ce6627d$export$ec1e04e4e5ef8233).borne ? "rf-bg-truewhite rf-justify-start" : "rf-bg-truewhite rf-justify-center" : "rf-justify-center"}`,
                style: {
                    height: isMobile ? customerReviews ? currentWidth : undefined : currentDeviceType === (0, $16ad089b9ce6627d$export$ec1e04e4e5ef8233).landscape ? coordinates && coordinates.latitude && coordinates.longitude ? "50%" : "100%" : "calc(50vw - 3rem)"
                },
                children: [
                    /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("div", {
                        className: customerReviews && currentDeviceType !== (0, $16ad089b9ce6627d$export$ec1e04e4e5ef8233).borne ? currentDeviceType === (0, $16ad089b9ce6627d$export$ec1e04e4e5ef8233).landscape ? "rf-pt-[26vh] rf-pb-12" : "rf-pt-11/20 rf-pb-12" : "rf-py-12",
                        children: address || ""
                    }),
                    phoneNumber && /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $4836ad818fa804ff$export$2e2bcd8739ae039), {
                        phoneNumber: phoneNumber
                    }),
                    coordinates && coordinates.latitude && coordinates.longitude && currentDeviceType === (0, $16ad089b9ce6627d$export$ec1e04e4e5ef8233).borne && url && (configuration.isUsedOnBorne ? /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $23a0015420938728$export$2e2bcd8739ae039), {
                        url: url
                    }) : /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $02a6addb65ee69eb$export$2e2bcd8739ae039), {
                        className: "rf-justify-center",
                        url: url
                    }))
                ]
            }),
            coordinates && coordinates.latitude && coordinates.longitude ? /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("div", {
                className: "rf-relative large-vertical:rf-w-1/2",
                style: {
                    height: isMobile ? currentWidth : currentDeviceType === (0, $16ad089b9ce6627d$export$ec1e04e4e5ef8233).landscape ? "50%" : "calc(50vw - 3rem)"
                },
                children: /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $600ffc7613525482$export$2e2bcd8739ae039), {
                    latitude: coordinates.latitude,
                    longitude: coordinates.longitude,
                    color: color,
                    colorWithTransparency: colorWithTransparency
                })
            }) : currentDeviceType === (0, $16ad089b9ce6627d$export$ec1e04e4e5ef8233).borne ? /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("div", {
                className: "rf-flex rf-justify-center rf-items-center rf-h-[calc(50vw-3rem)] rf-w-1/2",
                children: url && (configuration.isUsedOnBorne ? /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $23a0015420938728$export$2e2bcd8739ae039), {
                    url: url
                }) : /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $02a6addb65ee69eb$export$2e2bcd8739ae039), {
                    className: "rf-justify-center",
                    url: url
                }))
            }) : /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eO7Kz))).Fragment, {})
        ]
    });
};
var $8ec20b1c7384f834$export$2e2bcd8739ae039 = $8ec20b1c7384f834$var$DetailedAddress;




const $da3b3c7a7b543978$var$AttachmentDetails = ()=>{
    const askForDetailedPOI = (0, $8e8554fbe249bb45$export$2e2bcd8739ae039)();
    const { mode: mode } = (0, $e599569c1fc3ca2c$export$d8760bee47331b1d)();
    const { themeColors: themeColors, isMobile: isMobile } = (0, $8b59a4dbb18c269b$export$3abe3478af3cb63b)();
    const [content, setContent] = (0, $eO7Kz.useState)(undefined);
    const [color, setColor] = (0, $eO7Kz.useState)(themeColors.secondary);
    const [colorWithTransparency, setColorWithTransparency] = (0, $eO7Kz.useState)("rgba(25, 153, 177, 0.5)");
    (0, $eO7Kz.useEffect)(()=>{
        setContent(askForDetailedPOI);
        if (askForDetailedPOI) (0, $134592d23f105dbc$export$dcb32d000c0e0280)((0, $16ad089b9ce6627d$export$4f7cd669585dc69f).DetailViewOpen);
    }, [
        askForDetailedPOI
    ]);
    /**
   * On content change :
   *  - retrieve the color for the category by calling getColorFromCategoryId
   *  - set color state
   */ (0, $eO7Kz.useEffect)(()=>{
        if (content && content.category?.id) setColor((0, $ef53ee7f96bcc303$export$7c3e7489ecac4759)(content.category.id, themeColors));
    }, [
        content
    ]);
    /**
   * On color props change :
   *  - set colorWithTransparency state by calling getColorWithTransparency method with a transparency of 0.5
   */ (0, $eO7Kz.useEffect)(()=>{
        color && setColorWithTransparency((0, $00bd6a4dae2c5391$export$730331b97844b22d)(color, 0.5));
    }, [
        color
    ]);
    const handleClose = ()=>{
        setContent(undefined);
        (0, $134592d23f105dbc$export$dcb32d000c0e0280)((0, $16ad089b9ce6627d$export$4f7cd669585dc69f).DetailViewClose);
    };
    return content ? /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $47785786bd448bb5$export$2e2bcd8739ae039), {
        handleClose: handleClose,
        closeButtonClassName: "rf-z-util",
        remoteCloseButtonZIndex: "rf-z-detailedPOI",
        children: /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsxs)("div", {
            className: "rf-relative rf-flex rf-flex-row vertical:rf-flex-col large:rf-h-full",
            children: [
                /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsxs)("div", {
                    className: "rf-px-6 large:rf-px-8 rf-w-2/3 vertical:rf-w-full rf-mb-4 large:rf-mb-0 rf-flex rf-flex-col rf-border-r rf-border-r-silver vertical:rf-border-r-0",
                    children: [
                        /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $5006fba2be467a7a$export$2e2bcd8739ae039), {
                            category: content.category,
                            title: content.title,
                            infoBanner: content.infoBanner,
                            color: color,
                            customerReviews: content.customerReviews,
                            favorite: content.favorite,
                            handleClose: handleClose
                        }),
                        /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsxs)("div", {
                            className: "rf-flex rf-flex-col large:rf-flex-row",
                            children: [
                                /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $84dec8e96990628c$export$2e2bcd8739ae039), {
                                    text: content.text,
                                    otherInformations: content.otherInformations,
                                    color: color,
                                    url: content.downloadUri
                                }),
                                (content.media && content.media.length > 0 || content.review) && /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $a495e45504638d20$export$2e2bcd8739ae039), {
                                    media: content.media,
                                    review: content.review,
                                    color: color
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $8ec20b1c7384f834$export$2e2bcd8739ae039), {
                    address: content.address,
                    phoneNumber: content.phoneNumber,
                    coordinates: content.coordinates,
                    color: color,
                    colorWithTransparency: colorWithTransparency,
                    customerReviews: content.customerReviews,
                    url: content.downloadUri
                }),
                isMobile && /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("div", {
                    className: mode === (0, $16ad089b9ce6627d$export$9484bbecc3c49a2e).text ? "rf-mb-28" : "rf-mb-16",
                    children: content.downloadUri && /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $02a6addb65ee69eb$export$2e2bcd8739ae039), {
                        className: "rf-justify-center",
                        url: content.downloadUri
                    })
                })
            ]
        })
    }) : /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eO7Kz))).Fragment, {});
};
var $da3b3c7a7b543978$export$2e2bcd8739ae039 = $da3b3c7a7b543978$var$AttachmentDetails;




var $eO7Kz = parcelRequire("eO7Kz");








const $9abebc121984a403$var$FullScreenImage = ()=>{
    const locale = (0, $2e4dc8fa28d39601$export$6650dace022cfacc)((state)=>state.locale);
    const fullScreenImage = (0, $7bb94569b6340a35$export$2e2bcd8739ae039)();
    const { mode: mode } = (0, $e599569c1fc3ca2c$export$d8760bee47331b1d)();
    const { isMobile: isMobile } = (0, $8b59a4dbb18c269b$export$3abe3478af3cb63b)();
    const [content, setContent] = (0, $eO7Kz.useState)();
    (0, $eO7Kz.useEffect)(()=>{
        setContent(fullScreenImage);
    }, [
        fullScreenImage
    ]);
    const handleClose = ()=>{
        (0, $134592d23f105dbc$export$4e062bd31c814155)(undefined);
    };
    return content ? /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $47785786bd448bb5$export$2e2bcd8739ae039), {
        handleClose: handleClose,
        mobileReturnTitle: (0, (/*@__PURE__*/$parcel$interopDefault($abbebf5de79f9da4$exports)))[locale]?.backconversation || (0, (/*@__PURE__*/$parcel$interopDefault($abbebf5de79f9da4$exports)))["fr-FR"].backconversation,
        children: /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("div", {
            className: `rf-h-full rf-w-full ${isMobile ? mode === (0, $16ad089b9ce6627d$export$9484bbecc3c49a2e).text ? "rf-mb-28" : "rf-mb-16" : "rf-pt-12"} rf-px-8 rf-pb-12 rf-flex rf-justify-center rf-items-center`,
            children: /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("img", {
                className: "rf-max-h-full rf-max-w-full",
                src: content
            })
        })
    }) : /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eO7Kz))).Fragment, {});
};
var $9abebc121984a403$export$2e2bcd8739ae039 = $9abebc121984a403$var$FullScreenImage;


/* eslint-disable react/jsx-boolean-value */ 
parcelRequire("eO7Kz");



var $eO7Kz = parcelRequire("eO7Kz");

var $kz03S = parcelRequire("kz03S");
let $67b54afe16cc9453$var$$32e24fada5befcfe$export$ec1e04e4e5ef8233;
(function(DeviceType) {
    DeviceType[DeviceType["mobile"] = 1] = "mobile";
    DeviceType[DeviceType["borne"] = 2] = "borne";
    DeviceType[DeviceType["landscape"] = 3] = "landscape";
    DeviceType[DeviceType["widget"] = 4] = "widget";
})($67b54afe16cc9453$var$$32e24fada5befcfe$export$ec1e04e4e5ef8233 || ($67b54afe16cc9453$var$$32e24fada5befcfe$export$ec1e04e4e5ef8233 = {}));
const $67b54afe16cc9453$var$$91d4a798329bd0d3$export$7f608b480d9e7085 = {
    weekday: "long",
    month: "long",
    day: "numeric"
};
const $67b54afe16cc9453$var$$91d4a798329bd0d3$export$78f16669b353a880 = [
    $67b54afe16cc9453$var$$32e24fada5befcfe$export$ec1e04e4e5ef8233.mobile,
    $67b54afe16cc9453$var$$32e24fada5befcfe$export$ec1e04e4e5ef8233.widget
];
const $67b54afe16cc9453$var$$91d4a798329bd0d3$export$dc91bcad81fffb1f = "https://api.open-meteo.com/v1/forecast?";
const $67b54afe16cc9453$var$$91d4a798329bd0d3$export$68b4ac416ba801c6 = "&daily=weathercode,temperature_2m_max,temperature_2m_min&timezone=auto&current_weather=true";
const $67b54afe16cc9453$var$$d3351fce476b5d48$export$43a4b902cf54b66d = async (position)=>{
    if (position?.latitude && position?.longitude) {
        // Create the address to call the open-meteo API
        const fullAddress = `${$67b54afe16cc9453$var$$91d4a798329bd0d3$export$dc91bcad81fffb1f}latitude=${position.latitude}&longitude=${position.longitude}${$67b54afe16cc9453$var$$91d4a798329bd0d3$export$68b4ac416ba801c6}`;
        // Call the API
        const fetchedData = await fetch(fullAddress).then((result)=>{
            return result.json();
        }).catch((error)=>{
            console.log(error);
            return null;
        });
        if (fetchedData) return $67b54afe16cc9453$var$$d3351fce476b5d48$var$processFetchedData(fetchedData);
    }
    return null;
};
const $67b54afe16cc9453$var$$d3351fce476b5d48$var$processFetchedData = (data)=>{
    const current = {
        weather: data.current_weather.weathercode,
        temperature: {
            unit: data.daily_units.temperature_2m_max || "\xb0C",
            average: data.current_weather.temperature
        },
        time: data.current_weather.time
    };
    const prevision = [];
    // The first item is the current day, we will use the 6 next days
    for(let i = 1; i < 7; i++){
        const tempWeatherData = {
            day: data.daily.time[i],
            weather: data.daily.weathercode[i],
            temperature: {
                unit: data.daily_units.temperature_2m_max || "\xb0C",
                min: data.daily.temperature_2m_min[i],
                max: data.daily.temperature_2m_max[i]
            }
        };
        prevision.push(tempWeatherData);
    }
    const allData = {
        current: {
            ...current
        },
        prevision: [
            ...prevision
        ]
    };
    localStorage.setItem("Retorik.Weather.Data", JSON.stringify(allData));
    return allData;
};
const $67b54afe16cc9453$var$$379dc81df3dc7496$export$d07f57595c356899 = (text, locale = "fr-FR")=>{
    if (text.length > 0) {
        const first = text.charAt(0);
        const rest = text.slice(1);
        return first.toLocaleUpperCase(locale) + rest;
    }
    return "";
};
const $67b54afe16cc9453$var$$d73edfc5f2fb24d0$var$CloudIcon = ({ className: className, color: color })=>{
    return (0, $179ad052de55b86f$exports.jsx)("svg", {
        version: "1.1",
        id: "Layer_1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        x: "0px",
        y: "0px",
        viewBox: "0 0 30 30",
        className: className || "rf-h-16 rf-w-16",
        xmlSpace: "preserve",
        fill: color || "#1999B1",
        children: (0, $179ad052de55b86f$exports.jsx)("path", {
            d: "M3.89,17.6c0-0.99,0.31-1.88,0.93-2.65s1.41-1.27,2.38-1.49c0.26-1.17,0.85-2.14,1.78-2.88c0.93-0.75,2-1.12,3.22-1.12 c1.18,0,2.24,0.36,3.16,1.09c0.93,0.73,1.53,1.66,1.8,2.8h0.27c1.18,0,2.18,0.41,3.01,1.24s1.25,1.83,1.25,3 c0,1.18-0.42,2.18-1.25,3.01s-1.83,1.25-3.01,1.25H8.16c-0.58,0-1.13-0.11-1.65-0.34S5.52,21,5.14,20.62 c-0.38-0.38-0.68-0.84-0.91-1.36S3.89,18.17,3.89,17.6z M5.34,17.6c0,0.76,0.28,1.42,0.82,1.96s1.21,0.82,1.99,0.82h9.28 c0.77,0,1.44-0.27,1.99-0.82c0.55-0.55,0.83-1.2,0.83-1.96c0-0.76-0.27-1.42-0.83-1.96c-0.55-0.54-1.21-0.82-1.99-0.82h-1.39 c-0.1,0-0.15-0.05-0.15-0.15l-0.07-0.49c-0.1-0.94-0.5-1.73-1.19-2.35s-1.51-0.93-2.45-0.93c-0.94,0-1.76,0.31-2.46,0.94 c-0.7,0.62-1.09,1.41-1.18,2.34l-0.07,0.42c0,0.1-0.05,0.15-0.16,0.15l-0.45,0.07c-0.72,0.06-1.32,0.36-1.81,0.89 C5.59,16.24,5.34,16.87,5.34,17.6z M14.19,8.88c-0.1,0.09-0.08,0.16,0.07,0.21c0.43,0.19,0.79,0.37,1.08,0.55 c0.11,0.03,0.19,0.02,0.22-0.03c0.61-0.57,1.31-0.86,2.12-0.86c0.81,0,1.5,0.27,2.1,0.81c0.59,0.54,0.92,1.21,0.99,2l0.09,0.64h1.42 c0.65,0,1.21,0.23,1.68,0.7c0.47,0.47,0.7,1.02,0.7,1.66c0,0.6-0.21,1.12-0.62,1.57s-0.92,0.7-1.53,0.77c-0.1,0-0.15,0.05-0.15,0.16 v1.13c0,0.11,0.05,0.16,0.15,0.16c1.01-0.06,1.86-0.46,2.55-1.19s1.04-1.6,1.04-2.6c0-1.06-0.37-1.96-1.12-2.7 c-0.75-0.75-1.65-1.12-2.7-1.12h-0.15c-0.26-1-0.81-1.82-1.65-2.47c-0.83-0.65-1.77-0.97-2.8-0.97C16.28,7.29,15.11,7.82,14.19,8.88 z"
        })
    });
};
var $67b54afe16cc9453$var$$d73edfc5f2fb24d0$export$2e2bcd8739ae039 = $67b54afe16cc9453$var$$d73edfc5f2fb24d0$var$CloudIcon;
const $67b54afe16cc9453$var$$b3a5251415e304a6$var$DrizzleIcon = ({ className: className, color: color })=>{
    return (0, $179ad052de55b86f$exports.jsx)("svg", {
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        x: "0px",
        y: "0px",
        viewBox: "0 0 30 30",
        className: className || "rf-h-16 rf-w-16",
        xmlSpace: "preserve",
        fill: color || "#1999B1",
        children: (0, $179ad052de55b86f$exports.jsx)("path", {
            d: "M3.1,21.04c0-0.24,0.08-0.45,0.25-0.61s0.38-0.24,0.63-0.24h8.97c0.24,0,0.43,0.08,0.59,0.24c0.16,0.16,0.23,0.36,0.23,0.61 c0,0.24-0.08,0.44-0.24,0.6c-0.16,0.16-0.35,0.24-0.59,0.24H3.98c-0.25,0-0.46-0.08-0.63-0.24S3.1,21.27,3.1,21.04z M5.73,17.98 c0-0.24,0.09-0.44,0.27-0.6c0.14-0.15,0.34-0.23,0.59-0.23h9c0.23,0,0.42,0.08,0.58,0.23s0.23,0.35,0.23,0.59 c0,0.24-0.08,0.44-0.23,0.61c-0.15,0.17-0.35,0.25-0.58,0.25h-9c-0.23,0-0.43-0.09-0.6-0.26S5.73,18.21,5.73,17.98z M6.35,15.65 c0,0.09,0.06,0.14,0.17,0.14h1.43c0.09,0,0.17-0.05,0.23-0.14c0.23-0.54,0.57-0.99,1.04-1.35s0.99-0.56,1.58-0.6l0.54-0.07 c0.11,0,0.17-0.06,0.17-0.18l0.07-0.52c0.11-1.09,0.58-1.99,1.39-2.72c0.82-0.73,1.77-1.09,2.87-1.09c1.09,0,2.03,0.36,2.83,1.07 c0.8,0.72,1.27,1.62,1.41,2.7l0.07,0.59c0,0.11,0.06,0.16,0.18,0.16h1.6c0.91,0,1.68,0.32,2.32,0.96c0.64,0.64,0.96,1.41,0.96,2.32 c0,0.88-0.33,1.64-0.97,2.28c-0.65,0.65-1.42,0.97-2.31,0.97h-6.89c-0.12,0-0.18,0.06-0.18,0.17v1.34c0,0.12,0.06,0.18,0.18,0.18 h6.89c0.68,0,1.32-0.13,1.94-0.39s1.14-0.61,1.58-1.05s0.79-0.97,1.05-1.58s0.39-1.25,0.39-1.92c0-0.9-0.22-1.73-0.66-2.49 c-0.44-0.76-1.04-1.36-1.8-1.8c-0.76-0.44-1.6-0.66-2.5-0.66h-0.31c-0.33-1.34-1.03-2.44-2.1-3.3c-1.08-0.85-2.3-1.28-3.68-1.28 c-1.42,0-2.67,0.44-3.76,1.33c-1.09,0.88-1.78,2.01-2.08,3.39c-0.86,0.19-1.62,0.6-2.27,1.21s-1.1,1.35-1.36,2.22v0.02 C6.36,15.6,6.35,15.62,6.35,15.65z M7.5,24.13c0-0.24,0.09-0.44,0.26-0.6c0.15-0.16,0.35-0.23,0.59-0.23h8.99 c0.24,0,0.45,0.08,0.61,0.24c0.17,0.16,0.25,0.36,0.25,0.6c0,0.24-0.08,0.44-0.25,0.61c-0.17,0.17-0.37,0.25-0.61,0.25H8.35 c-0.23,0-0.43-0.08-0.6-0.25C7.58,24.57,7.5,24.37,7.5,24.13z"
        })
    });
};
var $67b54afe16cc9453$var$$b3a5251415e304a6$export$2e2bcd8739ae039 = $67b54afe16cc9453$var$$b3a5251415e304a6$var$DrizzleIcon;
const $67b54afe16cc9453$var$$cb12c9594bbf6bb4$var$DustIcon = ({ className: className, color: color })=>{
    return (0, $179ad052de55b86f$exports.jsx)("svg", {
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        x: "0px",
        y: "0px",
        viewBox: "0 0 30 30",
        className: className || "rf-h-16 rf-w-16",
        xmlSpace: "preserve",
        fill: color || "#1999B1",
        children: (0, $179ad052de55b86f$exports.jsx)("path", {
            d: "M7.33,16.58c0-0.23,0.08-0.41,0.23-0.56c0.16-0.15,0.37-0.22,0.64-0.22h5.71c0.27,0,0.48,0.07,0.64,0.22 c0.16,0.15,0.23,0.33,0.23,0.56c0,0.27-0.08,0.49-0.23,0.64s-0.37,0.23-0.64,0.23H8.2c-0.27,0-0.48-0.08-0.64-0.23 S7.33,16.86,7.33,16.58z M7.33,10.67c0-0.22,0.08-0.41,0.23-0.55C7.72,9.97,7.93,9.9,8.2,9.9h2.96c0.27,0,0.48,0.07,0.64,0.22 c0.16,0.14,0.24,0.33,0.24,0.55c0,0.27-0.08,0.48-0.24,0.64c-0.16,0.16-0.37,0.24-0.64,0.24H8.2c-0.27,0-0.48-0.08-0.64-0.23 S7.33,10.94,7.33,10.67z M8.32,19.54c0-0.22,0.09-0.42,0.28-0.6c0.18-0.18,0.39-0.28,0.6-0.28c0.26,0,0.46,0.09,0.62,0.27 s0.24,0.38,0.24,0.61c0,0.27-0.08,0.49-0.23,0.65c-0.15,0.16-0.36,0.23-0.63,0.23c-0.23,0-0.44-0.08-0.61-0.24 C8.4,20.01,8.32,19.8,8.32,19.54z M9.74,13.61c0-0.23,0.07-0.44,0.22-0.61c0.15-0.18,0.33-0.27,0.54-0.27 c0.26,0,0.48,0.09,0.64,0.27c0.16,0.18,0.24,0.38,0.24,0.61c0,0.27-0.08,0.49-0.23,0.65c-0.16,0.16-0.37,0.23-0.65,0.23 c-0.23,0-0.41-0.08-0.55-0.24S9.74,13.88,9.74,13.61z M10.73,19.54c0-0.23,0.08-0.44,0.24-0.61s0.38-0.27,0.64-0.27h3.83l0.88,0.88 c0,0.26-0.09,0.47-0.27,0.64s-0.38,0.24-0.61,0.24h-3.83c-0.27,0-0.49-0.08-0.65-0.24S10.73,19.81,10.73,19.54z M12.05,13.61 c0-0.22,0.09-0.42,0.28-0.6c0.18-0.18,0.39-0.28,0.6-0.28h3.83c0.26,0,0.47,0.09,0.63,0.27c0.16,0.18,0.24,0.38,0.24,0.61 c0,0.27-0.08,0.49-0.23,0.65c-0.16,0.16-0.37,0.23-0.64,0.23h-3.83c-0.23,0-0.44-0.08-0.61-0.24 C12.14,14.09,12.05,13.88,12.05,13.61z M12.81,10.67c0-0.22,0.08-0.41,0.24-0.55c0.16-0.14,0.37-0.22,0.64-0.22h5.71 c0.23,0,0.43,0.08,0.61,0.23c0.18,0.15,0.27,0.33,0.27,0.54c0,0.26-0.09,0.48-0.27,0.64c-0.18,0.16-0.38,0.24-0.61,0.24h-5.71 c-0.27,0-0.49-0.08-0.65-0.24C12.88,11.15,12.81,10.94,12.81,10.67z M15.44,16.58c0-0.21,0.09-0.4,0.27-0.55 c0.18-0.15,0.38-0.23,0.61-0.23s0.43,0.08,0.61,0.23c0.18,0.15,0.27,0.34,0.27,0.55c0,0.26-0.09,0.47-0.27,0.63 c-0.18,0.16-0.38,0.24-0.61,0.24c-0.23,0-0.44-0.08-0.61-0.24C15.53,17.06,15.44,16.85,15.44,16.58z M16.98,19.54 c0-0.23,0.08-0.44,0.24-0.61c0.16-0.18,0.37-0.27,0.63-0.27h1.87c0.26,0,0.47,0.09,0.63,0.26c0.16,0.17,0.24,0.38,0.24,0.62 c0,0.27-0.08,0.49-0.23,0.65c-0.15,0.16-0.37,0.23-0.64,0.23h-1.87c-0.27,0-0.48-0.08-0.64-0.23 C17.06,20.03,16.98,19.81,16.98,19.54z M17.85,16.58c0-0.21,0.09-0.4,0.27-0.55c0.18-0.15,0.38-0.23,0.61-0.23h3.07 c0.22,0,0.4,0.08,0.54,0.23c0.14,0.15,0.22,0.33,0.22,0.55c0,0.27-0.07,0.48-0.21,0.64c-0.14,0.16-0.32,0.23-0.55,0.23h-3.07 c-0.23,0-0.44-0.08-0.61-0.24C17.94,17.06,17.85,16.85,17.85,16.58z M18.29,13.61c0-0.22,0.09-0.42,0.28-0.6 c0.18-0.18,0.39-0.28,0.6-0.28h1.96c0.21,0,0.39,0.09,0.54,0.27c0.15,0.18,0.23,0.38,0.23,0.61c0,0.27-0.07,0.48-0.22,0.64 c-0.14,0.16-0.33,0.24-0.55,0.24h-1.96c-0.23,0-0.44-0.08-0.61-0.24C18.38,14.09,18.29,13.88,18.29,13.61z M21.03,10.67 c0-0.22,0.07-0.4,0.22-0.55C21.4,9.97,21.58,9.9,21.8,9.9c0.27,0,0.48,0.07,0.64,0.22c0.16,0.14,0.24,0.33,0.24,0.55 c0,0.27-0.08,0.48-0.24,0.64c-0.16,0.16-0.37,0.24-0.64,0.24c-0.23,0-0.41-0.08-0.55-0.24C21.1,11.15,21.03,10.94,21.03,10.67z"
        })
    });
};
var $67b54afe16cc9453$var$$cb12c9594bbf6bb4$export$2e2bcd8739ae039 = $67b54afe16cc9453$var$$cb12c9594bbf6bb4$var$DustIcon;
const $67b54afe16cc9453$var$$718b047b0c60e4b6$var$FogIcon = ({ className: className, color: color })=>{
    return (0, $179ad052de55b86f$exports.jsx)("svg", {
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        x: "0px",
        y: "0px",
        viewBox: "0 0 30 30",
        className: className || "rf-h-16 rf-w-16",
        xmlSpace: "preserve",
        fill: color || "#1999B1",
        children: (0, $179ad052de55b86f$exports.jsx)("path", {
            d: "M2.62,21.05c0-0.24,0.08-0.45,0.25-0.61c0.17-0.16,0.38-0.24,0.63-0.24h18.67c0.25,0,0.45,0.08,0.61,0.24 c0.16,0.16,0.24,0.36,0.24,0.61c0,0.23-0.08,0.43-0.25,0.58c-0.17,0.16-0.37,0.23-0.6,0.23H3.5c-0.25,0-0.46-0.08-0.63-0.23 C2.7,21.47,2.62,21.28,2.62,21.05z M5.24,17.91c0-0.24,0.09-0.44,0.26-0.6c0.15-0.15,0.35-0.23,0.59-0.23h18.67 c0.23,0,0.42,0.08,0.58,0.24c0.16,0.16,0.23,0.35,0.23,0.59c0,0.24-0.08,0.44-0.23,0.6c-0.16,0.17-0.35,0.25-0.58,0.25H6.09 c-0.24,0-0.44-0.08-0.6-0.25C5.32,18.34,5.24,18.14,5.24,17.91z M5.37,15.52c0,0.09,0.05,0.13,0.15,0.13h1.43 c0.06,0,0.13-0.05,0.2-0.16c0.24-0.52,0.59-0.94,1.06-1.27c0.47-0.33,0.99-0.52,1.55-0.56l0.55-0.07c0.11,0,0.17-0.06,0.17-0.18 l0.07-0.5c0.11-1.08,0.56-1.98,1.37-2.7c0.81-0.72,1.76-1.08,2.85-1.08c1.08,0,2.02,0.36,2.83,1.07c0.8,0.71,1.26,1.61,1.37,2.68 l0.08,0.57c0,0.11,0.07,0.17,0.2,0.17h1.59c0.64,0,1.23,0.17,1.76,0.52s0.92,0.8,1.18,1.37c0.07,0.11,0.14,0.16,0.21,0.16h1.43 c0.12,0,0.17-0.07,0.14-0.23c-0.29-1.02-0.88-1.86-1.74-2.51c-0.87-0.65-1.86-0.97-2.97-0.97h-0.32c-0.33-1.33-1.03-2.42-2.1-3.27 s-2.28-1.27-3.65-1.27c-1.4,0-2.64,0.44-3.73,1.32s-1.78,2-2.09,3.36c-0.85,0.2-1.6,0.6-2.24,1.21c-0.64,0.61-1.09,1.33-1.34,2.18 v-0.04C5.37,15.45,5.37,15.48,5.37,15.52z M6.98,24.11c0-0.24,0.09-0.43,0.26-0.59c0.15-0.15,0.35-0.23,0.6-0.23h18.68 c0.24,0,0.44,0.08,0.6,0.23c0.17,0.16,0.25,0.35,0.25,0.58c0,0.24-0.08,0.44-0.25,0.61c-0.17,0.17-0.37,0.25-0.6,0.25H7.84 c-0.23,0-0.43-0.09-0.6-0.26C7.07,24.55,6.98,24.34,6.98,24.11z"
        })
    });
};
var $67b54afe16cc9453$var$$718b047b0c60e4b6$export$2e2bcd8739ae039 = $67b54afe16cc9453$var$$718b047b0c60e4b6$var$FogIcon;
const $67b54afe16cc9453$var$$4659807d943ee20a$var$HeavyRainIcon = ({ className: className, color: color })=>{
    return (0, $179ad052de55b86f$exports.jsx)("svg", {
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        x: "0px",
        y: "0px",
        viewBox: "0 0 30 30",
        className: className || "rf-h-16 rf-w-16",
        xmlSpace: "preserve",
        fill: color || "#1999B1",
        children: (0, $179ad052de55b86f$exports.jsx)("path", {
            d: "M4.64,16.91c0-1.15,0.36-2.17,1.08-3.07c0.72-0.9,1.63-1.47,2.73-1.73c0.31-1.36,1.02-2.48,2.11-3.36s2.34-1.31,3.75-1.31 c1.38,0,2.6,0.43,3.68,1.28c1.08,0.85,1.78,1.95,2.1,3.29h0.32c0.89,0,1.72,0.22,2.48,0.65s1.37,1.03,1.81,1.78 c0.44,0.75,0.67,1.58,0.67,2.47c0,0.88-0.21,1.69-0.63,2.44c-0.42,0.75-1,1.35-1.73,1.8c-0.73,0.45-1.53,0.69-2.4,0.71 c-0.13,0-0.2-0.06-0.2-0.17v-1.33c0-0.12,0.07-0.18,0.2-0.18c0.85-0.04,1.58-0.38,2.18-1.02s0.9-1.39,0.9-2.26s-0.33-1.62-0.98-2.26 s-1.42-0.96-2.31-0.96h-1.61c-0.12,0-0.18-0.06-0.18-0.17l-0.08-0.58c-0.11-1.08-0.58-1.99-1.39-2.71 c-0.82-0.73-1.76-1.09-2.85-1.09c-1.09,0-2.05,0.36-2.85,1.09c-0.81,0.73-1.26,1.63-1.36,2.71l-0.07,0.53c0,0.12-0.07,0.19-0.2,0.19 l-0.53,0.03c-0.83,0.1-1.53,0.46-2.1,1.07s-0.85,1.33-0.85,2.16c0,0.87,0.3,1.62,0.9,2.26s1.33,0.98,2.18,1.02 c0.11,0,0.17,0.06,0.17,0.18v1.33c0,0.11-0.06,0.17-0.17,0.17c-1.34-0.06-2.47-0.57-3.4-1.53S4.64,18.24,4.64,16.91z M9.99,23.6 c0-0.04,0.01-0.11,0.04-0.2l1.63-5.77c0.06-0.19,0.17-0.34,0.32-0.44c0.15-0.1,0.31-0.15,0.46-0.15c0.07,0,0.15,0.01,0.24,0.03 c0.24,0.04,0.42,0.17,0.54,0.37c0.12,0.2,0.15,0.42,0.08,0.67l-1.63,5.73c-0.12,0.43-0.4,0.64-0.82,0.64 c-0.04,0-0.07-0.01-0.11-0.02c-0.06-0.02-0.09-0.03-0.1-0.03c-0.22-0.06-0.38-0.17-0.49-0.33C10.04,23.93,9.99,23.77,9.99,23.6z M12.61,26.41l2.44-8.77c0.04-0.19,0.14-0.34,0.3-0.44c0.16-0.1,0.32-0.15,0.49-0.15c0.09,0,0.18,0.01,0.27,0.03 c0.22,0.06,0.38,0.19,0.49,0.39c0.11,0.2,0.13,0.41,0.07,0.64l-2.43,8.78c-0.04,0.17-0.13,0.31-0.29,0.43 c-0.16,0.12-0.32,0.18-0.51,0.18c-0.09,0-0.18-0.02-0.25-0.05c-0.2-0.05-0.37-0.18-0.52-0.39C12.56,26.88,12.54,26.67,12.61,26.41z M16.74,23.62c0-0.04,0.01-0.11,0.04-0.23l1.63-5.77c0.06-0.19,0.16-0.34,0.3-0.44c0.15-0.1,0.3-0.15,0.46-0.15 c0.08,0,0.17,0.01,0.26,0.03c0.21,0.06,0.36,0.16,0.46,0.31c0.1,0.15,0.15,0.31,0.15,0.47c0,0.03-0.01,0.08-0.02,0.14 s-0.02,0.1-0.02,0.12l-1.63,5.73c-0.04,0.19-0.13,0.35-0.28,0.46s-0.32,0.17-0.51,0.17l-0.24-0.05c-0.2-0.06-0.35-0.16-0.46-0.32 C16.79,23.94,16.74,23.78,16.74,23.62z"
        })
    });
};
var $67b54afe16cc9453$var$$4659807d943ee20a$export$2e2bcd8739ae039 = $67b54afe16cc9453$var$$4659807d943ee20a$var$HeavyRainIcon;
const $67b54afe16cc9453$var$$6fb07283996728c7$var$HeavySnowIcon = ({ className: className, color: color })=>{
    return (0, $179ad052de55b86f$exports.jsx)("svg", {
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        x: "0px",
        y: "0px",
        viewBox: "0 0 30 30",
        className: className || "rf-h-16 rf-w-16",
        xmlSpace: "preserve",
        fill: color || "#1999B1",
        children: (0, $179ad052de55b86f$exports.jsx)("path", {
            d: "M4.64,16.95c0-1.16,0.35-2.18,1.06-3.08s1.62-1.48,2.74-1.76c0.31-1.36,1.01-2.48,2.1-3.36s2.34-1.31,3.75-1.31 c1.38,0,2.6,0.43,3.68,1.28c1.08,0.85,1.78,1.95,2.1,3.29h0.32c0.89,0,1.72,0.22,2.48,0.66c0.76,0.44,1.37,1.04,1.81,1.8 c0.44,0.76,0.67,1.59,0.67,2.48c0,1.32-0.46,2.47-1.39,3.42c-0.92,0.96-2.05,1.46-3.38,1.5c-0.13,0-0.2-0.06-0.2-0.17v-1.33 c0-0.12,0.07-0.18,0.2-0.18c0.85-0.04,1.58-0.38,2.18-1.02s0.9-1.38,0.9-2.23c0-0.89-0.32-1.65-0.97-2.3s-1.42-0.97-2.32-0.97h-1.61 c-0.12,0-0.18-0.06-0.18-0.17l-0.08-0.58c-0.11-1.08-0.58-1.99-1.39-2.72c-0.82-0.73-1.76-1.1-2.85-1.1c-1.1,0-2.05,0.37-2.86,1.11 c-0.81,0.74-1.27,1.65-1.37,2.75l-0.06,0.5c0,0.12-0.07,0.19-0.2,0.19l-0.53,0.07c-0.83,0.07-1.53,0.41-2.1,1.04 s-0.85,1.35-0.85,2.19c0,0.85,0.3,1.59,0.9,2.23s1.33,0.97,2.18,1.02c0.11,0,0.17,0.06,0.17,0.18v1.33c0,0.11-0.06,0.17-0.17,0.17 c-1.34-0.04-2.47-0.54-3.4-1.5C5.1,19.42,4.64,18.27,4.64,16.95z M10.14,24.65c0-0.23,0.08-0.43,0.25-0.6 c0.16-0.15,0.35-0.23,0.57-0.23c0.23,0,0.43,0.08,0.59,0.23s0.24,0.35,0.24,0.59c0,0.24-0.08,0.43-0.24,0.59 c-0.16,0.16-0.35,0.23-0.59,0.23c-0.23,0-0.43-0.08-0.59-0.23C10.22,25.08,10.14,24.88,10.14,24.65z M11,21.02 c0-0.22,0.08-0.42,0.24-0.58c0.16-0.16,0.35-0.24,0.59-0.24c0.23,0,0.43,0.08,0.59,0.24c0.16,0.16,0.24,0.36,0.24,0.58 c0,0.24-0.08,0.44-0.24,0.6c-0.16,0.17-0.35,0.25-0.59,0.25c-0.23,0-0.43-0.08-0.59-0.25C11.08,21.46,11,21.26,11,21.02z M12.9,26.61c0-0.23,0.08-0.43,0.25-0.61c0.16-0.16,0.35-0.24,0.57-0.24c0.24,0,0.44,0.08,0.61,0.25c0.17,0.17,0.25,0.37,0.25,0.6 s-0.08,0.43-0.25,0.59c-0.17,0.16-0.37,0.24-0.61,0.24c-0.23,0-0.42-0.08-0.58-0.24C12.99,27.03,12.9,26.84,12.9,26.61z M13.77,22.95c0-0.24,0.08-0.44,0.24-0.62c0.16-0.16,0.36-0.24,0.58-0.24c0.23,0,0.43,0.08,0.6,0.25c0.17,0.17,0.25,0.37,0.25,0.61 c0,0.23-0.08,0.43-0.25,0.6s-0.37,0.25-0.6,0.25c-0.23,0-0.42-0.08-0.58-0.25C13.85,23.38,13.77,23.18,13.77,22.95z M14.19,19.33 c0-0.23,0.08-0.43,0.25-0.6c0.18-0.16,0.37-0.24,0.57-0.24c0.24,0,0.44,0.08,0.61,0.25c0.17,0.17,0.25,0.36,0.25,0.6 c0,0.23-0.08,0.43-0.25,0.59c-0.17,0.16-0.37,0.24-0.61,0.24c-0.23,0-0.42-0.08-0.58-0.24C14.27,19.76,14.19,19.56,14.19,19.33z M16.56,24.65c0-0.23,0.08-0.43,0.24-0.6c0.16-0.15,0.36-0.23,0.6-0.23c0.24,0,0.43,0.08,0.59,0.23c0.16,0.16,0.23,0.35,0.23,0.59 c0,0.24-0.08,0.43-0.23,0.59c-0.16,0.16-0.35,0.23-0.59,0.23c-0.24,0-0.44-0.08-0.6-0.24C16.64,25.07,16.56,24.88,16.56,24.65z M17.41,21.02c0-0.22,0.08-0.41,0.25-0.58c0.17-0.17,0.37-0.25,0.6-0.25c0.23,0,0.43,0.08,0.59,0.24c0.16,0.16,0.24,0.36,0.24,0.58 c0,0.24-0.08,0.44-0.24,0.6c-0.16,0.17-0.35,0.25-0.59,0.25c-0.24,0-0.44-0.08-0.6-0.25C17.5,21.45,17.41,21.25,17.41,21.02z"
        })
    });
};
var $67b54afe16cc9453$var$$6fb07283996728c7$export$2e2bcd8739ae039 = $67b54afe16cc9453$var$$6fb07283996728c7$var$HeavySnowIcon;
const $67b54afe16cc9453$var$$01d90ce62fe7f810$var$HeavyWindIcon = ({ className: className, color: color })=>{
    return (0, $179ad052de55b86f$exports.jsx)("svg", {
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        x: "0px",
        y: "0px",
        viewBox: "0 0 30 30",
        className: className || "rf-h-16 rf-w-16",
        xmlSpace: "preserve",
        fill: color || "#1999B1",
        children: (0, $179ad052de55b86f$exports.jsx)("path", {
            d: "M3.1,16.97c0,0.24,0.09,0.45,0.28,0.62c0.16,0.19,0.37,0.28,0.63,0.28H18.7c0.29,0,0.53,0.1,0.73,0.3 c0.2,0.2,0.3,0.45,0.3,0.74c0,0.29-0.1,0.53-0.3,0.72c-0.2,0.19-0.44,0.29-0.74,0.29c-0.29,0-0.54-0.1-0.73-0.29 c-0.16-0.18-0.36-0.26-0.6-0.26c-0.25,0-0.46,0.09-0.64,0.26s-0.27,0.38-0.27,0.61c0,0.25,0.09,0.46,0.28,0.63 c0.56,0.55,1.22,0.83,1.96,0.83c0.78,0,1.45-0.27,2.01-0.81c0.56-0.54,0.83-1.19,0.83-1.97s-0.28-1.44-0.84-2 c-0.56-0.56-1.23-0.84-2-0.84H4.01c-0.25,0-0.46,0.09-0.64,0.26C3.19,16.51,3.1,16.72,3.1,16.97z M3.1,13.69 c0,0.23,0.09,0.43,0.28,0.61c0.17,0.18,0.38,0.26,0.63,0.26h20.04c0.78,0,1.45-0.27,2.01-0.82c0.56-0.54,0.84-1.2,0.84-1.97 c0-0.77-0.28-1.44-0.84-1.99s-1.23-0.83-2.01-0.83c-0.77,0-1.42,0.27-1.95,0.8c-0.18,0.16-0.27,0.38-0.27,0.67 c0,0.26,0.09,0.47,0.26,0.63c0.17,0.16,0.38,0.24,0.63,0.24c0.24,0,0.45-0.08,0.63-0.24c0.19-0.21,0.42-0.31,0.7-0.31 c0.29,0,0.53,0.1,0.73,0.3c0.2,0.2,0.3,0.44,0.3,0.73c0,0.29-0.1,0.53-0.3,0.72c-0.2,0.19-0.44,0.29-0.73,0.29H4.01 c-0.25,0-0.46,0.09-0.64,0.26C3.19,13.23,3.1,13.44,3.1,13.69z"
        })
    });
};
var $67b54afe16cc9453$var$$01d90ce62fe7f810$export$2e2bcd8739ae039 = $67b54afe16cc9453$var$$01d90ce62fe7f810$var$HeavyWindIcon;
const $67b54afe16cc9453$var$$3bc16b70d32ea3e4$var$LowRainIcon = ({ className: className, color: color })=>{
    return (0, $179ad052de55b86f$exports.jsx)("svg", {
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        x: "0px",
        y: "0px",
        viewBox: "0 0 30 30",
        className: className || "rf-h-16 rf-w-16",
        xmlSpace: "preserve",
        fill: color || "#1999B1",
        children: (0, $179ad052de55b86f$exports.jsx)("path", {
            d: "M4.64,16.91c0-1.15,0.36-2.17,1.08-3.07c0.72-0.9,1.63-1.47,2.73-1.73c0.31-1.36,1.01-2.48,2.1-3.35s2.35-1.31,3.76-1.31 c1.38,0,2.6,0.43,3.68,1.27c1.07,0.85,1.78,1.94,2.11,3.28h0.31c0.89,0,1.72,0.22,2.48,0.65s1.37,1.03,1.81,1.78 c0.44,0.75,0.67,1.58,0.67,2.47c0,1.34-0.46,2.49-1.38,3.45s-2.05,1.47-3.38,1.51c-0.13,0-0.2-0.06-0.2-0.17v-1.33 c0-0.12,0.07-0.18,0.2-0.18c0.86-0.04,1.58-0.38,2.18-1.02s0.9-1.39,0.9-2.26s-0.32-1.62-0.98-2.26c-0.65-0.64-1.42-0.96-2.31-0.96 h-1.6c-0.12,0-0.19-0.06-0.19-0.17l-0.07-0.58c-0.11-1.07-0.57-1.98-1.38-2.71c-0.82-0.73-1.77-1.1-2.85-1.1 c-1.09,0-2.05,0.36-2.86,1.09c-0.81,0.73-1.27,1.63-1.38,2.71l-0.06,0.54c0,0.12-0.07,0.18-0.2,0.18l-0.53,0.03 c-0.82,0.04-1.51,0.37-2.09,1s-0.86,1.37-0.86,2.22c0,0.87,0.3,1.62,0.9,2.26s1.33,0.98,2.18,1.02c0.11,0,0.17,0.06,0.17,0.18v1.33 c0,0.11-0.06,0.17-0.17,0.17c-1.34-0.06-2.47-0.57-3.4-1.53S4.64,18.24,4.64,16.91z M10.57,17.79c0-0.24,0.12-0.57,0.37-0.99 c0.24-0.42,0.47-0.75,0.68-1.01c0.21-0.24,0.34-0.38,0.38-0.42l0.36,0.4c0.26,0.28,0.5,0.61,0.72,1.02c0.22,0.4,0.33,0.74,0.33,1 c0,0.39-0.13,0.72-0.4,0.98c-0.27,0.26-0.6,0.39-1,0.39c-0.39,0-0.73-0.13-1.01-0.4C10.71,18.5,10.57,18.17,10.57,17.79z M13.55,21.78c0-0.28,0.08-0.59,0.24-0.96s0.35-0.7,0.59-1.02c0.18-0.26,0.4-0.54,0.67-0.84c0.26-0.3,0.46-0.52,0.6-0.65 c0.07-0.06,0.15-0.14,0.24-0.23l0.24,0.23c0.38,0.33,0.8,0.82,1.27,1.46c0.24,0.33,0.43,0.68,0.59,1.04s0.23,0.68,0.23,0.97 c0,0.64-0.23,1.19-0.68,1.65s-1.01,0.68-1.66,0.68c-0.64,0-1.19-0.23-1.65-0.67C13.77,22.98,13.55,22.43,13.55,21.78z M15.02,15.12 c0-0.42,0.32-0.95,0.97-1.6l0.24,0.25c0.18,0.21,0.33,0.45,0.48,0.71c0.14,0.26,0.22,0.47,0.22,0.64c0,0.26-0.09,0.48-0.28,0.66 c-0.18,0.18-0.4,0.28-0.66,0.28c-0.27,0-0.5-0.09-0.69-0.28C15.11,15.6,15.02,15.38,15.02,15.12z"
        })
    });
};
var $67b54afe16cc9453$var$$3bc16b70d32ea3e4$export$2e2bcd8739ae039 = $67b54afe16cc9453$var$$3bc16b70d32ea3e4$var$LowRainIcon;
const $67b54afe16cc9453$var$$a27f237fa4d0560c$var$LowSnowIcon = ({ className: className, color: color })=>{
    return (0, $179ad052de55b86f$exports.jsx)("svg", {
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        x: "0px",
        y: "0px",
        viewBox: "0 0 30 30",
        className: className || "rf-h-16 rf-w-16",
        xmlSpace: "preserve",
        fill: color || "#1999B1",
        children: (0, $179ad052de55b86f$exports.jsx)("path", {
            d: "M7.46,14.41c0-0.19,0.07-0.36,0.2-0.5c0.13-0.14,0.29-0.21,0.48-0.21c0.19,0,0.36,0.07,0.49,0.21c0.13,0.14,0.2,0.3,0.2,0.5 c0,0.19-0.07,0.35-0.2,0.48c-0.13,0.13-0.3,0.2-0.48,0.2s-0.35-0.07-0.48-0.2C7.52,14.75,7.46,14.59,7.46,14.41z M9.44,14.41 c0-0.19,0.07-0.36,0.2-0.5c0.13-0.14,0.29-0.21,0.48-0.21h3.23l-2.28-2.28c-0.14-0.12-0.21-0.28-0.21-0.47 c0-0.19,0.07-0.35,0.21-0.49c0.14-0.14,0.3-0.21,0.49-0.21s0.35,0.07,0.49,0.21l2.27,2.27V9.52c0-0.19,0.07-0.36,0.21-0.5 s0.3-0.21,0.5-0.21c0.19,0,0.35,0.07,0.48,0.21c0.13,0.14,0.2,0.3,0.2,0.5v3.23l2.29-2.3c0.14-0.14,0.3-0.21,0.48-0.21 c0.18,0,0.35,0.07,0.49,0.21c0.12,0.14,0.18,0.3,0.18,0.49c0,0.19-0.06,0.35-0.18,0.47l-2.28,2.28h3.23c0.18,0,0.34,0.07,0.47,0.21 c0.13,0.14,0.2,0.3,0.2,0.5c0,0.18-0.07,0.34-0.2,0.47c-0.13,0.13-0.29,0.2-0.47,0.2h-3.23l2.29,2.29c0.12,0.12,0.18,0.28,0.18,0.47 s-0.06,0.35-0.18,0.49c-0.14,0.14-0.31,0.21-0.49,0.21c-0.18,0-0.35-0.07-0.48-0.21l-2.29-2.3v3.24c0,0.19-0.07,0.36-0.2,0.49 c-0.13,0.13-0.29,0.2-0.48,0.2c-0.19,0-0.36-0.07-0.5-0.2c-0.14-0.13-0.21-0.3-0.21-0.49v-3.22l-2.27,2.27 c-0.14,0.14-0.3,0.21-0.49,0.21s-0.35-0.07-0.49-0.21s-0.21-0.3-0.21-0.49s0.07-0.34,0.21-0.47l2.3-2.29h-3.24 c-0.19,0-0.35-0.07-0.48-0.2C9.5,14.75,9.44,14.59,9.44,14.41z M9.45,19.25c0-0.18,0.07-0.35,0.21-0.48 c0.12-0.14,0.28-0.21,0.47-0.21c0.19,0,0.35,0.07,0.49,0.21c0.14,0.14,0.21,0.3,0.21,0.48c0,0.18-0.07,0.35-0.21,0.48 c-0.14,0.14-0.3,0.21-0.49,0.21c-0.19,0-0.35-0.07-0.47-0.21C9.52,19.6,9.45,19.44,9.45,19.25z M9.45,9.54 c0-0.18,0.07-0.35,0.21-0.48c0.12-0.14,0.28-0.21,0.47-0.21c0.19,0,0.35,0.07,0.49,0.21c0.14,0.14,0.21,0.3,0.21,0.48 s-0.07,0.35-0.21,0.49c-0.14,0.14-0.3,0.21-0.49,0.21c-0.19,0-0.35-0.07-0.47-0.21C9.52,9.89,9.45,9.72,9.45,9.54z M14.3,21.25 c0-0.18,0.07-0.34,0.21-0.47c0.14-0.13,0.3-0.2,0.5-0.2c0.19,0,0.35,0.07,0.48,0.2c0.13,0.13,0.2,0.29,0.2,0.47 c0,0.19-0.07,0.36-0.2,0.49c-0.13,0.13-0.29,0.2-0.48,0.2c-0.19,0-0.36-0.07-0.5-0.2C14.37,21.61,14.3,21.45,14.3,21.25z M14.3,7.54 c0-0.19,0.07-0.36,0.21-0.49s0.3-0.2,0.5-0.2c0.19,0,0.35,0.07,0.48,0.2c0.13,0.13,0.2,0.3,0.2,0.49c0,0.18-0.07,0.34-0.2,0.47 c-0.13,0.13-0.29,0.2-0.48,0.2c-0.19,0-0.36-0.07-0.5-0.2C14.37,7.88,14.3,7.72,14.3,7.54z M19.17,19.25c0-0.18,0.07-0.35,0.21-0.48 c0.12-0.14,0.28-0.21,0.47-0.21c0.19,0,0.35,0.07,0.49,0.21c0.14,0.14,0.21,0.3,0.21,0.48c0,0.18-0.07,0.35-0.21,0.48 c-0.14,0.14-0.3,0.21-0.49,0.21c-0.19,0-0.35-0.07-0.47-0.21C19.24,19.6,19.17,19.44,19.17,19.25z M19.17,9.54 c0-0.18,0.07-0.35,0.21-0.48c0.12-0.14,0.28-0.21,0.47-0.21c0.19,0,0.35,0.07,0.49,0.21c0.14,0.14,0.21,0.3,0.21,0.48 s-0.07,0.35-0.21,0.49c-0.14,0.14-0.3,0.21-0.49,0.21c-0.19,0-0.35-0.07-0.47-0.21C19.24,9.89,19.17,9.72,19.17,9.54z M21.17,14.41 c0-0.19,0.07-0.36,0.2-0.5c0.13-0.14,0.3-0.21,0.49-0.21c0.18,0,0.34,0.07,0.47,0.21c0.13,0.14,0.2,0.3,0.2,0.5 c0,0.18-0.07,0.34-0.2,0.47c-0.13,0.13-0.29,0.2-0.47,0.2c-0.19,0-0.36-0.07-0.49-0.2C21.24,14.75,21.17,14.59,21.17,14.41z"
        })
    });
};
var $67b54afe16cc9453$var$$a27f237fa4d0560c$export$2e2bcd8739ae039 = $67b54afe16cc9453$var$$a27f237fa4d0560c$var$LowSnowIcon;
const $67b54afe16cc9453$var$$122feba17c252c93$var$MediumRainIcon = ({ className: className, color: color })=>{
    return (0, $179ad052de55b86f$exports.jsx)("svg", {
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        x: "0px",
        y: "0px",
        viewBox: "0 0 30 30",
        className: className || "rf-h-16 rf-w-16",
        xmlSpace: "preserve",
        fill: color || "#1999B1",
        children: (0, $179ad052de55b86f$exports.jsx)("path", {
            d: "M4.6,16.93c0-1.16,0.36-2.18,1.09-3.08c0.72-0.9,1.65-1.48,2.78-1.73c0.29-1.38,0.98-2.5,2.07-3.39S12.88,7.4,14.3,7.4 c1.39,0,2.63,0.43,3.72,1.28c1.08,0.85,1.79,1.95,2.12,3.3h0.34c0.9,0,1.73,0.22,2.48,0.66c0.76,0.44,1.35,1.04,1.79,1.8 c0.43,0.76,0.65,1.59,0.65,2.49c0,1.34-0.46,2.48-1.37,3.44c-0.92,0.96-2.04,1.46-3.37,1.5c-0.12,0-0.18-0.06-0.18-0.17v-1.34 c0-0.11,0.06-0.17,0.18-0.17c0.84-0.07,1.57-0.42,2.17-1.05s0.9-1.37,0.9-2.22c0-0.89-0.32-1.66-0.96-2.31 c-0.64-0.64-1.4-0.97-2.29-0.97h-1.63c-0.12,0-0.19-0.06-0.22-0.18l-0.07-0.57c-0.07-0.71-0.3-1.36-0.7-1.94s-0.91-1.03-1.53-1.36 c-0.62-0.33-1.3-0.49-2.02-0.49c-1.1,0-2.05,0.36-2.86,1.09c-0.81,0.73-1.27,1.64-1.37,2.72l-0.07,0.54c0,0.09-0.05,0.14-0.16,0.14 L9.31,13.7c-0.84,0.07-1.55,0.41-2.11,1.03c-0.57,0.62-0.85,1.35-0.85,2.2c0,0.87,0.3,1.62,0.89,2.25c0.59,0.63,1.31,0.97,2.17,1.02 c0.12,0,0.18,0.06,0.18,0.17v1.34c0,0.11-0.06,0.17-0.18,0.17c-0.66-0.03-1.28-0.18-1.88-0.45S6.42,20.8,6,20.36 c-0.43-0.44-0.77-0.95-1.02-1.55S4.6,17.59,4.6,16.93z M10.02,23.7c0-0.03,0.01-0.08,0.02-0.13s0.02-0.09,0.02-0.11l0.27-1.03 c0.07-0.22,0.2-0.4,0.4-0.51c0.2-0.12,0.41-0.14,0.64-0.07c0.23,0.07,0.4,0.2,0.52,0.4c0.12,0.2,0.14,0.41,0.07,0.64l-0.24,1.01 c-0.13,0.44-0.38,0.66-0.76,0.66c-0.03,0-0.05,0-0.09,0c-0.03,0-0.07-0.01-0.11-0.01c-0.04-0.01-0.07-0.01-0.1-0.01 c-0.21-0.06-0.37-0.18-0.48-0.34S10.02,23.86,10.02,23.7z M11.34,18.88c0-0.02,0-0.06,0.01-0.11c0.01-0.05,0.01-0.08,0.01-0.09 l0.3-1.05c0.06-0.19,0.17-0.34,0.32-0.45c0.15-0.1,0.31-0.15,0.47-0.15c0.02,0,0.05,0,0.08,0c0.03,0,0.06,0.01,0.09,0.01 c0.03,0.01,0.06,0.01,0.08,0.01c0.23,0.07,0.4,0.2,0.51,0.4c0.12,0.2,0.14,0.41,0.07,0.64l-0.24,1c-0.07,0.28-0.2,0.47-0.4,0.59 s-0.42,0.12-0.65,0.02c-0.22-0.06-0.38-0.17-0.49-0.34S11.34,19.04,11.34,18.88z M12.57,26.83c0-0.03,0.01-0.07,0.02-0.13 s0.02-0.09,0.02-0.12l0.29-0.99c0.06-0.24,0.2-0.42,0.4-0.54c0.2-0.12,0.42-0.15,0.65-0.08c0.23,0.07,0.39,0.2,0.51,0.41 s0.13,0.42,0.07,0.65l-0.25,1.04c-0.11,0.41-0.37,0.61-0.8,0.61c-0.05,0-0.13-0.01-0.24-0.04c-0.22-0.04-0.38-0.14-0.49-0.3 C12.63,27.18,12.57,27.01,12.57,26.83z M13.91,22.06c0-0.06,0.01-0.14,0.04-0.25l0.27-1.03c0.07-0.23,0.2-0.4,0.41-0.51 c0.2-0.12,0.42-0.14,0.65-0.07c0.23,0.06,0.39,0.19,0.51,0.39c0.11,0.2,0.13,0.41,0.06,0.65l-0.24,0.99 c-0.13,0.45-0.37,0.68-0.72,0.68c-0.04,0-0.15-0.02-0.31-0.06c-0.22-0.04-0.38-0.14-0.49-0.3C13.97,22.4,13.91,22.23,13.91,22.06z M16.73,23.74c0-0.07,0.01-0.15,0.03-0.24l0.28-0.99c0.07-0.24,0.2-0.42,0.41-0.54s0.41-0.15,0.63-0.09 c0.23,0.07,0.41,0.2,0.53,0.41c0.12,0.2,0.15,0.41,0.09,0.63l-0.29,1.06c-0.1,0.41-0.36,0.61-0.79,0.61c-0.09,0-0.18-0.01-0.26-0.03 c-0.2-0.04-0.35-0.14-0.46-0.3C16.8,24.08,16.74,23.91,16.73,23.74z M18.11,18.98c0-0.03,0.02-0.12,0.05-0.26l0.3-1.03 c0.04-0.21,0.13-0.37,0.29-0.47c0.16-0.1,0.32-0.15,0.49-0.14c0.04-0.01,0.13,0,0.24,0.03c0.22,0.05,0.39,0.18,0.52,0.38 c0.12,0.17,0.14,0.38,0.07,0.65l-0.24,1.03c-0.13,0.43-0.38,0.65-0.76,0.65c-0.06,0-0.17-0.02-0.34-0.06 c-0.21-0.06-0.36-0.17-0.46-0.31C18.16,19.29,18.11,19.14,18.11,18.98z"
        })
    });
};
var $67b54afe16cc9453$var$$122feba17c252c93$export$2e2bcd8739ae039 = $67b54afe16cc9453$var$$122feba17c252c93$var$MediumRainIcon;
const $67b54afe16cc9453$var$$15b1561596c9c9ef$var$MediumSnowIcon = ({ className: className, color: color })=>{
    return (0, $179ad052de55b86f$exports.jsx)("svg", {
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        x: "0px",
        y: "0px",
        viewBox: "0 0 30 30",
        className: className || "rf-h-16 rf-w-16",
        xmlSpace: "preserve",
        fill: color || "#1999B1",
        children: (0, $179ad052de55b86f$exports.jsx)("path", {
            d: "M4.64,16.95c0-1.16,0.35-2.18,1.06-3.08s1.62-1.48,2.74-1.76c0.31-1.36,1.01-2.48,2.1-3.36s2.34-1.31,3.75-1.31 c1.38,0,2.6,0.43,3.68,1.28c1.08,0.85,1.78,1.95,2.1,3.29h0.32c0.89,0,1.72,0.22,2.48,0.66c0.76,0.44,1.37,1.04,1.81,1.8 c0.44,0.76,0.67,1.59,0.67,2.48c0,1.32-0.46,2.47-1.39,3.42c-0.92,0.96-2.05,1.46-3.38,1.5c-0.13,0-0.2-0.06-0.2-0.17v-1.33 c0-0.12,0.07-0.18,0.2-0.18c0.85-0.04,1.58-0.38,2.18-1.02s0.9-1.38,0.9-2.23c0-0.89-0.32-1.65-0.97-2.3s-1.42-0.97-2.32-0.97h-1.61 c-0.12,0-0.18-0.06-0.18-0.17l-0.08-0.58c-0.11-1.08-0.58-1.99-1.39-2.72c-0.82-0.73-1.76-1.1-2.85-1.1c-1.1,0-2.05,0.37-2.86,1.11 c-0.81,0.74-1.27,1.65-1.37,2.75l-0.06,0.5c0,0.12-0.07,0.19-0.2,0.19l-0.53,0.07c-0.83,0.07-1.53,0.41-2.1,1.04 s-0.85,1.35-0.85,2.19c0,0.85,0.3,1.59,0.9,2.23s1.33,0.97,2.18,1.02c0.11,0,0.17,0.06,0.17,0.18v1.33c0,0.11-0.06,0.17-0.17,0.17 c-1.34-0.04-2.47-0.54-3.4-1.5C5.1,19.42,4.64,18.27,4.64,16.95z M11,21.02c0-0.22,0.08-0.42,0.24-0.58 c0.16-0.16,0.35-0.24,0.59-0.24c0.23,0,0.43,0.08,0.59,0.24c0.16,0.16,0.24,0.36,0.24,0.58c0,0.24-0.08,0.44-0.24,0.6 c-0.16,0.17-0.35,0.25-0.59,0.25c-0.23,0-0.43-0.08-0.59-0.25C11.08,21.46,11,21.26,11,21.02z M11,24.65c0-0.24,0.08-0.44,0.24-0.6 c0.16-0.15,0.35-0.23,0.58-0.23c0.23,0,0.43,0.08,0.59,0.23c0.16,0.16,0.24,0.35,0.24,0.59c0,0.24-0.08,0.43-0.24,0.59 c-0.16,0.16-0.35,0.23-0.59,0.23c-0.23,0-0.43-0.08-0.59-0.23C11.08,25.08,11,24.88,11,24.65z M14.19,22.95 c0-0.23,0.08-0.44,0.25-0.62c0.16-0.16,0.35-0.24,0.57-0.24c0.23,0,0.43,0.09,0.6,0.26c0.17,0.17,0.26,0.37,0.26,0.6 c0,0.23-0.08,0.43-0.25,0.6c-0.17,0.17-0.37,0.25-0.61,0.25c-0.23,0-0.42-0.08-0.58-0.25S14.19,23.18,14.19,22.95z M14.19,19.33 c0-0.23,0.08-0.43,0.25-0.6c0.18-0.16,0.37-0.24,0.57-0.24c0.24,0,0.44,0.08,0.61,0.25c0.17,0.17,0.25,0.36,0.25,0.6 c0,0.23-0.08,0.43-0.25,0.59c-0.17,0.16-0.37,0.24-0.61,0.24c-0.23,0-0.42-0.08-0.58-0.24C14.27,19.76,14.19,19.56,14.19,19.33z M14.19,26.61c0-0.23,0.08-0.43,0.25-0.61c0.16-0.16,0.35-0.24,0.57-0.24c0.24,0,0.44,0.08,0.61,0.25c0.17,0.17,0.25,0.37,0.25,0.6 s-0.08,0.43-0.25,0.59c-0.17,0.16-0.37,0.24-0.61,0.24c-0.23,0-0.42-0.08-0.58-0.24C14.27,27.03,14.19,26.84,14.19,26.61z M17.41,21.02c0-0.22,0.08-0.41,0.25-0.58c0.17-0.17,0.37-0.25,0.6-0.25c0.23,0,0.43,0.08,0.59,0.24c0.16,0.16,0.24,0.36,0.24,0.58 c0,0.24-0.08,0.44-0.24,0.6c-0.16,0.17-0.35,0.25-0.59,0.25c-0.24,0-0.44-0.08-0.6-0.25C17.5,21.45,17.41,21.25,17.41,21.02z M17.41,24.65c0-0.22,0.08-0.42,0.25-0.6c0.16-0.15,0.36-0.23,0.6-0.23c0.24,0,0.43,0.08,0.59,0.23s0.23,0.35,0.23,0.59 c0,0.24-0.08,0.43-0.23,0.59c-0.16,0.16-0.35,0.23-0.59,0.23c-0.24,0-0.44-0.08-0.6-0.24C17.5,25.07,17.41,24.88,17.41,24.65z"
        })
    });
};
var $67b54afe16cc9453$var$$15b1561596c9c9ef$export$2e2bcd8739ae039 = $67b54afe16cc9453$var$$15b1561596c9c9ef$var$MediumSnowIcon;
const $67b54afe16cc9453$var$$db27af05666c8ee5$var$SandStormIcon = ({ className: className, color: color })=>{
    return (0, $179ad052de55b86f$exports.jsx)("svg", {
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        x: "0px",
        y: "0px",
        viewBox: "0 0 30 30",
        className: className || "rf-h-16 rf-w-16",
        xmlSpace: "preserve",
        fill: color || "#1999B1",
        children: (0, $179ad052de55b86f$exports.jsx)("path", {
            d: "M3.1,16.97c0,0.24,0.09,0.45,0.28,0.62c0.16,0.19,0.37,0.28,0.63,0.28H18.7c0.29,0,0.53,0.1,0.73,0.3 c0.2,0.2,0.3,0.45,0.3,0.74c0,0.29-0.1,0.53-0.3,0.72c-0.2,0.19-0.44,0.29-0.74,0.29c-0.29,0-0.54-0.1-0.73-0.29 c-0.16-0.18-0.36-0.26-0.6-0.26c-0.25,0-0.46,0.09-0.64,0.26s-0.27,0.38-0.27,0.61c0,0.25,0.09,0.46,0.28,0.63 c0.56,0.55,1.22,0.83,1.96,0.83c0.78,0,1.45-0.27,2.01-0.81c0.56-0.54,0.83-1.19,0.83-1.97s-0.28-1.44-0.84-2 c-0.56-0.56-1.23-0.84-2-0.84H4.01c-0.25,0-0.46,0.09-0.64,0.26C3.19,16.51,3.1,16.72,3.1,16.97z M3.1,13.69 c0,0.23,0.09,0.43,0.28,0.61c0.17,0.18,0.38,0.26,0.63,0.26h20.04c0.78,0,1.45-0.27,2.01-0.82c0.56-0.54,0.84-1.2,0.84-1.97 c0-0.77-0.28-1.44-0.84-1.99s-1.23-0.83-2.01-0.83c-0.77,0-1.42,0.27-1.95,0.8c-0.18,0.16-0.27,0.38-0.27,0.67 c0,0.26,0.09,0.47,0.26,0.63c0.17,0.16,0.38,0.24,0.63,0.24c0.24,0,0.45-0.08,0.63-0.24c0.19-0.21,0.42-0.31,0.7-0.31 c0.29,0,0.53,0.1,0.73,0.3c0.2,0.2,0.3,0.44,0.3,0.73c0,0.29-0.1,0.53-0.3,0.72c-0.2,0.19-0.44,0.29-0.73,0.29H4.01 c-0.25,0-0.46,0.09-0.64,0.26C3.19,13.23,3.1,13.44,3.1,13.69z M4.67,20.61c0,0.24,0.08,0.43,0.24,0.58 c0.16,0.16,0.36,0.24,0.58,0.24c0.24,0,0.45-0.08,0.62-0.23s0.25-0.35,0.25-0.59c0-0.23-0.09-0.43-0.26-0.6 c-0.17-0.17-0.38-0.25-0.61-0.25c-0.22,0-0.42,0.08-0.58,0.25C4.75,20.18,4.67,20.38,4.67,20.61z M5.62,10.68 c0,0.24,0.08,0.43,0.24,0.58c0.16,0.16,0.36,0.24,0.58,0.24c0.24,0,0.45-0.08,0.61-0.23c0.17-0.16,0.25-0.35,0.25-0.59 c0-0.23-0.08-0.43-0.25-0.6C6.89,9.92,6.68,9.83,6.45,9.83c-0.22,0-0.42,0.08-0.58,0.25C5.7,10.25,5.62,10.45,5.62,10.68z M8.65,8.37c0,0.24,0.08,0.43,0.24,0.58C9.05,9.12,9.25,9.2,9.47,9.2c0.24,0,0.45-0.08,0.62-0.23c0.17-0.16,0.25-0.35,0.25-0.59 c0-0.23-0.09-0.43-0.26-0.6C9.92,7.61,9.71,7.53,9.47,7.53c-0.22,0-0.42,0.08-0.58,0.25C8.73,7.94,8.65,8.14,8.65,8.37z M8.74,19.97 c0,0.23,0.08,0.43,0.25,0.58c0.16,0.16,0.35,0.24,0.57,0.24c0.24,0,0.45-0.08,0.62-0.23c0.17-0.16,0.25-0.35,0.25-0.59 c0-0.23-0.09-0.43-0.26-0.6c-0.17-0.17-0.38-0.25-0.61-0.25c-0.22,0-0.42,0.08-0.58,0.25C8.82,19.54,8.74,19.74,8.74,19.97z M12.92,10.14c0,0.24,0.08,0.43,0.24,0.58c0.16,0.16,0.36,0.24,0.58,0.24c0.24,0,0.45-0.08,0.62-0.23s0.25-0.35,0.25-0.59 c0-0.23-0.09-0.43-0.26-0.6c-0.17-0.17-0.38-0.25-0.61-0.25c-0.23,0-0.42,0.08-0.58,0.25C13,9.71,12.92,9.91,12.92,10.14z M13.24,21.13c0,0.23,0.08,0.42,0.25,0.58c0.16,0.16,0.35,0.24,0.57,0.24c0.24,0,0.45-0.08,0.62-0.23c0.17-0.16,0.25-0.35,0.25-0.59 c0-0.23-0.09-0.43-0.26-0.6c-0.17-0.17-0.38-0.25-0.61-0.25c-0.22,0-0.42,0.08-0.58,0.25S13.24,20.9,13.24,21.13z M17.72,9.98 c0,0.23,0.08,0.42,0.24,0.57c0.17,0.17,0.36,0.25,0.58,0.25c0.24,0,0.45-0.08,0.62-0.23c0.17-0.16,0.25-0.35,0.25-0.59 c0-0.23-0.09-0.43-0.26-0.6c-0.17-0.17-0.38-0.25-0.61-0.25c-0.22,0-0.41,0.08-0.58,0.25C17.81,9.55,17.72,9.75,17.72,9.98z M22.81,17.04c0,0.24,0.08,0.43,0.24,0.58c0.16,0.16,0.36,0.24,0.58,0.24c0.24,0,0.45-0.08,0.61-0.23c0.17-0.16,0.25-0.35,0.25-0.59 c0-0.23-0.08-0.43-0.25-0.6c-0.17-0.17-0.37-0.25-0.61-0.25c-0.23,0-0.42,0.08-0.58,0.25C22.9,16.61,22.81,16.81,22.81,17.04z"
        })
    });
};
var $67b54afe16cc9453$var$$db27af05666c8ee5$export$2e2bcd8739ae039 = $67b54afe16cc9453$var$$db27af05666c8ee5$var$SandStormIcon;
const $67b54afe16cc9453$var$$11e053ad08a316e7$var$SmokeIcon = ({ className: className, color: color })=>{
    return (0, $179ad052de55b86f$exports.jsx)("svg", {
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        x: "0px",
        y: "0px",
        viewBox: "0 0 30 30",
        className: className || "rf-h-16 rf-w-16",
        xmlSpace: "preserve",
        fill: color || "#1999B1",
        children: (0, $179ad052de55b86f$exports.jsx)("path", {
            d: "M6.34,12.48c0-0.94,0.3-1.78,0.89-2.52s1.34-1.21,2.25-1.41C9.73,7.43,10.3,6.5,11.2,5.78s1.92-1.08,3.08-1.08 c1.12,0,2.13,0.35,3.02,1.05c0.89,0.7,1.46,1.6,1.73,2.69h0.27c1.12,0,2.08,0.39,2.88,1.18c0.79,0.78,1.19,1.74,1.19,2.85 c0,0.6-0.12,1.17-0.37,1.7c-0.25,0.53-0.59,0.99-1.03,1.37v0.03c0,0.59-0.19,1.12-0.56,1.59c-0.37,0.47-0.84,0.76-1.4,0.89 c-0.14,0.62-0.45,1.15-0.91,1.58c-0.46,0.43-1.01,0.7-1.63,0.8c0.29,0.34,0.43,0.72,0.43,1.13c0,0.48-0.17,0.89-0.51,1.24 c-0.34,0.34-0.75,0.52-1.23,0.52c-0.48,0-0.89-0.17-1.23-0.52c-0.34-0.34-0.51-0.76-0.51-1.24c0-0.19,0.03-0.38,0.1-0.57h-0.1 c-0.58,0-1.08-0.21-1.5-0.63c-0.42-0.42-0.63-0.92-0.63-1.5c0-0.4,0.1-0.76,0.3-1.07c-0.52-0.29-0.89-0.7-1.12-1.25h-1.28v-0.01 c-1.07-0.07-1.98-0.49-2.73-1.27S6.34,13.56,6.34,12.48z M7.74,12.23c0,0.8,0.28,1.48,0.84,2.04s1.24,0.84,2.03,0.84 c0.49,0,0.95-0.11,1.37-0.34c0.12,0.74,0.47,1.36,1.04,1.86s1.25,0.74,2.02,0.74c0.87,0,1.61-0.31,2.22-0.92 c0.41,0.48,0.92,0.71,1.54,0.71c0.57,0,1.05-0.2,1.46-0.6c0.4-0.4,0.6-0.89,0.6-1.46c0.4-0.27,0.72-0.61,0.95-1.04 c0.23-0.42,0.35-0.88,0.35-1.37c0-0.79-0.28-1.47-0.85-2.02c-0.57-0.55-1.25-0.83-2.05-0.83c-0.56,0-1.07,0.15-1.53,0.44 c0.06-0.24,0.08-0.51,0.08-0.79c0-0.96-0.34-1.78-1.03-2.46c-0.69-0.68-1.52-1.01-2.49-1.01c-0.94,0-1.75,0.33-2.43,0.97 s-1.04,1.44-1.07,2.37c-0.02,0-0.05,0-0.08,0c-0.04,0-0.07,0-0.09,0c-0.79,0-1.46,0.28-2.03,0.84S7.74,11.45,7.74,12.23z"
        })
    });
};
var $67b54afe16cc9453$var$$11e053ad08a316e7$export$2e2bcd8739ae039 = $67b54afe16cc9453$var$$11e053ad08a316e7$var$SmokeIcon;
const $67b54afe16cc9453$var$$976a2f524e1d121b$var$SunIcon = ({ className: className, color: color })=>{
    return (0, $179ad052de55b86f$exports.jsx)("svg", {
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        x: "0px",
        y: "0px",
        viewBox: "0 0 30 30",
        className: className || "rf-h-16 rf-w-16",
        xmlSpace: "preserve",
        fill: color || "#1999B1",
        children: (0, $179ad052de55b86f$exports.jsx)("path", {
            d: "M4.37,14.62c0-0.24,0.08-0.45,0.25-0.62c0.17-0.16,0.38-0.24,0.6-0.24h2.04c0.23,0,0.42,0.08,0.58,0.25 c0.15,0.17,0.23,0.37,0.23,0.61S8,15.06,7.85,15.23c-0.15,0.17-0.35,0.25-0.58,0.25H5.23c-0.23,0-0.43-0.08-0.6-0.25 C4.46,15.06,4.37,14.86,4.37,14.62z M7.23,21.55c0-0.23,0.08-0.43,0.23-0.61l1.47-1.43c0.15-0.16,0.35-0.23,0.59-0.23 c0.24,0,0.44,0.08,0.6,0.23s0.24,0.34,0.24,0.57c0,0.24-0.08,0.46-0.24,0.64L8.7,22.14c-0.41,0.32-0.82,0.32-1.23,0 C7.31,21.98,7.23,21.78,7.23,21.55z M7.23,7.71c0-0.23,0.08-0.43,0.23-0.61C7.66,6.93,7.87,6.85,8.1,6.85 c0.22,0,0.42,0.08,0.59,0.24l1.43,1.47c0.16,0.15,0.24,0.35,0.24,0.59c0,0.24-0.08,0.44-0.24,0.6s-0.36,0.24-0.6,0.24 c-0.24,0-0.44-0.08-0.59-0.24L7.47,8.32C7.31,8.16,7.23,7.95,7.23,7.71z M9.78,14.62c0-0.93,0.23-1.8,0.7-2.6s1.1-1.44,1.91-1.91 s1.67-0.7,2.6-0.7c0.7,0,1.37,0.14,2.02,0.42c0.64,0.28,1.2,0.65,1.66,1.12c0.47,0.47,0.84,1.02,1.11,1.66 c0.27,0.64,0.41,1.32,0.41,2.02c0,0.94-0.23,1.81-0.7,2.61c-0.47,0.8-1.1,1.43-1.9,1.9c-0.8,0.47-1.67,0.7-2.61,0.7 s-1.81-0.23-2.61-0.7c-0.8-0.47-1.43-1.1-1.9-1.9C10.02,16.43,9.78,15.56,9.78,14.62z M11.48,14.62c0,0.98,0.34,1.81,1.03,2.5 c0.68,0.69,1.51,1.04,2.49,1.04s1.81-0.35,2.5-1.04s1.04-1.52,1.04-2.5c0-0.96-0.35-1.78-1.04-2.47c-0.69-0.68-1.52-1.02-2.5-1.02 c-0.97,0-1.8,0.34-2.48,1.02C11.82,12.84,11.48,13.66,11.48,14.62z M14.14,22.4c0-0.24,0.08-0.44,0.25-0.6s0.37-0.24,0.6-0.24 c0.24,0,0.45,0.08,0.61,0.24s0.24,0.36,0.24,0.6v1.99c0,0.24-0.08,0.45-0.25,0.62c-0.17,0.17-0.37,0.25-0.6,0.25 s-0.44-0.08-0.6-0.25c-0.17-0.17-0.25-0.38-0.25-0.62V22.4z M14.14,6.9V4.86c0-0.23,0.08-0.43,0.25-0.6C14.56,4.09,14.76,4,15,4 s0.43,0.08,0.6,0.25c0.17,0.17,0.25,0.37,0.25,0.6V6.9c0,0.23-0.08,0.42-0.25,0.58S15.23,7.71,15,7.71s-0.44-0.08-0.6-0.23 S14.14,7.13,14.14,6.9z M19.66,20.08c0-0.23,0.08-0.42,0.23-0.56c0.15-0.16,0.34-0.23,0.56-0.23c0.24,0,0.44,0.08,0.6,0.23 l1.46,1.43c0.16,0.17,0.24,0.38,0.24,0.61c0,0.23-0.08,0.43-0.24,0.59c-0.4,0.31-0.8,0.31-1.2,0l-1.42-1.42 C19.74,20.55,19.66,20.34,19.66,20.08z M19.66,9.16c0-0.25,0.08-0.45,0.23-0.59l1.42-1.47c0.17-0.16,0.37-0.24,0.59-0.24 c0.24,0,0.44,0.08,0.6,0.25c0.17,0.17,0.25,0.37,0.25,0.6c0,0.25-0.08,0.46-0.24,0.62l-1.46,1.43c-0.18,0.16-0.38,0.24-0.6,0.24 c-0.23,0-0.41-0.08-0.56-0.24S19.66,9.4,19.66,9.16z M21.92,14.62c0-0.24,0.08-0.44,0.24-0.62c0.16-0.16,0.35-0.24,0.57-0.24h2.02 c0.23,0,0.43,0.09,0.6,0.26c0.17,0.17,0.26,0.37,0.26,0.6s-0.09,0.43-0.26,0.6c-0.17,0.17-0.37,0.25-0.6,0.25h-2.02 c-0.23,0-0.43-0.08-0.58-0.25S21.92,14.86,21.92,14.62z"
        })
    });
};
var $67b54afe16cc9453$var$$976a2f524e1d121b$export$2e2bcd8739ae039 = $67b54afe16cc9453$var$$976a2f524e1d121b$var$SunIcon;
const $67b54afe16cc9453$var$$947eb44583326c5d$var$SunCloudIcon = ({ className: className, color: color })=>{
    return (0, $179ad052de55b86f$exports.jsx)("svg", {
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        x: "0px",
        y: "0px",
        viewBox: "0 0 30 30",
        className: className || "rf-h-16 rf-w-16",
        xmlSpace: "preserve",
        fill: color || "#1999B1",
        children: (0, $179ad052de55b86f$exports.jsx)("path", {
            d: "M1.56,16.9c0,0.9,0.22,1.73,0.66,2.49s1.04,1.36,1.8,1.8c0.76,0.44,1.58,0.66,2.47,0.66h10.83c0.89,0,1.72-0.22,2.48-0.66 c0.76-0.44,1.37-1.04,1.81-1.8c0.44-0.76,0.67-1.59,0.67-2.49c0-0.66-0.14-1.33-0.42-2C22.62,13.98,23,12.87,23,11.6 c0-0.71-0.14-1.39-0.41-2.04c-0.27-0.65-0.65-1.2-1.12-1.67C21,7.42,20.45,7.04,19.8,6.77c-0.65-0.28-1.33-0.41-2.04-0.41 c-1.48,0-2.77,0.58-3.88,1.74c-0.77-0.44-1.67-0.66-2.7-0.66c-1.41,0-2.65,0.44-3.73,1.31c-1.08,0.87-1.78,1.99-2.08,3.35 c-1.12,0.26-2.03,0.83-2.74,1.73S1.56,15.75,1.56,16.9z M3.27,16.9c0-0.84,0.28-1.56,0.84-2.17c0.56-0.61,1.26-0.96,2.1-1.06 l0.5-0.03c0.12,0,0.19-0.06,0.19-0.18l0.07-0.54c0.14-1.08,0.61-1.99,1.41-2.71c0.8-0.73,1.74-1.09,2.81-1.09 c1.1,0,2.06,0.37,2.87,1.1c0.82,0.73,1.27,1.63,1.37,2.71l0.07,0.58c0.02,0.11,0.09,0.17,0.21,0.17h1.61c0.88,0,1.64,0.32,2.28,0.96 c0.64,0.64,0.96,1.39,0.96,2.27c0,0.91-0.32,1.68-0.95,2.32c-0.63,0.64-1.4,0.96-2.28,0.96H6.49c-0.88,0-1.63-0.32-2.27-0.97 C3.59,18.57,3.27,17.8,3.27,16.9z M9.97,4.63c0,0.24,0.08,0.45,0.24,0.63l0.66,0.64c0.25,0.19,0.46,0.27,0.64,0.25 c0.21,0,0.39-0.09,0.55-0.26s0.24-0.38,0.24-0.62c0-0.24-0.09-0.44-0.26-0.59l-0.59-0.66c-0.18-0.16-0.38-0.24-0.61-0.24 c-0.24,0-0.45,0.08-0.62,0.25C10.05,4.19,9.97,4.39,9.97,4.63z M15.31,9.06c0.69-0.67,1.51-1,2.45-1c0.99,0,1.83,0.34,2.52,1.03 c0.69,0.69,1.04,1.52,1.04,2.51c0,0.62-0.17,1.24-0.51,1.84C19.84,12.48,18.68,12,17.32,12H17C16.75,10.91,16.19,9.93,15.31,9.06z M16.94,3.78c0,0.26,0.08,0.46,0.23,0.62s0.35,0.23,0.59,0.23c0.26,0,0.46-0.08,0.62-0.23c0.16-0.16,0.23-0.36,0.23-0.62V1.73 c0-0.24-0.08-0.43-0.24-0.59s-0.36-0.23-0.61-0.23c-0.24,0-0.43,0.08-0.59,0.23s-0.23,0.35-0.23,0.59V3.78z M22.46,6.07 c0,0.26,0.07,0.46,0.22,0.62c0.21,0.16,0.42,0.24,0.62,0.24c0.18,0,0.38-0.08,0.59-0.24l1.43-1.43c0.16-0.18,0.24-0.39,0.24-0.64 c0-0.24-0.08-0.44-0.24-0.6c-0.16-0.16-0.36-0.24-0.59-0.24c-0.24,0-0.43,0.08-0.58,0.24l-1.47,1.43 C22.53,5.64,22.46,5.84,22.46,6.07z M23.25,17.91c0,0.24,0.08,0.45,0.25,0.63l0.65,0.63c0.15,0.16,0.34,0.24,0.58,0.24 s0.44-0.08,0.6-0.25c0.16-0.17,0.24-0.37,0.24-0.62c0-0.22-0.08-0.42-0.24-0.58l-0.65-0.65c-0.16-0.16-0.35-0.24-0.57-0.24 c-0.24,0-0.44,0.08-0.6,0.24C23.34,17.47,23.25,17.67,23.25,17.91z M24.72,11.6c0,0.23,0.09,0.42,0.26,0.58 c0.16,0.16,0.37,0.24,0.61,0.24h2.04c0.23,0,0.42-0.08,0.58-0.23s0.23-0.35,0.23-0.59c0-0.24-0.08-0.44-0.23-0.6 s-0.35-0.25-0.58-0.25h-2.04c-0.24,0-0.44,0.08-0.61,0.25C24.8,11.17,24.72,11.37,24.72,11.6z"
        })
    });
};
var $67b54afe16cc9453$var$$947eb44583326c5d$export$2e2bcd8739ae039 = $67b54afe16cc9453$var$$947eb44583326c5d$var$SunCloudIcon;
const $67b54afe16cc9453$var$$76289450d1bd9fde$var$ThunderIcon = ({ className: className, color: color })=>{
    return (0, $179ad052de55b86f$exports.jsx)("svg", {
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        x: "0px",
        y: "0px",
        viewBox: "0 0 30 30",
        className: className || "rf-h-16 rf-w-16",
        xmlSpace: "preserve",
        fill: color || "#1999B1",
        children: (0, $179ad052de55b86f$exports.jsx)("path", {
            d: "M7.96,24.51h0.39l6.88-10.18c0.09-0.18,0.04-0.27-0.15-0.27h-2.84l2.99-5.45c0.09-0.18,0.02-0.27-0.2-0.27h-3.81 c-0.11,0-0.2,0.06-0.29,0.18l-2.78,7.4c-0.02,0.18,0.04,0.27,0.19,0.27h2.75L7.96,24.51z M16.46,18.18h0.27l5.22-7.67 c0.05-0.08,0.06-0.15,0.04-0.2s-0.08-0.07-0.17-0.07h-2.1l2.18-4.03c0.12-0.2,0.06-0.3-0.18-0.3h-2.74c-0.13,0-0.23,0.06-0.3,0.19 l-2.08,5.48c-0.03,0.09-0.03,0.16,0.01,0.21c0.04,0.05,0.1,0.07,0.19,0.07h2.04L16.46,18.18z"
        })
    });
};
var $67b54afe16cc9453$var$$76289450d1bd9fde$export$2e2bcd8739ae039 = $67b54afe16cc9453$var$$76289450d1bd9fde$var$ThunderIcon;
const $67b54afe16cc9453$var$$8ca1468a3164388d$var$ThunderStormIcon = ({ className: className, color: color })=>{
    return (0, $179ad052de55b86f$exports.jsx)("svg", {
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        x: "0px",
        y: "0px",
        viewBox: "0 0 30 30",
        className: className || "rf-h-16 rf-w-16",
        xmlSpace: "preserve",
        fill: color || "#1999B1",
        children: (0, $179ad052de55b86f$exports.jsx)("path", {
            d: "M4.63,16.91c0,1.11,0.33,2.1,0.99,2.97s1.52,1.47,2.58,1.79l-0.66,1.68c-0.03,0.14,0.02,0.22,0.14,0.22h2.13l-0.98,4.3h0.28 l3.92-5.75c0.04-0.04,0.04-0.09,0.01-0.14c-0.03-0.05-0.08-0.07-0.15-0.07h-2.18l2.48-4.64c0.07-0.14,0.02-0.22-0.14-0.22h-2.94 c-0.09,0-0.17,0.05-0.23,0.15l-1.07,2.87c-0.71-0.18-1.3-0.57-1.77-1.16c-0.47-0.59-0.7-1.26-0.7-2.01c0-0.83,0.28-1.55,0.85-2.17 c0.57-0.61,1.27-0.97,2.1-1.07l0.53-0.07c0.13,0,0.2-0.06,0.2-0.18l0.07-0.51c0.11-1.08,0.56-1.99,1.37-2.72 c0.81-0.73,1.76-1.1,2.85-1.1c1.09,0,2.04,0.37,2.85,1.1c0.82,0.73,1.28,1.64,1.4,2.72l0.07,0.58c0,0.11,0.06,0.17,0.18,0.17h1.6 c0.91,0,1.68,0.32,2.32,0.95c0.64,0.63,0.97,1.4,0.97,2.28c0,0.85-0.3,1.59-0.89,2.21c-0.59,0.62-1.33,0.97-2.2,1.04 c-0.13,0-0.2,0.06-0.2,0.18v1.37c0,0.11,0.07,0.17,0.2,0.17c1.33-0.04,2.46-0.55,3.39-1.51s1.39-2.11,1.39-3.45 c0-0.9-0.22-1.73-0.67-2.49c-0.44-0.76-1.05-1.36-1.81-1.8c-0.77-0.44-1.6-0.66-2.5-0.66H20.1c-0.33-1.33-1.04-2.42-2.11-3.26 s-2.3-1.27-3.68-1.27c-1.41,0-2.67,0.44-3.76,1.31s-1.79,1.99-2.1,3.36c-1.11,0.26-2.02,0.83-2.74,1.73S4.63,15.76,4.63,16.91z M12.77,26.62c0,0.39,0.19,0.65,0.58,0.77c0.01,0,0.05,0,0.11,0.01c0.06,0.01,0.11,0.01,0.14,0.01c0.17,0,0.33-0.05,0.49-0.15 c0.16-0.1,0.27-0.26,0.32-0.48l2.25-8.69c0.06-0.24,0.04-0.45-0.07-0.65c-0.11-0.19-0.27-0.32-0.5-0.39 c-0.17-0.02-0.26-0.03-0.26-0.03c-0.16,0-0.32,0.05-0.47,0.15c-0.15,0.1-0.26,0.25-0.31,0.45l-2.26,8.72 C12.78,26.44,12.77,26.53,12.77,26.62z M16.93,23.56c0,0.13,0.03,0.26,0.1,0.38c0.14,0.22,0.31,0.37,0.51,0.44 c0.11,0.03,0.21,0.05,0.3,0.05s0.2-0.02,0.32-0.08c0.21-0.09,0.35-0.28,0.42-0.57l1.44-5.67c0.03-0.14,0.05-0.23,0.05-0.27 c0-0.15-0.05-0.3-0.16-0.45s-0.26-0.26-0.46-0.32c-0.17-0.02-0.26-0.03-0.26-0.03c-0.17,0-0.33,0.05-0.47,0.15 c-0.14,0.1-0.24,0.25-0.3,0.45l-1.46,5.7c0,0.02,0,0.05-0.01,0.11C16.93,23.5,16.93,23.53,16.93,23.56z"
        })
    });
};
var $67b54afe16cc9453$var$$8ca1468a3164388d$export$2e2bcd8739ae039 = $67b54afe16cc9453$var$$8ca1468a3164388d$var$ThunderStormIcon;
const $67b54afe16cc9453$var$$32016b29b994233a$var$ThunderStormShowerIcon = ({ className: className, color: color })=>{
    return (0, $179ad052de55b86f$exports.jsx)("svg", {
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        x: "0px",
        y: "0px",
        viewBox: "0 0 30 30",
        className: className || "rf-h-16 rf-w-16",
        xmlSpace: "preserve",
        fill: color || "#1999B1",
        children: (0, $179ad052de55b86f$exports.jsx)("path", {
            d: "M4.63,16.91c0,1.11,0.33,2.1,0.99,2.97s1.51,1.47,2.56,1.79l-0.65,1.68c-0.03,0.14,0.02,0.22,0.14,0.22h2.13l-1.04,3.78 h0.28l3.97-5.22c0.04-0.04,0.04-0.09,0.02-0.14s-0.07-0.07-0.14-0.07h-2.18l2.48-4.64c0.06-0.14,0.02-0.21-0.14-0.21h-2.94 c-0.09,0-0.17,0.05-0.22,0.14L8.8,20.08c-0.71-0.18-1.3-0.57-1.77-1.16c-0.47-0.59-0.7-1.26-0.7-2.01c0-0.83,0.28-1.55,0.84-2.16 s1.26-0.96,2.1-1.06l0.52-0.07c0.13,0,0.2-0.06,0.2-0.17l0.07-0.52c0.1-1.08,0.55-1.99,1.36-2.72c0.81-0.73,1.76-1.1,2.85-1.1 c1.09,0,2.04,0.37,2.85,1.1c0.82,0.73,1.28,1.64,1.4,2.72l0.06,0.58c0,0.12,0.06,0.18,0.19,0.18h1.61c0.91,0,1.68,0.32,2.32,0.95 c0.64,0.63,0.96,1.39,0.96,2.28c0,0.85-0.3,1.59-0.89,2.21c-0.59,0.62-1.32,0.96-2.19,1.03c-0.13,0-0.2,0.06-0.2,0.19v1.37 c0,0.11,0.07,0.17,0.2,0.17c0.65-0.02,1.27-0.17,1.86-0.44c0.59-0.27,1.1-0.63,1.52-1.07c0.42-0.44,0.76-0.96,1.01-1.57 c0.25-0.6,0.38-1.23,0.38-1.88c0-0.9-0.22-1.73-0.67-2.49c-0.45-0.76-1.05-1.36-1.81-1.8c-0.76-0.44-1.59-0.66-2.48-0.66h-0.32 c-0.33-1.33-1.03-2.42-2.11-3.26c-1.08-0.84-2.3-1.27-3.68-1.27c-1.41,0-2.67,0.44-3.76,1.31s-1.79,1.99-2.1,3.36 c-1.1,0.26-2.01,0.83-2.73,1.73S4.63,15.76,4.63,16.91z M12.79,26.77c0,0.16,0.05,0.31,0.15,0.46c0.1,0.15,0.26,0.26,0.46,0.32 c0.14,0.03,0.22,0.05,0.25,0.05c0.09,0,0.21-0.03,0.38-0.1c0.21-0.09,0.35-0.27,0.42-0.52l0.28-1.05c0.06-0.22,0.04-0.43-0.08-0.63 s-0.29-0.33-0.53-0.4c-0.22-0.06-0.43-0.04-0.63,0.08c-0.2,0.12-0.34,0.29-0.41,0.53l-0.27,1C12.8,26.68,12.79,26.77,12.79,26.77z M14.13,22c0,0.14,0.05,0.29,0.15,0.44c0.1,0.15,0.25,0.26,0.45,0.33c0.22,0.07,0.44,0.06,0.64-0.05s0.33-0.28,0.4-0.52l0.3-1.04 c0.06-0.22,0.03-0.43-0.08-0.63c-0.12-0.2-0.3-0.34-0.53-0.41c-0.23-0.06-0.44-0.04-0.65,0.08s-0.34,0.29-0.41,0.52l-0.24,1.01 C14.14,21.9,14.13,21.99,14.13,22z M16.95,23.65c0,0.17,0.05,0.34,0.16,0.51c0.11,0.17,0.27,0.28,0.47,0.35 c0.02,0,0.06,0.01,0.12,0.02c0.05,0.01,0.09,0.02,0.12,0.02c0.13,0,0.26-0.02,0.38-0.08c0.19-0.07,0.33-0.26,0.41-0.57l0.25-1.01 c0.07-0.23,0.05-0.45-0.06-0.66c-0.11-0.21-0.28-0.35-0.5-0.42c-0.25-0.06-0.48-0.03-0.68,0.08c-0.2,0.12-0.33,0.3-0.37,0.53 l-0.27,1.03C16.96,23.51,16.95,23.58,16.95,23.65z M18.31,18.86c-0.01,0.16,0.04,0.31,0.15,0.47c0.11,0.16,0.27,0.28,0.49,0.38 c0.08,0.04,0.16,0.06,0.26,0.06c0.11,0,0.22-0.03,0.34-0.08c0.21-0.1,0.35-0.29,0.44-0.57l0.29-1.03c0.02-0.13,0.03-0.2,0.03-0.22 c0-0.17-0.05-0.33-0.16-0.49s-0.27-0.27-0.49-0.33c-0.02,0-0.06-0.01-0.11-0.02C19.49,17,19.45,17,19.42,17 c-0.17,0-0.33,0.05-0.49,0.15c-0.16,0.1-0.27,0.26-0.33,0.48l-0.27,1.01C18.32,18.72,18.31,18.79,18.31,18.86z"
        })
    });
};
var $67b54afe16cc9453$var$$32016b29b994233a$export$2e2bcd8739ae039 = $67b54afe16cc9453$var$$32016b29b994233a$var$ThunderStormShowerIcon;
const $67b54afe16cc9453$var$$2d73a9e5e9c30df9$var$TornadoIcon = ({ className: className, color: color })=>{
    return (0, $179ad052de55b86f$exports.jsx)("svg", {
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        x: "0px",
        y: "0px",
        viewBox: "0 0 30 30",
        className: className || "rf-h-16 rf-w-16",
        xmlSpace: "preserve",
        fill: color || "#1999B1",
        children: (0, $179ad052de55b86f$exports.jsx)("path", {
            d: "M4.13,15.19c0,0.69,0.36,1.28,1.08,1.77c1.32,0.93,3.31,1.39,5.98,1.39c1.2,0,2.31-0.1,3.34-0.31 c1.08-0.23,1.97-0.6,2.65-1.1s1.03-1.08,1.03-1.76c0-0.21-0.04-0.41-0.12-0.62c1.39-0.34,2.48-0.8,3.27-1.38s1.19-1.25,1.19-2 c0-0.19-0.03-0.39-0.09-0.6c2.29-0.81,3.43-1.9,3.43-3.28c0-0.88-0.5-1.66-1.49-2.34c-1.95-1.3-4.81-1.95-8.58-1.95 c-1.78,0-3.39,0.16-4.83,0.47C9.42,3.8,8.16,4.3,7.2,4.98S5.76,6.44,5.76,7.31c0,0.52,0.16,0.99,0.48,1.42 c-1.18,0.67-1.77,1.49-1.77,2.46c0,0.75,0.37,1.41,1.1,1.98C4.61,13.73,4.13,14.4,4.13,15.19z M4.73,19.69 c0,0.73,0.45,1.31,1.35,1.72s2.04,0.62,3.41,0.62c1.39,0,2.53-0.21,3.44-0.62s1.36-0.99,1.36-1.72c0-0.27-0.09-0.5-0.26-0.69 s-0.4-0.28-0.67-0.28c-0.22,0-0.42,0.08-0.6,0.23s-0.29,0.35-0.34,0.57c-0.2,0.16-0.56,0.3-1.1,0.43s-1.15,0.2-1.83,0.2 c-1.1,0-2-0.16-2.68-0.47c0.16-0.16,0.24-0.36,0.26-0.6s-0.04-0.45-0.15-0.62c-0.16-0.21-0.36-0.35-0.61-0.4s-0.48,0-0.7,0.13 C5.02,18.6,4.73,19.09,4.73,19.69z M6.01,15.19c0-0.01,0.06-0.07,0.19-0.18c0.09-0.09,0.28-0.2,0.56-0.34s0.61-0.25,0.96-0.35 l0.12-0.06c1.62,0.54,3.51,0.81,5.67,0.81c0.95,0,1.81-0.05,2.58-0.16l0.26,0.23c-0.09,0.16-0.3,0.32-0.63,0.5 c-0.4,0.21-1.02,0.41-1.86,0.57s-1.73,0.25-2.67,0.25s-1.83-0.08-2.67-0.25s-1.47-0.36-1.88-0.57C6.3,15.5,6.09,15.35,6.01,15.19z M6.12,23.61c0,0.63,0.36,1.12,1.08,1.46s1.61,0.51,2.67,0.51c1.08,0,1.99-0.17,2.72-0.51s1.1-0.83,1.1-1.46 c0-0.25-0.09-0.48-0.28-0.67s-0.41-0.29-0.66-0.29c-0.47,0-0.78,0.24-0.92,0.72c-0.39,0.24-1.04,0.37-1.96,0.37 c-0.8,0-1.44-0.12-1.92-0.37c-0.15-0.48-0.45-0.72-0.92-0.72c-0.25,0-0.47,0.09-0.64,0.28S6.12,23.34,6.12,23.61z M6.33,11.19 c0-0.08,0.05-0.17,0.15-0.28c0.24-0.3,0.72-0.6,1.42-0.88c1.92,1.03,4.56,1.54,7.91,1.54c1.71,0,3.32-0.16,4.82-0.47v0.09 c0,0.15-0.09,0.3-0.28,0.45c-0.41,0.36-1.17,0.7-2.29,1.03c-1.21,0.36-2.73,0.54-4.56,0.54c-1.84,0-3.36-0.18-4.57-0.54 C7.77,12.35,7,12.01,6.61,11.65C6.42,11.5,6.33,11.35,6.33,11.19z M7.63,7.31c0-0.18,0.12-0.37,0.35-0.59 C8.43,6.3,9.33,5.9,10.66,5.51c1.43-0.42,3.14-0.63,5.14-0.63c2.01,0,3.74,0.21,5.19,0.63c1.35,0.39,2.24,0.8,2.68,1.22 c0.22,0.22,0.34,0.42,0.34,0.59s-0.11,0.35-0.34,0.56c-0.44,0.42-1.33,0.83-2.68,1.23c-1.45,0.42-3.17,0.63-5.19,0.63 c-2,0-3.72-0.21-5.14-0.63C9.32,8.71,8.42,8.3,7.98,7.87C7.75,7.66,7.63,7.48,7.63,7.31z"
        })
    });
};
var $67b54afe16cc9453$var$$2d73a9e5e9c30df9$export$2e2bcd8739ae039 = $67b54afe16cc9453$var$$2d73a9e5e9c30df9$var$TornadoIcon;
/**
 * Cf https://www.jodc.go.jp/data_format/weather-code.html for weather codes and their corresponding weathers
 * @param code : number
 */ const $67b54afe16cc9453$var$$1081c1897db35bfa$export$596264e6595ef029 = (code, className)=>{
    if (code === 0) return (0, $179ad052de55b86f$exports.jsx)($67b54afe16cc9453$var$$976a2f524e1d121b$export$2e2bcd8739ae039, {
        className: className
    });
    else if (code < 3) return (0, $179ad052de55b86f$exports.jsx)($67b54afe16cc9453$var$$947eb44583326c5d$export$2e2bcd8739ae039, {
        className: className
    });
    else if (code === 3) return (0, $179ad052de55b86f$exports.jsx)($67b54afe16cc9453$var$$d73edfc5f2fb24d0$export$2e2bcd8739ae039, {
        className: className
    });
    else if (code === 4) return (0, $179ad052de55b86f$exports.jsx)($67b54afe16cc9453$var$$11e053ad08a316e7$export$2e2bcd8739ae039, {
        className: className
    });
    else if (code === 5) return (0, $179ad052de55b86f$exports.jsx)($67b54afe16cc9453$var$$718b047b0c60e4b6$export$2e2bcd8739ae039, {
        className: className
    });
    else if (code < 9) return (0, $179ad052de55b86f$exports.jsx)($67b54afe16cc9453$var$$cb12c9594bbf6bb4$export$2e2bcd8739ae039, {
        className: className
    });
    else if (code === 9) return (0, $179ad052de55b86f$exports.jsx)($67b54afe16cc9453$var$$db27af05666c8ee5$export$2e2bcd8739ae039, {
        className: className
    });
    else if (code < 13) return (0, $179ad052de55b86f$exports.jsx)($67b54afe16cc9453$var$$718b047b0c60e4b6$export$2e2bcd8739ae039, {
        className: className
    });
    else if (code === 13) return (0, $179ad052de55b86f$exports.jsx)($67b54afe16cc9453$var$$76289450d1bd9fde$export$2e2bcd8739ae039, {
        className: className
    });
    else if (code < 17) return (0, $179ad052de55b86f$exports.jsx)($67b54afe16cc9453$var$$3bc16b70d32ea3e4$export$2e2bcd8739ae039, {
        className: className
    });
    else if (code === 17) return (0, $179ad052de55b86f$exports.jsx)($67b54afe16cc9453$var$$8ca1468a3164388d$export$2e2bcd8739ae039, {
        className: className
    });
    else if (code === 18) return (0, $179ad052de55b86f$exports.jsx)($67b54afe16cc9453$var$$01d90ce62fe7f810$export$2e2bcd8739ae039, {
        className: className
    });
    else if (code === 19) return (0, $179ad052de55b86f$exports.jsx)($67b54afe16cc9453$var$$2d73a9e5e9c30df9$export$2e2bcd8739ae039, {
        className: className
    });
    else if (code === 20) return (0, $179ad052de55b86f$exports.jsx)($67b54afe16cc9453$var$$b3a5251415e304a6$export$2e2bcd8739ae039, {
        className: className
    });
    else if (code === 21 || code === 23) return (0, $179ad052de55b86f$exports.jsx)($67b54afe16cc9453$var$$122feba17c252c93$export$2e2bcd8739ae039, {
        className: className
    });
    else if (code === 22 || code === 24) return (0, $179ad052de55b86f$exports.jsx)($67b54afe16cc9453$var$$15b1561596c9c9ef$export$2e2bcd8739ae039, {
        className: className
    });
    else if (code < 28) return (0, $179ad052de55b86f$exports.jsx)($67b54afe16cc9453$var$$4659807d943ee20a$export$2e2bcd8739ae039, {
        className: className
    });
    else if (code === 28) return (0, $179ad052de55b86f$exports.jsx)($67b54afe16cc9453$var$$718b047b0c60e4b6$export$2e2bcd8739ae039, {
        className: className
    });
    else if (code === 29) return (0, $179ad052de55b86f$exports.jsx)($67b54afe16cc9453$var$$8ca1468a3164388d$export$2e2bcd8739ae039, {
        className: className
    });
    else if (code < 36) return (0, $179ad052de55b86f$exports.jsx)($67b54afe16cc9453$var$$db27af05666c8ee5$export$2e2bcd8739ae039, {
        className: className
    });
    else if (code < 40) return (0, $179ad052de55b86f$exports.jsx)($67b54afe16cc9453$var$$6fb07283996728c7$export$2e2bcd8739ae039, {
        className: className
    });
    else if (code < 50) return (0, $179ad052de55b86f$exports.jsx)($67b54afe16cc9453$var$$718b047b0c60e4b6$export$2e2bcd8739ae039, {
        className: className
    });
    else if (code < 60) return (0, $179ad052de55b86f$exports.jsx)($67b54afe16cc9453$var$$b3a5251415e304a6$export$2e2bcd8739ae039, {
        className: className
    });
    else if (code < 62) return (0, $179ad052de55b86f$exports.jsx)($67b54afe16cc9453$var$$3bc16b70d32ea3e4$export$2e2bcd8739ae039, {
        className: className
    });
    else if (code < 64) return (0, $179ad052de55b86f$exports.jsx)($67b54afe16cc9453$var$$122feba17c252c93$export$2e2bcd8739ae039, {
        className: className
    });
    else if (code < 66) return (0, $179ad052de55b86f$exports.jsx)($67b54afe16cc9453$var$$4659807d943ee20a$export$2e2bcd8739ae039, {
        className: className
    });
    else if (code === 66 || code === 68) return (0, $179ad052de55b86f$exports.jsx)($67b54afe16cc9453$var$$3bc16b70d32ea3e4$export$2e2bcd8739ae039, {
        className: className
    });
    else if (code === 67 || code === 69) return (0, $179ad052de55b86f$exports.jsx)($67b54afe16cc9453$var$$122feba17c252c93$export$2e2bcd8739ae039, {
        className: className
    });
    else if (code === 70 || code === 71 || code === 76 || code === 77 || code === 78 || code === 79) return (0, $179ad052de55b86f$exports.jsx)($67b54afe16cc9453$var$$a27f237fa4d0560c$export$2e2bcd8739ae039, {
        className: className
    });
    else if (code === 72 || code === 73) return (0, $179ad052de55b86f$exports.jsx)($67b54afe16cc9453$var$$15b1561596c9c9ef$export$2e2bcd8739ae039, {
        className: className
    });
    else if (code === 74 || code === 75) return (0, $179ad052de55b86f$exports.jsx)($67b54afe16cc9453$var$$6fb07283996728c7$export$2e2bcd8739ae039, {
        className: className
    });
    else if (code < 85) return (0, $179ad052de55b86f$exports.jsx)($67b54afe16cc9453$var$$4659807d943ee20a$export$2e2bcd8739ae039, {
        className: className
    });
    else if (code < 91) return (0, $179ad052de55b86f$exports.jsx)($67b54afe16cc9453$var$$6fb07283996728c7$export$2e2bcd8739ae039, {
        className: className
    });
    else if (code < 93) return (0, $179ad052de55b86f$exports.jsx)($67b54afe16cc9453$var$$122feba17c252c93$export$2e2bcd8739ae039, {
        className: className
    });
    else if (code < 95) return (0, $179ad052de55b86f$exports.jsx)($67b54afe16cc9453$var$$15b1561596c9c9ef$export$2e2bcd8739ae039, {
        className: className
    });
    else return (0, $179ad052de55b86f$exports.jsx)($67b54afe16cc9453$var$$32016b29b994233a$export$2e2bcd8739ae039, {
        className: className
    });
};
const $67b54afe16cc9453$var$$34b1838c227861bb$var$MobileWeather = ({ locale: locale, currentWeather: currentWeather, previsions: previsions })=>{
    return (0, $179ad052de55b86f$exports.jsxs)("div", {
        className: "rf-w-full rf-py-4 rf-flex rf-flex-col rf-items-center rf-overflow-y-scroll rf-scrollbar-hidden",
        children: [
            (0, $179ad052de55b86f$exports.jsx)("div", {
                className: "rf-pb-4 rf-title-large-bold-size-auto",
                children: $67b54afe16cc9453$var$$379dc81df3dc7496$export$d07f57595c356899(new Date().toLocaleDateString(locale, $67b54afe16cc9453$var$$91d4a798329bd0d3$export$7f608b480d9e7085))
            }),
            (0, $179ad052de55b86f$exports.jsx)("div", {
                className: "rf-h-36 rf-w-36",
                children: $67b54afe16cc9453$var$$1081c1897db35bfa$export$596264e6595ef029(currentWeather.weather, "rf-h-full rf-w-full")
            }),
            (0, $179ad052de55b86f$exports.jsx)("div", {
                className: "rf-title-extralarge-size-auto",
                children: `${Math.round(currentWeather.temperature.average || 0)}${currentWeather.temperature.unit}`
            }),
            (0, $179ad052de55b86f$exports.jsx)("div", {
                className: "rf-w-full rf-mt-4 rf-grid rf-grid-cols-3 rf-items-center",
                children: previsions.map((prevision, key)=>{
                    return (0, $179ad052de55b86f$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($eO7Kz))).Fragment, {
                        children: [
                            key !== 0 && (0, $179ad052de55b86f$exports.jsx)("div", {
                                className: "rf-col-span-3 rf-border-t rf-border-t-menuBorder"
                            }),
                            (0, $179ad052de55b86f$exports.jsx)("div", {
                                className: "rf-capitalize rf-font-bold",
                                children: $67b54afe16cc9453$var$$379dc81df3dc7496$export$d07f57595c356899(prevision.day ? new Date(prevision.day).toLocaleString(locale, {
                                    weekday: "long"
                                }) : "NC")
                            }),
                            (0, $179ad052de55b86f$exports.jsx)("div", {
                                className: "rf-py-2 rf-flex rf-justify-center",
                                children: $67b54afe16cc9453$var$$1081c1897db35bfa$export$596264e6595ef029(prevision.weather, "rf-h-12")
                            }),
                            (0, $179ad052de55b86f$exports.jsx)("div", {
                                className: "rf-flex rf-justify-end",
                                children: `${prevision.temperature.min}${prevision.temperature.unit} / ${prevision.temperature.max}${prevision.temperature.unit}`
                            })
                        ]
                    }, key);
                })
            })
        ]
    });
};
var $67b54afe16cc9453$var$$34b1838c227861bb$export$2e2bcd8739ae039 = $67b54afe16cc9453$var$$34b1838c227861bb$var$MobileWeather;
/* eslint-disable react/jsx-boolean-value */ const $67b54afe16cc9453$var$$f7eebfb9f1239f75$var$LargeWeather = ({ locale: locale, currentWeather: currentWeather, previsions: previsions })=>{
    return (0, $179ad052de55b86f$exports.jsxs)("div", {
        className: "rf-w-full rf-height-fill-available rf-flex rf-flex-col rf-justify-between rf-items-center",
        children: [
            (0, $179ad052de55b86f$exports.jsx)("div", {
                className: "rf-pb-4 rf-title-extralarge-bold-size-auto",
                children: $67b54afe16cc9453$var$$379dc81df3dc7496$export$d07f57595c356899(new Date().toLocaleDateString(locale, $67b54afe16cc9453$var$$91d4a798329bd0d3$export$7f608b480d9e7085))
            }),
            (0, $179ad052de55b86f$exports.jsxs)("div", {
                className: "rf-flex rf-flex-col rf-items-center rf-gap-8",
                children: [
                    (0, $179ad052de55b86f$exports.jsx)("div", {
                        className: "rf-h-64 rf-w-64",
                        children: $67b54afe16cc9453$var$$1081c1897db35bfa$export$596264e6595ef029(currentWeather.weather, "rf-h-full rf-w-full")
                    }),
                    (0, $179ad052de55b86f$exports.jsx)("div", {
                        className: "rf-text-7xl",
                        children: `${Math.round(currentWeather.temperature.average || 0)}${currentWeather.temperature.unit}`
                    })
                ]
            }),
            (0, $179ad052de55b86f$exports.jsx)("div", {
                className: "rf-w-full rf-py-4",
                style: {
                    background: "linear-gradient(to left bottom, #F2F3F6, #E5E6EC)"
                },
                children: (0, $179ad052de55b86f$exports.jsx)("div", {
                    className: "rf-w-full rf-grid rf-grid-cols-6 rf-text-size-auto",
                    children: previsions.map((prevision, key)=>{
                        return (0, $179ad052de55b86f$exports.jsxs)("div", {
                            className: `rf-p-4 rf-flex rf-flex-col rf-gap-4 rf-items-center ${key > 0 && "rf-border-l rf-border-l-menuBorder"}`,
                            children: [
                                (0, $179ad052de55b86f$exports.jsx)("div", {
                                    className: "rf-capitalize rf-subtitle-size-auto rf-font-bold",
                                    children: $67b54afe16cc9453$var$$379dc81df3dc7496$export$d07f57595c356899(prevision.day ? new Date(prevision.day).toLocaleDateString(locale, $67b54afe16cc9453$var$$91d4a798329bd0d3$export$7f608b480d9e7085) : "NC")
                                }),
                                $67b54afe16cc9453$var$$1081c1897db35bfa$export$596264e6595ef029(prevision.weather, "rf-h-24"),
                                (0, $179ad052de55b86f$exports.jsxs)("div", {
                                    className: "rf-flex rf-flex-col rf-gap-1 rf-items-center",
                                    children: [
                                        (0, $179ad052de55b86f$exports.jsxs)("div", {
                                            className: "rf-flex rf-flex-row rf-items-center",
                                            children: [
                                                (0, $179ad052de55b86f$exports.jsx)("p", {
                                                    children: "Min."
                                                }),
                                                (0, $179ad052de55b86f$exports.jsxs)("p", {
                                                    className: "rf-font-bold rf-ml-1",
                                                    children: [
                                                        prevision.temperature.min,
                                                        prevision.temperature.unit
                                                    ]
                                                })
                                            ]
                                        }),
                                        (0, $179ad052de55b86f$exports.jsxs)("div", {
                                            className: "rf-flex rf-flex-row rf-items-center",
                                            children: [
                                                (0, $179ad052de55b86f$exports.jsx)("p", {
                                                    children: "Max."
                                                }),
                                                (0, $179ad052de55b86f$exports.jsxs)("p", {
                                                    className: "rf-font-bold rf-ml-1",
                                                    children: [
                                                        prevision.temperature.max,
                                                        prevision.temperature.unit
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }, key);
                    })
                })
            })
        ]
    });
};
var $67b54afe16cc9453$var$$f7eebfb9f1239f75$export$2e2bcd8739ae039 = $67b54afe16cc9453$var$$f7eebfb9f1239f75$var$LargeWeather;
/* eslint-disable react/jsx-boolean-value */ const $67b54afe16cc9453$var$$0d1f91f3dea4626d$var$LargeVerticalWeather = ({ locale: locale, currentWeather: currentWeather, previsions: previsions })=>{
    return (0, $179ad052de55b86f$exports.jsxs)("div", {
        className: "rf-w-full rf-height-fill-available rf-flex rf-flex-col rf-items-center",
        children: [
            (0, $179ad052de55b86f$exports.jsxs)("div", {
                className: "rf-w-full rf-h-1/2 rf-flex rf-flex-col rf-justify-end rf-items-center",
                children: [
                    (0, $179ad052de55b86f$exports.jsx)("div", {
                        className: "rf-pb-4 rf-title-extralarge-bold-size-auto",
                        children: $67b54afe16cc9453$var$$379dc81df3dc7496$export$d07f57595c356899(new Date().toLocaleDateString(locale, $67b54afe16cc9453$var$$91d4a798329bd0d3$export$7f608b480d9e7085))
                    }),
                    (0, $179ad052de55b86f$exports.jsxs)("div", {
                        className: "rf-flex rf-flex-col rf-items-center rf-gap-8",
                        children: [
                            (0, $179ad052de55b86f$exports.jsx)("div", {
                                className: "rf-h-64 rf-w-64",
                                children: $67b54afe16cc9453$var$$1081c1897db35bfa$export$596264e6595ef029(currentWeather.weather, "rf-h-full rf-w-full")
                            }),
                            (0, $179ad052de55b86f$exports.jsx)("div", {
                                className: "rf-text-8xl",
                                children: `${Math.round(currentWeather.temperature.average || 0)}${currentWeather.temperature.unit}`
                            })
                        ]
                    })
                ]
            }),
            (0, $179ad052de55b86f$exports.jsx)("div", {
                className: "rf-w-full rf-h-1/2 rf-pt-24",
                children: (0, $179ad052de55b86f$exports.jsx)("div", {
                    className: "rf-w-full rf-p-6",
                    style: {
                        background: "linear-gradient(to left bottom, #F2F3F6, #E5E6EC)"
                    },
                    children: (0, $179ad052de55b86f$exports.jsx)("div", {
                        className: "rf-w-full rf-grid rf-grid-cols-3 rf-text-size-auto",
                        children: previsions.map((prevision, key)=>{
                            return (0, $179ad052de55b86f$exports.jsxs)("div", {
                                className: `rf-p-6 rf-flex rf-flex-col rf-gap-6 rf-items-center ${key > 0 && "rf-border-l rf-border-l-menuBorder"} ${key === 3 && "rf-border-l-0"} ${key > 2 && "rf-border-t rf-border-t-menuBorder"}`,
                                children: [
                                    (0, $179ad052de55b86f$exports.jsx)("div", {
                                        className: "rf-capitalize rf-subtitle-size-auto rf-font-bold",
                                        children: $67b54afe16cc9453$var$$379dc81df3dc7496$export$d07f57595c356899(prevision.day ? new Date(prevision.day).toLocaleDateString(locale, $67b54afe16cc9453$var$$91d4a798329bd0d3$export$7f608b480d9e7085) : "NC")
                                    }),
                                    $67b54afe16cc9453$var$$1081c1897db35bfa$export$596264e6595ef029(prevision.weather, "rf-h-24"),
                                    (0, $179ad052de55b86f$exports.jsxs)("div", {
                                        className: "rf-flex rf-flex-col rf-gap-1 rf-items-center",
                                        children: [
                                            (0, $179ad052de55b86f$exports.jsxs)("div", {
                                                className: "rf-flex rf-flex-row rf-items-center",
                                                children: [
                                                    (0, $179ad052de55b86f$exports.jsx)("p", {
                                                        children: "Min."
                                                    }),
                                                    (0, $179ad052de55b86f$exports.jsxs)("p", {
                                                        className: "rf-font-bold rf-ml-1",
                                                        children: [
                                                            prevision.temperature.min,
                                                            prevision.temperature.unit
                                                        ]
                                                    })
                                                ]
                                            }),
                                            (0, $179ad052de55b86f$exports.jsxs)("div", {
                                                className: "rf-flex rf-flex-row rf-items-center",
                                                children: [
                                                    (0, $179ad052de55b86f$exports.jsx)("p", {
                                                        children: "Max."
                                                    }),
                                                    (0, $179ad052de55b86f$exports.jsxs)("p", {
                                                        className: "rf-font-bold rf-ml-1",
                                                        children: [
                                                            prevision.temperature.max,
                                                            prevision.temperature.unit
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }, key);
                        })
                    })
                })
            })
        ]
    });
};
var $67b54afe16cc9453$var$$0d1f91f3dea4626d$export$2e2bcd8739ae039 = $67b54afe16cc9453$var$$0d1f91f3dea4626d$var$LargeVerticalWeather;
const $67b54afe16cc9453$var$$c59e3f81c2dfc450$var$Weather = ({ locale: locale, position: position, deviceType: deviceType })=>{
    const [currentWeather, setCurrentWeather] = (0, $eO7Kz.useState)();
    const [previsions, setPrevisions] = (0, $eO7Kz.useState)([]);
    (0, $eO7Kz.useEffect)(()=>{
        const savedWeatherData = localStorage.getItem("Retorik.Weather.Data");
        if (savedWeatherData) {
            const dataFromLocalStorage = JSON.parse(localStorage.getItem("Retorik.Weather.Data") || "null");
            if (dataFromLocalStorage) {
                // Check if the data are more than 1-hour old, if so get new data
                const currentDateTime = Date.now();
                const oldDate = new Date(dataFromLocalStorage.current.time);
                if (currentDateTime - 3600000 > oldDate.getTime()) getWeatherData();
                else {
                    setCurrentWeather(dataFromLocalStorage.current);
                    setPrevisions(dataFromLocalStorage.prevision);
                }
            } else getWeatherData();
        } else getWeatherData();
    }, []);
    /**
   * On call :
   *  - try to get weather data from open-meteo API
   *  - if succeeded, fill currentWeather and previsions states with data
   */ const getWeatherData = async ()=>{
        if (position?.latitude && position?.longitude) {
            const fullWeatherData = await $67b54afe16cc9453$var$$d3351fce476b5d48$export$43a4b902cf54b66d(position);
            if (fullWeatherData) {
                setCurrentWeather(fullWeatherData.current);
                setPrevisions(fullWeatherData.prevision);
            }
        }
    };
    return currentWeather && previsions && previsions.length > 0 ? $67b54afe16cc9453$var$$91d4a798329bd0d3$export$78f16669b353a880.includes(deviceType) ? (0, $179ad052de55b86f$exports.jsx)($67b54afe16cc9453$var$$34b1838c227861bb$export$2e2bcd8739ae039, {
        locale: locale || "fr-FR",
        currentWeather: currentWeather,
        previsions: previsions
    }) : deviceType !== $67b54afe16cc9453$var$$32e24fada5befcfe$export$ec1e04e4e5ef8233.borne ? (0, $179ad052de55b86f$exports.jsx)($67b54afe16cc9453$var$$f7eebfb9f1239f75$export$2e2bcd8739ae039, {
        locale: locale || "fr-FR",
        currentWeather: currentWeather,
        previsions: previsions
    }) : (0, $179ad052de55b86f$exports.jsx)($67b54afe16cc9453$var$$0d1f91f3dea4626d$export$2e2bcd8739ae039, {
        locale: locale || "fr-FR",
        currentWeather: currentWeather,
        previsions: previsions
    }) : (0, $179ad052de55b86f$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eO7Kz))).Fragment, {});
};
var $67b54afe16cc9453$export$e030160b7d850165 = $67b54afe16cc9453$var$$c59e3f81c2dfc450$var$Weather;
const $67b54afe16cc9453$var$$9214d57b8fee8e0a$var$renderWeather = (props, element)=>{
    (0, (/*@__PURE__*/$parcel$interopDefault($kz03S))).render((0, $179ad052de55b86f$exports.jsx)($67b54afe16cc9453$export$e030160b7d850165, {
        ...props
    }), element);
};
var $67b54afe16cc9453$export$6725c38767fd6246 = $67b54afe16cc9453$var$$9214d57b8fee8e0a$var$renderWeather;
var $67b54afe16cc9453$export$2e2bcd8739ae039 = $67b54afe16cc9453$export$e030160b7d850165;
window.Retorik = {
    ...window.Retorik,
    renderWeather: $67b54afe16cc9453$export$6725c38767fd6246
};









var $eO7Kz = parcelRequire("eO7Kz");





var $eO7Kz = parcelRequire("eO7Kz");




const $a50f498eb33ca913$var$iconClassname = "rf-h-8 rf-w-8";
const $a50f498eb33ca913$var$MobileIconAndTitle = ({ subView: subView, className: className })=>{
    const { locale: locale } = (0, $2e4dc8fa28d39601$export$6650dace022cfacc)();
    return /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsxs)("div", {
        className: `large:rf-hidden rf-py-2 rf-flex rf-flex-row rf-items-end ${className}`,
        children: [
            subView === (0, $16ad089b9ce6627d$export$3b4d92ba873f009a).weather ? /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)($d2eed5123295ffb9$export$2e2bcd8739ae039, {
                className: $a50f498eb33ca913$var$iconClassname
            }) : subView === (0, $16ad089b9ce6627d$export$3b4d92ba873f009a).emergency ? /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)($5208182085f9f5ff$export$2e2bcd8739ae039, {
                className: $a50f498eb33ca913$var$iconClassname
            }) : /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eO7Kz))).Fragment, {}),
            /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("div", {
                className: "rf-ml-2 rf-capitalize rf-subtitle-size-auto",
                children: (0, (/*@__PURE__*/$parcel$interopDefault($e2141f1e3ec1b348$exports)))[locale]?.[subView] || (0, (/*@__PURE__*/$parcel$interopDefault($e2141f1e3ec1b348$exports)))["fr-FR"][subView]
            })
        ]
    });
};
var $a50f498eb33ca913$export$2e2bcd8739ae039 = $a50f498eb33ca913$var$MobileIconAndTitle;


const $75829ed0c9da9ea2$var$MobileTopContainer = ({ subView: subView, className: className, handleBack: handleBack })=>{
    const { locale: locale } = (0, $2e4dc8fa28d39601$export$6650dace022cfacc)();
    return /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($eO7Kz))).Fragment, {
        children: [
            /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $53c3829f3df8be22$export$2e2bcd8739ae039), {
                title: (0, (/*@__PURE__*/$parcel$interopDefault($abbebf5de79f9da4$exports)))[locale]?.back || (0, (/*@__PURE__*/$parcel$interopDefault($abbebf5de79f9da4$exports)))["fr-FR"].back,
                className: "rf-text-sm",
                handleBack: handleBack
            }),
            subView && /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $a50f498eb33ca913$export$2e2bcd8739ae039), {
                subView: subView,
                className: className
            })
        ]
    });
};
var $75829ed0c9da9ea2$export$2e2bcd8739ae039 = $75829ed0c9da9ea2$var$MobileTopContainer;




var $eO7Kz = parcelRequire("eO7Kz");




const $13b7ff82c1b30145$var$iconClassname = "rf-h-16 rf-w-16 large-vertical:rf-h-24 large-vertical:rf-w-24";
const $13b7ff82c1b30145$var$LargeIconAndTitle = ({ subView: subView, className: className })=>{
    const { locale: locale } = (0, $2e4dc8fa28d39601$export$6650dace022cfacc)();
    return /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsxs)("div", {
        className: `rf-hidden large:rf-flex rf-w-full rf-pt-4 large-vertical:rf-pt-8 rf-pl-4 large-vertical:rf-pl-0 rf-flex-row rf-justify-start large-vertical:rf-justify-center rf-items-center ${className}`,
        children: [
            subView === (0, $16ad089b9ce6627d$export$3b4d92ba873f009a).weather ? /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)($d2eed5123295ffb9$export$2e2bcd8739ae039, {
                className: $13b7ff82c1b30145$var$iconClassname
            }) : subView === (0, $16ad089b9ce6627d$export$3b4d92ba873f009a).emergency ? /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)($5208182085f9f5ff$export$2e2bcd8739ae039, {
                className: $13b7ff82c1b30145$var$iconClassname
            }) : /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eO7Kz))).Fragment, {}),
            /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("div", {
                className: "rf-ml-2 rf-uppercase rf-text-[#575F6B] rf-subtitle-size-auto",
                children: (0, (/*@__PURE__*/$parcel$interopDefault($e2141f1e3ec1b348$exports)))[locale]?.[subView] || (0, (/*@__PURE__*/$parcel$interopDefault($e2141f1e3ec1b348$exports)))["fr-FR"][subView]
            })
        ]
    });
};
var $13b7ff82c1b30145$export$2e2bcd8739ae039 = $13b7ff82c1b30145$var$LargeIconAndTitle;



const $5e6c500b0ab75272$var$Weather = ({ handleClose: handleClose })=>{
    const { locale: locale } = (0, $2e4dc8fa28d39601$export$6650dace022cfacc)();
    const { configuration: configuration, setCurrentSubView: setCurrentSubView } = (0, $e599569c1fc3ca2c$export$d8760bee47331b1d)();
    const { currentDeviceType: currentDeviceType, isMobile: isMobile } = (0, $8b59a4dbb18c269b$export$3abe3478af3cb63b)();
    /**
   * On call :
   *  - set RetorikContext's displayWeather state to false
   */ const handleBack = ()=>{
        handleClose ? handleClose() : setCurrentSubView((0, $16ad089b9ce6627d$export$f05d0fed0593ead7).none);
    };
    return isMobile ? /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsxs)((0, $47178ad01294ff29$export$2e2bcd8739ae039), {
        depth: (0, $16ad089b9ce6627d$export$950556173b6cbecb).dropdown,
        background: "#FFFFFF",
        children: [
            /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $75829ed0c9da9ea2$export$2e2bcd8739ae039), {
                subView: (0, $16ad089b9ce6627d$export$3b4d92ba873f009a).weather,
                className: "rf-border-b rf-border-b-menuBorder",
                handleBack: handleBack
            }),
            /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $67b54afe16cc9453$export$2e2bcd8739ae039), {
                locale: locale,
                deviceType: currentDeviceType,
                position: {
                    latitude: configuration.position?.latitude || 0,
                    longitude: configuration.position?.longitude || 0
                }
            })
        ]
    }) : /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsxs)((0, $5798dbaf1694ea15$export$2e2bcd8739ae039), {
        depth: (0, $16ad089b9ce6627d$export$950556173b6cbecb).dropdown,
        background: "linear-gradient(to right bottom, #F2F8F8FC , #F2E1E2E8)",
        children: [
            /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsxs)("div", {
                className: "rf-h-full rf-w-full rf-flex rf-flex-col rf-items-center",
                children: [
                    /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $13b7ff82c1b30145$export$2e2bcd8739ae039), {
                        subView: (0, $16ad089b9ce6627d$export$3b4d92ba873f009a).weather
                    }),
                    /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $67b54afe16cc9453$export$2e2bcd8739ae039), {
                        locale: locale,
                        deviceType: currentDeviceType,
                        position: {
                            latitude: configuration.position?.latitude || 0,
                            longitude: configuration.position?.longitude || 0
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $4becae071fdebff0$export$2e2bcd8739ae039), {
                dashboardVisible: true,
                onClick: handleBack
            })
        ]
    });
};
var $5e6c500b0ab75272$export$2e2bcd8739ae039 = $5e6c500b0ab75272$var$Weather;





var $eO7Kz = parcelRequire("eO7Kz");









const $98025ff0c2e14c18$var$CustomView = ({ customView: customView, title: title, icon: icon, externalComponents: externalComponents, display: display, setDisplayCustomComponent: setDisplayCustomComponent })=>{
    const { locale: locale } = (0, $2e4dc8fa28d39601$export$6650dace022cfacc)();
    const { isMobile: isMobile, displayControls: displayControls } = (0, $8b59a4dbb18c269b$export$3abe3478af3cb63b)();
    const { setCurrentSubView: setCurrentSubView } = (0, $e599569c1fc3ca2c$export$d8760bee47331b1d)();
    /* const [componentToDisplay, setComponentToDisplay] = useState<JSX.Element>(
    <></>
  ) */ const handleBack = ()=>{
        setCurrentSubView((0, $16ad089b9ce6627d$export$f05d0fed0593ead7).none);
        setDisplayCustomComponent(false);
    };
    const iconClassname = "rf-h-16 rf-w-16 large-vertical:rf-h-24 large-vertical:rf-w-24";
    const iconClassnameMobile = "rf-h-8 rf-w-8";
    const componentToDisplay = (0, $eO7Kz.useMemo)(()=>{
        if (customView && customView.length > 0) {
            if (externalComponents) {
                const component = externalComponents?.find((e)=>e.name === customView);
                if (component && component.component) {
                    console.log(component.component);
                    return component.component;
                }
            }
        }
        return /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $179ad052de55b86f$exports.Fragment), {});
    }, [
        customView
    ]);
    return /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsxs)((0, $5798dbaf1694ea15$export$2e2bcd8739ae039), {
        className: `${!display && "rf-hidden"} ${isMobile && displayControls ? "rf-mb-12" : "rf-mb-0"}`,
        depth: (0, $16ad089b9ce6627d$export$950556173b6cbecb).modal,
        background: "#FFFFFF",
        children: [
            /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsxs)("div", {
                className: "rf-absolute rf-z-util rf-w-full rf-top-0 rf-left-0",
                children: [
                    /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsxs)("div", {
                        className: "large:rf-hidden rf-p-4 rf-flex rf-flex-col",
                        children: [
                            /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $53c3829f3df8be22$export$2e2bcd8739ae039), {
                                title: (0, (/*@__PURE__*/$parcel$interopDefault($abbebf5de79f9da4$exports)))[locale]?.back || (0, (/*@__PURE__*/$parcel$interopDefault($abbebf5de79f9da4$exports)))["fr-FR"].back,
                                className: "rf-text-sm",
                                handleBack: handleBack
                            }),
                            /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsxs)("div", {
                                className: "large:rf-hidden rf-py-2 rf-flex rf-flex-row rf-items-end undefined",
                                children: [
                                    icon ? /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsxs)("div", {
                                        className: iconClassnameMobile,
                                        children: [
                                            icon,
                                            " "
                                        ]
                                    }) : /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $179ad052de55b86f$exports.Fragment), {}),
                                    /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("div", {
                                        className: "rf-ml-2 rf-capitalize rf-subtitle-size-auto",
                                        children: title ? (0, $8fd1ab545cc1ab7a$export$d07f57595c356899)(title) : /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $179ad052de55b86f$exports.Fragment), {})
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsxs)("div", {
                        className: "rf-hidden large:rf-flex rf-w-full rf-pt-4 large-vertical:rf-pt-8 rf-pl-4 large-vertical:rf-pl-0 rf-flex-row rf-justify-start large-vertical:rf-justify-center rf-items-center",
                        children: [
                            icon ? /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsxs)("div", {
                                className: iconClassname,
                                children: [
                                    icon,
                                    " "
                                ]
                            }) : /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $179ad052de55b86f$exports.Fragment), {}),
                            /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("div", {
                                className: "rf-ml-2 rf-uppercase rf-subtitle-size-auto",
                                children: title ? (0, $8fd1ab545cc1ab7a$export$d07f57595c356899)(title) : /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $179ad052de55b86f$exports.Fragment), {})
                            })
                        ]
                    })
                ]
            }),
            componentToDisplay,
            /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $4becae071fdebff0$export$2e2bcd8739ae039), {
                dashboardVisible: true,
                onClick: handleBack
            })
        ]
    });
};
var $98025ff0c2e14c18$export$2e2bcd8739ae039 = $98025ff0c2e14c18$var$CustomView;




const { useActivities: $b8b42b001b80c06c$var$useActivities } = (0, $497baa802110a7bc$exports.hooks);
const $b8b42b001b80c06c$var$useShowMap = ()=>{
    const [activities] = $b8b42b001b80c06c$var$useActivities();
    if (activities && activities.length > 0) {
        const lastActivity = activities.slice(-1)[0];
        if (lastActivity.type === "event" && lastActivity.name === "Hospitality.ShowMap") return true;
    }
    return false;
};
var $b8b42b001b80c06c$export$2e2bcd8739ae039 = $b8b42b001b80c06c$var$useShowMap;


/* eslint-disable react/jsx-boolean-value */ 
parcelRequire("eO7Kz");







var $eO7Kz = parcelRequire("eO7Kz");



async function $c36aed8a043fd3d2$export$cdd2c9f4b3acf5fb(data) {
    // baseURI is used for retrocompatibility
    let fullAddress = "";
    if (data.baseURI) fullAddress = data.baseURI;
    else fullAddress = `${(0, $519f31eef1fe5fca$export$2e2bcd8739ae039)(data.prefix)}/${data.tenant}`;
    if (fullAddress.indexOf(`/${(0, $674f1d59bae686ab$export$d9e38c0112bbdae6)}`) > -1) fullAddress = fullAddress.replace(`/${(0, $674f1d59bae686ab$export$d9e38c0112bbdae6)}`, "");
    fullAddress += `/${0, $674f1d59bae686ab$export$1ca3e229e23d7f42}`;
    const res = await fetch(fullAddress);
    const token = await res.json();
    return token;
}




var $3c996e69175ba6a3$exports = {};
$3c996e69175ba6a3$exports = JSON.parse('{"fr-FR":{"samu":"samu","police":"police","firefighter":"pompiers","general":"g\xe9n\xe9ral"},"en-US":{"samu":"maeu","police":"police","firefighter":"firefighters","general":"general"},"es-ES":{"samu":"samu","police":"polic\xeda","firefighter":"bomberos","general":"general"},"de-DE":{"samu":"samu","police":"polizei","firefighter":"feuerwehrleute","general":"allgemein"}}');




parcelRequire("eO7Kz");
const $61c06acddfad6cb9$var$Animation2 = ({ color: color, loaderColor: loaderColor, backgroundColor: backgroundColor })=>{
    return /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsxs)("svg", {
        "aria-hidden": "true",
        className: "rf-inline rf-w-8 rf-h-8 rf-mr-2 rf-animate-spin ",
        viewBox: "0 0 100 101",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        style: {
            backgroundColor: backgroundColor
        },
        children: [
            /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("path", {
                d: "M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z",
                fill: "currentColor",
                style: {
                    fill: color
                }
            }),
            /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("path", {
                d: "M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z",
                fill: "currentFill",
                style: {
                    fill: loaderColor
                }
            })
        ]
    });
};
var $61c06acddfad6cb9$export$2e2bcd8739ae039 = $61c06acddfad6cb9$var$Animation2;




const $fa27ce84c549dc58$export$6478e9f7582bd8fc = ()=>{
    const locale = (0, $2e4dc8fa28d39601$export$6650dace022cfacc)((state)=>state.locale);
    const { addressData: addressData } = (0, $e599569c1fc3ca2c$export$d8760bee47331b1d)();
    const { isMobile: isMobile } = (0, $8b59a4dbb18c269b$export$3abe3478af3cb63b)();
    const [municipalPoliceNumber, setMunicipalPoliceNumber] = (0, $eO7Kz.useState)("");
    const [localHospitalName, setLocalHospitalName] = (0, $eO7Kz.useState)("");
    const [localHospitalNumber, setLocalHospitalNumber] = (0, $eO7Kz.useState)("");
    const [poisonControlNumber, setPoisonControlNumber] = (0, $eO7Kz.useState)("");
    const [loading, setLoading] = (0, $eO7Kz.useState)(true);
    const subView = (0, $16ad089b9ce6627d$export$3b4d92ba873f009a).emergency;
    (0, $eO7Kz.useEffect)(()=>{
        const getData = async ()=>{
            const data = await (0, $c36aed8a043fd3d2$export$cdd2c9f4b3acf5fb)(addressData);
            if (data) {
                setMunicipalPoliceNumber(data.municipalPoliceNumber);
                setLocalHospitalName(data.localHospitalName);
                setLocalHospitalNumber(data.localHospitalNumber);
                setPoisonControlNumber(data.poisonControlNumber);
            }
            setLoading(false);
        };
        getData();
    }, [
        addressData
    ]);
    return /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsxs)((0, $179ad052de55b86f$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsxs)("div", {
                className: `rf-flex rf-flex-col rf-items-center ${isMobile ? "rf-justify-center rf-gap-2" : "rf-justify-end rf-flex-[2_1_0%] rf-gap-9"}`,
                children: [
                    /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)($5208182085f9f5ff$export$2e2bcd8739ae039, {
                        className: "rf-h-9 rf-w-9 large:rf-h-16 large:rf-w-16"
                    }),
                    /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("h3", {
                        className: "rf-text-verylarge-size-auto rf-font-bold rf-capitalize-first rf-text-center",
                        children: (0, (/*@__PURE__*/$parcel$interopDefault($e2141f1e3ec1b348$exports)))[locale]?.[subView] || (0, (/*@__PURE__*/$parcel$interopDefault($e2141f1e3ec1b348$exports)))["fr-FR"][subView]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("div", {
                className: "rf-w-full rf-flex rf-flex-col rf-items-center rf-flex-[4_1_0%] rf-justify-evenly",
                style: {
                    background: isMobile ? "transparent" : "transparent linear-gradient(291deg, #F2F3F6 0%, #E5E6EC 100%) 0% 0% no-repeat padding-box",
                    boxShadow: isMobile ? "" : "#ffff -3px -3px 16px, rgb(0 0 0 / 25%) 0px 2px 10px 0px"
                },
                children: loading ? /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $179ad052de55b86f$exports.Fragment), {
                    children: /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("div", {
                        className: "rf-w-6 rf-h-6 rf-mb-16",
                        children: /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $61c06acddfad6cb9$export$2e2bcd8739ae039), {
                            color: "gray",
                            loaderColor: "#1999b1",
                            backgroundColor: "transparent"
                        })
                    })
                }) : /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsxs)((0, $179ad052de55b86f$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsxs)("div", {
                            className: `rf-w-full rf-grid ${isMobile ? "rf-grid-cols-2 rf-gap-8 rf-mt-10 rf-mb-8" : "rf-grid-cols-4 rf-divide-x"} `,
                            style: {
                                padding: isMobile ? "" : "0 10%"
                            },
                            children: [
                                /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsxs)("div", {
                                    className: "rf-flex rf-flex-col rf-items-center rf-gap-2",
                                    children: [
                                        /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("p", {
                                            className: "rf-text-xl rf-font-bold rf-uppercase",
                                            children: (0, (/*@__PURE__*/$parcel$interopDefault($3c996e69175ba6a3$exports)))[locale]?.samu || (0, (/*@__PURE__*/$parcel$interopDefault($3c996e69175ba6a3$exports)))["fr-FR"].samu
                                        }),
                                        /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("p", {
                                            className: "rf-text-5xl large:rf-text-6xl rf-font-bold",
                                            children: "15"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsxs)("div", {
                                    className: `rf-flex rf-flex-col rf-items-center ${isMobile ? "" : "rf-border-l rf-border-[#C7C6C6]"} rf-gap-2`,
                                    children: [
                                        /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("p", {
                                            className: "rf-text-xl rf-font-bold rf-uppercase",
                                            children: (0, (/*@__PURE__*/$parcel$interopDefault($3c996e69175ba6a3$exports)))[locale]?.police || (0, (/*@__PURE__*/$parcel$interopDefault($3c996e69175ba6a3$exports)))["fr-FR"].police
                                        }),
                                        /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("p", {
                                            className: "rf-text-5xl large:rf-text-6xl rf-font-bold",
                                            children: "17"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsxs)("div", {
                                    className: `rf-flex rf-flex-col rf-items-center ${isMobile ? "" : "rf-border-l rf-border-[#C7C6C6]"} rf-gap-2`,
                                    children: [
                                        /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("p", {
                                            className: "rf-text-xl rf-font-bold rf-uppercase",
                                            children: (0, (/*@__PURE__*/$parcel$interopDefault($3c996e69175ba6a3$exports)))[locale]?.firefighter || (0, (/*@__PURE__*/$parcel$interopDefault($3c996e69175ba6a3$exports)))["fr-FR"].firefighter
                                        }),
                                        /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("p", {
                                            className: "rf-text-5xl large:rf-text-6xl rf-font-bold",
                                            children: "18"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsxs)("div", {
                                    className: `rf-flex rf-flex-col rf-items-center ${isMobile ? "" : "rf-border-l rf-border-[#C7C6C6]"} rf-gap-2`,
                                    children: [
                                        /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("p", {
                                            className: "rf-text-xl rf-font-bold rf-uppercase",
                                            children: (0, (/*@__PURE__*/$parcel$interopDefault($3c996e69175ba6a3$exports)))[locale]?.general || (0, (/*@__PURE__*/$parcel$interopDefault($3c996e69175ba6a3$exports)))["fr-FR"].general
                                        }),
                                        /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("p", {
                                            className: "rf-text-5xl large:rf-text-6xl rf-font-bold",
                                            children: "112"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsxs)("div", {
                            className: `rf-flex rf-items-start ${isMobile ? "rf-flex-col" : "rf-gap-12"} `,
                            children: [
                                /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsxs)("div", {
                                    children: [
                                        municipalPoliceNumber && municipalPoliceNumber.length > 0 && /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsxs)("p", {
                                            className: "rf-text-xl rf-py-2",
                                            children: [
                                                "Police municipale :",
                                                " ",
                                                /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("span", {
                                                    className: "rf-font-bold",
                                                    children: municipalPoliceNumber
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsxs)("p", {
                                            className: "rf-text-xl rf-py-2",
                                            children: [
                                                "Sans abris (appel gratuit) :",
                                                " ",
                                                /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("span", {
                                                    className: "rf-font-bold",
                                                    children: "115"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsxs)("p", {
                                            className: "rf-text-xl rf-py-2",
                                            children: [
                                                "Urgences europ\xe9ennes :",
                                                " ",
                                                /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("span", {
                                                    className: "rf-font-bold",
                                                    children: "118"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsxs)("div", {
                                    children: [
                                        localHospitalName && localHospitalName.length > 0 && /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsxs)("p", {
                                            className: "rf-text-xl rf-py-2",
                                            children: [
                                                "H\xf4pital ",
                                                localHospitalName,
                                                " :",
                                                " ",
                                                /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("span", {
                                                    className: "rf-font-bold",
                                                    children: localHospitalNumber
                                                })
                                            ]
                                        }),
                                        poisonControlNumber && poisonControlNumber.length > 0 && /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsxs)("p", {
                                            className: "rf-text-xl rf-py-2",
                                            children: [
                                                "Centre anti-poison :",
                                                " ",
                                                /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("span", {
                                                    className: "rf-font-bold",
                                                    children: poisonControlNumber
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }),
            !isMobile && /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("div", {
                className: "rf-flex-1"
            })
        ]
    });
};


const $fb4c242e16d73ffa$var$Emergency = ({ handleClose: handleClose })=>{
    const { setCurrentSubView: setCurrentSubView } = (0, $e599569c1fc3ca2c$export$d8760bee47331b1d)();
    const { isMobile: isMobile } = (0, $8b59a4dbb18c269b$export$3abe3478af3cb63b)();
    const handleBack = ()=>{
        handleClose ? handleClose() : setCurrentSubView((0, $16ad089b9ce6627d$export$f05d0fed0593ead7).none);
    };
    return isMobile ? /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $d7dd81018f15de78$export$2e2bcd8739ae039), {
        handleClose: handleBack,
        backIsConversation: false,
        className: "rf-height-fill-available -rf-mb-4",
        children: /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $fa27ce84c549dc58$export$6478e9f7582bd8fc), {})
    }) : /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsxs)((0, $5798dbaf1694ea15$export$2e2bcd8739ae039), {
        depth: (0, $16ad089b9ce6627d$export$950556173b6cbecb).dropdown,
        background: "linear-gradient(to right bottom, #F2F8F8FC , #F2E1E2E8)",
        children: [
            /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("div", {
                className: "rf-h-full rf-w-full rf-flex rf-flex-col rf-items-center rf-justify-center rf-gap-12",
                children: /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $fa27ce84c549dc58$export$6478e9f7582bd8fc), {})
            }),
            /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $4becae071fdebff0$export$2e2bcd8739ae039), {
                dashboardVisible: true,
                onClick: handleBack
            })
        ]
    });
};
var $fb4c242e16d73ffa$export$2e2bcd8739ae039 = $fb4c242e16d73ffa$var$Emergency;



const { useActivities: $c59c40fb9729e1ff$var$useActivities } = (0, $497baa802110a7bc$exports.hooks);
const $c59c40fb9729e1ff$var$useShowEmergency = ()=>{
    const [activities] = $c59c40fb9729e1ff$var$useActivities();
    if (activities && activities.length > 0) {
        const lastActivity = activities.slice(-1)[0];
        if (lastActivity.type === "event" && lastActivity.name === "Hospitality.ShowEmergency") return true;
    }
    return false;
};
var $c59c40fb9729e1ff$export$2e2bcd8739ae039 = $c59c40fb9729e1ff$var$useShowEmergency;


const $c2d87c743d37863b$var$SubViews = ({ externalComponents: externalComponents })=>{
    const { currentSubView: currentSubView, customView: customView } = (0, $e599569c1fc3ca2c$export$d8760bee47331b1d)();
    const { configuration: configuration } = (0, $e599569c1fc3ca2c$export$d8760bee47331b1d)();
    const showMap = (0, $b8b42b001b80c06c$export$2e2bcd8739ae039)();
    const showEmergency = (0, $c59c40fb9729e1ff$export$2e2bcd8739ae039)();
    const [displayCustomComponent, setDisplayCustomComponent] = (0, $eO7Kz.useState)(true);
    (0, $eO7Kz.useEffect)(()=>{
        if (showMap && currentSubView !== (0, $16ad089b9ce6627d$export$f05d0fed0593ead7).custom) {
            if (externalComponents && externalComponents.length > 0) {
                const component = externalComponents?.find((e)=>e.name === "mapDisplay");
                if (component && component.component) {
                    if (configuration.baseMenu || configuration.customMenu) {
                        let allMenus = [];
                        configuration.baseMenu && // Filter on 'icon' key to get only CustomMenu items
                        (allMenus = [
                            ...configuration.baseMenu
                        ].filter((m)=>Object.keys(m).includes("icon")));
                        if (configuration.customMenu && configuration.customMenu.length > 0) {
                            if (Array.isArray(configuration.customMenu[0])) {
                                const tempCustomMenu = configuration.customMenu;
                                tempCustomMenu.forEach((menu)=>{
                                    allMenus = [
                                        ...allMenus,
                                        ...menu
                                    ];
                                });
                            } else allMenus = [
                                ...allMenus,
                                ...configuration.customMenu
                            ];
                        }
                        const customMenuMap = allMenus.find((c)=>c.customDisplay && c.customDisplay === "mapDisplay");
                        if (customMenuMap) {
                            console.log(component.component);
                            if (customView && customView.view === customMenuMap.customDisplay) ;
                            else (0, $134592d23f105dbc$export$5a678fd51bd89633)(customMenuMap);
                            (0, $134592d23f105dbc$export$dcb32d000c0e0280)((0, $16ad089b9ce6627d$export$4f7cd669585dc69f).DetailViewOpen);
                            (0, $134592d23f105dbc$export$f0c096b4ecd7115d)((0, $16ad089b9ce6627d$export$f05d0fed0593ead7).custom);
                            setDisplayCustomComponent(true);
                        }
                    }
                }
            }
        }
    }, [
        showMap
    ]);
    (0, $eO7Kz.useEffect)(()=>{
        if (showEmergency) (0, $134592d23f105dbc$export$f0c096b4ecd7115d)((0, $16ad089b9ce6627d$export$f05d0fed0593ead7).emergency);
    }, [
        showEmergency
    ]);
    (0, $eO7Kz.useEffect)(()=>{
        if (currentSubView !== (0, $16ad089b9ce6627d$export$f05d0fed0593ead7).none) (0, $134592d23f105dbc$export$dcb32d000c0e0280)((0, $16ad089b9ce6627d$export$4f7cd669585dc69f).DetailViewOpen);
        else (0, $134592d23f105dbc$export$dcb32d000c0e0280)((0, $16ad089b9ce6627d$export$4f7cd669585dc69f).DetailViewClose);
        if (currentSubView !== (0, $16ad089b9ce6627d$export$f05d0fed0593ead7).custom) setDisplayCustomComponent(false);
        else setDisplayCustomComponent(true);
    }, [
        currentSubView
    ]);
    return /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($eO7Kz))).Fragment, {
        children: [
            currentSubView === (0, $16ad089b9ce6627d$export$f05d0fed0593ead7).history ? /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $d63a7ea7bbd74325$export$2e2bcd8739ae039), {}) : currentSubView === (0, $16ad089b9ce6627d$export$f05d0fed0593ead7).languages ? /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $6a67b0d4511779d3$export$2e2bcd8739ae039), {}) : currentSubView === (0, $16ad089b9ce6627d$export$f05d0fed0593ead7).weather ? /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $5e6c500b0ab75272$export$2e2bcd8739ae039), {}) : currentSubView === (0, $16ad089b9ce6627d$export$f05d0fed0593ead7).emergency ? /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $fb4c242e16d73ffa$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eO7Kz))).Fragment, {}),
            /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $98025ff0c2e14c18$export$2e2bcd8739ae039), {
                display: displayCustomComponent,
                externalComponents: externalComponents,
                customView: customView?.view,
                title: customView?.title,
                icon: customView?.icon,
                setDisplayCustomComponent: setDisplayCustomComponent
            }),
            /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $da3b3c7a7b543978$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $9abebc121984a403$export$2e2bcd8739ae039), {})
        ]
    });
};
var $c2d87c743d37863b$export$2e2bcd8739ae039 = $c2d87c743d37863b$var$SubViews;





var $eO7Kz = parcelRequire("eO7Kz");




const $b0bf9d862842b3aa$export$d95eb9b67812311f = (0, $8deac4f58fe9f113$exports.create)()(()=>{
    return {
        widgetDisplayType: "large",
        open: false,
        loaded: false
    };
});
const $b0bf9d862842b3aa$export$a1c83309c736819f = ()=>{
    $b0bf9d862842b3aa$export$d95eb9b67812311f.setState({
        open: true,
        loaded: true
    });
};
const $b0bf9d862842b3aa$export$d27f1b0993b666c = ()=>{
    $b0bf9d862842b3aa$export$d95eb9b67812311f.setState({
        open: false,
        loaded: true
    });
};
const $b0bf9d862842b3aa$export$77c0ba4d0d97cee5 = ()=>{
    const open = $b0bf9d862842b3aa$export$d95eb9b67812311f.getState().open;
    $b0bf9d862842b3aa$export$d95eb9b67812311f.setState({
        open: !open,
        loaded: true
    });
};
const $b0bf9d862842b3aa$export$f0e9d14ede4c01bd = ()=>{
    const displayType = $b0bf9d862842b3aa$export$d95eb9b67812311f.getState().widgetDisplayType;
    $b0bf9d862842b3aa$export$d95eb9b67812311f.setState({
        widgetDisplayType: displayType === "large" ? "thumbnail" : "large"
    });
};




const { useActivities: $64502f4d4557c632$var$useActivities } = (0, $497baa802110a7bc$exports.hooks);
function $64502f4d4557c632$export$2e2bcd8739ae039() {
    const [allActivities] = $64502f4d4557c632$var$useActivities();
    // processedId contains the ids of the activities already processed (because useActivities gives duplicate activities with different state depending on if it's been spoken or not )
    const processedId = [];
    const history = [];
    const activities = allActivities.slice().filter(({ type: type })=>type === "message");
    activities.forEach((activity)=>{
        if (activity.id && !processedId.includes(activity.id)) {
            processedId.push(activity.id);
            // Check if this is a question or an answer (questions from the user don't have a replyToId field)
            if (activity.replyToId) {
                const question = history.find((historyItem)=>historyItem.question.id === activity.replyToId);
                if (question) question.answers.push(activity);
                else {
                    // Get answer's timestamp or create a new one if none present
                    const timestamp = activity.localTimestamp || activity.timestamp || Date.now().toString();
                    const newQuestion = {
                        id: activity.id,
                        type: "message",
                        text: "",
                        channelData: {
                            "webchat:sequence-id": 1
                        },
                        timestamp: timestamp,
                        localTimestamp: timestamp,
                        from: {
                            id: "bot",
                            role: "bot"
                        }
                    };
                    history.push({
                        question: newQuestion,
                        answers: [
                            activity
                        ]
                    });
                }
            } else // If the activity has a value, it is a need for further informations that don't need to be displayed
            !activity.value && history.push({
                question: activity,
                answers: []
            });
        }
    });
    return history;
}








parcelRequire("eO7Kz");



const $2e76bf6f8b20e85c$export$aa0c5ba341a0028 = ({ agentName: agentName = "L\xe9a", companyName: companyName = "Davi", subCompanyMessage: subCompanyMessage, imageUrl: imageUrl = "" })=>{
    const { themeColors: themeColors } = (0, $8b59a4dbb18c269b$export$3abe3478af3cb63b)();
    const { locale: locale } = (0, $2e4dc8fa28d39601$export$6650dace022cfacc)();
    return /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsxs)("div", {
        id: "retorik-conversation-header",
        className: "rf-w-full rf-h-fit rf-grid rf-grid-cols-4 rf-grid-rows-headerContainer rf-bg-truewhite",
        children: [
            /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("div", {
                className: "rf-col-start-1 rf-col-end-2 rf-row-start-1 rf-row-end-4 rf-flex rf-items-center rf-px-2 rf-py-2",
                children: /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("img", {
                    src: imageUrl,
                    alt: "Agent",
                    className: "rf-w-full rf-aspect-square rf-rounded-half rf-border-secondary rf-border-2 rf-bg-truewhite"
                })
            }),
            /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("div", {
                className: "rf-col-start-2 rf-col-span-full rf-row-start-1 rf-row-end-2 rf-flex rf-items-end rf-font-bold",
                style: {
                    color: themeColors.companyName
                },
                children: companyName
            }),
            /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("div", {
                className: "rf-col-start-2 rf-col-span-full rf-row-start-3 rf-row-end-4 rf-flex rf-items-start rf-text-sm rf-italic",
                children: subCompanyMessage || `${agentName} ${(0, (/*@__PURE__*/$parcel$interopDefault($abbebf5de79f9da4$exports)))[locale]?.answer || (0, (/*@__PURE__*/$parcel$interopDefault($abbebf5de79f9da4$exports)))["fr-FR"].answer}`
            }),
            /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("div", {
                className: "rf-col-start-2 rf-col-span-full rf-row-start-2 rf-row-end-3 -rf-ml-2 rf-flex rf-items-center",
                children: /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("hr", {
                    className: "rf-h-1 rf-bg-gray-200 rf-border-0 rf-w-full rf-shadow-[0_3px_6px_rgba(0,0,0,0.16)] rf-mb-1"
                })
            })
        ]
    });
};


/**
 * On call :
 *  - check if the activity data need a display as list to be triggered
 * @param activity : RetorikActivity
 * @returns boolean
 */ function $5c52ed9315e0e345$var$checkListDisplay(activity) {
    return activity && (activity.attachmentLayout?.toLowerCase() === "davilist" || activity.attachmentLayout !== "carousel" && activity.attachments && activity.attachments.length > 1) || false;
}
const $5c52ed9315e0e345$export$a1f3f6b0b496333e = ()=>{
    const activities = (0, $64502f4d4557c632$export$2e2bcd8739ae039)();
    const { open: open } = (0, $b0bf9d862842b3aa$export$d95eb9b67812311f)();
    const { isMobile: isMobile, currentDeviceType: currentDeviceType, showHomeAttachments: showHomeAttachments, mediumLandscape: mediumLandscape } = (0, $8b59a4dbb18c269b$export$3abe3478af3cb63b)();
    const listClosed = (0, $134592d23f105dbc$export$77e4cc5334565f28)((state)=>state.listClosed);
    const { configuration: configuration, agentData: agentData } = (0, $e599569c1fc3ca2c$export$d8760bee47331b1d)();
    const [list, setList] = (0, $eO7Kz.useState)();
    const [scrollButtonDisplay, setScrollButtonDisplay] = (0, $eO7Kz.useState)(false);
    const [scrollButtonDirection, setScrollButtonDirection] = (0, $eO7Kz.useState)("bottom");
    const retorikConversationRef = (0, $eO7Kz.useRef)(null);
    const [preventScroll, setPreventScroll] = (0, $eO7Kz.useState)(false);
    const userQuestion = (0, $eO7Kz.useMemo)(()=>{
        if (activities && activities.length > 0 && !isMobile) {
            const lastActivity = activities[activities.length - 1];
            return lastActivity.question.text ? lastActivity.question : undefined;
        } else return undefined;
    }, [
        activities
    ]);
    const botResponses = (0, $eO7Kz.useMemo)(()=>{
        if (activities && activities.length > 0 && !isMobile) {
            const lastActivity = activities[activities.length - 1];
            return lastActivity.answers;
        } else return undefined;
    }, [
        activities
    ]);
    const botEndRef = (0, $eO7Kz.useRef)(null);
    const activitiesNumberWithResponse = (0, $eO7Kz.useMemo)(()=>{
        let number = 0;
        activities.forEach((element)=>{
            number += element.answers.length + 1;
        });
        return number;
    }, [
        activities
    ]);
    const [opacityStyle, setOpacityStyle] = (0, $eO7Kz.useState)("");
    const handleScroll = ()=>{
        if (retorikConversationRef.current) {
            const scrollHeight = retorikConversationRef.current.scrollHeight;
            const scrollTop = retorikConversationRef.current.scrollTop;
            const offsetHeight = retorikConversationRef.current.offsetHeight;
            const clientHeight = retorikConversationRef.current.clientHeight;
            if (scrollHeight > offsetHeight) {
                setScrollButtonDisplay(true);
                if (scrollHeight - scrollTop === clientHeight) setScrollButtonDirection("top");
                else if (scrollHeight - scrollTop < clientHeight + 10) setScrollButtonDirection("top");
                else setScrollButtonDirection("bottom");
            }
            const maxScroll = scrollHeight - clientHeight;
            const percentage = Math.ceil(scrollTop / maxScroll * 15);
            setOpacityStyle(`linear-gradient(to top, black ${100 - percentage}%, transparent 100%)`);
        }
    };
    /**
   * On call :
   *  - scroll to the botEndRef HTML element at the bottom of the view
   */ const ScrollHandler = (to, from)=>{
        if (to === "bottom") setScrollButtonDirection("top");
        else setScrollButtonDirection("bottom");
        if ((!preventScroll || from === "button") && botEndRef && botEndRef.current !== null && to === "bottom") botEndRef.current.scrollIntoView({
            behavior: "smooth"
        });
        else if (to === "top" && retorikConversationRef && retorikConversationRef.current) retorikConversationRef.current.children[1].scrollIntoView({
            behavior: "smooth"
        });
    };
    /**
   * On retorikConversationRef change :
   *  - check if retorikConversationRef.current is defined
   *  - if scrollHeight > clientHeight, call handleScroll
   *  - if scrollHeight <= clientHeight, set opacityStyle state to undefined
   */ (0, $eO7Kz.useEffect)(()=>{
        if (retorikConversationRef.current) {
            if (retorikConversationRef.current.scrollHeight > retorikConversationRef.current.clientHeight) handleScroll();
            else setOpacityStyle(undefined);
        }
    }, [
        retorikConversationRef
    ]);
    /**
   * On call :
   *  - set listClosed state to true
   */ const onCloseList = ()=>{
        (0, $134592d23f105dbc$export$f03cfde7db70aa27)(true);
    };
    /**
   * On call :
   *  - scroll to the botEndRef HTML element at the bottom of the view
   *  - check if there is an activity in need of List display
   *  - set list state depending on the check's result
   */ (0, $eO7Kz.useEffect)(()=>{
        setPreventScroll(false);
        if (isMobile) {
            const answers = activities && activities.length > 0 ? activities[activities.length - 1].answers : [];
            setList(answers.some((activity)=>$5c52ed9315e0e345$var$checkListDisplay(activity)));
        } else botResponses && setList(botResponses.some((activity)=>$5c52ed9315e0e345$var$checkListDisplay(activity)));
        if (botEndRef.current) {
            const timer = setTimeout(()=>{
                ScrollHandler("bottom", "newMessage");
            }, 100);
            return ()=>timer && clearTimeout(timer);
        }
        return ()=>{};
    }, [
        activitiesNumberWithResponse
    ]);
    (0, $eO7Kz.useEffect)(()=>{
        if ((listClosed || showHomeAttachments) && botEndRef.current) {
            const timer = setTimeout(()=>{
                ScrollHandler("bottom", "newMessage");
            }, 100);
            return ()=>timer && clearTimeout(timer);
        }
        return ()=>{};
    }, [
        listClosed,
        showHomeAttachments
    ]);
    return /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $179ad052de55b86f$exports.Fragment), {
        children: (userQuestion || botResponses || isMobile) && (list && !listClosed ? isMobile ? /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $b1d30aac07bca848$export$2e2bcd8739ae039), {
            activity: activities[activities.length - 1].answers.find((activity)=>$5c52ed9315e0e345$var$checkListDisplay(activity)),
            onClose: onCloseList
        }) : /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $b1d30aac07bca848$export$2e2bcd8739ae039), {
            activity: botResponses?.find((activity)=>$5c52ed9315e0e345$var$checkListDisplay(activity)),
            onClose: onCloseList
        }) : /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsxs)("div", {
            className: `rf-relative rf-max-h-full ${isMobile && "rf-h-full"} rf-bg-textModePanelBackground ${mediumLandscape ? "rf-col-start-4" : "rf-col-start-5"} vertical:rf-col-start-1 rf-col-span-full vertical:rf-w-full rf-row-start-4 rf-row-end-13 large-vertical:rf-row-start-7 large-vertical:rf-row-span-6 rf-self-start rf-overflow-hidden
            vertical:rf-row-start-1 vertical:rf-row-span-full vertical:rf-overflow-x-auto rf-justify-self-center large:rf-w-3/5 rf-flex rf-flex-col large:rf-rounded`,
            children: [
                isMobile && /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $2e76bf6f8b20e85c$export$aa0c5ba341a0028), {
                    agentName: agentData?.name,
                    companyName: configuration?.companyName,
                    subCompanyMessage: configuration?.subCompanyMessage,
                    imageUrl: agentData?.portrait
                }),
                /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsxs)("div", {
                    ref: retorikConversationRef,
                    id: "retorik-conversation",
                    className: `rf-relative rf-max-h-full rf-bg-textModePanelBackground rf-py-4 rf-overflow-y-scroll rf-scrollbar-thin ${isMobile && "rf-self-auto rf-mb-26 rf-h-full"}
              vertical:rf-overflow-x-auto rf-justify-self-center rf-flex rf-flex-col rf-text-size-auto rf-text-trueblack rf-shadow-[3px_3px_6px_#00000029]`,
                    style: {
                        WebkitMaskImage: currentDeviceType === (0, $16ad089b9ce6627d$export$ec1e04e4e5ef8233).mobile ? opacityStyle : undefined
                    },
                    onScroll: handleScroll,
                    children: [
                        /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $b17b9cd9c76f9d83$export$93d01adc5582c83e), {
                            direction: scrollButtonDirection,
                            display: isMobile && scrollButtonDisplay && open,
                            ScrollHandler: ScrollHandler,
                            setPreventScroll: setPreventScroll,
                            className: "rf-fixed rf-z-ui rf-bottom-40 rf-right-6 rf-w-9 rf-h-9 rf-cursor-pointer rf-bg-[#00000050] rf-p-[7px_12px] rf-rounded-[20px] rf-flex"
                        }),
                        isMobile ? /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)($5c52ed9315e0e345$var$MultipleActivites, {
                            history: activities
                        }) : /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)($5c52ed9315e0e345$var$SingleMessage, {
                            userQuestion: userQuestion,
                            botResponses: botResponses
                        }),
                        /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("div", {
                            ref: botEndRef
                        })
                    ]
                })
            ]
        }))
    });
};
const $5c52ed9315e0e345$var$SingleMessage = ({ userQuestion: userQuestion, botResponses: botResponses, userClassName: userClassName = "" })=>{
    const locale = (0, $2e4dc8fa28d39601$export$6650dace022cfacc)((state)=>state.locale);
    const { isMobile: isMobile, showHomeAttachments: showHomeAttachments } = (0, $8b59a4dbb18c269b$export$3abe3478af3cb63b)();
    const userQuestionTime = userQuestion ? userQuestion.localTimestamp ? new Date(userQuestion.localTimestamp) : userQuestion.timestamp ? new Date(userQuestion.timestamp) : new Date() : undefined;
    return isMobile || !showHomeAttachments ? /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($eO7Kz))).Fragment, {
        children: [
            userQuestion && userQuestion.text && /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsxs)("div", {
                id: "retorik-userQuestion",
                className: `rf-text-textModePanelConversationUser rf-animate-slideBottom rf-flex rf-flex-col rf-justify-start rf-text-size-auto rf-gap-2 ${userClassName}`,
                children: [
                    isMobile && userQuestionTime && /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("div", {
                        className: "rf-px-4 rf-text-[#9A9A9A]",
                        children: userQuestionTime.toLocaleString(locale, {
                            hour: "numeric",
                            minute: "numeric"
                        })
                    }),
                    /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("div", {
                        className: "rf-px-4",
                        children: userQuestion.text
                    })
                ]
            }, userQuestion.id),
            botResponses && /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("div", {
                id: "retorik-botResponses",
                className: `${userQuestion && "rf-pt-4"} rf-flex rf-flex-col rf-text-size-auto rf-gap-2`,
                children: botResponses.map((activity, key)=>{
                    const answerTime = activity.localTimestamp ? new Date(activity.localTimestamp) : activity.timestamp ? new Date(activity.timestamp) : new Date();
                    return /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eO7Kz))).Fragment, {
                        children: /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)($5c52ed9315e0e345$var$BotMessageActivity, {
                            activity: activity,
                            answerTime: answerTime,
                            isMobile: isMobile,
                            mappingKey: key,
                            locale: locale
                        })
                    }, key);
                })
            })
        ]
    }) : showHomeAttachments.attachments?.length > 0 ? /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("div", {
        className: "rf-pt-4 rf-flex rf-flex-col rf-text-size-auto rf-gap-2",
        children: /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $a115f00bb53e5be0$export$2e2bcd8739ae039), {
            activity: showHomeAttachments
        })
    }) : /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $179ad052de55b86f$exports.Fragment), {});
};
const $5c52ed9315e0e345$var$MultipleActivites = ({ history: history })=>{
    const { showHomeAttachments: showHomeAttachments } = (0, $8b59a4dbb18c269b$export$3abe3478af3cb63b)();
    return /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsxs)((0, $179ad052de55b86f$exports.Fragment), {
        children: [
            history && history.map((history, index)=>{
                return /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eO7Kz))).Fragment, {
                    children: /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)($5c52ed9315e0e345$var$SingleMessage, {
                        userClassName: "rf-pt-3",
                        userQuestion: history.question,
                        botResponses: history.answers
                    })
                }, index);
            }),
            showHomeAttachments && showHomeAttachments.attachments?.length > 0 && /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("div", {
                className: "rf-pt-4 rf-flex rf-flex-col rf-text-size-auto rf-gap-2",
                children: /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $a115f00bb53e5be0$export$2e2bcd8739ae039), {
                    activity: showHomeAttachments
                })
            })
        ]
    });
};
const $5c52ed9315e0e345$var$BotMessageActivity = ({ isMobile: isMobile, answerTime: answerTime, locale: locale, activity: activity, mappingKey: mappingKey })=>{
    return /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsxs)("div", {
        className: `${mappingKey > 0 && "rf-pt-2"} rf-text-textModePanelConversationBot rf-animate-slideBottom rf-flex rf-flex-col rf-items-start rf-gap-2`,
        children: [
            isMobile && /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("div", {
                className: "rf-px-4 rf-text-[#9A9A9A]",
                children: answerTime.toLocaleString(locale, {
                    hour: "numeric",
                    minute: "numeric"
                })
            }),
            activity.htmlText ? /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("div", {
                className: "rf-px-4",
                dangerouslySetInnerHTML: {
                    __html: activity.htmlText
                }
            }) : activity.text ? /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("div", {
                className: "rf-px-4",
                children: (0, $8e06b2d561dfd8ee$export$d6c6ec86eedacfd9)(activity.text)
            }) : /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eO7Kz))).Fragment, {}),
            !!activity?.attachments?.length && !$5c52ed9315e0e345$var$checkListDisplay(activity) && /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("div", {
                className: `rf-w-full ${activity.attachments.length <= 1 && "rf-px-4"} rf-flex rf-flex-col rf-gap-2`,
                children: /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $a115f00bb53e5be0$export$2e2bcd8739ae039), {
                    activity: activity
                })
            })
        ]
    });
};




var $eO7Kz = parcelRequire("eO7Kz");



var $eO7Kz = parcelRequire("eO7Kz");






parcelRequire("eO7Kz");


var $eO7Kz = parcelRequire("eO7Kz");






const { useMicrophoneButtonClick: $0cf09c1165af1ce5$var$useMicrophoneButtonClick, useSendBoxSpeechInterimsVisible: $0cf09c1165af1ce5$var$useSendBoxSpeechInterimsVisible } = (0, $497baa802110a7bc$exports.hooks);
const $0cf09c1165af1ce5$var$Mode = ()=>{
    const { mode: mode, setMode: setMode, setCanFocusSendBox: setCanFocusSendBox } = (0, $e599569c1fc3ca2c$export$d8760bee47331b1d)();
    const { themeColors: themeColors } = (0, $8b59a4dbb18c269b$export$3abe3478af3cb63b)();
    const [fromTextToVocal, setFromTextToVocal] = (0, $eO7Kz.useState)(false);
    const microphoneClick = $0cf09c1165af1ce5$var$useMicrophoneButtonClick();
    const [interimsVisible] = $0cf09c1165af1ce5$var$useSendBoxSpeechInterimsVisible();
    const toggleMode = (newMode)=>{
        setFromTextToVocal(true);
        if (newMode === (0, $16ad089b9ce6627d$export$9484bbecc3c49a2e).text) {
            interimsVisible && microphoneClick();
            setCanFocusSendBox(true);
        }
        setMode(newMode);
    };
    return /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsxs)("div", {
        className: "rf-w-full rf-px-4 rf-grid rf-grid-cols-1 rf-grid-rows-2 rf-items-center",
        children: [
            /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("div", {
                className: "rf-w-full rf-flex rf-justify-center",
                children: mode === (0, $16ad089b9ce6627d$export$9484bbecc3c49a2e).text ? /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("button", {
                    className: "rf-w-full rf-aspect-square rf-flex rf-justify-center rf-items-center rf-border rf-border-menuBorder rf-rounded-half rf-shadow-[0_0_20px_1px_#A4A7AF80]",
                    onClick: ()=>toggleMode((0, $16ad089b9ce6627d$export$9484bbecc3c49a2e).vocal),
                    "aria-label": "vocal mode",
                    children: /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $723367a4828ad150$export$2e2bcd8739ae039), {
                        className: "rf-h-5 rf-w-5 tactile:rf-h-6 tactile:rf-w-6",
                        color: "#A4A7AF"
                    })
                }) : /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $b4b3f77eb1eaf002$export$2e2bcd8739ae039), {
                    openMicrophone: fromTextToVocal
                })
            }),
            /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("button", {
                className: "rf-flex rf-justify-center rf-items-center",
                onClick: ()=>toggleMode((0, $16ad089b9ce6627d$export$9484bbecc3c49a2e).text),
                "aria-label": "text mode",
                children: /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $c213472e440373a4$export$2e2bcd8739ae039), {
                    className: "rf-h-5 rf-w-5 large-vertical:rf-h-6 large-vertical:rf-w-6",
                    color: mode === (0, $16ad089b9ce6627d$export$9484bbecc3c49a2e).text ? themeColors.secondary : "#A4A7AF"
                })
            })
        ]
    });
};
var $0cf09c1165af1ce5$export$2e2bcd8739ae039 = $0cf09c1165af1ce5$var$Mode;



const $87413eb7b0c48bab$var$Remote = ()=>{
    return /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsxs)("div", {
        id: "retorik-framework-remote",
        className: "rf-w-full rf-pt-3 rf-pb-4 rf-flex rf-flex-col rf-items-center rf-rounded-l-lg rf-shadow-[0_3px_6px_#606267]",
        style: {
            background: "linear-gradient(#F8F8FC, #EDEEF3)"
        },
        children: [
            /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $0cf09c1165af1ce5$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("div", {
                className: "rf-w-[90%] rf-mb-4 rf-border-b-2 rf-border-b-[#C4C5C8]"
            }),
            /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("div", {
                className: "rf-w-full rf-flex rf-flex-col rf-justify-center rf-gap-5 large-vertical:rf-gap-6",
                children: /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $565625f6c996aee4$export$2e2bcd8739ae039), {})
            })
        ]
    });
};
var $87413eb7b0c48bab$export$2e2bcd8739ae039 = $87413eb7b0c48bab$var$Remote;


const $63604b0a3df09754$var$RemoteContainer = ({ hideMenu: hideMenu = false })=>{
    const { setCurrentSubView: setCurrentSubView } = (0, $e599569c1fc3ca2c$export$d8760bee47331b1d)();
    const top = (0, $7b896b1616483503$export$2e2bcd8739ae039)();
    const [dashboardOpened, setDashboardOpened] = (0, $eO7Kz.useState)(false);
    /**
   * On call :
   *  - close subview if one is opened and if the parameter is false / undefined
   *  - toggle dashboardOpened state
   * @param doNotCloseViews : boolean
   */ const toggleDashboard = (doNotCloseViews)=>{
        !doNotCloseViews && setCurrentSubView((0, $16ad089b9ce6627d$export$f05d0fed0593ead7).none);
        setDashboardOpened(!dashboardOpened);
    };
    return /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($eO7Kz))).Fragment, {
        children: [
            /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsxs)("div", {
                className: "rf-absolute rf-hidden large:rf-flex rf-flex-col rf-items-center rf-justify-start rf-w-24 rf-right-0 rf-text-xsm rf-text-trueblack",
                style: {
                    top: top
                },
                children: [
                    !hideMenu && /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $70f9c74a044f19d9$export$2e2bcd8739ae039), {
                        dashboardVisible: false,
                        onClick: ()=>toggleDashboard()
                    }),
                    /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $87413eb7b0c48bab$export$2e2bcd8739ae039), {})
                ]
            }),
            dashboardOpened && /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $4e7da85755ba84f6$export$2e2bcd8739ae039), {
                toggleDashboard: ()=>toggleDashboard(true)
            })
        ]
    });
};
var $63604b0a3df09754$export$2e2bcd8739ae039 = $63604b0a3df09754$var$RemoteContainer;




var $eO7Kz = parcelRequire("eO7Kz");





var $eO7Kz = parcelRequire("eO7Kz");





parcelRequire("eO7Kz");



const $07bfc01d373e9b86$var$ModeButton = ({ label: label, selected: selected, onClick: onClick })=>{
    const { themeColors: themeColors } = (0, $8b59a4dbb18c269b$export$3abe3478af3cb63b)();
    return /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("button", {
        className: "rf-grid rf-w-full rf-h-12 rf-pb-4 rf-justify-center rf-items-end",
        onClick: ()=>onClick((0, $16ad089b9ce6627d$export$9484bbecc3c49a2e)[label]),
        "aria-label": label,
        children: label === "vocal" ? /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $723367a4828ad150$export$2e2bcd8739ae039), {
            className: "rf-h-5",
            color: "#A4A7AF"
        }) : label === "text" ? /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $c213472e440373a4$export$2e2bcd8739ae039), {
            className: "rf-h-4",
            color: selected ? themeColors.secondary : "#A4A7AF"
        }) : /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $2b2ac986a23018e3$export$2e2bcd8739ae039), {
            className: "rf-h-[0.875rem]",
            color: selected ? themeColors.secondary : "#A4A7AF"
        })
    });
};
var $07bfc01d373e9b86$export$2e2bcd8739ae039 = $07bfc01d373e9b86$var$ModeButton;





const { useMicrophoneButtonClick: $6319f26798fc376a$var$useMicrophoneButtonClick, useSendBoxSpeechInterimsVisible: $6319f26798fc376a$var$useSendBoxSpeechInterimsVisible } = (0, $497baa802110a7bc$exports.hooks);
const $6319f26798fc376a$var$Mobile = ({ parametersOpened: parametersOpened, toggleParameters: toggleParameters })=>{
    const { mode: mode, setMode: setMode, setCanFocusSendBox: setCanFocusSendBox } = (0, $e599569c1fc3ca2c$export$d8760bee47331b1d)();
    const { currentDeviceType: currentDeviceType } = (0, $8b59a4dbb18c269b$export$3abe3478af3cb63b)();
    const [fromTextToVocal, setFromTextToVocal] = (0, $eO7Kz.useState)(false);
    const microphoneClick = $6319f26798fc376a$var$useMicrophoneButtonClick();
    const [interimsVisible] = $6319f26798fc376a$var$useSendBoxSpeechInterimsVisible();
    const toggleMode = (newMode)=>{
        // If the parameters are opened, no action
        if (!parametersOpened) {
            setFromTextToVocal(true);
            if (newMode === (0, $16ad089b9ce6627d$export$9484bbecc3c49a2e).text) {
                interimsVisible && microphoneClick();
                setCanFocusSendBox(true);
            }
            setMode(newMode);
        }
    };
    const handleDashboardClick = ()=>{
        toggleParameters();
    };
    return /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsxs)("div", {
        id: "retorik-framework-menu",
        className: "rf-w-full rf-h-fit rf-flex rf-flex-col-reverse rf-border-t rf-border-t-menuBorder rf-pointer-events-auto",
        style: {
            background: "linear-gradient(to right, #F8F8FC, #EDEEF3)"
        },
        children: [
            /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsxs)("div", {
                className: "rf-w-full rf-grid rf-flex-1 rf-h-full rf-grid-cols-3 rf-min-h-12 rf-grid-rows-1 rf-justify-center rf-items-end",
                children: [
                    /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $07bfc01d373e9b86$export$2e2bcd8739ae039), {
                        label: "text",
                        selected: parametersOpened ? false : mode === (0, $16ad089b9ce6627d$export$9484bbecc3c49a2e).text,
                        onClick: toggleMode
                    }),
                    mode === (0, $16ad089b9ce6627d$export$9484bbecc3c49a2e).vocal ? /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("div", {
                        className: "rf-py-2 rf-w-full rf-flex rf-justify-center",
                        children: /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $b4b3f77eb1eaf002$export$2e2bcd8739ae039), {
                            openMicrophone: fromTextToVocal
                        })
                    }) : /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $07bfc01d373e9b86$export$2e2bcd8739ae039), {
                        label: "vocal",
                        selected: false,
                        onClick: toggleMode
                    }),
                    /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $07bfc01d373e9b86$export$2e2bcd8739ae039), {
                        label: "dashboard",
                        selected: parametersOpened,
                        onClick: handleDashboardClick
                    })
                ]
            }),
            !parametersOpened && mode === (0, $16ad089b9ce6627d$export$9484bbecc3c49a2e).text && /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $cc51107c7c4d0305$export$2e2bcd8739ae039), {
                className: "rf-mx-3 rf-mt-2",
                withButton: currentDeviceType !== (0, $16ad089b9ce6627d$export$ec1e04e4e5ef8233).mobile
            }),
            !parametersOpened && mode === (0, $16ad089b9ce6627d$export$9484bbecc3c49a2e).vocal && /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $925563db5be72378$export$2e2bcd8739ae039), {
                className: "rf-w-full rf-px-6 rf-py-2"
            })
        ]
    });
};
var $6319f26798fc376a$export$2e2bcd8739ae039 = $6319f26798fc376a$var$Mobile;




var $eO7Kz = parcelRequire("eO7Kz");




const $222a71db719cd38c$var$ParametersAndDashboardContainer = ({ handleBack: handleBack, hideMenu: hideMenu = false })=>{
    const { locale: locale } = (0, $2e4dc8fa28d39601$export$6650dace022cfacc)();
    return /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsxs)("div", {
        className: "rf-w-full rf-h-full rf-flex rf-flex-col rf-py-4 rf-bg-truewhite rf-overflow-y-hidden rf-pointer-events-auto",
        children: [
            /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $53c3829f3df8be22$export$2e2bcd8739ae039), {
                title: (0, (/*@__PURE__*/$parcel$interopDefault($abbebf5de79f9da4$exports)))[locale]?.backconversation || (0, (/*@__PURE__*/$parcel$interopDefault($abbebf5de79f9da4$exports)))["fr-FR"].backconversation,
                className: "rf-px-4 rf-text-sm",
                handleBack: handleBack
            }),
            /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsxs)("div", {
                className: "rf-w-full rf-flex-rf-flex-col rf-overflow-y-scroll rf-scrollbar-hidden",
                children: [
                    !hideMenu && /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($eO7Kz))).Fragment, {
                        children: [
                            /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $4e7da85755ba84f6$export$2e2bcd8739ae039), {
                                toggleDashboard: handleBack
                            }),
                            /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("div", {
                                className: "rf-h-6 rf-bg-[#F0F0F0] rf-border-y rf-border-y-menuBorder"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsxs)("div", {
                        className: "rf-w-full rf-px-5 rf-flex rf-flex-col rf-justify-start",
                        children: [
                            /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("div", {
                                className: "rf-py-4 rf-text-lightgray",
                                children: (0, $8fd1ab545cc1ab7a$export$d07f57595c356899)((0, (/*@__PURE__*/$parcel$interopDefault($abbebf5de79f9da4$exports)))[locale]?.parameters || (0, (/*@__PURE__*/$parcel$interopDefault($abbebf5de79f9da4$exports)))["fr-FR"].parameters)
                            }),
                            /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $565625f6c996aee4$export$2e2bcd8739ae039), {
                                handleBack: handleBack
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $222a71db719cd38c$export$2e2bcd8739ae039 = $222a71db719cd38c$var$ParametersAndDashboardContainer;


const $643267d3ab597cd7$var$MobileContainer = ({ hideMenu: hideMenu })=>{
    const { setCurrentSubView: setCurrentSubView } = (0, $e599569c1fc3ca2c$export$d8760bee47331b1d)();
    const [parametersOpened, setParametersOpened] = (0, $eO7Kz.useState)(false);
    const toggleParameters = ()=>{
        setCurrentSubView((0, $16ad089b9ce6627d$export$f05d0fed0593ead7).none);
        setParametersOpened(!parametersOpened);
    };
    return /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsxs)((0, $5798dbaf1694ea15$export$2e2bcd8739ae039), {
        className: "large:rf-hidden rf-p-0 rf-m-0 rf-flex rf-flex-col-reverse rf-pointer-events-none vertical:rf-row-start-0 vertical:rf-row-end-13",
        depth: (0, $16ad089b9ce6627d$export$950556173b6cbecb).ui,
        background: "transparent",
        children: [
            /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $6319f26798fc376a$export$2e2bcd8739ae039), {
                parametersOpened: parametersOpened,
                toggleParameters: toggleParameters
            }),
            parametersOpened && /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $222a71db719cd38c$export$2e2bcd8739ae039), {
                handleBack: toggleParameters,
                hideMenu: hideMenu
            })
        ]
    });
};
var $643267d3ab597cd7$export$2e2bcd8739ae039 = $643267d3ab597cd7$var$MobileContainer;



const $e455745cc344e54e$var$MenuDisplayer = ({ hideMenu: hideMenu })=>{
    const { isMobile: isMobile, displayControls: displayControls } = (0, $8b59a4dbb18c269b$export$3abe3478af3cb63b)();
    return !displayControls ? /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eO7Kz))).Fragment, {}) : isMobile ? /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $643267d3ab597cd7$export$2e2bcd8739ae039), {
        hideMenu: !!hideMenu
    }) : /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($eO7Kz))).Fragment, {
        children: [
            /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $63604b0a3df09754$export$2e2bcd8739ae039), {
                hideMenu: !!hideMenu
            }),
            /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $03a0d44db8cf0b1b$export$2e2bcd8739ae039), {})
        ]
    });
};
var $e455745cc344e54e$export$2e2bcd8739ae039 = $e455745cc344e54e$var$MenuDisplayer;


const $477cbaf689c7fe12$var$HomeView = ({ chatbotData: chatbotData, externalComponents: externalComponents })=>{
    const { configuration: configuration, agentData: agentData } = (0, $e599569c1fc3ca2c$export$d8760bee47331b1d)();
    const { mode: mode } = (0, $e599569c1fc3ca2c$export$d8760bee47331b1d)();
    const { configurations: configurations, isMobile: isMobile, setDisplayControls: setDisplayControls } = (0, $8b59a4dbb18c269b$export$3abe3478af3cb63b)();
    const displayAgent = (0, $134592d23f105dbc$export$77e4cc5334565f28)((state)=>state.displayAgent);
    const displayData = (0, $eO7Kz.useMemo)(()=>{
        return configurations.views.home;
    }, [
        configurations
    ]);
    const lastAnimationQueue = (0, $6ab2a7bfc556faf0$export$2e2bcd8739ae039)();
    const { speaking: speaking, setSpeechAllowed: setSpeechAllowed } = (0, $633c6ef6f1f791c0$export$57e792e009c800a0)();
    const [animationQueue, setAnimationQueue] = (0, $eO7Kz.useState)([]);
    (0, $eO7Kz.useEffect)(()=>{
        lastAnimationQueue && setAnimationQueue(lastAnimationQueue);
    }, [
        lastAnimationQueue
    ]);
    (0, $eO7Kz.useEffect)(()=>{
        setSpeechAllowed(mode === (0, $16ad089b9ce6627d$export$9484bbecc3c49a2e).vocal);
        setDisplayControls(!configuration.hideControls);
    }, []);
    return /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($eO7Kz))).Fragment, {
        children: [
            /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $76554fe10d7587c9$export$2e2bcd8739ae039), {
                config: displayData.background
            }),
            configuration?.logo && (!isMobile || isMobile && mode !== (0, $16ad089b9ce6627d$export$9484bbecc3c49a2e).text) && /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $9856d835783ad65d$export$2e2bcd8739ae039), {}),
            (!isMobile || isMobile && mode !== (0, $16ad089b9ce6627d$export$9484bbecc3c49a2e).text) && chatbotData && agentData && displayAgent && /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($eO7Kz))).Fragment, {
                children: [
                    /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("div", {
                        className: "rf-relative rf-col-start-1 rf-col-end-9 large:rf-col-end-6 large-vertical:rf-col-end-9 rf-row-span-full rf-self-end rf-h-full",
                        children: /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $1ff9b34fabc7ea86$export$2e2bcd8739ae039), {
                            licence: "licence",
                            agentData: agentData,
                            height: chatbotData?.height,
                            size: chatbotData?.size,
                            speak: speaking,
                            animationQueue: animationQueue,
                            setAnimationQueue: setAnimationQueue
                        })
                    }),
                    /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $c0e24d884a46844c$export$2e2bcd8739ae039), {})
                ]
            }),
            configuration?.answerpanel !== false && /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($eO7Kz))).Fragment, {
                children: [
                    /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $eac94ac313894af3$export$2e2bcd8739ae039), {}),
                    mode === (0, $16ad089b9ce6627d$export$9484bbecc3c49a2e).vocal ? /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $42c0795976cacc7b$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $5c52ed9315e0e345$export$a1f3f6b0b496333e), {})
                ]
            }),
            /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $e455745cc344e54e$export$2e2bcd8739ae039), {
                hideMenu: configuration?.hideMenu
            }),
            /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $c2d87c743d37863b$export$2e2bcd8739ae039), {
                externalComponents: externalComponents
            }),
            !configuration?.hideRetorikLogo && /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $b149f92e325fd606$export$2e2bcd8739ae039), {})
        ]
    });
};
var $477cbaf689c7fe12$export$2e2bcd8739ae039 = $477cbaf689c7fe12$var$HomeView;


/* eslint-disable react/jsx-boolean-value */ 

var $eO7Kz = parcelRequire("eO7Kz");










var $eO7Kz = parcelRequire("eO7Kz");
var $ac27df041b6bee20$exports = {};
$ac27df041b6bee20$exports = JSON.parse('{"fr-FR":{"warningtext":"Vous allez acc\xe9der \xe0 la cha\xeene info, le son de votre appareil va \xeatre activ\xe9","warningcontinue":"Continuer","warningback":"Annuler","live":"direct","continuous":"en continu"},"en-US":{"warningtext":"You are about to access the information channel, the sound of your device will be activated","warningcontinue":"Continue","warningback":"Abort","live":"live","continuous":"continuous"},"es-ES":{"warningtext":"You are about to access the information channel, the sound of your device will be activated","warningcontinue":"Continue","warningback":"Abort","live":"live","continuous":"continuous"},"de-DE":{"warningtext":"You are about to access the information channel, the sound of your device will be activated","warningcontinue":"Continue","warningback":"Abort","live":"live","continuous":"continuous"}}');



const $3362a1e209fea3e0$var$Time = ({ belowReturnButton: belowReturnButton })=>{
    const { locale: locale } = (0, $2e4dc8fa28d39601$export$6650dace022cfacc)();
    const [time, setTime] = (0, $eO7Kz.useState)("");
    const timerRef = (0, $eO7Kz.useRef)(null);
    /**
   * Set current time (hours and minutes) depending on the locale (ex: adds AM/PM when needed)
   */ const setCurrentTime = ()=>{
        const now = new Date();
        setTime(now.toLocaleTimeString(locale, {
            hour: "2-digit",
            minute: "2-digit"
        }));
    };
    /**
   * On component mount :
   *  - set time
   *  - set interval for time update
   * On component unmount :
   *  - clear interval
   */ (0, $eO7Kz.useEffect)(()=>{
        setCurrentTime();
        timerRef && (timerRef.current = setInterval(setCurrentTime, 1000));
        return ()=>timerRef && clearInterval(timerRef.current);
    }, []);
    return /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("div", {
        className: `rf-relative ${belowReturnButton ? "rf-ml-4" : "rf-col-start-1 rf-col-span-2 rf-row-start-1 rf-row-span-2 rf-self-start rf-justify-self-start rf-m-4 large:rf-m-8"}`,
        children: /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsxs)("div", {
            className: "rf-w-fit rf-h-fit rf-flex rf-flex-col rf-justify-start rf-items-start rf-text-white",
            children: [
                /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("div", {
                    className: "rf-w-full rf-text-size-auto rf-px-3 rf-py-0 large:rf-px-4 large:rf-py-1 rf-text-center rf-font-semibold rf-bg-red-600 rf-whitespace-nowrap",
                    children: `${((0, (/*@__PURE__*/$parcel$interopDefault($ac27df041b6bee20$exports)))[locale]?.live || (0, (/*@__PURE__*/$parcel$interopDefault($ac27df041b6bee20$exports)))["fr-FR"].live).toLocaleUpperCase(locale)} \u25cf`
                }),
                /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("div", {
                    className: "rf-w-full rf-title-size-auto rf-px-3 rf-py-0 large:rf-px-4 large:rf-py-1 rf-text-center rf-font-bold rf-bg-blue-500",
                    children: time
                })
            ]
        })
    });
};
var $3362a1e209fea3e0$export$2e2bcd8739ae039 = $3362a1e209fea3e0$var$Time;




var $eO7Kz = parcelRequire("eO7Kz");




var $eO7Kz = parcelRequire("eO7Kz");


var $eO7Kz = parcelRequire("eO7Kz");





var $eO7Kz = parcelRequire("eO7Kz");



var $f4ba8d170aa5ac2b$exports = {};
$f4ba8d170aa5ac2b$exports = JSON.parse('{"fr-FR":{"loader":{"optimal":"Pour une exp\xe9rience optimale,","classic":"Pour une exp\xe9rience plus classique","vocal":"j\'\xe9change de vive voix avec l\'agent.","text":"j\'\xe9change \xe0 l\'\xe9crit avec l\'agent."},"loaderValidation":"D\xe9marrer la conversation","modes":{"vocal":"mode vocal","text":"mode texte"},"locale":"v\xe9rification de la langue","supported":"v\xe9rification des langues disponibles","store":"cr\xe9ation du store","directline":"connection au directline","ponyfill":"cr\xe9ation du ponyfill","addressdata":"r\xe9cup\xe9ration des donn\xe9es"},"en-US":{"loader":{"optimal":"For an optimal experience,","classic":"For a more classical experience,","vocal":"I communicate by speaking with the agent.","text":"I communicate by text with the agent."},"loaderValidation":"Start conversation","modes":{"vocal":"vocal mode","text":"text mode"},"locale":"checking locale","supported":"checking supported locales","store":"creating store","directline":"connecting directline","ponyfill":"ponyfilling","addressdata":"retrieving data"},"es-ES":{"loader":{"optimal":"For an optimal experience,","classic":"For a more classical experience,","vocal":"I communicate by speaking with the agent.","text":"I communicate by text with the agent."},"loaderValidation":"Start conversation","modes":{"vocal":"vocal mode","text":"text mode"},"locale":"checking locale","supported":"checking supported locales","store":"creating store","directline":"connecting directline","ponyfill":"ponyfilling","addressdata":"retrieving data"},"de-DE":{"loader":{"optimal":"For an optimal experience,","classic":"For a more classical experience,","vocal":"I communicate by speaking with the agent.","text":"I communicate by text with the agent."},"loaderValidation":"Start conversation","modes":{"vocal":"vocal mode","text":"text mode"},"locale":"checking locale","supported":"checking supported locales","store":"creating store","directline":"connecting directline","ponyfill":"ponyfilling","addressdata":"retrieving data"}}');




parcelRequire("eO7Kz");
const $cd1279e009cb1202$var$Animation = ()=>{
    return /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("div", {
        className: "rf-relative rf-loader rf-animate-loader rf-h-6 -rf-top-6 rf-rounded-half"
    });
};
var $cd1279e009cb1202$export$2e2bcd8739ae039 = $cd1279e009cb1202$var$Animation;





const $58598655f6490d49$var$LoaderCallToAction = ({ handleValidation: handleValidation })=>{
    const { mode: mode, setMode: setMode, configuration: { loaderInformationTexts: loaderInformationTexts, hideRetorikLogo: hideRetorikLogo } } = (0, $e599569c1fc3ca2c$export$d8760bee47331b1d)();
    const { locale: locale } = (0, $2e4dc8fa28d39601$export$6650dace022cfacc)();
    const { themeColors: themeColors, isMobile: isMobile } = (0, $8b59a4dbb18c269b$export$3abe3478af3cb63b)();
    const [textSize, setTextSize] = (0, $eO7Kz.useState)("landscape");
    const container = (0, $eO7Kz.useRef)(null);
    const dimensions = (0, $6860898abc4c0a4f$export$2e2bcd8739ae039)(container);
    const [hover, setHover] = (0, $eO7Kz.useState)(false);
    const animationColor = {
        "--rf-color-loader-animation": themeColors.loader.animation
    };
    /**
   * On container dimension change :
   *  - check which display mode is active (mobile, borne , landscape)
   *  - set text size depending on the display mode
   */ (0, $eO7Kz.useEffect)(()=>{
        let isPortrait = true;
        if (!(dimensions.width && dimensions.height && dimensions.width < dimensions.height)) isPortrait = false;
        if (dimensions.width && dimensions.width > 600) setTextSize(isPortrait ? "rf-text-lgcustom" : "rf-text-basecustom");
        else setTextSize("rf-text-sm");
    }, [
        dimensions
    ]);
    const handleChange = (modeId)=>{
        const tempMode = modeId === 1 ? (0, $16ad089b9ce6627d$export$9484bbecc3c49a2e).vocal : (0, $16ad089b9ce6627d$export$9484bbecc3c49a2e).text;
        setMode(tempMode);
    };
    return /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsxs)("div", {
        className: `rf-absolute rf-z-modal rf-top-0 rf-left-0 rf-h-full rf-w-full rf-flex rf-flex-col rf-items-center ${textSize}`,
        ref: container,
        style: {
            background: themeColors.loader.background,
            ...animationColor
        },
        children: [
            /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsxs)("div", {
                className: "rf-w-full rf-h-1/2 rf-pb-6 rf-flex rf-flex-col rf-items-center rf-justify-end",
                children: [
                    /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("div", {
                        className: "rf-w-6 rf-h-6 rf-mb-16",
                        children: /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $cd1279e009cb1202$export$2e2bcd8739ae039), {})
                    }),
                    /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsxs)("div", {
                        className: "rf-text-center",
                        style: {
                            color: themeColors.loader.text
                        },
                        children: [
                            loaderInformationTexts?.vocal.top && loaderInformationTexts.text.top ? /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("p", {
                                children: mode === (0, $16ad089b9ce6627d$export$9484bbecc3c49a2e).vocal ? loaderInformationTexts?.vocal.top : loaderInformationTexts.text.top
                            }) : /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("p", {
                                children: mode === (0, $16ad089b9ce6627d$export$9484bbecc3c49a2e).vocal ? (0, (/*@__PURE__*/$parcel$interopDefault($f4ba8d170aa5ac2b$exports)))[locale]?.loader.optimal || (0, (/*@__PURE__*/$parcel$interopDefault($f4ba8d170aa5ac2b$exports)))["fr-FR"].loader.optimal : (0, (/*@__PURE__*/$parcel$interopDefault($f4ba8d170aa5ac2b$exports)))[locale]?.loader.classic || (0, (/*@__PURE__*/$parcel$interopDefault($f4ba8d170aa5ac2b$exports)))["fr-FR"].loader.classic
                            }),
                            loaderInformationTexts?.vocal.top && loaderInformationTexts.text.top ? loaderInformationTexts?.vocal.bottom && loaderInformationTexts.text.bottom && /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("p", {
                                className: "rf-font-bold",
                                children: mode === (0, $16ad089b9ce6627d$export$9484bbecc3c49a2e).vocal ? loaderInformationTexts?.vocal.bottom : loaderInformationTexts.text.bottom
                            }) : /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("p", {
                                className: "rf-font-bold",
                                children: mode === (0, $16ad089b9ce6627d$export$9484bbecc3c49a2e).vocal ? (0, (/*@__PURE__*/$parcel$interopDefault($f4ba8d170aa5ac2b$exports)))[locale]?.loader.vocal || (0, (/*@__PURE__*/$parcel$interopDefault($f4ba8d170aa5ac2b$exports)))["fr-FR"].loader.vocal : (0, (/*@__PURE__*/$parcel$interopDefault($f4ba8d170aa5ac2b$exports)))[locale]?.loader.text || (0, (/*@__PURE__*/$parcel$interopDefault($f4ba8d170aa5ac2b$exports)))["fr-FR"].loader.text
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsxs)("div", {
                className: `rf-w-full rf-h-1/2 rf-flex rf-flex-col ${hideRetorikLogo ? "rf-justify-start" : "rf-justify-between"} rf-items-center`,
                children: [
                    /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsxs)("div", {
                        className: "rf-flex rf-flex-col rf-items-center",
                        children: [
                            /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $a6958f8775cfa233$export$2e2bcd8739ae039), {
                                texts: {
                                    left: (0, (/*@__PURE__*/$parcel$interopDefault($f4ba8d170aa5ac2b$exports)))[locale]?.modes.vocal || (0, (/*@__PURE__*/$parcel$interopDefault($f4ba8d170aa5ac2b$exports)))["fr-FR"].modes.vocal,
                                    leftId: 1,
                                    right: (0, (/*@__PURE__*/$parcel$interopDefault($f4ba8d170aa5ac2b$exports)))[locale]?.modes.text || (0, (/*@__PURE__*/$parcel$interopDefault($f4ba8d170aa5ac2b$exports)))["fr-FR"].modes.text,
                                    rightId: 2
                                },
                                colors: themeColors.loader.toggle,
                                defaultChecked: mode,
                                handleChange: handleChange
                            }),
                            /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("button", {
                                className: "rf-font-bold rf-border-2 rf-rounded-lg rf-px-6 rf-py-3 rf-mt-8",
                                style: {
                                    color: hover ? themeColors.loader.button.text.hover : themeColors.loader.button.text.default,
                                    borderColor: hover ? themeColors.loader.button.border.hover : themeColors.loader.button.border.default,
                                    background: hover ? themeColors.loader.button.background.hover : themeColors.loader.button.background.default
                                },
                                onClick: handleValidation,
                                onMouseEnter: ()=>setHover(true),
                                onMouseLeave: ()=>setHover(false),
                                children: (0, (/*@__PURE__*/$parcel$interopDefault($f4ba8d170aa5ac2b$exports)))[locale]?.loaderValidation || (0, (/*@__PURE__*/$parcel$interopDefault($f4ba8d170aa5ac2b$exports)))["fr-FR"].loaderValidation
                            })
                        ]
                    }),
                    !hideRetorikLogo && (isMobile ? /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $31dbbe0462359456$export$2e2bcd8739ae039), {
                        className: "rf-mb-10 rf-h-14"
                    }) : /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("div", {
                        className: "rf-w-full rf-flex rf-justify-start",
                        children: /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $31dbbe0462359456$export$2e2bcd8739ae039), {
                            className: "rf-ml-4 rf-mb-4 rf-h-14"
                        })
                    }))
                ]
            })
        ]
    });
};
var $58598655f6490d49$export$2e2bcd8739ae039 = $58598655f6490d49$var$LoaderCallToAction;


const $a32ae2aa400acc62$var$RetorikSpeech = ({ ponyfill: ponyfill, onEnd: onEnd, onError: onError, onStart: onStart, utterance: utterance, appAvailable: appAvailable })=>{
    const { loaderClosed: loaderClosed, setLoaderClosed: setLoaderClosed } = (0, $e599569c1fc3ca2c$export$d8760bee47331b1d)();
    const { speechAllowed: speechAllowed, muted: muted, setBoundaryData: setBoundaryData } = (0, $633c6ef6f1f791c0$export$57e792e009c800a0)();
    const { route: route } = (0, $8b59a4dbb18c269b$export$3abe3478af3cb63b)();
    const timerRef = (0, $eO7Kz.useRef)(null);
    const [boundaries, setBoundaries] = (0, $eO7Kz.useState)();
    /**
   * On utterance.text prop change :
   *  - check if the output speech is allowed from SpeechContext's speechAllowed state
   *  - if allowed : add start / end / error behaviour to the utterance, and start it
   *  - if not allowed : call handleStart method, and then handleEnd aftrer a little delay
   */ (0, $eO7Kz.useEffect)(()=>{
        if (utterance) {
            // If speech is allowed, let's play the utterance
            if (speechAllowed) {
                utterance.onstart = ()=>{
                    handleStart();
                };
                utterance.onend = ()=>{
                    setBoundaries([]);
                    handleEnd();
                };
                utterance.onerror = (event)=>{
                    handleError(event);
                };
                if (route !== "news") {
                    utterance.onsynthesiscompleted = ()=>{
                        const endBoundary = {
                            word: "",
                            startTime: 0,
                            endTime: 0,
                            boundaryType: "EndBoundary"
                        };
                        setBoundaries((prevData)=>{
                            return prevData ? [
                                ...prevData,
                                endBoundary
                            ] : [
                                endBoundary
                            ];
                        });
                    };
                    utterance.onboundary = (event)=>{
                        if (event.boundaryType !== "Viseme") {
                            // Get the current word and its start time and end time.
                            const word = event.name;
                            const startTime = event.elapsedTime;
                            const endTime = event.elapsedTime + event.duration;
                            const boundaryType = event.boundaryType;
                            // Update the boundaryData state with the new data.
                            setBoundaries((prevData)=>{
                                return [
                                    ...prevData ?? [],
                                    {
                                        word: word,
                                        startTime: startTime,
                                        endTime: endTime,
                                        boundaryType: boundaryType
                                    }
                                ];
                            });
                        }
                    };
                }
                /*
        utterance.onmark = (event): void => {
          // TODO
        }

        utterance.onviseme = (event): void => {
          // TODO
        }
        */ muted && ponyfill.speechSynthesis.mute();
                ponyfill.speechSynthesis.speak(utterance);
            } else {
                handleStart();
                timerRef && clearTimeout(timerRef.current);
                timerRef.current = setTimeout(()=>{
                    handleEnd();
                }, 50);
            }
        }
        return ()=>{
            ponyfill.speechSynthesis.cancel();
            timerRef && clearTimeout(timerRef.current);
        };
    }, [
        utterance?.text
    ]);
    (0, $eO7Kz.useEffect)(()=>{
        if (boundaries && boundaries.length > 0) setBoundaryData(boundaries);
        else setBoundaryData([]);
    }, [
        boundaries
    ]);
    (0, $eO7Kz.useEffect)(()=>{
        if (ponyfill.speechSynthesis) muted ? ponyfill.speechSynthesis.mute() : ponyfill.speechSynthesis.unmute();
    }, [
        muted
    ]);
    /**
   * On call :
   *  - call parent's onStart method if defined
   */ const handleStart = ()=>{
        onStart && onStart();
    };
    /**
   * On call :
   *  - call parent's onEnd method if defined
   */ const handleEnd = ()=>{
        onEnd && onEnd();
    };
    /**
   * On call :
   *  - log the error
   *  - call parent's onError method if defined
   */ const handleError = (error)=>{
        console.log("Error : ", error);
        onError && onError();
        setBoundaries([]);
    };
    /**
   * On call :
   *  - create basic utterance to be read to prime audio output
   *  - MANDATORY FOR SAFARI IN VOCAL MODE
   */ const primeRetorikSpeech = ()=>{
        const ssml = '<speak version="1.0" xmlns="http://www.w3.org/2001/10/synthesis" xmlns:mstts="https://www.w3.org/2001/mstts" xml:lang="fr-FR"><voice name="Microsoft Server Speech Text to Speech Voice (fr-FR, BrigitteNeural)"><prosody volume="-100%">Bonjour</prosody></voice></speak>';
        const primeUtterance = new ponyfill.SpeechSynthesisUtterance(ssml);
        primeUtterance.onend = ()=>setLoaderClosed(true);
        ponyfill.speechSynthesis.speak(primeUtterance);
        // Send animation start event to secure animation not playing on safari if permissions are not sufficient
        window.dispatchEvent(new Event("retorikSpiritEnginePlay"));
    };
    return appAvailable || loaderClosed ? /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eO7Kz))).Fragment, {}) : /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $58598655f6490d49$export$2e2bcd8739ae039), {
        handleValidation: primeRetorikSpeech
    });
};
$a32ae2aa400acc62$var$RetorikSpeech.defaultProps = {
    ponyfill: undefined,
    onEnd: undefined,
    onError: undefined,
    onStart: undefined,
    utterance: undefined,
    appAvailable: false
};
var $a32ae2aa400acc62$export$2e2bcd8739ae039 = $a32ae2aa400acc62$var$RetorikSpeech;




var $gySRD = parcelRequire("gySRD");

const $1a9f2bb97ec15549$var$buildSSML = (activity, speechMarkdownParser)=>{
    const textParsedAsSSML = speechMarkdownParser.toSSML(activity.speak || activity.text);
    return `<speak version="1.0" xmlns="http://www.w3.org/2001/10/synthesis" xmlns:mstts="https://www.w3.org/2001/mstts" xmlns:emo="http://www.w3.org/2009/10/emotionml" xml:lang="${activity.locale}">` + textParsedAsSSML + "</speak>";
};
function $1a9f2bb97ec15549$export$2e2bcd8739ae039({ ponyfill: ponyfill, selectVoice: selectVoice, activity: activity }) {
    const { speechSynthesis: speechSynthesis, SpeechSynthesisUtterance: SpeechSynthesisUtterance } = ponyfill;
    // If there is no text to be read, create an empty utterance that will be put in the array of ended activities
    if (!activity.speak && !activity.text) return new SpeechSynthesisUtterance();
    const voice = selectVoice(speechSynthesis.getVoices(), activity);
    const options = {
        platform: "microsoft-azure",
        includeSpeakTag: false,
        globalVoiceAndLang: {
            voice: voice.name,
            lang: voice.name.toLowerCase().includes("multilingual") ? activity.locale : undefined
        }
    };
    const speechMarkdownParser = new (0, $0005a2081ed17843$exports.SpeechMarkdown)(options);
    const utterance = new SpeechSynthesisUtterance($1a9f2bb97ec15549$var$buildSSML(activity, speechMarkdownParser));
    return utterance;
}



const $042d26de52de8436$var$SpeakNews = ({ news: news, onEnd: onEnd, ponyfill: ponyfill, activity: activity })=>{
    const { setSpeaking: setSpeaking, muted: muted } = (0, $633c6ef6f1f791c0$export$57e792e009c800a0)();
    const defaultLocale = (0, $2e4dc8fa28d39601$export$6650dace022cfacc)((state)=>state.locale);
    if (activity && activity.type === "message" && !activity.locale) activity.locale = defaultLocale;
    const selectVoice = (0, $gySRD.useVoiceSelector)(activity);
    const [utterance, setUtterance] = (0, $eO7Kz.useState)(null);
    (0, $eO7Kz.useEffect)(()=>{
        if (ponyfill) {
            const tempActivity = {
                ...activity,
                speak: `${news.title}, <break/> ${news.subtitle}: <break/> ${news.text}`
            };
            const utteranceParams = {
                ponyfill: ponyfill,
                selectVoice: selectVoice,
                activity: tempActivity,
                muted: muted
            };
            setUtterance((0, $1a9f2bb97ec15549$export$2e2bcd8739ae039)({
                ...utteranceParams
            }));
        }
        return ()=>setUtterance(null);
    }, [
        news
    ]);
    const handleStart = ()=>{
        setSpeaking(true);
        const startEvent = new Event("retorikSpeakStart");
        document.dispatchEvent(startEvent);
    };
    const handleEnd = ()=>{
        setSpeaking(false);
        const stopEvent = new Event("retorikSpeakStop");
        document.dispatchEvent(stopEvent);
        onEnd();
    };
    return utterance ? /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $a32ae2aa400acc62$export$2e2bcd8739ae039), {
        ponyfill: ponyfill,
        onEnd: handleEnd,
        onError: handleEnd,
        onStart: handleStart,
        utterance: utterance
    }) : null;
};
var $042d26de52de8436$export$2e2bcd8739ae039 = $042d26de52de8436$var$SpeakNews;


var $1276b8950dbad48b$exports = {};
"use strict";

var $clWYw = parcelRequire("clWYw");

var $cAvdA = parcelRequire("cAvdA");
Object.defineProperty($1276b8950dbad48b$exports, "__esModule", {
    value: true
});
Object.defineProperty($1276b8950dbad48b$exports, "createSpeechRecognitionPonyfill", {
    enumerable: true,
    get: function get() {
        return $1276b8950dbad48b$var$_SpeechToText.default;
    }
});
Object.defineProperty($1276b8950dbad48b$exports, "createSpeechRecognitionPonyfillFromRecognizer", {
    enumerable: true,
    get: function get() {
        return $1276b8950dbad48b$var$_SpeechToText.createSpeechRecognitionPonyfillFromRecognizer;
    }
});
Object.defineProperty($1276b8950dbad48b$exports, "createSpeechSynthesisPonyfill", {
    enumerable: true,
    get: function get() {
        return $1276b8950dbad48b$var$_TextToSpeech.default;
    }
});
$1276b8950dbad48b$exports.default = $1276b8950dbad48b$var$createSpeechServicesPonyfill;
Object.defineProperty($1276b8950dbad48b$exports, "fetchAuthorizationToken", {
    enumerable: true,
    get: function get() {
        return $1276b8950dbad48b$var$_fetchAuthorizationToken.default;
    }
});

var $1276b8950dbad48b$var$_defineProperty2 = $clWYw((parcelRequire("0ITDg")));

var $1276b8950dbad48b$var$_SpeechToText = $1276b8950dbad48b$var$_interopRequireWildcard((parcelRequire("hj0W0")));

var $1276b8950dbad48b$var$_TextToSpeech = $clWYw((parcelRequire("tFivm")));

var $1276b8950dbad48b$var$_fetchAuthorizationToken = $clWYw((parcelRequire("iWVEf")));
function $1276b8950dbad48b$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($1276b8950dbad48b$var$_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $1276b8950dbad48b$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || $cAvdA(obj) !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $1276b8950dbad48b$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $1276b8950dbad48b$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $1276b8950dbad48b$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $1276b8950dbad48b$var$ownKeys(Object(source), !0).forEach(function(key) {
            (0, $1276b8950dbad48b$var$_defineProperty2.default)(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $1276b8950dbad48b$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $1276b8950dbad48b$var$createSpeechServicesPonyfill() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
    var ponyfill = $1276b8950dbad48b$var$_objectSpread($1276b8950dbad48b$var$_objectSpread({}, $1276b8950dbad48b$var$_SpeechToText.default.apply(void 0, [
        options
    ].concat(args))), $1276b8950dbad48b$var$_TextToSpeech.default.apply(void 0, [
        options
    ].concat(args)));
    return $1276b8950dbad48b$var$_objectSpread($1276b8950dbad48b$var$_objectSpread({}, ponyfill), {}, {
        then: function then(resolve) {
            console.warn("web-speech-cognitive-services: This function no longer need to be called in an asynchronous fashion. Please update your code. We will remove this Promise.then function on or after 2020-08-10.");
            resolve(ponyfill);
        }
    });
}
var $1276b8950dbad48b$var$meta = document.createElement("meta");
$1276b8950dbad48b$var$meta.setAttribute("name", "web-speech-cognitive-services");
$1276b8950dbad48b$var$meta.setAttribute("content", "version=".concat("0.0.1-2"));
document.head.appendChild($1276b8950dbad48b$var$meta);




var $eO7Kz = parcelRequire("eO7Kz");




const $40dcf78a5d401cc3$var$Banner = ({ news: news })=>{
    const { locale: locale } = (0, $2e4dc8fa28d39601$export$6650dace022cfacc)();
    const { currentWidth: currentWidth, isMobile: isMobile } = (0, $8b59a4dbb18c269b$export$3abe3478af3cb63b)();
    const timerRef = (0, $eO7Kz.useRef)(null);
    const [scrollDuration, setScrollDuration] = (0, $eO7Kz.useState)(0);
    const [imageSize, setImageSize] = (0, $eO7Kz.useState)(0);
    const elementRef = (0, $eO7Kz.useRef)(null);
    /**
   * Set animation for text horizontal scrolling if necessary
   */ const updateDuration = ()=>{
        // Reset animation
        setScrollDuration(0);
        // Set animation, after a 1s timeout
        timerRef && (timerRef.current = setTimeout(()=>{
            setScrollDuration(Math.floor(news.text.length / 11));
        }, 1000));
    };
    /**
   * On news props change :
   *  - call updateDuration function
   * On component unmount :
   *  - clear timeout
   */ (0, $eO7Kz.useEffect)(()=>{
        updateDuration();
        return ()=>timerRef && clearTimeout(timerRef.current);
    }, [
        news
    ]);
    /**
   * On ref change :
   *  - set the width of the image container equal to the category container's width
   */ (0, $eO7Kz.useEffect)(()=>{
        elementRef.current && setImageSize(elementRef.current.clientWidth);
    }, [
        elementRef
    ]);
    return /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsxs)("div", {
        className: "rf-h-fit rf-col-start-1 rf-col-span-full rf-row-start-9 large:rf-row-start-10 rf-row-span-3 large:rf-mb-6 rf-flex rf-flex-col rf-self-end rf-items-center rf-glass-background rf-text-white",
        children: [
            /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsxs)("div", {
                className: "rf-w-full rf-flex rf-flex-row rf-justify-start rf-text-size-auto",
                children: [
                    /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("div", {
                        className: "rf-px-4 rf-pb-2 rf-pt-2 large:rf-pt-3 rf-font-bold rf-bg-red-600 rf-whitespace-nowrap",
                        ref: elementRef,
                        children: (news.category || (0, (/*@__PURE__*/$parcel$interopDefault($ac27df041b6bee20$exports)))[locale]?.continuous || (0, (/*@__PURE__*/$parcel$interopDefault($ac27df041b6bee20$exports)))["fr-FR"].continuous).toLocaleUpperCase(locale)
                    }),
                    /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("div", {
                        className: "rf-px-4 rf-mb-2 rf-mt-2 large:rf-mt-3 rf-font-bold rf-line-clamp-1",
                        children: news.title && news.title.toLocaleUpperCase(locale)
                    })
                ]
            }),
            /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsxs)("div", {
                className: "rf-w-full rf-h-fit rf-flex rf-flex-row rf-justify-start",
                children: [
                    isMobile && news.image?.url && /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("div", {
                        style: {
                            minWidth: `${imageSize}px`,
                            backgroundImage: `url(${news.image?.url})`,
                            backgroundSize: "cover",
                            backgroundRepeat: "no-repeat",
                            backgroundPosition: "center"
                        }
                    }),
                    /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("div", {
                        className: "rf-px-4 rf-my-2 large:rf-my-3 rf-title-large-size-auto rf-line-clamp-2",
                        children: news.subtitle ? (0, $8fd1ab545cc1ab7a$export$d07f57595c356899)(news.subtitle) : "..."
                    })
                ]
            }),
            /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("div", {
                className: "rf-w-full rf-pr-4 rf-py-4 rf-subtitle-size-auto rf-text-black rf-bg-white rf-overflow-clip",
                style: {
                    paddingLeft: currentWidth
                },
                children: scrollDuration !== 0 ? /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("p", {
                    className: "rf-w-max rf-whitespace-nowrap rf-animate-hScroll",
                    style: {
                        animation: `rf-hScroll ${scrollDuration}s infinite linear`,
                        paddingRight: currentWidth
                    },
                    children: news.text ? (0, $8fd1ab545cc1ab7a$export$d07f57595c356899)(news.text) : "..."
                }) : /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("p", {
                    className: "rf-w-max rf-whitespace-nowrap",
                    children: news.text ? (0, $8fd1ab545cc1ab7a$export$d07f57595c356899)(news.text) : "..."
                })
            })
        ]
    });
};
var $40dcf78a5d401cc3$export$2e2bcd8739ae039 = $40dcf78a5d401cc3$var$Banner;




var $gySRD = parcelRequire("gySRD");

const $a28e855fd90ae1af$var$useNews = ()=>{
    const [activities] = (0, $gySRD.useActivities)();
    if (!activities.length) return {
        newsAttachments: []
    };
    const activity = activities[activities.length - 1];
    if (!activity || !(activity.type === "event") || !activity.attachments?.length) return {
        newsAttachments: [],
        activity: activity
    };
    const newsAttachments = [];
    activity.attachments.forEach((attachment)=>{
        if (attachment.contentType === (0, $67e1576cd7fc37b7$export$7ff82c027074e396)) newsAttachments.push({
            contentType: (0, $67e1576cd7fc37b7$export$7ff82c027074e396),
            content: attachment.content || ""
        });
    });
    return {
        newsAttachments: newsAttachments,
        activity: activity
    };
};
var $a28e855fd90ae1af$export$2e2bcd8739ae039 = $a28e855fd90ae1af$var$useNews;



var $gySRD = parcelRequire("gySRD");
const $d8de746fa55ea478$var$News = ({ intervalInSeconds: intervalInSeconds = 3, onEnd: onEnd, isRetorikNews: isRetorikNews })=>{
    const { newsAttachments: newsAttachments, activity: activity } = (0, $a28e855fd90ae1af$export$2e2bcd8739ae039)();
    const { route: route, isMobile: isMobile } = (0, $8b59a4dbb18c269b$export$3abe3478af3cb63b)();
    const { ponyfillCredentials: ponyfillCredentials } = (0, $633c6ef6f1f791c0$export$57e792e009c800a0)();
    const news = (0, $eO7Kz.useMemo)(()=>{
        return newsAttachments.map((newsAttachement)=>newsAttachement.content);
    }, [
        newsAttachments
    ]);
    const sendEvent = (0, $gySRD.useSendEvent)();
    const [current, setCurrent] = (0, $eO7Kz.useState)(0);
    const [voicesLoaded, setVoicesLoaded] = (0, $eO7Kz.useState)(false);
    const timerRef = (0, $eO7Kz.useRef)(null);
    const ponyfill = (0, $eO7Kz.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($1276b8950dbad48b$exports)))({
            credentials: ponyfillCredentials
        }), [
        ponyfillCredentials
    ]);
    (0, $eO7Kz.useEffect)(()=>{
        if (!newsAttachments.length) sendEvent("news.getAllNews", null);
        return ()=>timerRef && clearTimeout(timerRef.current);
    }, []);
    const onVoicesChanged = ()=>{
        setVoicesLoaded(Array.isArray(ponyfill.speechSynthesis.getVoices()) && ponyfill.speechSynthesis.getVoices().length > 0);
    };
    (0, $eO7Kz.useEffect)(()=>{
        if (voicesLoaded === true) return;
        if (ponyfill && Array.isArray(ponyfill.speechSynthesis.getVoices()) && ponyfill.speechSynthesis.getVoices().length > 0) onVoicesChanged();
        else if (ponyfill) ponyfill.speechSynthesis.onvoiceschanged = onVoicesChanged;
    }, [
        ponyfill
    ]);
    const currentMedia = (0, $eO7Kz.useMemo)(()=>{
        const currentNew = news[current];
        if (currentNew) {
            if (currentNew.media && currentNew.media.length > 0) return currentNew.media;
            else if (currentNew.image && currentNew.image.url) return [
                currentNew.image
            ];
        }
        return [];
    }, [
        news,
        current
    ]);
    const handleEnd = ()=>{
        if (current < news.length - 1) {
            const delay = current < news.length - 1 ? intervalInSeconds : intervalInSeconds * 3;
            timerRef && clearTimeout(timerRef.current);
            if (route === "news" || isRetorikNews) timerRef.current = setTimeout(next, delay * 1000);
        } else onEnd();
    };
    const next = ()=>{
        const next = (current + 1) % news.length;
        changeNews(next);
    };
    const changeNews = (next)=>{
        setCurrent(next);
    };
    return news.length > 0 && voicesLoaded && current >= 0 ? /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($eO7Kz))).Fragment, {
        children: [
            /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $042d26de52de8436$export$2e2bcd8739ae039), {
                news: news[current],
                onEnd: handleEnd,
                ponyfill: ponyfill,
                activity: activity
            }),
            !isMobile && /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("div", {
                className: "rf-relative rf-col-start-5 rf-col-span-3 rf-row-start-1 rf-row-span-9 large-vertical:rf-col-start-2 large-vertical:rf-col-end-8 large-vertical:rf-row-start-7 large-vertical:rf-row-end-11 rf-flex rf-justify-center rf-items-center",
                children: currentMedia.length > 0 && /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $fff38b5425abcfb1$export$2e2bcd8739ae039), {
                    className: "rf-max-h-4/5 large-vertical:rf-max-h-11/12 rf-max-w-full",
                    medias: news[current].media || [
                        news[current].image || {
                            url: ""
                        }
                    ]
                })
            }),
            /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $40dcf78a5d401cc3$export$2e2bcd8739ae039), {
                news: news[current]
            })
        ]
    }) : /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eO7Kz))).Fragment, {});
};
var $d8de746fa55ea478$export$2e2bcd8739ae039 = $d8de746fa55ea478$var$News;






var // Steps enum
$373d04203a5f5c64$var$Steps;
(function($373d04203a5f5c64$var$Steps) {
    $373d04203a5f5c64$var$Steps[$373d04203a5f5c64$var$Steps["opening"] = 1] = "opening";
    $373d04203a5f5c64$var$Steps[$373d04203a5f5c64$var$Steps["news"] = 2] = "news";
    $373d04203a5f5c64$var$Steps[$373d04203a5f5c64$var$Steps["events"] = 3] = "events";
    $373d04203a5f5c64$var$Steps[$373d04203a5f5c64$var$Steps["weather"] = 4] = "weather";
    $373d04203a5f5c64$var$Steps[$373d04203a5f5c64$var$Steps["ending"] = 5] = "ending";
})($373d04203a5f5c64$var$Steps || ($373d04203a5f5c64$var$Steps = {}));
const $373d04203a5f5c64$var$NewsView = ({ chatbotData: chatbotData, hideMenu: hideMenu, isRetorikNews: isRetorikNews, handleEndedWithoutloop: handleEndedWithoutloop })=>{
    const locale = (0, $2e4dc8fa28d39601$export$6650dace022cfacc)((state)=>state.locale);
    const { configuration: configuration, agentData: agentData } = (0, $e599569c1fc3ca2c$export$d8760bee47331b1d)();
    const { configurations: configurations, setRoute: setRoute, isMobile: isMobile, currentDeviceType: currentDeviceType, setDisplayControls: setDisplayControls } = (0, $8b59a4dbb18c269b$export$3abe3478af3cb63b)();
    const [displayData, setDisplayData] = (0, $eO7Kz.useState)(configurations.views.news || configurations.views.home);
    const { speaking: speaking, setSpeechAllowed: setSpeechAllowed } = (0, $633c6ef6f1f791c0$export$57e792e009c800a0)();
    const lastAnimationQueue = (0, $6ab2a7bfc556faf0$export$2e2bcd8739ae039)();
    const [animationQueue, setAnimationQueue] = (0, $eO7Kz.useState)([]);
    const [step, setStep] = (0, $eO7Kz.useState)(configurations.views.news?.openingVideo ? $373d04203a5f5c64$var$Steps.opening : $373d04203a5f5c64$var$Steps.news);
    const timerRef = (0, $eO7Kz.useRef)(null);
    const newsEndedTimerRef = (0, $eO7Kz.useRef)(null);
    /**
   * On call :
   *  - if the component is news-only, return
   *  - else set ViewContext's route state to 'home'
   */ const handleBack = ()=>{
        if (isRetorikNews) return;
        setRoute("home");
    };
    (0, $eO7Kz.useEffect)(()=>{
        setSpeechAllowed(true);
        setDisplayControls(false);
    }, []);
    /**
   * On step change :
   *  - switch on the current step to launch corresponding processing
   * On component unmount :
   *  - clear timerRef timeout
   */ (0, $eO7Kz.useEffect)(()=>{
        switch(step){
            case $373d04203a5f5c64$var$Steps.opening:
                {
                    const videoUrl = configurations.views.news?.openingVideo;
                    videoUrl ? setViewContextCurrentConfiguration(videoUrl) : setStep($373d04203a5f5c64$var$Steps.news);
                    break;
                }
            case $373d04203a5f5c64$var$Steps.news:
                setDisplayData(configurations.views.news || configurations.views.home);
                break;
            case $373d04203a5f5c64$var$Steps.events:
                break;
            case $373d04203a5f5c64$var$Steps.weather:
                // If the position is known, display the weather page during 10 seconds, otherwise switch to the next step directly
                configuration.position?.latitude && configuration.position?.longitude ? timerRef.current = setTimeout(()=>{
                    setStep($373d04203a5f5c64$var$Steps.ending);
                }, 10000) : setStep($373d04203a5f5c64$var$Steps.ending);
                break;
            case $373d04203a5f5c64$var$Steps.ending:
                {
                    const videoUrl = configurations.views.news?.openingVideo;
                    videoUrl ? setViewContextCurrentConfiguration(videoUrl) : exitNewsOrLoop();
                    break;
                }
            default:
                break;
        }
        return ()=>{
            timerRef && clearTimeout(timerRef.current);
            newsEndedTimerRef && clearTimeout(newsEndedTimerRef.current);
        };
    }, [
        step
    ]);
    (0, $eO7Kz.useEffect)(()=>{
        lastAnimationQueue && setAnimationQueue(lastAnimationQueue);
    }, [
        lastAnimationQueue
    ]);
    /**
   * On call :
   *  - set the current display configuration to have the given video as background
   * @param videoUrl
   */ const setViewContextCurrentConfiguration = (videoUrl)=>{
        setDisplayData({
            ...configurations.views.news,
            background: {
                video: videoUrl,
                style: "video",
                blur: 0
            }
        });
    };
    /**
   * On call :
   *  - send the event 'newsEnded' used in retorik Kiosk
   *  - if the component is news-only :
   *    + if 'loop' is explicitly set to false, call props' handleEndedWithoutloop method if defined. Call handleBack method otherwise
   *    + if 'loop' is not false, loop by setting step state to Steps.news
   *  - or else if 'loop' parameter in configuration is true, get back to Steps.news step. Call handleBack method otherwise
   */ const exitNewsOrLoop = ()=>{
        // Send event 'newsEnded'
        const endEvent = new Event("newsEnded");
        document.dispatchEvent(endEvent);
        // Relaunch from the start if this is a news-only component and loop hasn't explicitly been set to false
        isRetorikNews ? displayData.loop !== false ? setStep($373d04203a5f5c64$var$Steps.news) : handleEndedWithoutloop ? handleEndedWithoutloop() : handleBack() : displayData.loop ? setStep($373d04203a5f5c64$var$Steps.news) : handleBack();
    };
    /**
   * On video end :
   *  - if we are at the opening step, let's set the step state to Steps.news to launch the news
   *  - if we are at the ending step, call exitNewsOrLoop function
   */ const handleVideoEnd = ()=>{
        switch(step){
            case $373d04203a5f5c64$var$Steps.opening:
                setStep($373d04203a5f5c64$var$Steps.news);
                break;
            case $373d04203a5f5c64$var$Steps.ending:
                exitNewsOrLoop();
                break;
        }
    };
    /**
   * On news end :
   *  - wait 3 seconds
   *  - get to the next step (Steps.events)
   */ const handleNewsEnd = ()=>{
        newsEndedTimerRef && (newsEndedTimerRef.current = setTimeout(()=>{
            // setStep(Steps.events)
            setStep($373d04203a5f5c64$var$Steps.weather);
        }, 3000));
    };
    return /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($eO7Kz))).Fragment, {
        children: [
            /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $76554fe10d7587c9$export$2e2bcd8739ae039), {
                config: displayData.background,
                videoLoop: false,
                videoMuted: false,
                onVideoEnded: handleVideoEnd
            }),
            isMobile && !isRetorikNews && !hideMenu ? /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsxs)("div", {
                className: "rf-relative rf-z-util rf-col-start-1 rf-col-span-full rf-row-start-1 rf-flex rf-flex-col rf-gap-2 rf-items-start",
                children: [
                    /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $53c3829f3df8be22$export$2e2bcd8739ae039), {
                        title: (0, (/*@__PURE__*/$parcel$interopDefault($abbebf5de79f9da4$exports)))[locale]?.back || (0, (/*@__PURE__*/$parcel$interopDefault($abbebf5de79f9da4$exports)))["fr-FR"].back,
                        handleBack: handleBack,
                        className: "rf-pr-2 rf-mt-4 rf-ml-4 rf-text-size-auto rf-bg-truewhite rf-rounded-lg"
                    }),
                    /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $3362a1e209fea3e0$export$2e2bcd8739ae039), {
                        belowReturnButton: true
                    })
                ]
            }) : /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $3362a1e209fea3e0$export$2e2bcd8739ae039), {}),
            step === $373d04203a5f5c64$var$Steps.news && agentData && /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($eO7Kz))).Fragment, {
                children: [
                    chatbotData && /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("div", {
                        className: `rf-relative rf-col-start-1 vertical:rf-col-span-full rf-col-span-5 rf-row-start-1 rf-row-span-full rf-self-end ${currentDeviceType === (0, $16ad089b9ce6627d$export$ec1e04e4e5ef8233).widget ? "rf-h-full" : "rf-h-screen"}`,
                        children: /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $1ff9b34fabc7ea86$export$2e2bcd8739ae039), {
                            licence: "licence",
                            agentData: agentData,
                            height: chatbotData?.height,
                            size: chatbotData?.size,
                            speak: speaking,
                            animationQueue: animationQueue,
                            setAnimationQueue: setAnimationQueue
                        })
                    }),
                    /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $d8de746fa55ea478$export$2e2bcd8739ae039), {
                        intervalInSeconds: displayData.intervalInSeconds ? displayData.intervalInSeconds : undefined,
                        onEnd: handleNewsEnd,
                        isRetorikNews: isRetorikNews
                    })
                ]
            }),
            step === $373d04203a5f5c64$var$Steps.weather && /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $5e6c500b0ab75272$export$2e2bcd8739ae039), {
                handleClose: handleBack
            }),
            !hideMenu && /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $4becae071fdebff0$export$2e2bcd8739ae039), {
                dashboardVisible: true,
                onClick: handleBack
            })
        ]
    });
};
var $373d04203a5f5c64$export$2e2bcd8739ae039 = $373d04203a5f5c64$var$NewsView;




var $eO7Kz = parcelRequire("eO7Kz");






const $a2895910d27c0cfa$var$WarningBeforeNewsView = ({ propsToTransfer: propsToTransfer })=>{
    const { setRoute: setRoute } = (0, $8b59a4dbb18c269b$export$3abe3478af3cb63b)();
    const locale = (0, $2e4dc8fa28d39601$export$6650dace022cfacc)((state)=>state.locale);
    const [waiting, setWaiting] = (0, $eO7Kz.useState)(true);
    (0, $eO7Kz.useEffect)(()=>{
        setWaiting(true);
    }, []);
    const handleClick = (goHome)=>{
        goHome ? setRoute("home") : setWaiting(false);
    };
    return waiting ? /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsxs)("div", {
        className: "rf-relative rf-z-util rf-col-start-1 rf-col-span-full rf-row-start-1 rf-row-span-full rf-flex rf-flex-col rf-gap-4 rf-justify-center rf-items-center rf-bg-truewhite",
        children: [
            /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $53c3829f3df8be22$export$2e2bcd8739ae039), {
                title: (0, (/*@__PURE__*/$parcel$interopDefault($abbebf5de79f9da4$exports)))[locale]?.back || (0, (/*@__PURE__*/$parcel$interopDefault($abbebf5de79f9da4$exports)))["fr-FR"].back,
                handleBack: ()=>handleClick(true),
                className: "rf-absolute rf-top-4 rf-left-4 rf-text-size-auto"
            }),
            /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("p", {
                className: "rf-px-4 rf-text-center",
                children: (0, (/*@__PURE__*/$parcel$interopDefault($ac27df041b6bee20$exports)))[locale]?.warningtext || (0, (/*@__PURE__*/$parcel$interopDefault($ac27df041b6bee20$exports)))["fr-FR"].warningtext
            }),
            /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("button", {
                className: "rf-card-button-secondary",
                onClick: ()=>handleClick(false),
                children: (0, (/*@__PURE__*/$parcel$interopDefault($ac27df041b6bee20$exports)))[locale]?.warningcontinue || (0, (/*@__PURE__*/$parcel$interopDefault($ac27df041b6bee20$exports)))["fr-FR"].warningcontinue
            }),
            /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("button", {
                className: "rf-card-button-secondary",
                onClick: ()=>handleClick(true),
                children: (0, (/*@__PURE__*/$parcel$interopDefault($ac27df041b6bee20$exports)))[locale]?.warningback || (0, (/*@__PURE__*/$parcel$interopDefault($ac27df041b6bee20$exports)))["fr-FR"].warningback
            })
        ]
    }) : /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $373d04203a5f5c64$export$2e2bcd8739ae039), {
        ...propsToTransfer
    });
};
var $a2895910d27c0cfa$export$2e2bcd8739ae039 = $a2895910d27c0cfa$var$WarningBeforeNewsView;



var $gySRD = parcelRequire("gySRD");
const $f1cd80aa27d674e7$var$RetorikRouter = (props)=>{
    const { setCurrentSubView: setCurrentSubView, mode: mode, configuration: { isUsedOnBorne: isUsedOnBorne } } = (0, $e599569c1fc3ca2c$export$d8760bee47331b1d)();
    const { route: route, setRoute: setRoute, homeActivityKey: homeActivityKey, setHomeActivityKey: setHomeActivityKey, setShowHomeAttachments: setShowHomeAttachments } = (0, $8b59a4dbb18c269b$export$3abe3478af3cb63b)();
    const getKeyByActivity = (0, $gySRD.useGetKeyByActivity)();
    const [activities] = (0, $gySRD.useActivities)();
    const lastEvent = (0, $d1f091fecbe0bca7$export$2e2bcd8739ae039)();
    (0, $eO7Kz.useEffect)(()=>{
        if (lastEvent && lastEvent.type === "event") switch(lastEvent.name){
            case "news.ShowFlashInfo":
                setRoute("news");
                break;
            case "weather.ShowWeather":
                setCurrentSubView((0, $16ad089b9ce6627d$export$f05d0fed0593ead7).weather);
                break;
            default:
                break;
        }
    }, [
        lastEvent
    ]);
    (0, $eO7Kz.useEffect)(()=>{
        if (!homeActivityKey) {
            const firstActivityId = activities.slice().find((activity)=>activity.type === "message" && activity.from?.role === "bot")?.replyToId;
            let attachments;
            if (firstActivityId) {
                attachments = activities.filter((activity)=>activity.replyToId === firstActivityId).reverse().find((act)=>act.attachments && act.attachments.length > 0);
                const key = attachments ? getKeyByActivity(attachments) : undefined;
                setHomeActivityKey(key);
            }
        }
        activities && activities.length > 0 && (activities[activities.length - 1].from?.role === "bot" || activities.some((a)=>a.name === "setUser")) && setShowHomeAttachments(undefined);
    }, [
        activities
    ]);
    return /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($eO7Kz))).Fragment, {
        children: [
            route === "home" && /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $477cbaf689c7fe12$export$2e2bcd8739ae039), {
                ...props
            }),
            route === "news" && (mode === (0, $16ad089b9ce6627d$export$9484bbecc3c49a2e).vocal || !!isUsedOnBorne ? /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $373d04203a5f5c64$export$2e2bcd8739ae039), {
                ...props
            }) : /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $a2895910d27c0cfa$export$2e2bcd8739ae039), {
                propsToTransfer: props
            }))
        ]
    });
};
var $f1cd80aa27d674e7$export$2e2bcd8739ae039 = $f1cd80aa27d674e7$var$RetorikRouter;




var $eO7Kz = parcelRequire("eO7Kz");





var $eO7Kz = parcelRequire("eO7Kz");



function $46f5813fece9e5dd$export$2e2bcd8739ae039() {
    const { configuration: configuration } = (0, $e599569c1fc3ca2c$export$d8760bee47331b1d)();
    const { currentDeviceType: currentDeviceType } = (0, $8b59a4dbb18c269b$export$3abe3478af3cb63b)();
    const [currentPagination, setCurrentPagination] = (0, $eO7Kz.useState)(10);
    (0, $eO7Kz.useEffect)(()=>{
        if (configuration && currentDeviceType) switch(currentDeviceType){
            case (0, $16ad089b9ce6627d$export$ec1e04e4e5ef8233).borne:
                setCurrentPagination(configuration.pagination?.borne || 15);
                break;
            case (0, $16ad089b9ce6627d$export$ec1e04e4e5ef8233).landscape:
                setCurrentPagination(configuration.pagination?.landscape || 20);
                break;
            case (0, $16ad089b9ce6627d$export$ec1e04e4e5ef8233).mobile:
            case (0, $16ad089b9ce6627d$export$ec1e04e4e5ef8233).widget:
                setCurrentPagination(configuration.pagination?.mobile || 12);
                break;
            default:
                break;
        }
        else setCurrentPagination(10);
    }, [
        configuration,
        currentDeviceType
    ]);
    return currentPagination;
}



var $3b92b5930fe5794d$exports = {};
"use strict";
Object.defineProperty($3b92b5930fe5794d$exports, "__esModule", {
    value: true
});
function $3b92b5930fe5794d$var$_interopDefault(ex) {
    return ex && typeof ex === "object" && "default" in ex ? ex["default"] : ex;
}

var $eO7Kz = parcelRequire("eO7Kz");
var $3b92b5930fe5794d$var$React__default = $3b92b5930fe5794d$var$_interopDefault($eO7Kz);

var $9oAFS = parcelRequire("9oAFS");
var $3b92b5930fe5794d$var$ClientUAInstance = new $9oAFS();
var $3b92b5930fe5794d$var$browser = $3b92b5930fe5794d$var$ClientUAInstance.getBrowser();
var $3b92b5930fe5794d$var$cpu = $3b92b5930fe5794d$var$ClientUAInstance.getCPU();
var $3b92b5930fe5794d$var$device = $3b92b5930fe5794d$var$ClientUAInstance.getDevice();
var $3b92b5930fe5794d$var$engine = $3b92b5930fe5794d$var$ClientUAInstance.getEngine();
var $3b92b5930fe5794d$var$os = $3b92b5930fe5794d$var$ClientUAInstance.getOS();
var $3b92b5930fe5794d$var$ua = $3b92b5930fe5794d$var$ClientUAInstance.getUA();
var $3b92b5930fe5794d$var$setUa = function setUa(userAgentString) {
    return $3b92b5930fe5794d$var$ClientUAInstance.setUA(userAgentString);
};
var $3b92b5930fe5794d$var$parseUserAgent = function parseUserAgent(userAgent) {
    if (!userAgent) {
        console.error("No userAgent string was provided");
        return;
    }
    var UserAgentInstance = new $9oAFS(userAgent);
    return {
        UA: UserAgentInstance,
        browser: UserAgentInstance.getBrowser(),
        cpu: UserAgentInstance.getCPU(),
        device: UserAgentInstance.getDevice(),
        engine: UserAgentInstance.getEngine(),
        os: UserAgentInstance.getOS(),
        ua: UserAgentInstance.getUA(),
        setUserAgent: function setUserAgent(userAgentString) {
            return UserAgentInstance.setUA(userAgentString);
        }
    };
};
var $3b92b5930fe5794d$var$UAHelper = /*#__PURE__*/ Object.freeze({
    ClientUAInstance: $3b92b5930fe5794d$var$ClientUAInstance,
    browser: $3b92b5930fe5794d$var$browser,
    cpu: $3b92b5930fe5794d$var$cpu,
    device: $3b92b5930fe5794d$var$device,
    engine: $3b92b5930fe5794d$var$engine,
    os: $3b92b5930fe5794d$var$os,
    ua: $3b92b5930fe5794d$var$ua,
    setUa: $3b92b5930fe5794d$var$setUa,
    parseUserAgent: $3b92b5930fe5794d$var$parseUserAgent
});
function $3b92b5930fe5794d$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $3b92b5930fe5794d$var$_objectSpread2(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $3b92b5930fe5794d$var$ownKeys(Object(source), true).forEach(function(key) {
            $3b92b5930fe5794d$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $3b92b5930fe5794d$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $3b92b5930fe5794d$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $3b92b5930fe5794d$var$_typeof = function(obj) {
        return typeof obj;
    };
    else $3b92b5930fe5794d$var$_typeof = function(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $3b92b5930fe5794d$var$_typeof(obj);
}
function $3b92b5930fe5794d$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $3b92b5930fe5794d$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $3b92b5930fe5794d$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $3b92b5930fe5794d$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $3b92b5930fe5794d$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $3b92b5930fe5794d$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $3b92b5930fe5794d$var$_extends() {
    $3b92b5930fe5794d$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $3b92b5930fe5794d$var$_extends.apply(this, arguments);
}
function $3b92b5930fe5794d$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $3b92b5930fe5794d$var$_setPrototypeOf(subClass, superClass);
}
function $3b92b5930fe5794d$var$_getPrototypeOf(o) {
    $3b92b5930fe5794d$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $3b92b5930fe5794d$var$_getPrototypeOf(o);
}
function $3b92b5930fe5794d$var$_setPrototypeOf(o, p) {
    $3b92b5930fe5794d$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $3b92b5930fe5794d$var$_setPrototypeOf(o, p);
}
function $3b92b5930fe5794d$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $3b92b5930fe5794d$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $3b92b5930fe5794d$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $3b92b5930fe5794d$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $3b92b5930fe5794d$var$_possibleConstructorReturn(self, call) {
    if (call && (typeof call === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $3b92b5930fe5794d$var$_assertThisInitialized(self);
}
function $3b92b5930fe5794d$var$_slicedToArray(arr, i) {
    return $3b92b5930fe5794d$var$_arrayWithHoles(arr) || $3b92b5930fe5794d$var$_iterableToArrayLimit(arr, i) || $3b92b5930fe5794d$var$_unsupportedIterableToArray(arr, i) || $3b92b5930fe5794d$var$_nonIterableRest();
}
function $3b92b5930fe5794d$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $3b92b5930fe5794d$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $3b92b5930fe5794d$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $3b92b5930fe5794d$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $3b92b5930fe5794d$var$_arrayLikeToArray(o, minLen);
}
function $3b92b5930fe5794d$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $3b92b5930fe5794d$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
var $3b92b5930fe5794d$var$DeviceTypes = {
    Mobile: "mobile",
    Tablet: "tablet",
    SmartTv: "smarttv",
    Console: "console",
    Wearable: "wearable",
    Embedded: "embedded",
    Browser: undefined
};
var $3b92b5930fe5794d$var$BrowserTypes = {
    Chrome: "Chrome",
    Firefox: "Firefox",
    Opera: "Opera",
    Yandex: "Yandex",
    Safari: "Safari",
    InternetExplorer: "Internet Explorer",
    Edge: "Edge",
    Chromium: "Chromium",
    Ie: "IE",
    MobileSafari: "Mobile Safari",
    EdgeChromium: "Edge Chromium",
    MIUI: "MIUI Browser",
    SamsungBrowser: "Samsung Browser"
};
var $3b92b5930fe5794d$var$OsTypes = {
    IOS: "iOS",
    Android: "Android",
    WindowsPhone: "Windows Phone",
    Windows: "Windows",
    MAC_OS: "Mac OS"
};
var $3b92b5930fe5794d$var$InitialDeviceTypes = {
    isMobile: false,
    isTablet: false,
    isBrowser: false,
    isSmartTV: false,
    isConsole: false,
    isWearable: false
};
var $3b92b5930fe5794d$var$checkDeviceType = function checkDeviceType(type) {
    switch(type){
        case $3b92b5930fe5794d$var$DeviceTypes.Mobile:
            return {
                isMobile: true
            };
        case $3b92b5930fe5794d$var$DeviceTypes.Tablet:
            return {
                isTablet: true
            };
        case $3b92b5930fe5794d$var$DeviceTypes.SmartTv:
            return {
                isSmartTV: true
            };
        case $3b92b5930fe5794d$var$DeviceTypes.Console:
            return {
                isConsole: true
            };
        case $3b92b5930fe5794d$var$DeviceTypes.Wearable:
            return {
                isWearable: true
            };
        case $3b92b5930fe5794d$var$DeviceTypes.Browser:
            return {
                isBrowser: true
            };
        case $3b92b5930fe5794d$var$DeviceTypes.Embedded:
            return {
                isEmbedded: true
            };
        default:
            return $3b92b5930fe5794d$var$InitialDeviceTypes;
    }
};
var $3b92b5930fe5794d$var$setUserAgent = function setUserAgent(userAgent) {
    return $3b92b5930fe5794d$var$setUa(userAgent);
};
var $3b92b5930fe5794d$var$setDefaults = function setDefaults(p) {
    var d = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "none";
    return p ? p : d;
};
var $3b92b5930fe5794d$var$getNavigatorInstance = function getNavigatorInstance() {
    if (typeof window !== "undefined") {
        if (window.navigator || navigator) return window.navigator || navigator;
    }
    return false;
};
var $3b92b5930fe5794d$var$isIOS13Check = function isIOS13Check(type) {
    var nav = $3b92b5930fe5794d$var$getNavigatorInstance();
    return nav && nav.platform && (nav.platform.indexOf(type) !== -1 || nav.platform === "MacIntel" && nav.maxTouchPoints > 1 && !window.MSStream);
};
var $3b92b5930fe5794d$var$browserPayload = function browserPayload(isBrowser, browser, engine, os, ua) {
    return {
        isBrowser: isBrowser,
        browserMajorVersion: $3b92b5930fe5794d$var$setDefaults(browser.major),
        browserFullVersion: $3b92b5930fe5794d$var$setDefaults(browser.version),
        browserName: $3b92b5930fe5794d$var$setDefaults(browser.name),
        engineName: $3b92b5930fe5794d$var$setDefaults(engine.name),
        engineVersion: $3b92b5930fe5794d$var$setDefaults(engine.version),
        osName: $3b92b5930fe5794d$var$setDefaults(os.name),
        osVersion: $3b92b5930fe5794d$var$setDefaults(os.version),
        userAgent: $3b92b5930fe5794d$var$setDefaults(ua)
    };
};
var $3b92b5930fe5794d$var$mobilePayload = function mobilePayload(type, device, os, ua) {
    return $3b92b5930fe5794d$var$_objectSpread2({}, type, {
        vendor: $3b92b5930fe5794d$var$setDefaults(device.vendor),
        model: $3b92b5930fe5794d$var$setDefaults(device.model),
        os: $3b92b5930fe5794d$var$setDefaults(os.name),
        osVersion: $3b92b5930fe5794d$var$setDefaults(os.version),
        ua: $3b92b5930fe5794d$var$setDefaults(ua)
    });
};
var $3b92b5930fe5794d$var$smartTvPayload = function smartTvPayload(isSmartTV, engine, os, ua) {
    return {
        isSmartTV: isSmartTV,
        engineName: $3b92b5930fe5794d$var$setDefaults(engine.name),
        engineVersion: $3b92b5930fe5794d$var$setDefaults(engine.version),
        osName: $3b92b5930fe5794d$var$setDefaults(os.name),
        osVersion: $3b92b5930fe5794d$var$setDefaults(os.version),
        userAgent: $3b92b5930fe5794d$var$setDefaults(ua)
    };
};
var $3b92b5930fe5794d$var$consolePayload = function consolePayload(isConsole, engine, os, ua) {
    return {
        isConsole: isConsole,
        engineName: $3b92b5930fe5794d$var$setDefaults(engine.name),
        engineVersion: $3b92b5930fe5794d$var$setDefaults(engine.version),
        osName: $3b92b5930fe5794d$var$setDefaults(os.name),
        osVersion: $3b92b5930fe5794d$var$setDefaults(os.version),
        userAgent: $3b92b5930fe5794d$var$setDefaults(ua)
    };
};
var $3b92b5930fe5794d$var$wearablePayload = function wearablePayload(isWearable, engine, os, ua) {
    return {
        isWearable: isWearable,
        engineName: $3b92b5930fe5794d$var$setDefaults(engine.name),
        engineVersion: $3b92b5930fe5794d$var$setDefaults(engine.version),
        osName: $3b92b5930fe5794d$var$setDefaults(os.name),
        osVersion: $3b92b5930fe5794d$var$setDefaults(os.version),
        userAgent: $3b92b5930fe5794d$var$setDefaults(ua)
    };
};
var $3b92b5930fe5794d$var$embeddedPayload = function embeddedPayload(isEmbedded, device, engine, os, ua) {
    return {
        isEmbedded: isEmbedded,
        vendor: $3b92b5930fe5794d$var$setDefaults(device.vendor),
        model: $3b92b5930fe5794d$var$setDefaults(device.model),
        engineName: $3b92b5930fe5794d$var$setDefaults(engine.name),
        engineVersion: $3b92b5930fe5794d$var$setDefaults(engine.version),
        osName: $3b92b5930fe5794d$var$setDefaults(os.name),
        osVersion: $3b92b5930fe5794d$var$setDefaults(os.version),
        userAgent: $3b92b5930fe5794d$var$setDefaults(ua)
    };
};
function $3b92b5930fe5794d$var$deviceDetect(userAgent) {
    var _ref = userAgent ? $3b92b5930fe5794d$var$parseUserAgent(userAgent) : $3b92b5930fe5794d$var$UAHelper, device = _ref.device, browser = _ref.browser, engine = _ref.engine, os = _ref.os, ua = _ref.ua;
    var type = $3b92b5930fe5794d$var$checkDeviceType(device.type);
    var isBrowser = type.isBrowser, isMobile = type.isMobile, isTablet = type.isTablet, isSmartTV = type.isSmartTV, isConsole = type.isConsole, isWearable = type.isWearable, isEmbedded = type.isEmbedded;
    if (isBrowser) return $3b92b5930fe5794d$var$browserPayload(isBrowser, browser, engine, os, ua);
    if (isSmartTV) return $3b92b5930fe5794d$var$smartTvPayload(isSmartTV, engine, os, ua);
    if (isConsole) return $3b92b5930fe5794d$var$consolePayload(isConsole, engine, os, ua);
    if (isMobile) return $3b92b5930fe5794d$var$mobilePayload(type, device, os, ua);
    if (isTablet) return $3b92b5930fe5794d$var$mobilePayload(type, device, os, ua);
    if (isWearable) return $3b92b5930fe5794d$var$wearablePayload(isWearable, engine, os, ua);
    if (isEmbedded) return $3b92b5930fe5794d$var$embeddedPayload(isEmbedded, device, engine, os, ua);
}
var $3b92b5930fe5794d$var$isMobileType = function isMobileType(_ref) {
    var type = _ref.type;
    return type === $3b92b5930fe5794d$var$DeviceTypes.Mobile;
};
var $3b92b5930fe5794d$var$isTabletType = function isTabletType(_ref2) {
    var type = _ref2.type;
    return type === $3b92b5930fe5794d$var$DeviceTypes.Tablet;
};
var $3b92b5930fe5794d$var$isMobileAndTabletType = function isMobileAndTabletType(_ref3) {
    var type = _ref3.type;
    return type === $3b92b5930fe5794d$var$DeviceTypes.Mobile || type === $3b92b5930fe5794d$var$DeviceTypes.Tablet;
};
var $3b92b5930fe5794d$var$isSmartTVType = function isSmartTVType(_ref4) {
    var type = _ref4.type;
    return type === $3b92b5930fe5794d$var$DeviceTypes.SmartTv;
};
var $3b92b5930fe5794d$var$isBrowserType = function isBrowserType(_ref5) {
    var type = _ref5.type;
    return type === $3b92b5930fe5794d$var$DeviceTypes.Browser;
};
var $3b92b5930fe5794d$var$isWearableType = function isWearableType(_ref6) {
    var type = _ref6.type;
    return type === $3b92b5930fe5794d$var$DeviceTypes.Wearable;
};
var $3b92b5930fe5794d$var$isConsoleType = function isConsoleType(_ref7) {
    var type = _ref7.type;
    return type === $3b92b5930fe5794d$var$DeviceTypes.Console;
};
var $3b92b5930fe5794d$var$isEmbeddedType = function isEmbeddedType(_ref8) {
    var type = _ref8.type;
    return type === $3b92b5930fe5794d$var$DeviceTypes.Embedded;
};
var $3b92b5930fe5794d$var$getMobileVendor = function getMobileVendor(_ref9) {
    var vendor = _ref9.vendor;
    return $3b92b5930fe5794d$var$setDefaults(vendor);
};
var $3b92b5930fe5794d$var$getMobileModel = function getMobileModel(_ref10) {
    var model = _ref10.model;
    return $3b92b5930fe5794d$var$setDefaults(model);
};
var $3b92b5930fe5794d$var$getDeviceType = function getDeviceType(_ref11) {
    var type = _ref11.type;
    return $3b92b5930fe5794d$var$setDefaults(type, "browser");
}; // os types
var $3b92b5930fe5794d$var$isAndroidType = function isAndroidType(_ref12) {
    var name = _ref12.name;
    return name === $3b92b5930fe5794d$var$OsTypes.Android;
};
var $3b92b5930fe5794d$var$isWindowsType = function isWindowsType(_ref13) {
    var name = _ref13.name;
    return name === $3b92b5930fe5794d$var$OsTypes.Windows;
};
var $3b92b5930fe5794d$var$isMacOsType = function isMacOsType(_ref14) {
    var name = _ref14.name;
    return name === $3b92b5930fe5794d$var$OsTypes.MAC_OS;
};
var $3b92b5930fe5794d$var$isWinPhoneType = function isWinPhoneType(_ref15) {
    var name = _ref15.name;
    return name === $3b92b5930fe5794d$var$OsTypes.WindowsPhone;
};
var $3b92b5930fe5794d$var$isIOSType = function isIOSType(_ref16) {
    var name = _ref16.name;
    return name === $3b92b5930fe5794d$var$OsTypes.IOS;
};
var $3b92b5930fe5794d$var$getOsVersion = function getOsVersion(_ref17) {
    var version = _ref17.version;
    return $3b92b5930fe5794d$var$setDefaults(version);
};
var $3b92b5930fe5794d$var$getOsName = function getOsName(_ref18) {
    var name = _ref18.name;
    return $3b92b5930fe5794d$var$setDefaults(name);
}; // browser types
var $3b92b5930fe5794d$var$isChromeType = function isChromeType(_ref19) {
    var name = _ref19.name;
    return name === $3b92b5930fe5794d$var$BrowserTypes.Chrome;
};
var $3b92b5930fe5794d$var$isFirefoxType = function isFirefoxType(_ref20) {
    var name = _ref20.name;
    return name === $3b92b5930fe5794d$var$BrowserTypes.Firefox;
};
var $3b92b5930fe5794d$var$isChromiumType = function isChromiumType(_ref21) {
    var name = _ref21.name;
    return name === $3b92b5930fe5794d$var$BrowserTypes.Chromium;
};
var $3b92b5930fe5794d$var$isEdgeType = function isEdgeType(_ref22) {
    var name = _ref22.name;
    return name === $3b92b5930fe5794d$var$BrowserTypes.Edge;
};
var $3b92b5930fe5794d$var$isYandexType = function isYandexType(_ref23) {
    var name = _ref23.name;
    return name === $3b92b5930fe5794d$var$BrowserTypes.Yandex;
};
var $3b92b5930fe5794d$var$isSafariType = function isSafariType(_ref24) {
    var name = _ref24.name;
    return name === $3b92b5930fe5794d$var$BrowserTypes.Safari || name === $3b92b5930fe5794d$var$BrowserTypes.MobileSafari;
};
var $3b92b5930fe5794d$var$isMobileSafariType = function isMobileSafariType(_ref25) {
    var name = _ref25.name;
    return name === $3b92b5930fe5794d$var$BrowserTypes.MobileSafari;
};
var $3b92b5930fe5794d$var$isOperaType = function isOperaType(_ref26) {
    var name = _ref26.name;
    return name === $3b92b5930fe5794d$var$BrowserTypes.Opera;
};
var $3b92b5930fe5794d$var$isIEType = function isIEType(_ref27) {
    var name = _ref27.name;
    return name === $3b92b5930fe5794d$var$BrowserTypes.InternetExplorer || name === $3b92b5930fe5794d$var$BrowserTypes.Ie;
};
var $3b92b5930fe5794d$var$isMIUIType = function isMIUIType(_ref28) {
    var name = _ref28.name;
    return name === $3b92b5930fe5794d$var$BrowserTypes.MIUI;
};
var $3b92b5930fe5794d$var$isSamsungBrowserType = function isSamsungBrowserType(_ref29) {
    var name = _ref29.name;
    return name === $3b92b5930fe5794d$var$BrowserTypes.SamsungBrowser;
};
var $3b92b5930fe5794d$var$getBrowserFullVersion = function getBrowserFullVersion(_ref30) {
    var version = _ref30.version;
    return $3b92b5930fe5794d$var$setDefaults(version);
};
var $3b92b5930fe5794d$var$getBrowserVersion = function getBrowserVersion(_ref31) {
    var major = _ref31.major;
    return $3b92b5930fe5794d$var$setDefaults(major);
};
var $3b92b5930fe5794d$var$getBrowserName = function getBrowserName(_ref32) {
    var name = _ref32.name;
    return $3b92b5930fe5794d$var$setDefaults(name);
}; // engine types
var $3b92b5930fe5794d$var$getEngineName = function getEngineName(_ref33) {
    var name = _ref33.name;
    return $3b92b5930fe5794d$var$setDefaults(name);
};
var $3b92b5930fe5794d$var$getEngineVersion = function getEngineVersion(_ref34) {
    var version = _ref34.version;
    return $3b92b5930fe5794d$var$setDefaults(version);
};
var $3b92b5930fe5794d$var$isElectronType = function isElectronType() {
    var nav = $3b92b5930fe5794d$var$getNavigatorInstance();
    var ua = nav && nav.userAgent && nav.userAgent.toLowerCase();
    return typeof ua === "string" ? /electron/.test(ua) : false;
};
var $3b92b5930fe5794d$var$isEdgeChromiumType = function isEdgeChromiumType(ua) {
    return typeof ua === "string" && ua.indexOf("Edg/") !== -1;
};
var $3b92b5930fe5794d$var$getIOS13 = function getIOS13() {
    var nav = $3b92b5930fe5794d$var$getNavigatorInstance();
    return nav && (/iPad|iPhone|iPod/.test(nav.platform) || nav.platform === "MacIntel" && nav.maxTouchPoints > 1) && !window.MSStream;
};
var $3b92b5930fe5794d$var$getIPad13 = function getIPad13() {
    return $3b92b5930fe5794d$var$isIOS13Check("iPad");
};
var $3b92b5930fe5794d$var$getIphone13 = function getIphone13() {
    return $3b92b5930fe5794d$var$isIOS13Check("iPhone");
};
var $3b92b5930fe5794d$var$getIPod13 = function getIPod13() {
    return $3b92b5930fe5794d$var$isIOS13Check("iPod");
};
var $3b92b5930fe5794d$var$getUseragent = function getUseragent(userAg) {
    return $3b92b5930fe5794d$var$setDefaults(userAg);
};
function $3b92b5930fe5794d$var$buildSelectorsObject(options) {
    var _ref = options ? options : $3b92b5930fe5794d$var$UAHelper, device = _ref.device, browser = _ref.browser, os = _ref.os, engine = _ref.engine, ua = _ref.ua;
    return {
        isSmartTV: $3b92b5930fe5794d$var$isSmartTVType(device),
        isConsole: $3b92b5930fe5794d$var$isConsoleType(device),
        isWearable: $3b92b5930fe5794d$var$isWearableType(device),
        isEmbedded: $3b92b5930fe5794d$var$isEmbeddedType(device),
        isMobileSafari: $3b92b5930fe5794d$var$isMobileSafariType(browser) || $3b92b5930fe5794d$var$getIPad13(),
        isChromium: $3b92b5930fe5794d$var$isChromiumType(browser),
        isMobile: $3b92b5930fe5794d$var$isMobileAndTabletType(device) || $3b92b5930fe5794d$var$getIPad13(),
        isMobileOnly: $3b92b5930fe5794d$var$isMobileType(device),
        isTablet: $3b92b5930fe5794d$var$isTabletType(device) || $3b92b5930fe5794d$var$getIPad13(),
        isBrowser: $3b92b5930fe5794d$var$isBrowserType(device),
        isDesktop: $3b92b5930fe5794d$var$isBrowserType(device),
        isAndroid: $3b92b5930fe5794d$var$isAndroidType(os),
        isWinPhone: $3b92b5930fe5794d$var$isWinPhoneType(os),
        isIOS: $3b92b5930fe5794d$var$isIOSType(os) || $3b92b5930fe5794d$var$getIPad13(),
        isChrome: $3b92b5930fe5794d$var$isChromeType(browser),
        isFirefox: $3b92b5930fe5794d$var$isFirefoxType(browser),
        isSafari: $3b92b5930fe5794d$var$isSafariType(browser),
        isOpera: $3b92b5930fe5794d$var$isOperaType(browser),
        isIE: $3b92b5930fe5794d$var$isIEType(browser),
        osVersion: $3b92b5930fe5794d$var$getOsVersion(os),
        osName: $3b92b5930fe5794d$var$getOsName(os),
        fullBrowserVersion: $3b92b5930fe5794d$var$getBrowserFullVersion(browser),
        browserVersion: $3b92b5930fe5794d$var$getBrowserVersion(browser),
        browserName: $3b92b5930fe5794d$var$getBrowserName(browser),
        mobileVendor: $3b92b5930fe5794d$var$getMobileVendor(device),
        mobileModel: $3b92b5930fe5794d$var$getMobileModel(device),
        engineName: $3b92b5930fe5794d$var$getEngineName(engine),
        engineVersion: $3b92b5930fe5794d$var$getEngineVersion(engine),
        getUA: $3b92b5930fe5794d$var$getUseragent(ua),
        isEdge: $3b92b5930fe5794d$var$isEdgeType(browser) || $3b92b5930fe5794d$var$isEdgeChromiumType(ua),
        isYandex: $3b92b5930fe5794d$var$isYandexType(browser),
        deviceType: $3b92b5930fe5794d$var$getDeviceType(device),
        isIOS13: $3b92b5930fe5794d$var$getIOS13(),
        isIPad13: $3b92b5930fe5794d$var$getIPad13(),
        isIPhone13: $3b92b5930fe5794d$var$getIphone13(),
        isIPod13: $3b92b5930fe5794d$var$getIPod13(),
        isElectron: $3b92b5930fe5794d$var$isElectronType(),
        isEdgeChromium: $3b92b5930fe5794d$var$isEdgeChromiumType(ua),
        isLegacyEdge: $3b92b5930fe5794d$var$isEdgeType(browser) && !$3b92b5930fe5794d$var$isEdgeChromiumType(ua),
        isWindows: $3b92b5930fe5794d$var$isWindowsType(os),
        isMacOs: $3b92b5930fe5794d$var$isMacOsType(os),
        isMIUI: $3b92b5930fe5794d$var$isMIUIType(browser),
        isSamsungBrowser: $3b92b5930fe5794d$var$isSamsungBrowserType(browser)
    };
}
var $3b92b5930fe5794d$var$isSmartTV = $3b92b5930fe5794d$var$isSmartTVType($3b92b5930fe5794d$var$device);
var $3b92b5930fe5794d$var$isConsole = $3b92b5930fe5794d$var$isConsoleType($3b92b5930fe5794d$var$device);
var $3b92b5930fe5794d$var$isWearable = $3b92b5930fe5794d$var$isWearableType($3b92b5930fe5794d$var$device);
var $3b92b5930fe5794d$var$isEmbedded = $3b92b5930fe5794d$var$isEmbeddedType($3b92b5930fe5794d$var$device);
var $3b92b5930fe5794d$var$isMobileSafari = $3b92b5930fe5794d$var$isMobileSafariType($3b92b5930fe5794d$var$browser) || $3b92b5930fe5794d$var$getIPad13();
var $3b92b5930fe5794d$var$isChromium = $3b92b5930fe5794d$var$isChromiumType($3b92b5930fe5794d$var$browser);
var $3b92b5930fe5794d$var$isMobile = $3b92b5930fe5794d$var$isMobileAndTabletType($3b92b5930fe5794d$var$device) || $3b92b5930fe5794d$var$getIPad13();
var $3b92b5930fe5794d$var$isMobileOnly = $3b92b5930fe5794d$var$isMobileType($3b92b5930fe5794d$var$device);
var $3b92b5930fe5794d$var$isTablet = $3b92b5930fe5794d$var$isTabletType($3b92b5930fe5794d$var$device) || $3b92b5930fe5794d$var$getIPad13();
var $3b92b5930fe5794d$var$isBrowser = $3b92b5930fe5794d$var$isBrowserType($3b92b5930fe5794d$var$device);
var $3b92b5930fe5794d$var$isDesktop = $3b92b5930fe5794d$var$isBrowserType($3b92b5930fe5794d$var$device);
var $3b92b5930fe5794d$var$isAndroid = $3b92b5930fe5794d$var$isAndroidType($3b92b5930fe5794d$var$os);
var $3b92b5930fe5794d$var$isWinPhone = $3b92b5930fe5794d$var$isWinPhoneType($3b92b5930fe5794d$var$os);
var $3b92b5930fe5794d$var$isIOS = $3b92b5930fe5794d$var$isIOSType($3b92b5930fe5794d$var$os) || $3b92b5930fe5794d$var$getIPad13();
var $3b92b5930fe5794d$var$isChrome = $3b92b5930fe5794d$var$isChromeType($3b92b5930fe5794d$var$browser);
var $3b92b5930fe5794d$var$isFirefox = $3b92b5930fe5794d$var$isFirefoxType($3b92b5930fe5794d$var$browser);
var $3b92b5930fe5794d$var$isSafari = $3b92b5930fe5794d$var$isSafariType($3b92b5930fe5794d$var$browser);
var $3b92b5930fe5794d$var$isOpera = $3b92b5930fe5794d$var$isOperaType($3b92b5930fe5794d$var$browser);
var $3b92b5930fe5794d$var$isIE = $3b92b5930fe5794d$var$isIEType($3b92b5930fe5794d$var$browser);
var $3b92b5930fe5794d$var$osVersion = $3b92b5930fe5794d$var$getOsVersion($3b92b5930fe5794d$var$os);
var $3b92b5930fe5794d$var$osName = $3b92b5930fe5794d$var$getOsName($3b92b5930fe5794d$var$os);
var $3b92b5930fe5794d$var$fullBrowserVersion = $3b92b5930fe5794d$var$getBrowserFullVersion($3b92b5930fe5794d$var$browser);
var $3b92b5930fe5794d$var$browserVersion = $3b92b5930fe5794d$var$getBrowserVersion($3b92b5930fe5794d$var$browser);
var $3b92b5930fe5794d$var$browserName = $3b92b5930fe5794d$var$getBrowserName($3b92b5930fe5794d$var$browser);
var $3b92b5930fe5794d$var$mobileVendor = $3b92b5930fe5794d$var$getMobileVendor($3b92b5930fe5794d$var$device);
var $3b92b5930fe5794d$var$mobileModel = $3b92b5930fe5794d$var$getMobileModel($3b92b5930fe5794d$var$device);
var $3b92b5930fe5794d$var$engineName = $3b92b5930fe5794d$var$getEngineName($3b92b5930fe5794d$var$engine);
var $3b92b5930fe5794d$var$engineVersion = $3b92b5930fe5794d$var$getEngineVersion($3b92b5930fe5794d$var$engine);
var $3b92b5930fe5794d$var$getUA = $3b92b5930fe5794d$var$getUseragent($3b92b5930fe5794d$var$ua);
var $3b92b5930fe5794d$var$isEdge = $3b92b5930fe5794d$var$isEdgeType($3b92b5930fe5794d$var$browser) || $3b92b5930fe5794d$var$isEdgeChromiumType($3b92b5930fe5794d$var$ua);
var $3b92b5930fe5794d$var$isYandex = $3b92b5930fe5794d$var$isYandexType($3b92b5930fe5794d$var$browser);
var $3b92b5930fe5794d$var$deviceType = $3b92b5930fe5794d$var$getDeviceType($3b92b5930fe5794d$var$device);
var $3b92b5930fe5794d$var$isIOS13 = $3b92b5930fe5794d$var$getIOS13();
var $3b92b5930fe5794d$var$isIPad13 = $3b92b5930fe5794d$var$getIPad13();
var $3b92b5930fe5794d$var$isIPhone13 = $3b92b5930fe5794d$var$getIphone13();
var $3b92b5930fe5794d$var$isIPod13 = $3b92b5930fe5794d$var$getIPod13();
var $3b92b5930fe5794d$var$isElectron = $3b92b5930fe5794d$var$isElectronType();
var $3b92b5930fe5794d$var$isEdgeChromium = $3b92b5930fe5794d$var$isEdgeChromiumType($3b92b5930fe5794d$var$ua);
var $3b92b5930fe5794d$var$isLegacyEdge = $3b92b5930fe5794d$var$isEdgeType($3b92b5930fe5794d$var$browser) && !$3b92b5930fe5794d$var$isEdgeChromiumType($3b92b5930fe5794d$var$ua);
var $3b92b5930fe5794d$var$isWindows = $3b92b5930fe5794d$var$isWindowsType($3b92b5930fe5794d$var$os);
var $3b92b5930fe5794d$var$isMacOs = $3b92b5930fe5794d$var$isMacOsType($3b92b5930fe5794d$var$os);
var $3b92b5930fe5794d$var$isMIUI = $3b92b5930fe5794d$var$isMIUIType($3b92b5930fe5794d$var$browser);
var $3b92b5930fe5794d$var$isSamsungBrowser = $3b92b5930fe5794d$var$isSamsungBrowserType($3b92b5930fe5794d$var$browser);
var $3b92b5930fe5794d$var$getSelectorsByUserAgent = function getSelectorsByUserAgent(userAgent) {
    if (!userAgent || typeof userAgent !== "string") {
        console.error("No valid user agent string was provided");
        return;
    }
    var _UAHelper$parseUserAg = $3b92b5930fe5794d$var$parseUserAgent(userAgent), device = _UAHelper$parseUserAg.device, browser = _UAHelper$parseUserAg.browser, os = _UAHelper$parseUserAg.os, engine = _UAHelper$parseUserAg.engine, ua = _UAHelper$parseUserAg.ua;
    return $3b92b5930fe5794d$var$buildSelectorsObject({
        device: device,
        browser: browser,
        os: os,
        engine: engine,
        ua: ua
    });
};
var $3b92b5930fe5794d$var$AndroidView = function AndroidView(_ref) {
    var renderWithFragment = _ref.renderWithFragment, children = _ref.children, props = $3b92b5930fe5794d$var$_objectWithoutProperties(_ref, [
        "renderWithFragment",
        "children"
    ]);
    return $3b92b5930fe5794d$var$isAndroid ? renderWithFragment ? $3b92b5930fe5794d$var$React__default.createElement($eO7Kz.Fragment, null, children) : $3b92b5930fe5794d$var$React__default.createElement("div", props, children) : null;
};
var $3b92b5930fe5794d$var$BrowserView = function BrowserView(_ref2) {
    var renderWithFragment = _ref2.renderWithFragment, children = _ref2.children, props = $3b92b5930fe5794d$var$_objectWithoutProperties(_ref2, [
        "renderWithFragment",
        "children"
    ]);
    return $3b92b5930fe5794d$var$isBrowser ? renderWithFragment ? $3b92b5930fe5794d$var$React__default.createElement($eO7Kz.Fragment, null, children) : $3b92b5930fe5794d$var$React__default.createElement("div", props, children) : null;
};
var $3b92b5930fe5794d$var$IEView = function IEView(_ref3) {
    var renderWithFragment = _ref3.renderWithFragment, children = _ref3.children, props = $3b92b5930fe5794d$var$_objectWithoutProperties(_ref3, [
        "renderWithFragment",
        "children"
    ]);
    return $3b92b5930fe5794d$var$isIE ? renderWithFragment ? $3b92b5930fe5794d$var$React__default.createElement($eO7Kz.Fragment, null, children) : $3b92b5930fe5794d$var$React__default.createElement("div", props, children) : null;
};
var $3b92b5930fe5794d$var$IOSView = function IOSView(_ref4) {
    var renderWithFragment = _ref4.renderWithFragment, children = _ref4.children, props = $3b92b5930fe5794d$var$_objectWithoutProperties(_ref4, [
        "renderWithFragment",
        "children"
    ]);
    return $3b92b5930fe5794d$var$isIOS ? renderWithFragment ? $3b92b5930fe5794d$var$React__default.createElement($eO7Kz.Fragment, null, children) : $3b92b5930fe5794d$var$React__default.createElement("div", props, children) : null;
};
var $3b92b5930fe5794d$var$MobileView = function MobileView(_ref5) {
    var renderWithFragment = _ref5.renderWithFragment, children = _ref5.children, props = $3b92b5930fe5794d$var$_objectWithoutProperties(_ref5, [
        "renderWithFragment",
        "children"
    ]);
    return $3b92b5930fe5794d$var$isMobile ? renderWithFragment ? $3b92b5930fe5794d$var$React__default.createElement($eO7Kz.Fragment, null, children) : $3b92b5930fe5794d$var$React__default.createElement("div", props, children) : null;
};
var $3b92b5930fe5794d$var$TabletView = function TabletView(_ref6) {
    var renderWithFragment = _ref6.renderWithFragment, children = _ref6.children, props = $3b92b5930fe5794d$var$_objectWithoutProperties(_ref6, [
        "renderWithFragment",
        "children"
    ]);
    return $3b92b5930fe5794d$var$isTablet ? renderWithFragment ? $3b92b5930fe5794d$var$React__default.createElement($eO7Kz.Fragment, null, children) : $3b92b5930fe5794d$var$React__default.createElement("div", props, children) : null;
};
var $3b92b5930fe5794d$var$WinPhoneView = function WinPhoneView(_ref7) {
    var renderWithFragment = _ref7.renderWithFragment, children = _ref7.children, props = $3b92b5930fe5794d$var$_objectWithoutProperties(_ref7, [
        "renderWithFragment",
        "children"
    ]);
    return $3b92b5930fe5794d$var$isWinPhone ? renderWithFragment ? $3b92b5930fe5794d$var$React__default.createElement($eO7Kz.Fragment, null, children) : $3b92b5930fe5794d$var$React__default.createElement("div", props, children) : null;
};
var $3b92b5930fe5794d$var$MobileOnlyView = function MobileOnlyView(_ref8) {
    var renderWithFragment = _ref8.renderWithFragment, children = _ref8.children, viewClassName = _ref8.viewClassName, style = _ref8.style, props = $3b92b5930fe5794d$var$_objectWithoutProperties(_ref8, [
        "renderWithFragment",
        "children",
        "viewClassName",
        "style"
    ]);
    return $3b92b5930fe5794d$var$isMobileOnly ? renderWithFragment ? $3b92b5930fe5794d$var$React__default.createElement($eO7Kz.Fragment, null, children) : $3b92b5930fe5794d$var$React__default.createElement("div", props, children) : null;
};
var $3b92b5930fe5794d$var$SmartTVView = function SmartTVView(_ref9) {
    var renderWithFragment = _ref9.renderWithFragment, children = _ref9.children, props = $3b92b5930fe5794d$var$_objectWithoutProperties(_ref9, [
        "renderWithFragment",
        "children"
    ]);
    return $3b92b5930fe5794d$var$isSmartTV ? renderWithFragment ? $3b92b5930fe5794d$var$React__default.createElement($eO7Kz.Fragment, null, children) : $3b92b5930fe5794d$var$React__default.createElement("div", props, children) : null;
};
var $3b92b5930fe5794d$var$ConsoleView = function ConsoleView(_ref10) {
    var renderWithFragment = _ref10.renderWithFragment, children = _ref10.children, props = $3b92b5930fe5794d$var$_objectWithoutProperties(_ref10, [
        "renderWithFragment",
        "children"
    ]);
    return $3b92b5930fe5794d$var$isConsole ? renderWithFragment ? $3b92b5930fe5794d$var$React__default.createElement($eO7Kz.Fragment, null, children) : $3b92b5930fe5794d$var$React__default.createElement("div", props, children) : null;
};
var $3b92b5930fe5794d$var$WearableView = function WearableView(_ref11) {
    var renderWithFragment = _ref11.renderWithFragment, children = _ref11.children, props = $3b92b5930fe5794d$var$_objectWithoutProperties(_ref11, [
        "renderWithFragment",
        "children"
    ]);
    return $3b92b5930fe5794d$var$isWearable ? renderWithFragment ? $3b92b5930fe5794d$var$React__default.createElement($eO7Kz.Fragment, null, children) : $3b92b5930fe5794d$var$React__default.createElement("div", props, children) : null;
};
var $3b92b5930fe5794d$var$CustomView = function CustomView(_ref12) {
    var renderWithFragment = _ref12.renderWithFragment, children = _ref12.children, viewClassName = _ref12.viewClassName, style = _ref12.style, condition = _ref12.condition, props = $3b92b5930fe5794d$var$_objectWithoutProperties(_ref12, [
        "renderWithFragment",
        "children",
        "viewClassName",
        "style",
        "condition"
    ]);
    return condition ? renderWithFragment ? $3b92b5930fe5794d$var$React__default.createElement($eO7Kz.Fragment, null, children) : $3b92b5930fe5794d$var$React__default.createElement("div", props, children) : null;
};
function $3b92b5930fe5794d$var$withOrientationChange(WrappedComponent) {
    return /*#__PURE__*/ function(_React$Component) {
        $3b92b5930fe5794d$var$_inherits(_class, _React$Component);
        function _class(props) {
            var _this;
            $3b92b5930fe5794d$var$_classCallCheck(this, _class);
            _this = $3b92b5930fe5794d$var$_possibleConstructorReturn(this, $3b92b5930fe5794d$var$_getPrototypeOf(_class).call(this, props));
            _this.isEventListenerAdded = false;
            _this.handleOrientationChange = _this.handleOrientationChange.bind($3b92b5930fe5794d$var$_assertThisInitialized(_this));
            _this.onOrientationChange = _this.onOrientationChange.bind($3b92b5930fe5794d$var$_assertThisInitialized(_this));
            _this.onPageLoad = _this.onPageLoad.bind($3b92b5930fe5794d$var$_assertThisInitialized(_this));
            _this.state = {
                isLandscape: false,
                isPortrait: false
            };
            return _this;
        }
        $3b92b5930fe5794d$var$_createClass(_class, [
            {
                key: "handleOrientationChange",
                value: function handleOrientationChange() {
                    if (!this.isEventListenerAdded) this.isEventListenerAdded = true;
                    var orientation = window.innerWidth > window.innerHeight ? 90 : 0;
                    this.setState({
                        isPortrait: orientation === 0,
                        isLandscape: orientation === 90
                    });
                }
            },
            {
                key: "onOrientationChange",
                value: function onOrientationChange() {
                    this.handleOrientationChange();
                }
            },
            {
                key: "onPageLoad",
                value: function onPageLoad() {
                    this.handleOrientationChange();
                }
            },
            {
                key: "componentDidMount",
                value: function componentDidMount() {
                    if ((typeof window === "undefined" ? "undefined" : $3b92b5930fe5794d$var$_typeof(window)) !== undefined && $3b92b5930fe5794d$var$isMobile) {
                        if (!this.isEventListenerAdded) {
                            this.handleOrientationChange();
                            window.addEventListener("load", this.onPageLoad, false);
                        } else window.removeEventListener("load", this.onPageLoad, false);
                        window.addEventListener("resize", this.onOrientationChange, false);
                    }
                }
            },
            {
                key: "componentWillUnmount",
                value: function componentWillUnmount() {
                    window.removeEventListener("resize", this.onOrientationChange, false);
                }
            },
            {
                key: "render",
                value: function render() {
                    return $3b92b5930fe5794d$var$React__default.createElement(WrappedComponent, $3b92b5930fe5794d$var$_extends({}, this.props, {
                        isLandscape: this.state.isLandscape,
                        isPortrait: this.state.isPortrait
                    }));
                }
            }
        ]);
        return _class;
    }($3b92b5930fe5794d$var$React__default.Component);
}
function $3b92b5930fe5794d$var$useMobileOrientation() {
    var _useState = $eO7Kz.useState(function() {
        var orientation = window.innerWidth > window.innerHeight ? 90 : 0;
        return {
            isPortrait: orientation === 0,
            isLandscape: orientation === 90,
            orientation: orientation === 0 ? "portrait" : "landscape"
        };
    }), _useState2 = $3b92b5930fe5794d$var$_slicedToArray(_useState, 2), state = _useState2[0], setState = _useState2[1];
    var handleOrientationChange = $eO7Kz.useCallback(function() {
        var orientation = window.innerWidth > window.innerHeight ? 90 : 0;
        var next = {
            isPortrait: orientation === 0,
            isLandscape: orientation === 90,
            orientation: orientation === 0 ? "portrait" : "landscape"
        };
        state.orientation !== next.orientation && setState(next);
    }, [
        state.orientation
    ]);
    $eO7Kz.useEffect(function() {
        if ((typeof window === "undefined" ? "undefined" : $3b92b5930fe5794d$var$_typeof(window)) !== undefined && $3b92b5930fe5794d$var$isMobile) {
            handleOrientationChange();
            window.addEventListener("load", handleOrientationChange, false);
            window.addEventListener("resize", handleOrientationChange, false);
        }
        return function() {
            window.removeEventListener("resize", handleOrientationChange, false);
            window.removeEventListener("load", handleOrientationChange, false);
        };
    }, [
        handleOrientationChange
    ]);
    return state;
}
function $3b92b5930fe5794d$var$useDeviceData(userAgent) {
    var hookUserAgent = userAgent ? userAgent : window.navigator.userAgent;
    return $3b92b5930fe5794d$var$parseUserAgent(hookUserAgent);
}
function $3b92b5930fe5794d$var$useDeviceSelectors(userAgent) {
    var hookUserAgent = userAgent ? userAgent : window.navigator.userAgent;
    var deviceData = $3b92b5930fe5794d$var$useDeviceData(hookUserAgent);
    var selectors = $3b92b5930fe5794d$var$buildSelectorsObject(deviceData);
    return [
        selectors,
        deviceData
    ];
}
$3b92b5930fe5794d$exports.AndroidView = $3b92b5930fe5794d$var$AndroidView;
$3b92b5930fe5794d$exports.BrowserTypes = $3b92b5930fe5794d$var$BrowserTypes;
$3b92b5930fe5794d$exports.BrowserView = $3b92b5930fe5794d$var$BrowserView;
$3b92b5930fe5794d$exports.ConsoleView = $3b92b5930fe5794d$var$ConsoleView;
$3b92b5930fe5794d$exports.CustomView = $3b92b5930fe5794d$var$CustomView;
$3b92b5930fe5794d$exports.IEView = $3b92b5930fe5794d$var$IEView;
$3b92b5930fe5794d$exports.IOSView = $3b92b5930fe5794d$var$IOSView;
$3b92b5930fe5794d$exports.MobileOnlyView = $3b92b5930fe5794d$var$MobileOnlyView;
$3b92b5930fe5794d$exports.MobileView = $3b92b5930fe5794d$var$MobileView;
$3b92b5930fe5794d$exports.OsTypes = $3b92b5930fe5794d$var$OsTypes;
$3b92b5930fe5794d$exports.SmartTVView = $3b92b5930fe5794d$var$SmartTVView;
$3b92b5930fe5794d$exports.TabletView = $3b92b5930fe5794d$var$TabletView;
$3b92b5930fe5794d$exports.WearableView = $3b92b5930fe5794d$var$WearableView;
$3b92b5930fe5794d$exports.WinPhoneView = $3b92b5930fe5794d$var$WinPhoneView;
$3b92b5930fe5794d$exports.browserName = $3b92b5930fe5794d$var$browserName;
$3b92b5930fe5794d$exports.browserVersion = $3b92b5930fe5794d$var$browserVersion;
$3b92b5930fe5794d$exports.deviceDetect = $3b92b5930fe5794d$var$deviceDetect;
$3b92b5930fe5794d$exports.deviceType = $3b92b5930fe5794d$var$deviceType;
$3b92b5930fe5794d$exports.engineName = $3b92b5930fe5794d$var$engineName;
$3b92b5930fe5794d$exports.engineVersion = $3b92b5930fe5794d$var$engineVersion;
$3b92b5930fe5794d$exports.fullBrowserVersion = $3b92b5930fe5794d$var$fullBrowserVersion;
$3b92b5930fe5794d$exports.getSelectorsByUserAgent = $3b92b5930fe5794d$var$getSelectorsByUserAgent;
$3b92b5930fe5794d$exports.getUA = $3b92b5930fe5794d$var$getUA;
$3b92b5930fe5794d$exports.isAndroid = $3b92b5930fe5794d$var$isAndroid;
$3b92b5930fe5794d$exports.isBrowser = $3b92b5930fe5794d$var$isBrowser;
$3b92b5930fe5794d$exports.isChrome = $3b92b5930fe5794d$var$isChrome;
$3b92b5930fe5794d$exports.isChromium = $3b92b5930fe5794d$var$isChromium;
$3b92b5930fe5794d$exports.isConsole = $3b92b5930fe5794d$var$isConsole;
$3b92b5930fe5794d$exports.isDesktop = $3b92b5930fe5794d$var$isDesktop;
$3b92b5930fe5794d$exports.isEdge = $3b92b5930fe5794d$var$isEdge;
$3b92b5930fe5794d$exports.isEdgeChromium = $3b92b5930fe5794d$var$isEdgeChromium;
$3b92b5930fe5794d$exports.isElectron = $3b92b5930fe5794d$var$isElectron;
$3b92b5930fe5794d$exports.isEmbedded = $3b92b5930fe5794d$var$isEmbedded;
$3b92b5930fe5794d$exports.isFirefox = $3b92b5930fe5794d$var$isFirefox;
$3b92b5930fe5794d$exports.isIE = $3b92b5930fe5794d$var$isIE;
$3b92b5930fe5794d$exports.isIOS = $3b92b5930fe5794d$var$isIOS;
$3b92b5930fe5794d$exports.isIOS13 = $3b92b5930fe5794d$var$isIOS13;
$3b92b5930fe5794d$exports.isIPad13 = $3b92b5930fe5794d$var$isIPad13;
$3b92b5930fe5794d$exports.isIPhone13 = $3b92b5930fe5794d$var$isIPhone13;
$3b92b5930fe5794d$exports.isIPod13 = $3b92b5930fe5794d$var$isIPod13;
$3b92b5930fe5794d$exports.isLegacyEdge = $3b92b5930fe5794d$var$isLegacyEdge;
$3b92b5930fe5794d$exports.isMIUI = $3b92b5930fe5794d$var$isMIUI;
$3b92b5930fe5794d$exports.isMacOs = $3b92b5930fe5794d$var$isMacOs;
$3b92b5930fe5794d$exports.isMobile = $3b92b5930fe5794d$var$isMobile;
$3b92b5930fe5794d$exports.isMobileOnly = $3b92b5930fe5794d$var$isMobileOnly;
$3b92b5930fe5794d$exports.isMobileSafari = $3b92b5930fe5794d$var$isMobileSafari;
$3b92b5930fe5794d$exports.isOpera = $3b92b5930fe5794d$var$isOpera;
$3b92b5930fe5794d$exports.isSafari = $3b92b5930fe5794d$var$isSafari;
$3b92b5930fe5794d$exports.isSamsungBrowser = $3b92b5930fe5794d$var$isSamsungBrowser;
$3b92b5930fe5794d$exports.isSmartTV = $3b92b5930fe5794d$var$isSmartTV;
$3b92b5930fe5794d$exports.isTablet = $3b92b5930fe5794d$var$isTablet;
$3b92b5930fe5794d$exports.isWearable = $3b92b5930fe5794d$var$isWearable;
$3b92b5930fe5794d$exports.isWinPhone = $3b92b5930fe5794d$var$isWinPhone;
$3b92b5930fe5794d$exports.isWindows = $3b92b5930fe5794d$var$isWindows;
$3b92b5930fe5794d$exports.isYandex = $3b92b5930fe5794d$var$isYandex;
$3b92b5930fe5794d$exports.mobileModel = $3b92b5930fe5794d$var$mobileModel;
$3b92b5930fe5794d$exports.mobileVendor = $3b92b5930fe5794d$var$mobileVendor;
$3b92b5930fe5794d$exports.osName = $3b92b5930fe5794d$var$osName;
$3b92b5930fe5794d$exports.osVersion = $3b92b5930fe5794d$var$osVersion;
$3b92b5930fe5794d$exports.parseUserAgent = $3b92b5930fe5794d$var$parseUserAgent;
$3b92b5930fe5794d$exports.setUserAgent = $3b92b5930fe5794d$var$setUserAgent;
$3b92b5930fe5794d$exports.useDeviceData = $3b92b5930fe5794d$var$useDeviceData;
$3b92b5930fe5794d$exports.useDeviceSelectors = $3b92b5930fe5794d$var$useDeviceSelectors;
$3b92b5930fe5794d$exports.useMobileOrientation = $3b92b5930fe5794d$var$useMobileOrientation;
$3b92b5930fe5794d$exports.withOrientationChange = $3b92b5930fe5794d$var$withOrientationChange;


const $3841ba17527a0169$var$Container = ({ fullSize: fullSize, width: width, height: height, children: children, colors: colors, parent: parent })=>{
    const { currentDeviceType: currentDeviceType, overlayOpacity: overlayOpacity, isTactile: isTactile, setCurrentDeviceType: setCurrentDeviceType, setCurrentHeight: setCurrentHeight, setCurrentWidth: setCurrentWidth } = (0, $8b59a4dbb18c269b$export$3abe3478af3cb63b)();
    const { configuration: { doNotDetectDeviceFromUserAgent: doNotDetectDeviceFromUserAgent } } = (0, $e599569c1fc3ca2c$export$d8760bee47331b1d)();
    const container = (0, $eO7Kz.useRef)(null);
    const dimensions = (0, $6860898abc4c0a4f$export$2e2bcd8739ae039)(container);
    const [portrait, setPortrait] = (0, $eO7Kz.useState)("");
    const [large, setLarge] = (0, $eO7Kz.useState)("");
    // Call useCurrentPagination to update data sent to store. Do not remove
    const pagination = (0, $46f5813fece9e5dd$export$2e2bcd8739ae039)();
    /**
   * On pagination change :
   *  - save current pagination in localstorage to be used in custom store
   */ (0, $eO7Kz.useEffect)(()=>{
        // Add pagination to local storage to be used in botframework store
        localStorage.setItem("Retorik.Framework.Pagination", JSON.stringify(pagination));
    }, [
        pagination
    ]);
    let widthStyle = {};
    if (width === "full") widthStyle = {
        width: "100%"
    };
    else if (typeof width === "number") widthStyle = {
        width: `${width}px`
    };
    else if (typeof width === "string") widthStyle = {
        width: width
    };
    let heightStyle = {};
    if (height === "full") heightStyle = {
        height: "100%",
        flexGrow: 1
    };
    else if (typeof height === "number") heightStyle = {
        height: `${height}px`
    };
    else if (typeof height === "string") heightStyle = {
        height: height
    };
    if (currentDeviceType === (0, $16ad089b9ce6627d$export$ec1e04e4e5ef8233).mobile) heightStyle = {
        height: window.innerHeight,
        minHeight: window.innerHeight,
        maxHeight: window.innerHeight
    };
    const checkPortrait = (width, height)=>{
        if (width && height && width < height) setPortrait("rf-portrait");
        else {
            setPortrait("");
            return false;
        }
        return true;
    };
    /**
   * On dimensions change :
   *  - check and set the classes in the main div that will allow us to use tailwind variants
   *  - set the main div dimensions in context
   */ (0, $eO7Kz.useEffect)(()=>{
        // Widget mode => portrait only
        if (parent === (0, $16ad089b9ce6627d$export$a31c5a03aaeee5f).widget) {
            setPortrait("rf-portrait");
            setLarge("");
            setCurrentDeviceType((0, $16ad089b9ce6627d$export$ec1e04e4e5ef8233).widget);
        } else if (doNotDetectDeviceFromUserAgent) {
            const isPortrait = checkPortrait(dimensions.width, dimensions.height);
            if (isPortrait) {
                if (dimensions.width > (0, $674f1d59bae686ab$export$2e65b7c7134e01f0)) {
                    setLarge("rf-large");
                    setCurrentDeviceType((0, $16ad089b9ce6627d$export$ec1e04e4e5ef8233).borne);
                } else {
                    setLarge("");
                    setCurrentDeviceType((0, $16ad089b9ce6627d$export$ec1e04e4e5ef8233).mobile);
                }
            } else if (dimensions.height > (0, $674f1d59bae686ab$export$2e65b7c7134e01f0)) {
                setLarge("rf-large");
                setCurrentDeviceType((0, $16ad089b9ce6627d$export$ec1e04e4e5ef8233).landscape);
            } else {
                setLarge("");
                setCurrentDeviceType((0, $16ad089b9ce6627d$export$ec1e04e4e5ef8233).mobile);
            }
        } else if (0, $3b92b5930fe5794d$exports.isMobile) {
            setPortrait("rf-portrait");
            setLarge("");
            setCurrentDeviceType((0, $16ad089b9ce6627d$export$ec1e04e4e5ef8233).mobile);
        } else {
            const isPortrait = checkPortrait(dimensions.width, dimensions.height);
            // Check for 'rf-large' class
            setLarge("rf-large");
            setCurrentDeviceType(isPortrait ? (0, $16ad089b9ce6627d$export$ec1e04e4e5ef8233).borne : (0, $16ad089b9ce6627d$export$ec1e04e4e5ef8233).landscape);
        }
        dimensions.height && setCurrentHeight(dimensions.height);
        dimensions.width && setCurrentWidth(dimensions.width);
    }, [
        dimensions
    ]);
    const cssVariables = {
        "--rf-opacity-overlay": overlayOpacity !== undefined ? overlayOpacity : 0.5
    };
    const customColors = {
        "--rf-color-primary": colors.primary,
        "--rf-color-secondary": colors.secondary,
        "--rf-color-black": colors.black,
        "--rf-color-whereToEatColor": colors.whereToEatColor,
        "--rf-color-whereToSleepColor": colors.whereToSleepColor,
        "--rf-color-tobeSeenColor": colors.tobeSeenColor,
        "--rf-color-tobeDoneColor": colors.tobeDoneColor,
        "--rf-color-localProductsColor": colors.localProductsColor,
        "--rf-color-servicesColor": colors.servicesColor,
        "--rf-color-cardFrameBackground": colors.card.frame.background,
        "--rf-color-cardFrameBorder": colors.card.frame.border,
        "--rf-color-cardFrameText": colors.card.frame.text,
        "--rf-color-cardButtonBackgroundDefault": colors.card.button.background.default,
        "--rf-color-cardButtonBackgroundHover": colors.card.button.background.hover,
        "--rf-color-cardButtonBorderDefault": colors.card.button.border.default,
        "--rf-color-cardButtonBorderHover": colors.card.button.border.hover,
        "--rf-color-cardButtonTextDefault": colors.card.button.text.default,
        "--rf-color-cardButtonTextHover": colors.card.button.text.hover,
        "--rf-color-cardButtonDiscoverBackgroundDefault": colors.card.discoverButton.background.default,
        "--rf-color-cardButtonDiscoverBackgroundHover": colors.card.discoverButton.background.hover,
        "--rf-color-cardButtonDiscoverBorderDefault": colors.card.discoverButton.border.default,
        "--rf-color-cardButtonDiscoverBorderHover": colors.card.discoverButton.border.hover,
        "--rf-color-cardButtonDiscoverTextDefault": colors.card.discoverButton.text.default,
        "--rf-color-cardButtonDiscoverTextHover": colors.card.discoverButton.text.hover,
        "--rf-color-textModePanelBackground": colors.textMode.panel.background,
        "--rf-color-textModePanelBorder": colors.textMode.panel.border,
        "--rf-color-textModePanelConversationUser": colors.textMode.panel.conversationUser,
        "--rf-color-textModePanelConversationBot": colors.textMode.panel.conversationBot,
        "--rf-color-vocalModeSubtitlesText": colors.vocalMode.subtitles.text,
        "--rf-color-vocalModeSubtitlesBackground": colors.vocalMode.subtitles.background,
        "--rf-color-formInputTextDefault": colors.formInput.text.default,
        "--rf-color-formInputTextHover": colors.formInput.text.hover,
        "--rf-color-formInputRadioCheckboxUncheckedBackground": colors.formInput.inputRadioCheckbox.unchecked.background,
        "--rf-color-formInputRadioCheckboxUncheckedBorder": colors.formInput.inputRadioCheckbox.unchecked.border,
        "--rf-color-formInputRadioCheckboxCheckedBackground": colors.formInput.inputRadioCheckbox.checked.background,
        "--rf-color-formInputRadioCheckboxCheckedBorder": colors.formInput.inputRadioCheckbox.checked.border,
        "--rf-color-formInputRadioCheckboxCheckedItem": colors.formInput.inputRadioCheckbox.checked.item,
        "--rf-color-formInputButtonBackgroundDefault": colors.formInput.inputButton.background.default,
        "--rf-color-formInputButtonBackgroundHover": colors.formInput.inputButton.background.hover,
        "--rf-color-formInputButtonBorderDefault": colors.formInput.inputButton.border.default,
        "--rf-color-formInputButtonBorderHover": colors.formInput.inputButton.border.hover,
        "--rf-color-formInputButtonTextDefault": colors.formInput.inputButton.text.default,
        "--rf-color-formInputButtonTextHover": colors.formInput.inputButton.text.hover
    };
    return /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("div", {
        id: "retorik-container",
        ref: container,
        className: `rf-relative ${fullSize ? "rf-w-screen rf-h-screen" : "rf-w-full rf-h-full"} rf-max-w-screen rf-max-h-screen rf-grid rf-grid-cols-8 rf-grid-rows-container rf-bg-transparent rf-text-trueblack rf-font-default ${portrait} ${large} ${isTactile && "rf-tactile"} rf-overflow-hidden`,
        style: {
            ...widthStyle,
            ...heightStyle,
            ...cssVariables,
            ...customColors
        },
        children: children
    });
};
var $3841ba17527a0169$export$2e2bcd8739ae039 = $3841ba17527a0169$var$Container;




var $eO7Kz = parcelRequire("eO7Kz");



var // Get data from the json file located at the root of the folder at the address agentUrl
$556ffbb24e38a731$export$2e2bcd8739ae039 = async (agentUrl)=>{
    const responseData = await fetch(`${agentUrl}/manifest.json`).then((data)=>{
        return data.json();
    }).then((json)=>{
        return json;
    }).catch((error)=>{
        console.log(error);
        return null;
    });
    // Set urls to retrieve the animations and a portrait of the agent
    if (responseData !== null) {
        responseData.url = agentUrl;
        responseData.portrait = agentUrl + "/" + responseData.portrait;
    }
    return responseData;
};





const $c7fbeb1cc12b58ef$var$ContextProvider = ({ skipLoader: skipLoader, mode: mode, viewsConfiguration: viewsConfiguration, config: config, addressData: addressData, agentSource: agentSource, ponyfillFactoryCredentials: ponyfillFactoryCredentials, themeColors: themeColors, children: children, isConfigUpdated: isConfigUpdated })=>{
    const [agentManifest, setAgentManifest] = (0, $eO7Kz.useState)(null);
    const { locale: locale, supported: supported, defaultLocale: defaultLocale } = (0, $2e4dc8fa28d39601$export$6650dace022cfacc)();
    /**
   * On component mount :
   *  - fetch supported languages on studio retorik
   */ (0, $eO7Kz.useEffect)(()=>{
        (0, $2e4dc8fa28d39601$export$fe443f6e3680433)(addressData);
    }, []);
    /**
   * On supported state change :
   *  - set locale state depending on data retrieved after fetching available languages and data from config prop
   */ (0, $eO7Kz.useEffect)(()=>{
        if (supported.length) (0, $2e4dc8fa28d39601$export$c8aadf3621e41efb)((0, $f4c1c4ed4ddeab4a$export$d64c0ac95bb7fd72)({
            all: supported,
            default: defaultLocale
        }, config.locales));
    }, [
        supported,
        config,
        isConfigUpdated
    ]);
    /**
   * On agentSource prop change :
   *  - fetch agent data from the url present in agentSource prop
   *  - set the agent's name if present in agentSource prop
   *  - set agentManifest state
   */ (0, $eO7Kz.useEffect)(()=>{
        const getData = async ()=>{
            const url = typeof agentSource === "string" ? agentSource : agentSource.url;
            const data = await (0, $556ffbb24e38a731$export$2e2bcd8739ae039)(url);
            data && typeof agentSource !== "string" && agentSource.name && (data.name = agentSource.name);
            setAgentManifest(data);
        };
        getData();
    }, [
        agentSource
    ]);
    return locale && supported && agentManifest ? /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $8b59a4dbb18c269b$export$50e22524de02f5db), {
        viewsConfiguration: viewsConfiguration,
        themeColors: themeColors,
        children: /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $e599569c1fc3ca2c$export$8d0f3aad9142f5c7), {
            skipLoader: skipLoader,
            chosenMode: mode,
            config: config,
            currentLocale: locale,
            allLocales: supported,
            agentManifest: agentManifest,
            addressData: addressData,
            children: /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsxs)((0, $633c6ef6f1f791c0$export$c3549adc483a11c2), {
                ponyfillFactoryCredentials: ponyfillFactoryCredentials,
                children: [
                    children,
                    /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $d7666235a46cb40b$export$2e2bcd8739ae039), {})
                ]
            })
        })
    }) : /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eO7Kz))).Fragment, {});
};
var $c7fbeb1cc12b58ef$export$2e2bcd8739ae039 = $c7fbeb1cc12b58ef$var$ContextProvider;



const $1eaf476b978cfda6$var$deepMerge = (target, source)=>{
    const isObject = (obj)=>obj && typeof obj === "object";
    if (!isObject(target) || !isObject(source)) return source;
    Object.keys(source).forEach((key)=>{
        const targetValue = target[key];
        const sourceValue = source[key];
        if (targetValue) {
            if (Array.isArray(targetValue) && Array.isArray(sourceValue)) source[key] = targetValue.concat(sourceValue);
            else if (isObject(targetValue) && isObject(sourceValue)) source[key] = $1eaf476b978cfda6$var$deepMerge(targetValue, sourceValue);
            else source[key] = targetValue;
        }
    });
    return source;
};
const $1eaf476b978cfda6$var$getThemeColors = (colors)=>{
    let defaultColors = colors?.theme === "light" ? (0, $f8d049bab9f68eda$export$1196b7bf97f3d16c) : (0, $f8d049bab9f68eda$export$d80fe84b82195dbd);
    defaultColors = $1eaf476b978cfda6$var$deepMerge(colors, defaultColors);
    return defaultColors;
};
var $1eaf476b978cfda6$export$2e2bcd8739ae039 = $1eaf476b978cfda6$var$getThemeColors;






var $eO7Kz = parcelRequire("eO7Kz");





var $gySRD = parcelRequire("gySRD");

var $kssQU = parcelRequire("kssQU");

var $cG9B9 = parcelRequire("cG9B9");

/* Return codes:
  0 => do nothing
  1 => add to queue
  2 => stop current activity + change to the one tested
*/ const $13d0643752b29416$var$checkLastbotActivity = (lastbotActivity, currentPlaying, currentReplyToId, queuedActivities, endedActivities)=>{
    // Check if the activity is the one currently being played
    if (lastbotActivity.id === currentPlaying.id) return 0;
    // Check if the activity has already been ended
    if (endedActivities.includes(lastbotActivity.id)) return 0;
    // Check if the activity has the same replyToId than the one currently being played
    if (lastbotActivity.replyToId === currentReplyToId) {
        // Check if the activity is already in the queue
        let count = 0;
        if (queuedActivities.length > 0) queuedActivities.forEach((activity)=>{
            if (activity.id === lastbotActivity.id) count++;
        });
        if (count === 0) return 1;
        else return 0;
    } else return 2;
};
var $13d0643752b29416$export$2e2bcd8739ae039 = $13d0643752b29416$var$checkLastbotActivity;





const { DictateState: { WILL_START: $2c0168ce1a66fd17$var$WILL_START } } = (0, $cG9B9.Constants);
const $2c0168ce1a66fd17$var$SpeechManager = ()=>{
    const { setSpeaking: setSpeaking, currentPlaying: currentPlaying, setCurrentPlaying: setCurrentPlaying, currentReplyToId: currentReplyToId, setCurrentReplyToId: setCurrentReplyToId, queuedActivities: queuedActivities, setQueuedActivities: setQueuedActivities, endedActivities: endedActivities, setEndedActivities: setEndedActivities, ponyfillCredentials: ponyfillCredentials, muted: muted, speechAllowed: speechAllowed, setBoundaryData: setBoundaryData } = (0, $633c6ef6f1f791c0$export$57e792e009c800a0)();
    const { route: route } = (0, $8b59a4dbb18c269b$export$3abe3478af3cb63b)();
    const { appAvailable: appAvailable, configuration: { preventExpectedInputHint: preventExpectedInputHint } } = (0, $e599569c1fc3ca2c$export$d8760bee47331b1d)();
    const { cancel: cancel } = (0, $b3b97ac6cb18c5e1$export$88ac23e9e2fc8440)();
    const dictateState = (0, $gySRD.useDictateState)()[0];
    const microphoneButtonClick = (0, $kssQU.useMicrophoneButtonClick)();
    const [lastBotActivity] = (0, $d28e9cb6a5674991$export$2e2bcd8739ae039)();
    const markAsSpoken = (0, $gySRD.useMarkActivityAsSpoken)();
    const selectVoice = (0, $gySRD.useVoiceSelector)(lastBotActivity);
    const [utterance, setUtterance] = (0, $eO7Kz.useState)(null);
    const [utteranceEnded, setUtteranceEnded] = (0, $eO7Kz.useState)(false);
    const [currentActivity, setCurrentActivity] = (0, $eO7Kz.useState)();
    const timerRef = (0, $eO7Kz.useRef)(null);
    const ponyfill = (0, $eO7Kz.useMemo)(()=>{
        return (0, $1276b8950dbad48b$exports.createSpeechSynthesisPonyfill)({
            credentials: ponyfillCredentials
        });
    }, [
        ponyfillCredentials
    ]);
    /**
   * On call (used with the 'cancelSpeech' event is fired) :
   *  - set speechCancelStore's cancel state to false
   */ const cancelSpeech = ()=>{
        (0, $b3b97ac6cb18c5e1$export$d0df6aec4e971f52)(true);
    };
    /**
   * On component mount :
   *  - attach event listener to 'cancelSpeech' event
   * On component unmount :
   *  - reset the timer
   *  - detach the event listener
   */ (0, $eO7Kz.useEffect)(()=>{
        // Event called from the outside to cancel speech
        document.addEventListener("cancelSpeech", cancelSpeech);
        return ()=>{
            timerRef && clearTimeout(timerRef.current);
            document.removeEventListener("cancelSpeech", cancelSpeech);
        };
    }, []);
    /**
   * On ViewContext's route state change :
   *  - when we toggle from a view to another, we reset the data related to speech
   */ (0, $eO7Kz.useEffect)(()=>{
        setSpeaking(false);
        setBoundaryData([]);
        const ended = [
            ...endedActivities
        ];
        if (currentPlaying) {
            markAsSpoken(currentPlaying);
            // Add played activity id to context's endedActivities
            ended.length > 10 && ended.splice(0, 1);
            currentPlaying.id && ended.push(currentPlaying.id);
            setEndedActivities(ended);
        }
        setCurrentPlaying(undefined);
        setQueuedActivities([]);
        (0, $b3b97ac6cb18c5e1$export$d0df6aec4e971f52)(false);
        setUtterance(null);
    }, [
        route
    ]);
    /**
   * On RetorikContext's appAvailable state change :
   *  - appAvailable is set to true after the user interacted with the loader and every needed element is loaded
   *  - no utterance is created while appAvailable isn't true
   *  - if during the waiting time, some activities were queued, when appAvailable comes to true, let's begin creating the utterances and playing them
   */ (0, $eO7Kz.useEffect)(()=>{
        if (appAvailable && queuedActivities.length > 0) {
            setCurrentActivity(queuedActivities[0]);
            const params = {
                ponyfill: ponyfill,
                selectVoice: selectVoice,
                activity: queuedActivities[0],
                muted: muted
            };
            const queue = [
                ...queuedActivities
            ];
            queue.splice(0, 1);
            setQueuedActivities(queue);
            setUtterance((0, $1a9f2bb97ec15549$export$2e2bcd8739ae039)({
                ...params
            }));
        }
    }, [
        appAvailable
    ]);
    /**
   * On speechCancelStore's cancel state change :
   *  - if there is currently non utterance being played, reset cancel state to false
   *  - if an utterance is being played, set it to null to stop playing and prevent data in queue from being played
   *  - setting an utterance to null will trigger the handleUtteranceEnded method automatically
   */ (0, $eO7Kz.useEffect)(()=>{
        cancel && !utterance && (0, $b3b97ac6cb18c5e1$export$d0df6aec4e971f52)(false);
        cancel && utterance && setUtterance(null);
    }, [
        cancel
    ]);
    /**
   * On lastBotActivity, ponyfill, voicesLoaded states change :
   *  - check if the ponyfill is created and the voices loaded
   *  - if the app is not available yet, put the activity in the queue if it is not yet inside
   *  - NB: an activity can be received once from the directline, but can be found several times in the activities in the botframework
   *  this is because it is processed multiple times if there is something to speak (channelDate empty, then channelData with {speak: true})
   *  - if an utterance is being played, process the new one (do nothing / put it in the queue / stop the current one and play the new one)
   *  - if an utterance has to be created, create it and set the utterance state
   */ (0, $eO7Kz.useEffect)(()=>{
        if (ponyfill) {
            if (lastBotActivity && lastBotActivity.id) {
                let createNewUtterance = false;
                if (!appAvailable) {
                    if (!currentReplyToId) {
                        setCurrentReplyToId(lastBotActivity.replyToId);
                        setQueuedActivities([
                            lastBotActivity
                        ]);
                    } else if (currentReplyToId === lastBotActivity.replyToId) {
                        let count = 0;
                        if (queuedActivities.length > 0) queuedActivities.forEach((activity)=>{
                            if (activity.id === lastBotActivity.id) count++;
                        });
                        if (count === 0) setQueuedActivities([
                            ...queuedActivities,
                            lastBotActivity
                        ]);
                    } else {
                        setCurrentReplyToId(lastBotActivity.replyToId);
                        setQueuedActivities([
                            lastBotActivity
                        ]);
                    }
                } else if (currentActivity) {
                    const returnCode = (0, $13d0643752b29416$export$2e2bcd8739ae039)(lastBotActivity, currentActivity, currentReplyToId, queuedActivities, endedActivities);
                    const queue = [
                        ...queuedActivities
                    ];
                    switch(returnCode){
                        case 0:
                            break;
                        case 1:
                            // Add the activity to the queue
                            queue.push(lastBotActivity);
                            setQueuedActivities(queue);
                            break;
                        case 2:
                            // Stop current activity and play the new one
                            setQueuedActivities([]);
                            createNewUtterance = true;
                            break;
                    }
                } else createNewUtterance = !endedActivities.includes(lastBotActivity.id);
                if (createNewUtterance) {
                    setCurrentActivity(lastBotActivity);
                    setCurrentReplyToId(lastBotActivity.replyToId);
                    const params = {
                        ponyfill: ponyfill,
                        selectVoice: selectVoice,
                        activity: lastBotActivity,
                        muted: muted
                    };
                    setUtterance((0, $1a9f2bb97ec15549$export$2e2bcd8739ae039)({
                        ...params
                    }));
                }
            }
        }
    }, [
        lastBotActivity,
        ponyfill
    ]);
    /**
   * On utteranceEnded state change :
   *  - if the state is true, an utterance just ended, so the steps are :
   *  - call the handleEnded method
   *  - set utteranceEnded state to false to wait for another utterance end
   */ (0, $eO7Kz.useEffect)(()=>{
        if (utteranceEnded) {
            handleEnded();
            setUtteranceEnded(false);
        }
    }, [
        utteranceEnded
    ]);
    /**
   * On call :
   *  - set speaking state depending on the speechAllowed state
   *  - clear timerref timeout
   *  - set currentPlaying adn currentReplyToId states after a small delay to prevent make sure that the display will happen after the speech has begun
   */ const handleUtteranceStart = ()=>{
        setSpeaking(speechAllowed);
        timerRef && clearTimeout(timerRef.current);
        timerRef.current = setTimeout(()=>{
            setCurrentPlaying(currentActivity);
        }, 10);
    };
    /**
   * On call :
   *  - set speaking state to false
   *  - set utteranceEnded state to true
   */ const handleUtteranceEnd = ()=>{
        setSpeaking(false);
        setUtteranceEnded(true);
    };
    /**
   * On call :
   *  - check if opening the microphone by using inputHint: "expectingInput" is not disabled
   *  - check if the current dictate state is WILL_START
   *  - if all conditions are fulfilled, call microphoneButtonClick hook
   *  - if the microphone isn't allowed in the navigator, the method will fail
   */ const checkDictateState = ()=>{
        !preventExpectedInputHint && dictateState === $2c0168ce1a66fd17$var$WILL_START && microphoneButtonClick();
    };
    /**
   * On call :
   *  - update the states related to the ende activity
   *  - check if the end of the utterance was called by a cancel or not
   *  - if it wasn't a cancel, deal with the queue
   *  - if this was the last activity of the queue, check if the microphone has to be opened automatically (inputHint = expectingInput)
   */ const handleEnded = ()=>{
        let nextUtterance = null;
        const ended = [
            ...endedActivities
        ];
        if (currentPlaying) {
            // Add played activity id to context's endedActivities
            ended.length > 10 && ended.splice(0, 1);
            currentPlaying.id && ended.push(currentPlaying.id);
        }
        setCurrentPlaying(undefined);
        setEndedActivities(ended);
        // Check if the audio ended because of a cancel call
        if (cancel) {
            setQueuedActivities([]);
            (0, $b3b97ac6cb18c5e1$export$d0df6aec4e971f52)(false);
        } else // Launch next activity in the queue and remove it from the queue
        if (queuedActivities.length > 0) {
            setCurrentActivity(queuedActivities[0]);
            const params = {
                ponyfill: ponyfill,
                selectVoice: selectVoice,
                activity: queuedActivities[0],
                muted: muted
            };
            nextUtterance = (0, $1a9f2bb97ec15549$export$2e2bcd8739ae039)({
                ...params
            });
            const queue = [
                ...queuedActivities
            ];
            queue.splice(0, 1);
            setQueuedActivities(queue);
        } else checkDictateState();
        setUtterance(nextUtterance);
    };
    return appAvailable ? utterance ? /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("div", {
        id: "rf-retorik-speech",
        children: /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $a32ae2aa400acc62$export$2e2bcd8739ae039), {
            ponyfill: ponyfill,
            utterance: utterance,
            onStart: handleUtteranceStart,
            onError: handleUtteranceEnd,
            onEnd: handleUtteranceEnd
        })
    }) : null : /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("div", {
        id: "rf-retorik-speech",
        children: /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $a32ae2aa400acc62$export$2e2bcd8739ae039), {
            ponyfill: ponyfill,
            appAvailable: appAvailable
        })
    });
};
var $2c0168ce1a66fd17$export$2e2bcd8739ae039 = $2c0168ce1a66fd17$var$SpeechManager;




var $eO7Kz = parcelRequire("eO7Kz");


var $6f0785606af46b65$exports = {};
$6f0785606af46b65$exports = JSON.parse('{"fr-FR":{"firstline":"Pour une exp\xe9rience optimale,","secondline":"basculez votre \xe9cran"},"en-US":{"firstline":"For an optimal experience,","secondline":"flip your screen"},"es-ES":{"firstline":"For an optimal experience,","secondline":"flip your screen"},"de-DE":{"firstline":"For an optimal experience,","secondline":"flip your screen"}}');


const $2f4fe7b09614a8ab$export$ad7b40b81d5409c = "data:image/png;base64,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";


const $38f9d6827ba977a5$var$MobileLandscapePreventer = ()=>{
    const locale = (0, $2e4dc8fa28d39601$export$6650dace022cfacc)((state)=>state.locale);
    const { isMobileLandscape: isMobileLandscape } = (0, $8b59a4dbb18c269b$export$3abe3478af3cb63b)();
    return isMobileLandscape ? /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsxs)("div", {
        className: "rf-absolute rf-w-full rf-h-full rf-z-exitwidget rf-flex rf-flex-col rf-items-center rf-bg-truewhite",
        children: [
            /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("div", {
                className: "rf-h-1/2 rf-flex rf-items-end rf-pb-4",
                children: /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("img", {
                    className: "rf-h-2/3",
                    src: (0, $2f4fe7b09614a8ab$export$ad7b40b81d5409c)
                })
            }),
            /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsxs)("div", {
                className: "rf-h-1/2 rf-pt-4 rf-flex rf-flex-col rf-items-center",
                children: [
                    /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("div", {
                        className: "rf-font-semibold rf-text-xl",
                        children: (0, (/*@__PURE__*/$parcel$interopDefault($6f0785606af46b65$exports)))[locale]?.firstline || (0, (/*@__PURE__*/$parcel$interopDefault($6f0785606af46b65$exports)))["fr-FR"].firstline
                    }),
                    /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("div", {
                        className: "rf-font-bold rf-text-3xl",
                        children: (0, (/*@__PURE__*/$parcel$interopDefault($6f0785606af46b65$exports)))[locale]?.secondline || (0, (/*@__PURE__*/$parcel$interopDefault($6f0785606af46b65$exports)))["fr-FR"].secondline
                    })
                ]
            })
        ]
    }) : /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eO7Kz))).Fragment, {});
};
var $38f9d6827ba977a5$export$2e2bcd8739ae039 = $38f9d6827ba977a5$var$MobileLandscapePreventer;





const $c8ce98cd143422bb$var$getRetorikConfigs = async (props)=>{
    // eslint-disable-next-line prefer-const
    let retorikProps = {
        ...props
    };
    let res;
    // Fetch tenant data config
    const baseAddress = `${retorikProps.addressData.baseURI && retorikProps.addressData.baseURI?.length > 0 ? (0, $c3aed5b5062ec765$export$2e2bcd8739ae039)(retorikProps.addressData.baseURI) : (0, $519f31eef1fe5fca$export$2e2bcd8739ae039)(retorikProps.addressData.prefix)}/${retorikProps.addressData.tenant ? retorikProps.addressData.tenant + "/" : ""}`;
    const fullAddress = `${baseAddress}api/integration/framework`;
    const retorikConfig = await fetch(fullAddress).then((res)=>res.json()).then((json)=>{
        // Process config
        return $c8ce98cd143422bb$var$processJson(json, retorikProps, baseAddress);
    }).catch((error)=>{
        console.log(error);
        return retorikProps;
    });
    if (retorikConfig) res = $c8ce98cd143422bb$var$deepMerge(retorikConfig, retorikProps);
    else res = {
        ...retorikProps
    };
    return res;
};
const $c8ce98cd143422bb$var$processJson = (json, retorikProps, baseAddress)=>{
    if (json) {
        if (!json.enabled) return null;
        // Get full adress for backgrounds & logo
        let logo, background, newsBackground, personnage;
        if (json.personnage) personnage = `${0, $674f1d59bae686ab$export$2475544086fd222b}/${json.personnage}`;
        else personnage = undefined;
        if (retorikProps.addressData.tenant && baseAddress.indexOf(`/${retorikProps.addressData.tenant}`)) baseAddress = baseAddress.replace(`/${retorikProps.addressData.tenant}`, "");
        baseAddress = baseAddress.endsWith("/") ? baseAddress.slice(0, -1) : baseAddress;
        if (json.logo) logo = `${baseAddress}${json.logo}`;
        if (json.background) background = `${baseAddress}${json.background}`;
        if (json.newsBackground) newsBackground = `${baseAddress}${json.newsBackground}`;
        const props = {
            config: {
                fullSize: undefined,
                isUsedOnBorne: undefined,
                locales: {
                    default: json.defaultLocale || undefined,
                    getDefaultFromBrowser: undefined
                },
                position: {
                    searchForLocation: json.detectLocation || undefined,
                    latitude: undefined,
                    longitude: undefined,
                    city: undefined,
                    country: undefined
                },
                subtitles: json.subtitles || undefined,
                logo: json.logo ? {
                    src: logo
                } : undefined,
                answerpanel: json.answerPanel || undefined,
                skipWelcome: json.skipWelcome || undefined,
                preventExpectedInputHint: json.preventExpectedInputHint || undefined,
                pagination: undefined,
                remote: undefined,
                companyName: json.companyName || undefined,
                subCompanyMessage: json.subCompanyMessage || undefined,
                loaderInformationTexts: undefined,
                hideRetorikLogo: json.hideRetorikLogo || undefined,
                baseMenu: undefined,
                customMenu: undefined,
                subMenu: undefined,
                hideMenu: json.hideMenu || undefined,
                hideControls: json.hideControls || undefined,
                doNotDetectDeviceFromUserAgent: json.doNotDetectDeviceFromUserAgent || undefined
            },
            viewsConfig: {
                homeRoute: "home",
                webcamRotation: undefined,
                views: {
                    home: {
                        background: {
                            style: "image",
                            image: background
                        }
                    },
                    news: {
                        intervalInSeconds: 2,
                        loop: true,
                        openingVideo: "",
                        background: {
                            style: "image",
                            image: newsBackground
                        }
                    }
                }
            },
            chatbotData: {
                size: undefined,
                height: undefined
            },
            agentData: personnage,
            ponyfillFactoryCredentials: {
                region: "",
                subscriptionKey: ""
            },
            addressData: retorikProps.addressData,
            userData: retorikProps.userData,
            externalEventHandler: undefined,
            customVoice: {
                voice: json.voice || undefined,
                gender: undefined
            },
            width: undefined,
            height: undefined,
            colors: {
                theme: json.colorSettings.theme || undefined,
                primary: json.colorSettings.primary || undefined,
                secondary: json.colorSettings.secondary || undefined,
                black: json.colorSettings.black || undefined,
                whereToEatColor: json.colorSettings.whereToEatColor || undefined,
                whereToSleepColor: json.colorSettings.whereToSleepColor || undefined,
                tobeSeenColor: json.colorSettings.tobeSeenColor || undefined,
                tobeDoneColor: json.colorSettings.tobeDoneColor || undefined,
                localProductsColor: json.colorSettings.localProductsColor || undefined,
                servicesColor: json.colorSettings.servicesColor || undefined,
                companyName: json.colorSettings.companyName || undefined,
                loader: {
                    animation: json.colorSettings.loader?.animation || undefined,
                    background: json.colorSettings.loader?.background || undefined,
                    text: json.colorSettings.loader?.text || undefined,
                    toggle: {
                        text: json.colorSettings.loader?.toggle?.text || undefined,
                        background: json.colorSettings.loader?.toggle?.background || undefined
                    },
                    button: {
                        background: {
                            default: json.colorSettings.loader?.button?.background?.default || undefined,
                            hover: json.colorSettings.loader?.button?.background?.hover || undefined
                        },
                        border: {
                            default: json.colorSettings.loader?.button?.border?.default || undefined,
                            hover: json.colorSettings.loader?.button?.border?.hover || undefined
                        },
                        text: {
                            default: json.colorSettings.loader?.button?.text?.default || undefined,
                            hover: json.colorSettings.loader?.button?.text?.hover || undefined
                        }
                    }
                },
                card: {
                    frame: {
                        background: json.colorSettings.card?.frame?.background || undefined,
                        border: json.colorSettings.card?.frame?.border || undefined,
                        text: json.colorSettings.card?.frame?.text || undefined
                    },
                    button: {
                        background: {
                            default: json.colorSettings.card?.button?.background?.default || undefined,
                            hover: json.colorSettings.card?.button?.background?.hover || undefined
                        },
                        border: {
                            default: json.colorSettings.card?.button?.border?.default || undefined,
                            hover: json.colorSettings.card?.button?.border?.hover || undefined
                        },
                        text: {
                            default: json.colorSettings.card?.button?.text?.default || undefined,
                            hover: json.colorSettings.card?.button?.text?.hover || undefined
                        }
                    },
                    discoverButton: {
                        background: {
                            default: json.colorSettings.card?.discoverButton?.background?.default || undefined,
                            hover: json.colorSettings.card?.discoverButton?.background?.hover || undefined
                        },
                        border: {
                            default: json.colorSettings.card?.discoverButton?.border?.default || undefined,
                            hover: json.colorSettings.card?.discoverButton?.border?.hover || undefined
                        },
                        text: {
                            default: json.colorSettings.card?.discoverButton?.text?.default || undefined,
                            hover: json.colorSettings.card?.discoverButton?.text?.hover || undefined
                        }
                    }
                },
                textMode: {
                    panel: {
                        background: json.colorSettings.textMode?.panel?.background || undefined,
                        border: json.colorSettings.textMode?.panel?.border || undefined,
                        conversationUser: json.colorSettings.textMode?.panel?.conversationUser || undefined,
                        conversationBot: json.colorSettings.textMode?.panel?.conversationBot || undefined
                    }
                },
                vocalMode: {
                    subtitles: {
                        text: json.colorSettings.vocalMode?.subtitles?.text || undefined,
                        background: json.colorSettings.vocalMode?.subtitles?.background || undefined
                    }
                },
                formInput: {
                    text: {
                        default: json.colorSettings.formInput?.inputText?.default || undefined,
                        hover: json.colorSettings.formInput?.inputText?.hover || undefined
                    },
                    inputRadioCheckbox: {
                        unchecked: {
                            background: json.colorSettings.formInput?.inputRadioCheckbox?.unchecked?.background || undefined,
                            border: json.colorSettings.formInput?.inputRadioCheckbox?.unchecked?.border || undefined
                        },
                        checked: {
                            background: json.colorSettings.formInput?.inputRadioCheckbox?.checked?.background || undefined,
                            border: json.colorSettings.formInput?.inputRadioCheckbox?.checked?.border || undefined,
                            item: json.colorSettings.formInput?.inputRadioCheckbox?.checked?.item || undefined
                        }
                    },
                    inputButton: {
                        background: {
                            default: json.colorSettings.formInput?.inputButton?.background?.default || undefined,
                            hover: json.colorSettings.formInput?.inputButton?.background?.hover || undefined
                        },
                        border: {
                            default: json.colorSettings.formInput?.inputButton?.border?.default || undefined,
                            hover: json.colorSettings.formInput?.inputButton?.border?.hover || undefined
                        },
                        text: {
                            default: json.colorSettings.formInput?.inputButton?.text?.default || undefined,
                            hover: json.colorSettings.formInput?.inputButton?.text?.hover || undefined
                        }
                    },
                    likert: {
                        default: json.colorSettings.formInput?.likert?.default || undefined,
                        hover: json.colorSettings.formInput?.likert?.hover || undefined
                    }
                }
            },
            defaultMode: json.defaultMode
        };
        return props;
    }
    return null;
};
const $c8ce98cd143422bb$var$deepMerge = (target, source)=>{
    const isObject = (obj)=>obj && typeof obj === "object";
    if (!isObject(target) || !isObject(source)) return source;
    Object.keys(target).forEach((key)=>{
        const targetValue = target[key];
        const sourceValue = source[key];
        if (targetValue) {
            if (Array.isArray(targetValue) && Array.isArray(sourceValue)) source[key] = targetValue.concat(sourceValue);
            else if (isObject(targetValue) && isObject(sourceValue)) source[key] = $c8ce98cd143422bb$var$deepMerge(targetValue, sourceValue);
            else source[key] = targetValue;
        }
    });
    return source;
};
var $c8ce98cd143422bb$export$2e2bcd8739ae039 = $c8ce98cd143422bb$var$getRetorikConfigs;



const $4accaec41a4890ec$var$RetorikContainer = (props)=>{
    const [themeColors, setThemeColors] = (0, $eO7Kz.useState)((0, $1eaf476b978cfda6$export$2e2bcd8739ae039)(props.colors));
    const [isConfigUpdated, setIsConfigUpdated] = (0, $eO7Kz.useState)(false);
    const { setConfiguration: setConfiguration, setAgentData: setAgentData } = (0, $e599569c1fc3ca2c$export$d8760bee47331b1d)();
    const [skipLoader, setSkipLoader] = (0, $eO7Kz.useState)(props.skipLoader);
    const [defaultMode, setDefaultMode] = (0, $eO7Kz.useState)(props.defaultMode);
    const [parent] = (0, $eO7Kz.useState)(props.parent);
    const [config, setConfig] = (0, $eO7Kz.useState)(props.config);
    const [viewsConfig, setViewsConfig] = (0, $eO7Kz.useState)(props.viewsConfig);
    const [chatbotData, setChatbotData] = (0, $eO7Kz.useState)(props.chatbotData);
    const [agentData, setagentData] = (0, $eO7Kz.useState)(props.agentData);
    const [ponyfillFactoryCredentials, setPonyfillFactoryCredentials] = (0, $eO7Kz.useState)(props.ponyfillFactoryCredentials);
    const [addressData, setAddressData] = (0, $eO7Kz.useState)(props.addressData);
    const [userData, setUserData] = (0, $eO7Kz.useState)(props.userData);
    const [externalEventHandler, setExternalEventHandler] = (0, $eO7Kz.useState)(props.externalEventHandler);
    const [width, setWidth] = (0, $eO7Kz.useState)(props.width);
    const [height, setHeight] = (0, $eO7Kz.useState)(props.height);
    const [customVoice, setCustomVoice] = (0, $eO7Kz.useState)(props.customVoice);
    const [externalComponents, setExternalComponents] = (0, $eO7Kz.useState)(props.externalComponents);
    (0, $eO7Kz.useEffect)(()=>{
        const getUpdatedConfig = async ()=>{
            const { skipLoader: skipLoader, defaultMode: defaultMode, config: _config, viewsConfig: viewsConfig, chatbotData: chatbotData, agentData: agentData, ponyfillFactoryCredentials: ponyfillFactoryCredentials, addressData: addressData, userData: userData, externalEventHandler: externalEventHandler, width: width, height: height, customVoice: customVoice, colors: colors, externalComponents: externalComponents } = await (0, $c8ce98cd143422bb$export$2e2bcd8739ae039)(props);
            setSkipLoader(skipLoader);
            setDefaultMode(defaultMode);
            setConfig(_config);
            setViewsConfig(viewsConfig);
            setChatbotData(chatbotData);
            setagentData(agentData);
            setPonyfillFactoryCredentials(ponyfillFactoryCredentials);
            setAddressData(addressData);
            setUserData(userData);
            setExternalEventHandler(externalEventHandler);
            setWidth(width);
            setHeight(height);
            setCustomVoice(customVoice);
            setThemeColors((0, $1eaf476b978cfda6$export$2e2bcd8739ae039)(colors));
            setExternalComponents(externalComponents);
        };
        getUpdatedConfig().then(()=>{
            setIsConfigUpdated(true);
        });
    }, []);
    (0, $eO7Kz.useEffect)(()=>{
        if (isConfigUpdated) {
            setConfiguration(config);
            if (agentData && typeof agentData === "object") setAgentData(agentData);
        }
    }, [
        isConfigUpdated
    ]);
    return /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsxs)((0, $c7fbeb1cc12b58ef$export$2e2bcd8739ae039), {
        skipLoader: skipLoader,
        mode: defaultMode || (0, $16ad089b9ce6627d$export$9484bbecc3c49a2e).vocal,
        viewsConfiguration: viewsConfig,
        config: config,
        addressData: addressData,
        agentSource: agentData,
        ponyfillFactoryCredentials: ponyfillFactoryCredentials,
        themeColors: themeColors,
        isConfigUpdated: isConfigUpdated,
        children: [
            /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $38f9d6827ba977a5$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsxs)((0, $17a5c51a47881692$export$2e2bcd8739ae039), {
                addressData: addressData,
                userData: userData,
                externalEventHandler: externalEventHandler,
                customVoice: customVoice,
                colors: themeColors,
                children: [
                    /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $2c0168ce1a66fd17$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $3841ba17527a0169$export$2e2bcd8739ae039), {
                        fullSize: parent !== (0, $16ad089b9ce6627d$export$a31c5a03aaeee5f).widget && config.fullSize !== false,
                        width: width,
                        height: height,
                        colors: themeColors,
                        parent: parent,
                        children: parent === (0, $16ad089b9ce6627d$export$a31c5a03aaeee5f).news ? /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $373d04203a5f5c64$export$2e2bcd8739ae039), {
                            chatbotData: chatbotData,
                            hideMenu: true,
                            isRetorikNews: true
                        }) : /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $f1cd80aa27d674e7$export$2e2bcd8739ae039), {
                            chatbotData: chatbotData,
                            externalComponents: externalComponents
                        })
                    })
                ]
            })
        ]
    });
};
var $4accaec41a4890ec$export$2e2bcd8739ae039 = $4accaec41a4890ec$var$RetorikContainer;



const $ff704b553a7260e6$var$RetorikAgent = (props)=>{
    // --------- /!\ -----------
    // Ne mettre ici que de la logique spécifique au retorikAgent
    // Ce qui est commun avec RetorikWidget ou autres doit aller dans RetorikComposer
    // -------------------------
    return /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $c2309a35977c160d$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $4accaec41a4890ec$export$2e2bcd8739ae039), {
            parent: (0, $16ad089b9ce6627d$export$a31c5a03aaeee5f).agent,
            ...props
        })
    });
};
var $ff704b553a7260e6$export$2e2bcd8739ae039 = $ff704b553a7260e6$var$RetorikAgent;




var $eO7Kz = parcelRequire("eO7Kz");



// Get style for widget's border (except colors)
const $14c3a57f434f2c40$export$d6ad062ea094ff6f = (borderData)=>{
    if (!borderData || !borderData.color && borderData.thickness === undefined && borderData.rounded === undefined) return "rf-border rf-rounded rf-border-gray";
    const borderThickness = borderData.thickness !== undefined && borderData.thickness !== 1 ? `rf-border-${borderData.thickness}` : "rf-border";
    const borderRounded = borderData.rounded === false ? "" : "rf-rounded-lg";
    return `${borderThickness} ${borderRounded}`;
};
// Get style for widget's button (except colors)
const $14c3a57f434f2c40$export$5bc78eab59412c50 = (buttonData)=>{
    if (!buttonData || !buttonData.text && !buttonData.image && !buttonData.border && !buttonData.background && !buttonData.position) return "rf-rounded-lg rf-font-bold";
    // Button border
    const borderStyle = buttonData.border?.rounded === false ? "" : "rf-rounded-lg";
    // Button text
    const textStyle = buttonData.text?.bold && buttonData.text.bold === false ? "" : "rf-font-bold";
    return `${borderStyle} ${textStyle}`;
};


var $0f049f40fa3749e9$exports = {};
$0f049f40fa3749e9$exports = JSON.parse('{"fr-FR":{"button":"Besoin d\'aide ?","close":"Fermer"},"en-US":{"button":"Need help ?","close":"Close"},"es-ES":{"button":"Need help ?","close":"Close"},"de-DE":{"button":"Need help ?","close":"Close"}}');





window.Retorik = {
    ...window.Retorik,
    openWidget: $b0bf9d862842b3aa$export$a1c83309c736819f,
    closeWidget: $b0bf9d862842b3aa$export$d27f1b0993b666c,
    toggleWidget: $b0bf9d862842b3aa$export$77c0ba4d0d97cee5,
    toggleDisplay: $b0bf9d862842b3aa$export$f0e9d14ede4c01bd
};
const $26a72e2566a0b13d$var$RetorikWidget = (props)=>{
    // --------- /!\ -----------
    // Ne mettre ici que de la logique spécifique au widget
    // Ce qui est commun avec RetorikAgent ou autres doit aller dans RetorikComposer ou ContextProvider
    // -------------------------
    const { open: open, loaded: loaded, widgetDisplayType: widgetDisplayType } = (0, $b0bf9d862842b3aa$export$d95eb9b67812311f)();
    const [currentConfiguration, setCurrentConfiguration] = (0, $eO7Kz.useState)(props.widgetConfig?.large);
    const [widgetButton, setWidgetButton] = (0, $eO7Kz.useState)("");
    const [widgetBorder, setWidgetBorder] = (0, $eO7Kz.useState)("");
    const [mobileWidth, setMobileWidth] = (0, $eO7Kz.useState)(window.innerWidth < 600);
    const [frameStyle, setFrameStyle] = (0, $eO7Kz.useState)({});
    const handleResize = ()=>{
        setMobileWidth(window.innerWidth < 600);
    };
    (0, $eO7Kz.useEffect)(()=>{
        setWidgetButton((0, $14c3a57f434f2c40$export$5bc78eab59412c50)(props.widgetConfig?.button));
        window.addEventListener("resize", handleResize);
        return ()=>window.removeEventListener("resize", handleResize);
    }, []);
    (0, $eO7Kz.useEffect)(()=>{
        mobileWidth ? setFrameStyle({
            width: open ? "100%" : "0px",
            height: "100%"
        }) : setFrameStyle({
            top: currentConfiguration?.position?.top,
            bottom: currentConfiguration?.position?.bottom ? currentConfiguration?.position?.bottom : currentConfiguration?.position?.top || currentConfiguration?.position?.left || currentConfiguration?.position?.right ? undefined : "1rem",
            left: currentConfiguration?.position?.left,
            right: currentConfiguration?.position?.right ? currentConfiguration?.position?.right : currentConfiguration?.position?.top || currentConfiguration?.position?.bottom || currentConfiguration?.position?.left ? undefined : "1rem",
            borderColor: currentConfiguration?.border?.color || (0, $f8d049bab9f68eda$export$4aebf65ed07cf17b).rgb
        });
    }, [
        mobileWidth,
        currentConfiguration
    ]);
    (0, $eO7Kz.useEffect)(()=>{
        switch(widgetDisplayType){
            case "large":
                setCurrentConfiguration(props.widgetConfig?.large);
                setWidgetBorder((0, $14c3a57f434f2c40$export$d6ad062ea094ff6f)(props.widgetConfig?.large?.border));
                break;
            case "thumbnail":
                setCurrentConfiguration(props.widgetConfig?.thumbnail || props.widgetConfig?.large);
                setWidgetBorder((0, $14c3a57f434f2c40$export$d6ad062ea094ff6f)(props.widgetConfig?.thumbnail?.border || props.widgetConfig?.large?.border));
                break;
            default:
                break;
        }
    }, [
        widgetDisplayType
    ]);
    return /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsxs)((0, $c2309a35977c160d$export$2e2bcd8739ae039), {
        children: [
            props.widgetConfig?.button?.display !== false && /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsxs)("button", {
                className: `rf-fixed rf-px-2 rf-flex rf-flex-row rf-items-center ${widgetButton}`,
                style: {
                    color: props.widgetConfig?.button?.text?.color || (0, $f8d049bab9f68eda$export$4aebf65ed07cf17b).rgb,
                    backgroundColor: props.widgetConfig?.button?.background?.color || "transparent",
                    borderWidth: props.widgetConfig?.button?.border?.thickness !== undefined ? `${props.widgetConfig?.button?.border?.thickness}px` : "1px",
                    borderColor: props.widgetConfig?.button?.border?.color || (0, $f8d049bab9f68eda$export$4aebf65ed07cf17b).rgb,
                    top: props.widgetConfig?.button?.position?.top,
                    bottom: props.widgetConfig?.button?.position?.bottom ? props.widgetConfig?.button?.position?.bottom : props.widgetConfig?.button?.position?.top || props.widgetConfig?.button?.position?.left || props.widgetConfig?.button?.position?.right ? undefined : "1rem",
                    left: props.widgetConfig?.button?.position?.left,
                    right: props.widgetConfig?.button?.position?.right ? props.widgetConfig?.button?.position?.right : props.widgetConfig?.button?.position?.top || props.widgetConfig?.button?.position?.bottom || props.widgetConfig?.button?.position?.left ? undefined : "1rem"
                },
                onClick: (0, $b0bf9d862842b3aa$export$77c0ba4d0d97cee5),
                id: "retorik-widget-button",
                children: [
                    props.widgetConfig?.button?.image?.url && props.widgetConfig?.button?.image?.position !== "right" && /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("img", {
                        className: `${props.widgetConfig?.button?.image.marginY === false ? "" : "rf-my-1"}`,
                        src: `${props.widgetConfig.button.image.url}`,
                        alt: "Retorik widget",
                        style: {
                            height: props.widgetConfig?.button?.image.height || "2rem"
                        }
                    }),
                    /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("div", {
                        className: "rf-py-2 rf-ml-1",
                        children: props.widgetConfig?.button?.text?.content || navigator.language && (0, (/*@__PURE__*/$parcel$interopDefault($0f049f40fa3749e9$exports)))[navigator.language]?.button || (0, (/*@__PURE__*/$parcel$interopDefault($0f049f40fa3749e9$exports)))["fr-FR"].button
                    }),
                    props.widgetConfig?.button?.image?.url && props.widgetConfig?.button?.image?.position === "right" && /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("img", {
                        className: `${props.widgetConfig?.button?.image.marginY === false ? "" : "rf-my-1"}`,
                        src: `${props.widgetConfig.button.image.url}`,
                        alt: "Retorik widget",
                        style: {
                            height: props.widgetConfig?.button?.image.height || "2rem"
                        }
                    })
                ]
            }),
            loaded && /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsxs)("div", {
                className: `rf-fixed rf-pt-8 rf-height-fill-available rf-transition-all rf-overflow-hidden ${mobileWidth ? "rf-max-w-[100vw]" : "rf-max-w-[600px]"}`,
                style: {
                    ...frameStyle,
                    width: open ? mobileWidth ? "100%" : currentConfiguration?.width || "400px" : "0px",
                    height: currentConfiguration?.height || (mobileWidth ? "100%" : "630px")
                },
                "data-testid": "widget-wrapper",
                children: [
                    /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("button", {
                        onClick: (0, $b0bf9d862842b3aa$export$77c0ba4d0d97cee5),
                        "aria-label": "Close",
                        className: "rf-absolute rf-z-exitwidget rf-flex rf-right-0 rf-top-0 rf-p-1 rf-bg-truewhite rf-border rf-border-trueblack rf-rounded-lg",
                        children: /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $afdfbac274da5706$export$2e2bcd8739ae039), {
                            className: "rf-h-4 rf-w-4",
                            color: "#000000"
                        })
                    }),
                    /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)("div", {
                        className: `rf-relative rf-h-full rf-w-full rf-overflow-hidden ${!mobileWidth && widgetBorder}`,
                        style: {
                            borderColor: frameStyle.borderColor
                        },
                        children: /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $4accaec41a4890ec$export$2e2bcd8739ae039), {
                            parent: (0, $16ad089b9ce6627d$export$a31c5a03aaeee5f).widget,
                            ...props,
                            width: "full",
                            height: "full",
                            mobile: mobileWidth
                        })
                    })
                ]
            })
        ]
    });
};
var $26a72e2566a0b13d$export$2e2bcd8739ae039 = $26a72e2566a0b13d$var$RetorikWidget;



parcelRequire("eO7Kz");



const $a9b4e45fd666435d$var$RetorikNews = (props)=>{
    // --------- /!\ -----------
    // Ne mettre ici que de la logique spécifique au retorikNews
    // Ce qui est commun avec RetorikWidget ou autres doit aller dans RetorikComposer ou ContextProvider
    // -------------------------
    return /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $c2309a35977c160d$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $179ad052de55b86f$exports.jsx)((0, $4accaec41a4890ec$export$2e2bcd8739ae039), {
            parent: (0, $16ad089b9ce6627d$export$a31c5a03aaeee5f).news,
            ...props
        })
    });
};
var $a9b4e45fd666435d$export$2e2bcd8739ae039 = $a9b4e45fd666435d$var$RetorikNews;





const $c757339df42b57e8$export$30a86d91af8ff6e6 = {
    alice: `${(0, $674f1d59bae686ab$export$2475544086fd222b)}/alice`,
    jeanmarc: `${(0, $674f1d59bae686ab$export$2475544086fd222b)}/jean-marc`,
    ikaa: `${(0, $674f1d59bae686ab$export$2475544086fd222b)}/ikaa`,
    karine: `${(0, $674f1d59bae686ab$export$2475544086fd222b)}/karine`,
    lea: `${(0, $674f1d59bae686ab$export$2475544086fd222b)}/lea`,
    prosper: `${(0, $674f1d59bae686ab$export$2475544086fd222b)}/prosper`,
    raphael: `${(0, $674f1d59bae686ab$export$2475544086fd222b)}/raphael`,
    zahra: `${(0, $674f1d59bae686ab$export$2475544086fd222b)}/zahra`
};



function $d40859eb735196bb$export$2e2bcd8739ae039() {
    const [lastBotActivity] = (0, $d28e9cb6a5674991$export$2e2bcd8739ae039)();
    if (lastBotActivity?.channelData?.speak === false) return lastBotActivity;
    return undefined;
}








const $632c75eb8e0ce232$export$b69254d879536cde = (0, $4e80c14196de719d$export$2e2bcd8739ae039).bind(null, (0, $ff704b553a7260e6$export$2e2bcd8739ae039));
const $632c75eb8e0ce232$var$renderWidget = (0, $795ef26b02b77e41$export$2e2bcd8739ae039).bind(null, (0, $26a72e2566a0b13d$export$2e2bcd8739ae039));
var $632c75eb8e0ce232$export$2e2bcd8739ae039 = (0, $ff704b553a7260e6$export$2e2bcd8739ae039);
window.Retorik = {
    ...window.Retorik,
    renderAgent: $632c75eb8e0ce232$export$b69254d879536cde,
    renderWidget: $632c75eb8e0ce232$var$renderWidget,
    showAgent: $134592d23f105dbc$export$ae67eb518a2aae74,
    hideAgent: $134592d23f105dbc$export$e73dbd7ba351e3e,
    setLocale: $2e4dc8fa28d39601$export$c8aadf3621e41efb,
    sendActivity: $134592d23f105dbc$export$d4c8c6daac289378
};


//# sourceMappingURL=index.js.map
